var _slicedToArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

module.exports = function (e) {
  var t = {};

  function a(r) {
    if (t[r]) return t[r].exports;
    var n = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(n.exports, n, n.exports, a), n.l = !0, n.exports;
  }

  return a.m = e, a.c = t, a.d = function (e, t, r) {
    a.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, a.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, a.t = function (e, t) {
    if (1 & t && (e = a(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (a.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var n in e) {
      a.d(r, n, function (t) {
        return e[t];
      }.bind(null, n));
    }
    return r;
  }, a.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return a.d(t, "a", t), t;
  }, a.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, a.p = "", a(a.s = 319);
}([
/*!***************************************!*\
  !*** ./node_modules/lodash/lodash.js ***!
  \***************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (e, r) {
    var n;
    /**
     * @license
     * Lodash <https://lodash.com/>
     * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
     * Released under MIT license <https://lodash.com/license>
     * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
     * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
     */

    (function () {
      var s,
          o = 200,
          i = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.",
          c = "Expected a function",
          u = "__lodash_hash_undefined__",
          d = 500,
          f = "__lodash_placeholder__",
          l = 1,
          h = 2,
          p = 4,
          b = 1,
          m = 2,
          y = 1,
          v = 2,
          _ = 4,
          g = 8,
          A = 16,
          w = 32,
          T = 64,
          x = 128,
          D = 256,
          C = 512,
          S = 30,
          E = "...",
          B = 800,
          k = 16,
          R = 1,
          W = 2,
          I = 1 / 0,
          N = 9007199254740991,
          M = 17976931348623157e292,
          P = NaN,
          L = 4294967295,
          O = L - 1,
          F = L >>> 1,
          j = [["ary", x], ["bind", y], ["bindKey", v], ["curry", g], ["curryRight", A], ["flip", C], ["partial", w], ["partialRight", T], ["rearg", D]],
          G = "[object Arguments]",
          V = "[object Array]",
          U = "[object AsyncFunction]",
          H = "[object Boolean]",
          z = "[object Date]",
          K = "[object DOMException]",
          q = "[object Error]",
          Y = "[object Function]",
          Z = "[object GeneratorFunction]",
          J = "[object Map]",
          X = "[object Number]",
          $ = "[object Null]",
          Q = "[object Object]",
          ee = "[object Proxy]",
          te = "[object RegExp]",
          ae = "[object Set]",
          re = "[object String]",
          ne = "[object Symbol]",
          se = "[object Undefined]",
          oe = "[object WeakMap]",
          ie = "[object WeakSet]",
          ce = "[object ArrayBuffer]",
          ue = "[object DataView]",
          de = "[object Float32Array]",
          fe = "[object Float64Array]",
          le = "[object Int8Array]",
          he = "[object Int16Array]",
          pe = "[object Int32Array]",
          be = "[object Uint8Array]",
          me = "[object Uint8ClampedArray]",
          ye = "[object Uint16Array]",
          ve = "[object Uint32Array]",
          _e = /\b__p \+= '';/g,
          ge = /\b(__p \+=) '' \+/g,
          Ae = /(__e\(.*?\)|\b__t\)) \+\n'';/g,
          we = /&(?:amp|lt|gt|quot|#39);/g,
          Te = /[&<>"']/g,
          xe = RegExp(we.source),
          De = RegExp(Te.source),
          Ce = /<%-([\s\S]+?)%>/g,
          Se = /<%([\s\S]+?)%>/g,
          Ee = /<%=([\s\S]+?)%>/g,
          Be = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
          ke = /^\w*$/,
          Re = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
          We = /[\\^$.*+?()[\]{}|]/g,
          Ie = RegExp(We.source),
          Ne = /^\s+|\s+$/g,
          Me = /^\s+/,
          Pe = /\s+$/,
          Le = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
          Oe = /\{\n\/\* \[wrapped with (.+)\] \*/,
          Fe = /,? & /,
          je = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,
          Ge = /\\(\\)?/g,
          Ve = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,
          Ue = /\w*$/,
          He = /^[-+]0x[0-9a-f]+$/i,
          ze = /^0b[01]+$/i,
          Ke = /^\[object .+?Constructor\]$/,
          qe = /^0o[0-7]+$/i,
          Ye = /^(?:0|[1-9]\d*)$/,
          Ze = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
          Je = /($^)/,
          Xe = /['\n\r\u2028\u2029\\]/g,
          $e = "\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff",
          Qe = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
          et = "[\\ud800-\\udfff]",
          tt = "[" + Qe + "]",
          at = "[" + $e + "]",
          rt = "\\d+",
          nt = "[\\u2700-\\u27bf]",
          st = "[a-z\\xdf-\\xf6\\xf8-\\xff]",
          ot = "[^\\ud800-\\udfff" + Qe + rt + "\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde]",
          it = "\\ud83c[\\udffb-\\udfff]",
          ct = "[^\\ud800-\\udfff]",
          ut = "(?:\\ud83c[\\udde6-\\uddff]){2}",
          dt = "[\\ud800-\\udbff][\\udc00-\\udfff]",
          ft = "[A-Z\\xc0-\\xd6\\xd8-\\xde]",
          lt = "(?:" + st + "|" + ot + ")",
          ht = "(?:" + ft + "|" + ot + ")",
          pt = "(?:" + at + "|" + it + ")" + "?",
          bt = "[\\ufe0e\\ufe0f]?" + pt + ("(?:\\u200d(?:" + [ct, ut, dt].join("|") + ")[\\ufe0e\\ufe0f]?" + pt + ")*"),
          mt = "(?:" + [nt, ut, dt].join("|") + ")" + bt,
          yt = "(?:" + [ct + at + "?", at, ut, dt, et].join("|") + ")",
          vt = RegExp("['’]", "g"),
          _t = RegExp(at, "g"),
          gt = RegExp(it + "(?=" + it + ")|" + yt + bt, "g"),
          At = RegExp([ft + "?" + st + "+(?:['’](?:d|ll|m|re|s|t|ve))?(?=" + [tt, ft, "$"].join("|") + ")", ht + "+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=" + [tt, ft + lt, "$"].join("|") + ")", ft + "?" + lt + "+(?:['’](?:d|ll|m|re|s|t|ve))?", ft + "+(?:['’](?:D|LL|M|RE|S|T|VE))?", "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rt, mt].join("|"), "g"),
          wt = RegExp("[\\u200d\\ud800-\\udfff" + $e + "\\ufe0e\\ufe0f]"),
          Tt = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,
          xt = ["Array", "Buffer", "DataView", "Date", "Error", "Float32Array", "Float64Array", "Function", "Int8Array", "Int16Array", "Int32Array", "Map", "Math", "Object", "Promise", "RegExp", "Set", "String", "Symbol", "TypeError", "Uint8Array", "Uint8ClampedArray", "Uint16Array", "Uint32Array", "WeakMap", "_", "clearTimeout", "isFinite", "parseInt", "setTimeout"],
          Dt = -1,
          Ct = {};

      Ct[de] = Ct[fe] = Ct[le] = Ct[he] = Ct[pe] = Ct[be] = Ct[me] = Ct[ye] = Ct[ve] = !0, Ct[G] = Ct[V] = Ct[ce] = Ct[H] = Ct[ue] = Ct[z] = Ct[q] = Ct[Y] = Ct[J] = Ct[X] = Ct[Q] = Ct[te] = Ct[ae] = Ct[re] = Ct[oe] = !1;
      var St = {};
      St[G] = St[V] = St[ce] = St[ue] = St[H] = St[z] = St[de] = St[fe] = St[le] = St[he] = St[pe] = St[J] = St[X] = St[Q] = St[te] = St[ae] = St[re] = St[ne] = St[be] = St[me] = St[ye] = St[ve] = !0, St[q] = St[Y] = St[oe] = !1;

      var Et = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      },
          Bt = parseFloat,
          kt = parseInt,
          Rt = "object" == typeof e && e && e.Object === Object && e,
          Wt = "object" == typeof self && self && self.Object === Object && self,
          It = Rt || Wt || Function("return this")(),
          Nt = t && !t.nodeType && t,
          Mt = Nt && "object" == typeof r && r && !r.nodeType && r,
          Pt = Mt && Mt.exports === Nt,
          Lt = Pt && Rt.process,
          Ot = function () {
        try {
          var e = Mt && Mt.require && Mt.require("util").types;

          return e || Lt && Lt.binding && Lt.binding("util");
        } catch (e) {}
      }(),
          Ft = Ot && Ot.isArrayBuffer,
          jt = Ot && Ot.isDate,
          Gt = Ot && Ot.isMap,
          Vt = Ot && Ot.isRegExp,
          Ut = Ot && Ot.isSet,
          Ht = Ot && Ot.isTypedArray;

      function zt(e, t, a) {
        switch (a.length) {
          case 0:
            return e.call(t);

          case 1:
            return e.call(t, a[0]);

          case 2:
            return e.call(t, a[0], a[1]);

          case 3:
            return e.call(t, a[0], a[1], a[2]);
        }

        return e.apply(t, a);
      }

      function Kt(e, t, a, r) {
        for (var n = -1, s = null == e ? 0 : e.length; ++n < s;) {
          var o = e[n];
          t(r, o, a(o), e);
        }

        return r;
      }

      function qt(e, t) {
        for (var a = -1, r = null == e ? 0 : e.length; ++a < r && !1 !== t(e[a], a, e);) {
          ;
        }

        return e;
      }

      function Yt(e, t) {
        for (var a = null == e ? 0 : e.length; a-- && !1 !== t(e[a], a, e);) {
          ;
        }

        return e;
      }

      function Zt(e, t) {
        for (var a = -1, r = null == e ? 0 : e.length; ++a < r;) {
          if (!t(e[a], a, e)) return !1;
        }

        return !0;
      }

      function Jt(e, t) {
        for (var a = -1, r = null == e ? 0 : e.length, n = 0, s = []; ++a < r;) {
          var o = e[a];
          t(o, a, e) && (s[n++] = o);
        }

        return s;
      }

      function Xt(e, t) {
        return !!(null == e ? 0 : e.length) && ia(e, t, 0) > -1;
      }

      function $t(e, t, a) {
        for (var r = -1, n = null == e ? 0 : e.length; ++r < n;) {
          if (a(t, e[r])) return !0;
        }

        return !1;
      }

      function Qt(e, t) {
        for (var a = -1, r = null == e ? 0 : e.length, n = Array(r); ++a < r;) {
          n[a] = t(e[a], a, e);
        }

        return n;
      }

      function ea(e, t) {
        for (var a = -1, r = t.length, n = e.length; ++a < r;) {
          e[n + a] = t[a];
        }

        return e;
      }

      function ta(e, t, a, r) {
        var n = -1,
            s = null == e ? 0 : e.length;

        for (r && s && (a = e[++n]); ++n < s;) {
          a = t(a, e[n], n, e);
        }

        return a;
      }

      function aa(e, t, a, r) {
        var n = null == e ? 0 : e.length;

        for (r && n && (a = e[--n]); n--;) {
          a = t(a, e[n], n, e);
        }

        return a;
      }

      function ra(e, t) {
        for (var a = -1, r = null == e ? 0 : e.length; ++a < r;) {
          if (t(e[a], a, e)) return !0;
        }

        return !1;
      }

      var na = fa("length");

      function sa(e, t, a) {
        var r;
        return a(e, function (e, a, n) {
          if (t(e, a, n)) return r = a, !1;
        }), r;
      }

      function oa(e, t, a, r) {
        for (var n = e.length, s = a + (r ? 1 : -1); r ? s-- : ++s < n;) {
          if (t(e[s], s, e)) return s;
        }

        return -1;
      }

      function ia(e, t, a) {
        return t == t ? function (e, t, a) {
          var r = a - 1,
              n = e.length;

          for (; ++r < n;) {
            if (e[r] === t) return r;
          }

          return -1;
        }(e, t, a) : oa(e, ua, a);
      }

      function ca(e, t, a, r) {
        for (var n = a - 1, s = e.length; ++n < s;) {
          if (r(e[n], t)) return n;
        }

        return -1;
      }

      function ua(e) {
        return e != e;
      }

      function da(e, t) {
        var a = null == e ? 0 : e.length;
        return a ? pa(e, t) / a : P;
      }

      function fa(e) {
        return function (t) {
          return null == t ? s : t[e];
        };
      }

      function la(e) {
        return function (t) {
          return null == e ? s : e[t];
        };
      }

      function ha(e, t, a, r, n) {
        return n(e, function (e, n, s) {
          a = r ? (r = !1, e) : t(a, e, n, s);
        }), a;
      }

      function pa(e, t) {
        for (var a, r = -1, n = e.length; ++r < n;) {
          var o = t(e[r]);
          o !== s && (a = a === s ? o : a + o);
        }

        return a;
      }

      function ba(e, t) {
        for (var a = -1, r = Array(e); ++a < e;) {
          r[a] = t(a);
        }

        return r;
      }

      function ma(e) {
        return function (t) {
          return e(t);
        };
      }

      function ya(e, t) {
        return Qt(t, function (t) {
          return e[t];
        });
      }

      function va(e, t) {
        return e.has(t);
      }

      function _a(e, t) {
        for (var a = -1, r = e.length; ++a < r && ia(t, e[a], 0) > -1;) {
          ;
        }

        return a;
      }

      function ga(e, t) {
        for (var a = e.length; a-- && ia(t, e[a], 0) > -1;) {
          ;
        }

        return a;
      }

      var Aa = la({
        "À": "A",
        "Á": "A",
        "Â": "A",
        "Ã": "A",
        "Ä": "A",
        "Å": "A",
        "à": "a",
        "á": "a",
        "â": "a",
        "ã": "a",
        "ä": "a",
        "å": "a",
        "Ç": "C",
        "ç": "c",
        "Ð": "D",
        "ð": "d",
        "È": "E",
        "É": "E",
        "Ê": "E",
        "Ë": "E",
        "è": "e",
        "é": "e",
        "ê": "e",
        "ë": "e",
        "Ì": "I",
        "Í": "I",
        "Î": "I",
        "Ï": "I",
        "ì": "i",
        "í": "i",
        "î": "i",
        "ï": "i",
        "Ñ": "N",
        "ñ": "n",
        "Ò": "O",
        "Ó": "O",
        "Ô": "O",
        "Õ": "O",
        "Ö": "O",
        "Ø": "O",
        "ò": "o",
        "ó": "o",
        "ô": "o",
        "õ": "o",
        "ö": "o",
        "ø": "o",
        "Ù": "U",
        "Ú": "U",
        "Û": "U",
        "Ü": "U",
        "ù": "u",
        "ú": "u",
        "û": "u",
        "ü": "u",
        "Ý": "Y",
        "ý": "y",
        "ÿ": "y",
        "Æ": "Ae",
        "æ": "ae",
        "Þ": "Th",
        "þ": "th",
        "ß": "ss",
        "Ā": "A",
        "Ă": "A",
        "Ą": "A",
        "ā": "a",
        "ă": "a",
        "ą": "a",
        "Ć": "C",
        "Ĉ": "C",
        "Ċ": "C",
        "Č": "C",
        "ć": "c",
        "ĉ": "c",
        "ċ": "c",
        "č": "c",
        "Ď": "D",
        "Đ": "D",
        "ď": "d",
        "đ": "d",
        "Ē": "E",
        "Ĕ": "E",
        "Ė": "E",
        "Ę": "E",
        "Ě": "E",
        "ē": "e",
        "ĕ": "e",
        "ė": "e",
        "ę": "e",
        "ě": "e",
        "Ĝ": "G",
        "Ğ": "G",
        "Ġ": "G",
        "Ģ": "G",
        "ĝ": "g",
        "ğ": "g",
        "ġ": "g",
        "ģ": "g",
        "Ĥ": "H",
        "Ħ": "H",
        "ĥ": "h",
        "ħ": "h",
        "Ĩ": "I",
        "Ī": "I",
        "Ĭ": "I",
        "Į": "I",
        "İ": "I",
        "ĩ": "i",
        "ī": "i",
        "ĭ": "i",
        "į": "i",
        "ı": "i",
        "Ĵ": "J",
        "ĵ": "j",
        "Ķ": "K",
        "ķ": "k",
        "ĸ": "k",
        "Ĺ": "L",
        "Ļ": "L",
        "Ľ": "L",
        "Ŀ": "L",
        "Ł": "L",
        "ĺ": "l",
        "ļ": "l",
        "ľ": "l",
        "ŀ": "l",
        "ł": "l",
        "Ń": "N",
        "Ņ": "N",
        "Ň": "N",
        "Ŋ": "N",
        "ń": "n",
        "ņ": "n",
        "ň": "n",
        "ŋ": "n",
        "Ō": "O",
        "Ŏ": "O",
        "Ő": "O",
        "ō": "o",
        "ŏ": "o",
        "ő": "o",
        "Ŕ": "R",
        "Ŗ": "R",
        "Ř": "R",
        "ŕ": "r",
        "ŗ": "r",
        "ř": "r",
        "Ś": "S",
        "Ŝ": "S",
        "Ş": "S",
        "Š": "S",
        "ś": "s",
        "ŝ": "s",
        "ş": "s",
        "š": "s",
        "Ţ": "T",
        "Ť": "T",
        "Ŧ": "T",
        "ţ": "t",
        "ť": "t",
        "ŧ": "t",
        "Ũ": "U",
        "Ū": "U",
        "Ŭ": "U",
        "Ů": "U",
        "Ű": "U",
        "Ų": "U",
        "ũ": "u",
        "ū": "u",
        "ŭ": "u",
        "ů": "u",
        "ű": "u",
        "ų": "u",
        "Ŵ": "W",
        "ŵ": "w",
        "Ŷ": "Y",
        "ŷ": "y",
        "Ÿ": "Y",
        "Ź": "Z",
        "Ż": "Z",
        "Ž": "Z",
        "ź": "z",
        "ż": "z",
        "ž": "z",
        "Ĳ": "IJ",
        "ĳ": "ij",
        "Œ": "Oe",
        "œ": "oe",
        "ŉ": "'n",
        "ſ": "s"
      }),
          wa = la({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      });

      function Ta(e) {
        return "\\" + Et[e];
      }

      function xa(e) {
        return wt.test(e);
      }

      function Da(e) {
        var t = -1,
            a = Array(e.size);
        return e.forEach(function (e, r) {
          a[++t] = [r, e];
        }), a;
      }

      function Ca(e, t) {
        return function (a) {
          return e(t(a));
        };
      }

      function Sa(e, t) {
        for (var a = -1, r = e.length, n = 0, s = []; ++a < r;) {
          var o = e[a];
          o !== t && o !== f || (e[a] = f, s[n++] = a);
        }

        return s;
      }

      function Ea(e) {
        var t = -1,
            a = Array(e.size);
        return e.forEach(function (e) {
          a[++t] = e;
        }), a;
      }

      function Ba(e) {
        var t = -1,
            a = Array(e.size);
        return e.forEach(function (e) {
          a[++t] = [e, e];
        }), a;
      }

      function ka(e) {
        return xa(e) ? function (e) {
          var t = gt.lastIndex = 0;

          for (; gt.test(e);) {
            ++t;
          }

          return t;
        }(e) : na(e);
      }

      function Ra(e) {
        return xa(e) ? function (e) {
          return e.match(gt) || [];
        }(e) : function (e) {
          return e.split("");
        }(e);
      }

      var Wa = la({
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      });

      var Ia = function e(t) {
        var a,
            r = (t = null == t ? It : Ia.defaults(It.Object(), t, Ia.pick(It, xt))).Array,
            n = t.Date,
            $e = t.Error,
            Qe = t.Function,
            et = t.Math,
            tt = t.Object,
            at = t.RegExp,
            rt = t.String,
            nt = t.TypeError,
            st = r.prototype,
            ot = Qe.prototype,
            it = tt.prototype,
            ct = t["__core-js_shared__"],
            ut = ot.toString,
            dt = it.hasOwnProperty,
            ft = 0,
            lt = (a = /[^.]+$/.exec(ct && ct.keys && ct.keys.IE_PROTO || "")) ? "Symbol(src)_1." + a : "",
            ht = it.toString,
            pt = ut.call(tt),
            bt = It._,
            mt = at("^" + ut.call(dt).replace(We, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
            yt = Pt ? t.Buffer : s,
            gt = t.Symbol,
            wt = t.Uint8Array,
            Et = yt ? yt.allocUnsafe : s,
            Rt = Ca(tt.getPrototypeOf, tt),
            Wt = tt.create,
            Nt = it.propertyIsEnumerable,
            Mt = st.splice,
            Lt = gt ? gt.isConcatSpreadable : s,
            Ot = gt ? gt.iterator : s,
            na = gt ? gt.toStringTag : s,
            la = function () {
          try {
            var e = Os(tt, "defineProperty");
            return e({}, "", {}), e;
          } catch (e) {}
        }(),
            Na = t.clearTimeout !== It.clearTimeout && t.clearTimeout,
            Ma = n && n.now !== It.Date.now && n.now,
            Pa = t.setTimeout !== It.setTimeout && t.setTimeout,
            La = et.ceil,
            Oa = et.floor,
            Fa = tt.getOwnPropertySymbols,
            ja = yt ? yt.isBuffer : s,
            Ga = t.isFinite,
            Va = st.join,
            Ua = Ca(tt.keys, tt),
            Ha = et.max,
            za = et.min,
            Ka = n.now,
            qa = t.parseInt,
            Ya = et.random,
            Za = st.reverse,
            Ja = Os(t, "DataView"),
            Xa = Os(t, "Map"),
            $a = Os(t, "Promise"),
            Qa = Os(t, "Set"),
            er = Os(t, "WeakMap"),
            tr = Os(tt, "create"),
            ar = er && new er(),
            rr = {},
            nr = fo(Ja),
            sr = fo(Xa),
            or = fo($a),
            ir = fo(Qa),
            cr = fo(er),
            ur = gt ? gt.prototype : s,
            dr = ur ? ur.valueOf : s,
            fr = ur ? ur.toString : s;

        function lr(e) {
          if (Ei(e) && !yi(e) && !(e instanceof mr)) {
            if (e instanceof br) return e;
            if (dt.call(e, "__wrapped__")) return lo(e);
          }

          return new br(e);
        }

        var hr = function () {
          function e() {}

          return function (t) {
            if (!Si(t)) return {};
            if (Wt) return Wt(t);
            e.prototype = t;
            var a = new e();
            return e.prototype = s, a;
          };
        }();

        function pr() {}

        function br(e, t) {
          this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = s;
        }

        function mr(e) {
          this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = L, this.__views__ = [];
        }

        function yr(e) {
          var t = -1,
              a = null == e ? 0 : e.length;

          for (this.clear(); ++t < a;) {
            var r = e[t];
            this.set(r[0], r[1]);
          }
        }

        function vr(e) {
          var t = -1,
              a = null == e ? 0 : e.length;

          for (this.clear(); ++t < a;) {
            var r = e[t];
            this.set(r[0], r[1]);
          }
        }

        function _r(e) {
          var t = -1,
              a = null == e ? 0 : e.length;

          for (this.clear(); ++t < a;) {
            var r = e[t];
            this.set(r[0], r[1]);
          }
        }

        function gr(e) {
          var t = -1,
              a = null == e ? 0 : e.length;

          for (this.__data__ = new _r(); ++t < a;) {
            this.add(e[t]);
          }
        }

        function Ar(e) {
          var t = this.__data__ = new vr(e);
          this.size = t.size;
        }

        function wr(e, t) {
          var a = yi(e),
              r = !a && mi(e),
              n = !a && !r && Ai(e),
              s = !a && !r && !n && Pi(e),
              o = a || r || n || s,
              i = o ? ba(e.length, rt) : [],
              c = i.length;

          for (var u in e) {
            !t && !dt.call(e, u) || o && ("length" == u || n && ("offset" == u || "parent" == u) || s && ("buffer" == u || "byteLength" == u || "byteOffset" == u) || zs(u, c)) || i.push(u);
          }

          return i;
        }

        function Tr(e) {
          var t = e.length;
          return t ? e[An(0, t - 1)] : s;
        }

        function xr(e, t) {
          return io(as(e), Ir(t, 0, e.length));
        }

        function Dr(e) {
          return io(as(e));
        }

        function Cr(e, t, a) {
          (a === s || hi(e[t], a)) && (a !== s || t in e) || Rr(e, t, a);
        }

        function Sr(e, t, a) {
          var r = e[t];
          dt.call(e, t) && hi(r, a) && (a !== s || t in e) || Rr(e, t, a);
        }

        function Er(e, t) {
          for (var a = e.length; a--;) {
            if (hi(e[a][0], t)) return a;
          }

          return -1;
        }

        function Br(e, t, a, r) {
          return Or(e, function (e, n, s) {
            t(r, e, a(e), s);
          }), r;
        }

        function kr(e, t) {
          return e && rs(t, nc(t), e);
        }

        function Rr(e, t, a) {
          "__proto__" == t && la ? la(e, t, {
            configurable: !0,
            enumerable: !0,
            value: a,
            writable: !0
          }) : e[t] = a;
        }

        function Wr(e, t) {
          for (var a = -1, n = t.length, o = r(n), i = null == e; ++a < n;) {
            o[a] = i ? s : Qi(e, t[a]);
          }

          return o;
        }

        function Ir(e, t, a) {
          return e == e && (a !== s && (e = e <= a ? e : a), t !== s && (e = e >= t ? e : t)), e;
        }

        function Nr(e, t, a, r, n, o) {
          var i,
              c = t & l,
              u = t & h,
              d = t & p;
          if (a && (i = n ? a(e, r, n, o) : a(e)), i !== s) return i;
          if (!Si(e)) return e;
          var f = yi(e);

          if (f) {
            if (i = function (e) {
              var t = e.length,
                  a = new e.constructor(t);
              t && "string" == typeof e[0] && dt.call(e, "index") && (a.index = e.index, a.input = e.input);
              return a;
            }(e), !c) return as(e, i);
          } else {
            var b = Gs(e),
                m = b == Y || b == Z;
            if (Ai(e)) return Jn(e, c);

            if (b == Q || b == G || m && !n) {
              if (i = u || m ? {} : Us(e), !c) return u ? function (e, t) {
                return rs(e, js(e), t);
              }(e, function (e, t) {
                return e && rs(t, sc(t), e);
              }(i, e)) : function (e, t) {
                return rs(e, Fs(e), t);
              }(e, kr(i, e));
            } else {
              if (!St[b]) return n ? e : {};

              i = function (e, t, a) {
                var r = e.constructor;

                switch (t) {
                  case ce:
                    return Xn(e);

                  case H:
                  case z:
                    return new r(+e);

                  case ue:
                    return function (e, t) {
                      var a = t ? Xn(e.buffer) : e.buffer;
                      return new e.constructor(a, e.byteOffset, e.byteLength);
                    }(e, a);

                  case de:
                  case fe:
                  case le:
                  case he:
                  case pe:
                  case be:
                  case me:
                  case ye:
                  case ve:
                    return $n(e, a);

                  case J:
                    return new r();

                  case X:
                  case re:
                    return new r(e);

                  case te:
                    return function (e) {
                      var t = new e.constructor(e.source, Ue.exec(e));
                      return t.lastIndex = e.lastIndex, t;
                    }(e);

                  case ae:
                    return new r();

                  case ne:
                    return n = e, dr ? tt(dr.call(n)) : {};
                }

                var n;
              }(e, b, c);
            }
          }

          o || (o = new Ar());
          var y = o.get(e);
          if (y) return y;
          o.set(e, i), Ii(e) ? e.forEach(function (r) {
            i.add(Nr(r, t, a, r, e, o));
          }) : Bi(e) && e.forEach(function (r, n) {
            i.set(n, Nr(r, t, a, n, e, o));
          });
          var v = f ? s : (d ? u ? Rs : ks : u ? sc : nc)(e);
          return qt(v || e, function (r, n) {
            v && (r = e[n = r]), Sr(i, n, Nr(r, t, a, n, e, o));
          }), i;
        }

        function Mr(e, t, a) {
          var r = a.length;
          if (null == e) return !r;

          for (e = tt(e); r--;) {
            var n = a[r],
                o = t[n],
                i = e[n];
            if (i === s && !(n in e) || !o(i)) return !1;
          }

          return !0;
        }

        function Pr(e, t, a) {
          if ("function" != typeof e) throw new nt(c);
          return ro(function () {
            e.apply(s, a);
          }, t);
        }

        function Lr(e, t, a, r) {
          var n = -1,
              s = Xt,
              i = !0,
              c = e.length,
              u = [],
              d = t.length;
          if (!c) return u;
          a && (t = Qt(t, ma(a))), r ? (s = $t, i = !1) : t.length >= o && (s = va, i = !1, t = new gr(t));

          e: for (; ++n < c;) {
            var f = e[n],
                l = null == a ? f : a(f);

            if (f = r || 0 !== f ? f : 0, i && l == l) {
              for (var h = d; h--;) {
                if (t[h] === l) continue e;
              }

              u.push(f);
            } else s(t, l, r) || u.push(f);
          }

          return u;
        }

        lr.templateSettings = {
          escape: Ce,
          evaluate: Se,
          interpolate: Ee,
          variable: "",
          imports: {
            _: lr
          }
        }, lr.prototype = pr.prototype, lr.prototype.constructor = lr, br.prototype = hr(pr.prototype), br.prototype.constructor = br, mr.prototype = hr(pr.prototype), mr.prototype.constructor = mr, yr.prototype.clear = function () {
          this.__data__ = tr ? tr(null) : {}, this.size = 0;
        }, yr.prototype.delete = function (e) {
          var t = this.has(e) && delete this.__data__[e];
          return this.size -= t ? 1 : 0, t;
        }, yr.prototype.get = function (e) {
          var t = this.__data__;

          if (tr) {
            var a = t[e];
            return a === u ? s : a;
          }

          return dt.call(t, e) ? t[e] : s;
        }, yr.prototype.has = function (e) {
          var t = this.__data__;
          return tr ? t[e] !== s : dt.call(t, e);
        }, yr.prototype.set = function (e, t) {
          var a = this.__data__;
          return this.size += this.has(e) ? 0 : 1, a[e] = tr && t === s ? u : t, this;
        }, vr.prototype.clear = function () {
          this.__data__ = [], this.size = 0;
        }, vr.prototype.delete = function (e) {
          var t = this.__data__,
              a = Er(t, e);
          return !(a < 0) && (a == t.length - 1 ? t.pop() : Mt.call(t, a, 1), --this.size, !0);
        }, vr.prototype.get = function (e) {
          var t = this.__data__,
              a = Er(t, e);
          return a < 0 ? s : t[a][1];
        }, vr.prototype.has = function (e) {
          return Er(this.__data__, e) > -1;
        }, vr.prototype.set = function (e, t) {
          var a = this.__data__,
              r = Er(a, e);
          return r < 0 ? (++this.size, a.push([e, t])) : a[r][1] = t, this;
        }, _r.prototype.clear = function () {
          this.size = 0, this.__data__ = {
            hash: new yr(),
            map: new (Xa || vr)(),
            string: new yr()
          };
        }, _r.prototype.delete = function (e) {
          var t = Ps(this, e).delete(e);
          return this.size -= t ? 1 : 0, t;
        }, _r.prototype.get = function (e) {
          return Ps(this, e).get(e);
        }, _r.prototype.has = function (e) {
          return Ps(this, e).has(e);
        }, _r.prototype.set = function (e, t) {
          var a = Ps(this, e),
              r = a.size;
          return a.set(e, t), this.size += a.size == r ? 0 : 1, this;
        }, gr.prototype.add = gr.prototype.push = function (e) {
          return this.__data__.set(e, u), this;
        }, gr.prototype.has = function (e) {
          return this.__data__.has(e);
        }, Ar.prototype.clear = function () {
          this.__data__ = new vr(), this.size = 0;
        }, Ar.prototype.delete = function (e) {
          var t = this.__data__,
              a = t.delete(e);
          return this.size = t.size, a;
        }, Ar.prototype.get = function (e) {
          return this.__data__.get(e);
        }, Ar.prototype.has = function (e) {
          return this.__data__.has(e);
        }, Ar.prototype.set = function (e, t) {
          var a = this.__data__;

          if (a instanceof vr) {
            var r = a.__data__;
            if (!Xa || r.length < o - 1) return r.push([e, t]), this.size = ++a.size, this;
            a = this.__data__ = new _r(r);
          }

          return a.set(e, t), this.size = a.size, this;
        };
        var Or = os(Kr),
            Fr = os(qr, !0);

        function jr(e, t) {
          var a = !0;
          return Or(e, function (e, r, n) {
            return a = !!t(e, r, n);
          }), a;
        }

        function Gr(e, t, a) {
          for (var r = -1, n = e.length; ++r < n;) {
            var o = e[r],
                i = t(o);
            if (null != i && (c === s ? i == i && !Mi(i) : a(i, c))) var c = i,
                u = o;
          }

          return u;
        }

        function Vr(e, t) {
          var a = [];
          return Or(e, function (e, r, n) {
            t(e, r, n) && a.push(e);
          }), a;
        }

        function Ur(e, t, a, r, n) {
          var s = -1,
              o = e.length;

          for (a || (a = Hs), n || (n = []); ++s < o;) {
            var i = e[s];
            t > 0 && a(i) ? t > 1 ? Ur(i, t - 1, a, r, n) : ea(n, i) : r || (n[n.length] = i);
          }

          return n;
        }

        var Hr = is(),
            zr = is(!0);

        function Kr(e, t) {
          return e && Hr(e, t, nc);
        }

        function qr(e, t) {
          return e && zr(e, t, nc);
        }

        function Yr(e, t) {
          return Jt(t, function (t) {
            return xi(e[t]);
          });
        }

        function Zr(e, t) {
          for (var a = 0, r = (t = Kn(t, e)).length; null != e && a < r;) {
            e = e[uo(t[a++])];
          }

          return a && a == r ? e : s;
        }

        function Jr(e, t, a) {
          var r = t(e);
          return yi(e) ? r : ea(r, a(e));
        }

        function Xr(e) {
          return null == e ? e === s ? se : $ : na && na in tt(e) ? function (e) {
            var t = dt.call(e, na),
                a = e[na];

            try {
              e[na] = s;
              var r = !0;
            } catch (e) {}

            var n = ht.call(e);
            r && (t ? e[na] = a : delete e[na]);
            return n;
          }(e) : function (e) {
            return ht.call(e);
          }(e);
        }

        function $r(e, t) {
          return e > t;
        }

        function Qr(e, t) {
          return null != e && dt.call(e, t);
        }

        function en(e, t) {
          return null != e && t in tt(e);
        }

        function tn(e, t, a) {
          for (var n = a ? $t : Xt, o = e[0].length, i = e.length, c = i, u = r(i), d = 1 / 0, f = []; c--;) {
            var l = e[c];
            c && t && (l = Qt(l, ma(t))), d = za(l.length, d), u[c] = !a && (t || o >= 120 && l.length >= 120) ? new gr(c && l) : s;
          }

          l = e[0];
          var h = -1,
              p = u[0];

          e: for (; ++h < o && f.length < d;) {
            var b = l[h],
                m = t ? t(b) : b;

            if (b = a || 0 !== b ? b : 0, !(p ? va(p, m) : n(f, m, a))) {
              for (c = i; --c;) {
                var y = u[c];
                if (!(y ? va(y, m) : n(e[c], m, a))) continue e;
              }

              p && p.push(m), f.push(b);
            }
          }

          return f;
        }

        function an(e, t, a) {
          var r = null == (e = eo(e, t = Kn(t, e))) ? e : e[uo(To(t))];
          return null == r ? s : zt(r, e, a);
        }

        function rn(e) {
          return Ei(e) && Xr(e) == G;
        }

        function nn(e, t, a, r, n) {
          return e === t || (null == e || null == t || !Ei(e) && !Ei(t) ? e != e && t != t : function (e, t, a, r, n, o) {
            var i = yi(e),
                c = yi(t),
                u = i ? V : Gs(e),
                d = c ? V : Gs(t),
                f = (u = u == G ? Q : u) == Q,
                l = (d = d == G ? Q : d) == Q,
                h = u == d;

            if (h && Ai(e)) {
              if (!Ai(t)) return !1;
              i = !0, f = !1;
            }

            if (h && !f) return o || (o = new Ar()), i || Pi(e) ? Es(e, t, a, r, n, o) : function (e, t, a, r, n, s, o) {
              switch (a) {
                case ue:
                  if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                  e = e.buffer, t = t.buffer;

                case ce:
                  return !(e.byteLength != t.byteLength || !s(new wt(e), new wt(t)));

                case H:
                case z:
                case X:
                  return hi(+e, +t);

                case q:
                  return e.name == t.name && e.message == t.message;

                case te:
                case re:
                  return e == t + "";

                case J:
                  var i = Da;

                case ae:
                  var c = r & b;
                  if (i || (i = Ea), e.size != t.size && !c) return !1;
                  var u = o.get(e);
                  if (u) return u == t;
                  r |= m, o.set(e, t);
                  var d = Es(i(e), i(t), r, n, s, o);
                  return o.delete(e), d;

                case ne:
                  if (dr) return dr.call(e) == dr.call(t);
              }

              return !1;
            }(e, t, u, a, r, n, o);

            if (!(a & b)) {
              var p = f && dt.call(e, "__wrapped__"),
                  y = l && dt.call(t, "__wrapped__");

              if (p || y) {
                var v = p ? e.value() : e,
                    _ = y ? t.value() : t;

                return o || (o = new Ar()), n(v, _, a, r, o);
              }
            }

            if (!h) return !1;
            return o || (o = new Ar()), function (e, t, a, r, n, o) {
              var i = a & b,
                  c = ks(e),
                  u = c.length,
                  d = ks(t).length;
              if (u != d && !i) return !1;
              var f = u;

              for (; f--;) {
                var l = c[f];
                if (!(i ? l in t : dt.call(t, l))) return !1;
              }

              var h = o.get(e);
              if (h && o.get(t)) return h == t;
              var p = !0;
              o.set(e, t), o.set(t, e);
              var m = i;

              for (; ++f < u;) {
                l = c[f];
                var y = e[l],
                    v = t[l];
                if (r) var _ = i ? r(v, y, l, t, e, o) : r(y, v, l, e, t, o);

                if (!(_ === s ? y === v || n(y, v, a, r, o) : _)) {
                  p = !1;
                  break;
                }

                m || (m = "constructor" == l);
              }

              if (p && !m) {
                var g = e.constructor,
                    A = t.constructor;
                g != A && "constructor" in e && "constructor" in t && !("function" == typeof g && g instanceof g && "function" == typeof A && A instanceof A) && (p = !1);
              }

              return o.delete(e), o.delete(t), p;
            }(e, t, a, r, n, o);
          }(e, t, a, r, nn, n));
        }

        function sn(e, t, a, r) {
          var n = a.length,
              o = n,
              i = !r;
          if (null == e) return !o;

          for (e = tt(e); n--;) {
            var c = a[n];
            if (i && c[2] ? c[1] !== e[c[0]] : !(c[0] in e)) return !1;
          }

          for (; ++n < o;) {
            var u = (c = a[n])[0],
                d = e[u],
                f = c[1];

            if (i && c[2]) {
              if (d === s && !(u in e)) return !1;
            } else {
              var l = new Ar();
              if (r) var h = r(d, f, u, e, t, l);
              if (!(h === s ? nn(f, d, b | m, r, l) : h)) return !1;
            }
          }

          return !0;
        }

        function on(e) {
          return !(!Si(e) || (t = e, lt && lt in t)) && (xi(e) ? mt : Ke).test(fo(e));
          var t;
        }

        function cn(e) {
          return "function" == typeof e ? e : null == e ? kc : "object" == typeof e ? yi(e) ? pn(e[0], e[1]) : hn(e) : Fc(e);
        }

        function un(e) {
          if (!Js(e)) return Ua(e);
          var t = [];

          for (var a in tt(e)) {
            dt.call(e, a) && "constructor" != a && t.push(a);
          }

          return t;
        }

        function dn(e) {
          if (!Si(e)) return function (e) {
            var t = [];
            if (null != e) for (var a in tt(e)) {
              t.push(a);
            }
            return t;
          }(e);
          var t = Js(e),
              a = [];

          for (var r in e) {
            ("constructor" != r || !t && dt.call(e, r)) && a.push(r);
          }

          return a;
        }

        function fn(e, t) {
          return e < t;
        }

        function ln(e, t) {
          var a = -1,
              n = _i(e) ? r(e.length) : [];
          return Or(e, function (e, r, s) {
            n[++a] = t(e, r, s);
          }), n;
        }

        function hn(e) {
          var t = Ls(e);
          return 1 == t.length && t[0][2] ? $s(t[0][0], t[0][1]) : function (a) {
            return a === e || sn(a, e, t);
          };
        }

        function pn(e, t) {
          return qs(e) && Xs(t) ? $s(uo(e), t) : function (a) {
            var r = Qi(a, e);
            return r === s && r === t ? ec(a, e) : nn(t, r, b | m);
          };
        }

        function bn(e, t, a, r, n) {
          e !== t && Hr(t, function (o, i) {
            if (n || (n = new Ar()), Si(o)) !function (e, t, a, r, n, o, i) {
              var c = to(e, a),
                  u = to(t, a),
                  d = i.get(u);
              if (d) return void Cr(e, a, d);
              var f = o ? o(c, u, a + "", e, t, i) : s,
                  l = f === s;

              if (l) {
                var h = yi(u),
                    p = !h && Ai(u),
                    b = !h && !p && Pi(u);
                f = u, h || p || b ? yi(c) ? f = c : gi(c) ? f = as(c) : p ? (l = !1, f = Jn(u, !0)) : b ? (l = !1, f = $n(u, !0)) : f = [] : Ri(u) || mi(u) ? (f = c, mi(c) ? f = Hi(c) : Si(c) && !xi(c) || (f = Us(u))) : l = !1;
              }

              l && (i.set(u, f), n(f, u, r, o, i), i.delete(u));
              Cr(e, a, f);
            }(e, t, i, a, bn, r, n);else {
              var c = r ? r(to(e, i), o, i + "", e, t, n) : s;
              c === s && (c = o), Cr(e, i, c);
            }
          }, sc);
        }

        function mn(e, t) {
          var a = e.length;
          if (a) return zs(t += t < 0 ? a : 0, a) ? e[t] : s;
        }

        function yn(e, t, a) {
          var r = -1;
          return t = Qt(t.length ? t : [kc], ma(Ms())), function (e, t) {
            var a = e.length;

            for (e.sort(t); a--;) {
              e[a] = e[a].value;
            }

            return e;
          }(ln(e, function (e, a, n) {
            return {
              criteria: Qt(t, function (t) {
                return t(e);
              }),
              index: ++r,
              value: e
            };
          }), function (e, t) {
            return function (e, t, a) {
              var r = -1,
                  n = e.criteria,
                  s = t.criteria,
                  o = n.length,
                  i = a.length;

              for (; ++r < o;) {
                var c = Qn(n[r], s[r]);

                if (c) {
                  if (r >= i) return c;
                  var u = a[r];
                  return c * ("desc" == u ? -1 : 1);
                }
              }

              return e.index - t.index;
            }(e, t, a);
          });
        }

        function vn(e, t, a) {
          for (var r = -1, n = t.length, s = {}; ++r < n;) {
            var o = t[r],
                i = Zr(e, o);
            a(i, o) && Cn(s, Kn(o, e), i);
          }

          return s;
        }

        function _n(e, t, a, r) {
          var n = r ? ca : ia,
              s = -1,
              o = t.length,
              i = e;

          for (e === t && (t = as(t)), a && (i = Qt(e, ma(a))); ++s < o;) {
            for (var c = 0, u = t[s], d = a ? a(u) : u; (c = n(i, d, c, r)) > -1;) {
              i !== e && Mt.call(i, c, 1), Mt.call(e, c, 1);
            }
          }

          return e;
        }

        function gn(e, t) {
          for (var a = e ? t.length : 0, r = a - 1; a--;) {
            var n = t[a];

            if (a == r || n !== s) {
              var s = n;
              zs(n) ? Mt.call(e, n, 1) : On(e, n);
            }
          }

          return e;
        }

        function An(e, t) {
          return e + Oa(Ya() * (t - e + 1));
        }

        function wn(e, t) {
          var a = "";
          if (!e || t < 1 || t > N) return a;

          do {
            t % 2 && (a += e), (t = Oa(t / 2)) && (e += e);
          } while (t);

          return a;
        }

        function Tn(e, t) {
          return no(Qs(e, t, kc), e + "");
        }

        function xn(e) {
          return Tr(hc(e));
        }

        function Dn(e, t) {
          var a = hc(e);
          return io(a, Ir(t, 0, a.length));
        }

        function Cn(e, t, a, r) {
          if (!Si(e)) return e;

          for (var n = -1, o = (t = Kn(t, e)).length, i = o - 1, c = e; null != c && ++n < o;) {
            var u = uo(t[n]),
                d = a;

            if (n != i) {
              var f = c[u];
              (d = r ? r(f, u, c) : s) === s && (d = Si(f) ? f : zs(t[n + 1]) ? [] : {});
            }

            Sr(c, u, d), c = c[u];
          }

          return e;
        }

        var Sn = ar ? function (e, t) {
          return ar.set(e, t), e;
        } : kc,
            En = la ? function (e, t) {
          return la(e, "toString", {
            configurable: !0,
            enumerable: !1,
            value: Sc(t),
            writable: !0
          });
        } : kc;

        function Bn(e) {
          return io(hc(e));
        }

        function kn(e, t, a) {
          var n = -1,
              s = e.length;
          t < 0 && (t = -t > s ? 0 : s + t), (a = a > s ? s : a) < 0 && (a += s), s = t > a ? 0 : a - t >>> 0, t >>>= 0;

          for (var o = r(s); ++n < s;) {
            o[n] = e[n + t];
          }

          return o;
        }

        function Rn(e, t) {
          var a;
          return Or(e, function (e, r, n) {
            return !(a = t(e, r, n));
          }), !!a;
        }

        function Wn(e, t, a) {
          var r = 0,
              n = null == e ? r : e.length;

          if ("number" == typeof t && t == t && n <= F) {
            for (; r < n;) {
              var s = r + n >>> 1,
                  o = e[s];
              null !== o && !Mi(o) && (a ? o <= t : o < t) ? r = s + 1 : n = s;
            }

            return n;
          }

          return In(e, t, kc, a);
        }

        function In(e, t, a, r) {
          t = a(t);

          for (var n = 0, o = null == e ? 0 : e.length, i = t != t, c = null === t, u = Mi(t), d = t === s; n < o;) {
            var f = Oa((n + o) / 2),
                l = a(e[f]),
                h = l !== s,
                p = null === l,
                b = l == l,
                m = Mi(l);
            if (i) var y = r || b;else y = d ? b && (r || h) : c ? b && h && (r || !p) : u ? b && h && !p && (r || !m) : !p && !m && (r ? l <= t : l < t);
            y ? n = f + 1 : o = f;
          }

          return za(o, O);
        }

        function Nn(e, t) {
          for (var a = -1, r = e.length, n = 0, s = []; ++a < r;) {
            var o = e[a],
                i = t ? t(o) : o;

            if (!a || !hi(i, c)) {
              var c = i;
              s[n++] = 0 === o ? 0 : o;
            }
          }

          return s;
        }

        function Mn(e) {
          return "number" == typeof e ? e : Mi(e) ? P : +e;
        }

        function Pn(e) {
          if ("string" == typeof e) return e;
          if (yi(e)) return Qt(e, Pn) + "";
          if (Mi(e)) return fr ? fr.call(e) : "";
          var t = e + "";
          return "0" == t && 1 / e == -I ? "-0" : t;
        }

        function Ln(e, t, a) {
          var r = -1,
              n = Xt,
              s = e.length,
              i = !0,
              c = [],
              u = c;
          if (a) i = !1, n = $t;else if (s >= o) {
            var d = t ? null : ws(e);
            if (d) return Ea(d);
            i = !1, n = va, u = new gr();
          } else u = t ? [] : c;

          e: for (; ++r < s;) {
            var f = e[r],
                l = t ? t(f) : f;

            if (f = a || 0 !== f ? f : 0, i && l == l) {
              for (var h = u.length; h--;) {
                if (u[h] === l) continue e;
              }

              t && u.push(l), c.push(f);
            } else n(u, l, a) || (u !== c && u.push(l), c.push(f));
          }

          return c;
        }

        function On(e, t) {
          return null == (e = eo(e, t = Kn(t, e))) || delete e[uo(To(t))];
        }

        function Fn(e, t, a, r) {
          return Cn(e, t, a(Zr(e, t)), r);
        }

        function jn(e, t, a, r) {
          for (var n = e.length, s = r ? n : -1; (r ? s-- : ++s < n) && t(e[s], s, e);) {
            ;
          }

          return a ? kn(e, r ? 0 : s, r ? s + 1 : n) : kn(e, r ? s + 1 : 0, r ? n : s);
        }

        function Gn(e, t) {
          var a = e;
          return a instanceof mr && (a = a.value()), ta(t, function (e, t) {
            return t.func.apply(t.thisArg, ea([e], t.args));
          }, a);
        }

        function Vn(e, t, a) {
          var n = e.length;
          if (n < 2) return n ? Ln(e[0]) : [];

          for (var s = -1, o = r(n); ++s < n;) {
            for (var i = e[s], c = -1; ++c < n;) {
              c != s && (o[s] = Lr(o[s] || i, e[c], t, a));
            }
          }

          return Ln(Ur(o, 1), t, a);
        }

        function Un(e, t, a) {
          for (var r = -1, n = e.length, o = t.length, i = {}; ++r < n;) {
            var c = r < o ? t[r] : s;
            a(i, e[r], c);
          }

          return i;
        }

        function Hn(e) {
          return gi(e) ? e : [];
        }

        function zn(e) {
          return "function" == typeof e ? e : kc;
        }

        function Kn(e, t) {
          return yi(e) ? e : qs(e, t) ? [e] : co(zi(e));
        }

        var qn = Tn;

        function Yn(e, t, a) {
          var r = e.length;
          return a = a === s ? r : a, !t && a >= r ? e : kn(e, t, a);
        }

        var Zn = Na || function (e) {
          return It.clearTimeout(e);
        };

        function Jn(e, t) {
          if (t) return e.slice();
          var a = e.length,
              r = Et ? Et(a) : new e.constructor(a);
          return e.copy(r), r;
        }

        function Xn(e) {
          var t = new e.constructor(e.byteLength);
          return new wt(t).set(new wt(e)), t;
        }

        function $n(e, t) {
          var a = t ? Xn(e.buffer) : e.buffer;
          return new e.constructor(a, e.byteOffset, e.length);
        }

        function Qn(e, t) {
          if (e !== t) {
            var a = e !== s,
                r = null === e,
                n = e == e,
                o = Mi(e),
                i = t !== s,
                c = null === t,
                u = t == t,
                d = Mi(t);
            if (!c && !d && !o && e > t || o && i && u && !c && !d || r && i && u || !a && u || !n) return 1;
            if (!r && !o && !d && e < t || d && a && n && !r && !o || c && a && n || !i && n || !u) return -1;
          }

          return 0;
        }

        function es(e, t, a, n) {
          for (var s = -1, o = e.length, i = a.length, c = -1, u = t.length, d = Ha(o - i, 0), f = r(u + d), l = !n; ++c < u;) {
            f[c] = t[c];
          }

          for (; ++s < i;) {
            (l || s < o) && (f[a[s]] = e[s]);
          }

          for (; d--;) {
            f[c++] = e[s++];
          }

          return f;
        }

        function ts(e, t, a, n) {
          for (var s = -1, o = e.length, i = -1, c = a.length, u = -1, d = t.length, f = Ha(o - c, 0), l = r(f + d), h = !n; ++s < f;) {
            l[s] = e[s];
          }

          for (var p = s; ++u < d;) {
            l[p + u] = t[u];
          }

          for (; ++i < c;) {
            (h || s < o) && (l[p + a[i]] = e[s++]);
          }

          return l;
        }

        function as(e, t) {
          var a = -1,
              n = e.length;

          for (t || (t = r(n)); ++a < n;) {
            t[a] = e[a];
          }

          return t;
        }

        function rs(e, t, a, r) {
          var n = !a;
          a || (a = {});

          for (var o = -1, i = t.length; ++o < i;) {
            var c = t[o],
                u = r ? r(a[c], e[c], c, a, e) : s;
            u === s && (u = e[c]), n ? Rr(a, c, u) : Sr(a, c, u);
          }

          return a;
        }

        function ns(e, t) {
          return function (a, r) {
            var n = yi(a) ? Kt : Br,
                s = t ? t() : {};
            return n(a, e, Ms(r, 2), s);
          };
        }

        function ss(e) {
          return Tn(function (t, a) {
            var r = -1,
                n = a.length,
                o = n > 1 ? a[n - 1] : s,
                i = n > 2 ? a[2] : s;

            for (o = e.length > 3 && "function" == typeof o ? (n--, o) : s, i && Ks(a[0], a[1], i) && (o = n < 3 ? s : o, n = 1), t = tt(t); ++r < n;) {
              var c = a[r];
              c && e(t, c, r, o);
            }

            return t;
          });
        }

        function os(e, t) {
          return function (a, r) {
            if (null == a) return a;
            if (!_i(a)) return e(a, r);

            for (var n = a.length, s = t ? n : -1, o = tt(a); (t ? s-- : ++s < n) && !1 !== r(o[s], s, o);) {
              ;
            }

            return a;
          };
        }

        function is(e) {
          return function (t, a, r) {
            for (var n = -1, s = tt(t), o = r(t), i = o.length; i--;) {
              var c = o[e ? i : ++n];
              if (!1 === a(s[c], c, s)) break;
            }

            return t;
          };
        }

        function cs(e) {
          return function (t) {
            var a = xa(t = zi(t)) ? Ra(t) : s,
                r = a ? a[0] : t.charAt(0),
                n = a ? Yn(a, 1).join("") : t.slice(1);
            return r[e]() + n;
          };
        }

        function us(e) {
          return function (t) {
            return ta(xc(mc(t).replace(vt, "")), e, "");
          };
        }

        function ds(e) {
          return function () {
            var t = arguments;

            switch (t.length) {
              case 0:
                return new e();

              case 1:
                return new e(t[0]);

              case 2:
                return new e(t[0], t[1]);

              case 3:
                return new e(t[0], t[1], t[2]);

              case 4:
                return new e(t[0], t[1], t[2], t[3]);

              case 5:
                return new e(t[0], t[1], t[2], t[3], t[4]);

              case 6:
                return new e(t[0], t[1], t[2], t[3], t[4], t[5]);

              case 7:
                return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
            }

            var a = hr(e.prototype),
                r = e.apply(a, t);
            return Si(r) ? r : a;
          };
        }

        function fs(e) {
          return function (t, a, r) {
            var n = tt(t);

            if (!_i(t)) {
              var o = Ms(a, 3);
              t = nc(t), a = function a(e) {
                return o(n[e], e, n);
              };
            }

            var i = e(t, a, r);
            return i > -1 ? n[o ? t[i] : i] : s;
          };
        }

        function ls(e) {
          return Bs(function (t) {
            var a = t.length,
                r = a,
                n = br.prototype.thru;

            for (e && t.reverse(); r--;) {
              var o = t[r];
              if ("function" != typeof o) throw new nt(c);
              if (n && !i && "wrapper" == Is(o)) var i = new br([], !0);
            }

            for (r = i ? r : a; ++r < a;) {
              var u = Is(o = t[r]),
                  d = "wrapper" == u ? Ws(o) : s;
              i = d && Ys(d[0]) && d[1] == (x | g | w | D) && !d[4].length && 1 == d[9] ? i[Is(d[0])].apply(i, d[3]) : 1 == o.length && Ys(o) ? i[u]() : i.thru(o);
            }

            return function () {
              var e = arguments,
                  r = e[0];
              if (i && 1 == e.length && yi(r)) return i.plant(r).value();

              for (var n = 0, s = a ? t[n].apply(this, e) : r; ++n < a;) {
                s = t[n].call(this, s);
              }

              return s;
            };
          });
        }

        function hs(e, t, a, n, o, i, c, u, d, f) {
          var l = t & x,
              h = t & y,
              p = t & v,
              b = t & (g | A),
              m = t & C,
              _ = p ? s : ds(e);

          return function y() {
            for (var v = arguments.length, g = r(v), A = v; A--;) {
              g[A] = arguments[A];
            }

            if (b) var w = Ns(y),
                T = function (e, t) {
              for (var a = e.length, r = 0; a--;) {
                e[a] === t && ++r;
              }

              return r;
            }(g, w);

            if (n && (g = es(g, n, o, b)), i && (g = ts(g, i, c, b)), v -= T, b && v < f) {
              var x = Sa(g, w);
              return gs(e, t, hs, y.placeholder, a, g, x, u, d, f - v);
            }

            var D = h ? a : this,
                C = p ? D[e] : e;
            return v = g.length, u ? g = function (e, t) {
              for (var a = e.length, r = za(t.length, a), n = as(e); r--;) {
                var o = t[r];
                e[r] = zs(o, a) ? n[o] : s;
              }

              return e;
            }(g, u) : m && v > 1 && g.reverse(), l && d < v && (g.length = d), this && this !== It && this instanceof y && (C = _ || ds(C)), C.apply(D, g);
          };
        }

        function ps(e, t) {
          return function (a, r) {
            return function (e, t, a, r) {
              return Kr(e, function (e, n, s) {
                t(r, a(e), n, s);
              }), r;
            }(a, e, t(r), {});
          };
        }

        function bs(e, t) {
          return function (a, r) {
            var n;
            if (a === s && r === s) return t;

            if (a !== s && (n = a), r !== s) {
              if (n === s) return r;
              "string" == typeof a || "string" == typeof r ? (a = Pn(a), r = Pn(r)) : (a = Mn(a), r = Mn(r)), n = e(a, r);
            }

            return n;
          };
        }

        function ms(e) {
          return Bs(function (t) {
            return t = Qt(t, ma(Ms())), Tn(function (a) {
              var r = this;
              return e(t, function (e) {
                return zt(e, r, a);
              });
            });
          });
        }

        function ys(e, t) {
          var a = (t = t === s ? " " : Pn(t)).length;
          if (a < 2) return a ? wn(t, e) : t;
          var r = wn(t, La(e / ka(t)));
          return xa(t) ? Yn(Ra(r), 0, e).join("") : r.slice(0, e);
        }

        function vs(e) {
          return function (t, a, n) {
            return n && "number" != typeof n && Ks(t, a, n) && (a = n = s), t = ji(t), a === s ? (a = t, t = 0) : a = ji(a), function (e, t, a, n) {
              for (var s = -1, o = Ha(La((t - e) / (a || 1)), 0), i = r(o); o--;) {
                i[n ? o : ++s] = e, e += a;
              }

              return i;
            }(t, a, n = n === s ? t < a ? 1 : -1 : ji(n), e);
          };
        }

        function _s(e) {
          return function (t, a) {
            return "string" == typeof t && "string" == typeof a || (t = Ui(t), a = Ui(a)), e(t, a);
          };
        }

        function gs(e, t, a, r, n, o, i, c, u, d) {
          var f = t & g;
          t |= f ? w : T, (t &= ~(f ? T : w)) & _ || (t &= ~(y | v));
          var l = [e, t, n, f ? o : s, f ? i : s, f ? s : o, f ? s : i, c, u, d],
              h = a.apply(s, l);
          return Ys(e) && ao(h, l), h.placeholder = r, so(h, e, t);
        }

        function As(e) {
          var t = et[e];
          return function (e, a) {
            if (e = Ui(e), (a = null == a ? 0 : za(Gi(a), 292)) && Ga(e)) {
              var r = (zi(e) + "e").split("e");
              return +((r = (zi(t(r[0] + "e" + (+r[1] + a))) + "e").split("e"))[0] + "e" + (+r[1] - a));
            }

            return t(e);
          };
        }

        var ws = Qa && 1 / Ea(new Qa([, -0]))[1] == I ? function (e) {
          return new Qa(e);
        } : Mc;

        function Ts(e) {
          return function (t) {
            var a = Gs(t);
            return a == J ? Da(t) : a == ae ? Ba(t) : function (e, t) {
              return Qt(t, function (t) {
                return [t, e[t]];
              });
            }(t, e(t));
          };
        }

        function xs(e, t, a, n, o, i, u, d) {
          var l = t & v;
          if (!l && "function" != typeof e) throw new nt(c);
          var h = n ? n.length : 0;

          if (h || (t &= ~(w | T), n = o = s), u = u === s ? u : Ha(Gi(u), 0), d = d === s ? d : Gi(d), h -= o ? o.length : 0, t & T) {
            var p = n,
                b = o;
            n = o = s;
          }

          var m = l ? s : Ws(e),
              C = [e, t, a, n, o, p, b, i, u, d];
          if (m && function (e, t) {
            var a = e[1],
                r = t[1],
                n = a | r,
                s = n < (y | v | x),
                o = r == x && a == g || r == x && a == D && e[7].length <= t[8] || r == (x | D) && t[7].length <= t[8] && a == g;
            if (!s && !o) return e;
            r & y && (e[2] = t[2], n |= a & y ? 0 : _);
            var i = t[3];

            if (i) {
              var c = e[3];
              e[3] = c ? es(c, i, t[4]) : i, e[4] = c ? Sa(e[3], f) : t[4];
            }

            (i = t[5]) && (c = e[5], e[5] = c ? ts(c, i, t[6]) : i, e[6] = c ? Sa(e[5], f) : t[6]);
            (i = t[7]) && (e[7] = i);
            r & x && (e[8] = null == e[8] ? t[8] : za(e[8], t[8]));
            null == e[9] && (e[9] = t[9]);
            e[0] = t[0], e[1] = n;
          }(C, m), e = C[0], t = C[1], a = C[2], n = C[3], o = C[4], !(d = C[9] = C[9] === s ? l ? 0 : e.length : Ha(C[9] - h, 0)) && t & (g | A) && (t &= ~(g | A)), t && t != y) S = t == g || t == A ? function (e, t, a) {
            var n = ds(e);
            return function o() {
              for (var i = arguments.length, c = r(i), u = i, d = Ns(o); u--;) {
                c[u] = arguments[u];
              }

              var f = i < 3 && c[0] !== d && c[i - 1] !== d ? [] : Sa(c, d);
              return (i -= f.length) < a ? gs(e, t, hs, o.placeholder, s, c, f, s, s, a - i) : zt(this && this !== It && this instanceof o ? n : e, this, c);
            };
          }(e, t, d) : t != w && t != (y | w) || o.length ? hs.apply(s, C) : function (e, t, a, n) {
            var s = t & y,
                o = ds(e);
            return function t() {
              for (var i = -1, c = arguments.length, u = -1, d = n.length, f = r(d + c), l = this && this !== It && this instanceof t ? o : e; ++u < d;) {
                f[u] = n[u];
              }

              for (; c--;) {
                f[u++] = arguments[++i];
              }

              return zt(l, s ? a : this, f);
            };
          }(e, t, a, n);else var S = function (e, t, a) {
            var r = t & y,
                n = ds(e);
            return function t() {
              return (this && this !== It && this instanceof t ? n : e).apply(r ? a : this, arguments);
            };
          }(e, t, a);
          return so((m ? Sn : ao)(S, C), e, t);
        }

        function Ds(e, t, a, r) {
          return e === s || hi(e, it[a]) && !dt.call(r, a) ? t : e;
        }

        function Cs(e, t, a, r, n, o) {
          return Si(e) && Si(t) && (o.set(t, e), bn(e, t, s, Cs, o), o.delete(t)), e;
        }

        function Ss(e) {
          return Ri(e) ? s : e;
        }

        function Es(e, t, a, r, n, o) {
          var i = a & b,
              c = e.length,
              u = t.length;
          if (c != u && !(i && u > c)) return !1;
          var d = o.get(e);
          if (d && o.get(t)) return d == t;
          var f = -1,
              l = !0,
              h = a & m ? new gr() : s;

          for (o.set(e, t), o.set(t, e); ++f < c;) {
            var p = e[f],
                y = t[f];
            if (r) var v = i ? r(y, p, f, t, e, o) : r(p, y, f, e, t, o);

            if (v !== s) {
              if (v) continue;
              l = !1;
              break;
            }

            if (h) {
              if (!ra(t, function (e, t) {
                if (!va(h, t) && (p === e || n(p, e, a, r, o))) return h.push(t);
              })) {
                l = !1;
                break;
              }
            } else if (p !== y && !n(p, y, a, r, o)) {
              l = !1;
              break;
            }
          }

          return o.delete(e), o.delete(t), l;
        }

        function Bs(e) {
          return no(Qs(e, s, vo), e + "");
        }

        function ks(e) {
          return Jr(e, nc, Fs);
        }

        function Rs(e) {
          return Jr(e, sc, js);
        }

        var Ws = ar ? function (e) {
          return ar.get(e);
        } : Mc;

        function Is(e) {
          for (var t = e.name + "", a = rr[t], r = dt.call(rr, t) ? a.length : 0; r--;) {
            var n = a[r],
                s = n.func;
            if (null == s || s == e) return n.name;
          }

          return t;
        }

        function Ns(e) {
          return (dt.call(lr, "placeholder") ? lr : e).placeholder;
        }

        function Ms() {
          var e = lr.iteratee || Rc;
          return e = e === Rc ? cn : e, arguments.length ? e(arguments[0], arguments[1]) : e;
        }

        function Ps(e, t) {
          var a,
              r,
              n = e.__data__;
          return ("string" == (r = typeof (a = t)) || "number" == r || "symbol" == r || "boolean" == r ? "__proto__" !== a : null === a) ? n["string" == typeof t ? "string" : "hash"] : n.map;
        }

        function Ls(e) {
          for (var t = nc(e), a = t.length; a--;) {
            var r = t[a],
                n = e[r];
            t[a] = [r, n, Xs(n)];
          }

          return t;
        }

        function Os(e, t) {
          var a = function (e, t) {
            return null == e ? s : e[t];
          }(e, t);

          return on(a) ? a : s;
        }

        var Fs = Fa ? function (e) {
          return null == e ? [] : (e = tt(e), Jt(Fa(e), function (t) {
            return Nt.call(e, t);
          }));
        } : Vc,
            js = Fa ? function (e) {
          for (var t = []; e;) {
            ea(t, Fs(e)), e = Rt(e);
          }

          return t;
        } : Vc,
            Gs = Xr;

        function Vs(e, t, a) {
          for (var r = -1, n = (t = Kn(t, e)).length, s = !1; ++r < n;) {
            var o = uo(t[r]);
            if (!(s = null != e && a(e, o))) break;
            e = e[o];
          }

          return s || ++r != n ? s : !!(n = null == e ? 0 : e.length) && Ci(n) && zs(o, n) && (yi(e) || mi(e));
        }

        function Us(e) {
          return "function" != typeof e.constructor || Js(e) ? {} : hr(Rt(e));
        }

        function Hs(e) {
          return yi(e) || mi(e) || !!(Lt && e && e[Lt]);
        }

        function zs(e, t) {
          var a = typeof e;
          return !!(t = null == t ? N : t) && ("number" == a || "symbol" != a && Ye.test(e)) && e > -1 && e % 1 == 0 && e < t;
        }

        function Ks(e, t, a) {
          if (!Si(a)) return !1;
          var r = typeof t;
          return !!("number" == r ? _i(a) && zs(t, a.length) : "string" == r && t in a) && hi(a[t], e);
        }

        function qs(e, t) {
          if (yi(e)) return !1;
          var a = typeof e;
          return !("number" != a && "symbol" != a && "boolean" != a && null != e && !Mi(e)) || ke.test(e) || !Be.test(e) || null != t && e in tt(t);
        }

        function Ys(e) {
          var t = Is(e),
              a = lr[t];
          if ("function" != typeof a || !(t in mr.prototype)) return !1;
          if (e === a) return !0;
          var r = Ws(a);
          return !!r && e === r[0];
        }

        (Ja && Gs(new Ja(new ArrayBuffer(1))) != ue || Xa && Gs(new Xa()) != J || $a && "[object Promise]" != Gs($a.resolve()) || Qa && Gs(new Qa()) != ae || er && Gs(new er()) != oe) && (Gs = function Gs(e) {
          var t = Xr(e),
              a = t == Q ? e.constructor : s,
              r = a ? fo(a) : "";
          if (r) switch (r) {
            case nr:
              return ue;

            case sr:
              return J;

            case or:
              return "[object Promise]";

            case ir:
              return ae;

            case cr:
              return oe;
          }
          return t;
        });
        var Zs = ct ? xi : Uc;

        function Js(e) {
          var t = e && e.constructor;
          return e === ("function" == typeof t && t.prototype || it);
        }

        function Xs(e) {
          return e == e && !Si(e);
        }

        function $s(e, t) {
          return function (a) {
            return null != a && a[e] === t && (t !== s || e in tt(a));
          };
        }

        function Qs(e, t, a) {
          return t = Ha(t === s ? e.length - 1 : t, 0), function () {
            for (var n = arguments, s = -1, o = Ha(n.length - t, 0), i = r(o); ++s < o;) {
              i[s] = n[t + s];
            }

            s = -1;

            for (var c = r(t + 1); ++s < t;) {
              c[s] = n[s];
            }

            return c[t] = a(i), zt(e, this, c);
          };
        }

        function eo(e, t) {
          return t.length < 2 ? e : Zr(e, kn(t, 0, -1));
        }

        function to(e, t) {
          if (("constructor" !== t || "function" != typeof e[t]) && "__proto__" != t) return e[t];
        }

        var ao = oo(Sn),
            ro = Pa || function (e, t) {
          return It.setTimeout(e, t);
        },
            no = oo(En);

        function so(e, t, a) {
          var r = t + "";
          return no(e, function (e, t) {
            var a = t.length;
            if (!a) return e;
            var r = a - 1;
            return t[r] = (a > 1 ? "& " : "") + t[r], t = t.join(a > 2 ? ", " : " "), e.replace(Le, "{\n/* [wrapped with " + t + "] */\n");
          }(r, function (e, t) {
            return qt(j, function (a) {
              var r = "_." + a[0];
              t & a[1] && !Xt(e, r) && e.push(r);
            }), e.sort();
          }(function (e) {
            var t = e.match(Oe);
            return t ? t[1].split(Fe) : [];
          }(r), a)));
        }

        function oo(e) {
          var t = 0,
              a = 0;
          return function () {
            var r = Ka(),
                n = k - (r - a);

            if (a = r, n > 0) {
              if (++t >= B) return arguments[0];
            } else t = 0;

            return e.apply(s, arguments);
          };
        }

        function io(e, t) {
          var a = -1,
              r = e.length,
              n = r - 1;

          for (t = t === s ? r : t; ++a < t;) {
            var o = An(a, n),
                i = e[o];
            e[o] = e[a], e[a] = i;
          }

          return e.length = t, e;
        }

        var co = function (e) {
          var t = ii(e, function (e) {
            return a.size === d && a.clear(), e;
          }),
              a = t.cache;
          return t;
        }(function (e) {
          var t = [];
          return 46 === e.charCodeAt(0) && t.push(""), e.replace(Re, function (e, a, r, n) {
            t.push(r ? n.replace(Ge, "$1") : a || e);
          }), t;
        });

        function uo(e) {
          if ("string" == typeof e || Mi(e)) return e;
          var t = e + "";
          return "0" == t && 1 / e == -I ? "-0" : t;
        }

        function fo(e) {
          if (null != e) {
            try {
              return ut.call(e);
            } catch (e) {}

            try {
              return e + "";
            } catch (e) {}
          }

          return "";
        }

        function lo(e) {
          if (e instanceof mr) return e.clone();
          var t = new br(e.__wrapped__, e.__chain__);
          return t.__actions__ = as(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
        }

        var ho = Tn(function (e, t) {
          return gi(e) ? Lr(e, Ur(t, 1, gi, !0)) : [];
        }),
            po = Tn(function (e, t) {
          var a = To(t);
          return gi(a) && (a = s), gi(e) ? Lr(e, Ur(t, 1, gi, !0), Ms(a, 2)) : [];
        }),
            bo = Tn(function (e, t) {
          var a = To(t);
          return gi(a) && (a = s), gi(e) ? Lr(e, Ur(t, 1, gi, !0), s, a) : [];
        });

        function mo(e, t, a) {
          var r = null == e ? 0 : e.length;
          if (!r) return -1;
          var n = null == a ? 0 : Gi(a);
          return n < 0 && (n = Ha(r + n, 0)), oa(e, Ms(t, 3), n);
        }

        function yo(e, t, a) {
          var r = null == e ? 0 : e.length;
          if (!r) return -1;
          var n = r - 1;
          return a !== s && (n = Gi(a), n = a < 0 ? Ha(r + n, 0) : za(n, r - 1)), oa(e, Ms(t, 3), n, !0);
        }

        function vo(e) {
          return (null == e ? 0 : e.length) ? Ur(e, 1) : [];
        }

        function _o(e) {
          return e && e.length ? e[0] : s;
        }

        var go = Tn(function (e) {
          var t = Qt(e, Hn);
          return t.length && t[0] === e[0] ? tn(t) : [];
        }),
            Ao = Tn(function (e) {
          var t = To(e),
              a = Qt(e, Hn);
          return t === To(a) ? t = s : a.pop(), a.length && a[0] === e[0] ? tn(a, Ms(t, 2)) : [];
        }),
            wo = Tn(function (e) {
          var t = To(e),
              a = Qt(e, Hn);
          return (t = "function" == typeof t ? t : s) && a.pop(), a.length && a[0] === e[0] ? tn(a, s, t) : [];
        });

        function To(e) {
          var t = null == e ? 0 : e.length;
          return t ? e[t - 1] : s;
        }

        var xo = Tn(Do);

        function Do(e, t) {
          return e && e.length && t && t.length ? _n(e, t) : e;
        }

        var Co = Bs(function (e, t) {
          var a = null == e ? 0 : e.length,
              r = Wr(e, t);
          return gn(e, Qt(t, function (e) {
            return zs(e, a) ? +e : e;
          }).sort(Qn)), r;
        });

        function So(e) {
          return null == e ? e : Za.call(e);
        }

        var Eo = Tn(function (e) {
          return Ln(Ur(e, 1, gi, !0));
        }),
            Bo = Tn(function (e) {
          var t = To(e);
          return gi(t) && (t = s), Ln(Ur(e, 1, gi, !0), Ms(t, 2));
        }),
            ko = Tn(function (e) {
          var t = To(e);
          return t = "function" == typeof t ? t : s, Ln(Ur(e, 1, gi, !0), s, t);
        });

        function Ro(e) {
          if (!e || !e.length) return [];
          var t = 0;
          return e = Jt(e, function (e) {
            if (gi(e)) return t = Ha(e.length, t), !0;
          }), ba(t, function (t) {
            return Qt(e, fa(t));
          });
        }

        function Wo(e, t) {
          if (!e || !e.length) return [];
          var a = Ro(e);
          return null == t ? a : Qt(a, function (e) {
            return zt(t, s, e);
          });
        }

        var Io = Tn(function (e, t) {
          return gi(e) ? Lr(e, t) : [];
        }),
            No = Tn(function (e) {
          return Vn(Jt(e, gi));
        }),
            Mo = Tn(function (e) {
          var t = To(e);
          return gi(t) && (t = s), Vn(Jt(e, gi), Ms(t, 2));
        }),
            Po = Tn(function (e) {
          var t = To(e);
          return t = "function" == typeof t ? t : s, Vn(Jt(e, gi), s, t);
        }),
            Lo = Tn(Ro);
        var Oo = Tn(function (e) {
          var t = e.length,
              a = t > 1 ? e[t - 1] : s;
          return a = "function" == typeof a ? (e.pop(), a) : s, Wo(e, a);
        });

        function Fo(e) {
          var t = lr(e);
          return t.__chain__ = !0, t;
        }

        function jo(e, t) {
          return t(e);
        }

        var Go = Bs(function (e) {
          var t = e.length,
              a = t ? e[0] : 0,
              r = this.__wrapped__,
              n = function n(t) {
            return Wr(t, e);
          };

          return !(t > 1 || this.__actions__.length) && r instanceof mr && zs(a) ? ((r = r.slice(a, +a + (t ? 1 : 0))).__actions__.push({
            func: jo,
            args: [n],
            thisArg: s
          }), new br(r, this.__chain__).thru(function (e) {
            return t && !e.length && e.push(s), e;
          })) : this.thru(n);
        });
        var Vo = ns(function (e, t, a) {
          dt.call(e, a) ? ++e[a] : Rr(e, a, 1);
        });
        var Uo = fs(mo),
            Ho = fs(yo);

        function zo(e, t) {
          return (yi(e) ? qt : Or)(e, Ms(t, 3));
        }

        function Ko(e, t) {
          return (yi(e) ? Yt : Fr)(e, Ms(t, 3));
        }

        var qo = ns(function (e, t, a) {
          dt.call(e, a) ? e[a].push(t) : Rr(e, a, [t]);
        });
        var Yo = Tn(function (e, t, a) {
          var n = -1,
              s = "function" == typeof t,
              o = _i(e) ? r(e.length) : [];
          return Or(e, function (e) {
            o[++n] = s ? zt(t, e, a) : an(e, t, a);
          }), o;
        }),
            Zo = ns(function (e, t, a) {
          Rr(e, a, t);
        });

        function Jo(e, t) {
          return (yi(e) ? Qt : ln)(e, Ms(t, 3));
        }

        var Xo = ns(function (e, t, a) {
          e[a ? 0 : 1].push(t);
        }, function () {
          return [[], []];
        });

        var $o = Tn(function (e, t) {
          if (null == e) return [];
          var a = t.length;
          return a > 1 && Ks(e, t[0], t[1]) ? t = [] : a > 2 && Ks(t[0], t[1], t[2]) && (t = [t[0]]), yn(e, Ur(t, 1), []);
        }),
            Qo = Ma || function () {
          return It.Date.now();
        };

        function ei(e, t, a) {
          return t = a ? s : t, t = e && null == t ? e.length : t, xs(e, x, s, s, s, s, t);
        }

        function ti(e, t) {
          var a;
          if ("function" != typeof t) throw new nt(c);
          return e = Gi(e), function () {
            return --e > 0 && (a = t.apply(this, arguments)), e <= 1 && (t = s), a;
          };
        }

        var ai = Tn(function (e, t, a) {
          var r = y;

          if (a.length) {
            var n = Sa(a, Ns(ai));
            r |= w;
          }

          return xs(e, r, t, a, n);
        }),
            ri = Tn(function (e, t, a) {
          var r = y | v;

          if (a.length) {
            var n = Sa(a, Ns(ri));
            r |= w;
          }

          return xs(t, r, e, a, n);
        });

        function ni(e, t, a) {
          var r,
              n,
              o,
              i,
              u,
              d,
              f = 0,
              l = !1,
              h = !1,
              p = !0;
          if ("function" != typeof e) throw new nt(c);

          function b(t) {
            var a = r,
                o = n;
            return r = n = s, f = t, i = e.apply(o, a);
          }

          function m(e) {
            var a = e - d;
            return d === s || a >= t || a < 0 || h && e - f >= o;
          }

          function y() {
            var e = Qo();
            if (m(e)) return v(e);
            u = ro(y, function (e) {
              var a = t - (e - d);
              return h ? za(a, o - (e - f)) : a;
            }(e));
          }

          function v(e) {
            return u = s, p && r ? b(e) : (r = n = s, i);
          }

          function _() {
            var e = Qo(),
                a = m(e);

            if (r = arguments, n = this, d = e, a) {
              if (u === s) return function (e) {
                return f = e, u = ro(y, t), l ? b(e) : i;
              }(d);
              if (h) return Zn(u), u = ro(y, t), b(d);
            }

            return u === s && (u = ro(y, t)), i;
          }

          return t = Ui(t) || 0, Si(a) && (l = !!a.leading, o = (h = "maxWait" in a) ? Ha(Ui(a.maxWait) || 0, t) : o, p = "trailing" in a ? !!a.trailing : p), _.cancel = function () {
            u !== s && Zn(u), f = 0, r = d = n = u = s;
          }, _.flush = function () {
            return u === s ? i : v(Qo());
          }, _;
        }

        var si = Tn(function (e, t) {
          return Pr(e, 1, t);
        }),
            oi = Tn(function (e, t, a) {
          return Pr(e, Ui(t) || 0, a);
        });

        function ii(e, t) {
          if ("function" != typeof e || null != t && "function" != typeof t) throw new nt(c);

          var a = function a() {
            var r = arguments,
                n = t ? t.apply(this, r) : r[0],
                s = a.cache;
            if (s.has(n)) return s.get(n);
            var o = e.apply(this, r);
            return a.cache = s.set(n, o) || s, o;
          };

          return a.cache = new (ii.Cache || _r)(), a;
        }

        function ci(e) {
          if ("function" != typeof e) throw new nt(c);
          return function () {
            var t = arguments;

            switch (t.length) {
              case 0:
                return !e.call(this);

              case 1:
                return !e.call(this, t[0]);

              case 2:
                return !e.call(this, t[0], t[1]);

              case 3:
                return !e.call(this, t[0], t[1], t[2]);
            }

            return !e.apply(this, t);
          };
        }

        ii.Cache = _r;
        var ui = qn(function (e, t) {
          var a = (t = 1 == t.length && yi(t[0]) ? Qt(t[0], ma(Ms())) : Qt(Ur(t, 1), ma(Ms()))).length;
          return Tn(function (r) {
            for (var n = -1, s = za(r.length, a); ++n < s;) {
              r[n] = t[n].call(this, r[n]);
            }

            return zt(e, this, r);
          });
        }),
            di = Tn(function (e, t) {
          var a = Sa(t, Ns(di));
          return xs(e, w, s, t, a);
        }),
            fi = Tn(function (e, t) {
          var a = Sa(t, Ns(fi));
          return xs(e, T, s, t, a);
        }),
            li = Bs(function (e, t) {
          return xs(e, D, s, s, s, t);
        });

        function hi(e, t) {
          return e === t || e != e && t != t;
        }

        var pi = _s($r),
            bi = _s(function (e, t) {
          return e >= t;
        }),
            mi = rn(function () {
          return arguments;
        }()) ? rn : function (e) {
          return Ei(e) && dt.call(e, "callee") && !Nt.call(e, "callee");
        },
            yi = r.isArray,
            vi = Ft ? ma(Ft) : function (e) {
          return Ei(e) && Xr(e) == ce;
        };

        function _i(e) {
          return null != e && Ci(e.length) && !xi(e);
        }

        function gi(e) {
          return Ei(e) && _i(e);
        }

        var Ai = ja || Uc,
            wi = jt ? ma(jt) : function (e) {
          return Ei(e) && Xr(e) == z;
        };

        function Ti(e) {
          if (!Ei(e)) return !1;
          var t = Xr(e);
          return t == q || t == K || "string" == typeof e.message && "string" == typeof e.name && !Ri(e);
        }

        function xi(e) {
          if (!Si(e)) return !1;
          var t = Xr(e);
          return t == Y || t == Z || t == U || t == ee;
        }

        function Di(e) {
          return "number" == typeof e && e == Gi(e);
        }

        function Ci(e) {
          return "number" == typeof e && e > -1 && e % 1 == 0 && e <= N;
        }

        function Si(e) {
          var t = typeof e;
          return null != e && ("object" == t || "function" == t);
        }

        function Ei(e) {
          return null != e && "object" == typeof e;
        }

        var Bi = Gt ? ma(Gt) : function (e) {
          return Ei(e) && Gs(e) == J;
        };

        function ki(e) {
          return "number" == typeof e || Ei(e) && Xr(e) == X;
        }

        function Ri(e) {
          if (!Ei(e) || Xr(e) != Q) return !1;
          var t = Rt(e);
          if (null === t) return !0;
          var a = dt.call(t, "constructor") && t.constructor;
          return "function" == typeof a && a instanceof a && ut.call(a) == pt;
        }

        var Wi = Vt ? ma(Vt) : function (e) {
          return Ei(e) && Xr(e) == te;
        };
        var Ii = Ut ? ma(Ut) : function (e) {
          return Ei(e) && Gs(e) == ae;
        };

        function Ni(e) {
          return "string" == typeof e || !yi(e) && Ei(e) && Xr(e) == re;
        }

        function Mi(e) {
          return "symbol" == typeof e || Ei(e) && Xr(e) == ne;
        }

        var Pi = Ht ? ma(Ht) : function (e) {
          return Ei(e) && Ci(e.length) && !!Ct[Xr(e)];
        };

        var Li = _s(fn),
            Oi = _s(function (e, t) {
          return e <= t;
        });

        function Fi(e) {
          if (!e) return [];
          if (_i(e)) return Ni(e) ? Ra(e) : as(e);
          if (Ot && e[Ot]) return function (e) {
            for (var t, a = []; !(t = e.next()).done;) {
              a.push(t.value);
            }

            return a;
          }(e[Ot]());
          var t = Gs(e);
          return (t == J ? Da : t == ae ? Ea : hc)(e);
        }

        function ji(e) {
          return e ? (e = Ui(e)) === I || e === -I ? (e < 0 ? -1 : 1) * M : e == e ? e : 0 : 0 === e ? e : 0;
        }

        function Gi(e) {
          var t = ji(e),
              a = t % 1;
          return t == t ? a ? t - a : t : 0;
        }

        function Vi(e) {
          return e ? Ir(Gi(e), 0, L) : 0;
        }

        function Ui(e) {
          if ("number" == typeof e) return e;
          if (Mi(e)) return P;

          if (Si(e)) {
            var t = "function" == typeof e.valueOf ? e.valueOf() : e;
            e = Si(t) ? t + "" : t;
          }

          if ("string" != typeof e) return 0 === e ? e : +e;
          e = e.replace(Ne, "");
          var a = ze.test(e);
          return a || qe.test(e) ? kt(e.slice(2), a ? 2 : 8) : He.test(e) ? P : +e;
        }

        function Hi(e) {
          return rs(e, sc(e));
        }

        function zi(e) {
          return null == e ? "" : Pn(e);
        }

        var Ki = ss(function (e, t) {
          if (Js(t) || _i(t)) rs(t, nc(t), e);else for (var a in t) {
            dt.call(t, a) && Sr(e, a, t[a]);
          }
        }),
            qi = ss(function (e, t) {
          rs(t, sc(t), e);
        }),
            Yi = ss(function (e, t, a, r) {
          rs(t, sc(t), e, r);
        }),
            Zi = ss(function (e, t, a, r) {
          rs(t, nc(t), e, r);
        }),
            Ji = Bs(Wr);
        var Xi = Tn(function (e, t) {
          e = tt(e);
          var a = -1,
              r = t.length,
              n = r > 2 ? t[2] : s;

          for (n && Ks(t[0], t[1], n) && (r = 1); ++a < r;) {
            for (var o = t[a], i = sc(o), c = -1, u = i.length; ++c < u;) {
              var d = i[c],
                  f = e[d];
              (f === s || hi(f, it[d]) && !dt.call(e, d)) && (e[d] = o[d]);
            }
          }

          return e;
        }),
            $i = Tn(function (e) {
          return e.push(s, Cs), zt(ic, s, e);
        });

        function Qi(e, t, a) {
          var r = null == e ? s : Zr(e, t);
          return r === s ? a : r;
        }

        function ec(e, t) {
          return null != e && Vs(e, t, en);
        }

        var tc = ps(function (e, t, a) {
          null != t && "function" != typeof t.toString && (t = ht.call(t)), e[t] = a;
        }, Sc(kc)),
            ac = ps(function (e, t, a) {
          null != t && "function" != typeof t.toString && (t = ht.call(t)), dt.call(e, t) ? e[t].push(a) : e[t] = [a];
        }, Ms),
            rc = Tn(an);

        function nc(e) {
          return _i(e) ? wr(e) : un(e);
        }

        function sc(e) {
          return _i(e) ? wr(e, !0) : dn(e);
        }

        var oc = ss(function (e, t, a) {
          bn(e, t, a);
        }),
            ic = ss(function (e, t, a, r) {
          bn(e, t, a, r);
        }),
            cc = Bs(function (e, t) {
          var a = {};
          if (null == e) return a;
          var r = !1;
          t = Qt(t, function (t) {
            return t = Kn(t, e), r || (r = t.length > 1), t;
          }), rs(e, Rs(e), a), r && (a = Nr(a, l | h | p, Ss));

          for (var n = t.length; n--;) {
            On(a, t[n]);
          }

          return a;
        });
        var uc = Bs(function (e, t) {
          return null == e ? {} : function (e, t) {
            return vn(e, t, function (t, a) {
              return ec(e, a);
            });
          }(e, t);
        });

        function dc(e, t) {
          if (null == e) return {};
          var a = Qt(Rs(e), function (e) {
            return [e];
          });
          return t = Ms(t), vn(e, a, function (e, a) {
            return t(e, a[0]);
          });
        }

        var fc = Ts(nc),
            lc = Ts(sc);

        function hc(e) {
          return null == e ? [] : ya(e, nc(e));
        }

        var pc = us(function (e, t, a) {
          return t = t.toLowerCase(), e + (a ? bc(t) : t);
        });

        function bc(e) {
          return Tc(zi(e).toLowerCase());
        }

        function mc(e) {
          return (e = zi(e)) && e.replace(Ze, Aa).replace(_t, "");
        }

        var yc = us(function (e, t, a) {
          return e + (a ? "-" : "") + t.toLowerCase();
        }),
            vc = us(function (e, t, a) {
          return e + (a ? " " : "") + t.toLowerCase();
        }),
            _c = cs("toLowerCase");

        var gc = us(function (e, t, a) {
          return e + (a ? "_" : "") + t.toLowerCase();
        });
        var Ac = us(function (e, t, a) {
          return e + (a ? " " : "") + Tc(t);
        });
        var wc = us(function (e, t, a) {
          return e + (a ? " " : "") + t.toUpperCase();
        }),
            Tc = cs("toUpperCase");

        function xc(e, t, a) {
          return e = zi(e), (t = a ? s : t) === s ? function (e) {
            return Tt.test(e);
          }(e) ? function (e) {
            return e.match(At) || [];
          }(e) : function (e) {
            return e.match(je) || [];
          }(e) : e.match(t) || [];
        }

        var Dc = Tn(function (e, t) {
          try {
            return zt(e, s, t);
          } catch (e) {
            return Ti(e) ? e : new $e(e);
          }
        }),
            Cc = Bs(function (e, t) {
          return qt(t, function (t) {
            t = uo(t), Rr(e, t, ai(e[t], e));
          }), e;
        });

        function Sc(e) {
          return function () {
            return e;
          };
        }

        var Ec = ls(),
            Bc = ls(!0);

        function kc(e) {
          return e;
        }

        function Rc(e) {
          return cn("function" == typeof e ? e : Nr(e, l));
        }

        var Wc = Tn(function (e, t) {
          return function (a) {
            return an(a, e, t);
          };
        }),
            Ic = Tn(function (e, t) {
          return function (a) {
            return an(e, a, t);
          };
        });

        function Nc(e, t, a) {
          var r = nc(t),
              n = Yr(t, r);
          null != a || Si(t) && (n.length || !r.length) || (a = t, t = e, e = this, n = Yr(t, nc(t)));
          var s = !(Si(a) && "chain" in a && !a.chain),
              o = xi(e);
          return qt(n, function (a) {
            var r = t[a];
            e[a] = r, o && (e.prototype[a] = function () {
              var t = this.__chain__;

              if (s || t) {
                var a = e(this.__wrapped__),
                    n = a.__actions__ = as(this.__actions__);
                return n.push({
                  func: r,
                  args: arguments,
                  thisArg: e
                }), a.__chain__ = t, a;
              }

              return r.apply(e, ea([this.value()], arguments));
            });
          }), e;
        }

        function Mc() {}

        var Pc = ms(Qt),
            Lc = ms(Zt),
            Oc = ms(ra);

        function Fc(e) {
          return qs(e) ? fa(uo(e)) : function (e) {
            return function (t) {
              return Zr(t, e);
            };
          }(e);
        }

        var jc = vs(),
            Gc = vs(!0);

        function Vc() {
          return [];
        }

        function Uc() {
          return !1;
        }

        var Hc = bs(function (e, t) {
          return e + t;
        }, 0),
            zc = As("ceil"),
            Kc = bs(function (e, t) {
          return e / t;
        }, 1),
            qc = As("floor");
        var Yc,
            Zc = bs(function (e, t) {
          return e * t;
        }, 1),
            Jc = As("round"),
            Xc = bs(function (e, t) {
          return e - t;
        }, 0);
        return lr.after = function (e, t) {
          if ("function" != typeof t) throw new nt(c);
          return e = Gi(e), function () {
            if (--e < 1) return t.apply(this, arguments);
          };
        }, lr.ary = ei, lr.assign = Ki, lr.assignIn = qi, lr.assignInWith = Yi, lr.assignWith = Zi, lr.at = Ji, lr.before = ti, lr.bind = ai, lr.bindAll = Cc, lr.bindKey = ri, lr.castArray = function () {
          if (!arguments.length) return [];
          var e = arguments[0];
          return yi(e) ? e : [e];
        }, lr.chain = Fo, lr.chunk = function (e, t, a) {
          t = (a ? Ks(e, t, a) : t === s) ? 1 : Ha(Gi(t), 0);
          var n = null == e ? 0 : e.length;
          if (!n || t < 1) return [];

          for (var o = 0, i = 0, c = r(La(n / t)); o < n;) {
            c[i++] = kn(e, o, o += t);
          }

          return c;
        }, lr.compact = function (e) {
          for (var t = -1, a = null == e ? 0 : e.length, r = 0, n = []; ++t < a;) {
            var s = e[t];
            s && (n[r++] = s);
          }

          return n;
        }, lr.concat = function () {
          var e = arguments.length;
          if (!e) return [];

          for (var t = r(e - 1), a = arguments[0], n = e; n--;) {
            t[n - 1] = arguments[n];
          }

          return ea(yi(a) ? as(a) : [a], Ur(t, 1));
        }, lr.cond = function (e) {
          var t = null == e ? 0 : e.length,
              a = Ms();
          return e = t ? Qt(e, function (e) {
            if ("function" != typeof e[1]) throw new nt(c);
            return [a(e[0]), e[1]];
          }) : [], Tn(function (a) {
            for (var r = -1; ++r < t;) {
              var n = e[r];
              if (zt(n[0], this, a)) return zt(n[1], this, a);
            }
          });
        }, lr.conforms = function (e) {
          return function (e) {
            var t = nc(e);
            return function (a) {
              return Mr(a, e, t);
            };
          }(Nr(e, l));
        }, lr.constant = Sc, lr.countBy = Vo, lr.create = function (e, t) {
          var a = hr(e);
          return null == t ? a : kr(a, t);
        }, lr.curry = function e(t, a, r) {
          var n = xs(t, g, s, s, s, s, s, a = r ? s : a);
          return n.placeholder = e.placeholder, n;
        }, lr.curryRight = function e(t, a, r) {
          var n = xs(t, A, s, s, s, s, s, a = r ? s : a);
          return n.placeholder = e.placeholder, n;
        }, lr.debounce = ni, lr.defaults = Xi, lr.defaultsDeep = $i, lr.defer = si, lr.delay = oi, lr.difference = ho, lr.differenceBy = po, lr.differenceWith = bo, lr.drop = function (e, t, a) {
          var r = null == e ? 0 : e.length;
          return r ? kn(e, (t = a || t === s ? 1 : Gi(t)) < 0 ? 0 : t, r) : [];
        }, lr.dropRight = function (e, t, a) {
          var r = null == e ? 0 : e.length;
          return r ? kn(e, 0, (t = r - (t = a || t === s ? 1 : Gi(t))) < 0 ? 0 : t) : [];
        }, lr.dropRightWhile = function (e, t) {
          return e && e.length ? jn(e, Ms(t, 3), !0, !0) : [];
        }, lr.dropWhile = function (e, t) {
          return e && e.length ? jn(e, Ms(t, 3), !0) : [];
        }, lr.fill = function (e, t, a, r) {
          var n = null == e ? 0 : e.length;
          return n ? (a && "number" != typeof a && Ks(e, t, a) && (a = 0, r = n), function (e, t, a, r) {
            var n = e.length;

            for ((a = Gi(a)) < 0 && (a = -a > n ? 0 : n + a), (r = r === s || r > n ? n : Gi(r)) < 0 && (r += n), r = a > r ? 0 : Vi(r); a < r;) {
              e[a++] = t;
            }

            return e;
          }(e, t, a, r)) : [];
        }, lr.filter = function (e, t) {
          return (yi(e) ? Jt : Vr)(e, Ms(t, 3));
        }, lr.flatMap = function (e, t) {
          return Ur(Jo(e, t), 1);
        }, lr.flatMapDeep = function (e, t) {
          return Ur(Jo(e, t), I);
        }, lr.flatMapDepth = function (e, t, a) {
          return a = a === s ? 1 : Gi(a), Ur(Jo(e, t), a);
        }, lr.flatten = vo, lr.flattenDeep = function (e) {
          return (null == e ? 0 : e.length) ? Ur(e, I) : [];
        }, lr.flattenDepth = function (e, t) {
          return (null == e ? 0 : e.length) ? Ur(e, t = t === s ? 1 : Gi(t)) : [];
        }, lr.flip = function (e) {
          return xs(e, C);
        }, lr.flow = Ec, lr.flowRight = Bc, lr.fromPairs = function (e) {
          for (var t = -1, a = null == e ? 0 : e.length, r = {}; ++t < a;) {
            var n = e[t];
            r[n[0]] = n[1];
          }

          return r;
        }, lr.functions = function (e) {
          return null == e ? [] : Yr(e, nc(e));
        }, lr.functionsIn = function (e) {
          return null == e ? [] : Yr(e, sc(e));
        }, lr.groupBy = qo, lr.initial = function (e) {
          return (null == e ? 0 : e.length) ? kn(e, 0, -1) : [];
        }, lr.intersection = go, lr.intersectionBy = Ao, lr.intersectionWith = wo, lr.invert = tc, lr.invertBy = ac, lr.invokeMap = Yo, lr.iteratee = Rc, lr.keyBy = Zo, lr.keys = nc, lr.keysIn = sc, lr.map = Jo, lr.mapKeys = function (e, t) {
          var a = {};
          return t = Ms(t, 3), Kr(e, function (e, r, n) {
            Rr(a, t(e, r, n), e);
          }), a;
        }, lr.mapValues = function (e, t) {
          var a = {};
          return t = Ms(t, 3), Kr(e, function (e, r, n) {
            Rr(a, r, t(e, r, n));
          }), a;
        }, lr.matches = function (e) {
          return hn(Nr(e, l));
        }, lr.matchesProperty = function (e, t) {
          return pn(e, Nr(t, l));
        }, lr.memoize = ii, lr.merge = oc, lr.mergeWith = ic, lr.method = Wc, lr.methodOf = Ic, lr.mixin = Nc, lr.negate = ci, lr.nthArg = function (e) {
          return e = Gi(e), Tn(function (t) {
            return mn(t, e);
          });
        }, lr.omit = cc, lr.omitBy = function (e, t) {
          return dc(e, ci(Ms(t)));
        }, lr.once = function (e) {
          return ti(2, e);
        }, lr.orderBy = function (e, t, a, r) {
          return null == e ? [] : (yi(t) || (t = null == t ? [] : [t]), yi(a = r ? s : a) || (a = null == a ? [] : [a]), yn(e, t, a));
        }, lr.over = Pc, lr.overArgs = ui, lr.overEvery = Lc, lr.overSome = Oc, lr.partial = di, lr.partialRight = fi, lr.partition = Xo, lr.pick = uc, lr.pickBy = dc, lr.property = Fc, lr.propertyOf = function (e) {
          return function (t) {
            return null == e ? s : Zr(e, t);
          };
        }, lr.pull = xo, lr.pullAll = Do, lr.pullAllBy = function (e, t, a) {
          return e && e.length && t && t.length ? _n(e, t, Ms(a, 2)) : e;
        }, lr.pullAllWith = function (e, t, a) {
          return e && e.length && t && t.length ? _n(e, t, s, a) : e;
        }, lr.pullAt = Co, lr.range = jc, lr.rangeRight = Gc, lr.rearg = li, lr.reject = function (e, t) {
          return (yi(e) ? Jt : Vr)(e, ci(Ms(t, 3)));
        }, lr.remove = function (e, t) {
          var a = [];
          if (!e || !e.length) return a;
          var r = -1,
              n = [],
              s = e.length;

          for (t = Ms(t, 3); ++r < s;) {
            var o = e[r];
            t(o, r, e) && (a.push(o), n.push(r));
          }

          return gn(e, n), a;
        }, lr.rest = function (e, t) {
          if ("function" != typeof e) throw new nt(c);
          return Tn(e, t = t === s ? t : Gi(t));
        }, lr.reverse = So, lr.sampleSize = function (e, t, a) {
          return t = (a ? Ks(e, t, a) : t === s) ? 1 : Gi(t), (yi(e) ? xr : Dn)(e, t);
        }, lr.set = function (e, t, a) {
          return null == e ? e : Cn(e, t, a);
        }, lr.setWith = function (e, t, a, r) {
          return r = "function" == typeof r ? r : s, null == e ? e : Cn(e, t, a, r);
        }, lr.shuffle = function (e) {
          return (yi(e) ? Dr : Bn)(e);
        }, lr.slice = function (e, t, a) {
          var r = null == e ? 0 : e.length;
          return r ? (a && "number" != typeof a && Ks(e, t, a) ? (t = 0, a = r) : (t = null == t ? 0 : Gi(t), a = a === s ? r : Gi(a)), kn(e, t, a)) : [];
        }, lr.sortBy = $o, lr.sortedUniq = function (e) {
          return e && e.length ? Nn(e) : [];
        }, lr.sortedUniqBy = function (e, t) {
          return e && e.length ? Nn(e, Ms(t, 2)) : [];
        }, lr.split = function (e, t, a) {
          return a && "number" != typeof a && Ks(e, t, a) && (t = a = s), (a = a === s ? L : a >>> 0) ? (e = zi(e)) && ("string" == typeof t || null != t && !Wi(t)) && !(t = Pn(t)) && xa(e) ? Yn(Ra(e), 0, a) : e.split(t, a) : [];
        }, lr.spread = function (e, t) {
          if ("function" != typeof e) throw new nt(c);
          return t = null == t ? 0 : Ha(Gi(t), 0), Tn(function (a) {
            var r = a[t],
                n = Yn(a, 0, t);
            return r && ea(n, r), zt(e, this, n);
          });
        }, lr.tail = function (e) {
          var t = null == e ? 0 : e.length;
          return t ? kn(e, 1, t) : [];
        }, lr.take = function (e, t, a) {
          return e && e.length ? kn(e, 0, (t = a || t === s ? 1 : Gi(t)) < 0 ? 0 : t) : [];
        }, lr.takeRight = function (e, t, a) {
          var r = null == e ? 0 : e.length;
          return r ? kn(e, (t = r - (t = a || t === s ? 1 : Gi(t))) < 0 ? 0 : t, r) : [];
        }, lr.takeRightWhile = function (e, t) {
          return e && e.length ? jn(e, Ms(t, 3), !1, !0) : [];
        }, lr.takeWhile = function (e, t) {
          return e && e.length ? jn(e, Ms(t, 3)) : [];
        }, lr.tap = function (e, t) {
          return t(e), e;
        }, lr.throttle = function (e, t, a) {
          var r = !0,
              n = !0;
          if ("function" != typeof e) throw new nt(c);
          return Si(a) && (r = "leading" in a ? !!a.leading : r, n = "trailing" in a ? !!a.trailing : n), ni(e, t, {
            leading: r,
            maxWait: t,
            trailing: n
          });
        }, lr.thru = jo, lr.toArray = Fi, lr.toPairs = fc, lr.toPairsIn = lc, lr.toPath = function (e) {
          return yi(e) ? Qt(e, uo) : Mi(e) ? [e] : as(co(zi(e)));
        }, lr.toPlainObject = Hi, lr.transform = function (e, t, a) {
          var r = yi(e),
              n = r || Ai(e) || Pi(e);

          if (t = Ms(t, 4), null == a) {
            var s = e && e.constructor;
            a = n ? r ? new s() : [] : Si(e) && xi(s) ? hr(Rt(e)) : {};
          }

          return (n ? qt : Kr)(e, function (e, r, n) {
            return t(a, e, r, n);
          }), a;
        }, lr.unary = function (e) {
          return ei(e, 1);
        }, lr.union = Eo, lr.unionBy = Bo, lr.unionWith = ko, lr.uniq = function (e) {
          return e && e.length ? Ln(e) : [];
        }, lr.uniqBy = function (e, t) {
          return e && e.length ? Ln(e, Ms(t, 2)) : [];
        }, lr.uniqWith = function (e, t) {
          return t = "function" == typeof t ? t : s, e && e.length ? Ln(e, s, t) : [];
        }, lr.unset = function (e, t) {
          return null == e || On(e, t);
        }, lr.unzip = Ro, lr.unzipWith = Wo, lr.update = function (e, t, a) {
          return null == e ? e : Fn(e, t, zn(a));
        }, lr.updateWith = function (e, t, a, r) {
          return r = "function" == typeof r ? r : s, null == e ? e : Fn(e, t, zn(a), r);
        }, lr.values = hc, lr.valuesIn = function (e) {
          return null == e ? [] : ya(e, sc(e));
        }, lr.without = Io, lr.words = xc, lr.wrap = function (e, t) {
          return di(zn(t), e);
        }, lr.xor = No, lr.xorBy = Mo, lr.xorWith = Po, lr.zip = Lo, lr.zipObject = function (e, t) {
          return Un(e || [], t || [], Sr);
        }, lr.zipObjectDeep = function (e, t) {
          return Un(e || [], t || [], Cn);
        }, lr.zipWith = Oo, lr.entries = fc, lr.entriesIn = lc, lr.extend = qi, lr.extendWith = Yi, Nc(lr, lr), lr.add = Hc, lr.attempt = Dc, lr.camelCase = pc, lr.capitalize = bc, lr.ceil = zc, lr.clamp = function (e, t, a) {
          return a === s && (a = t, t = s), a !== s && (a = (a = Ui(a)) == a ? a : 0), t !== s && (t = (t = Ui(t)) == t ? t : 0), Ir(Ui(e), t, a);
        }, lr.clone = function (e) {
          return Nr(e, p);
        }, lr.cloneDeep = function (e) {
          return Nr(e, l | p);
        }, lr.cloneDeepWith = function (e, t) {
          return Nr(e, l | p, t = "function" == typeof t ? t : s);
        }, lr.cloneWith = function (e, t) {
          return Nr(e, p, t = "function" == typeof t ? t : s);
        }, lr.conformsTo = function (e, t) {
          return null == t || Mr(e, t, nc(t));
        }, lr.deburr = mc, lr.defaultTo = function (e, t) {
          return null == e || e != e ? t : e;
        }, lr.divide = Kc, lr.endsWith = function (e, t, a) {
          e = zi(e), t = Pn(t);
          var r = e.length,
              n = a = a === s ? r : Ir(Gi(a), 0, r);
          return (a -= t.length) >= 0 && e.slice(a, n) == t;
        }, lr.eq = hi, lr.escape = function (e) {
          return (e = zi(e)) && De.test(e) ? e.replace(Te, wa) : e;
        }, lr.escapeRegExp = function (e) {
          return (e = zi(e)) && Ie.test(e) ? e.replace(We, "\\$&") : e;
        }, lr.every = function (e, t, a) {
          var r = yi(e) ? Zt : jr;
          return a && Ks(e, t, a) && (t = s), r(e, Ms(t, 3));
        }, lr.find = Uo, lr.findIndex = mo, lr.findKey = function (e, t) {
          return sa(e, Ms(t, 3), Kr);
        }, lr.findLast = Ho, lr.findLastIndex = yo, lr.findLastKey = function (e, t) {
          return sa(e, Ms(t, 3), qr);
        }, lr.floor = qc, lr.forEach = zo, lr.forEachRight = Ko, lr.forIn = function (e, t) {
          return null == e ? e : Hr(e, Ms(t, 3), sc);
        }, lr.forInRight = function (e, t) {
          return null == e ? e : zr(e, Ms(t, 3), sc);
        }, lr.forOwn = function (e, t) {
          return e && Kr(e, Ms(t, 3));
        }, lr.forOwnRight = function (e, t) {
          return e && qr(e, Ms(t, 3));
        }, lr.get = Qi, lr.gt = pi, lr.gte = bi, lr.has = function (e, t) {
          return null != e && Vs(e, t, Qr);
        }, lr.hasIn = ec, lr.head = _o, lr.identity = kc, lr.includes = function (e, t, a, r) {
          e = _i(e) ? e : hc(e), a = a && !r ? Gi(a) : 0;
          var n = e.length;
          return a < 0 && (a = Ha(n + a, 0)), Ni(e) ? a <= n && e.indexOf(t, a) > -1 : !!n && ia(e, t, a) > -1;
        }, lr.indexOf = function (e, t, a) {
          var r = null == e ? 0 : e.length;
          if (!r) return -1;
          var n = null == a ? 0 : Gi(a);
          return n < 0 && (n = Ha(r + n, 0)), ia(e, t, n);
        }, lr.inRange = function (e, t, a) {
          return t = ji(t), a === s ? (a = t, t = 0) : a = ji(a), function (e, t, a) {
            return e >= za(t, a) && e < Ha(t, a);
          }(e = Ui(e), t, a);
        }, lr.invoke = rc, lr.isArguments = mi, lr.isArray = yi, lr.isArrayBuffer = vi, lr.isArrayLike = _i, lr.isArrayLikeObject = gi, lr.isBoolean = function (e) {
          return !0 === e || !1 === e || Ei(e) && Xr(e) == H;
        }, lr.isBuffer = Ai, lr.isDate = wi, lr.isElement = function (e) {
          return Ei(e) && 1 === e.nodeType && !Ri(e);
        }, lr.isEmpty = function (e) {
          if (null == e) return !0;
          if (_i(e) && (yi(e) || "string" == typeof e || "function" == typeof e.splice || Ai(e) || Pi(e) || mi(e))) return !e.length;
          var t = Gs(e);
          if (t == J || t == ae) return !e.size;
          if (Js(e)) return !un(e).length;

          for (var a in e) {
            if (dt.call(e, a)) return !1;
          }

          return !0;
        }, lr.isEqual = function (e, t) {
          return nn(e, t);
        }, lr.isEqualWith = function (e, t, a) {
          var r = (a = "function" == typeof a ? a : s) ? a(e, t) : s;
          return r === s ? nn(e, t, s, a) : !!r;
        }, lr.isError = Ti, lr.isFinite = function (e) {
          return "number" == typeof e && Ga(e);
        }, lr.isFunction = xi, lr.isInteger = Di, lr.isLength = Ci, lr.isMap = Bi, lr.isMatch = function (e, t) {
          return e === t || sn(e, t, Ls(t));
        }, lr.isMatchWith = function (e, t, a) {
          return a = "function" == typeof a ? a : s, sn(e, t, Ls(t), a);
        }, lr.isNaN = function (e) {
          return ki(e) && e != +e;
        }, lr.isNative = function (e) {
          if (Zs(e)) throw new $e(i);
          return on(e);
        }, lr.isNil = function (e) {
          return null == e;
        }, lr.isNull = function (e) {
          return null === e;
        }, lr.isNumber = ki, lr.isObject = Si, lr.isObjectLike = Ei, lr.isPlainObject = Ri, lr.isRegExp = Wi, lr.isSafeInteger = function (e) {
          return Di(e) && e >= -N && e <= N;
        }, lr.isSet = Ii, lr.isString = Ni, lr.isSymbol = Mi, lr.isTypedArray = Pi, lr.isUndefined = function (e) {
          return e === s;
        }, lr.isWeakMap = function (e) {
          return Ei(e) && Gs(e) == oe;
        }, lr.isWeakSet = function (e) {
          return Ei(e) && Xr(e) == ie;
        }, lr.join = function (e, t) {
          return null == e ? "" : Va.call(e, t);
        }, lr.kebabCase = yc, lr.last = To, lr.lastIndexOf = function (e, t, a) {
          var r = null == e ? 0 : e.length;
          if (!r) return -1;
          var n = r;
          return a !== s && (n = (n = Gi(a)) < 0 ? Ha(r + n, 0) : za(n, r - 1)), t == t ? function (e, t, a) {
            for (var r = a + 1; r--;) {
              if (e[r] === t) return r;
            }

            return r;
          }(e, t, n) : oa(e, ua, n, !0);
        }, lr.lowerCase = vc, lr.lowerFirst = _c, lr.lt = Li, lr.lte = Oi, lr.max = function (e) {
          return e && e.length ? Gr(e, kc, $r) : s;
        }, lr.maxBy = function (e, t) {
          return e && e.length ? Gr(e, Ms(t, 2), $r) : s;
        }, lr.mean = function (e) {
          return da(e, kc);
        }, lr.meanBy = function (e, t) {
          return da(e, Ms(t, 2));
        }, lr.min = function (e) {
          return e && e.length ? Gr(e, kc, fn) : s;
        }, lr.minBy = function (e, t) {
          return e && e.length ? Gr(e, Ms(t, 2), fn) : s;
        }, lr.stubArray = Vc, lr.stubFalse = Uc, lr.stubObject = function () {
          return {};
        }, lr.stubString = function () {
          return "";
        }, lr.stubTrue = function () {
          return !0;
        }, lr.multiply = Zc, lr.nth = function (e, t) {
          return e && e.length ? mn(e, Gi(t)) : s;
        }, lr.noConflict = function () {
          return It._ === this && (It._ = bt), this;
        }, lr.noop = Mc, lr.now = Qo, lr.pad = function (e, t, a) {
          e = zi(e);
          var r = (t = Gi(t)) ? ka(e) : 0;
          if (!t || r >= t) return e;
          var n = (t - r) / 2;
          return ys(Oa(n), a) + e + ys(La(n), a);
        }, lr.padEnd = function (e, t, a) {
          e = zi(e);
          var r = (t = Gi(t)) ? ka(e) : 0;
          return t && r < t ? e + ys(t - r, a) : e;
        }, lr.padStart = function (e, t, a) {
          e = zi(e);
          var r = (t = Gi(t)) ? ka(e) : 0;
          return t && r < t ? ys(t - r, a) + e : e;
        }, lr.parseInt = function (e, t, a) {
          return a || null == t ? t = 0 : t && (t = +t), qa(zi(e).replace(Me, ""), t || 0);
        }, lr.random = function (e, t, a) {
          if (a && "boolean" != typeof a && Ks(e, t, a) && (t = a = s), a === s && ("boolean" == typeof t ? (a = t, t = s) : "boolean" == typeof e && (a = e, e = s)), e === s && t === s ? (e = 0, t = 1) : (e = ji(e), t === s ? (t = e, e = 0) : t = ji(t)), e > t) {
            var r = e;
            e = t, t = r;
          }

          if (a || e % 1 || t % 1) {
            var n = Ya();
            return za(e + n * (t - e + Bt("1e-" + ((n + "").length - 1))), t);
          }

          return An(e, t);
        }, lr.reduce = function (e, t, a) {
          var r = yi(e) ? ta : ha,
              n = arguments.length < 3;
          return r(e, Ms(t, 4), a, n, Or);
        }, lr.reduceRight = function (e, t, a) {
          var r = yi(e) ? aa : ha,
              n = arguments.length < 3;
          return r(e, Ms(t, 4), a, n, Fr);
        }, lr.repeat = function (e, t, a) {
          return t = (a ? Ks(e, t, a) : t === s) ? 1 : Gi(t), wn(zi(e), t);
        }, lr.replace = function () {
          var e = arguments,
              t = zi(e[0]);
          return e.length < 3 ? t : t.replace(e[1], e[2]);
        }, lr.result = function (e, t, a) {
          var r = -1,
              n = (t = Kn(t, e)).length;

          for (n || (n = 1, e = s); ++r < n;) {
            var o = null == e ? s : e[uo(t[r])];
            o === s && (r = n, o = a), e = xi(o) ? o.call(e) : o;
          }

          return e;
        }, lr.round = Jc, lr.runInContext = e, lr.sample = function (e) {
          return (yi(e) ? Tr : xn)(e);
        }, lr.size = function (e) {
          if (null == e) return 0;
          if (_i(e)) return Ni(e) ? ka(e) : e.length;
          var t = Gs(e);
          return t == J || t == ae ? e.size : un(e).length;
        }, lr.snakeCase = gc, lr.some = function (e, t, a) {
          var r = yi(e) ? ra : Rn;
          return a && Ks(e, t, a) && (t = s), r(e, Ms(t, 3));
        }, lr.sortedIndex = function (e, t) {
          return Wn(e, t);
        }, lr.sortedIndexBy = function (e, t, a) {
          return In(e, t, Ms(a, 2));
        }, lr.sortedIndexOf = function (e, t) {
          var a = null == e ? 0 : e.length;

          if (a) {
            var r = Wn(e, t);
            if (r < a && hi(e[r], t)) return r;
          }

          return -1;
        }, lr.sortedLastIndex = function (e, t) {
          return Wn(e, t, !0);
        }, lr.sortedLastIndexBy = function (e, t, a) {
          return In(e, t, Ms(a, 2), !0);
        }, lr.sortedLastIndexOf = function (e, t) {
          if (null == e ? 0 : e.length) {
            var a = Wn(e, t, !0) - 1;
            if (hi(e[a], t)) return a;
          }

          return -1;
        }, lr.startCase = Ac, lr.startsWith = function (e, t, a) {
          return e = zi(e), a = null == a ? 0 : Ir(Gi(a), 0, e.length), t = Pn(t), e.slice(a, a + t.length) == t;
        }, lr.subtract = Xc, lr.sum = function (e) {
          return e && e.length ? pa(e, kc) : 0;
        }, lr.sumBy = function (e, t) {
          return e && e.length ? pa(e, Ms(t, 2)) : 0;
        }, lr.template = function (e, t, a) {
          var r = lr.templateSettings;
          a && Ks(e, t, a) && (t = s), e = zi(e), t = Yi({}, t, r, Ds);
          var n,
              o,
              i = Yi({}, t.imports, r.imports, Ds),
              c = nc(i),
              u = ya(i, c),
              d = 0,
              f = t.interpolate || Je,
              l = "__p += '",
              h = at((t.escape || Je).source + "|" + f.source + "|" + (f === Ee ? Ve : Je).source + "|" + (t.evaluate || Je).source + "|$", "g"),
              p = "//# sourceURL=" + (dt.call(t, "sourceURL") ? (t.sourceURL + "").replace(/[\r\n]/g, " ") : "lodash.templateSources[" + ++Dt + "]") + "\n";
          e.replace(h, function (t, a, r, s, i, c) {
            return r || (r = s), l += e.slice(d, c).replace(Xe, Ta), a && (n = !0, l += "' +\n__e(" + a + ") +\n'"), i && (o = !0, l += "';\n" + i + ";\n__p += '"), r && (l += "' +\n((__t = (" + r + ")) == null ? '' : __t) +\n'"), d = c + t.length, t;
          }), l += "';\n";
          var b = dt.call(t, "variable") && t.variable;
          b || (l = "with (obj) {\n" + l + "\n}\n"), l = (o ? l.replace(_e, "") : l).replace(ge, "$1").replace(Ae, "$1;"), l = "function(" + (b || "obj") + ") {\n" + (b ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (n ? ", __e = _.escape" : "") + (o ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + l + "return __p\n}";
          var m = Dc(function () {
            return Qe(c, p + "return " + l).apply(s, u);
          });
          if (m.source = l, Ti(m)) throw m;
          return m;
        }, lr.times = function (e, t) {
          if ((e = Gi(e)) < 1 || e > N) return [];
          var a = L,
              r = za(e, L);
          t = Ms(t), e -= L;

          for (var n = ba(r, t); ++a < e;) {
            t(a);
          }

          return n;
        }, lr.toFinite = ji, lr.toInteger = Gi, lr.toLength = Vi, lr.toLower = function (e) {
          return zi(e).toLowerCase();
        }, lr.toNumber = Ui, lr.toSafeInteger = function (e) {
          return e ? Ir(Gi(e), -N, N) : 0 === e ? e : 0;
        }, lr.toString = zi, lr.toUpper = function (e) {
          return zi(e).toUpperCase();
        }, lr.trim = function (e, t, a) {
          if ((e = zi(e)) && (a || t === s)) return e.replace(Ne, "");
          if (!e || !(t = Pn(t))) return e;
          var r = Ra(e),
              n = Ra(t);
          return Yn(r, _a(r, n), ga(r, n) + 1).join("");
        }, lr.trimEnd = function (e, t, a) {
          if ((e = zi(e)) && (a || t === s)) return e.replace(Pe, "");
          if (!e || !(t = Pn(t))) return e;
          var r = Ra(e);
          return Yn(r, 0, ga(r, Ra(t)) + 1).join("");
        }, lr.trimStart = function (e, t, a) {
          if ((e = zi(e)) && (a || t === s)) return e.replace(Me, "");
          if (!e || !(t = Pn(t))) return e;
          var r = Ra(e);
          return Yn(r, _a(r, Ra(t))).join("");
        }, lr.truncate = function (e, t) {
          var a = S,
              r = E;

          if (Si(t)) {
            var n = "separator" in t ? t.separator : n;
            a = "length" in t ? Gi(t.length) : a, r = "omission" in t ? Pn(t.omission) : r;
          }

          var o = (e = zi(e)).length;

          if (xa(e)) {
            var i = Ra(e);
            o = i.length;
          }

          if (a >= o) return e;
          var c = a - ka(r);
          if (c < 1) return r;
          var u = i ? Yn(i, 0, c).join("") : e.slice(0, c);
          if (n === s) return u + r;

          if (i && (c += u.length - c), Wi(n)) {
            if (e.slice(c).search(n)) {
              var d,
                  f = u;

              for (n.global || (n = at(n.source, zi(Ue.exec(n)) + "g")), n.lastIndex = 0; d = n.exec(f);) {
                var l = d.index;
              }

              u = u.slice(0, l === s ? c : l);
            }
          } else if (e.indexOf(Pn(n), c) != c) {
            var h = u.lastIndexOf(n);
            h > -1 && (u = u.slice(0, h));
          }

          return u + r;
        }, lr.unescape = function (e) {
          return (e = zi(e)) && xe.test(e) ? e.replace(we, Wa) : e;
        }, lr.uniqueId = function (e) {
          var t = ++ft;
          return zi(e) + t;
        }, lr.upperCase = wc, lr.upperFirst = Tc, lr.each = zo, lr.eachRight = Ko, lr.first = _o, Nc(lr, (Yc = {}, Kr(lr, function (e, t) {
          dt.call(lr.prototype, t) || (Yc[t] = e);
        }), Yc), {
          chain: !1
        }), lr.VERSION = "4.17.15", qt(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function (e) {
          lr[e].placeholder = lr;
        }), qt(["drop", "take"], function (e, t) {
          mr.prototype[e] = function (a) {
            a = a === s ? 1 : Ha(Gi(a), 0);
            var r = this.__filtered__ && !t ? new mr(this) : this.clone();
            return r.__filtered__ ? r.__takeCount__ = za(a, r.__takeCount__) : r.__views__.push({
              size: za(a, L),
              type: e + (r.__dir__ < 0 ? "Right" : "")
            }), r;
          }, mr.prototype[e + "Right"] = function (t) {
            return this.reverse()[e](t).reverse();
          };
        }), qt(["filter", "map", "takeWhile"], function (e, t) {
          var a = t + 1,
              r = a == R || 3 == a;

          mr.prototype[e] = function (e) {
            var t = this.clone();
            return t.__iteratees__.push({
              iteratee: Ms(e, 3),
              type: a
            }), t.__filtered__ = t.__filtered__ || r, t;
          };
        }), qt(["head", "last"], function (e, t) {
          var a = "take" + (t ? "Right" : "");

          mr.prototype[e] = function () {
            return this[a](1).value()[0];
          };
        }), qt(["initial", "tail"], function (e, t) {
          var a = "drop" + (t ? "" : "Right");

          mr.prototype[e] = function () {
            return this.__filtered__ ? new mr(this) : this[a](1);
          };
        }), mr.prototype.compact = function () {
          return this.filter(kc);
        }, mr.prototype.find = function (e) {
          return this.filter(e).head();
        }, mr.prototype.findLast = function (e) {
          return this.reverse().find(e);
        }, mr.prototype.invokeMap = Tn(function (e, t) {
          return "function" == typeof e ? new mr(this) : this.map(function (a) {
            return an(a, e, t);
          });
        }), mr.prototype.reject = function (e) {
          return this.filter(ci(Ms(e)));
        }, mr.prototype.slice = function (e, t) {
          e = Gi(e);
          var a = this;
          return a.__filtered__ && (e > 0 || t < 0) ? new mr(a) : (e < 0 ? a = a.takeRight(-e) : e && (a = a.drop(e)), t !== s && (a = (t = Gi(t)) < 0 ? a.dropRight(-t) : a.take(t - e)), a);
        }, mr.prototype.takeRightWhile = function (e) {
          return this.reverse().takeWhile(e).reverse();
        }, mr.prototype.toArray = function () {
          return this.take(L);
        }, Kr(mr.prototype, function (e, t) {
          var a = /^(?:filter|find|map|reject)|While$/.test(t),
              r = /^(?:head|last)$/.test(t),
              n = lr[r ? "take" + ("last" == t ? "Right" : "") : t],
              o = r || /^find/.test(t);
          n && (lr.prototype[t] = function () {
            var t = this.__wrapped__,
                i = r ? [1] : arguments,
                c = t instanceof mr,
                u = i[0],
                d = c || yi(t),
                f = function f(e) {
              var t = n.apply(lr, ea([e], i));
              return r && l ? t[0] : t;
            };

            d && a && "function" == typeof u && 1 != u.length && (c = d = !1);
            var l = this.__chain__,
                h = !!this.__actions__.length,
                p = o && !l,
                b = c && !h;

            if (!o && d) {
              t = b ? t : new mr(this);
              var m = e.apply(t, i);
              return m.__actions__.push({
                func: jo,
                args: [f],
                thisArg: s
              }), new br(m, l);
            }

            return p && b ? e.apply(this, i) : (m = this.thru(f), p ? r ? m.value()[0] : m.value() : m);
          });
        }), qt(["pop", "push", "shift", "sort", "splice", "unshift"], function (e) {
          var t = st[e],
              a = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru",
              r = /^(?:pop|shift)$/.test(e);

          lr.prototype[e] = function () {
            var e = arguments;

            if (r && !this.__chain__) {
              var n = this.value();
              return t.apply(yi(n) ? n : [], e);
            }

            return this[a](function (a) {
              return t.apply(yi(a) ? a : [], e);
            });
          };
        }), Kr(mr.prototype, function (e, t) {
          var a = lr[t];

          if (a) {
            var r = a.name + "";
            dt.call(rr, r) || (rr[r] = []), rr[r].push({
              name: t,
              func: a
            });
          }
        }), rr[hs(s, v).name] = [{
          name: "wrapper",
          func: s
        }], mr.prototype.clone = function () {
          var e = new mr(this.__wrapped__);
          return e.__actions__ = as(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = as(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = as(this.__views__), e;
        }, mr.prototype.reverse = function () {
          if (this.__filtered__) {
            var e = new mr(this);
            e.__dir__ = -1, e.__filtered__ = !0;
          } else (e = this.clone()).__dir__ *= -1;

          return e;
        }, mr.prototype.value = function () {
          var e = this.__wrapped__.value(),
              t = this.__dir__,
              a = yi(e),
              r = t < 0,
              n = a ? e.length : 0,
              s = function (e, t, a) {
            var r = -1,
                n = a.length;

            for (; ++r < n;) {
              var s = a[r],
                  o = s.size;

              switch (s.type) {
                case "drop":
                  e += o;
                  break;

                case "dropRight":
                  t -= o;
                  break;

                case "take":
                  t = za(t, e + o);
                  break;

                case "takeRight":
                  e = Ha(e, t - o);
              }
            }

            return {
              start: e,
              end: t
            };
          }(0, n, this.__views__),
              o = s.start,
              i = s.end,
              c = i - o,
              u = r ? i : o - 1,
              d = this.__iteratees__,
              f = d.length,
              l = 0,
              h = za(c, this.__takeCount__);

          if (!a || !r && n == c && h == c) return Gn(e, this.__actions__);
          var p = [];

          e: for (; c-- && l < h;) {
            for (var b = -1, m = e[u += t]; ++b < f;) {
              var y = d[b],
                  v = y.iteratee,
                  _ = y.type,
                  g = v(m);
              if (_ == W) m = g;else if (!g) {
                if (_ == R) continue e;
                break e;
              }
            }

            p[l++] = m;
          }

          return p;
        }, lr.prototype.at = Go, lr.prototype.chain = function () {
          return Fo(this);
        }, lr.prototype.commit = function () {
          return new br(this.value(), this.__chain__);
        }, lr.prototype.next = function () {
          this.__values__ === s && (this.__values__ = Fi(this.value()));
          var e = this.__index__ >= this.__values__.length;
          return {
            done: e,
            value: e ? s : this.__values__[this.__index__++]
          };
        }, lr.prototype.plant = function (e) {
          for (var t, a = this; a instanceof pr;) {
            var r = lo(a);
            r.__index__ = 0, r.__values__ = s, t ? n.__wrapped__ = r : t = r;
            var n = r;
            a = a.__wrapped__;
          }

          return n.__wrapped__ = e, t;
        }, lr.prototype.reverse = function () {
          var e = this.__wrapped__;

          if (e instanceof mr) {
            var t = e;
            return this.__actions__.length && (t = new mr(this)), (t = t.reverse()).__actions__.push({
              func: jo,
              args: [So],
              thisArg: s
            }), new br(t, this.__chain__);
          }

          return this.thru(So);
        }, lr.prototype.toJSON = lr.prototype.valueOf = lr.prototype.value = function () {
          return Gn(this.__wrapped__, this.__actions__);
        }, lr.prototype.first = lr.prototype.head, Ot && (lr.prototype[Ot] = function () {
          return this;
        }), lr;
      }();

      It._ = Ia, (n = function () {
        return Ia;
      }.call(t, a, t, r)) === s || (r.exports = n);
    }).call(this);
  }).call(this, a(
  /*! ./../webpack/buildin/global.js */
  18), a(
  /*! ./../webpack/buildin/module.js */
  45)(e));
},
/*!*********************************************************************!*\
  !*** ./node_modules/node-libs-browser/node_modules/buffer/index.js ***!
  \*********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    /*!
     * The buffer module from node.js, for the browser.
     *
     * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
     * @license  MIT
     */
    var r = a(
    /*! base64-js */
    320),
        n = a(
    /*! ieee754 */
    321),
        s = a(
    /*! isarray */
    149);

    function o() {
      return c.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
    }

    function i(e, t) {
      if (o() < t) throw new RangeError("Invalid typed array length");
      return c.TYPED_ARRAY_SUPPORT ? (e = new Uint8Array(t)).__proto__ = c.prototype : (null === e && (e = new c(t)), e.length = t), e;
    }

    function c(e, t, a) {
      if (!(c.TYPED_ARRAY_SUPPORT || this instanceof c)) return new c(e, t, a);

      if ("number" == typeof e) {
        if ("string" == typeof t) throw new Error("If encoding is specified then the first argument must be a string");
        return f(this, e);
      }

      return u(this, e, t, a);
    }

    function u(e, t, a, r) {
      if ("number" == typeof t) throw new TypeError('"value" argument must not be a number');
      return "undefined" != typeof ArrayBuffer && t instanceof ArrayBuffer ? function (e, t, a, r) {
        if (t.byteLength, a < 0 || t.byteLength < a) throw new RangeError("'offset' is out of bounds");
        if (t.byteLength < a + (r || 0)) throw new RangeError("'length' is out of bounds");
        t = void 0 === a && void 0 === r ? new Uint8Array(t) : void 0 === r ? new Uint8Array(t, a) : new Uint8Array(t, a, r);
        c.TYPED_ARRAY_SUPPORT ? (e = t).__proto__ = c.prototype : e = l(e, t);
        return e;
      }(e, t, a, r) : "string" == typeof t ? function (e, t, a) {
        "string" == typeof a && "" !== a || (a = "utf8");
        if (!c.isEncoding(a)) throw new TypeError('"encoding" must be a valid string encoding');
        var r = 0 | p(t, a),
            n = (e = i(e, r)).write(t, a);
        n !== r && (e = e.slice(0, n));
        return e;
      }(e, t, a) : function (e, t) {
        if (c.isBuffer(t)) {
          var a = 0 | h(t.length);
          return 0 === (e = i(e, a)).length ? e : (t.copy(e, 0, 0, a), e);
        }

        if (t) {
          if ("undefined" != typeof ArrayBuffer && t.buffer instanceof ArrayBuffer || "length" in t) return "number" != typeof t.length || (r = t.length) != r ? i(e, 0) : l(e, t);
          if ("Buffer" === t.type && s(t.data)) return l(e, t.data);
        }

        var r;
        throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
      }(e, t);
    }

    function d(e) {
      if ("number" != typeof e) throw new TypeError('"size" argument must be a number');
      if (e < 0) throw new RangeError('"size" argument must not be negative');
    }

    function f(e, t) {
      if (d(t), e = i(e, t < 0 ? 0 : 0 | h(t)), !c.TYPED_ARRAY_SUPPORT) for (var a = 0; a < t; ++a) {
        e[a] = 0;
      }
      return e;
    }

    function l(e, t) {
      var a = t.length < 0 ? 0 : 0 | h(t.length);
      e = i(e, a);

      for (var r = 0; r < a; r += 1) {
        e[r] = 255 & t[r];
      }

      return e;
    }

    function h(e) {
      if (e >= o()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + o().toString(16) + " bytes");
      return 0 | e;
    }

    function p(e, t) {
      if (c.isBuffer(e)) return e.length;
      if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(e) || e instanceof ArrayBuffer)) return e.byteLength;
      "string" != typeof e && (e = "" + e);
      var a = e.length;
      if (0 === a) return 0;

      for (var r = !1;;) {
        switch (t) {
          case "ascii":
          case "latin1":
          case "binary":
            return a;

          case "utf8":
          case "utf-8":
          case void 0:
            return G(e).length;

          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return 2 * a;

          case "hex":
            return a >>> 1;

          case "base64":
            return V(e).length;

          default:
            if (r) return G(e).length;
            t = ("" + t).toLowerCase(), r = !0;
        }
      }
    }

    function b(e, t, a) {
      var r = !1;
      if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";
      if ((void 0 === a || a > this.length) && (a = this.length), a <= 0) return "";
      if ((a >>>= 0) <= (t >>>= 0)) return "";

      for (e || (e = "utf8");;) {
        switch (e) {
          case "hex":
            return k(this, t, a);

          case "utf8":
          case "utf-8":
            return C(this, t, a);

          case "ascii":
            return E(this, t, a);

          case "latin1":
          case "binary":
            return B(this, t, a);

          case "base64":
            return D(this, t, a);

          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return R(this, t, a);

          default:
            if (r) throw new TypeError("Unknown encoding: " + e);
            e = (e + "").toLowerCase(), r = !0;
        }
      }
    }

    function m(e, t, a) {
      var r = e[t];
      e[t] = e[a], e[a] = r;
    }

    function y(e, t, a, r, n) {
      if (0 === e.length) return -1;

      if ("string" == typeof a ? (r = a, a = 0) : a > 2147483647 ? a = 2147483647 : a < -2147483648 && (a = -2147483648), a = +a, isNaN(a) && (a = n ? 0 : e.length - 1), a < 0 && (a = e.length + a), a >= e.length) {
        if (n) return -1;
        a = e.length - 1;
      } else if (a < 0) {
        if (!n) return -1;
        a = 0;
      }

      if ("string" == typeof t && (t = c.from(t, r)), c.isBuffer(t)) return 0 === t.length ? -1 : v(e, t, a, r, n);
      if ("number" == typeof t) return t &= 255, c.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? n ? Uint8Array.prototype.indexOf.call(e, t, a) : Uint8Array.prototype.lastIndexOf.call(e, t, a) : v(e, [t], a, r, n);
      throw new TypeError("val must be string, number or Buffer");
    }

    function v(e, t, a, r, n) {
      var s,
          o = 1,
          i = e.length,
          c = t.length;

      if (void 0 !== r && ("ucs2" === (r = String(r).toLowerCase()) || "ucs-2" === r || "utf16le" === r || "utf-16le" === r)) {
        if (e.length < 2 || t.length < 2) return -1;
        o = 2, i /= 2, c /= 2, a /= 2;
      }

      function u(e, t) {
        return 1 === o ? e[t] : e.readUInt16BE(t * o);
      }

      if (n) {
        var d = -1;

        for (s = a; s < i; s++) {
          if (u(e, s) === u(t, -1 === d ? 0 : s - d)) {
            if (-1 === d && (d = s), s - d + 1 === c) return d * o;
          } else -1 !== d && (s -= s - d), d = -1;
        }
      } else for (a + c > i && (a = i - c), s = a; s >= 0; s--) {
        for (var f = !0, l = 0; l < c; l++) {
          if (u(e, s + l) !== u(t, l)) {
            f = !1;
            break;
          }
        }

        if (f) return s;
      }

      return -1;
    }

    function _(e, t, a, r) {
      a = Number(a) || 0;
      var n = e.length - a;
      r ? (r = Number(r)) > n && (r = n) : r = n;
      var s = t.length;
      if (s % 2 != 0) throw new TypeError("Invalid hex string");
      r > s / 2 && (r = s / 2);

      for (var o = 0; o < r; ++o) {
        var i = parseInt(t.substr(2 * o, 2), 16);
        if (isNaN(i)) return o;
        e[a + o] = i;
      }

      return o;
    }

    function g(e, t, a, r) {
      return U(G(t, e.length - a), e, a, r);
    }

    function A(e, t, a, r) {
      return U(function (e) {
        for (var t = [], a = 0; a < e.length; ++a) {
          t.push(255 & e.charCodeAt(a));
        }

        return t;
      }(t), e, a, r);
    }

    function w(e, t, a, r) {
      return A(e, t, a, r);
    }

    function T(e, t, a, r) {
      return U(V(t), e, a, r);
    }

    function x(e, t, a, r) {
      return U(function (e, t) {
        for (var a, r, n, s = [], o = 0; o < e.length && !((t -= 2) < 0); ++o) {
          a = e.charCodeAt(o), r = a >> 8, n = a % 256, s.push(n), s.push(r);
        }

        return s;
      }(t, e.length - a), e, a, r);
    }

    function D(e, t, a) {
      return 0 === t && a === e.length ? r.fromByteArray(e) : r.fromByteArray(e.slice(t, a));
    }

    function C(e, t, a) {
      a = Math.min(e.length, a);

      for (var r = [], n = t; n < a;) {
        var s,
            o,
            i,
            c,
            u = e[n],
            d = null,
            f = u > 239 ? 4 : u > 223 ? 3 : u > 191 ? 2 : 1;
        if (n + f <= a) switch (f) {
          case 1:
            u < 128 && (d = u);
            break;

          case 2:
            128 == (192 & (s = e[n + 1])) && (c = (31 & u) << 6 | 63 & s) > 127 && (d = c);
            break;

          case 3:
            s = e[n + 1], o = e[n + 2], 128 == (192 & s) && 128 == (192 & o) && (c = (15 & u) << 12 | (63 & s) << 6 | 63 & o) > 2047 && (c < 55296 || c > 57343) && (d = c);
            break;

          case 4:
            s = e[n + 1], o = e[n + 2], i = e[n + 3], 128 == (192 & s) && 128 == (192 & o) && 128 == (192 & i) && (c = (15 & u) << 18 | (63 & s) << 12 | (63 & o) << 6 | 63 & i) > 65535 && c < 1114112 && (d = c);
        }
        null === d ? (d = 65533, f = 1) : d > 65535 && (d -= 65536, r.push(d >>> 10 & 1023 | 55296), d = 56320 | 1023 & d), r.push(d), n += f;
      }

      return function (e) {
        var t = e.length;
        if (t <= S) return String.fromCharCode.apply(String, e);
        var a = "",
            r = 0;

        for (; r < t;) {
          a += String.fromCharCode.apply(String, e.slice(r, r += S));
        }

        return a;
      }(r);
    }

    t.Buffer = c, t.SlowBuffer = function (e) {
      +e != e && (e = 0);
      return c.alloc(+e);
    }, t.INSPECT_MAX_BYTES = 50, c.TYPED_ARRAY_SUPPORT = void 0 !== e.TYPED_ARRAY_SUPPORT ? e.TYPED_ARRAY_SUPPORT : function () {
      try {
        var e = new Uint8Array(1);
        return e.__proto__ = {
          __proto__: Uint8Array.prototype,
          foo: function foo() {
            return 42;
          }
        }, 42 === e.foo() && "function" == typeof e.subarray && 0 === e.subarray(1, 1).byteLength;
      } catch (e) {
        return !1;
      }
    }(), t.kMaxLength = o(), c.poolSize = 8192, c._augment = function (e) {
      return e.__proto__ = c.prototype, e;
    }, c.from = function (e, t, a) {
      return u(null, e, t, a);
    }, c.TYPED_ARRAY_SUPPORT && (c.prototype.__proto__ = Uint8Array.prototype, c.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && c[Symbol.species] === c && Object.defineProperty(c, Symbol.species, {
      value: null,
      configurable: !0
    })), c.alloc = function (e, t, a) {
      return function (e, t, a, r) {
        return d(t), t <= 0 ? i(e, t) : void 0 !== a ? "string" == typeof r ? i(e, t).fill(a, r) : i(e, t).fill(a) : i(e, t);
      }(null, e, t, a);
    }, c.allocUnsafe = function (e) {
      return f(null, e);
    }, c.allocUnsafeSlow = function (e) {
      return f(null, e);
    }, c.isBuffer = function (e) {
      return !(null == e || !e._isBuffer);
    }, c.compare = function (e, t) {
      if (!c.isBuffer(e) || !c.isBuffer(t)) throw new TypeError("Arguments must be Buffers");
      if (e === t) return 0;

      for (var a = e.length, r = t.length, n = 0, s = Math.min(a, r); n < s; ++n) {
        if (e[n] !== t[n]) {
          a = e[n], r = t[n];
          break;
        }
      }

      return a < r ? -1 : r < a ? 1 : 0;
    }, c.isEncoding = function (e) {
      switch (String(e).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return !0;

        default:
          return !1;
      }
    }, c.concat = function (e, t) {
      if (!s(e)) throw new TypeError('"list" argument must be an Array of Buffers');
      if (0 === e.length) return c.alloc(0);
      var a;
      if (void 0 === t) for (t = 0, a = 0; a < e.length; ++a) {
        t += e[a].length;
      }
      var r = c.allocUnsafe(t),
          n = 0;

      for (a = 0; a < e.length; ++a) {
        var o = e[a];
        if (!c.isBuffer(o)) throw new TypeError('"list" argument must be an Array of Buffers');
        o.copy(r, n), n += o.length;
      }

      return r;
    }, c.byteLength = p, c.prototype._isBuffer = !0, c.prototype.swap16 = function () {
      var e = this.length;
      if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");

      for (var t = 0; t < e; t += 2) {
        m(this, t, t + 1);
      }

      return this;
    }, c.prototype.swap32 = function () {
      var e = this.length;
      if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");

      for (var t = 0; t < e; t += 4) {
        m(this, t, t + 3), m(this, t + 1, t + 2);
      }

      return this;
    }, c.prototype.swap64 = function () {
      var e = this.length;
      if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");

      for (var t = 0; t < e; t += 8) {
        m(this, t, t + 7), m(this, t + 1, t + 6), m(this, t + 2, t + 5), m(this, t + 3, t + 4);
      }

      return this;
    }, c.prototype.toString = function () {
      var e = 0 | this.length;
      return 0 === e ? "" : 0 === arguments.length ? C(this, 0, e) : b.apply(this, arguments);
    }, c.prototype.equals = function (e) {
      if (!c.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
      return this === e || 0 === c.compare(this, e);
    }, c.prototype.inspect = function () {
      var e = "",
          a = t.INSPECT_MAX_BYTES;
      return this.length > 0 && (e = this.toString("hex", 0, a).match(/.{2}/g).join(" "), this.length > a && (e += " ... ")), "<Buffer " + e + ">";
    }, c.prototype.compare = function (e, t, a, r, n) {
      if (!c.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
      if (void 0 === t && (t = 0), void 0 === a && (a = e ? e.length : 0), void 0 === r && (r = 0), void 0 === n && (n = this.length), t < 0 || a > e.length || r < 0 || n > this.length) throw new RangeError("out of range index");
      if (r >= n && t >= a) return 0;
      if (r >= n) return -1;
      if (t >= a) return 1;
      if (this === e) return 0;

      for (var s = (n >>>= 0) - (r >>>= 0), o = (a >>>= 0) - (t >>>= 0), i = Math.min(s, o), u = this.slice(r, n), d = e.slice(t, a), f = 0; f < i; ++f) {
        if (u[f] !== d[f]) {
          s = u[f], o = d[f];
          break;
        }
      }

      return s < o ? -1 : o < s ? 1 : 0;
    }, c.prototype.includes = function (e, t, a) {
      return -1 !== this.indexOf(e, t, a);
    }, c.prototype.indexOf = function (e, t, a) {
      return y(this, e, t, a, !0);
    }, c.prototype.lastIndexOf = function (e, t, a) {
      return y(this, e, t, a, !1);
    }, c.prototype.write = function (e, t, a, r) {
      if (void 0 === t) r = "utf8", a = this.length, t = 0;else if (void 0 === a && "string" == typeof t) r = t, a = this.length, t = 0;else {
        if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
        t |= 0, isFinite(a) ? (a |= 0, void 0 === r && (r = "utf8")) : (r = a, a = void 0);
      }
      var n = this.length - t;
      if ((void 0 === a || a > n) && (a = n), e.length > 0 && (a < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
      r || (r = "utf8");

      for (var s = !1;;) {
        switch (r) {
          case "hex":
            return _(this, e, t, a);

          case "utf8":
          case "utf-8":
            return g(this, e, t, a);

          case "ascii":
            return A(this, e, t, a);

          case "latin1":
          case "binary":
            return w(this, e, t, a);

          case "base64":
            return T(this, e, t, a);

          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return x(this, e, t, a);

          default:
            if (s) throw new TypeError("Unknown encoding: " + r);
            r = ("" + r).toLowerCase(), s = !0;
        }
      }
    }, c.prototype.toJSON = function () {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    var S = 4096;

    function E(e, t, a) {
      var r = "";
      a = Math.min(e.length, a);

      for (var n = t; n < a; ++n) {
        r += String.fromCharCode(127 & e[n]);
      }

      return r;
    }

    function B(e, t, a) {
      var r = "";
      a = Math.min(e.length, a);

      for (var n = t; n < a; ++n) {
        r += String.fromCharCode(e[n]);
      }

      return r;
    }

    function k(e, t, a) {
      var r = e.length;
      (!t || t < 0) && (t = 0), (!a || a < 0 || a > r) && (a = r);

      for (var n = "", s = t; s < a; ++s) {
        n += j(e[s]);
      }

      return n;
    }

    function R(e, t, a) {
      for (var r = e.slice(t, a), n = "", s = 0; s < r.length; s += 2) {
        n += String.fromCharCode(r[s] + 256 * r[s + 1]);
      }

      return n;
    }

    function W(e, t, a) {
      if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");
      if (e + t > a) throw new RangeError("Trying to access beyond buffer length");
    }

    function I(e, t, a, r, n, s) {
      if (!c.isBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
      if (t > n || t < s) throw new RangeError('"value" argument is out of bounds');
      if (a + r > e.length) throw new RangeError("Index out of range");
    }

    function N(e, t, a, r) {
      t < 0 && (t = 65535 + t + 1);

      for (var n = 0, s = Math.min(e.length - a, 2); n < s; ++n) {
        e[a + n] = (t & 255 << 8 * (r ? n : 1 - n)) >>> 8 * (r ? n : 1 - n);
      }
    }

    function M(e, t, a, r) {
      t < 0 && (t = 4294967295 + t + 1);

      for (var n = 0, s = Math.min(e.length - a, 4); n < s; ++n) {
        e[a + n] = t >>> 8 * (r ? n : 3 - n) & 255;
      }
    }

    function P(e, t, a, r, n, s) {
      if (a + r > e.length) throw new RangeError("Index out of range");
      if (a < 0) throw new RangeError("Index out of range");
    }

    function L(e, t, a, r, s) {
      return s || P(e, 0, a, 4), n.write(e, t, a, r, 23, 4), a + 4;
    }

    function O(e, t, a, r, s) {
      return s || P(e, 0, a, 8), n.write(e, t, a, r, 52, 8), a + 8;
    }

    c.prototype.slice = function (e, t) {
      var a,
          r = this.length;
      if ((e = ~~e) < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r), (t = void 0 === t ? r : ~~t) < 0 ? (t += r) < 0 && (t = 0) : t > r && (t = r), t < e && (t = e), c.TYPED_ARRAY_SUPPORT) (a = this.subarray(e, t)).__proto__ = c.prototype;else {
        var n = t - e;
        a = new c(n, void 0);

        for (var s = 0; s < n; ++s) {
          a[s] = this[s + e];
        }
      }
      return a;
    }, c.prototype.readUIntLE = function (e, t, a) {
      e |= 0, t |= 0, a || W(e, t, this.length);

      for (var r = this[e], n = 1, s = 0; ++s < t && (n *= 256);) {
        r += this[e + s] * n;
      }

      return r;
    }, c.prototype.readUIntBE = function (e, t, a) {
      e |= 0, t |= 0, a || W(e, t, this.length);

      for (var r = this[e + --t], n = 1; t > 0 && (n *= 256);) {
        r += this[e + --t] * n;
      }

      return r;
    }, c.prototype.readUInt8 = function (e, t) {
      return t || W(e, 1, this.length), this[e];
    }, c.prototype.readUInt16LE = function (e, t) {
      return t || W(e, 2, this.length), this[e] | this[e + 1] << 8;
    }, c.prototype.readUInt16BE = function (e, t) {
      return t || W(e, 2, this.length), this[e] << 8 | this[e + 1];
    }, c.prototype.readUInt32LE = function (e, t) {
      return t || W(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
    }, c.prototype.readUInt32BE = function (e, t) {
      return t || W(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
    }, c.prototype.readIntLE = function (e, t, a) {
      e |= 0, t |= 0, a || W(e, t, this.length);

      for (var r = this[e], n = 1, s = 0; ++s < t && (n *= 256);) {
        r += this[e + s] * n;
      }

      return r >= (n *= 128) && (r -= Math.pow(2, 8 * t)), r;
    }, c.prototype.readIntBE = function (e, t, a) {
      e |= 0, t |= 0, a || W(e, t, this.length);

      for (var r = t, n = 1, s = this[e + --r]; r > 0 && (n *= 256);) {
        s += this[e + --r] * n;
      }

      return s >= (n *= 128) && (s -= Math.pow(2, 8 * t)), s;
    }, c.prototype.readInt8 = function (e, t) {
      return t || W(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
    }, c.prototype.readInt16LE = function (e, t) {
      t || W(e, 2, this.length);
      var a = this[e] | this[e + 1] << 8;
      return 32768 & a ? 4294901760 | a : a;
    }, c.prototype.readInt16BE = function (e, t) {
      t || W(e, 2, this.length);
      var a = this[e + 1] | this[e] << 8;
      return 32768 & a ? 4294901760 | a : a;
    }, c.prototype.readInt32LE = function (e, t) {
      return t || W(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
    }, c.prototype.readInt32BE = function (e, t) {
      return t || W(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
    }, c.prototype.readFloatLE = function (e, t) {
      return t || W(e, 4, this.length), n.read(this, e, !0, 23, 4);
    }, c.prototype.readFloatBE = function (e, t) {
      return t || W(e, 4, this.length), n.read(this, e, !1, 23, 4);
    }, c.prototype.readDoubleLE = function (e, t) {
      return t || W(e, 8, this.length), n.read(this, e, !0, 52, 8);
    }, c.prototype.readDoubleBE = function (e, t) {
      return t || W(e, 8, this.length), n.read(this, e, !1, 52, 8);
    }, c.prototype.writeUIntLE = function (e, t, a, r) {
      (e = +e, t |= 0, a |= 0, r) || I(this, e, t, a, Math.pow(2, 8 * a) - 1, 0);
      var n = 1,
          s = 0;

      for (this[t] = 255 & e; ++s < a && (n *= 256);) {
        this[t + s] = e / n & 255;
      }

      return t + a;
    }, c.prototype.writeUIntBE = function (e, t, a, r) {
      (e = +e, t |= 0, a |= 0, r) || I(this, e, t, a, Math.pow(2, 8 * a) - 1, 0);
      var n = a - 1,
          s = 1;

      for (this[t + n] = 255 & e; --n >= 0 && (s *= 256);) {
        this[t + n] = e / s & 255;
      }

      return t + a;
    }, c.prototype.writeUInt8 = function (e, t, a) {
      return e = +e, t |= 0, a || I(this, e, t, 1, 255, 0), c.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[t] = 255 & e, t + 1;
    }, c.prototype.writeUInt16LE = function (e, t, a) {
      return e = +e, t |= 0, a || I(this, e, t, 2, 65535, 0), c.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : N(this, e, t, !0), t + 2;
    }, c.prototype.writeUInt16BE = function (e, t, a) {
      return e = +e, t |= 0, a || I(this, e, t, 2, 65535, 0), c.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : N(this, e, t, !1), t + 2;
    }, c.prototype.writeUInt32LE = function (e, t, a) {
      return e = +e, t |= 0, a || I(this, e, t, 4, 4294967295, 0), c.TYPED_ARRAY_SUPPORT ? (this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e) : M(this, e, t, !0), t + 4;
    }, c.prototype.writeUInt32BE = function (e, t, a) {
      return e = +e, t |= 0, a || I(this, e, t, 4, 4294967295, 0), c.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : M(this, e, t, !1), t + 4;
    }, c.prototype.writeIntLE = function (e, t, a, r) {
      if (e = +e, t |= 0, !r) {
        var n = Math.pow(2, 8 * a - 1);
        I(this, e, t, a, n - 1, -n);
      }

      var s = 0,
          o = 1,
          i = 0;

      for (this[t] = 255 & e; ++s < a && (o *= 256);) {
        e < 0 && 0 === i && 0 !== this[t + s - 1] && (i = 1), this[t + s] = (e / o >> 0) - i & 255;
      }

      return t + a;
    }, c.prototype.writeIntBE = function (e, t, a, r) {
      if (e = +e, t |= 0, !r) {
        var n = Math.pow(2, 8 * a - 1);
        I(this, e, t, a, n - 1, -n);
      }

      var s = a - 1,
          o = 1,
          i = 0;

      for (this[t + s] = 255 & e; --s >= 0 && (o *= 256);) {
        e < 0 && 0 === i && 0 !== this[t + s + 1] && (i = 1), this[t + s] = (e / o >> 0) - i & 255;
      }

      return t + a;
    }, c.prototype.writeInt8 = function (e, t, a) {
      return e = +e, t |= 0, a || I(this, e, t, 1, 127, -128), c.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
    }, c.prototype.writeInt16LE = function (e, t, a) {
      return e = +e, t |= 0, a || I(this, e, t, 2, 32767, -32768), c.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : N(this, e, t, !0), t + 2;
    }, c.prototype.writeInt16BE = function (e, t, a) {
      return e = +e, t |= 0, a || I(this, e, t, 2, 32767, -32768), c.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : N(this, e, t, !1), t + 2;
    }, c.prototype.writeInt32LE = function (e, t, a) {
      return e = +e, t |= 0, a || I(this, e, t, 4, 2147483647, -2147483648), c.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24) : M(this, e, t, !0), t + 4;
    }, c.prototype.writeInt32BE = function (e, t, a) {
      return e = +e, t |= 0, a || I(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), c.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : M(this, e, t, !1), t + 4;
    }, c.prototype.writeFloatLE = function (e, t, a) {
      return L(this, e, t, !0, a);
    }, c.prototype.writeFloatBE = function (e, t, a) {
      return L(this, e, t, !1, a);
    }, c.prototype.writeDoubleLE = function (e, t, a) {
      return O(this, e, t, !0, a);
    }, c.prototype.writeDoubleBE = function (e, t, a) {
      return O(this, e, t, !1, a);
    }, c.prototype.copy = function (e, t, a, r) {
      if (a || (a = 0), r || 0 === r || (r = this.length), t >= e.length && (t = e.length), t || (t = 0), r > 0 && r < a && (r = a), r === a) return 0;
      if (0 === e.length || 0 === this.length) return 0;
      if (t < 0) throw new RangeError("targetStart out of bounds");
      if (a < 0 || a >= this.length) throw new RangeError("sourceStart out of bounds");
      if (r < 0) throw new RangeError("sourceEnd out of bounds");
      r > this.length && (r = this.length), e.length - t < r - a && (r = e.length - t + a);
      var n,
          s = r - a;
      if (this === e && a < t && t < r) for (n = s - 1; n >= 0; --n) {
        e[n + t] = this[n + a];
      } else if (s < 1e3 || !c.TYPED_ARRAY_SUPPORT) for (n = 0; n < s; ++n) {
        e[n + t] = this[n + a];
      } else Uint8Array.prototype.set.call(e, this.subarray(a, a + s), t);
      return s;
    }, c.prototype.fill = function (e, t, a, r) {
      if ("string" == typeof e) {
        if ("string" == typeof t ? (r = t, t = 0, a = this.length) : "string" == typeof a && (r = a, a = this.length), 1 === e.length) {
          var n = e.charCodeAt(0);
          n < 256 && (e = n);
        }

        if (void 0 !== r && "string" != typeof r) throw new TypeError("encoding must be a string");
        if ("string" == typeof r && !c.isEncoding(r)) throw new TypeError("Unknown encoding: " + r);
      } else "number" == typeof e && (e &= 255);

      if (t < 0 || this.length < t || this.length < a) throw new RangeError("Out of range index");
      if (a <= t) return this;
      var s;
      if (t >>>= 0, a = void 0 === a ? this.length : a >>> 0, e || (e = 0), "number" == typeof e) for (s = t; s < a; ++s) {
        this[s] = e;
      } else {
        var o = c.isBuffer(e) ? e : G(new c(e, r).toString()),
            i = o.length;

        for (s = 0; s < a - t; ++s) {
          this[s + t] = o[s % i];
        }
      }
      return this;
    };
    var F = /[^+\/0-9A-Za-z-_]/g;

    function j(e) {
      return e < 16 ? "0" + e.toString(16) : e.toString(16);
    }

    function G(e, t) {
      var a;
      t = t || 1 / 0;

      for (var r = e.length, n = null, s = [], o = 0; o < r; ++o) {
        if ((a = e.charCodeAt(o)) > 55295 && a < 57344) {
          if (!n) {
            if (a > 56319) {
              (t -= 3) > -1 && s.push(239, 191, 189);
              continue;
            }

            if (o + 1 === r) {
              (t -= 3) > -1 && s.push(239, 191, 189);
              continue;
            }

            n = a;
            continue;
          }

          if (a < 56320) {
            (t -= 3) > -1 && s.push(239, 191, 189), n = a;
            continue;
          }

          a = 65536 + (n - 55296 << 10 | a - 56320);
        } else n && (t -= 3) > -1 && s.push(239, 191, 189);

        if (n = null, a < 128) {
          if ((t -= 1) < 0) break;
          s.push(a);
        } else if (a < 2048) {
          if ((t -= 2) < 0) break;
          s.push(a >> 6 | 192, 63 & a | 128);
        } else if (a < 65536) {
          if ((t -= 3) < 0) break;
          s.push(a >> 12 | 224, a >> 6 & 63 | 128, 63 & a | 128);
        } else {
          if (!(a < 1114112)) throw new Error("Invalid code point");
          if ((t -= 4) < 0) break;
          s.push(a >> 18 | 240, a >> 12 & 63 | 128, a >> 6 & 63 | 128, 63 & a | 128);
        }
      }

      return s;
    }

    function V(e) {
      return r.toByteArray(function (e) {
        if ((e = function (e) {
          return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
        }(e).replace(F, "")).length < 2) return "";

        for (; e.length % 4 != 0;) {
          e += "=";
        }

        return e;
      }(e));
    }

    function U(e, t, a, r) {
      for (var n = 0; n < r && !(n + a >= t.length || n >= e.length); ++n) {
        t[n + a] = e[n];
      }

      return n;
    }
  }).call(this, a(
  /*! ./../../../webpack/buildin/global.js */
  18));
},
/*!********************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/src/index.js ***!
  \********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = a(
  /*! jsonschema */
  150);
  t.ValidatorResult = r.ValidatorResult;
  var n = a(
  /*! ./schema_validator */
  329);
  t.SchemaValidator = n.SchemaValidator;
  var s = a(
  /*! ./schemas */
  151);
  t.schemas = s.schemas;
},
/*!***************************************************!*\
  !*** ./node_modules/inherits/inherits_browser.js ***!
  \***************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  "function" == typeof Object.create ? e.exports = function (e, t) {
    t && (e.super_ = t, e.prototype = Object.create(t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }));
  } : e.exports = function (e, t) {
    if (t) {
      e.super_ = t;

      var a = function a() {};

      a.prototype = t.prototype, e.prototype = new a(), e.prototype.constructor = e;
    }
  };
},
/*!**********************!*\
  !*** ./src/types.ts ***!
  \**********************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = a(
  /*! @polymathnetwork/abi-wrappers */
  6);
  !function (e) {
    e[e.Mainnet = 1] = "Mainnet", e[e.Kovan = 42] = "Kovan", e[e.Local = 15] = "Local";
  }(t.NetworkId || (t.NetworkId = {})), function (e) {
    e[e.PermissionManager = 1] = "PermissionManager", e[e.TransferManager = 2] = "TransferManager", e[e.STO = 3] = "STO", e[e.Dividends = 4] = "Dividends", e[e.Burn = 5] = "Burn", e[e.Wallet = 7] = "Wallet";
  }(t.ModuleType || (t.ModuleType = {})), function (e) {
    e[e.General = 0] = "General", e[e.Issuance = 1] = "Issuance", e[e.Redemption = 2] = "Redemption";
  }(t.TransferType || (t.TransferType = {})), function (e) {
    e[e.ETH = 0] = "ETH", e[e.POLY = 1] = "POLY", e[e.StableCoin = 2] = "StableCoin";
  }(t.FundRaiseType || (t.FundRaiseType = {})), function (e) {
    e[e.ETH = 0] = "ETH", e[e.POLY = 1] = "POLY";
  }(t.CappedSTOFundRaiseType || (t.CappedSTOFundRaiseType = {})), function (e) {
    e[e.IsAccredited = 0] = "IsAccredited", e[e.CanNotBuyFromSto = 1] = "CanNotBuyFromSto", e[e.IsVolRestricted = 2] = "IsVolRestricted";
  }(t.FlagsType || (t.FlagsType = {})), function (e) {
    e[e.INVALID = 0] = "INVALID", e[e.NA = 1] = "NA", e[e.VALID = 2] = "VALID", e[e.FORCE_VALID = 3] = "FORCE_VALID";
  }(t.TransferResult || (t.TransferResult = {})), function (e) {
    e.Prep = "PREP", e.Commit = "COMMIT", e.Reveal = "REVEAL", e.Resolved = "RESOLVED";
  }(t.BallotStage || (t.BallotStage = {})), function (e) {
    e.TickerRegFee = "tickerRegFee", e.StLaunchFee = "stLaunchFee";
  }(t.FeeType || (t.FeeType = {})), function (e) {
    e.CustomModulesAllowed = "customModulesAllowed", e.FreezeMintingAllowed = "freezeMintingAllowed";
  }(t.Feature || (t.Feature = {})), function (e) {
    e.Unlocked = "UNLOCKED", e.Locked = "LOCKED", e.Undefined = "UNDEFINED";
  }(t.Partition || (t.Partition = {})), function (e) {
    e.LowerBound = "lowerBound", e.UpperBound = "upperBound";
  }(t.BoundType || (t.BoundType = {})), function (e) {
    e.PolyToken = "PolyToken", e.ModuleRegistry = "ModuleRegistry", e.FeatureRegistry = "FeatureRegistry", e.SecurityTokenRegistry = "SecurityTokenRegistry", e.PolyUsdOracle = "PolyUsdOracle", e.EthUsdOracle = "EthUsdOracle";
  }(t.PolymathContract || (t.PolymathContract = {})), function (e) {
    e.GeneralPermissionManager = "GeneralPermissionManager", e.CountTransferManager = "CountTransferManager", e.GeneralTransferManager = "GeneralTransferManager", e.ManualApprovalTransferManager = "ManualApprovalTransferManager", e.PercentageTransferManager = "PercentageTransferManager", e.LockUpTransferManager = "LockUpTransferManager", e.BlacklistTransferManager = "BlacklistTransferManager", e.VolumeRestrictionTM = "VolumeRestrictionTM", e.RestrictedPartialSaleTM = "RestrictedPartialSaleTM", e.CappedSTO = "CappedSTO", e.UsdTieredSTO = "USDTieredSTO", e.ERC20DividendCheckpoint = "ERC20DividendCheckpoint", e.EtherDividendCheckpoint = "EtherDividendCheckpoint", e.VestingEscrowWallet = "VestingEscrowWallet", e.AdvancedPLCRVotingCheckpoint = "AdvancedPLCRVotingCheckpoint";
  }(t.ModuleName || (t.ModuleName = {})), function (e) {
    e.TransferFailure = "0x50", e.TransferSuccess = "0x51", e.InsufficientBalance = "0x52", e.InsufficientAllowance = "0x53", e.TransfersHalted = "0x54", e.FundsLocked = "0x55", e.InvalidSender = "0x56", e.InvalidReceiver = "0x57", e.InvalidOperator = "0x58";
  }(t.TransferStatusCode || (t.TransferStatusCode = {})), function (e) {
    e.Admin = "ADMIN", e.Operator = "OPERATOR";
  }(t.Perm || (t.Perm = {})), function (e) {
    e[e.Fixed = 0] = "Fixed", e[e.Percentage = 1] = "Percentage";
  }(t.RestrictionType || (t.RestrictionType = {})), t.PERCENTAGE_DECIMALS = new r.BigNumber(16), t.FULL_DECIMALS = new r.BigNumber(18), function (e) {
    e.Unauthorized = "Unauthorized", e.InvalidAddress = "InvalidAddress", e.InsufficientBalance = "InsufficientBalance", e.InvalidSubscriptionToken = "InvalidSubscriptionToken", e.DuplicatedStrings = "DuplicatedStrings", e.TooLate = "TooLate", e.TooEarly = "TooEarly", e.InvalidData = "InvalidData", e.MismatchedArrayLength = "MismatchedArrayLength", e.InvalidVersion = "InvalidVersion", e.InvalidPartition = "InvalidPartition", e.ContractPaused = "ContractPaused", e.PreconditionRequired = "PreconditionRequired", e.AlreadyClaimed = "AlreadyClaimed", e.AddressExcluded = "AddressExcluded", e.InvalidDividend = "InvalidDividend", e.InvalidCheckpoint = "InvalidCheckpoint", e.ArrayTooLarge = "ArrayTooLarge", e.InvalidBound = "InvalidBound", e.InsufficientAllowance = "InsufficientAllowance", e.DifferentMode = "DifferentMode", e.InvalidTransfer = "InvalidTransfer", e.InvalidDiscount = "InvalidDiscount", e.STOClosed = "STOClosed", e.CoinNotAllowed = "CoinNotAllowed", e.AlreadyExists = "AlreadyExists", e.NotFound = "NotFound", e.TickerExpired = "TickerExpired", e.UnknownNetwork = "UnknownNetwork", e.UnsupportedVersion = "UnsupportedVersion", e.InvalidLength = "InvalidLength";
  }(t.ErrorCode || (t.ErrorCode = {})), function (e) {
    e.V3_0_0 = "3.0.0", e.V3_1_0 = "3.1.0";
  }(t.ContractVersion || (t.ContractVersion = {}));
},
/*!**************************************!*\
  !*** ./node_modules/bn.js/lib/bn.js ***!
  \**************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (e) {
    !function (e, t) {
      "use strict";

      function r(e, t) {
        if (!e) throw new Error(t || "Assertion failed");
      }

      function n(e, t) {
        e.super_ = t;

        var a = function a() {};

        a.prototype = t.prototype, e.prototype = new a(), e.prototype.constructor = e;
      }

      function s(e, t, a) {
        if (s.isBN(e)) return e;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== e && ("le" !== t && "be" !== t || (a = t, t = 10), this._init(e || 0, t || 10, a || "be"));
      }

      var o;
      "object" == typeof e ? e.exports = s : t.BN = s, s.BN = s, s.wordSize = 26;

      try {
        o = a(
        /*! buffer */
        400).Buffer;
      } catch (e) {}

      function i(e, t, a) {
        for (var r = 0, n = Math.min(e.length, a), s = t; s < n; s++) {
          var o = e.charCodeAt(s) - 48;
          r <<= 4, r |= o >= 49 && o <= 54 ? o - 49 + 10 : o >= 17 && o <= 22 ? o - 17 + 10 : 15 & o;
        }

        return r;
      }

      function c(e, t, a, r) {
        for (var n = 0, s = Math.min(e.length, a), o = t; o < s; o++) {
          var i = e.charCodeAt(o) - 48;
          n *= r, n += i >= 49 ? i - 49 + 10 : i >= 17 ? i - 17 + 10 : i;
        }

        return n;
      }

      s.isBN = function (e) {
        return e instanceof s || null !== e && "object" == typeof e && e.constructor.wordSize === s.wordSize && Array.isArray(e.words);
      }, s.max = function (e, t) {
        return e.cmp(t) > 0 ? e : t;
      }, s.min = function (e, t) {
        return e.cmp(t) < 0 ? e : t;
      }, s.prototype._init = function (e, t, a) {
        if ("number" == typeof e) return this._initNumber(e, t, a);
        if ("object" == typeof e) return this._initArray(e, t, a);
        "hex" === t && (t = 16), r(t === (0 | t) && t >= 2 && t <= 36);
        var n = 0;
        "-" === (e = e.toString().replace(/\s+/g, ""))[0] && n++, 16 === t ? this._parseHex(e, n) : this._parseBase(e, t, n), "-" === e[0] && (this.negative = 1), this.strip(), "le" === a && this._initArray(this.toArray(), t, a);
      }, s.prototype._initNumber = function (e, t, a) {
        e < 0 && (this.negative = 1, e = -e), e < 67108864 ? (this.words = [67108863 & e], this.length = 1) : e < 4503599627370496 ? (this.words = [67108863 & e, e / 67108864 & 67108863], this.length = 2) : (r(e < 9007199254740992), this.words = [67108863 & e, e / 67108864 & 67108863, 1], this.length = 3), "le" === a && this._initArray(this.toArray(), t, a);
      }, s.prototype._initArray = function (e, t, a) {
        if (r("number" == typeof e.length), e.length <= 0) return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(e.length / 3), this.words = new Array(this.length);

        for (var n = 0; n < this.length; n++) {
          this.words[n] = 0;
        }

        var s,
            o,
            i = 0;
        if ("be" === a) for (n = e.length - 1, s = 0; n >= 0; n -= 3) {
          o = e[n] | e[n - 1] << 8 | e[n - 2] << 16, this.words[s] |= o << i & 67108863, this.words[s + 1] = o >>> 26 - i & 67108863, (i += 24) >= 26 && (i -= 26, s++);
        } else if ("le" === a) for (n = 0, s = 0; n < e.length; n += 3) {
          o = e[n] | e[n + 1] << 8 | e[n + 2] << 16, this.words[s] |= o << i & 67108863, this.words[s + 1] = o >>> 26 - i & 67108863, (i += 24) >= 26 && (i -= 26, s++);
        }
        return this.strip();
      }, s.prototype._parseHex = function (e, t) {
        this.length = Math.ceil((e.length - t) / 6), this.words = new Array(this.length);

        for (var a = 0; a < this.length; a++) {
          this.words[a] = 0;
        }

        var r,
            n,
            s = 0;

        for (a = e.length - 6, r = 0; a >= t; a -= 6) {
          n = i(e, a, a + 6), this.words[r] |= n << s & 67108863, this.words[r + 1] |= n >>> 26 - s & 4194303, (s += 24) >= 26 && (s -= 26, r++);
        }

        a + 6 !== t && (n = i(e, t, a + 6), this.words[r] |= n << s & 67108863, this.words[r + 1] |= n >>> 26 - s & 4194303), this.strip();
      }, s.prototype._parseBase = function (e, t, a) {
        this.words = [0], this.length = 1;

        for (var r = 0, n = 1; n <= 67108863; n *= t) {
          r++;
        }

        r--, n = n / t | 0;

        for (var s = e.length - a, o = s % r, i = Math.min(s, s - o) + a, u = 0, d = a; d < i; d += r) {
          u = c(e, d, d + r, t), this.imuln(n), this.words[0] + u < 67108864 ? this.words[0] += u : this._iaddn(u);
        }

        if (0 !== o) {
          var f = 1;

          for (u = c(e, d, e.length, t), d = 0; d < o; d++) {
            f *= t;
          }

          this.imuln(f), this.words[0] + u < 67108864 ? this.words[0] += u : this._iaddn(u);
        }
      }, s.prototype.copy = function (e) {
        e.words = new Array(this.length);

        for (var t = 0; t < this.length; t++) {
          e.words[t] = this.words[t];
        }

        e.length = this.length, e.negative = this.negative, e.red = this.red;
      }, s.prototype.clone = function () {
        var e = new s(null);
        return this.copy(e), e;
      }, s.prototype._expand = function (e) {
        for (; this.length < e;) {
          this.words[this.length++] = 0;
        }

        return this;
      }, s.prototype.strip = function () {
        for (; this.length > 1 && 0 === this.words[this.length - 1];) {
          this.length--;
        }

        return this._normSign();
      }, s.prototype._normSign = function () {
        return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
      }, s.prototype.inspect = function () {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var u = ["", "0", "00", "000", "0000", "00000", "000000", "0000000", "00000000", "000000000", "0000000000", "00000000000", "000000000000", "0000000000000", "00000000000000", "000000000000000", "0000000000000000", "00000000000000000", "000000000000000000", "0000000000000000000", "00000000000000000000", "000000000000000000000", "0000000000000000000000", "00000000000000000000000", "000000000000000000000000", "0000000000000000000000000"],
          d = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
          f = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];

      function l(e, t, a) {
        a.negative = t.negative ^ e.negative;
        var r = e.length + t.length | 0;
        a.length = r, r = r - 1 | 0;
        var n = 0 | e.words[0],
            s = 0 | t.words[0],
            o = n * s,
            i = 67108863 & o,
            c = o / 67108864 | 0;
        a.words[0] = i;

        for (var u = 1; u < r; u++) {
          for (var d = c >>> 26, f = 67108863 & c, l = Math.min(u, t.length - 1), h = Math.max(0, u - e.length + 1); h <= l; h++) {
            var p = u - h | 0;
            d += (o = (n = 0 | e.words[p]) * (s = 0 | t.words[h]) + f) / 67108864 | 0, f = 67108863 & o;
          }

          a.words[u] = 0 | f, c = 0 | d;
        }

        return 0 !== c ? a.words[u] = 0 | c : a.length--, a.strip();
      }

      s.prototype.toString = function (e, t) {
        var a;

        if (t = 0 | t || 1, 16 === (e = e || 10) || "hex" === e) {
          a = "";

          for (var n = 0, s = 0, o = 0; o < this.length; o++) {
            var i = this.words[o],
                c = (16777215 & (i << n | s)).toString(16);
            a = 0 !== (s = i >>> 24 - n & 16777215) || o !== this.length - 1 ? u[6 - c.length] + c + a : c + a, (n += 2) >= 26 && (n -= 26, o--);
          }

          for (0 !== s && (a = s.toString(16) + a); a.length % t != 0;) {
            a = "0" + a;
          }

          return 0 !== this.negative && (a = "-" + a), a;
        }

        if (e === (0 | e) && e >= 2 && e <= 36) {
          var l = d[e],
              h = f[e];
          a = "";
          var p = this.clone();

          for (p.negative = 0; !p.isZero();) {
            var b = p.modn(h).toString(e);
            a = (p = p.idivn(h)).isZero() ? b + a : u[l - b.length] + b + a;
          }

          for (this.isZero() && (a = "0" + a); a.length % t != 0;) {
            a = "0" + a;
          }

          return 0 !== this.negative && (a = "-" + a), a;
        }

        r(!1, "Base should be between 2 and 36");
      }, s.prototype.toNumber = function () {
        var e = this.words[0];
        return 2 === this.length ? e += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? e += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && r(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -e : e;
      }, s.prototype.toJSON = function () {
        return this.toString(16);
      }, s.prototype.toBuffer = function (e, t) {
        return r(void 0 !== o), this.toArrayLike(o, e, t);
      }, s.prototype.toArray = function (e, t) {
        return this.toArrayLike(Array, e, t);
      }, s.prototype.toArrayLike = function (e, t, a) {
        var n = this.byteLength(),
            s = a || Math.max(1, n);
        r(n <= s, "byte array longer than desired length"), r(s > 0, "Requested array length <= 0"), this.strip();
        var o,
            i,
            c = "le" === t,
            u = new e(s),
            d = this.clone();

        if (c) {
          for (i = 0; !d.isZero(); i++) {
            o = d.andln(255), d.iushrn(8), u[i] = o;
          }

          for (; i < s; i++) {
            u[i] = 0;
          }
        } else {
          for (i = 0; i < s - n; i++) {
            u[i] = 0;
          }

          for (i = 0; !d.isZero(); i++) {
            o = d.andln(255), d.iushrn(8), u[s - i - 1] = o;
          }
        }

        return u;
      }, Math.clz32 ? s.prototype._countBits = function (e) {
        return 32 - Math.clz32(e);
      } : s.prototype._countBits = function (e) {
        var t = e,
            a = 0;
        return t >= 4096 && (a += 13, t >>>= 13), t >= 64 && (a += 7, t >>>= 7), t >= 8 && (a += 4, t >>>= 4), t >= 2 && (a += 2, t >>>= 2), a + t;
      }, s.prototype._zeroBits = function (e) {
        if (0 === e) return 26;
        var t = e,
            a = 0;
        return 0 == (8191 & t) && (a += 13, t >>>= 13), 0 == (127 & t) && (a += 7, t >>>= 7), 0 == (15 & t) && (a += 4, t >>>= 4), 0 == (3 & t) && (a += 2, t >>>= 2), 0 == (1 & t) && a++, a;
      }, s.prototype.bitLength = function () {
        var e = this.words[this.length - 1],
            t = this._countBits(e);

        return 26 * (this.length - 1) + t;
      }, s.prototype.zeroBits = function () {
        if (this.isZero()) return 0;

        for (var e = 0, t = 0; t < this.length; t++) {
          var a = this._zeroBits(this.words[t]);

          if (e += a, 26 !== a) break;
        }

        return e;
      }, s.prototype.byteLength = function () {
        return Math.ceil(this.bitLength() / 8);
      }, s.prototype.toTwos = function (e) {
        return 0 !== this.negative ? this.abs().inotn(e).iaddn(1) : this.clone();
      }, s.prototype.fromTwos = function (e) {
        return this.testn(e - 1) ? this.notn(e).iaddn(1).ineg() : this.clone();
      }, s.prototype.isNeg = function () {
        return 0 !== this.negative;
      }, s.prototype.neg = function () {
        return this.clone().ineg();
      }, s.prototype.ineg = function () {
        return this.isZero() || (this.negative ^= 1), this;
      }, s.prototype.iuor = function (e) {
        for (; this.length < e.length;) {
          this.words[this.length++] = 0;
        }

        for (var t = 0; t < e.length; t++) {
          this.words[t] = this.words[t] | e.words[t];
        }

        return this.strip();
      }, s.prototype.ior = function (e) {
        return r(0 == (this.negative | e.negative)), this.iuor(e);
      }, s.prototype.or = function (e) {
        return this.length > e.length ? this.clone().ior(e) : e.clone().ior(this);
      }, s.prototype.uor = function (e) {
        return this.length > e.length ? this.clone().iuor(e) : e.clone().iuor(this);
      }, s.prototype.iuand = function (e) {
        var t;
        t = this.length > e.length ? e : this;

        for (var a = 0; a < t.length; a++) {
          this.words[a] = this.words[a] & e.words[a];
        }

        return this.length = t.length, this.strip();
      }, s.prototype.iand = function (e) {
        return r(0 == (this.negative | e.negative)), this.iuand(e);
      }, s.prototype.and = function (e) {
        return this.length > e.length ? this.clone().iand(e) : e.clone().iand(this);
      }, s.prototype.uand = function (e) {
        return this.length > e.length ? this.clone().iuand(e) : e.clone().iuand(this);
      }, s.prototype.iuxor = function (e) {
        var t, a;
        this.length > e.length ? (t = this, a = e) : (t = e, a = this);

        for (var r = 0; r < a.length; r++) {
          this.words[r] = t.words[r] ^ a.words[r];
        }

        if (this !== t) for (; r < t.length; r++) {
          this.words[r] = t.words[r];
        }
        return this.length = t.length, this.strip();
      }, s.prototype.ixor = function (e) {
        return r(0 == (this.negative | e.negative)), this.iuxor(e);
      }, s.prototype.xor = function (e) {
        return this.length > e.length ? this.clone().ixor(e) : e.clone().ixor(this);
      }, s.prototype.uxor = function (e) {
        return this.length > e.length ? this.clone().iuxor(e) : e.clone().iuxor(this);
      }, s.prototype.inotn = function (e) {
        r("number" == typeof e && e >= 0);
        var t = 0 | Math.ceil(e / 26),
            a = e % 26;
        this._expand(t), a > 0 && t--;

        for (var n = 0; n < t; n++) {
          this.words[n] = 67108863 & ~this.words[n];
        }

        return a > 0 && (this.words[n] = ~this.words[n] & 67108863 >> 26 - a), this.strip();
      }, s.prototype.notn = function (e) {
        return this.clone().inotn(e);
      }, s.prototype.setn = function (e, t) {
        r("number" == typeof e && e >= 0);
        var a = e / 26 | 0,
            n = e % 26;
        return this._expand(a + 1), this.words[a] = t ? this.words[a] | 1 << n : this.words[a] & ~(1 << n), this.strip();
      }, s.prototype.iadd = function (e) {
        var t, a, r;
        if (0 !== this.negative && 0 === e.negative) return this.negative = 0, t = this.isub(e), this.negative ^= 1, this._normSign();
        if (0 === this.negative && 0 !== e.negative) return e.negative = 0, t = this.isub(e), e.negative = 1, t._normSign();
        this.length > e.length ? (a = this, r = e) : (a = e, r = this);

        for (var n = 0, s = 0; s < r.length; s++) {
          t = (0 | a.words[s]) + (0 | r.words[s]) + n, this.words[s] = 67108863 & t, n = t >>> 26;
        }

        for (; 0 !== n && s < a.length; s++) {
          t = (0 | a.words[s]) + n, this.words[s] = 67108863 & t, n = t >>> 26;
        }

        if (this.length = a.length, 0 !== n) this.words[this.length] = n, this.length++;else if (a !== this) for (; s < a.length; s++) {
          this.words[s] = a.words[s];
        }
        return this;
      }, s.prototype.add = function (e) {
        var t;
        return 0 !== e.negative && 0 === this.negative ? (e.negative = 0, t = this.sub(e), e.negative ^= 1, t) : 0 === e.negative && 0 !== this.negative ? (this.negative = 0, t = e.sub(this), this.negative = 1, t) : this.length > e.length ? this.clone().iadd(e) : e.clone().iadd(this);
      }, s.prototype.isub = function (e) {
        if (0 !== e.negative) {
          e.negative = 0;
          var t = this.iadd(e);
          return e.negative = 1, t._normSign();
        }

        if (0 !== this.negative) return this.negative = 0, this.iadd(e), this.negative = 1, this._normSign();
        var a,
            r,
            n = this.cmp(e);
        if (0 === n) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        n > 0 ? (a = this, r = e) : (a = e, r = this);

        for (var s = 0, o = 0; o < r.length; o++) {
          s = (t = (0 | a.words[o]) - (0 | r.words[o]) + s) >> 26, this.words[o] = 67108863 & t;
        }

        for (; 0 !== s && o < a.length; o++) {
          s = (t = (0 | a.words[o]) + s) >> 26, this.words[o] = 67108863 & t;
        }

        if (0 === s && o < a.length && a !== this) for (; o < a.length; o++) {
          this.words[o] = a.words[o];
        }
        return this.length = Math.max(this.length, o), a !== this && (this.negative = 1), this.strip();
      }, s.prototype.sub = function (e) {
        return this.clone().isub(e);
      };

      var h = function h(e, t, a) {
        var r,
            n,
            s,
            o = e.words,
            i = t.words,
            c = a.words,
            u = 0,
            d = 0 | o[0],
            f = 8191 & d,
            l = d >>> 13,
            h = 0 | o[1],
            p = 8191 & h,
            b = h >>> 13,
            m = 0 | o[2],
            y = 8191 & m,
            v = m >>> 13,
            _ = 0 | o[3],
            g = 8191 & _,
            A = _ >>> 13,
            w = 0 | o[4],
            T = 8191 & w,
            x = w >>> 13,
            D = 0 | o[5],
            C = 8191 & D,
            S = D >>> 13,
            E = 0 | o[6],
            B = 8191 & E,
            k = E >>> 13,
            R = 0 | o[7],
            W = 8191 & R,
            I = R >>> 13,
            N = 0 | o[8],
            M = 8191 & N,
            P = N >>> 13,
            L = 0 | o[9],
            O = 8191 & L,
            F = L >>> 13,
            j = 0 | i[0],
            G = 8191 & j,
            V = j >>> 13,
            U = 0 | i[1],
            H = 8191 & U,
            z = U >>> 13,
            K = 0 | i[2],
            q = 8191 & K,
            Y = K >>> 13,
            Z = 0 | i[3],
            J = 8191 & Z,
            X = Z >>> 13,
            $ = 0 | i[4],
            Q = 8191 & $,
            ee = $ >>> 13,
            te = 0 | i[5],
            ae = 8191 & te,
            re = te >>> 13,
            ne = 0 | i[6],
            se = 8191 & ne,
            oe = ne >>> 13,
            ie = 0 | i[7],
            ce = 8191 & ie,
            ue = ie >>> 13,
            de = 0 | i[8],
            fe = 8191 & de,
            le = de >>> 13,
            he = 0 | i[9],
            pe = 8191 & he,
            be = he >>> 13;

        a.negative = e.negative ^ t.negative, a.length = 19;
        var me = (u + (r = Math.imul(f, G)) | 0) + ((8191 & (n = (n = Math.imul(f, V)) + Math.imul(l, G) | 0)) << 13) | 0;
        u = ((s = Math.imul(l, V)) + (n >>> 13) | 0) + (me >>> 26) | 0, me &= 67108863, r = Math.imul(p, G), n = (n = Math.imul(p, V)) + Math.imul(b, G) | 0, s = Math.imul(b, V);
        var ye = (u + (r = r + Math.imul(f, H) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(f, z) | 0) + Math.imul(l, H) | 0)) << 13) | 0;
        u = ((s = s + Math.imul(l, z) | 0) + (n >>> 13) | 0) + (ye >>> 26) | 0, ye &= 67108863, r = Math.imul(y, G), n = (n = Math.imul(y, V)) + Math.imul(v, G) | 0, s = Math.imul(v, V), r = r + Math.imul(p, H) | 0, n = (n = n + Math.imul(p, z) | 0) + Math.imul(b, H) | 0, s = s + Math.imul(b, z) | 0;
        var ve = (u + (r = r + Math.imul(f, q) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(f, Y) | 0) + Math.imul(l, q) | 0)) << 13) | 0;
        u = ((s = s + Math.imul(l, Y) | 0) + (n >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, r = Math.imul(g, G), n = (n = Math.imul(g, V)) + Math.imul(A, G) | 0, s = Math.imul(A, V), r = r + Math.imul(y, H) | 0, n = (n = n + Math.imul(y, z) | 0) + Math.imul(v, H) | 0, s = s + Math.imul(v, z) | 0, r = r + Math.imul(p, q) | 0, n = (n = n + Math.imul(p, Y) | 0) + Math.imul(b, q) | 0, s = s + Math.imul(b, Y) | 0;

        var _e = (u + (r = r + Math.imul(f, J) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(f, X) | 0) + Math.imul(l, J) | 0)) << 13) | 0;

        u = ((s = s + Math.imul(l, X) | 0) + (n >>> 13) | 0) + (_e >>> 26) | 0, _e &= 67108863, r = Math.imul(T, G), n = (n = Math.imul(T, V)) + Math.imul(x, G) | 0, s = Math.imul(x, V), r = r + Math.imul(g, H) | 0, n = (n = n + Math.imul(g, z) | 0) + Math.imul(A, H) | 0, s = s + Math.imul(A, z) | 0, r = r + Math.imul(y, q) | 0, n = (n = n + Math.imul(y, Y) | 0) + Math.imul(v, q) | 0, s = s + Math.imul(v, Y) | 0, r = r + Math.imul(p, J) | 0, n = (n = n + Math.imul(p, X) | 0) + Math.imul(b, J) | 0, s = s + Math.imul(b, X) | 0;
        var ge = (u + (r = r + Math.imul(f, Q) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(f, ee) | 0) + Math.imul(l, Q) | 0)) << 13) | 0;
        u = ((s = s + Math.imul(l, ee) | 0) + (n >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, r = Math.imul(C, G), n = (n = Math.imul(C, V)) + Math.imul(S, G) | 0, s = Math.imul(S, V), r = r + Math.imul(T, H) | 0, n = (n = n + Math.imul(T, z) | 0) + Math.imul(x, H) | 0, s = s + Math.imul(x, z) | 0, r = r + Math.imul(g, q) | 0, n = (n = n + Math.imul(g, Y) | 0) + Math.imul(A, q) | 0, s = s + Math.imul(A, Y) | 0, r = r + Math.imul(y, J) | 0, n = (n = n + Math.imul(y, X) | 0) + Math.imul(v, J) | 0, s = s + Math.imul(v, X) | 0, r = r + Math.imul(p, Q) | 0, n = (n = n + Math.imul(p, ee) | 0) + Math.imul(b, Q) | 0, s = s + Math.imul(b, ee) | 0;
        var Ae = (u + (r = r + Math.imul(f, ae) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(f, re) | 0) + Math.imul(l, ae) | 0)) << 13) | 0;
        u = ((s = s + Math.imul(l, re) | 0) + (n >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, r = Math.imul(B, G), n = (n = Math.imul(B, V)) + Math.imul(k, G) | 0, s = Math.imul(k, V), r = r + Math.imul(C, H) | 0, n = (n = n + Math.imul(C, z) | 0) + Math.imul(S, H) | 0, s = s + Math.imul(S, z) | 0, r = r + Math.imul(T, q) | 0, n = (n = n + Math.imul(T, Y) | 0) + Math.imul(x, q) | 0, s = s + Math.imul(x, Y) | 0, r = r + Math.imul(g, J) | 0, n = (n = n + Math.imul(g, X) | 0) + Math.imul(A, J) | 0, s = s + Math.imul(A, X) | 0, r = r + Math.imul(y, Q) | 0, n = (n = n + Math.imul(y, ee) | 0) + Math.imul(v, Q) | 0, s = s + Math.imul(v, ee) | 0, r = r + Math.imul(p, ae) | 0, n = (n = n + Math.imul(p, re) | 0) + Math.imul(b, ae) | 0, s = s + Math.imul(b, re) | 0;
        var we = (u + (r = r + Math.imul(f, se) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(f, oe) | 0) + Math.imul(l, se) | 0)) << 13) | 0;
        u = ((s = s + Math.imul(l, oe) | 0) + (n >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, r = Math.imul(W, G), n = (n = Math.imul(W, V)) + Math.imul(I, G) | 0, s = Math.imul(I, V), r = r + Math.imul(B, H) | 0, n = (n = n + Math.imul(B, z) | 0) + Math.imul(k, H) | 0, s = s + Math.imul(k, z) | 0, r = r + Math.imul(C, q) | 0, n = (n = n + Math.imul(C, Y) | 0) + Math.imul(S, q) | 0, s = s + Math.imul(S, Y) | 0, r = r + Math.imul(T, J) | 0, n = (n = n + Math.imul(T, X) | 0) + Math.imul(x, J) | 0, s = s + Math.imul(x, X) | 0, r = r + Math.imul(g, Q) | 0, n = (n = n + Math.imul(g, ee) | 0) + Math.imul(A, Q) | 0, s = s + Math.imul(A, ee) | 0, r = r + Math.imul(y, ae) | 0, n = (n = n + Math.imul(y, re) | 0) + Math.imul(v, ae) | 0, s = s + Math.imul(v, re) | 0, r = r + Math.imul(p, se) | 0, n = (n = n + Math.imul(p, oe) | 0) + Math.imul(b, se) | 0, s = s + Math.imul(b, oe) | 0;
        var Te = (u + (r = r + Math.imul(f, ce) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(f, ue) | 0) + Math.imul(l, ce) | 0)) << 13) | 0;
        u = ((s = s + Math.imul(l, ue) | 0) + (n >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, r = Math.imul(M, G), n = (n = Math.imul(M, V)) + Math.imul(P, G) | 0, s = Math.imul(P, V), r = r + Math.imul(W, H) | 0, n = (n = n + Math.imul(W, z) | 0) + Math.imul(I, H) | 0, s = s + Math.imul(I, z) | 0, r = r + Math.imul(B, q) | 0, n = (n = n + Math.imul(B, Y) | 0) + Math.imul(k, q) | 0, s = s + Math.imul(k, Y) | 0, r = r + Math.imul(C, J) | 0, n = (n = n + Math.imul(C, X) | 0) + Math.imul(S, J) | 0, s = s + Math.imul(S, X) | 0, r = r + Math.imul(T, Q) | 0, n = (n = n + Math.imul(T, ee) | 0) + Math.imul(x, Q) | 0, s = s + Math.imul(x, ee) | 0, r = r + Math.imul(g, ae) | 0, n = (n = n + Math.imul(g, re) | 0) + Math.imul(A, ae) | 0, s = s + Math.imul(A, re) | 0, r = r + Math.imul(y, se) | 0, n = (n = n + Math.imul(y, oe) | 0) + Math.imul(v, se) | 0, s = s + Math.imul(v, oe) | 0, r = r + Math.imul(p, ce) | 0, n = (n = n + Math.imul(p, ue) | 0) + Math.imul(b, ce) | 0, s = s + Math.imul(b, ue) | 0;
        var xe = (u + (r = r + Math.imul(f, fe) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(f, le) | 0) + Math.imul(l, fe) | 0)) << 13) | 0;
        u = ((s = s + Math.imul(l, le) | 0) + (n >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, r = Math.imul(O, G), n = (n = Math.imul(O, V)) + Math.imul(F, G) | 0, s = Math.imul(F, V), r = r + Math.imul(M, H) | 0, n = (n = n + Math.imul(M, z) | 0) + Math.imul(P, H) | 0, s = s + Math.imul(P, z) | 0, r = r + Math.imul(W, q) | 0, n = (n = n + Math.imul(W, Y) | 0) + Math.imul(I, q) | 0, s = s + Math.imul(I, Y) | 0, r = r + Math.imul(B, J) | 0, n = (n = n + Math.imul(B, X) | 0) + Math.imul(k, J) | 0, s = s + Math.imul(k, X) | 0, r = r + Math.imul(C, Q) | 0, n = (n = n + Math.imul(C, ee) | 0) + Math.imul(S, Q) | 0, s = s + Math.imul(S, ee) | 0, r = r + Math.imul(T, ae) | 0, n = (n = n + Math.imul(T, re) | 0) + Math.imul(x, ae) | 0, s = s + Math.imul(x, re) | 0, r = r + Math.imul(g, se) | 0, n = (n = n + Math.imul(g, oe) | 0) + Math.imul(A, se) | 0, s = s + Math.imul(A, oe) | 0, r = r + Math.imul(y, ce) | 0, n = (n = n + Math.imul(y, ue) | 0) + Math.imul(v, ce) | 0, s = s + Math.imul(v, ue) | 0, r = r + Math.imul(p, fe) | 0, n = (n = n + Math.imul(p, le) | 0) + Math.imul(b, fe) | 0, s = s + Math.imul(b, le) | 0;
        var De = (u + (r = r + Math.imul(f, pe) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(f, be) | 0) + Math.imul(l, pe) | 0)) << 13) | 0;
        u = ((s = s + Math.imul(l, be) | 0) + (n >>> 13) | 0) + (De >>> 26) | 0, De &= 67108863, r = Math.imul(O, H), n = (n = Math.imul(O, z)) + Math.imul(F, H) | 0, s = Math.imul(F, z), r = r + Math.imul(M, q) | 0, n = (n = n + Math.imul(M, Y) | 0) + Math.imul(P, q) | 0, s = s + Math.imul(P, Y) | 0, r = r + Math.imul(W, J) | 0, n = (n = n + Math.imul(W, X) | 0) + Math.imul(I, J) | 0, s = s + Math.imul(I, X) | 0, r = r + Math.imul(B, Q) | 0, n = (n = n + Math.imul(B, ee) | 0) + Math.imul(k, Q) | 0, s = s + Math.imul(k, ee) | 0, r = r + Math.imul(C, ae) | 0, n = (n = n + Math.imul(C, re) | 0) + Math.imul(S, ae) | 0, s = s + Math.imul(S, re) | 0, r = r + Math.imul(T, se) | 0, n = (n = n + Math.imul(T, oe) | 0) + Math.imul(x, se) | 0, s = s + Math.imul(x, oe) | 0, r = r + Math.imul(g, ce) | 0, n = (n = n + Math.imul(g, ue) | 0) + Math.imul(A, ce) | 0, s = s + Math.imul(A, ue) | 0, r = r + Math.imul(y, fe) | 0, n = (n = n + Math.imul(y, le) | 0) + Math.imul(v, fe) | 0, s = s + Math.imul(v, le) | 0;
        var Ce = (u + (r = r + Math.imul(p, pe) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(p, be) | 0) + Math.imul(b, pe) | 0)) << 13) | 0;
        u = ((s = s + Math.imul(b, be) | 0) + (n >>> 13) | 0) + (Ce >>> 26) | 0, Ce &= 67108863, r = Math.imul(O, q), n = (n = Math.imul(O, Y)) + Math.imul(F, q) | 0, s = Math.imul(F, Y), r = r + Math.imul(M, J) | 0, n = (n = n + Math.imul(M, X) | 0) + Math.imul(P, J) | 0, s = s + Math.imul(P, X) | 0, r = r + Math.imul(W, Q) | 0, n = (n = n + Math.imul(W, ee) | 0) + Math.imul(I, Q) | 0, s = s + Math.imul(I, ee) | 0, r = r + Math.imul(B, ae) | 0, n = (n = n + Math.imul(B, re) | 0) + Math.imul(k, ae) | 0, s = s + Math.imul(k, re) | 0, r = r + Math.imul(C, se) | 0, n = (n = n + Math.imul(C, oe) | 0) + Math.imul(S, se) | 0, s = s + Math.imul(S, oe) | 0, r = r + Math.imul(T, ce) | 0, n = (n = n + Math.imul(T, ue) | 0) + Math.imul(x, ce) | 0, s = s + Math.imul(x, ue) | 0, r = r + Math.imul(g, fe) | 0, n = (n = n + Math.imul(g, le) | 0) + Math.imul(A, fe) | 0, s = s + Math.imul(A, le) | 0;
        var Se = (u + (r = r + Math.imul(y, pe) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(y, be) | 0) + Math.imul(v, pe) | 0)) << 13) | 0;
        u = ((s = s + Math.imul(v, be) | 0) + (n >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, r = Math.imul(O, J), n = (n = Math.imul(O, X)) + Math.imul(F, J) | 0, s = Math.imul(F, X), r = r + Math.imul(M, Q) | 0, n = (n = n + Math.imul(M, ee) | 0) + Math.imul(P, Q) | 0, s = s + Math.imul(P, ee) | 0, r = r + Math.imul(W, ae) | 0, n = (n = n + Math.imul(W, re) | 0) + Math.imul(I, ae) | 0, s = s + Math.imul(I, re) | 0, r = r + Math.imul(B, se) | 0, n = (n = n + Math.imul(B, oe) | 0) + Math.imul(k, se) | 0, s = s + Math.imul(k, oe) | 0, r = r + Math.imul(C, ce) | 0, n = (n = n + Math.imul(C, ue) | 0) + Math.imul(S, ce) | 0, s = s + Math.imul(S, ue) | 0, r = r + Math.imul(T, fe) | 0, n = (n = n + Math.imul(T, le) | 0) + Math.imul(x, fe) | 0, s = s + Math.imul(x, le) | 0;
        var Ee = (u + (r = r + Math.imul(g, pe) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(g, be) | 0) + Math.imul(A, pe) | 0)) << 13) | 0;
        u = ((s = s + Math.imul(A, be) | 0) + (n >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, r = Math.imul(O, Q), n = (n = Math.imul(O, ee)) + Math.imul(F, Q) | 0, s = Math.imul(F, ee), r = r + Math.imul(M, ae) | 0, n = (n = n + Math.imul(M, re) | 0) + Math.imul(P, ae) | 0, s = s + Math.imul(P, re) | 0, r = r + Math.imul(W, se) | 0, n = (n = n + Math.imul(W, oe) | 0) + Math.imul(I, se) | 0, s = s + Math.imul(I, oe) | 0, r = r + Math.imul(B, ce) | 0, n = (n = n + Math.imul(B, ue) | 0) + Math.imul(k, ce) | 0, s = s + Math.imul(k, ue) | 0, r = r + Math.imul(C, fe) | 0, n = (n = n + Math.imul(C, le) | 0) + Math.imul(S, fe) | 0, s = s + Math.imul(S, le) | 0;
        var Be = (u + (r = r + Math.imul(T, pe) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(T, be) | 0) + Math.imul(x, pe) | 0)) << 13) | 0;
        u = ((s = s + Math.imul(x, be) | 0) + (n >>> 13) | 0) + (Be >>> 26) | 0, Be &= 67108863, r = Math.imul(O, ae), n = (n = Math.imul(O, re)) + Math.imul(F, ae) | 0, s = Math.imul(F, re), r = r + Math.imul(M, se) | 0, n = (n = n + Math.imul(M, oe) | 0) + Math.imul(P, se) | 0, s = s + Math.imul(P, oe) | 0, r = r + Math.imul(W, ce) | 0, n = (n = n + Math.imul(W, ue) | 0) + Math.imul(I, ce) | 0, s = s + Math.imul(I, ue) | 0, r = r + Math.imul(B, fe) | 0, n = (n = n + Math.imul(B, le) | 0) + Math.imul(k, fe) | 0, s = s + Math.imul(k, le) | 0;
        var ke = (u + (r = r + Math.imul(C, pe) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(C, be) | 0) + Math.imul(S, pe) | 0)) << 13) | 0;
        u = ((s = s + Math.imul(S, be) | 0) + (n >>> 13) | 0) + (ke >>> 26) | 0, ke &= 67108863, r = Math.imul(O, se), n = (n = Math.imul(O, oe)) + Math.imul(F, se) | 0, s = Math.imul(F, oe), r = r + Math.imul(M, ce) | 0, n = (n = n + Math.imul(M, ue) | 0) + Math.imul(P, ce) | 0, s = s + Math.imul(P, ue) | 0, r = r + Math.imul(W, fe) | 0, n = (n = n + Math.imul(W, le) | 0) + Math.imul(I, fe) | 0, s = s + Math.imul(I, le) | 0;
        var Re = (u + (r = r + Math.imul(B, pe) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(B, be) | 0) + Math.imul(k, pe) | 0)) << 13) | 0;
        u = ((s = s + Math.imul(k, be) | 0) + (n >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, r = Math.imul(O, ce), n = (n = Math.imul(O, ue)) + Math.imul(F, ce) | 0, s = Math.imul(F, ue), r = r + Math.imul(M, fe) | 0, n = (n = n + Math.imul(M, le) | 0) + Math.imul(P, fe) | 0, s = s + Math.imul(P, le) | 0;
        var We = (u + (r = r + Math.imul(W, pe) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(W, be) | 0) + Math.imul(I, pe) | 0)) << 13) | 0;
        u = ((s = s + Math.imul(I, be) | 0) + (n >>> 13) | 0) + (We >>> 26) | 0, We &= 67108863, r = Math.imul(O, fe), n = (n = Math.imul(O, le)) + Math.imul(F, fe) | 0, s = Math.imul(F, le);
        var Ie = (u + (r = r + Math.imul(M, pe) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(M, be) | 0) + Math.imul(P, pe) | 0)) << 13) | 0;
        u = ((s = s + Math.imul(P, be) | 0) + (n >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863;
        var Ne = (u + (r = Math.imul(O, pe)) | 0) + ((8191 & (n = (n = Math.imul(O, be)) + Math.imul(F, pe) | 0)) << 13) | 0;
        return u = ((s = Math.imul(F, be)) + (n >>> 13) | 0) + (Ne >>> 26) | 0, Ne &= 67108863, c[0] = me, c[1] = ye, c[2] = ve, c[3] = _e, c[4] = ge, c[5] = Ae, c[6] = we, c[7] = Te, c[8] = xe, c[9] = De, c[10] = Ce, c[11] = Se, c[12] = Ee, c[13] = Be, c[14] = ke, c[15] = Re, c[16] = We, c[17] = Ie, c[18] = Ne, 0 !== u && (c[19] = u, a.length++), a;
      };

      function p(e, t, a) {
        return new b().mulp(e, t, a);
      }

      function b(e, t) {
        this.x = e, this.y = t;
      }

      Math.imul || (h = l), s.prototype.mulTo = function (e, t) {
        var a = this.length + e.length;
        return 10 === this.length && 10 === e.length ? h(this, e, t) : a < 63 ? l(this, e, t) : a < 1024 ? function (e, t, a) {
          a.negative = t.negative ^ e.negative, a.length = e.length + t.length;

          for (var r = 0, n = 0, s = 0; s < a.length - 1; s++) {
            var o = n;
            n = 0;

            for (var i = 67108863 & r, c = Math.min(s, t.length - 1), u = Math.max(0, s - e.length + 1); u <= c; u++) {
              var d = s - u,
                  f = (0 | e.words[d]) * (0 | t.words[u]),
                  l = 67108863 & f;
              i = 67108863 & (l = l + i | 0), n += (o = (o = o + (f / 67108864 | 0) | 0) + (l >>> 26) | 0) >>> 26, o &= 67108863;
            }

            a.words[s] = i, r = o, o = n;
          }

          return 0 !== r ? a.words[s] = r : a.length--, a.strip();
        }(this, e, t) : p(this, e, t);
      }, b.prototype.makeRBT = function (e) {
        for (var t = new Array(e), a = s.prototype._countBits(e) - 1, r = 0; r < e; r++) {
          t[r] = this.revBin(r, a, e);
        }

        return t;
      }, b.prototype.revBin = function (e, t, a) {
        if (0 === e || e === a - 1) return e;

        for (var r = 0, n = 0; n < t; n++) {
          r |= (1 & e) << t - n - 1, e >>= 1;
        }

        return r;
      }, b.prototype.permute = function (e, t, a, r, n, s) {
        for (var o = 0; o < s; o++) {
          r[o] = t[e[o]], n[o] = a[e[o]];
        }
      }, b.prototype.transform = function (e, t, a, r, n, s) {
        this.permute(s, e, t, a, r, n);

        for (var o = 1; o < n; o <<= 1) {
          for (var i = o << 1, c = Math.cos(2 * Math.PI / i), u = Math.sin(2 * Math.PI / i), d = 0; d < n; d += i) {
            for (var f = c, l = u, h = 0; h < o; h++) {
              var p = a[d + h],
                  b = r[d + h],
                  m = a[d + h + o],
                  y = r[d + h + o],
                  v = f * m - l * y;
              y = f * y + l * m, m = v, a[d + h] = p + m, r[d + h] = b + y, a[d + h + o] = p - m, r[d + h + o] = b - y, h !== i && (v = c * f - u * l, l = c * l + u * f, f = v);
            }
          }
        }
      }, b.prototype.guessLen13b = function (e, t) {
        var a = 1 | Math.max(t, e),
            r = 1 & a,
            n = 0;

        for (a = a / 2 | 0; a; a >>>= 1) {
          n++;
        }

        return 1 << n + 1 + r;
      }, b.prototype.conjugate = function (e, t, a) {
        if (!(a <= 1)) for (var r = 0; r < a / 2; r++) {
          var n = e[r];
          e[r] = e[a - r - 1], e[a - r - 1] = n, n = t[r], t[r] = -t[a - r - 1], t[a - r - 1] = -n;
        }
      }, b.prototype.normalize13b = function (e, t) {
        for (var a = 0, r = 0; r < t / 2; r++) {
          var n = 8192 * Math.round(e[2 * r + 1] / t) + Math.round(e[2 * r] / t) + a;
          e[r] = 67108863 & n, a = n < 67108864 ? 0 : n / 67108864 | 0;
        }

        return e;
      }, b.prototype.convert13b = function (e, t, a, n) {
        for (var s = 0, o = 0; o < t; o++) {
          s += 0 | e[o], a[2 * o] = 8191 & s, s >>>= 13, a[2 * o + 1] = 8191 & s, s >>>= 13;
        }

        for (o = 2 * t; o < n; ++o) {
          a[o] = 0;
        }

        r(0 === s), r(0 == (-8192 & s));
      }, b.prototype.stub = function (e) {
        for (var t = new Array(e), a = 0; a < e; a++) {
          t[a] = 0;
        }

        return t;
      }, b.prototype.mulp = function (e, t, a) {
        var r = 2 * this.guessLen13b(e.length, t.length),
            n = this.makeRBT(r),
            s = this.stub(r),
            o = new Array(r),
            i = new Array(r),
            c = new Array(r),
            u = new Array(r),
            d = new Array(r),
            f = new Array(r),
            l = a.words;
        l.length = r, this.convert13b(e.words, e.length, o, r), this.convert13b(t.words, t.length, u, r), this.transform(o, s, i, c, r, n), this.transform(u, s, d, f, r, n);

        for (var h = 0; h < r; h++) {
          var p = i[h] * d[h] - c[h] * f[h];
          c[h] = i[h] * f[h] + c[h] * d[h], i[h] = p;
        }

        return this.conjugate(i, c, r), this.transform(i, c, l, s, r, n), this.conjugate(l, s, r), this.normalize13b(l, r), a.negative = e.negative ^ t.negative, a.length = e.length + t.length, a.strip();
      }, s.prototype.mul = function (e) {
        var t = new s(null);
        return t.words = new Array(this.length + e.length), this.mulTo(e, t);
      }, s.prototype.mulf = function (e) {
        var t = new s(null);
        return t.words = new Array(this.length + e.length), p(this, e, t);
      }, s.prototype.imul = function (e) {
        return this.clone().mulTo(e, this);
      }, s.prototype.imuln = function (e) {
        r("number" == typeof e), r(e < 67108864);

        for (var t = 0, a = 0; a < this.length; a++) {
          var n = (0 | this.words[a]) * e,
              s = (67108863 & n) + (67108863 & t);
          t >>= 26, t += n / 67108864 | 0, t += s >>> 26, this.words[a] = 67108863 & s;
        }

        return 0 !== t && (this.words[a] = t, this.length++), this;
      }, s.prototype.muln = function (e) {
        return this.clone().imuln(e);
      }, s.prototype.sqr = function () {
        return this.mul(this);
      }, s.prototype.isqr = function () {
        return this.imul(this.clone());
      }, s.prototype.pow = function (e) {
        var t = function (e) {
          for (var t = new Array(e.bitLength()), a = 0; a < t.length; a++) {
            var r = a / 26 | 0,
                n = a % 26;
            t[a] = (e.words[r] & 1 << n) >>> n;
          }

          return t;
        }(e);

        if (0 === t.length) return new s(1);

        for (var a = this, r = 0; r < t.length && 0 === t[r]; r++, a = a.sqr()) {
          ;
        }

        if (++r < t.length) for (var n = a.sqr(); r < t.length; r++, n = n.sqr()) {
          0 !== t[r] && (a = a.mul(n));
        }
        return a;
      }, s.prototype.iushln = function (e) {
        r("number" == typeof e && e >= 0);
        var t,
            a = e % 26,
            n = (e - a) / 26,
            s = 67108863 >>> 26 - a << 26 - a;

        if (0 !== a) {
          var o = 0;

          for (t = 0; t < this.length; t++) {
            var i = this.words[t] & s,
                c = (0 | this.words[t]) - i << a;
            this.words[t] = c | o, o = i >>> 26 - a;
          }

          o && (this.words[t] = o, this.length++);
        }

        if (0 !== n) {
          for (t = this.length - 1; t >= 0; t--) {
            this.words[t + n] = this.words[t];
          }

          for (t = 0; t < n; t++) {
            this.words[t] = 0;
          }

          this.length += n;
        }

        return this.strip();
      }, s.prototype.ishln = function (e) {
        return r(0 === this.negative), this.iushln(e);
      }, s.prototype.iushrn = function (e, t, a) {
        var n;
        r("number" == typeof e && e >= 0), n = t ? (t - t % 26) / 26 : 0;
        var s = e % 26,
            o = Math.min((e - s) / 26, this.length),
            i = 67108863 ^ 67108863 >>> s << s,
            c = a;

        if (n -= o, n = Math.max(0, n), c) {
          for (var u = 0; u < o; u++) {
            c.words[u] = this.words[u];
          }

          c.length = o;
        }

        if (0 === o) ;else if (this.length > o) for (this.length -= o, u = 0; u < this.length; u++) {
          this.words[u] = this.words[u + o];
        } else this.words[0] = 0, this.length = 1;
        var d = 0;

        for (u = this.length - 1; u >= 0 && (0 !== d || u >= n); u--) {
          var f = 0 | this.words[u];
          this.words[u] = d << 26 - s | f >>> s, d = f & i;
        }

        return c && 0 !== d && (c.words[c.length++] = d), 0 === this.length && (this.words[0] = 0, this.length = 1), this.strip();
      }, s.prototype.ishrn = function (e, t, a) {
        return r(0 === this.negative), this.iushrn(e, t, a);
      }, s.prototype.shln = function (e) {
        return this.clone().ishln(e);
      }, s.prototype.ushln = function (e) {
        return this.clone().iushln(e);
      }, s.prototype.shrn = function (e) {
        return this.clone().ishrn(e);
      }, s.prototype.ushrn = function (e) {
        return this.clone().iushrn(e);
      }, s.prototype.testn = function (e) {
        r("number" == typeof e && e >= 0);
        var t = e % 26,
            a = (e - t) / 26,
            n = 1 << t;
        return !(this.length <= a) && !!(this.words[a] & n);
      }, s.prototype.imaskn = function (e) {
        r("number" == typeof e && e >= 0);
        var t = e % 26,
            a = (e - t) / 26;
        if (r(0 === this.negative, "imaskn works only with positive numbers"), this.length <= a) return this;

        if (0 !== t && a++, this.length = Math.min(a, this.length), 0 !== t) {
          var n = 67108863 ^ 67108863 >>> t << t;
          this.words[this.length - 1] &= n;
        }

        return this.strip();
      }, s.prototype.maskn = function (e) {
        return this.clone().imaskn(e);
      }, s.prototype.iaddn = function (e) {
        return r("number" == typeof e), r(e < 67108864), e < 0 ? this.isubn(-e) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) < e ? (this.words[0] = e - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(e), this.negative = 1, this) : this._iaddn(e);
      }, s.prototype._iaddn = function (e) {
        this.words[0] += e;

        for (var t = 0; t < this.length && this.words[t] >= 67108864; t++) {
          this.words[t] -= 67108864, t === this.length - 1 ? this.words[t + 1] = 1 : this.words[t + 1]++;
        }

        return this.length = Math.max(this.length, t + 1), this;
      }, s.prototype.isubn = function (e) {
        if (r("number" == typeof e), r(e < 67108864), e < 0) return this.iaddn(-e);
        if (0 !== this.negative) return this.negative = 0, this.iaddn(e), this.negative = 1, this;
        if (this.words[0] -= e, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;else for (var t = 0; t < this.length && this.words[t] < 0; t++) {
          this.words[t] += 67108864, this.words[t + 1] -= 1;
        }
        return this.strip();
      }, s.prototype.addn = function (e) {
        return this.clone().iaddn(e);
      }, s.prototype.subn = function (e) {
        return this.clone().isubn(e);
      }, s.prototype.iabs = function () {
        return this.negative = 0, this;
      }, s.prototype.abs = function () {
        return this.clone().iabs();
      }, s.prototype._ishlnsubmul = function (e, t, a) {
        var n,
            s,
            o = e.length + a;

        this._expand(o);

        var i = 0;

        for (n = 0; n < e.length; n++) {
          s = (0 | this.words[n + a]) + i;
          var c = (0 | e.words[n]) * t;
          i = ((s -= 67108863 & c) >> 26) - (c / 67108864 | 0), this.words[n + a] = 67108863 & s;
        }

        for (; n < this.length - a; n++) {
          i = (s = (0 | this.words[n + a]) + i) >> 26, this.words[n + a] = 67108863 & s;
        }

        if (0 === i) return this.strip();

        for (r(-1 === i), i = 0, n = 0; n < this.length; n++) {
          i = (s = -(0 | this.words[n]) + i) >> 26, this.words[n] = 67108863 & s;
        }

        return this.negative = 1, this.strip();
      }, s.prototype._wordDiv = function (e, t) {
        var a = (this.length, e.length),
            r = this.clone(),
            n = e,
            o = 0 | n.words[n.length - 1];
        0 !== (a = 26 - this._countBits(o)) && (n = n.ushln(a), r.iushln(a), o = 0 | n.words[n.length - 1]);
        var i,
            c = r.length - n.length;

        if ("mod" !== t) {
          (i = new s(null)).length = c + 1, i.words = new Array(i.length);

          for (var u = 0; u < i.length; u++) {
            i.words[u] = 0;
          }
        }

        var d = r.clone()._ishlnsubmul(n, 1, c);

        0 === d.negative && (r = d, i && (i.words[c] = 1));

        for (var f = c - 1; f >= 0; f--) {
          var l = 67108864 * (0 | r.words[n.length + f]) + (0 | r.words[n.length + f - 1]);

          for (l = Math.min(l / o | 0, 67108863), r._ishlnsubmul(n, l, f); 0 !== r.negative;) {
            l--, r.negative = 0, r._ishlnsubmul(n, 1, f), r.isZero() || (r.negative ^= 1);
          }

          i && (i.words[f] = l);
        }

        return i && i.strip(), r.strip(), "div" !== t && 0 !== a && r.iushrn(a), {
          div: i || null,
          mod: r
        };
      }, s.prototype.divmod = function (e, t, a) {
        return r(!e.isZero()), this.isZero() ? {
          div: new s(0),
          mod: new s(0)
        } : 0 !== this.negative && 0 === e.negative ? (i = this.neg().divmod(e, t), "mod" !== t && (n = i.div.neg()), "div" !== t && (o = i.mod.neg(), a && 0 !== o.negative && o.iadd(e)), {
          div: n,
          mod: o
        }) : 0 === this.negative && 0 !== e.negative ? (i = this.divmod(e.neg(), t), "mod" !== t && (n = i.div.neg()), {
          div: n,
          mod: i.mod
        }) : 0 != (this.negative & e.negative) ? (i = this.neg().divmod(e.neg(), t), "div" !== t && (o = i.mod.neg(), a && 0 !== o.negative && o.isub(e)), {
          div: i.div,
          mod: o
        }) : e.length > this.length || this.cmp(e) < 0 ? {
          div: new s(0),
          mod: this
        } : 1 === e.length ? "div" === t ? {
          div: this.divn(e.words[0]),
          mod: null
        } : "mod" === t ? {
          div: null,
          mod: new s(this.modn(e.words[0]))
        } : {
          div: this.divn(e.words[0]),
          mod: new s(this.modn(e.words[0]))
        } : this._wordDiv(e, t);
        var n, o, i;
      }, s.prototype.div = function (e) {
        return this.divmod(e, "div", !1).div;
      }, s.prototype.mod = function (e) {
        return this.divmod(e, "mod", !1).mod;
      }, s.prototype.umod = function (e) {
        return this.divmod(e, "mod", !0).mod;
      }, s.prototype.divRound = function (e) {
        var t = this.divmod(e);
        if (t.mod.isZero()) return t.div;
        var a = 0 !== t.div.negative ? t.mod.isub(e) : t.mod,
            r = e.ushrn(1),
            n = e.andln(1),
            s = a.cmp(r);
        return s < 0 || 1 === n && 0 === s ? t.div : 0 !== t.div.negative ? t.div.isubn(1) : t.div.iaddn(1);
      }, s.prototype.modn = function (e) {
        r(e <= 67108863);

        for (var t = (1 << 26) % e, a = 0, n = this.length - 1; n >= 0; n--) {
          a = (t * a + (0 | this.words[n])) % e;
        }

        return a;
      }, s.prototype.idivn = function (e) {
        r(e <= 67108863);

        for (var t = 0, a = this.length - 1; a >= 0; a--) {
          var n = (0 | this.words[a]) + 67108864 * t;
          this.words[a] = n / e | 0, t = n % e;
        }

        return this.strip();
      }, s.prototype.divn = function (e) {
        return this.clone().idivn(e);
      }, s.prototype.egcd = function (e) {
        r(0 === e.negative), r(!e.isZero());
        var t = this,
            a = e.clone();
        t = 0 !== t.negative ? t.umod(e) : t.clone();

        for (var n = new s(1), o = new s(0), i = new s(0), c = new s(1), u = 0; t.isEven() && a.isEven();) {
          t.iushrn(1), a.iushrn(1), ++u;
        }

        for (var d = a.clone(), f = t.clone(); !t.isZero();) {
          for (var l = 0, h = 1; 0 == (t.words[0] & h) && l < 26; ++l, h <<= 1) {
            ;
          }

          if (l > 0) for (t.iushrn(l); l-- > 0;) {
            (n.isOdd() || o.isOdd()) && (n.iadd(d), o.isub(f)), n.iushrn(1), o.iushrn(1);
          }

          for (var p = 0, b = 1; 0 == (a.words[0] & b) && p < 26; ++p, b <<= 1) {
            ;
          }

          if (p > 0) for (a.iushrn(p); p-- > 0;) {
            (i.isOdd() || c.isOdd()) && (i.iadd(d), c.isub(f)), i.iushrn(1), c.iushrn(1);
          }
          t.cmp(a) >= 0 ? (t.isub(a), n.isub(i), o.isub(c)) : (a.isub(t), i.isub(n), c.isub(o));
        }

        return {
          a: i,
          b: c,
          gcd: a.iushln(u)
        };
      }, s.prototype._invmp = function (e) {
        r(0 === e.negative), r(!e.isZero());
        var t = this,
            a = e.clone();
        t = 0 !== t.negative ? t.umod(e) : t.clone();

        for (var n, o = new s(1), i = new s(0), c = a.clone(); t.cmpn(1) > 0 && a.cmpn(1) > 0;) {
          for (var u = 0, d = 1; 0 == (t.words[0] & d) && u < 26; ++u, d <<= 1) {
            ;
          }

          if (u > 0) for (t.iushrn(u); u-- > 0;) {
            o.isOdd() && o.iadd(c), o.iushrn(1);
          }

          for (var f = 0, l = 1; 0 == (a.words[0] & l) && f < 26; ++f, l <<= 1) {
            ;
          }

          if (f > 0) for (a.iushrn(f); f-- > 0;) {
            i.isOdd() && i.iadd(c), i.iushrn(1);
          }
          t.cmp(a) >= 0 ? (t.isub(a), o.isub(i)) : (a.isub(t), i.isub(o));
        }

        return (n = 0 === t.cmpn(1) ? o : i).cmpn(0) < 0 && n.iadd(e), n;
      }, s.prototype.gcd = function (e) {
        if (this.isZero()) return e.abs();
        if (e.isZero()) return this.abs();
        var t = this.clone(),
            a = e.clone();
        t.negative = 0, a.negative = 0;

        for (var r = 0; t.isEven() && a.isEven(); r++) {
          t.iushrn(1), a.iushrn(1);
        }

        for (;;) {
          for (; t.isEven();) {
            t.iushrn(1);
          }

          for (; a.isEven();) {
            a.iushrn(1);
          }

          var n = t.cmp(a);

          if (n < 0) {
            var s = t;
            t = a, a = s;
          } else if (0 === n || 0 === a.cmpn(1)) break;

          t.isub(a);
        }

        return a.iushln(r);
      }, s.prototype.invm = function (e) {
        return this.egcd(e).a.umod(e);
      }, s.prototype.isEven = function () {
        return 0 == (1 & this.words[0]);
      }, s.prototype.isOdd = function () {
        return 1 == (1 & this.words[0]);
      }, s.prototype.andln = function (e) {
        return this.words[0] & e;
      }, s.prototype.bincn = function (e) {
        r("number" == typeof e);
        var t = e % 26,
            a = (e - t) / 26,
            n = 1 << t;
        if (this.length <= a) return this._expand(a + 1), this.words[a] |= n, this;

        for (var s = n, o = a; 0 !== s && o < this.length; o++) {
          var i = 0 | this.words[o];
          s = (i += s) >>> 26, i &= 67108863, this.words[o] = i;
        }

        return 0 !== s && (this.words[o] = s, this.length++), this;
      }, s.prototype.isZero = function () {
        return 1 === this.length && 0 === this.words[0];
      }, s.prototype.cmpn = function (e) {
        var t,
            a = e < 0;
        if (0 !== this.negative && !a) return -1;
        if (0 === this.negative && a) return 1;
        if (this.strip(), this.length > 1) t = 1;else {
          a && (e = -e), r(e <= 67108863, "Number is too big");
          var n = 0 | this.words[0];
          t = n === e ? 0 : n < e ? -1 : 1;
        }
        return 0 !== this.negative ? 0 | -t : t;
      }, s.prototype.cmp = function (e) {
        if (0 !== this.negative && 0 === e.negative) return -1;
        if (0 === this.negative && 0 !== e.negative) return 1;
        var t = this.ucmp(e);
        return 0 !== this.negative ? 0 | -t : t;
      }, s.prototype.ucmp = function (e) {
        if (this.length > e.length) return 1;
        if (this.length < e.length) return -1;

        for (var t = 0, a = this.length - 1; a >= 0; a--) {
          var r = 0 | this.words[a],
              n = 0 | e.words[a];

          if (r !== n) {
            r < n ? t = -1 : r > n && (t = 1);
            break;
          }
        }

        return t;
      }, s.prototype.gtn = function (e) {
        return 1 === this.cmpn(e);
      }, s.prototype.gt = function (e) {
        return 1 === this.cmp(e);
      }, s.prototype.gten = function (e) {
        return this.cmpn(e) >= 0;
      }, s.prototype.gte = function (e) {
        return this.cmp(e) >= 0;
      }, s.prototype.ltn = function (e) {
        return -1 === this.cmpn(e);
      }, s.prototype.lt = function (e) {
        return -1 === this.cmp(e);
      }, s.prototype.lten = function (e) {
        return this.cmpn(e) <= 0;
      }, s.prototype.lte = function (e) {
        return this.cmp(e) <= 0;
      }, s.prototype.eqn = function (e) {
        return 0 === this.cmpn(e);
      }, s.prototype.eq = function (e) {
        return 0 === this.cmp(e);
      }, s.red = function (e) {
        return new w(e);
      }, s.prototype.toRed = function (e) {
        return r(!this.red, "Already a number in reduction context"), r(0 === this.negative, "red works only with positives"), e.convertTo(this)._forceRed(e);
      }, s.prototype.fromRed = function () {
        return r(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, s.prototype._forceRed = function (e) {
        return this.red = e, this;
      }, s.prototype.forceRed = function (e) {
        return r(!this.red, "Already a number in reduction context"), this._forceRed(e);
      }, s.prototype.redAdd = function (e) {
        return r(this.red, "redAdd works only with red numbers"), this.red.add(this, e);
      }, s.prototype.redIAdd = function (e) {
        return r(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, e);
      }, s.prototype.redSub = function (e) {
        return r(this.red, "redSub works only with red numbers"), this.red.sub(this, e);
      }, s.prototype.redISub = function (e) {
        return r(this.red, "redISub works only with red numbers"), this.red.isub(this, e);
      }, s.prototype.redShl = function (e) {
        return r(this.red, "redShl works only with red numbers"), this.red.shl(this, e);
      }, s.prototype.redMul = function (e) {
        return r(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.mul(this, e);
      }, s.prototype.redIMul = function (e) {
        return r(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.imul(this, e);
      }, s.prototype.redSqr = function () {
        return r(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, s.prototype.redISqr = function () {
        return r(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, s.prototype.redSqrt = function () {
        return r(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, s.prototype.redInvm = function () {
        return r(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, s.prototype.redNeg = function () {
        return r(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, s.prototype.redPow = function (e) {
        return r(this.red && !e.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, e);
      };
      var m = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };

      function y(e, t) {
        this.name = e, this.p = new s(t, 16), this.n = this.p.bitLength(), this.k = new s(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }

      function v() {
        y.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
      }

      function _() {
        y.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
      }

      function g() {
        y.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
      }

      function A() {
        y.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
      }

      function w(e) {
        if ("string" == typeof e) {
          var t = s._prime(e);

          this.m = t.p, this.prime = t;
        } else r(e.gtn(1), "modulus must be greater than 1"), this.m = e, this.prime = null;
      }

      function T(e) {
        w.call(this, e), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new s(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }

      y.prototype._tmp = function () {
        var e = new s(null);
        return e.words = new Array(Math.ceil(this.n / 13)), e;
      }, y.prototype.ireduce = function (e) {
        var t,
            a = e;

        do {
          this.split(a, this.tmp), t = (a = (a = this.imulK(a)).iadd(this.tmp)).bitLength();
        } while (t > this.n);

        var r = t < this.n ? -1 : a.ucmp(this.p);
        return 0 === r ? (a.words[0] = 0, a.length = 1) : r > 0 ? a.isub(this.p) : a.strip(), a;
      }, y.prototype.split = function (e, t) {
        e.iushrn(this.n, 0, t);
      }, y.prototype.imulK = function (e) {
        return e.imul(this.k);
      }, n(v, y), v.prototype.split = function (e, t) {
        for (var a = Math.min(e.length, 9), r = 0; r < a; r++) {
          t.words[r] = e.words[r];
        }

        if (t.length = a, e.length <= 9) return e.words[0] = 0, void (e.length = 1);
        var n = e.words[9];

        for (t.words[t.length++] = 4194303 & n, r = 10; r < e.length; r++) {
          var s = 0 | e.words[r];
          e.words[r - 10] = (4194303 & s) << 4 | n >>> 22, n = s;
        }

        n >>>= 22, e.words[r - 10] = n, 0 === n && e.length > 10 ? e.length -= 10 : e.length -= 9;
      }, v.prototype.imulK = function (e) {
        e.words[e.length] = 0, e.words[e.length + 1] = 0, e.length += 2;

        for (var t = 0, a = 0; a < e.length; a++) {
          var r = 0 | e.words[a];
          t += 977 * r, e.words[a] = 67108863 & t, t = 64 * r + (t / 67108864 | 0);
        }

        return 0 === e.words[e.length - 1] && (e.length--, 0 === e.words[e.length - 1] && e.length--), e;
      }, n(_, y), n(g, y), n(A, y), A.prototype.imulK = function (e) {
        for (var t = 0, a = 0; a < e.length; a++) {
          var r = 19 * (0 | e.words[a]) + t,
              n = 67108863 & r;
          r >>>= 26, e.words[a] = n, t = r;
        }

        return 0 !== t && (e.words[e.length++] = t), e;
      }, s._prime = function (e) {
        if (m[e]) return m[e];
        var t;
        if ("k256" === e) t = new v();else if ("p224" === e) t = new _();else if ("p192" === e) t = new g();else {
          if ("p25519" !== e) throw new Error("Unknown prime " + e);
          t = new A();
        }
        return m[e] = t, t;
      }, w.prototype._verify1 = function (e) {
        r(0 === e.negative, "red works only with positives"), r(e.red, "red works only with red numbers");
      }, w.prototype._verify2 = function (e, t) {
        r(0 == (e.negative | t.negative), "red works only with positives"), r(e.red && e.red === t.red, "red works only with red numbers");
      }, w.prototype.imod = function (e) {
        return this.prime ? this.prime.ireduce(e)._forceRed(this) : e.umod(this.m)._forceRed(this);
      }, w.prototype.neg = function (e) {
        return e.isZero() ? e.clone() : this.m.sub(e)._forceRed(this);
      }, w.prototype.add = function (e, t) {
        this._verify2(e, t);

        var a = e.add(t);
        return a.cmp(this.m) >= 0 && a.isub(this.m), a._forceRed(this);
      }, w.prototype.iadd = function (e, t) {
        this._verify2(e, t);

        var a = e.iadd(t);
        return a.cmp(this.m) >= 0 && a.isub(this.m), a;
      }, w.prototype.sub = function (e, t) {
        this._verify2(e, t);

        var a = e.sub(t);
        return a.cmpn(0) < 0 && a.iadd(this.m), a._forceRed(this);
      }, w.prototype.isub = function (e, t) {
        this._verify2(e, t);

        var a = e.isub(t);
        return a.cmpn(0) < 0 && a.iadd(this.m), a;
      }, w.prototype.shl = function (e, t) {
        return this._verify1(e), this.imod(e.ushln(t));
      }, w.prototype.imul = function (e, t) {
        return this._verify2(e, t), this.imod(e.imul(t));
      }, w.prototype.mul = function (e, t) {
        return this._verify2(e, t), this.imod(e.mul(t));
      }, w.prototype.isqr = function (e) {
        return this.imul(e, e.clone());
      }, w.prototype.sqr = function (e) {
        return this.mul(e, e);
      }, w.prototype.sqrt = function (e) {
        if (e.isZero()) return e.clone();
        var t = this.m.andln(3);

        if (r(t % 2 == 1), 3 === t) {
          var a = this.m.add(new s(1)).iushrn(2);
          return this.pow(e, a);
        }

        for (var n = this.m.subn(1), o = 0; !n.isZero() && 0 === n.andln(1);) {
          o++, n.iushrn(1);
        }

        r(!n.isZero());
        var i = new s(1).toRed(this),
            c = i.redNeg(),
            u = this.m.subn(1).iushrn(1),
            d = this.m.bitLength();

        for (d = new s(2 * d * d).toRed(this); 0 !== this.pow(d, u).cmp(c);) {
          d.redIAdd(c);
        }

        for (var f = this.pow(d, n), l = this.pow(e, n.addn(1).iushrn(1)), h = this.pow(e, n), p = o; 0 !== h.cmp(i);) {
          for (var b = h, m = 0; 0 !== b.cmp(i); m++) {
            b = b.redSqr();
          }

          r(m < p);
          var y = this.pow(f, new s(1).iushln(p - m - 1));
          l = l.redMul(y), f = y.redSqr(), h = h.redMul(f), p = m;
        }

        return l;
      }, w.prototype.invm = function (e) {
        var t = e._invmp(this.m);

        return 0 !== t.negative ? (t.negative = 0, this.imod(t).redNeg()) : this.imod(t);
      }, w.prototype.pow = function (e, t) {
        if (t.isZero()) return new s(1).toRed(this);
        if (0 === t.cmpn(1)) return e.clone();
        var a = new Array(16);
        a[0] = new s(1).toRed(this), a[1] = e;

        for (var r = 2; r < a.length; r++) {
          a[r] = this.mul(a[r - 1], e);
        }

        var n = a[0],
            o = 0,
            i = 0,
            c = t.bitLength() % 26;

        for (0 === c && (c = 26), r = t.length - 1; r >= 0; r--) {
          for (var u = t.words[r], d = c - 1; d >= 0; d--) {
            var f = u >> d & 1;
            n !== a[0] && (n = this.sqr(n)), 0 !== f || 0 !== o ? (o <<= 1, o |= f, (4 === ++i || 0 === r && 0 === d) && (n = this.mul(n, a[o]), i = 0, o = 0)) : i = 0;
          }

          c = 26;
        }

        return n;
      }, w.prototype.convertTo = function (e) {
        var t = e.umod(this.m);
        return t === e ? t.clone() : t;
      }, w.prototype.convertFrom = function (e) {
        var t = e.clone();
        return t.red = null, t;
      }, s.mont = function (e) {
        return new T(e);
      }, n(T, w), T.prototype.convertTo = function (e) {
        return this.imod(e.ushln(this.shift));
      }, T.prototype.convertFrom = function (e) {
        var t = this.imod(e.mul(this.rinv));
        return t.red = null, t;
      }, T.prototype.imul = function (e, t) {
        if (e.isZero() || t.isZero()) return e.words[0] = 0, e.length = 1, e;
        var a = e.imul(t),
            r = a.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
            n = a.isub(r).iushrn(this.shift),
            s = n;
        return n.cmp(this.m) >= 0 ? s = n.isub(this.m) : n.cmpn(0) < 0 && (s = n.iadd(this.m)), s._forceRed(this);
      }, T.prototype.mul = function (e, t) {
        if (e.isZero() || t.isZero()) return new s(0)._forceRed(this);
        var a = e.mul(t),
            r = a.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
            n = a.isub(r).iushrn(this.shift),
            o = n;
        return n.cmp(this.m) >= 0 ? o = n.isub(this.m) : n.cmpn(0) < 0 && (o = n.iadd(this.m)), o._forceRed(this);
      }, T.prototype.invm = function (e) {
        return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this);
      };
    }(e, this);
  }).call(this, a(
  /*! ./../../webpack/buildin/module.js */
  45)(e));
},
/*!*********************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/index.js ***!
  \*********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  function r(e) {
    for (var a in e) {
      t.hasOwnProperty(a) || (t[a] = e[a]);
    }
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = a(
  /*! ./PolyResponse */
  14);
  t.PolyResponse = n.PolyResponse, r(a(
  /*! @0x/base-contract */
  12)), r(a(
  /*! @0x/utils */
  8)), r(a(
  /*! @0x/web3-wrapper */
  11)), r(a(
  /*! ethereum-types */
  25));
  var s = a(
  /*! ethers */
  13);
  t.ethersUtils = s.utils, r(a(
  /*! ./generated-wrappers/3.0.0/blacklist_transfer_manager */
  776)), r(a(
  /*! ./generated-wrappers/3.0.0/capped_s_t_o */
  777)), r(a(
  /*! ./generated-wrappers/3.0.0/capped_s_t_o_factory */
  778)), r(a(
  /*! ./generated-wrappers/3.0.0/count_transfer_manager */
  779)), r(a(
  /*! ./generated-wrappers/3.0.0/dividend_checkpoint */
  780)), r(a(
  /*! ./generated-wrappers/3.0.0/erc20_detailed */
  781)), r(a(
  /*! ./generated-wrappers/3.0.0/erc20_dividend_checkpoint */
  782)), r(a(
  /*! ./generated-wrappers/3.0.0/ether_dividend_checkpoint */
  783)), r(a(
  /*! ./generated-wrappers/3.0.0/feature_registry */
  784)), r(a(
  /*! ./generated-wrappers/3.0.0/general_permission_manager */
  785)), r(a(
  /*! ./generated-wrappers/3.0.0/general_transfer_manager */
  786)), r(a(
  /*! ./generated-wrappers/3.0.0/isto */
  787)), r(a(
  /*! ./generated-wrappers/3.0.0/i_module */
  788)), r(a(
  /*! ./generated-wrappers/3.0.0/security_token */
  789)), r(a(
  /*! ./generated-wrappers/3.0.0/i_security_token */
  790)), r(a(
  /*! ./generated-wrappers/3.0.0/i_security_token_registry */
  791)), r(a(
  /*! ./generated-wrappers/3.0.0/i_transfer_manager */
  792)), r(a(
  /*! ./generated-wrappers/3.0.0/lock_up_transfer_manager */
  793)), r(a(
  /*! ./generated-wrappers/3.0.0/manual_approval_transfer_manager */
  794)), r(a(
  /*! ./generated-wrappers/3.0.0/module */
  795)), r(a(
  /*! ./generated-wrappers/3.0.0/module_factory */
  796)), r(a(
  /*! ./generated-wrappers/3.0.0/module_registry */
  797)), r(a(
  /*! ./generated-wrappers/3.0.0/ownable */
  798)), r(a(
  /*! ./generated-wrappers/3.0.0/pausable */
  799)), r(a(
  /*! ./generated-wrappers/3.0.0/percentage_transfer_manager */
  800)), r(a(
  /*! ./generated-wrappers/3.0.0/polymath_registry */
  801)), r(a(
  /*! ./generated-wrappers/3.0.0/poly_token */
  802)), r(a(
  /*! ./generated-wrappers/3.0.0/poly_token_faucet */
  803)), r(a(
  /*! ./generated-wrappers/3.0.0/sto */
  804)), r(a(
  /*! ./generated-wrappers/3.0.0/u_s_d_tiered_s_t_o */
  805)), r(a(
  /*! ./generated-wrappers/3.0.0/u_s_d_tiered_s_t_o_factory */
  806)), r(a(
  /*! ./generated-wrappers/3.0.0/vesting_escrow_wallet */
  807)), r(a(
  /*! ./generated-wrappers/3.0.0/volume_restriction_t_m */
  808)), r(a(
  /*! ./generated-wrappers/3.0.0/weighted_vote_checkpoint */
  809)), r(a(
  /*! ./generated-wrappers/3.0.0/p_l_c_r_voting_checkpoint */
  810)), r(a(
  /*! ./generated-wrappers/3.1.0/sto */
  811)), r(a(
  /*! ./generated-wrappers/3.1.0/capped_s_t_o */
  812)), r(a(
  /*! ./generated-wrappers/3.1.0/general_permission_manager */
  813)), r(a(
  /*! ./generated-wrappers/3.1.0/general_transfer_manager */
  814)), r(a(
  /*! ./generated-wrappers/3.1.0/u_s_d_tiered_s_t_o */
  815)), r(a(
  /*! ./generated-wrappers/3.1.0/vesting_escrow_wallet */
  816)), r(a(
  /*! ./generated-wrappers/3.1.0/restricted_partial_sale_t_m */
  817)), r(a(
  /*! ./generated-wrappers/3.1.0/advanced_p_l_c_r_voting_checkpoint */
  818));
},
/*!*******************************************!*\
  !*** ./node_modules/safe-buffer/index.js ***!
  \*******************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! buffer */
  1),
      n = r.Buffer;

  function s(e, t) {
    for (var a in e) {
      t[a] = e[a];
    }
  }

  function o(e, t, a) {
    return n(e, t, a);
  }

  n.from && n.alloc && n.allocUnsafe && n.allocUnsafeSlow ? e.exports = r : (s(r, t), t.Buffer = o), o.prototype = Object.create(n.prototype), s(n, o), o.from = function (e, t, a) {
    if ("number" == typeof e) throw new TypeError("Argument must not be a number");
    return n(e, t, a);
  }, o.alloc = function (e, t, a) {
    if ("number" != typeof e) throw new TypeError("Argument must be a number");
    var r = n(e);
    return void 0 !== t ? "string" == typeof a ? r.fill(t, a) : r.fill(t) : r.fill(0), r;
  }, o.allocUnsafe = function (e) {
    if ("number" != typeof e) throw new TypeError("Argument must be a number");
    return n(e);
  }, o.allocUnsafeSlow = function (e) {
    if ("number" != typeof e) throw new TypeError("Argument must be a number");
    return r.SlowBuffer(e);
  };
},
/*!*************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/index.js ***!
  \*************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = a(
  /*! ./promisify */
  375);
  t.promisify = r.promisify;
  var n = a(
  /*! ./address_utils */
  152);
  t.addressUtils = n.addressUtils;
  var s = a(
  /*! ./class_utils */
  433);
  t.classUtils = s.classUtils;
  var o = a(
  /*! ./delete_nested_property */
  434);
  t.deleteNestedProperty = o.deleteNestedProperty;
  var i = a(
  /*! ./interval_utils */
  435);
  t.intervalUtils = i.intervalUtils;
  var c = a(
  /*! ./provider_utils */
  436);
  t.providerUtils = c.providerUtils;
  var u = a(
  /*! ./configured_bignumber */
  37);
  t.BigNumber = u.BigNumber;
  var d = a(
  /*! ./abi_decoder */
  437);
  t.AbiDecoder = d.AbiDecoder;
  var f = a(
  /*! ./log_utils */
  438);
  t.logUtils = f.logUtils;
  var l = a(
  /*! ./abi_utils */
  447);
  t.abiUtils = l.abiUtils;
  var h = a(
  /*! ./constants */
  448);
  t.NULL_BYTES = h.NULL_BYTES;
  var p = a(
  /*! ./error_utils */
  449);
  t.errorUtils = p.errorUtils;
  var b = a(
  /*! ./fetch_async */
  450);
  t.fetchAsync = b.fetchAsync;
  var m = a(
  /*! ./sign_typed_data_utils */
  454);
  t.signTypedDataUtils = m.signTypedDataUtils, t.AbiEncoder = a(
  /*! ./abi_encoder */
  455);
  var y = a(
  /*! ./random */
  171);
  t.generatePseudoRandom256BitNumber = y.generatePseudoRandom256BitNumber;
},
/*!*****************************************!*\
  !*** ./node_modules/process/browser.js ***!
  \*****************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  var a,
      r,
      n = e.exports = {};

  function s() {
    throw new Error("setTimeout has not been defined");
  }

  function o() {
    throw new Error("clearTimeout has not been defined");
  }

  function i(e) {
    if (a === setTimeout) return setTimeout(e, 0);
    if ((a === s || !a) && setTimeout) return a = setTimeout, setTimeout(e, 0);

    try {
      return a(e, 0);
    } catch (t) {
      try {
        return a.call(null, e, 0);
      } catch (t) {
        return a.call(this, e, 0);
      }
    }
  }

  !function () {
    try {
      a = "function" == typeof setTimeout ? setTimeout : s;
    } catch (e) {
      a = s;
    }

    try {
      r = "function" == typeof clearTimeout ? clearTimeout : o;
    } catch (e) {
      r = o;
    }
  }();
  var c,
      u = [],
      d = !1,
      f = -1;

  function l() {
    d && c && (d = !1, c.length ? u = c.concat(u) : f = -1, u.length && h());
  }

  function h() {
    if (!d) {
      var e = i(l);
      d = !0;

      for (var t = u.length; t;) {
        for (c = u, u = []; ++f < t;) {
          c && c[f].run();
        }

        f = -1, t = u.length;
      }

      c = null, d = !1, function (e) {
        if (r === clearTimeout) return clearTimeout(e);
        if ((r === o || !r) && clearTimeout) return r = clearTimeout, clearTimeout(e);

        try {
          r(e);
        } catch (t) {
          try {
            return r.call(null, e);
          } catch (t) {
            return r.call(this, e);
          }
        }
      }(e);
    }
  }

  function p(e, t) {
    this.fun = e, this.array = t;
  }

  function b() {}

  n.nextTick = function (e) {
    var t = new Array(arguments.length - 1);
    if (arguments.length > 1) for (var a = 1; a < arguments.length; a++) {
      t[a - 1] = arguments[a];
    }
    u.push(new p(e, t)), 1 !== u.length || d || i(h);
  }, p.prototype.run = function () {
    this.fun.apply(null, this.array);
  }, n.title = "browser", n.browser = !0, n.env = {}, n.argv = [], n.version = "", n.versions = {}, n.on = b, n.addListener = b, n.once = b, n.off = b, n.removeListener = b, n.removeAllListeners = b, n.emit = b, n.prependListener = b, n.prependOnceListener = b, n.listeners = function (e) {
    return [];
  }, n.binding = function (e) {
    throw new Error("process.binding is not supported");
  }, n.cwd = function () {
    return "/";
  }, n.chdir = function (e) {
    throw new Error("process.chdir is not supported");
  }, n.umask = function () {
    return 0;
  };
},
/*!**************************************************!*\
  !*** ./node_modules/@0x/assert/lib/src/index.js ***!
  \**************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = a(
  /*! @0x/json-schemas */
  2),
      n = a(
  /*! @0x/utils */
  8),
      s = a(
  /*! lodash */
  0),
      o = a(
  /*! valid-url */
  471),
      i = /^0x[0-9A-F]*$/i;
  t.assert = {
    isBigNumber: function isBigNumber(e, a) {
      var r = n.BigNumber.isBigNumber(a);
      t.assert.assert(r, t.assert.typeAssertionMessage(e, "BigNumber", a));
    },
    isValidBaseUnitAmount: function isValidBaseUnitAmount(e, a) {
      t.assert.isBigNumber(e, a);
      var r = a.isLessThan(0);
      t.assert.assert(!r, e + " cannot be a negative number, found value: " + a.toNumber());
      var n = 0 !== a.decimalPlaces();
      t.assert.assert(!n, e + " should be in baseUnits (no decimals), found value: " + a.toNumber());
    },
    isString: function isString(e, a) {
      t.assert.assert(s.isString(a), t.assert.typeAssertionMessage(e, "string", a));
    },
    isFunction: function isFunction(e, a) {
      t.assert.assert(s.isFunction(a), t.assert.typeAssertionMessage(e, "function", a));
    },
    isHexString: function isHexString(e, a) {
      t.assert.assert(s.isString(a) && i.test(a), t.assert.typeAssertionMessage(e, "HexString", a));
    },
    isETHAddressHex: function isETHAddressHex(e, a) {
      t.assert.assert(s.isString(a), t.assert.typeAssertionMessage(e, "string", a)), t.assert.assert(n.addressUtils.isAddress(a), t.assert.typeAssertionMessage(e, "ETHAddressHex", a));
    },
    doesBelongToStringEnum: function doesBelongToStringEnum(e, a, r) {
      var n = s.values(r),
          o = s.includes(n, a),
          i = s.map(n, function (e) {
        return "'" + e + "'";
      }).join(", ");
      t.assert.assert(o, "Expected " + e + " to be one of: " + i + ", encountered: " + a);
    },
    hasAtMostOneUniqueValue: function hasAtMostOneUniqueValue(e, a) {
      t.assert.assert(s.uniq(e).length <= 1, a);
    },
    isNumber: function isNumber(e, a) {
      t.assert.assert(s.isFinite(a), t.assert.typeAssertionMessage(e, "number", a));
    },
    isNumberOrBigNumber: function isNumberOrBigNumber(e, a) {
      s.isFinite(a) || t.assert.assert(n.BigNumber.isBigNumber(a), t.assert.typeAssertionMessage(e, "number or BigNumber", a));
    },
    isBoolean: function isBoolean(e, a) {
      t.assert.assert(s.isBoolean(a), t.assert.typeAssertionMessage(e, "boolean", a));
    },
    isWeb3Provider: function isWeb3Provider(e, a) {
      n.logUtils.warn("DEPRECATED: Please use providerUtils.standardizeOrThrow() instead");
      var r = s.isFunction(a.send) || s.isFunction(a.sendAsync);
      t.assert.assert(r, t.assert.typeAssertionMessage(e, "Provider", a));
    },
    doesConformToSchema: function doesConformToSchema(e, a, n, o) {
      if (void 0 === a) throw new Error(e + " can't be undefined");
      var i = new r.SchemaValidator();
      void 0 !== o && s.map(o, i.addSchema.bind(i));
      var c = i.validate(a, n),
          u = c.errors.length > 0,
          d = "Expected " + e + " to conform to schema " + n.id + "\nEncountered: " + JSON.stringify(a, null, "\t") + "\nValidation errors: " + c.errors.join(", ");
      t.assert.assert(!u, d);
    },
    isWebUri: function isWebUri(e, a) {
      var r = void 0 !== o.isWebUri(a);
      t.assert.assert(r, t.assert.typeAssertionMessage(e, "web uri", a));
    },
    isUri: function isUri(e, a) {
      var r = void 0 !== o.isUri(a);
      t.assert.assert(r, t.assert.typeAssertionMessage(e, "uri", a));
    },
    isBlockParam: function isBlockParam(e, a) {
      if (!(Number.isInteger(a) && a >= 0) && "earliest" !== a && "latest" !== a && "pending" !== a) throw new Error(t.assert.typeAssertionMessage(e, "BlockParam", a));
    },
    isArray: function isArray(e, a) {
      if (!Array.isArray(a)) throw new Error(t.assert.typeAssertionMessage(e, "Array", a));
    },
    assert: function assert(e, t) {
      if (!e) throw new Error(t);
    },
    typeAssertionMessage: function typeAssertionMessage(e, t, a) {
      return "Expected " + e + " to be of type " + t + ", encountered: " + a;
    }
  };
},
/*!********************************************************!*\
  !*** ./node_modules/@0x/web3-wrapper/lib/src/index.js ***!
  \********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = a(
  /*! ./web3_wrapper */
  472);
  t.Web3Wrapper = r.Web3Wrapper;
  var n = a(
  /*! ./marshaller */
  179);
  t.marshaller = n.marshaller;
  var s = a(
  /*! @0x/utils */
  8);
  t.AbiDecoder = s.AbiDecoder;
  var o = a(
  /*! ethereum-types */
  25);
  t.BlockParamLiteral = o.BlockParamLiteral, t.OpCode = o.OpCode;
  var i = a(
  /*! ./types */
  181);
  t.Web3WrapperErrors = i.Web3WrapperErrors, t.NodeType = i.NodeType;
},
/*!*********************************************************!*\
  !*** ./node_modules/@0x/base-contract/lib/src/index.js ***!
  \*********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, a = 1, r = arguments.length; a < r; a++) {
          for (var n in t = arguments[a]) {
            Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        n = this && this.__awaiter || function (e, t, a, r) {
      return new (a || (a = Promise))(function (n, s) {
        function o(e) {
          try {
            c(r.next(e));
          } catch (e) {
            s(e);
          }
        }

        function i(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            s(e);
          }
        }

        function c(e) {
          e.done ? n(e.value) : new a(function (t) {
            t(e.value);
          }).then(o, i);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        s = this && this.__generator || function (e, t) {
      var a,
          r,
          n,
          s,
          o = {
        label: 0,
        sent: function sent() {
          if (1 & n[0]) throw n[1];
          return n[1];
        },
        trys: [],
        ops: []
      };
      return s = {
        next: i(0),
        throw: i(1),
        return: i(2)
      }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
        return this;
      }), s;

      function i(s) {
        return function (i) {
          return function (s) {
            if (a) throw new TypeError("Generator is already executing.");

            for (; o;) {
              try {
                if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

                switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                  case 0:
                  case 1:
                    n = s;
                    break;

                  case 4:
                    return o.label++, {
                      value: s[1],
                      done: !1
                    };

                  case 5:
                    o.label++, r = s[1], s = [0];
                    continue;

                  case 7:
                    s = o.ops.pop(), o.trys.pop();
                    continue;

                  default:
                    if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                      o = 0;
                      continue;
                    }

                    if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                      o.label = s[1];
                      break;
                    }

                    if (6 === s[0] && o.label < n[1]) {
                      o.label = n[1], n = s;
                      break;
                    }

                    if (n && o.label < n[2]) {
                      o.label = n[2], o.ops.push(s);
                      break;
                    }

                    n[2] && o.ops.pop(), o.trys.pop();
                    continue;
                }

                s = t.call(e, o);
              } catch (e) {
                s = [6, e], r = 0;
              } finally {
                a = n = 0;
              }
            }

            if (5 & s[0]) throw s[1];
            return {
              value: s[0] ? s[1] : void 0,
              done: !0
            };
          }([s, i]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = a(
    /*! @0x/assert */
    10),
        i = a(
    /*! @0x/json-schemas */
    2),
        c = a(
    /*! @0x/utils */
    8),
        u = a(
    /*! @0x/web3-wrapper */
    11),
        d = a(
    /*! ethereum-types */
    25),
        f = a(
    /*! ethereumjs-account */
    72),
        l = a(
    /*! ethereumjs-util */
    183),
        h = a(
    /*! ethereumjs-vm */
    474),
        p = a(
    /*! ethereumjs-vm/dist/state/promisified */
    74),
        b = a(
    /*! ethers */
    104),
        m = a(
    /*! lodash */
    0),
        y = a(
    /*! ./utils */
    763),
        v = a(
    /*! ./subscription_manager */
    764);
    t.SubscriptionManager = v.SubscriptionManager, function (e) {
      for (var a in e) {
        t.hasOwnProperty(a) || (t[a] = e[a]);
      }
    }(a(
    /*! ./types */
    280));

    var _ = function () {
      function e(e, t) {
        this.txHashPromise = e, this._promise = t;
      }

      return e.prototype.then = function (e, t) {
        return this._promise.then(e, t);
      }, e;
    }();

    t.PromiseWithTransactionHash = _;

    var g = function () {
      function t(e, t, a, r, n, s) {
        var f = this;
        this.constructorArgs = [], o.assert.isString("contractName", e), o.assert.isETHAddressHex("address", a);
        var l = c.providerUtils.standardizeOrThrow(r);
        void 0 !== n && o.assert.doesConformToSchema("callAndTxnDefaults", n, i.schemas.callDataSchema, [i.schemas.addressSchema, i.schemas.numberSchema, i.schemas.jsNumber]), this.contractName = e, this._web3Wrapper = new u.Web3Wrapper(l, n), this.abi = t, this.address = a;
        var h = this.abi.filter(function (e) {
          return e.type === d.AbiType.Function;
        });
        this._abiEncoderByFunctionSignature = {}, m.each(h, function (a) {
          var r = new c.AbiEncoder.Method(a),
              n = r.getSignature();
          f._abiEncoderByFunctionSignature[n] = r, f._web3Wrapper.abiDecoder.addABI(t, e);
        }), m.each(s, function (e, t) {
          f._web3Wrapper.abiDecoder.addABI(e, t);
        });
      }

      return t._formatABIDataItemList = function (e, t, a) {
        return m.map(t, function (t, r) {
          return y.formatABIDataItem(e[r], t, a);
        });
      }, t._lowercaseAddress = function (e, t) {
        return "address" === e ? t.toLowerCase() : t;
      }, t._bigNumberToString = function (e, t) {
        return c.BigNumber.isBigNumber(t) ? t.toString() : t;
      }, t._lookupConstructorAbi = function (e) {
        var t = m.find(e, function (e) {
          return e.type === d.AbiType.Constructor;
        });
        return void 0 !== t ? t : {
          type: d.AbiType.Constructor,
          stateMutability: "nonpayable",
          payable: !1,
          inputs: []
        };
      }, t._applyDefaultsToTxDataAsync = function (e, t, a) {
        return n(this, void 0, void 0, function () {
          var n, o, i;
          return s(this, function (s) {
            switch (s.label) {
              case 0:
                return n = m.pickBy.bind(m), void 0 !== (o = r({}, n(t || {}), n(e))).gas || void 0 === a ? [3, 2] : (i = o, [4, a(o)]);

              case 1:
                i.gas = s.sent(), s.label = 2;

              case 2:
                return [2, o];
            }
          });
        });
      }, t._throwIfRevertWithReasonCallResult = function (e) {
        if ("08c379a0" === e.slice(2, 10)) {
          var t = c.AbiEncoder.create("(string)").decodeAsArray(b.utils.hexDataSlice(e, 4));
          if (1 !== t.length) throw new Error("Cannot safely decode revert reason: Expected an array with one element, got " + t);
          var a = t[0];
          throw new Error(a);
        }
      }, t.strictArgumentEncodingCheck = function (e, t) {
        for (var a = c.AbiEncoder.create(e), r = c.abiUtils.parseEthersParams(e), n = a.encode(t), s = a.decodeAsArray(n), o = 0; o < s.length; o++) {
          var i = t[o],
              u = s[o];
          if (!c.abiUtils.isAbiDataEqual(r.names[o], r.types[o], i, u)) throw new Error("Cannot safely encode argument: " + r.names[o] + " (" + i + ") of type " + r.types[o] + ". (Possible type overflow or other encoding error)");
        }

        return n;
      }, t.prototype.evmExecAsync = function (t) {
        return n(this, void 0, void 0, function () {
          var a, r, n, o, i, c, u, d, b;
          return s(this, function (s) {
            switch (s.label) {
              case 0:
                return a = e.from(this.address.substr(2), "hex"), void 0 !== this._evmIfExists ? [3, 4] : (r = new h.default({}), n = new p.default(r.stateManager), o = e.from("e331b6d69882b4cb4ea581d88e0b604039a3de5967688d3dcffdd2270c0fd109", "hex"), i = l.privateToAddress(o), c = new f.default({
                  balance: 1e18
                }), [4, n.putAccount(i, c)]);

              case 1:
                return s.sent(), [4, this._web3Wrapper.getContractCodeAsync(this.address)];

              case 2:
                return u = s.sent(), d = e.from(u.substr(2), "hex"), [4, n.putContractCode(a, d)];

              case 3:
                s.sent(), this._evmIfExists = r, this._evmAccountIfExists = i, s.label = 4;

              case 4:
                return [4, this._evmIfExists.runCall({
                  to: a,
                  caller: this._evmAccountIfExists,
                  origin: this._evmAccountIfExists,
                  data: t
                })];

              case 5:
                return b = s.sent(), [2, "0x" + b.execResult.returnValue.toString("hex")];
            }
          });
        });
      }, t.prototype._lookupAbiEncoder = function (e) {
        var t = this._abiEncoderByFunctionSignature[e];
        if (void 0 === t) throw new Error("Failed to lookup method with function signature '" + e + "'");
        return t;
      }, t.prototype._lookupAbi = function (e) {
        return m.find(this.abi, function (t) {
          return t.type === d.AbiType.Function && new c.AbiEncoder.Method(t).getSignature() === e;
        });
      }, t.prototype._strictEncodeArguments = function (e, t) {
        var a = this._lookupAbiEncoder(e);

        if (void 0 === a.getDataItem().components) throw new Error("Undefined Method Input ABI");
        return a.encode(t);
      }, t;
    }();

    t.BaseContract = g;
  }).call(this, a(
  /*! ./../../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!*******************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/node_modules/ethers/dist/ethers.min.js ***!
  \*******************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    var a;

    e.exports = function e(t, r, n) {
      function s(i, c) {
        if (!r[i]) {
          if (!t[i]) {
            if (!c && "function" == typeof a && a) return a(i, !0);
            if (o) return o(i, !0);
            var u = new Error("Cannot find module '" + i + "'");
            throw u.code = "MODULE_NOT_FOUND", u;
          }

          var d = r[i] = {
            exports: {}
          };
          t[i][0].call(d.exports, function (e) {
            return s(t[i][1][e] || e);
          }, d, d.exports, e, t, r, n);
        }

        return r[i].exports;
      }

      for (var o = "function" == typeof a && a, i = 0; i < n.length; i++) {
        s(n[i]);
      }

      return s;
    }({
      1: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        }), a.version = "4.0.37";
      }, {}],
      2: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var r = e("./utils/properties"),
            n = (s.isSigner = function (e) {
          return r.isType(e, "Signer");
        }, s);

        function s() {
          r.setType(this, "Signer");
        }

        a.Signer = n;
      }, {
        "./utils/properties": 73
      }],
      3: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var r = e("./utils/bignumber");
        a.AddressZero = "0x0000000000000000000000000000000000000000", a.HashZero = "0x0000000000000000000000000000000000000000000000000000000000000000", a.EtherSymbol = "Ξ";
        var n = r.bigNumberify(-1);
        a.NegativeOne = n;
        var s = r.bigNumberify(0);
        a.Zero = s;
        var o = r.bigNumberify(1);
        a.One = o;
        var i = r.bigNumberify(2);
        a.Two = i;
        var c = r.bigNumberify("1000000000000000000");
        a.WeiPerEther = c;
        var u = r.bigNumberify("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
        a.MaxUint256 = u;
      }, {
        "./utils/bignumber": 62
      }],
      4: [function (e, t, a) {
        "use strict";

        var r,
            n = this && this.__extends || (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var a in t) {
            t.hasOwnProperty(a) && (e[a] = t[a]);
          }
        }, function (e, t) {
          function a() {
            this.constructor = e;
          }

          r(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
        }),
            s = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var o,
            i = e("./constants"),
            c = s(e("./errors")),
            u = e("./utils/abi-coder"),
            d = e("./utils/address"),
            f = e("./utils/bignumber"),
            l = e("./utils/bytes"),
            h = e("./utils/interface"),
            p = e("./utils/properties"),
            b = e("./providers/abstract-provider"),
            m = e("./abstract-signer"),
            y = (n(v, o = m.Signer), v.prototype.getAddress = function () {
          return Promise.resolve(this.address);
        }, v.prototype._fail = function (e, t) {
          return Promise.resolve().then(function () {
            c.throwError(e, c.UNSUPPORTED_OPERATION, {
              operation: t
            });
          });
        }, v.prototype.signMessage = function (e) {
          return this._fail("VoidSigner cannot sign messages", "signMessage");
        }, v.prototype.sendTransaction = function (e) {
          return this._fail("VoidSigner cannot sign transactions", "sendTransaction");
        }, v.prototype.connect = function (e) {
          return new v(this.address, e);
        }, v);

        function v(e, t) {
          var a = o.call(this) || this;
          return p.defineReadOnly(a, "address", e), p.defineReadOnly(a, "provider", t), a;
        }

        a.VoidSigner = y;
        var _ = {
          chainId: !0,
          data: !0,
          from: !0,
          gasLimit: !0,
          gasPrice: !0,
          nonce: !0,
          to: !0,
          value: !0
        };

        function g(e, t, a) {
          var r = e.interface.functions[t];
          return function () {
            for (var t = [], n = 0; n < arguments.length; n++) {
              t[n] = arguments[n];
            }

            var s = {},
                o = null;
            if (t.length === r.inputs.length + 1 && "object" == typeof t[t.length - 1]) for (var d in null != (s = p.shallowCopy(t.pop())).blockTag && (o = s.blockTag), delete s.blockTag, s) {
              if (!_[d]) throw new Error("unknown transaction override " + d);
            }
            if (t.length != r.inputs.length) throw new Error("incorrect number of arguments");
            return ["data", "to"].forEach(function (e) {
              null != s[e] && c.throwError("cannot override " + e, c.UNSUPPORTED_OPERATION, {
                operation: e
              });
            }), s.to = e._deployed(o).then(function () {
              return e.addressPromise;
            }), function e(t, a, r) {
              if (Array.isArray(r)) {
                var n = [];
                return r.forEach(function (r, s) {
                  var o;
                  o = Array.isArray(a) ? a[s] : a[r.name], n.push(e(t, o, r));
                }), Promise.all(n);
              }

              if ("address" === r.type) return t.resolveName(a);
              if ("tuple" === r.type) return e(t, a, r.components);
              var s = r.type.match(/(.*)(\[[0-9]*\]$)/);

              if (s) {
                if (!Array.isArray(a)) throw new Error("invalid value for array");
                var o = [],
                    i = {
                  components: r.components,
                  type: s[1]
                };
                return a.forEach(function (a) {
                  o.push(e(t, a, i));
                }), Promise.all(o);
              }

              return Promise.resolve(a);
            }(e.provider, t, r.inputs).then(function (t) {
              if (s.data = r.encode(t), "call" === r.type) return a ? Promise.resolve(i.Zero) : (e.provider || c.throwError("call (constant functions) require a provider or a signer with a provider", c.UNSUPPORTED_OPERATION, {
                operation: "call"
              }), ["gasLimit", "gasPrice", "value"].forEach(function (e) {
                if (null != s[e]) throw new Error("call cannot override " + e);
              }), null == s.from && e.signer && (s.from = e.signer.getAddress()), e.provider.call(s, o).then(function (a) {
                if (l.hexDataLength(a) % 32 == 4 && "0x08c379a0" === l.hexDataSlice(a, 0, 4)) {
                  var n = u.defaultAbiCoder.decode(["string"], l.hexDataSlice(a, 4));
                  c.throwError("call revert exception", c.CALL_EXCEPTION, {
                    address: e.address,
                    args: t,
                    method: r.signature,
                    errorSignature: "Error(string)",
                    errorArgs: [n],
                    reason: n,
                    transaction: s
                  });
                }

                try {
                  var o = r.decode(a);
                  return 1 === r.outputs.length && (o = o[0]), o;
                } catch (n) {
                  throw "0x" === a && 0 < r.outputs.length && c.throwError("call exception", c.CALL_EXCEPTION, {
                    address: e.address,
                    method: r.signature,
                    args: t
                  }), n;
                }
              }));
              if ("transaction" === r.type) return a ? (e.provider || c.throwError("estimate gas require a provider or a signer with a provider", c.UNSUPPORTED_OPERATION, {
                operation: "estimateGas"
              }), null == s.from && e.signer && (s.from = e.signer.getAddress()), e.provider.estimateGas(s)) : (null == s.gasLimit && null != r.gas && (s.gasLimit = f.bigNumberify(r.gas).add(21e3)), e.signer || c.throwError("sending a transaction requires a signer", c.UNSUPPORTED_OPERATION, {
                operation: "sendTransaction"
              }), null != s.from && c.throwError("cannot override from in a transaction", c.UNSUPPORTED_OPERATION, {
                operation: "sendTransaction"
              }), e.signer.sendTransaction(s).then(function (t) {
                var a = t.wait.bind(t);
                return t.wait = function (t) {
                  return a(t).then(function (t) {
                    return t.events = t.logs.map(function (a) {
                      var r = p.deepCopy(a),
                          n = e.interface.parseLog(a);
                      return n && (r.args = n.values, r.decode = n.decode, r.event = n.name, r.eventSignature = n.signature), r.removeListener = function () {
                        return e.provider;
                      }, r.getBlock = function () {
                        return e.provider.getBlock(t.blockHash);
                      }, r.getTransaction = function () {
                        return e.provider.getTransaction(t.transactionHash);
                      }, r.getTransactionReceipt = function () {
                        return Promise.resolve(t);
                      }, r;
                    }), t;
                  });
                }, t;
              }));
              throw new Error("invalid type - " + r.type);
            });
          };
        }

        function A(e) {
          return !e.address || null != e.topics && 0 !== e.topics.length ? (e.address || "*") + "@" + (e.topics ? e.topics.join(":") : "") : "*";
        }

        var w = (T.prototype.deployed = function () {
          return this._deployed();
        }, T.prototype._deployed = function (e) {
          var t = this;
          return this._deployedPromise || (this.deployTransaction ? this._deployedPromise = this.deployTransaction.wait().then(function () {
            return t;
          }) : this._deployedPromise = this.provider.getCode(this.address, e).then(function (e) {
            return "0x" === e && c.throwError("contract not deployed", c.UNSUPPORTED_OPERATION, {
              contractAddress: t.address,
              operation: "getDeployed"
            }), t;
          })), this._deployedPromise;
        }, T.prototype.fallback = function (e) {
          var t = this;
          this.signer || c.throwError("sending a transaction requires a signer", c.UNSUPPORTED_OPERATION, {
            operation: "sendTransaction(fallback)"
          });
          var a = p.shallowCopy(e || {});
          return ["from", "to"].forEach(function (e) {
            null != a[e] && c.throwError("cannot override " + e, c.UNSUPPORTED_OPERATION, {
              operation: e
            });
          }), a.to = this.addressPromise, this.deployed().then(function () {
            return t.signer.sendTransaction(a);
          });
        }, T.prototype.connect = function (e) {
          "string" == typeof e && (e = new y(e, this.provider));
          var t = new T(this.address, this.interface, e);
          return this.deployTransaction && p.defineReadOnly(t, "deployTransaction", this.deployTransaction), t;
        }, T.prototype.attach = function (e) {
          return new T(e, this.interface, this.signer || this.provider);
        }, T.isIndexed = function (e) {
          return h.Interface.isIndexed(e);
        }, T.prototype._getEventFilter = function (e) {
          var t = this;

          if ("string" == typeof e) {
            if ("*" === e) return {
              prepareEvent: function prepareEvent(e) {
                var a = t.interface.parseLog(e);
                return a && (e.args = a.values, e.decode = a.decode, e.event = a.name, e.eventSignature = a.signature), [e];
              },
              eventTag: "*",
              filter: {
                address: this.address
              }
            };
            -1 !== e.indexOf("(") && (e = u.formatSignature(u.parseSignature("event " + e)));
            var a = this.interface.events[e];
            a || c.throwError("unknown event - " + e, c.INVALID_ARGUMENT, {
              argumnet: "eventName",
              value: e
            });
            var r = {
              address: this.address,
              topics: [a.topic]
            };
            return {
              prepareEvent: function prepareEvent(e) {
                var t = a.decode(e.data, e.topics);
                e.args = t;
                var r = Array.prototype.slice.call(t);
                return r.push(e), r;
              },
              event: a,
              eventTag: A(r),
              filter: r
            };
          }

          var n = {
            address: this.address
          },
              s = null;
          if (e.topics && e.topics[0]) for (var o in n.topics = e.topics, this.interface.events) {
            if (-1 !== o.indexOf("(")) {
              var i = this.interface.events[o];

              if (i.topic === e.topics[0].toLowerCase()) {
                s = i;
                break;
              }
            }
          }
          return {
            prepareEvent: function prepareEvent(e) {
              if (!s) return [e];
              var t = s.decode(e.data, e.topics);
              e.args = t;
              var a = Array.prototype.slice.call(t);
              return a.push(e), a;
            },
            event: s,
            eventTag: A(n),
            filter: n
          };
        }, T.prototype._addEventListener = function (e, t, a) {
          var r = this;

          function n(a) {
            var n = p.deepCopy(a),
                s = e.prepareEvent(n);
            e.event && (n.decode = e.event.decode, n.event = e.event.name, n.eventSignature = e.event.signature), n.removeListener = function () {
              r.removeListener(e.filter, t);
            }, n.getBlock = function () {
              return r.provider.getBlock(a.blockHash);
            }, n.getTransaction = function () {
              return r.provider.getTransaction(a.transactionHash);
            }, n.getTransactionReceipt = function () {
              return r.provider.getTransactionReceipt(a.transactionHash);
            }, r.emit.apply(r, [e.filter].concat(s));
          }

          this.provider || c.throwError("events require a provider or a signer with a provider", c.UNSUPPORTED_OPERATION, {
            operation: "once"
          }), this.provider.on(e.filter, n), this._events.push({
            eventFilter: e,
            listener: t,
            wrappedListener: n,
            once: a
          });
        }, T.prototype.on = function (e, t) {
          return this._addEventListener(this._getEventFilter(e), t, !1), this;
        }, T.prototype.once = function (e, t) {
          return this._addEventListener(this._getEventFilter(e), t, !0), this;
        }, T.prototype.addListener = function (e, t) {
          return this.on(e, t);
        }, T.prototype.emit = function (e) {
          for (var t = this, a = [], r = 1; r < arguments.length; r++) {
            a[r - 1] = arguments[r];
          }

          if (!this.provider) return !1;

          var n = !1,
              s = this._getEventFilter(e);

          return this._events = this._events.filter(function (e) {
            return e.eventFilter.eventTag !== s.eventTag || (setTimeout(function () {
              e.listener.apply(t, a);
            }, 0), n = !0, !e.once);
          }), n;
        }, T.prototype.listenerCount = function (e) {
          if (!this.provider) return 0;

          var t = this._getEventFilter(e);

          return this._events.filter(function (e) {
            return e.eventFilter.eventTag === t.eventTag;
          }).length;
        }, T.prototype.listeners = function (e) {
          if (!this.provider) return [];

          var t = this._getEventFilter(e);

          return this._events.filter(function (e) {
            return e.eventFilter.eventTag === t.eventTag;
          }).map(function (e) {
            return e.listener;
          });
        }, T.prototype.removeAllListeners = function (e) {
          var t = this;
          if (!this.provider) return this;

          var a = this._getEventFilter(e);

          return this._events = this._events.filter(function (e) {
            return e.eventFilter.eventTag !== a.eventTag || (t.provider.removeListener(e.eventFilter.filter, e.wrappedListener), !1);
          }), this;
        }, T.prototype.removeListener = function (e, t) {
          var a = this;
          if (!this.provider) return this;

          var r = !1,
              n = this._getEventFilter(e);

          return this._events = this._events.filter(function (e) {
            return e.eventFilter.eventTag !== n.eventTag || e.listener !== t || (a.provider.removeListener(e.eventFilter.filter, e.wrappedListener), !!r || !(r = !0));
          }), this;
        }, T);

        function T(e, t, a) {
          var r = this;
          if (c.checkNew(this, T), h.Interface.isInterface(t) ? p.defineReadOnly(this, "interface", t) : p.defineReadOnly(this, "interface", new h.Interface(t)), m.Signer.isSigner(a) ? (p.defineReadOnly(this, "provider", a.provider), p.defineReadOnly(this, "signer", a)) : b.Provider.isProvider(a) ? (p.defineReadOnly(this, "provider", a), p.defineReadOnly(this, "signer", null)) : c.throwError("invalid signer or provider", c.INVALID_ARGUMENT, {
            arg: "signerOrProvider",
            value: a
          }), p.defineReadOnly(this, "estimate", {}), p.defineReadOnly(this, "functions", {}), p.defineReadOnly(this, "filters", {}), Object.keys(this.interface.events).forEach(function (e) {
            var t = r.interface.events[e];
            p.defineReadOnly(r.filters, e, function () {
              for (var e = [], a = 0; a < arguments.length; a++) {
                e[a] = arguments[a];
              }

              return {
                address: r.address,
                topics: t.encodeTopics(e)
              };
            });
          }), this._events = [], p.defineReadOnly(this, "address", e), this.provider) p.defineReadOnly(this, "addressPromise", this.provider.resolveName(e).then(function (e) {
            if (null == e) throw new Error("name not found");
            return e;
          }).catch(function (e) {
            throw e;
          }));else try {
            p.defineReadOnly(this, "addressPromise", Promise.resolve(d.getAddress(e)));
          } catch (t) {
            c.throwError("provider is required to use non-address contract address", c.INVALID_ARGUMENT, {
              argument: "addressOrName",
              value: e
            });
          }
          Object.keys(this.interface.functions).forEach(function (e) {
            var t = g(r, e, !1);
            null == r[e] ? p.defineReadOnly(r, e, t) : c.warn("WARNING: Multiple definitions for " + e), null == r.functions[e] && (p.defineReadOnly(r.functions, e, t), p.defineReadOnly(r.estimate, e, g(r, e, !0)));
          });
        }

        a.Contract = w;
        var x = (D.prototype.getDeployTransaction = function () {
          for (var e = [], t = 0; t < arguments.length; t++) {
            e[t] = arguments[t];
          }

          var a = {};
          if (e.length === this.interface.deployFunction.inputs.length + 1) for (var r in a = p.shallowCopy(e.pop())) {
            if (!_[r]) throw new Error("unknown transaction override " + r);
          }
          return ["data", "from", "to"].forEach(function (e) {
            null != a[e] && c.throwError("cannot override " + e, c.UNSUPPORTED_OPERATION, {
              operation: e
            });
          }), c.checkArgumentCount(e.length, this.interface.deployFunction.inputs.length, " in Contract constructor"), a.data = this.interface.deployFunction.encode(this.bytecode, e), a;
        }, D.prototype.deploy = function () {
          for (var e = this, t = [], a = 0; a < arguments.length; a++) {
            t[a] = arguments[a];
          }

          var r = this.getDeployTransaction.apply(this, t);
          return this.signer.sendTransaction(r).then(function (t) {
            var a = new w(d.getContractAddress(t), e.interface, e.signer);
            return p.defineReadOnly(a, "deployTransaction", t), a;
          });
        }, D.prototype.attach = function (e) {
          return new w(e, this.interface, this.signer);
        }, D.prototype.connect = function (e) {
          return new D(this.interface, this.bytecode, e);
        }, D.fromSolidity = function (e, t) {
          null == e && c.throwError("missing compiler output", c.MISSING_ARGUMENT, {
            argument: "compilerOutput"
          }), "string" == typeof e && (e = JSON.parse(e));
          var a = e.abi,
              r = null;
          return e.bytecode ? r = e.bytecode : e.evm && e.evm.bytecode && (r = e.evm.bytecode), new D(a, r, t);
        }, D);

        function D(e, t, a) {
          var r = null;
          "string" == typeof t ? r = t : l.isArrayish(t) ? r = l.hexlify(t) : "string" == typeof t.object ? r = t.object : c.throwError("bytecode must be a valid hex string", c.INVALID_ARGUMENT, {
            arg: "bytecode",
            value: t
          }), "0x" !== r.substring(0, 2) && (r = "0x" + r), l.isHexString(r) || c.throwError("bytecode must be a valid hex string", c.INVALID_ARGUMENT, {
            arg: "bytecode",
            value: t
          }), r.length % 2 != 0 && c.throwError("bytecode must be valid data (even length)", c.INVALID_ARGUMENT, {
            arg: "bytecode",
            value: t
          }), p.defineReadOnly(this, "bytecode", r), h.Interface.isInterface(e) ? p.defineReadOnly(this, "interface", e) : p.defineReadOnly(this, "interface", new h.Interface(e)), a && !m.Signer.isSigner(a) && c.throwError("invalid signer", c.INVALID_ARGUMENT, {
            arg: "signer",
            value: null
          }), p.defineReadOnly(this, "signer", a || null);
        }

        a.ContractFactory = x;
      }, {
        "./abstract-signer": 2,
        "./constants": 3,
        "./errors": 5,
        "./providers/abstract-provider": 49,
        "./utils/abi-coder": 58,
        "./utils/address": 59,
        "./utils/bignumber": 62,
        "./utils/bytes": 63,
        "./utils/interface": 68,
        "./utils/properties": 73
      }],
      5: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var r = e("./_version");
        a.UNKNOWN_ERROR = "UNKNOWN_ERROR", a.NOT_IMPLEMENTED = "NOT_IMPLEMENTED", a.MISSING_NEW = "MISSING_NEW", a.CALL_EXCEPTION = "CALL_EXCEPTION", a.INVALID_ARGUMENT = "INVALID_ARGUMENT", a.MISSING_ARGUMENT = "MISSING_ARGUMENT", a.UNEXPECTED_ARGUMENT = "UNEXPECTED_ARGUMENT", a.NUMERIC_FAULT = "NUMERIC_FAULT", a.INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS", a.NONCE_EXPIRED = "NONCE_EXPIRED", a.REPLACEMENT_UNDERPRICED = "REPLACEMENT_UNDERPRICED";
        var n = !(a.UNSUPPORTED_OPERATION = "UNSUPPORTED_OPERATION"),
            s = !1;

        function o(e, t, n) {
          if (s) throw new Error("unknown error");
          t = t || a.UNKNOWN_ERROR, n = n || {};
          var o = [];
          Object.keys(n).forEach(function (e) {
            try {
              o.push(e + "=" + JSON.stringify(n[e]));
            } catch (t) {
              o.push(e + "=" + JSON.stringify(n[e].toString()));
            }
          }), o.push("version=" + r.version);
          var i = e;
          o.length && (e += " (" + o.join(", ") + ")");
          var c = new Error(e);
          throw c.reason = i, c.code = t, Object.keys(n).forEach(function (e) {
            c[e] = n[e];
          }), c;
        }

        a.throwError = o, a.checkNew = function (e, t) {
          e instanceof t || o("missing new", a.MISSING_NEW, {
            name: t.name
          });
        }, a.checkArgumentCount = function (e, t, r) {
          r = r || "", e < t && o("missing argument" + r, a.MISSING_ARGUMENT, {
            count: e,
            expectedCount: t
          }), t < e && o("too many arguments" + r, a.UNEXPECTED_ARGUMENT, {
            count: e,
            expectedCount: t
          });
        }, a.setCensorship = function (e, t) {
          n && o("error censorship permanent", a.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
          }), s = !!e, n = !!t;
        }, a.checkNormalize = function () {
          try {
            if (["NFD", "NFC", "NFKD", "NFKC"].forEach(function (e) {
              try {
                "test".normalize(e);
              } catch (t) {
                throw new Error("missing " + e);
              }
            }), String.fromCharCode(233).normalize("NFD") !== String.fromCharCode(101, 769)) throw new Error("broken implementation");
          } catch (e) {
            o("platform missing String.prototype.normalize", a.UNSUPPORTED_OPERATION, {
              operation: "String.prototype.normalize",
              form: e.message
            });
          }
        };
        var i = {
          debug: 1,
          default: 2,
          info: 2,
          warn: 3,
          error: 4,
          off: 5
        },
            c = i.default;

        function u(e, t) {
          c > i[e] || console.log.apply(console, t);
        }

        function d() {
          for (var e = [], t = 0; t < arguments.length; t++) {
            e[t] = arguments[t];
          }

          u("warn", e);
        }

        a.setLogLevel = function (e) {
          var t = i[e];
          null != t ? c = t : d("invliad log level - " + e);
        }, a.warn = d, a.info = function () {
          for (var e = [], t = 0; t < arguments.length; t++) {
            e[t] = arguments[t];
          }

          u("info", e);
        };
      }, {
        "./_version": 1
      }],
      6: [function (e, t, a) {
        "use strict";

        var r = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var n = e("./contract");
        a.Contract = n.Contract, a.ContractFactory = n.ContractFactory, a.VoidSigner = n.VoidSigner;
        var s = e("./abstract-signer");
        a.Signer = s.Signer;
        var o = e("./wallet");
        a.Wallet = o.Wallet;
        var i = r(e("./constants"));
        a.constants = i;
        var c = r(e("./errors"));
        a.errors = c;
        var u = r(e("./providers"));
        a.providers = u;
        var d = r(e("./utils"));
        a.utils = d;
        var f = r(e("./wordlists"));
        a.wordlists = f;
        var l = e("./utils/shims");
        a.platform = l.platform;
        var h = e("./_version");
        a.version = h.version, a.getDefaultProvider = function (e) {
          null == e && (e = "homestead");
          var t = d.getNetwork(e);
          return t && t._defaultProvider || c.throwError("unsupported getDefaultProvider network", c.UNSUPPORTED_OPERATION, {
            operation: "getDefaultProvider",
            network: e
          }), t._defaultProvider(u);
        };
      }, {
        "./_version": 1,
        "./abstract-signer": 2,
        "./constants": 3,
        "./contract": 4,
        "./errors": 5,
        "./providers": 53,
        "./utils": 67,
        "./utils/shims": 79,
        "./wallet": 87,
        "./wordlists": 88
      }],
      7: [function (e, t, a) {
        "use strict";

        var r = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var n = r(e("./ethers"));
        a.ethers = n, function (e) {
          for (var t in e) {
            a.hasOwnProperty(t) || (a[t] = e[t]);
          }
        }(e("./ethers"));
      }, {
        "./ethers": 6
      }],
      8: [function (e, t, a) {
        "use strict";

        !function (e) {
          function r(e) {
            return parseInt(e) === e;
          }

          function n(e) {
            if (!r(e.length)) return !1;

            for (var t = 0; t < e.length; t++) {
              if (!r(e[t]) || e[t] < 0 || 255 < e[t]) return !1;
            }

            return !0;
          }

          function s(e, t) {
            if (e.buffer && ArrayBuffer.isView(e) && "Uint8Array" === e.name) return t && (e = e.slice ? e.slice() : Array.prototype.slice.call(e)), e;

            if (Array.isArray(e)) {
              if (!n(e)) throw new Error("Array contains invalid value: " + e);
              return new Uint8Array(e);
            }

            if (r(e.length) && n(e)) return new Uint8Array(e);
            throw new Error("unsupported array-like object");
          }

          function o(e) {
            return new Uint8Array(e);
          }

          function i(e, t, a, r, n) {
            null == r && null == n || (e = e.slice ? e.slice(r, n) : Array.prototype.slice.call(e, r, n)), t.set(e, a);
          }

          var c,
              u = {
            toBytes: function toBytes(e) {
              var t = [],
                  a = 0;

              for (e = encodeURI(e); a < e.length;) {
                var r = e.charCodeAt(a++);
                37 === r ? (t.push(parseInt(e.substr(a, 2), 16)), a += 2) : t.push(r);
              }

              return s(t);
            },
            fromBytes: function fromBytes(e) {
              for (var t = [], a = 0; a < e.length;) {
                var r = e[a];
                r < 128 ? (t.push(String.fromCharCode(r)), a++) : 191 < r && r < 224 ? (t.push(String.fromCharCode((31 & r) << 6 | 63 & e[a + 1])), a += 2) : (t.push(String.fromCharCode((15 & r) << 12 | (63 & e[a + 1]) << 6 | 63 & e[a + 2])), a += 3);
              }

              return t.join("");
            }
          },
              d = (c = "0123456789abcdef", {
            toBytes: function toBytes(e) {
              for (var t = [], a = 0; a < e.length; a += 2) {
                t.push(parseInt(e.substr(a, 2), 16));
              }

              return t;
            },
            fromBytes: function fromBytes(e) {
              for (var t = [], a = 0; a < e.length; a++) {
                var r = e[a];
                t.push(c[(240 & r) >> 4] + c[15 & r]);
              }

              return t.join("");
            }
          }),
              f = {
            16: 10,
            24: 12,
            32: 14
          },
              l = [1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145],
              h = [99, 124, 119, 123, 242, 107, 111, 197, 48, 1, 103, 43, 254, 215, 171, 118, 202, 130, 201, 125, 250, 89, 71, 240, 173, 212, 162, 175, 156, 164, 114, 192, 183, 253, 147, 38, 54, 63, 247, 204, 52, 165, 229, 241, 113, 216, 49, 21, 4, 199, 35, 195, 24, 150, 5, 154, 7, 18, 128, 226, 235, 39, 178, 117, 9, 131, 44, 26, 27, 110, 90, 160, 82, 59, 214, 179, 41, 227, 47, 132, 83, 209, 0, 237, 32, 252, 177, 91, 106, 203, 190, 57, 74, 76, 88, 207, 208, 239, 170, 251, 67, 77, 51, 133, 69, 249, 2, 127, 80, 60, 159, 168, 81, 163, 64, 143, 146, 157, 56, 245, 188, 182, 218, 33, 16, 255, 243, 210, 205, 12, 19, 236, 95, 151, 68, 23, 196, 167, 126, 61, 100, 93, 25, 115, 96, 129, 79, 220, 34, 42, 144, 136, 70, 238, 184, 20, 222, 94, 11, 219, 224, 50, 58, 10, 73, 6, 36, 92, 194, 211, 172, 98, 145, 149, 228, 121, 231, 200, 55, 109, 141, 213, 78, 169, 108, 86, 244, 234, 101, 122, 174, 8, 186, 120, 37, 46, 28, 166, 180, 198, 232, 221, 116, 31, 75, 189, 139, 138, 112, 62, 181, 102, 72, 3, 246, 14, 97, 53, 87, 185, 134, 193, 29, 158, 225, 248, 152, 17, 105, 217, 142, 148, 155, 30, 135, 233, 206, 85, 40, 223, 140, 161, 137, 13, 191, 230, 66, 104, 65, 153, 45, 15, 176, 84, 187, 22],
              p = [82, 9, 106, 213, 48, 54, 165, 56, 191, 64, 163, 158, 129, 243, 215, 251, 124, 227, 57, 130, 155, 47, 255, 135, 52, 142, 67, 68, 196, 222, 233, 203, 84, 123, 148, 50, 166, 194, 35, 61, 238, 76, 149, 11, 66, 250, 195, 78, 8, 46, 161, 102, 40, 217, 36, 178, 118, 91, 162, 73, 109, 139, 209, 37, 114, 248, 246, 100, 134, 104, 152, 22, 212, 164, 92, 204, 93, 101, 182, 146, 108, 112, 72, 80, 253, 237, 185, 218, 94, 21, 70, 87, 167, 141, 157, 132, 144, 216, 171, 0, 140, 188, 211, 10, 247, 228, 88, 5, 184, 179, 69, 6, 208, 44, 30, 143, 202, 63, 15, 2, 193, 175, 189, 3, 1, 19, 138, 107, 58, 145, 17, 65, 79, 103, 220, 234, 151, 242, 207, 206, 240, 180, 230, 115, 150, 172, 116, 34, 231, 173, 53, 133, 226, 249, 55, 232, 28, 117, 223, 110, 71, 241, 26, 113, 29, 41, 197, 137, 111, 183, 98, 14, 170, 24, 190, 27, 252, 86, 62, 75, 198, 210, 121, 32, 154, 219, 192, 254, 120, 205, 90, 244, 31, 221, 168, 51, 136, 7, 199, 49, 177, 18, 16, 89, 39, 128, 236, 95, 96, 81, 127, 169, 25, 181, 74, 13, 45, 229, 122, 159, 147, 201, 156, 239, 160, 224, 59, 77, 174, 42, 245, 176, 200, 235, 187, 60, 131, 83, 153, 97, 23, 43, 4, 126, 186, 119, 214, 38, 225, 105, 20, 99, 85, 33, 12, 125],
              b = [3328402341, 4168907908, 4000806809, 4135287693, 4294111757, 3597364157, 3731845041, 2445657428, 1613770832, 33620227, 3462883241, 1445669757, 3892248089, 3050821474, 1303096294, 3967186586, 2412431941, 528646813, 2311702848, 4202528135, 4026202645, 2992200171, 2387036105, 4226871307, 1101901292, 3017069671, 1604494077, 1169141738, 597466303, 1403299063, 3832705686, 2613100635, 1974974402, 3791519004, 1033081774, 1277568618, 1815492186, 2118074177, 4126668546, 2211236943, 1748251740, 1369810420, 3521504564, 4193382664, 3799085459, 2883115123, 1647391059, 706024767, 134480908, 2512897874, 1176707941, 2646852446, 806885416, 932615841, 168101135, 798661301, 235341577, 605164086, 461406363, 3756188221, 3454790438, 1311188841, 2142417613, 3933566367, 302582043, 495158174, 1479289972, 874125870, 907746093, 3698224818, 3025820398, 1537253627, 2756858614, 1983593293, 3084310113, 2108928974, 1378429307, 3722699582, 1580150641, 327451799, 2790478837, 3117535592, 0, 3253595436, 1075847264, 3825007647, 2041688520, 3059440621, 3563743934, 2378943302, 1740553945, 1916352843, 2487896798, 2555137236, 2958579944, 2244988746, 3151024235, 3320835882, 1336584933, 3992714006, 2252555205, 2588757463, 1714631509, 293963156, 2319795663, 3925473552, 67240454, 4269768577, 2689618160, 2017213508, 631218106, 1269344483, 2723238387, 1571005438, 2151694528, 93294474, 1066570413, 563977660, 1882732616, 4059428100, 1673313503, 2008463041, 2950355573, 1109467491, 537923632, 3858759450, 4260623118, 3218264685, 2177748300, 403442708, 638784309, 3287084079, 3193921505, 899127202, 2286175436, 773265209, 2479146071, 1437050866, 4236148354, 2050833735, 3362022572, 3126681063, 840505643, 3866325909, 3227541664, 427917720, 2655997905, 2749160575, 1143087718, 1412049534, 999329963, 193497219, 2353415882, 3354324521, 1807268051, 672404540, 2816401017, 3160301282, 369822493, 2916866934, 3688947771, 1681011286, 1949973070, 336202270, 2454276571, 201721354, 1210328172, 3093060836, 2680341085, 3184776046, 1135389935, 3294782118, 965841320, 831886756, 3554993207, 4068047243, 3588745010, 2345191491, 1849112409, 3664604599, 26054028, 2983581028, 2622377682, 1235855840, 3630984372, 2891339514, 4092916743, 3488279077, 3395642799, 4101667470, 1202630377, 268961816, 1874508501, 4034427016, 1243948399, 1546530418, 941366308, 1470539505, 1941222599, 2546386513, 3421038627, 2715671932, 3899946140, 1042226977, 2521517021, 1639824860, 227249030, 260737669, 3765465232, 2084453954, 1907733956, 3429263018, 2420656344, 100860677, 4160157185, 470683154, 3261161891, 1781871967, 2924959737, 1773779408, 394692241, 2579611992, 974986535, 664706745, 3655459128, 3958962195, 731420851, 571543859, 3530123707, 2849626480, 126783113, 865375399, 765172662, 1008606754, 361203602, 3387549984, 2278477385, 2857719295, 1344809080, 2782912378, 59542671, 1503764984, 160008576, 437062935, 1707065306, 3622233649, 2218934982, 3496503480, 2185314755, 697932208, 1512910199, 504303377, 2075177163, 2824099068, 1841019862, 739644986],
              m = [2781242211, 2230877308, 2582542199, 2381740923, 234877682, 3184946027, 2984144751, 1418839493, 1348481072, 50462977, 2848876391, 2102799147, 434634494, 1656084439, 3863849899, 2599188086, 1167051466, 2636087938, 1082771913, 2281340285, 368048890, 3954334041, 3381544775, 201060592, 3963727277, 1739838676, 4250903202, 3930435503, 3206782108, 4149453988, 2531553906, 1536934080, 3262494647, 484572669, 2923271059, 1783375398, 1517041206, 1098792767, 49674231, 1334037708, 1550332980, 4098991525, 886171109, 150598129, 2481090929, 1940642008, 1398944049, 1059722517, 201851908, 1385547719, 1699095331, 1587397571, 674240536, 2704774806, 252314885, 3039795866, 151914247, 908333586, 2602270848, 1038082786, 651029483, 1766729511, 3447698098, 2682942837, 454166793, 2652734339, 1951935532, 775166490, 758520603, 3000790638, 4004797018, 4217086112, 4137964114, 1299594043, 1639438038, 3464344499, 2068982057, 1054729187, 1901997871, 2534638724, 4121318227, 1757008337, 0, 750906861, 1614815264, 535035132, 3363418545, 3988151131, 3201591914, 1183697867, 3647454910, 1265776953, 3734260298, 3566750796, 3903871064, 1250283471, 1807470800, 717615087, 3847203498, 384695291, 3313910595, 3617213773, 1432761139, 2484176261, 3481945413, 283769337, 100925954, 2180939647, 4037038160, 1148730428, 3123027871, 3813386408, 4087501137, 4267549603, 3229630528, 2315620239, 2906624658, 3156319645, 1215313976, 82966005, 3747855548, 3245848246, 1974459098, 1665278241, 807407632, 451280895, 251524083, 1841287890, 1283575245, 337120268, 891687699, 801369324, 3787349855, 2721421207, 3431482436, 959321879, 1469301956, 4065699751, 2197585534, 1199193405, 2898814052, 3887750493, 724703513, 2514908019, 2696962144, 2551808385, 3516813135, 2141445340, 1715741218, 2119445034, 2872807568, 2198571144, 3398190662, 700968686, 3547052216, 1009259540, 2041044702, 3803995742, 487983883, 1991105499, 1004265696, 1449407026, 1316239930, 504629770, 3683797321, 168560134, 1816667172, 3837287516, 1570751170, 1857934291, 4014189740, 2797888098, 2822345105, 2754712981, 936633572, 2347923833, 852879335, 1133234376, 1500395319, 3084545389, 2348912013, 1689376213, 3533459022, 3762923945, 3034082412, 4205598294, 133428468, 634383082, 2949277029, 2398386810, 3913789102, 403703816, 3580869306, 2297460856, 1867130149, 1918643758, 607656988, 4049053350, 3346248884, 1368901318, 600565992, 2090982877, 2632479860, 557719327, 3717614411, 3697393085, 2249034635, 2232388234, 2430627952, 1115438654, 3295786421, 2865522278, 3633334344, 84280067, 33027830, 303828494, 2747425121, 1600795957, 4188952407, 3496589753, 2434238086, 1486471617, 658119965, 3106381470, 953803233, 334231800, 3005978776, 857870609, 3151128937, 1890179545, 2298973838, 2805175444, 3056442267, 574365214, 2450884487, 550103529, 1233637070, 4289353045, 2018519080, 2057691103, 2399374476, 4166623649, 2148108681, 387583245, 3664101311, 836232934, 3330556482, 3100665960, 3280093505, 2955516313, 2002398509, 287182607, 3413881008, 4238890068, 3597515707, 975967766],
              y = [1671808611, 2089089148, 2006576759, 2072901243, 4061003762, 1807603307, 1873927791, 3310653893, 810573872, 16974337, 1739181671, 729634347, 4263110654, 3613570519, 2883997099, 1989864566, 3393556426, 2191335298, 3376449993, 2106063485, 4195741690, 1508618841, 1204391495, 4027317232, 2917941677, 3563566036, 2734514082, 2951366063, 2629772188, 2767672228, 1922491506, 3227229120, 3082974647, 4246528509, 2477669779, 644500518, 911895606, 1061256767, 4144166391, 3427763148, 878471220, 2784252325, 3845444069, 4043897329, 1905517169, 3631459288, 827548209, 356461077, 67897348, 3344078279, 593839651, 3277757891, 405286936, 2527147926, 84871685, 2595565466, 118033927, 305538066, 2157648768, 3795705826, 3945188843, 661212711, 2999812018, 1973414517, 152769033, 2208177539, 745822252, 439235610, 455947803, 1857215598, 1525593178, 2700827552, 1391895634, 994932283, 3596728278, 3016654259, 695947817, 3812548067, 795958831, 2224493444, 1408607827, 3513301457, 0, 3979133421, 543178784, 4229948412, 2982705585, 1542305371, 1790891114, 3410398667, 3201918910, 961245753, 1256100938, 1289001036, 1491644504, 3477767631, 3496721360, 4012557807, 2867154858, 4212583931, 1137018435, 1305975373, 861234739, 2241073541, 1171229253, 4178635257, 33948674, 2139225727, 1357946960, 1011120188, 2679776671, 2833468328, 1374921297, 2751356323, 1086357568, 2408187279, 2460827538, 2646352285, 944271416, 4110742005, 3168756668, 3066132406, 3665145818, 560153121, 271589392, 4279952895, 4077846003, 3530407890, 3444343245, 202643468, 322250259, 3962553324, 1608629855, 2543990167, 1154254916, 389623319, 3294073796, 2817676711, 2122513534, 1028094525, 1689045092, 1575467613, 422261273, 1939203699, 1621147744, 2174228865, 1339137615, 3699352540, 577127458, 712922154, 2427141008, 2290289544, 1187679302, 3995715566, 3100863416, 339486740, 3732514782, 1591917662, 186455563, 3681988059, 3762019296, 844522546, 978220090, 169743370, 1239126601, 101321734, 611076132, 1558493276, 3260915650, 3547250131, 2901361580, 1655096418, 2443721105, 2510565781, 3828863972, 2039214713, 3878868455, 3359869896, 928607799, 1840765549, 2374762893, 3580146133, 1322425422, 2850048425, 1823791212, 1459268694, 4094161908, 3928346602, 1706019429, 2056189050, 2934523822, 135794696, 3134549946, 2022240376, 628050469, 779246638, 472135708, 2800834470, 3032970164, 3327236038, 3894660072, 3715932637, 1956440180, 522272287, 1272813131, 3185336765, 2340818315, 2323976074, 1888542832, 1044544574, 3049550261, 1722469478, 1222152264, 50660867, 4127324150, 236067854, 1638122081, 895445557, 1475980887, 3117443513, 2257655686, 3243809217, 489110045, 2662934430, 3778599393, 4162055160, 2561878936, 288563729, 1773916777, 3648039385, 2391345038, 2493985684, 2612407707, 505560094, 2274497927, 3911240169, 3460925390, 1442818645, 678973480, 3749357023, 2358182796, 2717407649, 2306869641, 219617805, 3218761151, 3862026214, 1120306242, 1756942440, 1103331905, 2578459033, 762796589, 252780047, 2966125488, 1425844308, 3151392187, 372911126],
              v = [1667474886, 2088535288, 2004326894, 2071694838, 4075949567, 1802223062, 1869591006, 3318043793, 808472672, 16843522, 1734846926, 724270422, 4278065639, 3621216949, 2880169549, 1987484396, 3402253711, 2189597983, 3385409673, 2105378810, 4210693615, 1499065266, 1195886990, 4042263547, 2913856577, 3570689971, 2728590687, 2947541573, 2627518243, 2762274643, 1920112356, 3233831835, 3082273397, 4261223649, 2475929149, 640051788, 909531756, 1061110142, 4160160501, 3435941763, 875846760, 2779116625, 3857003729, 4059105529, 1903268834, 3638064043, 825316194, 353713962, 67374088, 3351728789, 589522246, 3284360861, 404236336, 2526454071, 84217610, 2593830191, 117901582, 303183396, 2155911963, 3806477791, 3958056653, 656894286, 2998062463, 1970642922, 151591698, 2206440989, 741110872, 437923380, 454765878, 1852748508, 1515908788, 2694904667, 1381168804, 993742198, 3604373943, 3014905469, 690584402, 3823320797, 791638366, 2223281939, 1398011302, 3520161977, 0, 3991743681, 538992704, 4244381667, 2981218425, 1532751286, 1785380564, 3419096717, 3200178535, 960056178, 1246420628, 1280103576, 1482221744, 3486468741, 3503319995, 4025428677, 2863326543, 4227536621, 1128514950, 1296947098, 859002214, 2240123921, 1162203018, 4193849577, 33687044, 2139062782, 1347481760, 1010582648, 2678045221, 2829640523, 1364325282, 2745433693, 1077985408, 2408548869, 2459086143, 2644360225, 943212656, 4126475505, 3166494563, 3065430391, 3671750063, 555836226, 269496352, 4294908645, 4092792573, 3537006015, 3452783745, 202118168, 320025894, 3974901699, 1600119230, 2543297077, 1145359496, 387397934, 3301201811, 2812801621, 2122220284, 1027426170, 1684319432, 1566435258, 421079858, 1936954854, 1616945344, 2172753945, 1330631070, 3705438115, 572679748, 707427924, 2425400123, 2290647819, 1179044492, 4008585671, 3099120491, 336870440, 3739122087, 1583276732, 185277718, 3688593069, 3772791771, 842159716, 976899700, 168435220, 1229577106, 101059084, 606366792, 1549591736, 3267517855, 3553849021, 2897014595, 1650632388, 2442242105, 2509612081, 3840161747, 2038008818, 3890688725, 3368567691, 926374254, 1835907034, 2374863873, 3587531953, 1313788572, 2846482505, 1819063512, 1448540844, 4109633523, 3941213647, 1701162954, 2054852340, 2930698567, 134748176, 3132806511, 2021165296, 623210314, 774795868, 471606328, 2795958615, 3031746419, 3334885783, 3907527627, 3722280097, 1953799400, 522133822, 1263263126, 3183336545, 2341176845, 2324333839, 1886425312, 1044267644, 3048588401, 1718004428, 1212733584, 50529542, 4143317495, 235803164, 1633788866, 892690282, 1465383342, 3115962473, 2256965911, 3250673817, 488449850, 2661202215, 3789633753, 4177007595, 2560144171, 286339874, 1768537042, 3654906025, 2391705863, 2492770099, 2610673197, 505291324, 2273808917, 3924369609, 3469625735, 1431699370, 673740880, 3755965093, 2358021891, 2711746649, 2307489801, 218961690, 3217021541, 3873845719, 1111672452, 1751693520, 1094828930, 2576986153, 757954394, 252645662, 2964376443, 1414855848, 3149649517, 370555436],
              _ = [1374988112, 2118214995, 437757123, 975658646, 1001089995, 530400753, 2902087851, 1273168787, 540080725, 2910219766, 2295101073, 4110568485, 1340463100, 3307916247, 641025152, 3043140495, 3736164937, 632953703, 1172967064, 1576976609, 3274667266, 2169303058, 2370213795, 1809054150, 59727847, 361929877, 3211623147, 2505202138, 3569255213, 1484005843, 1239443753, 2395588676, 1975683434, 4102977912, 2572697195, 666464733, 3202437046, 4035489047, 3374361702, 2110667444, 1675577880, 3843699074, 2538681184, 1649639237, 2976151520, 3144396420, 4269907996, 4178062228, 1883793496, 2403728665, 2497604743, 1383856311, 2876494627, 1917518562, 3810496343, 1716890410, 3001755655, 800440835, 2261089178, 3543599269, 807962610, 599762354, 33778362, 3977675356, 2328828971, 2809771154, 4077384432, 1315562145, 1708848333, 101039829, 3509871135, 3299278474, 875451293, 2733856160, 92987698, 2767645557, 193195065, 1080094634, 1584504582, 3178106961, 1042385657, 2531067453, 3711829422, 1306967366, 2438237621, 1908694277, 67556463, 1615861247, 429456164, 3602770327, 2302690252, 1742315127, 2968011453, 126454664, 3877198648, 2043211483, 2709260871, 2084704233, 4169408201, 0, 159417987, 841739592, 504459436, 1817866830, 4245618683, 260388950, 1034867998, 908933415, 168810852, 1750902305, 2606453969, 607530554, 202008497, 2472011535, 3035535058, 463180190, 2160117071, 1641816226, 1517767529, 470948374, 3801332234, 3231722213, 1008918595, 303765277, 235474187, 4069246893, 766945465, 337553864, 1475418501, 2943682380, 4003061179, 2743034109, 4144047775, 1551037884, 1147550661, 1543208500, 2336434550, 3408119516, 3069049960, 3102011747, 3610369226, 1113818384, 328671808, 2227573024, 2236228733, 3535486456, 2935566865, 3341394285, 496906059, 3702665459, 226906860, 2009195472, 733156972, 2842737049, 294930682, 1206477858, 2835123396, 2700099354, 1451044056, 573804783, 2269728455, 3644379585, 2362090238, 2564033334, 2801107407, 2776292904, 3669462566, 1068351396, 742039012, 1350078989, 1784663195, 1417561698, 4136440770, 2430122216, 775550814, 2193862645, 2673705150, 1775276924, 1876241833, 3475313331, 3366754619, 270040487, 3902563182, 3678124923, 3441850377, 1851332852, 3969562369, 2203032232, 3868552805, 2868897406, 566021896, 4011190502, 3135740889, 1248802510, 3936291284, 699432150, 832877231, 708780849, 3332740144, 899835584, 1951317047, 4236429990, 3767586992, 866637845, 4043610186, 1106041591, 2144161806, 395441711, 1984812685, 1139781709, 3433712980, 3835036895, 2664543715, 1282050075, 3240894392, 1181045119, 2640243204, 25965917, 4203181171, 4211818798, 3009879386, 2463879762, 3910161971, 1842759443, 2597806476, 933301370, 1509430414, 3943906441, 3467192302, 3076639029, 3776767469, 2051518780, 2631065433, 1441952575, 404016761, 1942435775, 1408749034, 1610459739, 3745345300, 2017778566, 3400528769, 3110650942, 941896748, 3265478751, 371049330, 3168937228, 675039627, 4279080257, 967311729, 135050206, 3635733660, 1683407248, 2076935265, 3576870512, 1215061108, 3501741890],
              g = [1347548327, 1400783205, 3273267108, 2520393566, 3409685355, 4045380933, 2880240216, 2471224067, 1428173050, 4138563181, 2441661558, 636813900, 4233094615, 3620022987, 2149987652, 2411029155, 1239331162, 1730525723, 2554718734, 3781033664, 46346101, 310463728, 2743944855, 3328955385, 3875770207, 2501218972, 3955191162, 3667219033, 768917123, 3545789473, 692707433, 1150208456, 1786102409, 2029293177, 1805211710, 3710368113, 3065962831, 401639597, 1724457132, 3028143674, 409198410, 2196052529, 1620529459, 1164071807, 3769721975, 2226875310, 486441376, 2499348523, 1483753576, 428819965, 2274680428, 3075636216, 598438867, 3799141122, 1474502543, 711349675, 129166120, 53458370, 2592523643, 2782082824, 4063242375, 2988687269, 3120694122, 1559041666, 730517276, 2460449204, 4042459122, 2706270690, 3446004468, 3573941694, 533804130, 2328143614, 2637442643, 2695033685, 839224033, 1973745387, 957055980, 2856345839, 106852767, 1371368976, 4181598602, 1033297158, 2933734917, 1179510461, 3046200461, 91341917, 1862534868, 4284502037, 605657339, 2547432937, 3431546947, 2003294622, 3182487618, 2282195339, 954669403, 3682191598, 1201765386, 3917234703, 3388507166, 0, 2198438022, 1211247597, 2887651696, 1315723890, 4227665663, 1443857720, 507358933, 657861945, 1678381017, 560487590, 3516619604, 975451694, 2970356327, 261314535, 3535072918, 2652609425, 1333838021, 2724322336, 1767536459, 370938394, 182621114, 3854606378, 1128014560, 487725847, 185469197, 2918353863, 3106780840, 3356761769, 2237133081, 1286567175, 3152976349, 4255350624, 2683765030, 3160175349, 3309594171, 878443390, 1988838185, 3704300486, 1756818940, 1673061617, 3403100636, 272786309, 1075025698, 545572369, 2105887268, 4174560061, 296679730, 1841768865, 1260232239, 4091327024, 3960309330, 3497509347, 1814803222, 2578018489, 4195456072, 575138148, 3299409036, 446754879, 3629546796, 4011996048, 3347532110, 3252238545, 4270639778, 915985419, 3483825537, 681933534, 651868046, 2755636671, 3828103837, 223377554, 2607439820, 1649704518, 3270937875, 3901806776, 1580087799, 4118987695, 3198115200, 2087309459, 2842678573, 3016697106, 1003007129, 2802849917, 1860738147, 2077965243, 164439672, 4100872472, 32283319, 2827177882, 1709610350, 2125135846, 136428751, 3874428392, 3652904859, 3460984630, 3572145929, 3593056380, 2939266226, 824852259, 818324884, 3224740454, 930369212, 2801566410, 2967507152, 355706840, 1257309336, 4148292826, 243256656, 790073846, 2373340630, 1296297904, 1422699085, 3756299780, 3818836405, 457992840, 3099667487, 2135319889, 77422314, 1560382517, 1945798516, 788204353, 1521706781, 1385356242, 870912086, 325965383, 2358957921, 2050466060, 2388260884, 2313884476, 4006521127, 901210569, 3990953189, 1014646705, 1503449823, 1062597235, 2031621326, 3212035895, 3931371469, 1533017514, 350174575, 2256028891, 2177544179, 1052338372, 741876788, 1606591296, 1914052035, 213705253, 2334669897, 1107234197, 1899603969, 3725069491, 2631447780, 2422494913, 1635502980, 1893020342, 1950903388, 1120974935],
              A = [2807058932, 1699970625, 2764249623, 1586903591, 1808481195, 1173430173, 1487645946, 59984867, 4199882800, 1844882806, 1989249228, 1277555970, 3623636965, 3419915562, 1149249077, 2744104290, 1514790577, 459744698, 244860394, 3235995134, 1963115311, 4027744588, 2544078150, 4190530515, 1608975247, 2627016082, 2062270317, 1507497298, 2200818878, 567498868, 1764313568, 3359936201, 2305455554, 2037970062, 1047239e3, 1910319033, 1337376481, 2904027272, 2892417312, 984907214, 1243112415, 830661914, 861968209, 2135253587, 2011214180, 2927934315, 2686254721, 731183368, 1750626376, 4246310725, 1820824798, 4172763771, 3542330227, 48394827, 2404901663, 2871682645, 671593195, 3254988725, 2073724613, 145085239, 2280796200, 2779915199, 1790575107, 2187128086, 472615631, 3029510009, 4075877127, 3802222185, 4107101658, 3201631749, 1646252340, 4270507174, 1402811438, 1436590835, 3778151818, 3950355702, 3963161475, 4020912224, 2667994737, 273792366, 2331590177, 104699613, 95345982, 3175501286, 2377486676, 1560637892, 3564045318, 369057872, 4213447064, 3919042237, 1137477952, 2658625497, 1119727848, 2340947849, 1530455833, 4007360968, 172466556, 266959938, 516552836, 0, 2256734592, 3980931627, 1890328081, 1917742170, 4294704398, 945164165, 3575528878, 958871085, 3647212047, 2787207260, 1423022939, 775562294, 1739656202, 3876557655, 2530391278, 2443058075, 3310321856, 547512796, 1265195639, 437656594, 3121275539, 719700128, 3762502690, 387781147, 218828297, 3350065803, 2830708150, 2848461854, 428169201, 122466165, 3720081049, 1627235199, 648017665, 4122762354, 1002783846, 2117360635, 695634755, 3336358691, 4234721005, 4049844452, 3704280881, 2232435299, 574624663, 287343814, 612205898, 1039717051, 840019705, 2708326185, 793451934, 821288114, 1391201670, 3822090177, 376187827, 3113855344, 1224348052, 1679968233, 2361698556, 1058709744, 752375421, 2431590963, 1321699145, 3519142200, 2734591178, 188127444, 2177869557, 3727205754, 2384911031, 3215212461, 2648976442, 2450346104, 3432737375, 1180849278, 331544205, 3102249176, 4150144569, 2952102595, 2159976285, 2474404304, 766078933, 313773861, 2570832044, 2108100632, 1668212892, 3145456443, 2013908262, 418672217, 3070356634, 2594734927, 1852171925, 3867060991, 3473416636, 3907448597, 2614737639, 919489135, 164948639, 2094410160, 2997825956, 590424639, 2486224549, 1723872674, 3157750862, 3399941250, 3501252752, 3625268135, 2555048196, 3673637356, 1343127501, 4130281361, 3599595085, 2957853679, 1297403050, 81781910, 3051593425, 2283490410, 532201772, 1367295589, 3926170974, 895287692, 1953757831, 1093597963, 492483431, 3528626907, 1446242576, 1192455638, 1636604631, 209336225, 344873464, 1015671571, 669961897, 3375740769, 3857572124, 2973530695, 3747192018, 1933530610, 3464042516, 935293895, 3454686199, 2858115069, 1863638845, 3683022916, 4085369519, 3292445032, 875313188, 1080017571, 3279033885, 621591778, 1233856572, 2504130317, 24197544, 3017672716, 3835484340, 3247465558, 2220981195, 3060847922, 1551124588, 1463996600],
              w = [4104605777, 1097159550, 396673818, 660510266, 2875968315, 2638606623, 4200115116, 3808662347, 821712160, 1986918061, 3430322568, 38544885, 3856137295, 718002117, 893681702, 1654886325, 2975484382, 3122358053, 3926825029, 4274053469, 796197571, 1290801793, 1184342925, 3556361835, 2405426947, 2459735317, 1836772287, 1381620373, 3196267988, 1948373848, 3764988233, 3385345166, 3263785589, 2390325492, 1480485785, 3111247143, 3780097726, 2293045232, 548169417, 3459953789, 3746175075, 439452389, 1362321559, 1400849762, 1685577905, 1806599355, 2174754046, 137073913, 1214797936, 1174215055, 3731654548, 2079897426, 1943217067, 1258480242, 529487843, 1437280870, 3945269170, 3049390895, 3313212038, 923313619, 679998e3, 3215307299, 57326082, 377642221, 3474729866, 2041877159, 133361907, 1776460110, 3673476453, 96392454, 878845905, 2801699524, 777231668, 4082475170, 2330014213, 4142626212, 2213296395, 1626319424, 1906247262, 1846563261, 562755902, 3708173718, 1040559837, 3871163981, 1418573201, 3294430577, 114585348, 1343618912, 2566595609, 3186202582, 1078185097, 3651041127, 3896688048, 2307622919, 425408743, 3371096953, 2081048481, 1108339068, 2216610296, 0, 2156299017, 736970802, 292596766, 1517440620, 251657213, 2235061775, 2933202493, 758720310, 265905162, 1554391400, 1532285339, 908999204, 174567692, 1474760595, 4002861748, 2610011675, 3234156416, 3693126241, 2001430874, 303699484, 2478443234, 2687165888, 585122620, 454499602, 151849742, 2345119218, 3064510765, 514443284, 4044981591, 1963412655, 2581445614, 2137062819, 19308535, 1928707164, 1715193156, 4219352155, 1126790795, 600235211, 3992742070, 3841024952, 836553431, 1669664834, 2535604243, 3323011204, 1243905413, 3141400786, 4180808110, 698445255, 2653899549, 2989552604, 2253581325, 3252932727, 3004591147, 1891211689, 2487810577, 3915653703, 4237083816, 4030667424, 2100090966, 865136418, 1229899655, 953270745, 3399679628, 3557504664, 4118925222, 2061379749, 3079546586, 2915017791, 983426092, 2022837584, 1607244650, 2118541908, 2366882550, 3635996816, 972512814, 3283088770, 1568718495, 3499326569, 3576539503, 621982671, 2895723464, 410887952, 2623762152, 1002142683, 645401037, 1494807662, 2595684844, 1335535747, 2507040230, 4293295786, 3167684641, 367585007, 3885750714, 1865862730, 2668221674, 2960971305, 2763173681, 1059270954, 2777952454, 2724642869, 1320957812, 2194319100, 2429595872, 2815956275, 77089521, 3973773121, 3444575871, 2448830231, 1305906550, 4021308739, 2857194700, 2516901860, 3518358430, 1787304780, 740276417, 1699839814, 1592394909, 2352307457, 2272556026, 188821243, 1729977011, 3687994002, 274084841, 3594982253, 3613494426, 2701949495, 4162096729, 322734571, 2837966542, 1640576439, 484830689, 1202797690, 3537852828, 4067639125, 349075736, 3342319475, 4157467219, 4255800159, 1030690015, 1155237496, 2951971274, 1757691577, 607398968, 2738905026, 499347990, 3794078908, 1011452712, 227885567, 2818666809, 213114376, 3034881240, 1455525988, 3414450555, 850817237, 1817998408, 3092726480],
              T = [0, 235474187, 470948374, 303765277, 941896748, 908933415, 607530554, 708780849, 1883793496, 2118214995, 1817866830, 1649639237, 1215061108, 1181045119, 1417561698, 1517767529, 3767586992, 4003061179, 4236429990, 4069246893, 3635733660, 3602770327, 3299278474, 3400528769, 2430122216, 2664543715, 2362090238, 2193862645, 2835123396, 2801107407, 3035535058, 3135740889, 3678124923, 3576870512, 3341394285, 3374361702, 3810496343, 3977675356, 4279080257, 4043610186, 2876494627, 2776292904, 3076639029, 3110650942, 2472011535, 2640243204, 2403728665, 2169303058, 1001089995, 899835584, 666464733, 699432150, 59727847, 226906860, 530400753, 294930682, 1273168787, 1172967064, 1475418501, 1509430414, 1942435775, 2110667444, 1876241833, 1641816226, 2910219766, 2743034109, 2976151520, 3211623147, 2505202138, 2606453969, 2302690252, 2269728455, 3711829422, 3543599269, 3240894392, 3475313331, 3843699074, 3943906441, 4178062228, 4144047775, 1306967366, 1139781709, 1374988112, 1610459739, 1975683434, 2076935265, 1775276924, 1742315127, 1034867998, 866637845, 566021896, 800440835, 92987698, 193195065, 429456164, 395441711, 1984812685, 2017778566, 1784663195, 1683407248, 1315562145, 1080094634, 1383856311, 1551037884, 101039829, 135050206, 437757123, 337553864, 1042385657, 807962610, 573804783, 742039012, 2531067453, 2564033334, 2328828971, 2227573024, 2935566865, 2700099354, 3001755655, 3168937228, 3868552805, 3902563182, 4203181171, 4102977912, 3736164937, 3501741890, 3265478751, 3433712980, 1106041591, 1340463100, 1576976609, 1408749034, 2043211483, 2009195472, 1708848333, 1809054150, 832877231, 1068351396, 766945465, 599762354, 159417987, 126454664, 361929877, 463180190, 2709260871, 2943682380, 3178106961, 3009879386, 2572697195, 2538681184, 2236228733, 2336434550, 3509871135, 3745345300, 3441850377, 3274667266, 3910161971, 3877198648, 4110568485, 4211818798, 2597806476, 2497604743, 2261089178, 2295101073, 2733856160, 2902087851, 3202437046, 2968011453, 3936291284, 3835036895, 4136440770, 4169408201, 3535486456, 3702665459, 3467192302, 3231722213, 2051518780, 1951317047, 1716890410, 1750902305, 1113818384, 1282050075, 1584504582, 1350078989, 168810852, 67556463, 371049330, 404016761, 841739592, 1008918595, 775550814, 540080725, 3969562369, 3801332234, 4035489047, 4269907996, 3569255213, 3669462566, 3366754619, 3332740144, 2631065433, 2463879762, 2160117071, 2395588676, 2767645557, 2868897406, 3102011747, 3069049960, 202008497, 33778362, 270040487, 504459436, 875451293, 975658646, 675039627, 641025152, 2084704233, 1917518562, 1615861247, 1851332852, 1147550661, 1248802510, 1484005843, 1451044056, 933301370, 967311729, 733156972, 632953703, 260388950, 25965917, 328671808, 496906059, 1206477858, 1239443753, 1543208500, 1441952575, 2144161806, 1908694277, 1675577880, 1842759443, 3610369226, 3644379585, 3408119516, 3307916247, 4011190502, 3776767469, 4077384432, 4245618683, 2809771154, 2842737049, 3144396420, 3043140495, 2673705150, 2438237621, 2203032232, 2370213795],
              x = [0, 185469197, 370938394, 487725847, 741876788, 657861945, 975451694, 824852259, 1483753576, 1400783205, 1315723890, 1164071807, 1950903388, 2135319889, 1649704518, 1767536459, 2967507152, 3152976349, 2801566410, 2918353863, 2631447780, 2547432937, 2328143614, 2177544179, 3901806776, 3818836405, 4270639778, 4118987695, 3299409036, 3483825537, 3535072918, 3652904859, 2077965243, 1893020342, 1841768865, 1724457132, 1474502543, 1559041666, 1107234197, 1257309336, 598438867, 681933534, 901210569, 1052338372, 261314535, 77422314, 428819965, 310463728, 3409685355, 3224740454, 3710368113, 3593056380, 3875770207, 3960309330, 4045380933, 4195456072, 2471224067, 2554718734, 2237133081, 2388260884, 3212035895, 3028143674, 2842678573, 2724322336, 4138563181, 4255350624, 3769721975, 3955191162, 3667219033, 3516619604, 3431546947, 3347532110, 2933734917, 2782082824, 3099667487, 3016697106, 2196052529, 2313884476, 2499348523, 2683765030, 1179510461, 1296297904, 1347548327, 1533017514, 1786102409, 1635502980, 2087309459, 2003294622, 507358933, 355706840, 136428751, 53458370, 839224033, 957055980, 605657339, 790073846, 2373340630, 2256028891, 2607439820, 2422494913, 2706270690, 2856345839, 3075636216, 3160175349, 3573941694, 3725069491, 3273267108, 3356761769, 4181598602, 4063242375, 4011996048, 3828103837, 1033297158, 915985419, 730517276, 545572369, 296679730, 446754879, 129166120, 213705253, 1709610350, 1860738147, 1945798516, 2029293177, 1239331162, 1120974935, 1606591296, 1422699085, 4148292826, 4233094615, 3781033664, 3931371469, 3682191598, 3497509347, 3446004468, 3328955385, 2939266226, 2755636671, 3106780840, 2988687269, 2198438022, 2282195339, 2501218972, 2652609425, 1201765386, 1286567175, 1371368976, 1521706781, 1805211710, 1620529459, 2105887268, 1988838185, 533804130, 350174575, 164439672, 46346101, 870912086, 954669403, 636813900, 788204353, 2358957921, 2274680428, 2592523643, 2441661558, 2695033685, 2880240216, 3065962831, 3182487618, 3572145929, 3756299780, 3270937875, 3388507166, 4174560061, 4091327024, 4006521127, 3854606378, 1014646705, 930369212, 711349675, 560487590, 272786309, 457992840, 106852767, 223377554, 1678381017, 1862534868, 1914052035, 2031621326, 1211247597, 1128014560, 1580087799, 1428173050, 32283319, 182621114, 401639597, 486441376, 768917123, 651868046, 1003007129, 818324884, 1503449823, 1385356242, 1333838021, 1150208456, 1973745387, 2125135846, 1673061617, 1756818940, 2970356327, 3120694122, 2802849917, 2887651696, 2637442643, 2520393566, 2334669897, 2149987652, 3917234703, 3799141122, 4284502037, 4100872472, 3309594171, 3460984630, 3545789473, 3629546796, 2050466060, 1899603969, 1814803222, 1730525723, 1443857720, 1560382517, 1075025698, 1260232239, 575138148, 692707433, 878443390, 1062597235, 243256656, 91341917, 409198410, 325965383, 3403100636, 3252238545, 3704300486, 3620022987, 3874428392, 3990953189, 4042459122, 4227665663, 2460449204, 2578018489, 2226875310, 2411029155, 3198115200, 3046200461, 2827177882, 2743944855],
              D = [0, 218828297, 437656594, 387781147, 875313188, 958871085, 775562294, 590424639, 1750626376, 1699970625, 1917742170, 2135253587, 1551124588, 1367295589, 1180849278, 1265195639, 3501252752, 3720081049, 3399941250, 3350065803, 3835484340, 3919042237, 4270507174, 4085369519, 3102249176, 3051593425, 2734591178, 2952102595, 2361698556, 2177869557, 2530391278, 2614737639, 3145456443, 3060847922, 2708326185, 2892417312, 2404901663, 2187128086, 2504130317, 2555048196, 3542330227, 3727205754, 3375740769, 3292445032, 3876557655, 3926170974, 4246310725, 4027744588, 1808481195, 1723872674, 1910319033, 2094410160, 1608975247, 1391201670, 1173430173, 1224348052, 59984867, 244860394, 428169201, 344873464, 935293895, 984907214, 766078933, 547512796, 1844882806, 1627235199, 2011214180, 2062270317, 1507497298, 1423022939, 1137477952, 1321699145, 95345982, 145085239, 532201772, 313773861, 830661914, 1015671571, 731183368, 648017665, 3175501286, 2957853679, 2807058932, 2858115069, 2305455554, 2220981195, 2474404304, 2658625497, 3575528878, 3625268135, 3473416636, 3254988725, 3778151818, 3963161475, 4213447064, 4130281361, 3599595085, 3683022916, 3432737375, 3247465558, 3802222185, 4020912224, 4172763771, 4122762354, 3201631749, 3017672716, 2764249623, 2848461854, 2331590177, 2280796200, 2431590963, 2648976442, 104699613, 188127444, 472615631, 287343814, 840019705, 1058709744, 671593195, 621591778, 1852171925, 1668212892, 1953757831, 2037970062, 1514790577, 1463996600, 1080017571, 1297403050, 3673637356, 3623636965, 3235995134, 3454686199, 4007360968, 3822090177, 4107101658, 4190530515, 2997825956, 3215212461, 2830708150, 2779915199, 2256734592, 2340947849, 2627016082, 2443058075, 172466556, 122466165, 273792366, 492483431, 1047239e3, 861968209, 612205898, 695634755, 1646252340, 1863638845, 2013908262, 1963115311, 1446242576, 1530455833, 1277555970, 1093597963, 1636604631, 1820824798, 2073724613, 1989249228, 1436590835, 1487645946, 1337376481, 1119727848, 164948639, 81781910, 331544205, 516552836, 1039717051, 821288114, 669961897, 719700128, 2973530695, 3157750862, 2871682645, 2787207260, 2232435299, 2283490410, 2667994737, 2450346104, 3647212047, 3564045318, 3279033885, 3464042516, 3980931627, 3762502690, 4150144569, 4199882800, 3070356634, 3121275539, 2904027272, 2686254721, 2200818878, 2384911031, 2570832044, 2486224549, 3747192018, 3528626907, 3310321856, 3359936201, 3950355702, 3867060991, 4049844452, 4234721005, 1739656202, 1790575107, 2108100632, 1890328081, 1402811438, 1586903591, 1233856572, 1149249077, 266959938, 48394827, 369057872, 418672217, 1002783846, 919489135, 567498868, 752375421, 209336225, 24197544, 376187827, 459744698, 945164165, 895287692, 574624663, 793451934, 1679968233, 1764313568, 2117360635, 1933530610, 1343127501, 1560637892, 1243112415, 1192455638, 3704280881, 3519142200, 3336358691, 3419915562, 3907448597, 3857572124, 4075877127, 4294704398, 3029510009, 3113855344, 2927934315, 2744104290, 2159976285, 2377486676, 2594734927, 2544078150],
              C = [0, 151849742, 303699484, 454499602, 607398968, 758720310, 908999204, 1059270954, 1214797936, 1097159550, 1517440620, 1400849762, 1817998408, 1699839814, 2118541908, 2001430874, 2429595872, 2581445614, 2194319100, 2345119218, 3034881240, 3186202582, 2801699524, 2951971274, 3635996816, 3518358430, 3399679628, 3283088770, 4237083816, 4118925222, 4002861748, 3885750714, 1002142683, 850817237, 698445255, 548169417, 529487843, 377642221, 227885567, 77089521, 1943217067, 2061379749, 1640576439, 1757691577, 1474760595, 1592394909, 1174215055, 1290801793, 2875968315, 2724642869, 3111247143, 2960971305, 2405426947, 2253581325, 2638606623, 2487810577, 3808662347, 3926825029, 4044981591, 4162096729, 3342319475, 3459953789, 3576539503, 3693126241, 1986918061, 2137062819, 1685577905, 1836772287, 1381620373, 1532285339, 1078185097, 1229899655, 1040559837, 923313619, 740276417, 621982671, 439452389, 322734571, 137073913, 19308535, 3871163981, 4021308739, 4104605777, 4255800159, 3263785589, 3414450555, 3499326569, 3651041127, 2933202493, 2815956275, 3167684641, 3049390895, 2330014213, 2213296395, 2566595609, 2448830231, 1305906550, 1155237496, 1607244650, 1455525988, 1776460110, 1626319424, 2079897426, 1928707164, 96392454, 213114376, 396673818, 514443284, 562755902, 679998e3, 865136418, 983426092, 3708173718, 3557504664, 3474729866, 3323011204, 4180808110, 4030667424, 3945269170, 3794078908, 2507040230, 2623762152, 2272556026, 2390325492, 2975484382, 3092726480, 2738905026, 2857194700, 3973773121, 3856137295, 4274053469, 4157467219, 3371096953, 3252932727, 3673476453, 3556361835, 2763173681, 2915017791, 3064510765, 3215307299, 2156299017, 2307622919, 2459735317, 2610011675, 2081048481, 1963412655, 1846563261, 1729977011, 1480485785, 1362321559, 1243905413, 1126790795, 878845905, 1030690015, 645401037, 796197571, 274084841, 425408743, 38544885, 188821243, 3613494426, 3731654548, 3313212038, 3430322568, 4082475170, 4200115116, 3780097726, 3896688048, 2668221674, 2516901860, 2366882550, 2216610296, 3141400786, 2989552604, 2837966542, 2687165888, 1202797690, 1320957812, 1437280870, 1554391400, 1669664834, 1787304780, 1906247262, 2022837584, 265905162, 114585348, 499347990, 349075736, 736970802, 585122620, 972512814, 821712160, 2595684844, 2478443234, 2293045232, 2174754046, 3196267988, 3079546586, 2895723464, 2777952454, 3537852828, 3687994002, 3234156416, 3385345166, 4142626212, 4293295786, 3841024952, 3992742070, 174567692, 57326082, 410887952, 292596766, 777231668, 660510266, 1011452712, 893681702, 1108339068, 1258480242, 1343618912, 1494807662, 1715193156, 1865862730, 1948373848, 2100090966, 2701949495, 2818666809, 3004591147, 3122358053, 2235061775, 2352307457, 2535604243, 2653899549, 3915653703, 3764988233, 4219352155, 4067639125, 3444575871, 3294430577, 3746175075, 3594982253, 836553431, 953270745, 600235211, 718002117, 367585007, 484830689, 133361907, 251657213, 2041877159, 1891211689, 1806599355, 1654886325, 1568718495, 1418573201, 1335535747, 1184342925];

          function S(e) {
            for (var t = [], a = 0; a < e.length; a += 4) {
              t.push(e[a] << 24 | e[a + 1] << 16 | e[a + 2] << 8 | e[a + 3]);
            }

            return t;
          }

          var E = function E(e) {
            if (!(this instanceof E)) throw Error("AES must be instanitated with `new`");
            Object.defineProperty(this, "key", {
              value: s(e, !0)
            }), this._prepare();
          };

          E.prototype._prepare = function () {
            var e = f[this.key.length];
            if (null == e) throw new Error("invalid key size (must be 16, 24 or 32 bytes)");
            this._Ke = [], this._Kd = [];

            for (var t = 0; t <= e; t++) {
              this._Ke.push([0, 0, 0, 0]), this._Kd.push([0, 0, 0, 0]);
            }

            var a,
                r = 4 * (e + 1),
                n = this.key.length / 4,
                s = S(this.key);

            for (t = 0; t < n; t++) {
              a = t >> 2, this._Ke[a][t % 4] = s[t], this._Kd[e - a][t % 4] = s[t];
            }

            for (var o, i = 0, c = n; c < r;) {
              if (o = s[n - 1], s[0] ^= h[o >> 16 & 255] << 24 ^ h[o >> 8 & 255] << 16 ^ h[255 & o] << 8 ^ h[o >> 24 & 255] ^ l[i] << 24, i += 1, 8 != n) for (t = 1; t < n; t++) {
                s[t] ^= s[t - 1];
              } else {
                for (t = 1; t < n / 2; t++) {
                  s[t] ^= s[t - 1];
                }

                for (o = s[n / 2 - 1], s[n / 2] ^= h[255 & o] ^ h[o >> 8 & 255] << 8 ^ h[o >> 16 & 255] << 16 ^ h[o >> 24 & 255] << 24, t = n / 2 + 1; t < n; t++) {
                  s[t] ^= s[t - 1];
                }
              }

              for (t = 0; t < n && c < r;) {
                u = c >> 2, d = c % 4, this._Ke[u][d] = s[t], this._Kd[e - u][d] = s[t++], c++;
              }
            }

            for (var u = 1; u < e; u++) {
              for (var d = 0; d < 4; d++) {
                o = this._Kd[u][d], this._Kd[u][d] = T[o >> 24 & 255] ^ x[o >> 16 & 255] ^ D[o >> 8 & 255] ^ C[255 & o];
              }
            }
          }, E.prototype.encrypt = function (e) {
            if (16 != e.length) throw new Error("invalid plaintext size (must be 16 bytes)");

            for (var t = this._Ke.length - 1, a = [0, 0, 0, 0], r = S(e), n = 0; n < 4; n++) {
              r[n] ^= this._Ke[0][n];
            }

            for (var s = 1; s < t; s++) {
              for (n = 0; n < 4; n++) {
                a[n] = b[r[n] >> 24 & 255] ^ m[r[(n + 1) % 4] >> 16 & 255] ^ y[r[(n + 2) % 4] >> 8 & 255] ^ v[255 & r[(n + 3) % 4]] ^ this._Ke[s][n];
              }

              r = a.slice();
            }

            var i,
                c = o(16);

            for (n = 0; n < 4; n++) {
              i = this._Ke[t][n], c[4 * n] = 255 & (h[r[n] >> 24 & 255] ^ i >> 24), c[4 * n + 1] = 255 & (h[r[(n + 1) % 4] >> 16 & 255] ^ i >> 16), c[4 * n + 2] = 255 & (h[r[(n + 2) % 4] >> 8 & 255] ^ i >> 8), c[4 * n + 3] = 255 & (h[255 & r[(n + 3) % 4]] ^ i);
            }

            return c;
          }, E.prototype.decrypt = function (e) {
            if (16 != e.length) throw new Error("invalid ciphertext size (must be 16 bytes)");

            for (var t = this._Kd.length - 1, a = [0, 0, 0, 0], r = S(e), n = 0; n < 4; n++) {
              r[n] ^= this._Kd[0][n];
            }

            for (var s = 1; s < t; s++) {
              for (n = 0; n < 4; n++) {
                a[n] = _[r[n] >> 24 & 255] ^ g[r[(n + 3) % 4] >> 16 & 255] ^ A[r[(n + 2) % 4] >> 8 & 255] ^ w[255 & r[(n + 1) % 4]] ^ this._Kd[s][n];
              }

              r = a.slice();
            }

            var i,
                c = o(16);

            for (n = 0; n < 4; n++) {
              i = this._Kd[t][n], c[4 * n] = 255 & (p[r[n] >> 24 & 255] ^ i >> 24), c[4 * n + 1] = 255 & (p[r[(n + 3) % 4] >> 16 & 255] ^ i >> 16), c[4 * n + 2] = 255 & (p[r[(n + 2) % 4] >> 8 & 255] ^ i >> 8), c[4 * n + 3] = 255 & (p[255 & r[(n + 1) % 4]] ^ i);
            }

            return c;
          };

          var B = function B(e) {
            if (!(this instanceof B)) throw Error("AES must be instanitated with `new`");
            this.description = "Electronic Code Block", this.name = "ecb", this._aes = new E(e);
          };

          B.prototype.encrypt = function (e) {
            if ((e = s(e)).length % 16 != 0) throw new Error("invalid plaintext size (must be multiple of 16 bytes)");

            for (var t = o(e.length), a = o(16), r = 0; r < e.length; r += 16) {
              i(e, a, 0, r, r + 16), i(a = this._aes.encrypt(a), t, r);
            }

            return t;
          }, B.prototype.decrypt = function (e) {
            if ((e = s(e)).length % 16 != 0) throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");

            for (var t = o(e.length), a = o(16), r = 0; r < e.length; r += 16) {
              i(e, a, 0, r, r + 16), i(a = this._aes.decrypt(a), t, r);
            }

            return t;
          };

          var k = function k(e, t) {
            if (!(this instanceof k)) throw Error("AES must be instanitated with `new`");

            if (this.description = "Cipher Block Chaining", this.name = "cbc", t) {
              if (16 != t.length) throw new Error("invalid initialation vector size (must be 16 bytes)");
            } else t = o(16);

            this._lastCipherblock = s(t, !0), this._aes = new E(e);
          };

          k.prototype.encrypt = function (e) {
            if ((e = s(e)).length % 16 != 0) throw new Error("invalid plaintext size (must be multiple of 16 bytes)");

            for (var t = o(e.length), a = o(16), r = 0; r < e.length; r += 16) {
              i(e, a, 0, r, r + 16);

              for (var n = 0; n < 16; n++) {
                a[n] ^= this._lastCipherblock[n];
              }

              this._lastCipherblock = this._aes.encrypt(a), i(this._lastCipherblock, t, r);
            }

            return t;
          }, k.prototype.decrypt = function (e) {
            if ((e = s(e)).length % 16 != 0) throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");

            for (var t = o(e.length), a = o(16), r = 0; r < e.length; r += 16) {
              i(e, a, 0, r, r + 16), a = this._aes.decrypt(a);

              for (var n = 0; n < 16; n++) {
                t[r + n] = a[n] ^ this._lastCipherblock[n];
              }

              i(e, this._lastCipherblock, 0, r, r + 16);
            }

            return t;
          };

          var R = function R(e, t, a) {
            if (!(this instanceof R)) throw Error("AES must be instanitated with `new`");

            if (this.description = "Cipher Feedback", this.name = "cfb", t) {
              if (16 != t.length) throw new Error("invalid initialation vector size (must be 16 size)");
            } else t = o(16);

            a = a || 1, this.segmentSize = a, this._shiftRegister = s(t, !0), this._aes = new E(e);
          };

          R.prototype.encrypt = function (e) {
            if (e.length % this.segmentSize != 0) throw new Error("invalid plaintext size (must be segmentSize bytes)");

            for (var t, a = s(e, !0), r = 0; r < a.length; r += this.segmentSize) {
              t = this._aes.encrypt(this._shiftRegister);

              for (var n = 0; n < this.segmentSize; n++) {
                a[r + n] ^= t[n];
              }

              i(this._shiftRegister, this._shiftRegister, 0, this.segmentSize), i(a, this._shiftRegister, 16 - this.segmentSize, r, r + this.segmentSize);
            }

            return a;
          }, R.prototype.decrypt = function (e) {
            if (e.length % this.segmentSize != 0) throw new Error("invalid ciphertext size (must be segmentSize bytes)");

            for (var t, a = s(e, !0), r = 0; r < a.length; r += this.segmentSize) {
              t = this._aes.encrypt(this._shiftRegister);

              for (var n = 0; n < this.segmentSize; n++) {
                a[r + n] ^= t[n];
              }

              i(this._shiftRegister, this._shiftRegister, 0, this.segmentSize), i(e, this._shiftRegister, 16 - this.segmentSize, r, r + this.segmentSize);
            }

            return a;
          };

          var W = function W(e, t) {
            if (!(this instanceof W)) throw Error("AES must be instanitated with `new`");

            if (this.description = "Output Feedback", this.name = "ofb", t) {
              if (16 != t.length) throw new Error("invalid initialation vector size (must be 16 bytes)");
            } else t = o(16);

            this._lastPrecipher = s(t, !0), this._lastPrecipherIndex = 16, this._aes = new E(e);
          };

          W.prototype.encrypt = function (e) {
            for (var t = s(e, !0), a = 0; a < t.length; a++) {
              16 === this._lastPrecipherIndex && (this._lastPrecipher = this._aes.encrypt(this._lastPrecipher), this._lastPrecipherIndex = 0), t[a] ^= this._lastPrecipher[this._lastPrecipherIndex++];
            }

            return t;
          }, W.prototype.decrypt = W.prototype.encrypt;

          var I = function I(e) {
            if (!(this instanceof I)) throw Error("Counter must be instanitated with `new`");
            0 === e || e || (e = 1), "number" == typeof e ? (this._counter = o(16), this.setValue(e)) : this.setBytes(e);
          };

          I.prototype.setValue = function (e) {
            if ("number" != typeof e || parseInt(e) != e) throw new Error("invalid counter value (must be an integer)");

            for (var t = 15; 0 <= t; --t) {
              this._counter[t] = e % 256, e >>= 8;
            }
          }, I.prototype.setBytes = function (e) {
            if (16 != (e = s(e, !0)).length) throw new Error("invalid counter bytes size (must be 16 bytes)");
            this._counter = e;
          }, I.prototype.increment = function () {
            for (var e = 15; 0 <= e; e--) {
              if (255 !== this._counter[e]) {
                this._counter[e]++;
                break;
              }

              this._counter[e] = 0;
            }
          };

          var N = function N(e, t) {
            if (!(this instanceof N)) throw Error("AES must be instanitated with `new`");
            this.description = "Counter", this.name = "ctr", t instanceof I || (t = new I(t)), this._counter = t, this._remainingCounter = null, this._remainingCounterIndex = 16, this._aes = new E(e);
          };

          N.prototype.encrypt = function (e) {
            for (var t = s(e, !0), a = 0; a < t.length; a++) {
              16 === this._remainingCounterIndex && (this._remainingCounter = this._aes.encrypt(this._counter._counter), this._remainingCounterIndex = 0, this._counter.increment()), t[a] ^= this._remainingCounter[this._remainingCounterIndex++];
            }

            return t;
          }, N.prototype.decrypt = N.prototype.encrypt;
          var M = {
            AES: E,
            Counter: I,
            ModeOfOperation: {
              ecb: B,
              cbc: k,
              cfb: R,
              ofb: W,
              ctr: N
            },
            utils: {
              hex: d,
              utf8: u
            },
            padding: {
              pkcs7: {
                pad: function pad(e) {
                  var t = 16 - (e = s(e, !0)).length % 16,
                      a = o(e.length + t);
                  i(e, a);

                  for (var r = e.length; r < a.length; r++) {
                    a[r] = t;
                  }

                  return a;
                },
                strip: function strip(e) {
                  if ((e = s(e, !0)).length < 16) throw new Error("PKCS#7 invalid length");
                  var t = e[e.length - 1];
                  if (16 < t) throw new Error("PKCS#7 padding byte out of range");

                  for (var a = e.length - t, r = 0; r < t; r++) {
                    if (e[a + r] !== t) throw new Error("PKCS#7 invalid padding byte");
                  }

                  var n = o(a);
                  return i(e, n, 0, 0, a), n;
                }
              }
            },
            _arrayTest: {
              coerceArray: s,
              createArray: o,
              copyArray: i
            }
          };
          void 0 !== a ? t.exports = M : (e.aesjs && (M._aesjs = e.aesjs), e.aesjs = M);
        }(this);
      }, {}],
      9: [function (e, t, a) {
        !function (t, a) {
          "use strict";

          function r(e, t) {
            if (!e) throw new Error(t || "Assertion failed");
          }

          function n(e, t) {
            function a() {}

            e.super_ = t, a.prototype = t.prototype, e.prototype = new a(), e.prototype.constructor = e;
          }

          function s(e, t, a) {
            if (s.isBN(e)) return e;
            this.negative = 0, this.words = null, this.length = 0, (this.red = null) !== e && ("le" !== t && "be" !== t || (a = t, t = 10), this._init(e || 0, t || 10, a || "be"));
          }

          var o;
          "object" == typeof t ? t.exports = s : a.BN = s, (s.BN = s).wordSize = 26;

          try {
            o = e("buffer").Buffer;
          } catch (t) {}

          function i(e, t, a) {
            for (var r = 0, n = Math.min(e.length, a), s = t; s < n; s++) {
              var o = e.charCodeAt(s) - 48;
              r <<= 4, r |= 49 <= o && o <= 54 ? o - 49 + 10 : 17 <= o && o <= 22 ? o - 17 + 10 : 15 & o;
            }

            return r;
          }

          function c(e, t, a, r) {
            for (var n = 0, s = Math.min(e.length, a), o = t; o < s; o++) {
              var i = e.charCodeAt(o) - 48;
              n *= r, n += 49 <= i ? i - 49 + 10 : 17 <= i ? i - 17 + 10 : i;
            }

            return n;
          }

          s.isBN = function (e) {
            return e instanceof s || null !== e && "object" == typeof e && e.constructor.wordSize === s.wordSize && Array.isArray(e.words);
          }, s.max = function (e, t) {
            return 0 < e.cmp(t) ? e : t;
          }, s.min = function (e, t) {
            return e.cmp(t) < 0 ? e : t;
          }, s.prototype._init = function (e, t, a) {
            if ("number" == typeof e) return this._initNumber(e, t, a);
            if ("object" == typeof e) return this._initArray(e, t, a);
            "hex" === t && (t = 16), r(t === (0 | t) && 2 <= t && t <= 36);
            var n = 0;
            "-" === (e = e.toString().replace(/\s+/g, ""))[0] && n++, 16 === t ? this._parseHex(e, n) : this._parseBase(e, t, n), "-" === e[0] && (this.negative = 1), this.strip(), "le" === a && this._initArray(this.toArray(), t, a);
          }, s.prototype._initNumber = function (e, t, a) {
            e < 0 && (this.negative = 1, e = -e), e < 67108864 ? (this.words = [67108863 & e], this.length = 1) : e < 4503599627370496 ? (this.words = [67108863 & e, e / 67108864 & 67108863], this.length = 2) : (r(e < 9007199254740992), this.words = [67108863 & e, e / 67108864 & 67108863, 1], this.length = 3), "le" === a && this._initArray(this.toArray(), t, a);
          }, s.prototype._initArray = function (e, t, a) {
            if (r("number" == typeof e.length), e.length <= 0) return this.words = [0], this.length = 1, this;
            this.length = Math.ceil(e.length / 3), this.words = new Array(this.length);

            for (var n = 0; n < this.length; n++) {
              this.words[n] = 0;
            }

            var s,
                o,
                i = 0;
            if ("be" === a) for (n = e.length - 1, s = 0; 0 <= n; n -= 3) {
              o = e[n] | e[n - 1] << 8 | e[n - 2] << 16, this.words[s] |= o << i & 67108863, this.words[s + 1] = o >>> 26 - i & 67108863, 26 <= (i += 24) && (i -= 26, s++);
            } else if ("le" === a) for (s = n = 0; n < e.length; n += 3) {
              o = e[n] | e[n + 1] << 8 | e[n + 2] << 16, this.words[s] |= o << i & 67108863, this.words[s + 1] = o >>> 26 - i & 67108863, 26 <= (i += 24) && (i -= 26, s++);
            }
            return this.strip();
          }, s.prototype._parseHex = function (e, t) {
            this.length = Math.ceil((e.length - t) / 6), this.words = new Array(this.length);

            for (var a = 0; a < this.length; a++) {
              this.words[a] = 0;
            }

            var r,
                n,
                s = 0;

            for (a = e.length - 6, r = 0; t <= a; a -= 6) {
              n = i(e, a, a + 6), this.words[r] |= n << s & 67108863, this.words[r + 1] |= n >>> 26 - s & 4194303, 26 <= (s += 24) && (s -= 26, r++);
            }

            a + 6 !== t && (n = i(e, t, a + 6), this.words[r] |= n << s & 67108863, this.words[r + 1] |= n >>> 26 - s & 4194303), this.strip();
          }, s.prototype._parseBase = function (e, t, a) {
            this.words = [0];

            for (var r = 0, n = this.length = 1; n <= 67108863; n *= t) {
              r++;
            }

            r--, n = n / t | 0;

            for (var s = e.length - a, o = s % r, i = Math.min(s, s - o) + a, u = 0, d = a; d < i; d += r) {
              u = c(e, d, d + r, t), this.imuln(n), this.words[0] + u < 67108864 ? this.words[0] += u : this._iaddn(u);
            }

            if (0 != o) {
              var f = 1;

              for (u = c(e, d, e.length, t), d = 0; d < o; d++) {
                f *= t;
              }

              this.imuln(f), this.words[0] + u < 67108864 ? this.words[0] += u : this._iaddn(u);
            }
          }, s.prototype.copy = function (e) {
            e.words = new Array(this.length);

            for (var t = 0; t < this.length; t++) {
              e.words[t] = this.words[t];
            }

            e.length = this.length, e.negative = this.negative, e.red = this.red;
          }, s.prototype.clone = function () {
            var e = new s(null);
            return this.copy(e), e;
          }, s.prototype._expand = function (e) {
            for (; this.length < e;) {
              this.words[this.length++] = 0;
            }

            return this;
          }, s.prototype.strip = function () {
            for (; 1 < this.length && 0 === this.words[this.length - 1];) {
              this.length--;
            }

            return this._normSign();
          }, s.prototype._normSign = function () {
            return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
          }, s.prototype.inspect = function () {
            return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
          };
          var u = ["", "0", "00", "000", "0000", "00000", "000000", "0000000", "00000000", "000000000", "0000000000", "00000000000", "000000000000", "0000000000000", "00000000000000", "000000000000000", "0000000000000000", "00000000000000000", "000000000000000000", "0000000000000000000", "00000000000000000000", "000000000000000000000", "0000000000000000000000", "00000000000000000000000", "000000000000000000000000", "0000000000000000000000000"],
              d = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
              f = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];

          function l(e, t, a) {
            a.negative = t.negative ^ e.negative;
            var r = e.length + t.length | 0;
            r = (a.length = r) - 1 | 0;
            var n = 0 | e.words[0],
                s = 0 | t.words[0],
                o = n * s,
                i = 67108863 & o,
                c = o / 67108864 | 0;
            a.words[0] = i;

            for (var u = 1; u < r; u++) {
              for (var d = c >>> 26, f = 67108863 & c, l = Math.min(u, t.length - 1), h = Math.max(0, u - e.length + 1); h <= l; h++) {
                var p = u - h | 0;
                d += (o = (n = 0 | e.words[p]) * (s = 0 | t.words[h]) + f) / 67108864 | 0, f = 67108863 & o;
              }

              a.words[u] = 0 | f, c = 0 | d;
            }

            return 0 !== c ? a.words[u] = 0 | c : a.length--, a.strip();
          }

          s.prototype.toString = function (e, t) {
            var a;

            if (t = 0 | t || 1, 16 === (e = e || 10) || "hex" === e) {
              a = "";

              for (var n = 0, s = 0, o = 0; o < this.length; o++) {
                var i = this.words[o],
                    c = (16777215 & (i << n | s)).toString(16);
                a = 0 != (s = i >>> 24 - n & 16777215) || o !== this.length - 1 ? u[6 - c.length] + c + a : c + a, 26 <= (n += 2) && (n -= 26, o--);
              }

              for (0 !== s && (a = s.toString(16) + a); a.length % t != 0;) {
                a = "0" + a;
              }

              return 0 !== this.negative && (a = "-" + a), a;
            }

            if (e === (0 | e) && 2 <= e && e <= 36) {
              var l = d[e],
                  h = f[e];
              a = "";
              var p = this.clone();

              for (p.negative = 0; !p.isZero();) {
                var b = p.modn(h).toString(e);
                a = (p = p.idivn(h)).isZero() ? b + a : u[l - b.length] + b + a;
              }

              for (this.isZero() && (a = "0" + a); a.length % t != 0;) {
                a = "0" + a;
              }

              return 0 !== this.negative && (a = "-" + a), a;
            }

            r(!1, "Base should be between 2 and 36");
          }, s.prototype.toNumber = function () {
            var e = this.words[0];
            return 2 === this.length ? e += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? e += 4503599627370496 + 67108864 * this.words[1] : 2 < this.length && r(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -e : e;
          }, s.prototype.toJSON = function () {
            return this.toString(16);
          }, s.prototype.toBuffer = function (e, t) {
            return r(void 0 !== o), this.toArrayLike(o, e, t);
          }, s.prototype.toArray = function (e, t) {
            return this.toArrayLike(Array, e, t);
          }, s.prototype.toArrayLike = function (e, t, a) {
            var n = this.byteLength(),
                s = a || Math.max(1, n);
            r(n <= s, "byte array longer than desired length"), r(0 < s, "Requested array length <= 0"), this.strip();
            var o,
                i,
                c = "le" === t,
                u = new e(s),
                d = this.clone();

            if (c) {
              for (i = 0; !d.isZero(); i++) {
                o = d.andln(255), d.iushrn(8), u[i] = o;
              }

              for (; i < s; i++) {
                u[i] = 0;
              }
            } else {
              for (i = 0; i < s - n; i++) {
                u[i] = 0;
              }

              for (i = 0; !d.isZero(); i++) {
                o = d.andln(255), d.iushrn(8), u[s - i - 1] = o;
              }
            }

            return u;
          }, s.prototype._countBits = Math.clz32 ? function (e) {
            return 32 - Math.clz32(e);
          } : function (e) {
            var t = e,
                a = 0;
            return 4096 <= t && (a += 13, t >>>= 13), 64 <= t && (a += 7, t >>>= 7), 8 <= t && (a += 4, t >>>= 4), 2 <= t && (a += 2, t >>>= 2), a + t;
          }, s.prototype._zeroBits = function (e) {
            if (0 === e) return 26;
            var t = e,
                a = 0;
            return 0 == (8191 & t) && (a += 13, t >>>= 13), 0 == (127 & t) && (a += 7, t >>>= 7), 0 == (15 & t) && (a += 4, t >>>= 4), 0 == (3 & t) && (a += 2, t >>>= 2), 0 == (1 & t) && a++, a;
          }, s.prototype.bitLength = function () {
            var e = this.words[this.length - 1],
                t = this._countBits(e);

            return 26 * (this.length - 1) + t;
          }, s.prototype.zeroBits = function () {
            if (this.isZero()) return 0;

            for (var e = 0, t = 0; t < this.length; t++) {
              var a = this._zeroBits(this.words[t]);

              if (e += a, 26 !== a) break;
            }

            return e;
          }, s.prototype.byteLength = function () {
            return Math.ceil(this.bitLength() / 8);
          }, s.prototype.toTwos = function (e) {
            return 0 !== this.negative ? this.abs().inotn(e).iaddn(1) : this.clone();
          }, s.prototype.fromTwos = function (e) {
            return this.testn(e - 1) ? this.notn(e).iaddn(1).ineg() : this.clone();
          }, s.prototype.isNeg = function () {
            return 0 !== this.negative;
          }, s.prototype.neg = function () {
            return this.clone().ineg();
          }, s.prototype.ineg = function () {
            return this.isZero() || (this.negative ^= 1), this;
          }, s.prototype.iuor = function (e) {
            for (; this.length < e.length;) {
              this.words[this.length++] = 0;
            }

            for (var t = 0; t < e.length; t++) {
              this.words[t] = this.words[t] | e.words[t];
            }

            return this.strip();
          }, s.prototype.ior = function (e) {
            return r(0 == (this.negative | e.negative)), this.iuor(e);
          }, s.prototype.or = function (e) {
            return this.length > e.length ? this.clone().ior(e) : e.clone().ior(this);
          }, s.prototype.uor = function (e) {
            return this.length > e.length ? this.clone().iuor(e) : e.clone().iuor(this);
          }, s.prototype.iuand = function (e) {
            var t;
            t = this.length > e.length ? e : this;

            for (var a = 0; a < t.length; a++) {
              this.words[a] = this.words[a] & e.words[a];
            }

            return this.length = t.length, this.strip();
          }, s.prototype.iand = function (e) {
            return r(0 == (this.negative | e.negative)), this.iuand(e);
          }, s.prototype.and = function (e) {
            return this.length > e.length ? this.clone().iand(e) : e.clone().iand(this);
          }, s.prototype.uand = function (e) {
            return this.length > e.length ? this.clone().iuand(e) : e.clone().iuand(this);
          }, s.prototype.iuxor = function (e) {
            var t, a;
            a = this.length > e.length ? (t = this, e) : (t = e, this);

            for (var r = 0; r < a.length; r++) {
              this.words[r] = t.words[r] ^ a.words[r];
            }

            if (this !== t) for (; r < t.length; r++) {
              this.words[r] = t.words[r];
            }
            return this.length = t.length, this.strip();
          }, s.prototype.ixor = function (e) {
            return r(0 == (this.negative | e.negative)), this.iuxor(e);
          }, s.prototype.xor = function (e) {
            return this.length > e.length ? this.clone().ixor(e) : e.clone().ixor(this);
          }, s.prototype.uxor = function (e) {
            return this.length > e.length ? this.clone().iuxor(e) : e.clone().iuxor(this);
          }, s.prototype.inotn = function (e) {
            r("number" == typeof e && 0 <= e);
            var t = 0 | Math.ceil(e / 26),
                a = e % 26;
            this._expand(t), 0 < a && t--;

            for (var n = 0; n < t; n++) {
              this.words[n] = 67108863 & ~this.words[n];
            }

            return 0 < a && (this.words[n] = ~this.words[n] & 67108863 >> 26 - a), this.strip();
          }, s.prototype.notn = function (e) {
            return this.clone().inotn(e);
          }, s.prototype.setn = function (e, t) {
            r("number" == typeof e && 0 <= e);
            var a = e / 26 | 0,
                n = e % 26;
            return this._expand(1 + a), this.words[a] = t ? this.words[a] | 1 << n : this.words[a] & ~(1 << n), this.strip();
          }, s.prototype.iadd = function (e) {
            var t, a, r;
            if (0 !== this.negative && 0 === e.negative) return this.negative = 0, t = this.isub(e), this.negative ^= 1, this._normSign();
            if (0 === this.negative && 0 !== e.negative) return e.negative = 0, t = this.isub(e), e.negative = 1, t._normSign();
            r = this.length > e.length ? (a = this, e) : (a = e, this);

            for (var n = 0, s = 0; s < r.length; s++) {
              t = (0 | a.words[s]) + (0 | r.words[s]) + n, this.words[s] = 67108863 & t, n = t >>> 26;
            }

            for (; 0 !== n && s < a.length; s++) {
              t = (0 | a.words[s]) + n, this.words[s] = 67108863 & t, n = t >>> 26;
            }

            if (this.length = a.length, 0 !== n) this.words[this.length] = n, this.length++;else if (a !== this) for (; s < a.length; s++) {
              this.words[s] = a.words[s];
            }
            return this;
          }, s.prototype.add = function (e) {
            var t;
            return 0 !== e.negative && 0 === this.negative ? (e.negative = 0, t = this.sub(e), e.negative ^= 1, t) : 0 === e.negative && 0 !== this.negative ? (this.negative = 0, t = e.sub(this), this.negative = 1, t) : this.length > e.length ? this.clone().iadd(e) : e.clone().iadd(this);
          }, s.prototype.isub = function (e) {
            if (0 !== e.negative) {
              e.negative = 0;
              var t = this.iadd(e);
              return e.negative = 1, t._normSign();
            }

            if (0 !== this.negative) return this.negative = 0, this.iadd(e), this.negative = 1, this._normSign();
            var a,
                r,
                n = this.cmp(e);
            if (0 === n) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
            r = 0 < n ? (a = this, e) : (a = e, this);

            for (var s = 0, o = 0; o < r.length; o++) {
              s = (t = (0 | a.words[o]) - (0 | r.words[o]) + s) >> 26, this.words[o] = 67108863 & t;
            }

            for (; 0 !== s && o < a.length; o++) {
              s = (t = (0 | a.words[o]) + s) >> 26, this.words[o] = 67108863 & t;
            }

            if (0 === s && o < a.length && a !== this) for (; o < a.length; o++) {
              this.words[o] = a.words[o];
            }
            return this.length = Math.max(this.length, o), a !== this && (this.negative = 1), this.strip();
          }, s.prototype.sub = function (e) {
            return this.clone().isub(e);
          };

          var h = function h(e, t, a) {
            var r,
                n,
                s,
                o = e.words,
                i = t.words,
                c = a.words,
                u = 0,
                d = 0 | o[0],
                f = 8191 & d,
                l = d >>> 13,
                h = 0 | o[1],
                p = 8191 & h,
                b = h >>> 13,
                m = 0 | o[2],
                y = 8191 & m,
                v = m >>> 13,
                _ = 0 | o[3],
                g = 8191 & _,
                A = _ >>> 13,
                w = 0 | o[4],
                T = 8191 & w,
                x = w >>> 13,
                D = 0 | o[5],
                C = 8191 & D,
                S = D >>> 13,
                E = 0 | o[6],
                B = 8191 & E,
                k = E >>> 13,
                R = 0 | o[7],
                W = 8191 & R,
                I = R >>> 13,
                N = 0 | o[8],
                M = 8191 & N,
                P = N >>> 13,
                L = 0 | o[9],
                O = 8191 & L,
                F = L >>> 13,
                j = 0 | i[0],
                G = 8191 & j,
                V = j >>> 13,
                U = 0 | i[1],
                H = 8191 & U,
                z = U >>> 13,
                K = 0 | i[2],
                q = 8191 & K,
                Y = K >>> 13,
                Z = 0 | i[3],
                J = 8191 & Z,
                X = Z >>> 13,
                $ = 0 | i[4],
                Q = 8191 & $,
                ee = $ >>> 13,
                te = 0 | i[5],
                ae = 8191 & te,
                re = te >>> 13,
                ne = 0 | i[6],
                se = 8191 & ne,
                oe = ne >>> 13,
                ie = 0 | i[7],
                ce = 8191 & ie,
                ue = ie >>> 13,
                de = 0 | i[8],
                fe = 8191 & de,
                le = de >>> 13,
                he = 0 | i[9],
                pe = 8191 & he,
                be = he >>> 13;

            a.negative = e.negative ^ t.negative, a.length = 19;
            var me = (u + (r = Math.imul(f, G)) | 0) + ((8191 & (n = (n = Math.imul(f, V)) + Math.imul(l, G) | 0)) << 13) | 0;
            u = ((s = Math.imul(l, V)) + (n >>> 13) | 0) + (me >>> 26) | 0, me &= 67108863, r = Math.imul(p, G), n = (n = Math.imul(p, V)) + Math.imul(b, G) | 0, s = Math.imul(b, V);
            var ye = (u + (r = r + Math.imul(f, H) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(f, z) | 0) + Math.imul(l, H) | 0)) << 13) | 0;
            u = ((s = s + Math.imul(l, z) | 0) + (n >>> 13) | 0) + (ye >>> 26) | 0, ye &= 67108863, r = Math.imul(y, G), n = (n = Math.imul(y, V)) + Math.imul(v, G) | 0, s = Math.imul(v, V), r = r + Math.imul(p, H) | 0, n = (n = n + Math.imul(p, z) | 0) + Math.imul(b, H) | 0, s = s + Math.imul(b, z) | 0;
            var ve = (u + (r = r + Math.imul(f, q) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(f, Y) | 0) + Math.imul(l, q) | 0)) << 13) | 0;
            u = ((s = s + Math.imul(l, Y) | 0) + (n >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, r = Math.imul(g, G), n = (n = Math.imul(g, V)) + Math.imul(A, G) | 0, s = Math.imul(A, V), r = r + Math.imul(y, H) | 0, n = (n = n + Math.imul(y, z) | 0) + Math.imul(v, H) | 0, s = s + Math.imul(v, z) | 0, r = r + Math.imul(p, q) | 0, n = (n = n + Math.imul(p, Y) | 0) + Math.imul(b, q) | 0, s = s + Math.imul(b, Y) | 0;

            var _e = (u + (r = r + Math.imul(f, J) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(f, X) | 0) + Math.imul(l, J) | 0)) << 13) | 0;

            u = ((s = s + Math.imul(l, X) | 0) + (n >>> 13) | 0) + (_e >>> 26) | 0, _e &= 67108863, r = Math.imul(T, G), n = (n = Math.imul(T, V)) + Math.imul(x, G) | 0, s = Math.imul(x, V), r = r + Math.imul(g, H) | 0, n = (n = n + Math.imul(g, z) | 0) + Math.imul(A, H) | 0, s = s + Math.imul(A, z) | 0, r = r + Math.imul(y, q) | 0, n = (n = n + Math.imul(y, Y) | 0) + Math.imul(v, q) | 0, s = s + Math.imul(v, Y) | 0, r = r + Math.imul(p, J) | 0, n = (n = n + Math.imul(p, X) | 0) + Math.imul(b, J) | 0, s = s + Math.imul(b, X) | 0;
            var ge = (u + (r = r + Math.imul(f, Q) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(f, ee) | 0) + Math.imul(l, Q) | 0)) << 13) | 0;
            u = ((s = s + Math.imul(l, ee) | 0) + (n >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, r = Math.imul(C, G), n = (n = Math.imul(C, V)) + Math.imul(S, G) | 0, s = Math.imul(S, V), r = r + Math.imul(T, H) | 0, n = (n = n + Math.imul(T, z) | 0) + Math.imul(x, H) | 0, s = s + Math.imul(x, z) | 0, r = r + Math.imul(g, q) | 0, n = (n = n + Math.imul(g, Y) | 0) + Math.imul(A, q) | 0, s = s + Math.imul(A, Y) | 0, r = r + Math.imul(y, J) | 0, n = (n = n + Math.imul(y, X) | 0) + Math.imul(v, J) | 0, s = s + Math.imul(v, X) | 0, r = r + Math.imul(p, Q) | 0, n = (n = n + Math.imul(p, ee) | 0) + Math.imul(b, Q) | 0, s = s + Math.imul(b, ee) | 0;
            var Ae = (u + (r = r + Math.imul(f, ae) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(f, re) | 0) + Math.imul(l, ae) | 0)) << 13) | 0;
            u = ((s = s + Math.imul(l, re) | 0) + (n >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, r = Math.imul(B, G), n = (n = Math.imul(B, V)) + Math.imul(k, G) | 0, s = Math.imul(k, V), r = r + Math.imul(C, H) | 0, n = (n = n + Math.imul(C, z) | 0) + Math.imul(S, H) | 0, s = s + Math.imul(S, z) | 0, r = r + Math.imul(T, q) | 0, n = (n = n + Math.imul(T, Y) | 0) + Math.imul(x, q) | 0, s = s + Math.imul(x, Y) | 0, r = r + Math.imul(g, J) | 0, n = (n = n + Math.imul(g, X) | 0) + Math.imul(A, J) | 0, s = s + Math.imul(A, X) | 0, r = r + Math.imul(y, Q) | 0, n = (n = n + Math.imul(y, ee) | 0) + Math.imul(v, Q) | 0, s = s + Math.imul(v, ee) | 0, r = r + Math.imul(p, ae) | 0, n = (n = n + Math.imul(p, re) | 0) + Math.imul(b, ae) | 0, s = s + Math.imul(b, re) | 0;
            var we = (u + (r = r + Math.imul(f, se) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(f, oe) | 0) + Math.imul(l, se) | 0)) << 13) | 0;
            u = ((s = s + Math.imul(l, oe) | 0) + (n >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, r = Math.imul(W, G), n = (n = Math.imul(W, V)) + Math.imul(I, G) | 0, s = Math.imul(I, V), r = r + Math.imul(B, H) | 0, n = (n = n + Math.imul(B, z) | 0) + Math.imul(k, H) | 0, s = s + Math.imul(k, z) | 0, r = r + Math.imul(C, q) | 0, n = (n = n + Math.imul(C, Y) | 0) + Math.imul(S, q) | 0, s = s + Math.imul(S, Y) | 0, r = r + Math.imul(T, J) | 0, n = (n = n + Math.imul(T, X) | 0) + Math.imul(x, J) | 0, s = s + Math.imul(x, X) | 0, r = r + Math.imul(g, Q) | 0, n = (n = n + Math.imul(g, ee) | 0) + Math.imul(A, Q) | 0, s = s + Math.imul(A, ee) | 0, r = r + Math.imul(y, ae) | 0, n = (n = n + Math.imul(y, re) | 0) + Math.imul(v, ae) | 0, s = s + Math.imul(v, re) | 0, r = r + Math.imul(p, se) | 0, n = (n = n + Math.imul(p, oe) | 0) + Math.imul(b, se) | 0, s = s + Math.imul(b, oe) | 0;
            var Te = (u + (r = r + Math.imul(f, ce) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(f, ue) | 0) + Math.imul(l, ce) | 0)) << 13) | 0;
            u = ((s = s + Math.imul(l, ue) | 0) + (n >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, r = Math.imul(M, G), n = (n = Math.imul(M, V)) + Math.imul(P, G) | 0, s = Math.imul(P, V), r = r + Math.imul(W, H) | 0, n = (n = n + Math.imul(W, z) | 0) + Math.imul(I, H) | 0, s = s + Math.imul(I, z) | 0, r = r + Math.imul(B, q) | 0, n = (n = n + Math.imul(B, Y) | 0) + Math.imul(k, q) | 0, s = s + Math.imul(k, Y) | 0, r = r + Math.imul(C, J) | 0, n = (n = n + Math.imul(C, X) | 0) + Math.imul(S, J) | 0, s = s + Math.imul(S, X) | 0, r = r + Math.imul(T, Q) | 0, n = (n = n + Math.imul(T, ee) | 0) + Math.imul(x, Q) | 0, s = s + Math.imul(x, ee) | 0, r = r + Math.imul(g, ae) | 0, n = (n = n + Math.imul(g, re) | 0) + Math.imul(A, ae) | 0, s = s + Math.imul(A, re) | 0, r = r + Math.imul(y, se) | 0, n = (n = n + Math.imul(y, oe) | 0) + Math.imul(v, se) | 0, s = s + Math.imul(v, oe) | 0, r = r + Math.imul(p, ce) | 0, n = (n = n + Math.imul(p, ue) | 0) + Math.imul(b, ce) | 0, s = s + Math.imul(b, ue) | 0;
            var xe = (u + (r = r + Math.imul(f, fe) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(f, le) | 0) + Math.imul(l, fe) | 0)) << 13) | 0;
            u = ((s = s + Math.imul(l, le) | 0) + (n >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, r = Math.imul(O, G), n = (n = Math.imul(O, V)) + Math.imul(F, G) | 0, s = Math.imul(F, V), r = r + Math.imul(M, H) | 0, n = (n = n + Math.imul(M, z) | 0) + Math.imul(P, H) | 0, s = s + Math.imul(P, z) | 0, r = r + Math.imul(W, q) | 0, n = (n = n + Math.imul(W, Y) | 0) + Math.imul(I, q) | 0, s = s + Math.imul(I, Y) | 0, r = r + Math.imul(B, J) | 0, n = (n = n + Math.imul(B, X) | 0) + Math.imul(k, J) | 0, s = s + Math.imul(k, X) | 0, r = r + Math.imul(C, Q) | 0, n = (n = n + Math.imul(C, ee) | 0) + Math.imul(S, Q) | 0, s = s + Math.imul(S, ee) | 0, r = r + Math.imul(T, ae) | 0, n = (n = n + Math.imul(T, re) | 0) + Math.imul(x, ae) | 0, s = s + Math.imul(x, re) | 0, r = r + Math.imul(g, se) | 0, n = (n = n + Math.imul(g, oe) | 0) + Math.imul(A, se) | 0, s = s + Math.imul(A, oe) | 0, r = r + Math.imul(y, ce) | 0, n = (n = n + Math.imul(y, ue) | 0) + Math.imul(v, ce) | 0, s = s + Math.imul(v, ue) | 0, r = r + Math.imul(p, fe) | 0, n = (n = n + Math.imul(p, le) | 0) + Math.imul(b, fe) | 0, s = s + Math.imul(b, le) | 0;
            var De = (u + (r = r + Math.imul(f, pe) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(f, be) | 0) + Math.imul(l, pe) | 0)) << 13) | 0;
            u = ((s = s + Math.imul(l, be) | 0) + (n >>> 13) | 0) + (De >>> 26) | 0, De &= 67108863, r = Math.imul(O, H), n = (n = Math.imul(O, z)) + Math.imul(F, H) | 0, s = Math.imul(F, z), r = r + Math.imul(M, q) | 0, n = (n = n + Math.imul(M, Y) | 0) + Math.imul(P, q) | 0, s = s + Math.imul(P, Y) | 0, r = r + Math.imul(W, J) | 0, n = (n = n + Math.imul(W, X) | 0) + Math.imul(I, J) | 0, s = s + Math.imul(I, X) | 0, r = r + Math.imul(B, Q) | 0, n = (n = n + Math.imul(B, ee) | 0) + Math.imul(k, Q) | 0, s = s + Math.imul(k, ee) | 0, r = r + Math.imul(C, ae) | 0, n = (n = n + Math.imul(C, re) | 0) + Math.imul(S, ae) | 0, s = s + Math.imul(S, re) | 0, r = r + Math.imul(T, se) | 0, n = (n = n + Math.imul(T, oe) | 0) + Math.imul(x, se) | 0, s = s + Math.imul(x, oe) | 0, r = r + Math.imul(g, ce) | 0, n = (n = n + Math.imul(g, ue) | 0) + Math.imul(A, ce) | 0, s = s + Math.imul(A, ue) | 0, r = r + Math.imul(y, fe) | 0, n = (n = n + Math.imul(y, le) | 0) + Math.imul(v, fe) | 0, s = s + Math.imul(v, le) | 0;
            var Ce = (u + (r = r + Math.imul(p, pe) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(p, be) | 0) + Math.imul(b, pe) | 0)) << 13) | 0;
            u = ((s = s + Math.imul(b, be) | 0) + (n >>> 13) | 0) + (Ce >>> 26) | 0, Ce &= 67108863, r = Math.imul(O, q), n = (n = Math.imul(O, Y)) + Math.imul(F, q) | 0, s = Math.imul(F, Y), r = r + Math.imul(M, J) | 0, n = (n = n + Math.imul(M, X) | 0) + Math.imul(P, J) | 0, s = s + Math.imul(P, X) | 0, r = r + Math.imul(W, Q) | 0, n = (n = n + Math.imul(W, ee) | 0) + Math.imul(I, Q) | 0, s = s + Math.imul(I, ee) | 0, r = r + Math.imul(B, ae) | 0, n = (n = n + Math.imul(B, re) | 0) + Math.imul(k, ae) | 0, s = s + Math.imul(k, re) | 0, r = r + Math.imul(C, se) | 0, n = (n = n + Math.imul(C, oe) | 0) + Math.imul(S, se) | 0, s = s + Math.imul(S, oe) | 0, r = r + Math.imul(T, ce) | 0, n = (n = n + Math.imul(T, ue) | 0) + Math.imul(x, ce) | 0, s = s + Math.imul(x, ue) | 0, r = r + Math.imul(g, fe) | 0, n = (n = n + Math.imul(g, le) | 0) + Math.imul(A, fe) | 0, s = s + Math.imul(A, le) | 0;
            var Se = (u + (r = r + Math.imul(y, pe) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(y, be) | 0) + Math.imul(v, pe) | 0)) << 13) | 0;
            u = ((s = s + Math.imul(v, be) | 0) + (n >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, r = Math.imul(O, J), n = (n = Math.imul(O, X)) + Math.imul(F, J) | 0, s = Math.imul(F, X), r = r + Math.imul(M, Q) | 0, n = (n = n + Math.imul(M, ee) | 0) + Math.imul(P, Q) | 0, s = s + Math.imul(P, ee) | 0, r = r + Math.imul(W, ae) | 0, n = (n = n + Math.imul(W, re) | 0) + Math.imul(I, ae) | 0, s = s + Math.imul(I, re) | 0, r = r + Math.imul(B, se) | 0, n = (n = n + Math.imul(B, oe) | 0) + Math.imul(k, se) | 0, s = s + Math.imul(k, oe) | 0, r = r + Math.imul(C, ce) | 0, n = (n = n + Math.imul(C, ue) | 0) + Math.imul(S, ce) | 0, s = s + Math.imul(S, ue) | 0, r = r + Math.imul(T, fe) | 0, n = (n = n + Math.imul(T, le) | 0) + Math.imul(x, fe) | 0, s = s + Math.imul(x, le) | 0;
            var Ee = (u + (r = r + Math.imul(g, pe) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(g, be) | 0) + Math.imul(A, pe) | 0)) << 13) | 0;
            u = ((s = s + Math.imul(A, be) | 0) + (n >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, r = Math.imul(O, Q), n = (n = Math.imul(O, ee)) + Math.imul(F, Q) | 0, s = Math.imul(F, ee), r = r + Math.imul(M, ae) | 0, n = (n = n + Math.imul(M, re) | 0) + Math.imul(P, ae) | 0, s = s + Math.imul(P, re) | 0, r = r + Math.imul(W, se) | 0, n = (n = n + Math.imul(W, oe) | 0) + Math.imul(I, se) | 0, s = s + Math.imul(I, oe) | 0, r = r + Math.imul(B, ce) | 0, n = (n = n + Math.imul(B, ue) | 0) + Math.imul(k, ce) | 0, s = s + Math.imul(k, ue) | 0, r = r + Math.imul(C, fe) | 0, n = (n = n + Math.imul(C, le) | 0) + Math.imul(S, fe) | 0, s = s + Math.imul(S, le) | 0;
            var Be = (u + (r = r + Math.imul(T, pe) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(T, be) | 0) + Math.imul(x, pe) | 0)) << 13) | 0;
            u = ((s = s + Math.imul(x, be) | 0) + (n >>> 13) | 0) + (Be >>> 26) | 0, Be &= 67108863, r = Math.imul(O, ae), n = (n = Math.imul(O, re)) + Math.imul(F, ae) | 0, s = Math.imul(F, re), r = r + Math.imul(M, se) | 0, n = (n = n + Math.imul(M, oe) | 0) + Math.imul(P, se) | 0, s = s + Math.imul(P, oe) | 0, r = r + Math.imul(W, ce) | 0, n = (n = n + Math.imul(W, ue) | 0) + Math.imul(I, ce) | 0, s = s + Math.imul(I, ue) | 0, r = r + Math.imul(B, fe) | 0, n = (n = n + Math.imul(B, le) | 0) + Math.imul(k, fe) | 0, s = s + Math.imul(k, le) | 0;
            var ke = (u + (r = r + Math.imul(C, pe) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(C, be) | 0) + Math.imul(S, pe) | 0)) << 13) | 0;
            u = ((s = s + Math.imul(S, be) | 0) + (n >>> 13) | 0) + (ke >>> 26) | 0, ke &= 67108863, r = Math.imul(O, se), n = (n = Math.imul(O, oe)) + Math.imul(F, se) | 0, s = Math.imul(F, oe), r = r + Math.imul(M, ce) | 0, n = (n = n + Math.imul(M, ue) | 0) + Math.imul(P, ce) | 0, s = s + Math.imul(P, ue) | 0, r = r + Math.imul(W, fe) | 0, n = (n = n + Math.imul(W, le) | 0) + Math.imul(I, fe) | 0, s = s + Math.imul(I, le) | 0;
            var Re = (u + (r = r + Math.imul(B, pe) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(B, be) | 0) + Math.imul(k, pe) | 0)) << 13) | 0;
            u = ((s = s + Math.imul(k, be) | 0) + (n >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, r = Math.imul(O, ce), n = (n = Math.imul(O, ue)) + Math.imul(F, ce) | 0, s = Math.imul(F, ue), r = r + Math.imul(M, fe) | 0, n = (n = n + Math.imul(M, le) | 0) + Math.imul(P, fe) | 0, s = s + Math.imul(P, le) | 0;
            var We = (u + (r = r + Math.imul(W, pe) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(W, be) | 0) + Math.imul(I, pe) | 0)) << 13) | 0;
            u = ((s = s + Math.imul(I, be) | 0) + (n >>> 13) | 0) + (We >>> 26) | 0, We &= 67108863, r = Math.imul(O, fe), n = (n = Math.imul(O, le)) + Math.imul(F, fe) | 0, s = Math.imul(F, le);
            var Ie = (u + (r = r + Math.imul(M, pe) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(M, be) | 0) + Math.imul(P, pe) | 0)) << 13) | 0;
            u = ((s = s + Math.imul(P, be) | 0) + (n >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863;
            var Ne = (u + (r = Math.imul(O, pe)) | 0) + ((8191 & (n = (n = Math.imul(O, be)) + Math.imul(F, pe) | 0)) << 13) | 0;
            return u = ((s = Math.imul(F, be)) + (n >>> 13) | 0) + (Ne >>> 26) | 0, Ne &= 67108863, c[0] = me, c[1] = ye, c[2] = ve, c[3] = _e, c[4] = ge, c[5] = Ae, c[6] = we, c[7] = Te, c[8] = xe, c[9] = De, c[10] = Ce, c[11] = Se, c[12] = Ee, c[13] = Be, c[14] = ke, c[15] = Re, c[16] = We, c[17] = Ie, c[18] = Ne, 0 !== u && (c[19] = u, a.length++), a;
          };

          function p(e, t, a) {
            return new b().mulp(e, t, a);
          }

          function b(e, t) {
            this.x = e, this.y = t;
          }

          Math.imul || (h = l), s.prototype.mulTo = function (e, t) {
            var a = this.length + e.length;
            return 10 === this.length && 10 === e.length ? h(this, e, t) : a < 63 ? l(this, e, t) : a < 1024 ? function (e, t, a) {
              a.negative = t.negative ^ e.negative, a.length = e.length + t.length;

              for (var r = 0, n = 0, s = 0; s < a.length - 1; s++) {
                var o = n;
                n = 0;

                for (var i = 67108863 & r, c = Math.min(s, t.length - 1), u = Math.max(0, s - e.length + 1); u <= c; u++) {
                  var d = s - u,
                      f = (0 | e.words[d]) * (0 | t.words[u]),
                      l = 67108863 & f;
                  i = 67108863 & (l = l + i | 0), n += (o = (o = o + (f / 67108864 | 0) | 0) + (l >>> 26) | 0) >>> 26, o &= 67108863;
                }

                a.words[s] = i, r = o, o = n;
              }

              return 0 !== r ? a.words[s] = r : a.length--, a.strip();
            }(this, e, t) : p(this, e, t);
          }, b.prototype.makeRBT = function (e) {
            for (var t = new Array(e), a = s.prototype._countBits(e) - 1, r = 0; r < e; r++) {
              t[r] = this.revBin(r, a, e);
            }

            return t;
          }, b.prototype.revBin = function (e, t, a) {
            if (0 === e || e === a - 1) return e;

            for (var r = 0, n = 0; n < t; n++) {
              r |= (1 & e) << t - n - 1, e >>= 1;
            }

            return r;
          }, b.prototype.permute = function (e, t, a, r, n, s) {
            for (var o = 0; o < s; o++) {
              r[o] = t[e[o]], n[o] = a[e[o]];
            }
          }, b.prototype.transform = function (e, t, a, r, n, s) {
            this.permute(s, e, t, a, r, n);

            for (var o = 1; o < n; o <<= 1) {
              for (var i = o << 1, c = Math.cos(2 * Math.PI / i), u = Math.sin(2 * Math.PI / i), d = 0; d < n; d += i) {
                for (var f = c, l = u, h = 0; h < o; h++) {
                  var p = a[d + h],
                      b = r[d + h],
                      m = a[d + h + o],
                      y = r[d + h + o],
                      v = f * m - l * y;
                  y = f * y + l * m, m = v, a[d + h] = p + m, r[d + h] = b + y, a[d + h + o] = p - m, r[d + h + o] = b - y, h !== i && (v = c * f - u * l, l = c * l + u * f, f = v);
                }
              }
            }
          }, b.prototype.guessLen13b = function (e, t) {
            var a = 1 | Math.max(t, e),
                r = 1 & a,
                n = 0;

            for (a = a / 2 | 0; a; a >>>= 1) {
              n++;
            }

            return 1 << n + 1 + r;
          }, b.prototype.conjugate = function (e, t, a) {
            if (!(a <= 1)) for (var r = 0; r < a / 2; r++) {
              var n = e[r];
              e[r] = e[a - r - 1], e[a - r - 1] = n, n = t[r], t[r] = -t[a - r - 1], t[a - r - 1] = -n;
            }
          }, b.prototype.normalize13b = function (e, t) {
            for (var a = 0, r = 0; r < t / 2; r++) {
              var n = 8192 * Math.round(e[2 * r + 1] / t) + Math.round(e[2 * r] / t) + a;
              e[r] = 67108863 & n, a = n < 67108864 ? 0 : n / 67108864 | 0;
            }

            return e;
          }, b.prototype.convert13b = function (e, t, a, n) {
            for (var s = 0, o = 0; o < t; o++) {
              s += 0 | e[o], a[2 * o] = 8191 & s, s >>>= 13, a[2 * o + 1] = 8191 & s, s >>>= 13;
            }

            for (o = 2 * t; o < n; ++o) {
              a[o] = 0;
            }

            r(0 === s), r(0 == (-8192 & s));
          }, b.prototype.stub = function (e) {
            for (var t = new Array(e), a = 0; a < e; a++) {
              t[a] = 0;
            }

            return t;
          }, b.prototype.mulp = function (e, t, a) {
            var r = 2 * this.guessLen13b(e.length, t.length),
                n = this.makeRBT(r),
                s = this.stub(r),
                o = new Array(r),
                i = new Array(r),
                c = new Array(r),
                u = new Array(r),
                d = new Array(r),
                f = new Array(r),
                l = a.words;
            l.length = r, this.convert13b(e.words, e.length, o, r), this.convert13b(t.words, t.length, u, r), this.transform(o, s, i, c, r, n), this.transform(u, s, d, f, r, n);

            for (var h = 0; h < r; h++) {
              var p = i[h] * d[h] - c[h] * f[h];
              c[h] = i[h] * f[h] + c[h] * d[h], i[h] = p;
            }

            return this.conjugate(i, c, r), this.transform(i, c, l, s, r, n), this.conjugate(l, s, r), this.normalize13b(l, r), a.negative = e.negative ^ t.negative, a.length = e.length + t.length, a.strip();
          }, s.prototype.mul = function (e) {
            var t = new s(null);
            return t.words = new Array(this.length + e.length), this.mulTo(e, t);
          }, s.prototype.mulf = function (e) {
            var t = new s(null);
            return t.words = new Array(this.length + e.length), p(this, e, t);
          }, s.prototype.imul = function (e) {
            return this.clone().mulTo(e, this);
          }, s.prototype.imuln = function (e) {
            r("number" == typeof e), r(e < 67108864);

            for (var t = 0, a = 0; a < this.length; a++) {
              var n = (0 | this.words[a]) * e,
                  s = (67108863 & n) + (67108863 & t);
              t >>= 26, t += n / 67108864 | 0, t += s >>> 26, this.words[a] = 67108863 & s;
            }

            return 0 !== t && (this.words[a] = t, this.length++), this;
          }, s.prototype.muln = function (e) {
            return this.clone().imuln(e);
          }, s.prototype.sqr = function () {
            return this.mul(this);
          }, s.prototype.isqr = function () {
            return this.imul(this.clone());
          }, s.prototype.pow = function (e) {
            var t = function (e) {
              for (var t = new Array(e.bitLength()), a = 0; a < t.length; a++) {
                var r = a / 26 | 0,
                    n = a % 26;
                t[a] = (e.words[r] & 1 << n) >>> n;
              }

              return t;
            }(e);

            if (0 === t.length) return new s(1);

            for (var a = this, r = 0; r < t.length && 0 === t[r]; r++, a = a.sqr()) {
              ;
            }

            if (++r < t.length) for (var n = a.sqr(); r < t.length; r++, n = n.sqr()) {
              0 !== t[r] && (a = a.mul(n));
            }
            return a;
          }, s.prototype.iushln = function (e) {
            r("number" == typeof e && 0 <= e);
            var t,
                a = e % 26,
                n = (e - a) / 26,
                s = 67108863 >>> 26 - a << 26 - a;

            if (0 != a) {
              var o = 0;

              for (t = 0; t < this.length; t++) {
                var i = this.words[t] & s,
                    c = (0 | this.words[t]) - i << a;
                this.words[t] = c | o, o = i >>> 26 - a;
              }

              o && (this.words[t] = o, this.length++);
            }

            if (0 != n) {
              for (t = this.length - 1; 0 <= t; t--) {
                this.words[t + n] = this.words[t];
              }

              for (t = 0; t < n; t++) {
                this.words[t] = 0;
              }

              this.length += n;
            }

            return this.strip();
          }, s.prototype.ishln = function (e) {
            return r(0 === this.negative), this.iushln(e);
          }, s.prototype.iushrn = function (e, t, a) {
            var n;
            r("number" == typeof e && 0 <= e), n = t ? (t - t % 26) / 26 : 0;
            var s = e % 26,
                o = Math.min((e - s) / 26, this.length),
                i = 67108863 ^ 67108863 >>> s << s,
                c = a;

            if (n -= o, n = Math.max(0, n), c) {
              for (var u = 0; u < o; u++) {
                c.words[u] = this.words[u];
              }

              c.length = o;
            }

            if (0 === o) ;else if (this.length > o) for (this.length -= o, u = 0; u < this.length; u++) {
              this.words[u] = this.words[u + o];
            } else this.words[0] = 0, this.length = 1;
            var d = 0;

            for (u = this.length - 1; 0 <= u && (0 !== d || n <= u); u--) {
              var f = 0 | this.words[u];
              this.words[u] = d << 26 - s | f >>> s, d = f & i;
            }

            return c && 0 !== d && (c.words[c.length++] = d), 0 === this.length && (this.words[0] = 0, this.length = 1), this.strip();
          }, s.prototype.ishrn = function (e, t, a) {
            return r(0 === this.negative), this.iushrn(e, t, a);
          }, s.prototype.shln = function (e) {
            return this.clone().ishln(e);
          }, s.prototype.ushln = function (e) {
            return this.clone().iushln(e);
          }, s.prototype.shrn = function (e) {
            return this.clone().ishrn(e);
          }, s.prototype.ushrn = function (e) {
            return this.clone().iushrn(e);
          }, s.prototype.testn = function (e) {
            r("number" == typeof e && 0 <= e);
            var t = e % 26,
                a = (e - t) / 26,
                n = 1 << t;
            return !(this.length <= a || !(this.words[a] & n));
          }, s.prototype.imaskn = function (e) {
            r("number" == typeof e && 0 <= e);
            var t = e % 26,
                a = (e - t) / 26;
            if (r(0 === this.negative, "imaskn works only with positive numbers"), this.length <= a) return this;

            if (0 != t && a++, this.length = Math.min(a, this.length), 0 != t) {
              var n = 67108863 ^ 67108863 >>> t << t;
              this.words[this.length - 1] &= n;
            }

            return this.strip();
          }, s.prototype.maskn = function (e) {
            return this.clone().imaskn(e);
          }, s.prototype.iaddn = function (e) {
            return r("number" == typeof e), r(e < 67108864), e < 0 ? this.isubn(-e) : 0 !== this.negative ? (1 === this.length && (0 | this.words[0]) < e ? (this.words[0] = e - (0 | this.words[0]), this.negative = 0) : (this.negative = 0, this.isubn(e), this.negative = 1), this) : this._iaddn(e);
          }, s.prototype._iaddn = function (e) {
            this.words[0] += e;

            for (var t = 0; t < this.length && 67108864 <= this.words[t]; t++) {
              this.words[t] -= 67108864, t === this.length - 1 ? this.words[t + 1] = 1 : this.words[t + 1]++;
            }

            return this.length = Math.max(this.length, t + 1), this;
          }, s.prototype.isubn = function (e) {
            if (r("number" == typeof e), r(e < 67108864), e < 0) return this.iaddn(-e);
            if (0 !== this.negative) return this.negative = 0, this.iaddn(e), this.negative = 1, this;
            if (this.words[0] -= e, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;else for (var t = 0; t < this.length && this.words[t] < 0; t++) {
              this.words[t] += 67108864, this.words[t + 1] -= 1;
            }
            return this.strip();
          }, s.prototype.addn = function (e) {
            return this.clone().iaddn(e);
          }, s.prototype.subn = function (e) {
            return this.clone().isubn(e);
          }, s.prototype.iabs = function () {
            return this.negative = 0, this;
          }, s.prototype.abs = function () {
            return this.clone().iabs();
          }, s.prototype._ishlnsubmul = function (e, t, a) {
            var n,
                s,
                o = e.length + a;

            this._expand(o);

            var i = 0;

            for (n = 0; n < e.length; n++) {
              s = (0 | this.words[n + a]) + i;
              var c = (0 | e.words[n]) * t;
              i = ((s -= 67108863 & c) >> 26) - (c / 67108864 | 0), this.words[n + a] = 67108863 & s;
            }

            for (; n < this.length - a; n++) {
              i = (s = (0 | this.words[n + a]) + i) >> 26, this.words[n + a] = 67108863 & s;
            }

            if (0 === i) return this.strip();

            for (r(-1 === i), n = i = 0; n < this.length; n++) {
              i = (s = -(0 | this.words[n]) + i) >> 26, this.words[n] = 67108863 & s;
            }

            return this.negative = 1, this.strip();
          }, s.prototype._wordDiv = function (e, t) {
            var a = (this.length, e.length),
                r = this.clone(),
                n = e,
                o = 0 | n.words[n.length - 1];
            0 != (a = 26 - this._countBits(o)) && (n = n.ushln(a), r.iushln(a), o = 0 | n.words[n.length - 1]);
            var i,
                c = r.length - n.length;

            if ("mod" !== t) {
              (i = new s(null)).length = 1 + c, i.words = new Array(i.length);

              for (var u = 0; u < i.length; u++) {
                i.words[u] = 0;
              }
            }

            var d = r.clone()._ishlnsubmul(n, 1, c);

            0 === d.negative && (r = d, i && (i.words[c] = 1));

            for (var f = c - 1; 0 <= f; f--) {
              var l = 67108864 * (0 | r.words[n.length + f]) + (0 | r.words[n.length + f - 1]);

              for (l = Math.min(l / o | 0, 67108863), r._ishlnsubmul(n, l, f); 0 !== r.negative;) {
                l--, r.negative = 0, r._ishlnsubmul(n, 1, f), r.isZero() || (r.negative ^= 1);
              }

              i && (i.words[f] = l);
            }

            return i && i.strip(), r.strip(), "div" !== t && 0 != a && r.iushrn(a), {
              div: i || null,
              mod: r
            };
          }, s.prototype.divmod = function (e, t, a) {
            return r(!e.isZero()), this.isZero() ? {
              div: new s(0),
              mod: new s(0)
            } : 0 !== this.negative && 0 === e.negative ? (i = this.neg().divmod(e, t), "mod" !== t && (n = i.div.neg()), "div" !== t && (o = i.mod.neg(), a && 0 !== o.negative && o.iadd(e)), {
              div: n,
              mod: o
            }) : 0 === this.negative && 0 !== e.negative ? (i = this.divmod(e.neg(), t), "mod" !== t && (n = i.div.neg()), {
              div: n,
              mod: i.mod
            }) : 0 != (this.negative & e.negative) ? (i = this.neg().divmod(e.neg(), t), "div" !== t && (o = i.mod.neg(), a && 0 !== o.negative && o.isub(e)), {
              div: i.div,
              mod: o
            }) : e.length > this.length || this.cmp(e) < 0 ? {
              div: new s(0),
              mod: this
            } : 1 === e.length ? "div" === t ? {
              div: this.divn(e.words[0]),
              mod: null
            } : "mod" === t ? {
              div: null,
              mod: new s(this.modn(e.words[0]))
            } : {
              div: this.divn(e.words[0]),
              mod: new s(this.modn(e.words[0]))
            } : this._wordDiv(e, t);
            var n, o, i;
          }, s.prototype.div = function (e) {
            return this.divmod(e, "div", !1).div;
          }, s.prototype.mod = function (e) {
            return this.divmod(e, "mod", !1).mod;
          }, s.prototype.umod = function (e) {
            return this.divmod(e, "mod", !0).mod;
          }, s.prototype.divRound = function (e) {
            var t = this.divmod(e);
            if (t.mod.isZero()) return t.div;
            var a = 0 !== t.div.negative ? t.mod.isub(e) : t.mod,
                r = e.ushrn(1),
                n = e.andln(1),
                s = a.cmp(r);
            return s < 0 || 1 === n && 0 === s ? t.div : 0 !== t.div.negative ? t.div.isubn(1) : t.div.iaddn(1);
          }, s.prototype.modn = function (e) {
            r(e <= 67108863);

            for (var t = (1 << 26) % e, a = 0, n = this.length - 1; 0 <= n; n--) {
              a = (t * a + (0 | this.words[n])) % e;
            }

            return a;
          }, s.prototype.idivn = function (e) {
            r(e <= 67108863);

            for (var t = 0, a = this.length - 1; 0 <= a; a--) {
              var n = (0 | this.words[a]) + 67108864 * t;
              this.words[a] = n / e | 0, t = n % e;
            }

            return this.strip();
          }, s.prototype.divn = function (e) {
            return this.clone().idivn(e);
          }, s.prototype.egcd = function (e) {
            r(0 === e.negative), r(!e.isZero());
            var t = this,
                a = e.clone();
            t = 0 !== t.negative ? t.umod(e) : t.clone();

            for (var n = new s(1), o = new s(0), i = new s(0), c = new s(1), u = 0; t.isEven() && a.isEven();) {
              t.iushrn(1), a.iushrn(1), ++u;
            }

            for (var d = a.clone(), f = t.clone(); !t.isZero();) {
              for (var l = 0, h = 1; 0 == (t.words[0] & h) && l < 26; ++l, h <<= 1) {
                ;
              }

              if (0 < l) for (t.iushrn(l); 0 < l--;) {
                (n.isOdd() || o.isOdd()) && (n.iadd(d), o.isub(f)), n.iushrn(1), o.iushrn(1);
              }

              for (var p = 0, b = 1; 0 == (a.words[0] & b) && p < 26; ++p, b <<= 1) {
                ;
              }

              if (0 < p) for (a.iushrn(p); 0 < p--;) {
                (i.isOdd() || c.isOdd()) && (i.iadd(d), c.isub(f)), i.iushrn(1), c.iushrn(1);
              }
              0 <= t.cmp(a) ? (t.isub(a), n.isub(i), o.isub(c)) : (a.isub(t), i.isub(n), c.isub(o));
            }

            return {
              a: i,
              b: c,
              gcd: a.iushln(u)
            };
          }, s.prototype._invmp = function (e) {
            r(0 === e.negative), r(!e.isZero());
            var t = this,
                a = e.clone();
            t = 0 !== t.negative ? t.umod(e) : t.clone();

            for (var n, o = new s(1), i = new s(0), c = a.clone(); 0 < t.cmpn(1) && 0 < a.cmpn(1);) {
              for (var u = 0, d = 1; 0 == (t.words[0] & d) && u < 26; ++u, d <<= 1) {
                ;
              }

              if (0 < u) for (t.iushrn(u); 0 < u--;) {
                o.isOdd() && o.iadd(c), o.iushrn(1);
              }

              for (var f = 0, l = 1; 0 == (a.words[0] & l) && f < 26; ++f, l <<= 1) {
                ;
              }

              if (0 < f) for (a.iushrn(f); 0 < f--;) {
                i.isOdd() && i.iadd(c), i.iushrn(1);
              }
              0 <= t.cmp(a) ? (t.isub(a), o.isub(i)) : (a.isub(t), i.isub(o));
            }

            return (n = 0 === t.cmpn(1) ? o : i).cmpn(0) < 0 && n.iadd(e), n;
          }, s.prototype.gcd = function (e) {
            if (this.isZero()) return e.abs();
            if (e.isZero()) return this.abs();
            var t = this.clone(),
                a = e.clone();
            t.negative = 0;

            for (var r = a.negative = 0; t.isEven() && a.isEven(); r++) {
              t.iushrn(1), a.iushrn(1);
            }

            for (;;) {
              for (; t.isEven();) {
                t.iushrn(1);
              }

              for (; a.isEven();) {
                a.iushrn(1);
              }

              var n = t.cmp(a);

              if (n < 0) {
                var s = t;
                t = a, a = s;
              } else if (0 === n || 0 === a.cmpn(1)) break;

              t.isub(a);
            }

            return a.iushln(r);
          }, s.prototype.invm = function (e) {
            return this.egcd(e).a.umod(e);
          }, s.prototype.isEven = function () {
            return 0 == (1 & this.words[0]);
          }, s.prototype.isOdd = function () {
            return 1 == (1 & this.words[0]);
          }, s.prototype.andln = function (e) {
            return this.words[0] & e;
          }, s.prototype.bincn = function (e) {
            r("number" == typeof e);
            var t = e % 26,
                a = (e - t) / 26,
                n = 1 << t;
            if (this.length <= a) return this._expand(1 + a), this.words[a] |= n, this;

            for (var s = n, o = a; 0 !== s && o < this.length; o++) {
              var i = 0 | this.words[o];
              s = (i += s) >>> 26, i &= 67108863, this.words[o] = i;
            }

            return 0 !== s && (this.words[o] = s, this.length++), this;
          }, s.prototype.isZero = function () {
            return 1 === this.length && 0 === this.words[0];
          }, s.prototype.cmpn = function (e) {
            var t,
                a = e < 0;
            if (0 !== this.negative && !a) return -1;
            if (0 === this.negative && a) return 1;
            if (this.strip(), 1 < this.length) t = 1;else {
              a && (e = -e), r(e <= 67108863, "Number is too big");
              var n = 0 | this.words[0];
              t = n === e ? 0 : n < e ? -1 : 1;
            }
            return 0 !== this.negative ? 0 | -t : t;
          }, s.prototype.cmp = function (e) {
            if (0 !== this.negative && 0 === e.negative) return -1;
            if (0 === this.negative && 0 !== e.negative) return 1;
            var t = this.ucmp(e);
            return 0 !== this.negative ? 0 | -t : t;
          }, s.prototype.ucmp = function (e) {
            if (this.length > e.length) return 1;
            if (this.length < e.length) return -1;

            for (var t = 0, a = this.length - 1; 0 <= a; a--) {
              var r = 0 | this.words[a],
                  n = 0 | e.words[a];

              if (r != n) {
                r < n ? t = -1 : n < r && (t = 1);
                break;
              }
            }

            return t;
          }, s.prototype.gtn = function (e) {
            return 1 === this.cmpn(e);
          }, s.prototype.gt = function (e) {
            return 1 === this.cmp(e);
          }, s.prototype.gten = function (e) {
            return 0 <= this.cmpn(e);
          }, s.prototype.gte = function (e) {
            return 0 <= this.cmp(e);
          }, s.prototype.ltn = function (e) {
            return -1 === this.cmpn(e);
          }, s.prototype.lt = function (e) {
            return -1 === this.cmp(e);
          }, s.prototype.lten = function (e) {
            return this.cmpn(e) <= 0;
          }, s.prototype.lte = function (e) {
            return this.cmp(e) <= 0;
          }, s.prototype.eqn = function (e) {
            return 0 === this.cmpn(e);
          }, s.prototype.eq = function (e) {
            return 0 === this.cmp(e);
          }, s.red = function (e) {
            return new w(e);
          }, s.prototype.toRed = function (e) {
            return r(!this.red, "Already a number in reduction context"), r(0 === this.negative, "red works only with positives"), e.convertTo(this)._forceRed(e);
          }, s.prototype.fromRed = function () {
            return r(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
          }, s.prototype._forceRed = function (e) {
            return this.red = e, this;
          }, s.prototype.forceRed = function (e) {
            return r(!this.red, "Already a number in reduction context"), this._forceRed(e);
          }, s.prototype.redAdd = function (e) {
            return r(this.red, "redAdd works only with red numbers"), this.red.add(this, e);
          }, s.prototype.redIAdd = function (e) {
            return r(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, e);
          }, s.prototype.redSub = function (e) {
            return r(this.red, "redSub works only with red numbers"), this.red.sub(this, e);
          }, s.prototype.redISub = function (e) {
            return r(this.red, "redISub works only with red numbers"), this.red.isub(this, e);
          }, s.prototype.redShl = function (e) {
            return r(this.red, "redShl works only with red numbers"), this.red.shl(this, e);
          }, s.prototype.redMul = function (e) {
            return r(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.mul(this, e);
          }, s.prototype.redIMul = function (e) {
            return r(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.imul(this, e);
          }, s.prototype.redSqr = function () {
            return r(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
          }, s.prototype.redISqr = function () {
            return r(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
          }, s.prototype.redSqrt = function () {
            return r(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
          }, s.prototype.redInvm = function () {
            return r(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
          }, s.prototype.redNeg = function () {
            return r(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
          }, s.prototype.redPow = function (e) {
            return r(this.red && !e.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, e);
          };
          var m = {
            k256: null,
            p224: null,
            p192: null,
            p25519: null
          };

          function y(e, t) {
            this.name = e, this.p = new s(t, 16), this.n = this.p.bitLength(), this.k = new s(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
          }

          function v() {
            y.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
          }

          function _() {
            y.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
          }

          function g() {
            y.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
          }

          function A() {
            y.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
          }

          function w(e) {
            if ("string" == typeof e) {
              var t = s._prime(e);

              this.m = t.p, this.prime = t;
            } else r(e.gtn(1), "modulus must be greater than 1"), this.m = e, this.prime = null;
          }

          function T(e) {
            w.call(this, e), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new s(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
          }

          y.prototype._tmp = function () {
            var e = new s(null);
            return e.words = new Array(Math.ceil(this.n / 13)), e;
          }, y.prototype.ireduce = function (e) {
            for (var t, a = e; this.split(a, this.tmp), (t = (a = (a = this.imulK(a)).iadd(this.tmp)).bitLength()) > this.n;) {
              ;
            }

            var r = t < this.n ? -1 : a.ucmp(this.p);
            return 0 === r ? (a.words[0] = 0, a.length = 1) : 0 < r ? a.isub(this.p) : a.strip(), a;
          }, y.prototype.split = function (e, t) {
            e.iushrn(this.n, 0, t);
          }, y.prototype.imulK = function (e) {
            return e.imul(this.k);
          }, n(v, y), v.prototype.split = function (e, t) {
            for (var a = Math.min(e.length, 9), r = 0; r < a; r++) {
              t.words[r] = e.words[r];
            }

            if (t.length = a, e.length <= 9) return e.words[0] = 0, void (e.length = 1);
            var n = e.words[9];

            for (t.words[t.length++] = 4194303 & n, r = 10; r < e.length; r++) {
              var s = 0 | e.words[r];
              e.words[r - 10] = (4194303 & s) << 4 | n >>> 22, n = s;
            }

            n >>>= 22, 0 === (e.words[r - 10] = n) && 10 < e.length ? e.length -= 10 : e.length -= 9;
          }, v.prototype.imulK = function (e) {
            e.words[e.length] = 0, e.words[e.length + 1] = 0, e.length += 2;

            for (var t = 0, a = 0; a < e.length; a++) {
              var r = 0 | e.words[a];
              t += 977 * r, e.words[a] = 67108863 & t, t = 64 * r + (t / 67108864 | 0);
            }

            return 0 === e.words[e.length - 1] && (e.length--, 0 === e.words[e.length - 1] && e.length--), e;
          }, n(_, y), n(g, y), n(A, y), A.prototype.imulK = function (e) {
            for (var t = 0, a = 0; a < e.length; a++) {
              var r = 19 * (0 | e.words[a]) + t,
                  n = 67108863 & r;
              r >>>= 26, e.words[a] = n, t = r;
            }

            return 0 !== t && (e.words[e.length++] = t), e;
          }, s._prime = function (e) {
            if (m[e]) return m[e];
            var t;
            if ("k256" === e) t = new v();else if ("p224" === e) t = new _();else if ("p192" === e) t = new g();else {
              if ("p25519" !== e) throw new Error("Unknown prime " + e);
              t = new A();
            }
            return m[e] = t;
          }, w.prototype._verify1 = function (e) {
            r(0 === e.negative, "red works only with positives"), r(e.red, "red works only with red numbers");
          }, w.prototype._verify2 = function (e, t) {
            r(0 == (e.negative | t.negative), "red works only with positives"), r(e.red && e.red === t.red, "red works only with red numbers");
          }, w.prototype.imod = function (e) {
            return this.prime ? this.prime.ireduce(e)._forceRed(this) : e.umod(this.m)._forceRed(this);
          }, w.prototype.neg = function (e) {
            return e.isZero() ? e.clone() : this.m.sub(e)._forceRed(this);
          }, w.prototype.add = function (e, t) {
            this._verify2(e, t);

            var a = e.add(t);
            return 0 <= a.cmp(this.m) && a.isub(this.m), a._forceRed(this);
          }, w.prototype.iadd = function (e, t) {
            this._verify2(e, t);

            var a = e.iadd(t);
            return 0 <= a.cmp(this.m) && a.isub(this.m), a;
          }, w.prototype.sub = function (e, t) {
            this._verify2(e, t);

            var a = e.sub(t);
            return a.cmpn(0) < 0 && a.iadd(this.m), a._forceRed(this);
          }, w.prototype.isub = function (e, t) {
            this._verify2(e, t);

            var a = e.isub(t);
            return a.cmpn(0) < 0 && a.iadd(this.m), a;
          }, w.prototype.shl = function (e, t) {
            return this._verify1(e), this.imod(e.ushln(t));
          }, w.prototype.imul = function (e, t) {
            return this._verify2(e, t), this.imod(e.imul(t));
          }, w.prototype.mul = function (e, t) {
            return this._verify2(e, t), this.imod(e.mul(t));
          }, w.prototype.isqr = function (e) {
            return this.imul(e, e.clone());
          }, w.prototype.sqr = function (e) {
            return this.mul(e, e);
          }, w.prototype.sqrt = function (e) {
            if (e.isZero()) return e.clone();
            var t = this.m.andln(3);

            if (r(t % 2 == 1), 3 === t) {
              var a = this.m.add(new s(1)).iushrn(2);
              return this.pow(e, a);
            }

            for (var n = this.m.subn(1), o = 0; !n.isZero() && 0 === n.andln(1);) {
              o++, n.iushrn(1);
            }

            r(!n.isZero());
            var i = new s(1).toRed(this),
                c = i.redNeg(),
                u = this.m.subn(1).iushrn(1),
                d = this.m.bitLength();

            for (d = new s(2 * d * d).toRed(this); 0 !== this.pow(d, u).cmp(c);) {
              d.redIAdd(c);
            }

            for (var f = this.pow(d, n), l = this.pow(e, n.addn(1).iushrn(1)), h = this.pow(e, n), p = o; 0 !== h.cmp(i);) {
              for (var b = h, m = 0; 0 !== b.cmp(i); m++) {
                b = b.redSqr();
              }

              r(m < p);
              var y = this.pow(f, new s(1).iushln(p - m - 1));
              l = l.redMul(y), f = y.redSqr(), h = h.redMul(f), p = m;
            }

            return l;
          }, w.prototype.invm = function (e) {
            var t = e._invmp(this.m);

            return 0 !== t.negative ? (t.negative = 0, this.imod(t).redNeg()) : this.imod(t);
          }, w.prototype.pow = function (e, t) {
            if (t.isZero()) return new s(1).toRed(this);
            if (0 === t.cmpn(1)) return e.clone();
            var a = new Array(16);
            a[0] = new s(1).toRed(this), a[1] = e;

            for (var r = 2; r < a.length; r++) {
              a[r] = this.mul(a[r - 1], e);
            }

            var n = a[0],
                o = 0,
                i = 0,
                c = t.bitLength() % 26;

            for (0 === c && (c = 26), r = t.length - 1; 0 <= r; r--) {
              for (var u = t.words[r], d = c - 1; 0 <= d; d--) {
                var f = u >> d & 1;
                n !== a[0] && (n = this.sqr(n)), 0 != f || 0 !== o ? (o <<= 1, o |= f, (4 == ++i || 0 === r && 0 === d) && (n = this.mul(n, a[o]), o = i = 0)) : i = 0;
              }

              c = 26;
            }

            return n;
          }, w.prototype.convertTo = function (e) {
            var t = e.umod(this.m);
            return t === e ? t.clone() : t;
          }, w.prototype.convertFrom = function (e) {
            var t = e.clone();
            return t.red = null, t;
          }, s.mont = function (e) {
            return new T(e);
          }, n(T, w), T.prototype.convertTo = function (e) {
            return this.imod(e.ushln(this.shift));
          }, T.prototype.convertFrom = function (e) {
            var t = this.imod(e.mul(this.rinv));
            return t.red = null, t;
          }, T.prototype.imul = function (e, t) {
            if (e.isZero() || t.isZero()) return e.words[0] = 0, e.length = 1, e;
            var a = e.imul(t),
                r = a.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
                n = a.isub(r).iushrn(this.shift),
                s = n;
            return 0 <= n.cmp(this.m) ? s = n.isub(this.m) : n.cmpn(0) < 0 && (s = n.iadd(this.m)), s._forceRed(this);
          }, T.prototype.mul = function (e, t) {
            if (e.isZero() || t.isZero()) return new s(0)._forceRed(this);
            var a = e.mul(t),
                r = a.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
                n = a.isub(r).iushrn(this.shift),
                o = n;
            return 0 <= n.cmp(this.m) ? o = n.isub(this.m) : n.cmpn(0) < 0 && (o = n.iadd(this.m)), o._forceRed(this);
          }, T.prototype.invm = function (e) {
            return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this);
          };
        }(void 0 === t || t, this);
      }, {
        buffer: 11
      }],
      10: [function (e, a, r) {
        (function (e) {
          a.exports = function (t) {
            var a = new Uint8Array(t);
            return (e.crypto || e.msCrypto).getRandomValues(a), a;
          };
        }).call(this, void 0 !== t ? t : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
      }, {}],
      11: [function (e, t, a) {}, {}],
      12: [function (e, t, a) {
        "use strict";

        var r = a;
        r.version = e("../package.json").version, r.utils = e("./elliptic/utils"), r.rand = e("brorand"), r.hmacDRBG = e("./elliptic/hmac-drbg"), r.curve = e("./elliptic/curve"), r.curves = e("./elliptic/curves"), r.ec = e("./elliptic/ec"), r.eddsa = e("./elliptic/eddsa");
      }, {
        "../package.json": 26,
        "./elliptic/curve": 15,
        "./elliptic/curves": 18,
        "./elliptic/ec": 19,
        "./elliptic/eddsa": 22,
        "./elliptic/hmac-drbg": 23,
        "./elliptic/utils": 25,
        brorand: 10
      }],
      13: [function (e, t, a) {
        "use strict";

        var r = e("bn.js"),
            n = e("../../elliptic").utils,
            s = n.getNAF,
            o = n.getJSF,
            i = n.assert;

        function c(e, t) {
          this.type = e, this.p = new r(t.p, 16), this.red = t.prime ? r.red(t.prime) : r.mont(this.p), this.zero = new r(0).toRed(this.red), this.one = new r(1).toRed(this.red), this.two = new r(2).toRed(this.red), this.n = t.n && new r(t.n, 16), this.g = t.g && this.pointFromJSON(t.g, t.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4);
          var a = this.n && this.p.div(this.n);
          !a || 0 < a.cmpn(100) ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
        }

        function u(e, t) {
          this.curve = e, this.type = t, this.precomputed = null;
        }

        (t.exports = c).prototype.point = function () {
          throw new Error("Not implemented");
        }, c.prototype.validate = function () {
          throw new Error("Not implemented");
        }, c.prototype._fixedNafMul = function (e, t) {
          i(e.precomputed);

          var a = e._getDoubles(),
              r = s(t, 1),
              n = (1 << a.step + 1) - (a.step % 2 == 0 ? 2 : 1);

          n /= 3;

          for (var o = [], c = 0; c < r.length; c += a.step) {
            var u = 0;

            for (t = c + a.step - 1; c <= t; t--) {
              u = (u << 1) + r[t];
            }

            o.push(u);
          }

          for (var d = this.jpoint(null, null, null), f = this.jpoint(null, null, null), l = n; 0 < l; l--) {
            for (c = 0; c < o.length; c++) {
              (u = o[c]) === l ? f = f.mixedAdd(a.points[c]) : u === -l && (f = f.mixedAdd(a.points[c].neg()));
            }

            d = d.add(f);
          }

          return d.toP();
        }, c.prototype._wnafMul = function (e, t) {
          var a = 4,
              r = e._getNAFPoints(a);

          a = r.wnd;

          for (var n = r.points, o = s(t, a), c = this.jpoint(null, null, null), u = o.length - 1; 0 <= u; u--) {
            for (t = 0; 0 <= u && 0 === o[u]; u--) {
              t++;
            }

            if (0 <= u && t++, c = c.dblp(t), u < 0) break;
            var d = o[u];
            i(0 !== d), c = "affine" === e.type ? 0 < d ? c.mixedAdd(n[d - 1 >> 1]) : c.mixedAdd(n[-d - 1 >> 1].neg()) : 0 < d ? c.add(n[d - 1 >> 1]) : c.add(n[-d - 1 >> 1].neg());
          }

          return "affine" === e.type ? c.toP() : c;
        }, c.prototype._wnafMulAdd = function (e, t, a, r, n) {
          for (var i = this._wnafT1, c = this._wnafT2, u = this._wnafT3, d = 0, f = 0; f < r; f++) {
            var l = (D = t[f])._getNAFPoints(e);

            i[f] = l.wnd, c[f] = l.points;
          }

          for (f = r - 1; 1 <= f; f -= 2) {
            var h = f - 1,
                p = f;

            if (1 === i[h] && 1 === i[p]) {
              var b = [t[h], null, null, t[p]];
              0 === t[h].y.cmp(t[p].y) ? (b[1] = t[h].add(t[p]), b[2] = t[h].toJ().mixedAdd(t[p].neg())) : 0 === t[h].y.cmp(t[p].y.redNeg()) ? (b[1] = t[h].toJ().mixedAdd(t[p]), b[2] = t[h].add(t[p].neg())) : (b[1] = t[h].toJ().mixedAdd(t[p]), b[2] = t[h].toJ().mixedAdd(t[p].neg()));
              var m = [-3, -1, -5, -7, 0, 7, 5, 1, 3],
                  y = o(a[h], a[p]);
              d = Math.max(y[0].length, d), u[h] = new Array(d), u[p] = new Array(d);

              for (var v = 0; v < d; v++) {
                var _ = 0 | y[0][v],
                    g = 0 | y[1][v];

                u[h][v] = m[3 * (1 + _) + (1 + g)], u[p][v] = 0, c[h] = b;
              }
            } else u[h] = s(a[h], i[h]), u[p] = s(a[p], i[p]), d = Math.max(u[h].length, d), d = Math.max(u[p].length, d);
          }

          var A = this.jpoint(null, null, null),
              w = this._wnafT4;

          for (f = d; 0 <= f; f--) {
            for (var T = 0; 0 <= f;) {
              var x = !0;

              for (v = 0; v < r; v++) {
                w[v] = 0 | u[v][f], 0 !== w[v] && (x = !1);
              }

              if (!x) break;
              T++, f--;
            }

            if (0 <= f && T++, A = A.dblp(T), f < 0) break;

            for (v = 0; v < r; v++) {
              var D,
                  C = w[v];
              0 !== C && (0 < C ? D = c[v][C - 1 >> 1] : C < 0 && (D = c[v][-C - 1 >> 1].neg()), A = "affine" === D.type ? A.mixedAdd(D) : A.add(D));
            }
          }

          for (f = 0; f < r; f++) {
            c[f] = null;
          }

          return n ? A : A.toP();
        }, (c.BasePoint = u).prototype.eq = function () {
          throw new Error("Not implemented");
        }, u.prototype.validate = function () {
          return this.curve.validate(this);
        }, c.prototype.decodePoint = function (e, t) {
          e = n.toArray(e, t);
          var a = this.p.byteLength();
          if ((4 === e[0] || 6 === e[0] || 7 === e[0]) && e.length - 1 == 2 * a) return 6 === e[0] ? i(e[e.length - 1] % 2 == 0) : 7 === e[0] && i(e[e.length - 1] % 2 == 1), this.point(e.slice(1, 1 + a), e.slice(1 + a, 1 + 2 * a));
          if ((2 === e[0] || 3 === e[0]) && e.length - 1 === a) return this.pointFromX(e.slice(1, 1 + a), 3 === e[0]);
          throw new Error("Unknown point format");
        }, u.prototype.encodeCompressed = function (e) {
          return this.encode(e, !0);
        }, u.prototype._encode = function (e) {
          var t = this.curve.p.byteLength(),
              a = this.getX().toArray("be", t);
          return e ? [this.getY().isEven() ? 2 : 3].concat(a) : [4].concat(a, this.getY().toArray("be", t));
        }, u.prototype.encode = function (e, t) {
          return n.encode(this._encode(t), e);
        }, u.prototype.precompute = function (e) {
          if (this.precomputed) return this;
          var t = {
            doubles: null,
            naf: null,
            beta: null
          };
          return t.naf = this._getNAFPoints(8), t.doubles = this._getDoubles(4, e), t.beta = this._getBeta(), this.precomputed = t, this;
        }, u.prototype._hasDoubles = function (e) {
          if (!this.precomputed) return !1;
          var t = this.precomputed.doubles;
          return !!t && t.points.length >= Math.ceil((e.bitLength() + 1) / t.step);
        }, u.prototype._getDoubles = function (e, t) {
          if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;

          for (var a = [this], r = this, n = 0; n < t; n += e) {
            for (var s = 0; s < e; s++) {
              r = r.dbl();
            }

            a.push(r);
          }

          return {
            step: e,
            points: a
          };
        }, u.prototype._getNAFPoints = function (e) {
          if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;

          for (var t = [this], a = (1 << e) - 1, r = 1 == a ? null : this.dbl(), n = 1; n < a; n++) {
            t[n] = t[n - 1].add(r);
          }

          return {
            wnd: e,
            points: t
          };
        }, u.prototype._getBeta = function () {
          return null;
        }, u.prototype.dblp = function (e) {
          for (var t = this, a = 0; a < e; a++) {
            t = t.dbl();
          }

          return t;
        };
      }, {
        "../../elliptic": 12,
        "bn.js": 9
      }],
      14: [function (e, t, a) {
        t.exports = {};
      }, {}],
      15: [function (e, t, a) {
        "use strict";

        var r = a;
        r.base = e("./base"), r.short = e("./short"), r.mont = e("./mont"), r.edwards = e("./edwards");
      }, {
        "./base": 13,
        "./edwards": 14,
        "./mont": 16,
        "./short": 17
      }],
      16: [function (e, t, a) {
        arguments[4][14][0].apply(a, arguments);
      }, {
        dup: 14
      }],
      17: [function (e, t, a) {
        "use strict";

        var r = e("../curve"),
            n = e("../../elliptic"),
            s = e("bn.js"),
            o = e("inherits"),
            i = r.base,
            c = n.utils.assert;

        function u(e) {
          i.call(this, "short", e), this.a = new s(e.a, 16).toRed(this.red), this.b = new s(e.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = 0 === this.a.fromRed().cmpn(0), this.threeA = 0 === this.a.fromRed().sub(this.p).cmpn(-3), this.endo = this._getEndomorphism(e), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
        }

        function d(e, t, a, r) {
          i.BasePoint.call(this, e, "affine"), null === t && null === a ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new s(t, 16), this.y = new s(a, 16), r && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
        }

        function f(e, t, a, r) {
          i.BasePoint.call(this, e, "jacobian"), null === t && null === a && null === r ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new s(0)) : (this.x = new s(t, 16), this.y = new s(a, 16), this.z = new s(r, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
        }

        o(u, i), (t.exports = u).prototype._getEndomorphism = function (e) {
          if (this.zeroA && this.g && this.n && 1 === this.p.modn(3)) {
            var t, a;
            if (e.beta) t = new s(e.beta, 16).toRed(this.red);else {
              var r = this._getEndoRoots(this.p);

              t = (t = r[0].cmp(r[1]) < 0 ? r[0] : r[1]).toRed(this.red);
            }
            if (e.lambda) a = new s(e.lambda, 16);else {
              var n = this._getEndoRoots(this.n);

              0 === this.g.mul(n[0]).x.cmp(this.g.x.redMul(t)) ? a = n[0] : (a = n[1], c(0 === this.g.mul(a).x.cmp(this.g.x.redMul(t))));
            }
            return {
              beta: t,
              lambda: a,
              basis: e.basis ? e.basis.map(function (e) {
                return {
                  a: new s(e.a, 16),
                  b: new s(e.b, 16)
                };
              }) : this._getEndoBasis(a)
            };
          }
        }, u.prototype._getEndoRoots = function (e) {
          var t = e === this.p ? this.red : s.mont(e),
              a = new s(2).toRed(t).redInvm(),
              r = a.redNeg(),
              n = new s(3).toRed(t).redNeg().redSqrt().redMul(a);
          return [r.redAdd(n).fromRed(), r.redSub(n).fromRed()];
        }, u.prototype._getEndoBasis = function (e) {
          for (var t, a, r, n, o, i, c, u, d, f = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), l = e, h = this.n.clone(), p = new s(1), b = new s(0), m = new s(0), y = new s(1), v = 0; 0 !== l.cmpn(0);) {
            var _ = h.div(l);

            u = h.sub(_.mul(l)), d = m.sub(_.mul(p));
            var g = y.sub(_.mul(b));
            if (!r && u.cmp(f) < 0) t = c.neg(), a = p, r = u.neg(), n = d;else if (r && 2 == ++v) break;
            h = l, l = c = u, m = p, p = d, y = b, b = g;
          }

          o = u.neg(), i = d;
          var A = r.sqr().add(n.sqr());
          return 0 <= o.sqr().add(i.sqr()).cmp(A) && (o = t, i = a), r.negative && (r = r.neg(), n = n.neg()), o.negative && (o = o.neg(), i = i.neg()), [{
            a: r,
            b: n
          }, {
            a: o,
            b: i
          }];
        }, u.prototype._endoSplit = function (e) {
          var t = this.endo.basis,
              a = t[0],
              r = t[1],
              n = r.b.mul(e).divRound(this.n),
              s = a.b.neg().mul(e).divRound(this.n),
              o = n.mul(a.a),
              i = s.mul(r.a),
              c = n.mul(a.b),
              u = s.mul(r.b);
          return {
            k1: e.sub(o).sub(i),
            k2: c.add(u).neg()
          };
        }, u.prototype.pointFromX = function (e, t) {
          (e = new s(e, 16)).red || (e = e.toRed(this.red));
          var a = e.redSqr().redMul(e).redIAdd(e.redMul(this.a)).redIAdd(this.b),
              r = a.redSqrt();
          if (0 !== r.redSqr().redSub(a).cmp(this.zero)) throw new Error("invalid point");
          var n = r.fromRed().isOdd();
          return (t && !n || !t && n) && (r = r.redNeg()), this.point(e, r);
        }, u.prototype.validate = function (e) {
          if (e.inf) return !0;
          var t = e.x,
              a = e.y,
              r = this.a.redMul(t),
              n = t.redSqr().redMul(t).redIAdd(r).redIAdd(this.b);
          return 0 === a.redSqr().redISub(n).cmpn(0);
        }, u.prototype._endoWnafMulAdd = function (e, t, a) {
          for (var r = this._endoWnafT1, n = this._endoWnafT2, s = 0; s < e.length; s++) {
            var o = this._endoSplit(t[s]),
                i = e[s],
                c = i._getBeta();

            o.k1.negative && (o.k1.ineg(), i = i.neg(!0)), o.k2.negative && (o.k2.ineg(), c = c.neg(!0)), r[2 * s] = i, r[2 * s + 1] = c, n[2 * s] = o.k1, n[2 * s + 1] = o.k2;
          }

          for (var u = this._wnafMulAdd(1, r, n, 2 * s, a), d = 0; d < 2 * s; d++) {
            r[d] = null, n[d] = null;
          }

          return u;
        }, o(d, i.BasePoint), u.prototype.point = function (e, t, a) {
          return new d(this, e, t, a);
        }, u.prototype.pointFromJSON = function (e, t) {
          return d.fromJSON(this, e, t);
        }, d.prototype._getBeta = function () {
          if (this.curve.endo) {
            var e = this.precomputed;
            if (e && e.beta) return e.beta;
            var t = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);

            if (e) {
              var a = this.curve,
                  r = function r(e) {
                return a.point(e.x.redMul(a.endo.beta), e.y);
              };

              (e.beta = t).precomputed = {
                beta: null,
                naf: e.naf && {
                  wnd: e.naf.wnd,
                  points: e.naf.points.map(r)
                },
                doubles: e.doubles && {
                  step: e.doubles.step,
                  points: e.doubles.points.map(r)
                }
              };
            }

            return t;
          }
        }, d.prototype.toJSON = function () {
          return this.precomputed ? [this.x, this.y, this.precomputed && {
            doubles: this.precomputed.doubles && {
              step: this.precomputed.doubles.step,
              points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
              wnd: this.precomputed.naf.wnd,
              points: this.precomputed.naf.points.slice(1)
            }
          }] : [this.x, this.y];
        }, d.fromJSON = function (e, t, a) {
          "string" == typeof t && (t = JSON.parse(t));
          var r = e.point(t[0], t[1], a);
          if (!t[2]) return r;

          function n(t) {
            return e.point(t[0], t[1], a);
          }

          var s = t[2];
          return r.precomputed = {
            beta: null,
            doubles: s.doubles && {
              step: s.doubles.step,
              points: [r].concat(s.doubles.points.map(n))
            },
            naf: s.naf && {
              wnd: s.naf.wnd,
              points: [r].concat(s.naf.points.map(n))
            }
          }, r;
        }, d.prototype.inspect = function () {
          return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
        }, d.prototype.isInfinity = function () {
          return this.inf;
        }, d.prototype.add = function (e) {
          if (this.inf) return e;
          if (e.inf) return this;
          if (this.eq(e)) return this.dbl();
          if (this.neg().eq(e)) return this.curve.point(null, null);
          if (0 === this.x.cmp(e.x)) return this.curve.point(null, null);
          var t = this.y.redSub(e.y);
          0 !== t.cmpn(0) && (t = t.redMul(this.x.redSub(e.x).redInvm()));
          var a = t.redSqr().redISub(this.x).redISub(e.x),
              r = t.redMul(this.x.redSub(a)).redISub(this.y);
          return this.curve.point(a, r);
        }, d.prototype.dbl = function () {
          if (this.inf) return this;
          var e = this.y.redAdd(this.y);
          if (0 === e.cmpn(0)) return this.curve.point(null, null);
          var t = this.curve.a,
              a = this.x.redSqr(),
              r = e.redInvm(),
              n = a.redAdd(a).redIAdd(a).redIAdd(t).redMul(r),
              s = n.redSqr().redISub(this.x.redAdd(this.x)),
              o = n.redMul(this.x.redSub(s)).redISub(this.y);
          return this.curve.point(s, o);
        }, d.prototype.getX = function () {
          return this.x.fromRed();
        }, d.prototype.getY = function () {
          return this.y.fromRed();
        }, d.prototype.mul = function (e) {
          return e = new s(e, 16), this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [e]) : this.curve._wnafMul(this, e);
        }, d.prototype.mulAdd = function (e, t, a) {
          var r = [this, t],
              n = [e, a];
          return this.curve.endo ? this.curve._endoWnafMulAdd(r, n) : this.curve._wnafMulAdd(1, r, n, 2);
        }, d.prototype.jmulAdd = function (e, t, a) {
          var r = [this, t],
              n = [e, a];
          return this.curve.endo ? this.curve._endoWnafMulAdd(r, n, !0) : this.curve._wnafMulAdd(1, r, n, 2, !0);
        }, d.prototype.eq = function (e) {
          return this === e || this.inf === e.inf && (this.inf || 0 === this.x.cmp(e.x) && 0 === this.y.cmp(e.y));
        }, d.prototype.neg = function (e) {
          if (this.inf) return this;
          var t = this.curve.point(this.x, this.y.redNeg());

          if (e && this.precomputed) {
            var a = this.precomputed,
                r = function r(e) {
              return e.neg();
            };

            t.precomputed = {
              naf: a.naf && {
                wnd: a.naf.wnd,
                points: a.naf.points.map(r)
              },
              doubles: a.doubles && {
                step: a.doubles.step,
                points: a.doubles.points.map(r)
              }
            };
          }

          return t;
        }, d.prototype.toJ = function () {
          return this.inf ? this.curve.jpoint(null, null, null) : this.curve.jpoint(this.x, this.y, this.curve.one);
        }, o(f, i.BasePoint), u.prototype.jpoint = function (e, t, a) {
          return new f(this, e, t, a);
        }, f.prototype.toP = function () {
          if (this.isInfinity()) return this.curve.point(null, null);
          var e = this.z.redInvm(),
              t = e.redSqr(),
              a = this.x.redMul(t),
              r = this.y.redMul(t).redMul(e);
          return this.curve.point(a, r);
        }, f.prototype.neg = function () {
          return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
        }, f.prototype.add = function (e) {
          if (this.isInfinity()) return e;
          if (e.isInfinity()) return this;
          var t = e.z.redSqr(),
              a = this.z.redSqr(),
              r = this.x.redMul(t),
              n = e.x.redMul(a),
              s = this.y.redMul(t.redMul(e.z)),
              o = e.y.redMul(a.redMul(this.z)),
              i = r.redSub(n),
              c = s.redSub(o);
          if (0 === i.cmpn(0)) return 0 !== c.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
          var u = i.redSqr(),
              d = u.redMul(i),
              f = r.redMul(u),
              l = c.redSqr().redIAdd(d).redISub(f).redISub(f),
              h = c.redMul(f.redISub(l)).redISub(s.redMul(d)),
              p = this.z.redMul(e.z).redMul(i);
          return this.curve.jpoint(l, h, p);
        }, f.prototype.mixedAdd = function (e) {
          if (this.isInfinity()) return e.toJ();
          if (e.isInfinity()) return this;
          var t = this.z.redSqr(),
              a = this.x,
              r = e.x.redMul(t),
              n = this.y,
              s = e.y.redMul(t).redMul(this.z),
              o = a.redSub(r),
              i = n.redSub(s);
          if (0 === o.cmpn(0)) return 0 !== i.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
          var c = o.redSqr(),
              u = c.redMul(o),
              d = a.redMul(c),
              f = i.redSqr().redIAdd(u).redISub(d).redISub(d),
              l = i.redMul(d.redISub(f)).redISub(n.redMul(u)),
              h = this.z.redMul(o);
          return this.curve.jpoint(f, l, h);
        }, f.prototype.dblp = function (e) {
          if (0 === e) return this;
          if (this.isInfinity()) return this;
          if (!e) return this.dbl();

          if (this.curve.zeroA || this.curve.threeA) {
            for (var t = this, a = 0; a < e; a++) {
              t = t.dbl();
            }

            return t;
          }

          var r = this.curve.a,
              n = this.curve.tinv,
              s = this.x,
              o = this.y,
              i = this.z,
              c = i.redSqr().redSqr(),
              u = o.redAdd(o);

          for (a = 0; a < e; a++) {
            var d = s.redSqr(),
                f = u.redSqr(),
                l = f.redSqr(),
                h = d.redAdd(d).redIAdd(d).redIAdd(r.redMul(c)),
                p = s.redMul(f),
                b = h.redSqr().redISub(p.redAdd(p)),
                m = p.redISub(b),
                y = h.redMul(m);
            y = y.redIAdd(y).redISub(l);
            var v = u.redMul(i);
            a + 1 < e && (c = c.redMul(l)), s = b, i = v, u = y;
          }

          return this.curve.jpoint(s, u.redMul(n), i);
        }, f.prototype.dbl = function () {
          return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
        }, f.prototype._zeroDbl = function () {
          var e, t, a;

          if (this.zOne) {
            var r = this.x.redSqr(),
                n = this.y.redSqr(),
                s = n.redSqr(),
                o = this.x.redAdd(n).redSqr().redISub(r).redISub(s);
            o = o.redIAdd(o);
            var i = r.redAdd(r).redIAdd(r),
                c = i.redSqr().redISub(o).redISub(o),
                u = s.redIAdd(s);
            u = (u = u.redIAdd(u)).redIAdd(u), e = c, t = i.redMul(o.redISub(c)).redISub(u), a = this.y.redAdd(this.y);
          } else {
            var d = this.x.redSqr(),
                f = this.y.redSqr(),
                l = f.redSqr(),
                h = this.x.redAdd(f).redSqr().redISub(d).redISub(l);
            h = h.redIAdd(h);
            var p = d.redAdd(d).redIAdd(d),
                b = p.redSqr(),
                m = l.redIAdd(l);
            m = (m = m.redIAdd(m)).redIAdd(m), e = b.redISub(h).redISub(h), t = p.redMul(h.redISub(e)).redISub(m), a = (a = this.y.redMul(this.z)).redIAdd(a);
          }

          return this.curve.jpoint(e, t, a);
        }, f.prototype._threeDbl = function () {
          var e, t, a;

          if (this.zOne) {
            var r = this.x.redSqr(),
                n = this.y.redSqr(),
                s = n.redSqr(),
                o = this.x.redAdd(n).redSqr().redISub(r).redISub(s);
            o = o.redIAdd(o);
            var i = r.redAdd(r).redIAdd(r).redIAdd(this.curve.a),
                c = i.redSqr().redISub(o).redISub(o);
            e = c;
            var u = s.redIAdd(s);
            u = (u = u.redIAdd(u)).redIAdd(u), t = i.redMul(o.redISub(c)).redISub(u), a = this.y.redAdd(this.y);
          } else {
            var d = this.z.redSqr(),
                f = this.y.redSqr(),
                l = this.x.redMul(f),
                h = this.x.redSub(d).redMul(this.x.redAdd(d));
            h = h.redAdd(h).redIAdd(h);
            var p = l.redIAdd(l),
                b = (p = p.redIAdd(p)).redAdd(p);
            e = h.redSqr().redISub(b), a = this.y.redAdd(this.z).redSqr().redISub(f).redISub(d);
            var m = f.redSqr();
            m = (m = (m = m.redIAdd(m)).redIAdd(m)).redIAdd(m), t = h.redMul(p.redISub(e)).redISub(m);
          }

          return this.curve.jpoint(e, t, a);
        }, f.prototype._dbl = function () {
          var e = this.curve.a,
              t = this.x,
              a = this.y,
              r = this.z,
              n = r.redSqr().redSqr(),
              s = t.redSqr(),
              o = a.redSqr(),
              i = s.redAdd(s).redIAdd(s).redIAdd(e.redMul(n)),
              c = t.redAdd(t),
              u = (c = c.redIAdd(c)).redMul(o),
              d = i.redSqr().redISub(u.redAdd(u)),
              f = u.redISub(d),
              l = o.redSqr();
          l = (l = (l = l.redIAdd(l)).redIAdd(l)).redIAdd(l);
          var h = i.redMul(f).redISub(l),
              p = a.redAdd(a).redMul(r);
          return this.curve.jpoint(d, h, p);
        }, f.prototype.trpl = function () {
          if (!this.curve.zeroA) return this.dbl().add(this);
          var e = this.x.redSqr(),
              t = this.y.redSqr(),
              a = this.z.redSqr(),
              r = t.redSqr(),
              n = e.redAdd(e).redIAdd(e),
              s = n.redSqr(),
              o = this.x.redAdd(t).redSqr().redISub(e).redISub(r),
              i = (o = (o = (o = o.redIAdd(o)).redAdd(o).redIAdd(o)).redISub(s)).redSqr(),
              c = r.redIAdd(r);
          c = (c = (c = c.redIAdd(c)).redIAdd(c)).redIAdd(c);
          var u = n.redIAdd(o).redSqr().redISub(s).redISub(i).redISub(c),
              d = t.redMul(u);
          d = (d = d.redIAdd(d)).redIAdd(d);
          var f = this.x.redMul(i).redISub(d);
          f = (f = f.redIAdd(f)).redIAdd(f);
          var l = this.y.redMul(u.redMul(c.redISub(u)).redISub(o.redMul(i)));
          l = (l = (l = l.redIAdd(l)).redIAdd(l)).redIAdd(l);
          var h = this.z.redAdd(o).redSqr().redISub(a).redISub(i);
          return this.curve.jpoint(f, l, h);
        }, f.prototype.mul = function (e, t) {
          return e = new s(e, t), this.curve._wnafMul(this, e);
        }, f.prototype.eq = function (e) {
          if ("affine" === e.type) return this.eq(e.toJ());
          if (this === e) return !0;
          var t = this.z.redSqr(),
              a = e.z.redSqr();
          if (0 !== this.x.redMul(a).redISub(e.x.redMul(t)).cmpn(0)) return !1;
          var r = t.redMul(this.z),
              n = a.redMul(e.z);
          return 0 === this.y.redMul(n).redISub(e.y.redMul(r)).cmpn(0);
        }, f.prototype.eqXToP = function (e) {
          var t = this.z.redSqr(),
              a = e.toRed(this.curve.red).redMul(t);
          if (0 === this.x.cmp(a)) return !0;

          for (var r = e.clone(), n = this.curve.redN.redMul(t);;) {
            if (r.iadd(this.curve.n), 0 <= r.cmp(this.curve.p)) return !1;
            if (a.redIAdd(n), 0 === this.x.cmp(a)) return !0;
          }

          return !1;
        }, f.prototype.inspect = function () {
          return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
        }, f.prototype.isInfinity = function () {
          return 0 === this.z.cmpn(0);
        };
      }, {
        "../../elliptic": 12,
        "../curve": 15,
        "bn.js": 9,
        inherits: 39
      }],
      18: [function (e, t, a) {
        "use strict";

        var r,
            n = a,
            s = e("hash.js"),
            o = e("../elliptic"),
            i = o.utils.assert;

        function c(e) {
          "short" === e.type ? this.curve = new o.curve.short(e) : "edwards" === e.type ? this.curve = new o.curve.edwards(e) : this.curve = new o.curve.mont(e), this.g = this.curve.g, this.n = this.curve.n, this.hash = e.hash, i(this.g.validate(), "Invalid curve"), i(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
        }

        function u(e, t) {
          Object.defineProperty(n, e, {
            configurable: !0,
            enumerable: !0,
            get: function get() {
              var a = new c(t);
              return Object.defineProperty(n, e, {
                configurable: !0,
                enumerable: !0,
                value: a
              }), a;
            }
          });
        }

        n.PresetCurve = c, u("p192", {
          type: "short",
          prime: "p192",
          p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
          a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
          b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
          n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
          hash: s.sha256,
          gRed: !1,
          g: ["188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012", "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"]
        }), u("p224", {
          type: "short",
          prime: "p224",
          p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
          a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
          b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
          n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
          hash: s.sha256,
          gRed: !1,
          g: ["b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21", "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"]
        }), u("p256", {
          type: "short",
          prime: null,
          p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
          a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
          b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
          n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
          hash: s.sha256,
          gRed: !1,
          g: ["6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296", "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"]
        }), u("p384", {
          type: "short",
          prime: null,
          p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
          a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
          b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
          n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
          hash: s.sha384,
          gRed: !1,
          g: ["aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7", "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"]
        }), u("p521", {
          type: "short",
          prime: null,
          p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
          a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
          b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
          n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
          hash: s.sha512,
          gRed: !1,
          g: ["000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66", "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"]
        }), u("curve25519", {
          type: "mont",
          prime: "p25519",
          p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
          a: "76d06",
          b: "1",
          n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
          hash: s.sha256,
          gRed: !1,
          g: ["9"]
        }), u("ed25519", {
          type: "edwards",
          prime: "p25519",
          p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
          a: "-1",
          c: "1",
          d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
          n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
          hash: s.sha256,
          gRed: !1,
          g: ["216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a", "6666666666666666666666666666666666666666666666666666666666666658"]
        });

        try {
          r = e("./precomputed/secp256k1");
        } catch (e) {
          r = void 0;
        }

        u("secp256k1", {
          type: "short",
          prime: "k256",
          p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
          a: "0",
          b: "7",
          n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
          h: "1",
          hash: s.sha256,
          beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
          lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
          basis: [{
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
          }, {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
          }],
          gRed: !1,
          g: ["79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798", "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8", r]
        });
      }, {
        "../elliptic": 12,
        "./precomputed/secp256k1": 24,
        "hash.js": 27
      }],
      19: [function (e, t, a) {
        "use strict";

        var r = e("bn.js"),
            n = e("../../elliptic"),
            s = n.utils.assert,
            o = e("./key"),
            i = e("./signature");

        function c(e) {
          if (!(this instanceof c)) return new c(e);
          "string" == typeof e && (s(n.curves.hasOwnProperty(e), "Unknown curve " + e), e = n.curves[e]), e instanceof n.curves.PresetCurve && (e = {
            curve: e
          }), this.curve = e.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = e.curve.g, this.g.precompute(e.curve.n.bitLength() + 1), this.hash = e.hash || e.curve.hash;
        }

        (t.exports = c).prototype.keyPair = function (e) {
          return new o(this, e);
        }, c.prototype.keyFromPrivate = function (e, t) {
          return o.fromPrivate(this, e, t);
        }, c.prototype.keyFromPublic = function (e, t) {
          return o.fromPublic(this, e, t);
        }, c.prototype.genKeyPair = function (e) {
          e = e || {};

          for (var t = new n.hmacDRBG({
            hash: this.hash,
            pers: e.pers,
            entropy: e.entropy || n.rand(this.hash.hmacStrength),
            nonce: this.n.toArray()
          }), a = this.n.byteLength(), s = this.n.sub(new r(2));;) {
            var o = new r(t.generate(a));
            if (!(0 < o.cmp(s))) return o.iaddn(1), this.keyFromPrivate(o);
          }
        }, c.prototype._truncateToN = function (e, t) {
          var a = 8 * e.byteLength() - this.n.bitLength();
          return 0 < a && (e = e.ushrn(a)), !t && 0 <= e.cmp(this.n) ? e.sub(this.n) : e;
        }, c.prototype.sign = function (e, t, a, s) {
          "object" == typeof a && (s = a, a = null), s = s || {}, t = this.keyFromPrivate(t, a), e = this._truncateToN(new r(e, 16));

          for (var o = this.n.byteLength(), c = t.getPrivate().toArray("be", o), u = e.toArray("be", o), d = new n.hmacDRBG({
            hash: this.hash,
            entropy: c,
            nonce: u,
            pers: s.pers,
            persEnc: s.persEnc
          }), f = this.n.sub(new r(1)), l = 0;; l++) {
            var h = s.k ? s.k(l) : new r(d.generate(this.n.byteLength()));

            if (!((h = this._truncateToN(h, !0)).cmpn(1) <= 0 || 0 <= h.cmp(f))) {
              var p = this.g.mul(h);

              if (!p.isInfinity()) {
                var b = p.getX(),
                    m = b.umod(this.n);

                if (0 !== m.cmpn(0)) {
                  var y = h.invm(this.n).mul(m.mul(t.getPrivate()).iadd(e));

                  if (0 !== (y = y.umod(this.n)).cmpn(0)) {
                    var v = (p.getY().isOdd() ? 1 : 0) | (0 !== b.cmp(m) ? 2 : 0);
                    return s.canonical && 0 < y.cmp(this.nh) && (y = this.n.sub(y), v ^= 1), new i({
                      r: m,
                      s: y,
                      recoveryParam: v
                    });
                  }
                }
              }
            }
          }
        }, c.prototype.verify = function (e, t, a, n) {
          e = this._truncateToN(new r(e, 16)), a = this.keyFromPublic(a, n);
          var s = (t = new i(t, "hex")).r,
              o = t.s;
          if (s.cmpn(1) < 0 || 0 <= s.cmp(this.n)) return !1;
          if (o.cmpn(1) < 0 || 0 <= o.cmp(this.n)) return !1;
          var c,
              u = o.invm(this.n),
              d = u.mul(e).umod(this.n),
              f = u.mul(s).umod(this.n);
          return this.curve._maxwellTrick ? !(c = this.g.jmulAdd(d, a.getPublic(), f)).isInfinity() && c.eqXToP(s) : !(c = this.g.mulAdd(d, a.getPublic(), f)).isInfinity() && 0 === c.getX().umod(this.n).cmp(s);
        }, c.prototype.recoverPubKey = function (e, t, a, n) {
          s((3 & a) === a, "The recovery param is more than two bits"), t = new i(t, n);
          var o = this.n,
              c = new r(e),
              u = t.r,
              d = t.s,
              f = 1 & a,
              l = a >> 1;
          if (0 <= u.cmp(this.curve.p.umod(this.curve.n)) && l) throw new Error("Unable to find sencond key candinate");
          u = l ? this.curve.pointFromX(u.add(this.curve.n), f) : this.curve.pointFromX(u, f);
          var h = t.r.invm(o),
              p = o.sub(c).mul(h).umod(o),
              b = d.mul(h).umod(o);
          return this.g.mulAdd(p, u, b);
        }, c.prototype.getKeyRecoveryParam = function (e, t, a, r) {
          if (null !== (t = new i(t, r)).recoveryParam) return t.recoveryParam;

          for (var n = 0; n < 4; n++) {
            var s;

            try {
              s = this.recoverPubKey(e, t, n);
            } catch (e) {
              continue;
            }

            if (s.eq(a)) return n;
          }

          throw new Error("Unable to find valid recovery factor");
        };
      }, {
        "../../elliptic": 12,
        "./key": 20,
        "./signature": 21,
        "bn.js": 9
      }],
      20: [function (e, t, a) {
        "use strict";

        var r = e("bn.js"),
            n = e("../../elliptic").utils.assert;

        function s(e, t) {
          this.ec = e, this.priv = null, this.pub = null, t.priv && this._importPrivate(t.priv, t.privEnc), t.pub && this._importPublic(t.pub, t.pubEnc);
        }

        (t.exports = s).fromPublic = function (e, t, a) {
          return t instanceof s ? t : new s(e, {
            pub: t,
            pubEnc: a
          });
        }, s.fromPrivate = function (e, t, a) {
          return t instanceof s ? t : new s(e, {
            priv: t,
            privEnc: a
          });
        }, s.prototype.validate = function () {
          var e = this.getPublic();
          return e.isInfinity() ? {
            result: !1,
            reason: "Invalid public key"
          } : e.validate() ? e.mul(this.ec.curve.n).isInfinity() ? {
            result: !0,
            reason: null
          } : {
            result: !1,
            reason: "Public key * N != O"
          } : {
            result: !1,
            reason: "Public key is not a point"
          };
        }, s.prototype.getPublic = function (e, t) {
          return "string" == typeof e && (t = e, e = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), t ? this.pub.encode(t, e) : this.pub;
        }, s.prototype.getPrivate = function (e) {
          return "hex" === e ? this.priv.toString(16, 2) : this.priv;
        }, s.prototype._importPrivate = function (e, t) {
          this.priv = new r(e, t || 16), this.priv = this.priv.umod(this.ec.curve.n);
        }, s.prototype._importPublic = function (e, t) {
          if (e.x || e.y) return "mont" === this.ec.curve.type ? n(e.x, "Need x coordinate") : "short" !== this.ec.curve.type && "edwards" !== this.ec.curve.type || n(e.x && e.y, "Need both x and y coordinate"), void (this.pub = this.ec.curve.point(e.x, e.y));
          this.pub = this.ec.curve.decodePoint(e, t);
        }, s.prototype.derive = function (e) {
          return e.mul(this.priv).getX();
        }, s.prototype.sign = function (e, t, a) {
          return this.ec.sign(e, this, t, a);
        }, s.prototype.verify = function (e, t) {
          return this.ec.verify(e, t, this);
        }, s.prototype.inspect = function () {
          return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
        };
      }, {
        "../../elliptic": 12,
        "bn.js": 9
      }],
      21: [function (e, t, a) {
        "use strict";

        var r = e("bn.js"),
            n = e("../../elliptic").utils,
            s = n.assert;

        function o(e, t) {
          if (e instanceof o) return e;
          this._importDER(e, t) || (s(e.r && e.s, "Signature without r or s"), this.r = new r(e.r, 16), this.s = new r(e.s, 16), void 0 === e.recoveryParam ? this.recoveryParam = null : this.recoveryParam = e.recoveryParam);
        }

        function i() {
          this.place = 0;
        }

        function c(e, t) {
          var a = e[t.place++];
          if (!(128 & a)) return a;

          for (var r = 15 & a, n = 0, s = 0, o = t.place; s < r; s++, o++) {
            n <<= 8, n |= e[o];
          }

          return t.place = o, n;
        }

        function u(e) {
          for (var t = 0, a = e.length - 1; !e[t] && !(128 & e[t + 1]) && t < a;) {
            t++;
          }

          return 0 === t ? e : e.slice(t);
        }

        function d(e, t) {
          if (t < 128) e.push(t);else {
            var a = 1 + (Math.log(t) / Math.LN2 >>> 3);

            for (e.push(128 | a); --a;) {
              e.push(t >>> (a << 3) & 255);
            }

            e.push(t);
          }
        }

        (t.exports = o).prototype._importDER = function (e, t) {
          e = n.toArray(e, t);
          var a = new i();
          if (48 !== e[a.place++]) return !1;
          if (c(e, a) + a.place !== e.length) return !1;
          if (2 !== e[a.place++]) return !1;
          var s = c(e, a),
              o = e.slice(a.place, s + a.place);
          if (a.place += s, 2 !== e[a.place++]) return !1;
          var u = c(e, a);
          if (e.length !== u + a.place) return !1;
          var d = e.slice(a.place, u + a.place);
          return 0 === o[0] && 128 & o[1] && (o = o.slice(1)), 0 === d[0] && 128 & d[1] && (d = d.slice(1)), this.r = new r(o), this.s = new r(d), !(this.recoveryParam = null);
        }, o.prototype.toDER = function (e) {
          var t = this.r.toArray(),
              a = this.s.toArray();

          for (128 & t[0] && (t = [0].concat(t)), 128 & a[0] && (a = [0].concat(a)), t = u(t), a = u(a); !(a[0] || 128 & a[1]);) {
            a = a.slice(1);
          }

          var r = [2];
          d(r, t.length), (r = r.concat(t)).push(2), d(r, a.length);
          var s = r.concat(a),
              o = [48];
          return d(o, s.length), o = o.concat(s), n.encode(o, e);
        };
      }, {
        "../../elliptic": 12,
        "bn.js": 9
      }],
      22: [function (e, t, a) {
        arguments[4][14][0].apply(a, arguments);
      }, {
        dup: 14
      }],
      23: [function (e, t, a) {
        "use strict";

        var r = e("hash.js"),
            n = e("../elliptic").utils,
            s = n.assert;

        function o(e) {
          if (!(this instanceof o)) return new o(e);
          this.hash = e.hash, this.predResist = !!e.predResist, this.outLen = this.hash.outSize, this.minEntropy = e.minEntropy || this.hash.hmacStrength, this.reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
          var t = n.toArray(e.entropy, e.entropyEnc),
              a = n.toArray(e.nonce, e.nonceEnc),
              r = n.toArray(e.pers, e.persEnc);
          s(t.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._init(t, a, r);
        }

        (t.exports = o).prototype._init = function (e, t, a) {
          var r = e.concat(t).concat(a);
          this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);

          for (var n = 0; n < this.V.length; n++) {
            this.K[n] = 0, this.V[n] = 1;
          }

          this._update(r), this.reseed = 1, this.reseedInterval = 281474976710656;
        }, o.prototype._hmac = function () {
          return new r.hmac(this.hash, this.K);
        }, o.prototype._update = function (e) {
          var t = this._hmac().update(this.V).update([0]);

          e && (t = t.update(e)), this.K = t.digest(), this.V = this._hmac().update(this.V).digest(), e && (this.K = this._hmac().update(this.V).update([1]).update(e).digest(), this.V = this._hmac().update(this.V).digest());
        }, o.prototype.reseed = function (e, t, a, r) {
          "string" != typeof t && (r = a, a = t, t = null), e = n.toBuffer(e, t), a = n.toBuffer(a, r), s(e.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._update(e.concat(a || [])), this.reseed = 1;
        }, o.prototype.generate = function (e, t, a, r) {
          if (this.reseed > this.reseedInterval) throw new Error("Reseed is required");
          "string" != typeof t && (r = a, a = t, t = null), a && (a = n.toArray(a, r), this._update(a));

          for (var s = []; s.length < e;) {
            this.V = this._hmac().update(this.V).digest(), s = s.concat(this.V);
          }

          var o = s.slice(0, e);
          return this._update(a), this.reseed++, n.encode(o, t);
        };
      }, {
        "../elliptic": 12,
        "hash.js": 27
      }],
      24: [function (e, t, a) {
        t.exports = void 0;
      }, {}],
      25: [function (e, t, a) {
        "use strict";

        var r = a,
            n = e("bn.js");

        function s(e) {
          return 1 === e.length ? "0" + e : e;
        }

        function o(e) {
          for (var t = "", a = 0; a < e.length; a++) {
            t += s(e[a].toString(16));
          }

          return t;
        }

        r.assert = function (e, t) {
          if (!e) throw new Error(t || "Assertion failed");
        }, r.toArray = function (e, t) {
          if (Array.isArray(e)) return e.slice();
          if (!e) return [];
          var a = [];

          if ("string" != typeof e) {
            for (var r = 0; r < e.length; r++) {
              a[r] = 0 | e[r];
            }

            return a;
          }

          if (t) {
            if ("hex" === t) for ((e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e), r = 0; r < e.length; r += 2) {
              a.push(parseInt(e[r] + e[r + 1], 16));
            }
          } else for (r = 0; r < e.length; r++) {
            var n = e.charCodeAt(r),
                s = n >> 8,
                o = 255 & n;
            s ? a.push(s, o) : a.push(o);
          }

          return a;
        }, r.zero2 = s, r.toHex = o, r.encode = function (e, t) {
          return "hex" === t ? o(e) : e;
        }, r.getNAF = function (e, t) {
          for (var a = [], r = 1 << t + 1, n = e.clone(); 0 <= n.cmpn(1);) {
            var s;

            if (n.isOdd()) {
              var o = n.andln(r - 1);
              s = (r >> 1) - 1 < o ? (r >> 1) - o : o, n.isubn(s);
            } else s = 0;

            a.push(s);

            for (var i = 0 !== n.cmpn(0) && 0 === n.andln(r - 1) ? t + 1 : 1, c = 1; c < i; c++) {
              a.push(0);
            }

            n.iushrn(i);
          }

          return a;
        }, r.getJSF = function (e, t) {
          var a = [[], []];
          e = e.clone(), t = t.clone();

          for (var r = 0, n = 0; 0 < e.cmpn(-r) || 0 < t.cmpn(-n);) {
            var s,
                o,
                i,
                c = e.andln(3) + r & 3,
                u = t.andln(3) + n & 3;
            3 === c && (c = -1), 3 === u && (u = -1), s = 0 == (1 & c) ? 0 : 3 != (i = e.andln(7) + r & 7) && 5 !== i || 2 !== u ? c : -c, a[0].push(s), o = 0 == (1 & u) ? 0 : 3 != (i = t.andln(7) + n & 7) && 5 !== i || 2 !== c ? u : -u, a[1].push(o), 2 * r === s + 1 && (r = 1 - r), 2 * n === o + 1 && (n = 1 - n), e.iushrn(1), t.iushrn(1);
          }

          return a;
        }, r.cachedProperty = function (e, t, a) {
          var r = "_" + t;

          e.prototype[t] = function () {
            return void 0 !== this[r] ? this[r] : this[r] = a.call(this);
          };
        }, r.parseBytes = function (e) {
          return "string" == typeof e ? r.toArray(e, "hex") : e;
        }, r.intFromLE = function (e) {
          return new n(e, "hex", "le");
        };
      }, {
        "bn.js": 9
      }],
      26: [function (e, t, a) {
        t.exports = {
          version: "6.3.3"
        };
      }, {}],
      27: [function (e, t, a) {
        var r = a;
        r.utils = e("./hash/utils"), r.common = e("./hash/common"), r.sha = e("./hash/sha"), r.ripemd = e("./hash/ripemd"), r.hmac = e("./hash/hmac"), r.sha1 = r.sha.sha1, r.sha256 = r.sha.sha256, r.sha224 = r.sha.sha224, r.sha384 = r.sha.sha384, r.sha512 = r.sha.sha512, r.ripemd160 = r.ripemd.ripemd160;
      }, {
        "./hash/common": 28,
        "./hash/hmac": 29,
        "./hash/ripemd": 30,
        "./hash/sha": 31,
        "./hash/utils": 38
      }],
      28: [function (e, t, a) {
        "use strict";

        var r = e("./utils"),
            n = e("minimalistic-assert");

        function s() {
          this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
        }

        (a.BlockHash = s).prototype.update = function (e, t) {
          if (e = r.toArray(e, t), this.pending ? this.pending = this.pending.concat(e) : this.pending = e, this.pendingTotal += e.length, this.pending.length >= this._delta8) {
            var a = (e = this.pending).length % this._delta8;
            this.pending = e.slice(e.length - a, e.length), 0 === this.pending.length && (this.pending = null), e = r.join32(e, 0, e.length - a, this.endian);

            for (var n = 0; n < e.length; n += this._delta32) {
              this._update(e, n, n + this._delta32);
            }
          }

          return this;
        }, s.prototype.digest = function (e) {
          return this.update(this._pad()), n(null === this.pending), this._digest(e);
        }, s.prototype._pad = function () {
          var e = this.pendingTotal,
              t = this._delta8,
              a = t - (e + this.padLength) % t,
              r = new Array(a + this.padLength);
          r[0] = 128;

          for (var n = 1; n < a; n++) {
            r[n] = 0;
          }

          if (e <<= 3, "big" === this.endian) {
            for (var s = 8; s < this.padLength; s++) {
              r[n++] = 0;
            }

            r[n++] = 0, r[n++] = 0, r[n++] = 0, r[n++] = 0, r[n++] = e >>> 24 & 255, r[n++] = e >>> 16 & 255, r[n++] = e >>> 8 & 255, r[n++] = 255 & e;
          } else for (r[n++] = 255 & e, r[n++] = e >>> 8 & 255, r[n++] = e >>> 16 & 255, r[n++] = e >>> 24 & 255, r[n++] = 0, r[n++] = 0, r[n++] = 0, r[n++] = 0, s = 8; s < this.padLength; s++) {
            r[n++] = 0;
          }

          return r;
        };
      }, {
        "./utils": 38,
        "minimalistic-assert": 41
      }],
      29: [function (e, t, a) {
        "use strict";

        var r = e("./utils"),
            n = e("minimalistic-assert");

        function s(e, t, a) {
          if (!(this instanceof s)) return new s(e, t, a);
          this.Hash = e, this.blockSize = e.blockSize / 8, this.outSize = e.outSize / 8, this.inner = null, this.outer = null, this._init(r.toArray(t, a));
        }

        (t.exports = s).prototype._init = function (e) {
          e.length > this.blockSize && (e = new this.Hash().update(e).digest()), n(e.length <= this.blockSize);

          for (var t = e.length; t < this.blockSize; t++) {
            e.push(0);
          }

          for (t = 0; t < e.length; t++) {
            e[t] ^= 54;
          }

          for (this.inner = new this.Hash().update(e), t = 0; t < e.length; t++) {
            e[t] ^= 106;
          }

          this.outer = new this.Hash().update(e);
        }, s.prototype.update = function (e, t) {
          return this.inner.update(e, t), this;
        }, s.prototype.digest = function (e) {
          return this.outer.update(this.inner.digest()), this.outer.digest(e);
        };
      }, {
        "./utils": 38,
        "minimalistic-assert": 41
      }],
      30: [function (e, t, a) {
        "use strict";

        var r = e("./utils"),
            n = e("./common"),
            s = r.rotl32,
            o = r.sum32,
            i = r.sum32_3,
            c = r.sum32_4,
            u = n.BlockHash;

        function d() {
          if (!(this instanceof d)) return new d();
          u.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
        }

        function f(e, t, a, r) {
          return e <= 15 ? t ^ a ^ r : e <= 31 ? t & a | ~t & r : e <= 47 ? (t | ~a) ^ r : e <= 63 ? t & r | a & ~r : t ^ (a | ~r);
        }

        function l(e) {
          return e <= 15 ? 0 : e <= 31 ? 1518500249 : e <= 47 ? 1859775393 : e <= 63 ? 2400959708 : 2840853838;
        }

        function h(e) {
          return e <= 15 ? 1352829926 : e <= 31 ? 1548603684 : e <= 47 ? 1836072691 : e <= 63 ? 2053994217 : 0;
        }

        r.inherits(d, u), (a.ripemd160 = d).blockSize = 512, d.outSize = 160, d.hmacStrength = 192, d.padLength = 64, d.prototype._update = function (e, t) {
          for (var a = this.h[0], r = this.h[1], n = this.h[2], u = this.h[3], d = this.h[4], v = a, _ = r, g = n, A = u, w = d, T = 0; T < 80; T++) {
            var x = o(s(c(a, f(T, r, n, u), e[p[T] + t], l(T)), m[T]), d);
            a = d, d = u, u = s(n, 10), n = r, r = x, x = o(s(c(v, f(79 - T, _, g, A), e[b[T] + t], h(T)), y[T]), w), v = w, w = A, A = s(g, 10), g = _, _ = x;
          }

          x = i(this.h[1], n, A), this.h[1] = i(this.h[2], u, w), this.h[2] = i(this.h[3], d, v), this.h[3] = i(this.h[4], a, _), this.h[4] = i(this.h[0], r, g), this.h[0] = x;
        }, d.prototype._digest = function (e) {
          return "hex" === e ? r.toHex32(this.h, "little") : r.split32(this.h, "little");
        };
        var p = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13],
            b = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11],
            m = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6],
            y = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11];
      }, {
        "./common": 28,
        "./utils": 38
      }],
      31: [function (e, t, a) {
        "use strict";

        a.sha1 = e("./sha/1"), a.sha224 = e("./sha/224"), a.sha256 = e("./sha/256"), a.sha384 = e("./sha/384"), a.sha512 = e("./sha/512");
      }, {
        "./sha/1": 32,
        "./sha/224": 33,
        "./sha/256": 34,
        "./sha/384": 35,
        "./sha/512": 36
      }],
      32: [function (e, t, a) {
        arguments[4][14][0].apply(a, arguments);
      }, {
        dup: 14
      }],
      33: [function (e, t, a) {
        arguments[4][14][0].apply(a, arguments);
      }, {
        dup: 14
      }],
      34: [function (e, t, a) {
        "use strict";

        var r = e("../utils"),
            n = e("../common"),
            s = e("./common"),
            o = e("minimalistic-assert"),
            i = r.sum32,
            c = r.sum32_4,
            u = r.sum32_5,
            d = s.ch32,
            f = s.maj32,
            l = s.s0_256,
            h = s.s1_256,
            p = s.g0_256,
            b = s.g1_256,
            m = n.BlockHash,
            y = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298];

        function v() {
          if (!(this instanceof v)) return new v();
          m.call(this), this.h = [1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225], this.k = y, this.W = new Array(64);
        }

        r.inherits(v, m), (t.exports = v).blockSize = 512, v.outSize = 256, v.hmacStrength = 192, v.padLength = 64, v.prototype._update = function (e, t) {
          for (var a = this.W, r = 0; r < 16; r++) {
            a[r] = e[t + r];
          }

          for (; r < a.length; r++) {
            a[r] = c(b(a[r - 2]), a[r - 7], p(a[r - 15]), a[r - 16]);
          }

          var n = this.h[0],
              s = this.h[1],
              m = this.h[2],
              y = this.h[3],
              v = this.h[4],
              _ = this.h[5],
              g = this.h[6],
              A = this.h[7];

          for (o(this.k.length === a.length), r = 0; r < a.length; r++) {
            var w = u(A, h(v), d(v, _, g), this.k[r], a[r]),
                T = i(l(n), f(n, s, m));
            A = g, g = _, _ = v, v = i(y, w), y = m, m = s, s = n, n = i(w, T);
          }

          this.h[0] = i(this.h[0], n), this.h[1] = i(this.h[1], s), this.h[2] = i(this.h[2], m), this.h[3] = i(this.h[3], y), this.h[4] = i(this.h[4], v), this.h[5] = i(this.h[5], _), this.h[6] = i(this.h[6], g), this.h[7] = i(this.h[7], A);
        }, v.prototype._digest = function (e) {
          return "hex" === e ? r.toHex32(this.h, "big") : r.split32(this.h, "big");
        };
      }, {
        "../common": 28,
        "../utils": 38,
        "./common": 37,
        "minimalistic-assert": 41
      }],
      35: [function (e, t, a) {
        arguments[4][14][0].apply(a, arguments);
      }, {
        dup: 14
      }],
      36: [function (e, t, a) {
        "use strict";

        var r = e("../utils"),
            n = e("../common"),
            s = e("minimalistic-assert"),
            o = r.rotr64_hi,
            i = r.rotr64_lo,
            c = r.shr64_hi,
            u = r.shr64_lo,
            d = r.sum64,
            f = r.sum64_hi,
            l = r.sum64_lo,
            h = r.sum64_4_hi,
            p = r.sum64_4_lo,
            b = r.sum64_5_hi,
            m = r.sum64_5_lo,
            y = n.BlockHash,
            v = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591];

        function _() {
          if (!(this instanceof _)) return new _();
          y.call(this), this.h = [1779033703, 4089235720, 3144134277, 2227873595, 1013904242, 4271175723, 2773480762, 1595750129, 1359893119, 2917565137, 2600822924, 725511199, 528734635, 4215389547, 1541459225, 327033209], this.k = v, this.W = new Array(160);
        }

        function g(e, t, a, r, n) {
          var s = e & a ^ ~e & n;
          return s < 0 && (s += 4294967296), s;
        }

        function A(e, t, a, r, n, s) {
          var o = t & r ^ ~t & s;
          return o < 0 && (o += 4294967296), o;
        }

        function w(e, t, a, r, n) {
          var s = e & a ^ e & n ^ a & n;
          return s < 0 && (s += 4294967296), s;
        }

        function T(e, t, a, r, n, s) {
          var o = t & r ^ t & s ^ r & s;
          return o < 0 && (o += 4294967296), o;
        }

        function x(e, t) {
          var a = o(e, t, 28) ^ o(t, e, 2) ^ o(t, e, 7);
          return a < 0 && (a += 4294967296), a;
        }

        function D(e, t) {
          var a = i(e, t, 28) ^ i(t, e, 2) ^ i(t, e, 7);
          return a < 0 && (a += 4294967296), a;
        }

        function C(e, t) {
          var a = o(e, t, 14) ^ o(e, t, 18) ^ o(t, e, 9);
          return a < 0 && (a += 4294967296), a;
        }

        function S(e, t) {
          var a = i(e, t, 14) ^ i(e, t, 18) ^ i(t, e, 9);
          return a < 0 && (a += 4294967296), a;
        }

        function E(e, t) {
          var a = o(e, t, 1) ^ o(e, t, 8) ^ c(e, t, 7);
          return a < 0 && (a += 4294967296), a;
        }

        function B(e, t) {
          var a = i(e, t, 1) ^ i(e, t, 8) ^ u(e, t, 7);
          return a < 0 && (a += 4294967296), a;
        }

        function k(e, t) {
          var a = o(e, t, 19) ^ o(t, e, 29) ^ c(e, t, 6);
          return a < 0 && (a += 4294967296), a;
        }

        function R(e, t) {
          var a = i(e, t, 19) ^ i(t, e, 29) ^ u(e, t, 6);
          return a < 0 && (a += 4294967296), a;
        }

        r.inherits(_, y), (t.exports = _).blockSize = 1024, _.outSize = 512, _.hmacStrength = 192, _.padLength = 128, _.prototype._prepareBlock = function (e, t) {
          for (var a = this.W, r = 0; r < 32; r++) {
            a[r] = e[t + r];
          }

          for (; r < a.length; r += 2) {
            var n = k(a[r - 4], a[r - 3]),
                s = R(a[r - 4], a[r - 3]),
                o = a[r - 14],
                i = a[r - 13],
                c = E(a[r - 30], a[r - 29]),
                u = B(a[r - 30], a[r - 29]),
                d = a[r - 32],
                f = a[r - 31];
            a[r] = h(n, s, o, i, c, u, d, f), a[r + 1] = p(n, s, o, i, c, u, d, f);
          }
        }, _.prototype._update = function (e, t) {
          this._prepareBlock(e, t);

          var a = this.W,
              r = this.h[0],
              n = this.h[1],
              o = this.h[2],
              i = this.h[3],
              c = this.h[4],
              u = this.h[5],
              h = this.h[6],
              p = this.h[7],
              y = this.h[8],
              v = this.h[9],
              _ = this.h[10],
              E = this.h[11],
              B = this.h[12],
              k = this.h[13],
              R = this.h[14],
              W = this.h[15];
          s(this.k.length === a.length);

          for (var I = 0; I < a.length; I += 2) {
            var N = R,
                M = W,
                P = C(y, v),
                L = S(y, v),
                O = g(y, 0, _, 0, B),
                F = A(0, v, 0, E, 0, k),
                j = this.k[I],
                G = this.k[I + 1],
                V = a[I],
                U = a[I + 1],
                H = b(N, M, P, L, O, F, j, G, V, U),
                z = m(N, M, P, L, O, F, j, G, V, U);
            N = x(r, n), M = D(r, n), P = w(r, 0, o, 0, c), L = T(0, n, 0, i, 0, u);
            var K = f(N, M, P, L),
                q = l(N, M, P, L);
            R = B, W = k, B = _, k = E, _ = y, E = v, y = f(h, p, H, z), v = l(p, p, H, z), h = c, p = u, c = o, u = i, o = r, i = n, r = f(H, z, K, q), n = l(H, z, K, q);
          }

          d(this.h, 0, r, n), d(this.h, 2, o, i), d(this.h, 4, c, u), d(this.h, 6, h, p), d(this.h, 8, y, v), d(this.h, 10, _, E), d(this.h, 12, B, k), d(this.h, 14, R, W);
        }, _.prototype._digest = function (e) {
          return "hex" === e ? r.toHex32(this.h, "big") : r.split32(this.h, "big");
        };
      }, {
        "../common": 28,
        "../utils": 38,
        "minimalistic-assert": 41
      }],
      37: [function (e, t, a) {
        "use strict";

        var r = e("../utils").rotr32;

        function n(e, t, a) {
          return e & t ^ ~e & a;
        }

        function s(e, t, a) {
          return e & t ^ e & a ^ t & a;
        }

        function o(e, t, a) {
          return e ^ t ^ a;
        }

        a.ft_1 = function (e, t, a, r) {
          return 0 === e ? n(t, a, r) : 1 === e || 3 === e ? o(t, a, r) : 2 === e ? s(t, a, r) : void 0;
        }, a.ch32 = n, a.maj32 = s, a.p32 = o, a.s0_256 = function (e) {
          return r(e, 2) ^ r(e, 13) ^ r(e, 22);
        }, a.s1_256 = function (e) {
          return r(e, 6) ^ r(e, 11) ^ r(e, 25);
        }, a.g0_256 = function (e) {
          return r(e, 7) ^ r(e, 18) ^ e >>> 3;
        }, a.g1_256 = function (e) {
          return r(e, 17) ^ r(e, 19) ^ e >>> 10;
        };
      }, {
        "../utils": 38
      }],
      38: [function (e, t, a) {
        "use strict";

        var r = e("minimalistic-assert"),
            n = e("inherits");

        function s(e) {
          return (e >>> 24 | e >>> 8 & 65280 | e << 8 & 16711680 | (255 & e) << 24) >>> 0;
        }

        function o(e) {
          return 1 === e.length ? "0" + e : e;
        }

        function i(e) {
          return 7 === e.length ? "0" + e : 6 === e.length ? "00" + e : 5 === e.length ? "000" + e : 4 === e.length ? "0000" + e : 3 === e.length ? "00000" + e : 2 === e.length ? "000000" + e : 1 === e.length ? "0000000" + e : e;
        }

        a.inherits = n, a.toArray = function (e, t) {
          if (Array.isArray(e)) return e.slice();
          if (!e) return [];
          var a = [];
          if ("string" == typeof e) {
            if (t) {
              if ("hex" === t) for ((e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e), r = 0; r < e.length; r += 2) {
                a.push(parseInt(e[r] + e[r + 1], 16));
              }
            } else for (var r = 0; r < e.length; r++) {
              var n = e.charCodeAt(r),
                  s = n >> 8,
                  o = 255 & n;
              s ? a.push(s, o) : a.push(o);
            }
          } else for (r = 0; r < e.length; r++) {
            a[r] = 0 | e[r];
          }
          return a;
        }, a.toHex = function (e) {
          for (var t = "", a = 0; a < e.length; a++) {
            t += o(e[a].toString(16));
          }

          return t;
        }, a.htonl = s, a.toHex32 = function (e, t) {
          for (var a = "", r = 0; r < e.length; r++) {
            var n = e[r];
            "little" === t && (n = s(n)), a += i(n.toString(16));
          }

          return a;
        }, a.zero2 = o, a.zero8 = i, a.join32 = function (e, t, a, n) {
          var s = a - t;
          r(s % 4 == 0);

          for (var o = new Array(s / 4), i = 0, c = t; i < o.length; i++, c += 4) {
            var u;
            u = "big" === n ? e[c] << 24 | e[c + 1] << 16 | e[c + 2] << 8 | e[c + 3] : e[c + 3] << 24 | e[c + 2] << 16 | e[c + 1] << 8 | e[c], o[i] = u >>> 0;
          }

          return o;
        }, a.split32 = function (e, t) {
          for (var a = new Array(4 * e.length), r = 0, n = 0; r < e.length; r++, n += 4) {
            var s = e[r];
            "big" === t ? (a[n] = s >>> 24, a[n + 1] = s >>> 16 & 255, a[n + 2] = s >>> 8 & 255, a[n + 3] = 255 & s) : (a[n + 3] = s >>> 24, a[n + 2] = s >>> 16 & 255, a[n + 1] = s >>> 8 & 255, a[n] = 255 & s);
          }

          return a;
        }, a.rotr32 = function (e, t) {
          return e >>> t | e << 32 - t;
        }, a.rotl32 = function (e, t) {
          return e << t | e >>> 32 - t;
        }, a.sum32 = function (e, t) {
          return e + t >>> 0;
        }, a.sum32_3 = function (e, t, a) {
          return e + t + a >>> 0;
        }, a.sum32_4 = function (e, t, a, r) {
          return e + t + a + r >>> 0;
        }, a.sum32_5 = function (e, t, a, r, n) {
          return e + t + a + r + n >>> 0;
        }, a.sum64 = function (e, t, a, r) {
          var n = e[t],
              s = r + e[t + 1] >>> 0,
              o = (s < r ? 1 : 0) + a + n;
          e[t] = o >>> 0, e[t + 1] = s;
        }, a.sum64_hi = function (e, t, a, r) {
          return (t + r >>> 0 < t ? 1 : 0) + e + a >>> 0;
        }, a.sum64_lo = function (e, t, a, r) {
          return t + r >>> 0;
        }, a.sum64_4_hi = function (e, t, a, r, n, s, o, i) {
          var c = 0,
              u = t;
          return c += (u = u + r >>> 0) < t ? 1 : 0, c += (u = u + s >>> 0) < s ? 1 : 0, e + a + n + o + (c += (u = u + i >>> 0) < i ? 1 : 0) >>> 0;
        }, a.sum64_4_lo = function (e, t, a, r, n, s, o, i) {
          return t + r + s + i >>> 0;
        }, a.sum64_5_hi = function (e, t, a, r, n, s, o, i, c, u) {
          var d = 0,
              f = t;
          return d += (f = f + r >>> 0) < t ? 1 : 0, d += (f = f + s >>> 0) < s ? 1 : 0, d += (f = f + i >>> 0) < i ? 1 : 0, e + a + n + o + c + (d += (f = f + u >>> 0) < u ? 1 : 0) >>> 0;
        }, a.sum64_5_lo = function (e, t, a, r, n, s, o, i, c, u) {
          return t + r + s + i + u >>> 0;
        }, a.rotr64_hi = function (e, t, a) {
          return (t << 32 - a | e >>> a) >>> 0;
        }, a.rotr64_lo = function (e, t, a) {
          return (e << 32 - a | t >>> a) >>> 0;
        }, a.shr64_hi = function (e, t, a) {
          return e >>> a;
        }, a.shr64_lo = function (e, t, a) {
          return (e << 32 - a | t >>> a) >>> 0;
        };
      }, {
        inherits: 39,
        "minimalistic-assert": 41
      }],
      39: [function (e, t, a) {
        "function" == typeof Object.create ? t.exports = function (e, t) {
          t && (e.super_ = t, e.prototype = Object.create(t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }));
        } : t.exports = function (e, t) {
          if (t) {
            var _a2 = function _a2() {};

            e.super_ = t, _a2.prototype = t.prototype, e.prototype = new _a2(), e.prototype.constructor = e;
          }
        };
      }, {}],
      40: [function (e, a, r) {
        (function (e, t) {
          !function () {
            "use strict";

            var r = "object" == typeof window ? window : {};
            !r.JS_SHA3_NO_NODE_JS && "object" == typeof e && e.versions && e.versions.node && (r = t);

            for (var n = !r.JS_SHA3_NO_COMMON_JS && "object" == typeof a && a.exports, s = "0123456789abcdef".split(""), o = [0, 8, 16, 24], i = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649, 0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0, 2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771, 2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648, 2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648], c = [224, 256, 384, 512], u = ["hex", "buffer", "arrayBuffer", "array"], d = function d(e, t, a) {
              return function (r) {
                return new A(e, t, e).update(r)[a]();
              };
            }, f = function f(e, t, a) {
              return function (r, n) {
                return new A(e, t, n).update(r)[a]();
              };
            }, l = function l(e, t) {
              var a = d(e, t, "hex");
              a.create = function () {
                return new A(e, t, e);
              }, a.update = function (e) {
                return a.create().update(e);
              };

              for (var r = 0; r < u.length; ++r) {
                var n = u[r];
                a[n] = d(e, t, n);
              }

              return a;
            }, h = [{
              name: "keccak",
              padding: [1, 256, 65536, 16777216],
              bits: c,
              createMethod: l
            }, {
              name: "sha3",
              padding: [6, 1536, 393216, 100663296],
              bits: c,
              createMethod: l
            }, {
              name: "shake",
              padding: [31, 7936, 2031616, 520093696],
              bits: [128, 256],
              createMethod: function createMethod(e, t) {
                var a = f(e, t, "hex");
                a.create = function (a) {
                  return new A(e, t, a);
                }, a.update = function (e, t) {
                  return a.create(t).update(e);
                };

                for (var r = 0; r < u.length; ++r) {
                  var n = u[r];
                  a[n] = f(e, t, n);
                }

                return a;
              }
            }], p = {}, b = [], m = 0; m < h.length; ++m) {
              for (var y = h[m], v = y.bits, _ = 0; _ < v.length; ++_) {
                var g = y.name + "_" + v[_];
                b.push(g), p[g] = y.createMethod(v[_], y.padding);
              }
            }

            function A(e, t, a) {
              this.blocks = [], this.s = [], this.padding = t, this.outputBits = a, this.reset = !0, this.block = 0, this.start = 0, this.blockCount = 1600 - (e << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = a >> 5, this.extraBytes = (31 & a) >> 3;

              for (var r = 0; r < 50; ++r) {
                this.s[r] = 0;
              }
            }

            A.prototype.update = function (e) {
              var t = "string" != typeof e;
              t && e.constructor === ArrayBuffer && (e = new Uint8Array(e));

              for (var a, r, n = e.length, s = this.blocks, i = this.byteCount, c = this.blockCount, u = 0, d = this.s; u < n;) {
                if (this.reset) for (this.reset = !1, s[0] = this.block, a = 1; a < c + 1; ++a) {
                  s[a] = 0;
                }
                if (t) for (a = this.start; u < n && a < i; ++u) {
                  s[a >> 2] |= e[u] << o[3 & a++];
                } else for (a = this.start; u < n && a < i; ++u) {
                  (r = e.charCodeAt(u)) < 128 ? s[a >> 2] |= r << o[3 & a++] : (r < 2048 ? s[a >> 2] |= (192 | r >> 6) << o[3 & a++] : (r < 55296 || 57344 <= r ? s[a >> 2] |= (224 | r >> 12) << o[3 & a++] : (r = 65536 + ((1023 & r) << 10 | 1023 & e.charCodeAt(++u)), s[a >> 2] |= (240 | r >> 18) << o[3 & a++], s[a >> 2] |= (128 | r >> 12 & 63) << o[3 & a++]), s[a >> 2] |= (128 | r >> 6 & 63) << o[3 & a++]), s[a >> 2] |= (128 | 63 & r) << o[3 & a++]);
                }

                if (i <= (this.lastByteIndex = a)) {
                  for (this.start = a - i, this.block = s[c], a = 0; a < c; ++a) {
                    d[a] ^= s[a];
                  }

                  w(d), this.reset = !0;
                } else this.start = a;
              }

              return this;
            }, A.prototype.finalize = function () {
              var e = this.blocks,
                  t = this.lastByteIndex,
                  a = this.blockCount,
                  r = this.s;
              if (e[t >> 2] |= this.padding[3 & t], this.lastByteIndex === this.byteCount) for (e[0] = e[a], t = 1; t < a + 1; ++t) {
                e[t] = 0;
              }

              for (e[a - 1] |= 2147483648, t = 0; t < a; ++t) {
                r[t] ^= e[t];
              }

              w(r);
            }, A.prototype.toString = A.prototype.hex = function () {
              this.finalize();

              for (var e, t = this.blockCount, a = this.s, r = this.outputBlocks, n = this.extraBytes, o = 0, i = 0, c = ""; i < r;) {
                for (o = 0; o < t && i < r; ++o, ++i) {
                  e = a[o], c += s[e >> 4 & 15] + s[15 & e] + s[e >> 12 & 15] + s[e >> 8 & 15] + s[e >> 20 & 15] + s[e >> 16 & 15] + s[e >> 28 & 15] + s[e >> 24 & 15];
                }

                i % t == 0 && (w(a), o = 0);
              }

              return n && (e = a[o], 0 < n && (c += s[e >> 4 & 15] + s[15 & e]), 1 < n && (c += s[e >> 12 & 15] + s[e >> 8 & 15]), 2 < n && (c += s[e >> 20 & 15] + s[e >> 16 & 15])), c;
            }, A.prototype.buffer = A.prototype.arrayBuffer = function () {
              this.finalize();
              var e,
                  t = this.blockCount,
                  a = this.s,
                  r = this.outputBlocks,
                  n = this.extraBytes,
                  s = 0,
                  o = 0,
                  i = this.outputBits >> 3;
              e = n ? new ArrayBuffer(r + 1 << 2) : new ArrayBuffer(i);

              for (var c = new Uint32Array(e); o < r;) {
                for (s = 0; s < t && o < r; ++s, ++o) {
                  c[o] = a[s];
                }

                o % t == 0 && w(a);
              }

              return n && (c[s] = a[s], e = e.slice(0, i)), e;
            }, A.prototype.digest = A.prototype.array = function () {
              this.finalize();

              for (var e, t, a = this.blockCount, r = this.s, n = this.outputBlocks, s = this.extraBytes, o = 0, i = 0, c = []; i < n;) {
                for (o = 0; o < a && i < n; ++o, ++i) {
                  e = i << 2, t = r[o], c[e] = 255 & t, c[e + 1] = t >> 8 & 255, c[e + 2] = t >> 16 & 255, c[e + 3] = t >> 24 & 255;
                }

                i % a == 0 && w(r);
              }

              return s && (e = i << 2, t = r[o], 0 < s && (c[e] = 255 & t), 1 < s && (c[e + 1] = t >> 8 & 255), 2 < s && (c[e + 2] = t >> 16 & 255)), c;
            };

            var w = function w(e) {
              var t, a, r, n, s, o, c, u, d, f, l, h, p, b, m, y, v, _, g, A, w, T, x, D, C, S, E, B, k, R, W, I, N, M, P, L, O, F, j, G, V, U, H, z, K, q, Y, Z, J, X, $, Q, ee, te, ae, re, ne, se, oe, ie, ce, ue, de;

              for (r = 0; r < 48; r += 2) {
                n = e[0] ^ e[10] ^ e[20] ^ e[30] ^ e[40], s = e[1] ^ e[11] ^ e[21] ^ e[31] ^ e[41], o = e[2] ^ e[12] ^ e[22] ^ e[32] ^ e[42], c = e[3] ^ e[13] ^ e[23] ^ e[33] ^ e[43], u = e[4] ^ e[14] ^ e[24] ^ e[34] ^ e[44], d = e[5] ^ e[15] ^ e[25] ^ e[35] ^ e[45], f = e[6] ^ e[16] ^ e[26] ^ e[36] ^ e[46], l = e[7] ^ e[17] ^ e[27] ^ e[37] ^ e[47], t = (h = e[8] ^ e[18] ^ e[28] ^ e[38] ^ e[48]) ^ (o << 1 | c >>> 31), a = (p = e[9] ^ e[19] ^ e[29] ^ e[39] ^ e[49]) ^ (c << 1 | o >>> 31), e[0] ^= t, e[1] ^= a, e[10] ^= t, e[11] ^= a, e[20] ^= t, e[21] ^= a, e[30] ^= t, e[31] ^= a, e[40] ^= t, e[41] ^= a, t = n ^ (u << 1 | d >>> 31), a = s ^ (d << 1 | u >>> 31), e[2] ^= t, e[3] ^= a, e[12] ^= t, e[13] ^= a, e[22] ^= t, e[23] ^= a, e[32] ^= t, e[33] ^= a, e[42] ^= t, e[43] ^= a, t = o ^ (f << 1 | l >>> 31), a = c ^ (l << 1 | f >>> 31), e[4] ^= t, e[5] ^= a, e[14] ^= t, e[15] ^= a, e[24] ^= t, e[25] ^= a, e[34] ^= t, e[35] ^= a, e[44] ^= t, e[45] ^= a, t = u ^ (h << 1 | p >>> 31), a = d ^ (p << 1 | h >>> 31), e[6] ^= t, e[7] ^= a, e[16] ^= t, e[17] ^= a, e[26] ^= t, e[27] ^= a, e[36] ^= t, e[37] ^= a, e[46] ^= t, e[47] ^= a, t = f ^ (n << 1 | s >>> 31), a = l ^ (s << 1 | n >>> 31), e[8] ^= t, e[9] ^= a, e[18] ^= t, e[19] ^= a, e[28] ^= t, e[29] ^= a, e[38] ^= t, e[39] ^= a, e[48] ^= t, e[49] ^= a, b = e[0], m = e[1], q = e[11] << 4 | e[10] >>> 28, Y = e[10] << 4 | e[11] >>> 28, B = e[20] << 3 | e[21] >>> 29, k = e[21] << 3 | e[20] >>> 29, ie = e[31] << 9 | e[30] >>> 23, ce = e[30] << 9 | e[31] >>> 23, U = e[40] << 18 | e[41] >>> 14, H = e[41] << 18 | e[40] >>> 14, M = e[2] << 1 | e[3] >>> 31, P = e[3] << 1 | e[2] >>> 31, y = e[13] << 12 | e[12] >>> 20, v = e[12] << 12 | e[13] >>> 20, Z = e[22] << 10 | e[23] >>> 22, J = e[23] << 10 | e[22] >>> 22, R = e[33] << 13 | e[32] >>> 19, W = e[32] << 13 | e[33] >>> 19, ue = e[42] << 2 | e[43] >>> 30, de = e[43] << 2 | e[42] >>> 30, te = e[5] << 30 | e[4] >>> 2, ae = e[4] << 30 | e[5] >>> 2, L = e[14] << 6 | e[15] >>> 26, O = e[15] << 6 | e[14] >>> 26, _ = e[25] << 11 | e[24] >>> 21, g = e[24] << 11 | e[25] >>> 21, X = e[34] << 15 | e[35] >>> 17, $ = e[35] << 15 | e[34] >>> 17, I = e[45] << 29 | e[44] >>> 3, N = e[44] << 29 | e[45] >>> 3, D = e[6] << 28 | e[7] >>> 4, C = e[7] << 28 | e[6] >>> 4, re = e[17] << 23 | e[16] >>> 9, ne = e[16] << 23 | e[17] >>> 9, F = e[26] << 25 | e[27] >>> 7, j = e[27] << 25 | e[26] >>> 7, A = e[36] << 21 | e[37] >>> 11, w = e[37] << 21 | e[36] >>> 11, Q = e[47] << 24 | e[46] >>> 8, ee = e[46] << 24 | e[47] >>> 8, z = e[8] << 27 | e[9] >>> 5, K = e[9] << 27 | e[8] >>> 5, S = e[18] << 20 | e[19] >>> 12, E = e[19] << 20 | e[18] >>> 12, se = e[29] << 7 | e[28] >>> 25, oe = e[28] << 7 | e[29] >>> 25, G = e[38] << 8 | e[39] >>> 24, V = e[39] << 8 | e[38] >>> 24, T = e[48] << 14 | e[49] >>> 18, x = e[49] << 14 | e[48] >>> 18, e[0] = b ^ ~y & _, e[1] = m ^ ~v & g, e[10] = D ^ ~S & B, e[11] = C ^ ~E & k, e[20] = M ^ ~L & F, e[21] = P ^ ~O & j, e[30] = z ^ ~q & Z, e[31] = K ^ ~Y & J, e[40] = te ^ ~re & se, e[41] = ae ^ ~ne & oe, e[2] = y ^ ~_ & A, e[3] = v ^ ~g & w, e[12] = S ^ ~B & R, e[13] = E ^ ~k & W, e[22] = L ^ ~F & G, e[23] = O ^ ~j & V, e[32] = q ^ ~Z & X, e[33] = Y ^ ~J & $, e[42] = re ^ ~se & ie, e[43] = ne ^ ~oe & ce, e[4] = _ ^ ~A & T, e[5] = g ^ ~w & x, e[14] = B ^ ~R & I, e[15] = k ^ ~W & N, e[24] = F ^ ~G & U, e[25] = j ^ ~V & H, e[34] = Z ^ ~X & Q, e[35] = J ^ ~$ & ee, e[44] = se ^ ~ie & ue, e[45] = oe ^ ~ce & de, e[6] = A ^ ~T & b, e[7] = w ^ ~x & m, e[16] = R ^ ~I & D, e[17] = W ^ ~N & C, e[26] = G ^ ~U & M, e[27] = V ^ ~H & P, e[36] = X ^ ~Q & z, e[37] = $ ^ ~ee & K, e[46] = ie ^ ~ue & te, e[47] = ce ^ ~de & ae, e[8] = T ^ ~b & y, e[9] = x ^ ~m & v, e[18] = I ^ ~D & S, e[19] = N ^ ~C & E, e[28] = U ^ ~M & L, e[29] = H ^ ~P & O, e[38] = Q ^ ~z & q, e[39] = ee ^ ~K & Y, e[48] = ue ^ ~te & re, e[49] = de ^ ~ae & ne, e[0] ^= i[r], e[1] ^= i[r + 1];
              }
            };

            if (n) a.exports = p;else for (m = 0; m < b.length; ++m) {
              r[b[m]] = p[b[m]];
            }
          }();
        }).call(this, e("_process"), void 0 !== t ? t : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
      }, {
        _process: 42
      }],
      41: [function (e, t, a) {
        (t.exports = function (e, t) {
          if (!e) throw new Error(t || "Assertion failed");
        }).equal = function (e, t, a) {
          if (e != t) throw new Error(a || "Assertion failed: " + e + " != " + t);
        };
      }, {}],
      42: [function (e, t, a) {
        t.exports = {
          browser: !0
        };
      }, {}],
      43: [function (e, t, a) {
        (function (e) {
          "use strict";

          function r(e) {
            var t = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298],
                a = 1779033703,
                r = 3144134277,
                n = 1013904242,
                s = 2773480762,
                o = 1359893119,
                i = 2600822924,
                c = 528734635,
                u = 1541459225,
                d = new Array(64);

            function f(e) {
              for (var f = 0, l = e.length; 64 <= l;) {
                var h,
                    p,
                    b,
                    m,
                    y,
                    v = a,
                    _ = r,
                    g = n,
                    A = s,
                    w = o,
                    T = i,
                    x = c,
                    D = u;

                for (p = 0; p < 16; p++) {
                  b = f + 4 * p, d[p] = (255 & e[b]) << 24 | (255 & e[b + 1]) << 16 | (255 & e[b + 2]) << 8 | 255 & e[b + 3];
                }

                for (p = 16; p < 64; p++) {
                  m = ((h = d[p - 2]) >>> 17 | h << 15) ^ (h >>> 19 | h << 13) ^ h >>> 10, y = ((h = d[p - 15]) >>> 7 | h << 25) ^ (h >>> 18 | h << 14) ^ h >>> 3, d[p] = (m + d[p - 7] | 0) + (y + d[p - 16] | 0) | 0;
                }

                for (p = 0; p < 64; p++) {
                  m = (((w >>> 6 | w << 26) ^ (w >>> 11 | w << 21) ^ (w >>> 25 | w << 7)) + (w & T ^ ~w & x) | 0) + (D + (t[p] + d[p] | 0) | 0) | 0, y = ((v >>> 2 | v << 30) ^ (v >>> 13 | v << 19) ^ (v >>> 22 | v << 10)) + (v & _ ^ v & g ^ _ & g) | 0, D = x, x = T, T = w, w = A + m | 0, A = g, g = _, _ = v, v = m + y | 0;
                }

                a = a + v | 0, r = r + _ | 0, n = n + g | 0, s = s + A | 0, o = o + w | 0, i = i + T | 0, c = c + x | 0, u = u + D | 0, f += 64, l -= 64;
              }
            }

            f(e);
            var l,
                h = e.length % 64,
                p = e.length / 536870912 | 0,
                b = e.length << 3,
                m = h < 56 ? 56 : 120,
                y = e.slice(e.length - h, e.length);

            for (y.push(128), l = 1 + h; l < m; l++) {
              y.push(0);
            }

            return y.push(p >>> 24 & 255), y.push(p >>> 16 & 255), y.push(p >>> 8 & 255), y.push(p >>> 0 & 255), y.push(b >>> 24 & 255), y.push(b >>> 16 & 255), y.push(b >>> 8 & 255), y.push(b >>> 0 & 255), f(y), [a >>> 24 & 255, a >>> 16 & 255, a >>> 8 & 255, a >>> 0 & 255, r >>> 24 & 255, r >>> 16 & 255, r >>> 8 & 255, r >>> 0 & 255, n >>> 24 & 255, n >>> 16 & 255, n >>> 8 & 255, n >>> 0 & 255, s >>> 24 & 255, s >>> 16 & 255, s >>> 8 & 255, s >>> 0 & 255, o >>> 24 & 255, o >>> 16 & 255, o >>> 8 & 255, o >>> 0 & 255, i >>> 24 & 255, i >>> 16 & 255, i >>> 8 & 255, i >>> 0 & 255, c >>> 24 & 255, c >>> 16 & 255, c >>> 8 & 255, c >>> 0 & 255, u >>> 24 & 255, u >>> 16 & 255, u >>> 8 & 255, u >>> 0 & 255];
          }

          function n(e, t, a) {
            var n;
            e = e.length <= 64 ? e : r(e);
            var s = 64 + t.length + 4,
                o = new Array(s),
                i = new Array(64),
                c = [];

            for (n = 0; n < 64; n++) {
              o[n] = 54;
            }

            for (n = 0; n < e.length; n++) {
              o[n] ^= e[n];
            }

            for (n = 0; n < t.length; n++) {
              o[64 + n] = t[n];
            }

            for (n = s - 4; n < s; n++) {
              o[n] = 0;
            }

            for (n = 0; n < 64; n++) {
              i[n] = 92;
            }

            for (n = 0; n < e.length; n++) {
              i[n] ^= e[n];
            }

            function u() {
              for (var e = s - 1; s - 4 <= e; e--) {
                if (o[e]++, o[e] <= 255) return;
                o[e] = 0;
              }
            }

            for (; 32 <= a;) {
              u(), c = c.concat(r(i.concat(r(o)))), a -= 32;
            }

            return 0 < a && (u(), c = c.concat(r(i.concat(r(o))).slice(0, a))), c;
          }

          function s(e, t, a, r, n) {
            var s;

            for (u(e, 16 * (2 * a - 1), n, 0, 16), s = 0; s < 2 * a; s++) {
              c(e, 16 * s, n, 16), i(n, r), u(n, 0, e, t + 16 * s, 16);
            }

            for (s = 0; s < a; s++) {
              u(e, t + 2 * s * 16, e, 16 * s, 16);
            }

            for (s = 0; s < a; s++) {
              u(e, t + 16 * (2 * s + 1), e, 16 * (s + a), 16);
            }
          }

          function o(e, t) {
            return e << t | e >>> 32 - t;
          }

          function i(e, t) {
            u(e, 0, t, 0, 16);

            for (var a = 8; 0 < a; a -= 2) {
              t[4] ^= o(t[0] + t[12], 7), t[8] ^= o(t[4] + t[0], 9), t[12] ^= o(t[8] + t[4], 13), t[0] ^= o(t[12] + t[8], 18), t[9] ^= o(t[5] + t[1], 7), t[13] ^= o(t[9] + t[5], 9), t[1] ^= o(t[13] + t[9], 13), t[5] ^= o(t[1] + t[13], 18), t[14] ^= o(t[10] + t[6], 7), t[2] ^= o(t[14] + t[10], 9), t[6] ^= o(t[2] + t[14], 13), t[10] ^= o(t[6] + t[2], 18), t[3] ^= o(t[15] + t[11], 7), t[7] ^= o(t[3] + t[15], 9), t[11] ^= o(t[7] + t[3], 13), t[15] ^= o(t[11] + t[7], 18), t[1] ^= o(t[0] + t[3], 7), t[2] ^= o(t[1] + t[0], 9), t[3] ^= o(t[2] + t[1], 13), t[0] ^= o(t[3] + t[2], 18), t[6] ^= o(t[5] + t[4], 7), t[7] ^= o(t[6] + t[5], 9), t[4] ^= o(t[7] + t[6], 13), t[5] ^= o(t[4] + t[7], 18), t[11] ^= o(t[10] + t[9], 7), t[8] ^= o(t[11] + t[10], 9), t[9] ^= o(t[8] + t[11], 13), t[10] ^= o(t[9] + t[8], 18), t[12] ^= o(t[15] + t[14], 7), t[13] ^= o(t[12] + t[15], 9), t[14] ^= o(t[13] + t[12], 13), t[15] ^= o(t[14] + t[13], 18);
            }

            for (a = 0; a < 16; ++a) {
              e[a] += t[a];
            }
          }

          function c(e, t, a, r) {
            for (var n = 0; n < r; n++) {
              a[n] ^= e[t + n];
            }
          }

          function u(e, t, a, r, n) {
            for (; n--;) {
              a[r++] = e[t++];
            }
          }

          function d(e) {
            if (!e || "number" != typeof e.length) return !1;

            for (var t = 0; t < e.length; t++) {
              if ("number" != typeof e[t]) return !1;
              var a = parseInt(e[t]);
              if (a != e[t] || a < 0 || 256 <= a) return !1;
            }

            return !0;
          }

          function f(e, t) {
            var a = parseInt(e);
            if (e != a) throw new Error("invalid " + t);
            return a;
          }

          function l(t, a, r, o, i, l, h) {
            if (!h) throw new Error("missing callback");
            if (r = f(r, "N"), o = f(o, "r"), i = f(i, "p"), l = f(l, "dkLen"), 0 === r || 0 != (r & r - 1)) throw new Error("N must be power of 2");
            if (p / 128 / o < r) throw new Error("N too large");
            if (p / 128 / i < o) throw new Error("r too large");
            if (!d(t)) throw new Error("password must be an array or buffer");
            if (t = Array.prototype.slice.call(t), !d(a)) throw new Error("salt must be an array or buffer");
            a = Array.prototype.slice.call(a);

            for (var b = n(t, a, 128 * i * o), m = new Uint32Array(32 * i * o), y = 0; y < m.length; y++) {
              var v = 4 * y;
              m[y] = (255 & b[3 + v]) << 24 | (255 & b[2 + v]) << 16 | (255 & b[1 + v]) << 8 | (255 & b[0 + v]) << 0;
            }

            var _,
                g,
                A = new Uint32Array(64 * o),
                w = new Uint32Array(32 * o * r),
                T = 32 * o,
                x = new Uint32Array(16),
                D = new Uint32Array(16),
                C = i * r * 2,
                S = 0,
                E = null,
                B = !1,
                k = 0,
                R = 0,
                W = parseInt(1e3 / o),
                I = void 0 !== e ? e : setTimeout,
                N = function N() {
              if (B) return h(new Error("cancelled"), S / C);

              switch (k) {
                case 0:
                  u(m, g = 32 * R * o, A, 0, T), k = 1, _ = 0;

                case 1:
                  W < (a = r - _) && (a = W);

                  for (var e = 0; e < a; e++) {
                    u(A, 0, w, (_ + e) * T, T), s(A, T, o, x, D);
                  }

                  if (_ += a, S += a, (d = parseInt(1e3 * S / C)) !== E) {
                    if (B = h(null, S / C)) break;
                    E = d;
                  }

                  if (_ < r) break;
                  _ = 0, k = 2;

                case 2:
                  var a, d;

                  for (W < (a = r - _) && (a = W), e = 0; e < a; e++) {
                    var f = A[16 * (2 * o - 1)] & r - 1;
                    c(w, f * T, A, T), s(A, T, o, x, D);
                  }

                  if (_ += a, S += a, (d = parseInt(1e3 * S / C)) !== E) {
                    if (B = h(null, S / C)) break;
                    E = d;
                  }

                  if (_ < r) break;

                  if (u(A, 0, m, g, T), ++R < i) {
                    k = 0;
                    break;
                  }

                  for (b = [], e = 0; e < m.length; e++) {
                    b.push(m[e] >> 0 & 255), b.push(m[e] >> 8 & 255), b.push(m[e] >> 16 & 255), b.push(m[e] >> 24 & 255);
                  }

                  var p = n(t, b, l);
                  return h(null, 1, p);
              }

              I(N);
            };

            N();
          }

          var h, p;
          h = this, p = 2147483647, void 0 !== a ? t.exports = l : h && (h.scrypt && (h._scrypt = h.scrypt), h.scrypt = l);
        }).call(this, e("timers").setImmediate);
      }, {
        timers: 45
      }],
      44: [function (e, a, r) {
        (function (e, t, a) {
          !function (t, a) {
            "use strict";

            if (!t.setImmediate) {
              var r,
                  n,
                  s,
                  o,
                  i = 1,
                  c = {},
                  u = !1,
                  d = t.document,
                  f = Object.getPrototypeOf && Object.getPrototypeOf(t);
              f = f && f.setTimeout ? f : t, r = "[object process]" === {}.toString.call(t.process) ? function () {
                var t = l(arguments);
                return e.nextTick(h(p, t)), t;
              } : function () {
                if (t.postMessage && !t.importScripts) {
                  var e = !0,
                      a = t.onmessage;
                  return t.onmessage = function () {
                    e = !1;
                  }, t.postMessage("", "*"), t.onmessage = a, e;
                }
              }() ? (o = "setImmediate$" + Math.random() + "$", t.addEventListener ? t.addEventListener("message", m, !1) : t.attachEvent("onmessage", m), function () {
                var e = l(arguments);
                return t.postMessage(o + e, "*"), e;
              }) : t.MessageChannel ? ((s = new MessageChannel()).port1.onmessage = function (e) {
                p(e.data);
              }, function () {
                var e = l(arguments);
                return s.port2.postMessage(e), e;
              }) : d && "onreadystatechange" in d.createElement("script") ? (n = d.documentElement, function () {
                var e = l(arguments),
                    t = d.createElement("script");
                return t.onreadystatechange = function () {
                  p(e), t.onreadystatechange = null, n.removeChild(t), t = null;
                }, n.appendChild(t), e;
              }) : function () {
                var e = l(arguments);
                return setTimeout(h(p, e), 0), e;
              }, f.setImmediate = r, f.clearImmediate = b;
            }

            function l(e) {
              return c[i] = h.apply(a, e), i++;
            }

            function h(e) {
              var t = [].slice.call(arguments, 1);
              return function () {
                "function" == typeof e ? e.apply(a, t) : new Function("" + e)();
              };
            }

            function p(e) {
              if (u) setTimeout(h(p, e), 0);else {
                var t = c[e];

                if (t) {
                  u = !0;

                  try {
                    t();
                  } finally {
                    b(e), u = !1;
                  }
                }
              }
            }

            function b(e) {
              delete c[e];
            }

            function m(e) {
              e.source === t && "string" == typeof e.data && 0 === e.data.indexOf(o) && p(+e.data.slice(o.length));
            }
          }("undefined" == typeof self ? void 0 === t ? this : t : self);
        }).call(this, e("_process"), void 0 !== t ? t : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("timers").clearImmediate);
      }, {
        _process: 42,
        timers: 45
      }],
      45: [function (e, a, r) {
        (function (e) {
          a.exports = {
            setImmediate: e.setImmediate
          };
        }).call(this, void 0 !== t ? t : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
      }, {}],
      46: [function (e, a, r) {
        (function (e) {
          var t;

          if (e.crypto && crypto.getRandomValues) {
            var r = new Uint8Array(16);

            t = function t() {
              return crypto.getRandomValues(r), r;
            };
          }

          if (!t) {
            var n = new Array(16);

            t = function t() {
              for (var e, t = 0; t < 16; t++) {
                0 == (3 & t) && (e = 4294967296 * Math.random()), n[t] = e >>> ((3 & t) << 3) & 255;
              }

              return n;
            };
          }

          a.exports = t;
        }).call(this, void 0 !== t ? t : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
      }, {}],
      47: [function (e, t, a) {
        for (var r = e("./rng"), n = [], s = {}, o = 0; o < 256; o++) {
          n[o] = (o + 256).toString(16).substr(1), s[n[o]] = o;
        }

        function i(e, t) {
          var a = t || 0,
              r = n;
          return r[e[a++]] + r[e[a++]] + r[e[a++]] + r[e[a++]] + "-" + r[e[a++]] + r[e[a++]] + "-" + r[e[a++]] + r[e[a++]] + "-" + r[e[a++]] + r[e[a++]] + "-" + r[e[a++]] + r[e[a++]] + r[e[a++]] + r[e[a++]] + r[e[a++]] + r[e[a++]];
        }

        var c = r(),
            u = [1 | c[0], c[1], c[2], c[3], c[4], c[5]],
            d = 16383 & (c[6] << 8 | c[7]),
            f = 0,
            l = 0;

        function h(e, t, a) {
          var n = t && a || 0;
          "string" == typeof e && (t = "binary" == e ? new Array(16) : null, e = null);
          var s = (e = e || {}).random || (e.rng || r)();
          if (s[6] = 15 & s[6] | 64, s[8] = 63 & s[8] | 128, t) for (var o = 0; o < 16; o++) {
            t[n + o] = s[o];
          }
          return t || i(s);
        }

        var p = h;
        p.v1 = function (e, t, a) {
          var r = t && a || 0,
              n = t || [],
              s = void 0 !== (e = e || {}).clockseq ? e.clockseq : d,
              o = void 0 !== e.msecs ? e.msecs : new Date().getTime(),
              c = void 0 !== e.nsecs ? e.nsecs : l + 1,
              h = o - f + (c - l) / 1e4;
          if (h < 0 && void 0 === e.clockseq && (s = s + 1 & 16383), (h < 0 || f < o) && void 0 === e.nsecs && (c = 0), 1e4 <= c) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
          f = o, d = s;
          var p = (1e4 * (268435455 & (o += 122192928e5)) + (l = c)) % 4294967296;
          n[r++] = p >>> 24 & 255, n[r++] = p >>> 16 & 255, n[r++] = p >>> 8 & 255, n[r++] = 255 & p;
          var b = o / 4294967296 * 1e4 & 268435455;
          n[r++] = b >>> 8 & 255, n[r++] = 255 & b, n[r++] = b >>> 24 & 15 | 16, n[r++] = b >>> 16 & 255, n[r++] = s >>> 8 | 128, n[r++] = 255 & s;

          for (var m = e.node || u, y = 0; y < 6; y++) {
            n[r + y] = m[y];
          }

          return t || i(n);
        }, p.v4 = h, p.parse = function (e, t, a) {
          var r = t && a || 0,
              n = 0;

          for (t = t || [], e.toLowerCase().replace(/[0-9a-f]{2}/g, function (e) {
            n < 16 && (t[r + n++] = s[e]);
          }); n < 16;) {
            t[r + n++] = 0;
          }

          return t;
        }, p.unparse = i, t.exports = p;
      }, {
        "./rng": 46
      }],
      48: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        });

        try {
          t.exports.XMLHttpRequest = XMLHttpRequest;
        } catch (e) {
          console.log("Warning: XMLHttpRequest is not defined"), t.exports.XMLHttpRequest = null;
        }
      }, {}],
      49: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var r = e("../utils/properties"),
            n = (s.isProvider = function (e) {
          return r.isType(e, "Provider");
        }, s);

        function s() {
          r.setType(this, "Provider");
        }

        a.Provider = n;
      }, {
        "../utils/properties": 73
      }],
      50: [function (e, t, a) {
        "use strict";

        var r,
            n = this && this.__extends || (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var a in t) {
            t.hasOwnProperty(a) && (e[a] = t[a]);
          }
        }, function (e, t) {
          function a() {
            this.constructor = e;
          }

          r(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
        }),
            s = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var o = e("../utils/address"),
            i = e("../utils/bignumber"),
            c = e("../utils/bytes"),
            u = e("../constants"),
            d = e("../utils/hash"),
            f = e("../utils/networks"),
            l = e("../utils/properties"),
            h = e("../utils/rlp"),
            p = e("../utils/transaction"),
            b = e("../utils/utf8"),
            m = e("../utils/web"),
            y = s(e("../errors")),
            v = e("./abstract-provider");

        function _(e, t) {
          var a = {};

          for (var r in e) {
            try {
              var n = e[r](t[r]);
              void 0 !== n && (a[r] = n);
            } catch (e) {
              throw e.checkKey = r, e.checkValue = t[r], e;
            }
          }

          return a;
        }

        function g(e, t) {
          return function (a) {
            return null == a ? t : e(a);
          };
        }

        function A(e) {
          return function (t) {
            if (!Array.isArray(t)) throw new Error("not an array");
            var a = [];
            return t.forEach(function (t) {
              a.push(e(t));
            }), a;
          };
        }

        function w(e, t) {
          return "string" == typeof e && (t || "0x" === e.substring(0, 2) || (e = "0x" + e), 32 === c.hexDataLength(e)) ? e.toLowerCase() : (y.throwError("invalid hash", y.INVALID_ARGUMENT, {
            arg: "hash",
            value: e
          }), null);
        }

        function T(e) {
          return i.bigNumberify(e).toNumber();
        }

        function x(e) {
          if (!c.isHexString(e)) throw new Error("invalid uint256");

          for (; e.length < 66;) {
            e = "0x0" + e.substring(2);
          }

          return e;
        }

        function D(e) {
          if (null == e) return "latest";
          if ("earliest" === e) return "0x0";
          if ("latest" === e || "pending" === e) return e;
          if ("number" == typeof e) return c.hexStripZeros(c.hexlify(e));
          if (c.isHexString(e)) return c.hexStripZeros(e);
          throw new Error("invalid blockTag");
        }

        var C = {
          hash: w,
          blockHash: g(w, null),
          blockNumber: g(T, null),
          transactionIndex: g(T, null),
          confirmations: g(T, null),
          from: o.getAddress,
          gasPrice: i.bigNumberify,
          gasLimit: i.bigNumberify,
          to: g(o.getAddress, null),
          value: i.bigNumberify,
          nonce: T,
          data: c.hexlify,
          r: g(x),
          s: g(x),
          v: g(T),
          creates: g(o.getAddress, null),
          raw: g(c.hexlify)
        };

        function S(e) {
          if (null != e.gas && null == e.gasLimit && (e.gasLimit = e.gas), e.to && i.bigNumberify(e.to).isZero() && (e.to = "0x0000000000000000000000000000000000000000"), null != e.input && null == e.data && (e.data = e.input), null == e.to && null == e.creates && (e.creates = o.getContractAddress(e)), !e.raw && e.v && e.r && e.s) {
            var t = [c.stripZeros(c.hexlify(e.nonce)), c.stripZeros(c.hexlify(e.gasPrice)), c.stripZeros(c.hexlify(e.gasLimit)), e.to || "0x", c.stripZeros(c.hexlify(e.value || "0x")), c.hexlify(e.data || "0x"), c.stripZeros(c.hexlify(e.v || "0x")), c.stripZeros(c.hexlify(e.r)), c.stripZeros(c.hexlify(e.s))];
            e.raw = h.encode(t);
          }

          var a = _(C, e),
              r = e.networkId;

          return null != e.chainId && null == r && null == a.v && (r = e.chainId), c.isHexString(r) && (r = i.bigNumberify(r).toNumber()), "number" != typeof r && null != a.v && ((r = (a.v - 35) / 2) < 0 && (r = 0), r = parseInt(r)), "number" != typeof r && (r = 0), a.networkId = r, a.blockHash && "x" === a.blockHash.replace(/0/g, "") && (a.blockHash = null), a;
        }

        var E = {
          hash: w,
          parentHash: w,
          number: T,
          timestamp: T,
          nonce: g(c.hexlify),
          difficulty: function difficulty(e) {
            var t = i.bigNumberify(e);

            try {
              return t.toNumber();
            } catch (e) {}

            return null;
          },
          gasLimit: i.bigNumberify,
          gasUsed: i.bigNumberify,
          miner: o.getAddress,
          extraData: c.hexlify,
          transactions: g(A(w))
        },
            B = l.shallowCopy(E);

        function k(e, t) {
          return null != e.author && null == e.miner && (e.miner = e.author), _(t ? B : E, e);
        }

        B.transactions = g(A(S));
        var R = {
          from: g(o.getAddress),
          nonce: g(T),
          gasLimit: g(i.bigNumberify),
          gasPrice: g(i.bigNumberify),
          to: g(o.getAddress),
          value: g(i.bigNumberify),
          data: g(c.hexlify)
        };

        function W(e) {
          return _(R, e);
        }

        var I = {
          transactionLogIndex: g(T),
          transactionIndex: T,
          blockNumber: T,
          transactionHash: w,
          address: o.getAddress,
          topics: A(w),
          data: c.hexlify,
          logIndex: T,
          blockHash: w
        },
            N = {
          to: g(o.getAddress, null),
          from: g(o.getAddress, null),
          contractAddress: g(o.getAddress, null),
          transactionIndex: T,
          root: g(w),
          gasUsed: i.bigNumberify,
          logsBloom: g(c.hexlify),
          blockHash: w,
          transactionHash: w,
          logs: A(function (e) {
            return _(I, e);
          }),
          blockNumber: T,
          confirmations: g(T, null),
          cumulativeGasUsed: i.bigNumberify,
          status: g(T)
        };

        function M(e) {
          return Array.isArray(e) ? e.forEach(function (e) {
            M(e);
          }) : null != e && w(e), e;
        }

        var P,
            L = {
          fromBlock: g(D, void 0),
          toBlock: g(D, void 0),
          address: g(o.getAddress, void 0),
          topics: g(M, void 0)
        },
            O = {
          blockHash: g(w, void 0),
          address: g(o.getAddress, void 0),
          topics: g(M, void 0)
        },
            F = {
          blockNumber: g(T),
          blockHash: g(w),
          transactionIndex: T,
          removed: g(function (e) {
            if ("boolean" == typeof e) return e;

            if ("string" == typeof e) {
              if ("true" === e) return !0;
              if ("false" === e) return !1;
            }

            throw new Error("invaid boolean - " + e);
          }),
          address: o.getAddress,
          data: (P = c.hexlify, function (e) {
            return e ? P(e) : "0x";
          }),
          topics: A(w),
          transactionHash: w,
          logIndex: T
        };

        function j(e) {
          return _(F, e);
        }

        function G(e) {
          return e.map(function (e) {
            return "string" == typeof e ? e : Array.isArray(e) ? (e.forEach(function (e) {
              null !== e && 32 !== c.hexDataLength(e) && y.throwError("invalid topic", y.INVALID_ARGUMENT, {
                argument: "topic",
                value: e
              });
            }), e.join(",")) : null === e ? "" : y.throwError("invalid topic value", y.INVALID_ARGUMENT, {
              argument: "topic",
              value: e
            });
          }).join("&");
        }

        function V(e) {
          if ("string" == typeof e) {
            if (20 === c.hexDataLength(e)) return "address:" + o.getAddress(e);
            if (e = e.toLowerCase(), 32 === c.hexDataLength(e)) return "tx:" + e;
            if (-1 === e.indexOf(":")) return e;
          } else {
            if (Array.isArray(e)) return "filter::" + G(e);
            if (e && "object" == typeof e) return "filter:" + (e.address || "") + ":" + G(e.topics || []);
          }

          throw new Error("invalid event - " + e);
        }

        function U() {
          return new Date().getTime();
        }

        var H,
            z = (n(K, H = v.Provider), K.prototype._doPoll = function () {
          var e = this;
          this.getBlockNumber().then(function (t) {
            if (e._setFastBlockNumber(t), t !== e._lastBlockNumber) {
              -2 === e._emitted.block && (e._emitted.block = t - 1);

              for (var a = e._emitted.block + 1; a <= t; a++) {
                e.emit("block", a);
              }

              e._emitted.block !== t && (e._emitted.block = t, Object.keys(e._emitted).forEach(function (a) {
                if ("block" !== a) {
                  var r = e._emitted[a];
                  "pending" !== r && 12 < t - r && delete e._emitted[a];
                }
              })), -2 === e._lastBlockNumber && (e._lastBlockNumber = t - 1);
              var r = {},
                  n = {};
              return e._events.forEach(function (e) {
                n[e.tag] = !0;
              }), Object.keys(n).forEach(function (a) {
                var n = a.split(":");

                switch (n[0]) {
                  case "tx":
                    var s = n[1];
                    e.getTransactionReceipt(s).then(function (t) {
                      return t && null != t.blockNumber && (e._emitted["t:" + s] = t.blockNumber, e.emit(s, t)), null;
                    }).catch(function (t) {
                      e.emit("error", t);
                    });
                    break;

                  case "address":
                    var o = n[1];
                    e._balances[o] && (r[o] = e._balances[o]), e.getBalance(o, "latest").then(function (t) {
                      var a = e._balances[o];
                      if (!a || !t.eq(a)) return e._balances[o] = t, e.emit(o, t), null;
                    }).catch(function (t) {
                      e.emit("error", t);
                    });
                    break;

                  case "filter":
                    var i = n[2].split(/&/g).map(function (e) {
                      var t = e.split(",");
                      return 1 === t.length ? "" === t[0] ? null : e : t.map(function (e) {
                        return "" === e ? null : e;
                      });
                    }),
                        c = {
                      address: n[1],
                      fromBlock: e._lastBlockNumber + 1,
                      toBlock: t,
                      topics: i
                    };
                    c.address || delete c.address, e.getLogs(c).then(function (t) {
                      if (0 !== t.length) return t.forEach(function (t) {
                        e._emitted["b:" + t.blockHash] = t.blockNumber, e._emitted["t:" + t.transactionHash] = t.blockNumber, e.emit(c, t);
                      }), null;
                    }).catch(function (t) {
                      e.emit("error", t);
                    });
                }
              }), e._lastBlockNumber = t, e._balances = r, null;
            }
          }).catch(function (e) {}), this.doPoll();
        }, K.prototype.resetEventsBlock = function (e) {
          this._lastBlockNumber = e - 1, this.polling && this._doPoll();
        }, Object.defineProperty(K.prototype, "network", {
          get: function get() {
            return this._network;
          },
          enumerable: !0,
          configurable: !0
        }), K.prototype.getNetwork = function () {
          return this.ready;
        }, Object.defineProperty(K.prototype, "blockNumber", {
          get: function get() {
            return this._fastBlockNumber;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(K.prototype, "polling", {
          get: function get() {
            return null != this._poller;
          },
          set: function set(e) {
            var t = this;
            setTimeout(function () {
              e && !t._poller ? t._poller = setInterval(t._doPoll.bind(t), t.pollingInterval) : !e && t._poller && (clearInterval(t._poller), t._poller = null);
            }, 0);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(K.prototype, "pollingInterval", {
          get: function get() {
            return this._pollingInterval;
          },
          set: function set(e) {
            var t = this;
            if ("number" != typeof e || e <= 0 || parseInt(String(e)) != e) throw new Error("invalid polling interval");
            this._pollingInterval = e, this._poller && (clearInterval(this._poller), this._poller = setInterval(function () {
              t._doPoll();
            }, this._pollingInterval));
          },
          enumerable: !0,
          configurable: !0
        }), K.prototype._getFastBlockNumber = function () {
          var e = this,
              t = U();
          return t - this._fastQueryDate > 2 * this._pollingInterval && (this._fastQueryDate = t, this._fastBlockNumberPromise = this.getBlockNumber().then(function (t) {
            return (null == e._fastBlockNumber || t > e._fastBlockNumber) && (e._fastBlockNumber = t), e._fastBlockNumber;
          })), this._fastBlockNumberPromise;
        }, K.prototype._setFastBlockNumber = function (e) {
          null != this._fastBlockNumber && e < this._fastBlockNumber || (this._fastQueryDate = U(), (null == this._fastBlockNumber || e > this._fastBlockNumber) && (this._fastBlockNumber = e, this._fastBlockNumberPromise = Promise.resolve(e)));
        }, K.prototype.waitForTransaction = function (e, t) {
          var a = this;
          return null == t && (t = 1), this.getTransactionReceipt(e).then(function (r) {
            return 0 === t || r && r.confirmations >= t ? r : new Promise(function (r) {
              var n = function n(s) {
                s.confirmations < t || (a.removeListener(e, n), r(s));
              };

              a.on(e, n);
            });
          });
        }, K.prototype.getBlockNumber = function () {
          var e = this;
          return this.ready.then(function () {
            return e.perform("getBlockNumber", {}).then(function (t) {
              var a = parseInt(t);
              if (a != t) throw new Error("invalid response - getBlockNumber");
              return e._setFastBlockNumber(a), a;
            });
          });
        }, K.prototype.getGasPrice = function () {
          var e = this;
          return this.ready.then(function () {
            return e.perform("getGasPrice", {}).then(function (e) {
              return i.bigNumberify(e);
            });
          });
        }, K.prototype.getBalance = function (e, t) {
          var a = this;
          return this.ready.then(function () {
            return l.resolveProperties({
              addressOrName: e,
              blockTag: t
            }).then(function (e) {
              var t = e.addressOrName,
                  r = e.blockTag;
              return a._getAddress(t).then(function (e) {
                var t = {
                  address: e,
                  blockTag: D(r)
                };
                return a.perform("getBalance", t).then(function (e) {
                  return i.bigNumberify(e);
                });
              });
            });
          });
        }, K.prototype.getTransactionCount = function (e, t) {
          var a = this;
          return this.ready.then(function () {
            return l.resolveProperties({
              addressOrName: e,
              blockTag: t
            }).then(function (e) {
              var t = e.addressOrName,
                  r = e.blockTag;
              return a._getAddress(t).then(function (e) {
                var t = {
                  address: e,
                  blockTag: D(r)
                };
                return a.perform("getTransactionCount", t).then(function (e) {
                  return i.bigNumberify(e).toNumber();
                });
              });
            });
          });
        }, K.prototype.getCode = function (e, t) {
          var a = this;
          return this.ready.then(function () {
            return l.resolveProperties({
              addressOrName: e,
              blockTag: t
            }).then(function (e) {
              var t = e.addressOrName,
                  r = e.blockTag;
              return a._getAddress(t).then(function (e) {
                var t = {
                  address: e,
                  blockTag: D(r)
                };
                return a.perform("getCode", t).then(function (e) {
                  return c.hexlify(e);
                });
              });
            });
          });
        }, K.prototype.getStorageAt = function (e, t, a) {
          var r = this;
          return this.ready.then(function () {
            return l.resolveProperties({
              addressOrName: e,
              position: t,
              blockTag: a
            }).then(function (e) {
              var t = e.addressOrName,
                  a = e.position,
                  n = e.blockTag;
              return r._getAddress(t).then(function (e) {
                var t = {
                  address: e,
                  blockTag: D(n),
                  position: c.hexStripZeros(c.hexlify(a))
                };
                return r.perform("getStorageAt", t).then(function (e) {
                  return c.hexlify(e);
                });
              });
            });
          });
        }, K.prototype.sendTransaction = function (e) {
          var t = this;
          return this.ready.then(function () {
            return l.resolveProperties({
              signedTransaction: e
            }).then(function (e) {
              var a = e.signedTransaction,
                  r = {
                signedTransaction: c.hexlify(a)
              };
              return t.perform("sendTransaction", r).then(function (e) {
                return t._wrapTransaction(p.parse(a), e);
              }, function (e) {
                throw e.transaction = p.parse(a), e.transaction.hash && (e.transactionHash = e.transaction.hash), e;
              });
            });
          });
        }, K.prototype._wrapTransaction = function (e, t) {
          var a = this;
          if (null != t && 32 !== c.hexDataLength(t)) throw new Error("invalid response - sendTransaction");
          var r = e;
          return null != t && e.hash !== t && y.throwError("Transaction hash mismatch from Provider.sendTransaction.", y.UNKNOWN_ERROR, {
            expectedHash: e.hash,
            returnedHash: t
          }), r.wait = function (t) {
            return 0 !== t && (a._emitted["t:" + e.hash] = "pending"), a.waitForTransaction(e.hash, t).then(function (r) {
              return null == r && 0 === t ? null : (a._emitted["t:" + e.hash] = r.blockNumber, 0 === r.status && y.throwError("transaction failed", y.CALL_EXCEPTION, {
                transactionHash: e.hash,
                transaction: e
              }), r);
            });
          }, r;
        }, K.prototype.call = function (e, t) {
          var a = this,
              r = l.shallowCopy(e);
          return this.ready.then(function () {
            return l.resolveProperties({
              blockTag: t,
              tx: r
            }).then(function (e) {
              var t = e.blockTag,
                  r = e.tx;
              return a._resolveNames(r, ["to", "from"]).then(function (e) {
                var r = {
                  blockTag: D(t),
                  transaction: W(e)
                };
                return a.perform("call", r).then(function (e) {
                  return c.hexlify(e);
                });
              });
            });
          });
        }, K.prototype.estimateGas = function (e) {
          var t = this,
              a = {
            to: e.to,
            from: e.from,
            data: e.data,
            gasPrice: e.gasPrice,
            value: e.value
          };
          return this.ready.then(function () {
            return l.resolveProperties(a).then(function (e) {
              return t._resolveNames(e, ["to", "from"]).then(function (e) {
                var a = {
                  transaction: W(e)
                };
                return t.perform("estimateGas", a).then(function (e) {
                  return i.bigNumberify(e);
                });
              });
            });
          });
        }, K.prototype.getBlock = function (e, t) {
          var a = this;
          return this.ready.then(function () {
            return l.resolveProperties({
              blockHashOrBlockTag: e
            }).then(function (e) {
              var r = e.blockHashOrBlockTag;

              try {
                var n = c.hexlify(r);
                if (32 === c.hexDataLength(n)) return m.poll(function () {
                  return a.perform("getBlock", {
                    blockHash: n,
                    includeTransactions: !!t
                  }).then(function (e) {
                    return null == e ? null == a._emitted["b:" + n] ? null : void 0 : k(e, t);
                  });
                }, {
                  onceBlock: a
                });
              } catch (e) {}

              try {
                var s = -128,
                    o = D(r);
                return c.isHexString(o) && (s = parseInt(o.substring(2), 16)), m.poll(function () {
                  return a.perform("getBlock", {
                    blockTag: o,
                    includeTransactions: !!t
                  }).then(function (e) {
                    return null != e ? k(e, t) : s <= a._emitted.block ? void 0 : null;
                  });
                }, {
                  onceBlock: a
                });
              } catch (e) {}

              throw new Error("invalid block hash or block tag");
            });
          });
        }, K.prototype.getTransaction = function (e) {
          var t = this;
          return this.ready.then(function () {
            return l.resolveProperties({
              transactionHash: e
            }).then(function (e) {
              var a = e.transactionHash,
                  r = {
                transactionHash: w(a, !0)
              };
              return m.poll(function () {
                return t.perform("getTransaction", r).then(function (e) {
                  if (null == e) return null == t._emitted["t:" + a] ? null : void 0;
                  var r = K.checkTransactionResponse(e);
                  if (null == r.blockNumber) r.confirmations = 0;else if (null == r.confirmations) return t._getFastBlockNumber().then(function (e) {
                    var a = e - r.blockNumber + 1;
                    return a <= 0 && (a = 1), r.confirmations = a, t._wrapTransaction(r);
                  });
                  return t._wrapTransaction(r);
                });
              }, {
                onceBlock: t
              });
            });
          });
        }, K.prototype.getTransactionReceipt = function (e) {
          var t = this;
          return this.ready.then(function () {
            return l.resolveProperties({
              transactionHash: e
            }).then(function (e) {
              var a = e.transactionHash,
                  r = {
                transactionHash: w(a, !0)
              };
              return m.poll(function () {
                return t.perform("getTransactionReceipt", r).then(function (e) {
                  if (null == e) return null == t._emitted["t:" + a] ? null : void 0;

                  if (null != e.blockHash) {
                    var r = function (e) {
                      var t = _(N, e);

                      return t.logs.forEach(function (e, t) {
                        null == e.transactionLogIndex && (e.transactionLogIndex = t);
                      }), null != e.status && (t.byzantium = !0), t;
                    }(e);

                    if (null == r.blockNumber) r.confirmations = 0;else if (null == r.confirmations) return t._getFastBlockNumber().then(function (e) {
                      var t = e - r.blockNumber + 1;
                      return t <= 0 && (t = 1), r.confirmations = t, r;
                    });
                    return r;
                  }
                });
              }, {
                onceBlock: t
              });
            });
          });
        }, K.prototype.getLogs = function (e) {
          var t = this;
          return this.ready.then(function () {
            return l.resolveProperties(e).then(function (e) {
              return t._resolveNames(e, ["address"]).then(function (e) {
                var a = {
                  filter: function (e) {
                    return e && e.blockHash ? _(O, e) : _(L, e);
                  }(e)
                };
                return t.perform("getLogs", a).then(function (e) {
                  return A(j)(e);
                });
              });
            });
          });
        }, K.prototype.getEtherPrice = function () {
          var e = this;
          return this.ready.then(function () {
            return e.perform("getEtherPrice", {}).then(function (e) {
              return e;
            });
          });
        }, K.prototype._getAddress = function (e) {
          return this.resolveName(e).then(function (t) {
            return null == t && y.throwError("ENS name not configured", y.UNSUPPORTED_OPERATION, {
              operation: "resolveName(" + JSON.stringify(e) + ")"
            }), t;
          });
        }, K.prototype._resolveNames = function (e, t) {
          var a = [],
              r = l.shallowCopy(e);
          return t.forEach(function (e) {
            null != r[e] && a.push(this._getAddress(r[e]).then(function (t) {
              r[e] = t;
            }));
          }, this), Promise.all(a).then(function () {
            return r;
          });
        }, K.prototype._getResolver = function (e) {
          var t = this;
          return this.getNetwork().then(function (a) {
            a.ensAddress || y.throwError("network does not support ENS", y.UNSUPPORTED_OPERATION, {
              operation: "ENS",
              network: a.name
            });
            var r = "0x0178b8bf" + d.namehash(e).substring(2),
                n = {
              to: a.ensAddress,
              data: r
            };
            return t.call(n).then(function (e) {
              if (32 !== c.hexDataLength(e)) return null;
              var t = o.getAddress(c.hexDataSlice(e, 12));
              return t === u.AddressZero ? null : t;
            });
          });
        }, K.prototype.resolveName = function (e) {
          var t = this;
          if (e instanceof Promise) return e.then(function (e) {
            return t.resolveName(e);
          });

          try {
            return Promise.resolve(o.getAddress(e));
          } catch (e) {}

          var a = this,
              r = d.namehash(e);
          return this._getResolver(e).then(function (e) {
            if (null == e) return null;
            var t = {
              to: e,
              data: "0x3b3b57de" + r.substring(2)
            };
            return a.call(t);
          }).then(function (e) {
            if (32 !== c.hexDataLength(e)) return null;
            var t = o.getAddress(c.hexDataSlice(e, 12));
            return t === u.AddressZero ? null : t;
          });
        }, K.prototype.lookupAddress = function (e) {
          var t = this;
          if (e instanceof Promise) return e.then(function (e) {
            return t.lookupAddress(e);
          });
          var a = (e = o.getAddress(e)).substring(2) + ".addr.reverse",
              r = d.namehash(a),
              n = this;
          return this._getResolver(a).then(function (e) {
            if (!e) return null;
            var t = {
              to: e,
              data: "0x691f3431" + r.substring(2)
            };
            return n.call(t);
          }).then(function (t) {
            if (null == t) return null;
            if ((t = t.substring(2)).length < 64) return null;
            if ((t = t.substring(64)).length < 64) return null;
            var a = i.bigNumberify("0x" + t.substring(0, 64)).toNumber();
            if (2 * a > (t = t.substring(64)).length) return null;
            var r = b.toUtf8String("0x" + t.substring(0, 2 * a));
            return n.resolveName(r).then(function (t) {
              return t != e ? null : r;
            });
          });
        }, K.checkTransactionResponse = function (e) {
          return S(e);
        }, K.prototype.doPoll = function () {}, K.prototype.perform = function (e, t) {
          return y.throwError(e + " not implemented", y.NOT_IMPLEMENTED, {
            operation: e
          }), null;
        }, K.prototype._startPending = function () {
          y.warn("WARNING: this provider does not support pending events");
        }, K.prototype._stopPending = function () {}, K.prototype._addEventListener = function (e, t, a) {
          this._events.push({
            tag: V(e),
            listener: t,
            once: a
          }), "pending" === e && this._startPending(), this.polling = !0;
        }, K.prototype.on = function (e, t) {
          return this._addEventListener(e, t, !1), this;
        }, K.prototype.once = function (e, t) {
          return this._addEventListener(e, t, !0), this;
        }, K.prototype.addEventListener = function (e, t) {
          return this.on(e, t);
        }, K.prototype.emit = function (e) {
          for (var t = this, a = [], r = 1; r < arguments.length; r++) {
            a[r - 1] = arguments[r];
          }

          var n = !1,
              s = V(e);
          return this._events = this._events.filter(function (e) {
            return e.tag !== s || (setTimeout(function () {
              e.listener.apply(t, a);
            }, 0), n = !0, !e.once);
          }), 0 === this.listenerCount() && (this.polling = !1), n;
        }, K.prototype.listenerCount = function (e) {
          if (!e) return this._events.length;
          var t = V(e);
          return this._events.filter(function (e) {
            return e.tag === t;
          }).length;
        }, K.prototype.listeners = function (e) {
          var t = V(e);
          return this._events.filter(function (e) {
            return e.tag === t;
          }).map(function (e) {
            return e.listener;
          });
        }, K.prototype.removeAllListeners = function (e) {
          if (null == e) this._events = [], this._stopPending();else {
            var t = V(e);
            this._events = this._events.filter(function (e) {
              return e.tag !== t;
            }), "pending" === e && this._stopPending();
          }
          return 0 === this._events.length && (this.polling = !1), this;
        }, K.prototype.removeListener = function (e, t) {
          var a = !1,
              r = V(e);
          return this._events = this._events.filter(function (e) {
            return e.tag !== r || e.listener != t || !!a || !(a = !0);
          }), "pending" === e && 0 === this.listenerCount("pending") && this._stopPending(), 0 === this.listenerCount() && (this.polling = !1), this;
        }, K);

        function K(e) {
          var t = H.call(this) || this;
          if (y.checkNew(t, v.Provider), e instanceof Promise) l.defineReadOnly(t, "ready", e.then(function (e) {
            return l.defineReadOnly(t, "_network", e), e;
          })), t.ready.catch(function (e) {});else {
            var a = f.getNetwork(null == e ? "homestead" : e);
            a ? (l.defineReadOnly(t, "_network", a), l.defineReadOnly(t, "ready", Promise.resolve(t._network))) : y.throwError("invalid network", y.INVALID_ARGUMENT, {
              arg: "network",
              value: e
            });
          }
          return t._lastBlockNumber = -2, t._balances = {}, t._events = [], t._pollingInterval = 4e3, t._emitted = {
            block: -2
          }, t._fastQueryDate = 0, t;
        }

        a.BaseProvider = z, l.defineReadOnly(v.Provider, "inherits", l.inheritable(v.Provider));
      }, {
        "../constants": 3,
        "../errors": 5,
        "../utils/address": 59,
        "../utils/bignumber": 62,
        "../utils/bytes": 63,
        "../utils/hash": 64,
        "../utils/networks": 71,
        "../utils/properties": 73,
        "../utils/rlp": 75,
        "../utils/transaction": 82,
        "../utils/utf8": 84,
        "../utils/web": 85,
        "./abstract-provider": 49
      }],
      51: [function (e, t, a) {
        "use strict";

        var r,
            n = this && this.__extends || (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var a in t) {
            t.hasOwnProperty(a) && (e[a] = t[a]);
          }
        }, function (e, t) {
          function a() {
            this.constructor = e;
          }

          r(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
        }),
            s = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var o = e("./base-provider"),
            i = e("../utils/bytes"),
            c = e("../utils/properties"),
            u = e("../utils/web"),
            d = s(e("../errors"));

        function f(e) {
          var t = [];

          for (var a in e) {
            if (null != e[a]) {
              var r = i.hexlify(e[a]);
              !{
                gasLimit: !0,
                gasPrice: !0,
                nonce: !0,
                value: !0
              }[a] || (r = i.hexStripZeros(r)), t.push(a + "=" + r);
            }
          }

          return t.join("&");
        }

        function l(e) {
          if (0 == e.status && ("No records found" === e.message || "No transactions found" === e.message)) return e.result;
          if (1 == e.status && "OK" == e.message) return e.result;
          var t = new Error("invalid response");
          throw t.result = JSON.stringify(e), t;
        }

        function h(e) {
          if ("2.0" != e.jsonrpc) throw (t = new Error("invalid response")).result = JSON.stringify(e), t;

          if (e.error) {
            var t = new Error(e.error.message || "unknown error");
            throw e.error.code && (t.code = e.error.code), e.error.data && (t.data = e.error.data), t;
          }

          return e.result;
        }

        function p(e) {
          if ("pending" === e) throw new Error("pending not supported");
          return "latest" === e ? e : parseInt(e.substring(2), 16);
        }

        var b,
            m = (n(y, b = o.BaseProvider), y.prototype.perform = function (e, t) {
          var a = this,
              r = this.baseUrl,
              n = "";

          function s(e, t) {
            return u.fetchJson(e, null, t || h).then(function (t) {
              return a.emit("debug", {
                action: "perform",
                request: e,
                response: t,
                provider: a
              }), t;
            });
          }

          switch (this.apiKey && (n += "&apikey=" + this.apiKey), e) {
            case "getBlockNumber":
              return s(r += "/api?module=proxy&action=eth_blockNumber" + n);

            case "getGasPrice":
              return s(r += "/api?module=proxy&action=eth_gasPrice" + n);

            case "getBalance":
              return r += "/api?module=account&action=balance&address=" + t.address, s(r += "&tag=" + t.blockTag + n, l);

            case "getTransactionCount":
              return r += "/api?module=proxy&action=eth_getTransactionCount&address=" + t.address, s(r += "&tag=" + t.blockTag + n);

            case "getCode":
              return r += "/api?module=proxy&action=eth_getCode&address=" + t.address, s(r += "&tag=" + t.blockTag + n, h);

            case "getStorageAt":
              return r += "/api?module=proxy&action=eth_getStorageAt&address=" + t.address, r += "&position=" + t.position, s(r += "&tag=" + t.blockTag + n, h);

            case "sendTransaction":
              return r += "/api?module=proxy&action=eth_sendRawTransaction&hex=" + t.signedTransaction, s(r += n).catch(function (e) {
                throw e.responseText && (0 <= e.responseText.toLowerCase().indexOf("insufficient funds") && d.throwError("insufficient funds", d.INSUFFICIENT_FUNDS, {}), 0 <= e.responseText.indexOf("same hash was already imported") && d.throwError("nonce has already been used", d.NONCE_EXPIRED, {}), 0 <= e.responseText.indexOf("another transaction with same nonce") && d.throwError("replacement fee too low", d.REPLACEMENT_UNDERPRICED, {})), e;
              });

            case "getBlock":
              if (t.blockTag) return r += "/api?module=proxy&action=eth_getBlockByNumber&tag=" + t.blockTag, t.includeTransactions ? r += "&boolean=true" : r += "&boolean=false", s(r += n);
              throw new Error("getBlock by blockHash not implmeneted");

            case "getTransaction":
              return r += "/api?module=proxy&action=eth_getTransactionByHash&txhash=" + t.transactionHash, s(r += n);

            case "getTransactionReceipt":
              return r += "/api?module=proxy&action=eth_getTransactionReceipt&txhash=" + t.transactionHash, s(r += n);

            case "call":
              if (r += "/api?module=proxy&action=eth_call" + (o = (o = f(t.transaction)) && "&" + o), "latest" !== t.blockTag) throw new Error("EtherscanProvider does not support blockTag for call");
              return s(r += n);

            case "estimateGas":
              var o;
              return r += "/api?module=proxy&action=eth_estimateGas&" + (o = (o = f(t.transaction)) && "&" + o), s(r += n);

            case "getLogs":
              r += "/api?module=logs&action=getLogs";

              try {
                if (t.filter.fromBlock && (r += "&fromBlock=" + p(t.filter.fromBlock)), t.filter.toBlock && (r += "&toBlock=" + p(t.filter.toBlock)), t.filter.blockHash) try {
                  d.throwError("Etherscan does not support blockHash filters", d.UNSUPPORTED_OPERATION, {
                    operation: "getLogs(blockHash)"
                  });
                } catch (e) {
                  return Promise.reject(e);
                }

                if (t.filter.address && (r += "&address=" + t.filter.address), t.filter.topics && 0 < t.filter.topics.length) {
                  if (1 < t.filter.topics.length) throw new Error("unsupported topic format");
                  var i = t.filter.topics[0];
                  if ("string" != typeof i || 66 !== i.length) throw new Error("unsupported topic0 format");
                  r += "&topic0=" + i;
                }
              } catch (e) {
                return Promise.reject(e);
              }

              var c = this;
              return s(r += n, l).then(function (e) {
                var t = {},
                    a = Promise.resolve();
                return e.forEach(function (e) {
                  a = a.then(function () {
                    return null != e.blockHash ? null : (e.blockHash = t[e.transactionHash], null == e.blockHash ? c.getTransaction(e.transactionHash).then(function (a) {
                      return t[e.transactionHash] = a.blockHash, e.blockHash = a.blockHash, null;
                    }) : null);
                  });
                }), a.then(function () {
                  return e;
                });
              });

            case "getEtherPrice":
              return "homestead" !== this.network.name ? Promise.resolve(0) : (r += "/api?module=stats&action=ethprice", s(r += n, l).then(function (e) {
                return parseFloat(e.ethusd);
              }));
          }

          return b.prototype.perform.call(this, e, t);
        }, y.prototype.getHistory = function (e, t, a) {
          var r = this,
              n = this.baseUrl,
              s = "";
          return this.apiKey && (s += "&apikey=" + this.apiKey), null == t && (t = 0), null == a && (a = 99999999), this.resolveName(e).then(function (e) {
            return n += "/api?module=account&action=txlist&address=" + e, n += "&startblock=" + t, n += "&endblock=" + a, n += "&sort=asc" + s, u.fetchJson(n, null, l).then(function (e) {
              r.emit("debug", {
                action: "getHistory",
                request: n,
                response: e,
                provider: r
              });
              var t = [];
              return e.forEach(function (e) {
                ["contractAddress", "to"].forEach(function (t) {
                  "" == e[t] && delete e[t];
                }), null == e.creates && null != e.contractAddress && (e.creates = e.contractAddress);
                var a = o.BaseProvider.checkTransactionResponse(e);
                e.timeStamp && (a.timestamp = parseInt(e.timeStamp)), t.push(a);
              }), t;
            });
          });
        }, y);

        function y(e, t) {
          var a = b.call(this, e) || this;
          d.checkNew(a, y);
          var r = "invalid";
          a.network && (r = a.network.name);
          var n = null;

          switch (r) {
            case "homestead":
              n = "https://api.etherscan.io";
              break;

            case "ropsten":
              n = "https://api-ropsten.etherscan.io";
              break;

            case "rinkeby":
              n = "https://api-rinkeby.etherscan.io";
              break;

            case "kovan":
              n = "https://api-kovan.etherscan.io";
              break;

            case "goerli":
              n = "https://api-goerli.etherscan.io";
              break;

            default:
              throw new Error("unsupported network");
          }

          return c.defineReadOnly(a, "baseUrl", n), c.defineReadOnly(a, "apiKey", t), a;
        }

        a.EtherscanProvider = m;
      }, {
        "../errors": 5,
        "../utils/bytes": 63,
        "../utils/properties": 73,
        "../utils/web": 85,
        "./base-provider": 50
      }],
      52: [function (e, t, a) {
        "use strict";

        var r,
            n = this && this.__extends || (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var a in t) {
            t.hasOwnProperty(a) && (e[a] = t[a]);
          }
        }, function (e, t) {
          function a() {
            this.constructor = e;
          }

          r(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
        }),
            s = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var o = e("./base-provider"),
            i = s(e("../errors"));

        function c(e) {
          var t = !0,
              a = null;
          return e.forEach(function (r) {
            null != r ? null != a ? a.name === r.name && a.chainId === r.chainId && (a.ensAddress === r.ensAddress || null == a.ensAddress && null == r.ensAddress) || i.throwError("provider mismatch", i.INVALID_ARGUMENT, {
              arg: "networks",
              value: e
            }) : a = r : t = !1;
          }), t;
        }

        var u,
            d = (n(f, u = o.BaseProvider), Object.defineProperty(f.prototype, "providers", {
          get: function get() {
            return this._providers.slice(0);
          },
          enumerable: !0,
          configurable: !0
        }), f.prototype.perform = function (e, t) {
          var a = this.providers;
          return new Promise(function (r, n) {
            var s = null;
            !function o() {
              a.length ? a.shift().perform(e, t).then(function (e) {
                return r(e);
              }).catch(function (e) {
                s = s || e, setTimeout(o, 0);
              }) : n(s);
            }();
          });
        }, f);

        function f(e) {
          var t = this;
          if (0 === e.length) throw new Error("no providers");
          if (c(e.map(function (e) {
            return e.network;
          }))) t = u.call(this, e[0].network) || this;else {
            var a = Promise.all(e.map(function (e) {
              return e.getNetwork();
            })).then(function (e) {
              return c(e) || i.throwError("getNetwork returned null", i.UNKNOWN_ERROR, {}), e[0];
            });
            t = u.call(this, a) || this;
          }
          return i.checkNew(t, f), t._providers = e.slice(0), t;
        }

        a.FallbackProvider = d;
      }, {
        "../errors": 5,
        "./base-provider": 50
      }],
      53: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var r = e("./abstract-provider");
        a.Provider = r.Provider;
        var n = e("./base-provider");
        a.BaseProvider = n.BaseProvider;
        var s = e("./etherscan-provider");
        a.EtherscanProvider = s.EtherscanProvider;
        var o = e("./fallback-provider");
        a.FallbackProvider = o.FallbackProvider;
        var i = e("./ipc-provider");
        a.IpcProvider = i.IpcProvider;
        var c = e("./infura-provider");
        a.InfuraProvider = c.InfuraProvider;
        var u = e("./json-rpc-provider");
        a.JsonRpcProvider = u.JsonRpcProvider, a.JsonRpcSigner = u.JsonRpcSigner;
        var d = e("./web3-provider");
        a.Web3Provider = d.Web3Provider;
      }, {
        "./abstract-provider": 49,
        "./base-provider": 50,
        "./etherscan-provider": 51,
        "./fallback-provider": 52,
        "./infura-provider": 54,
        "./ipc-provider": 55,
        "./json-rpc-provider": 56,
        "./web3-provider": 57
      }],
      54: [function (e, t, a) {
        "use strict";

        var r,
            n = this && this.__extends || (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var a in t) {
            t.hasOwnProperty(a) && (e[a] = t[a]);
          }
        }, function (e, t) {
          function a() {
            this.constructor = e;
          }

          r(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
        }),
            s = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var o,
            i = e("./json-rpc-provider"),
            c = e("../utils/bytes"),
            u = e("../utils/networks"),
            d = e("../utils/properties"),
            f = s(e("../errors")),
            l = (n(h, o = i.JsonRpcProvider), h.prototype._startPending = function () {
          f.warn("WARNING: INFURA does not support pending filters");
        }, h.prototype.getSigner = function (e) {
          return f.throwError("INFURA does not support signing", f.UNSUPPORTED_OPERATION, {
            operation: "getSigner"
          });
        }, h.prototype.listAccounts = function () {
          return Promise.resolve([]);
        }, h);

        function h(e, t) {
          var a = this,
              r = u.getNetwork(null == e ? "homestead" : e);
          null == t && (t = "7d0d81d0919f4f05b9ab6634be01ee73");
          var n = null;

          switch (r.name) {
            case "homestead":
              n = "mainnet.infura.io";
              break;

            case "ropsten":
              n = "ropsten.infura.io";
              break;

            case "rinkeby":
              n = "rinkeby.infura.io";
              break;

            case "goerli":
              n = "goerli.infura.io";
              break;

            case "kovan":
              n = "kovan.infura.io";
              break;

            default:
              f.throwError("unsupported network", f.INVALID_ARGUMENT, {
                argument: "network",
                value: e
              });
          }

          return c.isHexString("0x" + t, 16) ? (a = o.call(this, "https://" + n + "/v3/" + t, r) || this, d.defineReadOnly(a, "apiAccessToken", null), d.defineReadOnly(a, "projectId", t)) : (f.warn("The legacy INFURA apiAccesToken API is deprecated; please upgrade to a Project ID instead (see INFURA dshboard; https://infura.io)"), a = o.call(this, "https://" + n + "/" + t, r) || this, d.defineReadOnly(a, "apiAccessToken", t), d.defineReadOnly(a, "projectId", null)), f.checkNew(a, h), a;
        }

        a.InfuraProvider = l;
      }, {
        "../errors": 5,
        "../utils/bytes": 63,
        "../utils/networks": 71,
        "../utils/properties": 73,
        "./json-rpc-provider": 56
      }],
      55: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
      }, {}],
      56: [function (e, t, a) {
        "use strict";

        var r,
            n = this && this.__extends || (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var a in t) {
            t.hasOwnProperty(a) && (e[a] = t[a]);
          }
        }, function (e, t) {
          function a() {
            this.constructor = e;
          }

          r(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
        }),
            s = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var o = e("./base-provider"),
            i = e("../abstract-signer"),
            c = s(e("../errors")),
            u = e("../utils/address"),
            d = e("../utils/bytes"),
            f = e("../utils/networks"),
            l = e("../utils/properties"),
            h = e("../utils/utf8"),
            p = e("../utils/web");

        function b(e) {
          if (e.error) {
            var t = new Error(e.error.message);
            throw t.code = e.error.code, t.data = e.error.data, t;
          }

          return e.result;
        }

        function m(e) {
          return e ? e.toLowerCase() : e;
        }

        var y,
            v = {},
            _ = 42,
            g = (n(A, y = i.Signer), A.prototype.getAddress = function () {
          var e = this;
          return this._address ? Promise.resolve(this._address) : this.provider.send("eth_accounts", []).then(function (t) {
            return t.length <= e._index && c.throwError("unknown account #" + e._index, c.UNSUPPORTED_OPERATION, {
              operation: "getAddress"
            }), e._address = u.getAddress(t[e._index]), e._address;
          });
        }, A.prototype.getBalance = function (e) {
          return this.provider.getBalance(this.getAddress(), e);
        }, A.prototype.getTransactionCount = function (e) {
          return this.provider.getTransactionCount(this.getAddress(), e);
        }, A.prototype.sendUncheckedTransaction = function (e) {
          var t = this;
          e = l.shallowCopy(e);
          var a = this.getAddress().then(function (e) {
            return e && e.toLowerCase();
          });

          if (null == e.gasLimit) {
            var r = l.shallowCopy(e);
            r.from = a, e.gasLimit = this.provider.estimateGas(r);
          }

          return Promise.all([l.resolveProperties(e), a]).then(function (e) {
            var a = e[0],
                r = x.hexlifyTransaction(a);
            return r.from = e[1], t.provider.send("eth_sendTransaction", [r]).then(function (e) {
              return e;
            }, function (e) {
              throw e.responseText && (0 <= e.responseText.indexOf("insufficient funds") && c.throwError("insufficient funds", c.INSUFFICIENT_FUNDS, {
                transaction: a
              }), 0 <= e.responseText.indexOf("nonce too low") && c.throwError("nonce has already been used", c.NONCE_EXPIRED, {
                transaction: a
              }), 0 <= e.responseText.indexOf("replacement transaction underpriced") && c.throwError("replacement fee too low", c.REPLACEMENT_UNDERPRICED, {
                transaction: a
              })), e;
            });
          });
        }, A.prototype.sendTransaction = function (e) {
          var t = this;
          return this.sendUncheckedTransaction(e).then(function (e) {
            return p.poll(function () {
              return t.provider.getTransaction(e).then(function (a) {
                if (null !== a) return t.provider._wrapTransaction(a, e);
              });
            }, {
              fastRetry: 250,
              onceBlock: t.provider
            }).catch(function (t) {
              throw t.transactionHash = e, t;
            });
          });
        }, A.prototype.signMessage = function (e) {
          var t = this,
              a = "string" == typeof e ? h.toUtf8Bytes(e) : e;
          return this.getAddress().then(function (e) {
            return t.provider.send("eth_sign", [e.toLowerCase(), d.hexlify(a)]);
          });
        }, A.prototype.unlock = function (e) {
          var t = this.provider;
          return this.getAddress().then(function (a) {
            return t.send("personal_unlockAccount", [a.toLowerCase(), e, null]);
          });
        }, A);

        function A(e, t, a) {
          var r = y.call(this) || this;
          if (c.checkNew(r, A), e !== v) throw new Error("do not call the JsonRpcSigner constructor directly; use provider.getSigner");
          return l.defineReadOnly(r, "provider", t), a ? "string" == typeof a ? l.defineReadOnly(r, "_address", u.getAddress(a)) : "number" == typeof a ? l.defineReadOnly(r, "_index", a) : c.throwError("invalid address or index", c.INVALID_ARGUMENT, {
            argument: "addressOrIndex",
            value: a
          }) : l.defineReadOnly(r, "_index", 0), r;
        }

        a.JsonRpcSigner = g;
        var w,
            T = {
          chainId: !0,
          data: !0,
          gasLimit: !0,
          gasPrice: !0,
          nonce: !0,
          to: !0,
          value: !0
        },
            x = (n(D, w = o.BaseProvider), D.prototype.getSigner = function (e) {
          return new g(v, this, e);
        }, D.prototype.listAccounts = function () {
          return this.send("eth_accounts", []).then(function (e) {
            return e.map(function (e) {
              return u.getAddress(e);
            });
          });
        }, D.prototype.send = function (e, t) {
          var a = this,
              r = {
            method: e,
            params: t,
            id: _++,
            jsonrpc: "2.0"
          };
          return p.fetchJson(this.connection, JSON.stringify(r), b).then(function (e) {
            return a.emit("debug", {
              action: "send",
              request: r,
              response: e,
              provider: a
            }), e;
          });
        }, D.prototype.perform = function (e, t) {
          switch (e) {
            case "getBlockNumber":
              return this.send("eth_blockNumber", []);

            case "getGasPrice":
              return this.send("eth_gasPrice", []);

            case "getBalance":
              return this.send("eth_getBalance", [m(t.address), t.blockTag]);

            case "getTransactionCount":
              return this.send("eth_getTransactionCount", [m(t.address), t.blockTag]);

            case "getCode":
              return this.send("eth_getCode", [m(t.address), t.blockTag]);

            case "getStorageAt":
              return this.send("eth_getStorageAt", [m(t.address), t.position, t.blockTag]);

            case "sendTransaction":
              return this.send("eth_sendRawTransaction", [t.signedTransaction]).catch(function (e) {
                throw e.responseText && (0 < e.responseText.indexOf("insufficient funds") && c.throwError("insufficient funds", c.INSUFFICIENT_FUNDS, {}), 0 < e.responseText.indexOf("nonce too low") && c.throwError("nonce has already been used", c.NONCE_EXPIRED, {}), 0 < e.responseText.indexOf("replacement transaction underpriced") && c.throwError("replacement fee too low", c.REPLACEMENT_UNDERPRICED, {})), e;
              });

            case "getBlock":
              return t.blockTag ? this.send("eth_getBlockByNumber", [t.blockTag, !!t.includeTransactions]) : t.blockHash ? this.send("eth_getBlockByHash", [t.blockHash, !!t.includeTransactions]) : Promise.reject(new Error("invalid block tag or block hash"));

            case "getTransaction":
              return this.send("eth_getTransactionByHash", [t.transactionHash]);

            case "getTransactionReceipt":
              return this.send("eth_getTransactionReceipt", [t.transactionHash]);

            case "call":
              return this.send("eth_call", [D.hexlifyTransaction(t.transaction, {
                from: !0
              }), t.blockTag]);

            case "estimateGas":
              return this.send("eth_estimateGas", [D.hexlifyTransaction(t.transaction, {
                from: !0
              })]);

            case "getLogs":
              return t.filter && null != t.filter.address && (t.filter.address = m(t.filter.address)), this.send("eth_getLogs", [t.filter]);
          }

          return c.throwError(e + " not implemented", c.NOT_IMPLEMENTED, {
            operation: e
          }), null;
        }, D.prototype._startPending = function () {
          if (null == this._pendingFilter) {
            var e = this,
                t = this.send("eth_newPendingTransactionFilter", []);
            (this._pendingFilter = t).then(function (a) {
              return function r() {
                e.send("eth_getFilterChanges", [a]).then(function (a) {
                  if (e._pendingFilter != t) return null;
                  var r = Promise.resolve();
                  return a.forEach(function (t) {
                    e._emitted["t:" + t.toLowerCase()] = "pending", r = r.then(function () {
                      return e.getTransaction(t).then(function (t) {
                        return e.emit("pending", t), null;
                      });
                    });
                  }), r.then(function () {
                    return new Promise(function (e) {
                      setTimeout(function () {
                        e();
                      }, 1e3);
                    });
                  });
                }).then(function () {
                  if (e._pendingFilter == t) return setTimeout(function () {
                    r();
                  }, 0), null;
                  e.send("eth_uninstallFilter", [a]);
                }).catch(function (e) {});
              }(), a;
            }).catch(function (e) {});
          }
        }, D.prototype._stopPending = function () {
          this._pendingFilter = null;
        }, D.hexlifyTransaction = function (e, t) {
          var a = l.shallowCopy(T);
          if (t) for (var r in t) {
            t[r] && (a[r] = !0);
          }
          l.checkProperties(e, a);
          var n = {};
          return ["gasLimit", "gasPrice", "nonce", "value"].forEach(function (t) {
            if (null != e[t]) {
              var a = d.hexStripZeros(d.hexlify(e[t]));
              "gasLimit" === t && (t = "gas"), n[t] = a;
            }
          }), ["from", "to", "data"].forEach(function (t) {
            null != e[t] && (n[t] = d.hexlify(e[t]));
          }), n;
        }, D);

        function D(e, t) {
          var a = this;
          if ("string" == typeof e && null === t && f.getNetwork(e) && (t = e, e = null), t) a = w.call(this, t) || this;else {
            var r = new Promise(function (e, t) {
              setTimeout(function () {
                a.send("net_version", []).then(function (t) {
                  return e(f.getNetwork(parseInt(t)));
                }).catch(function (e) {
                  t(e);
                });
              });
            });
            a = w.call(this, r) || this;
          }
          return c.checkNew(a, D), e = e || "http://localhost:8545", a.connection = "string" == typeof e ? {
            url: e
          } : e, a;
        }

        a.JsonRpcProvider = x;
      }, {
        "../abstract-signer": 2,
        "../errors": 5,
        "../utils/address": 59,
        "../utils/bytes": 63,
        "../utils/networks": 71,
        "../utils/properties": 73,
        "../utils/utf8": 84,
        "../utils/web": 85,
        "./base-provider": 50
      }],
      57: [function (e, t, a) {
        "use strict";

        var r,
            n = this && this.__extends || (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var a in t) {
            t.hasOwnProperty(a) && (e[a] = t[a]);
          }
        }, function (e, t) {
          function a() {
            this.constructor = e;
          }

          r(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
        }),
            s = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var o,
            i = e("./json-rpc-provider"),
            c = e("../utils/properties"),
            u = s(e("../errors")),
            d = 42,
            f = (n(l, o = i.JsonRpcProvider), l.prototype.send = function (e, t) {
          var a = this;
          return "eth_sign" == e && this._web3Provider.isMetaMask && (e = "personal_sign", t = [t[1], t[0]]), new Promise(function (r, n) {
            var s = {
              method: e,
              params: t,
              id: d++,
              jsonrpc: "2.0"
            };

            a._sendAsync(s, function (e, t) {
              if (e) n(e);else {
                if (t.error) {
                  var a = new Error(t.error.message);
                  return a.code = t.error.code, a.data = t.error.data, void n(a);
                }

                r(t.result);
              }
            });
          });
        }, l);

        function l(e, t) {
          var a = o.call(this, e.host || e.path || "", t) || this;
          return u.checkNew(a, l), e && (e.sendAsync ? a._sendAsync = e.sendAsync.bind(e) : e.send && (a._sendAsync = e.send.bind(e))), e && a._sendAsync || u.throwError("invalid web3Provider", u.INVALID_ARGUMENT, {
            arg: "web3Provider",
            value: e
          }), c.defineReadOnly(a, "_web3Provider", e), a;
        }

        a.Web3Provider = f;
      }, {
        "../errors": 5,
        "../utils/properties": 73,
        "./json-rpc-provider": 56
      }],
      58: [function (e, t, a) {
        "use strict";

        var r,
            n = this && this.__extends || (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var a in t) {
            t.hasOwnProperty(a) && (e[a] = t[a]);
          }
        }, function (e, t) {
          function a() {
            this.constructor = e;
          }

          r(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
        }),
            s = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var o = e("../constants"),
            i = s(e("../errors")),
            c = e("./address"),
            u = e("./bignumber"),
            d = e("./bytes"),
            f = e("./utf8"),
            l = e("./properties"),
            h = new RegExp(/^bytes([0-9]*)$/),
            p = new RegExp(/^(u?int)([0-9]*)$/),
            b = new RegExp(/^(.*)\[([0-9]*)\]$/);

        a.defaultCoerceFunc = function (e, t) {
          var a = e.match(p);
          return a && parseInt(a[2]) <= 48 ? t.toNumber() : t;
        };

        var m = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$"),
            y = new RegExp("^[A-Za-z_][A-Za-z0-9_]*$");

        function v(e) {
          return e.match(/^uint($|[^1-9])/) ? e = "uint256" + e.substring(4) : e.match(/^int($|[^1-9])/) && (e = "int256" + e.substring(3)), e;
        }

        function _(e, t) {
          var a = e;

          function r(e) {
            throw new Error('unexpected character "' + a[e] + '" at position ' + e + ' in "' + a + '"');
          }

          e = e.replace(/\s/g, " ");

          for (var n = {
            type: "",
            name: "",
            state: {
              allowType: !0
            }
          }, s = n, o = 0; o < e.length; o++) {
            var i = e[o];

            switch (i) {
              case "(":
                s.state.allowParams || r(o), s.state.allowType = !1, s.type = v(s.type), s.components = [{
                  type: "",
                  name: "",
                  parent: s,
                  state: {
                    allowType: !0
                  }
                }], s = s.components[0];
                break;

              case ")":
                delete s.state, t && "indexed" === s.name && (s.indexed = !0, s.name = ""), s.type = v(s.type);
                var c = s;
                (s = s.parent) || r(o), delete c.parent, s.state.allowParams = !1, s.state.allowName = !0, s.state.allowArray = !0;
                break;

              case ",":
                delete s.state, t && "indexed" === s.name && (s.indexed = !0, s.name = ""), s.type = v(s.type);
                var u = {
                  type: "",
                  name: "",
                  parent: s.parent,
                  state: {
                    allowType: !0
                  }
                };
                s.parent.components.push(u), delete s.parent, s = u;
                break;

              case " ":
                s.state.allowType && "" !== s.type && (s.type = v(s.type), delete s.state.allowType, s.state.allowName = !0, s.state.allowParams = !0), s.state.allowName && "" !== s.name && (t && "indexed" === s.name ? (s.indexed = !0, s.name = "") : s.state.allowName = !1);
                break;

              case "[":
                s.state.allowArray || r(o), s.type += i, s.state.allowArray = !1, s.state.allowName = !1, s.state.readArray = !0;
                break;

              case "]":
                s.state.readArray || r(o), s.type += i, s.state.readArray = !1, s.state.allowArray = !0, s.state.allowName = !0;
                break;

              default:
                s.state.allowType ? (s.type += i, s.state.allowParams = !0, s.state.allowArray = !0) : s.state.allowName ? (s.name += i, delete s.state.allowArray) : s.state.readArray ? s.type += i : r(o);
            }
          }

          if (s.parent) throw new Error("unexpected eof");
          return delete n.state, t && "indexed" === s.name && (s.indexed = !0, s.name = ""), n.type = v(n.type), n;
        }

        function g(e) {
          return oe(a.defaultCoerceFunc, e).type;
        }

        function A(e, t, a, r, n) {
          this.coerceFunc = e, this.name = t, this.type = a, this.localName = r, this.dynamic = n;
        }

        a.parseParamType = function (e) {
          return _(e, !0);
        }, a.formatParamType = g, a.formatSignature = function (e) {
          return e.name + "(" + e.inputs.map(function (e) {
            return g(e);
          }).join(",") + ")";
        }, a.parseSignature = function (e) {
          if ("string" == typeof e) return "event " === (e = (e = (e = e.replace(/\s/g, " ")).replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " ")).trim()).substring(0, 6) ? function (e) {
            var t = {
              anonymous: !1,
              inputs: [],
              name: "",
              type: "event"
            },
                a = e.match(m);
            if (!a) throw new Error("invalid event: " + e);
            if (t.name = a[1].trim(), ne(a[2]).forEach(function (e) {
              (e = _(e, !0)).indexed = !!e.indexed, t.inputs.push(e);
            }), a[3].split(" ").forEach(function (e) {
              switch (e) {
                case "anonymous":
                  t.anonymous = !0;
                  break;

                case "":
                  break;

                default:
                  i.info("unknown modifier: " + e);
              }
            }), t.name && !t.name.match(y)) throw new Error('invalid identifier: "' + t.name + '"');
            return t;
          }(e.substring(6).trim()) : ("function " === e.substring(0, 9) && (e = e.substring(9)), function (e) {
            var t = {
              constant: !1,
              gas: null,
              inputs: [],
              name: "",
              outputs: [],
              payable: !1,
              stateMutability: null,
              type: "function"
            },
                a = e.split("@");

            if (1 !== a.length) {
              if (2 < a.length) throw new Error("invalid signature");
              if (!a[1].match(/^[0-9]+$/)) throw new Error("invalid signature gas");
              t.gas = u.bigNumberify(a[1]), e = a[0];
            }

            var r = (a = e.split(" returns "))[0].match(m);
            if (!r) throw new Error("invalid signature");
            if (t.name = r[1].trim(), !t.name.match(y)) throw new Error('invalid identifier: "' + r[1] + '"');

            if (ne(r[2]).forEach(function (e) {
              t.inputs.push(_(e));
            }), r[3].split(" ").forEach(function (e) {
              switch (e) {
                case "constant":
                  t.constant = !0;
                  break;

                case "payable":
                  t.payable = !0, t.stateMutability = "payable";
                  break;

                case "pure":
                  t.constant = !0, t.stateMutability = "pure";
                  break;

                case "view":
                  t.constant = !0, t.stateMutability = "view";
                  break;

                case "external":
                case "public":
                case "":
                  break;

                default:
                  i.info("unknown modifier: " + e);
              }
            }), 1 < a.length) {
              var n = a[1].match(m);
              if ("" != n[1].trim() || "" != n[3].trim()) throw new Error("unexpected tokens");
              ne(n[2]).forEach(function (e) {
                t.outputs.push(_(e));
              });
            }

            if ("constructor" === t.name) {
              if (t.type = "constructor", t.outputs.length) throw new Error("constructor may not have outputs");
              delete t.name, delete t.outputs;
            }

            return t;
          }(e.trim()));
          throw new Error("unknown signature");
        };
        var w,
            T = (n(x, w = A), x.prototype.encode = function (e) {
          return this.coder.encode(e);
        }, x.prototype.decode = function (e, t) {
          return this.coder.decode(e, t);
        }, x);

        function x(e) {
          var t = w.call(this, e.coerceFunc, e.name, e.type, void 0, e.dynamic) || this;
          return l.defineReadOnly(t, "coder", e), t;
        }

        var D,
            C = (n(S, D = A), S.prototype.encode = function (e) {
          return d.arrayify([]);
        }, S.prototype.decode = function (e, t) {
          if (t > e.length) throw new Error("invalid null");
          return {
            consumed: 0,
            value: this.coerceFunc("null", void 0)
          };
        }, S);

        function S(e, t) {
          return D.call(this, e, "null", "", t, !1) || this;
        }

        var E,
            B = (n(k, E = A), k.prototype.encode = function (e) {
          try {
            var t = u.bigNumberify(e);

            if (this.signed) {
              var a = o.MaxUint256.maskn(8 * this.size - 1);
              if (t.gt(a)) throw new Error("out-of-bounds");
              if (a = a.add(o.One).mul(o.NegativeOne), t.lt(a)) throw new Error("out-of-bounds");
            } else if (t.lt(o.Zero) || t.gt(o.MaxUint256.maskn(8 * this.size))) throw new Error("out-of-bounds");

            return t = t.toTwos(8 * this.size).maskn(8 * this.size), this.signed && (t = t.fromTwos(8 * this.size).toTwos(256)), d.padZeros(d.arrayify(t), 32);
          } catch (t) {
            i.throwError("invalid number value", i.INVALID_ARGUMENT, {
              arg: this.localName,
              coderType: this.name,
              value: e
            });
          }

          return null;
        }, k.prototype.decode = function (e, t) {
          e.length < t + 32 && i.throwError("insufficient data for " + this.name + " type", i.INVALID_ARGUMENT, {
            arg: this.localName,
            coderType: this.name,
            value: d.hexlify(e.slice(t, t + 32))
          });
          var a = 32 - this.size,
              r = u.bigNumberify(e.slice(t + a, t + 32));
          return r = this.signed ? r.fromTwos(8 * this.size) : r.maskn(8 * this.size), {
            consumed: 32,
            value: this.coerceFunc(this.name, r)
          };
        }, k);

        function k(e, t, a, r) {
          var n = this,
              s = (a ? "int" : "uint") + 8 * t;
          return (n = E.call(this, e, s, s, r, !1) || this).size = t, n.signed = a, n;
        }

        var R,
            W = new B(function (e, t) {
          return t;
        }, 32, !1, "none"),
            I = (n(N, R = A), N.prototype.encode = function (e) {
          return W.encode(e ? 1 : 0);
        }, N.prototype.decode = function (e, t) {
          try {
            var a = W.decode(e, t);
          } catch (e) {
            throw "insufficient data for uint256 type" === e.reason && i.throwError("insufficient data for boolean type", i.INVALID_ARGUMENT, {
              arg: this.localName,
              coderType: "boolean",
              value: e.value
            }), e;
          }

          return {
            consumed: a.consumed,
            value: this.coerceFunc("bool", !a.value.isZero())
          };
        }, N);

        function N(e, t) {
          return R.call(this, e, "bool", "bool", t, !1) || this;
        }

        var M,
            P = (n(L, M = A), L.prototype.encode = function (e) {
          var t = new Uint8Array(32);

          try {
            var a = d.arrayify(e);
            if (a.length !== this.length) throw new Error("incorrect data length");
            t.set(a);
          } catch (t) {
            i.throwError("invalid " + this.name + " value", i.INVALID_ARGUMENT, {
              arg: this.localName,
              coderType: this.name,
              value: t.value || e
            });
          }

          return t;
        }, L.prototype.decode = function (e, t) {
          return e.length < t + 32 && i.throwError("insufficient data for " + this.name + " type", i.INVALID_ARGUMENT, {
            arg: this.localName,
            coderType: this.name,
            value: d.hexlify(e.slice(t, t + 32))
          }), {
            consumed: 32,
            value: this.coerceFunc(this.name, d.hexlify(e.slice(t, t + this.length)))
          };
        }, L);

        function L(e, t, a) {
          var r = this,
              n = "bytes" + t;
          return (r = M.call(this, e, n, n, a, !1) || this).length = t, r;
        }

        var O,
            F = (n(j, O = A), j.prototype.encode = function (e) {
          var t = new Uint8Array(32);

          try {
            t.set(d.arrayify(c.getAddress(e)), 12);
          } catch (t) {
            i.throwError("invalid address", i.INVALID_ARGUMENT, {
              arg: this.localName,
              coderType: "address",
              value: e
            });
          }

          return t;
        }, j.prototype.decode = function (e, t) {
          return e.length < t + 32 && i.throwError("insufficuent data for address type", i.INVALID_ARGUMENT, {
            arg: this.localName,
            coderType: "address",
            value: d.hexlify(e.slice(t, t + 32))
          }), {
            consumed: 32,
            value: this.coerceFunc("address", c.getAddress(d.hexlify(e.slice(t + 12, t + 32))))
          };
        }, j);

        function j(e, t) {
          return O.call(this, e, "address", "address", t, !1) || this;
        }

        function G(e) {
          var t = 32 * Math.ceil(e.length / 32),
              a = new Uint8Array(t - e.length);
          return d.concat([W.encode(e.length), e, a]);
        }

        function V(e, t, a) {
          e.length < t + 32 && i.throwError("insufficient data for dynamicBytes length", i.INVALID_ARGUMENT, {
            arg: a,
            coderType: "dynamicBytes",
            value: d.hexlify(e.slice(t, t + 32))
          });
          var r = W.decode(e, t).value;

          try {
            r = r.toNumber();
          } catch (e) {
            i.throwError("dynamic bytes count too large", i.INVALID_ARGUMENT, {
              arg: a,
              coderType: "dynamicBytes",
              value: r.toString()
            });
          }

          return e.length < t + 32 + r && i.throwError("insufficient data for dynamicBytes type", i.INVALID_ARGUMENT, {
            arg: a,
            coderType: "dynamicBytes",
            value: d.hexlify(e.slice(t, t + 32 + r))
          }), {
            consumed: 32 + 32 * Math.ceil(r / 32),
            value: e.slice(t + 32, t + 32 + r)
          };
        }

        var U,
            H = (n(z, U = A), z.prototype.encode = function (e) {
          try {
            return G(d.arrayify(e));
          } catch (e) {
            i.throwError("invalid bytes value", i.INVALID_ARGUMENT, {
              arg: this.localName,
              coderType: "bytes",
              value: e.value
            });
          }

          return null;
        }, z.prototype.decode = function (e, t) {
          var a = V(e, t, this.localName);
          return a.value = this.coerceFunc("bytes", d.hexlify(a.value)), a;
        }, z);

        function z(e, t) {
          return U.call(this, e, "bytes", "bytes", t, !0) || this;
        }

        var K,
            q = (n(Y, K = A), Y.prototype.encode = function (e) {
          return "string" != typeof e && i.throwError("invalid string value", i.INVALID_ARGUMENT, {
            arg: this.localName,
            coderType: "string",
            value: e
          }), G(f.toUtf8Bytes(e));
        }, Y.prototype.decode = function (e, t) {
          var a = V(e, t, this.localName);
          return a.value = this.coerceFunc("string", f.toUtf8String(a.value)), a;
        }, Y);

        function Y(e, t) {
          return K.call(this, e, "string", "string", t, !0) || this;
        }

        function Z(e) {
          return 32 * Math.ceil(e / 32);
        }

        function J(e, t) {
          if (Array.isArray(t)) ;else if (t && "object" == typeof t) {
            var a = [];
            e.forEach(function (e) {
              a.push(t[e.localName]);
            }), t = a;
          } else i.throwError("invalid tuple value", i.INVALID_ARGUMENT, {
            coderType: "tuple",
            value: t
          });
          e.length !== t.length && i.throwError("types/value length mismatch", i.INVALID_ARGUMENT, {
            coderType: "tuple",
            value: t
          });
          var r = [];
          e.forEach(function (e, a) {
            r.push({
              dynamic: e.dynamic,
              value: e.encode(t[a])
            });
          });
          var n = 0,
              s = 0;
          r.forEach(function (e) {
            e.dynamic ? (n += 32, s += Z(e.value.length)) : n += Z(e.value.length);
          });
          var o = 0,
              c = n,
              u = new Uint8Array(n + s);
          return r.forEach(function (e) {
            e.dynamic ? (u.set(W.encode(c), o), o += 32, u.set(e.value, c), c += Z(e.value.length)) : (u.set(e.value, o), o += Z(e.value.length));
          }), u;
        }

        function X(e, t, a) {
          var r = a,
              n = 0,
              s = [];
          return e.forEach(function (e) {
            if (e.dynamic) {
              var o = W.decode(t, a);
              (i = e.decode(t, r + o.value.toNumber())).consumed = o.consumed;
            } else var i = e.decode(t, a);

            null != i.value && s.push(i.value), a += i.consumed, n += i.consumed;
          }), e.forEach(function (e, t) {
            var a = e.localName;
            a && ("length" === a && (a = "_length"), null == s[a] && (s[a] = s[t]));
          }), {
            value: s,
            consumed: n
          };
        }

        var $,
            Q = (n(ee, $ = A), ee.prototype.encode = function (e) {
          Array.isArray(e) || i.throwError("expected array value", i.INVALID_ARGUMENT, {
            arg: this.localName,
            coderType: "array",
            value: e
          });
          var t = this.length,
              a = new Uint8Array(0);
          -1 === t && (t = e.length, a = W.encode(t)), i.checkArgumentCount(t, e.length, " in coder array" + (this.localName ? " " + this.localName : ""));

          for (var r = [], n = 0; n < e.length; n++) {
            r.push(this.coder);
          }

          return d.concat([a, J(r, e)]);
        }, ee.prototype.decode = function (e, t) {
          var a = 0,
              r = this.length;

          if (-1 === r) {
            try {
              var n = W.decode(e, t);
            } catch (e) {
              i.throwError("insufficient data for dynamic array length", i.INVALID_ARGUMENT, {
                arg: this.localName,
                coderType: "array",
                value: e.value
              });
            }

            try {
              r = n.value.toNumber();
            } catch (e) {
              i.throwError("array count too large", i.INVALID_ARGUMENT, {
                arg: this.localName,
                coderType: "array",
                value: n.value.toString()
              });
            }

            a += n.consumed, t += n.consumed;
          }

          for (var s = [], o = 0; o < r; o++) {
            s.push(new T(this.coder));
          }

          var c = X(s, e, t);
          return c.consumed += a, c.value = this.coerceFunc(this.type, c.value), c;
        }, ee);

        function ee(e, t, a, r) {
          var n = this,
              s = t.type + "[" + (0 <= a ? a : "") + "]",
              o = -1 === a || t.dynamic;
          return (n = $.call(this, e, "array", s, r, o) || this).coder = t, n.length = a, n;
        }

        var te,
            ae = (n(re, te = A), re.prototype.encode = function (e) {
          return J(this.coders, e);
        }, re.prototype.decode = function (e, t) {
          var a = X(this.coders, e, t);
          return a.value = this.coerceFunc(this.type, a.value), a;
        }, re);

        function re(e, t, a) {
          var r = this,
              n = !1,
              s = [];
          t.forEach(function (e) {
            e.dynamic && (n = !0), s.push(e.type);
          });
          var o = "tuple(" + s.join(",") + ")";
          return (r = te.call(this, e, "tuple", o, a, n) || this).coders = t, r;
        }

        function ne(e) {
          e = e.trim();

          for (var t = [], a = "", r = 0, n = 0; n < e.length; n++) {
            var s = e[n];
            if ("," === s && 0 === r) t.push(a), a = "";else if (a += s, "(" === s) r++;else if (")" === s && -1 == --r) throw new Error("unbalanced parenthsis");
          }

          return a && t.push(a), t;
        }

        var se = {
          address: F,
          bool: I,
          string: q,
          bytes: H
        };

        function oe(e, t) {
          var a,
              r = se[t.type];
          if (r) return new r(e, t.name);
          if (a = t.type.match(p)) return (0 === (n = parseInt(a[2] || "256")) || 256 < n || n % 8 != 0) && i.throwError("invalid " + a[1] + " bit length", i.INVALID_ARGUMENT, {
            arg: "param",
            value: t
          }), new B(e, n / 8, "int" === a[1], t.name);
          if (a = t.type.match(h)) return (0 === (n = parseInt(a[1])) || 32 < n) && i.throwError("invalid bytes length", i.INVALID_ARGUMENT, {
            arg: "param",
            value: t
          }), new P(e, n, t.name);

          if (a = t.type.match(b)) {
            var n = parseInt(a[2] || "-1");
            return (t = l.shallowCopy(t)).type = a[1], t = l.deepCopy(t), new Q(e, oe(e, t), n, t.name);
          }

          return "tuple" === t.type.substring(0, 5) ? function (e, t, a) {
            var r = [];
            return (t = t || []).forEach(function (t) {
              r.push(oe(e, t));
            }), new ae(e, r, a);
          }(e, t.components, t.name) : "" === t.type ? new C(e, t.name) : (i.throwError("invalid type", i.INVALID_ARGUMENT, {
            arg: "type",
            value: t.type
          }), null);
        }

        var ie = (ce.prototype.encode = function (e, t) {
          e.length !== t.length && i.throwError("types/values length mismatch", i.INVALID_ARGUMENT, {
            count: {
              types: e.length,
              values: t.length
            },
            value: {
              types: e,
              values: t
            }
          });
          var a = [];
          return e.forEach(function (e) {
            var t;
            t = "string" == typeof e ? _(e) : e, a.push(oe(this.coerceFunc, t));
          }, this), d.hexlify(new ae(this.coerceFunc, a, "_").encode(t));
        }, ce.prototype.decode = function (e, t) {
          var a = [];
          return e.forEach(function (e) {
            var t;
            t = "string" == typeof e ? _(e) : l.deepCopy(e), a.push(oe(this.coerceFunc, t));
          }, this), new ae(this.coerceFunc, a, "_").decode(d.arrayify(t), 0).value;
        }, ce);

        function ce(e) {
          i.checkNew(this, ce), e = e || a.defaultCoerceFunc, l.defineReadOnly(this, "coerceFunc", e);
        }

        a.AbiCoder = ie, a.defaultAbiCoder = new ie();
      }, {
        "../constants": 3,
        "../errors": 5,
        "./address": 59,
        "./bignumber": 62,
        "./bytes": 63,
        "./properties": 73,
        "./utf8": 84
      }],
      59: [function (e, t, a) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var n = r(e("bn.js")),
            s = e("./bytes"),
            o = e("./keccak256"),
            i = e("./rlp"),
            c = e("../errors");

        function u(e) {
          "string" == typeof e && e.match(/^0x[0-9A-Fa-f]{40}$/) || c.throwError("invalid address", c.INVALID_ARGUMENT, {
            arg: "address",
            value: e
          });

          for (var t = (e = e.toLowerCase()).substring(2).split(""), a = new Uint8Array(40), r = 0; r < 40; r++) {
            a[r] = t[r].charCodeAt(0);
          }

          a = s.arrayify(o.keccak256(a));

          for (var n = 0; n < 40; n += 2) {
            8 <= a[n >> 1] >> 4 && (t[n] = t[n].toUpperCase()), 8 <= (15 & a[n >> 1]) && (t[n + 1] = t[n + 1].toUpperCase());
          }

          return "0x" + t.join("");
        }

        for (var d = {}, f = 0; f < 10; f++) {
          d[String(f)] = String(f);
        }

        for (f = 0; f < 26; f++) {
          d[String.fromCharCode(65 + f)] = String(10 + f);
        }

        var l,
            h = Math.floor((l = 9007199254740991, Math.log10 ? Math.log10(l) : Math.log(l) / Math.LN10));

        function p(e) {
          e = (e = e.toUpperCase()).substring(4) + e.substring(0, 2) + "00";
          var t = "";

          for (e.split("").forEach(function (e) {
            t += d[e];
          }); t.length >= h;) {
            var a = t.substring(0, h);
            t = parseInt(a, 10) % 97 + t.substring(a.length);
          }

          for (var r = String(98 - parseInt(t, 10) % 97); r.length < 2;) {
            r = "0" + r;
          }

          return r;
        }

        function b(e) {
          var t = null;
          if ("string" != typeof e && c.throwError("invalid address", c.INVALID_ARGUMENT, {
            arg: "address",
            value: e
          }), e.match(/^(0x)?[0-9a-fA-F]{40}$/)) "0x" !== e.substring(0, 2) && (e = "0x" + e), t = u(e), e.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && t !== e && c.throwError("bad address checksum", c.INVALID_ARGUMENT, {
            arg: "address",
            value: e
          });else if (e.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
            for (e.substring(2, 4) !== p(e) && c.throwError("bad icap checksum", c.INVALID_ARGUMENT, {
              arg: "address",
              value: e
            }), t = new n.default.BN(e.substring(4), 36).toString(16); t.length < 40;) {
              t = "0" + t;
            }

            t = u("0x" + t);
          } else c.throwError("invalid address", c.INVALID_ARGUMENT, {
            arg: "address",
            value: e
          });
          return t;
        }

        a.getAddress = b, a.getIcapAddress = function (e) {
          for (var t = new n.default.BN(b(e).substring(2), 16).toString(36).toUpperCase(); t.length < 30;) {
            t = "0" + t;
          }

          return "XE" + p("XE00" + t) + t;
        }, a.getContractAddress = function (e) {
          if (!e.from) throw new Error("missing from address");
          var t = e.nonce;
          return b("0x" + o.keccak256(i.encode([b(e.from), s.stripZeros(s.hexlify(t))])).substring(26));
        };
      }, {
        "../errors": 5,
        "./bytes": 63,
        "./keccak256": 70,
        "./rlp": 75,
        "bn.js": 9
      }],
      60: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var r = e("../utils/bytes");
        t.exports = {
          decode: function decode(e) {
            e = atob(e);

            for (var t = [], a = 0; a < e.length; a++) {
              t.push(e.charCodeAt(a));
            }

            return r.arrayify(t);
          },
          encode: function encode(e) {
            e = r.arrayify(e);

            for (var t = "", a = 0; a < e.length; a++) {
              t += String.fromCharCode(e[a]);
            }

            return btoa(t);
          }
        };
      }, {
        "../utils/bytes": 63
      }],
      61: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var r = e("./bytes"),
            n = e("./properties"),
            s = (o.prototype.encode = function (e) {
          var t = r.arrayify(e);
          if (0 === t.length) return "";

          for (var a = [0], n = 0; n < t.length; ++n) {
            for (var s = t[n], o = 0; o < a.length; ++o) {
              s += a[o] << 8, a[o] = s % this.base, s = s / this.base | 0;
            }

            for (; 0 < s;) {
              a.push(s % this.base), s = s / this.base | 0;
            }
          }

          for (var i = "", c = 0; 0 === t[c] && c < t.length - 1; ++c) {
            i += this._leader;
          }

          for (var u = a.length - 1; 0 <= u; --u) {
            i += this.alphabet[a[u]];
          }

          return i;
        }, o.prototype.decode = function (e) {
          if ("string" != typeof e) throw new TypeError("Expected String");
          var t = [];
          if (0 === e.length) return new Uint8Array(t);
          t.push(0);

          for (var a = 0; a < e.length; a++) {
            var n = this._alphabetMap[e[a]];
            if (void 0 === n) throw new Error("Non-base" + this.base + " character");

            for (var s = n, o = 0; o < t.length; ++o) {
              s += t[o] * this.base, t[o] = 255 & s, s >>= 8;
            }

            for (; 0 < s;) {
              t.push(255 & s), s >>= 8;
            }
          }

          for (var i = 0; e[i] === this._leader && i < e.length - 1; ++i) {
            t.push(0);
          }

          return r.arrayify(new Uint8Array(t.reverse()));
        }, o);

        function o(e) {
          n.defineReadOnly(this, "alphabet", e), n.defineReadOnly(this, "base", e.length), n.defineReadOnly(this, "_alphabetMap", {}), n.defineReadOnly(this, "_leader", e.charAt(0));

          for (var t = 0; t < e.length; t++) {
            this._alphabetMap[e.charAt(t)] = t;
          }
        }

        var i = new (a.BaseX = s)("abcdefghijklmnopqrstuvwxyz234567");
        a.Base32 = i;
        var c = new s("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
        a.Base58 = c;
      }, {
        "./bytes": 63,
        "./properties": 73
      }],
      62: [function (e, t, a) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        },
            n = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var s = r(e("bn.js")),
            o = e("./bytes"),
            i = e("./properties"),
            c = n(e("../errors")),
            u = new s.default.BN(-1);

        function d(e) {
          var t = e.toString(16);
          return "-" === t[0] ? t.length % 2 == 0 ? "-0x0" + t.substring(1) : "-0x" + t.substring(1) : t.length % 2 == 1 ? "0x0" + t : "0x" + t;
        }

        function f(e) {
          return h(m(e));
        }

        function l(e) {
          return new p(d(e));
        }

        function h(e) {
          var t = e._hex;
          return "-" === t[0] ? new s.default.BN(t.substring(3), 16).mul(u) : new s.default.BN(t.substring(2), 16);
        }

        var p = (b.prototype.fromTwos = function (e) {
          return l(h(this).fromTwos(e));
        }, b.prototype.toTwos = function (e) {
          return l(h(this).toTwos(e));
        }, b.prototype.abs = function () {
          return "-" === this._hex[0] ? l(h(this).mul(u)) : this;
        }, b.prototype.add = function (e) {
          return l(h(this).add(f(e)));
        }, b.prototype.sub = function (e) {
          return l(h(this).sub(f(e)));
        }, b.prototype.div = function (e) {
          return m(e).isZero() && c.throwError("division by zero", c.NUMERIC_FAULT, {
            operation: "divide",
            fault: "division by zero"
          }), l(h(this).div(f(e)));
        }, b.prototype.mul = function (e) {
          return l(h(this).mul(f(e)));
        }, b.prototype.mod = function (e) {
          return l(h(this).mod(f(e)));
        }, b.prototype.pow = function (e) {
          return l(h(this).pow(f(e)));
        }, b.prototype.maskn = function (e) {
          return l(h(this).maskn(e));
        }, b.prototype.eq = function (e) {
          return h(this).eq(f(e));
        }, b.prototype.lt = function (e) {
          return h(this).lt(f(e));
        }, b.prototype.lte = function (e) {
          return h(this).lte(f(e));
        }, b.prototype.gt = function (e) {
          return h(this).gt(f(e));
        }, b.prototype.gte = function (e) {
          return h(this).gte(f(e));
        }, b.prototype.isZero = function () {
          return h(this).isZero();
        }, b.prototype.toNumber = function () {
          try {
            return h(this).toNumber();
          } catch (e) {
            c.throwError("overflow", c.NUMERIC_FAULT, {
              operation: "setValue",
              fault: "overflow",
              details: e.message
            });
          }

          return null;
        }, b.prototype.toString = function () {
          return h(this).toString(10);
        }, b.prototype.toHexString = function () {
          return this._hex;
        }, b.isBigNumber = function (e) {
          return i.isType(e, "BigNumber");
        }, b);

        function b(e) {
          if (c.checkNew(this, b), i.setType(this, "BigNumber"), "string" == typeof e) o.isHexString(e) ? ("0x" == e && (e = "0x0"), i.defineReadOnly(this, "_hex", e)) : "-" === e[0] && o.isHexString(e.substring(1)) ? i.defineReadOnly(this, "_hex", e) : e.match(/^-?[0-9]*$/) ? ("" == e && (e = "0"), i.defineReadOnly(this, "_hex", d(new s.default.BN(e)))) : c.throwError("invalid BigNumber string value", c.INVALID_ARGUMENT, {
            arg: "value",
            value: e
          });else if ("number" == typeof e) {
            parseInt(String(e)) !== e && c.throwError("underflow", c.NUMERIC_FAULT, {
              operation: "setValue",
              fault: "underflow",
              value: e,
              outputValue: parseInt(String(e))
            });

            try {
              i.defineReadOnly(this, "_hex", d(new s.default.BN(e)));
            } catch (e) {
              c.throwError("overflow", c.NUMERIC_FAULT, {
                operation: "setValue",
                fault: "overflow",
                details: e.message
              });
            }
          } else e instanceof b ? i.defineReadOnly(this, "_hex", e._hex) : e.toHexString ? i.defineReadOnly(this, "_hex", d(f(e.toHexString()))) : e._hex && o.isHexString(e._hex) ? i.defineReadOnly(this, "_hex", e._hex) : o.isArrayish(e) ? i.defineReadOnly(this, "_hex", d(new s.default.BN(o.hexlify(e).substring(2), 16))) : c.throwError("invalid BigNumber value", c.INVALID_ARGUMENT, {
            arg: "value",
            value: e
          });
        }

        function m(e) {
          return p.isBigNumber(e) ? e : new p(e);
        }

        a.BigNumber = p, a.bigNumberify = m;
      }, {
        "../errors": 5,
        "./bytes": 63,
        "./properties": 73,
        "bn.js": 9
      }],
      63: [function (e, t, a) {
        "use strict";

        var r = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var n = r(e("../errors"));

        function s(e) {
          return !!e.toHexString;
        }

        function o(e) {
          return e.slice || (e.slice = function () {
            var t = Array.prototype.slice.call(arguments);
            return o(new Uint8Array(Array.prototype.slice.apply(e, t)));
          }), e;
        }

        function i(e) {
          if (!e || parseInt(String(e.length)) != e.length || "string" == typeof e) return !1;

          for (var t = 0; t < e.length; t++) {
            var a = e[t];
            if (a < 0 || 256 <= a || parseInt(String(a)) != a) return !1;
          }

          return !0;
        }

        function c(e) {
          if (null == e && n.throwError("cannot convert null value to array", n.INVALID_ARGUMENT, {
            arg: "value",
            value: e
          }), s(e) && (e = e.toHexString()), "string" != typeof e) return i(e) ? o(new Uint8Array(e)) : (n.throwError("invalid arrayify value", null, {
            arg: "value",
            value: e,
            type: typeof e
          }), null);
          var t = e.match(/^(0x)?[0-9a-fA-F]*$/);
          t || n.throwError("invalid hexidecimal string", n.INVALID_ARGUMENT, {
            arg: "value",
            value: e
          }), "0x" !== t[1] && n.throwError("hex string must have 0x prefix", n.INVALID_ARGUMENT, {
            arg: "value",
            value: e
          }), (e = e.substring(2)).length % 2 && (e = "0" + e);

          for (var a = [], r = 0; r < e.length; r += 2) {
            a.push(parseInt(e.substr(r, 2), 16));
          }

          return o(new Uint8Array(a));
        }

        function u(e) {
          for (var t = [], a = 0, r = 0; r < e.length; r++) {
            var n = c(e[r]);
            t.push(n), a += n.length;
          }

          var s = new Uint8Array(a),
              i = 0;

          for (r = 0; r < t.length; r++) {
            s.set(t[r], i), i += t[r].length;
          }

          return o(s);
        }

        function d(e, t) {
          return !("string" != typeof e || !e.match(/^0x[0-9A-Fa-f]*$/) || t && e.length !== 2 + 2 * t);
        }

        a.isHexable = s, a.isArrayish = i, a.arrayify = c, a.concat = u, a.stripZeros = function (e) {
          var t = c(e);
          if (0 === t.length) return t;

          for (var a = 0; 0 === t[a];) {
            a++;
          }

          return a && (t = t.slice(a)), t;
        }, a.padZeros = function (e, t) {
          if (t < (e = c(e)).length) throw new Error("cannot pad");
          var a = new Uint8Array(t);
          return a.set(e, t - e.length), o(a);
        }, a.isHexString = d;
        var f = "0123456789abcdef";

        function l(e) {
          if (s(e)) return e.toHexString();

          if ("number" == typeof e) {
            e < 0 && n.throwError("cannot hexlify negative value", n.INVALID_ARGUMENT, {
              arg: "value",
              value: e
            }), 9007199254740991 <= e && n.throwError("out-of-range", n.NUMERIC_FAULT, {
              operartion: "hexlify",
              fault: "out-of-safe-range"
            });

            for (var t = ""; e;) {
              t = f[15 & e] + t, e = Math.floor(e / 16);
            }

            return t.length ? (t.length % 2 && (t = "0" + t), "0x" + t) : "0x00";
          }

          if ("string" == typeof e) {
            var a = e.match(/^(0x)?[0-9a-fA-F]*$/);
            return a || n.throwError("invalid hexidecimal string", n.INVALID_ARGUMENT, {
              arg: "value",
              value: e
            }), "0x" !== a[1] && n.throwError("hex string must have 0x prefix", n.INVALID_ARGUMENT, {
              arg: "value",
              value: e
            }), e.length % 2 && (e = "0x0" + e.substring(2)), e;
          }

          if (i(e)) {
            for (var r = [], o = 0; o < e.length; o++) {
              var c = e[o];
              r.push(f[(240 & c) >> 4] + f[15 & c]);
            }

            return "0x" + r.join("");
          }

          return n.throwError("invalid hexlify value", null, {
            arg: "value",
            value: e
          }), "never";
        }

        function h(e, t) {
          for (d(e) || n.throwError("invalid hex string", n.INVALID_ARGUMENT, {
            arg: "value",
            value: e
          }); e.length < 2 * t + 2;) {
            e = "0x0" + e.substring(2);
          }

          return e;
        }

        function p(e) {
          var t = 0,
              a = "0x",
              r = "0x";

          if (function (e) {
            return e && null != e.r && null != e.s;
          }(e)) {
            null == e.v && null == e.recoveryParam && n.throwError("at least on of recoveryParam or v must be specified", n.INVALID_ARGUMENT, {
              argument: "signature",
              value: e
            }), a = h(e.r, 32), r = h(e.s, 32), "string" == typeof (t = e.v) && (t = parseInt(t, 16));
            var s = e.recoveryParam;
            null == s && null != e.v && (s = 1 - t % 2), t = 27 + s;
          } else {
            var o = c(e);
            if (65 !== o.length) throw new Error("invalid signature");
            a = l(o.slice(0, 32)), r = l(o.slice(32, 64)), 27 !== (t = o[64]) && 28 !== t && (t = 27 + t % 2);
          }

          return {
            r: a,
            s: r,
            recoveryParam: t - 27,
            v: t
          };
        }

        a.hexlify = l, a.hexDataLength = function (e) {
          return d(e) && e.length % 2 == 0 ? (e.length - 2) / 2 : null;
        }, a.hexDataSlice = function (e, t, a) {
          return d(e) || n.throwError("invalid hex data", n.INVALID_ARGUMENT, {
            arg: "value",
            value: e
          }), e.length % 2 != 0 && n.throwError("hex data length must be even", n.INVALID_ARGUMENT, {
            arg: "value",
            value: e
          }), t = 2 + 2 * t, null != a ? "0x" + e.substring(t, 2 + 2 * a) : "0x" + e.substring(t);
        }, a.hexStripZeros = function (e) {
          for (d(e) || n.throwError("invalid hex string", n.INVALID_ARGUMENT, {
            arg: "value",
            value: e
          }); 3 < e.length && "0x0" === e.substring(0, 3);) {
            e = "0x" + e.substring(3);
          }

          return e;
        }, a.hexZeroPad = h, a.splitSignature = p, a.joinSignature = function (e) {
          return l(u([(e = p(e)).r, e.s, e.recoveryParam ? "0x1c" : "0x1b"]));
        };
      }, {
        "../errors": 5
      }],
      64: [function (e, t, a) {
        "use strict";

        var r = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var n = r(e("../errors")),
            s = e("./bytes"),
            o = e("./utf8"),
            i = e("./keccak256"),
            c = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]),
            u = new RegExp("^((.*)\\.)?([^.]+)$"),
            d = new RegExp("^[a-z0-9.-]*$");
        a.namehash = function (e) {
          "string" != typeof e && n.throwError("invalid address - " + String(e), n.INVALID_ARGUMENT, {
            argument: "name",
            value: e
          }), (e = e.toLowerCase()).match(d) || n.throwError("contains invalid UseSTD3ASCIIRules characters", n.INVALID_ARGUMENT, {
            argument: "name",
            value: e
          });

          for (var t = c; e.length;) {
            var a = e.match(u),
                r = o.toUtf8Bytes(a[3]);
            t = i.keccak256(s.concat([t, i.keccak256(r)])), e = a[2] || "";
          }

          return s.hexlify(t);
        }, a.id = function (e) {
          return i.keccak256(o.toUtf8Bytes(e));
        }, a.hashMessage = function (e) {
          return i.keccak256(s.concat([o.toUtf8Bytes("Ethereum Signed Message:\n"), o.toUtf8Bytes(String(e.length)), "string" == typeof e ? o.toUtf8Bytes(e) : e]));
        };
      }, {
        "../errors": 5,
        "./bytes": 63,
        "./keccak256": 70,
        "./utf8": 84
      }],
      65: [function (e, t, a) {
        "use strict";

        var r = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var n = r(e("../errors")),
            s = e("../wordlists/lang-en"),
            o = e("./basex"),
            i = e("./bytes"),
            c = e("./bignumber"),
            u = e("./utf8"),
            d = e("./pbkdf2"),
            f = e("./hmac"),
            l = e("./properties"),
            h = e("./secp256k1"),
            p = e("./sha2"),
            b = c.bigNumberify("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"),
            m = u.toUtf8Bytes("Bitcoin seed"),
            y = 2147483648;

        function v(e) {
          return (1 << e) - 1 << 8 - e;
        }

        function _(e) {
          return i.hexZeroPad(i.hexlify(e), 32);
        }

        function g(e) {
          var t = i.hexDataSlice(p.sha256(p.sha256(e)), 0, 4);
          return o.Base58.encode(i.concat([e, t]));
        }

        var A = {};
        a.defaultPath = "m/44'/60'/0'/0/0";
        var w = (Object.defineProperty(T.prototype, "extendedKey", {
          get: function get() {
            if (256 <= this.depth) throw new Error("Depth too large!");
            return g(i.concat([null != this.privateKey ? "0x0488ADE4" : "0x0488B21E", i.hexlify(this.depth), this.parentFingerprint, i.hexZeroPad(i.hexlify(this.index), 4), this.chainCode, null != this.privateKey ? i.concat(["0x00", this.privateKey]) : this.publicKey]));
          },
          enumerable: !0,
          configurable: !0
        }), T.prototype.neuter = function () {
          return new T(A, null, this.publicKey, this.parentFingerprint, this.chainCode, this.index, this.depth, null, this.path);
        }, T.prototype._derive = function (e) {
          if (4294967295 < e) throw new Error("invalid index - " + String(e));
          var t = this.path;
          t && (t += "/" + (e & ~y));
          var a = new Uint8Array(37);

          if (e & y) {
            if (!this.privateKey) throw new Error("cannot derive child of neutered node");
            a.set(i.arrayify(this.privateKey), 1), t && (t += "'");
          } else a.set(i.arrayify(this.publicKey));

          for (var r = 24; 0 <= r; r -= 8) {
            a[33 + (r >> 3)] = e >> 24 - r & 255;
          }

          var n = f.computeHmac(f.SupportedAlgorithms.sha512, this.chainCode, a),
              s = n.slice(0, 32),
              o = n.slice(32),
              u = null,
              d = null;
          return this.privateKey ? u = _(c.bigNumberify(s).add(this.privateKey).mod(b)) : d = new h.KeyPair(i.hexlify(s))._addPoint(this.publicKey), new T(A, u, d, this.fingerprint, _(o), e, this.depth + 1, this.mnemonic, t);
        }, T.prototype.derivePath = function (e) {
          var t = e.split("/");
          if (0 === t.length || "m" === t[0] && 0 !== this.depth) throw new Error("invalid path - " + e);
          "m" === t[0] && t.shift();

          for (var a = this, r = 0; r < t.length; r++) {
            var n = t[r];

            if (n.match(/^[0-9]+'$/)) {
              var s = parseInt(n.substring(0, n.length - 1));
              if (y <= s) throw new Error("invalid path index - " + n);
              a = a._derive(y + s);
            } else {
              if (!n.match(/^[0-9]+$/)) throw new Error("invalid path component - " + n);
              if (s = parseInt(n), y <= s) throw new Error("invalid path index - " + n);
              a = a._derive(s);
            }
          }

          return a;
        }, T.isHDNode = function (e) {
          return l.isType(e, "HDNode");
        }, T);

        function T(e, t, a, r, s, o, c, u, d) {
          if (n.checkNew(this, T), e !== A) throw new Error("HDNode constructor cannot be called directly");

          if (t) {
            var f = new h.KeyPair(t);
            l.defineReadOnly(this, "privateKey", f.privateKey), l.defineReadOnly(this, "publicKey", f.compressedPublicKey);
          } else l.defineReadOnly(this, "privateKey", null), l.defineReadOnly(this, "publicKey", i.hexlify(a));

          l.defineReadOnly(this, "parentFingerprint", r), l.defineReadOnly(this, "fingerprint", i.hexDataSlice(p.ripemd160(p.sha256(this.publicKey)), 0, 4)), l.defineReadOnly(this, "address", h.computeAddress(this.publicKey)), l.defineReadOnly(this, "chainCode", s), l.defineReadOnly(this, "index", o), l.defineReadOnly(this, "depth", c), l.defineReadOnly(this, "mnemonic", u), l.defineReadOnly(this, "path", d), l.setType(this, "HDNode");
        }

        function x(e, t) {
          var a = i.arrayify(e);
          if (a.length < 16 || 64 < a.length) throw new Error("invalid seed");
          var r = i.arrayify(f.computeHmac(f.SupportedAlgorithms.sha512, m, a));
          return new w(A, _(r.slice(0, 32)), null, "0x00000000", _(r.slice(32)), 0, 0, t, "m");
        }

        function D(e, t) {
          t = t || "";
          var a = u.toUtf8Bytes("mnemonic" + t, u.UnicodeNormalizationForm.NFKD);
          return i.hexlify(d.pbkdf2(u.toUtf8Bytes(e, u.UnicodeNormalizationForm.NFKD), a, 2048, 64, "sha512"));
        }

        function C(e, t) {
          t = t || s.langEn, n.checkNormalize();
          var a = t.split(e);
          if (a.length % 3 != 0) throw new Error("invalid mnemonic");

          for (var r = i.arrayify(new Uint8Array(Math.ceil(11 * a.length / 8))), o = 0, c = 0; c < a.length; c++) {
            var u = t.getWordIndex(a[c].normalize("NFKD"));
            if (-1 === u) throw new Error("invalid mnemonic");

            for (var d = 0; d < 11; d++) {
              u & 1 << 10 - d && (r[o >> 3] |= 1 << 7 - o % 8), o++;
            }
          }

          var f = 32 * a.length / 3,
              l = v(a.length / 3),
              h = i.arrayify(p.sha256(r.slice(0, f / 8)))[0];
          if ((h &= l) != (r[r.length - 1] & l)) throw new Error("invalid checksum");
          return i.hexlify(r.slice(0, f / 8));
        }

        function S(e, t) {
          if ((e = i.arrayify(e)).length % 4 != 0 || e.length < 16 || 32 < e.length) throw new Error("invalid entropy");

          for (var a = [0], r = 11, n = 0; n < e.length; n++) {
            8 < r ? (a[a.length - 1] <<= 8, a[a.length - 1] |= e[n], r -= 8) : (a[a.length - 1] <<= r, a[a.length - 1] |= e[n] >> 8 - r, a.push(e[n] & (1 << 8 - r) - 1), r += 3);
          }

          var o = i.arrayify(p.sha256(e))[0],
              c = e.length / 4;
          return o &= v(c), a[a.length - 1] <<= c, a[a.length - 1] |= o >> 8 - c, (t = t || s.langEn).join(a.map(function (e) {
            return t.getWord(e);
          }));
        }

        a.HDNode = w, a.fromExtendedKey = function (e) {
          var t = o.Base58.decode(e);
          82 === t.length && g(t.slice(0, 78)) === e || n.throwError("invalid extended key", n.INVALID_ARGUMENT, {
            argument: "extendedKey",
            value: "[REDACTED]"
          });
          var a = t[4],
              r = i.hexlify(t.slice(5, 9)),
              s = parseInt(i.hexlify(t.slice(9, 13)).substring(2), 16),
              c = i.hexlify(t.slice(13, 45)),
              u = t.slice(45, 78);

          switch (i.hexlify(t.slice(0, 4))) {
            case "0x0488b21e":
            case "0x043587cf":
              return new w(A, null, i.hexlify(u), r, c, s, a, null, null);

            case "0x0488ade4":
            case "0x04358394":
              if (0 !== u[0]) break;
              return new w(A, i.hexlify(u.slice(1)), null, r, c, s, a, null, null);
          }

          return n.throwError("invalid extended key", n.INVALID_ARGUMENT, {
            argument: "extendedKey",
            value: "[REDACTED]"
          });
        }, a.fromMnemonic = function (e, t, a) {
          return x(D(e = S(C(e, t), t), a), e);
        }, a.fromSeed = function (e) {
          return x(e, null);
        }, a.mnemonicToSeed = D, a.mnemonicToEntropy = C, a.entropyToMnemonic = S, a.isValidMnemonic = function (e, t) {
          try {
            return C(e, t), !0;
          } catch (e) {}

          return !1;
        };
      }, {
        "../errors": 5,
        "../wordlists/lang-en": 89,
        "./basex": 61,
        "./bignumber": 62,
        "./bytes": 63,
        "./hmac": 66,
        "./pbkdf2": 72,
        "./properties": 73,
        "./secp256k1": 76,
        "./sha2": 78,
        "./utf8": 84
      }],
      66: [function (e, t, a) {
        "use strict";

        var r = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var n,
            s,
            o = r(e("hash.js")),
            i = e("../utils/bytes"),
            c = r(e("../errors"));
        (s = n = a.SupportedAlgorithms || (a.SupportedAlgorithms = {})).sha256 = "sha256", s.sha512 = "sha512", a.computeHmac = function (e, t, a) {
          return n[e] || c.throwError("unsupported algorithm " + e, c.UNSUPPORTED_OPERATION, {
            operation: "hmac",
            algorithm: e
          }), i.arrayify(o.hmac(o[e], i.arrayify(t)).update(i.arrayify(a)).digest());
        };
      }, {
        "../errors": 5,
        "../utils/bytes": 63,
        "hash.js": 27
      }],
      67: [function (e, t, a) {
        "use strict";

        var r = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var n = e("./abi-coder");
        a.AbiCoder = n.AbiCoder, a.defaultAbiCoder = n.defaultAbiCoder, a.formatSignature = n.formatSignature, a.formatParamType = n.formatParamType, a.parseSignature = n.parseSignature, a.parseParamType = n.parseParamType;
        var s = e("./address");
        a.getAddress = s.getAddress, a.getContractAddress = s.getContractAddress, a.getIcapAddress = s.getIcapAddress;
        var o = r(e("./base64"));
        a.base64 = o;
        var i = e("./bignumber");
        a.BigNumber = i.BigNumber, a.bigNumberify = i.bigNumberify;
        var c = e("./bytes");
        a.arrayify = c.arrayify, a.concat = c.concat, a.hexDataSlice = c.hexDataSlice, a.hexDataLength = c.hexDataLength, a.hexlify = c.hexlify, a.hexStripZeros = c.hexStripZeros, a.hexZeroPad = c.hexZeroPad, a.isHexString = c.isHexString, a.joinSignature = c.joinSignature, a.padZeros = c.padZeros, a.splitSignature = c.splitSignature, a.stripZeros = c.stripZeros;
        var u = e("./hash");
        a.hashMessage = u.hashMessage, a.id = u.id, a.namehash = u.namehash;
        var d = r(e("./hdnode"));
        a.HDNode = d;
        var f = e("./interface");
        a.Interface = f.Interface;
        var l = e("./json-wallet");
        a.getJsonWalletAddress = l.getJsonWalletAddress;
        var h = e("./keccak256");
        a.keccak256 = h.keccak256;
        var p = e("./sha2");
        a.sha256 = p.sha256;
        var b = e("./solidity");
        a.solidityKeccak256 = b.keccak256, a.solidityPack = b.pack, a.soliditySha256 = b.sha256;
        var m = e("./random-bytes");
        a.randomBytes = m.randomBytes;
        var y = e("./networks");
        a.getNetwork = y.getNetwork;
        var v = e("./properties");
        a.checkProperties = v.checkProperties, a.deepCopy = v.deepCopy, a.defineReadOnly = v.defineReadOnly, a.resolveProperties = v.resolveProperties, a.shallowCopy = v.shallowCopy;

        var _ = r(e("./rlp"));

        a.RLP = _;
        var g = e("./secp256k1");
        a.computeAddress = g.computeAddress, a.computePublicKey = g.computePublicKey, a.recoverAddress = g.recoverAddress, a.recoverPublicKey = g.recoverPublicKey, a.verifyMessage = g.verifyMessage;
        var A = e("./signing-key");
        a.SigningKey = A.SigningKey;
        var w = e("./transaction");
        a.populateTransaction = w.populateTransaction;
        var T = e("./transaction");
        a.parseTransaction = T.parse, a.serializeTransaction = T.serialize;
        var x = e("./utf8");
        a.formatBytes32String = x.formatBytes32String, a.parseBytes32String = x.parseBytes32String, a.toUtf8Bytes = x.toUtf8Bytes, a.toUtf8String = x.toUtf8String;
        var D = e("./units");
        a.commify = D.commify, a.formatEther = D.formatEther, a.parseEther = D.parseEther, a.formatUnits = D.formatUnits, a.parseUnits = D.parseUnits;
        var C = e("./web");
        a.fetchJson = C.fetchJson, a.poll = C.poll;
        var S = e("./hmac");
        a.SupportedAlgorithms = S.SupportedAlgorithms;
        var E = e("./utf8");
        a.UnicodeNormalizationForm = E.UnicodeNormalizationForm;
        var B = e("./wordlist");
        a.Wordlist = B.Wordlist;
      }, {
        "./abi-coder": 58,
        "./address": 59,
        "./base64": 60,
        "./bignumber": 62,
        "./bytes": 63,
        "./hash": 64,
        "./hdnode": 65,
        "./hmac": 66,
        "./interface": 68,
        "./json-wallet": 69,
        "./keccak256": 70,
        "./networks": 71,
        "./properties": 73,
        "./random-bytes": 74,
        "./rlp": 75,
        "./secp256k1": 76,
        "./sha2": 78,
        "./signing-key": 80,
        "./solidity": 81,
        "./transaction": 82,
        "./units": 83,
        "./utf8": 84,
        "./web": 85,
        "./wordlist": 86
      }],
      68: [function (e, t, a) {
        "use strict";

        var r,
            n = this && this.__extends || (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var a in t) {
            t.hasOwnProperty(a) && (e[a] = t[a]);
          }
        }, function (e, t) {
          function a() {
            this.constructor = e;
          }

          r(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
        }),
            s = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        function o(e) {
          for (var t in p.setType(this, "Description"), e) {
            p.defineReadOnly(this, t, p.deepCopy(e[t], !0));
          }

          Object.freeze(this);
        }

        Object.defineProperty(a, "__esModule", {
          value: !0
        });

        var i,
            c = e("./address"),
            u = e("./abi-coder"),
            d = e("./bignumber"),
            f = e("./bytes"),
            l = e("./hash"),
            h = e("./keccak256"),
            p = e("./properties"),
            b = s(e("../errors")),
            m = function m(e) {
          p.setType(this, "Indexed"), p.defineReadOnly(this, "hash", e);
        },
            y = (n(v, i = o), v.prototype.encode = function (e, t) {
          f.isHexString(e) || b.throwError("invalid contract bytecode", b.INVALID_ARGUMENT, {
            arg: "bytecode",
            value: e
          }), b.checkArgumentCount(t.length, this.inputs.length, " in Interface constructor");

          try {
            return e + u.defaultAbiCoder.encode(this.inputs, t).substring(2);
          } catch (e) {
            b.throwError("invalid constructor argument", b.INVALID_ARGUMENT, {
              arg: e.arg,
              reason: e.reason,
              value: e.value
            });
          }

          return null;
        }, v);

        function v() {
          return null !== i && i.apply(this, arguments) || this;
        }

        var _,
            g = (n(A, _ = o), A.prototype.encode = function (e) {
          b.checkArgumentCount(e.length, this.inputs.length, " in interface function " + this.name);

          try {
            return this.sighash + u.defaultAbiCoder.encode(this.inputs, e).substring(2);
          } catch (e) {
            b.throwError("invalid input argument", b.INVALID_ARGUMENT, {
              arg: e.arg,
              reason: e.reason,
              value: e.value
            });
          }

          return null;
        }, A.prototype.decode = function (e) {
          try {
            return u.defaultAbiCoder.decode(this.outputs, f.arrayify(e));
          } catch (t) {
            b.throwError("invalid data for function output", b.INVALID_ARGUMENT, {
              arg: "data",
              errorArg: t.arg,
              errorValue: t.value,
              value: e,
              reason: t.reason
            });
          }
        }, A);

        function A() {
          return null !== _ && _.apply(this, arguments) || this;
        }

        var w,
            T = (n(x, w = o), x);

        function x() {
          return null !== w && w.apply(this, arguments) || this;
        }

        var D,
            C = (n(S, D = o), S.prototype.encodeTopics = function (e) {
          var t = this;
          e.length > this.inputs.length && b.throwError("too many arguments for " + this.name, b.UNEXPECTED_ARGUMENT, {
            maxCount: e.length,
            expectedCount: this.inputs.length
          });
          var a = [];

          for (this.anonymous || a.push(this.topic), e.forEach(function (e, r) {
            var n = t.inputs[r];
            n.indexed ? null == e ? a.push(null) : "string" === n.type ? a.push(l.id(e)) : "bytes" === n.type ? a.push(h.keccak256(e)) : -1 !== n.type.indexOf("[") || "tuple" === n.type.substring(0, 5) ? b.throwError("filtering with tuples or arrays not implemented yet; bug us on GitHub", b.NOT_IMPLEMENTED, {
              operation: "filter(array|tuple)"
            }) : ("address" === n.type && c.getAddress(e), a.push(f.hexZeroPad(f.hexlify(e), 32).toLowerCase())) : null != e && b.throwError("cannot filter non-indexed parameters; must be null", b.INVALID_ARGUMENT, {
              argument: n.name || r,
              value: e
            });
          }); a.length && null === a[a.length - 1];) {
            a.pop();
          }

          return a;
        }, S.prototype.decode = function (e, t) {
          null == t || this.anonymous || (t = t.slice(1));
          var a = [],
              r = [],
              n = [];
          if (this.inputs.forEach(function (e, t) {
            e.indexed ? "string" === e.type || "bytes" === e.type || 0 <= e.type.indexOf("[") || "tuple" === e.type.substring(0, 5) ? (a.push({
              type: "bytes32",
              name: e.name || ""
            }), n.push(!0)) : (a.push(e), n.push(!1)) : (r.push(e), n.push(!1));
          }), null != t) var s = u.defaultAbiCoder.decode(a, f.concat(t));
          var o = u.defaultAbiCoder.decode(r, f.arrayify(e)),
              i = {},
              c = 0,
              d = 0;
          return this.inputs.forEach(function (e, a) {
            e.indexed ? null == t ? i[a] = new m(null) : n[a] ? i[a] = new m(s[d++]) : i[a] = s[d++] : i[a] = o[c++], e.name && (i[e.name] = i[a]);
          }), i.length = this.inputs.length, new T(i);
        }, S);

        function S() {
          return null !== D && D.apply(this, arguments) || this;
        }

        var E,
            B = (n(k, E = o), k);

        function k() {
          return null !== E && E.apply(this, arguments) || this;
        }

        var R,
            W = (n(I, R = o), I);

        function I() {
          return null !== R && R.apply(this, arguments) || this;
        }

        function N(e) {
          switch (e.type) {
            case "constructor":
              var t = new y({
                inputs: e.inputs,
                payable: null == e.payable || !!e.payable
              });
              this.deployFunction || (this.deployFunction = t);
              break;

            case "function":
              var a = u.formatSignature(e).replace(/tuple/g, ""),
                  r = l.id(a).substring(0, 10);
              t = new g({
                inputs: e.inputs,
                outputs: e.outputs,
                gas: e.gas,
                payable: null == e.payable || !!e.payable,
                type: e.constant ? "call" : "transaction",
                name: e.name,
                signature: a,
                sighash: r
              }), e.name && (null == this.functions[e.name] ? p.defineReadOnly(this.functions, e.name, t) : b.warn("WARNING: Multiple definitions for " + e.name)), null == this.functions[t.signature] && p.defineReadOnly(this.functions, t.signature, t);
              break;

            case "event":
              a = u.formatSignature(e).replace(/tuple/g, ""), t = new C({
                name: e.name,
                signature: a,
                inputs: e.inputs,
                topic: l.id(a),
                anonymous: !!e.anonymous
              }), e.name && null == this.events[e.name] && p.defineReadOnly(this.events, e.name, t), null == this.events[t.signature] && p.defineReadOnly(this.events, t.signature, t);
              break;

            case "fallback":
              break;

            default:
              b.warn("WARNING: unsupported ABI type - " + e.type);
          }
        }

        var M = (P.prototype.parseTransaction = function (e) {
          var t = e.data.substring(0, 10).toLowerCase();

          for (var a in this.functions) {
            if (-1 !== a.indexOf("(")) {
              var r = this.functions[a];

              if (r.sighash === t) {
                var n = u.defaultAbiCoder.decode(r.inputs, "0x" + e.data.substring(10));
                return new B({
                  args: n,
                  decode: r.decode,
                  name: r.name,
                  signature: r.signature,
                  sighash: r.sighash,
                  value: d.bigNumberify(e.value || "0")
                });
              }
            }
          }

          return null;
        }, P.prototype.parseLog = function (e) {
          for (var t in this.events) {
            if (-1 !== t.indexOf("(")) {
              var a = this.events[t];
              if (!a.anonymous && a.topic === e.topics[0]) return new W({
                decode: a.decode,
                name: a.name,
                signature: a.signature,
                topic: a.topic,
                values: a.decode(e.data, e.topics)
              });
            }
          }

          return null;
        }, P.isInterface = function (e) {
          return p.isType(e, "Interface");
        }, P.isIndexed = function (e) {
          return p.isType(e, "Indexed");
        }, P);

        function P(e) {
          if (b.checkNew(this, P), "string" == typeof e) {
            try {
              e = JSON.parse(e);
            } catch (t) {
              b.throwError("could not parse ABI JSON", b.INVALID_ARGUMENT, {
                arg: "abi",
                errorMessage: t.message,
                value: e
              });
            }

            if (!Array.isArray(e)) return b.throwError("invalid abi", b.INVALID_ARGUMENT, {
              arg: "abi",
              value: e
            }), null;
          }

          p.defineReadOnly(this, "functions", {}), p.defineReadOnly(this, "events", {});
          var t = [];
          e.forEach(function (e) {
            "string" == typeof e && (e = u.parseSignature(e)), t.push(e);
          }), p.defineReadOnly(this, "abi", p.deepCopy(t, !0)), t.forEach(N, this), this.deployFunction || N.call(this, {
            type: "constructor",
            inputs: []
          }), p.setType(this, "Interface");
        }

        a.Interface = M;
      }, {
        "../errors": 5,
        "./abi-coder": 58,
        "./address": 59,
        "./bignumber": 62,
        "./bytes": 63,
        "./hash": 64,
        "./keccak256": 70,
        "./properties": 73
      }],
      69: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var r = e("./address");

        function n(e) {
          try {
            var t = JSON.parse(e);
          } catch (e) {
            return !1;
          }

          return t.encseed && t.ethaddr;
        }

        function s(e) {
          try {
            var t = JSON.parse(e);
          } catch (e) {
            return !1;
          }

          return !(!t.version || parseInt(t.version) !== t.version || 3 !== parseInt(t.version));
        }

        a.isCrowdsaleWallet = n, a.isSecretStorageWallet = s, a.getJsonWalletAddress = function (e) {
          if (n(e)) try {
            return r.getAddress(JSON.parse(e).ethaddr);
          } catch (e) {
            return null;
          }
          if (s(e)) try {
            return r.getAddress(JSON.parse(e).address);
          } catch (e) {
            return null;
          }
          return null;
        };
      }, {
        "./address": 59
      }],
      70: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var r = e("js-sha3"),
            n = e("./bytes");

        a.keccak256 = function (e) {
          return "0x" + r.keccak_256(n.arrayify(e));
        };
      }, {
        "./bytes": 63,
        "js-sha3": 40
      }],
      71: [function (e, t, a) {
        "use strict";

        var r = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var n = r(e("../errors"));

        function s(e) {
          return function (t) {
            var a = [];
            return t.InfuraProvider && a.push(new t.InfuraProvider(e)), t.EtherscanProvider && a.push(new t.EtherscanProvider(e)), 0 === a.length ? null : t.FallbackProvider ? new t.FallbackProvider(a) : a[0];
          };
        }

        function o(e, t) {
          return function (a) {
            return a.JsonRpcProvider ? new a.JsonRpcProvider(e, t) : null;
          };
        }

        var i = {
          chainId: 1,
          ensAddress: "0x314159265dd8dbb310642f98f50c066173c1259b",
          name: "homestead",
          _defaultProvider: s("homestead")
        },
            c = {
          chainId: 3,
          ensAddress: "0x112234455c3a32fd11230c42e7bccd4a84e02010",
          name: "ropsten",
          _defaultProvider: s("ropsten")
        },
            u = {
          unspecified: {
            chainId: 0,
            name: "unspecified"
          },
          homestead: i,
          mainnet: i,
          morden: {
            chainId: 2,
            name: "morden"
          },
          ropsten: c,
          testnet: c,
          rinkeby: {
            chainId: 4,
            ensAddress: "0xe7410170f87102DF0055eB195163A03B7F2Bff4A",
            name: "rinkeby",
            _defaultProvider: s("rinkeby")
          },
          goerli: {
            chainId: 5,
            ensAddress: "0x112234455c3a32fd11230c42e7bccd4a84e02010",
            name: "goerli",
            _defaultProvider: s("goerli")
          },
          kovan: {
            chainId: 42,
            name: "kovan",
            _defaultProvider: s("kovan")
          },
          classic: {
            chainId: 61,
            name: "classic",
            _defaultProvider: o("https://web3.gastracker.io", "classic")
          },
          classicTestnet: {
            chainId: 62,
            name: "classicTestnet",
            _defaultProvider: o("https://web3.gastracker.io/morden", "classicTestnet")
          }
        };

        a.getNetwork = function (e) {
          if (null == e) return null;

          if ("number" == typeof e) {
            for (var t in u) {
              var a = u[t];
              if (a.chainId === e) return {
                name: a.name,
                chainId: a.chainId,
                ensAddress: a.ensAddress || null,
                _defaultProvider: a._defaultProvider || null
              };
            }

            return {
              chainId: e,
              name: "unknown"
            };
          }

          if ("string" == typeof e) {
            var r = u[e];
            return null == r ? null : {
              name: r.name,
              chainId: r.chainId,
              ensAddress: r.ensAddress,
              _defaultProvider: r._defaultProvider || null
            };
          }

          var s = u[e.name];
          return s ? (0 !== e.chainId && e.chainId !== s.chainId && n.throwError("network chainId mismatch", n.INVALID_ARGUMENT, {
            arg: "network",
            value: e
          }), {
            name: e.name,
            chainId: s.chainId,
            ensAddress: e.ensAddress || s.ensAddress || null,
            _defaultProvider: e._defaultProvider || s._defaultProvider || null
          }) : ("number" != typeof e.chainId && n.throwError("invalid network chainId", n.INVALID_ARGUMENT, {
            arg: "network",
            value: e
          }), e);
        };
      }, {
        "../errors": 5
      }],
      72: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var r = e("../utils/bytes"),
            n = e("./hmac");

        a.pbkdf2 = function (e, t, a, s, o) {
          var i;
          e = r.arrayify(e), t = r.arrayify(t);
          var c,
              u,
              d = 1,
              f = new Uint8Array(s),
              l = new Uint8Array(t.length + 4);
          l.set(t);

          for (var h = 1; h <= d; h++) {
            l[t.length] = h >> 24 & 255, l[t.length + 1] = h >> 16 & 255, l[t.length + 2] = h >> 8 & 255, l[t.length + 3] = 255 & h;
            var p = n.computeHmac(o, e, l);
            i || (i = p.length, u = new Uint8Array(i), c = s - ((d = Math.ceil(s / i)) - 1) * i), u.set(p);

            for (var b = 1; b < a; b++) {
              p = n.computeHmac(o, e, p);

              for (var m = 0; m < i; m++) {
                u[m] ^= p[m];
              }
            }

            var y = (h - 1) * i,
                v = h === d ? c : i;
            f.set(r.arrayify(u).slice(0, v), y);
          }

          return r.arrayify(f);
        };
      }, {
        "../utils/bytes": 63,
        "./hmac": 66
      }],
      73: [function (e, t, a) {
        "use strict";

        var r = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var n = r(e("../errors"));

        function s(e, t, a) {
          Object.defineProperty(e, t, {
            enumerable: !0,
            value: a,
            writable: !1
          });
        }

        function o(e, t) {
          return e && e._ethersType === t;
        }

        a.defineReadOnly = s, a.setType = function (e, t) {
          Object.defineProperty(e, "_ethersType", {
            configurable: !1,
            value: t,
            writable: !1
          });
        }, a.isType = o, a.resolveProperties = function (e) {
          var t = {},
              a = [];
          return Object.keys(e).forEach(function (r) {
            var n = e[r];
            n instanceof Promise ? a.push(n.then(function (e) {
              return t[r] = e, null;
            })) : t[r] = n;
          }), Promise.all(a).then(function () {
            return t;
          });
        }, a.checkProperties = function (e, t) {
          e && "object" == typeof e || n.throwError("invalid object", n.INVALID_ARGUMENT, {
            argument: "object",
            value: e
          }), Object.keys(e).forEach(function (a) {
            t[a] || n.throwError("invalid object key - " + a, n.INVALID_ARGUMENT, {
              argument: "transaction",
              value: e,
              key: a
            });
          });
        }, a.shallowCopy = function (e) {
          var t = {};

          for (var a in e) {
            t[a] = e[a];
          }

          return t;
        };
        var i = {
          boolean: !0,
          number: !0,
          string: !0
        };
        a.deepCopy = function e(t, a) {
          if (null == t || i[typeof t]) return t;

          if (Array.isArray(t)) {
            var r = t.map(function (t) {
              return e(t, a);
            });
            return a && Object.freeze(r), r;
          }

          if ("object" == typeof t) {
            if (o(t, "BigNumber")) return t;
            if (o(t, "Description")) return t;
            if (o(t, "Indexed")) return t;

            for (var n in r = {}, t) {
              var c = t[n];
              void 0 !== c && s(r, n, e(c, a));
            }

            return a && Object.freeze(r), r;
          }

          if ("function" == typeof t) return t;
          throw new Error("Cannot deepCopy " + typeof t);
        }, a.inheritable = function e(t) {
          return function (a) {
            !function (e, t) {
              e.super_ = t, e.prototype = Object.create(t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0
                }
              });
            }(a, t), s(a, "inherits", e(a));
          };
        };
      }, {
        "../errors": 5
      }],
      74: [function (e, a, r) {
        (function (t) {
          "use strict";

          Object.defineProperty(r, "__esModule", {
            value: !0
          });
          var a = e("../utils/bytes"),
              n = e("../utils/properties"),
              s = t.crypto || t.msCrypto;

          function o(e) {
            if (e <= 0 || 1024 < e || parseInt(String(e)) != e) throw new Error("invalid length");
            var t = new Uint8Array(e);
            return s.getRandomValues(t), a.arrayify(t);
          }

          s && s.getRandomValues || (console.log("WARNING: Missing strong random number source; using weak randomBytes"), s = {
            getRandomValues: function getRandomValues(e) {
              for (var t = 0; t < 20; t++) {
                for (var a = 0; a < e.length; a++) {
                  t ? e[a] ^= Math.trunc(256 * Math.random()) : e[a] = Math.trunc(256 * Math.random());
                }
              }

              return e;
            },
            _weakCrypto: !0
          }), r.randomBytes = o, !0 === s._weakCrypto && n.defineReadOnly(o, "_weakCrypto", !0);
        }).call(this, void 0 !== t ? t : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
      }, {
        "../utils/bytes": 63,
        "../utils/properties": 73
      }],
      75: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var r = e("./bytes");

        function n(e) {
          for (var t = []; e;) {
            t.unshift(255 & e), e >>= 8;
          }

          return t;
        }

        function s(e, t, a) {
          for (var r = 0, n = 0; n < a; n++) {
            r = 256 * r + e[t + n];
          }

          return r;
        }

        function o(e, t, a, r) {
          for (var n = []; a < t + 1 + r;) {
            var s = i(e, a);
            if (n.push(s.result), t + 1 + r < (a += s.consumed)) throw new Error("invalid rlp");
          }

          return {
            consumed: 1 + r,
            result: n
          };
        }

        function i(e, t) {
          if (0 === e.length) throw new Error("invalid rlp data");

          if (248 <= e[t]) {
            if (t + 1 + (a = e[t] - 247) > e.length) throw new Error("too short");
            if (t + 1 + a + (n = s(e, t + 1, a)) > e.length) throw new Error("to short");
            return o(e, t, t + 1 + a, a + n);
          }

          if (192 <= e[t]) {
            if (t + 1 + (n = e[t] - 192) > e.length) throw new Error("invalid rlp data");
            return o(e, t, t + 1, n);
          }

          if (184 <= e[t]) {
            var a;
            if (t + 1 + (a = e[t] - 183) > e.length) throw new Error("invalid rlp data");
            if (t + 1 + a + (n = s(e, t + 1, a)) > e.length) throw new Error("invalid rlp data");
            return {
              consumed: 1 + a + n,
              result: r.hexlify(e.slice(t + 1 + a, t + 1 + a + n))
            };
          }

          if (128 <= e[t]) {
            var n;
            if (t + 1 + (n = e[t] - 128) > e.length) throw new Error("invalid rlp data");
            return {
              consumed: 1 + n,
              result: r.hexlify(e.slice(t + 1, t + 1 + n))
            };
          }

          return {
            consumed: 1,
            result: r.hexlify(e[t])
          };
        }

        a.encode = function (e) {
          return r.hexlify(function e(t) {
            if (Array.isArray(t)) {
              var a = [];
              return t.forEach(function (t) {
                a = a.concat(e(t));
              }), a.length <= 55 ? (a.unshift(192 + a.length), a) : ((s = n(a.length)).unshift(247 + s.length), s.concat(a));
            }

            var s,
                o = Array.prototype.slice.call(r.arrayify(t));
            return 1 === o.length && o[0] <= 127 ? o : o.length <= 55 ? (o.unshift(128 + o.length), o) : ((s = n(o.length)).unshift(183 + s.length), s.concat(o));
          }(e));
        }, a.decode = function (e) {
          var t = r.arrayify(e),
              a = i(t, 0);
          if (a.consumed !== t.length) throw new Error("invalid rlp data");
          return a.result;
        };
      }, {
        "./bytes": 63
      }],
      76: [function (e, t, a) {
        "use strict";

        var r = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var n = e("elliptic"),
            s = e("./address"),
            o = e("./bytes"),
            i = e("./hash"),
            c = e("./keccak256"),
            u = e("./properties"),
            d = r(e("../errors")),
            f = null;

        function l() {
          return f = f || new n.ec("secp256k1");
        }

        var h = (p.prototype.sign = function (e) {
          var t = l().keyFromPrivate(o.arrayify(this.privateKey)).sign(o.arrayify(e), {
            canonical: !0
          });
          return {
            recoveryParam: t.recoveryParam,
            r: o.hexZeroPad("0x" + t.r.toString(16), 32),
            s: o.hexZeroPad("0x" + t.s.toString(16), 32),
            v: 27 + t.recoveryParam
          };
        }, p.prototype.computeSharedSecret = function (e) {
          var t = l().keyFromPrivate(o.arrayify(this.privateKey)),
              a = l().keyFromPublic(o.arrayify(b(e)));
          return o.hexZeroPad("0x" + t.derive(a.getPublic()).toString(16), 32);
        }, p.prototype._addPoint = function (e) {
          var t = l().keyFromPublic(o.arrayify(this.publicKey)),
              a = l().keyFromPublic(o.arrayify(e));
          return "0x" + t.pub.add(a.pub).encodeCompressed("hex");
        }, p);

        function p(e) {
          var t = l().keyFromPrivate(o.arrayify(e));
          u.defineReadOnly(this, "privateKey", o.hexlify(t.priv.toArray("be", 32))), u.defineReadOnly(this, "publicKey", "0x" + t.getPublic(!1, "hex")), u.defineReadOnly(this, "compressedPublicKey", "0x" + t.getPublic(!0, "hex")), u.defineReadOnly(this, "publicKeyBytes", t.getPublic().encode(null, !0));
        }

        function b(e, t) {
          var a = o.arrayify(e);
          if (32 !== a.length) return 33 === a.length ? t ? o.hexlify(a) : "0x" + l().keyFromPublic(a).getPublic(!1, "hex") : 65 === a.length ? t ? "0x" + l().keyFromPublic(a).getPublic(!0, "hex") : o.hexlify(a) : (d.throwError("invalid public or private key", d.INVALID_ARGUMENT, {
            arg: "key",
            value: "[REDACTED]"
          }), null);
          var r = new h(a);
          return t ? r.compressedPublicKey : r.publicKey;
        }

        function m(e) {
          var t = "0x" + b(e).slice(4);
          return s.getAddress("0x" + c.keccak256(t).substring(26));
        }

        function y(e, t) {
          var a = o.splitSignature(t),
              r = {
            r: o.arrayify(a.r),
            s: o.arrayify(a.s)
          };
          return "0x" + l().recoverPubKey(o.arrayify(e), r, a.recoveryParam).encode("hex", !1);
        }

        function v(e, t) {
          return m(y(o.arrayify(e), t));
        }

        a.KeyPair = h, a.computePublicKey = b, a.computeAddress = m, a.recoverPublicKey = y, a.recoverAddress = v, a.verifyMessage = function (e, t) {
          return v(i.hashMessage(e), t);
        };
      }, {
        "../errors": 5,
        "./address": 59,
        "./bytes": 63,
        "./hash": 64,
        "./keccak256": 70,
        "./properties": 73,
        elliptic: 12
      }],
      77: [function (e, t, a) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        },
            n = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var s = r(e("aes-js")),
            o = r(e("scrypt-js")),
            i = r(e("uuid")),
            c = e("./signing-key"),
            u = n(e("./hdnode")),
            d = e("./address"),
            f = e("./bytes"),
            l = e("./pbkdf2"),
            h = e("./keccak256"),
            p = e("./utf8"),
            b = e("./random-bytes");

        function m(e) {
          return "string" == typeof e && "0x" !== e.substring(0, 2) && (e = "0x" + e), f.arrayify(e);
        }

        function y(e, t) {
          for (e = String(e); e.length < t;) {
            e = "0" + e;
          }

          return e;
        }

        function v(e) {
          return "string" == typeof e ? p.toUtf8Bytes(e, p.UnicodeNormalizationForm.NFKC) : f.arrayify(e);
        }

        function _(e, t) {
          for (var a = e, r = t.toLowerCase().split("/"), n = 0; n < r.length; n++) {
            var s = null;

            for (var o in a) {
              if (o.toLowerCase() === r[n]) {
                s = a[o];
                break;
              }
            }

            if (null === s) return null;
            a = s;
          }

          return a;
        }

        a.decryptCrowdsale = function (e, t) {
          var a = JSON.parse(e);
          t = v(t);
          var r = d.getAddress(_(a, "ethaddr")),
              n = m(_(a, "encseed"));
          if (!n || n.length % 16 != 0) throw new Error("invalid encseed");
          var o = l.pbkdf2(t, t, 2e3, 32, "sha256").slice(0, 16),
              i = n.slice(0, 16),
              u = n.slice(16),
              b = new s.default.ModeOfOperation.cbc(o, i),
              y = f.arrayify(b.decrypt(u));
          y = s.default.padding.pkcs7.strip(y);

          for (var g = "", A = 0; A < y.length; A++) {
            g += String.fromCharCode(y[A]);
          }

          var w = p.toUtf8Bytes(g),
              T = new c.SigningKey(h.keccak256(w));
          if (T.address !== r) throw new Error("corrupt crowdsale wallet");
          return T;
        }, a.decrypt = function (e, t, a) {
          function r(e, t) {
            var a = m(_(n, "crypto/ciphertext"));
            if (f.hexlify(function (e, t) {
              return h.keccak256(f.concat([e, t]));
            }(e.slice(16, 32), a)).substring(2) !== _(n, "crypto/mac").toLowerCase()) return t(new Error("invalid password")), null;

            var r = function (e, t) {
              if ("aes-128-ctr" !== _(n, "crypto/cipher")) return null;
              var a = m(_(n, "crypto/cipherparams/iv")),
                  r = new s.default.Counter(a),
                  o = new s.default.ModeOfOperation.ctr(e, r);
              return f.arrayify(o.decrypt(t));
            }(e.slice(0, 16), a),
                o = e.slice(32, 64);

            if (!r) return t(new Error("unsupported cipher")), null;
            var i = new c.SigningKey(r);
            if (n.address && i.address !== d.getAddress(n.address)) return t(new Error("address mismatch")), null;

            if ("0.1" === _(n, "x-ethers/version")) {
              var l = m(_(n, "x-ethers/mnemonicCiphertext")),
                  p = m(_(n, "x-ethers/mnemonicCounter")),
                  b = new s.default.Counter(p),
                  y = new s.default.ModeOfOperation.ctr(o, b),
                  v = _(n, "x-ethers/path") || u.defaultPath,
                  g = f.arrayify(y.decrypt(l)),
                  A = u.entropyToMnemonic(g),
                  w = u.fromMnemonic(A).derivePath(v);
              if (w.privateKey != f.hexlify(r)) return t(new Error("mnemonic mismatch")), null;
              i = new c.SigningKey(w);
            }

            return i;
          }

          var n = JSON.parse(e),
              i = v(t);
          return new Promise(function (e, t) {
            var s = _(n, "crypto/kdf");

            if (s && "string" == typeof s) {
              if ("scrypt" === s.toLowerCase()) {
                var c = m(_(n, "crypto/kdfparams/salt")),
                    u = parseInt(_(n, "crypto/kdfparams/n")),
                    d = parseInt(_(n, "crypto/kdfparams/r")),
                    h = parseInt(_(n, "crypto/kdfparams/p"));
                if (!u || !d || !h) return void t(new Error("unsupported key-derivation function parameters"));
                if (0 != (u & u - 1)) return void t(new Error("unsupported key-derivation function parameter value for N"));
                if (32 !== (y = parseInt(_(n, "crypto/kdfparams/dklen")))) return void t(new Error("unsupported key-derivation derived-key length"));
                a && a(0), o.default(i, c, u, d, h, 64, function (n, s, o) {
                  if (n) n.progress = s, t(n);else if (o) {
                    var i = r(o = f.arrayify(o), t);
                    if (!i) return;
                    a && a(1), e(i);
                  } else if (a) return a(s);
                });
              } else if ("pbkdf2" === s.toLowerCase()) {
                c = m(_(n, "crypto/kdfparams/salt"));

                var p = null,
                    b = _(n, "crypto/kdfparams/prf");

                if ("hmac-sha256" === b) p = "sha256";else {
                  if ("hmac-sha512" !== b) return void t(new Error("unsupported prf"));
                  p = "sha512";
                }
                var y,
                    v = parseInt(_(n, "crypto/kdfparams/c"));
                if (32 !== (y = parseInt(_(n, "crypto/kdfparams/dklen")))) return void t(new Error("unsupported key-derivation derived-key length"));
                var g = r(l.pbkdf2(i, c, v, y, p), t);
                if (!g) return;
                e(g);
              } else t(new Error("unsupported key-derivation function"));
            } else t(new Error("unsupported key-derivation function"));
          });
        }, a.encrypt = function (e, t, a, r) {
          var n;
          if ("function" != typeof a || r || (r = a, a = {}), a = a || {}, 32 !== (n = c.SigningKey.isSigningKey(e) ? f.arrayify(e.privateKey) : f.arrayify(e)).length) throw new Error("invalid private key");
          var d = v(t),
              l = null;
          if (a.entropy && (l = f.arrayify(a.entropy)), a.mnemonic) if (l) {
            if (u.entropyToMnemonic(l) !== a.mnemonic) throw new Error("entropy and mnemonic mismatch");
          } else l = f.arrayify(u.mnemonicToEntropy(a.mnemonic));
          var p = a.path;
          l && !p && (p = u.defaultPath);
          var m,
              _ = a.client;
          _ = _ || "ethers.js", m = a.salt ? f.arrayify(a.salt) : b.randomBytes(32);
          var g = null;

          if (a.iv) {
            if (16 !== (g = f.arrayify(a.iv)).length) throw new Error("invalid iv");
          } else g = b.randomBytes(16);

          var A = null;

          if (a.uuid) {
            if (16 !== (A = f.arrayify(a.uuid)).length) throw new Error("invalid uuid");
          } else A = b.randomBytes(16);

          var w = 1 << 17,
              T = 8,
              x = 1;
          return a.scrypt && (a.scrypt.N && (w = a.scrypt.N), a.scrypt.r && (T = a.scrypt.r), a.scrypt.p && (x = a.scrypt.p)), new Promise(function (e, t) {
            r && r(0), o.default(d, m, w, T, x, 64, function (a, o, u) {
              if (a) a.progress = o, t(a);else if (u) {
                var d = (u = f.arrayify(u)).slice(0, 16),
                    v = u.slice(16, 32),
                    D = u.slice(32, 64),
                    C = new c.SigningKey(n).address,
                    S = new s.default.Counter(g),
                    E = new s.default.ModeOfOperation.ctr(d, S),
                    B = f.arrayify(E.encrypt(n)),
                    k = h.keccak256(f.concat([v, B])),
                    R = {
                  address: C.substring(2).toLowerCase(),
                  id: i.default.v4({
                    random: A
                  }),
                  version: 3,
                  Crypto: {
                    cipher: "aes-128-ctr",
                    cipherparams: {
                      iv: f.hexlify(g).substring(2)
                    },
                    ciphertext: f.hexlify(B).substring(2),
                    kdf: "scrypt",
                    kdfparams: {
                      salt: f.hexlify(m).substring(2),
                      n: w,
                      dklen: 32,
                      p: x,
                      r: T
                    },
                    mac: k.substring(2)
                  }
                };

                if (l) {
                  var W = b.randomBytes(16),
                      I = new s.default.Counter(W),
                      N = new s.default.ModeOfOperation.ctr(D, I),
                      M = f.arrayify(N.encrypt(l)),
                      P = new Date(),
                      L = P.getUTCFullYear() + "-" + y(P.getUTCMonth() + 1, 2) + "-" + y(P.getUTCDate(), 2) + "T" + y(P.getUTCHours(), 2) + "-" + y(P.getUTCMinutes(), 2) + "-" + y(P.getUTCSeconds(), 2) + ".0Z";
                  R["x-ethers"] = {
                    client: _,
                    gethFilename: "UTC--" + L + "--" + R.address,
                    mnemonicCounter: f.hexlify(W).substring(2),
                    mnemonicCiphertext: f.hexlify(M).substring(2),
                    path: p,
                    version: "0.1"
                  };
                }

                r && r(1), e(JSON.stringify(R));
              } else if (r) return r(o);
            });
          });
        };
      }, {
        "./address": 59,
        "./bytes": 63,
        "./hdnode": 65,
        "./keccak256": 70,
        "./pbkdf2": 72,
        "./random-bytes": 74,
        "./signing-key": 80,
        "./utf8": 84,
        "aes-js": 8,
        "scrypt-js": 43,
        uuid: 47
      }],
      78: [function (e, t, a) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var n = r(e("hash.js")),
            s = e("./bytes");
        a.ripemd160 = function (e) {
          return "0x" + n.default.ripemd160().update(s.arrayify(e)).digest("hex");
        }, a.sha256 = function (e) {
          return "0x" + n.default.sha256().update(s.arrayify(e)).digest("hex");
        }, a.sha512 = function (e) {
          return "0x" + n.default.sha512().update(s.arrayify(e)).digest("hex");
        };
      }, {
        "./bytes": 63,
        "hash.js": 27
      }],
      79: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        }), e("setimmediate"), a.platform = "browser";
      }, {
        setimmediate: 44
      }],
      80: [function (e, t, a) {
        "use strict";

        var r = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var n = e("./hdnode"),
            s = e("./bytes"),
            o = e("./properties"),
            i = e("./secp256k1"),
            c = r(e("../errors")),
            u = (d.prototype.signDigest = function (e) {
          return this.keyPair.sign(e);
        }, d.prototype.computeSharedSecret = function (e) {
          return this.keyPair.computeSharedSecret(s.arrayify(e));
        }, d.isSigningKey = function (e) {
          return o.isType(e, "SigningKey");
        }, d);

        function d(e) {
          var t;
          c.checkNew(this, d), t = n.HDNode.isHDNode(e) ? (o.defineReadOnly(this, "mnemonic", e.mnemonic), o.defineReadOnly(this, "path", e.path), s.arrayify(e.privateKey)) : ("string" == typeof e && e.match(/^[0-9a-f]*$/i) && 64 === e.length && (e = "0x" + e), s.arrayify(e));

          try {
            32 !== t.length && c.throwError("exactly 32 bytes required", c.INVALID_ARGUMENT, {
              arg: "privateKey",
              value: "[REDACTED]"
            });
          } catch (e) {
            var a = {
              arg: "privateKey",
              reason: e.reason,
              value: "[REDACTED]"
            };
            e.value && ("number" == typeof e.value.length && (a.length = e.value.length), a.type = typeof e.value), c.throwError("invalid private key", e.code, a);
          }

          o.defineReadOnly(this, "privateKey", s.hexlify(t)), o.defineReadOnly(this, "keyPair", new i.KeyPair(t)), o.defineReadOnly(this, "publicKey", this.keyPair.publicKey), o.defineReadOnly(this, "address", i.computeAddress(this.keyPair.publicKey)), o.setType(this, "SigningKey");
        }

        a.SigningKey = u;
      }, {
        "../errors": 5,
        "./bytes": 63,
        "./hdnode": 65,
        "./properties": 73,
        "./secp256k1": 76
      }],
      81: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var r = e("./bignumber"),
            n = e("./bytes"),
            s = e("./utf8"),
            o = e("./keccak256"),
            i = e("./sha2"),
            c = new RegExp("^bytes([0-9]+)$"),
            u = new RegExp("^(u?int)([0-9]*)$"),
            d = new RegExp("^(.*)\\[([0-9]*)\\]$"),
            f = "0000000000000000000000000000000000000000000000000000000000000000";

        function l(e, t) {
          if (e.length != t.length) throw new Error("type/value count mismatch");
          var a = [];
          return e.forEach(function (e, o) {
            a.push(function e(t, a, o) {
              switch (t) {
                case "address":
                  return o ? n.padZeros(a, 32) : n.arrayify(a);

                case "string":
                  return s.toUtf8Bytes(a);

                case "bytes":
                  return n.arrayify(a);

                case "bool":
                  return a = a ? "0x01" : "0x00", o ? n.padZeros(a, 32) : n.arrayify(a);
              }

              var i = t.match(u);

              if (i) {
                if ((l = parseInt(i[2] || "256")) % 8 != 0 || 0 === l || 256 < l) throw new Error("invalid number type - " + t);
                return o && (l = 256), a = r.bigNumberify(a).toTwos(l), n.padZeros(a, l / 8);
              }

              if (i = t.match(c)) {
                var l = parseInt(i[1]);
                if (String(l) != i[1] || 0 === l || 32 < l) throw new Error("invalid number type - " + t);
                if (n.arrayify(a).byteLength !== l) throw new Error("invalid value for " + t);
                return o ? n.arrayify((a + f).substring(0, 66)) : a;
              }

              if ((i = t.match(d)) && Array.isArray(a)) {
                var h = i[1];
                if (parseInt(i[2] || String(a.length)) != a.length) throw new Error("invalid value for " + t);
                var p = [];
                return a.forEach(function (t) {
                  p.push(e(h, t, !0));
                }), n.concat(p);
              }

              throw new Error("unknown type - " + t);
            }(e, t[o]));
          }), n.hexlify(n.concat(a));
        }

        a.pack = l, a.keccak256 = function (e, t) {
          return o.keccak256(l(e, t));
        }, a.sha256 = function (e, t) {
          return i.sha256(l(e, t));
        };
      }, {
        "./bignumber": 62,
        "./bytes": 63,
        "./keccak256": 70,
        "./sha2": 78,
        "./utf8": 84
      }],
      82: [function (e, t, a) {
        "use strict";

        var r = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var n = e("../constants"),
            s = r(e("../errors")),
            o = e("./secp256k1"),
            i = e("./address"),
            c = e("./bignumber"),
            u = e("./bytes"),
            d = e("./keccak256"),
            f = e("./properties"),
            l = r(e("./rlp")),
            h = e("../providers/abstract-provider");

        function p(e) {
          return "0x" === e ? n.Zero : c.bigNumberify(e);
        }

        var b = [{
          name: "nonce",
          maxLength: 32
        }, {
          name: "gasPrice",
          maxLength: 32
        }, {
          name: "gasLimit",
          maxLength: 32
        }, {
          name: "to",
          length: 20
        }, {
          name: "value",
          maxLength: 32
        }, {
          name: "data"
        }],
            m = {
          chainId: !0,
          data: !0,
          gasLimit: !0,
          gasPrice: !0,
          nonce: !0,
          to: !0,
          value: !0
        };
        a.serialize = function (e, t) {
          f.checkProperties(e, m);
          var a = [];
          b.forEach(function (t) {
            var r = e[t.name] || [];
            r = u.arrayify(u.hexlify(r)), t.length && r.length !== t.length && 0 < r.length && s.throwError("invalid length for " + t.name, s.INVALID_ARGUMENT, {
              arg: "transaction" + t.name,
              value: r
            }), t.maxLength && (r = u.stripZeros(r)).length > t.maxLength && s.throwError("invalid length for " + t.name, s.INVALID_ARGUMENT, {
              arg: "transaction" + t.name,
              value: r
            }), a.push(u.hexlify(r));
          }), null != e.chainId && 0 !== e.chainId && (a.push(u.hexlify(e.chainId)), a.push("0x"), a.push("0x"));
          var r = l.encode(a);
          if (!t) return r;
          var n = u.splitSignature(t),
              o = 27 + n.recoveryParam;
          return 9 === a.length && (a.pop(), a.pop(), a.pop(), o += 2 * e.chainId + 8), a.push(u.hexlify(o)), a.push(u.stripZeros(u.arrayify(n.r))), a.push(u.stripZeros(u.arrayify(n.s))), l.encode(a);
        }, a.parse = function (e) {
          var t = l.decode(e);
          9 !== t.length && 6 !== t.length && s.throwError("invalid raw transaction", s.INVALID_ARGUMENT, {
            arg: "rawTransactin",
            value: e
          });
          var a = {
            nonce: p(t[0]).toNumber(),
            gasPrice: p(t[1]),
            gasLimit: p(t[2]),
            to: function (e) {
              return "0x" === e ? null : i.getAddress(e);
            }(t[3]),
            value: p(t[4]),
            data: t[5],
            chainId: 0
          };
          if (6 === t.length) return a;

          try {
            a.v = c.bigNumberify(t[6]).toNumber();
          } catch (e) {
            return s.info(e), a;
          }

          if (a.r = u.hexZeroPad(t[7], 32), a.s = u.hexZeroPad(t[8], 32), c.bigNumberify(a.r).isZero() && c.bigNumberify(a.s).isZero()) a.chainId = a.v, a.v = 0;else {
            a.chainId = Math.floor((a.v - 35) / 2), a.chainId < 0 && (a.chainId = 0);
            var r = a.v - 27,
                n = t.slice(0, 6);
            0 !== a.chainId && (n.push(u.hexlify(a.chainId)), n.push("0x"), n.push("0x"), r -= 2 * a.chainId + 8);
            var f = d.keccak256(l.encode(n));

            try {
              a.from = o.recoverAddress(f, {
                r: u.hexlify(a.r),
                s: u.hexlify(a.s),
                recoveryParam: r
              });
            } catch (e) {
              s.info(e);
            }

            a.hash = d.keccak256(e);
          }
          return a;
        }, a.populateTransaction = function (e, t, a) {
          h.Provider.isProvider(t) || s.throwError("missing provider", s.INVALID_ARGUMENT, {
            argument: "provider",
            value: t
          }), f.checkProperties(e, m);
          var r = f.shallowCopy(e);

          if (null != r.to && (r.to = t.resolveName(r.to)), null == r.gasPrice && (r.gasPrice = t.getGasPrice()), null == r.nonce && (r.nonce = t.getTransactionCount(a)), null == r.gasLimit) {
            var n = f.shallowCopy(r);
            n.from = a, r.gasLimit = t.estimateGas(n);
          }

          return null == r.chainId && (r.chainId = t.getNetwork().then(function (e) {
            return e.chainId;
          })), f.resolveProperties(r);
        };
      }, {
        "../constants": 3,
        "../errors": 5,
        "../providers/abstract-provider": 49,
        "./address": 59,
        "./bignumber": 62,
        "./bytes": 63,
        "./keccak256": 70,
        "./properties": 73,
        "./rlp": 75,
        "./secp256k1": 76
      }],
      83: [function (e, t, a) {
        "use strict";

        var r = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var n,
            s = e("../constants"),
            o = r(e("../errors")),
            i = e("./bignumber"),
            c = {};

        function u(e) {
          return {
            decimals: e.length - 1,
            tenPower: i.bigNumberify(e)
          };
        }

        function d(e) {
          var t = c[String(e).toLowerCase()];

          if (!t && "number" == typeof e && parseInt(String(e)) == e && 0 <= e && e <= 256) {
            for (var a = "1", r = 0; r < e; r++) {
              a += "0";
            }

            t = u(a);
          }

          return t || o.throwError("invalid unitType", o.INVALID_ARGUMENT, {
            argument: "name",
            value: e
          }), t;
        }

        function f(e, t) {
          var a = d(t),
              r = (e = i.bigNumberify(e)).lt(s.Zero);
          r && (e = e.mul(s.NegativeOne));

          for (var n = e.mod(a.tenPower).toString(); n.length < a.decimals;) {
            n = "0" + n;
          }

          return n = n.match(/^([0-9]*[1-9]|0)(0*)/)[1], e = e.div(a.tenPower).toString() + "." + n, r && (e = "-" + e), e;
        }

        function l(e, t) {
          null == t && (t = 18);
          var a = d(t);
          if ("string" == typeof e && e.match(/^-?[0-9.,]+$/) || o.throwError("invalid decimal value", o.INVALID_ARGUMENT, {
            arg: "value",
            value: e
          }), 0 === a.decimals) return i.bigNumberify(e);
          var r = "-" === e.substring(0, 1);
          r && (e = e.substring(1)), "." === e && o.throwError("missing value", o.INVALID_ARGUMENT, {
            arg: "value",
            value: e
          });
          var n = e.split(".");
          2 < n.length && o.throwError("too many decimal points", o.INVALID_ARGUMENT, {
            arg: "value",
            value: e
          });
          var c = n[0],
              u = n[1];

          for (c = c || "0", (u = u || "0").length > a.decimals && o.throwError("underflow occurred", o.NUMERIC_FAULT, {
            operation: "division",
            fault: "underflow"
          }); u.length < a.decimals;) {
            u += "0";
          }

          var f = i.bigNumberify(c),
              l = i.bigNumberify(u),
              h = f.mul(a.tenPower).add(l);
          return r && (h = h.mul(s.NegativeOne)), h;
        }

        n = "1", ["wei", "kwei", "Mwei", "Gwei", "szabo", "finney", "ether"].forEach(function (e) {
          var t = u(n);
          c[e.toLowerCase()] = t, c[String(t.decimals)] = t, n += "000";
        }), a.commify = function (e) {
          var t = String(e).split(".");
          (2 < t.length || !t[0].match(/^-?[0-9]*$/) || t[1] && !t[1].match(/^[0-9]*$/) || "." === e || "-." === e) && o.throwError("invalid value", o.INVALID_ARGUMENT, {
            argument: "value",
            value: e
          });
          var a = t[0],
              r = "";

          for ("-" === a.substring(0, 1) && (r = "-", a = a.substring(1)); "0" === a.substring(0, 1);) {
            a = a.substring(1);
          }

          "" === a && (a = "0");
          var n = "";
          2 === t.length && (n = "." + (t[1] || "0"));

          for (var s = []; a.length;) {
            if (a.length <= 3) {
              s.unshift(a);
              break;
            }

            var i = a.length - 3;
            s.unshift(a.substring(i)), a = a.substring(0, i);
          }

          return r + s.join(",") + n;
        }, a.formatUnits = f, a.parseUnits = l, a.formatEther = function (e) {
          return f(e, 18);
        }, a.parseEther = function (e) {
          return l(e, 18);
        };
      }, {
        "../constants": 3,
        "../errors": 5,
        "./bignumber": 62
      }],
      84: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var r,
            n,
            s = e("../constants"),
            o = e("../errors"),
            i = e("./bytes");

        function c(e, t) {
          void 0 === t && (t = r.current), t != r.current && (o.checkNormalize(), e = e.normalize(t));

          for (var a = [], n = 0; n < e.length; n++) {
            var s = e.charCodeAt(n);
            if (s < 128) a.push(s);else if (s < 2048) a.push(s >> 6 | 192), a.push(63 & s | 128);else if (55296 == (64512 & s)) {
              n++;
              var c = e.charCodeAt(n);
              if (n >= e.length || 56320 != (64512 & c)) throw new Error("invalid utf-8 string");
              s = 65536 + ((1023 & s) << 10) + (1023 & c), a.push(s >> 18 | 240), a.push(s >> 12 & 63 | 128), a.push(s >> 6 & 63 | 128), a.push(63 & s | 128);
            } else a.push(s >> 12 | 224), a.push(s >> 6 & 63 | 128), a.push(63 & s | 128);
          }

          return i.arrayify(a);
        }

        function u(e, t) {
          e = i.arrayify(e);

          for (var a = "", r = 0; r < e.length;) {
            var n = e[r++];

            if (n >> 7 != 0) {
              var s = null,
                  o = null;
              if (192 == (224 & n)) s = 1, o = 127;else if (224 == (240 & n)) s = 2, o = 2047;else {
                if (240 != (248 & n)) {
                  if (t) continue;
                  if (128 == (192 & n)) throw new Error("invalid utf8 byte sequence; unexpected continuation byte");
                  throw new Error("invalid utf8 byte sequence; invalid prefix");
                }

                s = 3, o = 65535;
              }

              if (r + s > e.length) {
                if (!t) throw new Error("invalid utf8 byte sequence; too short");

                for (; r < e.length && e[r] >> 6 == 2; r++) {
                  ;
                }
              } else {
                for (var c = n & (1 << 8 - s - 1) - 1, u = 0; u < s; u++) {
                  var d = e[r];

                  if (128 != (192 & d)) {
                    c = null;
                    break;
                  }

                  c = c << 6 | 63 & d, r++;
                }

                if (null !== c) {
                  if (c <= o) {
                    if (!t) throw new Error("invalid utf8 byte sequence; overlong");
                  } else if (1114111 < c) {
                    if (!t) throw new Error("invalid utf8 byte sequence; out-of-range");
                  } else if (55296 <= c && c <= 57343) {
                    if (!t) throw new Error("invalid utf8 byte sequence; utf-16 surrogate");
                  } else c <= 65535 ? a += String.fromCharCode(c) : (c -= 65536, a += String.fromCharCode(55296 + (c >> 10 & 1023), 56320 + (1023 & c)));
                } else if (!t) throw new Error("invalid utf8 byte sequence; invalid continuation byte");
              }
            } else a += String.fromCharCode(n);
          }

          return a;
        }

        (n = r = a.UnicodeNormalizationForm || (a.UnicodeNormalizationForm = {})).current = "", n.NFC = "NFC", n.NFD = "NFD", n.NFKC = "NFKC", n.NFKD = "NFKD", a.toUtf8Bytes = c, a.toUtf8String = u, a.formatBytes32String = function (e) {
          var t = c(e);
          if (31 < t.length) throw new Error("bytes32 string must be less than 32 bytes");
          return i.hexlify(i.concat([t, s.HashZero]).slice(0, 32));
        }, a.parseBytes32String = function (e) {
          var t = i.arrayify(e);
          if (32 !== t.length) throw new Error("invalid bytes32 - not 32 bytes long");
          if (0 !== t[31]) throw new Error("invalid bytes32 string - no null terminator");

          for (var a = 31; 0 === t[a - 1];) {
            a--;
          }

          return u(t.slice(0, a));
        };
      }, {
        "../constants": 3,
        "../errors": 5,
        "./bytes": 63
      }],
      85: [function (e, t, a) {
        "use strict";

        var r = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var n = e("xmlhttprequest"),
            s = e("./base64"),
            o = e("./properties"),
            i = e("./utf8"),
            c = r(e("../errors"));
        a.fetchJson = function (e, t, a) {
          var r = {},
              o = null,
              u = 12e4;
          if ("string" == typeof e) o = e;else if ("object" == typeof e) {
            if (null == e.url && c.throwError("missing URL", c.MISSING_ARGUMENT, {
              arg: "url"
            }), o = e.url, "number" == typeof e.timeout && 0 < e.timeout && (u = e.timeout), e.headers) for (var d in e.headers) {
              r[d.toLowerCase()] = {
                key: d,
                value: String(e.headers[d])
              };
            }

            if (null != e.user && null != e.password) {
              "https:" !== o.substring(0, 6) && !0 !== e.allowInsecure && c.throwError("basic authentication requires a secure https url", c.INVALID_ARGUMENT, {
                arg: "url",
                url: o,
                user: e.user,
                password: "[REDACTED]"
              });
              var f = e.user + ":" + e.password;
              r.authorization = {
                key: "Authorization",
                value: "Basic " + s.encode(i.toUtf8Bytes(f))
              };
            }
          }
          return new Promise(function (e, s) {
            var i = new n.XMLHttpRequest(),
                c = null;

            function d() {
              null != c && (clearTimeout(c), c = null);
            }

            c = setTimeout(function () {
              null != c && (c = null, s(new Error("timeout")), setTimeout(function () {
                i.abort();
              }, 0));
            }, u), t ? (i.open("POST", o, !0), r["content-type"] = {
              key: "Content-Type",
              value: "application/json"
            }) : i.open("GET", o, !0), Object.keys(r).forEach(function (e) {
              var t = r[e];
              i.setRequestHeader(t.key, t.value);
            }), i.onreadystatechange = function () {
              if (4 === i.readyState) {
                if (200 != i.status) {
                  d();
                  var r = new Error("invalid response - " + i.status);
                  return r.statusCode = i.status, i.responseText && (r.responseText = i.responseText), void s(r);
                }

                var n = null;

                try {
                  n = JSON.parse(i.responseText);
                } catch (r) {
                  d();
                  var c = new Error("invalid json response");
                  return c.orginialError = r, c.responseText = i.responseText, null != t && (c.requestBody = t), c.url = o, void s(c);
                }

                if (a) try {
                  n = a(n);
                } catch (r) {
                  return d(), r.url = o, r.body = t, r.responseText = i.responseText, void s(r);
                }
                d(), e(n);
              }
            }, i.onerror = function (e) {
              d(), s(e);
            };

            try {
              null != t ? i.send(t) : i.send();
            } catch (c) {
              d();
              var f = new Error("connection error");
              f.error = c, s(f);
            }
          });
        }, a.poll = function (e, t) {
          return t = t || {}, null == (t = o.shallowCopy(t)).floor && (t.floor = 0), null == t.ceiling && (t.ceiling = 1e4), null == t.interval && (t.interval = 250), new Promise(function (a, r) {
            var n = null,
                s = !1,
                o = function o() {
              return !s && (s = !0, n && clearTimeout(n), !0);
            };

            t.timeout && (n = setTimeout(function () {
              o() && r(new Error("timeout"));
            }, t.timeout));
            var i = t.fastRetry || null,
                c = 0;
            !function n() {
              return e().then(function (e) {
                if (void 0 !== e) o() && a(e);else if (t.onceBlock) t.onceBlock.once("block", n);else if (!s) {
                  c++;
                  var r = t.interval * parseInt(String(Math.random() * Math.pow(2, c)));
                  r < t.floor && (r = t.floor), r > t.ceiling && (r = t.ceiling), i && (c--, r = i, i = null), setTimeout(n, r);
                }
                return null;
              }, function (e) {
                o() && r(e);
              });
            }();
          });
        };
      }, {
        "../errors": 5,
        "./base64": 60,
        "./properties": 73,
        "./utf8": 84,
        xmlhttprequest: 48
      }],
      86: [function (e, a, r) {
        (function (t) {
          "use strict";

          Object.defineProperty(r, "__esModule", {
            value: !0
          });
          var a = e("../utils/hash"),
              n = e("../utils/properties");

          r.check = function (e) {
            for (var t = [], r = 0; r < 2048; r++) {
              var n = e.getWord(r);
              if (r !== e.getWordIndex(n)) return "0x";
              t.push(n);
            }

            return a.id(t.join("\n") + "\n");
          };

          var s = (o.prototype.split = function (e) {
            return e.toLowerCase().split(/ +/g);
          }, o.prototype.join = function (e) {
            return e.join(" ");
          }, o);

          function o(e) {
            n.defineReadOnly(this, "locale", e);
          }

          r.Wordlist = s, r.register = function (e, t) {
            t = t || e.locale;
          };
        }).call(this, void 0 !== t ? t : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
      }, {
        "../utils/hash": 64,
        "../utils/properties": 73
      }],
      87: [function (e, t, a) {
        "use strict";

        var r,
            n = this && this.__extends || (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var a in t) {
            t.hasOwnProperty(a) && (e[a] = t[a]);
          }
        }, function (e, t) {
          function a() {
            this.constructor = e;
          }

          r(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
        }),
            s = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });

        var o,
            i = e("./utils/bytes"),
            c = e("./utils/hash"),
            u = e("./utils/hdnode"),
            d = e("./utils/json-wallet"),
            f = e("./utils/keccak256"),
            l = e("./utils/properties"),
            h = e("./utils/random-bytes"),
            p = s(e("./utils/secret-storage")),
            b = e("./utils/signing-key"),
            m = e("./utils/transaction"),
            y = e("./abstract-signer"),
            v = e("./providers/abstract-provider"),
            _ = s(e("./errors")),
            g = (n(A, o = y.Signer), Object.defineProperty(A.prototype, "address", {
          get: function get() {
            return this.signingKey.address;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(A.prototype, "mnemonic", {
          get: function get() {
            return this.signingKey.mnemonic;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(A.prototype, "path", {
          get: function get() {
            return this.signingKey.path;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(A.prototype, "privateKey", {
          get: function get() {
            return this.signingKey.privateKey;
          },
          enumerable: !0,
          configurable: !0
        }), A.prototype.connect = function (e) {
          return v.Provider.isProvider(e) || _.throwError("invalid provider", _.INVALID_ARGUMENT, {
            argument: "provider",
            value: e
          }), new A(this.signingKey, e);
        }, A.prototype.getAddress = function () {
          return Promise.resolve(this.address);
        }, A.prototype.sign = function (e) {
          var t = this;
          return l.resolveProperties(e).then(function (e) {
            var a = m.serialize(e),
                r = t.signingKey.signDigest(f.keccak256(a));
            return m.serialize(e, r);
          });
        }, A.prototype.signMessage = function (e) {
          return Promise.resolve(i.joinSignature(this.signingKey.signDigest(c.hashMessage(e))));
        }, A.prototype.getBalance = function (e) {
          if (!this.provider) throw new Error("missing provider");
          return this.provider.getBalance(this.address, e);
        }, A.prototype.getTransactionCount = function (e) {
          if (!this.provider) throw new Error("missing provider");
          return this.provider.getTransactionCount(this.address, e);
        }, A.prototype.sendTransaction = function (e) {
          var t = this;
          if (!this.provider) throw new Error("missing provider");
          return null == e.nonce && ((e = l.shallowCopy(e)).nonce = this.getTransactionCount("pending")), m.populateTransaction(e, this.provider, this.address).then(function (e) {
            return t.sign(e).then(function (e) {
              return t.provider.sendTransaction(e);
            });
          });
        }, A.prototype.encrypt = function (e, t, a) {
          if ("function" != typeof t || a || (a = t, t = {}), a && "function" != typeof a) throw new Error("invalid callback");
          return t = t || {}, this.mnemonic && ((t = l.shallowCopy(t)).mnemonic = this.mnemonic, t.path = this.path), p.encrypt(this.privateKey, e, t, a);
        }, A.createRandom = function (e) {
          var t = h.randomBytes(16);
          (e = e || {}).extraEntropy && (t = i.arrayify(f.keccak256(i.concat([t, e.extraEntropy])).substring(0, 34)));
          var a = u.entropyToMnemonic(t, e.locale);
          return A.fromMnemonic(a, e.path, e.locale);
        }, A.fromEncryptedJson = function (e, t, a) {
          if (d.isCrowdsaleWallet(e)) try {
            a && a(0);
            var r = p.decryptCrowdsale(e, t);
            return a && a(1), Promise.resolve(new A(r));
          } catch (e) {
            return Promise.reject(e);
          } else if (d.isSecretStorageWallet(e)) return p.decrypt(e, t, a).then(function (e) {
            return new A(e);
          });
          return Promise.reject("invalid wallet JSON");
        }, A.fromMnemonic = function (e, t, a) {
          return t = t || u.defaultPath, new A(u.fromMnemonic(e, a).derivePath(t));
        }, A);

        function A(e, t) {
          var a = o.call(this) || this;
          return _.checkNew(a, A), b.SigningKey.isSigningKey(e) ? l.defineReadOnly(a, "signingKey", e) : l.defineReadOnly(a, "signingKey", new b.SigningKey(e)), l.defineReadOnly(a, "provider", t), a;
        }

        a.Wallet = g;
      }, {
        "./abstract-signer": 2,
        "./errors": 5,
        "./providers/abstract-provider": 49,
        "./utils/bytes": 63,
        "./utils/hash": 64,
        "./utils/hdnode": 65,
        "./utils/json-wallet": 69,
        "./utils/keccak256": 70,
        "./utils/properties": 73,
        "./utils/random-bytes": 74,
        "./utils/secret-storage": 77,
        "./utils/signing-key": 80,
        "./utils/transaction": 82
      }],
      88: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var r = e("../wordlists/lang-en").langEn;
        a.en = r;
      }, {
        "../wordlists/lang-en": 89
      }],
      89: [function (e, t, a) {
        "use strict";

        var r,
            n = this && this.__extends || (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var a in t) {
            t.hasOwnProperty(a) && (e[a] = t[a]);
          }
        }, function (e, t) {
          function a() {
            this.constructor = e;
          }

          r(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
        });
        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var s,
            o = e("../utils/wordlist"),
            i = "AbandonAbilityAbleAboutAboveAbsentAbsorbAbstractAbsurdAbuseAccessAccidentAccountAccuseAchieveAcidAcousticAcquireAcrossActActionActorActressActualAdaptAddAddictAddressAdjustAdmitAdultAdvanceAdviceAerobicAffairAffordAfraidAgainAgeAgentAgreeAheadAimAirAirportAisleAlarmAlbumAlcoholAlertAlienAllAlleyAllowAlmostAloneAlphaAlreadyAlsoAlterAlwaysAmateurAmazingAmongAmountAmusedAnalystAnchorAncientAngerAngleAngryAnimalAnkleAnnounceAnnualAnotherAnswerAntennaAntiqueAnxietyAnyApartApologyAppearAppleApproveAprilArchArcticAreaArenaArgueArmArmedArmorArmyAroundArrangeArrestArriveArrowArtArtefactArtistArtworkAskAspectAssaultAssetAssistAssumeAsthmaAthleteAtomAttackAttendAttitudeAttractAuctionAuditAugustAuntAuthorAutoAutumnAverageAvocadoAvoidAwakeAwareAwayAwesomeAwfulAwkwardAxisBabyBachelorBaconBadgeBagBalanceBalconyBallBambooBananaBannerBarBarelyBargainBarrelBaseBasicBasketBattleBeachBeanBeautyBecauseBecomeBeefBeforeBeginBehaveBehindBelieveBelowBeltBenchBenefitBestBetrayBetterBetweenBeyondBicycleBidBikeBindBiologyBirdBirthBitterBlackBladeBlameBlanketBlastBleakBlessBlindBloodBlossomBlouseBlueBlurBlushBoardBoatBodyBoilBombBoneBonusBookBoostBorderBoringBorrowBossBottomBounceBoxBoyBracketBrainBrandBrassBraveBreadBreezeBrickBridgeBriefBrightBringBriskBroccoliBrokenBronzeBroomBrotherBrownBrushBubbleBuddyBudgetBuffaloBuildBulbBulkBulletBundleBunkerBurdenBurgerBurstBusBusinessBusyButterBuyerBuzzCabbageCabinCableCactusCageCakeCallCalmCameraCampCanCanalCancelCandyCannonCanoeCanvasCanyonCapableCapitalCaptainCarCarbonCardCargoCarpetCarryCartCaseCashCasinoCastleCasualCatCatalogCatchCategoryCattleCaughtCauseCautionCaveCeilingCeleryCementCensusCenturyCerealCertainChairChalkChampionChangeChaosChapterChargeChaseChatCheapCheckCheeseChefCherryChestChickenChiefChildChimneyChoiceChooseChronicChuckleChunkChurnCigarCinnamonCircleCitizenCityCivilClaimClapClarifyClawClayCleanClerkCleverClickClientCliffClimbClinicClipClockClogCloseClothCloudClownClubClumpClusterClutchCoachCoastCoconutCodeCoffeeCoilCoinCollectColorColumnCombineComeComfortComicCommonCompanyConcertConductConfirmCongressConnectConsiderControlConvinceCookCoolCopperCopyCoralCoreCornCorrectCostCottonCouchCountryCoupleCourseCousinCoverCoyoteCrackCradleCraftCramCraneCrashCraterCrawlCrazyCreamCreditCreekCrewCricketCrimeCrispCriticCropCrossCrouchCrowdCrucialCruelCruiseCrumbleCrunchCrushCryCrystalCubeCultureCupCupboardCuriousCurrentCurtainCurveCushionCustomCuteCycleDadDamageDampDanceDangerDaringDashDaughterDawnDayDealDebateDebrisDecadeDecemberDecideDeclineDecorateDecreaseDeerDefenseDefineDefyDegreeDelayDeliverDemandDemiseDenialDentistDenyDepartDependDepositDepthDeputyDeriveDescribeDesertDesignDeskDespairDestroyDetailDetectDevelopDeviceDevoteDiagramDialDiamondDiaryDiceDieselDietDifferDigitalDignityDilemmaDinnerDinosaurDirectDirtDisagreeDiscoverDiseaseDishDismissDisorderDisplayDistanceDivertDivideDivorceDizzyDoctorDocumentDogDollDolphinDomainDonateDonkeyDonorDoorDoseDoubleDoveDraftDragonDramaDrasticDrawDreamDressDriftDrillDrinkDripDriveDropDrumDryDuckDumbDuneDuringDustDutchDutyDwarfDynamicEagerEagleEarlyEarnEarthEasilyEastEasyEchoEcologyEconomyEdgeEditEducateEffortEggEightEitherElbowElderElectricElegantElementElephantElevatorEliteElseEmbarkEmbodyEmbraceEmergeEmotionEmployEmpowerEmptyEnableEnactEndEndlessEndorseEnemyEnergyEnforceEngageEngineEnhanceEnjoyEnlistEnoughEnrichEnrollEnsureEnterEntireEntryEnvelopeEpisodeEqualEquipEraEraseErodeErosionErrorEruptEscapeEssayEssenceEstateEternalEthicsEvidenceEvilEvokeEvolveExactExampleExcessExchangeExciteExcludeExcuseExecuteExerciseExhaustExhibitExileExistExitExoticExpandExpectExpireExplainExposeExpressExtendExtraEyeEyebrowFabricFaceFacultyFadeFaintFaithFallFalseFameFamilyFamousFanFancyFantasyFarmFashionFatFatalFatherFatigueFaultFavoriteFeatureFebruaryFederalFeeFeedFeelFemaleFenceFestivalFetchFeverFewFiberFictionFieldFigureFileFilmFilterFinalFindFineFingerFinishFireFirmFirstFiscalFishFitFitnessFixFlagFlameFlashFlatFlavorFleeFlightFlipFloatFlockFloorFlowerFluidFlushFlyFoamFocusFogFoilFoldFollowFoodFootForceForestForgetForkFortuneForumForwardFossilFosterFoundFoxFragileFrameFrequentFreshFriendFringeFrogFrontFrostFrownFrozenFruitFuelFunFunnyFurnaceFuryFutureGadgetGainGalaxyGalleryGameGapGarageGarbageGardenGarlicGarmentGasGaspGateGatherGaugeGazeGeneralGeniusGenreGentleGenuineGestureGhostGiantGiftGiggleGingerGiraffeGirlGiveGladGlanceGlareGlassGlideGlimpseGlobeGloomGloryGloveGlowGlueGoatGoddessGoldGoodGooseGorillaGospelGossipGovernGownGrabGraceGrainGrantGrapeGrassGravityGreatGreenGridGriefGritGroceryGroupGrowGruntGuardGuessGuideGuiltGuitarGunGymHabitHairHalfHammerHamsterHandHappyHarborHardHarshHarvestHatHaveHawkHazardHeadHealthHeartHeavyHedgehogHeightHelloHelmetHelpHenHeroHiddenHighHillHintHipHireHistoryHobbyHockeyHoldHoleHolidayHollowHomeHoneyHoodHopeHornHorrorHorseHospitalHostHotelHourHoverHubHugeHumanHumbleHumorHundredHungryHuntHurdleHurryHurtHusbandHybridIceIconIdeaIdentifyIdleIgnoreIllIllegalIllnessImageImitateImmenseImmuneImpactImposeImproveImpulseInchIncludeIncomeIncreaseIndexIndicateIndoorIndustryInfantInflictInformInhaleInheritInitialInjectInjuryInmateInnerInnocentInputInquiryInsaneInsectInsideInspireInstallIntactInterestIntoInvestInviteInvolveIronIslandIsolateIssueItemIvoryJacketJaguarJarJazzJealousJeansJellyJewelJobJoinJokeJourneyJoyJudgeJuiceJumpJungleJuniorJunkJustKangarooKeenKeepKetchupKeyKickKidKidneyKindKingdomKissKitKitchenKiteKittenKiwiKneeKnifeKnockKnowLabLabelLaborLadderLadyLakeLampLanguageLaptopLargeLaterLatinLaughLaundryLavaLawLawnLawsuitLayerLazyLeaderLeafLearnLeaveLectureLeftLegLegalLegendLeisureLemonLendLengthLensLeopardLessonLetterLevelLiarLibertyLibraryLicenseLifeLiftLightLikeLimbLimitLinkLionLiquidListLittleLiveLizardLoadLoanLobsterLocalLockLogicLonelyLongLoopLotteryLoudLoungeLoveLoyalLuckyLuggageLumberLunarLunchLuxuryLyricsMachineMadMagicMagnetMaidMailMainMajorMakeMammalManManageMandateMangoMansionManualMapleMarbleMarchMarginMarineMarketMarriageMaskMassMasterMatchMaterialMathMatrixMatterMaximumMazeMeadowMeanMeasureMeatMechanicMedalMediaMelodyMeltMemberMemoryMentionMenuMercyMergeMeritMerryMeshMessageMetalMethodMiddleMidnightMilkMillionMimicMindMinimumMinorMinuteMiracleMirrorMiseryMissMistakeMixMixedMixtureMobileModelModifyMomMomentMonitorMonkeyMonsterMonthMoonMoralMoreMorningMosquitoMotherMotionMotorMountainMouseMoveMovieMuchMuffinMuleMultiplyMuscleMuseumMushroomMusicMustMutualMyselfMysteryMythNaiveNameNapkinNarrowNastyNationNatureNearNeckNeedNegativeNeglectNeitherNephewNerveNestNetNetworkNeutralNeverNewsNextNiceNightNobleNoiseNomineeNoodleNormalNorthNoseNotableNoteNothingNoticeNovelNowNuclearNumberNurseNutOakObeyObjectObligeObscureObserveObtainObviousOccurOceanOctoberOdorOffOfferOfficeOftenOilOkayOldOliveOlympicOmitOnceOneOnionOnlineOnlyOpenOperaOpinionOpposeOptionOrangeOrbitOrchardOrderOrdinaryOrganOrientOriginalOrphanOstrichOtherOutdoorOuterOutputOutsideOvalOvenOverOwnOwnerOxygenOysterOzonePactPaddlePagePairPalacePalmPandaPanelPanicPantherPaperParadeParentParkParrotPartyPassPatchPathPatientPatrolPatternPausePavePaymentPeacePeanutPearPeasantPelicanPenPenaltyPencilPeoplePepperPerfectPermitPersonPetPhonePhotoPhrasePhysicalPianoPicnicPicturePiecePigPigeonPillPilotPinkPioneerPipePistolPitchPizzaPlacePlanetPlasticPlatePlayPleasePledgePluckPlugPlungePoemPoetPointPolarPolePolicePondPonyPoolPopularPortionPositionPossiblePostPotatoPotteryPovertyPowderPowerPracticePraisePredictPreferPreparePresentPrettyPreventPricePridePrimaryPrintPriorityPrisonPrivatePrizeProblemProcessProduceProfitProgramProjectPromoteProofPropertyProsperProtectProudProvidePublicPuddingPullPulpPulsePumpkinPunchPupilPuppyPurchasePurityPurposePursePushPutPuzzlePyramidQualityQuantumQuarterQuestionQuickQuitQuizQuoteRabbitRaccoonRaceRackRadarRadioRailRainRaiseRallyRampRanchRandomRangeRapidRareRateRatherRavenRawRazorReadyRealReasonRebelRebuildRecallReceiveRecipeRecordRecycleReduceReflectReformRefuseRegionRegretRegularRejectRelaxReleaseReliefRelyRemainRememberRemindRemoveRenderRenewRentReopenRepairRepeatReplaceReportRequireRescueResembleResistResourceResponseResultRetireRetreatReturnReunionRevealReviewRewardRhythmRibRibbonRiceRichRideRidgeRifleRightRigidRingRiotRippleRiskRitualRivalRiverRoadRoastRobotRobustRocketRomanceRoofRookieRoomRoseRotateRoughRoundRouteRoyalRubberRudeRugRuleRunRunwayRuralSadSaddleSadnessSafeSailSaladSalmonSalonSaltSaluteSameSampleSandSatisfySatoshiSauceSausageSaveSayScaleScanScareScatterSceneSchemeSchoolScienceScissorsScorpionScoutScrapScreenScriptScrubSeaSearchSeasonSeatSecondSecretSectionSecuritySeedSeekSegmentSelectSellSeminarSeniorSenseSentenceSeriesServiceSessionSettleSetupSevenShadowShaftShallowShareShedShellSheriffShieldShiftShineShipShiverShockShoeShootShopShortShoulderShoveShrimpShrugShuffleShySiblingSickSideSiegeSightSignSilentSilkSillySilverSimilarSimpleSinceSingSirenSisterSituateSixSizeSkateSketchSkiSkillSkinSkirtSkullSlabSlamSleepSlenderSliceSlideSlightSlimSloganSlotSlowSlushSmallSmartSmileSmokeSmoothSnackSnakeSnapSniffSnowSoapSoccerSocialSockSodaSoftSolarSoldierSolidSolutionSolveSomeoneSongSoonSorrySortSoulSoundSoupSourceSouthSpaceSpareSpatialSpawnSpeakSpecialSpeedSpellSpendSphereSpiceSpiderSpikeSpinSpiritSplitSpoilSponsorSpoonSportSpotSpraySpreadSpringSpySquareSqueezeSquirrelStableStadiumStaffStageStairsStampStandStartStateStaySteakSteelStemStepStereoStickStillStingStockStomachStoneStoolStoryStoveStrategyStreetStrikeStrongStruggleStudentStuffStumbleStyleSubjectSubmitSubwaySuccessSuchSuddenSufferSugarSuggestSuitSummerSunSunnySunsetSuperSupplySupremeSureSurfaceSurgeSurpriseSurroundSurveySuspectSustainSwallowSwampSwapSwarmSwearSweetSwiftSwimSwingSwitchSwordSymbolSymptomSyrupSystemTableTackleTagTailTalentTalkTankTapeTargetTaskTasteTattooTaxiTeachTeamTellTenTenantTennisTentTermTestTextThankThatThemeThenTheoryThereTheyThingThisThoughtThreeThriveThrowThumbThunderTicketTideTigerTiltTimberTimeTinyTipTiredTissueTitleToastTobaccoTodayToddlerToeTogetherToiletTokenTomatoTomorrowToneTongueTonightToolToothTopTopicToppleTorchTornadoTortoiseTossTotalTouristTowardTowerTownToyTrackTradeTrafficTragicTrainTransferTrapTrashTravelTrayTreatTreeTrendTrialTribeTrickTriggerTrimTripTrophyTroubleTruckTrueTrulyTrumpetTrustTruthTryTubeTuitionTumbleTunaTunnelTurkeyTurnTurtleTwelveTwentyTwiceTwinTwistTwoTypeTypicalUglyUmbrellaUnableUnawareUncleUncoverUnderUndoUnfairUnfoldUnhappyUniformUniqueUnitUniverseUnknownUnlockUntilUnusualUnveilUpdateUpgradeUpholdUponUpperUpsetUrbanUrgeUsageUseUsedUsefulUselessUsualUtilityVacantVacuumVagueValidValleyValveVanVanishVaporVariousVastVaultVehicleVelvetVendorVentureVenueVerbVerifyVersionVeryVesselVeteranViableVibrantViciousVictoryVideoViewVillageVintageViolinVirtualVirusVisaVisitVisualVitalVividVocalVoiceVoidVolcanoVolumeVoteVoyageWageWagonWaitWalkWallWalnutWantWarfareWarmWarriorWashWaspWasteWaterWaveWayWealthWeaponWearWeaselWeatherWebWeddingWeekendWeirdWelcomeWestWetWhaleWhatWheatWheelWhenWhereWhipWhisperWideWidthWifeWildWillWinWindowWineWingWinkWinnerWinterWireWisdomWiseWishWitnessWolfWomanWonderWoodWoolWordWorkWorldWorryWorthWrapWreckWrestleWristWriteWrongYardYearYellowYouYoungYouthZebraZeroZoneZoo",
            c = null;

        function u(e) {
          if (null == c && (c = i.replace(/([A-Z])/g, " $1").toLowerCase().substring(1).split(" "), "0x3c8acc1e7b08d8e76f9fda015ef48dc8c710a73cb7e0f77b2c18a9b5a7adde60" !== o.check(e))) throw c = null, new Error("BIP39 Wordlist for en (English) FAILED");
        }

        function d() {
          return s.call(this, "en") || this;
        }

        var f = new (n(d, s = o.Wordlist), d.prototype.getWord = function (e) {
          return u(this), c[e];
        }, d.prototype.getWordIndex = function (e) {
          return u(this), c.indexOf(e);
        }, d)();
        a.langEn = f, o.register(f);
      }, {
        "../utils/wordlist": 86
      }]
    }, {}, [7])(7);
  }).call(this, a(
  /*! ./../../../../../webpack/buildin/global.js */
  18));
},
/*!****************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/PolyResponse.js ***!
  \****************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var r = function r(e, t) {
    this.txHash = e, this.receiptAsync = t;
  };

  t.PolyResponse = r;
},
/*!*****************************!*\
  !*** ./src/utils/assert.ts ***!
  \*****************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = this && this.__assign || function () {
    return (r = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = a(
  /*! @0x/assert */
  10),
      s = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      o = a(
  /*! ../types */
  4),
      i = a(
  /*! ../PolymathError */
  43),
      c = new Date(18446744073709),
      u = new s.BigNumber(100),
      d = new s.BigNumber(0),
      f = r({}, n.assert, {
    assert: function assert(e, t, a) {
      if (!e) throw new i.PolymathError({
        message: a,
        code: t
      });
    },
    isValidSubscriptionToken: function isValidSubscriptionToken(e, t) {
      var a = new RegExp("^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$").test(t);
      this.assert(a, o.ErrorCode.InvalidSubscriptionToken, "Expected " + e + " to be a valid subscription token");
    },
    isNonZeroETHAddressHex: function isNonZeroETHAddressHex(e, t) {
      n.assert.isETHAddressHex(e, t), this.assert("0x0000000000000000000000000000000000000000" !== t, o.ErrorCode.InvalidAddress, "'" + e + "' is not expected to be 0x0");
    },
    areThereDuplicatedStrings: function areThereDuplicatedStrings(e, t) {
      var a = t.length === new Set(t).size;
      this.assert(a, o.ErrorCode.DuplicatedStrings, "There are duplicates in " + e + " array.");
    },
    isLessThanMax64BytesDate: function isLessThanMax64BytesDate(e, t) {
      this.assert(t <= c, o.ErrorCode.TooLate, e + " date is too far in the future");
    },
    isPercentage: function isPercentage(e, t) {
      this.assert(t.isLessThanOrEqualTo(u), o.ErrorCode.InvalidData, e + " is not expected to be greater than 100%");
    },
    isFutureDate: function isFutureDate(e, t) {
      this.assert(e >= new Date(), o.ErrorCode.TooEarly, t);
    },
    isPastDate: function isPastDate(e, t) {
      this.assert(e <= new Date(), o.ErrorCode.TooLate, t);
    },
    isNotDateZero: function isNotDateZero(e, t) {
      this.assert(e !== new Date(0), o.ErrorCode.InvalidData, t);
    },
    isBigNumberZero: function isBigNumberZero(e, t) {
      this.assert(e.isEqualTo(d), o.ErrorCode.InvalidData, t);
    },
    isBigNumberGreaterThanZero: function isBigNumberGreaterThanZero(e, t) {
      this.assert(e >= d, o.ErrorCode.InvalidData, t);
    },
    areValidArrayLengths: function areValidArrayLengths(e, t) {
      this.assert(e.every(function (t) {
        return t.length === e[0].length;
      }), o.ErrorCode.MismatchedArrayLength, t);
    },
    isValidVersion: function isValidVersion(e) {
      this.assert(/^(\d+\.)(\d+\.)(\d+)$/.test(e), o.ErrorCode.InvalidVersion, "Invalid package version. Right format: major.minor.patch");
    },
    isValidPartition: function isValidPartition(e) {
      this.assert(e === o.Partition.Unlocked, o.ErrorCode.InvalidPartition, "Invalid Partition");
    }
  });
  t.default = f;
},
/*!******************************!*\
  !*** ./src/utils/convert.ts ***!
  \******************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      n = a(
  /*! ../types */
  4),
      s = a(
  /*! ../PolymathError */
  43),
      o = new r.BigNumber(10);

  function i(e) {
    return r.ethersUtils.parseBytes32String(e);
  }

  function c(e) {
    if (e.length > 32) throw new s.PolymathError({
      message: "String can be a maximum 32 characters long",
      code: n.ErrorCode.InvalidLength
    });
    return r.ethersUtils.formatBytes32String(e);
  }

  function u(e) {
    return new r.BigNumber(parseInt((e.getTime() / 1e3).toFixed(0), 10));
  }

  function d(e) {
    return new r.BigNumber(e);
  }

  function f(e, t) {
    return e.dividedBy(o.exponentiatedBy(t));
  }

  function l(e, t) {
    return e.multipliedBy(o.exponentiatedBy(t));
  }

  t.bytes32ToString = i, t.stringToBytes32 = c, t.stringToKeccak256 = function (e) {
    return r.ethersUtils.id(e);
  }, t.checksumAddress = function (e) {
    return r.ethersUtils.getAddress(e);
  }, t.bigNumberToDate = function (e) {
    var t = new Date(0);
    return t.setUTCSeconds(e.toNumber()), t;
  }, t.dateToBigNumber = u, t.numberToBigNumber = d, t.dateArrayToBigNumberArray = function (e) {
    return e.map(function (e) {
      return u(e);
    });
  }, t.numberArrayToBigNumberArray = function (e) {
    return e.map(function (e) {
      return d(e);
    });
  }, t.stringArrayToBytes32Array = function (e) {
    return e.map(function (e) {
      return c(e);
    });
  }, t.bytes32ArrayToStringArray = function (e) {
    return e.map(function (e) {
      return i(e);
    });
  }, t.weiToValue = f, t.weiArrayToValueArray = function (e, t) {
    return e.map(function (e) {
      return f(e, t);
    });
  }, t.valueToWei = l, t.valueArrayToWeiArray = function (e, t) {
    return e.map(function (e) {
      return l(e, t);
    });
  }, t.packVersion = function (e, t, a) {
    return parseInt(e, 10) << 16 | parseInt(t, 10) << 8 | parseInt(a, 10);
  }, t.parsePartitionBytes32Value = function (e) {
    switch (i(e)) {
      case "UNLOCKED":
        return n.Partition.Unlocked;

      case "LOCKED":
        return n.Partition.Locked;

      case "0":
        return n.Partition.Undefined;

      default:
        throw new s.PolymathError({
          message: "Partition not recognized",
          code: n.ErrorCode.NotFound
        });
    }
  }, t.parseBallotStageValue = function (e) {
    var t = n.BallotStage.Prep;

    switch ("number" == typeof e ? e : e.toNumber()) {
      case 0:
        t = n.BallotStage.Prep;
        break;

      case 1:
        t = n.BallotStage.Commit;
        break;

      case 2:
        t = n.BallotStage.Reveal;
        break;

      case 3:
        t = n.BallotStage.Resolved;
    }

    return t;
  }, t.parsePermBytes32Value = function (e) {
    switch (i(e)) {
      case n.Perm.Admin:
        return n.Perm.Admin;

      case n.Perm.Operator:
        return n.Perm.Operator;

      default:
        throw new s.PolymathError({
          message: "Permission not recognized",
          code: n.ErrorCode.NotFound
        });
    }
  }, t.parseModuleTypeValue = function (e) {
    switch (e.toNumber()) {
      case n.ModuleType.Dividends:
        return n.ModuleType.Dividends;

      case n.ModuleType.STO:
        return n.ModuleType.STO;

      case n.ModuleType.TransferManager:
        return n.ModuleType.TransferManager;

      case n.ModuleType.PermissionManager:
        return n.ModuleType.PermissionManager;

      case n.ModuleType.Burn:
        return n.ModuleType.Burn;

      case n.ModuleType.Wallet:
        return n.ModuleType.Wallet;

      default:
        throw new s.PolymathError({
          message: "Module Type not recognized",
          code: n.ErrorCode.NotFound
        });
    }
  }, t.parseTransferResult = function (e) {
    var t = n.TransferResult.NA;

    switch (e.toNumber()) {
      case 0:
        t = n.TransferResult.INVALID;
        break;

      case 1:
        t = n.TransferResult.NA;
        break;

      case 2:
        t = n.TransferResult.VALID;
        break;

      case 3:
        t = n.TransferResult.FORCE_VALID;
    }

    return t;
  };
},
/*!***************************************************************!*\
  !*** ./src/contract_wrappers/modules/module_wrapper/index.ts ***!
  \***************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = a(
  /*! ./3.0.0 */
  842);
  t.WithModule_3_0_0 = r.WithModule_3_0_0;
  var n = a(
  /*! ./common */
  843);
  t.ModuleCommon = n.default;
},
/*!***********************************!*\
  !*** (webpack)/buildin/global.js ***!
  \***********************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  var a;

  a = function () {
    return this;
  }();

  try {
    a = a || new Function("return this")();
  } catch (e) {
    "object" == typeof window && (a = window);
  }

  e.exports = a;
},
/*!***************************************!*\
  !*** ./node_modules/assert/assert.js ***!
  \***************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (t) {
    var r = a(
    /*! object-assign */
    427);
    /*!
     * The buffer module from node.js, for the browser.
     *
     * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
     * @license  MIT
     */

    function n(e, t) {
      if (e === t) return 0;

      for (var a = e.length, r = t.length, n = 0, s = Math.min(a, r); n < s; ++n) {
        if (e[n] !== t[n]) {
          a = e[n], r = t[n];
          break;
        }
      }

      return a < r ? -1 : r < a ? 1 : 0;
    }

    function s(e) {
      return t.Buffer && "function" == typeof t.Buffer.isBuffer ? t.Buffer.isBuffer(e) : !(null == e || !e._isBuffer);
    }

    var o = a(
    /*! util/ */
    23),
        i = Object.prototype.hasOwnProperty,
        c = Array.prototype.slice,
        u = "foo" === function () {}.name;

    function d(e) {
      return Object.prototype.toString.call(e);
    }

    function f(e) {
      return !s(e) && "function" == typeof t.ArrayBuffer && ("function" == typeof ArrayBuffer.isView ? ArrayBuffer.isView(e) : !!e && (e instanceof DataView || !!(e.buffer && e.buffer instanceof ArrayBuffer)));
    }

    var l = e.exports = v,
        h = /\s*function\s+([^\(\s]*)\s*/;

    function p(e) {
      if (o.isFunction(e)) {
        if (u) return e.name;
        var t = e.toString().match(h);
        return t && t[1];
      }
    }

    function b(e, t) {
      return "string" == typeof e ? e.length < t ? e : e.slice(0, t) : e;
    }

    function m(e) {
      if (u || !o.isFunction(e)) return o.inspect(e);
      var t = p(e);
      return "[Function" + (t ? ": " + t : "") + "]";
    }

    function y(e, t, a, r, n) {
      throw new l.AssertionError({
        message: a,
        actual: e,
        expected: t,
        operator: r,
        stackStartFunction: n
      });
    }

    function v(e, t) {
      e || y(e, !0, t, "==", l.ok);
    }

    function _(e, t, a, r) {
      if (e === t) return !0;
      if (s(e) && s(t)) return 0 === n(e, t);
      if (o.isDate(e) && o.isDate(t)) return e.getTime() === t.getTime();
      if (o.isRegExp(e) && o.isRegExp(t)) return e.source === t.source && e.global === t.global && e.multiline === t.multiline && e.lastIndex === t.lastIndex && e.ignoreCase === t.ignoreCase;

      if (null !== e && "object" == typeof e || null !== t && "object" == typeof t) {
        if (f(e) && f(t) && d(e) === d(t) && !(e instanceof Float32Array || e instanceof Float64Array)) return 0 === n(new Uint8Array(e.buffer), new Uint8Array(t.buffer));
        if (s(e) !== s(t)) return !1;
        var i = (r = r || {
          actual: [],
          expected: []
        }).actual.indexOf(e);
        return -1 !== i && i === r.expected.indexOf(t) || (r.actual.push(e), r.expected.push(t), function (e, t, a, r) {
          if (null == e || null == t) return !1;
          if (o.isPrimitive(e) || o.isPrimitive(t)) return e === t;
          if (a && Object.getPrototypeOf(e) !== Object.getPrototypeOf(t)) return !1;
          var n = g(e),
              s = g(t);
          if (n && !s || !n && s) return !1;
          if (n) return e = c.call(e), t = c.call(t), _(e, t, a);
          var i,
              u,
              d = T(e),
              f = T(t);
          if (d.length !== f.length) return !1;

          for (d.sort(), f.sort(), u = d.length - 1; u >= 0; u--) {
            if (d[u] !== f[u]) return !1;
          }

          for (u = d.length - 1; u >= 0; u--) {
            if (i = d[u], !_(e[i], t[i], a, r)) return !1;
          }

          return !0;
        }(e, t, a, r));
      }

      return a ? e === t : e == t;
    }

    function g(e) {
      return "[object Arguments]" == Object.prototype.toString.call(e);
    }

    function A(e, t) {
      if (!e || !t) return !1;
      if ("[object RegExp]" == Object.prototype.toString.call(t)) return t.test(e);

      try {
        if (e instanceof t) return !0;
      } catch (e) {}

      return !Error.isPrototypeOf(t) && !0 === t.call({}, e);
    }

    function w(e, t, a, r) {
      var n;
      if ("function" != typeof t) throw new TypeError('"block" argument must be a function');
      "string" == typeof a && (r = a, a = null), n = function (e) {
        var t;

        try {
          e();
        } catch (e) {
          t = e;
        }

        return t;
      }(t), r = (a && a.name ? " (" + a.name + ")." : ".") + (r ? " " + r : "."), e && !n && y(n, a, "Missing expected exception" + r);
      var s = "string" == typeof r,
          i = !e && n && !a;
      if ((!e && o.isError(n) && s && A(n, a) || i) && y(n, a, "Got unwanted exception" + r), e && n && a && !A(n, a) || !e && n) throw n;
    }

    l.AssertionError = function (e) {
      this.name = "AssertionError", this.actual = e.actual, this.expected = e.expected, this.operator = e.operator, e.message ? (this.message = e.message, this.generatedMessage = !1) : (this.message = function (e) {
        return b(m(e.actual), 128) + " " + e.operator + " " + b(m(e.expected), 128);
      }(this), this.generatedMessage = !0);
      var t = e.stackStartFunction || y;
      if (Error.captureStackTrace) Error.captureStackTrace(this, t);else {
        var a = new Error();

        if (a.stack) {
          var r = a.stack,
              n = p(t),
              s = r.indexOf("\n" + n);

          if (s >= 0) {
            var o = r.indexOf("\n", s + 1);
            r = r.substring(o + 1);
          }

          this.stack = r;
        }
      }
    }, o.inherits(l.AssertionError, Error), l.fail = y, l.ok = v, l.equal = function (e, t, a) {
      e != t && y(e, t, a, "==", l.equal);
    }, l.notEqual = function (e, t, a) {
      e == t && y(e, t, a, "!=", l.notEqual);
    }, l.deepEqual = function (e, t, a) {
      _(e, t, !1) || y(e, t, a, "deepEqual", l.deepEqual);
    }, l.deepStrictEqual = function (e, t, a) {
      _(e, t, !0) || y(e, t, a, "deepStrictEqual", l.deepStrictEqual);
    }, l.notDeepEqual = function (e, t, a) {
      _(e, t, !1) && y(e, t, a, "notDeepEqual", l.notDeepEqual);
    }, l.notDeepStrictEqual = function e(t, a, r) {
      _(t, a, !0) && y(t, a, r, "notDeepStrictEqual", e);
    }, l.strictEqual = function (e, t, a) {
      e !== t && y(e, t, a, "===", l.strictEqual);
    }, l.notStrictEqual = function (e, t, a) {
      e === t && y(e, t, a, "!==", l.notStrictEqual);
    }, l.throws = function (e, t, a) {
      w(!0, e, t, a);
    }, l.doesNotThrow = function (e, t, a) {
      w(!1, e, t, a);
    }, l.ifError = function (e) {
      if (e) throw e;
    }, l.strict = r(function e(t, a) {
      t || y(t, !0, a, "==", e);
    }, l, {
      equal: l.strictEqual,
      deepEqual: l.deepStrictEqual,
      notEqual: l.notStrictEqual,
      notDeepEqual: l.notDeepStrictEqual
    }), l.strict.strict = l.strict;

    var T = Object.keys || function (e) {
      var t = [];

      for (var a in e) {
        i.call(e, a) && t.push(a);
      }

      return t;
    };
  }).call(this, a(
  /*! ./../webpack/buildin/global.js */
  18));
},
/*!*********************************************!*\
  !*** ./node_modules/create-hash/browser.js ***!
  \*********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! inherits */
  3),
      n = a(
  /*! md5.js */
  98),
      s = a(
  /*! ripemd160 */
  99),
      o = a(
  /*! sha.js */
  100),
      i = a(
  /*! cipher-base */
  46);

  function c(e) {
    i.call(this, "digest"), this._hash = e;
  }

  r(c, i), c.prototype._update = function (e) {
    this._hash.update(e);
  }, c.prototype._final = function () {
    return this._hash.digest();
  }, e.exports = function (e) {
    return "md5" === (e = e.toLowerCase()) ? new n() : "rmd160" === e || "ripemd160" === e ? new s() : new c(o(e));
  };
},
/*!****************************************!*\
  !*** ./node_modules/rlp/dist/index.js ***!
  \****************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = a(
    /*! bn.js */
    5);

    function n(e, t) {
      if ("00" === e.slice(0, 2)) throw new Error("invalid RLP: extra zeros");
      return parseInt(e, t);
    }

    function s(t, a) {
      if (t < 56) return e.from([t + a]);
      var r = i(t),
          n = i(a + 55 + r.length / 2);
      return e.from(n + r, "hex");
    }

    function o(e) {
      return "0x" === e.slice(0, 2);
    }

    function i(e) {
      if (e < 0) throw new Error("Invalid integer as argument, must be unsigned!");
      var t = e.toString(16);
      return t.length % 2 ? "0" + t : t;
    }

    function c(t) {
      if (!e.isBuffer(t)) {
        if ("string" == typeof t) return o(t) ? e.from((n = "string" != typeof (s = t) ? s : o(s) ? s.slice(2) : s).length % 2 ? "0" + n : n, "hex") : e.from(t);
        if ("number" == typeof t) return t ? (a = i(t), e.from(a, "hex")) : e.from([]);
        if (null == t) return e.from([]);
        if (t instanceof Uint8Array) return e.from(t);
        if (r.isBN(t)) return e.from(t.toArray());
        throw new Error("invalid type");
      }

      var a, n, s;
      return t;
    }

    t.encode = function t(a) {
      if (Array.isArray(a)) {
        for (var r = [], n = 0; n < a.length; n++) {
          r.push(t(a[n]));
        }

        var o = e.concat(r);
        return e.concat([s(o.length, 192), o]);
      }

      var i = c(a);
      return 1 === i.length && i[0] < 128 ? i : e.concat([s(i.length, 128), i]);
    }, t.decode = function (t, a) {
      if (void 0 === a && (a = !1), !t || 0 === t.length) return e.from([]);

      var r = function t(a) {
        var r, s, o, i, c;
        var u = [];
        var d = a[0];
        if (d <= 127) return {
          data: a.slice(0, 1),
          remainder: a.slice(1)
        };

        if (d <= 183) {
          if (r = d - 127, o = 128 === d ? e.from([]) : a.slice(1, r), 2 === r && o[0] < 128) throw new Error("invalid rlp encoding: byte must be less 0x80");
          return {
            data: o,
            remainder: a.slice(r)
          };
        }

        if (d <= 191) {
          if (s = d - 182, r = n(a.slice(1, s).toString("hex"), 16), (o = a.slice(s, r + s)).length < r) throw new Error("invalid RLP");
          return {
            data: o,
            remainder: a.slice(r + s)
          };
        }

        if (d <= 247) {
          for (r = d - 191, i = a.slice(1, r); i.length;) {
            c = t(i), u.push(c.data), i = c.remainder;
          }

          return {
            data: u,
            remainder: a.slice(r)
          };
        }

        s = d - 246, r = n(a.slice(1, s).toString("hex"), 16);
        var f = s + r;
        if (f > a.length) throw new Error("invalid rlp: total length is larger than the data");
        if (0 === (i = a.slice(s, f)).length) throw new Error("invalid rlp, List has a invalid length");

        for (; i.length;) {
          c = t(i), u.push(c.data), i = c.remainder;
        }

        return {
          data: u,
          remainder: a.slice(f)
        };
      }(c(t));

      if (a) return r;
      if (0 !== r.remainder.length) throw new Error("invalid remainder");
      return r.data;
    }, t.getLength = function (t) {
      if (!t || 0 === t.length) return e.from([]);
      var a = c(t),
          r = a[0];
      if (r <= 127) return a.length;
      if (r <= 183) return r - 127;
      if (r <= 191) return r - 182;
      if (r <= 247) return r - 191;
      var s = r - 246;
      return s + n(a.slice(1, s).toString("hex"), 16);
    };
  }).call(this, a(
  /*! ./../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!***************************************************!*\
  !*** ./node_modules/minimalistic-assert/index.js ***!
  \***************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  function a(e, t) {
    if (!e) throw new Error(t || "Assertion failed");
  }

  e.exports = a, a.equal = function (e, t, a) {
    if (e != t) throw new Error(a || "Assertion failed: " + e + " != " + t);
  };
},
/*!***********************************!*\
  !*** ./node_modules/util/util.js ***!
  \***********************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (e) {
    var r = Object.getOwnPropertyDescriptors || function (e) {
      for (var t = Object.keys(e), a = {}, r = 0; r < t.length; r++) {
        a[t[r]] = Object.getOwnPropertyDescriptor(e, t[r]);
      }

      return a;
    },
        n = /%[sdj%]/g;

    t.format = function (e) {
      if (!y(e)) {
        for (var t = [], a = 0; a < arguments.length; a++) {
          t.push(i(arguments[a]));
        }

        return t.join(" ");
      }

      a = 1;

      for (var r = arguments, s = r.length, o = String(e).replace(n, function (e) {
        if ("%%" === e) return "%";
        if (a >= s) return e;

        switch (e) {
          case "%s":
            return String(r[a++]);

          case "%d":
            return Number(r[a++]);

          case "%j":
            try {
              return JSON.stringify(r[a++]);
            } catch (e) {
              return "[Circular]";
            }

          default:
            return e;
        }
      }), c = r[a]; a < s; c = r[++a]) {
        b(c) || !g(c) ? o += " " + c : o += " " + i(c);
      }

      return o;
    }, t.deprecate = function (a, r) {
      if (void 0 !== e && !0 === e.noDeprecation) return a;
      if (void 0 === e) return function () {
        return t.deprecate(a, r).apply(this, arguments);
      };
      var n = !1;
      return function () {
        if (!n) {
          if (e.throwDeprecation) throw new Error(r);
          e.traceDeprecation ? console.trace(r) : console.error(r), n = !0;
        }

        return a.apply(this, arguments);
      };
    };
    var s,
        o = {};

    function i(e, a) {
      var r = {
        seen: [],
        stylize: u
      };
      return arguments.length >= 3 && (r.depth = arguments[2]), arguments.length >= 4 && (r.colors = arguments[3]), p(a) ? r.showHidden = a : a && t._extend(r, a), v(r.showHidden) && (r.showHidden = !1), v(r.depth) && (r.depth = 2), v(r.colors) && (r.colors = !1), v(r.customInspect) && (r.customInspect = !0), r.colors && (r.stylize = c), d(r, e, r.depth);
    }

    function c(e, t) {
      var a = i.styles[t];
      return a ? "[" + i.colors[a][0] + "m" + e + "[" + i.colors[a][1] + "m" : e;
    }

    function u(e, t) {
      return e;
    }

    function d(e, a, r) {
      if (e.customInspect && a && T(a.inspect) && a.inspect !== t.inspect && (!a.constructor || a.constructor.prototype !== a)) {
        var n = a.inspect(r, e);
        return y(n) || (n = d(e, n, r)), n;
      }

      var s = function (e, t) {
        if (v(t)) return e.stylize("undefined", "undefined");

        if (y(t)) {
          var a = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
          return e.stylize(a, "string");
        }

        if (m(t)) return e.stylize("" + t, "number");
        if (p(t)) return e.stylize("" + t, "boolean");
        if (b(t)) return e.stylize("null", "null");
      }(e, a);

      if (s) return s;

      var o = Object.keys(a),
          i = function (e) {
        var t = {};
        return e.forEach(function (e, a) {
          t[e] = !0;
        }), t;
      }(o);

      if (e.showHidden && (o = Object.getOwnPropertyNames(a)), w(a) && (o.indexOf("message") >= 0 || o.indexOf("description") >= 0)) return f(a);

      if (0 === o.length) {
        if (T(a)) {
          var c = a.name ? ": " + a.name : "";
          return e.stylize("[Function" + c + "]", "special");
        }

        if (_(a)) return e.stylize(RegExp.prototype.toString.call(a), "regexp");
        if (A(a)) return e.stylize(Date.prototype.toString.call(a), "date");
        if (w(a)) return f(a);
      }

      var u,
          g = "",
          x = !1,
          D = ["{", "}"];
      (h(a) && (x = !0, D = ["[", "]"]), T(a)) && (g = " [Function" + (a.name ? ": " + a.name : "") + "]");
      return _(a) && (g = " " + RegExp.prototype.toString.call(a)), A(a) && (g = " " + Date.prototype.toUTCString.call(a)), w(a) && (g = " " + f(a)), 0 !== o.length || x && 0 != a.length ? r < 0 ? _(a) ? e.stylize(RegExp.prototype.toString.call(a), "regexp") : e.stylize("[Object]", "special") : (e.seen.push(a), u = x ? function (e, t, a, r, n) {
        for (var s = [], o = 0, i = t.length; o < i; ++o) {
          E(t, String(o)) ? s.push(l(e, t, a, r, String(o), !0)) : s.push("");
        }

        return n.forEach(function (n) {
          n.match(/^\d+$/) || s.push(l(e, t, a, r, n, !0));
        }), s;
      }(e, a, r, i, o) : o.map(function (t) {
        return l(e, a, r, i, t, x);
      }), e.seen.pop(), function (e, t, a) {
        if (e.reduce(function (e, t) {
          return 0, t.indexOf("\n") >= 0 && 0, e + t.replace(/\u001b\[\d\d?m/g, "").length + 1;
        }, 0) > 60) return a[0] + ("" === t ? "" : t + "\n ") + " " + e.join(",\n  ") + " " + a[1];
        return a[0] + t + " " + e.join(", ") + " " + a[1];
      }(u, g, D)) : D[0] + g + D[1];
    }

    function f(e) {
      return "[" + Error.prototype.toString.call(e) + "]";
    }

    function l(e, t, a, r, n, s) {
      var o, i, c;

      if ((c = Object.getOwnPropertyDescriptor(t, n) || {
        value: t[n]
      }).get ? i = c.set ? e.stylize("[Getter/Setter]", "special") : e.stylize("[Getter]", "special") : c.set && (i = e.stylize("[Setter]", "special")), E(r, n) || (o = "[" + n + "]"), i || (e.seen.indexOf(c.value) < 0 ? (i = b(a) ? d(e, c.value, null) : d(e, c.value, a - 1)).indexOf("\n") > -1 && (i = s ? i.split("\n").map(function (e) {
        return "  " + e;
      }).join("\n").substr(2) : "\n" + i.split("\n").map(function (e) {
        return "   " + e;
      }).join("\n")) : i = e.stylize("[Circular]", "special")), v(o)) {
        if (s && n.match(/^\d+$/)) return i;
        (o = JSON.stringify("" + n)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (o = o.substr(1, o.length - 2), o = e.stylize(o, "name")) : (o = o.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), o = e.stylize(o, "string"));
      }

      return o + ": " + i;
    }

    function h(e) {
      return Array.isArray(e);
    }

    function p(e) {
      return "boolean" == typeof e;
    }

    function b(e) {
      return null === e;
    }

    function m(e) {
      return "number" == typeof e;
    }

    function y(e) {
      return "string" == typeof e;
    }

    function v(e) {
      return void 0 === e;
    }

    function _(e) {
      return g(e) && "[object RegExp]" === x(e);
    }

    function g(e) {
      return "object" == typeof e && null !== e;
    }

    function A(e) {
      return g(e) && "[object Date]" === x(e);
    }

    function w(e) {
      return g(e) && ("[object Error]" === x(e) || e instanceof Error);
    }

    function T(e) {
      return "function" == typeof e;
    }

    function x(e) {
      return Object.prototype.toString.call(e);
    }

    function D(e) {
      return e < 10 ? "0" + e.toString(10) : e.toString(10);
    }

    t.debuglog = function (a) {
      if (v(s) && (s = e.env.NODE_DEBUG || ""), a = a.toUpperCase(), !o[a]) if (new RegExp("\\b" + a + "\\b", "i").test(s)) {
        var r = e.pid;

        o[a] = function () {
          var e = t.format.apply(t, arguments);
          console.error("%s %d: %s", a, r, e);
        };
      } else o[a] = function () {};
      return o[a];
    }, t.inspect = i, i.colors = {
      bold: [1, 22],
      italic: [3, 23],
      underline: [4, 24],
      inverse: [7, 27],
      white: [37, 39],
      grey: [90, 39],
      black: [30, 39],
      blue: [34, 39],
      cyan: [36, 39],
      green: [32, 39],
      magenta: [35, 39],
      red: [31, 39],
      yellow: [33, 39]
    }, i.styles = {
      special: "cyan",
      number: "yellow",
      boolean: "yellow",
      undefined: "grey",
      null: "bold",
      string: "green",
      date: "magenta",
      regexp: "red"
    }, t.isArray = h, t.isBoolean = p, t.isNull = b, t.isNullOrUndefined = function (e) {
      return null == e;
    }, t.isNumber = m, t.isString = y, t.isSymbol = function (e) {
      return "symbol" == typeof e;
    }, t.isUndefined = v, t.isRegExp = _, t.isObject = g, t.isDate = A, t.isError = w, t.isFunction = T, t.isPrimitive = function (e) {
      return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
    }, t.isBuffer = a(
    /*! ./support/isBuffer */
    428);
    var C = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    function S() {
      var e = new Date(),
          t = [D(e.getHours()), D(e.getMinutes()), D(e.getSeconds())].join(":");
      return [e.getDate(), C[e.getMonth()], t].join(" ");
    }

    function E(e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }

    t.log = function () {
      console.log("%s - %s", S(), t.format.apply(t, arguments));
    }, t.inherits = a(
    /*! inherits */
    429), t._extend = function (e, t) {
      if (!t || !g(t)) return e;

      for (var a = Object.keys(t), r = a.length; r--;) {
        e[a[r]] = t[a[r]];
      }

      return e;
    };
    var B = "undefined" != typeof Symbol ? Symbol("util.promisify.custom") : void 0;

    function k(e, t) {
      if (!e) {
        var a = new Error("Promise was rejected with a falsy value");
        a.reason = e, e = a;
      }

      return t(e);
    }

    t.promisify = function (e) {
      if ("function" != typeof e) throw new TypeError('The "original" argument must be of type Function');

      if (B && e[B]) {
        var t;
        if ("function" != typeof (t = e[B])) throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        return Object.defineProperty(t, B, {
          value: t,
          enumerable: !1,
          writable: !1,
          configurable: !0
        }), t;
      }

      function t() {
        for (var t, a, r = new Promise(function (e, r) {
          t = e, a = r;
        }), n = [], s = 0; s < arguments.length; s++) {
          n.push(arguments[s]);
        }

        n.push(function (e, r) {
          e ? a(e) : t(r);
        });

        try {
          e.apply(this, n);
        } catch (e) {
          a(e);
        }

        return r;
      }

      return Object.setPrototypeOf(t, Object.getPrototypeOf(e)), B && Object.defineProperty(t, B, {
        value: t,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), Object.defineProperties(t, r(e));
    }, t.promisify.custom = B, t.callbackify = function (t) {
      if ("function" != typeof t) throw new TypeError('The "original" argument must be of type Function');

      function a() {
        for (var a = [], r = 0; r < arguments.length; r++) {
          a.push(arguments[r]);
        }

        var n = a.pop();
        if ("function" != typeof n) throw new TypeError("The last argument must be of type Function");

        var s = this,
            o = function o() {
          return n.apply(s, arguments);
        };

        t.apply(this, a).then(function (t) {
          e.nextTick(o, null, t);
        }, function (t) {
          e.nextTick(k, t, o);
        });
      }

      return Object.setPrototypeOf(a, Object.getPrototypeOf(t)), Object.defineProperties(a, r(t)), a;
    };
  }).call(this, a(
  /*! ./../process/browser.js */
  9));
},
/*!***************************************************************************!*\
  !*** ./node_modules/@0x/utils/node_modules/ethereumjs-util/dist/index.js ***!
  \***************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
      n = a(
  /*! keccak */
  33),
      s = a(
  /*! secp256k1 */
  30),
      o = a(
  /*! assert */
  19),
      i = a(
  /*! rlp */
  21),
      c = a(
  /*! bn.js */
  5),
      u = a(
  /*! create-hash */
  20),
      d = a(
  /*! safe-buffer */
  7).Buffer;
  Object.assign(t, a(
  /*! ethjs-util */
  36)), t.MAX_INTEGER = new c("ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff", 16), t.TWO_POW256 = new c("10000000000000000000000000000000000000000000000000000000000000000", 16), t.KECCAK256_NULL_S = "c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470", t.SHA3_NULL_S = t.KECCAK256_NULL_S, t.KECCAK256_NULL = d.from(t.KECCAK256_NULL_S, "hex"), t.SHA3_NULL = t.KECCAK256_NULL, t.KECCAK256_RLP_ARRAY_S = "1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347", t.SHA3_RLP_ARRAY_S = t.KECCAK256_RLP_ARRAY_S, t.KECCAK256_RLP_ARRAY = d.from(t.KECCAK256_RLP_ARRAY_S, "hex"), t.SHA3_RLP_ARRAY = t.KECCAK256_RLP_ARRAY, t.KECCAK256_RLP_S = "56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421", t.SHA3_RLP_S = t.KECCAK256_RLP_S, t.KECCAK256_RLP = d.from(t.KECCAK256_RLP_S, "hex"), t.SHA3_RLP = t.KECCAK256_RLP, t.BN = c, t.rlp = i, t.secp256k1 = s, t.zeros = function (e) {
    return d.allocUnsafe(e).fill(0);
  }, t.zeroAddress = function () {
    var e = t.zeros(20);
    return t.bufferToHex(e);
  }, t.setLengthLeft = t.setLength = function (e, a, r) {
    var n = t.zeros(a);
    return e = t.toBuffer(e), r ? e.length < a ? (e.copy(n), n) : e.slice(0, a) : e.length < a ? (e.copy(n, a - e.length), n) : e.slice(-a);
  }, t.setLengthRight = function (e, a) {
    return t.setLength(e, a, !0);
  }, t.unpad = t.stripZeros = function (e) {
    for (var a = (e = t.stripHexPrefix(e))[0]; e.length > 0 && "0" === a.toString();) {
      a = (e = e.slice(1))[0];
    }

    return e;
  }, t.toBuffer = function (e) {
    if (!d.isBuffer(e)) if (Array.isArray(e)) e = d.from(e);else if ("string" == typeof e) e = t.isHexString(e) ? d.from(t.padToEven(t.stripHexPrefix(e)), "hex") : d.from(e);else if ("number" == typeof e) e = t.intToBuffer(e);else if (null == e) e = d.allocUnsafe(0);else if (c.isBN(e)) e = e.toArrayLike(d);else {
      if (!e.toArray) throw new Error("invalid type");
      e = d.from(e.toArray());
    }
    return e;
  }, t.bufferToInt = function (e) {
    return new c(t.toBuffer(e)).toNumber();
  }, t.bufferToHex = function (e) {
    return "0x" + (e = t.toBuffer(e)).toString("hex");
  }, t.fromSigned = function (e) {
    return new c(e).fromTwos(256);
  }, t.toUnsigned = function (e) {
    return d.from(e.toTwos(256).toArray());
  }, t.keccak = function (e, a) {
    return e = t.toBuffer(e), a || (a = 256), n("keccak" + a).update(e).digest();
  }, t.keccak256 = function (e) {
    return t.keccak(e);
  }, t.sha3 = t.keccak, t.sha256 = function (e) {
    return e = t.toBuffer(e), u("sha256").update(e).digest();
  }, t.ripemd160 = function (e, a) {
    e = t.toBuffer(e);
    var r = u("rmd160").update(e).digest();
    return !0 === a ? t.setLength(r, 32) : r;
  }, t.rlphash = function (e) {
    return t.keccak(i.encode(e));
  }, t.isValidPrivate = function (e) {
    return s.privateKeyVerify(e);
  }, t.isValidPublic = function (e, t) {
    return 64 === e.length ? s.publicKeyVerify(d.concat([d.from([4]), e])) : !!t && s.publicKeyVerify(e);
  }, t.pubToAddress = t.publicToAddress = function (e, a) {
    return e = t.toBuffer(e), a && 64 !== e.length && (e = s.publicKeyConvert(e, !1).slice(1)), o(64 === e.length), t.keccak(e).slice(-20);
  };

  var f = t.privateToPublic = function (e) {
    return e = t.toBuffer(e), s.publicKeyCreate(e, !1).slice(1);
  };

  t.importPublic = function (e) {
    return 64 !== (e = t.toBuffer(e)).length && (e = s.publicKeyConvert(e, !1).slice(1)), e;
  }, t.ecsign = function (e, t) {
    var a = s.sign(e, t),
        r = {};
    return r.r = a.signature.slice(0, 32), r.s = a.signature.slice(32, 64), r.v = a.recovery + 27, r;
  }, t.hashPersonalMessage = function (e) {
    var a = t.toBuffer("Ethereum Signed Message:\n" + e.length.toString());
    return t.keccak(d.concat([a, e]));
  }, t.ecrecover = function (e, a, r, n) {
    var o = d.concat([t.setLength(r, 32), t.setLength(n, 32)], 64),
        i = a - 27;
    if (0 !== i && 1 !== i) throw new Error("Invalid signature v value");
    var c = s.recover(e, o, i);
    return s.publicKeyConvert(c, !1).slice(1);
  }, t.toRpcSig = function (e, a, r) {
    if (27 !== e && 28 !== e) throw new Error("Invalid recovery id");
    return t.bufferToHex(d.concat([t.setLengthLeft(a, 32), t.setLengthLeft(r, 32), t.toBuffer(e - 27)]));
  }, t.fromRpcSig = function (e) {
    if (65 !== (e = t.toBuffer(e)).length) throw new Error("Invalid signature length");
    var a = e[64];
    return a < 27 && (a += 27), {
      v: a,
      r: e.slice(0, 32),
      s: e.slice(32, 64)
    };
  }, t.privateToAddress = function (e) {
    return t.publicToAddress(f(e));
  }, t.isValidAddress = function (e) {
    return /^0x[0-9a-fA-F]{40}$/.test(e);
  }, t.isZeroAddress = function (e) {
    return t.zeroAddress() === t.addHexPrefix(e);
  }, t.toChecksumAddress = function (e) {
    e = t.stripHexPrefix(e).toLowerCase();

    for (var a = t.keccak(e).toString("hex"), r = "0x", n = 0; n < e.length; n++) {
      parseInt(a[n], 16) >= 8 ? r += e[n].toUpperCase() : r += e[n];
    }

    return r;
  }, t.isValidChecksumAddress = function (e) {
    return t.isValidAddress(e) && t.toChecksumAddress(e) === e;
  }, t.generateAddress = function (e, a) {
    return e = t.toBuffer(e), a = (a = new c(a)).isZero() ? null : d.from(a.toArray()), t.rlphash([e, a]).slice(-20);
  }, t.isPrecompiled = function (e) {
    var a = t.unpad(e);
    return 1 === a.length && a[0] >= 1 && a[0] <= 8;
  }, t.addHexPrefix = function (e) {
    return "string" != typeof e ? e : t.isHexPrefixed(e) ? e : "0x" + e;
  }, t.isValidSignature = function (e, t, a, r) {
    var n = new c("7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a0", 16),
        s = new c("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", 16);
    return 32 === t.length && 32 === a.length && (27 === e || 28 === e) && (t = new c(t), a = new c(a), !(t.isZero() || t.gt(s) || a.isZero() || a.gt(s)) && (!1 !== r || 1 !== new c(a).cmp(n)));
  }, t.baToJSON = function (e) {
    if (d.isBuffer(e)) return "0x" + e.toString("hex");

    if (e instanceof Array) {
      for (var a = [], r = 0; r < e.length; r++) {
        a.push(t.baToJSON(e[r]));
      }

      return a;
    }
  }, t.defineProperties = function (e, a, n) {
    if (e.raw = [], e._fields = [], e.toJSON = function (a) {
      if (a) {
        var r = {};
        return e._fields.forEach(function (t) {
          r[t] = "0x" + e[t].toString("hex");
        }), r;
      }

      return t.baToJSON(this.raw);
    }, e.serialize = function () {
      return i.encode(e.raw);
    }, a.forEach(function (a, r) {
      function n() {
        return e.raw[r];
      }

      function s(n) {
        "00" !== (n = t.toBuffer(n)).toString("hex") || a.allowZero || (n = d.allocUnsafe(0)), a.allowLess && a.length ? (n = t.stripZeros(n), o(a.length >= n.length, "The field " + a.name + " must not have more " + a.length + " bytes")) : a.allowZero && 0 === n.length || !a.length || o(a.length === n.length, "The field " + a.name + " must have byte length of " + a.length), e.raw[r] = n;
      }

      e._fields.push(a.name), Object.defineProperty(e, a.name, {
        enumerable: !0,
        configurable: !0,
        get: n,
        set: s
      }), a.default && (e[a.name] = a.default), a.alias && Object.defineProperty(e, a.alias, {
        enumerable: !1,
        configurable: !0,
        set: s,
        get: n
      });
    }), n) if ("string" == typeof n && (n = d.from(t.stripHexPrefix(n), "hex")), d.isBuffer(n) && (n = i.decode(n)), Array.isArray(n)) {
      if (n.length > e._fields.length) throw new Error("wrong number of fields in data");
      n.forEach(function (a, r) {
        e[e._fields[r]] = t.toBuffer(a);
      });
    } else {
      if ("object" !== (void 0 === n ? "undefined" : r(n))) throw new Error("invalid data");
      var s = Object.keys(n);
      a.forEach(function (t) {
        -1 !== s.indexOf(t.name) && (e[t.name] = n[t.name]), -1 !== s.indexOf(t.alias) && (e[t.alias] = n[t.alias]);
      });
    }
  };
},
/*!**************************************************!*\
  !*** ./node_modules/ethereum-types/lib/index.js ***!
  \**************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), function (e) {
    e.Stop = "STOP", e.Add = "ADD", e.Mul = "MUL", e.Sub = "SUB", e.Div = "DIV", e.SDiv = "SDIV", e.Mod = "MOD", e.SMod = "SMOD", e.AddMod = "ADDMOD", e.MulMod = "MULMOD", e.Exp = "EXP", e.SignExtend = "SIGNEXTEND", e.Lt = "LT", e.Gt = "GT", e.SLt = "SLT", e.SGt = "SGT", e.Eq = "EQ", e.IsZero = "ISZERO", e.And = "AND", e.Or = "OR", e.Xor = "XOR", e.Not = "NOT", e.Byte = "BYTE", e.Sha3 = "SHA3", e.Address = "ADDRESS", e.Balance = "BALANCE", e.Origin = "ORIGIN", e.Caller = "CALLER", e.CallValue = "CALLVALUE", e.CallDataLoad = "CALLDATALOAD", e.CallDataSize = "CALLDATASIZE", e.CallDataCopy = "CALLDATACOPY", e.CodeSize = "CODESIZE", e.CodeCopy = "CODECOPY", e.GasPrice = "GASPRICE", e.ExtCodeSize = "EXTCODESIZE", e.ExtCodeCopy = "EXTCODECOPY", e.ReturnDataSize = "RETURNDATASIZE", e.ReturnDataCopy = "RETURNDATACOPY", e.BlockHash = "BLOCKHASH", e.Coinbase = "COINBASE", e.TimeStamp = "TimeStamp", e.Number = "NUMBER", e.Difficulty = "DIFFICULTY", e.Gaslimit = "GASLIMIT", e.Pop = "POP", e.MLoad = "MLOAD", e.MStore = "MSTORE", e.MStore8 = "MSTORE8", e.SLoad = "SLOAD", e.SStore = "SSTORE", e.Jump = "JUMP", e.Jumpi = "JUMPI", e.Pc = "PC", e.MSize = "MSIZE", e.Gas = "GAS", e.JumpDest = "JUMPDEST", e.Push1 = "PUSH1", e.Push2 = "PUSH2", e.Push3 = "PUSH3", e.Push4 = "PUSH4", e.Push5 = "PUSH5", e.Push6 = "PUSH6", e.Push7 = "PUSH7", e.Push8 = "PUSH8", e.Push9 = "PUSH9", e.Push10 = "PUSH10", e.Push11 = "PUSH11", e.Push12 = "PUSH12", e.Push13 = "PUSH13", e.Push14 = "PUSH14", e.Push15 = "PUSH15", e.Push16 = "PUSH16", e.Push17 = "PUSH17", e.Push18 = "PUSH18", e.Push19 = "PUSH19", e.Push20 = "PUSH20", e.Push21 = "PUSH21", e.Push22 = "PUSH22", e.Push23 = "PUSH23", e.Push24 = "PUSH24", e.Push25 = "PUSH25", e.Push26 = "PUSH26", e.Push27 = "PUSH27", e.Push28 = "PUSH28", e.Push29 = "PUSH29", e.Push30 = "PUSH30", e.Push31 = "PUSH31", e.Push32 = "PUSH32", e.Dup1 = "DUP1", e.Dup2 = "DUP2", e.Dup3 = "DUP3", e.Dup4 = "DUP4", e.Dup5 = "DUP5", e.Dup6 = "DUP6", e.Dup7 = "DUP7", e.Dup8 = "DUP8", e.Dup9 = "DUP9", e.Dup10 = "DUP10", e.Dup11 = "DUP11", e.Dup12 = "DUP12", e.Dup13 = "DUP13", e.Dup14 = "DUP14", e.Dup15 = "DUP15", e.Dup16 = "DUP16", e.Swap1 = "SWAP1", e.Swap2 = "SWAP2", e.Swap3 = "SWAP3", e.Swap4 = "SWAP4", e.Swap5 = "SWAP5", e.Swap6 = "SWAP6", e.Swap7 = "SWAP7", e.Swap8 = "SWAP8", e.Swap9 = "SWAP9", e.Swap10 = "SWAP10", e.Swap11 = "SWAP11", e.Swap12 = "SWAP12", e.Swap13 = "SWAP13", e.Swap14 = "SWAP14", e.Swap15 = "SWAP15", e.Swap16 = "SWAP16", e.Log1 = "LOG1", e.Log2 = "LOG2", e.Log3 = "LOG3", e.Log4 = "LOG4", e.Create = "CREATE", e.Call = "CALL", e.CallCode = "CALLCODE", e.Return = "RETURN", e.DelegateCall = "DELEGATECALL", e.StaticCall = "STATICCALL", e.Revert = "REVERT", e.Invalid = "INVALID", e.SelfDestruct = "SELFDESTRUCT";
  }(t.OpCode || (t.OpCode = {})), function (e) {
    e.Function = "function", e.Constructor = "constructor", e.Event = "event", e.Fallback = "fallback";
  }(t.AbiType || (t.AbiType = {})), function (e) {
    e.Earliest = "earliest", e.Latest = "latest", e.Pending = "pending";
  }(t.BlockParamLiteral || (t.BlockParamLiteral = {})), function (e) {
    e.Address = "address", e.Bool = "bool", e.Bytes = "bytes", e.Int = "int", e.String = "string", e.Tuple = "tuple", e.Uint256 = "uint256", e.Uint8 = "uint8", e.Uint = "uint";
  }(t.SolidityTypes || (t.SolidityTypes = {}));
},
/*!***********************************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/abi_encoder/utils/constants.js ***!
  \***********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = a(
  /*! ethereumjs-util */
  24);
  t.constants = {
    EVM_WORD_WIDTH_IN_BYTES: 32,
    EVM_WORD_WIDTH_IN_BITS: 256,
    HEX_BASE: 16,
    DEC_BASE: 10,
    BIN_BASE: 2,
    HEX_SELECTOR_LENGTH_IN_CHARS: 10,
    HEX_SELECTOR_LENGTH_IN_BYTES: 4,
    HEX_SELECTOR_BYTE_OFFSET_IN_CALLDATA: 0,
    DEFAULT_DECODING_RULES: {
      shouldConvertStructsToObjects: !0
    },
    DEFAULT_ENCODING_RULES: {
      shouldOptimize: !0,
      shouldAnnotate: !1
    },
    EMPTY_EVM_WORD_STRING: "0x0000000000000000000000000000000000000000000000000000000000000000",
    EMPTY_EVM_WORD_BUFFER: r.toBuffer("0x0000000000000000000000000000000000000000000000000000000000000000"),
    NUMBER_OF_BYTES_IN_UINT8: 8,
    NUMBER_OF_BYTES_IN_INT8: 8
  };
},
/*!***********************************************!*\
  !*** ./node_modules/core-util-is/lib/util.js ***!
  \***********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (e) {
    function a(e) {
      return Object.prototype.toString.call(e);
    }

    t.isArray = function (e) {
      return Array.isArray ? Array.isArray(e) : "[object Array]" === a(e);
    }, t.isBoolean = function (e) {
      return "boolean" == typeof e;
    }, t.isNull = function (e) {
      return null === e;
    }, t.isNullOrUndefined = function (e) {
      return null == e;
    }, t.isNumber = function (e) {
      return "number" == typeof e;
    }, t.isString = function (e) {
      return "string" == typeof e;
    }, t.isSymbol = function (e) {
      return "symbol" == typeof e;
    }, t.isUndefined = function (e) {
      return void 0 === e;
    }, t.isRegExp = function (e) {
      return "[object RegExp]" === a(e);
    }, t.isObject = function (e) {
      return "object" == typeof e && null !== e;
    }, t.isDate = function (e) {
      return "[object Date]" === a(e);
    }, t.isError = function (e) {
      return "[object Error]" === a(e) || e instanceof Error;
    }, t.isFunction = function (e) {
      return "function" == typeof e;
    }, t.isPrimitive = function (e) {
      return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
    }, t.isBuffer = e.isBuffer;
  }).call(this, a(
  /*! ./../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!*************************************************!*\
  !*** ./node_modules/stream-browserify/index.js ***!
  \*************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  e.exports = n;
  var r = a(
  /*! events */
  41).EventEmitter;

  function n() {
    r.call(this);
  }

  a(
  /*! inherits */
  3)(n, r), n.Readable = a(
  /*! readable-stream/readable.js */
  58), n.Writable = a(
  /*! readable-stream/writable.js */
  384), n.Duplex = a(
  /*! readable-stream/duplex.js */
  385), n.Transform = a(
  /*! readable-stream/transform.js */
  386), n.PassThrough = a(
  /*! readable-stream/passthrough.js */
  387), n.Stream = n, n.prototype.pipe = function (e, t) {
    var a = this;

    function n(t) {
      e.writable && !1 === e.write(t) && a.pause && a.pause();
    }

    function s() {
      a.readable && a.resume && a.resume();
    }

    a.on("data", n), e.on("drain", s), e._isStdio || t && !1 === t.end || (a.on("end", i), a.on("close", c));
    var o = !1;

    function i() {
      o || (o = !0, e.end());
    }

    function c() {
      o || (o = !0, "function" == typeof e.destroy && e.destroy());
    }

    function u(e) {
      if (d(), 0 === r.listenerCount(this, "error")) throw e;
    }

    function d() {
      a.removeListener("data", n), e.removeListener("drain", s), a.removeListener("end", i), a.removeListener("close", c), a.removeListener("error", u), e.removeListener("error", u), a.removeListener("end", d), a.removeListener("close", d), e.removeListener("close", d);
    }

    return a.on("error", u), e.on("error", u), a.on("end", d), a.on("close", d), e.on("close", d), e.emit("pipe", a), e;
  };
},
/*!**************************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-vm/node_modules/ethereumjs-util/dist/index.js ***!
  \**************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = a(
  /*! bn.js */
  5);
  t.BN = r;
  var n = a(
  /*! rlp */
  21);
  t.rlp = n;
  var s = a(
  /*! keccak */
  33),
      o = a(
  /*! secp256k1 */
  30);
  t.secp256k1 = o;
  var i = a(
  /*! assert */
  19),
      c = a(
  /*! create-hash */
  20),
      u = a(
  /*! safe-buffer */
  7).Buffer,
      d = a(
  /*! ethjs-util */
  36);

  function f(e, t) {
    return t ? e - (2 * t + 35) : e - 27;
  }

  function l(e) {
    return 0 === e || 1 === e;
  }

  Object.assign(t, d), t.MAX_INTEGER = new r("ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff", 16), t.TWO_POW256 = new r("10000000000000000000000000000000000000000000000000000000000000000", 16), t.KECCAK256_NULL_S = "c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470", t.KECCAK256_NULL = u.from(t.KECCAK256_NULL_S, "hex"), t.KECCAK256_RLP_ARRAY_S = "1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347", t.KECCAK256_RLP_ARRAY = u.from(t.KECCAK256_RLP_ARRAY_S, "hex"), t.KECCAK256_RLP_S = "56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421", t.KECCAK256_RLP = u.from(t.KECCAK256_RLP_S, "hex"), t.zeros = function (e) {
    return u.allocUnsafe(e).fill(0);
  }, t.zeroAddress = function () {
    var e = t.zeros(20);
    return t.bufferToHex(e);
  }, t.setLengthLeft = function (e, a, r) {
    void 0 === r && (r = !1);
    var n = t.zeros(a);
    return e = t.toBuffer(e), r ? e.length < a ? (e.copy(n), n) : e.slice(0, a) : e.length < a ? (e.copy(n, a - e.length), n) : e.slice(-a);
  }, t.setLength = t.setLengthLeft, t.setLengthRight = function (e, a) {
    return t.setLength(e, a, !0);
  }, t.unpad = function (e) {
    for (var t = (e = d.stripHexPrefix(e))[0]; e.length > 0 && "0" === t.toString();) {
      t = (e = e.slice(1))[0];
    }

    return e;
  }, t.stripZeros = t.unpad, t.toBuffer = function (e) {
    if (!u.isBuffer(e)) if (Array.isArray(e)) e = u.from(e);else if ("string" == typeof e) e = t.isHexString(e) ? u.from(t.padToEven(t.stripHexPrefix(e)), "hex") : u.from(e);else if ("number" == typeof e) e = t.intToBuffer(e);else if (null == e) e = u.allocUnsafe(0);else if (r.isBN(e)) e = e.toArrayLike(u);else {
      if (!e.toArray) throw new Error("invalid type");
      e = u.from(e.toArray());
    }
    return e;
  }, t.bufferToInt = function (e) {
    return new r(t.toBuffer(e)).toNumber();
  }, t.bufferToHex = function (e) {
    return "0x" + (e = t.toBuffer(e)).toString("hex");
  }, t.fromSigned = function (e) {
    return new r(e).fromTwos(256);
  }, t.toUnsigned = function (e) {
    return u.from(e.toTwos(256).toArray());
  }, t.keccak = function (e, a) {
    return void 0 === a && (a = 256), e = t.toBuffer(e), a || (a = 256), s("keccak" + a).update(e).digest();
  }, t.keccak256 = function (e) {
    return t.keccak(e);
  }, t.sha256 = function (e) {
    return e = t.toBuffer(e), c("sha256").update(e).digest();
  }, t.ripemd160 = function (e, a) {
    e = t.toBuffer(e);
    var r = c("rmd160").update(e).digest();
    return !0 === a ? t.setLength(r, 32) : r;
  }, t.rlphash = function (e) {
    return t.keccak(n.encode(e));
  }, t.isValidPrivate = function (e) {
    return o.privateKeyVerify(e);
  }, t.isValidPublic = function (e, t) {
    return void 0 === t && (t = !1), 64 === e.length ? o.publicKeyVerify(u.concat([u.from([4]), e])) : !!t && o.publicKeyVerify(e);
  }, t.pubToAddress = function (e, a) {
    return void 0 === a && (a = !1), e = t.toBuffer(e), a && 64 !== e.length && (e = o.publicKeyConvert(e, !1).slice(1)), i(64 === e.length), t.keccak(e).slice(-20);
  }, t.publicToAddress = t.pubToAddress, t.privateToPublic = function (e) {
    return e = t.toBuffer(e), o.publicKeyCreate(e, !1).slice(1);
  }, t.importPublic = function (e) {
    return 64 !== (e = t.toBuffer(e)).length && (e = o.publicKeyConvert(e, !1).slice(1)), e;
  }, t.ecsign = function (e, t, a) {
    var r = o.sign(e, t),
        n = r.recovery;
    return {
      r: r.signature.slice(0, 32),
      s: r.signature.slice(32, 64),
      v: a ? n + (2 * a + 35) : n + 27
    };
  }, t.hashPersonalMessage = function (e) {
    var a = t.toBuffer("Ethereum Signed Message:\n" + e.length.toString());
    return t.keccak(u.concat([a, e]));
  }, t.ecrecover = function (e, a, r, n, s) {
    var i = u.concat([t.setLength(r, 32), t.setLength(n, 32)], 64),
        c = f(a, s);
    if (!l(c)) throw new Error("Invalid signature v value");
    var d = o.recover(e, i, c);
    return o.publicKeyConvert(d, !1).slice(1);
  }, t.toRpcSig = function (e, a, r, n) {
    if (!l(f(e, n))) throw new Error("Invalid signature v value");
    return t.bufferToHex(u.concat([t.setLengthLeft(a, 32), t.setLengthLeft(r, 32), t.toBuffer(e)]));
  }, t.fromRpcSig = function (e) {
    var a = t.toBuffer(e);
    if (65 !== a.length) throw new Error("Invalid signature length");
    var r = a[64];
    return r < 27 && (r += 27), {
      v: r,
      r: a.slice(0, 32),
      s: a.slice(32, 64)
    };
  }, t.privateToAddress = function (e) {
    return t.publicToAddress(t.privateToPublic(e));
  }, t.isValidAddress = function (e) {
    return /^0x[0-9a-fA-F]{40}$/.test(e);
  }, t.isZeroAddress = function (e) {
    return t.zeroAddress() === t.addHexPrefix(e);
  }, t.toChecksumAddress = function (e) {
    e = d.stripHexPrefix(e).toLowerCase();

    for (var a = t.keccak(e).toString("hex"), r = "0x", n = 0; n < e.length; n++) {
      parseInt(a[n], 16) >= 8 ? r += e[n].toUpperCase() : r += e[n];
    }

    return r;
  }, t.isValidChecksumAddress = function (e) {
    return t.isValidAddress(e) && t.toChecksumAddress(e) === e;
  }, t.generateAddress = function (e, a) {
    e = t.toBuffer(e);
    var n = new r(a);
    return n.isZero() ? t.rlphash([e, null]).slice(-20) : t.rlphash([e, u.from(n.toArray())]).slice(-20);
  }, t.generateAddress2 = function (e, a, r) {
    var n = t.toBuffer(e),
        s = t.toBuffer(a),
        o = t.toBuffer(r);
    return i(20 === n.length), i(32 === s.length), t.keccak256(u.concat([u.from("ff", "hex"), n, s, t.keccak256(o)])).slice(-20);
  }, t.isPrecompiled = function (e) {
    var a = t.unpad(e);
    return 1 === a.length && a[0] >= 1 && a[0] <= 8;
  }, t.addHexPrefix = function (e) {
    return "string" != typeof e ? e : d.isHexPrefixed(e) ? e : "0x" + e;
  }, t.isValidSignature = function (e, t, a, n, s) {
    void 0 === n && (n = !0);
    var o = new r("7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a0", 16),
        i = new r("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", 16);
    if (32 !== t.length || 32 !== a.length) return !1;
    if (!l(f(e, s))) return !1;
    var c = new r(t),
        u = new r(a);
    return !(c.isZero() || c.gt(i) || u.isZero() || u.gt(i)) && (!n || 1 !== u.cmp(o));
  }, t.baToJSON = function (e) {
    if (u.isBuffer(e)) return "0x" + e.toString("hex");

    if (e instanceof Array) {
      for (var a = [], r = 0; r < e.length; r++) {
        a.push(t.baToJSON(e[r]));
      }

      return a;
    }
  }, t.defineProperties = function (e, a, r) {
    if (e.raw = [], e._fields = [], e.toJSON = function (a) {
      if (void 0 === a && (a = !1), a) {
        var r = {};
        return e._fields.forEach(function (t) {
          r[t] = "0x" + e[t].toString("hex");
        }), r;
      }

      return t.baToJSON(e.raw);
    }, e.serialize = function () {
      return n.encode(e.raw);
    }, a.forEach(function (a, r) {
      function n() {
        return e.raw[r];
      }

      function s(n) {
        "00" !== (n = t.toBuffer(n)).toString("hex") || a.allowZero || (n = u.allocUnsafe(0)), a.allowLess && a.length ? (n = t.stripZeros(n), i(a.length >= n.length, "The field " + a.name + " must not have more " + a.length + " bytes")) : a.allowZero && 0 === n.length || !a.length || i(a.length === n.length, "The field " + a.name + " must have byte length of " + a.length), e.raw[r] = n;
      }

      e._fields.push(a.name), Object.defineProperty(e, a.name, {
        enumerable: !0,
        configurable: !0,
        get: n,
        set: s
      }), a.default && (e[a.name] = a.default), a.alias && Object.defineProperty(e, a.alias, {
        enumerable: !1,
        configurable: !0,
        set: s,
        get: n
      });
    }), r) if ("string" == typeof r && (r = u.from(d.stripHexPrefix(r), "hex")), u.isBuffer(r) && (r = n.decode(r)), Array.isArray(r)) {
      if (r.length > e._fields.length) throw new Error("wrong number of fields in data");
      r.forEach(function (a, r) {
        e[e._fields[r]] = t.toBuffer(a);
      });
    } else {
      if ("object" != typeof r) throw new Error("invalid data");
      var s = Object.keys(r);
      a.forEach(function (t) {
        -1 !== s.indexOf(t.name) && (e[t.name] = r[t.name]), -1 !== s.indexOf(t.alias) && (e[t.alias] = r[t.alias]);
      });
    }
  };
},
/*!********************************************!*\
  !*** ./node_modules/secp256k1/elliptic.js ***!
  \********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  e.exports = a(
  /*! ./lib */
  391)(a(
  /*! ./lib/elliptic */
  395));
},
/*!*****************************************************!*\
  !*** ./node_modules/elliptic/lib/elliptic/utils.js ***!
  \*****************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = t,
      n = a(
  /*! bn.js */
  5),
      s = a(
  /*! minimalistic-assert */
  22),
      o = a(
  /*! minimalistic-crypto-utils */
  161);
  r.assert = s, r.toArray = o.toArray, r.zero2 = o.zero2, r.toHex = o.toHex, r.encode = o.encode, r.getNAF = function (e, t) {
    for (var a = [], r = 1 << t + 1, n = e.clone(); n.cmpn(1) >= 0;) {
      var s;

      if (n.isOdd()) {
        var o = n.andln(r - 1);
        s = o > (r >> 1) - 1 ? (r >> 1) - o : o, n.isubn(s);
      } else s = 0;

      a.push(s);

      for (var i = 0 !== n.cmpn(0) && 0 === n.andln(r - 1) ? t + 1 : 1, c = 1; c < i; c++) {
        a.push(0);
      }

      n.iushrn(i);
    }

    return a;
  }, r.getJSF = function (e, t) {
    var a = [[], []];
    e = e.clone(), t = t.clone();

    for (var r = 0, n = 0; e.cmpn(-r) > 0 || t.cmpn(-n) > 0;) {
      var s,
          o,
          i,
          c = e.andln(3) + r & 3,
          u = t.andln(3) + n & 3;
      if (3 === c && (c = -1), 3 === u && (u = -1), 0 == (1 & c)) s = 0;else s = 3 !== (i = e.andln(7) + r & 7) && 5 !== i || 2 !== u ? c : -c;
      if (a[0].push(s), 0 == (1 & u)) o = 0;else o = 3 !== (i = t.andln(7) + n & 7) && 5 !== i || 2 !== c ? u : -u;
      a[1].push(o), 2 * r === s + 1 && (r = 1 - r), 2 * n === o + 1 && (n = 1 - n), e.iushrn(1), t.iushrn(1);
    }

    return a;
  }, r.cachedProperty = function (e, t, a) {
    var r = "_" + t;

    e.prototype[t] = function () {
      return void 0 !== this[r] ? this[r] : this[r] = a.call(this);
    };
  }, r.parseBytes = function (e) {
    return "string" == typeof e ? r.toArray(e, "hex") : e;
  }, r.intFromLE = function (e) {
    return new n(e, "hex", "le");
  };
},
/*!***********************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-vm/dist/evm/evm.js ***!
  \***********************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, a = 1, r = arguments.length; a < r; a++) {
          for (var n in t = arguments[a]) {
            Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        n = this && this.__awaiter || function (e, t, a, r) {
      return new (a || (a = Promise))(function (n, s) {
        function o(e) {
          try {
            c(r.next(e));
          } catch (e) {
            s(e);
          }
        }

        function i(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            s(e);
          }
        }

        function c(e) {
          e.done ? n(e.value) : new a(function (t) {
            t(e.value);
          }).then(o, i);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        s = this && this.__generator || function (e, t) {
      var a,
          r,
          n,
          s,
          o = {
        label: 0,
        sent: function sent() {
          if (1 & n[0]) throw n[1];
          return n[1];
        },
        trys: [],
        ops: []
      };
      return s = {
        next: i(0),
        throw: i(1),
        return: i(2)
      }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
        return this;
      }), s;

      function i(s) {
        return function (i) {
          return function (s) {
            if (a) throw new TypeError("Generator is already executing.");

            for (; o;) {
              try {
                if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

                switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                  case 0:
                  case 1:
                    n = s;
                    break;

                  case 4:
                    return o.label++, {
                      value: s[1],
                      done: !1
                    };

                  case 5:
                    o.label++, r = s[1], s = [0];
                    continue;

                  case 7:
                    s = o.ops.pop(), o.trys.pop();
                    continue;

                  default:
                    if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                      o = 0;
                      continue;
                    }

                    if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                      o.label = s[1];
                      break;
                    }

                    if (6 === s[0] && o.label < n[1]) {
                      o.label = n[1], n = s;
                      break;
                    }

                    if (n && o.label < n[2]) {
                      o.label = n[2], o.ops.push(s);
                      break;
                    }

                    n[2] && o.ops.pop(), o.trys.pop();
                    continue;
                }

                s = t.call(e, o);
              } catch (e) {
                s = [6, e], r = 0;
              } finally {
                a = n = 0;
              }
            }

            if (5 & s[0]) throw s[1];
            return {
              value: s[0] ? s[1] : void 0,
              done: !0
            };
          }([s, i]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = a(
    /*! bn.js */
    5),
        i = a(
    /*! ethereumjs-util */
    29),
        c = a(
    /*! ../exceptions */
    66),
        u = a(
    /*! ../state/promisified */
    74),
        d = a(
    /*! ./precompiles */
    660),
        f = a(
    /*! ./eei */
    716),
        l = a(
    /*! ./interpreter */
    717),
        h = a(
    /*! ethereumjs-block */
    60);

    function p(t) {
      return {
        returnValue: e.alloc(0),
        gasUsed: t,
        exceptionError: new c.VmError(c.ERROR.OUT_OF_GAS)
      };
    }

    t.OOGResult = p;

    var b = function () {
      function t(e, t, a) {
        this._vm = e, this._state = new u.default(this._vm.stateManager), this._tx = t, this._block = a;
      }

      return t.prototype.executeMessage = function (e) {
        return n(this, void 0, void 0, function () {
          var t, a;
          return s(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this._vm._emit("beforeMessage", e)];

              case 1:
                return r.sent(), [4, this._state.checkpoint()];

              case 2:
                return r.sent(), e.to ? [4, this._executeCall(e)] : [3, 4];

              case 3:
                return t = r.sent(), [3, 6];

              case 4:
                return [4, this._executeCreate(e)];

              case 5:
                t = r.sent(), r.label = 6;

              case 6:
                return (a = t.execResult.exceptionError) ? (t.execResult.logs = [], [4, this._state.revert()]) : [3, 10];

              case 7:
                return r.sent(), e.isCompiled ? a.error !== c.ERROR.OUT_OF_GAS ? [3, 9] : [4, this._touchAccount(e.to)] : [3, 9];

              case 8:
                r.sent(), r.label = 9;

              case 9:
                return [3, 12];

              case 10:
                return [4, this._state.commit()];

              case 11:
                r.sent(), r.label = 12;

              case 12:
                return [4, this._vm._emit("afterMessage", t)];

              case 13:
                return r.sent(), [2, t];
            }
          });
        });
      }, t.prototype._executeCall = function (t) {
        return n(this, void 0, void 0, function () {
          var a, r, n;
          return s(this, function (s) {
            switch (s.label) {
              case 0:
                return [4, this._state.getAccount(t.caller)];

              case 1:
                return a = s.sent(), t.delegatecall ? [3, 3] : [4, this._reduceSenderBalance(a, t)];

              case 2:
                s.sent(), s.label = 3;

              case 3:
                return [4, this._state.getAccount(t.to)];

              case 4:
                return r = s.sent(), t.delegatecall ? [3, 6] : [4, this._addToBalance(r, t)];

              case 5:
                s.sent(), s.label = 6;

              case 6:
                return [4, this._loadCode(t)];

              case 7:
                return s.sent(), t.code && 0 !== t.code.length ? t.isCompiled ? (n = this.runPrecompile(t.code, t.data, t.gasLimit), [3, 10]) : [3, 8] : [2, {
                  gasUsed: new o(0),
                  execResult: {
                    gasUsed: new o(0),
                    returnValue: e.alloc(0)
                  }
                }];

              case 8:
                return [4, this.runInterpreter(t)];

              case 9:
                n = s.sent(), s.label = 10;

              case 10:
                return [2, {
                  gasUsed: n.gasUsed,
                  execResult: n
                }];
            }
          });
        });
      }, t.prototype._executeCreate = function (t) {
        return n(this, void 0, void 0, function () {
          var a, n, u, d, f, l, h;
          return s(this, function (s) {
            switch (s.label) {
              case 0:
                return [4, this._state.getAccount(t.caller)];

              case 1:
                return a = s.sent(), [4, this._reduceSenderBalance(a, t)];

              case 2:
                return s.sent(), t.code = t.data, t.data = e.alloc(0), n = t, [4, this._generateAddress(t)];

              case 3:
                return n.to = s.sent(), [4, this._state.getAccount(t.to)];

              case 4:
                return (u = s.sent()).nonce && new o(u.nonce).gtn(0) || 0 !== u.codeHash.compare(i.KECCAK256_NULL) ? [2, {
                  gasUsed: t.gasLimit,
                  createdAddress: t.to,
                  execResult: {
                    returnValue: e.alloc(0),
                    exceptionError: new c.VmError(c.ERROR.CREATE_COLLISION),
                    gasUsed: t.gasLimit
                  }
                }] : [4, this._state.clearContractStorage(t.to)];

              case 5:
                return s.sent(), d = {
                  address: t.to,
                  code: t.code
                }, [4, this._vm._emit("newContract", d)];

              case 6:
                return s.sent(), [4, this._state.getAccount(t.to)];

              case 7:
                return (u = s.sent()).nonce = new o(u.nonce).addn(1).toArrayLike(e), [4, this._addToBalance(u, t)];

              case 8:
                return s.sent(), t.code && 0 !== t.code.length ? [4, this.runInterpreter(t)] : [2, {
                  gasUsed: new o(0),
                  createdAddress: t.to,
                  execResult: {
                    gasUsed: new o(0),
                    returnValue: e.alloc(0)
                  }
                }];

              case 9:
                return f = s.sent(), l = f.gasUsed, f.exceptionError || (h = new o(f.returnValue.length * this._vm._common.param("gasPrices", "createData")), l = l.add(h)), l.lte(t.gasLimit) && (this._vm.allowUnlimitedContractSize || f.returnValue.length <= 24576) ? f.gasUsed = l : f = r({}, f, p(t.gasLimit)), f.exceptionError || !f.returnValue || "" === f.returnValue.toString() ? [3, 11] : [4, this._state.putContractCode(t.to, f.returnValue)];

              case 10:
                s.sent(), s.label = 11;

              case 11:
                return [2, {
                  gasUsed: f.gasUsed,
                  createdAddress: t.to,
                  execResult: f
                }];
            }
          });
        });
      }, t.prototype.runInterpreter = function (t, a) {
        return void 0 === a && (a = {}), n(this, void 0, void 0, function () {
          var n, u, d, p, b, m;
          return s(this, function (s) {
            switch (s.label) {
              case 0:
                return u = {
                  blockchain: this._vm.blockchain,
                  address: t.to || i.zeros(32),
                  caller: t.caller || i.zeros(32),
                  callData: t.data || e.from([0]),
                  callValue: t.value || new o(0),
                  code: t.code,
                  isStatic: t.isStatic || !1,
                  depth: t.depth || 0,
                  gasPrice: this._tx.gasPrice,
                  origin: this._tx.origin || t.caller || i.zeros(32),
                  block: this._block || new h()
                }, [4, this._state.getAccount(t.to || i.zeros(32))];

              case 1:
                return u.contract = s.sent(), n = u, d = new f.default(n, this._state, this, this._vm._common, t.gasLimit.clone()), t.selfdestruct && (d._result.selfdestruct = t.selfdestruct), [4, new l.default(this._vm, d).run(t.code, a)];

              case 2:
                return p = s.sent(), b = d._result, m = t.gasLimit.sub(d._gasLeft), p.exceptionError && (p.exceptionError.error !== c.ERROR.REVERT && (m = t.gasLimit), b = r({}, b, {
                  logs: [],
                  gasRefund: new o(0),
                  selfdestruct: {}
                })), [2, r({}, b, {
                  runState: r({}, p.runState, b, d._env),
                  exceptionError: p.exceptionError,
                  gas: d._gasLeft,
                  gasUsed: m,
                  returnValue: b.returnValue ? b.returnValue : e.alloc(0)
                })];
            }
          });
        });
      }, t.prototype.getPrecompile = function (e) {
        return d.getPrecompile(e.toString("hex"));
      }, t.prototype.runPrecompile = function (e, t, a) {
        if ("function" != typeof e) throw new Error("Invalid precompile");
        return e({
          data: t,
          gasLimit: a,
          _common: this._vm._common
        });
      }, t.prototype._loadCode = function (e) {
        return n(this, void 0, void 0, function () {
          var t, a;
          return s(this, function (r) {
            switch (r.label) {
              case 0:
                return e.code ? [3, 3] : (t = this.getPrecompile(e.codeAddress)) ? (e.code = t, e.isCompiled = !0, [3, 3]) : [3, 1];

              case 1:
                return a = e, [4, this._state.getContractCode(e.codeAddress)];

              case 2:
                a.code = r.sent(), e.isCompiled = !1, r.label = 3;

              case 3:
                return [2];
            }
          });
        });
      }, t.prototype._generateAddress = function (t) {
        return n(this, void 0, void 0, function () {
          var a, r, n;
          return s(this, function (s) {
            switch (s.label) {
              case 0:
                return t.salt ? (a = i.generateAddress2(t.caller, t.salt, t.code), [3, 3]) : [3, 1];

              case 1:
                return [4, this._state.getAccount(t.caller)];

              case 2:
                r = s.sent(), n = new o(r.nonce).subn(1), a = i.generateAddress(t.caller, n.toArrayLike(e)), s.label = 3;

              case 3:
                return [2, a];
            }
          });
        });
      }, t.prototype._reduceSenderBalance = function (e, t) {
        return n(this, void 0, void 0, function () {
          var a;
          return s(this, function (r) {
            return a = new o(e.balance).sub(t.value), e.balance = i.toBuffer(a), [2, this._state.putAccount(i.toBuffer(t.caller), e)];
          });
        });
      }, t.prototype._addToBalance = function (e, t) {
        return n(this, void 0, void 0, function () {
          var a;
          return s(this, function (r) {
            if ((a = new o(e.balance).add(t.value)).gt(i.MAX_INTEGER)) throw new Error("Value overflow");
            return e.balance = i.toBuffer(a), [2, this._state.putAccount(i.toBuffer(t.to), e)];
          });
        });
      }, t.prototype._touchAccount = function (e) {
        return n(this, void 0, void 0, function () {
          var t;
          return s(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this._state.getAccount(e)];

              case 1:
                return t = a.sent(), [2, this._state.putAccount(e, t)];
            }
          });
        });
      }, t;
    }();

    t.default = b;
  }).call(this, a(
  /*! ./../../../../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!***********************************!*\
  !*** ./node_modules/keccak/js.js ***!
  \***********************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  e.exports = a(
  /*! ./lib/api */
  376)(a(
  /*! ./lib/keccak */
  389));
},
/*!**********************************************************************!*\
  !*** ./node_modules/elliptic/node_modules/hash.js/lib/hash/utils.js ***!
  \**********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! minimalistic-assert */
  22),
      n = a(
  /*! inherits */
  3);

  function s(e, t) {
    return 55296 == (64512 & e.charCodeAt(t)) && !(t < 0 || t + 1 >= e.length) && 56320 == (64512 & e.charCodeAt(t + 1));
  }

  function o(e) {
    return (e >>> 24 | e >>> 8 & 65280 | e << 8 & 16711680 | (255 & e) << 24) >>> 0;
  }

  function i(e) {
    return 1 === e.length ? "0" + e : e;
  }

  function c(e) {
    return 7 === e.length ? "0" + e : 6 === e.length ? "00" + e : 5 === e.length ? "000" + e : 4 === e.length ? "0000" + e : 3 === e.length ? "00000" + e : 2 === e.length ? "000000" + e : 1 === e.length ? "0000000" + e : e;
  }

  t.inherits = n, t.toArray = function (e, t) {
    if (Array.isArray(e)) return e.slice();
    if (!e) return [];
    var a = [];
    if ("string" == typeof e) {
      if (t) {
        if ("hex" === t) for ((e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e), n = 0; n < e.length; n += 2) {
          a.push(parseInt(e[n] + e[n + 1], 16));
        }
      } else for (var r = 0, n = 0; n < e.length; n++) {
        var o = e.charCodeAt(n);
        o < 128 ? a[r++] = o : o < 2048 ? (a[r++] = o >> 6 | 192, a[r++] = 63 & o | 128) : s(e, n) ? (o = 65536 + ((1023 & o) << 10) + (1023 & e.charCodeAt(++n)), a[r++] = o >> 18 | 240, a[r++] = o >> 12 & 63 | 128, a[r++] = o >> 6 & 63 | 128, a[r++] = 63 & o | 128) : (a[r++] = o >> 12 | 224, a[r++] = o >> 6 & 63 | 128, a[r++] = 63 & o | 128);
      }
    } else for (n = 0; n < e.length; n++) {
      a[n] = 0 | e[n];
    }
    return a;
  }, t.toHex = function (e) {
    for (var t = "", a = 0; a < e.length; a++) {
      t += i(e[a].toString(16));
    }

    return t;
  }, t.htonl = o, t.toHex32 = function (e, t) {
    for (var a = "", r = 0; r < e.length; r++) {
      var n = e[r];
      "little" === t && (n = o(n)), a += c(n.toString(16));
    }

    return a;
  }, t.zero2 = i, t.zero8 = c, t.join32 = function (e, t, a, n) {
    var s = a - t;
    r(s % 4 == 0);

    for (var o = new Array(s / 4), i = 0, c = t; i < o.length; i++, c += 4) {
      var u;
      u = "big" === n ? e[c] << 24 | e[c + 1] << 16 | e[c + 2] << 8 | e[c + 3] : e[c + 3] << 24 | e[c + 2] << 16 | e[c + 1] << 8 | e[c], o[i] = u >>> 0;
    }

    return o;
  }, t.split32 = function (e, t) {
    for (var a = new Array(4 * e.length), r = 0, n = 0; r < e.length; r++, n += 4) {
      var s = e[r];
      "big" === t ? (a[n] = s >>> 24, a[n + 1] = s >>> 16 & 255, a[n + 2] = s >>> 8 & 255, a[n + 3] = 255 & s) : (a[n + 3] = s >>> 24, a[n + 2] = s >>> 16 & 255, a[n + 1] = s >>> 8 & 255, a[n] = 255 & s);
    }

    return a;
  }, t.rotr32 = function (e, t) {
    return e >>> t | e << 32 - t;
  }, t.rotl32 = function (e, t) {
    return e << t | e >>> 32 - t;
  }, t.sum32 = function (e, t) {
    return e + t >>> 0;
  }, t.sum32_3 = function (e, t, a) {
    return e + t + a >>> 0;
  }, t.sum32_4 = function (e, t, a, r) {
    return e + t + a + r >>> 0;
  }, t.sum32_5 = function (e, t, a, r, n) {
    return e + t + a + r + n >>> 0;
  }, t.sum64 = function (e, t, a, r) {
    var n = e[t],
        s = r + e[t + 1] >>> 0,
        o = (s < r ? 1 : 0) + a + n;
    e[t] = o >>> 0, e[t + 1] = s;
  }, t.sum64_hi = function (e, t, a, r) {
    return (t + r >>> 0 < t ? 1 : 0) + e + a >>> 0;
  }, t.sum64_lo = function (e, t, a, r) {
    return t + r >>> 0;
  }, t.sum64_4_hi = function (e, t, a, r, n, s, o, i) {
    var c = 0,
        u = t;
    return c += (u = u + r >>> 0) < t ? 1 : 0, c += (u = u + s >>> 0) < s ? 1 : 0, e + a + n + o + (c += (u = u + i >>> 0) < i ? 1 : 0) >>> 0;
  }, t.sum64_4_lo = function (e, t, a, r, n, s, o, i) {
    return t + r + s + i >>> 0;
  }, t.sum64_5_hi = function (e, t, a, r, n, s, o, i, c, u) {
    var d = 0,
        f = t;
    return d += (f = f + r >>> 0) < t ? 1 : 0, d += (f = f + s >>> 0) < s ? 1 : 0, d += (f = f + i >>> 0) < i ? 1 : 0, e + a + n + o + c + (d += (f = f + u >>> 0) < u ? 1 : 0) >>> 0;
  }, t.sum64_5_lo = function (e, t, a, r, n, s, o, i, c, u) {
    return t + r + s + i + u >>> 0;
  }, t.rotr64_hi = function (e, t, a) {
    return (t << 32 - a | e >>> a) >>> 0;
  }, t.rotr64_lo = function (e, t, a) {
    return (e << 32 - a | t >>> a) >>> 0;
  }, t.shr64_hi = function (e, t, a) {
    return e >>> a;
  }, t.shr64_lo = function (e, t, a) {
    return (e << 32 - a | t >>> a) >>> 0;
  };
},
/*!***********************************************************************!*\
  !*** ./node_modules/hmac-drbg/node_modules/hash.js/lib/hash/utils.js ***!
  \***********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! minimalistic-assert */
  22),
      n = a(
  /*! inherits */
  3);

  function s(e, t) {
    return 55296 == (64512 & e.charCodeAt(t)) && !(t < 0 || t + 1 >= e.length) && 56320 == (64512 & e.charCodeAt(t + 1));
  }

  function o(e) {
    return (e >>> 24 | e >>> 8 & 65280 | e << 8 & 16711680 | (255 & e) << 24) >>> 0;
  }

  function i(e) {
    return 1 === e.length ? "0" + e : e;
  }

  function c(e) {
    return 7 === e.length ? "0" + e : 6 === e.length ? "00" + e : 5 === e.length ? "000" + e : 4 === e.length ? "0000" + e : 3 === e.length ? "00000" + e : 2 === e.length ? "000000" + e : 1 === e.length ? "0000000" + e : e;
  }

  t.inherits = n, t.toArray = function (e, t) {
    if (Array.isArray(e)) return e.slice();
    if (!e) return [];
    var a = [];
    if ("string" == typeof e) {
      if (t) {
        if ("hex" === t) for ((e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e), n = 0; n < e.length; n += 2) {
          a.push(parseInt(e[n] + e[n + 1], 16));
        }
      } else for (var r = 0, n = 0; n < e.length; n++) {
        var o = e.charCodeAt(n);
        o < 128 ? a[r++] = o : o < 2048 ? (a[r++] = o >> 6 | 192, a[r++] = 63 & o | 128) : s(e, n) ? (o = 65536 + ((1023 & o) << 10) + (1023 & e.charCodeAt(++n)), a[r++] = o >> 18 | 240, a[r++] = o >> 12 & 63 | 128, a[r++] = o >> 6 & 63 | 128, a[r++] = 63 & o | 128) : (a[r++] = o >> 12 | 224, a[r++] = o >> 6 & 63 | 128, a[r++] = 63 & o | 128);
      }
    } else for (n = 0; n < e.length; n++) {
      a[n] = 0 | e[n];
    }
    return a;
  }, t.toHex = function (e) {
    for (var t = "", a = 0; a < e.length; a++) {
      t += i(e[a].toString(16));
    }

    return t;
  }, t.htonl = o, t.toHex32 = function (e, t) {
    for (var a = "", r = 0; r < e.length; r++) {
      var n = e[r];
      "little" === t && (n = o(n)), a += c(n.toString(16));
    }

    return a;
  }, t.zero2 = i, t.zero8 = c, t.join32 = function (e, t, a, n) {
    var s = a - t;
    r(s % 4 == 0);

    for (var o = new Array(s / 4), i = 0, c = t; i < o.length; i++, c += 4) {
      var u;
      u = "big" === n ? e[c] << 24 | e[c + 1] << 16 | e[c + 2] << 8 | e[c + 3] : e[c + 3] << 24 | e[c + 2] << 16 | e[c + 1] << 8 | e[c], o[i] = u >>> 0;
    }

    return o;
  }, t.split32 = function (e, t) {
    for (var a = new Array(4 * e.length), r = 0, n = 0; r < e.length; r++, n += 4) {
      var s = e[r];
      "big" === t ? (a[n] = s >>> 24, a[n + 1] = s >>> 16 & 255, a[n + 2] = s >>> 8 & 255, a[n + 3] = 255 & s) : (a[n + 3] = s >>> 24, a[n + 2] = s >>> 16 & 255, a[n + 1] = s >>> 8 & 255, a[n] = 255 & s);
    }

    return a;
  }, t.rotr32 = function (e, t) {
    return e >>> t | e << 32 - t;
  }, t.rotl32 = function (e, t) {
    return e << t | e >>> 32 - t;
  }, t.sum32 = function (e, t) {
    return e + t >>> 0;
  }, t.sum32_3 = function (e, t, a) {
    return e + t + a >>> 0;
  }, t.sum32_4 = function (e, t, a, r) {
    return e + t + a + r >>> 0;
  }, t.sum32_5 = function (e, t, a, r, n) {
    return e + t + a + r + n >>> 0;
  }, t.sum64 = function (e, t, a, r) {
    var n = e[t],
        s = r + e[t + 1] >>> 0,
        o = (s < r ? 1 : 0) + a + n;
    e[t] = o >>> 0, e[t + 1] = s;
  }, t.sum64_hi = function (e, t, a, r) {
    return (t + r >>> 0 < t ? 1 : 0) + e + a >>> 0;
  }, t.sum64_lo = function (e, t, a, r) {
    return t + r >>> 0;
  }, t.sum64_4_hi = function (e, t, a, r, n, s, o, i) {
    var c = 0,
        u = t;
    return c += (u = u + r >>> 0) < t ? 1 : 0, c += (u = u + s >>> 0) < s ? 1 : 0, e + a + n + o + (c += (u = u + i >>> 0) < i ? 1 : 0) >>> 0;
  }, t.sum64_4_lo = function (e, t, a, r, n, s, o, i) {
    return t + r + s + i >>> 0;
  }, t.sum64_5_hi = function (e, t, a, r, n, s, o, i, c, u) {
    var d = 0,
        f = t;
    return d += (f = f + r >>> 0) < t ? 1 : 0, d += (f = f + s >>> 0) < s ? 1 : 0, d += (f = f + i >>> 0) < i ? 1 : 0, e + a + n + o + c + (d += (f = f + u >>> 0) < u ? 1 : 0) >>> 0;
  }, t.sum64_5_lo = function (e, t, a, r, n, s, o, i, c, u) {
    return t + r + s + i + u >>> 0;
  }, t.rotr64_hi = function (e, t, a) {
    return (t << 32 - a | e >>> a) >>> 0;
  }, t.rotr64_lo = function (e, t, a) {
    return (e << 32 - a | t >>> a) >>> 0;
  }, t.shr64_hi = function (e, t, a) {
    return e >>> a;
  }, t.shr64_lo = function (e, t, a) {
    return (e << 32 - a | t >>> a) >>> 0;
  };
},
/*!**********************************************!*\
  !*** ./node_modules/ethjs-util/lib/index.js ***!
  \**********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (t) {
    var r = a(
    /*! is-hex-prefixed */
    170),
        n = a(
    /*! strip-hex-prefix */
    430);

    function s(e) {
      var t = e;
      if ("string" != typeof t) throw new Error("[ethjs-util] while padding to even, value must be string, is currently " + typeof t + ", while padToEven.");
      return t.length % 2 && (t = "0" + t), t;
    }

    function o(e) {
      return "0x" + e.toString(16);
    }

    e.exports = {
      arrayContainsArray: function arrayContainsArray(e, t, a) {
        if (!0 !== Array.isArray(e)) throw new Error("[ethjs-util] method arrayContainsArray requires input 'superset' to be an array got type '" + typeof e + "'");
        if (!0 !== Array.isArray(t)) throw new Error("[ethjs-util] method arrayContainsArray requires input 'subset' to be an array got type '" + typeof t + "'");
        return t[Boolean(a) ? "some" : "every"](function (t) {
          return e.indexOf(t) >= 0;
        });
      },
      intToBuffer: function intToBuffer(e) {
        var a = o(e);
        return new t(s(a.slice(2)), "hex");
      },
      getBinarySize: function getBinarySize(e) {
        if ("string" != typeof e) throw new Error("[ethjs-util] while getting binary size, method getBinarySize requires input 'str' to be type String, got '" + typeof e + "'.");
        return t.byteLength(e, "utf8");
      },
      isHexPrefixed: r,
      stripHexPrefix: n,
      padToEven: s,
      intToHex: o,
      fromAscii: function fromAscii(e) {
        for (var t = "", a = 0; a < e.length; a++) {
          var r = e.charCodeAt(a).toString(16);
          t += r.length < 2 ? "0" + r : r;
        }

        return "0x" + t;
      },
      fromUtf8: function fromUtf8(e) {
        return "0x" + s(new t(e, "utf8").toString("hex")).replace(/^0+|0+$/g, "");
      },
      toAscii: function toAscii(e) {
        var t = "",
            a = 0,
            r = e.length;

        for ("0x" === e.substring(0, 2) && (a = 2); a < r; a += 2) {
          var n = parseInt(e.substr(a, 2), 16);
          t += String.fromCharCode(n);
        }

        return t;
      },
      toUtf8: function toUtf8(e) {
        return new t(s(n(e).replace(/^0+|0+$/g, "")), "hex").toString("utf8");
      },
      getKeys: function getKeys(e, t, a) {
        if (!Array.isArray(e)) throw new Error("[ethjs-util] method getKeys expecting type Array as 'params' input, got '" + typeof e + "'");
        if ("string" != typeof t) throw new Error("[ethjs-util] method getKeys expecting type String for input 'key' got '" + typeof t + "'.");

        for (var r = [], n = 0; n < e.length; n++) {
          var s = e[n][t];
          if (a && !s) s = "";else if ("string" != typeof s) throw new Error("invalid abi");
          r.push(s);
        }

        return r;
      },
      isHexString: function isHexString(e, t) {
        return !("string" != typeof e || !e.match(/^0x[0-9A-Fa-f]*$/)) && (!t || e.length === 2 + 2 * t);
      }
    };
  }).call(this, a(
  /*! ./../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!****************************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/configured_bignumber.js ***!
  \****************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = a(
  /*! bignumber.js */
  432);

  if (t.BigNumber = r.BigNumber, r.BigNumber.config({
    EXPONENTIAL_AT: 1e3,
    DECIMAL_PLACES: 78
  }), a(
  /*! detect-node */
  172)) {
    var n = a(
    /*! util */
    23);

    r.BigNumber.prototype[n.inspect.custom] = function () {
      return this.toString();
    };
  }
},
/*!*******************************************************!*\
  !*** ./node_modules/core-js-pure/internals/global.js ***!
  \*******************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    var a = "object",
        r = function r(e) {
      return e && e.Math == Math && e;
    };

    e.exports = r(typeof globalThis == a && globalThis) || r(typeof window == a && window) || r(typeof self == a && self) || r(typeof t == a && t) || Function("return this")();
  }).call(this, a(
  /*! ./../../webpack/buildin/global.js */
  18));
},
/*!******************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/well-known-symbol.js ***!
  \******************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/global */
  38),
      n = a(
  /*! ../internals/shared */
  123),
      s = a(
  /*! ../internals/uid */
  122),
      o = a(
  /*! ../internals/native-symbol */
  604),
      i = r.Symbol,
      c = n("wks");

  e.exports = function (e) {
    return c[e] || (c[e] = o && i[e] || (o ? i : s)("Symbol." + e));
  };
},
/*!**************************************!*\
  !*** ./src/utils/functions_utils.ts ***!
  \**************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = a(
  /*! ./convert */
  16),
      n = {
    checksumAddressComparision: function checksumAddressComparision(e, t) {
      return r.checksumAddress(e) === r.checksumAddress(t);
    }
  };
  t.default = n;
},
/*!***************************************!*\
  !*** ./node_modules/events/events.js ***!
  \***************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r,
      n = "object" == typeof Reflect ? Reflect : null,
      s = n && "function" == typeof n.apply ? n.apply : function (e, t, a) {
    return Function.prototype.apply.call(e, t, a);
  };
  r = n && "function" == typeof n.ownKeys ? n.ownKeys : Object.getOwnPropertySymbols ? function (e) {
    return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
  } : function (e) {
    return Object.getOwnPropertyNames(e);
  };

  var o = Number.isNaN || function (e) {
    return e != e;
  };

  function i() {
    i.init.call(this);
  }

  e.exports = i, i.EventEmitter = i, i.prototype._events = void 0, i.prototype._eventsCount = 0, i.prototype._maxListeners = void 0;
  var c = 10;

  function u(e) {
    return void 0 === e._maxListeners ? i.defaultMaxListeners : e._maxListeners;
  }

  function d(e, t, a, r) {
    var n, s, o, i;
    if ("function" != typeof a) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof a);
    if (void 0 === (s = e._events) ? (s = e._events = Object.create(null), e._eventsCount = 0) : (void 0 !== s.newListener && (e.emit("newListener", t, a.listener ? a.listener : a), s = e._events), o = s[t]), void 0 === o) o = s[t] = a, ++e._eventsCount;else if ("function" == typeof o ? o = s[t] = r ? [a, o] : [o, a] : r ? o.unshift(a) : o.push(a), (n = u(e)) > 0 && o.length > n && !o.warned) {
      o.warned = !0;
      var c = new Error("Possible EventEmitter memory leak detected. " + o.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      c.name = "MaxListenersExceededWarning", c.emitter = e, c.type = t, c.count = o.length, i = c, console && console.warn && console.warn(i);
    }
    return e;
  }

  function f(e, t, a) {
    var r = {
      fired: !1,
      wrapFn: void 0,
      target: e,
      type: t,
      listener: a
    },
        n = function () {
      for (var e = [], t = 0; t < arguments.length; t++) {
        e.push(arguments[t]);
      }

      this.fired || (this.target.removeListener(this.type, this.wrapFn), this.fired = !0, s(this.listener, this.target, e));
    }.bind(r);

    return n.listener = a, r.wrapFn = n, n;
  }

  function l(e, t, a) {
    var r = e._events;
    if (void 0 === r) return [];
    var n = r[t];
    return void 0 === n ? [] : "function" == typeof n ? a ? [n.listener || n] : [n] : a ? function (e) {
      for (var t = new Array(e.length), a = 0; a < t.length; ++a) {
        t[a] = e[a].listener || e[a];
      }

      return t;
    }(n) : p(n, n.length);
  }

  function h(e) {
    var t = this._events;

    if (void 0 !== t) {
      var a = t[e];
      if ("function" == typeof a) return 1;
      if (void 0 !== a) return a.length;
    }

    return 0;
  }

  function p(e, t) {
    for (var a = new Array(t), r = 0; r < t; ++r) {
      a[r] = e[r];
    }

    return a;
  }

  Object.defineProperty(i, "defaultMaxListeners", {
    enumerable: !0,
    get: function get() {
      return c;
    },
    set: function set(e) {
      if ("number" != typeof e || e < 0 || o(e)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
      c = e;
    }
  }), i.init = function () {
    void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, i.prototype.setMaxListeners = function (e) {
    if ("number" != typeof e || e < 0 || o(e)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
    return this._maxListeners = e, this;
  }, i.prototype.getMaxListeners = function () {
    return u(this);
  }, i.prototype.emit = function (e) {
    for (var t = [], a = 1; a < arguments.length; a++) {
      t.push(arguments[a]);
    }

    var r = "error" === e,
        n = this._events;
    if (void 0 !== n) r = r && void 0 === n.error;else if (!r) return !1;

    if (r) {
      var o;
      if (t.length > 0 && (o = t[0]), o instanceof Error) throw o;
      var i = new Error("Unhandled error." + (o ? " (" + o.message + ")" : ""));
      throw i.context = o, i;
    }

    var c = n[e];
    if (void 0 === c) return !1;
    if ("function" == typeof c) s(c, this, t);else {
      var u = c.length,
          d = p(c, u);

      for (a = 0; a < u; ++a) {
        s(d[a], this, t);
      }
    }
    return !0;
  }, i.prototype.addListener = function (e, t) {
    return d(this, e, t, !1);
  }, i.prototype.on = i.prototype.addListener, i.prototype.prependListener = function (e, t) {
    return d(this, e, t, !0);
  }, i.prototype.once = function (e, t) {
    if ("function" != typeof t) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof t);
    return this.on(e, f(this, e, t)), this;
  }, i.prototype.prependOnceListener = function (e, t) {
    if ("function" != typeof t) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof t);
    return this.prependListener(e, f(this, e, t)), this;
  }, i.prototype.removeListener = function (e, t) {
    var a, r, n, s, o;
    if ("function" != typeof t) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof t);
    if (void 0 === (r = this._events)) return this;
    if (void 0 === (a = r[e])) return this;
    if (a === t || a.listener === t) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete r[e], r.removeListener && this.emit("removeListener", e, a.listener || t));else if ("function" != typeof a) {
      for (n = -1, s = a.length - 1; s >= 0; s--) {
        if (a[s] === t || a[s].listener === t) {
          o = a[s].listener, n = s;
          break;
        }
      }

      if (n < 0) return this;
      0 === n ? a.shift() : function (e, t) {
        for (; t + 1 < e.length; t++) {
          e[t] = e[t + 1];
        }

        e.pop();
      }(a, n), 1 === a.length && (r[e] = a[0]), void 0 !== r.removeListener && this.emit("removeListener", e, o || t);
    }
    return this;
  }, i.prototype.off = i.prototype.removeListener, i.prototype.removeAllListeners = function (e) {
    var t, a, r;
    if (void 0 === (a = this._events)) return this;
    if (void 0 === a.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== a[e] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete a[e]), this;

    if (0 === arguments.length) {
      var n,
          s = Object.keys(a);

      for (r = 0; r < s.length; ++r) {
        "removeListener" !== (n = s[r]) && this.removeAllListeners(n);
      }

      return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
    }

    if ("function" == typeof (t = a[e])) this.removeListener(e, t);else if (void 0 !== t) for (r = t.length - 1; r >= 0; r--) {
      this.removeListener(e, t[r]);
    }
    return this;
  }, i.prototype.listeners = function (e) {
    return l(this, e, !0);
  }, i.prototype.rawListeners = function (e) {
    return l(this, e, !1);
  }, i.listenerCount = function (e, t) {
    return "function" == typeof e.listenerCount ? e.listenerCount(t) : h.call(e, t);
  }, i.prototype.listenerCount = h, i.prototype.eventNames = function () {
    return this._eventsCount > 0 ? r(this._events) : [];
  };
},
/*!*****************************************************!*\
  !*** ./node_modules/core-js-pure/internals/hide.js ***!
  \*****************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/descriptors */
  48),
      n = a(
  /*! ../internals/object-define-property */
  56),
      s = a(
  /*! ../internals/create-property-descriptor */
  118);
  e.exports = r ? function (e, t, a) {
    return n.f(e, t, s(1, a));
  } : function (e, t, a) {
    return e[t] = a, e;
  };
},
/*!******************************!*\
  !*** ./src/PolymathError.ts ***!
  \******************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r2,
      n = this && this.__extends || (_r2 = function r(e, t) {
    return (_r2 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r2(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  });

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var s = function (e) {
    function t(t) {
      var a = t.message,
          r = t.code,
          n = e.call(this, a || "Unknown error, code: " + r) || this;
      return n.code = r, n;
    }

    return n(t, e), t;
  }(Error);

  t.PolymathError = s;
},
/*!***************************************************!*\
  !*** ./src/contract_wrappers/contract_wrapper.ts ***!
  \***************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      n = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      s = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o = a(
  /*! ethereumjs-blockstream */
  819),
      i = s(a(
  /*! lodash */
  0)),
      c = a(
  /*! @0x/json-schemas */
  2),
      u = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      d = s(a(
  /*! ../utils/filter_utils */
  826)),
      f = a(
  /*! ../types */
  4),
      l = a(
  /*! ../PolymathError */
  43),
      h = s(a(
  /*! ../utils/assert */
  15)),
      p = function () {
    function e(e, t) {
      var a = this;
      this.abi = function () {
        return r(a, void 0, void 0, function () {
          return n(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().abi];
            }
          });
        });
      }, this.address = function () {
        return r(a, void 0, void 0, function () {
          return n(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().address];
            }
          });
        });
      }, this.unsubscribe = function (e) {
        h.default.isValidSubscriptionToken("subscriptionToken", e), a.unsubscribeInternal(e);
      }, this.unsubscribeAll = function () {
        var e = i.default.keys(a._filterCallbacks);
        i.default.each(e, function (e) {
          a.unsubscribeInternal(e);
        });
      }, this.getDefaultFromAddress = function () {
        return r(a, void 0, void 0, function () {
          return n(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.web3Wrapper.getAvailableAddressesAsync()];

              case 1:
                return [2, e.sent()[0]];
            }
          });
        });
      }, this.getCallerAddress = function (e) {
        return r(a, void 0, void 0, function () {
          return n(this, function (t) {
            return [2, void 0 === e || void 0 === e.from ? this.getDefaultFromAddress() : e.from];
          });
        });
      }, this.web3Wrapper = e, this.contract = t, this._blockPollingIntervalMs = 1e3, this._filters = {}, this._filterCallbacks = {};
    }

    return e._onBlockAndLogStreamerError = function (e, t) {
      e && u.logUtils.warn(t);
    }, e.prototype.unsubscribeInternal = function (e, t) {
      if (i.default.isUndefined(this._filters[e])) throw new l.PolymathError({
        code: f.ErrorCode.NotFound
      });
      i.default.isUndefined(t) || (0, this._filterCallbacks[e])(t, void 0);
      delete this._filters[e], delete this._filterCallbacks[e], i.default.isEmpty(this._filters) && this._stopBlockAndLogStream();
    }, e.prototype.subscribeInternal = function (e, t, a, s, o) {
      return void 0 === o && (o = !1), r(this, void 0, void 0, function () {
        var r, c, u;
        return n(this, function (n) {
          switch (n.label) {
            case 0:
              return [4, this.contract];

            case 1:
              return r = n.sent().abi, c = d.default.getFilter(e, t, a, r), i.default.isUndefined(this._blockAndLogStreamerIfExists) && this._startBlockAndLogStream(o), u = d.default.generateUUID(), this._filters[u] = c, this._filterCallbacks[u] = s, [2, u];
          }
        });
      });
    }, e.prototype.getLogsAsyncInternal = function (e, t, a, s) {
      return r(this, void 0, void 0, function () {
        var r, o, f, l, p;
        return n(this, function (n) {
          switch (n.label) {
            case 0:
              return [4, this.contract];

            case 1:
              return r = n.sent().abi, o = a || {
                fromBlock: u.BlockParamLiteral.Earliest,
                toBlock: u.BlockParamLiteral.Latest
              }, f = s || {}, h.default.doesConformToSchema("blockRange", o, c.schemas.blockRangeSchema), h.default.doesConformToSchema("indexFilterValues", f, c.schemas.indexFilterValuesSchema), l = d.default.getFilter(e, t, f, r, o), [4, this.web3Wrapper.getLogsAsync(l)];

            case 2:
              return p = n.sent(), [2, i.default.map(p, this.tryToDecodeLogOrNoopInternal.bind(this))];
          }
        });
      });
    }, e.prototype.tryToDecodeLogOrNoopInternal = function (e) {
      return this.web3Wrapper.abiDecoder.tryToDecodeLogOrNoop(e);
    }, e.prototype._onLogStateChanged = function (e, t) {
      var a = this,
          r = u.marshaller.unmarshalLog(t);
      i.default.forEach(this._filters, function (t, n) {
        if (d.default.matchesFilter(r, t)) {
          var s = {
            log: a.tryToDecodeLogOrNoopInternal(r),
            isRemoved: e
          };

          a._filterCallbacks[n](null, s);
        }
      });
    }, e.prototype._startBlockAndLogStream = function (t) {
      if (!i.default.isUndefined(this._blockAndLogStreamerIfExists)) throw new l.PolymathError({
        code: f.ErrorCode.AlreadyExists
      });
      this._blockAndLogStreamerIfExists = new o.BlockAndLogStreamer(this._blockstreamGetBlockOrNullAsync.bind(this), this._blockstreamGetLogsAsync.bind(this), e._onBlockAndLogStreamerError.bind(this, t));
      this._blockAndLogStreamerIfExists.addLogFilter({}), this._blockAndLogStreamIntervalIfExists = u.intervalUtils.setAsyncExcludingInterval(this._reconcileBlockAsync.bind(this), this._blockPollingIntervalMs, e._onBlockAndLogStreamerError.bind(this, t));
      var a = !1;
      this._onLogAddedSubscriptionToken = this._blockAndLogStreamerIfExists.subscribeToOnLogAdded(this._onLogStateChanged.bind(this, a)), a = !0, this._onLogRemovedSubscriptionToken = this._blockAndLogStreamerIfExists.subscribeToOnLogRemoved(this._onLogStateChanged.bind(this, a));
    }, e.prototype._blockstreamGetBlockOrNullAsync = function (e) {
      return r(this, void 0, void 0, function () {
        return n(this, function (t) {
          switch (t.label) {
            case 0:
              return !1, [4, this.web3Wrapper.sendRawPayloadAsync({
                method: "eth_getBlockByHash",
                params: [e, !1]
              })];

            case 1:
              return [2, t.sent()];
          }
        });
      });
    }, e.prototype._blockstreamGetLatestBlockOrNullAsync = function () {
      return r(this, void 0, void 0, function () {
        return n(this, function (e) {
          switch (e.label) {
            case 0:
              return !1, [4, this.web3Wrapper.sendRawPayloadAsync({
                method: "eth_getBlockByNumber",
                params: [u.BlockParamLiteral.Latest, !1]
              })];

            case 1:
              return [2, e.sent()];
          }
        });
      });
    }, e.prototype._stopBlockAndLogStream = function () {
      if (i.default.isUndefined(this._blockAndLogStreamerIfExists)) throw new l.PolymathError({
        code: f.ErrorCode.NotFound
      });
      this._blockAndLogStreamerIfExists.unsubscribeFromOnLogAdded(this._onLogAddedSubscriptionToken), this._blockAndLogStreamerIfExists.unsubscribeFromOnLogRemoved(this._onLogRemovedSubscriptionToken), u.intervalUtils.clearAsyncExcludingInterval(this._blockAndLogStreamIntervalIfExists), delete this._blockAndLogStreamerIfExists;
    }, e.prototype._blockstreamGetLogsAsync = function (e) {
      return r(this, void 0, void 0, function () {
        return n(this, function (t) {
          switch (t.label) {
            case 0:
              return [4, this.web3Wrapper.sendRawPayloadAsync({
                method: "eth_getLogs",
                params: [e]
              })];

            case 1:
              return [2, t.sent()];
          }
        });
      });
    }, e.prototype._reconcileBlockAsync = function () {
      return r(this, void 0, void 0, function () {
        var e;
        return n(this, function (t) {
          switch (t.label) {
            case 0:
              return [4, this._blockstreamGetLatestBlockOrNullAsync()];

            case 1:
              return e = t.sent(), i.default.isNull(e) ? [2] : i.default.isUndefined(this._blockAndLogStreamerIfExists) ? [3, 3] : [4, this._blockAndLogStreamerIfExists.reconcileNewBlock(e)];

            case 2:
              t.sent(), t.label = 3;

            case 3:
              return [2];
          }
        });
      });
    }, e;
  }();

  t.default = p;
},
/*!***********************************!*\
  !*** (webpack)/buildin/module.js ***!
  \***********************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = function (e) {
    return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
      enumerable: !0,
      get: function get() {
        return e.l;
      }
    }), Object.defineProperty(e, "id", {
      enumerable: !0,
      get: function get() {
        return e.i;
      }
    }), e.webpackPolyfill = 1), e;
  };
},
/*!*******************************************!*\
  !*** ./node_modules/cipher-base/index.js ***!
  \*******************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! safe-buffer */
  7).Buffer,
      n = a(
  /*! stream */
  28).Transform,
      s = a(
  /*! string_decoder */
  53).StringDecoder;

  function o(e) {
    n.call(this), this.hashMode = "string" == typeof e, this.hashMode ? this[e] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
  }

  a(
  /*! inherits */
  3)(o, n), o.prototype.update = function (e, t, a) {
    "string" == typeof e && (e = r.from(e, t));

    var n = this._update(e);

    return this.hashMode ? this : (a && (n = this._toString(n, a)), n);
  }, o.prototype.setAutoPadding = function () {}, o.prototype.getAuthTag = function () {
    throw new Error("trying to get auth tag in unsupported state");
  }, o.prototype.setAuthTag = function () {
    throw new Error("trying to set auth tag in unsupported state");
  }, o.prototype.setAAD = function () {
    throw new Error("trying to set aad in unsupported state");
  }, o.prototype._transform = function (e, t, a) {
    var r;

    try {
      this.hashMode ? this._update(e) : this.push(this._update(e));
    } catch (e) {
      r = e;
    } finally {
      a(r);
    }
  }, o.prototype._flush = function (e) {
    var t;

    try {
      this.push(this.__final());
    } catch (e) {
      t = e;
    }

    e(t);
  }, o.prototype._finalOrDigest = function (e) {
    var t = this.__final() || r.alloc(0);
    return e && (t = this._toString(t, e, !0)), t;
  }, o.prototype._toString = function (e, t, a) {
    if (this._decoder || (this._decoder = new s(t), this._encoding = t), this._encoding !== t) throw new Error("can't switch encodings");

    var r = this._decoder.write(e);

    return a && (r += this._decoder.end()), r;
  }, e.exports = o;
},
/*!*****************************************!*\
  !*** ./node_modules/xtend/immutable.js ***!
  \*****************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = function () {
    for (var e = {}, t = 0; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        a.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  };

  var a = Object.prototype.hasOwnProperty;
},
/*!************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/descriptors.js ***!
  \************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/fails */
  49);
  e.exports = !r(function () {
    return 7 != Object.defineProperty({}, "a", {
      get: function get() {
        return 7;
      }
    }).a;
  });
},
/*!******************************************************!*\
  !*** ./node_modules/core-js-pure/internals/fails.js ***!
  \******************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = function (e) {
    try {
      return !!e();
    } catch (e) {
      return !0;
    }
  };
},
/*!**********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/is-object.js ***!
  \**********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = function (e) {
    return "object" == typeof e ? null !== e : "function" == typeof e;
  };
},
/*!****************************************************!*\
  !*** ./node_modules/core-js-pure/internals/has.js ***!
  \****************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  var a = {}.hasOwnProperty;

  e.exports = function (e, t) {
    return a.call(e, t);
  };
},
/*!************************************************************!*\
  !*** ./node_modules/readable-stream/lib/_stream_duplex.js ***!
  \************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! process-nextick-args */
  77),
      n = Object.keys || function (e) {
    var t = [];

    for (var a in e) {
      t.push(a);
    }

    return t;
  };

  e.exports = f;
  var s = a(
  /*! core-util-is */
  27);
  s.inherits = a(
  /*! inherits */
  3);
  var o = a(
  /*! ./_stream_readable */
  153),
      i = a(
  /*! ./_stream_writable */
  97);
  s.inherits(f, o);

  for (var c = n(i.prototype), u = 0; u < c.length; u++) {
    var d = c[u];
    f.prototype[d] || (f.prototype[d] = i.prototype[d]);
  }

  function f(e) {
    if (!(this instanceof f)) return new f(e);
    o.call(this, e), i.call(this, e), e && !1 === e.readable && (this.readable = !1), e && !1 === e.writable && (this.writable = !1), this.allowHalfOpen = !0, e && !1 === e.allowHalfOpen && (this.allowHalfOpen = !1), this.once("end", l);
  }

  function l() {
    this.allowHalfOpen || this._writableState.ended || r.nextTick(h, this);
  }

  function h(e) {
    e.end();
  }

  Object.defineProperty(f.prototype, "writableHighWaterMark", {
    enumerable: !1,
    get: function get() {
      return this._writableState.highWaterMark;
    }
  }), Object.defineProperty(f.prototype, "destroyed", {
    get: function get() {
      return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(e) {
      void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = e, this._writableState.destroyed = e);
    }
  }), f.prototype._destroy = function (e, t) {
    this.push(null), this.end(), r.nextTick(t, e);
  };
},
/*!***********************************************************!*\
  !*** ./node_modules/string_decoder/lib/string_decoder.js ***!
  \***********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! safe-buffer */
  7).Buffer,
      n = r.isEncoding || function (e) {
    switch ((e = "" + e) && e.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;

      default:
        return !1;
    }
  };

  function s(e) {
    var t;

    switch (this.encoding = function (e) {
      var t = function (e) {
        if (!e) return "utf8";

        for (var t;;) {
          switch (e) {
            case "utf8":
            case "utf-8":
              return "utf8";

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return "utf16le";

            case "latin1":
            case "binary":
              return "latin1";

            case "base64":
            case "ascii":
            case "hex":
              return e;

            default:
              if (t) return;
              e = ("" + e).toLowerCase(), t = !0;
          }
        }
      }(e);

      if ("string" != typeof t && (r.isEncoding === n || !n(e))) throw new Error("Unknown encoding: " + e);
      return t || e;
    }(e), this.encoding) {
      case "utf16le":
        this.text = c, this.end = u, t = 4;
        break;

      case "utf8":
        this.fillLast = i, t = 4;
        break;

      case "base64":
        this.text = d, this.end = f, t = 3;
        break;

      default:
        return this.write = l, void (this.end = h);
    }

    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = r.allocUnsafe(t);
  }

  function o(e) {
    return e <= 127 ? 0 : e >> 5 == 6 ? 2 : e >> 4 == 14 ? 3 : e >> 3 == 30 ? 4 : e >> 6 == 2 ? -1 : -2;
  }

  function i(e) {
    var t = this.lastTotal - this.lastNeed,
        a = function (e, t, a) {
      if (128 != (192 & t[0])) return e.lastNeed = 0, "�";

      if (e.lastNeed > 1 && t.length > 1) {
        if (128 != (192 & t[1])) return e.lastNeed = 1, "�";
        if (e.lastNeed > 2 && t.length > 2 && 128 != (192 & t[2])) return e.lastNeed = 2, "�";
      }
    }(this, e);

    return void 0 !== a ? a : this.lastNeed <= e.length ? (e.copy(this.lastChar, t, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (e.copy(this.lastChar, t, 0, e.length), void (this.lastNeed -= e.length));
  }

  function c(e, t) {
    if ((e.length - t) % 2 == 0) {
      var a = e.toString("utf16le", t);

      if (a) {
        var r = a.charCodeAt(a.length - 1);
        if (r >= 55296 && r <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1], a.slice(0, -1);
      }

      return a;
    }

    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = e[e.length - 1], e.toString("utf16le", t, e.length - 1);
  }

  function u(e) {
    var t = e && e.length ? this.write(e) : "";

    if (this.lastNeed) {
      var a = this.lastTotal - this.lastNeed;
      return t + this.lastChar.toString("utf16le", 0, a);
    }

    return t;
  }

  function d(e, t) {
    var a = (e.length - t) % 3;
    return 0 === a ? e.toString("base64", t) : (this.lastNeed = 3 - a, this.lastTotal = 3, 1 === a ? this.lastChar[0] = e[e.length - 1] : (this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1]), e.toString("base64", t, e.length - a));
  }

  function f(e) {
    var t = e && e.length ? this.write(e) : "";
    return this.lastNeed ? t + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : t;
  }

  function l(e) {
    return e.toString(this.encoding);
  }

  function h(e) {
    return e && e.length ? this.write(e) : "";
  }

  t.StringDecoder = s, s.prototype.write = function (e) {
    if (0 === e.length) return "";
    var t, a;

    if (this.lastNeed) {
      if (void 0 === (t = this.fillLast(e))) return "";
      a = this.lastNeed, this.lastNeed = 0;
    } else a = 0;

    return a < e.length ? t ? t + this.text(e, a) : this.text(e, a) : t || "";
  }, s.prototype.end = function (e) {
    var t = e && e.length ? this.write(e) : "";
    return this.lastNeed ? t + "�" : t;
  }, s.prototype.text = function (e, t) {
    var a = function (e, t, a) {
      var r = t.length - 1;
      if (r < a) return 0;
      var n = o(t[r]);
      if (n >= 0) return n > 0 && (e.lastNeed = n - 1), n;
      if (--r < a || -2 === n) return 0;
      if ((n = o(t[r])) >= 0) return n > 0 && (e.lastNeed = n - 2), n;
      if (--r < a || -2 === n) return 0;
      if ((n = o(t[r])) >= 0) return n > 0 && (2 === n ? n = 0 : e.lastNeed = n - 3), n;
      return 0;
    }(this, e, t);

    if (!this.lastNeed) return e.toString("utf8", t);
    this.lastTotal = a;
    var r = e.length - (a - this.lastNeed);
    return e.copy(this.lastChar, 0, r), e.toString("utf8", t, r);
  }, s.prototype.fillLast = function (e) {
    if (this.lastNeed <= e.length) return e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, e.length), this.lastNeed -= e.length;
  };
},
/*!**************************************************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/abi_encoder/abstract_data_types/types/blob.js ***!
  \**************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r3,
      n = this && this.__extends || (_r3 = function r(e, t) {
    return (_r3 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r3(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  });

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var s = a(
  /*! ../../calldata/blocks/blob */
  174),
      o = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a) || this;
      return n._sizeKnownAtCompileTime = r, n;
    }

    return n(t, e), t.prototype.generateCalldataBlock = function (e, t) {
      var a = this.encodeValue(e),
          r = this.getDataItem().name,
          n = this.getSignature(),
          o = void 0 === t ? "" : t.getName();
      return new s.BlobCalldataBlock(r, n, o, a);
    }, t.prototype.generateValue = function (e, t) {
      return this.decodeValue(e);
    }, t.prototype.isStatic = function () {
      return this._sizeKnownAtCompileTime;
    }, t;
  }(a(
  /*! ../data_type */
  80).DataType);

  t.AbstractBlobDataType = o;
},
/*!**************************************************!*\
  !*** ./node_modules/abstract-leveldown/index.js ***!
  \**************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  t.AbstractLevelDOWN = a(
  /*! ./abstract-leveldown */
  503), t.AbstractIterator = a(
  /*! ./abstract-iterator */
  186), t.AbstractChainedBatch = a(
  /*! ./abstract-chained-batch */
  187);
},
/*!***********************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/object-define-property.js ***!
  \***********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/descriptors */
  48),
      n = a(
  /*! ../internals/ie8-dom-define */
  218),
      s = a(
  /*! ../internals/an-object */
  64),
      o = a(
  /*! ../internals/to-primitive */
  217),
      i = Object.defineProperty;
  t.f = r ? i : function (e, t, a) {
    if (s(e), t = o(t, !0), s(a), n) try {
      return i(e, t, a);
    } catch (e) {}
    if ("get" in a || "set" in a) throw TypeError("Accessors not supported");
    return "value" in a && (e[t] = a.value), e;
  };
},
/*!************************************************!*\
  !*** ./node_modules/jsonschema/lib/helpers.js ***!
  \************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! url */
  94),
      n = t.ValidationError = function (e, t, a, r, n, s) {
    r && (this.property = r), e && (this.message = e), a && (a.id ? this.schema = a.id : this.schema = a), t && (this.instance = t), this.name = n, this.argument = s, this.stack = this.toString();
  };

  n.prototype.toString = function () {
    return this.property + " " + this.message;
  };

  var s = t.ValidatorResult = function (e, t, a, r) {
    this.instance = e, this.schema = t, this.propertyPath = r.propertyPath, this.errors = [], this.throwError = a && a.throwError, this.disableFormat = a && !0 === a.disableFormat;
  };

  function o(e, t) {
    return t + ": " + e.toString() + "\n";
  }

  s.prototype.addError = function (e) {
    var t;
    if ("string" == typeof e) t = new n(e, this.instance, this.schema, this.propertyPath);else {
      if (!e) throw new Error("Missing error detail");
      if (!e.message) throw new Error("Missing error message");
      if (!e.name) throw new Error("Missing validator type");
      t = new n(e.message, this.instance, this.schema, this.propertyPath, e.name, e.argument);
    }
    if (this.throwError) throw t;
    return this.errors.push(t), t;
  }, s.prototype.importErrors = function (e) {
    "string" == typeof e || e && e.validatorType ? this.addError(e) : e && e.errors && Array.prototype.push.apply(this.errors, e.errors);
  }, s.prototype.toString = function (e) {
    return this.errors.map(o).join("");
  }, Object.defineProperty(s.prototype, "valid", {
    get: function get() {
      return !this.errors.length;
    }
  });

  var i = t.SchemaError = function e(t, a) {
    this.message = t, this.schema = a, Error.call(this, t), Error.captureStackTrace(this, e);
  };

  i.prototype = Object.create(Error.prototype, {
    constructor: {
      value: i,
      enumerable: !1
    },
    name: {
      value: "SchemaError",
      enumerable: !1
    }
  });

  var c = t.SchemaContext = function (e, t, a, r, n) {
    this.schema = e, this.options = t, this.propertyPath = a, this.base = r, this.schemas = n;
  };

  c.prototype.resolve = function (e) {
    return r.resolve(this.base, e);
  }, c.prototype.makeChild = function (e, t) {
    var a = void 0 === t ? this.propertyPath : this.propertyPath + d(t),
        n = r.resolve(this.base, e.id || ""),
        s = new c(e, this.options, a, n, Object.create(this.schemas));
    return e.id && !s.schemas[n] && (s.schemas[n] = e), s;
  };
  var u = t.FORMAT_REGEXPS = {
    "date-time": /^\d{4}-(?:0[0-9]{1}|1[0-2]{1})-(3[01]|0[1-9]|[12][0-9])[tT ](2[0-4]|[01][0-9]):([0-5][0-9]):(60|[0-5][0-9])(\.\d+)?([zZ]|[+-]([0-5][0-9]):(60|[0-5][0-9]))$/,
    date: /^\d{4}-(?:0[0-9]{1}|1[0-2]{1})-(3[01]|0[1-9]|[12][0-9])$/,
    time: /^(2[0-4]|[01][0-9]):([0-5][0-9]):(60|[0-5][0-9])$/,
    email: /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/,
    "ip-address": /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
    ipv6: /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/,
    uri: /^[a-zA-Z][a-zA-Z0-9+-.]*:[^\s]*$/,
    color: /^(#?([0-9A-Fa-f]{3}){1,2}\b|aqua|black|blue|fuchsia|gray|green|lime|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow|(rgb\(\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*\))|(rgb\(\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*\)))$/,
    hostname: /^(?=.{1,255}$)[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?(?:\.[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?)*\.?$/,
    "host-name": /^(?=.{1,255}$)[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?(?:\.[0-9A-Za-z](?:(?:[0-9A-Za-z]|-){0,61}[0-9A-Za-z])?)*\.?$/,
    alpha: /^[a-zA-Z]+$/,
    alphanumeric: /^[a-zA-Z0-9]+$/,
    "utc-millisec": function utcMillisec(e) {
      return "string" == typeof e && parseFloat(e) === parseInt(e, 10) && !isNaN(e);
    },
    regex: function regex(e) {
      var t = !0;

      try {
        new RegExp(e);
      } catch (e) {
        t = !1;
      }

      return t;
    },
    style: /\s*(.+?):\s*([^;]+);?/g,
    phone: /^\+(?:[0-9] ?){6,14}[0-9]$/
  };
  u.regexp = u.regex, u.pattern = u.regex, u.ipv4 = u["ip-address"], t.isFormat = function (e, t, a) {
    if ("string" == typeof e && void 0 !== u[t]) {
      if (u[t] instanceof RegExp) return u[t].test(e);
      if ("function" == typeof u[t]) return u[t](e);
    } else if (a && a.customFormats && "function" == typeof a.customFormats[t]) return a.customFormats[t](e);

    return !0;
  };

  var d = t.makeSuffix = function (e) {
    return (e = e.toString()).match(/[.\s\[\]]/) || e.match(/^[\d]/) ? e.match(/^\d+$/) ? "[" + e + "]" : "[" + JSON.stringify(e) + "]" : "." + e;
  };

  function f(e, t) {
    var a = Array.isArray(t),
        r = a && [] || {};
    return a ? (e = e || [], r = r.concat(e), t.forEach(function (e, t, a, r) {
      "object" == typeof a ? t[r] = f(e[r], a) : -1 === e.indexOf(a) && t.push(a);
    }.bind(null, e, r))) : (e && "object" == typeof e && Object.keys(e).forEach(function (e, t, a) {
      t[a] = e[a];
    }.bind(null, e, r)), Object.keys(t).forEach(function (e, t, a, r) {
      "object" == typeof t[r] && t[r] && e[r] ? a[r] = f(e[r], t[r]) : a[r] = t[r];
    }.bind(null, e, t, r))), r;
  }

  function l(e) {
    return "/" + encodeURIComponent(e).replace(/~/g, "%7E");
  }

  t.deepCompareStrict = function e(t, a) {
    if (typeof t != typeof a) return !1;
    if (t instanceof Array) return a instanceof Array && t.length === a.length && t.every(function (r, n) {
      return e(t[n], a[n]);
    });

    if ("object" == typeof t) {
      if (!t || !a) return t === a;
      var r = Object.keys(t),
          n = Object.keys(a);
      return r.length === n.length && r.every(function (r) {
        return e(t[r], a[r]);
      });
    }

    return t === a;
  }, e.exports.deepMerge = f, t.objectGetPath = function (e, t) {
    for (var a, r = t.split("/").slice(1); "string" == typeof (a = r.shift());) {
      var n = decodeURIComponent(a.replace(/~0/, "~").replace(/~1/g, "/"));
      if (!(n in e)) return;
      e = e[n];
    }

    return e;
  }, t.encodePath = function (e) {
    return e.map(l).join("");
  }, t.getDecimalPlaces = function (e) {
    var t = 0;
    if (isNaN(e)) return t;
    "number" != typeof e && (e = Number(e));
    var a = e.toString().split("e");

    if (2 === a.length) {
      if ("-" !== a[1][0]) return t;
      t = Number(a[1].slice(1));
    }

    var r = a[0].split(".");
    return 2 === r.length && (t += r[1].length), t;
  };
},
/*!**********************************************************!*\
  !*** ./node_modules/readable-stream/readable-browser.js ***!
  \**********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (t = e.exports = a(
  /*! ./lib/_stream_readable.js */
  153)).Stream = t, t.Readable = t, t.Writable = a(
  /*! ./lib/_stream_writable.js */
  97), t.Duplex = a(
  /*! ./lib/_stream_duplex.js */
  52), t.Transform = a(
  /*! ./lib/_stream_transform.js */
  156), t.PassThrough = a(
  /*! ./lib/_stream_passthrough.js */
  383);
},
/*!*************************************!*\
  !*** ./node_modules/sha.js/hash.js ***!
  \*************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! safe-buffer */
  7).Buffer;

  function n(e, t) {
    this._block = r.alloc(e), this._finalSize = t, this._blockSize = e, this._len = 0;
  }

  n.prototype.update = function (e, t) {
    "string" == typeof e && (t = t || "utf8", e = r.from(e, t));

    for (var a = this._block, n = this._blockSize, s = e.length, o = this._len, i = 0; i < s;) {
      for (var c = o % n, u = Math.min(s - i, n - c), d = 0; d < u; d++) {
        a[c + d] = e[i + d];
      }

      i += u, (o += u) % n == 0 && this._update(a);
    }

    return this._len += s, this;
  }, n.prototype.digest = function (e) {
    var t = this._len % this._blockSize;
    this._block[t] = 128, this._block.fill(0, t + 1), t >= this._finalSize && (this._update(this._block), this._block.fill(0));
    var a = 8 * this._len;
    if (a <= 4294967295) this._block.writeUInt32BE(a, this._blockSize - 4);else {
      var r = (4294967295 & a) >>> 0,
          n = (a - r) / 4294967296;
      this._block.writeUInt32BE(n, this._blockSize - 8), this._block.writeUInt32BE(r, this._blockSize - 4);
    }

    this._update(this._block);

    var s = this._hash();

    return e ? s.toString(e) : s;
  }, n.prototype._update = function () {
    throw new Error("_update must be implemented by subclass");
  }, e.exports = n;
},
/*!************************************************!*\
  !*** ./node_modules/ethereumjs-block/index.js ***!
  \************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    var r = a(
    /*! ethereumjs-common */
    192).default,
        n = a(
    /*! ethereumjs-util */
    193),
        s = a(
    /*! ethereumjs-tx */
    535),
        o = a(
    /*! merkle-patricia-tree */
    112),
        i = n.BN,
        c = n.rlp,
        u = a(
    /*! async */
    73),
        d = a(
    /*! ./header */
    569);

    var f = e.exports = function (e, a) {
      if ((a = a || {}).common) {
        if (a.chain) throw new Error("Instantiation with both opts.common and opts.chain parameter not allowed!");
        this._common = a.common;
      } else {
        var _e2 = a.chain ? a.chain : "mainnet",
            _t2 = a.hardfork ? a.hardfork : null;

        this._common = new r(_e2, _t2);
      }

      var n, i;
      this.transactions = [], this.uncleHeaders = [], this._inBlockChain = !1, this.txTrie = new o(), Object.defineProperty(this, "raw", {
        get: function get() {
          return this.serialize(!1);
        }
      }), e || (e = [[], [], []]), t.isBuffer(e) && (e = c.decode(e)), Array.isArray(e) ? (this.header = new d(e[0], a), n = e[1], i = e[2]) : (this.header = new d(e.header, a), n = e.transactions || [], i = e.uncleHeaders || []);

      for (var u = 0; u < i.length; u++) {
        this.uncleHeaders.push(new d(i[u], a));
      }

      for (u = 0; u < n.length; u++) {
        var f = new s(n[u]);
        f._homestead = !0, this.transactions.push(f);
      }
    };

    function l(e) {
      try {
        return e.reduce(function (e, t) {
          return e && (e += " "), e + t;
        });
      } catch (e) {
        return "";
      }
    }

    f.Header = d, f.prototype.hash = function () {
      return this.header.hash();
    }, f.prototype.isGenesis = function () {
      return this.header.isGenesis();
    }, f.prototype.setGenesisParams = function () {
      this.header.setGenesisParams();
    }, f.prototype.serialize = function (e) {
      var t = [this.header.raw, [], []];
      return void 0 === e && (e = !0), this.transactions.forEach(function (e) {
        t[1].push(e.raw);
      }), this.uncleHeaders.forEach(function (e) {
        t[2].push(e.raw);
      }), e ? c.encode(t) : t;
    }, f.prototype.genTxTrie = function (e) {
      var t = 0,
          a = this;
      u.eachSeries(this.transactions, function (e, r) {
        a.txTrie.put(c.encode(t), e.serialize(), r), t++;
      }, e);
    }, f.prototype.validateTransactionsTrie = function () {
      var e = this.header.transactionsTrie.toString("hex");
      return this.transactions.length ? e === this.txTrie.root.toString("hex") : e === n.SHA3_RLP.toString("hex");
    }, f.prototype.validateTransactions = function (e) {
      var t = [];
      return this.transactions.forEach(function (e, a) {
        var r = e.validate(!0);
        r && t.push(r + " at tx " + a);
      }), void 0 === e || !1 === e ? 0 === t.length : l(t);
    }, f.prototype.validate = function (e, t) {
      var a = this,
          r = [];
      u.parallel([a.validateUncles.bind(a, e), a.header.validate.bind(a.header, e), a.genTxTrie.bind(a)], function (e) {
        e && r.push(e), a.validateTransactionsTrie() || r.push("invalid transaction trie");
        var n = a.validateTransactions(!0);
        "" !== n && r.push(n), a.validateUnclesHash() || r.push("invalid uncle hash"), t(l(r));
      });
    }, f.prototype.validateUnclesHash = function () {
      var e = [];
      return this.uncleHeaders.forEach(function (t) {
        e.push(t.raw);
      }), e = c.encode(e), n.sha3(e).toString("hex") === this.header.uncleHash.toString("hex");
    }, f.prototype.validateUncles = function (e, t) {
      if (this.isGenesis()) return t();
      var a = this;
      if (a.uncleHeaders.length > 2) return t("too many uncle headers");
      var r = a.uncleHeaders.map(function (e) {
        return e.hash().toString("hex");
      });
      if (new Set(r).size !== r.length) return t("duplicate uncles");
      u.each(a.uncleHeaders, function (t, r) {
        var n = new i(a.header.number);
        u.parallel([t.validate.bind(t, e, n), function (a) {
          e.getDetails(t.hash(), function (e, t) {
            t && t.isUncle ? a(e || "uncle already included") : a();
          });
        }], r);
      }, t);
    }, f.prototype.toJSON = function (e) {
      if (e) {
        var t = {
          header: this.header.toJSON(!0),
          transactions: [],
          uncleHeaders: []
        };
        return this.transactions.forEach(function (a) {
          t.transactions.push(a.toJSON(e));
        }), this.uncleHeaders.forEach(function (e) {
          t.uncleHeaders.push(e.toJSON());
        }), t;
      }

      return n.baToJSON(this.raw);
    };
  }).call(this, a(
  /*! ./../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!*********************************************************************************************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/node_modules/level-iterator-stream/node_modules/readable-stream/lib/_stream_duplex.js ***!
  \*********************************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    e.exports = i;

    var r = Object.keys || function (e) {
      var t = [];

      for (var a in e) {
        t.push(a);
      }

      return t;
    },
        n = a(
    /*! core-util-is */
    27);

    n.inherits = a(
    /*! inherits */
    3);
    var s = a(
    /*! ./_stream_readable */
    199),
        o = a(
    /*! ./_stream_writable */
    200);

    function i(e) {
      if (!(this instanceof i)) return new i(e);
      s.call(this, e), o.call(this, e), e && !1 === e.readable && (this.readable = !1), e && !1 === e.writable && (this.writable = !1), this.allowHalfOpen = !0, e && !1 === e.allowHalfOpen && (this.allowHalfOpen = !1), this.once("end", c);
    }

    function c() {
      this.allowHalfOpen || this._writableState.ended || t.nextTick(this.end.bind(this));
    }

    n.inherits(i, s), function (e, t) {
      for (var a = 0, r = e.length; a < r; a++) {
        t(e[a], a);
      }
    }(r(o.prototype), function (e) {
      i.prototype[e] || (i.prototype[e] = o.prototype[e]);
    });
  }).call(this, a(
  /*! ./../../../../../../process/browser.js */
  9));
},
/*!***************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/util.js ***!
  \***************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    var r = a(
    /*! async */
    114);

    function n(e, t) {
      for (var a = 0; e[a] === t[a] && e.length > a;) {
        a++;
      }

      return a;
    }

    e.exports = {
      matchingNibbleLength: n,
      callTogether: function callTogether() {
        var e = arguments,
            t = e.length,
            a = t;
        if (!t) return function () {};
        return function () {
          for (t = a; t--;) {
            var r = e[t];
            if ("function" == typeof r) var n = e[t].apply(this, arguments);
          }

          return n;
        };
      },
      asyncFirstSeries: function asyncFirstSeries(e, a, n) {
        var s = !1;
        r.eachSeries(e, function (e, r) {
          if (s) return r;
          a(e, function (e, a) {
            a && (s = !0, t.nextTick(n.bind(null, null, a))), r(e);
          });
        }, function () {
          s || n();
        });
      },
      doKeysMatch: function doKeysMatch(e, t) {
        var a = n(e, t);
        return a === e.length && a === t.length;
      }
    };
  }).call(this, a(
  /*! ./../process/browser.js */
  9));
},
/*!******************************************!*\
  !*** ./node_modules/buffer-xor/index.js ***!
  \******************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    e.exports = function (e, a) {
      for (var r = Math.min(e.length, a.length), n = new t(r), s = 0; s < r; ++s) {
        n[s] = e[s] ^ a[s];
      }

      return n;
    };
  }).call(this, a(
  /*! ./../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!**********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/an-object.js ***!
  \**********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/is-object */
  50);

  e.exports = function (e) {
    if (!r(e)) throw TypeError(String(e) + " is not an object");
    return e;
  };
},
/*!**********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/iterators.js ***!
  \**********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = {};
},
/*!**************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-vm/dist/exceptions.js ***!
  \**************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), function (e) {
    e.OUT_OF_GAS = "out of gas", e.STACK_UNDERFLOW = "stack underflow", e.STACK_OVERFLOW = "stack overflow", e.INVALID_JUMP = "invalid JUMP", e.INVALID_OPCODE = "invalid opcode", e.OUT_OF_RANGE = "value out of range", e.REVERT = "revert", e.STATIC_STATE_CHANGE = "static state change", e.INTERNAL_ERROR = "internal error", e.CREATE_COLLISION = "create collision", e.STOP = "stop", e.REFUND_EXHAUSTED = "refund exhausted";
  }(t.ERROR || (t.ERROR = {}));

  var r = function r(e) {
    this.error = e, this.errorType = "VmError";
  };

  t.VmError = r;
},
/*!*********************************************!*\
  !*** ./node_modules/randombytes/browser.js ***!
  \*********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (t, r) {
    var n = 65536,
        s = 4294967295;
    var o = a(
    /*! safe-buffer */
    7).Buffer,
        i = t.crypto || t.msCrypto;
    i && i.getRandomValues ? e.exports = function (e, t) {
      if (e > s) throw new RangeError("requested too many random bytes");
      var a = o.allocUnsafe(e);
      if (e > 0) if (e > n) for (var c = 0; c < e; c += n) {
        i.getRandomValues(a.slice(c, c + n));
      } else i.getRandomValues(a);
      if ("function" == typeof t) return r.nextTick(function () {
        t(null, a);
      });
      return a;
    } : e.exports = function () {
      throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
    };
  }).call(this, a(
  /*! ./../webpack/buildin/global.js */
  18), a(
  /*! ./../process/browser.js */
  9));
},
/*!****************************************************************!*\
  !*** ./src/contract_wrappers/modules/sto/sto_wrapper/index.ts ***!
  \****************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = a(
  /*! ./3.0.0 */
  849);
  t.WithSTO_3_0_0 = r.WithSTO_3_0_0;
  var n = a(
  /*! ./3.1.0 */
  850);
  t.WithSTO_3_1_0 = n.WithSTO_3_1_0;
  var s = a(
  /*! ./common */
  851);
  t.STOCommon = s.default;
},
/*!************************************************!*\
  !*** ./node_modules/timers-browserify/main.js ***!
  \************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (e) {
    var r = void 0 !== e && e || "undefined" != typeof self && self || window,
        n = Function.prototype.apply;

    function s(e, t) {
      this._id = e, this._clearFn = t;
    }

    t.setTimeout = function () {
      return new s(n.call(setTimeout, r, arguments), clearTimeout);
    }, t.setInterval = function () {
      return new s(n.call(setInterval, r, arguments), clearInterval);
    }, t.clearTimeout = t.clearInterval = function (e) {
      e && e.close();
    }, s.prototype.unref = s.prototype.ref = function () {}, s.prototype.close = function () {
      this._clearFn.call(r, this._id);
    }, t.enroll = function (e, t) {
      clearTimeout(e._idleTimeoutId), e._idleTimeout = t;
    }, t.unenroll = function (e) {
      clearTimeout(e._idleTimeoutId), e._idleTimeout = -1;
    }, t._unrefActive = t.active = function (e) {
      clearTimeout(e._idleTimeoutId);
      var t = e._idleTimeout;
      t >= 0 && (e._idleTimeoutId = setTimeout(function () {
        e._onTimeout && e._onTimeout();
      }, t));
    }, a(
    /*! setimmediate */
    381), t.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== e && e.setImmediate || this && this.setImmediate, t.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== e && e.clearImmediate || this && this.clearImmediate;
  }).call(this, a(
  /*! ./../webpack/buildin/global.js */
  18));
},
/*!***********************************************************************!*\
  !*** ./node_modules/elliptic/node_modules/hash.js/lib/hash/common.js ***!
  \***********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ./utils */
  34),
      n = a(
  /*! minimalistic-assert */
  22);

  function s() {
    this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
  }

  t.BlockHash = s, s.prototype.update = function (e, t) {
    if (e = r.toArray(e, t), this.pending ? this.pending = this.pending.concat(e) : this.pending = e, this.pendingTotal += e.length, this.pending.length >= this._delta8) {
      var a = (e = this.pending).length % this._delta8;
      this.pending = e.slice(e.length - a, e.length), 0 === this.pending.length && (this.pending = null), e = r.join32(e, 0, e.length - a, this.endian);

      for (var n = 0; n < e.length; n += this._delta32) {
        this._update(e, n, n + this._delta32);
      }
    }

    return this;
  }, s.prototype.digest = function (e) {
    return this.update(this._pad()), n(null === this.pending), this._digest(e);
  }, s.prototype._pad = function () {
    var e = this.pendingTotal,
        t = this._delta8,
        a = t - (e + this.padLength) % t,
        r = new Array(a + this.padLength);
    r[0] = 128;

    for (var n = 1; n < a; n++) {
      r[n] = 0;
    }

    if (e <<= 3, "big" === this.endian) {
      for (var s = 8; s < this.padLength; s++) {
        r[n++] = 0;
      }

      r[n++] = 0, r[n++] = 0, r[n++] = 0, r[n++] = 0, r[n++] = e >>> 24 & 255, r[n++] = e >>> 16 & 255, r[n++] = e >>> 8 & 255, r[n++] = 255 & e;
    } else for (r[n++] = 255 & e, r[n++] = e >>> 8 & 255, r[n++] = e >>> 16 & 255, r[n++] = e >>> 24 & 255, r[n++] = 0, r[n++] = 0, r[n++] = 0, r[n++] = 0, s = 8; s < this.padLength; s++) {
      r[n++] = 0;
    }

    return r;
  };
},
/*!************************************************************************!*\
  !*** ./node_modules/hmac-drbg/node_modules/hash.js/lib/hash/common.js ***!
  \************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ./utils */
  35),
      n = a(
  /*! minimalistic-assert */
  22);

  function s() {
    this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
  }

  t.BlockHash = s, s.prototype.update = function (e, t) {
    if (e = r.toArray(e, t), this.pending ? this.pending = this.pending.concat(e) : this.pending = e, this.pendingTotal += e.length, this.pending.length >= this._delta8) {
      var a = (e = this.pending).length % this._delta8;
      this.pending = e.slice(e.length - a, e.length), 0 === this.pending.length && (this.pending = null), e = r.join32(e, 0, e.length - a, this.endian);

      for (var n = 0; n < e.length; n += this._delta32) {
        this._update(e, n, n + this._delta32);
      }
    }

    return this;
  }, s.prototype.digest = function (e) {
    return this.update(this._pad()), n(null === this.pending), this._digest(e);
  }, s.prototype._pad = function () {
    var e = this.pendingTotal,
        t = this._delta8,
        a = t - (e + this.padLength) % t,
        r = new Array(a + this.padLength);
    r[0] = 128;

    for (var n = 1; n < a; n++) {
      r[n] = 0;
    }

    if (e <<= 3, "big" === this.endian) {
      for (var s = 8; s < this.padLength; s++) {
        r[n++] = 0;
      }

      r[n++] = 0, r[n++] = 0, r[n++] = 0, r[n++] = 0, r[n++] = e >>> 24 & 255, r[n++] = e >>> 16 & 255, r[n++] = e >>> 8 & 255, r[n++] = 255 & e;
    } else for (r[n++] = 255 & e, r[n++] = e >>> 8 & 255, r[n++] = e >>> 16 & 255, r[n++] = e >>> 24 & 255, r[n++] = 0, r[n++] = 0, r[n++] = 0, r[n++] = 0, s = 8; s < this.padLength; s++) {
      r[n++] = 0;
    }

    return r;
  };
},
/*!*******************************************************!*\
  !*** ./node_modules/ethereumjs-account/dist/index.js ***!
  \*******************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var r = a(
  /*! rlp */
  21),
      n = a(
  /*! ethereumjs-util */
  182),
      s = a(
  /*! safe-buffer */
  7).Buffer,
      o = function () {
    function e(e) {
      var t = [{
        name: "nonce",
        default: s.alloc(0)
      }, {
        name: "balance",
        default: s.alloc(0)
      }, {
        name: "stateRoot",
        length: 32,
        default: n.KECCAK256_RLP
      }, {
        name: "codeHash",
        length: 32,
        default: n.KECCAK256_NULL
      }];
      n.defineProperties(this, t, e);
    }

    return e.prototype.serialize = function () {
      return r.encode([this.nonce, this.balance, this.stateRoot, this.codeHash]);
    }, e.prototype.isContract = function () {
      return this.codeHash.toString("hex") !== n.KECCAK256_NULL_S;
    }, e.prototype.getCode = function (e, t) {
      this.isContract() ? e.getRaw(this.codeHash, t) : t(null, s.alloc(0));
    }, e.prototype.setCode = function (e, t, a) {
      var r = this;
      this.codeHash = n.keccak256(t), this.codeHash.toString("hex") !== n.KECCAK256_NULL_S ? e.putRaw(this.codeHash, t, function (e) {
        a(e, r.codeHash);
      }) : a(null, s.alloc(0));
    }, e.prototype.getStorage = function (e, t, a) {
      var r = e.copy();
      r.root = this.stateRoot, r.get(t, a);
    }, e.prototype.setStorage = function (e, t, a, r) {
      var n = this,
          s = e.copy();
      s.root = this.stateRoot, s.put(t, a, function (e) {
        if (e) return r();
        n.stateRoot = s.root, r();
      });
    }, e.prototype.isEmpty = function () {
      return "" === this.balance.toString("hex") && "" === this.nonce.toString("hex") && this.stateRoot.toString("hex") === n.KECCAK256_RLP_S && this.codeHash.toString("hex") === n.KECCAK256_NULL_S;
    }, e;
  }();

  t.default = o;
},
/*!******************************************!*\
  !*** ./node_modules/async/dist/async.js ***!
  \******************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (e, a, r, n) {
    (function (t) {
      "use strict";

      function s(e, t) {
        t |= 0;

        for (var a = Math.max(e.length - t, 0), r = Array(a), n = 0; n < a; n++) {
          r[n] = e[t + n];
        }

        return r;
      }

      var o = function o(e) {
        var t = s(arguments, 1);
        return function () {
          var a = s(arguments);
          return e.apply(null, t.concat(a));
        };
      },
          i = function i(e) {
        return function () {
          var t = s(arguments),
              a = t.pop();
          e.call(this, t, a);
        };
      };

      function c(e) {
        var t = typeof e;
        return null != e && ("object" == t || "function" == t);
      }

      var u = "function" == typeof e && e,
          d = "object" == typeof a && "function" == typeof a.nextTick;

      function f(e) {
        setTimeout(e, 0);
      }

      function l(e) {
        return function (t) {
          var a = s(arguments, 1);
          e(function () {
            t.apply(null, a);
          });
        };
      }

      var h = l(u ? e : d ? a.nextTick : f);

      function p(e) {
        return i(function (t, a) {
          var r;

          try {
            r = e.apply(this, t);
          } catch (e) {
            return a(e);
          }

          c(r) && "function" == typeof r.then ? r.then(function (e) {
            b(a, null, e);
          }, function (e) {
            b(a, e.message ? e : new Error(e));
          }) : a(null, r);
        });
      }

      function b(e, t, a) {
        try {
          e(t, a);
        } catch (e) {
          h(m, e);
        }
      }

      function m(e) {
        throw e;
      }

      var y = "function" == typeof Symbol;

      function v(e) {
        return y && "AsyncFunction" === e[Symbol.toStringTag];
      }

      function _(e) {
        return v(e) ? p(e) : e;
      }

      function g(e) {
        return function (t) {
          var a = s(arguments, 1),
              r = i(function (a, r) {
            var n = this;
            return e(t, function (e, t) {
              _(e).apply(n, a.concat(t));
            }, r);
          });
          return a.length ? r.apply(this, a) : r;
        };
      }

      var A = "object" == typeof r && r && r.Object === Object && r,
          w = "object" == typeof self && self && self.Object === Object && self,
          T = A || w || Function("return this")(),
          x = T.Symbol,
          D = Object.prototype,
          C = D.hasOwnProperty,
          S = D.toString,
          E = x ? x.toStringTag : void 0,
          B = Object.prototype.toString,
          k = "[object Null]",
          R = "[object Undefined]",
          W = x ? x.toStringTag : void 0;

      function I(e) {
        return null == e ? void 0 === e ? R : k : W && W in Object(e) ? function (e) {
          var t = C.call(e, E),
              a = e[E];

          try {
            e[E] = void 0;
            var r = !0;
          } catch (e) {}

          var n = S.call(e);
          return r && (t ? e[E] = a : delete e[E]), n;
        }(e) : function (e) {
          return B.call(e);
        }(e);
      }

      var N = "[object AsyncFunction]",
          M = "[object Function]",
          P = "[object GeneratorFunction]",
          L = "[object Proxy]",
          O = 9007199254740991;

      function F(e) {
        return "number" == typeof e && e > -1 && e % 1 == 0 && e <= O;
      }

      function j(e) {
        return null != e && F(e.length) && !function (e) {
          if (!c(e)) return !1;
          var t = I(e);
          return t == M || t == P || t == N || t == L;
        }(e);
      }

      var G = {};

      function V() {}

      function U(e) {
        return function () {
          if (null !== e) {
            var t = e;
            e = null, t.apply(this, arguments);
          }
        };
      }

      var H = "function" == typeof Symbol && Symbol.iterator,
          z = function z(e) {
        return H && e[H] && e[H]();
      };

      function K(e) {
        return null != e && "object" == typeof e;
      }

      var q = "[object Arguments]";

      function Y(e) {
        return K(e) && I(e) == q;
      }

      var Z = Object.prototype,
          J = Z.hasOwnProperty,
          X = Z.propertyIsEnumerable,
          $ = Y(function () {
        return arguments;
      }()) ? Y : function (e) {
        return K(e) && J.call(e, "callee") && !X.call(e, "callee");
      },
          Q = Array.isArray,
          ee = "object" == typeof t && t && !t.nodeType && t,
          te = ee && "object" == typeof n && n && !n.nodeType && n,
          ae = te && te.exports === ee ? T.Buffer : void 0,
          re = (ae ? ae.isBuffer : void 0) || function () {
        return !1;
      },
          ne = 9007199254740991,
          se = /^(?:0|[1-9]\d*)$/;

      function oe(e, t) {
        var a = typeof e;
        return !!(t = null == t ? ne : t) && ("number" == a || "symbol" != a && se.test(e)) && e > -1 && e % 1 == 0 && e < t;
      }

      var ie = {};
      ie["[object Float32Array]"] = ie["[object Float64Array]"] = ie["[object Int8Array]"] = ie["[object Int16Array]"] = ie["[object Int32Array]"] = ie["[object Uint8Array]"] = ie["[object Uint8ClampedArray]"] = ie["[object Uint16Array]"] = ie["[object Uint32Array]"] = !0, ie["[object Arguments]"] = ie["[object Array]"] = ie["[object ArrayBuffer]"] = ie["[object Boolean]"] = ie["[object DataView]"] = ie["[object Date]"] = ie["[object Error]"] = ie["[object Function]"] = ie["[object Map]"] = ie["[object Number]"] = ie["[object Object]"] = ie["[object RegExp]"] = ie["[object Set]"] = ie["[object String]"] = ie["[object WeakMap]"] = !1;

      var ce,
          ue = "object" == typeof t && t && !t.nodeType && t,
          de = ue && "object" == typeof n && n && !n.nodeType && n,
          fe = de && de.exports === ue && A.process,
          le = function () {
        try {
          var e = de && de.require && de.require("util").types;

          return e || fe && fe.binding && fe.binding("util");
        } catch (e) {}
      }(),
          he = le && le.isTypedArray,
          pe = he ? (ce = he, function (e) {
        return ce(e);
      }) : function (e) {
        return K(e) && F(e.length) && !!ie[I(e)];
      },
          be = Object.prototype.hasOwnProperty;

      function me(e, t) {
        var a = Q(e),
            r = !a && $(e),
            n = !a && !r && re(e),
            s = !a && !r && !n && pe(e),
            o = a || r || n || s,
            i = o ? function (e, t) {
          for (var a = -1, r = Array(e); ++a < e;) {
            r[a] = t(a);
          }

          return r;
        }(e.length, String) : [],
            c = i.length;

        for (var u in e) {
          !t && !be.call(e, u) || o && ("length" == u || n && ("offset" == u || "parent" == u) || s && ("buffer" == u || "byteLength" == u || "byteOffset" == u) || oe(u, c)) || i.push(u);
        }

        return i;
      }

      var ye = Object.prototype,
          ve = function (e, t) {
        return function (a) {
          return e(t(a));
        };
      }(Object.keys, Object),
          _e = Object.prototype.hasOwnProperty;

      function ge(e) {
        if (a = (t = e) && t.constructor, t !== ("function" == typeof a && a.prototype || ye)) return ve(e);
        var t,
            a,
            r = [];

        for (var n in Object(e)) {
          _e.call(e, n) && "constructor" != n && r.push(n);
        }

        return r;
      }

      function Ae(e) {
        return j(e) ? me(e) : ge(e);
      }

      function we(e) {
        if (j(e)) return function (e) {
          var t = -1,
              a = e.length;
          return function () {
            return ++t < a ? {
              value: e[t],
              key: t
            } : null;
          };
        }(e);
        var t = z(e);
        return t ? function (e) {
          var t = -1;
          return function () {
            var a = e.next();
            return a.done ? null : (t++, {
              value: a.value,
              key: t
            });
          };
        }(t) : function (e) {
          var t = Ae(e),
              a = -1,
              r = t.length;
          return function () {
            var n = t[++a];
            return a < r ? {
              value: e[n],
              key: n
            } : null;
          };
        }(e);
      }

      function Te(e) {
        return function () {
          if (null === e) throw new Error("Callback was already called.");
          var t = e;
          e = null, t.apply(this, arguments);
        };
      }

      function xe(e) {
        return function (t, a, r) {
          if (r = U(r || V), e <= 0 || !t) return r(null);
          var n = we(t),
              s = !1,
              o = 0,
              i = !1;

          function c(e, t) {
            if (o -= 1, e) s = !0, r(e);else {
              if (t === G || s && o <= 0) return s = !0, r(null);
              i || u();
            }
          }

          function u() {
            for (i = !0; o < e && !s;) {
              var t = n();
              if (null === t) return s = !0, void (o <= 0 && r(null));
              o += 1, a(t.value, t.key, Te(c));
            }

            i = !1;
          }

          u();
        };
      }

      function De(e, t, a, r) {
        xe(t)(e, _(a), r);
      }

      function Ce(e, t) {
        return function (a, r, n) {
          return e(a, t, r, n);
        };
      }

      function Se(e, t, a) {
        a = U(a || V);
        var r = 0,
            n = 0,
            s = e.length;

        function o(e, t) {
          e ? a(e) : ++n !== s && t !== G || a(null);
        }

        for (0 === s && a(null); r < s; r++) {
          t(e[r], r, Te(o));
        }
      }

      var Ee = Ce(De, 1 / 0),
          Be = function Be(e, t, a) {
        (j(e) ? Se : Ee)(e, _(t), a);
      };

      function ke(e) {
        return function (t, a, r) {
          return e(Be, t, _(a), r);
        };
      }

      function Re(e, t, a, r) {
        r = r || V, t = t || [];

        var n = [],
            s = 0,
            o = _(a);

        e(t, function (e, t, a) {
          var r = s++;
          o(e, function (e, t) {
            n[r] = t, a(e);
          });
        }, function (e) {
          r(e, n);
        });
      }

      var We = ke(Re),
          Ie = g(We);

      function Ne(e) {
        return function (t, a, r, n) {
          return e(xe(a), t, _(r), n);
        };
      }

      var Me = Ne(Re),
          Pe = Ce(Me, 1),
          Le = g(Pe);

      function Oe(e, t) {
        for (var a = -1, r = null == e ? 0 : e.length; ++a < r && !1 !== t(e[a], a, e);) {
          ;
        }

        return e;
      }

      var Fe,
          je = function je(e, t, a) {
        for (var r = -1, n = Object(e), s = a(e), o = s.length; o--;) {
          var i = s[Fe ? o : ++r];
          if (!1 === t(n[i], i, n)) break;
        }

        return e;
      };

      function Ge(e, t) {
        return e && je(e, t, Ae);
      }

      function Ve(e) {
        return e != e;
      }

      function Ue(e, t, a) {
        return t == t ? function (e, t, a) {
          for (var r = a - 1, n = e.length; ++r < n;) {
            if (e[r] === t) return r;
          }

          return -1;
        }(e, t, a) : function (e, t, a, r) {
          for (var n = e.length, s = a + (r ? 1 : -1); r ? s-- : ++s < n;) {
            if (t(e[s], s, e)) return s;
          }

          return -1;
        }(e, Ve, a);
      }

      var He = function He(e, t, a) {
        "function" == typeof t && (a = t, t = null), a = U(a || V);
        var r = Ae(e).length;
        if (!r) return a(null);
        t || (t = r);
        var n = {},
            o = 0,
            i = !1,
            c = Object.create(null),
            u = [],
            d = [],
            f = {};

        function l(e, t) {
          u.push(function () {
            !function (e, t) {
              if (!i) {
                var r = Te(function (t, r) {
                  if (o--, arguments.length > 2 && (r = s(arguments, 1)), t) {
                    var u = {};
                    Ge(n, function (e, t) {
                      u[t] = e;
                    }), u[e] = r, i = !0, c = Object.create(null), a(t, u);
                  } else n[e] = r, p(e);
                });
                o++;

                var u = _(t[t.length - 1]);

                t.length > 1 ? u(n, r) : u(r);
              }
            }(e, t);
          });
        }

        function h() {
          if (0 === u.length && 0 === o) return a(null, n);

          for (; u.length && o < t;) {
            u.shift()();
          }
        }

        function p(e) {
          Oe(c[e] || [], function (e) {
            e();
          }), h();
        }

        function b(t) {
          var a = [];
          return Ge(e, function (e, r) {
            Q(e) && Ue(e, t, 0) >= 0 && a.push(r);
          }), a;
        }

        Ge(e, function (t, a) {
          if (!Q(t)) return l(a, [t]), void d.push(a);
          var r = t.slice(0, t.length - 1),
              n = r.length;
          if (0 === n) return l(a, t), void d.push(a);
          f[a] = n, Oe(r, function (s) {
            if (!e[s]) throw new Error("async.auto task `" + a + "` has a non-existent dependency `" + s + "` in " + r.join(", "));
            var o, i, u;
            i = function i() {
              0 == --n && l(a, t);
            }, (u = c[o = s]) || (u = c[o] = []), u.push(i);
          });
        }), function () {
          for (var e, t = 0; d.length;) {
            e = d.pop(), t++, Oe(b(e), function (e) {
              0 == --f[e] && d.push(e);
            });
          }

          if (t !== r) throw new Error("async.auto cannot execute tasks due to a recursive dependency");
        }(), h();
      };

      function ze(e, t) {
        for (var a = -1, r = null == e ? 0 : e.length, n = Array(r); ++a < r;) {
          n[a] = t(e[a], a, e);
        }

        return n;
      }

      var Ke = "[object Symbol]",
          qe = 1 / 0,
          Ye = x ? x.prototype : void 0,
          Ze = Ye ? Ye.toString : void 0;

      function Je(e) {
        if ("string" == typeof e) return e;
        if (Q(e)) return ze(e, Je) + "";
        if (function (e) {
          return "symbol" == typeof e || K(e) && I(e) == Ke;
        }(e)) return Ze ? Ze.call(e) : "";
        var t = e + "";
        return "0" == t && 1 / e == -qe ? "-0" : t;
      }

      function Xe(e, t, a) {
        var r = e.length;
        return a = void 0 === a ? r : a, !t && a >= r ? e : function (e, t, a) {
          var r = -1,
              n = e.length;
          t < 0 && (t = -t > n ? 0 : n + t), (a = a > n ? n : a) < 0 && (a += n), n = t > a ? 0 : a - t >>> 0, t >>>= 0;

          for (var s = Array(n); ++r < n;) {
            s[r] = e[r + t];
          }

          return s;
        }(e, t, a);
      }

      var $e = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]"),
          Qe = "[\\ud800-\\udfff]",
          et = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
          tt = "\\ud83c[\\udffb-\\udfff]",
          at = "[^\\ud800-\\udfff]",
          rt = "(?:\\ud83c[\\udde6-\\uddff]){2}",
          nt = "[\\ud800-\\udbff][\\udc00-\\udfff]",
          st = "(?:" + et + "|" + tt + ")?",
          ot = "[\\ufe0e\\ufe0f]?" + st + "(?:\\u200d(?:" + [at, rt, nt].join("|") + ")[\\ufe0e\\ufe0f]?" + st + ")*",
          it = "(?:" + [at + et + "?", et, rt, nt, Qe].join("|") + ")",
          ct = RegExp(tt + "(?=" + tt + ")|" + it + ot, "g");

      function ut(e) {
        return function (e) {
          return $e.test(e);
        }(e) ? function (e) {
          return e.match(ct) || [];
        }(e) : function (e) {
          return e.split("");
        }(e);
      }

      var dt = /^\s+|\s+$/g;

      function ft(e, t, a) {
        var r;
        if ((e = null == (r = e) ? "" : Je(r)) && (a || void 0 === t)) return e.replace(dt, "");
        if (!e || !(t = Je(t))) return e;
        var n = ut(e),
            s = ut(t);
        return Xe(n, function (e, t) {
          for (var a = -1, r = e.length; ++a < r && Ue(t, e[a], 0) > -1;) {
            ;
          }

          return a;
        }(n, s), function (e, t) {
          for (var a = e.length; a-- && Ue(t, e[a], 0) > -1;) {
            ;
          }

          return a;
        }(n, s) + 1).join("");
      }

      var lt = /^(?:async\s+)?(function)?\s*[^\(]*\(\s*([^\)]*)\)/m,
          ht = /,/,
          pt = /(=.+)?(\s*)$/,
          bt = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/gm;

      function mt(e, t) {
        var a = {};
        Ge(e, function (e, t) {
          var r,
              n = v(e),
              s = !n && 1 === e.length || n && 0 === e.length;
          if (Q(e)) r = e.slice(0, -1), e = e[e.length - 1], a[t] = r.concat(r.length > 0 ? o : e);else if (s) a[t] = e;else {
            if (r = function (e) {
              return e = (e = (e = (e = e.toString().replace(bt, "")).match(lt)[2].replace(" ", "")) ? e.split(ht) : []).map(function (e) {
                return ft(e.replace(pt, ""));
              });
            }(e), 0 === e.length && !n && 0 === r.length) throw new Error("autoInject task functions require explicit parameters.");
            n || r.pop(), a[t] = r.concat(o);
          }

          function o(t, a) {
            var n = ze(r, function (e) {
              return t[e];
            });
            n.push(a), _(e).apply(null, n);
          }
        }), He(a, t);
      }

      function yt() {
        this.head = this.tail = null, this.length = 0;
      }

      function vt(e, t) {
        e.length = 1, e.head = e.tail = t;
      }

      function _t(e, t, a) {
        if (null == t) t = 1;else if (0 === t) throw new Error("Concurrency must not be zero");

        var r = _(e),
            n = 0,
            s = [],
            o = !1;

        function i(e, t, a) {
          if (null != a && "function" != typeof a) throw new Error("task callback must be a function");
          if (d.started = !0, Q(e) || (e = [e]), 0 === e.length && d.idle()) return h(function () {
            d.drain();
          });

          for (var r = 0, n = e.length; r < n; r++) {
            var s = {
              data: e[r],
              callback: a || V
            };
            t ? d._tasks.unshift(s) : d._tasks.push(s);
          }

          o || (o = !0, h(function () {
            o = !1, d.process();
          }));
        }

        function c(e) {
          return function (t) {
            n -= 1;

            for (var a = 0, r = e.length; a < r; a++) {
              var o = e[a],
                  i = Ue(s, o, 0);
              0 === i ? s.shift() : i > 0 && s.splice(i, 1), o.callback.apply(o, arguments), null != t && d.error(t, o.data);
            }

            n <= d.concurrency - d.buffer && d.unsaturated(), d.idle() && d.drain(), d.process();
          };
        }

        var u = !1,
            d = {
          _tasks: new yt(),
          concurrency: t,
          payload: a,
          saturated: V,
          unsaturated: V,
          buffer: t / 4,
          empty: V,
          drain: V,
          error: V,
          started: !1,
          paused: !1,
          push: function push(e, t) {
            i(e, !1, t);
          },
          kill: function kill() {
            d.drain = V, d._tasks.empty();
          },
          unshift: function unshift(e, t) {
            i(e, !0, t);
          },
          remove: function remove(e) {
            d._tasks.remove(e);
          },
          process: function process() {
            if (!u) {
              for (u = !0; !d.paused && n < d.concurrency && d._tasks.length;) {
                var e = [],
                    t = [],
                    a = d._tasks.length;
                d.payload && (a = Math.min(a, d.payload));

                for (var o = 0; o < a; o++) {
                  var i = d._tasks.shift();

                  e.push(i), s.push(i), t.push(i.data);
                }

                n += 1, 0 === d._tasks.length && d.empty(), n === d.concurrency && d.saturated();
                var f = Te(c(e));
                r(t, f);
              }

              u = !1;
            }
          },
          length: function length() {
            return d._tasks.length;
          },
          running: function running() {
            return n;
          },
          workersList: function workersList() {
            return s;
          },
          idle: function idle() {
            return d._tasks.length + n === 0;
          },
          pause: function pause() {
            d.paused = !0;
          },
          resume: function resume() {
            !1 !== d.paused && (d.paused = !1, h(d.process));
          }
        };
        return d;
      }

      function gt(e, t) {
        return _t(e, 1, t);
      }

      yt.prototype.removeLink = function (e) {
        return e.prev ? e.prev.next = e.next : this.head = e.next, e.next ? e.next.prev = e.prev : this.tail = e.prev, e.prev = e.next = null, this.length -= 1, e;
      }, yt.prototype.empty = function () {
        for (; this.head;) {
          this.shift();
        }

        return this;
      }, yt.prototype.insertAfter = function (e, t) {
        t.prev = e, t.next = e.next, e.next ? e.next.prev = t : this.tail = t, e.next = t, this.length += 1;
      }, yt.prototype.insertBefore = function (e, t) {
        t.prev = e.prev, t.next = e, e.prev ? e.prev.next = t : this.head = t, e.prev = t, this.length += 1;
      }, yt.prototype.unshift = function (e) {
        this.head ? this.insertBefore(this.head, e) : vt(this, e);
      }, yt.prototype.push = function (e) {
        this.tail ? this.insertAfter(this.tail, e) : vt(this, e);
      }, yt.prototype.shift = function () {
        return this.head && this.removeLink(this.head);
      }, yt.prototype.pop = function () {
        return this.tail && this.removeLink(this.tail);
      }, yt.prototype.toArray = function () {
        for (var e = Array(this.length), t = this.head, a = 0; a < this.length; a++) {
          e[a] = t.data, t = t.next;
        }

        return e;
      }, yt.prototype.remove = function (e) {
        for (var t = this.head; t;) {
          var a = t.next;
          e(t) && this.removeLink(t), t = a;
        }

        return this;
      };
      var At = Ce(De, 1);

      function wt(e, t, a, r) {
        r = U(r || V);

        var n = _(a);

        At(e, function (e, a, r) {
          n(t, e, function (e, a) {
            t = a, r(e);
          });
        }, function (e) {
          r(e, t);
        });
      }

      function Tt() {
        var e = ze(arguments, _);
        return function () {
          var t = s(arguments),
              a = this,
              r = t[t.length - 1];
          "function" == typeof r ? t.pop() : r = V, wt(e, t, function (e, t, r) {
            t.apply(a, e.concat(function (e) {
              var t = s(arguments, 1);
              r(e, t);
            }));
          }, function (e, t) {
            r.apply(a, [e].concat(t));
          });
        };
      }

      var xt = function xt() {
        return Tt.apply(null, s(arguments).reverse());
      },
          Dt = Array.prototype.concat,
          Ct = function Ct(e, t, a, r) {
        r = r || V;

        var n = _(a);

        Me(e, t, function (e, t) {
          n(e, function (e) {
            return e ? t(e) : t(null, s(arguments, 1));
          });
        }, function (e, t) {
          for (var a = [], n = 0; n < t.length; n++) {
            t[n] && (a = Dt.apply(a, t[n]));
          }

          return r(e, a);
        });
      },
          St = Ce(Ct, 1 / 0),
          Et = Ce(Ct, 1),
          Bt = function Bt() {
        var e = s(arguments),
            t = [null].concat(e);
        return function () {
          var e = arguments[arguments.length - 1];
          return e.apply(this, t);
        };
      };

      function kt(e) {
        return e;
      }

      function Rt(e, t) {
        return function (a, r, n, s) {
          s = s || V;
          var o,
              i = !1;
          a(r, function (a, r, s) {
            n(a, function (r, n) {
              r ? s(r) : e(n) && !o ? (i = !0, o = t(!0, a), s(null, G)) : s();
            });
          }, function (e) {
            e ? s(e) : s(null, i ? o : t(!1));
          });
        };
      }

      function Wt(e, t) {
        return t;
      }

      var It = ke(Rt(kt, Wt)),
          Nt = Ne(Rt(kt, Wt)),
          Mt = Ce(Nt, 1);

      function Pt(e) {
        return function (t) {
          var a = s(arguments, 1);
          a.push(function (t) {
            var a = s(arguments, 1);
            "object" == typeof console && (t ? console.error && console.error(t) : console[e] && Oe(a, function (t) {
              console[e](t);
            }));
          }), _(t).apply(null, a);
        };
      }

      var Lt = Pt("dir");

      function Ot(e, t, a) {
        a = Te(a || V);

        var r = _(e),
            n = _(t);

        function o(e) {
          if (e) return a(e);
          var t = s(arguments, 1);
          t.push(i), n.apply(this, t);
        }

        function i(e, t) {
          return e ? a(e) : t ? void r(o) : a(null);
        }

        i(null, !0);
      }

      function Ft(e, t, a) {
        a = Te(a || V);

        var r = _(e),
            n = function n(e) {
          if (e) return a(e);
          var o = s(arguments, 1);
          if (t.apply(this, o)) return r(n);
          a.apply(null, [null].concat(o));
        };

        r(n);
      }

      function jt(e, t, a) {
        Ft(e, function () {
          return !t.apply(this, arguments);
        }, a);
      }

      function Gt(e, t, a) {
        a = Te(a || V);

        var r = _(t),
            n = _(e);

        function s(e) {
          if (e) return a(e);
          n(o);
        }

        function o(e, t) {
          return e ? a(e) : t ? void r(s) : a(null);
        }

        n(o);
      }

      function Vt(e) {
        return function (t, a, r) {
          return e(t, r);
        };
      }

      function Ut(e, t, a) {
        Be(e, Vt(_(t)), a);
      }

      function Ht(e, t, a, r) {
        xe(t)(e, Vt(_(a)), r);
      }

      var zt = Ce(Ht, 1);

      function Kt(e) {
        return v(e) ? e : i(function (t, a) {
          var r = !0;
          t.push(function () {
            var e = arguments;
            r ? h(function () {
              a.apply(null, e);
            }) : a.apply(null, e);
          }), e.apply(this, t), r = !1;
        });
      }

      function qt(e) {
        return !e;
      }

      var Yt = ke(Rt(qt, qt)),
          Zt = Ne(Rt(qt, qt)),
          Jt = Ce(Zt, 1);

      function Xt(e) {
        return function (t) {
          return null == t ? void 0 : t[e];
        };
      }

      function $t(e, t, a, r) {
        var n = new Array(t.length);
        e(t, function (e, t, r) {
          a(e, function (e, a) {
            n[t] = !!a, r(e);
          });
        }, function (e) {
          if (e) return r(e);

          for (var a = [], s = 0; s < t.length; s++) {
            n[s] && a.push(t[s]);
          }

          r(null, a);
        });
      }

      function Qt(e, t, a, r) {
        var n = [];
        e(t, function (e, t, r) {
          a(e, function (a, s) {
            a ? r(a) : (s && n.push({
              index: t,
              value: e
            }), r());
          });
        }, function (e) {
          e ? r(e) : r(null, ze(n.sort(function (e, t) {
            return e.index - t.index;
          }), Xt("value")));
        });
      }

      function ea(e, t, a, r) {
        (j(t) ? $t : Qt)(e, t, _(a), r || V);
      }

      var ta = ke(ea),
          aa = Ne(ea),
          ra = Ce(aa, 1);

      function na(e, t) {
        var a = Te(t || V),
            r = _(Kt(e));

        !function e(t) {
          if (t) return a(t);
          r(e);
        }();
      }

      var sa = function sa(e, t, a, r) {
        r = r || V;

        var n = _(a);

        Me(e, t, function (e, t) {
          n(e, function (a, r) {
            return a ? t(a) : t(null, {
              key: r,
              val: e
            });
          });
        }, function (e, t) {
          for (var a = {}, n = Object.prototype.hasOwnProperty, s = 0; s < t.length; s++) {
            if (t[s]) {
              var o = t[s].key,
                  i = t[s].val;
              n.call(a, o) ? a[o].push(i) : a[o] = [i];
            }
          }

          return r(e, a);
        });
      },
          oa = Ce(sa, 1 / 0),
          ia = Ce(sa, 1),
          ca = Pt("log");

      function ua(e, t, a, r) {
        r = U(r || V);

        var n = {},
            s = _(a);

        De(e, t, function (e, t, a) {
          s(e, t, function (e, r) {
            if (e) return a(e);
            n[t] = r, a();
          });
        }, function (e) {
          r(e, n);
        });
      }

      var da = Ce(ua, 1 / 0),
          fa = Ce(ua, 1);

      function la(e, t) {
        return t in e;
      }

      function ha(e, t) {
        var a = Object.create(null),
            r = Object.create(null);
        t = t || kt;

        var n = _(e),
            o = i(function (e, o) {
          var i = t.apply(null, e);
          la(a, i) ? h(function () {
            o.apply(null, a[i]);
          }) : la(r, i) ? r[i].push(o) : (r[i] = [o], n.apply(null, e.concat(function () {
            var e = s(arguments);
            a[i] = e;
            var t = r[i];
            delete r[i];

            for (var n = 0, o = t.length; n < o; n++) {
              t[n].apply(null, e);
            }
          })));
        });

        return o.memo = a, o.unmemoized = e, o;
      }

      var pa = l(d ? a.nextTick : u ? e : f);

      function ba(e, t, a) {
        a = a || V;
        var r = j(t) ? [] : {};
        e(t, function (e, t, a) {
          _(e)(function (e, n) {
            arguments.length > 2 && (n = s(arguments, 1)), r[t] = n, a(e);
          });
        }, function (e) {
          a(e, r);
        });
      }

      function ma(e, t) {
        ba(Be, e, t);
      }

      function ya(e, t, a) {
        ba(xe(t), e, a);
      }

      var va = function va(e, t) {
        var a = _(e);

        return _t(function (e, t) {
          a(e[0], t);
        }, t, 1);
      },
          _a = function _a(e, t) {
        var a = va(e, t);
        return a.push = function (e, t, r) {
          if (null == r && (r = V), "function" != typeof r) throw new Error("task callback must be a function");
          if (a.started = !0, Q(e) || (e = [e]), 0 === e.length) return h(function () {
            a.drain();
          });
          t = t || 0;

          for (var n = a._tasks.head; n && t >= n.priority;) {
            n = n.next;
          }

          for (var s = 0, o = e.length; s < o; s++) {
            var i = {
              data: e[s],
              priority: t,
              callback: r
            };
            n ? a._tasks.insertBefore(n, i) : a._tasks.push(i);
          }

          h(a.process);
        }, delete a.unshift, a;
      };

      function ga(e, t) {
        if (t = U(t || V), !Q(e)) return t(new TypeError("First argument to race must be an array of functions"));
        if (!e.length) return t();

        for (var a = 0, r = e.length; a < r; a++) {
          _(e[a])(t);
        }
      }

      function Aa(e, t, a, r) {
        wt(s(e).reverse(), t, a, r);
      }

      function wa(e) {
        var t = _(e);

        return i(function (e, a) {
          return e.push(function (e, t) {
            var r;
            e ? a(null, {
              error: e
            }) : (r = arguments.length <= 2 ? t : s(arguments, 1), a(null, {
              value: r
            }));
          }), t.apply(this, e);
        });
      }

      function Ta(e) {
        var t;
        return Q(e) ? t = ze(e, wa) : (t = {}, Ge(e, function (e, a) {
          t[a] = wa.call(this, e);
        })), t;
      }

      function xa(e, t, a, r) {
        ea(e, t, function (e, t) {
          a(e, function (e, a) {
            t(e, !a);
          });
        }, r);
      }

      var Da = ke(xa),
          Ca = Ne(xa),
          Sa = Ce(Ca, 1);

      function Ea(e) {
        return function () {
          return e;
        };
      }

      function Ba(e, t, a) {
        var r = 5,
            n = 0,
            s = {
          times: r,
          intervalFunc: Ea(n)
        };
        if (arguments.length < 3 && "function" == typeof e ? (a = t || V, t = e) : (function (e, t) {
          if ("object" == typeof t) e.times = +t.times || r, e.intervalFunc = "function" == typeof t.interval ? t.interval : Ea(+t.interval || n), e.errorFilter = t.errorFilter;else {
            if ("number" != typeof t && "string" != typeof t) throw new Error("Invalid arguments for async.retry");
            e.times = +t || r;
          }
        }(s, e), a = a || V), "function" != typeof t) throw new Error("Invalid arguments for async.retry");

        var o = _(t),
            i = 1;

        !function e() {
          o(function (t) {
            t && i++ < s.times && ("function" != typeof s.errorFilter || s.errorFilter(t)) ? setTimeout(e, s.intervalFunc(i)) : a.apply(null, arguments);
          });
        }();
      }

      var ka = function ka(e, t) {
        t || (t = e, e = null);

        var a = _(t);

        return i(function (t, r) {
          function n(e) {
            a.apply(null, t.concat(e));
          }

          e ? Ba(e, n, r) : Ba(n, r);
        });
      };

      function Ra(e, t) {
        ba(At, e, t);
      }

      var Wa = ke(Rt(Boolean, kt)),
          Ia = Ne(Rt(Boolean, kt)),
          Na = Ce(Ia, 1);

      function Ma(e, t, a) {
        var r = _(t);

        function n(e, t) {
          var a = e.criteria,
              r = t.criteria;
          return a < r ? -1 : a > r ? 1 : 0;
        }

        We(e, function (e, t) {
          r(e, function (a, r) {
            if (a) return t(a);
            t(null, {
              value: e,
              criteria: r
            });
          });
        }, function (e, t) {
          if (e) return a(e);
          a(null, ze(t.sort(n), Xt("value")));
        });
      }

      function Pa(e, t, a) {
        var r = _(e);

        return i(function (n, s) {
          var o,
              i = !1;
          n.push(function () {
            i || (s.apply(null, arguments), clearTimeout(o));
          }), o = setTimeout(function () {
            var t = e.name || "anonymous",
                r = new Error('Callback function "' + t + '" timed out.');
            r.code = "ETIMEDOUT", a && (r.info = a), i = !0, s(r);
          }, t), r.apply(null, n);
        });
      }

      var La = Math.ceil,
          Oa = Math.max;

      function Fa(e, t, a, r) {
        var n = _(a);

        Me(function (e, t, a, r) {
          for (var n = -1, s = Oa(La((t - e) / (a || 1)), 0), o = Array(s); s--;) {
            o[r ? s : ++n] = e, e += a;
          }

          return o;
        }(0, e, 1), t, n, r);
      }

      var ja = Ce(Fa, 1 / 0),
          Ga = Ce(Fa, 1);

      function Va(e, t, a, r) {
        arguments.length <= 3 && (r = a, a = t, t = Q(e) ? [] : {}), r = U(r || V);

        var n = _(a);

        Be(e, function (e, a, r) {
          n(t, e, a, r);
        }, function (e) {
          r(e, t);
        });
      }

      function Ua(e, t) {
        var a,
            r = null;
        t = t || V, zt(e, function (e, t) {
          _(e)(function (e, n) {
            a = arguments.length > 2 ? s(arguments, 1) : n, r = e, t(!e);
          });
        }, function () {
          t(r, a);
        });
      }

      function Ha(e) {
        return function () {
          return (e.unmemoized || e).apply(null, arguments);
        };
      }

      function za(e, t, a) {
        a = Te(a || V);

        var r = _(t);

        if (!e()) return a(null);

        var n = function n(t) {
          if (t) return a(t);
          if (e()) return r(n);
          var o = s(arguments, 1);
          a.apply(null, [null].concat(o));
        };

        r(n);
      }

      function Ka(e, t, a) {
        za(function () {
          return !e.apply(this, arguments);
        }, t, a);
      }

      var qa = function qa(e, t) {
        if (t = U(t || V), !Q(e)) return t(new Error("First argument to waterfall must be an array of functions"));
        if (!e.length) return t();
        var a = 0;

        function r(t) {
          var r = _(e[a++]);

          t.push(Te(n)), r.apply(null, t);
        }

        function n(n) {
          if (n || a === e.length) return t.apply(null, arguments);
          r(s(arguments, 1));
        }

        r([]);
      },
          Ya = {
        apply: o,
        applyEach: Ie,
        applyEachSeries: Le,
        asyncify: p,
        auto: He,
        autoInject: mt,
        cargo: gt,
        compose: xt,
        concat: St,
        concatLimit: Ct,
        concatSeries: Et,
        constant: Bt,
        detect: It,
        detectLimit: Nt,
        detectSeries: Mt,
        dir: Lt,
        doDuring: Ot,
        doUntil: jt,
        doWhilst: Ft,
        during: Gt,
        each: Ut,
        eachLimit: Ht,
        eachOf: Be,
        eachOfLimit: De,
        eachOfSeries: At,
        eachSeries: zt,
        ensureAsync: Kt,
        every: Yt,
        everyLimit: Zt,
        everySeries: Jt,
        filter: ta,
        filterLimit: aa,
        filterSeries: ra,
        forever: na,
        groupBy: oa,
        groupByLimit: sa,
        groupBySeries: ia,
        log: ca,
        map: We,
        mapLimit: Me,
        mapSeries: Pe,
        mapValues: da,
        mapValuesLimit: ua,
        mapValuesSeries: fa,
        memoize: ha,
        nextTick: pa,
        parallel: ma,
        parallelLimit: ya,
        priorityQueue: _a,
        queue: va,
        race: ga,
        reduce: wt,
        reduceRight: Aa,
        reflect: wa,
        reflectAll: Ta,
        reject: Da,
        rejectLimit: Ca,
        rejectSeries: Sa,
        retry: Ba,
        retryable: ka,
        seq: Tt,
        series: Ra,
        setImmediate: h,
        some: Wa,
        someLimit: Ia,
        someSeries: Na,
        sortBy: Ma,
        timeout: Pa,
        times: ja,
        timesLimit: Fa,
        timesSeries: Ga,
        transform: Va,
        tryEach: Ua,
        unmemoize: Ha,
        until: Ka,
        waterfall: qa,
        whilst: za,
        all: Yt,
        allLimit: Zt,
        allSeries: Jt,
        any: Wa,
        anyLimit: Ia,
        anySeries: Na,
        find: It,
        findLimit: Nt,
        findSeries: Mt,
        forEach: Ut,
        forEachSeries: zt,
        forEachLimit: Ht,
        forEachOf: Be,
        forEachOfSeries: At,
        forEachOfLimit: De,
        inject: wt,
        foldl: wt,
        foldr: Aa,
        select: ta,
        selectLimit: aa,
        selectSeries: ra,
        wrapSync: p
      };

      t.default = Ya, t.apply = o, t.applyEach = Ie, t.applyEachSeries = Le, t.asyncify = p, t.auto = He, t.autoInject = mt, t.cargo = gt, t.compose = xt, t.concat = St, t.concatLimit = Ct, t.concatSeries = Et, t.constant = Bt, t.detect = It, t.detectLimit = Nt, t.detectSeries = Mt, t.dir = Lt, t.doDuring = Ot, t.doUntil = jt, t.doWhilst = Ft, t.during = Gt, t.each = Ut, t.eachLimit = Ht, t.eachOf = Be, t.eachOfLimit = De, t.eachOfSeries = At, t.eachSeries = zt, t.ensureAsync = Kt, t.every = Yt, t.everyLimit = Zt, t.everySeries = Jt, t.filter = ta, t.filterLimit = aa, t.filterSeries = ra, t.forever = na, t.groupBy = oa, t.groupByLimit = sa, t.groupBySeries = ia, t.log = ca, t.map = We, t.mapLimit = Me, t.mapSeries = Pe, t.mapValues = da, t.mapValuesLimit = ua, t.mapValuesSeries = fa, t.memoize = ha, t.nextTick = pa, t.parallel = ma, t.parallelLimit = ya, t.priorityQueue = _a, t.queue = va, t.race = ga, t.reduce = wt, t.reduceRight = Aa, t.reflect = wa, t.reflectAll = Ta, t.reject = Da, t.rejectLimit = Ca, t.rejectSeries = Sa, t.retry = Ba, t.retryable = ka, t.seq = Tt, t.series = Ra, t.setImmediate = h, t.some = Wa, t.someLimit = Ia, t.someSeries = Na, t.sortBy = Ma, t.timeout = Pa, t.times = ja, t.timesLimit = Fa, t.timesSeries = Ga, t.transform = Va, t.tryEach = Ua, t.unmemoize = Ha, t.until = Ka, t.waterfall = qa, t.whilst = za, t.all = Yt, t.allLimit = Zt, t.allSeries = Jt, t.any = Wa, t.anyLimit = Ia, t.anySeries = Na, t.find = It, t.findLimit = Nt, t.findSeries = Mt, t.forEach = Ut, t.forEachSeries = zt, t.forEachLimit = Ht, t.forEachOf = Be, t.forEachOfSeries = At, t.forEachOfLimit = De, t.inject = wt, t.foldl = wt, t.foldr = Aa, t.select = ta, t.selectLimit = aa, t.selectSeries = ra, t.wrapSync = p, Object.defineProperty(t, "__esModule", {
        value: !0
      });
    })(t);
  }).call(this, a(
  /*! ./../../timers-browserify/main.js */
  69).setImmediate, a(
  /*! ./../../process/browser.js */
  9), a(
  /*! ./../../webpack/buildin/global.js */
  18), a(
  /*! ./../../webpack/buildin/module.js */
  45)(e));
},
/*!*********************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-vm/dist/state/promisified.js ***!
  \*********************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var r = a(
  /*! util.promisify */
  88),
      n = function () {
    function e(e) {
      this._wrapped = e;
    }

    return e.prototype.copy = function () {
      return new e(this._wrapped.copy());
    }, e.prototype.getAccount = function (e) {
      return r(this._wrapped.getAccount.bind(this._wrapped))(e);
    }, e.prototype.putAccount = function (e, t) {
      return r(this._wrapped.putAccount.bind(this._wrapped))(e, t);
    }, e.prototype.putContractCode = function (e, t) {
      return r(this._wrapped.putContractCode.bind(this._wrapped))(e, t);
    }, e.prototype.getContractCode = function (e) {
      return r(this._wrapped.getContractCode.bind(this._wrapped))(e);
    }, e.prototype.getContractStorage = function (e, t) {
      return r(this._wrapped.getContractStorage.bind(this._wrapped))(e, t);
    }, e.prototype.getOriginalContractStorage = function (e, t) {
      return r(this._wrapped.getOriginalContractStorage.bind(this._wrapped))(e, t);
    }, e.prototype.putContractStorage = function (e, t, a) {
      return r(this._wrapped.putContractStorage.bind(this._wrapped))(e, t, a);
    }, e.prototype.clearContractStorage = function (e) {
      return r(this._wrapped.clearContractStorage.bind(this._wrapped))(e);
    }, e.prototype.checkpoint = function () {
      return r(this._wrapped.checkpoint.bind(this._wrapped))();
    }, e.prototype.commit = function () {
      return r(this._wrapped.commit.bind(this._wrapped))();
    }, e.prototype.revert = function () {
      return r(this._wrapped.revert.bind(this._wrapped))();
    }, e.prototype.getStateRoot = function () {
      return r(this._wrapped.getStateRoot.bind(this._wrapped))();
    }, e.prototype.setStateRoot = function (e) {
      return r(this._wrapped.setStateRoot.bind(this._wrapped))(e);
    }, e.prototype.dumpStorage = function (e) {
      return r(this._wrapped.dumpStorage.bind(this._wrapped))(e);
    }, e.prototype.hasGenesisState = function () {
      return r(this._wrapped.hasGenesisState.bind(this._wrapped))();
    }, e.prototype.generateCanonicalGenesis = function () {
      return r(this._wrapped.generateCanonicalGenesis.bind(this._wrapped))();
    }, e.prototype.generateGenesis = function (e) {
      return r(this._wrapped.generateGenesis.bind(this._wrapped))(e);
    }, e.prototype.accountIsEmpty = function (e) {
      return r(this._wrapped.accountIsEmpty.bind(this._wrapped))(e);
    }, e.prototype.cleanupTouchedAccounts = function () {
      return r(this._wrapped.cleanupTouchedAccounts.bind(this._wrapped))();
    }, e;
  }();

  t.default = n;
},
/*!******************************************!*\
  !*** ./node_modules/asn1.js/lib/asn1.js ***!
  \******************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = t;
  r.bignum = a(
  /*! bn.js */
  5), r.define = a(
  /*! ./asn1/api */
  695).define, r.base = a(
  /*! ./asn1/base */
  76), r.constants = a(
  /*! ./asn1/constants */
  261), r.decoders = a(
  /*! ./asn1/decoders */
  700), r.encoders = a(
  /*! ./asn1/encoders */
  702);
},
/*!*****************************************************!*\
  !*** ./node_modules/asn1.js/lib/asn1/base/index.js ***!
  \*****************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = t;
  r.Reporter = a(
  /*! ./reporter */
  697).Reporter, r.DecoderBuffer = a(
  /*! ./buffer */
  260).DecoderBuffer, r.EncoderBuffer = a(
  /*! ./buffer */
  260).EncoderBuffer, r.Node = a(
  /*! ./node */
  698);
},
/*!****************************************************!*\
  !*** ./node_modules/process-nextick-args/index.js ***!
  \****************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (t) {
    void 0 === t || !t.version || 0 === t.version.indexOf("v0.") || 0 === t.version.indexOf("v1.") && 0 !== t.version.indexOf("v1.8.") ? e.exports = {
      nextTick: function nextTick(e, a, r, n) {
        if ("function" != typeof e) throw new TypeError('"callback" argument must be a function');
        var s,
            o,
            i = arguments.length;

        switch (i) {
          case 0:
          case 1:
            return t.nextTick(e);

          case 2:
            return t.nextTick(function () {
              e.call(null, a);
            });

          case 3:
            return t.nextTick(function () {
              e.call(null, a, r);
            });

          case 4:
            return t.nextTick(function () {
              e.call(null, a, r, n);
            });

          default:
            for (s = new Array(i - 1), o = 0; o < s.length;) {
              s[o++] = arguments[o];
            }

            return t.nextTick(function () {
              e.apply(null, s);
            });
        }
      }
    } : e.exports = t;
  }).call(this, a(
  /*! ./../process/browser.js */
  9));
},
/*!***********************************************!*\
  !*** ./node_modules/elliptic/lib/elliptic.js ***!
  \***********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = t;
  r.version = a(
  /*! ../package.json */
  401).version, r.utils = a(
  /*! ./elliptic/utils */
  31), r.rand = a(
  /*! brorand */
  101), r.curve = a(
  /*! ./elliptic/curve */
  162), r.curves = a(
  /*! ./elliptic/curves */
  102), r.ec = a(
  /*! ./elliptic/ec */
  413), r.eddsa = a(
  /*! ./elliptic/eddsa */
  424);
},
/*!**********************************************************!*\
  !*** ./node_modules/elliptic/lib/elliptic/curve/base.js ***!
  \**********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! bn.js */
  5),
      n = a(
  /*! ../utils */
  31),
      s = n.getNAF,
      o = n.getJSF,
      i = n.assert;

  function c(e, t) {
    this.type = e, this.p = new r(t.p, 16), this.red = t.prime ? r.red(t.prime) : r.mont(this.p), this.zero = new r(0).toRed(this.red), this.one = new r(1).toRed(this.red), this.two = new r(2).toRed(this.red), this.n = t.n && new r(t.n, 16), this.g = t.g && this.pointFromJSON(t.g, t.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4);
    var a = this.n && this.p.div(this.n);
    !a || a.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
  }

  function u(e, t) {
    this.curve = e, this.type = t, this.precomputed = null;
  }

  e.exports = c, c.prototype.point = function () {
    throw new Error("Not implemented");
  }, c.prototype.validate = function () {
    throw new Error("Not implemented");
  }, c.prototype._fixedNafMul = function (e, t) {
    i(e.precomputed);

    var a = e._getDoubles(),
        r = s(t, 1),
        n = (1 << a.step + 1) - (a.step % 2 == 0 ? 2 : 1);

    n /= 3;

    for (var o = [], c = 0; c < r.length; c += a.step) {
      var u = 0;

      for (t = c + a.step - 1; t >= c; t--) {
        u = (u << 1) + r[t];
      }

      o.push(u);
    }

    for (var d = this.jpoint(null, null, null), f = this.jpoint(null, null, null), l = n; l > 0; l--) {
      for (c = 0; c < o.length; c++) {
        (u = o[c]) === l ? f = f.mixedAdd(a.points[c]) : u === -l && (f = f.mixedAdd(a.points[c].neg()));
      }

      d = d.add(f);
    }

    return d.toP();
  }, c.prototype._wnafMul = function (e, t) {
    var a = 4,
        r = e._getNAFPoints(a);

    a = r.wnd;

    for (var n = r.points, o = s(t, a), c = this.jpoint(null, null, null), u = o.length - 1; u >= 0; u--) {
      for (t = 0; u >= 0 && 0 === o[u]; u--) {
        t++;
      }

      if (u >= 0 && t++, c = c.dblp(t), u < 0) break;
      var d = o[u];
      i(0 !== d), c = "affine" === e.type ? d > 0 ? c.mixedAdd(n[d - 1 >> 1]) : c.mixedAdd(n[-d - 1 >> 1].neg()) : d > 0 ? c.add(n[d - 1 >> 1]) : c.add(n[-d - 1 >> 1].neg());
    }

    return "affine" === e.type ? c.toP() : c;
  }, c.prototype._wnafMulAdd = function (e, t, a, r, n) {
    for (var i = this._wnafT1, c = this._wnafT2, u = this._wnafT3, d = 0, f = 0; f < r; f++) {
      var l = (D = t[f])._getNAFPoints(e);

      i[f] = l.wnd, c[f] = l.points;
    }

    for (f = r - 1; f >= 1; f -= 2) {
      var h = f - 1,
          p = f;

      if (1 === i[h] && 1 === i[p]) {
        var b = [t[h], null, null, t[p]];
        0 === t[h].y.cmp(t[p].y) ? (b[1] = t[h].add(t[p]), b[2] = t[h].toJ().mixedAdd(t[p].neg())) : 0 === t[h].y.cmp(t[p].y.redNeg()) ? (b[1] = t[h].toJ().mixedAdd(t[p]), b[2] = t[h].add(t[p].neg())) : (b[1] = t[h].toJ().mixedAdd(t[p]), b[2] = t[h].toJ().mixedAdd(t[p].neg()));
        var m = [-3, -1, -5, -7, 0, 7, 5, 1, 3],
            y = o(a[h], a[p]);
        d = Math.max(y[0].length, d), u[h] = new Array(d), u[p] = new Array(d);

        for (var v = 0; v < d; v++) {
          var _ = 0 | y[0][v],
              g = 0 | y[1][v];

          u[h][v] = m[3 * (_ + 1) + (g + 1)], u[p][v] = 0, c[h] = b;
        }
      } else u[h] = s(a[h], i[h]), u[p] = s(a[p], i[p]), d = Math.max(u[h].length, d), d = Math.max(u[p].length, d);
    }

    var A = this.jpoint(null, null, null),
        w = this._wnafT4;

    for (f = d; f >= 0; f--) {
      for (var T = 0; f >= 0;) {
        var x = !0;

        for (v = 0; v < r; v++) {
          w[v] = 0 | u[v][f], 0 !== w[v] && (x = !1);
        }

        if (!x) break;
        T++, f--;
      }

      if (f >= 0 && T++, A = A.dblp(T), f < 0) break;

      for (v = 0; v < r; v++) {
        var D,
            C = w[v];
        0 !== C && (C > 0 ? D = c[v][C - 1 >> 1] : C < 0 && (D = c[v][-C - 1 >> 1].neg()), A = "affine" === D.type ? A.mixedAdd(D) : A.add(D));
      }
    }

    for (f = 0; f < r; f++) {
      c[f] = null;
    }

    return n ? A : A.toP();
  }, c.BasePoint = u, u.prototype.eq = function () {
    throw new Error("Not implemented");
  }, u.prototype.validate = function () {
    return this.curve.validate(this);
  }, c.prototype.decodePoint = function (e, t) {
    e = n.toArray(e, t);
    var a = this.p.byteLength();
    if ((4 === e[0] || 6 === e[0] || 7 === e[0]) && e.length - 1 == 2 * a) return 6 === e[0] ? i(e[e.length - 1] % 2 == 0) : 7 === e[0] && i(e[e.length - 1] % 2 == 1), this.point(e.slice(1, 1 + a), e.slice(1 + a, 1 + 2 * a));
    if ((2 === e[0] || 3 === e[0]) && e.length - 1 === a) return this.pointFromX(e.slice(1, 1 + a), 3 === e[0]);
    throw new Error("Unknown point format");
  }, u.prototype.encodeCompressed = function (e) {
    return this.encode(e, !0);
  }, u.prototype._encode = function (e) {
    var t = this.curve.p.byteLength(),
        a = this.getX().toArray("be", t);
    return e ? [this.getY().isEven() ? 2 : 3].concat(a) : [4].concat(a, this.getY().toArray("be", t));
  }, u.prototype.encode = function (e, t) {
    return n.encode(this._encode(t), e);
  }, u.prototype.precompute = function (e) {
    if (this.precomputed) return this;
    var t = {
      doubles: null,
      naf: null,
      beta: null
    };
    return t.naf = this._getNAFPoints(8), t.doubles = this._getDoubles(4, e), t.beta = this._getBeta(), this.precomputed = t, this;
  }, u.prototype._hasDoubles = function (e) {
    if (!this.precomputed) return !1;
    var t = this.precomputed.doubles;
    return !!t && t.points.length >= Math.ceil((e.bitLength() + 1) / t.step);
  }, u.prototype._getDoubles = function (e, t) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;

    for (var a = [this], r = this, n = 0; n < t; n += e) {
      for (var s = 0; s < e; s++) {
        r = r.dbl();
      }

      a.push(r);
    }

    return {
      step: e,
      points: a
    };
  }, u.prototype._getNAFPoints = function (e) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;

    for (var t = [this], a = (1 << e) - 1, r = 1 === a ? null : this.dbl(), n = 1; n < a; n++) {
      t[n] = t[n - 1].add(r);
    }

    return {
      wnd: e,
      points: t
    };
  }, u.prototype._getBeta = function () {
    return null;
  }, u.prototype.dblp = function (e) {
    for (var t = this, a = 0; a < e; a++) {
      t = t.dbl();
    }

    return t;
  };
},
/*!*************************************************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/abi_encoder/abstract_data_types/data_type.js ***!
  \*************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var r = a(
  /*! lodash */
  0),
      n = a(
  /*! ../calldata/calldata */
  459),
      s = a(
  /*! ../calldata/raw_calldata */
  461),
      o = a(
  /*! ../utils/constants */
  26),
      i = function () {
    function e(e, t) {
      this._dataItem = e, this._factory = t;
    }

    return e.prototype.getDataItem = function () {
      return this._dataItem;
    }, e.prototype.getFactory = function () {
      return this._factory;
    }, e.prototype.encode = function (e, t, a) {
      var r = void 0 === t ? o.constants.DEFAULT_ENCODING_RULES : t,
          s = new n.Calldata(r);
      void 0 !== a && s.setSelector(a);
      var i = this.generateCalldataBlock(e);
      return s.setRoot(i), s.toString();
    }, e.prototype.decode = function (e, t, a) {
      if (void 0 !== a && !r.startsWith(e, a)) throw new Error("Tried to decode calldata, but it was missing the function selector. Expected prefix '" + a + "'. Got '" + e + "'.");
      var n = void 0 !== a,
          i = new s.RawCalldata(e, n),
          c = void 0 === t ? o.constants.DEFAULT_DECODING_RULES : t;
      return i.getSizeInBytes() > 0 ? this.generateValue(i, c) : this.getDefaultValue(c);
    }, e.prototype.decodeAsArray = function (e, t) {
      var a = this.decode(e, t);
      return r.isObject(a) ? r.values(a) : [a];
    }, e.prototype.getSignature = function (e) {
      if (r.isEmpty(this._dataItem.name) || !e) return this.getSignatureType();
      var t = this.getDataItem().name,
          a = t.lastIndexOf(".");
      return (void 0 !== a && a > 0 ? t.substr(a + 1) : t) + " " + this.getSignatureType();
    }, e;
  }();

  t.DataType = i;
},
/*!********************************************!*\
  !*** ./node_modules/levelup/lib/common.js ***!
  \********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  t.getCallback = function (e, t) {
    return "function" == typeof e ? e : t;
  }, t.getOptions = function (e) {
    return "object" == typeof e && null !== e ? e : {};
  };
},
/*!**************************************************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/node_modules/ethereumjs-util/dist/index.js ***!
  \**************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
      n = a(
  /*! keccak */
  33),
      s = a(
  /*! secp256k1 */
  30),
      o = a(
  /*! assert */
  19),
      i = a(
  /*! rlp */
  21),
      c = a(
  /*! bn.js */
  5),
      u = a(
  /*! create-hash */
  20),
      d = a(
  /*! safe-buffer */
  7).Buffer;
  Object.assign(t, a(
  /*! ethjs-util */
  36)), t.MAX_INTEGER = new c("ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff", 16), t.TWO_POW256 = new c("10000000000000000000000000000000000000000000000000000000000000000", 16), t.KECCAK256_NULL_S = "c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470", t.SHA3_NULL_S = t.KECCAK256_NULL_S, t.KECCAK256_NULL = d.from(t.KECCAK256_NULL_S, "hex"), t.SHA3_NULL = t.KECCAK256_NULL, t.KECCAK256_RLP_ARRAY_S = "1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347", t.SHA3_RLP_ARRAY_S = t.KECCAK256_RLP_ARRAY_S, t.KECCAK256_RLP_ARRAY = d.from(t.KECCAK256_RLP_ARRAY_S, "hex"), t.SHA3_RLP_ARRAY = t.KECCAK256_RLP_ARRAY, t.KECCAK256_RLP_S = "56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421", t.SHA3_RLP_S = t.KECCAK256_RLP_S, t.KECCAK256_RLP = d.from(t.KECCAK256_RLP_S, "hex"), t.SHA3_RLP = t.KECCAK256_RLP, t.BN = c, t.rlp = i, t.secp256k1 = s, t.zeros = function (e) {
    return d.allocUnsafe(e).fill(0);
  }, t.zeroAddress = function () {
    var e = t.zeros(20);
    return t.bufferToHex(e);
  }, t.setLengthLeft = t.setLength = function (e, a, r) {
    var n = t.zeros(a);
    return e = t.toBuffer(e), r ? e.length < a ? (e.copy(n), n) : e.slice(0, a) : e.length < a ? (e.copy(n, a - e.length), n) : e.slice(-a);
  }, t.setLengthRight = function (e, a) {
    return t.setLength(e, a, !0);
  }, t.unpad = t.stripZeros = function (e) {
    for (var a = (e = t.stripHexPrefix(e))[0]; e.length > 0 && "0" === a.toString();) {
      a = (e = e.slice(1))[0];
    }

    return e;
  }, t.toBuffer = function (e) {
    if (!d.isBuffer(e)) if (Array.isArray(e)) e = d.from(e);else if ("string" == typeof e) e = t.isHexString(e) ? d.from(t.padToEven(t.stripHexPrefix(e)), "hex") : d.from(e);else if ("number" == typeof e) e = t.intToBuffer(e);else if (null == e) e = d.allocUnsafe(0);else if (c.isBN(e)) e = e.toArrayLike(d);else {
      if (!e.toArray) throw new Error("invalid type");
      e = d.from(e.toArray());
    }
    return e;
  }, t.bufferToInt = function (e) {
    return new c(t.toBuffer(e)).toNumber();
  }, t.bufferToHex = function (e) {
    return "0x" + (e = t.toBuffer(e)).toString("hex");
  }, t.fromSigned = function (e) {
    return new c(e).fromTwos(256);
  }, t.toUnsigned = function (e) {
    return d.from(e.toTwos(256).toArray());
  }, t.keccak = function (e, a) {
    return e = t.toBuffer(e), a || (a = 256), n("keccak" + a).update(e).digest();
  }, t.keccak256 = function (e) {
    return t.keccak(e);
  }, t.sha3 = t.keccak, t.sha256 = function (e) {
    return e = t.toBuffer(e), u("sha256").update(e).digest();
  }, t.ripemd160 = function (e, a) {
    e = t.toBuffer(e);
    var r = u("rmd160").update(e).digest();
    return !0 === a ? t.setLength(r, 32) : r;
  }, t.rlphash = function (e) {
    return t.keccak(i.encode(e));
  }, t.isValidPrivate = function (e) {
    return s.privateKeyVerify(e);
  }, t.isValidPublic = function (e, t) {
    return 64 === e.length ? s.publicKeyVerify(d.concat([d.from([4]), e])) : !!t && s.publicKeyVerify(e);
  }, t.pubToAddress = t.publicToAddress = function (e, a) {
    return e = t.toBuffer(e), a && 64 !== e.length && (e = s.publicKeyConvert(e, !1).slice(1)), o(64 === e.length), t.keccak(e).slice(-20);
  };

  var f = t.privateToPublic = function (e) {
    return e = t.toBuffer(e), s.publicKeyCreate(e, !1).slice(1);
  };

  t.importPublic = function (e) {
    return 64 !== (e = t.toBuffer(e)).length && (e = s.publicKeyConvert(e, !1).slice(1)), e;
  }, t.ecsign = function (e, t) {
    var a = s.sign(e, t),
        r = {};
    return r.r = a.signature.slice(0, 32), r.s = a.signature.slice(32, 64), r.v = a.recovery + 27, r;
  }, t.hashPersonalMessage = function (e) {
    var a = t.toBuffer("Ethereum Signed Message:\n" + e.length.toString());
    return t.keccak(d.concat([a, e]));
  }, t.ecrecover = function (e, a, r, n) {
    var o = d.concat([t.setLength(r, 32), t.setLength(n, 32)], 64),
        i = a - 27;
    if (0 !== i && 1 !== i) throw new Error("Invalid signature v value");
    var c = s.recover(e, o, i);
    return s.publicKeyConvert(c, !1).slice(1);
  }, t.toRpcSig = function (e, a, r) {
    if (27 !== e && 28 !== e) throw new Error("Invalid recovery id");
    return t.bufferToHex(d.concat([t.setLengthLeft(a, 32), t.setLengthLeft(r, 32), t.toBuffer(e - 27)]));
  }, t.fromRpcSig = function (e) {
    if (65 !== (e = t.toBuffer(e)).length) throw new Error("Invalid signature length");
    var a = e[64];
    return a < 27 && (a += 27), {
      v: a,
      r: e.slice(0, 32),
      s: e.slice(32, 64)
    };
  }, t.privateToAddress = function (e) {
    return t.publicToAddress(f(e));
  }, t.isValidAddress = function (e) {
    return /^0x[0-9a-fA-F]{40}$/.test(e);
  }, t.isZeroAddress = function (e) {
    return t.zeroAddress() === t.addHexPrefix(e);
  }, t.toChecksumAddress = function (e) {
    e = t.stripHexPrefix(e).toLowerCase();

    for (var a = t.keccak(e).toString("hex"), r = "0x", n = 0; n < e.length; n++) {
      parseInt(a[n], 16) >= 8 ? r += e[n].toUpperCase() : r += e[n];
    }

    return r;
  }, t.isValidChecksumAddress = function (e) {
    return t.isValidAddress(e) && t.toChecksumAddress(e) === e;
  }, t.generateAddress = function (e, a) {
    return e = t.toBuffer(e), a = (a = new c(a)).isZero() ? null : d.from(a.toArray()), t.rlphash([e, a]).slice(-20);
  }, t.isPrecompiled = function (e) {
    var a = t.unpad(e);
    return 1 === a.length && a[0] >= 1 && a[0] <= 8;
  }, t.addHexPrefix = function (e) {
    return "string" != typeof e ? e : t.isHexPrefixed(e) ? e : "0x" + e;
  }, t.isValidSignature = function (e, t, a, r) {
    var n = new c("7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a0", 16),
        s = new c("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", 16);
    return 32 === t.length && 32 === a.length && (27 === e || 28 === e) && (t = new c(t), a = new c(a), !(t.isZero() || t.gt(s) || a.isZero() || a.gt(s)) && (!1 !== r || 1 !== new c(a).cmp(n)));
  }, t.baToJSON = function (e) {
    if (d.isBuffer(e)) return "0x" + e.toString("hex");

    if (e instanceof Array) {
      for (var a = [], r = 0; r < e.length; r++) {
        a.push(t.baToJSON(e[r]));
      }

      return a;
    }
  }, t.defineProperties = function (e, a, n) {
    if (e.raw = [], e._fields = [], e.toJSON = function (a) {
      if (a) {
        var r = {};
        return e._fields.forEach(function (t) {
          r[t] = "0x" + e[t].toString("hex");
        }), r;
      }

      return t.baToJSON(this.raw);
    }, e.serialize = function () {
      return i.encode(e.raw);
    }, a.forEach(function (a, r) {
      function n() {
        return e.raw[r];
      }

      function s(n) {
        "00" !== (n = t.toBuffer(n)).toString("hex") || a.allowZero || (n = d.allocUnsafe(0)), a.allowLess && a.length ? (n = t.stripZeros(n), o(a.length >= n.length, "The field " + a.name + " must not have more " + a.length + " bytes")) : a.allowZero && 0 === n.length || !a.length || o(a.length === n.length, "The field " + a.name + " must have byte length of " + a.length), e.raw[r] = n;
      }

      e._fields.push(a.name), Object.defineProperty(e, a.name, {
        enumerable: !0,
        configurable: !0,
        get: n,
        set: s
      }), a.default && (e[a.name] = a.default), a.alias && Object.defineProperty(e, a.alias, {
        enumerable: !1,
        configurable: !0,
        set: s,
        get: n
      });
    }), n) if ("string" == typeof n && (n = d.from(t.stripHexPrefix(n), "hex")), d.isBuffer(n) && (n = i.decode(n)), Array.isArray(n)) {
      if (n.length > e._fields.length) throw new Error("wrong number of fields in data");
      n.forEach(function (a, r) {
        e[e._fields[r]] = t.toBuffer(a);
      });
    } else {
      if ("object" !== (void 0 === n ? "undefined" : r(n))) throw new Error("invalid data");
      var s = Object.keys(n);
      a.forEach(function (t) {
        -1 !== s.indexOf(t.name) && (e[t.name] = n[t.name]), -1 !== s.indexOf(t.alias) && (e[t.alias] = n[t.alias]);
      });
    }
  };
},
/*!******************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/to-indexed-object.js ***!
  \******************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/indexed-object */
  216),
      n = a(
  /*! ../internals/require-object-coercible */
  120);

  e.exports = function (e) {
    return r(n(e));
  };
},
/*!*************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/bind-context.js ***!
  \*************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/a-function */
  600);

  e.exports = function (e, t, a) {
    if (r(e), void 0 === t) return e;

    switch (a) {
      case 0:
        return function () {
          return e.call(t);
        };

      case 1:
        return function (a) {
          return e.call(t, a);
        };

      case 2:
        return function (a, r) {
          return e.call(t, a, r);
        };

      case 3:
        return function (a, r, n) {
          return e.call(t, a, r, n);
        };
    }

    return function () {
      return e.apply(t, arguments);
    };
  };
},
/*!************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/hidden-keys.js ***!
  \************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = {};
},
/*!***************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/internal-state.js ***!
  \***************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r,
      n,
      s,
      o = a(
  /*! ../internals/native-weak-map */
  611),
      i = a(
  /*! ../internals/global */
  38),
      c = a(
  /*! ../internals/is-object */
  50),
      u = a(
  /*! ../internals/hide */
  42),
      d = a(
  /*! ../internals/has */
  51),
      f = a(
  /*! ../internals/shared-key */
  128),
      l = a(
  /*! ../internals/hidden-keys */
  85),
      h = i.WeakMap;

  if (o) {
    var p = new h(),
        b = p.get,
        m = p.has,
        y = p.set;
    r = function r(e, t) {
      return y.call(p, e, t), t;
    }, n = function n(e) {
      return b.call(p, e) || {};
    }, s = function s(e) {
      return m.call(p, e);
    };
  } else {
    var v = f("state");
    l[v] = !0, r = function r(e, t) {
      return u(e, v, t), t;
    }, n = function n(e) {
      return d(e, v) ? e[v] : {};
    }, s = function s(e) {
      return d(e, v);
    };
  }

  e.exports = {
    set: r,
    get: n,
    has: s,
    enforce: function enforce(e) {
      return s(e) ? n(e) : r(e, {});
    },
    getterFor: function getterFor(e) {
      return function (t) {
        var a;
        if (!c(t) || (a = n(t)).type !== e) throw TypeError("Incompatible receiver, " + e + " required");
        return a;
      };
    }
  };
},
/*!***************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-vm/dist/evm/message.js ***!
  \***************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = a(
    /*! bn.js */
    5),
        n = function () {
      function t(t) {
        this.to = t.to, this.value = t.value ? new r(t.value) : new r(0), this.caller = t.caller, this.gasLimit = t.gasLimit, this.data = t.data || e.alloc(0), this.depth = t.depth || 0, this.code = t.code, this._codeAddress = t.codeAddress, this.isStatic = t.isStatic || !1, this.isCompiled = t.isCompiled || !1, this.salt = t.salt, this.selfdestruct = t.selfdestruct, this.delegatecall = t.delegatecall || !1;
      }

      return Object.defineProperty(t.prototype, "codeAddress", {
        get: function get() {
          return this._codeAddress ? this._codeAddress : this.to;
        },
        enumerable: !0,
        configurable: !0
      }), t;
    }();

    t.default = n;
  }).call(this, a(
  /*! ./../../../../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!**********************************************!*\
  !*** ./node_modules/util.promisify/index.js ***!
  \**********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! define-properties */
  131),
      n = a(
  /*! util */
  23),
      s = a(
  /*! ./implementation */
  234),
      o = a(
  /*! ./polyfill */
  244),
      i = o(),
      c = a(
  /*! ./shim */
  659),
      u = function u(e) {
    return i.apply(n, arguments);
  };

  r(u, {
    custom: i.custom,
    customPromisifyArgs: i.customPromisifyArgs,
    getPolyfill: o,
    implementation: s,
    shim: c
  }), e.exports = u;
},
/*!***************************************!*\
  !*** ./node_modules/has/src/index.js ***!
  \***************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! function-bind */
  132);
  e.exports = r.call(Function.call, Object.prototype.hasOwnProperty);
},
/*!********************************************!*\
  !*** ./node_modules/browserify-aes/aes.js ***!
  \********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! safe-buffer */
  7).Buffer;

  function n(e) {
    r.isBuffer(e) || (e = r.from(e));

    for (var t = e.length / 4 | 0, a = new Array(t), n = 0; n < t; n++) {
      a[n] = e.readUInt32BE(4 * n);
    }

    return a;
  }

  function s(e) {
    for (; 0 < e.length; e++) {
      e[0] = 0;
    }
  }

  function o(e, t, a, r, n) {
    for (var s, o, i, c, u = a[0], d = a[1], f = a[2], l = a[3], h = e[0] ^ t[0], p = e[1] ^ t[1], b = e[2] ^ t[2], m = e[3] ^ t[3], y = 4, v = 1; v < n; v++) {
      s = u[h >>> 24] ^ d[p >>> 16 & 255] ^ f[b >>> 8 & 255] ^ l[255 & m] ^ t[y++], o = u[p >>> 24] ^ d[b >>> 16 & 255] ^ f[m >>> 8 & 255] ^ l[255 & h] ^ t[y++], i = u[b >>> 24] ^ d[m >>> 16 & 255] ^ f[h >>> 8 & 255] ^ l[255 & p] ^ t[y++], c = u[m >>> 24] ^ d[h >>> 16 & 255] ^ f[p >>> 8 & 255] ^ l[255 & b] ^ t[y++], h = s, p = o, b = i, m = c;
    }

    return s = (r[h >>> 24] << 24 | r[p >>> 16 & 255] << 16 | r[b >>> 8 & 255] << 8 | r[255 & m]) ^ t[y++], o = (r[p >>> 24] << 24 | r[b >>> 16 & 255] << 16 | r[m >>> 8 & 255] << 8 | r[255 & h]) ^ t[y++], i = (r[b >>> 24] << 24 | r[m >>> 16 & 255] << 16 | r[h >>> 8 & 255] << 8 | r[255 & p]) ^ t[y++], c = (r[m >>> 24] << 24 | r[h >>> 16 & 255] << 16 | r[p >>> 8 & 255] << 8 | r[255 & b]) ^ t[y++], [s >>>= 0, o >>>= 0, i >>>= 0, c >>>= 0];
  }

  var i = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54],
      c = function () {
    for (var e = new Array(256), t = 0; t < 256; t++) {
      e[t] = t < 128 ? t << 1 : t << 1 ^ 283;
    }

    for (var a = [], r = [], n = [[], [], [], []], s = [[], [], [], []], o = 0, i = 0, c = 0; c < 256; ++c) {
      var u = i ^ i << 1 ^ i << 2 ^ i << 3 ^ i << 4;
      u = u >>> 8 ^ 255 & u ^ 99, a[o] = u, r[u] = o;
      var d = e[o],
          f = e[d],
          l = e[f],
          h = 257 * e[u] ^ 16843008 * u;
      n[0][o] = h << 24 | h >>> 8, n[1][o] = h << 16 | h >>> 16, n[2][o] = h << 8 | h >>> 24, n[3][o] = h, h = 16843009 * l ^ 65537 * f ^ 257 * d ^ 16843008 * o, s[0][u] = h << 24 | h >>> 8, s[1][u] = h << 16 | h >>> 16, s[2][u] = h << 8 | h >>> 24, s[3][u] = h, 0 === o ? o = i = 1 : (o = d ^ e[e[e[l ^ d]]], i ^= e[e[i]]);
    }

    return {
      SBOX: a,
      INV_SBOX: r,
      SUB_MIX: n,
      INV_SUB_MIX: s
    };
  }();

  function u(e) {
    this._key = n(e), this._reset();
  }

  u.blockSize = 16, u.keySize = 32, u.prototype.blockSize = u.blockSize, u.prototype.keySize = u.keySize, u.prototype._reset = function () {
    for (var e = this._key, t = e.length, a = t + 6, r = 4 * (a + 1), n = [], s = 0; s < t; s++) {
      n[s] = e[s];
    }

    for (s = t; s < r; s++) {
      var o = n[s - 1];
      s % t == 0 ? (o = o << 8 | o >>> 24, o = c.SBOX[o >>> 24] << 24 | c.SBOX[o >>> 16 & 255] << 16 | c.SBOX[o >>> 8 & 255] << 8 | c.SBOX[255 & o], o ^= i[s / t | 0] << 24) : t > 6 && s % t == 4 && (o = c.SBOX[o >>> 24] << 24 | c.SBOX[o >>> 16 & 255] << 16 | c.SBOX[o >>> 8 & 255] << 8 | c.SBOX[255 & o]), n[s] = n[s - t] ^ o;
    }

    for (var u = [], d = 0; d < r; d++) {
      var f = r - d,
          l = n[f - (d % 4 ? 0 : 4)];
      u[d] = d < 4 || f <= 4 ? l : c.INV_SUB_MIX[0][c.SBOX[l >>> 24]] ^ c.INV_SUB_MIX[1][c.SBOX[l >>> 16 & 255]] ^ c.INV_SUB_MIX[2][c.SBOX[l >>> 8 & 255]] ^ c.INV_SUB_MIX[3][c.SBOX[255 & l]];
    }

    this._nRounds = a, this._keySchedule = n, this._invKeySchedule = u;
  }, u.prototype.encryptBlockRaw = function (e) {
    return o(e = n(e), this._keySchedule, c.SUB_MIX, c.SBOX, this._nRounds);
  }, u.prototype.encryptBlock = function (e) {
    var t = this.encryptBlockRaw(e),
        a = r.allocUnsafe(16);
    return a.writeUInt32BE(t[0], 0), a.writeUInt32BE(t[1], 4), a.writeUInt32BE(t[2], 8), a.writeUInt32BE(t[3], 12), a;
  }, u.prototype.decryptBlock = function (e) {
    var t = (e = n(e))[1];
    e[1] = e[3], e[3] = t;
    var a = o(e, this._invKeySchedule, c.INV_SUB_MIX, c.INV_SBOX, this._nRounds),
        s = r.allocUnsafe(16);
    return s.writeUInt32BE(a[0], 0), s.writeUInt32BE(a[3], 4), s.writeUInt32BE(a[2], 8), s.writeUInt32BE(a[1], 12), s;
  }, u.prototype.scrub = function () {
    s(this._keySchedule), s(this._invKeySchedule), s(this._key);
  }, e.exports.AES = u;
},
/*!**********************************************!*\
  !*** ./node_modules/evp_bytestokey/index.js ***!
  \**********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! safe-buffer */
  7).Buffer,
      n = a(
  /*! md5.js */
  98);

  e.exports = function (e, t, a, s) {
    if (r.isBuffer(e) || (e = r.from(e, "binary")), t && (r.isBuffer(t) || (t = r.from(t, "binary")), 8 !== t.length)) throw new RangeError("salt should be Buffer with 8 byte length");

    for (var o = a / 8, i = r.alloc(o), c = r.alloc(s || 0), u = r.alloc(0); o > 0 || s > 0;) {
      var d = new n();
      d.update(u), d.update(e), t && d.update(t), u = d.digest();
      var f = 0;

      if (o > 0) {
        var l = i.length - o;
        f = Math.min(o, u.length), u.copy(i, l, 0, f), o -= f;
      }

      if (f < u.length && s > 0) {
        var h = c.length - s,
            p = Math.min(s, u.length - f);
        u.copy(c, h, f, f + p), s -= p;
      }
    }

    return u.fill(0), {
      key: i,
      iv: c
    };
  };
},
/*!******************************************!*\
  !*** ./node_modules/parse-asn1/index.js ***!
  \******************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./asn1 */
  694),
      n = a(
  /*! ./aesid.json */
  705),
      s = a(
  /*! ./fixProc */
  706),
      o = a(
  /*! browserify-aes */
  137),
      i = a(
  /*! pbkdf2 */
  250),
      c = a(
  /*! safe-buffer */
  7).Buffer;

  function u(e) {
    var t;
    "object" != typeof e || c.isBuffer(e) || (t = e.passphrase, e = e.key), "string" == typeof e && (e = c.from(e));
    var a,
        u,
        d = s(e, t),
        f = d.tag,
        l = d.data;

    switch (f) {
      case "CERTIFICATE":
        u = r.certificate.decode(l, "der").tbsCertificate.subjectPublicKeyInfo;

      case "PUBLIC KEY":
        switch (u || (u = r.PublicKey.decode(l, "der")), a = u.algorithm.algorithm.join(".")) {
          case "1.2.840.113549.1.1.1":
            return r.RSAPublicKey.decode(u.subjectPublicKey.data, "der");

          case "1.2.840.10045.2.1":
            return u.subjectPrivateKey = u.subjectPublicKey, {
              type: "ec",
              data: u
            };

          case "1.2.840.10040.4.1":
            return u.algorithm.params.pub_key = r.DSAparam.decode(u.subjectPublicKey.data, "der"), {
              type: "dsa",
              data: u.algorithm.params
            };

          default:
            throw new Error("unknown key id " + a);
        }

        throw new Error("unknown key type " + f);

      case "ENCRYPTED PRIVATE KEY":
        l = function (e, t) {
          var a = e.algorithm.decrypt.kde.kdeparams.salt,
              r = parseInt(e.algorithm.decrypt.kde.kdeparams.iters.toString(), 10),
              s = n[e.algorithm.decrypt.cipher.algo.join(".")],
              u = e.algorithm.decrypt.cipher.iv,
              d = e.subjectPrivateKey,
              f = parseInt(s.split("-")[1], 10) / 8,
              l = i.pbkdf2Sync(t, a, r, f, "sha1"),
              h = o.createDecipheriv(s, l, u),
              p = [];
          return p.push(h.update(d)), p.push(h.final()), c.concat(p);
        }(l = r.EncryptedPrivateKey.decode(l, "der"), t);

      case "PRIVATE KEY":
        switch (a = (u = r.PrivateKey.decode(l, "der")).algorithm.algorithm.join(".")) {
          case "1.2.840.113549.1.1.1":
            return r.RSAPrivateKey.decode(u.subjectPrivateKey, "der");

          case "1.2.840.10045.2.1":
            return {
              curve: u.algorithm.curve,
              privateKey: r.ECPrivateKey.decode(u.subjectPrivateKey, "der").privateKey
            };

          case "1.2.840.10040.4.1":
            return u.algorithm.params.priv_key = r.DSAparam.decode(u.subjectPrivateKey, "der"), {
              type: "dsa",
              params: u.algorithm.params
            };

          default:
            throw new Error("unknown key id " + a);
        }

        throw new Error("unknown key type " + f);

      case "RSA PUBLIC KEY":
        return r.RSAPublicKey.decode(l, "der");

      case "RSA PRIVATE KEY":
        return r.RSAPrivateKey.decode(l, "der");

      case "DSA PRIVATE KEY":
        return {
          type: "dsa",
          params: r.DSAPrivateKey.decode(l, "der")
        };

      case "EC PRIVATE KEY":
        return {
          curve: (l = r.ECPrivateKey.decode(l, "der")).parameters.value,
          privateKey: l.privateKey
        };

      default:
        throw new Error("unknown key type " + f);
    }
  }

  e.exports = u, u.signature = r.signature;
},
/*!***************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/checkpoint/dividend_checkpoint_wrapper/index.ts ***!
  \***************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = a(
  /*! ./3.0.0 */
  841);
  t.WithDividendCheckpoint_3_0_0 = r.WithDividendCheckpoint_3_0_0;
  var n = a(
  /*! ./common */
  844);
  t.DividendCheckpointCommon = n.default;
},
/*!*********************************!*\
  !*** ./node_modules/url/url.js ***!
  \*********************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! punycode */
  323),
      n = a(
  /*! ./util */
  324);

  function s() {
    this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
  }

  t.parse = _, t.resolve = function (e, t) {
    return _(e, !1, !0).resolve(t);
  }, t.resolveObject = function (e, t) {
    return e ? _(e, !1, !0).resolveObject(t) : t;
  }, t.format = function (e) {
    n.isString(e) && (e = _(e));
    return e instanceof s ? e.format() : s.prototype.format.call(e);
  }, t.Url = s;
  var o = /^([a-z0-9.+-]+:)/i,
      i = /:[0-9]*$/,
      c = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
      u = ["{", "}", "|", "\\", "^", "`"].concat(["<", ">", '"', "`", " ", "\r", "\n", "\t"]),
      d = ["'"].concat(u),
      f = ["%", "/", "?", ";", "#"].concat(d),
      l = ["/", "?", "#"],
      h = /^[+a-z0-9A-Z_-]{0,63}$/,
      p = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
      b = {
    javascript: !0,
    "javascript:": !0
  },
      m = {
    javascript: !0,
    "javascript:": !0
  },
      y = {
    http: !0,
    https: !0,
    ftp: !0,
    gopher: !0,
    file: !0,
    "http:": !0,
    "https:": !0,
    "ftp:": !0,
    "gopher:": !0,
    "file:": !0
  },
      v = a(
  /*! querystring */
  325);

  function _(e, t, a) {
    if (e && n.isObject(e) && e instanceof s) return e;
    var r = new s();
    return r.parse(e, t, a), r;
  }

  s.prototype.parse = function (e, t, a) {
    if (!n.isString(e)) throw new TypeError("Parameter 'url' must be a string, not " + typeof e);
    var s = e.indexOf("?"),
        i = -1 !== s && s < e.indexOf("#") ? "?" : "#",
        u = e.split(i);
    u[0] = u[0].replace(/\\/g, "/");

    var _ = e = u.join(i);

    if (_ = _.trim(), !a && 1 === e.split("#").length) {
      var g = c.exec(_);
      if (g) return this.path = _, this.href = _, this.pathname = g[1], g[2] ? (this.search = g[2], this.query = t ? v.parse(this.search.substr(1)) : this.search.substr(1)) : t && (this.search = "", this.query = {}), this;
    }

    var A = o.exec(_);

    if (A) {
      var w = (A = A[0]).toLowerCase();
      this.protocol = w, _ = _.substr(A.length);
    }

    if (a || A || _.match(/^\/\/[^@\/]+@[^@\/]+/)) {
      var T = "//" === _.substr(0, 2);

      !T || A && m[A] || (_ = _.substr(2), this.slashes = !0);
    }

    if (!m[A] && (T || A && !y[A])) {
      for (var x, D, C = -1, S = 0; S < l.length; S++) {
        -1 !== (E = _.indexOf(l[S])) && (-1 === C || E < C) && (C = E);
      }

      -1 !== (D = -1 === C ? _.lastIndexOf("@") : _.lastIndexOf("@", C)) && (x = _.slice(0, D), _ = _.slice(D + 1), this.auth = decodeURIComponent(x)), C = -1;

      for (S = 0; S < f.length; S++) {
        var E;
        -1 !== (E = _.indexOf(f[S])) && (-1 === C || E < C) && (C = E);
      }

      -1 === C && (C = _.length), this.host = _.slice(0, C), _ = _.slice(C), this.parseHost(), this.hostname = this.hostname || "";
      var B = "[" === this.hostname[0] && "]" === this.hostname[this.hostname.length - 1];
      if (!B) for (var k = this.hostname.split(/\./), R = (S = 0, k.length); S < R; S++) {
        var W = k[S];

        if (W && !W.match(h)) {
          for (var I = "", N = 0, M = W.length; N < M; N++) {
            W.charCodeAt(N) > 127 ? I += "x" : I += W[N];
          }

          if (!I.match(h)) {
            var P = k.slice(0, S),
                L = k.slice(S + 1),
                O = W.match(p);
            O && (P.push(O[1]), L.unshift(O[2])), L.length && (_ = "/" + L.join(".") + _), this.hostname = P.join(".");
            break;
          }
        }
      }
      this.hostname.length > 255 ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), B || (this.hostname = r.toASCII(this.hostname));
      var F = this.port ? ":" + this.port : "",
          j = this.hostname || "";
      this.host = j + F, this.href += this.host, B && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), "/" !== _[0] && (_ = "/" + _));
    }

    if (!b[w]) for (S = 0, R = d.length; S < R; S++) {
      var G = d[S];

      if (-1 !== _.indexOf(G)) {
        var V = encodeURIComponent(G);
        V === G && (V = escape(G)), _ = _.split(G).join(V);
      }
    }

    var U = _.indexOf("#");

    -1 !== U && (this.hash = _.substr(U), _ = _.slice(0, U));

    var H = _.indexOf("?");

    if (-1 !== H ? (this.search = _.substr(H), this.query = _.substr(H + 1), t && (this.query = v.parse(this.query)), _ = _.slice(0, H)) : t && (this.search = "", this.query = {}), _ && (this.pathname = _), y[w] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
      F = this.pathname || "";
      var z = this.search || "";
      this.path = F + z;
    }

    return this.href = this.format(), this;
  }, s.prototype.format = function () {
    var e = this.auth || "";
    e && (e = (e = encodeURIComponent(e)).replace(/%3A/i, ":"), e += "@");
    var t = this.protocol || "",
        a = this.pathname || "",
        r = this.hash || "",
        s = !1,
        o = "";
    this.host ? s = e + this.host : this.hostname && (s = e + (-1 === this.hostname.indexOf(":") ? this.hostname : "[" + this.hostname + "]"), this.port && (s += ":" + this.port)), this.query && n.isObject(this.query) && Object.keys(this.query).length && (o = v.stringify(this.query));
    var i = this.search || o && "?" + o || "";
    return t && ":" !== t.substr(-1) && (t += ":"), this.slashes || (!t || y[t]) && !1 !== s ? (s = "//" + (s || ""), a && "/" !== a.charAt(0) && (a = "/" + a)) : s || (s = ""), r && "#" !== r.charAt(0) && (r = "#" + r), i && "?" !== i.charAt(0) && (i = "?" + i), t + s + (a = a.replace(/[?#]/g, function (e) {
      return encodeURIComponent(e);
    })) + (i = i.replace("#", "%23")) + r;
  }, s.prototype.resolve = function (e) {
    return this.resolveObject(_(e, !1, !0)).format();
  }, s.prototype.resolveObject = function (e) {
    if (n.isString(e)) {
      var t = new s();
      t.parse(e, !1, !0), e = t;
    }

    for (var a = new s(), r = Object.keys(this), o = 0; o < r.length; o++) {
      var i = r[o];
      a[i] = this[i];
    }

    if (a.hash = e.hash, "" === e.href) return a.href = a.format(), a;

    if (e.slashes && !e.protocol) {
      for (var c = Object.keys(e), u = 0; u < c.length; u++) {
        var d = c[u];
        "protocol" !== d && (a[d] = e[d]);
      }

      return y[a.protocol] && a.hostname && !a.pathname && (a.path = a.pathname = "/"), a.href = a.format(), a;
    }

    if (e.protocol && e.protocol !== a.protocol) {
      if (!y[e.protocol]) {
        for (var f = Object.keys(e), l = 0; l < f.length; l++) {
          var h = f[l];
          a[h] = e[h];
        }

        return a.href = a.format(), a;
      }

      if (a.protocol = e.protocol, e.host || m[e.protocol]) a.pathname = e.pathname;else {
        for (var p = (e.pathname || "").split("/"); p.length && !(e.host = p.shift());) {
          ;
        }

        e.host || (e.host = ""), e.hostname || (e.hostname = ""), "" !== p[0] && p.unshift(""), p.length < 2 && p.unshift(""), a.pathname = p.join("/");
      }

      if (a.search = e.search, a.query = e.query, a.host = e.host || "", a.auth = e.auth, a.hostname = e.hostname || e.host, a.port = e.port, a.pathname || a.search) {
        var b = a.pathname || "",
            v = a.search || "";
        a.path = b + v;
      }

      return a.slashes = a.slashes || e.slashes, a.href = a.format(), a;
    }

    var _ = a.pathname && "/" === a.pathname.charAt(0),
        g = e.host || e.pathname && "/" === e.pathname.charAt(0),
        A = g || _ || a.host && e.pathname,
        w = A,
        T = a.pathname && a.pathname.split("/") || [],
        x = (p = e.pathname && e.pathname.split("/") || [], a.protocol && !y[a.protocol]);

    if (x && (a.hostname = "", a.port = null, a.host && ("" === T[0] ? T[0] = a.host : T.unshift(a.host)), a.host = "", e.protocol && (e.hostname = null, e.port = null, e.host && ("" === p[0] ? p[0] = e.host : p.unshift(e.host)), e.host = null), A = A && ("" === p[0] || "" === T[0])), g) a.host = e.host || "" === e.host ? e.host : a.host, a.hostname = e.hostname || "" === e.hostname ? e.hostname : a.hostname, a.search = e.search, a.query = e.query, T = p;else if (p.length) T || (T = []), T.pop(), T = T.concat(p), a.search = e.search, a.query = e.query;else if (!n.isNullOrUndefined(e.search)) {
      if (x) a.hostname = a.host = T.shift(), (B = !!(a.host && a.host.indexOf("@") > 0) && a.host.split("@")) && (a.auth = B.shift(), a.host = a.hostname = B.shift());
      return a.search = e.search, a.query = e.query, n.isNull(a.pathname) && n.isNull(a.search) || (a.path = (a.pathname ? a.pathname : "") + (a.search ? a.search : "")), a.href = a.format(), a;
    }
    if (!T.length) return a.pathname = null, a.search ? a.path = "/" + a.search : a.path = null, a.href = a.format(), a;

    for (var D = T.slice(-1)[0], C = (a.host || e.host || T.length > 1) && ("." === D || ".." === D) || "" === D, S = 0, E = T.length; E >= 0; E--) {
      "." === (D = T[E]) ? T.splice(E, 1) : ".." === D ? (T.splice(E, 1), S++) : S && (T.splice(E, 1), S--);
    }

    if (!A && !w) for (; S--; S) {
      T.unshift("..");
    }
    !A || "" === T[0] || T[0] && "/" === T[0].charAt(0) || T.unshift(""), C && "/" !== T.join("/").substr(-1) && T.push("");
    var B,
        k = "" === T[0] || T[0] && "/" === T[0].charAt(0);
    x && (a.hostname = a.host = k ? "" : T.length ? T.shift() : "", (B = !!(a.host && a.host.indexOf("@") > 0) && a.host.split("@")) && (a.auth = B.shift(), a.host = a.hostname = B.shift()));
    return (A = A || a.host && T.length) && !k && T.unshift(""), T.length ? a.pathname = T.join("/") : (a.pathname = null, a.path = null), n.isNull(a.pathname) && n.isNull(a.search) || (a.path = (a.pathname ? a.pathname : "") + (a.search ? a.search : "")), a.auth = e.auth || a.auth, a.slashes = a.slashes || e.slashes, a.href = a.format(), a;
  }, s.prototype.parseHost = function () {
    var e = this.host,
        t = i.exec(e);
    t && (":" !== (t = t[0]) && (this.port = t.substr(1)), e = e.substr(0, e.length - t.length)), e && (this.hostname = e);
  };
},
/*!*********************************************!*\
  !*** ./node_modules/jsonschema/lib/scan.js ***!
  \*********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! url */
  94),
      n = a(
  /*! ./helpers */
  57);

  function s(e, t) {
    this.id = e, this.ref = t;
  }

  e.exports.SchemaScanResult = s, e.exports.scan = function (e, t) {
    function a(e, t) {
      if (t && "object" == typeof t) if (t.$ref) {
        var s = r.resolve(e, t.$ref);
        u[s] = u[s] ? u[s] + 1 : 0;
      } else {
        var d = t.id ? r.resolve(e, t.id) : e;

        if (d) {
          if (d.indexOf("#") < 0 && (d += "#"), c[d]) {
            if (!n.deepCompareStrict(c[d], t)) throw new Error("Schema <" + t + "> already exists with different definition");
            return c[d];
          }

          c[d] = t, "#" == d[d.length - 1] && (c[d.substring(0, d.length - 1)] = t);
        }

        o(d + "/items", t.items instanceof Array ? t.items : [t.items]), o(d + "/extends", t.extends instanceof Array ? t.extends : [t.extends]), a(d + "/additionalItems", t.additionalItems), i(d + "/properties", t.properties), a(d + "/additionalProperties", t.additionalProperties), i(d + "/definitions", t.definitions), i(d + "/patternProperties", t.patternProperties), i(d + "/dependencies", t.dependencies), o(d + "/disallow", t.disallow), o(d + "/allOf", t.allOf), o(d + "/anyOf", t.anyOf), o(d + "/oneOf", t.oneOf), a(d + "/not", t.not);
      }
    }

    function o(e, t) {
      if (t instanceof Array) for (var r = 0; r < t.length; r++) {
        a(e + "/" + r, t[r]);
      }
    }

    function i(e, t) {
      if (t && "object" == typeof t) for (var r in t) {
        a(e + "/" + r, t[r]);
      }
    }

    var c = {},
        u = {};
    return a(e, t), new s(c, u);
  };
},
/*!************************************************************************!*\
  !*** ./node_modules/readable-stream/node_modules/safe-buffer/index.js ***!
  \************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! buffer */
  1),
      n = r.Buffer;

  function s(e, t) {
    for (var a in e) {
      t[a] = e[a];
    }
  }

  function o(e, t, a) {
    return n(e, t, a);
  }

  n.from && n.alloc && n.allocUnsafe && n.allocUnsafeSlow ? e.exports = r : (s(r, t), t.Buffer = o), s(n, o), o.from = function (e, t, a) {
    if ("number" == typeof e) throw new TypeError("Argument must not be a number");
    return n(e, t, a);
  }, o.alloc = function (e, t, a) {
    if ("number" != typeof e) throw new TypeError("Argument must be a number");
    var r = n(e);
    return void 0 !== t ? "string" == typeof a ? r.fill(t, a) : r.fill(t) : r.fill(0), r;
  }, o.allocUnsafe = function (e) {
    if ("number" != typeof e) throw new TypeError("Argument must be a number");
    return n(e);
  }, o.allocUnsafeSlow = function (e) {
    if ("number" != typeof e) throw new TypeError("Argument must be a number");
    return r.SlowBuffer(e);
  };
},
/*!**************************************************************!*\
  !*** ./node_modules/readable-stream/lib/_stream_writable.js ***!
  \**************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (t, r, n) {
    var s = a(
    /*! process-nextick-args */
    77);

    function o(e) {
      var t = this;
      this.next = null, this.entry = null, this.finish = function () {
        !function (e, t, a) {
          var r = e.entry;
          e.entry = null;

          for (; r;) {
            var n = r.callback;
            t.pendingcb--, n(a), r = r.next;
          }

          t.corkedRequestsFree ? t.corkedRequestsFree.next = e : t.corkedRequestsFree = e;
        }(t, e);
      };
    }

    e.exports = v;
    var i,
        c = !t.browser && ["v0.10", "v0.9."].indexOf(t.version.slice(0, 5)) > -1 ? r : s.nextTick;
    v.WritableState = y;
    var u = a(
    /*! core-util-is */
    27);
    u.inherits = a(
    /*! inherits */
    3);

    var d = {
      deprecate: a(
      /*! util-deprecate */
      382)
    },
        f = a(
    /*! ./internal/streams/stream */
    154),
        l = a(
    /*! safe-buffer */
    96).Buffer,
        h = n.Uint8Array || function () {};

    var p,
        b = a(
    /*! ./internal/streams/destroy */
    155);

    function m() {}

    function y(e, t) {
      i = i || a(
      /*! ./_stream_duplex */
      52), e = e || {};
      var r = t instanceof i;
      this.objectMode = !!e.objectMode, r && (this.objectMode = this.objectMode || !!e.writableObjectMode);
      var n = e.highWaterMark,
          u = e.writableHighWaterMark,
          d = this.objectMode ? 16 : 16384;
      this.highWaterMark = n || 0 === n ? n : r && (u || 0 === u) ? u : d, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
      var f = !1 === e.decodeStrings;
      this.decodeStrings = !f, this.defaultEncoding = e.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function (e) {
        !function (e, t) {
          var a = e._writableState,
              r = a.sync,
              n = a.writecb;
          if (function (e) {
            e.writing = !1, e.writecb = null, e.length -= e.writelen, e.writelen = 0;
          }(a), t) !function (e, t, a, r, n) {
            --t.pendingcb, a ? (s.nextTick(n, r), s.nextTick(x, e, t), e._writableState.errorEmitted = !0, e.emit("error", r)) : (n(r), e._writableState.errorEmitted = !0, e.emit("error", r), x(e, t));
          }(e, a, r, t, n);else {
            var o = w(a);
            o || a.corked || a.bufferProcessing || !a.bufferedRequest || A(e, a), r ? c(g, e, a, o, n) : g(e, a, o, n);
          }
        }(t, e);
      }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new o(this);
    }

    function v(e) {
      if (i = i || a(
      /*! ./_stream_duplex */
      52), !(p.call(v, this) || this instanceof i)) return new v(e);
      this._writableState = new y(e, this), this.writable = !0, e && ("function" == typeof e.write && (this._write = e.write), "function" == typeof e.writev && (this._writev = e.writev), "function" == typeof e.destroy && (this._destroy = e.destroy), "function" == typeof e.final && (this._final = e.final)), f.call(this);
    }

    function _(e, t, a, r, n, s, o) {
      t.writelen = r, t.writecb = o, t.writing = !0, t.sync = !0, a ? e._writev(n, t.onwrite) : e._write(n, s, t.onwrite), t.sync = !1;
    }

    function g(e, t, a, r) {
      a || function (e, t) {
        0 === t.length && t.needDrain && (t.needDrain = !1, e.emit("drain"));
      }(e, t), t.pendingcb--, r(), x(e, t);
    }

    function A(e, t) {
      t.bufferProcessing = !0;
      var a = t.bufferedRequest;

      if (e._writev && a && a.next) {
        var r = t.bufferedRequestCount,
            n = new Array(r),
            s = t.corkedRequestsFree;
        s.entry = a;

        for (var i = 0, c = !0; a;) {
          n[i] = a, a.isBuf || (c = !1), a = a.next, i += 1;
        }

        n.allBuffers = c, _(e, t, !0, t.length, n, "", s.finish), t.pendingcb++, t.lastBufferedRequest = null, s.next ? (t.corkedRequestsFree = s.next, s.next = null) : t.corkedRequestsFree = new o(t), t.bufferedRequestCount = 0;
      } else {
        for (; a;) {
          var u = a.chunk,
              d = a.encoding,
              f = a.callback;
          if (_(e, t, !1, t.objectMode ? 1 : u.length, u, d, f), a = a.next, t.bufferedRequestCount--, t.writing) break;
        }

        null === a && (t.lastBufferedRequest = null);
      }

      t.bufferedRequest = a, t.bufferProcessing = !1;
    }

    function w(e) {
      return e.ending && 0 === e.length && null === e.bufferedRequest && !e.finished && !e.writing;
    }

    function T(e, t) {
      e._final(function (a) {
        t.pendingcb--, a && e.emit("error", a), t.prefinished = !0, e.emit("prefinish"), x(e, t);
      });
    }

    function x(e, t) {
      var a = w(t);
      return a && (!function (e, t) {
        t.prefinished || t.finalCalled || ("function" == typeof e._final ? (t.pendingcb++, t.finalCalled = !0, s.nextTick(T, e, t)) : (t.prefinished = !0, e.emit("prefinish")));
      }(e, t), 0 === t.pendingcb && (t.finished = !0, e.emit("finish"))), a;
    }

    u.inherits(v, f), y.prototype.getBuffer = function () {
      for (var e = this.bufferedRequest, t = []; e;) {
        t.push(e), e = e.next;
      }

      return t;
    }, function () {
      try {
        Object.defineProperty(y.prototype, "buffer", {
          get: d.deprecate(function () {
            return this.getBuffer();
          }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
      } catch (e) {}
    }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (p = Function.prototype[Symbol.hasInstance], Object.defineProperty(v, Symbol.hasInstance, {
      value: function value(e) {
        return !!p.call(this, e) || this === v && e && e._writableState instanceof y;
      }
    })) : p = function p(e) {
      return e instanceof this;
    }, v.prototype.pipe = function () {
      this.emit("error", new Error("Cannot pipe, not readable"));
    }, v.prototype.write = function (e, t, a) {
      var r,
          n = this._writableState,
          o = !1,
          i = !n.objectMode && (r = e, l.isBuffer(r) || r instanceof h);
      return i && !l.isBuffer(e) && (e = function (e) {
        return l.from(e);
      }(e)), "function" == typeof t && (a = t, t = null), i ? t = "buffer" : t || (t = n.defaultEncoding), "function" != typeof a && (a = m), n.ended ? function (e, t) {
        var a = new Error("write after end");
        e.emit("error", a), s.nextTick(t, a);
      }(this, a) : (i || function (e, t, a, r) {
        var n = !0,
            o = !1;
        return null === a ? o = new TypeError("May not write null values to stream") : "string" == typeof a || void 0 === a || t.objectMode || (o = new TypeError("Invalid non-string/buffer chunk")), o && (e.emit("error", o), s.nextTick(r, o), n = !1), n;
      }(this, n, e, a)) && (n.pendingcb++, o = function (e, t, a, r, n, s) {
        if (!a) {
          var o = function (e, t, a) {
            e.objectMode || !1 === e.decodeStrings || "string" != typeof t || (t = l.from(t, a));
            return t;
          }(t, r, n);

          r !== o && (a = !0, n = "buffer", r = o);
        }

        var i = t.objectMode ? 1 : r.length;
        t.length += i;
        var c = t.length < t.highWaterMark;
        c || (t.needDrain = !0);

        if (t.writing || t.corked) {
          var u = t.lastBufferedRequest;
          t.lastBufferedRequest = {
            chunk: r,
            encoding: n,
            isBuf: a,
            callback: s,
            next: null
          }, u ? u.next = t.lastBufferedRequest : t.bufferedRequest = t.lastBufferedRequest, t.bufferedRequestCount += 1;
        } else _(e, t, !1, i, r, n, s);

        return c;
      }(this, n, i, e, t, a)), o;
    }, v.prototype.cork = function () {
      this._writableState.corked++;
    }, v.prototype.uncork = function () {
      var e = this._writableState;
      e.corked && (e.corked--, e.writing || e.corked || e.finished || e.bufferProcessing || !e.bufferedRequest || A(this, e));
    }, v.prototype.setDefaultEncoding = function (e) {
      if ("string" == typeof e && (e = e.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((e + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + e);
      return this._writableState.defaultEncoding = e, this;
    }, Object.defineProperty(v.prototype, "writableHighWaterMark", {
      enumerable: !1,
      get: function get() {
        return this._writableState.highWaterMark;
      }
    }), v.prototype._write = function (e, t, a) {
      a(new Error("_write() is not implemented"));
    }, v.prototype._writev = null, v.prototype.end = function (e, t, a) {
      var r = this._writableState;
      "function" == typeof e ? (a = e, e = null, t = null) : "function" == typeof t && (a = t, t = null), null != e && this.write(e, t), r.corked && (r.corked = 1, this.uncork()), r.ending || r.finished || function (e, t, a) {
        t.ending = !0, x(e, t), a && (t.finished ? s.nextTick(a) : e.once("finish", a));
        t.ended = !0, e.writable = !1;
      }(this, r, a);
    }, Object.defineProperty(v.prototype, "destroyed", {
      get: function get() {
        return void 0 !== this._writableState && this._writableState.destroyed;
      },
      set: function set(e) {
        this._writableState && (this._writableState.destroyed = e);
      }
    }), v.prototype.destroy = b.destroy, v.prototype._undestroy = b.undestroy, v.prototype._destroy = function (e, t) {
      this.end(), t(e);
    };
  }).call(this, a(
  /*! ./../../process/browser.js */
  9), a(
  /*! ./../../timers-browserify/main.js */
  69).setImmediate, a(
  /*! ./../../webpack/buildin/global.js */
  18));
},
/*!**************************************!*\
  !*** ./node_modules/md5.js/index.js ***!
  \**************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! inherits */
  3),
      n = a(
  /*! hash-base */
  158),
      s = a(
  /*! safe-buffer */
  7).Buffer,
      o = new Array(16);

  function i() {
    n.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
  }

  function c(e, t) {
    return e << t | e >>> 32 - t;
  }

  function u(e, t, a, r, n, s, o) {
    return c(e + (t & a | ~t & r) + n + s | 0, o) + t | 0;
  }

  function d(e, t, a, r, n, s, o) {
    return c(e + (t & r | a & ~r) + n + s | 0, o) + t | 0;
  }

  function f(e, t, a, r, n, s, o) {
    return c(e + (t ^ a ^ r) + n + s | 0, o) + t | 0;
  }

  function l(e, t, a, r, n, s, o) {
    return c(e + (a ^ (t | ~r)) + n + s | 0, o) + t | 0;
  }

  r(i, n), i.prototype._update = function () {
    for (var e = o, t = 0; t < 16; ++t) {
      e[t] = this._block.readInt32LE(4 * t);
    }

    var a = this._a,
        r = this._b,
        n = this._c,
        s = this._d;
    a = u(a, r, n, s, e[0], 3614090360, 7), s = u(s, a, r, n, e[1], 3905402710, 12), n = u(n, s, a, r, e[2], 606105819, 17), r = u(r, n, s, a, e[3], 3250441966, 22), a = u(a, r, n, s, e[4], 4118548399, 7), s = u(s, a, r, n, e[5], 1200080426, 12), n = u(n, s, a, r, e[6], 2821735955, 17), r = u(r, n, s, a, e[7], 4249261313, 22), a = u(a, r, n, s, e[8], 1770035416, 7), s = u(s, a, r, n, e[9], 2336552879, 12), n = u(n, s, a, r, e[10], 4294925233, 17), r = u(r, n, s, a, e[11], 2304563134, 22), a = u(a, r, n, s, e[12], 1804603682, 7), s = u(s, a, r, n, e[13], 4254626195, 12), n = u(n, s, a, r, e[14], 2792965006, 17), a = d(a, r = u(r, n, s, a, e[15], 1236535329, 22), n, s, e[1], 4129170786, 5), s = d(s, a, r, n, e[6], 3225465664, 9), n = d(n, s, a, r, e[11], 643717713, 14), r = d(r, n, s, a, e[0], 3921069994, 20), a = d(a, r, n, s, e[5], 3593408605, 5), s = d(s, a, r, n, e[10], 38016083, 9), n = d(n, s, a, r, e[15], 3634488961, 14), r = d(r, n, s, a, e[4], 3889429448, 20), a = d(a, r, n, s, e[9], 568446438, 5), s = d(s, a, r, n, e[14], 3275163606, 9), n = d(n, s, a, r, e[3], 4107603335, 14), r = d(r, n, s, a, e[8], 1163531501, 20), a = d(a, r, n, s, e[13], 2850285829, 5), s = d(s, a, r, n, e[2], 4243563512, 9), n = d(n, s, a, r, e[7], 1735328473, 14), a = f(a, r = d(r, n, s, a, e[12], 2368359562, 20), n, s, e[5], 4294588738, 4), s = f(s, a, r, n, e[8], 2272392833, 11), n = f(n, s, a, r, e[11], 1839030562, 16), r = f(r, n, s, a, e[14], 4259657740, 23), a = f(a, r, n, s, e[1], 2763975236, 4), s = f(s, a, r, n, e[4], 1272893353, 11), n = f(n, s, a, r, e[7], 4139469664, 16), r = f(r, n, s, a, e[10], 3200236656, 23), a = f(a, r, n, s, e[13], 681279174, 4), s = f(s, a, r, n, e[0], 3936430074, 11), n = f(n, s, a, r, e[3], 3572445317, 16), r = f(r, n, s, a, e[6], 76029189, 23), a = f(a, r, n, s, e[9], 3654602809, 4), s = f(s, a, r, n, e[12], 3873151461, 11), n = f(n, s, a, r, e[15], 530742520, 16), a = l(a, r = f(r, n, s, a, e[2], 3299628645, 23), n, s, e[0], 4096336452, 6), s = l(s, a, r, n, e[7], 1126891415, 10), n = l(n, s, a, r, e[14], 2878612391, 15), r = l(r, n, s, a, e[5], 4237533241, 21), a = l(a, r, n, s, e[12], 1700485571, 6), s = l(s, a, r, n, e[3], 2399980690, 10), n = l(n, s, a, r, e[10], 4293915773, 15), r = l(r, n, s, a, e[1], 2240044497, 21), a = l(a, r, n, s, e[8], 1873313359, 6), s = l(s, a, r, n, e[15], 4264355552, 10), n = l(n, s, a, r, e[6], 2734768916, 15), r = l(r, n, s, a, e[13], 1309151649, 21), a = l(a, r, n, s, e[4], 4149444226, 6), s = l(s, a, r, n, e[11], 3174756917, 10), n = l(n, s, a, r, e[2], 718787259, 15), r = l(r, n, s, a, e[9], 3951481745, 21), this._a = this._a + a | 0, this._b = this._b + r | 0, this._c = this._c + n | 0, this._d = this._d + s | 0;
  }, i.prototype._digest = function () {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var e = s.allocUnsafe(16);
    return e.writeInt32LE(this._a, 0), e.writeInt32LE(this._b, 4), e.writeInt32LE(this._c, 8), e.writeInt32LE(this._d, 12), e;
  }, e.exports = i;
},
/*!*****************************************!*\
  !*** ./node_modules/ripemd160/index.js ***!
  \*****************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! buffer */
  1).Buffer,
      n = a(
  /*! inherits */
  3),
      s = a(
  /*! hash-base */
  158),
      o = new Array(16),
      i = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13],
      c = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11],
      u = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6],
      d = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11],
      f = [0, 1518500249, 1859775393, 2400959708, 2840853838],
      l = [1352829926, 1548603684, 1836072691, 2053994217, 0];

  function h() {
    s.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
  }

  function p(e, t) {
    return e << t | e >>> 32 - t;
  }

  function b(e, t, a, r, n, s, o, i) {
    return p(e + (t ^ a ^ r) + s + o | 0, i) + n | 0;
  }

  function m(e, t, a, r, n, s, o, i) {
    return p(e + (t & a | ~t & r) + s + o | 0, i) + n | 0;
  }

  function y(e, t, a, r, n, s, o, i) {
    return p(e + ((t | ~a) ^ r) + s + o | 0, i) + n | 0;
  }

  function v(e, t, a, r, n, s, o, i) {
    return p(e + (t & r | a & ~r) + s + o | 0, i) + n | 0;
  }

  function _(e, t, a, r, n, s, o, i) {
    return p(e + (t ^ (a | ~r)) + s + o | 0, i) + n | 0;
  }

  n(h, s), h.prototype._update = function () {
    for (var e = o, t = 0; t < 16; ++t) {
      e[t] = this._block.readInt32LE(4 * t);
    }

    for (var a = 0 | this._a, r = 0 | this._b, n = 0 | this._c, s = 0 | this._d, h = 0 | this._e, g = 0 | this._a, A = 0 | this._b, w = 0 | this._c, T = 0 | this._d, x = 0 | this._e, D = 0; D < 80; D += 1) {
      var C, S;
      D < 16 ? (C = b(a, r, n, s, h, e[i[D]], f[0], u[D]), S = _(g, A, w, T, x, e[c[D]], l[0], d[D])) : D < 32 ? (C = m(a, r, n, s, h, e[i[D]], f[1], u[D]), S = v(g, A, w, T, x, e[c[D]], l[1], d[D])) : D < 48 ? (C = y(a, r, n, s, h, e[i[D]], f[2], u[D]), S = y(g, A, w, T, x, e[c[D]], l[2], d[D])) : D < 64 ? (C = v(a, r, n, s, h, e[i[D]], f[3], u[D]), S = m(g, A, w, T, x, e[c[D]], l[3], d[D])) : (C = _(a, r, n, s, h, e[i[D]], f[4], u[D]), S = b(g, A, w, T, x, e[c[D]], l[4], d[D])), a = h, h = s, s = p(n, 10), n = r, r = C, g = x, x = T, T = p(w, 10), w = A, A = S;
    }

    var E = this._b + n + T | 0;
    this._b = this._c + s + x | 0, this._c = this._d + h + g | 0, this._d = this._e + a + A | 0, this._e = this._a + r + w | 0, this._a = E;
  }, h.prototype._digest = function () {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var e = r.alloc ? r.alloc(20) : new r(20);
    return e.writeInt32LE(this._a, 0), e.writeInt32LE(this._b, 4), e.writeInt32LE(this._c, 8), e.writeInt32LE(this._d, 12), e.writeInt32LE(this._e, 16), e;
  }, e.exports = h;
},
/*!**************************************!*\
  !*** ./node_modules/sha.js/index.js ***!
  \**************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (t = e.exports = function (e) {
    e = e.toLowerCase();
    var a = t[e];
    if (!a) throw new Error(e + " is not supported (we accept pull requests)");
    return new a();
  }).sha = a(
  /*! ./sha */
  396), t.sha1 = a(
  /*! ./sha1 */
  397), t.sha224 = a(
  /*! ./sha224 */
  398), t.sha256 = a(
  /*! ./sha256 */
  159), t.sha384 = a(
  /*! ./sha384 */
  399), t.sha512 = a(
  /*! ./sha512 */
  160);
},
/*!***************************************!*\
  !*** ./node_modules/brorand/index.js ***!
  \***************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r;

  function n(e) {
    this.rand = e;
  }

  if (e.exports = function (e) {
    return r || (r = new n(null)), r.generate(e);
  }, e.exports.Rand = n, n.prototype.generate = function (e) {
    return this._rand(e);
  }, n.prototype._rand = function (e) {
    if (this.rand.getBytes) return this.rand.getBytes(e);

    for (var t = new Uint8Array(e), a = 0; a < t.length; a++) {
      t[a] = this.rand.getByte();
    }

    return t;
  }, "object" == typeof self) self.crypto && self.crypto.getRandomValues ? n.prototype._rand = function (e) {
    var t = new Uint8Array(e);
    return self.crypto.getRandomValues(t), t;
  } : self.msCrypto && self.msCrypto.getRandomValues ? n.prototype._rand = function (e) {
    var t = new Uint8Array(e);
    return self.msCrypto.getRandomValues(t), t;
  } : "object" == typeof window && (n.prototype._rand = function () {
    throw new Error("Not implemented yet");
  });else try {
    var s = a(
    /*! crypto */
    402);
    if ("function" != typeof s.randomBytes) throw new Error("Not supported");

    n.prototype._rand = function (e) {
      return s.randomBytes(e);
    };
  } catch (e) {}
},
/*!******************************************************!*\
  !*** ./node_modules/elliptic/lib/elliptic/curves.js ***!
  \******************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r,
      n = t,
      s = a(
  /*! hash.js */
  163),
      o = a(
  /*! ./curve */
  162),
      i = a(
  /*! ./utils */
  31).assert;

  function c(e) {
    "short" === e.type ? this.curve = new o.short(e) : "edwards" === e.type ? this.curve = new o.edwards(e) : this.curve = new o.mont(e), this.g = this.curve.g, this.n = this.curve.n, this.hash = e.hash, i(this.g.validate(), "Invalid curve"), i(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
  }

  function u(e, t) {
    Object.defineProperty(n, e, {
      configurable: !0,
      enumerable: !0,
      get: function get() {
        var a = new c(t);
        return Object.defineProperty(n, e, {
          configurable: !0,
          enumerable: !0,
          value: a
        }), a;
      }
    });
  }

  n.PresetCurve = c, u("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: s.sha256,
    gRed: !1,
    g: ["188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012", "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"]
  }), u("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: s.sha256,
    gRed: !1,
    g: ["b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21", "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"]
  }), u("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: s.sha256,
    gRed: !1,
    g: ["6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296", "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"]
  }), u("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: s.sha384,
    gRed: !1,
    g: ["aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7", "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"]
  }), u("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: s.sha512,
    gRed: !1,
    g: ["000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66", "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"]
  }), u("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: s.sha256,
    gRed: !1,
    g: ["9"]
  }), u("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: s.sha256,
    gRed: !1,
    g: ["216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a", "6666666666666666666666666666666666666666666666666666666666666658"]
  });

  try {
    r = a(
    /*! ./precomputed/secp256k1 */
    412);
  } catch (e) {
    r = void 0;
  }

  u("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: s.sha256,
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [{
      a: "3086d221a7d46bcde86c90e49284eb15",
      b: "-e4437ed6010e88286f547fa90abfe4c3"
    }, {
      a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
      b: "3086d221a7d46bcde86c90e49284eb15"
    }],
    gRed: !1,
    g: ["79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798", "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8", r]
  });
},
/*!****************************************!*\
  !*** (webpack)/buildin/amd-options.js ***!
  \****************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  (function (t) {
    e.exports = t;
  }).call(this, {});
},
/*!************************************************!*\
  !*** ./node_modules/ethers/dist/ethers.min.js ***!
  \************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    var a;

    e.exports = function e(t, r, n) {
      function s(i, c) {
        if (!r[i]) {
          if (!t[i]) {
            if (!c && "function" == typeof a && a) return a(i, !0);
            if (o) return o(i, !0);
            var u = new Error("Cannot find module '" + i + "'");
            throw u.code = "MODULE_NOT_FOUND", u;
          }

          var d = r[i] = {
            exports: {}
          };
          t[i][0].call(d.exports, function (e) {
            return s(t[i][1][e] || e);
          }, d, d.exports, e, t, r, n);
        }

        return r[i].exports;
      }

      for (var o = "function" == typeof a && a, i = 0; i < n.length; i++) {
        s(n[i]);
      }

      return s;
    }({
      1: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        }), a.version = "4.0.33";
      }, {}],
      2: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var r = e("./utils/properties"),
            n = (s.isSigner = function (e) {
          return r.isType(e, "Signer");
        }, s);

        function s() {
          r.setType(this, "Signer");
        }

        a.Signer = n;
      }, {
        "./utils/properties": 73
      }],
      3: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var r = e("./utils/bignumber");
        a.AddressZero = "0x0000000000000000000000000000000000000000", a.HashZero = "0x0000000000000000000000000000000000000000000000000000000000000000", a.EtherSymbol = "Ξ";
        var n = r.bigNumberify(-1);
        a.NegativeOne = n;
        var s = r.bigNumberify(0);
        a.Zero = s;
        var o = r.bigNumberify(1);
        a.One = o;
        var i = r.bigNumberify(2);
        a.Two = i;
        var c = r.bigNumberify("1000000000000000000");
        a.WeiPerEther = c;
        var u = r.bigNumberify("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
        a.MaxUint256 = u;
      }, {
        "./utils/bignumber": 62
      }],
      4: [function (e, t, a) {
        "use strict";

        var r,
            n = this && this.__extends || (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var a in t) {
            t.hasOwnProperty(a) && (e[a] = t[a]);
          }
        }, function (e, t) {
          function a() {
            this.constructor = e;
          }

          r(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
        }),
            s = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var o,
            i = e("./constants"),
            c = s(e("./errors")),
            u = e("./utils/abi-coder"),
            d = e("./utils/address"),
            f = e("./utils/bignumber"),
            l = e("./utils/bytes"),
            h = e("./utils/interface"),
            p = e("./utils/properties"),
            b = e("./providers/abstract-provider"),
            m = e("./abstract-signer"),
            y = (n(v, o = m.Signer), v.prototype.getAddress = function () {
          return Promise.resolve(this.address);
        }, v.prototype._fail = function (e, t) {
          return Promise.resolve().then(function () {
            c.throwError(e, c.UNSUPPORTED_OPERATION, {
              operation: t
            });
          });
        }, v.prototype.signMessage = function (e) {
          return this._fail("VoidSigner cannot sign messages", "signMessage");
        }, v.prototype.sendTransaction = function (e) {
          return this._fail("VoidSigner cannot sign transactions", "sendTransaction");
        }, v.prototype.connect = function (e) {
          return new v(this.address, e);
        }, v);

        function v(e, t) {
          var a = o.call(this) || this;
          return p.defineReadOnly(a, "address", e), p.defineReadOnly(a, "provider", t), a;
        }

        a.VoidSigner = y;
        var _ = {
          chainId: !0,
          data: !0,
          from: !0,
          gasLimit: !0,
          gasPrice: !0,
          nonce: !0,
          to: !0,
          value: !0
        };

        function g(e, t, a) {
          var r = e.interface.functions[t];
          return function () {
            for (var t = [], n = 0; n < arguments.length; n++) {
              t[n] = arguments[n];
            }

            var s = {},
                o = null;
            if (t.length === r.inputs.length + 1 && "object" == typeof t[t.length - 1]) for (var d in null != (s = p.shallowCopy(t.pop())).blockTag && (o = s.blockTag), delete s.blockTag, s) {
              if (!_[d]) throw new Error("unknown transaction override " + d);
            }
            if (t.length != r.inputs.length) throw new Error("incorrect number of arguments");
            return ["data", "to"].forEach(function (e) {
              null != s[e] && c.throwError("cannot override " + e, c.UNSUPPORTED_OPERATION, {
                operation: e
              });
            }), s.to = e._deployed(o).then(function () {
              return e.addressPromise;
            }), function e(t, a, r) {
              if (Array.isArray(r)) {
                var n = [];
                return r.forEach(function (r, s) {
                  var o;
                  o = Array.isArray(a) ? a[s] : a[r.name], n.push(e(t, o, r));
                }), Promise.all(n);
              }

              if ("address" === r.type) return t.resolveName(a);
              if ("tuple" === r.type) return e(t, a, r.components);
              var s = r.type.match(/(.*)(\[[0-9]*\]$)/);

              if (s) {
                if (!Array.isArray(a)) throw new Error("invalid value for array");
                var o = [],
                    i = {
                  components: r.components,
                  type: s[1]
                };
                return a.forEach(function (a) {
                  o.push(e(t, a, i));
                }), Promise.all(o);
              }

              return Promise.resolve(a);
            }(e.provider, t, r.inputs).then(function (t) {
              if (s.data = r.encode(t), "call" === r.type) return a ? Promise.resolve(i.Zero) : (e.provider || c.throwError("call (constant functions) require a provider or a signer with a provider", c.UNSUPPORTED_OPERATION, {
                operation: "call"
              }), ["gasLimit", "gasPrice", "value"].forEach(function (e) {
                if (null != s[e]) throw new Error("call cannot override " + e);
              }), null == s.from && e.signer && (s.from = e.signer.getAddress()), e.provider.call(s, o).then(function (a) {
                if (l.hexDataLength(a) % 32 == 4 && "0x08c379a0" === l.hexDataSlice(a, 0, 4)) {
                  var n = u.defaultAbiCoder.decode(["string"], l.hexDataSlice(a, 4));
                  c.throwError("call revert exception", c.CALL_EXCEPTION, {
                    address: e.address,
                    args: t,
                    method: r.signature,
                    errorSignature: "Error(string)",
                    errorArgs: [n],
                    reason: n,
                    transaction: s
                  });
                }

                try {
                  var o = r.decode(a);
                  return 1 === r.outputs.length && (o = o[0]), o;
                } catch (n) {
                  throw "0x" === a && 0 < r.outputs.length && c.throwError("call exception", c.CALL_EXCEPTION, {
                    address: e.address,
                    method: r.signature,
                    args: t
                  }), n;
                }
              }));
              if ("transaction" === r.type) return a ? (e.provider || c.throwError("estimate gas require a provider or a signer with a provider", c.UNSUPPORTED_OPERATION, {
                operation: "estimateGas"
              }), null == s.from && e.signer && (s.from = e.signer.getAddress()), e.provider.estimateGas(s)) : (null == s.gasLimit && null != r.gas && (s.gasLimit = f.bigNumberify(r.gas).add(21e3)), e.signer || c.throwError("sending a transaction require a signer", c.UNSUPPORTED_OPERATION, {
                operation: "sendTransaction"
              }), null != s.from && c.throwError("cannot override from in a transaction", c.UNSUPPORTED_OPERATION, {
                operation: "sendTransaction"
              }), e.signer.sendTransaction(s).then(function (t) {
                var a = t.wait.bind(t);
                return t.wait = function (t) {
                  return a(t).then(function (t) {
                    return t.events = t.logs.map(function (a) {
                      var r = p.deepCopy(a),
                          n = e.interface.parseLog(a);
                      return n && (r.args = n.values, r.decode = n.decode, r.event = n.name, r.eventSignature = n.signature), r.removeListener = function () {
                        return e.provider;
                      }, r.getBlock = function () {
                        return e.provider.getBlock(t.blockHash);
                      }, r.getTransaction = function () {
                        return e.provider.getTransaction(t.transactionHash);
                      }, r.getTransactionReceipt = function () {
                        return Promise.resolve(t);
                      }, r;
                    }), t;
                  });
                }, t;
              }));
              throw new Error("invalid type - " + r.type);
            });
          };
        }

        function A(e) {
          return !e.address || null != e.topics && 0 !== e.topics.length ? (e.address || "*") + "@" + (e.topics ? e.topics.join(":") : "") : "*";
        }

        var w = (T.prototype.deployed = function () {
          return this._deployed();
        }, T.prototype._deployed = function (e) {
          var t = this;
          return this._deployedPromise || (this.deployTransaction ? this._deployedPromise = this.deployTransaction.wait().then(function () {
            return t;
          }) : this._deployedPromise = this.provider.getCode(this.address, e).then(function (e) {
            return "0x" === e && c.throwError("contract not deployed", c.UNSUPPORTED_OPERATION, {
              contractAddress: t.address,
              operation: "getDeployed"
            }), t;
          })), this._deployedPromise;
        }, T.prototype.fallback = function (e) {
          var t = this;
          this.signer || c.throwError("sending a transaction require a signer", c.UNSUPPORTED_OPERATION, {
            operation: "sendTransaction(fallback)"
          });
          var a = p.shallowCopy(e || {});
          return ["from", "to"].forEach(function (e) {
            null != a[e] && c.throwError("cannot override " + e, c.UNSUPPORTED_OPERATION, {
              operation: e
            });
          }), a.to = this.addressPromise, this.deployed().then(function () {
            return t.signer.sendTransaction(a);
          });
        }, T.prototype.connect = function (e) {
          "string" == typeof e && (e = new y(e, this.provider));
          var t = new T(this.address, this.interface, e);
          return this.deployTransaction && p.defineReadOnly(t, "deployTransaction", this.deployTransaction), t;
        }, T.prototype.attach = function (e) {
          return new T(e, this.interface, this.signer || this.provider);
        }, T.isIndexed = function (e) {
          return h.Interface.isIndexed(e);
        }, T.prototype._getEventFilter = function (e) {
          var t = this;

          if ("string" == typeof e) {
            if ("*" === e) return {
              prepareEvent: function prepareEvent(e) {
                var a = t.interface.parseLog(e);
                return a && (e.args = a.values, e.decode = a.decode, e.event = a.name, e.eventSignature = a.signature), [e];
              },
              eventTag: "*",
              filter: {
                address: this.address
              }
            };
            -1 !== e.indexOf("(") && (e = u.formatSignature(u.parseSignature("event " + e)));
            var a = this.interface.events[e];
            a || c.throwError("unknown event - " + e, c.INVALID_ARGUMENT, {
              argumnet: "eventName",
              value: e
            });
            var r = {
              address: this.address,
              topics: [a.topic]
            };
            return {
              prepareEvent: function prepareEvent(e) {
                var t = a.decode(e.data, e.topics);
                e.args = t;
                var r = Array.prototype.slice.call(t);
                return r.push(e), r;
              },
              event: a,
              eventTag: A(r),
              filter: r
            };
          }

          var n = {
            address: this.address
          },
              s = null;
          if (e.topics && e.topics[0]) for (var o in n.topics = e.topics, this.interface.events) {
            if (-1 !== o.indexOf("(")) {
              var i = this.interface.events[o];

              if (i.topic === e.topics[0].toLowerCase()) {
                s = i;
                break;
              }
            }
          }
          return {
            prepareEvent: function prepareEvent(e) {
              if (!s) return [e];
              var t = s.decode(e.data, e.topics);
              e.args = t;
              var a = Array.prototype.slice.call(t);
              return a.push(e), a;
            },
            event: s,
            eventTag: A(n),
            filter: n
          };
        }, T.prototype._addEventListener = function (e, t, a) {
          var r = this;

          function n(a) {
            var n = p.deepCopy(a),
                s = e.prepareEvent(n);
            e.event && (n.decode = e.event.decode, n.event = e.event.name, n.eventSignature = e.event.signature), n.removeListener = function () {
              r.removeListener(e.filter, t);
            }, n.getBlock = function () {
              return r.provider.getBlock(a.blockHash);
            }, n.getTransaction = function () {
              return r.provider.getTransaction(a.transactionHash);
            }, n.getTransactionReceipt = function () {
              return r.provider.getTransactionReceipt(a.transactionHash);
            }, r.emit.apply(r, [e.filter].concat(s));
          }

          this.provider || c.throwError("events require a provider or a signer with a provider", c.UNSUPPORTED_OPERATION, {
            operation: "once"
          }), this.provider.on(e.filter, n), this._events.push({
            eventFilter: e,
            listener: t,
            wrappedListener: n,
            once: a
          });
        }, T.prototype.on = function (e, t) {
          return this._addEventListener(this._getEventFilter(e), t, !1), this;
        }, T.prototype.once = function (e, t) {
          return this._addEventListener(this._getEventFilter(e), t, !0), this;
        }, T.prototype.addListener = function (e, t) {
          return this.on(e, t);
        }, T.prototype.emit = function (e) {
          for (var t = this, a = [], r = 1; r < arguments.length; r++) {
            a[r - 1] = arguments[r];
          }

          if (!this.provider) return !1;

          var n = !1,
              s = this._getEventFilter(e);

          return this._events = this._events.filter(function (e) {
            return e.eventFilter.eventTag !== s.eventTag || (setTimeout(function () {
              e.listener.apply(t, a);
            }, 0), n = !0, !e.once);
          }), n;
        }, T.prototype.listenerCount = function (e) {
          if (!this.provider) return 0;

          var t = this._getEventFilter(e);

          return this._events.filter(function (e) {
            return e.eventFilter.eventTag === t.eventTag;
          }).length;
        }, T.prototype.listeners = function (e) {
          if (!this.provider) return [];

          var t = this._getEventFilter(e);

          return this._events.filter(function (e) {
            return e.eventFilter.eventTag === t.eventTag;
          }).map(function (e) {
            return e.listener;
          });
        }, T.prototype.removeAllListeners = function (e) {
          var t = this;
          if (!this.provider) return this;

          var a = this._getEventFilter(e);

          return this._events = this._events.filter(function (e) {
            return e.eventFilter.eventTag !== a.eventTag || (t.provider.removeListener(e.eventFilter.filter, e.wrappedListener), !1);
          }), this;
        }, T.prototype.removeListener = function (e, t) {
          var a = this;
          if (!this.provider) return this;

          var r = !1,
              n = this._getEventFilter(e);

          return this._events = this._events.filter(function (e) {
            return e.eventFilter.eventTag !== n.eventTag || e.listener !== t || (a.provider.removeListener(e.eventFilter.filter, e.wrappedListener), !!r || !(r = !0));
          }), this;
        }, T);

        function T(e, t, a) {
          var r = this;
          if (c.checkNew(this, T), h.Interface.isInterface(t) ? p.defineReadOnly(this, "interface", t) : p.defineReadOnly(this, "interface", new h.Interface(t)), m.Signer.isSigner(a) ? (p.defineReadOnly(this, "provider", a.provider), p.defineReadOnly(this, "signer", a)) : b.Provider.isProvider(a) ? (p.defineReadOnly(this, "provider", a), p.defineReadOnly(this, "signer", null)) : c.throwError("invalid signer or provider", c.INVALID_ARGUMENT, {
            arg: "signerOrProvider",
            value: a
          }), p.defineReadOnly(this, "estimate", {}), p.defineReadOnly(this, "functions", {}), p.defineReadOnly(this, "filters", {}), Object.keys(this.interface.events).forEach(function (e) {
            var t = r.interface.events[e];
            p.defineReadOnly(r.filters, e, function () {
              for (var e = [], a = 0; a < arguments.length; a++) {
                e[a] = arguments[a];
              }

              return {
                address: r.address,
                topics: t.encodeTopics(e)
              };
            });
          }), this._events = [], p.defineReadOnly(this, "address", e), this.provider) p.defineReadOnly(this, "addressPromise", this.provider.resolveName(e).then(function (e) {
            if (null == e) throw new Error("name not found");
            return e;
          }).catch(function (e) {
            throw e;
          }));else try {
            p.defineReadOnly(this, "addressPromise", Promise.resolve(d.getAddress(e)));
          } catch (t) {
            c.throwError("provider is required to use non-address contract address", c.INVALID_ARGUMENT, {
              argument: "addressOrName",
              value: e
            });
          }
          Object.keys(this.interface.functions).forEach(function (e) {
            var t = g(r, e, !1);
            null == r[e] ? p.defineReadOnly(r, e, t) : c.warn("WARNING: Multiple definitions for " + e), null == r.functions[e] && (p.defineReadOnly(r.functions, e, t), p.defineReadOnly(r.estimate, e, g(r, e, !0)));
          });
        }

        a.Contract = w;
        var x = (D.prototype.getDeployTransaction = function () {
          for (var e = [], t = 0; t < arguments.length; t++) {
            e[t] = arguments[t];
          }

          var a = {};
          if (e.length === this.interface.deployFunction.inputs.length + 1) for (var r in a = p.shallowCopy(e.pop())) {
            if (!_[r]) throw new Error("unknown transaction override " + r);
          }
          return ["data", "from", "to"].forEach(function (e) {
            null != a[e] && c.throwError("cannot override " + e, c.UNSUPPORTED_OPERATION, {
              operation: e
            });
          }), c.checkArgumentCount(e.length, this.interface.deployFunction.inputs.length, " in Contract constructor"), a.data = this.interface.deployFunction.encode(this.bytecode, e), a;
        }, D.prototype.deploy = function () {
          for (var e = this, t = [], a = 0; a < arguments.length; a++) {
            t[a] = arguments[a];
          }

          var r = this.getDeployTransaction.apply(this, t);
          return this.signer.sendTransaction(r).then(function (t) {
            var a = new w(d.getContractAddress(t), e.interface, e.signer);
            return p.defineReadOnly(a, "deployTransaction", t), a;
          });
        }, D.prototype.attach = function (e) {
          return new w(e, this.interface, this.signer);
        }, D.prototype.connect = function (e) {
          return new D(this.interface, this.bytecode, e);
        }, D.fromSolidity = function (e, t) {
          null == e && c.throwError("missing compiler output", c.MISSING_ARGUMENT, {
            argument: "compilerOutput"
          }), "string" == typeof e && (e = JSON.parse(e));
          var a = e.abi,
              r = null;
          return e.bytecode ? r = e.bytecode : e.evm && e.evm.bytecode && (r = e.evm.bytecode), new D(a, r, t);
        }, D);

        function D(e, t, a) {
          var r = null;
          "string" == typeof t ? r = t : l.isArrayish(t) ? r = l.hexlify(t) : "string" == typeof t.object ? r = t.object : c.throwError("bytecode must be a valid hex string", c.INVALID_ARGUMENT, {
            arg: "bytecode",
            value: t
          }), "0x" !== r.substring(0, 2) && (r = "0x" + r), l.isHexString(r) || c.throwError("bytecode must be a valid hex string", c.INVALID_ARGUMENT, {
            arg: "bytecode",
            value: t
          }), r.length % 2 != 0 && c.throwError("bytecode must be valid data (even length)", c.INVALID_ARGUMENT, {
            arg: "bytecode",
            value: t
          }), p.defineReadOnly(this, "bytecode", r), h.Interface.isInterface(e) ? p.defineReadOnly(this, "interface", e) : p.defineReadOnly(this, "interface", new h.Interface(e)), a && !m.Signer.isSigner(a) && c.throwError("invalid signer", c.INVALID_ARGUMENT, {
            arg: "signer",
            value: null
          }), p.defineReadOnly(this, "signer", a || null);
        }

        a.ContractFactory = x;
      }, {
        "./abstract-signer": 2,
        "./constants": 3,
        "./errors": 5,
        "./providers/abstract-provider": 49,
        "./utils/abi-coder": 58,
        "./utils/address": 59,
        "./utils/bignumber": 62,
        "./utils/bytes": 63,
        "./utils/interface": 68,
        "./utils/properties": 73
      }],
      5: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var r = e("./_version");
        a.UNKNOWN_ERROR = "UNKNOWN_ERROR", a.NOT_IMPLEMENTED = "NOT_IMPLEMENTED", a.MISSING_NEW = "MISSING_NEW", a.CALL_EXCEPTION = "CALL_EXCEPTION", a.INVALID_ARGUMENT = "INVALID_ARGUMENT", a.MISSING_ARGUMENT = "MISSING_ARGUMENT", a.UNEXPECTED_ARGUMENT = "UNEXPECTED_ARGUMENT", a.NUMERIC_FAULT = "NUMERIC_FAULT", a.INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS", a.NONCE_EXPIRED = "NONCE_EXPIRED", a.REPLACEMENT_UNDERPRICED = "REPLACEMENT_UNDERPRICED";
        var n = !(a.UNSUPPORTED_OPERATION = "UNSUPPORTED_OPERATION"),
            s = !1;

        function o(e, t, n) {
          if (s) throw new Error("unknown error");
          t = t || a.UNKNOWN_ERROR, n = n || {};
          var o = [];
          Object.keys(n).forEach(function (e) {
            try {
              o.push(e + "=" + JSON.stringify(n[e]));
            } catch (t) {
              o.push(e + "=" + JSON.stringify(n[e].toString()));
            }
          }), o.push("version=" + r.version);
          var i = e;
          o.length && (e += " (" + o.join(", ") + ")");
          var c = new Error(e);
          throw c.reason = i, c.code = t, Object.keys(n).forEach(function (e) {
            c[e] = n[e];
          }), c;
        }

        a.throwError = o, a.checkNew = function (e, t) {
          e instanceof t || o("missing new", a.MISSING_NEW, {
            name: t.name
          });
        }, a.checkArgumentCount = function (e, t, r) {
          r = r || "", e < t && o("missing argument" + r, a.MISSING_ARGUMENT, {
            count: e,
            expectedCount: t
          }), t < e && o("too many arguments" + r, a.UNEXPECTED_ARGUMENT, {
            count: e,
            expectedCount: t
          });
        }, a.setCensorship = function (e, t) {
          n && o("error censorship permanent", a.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
          }), s = !!e, n = !!t;
        }, a.checkNormalize = function () {
          try {
            if (["NFD", "NFC", "NFKD", "NFKC"].forEach(function (e) {
              try {
                "test".normalize(e);
              } catch (t) {
                throw new Error("missing " + e);
              }
            }), String.fromCharCode(233).normalize("NFD") !== String.fromCharCode(101, 769)) throw new Error("broken implementation");
          } catch (e) {
            o("platform missing String.prototype.normalize", a.UNSUPPORTED_OPERATION, {
              operation: "String.prototype.normalize",
              form: e.message
            });
          }
        };
        var i = {
          debug: 1,
          default: 2,
          info: 2,
          warn: 3,
          error: 4,
          off: 5
        },
            c = i.default;

        function u(e, t) {
          c > i[e] || console.log.apply(console, t);
        }

        function d() {
          for (var e = [], t = 0; t < arguments.length; t++) {
            e[t] = arguments[t];
          }

          u("warn", e);
        }

        a.setLogLevel = function (e) {
          var t = i[e];
          null != t ? c = t : d("invliad log level - " + e);
        }, a.warn = d, a.info = function () {
          for (var e = [], t = 0; t < arguments.length; t++) {
            e[t] = arguments[t];
          }

          u("info", e);
        };
      }, {
        "./_version": 1
      }],
      6: [function (e, t, a) {
        "use strict";

        var r = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var n = e("./contract");
        a.Contract = n.Contract, a.ContractFactory = n.ContractFactory, a.VoidSigner = n.VoidSigner;
        var s = e("./abstract-signer");
        a.Signer = s.Signer;
        var o = e("./wallet");
        a.Wallet = o.Wallet;
        var i = r(e("./constants"));
        a.constants = i;
        var c = r(e("./errors"));
        a.errors = c;
        var u = r(e("./providers"));
        a.providers = u;
        var d = r(e("./utils"));
        a.utils = d;
        var f = r(e("./wordlists"));
        a.wordlists = f;
        var l = e("./utils/shims");
        a.platform = l.platform;
        var h = e("./_version");
        a.version = h.version, a.getDefaultProvider = function (e) {
          null == e && (e = "homestead");
          var t = d.getNetwork(e);
          return t && t._defaultProvider || c.throwError("unsupported getDefaultProvider network", c.UNSUPPORTED_OPERATION, {
            operation: "getDefaultProvider",
            network: e
          }), t._defaultProvider(u);
        };
      }, {
        "./_version": 1,
        "./abstract-signer": 2,
        "./constants": 3,
        "./contract": 4,
        "./errors": 5,
        "./providers": 53,
        "./utils": 67,
        "./utils/shims": 79,
        "./wallet": 87,
        "./wordlists": 88
      }],
      7: [function (e, t, a) {
        "use strict";

        var r = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var n = r(e("./ethers"));
        a.ethers = n, function (e) {
          for (var t in e) {
            a.hasOwnProperty(t) || (a[t] = e[t]);
          }
        }(e("./ethers"));
      }, {
        "./ethers": 6
      }],
      8: [function (e, t, a) {
        "use strict";

        !function (e) {
          function r(e) {
            return parseInt(e) === e;
          }

          function n(e) {
            if (!r(e.length)) return !1;

            for (var t = 0; t < e.length; t++) {
              if (!r(e[t]) || e[t] < 0 || 255 < e[t]) return !1;
            }

            return !0;
          }

          function s(e, t) {
            if (e.buffer && ArrayBuffer.isView(e) && "Uint8Array" === e.name) return t && (e = e.slice ? e.slice() : Array.prototype.slice.call(e)), e;

            if (Array.isArray(e)) {
              if (!n(e)) throw new Error("Array contains invalid value: " + e);
              return new Uint8Array(e);
            }

            if (r(e.length) && n(e)) return new Uint8Array(e);
            throw new Error("unsupported array-like object");
          }

          function o(e) {
            return new Uint8Array(e);
          }

          function i(e, t, a, r, n) {
            null == r && null == n || (e = e.slice ? e.slice(r, n) : Array.prototype.slice.call(e, r, n)), t.set(e, a);
          }

          var c,
              u = {
            toBytes: function toBytes(e) {
              var t = [],
                  a = 0;

              for (e = encodeURI(e); a < e.length;) {
                var r = e.charCodeAt(a++);
                37 === r ? (t.push(parseInt(e.substr(a, 2), 16)), a += 2) : t.push(r);
              }

              return s(t);
            },
            fromBytes: function fromBytes(e) {
              for (var t = [], a = 0; a < e.length;) {
                var r = e[a];
                r < 128 ? (t.push(String.fromCharCode(r)), a++) : 191 < r && r < 224 ? (t.push(String.fromCharCode((31 & r) << 6 | 63 & e[a + 1])), a += 2) : (t.push(String.fromCharCode((15 & r) << 12 | (63 & e[a + 1]) << 6 | 63 & e[a + 2])), a += 3);
              }

              return t.join("");
            }
          },
              d = (c = "0123456789abcdef", {
            toBytes: function toBytes(e) {
              for (var t = [], a = 0; a < e.length; a += 2) {
                t.push(parseInt(e.substr(a, 2), 16));
              }

              return t;
            },
            fromBytes: function fromBytes(e) {
              for (var t = [], a = 0; a < e.length; a++) {
                var r = e[a];
                t.push(c[(240 & r) >> 4] + c[15 & r]);
              }

              return t.join("");
            }
          }),
              f = {
            16: 10,
            24: 12,
            32: 14
          },
              l = [1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145],
              h = [99, 124, 119, 123, 242, 107, 111, 197, 48, 1, 103, 43, 254, 215, 171, 118, 202, 130, 201, 125, 250, 89, 71, 240, 173, 212, 162, 175, 156, 164, 114, 192, 183, 253, 147, 38, 54, 63, 247, 204, 52, 165, 229, 241, 113, 216, 49, 21, 4, 199, 35, 195, 24, 150, 5, 154, 7, 18, 128, 226, 235, 39, 178, 117, 9, 131, 44, 26, 27, 110, 90, 160, 82, 59, 214, 179, 41, 227, 47, 132, 83, 209, 0, 237, 32, 252, 177, 91, 106, 203, 190, 57, 74, 76, 88, 207, 208, 239, 170, 251, 67, 77, 51, 133, 69, 249, 2, 127, 80, 60, 159, 168, 81, 163, 64, 143, 146, 157, 56, 245, 188, 182, 218, 33, 16, 255, 243, 210, 205, 12, 19, 236, 95, 151, 68, 23, 196, 167, 126, 61, 100, 93, 25, 115, 96, 129, 79, 220, 34, 42, 144, 136, 70, 238, 184, 20, 222, 94, 11, 219, 224, 50, 58, 10, 73, 6, 36, 92, 194, 211, 172, 98, 145, 149, 228, 121, 231, 200, 55, 109, 141, 213, 78, 169, 108, 86, 244, 234, 101, 122, 174, 8, 186, 120, 37, 46, 28, 166, 180, 198, 232, 221, 116, 31, 75, 189, 139, 138, 112, 62, 181, 102, 72, 3, 246, 14, 97, 53, 87, 185, 134, 193, 29, 158, 225, 248, 152, 17, 105, 217, 142, 148, 155, 30, 135, 233, 206, 85, 40, 223, 140, 161, 137, 13, 191, 230, 66, 104, 65, 153, 45, 15, 176, 84, 187, 22],
              p = [82, 9, 106, 213, 48, 54, 165, 56, 191, 64, 163, 158, 129, 243, 215, 251, 124, 227, 57, 130, 155, 47, 255, 135, 52, 142, 67, 68, 196, 222, 233, 203, 84, 123, 148, 50, 166, 194, 35, 61, 238, 76, 149, 11, 66, 250, 195, 78, 8, 46, 161, 102, 40, 217, 36, 178, 118, 91, 162, 73, 109, 139, 209, 37, 114, 248, 246, 100, 134, 104, 152, 22, 212, 164, 92, 204, 93, 101, 182, 146, 108, 112, 72, 80, 253, 237, 185, 218, 94, 21, 70, 87, 167, 141, 157, 132, 144, 216, 171, 0, 140, 188, 211, 10, 247, 228, 88, 5, 184, 179, 69, 6, 208, 44, 30, 143, 202, 63, 15, 2, 193, 175, 189, 3, 1, 19, 138, 107, 58, 145, 17, 65, 79, 103, 220, 234, 151, 242, 207, 206, 240, 180, 230, 115, 150, 172, 116, 34, 231, 173, 53, 133, 226, 249, 55, 232, 28, 117, 223, 110, 71, 241, 26, 113, 29, 41, 197, 137, 111, 183, 98, 14, 170, 24, 190, 27, 252, 86, 62, 75, 198, 210, 121, 32, 154, 219, 192, 254, 120, 205, 90, 244, 31, 221, 168, 51, 136, 7, 199, 49, 177, 18, 16, 89, 39, 128, 236, 95, 96, 81, 127, 169, 25, 181, 74, 13, 45, 229, 122, 159, 147, 201, 156, 239, 160, 224, 59, 77, 174, 42, 245, 176, 200, 235, 187, 60, 131, 83, 153, 97, 23, 43, 4, 126, 186, 119, 214, 38, 225, 105, 20, 99, 85, 33, 12, 125],
              b = [3328402341, 4168907908, 4000806809, 4135287693, 4294111757, 3597364157, 3731845041, 2445657428, 1613770832, 33620227, 3462883241, 1445669757, 3892248089, 3050821474, 1303096294, 3967186586, 2412431941, 528646813, 2311702848, 4202528135, 4026202645, 2992200171, 2387036105, 4226871307, 1101901292, 3017069671, 1604494077, 1169141738, 597466303, 1403299063, 3832705686, 2613100635, 1974974402, 3791519004, 1033081774, 1277568618, 1815492186, 2118074177, 4126668546, 2211236943, 1748251740, 1369810420, 3521504564, 4193382664, 3799085459, 2883115123, 1647391059, 706024767, 134480908, 2512897874, 1176707941, 2646852446, 806885416, 932615841, 168101135, 798661301, 235341577, 605164086, 461406363, 3756188221, 3454790438, 1311188841, 2142417613, 3933566367, 302582043, 495158174, 1479289972, 874125870, 907746093, 3698224818, 3025820398, 1537253627, 2756858614, 1983593293, 3084310113, 2108928974, 1378429307, 3722699582, 1580150641, 327451799, 2790478837, 3117535592, 0, 3253595436, 1075847264, 3825007647, 2041688520, 3059440621, 3563743934, 2378943302, 1740553945, 1916352843, 2487896798, 2555137236, 2958579944, 2244988746, 3151024235, 3320835882, 1336584933, 3992714006, 2252555205, 2588757463, 1714631509, 293963156, 2319795663, 3925473552, 67240454, 4269768577, 2689618160, 2017213508, 631218106, 1269344483, 2723238387, 1571005438, 2151694528, 93294474, 1066570413, 563977660, 1882732616, 4059428100, 1673313503, 2008463041, 2950355573, 1109467491, 537923632, 3858759450, 4260623118, 3218264685, 2177748300, 403442708, 638784309, 3287084079, 3193921505, 899127202, 2286175436, 773265209, 2479146071, 1437050866, 4236148354, 2050833735, 3362022572, 3126681063, 840505643, 3866325909, 3227541664, 427917720, 2655997905, 2749160575, 1143087718, 1412049534, 999329963, 193497219, 2353415882, 3354324521, 1807268051, 672404540, 2816401017, 3160301282, 369822493, 2916866934, 3688947771, 1681011286, 1949973070, 336202270, 2454276571, 201721354, 1210328172, 3093060836, 2680341085, 3184776046, 1135389935, 3294782118, 965841320, 831886756, 3554993207, 4068047243, 3588745010, 2345191491, 1849112409, 3664604599, 26054028, 2983581028, 2622377682, 1235855840, 3630984372, 2891339514, 4092916743, 3488279077, 3395642799, 4101667470, 1202630377, 268961816, 1874508501, 4034427016, 1243948399, 1546530418, 941366308, 1470539505, 1941222599, 2546386513, 3421038627, 2715671932, 3899946140, 1042226977, 2521517021, 1639824860, 227249030, 260737669, 3765465232, 2084453954, 1907733956, 3429263018, 2420656344, 100860677, 4160157185, 470683154, 3261161891, 1781871967, 2924959737, 1773779408, 394692241, 2579611992, 974986535, 664706745, 3655459128, 3958962195, 731420851, 571543859, 3530123707, 2849626480, 126783113, 865375399, 765172662, 1008606754, 361203602, 3387549984, 2278477385, 2857719295, 1344809080, 2782912378, 59542671, 1503764984, 160008576, 437062935, 1707065306, 3622233649, 2218934982, 3496503480, 2185314755, 697932208, 1512910199, 504303377, 2075177163, 2824099068, 1841019862, 739644986],
              m = [2781242211, 2230877308, 2582542199, 2381740923, 234877682, 3184946027, 2984144751, 1418839493, 1348481072, 50462977, 2848876391, 2102799147, 434634494, 1656084439, 3863849899, 2599188086, 1167051466, 2636087938, 1082771913, 2281340285, 368048890, 3954334041, 3381544775, 201060592, 3963727277, 1739838676, 4250903202, 3930435503, 3206782108, 4149453988, 2531553906, 1536934080, 3262494647, 484572669, 2923271059, 1783375398, 1517041206, 1098792767, 49674231, 1334037708, 1550332980, 4098991525, 886171109, 150598129, 2481090929, 1940642008, 1398944049, 1059722517, 201851908, 1385547719, 1699095331, 1587397571, 674240536, 2704774806, 252314885, 3039795866, 151914247, 908333586, 2602270848, 1038082786, 651029483, 1766729511, 3447698098, 2682942837, 454166793, 2652734339, 1951935532, 775166490, 758520603, 3000790638, 4004797018, 4217086112, 4137964114, 1299594043, 1639438038, 3464344499, 2068982057, 1054729187, 1901997871, 2534638724, 4121318227, 1757008337, 0, 750906861, 1614815264, 535035132, 3363418545, 3988151131, 3201591914, 1183697867, 3647454910, 1265776953, 3734260298, 3566750796, 3903871064, 1250283471, 1807470800, 717615087, 3847203498, 384695291, 3313910595, 3617213773, 1432761139, 2484176261, 3481945413, 283769337, 100925954, 2180939647, 4037038160, 1148730428, 3123027871, 3813386408, 4087501137, 4267549603, 3229630528, 2315620239, 2906624658, 3156319645, 1215313976, 82966005, 3747855548, 3245848246, 1974459098, 1665278241, 807407632, 451280895, 251524083, 1841287890, 1283575245, 337120268, 891687699, 801369324, 3787349855, 2721421207, 3431482436, 959321879, 1469301956, 4065699751, 2197585534, 1199193405, 2898814052, 3887750493, 724703513, 2514908019, 2696962144, 2551808385, 3516813135, 2141445340, 1715741218, 2119445034, 2872807568, 2198571144, 3398190662, 700968686, 3547052216, 1009259540, 2041044702, 3803995742, 487983883, 1991105499, 1004265696, 1449407026, 1316239930, 504629770, 3683797321, 168560134, 1816667172, 3837287516, 1570751170, 1857934291, 4014189740, 2797888098, 2822345105, 2754712981, 936633572, 2347923833, 852879335, 1133234376, 1500395319, 3084545389, 2348912013, 1689376213, 3533459022, 3762923945, 3034082412, 4205598294, 133428468, 634383082, 2949277029, 2398386810, 3913789102, 403703816, 3580869306, 2297460856, 1867130149, 1918643758, 607656988, 4049053350, 3346248884, 1368901318, 600565992, 2090982877, 2632479860, 557719327, 3717614411, 3697393085, 2249034635, 2232388234, 2430627952, 1115438654, 3295786421, 2865522278, 3633334344, 84280067, 33027830, 303828494, 2747425121, 1600795957, 4188952407, 3496589753, 2434238086, 1486471617, 658119965, 3106381470, 953803233, 334231800, 3005978776, 857870609, 3151128937, 1890179545, 2298973838, 2805175444, 3056442267, 574365214, 2450884487, 550103529, 1233637070, 4289353045, 2018519080, 2057691103, 2399374476, 4166623649, 2148108681, 387583245, 3664101311, 836232934, 3330556482, 3100665960, 3280093505, 2955516313, 2002398509, 287182607, 3413881008, 4238890068, 3597515707, 975967766],
              y = [1671808611, 2089089148, 2006576759, 2072901243, 4061003762, 1807603307, 1873927791, 3310653893, 810573872, 16974337, 1739181671, 729634347, 4263110654, 3613570519, 2883997099, 1989864566, 3393556426, 2191335298, 3376449993, 2106063485, 4195741690, 1508618841, 1204391495, 4027317232, 2917941677, 3563566036, 2734514082, 2951366063, 2629772188, 2767672228, 1922491506, 3227229120, 3082974647, 4246528509, 2477669779, 644500518, 911895606, 1061256767, 4144166391, 3427763148, 878471220, 2784252325, 3845444069, 4043897329, 1905517169, 3631459288, 827548209, 356461077, 67897348, 3344078279, 593839651, 3277757891, 405286936, 2527147926, 84871685, 2595565466, 118033927, 305538066, 2157648768, 3795705826, 3945188843, 661212711, 2999812018, 1973414517, 152769033, 2208177539, 745822252, 439235610, 455947803, 1857215598, 1525593178, 2700827552, 1391895634, 994932283, 3596728278, 3016654259, 695947817, 3812548067, 795958831, 2224493444, 1408607827, 3513301457, 0, 3979133421, 543178784, 4229948412, 2982705585, 1542305371, 1790891114, 3410398667, 3201918910, 961245753, 1256100938, 1289001036, 1491644504, 3477767631, 3496721360, 4012557807, 2867154858, 4212583931, 1137018435, 1305975373, 861234739, 2241073541, 1171229253, 4178635257, 33948674, 2139225727, 1357946960, 1011120188, 2679776671, 2833468328, 1374921297, 2751356323, 1086357568, 2408187279, 2460827538, 2646352285, 944271416, 4110742005, 3168756668, 3066132406, 3665145818, 560153121, 271589392, 4279952895, 4077846003, 3530407890, 3444343245, 202643468, 322250259, 3962553324, 1608629855, 2543990167, 1154254916, 389623319, 3294073796, 2817676711, 2122513534, 1028094525, 1689045092, 1575467613, 422261273, 1939203699, 1621147744, 2174228865, 1339137615, 3699352540, 577127458, 712922154, 2427141008, 2290289544, 1187679302, 3995715566, 3100863416, 339486740, 3732514782, 1591917662, 186455563, 3681988059, 3762019296, 844522546, 978220090, 169743370, 1239126601, 101321734, 611076132, 1558493276, 3260915650, 3547250131, 2901361580, 1655096418, 2443721105, 2510565781, 3828863972, 2039214713, 3878868455, 3359869896, 928607799, 1840765549, 2374762893, 3580146133, 1322425422, 2850048425, 1823791212, 1459268694, 4094161908, 3928346602, 1706019429, 2056189050, 2934523822, 135794696, 3134549946, 2022240376, 628050469, 779246638, 472135708, 2800834470, 3032970164, 3327236038, 3894660072, 3715932637, 1956440180, 522272287, 1272813131, 3185336765, 2340818315, 2323976074, 1888542832, 1044544574, 3049550261, 1722469478, 1222152264, 50660867, 4127324150, 236067854, 1638122081, 895445557, 1475980887, 3117443513, 2257655686, 3243809217, 489110045, 2662934430, 3778599393, 4162055160, 2561878936, 288563729, 1773916777, 3648039385, 2391345038, 2493985684, 2612407707, 505560094, 2274497927, 3911240169, 3460925390, 1442818645, 678973480, 3749357023, 2358182796, 2717407649, 2306869641, 219617805, 3218761151, 3862026214, 1120306242, 1756942440, 1103331905, 2578459033, 762796589, 252780047, 2966125488, 1425844308, 3151392187, 372911126],
              v = [1667474886, 2088535288, 2004326894, 2071694838, 4075949567, 1802223062, 1869591006, 3318043793, 808472672, 16843522, 1734846926, 724270422, 4278065639, 3621216949, 2880169549, 1987484396, 3402253711, 2189597983, 3385409673, 2105378810, 4210693615, 1499065266, 1195886990, 4042263547, 2913856577, 3570689971, 2728590687, 2947541573, 2627518243, 2762274643, 1920112356, 3233831835, 3082273397, 4261223649, 2475929149, 640051788, 909531756, 1061110142, 4160160501, 3435941763, 875846760, 2779116625, 3857003729, 4059105529, 1903268834, 3638064043, 825316194, 353713962, 67374088, 3351728789, 589522246, 3284360861, 404236336, 2526454071, 84217610, 2593830191, 117901582, 303183396, 2155911963, 3806477791, 3958056653, 656894286, 2998062463, 1970642922, 151591698, 2206440989, 741110872, 437923380, 454765878, 1852748508, 1515908788, 2694904667, 1381168804, 993742198, 3604373943, 3014905469, 690584402, 3823320797, 791638366, 2223281939, 1398011302, 3520161977, 0, 3991743681, 538992704, 4244381667, 2981218425, 1532751286, 1785380564, 3419096717, 3200178535, 960056178, 1246420628, 1280103576, 1482221744, 3486468741, 3503319995, 4025428677, 2863326543, 4227536621, 1128514950, 1296947098, 859002214, 2240123921, 1162203018, 4193849577, 33687044, 2139062782, 1347481760, 1010582648, 2678045221, 2829640523, 1364325282, 2745433693, 1077985408, 2408548869, 2459086143, 2644360225, 943212656, 4126475505, 3166494563, 3065430391, 3671750063, 555836226, 269496352, 4294908645, 4092792573, 3537006015, 3452783745, 202118168, 320025894, 3974901699, 1600119230, 2543297077, 1145359496, 387397934, 3301201811, 2812801621, 2122220284, 1027426170, 1684319432, 1566435258, 421079858, 1936954854, 1616945344, 2172753945, 1330631070, 3705438115, 572679748, 707427924, 2425400123, 2290647819, 1179044492, 4008585671, 3099120491, 336870440, 3739122087, 1583276732, 185277718, 3688593069, 3772791771, 842159716, 976899700, 168435220, 1229577106, 101059084, 606366792, 1549591736, 3267517855, 3553849021, 2897014595, 1650632388, 2442242105, 2509612081, 3840161747, 2038008818, 3890688725, 3368567691, 926374254, 1835907034, 2374863873, 3587531953, 1313788572, 2846482505, 1819063512, 1448540844, 4109633523, 3941213647, 1701162954, 2054852340, 2930698567, 134748176, 3132806511, 2021165296, 623210314, 774795868, 471606328, 2795958615, 3031746419, 3334885783, 3907527627, 3722280097, 1953799400, 522133822, 1263263126, 3183336545, 2341176845, 2324333839, 1886425312, 1044267644, 3048588401, 1718004428, 1212733584, 50529542, 4143317495, 235803164, 1633788866, 892690282, 1465383342, 3115962473, 2256965911, 3250673817, 488449850, 2661202215, 3789633753, 4177007595, 2560144171, 286339874, 1768537042, 3654906025, 2391705863, 2492770099, 2610673197, 505291324, 2273808917, 3924369609, 3469625735, 1431699370, 673740880, 3755965093, 2358021891, 2711746649, 2307489801, 218961690, 3217021541, 3873845719, 1111672452, 1751693520, 1094828930, 2576986153, 757954394, 252645662, 2964376443, 1414855848, 3149649517, 370555436],
              _ = [1374988112, 2118214995, 437757123, 975658646, 1001089995, 530400753, 2902087851, 1273168787, 540080725, 2910219766, 2295101073, 4110568485, 1340463100, 3307916247, 641025152, 3043140495, 3736164937, 632953703, 1172967064, 1576976609, 3274667266, 2169303058, 2370213795, 1809054150, 59727847, 361929877, 3211623147, 2505202138, 3569255213, 1484005843, 1239443753, 2395588676, 1975683434, 4102977912, 2572697195, 666464733, 3202437046, 4035489047, 3374361702, 2110667444, 1675577880, 3843699074, 2538681184, 1649639237, 2976151520, 3144396420, 4269907996, 4178062228, 1883793496, 2403728665, 2497604743, 1383856311, 2876494627, 1917518562, 3810496343, 1716890410, 3001755655, 800440835, 2261089178, 3543599269, 807962610, 599762354, 33778362, 3977675356, 2328828971, 2809771154, 4077384432, 1315562145, 1708848333, 101039829, 3509871135, 3299278474, 875451293, 2733856160, 92987698, 2767645557, 193195065, 1080094634, 1584504582, 3178106961, 1042385657, 2531067453, 3711829422, 1306967366, 2438237621, 1908694277, 67556463, 1615861247, 429456164, 3602770327, 2302690252, 1742315127, 2968011453, 126454664, 3877198648, 2043211483, 2709260871, 2084704233, 4169408201, 0, 159417987, 841739592, 504459436, 1817866830, 4245618683, 260388950, 1034867998, 908933415, 168810852, 1750902305, 2606453969, 607530554, 202008497, 2472011535, 3035535058, 463180190, 2160117071, 1641816226, 1517767529, 470948374, 3801332234, 3231722213, 1008918595, 303765277, 235474187, 4069246893, 766945465, 337553864, 1475418501, 2943682380, 4003061179, 2743034109, 4144047775, 1551037884, 1147550661, 1543208500, 2336434550, 3408119516, 3069049960, 3102011747, 3610369226, 1113818384, 328671808, 2227573024, 2236228733, 3535486456, 2935566865, 3341394285, 496906059, 3702665459, 226906860, 2009195472, 733156972, 2842737049, 294930682, 1206477858, 2835123396, 2700099354, 1451044056, 573804783, 2269728455, 3644379585, 2362090238, 2564033334, 2801107407, 2776292904, 3669462566, 1068351396, 742039012, 1350078989, 1784663195, 1417561698, 4136440770, 2430122216, 775550814, 2193862645, 2673705150, 1775276924, 1876241833, 3475313331, 3366754619, 270040487, 3902563182, 3678124923, 3441850377, 1851332852, 3969562369, 2203032232, 3868552805, 2868897406, 566021896, 4011190502, 3135740889, 1248802510, 3936291284, 699432150, 832877231, 708780849, 3332740144, 899835584, 1951317047, 4236429990, 3767586992, 866637845, 4043610186, 1106041591, 2144161806, 395441711, 1984812685, 1139781709, 3433712980, 3835036895, 2664543715, 1282050075, 3240894392, 1181045119, 2640243204, 25965917, 4203181171, 4211818798, 3009879386, 2463879762, 3910161971, 1842759443, 2597806476, 933301370, 1509430414, 3943906441, 3467192302, 3076639029, 3776767469, 2051518780, 2631065433, 1441952575, 404016761, 1942435775, 1408749034, 1610459739, 3745345300, 2017778566, 3400528769, 3110650942, 941896748, 3265478751, 371049330, 3168937228, 675039627, 4279080257, 967311729, 135050206, 3635733660, 1683407248, 2076935265, 3576870512, 1215061108, 3501741890],
              g = [1347548327, 1400783205, 3273267108, 2520393566, 3409685355, 4045380933, 2880240216, 2471224067, 1428173050, 4138563181, 2441661558, 636813900, 4233094615, 3620022987, 2149987652, 2411029155, 1239331162, 1730525723, 2554718734, 3781033664, 46346101, 310463728, 2743944855, 3328955385, 3875770207, 2501218972, 3955191162, 3667219033, 768917123, 3545789473, 692707433, 1150208456, 1786102409, 2029293177, 1805211710, 3710368113, 3065962831, 401639597, 1724457132, 3028143674, 409198410, 2196052529, 1620529459, 1164071807, 3769721975, 2226875310, 486441376, 2499348523, 1483753576, 428819965, 2274680428, 3075636216, 598438867, 3799141122, 1474502543, 711349675, 129166120, 53458370, 2592523643, 2782082824, 4063242375, 2988687269, 3120694122, 1559041666, 730517276, 2460449204, 4042459122, 2706270690, 3446004468, 3573941694, 533804130, 2328143614, 2637442643, 2695033685, 839224033, 1973745387, 957055980, 2856345839, 106852767, 1371368976, 4181598602, 1033297158, 2933734917, 1179510461, 3046200461, 91341917, 1862534868, 4284502037, 605657339, 2547432937, 3431546947, 2003294622, 3182487618, 2282195339, 954669403, 3682191598, 1201765386, 3917234703, 3388507166, 0, 2198438022, 1211247597, 2887651696, 1315723890, 4227665663, 1443857720, 507358933, 657861945, 1678381017, 560487590, 3516619604, 975451694, 2970356327, 261314535, 3535072918, 2652609425, 1333838021, 2724322336, 1767536459, 370938394, 182621114, 3854606378, 1128014560, 487725847, 185469197, 2918353863, 3106780840, 3356761769, 2237133081, 1286567175, 3152976349, 4255350624, 2683765030, 3160175349, 3309594171, 878443390, 1988838185, 3704300486, 1756818940, 1673061617, 3403100636, 272786309, 1075025698, 545572369, 2105887268, 4174560061, 296679730, 1841768865, 1260232239, 4091327024, 3960309330, 3497509347, 1814803222, 2578018489, 4195456072, 575138148, 3299409036, 446754879, 3629546796, 4011996048, 3347532110, 3252238545, 4270639778, 915985419, 3483825537, 681933534, 651868046, 2755636671, 3828103837, 223377554, 2607439820, 1649704518, 3270937875, 3901806776, 1580087799, 4118987695, 3198115200, 2087309459, 2842678573, 3016697106, 1003007129, 2802849917, 1860738147, 2077965243, 164439672, 4100872472, 32283319, 2827177882, 1709610350, 2125135846, 136428751, 3874428392, 3652904859, 3460984630, 3572145929, 3593056380, 2939266226, 824852259, 818324884, 3224740454, 930369212, 2801566410, 2967507152, 355706840, 1257309336, 4148292826, 243256656, 790073846, 2373340630, 1296297904, 1422699085, 3756299780, 3818836405, 457992840, 3099667487, 2135319889, 77422314, 1560382517, 1945798516, 788204353, 1521706781, 1385356242, 870912086, 325965383, 2358957921, 2050466060, 2388260884, 2313884476, 4006521127, 901210569, 3990953189, 1014646705, 1503449823, 1062597235, 2031621326, 3212035895, 3931371469, 1533017514, 350174575, 2256028891, 2177544179, 1052338372, 741876788, 1606591296, 1914052035, 213705253, 2334669897, 1107234197, 1899603969, 3725069491, 2631447780, 2422494913, 1635502980, 1893020342, 1950903388, 1120974935],
              A = [2807058932, 1699970625, 2764249623, 1586903591, 1808481195, 1173430173, 1487645946, 59984867, 4199882800, 1844882806, 1989249228, 1277555970, 3623636965, 3419915562, 1149249077, 2744104290, 1514790577, 459744698, 244860394, 3235995134, 1963115311, 4027744588, 2544078150, 4190530515, 1608975247, 2627016082, 2062270317, 1507497298, 2200818878, 567498868, 1764313568, 3359936201, 2305455554, 2037970062, 1047239e3, 1910319033, 1337376481, 2904027272, 2892417312, 984907214, 1243112415, 830661914, 861968209, 2135253587, 2011214180, 2927934315, 2686254721, 731183368, 1750626376, 4246310725, 1820824798, 4172763771, 3542330227, 48394827, 2404901663, 2871682645, 671593195, 3254988725, 2073724613, 145085239, 2280796200, 2779915199, 1790575107, 2187128086, 472615631, 3029510009, 4075877127, 3802222185, 4107101658, 3201631749, 1646252340, 4270507174, 1402811438, 1436590835, 3778151818, 3950355702, 3963161475, 4020912224, 2667994737, 273792366, 2331590177, 104699613, 95345982, 3175501286, 2377486676, 1560637892, 3564045318, 369057872, 4213447064, 3919042237, 1137477952, 2658625497, 1119727848, 2340947849, 1530455833, 4007360968, 172466556, 266959938, 516552836, 0, 2256734592, 3980931627, 1890328081, 1917742170, 4294704398, 945164165, 3575528878, 958871085, 3647212047, 2787207260, 1423022939, 775562294, 1739656202, 3876557655, 2530391278, 2443058075, 3310321856, 547512796, 1265195639, 437656594, 3121275539, 719700128, 3762502690, 387781147, 218828297, 3350065803, 2830708150, 2848461854, 428169201, 122466165, 3720081049, 1627235199, 648017665, 4122762354, 1002783846, 2117360635, 695634755, 3336358691, 4234721005, 4049844452, 3704280881, 2232435299, 574624663, 287343814, 612205898, 1039717051, 840019705, 2708326185, 793451934, 821288114, 1391201670, 3822090177, 376187827, 3113855344, 1224348052, 1679968233, 2361698556, 1058709744, 752375421, 2431590963, 1321699145, 3519142200, 2734591178, 188127444, 2177869557, 3727205754, 2384911031, 3215212461, 2648976442, 2450346104, 3432737375, 1180849278, 331544205, 3102249176, 4150144569, 2952102595, 2159976285, 2474404304, 766078933, 313773861, 2570832044, 2108100632, 1668212892, 3145456443, 2013908262, 418672217, 3070356634, 2594734927, 1852171925, 3867060991, 3473416636, 3907448597, 2614737639, 919489135, 164948639, 2094410160, 2997825956, 590424639, 2486224549, 1723872674, 3157750862, 3399941250, 3501252752, 3625268135, 2555048196, 3673637356, 1343127501, 4130281361, 3599595085, 2957853679, 1297403050, 81781910, 3051593425, 2283490410, 532201772, 1367295589, 3926170974, 895287692, 1953757831, 1093597963, 492483431, 3528626907, 1446242576, 1192455638, 1636604631, 209336225, 344873464, 1015671571, 669961897, 3375740769, 3857572124, 2973530695, 3747192018, 1933530610, 3464042516, 935293895, 3454686199, 2858115069, 1863638845, 3683022916, 4085369519, 3292445032, 875313188, 1080017571, 3279033885, 621591778, 1233856572, 2504130317, 24197544, 3017672716, 3835484340, 3247465558, 2220981195, 3060847922, 1551124588, 1463996600],
              w = [4104605777, 1097159550, 396673818, 660510266, 2875968315, 2638606623, 4200115116, 3808662347, 821712160, 1986918061, 3430322568, 38544885, 3856137295, 718002117, 893681702, 1654886325, 2975484382, 3122358053, 3926825029, 4274053469, 796197571, 1290801793, 1184342925, 3556361835, 2405426947, 2459735317, 1836772287, 1381620373, 3196267988, 1948373848, 3764988233, 3385345166, 3263785589, 2390325492, 1480485785, 3111247143, 3780097726, 2293045232, 548169417, 3459953789, 3746175075, 439452389, 1362321559, 1400849762, 1685577905, 1806599355, 2174754046, 137073913, 1214797936, 1174215055, 3731654548, 2079897426, 1943217067, 1258480242, 529487843, 1437280870, 3945269170, 3049390895, 3313212038, 923313619, 679998e3, 3215307299, 57326082, 377642221, 3474729866, 2041877159, 133361907, 1776460110, 3673476453, 96392454, 878845905, 2801699524, 777231668, 4082475170, 2330014213, 4142626212, 2213296395, 1626319424, 1906247262, 1846563261, 562755902, 3708173718, 1040559837, 3871163981, 1418573201, 3294430577, 114585348, 1343618912, 2566595609, 3186202582, 1078185097, 3651041127, 3896688048, 2307622919, 425408743, 3371096953, 2081048481, 1108339068, 2216610296, 0, 2156299017, 736970802, 292596766, 1517440620, 251657213, 2235061775, 2933202493, 758720310, 265905162, 1554391400, 1532285339, 908999204, 174567692, 1474760595, 4002861748, 2610011675, 3234156416, 3693126241, 2001430874, 303699484, 2478443234, 2687165888, 585122620, 454499602, 151849742, 2345119218, 3064510765, 514443284, 4044981591, 1963412655, 2581445614, 2137062819, 19308535, 1928707164, 1715193156, 4219352155, 1126790795, 600235211, 3992742070, 3841024952, 836553431, 1669664834, 2535604243, 3323011204, 1243905413, 3141400786, 4180808110, 698445255, 2653899549, 2989552604, 2253581325, 3252932727, 3004591147, 1891211689, 2487810577, 3915653703, 4237083816, 4030667424, 2100090966, 865136418, 1229899655, 953270745, 3399679628, 3557504664, 4118925222, 2061379749, 3079546586, 2915017791, 983426092, 2022837584, 1607244650, 2118541908, 2366882550, 3635996816, 972512814, 3283088770, 1568718495, 3499326569, 3576539503, 621982671, 2895723464, 410887952, 2623762152, 1002142683, 645401037, 1494807662, 2595684844, 1335535747, 2507040230, 4293295786, 3167684641, 367585007, 3885750714, 1865862730, 2668221674, 2960971305, 2763173681, 1059270954, 2777952454, 2724642869, 1320957812, 2194319100, 2429595872, 2815956275, 77089521, 3973773121, 3444575871, 2448830231, 1305906550, 4021308739, 2857194700, 2516901860, 3518358430, 1787304780, 740276417, 1699839814, 1592394909, 2352307457, 2272556026, 188821243, 1729977011, 3687994002, 274084841, 3594982253, 3613494426, 2701949495, 4162096729, 322734571, 2837966542, 1640576439, 484830689, 1202797690, 3537852828, 4067639125, 349075736, 3342319475, 4157467219, 4255800159, 1030690015, 1155237496, 2951971274, 1757691577, 607398968, 2738905026, 499347990, 3794078908, 1011452712, 227885567, 2818666809, 213114376, 3034881240, 1455525988, 3414450555, 850817237, 1817998408, 3092726480],
              T = [0, 235474187, 470948374, 303765277, 941896748, 908933415, 607530554, 708780849, 1883793496, 2118214995, 1817866830, 1649639237, 1215061108, 1181045119, 1417561698, 1517767529, 3767586992, 4003061179, 4236429990, 4069246893, 3635733660, 3602770327, 3299278474, 3400528769, 2430122216, 2664543715, 2362090238, 2193862645, 2835123396, 2801107407, 3035535058, 3135740889, 3678124923, 3576870512, 3341394285, 3374361702, 3810496343, 3977675356, 4279080257, 4043610186, 2876494627, 2776292904, 3076639029, 3110650942, 2472011535, 2640243204, 2403728665, 2169303058, 1001089995, 899835584, 666464733, 699432150, 59727847, 226906860, 530400753, 294930682, 1273168787, 1172967064, 1475418501, 1509430414, 1942435775, 2110667444, 1876241833, 1641816226, 2910219766, 2743034109, 2976151520, 3211623147, 2505202138, 2606453969, 2302690252, 2269728455, 3711829422, 3543599269, 3240894392, 3475313331, 3843699074, 3943906441, 4178062228, 4144047775, 1306967366, 1139781709, 1374988112, 1610459739, 1975683434, 2076935265, 1775276924, 1742315127, 1034867998, 866637845, 566021896, 800440835, 92987698, 193195065, 429456164, 395441711, 1984812685, 2017778566, 1784663195, 1683407248, 1315562145, 1080094634, 1383856311, 1551037884, 101039829, 135050206, 437757123, 337553864, 1042385657, 807962610, 573804783, 742039012, 2531067453, 2564033334, 2328828971, 2227573024, 2935566865, 2700099354, 3001755655, 3168937228, 3868552805, 3902563182, 4203181171, 4102977912, 3736164937, 3501741890, 3265478751, 3433712980, 1106041591, 1340463100, 1576976609, 1408749034, 2043211483, 2009195472, 1708848333, 1809054150, 832877231, 1068351396, 766945465, 599762354, 159417987, 126454664, 361929877, 463180190, 2709260871, 2943682380, 3178106961, 3009879386, 2572697195, 2538681184, 2236228733, 2336434550, 3509871135, 3745345300, 3441850377, 3274667266, 3910161971, 3877198648, 4110568485, 4211818798, 2597806476, 2497604743, 2261089178, 2295101073, 2733856160, 2902087851, 3202437046, 2968011453, 3936291284, 3835036895, 4136440770, 4169408201, 3535486456, 3702665459, 3467192302, 3231722213, 2051518780, 1951317047, 1716890410, 1750902305, 1113818384, 1282050075, 1584504582, 1350078989, 168810852, 67556463, 371049330, 404016761, 841739592, 1008918595, 775550814, 540080725, 3969562369, 3801332234, 4035489047, 4269907996, 3569255213, 3669462566, 3366754619, 3332740144, 2631065433, 2463879762, 2160117071, 2395588676, 2767645557, 2868897406, 3102011747, 3069049960, 202008497, 33778362, 270040487, 504459436, 875451293, 975658646, 675039627, 641025152, 2084704233, 1917518562, 1615861247, 1851332852, 1147550661, 1248802510, 1484005843, 1451044056, 933301370, 967311729, 733156972, 632953703, 260388950, 25965917, 328671808, 496906059, 1206477858, 1239443753, 1543208500, 1441952575, 2144161806, 1908694277, 1675577880, 1842759443, 3610369226, 3644379585, 3408119516, 3307916247, 4011190502, 3776767469, 4077384432, 4245618683, 2809771154, 2842737049, 3144396420, 3043140495, 2673705150, 2438237621, 2203032232, 2370213795],
              x = [0, 185469197, 370938394, 487725847, 741876788, 657861945, 975451694, 824852259, 1483753576, 1400783205, 1315723890, 1164071807, 1950903388, 2135319889, 1649704518, 1767536459, 2967507152, 3152976349, 2801566410, 2918353863, 2631447780, 2547432937, 2328143614, 2177544179, 3901806776, 3818836405, 4270639778, 4118987695, 3299409036, 3483825537, 3535072918, 3652904859, 2077965243, 1893020342, 1841768865, 1724457132, 1474502543, 1559041666, 1107234197, 1257309336, 598438867, 681933534, 901210569, 1052338372, 261314535, 77422314, 428819965, 310463728, 3409685355, 3224740454, 3710368113, 3593056380, 3875770207, 3960309330, 4045380933, 4195456072, 2471224067, 2554718734, 2237133081, 2388260884, 3212035895, 3028143674, 2842678573, 2724322336, 4138563181, 4255350624, 3769721975, 3955191162, 3667219033, 3516619604, 3431546947, 3347532110, 2933734917, 2782082824, 3099667487, 3016697106, 2196052529, 2313884476, 2499348523, 2683765030, 1179510461, 1296297904, 1347548327, 1533017514, 1786102409, 1635502980, 2087309459, 2003294622, 507358933, 355706840, 136428751, 53458370, 839224033, 957055980, 605657339, 790073846, 2373340630, 2256028891, 2607439820, 2422494913, 2706270690, 2856345839, 3075636216, 3160175349, 3573941694, 3725069491, 3273267108, 3356761769, 4181598602, 4063242375, 4011996048, 3828103837, 1033297158, 915985419, 730517276, 545572369, 296679730, 446754879, 129166120, 213705253, 1709610350, 1860738147, 1945798516, 2029293177, 1239331162, 1120974935, 1606591296, 1422699085, 4148292826, 4233094615, 3781033664, 3931371469, 3682191598, 3497509347, 3446004468, 3328955385, 2939266226, 2755636671, 3106780840, 2988687269, 2198438022, 2282195339, 2501218972, 2652609425, 1201765386, 1286567175, 1371368976, 1521706781, 1805211710, 1620529459, 2105887268, 1988838185, 533804130, 350174575, 164439672, 46346101, 870912086, 954669403, 636813900, 788204353, 2358957921, 2274680428, 2592523643, 2441661558, 2695033685, 2880240216, 3065962831, 3182487618, 3572145929, 3756299780, 3270937875, 3388507166, 4174560061, 4091327024, 4006521127, 3854606378, 1014646705, 930369212, 711349675, 560487590, 272786309, 457992840, 106852767, 223377554, 1678381017, 1862534868, 1914052035, 2031621326, 1211247597, 1128014560, 1580087799, 1428173050, 32283319, 182621114, 401639597, 486441376, 768917123, 651868046, 1003007129, 818324884, 1503449823, 1385356242, 1333838021, 1150208456, 1973745387, 2125135846, 1673061617, 1756818940, 2970356327, 3120694122, 2802849917, 2887651696, 2637442643, 2520393566, 2334669897, 2149987652, 3917234703, 3799141122, 4284502037, 4100872472, 3309594171, 3460984630, 3545789473, 3629546796, 2050466060, 1899603969, 1814803222, 1730525723, 1443857720, 1560382517, 1075025698, 1260232239, 575138148, 692707433, 878443390, 1062597235, 243256656, 91341917, 409198410, 325965383, 3403100636, 3252238545, 3704300486, 3620022987, 3874428392, 3990953189, 4042459122, 4227665663, 2460449204, 2578018489, 2226875310, 2411029155, 3198115200, 3046200461, 2827177882, 2743944855],
              D = [0, 218828297, 437656594, 387781147, 875313188, 958871085, 775562294, 590424639, 1750626376, 1699970625, 1917742170, 2135253587, 1551124588, 1367295589, 1180849278, 1265195639, 3501252752, 3720081049, 3399941250, 3350065803, 3835484340, 3919042237, 4270507174, 4085369519, 3102249176, 3051593425, 2734591178, 2952102595, 2361698556, 2177869557, 2530391278, 2614737639, 3145456443, 3060847922, 2708326185, 2892417312, 2404901663, 2187128086, 2504130317, 2555048196, 3542330227, 3727205754, 3375740769, 3292445032, 3876557655, 3926170974, 4246310725, 4027744588, 1808481195, 1723872674, 1910319033, 2094410160, 1608975247, 1391201670, 1173430173, 1224348052, 59984867, 244860394, 428169201, 344873464, 935293895, 984907214, 766078933, 547512796, 1844882806, 1627235199, 2011214180, 2062270317, 1507497298, 1423022939, 1137477952, 1321699145, 95345982, 145085239, 532201772, 313773861, 830661914, 1015671571, 731183368, 648017665, 3175501286, 2957853679, 2807058932, 2858115069, 2305455554, 2220981195, 2474404304, 2658625497, 3575528878, 3625268135, 3473416636, 3254988725, 3778151818, 3963161475, 4213447064, 4130281361, 3599595085, 3683022916, 3432737375, 3247465558, 3802222185, 4020912224, 4172763771, 4122762354, 3201631749, 3017672716, 2764249623, 2848461854, 2331590177, 2280796200, 2431590963, 2648976442, 104699613, 188127444, 472615631, 287343814, 840019705, 1058709744, 671593195, 621591778, 1852171925, 1668212892, 1953757831, 2037970062, 1514790577, 1463996600, 1080017571, 1297403050, 3673637356, 3623636965, 3235995134, 3454686199, 4007360968, 3822090177, 4107101658, 4190530515, 2997825956, 3215212461, 2830708150, 2779915199, 2256734592, 2340947849, 2627016082, 2443058075, 172466556, 122466165, 273792366, 492483431, 1047239e3, 861968209, 612205898, 695634755, 1646252340, 1863638845, 2013908262, 1963115311, 1446242576, 1530455833, 1277555970, 1093597963, 1636604631, 1820824798, 2073724613, 1989249228, 1436590835, 1487645946, 1337376481, 1119727848, 164948639, 81781910, 331544205, 516552836, 1039717051, 821288114, 669961897, 719700128, 2973530695, 3157750862, 2871682645, 2787207260, 2232435299, 2283490410, 2667994737, 2450346104, 3647212047, 3564045318, 3279033885, 3464042516, 3980931627, 3762502690, 4150144569, 4199882800, 3070356634, 3121275539, 2904027272, 2686254721, 2200818878, 2384911031, 2570832044, 2486224549, 3747192018, 3528626907, 3310321856, 3359936201, 3950355702, 3867060991, 4049844452, 4234721005, 1739656202, 1790575107, 2108100632, 1890328081, 1402811438, 1586903591, 1233856572, 1149249077, 266959938, 48394827, 369057872, 418672217, 1002783846, 919489135, 567498868, 752375421, 209336225, 24197544, 376187827, 459744698, 945164165, 895287692, 574624663, 793451934, 1679968233, 1764313568, 2117360635, 1933530610, 1343127501, 1560637892, 1243112415, 1192455638, 3704280881, 3519142200, 3336358691, 3419915562, 3907448597, 3857572124, 4075877127, 4294704398, 3029510009, 3113855344, 2927934315, 2744104290, 2159976285, 2377486676, 2594734927, 2544078150],
              C = [0, 151849742, 303699484, 454499602, 607398968, 758720310, 908999204, 1059270954, 1214797936, 1097159550, 1517440620, 1400849762, 1817998408, 1699839814, 2118541908, 2001430874, 2429595872, 2581445614, 2194319100, 2345119218, 3034881240, 3186202582, 2801699524, 2951971274, 3635996816, 3518358430, 3399679628, 3283088770, 4237083816, 4118925222, 4002861748, 3885750714, 1002142683, 850817237, 698445255, 548169417, 529487843, 377642221, 227885567, 77089521, 1943217067, 2061379749, 1640576439, 1757691577, 1474760595, 1592394909, 1174215055, 1290801793, 2875968315, 2724642869, 3111247143, 2960971305, 2405426947, 2253581325, 2638606623, 2487810577, 3808662347, 3926825029, 4044981591, 4162096729, 3342319475, 3459953789, 3576539503, 3693126241, 1986918061, 2137062819, 1685577905, 1836772287, 1381620373, 1532285339, 1078185097, 1229899655, 1040559837, 923313619, 740276417, 621982671, 439452389, 322734571, 137073913, 19308535, 3871163981, 4021308739, 4104605777, 4255800159, 3263785589, 3414450555, 3499326569, 3651041127, 2933202493, 2815956275, 3167684641, 3049390895, 2330014213, 2213296395, 2566595609, 2448830231, 1305906550, 1155237496, 1607244650, 1455525988, 1776460110, 1626319424, 2079897426, 1928707164, 96392454, 213114376, 396673818, 514443284, 562755902, 679998e3, 865136418, 983426092, 3708173718, 3557504664, 3474729866, 3323011204, 4180808110, 4030667424, 3945269170, 3794078908, 2507040230, 2623762152, 2272556026, 2390325492, 2975484382, 3092726480, 2738905026, 2857194700, 3973773121, 3856137295, 4274053469, 4157467219, 3371096953, 3252932727, 3673476453, 3556361835, 2763173681, 2915017791, 3064510765, 3215307299, 2156299017, 2307622919, 2459735317, 2610011675, 2081048481, 1963412655, 1846563261, 1729977011, 1480485785, 1362321559, 1243905413, 1126790795, 878845905, 1030690015, 645401037, 796197571, 274084841, 425408743, 38544885, 188821243, 3613494426, 3731654548, 3313212038, 3430322568, 4082475170, 4200115116, 3780097726, 3896688048, 2668221674, 2516901860, 2366882550, 2216610296, 3141400786, 2989552604, 2837966542, 2687165888, 1202797690, 1320957812, 1437280870, 1554391400, 1669664834, 1787304780, 1906247262, 2022837584, 265905162, 114585348, 499347990, 349075736, 736970802, 585122620, 972512814, 821712160, 2595684844, 2478443234, 2293045232, 2174754046, 3196267988, 3079546586, 2895723464, 2777952454, 3537852828, 3687994002, 3234156416, 3385345166, 4142626212, 4293295786, 3841024952, 3992742070, 174567692, 57326082, 410887952, 292596766, 777231668, 660510266, 1011452712, 893681702, 1108339068, 1258480242, 1343618912, 1494807662, 1715193156, 1865862730, 1948373848, 2100090966, 2701949495, 2818666809, 3004591147, 3122358053, 2235061775, 2352307457, 2535604243, 2653899549, 3915653703, 3764988233, 4219352155, 4067639125, 3444575871, 3294430577, 3746175075, 3594982253, 836553431, 953270745, 600235211, 718002117, 367585007, 484830689, 133361907, 251657213, 2041877159, 1891211689, 1806599355, 1654886325, 1568718495, 1418573201, 1335535747, 1184342925];

          function S(e) {
            for (var t = [], a = 0; a < e.length; a += 4) {
              t.push(e[a] << 24 | e[a + 1] << 16 | e[a + 2] << 8 | e[a + 3]);
            }

            return t;
          }

          var E = function E(e) {
            if (!(this instanceof E)) throw Error("AES must be instanitated with `new`");
            Object.defineProperty(this, "key", {
              value: s(e, !0)
            }), this._prepare();
          };

          E.prototype._prepare = function () {
            var e = f[this.key.length];
            if (null == e) throw new Error("invalid key size (must be 16, 24 or 32 bytes)");
            this._Ke = [], this._Kd = [];

            for (var t = 0; t <= e; t++) {
              this._Ke.push([0, 0, 0, 0]), this._Kd.push([0, 0, 0, 0]);
            }

            var a,
                r = 4 * (e + 1),
                n = this.key.length / 4,
                s = S(this.key);

            for (t = 0; t < n; t++) {
              a = t >> 2, this._Ke[a][t % 4] = s[t], this._Kd[e - a][t % 4] = s[t];
            }

            for (var o, i = 0, c = n; c < r;) {
              if (o = s[n - 1], s[0] ^= h[o >> 16 & 255] << 24 ^ h[o >> 8 & 255] << 16 ^ h[255 & o] << 8 ^ h[o >> 24 & 255] ^ l[i] << 24, i += 1, 8 != n) for (t = 1; t < n; t++) {
                s[t] ^= s[t - 1];
              } else {
                for (t = 1; t < n / 2; t++) {
                  s[t] ^= s[t - 1];
                }

                for (o = s[n / 2 - 1], s[n / 2] ^= h[255 & o] ^ h[o >> 8 & 255] << 8 ^ h[o >> 16 & 255] << 16 ^ h[o >> 24 & 255] << 24, t = n / 2 + 1; t < n; t++) {
                  s[t] ^= s[t - 1];
                }
              }

              for (t = 0; t < n && c < r;) {
                u = c >> 2, d = c % 4, this._Ke[u][d] = s[t], this._Kd[e - u][d] = s[t++], c++;
              }
            }

            for (var u = 1; u < e; u++) {
              for (var d = 0; d < 4; d++) {
                o = this._Kd[u][d], this._Kd[u][d] = T[o >> 24 & 255] ^ x[o >> 16 & 255] ^ D[o >> 8 & 255] ^ C[255 & o];
              }
            }
          }, E.prototype.encrypt = function (e) {
            if (16 != e.length) throw new Error("invalid plaintext size (must be 16 bytes)");

            for (var t = this._Ke.length - 1, a = [0, 0, 0, 0], r = S(e), n = 0; n < 4; n++) {
              r[n] ^= this._Ke[0][n];
            }

            for (var s = 1; s < t; s++) {
              for (n = 0; n < 4; n++) {
                a[n] = b[r[n] >> 24 & 255] ^ m[r[(n + 1) % 4] >> 16 & 255] ^ y[r[(n + 2) % 4] >> 8 & 255] ^ v[255 & r[(n + 3) % 4]] ^ this._Ke[s][n];
              }

              r = a.slice();
            }

            var i,
                c = o(16);

            for (n = 0; n < 4; n++) {
              i = this._Ke[t][n], c[4 * n] = 255 & (h[r[n] >> 24 & 255] ^ i >> 24), c[4 * n + 1] = 255 & (h[r[(n + 1) % 4] >> 16 & 255] ^ i >> 16), c[4 * n + 2] = 255 & (h[r[(n + 2) % 4] >> 8 & 255] ^ i >> 8), c[4 * n + 3] = 255 & (h[255 & r[(n + 3) % 4]] ^ i);
            }

            return c;
          }, E.prototype.decrypt = function (e) {
            if (16 != e.length) throw new Error("invalid ciphertext size (must be 16 bytes)");

            for (var t = this._Kd.length - 1, a = [0, 0, 0, 0], r = S(e), n = 0; n < 4; n++) {
              r[n] ^= this._Kd[0][n];
            }

            for (var s = 1; s < t; s++) {
              for (n = 0; n < 4; n++) {
                a[n] = _[r[n] >> 24 & 255] ^ g[r[(n + 3) % 4] >> 16 & 255] ^ A[r[(n + 2) % 4] >> 8 & 255] ^ w[255 & r[(n + 1) % 4]] ^ this._Kd[s][n];
              }

              r = a.slice();
            }

            var i,
                c = o(16);

            for (n = 0; n < 4; n++) {
              i = this._Kd[t][n], c[4 * n] = 255 & (p[r[n] >> 24 & 255] ^ i >> 24), c[4 * n + 1] = 255 & (p[r[(n + 3) % 4] >> 16 & 255] ^ i >> 16), c[4 * n + 2] = 255 & (p[r[(n + 2) % 4] >> 8 & 255] ^ i >> 8), c[4 * n + 3] = 255 & (p[255 & r[(n + 1) % 4]] ^ i);
            }

            return c;
          };

          var B = function B(e) {
            if (!(this instanceof B)) throw Error("AES must be instanitated with `new`");
            this.description = "Electronic Code Block", this.name = "ecb", this._aes = new E(e);
          };

          B.prototype.encrypt = function (e) {
            if ((e = s(e)).length % 16 != 0) throw new Error("invalid plaintext size (must be multiple of 16 bytes)");

            for (var t = o(e.length), a = o(16), r = 0; r < e.length; r += 16) {
              i(e, a, 0, r, r + 16), i(a = this._aes.encrypt(a), t, r);
            }

            return t;
          }, B.prototype.decrypt = function (e) {
            if ((e = s(e)).length % 16 != 0) throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");

            for (var t = o(e.length), a = o(16), r = 0; r < e.length; r += 16) {
              i(e, a, 0, r, r + 16), i(a = this._aes.decrypt(a), t, r);
            }

            return t;
          };

          var k = function k(e, t) {
            if (!(this instanceof k)) throw Error("AES must be instanitated with `new`");

            if (this.description = "Cipher Block Chaining", this.name = "cbc", t) {
              if (16 != t.length) throw new Error("invalid initialation vector size (must be 16 bytes)");
            } else t = o(16);

            this._lastCipherblock = s(t, !0), this._aes = new E(e);
          };

          k.prototype.encrypt = function (e) {
            if ((e = s(e)).length % 16 != 0) throw new Error("invalid plaintext size (must be multiple of 16 bytes)");

            for (var t = o(e.length), a = o(16), r = 0; r < e.length; r += 16) {
              i(e, a, 0, r, r + 16);

              for (var n = 0; n < 16; n++) {
                a[n] ^= this._lastCipherblock[n];
              }

              this._lastCipherblock = this._aes.encrypt(a), i(this._lastCipherblock, t, r);
            }

            return t;
          }, k.prototype.decrypt = function (e) {
            if ((e = s(e)).length % 16 != 0) throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");

            for (var t = o(e.length), a = o(16), r = 0; r < e.length; r += 16) {
              i(e, a, 0, r, r + 16), a = this._aes.decrypt(a);

              for (var n = 0; n < 16; n++) {
                t[r + n] = a[n] ^ this._lastCipherblock[n];
              }

              i(e, this._lastCipherblock, 0, r, r + 16);
            }

            return t;
          };

          var R = function R(e, t, a) {
            if (!(this instanceof R)) throw Error("AES must be instanitated with `new`");

            if (this.description = "Cipher Feedback", this.name = "cfb", t) {
              if (16 != t.length) throw new Error("invalid initialation vector size (must be 16 size)");
            } else t = o(16);

            a = a || 1, this.segmentSize = a, this._shiftRegister = s(t, !0), this._aes = new E(e);
          };

          R.prototype.encrypt = function (e) {
            if (e.length % this.segmentSize != 0) throw new Error("invalid plaintext size (must be segmentSize bytes)");

            for (var t, a = s(e, !0), r = 0; r < a.length; r += this.segmentSize) {
              t = this._aes.encrypt(this._shiftRegister);

              for (var n = 0; n < this.segmentSize; n++) {
                a[r + n] ^= t[n];
              }

              i(this._shiftRegister, this._shiftRegister, 0, this.segmentSize), i(a, this._shiftRegister, 16 - this.segmentSize, r, r + this.segmentSize);
            }

            return a;
          }, R.prototype.decrypt = function (e) {
            if (e.length % this.segmentSize != 0) throw new Error("invalid ciphertext size (must be segmentSize bytes)");

            for (var t, a = s(e, !0), r = 0; r < a.length; r += this.segmentSize) {
              t = this._aes.encrypt(this._shiftRegister);

              for (var n = 0; n < this.segmentSize; n++) {
                a[r + n] ^= t[n];
              }

              i(this._shiftRegister, this._shiftRegister, 0, this.segmentSize), i(e, this._shiftRegister, 16 - this.segmentSize, r, r + this.segmentSize);
            }

            return a;
          };

          var W = function W(e, t) {
            if (!(this instanceof W)) throw Error("AES must be instanitated with `new`");

            if (this.description = "Output Feedback", this.name = "ofb", t) {
              if (16 != t.length) throw new Error("invalid initialation vector size (must be 16 bytes)");
            } else t = o(16);

            this._lastPrecipher = s(t, !0), this._lastPrecipherIndex = 16, this._aes = new E(e);
          };

          W.prototype.encrypt = function (e) {
            for (var t = s(e, !0), a = 0; a < t.length; a++) {
              16 === this._lastPrecipherIndex && (this._lastPrecipher = this._aes.encrypt(this._lastPrecipher), this._lastPrecipherIndex = 0), t[a] ^= this._lastPrecipher[this._lastPrecipherIndex++];
            }

            return t;
          }, W.prototype.decrypt = W.prototype.encrypt;

          var I = function I(e) {
            if (!(this instanceof I)) throw Error("Counter must be instanitated with `new`");
            0 === e || e || (e = 1), "number" == typeof e ? (this._counter = o(16), this.setValue(e)) : this.setBytes(e);
          };

          I.prototype.setValue = function (e) {
            if ("number" != typeof e || parseInt(e) != e) throw new Error("invalid counter value (must be an integer)");

            for (var t = 15; 0 <= t; --t) {
              this._counter[t] = e % 256, e >>= 8;
            }
          }, I.prototype.setBytes = function (e) {
            if (16 != (e = s(e, !0)).length) throw new Error("invalid counter bytes size (must be 16 bytes)");
            this._counter = e;
          }, I.prototype.increment = function () {
            for (var e = 15; 0 <= e; e--) {
              if (255 !== this._counter[e]) {
                this._counter[e]++;
                break;
              }

              this._counter[e] = 0;
            }
          };

          var N = function N(e, t) {
            if (!(this instanceof N)) throw Error("AES must be instanitated with `new`");
            this.description = "Counter", this.name = "ctr", t instanceof I || (t = new I(t)), this._counter = t, this._remainingCounter = null, this._remainingCounterIndex = 16, this._aes = new E(e);
          };

          N.prototype.encrypt = function (e) {
            for (var t = s(e, !0), a = 0; a < t.length; a++) {
              16 === this._remainingCounterIndex && (this._remainingCounter = this._aes.encrypt(this._counter._counter), this._remainingCounterIndex = 0, this._counter.increment()), t[a] ^= this._remainingCounter[this._remainingCounterIndex++];
            }

            return t;
          }, N.prototype.decrypt = N.prototype.encrypt;
          var M = {
            AES: E,
            Counter: I,
            ModeOfOperation: {
              ecb: B,
              cbc: k,
              cfb: R,
              ofb: W,
              ctr: N
            },
            utils: {
              hex: d,
              utf8: u
            },
            padding: {
              pkcs7: {
                pad: function pad(e) {
                  var t = 16 - (e = s(e, !0)).length % 16,
                      a = o(e.length + t);
                  i(e, a);

                  for (var r = e.length; r < a.length; r++) {
                    a[r] = t;
                  }

                  return a;
                },
                strip: function strip(e) {
                  if ((e = s(e, !0)).length < 16) throw new Error("PKCS#7 invalid length");
                  var t = e[e.length - 1];
                  if (16 < t) throw new Error("PKCS#7 padding byte out of range");

                  for (var a = e.length - t, r = 0; r < t; r++) {
                    if (e[a + r] !== t) throw new Error("PKCS#7 invalid padding byte");
                  }

                  var n = o(a);
                  return i(e, n, 0, 0, a), n;
                }
              }
            },
            _arrayTest: {
              coerceArray: s,
              createArray: o,
              copyArray: i
            }
          };
          void 0 !== a ? t.exports = M : (e.aesjs && (M._aesjs = e.aesjs), e.aesjs = M);
        }(this);
      }, {}],
      9: [function (e, t, a) {
        !function (t, a) {
          "use strict";

          function r(e, t) {
            if (!e) throw new Error(t || "Assertion failed");
          }

          function n(e, t) {
            function a() {}

            e.super_ = t, a.prototype = t.prototype, e.prototype = new a(), e.prototype.constructor = e;
          }

          function s(e, t, a) {
            if (s.isBN(e)) return e;
            this.negative = 0, this.words = null, this.length = 0, (this.red = null) !== e && ("le" !== t && "be" !== t || (a = t, t = 10), this._init(e || 0, t || 10, a || "be"));
          }

          var o;
          "object" == typeof t ? t.exports = s : a.BN = s, (s.BN = s).wordSize = 26;

          try {
            o = e("buffer").Buffer;
          } catch (t) {}

          function i(e, t, a) {
            for (var r = 0, n = Math.min(e.length, a), s = t; s < n; s++) {
              var o = e.charCodeAt(s) - 48;
              r <<= 4, r |= 49 <= o && o <= 54 ? o - 49 + 10 : 17 <= o && o <= 22 ? o - 17 + 10 : 15 & o;
            }

            return r;
          }

          function c(e, t, a, r) {
            for (var n = 0, s = Math.min(e.length, a), o = t; o < s; o++) {
              var i = e.charCodeAt(o) - 48;
              n *= r, n += 49 <= i ? i - 49 + 10 : 17 <= i ? i - 17 + 10 : i;
            }

            return n;
          }

          s.isBN = function (e) {
            return e instanceof s || null !== e && "object" == typeof e && e.constructor.wordSize === s.wordSize && Array.isArray(e.words);
          }, s.max = function (e, t) {
            return 0 < e.cmp(t) ? e : t;
          }, s.min = function (e, t) {
            return e.cmp(t) < 0 ? e : t;
          }, s.prototype._init = function (e, t, a) {
            if ("number" == typeof e) return this._initNumber(e, t, a);
            if ("object" == typeof e) return this._initArray(e, t, a);
            "hex" === t && (t = 16), r(t === (0 | t) && 2 <= t && t <= 36);
            var n = 0;
            "-" === (e = e.toString().replace(/\s+/g, ""))[0] && n++, 16 === t ? this._parseHex(e, n) : this._parseBase(e, t, n), "-" === e[0] && (this.negative = 1), this.strip(), "le" === a && this._initArray(this.toArray(), t, a);
          }, s.prototype._initNumber = function (e, t, a) {
            e < 0 && (this.negative = 1, e = -e), e < 67108864 ? (this.words = [67108863 & e], this.length = 1) : e < 4503599627370496 ? (this.words = [67108863 & e, e / 67108864 & 67108863], this.length = 2) : (r(e < 9007199254740992), this.words = [67108863 & e, e / 67108864 & 67108863, 1], this.length = 3), "le" === a && this._initArray(this.toArray(), t, a);
          }, s.prototype._initArray = function (e, t, a) {
            if (r("number" == typeof e.length), e.length <= 0) return this.words = [0], this.length = 1, this;
            this.length = Math.ceil(e.length / 3), this.words = new Array(this.length);

            for (var n = 0; n < this.length; n++) {
              this.words[n] = 0;
            }

            var s,
                o,
                i = 0;
            if ("be" === a) for (n = e.length - 1, s = 0; 0 <= n; n -= 3) {
              o = e[n] | e[n - 1] << 8 | e[n - 2] << 16, this.words[s] |= o << i & 67108863, this.words[s + 1] = o >>> 26 - i & 67108863, 26 <= (i += 24) && (i -= 26, s++);
            } else if ("le" === a) for (s = n = 0; n < e.length; n += 3) {
              o = e[n] | e[n + 1] << 8 | e[n + 2] << 16, this.words[s] |= o << i & 67108863, this.words[s + 1] = o >>> 26 - i & 67108863, 26 <= (i += 24) && (i -= 26, s++);
            }
            return this.strip();
          }, s.prototype._parseHex = function (e, t) {
            this.length = Math.ceil((e.length - t) / 6), this.words = new Array(this.length);

            for (var a = 0; a < this.length; a++) {
              this.words[a] = 0;
            }

            var r,
                n,
                s = 0;

            for (a = e.length - 6, r = 0; t <= a; a -= 6) {
              n = i(e, a, a + 6), this.words[r] |= n << s & 67108863, this.words[r + 1] |= n >>> 26 - s & 4194303, 26 <= (s += 24) && (s -= 26, r++);
            }

            a + 6 !== t && (n = i(e, t, a + 6), this.words[r] |= n << s & 67108863, this.words[r + 1] |= n >>> 26 - s & 4194303), this.strip();
          }, s.prototype._parseBase = function (e, t, a) {
            this.words = [0];

            for (var r = 0, n = this.length = 1; n <= 67108863; n *= t) {
              r++;
            }

            r--, n = n / t | 0;

            for (var s = e.length - a, o = s % r, i = Math.min(s, s - o) + a, u = 0, d = a; d < i; d += r) {
              u = c(e, d, d + r, t), this.imuln(n), this.words[0] + u < 67108864 ? this.words[0] += u : this._iaddn(u);
            }

            if (0 != o) {
              var f = 1;

              for (u = c(e, d, e.length, t), d = 0; d < o; d++) {
                f *= t;
              }

              this.imuln(f), this.words[0] + u < 67108864 ? this.words[0] += u : this._iaddn(u);
            }
          }, s.prototype.copy = function (e) {
            e.words = new Array(this.length);

            for (var t = 0; t < this.length; t++) {
              e.words[t] = this.words[t];
            }

            e.length = this.length, e.negative = this.negative, e.red = this.red;
          }, s.prototype.clone = function () {
            var e = new s(null);
            return this.copy(e), e;
          }, s.prototype._expand = function (e) {
            for (; this.length < e;) {
              this.words[this.length++] = 0;
            }

            return this;
          }, s.prototype.strip = function () {
            for (; 1 < this.length && 0 === this.words[this.length - 1];) {
              this.length--;
            }

            return this._normSign();
          }, s.prototype._normSign = function () {
            return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
          }, s.prototype.inspect = function () {
            return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
          };
          var u = ["", "0", "00", "000", "0000", "00000", "000000", "0000000", "00000000", "000000000", "0000000000", "00000000000", "000000000000", "0000000000000", "00000000000000", "000000000000000", "0000000000000000", "00000000000000000", "000000000000000000", "0000000000000000000", "00000000000000000000", "000000000000000000000", "0000000000000000000000", "00000000000000000000000", "000000000000000000000000", "0000000000000000000000000"],
              d = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
              f = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];

          function l(e, t, a) {
            a.negative = t.negative ^ e.negative;
            var r = e.length + t.length | 0;
            r = (a.length = r) - 1 | 0;
            var n = 0 | e.words[0],
                s = 0 | t.words[0],
                o = n * s,
                i = 67108863 & o,
                c = o / 67108864 | 0;
            a.words[0] = i;

            for (var u = 1; u < r; u++) {
              for (var d = c >>> 26, f = 67108863 & c, l = Math.min(u, t.length - 1), h = Math.max(0, u - e.length + 1); h <= l; h++) {
                var p = u - h | 0;
                d += (o = (n = 0 | e.words[p]) * (s = 0 | t.words[h]) + f) / 67108864 | 0, f = 67108863 & o;
              }

              a.words[u] = 0 | f, c = 0 | d;
            }

            return 0 !== c ? a.words[u] = 0 | c : a.length--, a.strip();
          }

          s.prototype.toString = function (e, t) {
            var a;

            if (t = 0 | t || 1, 16 === (e = e || 10) || "hex" === e) {
              a = "";

              for (var n = 0, s = 0, o = 0; o < this.length; o++) {
                var i = this.words[o],
                    c = (16777215 & (i << n | s)).toString(16);
                a = 0 != (s = i >>> 24 - n & 16777215) || o !== this.length - 1 ? u[6 - c.length] + c + a : c + a, 26 <= (n += 2) && (n -= 26, o--);
              }

              for (0 !== s && (a = s.toString(16) + a); a.length % t != 0;) {
                a = "0" + a;
              }

              return 0 !== this.negative && (a = "-" + a), a;
            }

            if (e === (0 | e) && 2 <= e && e <= 36) {
              var l = d[e],
                  h = f[e];
              a = "";
              var p = this.clone();

              for (p.negative = 0; !p.isZero();) {
                var b = p.modn(h).toString(e);
                a = (p = p.idivn(h)).isZero() ? b + a : u[l - b.length] + b + a;
              }

              for (this.isZero() && (a = "0" + a); a.length % t != 0;) {
                a = "0" + a;
              }

              return 0 !== this.negative && (a = "-" + a), a;
            }

            r(!1, "Base should be between 2 and 36");
          }, s.prototype.toNumber = function () {
            var e = this.words[0];
            return 2 === this.length ? e += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? e += 4503599627370496 + 67108864 * this.words[1] : 2 < this.length && r(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -e : e;
          }, s.prototype.toJSON = function () {
            return this.toString(16);
          }, s.prototype.toBuffer = function (e, t) {
            return r(void 0 !== o), this.toArrayLike(o, e, t);
          }, s.prototype.toArray = function (e, t) {
            return this.toArrayLike(Array, e, t);
          }, s.prototype.toArrayLike = function (e, t, a) {
            var n = this.byteLength(),
                s = a || Math.max(1, n);
            r(n <= s, "byte array longer than desired length"), r(0 < s, "Requested array length <= 0"), this.strip();
            var o,
                i,
                c = "le" === t,
                u = new e(s),
                d = this.clone();

            if (c) {
              for (i = 0; !d.isZero(); i++) {
                o = d.andln(255), d.iushrn(8), u[i] = o;
              }

              for (; i < s; i++) {
                u[i] = 0;
              }
            } else {
              for (i = 0; i < s - n; i++) {
                u[i] = 0;
              }

              for (i = 0; !d.isZero(); i++) {
                o = d.andln(255), d.iushrn(8), u[s - i - 1] = o;
              }
            }

            return u;
          }, s.prototype._countBits = Math.clz32 ? function (e) {
            return 32 - Math.clz32(e);
          } : function (e) {
            var t = e,
                a = 0;
            return 4096 <= t && (a += 13, t >>>= 13), 64 <= t && (a += 7, t >>>= 7), 8 <= t && (a += 4, t >>>= 4), 2 <= t && (a += 2, t >>>= 2), a + t;
          }, s.prototype._zeroBits = function (e) {
            if (0 === e) return 26;
            var t = e,
                a = 0;
            return 0 == (8191 & t) && (a += 13, t >>>= 13), 0 == (127 & t) && (a += 7, t >>>= 7), 0 == (15 & t) && (a += 4, t >>>= 4), 0 == (3 & t) && (a += 2, t >>>= 2), 0 == (1 & t) && a++, a;
          }, s.prototype.bitLength = function () {
            var e = this.words[this.length - 1],
                t = this._countBits(e);

            return 26 * (this.length - 1) + t;
          }, s.prototype.zeroBits = function () {
            if (this.isZero()) return 0;

            for (var e = 0, t = 0; t < this.length; t++) {
              var a = this._zeroBits(this.words[t]);

              if (e += a, 26 !== a) break;
            }

            return e;
          }, s.prototype.byteLength = function () {
            return Math.ceil(this.bitLength() / 8);
          }, s.prototype.toTwos = function (e) {
            return 0 !== this.negative ? this.abs().inotn(e).iaddn(1) : this.clone();
          }, s.prototype.fromTwos = function (e) {
            return this.testn(e - 1) ? this.notn(e).iaddn(1).ineg() : this.clone();
          }, s.prototype.isNeg = function () {
            return 0 !== this.negative;
          }, s.prototype.neg = function () {
            return this.clone().ineg();
          }, s.prototype.ineg = function () {
            return this.isZero() || (this.negative ^= 1), this;
          }, s.prototype.iuor = function (e) {
            for (; this.length < e.length;) {
              this.words[this.length++] = 0;
            }

            for (var t = 0; t < e.length; t++) {
              this.words[t] = this.words[t] | e.words[t];
            }

            return this.strip();
          }, s.prototype.ior = function (e) {
            return r(0 == (this.negative | e.negative)), this.iuor(e);
          }, s.prototype.or = function (e) {
            return this.length > e.length ? this.clone().ior(e) : e.clone().ior(this);
          }, s.prototype.uor = function (e) {
            return this.length > e.length ? this.clone().iuor(e) : e.clone().iuor(this);
          }, s.prototype.iuand = function (e) {
            var t;
            t = this.length > e.length ? e : this;

            for (var a = 0; a < t.length; a++) {
              this.words[a] = this.words[a] & e.words[a];
            }

            return this.length = t.length, this.strip();
          }, s.prototype.iand = function (e) {
            return r(0 == (this.negative | e.negative)), this.iuand(e);
          }, s.prototype.and = function (e) {
            return this.length > e.length ? this.clone().iand(e) : e.clone().iand(this);
          }, s.prototype.uand = function (e) {
            return this.length > e.length ? this.clone().iuand(e) : e.clone().iuand(this);
          }, s.prototype.iuxor = function (e) {
            var t, a;
            a = this.length > e.length ? (t = this, e) : (t = e, this);

            for (var r = 0; r < a.length; r++) {
              this.words[r] = t.words[r] ^ a.words[r];
            }

            if (this !== t) for (; r < t.length; r++) {
              this.words[r] = t.words[r];
            }
            return this.length = t.length, this.strip();
          }, s.prototype.ixor = function (e) {
            return r(0 == (this.negative | e.negative)), this.iuxor(e);
          }, s.prototype.xor = function (e) {
            return this.length > e.length ? this.clone().ixor(e) : e.clone().ixor(this);
          }, s.prototype.uxor = function (e) {
            return this.length > e.length ? this.clone().iuxor(e) : e.clone().iuxor(this);
          }, s.prototype.inotn = function (e) {
            r("number" == typeof e && 0 <= e);
            var t = 0 | Math.ceil(e / 26),
                a = e % 26;
            this._expand(t), 0 < a && t--;

            for (var n = 0; n < t; n++) {
              this.words[n] = 67108863 & ~this.words[n];
            }

            return 0 < a && (this.words[n] = ~this.words[n] & 67108863 >> 26 - a), this.strip();
          }, s.prototype.notn = function (e) {
            return this.clone().inotn(e);
          }, s.prototype.setn = function (e, t) {
            r("number" == typeof e && 0 <= e);
            var a = e / 26 | 0,
                n = e % 26;
            return this._expand(1 + a), this.words[a] = t ? this.words[a] | 1 << n : this.words[a] & ~(1 << n), this.strip();
          }, s.prototype.iadd = function (e) {
            var t, a, r;
            if (0 !== this.negative && 0 === e.negative) return this.negative = 0, t = this.isub(e), this.negative ^= 1, this._normSign();
            if (0 === this.negative && 0 !== e.negative) return e.negative = 0, t = this.isub(e), e.negative = 1, t._normSign();
            r = this.length > e.length ? (a = this, e) : (a = e, this);

            for (var n = 0, s = 0; s < r.length; s++) {
              t = (0 | a.words[s]) + (0 | r.words[s]) + n, this.words[s] = 67108863 & t, n = t >>> 26;
            }

            for (; 0 !== n && s < a.length; s++) {
              t = (0 | a.words[s]) + n, this.words[s] = 67108863 & t, n = t >>> 26;
            }

            if (this.length = a.length, 0 !== n) this.words[this.length] = n, this.length++;else if (a !== this) for (; s < a.length; s++) {
              this.words[s] = a.words[s];
            }
            return this;
          }, s.prototype.add = function (e) {
            var t;
            return 0 !== e.negative && 0 === this.negative ? (e.negative = 0, t = this.sub(e), e.negative ^= 1, t) : 0 === e.negative && 0 !== this.negative ? (this.negative = 0, t = e.sub(this), this.negative = 1, t) : this.length > e.length ? this.clone().iadd(e) : e.clone().iadd(this);
          }, s.prototype.isub = function (e) {
            if (0 !== e.negative) {
              e.negative = 0;
              var t = this.iadd(e);
              return e.negative = 1, t._normSign();
            }

            if (0 !== this.negative) return this.negative = 0, this.iadd(e), this.negative = 1, this._normSign();
            var a,
                r,
                n = this.cmp(e);
            if (0 === n) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
            r = 0 < n ? (a = this, e) : (a = e, this);

            for (var s = 0, o = 0; o < r.length; o++) {
              s = (t = (0 | a.words[o]) - (0 | r.words[o]) + s) >> 26, this.words[o] = 67108863 & t;
            }

            for (; 0 !== s && o < a.length; o++) {
              s = (t = (0 | a.words[o]) + s) >> 26, this.words[o] = 67108863 & t;
            }

            if (0 === s && o < a.length && a !== this) for (; o < a.length; o++) {
              this.words[o] = a.words[o];
            }
            return this.length = Math.max(this.length, o), a !== this && (this.negative = 1), this.strip();
          }, s.prototype.sub = function (e) {
            return this.clone().isub(e);
          };

          var h = function h(e, t, a) {
            var r,
                n,
                s,
                o = e.words,
                i = t.words,
                c = a.words,
                u = 0,
                d = 0 | o[0],
                f = 8191 & d,
                l = d >>> 13,
                h = 0 | o[1],
                p = 8191 & h,
                b = h >>> 13,
                m = 0 | o[2],
                y = 8191 & m,
                v = m >>> 13,
                _ = 0 | o[3],
                g = 8191 & _,
                A = _ >>> 13,
                w = 0 | o[4],
                T = 8191 & w,
                x = w >>> 13,
                D = 0 | o[5],
                C = 8191 & D,
                S = D >>> 13,
                E = 0 | o[6],
                B = 8191 & E,
                k = E >>> 13,
                R = 0 | o[7],
                W = 8191 & R,
                I = R >>> 13,
                N = 0 | o[8],
                M = 8191 & N,
                P = N >>> 13,
                L = 0 | o[9],
                O = 8191 & L,
                F = L >>> 13,
                j = 0 | i[0],
                G = 8191 & j,
                V = j >>> 13,
                U = 0 | i[1],
                H = 8191 & U,
                z = U >>> 13,
                K = 0 | i[2],
                q = 8191 & K,
                Y = K >>> 13,
                Z = 0 | i[3],
                J = 8191 & Z,
                X = Z >>> 13,
                $ = 0 | i[4],
                Q = 8191 & $,
                ee = $ >>> 13,
                te = 0 | i[5],
                ae = 8191 & te,
                re = te >>> 13,
                ne = 0 | i[6],
                se = 8191 & ne,
                oe = ne >>> 13,
                ie = 0 | i[7],
                ce = 8191 & ie,
                ue = ie >>> 13,
                de = 0 | i[8],
                fe = 8191 & de,
                le = de >>> 13,
                he = 0 | i[9],
                pe = 8191 & he,
                be = he >>> 13;

            a.negative = e.negative ^ t.negative, a.length = 19;
            var me = (u + (r = Math.imul(f, G)) | 0) + ((8191 & (n = (n = Math.imul(f, V)) + Math.imul(l, G) | 0)) << 13) | 0;
            u = ((s = Math.imul(l, V)) + (n >>> 13) | 0) + (me >>> 26) | 0, me &= 67108863, r = Math.imul(p, G), n = (n = Math.imul(p, V)) + Math.imul(b, G) | 0, s = Math.imul(b, V);
            var ye = (u + (r = r + Math.imul(f, H) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(f, z) | 0) + Math.imul(l, H) | 0)) << 13) | 0;
            u = ((s = s + Math.imul(l, z) | 0) + (n >>> 13) | 0) + (ye >>> 26) | 0, ye &= 67108863, r = Math.imul(y, G), n = (n = Math.imul(y, V)) + Math.imul(v, G) | 0, s = Math.imul(v, V), r = r + Math.imul(p, H) | 0, n = (n = n + Math.imul(p, z) | 0) + Math.imul(b, H) | 0, s = s + Math.imul(b, z) | 0;
            var ve = (u + (r = r + Math.imul(f, q) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(f, Y) | 0) + Math.imul(l, q) | 0)) << 13) | 0;
            u = ((s = s + Math.imul(l, Y) | 0) + (n >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, r = Math.imul(g, G), n = (n = Math.imul(g, V)) + Math.imul(A, G) | 0, s = Math.imul(A, V), r = r + Math.imul(y, H) | 0, n = (n = n + Math.imul(y, z) | 0) + Math.imul(v, H) | 0, s = s + Math.imul(v, z) | 0, r = r + Math.imul(p, q) | 0, n = (n = n + Math.imul(p, Y) | 0) + Math.imul(b, q) | 0, s = s + Math.imul(b, Y) | 0;

            var _e = (u + (r = r + Math.imul(f, J) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(f, X) | 0) + Math.imul(l, J) | 0)) << 13) | 0;

            u = ((s = s + Math.imul(l, X) | 0) + (n >>> 13) | 0) + (_e >>> 26) | 0, _e &= 67108863, r = Math.imul(T, G), n = (n = Math.imul(T, V)) + Math.imul(x, G) | 0, s = Math.imul(x, V), r = r + Math.imul(g, H) | 0, n = (n = n + Math.imul(g, z) | 0) + Math.imul(A, H) | 0, s = s + Math.imul(A, z) | 0, r = r + Math.imul(y, q) | 0, n = (n = n + Math.imul(y, Y) | 0) + Math.imul(v, q) | 0, s = s + Math.imul(v, Y) | 0, r = r + Math.imul(p, J) | 0, n = (n = n + Math.imul(p, X) | 0) + Math.imul(b, J) | 0, s = s + Math.imul(b, X) | 0;
            var ge = (u + (r = r + Math.imul(f, Q) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(f, ee) | 0) + Math.imul(l, Q) | 0)) << 13) | 0;
            u = ((s = s + Math.imul(l, ee) | 0) + (n >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, r = Math.imul(C, G), n = (n = Math.imul(C, V)) + Math.imul(S, G) | 0, s = Math.imul(S, V), r = r + Math.imul(T, H) | 0, n = (n = n + Math.imul(T, z) | 0) + Math.imul(x, H) | 0, s = s + Math.imul(x, z) | 0, r = r + Math.imul(g, q) | 0, n = (n = n + Math.imul(g, Y) | 0) + Math.imul(A, q) | 0, s = s + Math.imul(A, Y) | 0, r = r + Math.imul(y, J) | 0, n = (n = n + Math.imul(y, X) | 0) + Math.imul(v, J) | 0, s = s + Math.imul(v, X) | 0, r = r + Math.imul(p, Q) | 0, n = (n = n + Math.imul(p, ee) | 0) + Math.imul(b, Q) | 0, s = s + Math.imul(b, ee) | 0;
            var Ae = (u + (r = r + Math.imul(f, ae) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(f, re) | 0) + Math.imul(l, ae) | 0)) << 13) | 0;
            u = ((s = s + Math.imul(l, re) | 0) + (n >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, r = Math.imul(B, G), n = (n = Math.imul(B, V)) + Math.imul(k, G) | 0, s = Math.imul(k, V), r = r + Math.imul(C, H) | 0, n = (n = n + Math.imul(C, z) | 0) + Math.imul(S, H) | 0, s = s + Math.imul(S, z) | 0, r = r + Math.imul(T, q) | 0, n = (n = n + Math.imul(T, Y) | 0) + Math.imul(x, q) | 0, s = s + Math.imul(x, Y) | 0, r = r + Math.imul(g, J) | 0, n = (n = n + Math.imul(g, X) | 0) + Math.imul(A, J) | 0, s = s + Math.imul(A, X) | 0, r = r + Math.imul(y, Q) | 0, n = (n = n + Math.imul(y, ee) | 0) + Math.imul(v, Q) | 0, s = s + Math.imul(v, ee) | 0, r = r + Math.imul(p, ae) | 0, n = (n = n + Math.imul(p, re) | 0) + Math.imul(b, ae) | 0, s = s + Math.imul(b, re) | 0;
            var we = (u + (r = r + Math.imul(f, se) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(f, oe) | 0) + Math.imul(l, se) | 0)) << 13) | 0;
            u = ((s = s + Math.imul(l, oe) | 0) + (n >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, r = Math.imul(W, G), n = (n = Math.imul(W, V)) + Math.imul(I, G) | 0, s = Math.imul(I, V), r = r + Math.imul(B, H) | 0, n = (n = n + Math.imul(B, z) | 0) + Math.imul(k, H) | 0, s = s + Math.imul(k, z) | 0, r = r + Math.imul(C, q) | 0, n = (n = n + Math.imul(C, Y) | 0) + Math.imul(S, q) | 0, s = s + Math.imul(S, Y) | 0, r = r + Math.imul(T, J) | 0, n = (n = n + Math.imul(T, X) | 0) + Math.imul(x, J) | 0, s = s + Math.imul(x, X) | 0, r = r + Math.imul(g, Q) | 0, n = (n = n + Math.imul(g, ee) | 0) + Math.imul(A, Q) | 0, s = s + Math.imul(A, ee) | 0, r = r + Math.imul(y, ae) | 0, n = (n = n + Math.imul(y, re) | 0) + Math.imul(v, ae) | 0, s = s + Math.imul(v, re) | 0, r = r + Math.imul(p, se) | 0, n = (n = n + Math.imul(p, oe) | 0) + Math.imul(b, se) | 0, s = s + Math.imul(b, oe) | 0;
            var Te = (u + (r = r + Math.imul(f, ce) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(f, ue) | 0) + Math.imul(l, ce) | 0)) << 13) | 0;
            u = ((s = s + Math.imul(l, ue) | 0) + (n >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, r = Math.imul(M, G), n = (n = Math.imul(M, V)) + Math.imul(P, G) | 0, s = Math.imul(P, V), r = r + Math.imul(W, H) | 0, n = (n = n + Math.imul(W, z) | 0) + Math.imul(I, H) | 0, s = s + Math.imul(I, z) | 0, r = r + Math.imul(B, q) | 0, n = (n = n + Math.imul(B, Y) | 0) + Math.imul(k, q) | 0, s = s + Math.imul(k, Y) | 0, r = r + Math.imul(C, J) | 0, n = (n = n + Math.imul(C, X) | 0) + Math.imul(S, J) | 0, s = s + Math.imul(S, X) | 0, r = r + Math.imul(T, Q) | 0, n = (n = n + Math.imul(T, ee) | 0) + Math.imul(x, Q) | 0, s = s + Math.imul(x, ee) | 0, r = r + Math.imul(g, ae) | 0, n = (n = n + Math.imul(g, re) | 0) + Math.imul(A, ae) | 0, s = s + Math.imul(A, re) | 0, r = r + Math.imul(y, se) | 0, n = (n = n + Math.imul(y, oe) | 0) + Math.imul(v, se) | 0, s = s + Math.imul(v, oe) | 0, r = r + Math.imul(p, ce) | 0, n = (n = n + Math.imul(p, ue) | 0) + Math.imul(b, ce) | 0, s = s + Math.imul(b, ue) | 0;
            var xe = (u + (r = r + Math.imul(f, fe) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(f, le) | 0) + Math.imul(l, fe) | 0)) << 13) | 0;
            u = ((s = s + Math.imul(l, le) | 0) + (n >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, r = Math.imul(O, G), n = (n = Math.imul(O, V)) + Math.imul(F, G) | 0, s = Math.imul(F, V), r = r + Math.imul(M, H) | 0, n = (n = n + Math.imul(M, z) | 0) + Math.imul(P, H) | 0, s = s + Math.imul(P, z) | 0, r = r + Math.imul(W, q) | 0, n = (n = n + Math.imul(W, Y) | 0) + Math.imul(I, q) | 0, s = s + Math.imul(I, Y) | 0, r = r + Math.imul(B, J) | 0, n = (n = n + Math.imul(B, X) | 0) + Math.imul(k, J) | 0, s = s + Math.imul(k, X) | 0, r = r + Math.imul(C, Q) | 0, n = (n = n + Math.imul(C, ee) | 0) + Math.imul(S, Q) | 0, s = s + Math.imul(S, ee) | 0, r = r + Math.imul(T, ae) | 0, n = (n = n + Math.imul(T, re) | 0) + Math.imul(x, ae) | 0, s = s + Math.imul(x, re) | 0, r = r + Math.imul(g, se) | 0, n = (n = n + Math.imul(g, oe) | 0) + Math.imul(A, se) | 0, s = s + Math.imul(A, oe) | 0, r = r + Math.imul(y, ce) | 0, n = (n = n + Math.imul(y, ue) | 0) + Math.imul(v, ce) | 0, s = s + Math.imul(v, ue) | 0, r = r + Math.imul(p, fe) | 0, n = (n = n + Math.imul(p, le) | 0) + Math.imul(b, fe) | 0, s = s + Math.imul(b, le) | 0;
            var De = (u + (r = r + Math.imul(f, pe) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(f, be) | 0) + Math.imul(l, pe) | 0)) << 13) | 0;
            u = ((s = s + Math.imul(l, be) | 0) + (n >>> 13) | 0) + (De >>> 26) | 0, De &= 67108863, r = Math.imul(O, H), n = (n = Math.imul(O, z)) + Math.imul(F, H) | 0, s = Math.imul(F, z), r = r + Math.imul(M, q) | 0, n = (n = n + Math.imul(M, Y) | 0) + Math.imul(P, q) | 0, s = s + Math.imul(P, Y) | 0, r = r + Math.imul(W, J) | 0, n = (n = n + Math.imul(W, X) | 0) + Math.imul(I, J) | 0, s = s + Math.imul(I, X) | 0, r = r + Math.imul(B, Q) | 0, n = (n = n + Math.imul(B, ee) | 0) + Math.imul(k, Q) | 0, s = s + Math.imul(k, ee) | 0, r = r + Math.imul(C, ae) | 0, n = (n = n + Math.imul(C, re) | 0) + Math.imul(S, ae) | 0, s = s + Math.imul(S, re) | 0, r = r + Math.imul(T, se) | 0, n = (n = n + Math.imul(T, oe) | 0) + Math.imul(x, se) | 0, s = s + Math.imul(x, oe) | 0, r = r + Math.imul(g, ce) | 0, n = (n = n + Math.imul(g, ue) | 0) + Math.imul(A, ce) | 0, s = s + Math.imul(A, ue) | 0, r = r + Math.imul(y, fe) | 0, n = (n = n + Math.imul(y, le) | 0) + Math.imul(v, fe) | 0, s = s + Math.imul(v, le) | 0;
            var Ce = (u + (r = r + Math.imul(p, pe) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(p, be) | 0) + Math.imul(b, pe) | 0)) << 13) | 0;
            u = ((s = s + Math.imul(b, be) | 0) + (n >>> 13) | 0) + (Ce >>> 26) | 0, Ce &= 67108863, r = Math.imul(O, q), n = (n = Math.imul(O, Y)) + Math.imul(F, q) | 0, s = Math.imul(F, Y), r = r + Math.imul(M, J) | 0, n = (n = n + Math.imul(M, X) | 0) + Math.imul(P, J) | 0, s = s + Math.imul(P, X) | 0, r = r + Math.imul(W, Q) | 0, n = (n = n + Math.imul(W, ee) | 0) + Math.imul(I, Q) | 0, s = s + Math.imul(I, ee) | 0, r = r + Math.imul(B, ae) | 0, n = (n = n + Math.imul(B, re) | 0) + Math.imul(k, ae) | 0, s = s + Math.imul(k, re) | 0, r = r + Math.imul(C, se) | 0, n = (n = n + Math.imul(C, oe) | 0) + Math.imul(S, se) | 0, s = s + Math.imul(S, oe) | 0, r = r + Math.imul(T, ce) | 0, n = (n = n + Math.imul(T, ue) | 0) + Math.imul(x, ce) | 0, s = s + Math.imul(x, ue) | 0, r = r + Math.imul(g, fe) | 0, n = (n = n + Math.imul(g, le) | 0) + Math.imul(A, fe) | 0, s = s + Math.imul(A, le) | 0;
            var Se = (u + (r = r + Math.imul(y, pe) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(y, be) | 0) + Math.imul(v, pe) | 0)) << 13) | 0;
            u = ((s = s + Math.imul(v, be) | 0) + (n >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, r = Math.imul(O, J), n = (n = Math.imul(O, X)) + Math.imul(F, J) | 0, s = Math.imul(F, X), r = r + Math.imul(M, Q) | 0, n = (n = n + Math.imul(M, ee) | 0) + Math.imul(P, Q) | 0, s = s + Math.imul(P, ee) | 0, r = r + Math.imul(W, ae) | 0, n = (n = n + Math.imul(W, re) | 0) + Math.imul(I, ae) | 0, s = s + Math.imul(I, re) | 0, r = r + Math.imul(B, se) | 0, n = (n = n + Math.imul(B, oe) | 0) + Math.imul(k, se) | 0, s = s + Math.imul(k, oe) | 0, r = r + Math.imul(C, ce) | 0, n = (n = n + Math.imul(C, ue) | 0) + Math.imul(S, ce) | 0, s = s + Math.imul(S, ue) | 0, r = r + Math.imul(T, fe) | 0, n = (n = n + Math.imul(T, le) | 0) + Math.imul(x, fe) | 0, s = s + Math.imul(x, le) | 0;
            var Ee = (u + (r = r + Math.imul(g, pe) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(g, be) | 0) + Math.imul(A, pe) | 0)) << 13) | 0;
            u = ((s = s + Math.imul(A, be) | 0) + (n >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, r = Math.imul(O, Q), n = (n = Math.imul(O, ee)) + Math.imul(F, Q) | 0, s = Math.imul(F, ee), r = r + Math.imul(M, ae) | 0, n = (n = n + Math.imul(M, re) | 0) + Math.imul(P, ae) | 0, s = s + Math.imul(P, re) | 0, r = r + Math.imul(W, se) | 0, n = (n = n + Math.imul(W, oe) | 0) + Math.imul(I, se) | 0, s = s + Math.imul(I, oe) | 0, r = r + Math.imul(B, ce) | 0, n = (n = n + Math.imul(B, ue) | 0) + Math.imul(k, ce) | 0, s = s + Math.imul(k, ue) | 0, r = r + Math.imul(C, fe) | 0, n = (n = n + Math.imul(C, le) | 0) + Math.imul(S, fe) | 0, s = s + Math.imul(S, le) | 0;
            var Be = (u + (r = r + Math.imul(T, pe) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(T, be) | 0) + Math.imul(x, pe) | 0)) << 13) | 0;
            u = ((s = s + Math.imul(x, be) | 0) + (n >>> 13) | 0) + (Be >>> 26) | 0, Be &= 67108863, r = Math.imul(O, ae), n = (n = Math.imul(O, re)) + Math.imul(F, ae) | 0, s = Math.imul(F, re), r = r + Math.imul(M, se) | 0, n = (n = n + Math.imul(M, oe) | 0) + Math.imul(P, se) | 0, s = s + Math.imul(P, oe) | 0, r = r + Math.imul(W, ce) | 0, n = (n = n + Math.imul(W, ue) | 0) + Math.imul(I, ce) | 0, s = s + Math.imul(I, ue) | 0, r = r + Math.imul(B, fe) | 0, n = (n = n + Math.imul(B, le) | 0) + Math.imul(k, fe) | 0, s = s + Math.imul(k, le) | 0;
            var ke = (u + (r = r + Math.imul(C, pe) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(C, be) | 0) + Math.imul(S, pe) | 0)) << 13) | 0;
            u = ((s = s + Math.imul(S, be) | 0) + (n >>> 13) | 0) + (ke >>> 26) | 0, ke &= 67108863, r = Math.imul(O, se), n = (n = Math.imul(O, oe)) + Math.imul(F, se) | 0, s = Math.imul(F, oe), r = r + Math.imul(M, ce) | 0, n = (n = n + Math.imul(M, ue) | 0) + Math.imul(P, ce) | 0, s = s + Math.imul(P, ue) | 0, r = r + Math.imul(W, fe) | 0, n = (n = n + Math.imul(W, le) | 0) + Math.imul(I, fe) | 0, s = s + Math.imul(I, le) | 0;
            var Re = (u + (r = r + Math.imul(B, pe) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(B, be) | 0) + Math.imul(k, pe) | 0)) << 13) | 0;
            u = ((s = s + Math.imul(k, be) | 0) + (n >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, r = Math.imul(O, ce), n = (n = Math.imul(O, ue)) + Math.imul(F, ce) | 0, s = Math.imul(F, ue), r = r + Math.imul(M, fe) | 0, n = (n = n + Math.imul(M, le) | 0) + Math.imul(P, fe) | 0, s = s + Math.imul(P, le) | 0;
            var We = (u + (r = r + Math.imul(W, pe) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(W, be) | 0) + Math.imul(I, pe) | 0)) << 13) | 0;
            u = ((s = s + Math.imul(I, be) | 0) + (n >>> 13) | 0) + (We >>> 26) | 0, We &= 67108863, r = Math.imul(O, fe), n = (n = Math.imul(O, le)) + Math.imul(F, fe) | 0, s = Math.imul(F, le);
            var Ie = (u + (r = r + Math.imul(M, pe) | 0) | 0) + ((8191 & (n = (n = n + Math.imul(M, be) | 0) + Math.imul(P, pe) | 0)) << 13) | 0;
            u = ((s = s + Math.imul(P, be) | 0) + (n >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863;
            var Ne = (u + (r = Math.imul(O, pe)) | 0) + ((8191 & (n = (n = Math.imul(O, be)) + Math.imul(F, pe) | 0)) << 13) | 0;
            return u = ((s = Math.imul(F, be)) + (n >>> 13) | 0) + (Ne >>> 26) | 0, Ne &= 67108863, c[0] = me, c[1] = ye, c[2] = ve, c[3] = _e, c[4] = ge, c[5] = Ae, c[6] = we, c[7] = Te, c[8] = xe, c[9] = De, c[10] = Ce, c[11] = Se, c[12] = Ee, c[13] = Be, c[14] = ke, c[15] = Re, c[16] = We, c[17] = Ie, c[18] = Ne, 0 !== u && (c[19] = u, a.length++), a;
          };

          function p(e, t, a) {
            return new b().mulp(e, t, a);
          }

          function b(e, t) {
            this.x = e, this.y = t;
          }

          Math.imul || (h = l), s.prototype.mulTo = function (e, t) {
            var a = this.length + e.length;
            return 10 === this.length && 10 === e.length ? h(this, e, t) : a < 63 ? l(this, e, t) : a < 1024 ? function (e, t, a) {
              a.negative = t.negative ^ e.negative, a.length = e.length + t.length;

              for (var r = 0, n = 0, s = 0; s < a.length - 1; s++) {
                var o = n;
                n = 0;

                for (var i = 67108863 & r, c = Math.min(s, t.length - 1), u = Math.max(0, s - e.length + 1); u <= c; u++) {
                  var d = s - u,
                      f = (0 | e.words[d]) * (0 | t.words[u]),
                      l = 67108863 & f;
                  i = 67108863 & (l = l + i | 0), n += (o = (o = o + (f / 67108864 | 0) | 0) + (l >>> 26) | 0) >>> 26, o &= 67108863;
                }

                a.words[s] = i, r = o, o = n;
              }

              return 0 !== r ? a.words[s] = r : a.length--, a.strip();
            }(this, e, t) : p(this, e, t);
          }, b.prototype.makeRBT = function (e) {
            for (var t = new Array(e), a = s.prototype._countBits(e) - 1, r = 0; r < e; r++) {
              t[r] = this.revBin(r, a, e);
            }

            return t;
          }, b.prototype.revBin = function (e, t, a) {
            if (0 === e || e === a - 1) return e;

            for (var r = 0, n = 0; n < t; n++) {
              r |= (1 & e) << t - n - 1, e >>= 1;
            }

            return r;
          }, b.prototype.permute = function (e, t, a, r, n, s) {
            for (var o = 0; o < s; o++) {
              r[o] = t[e[o]], n[o] = a[e[o]];
            }
          }, b.prototype.transform = function (e, t, a, r, n, s) {
            this.permute(s, e, t, a, r, n);

            for (var o = 1; o < n; o <<= 1) {
              for (var i = o << 1, c = Math.cos(2 * Math.PI / i), u = Math.sin(2 * Math.PI / i), d = 0; d < n; d += i) {
                for (var f = c, l = u, h = 0; h < o; h++) {
                  var p = a[d + h],
                      b = r[d + h],
                      m = a[d + h + o],
                      y = r[d + h + o],
                      v = f * m - l * y;
                  y = f * y + l * m, m = v, a[d + h] = p + m, r[d + h] = b + y, a[d + h + o] = p - m, r[d + h + o] = b - y, h !== i && (v = c * f - u * l, l = c * l + u * f, f = v);
                }
              }
            }
          }, b.prototype.guessLen13b = function (e, t) {
            var a = 1 | Math.max(t, e),
                r = 1 & a,
                n = 0;

            for (a = a / 2 | 0; a; a >>>= 1) {
              n++;
            }

            return 1 << n + 1 + r;
          }, b.prototype.conjugate = function (e, t, a) {
            if (!(a <= 1)) for (var r = 0; r < a / 2; r++) {
              var n = e[r];
              e[r] = e[a - r - 1], e[a - r - 1] = n, n = t[r], t[r] = -t[a - r - 1], t[a - r - 1] = -n;
            }
          }, b.prototype.normalize13b = function (e, t) {
            for (var a = 0, r = 0; r < t / 2; r++) {
              var n = 8192 * Math.round(e[2 * r + 1] / t) + Math.round(e[2 * r] / t) + a;
              e[r] = 67108863 & n, a = n < 67108864 ? 0 : n / 67108864 | 0;
            }

            return e;
          }, b.prototype.convert13b = function (e, t, a, n) {
            for (var s = 0, o = 0; o < t; o++) {
              s += 0 | e[o], a[2 * o] = 8191 & s, s >>>= 13, a[2 * o + 1] = 8191 & s, s >>>= 13;
            }

            for (o = 2 * t; o < n; ++o) {
              a[o] = 0;
            }

            r(0 === s), r(0 == (-8192 & s));
          }, b.prototype.stub = function (e) {
            for (var t = new Array(e), a = 0; a < e; a++) {
              t[a] = 0;
            }

            return t;
          }, b.prototype.mulp = function (e, t, a) {
            var r = 2 * this.guessLen13b(e.length, t.length),
                n = this.makeRBT(r),
                s = this.stub(r),
                o = new Array(r),
                i = new Array(r),
                c = new Array(r),
                u = new Array(r),
                d = new Array(r),
                f = new Array(r),
                l = a.words;
            l.length = r, this.convert13b(e.words, e.length, o, r), this.convert13b(t.words, t.length, u, r), this.transform(o, s, i, c, r, n), this.transform(u, s, d, f, r, n);

            for (var h = 0; h < r; h++) {
              var p = i[h] * d[h] - c[h] * f[h];
              c[h] = i[h] * f[h] + c[h] * d[h], i[h] = p;
            }

            return this.conjugate(i, c, r), this.transform(i, c, l, s, r, n), this.conjugate(l, s, r), this.normalize13b(l, r), a.negative = e.negative ^ t.negative, a.length = e.length + t.length, a.strip();
          }, s.prototype.mul = function (e) {
            var t = new s(null);
            return t.words = new Array(this.length + e.length), this.mulTo(e, t);
          }, s.prototype.mulf = function (e) {
            var t = new s(null);
            return t.words = new Array(this.length + e.length), p(this, e, t);
          }, s.prototype.imul = function (e) {
            return this.clone().mulTo(e, this);
          }, s.prototype.imuln = function (e) {
            r("number" == typeof e), r(e < 67108864);

            for (var t = 0, a = 0; a < this.length; a++) {
              var n = (0 | this.words[a]) * e,
                  s = (67108863 & n) + (67108863 & t);
              t >>= 26, t += n / 67108864 | 0, t += s >>> 26, this.words[a] = 67108863 & s;
            }

            return 0 !== t && (this.words[a] = t, this.length++), this;
          }, s.prototype.muln = function (e) {
            return this.clone().imuln(e);
          }, s.prototype.sqr = function () {
            return this.mul(this);
          }, s.prototype.isqr = function () {
            return this.imul(this.clone());
          }, s.prototype.pow = function (e) {
            var t = function (e) {
              for (var t = new Array(e.bitLength()), a = 0; a < t.length; a++) {
                var r = a / 26 | 0,
                    n = a % 26;
                t[a] = (e.words[r] & 1 << n) >>> n;
              }

              return t;
            }(e);

            if (0 === t.length) return new s(1);

            for (var a = this, r = 0; r < t.length && 0 === t[r]; r++, a = a.sqr()) {
              ;
            }

            if (++r < t.length) for (var n = a.sqr(); r < t.length; r++, n = n.sqr()) {
              0 !== t[r] && (a = a.mul(n));
            }
            return a;
          }, s.prototype.iushln = function (e) {
            r("number" == typeof e && 0 <= e);
            var t,
                a = e % 26,
                n = (e - a) / 26,
                s = 67108863 >>> 26 - a << 26 - a;

            if (0 != a) {
              var o = 0;

              for (t = 0; t < this.length; t++) {
                var i = this.words[t] & s,
                    c = (0 | this.words[t]) - i << a;
                this.words[t] = c | o, o = i >>> 26 - a;
              }

              o && (this.words[t] = o, this.length++);
            }

            if (0 != n) {
              for (t = this.length - 1; 0 <= t; t--) {
                this.words[t + n] = this.words[t];
              }

              for (t = 0; t < n; t++) {
                this.words[t] = 0;
              }

              this.length += n;
            }

            return this.strip();
          }, s.prototype.ishln = function (e) {
            return r(0 === this.negative), this.iushln(e);
          }, s.prototype.iushrn = function (e, t, a) {
            var n;
            r("number" == typeof e && 0 <= e), n = t ? (t - t % 26) / 26 : 0;
            var s = e % 26,
                o = Math.min((e - s) / 26, this.length),
                i = 67108863 ^ 67108863 >>> s << s,
                c = a;

            if (n -= o, n = Math.max(0, n), c) {
              for (var u = 0; u < o; u++) {
                c.words[u] = this.words[u];
              }

              c.length = o;
            }

            if (0 === o) ;else if (this.length > o) for (this.length -= o, u = 0; u < this.length; u++) {
              this.words[u] = this.words[u + o];
            } else this.words[0] = 0, this.length = 1;
            var d = 0;

            for (u = this.length - 1; 0 <= u && (0 !== d || n <= u); u--) {
              var f = 0 | this.words[u];
              this.words[u] = d << 26 - s | f >>> s, d = f & i;
            }

            return c && 0 !== d && (c.words[c.length++] = d), 0 === this.length && (this.words[0] = 0, this.length = 1), this.strip();
          }, s.prototype.ishrn = function (e, t, a) {
            return r(0 === this.negative), this.iushrn(e, t, a);
          }, s.prototype.shln = function (e) {
            return this.clone().ishln(e);
          }, s.prototype.ushln = function (e) {
            return this.clone().iushln(e);
          }, s.prototype.shrn = function (e) {
            return this.clone().ishrn(e);
          }, s.prototype.ushrn = function (e) {
            return this.clone().iushrn(e);
          }, s.prototype.testn = function (e) {
            r("number" == typeof e && 0 <= e);
            var t = e % 26,
                a = (e - t) / 26,
                n = 1 << t;
            return !(this.length <= a || !(this.words[a] & n));
          }, s.prototype.imaskn = function (e) {
            r("number" == typeof e && 0 <= e);
            var t = e % 26,
                a = (e - t) / 26;
            if (r(0 === this.negative, "imaskn works only with positive numbers"), this.length <= a) return this;

            if (0 != t && a++, this.length = Math.min(a, this.length), 0 != t) {
              var n = 67108863 ^ 67108863 >>> t << t;
              this.words[this.length - 1] &= n;
            }

            return this.strip();
          }, s.prototype.maskn = function (e) {
            return this.clone().imaskn(e);
          }, s.prototype.iaddn = function (e) {
            return r("number" == typeof e), r(e < 67108864), e < 0 ? this.isubn(-e) : 0 !== this.negative ? (1 === this.length && (0 | this.words[0]) < e ? (this.words[0] = e - (0 | this.words[0]), this.negative = 0) : (this.negative = 0, this.isubn(e), this.negative = 1), this) : this._iaddn(e);
          }, s.prototype._iaddn = function (e) {
            this.words[0] += e;

            for (var t = 0; t < this.length && 67108864 <= this.words[t]; t++) {
              this.words[t] -= 67108864, t === this.length - 1 ? this.words[t + 1] = 1 : this.words[t + 1]++;
            }

            return this.length = Math.max(this.length, t + 1), this;
          }, s.prototype.isubn = function (e) {
            if (r("number" == typeof e), r(e < 67108864), e < 0) return this.iaddn(-e);
            if (0 !== this.negative) return this.negative = 0, this.iaddn(e), this.negative = 1, this;
            if (this.words[0] -= e, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;else for (var t = 0; t < this.length && this.words[t] < 0; t++) {
              this.words[t] += 67108864, this.words[t + 1] -= 1;
            }
            return this.strip();
          }, s.prototype.addn = function (e) {
            return this.clone().iaddn(e);
          }, s.prototype.subn = function (e) {
            return this.clone().isubn(e);
          }, s.prototype.iabs = function () {
            return this.negative = 0, this;
          }, s.prototype.abs = function () {
            return this.clone().iabs();
          }, s.prototype._ishlnsubmul = function (e, t, a) {
            var n,
                s,
                o = e.length + a;

            this._expand(o);

            var i = 0;

            for (n = 0; n < e.length; n++) {
              s = (0 | this.words[n + a]) + i;
              var c = (0 | e.words[n]) * t;
              i = ((s -= 67108863 & c) >> 26) - (c / 67108864 | 0), this.words[n + a] = 67108863 & s;
            }

            for (; n < this.length - a; n++) {
              i = (s = (0 | this.words[n + a]) + i) >> 26, this.words[n + a] = 67108863 & s;
            }

            if (0 === i) return this.strip();

            for (r(-1 === i), n = i = 0; n < this.length; n++) {
              i = (s = -(0 | this.words[n]) + i) >> 26, this.words[n] = 67108863 & s;
            }

            return this.negative = 1, this.strip();
          }, s.prototype._wordDiv = function (e, t) {
            var a = (this.length, e.length),
                r = this.clone(),
                n = e,
                o = 0 | n.words[n.length - 1];
            0 != (a = 26 - this._countBits(o)) && (n = n.ushln(a), r.iushln(a), o = 0 | n.words[n.length - 1]);
            var i,
                c = r.length - n.length;

            if ("mod" !== t) {
              (i = new s(null)).length = 1 + c, i.words = new Array(i.length);

              for (var u = 0; u < i.length; u++) {
                i.words[u] = 0;
              }
            }

            var d = r.clone()._ishlnsubmul(n, 1, c);

            0 === d.negative && (r = d, i && (i.words[c] = 1));

            for (var f = c - 1; 0 <= f; f--) {
              var l = 67108864 * (0 | r.words[n.length + f]) + (0 | r.words[n.length + f - 1]);

              for (l = Math.min(l / o | 0, 67108863), r._ishlnsubmul(n, l, f); 0 !== r.negative;) {
                l--, r.negative = 0, r._ishlnsubmul(n, 1, f), r.isZero() || (r.negative ^= 1);
              }

              i && (i.words[f] = l);
            }

            return i && i.strip(), r.strip(), "div" !== t && 0 != a && r.iushrn(a), {
              div: i || null,
              mod: r
            };
          }, s.prototype.divmod = function (e, t, a) {
            return r(!e.isZero()), this.isZero() ? {
              div: new s(0),
              mod: new s(0)
            } : 0 !== this.negative && 0 === e.negative ? (i = this.neg().divmod(e, t), "mod" !== t && (n = i.div.neg()), "div" !== t && (o = i.mod.neg(), a && 0 !== o.negative && o.iadd(e)), {
              div: n,
              mod: o
            }) : 0 === this.negative && 0 !== e.negative ? (i = this.divmod(e.neg(), t), "mod" !== t && (n = i.div.neg()), {
              div: n,
              mod: i.mod
            }) : 0 != (this.negative & e.negative) ? (i = this.neg().divmod(e.neg(), t), "div" !== t && (o = i.mod.neg(), a && 0 !== o.negative && o.isub(e)), {
              div: i.div,
              mod: o
            }) : e.length > this.length || this.cmp(e) < 0 ? {
              div: new s(0),
              mod: this
            } : 1 === e.length ? "div" === t ? {
              div: this.divn(e.words[0]),
              mod: null
            } : "mod" === t ? {
              div: null,
              mod: new s(this.modn(e.words[0]))
            } : {
              div: this.divn(e.words[0]),
              mod: new s(this.modn(e.words[0]))
            } : this._wordDiv(e, t);
            var n, o, i;
          }, s.prototype.div = function (e) {
            return this.divmod(e, "div", !1).div;
          }, s.prototype.mod = function (e) {
            return this.divmod(e, "mod", !1).mod;
          }, s.prototype.umod = function (e) {
            return this.divmod(e, "mod", !0).mod;
          }, s.prototype.divRound = function (e) {
            var t = this.divmod(e);
            if (t.mod.isZero()) return t.div;
            var a = 0 !== t.div.negative ? t.mod.isub(e) : t.mod,
                r = e.ushrn(1),
                n = e.andln(1),
                s = a.cmp(r);
            return s < 0 || 1 === n && 0 === s ? t.div : 0 !== t.div.negative ? t.div.isubn(1) : t.div.iaddn(1);
          }, s.prototype.modn = function (e) {
            r(e <= 67108863);

            for (var t = (1 << 26) % e, a = 0, n = this.length - 1; 0 <= n; n--) {
              a = (t * a + (0 | this.words[n])) % e;
            }

            return a;
          }, s.prototype.idivn = function (e) {
            r(e <= 67108863);

            for (var t = 0, a = this.length - 1; 0 <= a; a--) {
              var n = (0 | this.words[a]) + 67108864 * t;
              this.words[a] = n / e | 0, t = n % e;
            }

            return this.strip();
          }, s.prototype.divn = function (e) {
            return this.clone().idivn(e);
          }, s.prototype.egcd = function (e) {
            r(0 === e.negative), r(!e.isZero());
            var t = this,
                a = e.clone();
            t = 0 !== t.negative ? t.umod(e) : t.clone();

            for (var n = new s(1), o = new s(0), i = new s(0), c = new s(1), u = 0; t.isEven() && a.isEven();) {
              t.iushrn(1), a.iushrn(1), ++u;
            }

            for (var d = a.clone(), f = t.clone(); !t.isZero();) {
              for (var l = 0, h = 1; 0 == (t.words[0] & h) && l < 26; ++l, h <<= 1) {
                ;
              }

              if (0 < l) for (t.iushrn(l); 0 < l--;) {
                (n.isOdd() || o.isOdd()) && (n.iadd(d), o.isub(f)), n.iushrn(1), o.iushrn(1);
              }

              for (var p = 0, b = 1; 0 == (a.words[0] & b) && p < 26; ++p, b <<= 1) {
                ;
              }

              if (0 < p) for (a.iushrn(p); 0 < p--;) {
                (i.isOdd() || c.isOdd()) && (i.iadd(d), c.isub(f)), i.iushrn(1), c.iushrn(1);
              }
              0 <= t.cmp(a) ? (t.isub(a), n.isub(i), o.isub(c)) : (a.isub(t), i.isub(n), c.isub(o));
            }

            return {
              a: i,
              b: c,
              gcd: a.iushln(u)
            };
          }, s.prototype._invmp = function (e) {
            r(0 === e.negative), r(!e.isZero());
            var t = this,
                a = e.clone();
            t = 0 !== t.negative ? t.umod(e) : t.clone();

            for (var n, o = new s(1), i = new s(0), c = a.clone(); 0 < t.cmpn(1) && 0 < a.cmpn(1);) {
              for (var u = 0, d = 1; 0 == (t.words[0] & d) && u < 26; ++u, d <<= 1) {
                ;
              }

              if (0 < u) for (t.iushrn(u); 0 < u--;) {
                o.isOdd() && o.iadd(c), o.iushrn(1);
              }

              for (var f = 0, l = 1; 0 == (a.words[0] & l) && f < 26; ++f, l <<= 1) {
                ;
              }

              if (0 < f) for (a.iushrn(f); 0 < f--;) {
                i.isOdd() && i.iadd(c), i.iushrn(1);
              }
              0 <= t.cmp(a) ? (t.isub(a), o.isub(i)) : (a.isub(t), i.isub(o));
            }

            return (n = 0 === t.cmpn(1) ? o : i).cmpn(0) < 0 && n.iadd(e), n;
          }, s.prototype.gcd = function (e) {
            if (this.isZero()) return e.abs();
            if (e.isZero()) return this.abs();
            var t = this.clone(),
                a = e.clone();
            t.negative = 0;

            for (var r = a.negative = 0; t.isEven() && a.isEven(); r++) {
              t.iushrn(1), a.iushrn(1);
            }

            for (;;) {
              for (; t.isEven();) {
                t.iushrn(1);
              }

              for (; a.isEven();) {
                a.iushrn(1);
              }

              var n = t.cmp(a);

              if (n < 0) {
                var s = t;
                t = a, a = s;
              } else if (0 === n || 0 === a.cmpn(1)) break;

              t.isub(a);
            }

            return a.iushln(r);
          }, s.prototype.invm = function (e) {
            return this.egcd(e).a.umod(e);
          }, s.prototype.isEven = function () {
            return 0 == (1 & this.words[0]);
          }, s.prototype.isOdd = function () {
            return 1 == (1 & this.words[0]);
          }, s.prototype.andln = function (e) {
            return this.words[0] & e;
          }, s.prototype.bincn = function (e) {
            r("number" == typeof e);
            var t = e % 26,
                a = (e - t) / 26,
                n = 1 << t;
            if (this.length <= a) return this._expand(1 + a), this.words[a] |= n, this;

            for (var s = n, o = a; 0 !== s && o < this.length; o++) {
              var i = 0 | this.words[o];
              s = (i += s) >>> 26, i &= 67108863, this.words[o] = i;
            }

            return 0 !== s && (this.words[o] = s, this.length++), this;
          }, s.prototype.isZero = function () {
            return 1 === this.length && 0 === this.words[0];
          }, s.prototype.cmpn = function (e) {
            var t,
                a = e < 0;
            if (0 !== this.negative && !a) return -1;
            if (0 === this.negative && a) return 1;
            if (this.strip(), 1 < this.length) t = 1;else {
              a && (e = -e), r(e <= 67108863, "Number is too big");
              var n = 0 | this.words[0];
              t = n === e ? 0 : n < e ? -1 : 1;
            }
            return 0 !== this.negative ? 0 | -t : t;
          }, s.prototype.cmp = function (e) {
            if (0 !== this.negative && 0 === e.negative) return -1;
            if (0 === this.negative && 0 !== e.negative) return 1;
            var t = this.ucmp(e);
            return 0 !== this.negative ? 0 | -t : t;
          }, s.prototype.ucmp = function (e) {
            if (this.length > e.length) return 1;
            if (this.length < e.length) return -1;

            for (var t = 0, a = this.length - 1; 0 <= a; a--) {
              var r = 0 | this.words[a],
                  n = 0 | e.words[a];

              if (r != n) {
                r < n ? t = -1 : n < r && (t = 1);
                break;
              }
            }

            return t;
          }, s.prototype.gtn = function (e) {
            return 1 === this.cmpn(e);
          }, s.prototype.gt = function (e) {
            return 1 === this.cmp(e);
          }, s.prototype.gten = function (e) {
            return 0 <= this.cmpn(e);
          }, s.prototype.gte = function (e) {
            return 0 <= this.cmp(e);
          }, s.prototype.ltn = function (e) {
            return -1 === this.cmpn(e);
          }, s.prototype.lt = function (e) {
            return -1 === this.cmp(e);
          }, s.prototype.lten = function (e) {
            return this.cmpn(e) <= 0;
          }, s.prototype.lte = function (e) {
            return this.cmp(e) <= 0;
          }, s.prototype.eqn = function (e) {
            return 0 === this.cmpn(e);
          }, s.prototype.eq = function (e) {
            return 0 === this.cmp(e);
          }, s.red = function (e) {
            return new w(e);
          }, s.prototype.toRed = function (e) {
            return r(!this.red, "Already a number in reduction context"), r(0 === this.negative, "red works only with positives"), e.convertTo(this)._forceRed(e);
          }, s.prototype.fromRed = function () {
            return r(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
          }, s.prototype._forceRed = function (e) {
            return this.red = e, this;
          }, s.prototype.forceRed = function (e) {
            return r(!this.red, "Already a number in reduction context"), this._forceRed(e);
          }, s.prototype.redAdd = function (e) {
            return r(this.red, "redAdd works only with red numbers"), this.red.add(this, e);
          }, s.prototype.redIAdd = function (e) {
            return r(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, e);
          }, s.prototype.redSub = function (e) {
            return r(this.red, "redSub works only with red numbers"), this.red.sub(this, e);
          }, s.prototype.redISub = function (e) {
            return r(this.red, "redISub works only with red numbers"), this.red.isub(this, e);
          }, s.prototype.redShl = function (e) {
            return r(this.red, "redShl works only with red numbers"), this.red.shl(this, e);
          }, s.prototype.redMul = function (e) {
            return r(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.mul(this, e);
          }, s.prototype.redIMul = function (e) {
            return r(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.imul(this, e);
          }, s.prototype.redSqr = function () {
            return r(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
          }, s.prototype.redISqr = function () {
            return r(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
          }, s.prototype.redSqrt = function () {
            return r(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
          }, s.prototype.redInvm = function () {
            return r(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
          }, s.prototype.redNeg = function () {
            return r(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
          }, s.prototype.redPow = function (e) {
            return r(this.red && !e.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, e);
          };
          var m = {
            k256: null,
            p224: null,
            p192: null,
            p25519: null
          };

          function y(e, t) {
            this.name = e, this.p = new s(t, 16), this.n = this.p.bitLength(), this.k = new s(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
          }

          function v() {
            y.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
          }

          function _() {
            y.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
          }

          function g() {
            y.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
          }

          function A() {
            y.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
          }

          function w(e) {
            if ("string" == typeof e) {
              var t = s._prime(e);

              this.m = t.p, this.prime = t;
            } else r(e.gtn(1), "modulus must be greater than 1"), this.m = e, this.prime = null;
          }

          function T(e) {
            w.call(this, e), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new s(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
          }

          y.prototype._tmp = function () {
            var e = new s(null);
            return e.words = new Array(Math.ceil(this.n / 13)), e;
          }, y.prototype.ireduce = function (e) {
            for (var t, a = e; this.split(a, this.tmp), (t = (a = (a = this.imulK(a)).iadd(this.tmp)).bitLength()) > this.n;) {
              ;
            }

            var r = t < this.n ? -1 : a.ucmp(this.p);
            return 0 === r ? (a.words[0] = 0, a.length = 1) : 0 < r ? a.isub(this.p) : a.strip(), a;
          }, y.prototype.split = function (e, t) {
            e.iushrn(this.n, 0, t);
          }, y.prototype.imulK = function (e) {
            return e.imul(this.k);
          }, n(v, y), v.prototype.split = function (e, t) {
            for (var a = Math.min(e.length, 9), r = 0; r < a; r++) {
              t.words[r] = e.words[r];
            }

            if (t.length = a, e.length <= 9) return e.words[0] = 0, void (e.length = 1);
            var n = e.words[9];

            for (t.words[t.length++] = 4194303 & n, r = 10; r < e.length; r++) {
              var s = 0 | e.words[r];
              e.words[r - 10] = (4194303 & s) << 4 | n >>> 22, n = s;
            }

            n >>>= 22, 0 === (e.words[r - 10] = n) && 10 < e.length ? e.length -= 10 : e.length -= 9;
          }, v.prototype.imulK = function (e) {
            e.words[e.length] = 0, e.words[e.length + 1] = 0, e.length += 2;

            for (var t = 0, a = 0; a < e.length; a++) {
              var r = 0 | e.words[a];
              t += 977 * r, e.words[a] = 67108863 & t, t = 64 * r + (t / 67108864 | 0);
            }

            return 0 === e.words[e.length - 1] && (e.length--, 0 === e.words[e.length - 1] && e.length--), e;
          }, n(_, y), n(g, y), n(A, y), A.prototype.imulK = function (e) {
            for (var t = 0, a = 0; a < e.length; a++) {
              var r = 19 * (0 | e.words[a]) + t,
                  n = 67108863 & r;
              r >>>= 26, e.words[a] = n, t = r;
            }

            return 0 !== t && (e.words[e.length++] = t), e;
          }, s._prime = function (e) {
            if (m[e]) return m[e];
            var t;
            if ("k256" === e) t = new v();else if ("p224" === e) t = new _();else if ("p192" === e) t = new g();else {
              if ("p25519" !== e) throw new Error("Unknown prime " + e);
              t = new A();
            }
            return m[e] = t;
          }, w.prototype._verify1 = function (e) {
            r(0 === e.negative, "red works only with positives"), r(e.red, "red works only with red numbers");
          }, w.prototype._verify2 = function (e, t) {
            r(0 == (e.negative | t.negative), "red works only with positives"), r(e.red && e.red === t.red, "red works only with red numbers");
          }, w.prototype.imod = function (e) {
            return this.prime ? this.prime.ireduce(e)._forceRed(this) : e.umod(this.m)._forceRed(this);
          }, w.prototype.neg = function (e) {
            return e.isZero() ? e.clone() : this.m.sub(e)._forceRed(this);
          }, w.prototype.add = function (e, t) {
            this._verify2(e, t);

            var a = e.add(t);
            return 0 <= a.cmp(this.m) && a.isub(this.m), a._forceRed(this);
          }, w.prototype.iadd = function (e, t) {
            this._verify2(e, t);

            var a = e.iadd(t);
            return 0 <= a.cmp(this.m) && a.isub(this.m), a;
          }, w.prototype.sub = function (e, t) {
            this._verify2(e, t);

            var a = e.sub(t);
            return a.cmpn(0) < 0 && a.iadd(this.m), a._forceRed(this);
          }, w.prototype.isub = function (e, t) {
            this._verify2(e, t);

            var a = e.isub(t);
            return a.cmpn(0) < 0 && a.iadd(this.m), a;
          }, w.prototype.shl = function (e, t) {
            return this._verify1(e), this.imod(e.ushln(t));
          }, w.prototype.imul = function (e, t) {
            return this._verify2(e, t), this.imod(e.imul(t));
          }, w.prototype.mul = function (e, t) {
            return this._verify2(e, t), this.imod(e.mul(t));
          }, w.prototype.isqr = function (e) {
            return this.imul(e, e.clone());
          }, w.prototype.sqr = function (e) {
            return this.mul(e, e);
          }, w.prototype.sqrt = function (e) {
            if (e.isZero()) return e.clone();
            var t = this.m.andln(3);

            if (r(t % 2 == 1), 3 === t) {
              var a = this.m.add(new s(1)).iushrn(2);
              return this.pow(e, a);
            }

            for (var n = this.m.subn(1), o = 0; !n.isZero() && 0 === n.andln(1);) {
              o++, n.iushrn(1);
            }

            r(!n.isZero());
            var i = new s(1).toRed(this),
                c = i.redNeg(),
                u = this.m.subn(1).iushrn(1),
                d = this.m.bitLength();

            for (d = new s(2 * d * d).toRed(this); 0 !== this.pow(d, u).cmp(c);) {
              d.redIAdd(c);
            }

            for (var f = this.pow(d, n), l = this.pow(e, n.addn(1).iushrn(1)), h = this.pow(e, n), p = o; 0 !== h.cmp(i);) {
              for (var b = h, m = 0; 0 !== b.cmp(i); m++) {
                b = b.redSqr();
              }

              r(m < p);
              var y = this.pow(f, new s(1).iushln(p - m - 1));
              l = l.redMul(y), f = y.redSqr(), h = h.redMul(f), p = m;
            }

            return l;
          }, w.prototype.invm = function (e) {
            var t = e._invmp(this.m);

            return 0 !== t.negative ? (t.negative = 0, this.imod(t).redNeg()) : this.imod(t);
          }, w.prototype.pow = function (e, t) {
            if (t.isZero()) return new s(1).toRed(this);
            if (0 === t.cmpn(1)) return e.clone();
            var a = new Array(16);
            a[0] = new s(1).toRed(this), a[1] = e;

            for (var r = 2; r < a.length; r++) {
              a[r] = this.mul(a[r - 1], e);
            }

            var n = a[0],
                o = 0,
                i = 0,
                c = t.bitLength() % 26;

            for (0 === c && (c = 26), r = t.length - 1; 0 <= r; r--) {
              for (var u = t.words[r], d = c - 1; 0 <= d; d--) {
                var f = u >> d & 1;
                n !== a[0] && (n = this.sqr(n)), 0 != f || 0 !== o ? (o <<= 1, o |= f, (4 == ++i || 0 === r && 0 === d) && (n = this.mul(n, a[o]), o = i = 0)) : i = 0;
              }

              c = 26;
            }

            return n;
          }, w.prototype.convertTo = function (e) {
            var t = e.umod(this.m);
            return t === e ? t.clone() : t;
          }, w.prototype.convertFrom = function (e) {
            var t = e.clone();
            return t.red = null, t;
          }, s.mont = function (e) {
            return new T(e);
          }, n(T, w), T.prototype.convertTo = function (e) {
            return this.imod(e.ushln(this.shift));
          }, T.prototype.convertFrom = function (e) {
            var t = this.imod(e.mul(this.rinv));
            return t.red = null, t;
          }, T.prototype.imul = function (e, t) {
            if (e.isZero() || t.isZero()) return e.words[0] = 0, e.length = 1, e;
            var a = e.imul(t),
                r = a.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
                n = a.isub(r).iushrn(this.shift),
                s = n;
            return 0 <= n.cmp(this.m) ? s = n.isub(this.m) : n.cmpn(0) < 0 && (s = n.iadd(this.m)), s._forceRed(this);
          }, T.prototype.mul = function (e, t) {
            if (e.isZero() || t.isZero()) return new s(0)._forceRed(this);
            var a = e.mul(t),
                r = a.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
                n = a.isub(r).iushrn(this.shift),
                o = n;
            return 0 <= n.cmp(this.m) ? o = n.isub(this.m) : n.cmpn(0) < 0 && (o = n.iadd(this.m)), o._forceRed(this);
          }, T.prototype.invm = function (e) {
            return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this);
          };
        }(void 0 === t || t, this);
      }, {
        buffer: 11
      }],
      10: [function (e, a, r) {
        (function (e) {
          a.exports = function (t) {
            var a = new Uint8Array(t);
            return (e.crypto || e.msCrypto).getRandomValues(a), a;
          };
        }).call(this, void 0 !== t ? t : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
      }, {}],
      11: [function (e, t, a) {}, {}],
      12: [function (e, t, a) {
        "use strict";

        var r = a;
        r.version = e("../package.json").version, r.utils = e("./elliptic/utils"), r.rand = e("brorand"), r.hmacDRBG = e("./elliptic/hmac-drbg"), r.curve = e("./elliptic/curve"), r.curves = e("./elliptic/curves"), r.ec = e("./elliptic/ec"), r.eddsa = e("./elliptic/eddsa");
      }, {
        "../package.json": 26,
        "./elliptic/curve": 15,
        "./elliptic/curves": 18,
        "./elliptic/ec": 19,
        "./elliptic/eddsa": 22,
        "./elliptic/hmac-drbg": 23,
        "./elliptic/utils": 25,
        brorand: 10
      }],
      13: [function (e, t, a) {
        "use strict";

        var r = e("bn.js"),
            n = e("../../elliptic").utils,
            s = n.getNAF,
            o = n.getJSF,
            i = n.assert;

        function c(e, t) {
          this.type = e, this.p = new r(t.p, 16), this.red = t.prime ? r.red(t.prime) : r.mont(this.p), this.zero = new r(0).toRed(this.red), this.one = new r(1).toRed(this.red), this.two = new r(2).toRed(this.red), this.n = t.n && new r(t.n, 16), this.g = t.g && this.pointFromJSON(t.g, t.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4);
          var a = this.n && this.p.div(this.n);
          !a || 0 < a.cmpn(100) ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
        }

        function u(e, t) {
          this.curve = e, this.type = t, this.precomputed = null;
        }

        (t.exports = c).prototype.point = function () {
          throw new Error("Not implemented");
        }, c.prototype.validate = function () {
          throw new Error("Not implemented");
        }, c.prototype._fixedNafMul = function (e, t) {
          i(e.precomputed);

          var a = e._getDoubles(),
              r = s(t, 1),
              n = (1 << a.step + 1) - (a.step % 2 == 0 ? 2 : 1);

          n /= 3;

          for (var o = [], c = 0; c < r.length; c += a.step) {
            var u = 0;

            for (t = c + a.step - 1; c <= t; t--) {
              u = (u << 1) + r[t];
            }

            o.push(u);
          }

          for (var d = this.jpoint(null, null, null), f = this.jpoint(null, null, null), l = n; 0 < l; l--) {
            for (c = 0; c < o.length; c++) {
              (u = o[c]) === l ? f = f.mixedAdd(a.points[c]) : u === -l && (f = f.mixedAdd(a.points[c].neg()));
            }

            d = d.add(f);
          }

          return d.toP();
        }, c.prototype._wnafMul = function (e, t) {
          var a = 4,
              r = e._getNAFPoints(a);

          a = r.wnd;

          for (var n = r.points, o = s(t, a), c = this.jpoint(null, null, null), u = o.length - 1; 0 <= u; u--) {
            for (t = 0; 0 <= u && 0 === o[u]; u--) {
              t++;
            }

            if (0 <= u && t++, c = c.dblp(t), u < 0) break;
            var d = o[u];
            i(0 !== d), c = "affine" === e.type ? 0 < d ? c.mixedAdd(n[d - 1 >> 1]) : c.mixedAdd(n[-d - 1 >> 1].neg()) : 0 < d ? c.add(n[d - 1 >> 1]) : c.add(n[-d - 1 >> 1].neg());
          }

          return "affine" === e.type ? c.toP() : c;
        }, c.prototype._wnafMulAdd = function (e, t, a, r, n) {
          for (var i = this._wnafT1, c = this._wnafT2, u = this._wnafT3, d = 0, f = 0; f < r; f++) {
            var l = (D = t[f])._getNAFPoints(e);

            i[f] = l.wnd, c[f] = l.points;
          }

          for (f = r - 1; 1 <= f; f -= 2) {
            var h = f - 1,
                p = f;

            if (1 === i[h] && 1 === i[p]) {
              var b = [t[h], null, null, t[p]];
              0 === t[h].y.cmp(t[p].y) ? (b[1] = t[h].add(t[p]), b[2] = t[h].toJ().mixedAdd(t[p].neg())) : 0 === t[h].y.cmp(t[p].y.redNeg()) ? (b[1] = t[h].toJ().mixedAdd(t[p]), b[2] = t[h].add(t[p].neg())) : (b[1] = t[h].toJ().mixedAdd(t[p]), b[2] = t[h].toJ().mixedAdd(t[p].neg()));
              var m = [-3, -1, -5, -7, 0, 7, 5, 1, 3],
                  y = o(a[h], a[p]);
              d = Math.max(y[0].length, d), u[h] = new Array(d), u[p] = new Array(d);

              for (var v = 0; v < d; v++) {
                var _ = 0 | y[0][v],
                    g = 0 | y[1][v];

                u[h][v] = m[3 * (1 + _) + (1 + g)], u[p][v] = 0, c[h] = b;
              }
            } else u[h] = s(a[h], i[h]), u[p] = s(a[p], i[p]), d = Math.max(u[h].length, d), d = Math.max(u[p].length, d);
          }

          var A = this.jpoint(null, null, null),
              w = this._wnafT4;

          for (f = d; 0 <= f; f--) {
            for (var T = 0; 0 <= f;) {
              var x = !0;

              for (v = 0; v < r; v++) {
                w[v] = 0 | u[v][f], 0 !== w[v] && (x = !1);
              }

              if (!x) break;
              T++, f--;
            }

            if (0 <= f && T++, A = A.dblp(T), f < 0) break;

            for (v = 0; v < r; v++) {
              var D,
                  C = w[v];
              0 !== C && (0 < C ? D = c[v][C - 1 >> 1] : C < 0 && (D = c[v][-C - 1 >> 1].neg()), A = "affine" === D.type ? A.mixedAdd(D) : A.add(D));
            }
          }

          for (f = 0; f < r; f++) {
            c[f] = null;
          }

          return n ? A : A.toP();
        }, (c.BasePoint = u).prototype.eq = function () {
          throw new Error("Not implemented");
        }, u.prototype.validate = function () {
          return this.curve.validate(this);
        }, c.prototype.decodePoint = function (e, t) {
          e = n.toArray(e, t);
          var a = this.p.byteLength();
          if ((4 === e[0] || 6 === e[0] || 7 === e[0]) && e.length - 1 == 2 * a) return 6 === e[0] ? i(e[e.length - 1] % 2 == 0) : 7 === e[0] && i(e[e.length - 1] % 2 == 1), this.point(e.slice(1, 1 + a), e.slice(1 + a, 1 + 2 * a));
          if ((2 === e[0] || 3 === e[0]) && e.length - 1 === a) return this.pointFromX(e.slice(1, 1 + a), 3 === e[0]);
          throw new Error("Unknown point format");
        }, u.prototype.encodeCompressed = function (e) {
          return this.encode(e, !0);
        }, u.prototype._encode = function (e) {
          var t = this.curve.p.byteLength(),
              a = this.getX().toArray("be", t);
          return e ? [this.getY().isEven() ? 2 : 3].concat(a) : [4].concat(a, this.getY().toArray("be", t));
        }, u.prototype.encode = function (e, t) {
          return n.encode(this._encode(t), e);
        }, u.prototype.precompute = function (e) {
          if (this.precomputed) return this;
          var t = {
            doubles: null,
            naf: null,
            beta: null
          };
          return t.naf = this._getNAFPoints(8), t.doubles = this._getDoubles(4, e), t.beta = this._getBeta(), this.precomputed = t, this;
        }, u.prototype._hasDoubles = function (e) {
          if (!this.precomputed) return !1;
          var t = this.precomputed.doubles;
          return !!t && t.points.length >= Math.ceil((e.bitLength() + 1) / t.step);
        }, u.prototype._getDoubles = function (e, t) {
          if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;

          for (var a = [this], r = this, n = 0; n < t; n += e) {
            for (var s = 0; s < e; s++) {
              r = r.dbl();
            }

            a.push(r);
          }

          return {
            step: e,
            points: a
          };
        }, u.prototype._getNAFPoints = function (e) {
          if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;

          for (var t = [this], a = (1 << e) - 1, r = 1 == a ? null : this.dbl(), n = 1; n < a; n++) {
            t[n] = t[n - 1].add(r);
          }

          return {
            wnd: e,
            points: t
          };
        }, u.prototype._getBeta = function () {
          return null;
        }, u.prototype.dblp = function (e) {
          for (var t = this, a = 0; a < e; a++) {
            t = t.dbl();
          }

          return t;
        };
      }, {
        "../../elliptic": 12,
        "bn.js": 9
      }],
      14: [function (e, t, a) {
        t.exports = {};
      }, {}],
      15: [function (e, t, a) {
        "use strict";

        var r = a;
        r.base = e("./base"), r.short = e("./short"), r.mont = e("./mont"), r.edwards = e("./edwards");
      }, {
        "./base": 13,
        "./edwards": 14,
        "./mont": 16,
        "./short": 17
      }],
      16: [function (e, t, a) {
        arguments[4][14][0].apply(a, arguments);
      }, {
        dup: 14
      }],
      17: [function (e, t, a) {
        "use strict";

        var r = e("../curve"),
            n = e("../../elliptic"),
            s = e("bn.js"),
            o = e("inherits"),
            i = r.base,
            c = n.utils.assert;

        function u(e) {
          i.call(this, "short", e), this.a = new s(e.a, 16).toRed(this.red), this.b = new s(e.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = 0 === this.a.fromRed().cmpn(0), this.threeA = 0 === this.a.fromRed().sub(this.p).cmpn(-3), this.endo = this._getEndomorphism(e), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
        }

        function d(e, t, a, r) {
          i.BasePoint.call(this, e, "affine"), null === t && null === a ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new s(t, 16), this.y = new s(a, 16), r && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
        }

        function f(e, t, a, r) {
          i.BasePoint.call(this, e, "jacobian"), null === t && null === a && null === r ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new s(0)) : (this.x = new s(t, 16), this.y = new s(a, 16), this.z = new s(r, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
        }

        o(u, i), (t.exports = u).prototype._getEndomorphism = function (e) {
          if (this.zeroA && this.g && this.n && 1 === this.p.modn(3)) {
            var t, a;
            if (e.beta) t = new s(e.beta, 16).toRed(this.red);else {
              var r = this._getEndoRoots(this.p);

              t = (t = r[0].cmp(r[1]) < 0 ? r[0] : r[1]).toRed(this.red);
            }
            if (e.lambda) a = new s(e.lambda, 16);else {
              var n = this._getEndoRoots(this.n);

              0 === this.g.mul(n[0]).x.cmp(this.g.x.redMul(t)) ? a = n[0] : (a = n[1], c(0 === this.g.mul(a).x.cmp(this.g.x.redMul(t))));
            }
            return {
              beta: t,
              lambda: a,
              basis: e.basis ? e.basis.map(function (e) {
                return {
                  a: new s(e.a, 16),
                  b: new s(e.b, 16)
                };
              }) : this._getEndoBasis(a)
            };
          }
        }, u.prototype._getEndoRoots = function (e) {
          var t = e === this.p ? this.red : s.mont(e),
              a = new s(2).toRed(t).redInvm(),
              r = a.redNeg(),
              n = new s(3).toRed(t).redNeg().redSqrt().redMul(a);
          return [r.redAdd(n).fromRed(), r.redSub(n).fromRed()];
        }, u.prototype._getEndoBasis = function (e) {
          for (var t, a, r, n, o, i, c, u, d, f = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), l = e, h = this.n.clone(), p = new s(1), b = new s(0), m = new s(0), y = new s(1), v = 0; 0 !== l.cmpn(0);) {
            var _ = h.div(l);

            u = h.sub(_.mul(l)), d = m.sub(_.mul(p));
            var g = y.sub(_.mul(b));
            if (!r && u.cmp(f) < 0) t = c.neg(), a = p, r = u.neg(), n = d;else if (r && 2 == ++v) break;
            h = l, l = c = u, m = p, p = d, y = b, b = g;
          }

          o = u.neg(), i = d;
          var A = r.sqr().add(n.sqr());
          return 0 <= o.sqr().add(i.sqr()).cmp(A) && (o = t, i = a), r.negative && (r = r.neg(), n = n.neg()), o.negative && (o = o.neg(), i = i.neg()), [{
            a: r,
            b: n
          }, {
            a: o,
            b: i
          }];
        }, u.prototype._endoSplit = function (e) {
          var t = this.endo.basis,
              a = t[0],
              r = t[1],
              n = r.b.mul(e).divRound(this.n),
              s = a.b.neg().mul(e).divRound(this.n),
              o = n.mul(a.a),
              i = s.mul(r.a),
              c = n.mul(a.b),
              u = s.mul(r.b);
          return {
            k1: e.sub(o).sub(i),
            k2: c.add(u).neg()
          };
        }, u.prototype.pointFromX = function (e, t) {
          (e = new s(e, 16)).red || (e = e.toRed(this.red));
          var a = e.redSqr().redMul(e).redIAdd(e.redMul(this.a)).redIAdd(this.b),
              r = a.redSqrt();
          if (0 !== r.redSqr().redSub(a).cmp(this.zero)) throw new Error("invalid point");
          var n = r.fromRed().isOdd();
          return (t && !n || !t && n) && (r = r.redNeg()), this.point(e, r);
        }, u.prototype.validate = function (e) {
          if (e.inf) return !0;
          var t = e.x,
              a = e.y,
              r = this.a.redMul(t),
              n = t.redSqr().redMul(t).redIAdd(r).redIAdd(this.b);
          return 0 === a.redSqr().redISub(n).cmpn(0);
        }, u.prototype._endoWnafMulAdd = function (e, t, a) {
          for (var r = this._endoWnafT1, n = this._endoWnafT2, s = 0; s < e.length; s++) {
            var o = this._endoSplit(t[s]),
                i = e[s],
                c = i._getBeta();

            o.k1.negative && (o.k1.ineg(), i = i.neg(!0)), o.k2.negative && (o.k2.ineg(), c = c.neg(!0)), r[2 * s] = i, r[2 * s + 1] = c, n[2 * s] = o.k1, n[2 * s + 1] = o.k2;
          }

          for (var u = this._wnafMulAdd(1, r, n, 2 * s, a), d = 0; d < 2 * s; d++) {
            r[d] = null, n[d] = null;
          }

          return u;
        }, o(d, i.BasePoint), u.prototype.point = function (e, t, a) {
          return new d(this, e, t, a);
        }, u.prototype.pointFromJSON = function (e, t) {
          return d.fromJSON(this, e, t);
        }, d.prototype._getBeta = function () {
          if (this.curve.endo) {
            var e = this.precomputed;
            if (e && e.beta) return e.beta;
            var t = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);

            if (e) {
              var a = this.curve,
                  r = function r(e) {
                return a.point(e.x.redMul(a.endo.beta), e.y);
              };

              (e.beta = t).precomputed = {
                beta: null,
                naf: e.naf && {
                  wnd: e.naf.wnd,
                  points: e.naf.points.map(r)
                },
                doubles: e.doubles && {
                  step: e.doubles.step,
                  points: e.doubles.points.map(r)
                }
              };
            }

            return t;
          }
        }, d.prototype.toJSON = function () {
          return this.precomputed ? [this.x, this.y, this.precomputed && {
            doubles: this.precomputed.doubles && {
              step: this.precomputed.doubles.step,
              points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
              wnd: this.precomputed.naf.wnd,
              points: this.precomputed.naf.points.slice(1)
            }
          }] : [this.x, this.y];
        }, d.fromJSON = function (e, t, a) {
          "string" == typeof t && (t = JSON.parse(t));
          var r = e.point(t[0], t[1], a);
          if (!t[2]) return r;

          function n(t) {
            return e.point(t[0], t[1], a);
          }

          var s = t[2];
          return r.precomputed = {
            beta: null,
            doubles: s.doubles && {
              step: s.doubles.step,
              points: [r].concat(s.doubles.points.map(n))
            },
            naf: s.naf && {
              wnd: s.naf.wnd,
              points: [r].concat(s.naf.points.map(n))
            }
          }, r;
        }, d.prototype.inspect = function () {
          return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
        }, d.prototype.isInfinity = function () {
          return this.inf;
        }, d.prototype.add = function (e) {
          if (this.inf) return e;
          if (e.inf) return this;
          if (this.eq(e)) return this.dbl();
          if (this.neg().eq(e)) return this.curve.point(null, null);
          if (0 === this.x.cmp(e.x)) return this.curve.point(null, null);
          var t = this.y.redSub(e.y);
          0 !== t.cmpn(0) && (t = t.redMul(this.x.redSub(e.x).redInvm()));
          var a = t.redSqr().redISub(this.x).redISub(e.x),
              r = t.redMul(this.x.redSub(a)).redISub(this.y);
          return this.curve.point(a, r);
        }, d.prototype.dbl = function () {
          if (this.inf) return this;
          var e = this.y.redAdd(this.y);
          if (0 === e.cmpn(0)) return this.curve.point(null, null);
          var t = this.curve.a,
              a = this.x.redSqr(),
              r = e.redInvm(),
              n = a.redAdd(a).redIAdd(a).redIAdd(t).redMul(r),
              s = n.redSqr().redISub(this.x.redAdd(this.x)),
              o = n.redMul(this.x.redSub(s)).redISub(this.y);
          return this.curve.point(s, o);
        }, d.prototype.getX = function () {
          return this.x.fromRed();
        }, d.prototype.getY = function () {
          return this.y.fromRed();
        }, d.prototype.mul = function (e) {
          return e = new s(e, 16), this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [e]) : this.curve._wnafMul(this, e);
        }, d.prototype.mulAdd = function (e, t, a) {
          var r = [this, t],
              n = [e, a];
          return this.curve.endo ? this.curve._endoWnafMulAdd(r, n) : this.curve._wnafMulAdd(1, r, n, 2);
        }, d.prototype.jmulAdd = function (e, t, a) {
          var r = [this, t],
              n = [e, a];
          return this.curve.endo ? this.curve._endoWnafMulAdd(r, n, !0) : this.curve._wnafMulAdd(1, r, n, 2, !0);
        }, d.prototype.eq = function (e) {
          return this === e || this.inf === e.inf && (this.inf || 0 === this.x.cmp(e.x) && 0 === this.y.cmp(e.y));
        }, d.prototype.neg = function (e) {
          if (this.inf) return this;
          var t = this.curve.point(this.x, this.y.redNeg());

          if (e && this.precomputed) {
            var a = this.precomputed,
                r = function r(e) {
              return e.neg();
            };

            t.precomputed = {
              naf: a.naf && {
                wnd: a.naf.wnd,
                points: a.naf.points.map(r)
              },
              doubles: a.doubles && {
                step: a.doubles.step,
                points: a.doubles.points.map(r)
              }
            };
          }

          return t;
        }, d.prototype.toJ = function () {
          return this.inf ? this.curve.jpoint(null, null, null) : this.curve.jpoint(this.x, this.y, this.curve.one);
        }, o(f, i.BasePoint), u.prototype.jpoint = function (e, t, a) {
          return new f(this, e, t, a);
        }, f.prototype.toP = function () {
          if (this.isInfinity()) return this.curve.point(null, null);
          var e = this.z.redInvm(),
              t = e.redSqr(),
              a = this.x.redMul(t),
              r = this.y.redMul(t).redMul(e);
          return this.curve.point(a, r);
        }, f.prototype.neg = function () {
          return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
        }, f.prototype.add = function (e) {
          if (this.isInfinity()) return e;
          if (e.isInfinity()) return this;
          var t = e.z.redSqr(),
              a = this.z.redSqr(),
              r = this.x.redMul(t),
              n = e.x.redMul(a),
              s = this.y.redMul(t.redMul(e.z)),
              o = e.y.redMul(a.redMul(this.z)),
              i = r.redSub(n),
              c = s.redSub(o);
          if (0 === i.cmpn(0)) return 0 !== c.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
          var u = i.redSqr(),
              d = u.redMul(i),
              f = r.redMul(u),
              l = c.redSqr().redIAdd(d).redISub(f).redISub(f),
              h = c.redMul(f.redISub(l)).redISub(s.redMul(d)),
              p = this.z.redMul(e.z).redMul(i);
          return this.curve.jpoint(l, h, p);
        }, f.prototype.mixedAdd = function (e) {
          if (this.isInfinity()) return e.toJ();
          if (e.isInfinity()) return this;
          var t = this.z.redSqr(),
              a = this.x,
              r = e.x.redMul(t),
              n = this.y,
              s = e.y.redMul(t).redMul(this.z),
              o = a.redSub(r),
              i = n.redSub(s);
          if (0 === o.cmpn(0)) return 0 !== i.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
          var c = o.redSqr(),
              u = c.redMul(o),
              d = a.redMul(c),
              f = i.redSqr().redIAdd(u).redISub(d).redISub(d),
              l = i.redMul(d.redISub(f)).redISub(n.redMul(u)),
              h = this.z.redMul(o);
          return this.curve.jpoint(f, l, h);
        }, f.prototype.dblp = function (e) {
          if (0 === e) return this;
          if (this.isInfinity()) return this;
          if (!e) return this.dbl();

          if (this.curve.zeroA || this.curve.threeA) {
            for (var t = this, a = 0; a < e; a++) {
              t = t.dbl();
            }

            return t;
          }

          var r = this.curve.a,
              n = this.curve.tinv,
              s = this.x,
              o = this.y,
              i = this.z,
              c = i.redSqr().redSqr(),
              u = o.redAdd(o);

          for (a = 0; a < e; a++) {
            var d = s.redSqr(),
                f = u.redSqr(),
                l = f.redSqr(),
                h = d.redAdd(d).redIAdd(d).redIAdd(r.redMul(c)),
                p = s.redMul(f),
                b = h.redSqr().redISub(p.redAdd(p)),
                m = p.redISub(b),
                y = h.redMul(m);
            y = y.redIAdd(y).redISub(l);
            var v = u.redMul(i);
            a + 1 < e && (c = c.redMul(l)), s = b, i = v, u = y;
          }

          return this.curve.jpoint(s, u.redMul(n), i);
        }, f.prototype.dbl = function () {
          return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
        }, f.prototype._zeroDbl = function () {
          var e, t, a;

          if (this.zOne) {
            var r = this.x.redSqr(),
                n = this.y.redSqr(),
                s = n.redSqr(),
                o = this.x.redAdd(n).redSqr().redISub(r).redISub(s);
            o = o.redIAdd(o);
            var i = r.redAdd(r).redIAdd(r),
                c = i.redSqr().redISub(o).redISub(o),
                u = s.redIAdd(s);
            u = (u = u.redIAdd(u)).redIAdd(u), e = c, t = i.redMul(o.redISub(c)).redISub(u), a = this.y.redAdd(this.y);
          } else {
            var d = this.x.redSqr(),
                f = this.y.redSqr(),
                l = f.redSqr(),
                h = this.x.redAdd(f).redSqr().redISub(d).redISub(l);
            h = h.redIAdd(h);
            var p = d.redAdd(d).redIAdd(d),
                b = p.redSqr(),
                m = l.redIAdd(l);
            m = (m = m.redIAdd(m)).redIAdd(m), e = b.redISub(h).redISub(h), t = p.redMul(h.redISub(e)).redISub(m), a = (a = this.y.redMul(this.z)).redIAdd(a);
          }

          return this.curve.jpoint(e, t, a);
        }, f.prototype._threeDbl = function () {
          var e, t, a;

          if (this.zOne) {
            var r = this.x.redSqr(),
                n = this.y.redSqr(),
                s = n.redSqr(),
                o = this.x.redAdd(n).redSqr().redISub(r).redISub(s);
            o = o.redIAdd(o);
            var i = r.redAdd(r).redIAdd(r).redIAdd(this.curve.a),
                c = i.redSqr().redISub(o).redISub(o);
            e = c;
            var u = s.redIAdd(s);
            u = (u = u.redIAdd(u)).redIAdd(u), t = i.redMul(o.redISub(c)).redISub(u), a = this.y.redAdd(this.y);
          } else {
            var d = this.z.redSqr(),
                f = this.y.redSqr(),
                l = this.x.redMul(f),
                h = this.x.redSub(d).redMul(this.x.redAdd(d));
            h = h.redAdd(h).redIAdd(h);
            var p = l.redIAdd(l),
                b = (p = p.redIAdd(p)).redAdd(p);
            e = h.redSqr().redISub(b), a = this.y.redAdd(this.z).redSqr().redISub(f).redISub(d);
            var m = f.redSqr();
            m = (m = (m = m.redIAdd(m)).redIAdd(m)).redIAdd(m), t = h.redMul(p.redISub(e)).redISub(m);
          }

          return this.curve.jpoint(e, t, a);
        }, f.prototype._dbl = function () {
          var e = this.curve.a,
              t = this.x,
              a = this.y,
              r = this.z,
              n = r.redSqr().redSqr(),
              s = t.redSqr(),
              o = a.redSqr(),
              i = s.redAdd(s).redIAdd(s).redIAdd(e.redMul(n)),
              c = t.redAdd(t),
              u = (c = c.redIAdd(c)).redMul(o),
              d = i.redSqr().redISub(u.redAdd(u)),
              f = u.redISub(d),
              l = o.redSqr();
          l = (l = (l = l.redIAdd(l)).redIAdd(l)).redIAdd(l);
          var h = i.redMul(f).redISub(l),
              p = a.redAdd(a).redMul(r);
          return this.curve.jpoint(d, h, p);
        }, f.prototype.trpl = function () {
          if (!this.curve.zeroA) return this.dbl().add(this);
          var e = this.x.redSqr(),
              t = this.y.redSqr(),
              a = this.z.redSqr(),
              r = t.redSqr(),
              n = e.redAdd(e).redIAdd(e),
              s = n.redSqr(),
              o = this.x.redAdd(t).redSqr().redISub(e).redISub(r),
              i = (o = (o = (o = o.redIAdd(o)).redAdd(o).redIAdd(o)).redISub(s)).redSqr(),
              c = r.redIAdd(r);
          c = (c = (c = c.redIAdd(c)).redIAdd(c)).redIAdd(c);
          var u = n.redIAdd(o).redSqr().redISub(s).redISub(i).redISub(c),
              d = t.redMul(u);
          d = (d = d.redIAdd(d)).redIAdd(d);
          var f = this.x.redMul(i).redISub(d);
          f = (f = f.redIAdd(f)).redIAdd(f);
          var l = this.y.redMul(u.redMul(c.redISub(u)).redISub(o.redMul(i)));
          l = (l = (l = l.redIAdd(l)).redIAdd(l)).redIAdd(l);
          var h = this.z.redAdd(o).redSqr().redISub(a).redISub(i);
          return this.curve.jpoint(f, l, h);
        }, f.prototype.mul = function (e, t) {
          return e = new s(e, t), this.curve._wnafMul(this, e);
        }, f.prototype.eq = function (e) {
          if ("affine" === e.type) return this.eq(e.toJ());
          if (this === e) return !0;
          var t = this.z.redSqr(),
              a = e.z.redSqr();
          if (0 !== this.x.redMul(a).redISub(e.x.redMul(t)).cmpn(0)) return !1;
          var r = t.redMul(this.z),
              n = a.redMul(e.z);
          return 0 === this.y.redMul(n).redISub(e.y.redMul(r)).cmpn(0);
        }, f.prototype.eqXToP = function (e) {
          var t = this.z.redSqr(),
              a = e.toRed(this.curve.red).redMul(t);
          if (0 === this.x.cmp(a)) return !0;

          for (var r = e.clone(), n = this.curve.redN.redMul(t);;) {
            if (r.iadd(this.curve.n), 0 <= r.cmp(this.curve.p)) return !1;
            if (a.redIAdd(n), 0 === this.x.cmp(a)) return !0;
          }

          return !1;
        }, f.prototype.inspect = function () {
          return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
        }, f.prototype.isInfinity = function () {
          return 0 === this.z.cmpn(0);
        };
      }, {
        "../../elliptic": 12,
        "../curve": 15,
        "bn.js": 9,
        inherits: 39
      }],
      18: [function (e, t, a) {
        "use strict";

        var r,
            n = a,
            s = e("hash.js"),
            o = e("../elliptic"),
            i = o.utils.assert;

        function c(e) {
          "short" === e.type ? this.curve = new o.curve.short(e) : "edwards" === e.type ? this.curve = new o.curve.edwards(e) : this.curve = new o.curve.mont(e), this.g = this.curve.g, this.n = this.curve.n, this.hash = e.hash, i(this.g.validate(), "Invalid curve"), i(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
        }

        function u(e, t) {
          Object.defineProperty(n, e, {
            configurable: !0,
            enumerable: !0,
            get: function get() {
              var a = new c(t);
              return Object.defineProperty(n, e, {
                configurable: !0,
                enumerable: !0,
                value: a
              }), a;
            }
          });
        }

        n.PresetCurve = c, u("p192", {
          type: "short",
          prime: "p192",
          p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
          a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
          b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
          n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
          hash: s.sha256,
          gRed: !1,
          g: ["188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012", "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"]
        }), u("p224", {
          type: "short",
          prime: "p224",
          p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
          a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
          b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
          n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
          hash: s.sha256,
          gRed: !1,
          g: ["b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21", "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"]
        }), u("p256", {
          type: "short",
          prime: null,
          p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
          a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
          b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
          n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
          hash: s.sha256,
          gRed: !1,
          g: ["6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296", "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"]
        }), u("p384", {
          type: "short",
          prime: null,
          p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
          a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
          b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
          n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
          hash: s.sha384,
          gRed: !1,
          g: ["aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7", "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"]
        }), u("p521", {
          type: "short",
          prime: null,
          p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
          a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
          b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
          n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
          hash: s.sha512,
          gRed: !1,
          g: ["000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66", "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"]
        }), u("curve25519", {
          type: "mont",
          prime: "p25519",
          p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
          a: "76d06",
          b: "1",
          n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
          hash: s.sha256,
          gRed: !1,
          g: ["9"]
        }), u("ed25519", {
          type: "edwards",
          prime: "p25519",
          p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
          a: "-1",
          c: "1",
          d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
          n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
          hash: s.sha256,
          gRed: !1,
          g: ["216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a", "6666666666666666666666666666666666666666666666666666666666666658"]
        });

        try {
          r = e("./precomputed/secp256k1");
        } catch (e) {
          r = void 0;
        }

        u("secp256k1", {
          type: "short",
          prime: "k256",
          p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
          a: "0",
          b: "7",
          n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
          h: "1",
          hash: s.sha256,
          beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
          lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
          basis: [{
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
          }, {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
          }],
          gRed: !1,
          g: ["79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798", "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8", r]
        });
      }, {
        "../elliptic": 12,
        "./precomputed/secp256k1": 24,
        "hash.js": 27
      }],
      19: [function (e, t, a) {
        "use strict";

        var r = e("bn.js"),
            n = e("../../elliptic"),
            s = n.utils.assert,
            o = e("./key"),
            i = e("./signature");

        function c(e) {
          if (!(this instanceof c)) return new c(e);
          "string" == typeof e && (s(n.curves.hasOwnProperty(e), "Unknown curve " + e), e = n.curves[e]), e instanceof n.curves.PresetCurve && (e = {
            curve: e
          }), this.curve = e.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = e.curve.g, this.g.precompute(e.curve.n.bitLength() + 1), this.hash = e.hash || e.curve.hash;
        }

        (t.exports = c).prototype.keyPair = function (e) {
          return new o(this, e);
        }, c.prototype.keyFromPrivate = function (e, t) {
          return o.fromPrivate(this, e, t);
        }, c.prototype.keyFromPublic = function (e, t) {
          return o.fromPublic(this, e, t);
        }, c.prototype.genKeyPair = function (e) {
          e = e || {};

          for (var t = new n.hmacDRBG({
            hash: this.hash,
            pers: e.pers,
            entropy: e.entropy || n.rand(this.hash.hmacStrength),
            nonce: this.n.toArray()
          }), a = this.n.byteLength(), s = this.n.sub(new r(2));;) {
            var o = new r(t.generate(a));
            if (!(0 < o.cmp(s))) return o.iaddn(1), this.keyFromPrivate(o);
          }
        }, c.prototype._truncateToN = function (e, t) {
          var a = 8 * e.byteLength() - this.n.bitLength();
          return 0 < a && (e = e.ushrn(a)), !t && 0 <= e.cmp(this.n) ? e.sub(this.n) : e;
        }, c.prototype.sign = function (e, t, a, s) {
          "object" == typeof a && (s = a, a = null), s = s || {}, t = this.keyFromPrivate(t, a), e = this._truncateToN(new r(e, 16));

          for (var o = this.n.byteLength(), c = t.getPrivate().toArray("be", o), u = e.toArray("be", o), d = new n.hmacDRBG({
            hash: this.hash,
            entropy: c,
            nonce: u,
            pers: s.pers,
            persEnc: s.persEnc
          }), f = this.n.sub(new r(1)), l = 0;; l++) {
            var h = s.k ? s.k(l) : new r(d.generate(this.n.byteLength()));

            if (!((h = this._truncateToN(h, !0)).cmpn(1) <= 0 || 0 <= h.cmp(f))) {
              var p = this.g.mul(h);

              if (!p.isInfinity()) {
                var b = p.getX(),
                    m = b.umod(this.n);

                if (0 !== m.cmpn(0)) {
                  var y = h.invm(this.n).mul(m.mul(t.getPrivate()).iadd(e));

                  if (0 !== (y = y.umod(this.n)).cmpn(0)) {
                    var v = (p.getY().isOdd() ? 1 : 0) | (0 !== b.cmp(m) ? 2 : 0);
                    return s.canonical && 0 < y.cmp(this.nh) && (y = this.n.sub(y), v ^= 1), new i({
                      r: m,
                      s: y,
                      recoveryParam: v
                    });
                  }
                }
              }
            }
          }
        }, c.prototype.verify = function (e, t, a, n) {
          e = this._truncateToN(new r(e, 16)), a = this.keyFromPublic(a, n);
          var s = (t = new i(t, "hex")).r,
              o = t.s;
          if (s.cmpn(1) < 0 || 0 <= s.cmp(this.n)) return !1;
          if (o.cmpn(1) < 0 || 0 <= o.cmp(this.n)) return !1;
          var c,
              u = o.invm(this.n),
              d = u.mul(e).umod(this.n),
              f = u.mul(s).umod(this.n);
          return this.curve._maxwellTrick ? !(c = this.g.jmulAdd(d, a.getPublic(), f)).isInfinity() && c.eqXToP(s) : !(c = this.g.mulAdd(d, a.getPublic(), f)).isInfinity() && 0 === c.getX().umod(this.n).cmp(s);
        }, c.prototype.recoverPubKey = function (e, t, a, n) {
          s((3 & a) === a, "The recovery param is more than two bits"), t = new i(t, n);
          var o = this.n,
              c = new r(e),
              u = t.r,
              d = t.s,
              f = 1 & a,
              l = a >> 1;
          if (0 <= u.cmp(this.curve.p.umod(this.curve.n)) && l) throw new Error("Unable to find sencond key candinate");
          u = l ? this.curve.pointFromX(u.add(this.curve.n), f) : this.curve.pointFromX(u, f);
          var h = t.r.invm(o),
              p = o.sub(c).mul(h).umod(o),
              b = d.mul(h).umod(o);
          return this.g.mulAdd(p, u, b);
        }, c.prototype.getKeyRecoveryParam = function (e, t, a, r) {
          if (null !== (t = new i(t, r)).recoveryParam) return t.recoveryParam;

          for (var n = 0; n < 4; n++) {
            var s;

            try {
              s = this.recoverPubKey(e, t, n);
            } catch (e) {
              continue;
            }

            if (s.eq(a)) return n;
          }

          throw new Error("Unable to find valid recovery factor");
        };
      }, {
        "../../elliptic": 12,
        "./key": 20,
        "./signature": 21,
        "bn.js": 9
      }],
      20: [function (e, t, a) {
        "use strict";

        var r = e("bn.js"),
            n = e("../../elliptic").utils.assert;

        function s(e, t) {
          this.ec = e, this.priv = null, this.pub = null, t.priv && this._importPrivate(t.priv, t.privEnc), t.pub && this._importPublic(t.pub, t.pubEnc);
        }

        (t.exports = s).fromPublic = function (e, t, a) {
          return t instanceof s ? t : new s(e, {
            pub: t,
            pubEnc: a
          });
        }, s.fromPrivate = function (e, t, a) {
          return t instanceof s ? t : new s(e, {
            priv: t,
            privEnc: a
          });
        }, s.prototype.validate = function () {
          var e = this.getPublic();
          return e.isInfinity() ? {
            result: !1,
            reason: "Invalid public key"
          } : e.validate() ? e.mul(this.ec.curve.n).isInfinity() ? {
            result: !0,
            reason: null
          } : {
            result: !1,
            reason: "Public key * N != O"
          } : {
            result: !1,
            reason: "Public key is not a point"
          };
        }, s.prototype.getPublic = function (e, t) {
          return "string" == typeof e && (t = e, e = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), t ? this.pub.encode(t, e) : this.pub;
        }, s.prototype.getPrivate = function (e) {
          return "hex" === e ? this.priv.toString(16, 2) : this.priv;
        }, s.prototype._importPrivate = function (e, t) {
          this.priv = new r(e, t || 16), this.priv = this.priv.umod(this.ec.curve.n);
        }, s.prototype._importPublic = function (e, t) {
          if (e.x || e.y) return "mont" === this.ec.curve.type ? n(e.x, "Need x coordinate") : "short" !== this.ec.curve.type && "edwards" !== this.ec.curve.type || n(e.x && e.y, "Need both x and y coordinate"), void (this.pub = this.ec.curve.point(e.x, e.y));
          this.pub = this.ec.curve.decodePoint(e, t);
        }, s.prototype.derive = function (e) {
          return e.mul(this.priv).getX();
        }, s.prototype.sign = function (e, t, a) {
          return this.ec.sign(e, this, t, a);
        }, s.prototype.verify = function (e, t) {
          return this.ec.verify(e, t, this);
        }, s.prototype.inspect = function () {
          return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
        };
      }, {
        "../../elliptic": 12,
        "bn.js": 9
      }],
      21: [function (e, t, a) {
        "use strict";

        var r = e("bn.js"),
            n = e("../../elliptic").utils,
            s = n.assert;

        function o(e, t) {
          if (e instanceof o) return e;
          this._importDER(e, t) || (s(e.r && e.s, "Signature without r or s"), this.r = new r(e.r, 16), this.s = new r(e.s, 16), void 0 === e.recoveryParam ? this.recoveryParam = null : this.recoveryParam = e.recoveryParam);
        }

        function i() {
          this.place = 0;
        }

        function c(e, t) {
          var a = e[t.place++];
          if (!(128 & a)) return a;

          for (var r = 15 & a, n = 0, s = 0, o = t.place; s < r; s++, o++) {
            n <<= 8, n |= e[o];
          }

          return t.place = o, n;
        }

        function u(e) {
          for (var t = 0, a = e.length - 1; !e[t] && !(128 & e[t + 1]) && t < a;) {
            t++;
          }

          return 0 === t ? e : e.slice(t);
        }

        function d(e, t) {
          if (t < 128) e.push(t);else {
            var a = 1 + (Math.log(t) / Math.LN2 >>> 3);

            for (e.push(128 | a); --a;) {
              e.push(t >>> (a << 3) & 255);
            }

            e.push(t);
          }
        }

        (t.exports = o).prototype._importDER = function (e, t) {
          e = n.toArray(e, t);
          var a = new i();
          if (48 !== e[a.place++]) return !1;
          if (c(e, a) + a.place !== e.length) return !1;
          if (2 !== e[a.place++]) return !1;
          var s = c(e, a),
              o = e.slice(a.place, s + a.place);
          if (a.place += s, 2 !== e[a.place++]) return !1;
          var u = c(e, a);
          if (e.length !== u + a.place) return !1;
          var d = e.slice(a.place, u + a.place);
          return 0 === o[0] && 128 & o[1] && (o = o.slice(1)), 0 === d[0] && 128 & d[1] && (d = d.slice(1)), this.r = new r(o), this.s = new r(d), !(this.recoveryParam = null);
        }, o.prototype.toDER = function (e) {
          var t = this.r.toArray(),
              a = this.s.toArray();

          for (128 & t[0] && (t = [0].concat(t)), 128 & a[0] && (a = [0].concat(a)), t = u(t), a = u(a); !(a[0] || 128 & a[1]);) {
            a = a.slice(1);
          }

          var r = [2];
          d(r, t.length), (r = r.concat(t)).push(2), d(r, a.length);
          var s = r.concat(a),
              o = [48];
          return d(o, s.length), o = o.concat(s), n.encode(o, e);
        };
      }, {
        "../../elliptic": 12,
        "bn.js": 9
      }],
      22: [function (e, t, a) {
        arguments[4][14][0].apply(a, arguments);
      }, {
        dup: 14
      }],
      23: [function (e, t, a) {
        "use strict";

        var r = e("hash.js"),
            n = e("../elliptic").utils,
            s = n.assert;

        function o(e) {
          if (!(this instanceof o)) return new o(e);
          this.hash = e.hash, this.predResist = !!e.predResist, this.outLen = this.hash.outSize, this.minEntropy = e.minEntropy || this.hash.hmacStrength, this.reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
          var t = n.toArray(e.entropy, e.entropyEnc),
              a = n.toArray(e.nonce, e.nonceEnc),
              r = n.toArray(e.pers, e.persEnc);
          s(t.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._init(t, a, r);
        }

        (t.exports = o).prototype._init = function (e, t, a) {
          var r = e.concat(t).concat(a);
          this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);

          for (var n = 0; n < this.V.length; n++) {
            this.K[n] = 0, this.V[n] = 1;
          }

          this._update(r), this.reseed = 1, this.reseedInterval = 281474976710656;
        }, o.prototype._hmac = function () {
          return new r.hmac(this.hash, this.K);
        }, o.prototype._update = function (e) {
          var t = this._hmac().update(this.V).update([0]);

          e && (t = t.update(e)), this.K = t.digest(), this.V = this._hmac().update(this.V).digest(), e && (this.K = this._hmac().update(this.V).update([1]).update(e).digest(), this.V = this._hmac().update(this.V).digest());
        }, o.prototype.reseed = function (e, t, a, r) {
          "string" != typeof t && (r = a, a = t, t = null), e = n.toBuffer(e, t), a = n.toBuffer(a, r), s(e.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._update(e.concat(a || [])), this.reseed = 1;
        }, o.prototype.generate = function (e, t, a, r) {
          if (this.reseed > this.reseedInterval) throw new Error("Reseed is required");
          "string" != typeof t && (r = a, a = t, t = null), a && (a = n.toArray(a, r), this._update(a));

          for (var s = []; s.length < e;) {
            this.V = this._hmac().update(this.V).digest(), s = s.concat(this.V);
          }

          var o = s.slice(0, e);
          return this._update(a), this.reseed++, n.encode(o, t);
        };
      }, {
        "../elliptic": 12,
        "hash.js": 27
      }],
      24: [function (e, t, a) {
        t.exports = void 0;
      }, {}],
      25: [function (e, t, a) {
        "use strict";

        var r = a,
            n = e("bn.js");

        function s(e) {
          return 1 === e.length ? "0" + e : e;
        }

        function o(e) {
          for (var t = "", a = 0; a < e.length; a++) {
            t += s(e[a].toString(16));
          }

          return t;
        }

        r.assert = function (e, t) {
          if (!e) throw new Error(t || "Assertion failed");
        }, r.toArray = function (e, t) {
          if (Array.isArray(e)) return e.slice();
          if (!e) return [];
          var a = [];

          if ("string" != typeof e) {
            for (var r = 0; r < e.length; r++) {
              a[r] = 0 | e[r];
            }

            return a;
          }

          if (t) {
            if ("hex" === t) for ((e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e), r = 0; r < e.length; r += 2) {
              a.push(parseInt(e[r] + e[r + 1], 16));
            }
          } else for (r = 0; r < e.length; r++) {
            var n = e.charCodeAt(r),
                s = n >> 8,
                o = 255 & n;
            s ? a.push(s, o) : a.push(o);
          }

          return a;
        }, r.zero2 = s, r.toHex = o, r.encode = function (e, t) {
          return "hex" === t ? o(e) : e;
        }, r.getNAF = function (e, t) {
          for (var a = [], r = 1 << t + 1, n = e.clone(); 0 <= n.cmpn(1);) {
            var s;

            if (n.isOdd()) {
              var o = n.andln(r - 1);
              s = (r >> 1) - 1 < o ? (r >> 1) - o : o, n.isubn(s);
            } else s = 0;

            a.push(s);

            for (var i = 0 !== n.cmpn(0) && 0 === n.andln(r - 1) ? t + 1 : 1, c = 1; c < i; c++) {
              a.push(0);
            }

            n.iushrn(i);
          }

          return a;
        }, r.getJSF = function (e, t) {
          var a = [[], []];
          e = e.clone(), t = t.clone();

          for (var r = 0, n = 0; 0 < e.cmpn(-r) || 0 < t.cmpn(-n);) {
            var s,
                o,
                i,
                c = e.andln(3) + r & 3,
                u = t.andln(3) + n & 3;
            3 === c && (c = -1), 3 === u && (u = -1), s = 0 == (1 & c) ? 0 : 3 != (i = e.andln(7) + r & 7) && 5 !== i || 2 !== u ? c : -c, a[0].push(s), o = 0 == (1 & u) ? 0 : 3 != (i = t.andln(7) + n & 7) && 5 !== i || 2 !== c ? u : -u, a[1].push(o), 2 * r === s + 1 && (r = 1 - r), 2 * n === o + 1 && (n = 1 - n), e.iushrn(1), t.iushrn(1);
          }

          return a;
        }, r.cachedProperty = function (e, t, a) {
          var r = "_" + t;

          e.prototype[t] = function () {
            return void 0 !== this[r] ? this[r] : this[r] = a.call(this);
          };
        }, r.parseBytes = function (e) {
          return "string" == typeof e ? r.toArray(e, "hex") : e;
        }, r.intFromLE = function (e) {
          return new n(e, "hex", "le");
        };
      }, {
        "bn.js": 9
      }],
      26: [function (e, t, a) {
        t.exports = {
          version: "6.3.3"
        };
      }, {}],
      27: [function (e, t, a) {
        var r = a;
        r.utils = e("./hash/utils"), r.common = e("./hash/common"), r.sha = e("./hash/sha"), r.ripemd = e("./hash/ripemd"), r.hmac = e("./hash/hmac"), r.sha1 = r.sha.sha1, r.sha256 = r.sha.sha256, r.sha224 = r.sha.sha224, r.sha384 = r.sha.sha384, r.sha512 = r.sha.sha512, r.ripemd160 = r.ripemd.ripemd160;
      }, {
        "./hash/common": 28,
        "./hash/hmac": 29,
        "./hash/ripemd": 30,
        "./hash/sha": 31,
        "./hash/utils": 38
      }],
      28: [function (e, t, a) {
        "use strict";

        var r = e("./utils"),
            n = e("minimalistic-assert");

        function s() {
          this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
        }

        (a.BlockHash = s).prototype.update = function (e, t) {
          if (e = r.toArray(e, t), this.pending ? this.pending = this.pending.concat(e) : this.pending = e, this.pendingTotal += e.length, this.pending.length >= this._delta8) {
            var a = (e = this.pending).length % this._delta8;
            this.pending = e.slice(e.length - a, e.length), 0 === this.pending.length && (this.pending = null), e = r.join32(e, 0, e.length - a, this.endian);

            for (var n = 0; n < e.length; n += this._delta32) {
              this._update(e, n, n + this._delta32);
            }
          }

          return this;
        }, s.prototype.digest = function (e) {
          return this.update(this._pad()), n(null === this.pending), this._digest(e);
        }, s.prototype._pad = function () {
          var e = this.pendingTotal,
              t = this._delta8,
              a = t - (e + this.padLength) % t,
              r = new Array(a + this.padLength);
          r[0] = 128;

          for (var n = 1; n < a; n++) {
            r[n] = 0;
          }

          if (e <<= 3, "big" === this.endian) {
            for (var s = 8; s < this.padLength; s++) {
              r[n++] = 0;
            }

            r[n++] = 0, r[n++] = 0, r[n++] = 0, r[n++] = 0, r[n++] = e >>> 24 & 255, r[n++] = e >>> 16 & 255, r[n++] = e >>> 8 & 255, r[n++] = 255 & e;
          } else for (r[n++] = 255 & e, r[n++] = e >>> 8 & 255, r[n++] = e >>> 16 & 255, r[n++] = e >>> 24 & 255, r[n++] = 0, r[n++] = 0, r[n++] = 0, r[n++] = 0, s = 8; s < this.padLength; s++) {
            r[n++] = 0;
          }

          return r;
        };
      }, {
        "./utils": 38,
        "minimalistic-assert": 41
      }],
      29: [function (e, t, a) {
        "use strict";

        var r = e("./utils"),
            n = e("minimalistic-assert");

        function s(e, t, a) {
          if (!(this instanceof s)) return new s(e, t, a);
          this.Hash = e, this.blockSize = e.blockSize / 8, this.outSize = e.outSize / 8, this.inner = null, this.outer = null, this._init(r.toArray(t, a));
        }

        (t.exports = s).prototype._init = function (e) {
          e.length > this.blockSize && (e = new this.Hash().update(e).digest()), n(e.length <= this.blockSize);

          for (var t = e.length; t < this.blockSize; t++) {
            e.push(0);
          }

          for (t = 0; t < e.length; t++) {
            e[t] ^= 54;
          }

          for (this.inner = new this.Hash().update(e), t = 0; t < e.length; t++) {
            e[t] ^= 106;
          }

          this.outer = new this.Hash().update(e);
        }, s.prototype.update = function (e, t) {
          return this.inner.update(e, t), this;
        }, s.prototype.digest = function (e) {
          return this.outer.update(this.inner.digest()), this.outer.digest(e);
        };
      }, {
        "./utils": 38,
        "minimalistic-assert": 41
      }],
      30: [function (e, t, a) {
        "use strict";

        var r = e("./utils"),
            n = e("./common"),
            s = r.rotl32,
            o = r.sum32,
            i = r.sum32_3,
            c = r.sum32_4,
            u = n.BlockHash;

        function d() {
          if (!(this instanceof d)) return new d();
          u.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
        }

        function f(e, t, a, r) {
          return e <= 15 ? t ^ a ^ r : e <= 31 ? t & a | ~t & r : e <= 47 ? (t | ~a) ^ r : e <= 63 ? t & r | a & ~r : t ^ (a | ~r);
        }

        function l(e) {
          return e <= 15 ? 0 : e <= 31 ? 1518500249 : e <= 47 ? 1859775393 : e <= 63 ? 2400959708 : 2840853838;
        }

        function h(e) {
          return e <= 15 ? 1352829926 : e <= 31 ? 1548603684 : e <= 47 ? 1836072691 : e <= 63 ? 2053994217 : 0;
        }

        r.inherits(d, u), (a.ripemd160 = d).blockSize = 512, d.outSize = 160, d.hmacStrength = 192, d.padLength = 64, d.prototype._update = function (e, t) {
          for (var a = this.h[0], r = this.h[1], n = this.h[2], u = this.h[3], d = this.h[4], v = a, _ = r, g = n, A = u, w = d, T = 0; T < 80; T++) {
            var x = o(s(c(a, f(T, r, n, u), e[p[T] + t], l(T)), m[T]), d);
            a = d, d = u, u = s(n, 10), n = r, r = x, x = o(s(c(v, f(79 - T, _, g, A), e[b[T] + t], h(T)), y[T]), w), v = w, w = A, A = s(g, 10), g = _, _ = x;
          }

          x = i(this.h[1], n, A), this.h[1] = i(this.h[2], u, w), this.h[2] = i(this.h[3], d, v), this.h[3] = i(this.h[4], a, _), this.h[4] = i(this.h[0], r, g), this.h[0] = x;
        }, d.prototype._digest = function (e) {
          return "hex" === e ? r.toHex32(this.h, "little") : r.split32(this.h, "little");
        };
        var p = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13],
            b = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11],
            m = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6],
            y = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11];
      }, {
        "./common": 28,
        "./utils": 38
      }],
      31: [function (e, t, a) {
        "use strict";

        a.sha1 = e("./sha/1"), a.sha224 = e("./sha/224"), a.sha256 = e("./sha/256"), a.sha384 = e("./sha/384"), a.sha512 = e("./sha/512");
      }, {
        "./sha/1": 32,
        "./sha/224": 33,
        "./sha/256": 34,
        "./sha/384": 35,
        "./sha/512": 36
      }],
      32: [function (e, t, a) {
        arguments[4][14][0].apply(a, arguments);
      }, {
        dup: 14
      }],
      33: [function (e, t, a) {
        arguments[4][14][0].apply(a, arguments);
      }, {
        dup: 14
      }],
      34: [function (e, t, a) {
        "use strict";

        var r = e("../utils"),
            n = e("../common"),
            s = e("./common"),
            o = e("minimalistic-assert"),
            i = r.sum32,
            c = r.sum32_4,
            u = r.sum32_5,
            d = s.ch32,
            f = s.maj32,
            l = s.s0_256,
            h = s.s1_256,
            p = s.g0_256,
            b = s.g1_256,
            m = n.BlockHash,
            y = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298];

        function v() {
          if (!(this instanceof v)) return new v();
          m.call(this), this.h = [1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225], this.k = y, this.W = new Array(64);
        }

        r.inherits(v, m), (t.exports = v).blockSize = 512, v.outSize = 256, v.hmacStrength = 192, v.padLength = 64, v.prototype._update = function (e, t) {
          for (var a = this.W, r = 0; r < 16; r++) {
            a[r] = e[t + r];
          }

          for (; r < a.length; r++) {
            a[r] = c(b(a[r - 2]), a[r - 7], p(a[r - 15]), a[r - 16]);
          }

          var n = this.h[0],
              s = this.h[1],
              m = this.h[2],
              y = this.h[3],
              v = this.h[4],
              _ = this.h[5],
              g = this.h[6],
              A = this.h[7];

          for (o(this.k.length === a.length), r = 0; r < a.length; r++) {
            var w = u(A, h(v), d(v, _, g), this.k[r], a[r]),
                T = i(l(n), f(n, s, m));
            A = g, g = _, _ = v, v = i(y, w), y = m, m = s, s = n, n = i(w, T);
          }

          this.h[0] = i(this.h[0], n), this.h[1] = i(this.h[1], s), this.h[2] = i(this.h[2], m), this.h[3] = i(this.h[3], y), this.h[4] = i(this.h[4], v), this.h[5] = i(this.h[5], _), this.h[6] = i(this.h[6], g), this.h[7] = i(this.h[7], A);
        }, v.prototype._digest = function (e) {
          return "hex" === e ? r.toHex32(this.h, "big") : r.split32(this.h, "big");
        };
      }, {
        "../common": 28,
        "../utils": 38,
        "./common": 37,
        "minimalistic-assert": 41
      }],
      35: [function (e, t, a) {
        arguments[4][14][0].apply(a, arguments);
      }, {
        dup: 14
      }],
      36: [function (e, t, a) {
        "use strict";

        var r = e("../utils"),
            n = e("../common"),
            s = e("minimalistic-assert"),
            o = r.rotr64_hi,
            i = r.rotr64_lo,
            c = r.shr64_hi,
            u = r.shr64_lo,
            d = r.sum64,
            f = r.sum64_hi,
            l = r.sum64_lo,
            h = r.sum64_4_hi,
            p = r.sum64_4_lo,
            b = r.sum64_5_hi,
            m = r.sum64_5_lo,
            y = n.BlockHash,
            v = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591];

        function _() {
          if (!(this instanceof _)) return new _();
          y.call(this), this.h = [1779033703, 4089235720, 3144134277, 2227873595, 1013904242, 4271175723, 2773480762, 1595750129, 1359893119, 2917565137, 2600822924, 725511199, 528734635, 4215389547, 1541459225, 327033209], this.k = v, this.W = new Array(160);
        }

        function g(e, t, a, r, n) {
          var s = e & a ^ ~e & n;
          return s < 0 && (s += 4294967296), s;
        }

        function A(e, t, a, r, n, s) {
          var o = t & r ^ ~t & s;
          return o < 0 && (o += 4294967296), o;
        }

        function w(e, t, a, r, n) {
          var s = e & a ^ e & n ^ a & n;
          return s < 0 && (s += 4294967296), s;
        }

        function T(e, t, a, r, n, s) {
          var o = t & r ^ t & s ^ r & s;
          return o < 0 && (o += 4294967296), o;
        }

        function x(e, t) {
          var a = o(e, t, 28) ^ o(t, e, 2) ^ o(t, e, 7);
          return a < 0 && (a += 4294967296), a;
        }

        function D(e, t) {
          var a = i(e, t, 28) ^ i(t, e, 2) ^ i(t, e, 7);
          return a < 0 && (a += 4294967296), a;
        }

        function C(e, t) {
          var a = o(e, t, 14) ^ o(e, t, 18) ^ o(t, e, 9);
          return a < 0 && (a += 4294967296), a;
        }

        function S(e, t) {
          var a = i(e, t, 14) ^ i(e, t, 18) ^ i(t, e, 9);
          return a < 0 && (a += 4294967296), a;
        }

        function E(e, t) {
          var a = o(e, t, 1) ^ o(e, t, 8) ^ c(e, t, 7);
          return a < 0 && (a += 4294967296), a;
        }

        function B(e, t) {
          var a = i(e, t, 1) ^ i(e, t, 8) ^ u(e, t, 7);
          return a < 0 && (a += 4294967296), a;
        }

        function k(e, t) {
          var a = o(e, t, 19) ^ o(t, e, 29) ^ c(e, t, 6);
          return a < 0 && (a += 4294967296), a;
        }

        function R(e, t) {
          var a = i(e, t, 19) ^ i(t, e, 29) ^ u(e, t, 6);
          return a < 0 && (a += 4294967296), a;
        }

        r.inherits(_, y), (t.exports = _).blockSize = 1024, _.outSize = 512, _.hmacStrength = 192, _.padLength = 128, _.prototype._prepareBlock = function (e, t) {
          for (var a = this.W, r = 0; r < 32; r++) {
            a[r] = e[t + r];
          }

          for (; r < a.length; r += 2) {
            var n = k(a[r - 4], a[r - 3]),
                s = R(a[r - 4], a[r - 3]),
                o = a[r - 14],
                i = a[r - 13],
                c = E(a[r - 30], a[r - 29]),
                u = B(a[r - 30], a[r - 29]),
                d = a[r - 32],
                f = a[r - 31];
            a[r] = h(n, s, o, i, c, u, d, f), a[r + 1] = p(n, s, o, i, c, u, d, f);
          }
        }, _.prototype._update = function (e, t) {
          this._prepareBlock(e, t);

          var a = this.W,
              r = this.h[0],
              n = this.h[1],
              o = this.h[2],
              i = this.h[3],
              c = this.h[4],
              u = this.h[5],
              h = this.h[6],
              p = this.h[7],
              y = this.h[8],
              v = this.h[9],
              _ = this.h[10],
              E = this.h[11],
              B = this.h[12],
              k = this.h[13],
              R = this.h[14],
              W = this.h[15];
          s(this.k.length === a.length);

          for (var I = 0; I < a.length; I += 2) {
            var N = R,
                M = W,
                P = C(y, v),
                L = S(y, v),
                O = g(y, 0, _, 0, B),
                F = A(0, v, 0, E, 0, k),
                j = this.k[I],
                G = this.k[I + 1],
                V = a[I],
                U = a[I + 1],
                H = b(N, M, P, L, O, F, j, G, V, U),
                z = m(N, M, P, L, O, F, j, G, V, U);
            N = x(r, n), M = D(r, n), P = w(r, 0, o, 0, c), L = T(0, n, 0, i, 0, u);
            var K = f(N, M, P, L),
                q = l(N, M, P, L);
            R = B, W = k, B = _, k = E, _ = y, E = v, y = f(h, p, H, z), v = l(p, p, H, z), h = c, p = u, c = o, u = i, o = r, i = n, r = f(H, z, K, q), n = l(H, z, K, q);
          }

          d(this.h, 0, r, n), d(this.h, 2, o, i), d(this.h, 4, c, u), d(this.h, 6, h, p), d(this.h, 8, y, v), d(this.h, 10, _, E), d(this.h, 12, B, k), d(this.h, 14, R, W);
        }, _.prototype._digest = function (e) {
          return "hex" === e ? r.toHex32(this.h, "big") : r.split32(this.h, "big");
        };
      }, {
        "../common": 28,
        "../utils": 38,
        "minimalistic-assert": 41
      }],
      37: [function (e, t, a) {
        "use strict";

        var r = e("../utils").rotr32;

        function n(e, t, a) {
          return e & t ^ ~e & a;
        }

        function s(e, t, a) {
          return e & t ^ e & a ^ t & a;
        }

        function o(e, t, a) {
          return e ^ t ^ a;
        }

        a.ft_1 = function (e, t, a, r) {
          return 0 === e ? n(t, a, r) : 1 === e || 3 === e ? o(t, a, r) : 2 === e ? s(t, a, r) : void 0;
        }, a.ch32 = n, a.maj32 = s, a.p32 = o, a.s0_256 = function (e) {
          return r(e, 2) ^ r(e, 13) ^ r(e, 22);
        }, a.s1_256 = function (e) {
          return r(e, 6) ^ r(e, 11) ^ r(e, 25);
        }, a.g0_256 = function (e) {
          return r(e, 7) ^ r(e, 18) ^ e >>> 3;
        }, a.g1_256 = function (e) {
          return r(e, 17) ^ r(e, 19) ^ e >>> 10;
        };
      }, {
        "../utils": 38
      }],
      38: [function (e, t, a) {
        "use strict";

        var r = e("minimalistic-assert"),
            n = e("inherits");

        function s(e) {
          return (e >>> 24 | e >>> 8 & 65280 | e << 8 & 16711680 | (255 & e) << 24) >>> 0;
        }

        function o(e) {
          return 1 === e.length ? "0" + e : e;
        }

        function i(e) {
          return 7 === e.length ? "0" + e : 6 === e.length ? "00" + e : 5 === e.length ? "000" + e : 4 === e.length ? "0000" + e : 3 === e.length ? "00000" + e : 2 === e.length ? "000000" + e : 1 === e.length ? "0000000" + e : e;
        }

        a.inherits = n, a.toArray = function (e, t) {
          if (Array.isArray(e)) return e.slice();
          if (!e) return [];
          var a = [];
          if ("string" == typeof e) {
            if (t) {
              if ("hex" === t) for ((e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e), r = 0; r < e.length; r += 2) {
                a.push(parseInt(e[r] + e[r + 1], 16));
              }
            } else for (var r = 0; r < e.length; r++) {
              var n = e.charCodeAt(r),
                  s = n >> 8,
                  o = 255 & n;
              s ? a.push(s, o) : a.push(o);
            }
          } else for (r = 0; r < e.length; r++) {
            a[r] = 0 | e[r];
          }
          return a;
        }, a.toHex = function (e) {
          for (var t = "", a = 0; a < e.length; a++) {
            t += o(e[a].toString(16));
          }

          return t;
        }, a.htonl = s, a.toHex32 = function (e, t) {
          for (var a = "", r = 0; r < e.length; r++) {
            var n = e[r];
            "little" === t && (n = s(n)), a += i(n.toString(16));
          }

          return a;
        }, a.zero2 = o, a.zero8 = i, a.join32 = function (e, t, a, n) {
          var s = a - t;
          r(s % 4 == 0);

          for (var o = new Array(s / 4), i = 0, c = t; i < o.length; i++, c += 4) {
            var u;
            u = "big" === n ? e[c] << 24 | e[c + 1] << 16 | e[c + 2] << 8 | e[c + 3] : e[c + 3] << 24 | e[c + 2] << 16 | e[c + 1] << 8 | e[c], o[i] = u >>> 0;
          }

          return o;
        }, a.split32 = function (e, t) {
          for (var a = new Array(4 * e.length), r = 0, n = 0; r < e.length; r++, n += 4) {
            var s = e[r];
            "big" === t ? (a[n] = s >>> 24, a[n + 1] = s >>> 16 & 255, a[n + 2] = s >>> 8 & 255, a[n + 3] = 255 & s) : (a[n + 3] = s >>> 24, a[n + 2] = s >>> 16 & 255, a[n + 1] = s >>> 8 & 255, a[n] = 255 & s);
          }

          return a;
        }, a.rotr32 = function (e, t) {
          return e >>> t | e << 32 - t;
        }, a.rotl32 = function (e, t) {
          return e << t | e >>> 32 - t;
        }, a.sum32 = function (e, t) {
          return e + t >>> 0;
        }, a.sum32_3 = function (e, t, a) {
          return e + t + a >>> 0;
        }, a.sum32_4 = function (e, t, a, r) {
          return e + t + a + r >>> 0;
        }, a.sum32_5 = function (e, t, a, r, n) {
          return e + t + a + r + n >>> 0;
        }, a.sum64 = function (e, t, a, r) {
          var n = e[t],
              s = r + e[t + 1] >>> 0,
              o = (s < r ? 1 : 0) + a + n;
          e[t] = o >>> 0, e[t + 1] = s;
        }, a.sum64_hi = function (e, t, a, r) {
          return (t + r >>> 0 < t ? 1 : 0) + e + a >>> 0;
        }, a.sum64_lo = function (e, t, a, r) {
          return t + r >>> 0;
        }, a.sum64_4_hi = function (e, t, a, r, n, s, o, i) {
          var c = 0,
              u = t;
          return c += (u = u + r >>> 0) < t ? 1 : 0, c += (u = u + s >>> 0) < s ? 1 : 0, e + a + n + o + (c += (u = u + i >>> 0) < i ? 1 : 0) >>> 0;
        }, a.sum64_4_lo = function (e, t, a, r, n, s, o, i) {
          return t + r + s + i >>> 0;
        }, a.sum64_5_hi = function (e, t, a, r, n, s, o, i, c, u) {
          var d = 0,
              f = t;
          return d += (f = f + r >>> 0) < t ? 1 : 0, d += (f = f + s >>> 0) < s ? 1 : 0, d += (f = f + i >>> 0) < i ? 1 : 0, e + a + n + o + c + (d += (f = f + u >>> 0) < u ? 1 : 0) >>> 0;
        }, a.sum64_5_lo = function (e, t, a, r, n, s, o, i, c, u) {
          return t + r + s + i + u >>> 0;
        }, a.rotr64_hi = function (e, t, a) {
          return (t << 32 - a | e >>> a) >>> 0;
        }, a.rotr64_lo = function (e, t, a) {
          return (e << 32 - a | t >>> a) >>> 0;
        }, a.shr64_hi = function (e, t, a) {
          return e >>> a;
        }, a.shr64_lo = function (e, t, a) {
          return (e << 32 - a | t >>> a) >>> 0;
        };
      }, {
        inherits: 39,
        "minimalistic-assert": 41
      }],
      39: [function (e, t, a) {
        "function" == typeof Object.create ? t.exports = function (e, t) {
          t && (e.super_ = t, e.prototype = Object.create(t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }));
        } : t.exports = function (e, t) {
          if (t) {
            var _a3 = function _a3() {};

            e.super_ = t, _a3.prototype = t.prototype, e.prototype = new _a3(), e.prototype.constructor = e;
          }
        };
      }, {}],
      40: [function (e, a, r) {
        (function (e, t) {
          !function () {
            "use strict";

            var r = "object" == typeof window ? window : {};
            !r.JS_SHA3_NO_NODE_JS && "object" == typeof e && e.versions && e.versions.node && (r = t);

            for (var n = !r.JS_SHA3_NO_COMMON_JS && "object" == typeof a && a.exports, s = "0123456789abcdef".split(""), o = [0, 8, 16, 24], i = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649, 0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0, 2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771, 2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648, 2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648], c = [224, 256, 384, 512], u = ["hex", "buffer", "arrayBuffer", "array"], d = function d(e, t, a) {
              return function (r) {
                return new A(e, t, e).update(r)[a]();
              };
            }, f = function f(e, t, a) {
              return function (r, n) {
                return new A(e, t, n).update(r)[a]();
              };
            }, l = function l(e, t) {
              var a = d(e, t, "hex");
              a.create = function () {
                return new A(e, t, e);
              }, a.update = function (e) {
                return a.create().update(e);
              };

              for (var r = 0; r < u.length; ++r) {
                var n = u[r];
                a[n] = d(e, t, n);
              }

              return a;
            }, h = [{
              name: "keccak",
              padding: [1, 256, 65536, 16777216],
              bits: c,
              createMethod: l
            }, {
              name: "sha3",
              padding: [6, 1536, 393216, 100663296],
              bits: c,
              createMethod: l
            }, {
              name: "shake",
              padding: [31, 7936, 2031616, 520093696],
              bits: [128, 256],
              createMethod: function createMethod(e, t) {
                var a = f(e, t, "hex");
                a.create = function (a) {
                  return new A(e, t, a);
                }, a.update = function (e, t) {
                  return a.create(t).update(e);
                };

                for (var r = 0; r < u.length; ++r) {
                  var n = u[r];
                  a[n] = f(e, t, n);
                }

                return a;
              }
            }], p = {}, b = [], m = 0; m < h.length; ++m) {
              for (var y = h[m], v = y.bits, _ = 0; _ < v.length; ++_) {
                var g = y.name + "_" + v[_];
                b.push(g), p[g] = y.createMethod(v[_], y.padding);
              }
            }

            function A(e, t, a) {
              this.blocks = [], this.s = [], this.padding = t, this.outputBits = a, this.reset = !0, this.block = 0, this.start = 0, this.blockCount = 1600 - (e << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = a >> 5, this.extraBytes = (31 & a) >> 3;

              for (var r = 0; r < 50; ++r) {
                this.s[r] = 0;
              }
            }

            A.prototype.update = function (e) {
              var t = "string" != typeof e;
              t && e.constructor === ArrayBuffer && (e = new Uint8Array(e));

              for (var a, r, n = e.length, s = this.blocks, i = this.byteCount, c = this.blockCount, u = 0, d = this.s; u < n;) {
                if (this.reset) for (this.reset = !1, s[0] = this.block, a = 1; a < c + 1; ++a) {
                  s[a] = 0;
                }
                if (t) for (a = this.start; u < n && a < i; ++u) {
                  s[a >> 2] |= e[u] << o[3 & a++];
                } else for (a = this.start; u < n && a < i; ++u) {
                  (r = e.charCodeAt(u)) < 128 ? s[a >> 2] |= r << o[3 & a++] : (r < 2048 ? s[a >> 2] |= (192 | r >> 6) << o[3 & a++] : (r < 55296 || 57344 <= r ? s[a >> 2] |= (224 | r >> 12) << o[3 & a++] : (r = 65536 + ((1023 & r) << 10 | 1023 & e.charCodeAt(++u)), s[a >> 2] |= (240 | r >> 18) << o[3 & a++], s[a >> 2] |= (128 | r >> 12 & 63) << o[3 & a++]), s[a >> 2] |= (128 | r >> 6 & 63) << o[3 & a++]), s[a >> 2] |= (128 | 63 & r) << o[3 & a++]);
                }

                if (i <= (this.lastByteIndex = a)) {
                  for (this.start = a - i, this.block = s[c], a = 0; a < c; ++a) {
                    d[a] ^= s[a];
                  }

                  w(d), this.reset = !0;
                } else this.start = a;
              }

              return this;
            }, A.prototype.finalize = function () {
              var e = this.blocks,
                  t = this.lastByteIndex,
                  a = this.blockCount,
                  r = this.s;
              if (e[t >> 2] |= this.padding[3 & t], this.lastByteIndex === this.byteCount) for (e[0] = e[a], t = 1; t < a + 1; ++t) {
                e[t] = 0;
              }

              for (e[a - 1] |= 2147483648, t = 0; t < a; ++t) {
                r[t] ^= e[t];
              }

              w(r);
            }, A.prototype.toString = A.prototype.hex = function () {
              this.finalize();

              for (var e, t = this.blockCount, a = this.s, r = this.outputBlocks, n = this.extraBytes, o = 0, i = 0, c = ""; i < r;) {
                for (o = 0; o < t && i < r; ++o, ++i) {
                  e = a[o], c += s[e >> 4 & 15] + s[15 & e] + s[e >> 12 & 15] + s[e >> 8 & 15] + s[e >> 20 & 15] + s[e >> 16 & 15] + s[e >> 28 & 15] + s[e >> 24 & 15];
                }

                i % t == 0 && (w(a), o = 0);
              }

              return n && (e = a[o], 0 < n && (c += s[e >> 4 & 15] + s[15 & e]), 1 < n && (c += s[e >> 12 & 15] + s[e >> 8 & 15]), 2 < n && (c += s[e >> 20 & 15] + s[e >> 16 & 15])), c;
            }, A.prototype.buffer = A.prototype.arrayBuffer = function () {
              this.finalize();
              var e,
                  t = this.blockCount,
                  a = this.s,
                  r = this.outputBlocks,
                  n = this.extraBytes,
                  s = 0,
                  o = 0,
                  i = this.outputBits >> 3;
              e = n ? new ArrayBuffer(r + 1 << 2) : new ArrayBuffer(i);

              for (var c = new Uint32Array(e); o < r;) {
                for (s = 0; s < t && o < r; ++s, ++o) {
                  c[o] = a[s];
                }

                o % t == 0 && w(a);
              }

              return n && (c[s] = a[s], e = e.slice(0, i)), e;
            }, A.prototype.digest = A.prototype.array = function () {
              this.finalize();

              for (var e, t, a = this.blockCount, r = this.s, n = this.outputBlocks, s = this.extraBytes, o = 0, i = 0, c = []; i < n;) {
                for (o = 0; o < a && i < n; ++o, ++i) {
                  e = i << 2, t = r[o], c[e] = 255 & t, c[e + 1] = t >> 8 & 255, c[e + 2] = t >> 16 & 255, c[e + 3] = t >> 24 & 255;
                }

                i % a == 0 && w(r);
              }

              return s && (e = i << 2, t = r[o], 0 < s && (c[e] = 255 & t), 1 < s && (c[e + 1] = t >> 8 & 255), 2 < s && (c[e + 2] = t >> 16 & 255)), c;
            };

            var w = function w(e) {
              var t, a, r, n, s, o, c, u, d, f, l, h, p, b, m, y, v, _, g, A, w, T, x, D, C, S, E, B, k, R, W, I, N, M, P, L, O, F, j, G, V, U, H, z, K, q, Y, Z, J, X, $, Q, ee, te, ae, re, ne, se, oe, ie, ce, ue, de;

              for (r = 0; r < 48; r += 2) {
                n = e[0] ^ e[10] ^ e[20] ^ e[30] ^ e[40], s = e[1] ^ e[11] ^ e[21] ^ e[31] ^ e[41], o = e[2] ^ e[12] ^ e[22] ^ e[32] ^ e[42], c = e[3] ^ e[13] ^ e[23] ^ e[33] ^ e[43], u = e[4] ^ e[14] ^ e[24] ^ e[34] ^ e[44], d = e[5] ^ e[15] ^ e[25] ^ e[35] ^ e[45], f = e[6] ^ e[16] ^ e[26] ^ e[36] ^ e[46], l = e[7] ^ e[17] ^ e[27] ^ e[37] ^ e[47], t = (h = e[8] ^ e[18] ^ e[28] ^ e[38] ^ e[48]) ^ (o << 1 | c >>> 31), a = (p = e[9] ^ e[19] ^ e[29] ^ e[39] ^ e[49]) ^ (c << 1 | o >>> 31), e[0] ^= t, e[1] ^= a, e[10] ^= t, e[11] ^= a, e[20] ^= t, e[21] ^= a, e[30] ^= t, e[31] ^= a, e[40] ^= t, e[41] ^= a, t = n ^ (u << 1 | d >>> 31), a = s ^ (d << 1 | u >>> 31), e[2] ^= t, e[3] ^= a, e[12] ^= t, e[13] ^= a, e[22] ^= t, e[23] ^= a, e[32] ^= t, e[33] ^= a, e[42] ^= t, e[43] ^= a, t = o ^ (f << 1 | l >>> 31), a = c ^ (l << 1 | f >>> 31), e[4] ^= t, e[5] ^= a, e[14] ^= t, e[15] ^= a, e[24] ^= t, e[25] ^= a, e[34] ^= t, e[35] ^= a, e[44] ^= t, e[45] ^= a, t = u ^ (h << 1 | p >>> 31), a = d ^ (p << 1 | h >>> 31), e[6] ^= t, e[7] ^= a, e[16] ^= t, e[17] ^= a, e[26] ^= t, e[27] ^= a, e[36] ^= t, e[37] ^= a, e[46] ^= t, e[47] ^= a, t = f ^ (n << 1 | s >>> 31), a = l ^ (s << 1 | n >>> 31), e[8] ^= t, e[9] ^= a, e[18] ^= t, e[19] ^= a, e[28] ^= t, e[29] ^= a, e[38] ^= t, e[39] ^= a, e[48] ^= t, e[49] ^= a, b = e[0], m = e[1], q = e[11] << 4 | e[10] >>> 28, Y = e[10] << 4 | e[11] >>> 28, B = e[20] << 3 | e[21] >>> 29, k = e[21] << 3 | e[20] >>> 29, ie = e[31] << 9 | e[30] >>> 23, ce = e[30] << 9 | e[31] >>> 23, U = e[40] << 18 | e[41] >>> 14, H = e[41] << 18 | e[40] >>> 14, M = e[2] << 1 | e[3] >>> 31, P = e[3] << 1 | e[2] >>> 31, y = e[13] << 12 | e[12] >>> 20, v = e[12] << 12 | e[13] >>> 20, Z = e[22] << 10 | e[23] >>> 22, J = e[23] << 10 | e[22] >>> 22, R = e[33] << 13 | e[32] >>> 19, W = e[32] << 13 | e[33] >>> 19, ue = e[42] << 2 | e[43] >>> 30, de = e[43] << 2 | e[42] >>> 30, te = e[5] << 30 | e[4] >>> 2, ae = e[4] << 30 | e[5] >>> 2, L = e[14] << 6 | e[15] >>> 26, O = e[15] << 6 | e[14] >>> 26, _ = e[25] << 11 | e[24] >>> 21, g = e[24] << 11 | e[25] >>> 21, X = e[34] << 15 | e[35] >>> 17, $ = e[35] << 15 | e[34] >>> 17, I = e[45] << 29 | e[44] >>> 3, N = e[44] << 29 | e[45] >>> 3, D = e[6] << 28 | e[7] >>> 4, C = e[7] << 28 | e[6] >>> 4, re = e[17] << 23 | e[16] >>> 9, ne = e[16] << 23 | e[17] >>> 9, F = e[26] << 25 | e[27] >>> 7, j = e[27] << 25 | e[26] >>> 7, A = e[36] << 21 | e[37] >>> 11, w = e[37] << 21 | e[36] >>> 11, Q = e[47] << 24 | e[46] >>> 8, ee = e[46] << 24 | e[47] >>> 8, z = e[8] << 27 | e[9] >>> 5, K = e[9] << 27 | e[8] >>> 5, S = e[18] << 20 | e[19] >>> 12, E = e[19] << 20 | e[18] >>> 12, se = e[29] << 7 | e[28] >>> 25, oe = e[28] << 7 | e[29] >>> 25, G = e[38] << 8 | e[39] >>> 24, V = e[39] << 8 | e[38] >>> 24, T = e[48] << 14 | e[49] >>> 18, x = e[49] << 14 | e[48] >>> 18, e[0] = b ^ ~y & _, e[1] = m ^ ~v & g, e[10] = D ^ ~S & B, e[11] = C ^ ~E & k, e[20] = M ^ ~L & F, e[21] = P ^ ~O & j, e[30] = z ^ ~q & Z, e[31] = K ^ ~Y & J, e[40] = te ^ ~re & se, e[41] = ae ^ ~ne & oe, e[2] = y ^ ~_ & A, e[3] = v ^ ~g & w, e[12] = S ^ ~B & R, e[13] = E ^ ~k & W, e[22] = L ^ ~F & G, e[23] = O ^ ~j & V, e[32] = q ^ ~Z & X, e[33] = Y ^ ~J & $, e[42] = re ^ ~se & ie, e[43] = ne ^ ~oe & ce, e[4] = _ ^ ~A & T, e[5] = g ^ ~w & x, e[14] = B ^ ~R & I, e[15] = k ^ ~W & N, e[24] = F ^ ~G & U, e[25] = j ^ ~V & H, e[34] = Z ^ ~X & Q, e[35] = J ^ ~$ & ee, e[44] = se ^ ~ie & ue, e[45] = oe ^ ~ce & de, e[6] = A ^ ~T & b, e[7] = w ^ ~x & m, e[16] = R ^ ~I & D, e[17] = W ^ ~N & C, e[26] = G ^ ~U & M, e[27] = V ^ ~H & P, e[36] = X ^ ~Q & z, e[37] = $ ^ ~ee & K, e[46] = ie ^ ~ue & te, e[47] = ce ^ ~de & ae, e[8] = T ^ ~b & y, e[9] = x ^ ~m & v, e[18] = I ^ ~D & S, e[19] = N ^ ~C & E, e[28] = U ^ ~M & L, e[29] = H ^ ~P & O, e[38] = Q ^ ~z & q, e[39] = ee ^ ~K & Y, e[48] = ue ^ ~te & re, e[49] = de ^ ~ae & ne, e[0] ^= i[r], e[1] ^= i[r + 1];
              }
            };

            if (n) a.exports = p;else for (m = 0; m < b.length; ++m) {
              r[b[m]] = p[b[m]];
            }
          }();
        }).call(this, e("_process"), void 0 !== t ? t : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
      }, {
        _process: 42
      }],
      41: [function (e, t, a) {
        (t.exports = function (e, t) {
          if (!e) throw new Error(t || "Assertion failed");
        }).equal = function (e, t, a) {
          if (e != t) throw new Error(a || "Assertion failed: " + e + " != " + t);
        };
      }, {}],
      42: [function (e, t, a) {
        t.exports = {
          browser: !0
        };
      }, {}],
      43: [function (e, t, a) {
        (function (e) {
          "use strict";

          function r(e) {
            var t = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298],
                a = 1779033703,
                r = 3144134277,
                n = 1013904242,
                s = 2773480762,
                o = 1359893119,
                i = 2600822924,
                c = 528734635,
                u = 1541459225,
                d = new Array(64);

            function f(e) {
              for (var f = 0, l = e.length; 64 <= l;) {
                var h,
                    p,
                    b,
                    m,
                    y,
                    v = a,
                    _ = r,
                    g = n,
                    A = s,
                    w = o,
                    T = i,
                    x = c,
                    D = u;

                for (p = 0; p < 16; p++) {
                  b = f + 4 * p, d[p] = (255 & e[b]) << 24 | (255 & e[b + 1]) << 16 | (255 & e[b + 2]) << 8 | 255 & e[b + 3];
                }

                for (p = 16; p < 64; p++) {
                  m = ((h = d[p - 2]) >>> 17 | h << 15) ^ (h >>> 19 | h << 13) ^ h >>> 10, y = ((h = d[p - 15]) >>> 7 | h << 25) ^ (h >>> 18 | h << 14) ^ h >>> 3, d[p] = (m + d[p - 7] | 0) + (y + d[p - 16] | 0) | 0;
                }

                for (p = 0; p < 64; p++) {
                  m = (((w >>> 6 | w << 26) ^ (w >>> 11 | w << 21) ^ (w >>> 25 | w << 7)) + (w & T ^ ~w & x) | 0) + (D + (t[p] + d[p] | 0) | 0) | 0, y = ((v >>> 2 | v << 30) ^ (v >>> 13 | v << 19) ^ (v >>> 22 | v << 10)) + (v & _ ^ v & g ^ _ & g) | 0, D = x, x = T, T = w, w = A + m | 0, A = g, g = _, _ = v, v = m + y | 0;
                }

                a = a + v | 0, r = r + _ | 0, n = n + g | 0, s = s + A | 0, o = o + w | 0, i = i + T | 0, c = c + x | 0, u = u + D | 0, f += 64, l -= 64;
              }
            }

            f(e);
            var l,
                h = e.length % 64,
                p = e.length / 536870912 | 0,
                b = e.length << 3,
                m = h < 56 ? 56 : 120,
                y = e.slice(e.length - h, e.length);

            for (y.push(128), l = 1 + h; l < m; l++) {
              y.push(0);
            }

            return y.push(p >>> 24 & 255), y.push(p >>> 16 & 255), y.push(p >>> 8 & 255), y.push(p >>> 0 & 255), y.push(b >>> 24 & 255), y.push(b >>> 16 & 255), y.push(b >>> 8 & 255), y.push(b >>> 0 & 255), f(y), [a >>> 24 & 255, a >>> 16 & 255, a >>> 8 & 255, a >>> 0 & 255, r >>> 24 & 255, r >>> 16 & 255, r >>> 8 & 255, r >>> 0 & 255, n >>> 24 & 255, n >>> 16 & 255, n >>> 8 & 255, n >>> 0 & 255, s >>> 24 & 255, s >>> 16 & 255, s >>> 8 & 255, s >>> 0 & 255, o >>> 24 & 255, o >>> 16 & 255, o >>> 8 & 255, o >>> 0 & 255, i >>> 24 & 255, i >>> 16 & 255, i >>> 8 & 255, i >>> 0 & 255, c >>> 24 & 255, c >>> 16 & 255, c >>> 8 & 255, c >>> 0 & 255, u >>> 24 & 255, u >>> 16 & 255, u >>> 8 & 255, u >>> 0 & 255];
          }

          function n(e, t, a) {
            var n;
            e = e.length <= 64 ? e : r(e);
            var s = 64 + t.length + 4,
                o = new Array(s),
                i = new Array(64),
                c = [];

            for (n = 0; n < 64; n++) {
              o[n] = 54;
            }

            for (n = 0; n < e.length; n++) {
              o[n] ^= e[n];
            }

            for (n = 0; n < t.length; n++) {
              o[64 + n] = t[n];
            }

            for (n = s - 4; n < s; n++) {
              o[n] = 0;
            }

            for (n = 0; n < 64; n++) {
              i[n] = 92;
            }

            for (n = 0; n < e.length; n++) {
              i[n] ^= e[n];
            }

            function u() {
              for (var e = s - 1; s - 4 <= e; e--) {
                if (o[e]++, o[e] <= 255) return;
                o[e] = 0;
              }
            }

            for (; 32 <= a;) {
              u(), c = c.concat(r(i.concat(r(o)))), a -= 32;
            }

            return 0 < a && (u(), c = c.concat(r(i.concat(r(o))).slice(0, a))), c;
          }

          function s(e, t, a, r, n) {
            var s;

            for (u(e, 16 * (2 * a - 1), n, 0, 16), s = 0; s < 2 * a; s++) {
              c(e, 16 * s, n, 16), i(n, r), u(n, 0, e, t + 16 * s, 16);
            }

            for (s = 0; s < a; s++) {
              u(e, t + 2 * s * 16, e, 16 * s, 16);
            }

            for (s = 0; s < a; s++) {
              u(e, t + 16 * (2 * s + 1), e, 16 * (s + a), 16);
            }
          }

          function o(e, t) {
            return e << t | e >>> 32 - t;
          }

          function i(e, t) {
            u(e, 0, t, 0, 16);

            for (var a = 8; 0 < a; a -= 2) {
              t[4] ^= o(t[0] + t[12], 7), t[8] ^= o(t[4] + t[0], 9), t[12] ^= o(t[8] + t[4], 13), t[0] ^= o(t[12] + t[8], 18), t[9] ^= o(t[5] + t[1], 7), t[13] ^= o(t[9] + t[5], 9), t[1] ^= o(t[13] + t[9], 13), t[5] ^= o(t[1] + t[13], 18), t[14] ^= o(t[10] + t[6], 7), t[2] ^= o(t[14] + t[10], 9), t[6] ^= o(t[2] + t[14], 13), t[10] ^= o(t[6] + t[2], 18), t[3] ^= o(t[15] + t[11], 7), t[7] ^= o(t[3] + t[15], 9), t[11] ^= o(t[7] + t[3], 13), t[15] ^= o(t[11] + t[7], 18), t[1] ^= o(t[0] + t[3], 7), t[2] ^= o(t[1] + t[0], 9), t[3] ^= o(t[2] + t[1], 13), t[0] ^= o(t[3] + t[2], 18), t[6] ^= o(t[5] + t[4], 7), t[7] ^= o(t[6] + t[5], 9), t[4] ^= o(t[7] + t[6], 13), t[5] ^= o(t[4] + t[7], 18), t[11] ^= o(t[10] + t[9], 7), t[8] ^= o(t[11] + t[10], 9), t[9] ^= o(t[8] + t[11], 13), t[10] ^= o(t[9] + t[8], 18), t[12] ^= o(t[15] + t[14], 7), t[13] ^= o(t[12] + t[15], 9), t[14] ^= o(t[13] + t[12], 13), t[15] ^= o(t[14] + t[13], 18);
            }

            for (a = 0; a < 16; ++a) {
              e[a] += t[a];
            }
          }

          function c(e, t, a, r) {
            for (var n = 0; n < r; n++) {
              a[n] ^= e[t + n];
            }
          }

          function u(e, t, a, r, n) {
            for (; n--;) {
              a[r++] = e[t++];
            }
          }

          function d(e) {
            if (!e || "number" != typeof e.length) return !1;

            for (var t = 0; t < e.length; t++) {
              if ("number" != typeof e[t]) return !1;
              var a = parseInt(e[t]);
              if (a != e[t] || a < 0 || 256 <= a) return !1;
            }

            return !0;
          }

          function f(e, t) {
            var a = parseInt(e);
            if (e != a) throw new Error("invalid " + t);
            return a;
          }

          function l(t, a, r, o, i, l, h) {
            if (!h) throw new Error("missing callback");
            if (r = f(r, "N"), o = f(o, "r"), i = f(i, "p"), l = f(l, "dkLen"), 0 === r || 0 != (r & r - 1)) throw new Error("N must be power of 2");
            if (p / 128 / o < r) throw new Error("N too large");
            if (p / 128 / i < o) throw new Error("r too large");
            if (!d(t)) throw new Error("password must be an array or buffer");
            if (t = Array.prototype.slice.call(t), !d(a)) throw new Error("salt must be an array or buffer");
            a = Array.prototype.slice.call(a);

            for (var b = n(t, a, 128 * i * o), m = new Uint32Array(32 * i * o), y = 0; y < m.length; y++) {
              var v = 4 * y;
              m[y] = (255 & b[3 + v]) << 24 | (255 & b[2 + v]) << 16 | (255 & b[1 + v]) << 8 | (255 & b[0 + v]) << 0;
            }

            var _,
                g,
                A = new Uint32Array(64 * o),
                w = new Uint32Array(32 * o * r),
                T = 32 * o,
                x = new Uint32Array(16),
                D = new Uint32Array(16),
                C = i * r * 2,
                S = 0,
                E = null,
                B = !1,
                k = 0,
                R = 0,
                W = parseInt(1e3 / o),
                I = void 0 !== e ? e : setTimeout,
                N = function N() {
              if (B) return h(new Error("cancelled"), S / C);

              switch (k) {
                case 0:
                  u(m, g = 32 * R * o, A, 0, T), k = 1, _ = 0;

                case 1:
                  W < (a = r - _) && (a = W);

                  for (var e = 0; e < a; e++) {
                    u(A, 0, w, (_ + e) * T, T), s(A, T, o, x, D);
                  }

                  if (_ += a, S += a, (d = parseInt(1e3 * S / C)) !== E) {
                    if (B = h(null, S / C)) break;
                    E = d;
                  }

                  if (_ < r) break;
                  _ = 0, k = 2;

                case 2:
                  var a, d;

                  for (W < (a = r - _) && (a = W), e = 0; e < a; e++) {
                    var f = A[16 * (2 * o - 1)] & r - 1;
                    c(w, f * T, A, T), s(A, T, o, x, D);
                  }

                  if (_ += a, S += a, (d = parseInt(1e3 * S / C)) !== E) {
                    if (B = h(null, S / C)) break;
                    E = d;
                  }

                  if (_ < r) break;

                  if (u(A, 0, m, g, T), ++R < i) {
                    k = 0;
                    break;
                  }

                  for (b = [], e = 0; e < m.length; e++) {
                    b.push(m[e] >> 0 & 255), b.push(m[e] >> 8 & 255), b.push(m[e] >> 16 & 255), b.push(m[e] >> 24 & 255);
                  }

                  var p = n(t, b, l);
                  return h(null, 1, p);
              }

              I(N);
            };

            N();
          }

          var h, p;
          h = this, p = 2147483647, void 0 !== a ? t.exports = l : h && (h.scrypt && (h._scrypt = h.scrypt), h.scrypt = l);
        }).call(this, e("timers").setImmediate);
      }, {
        timers: 45
      }],
      44: [function (e, a, r) {
        (function (e, t, a) {
          !function (t, a) {
            "use strict";

            if (!t.setImmediate) {
              var r,
                  n,
                  s,
                  o,
                  i = 1,
                  c = {},
                  u = !1,
                  d = t.document,
                  f = Object.getPrototypeOf && Object.getPrototypeOf(t);
              f = f && f.setTimeout ? f : t, r = "[object process]" === {}.toString.call(t.process) ? function () {
                var t = l(arguments);
                return e.nextTick(h(p, t)), t;
              } : function () {
                if (t.postMessage && !t.importScripts) {
                  var e = !0,
                      a = t.onmessage;
                  return t.onmessage = function () {
                    e = !1;
                  }, t.postMessage("", "*"), t.onmessage = a, e;
                }
              }() ? (o = "setImmediate$" + Math.random() + "$", t.addEventListener ? t.addEventListener("message", m, !1) : t.attachEvent("onmessage", m), function () {
                var e = l(arguments);
                return t.postMessage(o + e, "*"), e;
              }) : t.MessageChannel ? ((s = new MessageChannel()).port1.onmessage = function (e) {
                p(e.data);
              }, function () {
                var e = l(arguments);
                return s.port2.postMessage(e), e;
              }) : d && "onreadystatechange" in d.createElement("script") ? (n = d.documentElement, function () {
                var e = l(arguments),
                    t = d.createElement("script");
                return t.onreadystatechange = function () {
                  p(e), t.onreadystatechange = null, n.removeChild(t), t = null;
                }, n.appendChild(t), e;
              }) : function () {
                var e = l(arguments);
                return setTimeout(h(p, e), 0), e;
              }, f.setImmediate = r, f.clearImmediate = b;
            }

            function l(e) {
              return c[i] = h.apply(a, e), i++;
            }

            function h(e) {
              var t = [].slice.call(arguments, 1);
              return function () {
                "function" == typeof e ? e.apply(a, t) : new Function("" + e)();
              };
            }

            function p(e) {
              if (u) setTimeout(h(p, e), 0);else {
                var t = c[e];

                if (t) {
                  u = !0;

                  try {
                    t();
                  } finally {
                    b(e), u = !1;
                  }
                }
              }
            }

            function b(e) {
              delete c[e];
            }

            function m(e) {
              e.source === t && "string" == typeof e.data && 0 === e.data.indexOf(o) && p(+e.data.slice(o.length));
            }
          }("undefined" == typeof self ? void 0 === t ? this : t : self);
        }).call(this, e("_process"), void 0 !== t ? t : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("timers").clearImmediate);
      }, {
        _process: 42,
        timers: 45
      }],
      45: [function (e, a, r) {
        (function (e) {
          a.exports = {
            setImmediate: e.setImmediate
          };
        }).call(this, void 0 !== t ? t : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
      }, {}],
      46: [function (e, a, r) {
        (function (e) {
          var t;

          if (e.crypto && crypto.getRandomValues) {
            var r = new Uint8Array(16);

            t = function t() {
              return crypto.getRandomValues(r), r;
            };
          }

          if (!t) {
            var n = new Array(16);

            t = function t() {
              for (var e, t = 0; t < 16; t++) {
                0 == (3 & t) && (e = 4294967296 * Math.random()), n[t] = e >>> ((3 & t) << 3) & 255;
              }

              return n;
            };
          }

          a.exports = t;
        }).call(this, void 0 !== t ? t : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
      }, {}],
      47: [function (e, t, a) {
        for (var r = e("./rng"), n = [], s = {}, o = 0; o < 256; o++) {
          n[o] = (o + 256).toString(16).substr(1), s[n[o]] = o;
        }

        function i(e, t) {
          var a = t || 0,
              r = n;
          return r[e[a++]] + r[e[a++]] + r[e[a++]] + r[e[a++]] + "-" + r[e[a++]] + r[e[a++]] + "-" + r[e[a++]] + r[e[a++]] + "-" + r[e[a++]] + r[e[a++]] + "-" + r[e[a++]] + r[e[a++]] + r[e[a++]] + r[e[a++]] + r[e[a++]] + r[e[a++]];
        }

        var c = r(),
            u = [1 | c[0], c[1], c[2], c[3], c[4], c[5]],
            d = 16383 & (c[6] << 8 | c[7]),
            f = 0,
            l = 0;

        function h(e, t, a) {
          var n = t && a || 0;
          "string" == typeof e && (t = "binary" == e ? new Array(16) : null, e = null);
          var s = (e = e || {}).random || (e.rng || r)();
          if (s[6] = 15 & s[6] | 64, s[8] = 63 & s[8] | 128, t) for (var o = 0; o < 16; o++) {
            t[n + o] = s[o];
          }
          return t || i(s);
        }

        var p = h;
        p.v1 = function (e, t, a) {
          var r = t && a || 0,
              n = t || [],
              s = void 0 !== (e = e || {}).clockseq ? e.clockseq : d,
              o = void 0 !== e.msecs ? e.msecs : new Date().getTime(),
              c = void 0 !== e.nsecs ? e.nsecs : l + 1,
              h = o - f + (c - l) / 1e4;
          if (h < 0 && void 0 === e.clockseq && (s = s + 1 & 16383), (h < 0 || f < o) && void 0 === e.nsecs && (c = 0), 1e4 <= c) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
          f = o, d = s;
          var p = (1e4 * (268435455 & (o += 122192928e5)) + (l = c)) % 4294967296;
          n[r++] = p >>> 24 & 255, n[r++] = p >>> 16 & 255, n[r++] = p >>> 8 & 255, n[r++] = 255 & p;
          var b = o / 4294967296 * 1e4 & 268435455;
          n[r++] = b >>> 8 & 255, n[r++] = 255 & b, n[r++] = b >>> 24 & 15 | 16, n[r++] = b >>> 16 & 255, n[r++] = s >>> 8 | 128, n[r++] = 255 & s;

          for (var m = e.node || u, y = 0; y < 6; y++) {
            n[r + y] = m[y];
          }

          return t || i(n);
        }, p.v4 = h, p.parse = function (e, t, a) {
          var r = t && a || 0,
              n = 0;

          for (t = t || [], e.toLowerCase().replace(/[0-9a-f]{2}/g, function (e) {
            n < 16 && (t[r + n++] = s[e]);
          }); n < 16;) {
            t[r + n++] = 0;
          }

          return t;
        }, p.unparse = i, t.exports = p;
      }, {
        "./rng": 46
      }],
      48: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        });

        try {
          t.exports.XMLHttpRequest = XMLHttpRequest;
        } catch (e) {
          console.log("Warning: XMLHttpRequest is not defined"), t.exports.XMLHttpRequest = null;
        }
      }, {}],
      49: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var r = e("../utils/properties"),
            n = (s.isProvider = function (e) {
          return r.isType(e, "Provider");
        }, s);

        function s() {
          r.setType(this, "Provider");
        }

        a.Provider = n;
      }, {
        "../utils/properties": 73
      }],
      50: [function (e, t, a) {
        "use strict";

        var r,
            n = this && this.__extends || (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var a in t) {
            t.hasOwnProperty(a) && (e[a] = t[a]);
          }
        }, function (e, t) {
          function a() {
            this.constructor = e;
          }

          r(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
        }),
            s = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var o = e("../utils/address"),
            i = e("../utils/bignumber"),
            c = e("../utils/bytes"),
            u = e("../constants"),
            d = e("../utils/hash"),
            f = e("../utils/networks"),
            l = e("../utils/properties"),
            h = e("../utils/rlp"),
            p = e("../utils/transaction"),
            b = e("../utils/utf8"),
            m = e("../utils/web"),
            y = s(e("../errors")),
            v = e("./abstract-provider");

        function _(e, t) {
          var a = {};

          for (var r in e) {
            try {
              var n = e[r](t[r]);
              void 0 !== n && (a[r] = n);
            } catch (e) {
              throw e.checkKey = r, e.checkValue = t[r], e;
            }
          }

          return a;
        }

        function g(e, t) {
          return function (a) {
            return null == a ? t : e(a);
          };
        }

        function A(e) {
          return function (t) {
            if (!Array.isArray(t)) throw new Error("not an array");
            var a = [];
            return t.forEach(function (t) {
              a.push(e(t));
            }), a;
          };
        }

        function w(e, t) {
          return "string" == typeof e && (t || "0x" === e.substring(0, 2) || (e = "0x" + e), 32 === c.hexDataLength(e)) ? e.toLowerCase() : (y.throwError("invalid hash", y.INVALID_ARGUMENT, {
            arg: "hash",
            value: e
          }), null);
        }

        function T(e) {
          return i.bigNumberify(e).toNumber();
        }

        function x(e) {
          if (!c.isHexString(e)) throw new Error("invalid uint256");

          for (; e.length < 66;) {
            e = "0x0" + e.substring(2);
          }

          return e;
        }

        function D(e) {
          if (null == e) return "latest";
          if ("earliest" === e) return "0x0";
          if ("latest" === e || "pending" === e) return e;
          if ("number" == typeof e) return c.hexStripZeros(c.hexlify(e));
          if (c.isHexString(e)) return c.hexStripZeros(e);
          throw new Error("invalid blockTag");
        }

        var C = {
          hash: w,
          blockHash: g(w, null),
          blockNumber: g(T, null),
          transactionIndex: g(T, null),
          confirmations: g(T, null),
          from: o.getAddress,
          gasPrice: i.bigNumberify,
          gasLimit: i.bigNumberify,
          to: g(o.getAddress, null),
          value: i.bigNumberify,
          nonce: T,
          data: c.hexlify,
          r: g(x),
          s: g(x),
          v: g(T),
          creates: g(o.getAddress, null),
          raw: g(c.hexlify)
        };

        function S(e) {
          if (null != e.gas && null == e.gasLimit && (e.gasLimit = e.gas), e.to && i.bigNumberify(e.to).isZero() && (e.to = "0x0000000000000000000000000000000000000000"), null != e.input && null == e.data && (e.data = e.input), null == e.to && null == e.creates && (e.creates = o.getContractAddress(e)), !e.raw && e.v && e.r && e.s) {
            var t = [c.stripZeros(c.hexlify(e.nonce)), c.stripZeros(c.hexlify(e.gasPrice)), c.stripZeros(c.hexlify(e.gasLimit)), e.to || "0x", c.stripZeros(c.hexlify(e.value || "0x")), c.hexlify(e.data || "0x"), c.stripZeros(c.hexlify(e.v || "0x")), c.stripZeros(c.hexlify(e.r)), c.stripZeros(c.hexlify(e.s))];
            e.raw = h.encode(t);
          }

          var a = _(C, e),
              r = e.networkId;

          return null != e.chainId && null == r && null == a.v && (r = e.chainId), c.isHexString(r) && (r = i.bigNumberify(r).toNumber()), "number" != typeof r && null != a.v && ((r = (a.v - 35) / 2) < 0 && (r = 0), r = parseInt(r)), "number" != typeof r && (r = 0), a.networkId = r, a.blockHash && "x" === a.blockHash.replace(/0/g, "") && (a.blockHash = null), a;
        }

        var E = {
          hash: w,
          parentHash: w,
          number: T,
          timestamp: T,
          nonce: g(c.hexlify),
          difficulty: function difficulty(e) {
            var t = i.bigNumberify(e);

            try {
              return t.toNumber();
            } catch (e) {}

            return null;
          },
          gasLimit: i.bigNumberify,
          gasUsed: i.bigNumberify,
          miner: o.getAddress,
          extraData: c.hexlify,
          transactions: g(A(w))
        },
            B = l.shallowCopy(E);

        function k(e, t) {
          return null != e.author && null == e.miner && (e.miner = e.author), _(t ? B : E, e);
        }

        B.transactions = g(A(S));
        var R = {
          from: g(o.getAddress),
          nonce: g(T),
          gasLimit: g(i.bigNumberify),
          gasPrice: g(i.bigNumberify),
          to: g(o.getAddress),
          value: g(i.bigNumberify),
          data: g(c.hexlify)
        };

        function W(e) {
          return _(R, e);
        }

        var I = {
          transactionLogIndex: g(T),
          transactionIndex: T,
          blockNumber: T,
          transactionHash: w,
          address: o.getAddress,
          topics: A(w),
          data: c.hexlify,
          logIndex: T,
          blockHash: w
        },
            N = {
          to: g(o.getAddress, null),
          from: g(o.getAddress, null),
          contractAddress: g(o.getAddress, null),
          transactionIndex: T,
          root: g(w),
          gasUsed: i.bigNumberify,
          logsBloom: g(c.hexlify),
          blockHash: w,
          transactionHash: w,
          logs: A(function (e) {
            return _(I, e);
          }),
          blockNumber: T,
          confirmations: g(T, null),
          cumulativeGasUsed: i.bigNumberify,
          status: g(T)
        };

        function M(e) {
          return Array.isArray(e) ? e.forEach(function (e) {
            M(e);
          }) : null != e && w(e), e;
        }

        var P,
            L = {
          fromBlock: g(D, void 0),
          toBlock: g(D, void 0),
          address: g(o.getAddress, void 0),
          topics: g(M, void 0)
        },
            O = {
          blockHash: g(w, void 0),
          address: g(o.getAddress, void 0),
          topics: g(M, void 0)
        },
            F = {
          blockNumber: g(T),
          blockHash: g(w),
          transactionIndex: T,
          removed: g(function (e) {
            if ("boolean" == typeof e) return e;

            if ("string" == typeof e) {
              if ("true" === e) return !0;
              if ("false" === e) return !1;
            }

            throw new Error("invaid boolean - " + e);
          }),
          address: o.getAddress,
          data: (P = c.hexlify, function (e) {
            return e ? P(e) : "0x";
          }),
          topics: A(w),
          transactionHash: w,
          logIndex: T
        };

        function j(e) {
          return _(F, e);
        }

        function G(e) {
          return e.map(function (e) {
            return "string" == typeof e ? e : Array.isArray(e) ? (e.forEach(function (e) {
              null !== e && 32 !== c.hexDataLength(e) && y.throwError("invalid topic", y.INVALID_ARGUMENT, {
                argument: "topic",
                value: e
              });
            }), e.join(",")) : null === e ? "" : y.throwError("invalid topic value", y.INVALID_ARGUMENT, {
              argument: "topic",
              value: e
            });
          }).join("&");
        }

        function V(e) {
          if ("string" == typeof e) {
            if (20 === c.hexDataLength(e)) return "address:" + o.getAddress(e);
            if (e = e.toLowerCase(), 32 === c.hexDataLength(e)) return "tx:" + e;
            if (-1 === e.indexOf(":")) return e;
          } else {
            if (Array.isArray(e)) return "filter::" + G(e);
            if (e && "object" == typeof e) return "filter:" + (e.address || "") + ":" + G(e.topics || []);
          }

          throw new Error("invalid event - " + e);
        }

        function U() {
          return new Date().getTime();
        }

        var H,
            z = (n(K, H = v.Provider), K.prototype._doPoll = function () {
          var e = this;
          this.getBlockNumber().then(function (t) {
            if (e._setFastBlockNumber(t), t !== e._lastBlockNumber) {
              -2 === e._emitted.block && (e._emitted.block = t - 1);

              for (var a = e._emitted.block + 1; a <= t; a++) {
                e.emit("block", a);
              }

              e._emitted.block !== t && (e._emitted.block = t, Object.keys(e._emitted).forEach(function (a) {
                if ("block" !== a) {
                  var r = e._emitted[a];
                  "pending" !== r && 12 < t - r && delete e._emitted[a];
                }
              })), -2 === e._lastBlockNumber && (e._lastBlockNumber = t - 1);
              var r = {},
                  n = {};
              return e._events.forEach(function (e) {
                n[e.tag] = !0;
              }), Object.keys(n).forEach(function (a) {
                var n = a.split(":");

                switch (n[0]) {
                  case "tx":
                    var s = n[1];
                    e.getTransactionReceipt(s).then(function (t) {
                      return t && null != t.blockNumber && (e._emitted["t:" + s] = t.blockNumber, e.emit(s, t)), null;
                    }).catch(function (t) {
                      e.emit("error", t);
                    });
                    break;

                  case "address":
                    var o = n[1];
                    e._balances[o] && (r[o] = e._balances[o]), e.getBalance(o, "latest").then(function (t) {
                      var a = e._balances[o];
                      if (!a || !t.eq(a)) return e._balances[o] = t, e.emit(o, t), null;
                    }).catch(function (t) {
                      e.emit("error", t);
                    });
                    break;

                  case "filter":
                    var i = n[2].split(/&/g).map(function (e) {
                      var t = e.split(",");
                      return 1 === t.length ? "" === t[0] ? null : e : t.map(function (e) {
                        return "" === e ? null : e;
                      });
                    }),
                        c = {
                      address: n[1],
                      fromBlock: e._lastBlockNumber + 1,
                      toBlock: t,
                      topics: i
                    };
                    c.address || delete c.address, e.getLogs(c).then(function (t) {
                      if (0 !== t.length) return t.forEach(function (t) {
                        e._emitted["b:" + t.blockHash] = t.blockNumber, e._emitted["t:" + t.transactionHash] = t.blockNumber, e.emit(c, t);
                      }), null;
                    }).catch(function (t) {
                      e.emit("error", t);
                    });
                }
              }), e._lastBlockNumber = t, e._balances = r, null;
            }
          }).catch(function (e) {}), this.doPoll();
        }, K.prototype.resetEventsBlock = function (e) {
          this._lastBlockNumber = e - 1, this.polling && this._doPoll();
        }, Object.defineProperty(K.prototype, "network", {
          get: function get() {
            return this._network;
          },
          enumerable: !0,
          configurable: !0
        }), K.prototype.getNetwork = function () {
          return this.ready;
        }, Object.defineProperty(K.prototype, "blockNumber", {
          get: function get() {
            return this._fastBlockNumber;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(K.prototype, "polling", {
          get: function get() {
            return null != this._poller;
          },
          set: function set(e) {
            var t = this;
            setTimeout(function () {
              e && !t._poller ? t._poller = setInterval(t._doPoll.bind(t), t.pollingInterval) : !e && t._poller && (clearInterval(t._poller), t._poller = null);
            }, 0);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(K.prototype, "pollingInterval", {
          get: function get() {
            return this._pollingInterval;
          },
          set: function set(e) {
            var t = this;
            if ("number" != typeof e || e <= 0 || parseInt(String(e)) != e) throw new Error("invalid polling interval");
            this._pollingInterval = e, this._poller && (clearInterval(this._poller), this._poller = setInterval(function () {
              t._doPoll();
            }, this._pollingInterval));
          },
          enumerable: !0,
          configurable: !0
        }), K.prototype._getFastBlockNumber = function () {
          var e = this,
              t = U();
          return t - this._fastQueryDate > 2 * this._pollingInterval && (this._fastQueryDate = t, this._fastBlockNumberPromise = this.getBlockNumber().then(function (t) {
            return (null == e._fastBlockNumber || t > e._fastBlockNumber) && (e._fastBlockNumber = t), e._fastBlockNumber;
          })), this._fastBlockNumberPromise;
        }, K.prototype._setFastBlockNumber = function (e) {
          null != this._fastBlockNumber && e < this._fastBlockNumber || (this._fastQueryDate = U(), (null == this._fastBlockNumber || e > this._fastBlockNumber) && (this._fastBlockNumber = e, this._fastBlockNumberPromise = Promise.resolve(e)));
        }, K.prototype.waitForTransaction = function (e, t) {
          var a = this;
          return null == t && (t = 1), this.getTransactionReceipt(e).then(function (r) {
            return 0 === t || r && r.confirmations >= t ? r : new Promise(function (r) {
              var n = function n(s) {
                s.confirmations < t || (a.removeListener(e, n), r(s));
              };

              a.on(e, n);
            });
          });
        }, K.prototype.getBlockNumber = function () {
          var e = this;
          return this.ready.then(function () {
            return e.perform("getBlockNumber", {}).then(function (t) {
              var a = parseInt(t);
              if (a != t) throw new Error("invalid response - getBlockNumber");
              return e._setFastBlockNumber(a), a;
            });
          });
        }, K.prototype.getGasPrice = function () {
          var e = this;
          return this.ready.then(function () {
            return e.perform("getGasPrice", {}).then(function (e) {
              return i.bigNumberify(e);
            });
          });
        }, K.prototype.getBalance = function (e, t) {
          var a = this;
          return this.ready.then(function () {
            return l.resolveProperties({
              addressOrName: e,
              blockTag: t
            }).then(function (e) {
              var t = e.addressOrName,
                  r = e.blockTag;
              return a._getAddress(t).then(function (e) {
                var t = {
                  address: e,
                  blockTag: D(r)
                };
                return a.perform("getBalance", t).then(function (e) {
                  return i.bigNumberify(e);
                });
              });
            });
          });
        }, K.prototype.getTransactionCount = function (e, t) {
          var a = this;
          return this.ready.then(function () {
            return l.resolveProperties({
              addressOrName: e,
              blockTag: t
            }).then(function (e) {
              var t = e.addressOrName,
                  r = e.blockTag;
              return a._getAddress(t).then(function (e) {
                var t = {
                  address: e,
                  blockTag: D(r)
                };
                return a.perform("getTransactionCount", t).then(function (e) {
                  return i.bigNumberify(e).toNumber();
                });
              });
            });
          });
        }, K.prototype.getCode = function (e, t) {
          var a = this;
          return this.ready.then(function () {
            return l.resolveProperties({
              addressOrName: e,
              blockTag: t
            }).then(function (e) {
              var t = e.addressOrName,
                  r = e.blockTag;
              return a._getAddress(t).then(function (e) {
                var t = {
                  address: e,
                  blockTag: D(r)
                };
                return a.perform("getCode", t).then(function (e) {
                  return c.hexlify(e);
                });
              });
            });
          });
        }, K.prototype.getStorageAt = function (e, t, a) {
          var r = this;
          return this.ready.then(function () {
            return l.resolveProperties({
              addressOrName: e,
              position: t,
              blockTag: a
            }).then(function (e) {
              var t = e.addressOrName,
                  a = e.position,
                  n = e.blockTag;
              return r._getAddress(t).then(function (e) {
                var t = {
                  address: e,
                  blockTag: D(n),
                  position: c.hexStripZeros(c.hexlify(a))
                };
                return r.perform("getStorageAt", t).then(function (e) {
                  return c.hexlify(e);
                });
              });
            });
          });
        }, K.prototype.sendTransaction = function (e) {
          var t = this;
          return this.ready.then(function () {
            return l.resolveProperties({
              signedTransaction: e
            }).then(function (e) {
              var a = e.signedTransaction,
                  r = {
                signedTransaction: c.hexlify(a)
              };
              return t.perform("sendTransaction", r).then(function (e) {
                return t._wrapTransaction(p.parse(a), e);
              }, function (e) {
                throw e.transaction = p.parse(a), e.transaction.hash && (e.transactionHash = e.transaction.hash), e;
              });
            });
          });
        }, K.prototype._wrapTransaction = function (e, t) {
          var a = this;
          if (null != t && 32 !== c.hexDataLength(t)) throw new Error("invalid response - sendTransaction");
          var r = e;
          return null != t && e.hash !== t && y.throwError("Transaction hash mismatch from Provider.sendTransaction.", y.UNKNOWN_ERROR, {
            expectedHash: e.hash,
            returnedHash: t
          }), r.wait = function (t) {
            return 0 !== t && (a._emitted["t:" + e.hash] = "pending"), a.waitForTransaction(e.hash, t).then(function (r) {
              return null == r && 0 === t ? null : (a._emitted["t:" + e.hash] = r.blockNumber, 0 === r.status && y.throwError("transaction failed", y.CALL_EXCEPTION, {
                transactionHash: e.hash,
                transaction: e
              }), r);
            });
          }, r;
        }, K.prototype.call = function (e, t) {
          var a = this,
              r = l.shallowCopy(e);
          return this.ready.then(function () {
            return l.resolveProperties({
              blockTag: t,
              tx: r
            }).then(function (e) {
              var t = e.blockTag,
                  r = e.tx;
              return a._resolveNames(r, ["to", "from"]).then(function (e) {
                var r = {
                  blockTag: D(t),
                  transaction: W(e)
                };
                return a.perform("call", r).then(function (e) {
                  return c.hexlify(e);
                });
              });
            });
          });
        }, K.prototype.estimateGas = function (e) {
          var t = this,
              a = {
            to: e.to,
            from: e.from,
            data: e.data,
            gasPrice: e.gasPrice,
            value: e.value
          };
          return this.ready.then(function () {
            return l.resolveProperties(a).then(function (e) {
              return t._resolveNames(e, ["to", "from"]).then(function (e) {
                var a = {
                  transaction: W(e)
                };
                return t.perform("estimateGas", a).then(function (e) {
                  return i.bigNumberify(e);
                });
              });
            });
          });
        }, K.prototype.getBlock = function (e, t) {
          var a = this;
          return this.ready.then(function () {
            return l.resolveProperties({
              blockHashOrBlockTag: e
            }).then(function (e) {
              var r = e.blockHashOrBlockTag;

              try {
                var n = c.hexlify(r);
                if (32 === c.hexDataLength(n)) return m.poll(function () {
                  return a.perform("getBlock", {
                    blockHash: n,
                    includeTransactions: !!t
                  }).then(function (e) {
                    return null == e ? null == a._emitted["b:" + n] ? null : void 0 : k(e, t);
                  });
                }, {
                  onceBlock: a
                });
              } catch (e) {}

              try {
                var s = -128,
                    o = D(r);
                return c.isHexString(o) && (s = parseInt(o.substring(2), 16)), m.poll(function () {
                  return a.perform("getBlock", {
                    blockTag: o,
                    includeTransactions: !!t
                  }).then(function (e) {
                    return null != e ? k(e, t) : s <= a._emitted.block ? void 0 : null;
                  });
                }, {
                  onceBlock: a
                });
              } catch (e) {}

              throw new Error("invalid block hash or block tag");
            });
          });
        }, K.prototype.getTransaction = function (e) {
          var t = this;
          return this.ready.then(function () {
            return l.resolveProperties({
              transactionHash: e
            }).then(function (e) {
              var a = e.transactionHash,
                  r = {
                transactionHash: w(a, !0)
              };
              return m.poll(function () {
                return t.perform("getTransaction", r).then(function (e) {
                  if (null == e) return null == t._emitted["t:" + a] ? null : void 0;
                  var r = K.checkTransactionResponse(e);
                  if (null == r.blockNumber) r.confirmations = 0;else if (null == r.confirmations) return t._getFastBlockNumber().then(function (e) {
                    var a = e - r.blockNumber + 1;
                    return a <= 0 && (a = 1), r.confirmations = a, t._wrapTransaction(r);
                  });
                  return t._wrapTransaction(r);
                });
              }, {
                onceBlock: t
              });
            });
          });
        }, K.prototype.getTransactionReceipt = function (e) {
          var t = this;
          return this.ready.then(function () {
            return l.resolveProperties({
              transactionHash: e
            }).then(function (e) {
              var a = e.transactionHash,
                  r = {
                transactionHash: w(a, !0)
              };
              return m.poll(function () {
                return t.perform("getTransactionReceipt", r).then(function (e) {
                  if (null == e) return null == t._emitted["t:" + a] ? null : void 0;

                  if (null != e.blockHash) {
                    var r = function (e) {
                      var t = _(N, e);

                      return t.logs.forEach(function (e, t) {
                        null == e.transactionLogIndex && (e.transactionLogIndex = t);
                      }), null != e.status && (t.byzantium = !0), t;
                    }(e);

                    if (null == r.blockNumber) r.confirmations = 0;else if (null == r.confirmations) return t._getFastBlockNumber().then(function (e) {
                      var t = e - r.blockNumber + 1;
                      return t <= 0 && (t = 1), r.confirmations = t, r;
                    });
                    return r;
                  }
                });
              }, {
                onceBlock: t
              });
            });
          });
        }, K.prototype.getLogs = function (e) {
          var t = this;
          return this.ready.then(function () {
            return l.resolveProperties(e).then(function (e) {
              return t._resolveNames(e, ["address"]).then(function (e) {
                var a = {
                  filter: function (e) {
                    return e && e.blockHash ? _(O, e) : _(L, e);
                  }(e)
                };
                return t.perform("getLogs", a).then(function (e) {
                  return A(j)(e);
                });
              });
            });
          });
        }, K.prototype.getEtherPrice = function () {
          var e = this;
          return this.ready.then(function () {
            return e.perform("getEtherPrice", {}).then(function (e) {
              return e;
            });
          });
        }, K.prototype._getAddress = function (e) {
          return this.resolveName(e).then(function (t) {
            return null == t && y.throwError("ENS name not configured", y.UNSUPPORTED_OPERATION, {
              operation: "resolveName(" + JSON.stringify(e) + ")"
            }), t;
          });
        }, K.prototype._resolveNames = function (e, t) {
          var a = [],
              r = l.shallowCopy(e);
          return t.forEach(function (e) {
            null != r[e] && a.push(this._getAddress(r[e]).then(function (t) {
              r[e] = t;
            }));
          }, this), Promise.all(a).then(function () {
            return r;
          });
        }, K.prototype._getResolver = function (e) {
          var t = this;
          return this.getNetwork().then(function (a) {
            a.ensAddress || y.throwError("network does support ENS", y.UNSUPPORTED_OPERATION, {
              operation: "ENS",
              network: a.name
            });
            var r = "0x0178b8bf" + d.namehash(e).substring(2),
                n = {
              to: a.ensAddress,
              data: r
            };
            return t.call(n).then(function (e) {
              if (32 !== c.hexDataLength(e)) return null;
              var t = o.getAddress(c.hexDataSlice(e, 12));
              return t === u.AddressZero ? null : t;
            });
          });
        }, K.prototype.resolveName = function (e) {
          var t = this;
          if (e instanceof Promise) return e.then(function (e) {
            return t.resolveName(e);
          });

          try {
            return Promise.resolve(o.getAddress(e));
          } catch (e) {}

          var a = this,
              r = d.namehash(e);
          return this._getResolver(e).then(function (e) {
            if (null == e) return null;
            var t = {
              to: e,
              data: "0x3b3b57de" + r.substring(2)
            };
            return a.call(t);
          }).then(function (e) {
            if (32 !== c.hexDataLength(e)) return null;
            var t = o.getAddress(c.hexDataSlice(e, 12));
            return t === u.AddressZero ? null : t;
          });
        }, K.prototype.lookupAddress = function (e) {
          var t = this;
          if (e instanceof Promise) return e.then(function (e) {
            return t.lookupAddress(e);
          });
          var a = (e = o.getAddress(e)).substring(2) + ".addr.reverse",
              r = d.namehash(a),
              n = this;
          return this._getResolver(a).then(function (e) {
            if (!e) return null;
            var t = {
              to: e,
              data: "0x691f3431" + r.substring(2)
            };
            return n.call(t);
          }).then(function (t) {
            if ((t = t.substring(2)).length < 64) return null;
            if ((t = t.substring(64)).length < 64) return null;
            var a = i.bigNumberify("0x" + t.substring(0, 64)).toNumber();
            if (2 * a > (t = t.substring(64)).length) return null;
            var r = b.toUtf8String("0x" + t.substring(0, 2 * a));
            return n.resolveName(r).then(function (t) {
              return t != e ? null : r;
            });
          });
        }, K.checkTransactionResponse = function (e) {
          return S(e);
        }, K.prototype.doPoll = function () {}, K.prototype.perform = function (e, t) {
          return y.throwError(e + " not implemented", y.NOT_IMPLEMENTED, {
            operation: e
          }), null;
        }, K.prototype._startPending = function () {
          y.warn("WARNING: this provider does not support pending events");
        }, K.prototype._stopPending = function () {}, K.prototype._addEventListener = function (e, t, a) {
          this._events.push({
            tag: V(e),
            listener: t,
            once: a
          }), "pending" === e && this._startPending(), this.polling = !0;
        }, K.prototype.on = function (e, t) {
          return this._addEventListener(e, t, !1), this;
        }, K.prototype.once = function (e, t) {
          return this._addEventListener(e, t, !0), this;
        }, K.prototype.addEventListener = function (e, t) {
          return this.on(e, t);
        }, K.prototype.emit = function (e) {
          for (var t = this, a = [], r = 1; r < arguments.length; r++) {
            a[r - 1] = arguments[r];
          }

          var n = !1,
              s = V(e);
          return this._events = this._events.filter(function (e) {
            return e.tag !== s || (setTimeout(function () {
              e.listener.apply(t, a);
            }, 0), n = !0, !e.once);
          }), 0 === this.listenerCount() && (this.polling = !1), n;
        }, K.prototype.listenerCount = function (e) {
          if (!e) return this._events.length;
          var t = V(e);
          return this._events.filter(function (e) {
            return e.tag === t;
          }).length;
        }, K.prototype.listeners = function (e) {
          var t = V(e);
          return this._events.filter(function (e) {
            return e.tag === t;
          }).map(function (e) {
            return e.listener;
          });
        }, K.prototype.removeAllListeners = function (e) {
          if (null == e) this._events = [], this._stopPending();else {
            var t = V(e);
            this._events = this._events.filter(function (e) {
              return e.tag !== t;
            }), "pending" === e && this._stopPending();
          }
          return 0 === this._events.length && (this.polling = !1), this;
        }, K.prototype.removeListener = function (e, t) {
          var a = !1,
              r = V(e);
          return this._events = this._events.filter(function (e) {
            return e.tag !== r || e.listener != t || !!a || !(a = !0);
          }), "pending" === e && 0 === this.listenerCount("pending") && this._stopPending(), 0 === this.listenerCount() && (this.polling = !1), this;
        }, K);

        function K(e) {
          var t = H.call(this) || this;
          if (y.checkNew(t, v.Provider), e instanceof Promise) l.defineReadOnly(t, "ready", e.then(function (e) {
            return l.defineReadOnly(t, "_network", e), e;
          })), t.ready.catch(function (e) {});else {
            var a = f.getNetwork(null == e ? "homestead" : e);
            a ? (l.defineReadOnly(t, "_network", a), l.defineReadOnly(t, "ready", Promise.resolve(t._network))) : y.throwError("invalid network", y.INVALID_ARGUMENT, {
              arg: "network",
              value: e
            });
          }
          return t._lastBlockNumber = -2, t._balances = {}, t._events = [], t._pollingInterval = 4e3, t._emitted = {
            block: -2
          }, t._fastQueryDate = 0, t;
        }

        a.BaseProvider = z, l.defineReadOnly(v.Provider, "inherits", l.inheritable(v.Provider));
      }, {
        "../constants": 3,
        "../errors": 5,
        "../utils/address": 59,
        "../utils/bignumber": 62,
        "../utils/bytes": 63,
        "../utils/hash": 64,
        "../utils/networks": 71,
        "../utils/properties": 73,
        "../utils/rlp": 75,
        "../utils/transaction": 82,
        "../utils/utf8": 84,
        "../utils/web": 85,
        "./abstract-provider": 49
      }],
      51: [function (e, t, a) {
        "use strict";

        var r,
            n = this && this.__extends || (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var a in t) {
            t.hasOwnProperty(a) && (e[a] = t[a]);
          }
        }, function (e, t) {
          function a() {
            this.constructor = e;
          }

          r(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
        }),
            s = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var o = e("./base-provider"),
            i = e("../utils/bytes"),
            c = e("../utils/properties"),
            u = e("../utils/web"),
            d = s(e("../errors"));

        function f(e) {
          var t = [];

          for (var a in e) {
            if (null != e[a]) {
              var r = i.hexlify(e[a]);
              !{
                gasLimit: !0,
                gasPrice: !0,
                nonce: !0,
                value: !0
              }[a] || (r = i.hexStripZeros(r)), t.push(a + "=" + r);
            }
          }

          return t.join("&");
        }

        function l(e) {
          if (0 == e.status && ("No records found" === e.message || "No transactions found" === e.message)) return e.result;
          if (1 == e.status && "OK" == e.message) return e.result;
          var t = new Error("invalid response");
          throw t.result = JSON.stringify(e), t;
        }

        function h(e) {
          if ("2.0" != e.jsonrpc) throw (t = new Error("invalid response")).result = JSON.stringify(e), t;

          if (e.error) {
            var t = new Error(e.error.message || "unknown error");
            throw e.error.code && (t.code = e.error.code), e.error.data && (t.data = e.error.data), t;
          }

          return e.result;
        }

        function p(e) {
          if ("pending" === e) throw new Error("pending not supported");
          return "latest" === e ? e : parseInt(e.substring(2), 16);
        }

        var b,
            m = (n(y, b = o.BaseProvider), y.prototype.perform = function (e, t) {
          var a = this,
              r = this.baseUrl,
              n = "";

          function s(e, t) {
            return u.fetchJson(e, null, t || h).then(function (t) {
              return a.emit("debug", {
                action: "perform",
                request: e,
                response: t,
                provider: a
              }), t;
            });
          }

          switch (this.apiKey && (n += "&apikey=" + this.apiKey), e) {
            case "getBlockNumber":
              return s(r += "/api?module=proxy&action=eth_blockNumber" + n);

            case "getGasPrice":
              return s(r += "/api?module=proxy&action=eth_gasPrice" + n);

            case "getBalance":
              return r += "/api?module=account&action=balance&address=" + t.address, s(r += "&tag=" + t.blockTag + n, l);

            case "getTransactionCount":
              return r += "/api?module=proxy&action=eth_getTransactionCount&address=" + t.address, s(r += "&tag=" + t.blockTag + n);

            case "getCode":
              return r += "/api?module=proxy&action=eth_getCode&address=" + t.address, s(r += "&tag=" + t.blockTag + n, h);

            case "getStorageAt":
              return r += "/api?module=proxy&action=eth_getStorageAt&address=" + t.address, r += "&position=" + t.position, s(r += "&tag=" + t.blockTag + n, h);

            case "sendTransaction":
              return r += "/api?module=proxy&action=eth_sendRawTransaction&hex=" + t.signedTransaction, s(r += n).catch(function (e) {
                throw e.responseText && (0 <= e.responseText.toLowerCase().indexOf("insufficient funds") && d.throwError("insufficient funds", d.INSUFFICIENT_FUNDS, {}), 0 <= e.responseText.indexOf("same hash was already imported") && d.throwError("nonce has already been used", d.NONCE_EXPIRED, {}), 0 <= e.responseText.indexOf("another transaction with same nonce") && d.throwError("replacement fee too low", d.REPLACEMENT_UNDERPRICED, {})), e;
              });

            case "getBlock":
              if (t.blockTag) return r += "/api?module=proxy&action=eth_getBlockByNumber&tag=" + t.blockTag, t.includeTransactions ? r += "&boolean=true" : r += "&boolean=false", s(r += n);
              throw new Error("getBlock by blockHash not implmeneted");

            case "getTransaction":
              return r += "/api?module=proxy&action=eth_getTransactionByHash&txhash=" + t.transactionHash, s(r += n);

            case "getTransactionReceipt":
              return r += "/api?module=proxy&action=eth_getTransactionReceipt&txhash=" + t.transactionHash, s(r += n);

            case "call":
              if (r += "/api?module=proxy&action=eth_call" + (o = (o = f(t.transaction)) && "&" + o), "latest" !== t.blockTag) throw new Error("EtherscanProvider does not support blockTag for call");
              return s(r += n);

            case "estimateGas":
              var o;
              return r += "/api?module=proxy&action=eth_estimateGas&" + (o = (o = f(t.transaction)) && "&" + o), s(r += n);

            case "getLogs":
              r += "/api?module=logs&action=getLogs";

              try {
                if (t.filter.fromBlock && (r += "&fromBlock=" + p(t.filter.fromBlock)), t.filter.toBlock && (r += "&toBlock=" + p(t.filter.toBlock)), t.filter.blockHash) try {
                  d.throwError("Etherscan does not support blockHash filters", d.UNSUPPORTED_OPERATION, {
                    operation: "getLogs(blockHash)"
                  });
                } catch (e) {
                  return Promise.reject(e);
                }

                if (t.filter.address && (r += "&address=" + t.filter.address), t.filter.topics && 0 < t.filter.topics.length) {
                  if (1 < t.filter.topics.length) throw new Error("unsupported topic format");
                  var i = t.filter.topics[0];
                  if ("string" != typeof i || 66 !== i.length) throw new Error("unsupported topic0 format");
                  r += "&topic0=" + i;
                }
              } catch (e) {
                return Promise.reject(e);
              }

              var c = this;
              return s(r += n, l).then(function (e) {
                var t = {},
                    a = Promise.resolve();
                return e.forEach(function (e) {
                  a = a.then(function () {
                    return null != e.blockHash ? null : (e.blockHash = t[e.transactionHash], null == e.blockHash ? c.getTransaction(e.transactionHash).then(function (a) {
                      return t[e.transactionHash] = a.blockHash, e.blockHash = a.blockHash, null;
                    }) : null);
                  });
                }), a.then(function () {
                  return e;
                });
              });

            case "getEtherPrice":
              return "homestead" !== this.network.name ? Promise.resolve(0) : (r += "/api?module=stats&action=ethprice", s(r += n, l).then(function (e) {
                return parseFloat(e.ethusd);
              }));
          }

          return b.prototype.perform.call(this, e, t);
        }, y.prototype.getHistory = function (e, t, a) {
          var r = this,
              n = this.baseUrl,
              s = "";
          return this.apiKey && (s += "&apikey=" + this.apiKey), null == t && (t = 0), null == a && (a = 99999999), this.resolveName(e).then(function (e) {
            return n += "/api?module=account&action=txlist&address=" + e, n += "&startblock=" + t, n += "&endblock=" + a, n += "&sort=asc" + s, u.fetchJson(n, null, l).then(function (e) {
              r.emit("debug", {
                action: "getHistory",
                request: n,
                response: e,
                provider: r
              });
              var t = [];
              return e.forEach(function (e) {
                ["contractAddress", "to"].forEach(function (t) {
                  "" == e[t] && delete e[t];
                }), null == e.creates && null != e.contractAddress && (e.creates = e.contractAddress);
                var a = o.BaseProvider.checkTransactionResponse(e);
                e.timeStamp && (a.timestamp = parseInt(e.timeStamp)), t.push(a);
              }), t;
            });
          });
        }, y);

        function y(e, t) {
          var a = b.call(this, e) || this;
          d.checkNew(a, y);
          var r = "invalid";
          a.network && (r = a.network.name);
          var n = null;

          switch (r) {
            case "homestead":
              n = "https://api.etherscan.io";
              break;

            case "ropsten":
              n = "https://api-ropsten.etherscan.io";
              break;

            case "rinkeby":
              n = "https://api-rinkeby.etherscan.io";
              break;

            case "kovan":
              n = "https://api-kovan.etherscan.io";
              break;

            case "goerli":
              n = "https://api-goerli.etherscan.io";
              break;

            default:
              throw new Error("unsupported network");
          }

          return c.defineReadOnly(a, "baseUrl", n), c.defineReadOnly(a, "apiKey", t), a;
        }

        a.EtherscanProvider = m;
      }, {
        "../errors": 5,
        "../utils/bytes": 63,
        "../utils/properties": 73,
        "../utils/web": 85,
        "./base-provider": 50
      }],
      52: [function (e, t, a) {
        "use strict";

        var r,
            n = this && this.__extends || (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var a in t) {
            t.hasOwnProperty(a) && (e[a] = t[a]);
          }
        }, function (e, t) {
          function a() {
            this.constructor = e;
          }

          r(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
        }),
            s = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var o = e("./base-provider"),
            i = s(e("../errors"));

        function c(e) {
          var t = !0,
              a = null;
          return e.forEach(function (r) {
            null != r ? null != a ? a.name === r.name && a.chainId === r.chainId && (a.ensAddress === r.ensAddress || null == a.ensAddress && null == r.ensAddress) || i.throwError("provider mismatch", i.INVALID_ARGUMENT, {
              arg: "networks",
              value: e
            }) : a = r : t = !1;
          }), t;
        }

        var u,
            d = (n(f, u = o.BaseProvider), Object.defineProperty(f.prototype, "providers", {
          get: function get() {
            return this._providers.slice(0);
          },
          enumerable: !0,
          configurable: !0
        }), f.prototype.perform = function (e, t) {
          var a = this.providers;
          return new Promise(function (r, n) {
            var s = null;
            !function o() {
              a.length ? a.shift().perform(e, t).then(function (e) {
                return r(e);
              }).catch(function (e) {
                s = s || e, setTimeout(o, 0);
              }) : n(s);
            }();
          });
        }, f);

        function f(e) {
          var t = this;
          if (0 === e.length) throw new Error("no providers");
          if (c(e.map(function (e) {
            return e.network;
          }))) t = u.call(this, e[0].network) || this;else {
            var a = Promise.all(e.map(function (e) {
              return e.getNetwork();
            })).then(function (e) {
              return c(e) || i.throwError("getNetwork returned null", i.UNKNOWN_ERROR, {}), e[0];
            });
            t = u.call(this, a) || this;
          }
          return i.checkNew(t, f), t._providers = e.slice(0), t;
        }

        a.FallbackProvider = d;
      }, {
        "../errors": 5,
        "./base-provider": 50
      }],
      53: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var r = e("./abstract-provider");
        a.Provider = r.Provider;
        var n = e("./base-provider");
        a.BaseProvider = n.BaseProvider;
        var s = e("./etherscan-provider");
        a.EtherscanProvider = s.EtherscanProvider;
        var o = e("./fallback-provider");
        a.FallbackProvider = o.FallbackProvider;
        var i = e("./ipc-provider");
        a.IpcProvider = i.IpcProvider;
        var c = e("./infura-provider");
        a.InfuraProvider = c.InfuraProvider;
        var u = e("./json-rpc-provider");
        a.JsonRpcProvider = u.JsonRpcProvider, a.JsonRpcSigner = u.JsonRpcSigner;
        var d = e("./web3-provider");
        a.Web3Provider = d.Web3Provider;
      }, {
        "./abstract-provider": 49,
        "./base-provider": 50,
        "./etherscan-provider": 51,
        "./fallback-provider": 52,
        "./infura-provider": 54,
        "./ipc-provider": 55,
        "./json-rpc-provider": 56,
        "./web3-provider": 57
      }],
      54: [function (e, t, a) {
        "use strict";

        var r,
            n = this && this.__extends || (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var a in t) {
            t.hasOwnProperty(a) && (e[a] = t[a]);
          }
        }, function (e, t) {
          function a() {
            this.constructor = e;
          }

          r(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
        }),
            s = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var o,
            i = e("./json-rpc-provider"),
            c = e("../utils/bytes"),
            u = e("../utils/networks"),
            d = e("../utils/properties"),
            f = s(e("../errors")),
            l = (n(h, o = i.JsonRpcProvider), h.prototype._startPending = function () {
          f.warn("WARNING: INFURA does not support pending filters");
        }, h.prototype.getSigner = function (e) {
          return f.throwError("INFURA does not support signing", f.UNSUPPORTED_OPERATION, {
            operation: "getSigner"
          });
        }, h.prototype.listAccounts = function () {
          return Promise.resolve([]);
        }, h);

        function h(e, t) {
          var a = this,
              r = u.getNetwork(null == e ? "homestead" : e);
          null == t && (t = "7d0d81d0919f4f05b9ab6634be01ee73");
          var n = null;

          switch (r.name) {
            case "homestead":
              n = "mainnet.infura.io";
              break;

            case "ropsten":
              n = "ropsten.infura.io";
              break;

            case "rinkeby":
              n = "rinkeby.infura.io";
              break;

            case "goerli":
              n = "goerli.infura.io";
              break;

            case "kovan":
              n = "kovan.infura.io";
              break;

            default:
              f.throwError("unsupported network", f.INVALID_ARGUMENT, {
                argument: "network",
                value: e
              });
          }

          return c.isHexString("0x" + t, 16) ? (a = o.call(this, "https://" + n + "/v3/" + t, r) || this, d.defineReadOnly(a, "apiAccessToken", null), d.defineReadOnly(a, "projectId", t)) : (f.warn("The legacy INFURA apiAccesToken API is deprecated; please upgrade to a Project ID instead (see INFURA dshboard; https://infura.io)"), a = o.call(this, "https://" + n + "/" + t, r) || this, d.defineReadOnly(a, "apiAccessToken", t), d.defineReadOnly(a, "projectId", null)), f.checkNew(a, h), a;
        }

        a.InfuraProvider = l;
      }, {
        "../errors": 5,
        "../utils/bytes": 63,
        "../utils/networks": 71,
        "../utils/properties": 73,
        "./json-rpc-provider": 56
      }],
      55: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
      }, {}],
      56: [function (e, t, a) {
        "use strict";

        var r,
            n = this && this.__extends || (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var a in t) {
            t.hasOwnProperty(a) && (e[a] = t[a]);
          }
        }, function (e, t) {
          function a() {
            this.constructor = e;
          }

          r(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
        }),
            s = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var o = e("./base-provider"),
            i = e("../abstract-signer"),
            c = s(e("../errors")),
            u = e("../utils/address"),
            d = e("../utils/bytes"),
            f = e("../utils/networks"),
            l = e("../utils/properties"),
            h = e("../utils/utf8"),
            p = e("../utils/web");

        function b(e) {
          if (e.error) {
            var t = new Error(e.error.message);
            throw t.code = e.error.code, t.data = e.error.data, t;
          }

          return e.result;
        }

        function m(e) {
          return e ? e.toLowerCase() : e;
        }

        var y,
            v = {},
            _ = 42,
            g = (n(A, y = i.Signer), A.prototype.getAddress = function () {
          var e = this;
          return this._address ? Promise.resolve(this._address) : this.provider.send("eth_accounts", []).then(function (t) {
            return t.length <= e._index && c.throwError("unknown account #" + e._index, c.UNSUPPORTED_OPERATION, {
              operation: "getAddress"
            }), e._address = u.getAddress(t[e._index]), e._address;
          });
        }, A.prototype.getBalance = function (e) {
          return this.provider.getBalance(this.getAddress(), e);
        }, A.prototype.getTransactionCount = function (e) {
          return this.provider.getTransactionCount(this.getAddress(), e);
        }, A.prototype.sendUncheckedTransaction = function (e) {
          var t = this;
          e = l.shallowCopy(e);
          var a = this.getAddress().then(function (e) {
            return e && e.toLowerCase();
          });

          if (null == e.gasLimit) {
            var r = l.shallowCopy(e);
            r.from = a, e.gasLimit = this.provider.estimateGas(r);
          }

          return Promise.all([l.resolveProperties(e), a]).then(function (e) {
            var a = e[0],
                r = x.hexlifyTransaction(a);
            return r.from = e[1], t.provider.send("eth_sendTransaction", [r]).then(function (e) {
              return e;
            }, function (e) {
              throw e.responseText && (0 <= e.responseText.indexOf("insufficient funds") && c.throwError("insufficient funds", c.INSUFFICIENT_FUNDS, {
                transaction: a
              }), 0 <= e.responseText.indexOf("nonce too low") && c.throwError("nonce has already been used", c.NONCE_EXPIRED, {
                transaction: a
              }), 0 <= e.responseText.indexOf("replacement transaction underpriced") && c.throwError("replacement fee too low", c.REPLACEMENT_UNDERPRICED, {
                transaction: a
              })), e;
            });
          });
        }, A.prototype.sendTransaction = function (e) {
          var t = this;
          return this.sendUncheckedTransaction(e).then(function (e) {
            return p.poll(function () {
              return t.provider.getTransaction(e).then(function (a) {
                if (null !== a) return t.provider._wrapTransaction(a, e);
              });
            }, {
              fastRetry: 250,
              onceBlock: t.provider
            }).catch(function (t) {
              throw t.transactionHash = e, t;
            });
          });
        }, A.prototype.signMessage = function (e) {
          var t = this,
              a = "string" == typeof e ? h.toUtf8Bytes(e) : e;
          return this.getAddress().then(function (e) {
            return t.provider.send("eth_sign", [e.toLowerCase(), d.hexlify(a)]);
          });
        }, A.prototype.unlock = function (e) {
          var t = this.provider;
          return this.getAddress().then(function (a) {
            return t.send("personal_unlockAccount", [a.toLowerCase(), e, null]);
          });
        }, A);

        function A(e, t, a) {
          var r = y.call(this) || this;
          if (c.checkNew(r, A), e !== v) throw new Error("do not call the JsonRpcSigner constructor directly; use provider.getSigner");
          return l.defineReadOnly(r, "provider", t), a ? "string" == typeof a ? l.defineReadOnly(r, "_address", u.getAddress(a)) : "number" == typeof a ? l.defineReadOnly(r, "_index", a) : c.throwError("invalid address or index", c.INVALID_ARGUMENT, {
            argument: "addressOrIndex",
            value: a
          }) : l.defineReadOnly(r, "_index", 0), r;
        }

        a.JsonRpcSigner = g;
        var w,
            T = {
          chainId: !0,
          data: !0,
          gasLimit: !0,
          gasPrice: !0,
          nonce: !0,
          to: !0,
          value: !0
        },
            x = (n(D, w = o.BaseProvider), D.prototype.getSigner = function (e) {
          return new g(v, this, e);
        }, D.prototype.listAccounts = function () {
          return this.send("eth_accounts", []).then(function (e) {
            return e.map(function (e) {
              return u.getAddress(e);
            });
          });
        }, D.prototype.send = function (e, t) {
          var a = this,
              r = {
            method: e,
            params: t,
            id: _++,
            jsonrpc: "2.0"
          };
          return p.fetchJson(this.connection, JSON.stringify(r), b).then(function (e) {
            return a.emit("debug", {
              action: "send",
              request: r,
              response: e,
              provider: a
            }), e;
          });
        }, D.prototype.perform = function (e, t) {
          switch (e) {
            case "getBlockNumber":
              return this.send("eth_blockNumber", []);

            case "getGasPrice":
              return this.send("eth_gasPrice", []);

            case "getBalance":
              return this.send("eth_getBalance", [m(t.address), t.blockTag]);

            case "getTransactionCount":
              return this.send("eth_getTransactionCount", [m(t.address), t.blockTag]);

            case "getCode":
              return this.send("eth_getCode", [m(t.address), t.blockTag]);

            case "getStorageAt":
              return this.send("eth_getStorageAt", [m(t.address), t.position, t.blockTag]);

            case "sendTransaction":
              return this.send("eth_sendRawTransaction", [t.signedTransaction]).catch(function (e) {
                throw e.responseText && (0 < e.responseText.indexOf("insufficient funds") && c.throwError("insufficient funds", c.INSUFFICIENT_FUNDS, {}), 0 < e.responseText.indexOf("nonce too low") && c.throwError("nonce has already been used", c.NONCE_EXPIRED, {}), 0 < e.responseText.indexOf("replacement transaction underpriced") && c.throwError("replacement fee too low", c.REPLACEMENT_UNDERPRICED, {})), e;
              });

            case "getBlock":
              return t.blockTag ? this.send("eth_getBlockByNumber", [t.blockTag, !!t.includeTransactions]) : t.blockHash ? this.send("eth_getBlockByHash", [t.blockHash, !!t.includeTransactions]) : Promise.reject(new Error("invalid block tag or block hash"));

            case "getTransaction":
              return this.send("eth_getTransactionByHash", [t.transactionHash]);

            case "getTransactionReceipt":
              return this.send("eth_getTransactionReceipt", [t.transactionHash]);

            case "call":
              return this.send("eth_call", [D.hexlifyTransaction(t.transaction, {
                from: !0
              }), t.blockTag]);

            case "estimateGas":
              return this.send("eth_estimateGas", [D.hexlifyTransaction(t.transaction, {
                from: !0
              })]);

            case "getLogs":
              return t.filter && null != t.filter.address && (t.filter.address = m(t.filter.address)), this.send("eth_getLogs", [t.filter]);
          }

          return c.throwError(e + " not implemented", c.NOT_IMPLEMENTED, {
            operation: e
          }), null;
        }, D.prototype._startPending = function () {
          if (null == this._pendingFilter) {
            var e = this,
                t = this.send("eth_newPendingTransactionFilter", []);
            (this._pendingFilter = t).then(function (a) {
              return function r() {
                e.send("eth_getFilterChanges", [a]).then(function (a) {
                  if (e._pendingFilter != t) return null;
                  var r = Promise.resolve();
                  return a.forEach(function (t) {
                    e._emitted["t:" + t.toLowerCase()] = "pending", r = r.then(function () {
                      return e.getTransaction(t).then(function (t) {
                        return e.emit("pending", t), null;
                      });
                    });
                  }), r.then(function () {
                    return new Promise(function (e) {
                      setTimeout(function () {
                        e();
                      }, 1e3);
                    });
                  });
                }).then(function () {
                  if (e._pendingFilter == t) return setTimeout(function () {
                    r();
                  }, 0), null;
                  e.send("eth_uninstallFilter", [a]);
                }).catch(function (e) {});
              }(), a;
            }).catch(function (e) {});
          }
        }, D.prototype._stopPending = function () {
          this._pendingFilter = null;
        }, D.hexlifyTransaction = function (e, t) {
          var a = l.shallowCopy(T);
          if (t) for (var r in t) {
            t[r] && (a[r] = !0);
          }
          l.checkProperties(e, a);
          var n = {};
          return ["gasLimit", "gasPrice", "nonce", "value"].forEach(function (t) {
            if (null != e[t]) {
              var a = d.hexStripZeros(d.hexlify(e[t]));
              "gasLimit" === t && (t = "gas"), n[t] = a;
            }
          }), ["from", "to", "data"].forEach(function (t) {
            null != e[t] && (n[t] = d.hexlify(e[t]));
          }), n;
        }, D);

        function D(e, t) {
          var a = this;
          if ("string" == typeof e && null === t && f.getNetwork(e) && (t = e, e = null), t) a = w.call(this, t) || this;else {
            var r = new Promise(function (e, t) {
              setTimeout(function () {
                a.send("net_version", []).then(function (t) {
                  return e(f.getNetwork(parseInt(t)));
                }).catch(function (e) {
                  t(e);
                });
              });
            });
            a = w.call(this, r) || this;
          }
          return c.checkNew(a, D), e = e || "http://localhost:8545", a.connection = "string" == typeof e ? {
            url: e
          } : e, a;
        }

        a.JsonRpcProvider = x;
      }, {
        "../abstract-signer": 2,
        "../errors": 5,
        "../utils/address": 59,
        "../utils/bytes": 63,
        "../utils/networks": 71,
        "../utils/properties": 73,
        "../utils/utf8": 84,
        "../utils/web": 85,
        "./base-provider": 50
      }],
      57: [function (e, t, a) {
        "use strict";

        var r,
            n = this && this.__extends || (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var a in t) {
            t.hasOwnProperty(a) && (e[a] = t[a]);
          }
        }, function (e, t) {
          function a() {
            this.constructor = e;
          }

          r(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
        }),
            s = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var o,
            i = e("./json-rpc-provider"),
            c = e("../utils/properties"),
            u = s(e("../errors")),
            d = 42,
            f = (n(l, o = i.JsonRpcProvider), l.prototype.send = function (e, t) {
          var a = this;
          return "eth_sign" == e && this._web3Provider.isMetaMask && (e = "personal_sign", t = [t[1], t[0]]), new Promise(function (r, n) {
            var s = {
              method: e,
              params: t,
              id: d++,
              jsonrpc: "2.0"
            };

            a._sendAsync(s, function (e, t) {
              if (e) n(e);else {
                if (t.error) {
                  var a = new Error(t.error.message);
                  return a.code = t.error.code, a.data = t.error.data, void n(a);
                }

                r(t.result);
              }
            });
          });
        }, l);

        function l(e, t) {
          var a = o.call(this, e.host || e.path || "", t) || this;
          return u.checkNew(a, l), e && (e.sendAsync ? a._sendAsync = e.sendAsync.bind(e) : e.send && (a._sendAsync = e.send.bind(e))), e && a._sendAsync || u.throwError("invalid web3Provider", u.INVALID_ARGUMENT, {
            arg: "web3Provider",
            value: e
          }), c.defineReadOnly(a, "_web3Provider", e), a;
        }

        a.Web3Provider = f;
      }, {
        "../errors": 5,
        "../utils/properties": 73,
        "./json-rpc-provider": 56
      }],
      58: [function (e, t, a) {
        "use strict";

        var r,
            n = this && this.__extends || (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var a in t) {
            t.hasOwnProperty(a) && (e[a] = t[a]);
          }
        }, function (e, t) {
          function a() {
            this.constructor = e;
          }

          r(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
        }),
            s = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var o = e("../constants"),
            i = s(e("../errors")),
            c = e("./address"),
            u = e("./bignumber"),
            d = e("./bytes"),
            f = e("./utf8"),
            l = e("./properties"),
            h = new RegExp(/^bytes([0-9]*)$/),
            p = new RegExp(/^(u?int)([0-9]*)$/),
            b = new RegExp(/^(.*)\[([0-9]*)\]$/);

        a.defaultCoerceFunc = function (e, t) {
          var a = e.match(p);
          return a && parseInt(a[2]) <= 48 ? t.toNumber() : t;
        };

        var m = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$"),
            y = new RegExp("^[A-Za-z_][A-Za-z0-9_]*$");

        function v(e) {
          return e.match(/^uint($|[^1-9])/) ? e = "uint256" + e.substring(4) : e.match(/^int($|[^1-9])/) && (e = "int256" + e.substring(3)), e;
        }

        function _(e, t) {
          var a = e;

          function r(e) {
            throw new Error('unexpected character "' + a[e] + '" at position ' + e + ' in "' + a + '"');
          }

          e = e.replace(/\s/g, " ");

          for (var n = {
            type: "",
            name: "",
            state: {
              allowType: !0
            }
          }, s = n, o = 0; o < e.length; o++) {
            var i = e[o];

            switch (i) {
              case "(":
                s.state.allowParams || r(o), s.state.allowType = !1, s.type = v(s.type), s.components = [{
                  type: "",
                  name: "",
                  parent: s,
                  state: {
                    allowType: !0
                  }
                }], s = s.components[0];
                break;

              case ")":
                delete s.state, t && "indexed" === s.name && (s.indexed = !0, s.name = ""), s.type = v(s.type);
                var c = s;
                (s = s.parent) || r(o), delete c.parent, s.state.allowParams = !1, s.state.allowName = !0, s.state.allowArray = !0;
                break;

              case ",":
                delete s.state, t && "indexed" === s.name && (s.indexed = !0, s.name = ""), s.type = v(s.type);
                var u = {
                  type: "",
                  name: "",
                  parent: s.parent,
                  state: {
                    allowType: !0
                  }
                };
                s.parent.components.push(u), delete s.parent, s = u;
                break;

              case " ":
                s.state.allowType && "" !== s.type && (s.type = v(s.type), delete s.state.allowType, s.state.allowName = !0, s.state.allowParams = !0), s.state.allowName && "" !== s.name && (t && "indexed" === s.name ? (s.indexed = !0, s.name = "") : s.state.allowName = !1);
                break;

              case "[":
                s.state.allowArray || r(o), s.type += i, s.state.allowArray = !1, s.state.allowName = !1, s.state.readArray = !0;
                break;

              case "]":
                s.state.readArray || r(o), s.type += i, s.state.readArray = !1, s.state.allowArray = !0, s.state.allowName = !0;
                break;

              default:
                s.state.allowType ? (s.type += i, s.state.allowParams = !0, s.state.allowArray = !0) : s.state.allowName ? (s.name += i, delete s.state.allowArray) : s.state.readArray ? s.type += i : r(o);
            }
          }

          if (s.parent) throw new Error("unexpected eof");
          return delete n.state, t && "indexed" === s.name && (s.indexed = !0, s.name = ""), n.type = v(n.type), n;
        }

        function g(e) {
          return oe(a.defaultCoerceFunc, e).type;
        }

        function A(e, t, a, r, n) {
          this.coerceFunc = e, this.name = t, this.type = a, this.localName = r, this.dynamic = n;
        }

        a.parseParamType = function (e) {
          return _(e, !0);
        }, a.formatParamType = g, a.formatSignature = function (e) {
          return e.name + "(" + e.inputs.map(function (e) {
            return g(e);
          }).join(",") + ")";
        }, a.parseSignature = function (e) {
          if ("string" == typeof e) return "event " === (e = (e = (e = e.replace(/\s/g, " ")).replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " ")).trim()).substring(0, 6) ? function (e) {
            var t = {
              anonymous: !1,
              inputs: [],
              name: "",
              type: "event"
            },
                a = e.match(m);
            if (!a) throw new Error("invalid event: " + e);
            if (t.name = a[1].trim(), ne(a[2]).forEach(function (e) {
              (e = _(e, !0)).indexed = !!e.indexed, t.inputs.push(e);
            }), a[3].split(" ").forEach(function (e) {
              switch (e) {
                case "anonymous":
                  t.anonymous = !0;
                  break;

                case "":
                  break;

                default:
                  i.info("unknown modifier: " + e);
              }
            }), t.name && !t.name.match(y)) throw new Error('invalid identifier: "' + t.name + '"');
            return t;
          }(e.substring(6).trim()) : ("function " === e.substring(0, 9) && (e = e.substring(9)), function (e) {
            var t = {
              constant: !1,
              gas: null,
              inputs: [],
              name: "",
              outputs: [],
              payable: !1,
              stateMutability: null,
              type: "function"
            },
                a = e.split("@");

            if (1 !== a.length) {
              if (2 < a.length) throw new Error("invalid signature");
              if (!a[1].match(/^[0-9]+$/)) throw new Error("invalid signature gas");
              t.gas = u.bigNumberify(a[1]), e = a[0];
            }

            var r = (a = e.split(" returns "))[0].match(m);
            if (!r) throw new Error("invalid signature");
            if (t.name = r[1].trim(), !t.name.match(y)) throw new Error('invalid identifier: "' + r[1] + '"');

            if (ne(r[2]).forEach(function (e) {
              t.inputs.push(_(e));
            }), r[3].split(" ").forEach(function (e) {
              switch (e) {
                case "constant":
                  t.constant = !0;
                  break;

                case "payable":
                  t.payable = !0, t.stateMutability = "payable";
                  break;

                case "pure":
                  t.constant = !0, t.stateMutability = "pure";
                  break;

                case "view":
                  t.constant = !0, t.stateMutability = "view";
                  break;

                case "external":
                case "public":
                case "":
                  break;

                default:
                  i.info("unknown modifier: " + e);
              }
            }), 1 < a.length) {
              var n = a[1].match(m);
              if ("" != n[1].trim() || "" != n[3].trim()) throw new Error("unexpected tokens");
              ne(n[2]).forEach(function (e) {
                t.outputs.push(_(e));
              });
            }

            if ("constructor" === t.name) {
              if (t.type = "constructor", t.outputs.length) throw new Error("constructor may not have outputs");
              delete t.name, delete t.outputs;
            }

            return t;
          }(e.trim()));
          throw new Error("unknown signature");
        };
        var w,
            T = (n(x, w = A), x.prototype.encode = function (e) {
          return this.coder.encode(e);
        }, x.prototype.decode = function (e, t) {
          return this.coder.decode(e, t);
        }, x);

        function x(e) {
          var t = w.call(this, e.coerceFunc, e.name, e.type, void 0, e.dynamic) || this;
          return l.defineReadOnly(t, "coder", e), t;
        }

        var D,
            C = (n(S, D = A), S.prototype.encode = function (e) {
          return d.arrayify([]);
        }, S.prototype.decode = function (e, t) {
          if (t > e.length) throw new Error("invalid null");
          return {
            consumed: 0,
            value: this.coerceFunc("null", void 0)
          };
        }, S);

        function S(e, t) {
          return D.call(this, e, "null", "", t, !1) || this;
        }

        var E,
            B = (n(k, E = A), k.prototype.encode = function (e) {
          try {
            var t = u.bigNumberify(e);

            if (this.signed) {
              var a = o.MaxUint256.maskn(8 * this.size - 1);
              if (t.gt(a)) throw new Error("out-of-bounds");
              if (a = a.add(o.One).mul(o.NegativeOne), t.lt(a)) throw new Error("out-of-bounds");
            } else if (t.lt(o.Zero) || t.gt(o.MaxUint256.maskn(8 * this.size))) throw new Error("out-of-bounds");

            return t = t.toTwos(8 * this.size).maskn(8 * this.size), this.signed && (t = t.fromTwos(8 * this.size).toTwos(256)), d.padZeros(d.arrayify(t), 32);
          } catch (t) {
            i.throwError("invalid number value", i.INVALID_ARGUMENT, {
              arg: this.localName,
              coderType: this.name,
              value: e
            });
          }

          return null;
        }, k.prototype.decode = function (e, t) {
          e.length < t + 32 && i.throwError("insufficient data for " + this.name + " type", i.INVALID_ARGUMENT, {
            arg: this.localName,
            coderType: this.name,
            value: d.hexlify(e.slice(t, t + 32))
          });
          var a = 32 - this.size,
              r = u.bigNumberify(e.slice(t + a, t + 32));
          return r = this.signed ? r.fromTwos(8 * this.size) : r.maskn(8 * this.size), {
            consumed: 32,
            value: this.coerceFunc(this.name, r)
          };
        }, k);

        function k(e, t, a, r) {
          var n = this,
              s = (a ? "int" : "uint") + 8 * t;
          return (n = E.call(this, e, s, s, r, !1) || this).size = t, n.signed = a, n;
        }

        var R,
            W = new B(function (e, t) {
          return t;
        }, 32, !1, "none"),
            I = (n(N, R = A), N.prototype.encode = function (e) {
          return W.encode(e ? 1 : 0);
        }, N.prototype.decode = function (e, t) {
          try {
            var a = W.decode(e, t);
          } catch (e) {
            throw "insufficient data for uint256 type" === e.reason && i.throwError("insufficient data for boolean type", i.INVALID_ARGUMENT, {
              arg: this.localName,
              coderType: "boolean",
              value: e.value
            }), e;
          }

          return {
            consumed: a.consumed,
            value: this.coerceFunc("bool", !a.value.isZero())
          };
        }, N);

        function N(e, t) {
          return R.call(this, e, "bool", "bool", t, !1) || this;
        }

        var M,
            P = (n(L, M = A), L.prototype.encode = function (e) {
          var t = new Uint8Array(32);

          try {
            var a = d.arrayify(e);
            if (a.length !== this.length) throw new Error("incorrect data length");
            t.set(a);
          } catch (t) {
            i.throwError("invalid " + this.name + " value", i.INVALID_ARGUMENT, {
              arg: this.localName,
              coderType: this.name,
              value: t.value || e
            });
          }

          return t;
        }, L.prototype.decode = function (e, t) {
          return e.length < t + 32 && i.throwError("insufficient data for " + this.name + " type", i.INVALID_ARGUMENT, {
            arg: this.localName,
            coderType: this.name,
            value: d.hexlify(e.slice(t, t + 32))
          }), {
            consumed: 32,
            value: this.coerceFunc(this.name, d.hexlify(e.slice(t, t + this.length)))
          };
        }, L);

        function L(e, t, a) {
          var r = this,
              n = "bytes" + t;
          return (r = M.call(this, e, n, n, a, !1) || this).length = t, r;
        }

        var O,
            F = (n(j, O = A), j.prototype.encode = function (e) {
          var t = new Uint8Array(32);

          try {
            t.set(d.arrayify(c.getAddress(e)), 12);
          } catch (t) {
            i.throwError("invalid address", i.INVALID_ARGUMENT, {
              arg: this.localName,
              coderType: "address",
              value: e
            });
          }

          return t;
        }, j.prototype.decode = function (e, t) {
          return e.length < t + 32 && i.throwError("insufficuent data for address type", i.INVALID_ARGUMENT, {
            arg: this.localName,
            coderType: "address",
            value: d.hexlify(e.slice(t, t + 32))
          }), {
            consumed: 32,
            value: this.coerceFunc("address", c.getAddress(d.hexlify(e.slice(t + 12, t + 32))))
          };
        }, j);

        function j(e, t) {
          return O.call(this, e, "address", "address", t, !1) || this;
        }

        function G(e) {
          var t = 32 * Math.ceil(e.length / 32),
              a = new Uint8Array(t - e.length);
          return d.concat([W.encode(e.length), e, a]);
        }

        function V(e, t, a) {
          e.length < t + 32 && i.throwError("insufficient data for dynamicBytes length", i.INVALID_ARGUMENT, {
            arg: a,
            coderType: "dynamicBytes",
            value: d.hexlify(e.slice(t, t + 32))
          });
          var r = W.decode(e, t).value;

          try {
            r = r.toNumber();
          } catch (e) {
            i.throwError("dynamic bytes count too large", i.INVALID_ARGUMENT, {
              arg: a,
              coderType: "dynamicBytes",
              value: r.toString()
            });
          }

          return e.length < t + 32 + r && i.throwError("insufficient data for dynamicBytes type", i.INVALID_ARGUMENT, {
            arg: a,
            coderType: "dynamicBytes",
            value: d.hexlify(e.slice(t, t + 32 + r))
          }), {
            consumed: 32 + 32 * Math.ceil(r / 32),
            value: e.slice(t + 32, t + 32 + r)
          };
        }

        var U,
            H = (n(z, U = A), z.prototype.encode = function (e) {
          try {
            return G(d.arrayify(e));
          } catch (e) {
            i.throwError("invalid bytes value", i.INVALID_ARGUMENT, {
              arg: this.localName,
              coderType: "bytes",
              value: e.value
            });
          }

          return null;
        }, z.prototype.decode = function (e, t) {
          var a = V(e, t, this.localName);
          return a.value = this.coerceFunc("bytes", d.hexlify(a.value)), a;
        }, z);

        function z(e, t) {
          return U.call(this, e, "bytes", "bytes", t, !0) || this;
        }

        var K,
            q = (n(Y, K = A), Y.prototype.encode = function (e) {
          return "string" != typeof e && i.throwError("invalid string value", i.INVALID_ARGUMENT, {
            arg: this.localName,
            coderType: "string",
            value: e
          }), G(f.toUtf8Bytes(e));
        }, Y.prototype.decode = function (e, t) {
          var a = V(e, t, this.localName);
          return a.value = this.coerceFunc("string", f.toUtf8String(a.value)), a;
        }, Y);

        function Y(e, t) {
          return K.call(this, e, "string", "string", t, !0) || this;
        }

        function Z(e) {
          return 32 * Math.ceil(e / 32);
        }

        function J(e, t) {
          if (Array.isArray(t)) ;else if (t && "object" == typeof t) {
            var a = [];
            e.forEach(function (e) {
              a.push(t[e.localName]);
            }), t = a;
          } else i.throwError("invalid tuple value", i.INVALID_ARGUMENT, {
            coderType: "tuple",
            value: t
          });
          e.length !== t.length && i.throwError("types/value length mismatch", i.INVALID_ARGUMENT, {
            coderType: "tuple",
            value: t
          });
          var r = [];
          e.forEach(function (e, a) {
            r.push({
              dynamic: e.dynamic,
              value: e.encode(t[a])
            });
          });
          var n = 0,
              s = 0;
          r.forEach(function (e) {
            e.dynamic ? (n += 32, s += Z(e.value.length)) : n += Z(e.value.length);
          });
          var o = 0,
              c = n,
              u = new Uint8Array(n + s);
          return r.forEach(function (e) {
            e.dynamic ? (u.set(W.encode(c), o), o += 32, u.set(e.value, c), c += Z(e.value.length)) : (u.set(e.value, o), o += Z(e.value.length));
          }), u;
        }

        function X(e, t, a) {
          var r = a,
              n = 0,
              s = [];
          return e.forEach(function (e) {
            if (e.dynamic) {
              var o = W.decode(t, a);
              (i = e.decode(t, r + o.value.toNumber())).consumed = o.consumed;
            } else var i = e.decode(t, a);

            null != i.value && s.push(i.value), a += i.consumed, n += i.consumed;
          }), e.forEach(function (e, t) {
            var a = e.localName;
            a && ("length" === a && (a = "_length"), null == s[a] && (s[a] = s[t]));
          }), {
            value: s,
            consumed: n
          };
        }

        var $,
            Q = (n(ee, $ = A), ee.prototype.encode = function (e) {
          Array.isArray(e) || i.throwError("expected array value", i.INVALID_ARGUMENT, {
            arg: this.localName,
            coderType: "array",
            value: e
          });
          var t = this.length,
              a = new Uint8Array(0);
          -1 === t && (t = e.length, a = W.encode(t)), i.checkArgumentCount(t, e.length, " in coder array" + (this.localName ? " " + this.localName : ""));

          for (var r = [], n = 0; n < e.length; n++) {
            r.push(this.coder);
          }

          return d.concat([a, J(r, e)]);
        }, ee.prototype.decode = function (e, t) {
          var a = 0,
              r = this.length;

          if (-1 === r) {
            try {
              var n = W.decode(e, t);
            } catch (e) {
              i.throwError("insufficient data for dynamic array length", i.INVALID_ARGUMENT, {
                arg: this.localName,
                coderType: "array",
                value: e.value
              });
            }

            try {
              r = n.value.toNumber();
            } catch (e) {
              i.throwError("array count too large", i.INVALID_ARGUMENT, {
                arg: this.localName,
                coderType: "array",
                value: n.value.toString()
              });
            }

            a += n.consumed, t += n.consumed;
          }

          for (var s = [], o = 0; o < r; o++) {
            s.push(new T(this.coder));
          }

          var c = X(s, e, t);
          return c.consumed += a, c.value = this.coerceFunc(this.type, c.value), c;
        }, ee);

        function ee(e, t, a, r) {
          var n = this,
              s = t.type + "[" + (0 <= a ? a : "") + "]",
              o = -1 === a || t.dynamic;
          return (n = $.call(this, e, "array", s, r, o) || this).coder = t, n.length = a, n;
        }

        var te,
            ae = (n(re, te = A), re.prototype.encode = function (e) {
          return J(this.coders, e);
        }, re.prototype.decode = function (e, t) {
          var a = X(this.coders, e, t);
          return a.value = this.coerceFunc(this.type, a.value), a;
        }, re);

        function re(e, t, a) {
          var r = this,
              n = !1,
              s = [];
          t.forEach(function (e) {
            e.dynamic && (n = !0), s.push(e.type);
          });
          var o = "tuple(" + s.join(",") + ")";
          return (r = te.call(this, e, "tuple", o, a, n) || this).coders = t, r;
        }

        function ne(e) {
          e = e.trim();

          for (var t = [], a = "", r = 0, n = 0; n < e.length; n++) {
            var s = e[n];
            if ("," === s && 0 === r) t.push(a), a = "";else if (a += s, "(" === s) r++;else if (")" === s && -1 == --r) throw new Error("unbalanced parenthsis");
          }

          return a && t.push(a), t;
        }

        var se = {
          address: F,
          bool: I,
          string: q,
          bytes: H
        };

        function oe(e, t) {
          var a,
              r = se[t.type];
          if (r) return new r(e, t.name);
          if (a = t.type.match(p)) return (0 === (n = parseInt(a[2] || "256")) || 256 < n || n % 8 != 0) && i.throwError("invalid " + a[1] + " bit length", i.INVALID_ARGUMENT, {
            arg: "param",
            value: t
          }), new B(e, n / 8, "int" === a[1], t.name);
          if (a = t.type.match(h)) return (0 === (n = parseInt(a[1])) || 32 < n) && i.throwError("invalid bytes length", i.INVALID_ARGUMENT, {
            arg: "param",
            value: t
          }), new P(e, n, t.name);

          if (a = t.type.match(b)) {
            var n = parseInt(a[2] || "-1");
            return (t = l.shallowCopy(t)).type = a[1], t = l.deepCopy(t), new Q(e, oe(e, t), n, t.name);
          }

          return "tuple" === t.type.substring(0, 5) ? function (e, t, a) {
            var r = [];
            return (t = t || []).forEach(function (t) {
              r.push(oe(e, t));
            }), new ae(e, r, a);
          }(e, t.components, t.name) : "" === t.type ? new C(e, t.name) : (i.throwError("invalid type", i.INVALID_ARGUMENT, {
            arg: "type",
            value: t.type
          }), null);
        }

        var ie = (ce.prototype.encode = function (e, t) {
          e.length !== t.length && i.throwError("types/values length mismatch", i.INVALID_ARGUMENT, {
            count: {
              types: e.length,
              values: t.length
            },
            value: {
              types: e,
              values: t
            }
          });
          var a = [];
          return e.forEach(function (e) {
            var t;
            t = "string" == typeof e ? _(e) : e, a.push(oe(this.coerceFunc, t));
          }, this), d.hexlify(new ae(this.coerceFunc, a, "_").encode(t));
        }, ce.prototype.decode = function (e, t) {
          var a = [];
          return e.forEach(function (e) {
            var t;
            t = "string" == typeof e ? _(e) : l.deepCopy(e), a.push(oe(this.coerceFunc, t));
          }, this), new ae(this.coerceFunc, a, "_").decode(d.arrayify(t), 0).value;
        }, ce);

        function ce(e) {
          i.checkNew(this, ce), e = e || a.defaultCoerceFunc, l.defineReadOnly(this, "coerceFunc", e);
        }

        a.AbiCoder = ie, a.defaultAbiCoder = new ie();
      }, {
        "../constants": 3,
        "../errors": 5,
        "./address": 59,
        "./bignumber": 62,
        "./bytes": 63,
        "./properties": 73,
        "./utf8": 84
      }],
      59: [function (e, t, a) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var n = r(e("bn.js")),
            s = e("./bytes"),
            o = e("./keccak256"),
            i = e("./rlp"),
            c = e("../errors");

        function u(e) {
          "string" == typeof e && e.match(/^0x[0-9A-Fa-f]{40}$/) || c.throwError("invalid address", c.INVALID_ARGUMENT, {
            arg: "address",
            value: e
          });

          for (var t = (e = e.toLowerCase()).substring(2).split(""), a = new Uint8Array(40), r = 0; r < 40; r++) {
            a[r] = t[r].charCodeAt(0);
          }

          a = s.arrayify(o.keccak256(a));

          for (var n = 0; n < 40; n += 2) {
            8 <= a[n >> 1] >> 4 && (t[n] = t[n].toUpperCase()), 8 <= (15 & a[n >> 1]) && (t[n + 1] = t[n + 1].toUpperCase());
          }

          return "0x" + t.join("");
        }

        for (var d = {}, f = 0; f < 10; f++) {
          d[String(f)] = String(f);
        }

        for (f = 0; f < 26; f++) {
          d[String.fromCharCode(65 + f)] = String(10 + f);
        }

        var l,
            h = Math.floor((l = 9007199254740991, Math.log10 ? Math.log10(l) : Math.log(l) / Math.LN10));

        function p(e) {
          e = (e = e.toUpperCase()).substring(4) + e.substring(0, 2) + "00";
          var t = "";

          for (e.split("").forEach(function (e) {
            t += d[e];
          }); t.length >= h;) {
            var a = t.substring(0, h);
            t = parseInt(a, 10) % 97 + t.substring(a.length);
          }

          for (var r = String(98 - parseInt(t, 10) % 97); r.length < 2;) {
            r = "0" + r;
          }

          return r;
        }

        function b(e) {
          var t = null;
          if ("string" != typeof e && c.throwError("invalid address", c.INVALID_ARGUMENT, {
            arg: "address",
            value: e
          }), e.match(/^(0x)?[0-9a-fA-F]{40}$/)) "0x" !== e.substring(0, 2) && (e = "0x" + e), t = u(e), e.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && t !== e && c.throwError("bad address checksum", c.INVALID_ARGUMENT, {
            arg: "address",
            value: e
          });else if (e.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
            for (e.substring(2, 4) !== p(e) && c.throwError("bad icap checksum", c.INVALID_ARGUMENT, {
              arg: "address",
              value: e
            }), t = new n.default.BN(e.substring(4), 36).toString(16); t.length < 40;) {
              t = "0" + t;
            }

            t = u("0x" + t);
          } else c.throwError("invalid address", c.INVALID_ARGUMENT, {
            arg: "address",
            value: e
          });
          return t;
        }

        a.getAddress = b, a.getIcapAddress = function (e) {
          for (var t = new n.default.BN(b(e).substring(2), 16).toString(36).toUpperCase(); t.length < 30;) {
            t = "0" + t;
          }

          return "XE" + p("XE00" + t) + t;
        }, a.getContractAddress = function (e) {
          if (!e.from) throw new Error("missing from address");
          var t = e.nonce;
          return b("0x" + o.keccak256(i.encode([b(e.from), s.stripZeros(s.hexlify(t))])).substring(26));
        };
      }, {
        "../errors": 5,
        "./bytes": 63,
        "./keccak256": 70,
        "./rlp": 75,
        "bn.js": 9
      }],
      60: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var r = e("../utils/bytes");
        t.exports = {
          decode: function decode(e) {
            e = atob(e);

            for (var t = [], a = 0; a < e.length; a++) {
              t.push(e.charCodeAt(a));
            }

            return r.arrayify(t);
          },
          encode: function encode(e) {
            e = r.arrayify(e);

            for (var t = "", a = 0; a < e.length; a++) {
              t += String.fromCharCode(e[a]);
            }

            return btoa(t);
          }
        };
      }, {
        "../utils/bytes": 63
      }],
      61: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var r = e("./bytes"),
            n = e("./properties"),
            s = (o.prototype.encode = function (e) {
          var t = r.arrayify(e);
          if (0 === t.length) return "";

          for (var a = [0], n = 0; n < t.length; ++n) {
            for (var s = t[n], o = 0; o < a.length; ++o) {
              s += a[o] << 8, a[o] = s % this.base, s = s / this.base | 0;
            }

            for (; 0 < s;) {
              a.push(s % this.base), s = s / this.base | 0;
            }
          }

          for (var i = "", c = 0; 0 === t[c] && c < t.length - 1; ++c) {
            i += this._leader;
          }

          for (var u = a.length - 1; 0 <= u; --u) {
            i += this.alphabet[a[u]];
          }

          return i;
        }, o.prototype.decode = function (e) {
          if ("string" != typeof e) throw new TypeError("Expected String");
          var t = [];
          if (0 === e.length) return new Uint8Array(t);
          t.push(0);

          for (var a = 0; a < e.length; a++) {
            var n = this._alphabetMap[e[a]];
            if (void 0 === n) throw new Error("Non-base" + this.base + " character");

            for (var s = n, o = 0; o < t.length; ++o) {
              s += t[o] * this.base, t[o] = 255 & s, s >>= 8;
            }

            for (; 0 < s;) {
              t.push(255 & s), s >>= 8;
            }
          }

          for (var i = 0; e[i] === this._leader && i < e.length - 1; ++i) {
            t.push(0);
          }

          return r.arrayify(new Uint8Array(t.reverse()));
        }, o);

        function o(e) {
          n.defineReadOnly(this, "alphabet", e), n.defineReadOnly(this, "base", e.length), n.defineReadOnly(this, "_alphabetMap", {}), n.defineReadOnly(this, "_leader", e.charAt(0));

          for (var t = 0; t < e.length; t++) {
            this._alphabetMap[e.charAt(t)] = t;
          }
        }

        var i = new (a.BaseX = s)("abcdefghijklmnopqrstuvwxyz234567");
        a.Base32 = i;
        var c = new s("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
        a.Base58 = c;
      }, {
        "./bytes": 63,
        "./properties": 73
      }],
      62: [function (e, t, a) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        },
            n = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var s = r(e("bn.js")),
            o = e("./bytes"),
            i = e("./properties"),
            c = n(e("../errors")),
            u = new s.default.BN(-1);

        function d(e) {
          var t = e.toString(16);
          return "-" === t[0] ? t.length % 2 == 0 ? "-0x0" + t.substring(1) : "-0x" + t.substring(1) : t.length % 2 == 1 ? "0x0" + t : "0x" + t;
        }

        function f(e) {
          return h(m(e));
        }

        function l(e) {
          return new p(d(e));
        }

        function h(e) {
          var t = e._hex;
          return "-" === t[0] ? new s.default.BN(t.substring(3), 16).mul(u) : new s.default.BN(t.substring(2), 16);
        }

        var p = (b.prototype.fromTwos = function (e) {
          return l(h(this).fromTwos(e));
        }, b.prototype.toTwos = function (e) {
          return l(h(this).toTwos(e));
        }, b.prototype.abs = function () {
          return "-" === this._hex[0] ? l(h(this).mul(u)) : this;
        }, b.prototype.add = function (e) {
          return l(h(this).add(f(e)));
        }, b.prototype.sub = function (e) {
          return l(h(this).sub(f(e)));
        }, b.prototype.div = function (e) {
          return m(e).isZero() && c.throwError("division by zero", c.NUMERIC_FAULT, {
            operation: "divide",
            fault: "division by zero"
          }), l(h(this).div(f(e)));
        }, b.prototype.mul = function (e) {
          return l(h(this).mul(f(e)));
        }, b.prototype.mod = function (e) {
          return l(h(this).mod(f(e)));
        }, b.prototype.pow = function (e) {
          return l(h(this).pow(f(e)));
        }, b.prototype.maskn = function (e) {
          return l(h(this).maskn(e));
        }, b.prototype.eq = function (e) {
          return h(this).eq(f(e));
        }, b.prototype.lt = function (e) {
          return h(this).lt(f(e));
        }, b.prototype.lte = function (e) {
          return h(this).lte(f(e));
        }, b.prototype.gt = function (e) {
          return h(this).gt(f(e));
        }, b.prototype.gte = function (e) {
          return h(this).gte(f(e));
        }, b.prototype.isZero = function () {
          return h(this).isZero();
        }, b.prototype.toNumber = function () {
          try {
            return h(this).toNumber();
          } catch (e) {
            c.throwError("overflow", c.NUMERIC_FAULT, {
              operation: "setValue",
              fault: "overflow",
              details: e.message
            });
          }

          return null;
        }, b.prototype.toString = function () {
          return h(this).toString(10);
        }, b.prototype.toHexString = function () {
          return this._hex;
        }, b.isBigNumber = function (e) {
          return i.isType(e, "BigNumber");
        }, b);

        function b(e) {
          if (c.checkNew(this, b), i.setType(this, "BigNumber"), "string" == typeof e) o.isHexString(e) ? ("0x" == e && (e = "0x0"), i.defineReadOnly(this, "_hex", e)) : "-" === e[0] && o.isHexString(e.substring(1)) ? i.defineReadOnly(this, "_hex", e) : e.match(/^-?[0-9]*$/) ? ("" == e && (e = "0"), i.defineReadOnly(this, "_hex", d(new s.default.BN(e)))) : c.throwError("invalid BigNumber string value", c.INVALID_ARGUMENT, {
            arg: "value",
            value: e
          });else if ("number" == typeof e) {
            parseInt(String(e)) !== e && c.throwError("underflow", c.NUMERIC_FAULT, {
              operation: "setValue",
              fault: "underflow",
              value: e,
              outputValue: parseInt(String(e))
            });

            try {
              i.defineReadOnly(this, "_hex", d(new s.default.BN(e)));
            } catch (e) {
              c.throwError("overflow", c.NUMERIC_FAULT, {
                operation: "setValue",
                fault: "overflow",
                details: e.message
              });
            }
          } else e instanceof b ? i.defineReadOnly(this, "_hex", e._hex) : e.toHexString ? i.defineReadOnly(this, "_hex", d(f(e.toHexString()))) : e._hex && o.isHexString(e._hex) ? i.defineReadOnly(this, "_hex", e._hex) : o.isArrayish(e) ? i.defineReadOnly(this, "_hex", d(new s.default.BN(o.hexlify(e).substring(2), 16))) : c.throwError("invalid BigNumber value", c.INVALID_ARGUMENT, {
            arg: "value",
            value: e
          });
        }

        function m(e) {
          return p.isBigNumber(e) ? e : new p(e);
        }

        a.BigNumber = p, a.bigNumberify = m;
      }, {
        "../errors": 5,
        "./bytes": 63,
        "./properties": 73,
        "bn.js": 9
      }],
      63: [function (e, t, a) {
        "use strict";

        var r = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var n = r(e("../errors"));

        function s(e) {
          return !!e.toHexString;
        }

        function o(e) {
          return e.slice || (e.slice = function () {
            var t = Array.prototype.slice.call(arguments);
            return o(new Uint8Array(Array.prototype.slice.apply(e, t)));
          }), e;
        }

        function i(e) {
          if (!e || parseInt(String(e.length)) != e.length || "string" == typeof e) return !1;

          for (var t = 0; t < e.length; t++) {
            var a = e[t];
            if (a < 0 || 256 <= a || parseInt(String(a)) != a) return !1;
          }

          return !0;
        }

        function c(e) {
          if (null == e && n.throwError("cannot convert null value to array", n.INVALID_ARGUMENT, {
            arg: "value",
            value: e
          }), s(e) && (e = e.toHexString()), "string" != typeof e) return i(e) ? o(new Uint8Array(e)) : (n.throwError("invalid arrayify value", null, {
            arg: "value",
            value: e,
            type: typeof e
          }), null);
          var t = e.match(/^(0x)?[0-9a-fA-F]*$/);
          t || n.throwError("invalid hexidecimal string", n.INVALID_ARGUMENT, {
            arg: "value",
            value: e
          }), "0x" !== t[1] && n.throwError("hex string must have 0x prefix", n.INVALID_ARGUMENT, {
            arg: "value",
            value: e
          }), (e = e.substring(2)).length % 2 && (e = "0" + e);

          for (var a = [], r = 0; r < e.length; r += 2) {
            a.push(parseInt(e.substr(r, 2), 16));
          }

          return o(new Uint8Array(a));
        }

        function u(e) {
          for (var t = [], a = 0, r = 0; r < e.length; r++) {
            var n = c(e[r]);
            t.push(n), a += n.length;
          }

          var s = new Uint8Array(a),
              i = 0;

          for (r = 0; r < t.length; r++) {
            s.set(t[r], i), i += t[r].length;
          }

          return o(s);
        }

        function d(e, t) {
          return !("string" != typeof e || !e.match(/^0x[0-9A-Fa-f]*$/) || t && e.length !== 2 + 2 * t);
        }

        a.isHexable = s, a.isArrayish = i, a.arrayify = c, a.concat = u, a.stripZeros = function (e) {
          var t = c(e);
          if (0 === t.length) return t;

          for (var a = 0; 0 === t[a];) {
            a++;
          }

          return a && (t = t.slice(a)), t;
        }, a.padZeros = function (e, t) {
          if (t < (e = c(e)).length) throw new Error("cannot pad");
          var a = new Uint8Array(t);
          return a.set(e, t - e.length), o(a);
        }, a.isHexString = d;
        var f = "0123456789abcdef";

        function l(e) {
          if (s(e)) return e.toHexString();

          if ("number" == typeof e) {
            e < 0 && n.throwError("cannot hexlify negative value", n.INVALID_ARGUMENT, {
              arg: "value",
              value: e
            }), 9007199254740991 <= e && n.throwError("out-of-range", n.NUMERIC_FAULT, {
              operartion: "hexlify",
              fault: "out-of-safe-range"
            });

            for (var t = ""; e;) {
              t = f[15 & e] + t, e = Math.floor(e / 16);
            }

            return t.length ? (t.length % 2 && (t = "0" + t), "0x" + t) : "0x00";
          }

          if ("string" == typeof e) {
            var a = e.match(/^(0x)?[0-9a-fA-F]*$/);
            return a || n.throwError("invalid hexidecimal string", n.INVALID_ARGUMENT, {
              arg: "value",
              value: e
            }), "0x" !== a[1] && n.throwError("hex string must have 0x prefix", n.INVALID_ARGUMENT, {
              arg: "value",
              value: e
            }), e.length % 2 && (e = "0x0" + e.substring(2)), e;
          }

          if (i(e)) {
            for (var r = [], o = 0; o < e.length; o++) {
              var c = e[o];
              r.push(f[(240 & c) >> 4] + f[15 & c]);
            }

            return "0x" + r.join("");
          }

          return n.throwError("invalid hexlify value", null, {
            arg: "value",
            value: e
          }), "never";
        }

        function h(e, t) {
          for (d(e) || n.throwError("invalid hex string", n.INVALID_ARGUMENT, {
            arg: "value",
            value: e
          }); e.length < 2 * t + 2;) {
            e = "0x0" + e.substring(2);
          }

          return e;
        }

        function p(e) {
          var t = 0,
              a = "0x",
              r = "0x";

          if (function (e) {
            return e && null != e.r && null != e.s;
          }(e)) {
            null == e.v && null == e.recoveryParam && n.throwError("at least on of recoveryParam or v must be specified", n.INVALID_ARGUMENT, {
              argument: "signature",
              value: e
            }), a = h(e.r, 32), r = h(e.s, 32), "string" == typeof (t = e.v) && (t = parseInt(t, 16));
            var s = e.recoveryParam;
            null == s && null != e.v && (s = 1 - t % 2), t = 27 + s;
          } else {
            var o = c(e);
            if (65 !== o.length) throw new Error("invalid signature");
            a = l(o.slice(0, 32)), r = l(o.slice(32, 64)), 27 !== (t = o[64]) && 28 !== t && (t = 27 + t % 2);
          }

          return {
            r: a,
            s: r,
            recoveryParam: t - 27,
            v: t
          };
        }

        a.hexlify = l, a.hexDataLength = function (e) {
          return d(e) && e.length % 2 == 0 ? (e.length - 2) / 2 : null;
        }, a.hexDataSlice = function (e, t, a) {
          return d(e) || n.throwError("invalid hex data", n.INVALID_ARGUMENT, {
            arg: "value",
            value: e
          }), e.length % 2 != 0 && n.throwError("hex data length must be even", n.INVALID_ARGUMENT, {
            arg: "value",
            value: e
          }), t = 2 + 2 * t, null != a ? "0x" + e.substring(t, 2 + 2 * a) : "0x" + e.substring(t);
        }, a.hexStripZeros = function (e) {
          for (d(e) || n.throwError("invalid hex string", n.INVALID_ARGUMENT, {
            arg: "value",
            value: e
          }); 3 < e.length && "0x0" === e.substring(0, 3);) {
            e = "0x" + e.substring(3);
          }

          return e;
        }, a.hexZeroPad = h, a.splitSignature = p, a.joinSignature = function (e) {
          return l(u([(e = p(e)).r, e.s, e.recoveryParam ? "0x1c" : "0x1b"]));
        };
      }, {
        "../errors": 5
      }],
      64: [function (e, t, a) {
        "use strict";

        var r = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var n = r(e("../errors")),
            s = e("./bytes"),
            o = e("./utf8"),
            i = e("./keccak256"),
            c = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]),
            u = new RegExp("^((.*)\\.)?([^.]+)$"),
            d = new RegExp("^[a-z0-9.-]*$");
        a.namehash = function (e) {
          "string" != typeof e && n.throwError("invalid address - " + String(e), n.INVALID_ARGUMENT, {
            argument: "name",
            value: e
          }), (e = e.toLowerCase()).match(d) || n.throwError("contains invalid UseSTD3ASCIIRules characters", n.INVALID_ARGUMENT, {
            argument: "name",
            value: e
          });

          for (var t = c; e.length;) {
            var a = e.match(u),
                r = o.toUtf8Bytes(a[3]);
            t = i.keccak256(s.concat([t, i.keccak256(r)])), e = a[2] || "";
          }

          return s.hexlify(t);
        }, a.id = function (e) {
          return i.keccak256(o.toUtf8Bytes(e));
        }, a.hashMessage = function (e) {
          return i.keccak256(s.concat([o.toUtf8Bytes("Ethereum Signed Message:\n"), o.toUtf8Bytes(String(e.length)), "string" == typeof e ? o.toUtf8Bytes(e) : e]));
        };
      }, {
        "../errors": 5,
        "./bytes": 63,
        "./keccak256": 70,
        "./utf8": 84
      }],
      65: [function (e, t, a) {
        "use strict";

        var r = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var n = r(e("../errors")),
            s = e("../wordlists/lang-en"),
            o = e("./basex"),
            i = e("./bytes"),
            c = e("./bignumber"),
            u = e("./utf8"),
            d = e("./pbkdf2"),
            f = e("./hmac"),
            l = e("./properties"),
            h = e("./secp256k1"),
            p = e("./sha2"),
            b = c.bigNumberify("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"),
            m = u.toUtf8Bytes("Bitcoin seed"),
            y = 2147483648;

        function v(e) {
          return (1 << e) - 1 << 8 - e;
        }

        function _(e) {
          return i.hexZeroPad(i.hexlify(e), 32);
        }

        function g(e) {
          var t = i.hexDataSlice(p.sha256(p.sha256(e)), 0, 4);
          return o.Base58.encode(i.concat([e, t]));
        }

        var A = {};
        a.defaultPath = "m/44'/60'/0'/0/0";
        var w = (Object.defineProperty(T.prototype, "extendedKey", {
          get: function get() {
            if (256 <= this.depth) throw new Error("Depth too large!");
            return g(i.concat([null != this.privateKey ? "0x0488ADE4" : "0x0488B21E", i.hexlify(this.depth), this.parentFingerprint, i.hexZeroPad(i.hexlify(this.index), 4), this.chainCode, null != this.privateKey ? i.concat(["0x00", this.privateKey]) : this.publicKey]));
          },
          enumerable: !0,
          configurable: !0
        }), T.prototype.neuter = function () {
          return new T(A, null, this.publicKey, this.parentFingerprint, this.chainCode, this.index, this.depth, null, this.path);
        }, T.prototype._derive = function (e) {
          if (4294967295 < e) throw new Error("invalid index - " + String(e));
          var t = this.path;
          t && (t += "/" + (e & ~y));
          var a = new Uint8Array(37);

          if (e & y) {
            if (!this.privateKey) throw new Error("cannot derive child of neutered node");
            a.set(i.arrayify(this.privateKey), 1), t && (t += "'");
          } else a.set(i.arrayify(this.publicKey));

          for (var r = 24; 0 <= r; r -= 8) {
            a[33 + (r >> 3)] = e >> 24 - r & 255;
          }

          var n = f.computeHmac(f.SupportedAlgorithms.sha512, this.chainCode, a),
              s = n.slice(0, 32),
              o = n.slice(32),
              u = null,
              d = null;
          return this.privateKey ? u = _(c.bigNumberify(s).add(this.privateKey).mod(b)) : d = new h.KeyPair(i.hexlify(s))._addPoint(this.publicKey), new T(A, u, d, this.fingerprint, _(o), e, this.depth + 1, this.mnemonic, t);
        }, T.prototype.derivePath = function (e) {
          var t = e.split("/");
          if (0 === t.length || "m" === t[0] && 0 !== this.depth) throw new Error("invalid path - " + e);
          "m" === t[0] && t.shift();

          for (var a = this, r = 0; r < t.length; r++) {
            var n = t[r];

            if (n.match(/^[0-9]+'$/)) {
              var s = parseInt(n.substring(0, n.length - 1));
              if (y <= s) throw new Error("invalid path index - " + n);
              a = a._derive(y + s);
            } else {
              if (!n.match(/^[0-9]+$/)) throw new Error("invlaid path component - " + n);
              if (s = parseInt(n), y <= s) throw new Error("invalid path index - " + n);
              a = a._derive(s);
            }
          }

          return a;
        }, T.isHDNode = function (e) {
          return l.isType(e, "HDNode");
        }, T);

        function T(e, t, a, r, s, o, c, u, d) {
          if (n.checkNew(this, T), e !== A) throw new Error("HDNode constructor cannot be called directly");

          if (t) {
            var f = new h.KeyPair(t);
            l.defineReadOnly(this, "privateKey", f.privateKey), l.defineReadOnly(this, "publicKey", f.compressedPublicKey);
          } else l.defineReadOnly(this, "privateKey", null), l.defineReadOnly(this, "publicKey", i.hexlify(a));

          l.defineReadOnly(this, "parentFingerprint", r), l.defineReadOnly(this, "fingerprint", i.hexDataSlice(p.ripemd160(p.sha256(this.publicKey)), 0, 4)), l.defineReadOnly(this, "address", h.computeAddress(this.publicKey)), l.defineReadOnly(this, "chainCode", s), l.defineReadOnly(this, "index", o), l.defineReadOnly(this, "depth", c), l.defineReadOnly(this, "mnemonic", u), l.defineReadOnly(this, "path", d), l.setType(this, "HDNode");
        }

        function x(e, t) {
          var a = i.arrayify(e);
          if (a.length < 16 || 64 < a.length) throw new Error("invalid seed");
          var r = i.arrayify(f.computeHmac(f.SupportedAlgorithms.sha512, m, a));
          return new w(A, _(r.slice(0, 32)), null, "0x00000000", _(r.slice(32)), 0, 0, t, "m");
        }

        function D(e, t) {
          t = t || "";
          var a = u.toUtf8Bytes("mnemonic" + t, u.UnicodeNormalizationForm.NFKD);
          return i.hexlify(d.pbkdf2(u.toUtf8Bytes(e, u.UnicodeNormalizationForm.NFKD), a, 2048, 64, "sha512"));
        }

        function C(e, t) {
          t = t || s.langEn, n.checkNormalize();
          var a = t.split(e);
          if (a.length % 3 != 0) throw new Error("invalid mnemonic");

          for (var r = i.arrayify(new Uint8Array(Math.ceil(11 * a.length / 8))), o = 0, c = 0; c < a.length; c++) {
            var u = t.getWordIndex(a[c].normalize("NFKD"));
            if (-1 === u) throw new Error("invalid mnemonic");

            for (var d = 0; d < 11; d++) {
              u & 1 << 10 - d && (r[o >> 3] |= 1 << 7 - o % 8), o++;
            }
          }

          var f = 32 * a.length / 3,
              l = v(a.length / 3),
              h = i.arrayify(p.sha256(r.slice(0, f / 8)))[0];
          if ((h &= l) != (r[r.length - 1] & l)) throw new Error("invalid checksum");
          return i.hexlify(r.slice(0, f / 8));
        }

        function S(e, t) {
          if ((e = i.arrayify(e)).length % 4 != 0 || e.length < 16 || 32 < e.length) throw new Error("invalid entropy");

          for (var a = [0], r = 11, n = 0; n < e.length; n++) {
            8 < r ? (a[a.length - 1] <<= 8, a[a.length - 1] |= e[n], r -= 8) : (a[a.length - 1] <<= r, a[a.length - 1] |= e[n] >> 8 - r, a.push(e[n] & (1 << 8 - r) - 1), r += 3);
          }

          var o = i.arrayify(p.sha256(e))[0],
              c = e.length / 4;
          return o &= v(c), a[a.length - 1] <<= c, a[a.length - 1] |= o >> 8 - c, (t = t || s.langEn).join(a.map(function (e) {
            return t.getWord(e);
          }));
        }

        a.HDNode = w, a.fromExtendedKey = function (e) {
          var t = o.Base58.decode(e);
          82 === t.length && g(t.slice(0, 78)) === e || n.throwError("invalid extended key", n.INVALID_ARGUMENT, {
            argument: "extendedKey",
            value: "[REDACTED]"
          });
          var a = t[4],
              r = i.hexlify(t.slice(5, 9)),
              s = parseInt(i.hexlify(t.slice(9, 13)).substring(2), 16),
              c = i.hexlify(t.slice(13, 45)),
              u = t.slice(45, 78);

          switch (i.hexlify(t.slice(0, 4))) {
            case "0x0488b21e":
            case "0x043587cf":
              return new w(A, null, i.hexlify(u), r, c, s, a, null, null);

            case "0x0488ade4":
            case "0x04358394":
              if (0 !== u[0]) break;
              return new w(A, i.hexlify(u.slice(1)), null, r, c, s, a, null, null);
          }

          return n.throwError("invalid extended key", n.INVALID_ARGUMENT, {
            argument: "extendedKey",
            value: "[REDACTED]"
          });
        }, a.fromMnemonic = function (e, t, a) {
          return x(D(e = S(C(e, t), t), a), e);
        }, a.fromSeed = function (e) {
          return x(e, null);
        }, a.mnemonicToSeed = D, a.mnemonicToEntropy = C, a.entropyToMnemonic = S, a.isValidMnemonic = function (e, t) {
          try {
            return C(e, t), !0;
          } catch (e) {}

          return !1;
        };
      }, {
        "../errors": 5,
        "../wordlists/lang-en": 89,
        "./basex": 61,
        "./bignumber": 62,
        "./bytes": 63,
        "./hmac": 66,
        "./pbkdf2": 72,
        "./properties": 73,
        "./secp256k1": 76,
        "./sha2": 78,
        "./utf8": 84
      }],
      66: [function (e, t, a) {
        "use strict";

        var r = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var n,
            s,
            o = r(e("hash.js")),
            i = e("../utils/bytes"),
            c = r(e("../errors"));
        (s = n = a.SupportedAlgorithms || (a.SupportedAlgorithms = {})).sha256 = "sha256", s.sha512 = "sha512", a.computeHmac = function (e, t, a) {
          return n[e] || c.throwError("unsupported algorithm " + e, c.UNSUPPORTED_OPERATION, {
            operation: "hmac",
            algorithm: e
          }), i.arrayify(o.hmac(o[e], i.arrayify(t)).update(i.arrayify(a)).digest());
        };
      }, {
        "../errors": 5,
        "../utils/bytes": 63,
        "hash.js": 27
      }],
      67: [function (e, t, a) {
        "use strict";

        var r = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var n = e("./abi-coder");
        a.AbiCoder = n.AbiCoder, a.defaultAbiCoder = n.defaultAbiCoder, a.formatSignature = n.formatSignature, a.formatParamType = n.formatParamType, a.parseSignature = n.parseSignature, a.parseParamType = n.parseParamType;
        var s = e("./address");
        a.getAddress = s.getAddress, a.getContractAddress = s.getContractAddress, a.getIcapAddress = s.getIcapAddress;
        var o = r(e("./base64"));
        a.base64 = o;
        var i = e("./bignumber");
        a.BigNumber = i.BigNumber, a.bigNumberify = i.bigNumberify;
        var c = e("./bytes");
        a.arrayify = c.arrayify, a.concat = c.concat, a.hexDataSlice = c.hexDataSlice, a.hexDataLength = c.hexDataLength, a.hexlify = c.hexlify, a.hexStripZeros = c.hexStripZeros, a.hexZeroPad = c.hexZeroPad, a.isHexString = c.isHexString, a.joinSignature = c.joinSignature, a.padZeros = c.padZeros, a.splitSignature = c.splitSignature, a.stripZeros = c.stripZeros;
        var u = e("./hash");
        a.hashMessage = u.hashMessage, a.id = u.id, a.namehash = u.namehash;
        var d = r(e("./hdnode"));
        a.HDNode = d;
        var f = e("./interface");
        a.Interface = f.Interface;
        var l = e("./json-wallet");
        a.getJsonWalletAddress = l.getJsonWalletAddress;
        var h = e("./keccak256");
        a.keccak256 = h.keccak256;
        var p = e("./sha2");
        a.sha256 = p.sha256;
        var b = e("./solidity");
        a.solidityKeccak256 = b.keccak256, a.solidityPack = b.pack, a.soliditySha256 = b.sha256;
        var m = e("./random-bytes");
        a.randomBytes = m.randomBytes;
        var y = e("./networks");
        a.getNetwork = y.getNetwork;
        var v = e("./properties");
        a.checkProperties = v.checkProperties, a.deepCopy = v.deepCopy, a.defineReadOnly = v.defineReadOnly, a.resolveProperties = v.resolveProperties, a.shallowCopy = v.shallowCopy;

        var _ = r(e("./rlp"));

        a.RLP = _;
        var g = e("./secp256k1");
        a.computeAddress = g.computeAddress, a.computePublicKey = g.computePublicKey, a.recoverAddress = g.recoverAddress, a.recoverPublicKey = g.recoverPublicKey, a.verifyMessage = g.verifyMessage;
        var A = e("./signing-key");
        a.SigningKey = A.SigningKey;
        var w = e("./transaction");
        a.populateTransaction = w.populateTransaction;
        var T = e("./transaction");
        a.parseTransaction = T.parse, a.serializeTransaction = T.serialize;
        var x = e("./utf8");
        a.formatBytes32String = x.formatBytes32String, a.parseBytes32String = x.parseBytes32String, a.toUtf8Bytes = x.toUtf8Bytes, a.toUtf8String = x.toUtf8String;
        var D = e("./units");
        a.commify = D.commify, a.formatEther = D.formatEther, a.parseEther = D.parseEther, a.formatUnits = D.formatUnits, a.parseUnits = D.parseUnits;
        var C = e("./web");
        a.fetchJson = C.fetchJson, a.poll = C.poll;
        var S = e("./hmac");
        a.SupportedAlgorithms = S.SupportedAlgorithms;
        var E = e("./utf8");
        a.UnicodeNormalizationForm = E.UnicodeNormalizationForm;
        var B = e("./wordlist");
        a.Wordlist = B.Wordlist;
      }, {
        "./abi-coder": 58,
        "./address": 59,
        "./base64": 60,
        "./bignumber": 62,
        "./bytes": 63,
        "./hash": 64,
        "./hdnode": 65,
        "./hmac": 66,
        "./interface": 68,
        "./json-wallet": 69,
        "./keccak256": 70,
        "./networks": 71,
        "./properties": 73,
        "./random-bytes": 74,
        "./rlp": 75,
        "./secp256k1": 76,
        "./sha2": 78,
        "./signing-key": 80,
        "./solidity": 81,
        "./transaction": 82,
        "./units": 83,
        "./utf8": 84,
        "./web": 85,
        "./wordlist": 86
      }],
      68: [function (e, t, a) {
        "use strict";

        var r,
            n = this && this.__extends || (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var a in t) {
            t.hasOwnProperty(a) && (e[a] = t[a]);
          }
        }, function (e, t) {
          function a() {
            this.constructor = e;
          }

          r(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
        }),
            s = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        function o(e) {
          for (var t in p.setType(this, "Description"), e) {
            p.defineReadOnly(this, t, p.deepCopy(e[t], !0));
          }

          Object.freeze(this);
        }

        Object.defineProperty(a, "__esModule", {
          value: !0
        });

        var i,
            c = e("./address"),
            u = e("./abi-coder"),
            d = e("./bignumber"),
            f = e("./bytes"),
            l = e("./hash"),
            h = e("./keccak256"),
            p = e("./properties"),
            b = s(e("../errors")),
            m = function m(e) {
          p.setType(this, "Indexed"), p.defineReadOnly(this, "hash", e);
        },
            y = (n(v, i = o), v.prototype.encode = function (e, t) {
          f.isHexString(e) || b.throwError("invalid contract bytecode", b.INVALID_ARGUMENT, {
            arg: "bytecode",
            value: e
          }), b.checkArgumentCount(t.length, this.inputs.length, " in Interface constructor");

          try {
            return e + u.defaultAbiCoder.encode(this.inputs, t).substring(2);
          } catch (e) {
            b.throwError("invalid constructor argument", b.INVALID_ARGUMENT, {
              arg: e.arg,
              reason: e.reason,
              value: e.value
            });
          }

          return null;
        }, v);

        function v() {
          return null !== i && i.apply(this, arguments) || this;
        }

        var _,
            g = (n(A, _ = o), A.prototype.encode = function (e) {
          b.checkArgumentCount(e.length, this.inputs.length, " in interface function " + this.name);

          try {
            return this.sighash + u.defaultAbiCoder.encode(this.inputs, e).substring(2);
          } catch (e) {
            b.throwError("invalid input argument", b.INVALID_ARGUMENT, {
              arg: e.arg,
              reason: e.reason,
              value: e.value
            });
          }

          return null;
        }, A.prototype.decode = function (e) {
          try {
            return u.defaultAbiCoder.decode(this.outputs, f.arrayify(e));
          } catch (t) {
            b.throwError("invalid data for function output", b.INVALID_ARGUMENT, {
              arg: "data",
              errorArg: t.arg,
              errorValue: t.value,
              value: e,
              reason: t.reason
            });
          }
        }, A);

        function A() {
          return null !== _ && _.apply(this, arguments) || this;
        }

        var w,
            T = (n(x, w = o), x);

        function x() {
          return null !== w && w.apply(this, arguments) || this;
        }

        var D,
            C = (n(S, D = o), S.prototype.encodeTopics = function (e) {
          var t = this;
          e.length > this.inputs.length && b.throwError("too many arguments for " + this.name, b.UNEXPECTED_ARGUMENT, {
            maxCount: e.length,
            expectedCount: this.inputs.length
          });
          var a = [];

          for (this.anonymous || a.push(this.topic), e.forEach(function (e, r) {
            var n = t.inputs[r];
            n.indexed ? null == e ? a.push(null) : "string" === n.type ? a.push(l.id(e)) : "bytes" === n.type ? a.push(h.keccak256(e)) : -1 !== n.type.indexOf("[") || "tuple" === n.type.substring(0, 5) ? b.throwError("filtering with tuples or arrays not implemented yet; bug us on GitHub", b.NOT_IMPLEMENTED, {
              operation: "filter(array|tuple)"
            }) : ("address" === n.type && c.getAddress(e), a.push(f.hexZeroPad(f.hexlify(e), 32).toLowerCase())) : null != e && b.throwError("cannot filter non-indexed parameters; must be null", b.INVALID_ARGUMENT, {
              argument: n.name || r,
              value: e
            });
          }); a.length && null === a[a.length - 1];) {
            a.pop();
          }

          return a;
        }, S.prototype.decode = function (e, t) {
          null == t || this.anonymous || (t = t.slice(1));
          var a = [],
              r = [],
              n = [];
          if (this.inputs.forEach(function (e, t) {
            e.indexed ? "string" === e.type || "bytes" === e.type || 0 <= e.type.indexOf("[") || "tuple" === e.type.substring(0, 5) ? (a.push({
              type: "bytes32",
              name: e.name || ""
            }), n.push(!0)) : (a.push(e), n.push(!1)) : (r.push(e), n.push(!1));
          }), null != t) var s = u.defaultAbiCoder.decode(a, f.concat(t));
          var o = u.defaultAbiCoder.decode(r, f.arrayify(e)),
              i = {},
              c = 0,
              d = 0;
          return this.inputs.forEach(function (e, a) {
            e.indexed ? null == t ? i[a] = new m(null) : n[a] ? i[a] = new m(s[d++]) : i[a] = s[d++] : i[a] = o[c++], e.name && (i[e.name] = i[a]);
          }), i.length = this.inputs.length, new T(i);
        }, S);

        function S() {
          return null !== D && D.apply(this, arguments) || this;
        }

        var E,
            B = (n(k, E = o), k);

        function k() {
          return null !== E && E.apply(this, arguments) || this;
        }

        var R,
            W = (n(I, R = o), I);

        function I() {
          return null !== R && R.apply(this, arguments) || this;
        }

        function N(e) {
          switch (e.type) {
            case "constructor":
              var t = new y({
                inputs: e.inputs,
                payable: null == e.payable || !!e.payable
              });
              this.deployFunction || (this.deployFunction = t);
              break;

            case "function":
              var a = u.formatSignature(e).replace(/tuple/g, ""),
                  r = l.id(a).substring(0, 10);
              t = new g({
                inputs: e.inputs,
                outputs: e.outputs,
                gas: e.gas,
                payable: null == e.payable || !!e.payable,
                type: e.constant ? "call" : "transaction",
                name: e.name,
                signature: a,
                sighash: r
              }), e.name && (null == this.functions[e.name] ? p.defineReadOnly(this.functions, e.name, t) : b.warn("WARNING: Multiple definitions for " + e.name)), null == this.functions[t.signature] && p.defineReadOnly(this.functions, t.signature, t);
              break;

            case "event":
              a = u.formatSignature(e).replace(/tuple/g, ""), t = new C({
                name: e.name,
                signature: a,
                inputs: e.inputs,
                topic: l.id(a),
                anonymous: !!e.anonymous
              }), e.name && null == this.events[e.name] && p.defineReadOnly(this.events, e.name, t), null == this.events[t.signature] && p.defineReadOnly(this.events, t.signature, t);
              break;

            case "fallback":
              break;

            default:
              b.warn("WARNING: unsupported ABI type - " + e.type);
          }
        }

        var M = (P.prototype.parseTransaction = function (e) {
          var t = e.data.substring(0, 10).toLowerCase();

          for (var a in this.functions) {
            if (-1 !== a.indexOf("(")) {
              var r = this.functions[a];

              if (r.sighash === t) {
                var n = u.defaultAbiCoder.decode(r.inputs, "0x" + e.data.substring(10));
                return new B({
                  args: n,
                  decode: r.decode,
                  name: r.name,
                  signature: r.signature,
                  sighash: r.sighash,
                  value: d.bigNumberify(e.value || "0")
                });
              }
            }
          }

          return null;
        }, P.prototype.parseLog = function (e) {
          for (var t in this.events) {
            if (-1 !== t.indexOf("(")) {
              var a = this.events[t];
              if (!a.anonymous && a.topic === e.topics[0]) return new W({
                decode: a.decode,
                name: a.name,
                signature: a.signature,
                topic: a.topic,
                values: a.decode(e.data, e.topics)
              });
            }
          }

          return null;
        }, P.isInterface = function (e) {
          return p.isType(e, "Interface");
        }, P.isIndexed = function (e) {
          return p.isType(e, "Indexed");
        }, P);

        function P(e) {
          if (b.checkNew(this, P), "string" == typeof e) {
            try {
              e = JSON.parse(e);
            } catch (t) {
              b.throwError("could not parse ABI JSON", b.INVALID_ARGUMENT, {
                arg: "abi",
                errorMessage: t.message,
                value: e
              });
            }

            if (!Array.isArray(e)) return b.throwError("invalid abi", b.INVALID_ARGUMENT, {
              arg: "abi",
              value: e
            }), null;
          }

          p.defineReadOnly(this, "functions", {}), p.defineReadOnly(this, "events", {});
          var t = [];
          e.forEach(function (e) {
            "string" == typeof e && (e = u.parseSignature(e)), t.push(e);
          }), p.defineReadOnly(this, "abi", p.deepCopy(t, !0)), t.forEach(N, this), this.deployFunction || N.call(this, {
            type: "constructor",
            inputs: []
          }), p.setType(this, "Interface");
        }

        a.Interface = M;
      }, {
        "../errors": 5,
        "./abi-coder": 58,
        "./address": 59,
        "./bignumber": 62,
        "./bytes": 63,
        "./hash": 64,
        "./keccak256": 70,
        "./properties": 73
      }],
      69: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var r = e("./address");

        function n(e) {
          try {
            var t = JSON.parse(e);
          } catch (e) {
            return !1;
          }

          return t.encseed && t.ethaddr;
        }

        function s(e) {
          try {
            var t = JSON.parse(e);
          } catch (e) {
            return !1;
          }

          return !(!t.version || parseInt(t.version) !== t.version || 3 !== parseInt(t.version));
        }

        a.isCrowdsaleWallet = n, a.isSecretStorageWallet = s, a.getJsonWalletAddress = function (e) {
          if (n(e)) try {
            return r.getAddress(JSON.parse(e).ethaddr);
          } catch (e) {
            return null;
          }
          if (s(e)) try {
            return r.getAddress(JSON.parse(e).address);
          } catch (e) {
            return null;
          }
          return null;
        };
      }, {
        "./address": 59
      }],
      70: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var r = e("js-sha3"),
            n = e("./bytes");

        a.keccak256 = function (e) {
          return "0x" + r.keccak_256(n.arrayify(e));
        };
      }, {
        "./bytes": 63,
        "js-sha3": 40
      }],
      71: [function (e, t, a) {
        "use strict";

        var r = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var n = r(e("../errors"));

        function s(e) {
          return function (t) {
            var a = [];
            return t.InfuraProvider && a.push(new t.InfuraProvider(e)), t.EtherscanProvider && a.push(new t.EtherscanProvider(e)), 0 === a.length ? null : t.FallbackProvider ? new t.FallbackProvider(a) : a[0];
          };
        }

        function o(e, t) {
          return function (a) {
            return a.JsonRpcProvider ? new a.JsonRpcProvider(e, t) : null;
          };
        }

        var i = {
          chainId: 1,
          ensAddress: "0x314159265dd8dbb310642f98f50c066173c1259b",
          name: "homestead",
          _defaultProvider: s("homestead")
        },
            c = {
          chainId: 3,
          ensAddress: "0x112234455c3a32fd11230c42e7bccd4a84e02010",
          name: "ropsten",
          _defaultProvider: s("ropsten")
        },
            u = {
          unspecified: {
            chainId: 0,
            name: "unspecified"
          },
          homestead: i,
          mainnet: i,
          morden: {
            chainId: 2,
            name: "morden"
          },
          ropsten: c,
          testnet: c,
          rinkeby: {
            chainId: 4,
            ensAddress: "0xe7410170f87102DF0055eB195163A03B7F2Bff4A",
            name: "rinkeby",
            _defaultProvider: s("rinkeby")
          },
          goerli: {
            chainId: 5,
            ensAddress: "0x112234455c3a32fd11230c42e7bccd4a84e02010",
            name: "goerli",
            _defaultProvider: s("goerli")
          },
          kovan: {
            chainId: 42,
            name: "kovan",
            _defaultProvider: s("kovan")
          },
          classic: {
            chainId: 61,
            name: "classic",
            _defaultProvider: o("https://web3.gastracker.io", "classic")
          },
          classicTestnet: {
            chainId: 62,
            name: "classicTestnet",
            _defaultProvider: o("https://web3.gastracker.io/morden", "classicTestnet")
          }
        };

        a.getNetwork = function (e) {
          if (null == e) return null;

          if ("number" == typeof e) {
            for (var t in u) {
              var a = u[t];
              if (a.chainId === e) return {
                name: a.name,
                chainId: a.chainId,
                ensAddress: a.ensAddress || null,
                _defaultProvider: a._defaultProvider || null
              };
            }

            return {
              chainId: e,
              name: "unknown"
            };
          }

          if ("string" == typeof e) {
            var r = u[e];
            return null == r ? null : {
              name: r.name,
              chainId: r.chainId,
              ensAddress: r.ensAddress,
              _defaultProvider: r._defaultProvider || null
            };
          }

          var s = u[e.name];
          return s ? (0 !== e.chainId && e.chainId !== s.chainId && n.throwError("network chainId mismatch", n.INVALID_ARGUMENT, {
            arg: "network",
            value: e
          }), {
            name: e.name,
            chainId: s.chainId,
            ensAddress: e.ensAddress || s.ensAddress || null,
            _defaultProvider: e._defaultProvider || s._defaultProvider || null
          }) : ("number" != typeof e.chainId && n.throwError("invalid network chainId", n.INVALID_ARGUMENT, {
            arg: "network",
            value: e
          }), e);
        };
      }, {
        "../errors": 5
      }],
      72: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var r = e("../utils/bytes"),
            n = e("./hmac");

        a.pbkdf2 = function (e, t, a, s, o) {
          var i;
          e = r.arrayify(e), t = r.arrayify(t);
          var c,
              u,
              d = 1,
              f = new Uint8Array(s),
              l = new Uint8Array(t.length + 4);
          l.set(t);

          for (var h = 1; h <= d; h++) {
            l[t.length] = h >> 24 & 255, l[t.length + 1] = h >> 16 & 255, l[t.length + 2] = h >> 8 & 255, l[t.length + 3] = 255 & h;
            var p = n.computeHmac(o, e, l);
            i || (i = p.length, u = new Uint8Array(i), c = s - ((d = Math.ceil(s / i)) - 1) * i), u.set(p);

            for (var b = 1; b < a; b++) {
              p = n.computeHmac(o, e, p);

              for (var m = 0; m < i; m++) {
                u[m] ^= p[m];
              }
            }

            var y = (h - 1) * i,
                v = h === d ? c : i;
            f.set(r.arrayify(u).slice(0, v), y);
          }

          return r.arrayify(f);
        };
      }, {
        "../utils/bytes": 63,
        "./hmac": 66
      }],
      73: [function (e, t, a) {
        "use strict";

        var r = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var n = r(e("../errors"));

        function s(e, t, a) {
          Object.defineProperty(e, t, {
            enumerable: !0,
            value: a,
            writable: !1
          });
        }

        function o(e, t) {
          return e && e._ethersType === t;
        }

        a.defineReadOnly = s, a.setType = function (e, t) {
          Object.defineProperty(e, "_ethersType", {
            configurable: !1,
            value: t,
            writable: !1
          });
        }, a.isType = o, a.resolveProperties = function (e) {
          var t = {},
              a = [];
          return Object.keys(e).forEach(function (r) {
            var n = e[r];
            n instanceof Promise ? a.push(n.then(function (e) {
              return t[r] = e, null;
            })) : t[r] = n;
          }), Promise.all(a).then(function () {
            return t;
          });
        }, a.checkProperties = function (e, t) {
          e && "object" == typeof e || n.throwError("invalid object", n.INVALID_ARGUMENT, {
            argument: "object",
            value: e
          }), Object.keys(e).forEach(function (a) {
            t[a] || n.throwError("invalid object key - " + a, n.INVALID_ARGUMENT, {
              argument: "transaction",
              value: e,
              key: a
            });
          });
        }, a.shallowCopy = function (e) {
          var t = {};

          for (var a in e) {
            t[a] = e[a];
          }

          return t;
        };
        var i = {
          boolean: !0,
          number: !0,
          string: !0
        };
        a.deepCopy = function e(t, a) {
          if (null == t || i[typeof t]) return t;

          if (Array.isArray(t)) {
            var r = t.map(function (t) {
              return e(t, a);
            });
            return a && Object.freeze(r), r;
          }

          if ("object" == typeof t) {
            if (o(t, "BigNumber")) return t;
            if (o(t, "Description")) return t;
            if (o(t, "Indexed")) return t;

            for (var n in r = {}, t) {
              var c = t[n];
              void 0 !== c && s(r, n, e(c, a));
            }

            return a && Object.freeze(r), r;
          }

          if ("function" == typeof t) return t;
          throw new Error("Cannot deepCopy " + typeof t);
        }, a.inheritable = function e(t) {
          return function (a) {
            !function (e, t) {
              e.super_ = t, e.prototype = Object.create(t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0
                }
              });
            }(a, t), s(a, "inherits", e(a));
          };
        };
      }, {
        "../errors": 5
      }],
      74: [function (e, a, r) {
        (function (t) {
          "use strict";

          Object.defineProperty(r, "__esModule", {
            value: !0
          });
          var a = e("../utils/bytes"),
              n = e("../utils/properties"),
              s = t.crypto || t.msCrypto;

          function o(e) {
            if (e <= 0 || 1024 < e || parseInt(String(e)) != e) throw new Error("invalid length");
            var t = new Uint8Array(e);
            return s.getRandomValues(t), a.arrayify(t);
          }

          s && s.getRandomValues || (console.log("WARNING: Missing strong random number source; using weak randomBytes"), s = {
            getRandomValues: function getRandomValues(e) {
              for (var t = 0; t < 20; t++) {
                for (var a = 0; a < e.length; a++) {
                  t ? e[a] ^= Math.trunc(256 * Math.random()) : e[a] = Math.trunc(256 * Math.random());
                }
              }

              return e;
            },
            _weakCrypto: !0
          }), r.randomBytes = o, !0 === s._weakCrypto && n.defineReadOnly(o, "_weakCrypto", !0);
        }).call(this, void 0 !== t ? t : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
      }, {
        "../utils/bytes": 63,
        "../utils/properties": 73
      }],
      75: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var r = e("./bytes");

        function n(e) {
          for (var t = []; e;) {
            t.unshift(255 & e), e >>= 8;
          }

          return t;
        }

        function s(e, t, a) {
          for (var r = 0, n = 0; n < a; n++) {
            r = 256 * r + e[t + n];
          }

          return r;
        }

        function o(e, t, a, r) {
          for (var n = []; a < t + 1 + r;) {
            var s = i(e, a);
            if (n.push(s.result), t + 1 + r < (a += s.consumed)) throw new Error("invalid rlp");
          }

          return {
            consumed: 1 + r,
            result: n
          };
        }

        function i(e, t) {
          if (0 === e.length) throw new Error("invalid rlp data");

          if (248 <= e[t]) {
            if (t + 1 + (a = e[t] - 247) > e.length) throw new Error("too short");
            if (t + 1 + a + (n = s(e, t + 1, a)) > e.length) throw new Error("to short");
            return o(e, t, t + 1 + a, a + n);
          }

          if (192 <= e[t]) {
            if (t + 1 + (n = e[t] - 192) > e.length) throw new Error("invalid rlp data");
            return o(e, t, t + 1, n);
          }

          if (184 <= e[t]) {
            var a;
            if (t + 1 + (a = e[t] - 183) > e.length) throw new Error("invalid rlp data");
            if (t + 1 + a + (n = s(e, t + 1, a)) > e.length) throw new Error("invalid rlp data");
            return {
              consumed: 1 + a + n,
              result: r.hexlify(e.slice(t + 1 + a, t + 1 + a + n))
            };
          }

          if (128 <= e[t]) {
            var n;
            if (t + 1 + (n = e[t] - 128) > e.length) throw new Error("invlaid rlp data");
            return {
              consumed: 1 + n,
              result: r.hexlify(e.slice(t + 1, t + 1 + n))
            };
          }

          return {
            consumed: 1,
            result: r.hexlify(e[t])
          };
        }

        a.encode = function (e) {
          return r.hexlify(function e(t) {
            if (Array.isArray(t)) {
              var a = [];
              return t.forEach(function (t) {
                a = a.concat(e(t));
              }), a.length <= 55 ? (a.unshift(192 + a.length), a) : ((s = n(a.length)).unshift(247 + s.length), s.concat(a));
            }

            var s,
                o = Array.prototype.slice.call(r.arrayify(t));
            return 1 === o.length && o[0] <= 127 ? o : o.length <= 55 ? (o.unshift(128 + o.length), o) : ((s = n(o.length)).unshift(183 + s.length), s.concat(o));
          }(e));
        }, a.decode = function (e) {
          var t = r.arrayify(e),
              a = i(t, 0);
          if (a.consumed !== t.length) throw new Error("invalid rlp data");
          return a.result;
        };
      }, {
        "./bytes": 63
      }],
      76: [function (e, t, a) {
        "use strict";

        var r = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var n = e("elliptic"),
            s = e("./address"),
            o = e("./bytes"),
            i = e("./hash"),
            c = e("./keccak256"),
            u = e("./properties"),
            d = r(e("../errors")),
            f = null;

        function l() {
          return f = f || new n.ec("secp256k1");
        }

        var h = (p.prototype.sign = function (e) {
          var t = l().keyFromPrivate(o.arrayify(this.privateKey)).sign(o.arrayify(e), {
            canonical: !0
          });
          return {
            recoveryParam: t.recoveryParam,
            r: o.hexZeroPad("0x" + t.r.toString(16), 32),
            s: o.hexZeroPad("0x" + t.s.toString(16), 32),
            v: 27 + t.recoveryParam
          };
        }, p.prototype.computeSharedSecret = function (e) {
          var t = l().keyFromPrivate(o.arrayify(this.privateKey)),
              a = l().keyFromPublic(o.arrayify(b(e)));
          return o.hexZeroPad("0x" + t.derive(a.getPublic()).toString(16), 32);
        }, p.prototype._addPoint = function (e) {
          var t = l().keyFromPublic(o.arrayify(this.publicKey)),
              a = l().keyFromPublic(o.arrayify(e));
          return "0x" + t.pub.add(a.pub).encodeCompressed("hex");
        }, p);

        function p(e) {
          var t = l().keyFromPrivate(o.arrayify(e));
          u.defineReadOnly(this, "privateKey", o.hexlify(t.priv.toArray("be", 32))), u.defineReadOnly(this, "publicKey", "0x" + t.getPublic(!1, "hex")), u.defineReadOnly(this, "compressedPublicKey", "0x" + t.getPublic(!0, "hex")), u.defineReadOnly(this, "publicKeyBytes", t.getPublic().encode(null, !0));
        }

        function b(e, t) {
          var a = o.arrayify(e);
          if (32 !== a.length) return 33 === a.length ? t ? o.hexlify(a) : "0x" + l().keyFromPublic(a).getPublic(!1, "hex") : 65 === a.length ? t ? "0x" + l().keyFromPublic(a).getPublic(!0, "hex") : o.hexlify(a) : (d.throwError("invalid public or private key", d.INVALID_ARGUMENT, {
            arg: "key",
            value: "[REDACTED]"
          }), null);
          var r = new h(a);
          return t ? r.compressedPublicKey : r.publicKey;
        }

        function m(e) {
          var t = "0x" + b(e).slice(4);
          return s.getAddress("0x" + c.keccak256(t).substring(26));
        }

        function y(e, t) {
          var a = o.splitSignature(t),
              r = {
            r: o.arrayify(a.r),
            s: o.arrayify(a.s)
          };
          return "0x" + l().recoverPubKey(o.arrayify(e), r, a.recoveryParam).encode("hex", !1);
        }

        function v(e, t) {
          return m(y(o.arrayify(e), t));
        }

        a.KeyPair = h, a.computePublicKey = b, a.computeAddress = m, a.recoverPublicKey = y, a.recoverAddress = v, a.verifyMessage = function (e, t) {
          return v(i.hashMessage(e), t);
        };
      }, {
        "../errors": 5,
        "./address": 59,
        "./bytes": 63,
        "./hash": 64,
        "./keccak256": 70,
        "./properties": 73,
        elliptic: 12
      }],
      77: [function (e, t, a) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        },
            n = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var s = r(e("aes-js")),
            o = r(e("scrypt-js")),
            i = r(e("uuid")),
            c = e("./signing-key"),
            u = n(e("./hdnode")),
            d = e("./address"),
            f = e("./bytes"),
            l = e("./pbkdf2"),
            h = e("./keccak256"),
            p = e("./utf8"),
            b = e("./random-bytes");

        function m(e) {
          return "string" == typeof e && "0x" !== e.substring(0, 2) && (e = "0x" + e), f.arrayify(e);
        }

        function y(e, t) {
          for (e = String(e); e.length < t;) {
            e = "0" + e;
          }

          return e;
        }

        function v(e) {
          return "string" == typeof e ? p.toUtf8Bytes(e, p.UnicodeNormalizationForm.NFKC) : f.arrayify(e);
        }

        function _(e, t) {
          for (var a = e, r = t.toLowerCase().split("/"), n = 0; n < r.length; n++) {
            var s = null;

            for (var o in a) {
              if (o.toLowerCase() === r[n]) {
                s = a[o];
                break;
              }
            }

            if (null === s) return null;
            a = s;
          }

          return a;
        }

        a.decryptCrowdsale = function (e, t) {
          var a = JSON.parse(e);
          t = v(t);
          var r = d.getAddress(_(a, "ethaddr")),
              n = m(_(a, "encseed"));
          if (!n || n.length % 16 != 0) throw new Error("invalid encseed");
          var o = l.pbkdf2(t, t, 2e3, 32, "sha256").slice(0, 16),
              i = n.slice(0, 16),
              u = n.slice(16),
              b = new s.default.ModeOfOperation.cbc(o, i),
              y = f.arrayify(b.decrypt(u));
          y = s.default.padding.pkcs7.strip(y);

          for (var g = "", A = 0; A < y.length; A++) {
            g += String.fromCharCode(y[A]);
          }

          var w = p.toUtf8Bytes(g),
              T = new c.SigningKey(h.keccak256(w));
          if (T.address !== r) throw new Error("corrupt crowdsale wallet");
          return T;
        }, a.decrypt = function (e, t, a) {
          function r(e, t) {
            var a = m(_(n, "crypto/ciphertext"));
            if (f.hexlify(function (e, t) {
              return h.keccak256(f.concat([e, t]));
            }(e.slice(16, 32), a)).substring(2) !== _(n, "crypto/mac").toLowerCase()) return t(new Error("invalid password")), null;

            var r = function (e, t) {
              if ("aes-128-ctr" !== _(n, "crypto/cipher")) return null;
              var a = m(_(n, "crypto/cipherparams/iv")),
                  r = new s.default.Counter(a),
                  o = new s.default.ModeOfOperation.ctr(e, r);
              return f.arrayify(o.decrypt(t));
            }(e.slice(0, 16), a),
                o = e.slice(32, 64);

            if (!r) return t(new Error("unsupported cipher")), null;
            var i = new c.SigningKey(r);
            if (i.address !== d.getAddress(n.address)) return t(new Error("address mismatch")), null;

            if ("0.1" === _(n, "x-ethers/version")) {
              var l = m(_(n, "x-ethers/mnemonicCiphertext")),
                  p = m(_(n, "x-ethers/mnemonicCounter")),
                  b = new s.default.Counter(p),
                  y = new s.default.ModeOfOperation.ctr(o, b),
                  v = _(n, "x-ethers/path") || u.defaultPath,
                  g = f.arrayify(y.decrypt(l)),
                  A = u.entropyToMnemonic(g),
                  w = u.fromMnemonic(A).derivePath(v);
              if (w.privateKey != f.hexlify(r)) return t(new Error("mnemonic mismatch")), null;
              i = new c.SigningKey(w);
            }

            return i;
          }

          var n = JSON.parse(e),
              i = v(t);
          return new Promise(function (e, t) {
            var s = _(n, "crypto/kdf");

            if (s && "string" == typeof s) {
              if ("scrypt" === s.toLowerCase()) {
                var c = m(_(n, "crypto/kdfparams/salt")),
                    u = parseInt(_(n, "crypto/kdfparams/n")),
                    d = parseInt(_(n, "crypto/kdfparams/r")),
                    h = parseInt(_(n, "crypto/kdfparams/p"));
                if (!u || !d || !h) return void t(new Error("unsupported key-derivation function parameters"));
                if (0 != (u & u - 1)) return void t(new Error("unsupported key-derivation function parameter value for N"));
                if (32 !== (y = parseInt(_(n, "crypto/kdfparams/dklen")))) return void t(new Error("unsupported key-derivation derived-key length"));
                a && a(0), o.default(i, c, u, d, h, 64, function (n, s, o) {
                  if (n) n.progress = s, t(n);else if (o) {
                    var i = r(o = f.arrayify(o), t);
                    if (!i) return;
                    a && a(1), e(i);
                  } else if (a) return a(s);
                });
              } else if ("pbkdf2" === s.toLowerCase()) {
                c = m(_(n, "crypto/kdfparams/salt"));

                var p = null,
                    b = _(n, "crypto/kdfparams/prf");

                if ("hmac-sha256" === b) p = "sha256";else {
                  if ("hmac-sha512" !== b) return void t(new Error("unsupported prf"));
                  p = "sha512";
                }
                var y,
                    v = parseInt(_(n, "crypto/kdfparams/c"));
                if (32 !== (y = parseInt(_(n, "crypto/kdfparams/dklen")))) return void t(new Error("unsupported key-derivation derived-key length"));
                var g = r(l.pbkdf2(i, c, v, y, p), t);
                if (!g) return;
                e(g);
              } else t(new Error("unsupported key-derivation function"));
            } else t(new Error("unsupported key-derivation function"));
          });
        }, a.encrypt = function (e, t, a, r) {
          var n;
          if ("function" != typeof a || r || (r = a, a = {}), a = a || {}, 32 !== (n = c.SigningKey.isSigningKey(e) ? f.arrayify(e.privateKey) : f.arrayify(e)).length) throw new Error("invalid private key");
          var d = v(t),
              l = null;
          if (a.entropy && (l = f.arrayify(a.entropy)), a.mnemonic) if (l) {
            if (u.entropyToMnemonic(l) !== a.mnemonic) throw new Error("entropy and mnemonic mismatch");
          } else l = f.arrayify(u.mnemonicToEntropy(a.mnemonic));
          var p = a.path;
          l && !p && (p = u.defaultPath);
          var m,
              _ = a.client;
          _ = _ || "ethers.js", m = a.salt ? f.arrayify(a.salt) : b.randomBytes(32);
          var g = null;

          if (a.iv) {
            if (16 !== (g = f.arrayify(a.iv)).length) throw new Error("invalid iv");
          } else g = b.randomBytes(16);

          var A = null;

          if (a.uuid) {
            if (16 !== (A = f.arrayify(a.uuid)).length) throw new Error("invalid uuid");
          } else A = b.randomBytes(16);

          var w = 1 << 17,
              T = 8,
              x = 1;
          return a.scrypt && (a.scrypt.N && (w = a.scrypt.N), a.scrypt.r && (T = a.scrypt.r), a.scrypt.p && (x = a.scrypt.p)), new Promise(function (e, t) {
            r && r(0), o.default(d, m, w, T, x, 64, function (a, o, u) {
              if (a) a.progress = o, t(a);else if (u) {
                var d = (u = f.arrayify(u)).slice(0, 16),
                    v = u.slice(16, 32),
                    D = u.slice(32, 64),
                    C = new c.SigningKey(n).address,
                    S = new s.default.Counter(g),
                    E = new s.default.ModeOfOperation.ctr(d, S),
                    B = f.arrayify(E.encrypt(n)),
                    k = h.keccak256(f.concat([v, B])),
                    R = {
                  address: C.substring(2).toLowerCase(),
                  id: i.default.v4({
                    random: A
                  }),
                  version: 3,
                  Crypto: {
                    cipher: "aes-128-ctr",
                    cipherparams: {
                      iv: f.hexlify(g).substring(2)
                    },
                    ciphertext: f.hexlify(B).substring(2),
                    kdf: "scrypt",
                    kdfparams: {
                      salt: f.hexlify(m).substring(2),
                      n: w,
                      dklen: 32,
                      p: x,
                      r: T
                    },
                    mac: k.substring(2)
                  }
                };

                if (l) {
                  var W = b.randomBytes(16),
                      I = new s.default.Counter(W),
                      N = new s.default.ModeOfOperation.ctr(D, I),
                      M = f.arrayify(N.encrypt(l)),
                      P = new Date(),
                      L = P.getUTCFullYear() + "-" + y(P.getUTCMonth() + 1, 2) + "-" + y(P.getUTCDate(), 2) + "T" + y(P.getUTCHours(), 2) + "-" + y(P.getUTCMinutes(), 2) + "-" + y(P.getUTCSeconds(), 2) + ".0Z";
                  R["x-ethers"] = {
                    client: _,
                    gethFilename: "UTC--" + L + "--" + R.address,
                    mnemonicCounter: f.hexlify(W).substring(2),
                    mnemonicCiphertext: f.hexlify(M).substring(2),
                    path: p,
                    version: "0.1"
                  };
                }

                r && r(1), e(JSON.stringify(R));
              } else if (r) return r(o);
            });
          });
        };
      }, {
        "./address": 59,
        "./bytes": 63,
        "./hdnode": 65,
        "./keccak256": 70,
        "./pbkdf2": 72,
        "./random-bytes": 74,
        "./signing-key": 80,
        "./utf8": 84,
        "aes-js": 8,
        "scrypt-js": 43,
        uuid: 47
      }],
      78: [function (e, t, a) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var n = r(e("hash.js")),
            s = e("./bytes");
        a.ripemd160 = function (e) {
          return "0x" + n.default.ripemd160().update(s.arrayify(e)).digest("hex");
        }, a.sha256 = function (e) {
          return "0x" + n.default.sha256().update(s.arrayify(e)).digest("hex");
        }, a.sha512 = function (e) {
          return "0x" + n.default.sha512().update(s.arrayify(e)).digest("hex");
        };
      }, {
        "./bytes": 63,
        "hash.js": 27
      }],
      79: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        }), e("setimmediate"), a.platform = "browser";
      }, {
        setimmediate: 44
      }],
      80: [function (e, t, a) {
        "use strict";

        var r = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var n = e("./hdnode"),
            s = e("./bytes"),
            o = e("./properties"),
            i = e("./secp256k1"),
            c = r(e("../errors")),
            u = (d.prototype.signDigest = function (e) {
          return this.keyPair.sign(e);
        }, d.prototype.computeSharedSecret = function (e) {
          return this.keyPair.computeSharedSecret(s.arrayify(e));
        }, d.isSigningKey = function (e) {
          return o.isType(e, "SigningKey");
        }, d);

        function d(e) {
          var t;
          c.checkNew(this, d), t = n.HDNode.isHDNode(e) ? (o.defineReadOnly(this, "mnemonic", e.mnemonic), o.defineReadOnly(this, "path", e.path), s.arrayify(e.privateKey)) : ("string" == typeof e && e.match(/^[0-9a-f]*$/i) && 64 === e.length && (e = "0x" + e), s.arrayify(e));

          try {
            32 !== t.length && c.throwError("exactly 32 bytes required", c.INVALID_ARGUMENT, {
              arg: "privateKey",
              value: "[REDACTED]"
            });
          } catch (e) {
            var a = {
              arg: "privateKey",
              reason: e.reason,
              value: "[REDACTED]"
            };
            e.value && ("number" == typeof e.value.length && (a.length = e.value.length), a.type = typeof e.value), c.throwError("invalid private key", e.code, a);
          }

          o.defineReadOnly(this, "privateKey", s.hexlify(t)), o.defineReadOnly(this, "keyPair", new i.KeyPair(t)), o.defineReadOnly(this, "publicKey", this.keyPair.publicKey), o.defineReadOnly(this, "address", i.computeAddress(this.keyPair.publicKey)), o.setType(this, "SigningKey");
        }

        a.SigningKey = u;
      }, {
        "../errors": 5,
        "./bytes": 63,
        "./hdnode": 65,
        "./properties": 73,
        "./secp256k1": 76
      }],
      81: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var r = e("./bignumber"),
            n = e("./bytes"),
            s = e("./utf8"),
            o = e("./keccak256"),
            i = e("./sha2"),
            c = new RegExp("^bytes([0-9]+)$"),
            u = new RegExp("^(u?int)([0-9]*)$"),
            d = new RegExp("^(.*)\\[([0-9]*)\\]$"),
            f = "0000000000000000000000000000000000000000000000000000000000000000";

        function l(e, t) {
          if (e.length != t.length) throw new Error("type/value count mismatch");
          var a = [];
          return e.forEach(function (e, o) {
            a.push(function e(t, a, o) {
              switch (t) {
                case "address":
                  return o ? n.padZeros(a, 32) : n.arrayify(a);

                case "string":
                  return s.toUtf8Bytes(a);

                case "bytes":
                  return n.arrayify(a);

                case "bool":
                  return a = a ? "0x01" : "0x00", o ? n.padZeros(a, 32) : n.arrayify(a);
              }

              var i = t.match(u);

              if (i) {
                if ((l = parseInt(i[2] || "256")) % 8 != 0 || 0 === l || 256 < l) throw new Error("invalid number type - " + t);
                return o && (l = 256), a = r.bigNumberify(a).toTwos(l), n.padZeros(a, l / 8);
              }

              if (i = t.match(c)) {
                var l = parseInt(i[1]);
                if (String(l) != i[1] || 0 === l || 32 < l) throw new Error("invalid number type - " + t);
                if (n.arrayify(a).byteLength !== l) throw new Error("invalid value for " + t);
                return o ? n.arrayify((a + f).substring(0, 66)) : a;
              }

              if ((i = t.match(d)) && Array.isArray(a)) {
                var h = i[1];
                if (parseInt(i[2] || String(a.length)) != a.length) throw new Error("invalid value for " + t);
                var p = [];
                return a.forEach(function (t) {
                  p.push(e(h, t, !0));
                }), n.concat(p);
              }

              throw new Error("unknown type - " + t);
            }(e, t[o]));
          }), n.hexlify(n.concat(a));
        }

        a.pack = l, a.keccak256 = function (e, t) {
          return o.keccak256(l(e, t));
        }, a.sha256 = function (e, t) {
          return i.sha256(l(e, t));
        };
      }, {
        "./bignumber": 62,
        "./bytes": 63,
        "./keccak256": 70,
        "./sha2": 78,
        "./utf8": 84
      }],
      82: [function (e, t, a) {
        "use strict";

        var r = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var n = e("../constants"),
            s = r(e("../errors")),
            o = e("./secp256k1"),
            i = e("./address"),
            c = e("./bignumber"),
            u = e("./bytes"),
            d = e("./keccak256"),
            f = e("./properties"),
            l = r(e("./rlp")),
            h = e("../providers/abstract-provider");

        function p(e) {
          return "0x" === e ? n.Zero : c.bigNumberify(e);
        }

        var b = [{
          name: "nonce",
          maxLength: 32
        }, {
          name: "gasPrice",
          maxLength: 32
        }, {
          name: "gasLimit",
          maxLength: 32
        }, {
          name: "to",
          length: 20
        }, {
          name: "value",
          maxLength: 32
        }, {
          name: "data"
        }],
            m = {
          chainId: !0,
          data: !0,
          gasLimit: !0,
          gasPrice: !0,
          nonce: !0,
          to: !0,
          value: !0
        };
        a.serialize = function (e, t) {
          f.checkProperties(e, m);
          var a = [];
          b.forEach(function (t) {
            var r = e[t.name] || [];
            r = u.arrayify(u.hexlify(r)), t.length && r.length !== t.length && 0 < r.length && s.throwError("invalid length for " + t.name, s.INVALID_ARGUMENT, {
              arg: "transaction" + t.name,
              value: r
            }), t.maxLength && (r = u.stripZeros(r)).length > t.maxLength && s.throwError("invalid length for " + t.name, s.INVALID_ARGUMENT, {
              arg: "transaction" + t.name,
              value: r
            }), a.push(u.hexlify(r));
          }), null != e.chainId && 0 !== e.chainId && (a.push(u.hexlify(e.chainId)), a.push("0x"), a.push("0x"));
          var r = l.encode(a);
          if (!t) return r;
          var n = u.splitSignature(t),
              o = 27 + n.recoveryParam;
          return 9 === a.length && (a.pop(), a.pop(), a.pop(), o += 2 * e.chainId + 8), a.push(u.hexlify(o)), a.push(u.stripZeros(u.arrayify(n.r))), a.push(u.stripZeros(u.arrayify(n.s))), l.encode(a);
        }, a.parse = function (e) {
          var t = l.decode(e);
          9 !== t.length && 6 !== t.length && s.throwError("invalid raw transaction", s.INVALID_ARGUMENT, {
            arg: "rawTransactin",
            value: e
          });
          var a = {
            nonce: p(t[0]).toNumber(),
            gasPrice: p(t[1]),
            gasLimit: p(t[2]),
            to: function (e) {
              return "0x" === e ? null : i.getAddress(e);
            }(t[3]),
            value: p(t[4]),
            data: t[5],
            chainId: 0
          };
          if (6 === t.length) return a;

          try {
            a.v = c.bigNumberify(t[6]).toNumber();
          } catch (e) {
            return s.info(e), a;
          }

          if (a.r = u.hexZeroPad(t[7], 32), a.s = u.hexZeroPad(t[8], 32), c.bigNumberify(a.r).isZero() && c.bigNumberify(a.s).isZero()) a.chainId = a.v, a.v = 0;else {
            a.chainId = Math.floor((a.v - 35) / 2), a.chainId < 0 && (a.chainId = 0);
            var r = a.v - 27,
                n = t.slice(0, 6);
            0 !== a.chainId && (n.push(u.hexlify(a.chainId)), n.push("0x"), n.push("0x"), r -= 2 * a.chainId + 8);
            var f = d.keccak256(l.encode(n));

            try {
              a.from = o.recoverAddress(f, {
                r: u.hexlify(a.r),
                s: u.hexlify(a.s),
                recoveryParam: r
              });
            } catch (e) {
              s.info(e);
            }

            a.hash = d.keccak256(e);
          }
          return a;
        }, a.populateTransaction = function (e, t, a) {
          h.Provider.isProvider(t) || s.throwError("missing provider", s.INVALID_ARGUMENT, {
            argument: "provider",
            value: t
          }), f.checkProperties(e, m);
          var r = f.shallowCopy(e);

          if (null != r.to && (r.to = t.resolveName(r.to)), null == r.gasPrice && (r.gasPrice = t.getGasPrice()), null == r.nonce && (r.nonce = t.getTransactionCount(a)), null == r.gasLimit) {
            var n = f.shallowCopy(r);
            n.from = a, r.gasLimit = t.estimateGas(n);
          }

          return null == r.chainId && (r.chainId = t.getNetwork().then(function (e) {
            return e.chainId;
          })), f.resolveProperties(r);
        };
      }, {
        "../constants": 3,
        "../errors": 5,
        "../providers/abstract-provider": 49,
        "./address": 59,
        "./bignumber": 62,
        "./bytes": 63,
        "./keccak256": 70,
        "./properties": 73,
        "./rlp": 75,
        "./secp256k1": 76
      }],
      83: [function (e, t, a) {
        "use strict";

        var r = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var n,
            s = e("../constants"),
            o = r(e("../errors")),
            i = e("./bignumber"),
            c = {};

        function u(e) {
          return {
            decimals: e.length - 1,
            tenPower: i.bigNumberify(e)
          };
        }

        function d(e) {
          var t = c[String(e).toLowerCase()];

          if (!t && "number" == typeof e && parseInt(String(e)) == e && 0 <= e && e <= 256) {
            for (var a = "1", r = 0; r < e; r++) {
              a += "0";
            }

            t = u(a);
          }

          return t || o.throwError("invalid unitType", o.INVALID_ARGUMENT, {
            argument: "name",
            value: e
          }), t;
        }

        function f(e, t) {
          var a = d(t),
              r = (e = i.bigNumberify(e)).lt(s.Zero);
          r && (e = e.mul(s.NegativeOne));

          for (var n = e.mod(a.tenPower).toString(); n.length < a.decimals;) {
            n = "0" + n;
          }

          return n = n.match(/^([0-9]*[1-9]|0)(0*)/)[1], e = e.div(a.tenPower).toString() + "." + n, r && (e = "-" + e), e;
        }

        function l(e, t) {
          null == t && (t = 18);
          var a = d(t);
          if ("string" == typeof e && e.match(/^-?[0-9.,]+$/) || o.throwError("invalid decimal value", o.INVALID_ARGUMENT, {
            arg: "value",
            value: e
          }), 0 === a.decimals) return i.bigNumberify(e);
          var r = "-" === e.substring(0, 1);
          r && (e = e.substring(1)), "." === e && o.throwError("missing value", o.INVALID_ARGUMENT, {
            arg: "value",
            value: e
          });
          var n = e.split(".");
          2 < n.length && o.throwError("too many decimal points", o.INVALID_ARGUMENT, {
            arg: "value",
            value: e
          });
          var c = n[0],
              u = n[1];

          for (c = c || "0", (u = u || "0").length > a.decimals && o.throwError("underflow occurred", o.NUMERIC_FAULT, {
            operation: "division",
            fault: "underflow"
          }); u.length < a.decimals;) {
            u += "0";
          }

          var f = i.bigNumberify(c),
              l = i.bigNumberify(u),
              h = f.mul(a.tenPower).add(l);
          return r && (h = h.mul(s.NegativeOne)), h;
        }

        n = "1", ["wei", "kwei", "Mwei", "Gwei", "szabo", "finney", "ether"].forEach(function (e) {
          var t = u(n);
          c[e.toLowerCase()] = t, c[String(t.decimals)] = t, n += "000";
        }), a.commify = function (e) {
          var t = String(e).split(".");
          (2 < t.length || !t[0].match(/^-?[0-9]*$/) || t[1] && !t[1].match(/^[0-9]*$/) || "." === e || "-." === e) && o.throwError("invalid value", o.INVALID_ARGUMENT, {
            argument: "value",
            value: e
          });
          var a = t[0],
              r = "";

          for ("-" === a.substring(0, 1) && (r = "-", a = a.substring(1)); "0" === a.substring(0, 1);) {
            a = a.substring(1);
          }

          "" === a && (a = "0");
          var n = "";
          2 === t.length && (n = "." + (t[1] || "0"));

          for (var s = []; a.length;) {
            if (a.length <= 3) {
              s.unshift(a);
              break;
            }

            var i = a.length - 3;
            s.unshift(a.substring(i)), a = a.substring(0, i);
          }

          return r + s.join(",") + n;
        }, a.formatUnits = f, a.parseUnits = l, a.formatEther = function (e) {
          return f(e, 18);
        }, a.parseEther = function (e) {
          return l(e, 18);
        };
      }, {
        "../constants": 3,
        "../errors": 5,
        "./bignumber": 62
      }],
      84: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var r,
            n,
            s = e("../constants"),
            o = e("../errors"),
            i = e("./bytes");

        function c(e, t) {
          void 0 === t && (t = r.current), t != r.current && (o.checkNormalize(), e = e.normalize(t));

          for (var a = [], n = 0; n < e.length; n++) {
            var s = e.charCodeAt(n);
            if (s < 128) a.push(s);else if (s < 2048) a.push(s >> 6 | 192), a.push(63 & s | 128);else if (55296 == (64512 & s)) {
              n++;
              var c = e.charCodeAt(n);
              if (n >= e.length || 56320 != (64512 & c)) throw new Error("invalid utf-8 string");
              s = 65536 + ((1023 & s) << 10) + (1023 & c), a.push(s >> 18 | 240), a.push(s >> 12 & 63 | 128), a.push(s >> 6 & 63 | 128), a.push(63 & s | 128);
            } else a.push(s >> 12 | 224), a.push(s >> 6 & 63 | 128), a.push(63 & s | 128);
          }

          return i.arrayify(a);
        }

        function u(e, t) {
          e = i.arrayify(e);

          for (var a = "", r = 0; r < e.length;) {
            var n = e[r++];

            if (n >> 7 != 0) {
              var s = null,
                  o = null;
              if (192 == (224 & n)) s = 1, o = 127;else if (224 == (240 & n)) s = 2, o = 2047;else {
                if (240 != (248 & n)) {
                  if (t) continue;
                  if (128 == (192 & n)) throw new Error("invalid utf8 byte sequence; unexpected continuation byte");
                  throw new Error("invalid utf8 byte sequence; invalid prefix");
                }

                s = 3, o = 65535;
              }

              if (r + s > e.length) {
                if (!t) throw new Error("invalid utf8 byte sequence; too short");

                for (; r < e.length && e[r] >> 6 == 2; r++) {
                  ;
                }
              } else {
                for (var c = n & (1 << 8 - s - 1) - 1, u = 0; u < s; u++) {
                  var d = e[r];

                  if (128 != (192 & d)) {
                    c = null;
                    break;
                  }

                  c = c << 6 | 63 & d, r++;
                }

                if (null !== c) {
                  if (c <= o) {
                    if (!t) throw new Error("invalid utf8 byte sequence; overlong");
                  } else if (1114111 < c) {
                    if (!t) throw new Error("invalid utf8 byte sequence; out-of-range");
                  } else if (55296 <= c && c <= 57343) {
                    if (!t) throw new Error("invalid utf8 byte sequence; utf-16 surrogate");
                  } else c <= 65535 ? a += String.fromCharCode(c) : (c -= 65536, a += String.fromCharCode(55296 + (c >> 10 & 1023), 56320 + (1023 & c)));
                } else if (!t) throw new Error("invalid utf8 byte sequence; invalid continuation byte");
              }
            } else a += String.fromCharCode(n);
          }

          return a;
        }

        (n = r = a.UnicodeNormalizationForm || (a.UnicodeNormalizationForm = {})).current = "", n.NFC = "NFC", n.NFD = "NFD", n.NFKC = "NFKC", n.NFKD = "NFKD", a.toUtf8Bytes = c, a.toUtf8String = u, a.formatBytes32String = function (e) {
          var t = c(e);
          if (31 < t.length) throw new Error("bytes32 string must be less than 32 bytes");
          return i.hexlify(i.concat([t, s.HashZero]).slice(0, 32));
        }, a.parseBytes32String = function (e) {
          var t = i.arrayify(e);
          if (32 !== t.length) throw new Error("invalid bytes32 - not 32 bytes long");
          if (0 !== t[31]) throw new Error("invalid bytes32 string - no null terminator");

          for (var a = 31; 0 === t[a - 1];) {
            a--;
          }

          return u(t.slice(0, a));
        };
      }, {
        "../constants": 3,
        "../errors": 5,
        "./bytes": 63
      }],
      85: [function (e, t, a) {
        "use strict";

        var r = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var n = e("xmlhttprequest"),
            s = e("./base64"),
            o = e("./properties"),
            i = e("./utf8"),
            c = r(e("../errors"));
        a.fetchJson = function (e, t, a) {
          var r = {},
              o = null,
              u = 12e4;
          if ("string" == typeof e) o = e;else if ("object" == typeof e) {
            if (null == e.url && c.throwError("missing URL", c.MISSING_ARGUMENT, {
              arg: "url"
            }), o = e.url, "number" == typeof e.timeout && 0 < e.timeout && (u = e.timeout), e.headers) for (var d in e.headers) {
              r[d.toLowerCase()] = {
                key: d,
                value: String(e.headers[d])
              };
            }

            if (null != e.user && null != e.password) {
              "https:" !== o.substring(0, 6) && !0 !== e.allowInsecure && c.throwError("basic authentication requires a secure https url", c.INVALID_ARGUMENT, {
                arg: "url",
                url: o,
                user: e.user,
                password: "[REDACTED]"
              });
              var f = e.user + ":" + e.password;
              r.authorization = {
                key: "Authorization",
                value: "Basic " + s.encode(i.toUtf8Bytes(f))
              };
            }
          }
          return new Promise(function (e, s) {
            var i = new n.XMLHttpRequest(),
                c = null;

            function d() {
              null != c && (clearTimeout(c), c = null);
            }

            c = setTimeout(function () {
              null != c && (c = null, s(new Error("timeout")), setTimeout(function () {
                i.abort();
              }, 0));
            }, u), t ? (i.open("POST", o, !0), r["content-type"] = {
              key: "Content-Type",
              value: "application/json"
            }) : i.open("GET", o, !0), Object.keys(r).forEach(function (e) {
              var t = r[e];
              i.setRequestHeader(t.key, t.value);
            }), i.onreadystatechange = function () {
              if (4 === i.readyState) {
                if (200 != i.status) {
                  d();
                  var r = new Error("invalid response - " + i.status);
                  return r.statusCode = i.status, i.responseText && (r.responseText = i.responseText), void s(r);
                }

                var n = null;

                try {
                  n = JSON.parse(i.responseText);
                } catch (r) {
                  d();
                  var c = new Error("invalid json response");
                  return c.orginialError = r, c.responseText = i.responseText, null != t && (c.requestBody = t), c.url = o, void s(c);
                }

                if (a) try {
                  n = a(n);
                } catch (r) {
                  return d(), r.url = o, r.body = t, r.responseText = i.responseText, void s(r);
                }
                d(), e(n);
              }
            }, i.onerror = function (e) {
              d(), s(e);
            };

            try {
              null != t ? i.send(t) : i.send();
            } catch (c) {
              d();
              var f = new Error("connection error");
              f.error = c, s(f);
            }
          });
        }, a.poll = function (e, t) {
          return t = t || {}, null == (t = o.shallowCopy(t)).floor && (t.floor = 0), null == t.ceiling && (t.ceiling = 1e4), null == t.interval && (t.interval = 250), new Promise(function (a, r) {
            var n = null,
                s = !1,
                o = function o() {
              return !s && (s = !0, n && clearTimeout(n), !0);
            };

            t.timeout && (n = setTimeout(function () {
              o() && r(new Error("timeout"));
            }, t.timeout));
            var i = t.fastRetry || null,
                c = 0;
            !function n() {
              return e().then(function (e) {
                if (void 0 !== e) o() && a(e);else if (t.onceBlock) t.onceBlock.once("block", n);else if (!s) {
                  c++;
                  var r = t.interval * parseInt(String(Math.random() * Math.pow(2, c)));
                  r < t.floor && (r = t.floor), r > t.ceiling && (r = t.ceiling), i && (c--, r = i, i = null), setTimeout(n, r);
                }
                return null;
              }, function (e) {
                o() && r(e);
              });
            }();
          });
        };
      }, {
        "../errors": 5,
        "./base64": 60,
        "./properties": 73,
        "./utf8": 84,
        xmlhttprequest: 48
      }],
      86: [function (e, a, r) {
        (function (t) {
          "use strict";

          Object.defineProperty(r, "__esModule", {
            value: !0
          });
          var a = e("../utils/hash"),
              n = e("../utils/properties");

          r.check = function (e) {
            for (var t = [], r = 0; r < 2048; r++) {
              var n = e.getWord(r);
              if (r !== e.getWordIndex(n)) return "0x";
              t.push(n);
            }

            return a.id(t.join("\n") + "\n");
          };

          var s = (o.prototype.split = function (e) {
            return e.toLowerCase().split(/ +/g);
          }, o.prototype.join = function (e) {
            return e.join(" ");
          }, o);

          function o(e) {
            n.defineReadOnly(this, "locale", e);
          }

          r.Wordlist = s, r.register = function (e, t) {
            t = t || e.locale;
          };
        }).call(this, void 0 !== t ? t : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
      }, {
        "../utils/hash": 64,
        "../utils/properties": 73
      }],
      87: [function (e, t, a) {
        "use strict";

        var r,
            n = this && this.__extends || (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var a in t) {
            t.hasOwnProperty(a) && (e[a] = t[a]);
          }
        }, function (e, t) {
          function a() {
            this.constructor = e;
          }

          r(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
        }),
            s = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var a in e) {
            Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
          }
          return t.default = e, t;
        };

        Object.defineProperty(a, "__esModule", {
          value: !0
        });

        var o,
            i = e("./utils/bytes"),
            c = e("./utils/hash"),
            u = e("./utils/hdnode"),
            d = e("./utils/json-wallet"),
            f = e("./utils/keccak256"),
            l = e("./utils/properties"),
            h = e("./utils/random-bytes"),
            p = s(e("./utils/secret-storage")),
            b = e("./utils/signing-key"),
            m = e("./utils/transaction"),
            y = e("./abstract-signer"),
            v = e("./providers/abstract-provider"),
            _ = s(e("./errors")),
            g = (n(A, o = y.Signer), Object.defineProperty(A.prototype, "address", {
          get: function get() {
            return this.signingKey.address;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(A.prototype, "mnemonic", {
          get: function get() {
            return this.signingKey.mnemonic;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(A.prototype, "path", {
          get: function get() {
            return this.signingKey.path;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(A.prototype, "privateKey", {
          get: function get() {
            return this.signingKey.privateKey;
          },
          enumerable: !0,
          configurable: !0
        }), A.prototype.connect = function (e) {
          return v.Provider.isProvider(e) || _.throwError("invalid provider", _.INVALID_ARGUMENT, {
            argument: "provider",
            value: e
          }), new A(this.signingKey, e);
        }, A.prototype.getAddress = function () {
          return Promise.resolve(this.address);
        }, A.prototype.sign = function (e) {
          var t = this;
          return l.resolveProperties(e).then(function (e) {
            var a = m.serialize(e),
                r = t.signingKey.signDigest(f.keccak256(a));
            return m.serialize(e, r);
          });
        }, A.prototype.signMessage = function (e) {
          return Promise.resolve(i.joinSignature(this.signingKey.signDigest(c.hashMessage(e))));
        }, A.prototype.getBalance = function (e) {
          if (!this.provider) throw new Error("missing provider");
          return this.provider.getBalance(this.address, e);
        }, A.prototype.getTransactionCount = function (e) {
          if (!this.provider) throw new Error("missing provider");
          return this.provider.getTransactionCount(this.address, e);
        }, A.prototype.sendTransaction = function (e) {
          var t = this;
          if (!this.provider) throw new Error("missing provider");
          return null == e.nonce && ((e = l.shallowCopy(e)).nonce = this.getTransactionCount("pending")), m.populateTransaction(e, this.provider, this.address).then(function (e) {
            return t.sign(e).then(function (e) {
              return t.provider.sendTransaction(e);
            });
          });
        }, A.prototype.encrypt = function (e, t, a) {
          if ("function" != typeof t || a || (a = t, t = {}), a && "function" != typeof a) throw new Error("invalid callback");
          return t = t || {}, this.mnemonic && ((t = l.shallowCopy(t)).mnemonic = this.mnemonic, t.path = this.path), p.encrypt(this.privateKey, e, t, a);
        }, A.createRandom = function (e) {
          var t = h.randomBytes(16);
          (e = e || {}).extraEntropy && (t = i.arrayify(f.keccak256(i.concat([t, e.extraEntropy])).substring(0, 34)));
          var a = u.entropyToMnemonic(t, e.locale);
          return A.fromMnemonic(a, e.path, e.locale);
        }, A.fromEncryptedJson = function (e, t, a) {
          if (d.isCrowdsaleWallet(e)) try {
            a && a(0);
            var r = p.decryptCrowdsale(e, t);
            return a && a(1), Promise.resolve(new A(r));
          } catch (e) {
            return Promise.reject(e);
          } else if (d.isSecretStorageWallet(e)) return p.decrypt(e, t, a).then(function (e) {
            return new A(e);
          });
          return Promise.reject("invalid wallet JSON");
        }, A.fromMnemonic = function (e, t, a) {
          return t = t || u.defaultPath, new A(u.fromMnemonic(e, a).derivePath(t));
        }, A);

        function A(e, t) {
          var a = o.call(this) || this;
          return _.checkNew(a, A), b.SigningKey.isSigningKey(e) ? l.defineReadOnly(a, "signingKey", e) : l.defineReadOnly(a, "signingKey", new b.SigningKey(e)), l.defineReadOnly(a, "provider", t), a;
        }

        a.Wallet = g;
      }, {
        "./abstract-signer": 2,
        "./errors": 5,
        "./providers/abstract-provider": 49,
        "./utils/bytes": 63,
        "./utils/hash": 64,
        "./utils/hdnode": 65,
        "./utils/json-wallet": 69,
        "./utils/keccak256": 70,
        "./utils/properties": 73,
        "./utils/random-bytes": 74,
        "./utils/secret-storage": 77,
        "./utils/signing-key": 80,
        "./utils/transaction": 82
      }],
      88: [function (e, t, a) {
        "use strict";

        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var r = e("../wordlists/lang-en").langEn;
        a.en = r;
      }, {
        "../wordlists/lang-en": 89
      }],
      89: [function (e, t, a) {
        "use strict";

        var r,
            n = this && this.__extends || (r = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var a in t) {
            t.hasOwnProperty(a) && (e[a] = t[a]);
          }
        }, function (e, t) {
          function a() {
            this.constructor = e;
          }

          r(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
        });
        Object.defineProperty(a, "__esModule", {
          value: !0
        });
        var s,
            o = e("../utils/wordlist"),
            i = "AbandonAbilityAbleAboutAboveAbsentAbsorbAbstractAbsurdAbuseAccessAccidentAccountAccuseAchieveAcidAcousticAcquireAcrossActActionActorActressActualAdaptAddAddictAddressAdjustAdmitAdultAdvanceAdviceAerobicAffairAffordAfraidAgainAgeAgentAgreeAheadAimAirAirportAisleAlarmAlbumAlcoholAlertAlienAllAlleyAllowAlmostAloneAlphaAlreadyAlsoAlterAlwaysAmateurAmazingAmongAmountAmusedAnalystAnchorAncientAngerAngleAngryAnimalAnkleAnnounceAnnualAnotherAnswerAntennaAntiqueAnxietyAnyApartApologyAppearAppleApproveAprilArchArcticAreaArenaArgueArmArmedArmorArmyAroundArrangeArrestArriveArrowArtArtefactArtistArtworkAskAspectAssaultAssetAssistAssumeAsthmaAthleteAtomAttackAttendAttitudeAttractAuctionAuditAugustAuntAuthorAutoAutumnAverageAvocadoAvoidAwakeAwareAwayAwesomeAwfulAwkwardAxisBabyBachelorBaconBadgeBagBalanceBalconyBallBambooBananaBannerBarBarelyBargainBarrelBaseBasicBasketBattleBeachBeanBeautyBecauseBecomeBeefBeforeBeginBehaveBehindBelieveBelowBeltBenchBenefitBestBetrayBetterBetweenBeyondBicycleBidBikeBindBiologyBirdBirthBitterBlackBladeBlameBlanketBlastBleakBlessBlindBloodBlossomBlouseBlueBlurBlushBoardBoatBodyBoilBombBoneBonusBookBoostBorderBoringBorrowBossBottomBounceBoxBoyBracketBrainBrandBrassBraveBreadBreezeBrickBridgeBriefBrightBringBriskBroccoliBrokenBronzeBroomBrotherBrownBrushBubbleBuddyBudgetBuffaloBuildBulbBulkBulletBundleBunkerBurdenBurgerBurstBusBusinessBusyButterBuyerBuzzCabbageCabinCableCactusCageCakeCallCalmCameraCampCanCanalCancelCandyCannonCanoeCanvasCanyonCapableCapitalCaptainCarCarbonCardCargoCarpetCarryCartCaseCashCasinoCastleCasualCatCatalogCatchCategoryCattleCaughtCauseCautionCaveCeilingCeleryCementCensusCenturyCerealCertainChairChalkChampionChangeChaosChapterChargeChaseChatCheapCheckCheeseChefCherryChestChickenChiefChildChimneyChoiceChooseChronicChuckleChunkChurnCigarCinnamonCircleCitizenCityCivilClaimClapClarifyClawClayCleanClerkCleverClickClientCliffClimbClinicClipClockClogCloseClothCloudClownClubClumpClusterClutchCoachCoastCoconutCodeCoffeeCoilCoinCollectColorColumnCombineComeComfortComicCommonCompanyConcertConductConfirmCongressConnectConsiderControlConvinceCookCoolCopperCopyCoralCoreCornCorrectCostCottonCouchCountryCoupleCourseCousinCoverCoyoteCrackCradleCraftCramCraneCrashCraterCrawlCrazyCreamCreditCreekCrewCricketCrimeCrispCriticCropCrossCrouchCrowdCrucialCruelCruiseCrumbleCrunchCrushCryCrystalCubeCultureCupCupboardCuriousCurrentCurtainCurveCushionCustomCuteCycleDadDamageDampDanceDangerDaringDashDaughterDawnDayDealDebateDebrisDecadeDecemberDecideDeclineDecorateDecreaseDeerDefenseDefineDefyDegreeDelayDeliverDemandDemiseDenialDentistDenyDepartDependDepositDepthDeputyDeriveDescribeDesertDesignDeskDespairDestroyDetailDetectDevelopDeviceDevoteDiagramDialDiamondDiaryDiceDieselDietDifferDigitalDignityDilemmaDinnerDinosaurDirectDirtDisagreeDiscoverDiseaseDishDismissDisorderDisplayDistanceDivertDivideDivorceDizzyDoctorDocumentDogDollDolphinDomainDonateDonkeyDonorDoorDoseDoubleDoveDraftDragonDramaDrasticDrawDreamDressDriftDrillDrinkDripDriveDropDrumDryDuckDumbDuneDuringDustDutchDutyDwarfDynamicEagerEagleEarlyEarnEarthEasilyEastEasyEchoEcologyEconomyEdgeEditEducateEffortEggEightEitherElbowElderElectricElegantElementElephantElevatorEliteElseEmbarkEmbodyEmbraceEmergeEmotionEmployEmpowerEmptyEnableEnactEndEndlessEndorseEnemyEnergyEnforceEngageEngineEnhanceEnjoyEnlistEnoughEnrichEnrollEnsureEnterEntireEntryEnvelopeEpisodeEqualEquipEraEraseErodeErosionErrorEruptEscapeEssayEssenceEstateEternalEthicsEvidenceEvilEvokeEvolveExactExampleExcessExchangeExciteExcludeExcuseExecuteExerciseExhaustExhibitExileExistExitExoticExpandExpectExpireExplainExposeExpressExtendExtraEyeEyebrowFabricFaceFacultyFadeFaintFaithFallFalseFameFamilyFamousFanFancyFantasyFarmFashionFatFatalFatherFatigueFaultFavoriteFeatureFebruaryFederalFeeFeedFeelFemaleFenceFestivalFetchFeverFewFiberFictionFieldFigureFileFilmFilterFinalFindFineFingerFinishFireFirmFirstFiscalFishFitFitnessFixFlagFlameFlashFlatFlavorFleeFlightFlipFloatFlockFloorFlowerFluidFlushFlyFoamFocusFogFoilFoldFollowFoodFootForceForestForgetForkFortuneForumForwardFossilFosterFoundFoxFragileFrameFrequentFreshFriendFringeFrogFrontFrostFrownFrozenFruitFuelFunFunnyFurnaceFuryFutureGadgetGainGalaxyGalleryGameGapGarageGarbageGardenGarlicGarmentGasGaspGateGatherGaugeGazeGeneralGeniusGenreGentleGenuineGestureGhostGiantGiftGiggleGingerGiraffeGirlGiveGladGlanceGlareGlassGlideGlimpseGlobeGloomGloryGloveGlowGlueGoatGoddessGoldGoodGooseGorillaGospelGossipGovernGownGrabGraceGrainGrantGrapeGrassGravityGreatGreenGridGriefGritGroceryGroupGrowGruntGuardGuessGuideGuiltGuitarGunGymHabitHairHalfHammerHamsterHandHappyHarborHardHarshHarvestHatHaveHawkHazardHeadHealthHeartHeavyHedgehogHeightHelloHelmetHelpHenHeroHiddenHighHillHintHipHireHistoryHobbyHockeyHoldHoleHolidayHollowHomeHoneyHoodHopeHornHorrorHorseHospitalHostHotelHourHoverHubHugeHumanHumbleHumorHundredHungryHuntHurdleHurryHurtHusbandHybridIceIconIdeaIdentifyIdleIgnoreIllIllegalIllnessImageImitateImmenseImmuneImpactImposeImproveImpulseInchIncludeIncomeIncreaseIndexIndicateIndoorIndustryInfantInflictInformInhaleInheritInitialInjectInjuryInmateInnerInnocentInputInquiryInsaneInsectInsideInspireInstallIntactInterestIntoInvestInviteInvolveIronIslandIsolateIssueItemIvoryJacketJaguarJarJazzJealousJeansJellyJewelJobJoinJokeJourneyJoyJudgeJuiceJumpJungleJuniorJunkJustKangarooKeenKeepKetchupKeyKickKidKidneyKindKingdomKissKitKitchenKiteKittenKiwiKneeKnifeKnockKnowLabLabelLaborLadderLadyLakeLampLanguageLaptopLargeLaterLatinLaughLaundryLavaLawLawnLawsuitLayerLazyLeaderLeafLearnLeaveLectureLeftLegLegalLegendLeisureLemonLendLengthLensLeopardLessonLetterLevelLiarLibertyLibraryLicenseLifeLiftLightLikeLimbLimitLinkLionLiquidListLittleLiveLizardLoadLoanLobsterLocalLockLogicLonelyLongLoopLotteryLoudLoungeLoveLoyalLuckyLuggageLumberLunarLunchLuxuryLyricsMachineMadMagicMagnetMaidMailMainMajorMakeMammalManManageMandateMangoMansionManualMapleMarbleMarchMarginMarineMarketMarriageMaskMassMasterMatchMaterialMathMatrixMatterMaximumMazeMeadowMeanMeasureMeatMechanicMedalMediaMelodyMeltMemberMemoryMentionMenuMercyMergeMeritMerryMeshMessageMetalMethodMiddleMidnightMilkMillionMimicMindMinimumMinorMinuteMiracleMirrorMiseryMissMistakeMixMixedMixtureMobileModelModifyMomMomentMonitorMonkeyMonsterMonthMoonMoralMoreMorningMosquitoMotherMotionMotorMountainMouseMoveMovieMuchMuffinMuleMultiplyMuscleMuseumMushroomMusicMustMutualMyselfMysteryMythNaiveNameNapkinNarrowNastyNationNatureNearNeckNeedNegativeNeglectNeitherNephewNerveNestNetNetworkNeutralNeverNewsNextNiceNightNobleNoiseNomineeNoodleNormalNorthNoseNotableNoteNothingNoticeNovelNowNuclearNumberNurseNutOakObeyObjectObligeObscureObserveObtainObviousOccurOceanOctoberOdorOffOfferOfficeOftenOilOkayOldOliveOlympicOmitOnceOneOnionOnlineOnlyOpenOperaOpinionOpposeOptionOrangeOrbitOrchardOrderOrdinaryOrganOrientOriginalOrphanOstrichOtherOutdoorOuterOutputOutsideOvalOvenOverOwnOwnerOxygenOysterOzonePactPaddlePagePairPalacePalmPandaPanelPanicPantherPaperParadeParentParkParrotPartyPassPatchPathPatientPatrolPatternPausePavePaymentPeacePeanutPearPeasantPelicanPenPenaltyPencilPeoplePepperPerfectPermitPersonPetPhonePhotoPhrasePhysicalPianoPicnicPicturePiecePigPigeonPillPilotPinkPioneerPipePistolPitchPizzaPlacePlanetPlasticPlatePlayPleasePledgePluckPlugPlungePoemPoetPointPolarPolePolicePondPonyPoolPopularPortionPositionPossiblePostPotatoPotteryPovertyPowderPowerPracticePraisePredictPreferPreparePresentPrettyPreventPricePridePrimaryPrintPriorityPrisonPrivatePrizeProblemProcessProduceProfitProgramProjectPromoteProofPropertyProsperProtectProudProvidePublicPuddingPullPulpPulsePumpkinPunchPupilPuppyPurchasePurityPurposePursePushPutPuzzlePyramidQualityQuantumQuarterQuestionQuickQuitQuizQuoteRabbitRaccoonRaceRackRadarRadioRailRainRaiseRallyRampRanchRandomRangeRapidRareRateRatherRavenRawRazorReadyRealReasonRebelRebuildRecallReceiveRecipeRecordRecycleReduceReflectReformRefuseRegionRegretRegularRejectRelaxReleaseReliefRelyRemainRememberRemindRemoveRenderRenewRentReopenRepairRepeatReplaceReportRequireRescueResembleResistResourceResponseResultRetireRetreatReturnReunionRevealReviewRewardRhythmRibRibbonRiceRichRideRidgeRifleRightRigidRingRiotRippleRiskRitualRivalRiverRoadRoastRobotRobustRocketRomanceRoofRookieRoomRoseRotateRoughRoundRouteRoyalRubberRudeRugRuleRunRunwayRuralSadSaddleSadnessSafeSailSaladSalmonSalonSaltSaluteSameSampleSandSatisfySatoshiSauceSausageSaveSayScaleScanScareScatterSceneSchemeSchoolScienceScissorsScorpionScoutScrapScreenScriptScrubSeaSearchSeasonSeatSecondSecretSectionSecuritySeedSeekSegmentSelectSellSeminarSeniorSenseSentenceSeriesServiceSessionSettleSetupSevenShadowShaftShallowShareShedShellSheriffShieldShiftShineShipShiverShockShoeShootShopShortShoulderShoveShrimpShrugShuffleShySiblingSickSideSiegeSightSignSilentSilkSillySilverSimilarSimpleSinceSingSirenSisterSituateSixSizeSkateSketchSkiSkillSkinSkirtSkullSlabSlamSleepSlenderSliceSlideSlightSlimSloganSlotSlowSlushSmallSmartSmileSmokeSmoothSnackSnakeSnapSniffSnowSoapSoccerSocialSockSodaSoftSolarSoldierSolidSolutionSolveSomeoneSongSoonSorrySortSoulSoundSoupSourceSouthSpaceSpareSpatialSpawnSpeakSpecialSpeedSpellSpendSphereSpiceSpiderSpikeSpinSpiritSplitSpoilSponsorSpoonSportSpotSpraySpreadSpringSpySquareSqueezeSquirrelStableStadiumStaffStageStairsStampStandStartStateStaySteakSteelStemStepStereoStickStillStingStockStomachStoneStoolStoryStoveStrategyStreetStrikeStrongStruggleStudentStuffStumbleStyleSubjectSubmitSubwaySuccessSuchSuddenSufferSugarSuggestSuitSummerSunSunnySunsetSuperSupplySupremeSureSurfaceSurgeSurpriseSurroundSurveySuspectSustainSwallowSwampSwapSwarmSwearSweetSwiftSwimSwingSwitchSwordSymbolSymptomSyrupSystemTableTackleTagTailTalentTalkTankTapeTargetTaskTasteTattooTaxiTeachTeamTellTenTenantTennisTentTermTestTextThankThatThemeThenTheoryThereTheyThingThisThoughtThreeThriveThrowThumbThunderTicketTideTigerTiltTimberTimeTinyTipTiredTissueTitleToastTobaccoTodayToddlerToeTogetherToiletTokenTomatoTomorrowToneTongueTonightToolToothTopTopicToppleTorchTornadoTortoiseTossTotalTouristTowardTowerTownToyTrackTradeTrafficTragicTrainTransferTrapTrashTravelTrayTreatTreeTrendTrialTribeTrickTriggerTrimTripTrophyTroubleTruckTrueTrulyTrumpetTrustTruthTryTubeTuitionTumbleTunaTunnelTurkeyTurnTurtleTwelveTwentyTwiceTwinTwistTwoTypeTypicalUglyUmbrellaUnableUnawareUncleUncoverUnderUndoUnfairUnfoldUnhappyUniformUniqueUnitUniverseUnknownUnlockUntilUnusualUnveilUpdateUpgradeUpholdUponUpperUpsetUrbanUrgeUsageUseUsedUsefulUselessUsualUtilityVacantVacuumVagueValidValleyValveVanVanishVaporVariousVastVaultVehicleVelvetVendorVentureVenueVerbVerifyVersionVeryVesselVeteranViableVibrantViciousVictoryVideoViewVillageVintageViolinVirtualVirusVisaVisitVisualVitalVividVocalVoiceVoidVolcanoVolumeVoteVoyageWageWagonWaitWalkWallWalnutWantWarfareWarmWarriorWashWaspWasteWaterWaveWayWealthWeaponWearWeaselWeatherWebWeddingWeekendWeirdWelcomeWestWetWhaleWhatWheatWheelWhenWhereWhipWhisperWideWidthWifeWildWillWinWindowWineWingWinkWinnerWinterWireWisdomWiseWishWitnessWolfWomanWonderWoodWoolWordWorkWorldWorryWorthWrapWreckWrestleWristWriteWrongYardYearYellowYouYoungYouthZebraZeroZoneZoo",
            c = null;

        function u(e) {
          if (null == c && (c = i.replace(/([A-Z])/g, " $1").toLowerCase().substring(1).split(" "), "0x3c8acc1e7b08d8e76f9fda015ef48dc8c710a73cb7e0f77b2c18a9b5a7adde60" !== o.check(e))) throw c = null, new Error("BIP39 Wordlist for en (English) FAILED");
        }

        function d() {
          return s.call(this, "en") || this;
        }

        var f = new (n(d, s = o.Wordlist), d.prototype.getWord = function (e) {
          return u(this), c[e];
        }, d.prototype.getWordIndex = function (e) {
          return u(this), c.indexOf(e);
        }, d)();
        a.langEn = f, o.register(f);
      }, {
        "../utils/wordlist": 86
      }]
    }, {}, [7])(7);
  }).call(this, a(
  /*! ./../../webpack/buildin/global.js */
  18));
},
/*!*******************************************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/abi_encoder/calldata/calldata_block.js ***!
  \*******************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var r = a(
  /*! ethereumjs-util */
  24),
      n = function () {
    function e(e, t, a, r, n) {
      this._name = e, this._signature = t, this._parentName = a, this._offsetInBytes = 0, this._headerSizeInBytes = r, this._bodySizeInBytes = n;
    }

    return e.prototype._setHeaderSize = function (e) {
      this._headerSizeInBytes = e;
    }, e.prototype._setBodySize = function (e) {
      this._bodySizeInBytes = e;
    }, e.prototype._setName = function (e) {
      this._name = e;
    }, e.prototype.getName = function () {
      return this._name;
    }, e.prototype.getParentName = function () {
      return this._parentName;
    }, e.prototype.getSignature = function () {
      return this._signature;
    }, e.prototype.getHeaderSizeInBytes = function () {
      return this._headerSizeInBytes;
    }, e.prototype.getBodySizeInBytes = function () {
      return this._bodySizeInBytes;
    }, e.prototype.getSizeInBytes = function () {
      return this.getHeaderSizeInBytes() + this.getBodySizeInBytes();
    }, e.prototype.getOffsetInBytes = function () {
      return this._offsetInBytes;
    }, e.prototype.setOffset = function (e) {
      this._offsetInBytes = e;
    }, e.prototype.computeHash = function () {
      var e = this.getRawData();
      return r.sha3(e);
    }, e;
  }();

  t.CalldataBlock = n;
},
/*!*******************************************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/abi_encoder/calldata/blocks/pointer.js ***!
  \*******************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    var _r4,
        n = this && this.__extends || (_r4 = function r(e, t) {
      return (_r4 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var a in t) {
          t.hasOwnProperty(a) && (e[a] = t[a]);
        }
      })(e, t);
    }, function (e, t) {
      function a() {
        this.constructor = e;
      }

      _r4(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = a(
    /*! ethereumjs-util */
    24),
        o = a(
    /*! ../../utils/constants */
    26),
        i = function (t) {
      function a(e, r, n, s, o) {
        var i = this,
            c = a._EMPTY_HEADER_SIZE,
            u = a._DEPENDENT_PAYLOAD_SIZE_IN_BYTES;
        return (i = t.call(this, e, r, n, c, u) || this)._parent = o, i._dependency = s, i._aliasFor = void 0, i;
      }

      return n(a, t), a.prototype.toBuffer = function () {
        var e = "0x" + ((void 0 !== this._aliasFor ? this._aliasFor.getOffsetInBytes() : this._dependency.getOffsetInBytes()) - (this._parent.getOffsetInBytes() + this._parent.getHeaderSizeInBytes())).toString(o.constants.HEX_BASE),
            t = s.toBuffer(e);

        return s.setLengthLeft(t, o.constants.EVM_WORD_WIDTH_IN_BYTES);
      }, a.prototype.getDependency = function () {
        return this._dependency;
      }, a.prototype.setAlias = function (e) {
        this._aliasFor = e, this._setName(this.getName() + " (alias for " + e.getName() + ")");
      }, a.prototype.getAlias = function () {
        return this._aliasFor;
      }, a.prototype.getRawData = function () {
        var t = this._dependency.getRawData(),
            r = [];

        return r.push(a.RAW_DATA_START), r.push(t), r.push(a.RAW_DATA_END), e.concat(r);
      }, a.RAW_DATA_START = new e("<"), a.RAW_DATA_END = new e(">"), a._DEPENDENT_PAYLOAD_SIZE_IN_BYTES = 32, a._EMPTY_HEADER_SIZE = 0, a;
    }(a(
    /*! ../calldata_block */
    105).CalldataBlock);

    t.PointerCalldataBlock = i;
  }).call(this, a(
  /*! ./../../../../../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!***************************************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/abi_encoder/calldata/blocks/set.js ***!
  \***************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    var _r5,
        n = this && this.__extends || (_r5 = function r(e, t) {
      return (_r5 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var a in t) {
          t.hasOwnProperty(a) && (e[a] = t[a]);
        }
      })(e, t);
    }, function (e, t) {
      function a() {
        this.constructor = e;
      }

      _r5(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = a(
    /*! lodash */
    0),
        o = function (t) {
      function a(e, a, r) {
        var n = t.call(this, e, a, r, 0, 0) || this;
        return n._members = [], n._header = void 0, n;
      }

      return n(a, t), a.prototype.getRawData = function () {
        var t = [];
        return void 0 !== this._header && t.push(this._header), s.each(this._members, function (e) {
          var a = e.getRawData();
          t.push(a);
        }), e.concat(t);
      }, a.prototype.setMembers = function (e) {
        this._members = e;
      }, a.prototype.setHeader = function (e) {
        this._setHeaderSize(e.byteLength), this._header = e;
      }, a.prototype.toBuffer = function () {
        return void 0 !== this._header ? this._header : new e("");
      }, a.prototype.getMembers = function () {
        return this._members;
      }, a;
    }(a(
    /*! ../calldata_block */
    105).CalldataBlock);

    t.SetCalldataBlock = o;
  }).call(this, a(
  /*! ./../../../../../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!*************************************************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/abi_encoder/abstract_data_types/types/set.js ***!
  \*************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r6,
      n = this && this.__extends || (_r6 = function r(e, t) {
    return (_r6 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r6(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || t-- > 0) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o = a(
  /*! ethereumjs-util */
  24),
      i = a(
  /*! lodash */
  0),
      c = a(
  /*! ../../../configured_bignumber */
  37),
      u = a(
  /*! ../../calldata/blocks/set */
  107),
      d = a(
  /*! ../../utils/constants */
  26),
      f = a(
  /*! ../data_type */
  80),
      l = a(
  /*! ./pointer */
  176),
      h = function (e) {
    function t(t, a, r, n, o) {
      var i, c;
      void 0 === r && (r = !1);
      var u = e.call(this, t, a) || this;
      return u._memberIndexByName = {}, u._members = [], u._isArray = r, u._arrayLength = n, u._arrayElementType = o, r && void 0 !== n ? (i = s(u._createMembersWithLength(t, n), 2), u._members = i[0], u._memberIndexByName = i[1]) : r || (c = s(u._createMembersWithKeys(t), 2), u._members = c[0], u._memberIndexByName = c[1]), u;
    }

    return n(t, e), t.prototype.generateCalldataBlock = function (e, t) {
      return e instanceof Array ? this._generateCalldataBlockFromArray(e, t) : this._generateCalldataBlockFromObject(e, t);
    }, t.prototype.generateValue = function (e, t) {
      var a,
          r = this,
          n = this._members;

      if (this._isArray && void 0 === this._arrayLength) {
        var u = e.popWord(),
            f = o.bufferToHex(u),
            l = new c.BigNumber(f, d.constants.HEX_BASE);
        n = s(this._createMembersWithLength(this.getDataItem(), l.toNumber()), 1)[0];
      }

      return e.startScope(), t.shouldConvertStructsToObjects && !this._isArray ? (a = {}, i.each(this._memberIndexByName, function (n, s) {
        var o = r._members[n].generateValue(e, t);

        a[s] = o;
      })) : (a = [], i.each(n, function (r, n) {
        var s = r.generateValue(e, t);
        a.push(s);
      })), e.endScope(), a;
    }, t.prototype.isStatic = function () {
      return (!this._isArray || void 0 !== this._arrayLength) && void 0 === i.find(this._members, function (e) {
        return e instanceof l.AbstractPointerDataType;
      });
    }, t.prototype.getDefaultValue = function (e) {
      var t,
          a = this;
      return this._isArray && void 0 === this._arrayLength ? t = [] : void 0 !== e && e.shouldConvertStructsToObjects && !this._isArray ? (t = {}, i.each(this._memberIndexByName, function (e, r) {
        var n = a._members[e].getDefaultValue();

        t[r] = n;
      })) : (t = [], i.each(this._members, function (e, a) {
        var r = e.getDefaultValue();
        t.push(r);
      })), t;
    }, t.prototype._generateCalldataBlockFromArray = function (e, t) {
      if (void 0 !== this._arrayLength && e.length !== this._arrayLength) throw new Error("Expected array of " + JSON.stringify(this._arrayLength) + " elements, but got array of length " + JSON.stringify(e.length));
      var a = void 0 === t ? "" : t.getName(),
          r = new u.SetCalldataBlock(this.getDataItem().name, this.getSignature(), a),
          n = this._members;

      if (this._isArray && void 0 === this._arrayLength) {
        n = s(this._createMembersWithLength(this.getDataItem(), e.length), 1)[0];
        var c = o.setLengthLeft(o.toBuffer("0x" + e.length.toString(d.constants.HEX_BASE)), d.constants.EVM_WORD_WIDTH_IN_BYTES);
        r.setHeader(c);
      }

      var f = [];
      return i.each(n, function (t, a) {
        var n = t.generateCalldataBlock(e[a], r);
        f.push(n);
      }), r.setMembers(f), r;
    }, t.prototype._generateCalldataBlockFromObject = function (e, t) {
      var a = this,
          r = void 0 === t ? "" : t.getName(),
          n = new u.SetCalldataBlock(this.getDataItem().name, this.getSignature(), r),
          s = [];
      return i.forEach(this._memberIndexByName, function (t, r) {
        if (!(r in e)) throw new Error("Could not assign tuple to object: missing key '" + r + "' in object " + JSON.stringify(e));

        var o = e[r],
            i = a._members[t].generateCalldataBlock(o, n);

        s.push(i);
      }), n.setMembers(s), n;
    }, t.prototype._computeSignatureOfMembers = function (e) {
      var t = this,
          a = "(";
      return i.each(this._members, function (r, n) {
        a += r.getSignature(e), n < t._members.length - 1 && (a += ",");
      }), a += ")";
    }, t.prototype._createMembersWithKeys = function (e) {
      var t = this;
      if (void 0 === e.components) throw new Error("Tried to create a set using key/value pairs, but no components were defined by the input DataItem '" + e.name + "'.");
      var a = [],
          r = {},
          n = [];
      return i.each(e.components, function (s) {
        for (var o = s.name, c = 0; i.includes(n, o) || i.isEmpty(o);) {
          c++, o = s.name + "_" + c;
        }

        n.push(o);
        var u = {
          type: s.type,
          name: e.name + "." + o
        },
            d = s.components;
        void 0 !== d && (u.components = d);
        var f = t.getFactory().create(u, t);
        r[o] = a.length, a.push(f);
      }), [a, r];
    }, t.prototype._createMembersWithLength = function (e, t) {
      var a = this,
          r = [],
          n = {},
          s = i.range(t);
      return i.each(s, function (t) {
        var s = {
          type: void 0 === a._arrayElementType ? "" : a._arrayElementType,
          name: e.name + "[" + t.toString(d.constants.DEC_BASE) + "]"
        },
            o = e.components;
        void 0 !== o && (s.components = o);
        var i = a.getFactory().create(s, a);
        n[t.toString(d.constants.DEC_BASE)] = r.length, r.push(i);
      }), [r, n];
    }, t;
  }(f.DataType);

  t.AbstractSetDataType = h;
},
/*!*********************************************!*\
  !*** ./node_modules/level-errors/errors.js ***!
  \*********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! errno */
  110).create,
      n = r("LevelUPError"),
      s = r("NotFoundError", n);
  s.prototype.notFound = !0, s.prototype.status = 404, e.exports = {
    LevelUPError: n,
    InitializationError: r("InitializationError", n),
    OpenError: r("OpenError", n),
    ReadError: r("ReadError", n),
    WriteError: r("WriteError", n),
    NotFoundError: s,
    EncodingError: r("EncodingError", n)
  };
},
/*!*************************************!*\
  !*** ./node_modules/errno/errno.js ***!
  \*************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = e.exports.all = [{
    errno: -2,
    code: "ENOENT",
    description: "no such file or directory"
  }, {
    errno: -1,
    code: "UNKNOWN",
    description: "unknown error"
  }, {
    errno: 0,
    code: "OK",
    description: "success"
  }, {
    errno: 1,
    code: "EOF",
    description: "end of file"
  }, {
    errno: 2,
    code: "EADDRINFO",
    description: "getaddrinfo error"
  }, {
    errno: 3,
    code: "EACCES",
    description: "permission denied"
  }, {
    errno: 4,
    code: "EAGAIN",
    description: "resource temporarily unavailable"
  }, {
    errno: 5,
    code: "EADDRINUSE",
    description: "address already in use"
  }, {
    errno: 6,
    code: "EADDRNOTAVAIL",
    description: "address not available"
  }, {
    errno: 7,
    code: "EAFNOSUPPORT",
    description: "address family not supported"
  }, {
    errno: 8,
    code: "EALREADY",
    description: "connection already in progress"
  }, {
    errno: 9,
    code: "EBADF",
    description: "bad file descriptor"
  }, {
    errno: 10,
    code: "EBUSY",
    description: "resource busy or locked"
  }, {
    errno: 11,
    code: "ECONNABORTED",
    description: "software caused connection abort"
  }, {
    errno: 12,
    code: "ECONNREFUSED",
    description: "connection refused"
  }, {
    errno: 13,
    code: "ECONNRESET",
    description: "connection reset by peer"
  }, {
    errno: 14,
    code: "EDESTADDRREQ",
    description: "destination address required"
  }, {
    errno: 15,
    code: "EFAULT",
    description: "bad address in system call argument"
  }, {
    errno: 16,
    code: "EHOSTUNREACH",
    description: "host is unreachable"
  }, {
    errno: 17,
    code: "EINTR",
    description: "interrupted system call"
  }, {
    errno: 18,
    code: "EINVAL",
    description: "invalid argument"
  }, {
    errno: 19,
    code: "EISCONN",
    description: "socket is already connected"
  }, {
    errno: 20,
    code: "EMFILE",
    description: "too many open files"
  }, {
    errno: 21,
    code: "EMSGSIZE",
    description: "message too long"
  }, {
    errno: 22,
    code: "ENETDOWN",
    description: "network is down"
  }, {
    errno: 23,
    code: "ENETUNREACH",
    description: "network is unreachable"
  }, {
    errno: 24,
    code: "ENFILE",
    description: "file table overflow"
  }, {
    errno: 25,
    code: "ENOBUFS",
    description: "no buffer space available"
  }, {
    errno: 26,
    code: "ENOMEM",
    description: "not enough memory"
  }, {
    errno: 27,
    code: "ENOTDIR",
    description: "not a directory"
  }, {
    errno: 28,
    code: "EISDIR",
    description: "illegal operation on a directory"
  }, {
    errno: 29,
    code: "ENONET",
    description: "machine is not on the network"
  }, {
    errno: 31,
    code: "ENOTCONN",
    description: "socket is not connected"
  }, {
    errno: 32,
    code: "ENOTSOCK",
    description: "socket operation on non-socket"
  }, {
    errno: 33,
    code: "ENOTSUP",
    description: "operation not supported on socket"
  }, {
    errno: 34,
    code: "ENOENT",
    description: "no such file or directory"
  }, {
    errno: 35,
    code: "ENOSYS",
    description: "function not implemented"
  }, {
    errno: 36,
    code: "EPIPE",
    description: "broken pipe"
  }, {
    errno: 37,
    code: "EPROTO",
    description: "protocol error"
  }, {
    errno: 38,
    code: "EPROTONOSUPPORT",
    description: "protocol not supported"
  }, {
    errno: 39,
    code: "EPROTOTYPE",
    description: "protocol wrong type for socket"
  }, {
    errno: 40,
    code: "ETIMEDOUT",
    description: "connection timed out"
  }, {
    errno: 41,
    code: "ECHARSET",
    description: "invalid Unicode character"
  }, {
    errno: 42,
    code: "EAIFAMNOSUPPORT",
    description: "address family for hostname not supported"
  }, {
    errno: 44,
    code: "EAISERVICE",
    description: "servname not supported for ai_socktype"
  }, {
    errno: 45,
    code: "EAISOCKTYPE",
    description: "ai_socktype not supported"
  }, {
    errno: 46,
    code: "ESHUTDOWN",
    description: "cannot send after transport endpoint shutdown"
  }, {
    errno: 47,
    code: "EEXIST",
    description: "file already exists"
  }, {
    errno: 48,
    code: "ESRCH",
    description: "no such process"
  }, {
    errno: 49,
    code: "ENAMETOOLONG",
    description: "name too long"
  }, {
    errno: 50,
    code: "EPERM",
    description: "operation not permitted"
  }, {
    errno: 51,
    code: "ELOOP",
    description: "too many symbolic links encountered"
  }, {
    errno: 52,
    code: "EXDEV",
    description: "cross-device link not permitted"
  }, {
    errno: 53,
    code: "ENOTEMPTY",
    description: "directory not empty"
  }, {
    errno: 54,
    code: "ENOSPC",
    description: "no space left on device"
  }, {
    errno: 55,
    code: "EIO",
    description: "i/o error"
  }, {
    errno: 56,
    code: "EROFS",
    description: "read-only file system"
  }, {
    errno: 57,
    code: "ENODEV",
    description: "no such device"
  }, {
    errno: 58,
    code: "ESPIPE",
    description: "invalid seek"
  }, {
    errno: 59,
    code: "ECANCELED",
    description: "operation canceled"
  }];
  e.exports.errno = {}, e.exports.code = {}, r.forEach(function (t) {
    e.exports.errno[t.errno] = t, e.exports.code[t.code] = t;
  }), e.exports.custom = a(
  /*! ./custom */
  507)(e.exports), e.exports.create = e.exports.custom.createError;
},
/*!**********************************************************!*\
  !*** ./node_modules/functional-red-black-tree/rbtree.js ***!
  \**********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  e.exports = function (e) {
    return new u(e || y, null);
  };

  var r = 0,
      n = 1;

  function s(e, t, a, r, n, s) {
    this._color = e, this.key = t, this.value = a, this.left = r, this.right = n, this._count = s;
  }

  function o(e) {
    return new s(e._color, e.key, e.value, e.left, e.right, e._count);
  }

  function i(e, t) {
    return new s(e, t.key, t.value, t.left, t.right, t._count);
  }

  function c(e) {
    e._count = 1 + (e.left ? e.left._count : 0) + (e.right ? e.right._count : 0);
  }

  function u(e, t) {
    this._compare = e, this.root = t;
  }

  var d = u.prototype;

  function f(e, t) {
    var a;
    if (t.left && (a = f(e, t.left))) return a;
    return (a = e(t.key, t.value)) || (t.right ? f(e, t.right) : void 0);
  }

  function l(e, t, a, r) {
    if (t(e, r.key) <= 0) {
      var n;
      if (r.left) if (n = l(e, t, a, r.left)) return n;
      if (n = a(r.key, r.value)) return n;
    }

    if (r.right) return l(e, t, a, r.right);
  }

  function h(e, t, a, r, n) {
    var s,
        o = a(e, n.key),
        i = a(t, n.key);

    if (o <= 0) {
      if (n.left && (s = h(e, t, a, r, n.left))) return s;
      if (i > 0 && (s = r(n.key, n.value))) return s;
    }

    if (i > 0 && n.right) return h(e, t, a, r, n.right);
  }

  function p(e, t) {
    this.tree = e, this._stack = t;
  }

  Object.defineProperty(d, "keys", {
    get: function get() {
      var e = [];
      return this.forEach(function (t, a) {
        e.push(t);
      }), e;
    }
  }), Object.defineProperty(d, "values", {
    get: function get() {
      var e = [];
      return this.forEach(function (t, a) {
        e.push(a);
      }), e;
    }
  }), Object.defineProperty(d, "length", {
    get: function get() {
      return this.root ? this.root._count : 0;
    }
  }), d.insert = function (e, t) {
    for (var a = this._compare, o = this.root, d = [], f = []; o;) {
      var l = a(e, o.key);
      d.push(o), f.push(l), o = l <= 0 ? o.left : o.right;
    }

    d.push(new s(r, e, t, null, null, 1));

    for (var h = d.length - 2; h >= 0; --h) {
      o = d[h];
      f[h] <= 0 ? d[h] = new s(o._color, o.key, o.value, d[h + 1], o.right, o._count + 1) : d[h] = new s(o._color, o.key, o.value, o.left, d[h + 1], o._count + 1);
    }

    for (h = d.length - 1; h > 1; --h) {
      var p = d[h - 1];
      o = d[h];
      if (p._color === n || o._color === n) break;
      var b = d[h - 2];
      if (b.left === p) {
        if (p.left === o) {
          if (!(m = b.right) || m._color !== r) {
            if (b._color = r, b.left = p.right, p._color = n, p.right = b, d[h - 2] = p, d[h - 1] = o, c(b), c(p), h >= 3) (y = d[h - 3]).left === b ? y.left = p : y.right = p;
            break;
          }

          p._color = n, b.right = i(n, m), b._color = r, h -= 1;
        } else {
          if (!(m = b.right) || m._color !== r) {
            if (p.right = o.left, b._color = r, b.left = o.right, o._color = n, o.left = p, o.right = b, d[h - 2] = o, d[h - 1] = p, c(b), c(p), c(o), h >= 3) (y = d[h - 3]).left === b ? y.left = o : y.right = o;
            break;
          }

          p._color = n, b.right = i(n, m), b._color = r, h -= 1;
        }
      } else if (p.right === o) {
        if (!(m = b.left) || m._color !== r) {
          if (b._color = r, b.right = p.left, p._color = n, p.left = b, d[h - 2] = p, d[h - 1] = o, c(b), c(p), h >= 3) (y = d[h - 3]).right === b ? y.right = p : y.left = p;
          break;
        }

        p._color = n, b.left = i(n, m), b._color = r, h -= 1;
      } else {
        var m;

        if (!(m = b.left) || m._color !== r) {
          var y;
          if (p.left = o.right, b._color = r, b.right = o.left, o._color = n, o.right = p, o.left = b, d[h - 2] = o, d[h - 1] = p, c(b), c(p), c(o), h >= 3) (y = d[h - 3]).right === b ? y.right = o : y.left = o;
          break;
        }

        p._color = n, b.left = i(n, m), b._color = r, h -= 1;
      }
    }

    return d[0]._color = n, new u(a, d[0]);
  }, d.forEach = function (e, t, a) {
    if (this.root) switch (arguments.length) {
      case 1:
        return f(e, this.root);

      case 2:
        return l(t, this._compare, e, this.root);

      case 3:
        if (this._compare(t, a) >= 0) return;
        return h(t, a, this._compare, e, this.root);
    }
  }, Object.defineProperty(d, "begin", {
    get: function get() {
      for (var e = [], t = this.root; t;) {
        e.push(t), t = t.left;
      }

      return new p(this, e);
    }
  }), Object.defineProperty(d, "end", {
    get: function get() {
      for (var e = [], t = this.root; t;) {
        e.push(t), t = t.right;
      }

      return new p(this, e);
    }
  }), d.at = function (e) {
    if (e < 0) return new p(this, []);

    for (var t = this.root, a = [];;) {
      if (a.push(t), t.left) {
        if (e < t.left._count) {
          t = t.left;
          continue;
        }

        e -= t.left._count;
      }

      if (!e) return new p(this, a);
      if (e -= 1, !t.right) break;
      if (e >= t.right._count) break;
      t = t.right;
    }

    return new p(this, []);
  }, d.ge = function (e) {
    for (var t = this._compare, a = this.root, r = [], n = 0; a;) {
      var s = t(e, a.key);
      r.push(a), s <= 0 && (n = r.length), a = s <= 0 ? a.left : a.right;
    }

    return r.length = n, new p(this, r);
  }, d.gt = function (e) {
    for (var t = this._compare, a = this.root, r = [], n = 0; a;) {
      var s = t(e, a.key);
      r.push(a), s < 0 && (n = r.length), a = s < 0 ? a.left : a.right;
    }

    return r.length = n, new p(this, r);
  }, d.lt = function (e) {
    for (var t = this._compare, a = this.root, r = [], n = 0; a;) {
      var s = t(e, a.key);
      r.push(a), s > 0 && (n = r.length), a = s <= 0 ? a.left : a.right;
    }

    return r.length = n, new p(this, r);
  }, d.le = function (e) {
    for (var t = this._compare, a = this.root, r = [], n = 0; a;) {
      var s = t(e, a.key);
      r.push(a), s >= 0 && (n = r.length), a = s < 0 ? a.left : a.right;
    }

    return r.length = n, new p(this, r);
  }, d.find = function (e) {
    for (var t = this._compare, a = this.root, r = []; a;) {
      var n = t(e, a.key);
      if (r.push(a), 0 === n) return new p(this, r);
      a = n <= 0 ? a.left : a.right;
    }

    return new p(this, []);
  }, d.remove = function (e) {
    var t = this.find(e);
    return t ? t.remove() : this;
  }, d.get = function (e) {
    for (var t = this._compare, a = this.root; a;) {
      var r = t(e, a.key);
      if (0 === r) return a.value;
      a = r <= 0 ? a.left : a.right;
    }
  };
  var b = p.prototype;

  function m(e, t) {
    e.key = t.key, e.value = t.value, e.left = t.left, e.right = t.right, e._color = t._color, e._count = t._count;
  }

  function y(e, t) {
    return e < t ? -1 : e > t ? 1 : 0;
  }

  Object.defineProperty(b, "valid", {
    get: function get() {
      return this._stack.length > 0;
    }
  }), Object.defineProperty(b, "node", {
    get: function get() {
      return this._stack.length > 0 ? this._stack[this._stack.length - 1] : null;
    },
    enumerable: !0
  }), b.clone = function () {
    return new p(this.tree, this._stack.slice());
  }, b.remove = function () {
    var e = this._stack;
    if (0 === e.length) return this.tree;
    var t = new Array(e.length),
        a = e[e.length - 1];
    t[t.length - 1] = new s(a._color, a.key, a.value, a.left, a.right, a._count);

    for (var d = e.length - 2; d >= 0; --d) {
      (a = e[d]).left === e[d + 1] ? t[d] = new s(a._color, a.key, a.value, t[d + 1], a.right, a._count) : t[d] = new s(a._color, a.key, a.value, a.left, t[d + 1], a._count);
    }

    if ((a = t[t.length - 1]).left && a.right) {
      var f = t.length;

      for (a = a.left; a.right;) {
        t.push(a), a = a.right;
      }

      var l = t[f - 1];
      t.push(new s(a._color, l.key, l.value, a.left, a.right, a._count)), t[f - 1].key = a.key, t[f - 1].value = a.value;

      for (d = t.length - 2; d >= f; --d) {
        a = t[d], t[d] = new s(a._color, a.key, a.value, a.left, t[d + 1], a._count);
      }

      t[f - 1].left = t[f];
    }

    if ((a = t[t.length - 1])._color === r) {
      var h = t[t.length - 2];
      h.left === a ? h.left = null : h.right === a && (h.right = null), t.pop();

      for (d = 0; d < t.length; ++d) {
        t[d]._count--;
      }

      return new u(this.tree._compare, t[0]);
    }

    if (a.left || a.right) {
      a.left ? m(a, a.left) : a.right && m(a, a.right), a._color = n;

      for (d = 0; d < t.length - 1; ++d) {
        t[d]._count--;
      }

      return new u(this.tree._compare, t[0]);
    }

    if (1 === t.length) return new u(this.tree._compare, null);

    for (d = 0; d < t.length; ++d) {
      t[d]._count--;
    }

    var p = t[t.length - 2];
    return function (e) {
      for (var t, a, s, u, d = e.length - 1; d >= 0; --d) {
        if (t = e[d], 0 === d) return void (t._color = n);

        if ((a = e[d - 1]).left === t) {
          if ((s = a.right).right && s.right._color === r) {
            if (u = (s = a.right = o(s)).right = o(s.right), a.right = s.left, s.left = a, s.right = u, s._color = a._color, t._color = n, a._color = n, u._color = n, c(a), c(s), d > 1) (f = e[d - 2]).left === a ? f.left = s : f.right = s;
            return void (e[d - 1] = s);
          }

          if (s.left && s.left._color === r) {
            if (u = (s = a.right = o(s)).left = o(s.left), a.right = u.left, s.left = u.right, u.left = a, u.right = s, u._color = a._color, a._color = n, s._color = n, t._color = n, c(a), c(s), c(u), d > 1) (f = e[d - 2]).left === a ? f.left = u : f.right = u;
            return void (e[d - 1] = u);
          }

          if (s._color === n) {
            if (a._color === r) return a._color = n, void (a.right = i(r, s));
            a.right = i(r, s);
            continue;
          }

          s = o(s), a.right = s.left, s.left = a, s._color = a._color, a._color = r, c(a), c(s), d > 1 && ((f = e[d - 2]).left === a ? f.left = s : f.right = s), e[d - 1] = s, e[d] = a, d + 1 < e.length ? e[d + 1] = t : e.push(t), d += 2;
        } else {
          if ((s = a.left).left && s.left._color === r) {
            if (u = (s = a.left = o(s)).left = o(s.left), a.left = s.right, s.right = a, s.left = u, s._color = a._color, t._color = n, a._color = n, u._color = n, c(a), c(s), d > 1) (f = e[d - 2]).right === a ? f.right = s : f.left = s;
            return void (e[d - 1] = s);
          }

          if (s.right && s.right._color === r) {
            if (u = (s = a.left = o(s)).right = o(s.right), a.left = u.right, s.right = u.left, u.right = a, u.left = s, u._color = a._color, a._color = n, s._color = n, t._color = n, c(a), c(s), c(u), d > 1) (f = e[d - 2]).right === a ? f.right = u : f.left = u;
            return void (e[d - 1] = u);
          }

          if (s._color === n) {
            if (a._color === r) return a._color = n, void (a.left = i(r, s));
            a.left = i(r, s);
            continue;
          }

          var f;
          s = o(s), a.left = s.right, s.right = a, s._color = a._color, a._color = r, c(a), c(s), d > 1 && ((f = e[d - 2]).right === a ? f.right = s : f.left = s), e[d - 1] = s, e[d] = a, d + 1 < e.length ? e[d + 1] = t : e.push(t), d += 2;
        }
      }
    }(t), p.left === a ? p.left = null : p.right = null, new u(this.tree._compare, t[0]);
  }, Object.defineProperty(b, "key", {
    get: function get() {
      if (this._stack.length > 0) return this._stack[this._stack.length - 1].key;
    },
    enumerable: !0
  }), Object.defineProperty(b, "value", {
    get: function get() {
      if (this._stack.length > 0) return this._stack[this._stack.length - 1].value;
    },
    enumerable: !0
  }), Object.defineProperty(b, "index", {
    get: function get() {
      var e = 0,
          t = this._stack;

      if (0 === t.length) {
        var a = this.tree.root;
        return a ? a._count : 0;
      }

      t[t.length - 1].left && (e = t[t.length - 1].left._count);

      for (var r = t.length - 2; r >= 0; --r) {
        t[r + 1] === t[r].right && (++e, t[r].left && (e += t[r].left._count));
      }

      return e;
    },
    enumerable: !0
  }), b.next = function () {
    var e = this._stack;

    if (0 !== e.length) {
      var t = e[e.length - 1];
      if (t.right) for (t = t.right; t;) {
        e.push(t), t = t.left;
      } else for (e.pop(); e.length > 0 && e[e.length - 1].right === t;) {
        t = e[e.length - 1], e.pop();
      }
    }
  }, Object.defineProperty(b, "hasNext", {
    get: function get() {
      var e = this._stack;
      if (0 === e.length) return !1;
      if (e[e.length - 1].right) return !0;

      for (var t = e.length - 1; t > 0; --t) {
        if (e[t - 1].left === e[t]) return !0;
      }

      return !1;
    }
  }), b.update = function (e) {
    var t = this._stack;
    if (0 === t.length) throw new Error("Can't update empty node!");
    var a = new Array(t.length),
        r = t[t.length - 1];
    a[a.length - 1] = new s(r._color, r.key, e, r.left, r.right, r._count);

    for (var n = t.length - 2; n >= 0; --n) {
      (r = t[n]).left === t[n + 1] ? a[n] = new s(r._color, r.key, r.value, a[n + 1], r.right, r._count) : a[n] = new s(r._color, r.key, r.value, r.left, a[n + 1], r._count);
    }

    return new u(this.tree._compare, a[0]);
  }, b.prev = function () {
    var e = this._stack;

    if (0 !== e.length) {
      var t = e[e.length - 1];
      if (t.left) for (t = t.left; t;) {
        e.push(t), t = t.right;
      } else for (e.pop(); e.length > 0 && e[e.length - 1].left === t;) {
        t = e[e.length - 1], e.pop();
      }
    }
  }, Object.defineProperty(b, "hasPrev", {
    get: function get() {
      var e = this._stack;
      if (0 === e.length) return !1;
      if (e[e.length - 1].left) return !0;

      for (var t = e.length - 1; t > 0; --t) {
        if (e[t - 1].right === e[t]) return !0;
      }

      return !1;
    }
  });
},
/*!****************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/index.js ***!
  \****************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./baseTrie */
  538),
      n = a(
  /*! ./checkpoint-interface */
  557),
      s = a(
  /*! util */
  23).inherits,
      o = a(
  /*! ./proof.js */
  568);

  function i() {
    r.apply(this, arguments), n.call(this, this);
  }

  e.exports = i, s(i, r), i.prove = o.prove, i.verifyProof = o.verifyProof;
},
/*!*******************************************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/node_modules/level-errors/errors.js ***!
  \*******************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! errno */
  110).create,
      n = r("LevelUPError"),
      s = r("NotFoundError", n);
  s.prototype.notFound = !0, s.prototype.status = 404, e.exports = {
    LevelUPError: n,
    InitializationError: r("InitializationError", n),
    OpenError: r("OpenError", n),
    ReadError: r("ReadError", n),
    WriteError: r("WriteError", n),
    NotFoundError: s,
    EncodingError: r("EncodingError", n)
  };
},
/*!***************************************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/node_modules/async/lib/async.js ***!
  \***************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (a, r, n) {
    var s;
    /*!
     * async
     * https://github.com/caolan/async
     *
     * Copyright 2010-2014 Caolan McMahon
     * Released under the MIT license
     */

    !function () {
      var o,
          i = {};

      function c() {}

      function u(e) {
        return e;
      }

      function d(e) {
        return !!e;
      }

      function f(e) {
        return !e;
      }

      var l = "object" == typeof self && self.self === self && self || "object" == typeof a && a.global === a && a || this;

      function h(e) {
        return function () {
          if (null === e) throw new Error("Callback was already called.");
          e.apply(this, arguments), e = null;
        };
      }

      function p(e) {
        return function () {
          null !== e && (e.apply(this, arguments), e = null);
        };
      }

      null != l && (o = l.async), i.noConflict = function () {
        return l.async = o, i;
      };

      var b = Object.prototype.toString,
          m = Array.isArray || function (e) {
        return "[object Array]" === b.call(e);
      };

      function y(e) {
        return m(e) || "number" == typeof e.length && e.length >= 0 && e.length % 1 == 0;
      }

      function v(e, t) {
        for (var a = -1, r = e.length; ++a < r;) {
          t(e[a], a, e);
        }
      }

      function _(e, t) {
        for (var a = -1, r = e.length, n = Array(r); ++a < r;) {
          n[a] = t(e[a], a, e);
        }

        return n;
      }

      function g(e) {
        return _(Array(e), function (e, t) {
          return t;
        });
      }

      function A(e, t, a) {
        return v(e, function (e, r, n) {
          a = t(a, e, r, n);
        }), a;
      }

      function w(e, t) {
        v(x(e), function (a) {
          t(e[a], a);
        });
      }

      function T(e, t) {
        for (var a = 0; a < e.length; a++) {
          if (e[a] === t) return a;
        }

        return -1;
      }

      var x = Object.keys || function (e) {
        var t = [];

        for (var a in e) {
          e.hasOwnProperty(a) && t.push(a);
        }

        return t;
      };

      function D(e) {
        var t,
            a,
            r = -1;
        return y(e) ? (t = e.length, function () {
          return ++r < t ? r : null;
        }) : (a = x(e), t = a.length, function () {
          return ++r < t ? a[r] : null;
        });
      }

      function C(e, t) {
        return t = null == t ? e.length - 1 : +t, function () {
          for (var a = Math.max(arguments.length - t, 0), r = Array(a), n = 0; n < a; n++) {
            r[n] = arguments[n + t];
          }

          switch (t) {
            case 0:
              return e.call(this, r);

            case 1:
              return e.call(this, arguments[0], r);
          }
        };
      }

      function S(e) {
        return function (t, a, r) {
          return e(t, r);
        };
      }

      var E = "function" == typeof r && r,
          B = E ? function (e) {
        E(e);
      } : function (e) {
        setTimeout(e, 0);
      };

      function k(e) {
        return function (t, a, r) {
          r = p(r || c);
          var n = D(t = t || []);
          if (e <= 0) return r(null);
          var s = !1,
              o = 0,
              i = !1;
          !function c() {
            if (s && o <= 0) return r(null);

            for (; o < e && !i;) {
              var u = n();
              if (null === u) return s = !0, void (o <= 0 && r(null));
              o += 1, a(t[u], u, h(function (e) {
                o -= 1, e ? (r(e), i = !0) : c();
              }));
            }
          }();
        };
      }

      function R(e) {
        return function (t, a, r) {
          return e(i.eachOf, t, a, r);
        };
      }

      function W(e) {
        return function (t, a, r, n) {
          return e(k(a), t, r, n);
        };
      }

      function I(e) {
        return function (t, a, r) {
          return e(i.eachOfSeries, t, a, r);
        };
      }

      function N(e, t, a, r) {
        r = p(r || c);
        var n = y(t = t || []) ? [] : {};
        e(t, function (e, t, r) {
          a(e, function (e, a) {
            n[t] = a, r(e);
          });
        }, function (e) {
          r(e, n);
        });
      }

      function M(e, t, a, r) {
        var n = [];
        e(t, function (e, t, r) {
          a(e, function (a) {
            a && n.push({
              index: t,
              value: e
            }), r();
          });
        }, function () {
          r(_(n.sort(function (e, t) {
            return e.index - t.index;
          }), function (e) {
            return e.value;
          }));
        });
      }

      function P(e, t, a, r) {
        M(e, t, function (e, t) {
          a(e, function (e) {
            t(!e);
          });
        }, r);
      }

      function L(e, t, a) {
        return function (r, n, s, o) {
          function i() {
            o && o(a(!1, void 0));
          }

          function c(e, r, n) {
            if (!o) return n();
            s(e, function (r) {
              o && t(r) && (o(a(!0, e)), o = s = !1), n();
            });
          }

          arguments.length > 3 ? e(r, n, c, i) : (o = s, s = n, e(r, c, i));
        };
      }

      function O(e, t) {
        return t;
      }

      function F(e, t, a) {
        a = a || c;
        var r = y(t) ? [] : {};
        e(t, function (e, t, a) {
          e(C(function (e, n) {
            n.length <= 1 && (n = n[0]), r[t] = n, a(e);
          }));
        }, function (e) {
          a(e, r);
        });
      }

      function j(e, t, a, r) {
        var n = [];
        e(t, function (e, t, r) {
          a(e, function (e, t) {
            n = n.concat(t || []), r(e);
          });
        }, function (e) {
          r(e, n);
        });
      }

      function G(e, t, a) {
        if (null == t) t = 1;else if (0 === t) throw new Error("Concurrency must not be zero");

        function r(e, t, a, r) {
          if (null != r && "function" != typeof r) throw new Error("task callback must be a function");
          if (e.started = !0, m(t) || (t = [t]), 0 === t.length && e.idle()) return i.setImmediate(function () {
            e.drain();
          });
          v(t, function (t) {
            var n = {
              data: t,
              callback: r || c
            };
            a ? e.tasks.unshift(n) : e.tasks.push(n), e.tasks.length === e.concurrency && e.saturated();
          }), i.setImmediate(e.process);
        }

        function n(e, t) {
          return function () {
            s -= 1;
            var a = !1,
                r = arguments;
            v(t, function (e) {
              v(o, function (t, r) {
                t !== e || a || (o.splice(r, 1), a = !0);
              }), e.callback.apply(e, r);
            }), e.tasks.length + s === 0 && e.drain(), e.process();
          };
        }

        var s = 0,
            o = [],
            u = {
          tasks: [],
          concurrency: t,
          payload: a,
          saturated: c,
          empty: c,
          drain: c,
          started: !1,
          paused: !1,
          push: function push(e, t) {
            r(u, e, !1, t);
          },
          kill: function kill() {
            u.drain = c, u.tasks = [];
          },
          unshift: function unshift(e, t) {
            r(u, e, !0, t);
          },
          process: function process() {
            for (; !u.paused && s < u.concurrency && u.tasks.length;) {
              var t = u.payload ? u.tasks.splice(0, u.payload) : u.tasks.splice(0, u.tasks.length),
                  a = _(t, function (e) {
                return e.data;
              });

              0 === u.tasks.length && u.empty(), s += 1, o.push(t[0]);
              var r = h(n(u, t));
              e(a, r);
            }
          },
          length: function length() {
            return u.tasks.length;
          },
          running: function running() {
            return s;
          },
          workersList: function workersList() {
            return o;
          },
          idle: function idle() {
            return u.tasks.length + s === 0;
          },
          pause: function pause() {
            u.paused = !0;
          },
          resume: function resume() {
            if (!1 !== u.paused) {
              u.paused = !1;

              for (var e = Math.min(u.concurrency, u.tasks.length), t = 1; t <= e; t++) {
                i.setImmediate(u.process);
              }
            }
          }
        };
        return u;
      }

      function V(e) {
        return C(function (t, a) {
          t.apply(null, a.concat([C(function (t, a) {
            "object" == typeof console && (t ? console.error && console.error(t) : console[e] && v(a, function (t) {
              console[e](t);
            }));
          })]));
        });
      }

      function U(e) {
        return function (t, a, r) {
          e(g(t), a, r);
        };
      }

      function H(e) {
        return C(function (t, a) {
          var r = C(function (a) {
            var r = this,
                n = a.pop();
            return e(t, function (e, t, n) {
              e.apply(r, a.concat([n]));
            }, n);
          });
          return a.length ? r.apply(this, a) : r;
        });
      }

      function z(e) {
        return C(function (t) {
          var a = t.pop();
          t.push(function () {
            var e = arguments;
            r ? i.setImmediate(function () {
              a.apply(null, e);
            }) : a.apply(null, e);
          });
          var r = !0;
          e.apply(this, t), r = !1;
        });
      }

      "object" == typeof n && "function" == typeof n.nextTick ? i.nextTick = n.nextTick : i.nextTick = B, i.setImmediate = E ? B : i.nextTick, i.forEach = i.each = function (e, t, a) {
        return i.eachOf(e, S(t), a);
      }, i.forEachSeries = i.eachSeries = function (e, t, a) {
        return i.eachOfSeries(e, S(t), a);
      }, i.forEachLimit = i.eachLimit = function (e, t, a, r) {
        return k(t)(e, S(a), r);
      }, i.forEachOf = i.eachOf = function (e, t, a) {
        a = p(a || c);

        for (var r, n = D(e = e || []), s = 0; null != (r = n());) {
          s += 1, t(e[r], r, h(o));
        }

        function o(e) {
          s--, e ? a(e) : null === r && s <= 0 && a(null);
        }

        0 === s && a(null);
      }, i.forEachOfSeries = i.eachOfSeries = function (e, t, a) {
        a = p(a || c);
        var r = D(e = e || []),
            n = r();
        !function s() {
          var o = !0;
          if (null === n) return a(null);
          t(e[n], n, h(function (e) {
            if (e) a(e);else {
              if (null === (n = r())) return a(null);
              o ? i.setImmediate(s) : s();
            }
          })), o = !1;
        }();
      }, i.forEachOfLimit = i.eachOfLimit = function (e, t, a, r) {
        k(t)(e, a, r);
      }, i.map = R(N), i.mapSeries = I(N), i.mapLimit = W(N), i.inject = i.foldl = i.reduce = function (e, t, a, r) {
        i.eachOfSeries(e, function (e, r, n) {
          a(t, e, function (e, a) {
            t = a, n(e);
          });
        }, function (e) {
          r(e, t);
        });
      }, i.foldr = i.reduceRight = function (e, t, a, r) {
        var n = _(e, u).reverse();

        i.reduce(n, t, a, r);
      }, i.transform = function (e, t, a, r) {
        3 === arguments.length && (r = a, a = t, t = m(e) ? [] : {}), i.eachOf(e, function (e, r, n) {
          a(t, e, r, n);
        }, function (e) {
          r(e, t);
        });
      }, i.select = i.filter = R(M), i.selectLimit = i.filterLimit = W(M), i.selectSeries = i.filterSeries = I(M), i.reject = R(P), i.rejectLimit = W(P), i.rejectSeries = I(P), i.any = i.some = L(i.eachOf, d, u), i.someLimit = L(i.eachOfLimit, d, u), i.all = i.every = L(i.eachOf, f, f), i.everyLimit = L(i.eachOfLimit, f, f), i.detect = L(i.eachOf, u, O), i.detectSeries = L(i.eachOfSeries, u, O), i.detectLimit = L(i.eachOfLimit, u, O), i.sortBy = function (e, t, a) {
        function r(e, t) {
          var a = e.criteria,
              r = t.criteria;
          return a < r ? -1 : a > r ? 1 : 0;
        }

        i.map(e, function (e, a) {
          t(e, function (t, r) {
            t ? a(t) : a(null, {
              value: e,
              criteria: r
            });
          });
        }, function (e, t) {
          if (e) return a(e);
          a(null, _(t.sort(r), function (e) {
            return e.value;
          }));
        });
      }, i.auto = function (e, t, a) {
        "function" == typeof arguments[1] && (a = t, t = null), a = p(a || c);
        var r = x(e),
            n = r.length;
        if (!n) return a(null);
        t || (t = n);
        var s = {},
            o = 0,
            u = !1,
            d = [];

        function f(e) {
          d.unshift(e);
        }

        function l(e) {
          var t = T(d, e);
          t >= 0 && d.splice(t, 1);
        }

        function h() {
          n--, v(d.slice(0), function (e) {
            e();
          });
        }

        f(function () {
          n || a(null, s);
        }), v(r, function (r) {
          if (!u) {
            for (var n, c = m(e[r]) ? e[r] : [e[r]], d = C(function (e, t) {
              if (o--, t.length <= 1 && (t = t[0]), e) {
                var n = {};
                w(s, function (e, t) {
                  n[t] = e;
                }), n[r] = t, u = !0, a(e, n);
              } else s[r] = t, i.setImmediate(h);
            }), p = c.slice(0, c.length - 1), b = p.length; b--;) {
              if (!(n = e[p[b]])) throw new Error("Has nonexistent dependency in " + p.join(", "));
              if (m(n) && T(n, r) >= 0) throw new Error("Has cyclic dependencies");
            }

            y() ? (o++, c[c.length - 1](d, s)) : f(function e() {
              y() && (o++, l(e), c[c.length - 1](d, s));
            });
          }

          function y() {
            return o < t && A(p, function (e, t) {
              return e && s.hasOwnProperty(t);
            }, !0) && !s.hasOwnProperty(r);
          }
        });
      }, i.retry = function (e, t, a) {
        var r = 5,
            n = 0,
            s = [],
            o = {
          times: r,
          interval: n
        };

        function c(e, t) {
          if ("number" == typeof t) e.times = parseInt(t, 10) || r;else {
            if ("object" != typeof t) throw new Error("Unsupported argument type for 'times': " + typeof t);
            e.times = parseInt(t.times, 10) || r, e.interval = parseInt(t.interval, 10) || n;
          }
        }

        var u = arguments.length;
        if (u < 1 || u > 3) throw new Error("Invalid arguments - must be either (task), (task, callback), (times, task) or (times, task, callback)");

        function d(e, t) {
          function a(e, a) {
            return function (r) {
              e(function (e, t) {
                r(!e || a, {
                  err: e,
                  result: t
                });
              }, t);
            };
          }

          function r(e) {
            return function (t) {
              setTimeout(function () {
                t(null);
              }, e);
            };
          }

          for (; o.times;) {
            var n = !(o.times -= 1);
            s.push(a(o.task, n)), !n && o.interval > 0 && s.push(r(o.interval));
          }

          i.series(s, function (t, a) {
            a = a[a.length - 1], (e || o.callback)(a.err, a.result);
          });
        }

        return u <= 2 && "function" == typeof e && (a = t, t = e), "function" != typeof e && c(o, e), o.callback = a, o.task = t, o.callback ? d() : d;
      }, i.waterfall = function (e, t) {
        if (t = p(t || c), !m(e)) {
          var a = new Error("First argument to waterfall must be an array of functions");
          return t(a);
        }

        if (!e.length) return t();
        !function e(a) {
          return C(function (r, n) {
            if (r) t.apply(null, [r].concat(n));else {
              var s = a.next();
              s ? n.push(e(s)) : n.push(t), z(a).apply(null, n);
            }
          });
        }(i.iterator(e))();
      }, i.parallel = function (e, t) {
        F(i.eachOf, e, t);
      }, i.parallelLimit = function (e, t, a) {
        F(k(t), e, a);
      }, i.series = function (e, t) {
        F(i.eachOfSeries, e, t);
      }, i.iterator = function (e) {
        return function t(a) {
          function r() {
            return e.length && e[a].apply(null, arguments), r.next();
          }

          return r.next = function () {
            return a < e.length - 1 ? t(a + 1) : null;
          }, r;
        }(0);
      }, i.apply = C(function (e, t) {
        return C(function (a) {
          return e.apply(null, t.concat(a));
        });
      }), i.concat = R(j), i.concatSeries = I(j), i.whilst = function (e, t, a) {
        if (a = a || c, e()) {
          var r = C(function (n, s) {
            n ? a(n) : e.apply(this, s) ? t(r) : a.apply(null, [null].concat(s));
          });
          t(r);
        } else a(null);
      }, i.doWhilst = function (e, t, a) {
        var r = 0;
        return i.whilst(function () {
          return ++r <= 1 || t.apply(this, arguments);
        }, e, a);
      }, i.until = function (e, t, a) {
        return i.whilst(function () {
          return !e.apply(this, arguments);
        }, t, a);
      }, i.doUntil = function (e, t, a) {
        return i.doWhilst(e, function () {
          return !t.apply(this, arguments);
        }, a);
      }, i.during = function (e, t, a) {
        a = a || c;

        var r = C(function (t, r) {
          t ? a(t) : (r.push(n), e.apply(this, r));
        }),
            n = function n(e, _n2) {
          e ? a(e) : _n2 ? t(r) : a(null);
        };

        e(n);
      }, i.doDuring = function (e, t, a) {
        var r = 0;
        i.during(function (e) {
          r++ < 1 ? e(null, !0) : t.apply(this, arguments);
        }, e, a);
      }, i.queue = function (e, t) {
        return G(function (t, a) {
          e(t[0], a);
        }, t, 1);
      }, i.priorityQueue = function (e, t) {
        function a(e, t) {
          return e.priority - t.priority;
        }

        var r = i.queue(e, t);
        return r.push = function (e, t, n) {
          !function (e, t, r, n) {
            if (null != n && "function" != typeof n) throw new Error("task callback must be a function");
            if (e.started = !0, m(t) || (t = [t]), 0 === t.length) return i.setImmediate(function () {
              e.drain();
            });
            v(t, function (t) {
              var s = {
                data: t,
                priority: r,
                callback: "function" == typeof n ? n : c
              };
              e.tasks.splice(function (e, t, a) {
                for (var r = -1, n = e.length - 1; r < n;) {
                  var s = r + (n - r + 1 >>> 1);
                  a(t, e[s]) >= 0 ? r = s : n = s - 1;
                }

                return r;
              }(e.tasks, s, a) + 1, 0, s), e.tasks.length === e.concurrency && e.saturated(), i.setImmediate(e.process);
            });
          }(r, e, t, n);
        }, delete r.unshift, r;
      }, i.cargo = function (e, t) {
        return G(e, 1, t);
      }, i.log = V("log"), i.dir = V("dir"), i.memoize = function (e, t) {
        var a = {},
            r = {},
            n = Object.prototype.hasOwnProperty;
        t = t || u;
        var s = C(function (s) {
          var o = s.pop(),
              c = t.apply(null, s);
          n.call(a, c) ? i.setImmediate(function () {
            o.apply(null, a[c]);
          }) : n.call(r, c) ? r[c].push(o) : (r[c] = [o], e.apply(null, s.concat([C(function (e) {
            a[c] = e;
            var t = r[c];
            delete r[c];

            for (var n = 0, s = t.length; n < s; n++) {
              t[n].apply(null, e);
            }
          })])));
        });
        return s.memo = a, s.unmemoized = e, s;
      }, i.unmemoize = function (e) {
        return function () {
          return (e.unmemoized || e).apply(null, arguments);
        };
      }, i.times = U(i.map), i.timesSeries = U(i.mapSeries), i.timesLimit = function (e, t, a, r) {
        return i.mapLimit(g(e), t, a, r);
      }, i.seq = function () {
        var e = arguments;
        return C(function (t) {
          var a = this,
              r = t[t.length - 1];
          "function" == typeof r ? t.pop() : r = c, i.reduce(e, t, function (e, t, r) {
            t.apply(a, e.concat([C(function (e, t) {
              r(e, t);
            })]));
          }, function (e, t) {
            r.apply(a, [e].concat(t));
          });
        });
      }, i.compose = function () {
        return i.seq.apply(null, Array.prototype.reverse.call(arguments));
      }, i.applyEach = H(i.eachOf), i.applyEachSeries = H(i.eachOfSeries), i.forever = function (e, t) {
        var a = h(t || c),
            r = z(e);
        !function e(t) {
          if (t) return a(t);
          r(e);
        }();
      }, i.ensureAsync = z, i.constant = C(function (e) {
        var t = [null].concat(e);
        return function (e) {
          return e.apply(this, t);
        };
      }), i.wrapSync = i.asyncify = function (e) {
        return C(function (t) {
          var a,
              r,
              n,
              s = t.pop();

          try {
            a = e.apply(this, t);
          } catch (e) {
            return s(e);
          }

          ("function" === (n = typeof (r = a)) || "object" === n && r) && "function" == typeof a.then ? a.then(function (e) {
            s(null, e);
          }).catch(function (e) {
            s(e.message ? e : new Error(e));
          }) : s(null, a);
        });
      }, e.exports ? e.exports = i : void 0 === (s = function () {
        return i;
      }.apply(t, [])) || (e.exports = s);
    }();
  }).call(this, a(
  /*! ./../../../../webpack/buildin/global.js */
  18), a(
  /*! ./../../../../timers-browserify/main.js */
  69).setImmediate, a(
  /*! ./../../../../process/browser.js */
  9));
},
/*!*******************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/trieNode.js ***!
  \*******************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    var r = a(
    /*! rlp */
    21),
        n = a(
    /*! ethereumjs-util */
    82);

    function s(e, t, a) {
      if (Array.isArray(e)) this.parseNode(e);else if (this.type = e, "branch" === e) {
        var r = t;
        this.raw = Array.apply(null, Array(17)), r && r.forEach(function (e) {
          this.set.apply(this, e);
        });
      } else this.raw = Array(2), this.setValue(a), this.setKey(t);
    }

    function o(e, t) {
      return e.length % 2 ? e.unshift(1) : (e.unshift(0), e.unshift(0)), t && (e[0] += 2), e;
    }

    function i(e) {
      return e = e[0] % 2 ? e.slice(1) : e.slice(2);
    }

    function c(e) {
      return e[0] > 1;
    }

    function u(e) {
      for (var a = new t(e), r = [], n = 0; n < a.length; n++) {
        var s = 2 * n;
        r[s] = a[n] >> 4, r[++s] = a[n] % 16;
      }

      return r;
    }

    function d(e) {
      for (var a = new t(e.length / 2), r = 0; r < a.length; r++) {
        var n = 2 * r;
        a[r] = (e[n] << 4) + e[++n];
      }

      return a;
    }

    function f(e) {
      return 17 === e.length ? "branch" : 2 === e.length ? c(u(e[0])) ? "leaf" : "extention" : void 0;
    }

    e.exports = s, s.isRawNode = function (e) {
      return Array.isArray(e) && !t.isBuffer(e);
    }, s.addHexPrefix = o, s.removeHexPrefix = i, s.isTerminator = c, s.stringToNibbles = u, s.nibblesToBuffer = d, s.getNodeType = f, Object.defineProperty(s.prototype, "value", {
      get: function get() {
        return this.getValue();
      },
      set: function set(e) {
        this.setValue(e);
      }
    }), Object.defineProperty(s.prototype, "key", {
      get: function get() {
        return this.getKey();
      },
      set: function set(e) {
        this.setKey(e);
      }
    }), s.prototype.parseNode = function (e) {
      this.raw = e, this.type = f(e);
    }, s.prototype.setValue = function (e, t) {
      "branch" !== this.type ? this.raw[1] = e : (1 === arguments.length && (t = e, e = 16), this.raw[e] = t);
    }, s.prototype.getValue = function (e) {
      if ("branch" !== this.type) return this.raw[1];
      0 === arguments.length && (e = 16);
      var t = this.raw[e];
      return null != t && 0 !== t.length ? t : void 0;
    }, s.prototype.setKey = function (e) {
      "branch" !== this.type && (e = o(e = t.isBuffer(e) ? u(e) : e.slice(0), "leaf" === this.type), this.raw[0] = d(e));
    }, s.prototype.getKey = function () {
      if ("branch" !== this.type) {
        var e = this.raw[0];
        return e = i(u(e));
      }
    }, s.prototype.serialize = function () {
      return r.encode(this.raw);
    }, s.prototype.hash = function () {
      return n.sha3(this.serialize());
    }, s.prototype.toString = function () {
      var e = this.type;
      return e += ": [", this.raw.forEach(function (a) {
        t.isBuffer(a) ? e += a.toString("hex") + ", " : e += a ? "object, " : "empty, ";
      }), e = e.slice(0, -2), e += "]";
    }, s.prototype.getChildren = function () {
      var e = [];

      switch (this.type) {
        case "leaf":
          break;

        case "extention":
          e.push([this.key, this.getValue()]);
          break;

        case "branch":
          for (var t = 0; t < 16; t++) {
            var a = this.getValue(t);
            a && e.push([[t], a]);
          }

      }

      return e;
    };
  }).call(this, a(
  /*! ./../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!**********************************************************************************!*\
  !*** ./node_modules/level-ws/node_modules/readable-stream/lib/_stream_duplex.js ***!
  \**********************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    e.exports = i;

    var r = Object.keys || function (e) {
      var t = [];

      for (var a in e) {
        t.push(a);
      }

      return t;
    },
        n = a(
    /*! core-util-is */
    27);

    n.inherits = a(
    /*! inherits */
    3);
    var s = a(
    /*! ./_stream_readable */
    209),
        o = a(
    /*! ./_stream_writable */
    210);

    function i(e) {
      if (!(this instanceof i)) return new i(e);
      s.call(this, e), o.call(this, e), e && !1 === e.readable && (this.readable = !1), e && !1 === e.writable && (this.writable = !1), this.allowHalfOpen = !0, e && !1 === e.allowHalfOpen && (this.allowHalfOpen = !1), this.once("end", c);
    }

    function c() {
      this.allowHalfOpen || this._writableState.ended || t.nextTick(this.end.bind(this));
    }

    n.inherits(i, s), function (e, t) {
      for (var a = 0, r = e.length; a < r; a++) {
        t(e[a], a);
      }
    }(r(o.prototype), function (e) {
      i.prototype[e] || (i.prototype[e] = o.prototype[e]);
    });
  }).call(this, a(
  /*! ./../../../../process/browser.js */
  9));
},
/*!*********************************************!*\
  !*** ./node_modules/miller-rabin/lib/mr.js ***!
  \*********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! bn.js */
  5),
      n = a(
  /*! brorand */
  101);

  function s(e) {
    this.rand = e || new n.Rand();
  }

  e.exports = s, s.create = function (e) {
    return new s(e);
  }, s.prototype._randbelow = function (e) {
    var t = e.bitLength(),
        a = Math.ceil(t / 8);

    do {
      var n = new r(this.rand.generate(a));
    } while (n.cmp(e) >= 0);

    return n;
  }, s.prototype._randrange = function (e, t) {
    var a = t.sub(e);
    return e.add(this._randbelow(a));
  }, s.prototype.test = function (e, t, a) {
    var n = e.bitLength(),
        s = r.mont(e),
        o = new r(1).toRed(s);
    t || (t = Math.max(1, n / 48 | 0));

    for (var i = e.subn(1), c = 0; !i.testn(c); c++) {
      ;
    }

    for (var u = e.shrn(c), d = i.toRed(s); t > 0; t--) {
      var f = this._randrange(new r(2), i);

      a && a(f);
      var l = f.toRed(s).redPow(u);

      if (0 !== l.cmp(o) && 0 !== l.cmp(d)) {
        for (var h = 1; h < c; h++) {
          if (0 === (l = l.redSqr()).cmp(o)) return !1;
          if (0 === l.cmp(d)) break;
        }

        if (h === c) return !1;
      }
    }

    return !0;
  }, s.prototype.getDivisor = function (e, t) {
    var a = e.bitLength(),
        n = r.mont(e),
        s = new r(1).toRed(n);
    t || (t = Math.max(1, a / 48 | 0));

    for (var o = e.subn(1), i = 0; !o.testn(i); i++) {
      ;
    }

    for (var c = e.shrn(i), u = o.toRed(n); t > 0; t--) {
      var d = this._randrange(new r(2), o),
          f = e.gcd(d);

      if (0 !== f.cmpn(1)) return f;
      var l = d.toRed(n).redPow(c);

      if (0 !== l.cmp(s) && 0 !== l.cmp(u)) {
        for (var h = 1; h < i; h++) {
          if (0 === (l = l.redSqr()).cmp(s)) return l.fromRed().subn(1).gcd(e);
          if (0 === l.cmp(u)) break;
        }

        if (h === i) return (l = l.redSqr()).fromRed().subn(1).gcd(e);
      }
    }

    return !1;
  };
},
/*!***************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/create-property-descriptor.js ***!
  \***************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = function (e, t) {
    return {
      enumerable: !(1 & e),
      configurable: !(2 & e),
      writable: !(4 & e),
      value: t
    };
  };
},
/*!************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/classof-raw.js ***!
  \************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  var a = {}.toString;

  e.exports = function (e) {
    return a.call(e).slice(8, -1);
  };
},
/*!*************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/require-object-coercible.js ***!
  \*************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = function (e) {
    if (null == e) throw TypeError("Can't call method on " + e);
    return e;
  };
},
/*!*****************************************************!*\
  !*** ./node_modules/core-js-pure/internals/path.js ***!
  \*****************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = {};
},
/*!****************************************************!*\
  !*** ./node_modules/core-js-pure/internals/uid.js ***!
  \****************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  var a = 0,
      r = Math.random();

  e.exports = function (e) {
    return "Symbol(" + String(void 0 === e ? "" : e) + ")_" + (++a + r).toString(36);
  };
},
/*!*******************************************************!*\
  !*** ./node_modules/core-js-pure/internals/shared.js ***!
  \*******************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/global */
  38),
      n = a(
  /*! ../internals/set-global */
  603),
      s = a(
  /*! ../internals/is-pure */
  124),
      o = r["__core-js_shared__"] || n("__core-js_shared__", {});
  (e.exports = function (e, t) {
    return o[e] || (o[e] = void 0 !== t ? t : {});
  })("versions", []).push({
    version: "3.2.1",
    mode: s ? "pure" : "global",
    copyright: "© 2019 Denis Pushkarev (zloirock.ru)"
  });
},
/*!********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/is-pure.js ***!
  \********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = !0;
},
/*!**********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/to-length.js ***!
  \**********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/to-integer */
  126),
      n = Math.min;

  e.exports = function (e) {
    return e > 0 ? n(r(e), 9007199254740991) : 0;
  };
},
/*!***********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/to-integer.js ***!
  \***********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  var a = Math.ceil,
      r = Math.floor;

  e.exports = function (e) {
    return isNaN(e = +e) ? 0 : (e > 0 ? r : a)(e);
  };
},
/*!******************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/set-to-string-tag.js ***!
  \******************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/object-define-property */
  56).f,
      n = a(
  /*! ../internals/hide */
  42),
      s = a(
  /*! ../internals/has */
  51),
      o = a(
  /*! ../internals/object-to-string */
  607),
      i = a(
  /*! ../internals/well-known-symbol */
  39)("toStringTag"),
      c = o !== {}.toString;

  e.exports = function (e, t, a, u) {
    if (e) {
      var d = a ? e : e.prototype;
      s(d, i) || r(d, i, {
        configurable: !0,
        value: t
      }), u && c && n(d, "toString", o);
    }
  };
},
/*!***********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/shared-key.js ***!
  \***********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/shared */
  123),
      n = a(
  /*! ../internals/uid */
  122),
      s = r("keys");

  e.exports = function (e) {
    return s[e] || (s[e] = n(e));
  };
},
/*!****************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/define-iterator.js ***!
  \****************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ../internals/export */
  215),
      n = a(
  /*! ../internals/create-iterator-constructor */
  621),
      s = a(
  /*! ../internals/object-get-prototype-of */
  230),
      o = a(
  /*! ../internals/object-set-prototype-of */
  623),
      i = a(
  /*! ../internals/set-to-string-tag */
  127),
      c = a(
  /*! ../internals/hide */
  42),
      u = a(
  /*! ../internals/redefine */
  228),
      d = a(
  /*! ../internals/well-known-symbol */
  39),
      f = a(
  /*! ../internals/is-pure */
  124),
      l = a(
  /*! ../internals/iterators */
  65),
      h = a(
  /*! ../internals/iterators-core */
  229),
      p = h.IteratorPrototype,
      b = h.BUGGY_SAFARI_ITERATORS,
      m = d("iterator"),
      y = function y() {
    return this;
  };

  e.exports = function (e, t, a, d, h, v, _) {
    n(a, t, d);

    var g,
        A,
        w,
        T = function T(e) {
      if (e === h && E) return E;
      if (!b && e in C) return C[e];

      switch (e) {
        case "keys":
        case "values":
        case "entries":
          return function () {
            return new a(this, e);
          };
      }

      return function () {
        return new a(this);
      };
    },
        x = t + " Iterator",
        D = !1,
        C = e.prototype,
        S = C[m] || C["@@iterator"] || h && C[h],
        E = !b && S || T(h),
        B = "Array" == t && C.entries || S;

    if (B && (g = s(B.call(new e())), p !== Object.prototype && g.next && (f || s(g) === p || (o ? o(g, p) : "function" != typeof g[m] && c(g, m, y)), i(g, x, !0, !0), f && (l[x] = y))), "values" == h && S && "values" !== S.name && (D = !0, E = function E() {
      return S.call(this);
    }), f && !_ || C[m] === E || c(C, m, E), l[t] = E, h) if (A = {
      values: T("values"),
      keys: v ? E : T("keys"),
      entries: T("entries")
    }, _) for (w in A) {
      !b && !D && w in C || u(C, w, A[w]);
    } else r({
      target: t,
      proto: !0,
      forced: b || D
    }, A);
    return A;
  };
},
/*!*****************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-vm/dist/evm/txContext.js ***!
  \*****************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var r = function r(e, t) {
    this.gasPrice = e, this.origin = t;
  };

  t.default = r;
},
/*!*************************************************!*\
  !*** ./node_modules/define-properties/index.js ***!
  \*************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! object-keys */
  232),
      n = "function" == typeof Symbol && "symbol" == typeof Symbol("foo"),
      s = Object.prototype.toString,
      o = Array.prototype.concat,
      i = Object.defineProperty,
      c = i && function () {
    var e = {};

    try {
      for (var t in i(e, "x", {
        enumerable: !1,
        value: e
      }), e) {
        return !1;
      }

      return e.x === e;
    } catch (e) {
      return !1;
    }
  }(),
      u = function u(e, t, a, r) {
    var n;
    t in e && ("function" != typeof (n = r) || "[object Function]" !== s.call(n) || !r()) || (c ? i(e, t, {
      configurable: !0,
      enumerable: !1,
      value: a,
      writable: !0
    }) : e[t] = a);
  },
      d = function d(e, t) {
    var a = arguments.length > 2 ? arguments[2] : {},
        s = r(t);
    n && (s = o.call(s, Object.getOwnPropertySymbols(t)));

    for (var i = 0; i < s.length; i += 1) {
      u(e, s[i], t[s[i]], a[s[i]]);
    }
  };

  d.supportsDescriptors = !!c, e.exports = d;
},
/*!*********************************************!*\
  !*** ./node_modules/function-bind/index.js ***!
  \*********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ./implementation */
  647);
  e.exports = Function.prototype.bind || r;
},
/*!*******************************************!*\
  !*** ./node_modules/is-callable/index.js ***!
  \*******************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = Function.prototype.toString,
      n = /^\s*class\b/,
      s = function s(e) {
    try {
      var t = r.call(e);
      return n.test(t);
    } catch (e) {
      return !1;
    }
  },
      o = Object.prototype.toString,
      i = "function" == typeof Symbol && "symbol" == typeof Symbol.toStringTag;

  e.exports = function (e) {
    if (!e) return !1;
    if ("function" != typeof e && "object" != typeof e) return !1;
    if ("function" == typeof e && !e.prototype) return !0;
    if (i) return function (e) {
      try {
        return !s(e) && (r.call(e), !0);
      } catch (e) {
        return !1;
      }
    }(e);
    if (s(e)) return !1;
    var t = o.call(e);
    return "[object Function]" === t || "[object GeneratorFunction]" === t;
  };
},
/*!**************************************************!*\
  !*** ./node_modules/es-abstract/GetIntrinsic.js ***!
  \**************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = Object.getOwnPropertyDescriptor ? function () {
    return Object.getOwnPropertyDescriptor(arguments, "callee").get;
  }() : function () {
    throw new TypeError();
  },
      n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator,
      s = Object.getPrototypeOf || function (e) {
    return e.__proto__;
  },
      o = void 0,
      i = "undefined" == typeof Uint8Array ? void 0 : s(Uint8Array),
      c = {
    "$ %Array%": Array,
    "$ %ArrayBuffer%": "undefined" == typeof ArrayBuffer ? void 0 : ArrayBuffer,
    "$ %ArrayBufferPrototype%": "undefined" == typeof ArrayBuffer ? void 0 : ArrayBuffer.prototype,
    "$ %ArrayIteratorPrototype%": n ? s([][Symbol.iterator]()) : void 0,
    "$ %ArrayPrototype%": Array.prototype,
    "$ %ArrayProto_entries%": Array.prototype.entries,
    "$ %ArrayProto_forEach%": Array.prototype.forEach,
    "$ %ArrayProto_keys%": Array.prototype.keys,
    "$ %ArrayProto_values%": Array.prototype.values,
    "$ %AsyncFromSyncIteratorPrototype%": void 0,
    "$ %AsyncFunction%": void 0,
    "$ %AsyncFunctionPrototype%": void 0,
    "$ %AsyncGenerator%": void 0,
    "$ %AsyncGeneratorFunction%": void 0,
    "$ %AsyncGeneratorPrototype%": void 0,
    "$ %AsyncIteratorPrototype%": o && n && Symbol.asyncIterator ? o[Symbol.asyncIterator]() : void 0,
    "$ %Atomics%": "undefined" == typeof Atomics ? void 0 : Atomics,
    "$ %Boolean%": Boolean,
    "$ %BooleanPrototype%": Boolean.prototype,
    "$ %DataView%": "undefined" == typeof DataView ? void 0 : DataView,
    "$ %DataViewPrototype%": "undefined" == typeof DataView ? void 0 : DataView.prototype,
    "$ %Date%": Date,
    "$ %DatePrototype%": Date.prototype,
    "$ %decodeURI%": decodeURI,
    "$ %decodeURIComponent%": decodeURIComponent,
    "$ %encodeURI%": encodeURI,
    "$ %encodeURIComponent%": encodeURIComponent,
    "$ %Error%": Error,
    "$ %ErrorPrototype%": Error.prototype,
    "$ %eval%": eval,
    "$ %EvalError%": EvalError,
    "$ %EvalErrorPrototype%": EvalError.prototype,
    "$ %Float32Array%": "undefined" == typeof Float32Array ? void 0 : Float32Array,
    "$ %Float32ArrayPrototype%": "undefined" == typeof Float32Array ? void 0 : Float32Array.prototype,
    "$ %Float64Array%": "undefined" == typeof Float64Array ? void 0 : Float64Array,
    "$ %Float64ArrayPrototype%": "undefined" == typeof Float64Array ? void 0 : Float64Array.prototype,
    "$ %Function%": Function,
    "$ %FunctionPrototype%": Function.prototype,
    "$ %Generator%": void 0,
    "$ %GeneratorFunction%": void 0,
    "$ %GeneratorPrototype%": void 0,
    "$ %Int8Array%": "undefined" == typeof Int8Array ? void 0 : Int8Array,
    "$ %Int8ArrayPrototype%": "undefined" == typeof Int8Array ? void 0 : Int8Array.prototype,
    "$ %Int16Array%": "undefined" == typeof Int16Array ? void 0 : Int16Array,
    "$ %Int16ArrayPrototype%": "undefined" == typeof Int16Array ? void 0 : Int8Array.prototype,
    "$ %Int32Array%": "undefined" == typeof Int32Array ? void 0 : Int32Array,
    "$ %Int32ArrayPrototype%": "undefined" == typeof Int32Array ? void 0 : Int32Array.prototype,
    "$ %isFinite%": isFinite,
    "$ %isNaN%": isNaN,
    "$ %IteratorPrototype%": n ? s(s([][Symbol.iterator]())) : void 0,
    "$ %JSON%": JSON,
    "$ %JSONParse%": JSON.parse,
    "$ %Map%": "undefined" == typeof Map ? void 0 : Map,
    "$ %MapIteratorPrototype%": "undefined" != typeof Map && n ? s(new Map()[Symbol.iterator]()) : void 0,
    "$ %MapPrototype%": "undefined" == typeof Map ? void 0 : Map.prototype,
    "$ %Math%": Math,
    "$ %Number%": Number,
    "$ %NumberPrototype%": Number.prototype,
    "$ %Object%": Object,
    "$ %ObjectPrototype%": Object.prototype,
    "$ %ObjProto_toString%": Object.prototype.toString,
    "$ %ObjProto_valueOf%": Object.prototype.valueOf,
    "$ %parseFloat%": parseFloat,
    "$ %parseInt%": parseInt,
    "$ %Promise%": "undefined" == typeof Promise ? void 0 : Promise,
    "$ %PromisePrototype%": "undefined" == typeof Promise ? void 0 : Promise.prototype,
    "$ %PromiseProto_then%": "undefined" == typeof Promise ? void 0 : Promise.prototype.then,
    "$ %Promise_all%": "undefined" == typeof Promise ? void 0 : Promise.all,
    "$ %Promise_reject%": "undefined" == typeof Promise ? void 0 : Promise.reject,
    "$ %Promise_resolve%": "undefined" == typeof Promise ? void 0 : Promise.resolve,
    "$ %Proxy%": "undefined" == typeof Proxy ? void 0 : Proxy,
    "$ %RangeError%": RangeError,
    "$ %RangeErrorPrototype%": RangeError.prototype,
    "$ %ReferenceError%": ReferenceError,
    "$ %ReferenceErrorPrototype%": ReferenceError.prototype,
    "$ %Reflect%": "undefined" == typeof Reflect ? void 0 : Reflect,
    "$ %RegExp%": RegExp,
    "$ %RegExpPrototype%": RegExp.prototype,
    "$ %Set%": "undefined" == typeof Set ? void 0 : Set,
    "$ %SetIteratorPrototype%": "undefined" != typeof Set && n ? s(new Set()[Symbol.iterator]()) : void 0,
    "$ %SetPrototype%": "undefined" == typeof Set ? void 0 : Set.prototype,
    "$ %SharedArrayBuffer%": "undefined" == typeof SharedArrayBuffer ? void 0 : SharedArrayBuffer,
    "$ %SharedArrayBufferPrototype%": "undefined" == typeof SharedArrayBuffer ? void 0 : SharedArrayBuffer.prototype,
    "$ %String%": String,
    "$ %StringIteratorPrototype%": n ? s(""[Symbol.iterator]()) : void 0,
    "$ %StringPrototype%": String.prototype,
    "$ %Symbol%": n ? Symbol : void 0,
    "$ %SymbolPrototype%": n ? Symbol.prototype : void 0,
    "$ %SyntaxError%": SyntaxError,
    "$ %SyntaxErrorPrototype%": SyntaxError.prototype,
    "$ %ThrowTypeError%": r,
    "$ %TypedArray%": i,
    "$ %TypedArrayPrototype%": i ? i.prototype : void 0,
    "$ %TypeError%": TypeError,
    "$ %TypeErrorPrototype%": TypeError.prototype,
    "$ %Uint8Array%": "undefined" == typeof Uint8Array ? void 0 : Uint8Array,
    "$ %Uint8ArrayPrototype%": "undefined" == typeof Uint8Array ? void 0 : Uint8Array.prototype,
    "$ %Uint8ClampedArray%": "undefined" == typeof Uint8ClampedArray ? void 0 : Uint8ClampedArray,
    "$ %Uint8ClampedArrayPrototype%": "undefined" == typeof Uint8ClampedArray ? void 0 : Uint8ClampedArray.prototype,
    "$ %Uint16Array%": "undefined" == typeof Uint16Array ? void 0 : Uint16Array,
    "$ %Uint16ArrayPrototype%": "undefined" == typeof Uint16Array ? void 0 : Uint16Array.prototype,
    "$ %Uint32Array%": "undefined" == typeof Uint32Array ? void 0 : Uint32Array,
    "$ %Uint32ArrayPrototype%": "undefined" == typeof Uint32Array ? void 0 : Uint32Array.prototype,
    "$ %URIError%": URIError,
    "$ %URIErrorPrototype%": URIError.prototype,
    "$ %WeakMap%": "undefined" == typeof WeakMap ? void 0 : WeakMap,
    "$ %WeakMapPrototype%": "undefined" == typeof WeakMap ? void 0 : WeakMap.prototype,
    "$ %WeakSet%": "undefined" == typeof WeakSet ? void 0 : WeakSet,
    "$ %WeakSetPrototype%": "undefined" == typeof WeakSet ? void 0 : WeakSet.prototype
  };

  e.exports = function (e, t) {
    if (arguments.length > 1 && "boolean" != typeof t) throw new TypeError('"allowMissing" argument must be a boolean');
    var a = "$ " + e;
    if (!(a in c)) throw new SyntaxError("intrinsic " + e + " does not exist!");
    if (void 0 === c[a] && !t) throw new TypeError("intrinsic " + e + " exists, but is not available. Please file an issue!");
    return c[a];
  };
},
/*!*****************************************!*\
  !*** ./node_modules/rustbn.js/index.js ***!
  \*****************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    var r = a(
    /*! ./lib/index.asm.js */
    667),
        n = r.cwrap("ec_add", "string", ["string"]),
        s = r.cwrap("ec_mul", "string", ["string"]),
        o = r.cwrap("ec_pairing", "string", ["string"]);
    e.exports = {
      add: function add(e) {
        return t.from(n(e.toString("hex")), "hex");
      },
      mul: function mul(e) {
        return t.from(s(e.toString("hex")), "hex");
      },
      pairing: function pairing(e) {
        return t.from(o(e.toString("hex")), "hex");
      }
    };
  }).call(this, a(
  /*! ./../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!****************************************!*\
  !*** ./node_modules/des.js/lib/des.js ***!
  \****************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  t.utils = a(
  /*! ./des/utils */
  674), t.Cipher = a(
  /*! ./des/cipher */
  675), t.DES = a(
  /*! ./des/des */
  676), t.CBC = a(
  /*! ./des/cbc */
  677), t.EDE = a(
  /*! ./des/ede */
  678);
},
/*!************************************************!*\
  !*** ./node_modules/browserify-aes/browser.js ***!
  \************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./encrypter */
  679),
      n = a(
  /*! ./decrypter */
  687),
      s = a(
  /*! ./modes/list.json */
  256);
  t.createCipher = t.Cipher = r.createCipher, t.createCipheriv = t.Cipheriv = r.createCipheriv, t.createDecipher = t.Decipher = n.createDecipher, t.createDecipheriv = t.Decipheriv = n.createDecipheriv, t.listCiphers = t.getCiphers = function () {
    return Object.keys(s);
  };
},
/*!****************************************************!*\
  !*** ./node_modules/browserify-aes/modes/index.js ***!
  \****************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = {
    ECB: a(
    /*! ./ecb */
    680),
    CBC: a(
    /*! ./cbc */
    681),
    CFB: a(
    /*! ./cfb */
    682),
    CFB8: a(
    /*! ./cfb8 */
    683),
    CFB1: a(
    /*! ./cfb1 */
    684),
    OFB: a(
    /*! ./ofb */
    685),
    CTR: a(
    /*! ./ctr */
    254),
    GCM: a(
    /*! ./ctr */
    254)
  },
      n = a(
  /*! ./list.json */
  256);

  for (var s in n) {
    n[s].module = r[n[s].mode];
  }

  e.exports = n;
},
/*!**********************************************!*\
  !*** ./node_modules/browserify-rsa/index.js ***!
  \**********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    var r = a(
    /*! bn.js */
    5),
        n = a(
    /*! randombytes */
    67);

    function s(e, a) {
      var n = function (e) {
        var t = o(e);
        return {
          blinder: t.toRed(r.mont(e.modulus)).redPow(new r(e.publicExponent)).fromRed(),
          unblinder: t.invm(e.modulus)
        };
      }(a),
          s = a.modulus.byteLength(),
          i = (r.mont(a.modulus), new r(e).mul(n.blinder).umod(a.modulus)),
          c = i.toRed(r.mont(a.prime1)),
          u = i.toRed(r.mont(a.prime2)),
          d = a.coefficient,
          f = a.prime1,
          l = a.prime2,
          h = c.redPow(a.exponent1),
          p = u.redPow(a.exponent2);

      h = h.fromRed(), p = p.fromRed();
      var b = h.isub(p).imul(d).umod(f);
      return b.imul(l), p.iadd(b), new t(p.imul(n.unblinder).umod(a.modulus).toArray(!1, s));
    }

    function o(e) {
      for (var t = e.modulus.byteLength(), a = new r(n(t)); a.cmp(e.modulus) >= 0 || !a.umod(e.prime1) || !a.umod(e.prime2);) {
        a = new r(n(t));
      }

      return a;
    }

    e.exports = s, s.getr = o;
  }).call(this, a(
  /*! ./../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!********************************************!*\
  !*** ./node_modules/lodash/_baseGetTag.js ***!
  \********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./_Symbol */
  270),
      n = a(
  /*! ./_getRawTag */
  735),
      s = a(
  /*! ./_objectToString */
  736),
      o = "[object Null]",
      i = "[object Undefined]",
      c = r ? r.toStringTag : void 0;

  e.exports = function (e) {
    return null == e ? void 0 === e ? i : o : c && c in Object(e) ? n(e) : s(e);
  };
},
/*!*********************************************!*\
  !*** ./node_modules/lodash/isObjectLike.js ***!
  \*********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = function (e) {
    return null != e && "object" == typeof e;
  };
},
/*!*******************************************************!*\
  !*** ./src/contract_wrappers/tokens/erc20_wrapper.ts ***!
  \*******************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r7,
      n = this && this.__extends || (_r7 = function r(e, t) {
    return (_r7 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r7(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      i = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var c = i(a(
  /*! lodash */
  0)),
      u = i(a(
  /*! ../contract_wrapper */
  44)),
      d = i(a(
  /*! ../../utils/assert */
  15)),
      f = a(
  /*! ../../utils/convert */
  16),
      l = function (e) {
    function t(t, a) {
      var r = e.call(this, t, a) || this;
      return r.name = function () {
        return s(r, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().name.callAsync()];
            }
          });
        });
      }, r.approve = function (e) {
        return s(r, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return d.default.isNonZeroETHAddressHex("spender", e.spender), [4, this.contract];

              case 1:
                return a = (t = o.sent().approve).sendTransactionAsync, r = [e.spender], n = f.valueToWei, s = [e.value], [4, this.decimals()];

              case 2:
                return [2, a.apply(t, r.concat([n.apply(void 0, s.concat([o.sent()])), e.txData, e.safetyFactor]))];
            }
          });
        });
      }, r.totalSupply = function () {
        return s(r, void 0, void 0, function () {
          var e, t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return e = f.weiToValue, [4, this.contract];

              case 1:
                return [4, a.sent().totalSupply.callAsync()];

              case 2:
                return t = [a.sent()], [4, this.decimals()];

              case 3:
                return [2, e.apply(void 0, t.concat([a.sent()]))];
            }
          });
        });
      }, r.transferFrom = function (e) {
        return s(r, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return d.default.isETHAddressHex("from", e.from), d.default.isNonZeroETHAddressHex("to", e.to), [4, this.contract];

              case 1:
                return a = (t = o.sent().transferFrom).sendTransactionAsync, r = [e.from, e.to], n = f.valueToWei, s = [e.value], [4, this.decimals()];

              case 2:
                return [2, a.apply(t, r.concat([n.apply(void 0, s.concat([o.sent()])), e.txData, e.safetyFactor]))];
            }
          });
        });
      }, r.decimals = function () {
        return s(r, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().decimals.callAsync()];
            }
          });
        });
      }, r.balanceOf = function (e) {
        return s(r, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return c.default.isUndefined(e) || c.default.isUndefined(e.owner) ? [3, 1] : (a = e.owner, [3, 3]);

              case 1:
                return [4, this.getDefaultFromAddress()];

              case 2:
                a = s.sent(), s.label = 3;

              case 3:
                return t = a, d.default.isETHAddressHex("owner", t), r = f.weiToValue, [4, this.contract];

              case 4:
                return [4, s.sent().balanceOf.callAsync(t)];

              case 5:
                return n = [s.sent()], [4, this.decimals()];

              case 6:
                return [2, r.apply(void 0, n.concat([s.sent()]))];
            }
          });
        });
      }, r.symbol = function () {
        return s(r, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().symbol.callAsync()];
            }
          });
        });
      }, r.transfer = function (e) {
        return s(r, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return d.default.isNonZeroETHAddressHex("to", e.to), [4, this.contract];

              case 1:
                return a = (t = o.sent().transfer).sendTransactionAsync, r = [e.to], n = f.valueToWei, s = [e.value], [4, this.decimals()];

              case 2:
                return [2, a.apply(t, r.concat([n.apply(void 0, s.concat([o.sent()])), e.txData, e.safetyFactor]))];
            }
          });
        });
      }, r.allowance = function (e) {
        return s(r, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return d.default.isETHAddressHex("owner", e.owner), d.default.isETHAddressHex("spender", e.spender), t = f.weiToValue, [4, this.contract];

              case 1:
                return [4, r.sent().allowance.callAsync(e.owner, e.spender)];

              case 2:
                return a = [r.sent()], [4, this.decimals()];

              case 3:
                return [2, t.apply(void 0, a.concat([r.sent()]))];
            }
          });
        });
      }, r.contract = a, r;
    }

    return n(t, e), t.prototype.isValidContract = function () {
      return s(this, void 0, void 0, function () {
        var e, t, a, r;
        return o(this, function (n) {
          switch (n.label) {
            case 0:
              return n.trys.push([0, 5,, 6]), [4, this.contract];

            case 1:
              return [4, (e = n.sent()).totalSupply.callAsync()];

            case 2:
              return t = n.sent(), [4, e.symbol.callAsync()];

            case 3:
              return a = n.sent(), [4, e.name.callAsync()];

            case 4:
              return r = n.sent(), "" === a || "" === r || t.isZero() ? [2, !1] : [2, !0];

            case 5:
              return n.sent(), [2, !1];

            case 6:
              return [2];
          }
        });
      });
    }, t;
  }(u.default);

  t.default = l;
},
/*!*******************************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/permission_manager/general_permission_manager_wrapper/common.ts ***!
  \*******************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r8,
      n = this && this.__extends || (_r8 = function r(e, t) {
    return (_r8 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r8(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      i = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var c = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      u = i(a(
  /*! lodash */
  0)),
      d = a(
  /*! @0x/json-schemas */
  2),
      f = i(a(
  /*! ../../../../utils/assert */
  15)),
      l = a(
  /*! ../../module_wrapper */
  17),
      h = a(
  /*! ../../../../types */
  4),
      p = a(
  /*! ../../../../utils/convert */
  16),
      b = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.perms = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return f.default.isETHAddressHex("module", e.module), f.default.isETHAddressHex("delegate", e.delegate), [4, this.contract];

              case 1:
                return [2, t.sent().perms.callAsync(e.module, e.delegate, p.stringToBytes32(e.permission))];
            }
          });
        });
      }, n.allDelegates = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, t.sent().allDelegates.callAsync(p.numberToBigNumber(e.delegateIndex))];
            }
          });
        });
      }, n.delegateDetails = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return f.default.isETHAddressHex("delegate", e.delegate), [4, this.contract];

              case 1:
                return [4, a.sent().delegateDetails.callAsync(e.delegate)];

              case 2:
                return t = a.sent(), [2, p.bytes32ToString(t)];
            }
          });
        });
      }, n.checkPermission = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return f.default.isETHAddressHex("delegate", e.delegate), f.default.isETHAddressHex("module", e.module), [4, this.contract];

              case 1:
                return [2, t.sent().checkPermission.callAsync(e.delegate, e.module, p.stringToBytes32(e.permission))];
            }
          });
        });
      }, n.addDelegate = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                return a.apply(t, [s.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), f.default.isNonZeroETHAddressHex("delegate", e.delegate), f.default.assert(e.details.length > 0, h.ErrorCode.InvalidData, "0 value not allowed"), n = (r = f.default).assert, [4, this.contract];

              case 2:
                return [4, s.sent().checkDelegate.callAsync(e.delegate)];

              case 3:
                return n.apply(r, [!s.sent(), h.ErrorCode.AlreadyExists, "Delegate already present"]), [4, this.contract];

              case 4:
                return [2, s.sent().addDelegate.sendTransactionAsync(e.delegate, p.stringToBytes32(e.details), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.deleteDelegate = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                return a.apply(t, [s.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), f.default.isNonZeroETHAddressHex("delegate", e.delegate), n = (r = f.default).assert, [4, this.contract];

              case 2:
                return [4, s.sent().checkDelegate.callAsync(e.delegate)];

              case 3:
                return n.apply(r, [s.sent(), h.ErrorCode.NotFound, "Delegate does not exist"]), [4, this.contract];

              case 4:
                return [2, s.sent().deleteDelegate.sendTransactionAsync(e.delegate, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.checkDelegate = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return f.default.isNonZeroETHAddressHex("delegate", e.delegate), [4, this.contract];

              case 1:
                return [2, t.sent().checkDelegate.callAsync(e.delegate)];
            }
          });
        });
      }, n.changePermission = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                return a.apply(t, [r.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), f.default.isNonZeroETHAddressHex("delegate", e.delegate), f.default.isETHAddressHex("module", e.module), [4, this.contract];

              case 2:
                return [2, r.sent().changePermission.sendTransactionAsync(e.delegate, e.module, p.stringToBytes32(e.perm), e.valid, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.changePermissionMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                return a.apply(t, [r.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), f.default.isNonZeroETHAddressHex("delegate", e.delegate), e.modules.forEach(function (e) {
                  return f.default.isETHAddressHex("modules", e);
                }), f.default.assert(e.modules.length > 0, h.ErrorCode.InvalidData, "0 length is not allowed"), f.default.assert(e.modules.length === e.perms.length, h.ErrorCode.MismatchedArrayLength, "Array length mismatch"), f.default.assert(e.valids.length === e.perms.length, h.ErrorCode.MismatchedArrayLength, "Array length mismatch"), [4, this.contract];

              case 2:
                return [2, r.sent().changePermissionMulti.sendTransactionAsync(e.delegate, e.modules, p.stringArrayToBytes32Array(e.perms), e.valids, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.getAllDelegatesWithPerm = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return f.default.isETHAddressHex("module", e.module), [4, this.contract];

              case 1:
                return [2, t.sent().getAllDelegatesWithPerm.callAsync(e.module, p.stringToBytes32(e.perm))];
            }
          });
        });
      }, n.getAllModulesAndPermsFromTypes = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return f.default.isETHAddressHex("delegate", e.delegate), [4, this.contract];

              case 1:
                return [4, s.sent().getAllModulesAndPermsFromTypes.callAsync(e.delegate, e.types)];

              case 2:
                return t = s.sent(), a = u.default.zip(t[0], t[1]), r = u.default.groupBy(a, function (e) {
                  return e[0];
                }), n = [], u.default.forEach(r, function (e, t) {
                  var a = {
                    module: t,
                    permissions: e.map(function (e) {
                      return p.parsePermBytes32Value(e[1]);
                    })
                  };
                  n.push(a);
                }), [2, n];
            }
          });
        });
      }, n.getAllDelegates = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().getAllDelegates.callAsync()];
            }
          });
        });
      }, n.subscribeAsync = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return f.default.doesBelongToStringEnum("eventName", e.eventName, c.GeneralPermissionManagerEvents_3_0_0), f.default.doesConformToSchema("indexFilterValues", e.indexFilterValues, d.schemas.indexFilterValuesSchema), f.default.isFunction("callback", e.callback), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.subscribeInternal(t, e.eventName, e.indexFilterValues, e.callback, e.isVerbose)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.getLogsAsync = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return f.default.doesBelongToStringEnum("eventName", e.eventName, c.GeneralPermissionManagerEvents_3_0_0), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.getLogsAsyncInternal(t, e.eventName, e.blockRange, e.indexFilterValues)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.contract = a, n;
    }

    return n(t, e), t;
  }(l.ModuleCommon);

  t.default = b, t.isGeneralPermissionManager = function (e) {
    return e instanceof b;
  };
},
/*!************************************************************************!*\
  !*** ./src/contract_wrappers/modules/sto/capped_sto_wrapper/common.ts ***!
  \************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r9,
      n = this && this.__extends || (_r9 = function r(e, t) {
    return (_r9 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r9(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      c = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var u = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      d = a(
  /*! @0x/json-schemas */
  2),
      f = c(a(
  /*! ../../../../utils/assert */
  15)),
      l = a(
  /*! ../sto_wrapper */
  68),
      h = a(
  /*! ../../../../types */
  4),
      p = a(
  /*! ../../../../utils/convert */
  16),
      b = c(a(
  /*! ../../../../utils/functions_utils */
  40)),
      m = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.rate = function () {
        return o(n, void 0, void 0, function () {
          var e;
          return i(this, function (t) {
            switch (t.label) {
              case 0:
                return e = p.weiToValue, [4, this.contract];

              case 1:
                return [4, t.sent().rate.callAsync()];

              case 2:
                return [2, e.apply(void 0, [t.sent(), h.FULL_DECIMALS])];
            }
          });
        });
      }, n.cap = function () {
        return o(n, void 0, void 0, function () {
          var e, t;
          return i(this, function (a) {
            switch (a.label) {
              case 0:
                return e = p.weiToValue, [4, this.contract];

              case 1:
                return [4, a.sent().cap.callAsync()];

              case 2:
                return t = [a.sent()], [4, this.securityTokenContract()];

              case 3:
                return [4, a.sent().decimals.callAsync()];

              case 4:
                return [2, e.apply(void 0, t.concat([a.sent()]))];
            }
          });
        });
      }, n.allowBeneficialInvestments = function () {
        return o(n, void 0, void 0, function () {
          return i(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().allowBeneficialInvestments.callAsync()];
            }
          });
        });
      }, n.investors = function (e) {
        return o(n, void 0, void 0, function () {
          return i(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, t.sent().investors.callAsync(e.investorAddress)];
            }
          });
        });
      }, n.changeAllowBeneficialInvestments = function (e) {
        return o(n, void 0, void 0, function () {
          var t, a, r, n;
          return i(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.isCallerTheSecurityTokenOwner(e.txData)];

              case 1:
                return a.apply(t, [s.sent(), h.ErrorCode.Unauthorized, "The caller must be the ST owner"]), n = (r = f.default).assert, [4, this.allowBeneficialInvestments()];

              case 2:
                return n.apply(r, [s.sent() !== e.allowBeneficialInvestments, h.ErrorCode.PreconditionRequired, "Does not change value"]), [4, this.contract];

              case 3:
                return [2, s.sent().changeAllowBeneficialInvestments.sendTransactionAsync(e.allowBeneficialInvestments, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.buyTokens = function (e) {
        return o(n, void 0, void 0, function () {
          var t, a, r, n, o, c, u, d, l, m, y, v, _, g, A, w, T;

          return i(this, function (i) {
            switch (i.label) {
              case 0:
                return f.default.isNonZeroETHAddressHex("beneficiary", e.beneficiary), a = (t = f.default).assert, [4, this.paused()];

              case 1:
                return a.apply(t, [!i.sent(), h.ErrorCode.ContractPaused, "Should not be paused"]), f.default.isBigNumberGreaterThanZero(e.value, "Amount invested should not be equal to 0"), o = (n = this.web3Wrapper).getBalanceInWeiAsync, [4, this.getCallerAddress(e.txData)];

              case 2:
                return [4, o.apply(n, [i.sent()])];

              case 3:
                return r = i.sent(), f.default.assert(r.isGreaterThan(p.valueToWei(e.value, h.FULL_DECIMALS)), h.ErrorCode.InsufficientBalance, "Insufficient ETH funds"), u = (c = f.default).assert, [4, this.fundRaiseTypes({
                  type: h.FundRaiseType.ETH
                })];

              case 4:
                return u.apply(c, [i.sent(), h.ErrorCode.DifferentMode, "Mode of investment is not ETH"]), [4, this.allowBeneficialInvestments()];

              case 5:
                return i.sent() ? (l = (d = f.default).assert, y = (m = b.default).checksumAddressComparision, v = [e.beneficiary], [4, this.getCallerAddress(e.txData)]) : [3, 7];

              case 6:
                l.apply(d, [y.apply(m, v.concat([i.sent()])), h.ErrorCode.Unauthorized, "Beneficiary address does not match msg.sender"]), i.label = 7;

              case 7:
                return g = (_ = f.default).isPastDate, [4, this.startTime()];

              case 8:
                return g.apply(_, [i.sent(), "Offering is not yet started"]), w = (A = f.default).isFutureDate, [4, this.endTime()];

              case 9:
                return w.apply(A, [i.sent(), "Offering is closed"]), T = s({}, e.txData, {
                  value: p.valueToWei(e.value, h.FULL_DECIMALS)
                }), [4, this.contract];

              case 10:
                return [2, i.sent().buyTokens.sendTransactionAsync(e.beneficiary, T, e.safetyFactor)];
            }
          });
        });
      }, n.buyTokensWithPoly = function (e) {
        return o(n, void 0, void 0, function () {
          var t, a, r, n, s, o, c, u, d, l, b;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                return f.default.isBigNumberGreaterThanZero(e.investedPOLY, "Amount invested should not be equal to 0"), a = (t = f.default).assert, [4, this.paused()];

              case 1:
                return a.apply(t, [!i.sent(), h.ErrorCode.ContractPaused, "Should not be paused"]), n = (r = f.default).assert, [4, this.fundRaiseTypes({
                  type: h.FundRaiseType.POLY
                })];

              case 2:
                return n.apply(r, [i.sent(), h.ErrorCode.DifferentMode, "Mode of investment is not POLY"]), [4, this.polyTokenContract()];

              case 3:
                return c = (o = i.sent().balanceOf).callAsync, [4, this.getCallerAddress(e.txData)];

              case 4:
                return [4, c.apply(o, [i.sent()])];

              case 5:
                return s = i.sent(), f.default.assert(s.isGreaterThanOrEqualTo(p.valueToWei(e.investedPOLY, h.FULL_DECIMALS)), h.ErrorCode.InvalidTransfer, "Budget less than amount unable to transfer fee"), d = (u = f.default).isPastDate, [4, this.startTime()];

              case 6:
                return d.apply(u, [i.sent(), "Offering is not yet started"]), b = (l = f.default).isFutureDate, [4, this.endTime()];

              case 7:
                return b.apply(l, [i.sent(), "Offering is closed"]), [4, this.contract];

              case 8:
                return [2, i.sent().buyTokensWithPoly.sendTransactionAsync(p.valueToWei(e.investedPOLY, h.FULL_DECIMALS), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.capReached = function () {
        return o(n, void 0, void 0, function () {
          return i(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().capReached.callAsync()];
            }
          });
        });
      }, n.getTokensSold = function () {
        return o(n, void 0, void 0, function () {
          var e, t;
          return i(this, function (a) {
            switch (a.label) {
              case 0:
                return e = p.weiToValue, [4, this.contract];

              case 1:
                return [4, a.sent().getTokensSold.callAsync()];

              case 2:
                return t = [a.sent()], [4, this.securityTokenContract()];

              case 3:
                return [4, a.sent().decimals.callAsync()];

              case 4:
                return [2, e.apply(void 0, t.concat([a.sent()]))];
            }
          });
        });
      }, n.subscribeAsync = function (e) {
        return o(n, void 0, void 0, function () {
          var t;
          return i(this, function (a) {
            switch (a.label) {
              case 0:
                return f.default.doesBelongToStringEnum("eventName", e.eventName, u.CappedSTOEvents_3_0_0), f.default.doesConformToSchema("indexFilterValues", e.indexFilterValues, d.schemas.indexFilterValuesSchema), f.default.isFunction("callback", e.callback), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.subscribeInternal(t, e.eventName, e.indexFilterValues, e.callback, e.isVerbose)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.getLogsAsync = function (e) {
        return o(n, void 0, void 0, function () {
          var t;
          return i(this, function (a) {
            switch (a.label) {
              case 0:
                return f.default.doesBelongToStringEnum("eventName", e.eventName, u.CappedSTOEvents_3_0_0), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.getLogsAsyncInternal(t, e.eventName, e.blockRange, e.indexFilterValues)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.contract = a, n;
    }

    return n(t, e), t;
  }(l.STOCommon);

  t.default = m, t.isCappedSTO = function (e) {
    return e instanceof m;
  };
},
/*!****************************************************************************!*\
  !*** ./src/contract_wrappers/modules/sto/usd_tiered_sto_wrapper/common.ts ***!
  \****************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r10,
      n = this && this.__extends || (_r10 = function r(e, t) {
    return (_r10 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r10(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      c = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var u = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      d = a(
  /*! @0x/json-schemas */
  2),
      f = c(a(
  /*! ../../../../utils/assert */
  15)),
      l = a(
  /*! ../sto_wrapper */
  68),
      h = a(
  /*! ../../../../types */
  4),
      p = a(
  /*! ../../../../utils/convert */
  16),
      b = c(a(
  /*! ../../../../utils/functions_utils */
  40)),
      m = a(
  /*! ../../transfer_manager/general_transfer_manager_wrapper */
  146),
      y = new u.BigNumber(0),
      v = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.generalTransferManagerContract = function (e) {
        return o(n, void 0, void 0, function () {
          return i(this, function (t) {
            return [2, this.contractFactory.getGeneralTransferManagerContract(e, h.ContractVersion.V3_0_0)];
          });
        });
      }, n.allowBeneficialInvestments = function () {
        return o(n, void 0, void 0, function () {
          return i(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().allowBeneficialInvestments.callAsync()];
            }
          });
        });
      }, n.finalAmountReturned = function () {
        return o(n, void 0, void 0, function () {
          var e, t;
          return i(this, function (a) {
            switch (a.label) {
              case 0:
                return e = p.weiToValue, [4, this.contract];

              case 1:
                return [4, a.sent().finalAmountReturned.callAsync()];

              case 2:
                return t = [a.sent()], [4, this.securityTokenContract()];

              case 3:
                return [4, a.sent().decimals.callAsync()];

              case 4:
                return [2, e.apply(void 0, t.concat([a.sent()]))];
            }
          });
        });
      }, n.investorInvested = function (e) {
        return o(n, void 0, void 0, function () {
          var t;
          return i(this, function (a) {
            switch (a.label) {
              case 0:
                return f.default.isETHAddressHex("investorAddress", e.investorAddress), t = p.weiToValue, [4, this.contract];

              case 1:
                return [4, a.sent().investorInvested.callAsync(e.investorAddress, e.fundRaiseType)];

              case 2:
                return [2, t.apply(void 0, [a.sent(), h.FULL_DECIMALS])];
            }
          });
        });
      }, n.investorInvestedUSD = function (e) {
        return o(n, void 0, void 0, function () {
          var t;
          return i(this, function (a) {
            switch (a.label) {
              case 0:
                return f.default.isETHAddressHex("investorAddress", e.investorAddress), t = p.weiToValue, [4, this.contract];

              case 1:
                return [4, a.sent().investorInvestedUSD.callAsync(e.investorAddress)];

              case 2:
                return [2, t.apply(void 0, [a.sent(), h.FULL_DECIMALS])];
            }
          });
        });
      }, n.changeAllowBeneficialInvestments = function (e) {
        return o(n, void 0, void 0, function () {
          var t, a, r, n, s;
          return i(this, function (o) {
            switch (o.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.isCallerTheSecurityTokenOwner(e.txData)];

              case 1:
                return a.apply(t, [o.sent(), h.ErrorCode.Unauthorized, "The caller must be the ST owner"]), n = (r = f.default).assert, s = e.allowBeneficialInvestments, [4, this.allowBeneficialInvestments()];

              case 2:
                return n.apply(r, [s !== o.sent(), h.ErrorCode.PreconditionRequired, "The value must be different"]), [4, this.contract];

              case 3:
                return [2, o.sent().changeAllowBeneficialInvestments.sendTransactionAsync(e.allowBeneficialInvestments, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.buyWithETH = function (e) {
        return o(n, void 0, void 0, function () {
          var t, a, r, n;
          return i(this, function (o) {
            switch (o.label) {
              case 0:
                return f.default.isETHAddressHex("beneficiary", e.beneficiary), t = p.valueToWei(e.value, h.FULL_DECIMALS), a = this.checkIfBuyIsValid, r = [e.beneficiary], [4, this.getCallerAddress(e.txData)];

              case 1:
                return [4, a.apply(this, r.concat([o.sent(), t, h.FundRaiseType.ETH]))];

              case 2:
                return o.sent(), n = s({}, e.txData, {
                  value: t
                }), [4, this.contract];

              case 3:
                return [2, o.sent().buyWithETH.sendTransactionAsync(e.beneficiary, n, e.safetyFactor)];
            }
          });
        });
      }, n.buyWithPOLY = function (e) {
        return o(n, void 0, void 0, function () {
          var t, a, r;
          return i(this, function (n) {
            switch (n.label) {
              case 0:
                return f.default.isETHAddressHex("beneficiary", e.beneficiary), t = p.valueToWei(e.investedPOLY, h.FULL_DECIMALS), a = this.checkIfBuyIsValid, r = [e.beneficiary], [4, this.getCallerAddress(e.txData)];

              case 1:
                return [4, a.apply(this, r.concat([n.sent(), t, h.FundRaiseType.POLY]))];

              case 2:
                return n.sent(), [4, this.contract];

              case 3:
                return [2, n.sent().buyWithPOLY.sendTransactionAsync(e.beneficiary, t, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.buyWithUSD = function (e) {
        return o(n, void 0, void 0, function () {
          var t, a, r, n;
          return i(this, function (s) {
            switch (s.label) {
              case 0:
                return f.default.isETHAddressHex("beneficiary", e.beneficiary), f.default.isETHAddressHex("usdToken", e.usdToken), [4, this.contractFactory.getERC20DetailedContract(e.usdToken)];

              case 1:
                return [4, s.sent().decimals.callAsync()];

              case 2:
                return t = s.sent(), a = p.valueToWei(e.investedSC, t), r = this.checkIfBuyIsValid, n = [e.beneficiary], [4, this.getCallerAddress(e.txData)];

              case 3:
                return [4, r.apply(this, n.concat([s.sent(), a, h.FundRaiseType.StableCoin, e.usdToken]))];

              case 4:
                return s.sent(), [4, this.contract];

              case 5:
                return [2, s.sent().buyWithUSD.sendTransactionAsync(e.beneficiary, a, e.usdToken, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.buyWithETHRateLimited = function (e) {
        return o(n, void 0, void 0, function () {
          var t, a, r, n;
          return i(this, function (o) {
            switch (o.label) {
              case 0:
                return t = p.valueToWei(e.value, h.FULL_DECIMALS), a = this.checkIfBuyIsValid, r = [e.beneficiary], [4, this.getCallerAddress(e.txData)];

              case 1:
                return [4, a.apply(this, r.concat([o.sent(), t, h.FundRaiseType.ETH]))];

              case 2:
                return o.sent(), n = s({}, e.txData, {
                  value: t
                }), [4, this.contract];

              case 3:
                return [2, o.sent().buyWithETHRateLimited.sendTransactionAsync(e.beneficiary, e.minTokens, n, e.safetyFactor)];
            }
          });
        });
      }, n.buyWithPOLYRateLimited = function (e) {
        return o(n, void 0, void 0, function () {
          var t, a, r;
          return i(this, function (n) {
            switch (n.label) {
              case 0:
                return t = p.valueToWei(e.investedPOLY, h.FULL_DECIMALS), a = this.checkIfBuyIsValid, r = [e.beneficiary], [4, this.getCallerAddress(e.txData)];

              case 1:
                return [4, a.apply(this, r.concat([n.sent(), t, h.FundRaiseType.POLY]))];

              case 2:
                return n.sent(), [4, this.contract];

              case 3:
                return [2, n.sent().buyWithPOLYRateLimited.sendTransactionAsync(e.beneficiary, t, e.minTokens, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.buyWithUSDRateLimited = function (e) {
        return o(n, void 0, void 0, function () {
          var t, a, r, n;
          return i(this, function (s) {
            switch (s.label) {
              case 0:
                return [4, this.contractFactory.getERC20DetailedContract(e.usdToken)];

              case 1:
                return [4, s.sent().decimals.callAsync()];

              case 2:
                return t = s.sent(), a = p.valueToWei(e.investedSC, t), r = this.checkIfBuyIsValid, n = [e.beneficiary], [4, this.getCallerAddress(e.txData)];

              case 3:
                return [4, r.apply(this, n.concat([s.sent(), a, h.FundRaiseType.StableCoin, e.usdToken]))];

              case 4:
                return s.sent(), [4, this.contract];

              case 5:
                return [2, s.sent().buyWithUSDRateLimited.sendTransactionAsync(e.beneficiary, a, e.minTokens, e.usdToken, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.isOpen = function () {
        return o(n, void 0, void 0, function () {
          return i(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().isOpen.callAsync()];
            }
          });
        });
      }, n.capReached = function () {
        return o(n, void 0, void 0, function () {
          return i(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().capReached.callAsync()];
            }
          });
        });
      }, n.getRate = function (e) {
        return o(n, void 0, void 0, function () {
          var t;
          return i(this, function (a) {
            switch (a.label) {
              case 0:
                return t = p.weiToValue, [4, this.contract];

              case 1:
                return [4, a.sent().getRate.callAsync(e.fundRaiseType)];

              case 2:
                return [2, t.apply(void 0, [a.sent(), h.FULL_DECIMALS])];
            }
          });
        });
      }, n.convertFromUSD = function (e) {
        return o(n, void 0, void 0, function () {
          var t;
          return i(this, function (a) {
            switch (a.label) {
              case 0:
                return t = p.weiToValue, [4, this.contract];

              case 1:
                return [4, a.sent().convertFromUSD.callAsync(e.fundRaiseType, p.valueToWei(e.amount, h.FULL_DECIMALS))];

              case 2:
                return [2, t.apply(void 0, [a.sent(), h.FULL_DECIMALS])];
            }
          });
        });
      }, n.getTokensMinted = function () {
        return o(n, void 0, void 0, function () {
          var e, t;
          return i(this, function (a) {
            switch (a.label) {
              case 0:
                return e = p.weiToValue, [4, this.contract];

              case 1:
                return [4, a.sent().getTokensMinted.callAsync()];

              case 2:
                return t = [a.sent()], [4, this.securityTokenContract()];

              case 3:
                return [4, a.sent().decimals.callAsync()];

              case 4:
                return [2, e.apply(void 0, t.concat([a.sent()]))];
            }
          });
        });
      }, n.getSTODetails = function () {
        return o(n, void 0, void 0, function () {
          var e, t;
          return i(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, a.sent().getSTODetails.callAsync()];

              case 2:
                return e = a.sent(), [4, this.securityTokenContract()];

              case 3:
                return [4, a.sent().decimals.callAsync()];

              case 4:
                return t = a.sent(), [2, {
                  startTime: p.bigNumberToDate(e[0]),
                  endTime: p.bigNumberToDate(e[1]),
                  currentTier: new u.BigNumber(e[2]).toNumber(),
                  capPerTier: p.weiArrayToValueArray(e[3], t),
                  ratePerTier: p.weiArrayToValueArray(e[4], h.FULL_DECIMALS),
                  fundsRaised: p.weiToValue(e[5], h.FULL_DECIMALS),
                  investorCount: e[6].toNumber(),
                  tokensSold: p.weiToValue(e[7], t),
                  isRaisedInETH: e[8][0],
                  isRaisedInPOLY: e[8][1],
                  isRaisedInSC: e[8][2]
                }];
            }
          });
        });
      }, n.currentTier = function () {
        return o(n, void 0, void 0, function () {
          return i(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, e.sent().currentTier.callAsync()];

              case 2:
                return [2, e.sent().toNumber()];
            }
          });
        });
      }, n.nonAccreditedLimitUSD = function () {
        return o(n, void 0, void 0, function () {
          var e;
          return i(this, function (t) {
            switch (t.label) {
              case 0:
                return e = p.weiToValue, [4, this.contract];

              case 1:
                return [4, t.sent().nonAccreditedLimitUSD.callAsync()];

              case 2:
                return [2, e.apply(void 0, [t.sent(), h.FULL_DECIMALS])];
            }
          });
        });
      }, n.minimumInvestmentUSD = function () {
        return o(n, void 0, void 0, function () {
          var e;
          return i(this, function (t) {
            switch (t.label) {
              case 0:
                return e = p.weiToValue, [4, this.contract];

              case 1:
                return [4, t.sent().minimumInvestmentUSD.callAsync()];

              case 2:
                return [2, e.apply(void 0, [t.sent(), h.FULL_DECIMALS])];
            }
          });
        });
      }, n.getTokensSold = function () {
        return o(n, void 0, void 0, function () {
          var e, t;
          return i(this, function (a) {
            switch (a.label) {
              case 0:
                return e = p.weiToValue, [4, this.contract];

              case 1:
                return [4, a.sent().getTokensSold.callAsync()];

              case 2:
                return t = [a.sent()], [4, this.securityTokenContract()];

              case 3:
                return [4, a.sent().decimals.callAsync()];

              case 4:
                return [2, e.apply(void 0, t.concat([a.sent()]))];
            }
          });
        });
      }, n.getNumberOfTiers = function () {
        return o(n, void 0, void 0, function () {
          return i(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, e.sent().getNumberOfTiers.callAsync()];

              case 2:
                return [2, e.sent().toNumber()];
            }
          });
        });
      }, n.getUsdTokens = function () {
        return o(n, void 0, void 0, function () {
          return i(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().getUsdTokens.callAsync()];
            }
          });
        });
      }, n.fundsRaisedUSD = function () {
        return o(n, void 0, void 0, function () {
          var e;
          return i(this, function (t) {
            switch (t.label) {
              case 0:
                return e = p.weiToValue, [4, this.contract];

              case 1:
                return [4, t.sent().fundsRaisedUSD.callAsync()];

              case 2:
                return [2, e.apply(void 0, [t.sent(), h.FULL_DECIMALS])];
            }
          });
        });
      }, n.convertToUSD = function (e) {
        return o(n, void 0, void 0, function () {
          var t;
          return i(this, function (a) {
            switch (a.label) {
              case 0:
                return t = p.weiToValue, [4, this.contract];

              case 1:
                return [4, a.sent().convertToUSD.callAsync(e.fundRaiseType, p.valueToWei(e.amount, h.FULL_DECIMALS))];

              case 2:
                return [2, t.apply(void 0, [a.sent(), h.FULL_DECIMALS])];
            }
          });
        });
      }, n.getTokensSoldFor = function (e) {
        return o(n, void 0, void 0, function () {
          var t, a;
          return i(this, function (r) {
            switch (r.label) {
              case 0:
                return t = p.weiToValue, [4, this.contract];

              case 1:
                return [4, r.sent().getTokensSoldFor.callAsync(e.fundRaiseType)];

              case 2:
                return a = [r.sent()], [4, this.securityTokenContract()];

              case 3:
                return [4, r.sent().decimals.callAsync()];

              case 4:
                return [2, t.apply(void 0, a.concat([r.sent()]))];
            }
          });
        });
      }, n.stableCoinsRaised = function (e) {
        return o(n, void 0, void 0, function () {
          var t;
          return i(this, function (a) {
            switch (a.label) {
              case 0:
                return f.default.isETHAddressHex("stableCoinAddress", e.stableCoinAddress), t = p.weiToValue, [4, this.contract];

              case 1:
                return [4, a.sent().stableCoinsRaised.callAsync(e.stableCoinAddress)];

              case 2:
                return [2, t.apply(void 0, [a.sent(), h.FULL_DECIMALS])];
            }
          });
        });
      }, n.changeNonAccreditedLimit = function (e) {
        return o(n, void 0, void 0, function () {
          var t, a;
          return i(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.isCallerTheSecurityTokenOwner(e.txData)];

              case 1:
                return a.apply(t, [r.sent(), h.ErrorCode.Unauthorized, "The caller must be the ST owner"]), e.investors.forEach(function (e) {
                  return f.default.isETHAddressHex("investors", e);
                }), f.default.assert(e.investors.length === e.nonAccreditedLimit.length, h.ErrorCode.MismatchedArrayLength, "Array length mismatch"), [4, this.contract];

              case 2:
                return [2, r.sent().changeNonAccreditedLimit.sendTransactionAsync(e.investors, p.valueArrayToWeiArray(e.nonAccreditedLimit, h.FULL_DECIMALS), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.modifyTimes = function (e) {
        return o(n, void 0, void 0, function () {
          var t, a, r, n;
          return i(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.isCallerTheSecurityTokenOwner(e.txData)];

              case 1:
                return a.apply(t, [s.sent(), h.ErrorCode.Unauthorized, "The caller must be the ST owner"]), n = (r = f.default).isFutureDate, [4, this.startTime()];

              case 2:
                return n.apply(r, [s.sent(), "STO already started"]), f.default.assert(e.endTime > e.startTime, h.ErrorCode.TooEarly, "End time must be greater than start time"), f.default.isFutureDate(e.startTime, "Start date must be in the future"), [4, this.contract];

              case 3:
                return [2, s.sent().modifyTimes.sendTransactionAsync(p.dateToBigNumber(e.startTime), p.dateToBigNumber(e.endTime), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.modifyLimits = function (e) {
        return o(n, void 0, void 0, function () {
          var t, a, r, n;
          return i(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.isCallerTheSecurityTokenOwner(e.txData)];

              case 1:
                return a.apply(t, [s.sent(), h.ErrorCode.Unauthorized, "The caller must be the ST owner"]), n = (r = f.default).isFutureDate, [4, this.startTime()];

              case 2:
                return n.apply(r, [s.sent(), "STO already started"]), [4, this.contract];

              case 3:
                return [2, s.sent().modifyLimits.sendTransactionAsync(p.valueToWei(e.nonAccreditedLimitUSD, h.FULL_DECIMALS), p.valueToWei(e.minimumInvestmentUSD, h.FULL_DECIMALS), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.modifyFunding = function (e) {
        return o(n, void 0, void 0, function () {
          var t, a, r, n;
          return i(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.isCallerTheSecurityTokenOwner(e.txData)];

              case 1:
                return a.apply(t, [s.sent(), h.ErrorCode.Unauthorized, "The caller must be the ST owner"]), n = (r = f.default).isFutureDate, [4, this.startTime()];

              case 2:
                return n.apply(r, [s.sent(), "STO already started"]), [4, this.contract];

              case 3:
                return [2, s.sent().modifyFunding.sendTransactionAsync(e.fundRaiseTypes, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.modifyAddresses = function (e) {
        return o(n, void 0, void 0, function () {
          var t, a;
          return i(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.isCallerTheSecurityTokenOwner(e.txData)];

              case 1:
                return a.apply(t, [r.sent(), h.ErrorCode.Unauthorized, "The caller must be the ST owner"]), e.stableTokens.forEach(function (e) {
                  return f.default.isETHAddressHex("stableTokens", e);
                }), f.default.isNonZeroETHAddressHex("wallet", e.wallet), f.default.isNonZeroETHAddressHex("treasuryWallet", e.treasuryWallet), [4, this.contract];

              case 2:
                return [2, r.sent().modifyAddresses.sendTransactionAsync(e.wallet, e.treasuryWallet, e.stableTokens, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.modifyTiers = function (e) {
        return o(n, void 0, void 0, function () {
          var t, a, r, n, s, o;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.isCallerTheSecurityTokenOwner(e.txData)];

              case 1:
                return a.apply(t, [i.sent(), h.ErrorCode.Unauthorized, "The caller must be the ST owner"]), n = (r = f.default).isFutureDate, [4, this.startTime()];

              case 2:
                for (n.apply(r, [i.sent(), "STO already started"]), f.default.assert(e.tokensPerTierTotal.length > 0, h.ErrorCode.InvalidData, "No tiers provided"), f.default.assert(e.ratePerTier.length === e.tokensPerTierTotal.length && e.ratePerTierDiscountPoly.length === e.tokensPerTierTotal.length && e.tokensPerTierDiscountPoly.length === e.tokensPerTierTotal.length, h.ErrorCode.MismatchedArrayLength, "Tier data arrays length mismatch"), s = 0; s < e.tokensPerTierTotal.length; s += 1) {
                  f.default.isBigNumberGreaterThanZero(e.ratePerTier[s], "Invalid rate"), f.default.isBigNumberGreaterThanZero(e.tokensPerTierTotal[s], "Invalid token amount"), f.default.assert(e.tokensPerTierDiscountPoly[s].isLessThanOrEqualTo(e.tokensPerTierTotal[s]), h.ErrorCode.InvalidDiscount, "Too many discounted tokens"), f.default.assert(e.ratePerTierDiscountPoly[s].isLessThanOrEqualTo(e.ratePerTier[s]), h.ErrorCode.InvalidDiscount, "Invalid discount");
                }

                return [4, this.securityTokenContract()];

              case 3:
                return [4, i.sent().decimals.callAsync()];

              case 4:
                return o = i.sent(), [4, this.contract];

              case 5:
                return [2, i.sent().modifyTiers.sendTransactionAsync(p.valueArrayToWeiArray(e.ratePerTier, h.FULL_DECIMALS), p.valueArrayToWeiArray(e.ratePerTierDiscountPoly, h.FULL_DECIMALS), p.valueArrayToWeiArray(e.tokensPerTierTotal, o), p.valueArrayToWeiArray(e.tokensPerTierDiscountPoly, o), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.getAccreditedData = function () {
        return o(n, void 0, void 0, function () {
          var e, t, a, r;
          return i(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, n.sent().getAccreditedData.callAsync()];

              case 2:
                for (e = n.sent(), t = [], a = 0; a < e[0].length; a += 1) {
                  r = {
                    investor: e[0][a],
                    accreditedData: {
                      accredited: e[1][a],
                      nonAccreditedLimitUSDOverride: p.weiToValue(e[2][a], h.FULL_DECIMALS)
                    }
                  }, t.push(r);
                }

                return [2, t];
            }
          });
        });
      }, n.checkIfBuyIsValid = function (e, t, a, r, s) {
        return o(n, void 0, void 0, function () {
          var n, o, c, u, d, l, v, _, g, A, w, T, x, D, C, S, E, B;

          return i(this, function (i) {
            switch (i.label) {
              case 0:
                return f.default.isETHAddressHex("beneficiary", e), o = (n = f.default).assert, [4, this.paused()];

              case 1:
                return o.apply(n, [!i.sent(), h.ErrorCode.PreconditionRequired, "Contract is Paused"]), u = (c = f.default).assert, [4, this.isOpen()];

              case 2:
                return u.apply(c, [i.sent(), h.ErrorCode.STOClosed, "STO not open"]), f.default.isBigNumberGreaterThanZero(a, "No funds were sent"), [4, this.getSTODetails()];

              case 3:
                switch (d = i.sent(), r) {
                  case h.FundRaiseType.ETH:
                    return [3, 4];

                  case h.FundRaiseType.POLY:
                    return [3, 6];

                  case h.FundRaiseType.StableCoin:
                    return [3, 9];
                }

                return [3, 13];

              case 4:
                return f.default.assert(d.isRaisedInETH, h.ErrorCode.CoinNotAllowed, "ETH Not Allowed"), [4, this.web3Wrapper.getBalanceInWeiAsync(t)];

              case 5:
                return l = i.sent(), f.default.assert(l.isGreaterThan(a), h.ErrorCode.InsufficientBalance, "Insufficient ETH funds"), [3, 14];

              case 6:
                return f.default.assert(d.isRaisedInPOLY, h.ErrorCode.CoinNotAllowed, "POLY Not Allowed"), [4, this.polyTokenContract()];

              case 7:
                return [4, i.sent().balanceOf.callAsync(t)];

              case 8:
                return v = i.sent(), f.default.assert(v.isGreaterThanOrEqualTo(a), h.ErrorCode.InsufficientBalance, "Budget less than amount unable to transfer fee"), [3, 14];

              case 9:
                return f.default.assert(d.isRaisedInSC, h.ErrorCode.CoinNotAllowed, "USD Not Allowed"), f.default.assert(null !== s, h.ErrorCode.InvalidAddress, "USD Token Address must exist"), s ? [4, this.detailedERC20TokenContract(s)] : [3, 12];

              case 10:
                return [4, i.sent().balanceOf.callAsync(t)];

              case 11:
                _ = i.sent(), f.default.assert(_.isGreaterThanOrEqualTo(a), h.ErrorCode.InsufficientBalance, "Budget less than amount unable to transfer fee"), i.label = 12;

              case 12:
                return [3, 14];

              case 13:
                return f.default.assert(!1, h.ErrorCode.InvalidData, "Missing fundraise type"), [3, 14];

              case 14:
                return [4, this.allowBeneficialInvestments()];

              case 15:
                return i.sent() || f.default.assert(b.default.checksumAddressComparision(e, t), h.ErrorCode.Unauthorized, "Beneficiary address must be the same as sender"), [4, this.getRate({
                  fundRaiseType: r
                })];

              case 16:
                return g = i.sent(), A = g.multipliedBy(a), [4, this.investorInvestedUSD({
                  investorAddress: e
                })];

              case 17:
                return w = i.sent(), [4, this.minimumInvestmentUSD()];

              case 18:
                return T = i.sent(), f.default.assert(A.plus(w).isGreaterThan(T), h.ErrorCode.PreconditionRequired, "Investment amount must be greater than the minimum investment amount"), [4, this.securityTokenContract()];

              case 19:
                return [4, i.sent().getModulesByName.callAsync(p.stringToBytes32(h.ModuleName.GeneralTransferManager))];

              case 20:
                return x = i.sent(), [4, new m.GeneralTransferManagerCommon(this.web3Wrapper, this.generalTransferManagerContract(x[0]), this.contractFactory).getInvestorFlag({
                  investor: e,
                  flag: 0
                })];

              case 21:
                return i.sent() ? [4, this.getAccreditedData()] : [3, 26];

              case 22:
                for (D = i.sent(), C = void 0, S = 0; S < D.length; S += 1) {
                  D[S].investor === e && (C = D[S].accreditedData.nonAccreditedLimitUSDOverride);
                }

                return C && !C.isEqualTo(y) ? [3, 24] : [4, this.nonAccreditedLimitUSD()];

              case 23:
                return B = i.sent(), [3, 25];

              case 24:
                B = C, i.label = 25;

              case 25:
                E = B, f.default.assert(w.isLessThan(E), h.ErrorCode.PreconditionRequired, "Over investor limit"), i.label = 26;

              case 26:
                return [2];
            }
          });
        });
      }, n.subscribeAsync = function (e) {
        return o(n, void 0, void 0, function () {
          var t;
          return i(this, function (a) {
            switch (a.label) {
              case 0:
                return f.default.doesBelongToStringEnum("eventName", e.eventName, u.USDTieredSTOEvents_3_0_0), f.default.doesConformToSchema("indexFilterValues", e.indexFilterValues, d.schemas.indexFilterValuesSchema), f.default.isFunction("callback", e.callback), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.subscribeInternal(t, e.eventName, e.indexFilterValues, e.callback, e.isVerbose)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.getLogsAsync = function (e) {
        return o(n, void 0, void 0, function () {
          var t;
          return i(this, function (a) {
            switch (a.label) {
              case 0:
                return f.default.doesBelongToStringEnum("eventName", e.eventName, u.USDTieredSTOEvents_3_0_0), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.getLogsAsyncInternal(t, e.eventName, e.blockRange, e.indexFilterValues)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.contract = a, n;
    }

    return n(t, e), t;
  }(l.STOCommon);

  t.default = v, t.isUSDTieredSTO = function (e) {
    return e instanceof v;
  };
},
/*!**************************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/transfer_manager/general_transfer_manager_wrapper/index.ts ***!
  \**************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r11,
      n = this && this.__extends || (_r11 = function r(e, t) {
    return (_r11 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r11(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__importStar || function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var a in e) {
      Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t.default = e, t;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var i = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      c = a(
  /*! ./3.0.0 */
  854);
  t.GeneralTransferManager_3_0_0 = c.GeneralTransferManager_3_0_0, t.isGeneralTransferManager_3_0_0 = c.isGeneralTransferManager_3_0_0;
  var u = a(
  /*! ./3.1.0 */
  855);
  t.GeneralTransferManager_3_1_0 = u.GeneralTransferManager_3_1_0, t.isGeneralTransferManager_3_1_0 = u.isGeneralTransferManager_3_1_0;
  var d = o(a(
  /*! ./common */
  147));
  t.isGeneralTransferManager = d.isGeneralTransferManager, t.GeneralTransferManagerEvents = s({}, i.GeneralTransferManagerEvents_3_1_0, i.GeneralTransferManagerEvents_3_0_0);

  var f = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }

    return n(t, e), t;
  }(d.default);

  t.GeneralTransferManagerCommon = f;
},
/*!***************************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/transfer_manager/general_transfer_manager_wrapper/common.ts ***!
  \***************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r12,
      n = this && this.__extends || (_r12 = function r(e, t) {
    return (_r12 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r12(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      i = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || t-- > 0) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  },
      c = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var u = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      d = a(
  /*! @0x/json-schemas */
  2),
      f = a(
  /*! ../../../../utils/convert */
  16),
      l = a(
  /*! ../../../../types */
  4),
      h = a(
  /*! ../../module_wrapper */
  17),
      p = c(a(
  /*! ../../../../utils/assert */
  15)),
      b = new u.BigNumber(100),
      m = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.nonceMap = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return p.default.isETHAddressHex("address", e.address), [4, this.contract];

              case 1:
                return [2, t.sent().nonceMap.callAsync(e.address, f.numberToBigNumber(e.nonce))];
            }
          });
        });
      }, n.issuanceAddress = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().issuanceAddress.callAsync()];
            }
          });
        });
      }, n.defaults = function () {
        return s(n, void 0, void 0, function () {
          var e;
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, t.sent().defaults.callAsync()];

              case 2:
                return e = t.sent(), [2, {
                  canSendAfter: f.bigNumberToDate(e[0]),
                  canReceiveAfter: f.bigNumberToDate(e[1])
                }];
            }
          });
        });
      }, n.changeDefaults = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = p.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                return a.apply(t, [r.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.contract];

              case 2:
                return [2, r.sent().changeDefaults.sendTransactionAsync(f.dateToBigNumber(e.defaultFromTime), f.dateToBigNumber(e.defaultToTime), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.changeIssuanceAddress = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return p.default.isETHAddressHex("issuanceAddress", e.issuanceAddress), a = (t = p.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                return a.apply(t, [r.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.contract];

              case 2:
                return [2, r.sent().changeIssuanceAddress.sendTransactionAsync(e.issuanceAddress, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.modifyKYCData = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return p.default.isNonZeroETHAddressHex("investor", e.investor), a = (t = p.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                return a.apply(t, [r.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), p.default.isLessThanMax64BytesDate("canSendAfter", e.canSendAfter), p.default.isLessThanMax64BytesDate("canReceiveAfter", e.canReceiveAfter), p.default.isLessThanMax64BytesDate("expiryTime", e.expiryTime), [4, this.contract];

              case 2:
                return [2, r.sent().modifyKYCData.sendTransactionAsync(e.investor, f.dateToBigNumber(e.canSendAfter), f.dateToBigNumber(e.canReceiveAfter), f.dateToBigNumber(e.expiryTime), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.getInvestorFlag = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, t.sent().getInvestorFlag.callAsync(e.investor, e.flag)];

              case 2:
                return [2, t.sent()];
            }
          });
        });
      }, n.isFlagTrue = function (e, t) {
        return !!(t >> e & 1);
      }, n.unpackFlags = function (e, t) {
        var a = !1,
            r = !1,
            s = !1;

        for (var o in l.FlagsType) {
          if (Object.prototype.hasOwnProperty.call(l.FlagsType, o)) {
            var i = Number(o);
            if (!o) continue;
            var c = n.isFlagTrue(i, t.toNumber());

            switch (i) {
              case l.FlagsType.IsAccredited:
                a = c;
                break;

              case l.FlagsType.CanNotBuyFromSto:
                r = c;
                break;

              case l.FlagsType.IsVolRestricted:
                s = c;
            }
          }
        }

        return {
          investor: e,
          isAccredited: a,
          canNotBuyFromSTO: r,
          isVolRestricted: s
        };
      }, n.getAllInvestorFlags = function () {
        return s(n, void 0, void 0, function () {
          var e, t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, o.sent().getAllInvestorFlags.callAsync()];

              case 2:
                for (e = o.sent(), t = i(e, 2), a = t[0], r = t[1], n = [], s = 0; s < a.length; s += 1) {
                  n.push(this.unpackFlags(a[s], r[s]));
                }

                return [2, n];
            }
          });
        });
      }, n.getInvestorFlags = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return t = e.investor, [4, this.contract];

              case 1:
                return [4, r.sent().getInvestorFlags.callAsync(t)];

              case 2:
                return a = r.sent(), [2, this.unpackFlags(t, a)];
            }
          });
        });
      }, n.getAllKYCData = function () {
        return s(n, void 0, void 0, function () {
          var e, t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, n.sent().getAllKYCData.callAsync()];

              case 2:
                for (e = n.sent(), t = [], a = 0; a < e[0].length; a += 1) {
                  r = {
                    investor: e[0][a],
                    canSendAfter: f.bigNumberToDate(e[1][a]),
                    canReceiveAfter: f.bigNumberToDate(e[2][a]),
                    expiryTime: f.bigNumberToDate(e[3][a])
                  }, t.push(r);
                }

                return [2, t];
            }
          });
        });
      }, n.getKYCData = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, s.sent().getKYCData.callAsync(e.investors)];

              case 2:
                for (t = s.sent(), a = [], r = 0; r < t[0].length; r += 1) {
                  n = {
                    canSendAfter: f.bigNumberToDate(t[0][r]),
                    canReceiveAfter: f.bigNumberToDate(t[1][r]),
                    expiryTime: f.bigNumberToDate(t[2][r])
                  }, a.push(n);
                }

                return [2, a];
            }
          });
        });
      }, n.getTokensByPartition = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.securityTokenContract()];

              case 1:
                return [4, r.sent().decimals.callAsync()];

              case 2:
                return t = r.sent(), [4, this.contract];

              case 3:
                return [4, r.sent().getTokensByPartition.callAsync(f.stringToBytes32(e.partition), e.tokenHolder, f.valueToWei(e.additionalBalance, t))];

              case 4:
                return a = r.sent(), [2, f.weiToValue(a, t)];
            }
          });
        });
      }, n.modifyKYCDataSigned = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return p.default.isNonZeroETHAddressHex("investor", e.investor), a = (t = p.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                return a.apply(t, [s.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), p.default.isLessThanMax64BytesDate("canSendAfter", e.canSendAfter), p.default.isLessThanMax64BytesDate("canReceiveAfter", e.canReceiveAfter), p.default.isLessThanMax64BytesDate("expiryTime", e.expiryTime), p.default.isPastDate(e.validFrom, "ValidFrom date must be in the past"), p.default.isFutureDate(e.validTo, "ValidTo date must be in the future"), n = (r = p.default).assert, [4, this.nonceMap({
                  address: e.investor,
                  nonce: e.nonce
                })];

              case 2:
                return n.apply(r, [!s.sent(), l.ErrorCode.AlreadyExists, "Already used signature of investor address and nonce"]), [4, this.contract];

              case 3:
                return [2, s.sent().modifyKYCDataSigned.sendTransactionAsync(e.investor, f.dateToBigNumber(e.canSendAfter), f.dateToBigNumber(e.canReceiveAfter), f.dateToBigNumber(e.expiryTime), f.dateToBigNumber(e.validFrom), f.dateToBigNumber(e.validTo), f.numberToBigNumber(e.nonce), e.signature, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.modifyInvestorFlag = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = p.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                return a.apply(t, [r.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), p.default.isNonZeroETHAddressHex("investor", e.investor), [4, this.contract];

              case 2:
                return [2, r.sent().modifyInvestorFlag.sendTransactionAsync(e.investor, e.flag, e.value, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.modifyInvestorFlagMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = p.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                return a.apply(t, [r.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), p.default.assert(e.investors.length === e.flag.length && e.flag.length === e.value.length, l.ErrorCode.MismatchedArrayLength, "Mismatched input lengths"), [4, this.contract];

              case 2:
                return [2, r.sent().modifyInvestorFlagMulti.sendTransactionAsync(e.investors, e.flag, e.value, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.executeTransfer = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, t.sent().executeTransfer.sendTransactionAsync(e.from, e.to, b, e.data, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.verifyTransfer = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, a.sent().verifyTransfer.callAsync(e.from, e.to, b, e.data)];

              case 2:
                return t = a.sent(), [2, {
                  transferResult: f.parseTransferResult(t[0]),
                  address: t[1]
                }];
            }
          });
        });
      }, n.modifyTransferRequirements = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, t.sent().modifyTransferRequirements.sendTransactionAsync(e.transferType, e.fromValidKYC, e.toValidKYC, e.fromRestricted, e.toRestricted, e.txData, e.safetyFactor)];

              case 2:
                return [2, t.sent()];
            }
          });
        });
      }, n.modifyTransferRequirementsMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = p.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                return a.apply(t, [r.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), p.default.assert(e.transferTypes.length === e.fromValidKYC.length && e.fromValidKYC.length === e.toValidKYC.length && e.toValidKYC.length === e.fromRestricted.length && e.fromRestricted.length === e.toRestricted.length, l.ErrorCode.MismatchedArrayLength, "Mismatched input lengths"), [4, this.contract];

              case 2:
                return [2, r.sent().modifyTransferRequirementsMulti.sendTransactionAsync(e.transferTypes, e.fromValidKYC, e.toValidKYC, e.fromRestricted, e.toRestricted, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.modifyKYCDataMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return a = (t = p.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                return a.apply(t, [o.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), p.default.assert(e.investors.length === e.canSendAfter.length && e.canSendAfter.length === e.canReceiveAfter.length && e.canReceiveAfter.length === e.expiryTime.length, l.ErrorCode.MismatchedArrayLength, "Mismatched input lengths"), r = e.canSendAfter.map(f.dateToBigNumber), n = e.canReceiveAfter.map(f.dateToBigNumber), s = e.expiryTime.map(f.dateToBigNumber), [4, this.contract];

              case 2:
                return [2, o.sent().modifyKYCDataMulti.sendTransactionAsync(e.investors, r, n, s, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.modifyKYCDataSignedMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return t = e.canSendAfter.map(f.dateToBigNumber), a = e.canReceiveAfter.map(f.dateToBigNumber), r = e.expiryTime.map(f.dateToBigNumber), [4, this.contract];

              case 1:
                return [2, n.sent().modifyKYCDataSignedMulti.sendTransactionAsync(e.investors, t, a, r, f.dateToBigNumber(e.validFrom), f.dateToBigNumber(e.validTo), new u.BigNumber(e.nonce), e.signature, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.getAllInvestors = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, e.sent().getAllInvestors.callAsync()];

              case 2:
                return [2, e.sent()];
            }
          });
        });
      }, n.getInvestors = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, t.sent().getInvestors.callAsync(new u.BigNumber(e.fromIndex), new u.BigNumber(e.toIndex))];

              case 2:
                return [2, t.sent()];
            }
          });
        });
      }, n.getAddressBytes32 = function () {
        return s(n, void 0, void 0, function () {
          var e;
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, t.sent().getAddressBytes32.callAsync()];

              case 2:
                return e = t.sent(), [2, f.bytes32ToString(e)];
            }
          });
        });
      }, n.subscribeAsync = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return p.default.doesBelongToStringEnum("eventName", e.eventName, u.GeneralTransferManagerEvents_3_0_0), p.default.doesConformToSchema("indexFilterValues", e.indexFilterValues, d.schemas.indexFilterValuesSchema), p.default.isFunction("callback", e.callback), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.subscribeInternal(t, e.eventName, e.indexFilterValues, e.callback, e.isVerbose)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.getLogsAsync = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return p.default.doesBelongToStringEnum("eventName", e.eventName, u.GeneralTransferManagerEvents_3_0_0), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.getLogsAsyncInternal(t, e.eventName, e.blockRange, e.indexFilterValues)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.contract = a, n;
    }

    return n(t, e), t;
  }(h.ModuleCommon);

  t.default = m, t.isGeneralTransferManager = function (e) {
    return e instanceof m;
  };
},
/*!**************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/wallet/vesting_escrow_wallet_wrapper/common.ts ***!
  \**************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r13,
      n = this && this.__extends || (_r13 = function r(e, t) {
    return (_r13 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r13(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      i = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var c,
      u = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      d = a(
  /*! @0x/json-schemas */
  2),
      f = i(a(
  /*! ../../../../utils/assert */
  15)),
      l = a(
  /*! ../../module_wrapper */
  17),
      h = a(
  /*! ../../../../types */
  4),
      p = a(
  /*! ../../../../utils/convert */
  16);
  !function (e) {
    e[e.Created = 0] = "Created", e[e.Started = 1] = "Started", e[e.Completed = 2] = "Completed";
  }(c || (c = {}));

  var b = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.unassignedTokens = function () {
        return s(n, void 0, void 0, function () {
          var e, t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, a.sent().unassignedTokens.callAsync()];

              case 2:
                return e = a.sent(), [4, this.securityTokenContract()];

              case 3:
                return [4, a.sent().decimals.callAsync()];

              case 4:
                return t = a.sent(), [2, p.weiToValue(e, t)];
            }
          });
        });
      }, n.schedules = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, r.sent().schedules.callAsync(e.beneficiary, p.numberToBigNumber(e.index))];

              case 2:
                return t = r.sent(), [4, this.securityTokenContract()];

              case 3:
                return [4, r.sent().decimals.callAsync()];

              case 4:
                return a = r.sent(), [2, {
                  templateName: p.bytes32ToString(t[0]),
                  claimedTokens: p.weiToValue(t[1], a).toNumber(),
                  startTime: p.bigNumberToDate(t[2])
                }];
            }
          });
        });
      }, n.templateNames = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, a.sent().templateNames.callAsync(p.numberToBigNumber(e.index))];

              case 2:
                return t = a.sent(), [2, p.bytes32ToString(t)];
            }
          });
        });
      }, n.beneficiaries = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, t.sent().beneficiaries.callAsync(p.numberToBigNumber(e.index))];
            }
          });
        });
      }, n.changeTreasuryWallet = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.isCallerTheSecurityTokenOwner(e.txData)];

              case 1:
                return a.apply(t, [r.sent(), h.ErrorCode.Unauthorized, "The caller must be the ST owner"]), [4, this.contract];

              case 2:
                return [2, r.sent().changeTreasuryWallet.sendTransactionAsync(e.newTreasuryWallet, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.depositTokens = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s, i, c;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                return a.apply(t, [o.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), f.default.assert(e.numberOfTokens.toNumber() > 0, h.ErrorCode.InvalidData, "Number of tokens should be > 0"), [4, this.securityTokenContract()];

              case 2:
                return [4, o.sent().decimals.callAsync()];

              case 3:
                return r = o.sent(), [4, this.securityTokenContract()];

              case 4:
                return i = (s = o.sent().canTransferFrom).callAsync, [4, this.getCallerAddress(e.txData)];

              case 5:
                return c = [o.sent()], [4, this.address()];

              case 6:
                return [4, i.apply(s, c.concat([o.sent(), p.valueToWei(e.numberOfTokens, r), "0x00"]))];

              case 7:
                return n = o.sent(), f.default.assert(n[0] === h.TransferStatusCode.TransferSuccess, h.ErrorCode.InvalidTransfer, "Failed transferFrom"), [4, this.contract];

              case 8:
                return [2, o.sent().depositTokens.sendTransactionAsync(p.valueToWei(e.numberOfTokens, r), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.sendToTreasury = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s, i, c;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Operator)];

              case 1:
                return a.apply(t, [o.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), f.default.assert(e.amount.toNumber() > 0, h.ErrorCode.InvalidData, "Amount cannot be zero"), [4, this.unassignedTokens()];

              case 2:
                return r = o.sent(), [4, this.securityTokenContract()];

              case 3:
                return [4, o.sent().decimals.callAsync()];

              case 4:
                return n = o.sent(), f.default.assert(e.amount.isLessThanOrEqualTo(p.valueToWei(r, n)), h.ErrorCode.InvalidData, "Amount is greater than unassigned tokens"), [4, this.securityTokenContract()];

              case 5:
                return c = (i = o.sent().canTransfer).callAsync, [4, this.getTreasuryWallet()];

              case 6:
                return [4, c.apply(i, [o.sent(), p.valueToWei(e.amount, n), "0x00"])];

              case 7:
                return s = o.sent(), f.default.assert(s[0] === h.TransferStatusCode.TransferSuccess, h.ErrorCode.InvalidTransfer, "Transfer failed"), [4, this.contract];

              case 8:
                return [2, o.sent().sendToTreasury.sendTransactionAsync(p.valueToWei(e.amount, n), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.getTreasuryWallet = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().getTreasuryWallet.callAsync()];
            }
          });
        });
      }, n.pushAvailableTokens = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Operator)];

              case 1:
                return a.apply(t, [r.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.contract];

              case 2:
                return [2, r.sent().pushAvailableTokens.sendTransactionAsync(e.beneficiary, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.pullAvailableTokens = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.paused()];

              case 1:
                return a.apply(t, [!r.sent(), h.ErrorCode.ContractPaused, "Contract currently paused"]), [4, this.contract];

              case 2:
                return [2, r.sent().pullAvailableTokens.sendTransactionAsync(e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.addTemplate = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                return a.apply(t, [o.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), f.default.assert("" !== e.name, h.ErrorCode.InvalidData, "Invalid name"), n = (r = f.default).assert, [4, this.getAllTemplateNames()];

              case 2:
                return n.apply(r, [!o.sent().includes(e.name), h.ErrorCode.AlreadyExists, "Template name already exists"]), [4, this.validateTemplate(e.numberOfTokens, e.duration, e.frequency)];

              case 3:
                return o.sent(), [4, this.securityTokenContract()];

              case 4:
                return [4, o.sent().decimals.callAsync()];

              case 5:
                return s = o.sent(), [4, this.contract];

              case 6:
                return [2, o.sent().addTemplate.sendTransactionAsync(p.stringToBytes32(e.name), p.valueToWei(e.numberOfTokens, s), p.numberToBigNumber(e.duration), p.numberToBigNumber(e.frequency), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.removeTemplate = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                return a.apply(t, [s.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), f.default.assert("" !== e.name, h.ErrorCode.InvalidData, "Invalid name"), n = (r = f.default).assert, [4, this.getAllTemplateNames()];

              case 2:
                return n.apply(r, [s.sent().includes(e.name), h.ErrorCode.NotFound, "Template not found"]), [4, this.contract];

              case 3:
                return [2, s.sent().removeTemplate.sendTransactionAsync(p.stringToBytes32(e.name), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.getTemplateCount = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, e.sent().getTemplateCount.callAsync()];

              case 2:
                return [2, e.sent().toNumber()];
            }
          });
        });
      }, n.getAllTemplateNames = function () {
        return s(n, void 0, void 0, function () {
          var e;
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, t.sent().getAllTemplateNames.callAsync()];

              case 2:
                return e = t.sent(), [2, p.bytes32ArrayToStringArray(e)];
            }
          });
        });
      }, n.addSchedule = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                return a.apply(t, [o.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), f.default.assert("" !== e.templateName, h.ErrorCode.InvalidData, "Invalid name"), n = (r = f.default).assert, [4, this.getAllTemplateNames()];

              case 2:
                return n.apply(r, [!o.sent().includes(e.templateName), h.ErrorCode.AlreadyExists, "Template name already exists"]), [4, this.validateTemplate(e.numberOfTokens, e.duration, e.frequency)];

              case 3:
                return o.sent(), [4, this.validateAddSchedule(e.beneficiary, e.templateName, e.startTime)];

              case 4:
                return o.sent(), [4, this.securityTokenContract()];

              case 5:
                return [4, o.sent().decimals.callAsync()];

              case 6:
                return s = o.sent(), [4, this.contract];

              case 7:
                return [2, o.sent().addSchedule.sendTransactionAsync(e.beneficiary, p.stringToBytes32(e.templateName), p.valueToWei(e.numberOfTokens, s), p.numberToBigNumber(e.duration), p.numberToBigNumber(e.frequency), p.dateToBigNumber(e.startTime), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.addScheduleFromTemplate = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                return a.apply(t, [r.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.validateAddScheduleFromTemplate(e.beneficiary, e.templateName, e.startTime)];

              case 2:
                return r.sent(), [4, this.contract];

              case 3:
                return [2, r.sent().addScheduleFromTemplate.sendTransactionAsync(e.beneficiary, p.stringToBytes32(e.templateName), p.dateToBigNumber(e.startTime), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.revokeSchedule = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                return a.apply(t, [r.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), this.checkSchedule(e.beneficiary), [4, this.contract];

              case 2:
                return [2, r.sent().revokeSchedule.sendTransactionAsync(e.beneficiary, p.stringToBytes32(e.templateName), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.revokeAllSchedules = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                return a.apply(t, [r.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), f.default.isNonZeroETHAddressHex("beneficiary", e.beneficiary), [4, this.contract];

              case 2:
                return [2, r.sent().revokeAllSchedules.sendTransactionAsync(e.beneficiary, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.getSchedule = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return this.checkSchedule(e.beneficiary), [4, this.contract];

              case 1:
                return [4, n.sent().getSchedule.callAsync(e.beneficiary, p.stringToBytes32(e.templateName))];

              case 2:
                switch (t = n.sent(), a = c.Created, t[5].toNumber()) {
                  case 0:
                    a = c.Created;
                    break;

                  case 1:
                    a = c.Completed;
                    break;

                  case 2:
                    a = c.Started;
                }

                return [4, this.securityTokenContract()];

              case 3:
                return [4, n.sent().decimals.callAsync()];

              case 4:
                return r = n.sent(), [2, {
                  numberOfTokens: p.weiToValue(t[0], r),
                  duration: t[1].toNumber(),
                  frequency: t[2].toNumber(),
                  startTime: p.bigNumberToDate(t[3]),
                  claimedTokens: t[4].toNumber(),
                  state: a
                }];
            }
          });
        });
      }, n.getTemplateNames = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return f.default.isNonZeroETHAddressHex("beneficiary", e.beneficiary), [4, this.contract];

              case 1:
                return [4, a.sent().getTemplateNames.callAsync(e.beneficiary)];

              case 2:
                return t = a.sent(), [2, p.bytes32ArrayToStringArray(t)];
            }
          });
        });
      }, n.getScheduleCount = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return f.default.isNonZeroETHAddressHex("beneficiary", e.beneficiary), [4, this.contract];

              case 1:
                return [4, t.sent().getScheduleCount.callAsync(e.beneficiary)];

              case 2:
                return [2, t.sent().toNumber()];
            }
          });
        });
      }, n.pushAvailableTokensMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Operator)];

              case 1:
                return a.apply(t, [r.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.contract];

              case 2:
                return [2, r.sent().pushAvailableTokensMulti.sendTransactionAsync(p.numberToBigNumber(e.fromIndex), p.numberToBigNumber(e.toIndex), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.addScheduleMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s, i, c;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                for (a.apply(t, [o.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), f.default.assert(e.beneficiaries.length === e.templateNames.length && e.beneficiaries.length === e.numberOfTokens.length && e.beneficiaries.length === e.durations.length && e.beneficiaries.length === e.frequencies.length && e.beneficiaries.length === e.startTimes.length, h.ErrorCode.MismatchedArrayLength, "Arrays sizes mismatch"), r = [], n = [], s = [], i = 0; i < e.beneficiaries.length; i += 1) {
                  f.default.assert("" !== e.templateNames[i], h.ErrorCode.InvalidData, "Invalid name"), r.push(this.getAllTemplateNames()), n.push(this.validateTemplate(e.numberOfTokens[i], e.durations[i], e.frequencies[i])), s.push(this.validateAddSchedule(e.beneficiaries[i], e.templateNames[i], e.startTimes[i]));
                }

                return [4, Promise.all(r)];

              case 2:
                return o.sent().forEach(function (t, a) {
                  f.default.assert(!t.includes(e.templateNames[a]), h.ErrorCode.AlreadyExists, "Template name already exists");
                }), [4, Promise.all(n)];

              case 3:
                return o.sent(), [4, Promise.all(s)];

              case 4:
                return o.sent(), [4, this.securityTokenContract()];

              case 5:
                return [4, o.sent().decimals.callAsync()];

              case 6:
                return c = o.sent(), [4, this.contract];

              case 7:
                return [2, o.sent().addScheduleMulti.sendTransactionAsync(e.beneficiaries, e.templateNames.map(function (e) {
                  return p.stringToBytes32(e);
                }), e.numberOfTokens.map(function (e) {
                  return p.valueToWei(e, c);
                }), e.durations.map(function (e) {
                  return p.numberToBigNumber(e);
                }), e.frequencies.map(function (e) {
                  return p.numberToBigNumber(e);
                }), e.startTimes.map(function (e) {
                  return p.dateToBigNumber(e);
                }), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.addScheduleFromTemplateMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                for (a.apply(t, [s.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), r = [], n = 0; n < e.beneficiaries.length; n += 1) {
                  r.push(this.validateAddScheduleFromTemplate(e.beneficiaries[n], e.templateNames[n], e.startTimes[n]));
                }

                return [4, Promise.all(r)];

              case 2:
                return s.sent(), [4, this.contract];

              case 3:
                return [2, s.sent().addScheduleFromTemplateMulti.sendTransactionAsync(e.beneficiaries, e.templateNames.map(function (e) {
                  return p.stringToBytes32(e);
                }), e.startTimes.map(function (e) {
                  return p.dateToBigNumber(e);
                }), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.revokeSchedulesMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                return a.apply(t, [r.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), e.beneficiaries.forEach(function (e) {
                  f.default.isNonZeroETHAddressHex("beneficiary", e);
                }), [4, this.contract];

              case 2:
                return [2, r.sent().revokeSchedulesMulti.sendTransactionAsync(e.beneficiaries, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.modifyScheduleMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                for (a.apply(t, [n.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), f.default.assert(e.beneficiaries.length === e.templateNames.length && e.beneficiaries.length === e.startTimes.length, h.ErrorCode.MismatchedArrayLength, "Arrays sizes mismatch"), r = 0; r < e.beneficiaries.length; r += 1) {
                  this.checkSchedule(e.beneficiaries[r]), f.default.assert(e.startTimes[r].getTime() > Date.now(), h.ErrorCode.TooEarly, "Date in the past");
                }

                return [4, this.contract];

              case 2:
                return [2, n.sent().modifyScheduleMulti.sendTransactionAsync(e.beneficiaries, e.templateNames.map(function (e) {
                  return p.stringToBytes32(e);
                }), e.startTimes.map(function (e) {
                  return p.dateToBigNumber(e);
                }), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.validateTemplate = function (e, t, a) {
        return s(n, void 0, void 0, function () {
          var r, n, s, i;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return f.default.assert(e.toNumber() > 0, h.ErrorCode.InvalidData, "Zero amount"), f.default.assert(t % a == 0, h.ErrorCode.InvalidData, "Invalid frequency"), r = t / a, f.default.assert(e.toNumber() % r == 0, h.ErrorCode.InvalidData, "Invalid period count"), n = e.toNumber() / r, i = p.weiToValue, [4, this.securityTokenContract()];

              case 1:
                return [4, o.sent().granularity.callAsync()];

              case 2:
                return s = i.apply(void 0, [o.sent(), h.FULL_DECIMALS]).toNumber(), f.default.assert(n % s == 0, h.ErrorCode.InvalidData, "Invalid granularity"), [2];
            }
          });
        });
      }, n.validateAddSchedule = function (e, t, a) {
        return s(n, void 0, void 0, function () {
          var t, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return f.default.isNonZeroETHAddressHex("beneficiary", e), r = (t = f.default).assert, [4, this.getScheduleCount({
                  beneficiary: e
                })];

              case 1:
                return r.apply(t, [0 === n.sent(), h.ErrorCode.AlreadyExists, "Already added"]), f.default.assert(a.getTime() > Date.now(), h.ErrorCode.TooEarly, "Date in the past"), [2];
            }
          });
        });
      }, n.validateAddScheduleFromTemplate = function (e, t, a) {
        return s(n, void 0, void 0, function () {
          var r, n, s, i;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return f.default.isNonZeroETHAddressHex("beneficiary", e), n = (r = f.default).assert, [4, this.getAllTemplateNames()];

              case 1:
                return n.apply(r, [o.sent().includes(t), h.ErrorCode.NotFound, "Template not found"]), i = (s = f.default).assert, [4, this.getScheduleCount({
                  beneficiary: e
                })];

              case 2:
                return i.apply(s, [0 === o.sent(), h.ErrorCode.AlreadyExists, "Already added"]), f.default.assert(a.getTime() > Date.now(), h.ErrorCode.TooEarly, "Date in the past"), [2];
            }
          });
        });
      }, n.checkSchedule = function (e) {
        f.default.isNonZeroETHAddressHex("beneficiary", e);
      }, n.subscribeAsync = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return f.default.doesBelongToStringEnum("eventName", e.eventName, u.VestingEscrowWalletEvents_3_0_0), f.default.doesConformToSchema("indexFilterValues", e.indexFilterValues, d.schemas.indexFilterValuesSchema), f.default.isFunction("callback", e.callback), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [2, this.subscribeInternal(t, e.eventName, e.indexFilterValues, e.callback, e.isVerbose)];
            }
          });
        });
      }, n.getLogsAsync = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return f.default.doesBelongToStringEnum("eventName", e.eventName, u.VestingEscrowWalletEvents_3_0_0), f.default.doesConformToSchema("blockRange", e.blockRange, d.schemas.blockRangeSchema), f.default.doesConformToSchema("indexFilterValues", e.indexFilterValues, d.schemas.indexFilterValuesSchema), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.getLogsAsyncInternal(t, e.eventName, e.blockRange, e.indexFilterValues)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.contract = a, n;
    }

    return n(t, e), t;
  }(l.ModuleCommon);

  t.default = b, t.isVestingEscrowWallet = function (e) {
    return e instanceof b;
  };
},
/*!***************************************!*\
  !*** ./node_modules/isarray/index.js ***!
  \***************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  var a = {}.toString;

  e.exports = Array.isArray || function (e) {
    return "[object Array]" == a.call(e);
  };
},
/*!**********************************************!*\
  !*** ./node_modules/jsonschema/lib/index.js ***!
  \**********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = e.exports.Validator = a(
  /*! ./validator */
  322);
  e.exports.ValidatorResult = a(
  /*! ./helpers */
  57).ValidatorResult, e.exports.ValidationError = a(
  /*! ./helpers */
  57).ValidationError, e.exports.SchemaError = a(
  /*! ./helpers */
  57).SchemaError, e.exports.SchemaScanResult = a(
  /*! ./scan */
  95).SchemaScanResult, e.exports.scan = a(
  /*! ./scan */
  95).scan, e.exports.validate = function (e, t, a) {
    return new r().validate(e, t, a);
  };
},
/*!**********************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/src/schemas.js ***!
  \**********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var r = a(
  /*! ../schemas/address_schema.json */
  331),
      n = a(
  /*! ../schemas/asset_pairs_request_opts_schema.json */
  332),
      s = a(
  /*! ../schemas/block_param_schema.json */
  333),
      o = a(
  /*! ../schemas/block_range_schema.json */
  334),
      i = a(
  /*! ../schemas/call_data_schema.json */
  335),
      c = a(
  /*! ../schemas/ec_signature_parameter_schema.json */
  336),
      u = a(
  /*! ../schemas/ec_signature_schema.json */
  337),
      d = a(
  /*! ../schemas/eip712_typed_data_schema.json */
  338),
      f = a(
  /*! ../schemas/hex_schema.json */
  339),
      l = a(
  /*! ../schemas/index_filter_values_schema.json */
  340),
      h = a(
  /*! ../schemas/js_number_schema.json */
  341),
      p = a(
  /*! ../schemas/number_schema.json */
  342),
      b = a(
  /*! ../schemas/order_cancel_schema.json */
  343),
      m = a(
  /*! ../schemas/order_config_request_schema.json */
  344),
      y = a(
  /*! ../schemas/order_fill_or_kill_requests_schema.json */
  345),
      v = a(
  /*! ../schemas/order_fill_requests_schema.json */
  346),
      _ = a(
  /*! ../schemas/order_hash_schema.json */
  347),
      g = a(
  /*! ../schemas/order_schema.json */
  348),
      A = a(
  /*! ../schemas/orderbook_request_schema.json */
  349),
      w = a(
  /*! ../schemas/orders_request_opts_schema.json */
  350),
      T = a(
  /*! ../schemas/orders_schema.json */
  351),
      x = a(
  /*! ../schemas/paged_request_opts_schema.json */
  352),
      D = a(
  /*! ../schemas/paginated_collection_schema.json */
  353),
      C = a(
  /*! ../schemas/relayer_api_asset_data_pairs_response_schema.json */
  354),
      S = a(
  /*! ../schemas/relayer_api_asset_data_pairs_schema.json */
  355),
      E = a(
  /*! ../schemas/relayer_api_asset_data_trade_info_schema.json */
  356),
      B = a(
  /*! ../schemas/relayer_api_error_response_schema.json */
  357),
      k = a(
  /*! ../schemas/relayer_api_fee_recipients_response_schema.json */
  358),
      R = a(
  /*! ../schemas/relayer_api_order_config_payload_schema.json */
  359),
      W = a(
  /*! ../schemas/relayer_api_order_config_response_schema.json */
  360),
      I = a(
  /*! ../schemas/relayer_api_order_schema.json */
  361),
      N = a(
  /*! ../schemas/relayer_api_orderbook_response_schema.json */
  362),
      M = a(
  /*! ../schemas/relayer_api_orders_channel_subscribe_payload_schema.json */
  363),
      P = a(
  /*! ../schemas/relayer_api_orders_channel_subscribe_schema.json */
  364),
      L = a(
  /*! ../schemas/relayer_api_orders_channel_update_response_schema.json */
  365),
      O = a(
  /*! ../schemas/relayer_api_orders_response_schema.json */
  366),
      F = a(
  /*! ../schemas/relayer_api_orders_schema.json */
  367),
      j = a(
  /*! ../schemas/request_opts_schema.json */
  368),
      G = a(
  /*! ../schemas/signed_order_schema.json */
  369),
      V = a(
  /*! ../schemas/signed_orders_schema.json */
  370),
      U = a(
  /*! ../schemas/token_schema.json */
  371),
      H = a(
  /*! ../schemas/tx_data_schema.json */
  372),
      z = a(
  /*! ../schemas/whole_number_schema.json */
  373),
      K = a(
  /*! ../schemas/zero_ex_transaction_schema.json */
  374);

  t.schemas = {
    numberSchema: p,
    addressSchema: r,
    callDataSchema: i,
    hexSchema: f,
    ecSignatureParameterSchema: c,
    ecSignatureSchema: u,
    eip712TypedDataSchema: d,
    indexFilterValuesSchema: l,
    orderCancellationRequestsSchema: b,
    orderFillOrKillRequestsSchema: y,
    orderFillRequestsSchema: v,
    orderHashSchema: _,
    orderSchema: g,
    signedOrderSchema: G,
    signedOrdersSchema: V,
    ordersSchema: T,
    blockParamSchema: s,
    blockRangeSchema: o,
    tokenSchema: U,
    jsNumber: h,
    requestOptsSchema: j,
    pagedRequestOptsSchema: x,
    ordersRequestOptsSchema: w,
    orderBookRequestSchema: A,
    orderConfigRequestSchema: m,
    assetPairsRequestOptsSchema: n,
    txDataSchema: H,
    paginatedCollectionSchema: D,
    relayerApiErrorResponseSchema: B,
    relayerApiFeeRecipientsResponseSchema: k,
    relayerApiOrderSchema: I,
    relayerApiOrdersSchema: F,
    relayerApiOrderConfigPayloadSchema: R,
    relayerApiOrderConfigResponseSchema: W,
    relayerApiOrderbookResponseSchema: N,
    relayerApiAssetDataPairsResponseSchema: C,
    relayerApiAssetDataTradeInfoSchema: E,
    relayerApiOrdersChannelSubscribeSchema: P,
    relayerApiOrdersChannelSubscribePayloadSchema: M,
    relayerApiOrdersChannelUpdateSchema: L,
    relayerApiOrdersResponseSchema: O,
    relayerApiAssetDataPairsSchema: S,
    zeroExTransactionSchema: K,
    wholeNumberSchema: z
  };
},
/*!*********************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/address_utils.js ***!
  \*********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = a(
  /*! ethereumjs-util */
  24),
      n = a(
  /*! js-sha3 */
  431),
      s = a(
  /*! lodash */
  0),
      o = a(
  /*! ./random */
  171),
      i = /^(0x)?[0-9a-f]{40}$/i,
      c = /^(0x)?([0-9a-f]{40}|[0-9A-F]{40})$/;
  t.addressUtils = {
    isChecksumAddress: function isChecksumAddress(e) {
      for (var t = e.replace("0x", ""), a = n.keccak256(t.toLowerCase()), r = 0; r < 40; r++) {
        if (parseInt(a[r], 16) > 7 && t[r].toUpperCase() !== t[r] || parseInt(a[r], 16) <= 7 && t[r].toLowerCase() !== t[r]) return !1;
      }

      return !0;
    },
    isAddress: function isAddress(e) {
      return !!i.test(e) && (!!c.test(e) || t.addressUtils.isChecksumAddress(e));
    },
    padZeros: function padZeros(e) {
      return r.addHexPrefix(s.padStart(r.stripHexPrefix(e), 40, "0"));
    },
    generatePseudoRandomAddress: function generatePseudoRandomAddress() {
      var e = o.generatePseudoRandom256BitNumber();
      return "0x" + r.sha3(e.toString()).slice(0, 20).toString("hex");
    }
  };
},
/*!**************************************************************!*\
  !*** ./node_modules/readable-stream/lib/_stream_readable.js ***!
  \**************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (t, r) {
    var n = a(
    /*! process-nextick-args */
    77);
    e.exports = _;
    var s,
        o = a(
    /*! isarray */
    149);
    _.ReadableState = v;
    a(
    /*! events */
    41).EventEmitter;

    var i = function i(e, t) {
      return e.listeners(t).length;
    },
        c = a(
    /*! ./internal/streams/stream */
    154),
        u = a(
    /*! safe-buffer */
    96).Buffer,
        d = t.Uint8Array || function () {};

    var f = a(
    /*! core-util-is */
    27);
    f.inherits = a(
    /*! inherits */
    3);
    var l = a(
    /*! util */
    378),
        h = void 0;
    h = l && l.debuglog ? l.debuglog("stream") : function () {};
    var p,
        b = a(
    /*! ./internal/streams/BufferList */
    379),
        m = a(
    /*! ./internal/streams/destroy */
    155);
    f.inherits(_, c);
    var y = ["error", "close", "destroy", "pause", "resume"];

    function v(e, t) {
      e = e || {};
      var r = t instanceof (s = s || a(
      /*! ./_stream_duplex */
      52));
      this.objectMode = !!e.objectMode, r && (this.objectMode = this.objectMode || !!e.readableObjectMode);
      var n = e.highWaterMark,
          o = e.readableHighWaterMark,
          i = this.objectMode ? 16 : 16384;
      this.highWaterMark = n || 0 === n ? n : r && (o || 0 === o) ? o : i, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new b(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = e.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, e.encoding && (p || (p = a(
      /*! string_decoder/ */
      53).StringDecoder), this.decoder = new p(e.encoding), this.encoding = e.encoding);
    }

    function _(e) {
      if (s = s || a(
      /*! ./_stream_duplex */
      52), !(this instanceof _)) return new _(e);
      this._readableState = new v(e, this), this.readable = !0, e && ("function" == typeof e.read && (this._read = e.read), "function" == typeof e.destroy && (this._destroy = e.destroy)), c.call(this);
    }

    function g(e, t, a, r, n) {
      var s,
          o = e._readableState;
      null === t ? (o.reading = !1, function (e, t) {
        if (t.ended) return;

        if (t.decoder) {
          var a = t.decoder.end();
          a && a.length && (t.buffer.push(a), t.length += t.objectMode ? 1 : a.length);
        }

        t.ended = !0, x(e);
      }(e, o)) : (n || (s = function (e, t) {
        var a;
        r = t, u.isBuffer(r) || r instanceof d || "string" == typeof t || void 0 === t || e.objectMode || (a = new TypeError("Invalid non-string/buffer chunk"));
        var r;
        return a;
      }(o, t)), s ? e.emit("error", s) : o.objectMode || t && t.length > 0 ? ("string" == typeof t || o.objectMode || Object.getPrototypeOf(t) === u.prototype || (t = function (e) {
        return u.from(e);
      }(t)), r ? o.endEmitted ? e.emit("error", new Error("stream.unshift() after end event")) : A(e, o, t, !0) : o.ended ? e.emit("error", new Error("stream.push() after EOF")) : (o.reading = !1, o.decoder && !a ? (t = o.decoder.write(t), o.objectMode || 0 !== t.length ? A(e, o, t, !1) : C(e, o)) : A(e, o, t, !1))) : r || (o.reading = !1));
      return function (e) {
        return !e.ended && (e.needReadable || e.length < e.highWaterMark || 0 === e.length);
      }(o);
    }

    function A(e, t, a, r) {
      t.flowing && 0 === t.length && !t.sync ? (e.emit("data", a), e.read(0)) : (t.length += t.objectMode ? 1 : a.length, r ? t.buffer.unshift(a) : t.buffer.push(a), t.needReadable && x(e)), C(e, t);
    }

    Object.defineProperty(_.prototype, "destroyed", {
      get: function get() {
        return void 0 !== this._readableState && this._readableState.destroyed;
      },
      set: function set(e) {
        this._readableState && (this._readableState.destroyed = e);
      }
    }), _.prototype.destroy = m.destroy, _.prototype._undestroy = m.undestroy, _.prototype._destroy = function (e, t) {
      this.push(null), t(e);
    }, _.prototype.push = function (e, t) {
      var a,
          r = this._readableState;
      return r.objectMode ? a = !0 : "string" == typeof e && ((t = t || r.defaultEncoding) !== r.encoding && (e = u.from(e, t), t = ""), a = !0), g(this, e, t, !1, a);
    }, _.prototype.unshift = function (e) {
      return g(this, e, null, !0, !1);
    }, _.prototype.isPaused = function () {
      return !1 === this._readableState.flowing;
    }, _.prototype.setEncoding = function (e) {
      return p || (p = a(
      /*! string_decoder/ */
      53).StringDecoder), this._readableState.decoder = new p(e), this._readableState.encoding = e, this;
    };
    var w = 8388608;

    function T(e, t) {
      return e <= 0 || 0 === t.length && t.ended ? 0 : t.objectMode ? 1 : e != e ? t.flowing && t.length ? t.buffer.head.data.length : t.length : (e > t.highWaterMark && (t.highWaterMark = function (e) {
        return e >= w ? e = w : (e--, e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, e |= e >>> 16, e++), e;
      }(e)), e <= t.length ? e : t.ended ? t.length : (t.needReadable = !0, 0));
    }

    function x(e) {
      var t = e._readableState;
      t.needReadable = !1, t.emittedReadable || (h("emitReadable", t.flowing), t.emittedReadable = !0, t.sync ? n.nextTick(D, e) : D(e));
    }

    function D(e) {
      h("emit readable"), e.emit("readable"), k(e);
    }

    function C(e, t) {
      t.readingMore || (t.readingMore = !0, n.nextTick(S, e, t));
    }

    function S(e, t) {
      for (var a = t.length; !t.reading && !t.flowing && !t.ended && t.length < t.highWaterMark && (h("maybeReadMore read 0"), e.read(0), a !== t.length);) {
        a = t.length;
      }

      t.readingMore = !1;
    }

    function E(e) {
      h("readable nexttick read 0"), e.read(0);
    }

    function B(e, t) {
      t.reading || (h("resume read 0"), e.read(0)), t.resumeScheduled = !1, t.awaitDrain = 0, e.emit("resume"), k(e), t.flowing && !t.reading && e.read(0);
    }

    function k(e) {
      var t = e._readableState;

      for (h("flow", t.flowing); t.flowing && null !== e.read();) {
        ;
      }
    }

    function R(e, t) {
      return 0 === t.length ? null : (t.objectMode ? a = t.buffer.shift() : !e || e >= t.length ? (a = t.decoder ? t.buffer.join("") : 1 === t.buffer.length ? t.buffer.head.data : t.buffer.concat(t.length), t.buffer.clear()) : a = function (e, t, a) {
        var r;
        e < t.head.data.length ? (r = t.head.data.slice(0, e), t.head.data = t.head.data.slice(e)) : r = e === t.head.data.length ? t.shift() : a ? function (e, t) {
          var a = t.head,
              r = 1,
              n = a.data;
          e -= n.length;

          for (; a = a.next;) {
            var s = a.data,
                o = e > s.length ? s.length : e;

            if (o === s.length ? n += s : n += s.slice(0, e), 0 === (e -= o)) {
              o === s.length ? (++r, a.next ? t.head = a.next : t.head = t.tail = null) : (t.head = a, a.data = s.slice(o));
              break;
            }

            ++r;
          }

          return t.length -= r, n;
        }(e, t) : function (e, t) {
          var a = u.allocUnsafe(e),
              r = t.head,
              n = 1;
          r.data.copy(a), e -= r.data.length;

          for (; r = r.next;) {
            var s = r.data,
                o = e > s.length ? s.length : e;

            if (s.copy(a, a.length - e, 0, o), 0 === (e -= o)) {
              o === s.length ? (++n, r.next ? t.head = r.next : t.head = t.tail = null) : (t.head = r, r.data = s.slice(o));
              break;
            }

            ++n;
          }

          return t.length -= n, a;
        }(e, t);
        return r;
      }(e, t.buffer, t.decoder), a);
      var a;
    }

    function W(e) {
      var t = e._readableState;
      if (t.length > 0) throw new Error('"endReadable()" called on non-empty stream');
      t.endEmitted || (t.ended = !0, n.nextTick(I, t, e));
    }

    function I(e, t) {
      e.endEmitted || 0 !== e.length || (e.endEmitted = !0, t.readable = !1, t.emit("end"));
    }

    function N(e, t) {
      for (var a = 0, r = e.length; a < r; a++) {
        if (e[a] === t) return a;
      }

      return -1;
    }

    _.prototype.read = function (e) {
      h("read", e), e = parseInt(e, 10);
      var t = this._readableState,
          a = e;
      if (0 !== e && (t.emittedReadable = !1), 0 === e && t.needReadable && (t.length >= t.highWaterMark || t.ended)) return h("read: emitReadable", t.length, t.ended), 0 === t.length && t.ended ? W(this) : x(this), null;
      if (0 === (e = T(e, t)) && t.ended) return 0 === t.length && W(this), null;
      var r,
          n = t.needReadable;
      return h("need readable", n), (0 === t.length || t.length - e < t.highWaterMark) && h("length less than watermark", n = !0), t.ended || t.reading ? h("reading or ended", n = !1) : n && (h("do read"), t.reading = !0, t.sync = !0, 0 === t.length && (t.needReadable = !0), this._read(t.highWaterMark), t.sync = !1, t.reading || (e = T(a, t))), null === (r = e > 0 ? R(e, t) : null) ? (t.needReadable = !0, e = 0) : t.length -= e, 0 === t.length && (t.ended || (t.needReadable = !0), a !== e && t.ended && W(this)), null !== r && this.emit("data", r), r;
    }, _.prototype._read = function (e) {
      this.emit("error", new Error("_read() is not implemented"));
    }, _.prototype.pipe = function (e, t) {
      var a = this,
          s = this._readableState;

      switch (s.pipesCount) {
        case 0:
          s.pipes = e;
          break;

        case 1:
          s.pipes = [s.pipes, e];
          break;

        default:
          s.pipes.push(e);
      }

      s.pipesCount += 1, h("pipe count=%d opts=%j", s.pipesCount, t);
      var c = (!t || !1 !== t.end) && e !== r.stdout && e !== r.stderr ? d : _;

      function u(t, r) {
        h("onunpipe"), t === a && r && !1 === r.hasUnpiped && (r.hasUnpiped = !0, h("cleanup"), e.removeListener("close", y), e.removeListener("finish", v), e.removeListener("drain", f), e.removeListener("error", m), e.removeListener("unpipe", u), a.removeListener("end", d), a.removeListener("end", _), a.removeListener("data", b), l = !0, !s.awaitDrain || e._writableState && !e._writableState.needDrain || f());
      }

      function d() {
        h("onend"), e.end();
      }

      s.endEmitted ? n.nextTick(c) : a.once("end", c), e.on("unpipe", u);

      var f = function (e) {
        return function () {
          var t = e._readableState;
          h("pipeOnDrain", t.awaitDrain), t.awaitDrain && t.awaitDrain--, 0 === t.awaitDrain && i(e, "data") && (t.flowing = !0, k(e));
        };
      }(a);

      e.on("drain", f);
      var l = !1;
      var p = !1;

      function b(t) {
        h("ondata"), p = !1, !1 !== e.write(t) || p || ((1 === s.pipesCount && s.pipes === e || s.pipesCount > 1 && -1 !== N(s.pipes, e)) && !l && (h("false write response, pause", a._readableState.awaitDrain), a._readableState.awaitDrain++, p = !0), a.pause());
      }

      function m(t) {
        h("onerror", t), _(), e.removeListener("error", m), 0 === i(e, "error") && e.emit("error", t);
      }

      function y() {
        e.removeListener("finish", v), _();
      }

      function v() {
        h("onfinish"), e.removeListener("close", y), _();
      }

      function _() {
        h("unpipe"), a.unpipe(e);
      }

      return a.on("data", b), function (e, t, a) {
        if ("function" == typeof e.prependListener) return e.prependListener(t, a);
        e._events && e._events[t] ? o(e._events[t]) ? e._events[t].unshift(a) : e._events[t] = [a, e._events[t]] : e.on(t, a);
      }(e, "error", m), e.once("close", y), e.once("finish", v), e.emit("pipe", a), s.flowing || (h("pipe resume"), a.resume()), e;
    }, _.prototype.unpipe = function (e) {
      var t = this._readableState,
          a = {
        hasUnpiped: !1
      };
      if (0 === t.pipesCount) return this;
      if (1 === t.pipesCount) return e && e !== t.pipes ? this : (e || (e = t.pipes), t.pipes = null, t.pipesCount = 0, t.flowing = !1, e && e.emit("unpipe", this, a), this);

      if (!e) {
        var r = t.pipes,
            n = t.pipesCount;
        t.pipes = null, t.pipesCount = 0, t.flowing = !1;

        for (var s = 0; s < n; s++) {
          r[s].emit("unpipe", this, a);
        }

        return this;
      }

      var o = N(t.pipes, e);
      return -1 === o ? this : (t.pipes.splice(o, 1), t.pipesCount -= 1, 1 === t.pipesCount && (t.pipes = t.pipes[0]), e.emit("unpipe", this, a), this);
    }, _.prototype.on = function (e, t) {
      var a = c.prototype.on.call(this, e, t);
      if ("data" === e) !1 !== this._readableState.flowing && this.resume();else if ("readable" === e) {
        var r = this._readableState;
        r.endEmitted || r.readableListening || (r.readableListening = r.needReadable = !0, r.emittedReadable = !1, r.reading ? r.length && x(this) : n.nextTick(E, this));
      }
      return a;
    }, _.prototype.addListener = _.prototype.on, _.prototype.resume = function () {
      var e = this._readableState;
      return e.flowing || (h("resume"), e.flowing = !0, function (e, t) {
        t.resumeScheduled || (t.resumeScheduled = !0, n.nextTick(B, e, t));
      }(this, e)), this;
    }, _.prototype.pause = function () {
      return h("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (h("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
    }, _.prototype.wrap = function (e) {
      var t = this,
          a = this._readableState,
          r = !1;

      for (var n in e.on("end", function () {
        if (h("wrapped end"), a.decoder && !a.ended) {
          var e = a.decoder.end();
          e && e.length && t.push(e);
        }

        t.push(null);
      }), e.on("data", function (n) {
        (h("wrapped data"), a.decoder && (n = a.decoder.write(n)), a.objectMode && null == n) || (a.objectMode || n && n.length) && (t.push(n) || (r = !0, e.pause()));
      }), e) {
        void 0 === this[n] && "function" == typeof e[n] && (this[n] = function (t) {
          return function () {
            return e[t].apply(e, arguments);
          };
        }(n));
      }

      for (var s = 0; s < y.length; s++) {
        e.on(y[s], this.emit.bind(this, y[s]));
      }

      return this._read = function (t) {
        h("wrapped _read", t), r && (r = !1, e.resume());
      }, this;
    }, Object.defineProperty(_.prototype, "readableHighWaterMark", {
      enumerable: !1,
      get: function get() {
        return this._readableState.highWaterMark;
      }
    }), _._fromList = R;
  }).call(this, a(
  /*! ./../../webpack/buildin/global.js */
  18), a(
  /*! ./../../process/browser.js */
  9));
},
/*!*****************************************************************************!*\
  !*** ./node_modules/readable-stream/lib/internal/streams/stream-browser.js ***!
  \*****************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  e.exports = a(
  /*! events */
  41).EventEmitter;
},
/*!**********************************************************************!*\
  !*** ./node_modules/readable-stream/lib/internal/streams/destroy.js ***!
  \**********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! process-nextick-args */
  77);

  function n(e, t) {
    e.emit("error", t);
  }

  e.exports = {
    destroy: function destroy(e, t) {
      var a = this,
          s = this._readableState && this._readableState.destroyed,
          o = this._writableState && this._writableState.destroyed;
      return s || o ? (t ? t(e) : !e || this._writableState && this._writableState.errorEmitted || r.nextTick(n, this, e), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(e || null, function (e) {
        !t && e ? (r.nextTick(n, a, e), a._writableState && (a._writableState.errorEmitted = !0)) : t && t(e);
      }), this);
    },
    undestroy: function undestroy() {
      this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
    }
  };
},
/*!***************************************************************!*\
  !*** ./node_modules/readable-stream/lib/_stream_transform.js ***!
  \***************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  e.exports = o;
  var r = a(
  /*! ./_stream_duplex */
  52),
      n = a(
  /*! core-util-is */
  27);

  function s(e, t) {
    var a = this._transformState;
    a.transforming = !1;
    var r = a.writecb;
    if (!r) return this.emit("error", new Error("write callback called multiple times"));
    a.writechunk = null, a.writecb = null, null != t && this.push(t), r(e);
    var n = this._readableState;
    n.reading = !1, (n.needReadable || n.length < n.highWaterMark) && this._read(n.highWaterMark);
  }

  function o(e) {
    if (!(this instanceof o)) return new o(e);
    r.call(this, e), this._transformState = {
      afterTransform: s.bind(this),
      needTransform: !1,
      transforming: !1,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }, this._readableState.needReadable = !0, this._readableState.sync = !1, e && ("function" == typeof e.transform && (this._transform = e.transform), "function" == typeof e.flush && (this._flush = e.flush)), this.on("prefinish", i);
  }

  function i() {
    var e = this;
    "function" == typeof this._flush ? this._flush(function (t, a) {
      c(e, t, a);
    }) : c(this, null, null);
  }

  function c(e, t, a) {
    if (t) return e.emit("error", t);
    if (null != a && e.push(a), e._writableState.length) throw new Error("Calling transform done when ws.length != 0");
    if (e._transformState.transforming) throw new Error("Calling transform done when still transforming");
    return e.push(null);
  }

  n.inherits = a(
  /*! inherits */
  3), n.inherits(o, r), o.prototype.push = function (e, t) {
    return this._transformState.needTransform = !1, r.prototype.push.call(this, e, t);
  }, o.prototype._transform = function (e, t, a) {
    throw new Error("_transform() is not implemented");
  }, o.prototype._write = function (e, t, a) {
    var r = this._transformState;

    if (r.writecb = a, r.writechunk = e, r.writeencoding = t, !r.transforming) {
      var n = this._readableState;
      (r.needTransform || n.needReadable || n.length < n.highWaterMark) && this._read(n.highWaterMark);
    }
  }, o.prototype._read = function (e) {
    var t = this._transformState;
    null !== t.writechunk && t.writecb && !t.transforming ? (t.transforming = !0, this._transform(t.writechunk, t.writeencoding, t.afterTransform)) : t.needTransform = !0;
  }, o.prototype._destroy = function (e, t) {
    var a = this;

    r.prototype._destroy.call(this, e, function (e) {
      t(e), a.emit("close");
    });
  };
},
/*!**************************************************!*\
  !*** ./node_modules/secp256k1/lib/messages.json ***!
  \**************************************************/

/*! exports provided: COMPRESSED_TYPE_INVALID, EC_PRIVATE_KEY_TYPE_INVALID, EC_PRIVATE_KEY_LENGTH_INVALID, EC_PRIVATE_KEY_RANGE_INVALID, EC_PRIVATE_KEY_TWEAK_ADD_FAIL, EC_PRIVATE_KEY_TWEAK_MUL_FAIL, EC_PRIVATE_KEY_EXPORT_DER_FAIL, EC_PRIVATE_KEY_IMPORT_DER_FAIL, EC_PUBLIC_KEYS_TYPE_INVALID, EC_PUBLIC_KEYS_LENGTH_INVALID, EC_PUBLIC_KEY_TYPE_INVALID, EC_PUBLIC_KEY_LENGTH_INVALID, EC_PUBLIC_KEY_PARSE_FAIL, EC_PUBLIC_KEY_CREATE_FAIL, EC_PUBLIC_KEY_TWEAK_ADD_FAIL, EC_PUBLIC_KEY_TWEAK_MUL_FAIL, EC_PUBLIC_KEY_COMBINE_FAIL, ECDH_FAIL, ECDSA_SIGNATURE_TYPE_INVALID, ECDSA_SIGNATURE_LENGTH_INVALID, ECDSA_SIGNATURE_PARSE_FAIL, ECDSA_SIGNATURE_PARSE_DER_FAIL, ECDSA_SIGNATURE_SERIALIZE_DER_FAIL, ECDSA_SIGN_FAIL, ECDSA_RECOVER_FAIL, MSG32_TYPE_INVALID, MSG32_LENGTH_INVALID, OPTIONS_TYPE_INVALID, OPTIONS_DATA_TYPE_INVALID, OPTIONS_DATA_LENGTH_INVALID, OPTIONS_NONCEFN_TYPE_INVALID, RECOVERY_ID_TYPE_INVALID, RECOVERY_ID_VALUE_INVALID, TWEAK_TYPE_INVALID, TWEAK_LENGTH_INVALID, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"COMPRESSED_TYPE_INVALID":"compressed should be a boolean","EC_PRIVATE_KEY_TYPE_INVALID":"private key should be a Buffer","EC_PRIVATE_KEY_LENGTH_INVALID":"private key length is invalid","EC_PRIVATE_KEY_RANGE_INVALID":"private key range is invalid","EC_PRIVATE_KEY_TWEAK_ADD_FAIL":"tweak out of range or resulting private key is invalid","EC_PRIVATE_KEY_TWEAK_MUL_FAIL":"tweak out of range","EC_PRIVATE_KEY_EXPORT_DER_FAIL":"couldn\'t export to DER format","EC_PRIVATE_KEY_IMPORT_DER_FAIL":"couldn\'t import from DER format","EC_PUBLIC_KEYS_TYPE_INVALID":"public keys should be an Array","EC_PUBLIC_KEYS_LENGTH_INVALID":"public keys Array should have at least 1 element","EC_PUBLIC_KEY_TYPE_INVALID":"public key should be a Buffer","EC_PUBLIC_KEY_LENGTH_INVALID":"public key length is invalid","EC_PUBLIC_KEY_PARSE_FAIL":"the public key could not be parsed or is invalid","EC_PUBLIC_KEY_CREATE_FAIL":"private was invalid, try again","EC_PUBLIC_KEY_TWEAK_ADD_FAIL":"tweak out of range or resulting public key is invalid","EC_PUBLIC_KEY_TWEAK_MUL_FAIL":"tweak out of range","EC_PUBLIC_KEY_COMBINE_FAIL":"the sum of the public keys is not valid","ECDH_FAIL":"scalar was invalid (zero or overflow)","ECDSA_SIGNATURE_TYPE_INVALID":"signature should be a Buffer","ECDSA_SIGNATURE_LENGTH_INVALID":"signature length is invalid","ECDSA_SIGNATURE_PARSE_FAIL":"couldn\'t parse signature","ECDSA_SIGNATURE_PARSE_DER_FAIL":"couldn\'t parse DER signature","ECDSA_SIGNATURE_SERIALIZE_DER_FAIL":"couldn\'t serialize signature to DER format","ECDSA_SIGN_FAIL":"nonce generation function failed or private key is invalid","ECDSA_RECOVER_FAIL":"couldn\'t recover public key from signature","MSG32_TYPE_INVALID":"message should be a Buffer","MSG32_LENGTH_INVALID":"message length is invalid","OPTIONS_TYPE_INVALID":"options should be an Object","OPTIONS_DATA_TYPE_INVALID":"options.data should be a Buffer","OPTIONS_DATA_LENGTH_INVALID":"options.data length is invalid","OPTIONS_NONCEFN_TYPE_INVALID":"options.noncefn should be a Function","RECOVERY_ID_TYPE_INVALID":"recovery should be a Number","RECOVERY_ID_VALUE_INVALID":"recovery should have value between -1 and 4","TWEAK_TYPE_INVALID":"tweak should be a Buffer","TWEAK_LENGTH_INVALID":"tweak length is invalid"}');
},
/*!*****************************************!*\
  !*** ./node_modules/hash-base/index.js ***!
  \*****************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! safe-buffer */
  7).Buffer,
      n = a(
  /*! stream */
  28).Transform;

  function s(e) {
    n.call(this), this._block = r.allocUnsafe(e), this._blockSize = e, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
  }

  a(
  /*! inherits */
  3)(s, n), s.prototype._transform = function (e, t, a) {
    var r = null;

    try {
      this.update(e, t);
    } catch (e) {
      r = e;
    }

    a(r);
  }, s.prototype._flush = function (e) {
    var t = null;

    try {
      this.push(this.digest());
    } catch (e) {
      t = e;
    }

    e(t);
  }, s.prototype.update = function (e, t) {
    if (function (e, t) {
      if (!r.isBuffer(e) && "string" != typeof e) throw new TypeError(t + " must be a string or a buffer");
    }(e, "Data"), this._finalized) throw new Error("Digest already called");
    r.isBuffer(e) || (e = r.from(e, t));

    for (var a = this._block, n = 0; this._blockOffset + e.length - n >= this._blockSize;) {
      for (var s = this._blockOffset; s < this._blockSize;) {
        a[s++] = e[n++];
      }

      this._update(), this._blockOffset = 0;
    }

    for (; n < e.length;) {
      a[this._blockOffset++] = e[n++];
    }

    for (var o = 0, i = 8 * e.length; i > 0; ++o) {
      this._length[o] += i, (i = this._length[o] / 4294967296 | 0) > 0 && (this._length[o] -= 4294967296 * i);
    }

    return this;
  }, s.prototype._update = function () {
    throw new Error("_update is not implemented");
  }, s.prototype.digest = function (e) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = !0;

    var t = this._digest();

    void 0 !== e && (t = t.toString(e)), this._block.fill(0), this._blockOffset = 0;

    for (var a = 0; a < 4; ++a) {
      this._length[a] = 0;
    }

    return t;
  }, s.prototype._digest = function () {
    throw new Error("_digest is not implemented");
  }, e.exports = s;
},
/*!***************************************!*\
  !*** ./node_modules/sha.js/sha256.js ***!
  \***************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! inherits */
  3),
      n = a(
  /*! ./hash */
  59),
      s = a(
  /*! safe-buffer */
  7).Buffer,
      o = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298],
      i = new Array(64);

  function c() {
    this.init(), this._w = i, n.call(this, 64, 56);
  }

  function u(e, t, a) {
    return a ^ e & (t ^ a);
  }

  function d(e, t, a) {
    return e & t | a & (e | t);
  }

  function f(e) {
    return (e >>> 2 | e << 30) ^ (e >>> 13 | e << 19) ^ (e >>> 22 | e << 10);
  }

  function l(e) {
    return (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
  }

  function h(e) {
    return (e >>> 7 | e << 25) ^ (e >>> 18 | e << 14) ^ e >>> 3;
  }

  r(c, n), c.prototype.init = function () {
    return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
  }, c.prototype._update = function (e) {
    for (var t, a = this._w, r = 0 | this._a, n = 0 | this._b, s = 0 | this._c, i = 0 | this._d, c = 0 | this._e, p = 0 | this._f, b = 0 | this._g, m = 0 | this._h, y = 0; y < 16; ++y) {
      a[y] = e.readInt32BE(4 * y);
    }

    for (; y < 64; ++y) {
      a[y] = 0 | (((t = a[y - 2]) >>> 17 | t << 15) ^ (t >>> 19 | t << 13) ^ t >>> 10) + a[y - 7] + h(a[y - 15]) + a[y - 16];
    }

    for (var v = 0; v < 64; ++v) {
      var _ = m + l(c) + u(c, p, b) + o[v] + a[v] | 0,
          g = f(r) + d(r, n, s) | 0;

      m = b, b = p, p = c, c = i + _ | 0, i = s, s = n, n = r, r = _ + g | 0;
    }

    this._a = r + this._a | 0, this._b = n + this._b | 0, this._c = s + this._c | 0, this._d = i + this._d | 0, this._e = c + this._e | 0, this._f = p + this._f | 0, this._g = b + this._g | 0, this._h = m + this._h | 0;
  }, c.prototype._hash = function () {
    var e = s.allocUnsafe(32);
    return e.writeInt32BE(this._a, 0), e.writeInt32BE(this._b, 4), e.writeInt32BE(this._c, 8), e.writeInt32BE(this._d, 12), e.writeInt32BE(this._e, 16), e.writeInt32BE(this._f, 20), e.writeInt32BE(this._g, 24), e.writeInt32BE(this._h, 28), e;
  }, e.exports = c;
},
/*!***************************************!*\
  !*** ./node_modules/sha.js/sha512.js ***!
  \***************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! inherits */
  3),
      n = a(
  /*! ./hash */
  59),
      s = a(
  /*! safe-buffer */
  7).Buffer,
      o = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591],
      i = new Array(160);

  function c() {
    this.init(), this._w = i, n.call(this, 128, 112);
  }

  function u(e, t, a) {
    return a ^ e & (t ^ a);
  }

  function d(e, t, a) {
    return e & t | a & (e | t);
  }

  function f(e, t) {
    return (e >>> 28 | t << 4) ^ (t >>> 2 | e << 30) ^ (t >>> 7 | e << 25);
  }

  function l(e, t) {
    return (e >>> 14 | t << 18) ^ (e >>> 18 | t << 14) ^ (t >>> 9 | e << 23);
  }

  function h(e, t) {
    return (e >>> 1 | t << 31) ^ (e >>> 8 | t << 24) ^ e >>> 7;
  }

  function p(e, t) {
    return (e >>> 1 | t << 31) ^ (e >>> 8 | t << 24) ^ (e >>> 7 | t << 25);
  }

  function b(e, t) {
    return (e >>> 19 | t << 13) ^ (t >>> 29 | e << 3) ^ e >>> 6;
  }

  function m(e, t) {
    return (e >>> 19 | t << 13) ^ (t >>> 29 | e << 3) ^ (e >>> 6 | t << 26);
  }

  function y(e, t) {
    return e >>> 0 < t >>> 0 ? 1 : 0;
  }

  r(c, n), c.prototype.init = function () {
    return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
  }, c.prototype._update = function (e) {
    for (var t = this._w, a = 0 | this._ah, r = 0 | this._bh, n = 0 | this._ch, s = 0 | this._dh, i = 0 | this._eh, c = 0 | this._fh, v = 0 | this._gh, _ = 0 | this._hh, g = 0 | this._al, A = 0 | this._bl, w = 0 | this._cl, T = 0 | this._dl, x = 0 | this._el, D = 0 | this._fl, C = 0 | this._gl, S = 0 | this._hl, E = 0; E < 32; E += 2) {
      t[E] = e.readInt32BE(4 * E), t[E + 1] = e.readInt32BE(4 * E + 4);
    }

    for (; E < 160; E += 2) {
      var B = t[E - 30],
          k = t[E - 30 + 1],
          R = h(B, k),
          W = p(k, B),
          I = b(B = t[E - 4], k = t[E - 4 + 1]),
          N = m(k, B),
          M = t[E - 14],
          P = t[E - 14 + 1],
          L = t[E - 32],
          O = t[E - 32 + 1],
          F = W + P | 0,
          j = R + M + y(F, W) | 0;
      j = (j = j + I + y(F = F + N | 0, N) | 0) + L + y(F = F + O | 0, O) | 0, t[E] = j, t[E + 1] = F;
    }

    for (var G = 0; G < 160; G += 2) {
      j = t[G], F = t[G + 1];
      var V = d(a, r, n),
          U = d(g, A, w),
          H = f(a, g),
          z = f(g, a),
          K = l(i, x),
          q = l(x, i),
          Y = o[G],
          Z = o[G + 1],
          J = u(i, c, v),
          X = u(x, D, C),
          $ = S + q | 0,
          Q = _ + K + y($, S) | 0;
      Q = (Q = (Q = Q + J + y($ = $ + X | 0, X) | 0) + Y + y($ = $ + Z | 0, Z) | 0) + j + y($ = $ + F | 0, F) | 0;
      var ee = z + U | 0,
          te = H + V + y(ee, z) | 0;
      _ = v, S = C, v = c, C = D, c = i, D = x, i = s + Q + y(x = T + $ | 0, T) | 0, s = n, T = w, n = r, w = A, r = a, A = g, a = Q + te + y(g = $ + ee | 0, $) | 0;
    }

    this._al = this._al + g | 0, this._bl = this._bl + A | 0, this._cl = this._cl + w | 0, this._dl = this._dl + T | 0, this._el = this._el + x | 0, this._fl = this._fl + D | 0, this._gl = this._gl + C | 0, this._hl = this._hl + S | 0, this._ah = this._ah + a + y(this._al, g) | 0, this._bh = this._bh + r + y(this._bl, A) | 0, this._ch = this._ch + n + y(this._cl, w) | 0, this._dh = this._dh + s + y(this._dl, T) | 0, this._eh = this._eh + i + y(this._el, x) | 0, this._fh = this._fh + c + y(this._fl, D) | 0, this._gh = this._gh + v + y(this._gl, C) | 0, this._hh = this._hh + _ + y(this._hl, S) | 0;
  }, c.prototype._hash = function () {
    var e = s.allocUnsafe(64);

    function t(t, a, r) {
      e.writeInt32BE(t, r), e.writeInt32BE(a, r + 4);
    }

    return t(this._ah, this._al, 0), t(this._bh, this._bl, 8), t(this._ch, this._cl, 16), t(this._dh, this._dl, 24), t(this._eh, this._el, 32), t(this._fh, this._fl, 40), t(this._gh, this._gl, 48), t(this._hh, this._hl, 56), e;
  }, e.exports = c;
},
/*!*************************************************************!*\
  !*** ./node_modules/minimalistic-crypto-utils/lib/utils.js ***!
  \*************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = t;

  function n(e) {
    return 1 === e.length ? "0" + e : e;
  }

  function s(e) {
    for (var t = "", a = 0; a < e.length; a++) {
      t += n(e[a].toString(16));
    }

    return t;
  }

  r.toArray = function (e, t) {
    if (Array.isArray(e)) return e.slice();
    if (!e) return [];
    var a = [];

    if ("string" != typeof e) {
      for (var r = 0; r < e.length; r++) {
        a[r] = 0 | e[r];
      }

      return a;
    }

    if ("hex" === t) {
      (e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e);

      for (r = 0; r < e.length; r += 2) {
        a.push(parseInt(e[r] + e[r + 1], 16));
      }
    } else for (r = 0; r < e.length; r++) {
      var n = e.charCodeAt(r),
          s = n >> 8,
          o = 255 & n;
      s ? a.push(s, o) : a.push(o);
    }

    return a;
  }, r.zero2 = n, r.toHex = s, r.encode = function (e, t) {
    return "hex" === t ? s(e) : e;
  };
},
/*!***********************************************************!*\
  !*** ./node_modules/elliptic/lib/elliptic/curve/index.js ***!
  \***********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = t;
  r.base = a(
  /*! ./base */
  79), r.short = a(
  /*! ./short */
  403), r.mont = a(
  /*! ./mont */
  404), r.edwards = a(
  /*! ./edwards */
  405);
},
/*!****************************************************************!*\
  !*** ./node_modules/elliptic/node_modules/hash.js/lib/hash.js ***!
  \****************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = t;
  r.utils = a(
  /*! ./hash/utils */
  34), r.common = a(
  /*! ./hash/common */
  70), r.sha = a(
  /*! ./hash/sha */
  406), r.ripemd = a(
  /*! ./hash/ripemd */
  410), r.hmac = a(
  /*! ./hash/hmac */
  411), r.sha1 = r.sha.sha1, r.sha256 = r.sha.sha256, r.sha224 = r.sha.sha224, r.sha384 = r.sha.sha384, r.sha512 = r.sha.sha512, r.ripemd160 = r.ripemd.ripemd160;
},
/*!***************************************************************************!*\
  !*** ./node_modules/elliptic/node_modules/hash.js/lib/hash/sha/common.js ***!
  \***************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ../utils */
  34).rotr32;

  function n(e, t, a) {
    return e & t ^ ~e & a;
  }

  function s(e, t, a) {
    return e & t ^ e & a ^ t & a;
  }

  function o(e, t, a) {
    return e ^ t ^ a;
  }

  t.ft_1 = function (e, t, a, r) {
    return 0 === e ? n(t, a, r) : 1 === e || 3 === e ? o(t, a, r) : 2 === e ? s(t, a, r) : void 0;
  }, t.ch32 = n, t.maj32 = s, t.p32 = o, t.s0_256 = function (e) {
    return r(e, 2) ^ r(e, 13) ^ r(e, 22);
  }, t.s1_256 = function (e) {
    return r(e, 6) ^ r(e, 11) ^ r(e, 25);
  }, t.g0_256 = function (e) {
    return r(e, 7) ^ r(e, 18) ^ e >>> 3;
  }, t.g1_256 = function (e) {
    return r(e, 17) ^ r(e, 19) ^ e >>> 10;
  };
},
/*!************************************************************************!*\
  !*** ./node_modules/elliptic/node_modules/hash.js/lib/hash/sha/256.js ***!
  \************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ../utils */
  34),
      n = a(
  /*! ../common */
  70),
      s = a(
  /*! ./common */
  164),
      o = a(
  /*! minimalistic-assert */
  22),
      i = r.sum32,
      c = r.sum32_4,
      u = r.sum32_5,
      d = s.ch32,
      f = s.maj32,
      l = s.s0_256,
      h = s.s1_256,
      p = s.g0_256,
      b = s.g1_256,
      m = n.BlockHash,
      y = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298];

  function v() {
    if (!(this instanceof v)) return new v();
    m.call(this), this.h = [1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225], this.k = y, this.W = new Array(64);
  }

  r.inherits(v, m), e.exports = v, v.blockSize = 512, v.outSize = 256, v.hmacStrength = 192, v.padLength = 64, v.prototype._update = function (e, t) {
    for (var a = this.W, r = 0; r < 16; r++) {
      a[r] = e[t + r];
    }

    for (; r < a.length; r++) {
      a[r] = c(b(a[r - 2]), a[r - 7], p(a[r - 15]), a[r - 16]);
    }

    var n = this.h[0],
        s = this.h[1],
        m = this.h[2],
        y = this.h[3],
        v = this.h[4],
        _ = this.h[5],
        g = this.h[6],
        A = this.h[7];

    for (o(this.k.length === a.length), r = 0; r < a.length; r++) {
      var w = u(A, h(v), d(v, _, g), this.k[r], a[r]),
          T = i(l(n), f(n, s, m));
      A = g, g = _, _ = v, v = i(y, w), y = m, m = s, s = n, n = i(w, T);
    }

    this.h[0] = i(this.h[0], n), this.h[1] = i(this.h[1], s), this.h[2] = i(this.h[2], m), this.h[3] = i(this.h[3], y), this.h[4] = i(this.h[4], v), this.h[5] = i(this.h[5], _), this.h[6] = i(this.h[6], g), this.h[7] = i(this.h[7], A);
  }, v.prototype._digest = function (e) {
    return "hex" === e ? r.toHex32(this.h, "big") : r.split32(this.h, "big");
  };
},
/*!************************************************************************!*\
  !*** ./node_modules/elliptic/node_modules/hash.js/lib/hash/sha/512.js ***!
  \************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ../utils */
  34),
      n = a(
  /*! ../common */
  70),
      s = a(
  /*! minimalistic-assert */
  22),
      o = r.rotr64_hi,
      i = r.rotr64_lo,
      c = r.shr64_hi,
      u = r.shr64_lo,
      d = r.sum64,
      f = r.sum64_hi,
      l = r.sum64_lo,
      h = r.sum64_4_hi,
      p = r.sum64_4_lo,
      b = r.sum64_5_hi,
      m = r.sum64_5_lo,
      y = n.BlockHash,
      v = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591];

  function _() {
    if (!(this instanceof _)) return new _();
    y.call(this), this.h = [1779033703, 4089235720, 3144134277, 2227873595, 1013904242, 4271175723, 2773480762, 1595750129, 1359893119, 2917565137, 2600822924, 725511199, 528734635, 4215389547, 1541459225, 327033209], this.k = v, this.W = new Array(160);
  }

  function g(e, t, a, r, n) {
    var s = e & a ^ ~e & n;
    return s < 0 && (s += 4294967296), s;
  }

  function A(e, t, a, r, n, s) {
    var o = t & r ^ ~t & s;
    return o < 0 && (o += 4294967296), o;
  }

  function w(e, t, a, r, n) {
    var s = e & a ^ e & n ^ a & n;
    return s < 0 && (s += 4294967296), s;
  }

  function T(e, t, a, r, n, s) {
    var o = t & r ^ t & s ^ r & s;
    return o < 0 && (o += 4294967296), o;
  }

  function x(e, t) {
    var a = o(e, t, 28) ^ o(t, e, 2) ^ o(t, e, 7);
    return a < 0 && (a += 4294967296), a;
  }

  function D(e, t) {
    var a = i(e, t, 28) ^ i(t, e, 2) ^ i(t, e, 7);
    return a < 0 && (a += 4294967296), a;
  }

  function C(e, t) {
    var a = o(e, t, 14) ^ o(e, t, 18) ^ o(t, e, 9);
    return a < 0 && (a += 4294967296), a;
  }

  function S(e, t) {
    var a = i(e, t, 14) ^ i(e, t, 18) ^ i(t, e, 9);
    return a < 0 && (a += 4294967296), a;
  }

  function E(e, t) {
    var a = o(e, t, 1) ^ o(e, t, 8) ^ c(e, t, 7);
    return a < 0 && (a += 4294967296), a;
  }

  function B(e, t) {
    var a = i(e, t, 1) ^ i(e, t, 8) ^ u(e, t, 7);
    return a < 0 && (a += 4294967296), a;
  }

  function k(e, t) {
    var a = o(e, t, 19) ^ o(t, e, 29) ^ c(e, t, 6);
    return a < 0 && (a += 4294967296), a;
  }

  function R(e, t) {
    var a = i(e, t, 19) ^ i(t, e, 29) ^ u(e, t, 6);
    return a < 0 && (a += 4294967296), a;
  }

  r.inherits(_, y), e.exports = _, _.blockSize = 1024, _.outSize = 512, _.hmacStrength = 192, _.padLength = 128, _.prototype._prepareBlock = function (e, t) {
    for (var a = this.W, r = 0; r < 32; r++) {
      a[r] = e[t + r];
    }

    for (; r < a.length; r += 2) {
      var n = k(a[r - 4], a[r - 3]),
          s = R(a[r - 4], a[r - 3]),
          o = a[r - 14],
          i = a[r - 13],
          c = E(a[r - 30], a[r - 29]),
          u = B(a[r - 30], a[r - 29]),
          d = a[r - 32],
          f = a[r - 31];
      a[r] = h(n, s, o, i, c, u, d, f), a[r + 1] = p(n, s, o, i, c, u, d, f);
    }
  }, _.prototype._update = function (e, t) {
    this._prepareBlock(e, t);

    var a = this.W,
        r = this.h[0],
        n = this.h[1],
        o = this.h[2],
        i = this.h[3],
        c = this.h[4],
        u = this.h[5],
        h = this.h[6],
        p = this.h[7],
        y = this.h[8],
        v = this.h[9],
        _ = this.h[10],
        E = this.h[11],
        B = this.h[12],
        k = this.h[13],
        R = this.h[14],
        W = this.h[15];
    s(this.k.length === a.length);

    for (var I = 0; I < a.length; I += 2) {
      var N = R,
          M = W,
          P = C(y, v),
          L = S(y, v),
          O = g(y, v, _, E, B),
          F = A(y, v, _, E, B, k),
          j = this.k[I],
          G = this.k[I + 1],
          V = a[I],
          U = a[I + 1],
          H = b(N, M, P, L, O, F, j, G, V, U),
          z = m(N, M, P, L, O, F, j, G, V, U);
      N = x(r, n), M = D(r, n), P = w(r, n, o, i, c), L = T(r, n, o, i, c, u);
      var K = f(N, M, P, L),
          q = l(N, M, P, L);
      R = B, W = k, B = _, k = E, _ = y, E = v, y = f(h, p, H, z), v = l(p, p, H, z), h = c, p = u, c = o, u = i, o = r, i = n, r = f(H, z, K, q), n = l(H, z, K, q);
    }

    d(this.h, 0, r, n), d(this.h, 2, o, i), d(this.h, 4, c, u), d(this.h, 6, h, p), d(this.h, 8, y, v), d(this.h, 10, _, E), d(this.h, 12, B, k), d(this.h, 14, R, W);
  }, _.prototype._digest = function (e) {
    return "hex" === e ? r.toHex32(this.h, "big") : r.split32(this.h, "big");
  };
},
/*!****************************************************************************!*\
  !*** ./node_modules/hmac-drbg/node_modules/hash.js/lib/hash/sha/common.js ***!
  \****************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ../utils */
  35).rotr32;

  function n(e, t, a) {
    return e & t ^ ~e & a;
  }

  function s(e, t, a) {
    return e & t ^ e & a ^ t & a;
  }

  function o(e, t, a) {
    return e ^ t ^ a;
  }

  t.ft_1 = function (e, t, a, r) {
    return 0 === e ? n(t, a, r) : 1 === e || 3 === e ? o(t, a, r) : 2 === e ? s(t, a, r) : void 0;
  }, t.ch32 = n, t.maj32 = s, t.p32 = o, t.s0_256 = function (e) {
    return r(e, 2) ^ r(e, 13) ^ r(e, 22);
  }, t.s1_256 = function (e) {
    return r(e, 6) ^ r(e, 11) ^ r(e, 25);
  }, t.g0_256 = function (e) {
    return r(e, 7) ^ r(e, 18) ^ e >>> 3;
  }, t.g1_256 = function (e) {
    return r(e, 17) ^ r(e, 19) ^ e >>> 10;
  };
},
/*!*************************************************************************!*\
  !*** ./node_modules/hmac-drbg/node_modules/hash.js/lib/hash/sha/256.js ***!
  \*************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ../utils */
  35),
      n = a(
  /*! ../common */
  71),
      s = a(
  /*! ./common */
  167),
      o = a(
  /*! minimalistic-assert */
  22),
      i = r.sum32,
      c = r.sum32_4,
      u = r.sum32_5,
      d = s.ch32,
      f = s.maj32,
      l = s.s0_256,
      h = s.s1_256,
      p = s.g0_256,
      b = s.g1_256,
      m = n.BlockHash,
      y = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298];

  function v() {
    if (!(this instanceof v)) return new v();
    m.call(this), this.h = [1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225], this.k = y, this.W = new Array(64);
  }

  r.inherits(v, m), e.exports = v, v.blockSize = 512, v.outSize = 256, v.hmacStrength = 192, v.padLength = 64, v.prototype._update = function (e, t) {
    for (var a = this.W, r = 0; r < 16; r++) {
      a[r] = e[t + r];
    }

    for (; r < a.length; r++) {
      a[r] = c(b(a[r - 2]), a[r - 7], p(a[r - 15]), a[r - 16]);
    }

    var n = this.h[0],
        s = this.h[1],
        m = this.h[2],
        y = this.h[3],
        v = this.h[4],
        _ = this.h[5],
        g = this.h[6],
        A = this.h[7];

    for (o(this.k.length === a.length), r = 0; r < a.length; r++) {
      var w = u(A, h(v), d(v, _, g), this.k[r], a[r]),
          T = i(l(n), f(n, s, m));
      A = g, g = _, _ = v, v = i(y, w), y = m, m = s, s = n, n = i(w, T);
    }

    this.h[0] = i(this.h[0], n), this.h[1] = i(this.h[1], s), this.h[2] = i(this.h[2], m), this.h[3] = i(this.h[3], y), this.h[4] = i(this.h[4], v), this.h[5] = i(this.h[5], _), this.h[6] = i(this.h[6], g), this.h[7] = i(this.h[7], A);
  }, v.prototype._digest = function (e) {
    return "hex" === e ? r.toHex32(this.h, "big") : r.split32(this.h, "big");
  };
},
/*!*************************************************************************!*\
  !*** ./node_modules/hmac-drbg/node_modules/hash.js/lib/hash/sha/512.js ***!
  \*************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ../utils */
  35),
      n = a(
  /*! ../common */
  71),
      s = a(
  /*! minimalistic-assert */
  22),
      o = r.rotr64_hi,
      i = r.rotr64_lo,
      c = r.shr64_hi,
      u = r.shr64_lo,
      d = r.sum64,
      f = r.sum64_hi,
      l = r.sum64_lo,
      h = r.sum64_4_hi,
      p = r.sum64_4_lo,
      b = r.sum64_5_hi,
      m = r.sum64_5_lo,
      y = n.BlockHash,
      v = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591];

  function _() {
    if (!(this instanceof _)) return new _();
    y.call(this), this.h = [1779033703, 4089235720, 3144134277, 2227873595, 1013904242, 4271175723, 2773480762, 1595750129, 1359893119, 2917565137, 2600822924, 725511199, 528734635, 4215389547, 1541459225, 327033209], this.k = v, this.W = new Array(160);
  }

  function g(e, t, a, r, n) {
    var s = e & a ^ ~e & n;
    return s < 0 && (s += 4294967296), s;
  }

  function A(e, t, a, r, n, s) {
    var o = t & r ^ ~t & s;
    return o < 0 && (o += 4294967296), o;
  }

  function w(e, t, a, r, n) {
    var s = e & a ^ e & n ^ a & n;
    return s < 0 && (s += 4294967296), s;
  }

  function T(e, t, a, r, n, s) {
    var o = t & r ^ t & s ^ r & s;
    return o < 0 && (o += 4294967296), o;
  }

  function x(e, t) {
    var a = o(e, t, 28) ^ o(t, e, 2) ^ o(t, e, 7);
    return a < 0 && (a += 4294967296), a;
  }

  function D(e, t) {
    var a = i(e, t, 28) ^ i(t, e, 2) ^ i(t, e, 7);
    return a < 0 && (a += 4294967296), a;
  }

  function C(e, t) {
    var a = o(e, t, 14) ^ o(e, t, 18) ^ o(t, e, 9);
    return a < 0 && (a += 4294967296), a;
  }

  function S(e, t) {
    var a = i(e, t, 14) ^ i(e, t, 18) ^ i(t, e, 9);
    return a < 0 && (a += 4294967296), a;
  }

  function E(e, t) {
    var a = o(e, t, 1) ^ o(e, t, 8) ^ c(e, t, 7);
    return a < 0 && (a += 4294967296), a;
  }

  function B(e, t) {
    var a = i(e, t, 1) ^ i(e, t, 8) ^ u(e, t, 7);
    return a < 0 && (a += 4294967296), a;
  }

  function k(e, t) {
    var a = o(e, t, 19) ^ o(t, e, 29) ^ c(e, t, 6);
    return a < 0 && (a += 4294967296), a;
  }

  function R(e, t) {
    var a = i(e, t, 19) ^ i(t, e, 29) ^ u(e, t, 6);
    return a < 0 && (a += 4294967296), a;
  }

  r.inherits(_, y), e.exports = _, _.blockSize = 1024, _.outSize = 512, _.hmacStrength = 192, _.padLength = 128, _.prototype._prepareBlock = function (e, t) {
    for (var a = this.W, r = 0; r < 32; r++) {
      a[r] = e[t + r];
    }

    for (; r < a.length; r += 2) {
      var n = k(a[r - 4], a[r - 3]),
          s = R(a[r - 4], a[r - 3]),
          o = a[r - 14],
          i = a[r - 13],
          c = E(a[r - 30], a[r - 29]),
          u = B(a[r - 30], a[r - 29]),
          d = a[r - 32],
          f = a[r - 31];
      a[r] = h(n, s, o, i, c, u, d, f), a[r + 1] = p(n, s, o, i, c, u, d, f);
    }
  }, _.prototype._update = function (e, t) {
    this._prepareBlock(e, t);

    var a = this.W,
        r = this.h[0],
        n = this.h[1],
        o = this.h[2],
        i = this.h[3],
        c = this.h[4],
        u = this.h[5],
        h = this.h[6],
        p = this.h[7],
        y = this.h[8],
        v = this.h[9],
        _ = this.h[10],
        E = this.h[11],
        B = this.h[12],
        k = this.h[13],
        R = this.h[14],
        W = this.h[15];
    s(this.k.length === a.length);

    for (var I = 0; I < a.length; I += 2) {
      var N = R,
          M = W,
          P = C(y, v),
          L = S(y, v),
          O = g(y, v, _, E, B),
          F = A(y, v, _, E, B, k),
          j = this.k[I],
          G = this.k[I + 1],
          V = a[I],
          U = a[I + 1],
          H = b(N, M, P, L, O, F, j, G, V, U),
          z = m(N, M, P, L, O, F, j, G, V, U);
      N = x(r, n), M = D(r, n), P = w(r, n, o, i, c), L = T(r, n, o, i, c, u);
      var K = f(N, M, P, L),
          q = l(N, M, P, L);
      R = B, W = k, B = _, k = E, _ = y, E = v, y = f(h, p, H, z), v = l(p, p, H, z), h = c, p = u, c = o, u = i, o = r, i = n, r = f(H, z, K, q), n = l(H, z, K, q);
    }

    d(this.h, 0, r, n), d(this.h, 2, o, i), d(this.h, 4, c, u), d(this.h, 6, h, p), d(this.h, 8, y, v), d(this.h, 10, _, E), d(this.h, 12, B, k), d(this.h, 14, R, W);
  }, _.prototype._digest = function (e) {
    return "hex" === e ? r.toHex32(this.h, "big") : r.split32(this.h, "big");
  };
},
/*!***************************************************!*\
  !*** ./node_modules/is-hex-prefixed/src/index.js ***!
  \***************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = function (e) {
    if ("string" != typeof e) throw new Error("[is-hex-prefixed] value must be type 'string', is currently type " + typeof e + ", while checking isHexPrefixed.");
    return "0x" === e.slice(0, 2);
  };
},
/*!**************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/random.js ***!
  \**************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = a(
  /*! ./configured_bignumber */
  37),
      n = 78;

  t.generatePseudoRandom256BitNumber = function () {
    var e = r.BigNumber.random(n),
        t = new r.BigNumber(10).pow(n - 1);
    return e.times(t).integerValue();
  };
},
/*!*******************************************!*\
  !*** ./node_modules/detect-node/index.js ***!
  \*******************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    e.exports = !1;

    try {
      e.exports = "[object process]" === Object.prototype.toString.call(t.process);
    } catch (e) {}
  }).call(this, a(
  /*! ./../webpack/buildin/global.js */
  18));
},
/*!***************************************************!*\
  !*** ./node_modules/color-convert/conversions.js ***!
  \***************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! color-name */
  443),
      n = {};

  for (var s in r) {
    r.hasOwnProperty(s) && (n[r[s]] = s);
  }

  var o = e.exports = {
    rgb: {
      channels: 3,
      labels: "rgb"
    },
    hsl: {
      channels: 3,
      labels: "hsl"
    },
    hsv: {
      channels: 3,
      labels: "hsv"
    },
    hwb: {
      channels: 3,
      labels: "hwb"
    },
    cmyk: {
      channels: 4,
      labels: "cmyk"
    },
    xyz: {
      channels: 3,
      labels: "xyz"
    },
    lab: {
      channels: 3,
      labels: "lab"
    },
    lch: {
      channels: 3,
      labels: "lch"
    },
    hex: {
      channels: 1,
      labels: ["hex"]
    },
    keyword: {
      channels: 1,
      labels: ["keyword"]
    },
    ansi16: {
      channels: 1,
      labels: ["ansi16"]
    },
    ansi256: {
      channels: 1,
      labels: ["ansi256"]
    },
    hcg: {
      channels: 3,
      labels: ["h", "c", "g"]
    },
    apple: {
      channels: 3,
      labels: ["r16", "g16", "b16"]
    },
    gray: {
      channels: 1,
      labels: ["gray"]
    }
  };

  for (var i in o) {
    if (o.hasOwnProperty(i)) {
      if (!("channels" in o[i])) throw new Error("missing channels property: " + i);
      if (!("labels" in o[i])) throw new Error("missing channel labels property: " + i);
      if (o[i].labels.length !== o[i].channels) throw new Error("channel and label counts mismatch: " + i);
      var c = o[i].channels,
          u = o[i].labels;
      delete o[i].channels, delete o[i].labels, Object.defineProperty(o[i], "channels", {
        value: c
      }), Object.defineProperty(o[i], "labels", {
        value: u
      });
    }
  }

  o.rgb.hsl = function (e) {
    var t,
        a,
        r = e[0] / 255,
        n = e[1] / 255,
        s = e[2] / 255,
        o = Math.min(r, n, s),
        i = Math.max(r, n, s),
        c = i - o;
    return i === o ? t = 0 : r === i ? t = (n - s) / c : n === i ? t = 2 + (s - r) / c : s === i && (t = 4 + (r - n) / c), (t = Math.min(60 * t, 360)) < 0 && (t += 360), a = (o + i) / 2, [t, 100 * (i === o ? 0 : a <= .5 ? c / (i + o) : c / (2 - i - o)), 100 * a];
  }, o.rgb.hsv = function (e) {
    var t,
        a,
        r,
        n,
        s,
        o = e[0] / 255,
        i = e[1] / 255,
        c = e[2] / 255,
        u = Math.max(o, i, c),
        d = u - Math.min(o, i, c),
        f = function f(e) {
      return (u - e) / 6 / d + .5;
    };

    return 0 === d ? n = s = 0 : (s = d / u, t = f(o), a = f(i), r = f(c), o === u ? n = r - a : i === u ? n = 1 / 3 + t - r : c === u && (n = 2 / 3 + a - t), n < 0 ? n += 1 : n > 1 && (n -= 1)), [360 * n, 100 * s, 100 * u];
  }, o.rgb.hwb = function (e) {
    var t = e[0],
        a = e[1],
        r = e[2];
    return [o.rgb.hsl(e)[0], 100 * (1 / 255 * Math.min(t, Math.min(a, r))), 100 * (r = 1 - 1 / 255 * Math.max(t, Math.max(a, r)))];
  }, o.rgb.cmyk = function (e) {
    var t,
        a = e[0] / 255,
        r = e[1] / 255,
        n = e[2] / 255;
    return [100 * ((1 - a - (t = Math.min(1 - a, 1 - r, 1 - n))) / (1 - t) || 0), 100 * ((1 - r - t) / (1 - t) || 0), 100 * ((1 - n - t) / (1 - t) || 0), 100 * t];
  }, o.rgb.keyword = function (e) {
    var t = n[e];
    if (t) return t;
    var a,
        s,
        o,
        i = 1 / 0;

    for (var c in r) {
      if (r.hasOwnProperty(c)) {
        var u = r[c],
            d = (s = e, o = u, Math.pow(s[0] - o[0], 2) + Math.pow(s[1] - o[1], 2) + Math.pow(s[2] - o[2], 2));
        d < i && (i = d, a = c);
      }
    }

    return a;
  }, o.keyword.rgb = function (e) {
    return r[e];
  }, o.rgb.xyz = function (e) {
    var t = e[0] / 255,
        a = e[1] / 255,
        r = e[2] / 255;
    return [100 * (.4124 * (t = t > .04045 ? Math.pow((t + .055) / 1.055, 2.4) : t / 12.92) + .3576 * (a = a > .04045 ? Math.pow((a + .055) / 1.055, 2.4) : a / 12.92) + .1805 * (r = r > .04045 ? Math.pow((r + .055) / 1.055, 2.4) : r / 12.92)), 100 * (.2126 * t + .7152 * a + .0722 * r), 100 * (.0193 * t + .1192 * a + .9505 * r)];
  }, o.rgb.lab = function (e) {
    var t = o.rgb.xyz(e),
        a = t[0],
        r = t[1],
        n = t[2];
    return r /= 100, n /= 108.883, a = (a /= 95.047) > .008856 ? Math.pow(a, 1 / 3) : 7.787 * a + 16 / 116, [116 * (r = r > .008856 ? Math.pow(r, 1 / 3) : 7.787 * r + 16 / 116) - 16, 500 * (a - r), 200 * (r - (n = n > .008856 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116))];
  }, o.hsl.rgb = function (e) {
    var t,
        a,
        r,
        n,
        s,
        o = e[0] / 360,
        i = e[1] / 100,
        c = e[2] / 100;
    if (0 === i) return [s = 255 * c, s, s];
    t = 2 * c - (a = c < .5 ? c * (1 + i) : c + i - c * i), n = [0, 0, 0];

    for (var u = 0; u < 3; u++) {
      (r = o + 1 / 3 * -(u - 1)) < 0 && r++, r > 1 && r--, s = 6 * r < 1 ? t + 6 * (a - t) * r : 2 * r < 1 ? a : 3 * r < 2 ? t + (a - t) * (2 / 3 - r) * 6 : t, n[u] = 255 * s;
    }

    return n;
  }, o.hsl.hsv = function (e) {
    var t = e[0],
        a = e[1] / 100,
        r = e[2] / 100,
        n = a,
        s = Math.max(r, .01);
    return a *= (r *= 2) <= 1 ? r : 2 - r, n *= s <= 1 ? s : 2 - s, [t, 100 * (0 === r ? 2 * n / (s + n) : 2 * a / (r + a)), 100 * ((r + a) / 2)];
  }, o.hsv.rgb = function (e) {
    var t = e[0] / 60,
        a = e[1] / 100,
        r = e[2] / 100,
        n = Math.floor(t) % 6,
        s = t - Math.floor(t),
        o = 255 * r * (1 - a),
        i = 255 * r * (1 - a * s),
        c = 255 * r * (1 - a * (1 - s));

    switch (r *= 255, n) {
      case 0:
        return [r, c, o];

      case 1:
        return [i, r, o];

      case 2:
        return [o, r, c];

      case 3:
        return [o, i, r];

      case 4:
        return [c, o, r];

      case 5:
        return [r, o, i];
    }
  }, o.hsv.hsl = function (e) {
    var t,
        a,
        r,
        n = e[0],
        s = e[1] / 100,
        o = e[2] / 100,
        i = Math.max(o, .01);
    return r = (2 - s) * o, a = s * i, [n, 100 * (a = (a /= (t = (2 - s) * i) <= 1 ? t : 2 - t) || 0), 100 * (r /= 2)];
  }, o.hwb.rgb = function (e) {
    var t,
        a,
        r,
        n,
        s,
        o,
        i,
        c = e[0] / 360,
        u = e[1] / 100,
        d = e[2] / 100,
        f = u + d;

    switch (f > 1 && (u /= f, d /= f), r = 6 * c - (t = Math.floor(6 * c)), 0 != (1 & t) && (r = 1 - r), n = u + r * ((a = 1 - d) - u), t) {
      default:
      case 6:
      case 0:
        s = a, o = n, i = u;
        break;

      case 1:
        s = n, o = a, i = u;
        break;

      case 2:
        s = u, o = a, i = n;
        break;

      case 3:
        s = u, o = n, i = a;
        break;

      case 4:
        s = n, o = u, i = a;
        break;

      case 5:
        s = a, o = u, i = n;
    }

    return [255 * s, 255 * o, 255 * i];
  }, o.cmyk.rgb = function (e) {
    var t = e[0] / 100,
        a = e[1] / 100,
        r = e[2] / 100,
        n = e[3] / 100;
    return [255 * (1 - Math.min(1, t * (1 - n) + n)), 255 * (1 - Math.min(1, a * (1 - n) + n)), 255 * (1 - Math.min(1, r * (1 - n) + n))];
  }, o.xyz.rgb = function (e) {
    var t,
        a,
        r,
        n = e[0] / 100,
        s = e[1] / 100,
        o = e[2] / 100;
    return a = -.9689 * n + 1.8758 * s + .0415 * o, r = .0557 * n + -.204 * s + 1.057 * o, t = (t = 3.2406 * n + -1.5372 * s + -.4986 * o) > .0031308 ? 1.055 * Math.pow(t, 1 / 2.4) - .055 : 12.92 * t, a = a > .0031308 ? 1.055 * Math.pow(a, 1 / 2.4) - .055 : 12.92 * a, r = r > .0031308 ? 1.055 * Math.pow(r, 1 / 2.4) - .055 : 12.92 * r, [255 * (t = Math.min(Math.max(0, t), 1)), 255 * (a = Math.min(Math.max(0, a), 1)), 255 * (r = Math.min(Math.max(0, r), 1))];
  }, o.xyz.lab = function (e) {
    var t = e[0],
        a = e[1],
        r = e[2];
    return a /= 100, r /= 108.883, t = (t /= 95.047) > .008856 ? Math.pow(t, 1 / 3) : 7.787 * t + 16 / 116, [116 * (a = a > .008856 ? Math.pow(a, 1 / 3) : 7.787 * a + 16 / 116) - 16, 500 * (t - a), 200 * (a - (r = r > .008856 ? Math.pow(r, 1 / 3) : 7.787 * r + 16 / 116))];
  }, o.lab.xyz = function (e) {
    var t,
        a,
        r,
        n = e[0];
    t = e[1] / 500 + (a = (n + 16) / 116), r = a - e[2] / 200;
    var s = Math.pow(a, 3),
        o = Math.pow(t, 3),
        i = Math.pow(r, 3);
    return a = s > .008856 ? s : (a - 16 / 116) / 7.787, t = o > .008856 ? o : (t - 16 / 116) / 7.787, r = i > .008856 ? i : (r - 16 / 116) / 7.787, [t *= 95.047, a *= 100, r *= 108.883];
  }, o.lab.lch = function (e) {
    var t,
        a = e[0],
        r = e[1],
        n = e[2];
    return (t = 360 * Math.atan2(n, r) / 2 / Math.PI) < 0 && (t += 360), [a, Math.sqrt(r * r + n * n), t];
  }, o.lch.lab = function (e) {
    var t,
        a = e[0],
        r = e[1];
    return t = e[2] / 360 * 2 * Math.PI, [a, r * Math.cos(t), r * Math.sin(t)];
  }, o.rgb.ansi16 = function (e) {
    var t = e[0],
        a = e[1],
        r = e[2],
        n = 1 in arguments ? arguments[1] : o.rgb.hsv(e)[2];
    if (0 === (n = Math.round(n / 50))) return 30;
    var s = 30 + (Math.round(r / 255) << 2 | Math.round(a / 255) << 1 | Math.round(t / 255));
    return 2 === n && (s += 60), s;
  }, o.hsv.ansi16 = function (e) {
    return o.rgb.ansi16(o.hsv.rgb(e), e[2]);
  }, o.rgb.ansi256 = function (e) {
    var t = e[0],
        a = e[1],
        r = e[2];
    return t === a && a === r ? t < 8 ? 16 : t > 248 ? 231 : Math.round((t - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(t / 255 * 5) + 6 * Math.round(a / 255 * 5) + Math.round(r / 255 * 5);
  }, o.ansi16.rgb = function (e) {
    var t = e % 10;
    if (0 === t || 7 === t) return e > 50 && (t += 3.5), [t = t / 10.5 * 255, t, t];
    var a = .5 * (1 + ~~(e > 50));
    return [(1 & t) * a * 255, (t >> 1 & 1) * a * 255, (t >> 2 & 1) * a * 255];
  }, o.ansi256.rgb = function (e) {
    if (e >= 232) {
      var t = 10 * (e - 232) + 8;
      return [t, t, t];
    }

    var a;
    return e -= 16, [Math.floor(e / 36) / 5 * 255, Math.floor((a = e % 36) / 6) / 5 * 255, a % 6 / 5 * 255];
  }, o.rgb.hex = function (e) {
    var t = (((255 & Math.round(e[0])) << 16) + ((255 & Math.round(e[1])) << 8) + (255 & Math.round(e[2]))).toString(16).toUpperCase();
    return "000000".substring(t.length) + t;
  }, o.hex.rgb = function (e) {
    var t = e.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!t) return [0, 0, 0];
    var a = t[0];
    3 === t[0].length && (a = a.split("").map(function (e) {
      return e + e;
    }).join(""));
    var r = parseInt(a, 16);
    return [r >> 16 & 255, r >> 8 & 255, 255 & r];
  }, o.rgb.hcg = function (e) {
    var t,
        a = e[0] / 255,
        r = e[1] / 255,
        n = e[2] / 255,
        s = Math.max(Math.max(a, r), n),
        o = Math.min(Math.min(a, r), n),
        i = s - o;
    return t = i <= 0 ? 0 : s === a ? (r - n) / i % 6 : s === r ? 2 + (n - a) / i : 4 + (a - r) / i + 4, t /= 6, [360 * (t %= 1), 100 * i, 100 * (i < 1 ? o / (1 - i) : 0)];
  }, o.hsl.hcg = function (e) {
    var t = e[1] / 100,
        a = e[2] / 100,
        r = 1,
        n = 0;
    return (r = a < .5 ? 2 * t * a : 2 * t * (1 - a)) < 1 && (n = (a - .5 * r) / (1 - r)), [e[0], 100 * r, 100 * n];
  }, o.hsv.hcg = function (e) {
    var t = e[1] / 100,
        a = e[2] / 100,
        r = t * a,
        n = 0;
    return r < 1 && (n = (a - r) / (1 - r)), [e[0], 100 * r, 100 * n];
  }, o.hcg.rgb = function (e) {
    var t = e[0] / 360,
        a = e[1] / 100,
        r = e[2] / 100;
    if (0 === a) return [255 * r, 255 * r, 255 * r];
    var n,
        s = [0, 0, 0],
        o = t % 1 * 6,
        i = o % 1,
        c = 1 - i;

    switch (Math.floor(o)) {
      case 0:
        s[0] = 1, s[1] = i, s[2] = 0;
        break;

      case 1:
        s[0] = c, s[1] = 1, s[2] = 0;
        break;

      case 2:
        s[0] = 0, s[1] = 1, s[2] = i;
        break;

      case 3:
        s[0] = 0, s[1] = c, s[2] = 1;
        break;

      case 4:
        s[0] = i, s[1] = 0, s[2] = 1;
        break;

      default:
        s[0] = 1, s[1] = 0, s[2] = c;
    }

    return n = (1 - a) * r, [255 * (a * s[0] + n), 255 * (a * s[1] + n), 255 * (a * s[2] + n)];
  }, o.hcg.hsv = function (e) {
    var t = e[1] / 100,
        a = t + e[2] / 100 * (1 - t),
        r = 0;
    return a > 0 && (r = t / a), [e[0], 100 * r, 100 * a];
  }, o.hcg.hsl = function (e) {
    var t = e[1] / 100,
        a = e[2] / 100 * (1 - t) + .5 * t,
        r = 0;
    return a > 0 && a < .5 ? r = t / (2 * a) : a >= .5 && a < 1 && (r = t / (2 * (1 - a))), [e[0], 100 * r, 100 * a];
  }, o.hcg.hwb = function (e) {
    var t = e[1] / 100,
        a = t + e[2] / 100 * (1 - t);
    return [e[0], 100 * (a - t), 100 * (1 - a)];
  }, o.hwb.hcg = function (e) {
    var t = e[1] / 100,
        a = 1 - e[2] / 100,
        r = a - t,
        n = 0;
    return r < 1 && (n = (a - r) / (1 - r)), [e[0], 100 * r, 100 * n];
  }, o.apple.rgb = function (e) {
    return [e[0] / 65535 * 255, e[1] / 65535 * 255, e[2] / 65535 * 255];
  }, o.rgb.apple = function (e) {
    return [e[0] / 255 * 65535, e[1] / 255 * 65535, e[2] / 255 * 65535];
  }, o.gray.rgb = function (e) {
    return [e[0] / 100 * 255, e[0] / 100 * 255, e[0] / 100 * 255];
  }, o.gray.hsl = o.gray.hsv = function (e) {
    return [0, 0, e[0]];
  }, o.gray.hwb = function (e) {
    return [0, 100, e[0]];
  }, o.gray.cmyk = function (e) {
    return [0, 0, 0, e[0]];
  }, o.gray.lab = function (e) {
    return [e[0], 0, 0];
  }, o.gray.hex = function (e) {
    var t = 255 & Math.round(e[0] / 100 * 255),
        a = ((t << 16) + (t << 8) + t).toString(16).toUpperCase();
    return "000000".substring(a.length) + a;
  }, o.rgb.gray = function (e) {
    return [(e[0] + e[1] + e[2]) / 3 / 255 * 100];
  };
},
/*!****************************************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/abi_encoder/calldata/blocks/blob.js ***!
  \****************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r14,
      n = this && this.__extends || (_r14 = function r(e, t) {
    return (_r14 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r14(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  });

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var s = function (e) {
    function t(t, a, r, n) {
      var s = this,
          o = n.byteLength;
      return (s = e.call(this, t, a, r, 0, o) || this)._blob = n, s;
    }

    return n(t, e), t.prototype.toBuffer = function () {
      return this._blob;
    }, t.prototype.getRawData = function () {
      return this._blob;
    }, t;
  }(a(
  /*! ../calldata_block */
  105).CalldataBlock);

  t.BlobCalldataBlock = s;
},
/*!*******************************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/abi_encoder/utils/queue.js ***!
  \*******************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var r = function () {
    function e() {
      this._store = [];
    }

    return e.prototype.pushBack = function (e) {
      this._store.push(e);
    }, e.prototype.pushFront = function (e) {
      this._store.unshift(e);
    }, e.prototype.popFront = function () {
      return this._store.shift();
    }, e.prototype.popBack = function () {
      if (0 !== this._store.length) return this._store.splice(-1, 1)[0];
    }, e.prototype.mergeBack = function (e) {
      this._store = this._store.concat(e._store);
    }, e.prototype.mergeFront = function (e) {
      this._store = e._store.concat(this._store);
    }, e.prototype.getStore = function () {
      return this._store;
    }, e.prototype.peekFront = function () {
      return this._store.length >= 0 ? this._store[0] : void 0;
    }, e;
  }();

  t.Queue = r;
},
/*!*****************************************************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/abi_encoder/abstract_data_types/types/pointer.js ***!
  \*****************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r15,
      n = this && this.__extends || (_r15 = function r(e, t) {
    return (_r15 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r15(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  });

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var s = a(
  /*! ethereumjs-util */
  24),
      o = a(
  /*! ../../calldata/blocks/pointer */
  106),
      i = a(
  /*! ../../utils/constants */
  26),
      c = function (e) {
    function t(t, a, r, n) {
      var s = e.call(this, t, a) || this;
      return s._destination = r, s._parent = n, s;
    }

    return n(t, e), t.prototype.generateCalldataBlock = function (e, t) {
      if (void 0 === t) throw new Error("DependentDataType requires a parent block to generate its block");

      var a = this._destination.generateCalldataBlock(e, t),
          r = this.getDataItem().name,
          n = this.getSignature(),
          s = t.getName();

      return new o.PointerCalldataBlock(r, n, s, a, t);
    }, t.prototype.generateValue = function (e, t) {
      var a = e.popWord(),
          r = s.bufferToHex(a),
          n = parseInt(r, i.constants.HEX_BASE),
          o = e.toAbsoluteOffset(n),
          c = e.getOffset();
      e.setOffset(o);

      var u = this._destination.generateValue(e, t);

      return e.setOffset(c), u;
    }, t.prototype.isStatic = function () {
      return !0;
    }, t;
  }(a(
  /*! ../data_type */
  80).DataType);

  t.AbstractPointerDataType = c;
},
/*!******************************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/abi_encoder/utils/math.js ***!
  \******************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = a(
  /*! ethereumjs-util */
  24),
      n = a(
  /*! lodash */
  0),
      s = a(
  /*! ../../configured_bignumber */
  37),
      o = a(
  /*! ../utils/constants */
  26);

  function i(e, t, a) {
    var r = new s.BigNumber(e, 10);
    if (r.isGreaterThan(a)) throw new Error("Tried to assign value of " + r + ", which exceeds max value of " + a);
    if (r.isLessThan(t)) throw new Error("Tried to assign value of " + r + ", which exceeds min value of " + t);
    if (r.isNaN()) throw new Error("Tried to assign NaN value");
  }

  function c(e) {
    var t = "0x" + e.toString(o.constants.HEX_BASE),
        a = r.toBuffer(t);
    return r.setLengthLeft(a, o.constants.EVM_WORD_WIDTH_IN_BYTES);
  }

  function u(e) {
    var t = new s.BigNumber(e, 10);
    if (t.isGreaterThanOrEqualTo(0)) return c(t);
    var a = t.times(-1).toString(o.constants.BIN_BASE),
        r = "1".repeat(o.constants.EVM_WORD_WIDTH_IN_BITS - a.length);
    return n.each(a, function (e) {
      r += "1" === e ? "0" : "1";
    }), c(new s.BigNumber(r, o.constants.BIN_BASE).plus(1));
  }

  function d(e, t) {
    var a = r.bufferToHex(e),
        i = new s.BigNumber(a, o.constants.HEX_BASE);
    if (!t.isLessThan(0)) return i;
    var c = i.toString(o.constants.BIN_BASE);
    if (!(c.length === o.constants.EVM_WORD_WIDTH_IN_BITS && n.startsWith(c[0], "1"))) return i;
    var u = "";
    return n.each(c, function (e) {
      u += "1" === e ? "0" : "1";
    }), new s.BigNumber(u, o.constants.BIN_BASE).plus(1).times(-1);
  }

  t.encodeNumericValue = u, t.safeEncodeNumericValue = function (e, t, a) {
    return i(e, t, a), u(e);
  }, t.decodeNumericValue = d, t.safeDecodeNumericValue = function (e, t, a) {
    var r = d(e, t);
    return i(r, t, a), r;
  };
},
/*!****************************************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/abi_encoder/evm_data_types/tuple.js ***!
  \****************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r16,
      n = this && this.__extends || (_r16 = function r(e, t) {
    return (_r16 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r16(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  });

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var s = a(
  /*! ethereum-types */
  25),
      o = a(
  /*! lodash */
  0),
      i = function (e) {
    function t(a, r) {
      var n = e.call(this, a, r) || this;
      if (!t.matchType(a.type)) throw new Error("Tried to instantiate Tuple with bad input: " + a);
      return n;
    }

    return n(t, e), t.matchType = function (e) {
      return e === s.SolidityTypes.Tuple;
    }, t.prototype.getSignatureType = function () {
      return this._computeSignatureOfMembers(!1);
    }, t.prototype.getSignature = function (e) {
      if (o.isEmpty(this.getDataItem().name) || !e) return this.getSignatureType();
      var t = this.getDataItem().name,
          a = t.lastIndexOf(".");
      return (void 0 !== a && a > 0 ? t.substr(a + 1) : t) + " " + this._computeSignatureOfMembers(e);
    }, t;
  }(a(
  /*! ../abstract_data_types/types/set */
  108).AbstractSetDataType);

  t.TupleDataType = i;
},
/*!*************************************************************!*\
  !*** ./node_modules/@0x/web3-wrapper/lib/src/marshaller.js ***!
  \*************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = this && this.__assign || function () {
    return (r = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = a(
  /*! @0x/utils */
  8),
      s = a(
  /*! ethereum-types */
  25),
      o = a(
  /*! ethereumjs-util */
  473),
      i = a(
  /*! lodash */
  0),
      c = a(
  /*! ./utils */
  180);
  t.marshaller = {
    unmarshalIntoBlockWithoutTransactionData: function unmarshalIntoBlockWithoutTransactionData(e) {
      return r({}, e, {
        gasLimit: c.utils.convertHexToNumber(e.gasLimit),
        gasUsed: c.utils.convertHexToNumber(e.gasUsed),
        size: c.utils.convertHexToNumber(e.size),
        timestamp: c.utils.convertHexToNumber(e.timestamp),
        number: null === e.number ? null : c.utils.convertHexToNumber(e.number),
        difficulty: c.utils.convertAmountToBigNumber(e.difficulty),
        totalDifficulty: c.utils.convertAmountToBigNumber(e.totalDifficulty)
      });
    },
    unmarshalIntoBlockWithTransactionData: function unmarshalIntoBlockWithTransactionData(e) {
      var a = r({}, e, {
        gasLimit: c.utils.convertHexToNumber(e.gasLimit),
        gasUsed: c.utils.convertHexToNumber(e.gasUsed),
        size: c.utils.convertHexToNumber(e.size),
        timestamp: c.utils.convertHexToNumber(e.timestamp),
        number: null === e.number ? null : c.utils.convertHexToNumber(e.number),
        difficulty: c.utils.convertAmountToBigNumber(e.difficulty),
        totalDifficulty: c.utils.convertAmountToBigNumber(e.totalDifficulty),
        transactions: []
      });
      return a.transactions = i.map(e.transactions, function (e) {
        return t.marshaller.unmarshalTransaction(e);
      }), a;
    },
    unmarshalTransaction: function unmarshalTransaction(e) {
      return r({}, e, {
        blockNumber: null !== e.blockNumber ? c.utils.convertHexToNumber(e.blockNumber) : null,
        transactionIndex: null !== e.transactionIndex ? c.utils.convertHexToNumber(e.transactionIndex) : null,
        nonce: c.utils.convertHexToNumber(e.nonce),
        gas: c.utils.convertHexToNumber(e.gas),
        gasPrice: c.utils.convertAmountToBigNumber(e.gasPrice),
        value: c.utils.convertAmountToBigNumber(e.value)
      });
    },
    unmarshalTransactionReceipt: function unmarshalTransactionReceipt(e) {
      return r({}, e, {
        blockNumber: c.utils.convertHexToNumber(e.blockNumber),
        transactionIndex: c.utils.convertHexToNumber(e.transactionIndex),
        cumulativeGasUsed: c.utils.convertHexToNumber(e.cumulativeGasUsed),
        gasUsed: c.utils.convertHexToNumber(e.gasUsed),
        logs: i.map(e.logs, t.marshaller.unmarshalLog.bind(t.marshaller))
      });
    },
    unmarshalTxData: function unmarshalTxData(e) {
      if (void 0 === e.from) throw new Error("txData must include valid 'from' value.");
      return r({}, e, {
        value: void 0 !== e.value ? c.utils.convertAmountToBigNumber(e.value) : void 0,
        gas: void 0 !== e.gas ? c.utils.convertHexToNumber(e.gas) : void 0,
        gasPrice: void 0 !== e.gasPrice ? c.utils.convertAmountToBigNumber(e.gasPrice) : void 0,
        nonce: void 0 !== e.nonce ? c.utils.convertHexToNumber(e.nonce) : void 0
      });
    },
    marshalTxData: function marshalTxData(e) {
      if (void 0 === e.from) throw new Error("txData must include valid 'from' value.");
      var a = r({}, e);
      delete a.from;

      var n = t.marshaller._marshalCallTxDataBase(a),
          s = r({}, n, {
        from: t.marshaller.marshalAddress(e.from)
      }),
          o = ["gasPrice", "gas", "value", "nonce"];

      return i.each(s, function (e, t) {
        void 0 === e && i.includes(o, t) && delete s[t];
      }), s;
    },
    marshalCallData: function marshalCallData(e) {
      var a = r({}, e);
      delete a.from;

      var n = t.marshaller._marshalCallTxDataBase(a);

      return r({}, n, {
        from: void 0 === e.from ? void 0 : t.marshaller.marshalAddress(e.from)
      });
    },
    marshalAddress: function marshalAddress(e) {
      if (n.addressUtils.isAddress(e)) return o.addHexPrefix(e);
      throw new Error("Invalid address encountered: " + e);
    },
    marshalBlockParam: function marshalBlockParam(e) {
      return void 0 === e ? s.BlockParamLiteral.Latest : i.isNumber(e) ? c.utils.numberToHex(e) : e;
    },
    unmarshalLog: function unmarshalLog(e) {
      return r({}, e, {
        logIndex: c.utils.convertHexToNumberOrNull(e.logIndex),
        blockNumber: c.utils.convertHexToNumberOrNull(e.blockNumber),
        transactionIndex: c.utils.convertHexToNumberOrNull(e.transactionIndex)
      });
    },
    _marshalCallTxDataBase: function _marshalCallTxDataBase(e) {
      return r({}, e, {
        to: void 0 === e.to ? void 0 : t.marshaller.marshalAddress(e.to),
        gasPrice: void 0 === e.gasPrice ? void 0 : c.utils.encodeAmountAsHexString(e.gasPrice),
        gas: void 0 === e.gas ? void 0 : c.utils.encodeAmountAsHexString(e.gas),
        value: void 0 === e.value ? void 0 : c.utils.encodeAmountAsHexString(e.value),
        nonce: void 0 === e.nonce ? void 0 : c.utils.encodeAmountAsHexString(e.nonce)
      });
    }
  };
},
/*!********************************************************!*\
  !*** ./node_modules/@0x/web3-wrapper/lib/src/utils.js ***!
  \********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = a(
  /*! @0x/utils */
  8),
      n = a(
  /*! lodash */
  0);
  t.utils = {
    convertHexToNumber: function convertHexToNumber(e) {
      return new r.BigNumber(e).toNumber();
    },
    convertHexToNumberOrNull: function convertHexToNumberOrNull(e) {
      return null === e ? null : t.utils.convertHexToNumber(e);
    },
    convertAmountToBigNumber: function convertAmountToBigNumber(e) {
      var t = e || 0;
      if (r.BigNumber.isBigNumber(t)) return t;
      if (n.isString(t) && (0 === t.indexOf("0x") || 0 === t.indexOf("-0x"))) return new r.BigNumber(t.replace("0x", ""), 16);
      return new r.BigNumber(t.toString(10), 10);
    },
    encodeAmountAsHexString: function encodeAmountAsHexString(e) {
      var a = t.utils.convertAmountToBigNumber(e),
          r = a.toString(16);
      return a.isLessThan(0) ? "-0x" + r.substr(1) : "0x" + r;
    },
    numberToHex: function numberToHex(e) {
      if (!isFinite(e) && !t.utils.isHexStrict(e)) throw new Error("Given input " + e + " is not a number.");
      var a = new r.BigNumber(e),
          n = a.toString(16);
      return a.lt(0) ? "-0x" + n.substr(1) : "0x" + n;
    },
    isHexStrict: function isHexStrict(e) {
      return (n.isString(e) || n.isNumber(e)) && /^(-)?0x[0-9a-f]*$/i.test(n.isNumber(e) ? e.toString() : e);
    }
  };
},
/*!********************************************************!*\
  !*** ./node_modules/@0x/web3-wrapper/lib/src/types.js ***!
  \********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), function (e) {
    e.TransactionMiningTimeout = "TRANSACTION_MINING_TIMEOUT";
  }(t.Web3WrapperErrors || (t.Web3WrapperErrors = {})), function (e) {
    e.Geth = "GETH", e.Ganache = "GANACHE";
  }(t.NodeType || (t.NodeType = {}));
},
/*!****************************************************!*\
  !*** ./node_modules/ethereumjs-util/dist/index.js ***!
  \****************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = a(
  /*! bn.js */
  5);
  t.BN = r;
  var n = a(
  /*! rlp */
  21);
  t.rlp = n;
  var s = a(
  /*! keccak */
  33),
      o = a(
  /*! secp256k1 */
  30);
  t.secp256k1 = o;
  var i = a(
  /*! assert */
  19),
      c = a(
  /*! create-hash */
  20),
      u = a(
  /*! safe-buffer */
  7).Buffer,
      d = a(
  /*! ethjs-util */
  36);

  function f(e, t) {
    return t ? e - (2 * t + 35) : e - 27;
  }

  function l(e) {
    return 0 === e || 1 === e;
  }

  Object.assign(t, d), t.MAX_INTEGER = new r("ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff", 16), t.TWO_POW256 = new r("10000000000000000000000000000000000000000000000000000000000000000", 16), t.KECCAK256_NULL_S = "c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470", t.KECCAK256_NULL = u.from(t.KECCAK256_NULL_S, "hex"), t.KECCAK256_RLP_ARRAY_S = "1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347", t.KECCAK256_RLP_ARRAY = u.from(t.KECCAK256_RLP_ARRAY_S, "hex"), t.KECCAK256_RLP_S = "56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421", t.KECCAK256_RLP = u.from(t.KECCAK256_RLP_S, "hex"), t.zeros = function (e) {
    return u.allocUnsafe(e).fill(0);
  }, t.zeroAddress = function () {
    var e = t.zeros(20);
    return t.bufferToHex(e);
  }, t.setLengthLeft = function (e, a, r) {
    void 0 === r && (r = !1);
    var n = t.zeros(a);
    return e = t.toBuffer(e), r ? e.length < a ? (e.copy(n), n) : e.slice(0, a) : e.length < a ? (e.copy(n, a - e.length), n) : e.slice(-a);
  }, t.setLength = t.setLengthLeft, t.setLengthRight = function (e, a) {
    return t.setLength(e, a, !0);
  }, t.unpad = function (e) {
    for (var t = (e = d.stripHexPrefix(e))[0]; e.length > 0 && "0" === t.toString();) {
      t = (e = e.slice(1))[0];
    }

    return e;
  }, t.stripZeros = t.unpad, t.toBuffer = function (e) {
    if (!u.isBuffer(e)) if (Array.isArray(e)) e = u.from(e);else if ("string" == typeof e) e = t.isHexString(e) ? u.from(t.padToEven(t.stripHexPrefix(e)), "hex") : u.from(e);else if ("number" == typeof e) e = t.intToBuffer(e);else if (null == e) e = u.allocUnsafe(0);else if (r.isBN(e)) e = e.toArrayLike(u);else {
      if (!e.toArray) throw new Error("invalid type");
      e = u.from(e.toArray());
    }
    return e;
  }, t.bufferToInt = function (e) {
    return new r(t.toBuffer(e)).toNumber();
  }, t.bufferToHex = function (e) {
    return "0x" + (e = t.toBuffer(e)).toString("hex");
  }, t.fromSigned = function (e) {
    return new r(e).fromTwos(256);
  }, t.toUnsigned = function (e) {
    return u.from(e.toTwos(256).toArray());
  }, t.keccak = function (e, a) {
    return void 0 === a && (a = 256), e = t.toBuffer(e), a || (a = 256), s("keccak" + a).update(e).digest();
  }, t.keccak256 = function (e) {
    return t.keccak(e);
  }, t.sha256 = function (e) {
    return e = t.toBuffer(e), c("sha256").update(e).digest();
  }, t.ripemd160 = function (e, a) {
    e = t.toBuffer(e);
    var r = c("rmd160").update(e).digest();
    return !0 === a ? t.setLength(r, 32) : r;
  }, t.rlphash = function (e) {
    return t.keccak(n.encode(e));
  }, t.isValidPrivate = function (e) {
    return o.privateKeyVerify(e);
  }, t.isValidPublic = function (e, t) {
    return void 0 === t && (t = !1), 64 === e.length ? o.publicKeyVerify(u.concat([u.from([4]), e])) : !!t && o.publicKeyVerify(e);
  }, t.pubToAddress = function (e, a) {
    return void 0 === a && (a = !1), e = t.toBuffer(e), a && 64 !== e.length && (e = o.publicKeyConvert(e, !1).slice(1)), i(64 === e.length), t.keccak(e).slice(-20);
  }, t.publicToAddress = t.pubToAddress, t.privateToPublic = function (e) {
    return e = t.toBuffer(e), o.publicKeyCreate(e, !1).slice(1);
  }, t.importPublic = function (e) {
    return 64 !== (e = t.toBuffer(e)).length && (e = o.publicKeyConvert(e, !1).slice(1)), e;
  }, t.ecsign = function (e, t, a) {
    var r = o.sign(e, t),
        n = r.recovery;
    return {
      r: r.signature.slice(0, 32),
      s: r.signature.slice(32, 64),
      v: a ? n + (2 * a + 35) : n + 27
    };
  }, t.hashPersonalMessage = function (e) {
    var a = t.toBuffer("Ethereum Signed Message:\n" + e.length.toString());
    return t.keccak(u.concat([a, e]));
  }, t.ecrecover = function (e, a, r, n, s) {
    var i = u.concat([t.setLength(r, 32), t.setLength(n, 32)], 64),
        c = f(a, s);
    if (!l(c)) throw new Error("Invalid signature v value");
    var d = o.recover(e, i, c);
    return o.publicKeyConvert(d, !1).slice(1);
  }, t.toRpcSig = function (e, a, r, n) {
    if (!l(f(e, n))) throw new Error("Invalid signature v value");
    return t.bufferToHex(u.concat([t.setLengthLeft(a, 32), t.setLengthLeft(r, 32), t.toBuffer(e)]));
  }, t.fromRpcSig = function (e) {
    var a = t.toBuffer(e);
    if (65 !== a.length) throw new Error("Invalid signature length");
    var r = a[64];
    return r < 27 && (r += 27), {
      v: r,
      r: a.slice(0, 32),
      s: a.slice(32, 64)
    };
  }, t.privateToAddress = function (e) {
    return t.publicToAddress(t.privateToPublic(e));
  }, t.isValidAddress = function (e) {
    return /^0x[0-9a-fA-F]{40}$/.test(e);
  }, t.isZeroAddress = function (e) {
    return t.zeroAddress() === t.addHexPrefix(e);
  }, t.toChecksumAddress = function (e) {
    e = d.stripHexPrefix(e).toLowerCase();

    for (var a = t.keccak(e).toString("hex"), r = "0x", n = 0; n < e.length; n++) {
      parseInt(a[n], 16) >= 8 ? r += e[n].toUpperCase() : r += e[n];
    }

    return r;
  }, t.isValidChecksumAddress = function (e) {
    return t.isValidAddress(e) && t.toChecksumAddress(e) === e;
  }, t.generateAddress = function (e, a) {
    e = t.toBuffer(e);
    var n = new r(a);
    return n.isZero() ? t.rlphash([e, null]).slice(-20) : t.rlphash([e, u.from(n.toArray())]).slice(-20);
  }, t.generateAddress2 = function (e, a, r) {
    var n = t.toBuffer(e),
        s = t.toBuffer(a),
        o = t.toBuffer(r);
    return i(20 === n.length), i(32 === s.length), t.keccak256(u.concat([u.from("ff", "hex"), n, s, t.keccak256(o)])).slice(-20);
  }, t.isPrecompiled = function (e) {
    var a = t.unpad(e);
    return 1 === a.length && a[0] >= 1 && a[0] <= 8;
  }, t.addHexPrefix = function (e) {
    return "string" != typeof e ? e : d.isHexPrefixed(e) ? e : "0x" + e;
  }, t.isValidSignature = function (e, t, a, n, s) {
    void 0 === n && (n = !0);
    var o = new r("7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a0", 16),
        i = new r("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", 16);
    if (32 !== t.length || 32 !== a.length) return !1;
    if (!l(f(e, s))) return !1;
    var c = new r(t),
        u = new r(a);
    return !(c.isZero() || c.gt(i) || u.isZero() || u.gt(i)) && (!n || 1 !== u.cmp(o));
  }, t.baToJSON = function (e) {
    if (u.isBuffer(e)) return "0x" + e.toString("hex");

    if (e instanceof Array) {
      for (var a = [], r = 0; r < e.length; r++) {
        a.push(t.baToJSON(e[r]));
      }

      return a;
    }
  }, t.defineProperties = function (e, a, r) {
    if (e.raw = [], e._fields = [], e.toJSON = function (a) {
      if (void 0 === a && (a = !1), a) {
        var r = {};
        return e._fields.forEach(function (t) {
          r[t] = "0x" + e[t].toString("hex");
        }), r;
      }

      return t.baToJSON(e.raw);
    }, e.serialize = function () {
      return n.encode(e.raw);
    }, a.forEach(function (a, r) {
      function n() {
        return e.raw[r];
      }

      function s(n) {
        "00" !== (n = t.toBuffer(n)).toString("hex") || a.allowZero || (n = u.allocUnsafe(0)), a.allowLess && a.length ? (n = t.stripZeros(n), i(a.length >= n.length, "The field " + a.name + " must not have more " + a.length + " bytes")) : a.allowZero && 0 === n.length || !a.length || i(a.length === n.length, "The field " + a.name + " must have byte length of " + a.length), e.raw[r] = n;
      }

      e._fields.push(a.name), Object.defineProperty(e, a.name, {
        enumerable: !0,
        configurable: !0,
        get: n,
        set: s
      }), a.default && (e[a.name] = a.default), a.alias && Object.defineProperty(e, a.alias, {
        enumerable: !1,
        configurable: !0,
        set: s,
        get: n
      });
    }), r) if ("string" == typeof r && (r = u.from(d.stripHexPrefix(r), "hex")), u.isBuffer(r) && (r = n.decode(r)), Array.isArray(r)) {
      if (r.length > e._fields.length) throw new Error("wrong number of fields in data");
      r.forEach(function (a, r) {
        e[e._fields[r]] = t.toBuffer(a);
      });
    } else {
      if ("object" != typeof r) throw new Error("invalid data");
      var s = Object.keys(r);
      a.forEach(function (t) {
        -1 !== s.indexOf(t.name) && (e[t.name] = r[t.name]), -1 !== s.indexOf(t.alias) && (e[t.alias] = r[t.alias]);
      });
    }
  };
},
/*!***********************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-util/dist/index.js ***!
  \***********************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
      n = a(
  /*! keccak */
  33),
      s = a(
  /*! secp256k1 */
  30),
      o = a(
  /*! assert */
  19),
      i = a(
  /*! rlp */
  21),
      c = a(
  /*! bn.js */
  5),
      u = a(
  /*! create-hash */
  20),
      d = a(
  /*! safe-buffer */
  7).Buffer;
  Object.assign(t, a(
  /*! ethjs-util */
  36)), t.MAX_INTEGER = new c("ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff", 16), t.TWO_POW256 = new c("10000000000000000000000000000000000000000000000000000000000000000", 16), t.KECCAK256_NULL_S = "c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470", t.SHA3_NULL_S = t.KECCAK256_NULL_S, t.KECCAK256_NULL = d.from(t.KECCAK256_NULL_S, "hex"), t.SHA3_NULL = t.KECCAK256_NULL, t.KECCAK256_RLP_ARRAY_S = "1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347", t.SHA3_RLP_ARRAY_S = t.KECCAK256_RLP_ARRAY_S, t.KECCAK256_RLP_ARRAY = d.from(t.KECCAK256_RLP_ARRAY_S, "hex"), t.SHA3_RLP_ARRAY = t.KECCAK256_RLP_ARRAY, t.KECCAK256_RLP_S = "56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421", t.SHA3_RLP_S = t.KECCAK256_RLP_S, t.KECCAK256_RLP = d.from(t.KECCAK256_RLP_S, "hex"), t.SHA3_RLP = t.KECCAK256_RLP, t.BN = c, t.rlp = i, t.secp256k1 = s, t.zeros = function (e) {
    return d.allocUnsafe(e).fill(0);
  }, t.zeroAddress = function () {
    var e = t.zeros(20);
    return t.bufferToHex(e);
  }, t.setLengthLeft = t.setLength = function (e, a, r) {
    var n = t.zeros(a);
    return e = t.toBuffer(e), r ? e.length < a ? (e.copy(n), n) : e.slice(0, a) : e.length < a ? (e.copy(n, a - e.length), n) : e.slice(-a);
  }, t.setLengthRight = function (e, a) {
    return t.setLength(e, a, !0);
  }, t.unpad = t.stripZeros = function (e) {
    for (var a = (e = t.stripHexPrefix(e))[0]; e.length > 0 && "0" === a.toString();) {
      a = (e = e.slice(1))[0];
    }

    return e;
  }, t.toBuffer = function (e) {
    if (!d.isBuffer(e)) if (Array.isArray(e)) e = d.from(e);else if ("string" == typeof e) e = t.isHexString(e) ? d.from(t.padToEven(t.stripHexPrefix(e)), "hex") : d.from(e);else if ("number" == typeof e) e = t.intToBuffer(e);else if (null == e) e = d.allocUnsafe(0);else if (c.isBN(e)) e = e.toArrayLike(d);else {
      if (!e.toArray) throw new Error("invalid type");
      e = d.from(e.toArray());
    }
    return e;
  }, t.bufferToInt = function (e) {
    return new c(t.toBuffer(e)).toNumber();
  }, t.bufferToHex = function (e) {
    return "0x" + (e = t.toBuffer(e)).toString("hex");
  }, t.fromSigned = function (e) {
    return new c(e).fromTwos(256);
  }, t.toUnsigned = function (e) {
    return d.from(e.toTwos(256).toArray());
  }, t.keccak = function (e, a) {
    return e = t.toBuffer(e), a || (a = 256), n("keccak" + a).update(e).digest();
  }, t.keccak256 = function (e) {
    return t.keccak(e);
  }, t.sha3 = t.keccak, t.sha256 = function (e) {
    return e = t.toBuffer(e), u("sha256").update(e).digest();
  }, t.ripemd160 = function (e, a) {
    e = t.toBuffer(e);
    var r = u("rmd160").update(e).digest();
    return !0 === a ? t.setLength(r, 32) : r;
  }, t.rlphash = function (e) {
    return t.keccak(i.encode(e));
  }, t.isValidPrivate = function (e) {
    return s.privateKeyVerify(e);
  }, t.isValidPublic = function (e, t) {
    return 64 === e.length ? s.publicKeyVerify(d.concat([d.from([4]), e])) : !!t && s.publicKeyVerify(e);
  }, t.pubToAddress = t.publicToAddress = function (e, a) {
    return e = t.toBuffer(e), a && 64 !== e.length && (e = s.publicKeyConvert(e, !1).slice(1)), o(64 === e.length), t.keccak(e).slice(-20);
  };

  var f = t.privateToPublic = function (e) {
    return e = t.toBuffer(e), s.publicKeyCreate(e, !1).slice(1);
  };

  t.importPublic = function (e) {
    return 64 !== (e = t.toBuffer(e)).length && (e = s.publicKeyConvert(e, !1).slice(1)), e;
  }, t.ecsign = function (e, t) {
    var a = s.sign(e, t),
        r = {};
    return r.r = a.signature.slice(0, 32), r.s = a.signature.slice(32, 64), r.v = a.recovery + 27, r;
  }, t.hashPersonalMessage = function (e) {
    var a = t.toBuffer("Ethereum Signed Message:\n" + e.length.toString());
    return t.keccak(d.concat([a, e]));
  }, t.ecrecover = function (e, a, r, n) {
    var o = d.concat([t.setLength(r, 32), t.setLength(n, 32)], 64),
        i = a - 27;
    if (0 !== i && 1 !== i) throw new Error("Invalid signature v value");
    var c = s.recover(e, o, i);
    return s.publicKeyConvert(c, !1).slice(1);
  }, t.toRpcSig = function (e, a, r) {
    if (27 !== e && 28 !== e) throw new Error("Invalid recovery id");
    return t.bufferToHex(d.concat([t.setLengthLeft(a, 32), t.setLengthLeft(r, 32), t.toBuffer(e - 27)]));
  }, t.fromRpcSig = function (e) {
    if (65 !== (e = t.toBuffer(e)).length) throw new Error("Invalid signature length");
    var a = e[64];
    return a < 27 && (a += 27), {
      v: a,
      r: e.slice(0, 32),
      s: e.slice(32, 64)
    };
  }, t.privateToAddress = function (e) {
    return t.publicToAddress(f(e));
  }, t.isValidAddress = function (e) {
    return /^0x[0-9a-fA-F]{40}$/.test(e);
  }, t.isZeroAddress = function (e) {
    return t.zeroAddress() === t.addHexPrefix(e);
  }, t.toChecksumAddress = function (e) {
    e = t.stripHexPrefix(e).toLowerCase();

    for (var a = t.keccak(e).toString("hex"), r = "0x", n = 0; n < e.length; n++) {
      parseInt(a[n], 16) >= 8 ? r += e[n].toUpperCase() : r += e[n];
    }

    return r;
  }, t.isValidChecksumAddress = function (e) {
    return t.isValidAddress(e) && t.toChecksumAddress(e) === e;
  }, t.generateAddress = function (e, a) {
    return e = t.toBuffer(e), a = (a = new c(a)).isZero() ? null : d.from(a.toArray()), t.rlphash([e, a]).slice(-20);
  }, t.isPrecompiled = function (e) {
    var a = t.unpad(e);
    return 1 === a.length && a[0] >= 1 && a[0] <= 8;
  }, t.addHexPrefix = function (e) {
    return "string" != typeof e ? e : t.isHexPrefixed(e) ? e : "0x" + e;
  }, t.isValidSignature = function (e, t, a, r) {
    var n = new c("7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a0", 16),
        s = new c("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", 16);
    return 32 === t.length && 32 === a.length && (27 === e || 28 === e) && (t = new c(t), a = new c(a), !(t.isZero() || t.gt(s) || a.isZero() || a.gt(s)) && (!1 !== r || 1 !== new c(a).cmp(n)));
  }, t.baToJSON = function (e) {
    if (d.isBuffer(e)) return "0x" + e.toString("hex");

    if (e instanceof Array) {
      for (var a = [], r = 0; r < e.length; r++) {
        a.push(t.baToJSON(e[r]));
      }

      return a;
    }
  }, t.defineProperties = function (e, a, n) {
    if (e.raw = [], e._fields = [], e.toJSON = function (a) {
      if (a) {
        var r = {};
        return e._fields.forEach(function (t) {
          r[t] = "0x" + e[t].toString("hex");
        }), r;
      }

      return t.baToJSON(this.raw);
    }, e.serialize = function () {
      return i.encode(e.raw);
    }, a.forEach(function (a, r) {
      function n() {
        return e.raw[r];
      }

      function s(n) {
        "00" !== (n = t.toBuffer(n)).toString("hex") || a.allowZero || (n = d.allocUnsafe(0)), a.allowLess && a.length ? (n = t.stripZeros(n), o(a.length >= n.length, "The field " + a.name + " must not have more " + a.length + " bytes")) : a.allowZero && 0 === n.length || !a.length || o(a.length === n.length, "The field " + a.name + " must have byte length of " + a.length), e.raw[r] = n;
      }

      e._fields.push(a.name), Object.defineProperty(e, a.name, {
        enumerable: !0,
        configurable: !0,
        get: n,
        set: s
      }), a.default && (e[a.name] = a.default), a.alias && Object.defineProperty(e, a.alias, {
        enumerable: !1,
        configurable: !0,
        set: s,
        get: n
      });
    }), n) if ("string" == typeof n && (n = d.from(t.stripHexPrefix(n), "hex")), d.isBuffer(n) && (n = i.decode(n)), Array.isArray(n)) {
      if (n.length > e._fields.length) throw new Error("wrong number of fields in data");
      n.forEach(function (a, r) {
        e[e._fields[r]] = t.toBuffer(a);
      });
    } else {
      if ("object" !== (void 0 === n ? "undefined" : r(n))) throw new Error("invalid data");
      var s = Object.keys(n);
      a.forEach(function (t) {
        -1 !== s.indexOf(t.name) && (e[t.name] = n[t.name]), -1 !== s.indexOf(t.alias) && (e[t.alias] = n[t.alias]);
      });
    }
  };
},
/*!****************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-blockchain/dist/util.js ***!
  \****************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    t.headsKey = "heads";
    t.headHeaderKey = "LastHeader";
    t.headBlockKey = "LastBlock";

    var a = e.from("h"),
        r = e.from("t"),
        n = e.from("n"),
        s = e.from("H"),
        o = e.from("b"),
        i = function i(t) {
      return t.toArrayLike(e, "be", 8);
    };

    t.bufBE8 = i;

    t.tdKey = function (t, n) {
      return e.concat([a, i(t), n, r]);
    };

    t.headerKey = function (t, r) {
      return e.concat([a, i(t), r]);
    };

    t.bodyKey = function (t, a) {
      return e.concat([o, i(t), a]);
    };

    t.numberToHashKey = function (t) {
      return e.concat([a, i(t), n]);
    };

    t.hashToNumberKey = function (t) {
      return e.concat([s, t]);
    };
  }).call(this, a(
  /*! ./../../../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!*********************************************!*\
  !*** ./node_modules/level-mem/level-mem.js ***!
  \*********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  e.exports = a(
  /*! level-packager */
  500)(a(
  /*! memdown */
  511));
},
/*!**************************************************************!*\
  !*** ./node_modules/abstract-leveldown/abstract-iterator.js ***!
  \**************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    function a(e) {
      this.db = e, this._ended = !1, this._nexting = !1;
    }

    a.prototype.next = function (e) {
      var a = this;
      if ("function" != typeof e) throw new Error("next() requires a callback argument");
      return a._ended ? (t.nextTick(e, new Error("cannot call next() after end()")), a) : a._nexting ? (t.nextTick(e, new Error("cannot call next() before previous next() has completed")), a) : (a._nexting = !0, a._next(function () {
        a._nexting = !1, e.apply(null, arguments);
      }), a);
    }, a.prototype._next = function (e) {
      t.nextTick(e);
    }, a.prototype.end = function (e) {
      if ("function" != typeof e) throw new Error("end() requires a callback argument");
      if (this._ended) return t.nextTick(e, new Error("end() already called on iterator"));
      this._ended = !0, this._end(e);
    }, a.prototype._end = function (e) {
      t.nextTick(e);
    }, e.exports = a;
  }).call(this, a(
  /*! ./../process/browser.js */
  9));
},
/*!*******************************************************************!*\
  !*** ./node_modules/abstract-leveldown/abstract-chained-batch.js ***!
  \*******************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    function a(e) {
      this._db = e, this._operations = [], this._written = !1;
    }

    a.prototype._serializeKey = function (e) {
      return this._db._serializeKey(e);
    }, a.prototype._serializeValue = function (e) {
      return this._db._serializeValue(e);
    }, a.prototype._checkWritten = function () {
      if (this._written) throw new Error("write() already called on this batch");
    }, a.prototype.put = function (e, t) {
      this._checkWritten();

      var a = this._db._checkKey(e, "key");

      if (a) throw a;
      return e = this._serializeKey(e), t = this._serializeValue(t), this._put(e, t), this;
    }, a.prototype._put = function (e, t) {
      this._operations.push({
        type: "put",
        key: e,
        value: t
      });
    }, a.prototype.del = function (e) {
      this._checkWritten();

      var t = this._db._checkKey(e, "key");

      if (t) throw t;
      return e = this._serializeKey(e), this._del(e), this;
    }, a.prototype._del = function (e) {
      this._operations.push({
        type: "del",
        key: e
      });
    }, a.prototype.clear = function () {
      return this._checkWritten(), this._operations = [], this._clear(), this;
    }, a.prototype._clear = function () {}, a.prototype.write = function (e, a) {
      if (this._checkWritten(), "function" == typeof e && (a = e), "function" != typeof a) throw new Error("write() requires a callback argument");
      return "object" != typeof e && (e = {}), this._written = !0, "function" == typeof this._write ? this._write(a) : "function" == typeof this._db._batch ? this._db._batch(this._operations, e, a) : void t.nextTick(a);
    }, e.exports = a;
  }).call(this, a(
  /*! ./../process/browser.js */
  9));
},
/*!*********************************!*\
  !*** ./node_modules/prr/prr.js ***!
  \*********************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  /*!
    * prr
    * (c) 2013 Rod Vagg <rod@vagg.org>
    * https://github.com/rvagg/prr
    * License: MIT
    */
  var r, n;
  r = this, n = function n() {
    var e = "function" == typeof Object.defineProperty ? function (e, t, a) {
      return Object.defineProperty(e, t, a), e;
    } : function (e, t, a) {
      return e[t] = a.value, e;
    };
    return function (t, a, r, n) {
      var s;

      if (n = function (e, t) {
        var a = "object" == typeof t,
            r = !a && "string" == typeof t,
            n = function n(e) {
          return a ? !!t[e] : !!r && t.indexOf(e[0]) > -1;
        };

        return {
          enumerable: n("enumerable"),
          configurable: n("configurable"),
          writable: n("writable"),
          value: e
        };
      }(r, n), "object" == typeof a) {
        for (s in a) {
          Object.hasOwnProperty.call(a, s) && (n.value = a[s], e(t, s, n));
        }

        return t;
      }

      return e(t, a, n);
    };
  }, e.exports ? e.exports = n() : r.prr = n();
},
/*!***********************************************!*\
  !*** ./node_modules/levelup/lib/promisify.js ***!
  \***********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = function () {
    var e,
        t = new Promise(function (t, a) {
      e = function e(_e3, r) {
        _e3 ? a(_e3) : t(r);
      };
    });
    return e.promise = t, e;
  };
},
/*!************************************!*\
  !*** ./node_modules/ltgt/index.js ***!
  \************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (e) {
    function a(e) {
      return void 0 !== e && "" !== e;
    }

    function r(e, t) {
      return Object.hasOwnProperty.call(e, t);
    }

    function n(e, t) {
      return Object.hasOwnProperty.call(e, t) && t;
    }

    t.compare = function (t, a) {
      if (e.isBuffer(t)) {
        for (var r = Math.min(t.length, a.length), n = 0; n < r; n++) {
          var s = t[n] - a[n];
          if (s) return s;
        }

        return t.length - a.length;
      }

      return t < a ? -1 : t > a ? 1 : 0;
    };

    var s = t.lowerBoundKey = function (e) {
      return n(e, "gt") || n(e, "gte") || n(e, "min") || (e.reverse ? n(e, "end") : n(e, "start")) || void 0;
    },
        o = t.lowerBound = function (e, t) {
      var a = s(e);
      return a ? e[a] : t;
    },
        i = t.lowerBoundInclusive = function (e) {
      return !r(e, "gt");
    },
        c = t.upperBoundInclusive = function (e) {
      return !r(e, "lt");
    },
        u = t.lowerBoundExclusive = function (e) {
      return !i(e);
    },
        d = t.upperBoundExclusive = function (e) {
      return !c(e);
    },
        f = t.upperBoundKey = function (e) {
      return n(e, "lt") || n(e, "lte") || n(e, "max") || (e.reverse ? n(e, "start") : n(e, "end")) || void 0;
    },
        l = t.upperBound = function (e, t) {
      var a = f(e);
      return a ? e[a] : t;
    };

    function h(e) {
      return e;
    }

    t.start = function (e, t) {
      return e.reverse ? l(e, t) : o(e, t);
    }, t.end = function (e, t) {
      return e.reverse ? o(e, t) : l(e, t);
    }, t.startInclusive = function (e) {
      return e.reverse ? c(e) : i(e);
    }, t.endInclusive = function (e) {
      return e.reverse ? i(e) : c(e);
    }, t.toLtgt = function (e, a, n, s, o) {
      a = a || {}, n = n || h;
      var i = arguments.length > 3,
          c = t.lowerBoundKey(e),
          u = t.upperBoundKey(e);
      return c ? "gt" === c ? a.gt = n(e.gt, !1) : a.gte = n(e[c], !1) : i && (a.gte = n(s, !1)), u ? "lt" === u ? a.lt = n(e.lt, !0) : a.lte = n(e[u], !0) : i && (a.lte = n(o, !0)), null != e.reverse && (a.reverse = !!e.reverse), r(a, "max") && delete a.max, r(a, "min") && delete a.min, r(a, "start") && delete a.start, r(a, "end") && delete a.end, a;
    }, t.contains = function (e, r, n) {
      n = n || t.compare;
      var s = o(e);
      if (a(s) && ((i = n(r, s)) < 0 || 0 === i && u(e))) return !1;
      var i,
          c = l(e);
      if (a(c) && ((i = n(r, c)) > 0 || 0 === i && d(e))) return !1;
      return !0;
    }, t.filter = function (e, a) {
      return function (r) {
        return t.contains(e, r, a);
      };
    };
  }).call(this, a(
  /*! ./../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!*********************************************!*\
  !*** ./node_modules/immediate/lib/index.js ***!
  \*********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r,
      n,
      s,
      o = [a(
  /*! ./nextTick */
  514), a(
  /*! ./mutation.js */
  515), a(
  /*! ./messageChannel */
  516), a(
  /*! ./stateChange */
  517), a(
  /*! ./timeout */
  518)],
      i = -1,
      c = [],
      u = !1;

  function d() {
    r && n && (r = !1, n.length ? c = n.concat(c) : i = -1, c.length && f());
  }

  function f() {
    if (!r) {
      u = !1, r = !0;

      for (var e = c.length, t = setTimeout(d); e;) {
        for (n = c, c = []; n && ++i < e;) {
          n[i].run();
        }

        i = -1, e = c.length;
      }

      n = null, i = -1, r = !1, clearTimeout(t);
    }
  }

  for (var l = -1, h = o.length; ++l < h;) {
    if (o[l] && o[l].test && o[l].test()) {
      s = o[l].install(f);
      break;
    }
  }

  function p(e, t) {
    this.fun = e, this.array = t;
  }

  p.prototype.run = function () {
    var e = this.fun,
        t = this.array;

    switch (t.length) {
      case 0:
        return e();

      case 1:
        return e(t[0]);

      case 2:
        return e(t[0], t[1]);

      case 3:
        return e(t[0], t[1], t[2]);

      default:
        return e.apply(null, t);
    }
  }, e.exports = function (e) {
    var t = new Array(arguments.length - 1);
    if (arguments.length > 1) for (var a = 1; a < arguments.length; a++) {
      t[a - 1] = arguments[a];
    }
    c.push(new p(e, t)), u || r || (u = !0, s());
  };
},
/*!******************************************************!*\
  !*** ./node_modules/ethereumjs-common/dist/index.js ***!
  \******************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = this && this.__assign || function () {
    return (r = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var n = a(
  /*! ./chains */
  519),
      s = a(
  /*! ./hardforks */
  525),
      o = function () {
    function e(e, t, a) {
      this._chainParams = this.setChain(e), this._hardfork = null, this._supportedHardforks = void 0 === a ? [] : a, t && this.setHardfork(t);
    }

    return e.forCustomChain = function (t, a, n, s) {
      var o = e._getChainParams(t);

      return new e(r({}, o, a), n, s);
    }, e._getChainParams = function (e) {
      if ("number" == typeof e) {
        if (n.chains.names[e]) return n.chains[n.chains.names[e]];
        throw new Error("Chain with ID " + e + " not supported");
      }

      if (n.chains[e]) return n.chains[e];
      throw new Error("Chain with name " + e + " not supported");
    }, e.prototype.setChain = function (t) {
      if ("number" == typeof t || "string" == typeof t) this._chainParams = e._getChainParams(t);else {
        if ("object" != typeof t) throw new Error("Wrong input format");

        for (var a = 0, r = ["networkId", "genesis", "hardforks", "bootstrapNodes"]; a < r.length; a++) {
          var n = r[a];
          if (void 0 === t[n]) throw new Error("Missing required chain parameter: " + n);
        }

        this._chainParams = t;
      }
      return this._chainParams;
    }, e.prototype.setHardfork = function (e) {
      if (!this._isSupportedHardfork(e)) throw new Error("Hardfork " + e + " not set as supported in supportedHardforks");

      for (var t = !1, a = 0, r = s.hardforks; a < r.length; a++) {
        r[a][0] === e && (this._hardfork = e, t = !0);
      }

      if (!t) throw new Error("Hardfork with name " + e + " not supported");
    }, e.prototype._chooseHardfork = function (e, t) {
      if (t = void 0 === t || t, e) {
        if (t && !this._isSupportedHardfork(e)) throw new Error("Hardfork " + e + " not set as supported in supportedHardforks");
      } else {
        if (!this._hardfork) throw new Error("Method called with neither a hardfork set nor provided by param");
        e = this._hardfork;
      }

      return e;
    }, e.prototype._getHardfork = function (e) {
      for (var t = 0, a = this.hardforks(); t < a.length; t++) {
        var r = a[t];
        if (r.name === e) return r;
      }

      throw new Error("Hardfork " + e + " not defined for chain " + this.chainName());
    }, e.prototype._isSupportedHardfork = function (e) {
      if (!(this._supportedHardforks.length > 0)) return !0;

      for (var t = 0, a = this._supportedHardforks; t < a.length; t++) {
        if (e === a[t]) return !0;
      }

      return !1;
    }, e.prototype.param = function (e, t, a) {
      var r;
      a = this._chooseHardfork(a);

      for (var n = 0, o = s.hardforks; n < o.length; n++) {
        var i = o[n];
        if (!i[1][e]) throw new Error("Topic " + e + " not defined");
        if (void 0 !== i[1][e][t] && (r = i[1][e][t].v), i[0] === a) break;
      }

      if (void 0 === r) throw new Error(e + " value for " + t + " not found");
      return r;
    }, e.prototype.paramByBlock = function (e, t, a) {
      var r = this.activeHardforks(a),
          n = r[r.length - 1].name;
      return this.param(e, t, n);
    }, e.prototype.hardforkIsActiveOnBlock = function (e, t, a) {
      var r = void 0 !== (a = void 0 !== a ? a : {}).onlySupported && a.onlySupported;
      e = this._chooseHardfork(e, r);
      var n = this.hardforkBlock(e);
      return null !== n && t >= n;
    }, e.prototype.activeOnBlock = function (e, t) {
      return this.hardforkIsActiveOnBlock(null, e, t);
    }, e.prototype.hardforkGteHardfork = function (e, t, a) {
      var r = void 0 !== (a = void 0 !== a ? a : {}).onlyActive && a.onlyActive;
      e = this._chooseHardfork(e, a.onlySupported);

      for (var n = -1, s = -1, o = 0, i = 0, c = r ? this.activeHardforks(null, a) : this.hardforks(); i < c.length; i++) {
        var u = c[i];
        u.name === e && (n = o), u.name === t && (s = o), o += 1;
      }

      return n >= s;
    }, e.prototype.gteHardfork = function (e, t) {
      return this.hardforkGteHardfork(null, e, t);
    }, e.prototype.hardforkIsActiveOnChain = function (e, t) {
      var a = void 0 !== (t = void 0 !== t ? t : {}).onlySupported && t.onlySupported;
      e = this._chooseHardfork(e, a);

      for (var r = 0, n = this.hardforks(); r < n.length; r++) {
        var s = n[r];
        if (s.name === e && null !== s.block) return !0;
      }

      return !1;
    }, e.prototype.activeHardforks = function (e, t) {
      t = void 0 !== t ? t : {};

      for (var a = [], r = 0, n = this.hardforks(); r < n.length; r++) {
        var s = n[r];

        if (null !== s.block) {
          if (null != e && e < s.block) break;
          t.onlySupported && !this._isSupportedHardfork(s.name) || a.push(s);
        }
      }

      return a;
    }, e.prototype.activeHardfork = function (e, t) {
      t = void 0 !== t ? t : {};
      var a = this.activeHardforks(e, t);
      if (a.length > 0) return a[a.length - 1].name;
      throw new Error("No (supported) active hardfork found");
    }, e.prototype.hardforkBlock = function (e) {
      return e = this._chooseHardfork(e, !1), this._getHardfork(e).block;
    }, e.prototype.isHardforkBlock = function (e, t) {
      return t = this._chooseHardfork(t, !1), this.hardforkBlock(t) === e;
    }, e.prototype.consensus = function (e) {
      return e = this._chooseHardfork(e), this._getHardfork(e).consensus;
    }, e.prototype.finality = function (e) {
      return e = this._chooseHardfork(e), this._getHardfork(e).finality;
    }, e.prototype.genesis = function () {
      return this._chainParams.genesis;
    }, e.prototype.hardforks = function () {
      return this._chainParams.hardforks;
    }, e.prototype.bootstrapNodes = function () {
      return this._chainParams.bootstrapNodes;
    }, e.prototype.hardfork = function () {
      return this._hardfork;
    }, e.prototype.chainId = function () {
      return this._chainParams.chainId;
    }, e.prototype.chainName = function () {
      return n.chains.names[this.chainId()] || this._chainParams.name;
    }, e.prototype.networkId = function () {
      return this._chainParams.networkId;
    }, e;
  }();

  t.default = o;
},
/*!**********************************************************************************!*\
  !*** ./node_modules/ethereumjs-block/node_modules/ethereumjs-util/dist/index.js ***!
  \**********************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
      n = a(
  /*! keccak */
  33),
      s = a(
  /*! secp256k1 */
  30),
      o = a(
  /*! assert */
  19),
      i = a(
  /*! rlp */
  21),
      c = a(
  /*! bn.js */
  5),
      u = a(
  /*! create-hash */
  20),
      d = a(
  /*! safe-buffer */
  7).Buffer;
  Object.assign(t, a(
  /*! ethjs-util */
  36)), t.MAX_INTEGER = new c("ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff", 16), t.TWO_POW256 = new c("10000000000000000000000000000000000000000000000000000000000000000", 16), t.KECCAK256_NULL_S = "c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470", t.SHA3_NULL_S = t.KECCAK256_NULL_S, t.KECCAK256_NULL = d.from(t.KECCAK256_NULL_S, "hex"), t.SHA3_NULL = t.KECCAK256_NULL, t.KECCAK256_RLP_ARRAY_S = "1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347", t.SHA3_RLP_ARRAY_S = t.KECCAK256_RLP_ARRAY_S, t.KECCAK256_RLP_ARRAY = d.from(t.KECCAK256_RLP_ARRAY_S, "hex"), t.SHA3_RLP_ARRAY = t.KECCAK256_RLP_ARRAY, t.KECCAK256_RLP_S = "56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421", t.SHA3_RLP_S = t.KECCAK256_RLP_S, t.KECCAK256_RLP = d.from(t.KECCAK256_RLP_S, "hex"), t.SHA3_RLP = t.KECCAK256_RLP, t.BN = c, t.rlp = i, t.secp256k1 = s, t.zeros = function (e) {
    return d.allocUnsafe(e).fill(0);
  }, t.zeroAddress = function () {
    var e = t.zeros(20);
    return t.bufferToHex(e);
  }, t.setLengthLeft = t.setLength = function (e, a, r) {
    var n = t.zeros(a);
    return e = t.toBuffer(e), r ? e.length < a ? (e.copy(n), n) : e.slice(0, a) : e.length < a ? (e.copy(n, a - e.length), n) : e.slice(-a);
  }, t.setLengthRight = function (e, a) {
    return t.setLength(e, a, !0);
  }, t.unpad = t.stripZeros = function (e) {
    for (var a = (e = t.stripHexPrefix(e))[0]; e.length > 0 && "0" === a.toString();) {
      a = (e = e.slice(1))[0];
    }

    return e;
  }, t.toBuffer = function (e) {
    if (!d.isBuffer(e)) if (Array.isArray(e)) e = d.from(e);else if ("string" == typeof e) e = t.isHexString(e) ? d.from(t.padToEven(t.stripHexPrefix(e)), "hex") : d.from(e);else if ("number" == typeof e) e = t.intToBuffer(e);else if (null == e) e = d.allocUnsafe(0);else if (c.isBN(e)) e = e.toArrayLike(d);else {
      if (!e.toArray) throw new Error("invalid type");
      e = d.from(e.toArray());
    }
    return e;
  }, t.bufferToInt = function (e) {
    return new c(t.toBuffer(e)).toNumber();
  }, t.bufferToHex = function (e) {
    return "0x" + (e = t.toBuffer(e)).toString("hex");
  }, t.fromSigned = function (e) {
    return new c(e).fromTwos(256);
  }, t.toUnsigned = function (e) {
    return d.from(e.toTwos(256).toArray());
  }, t.keccak = function (e, a) {
    return e = t.toBuffer(e), a || (a = 256), n("keccak" + a).update(e).digest();
  }, t.keccak256 = function (e) {
    return t.keccak(e);
  }, t.sha3 = t.keccak, t.sha256 = function (e) {
    return e = t.toBuffer(e), u("sha256").update(e).digest();
  }, t.ripemd160 = function (e, a) {
    e = t.toBuffer(e);
    var r = u("rmd160").update(e).digest();
    return !0 === a ? t.setLength(r, 32) : r;
  }, t.rlphash = function (e) {
    return t.keccak(i.encode(e));
  }, t.isValidPrivate = function (e) {
    return s.privateKeyVerify(e);
  }, t.isValidPublic = function (e, t) {
    return 64 === e.length ? s.publicKeyVerify(d.concat([d.from([4]), e])) : !!t && s.publicKeyVerify(e);
  }, t.pubToAddress = t.publicToAddress = function (e, a) {
    return e = t.toBuffer(e), a && 64 !== e.length && (e = s.publicKeyConvert(e, !1).slice(1)), o(64 === e.length), t.keccak(e).slice(-20);
  };

  var f = t.privateToPublic = function (e) {
    return e = t.toBuffer(e), s.publicKeyCreate(e, !1).slice(1);
  };

  t.importPublic = function (e) {
    return 64 !== (e = t.toBuffer(e)).length && (e = s.publicKeyConvert(e, !1).slice(1)), e;
  }, t.ecsign = function (e, t) {
    var a = s.sign(e, t),
        r = {};
    return r.r = a.signature.slice(0, 32), r.s = a.signature.slice(32, 64), r.v = a.recovery + 27, r;
  }, t.hashPersonalMessage = function (e) {
    var a = t.toBuffer("Ethereum Signed Message:\n" + e.length.toString());
    return t.keccak(d.concat([a, e]));
  }, t.ecrecover = function (e, a, r, n) {
    var o = d.concat([t.setLength(r, 32), t.setLength(n, 32)], 64),
        i = a - 27;
    if (0 !== i && 1 !== i) throw new Error("Invalid signature v value");
    var c = s.recover(e, o, i);
    return s.publicKeyConvert(c, !1).slice(1);
  }, t.toRpcSig = function (e, a, r) {
    if (27 !== e && 28 !== e) throw new Error("Invalid recovery id");
    return t.bufferToHex(d.concat([t.setLengthLeft(a, 32), t.setLengthLeft(r, 32), t.toBuffer(e - 27)]));
  }, t.fromRpcSig = function (e) {
    if (65 !== (e = t.toBuffer(e)).length) throw new Error("Invalid signature length");
    var a = e[64];
    return a < 27 && (a += 27), {
      v: a,
      r: e.slice(0, 32),
      s: e.slice(32, 64)
    };
  }, t.privateToAddress = function (e) {
    return t.publicToAddress(f(e));
  }, t.isValidAddress = function (e) {
    return /^0x[0-9a-fA-F]{40}$/.test(e);
  }, t.isZeroAddress = function (e) {
    return t.zeroAddress() === t.addHexPrefix(e);
  }, t.toChecksumAddress = function (e) {
    e = t.stripHexPrefix(e).toLowerCase();

    for (var a = t.keccak(e).toString("hex"), r = "0x", n = 0; n < e.length; n++) {
      parseInt(a[n], 16) >= 8 ? r += e[n].toUpperCase() : r += e[n];
    }

    return r;
  }, t.isValidChecksumAddress = function (e) {
    return t.isValidAddress(e) && t.toChecksumAddress(e) === e;
  }, t.generateAddress = function (e, a) {
    return e = t.toBuffer(e), a = (a = new c(a)).isZero() ? null : d.from(a.toArray()), t.rlphash([e, a]).slice(-20);
  }, t.isPrecompiled = function (e) {
    var a = t.unpad(e);
    return 1 === a.length && a[0] >= 1 && a[0] <= 8;
  }, t.addHexPrefix = function (e) {
    return "string" != typeof e ? e : t.isHexPrefixed(e) ? e : "0x" + e;
  }, t.isValidSignature = function (e, t, a, r) {
    var n = new c("7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a0", 16),
        s = new c("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", 16);
    return 32 === t.length && 32 === a.length && (27 === e || 28 === e) && (t = new c(t), a = new c(a), !(t.isZero() || t.gt(s) || a.isZero() || a.gt(s)) && (!1 !== r || 1 !== new c(a).cmp(n)));
  }, t.baToJSON = function (e) {
    if (d.isBuffer(e)) return "0x" + e.toString("hex");

    if (e instanceof Array) {
      for (var a = [], r = 0; r < e.length; r++) {
        a.push(t.baToJSON(e[r]));
      }

      return a;
    }
  }, t.defineProperties = function (e, a, n) {
    if (e.raw = [], e._fields = [], e.toJSON = function (a) {
      if (a) {
        var r = {};
        return e._fields.forEach(function (t) {
          r[t] = "0x" + e[t].toString("hex");
        }), r;
      }

      return t.baToJSON(this.raw);
    }, e.serialize = function () {
      return i.encode(e.raw);
    }, a.forEach(function (a, r) {
      function n() {
        return e.raw[r];
      }

      function s(n) {
        "00" !== (n = t.toBuffer(n)).toString("hex") || a.allowZero || (n = d.allocUnsafe(0)), a.allowLess && a.length ? (n = t.stripZeros(n), o(a.length >= n.length, "The field " + a.name + " must not have more " + a.length + " bytes")) : a.allowZero && 0 === n.length || !a.length || o(a.length === n.length, "The field " + a.name + " must have byte length of " + a.length), e.raw[r] = n;
      }

      e._fields.push(a.name), Object.defineProperty(e, a.name, {
        enumerable: !0,
        configurable: !0,
        get: n,
        set: s
      }), a.default && (e[a.name] = a.default), a.alias && Object.defineProperty(e, a.alias, {
        enumerable: !1,
        configurable: !0,
        set: s,
        get: n
      });
    }), n) if ("string" == typeof n && (n = d.from(t.stripHexPrefix(n), "hex")), d.isBuffer(n) && (n = i.decode(n)), Array.isArray(n)) {
      if (n.length > e._fields.length) throw new Error("wrong number of fields in data");
      n.forEach(function (a, r) {
        e[e._fields[r]] = t.toBuffer(a);
      });
    } else {
      if ("object" !== (void 0 === n ? "undefined" : r(n))) throw new Error("invalid data");
      var s = Object.keys(n);
      a.forEach(function (t) {
        -1 !== s.indexOf(t.name) && (e[t.name] = n[t.name]), -1 !== s.indexOf(t.alias) && (e[t.alias] = n[t.alias]);
      });
    }
  };
},
/*!*******************************************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/node_modules/levelup/lib/levelup.js ***!
  \*******************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    var r = a(
    /*! events */
    41).EventEmitter,
        n = a(
    /*! util */
    23).inherits,
        s = a(
    /*! util */
    23).deprecate,
        o = a(
    /*! xtend */
    47),
        i = a(
    /*! prr */
    188),
        c = a(
    /*! deferred-leveldown */
    539),
        u = a(
    /*! level-iterator-stream */
    542),
        d = a(
    /*! ./batch */
    548),
        f = a(
    /*! level-codec */
    549),
        l = a(
    /*! ./leveldown */
    551),
        h = a(
    /*! level-errors */
    113),
        p = a(
    /*! ./util */
    202),
        b = h.WriteError,
        m = h.ReadError,
        y = h.NotFoundError,
        v = h.OpenError,
        _ = h.EncodingError,
        g = h.InitializationError,
        A = h.LevelUPError,
        w = p.getOptions,
        T = p.defaultOptions,
        x = p.dispatchError;

    function D(e, t) {
      return "function" == typeof e ? e : t;
    }

    function C(e, a, n) {
      if (!(this instanceof C)) return new C(e, a, n);
      var s;

      if (r.call(this), this.setMaxListeners(1 / 0), "function" == typeof e ? ((a = "object" == typeof a ? a : {}).db = e, e = null) : "object" == typeof e && "function" == typeof e.db && (a = e, e = null), "function" == typeof a && (n = a, a = {}), (!a || "function" != typeof a.db) && "string" != typeof e) {
        if (s = new g("Must provide a location for the database"), n) return t.nextTick(function () {
          n(s);
        });
        throw s;
      }

      a = w(a), this.options = o(T, a), this._codec = new f(this.options), this._status = "new", i(this, "location", e, "e"), this.open(n);
    }

    function S(e, t, a) {
      if (!e._isOpening() && !e.isOpen()) return x(e, new m("Database is not open"), a), !0;
    }

    function E(e, t, a) {
      x(e, new b(t), a);
    }

    function B(e, t, a) {
      x(e, new m(t), a);
    }

    function k(e) {
      return function (t, a) {
        l()[e](t, a || function () {});
      };
    }

    n(C, r), C.prototype.open = function (e) {
      var a,
          r,
          n = this;
      if (this.isOpen()) return e && t.nextTick(function () {
        e(null, n);
      }), this;
      if (this._isOpening()) return e && this.once("open", function () {
        e(null, n);
      });
      if (this.emit("opening"), this._status = "opening", this.db = new c(this.location), "function" != typeof this.options.db && "function" != typeof l) throw new A("missing db factory, you need to set options.db");
      a = this.options.db || l(), (r = a(this.location)).open(this.options, function (t) {
        if (t) return x(n, new v(t), e);
        n.db.setDb(r), n.db = r, n._status = "open", e && e(null, n), n.emit("open"), n.emit("ready");
      });
    }, C.prototype.close = function (e) {
      var a = this;
      if (this.isOpen()) this._status = "closing", this.db.close(function () {
        a._status = "closed", a.emit("closed"), e && e.apply(null, arguments);
      }), this.emit("closing"), this.db = new c(this.location);else {
        if ("closed" === this._status && e) return t.nextTick(e);
        "closing" === this._status && e ? this.once("closed", e) : this._isOpening() && this.once("open", function () {
          a.close(e);
        });
      }
    }, C.prototype.isOpen = function () {
      return "open" === this._status;
    }, C.prototype._isOpening = function () {
      return "opening" === this._status;
    }, C.prototype.isClosed = function () {
      return /^clos/.test(this._status);
    }, C.prototype.get = function (e, t, a) {
      var r,
          n = this;

      if (!S(this, 0, a = D(t, a))) {
        if (null == e || "function" != typeof a) return B(this, "get() requires key and callback arguments", a);
        t = p.getOptions(t), r = this._codec.encodeKey(e, t), t.asBuffer = this._codec.valueAsBuffer(t), this.db.get(r, t, function (r, s) {
          if (r) return r = /notfound/i.test(r) || r.notFound ? new y("Key not found in database [" + e + "]", r) : new m(r), x(n, r, a);

          if (a) {
            try {
              s = n._codec.decodeValue(s, t);
            } catch (e) {
              return a(new _(e));
            }

            a(null, s);
          }
        });
      }
    }, C.prototype.put = function (e, t, a, r) {
      var n,
          s,
          o = this;
      if (r = D(a, r), null == e) return E(this, "put() requires a key argument", r);
      S(this, 0, r) || (a = w(a), n = this._codec.encodeKey(e, a), s = this._codec.encodeValue(t, a), this.db.put(n, s, a, function (a) {
        if (a) return x(o, new b(a), r);
        o.emit("put", e, t), r && r();
      }));
    }, C.prototype.del = function (e, t, a) {
      var r,
          n = this;
      if (a = D(t, a), null == e) return E(this, "del() requires a key argument", a);
      S(this, 0, a) || (t = w(t), r = this._codec.encodeKey(e, t), this.db.del(r, t, function (t) {
        if (t) return x(n, new b(t), a);
        n.emit("del", e), a && a();
      }));
    }, C.prototype.batch = function (e, t, a) {
      var r,
          n = this;
      return arguments.length ? (a = D(t, a), Array.isArray(e) ? void (S(this, 0, a) || (t = w(t), r = (r = n._codec.encodeBatch(e, t)).map(function (e) {
        return e.type || void 0 === e.key || void 0 === e.value || (e.type = "put"), e;
      }), this.db.batch(r, t, function (t) {
        if (t) return x(n, new b(t), a);
        n.emit("batch", e), a && a();
      }))) : E(this, "batch() requires an array argument", a)) : new d(this, this._codec);
    }, C.prototype.approximateSize = s(function (e, t, a, r) {
      var n,
          s,
          o = this;
      if (r = D(a, r), a = w(a), null == e || null == t || "function" != typeof r) return B(this, "approximateSize() requires start, end and callback arguments", r);
      n = this._codec.encodeKey(e, a), s = this._codec.encodeKey(t, a), this.db.approximateSize(n, s, function (e, t) {
        if (e) return x(o, new v(e), r);
        r && r(null, t);
      });
    }, "db.approximateSize() is deprecated. Use db.db.approximateSize() instead"), C.prototype.readStream = C.prototype.createReadStream = function (e) {
      return (e = o({
        keys: !0,
        values: !0
      }, this.options, e)).keyEncoding = e.keyEncoding, e.valueEncoding = e.valueEncoding, (e = this._codec.encodeLtgt(e)).keyAsBuffer = this._codec.keyAsBuffer(e), e.valueAsBuffer = this._codec.valueAsBuffer(e), "number" != typeof e.limit && (e.limit = -1), new u(this.db.iterator(e), o(e, {
        decoder: this._codec.createStreamDecoder(e)
      }));
    }, C.prototype.keyStream = C.prototype.createKeyStream = function (e) {
      return this.createReadStream(o(e, {
        keys: !0,
        values: !1
      }));
    }, C.prototype.valueStream = C.prototype.createValueStream = function (e) {
      return this.createReadStream(o(e, {
        keys: !1,
        values: !0
      }));
    }, C.prototype.toString = function () {
      return "LevelUP";
    }, e.exports = C, e.exports.errors = a(
    /*! level-errors */
    113), e.exports.destroy = s(k("destroy"), "levelup.destroy() is deprecated. Use leveldown.destroy() instead"), e.exports.repair = s(k("repair"), "levelup.repair() is deprecated. Use leveldown.repair() instead");
  }).call(this, a(
  /*! ./../../../../process/browser.js */
  9));
},
/*!************************************************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/node_modules/abstract-leveldown/index.js ***!
  \************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  t.AbstractLevelDOWN = a(
  /*! ./abstract-leveldown */
  196), t.AbstractIterator = a(
  /*! ./abstract-iterator */
  197), t.AbstractChainedBatch = a(
  /*! ./abstract-chained-batch */
  198), t.isLevelDOWN = a(
  /*! ./is-leveldown */
  540);
},
/*!*************************************************************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/node_modules/abstract-leveldown/abstract-leveldown.js ***!
  \*************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t, r) {
    var n = a(
    /*! xtend */
    47),
        s = a(
    /*! ./abstract-iterator */
    197),
        o = a(
    /*! ./abstract-chained-batch */
    198);

    function i(e) {
      if (!arguments.length || void 0 === e) throw new Error("constructor requires at least a location argument");
      if ("string" != typeof e) throw new Error("constructor requires a location string argument");
      this.location = e, this.status = "new";
    }

    i.prototype.open = function (e, a) {
      var r = this,
          n = this.status;
      if ("function" == typeof e && (a = e), "function" != typeof a) throw new Error("open() requires a callback argument");
      "object" != typeof e && (e = {}), e.createIfMissing = 0 != e.createIfMissing, e.errorIfExists = !!e.errorIfExists, "function" == typeof this._open ? (this.status = "opening", this._open(e, function (e) {
        if (e) return r.status = n, a(e);
        r.status = "open", a();
      })) : (this.status = "open", t.nextTick(a));
    }, i.prototype.close = function (e) {
      var a = this,
          r = this.status;
      if ("function" != typeof e) throw new Error("close() requires a callback argument");
      "function" == typeof this._close ? (this.status = "closing", this._close(function (t) {
        if (t) return a.status = r, e(t);
        a.status = "closed", e();
      })) : (this.status = "closed", t.nextTick(e));
    }, i.prototype.get = function (e, a, r) {
      var n;
      if ("function" == typeof a && (r = a), "function" != typeof r) throw new Error("get() requires a callback argument");
      return (n = this._checkKey(e, "key")) ? r(n) : (e = this._serializeKey(e), "object" != typeof a && (a = {}), a.asBuffer = 0 != a.asBuffer, "function" == typeof this._get ? this._get(e, a, r) : void t.nextTick(function () {
        r(new Error("NotFound"));
      }));
    }, i.prototype.put = function (e, a, r, n) {
      var s;
      if ("function" == typeof r && (n = r), "function" != typeof n) throw new Error("put() requires a callback argument");
      return (s = this._checkKey(e, "key")) ? n(s) : (e = this._serializeKey(e), a = this._serializeValue(a), "object" != typeof r && (r = {}), "function" == typeof this._put ? this._put(e, a, r, n) : void t.nextTick(n));
    }, i.prototype.del = function (e, a, r) {
      var n;
      if ("function" == typeof a && (r = a), "function" != typeof r) throw new Error("del() requires a callback argument");
      return (n = this._checkKey(e, "key")) ? r(n) : (e = this._serializeKey(e), "object" != typeof a && (a = {}), "function" == typeof this._del ? this._del(e, a, r) : void t.nextTick(r));
    }, i.prototype.batch = function (e, a, r) {
      if (!arguments.length) return this._chainedBatch();
      if ("function" == typeof a && (r = a), "function" == typeof e && (r = e), "function" != typeof r) throw new Error("batch(array) requires a callback argument");
      if (!Array.isArray(e)) return r(new Error("batch(array) requires an array argument"));
      a && "object" == typeof a || (a = {});

      for (var n, s, o = 0, i = e.length; o < i; o++) {
        if ("object" == typeof (n = e[o])) {
          if (s = this._checkKey(n.type, "type")) return r(s);
          if (s = this._checkKey(n.key, "key")) return r(s);
        }
      }

      if ("function" == typeof this._batch) return this._batch(e, a, r);
      t.nextTick(r);
    }, i.prototype.approximateSize = function (e, a, r) {
      if (null == e || null == a || "function" == typeof e || "function" == typeof a) throw new Error("approximateSize() requires valid `start`, `end` and `callback` arguments");
      if ("function" != typeof r) throw new Error("approximateSize() requires a callback argument");
      if (e = this._serializeKey(e), a = this._serializeKey(a), "function" == typeof this._approximateSize) return this._approximateSize(e, a, r);
      t.nextTick(function () {
        r(null, 0);
      });
    }, i.prototype._setupIteratorOptions = function (e) {
      var t = this;
      return e = n(e), ["start", "end", "gt", "gte", "lt", "lte"].forEach(function (a) {
        e[a] && t._isBuffer(e[a]) && 0 === e[a].length && delete e[a];
      }), e.reverse = !!e.reverse, e.keys = 0 != e.keys, e.values = 0 != e.values, e.limit = "limit" in e ? e.limit : -1, e.keyAsBuffer = 0 != e.keyAsBuffer, e.valueAsBuffer = 0 != e.valueAsBuffer, e;
    }, i.prototype.iterator = function (e) {
      return "object" != typeof e && (e = {}), e = this._setupIteratorOptions(e), "function" == typeof this._iterator ? this._iterator(e) : new s(this);
    }, i.prototype._chainedBatch = function () {
      return new o(this);
    }, i.prototype._isBuffer = function (e) {
      return r.isBuffer(e);
    }, i.prototype._serializeKey = function (e) {
      return this._isBuffer(e) ? e : String(e);
    }, i.prototype._serializeValue = function (e) {
      return null == e ? "" : this._isBuffer(e) || t.browser ? e : String(e);
    }, i.prototype._checkKey = function (e, t) {
      return null == e ? new Error(t + " cannot be `null` or `undefined`") : this._isBuffer(e) && 0 === e.length ? new Error(t + " cannot be an empty Buffer") : "" === String(e) ? new Error(t + " cannot be an empty String") : void 0;
    }, e.exports = i;
  }).call(this, a(
  /*! ./../../../process/browser.js */
  9), a(
  /*! ./../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!************************************************************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/node_modules/abstract-leveldown/abstract-iterator.js ***!
  \************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    function a(e) {
      this.db = e, this._ended = !1, this._nexting = !1;
    }

    a.prototype.next = function (e) {
      var a = this;
      if ("function" != typeof e) throw new Error("next() requires a callback argument");
      return a._ended ? e(new Error("cannot call next() after end()")) : a._nexting ? e(new Error("cannot call next() before previous next() has completed")) : (a._nexting = !0, "function" == typeof a._next ? a._next(function () {
        a._nexting = !1, e.apply(null, arguments);
      }) : void t.nextTick(function () {
        a._nexting = !1, e();
      }));
    }, a.prototype.end = function (e) {
      if ("function" != typeof e) throw new Error("end() requires a callback argument");
      return this._ended ? e(new Error("end() already called on iterator")) : (this._ended = !0, "function" == typeof this._end ? this._end(e) : void t.nextTick(e));
    }, e.exports = a;
  }).call(this, a(
  /*! ./../../../process/browser.js */
  9));
},
/*!*****************************************************************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/node_modules/abstract-leveldown/abstract-chained-batch.js ***!
  \*****************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    function a(e) {
      this._db = e, this._operations = [], this._written = !1;
    }

    a.prototype._serializeKey = function (e) {
      return this._db._serializeKey(e);
    }, a.prototype._serializeValue = function (e) {
      return this._db._serializeValue(e);
    }, a.prototype._checkWritten = function () {
      if (this._written) throw new Error("write() already called on this batch");
    }, a.prototype.put = function (e, t) {
      this._checkWritten();

      var a = this._db._checkKey(e, "key", this._db._isBuffer);

      if (a) throw a;
      return e = this._serializeKey(e), t = this._serializeValue(t), "function" == typeof this._put ? this._put(e, t) : this._operations.push({
        type: "put",
        key: e,
        value: t
      }), this;
    }, a.prototype.del = function (e) {
      this._checkWritten();

      var t = this._db._checkKey(e, "key", this._db._isBuffer);

      if (t) throw t;
      return e = this._serializeKey(e), "function" == typeof this._del ? this._del(e) : this._operations.push({
        type: "del",
        key: e
      }), this;
    }, a.prototype.clear = function () {
      return this._checkWritten(), this._operations = [], "function" == typeof this._clear && this._clear(), this;
    }, a.prototype.write = function (e, a) {
      if (this._checkWritten(), "function" == typeof e && (a = e), "function" != typeof a) throw new Error("write() requires a callback argument");
      return "object" != typeof e && (e = {}), this._written = !0, "function" == typeof this._write ? this._write(a) : "function" == typeof this._db._batch ? this._db._batch(this._operations, e, a) : void t.nextTick(a);
    }, e.exports = a;
  }).call(this, a(
  /*! ./../../../process/browser.js */
  9));
},
/*!***********************************************************************************************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/node_modules/level-iterator-stream/node_modules/readable-stream/lib/_stream_readable.js ***!
  \***********************************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    e.exports = f;
    var r = a(
    /*! isarray */
    544),
        n = a(
    /*! buffer */
    1).Buffer;
    f.ReadableState = d;
    var s = a(
    /*! events */
    41).EventEmitter;
    s.listenerCount || (s.listenerCount = function (e, t) {
      return e.listeners(t).length;
    });
    var o,
        i = a(
    /*! stream */
    28),
        c = a(
    /*! core-util-is */
    27);
    c.inherits = a(
    /*! inherits */
    3);
    var u = a(
    /*! util */
    545);

    function d(e, t) {
      var r = a(
      /*! ./_stream_duplex */
      61),
          n = (e = e || {}).highWaterMark,
          s = e.objectMode ? 16 : 16384;
      this.highWaterMark = n || 0 === n ? n : s, this.highWaterMark = ~~this.highWaterMark, this.buffer = [], this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.objectMode = !!e.objectMode, t instanceof r && (this.objectMode = this.objectMode || !!e.readableObjectMode), this.defaultEncoding = e.defaultEncoding || "utf8", this.ranOut = !1, this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, e.encoding && (o || (o = a(
      /*! string_decoder/ */
      53).StringDecoder), this.decoder = new o(e.encoding), this.encoding = e.encoding);
    }

    function f(e) {
      a(
      /*! ./_stream_duplex */
      61);
      if (!(this instanceof f)) return new f(e);
      this._readableState = new d(e, this), this.readable = !0, i.call(this);
    }

    function l(e, a, r, n, s) {
      var o = function (e, t) {
        var a = null;
        c.isBuffer(t) || c.isString(t) || c.isNullOrUndefined(t) || e.objectMode || (a = new TypeError("Invalid non-string/buffer chunk"));
        return a;
      }(a, r);

      if (o) e.emit("error", o);else if (c.isNullOrUndefined(r)) a.reading = !1, a.ended || function (e, t) {
        if (t.decoder && !t.ended) {
          var a = t.decoder.end();
          a && a.length && (t.buffer.push(a), t.length += t.objectMode ? 1 : a.length);
        }

        t.ended = !0, b(e);
      }(e, a);else if (a.objectMode || r && r.length > 0) {
        if (a.ended && !s) {
          var i = new Error("stream.push() after EOF");
          e.emit("error", i);
        } else if (a.endEmitted && s) {
          i = new Error("stream.unshift() after end event");
          e.emit("error", i);
        } else !a.decoder || s || n || (r = a.decoder.write(r)), s || (a.reading = !1), a.flowing && 0 === a.length && !a.sync ? (e.emit("data", r), e.read(0)) : (a.length += a.objectMode ? 1 : r.length, s ? a.buffer.unshift(r) : a.buffer.push(r), a.needReadable && b(e)), function (e, a) {
          a.readingMore || (a.readingMore = !0, t.nextTick(function () {
            !function (e, t) {
              var a = t.length;

              for (; !t.reading && !t.flowing && !t.ended && t.length < t.highWaterMark && (u("maybeReadMore read 0"), e.read(0), a !== t.length);) {
                a = t.length;
              }

              t.readingMore = !1;
            }(e, a);
          }));
        }(e, a);
      } else s || (a.reading = !1);
      return function (e) {
        return !e.ended && (e.needReadable || e.length < e.highWaterMark || 0 === e.length);
      }(a);
    }

    u = u && u.debuglog ? u.debuglog("stream") : function () {}, c.inherits(f, i), f.prototype.push = function (e, t) {
      var a = this._readableState;
      return c.isString(e) && !a.objectMode && (t = t || a.defaultEncoding) !== a.encoding && (e = new n(e, t), t = ""), l(this, a, e, t, !1);
    }, f.prototype.unshift = function (e) {
      return l(this, this._readableState, e, "", !0);
    }, f.prototype.setEncoding = function (e) {
      return o || (o = a(
      /*! string_decoder/ */
      53).StringDecoder), this._readableState.decoder = new o(e), this._readableState.encoding = e, this;
    };
    var h = 8388608;

    function p(e, t) {
      return 0 === t.length && t.ended ? 0 : t.objectMode ? 0 === e ? 0 : 1 : isNaN(e) || c.isNull(e) ? t.flowing && t.buffer.length ? t.buffer[0].length : t.length : e <= 0 ? 0 : (e > t.highWaterMark && (t.highWaterMark = function (e) {
        if (e >= h) e = h;else {
          e--;

          for (var t = 1; t < 32; t <<= 1) {
            e |= e >> t;
          }

          e++;
        }
        return e;
      }(e)), e > t.length ? t.ended ? t.length : (t.needReadable = !0, 0) : e);
    }

    function b(e) {
      var a = e._readableState;
      a.needReadable = !1, a.emittedReadable || (u("emitReadable", a.flowing), a.emittedReadable = !0, a.sync ? t.nextTick(function () {
        m(e);
      }) : m(e));
    }

    function m(e) {
      u("emit readable"), e.emit("readable"), y(e);
    }

    function y(e) {
      var t = e._readableState;
      if (u("flow", t.flowing), t.flowing) do {
        var a = e.read();
      } while (null !== a && t.flowing);
    }

    function v(e, t) {
      var a,
          r = t.buffer,
          s = t.length,
          o = !!t.decoder,
          i = !!t.objectMode;
      if (0 === r.length) return null;
      if (0 === s) a = null;else if (i) a = r.shift();else if (!e || e >= s) a = o ? r.join("") : n.concat(r, s), r.length = 0;else {
        if (e < r[0].length) a = (f = r[0]).slice(0, e), r[0] = f.slice(e);else if (e === r[0].length) a = r.shift();else {
          a = o ? "" : new n(e);

          for (var c = 0, u = 0, d = r.length; u < d && c < e; u++) {
            var f = r[0],
                l = Math.min(e - c, f.length);
            o ? a += f.slice(0, l) : f.copy(a, c, 0, l), l < f.length ? r[0] = f.slice(l) : r.shift(), c += l;
          }
        }
      }
      return a;
    }

    function _(e) {
      var a = e._readableState;
      if (a.length > 0) throw new Error("endReadable called on non-empty stream");
      a.endEmitted || (a.ended = !0, t.nextTick(function () {
        a.endEmitted || 0 !== a.length || (a.endEmitted = !0, e.readable = !1, e.emit("end"));
      }));
    }

    f.prototype.read = function (e) {
      u("read", e);
      var t = this._readableState,
          a = e;
      if ((!c.isNumber(e) || e > 0) && (t.emittedReadable = !1), 0 === e && t.needReadable && (t.length >= t.highWaterMark || t.ended)) return u("read: emitReadable", t.length, t.ended), 0 === t.length && t.ended ? _(this) : b(this), null;
      if (0 === (e = p(e, t)) && t.ended) return 0 === t.length && _(this), null;
      var r,
          n = t.needReadable;
      return u("need readable", n), (0 === t.length || t.length - e < t.highWaterMark) && u("length less than watermark", n = !0), (t.ended || t.reading) && u("reading or ended", n = !1), n && (u("do read"), t.reading = !0, t.sync = !0, 0 === t.length && (t.needReadable = !0), this._read(t.highWaterMark), t.sync = !1), n && !t.reading && (e = p(a, t)), r = e > 0 ? v(e, t) : null, c.isNull(r) && (t.needReadable = !0, e = 0), t.length -= e, 0 !== t.length || t.ended || (t.needReadable = !0), a !== e && t.ended && 0 === t.length && _(this), c.isNull(r) || this.emit("data", r), r;
    }, f.prototype._read = function (e) {
      this.emit("error", new Error("not implemented"));
    }, f.prototype.pipe = function (e, a) {
      var n = this,
          o = this._readableState;

      switch (o.pipesCount) {
        case 0:
          o.pipes = e;
          break;

        case 1:
          o.pipes = [o.pipes, e];
          break;

        default:
          o.pipes.push(e);
      }

      o.pipesCount += 1, u("pipe count=%d opts=%j", o.pipesCount, a);
      var i = (!a || !1 !== a.end) && e !== t.stdout && e !== t.stderr ? d : l;

      function c(e) {
        u("onunpipe"), e === n && l();
      }

      function d() {
        u("onend"), e.end();
      }

      o.endEmitted ? t.nextTick(i) : n.once("end", i), e.on("unpipe", c);

      var f = function (e) {
        return function () {
          var t = e._readableState;
          u("pipeOnDrain", t.awaitDrain), t.awaitDrain && t.awaitDrain--, 0 === t.awaitDrain && s.listenerCount(e, "data") && (t.flowing = !0, y(e));
        };
      }(n);

      function l() {
        u("cleanup"), e.removeListener("close", b), e.removeListener("finish", m), e.removeListener("drain", f), e.removeListener("error", p), e.removeListener("unpipe", c), n.removeListener("end", d), n.removeListener("end", l), n.removeListener("data", h), !o.awaitDrain || e._writableState && !e._writableState.needDrain || f();
      }

      function h(t) {
        u("ondata"), !1 === e.write(t) && (u("false write response, pause", n._readableState.awaitDrain), n._readableState.awaitDrain++, n.pause());
      }

      function p(t) {
        u("onerror", t), v(), e.removeListener("error", p), 0 === s.listenerCount(e, "error") && e.emit("error", t);
      }

      function b() {
        e.removeListener("finish", m), v();
      }

      function m() {
        u("onfinish"), e.removeListener("close", b), v();
      }

      function v() {
        u("unpipe"), n.unpipe(e);
      }

      return e.on("drain", f), n.on("data", h), e._events && e._events.error ? r(e._events.error) ? e._events.error.unshift(p) : e._events.error = [p, e._events.error] : e.on("error", p), e.once("close", b), e.once("finish", m), e.emit("pipe", n), o.flowing || (u("pipe resume"), n.resume()), e;
    }, f.prototype.unpipe = function (e) {
      var t = this._readableState;
      if (0 === t.pipesCount) return this;
      if (1 === t.pipesCount) return e && e !== t.pipes ? this : (e || (e = t.pipes), t.pipes = null, t.pipesCount = 0, t.flowing = !1, e && e.emit("unpipe", this), this);

      if (!e) {
        var a = t.pipes,
            r = t.pipesCount;
        t.pipes = null, t.pipesCount = 0, t.flowing = !1;

        for (var n = 0; n < r; n++) {
          a[n].emit("unpipe", this);
        }

        return this;
      }

      return -1 === (n = function (e, t) {
        for (var a = 0, r = e.length; a < r; a++) {
          if (e[a] === t) return a;
        }

        return -1;
      }(t.pipes, e)) ? this : (t.pipes.splice(n, 1), t.pipesCount -= 1, 1 === t.pipesCount && (t.pipes = t.pipes[0]), e.emit("unpipe", this), this);
    }, f.prototype.on = function (e, a) {
      var r = i.prototype.on.call(this, e, a);

      if ("data" === e && !1 !== this._readableState.flowing && this.resume(), "readable" === e && this.readable) {
        var n = this._readableState;
        if (!n.readableListening) if (n.readableListening = !0, n.emittedReadable = !1, n.needReadable = !0, n.reading) n.length && b(this);else {
          var s = this;
          t.nextTick(function () {
            u("readable nexttick read 0"), s.read(0);
          });
        }
      }

      return r;
    }, f.prototype.addListener = f.prototype.on, f.prototype.resume = function () {
      var e = this._readableState;
      return e.flowing || (u("resume"), e.flowing = !0, e.reading || (u("resume read 0"), this.read(0)), function (e, a) {
        a.resumeScheduled || (a.resumeScheduled = !0, t.nextTick(function () {
          !function (e, t) {
            t.resumeScheduled = !1, e.emit("resume"), y(e), t.flowing && !t.reading && e.read(0);
          }(e, a);
        }));
      }(this, e)), this;
    }, f.prototype.pause = function () {
      return u("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (u("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
    }, f.prototype.wrap = function (e) {
      var t = this._readableState,
          a = !1,
          r = this;

      for (var n in e.on("end", function () {
        if (u("wrapped end"), t.decoder && !t.ended) {
          var e = t.decoder.end();
          e && e.length && r.push(e);
        }

        r.push(null);
      }), e.on("data", function (n) {
        (u("wrapped data"), t.decoder && (n = t.decoder.write(n)), n && (t.objectMode || n.length)) && (r.push(n) || (a = !0, e.pause()));
      }), e) {
        c.isFunction(e[n]) && c.isUndefined(this[n]) && (this[n] = function (t) {
          return function () {
            return e[t].apply(e, arguments);
          };
        }(n));
      }

      return function (e, t) {
        for (var a = 0, r = e.length; a < r; a++) {
          t(e[a], a);
        }
      }(["error", "close", "destroy", "pause", "resume"], function (t) {
        e.on(t, r.emit.bind(r, t));
      }), r._read = function (t) {
        u("wrapped _read", t), a && (a = !1, e.resume());
      }, r;
    }, f._fromList = v;
  }).call(this, a(
  /*! ./../../../../../../process/browser.js */
  9));
},
/*!***********************************************************************************************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/node_modules/level-iterator-stream/node_modules/readable-stream/lib/_stream_writable.js ***!
  \***********************************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    e.exports = c;
    var r = a(
    /*! buffer */
    1).Buffer;
    c.WritableState = i;
    var n = a(
    /*! core-util-is */
    27);
    n.inherits = a(
    /*! inherits */
    3);
    var s = a(
    /*! stream */
    28);

    function o(e, t, a) {
      this.chunk = e, this.encoding = t, this.callback = a;
    }

    function i(e, r) {
      var n = a(
      /*! ./_stream_duplex */
      61),
          s = (e = e || {}).highWaterMark,
          o = e.objectMode ? 16 : 16384;
      this.highWaterMark = s || 0 === s ? s : o, this.objectMode = !!e.objectMode, r instanceof n && (this.objectMode = this.objectMode || !!e.writableObjectMode), this.highWaterMark = ~~this.highWaterMark, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1;
      var i = !1 === e.decodeStrings;
      this.decodeStrings = !i, this.defaultEncoding = e.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function (e) {
        !function (e, a) {
          var r = e._writableState,
              n = r.sync,
              s = r.writecb;
          if (function (e) {
            e.writing = !1, e.writecb = null, e.length -= e.writelen, e.writelen = 0;
          }(r), a) !function (e, a, r, n, s) {
            r ? t.nextTick(function () {
              a.pendingcb--, s(n);
            }) : (a.pendingcb--, s(n));
            e._writableState.errorEmitted = !0, e.emit("error", n);
          }(e, r, n, a, s);else {
            var o = l(e, r);
            o || r.corked || r.bufferProcessing || !r.buffer.length || f(e, r), n ? t.nextTick(function () {
              d(e, r, o, s);
            }) : d(e, r, o, s);
          }
        }(r, e);
      }, this.writecb = null, this.writelen = 0, this.buffer = [], this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1;
    }

    function c(e) {
      var t = a(
      /*! ./_stream_duplex */
      61);
      if (!(this instanceof c || this instanceof t)) return new c(e);
      this._writableState = new i(e, this), this.writable = !0, s.call(this);
    }

    function u(e, t, a, r, n, s, o) {
      t.writelen = r, t.writecb = o, t.writing = !0, t.sync = !0, a ? e._writev(n, t.onwrite) : e._write(n, s, t.onwrite), t.sync = !1;
    }

    function d(e, t, a, r) {
      a || function (e, t) {
        0 === t.length && t.needDrain && (t.needDrain = !1, e.emit("drain"));
      }(e, t), t.pendingcb--, r(), p(e, t);
    }

    function f(e, t) {
      if (t.bufferProcessing = !0, e._writev && t.buffer.length > 1) {
        for (var a = [], r = 0; r < t.buffer.length; r++) {
          a.push(t.buffer[r].callback);
        }

        t.pendingcb++, u(e, t, !0, t.length, t.buffer, "", function (e) {
          for (var r = 0; r < a.length; r++) {
            t.pendingcb--, a[r](e);
          }
        }), t.buffer = [];
      } else {
        for (r = 0; r < t.buffer.length; r++) {
          var n = t.buffer[r],
              s = n.chunk,
              o = n.encoding,
              i = n.callback,
              c = t.objectMode ? 1 : s.length;

          if (u(e, t, !1, c, s, o, i), t.writing) {
            r++;
            break;
          }
        }

        r < t.buffer.length ? t.buffer = t.buffer.slice(r) : t.buffer.length = 0;
      }

      t.bufferProcessing = !1;
    }

    function l(e, t) {
      return t.ending && 0 === t.length && !t.finished && !t.writing;
    }

    function h(e, t) {
      t.prefinished || (t.prefinished = !0, e.emit("prefinish"));
    }

    function p(e, t) {
      var a = l(0, t);
      return a && (0 === t.pendingcb ? (h(e, t), t.finished = !0, e.emit("finish")) : h(e, t)), a;
    }

    n.inherits(c, s), c.prototype.pipe = function () {
      this.emit("error", new Error("Cannot pipe. Not readable."));
    }, c.prototype.write = function (e, a, s) {
      var i = this._writableState,
          c = !1;
      return n.isFunction(a) && (s = a, a = null), n.isBuffer(e) ? a = "buffer" : a || (a = i.defaultEncoding), n.isFunction(s) || (s = function s() {}), i.ended ? function (e, a, r) {
        var n = new Error("write after end");
        e.emit("error", n), t.nextTick(function () {
          r(n);
        });
      }(this, 0, s) : function (e, a, r, s) {
        var o = !0;

        if (!(n.isBuffer(r) || n.isString(r) || n.isNullOrUndefined(r) || a.objectMode)) {
          var i = new TypeError("Invalid non-string/buffer chunk");
          e.emit("error", i), t.nextTick(function () {
            s(i);
          }), o = !1;
        }

        return o;
      }(this, i, e, s) && (i.pendingcb++, c = function (e, t, a, s, i) {
        a = function (e, t, a) {
          !e.objectMode && !1 !== e.decodeStrings && n.isString(t) && (t = new r(t, a));
          return t;
        }(t, a, s), n.isBuffer(a) && (s = "buffer");
        var c = t.objectMode ? 1 : a.length;
        t.length += c;
        var d = t.length < t.highWaterMark;
        d || (t.needDrain = !0);
        t.writing || t.corked ? t.buffer.push(new o(a, s, i)) : u(e, t, !1, c, a, s, i);
        return d;
      }(this, i, e, a, s)), c;
    }, c.prototype.cork = function () {
      this._writableState.corked++;
    }, c.prototype.uncork = function () {
      var e = this._writableState;
      e.corked && (e.corked--, e.writing || e.corked || e.finished || e.bufferProcessing || !e.buffer.length || f(this, e));
    }, c.prototype._write = function (e, t, a) {
      a(new Error("not implemented"));
    }, c.prototype._writev = null, c.prototype.end = function (e, a, r) {
      var s = this._writableState;
      n.isFunction(e) ? (r = e, e = null, a = null) : n.isFunction(a) && (r = a, a = null), n.isNullOrUndefined(e) || this.write(e, a), s.corked && (s.corked = 1, this.uncork()), s.ending || s.finished || function (e, a, r) {
        a.ending = !0, p(e, a), r && (a.finished ? t.nextTick(r) : e.once("finish", r));
        a.ended = !0;
      }(this, s, r);
    };
  }).call(this, a(
  /*! ./../../../../../../process/browser.js */
  9));
},
/*!************************************************************************************************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/node_modules/level-iterator-stream/node_modules/readable-stream/lib/_stream_transform.js ***!
  \************************************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  e.exports = o;
  var r = a(
  /*! ./_stream_duplex */
  61),
      n = a(
  /*! core-util-is */
  27);

  function s(e, t) {
    this.afterTransform = function (e, a) {
      return function (e, t, a) {
        var r = e._transformState;
        r.transforming = !1;
        var s = r.writecb;
        if (!s) return e.emit("error", new Error("no writecb in Transform class"));
        r.writechunk = null, r.writecb = null, n.isNullOrUndefined(a) || e.push(a);
        s && s(t);
        var o = e._readableState;
        o.reading = !1, (o.needReadable || o.length < o.highWaterMark) && e._read(o.highWaterMark);
      }(t, e, a);
    }, this.needTransform = !1, this.transforming = !1, this.writecb = null, this.writechunk = null;
  }

  function o(e) {
    if (!(this instanceof o)) return new o(e);
    r.call(this, e), this._transformState = new s(e, this);
    var t = this;
    this._readableState.needReadable = !0, this._readableState.sync = !1, this.once("prefinish", function () {
      n.isFunction(this._flush) ? this._flush(function (e) {
        i(t, e);
      }) : i(t);
    });
  }

  function i(e, t) {
    if (t) return e.emit("error", t);
    var a = e._writableState,
        r = e._transformState;
    if (a.length) throw new Error("calling transform done when ws.length != 0");
    if (r.transforming) throw new Error("calling transform done when still transforming");
    return e.push(null);
  }

  n.inherits = a(
  /*! inherits */
  3), n.inherits(o, r), o.prototype.push = function (e, t) {
    return this._transformState.needTransform = !1, r.prototype.push.call(this, e, t);
  }, o.prototype._transform = function (e, t, a) {
    throw new Error("not implemented");
  }, o.prototype._write = function (e, t, a) {
    var r = this._transformState;

    if (r.writecb = a, r.writechunk = e, r.writeencoding = t, !r.transforming) {
      var n = this._readableState;
      (r.needTransform || n.needReadable || n.length < n.highWaterMark) && this._read(n.highWaterMark);
    }
  }, o.prototype._read = function (e) {
    var t = this._transformState;
    n.isNull(t.writechunk) || !t.writecb || t.transforming ? t.needTransform = !0 : (t.transforming = !0, this._transform(t.writechunk, t.writeencoding, t.afterTransform));
  };
},
/*!****************************************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/node_modules/levelup/lib/util.js ***!
  \****************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = {
    defaultOptions: {
      createIfMissing: !0,
      errorIfExists: !1,
      keyEncoding: "utf8",
      valueEncoding: "utf8",
      compression: !0
    },
    getOptions: function getOptions(e) {
      return "string" == typeof e && (e = {
        valueEncoding: e
      }), "object" != typeof e && (e = {}), e;
    },
    dispatchError: function dispatchError(e, t, a) {
      "function" == typeof a ? a(t) : e.emit("error", t);
    },
    isDefined: function isDefined(e) {
      return void 0 !== e;
    }
  };
},
/*!*****************************************!*\
  !*** ./node_modules/memdown/memdown.js ***!
  \*****************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! inherits */
  3),
      n = a(
  /*! abstract-leveldown */
  204).AbstractLevelDOWN,
      s = a(
  /*! abstract-leveldown */
  204).AbstractIterator,
      o = a(
  /*! ltgt */
  190),
      i = a(
  /*! functional-red-black-tree */
  111),
      c = a(
  /*! safe-buffer */
  553).Buffer,
      u = {},
      d = a(
  /*! ./immediate */
  554);

  function f(e) {
    return o.compare(e, this._end) > 0;
  }

  function l(e) {
    return o.compare(e, this._end) >= 0;
  }

  function h(e) {
    return o.compare(e, this._end) < 0;
  }

  function p(e) {
    return o.compare(e, this._end) <= 0;
  }

  function b(e, t) {
    s.call(this, e), this._limit = t.limit, -1 === this._limit && (this._limit = 1 / 0);
    var a = e._store[e._location];
    this.keyAsBuffer = !1 !== t.keyAsBuffer, this.valueAsBuffer = !1 !== t.valueAsBuffer, this._reverse = t.reverse, this._options = t, this._done = 0, this._reverse ? (this._incr = "prev", this._start = o.upperBound(t), this._end = o.lowerBound(t), void 0 === this._start ? this._tree = a.end : o.upperBoundInclusive(t) ? this._tree = a.le(this._start) : this._tree = a.lt(this._start), this._end && (o.lowerBoundInclusive(t) ? this._test = l : this._test = f)) : (this._incr = "next", this._start = o.lowerBound(t), this._end = o.upperBound(t), void 0 === this._start ? this._tree = a.begin : o.lowerBoundInclusive(t) ? this._tree = a.ge(this._start) : this._tree = a.gt(this._start), this._end && (o.upperBoundInclusive(t) ? this._test = p : this._test = h));
  }

  function m(e) {
    if (!(this instanceof m)) return new m(e);
    n.call(this, "string" == typeof e ? e : ""), this._location = this.location ? "$" + this.location : "_tree", this._store = this.location ? u : this, this._store[this._location] = this._store[this._location] || i(o.compare);
  }

  r(b, s), b.prototype._next = function (e) {
    var t, a;
    return this._done++ >= this._limit ? d(e) : this._tree.valid ? (t = this._tree.key, a = this._tree.value, this._test(t) ? (this.keyAsBuffer && (t = c.from(t)), this.valueAsBuffer && (a = c.from(a)), this._tree[this._incr](), void d(function () {
      e(null, t, a);
    })) : d(e)) : d(e);
  }, b.prototype._test = function () {
    return !0;
  }, m.clearGlobalStore = function (e) {
    e ? Object.keys(u).forEach(function (e) {
      delete u[e];
    }) : u = {};
  }, r(m, n), m.prototype._open = function (e, t) {
    var a = this;
    d(function () {
      t(null, a);
    });
  }, m.prototype._put = function (e, t, a, r) {
    null == t && (t = "");

    var n = this._store[this._location].find(e);

    n.valid ? this._store[this._location] = n.update(t) : this._store[this._location] = this._store[this._location].insert(e, t), d(r);
  }, m.prototype._get = function (e, t, a) {
    var r = this._store[this._location].get(e);

    if (void 0 === r) return d(function () {
      a(new Error("NotFound"));
    });
    !1 === t.asBuffer || this._isBuffer(r) || (r = c.from(String(r))), d(function () {
      a(null, r);
    });
  }, m.prototype._del = function (e, t, a) {
    this._store[this._location] = this._store[this._location].remove(e), d(a);
  }, m.prototype._batch = function (e, t, a) {
    for (var r, n, s, o = -1, i = e.length, c = this._store[this._location]; ++o < i;) {
      e[o] && (r = this._isBuffer(e[o].key) ? e[o].key : String(e[o].key), s = c.find(r), "put" === e[o].type ? (n = this._isBuffer(e[o].value) ? e[o].value : String(e[o].value), c = s.valid ? s.update(n) : c.insert(r, n)) : c = s.remove());
    }

    this._store[this._location] = c, d(a);
  }, m.prototype._iterator = function (e) {
    return new b(this, e);
  }, m.prototype._isBuffer = function (e) {
    return c.isBuffer(e);
  }, m.destroy = function (e, t) {
    var a = "$" + e;
    a in u && delete u[a], d(t);
  }, e.exports = m.default = m;
},
/*!***********************************************************************!*\
  !*** ./node_modules/memdown/node_modules/abstract-leveldown/index.js ***!
  \***********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  t.AbstractLevelDOWN = a(
  /*! ./abstract-leveldown */
  205), t.AbstractIterator = a(
  /*! ./abstract-iterator */
  206), t.AbstractChainedBatch = a(
  /*! ./abstract-chained-batch */
  207), t.isLevelDOWN = a(
  /*! ./is-leveldown */
  552);
},
/*!************************************************************************************!*\
  !*** ./node_modules/memdown/node_modules/abstract-leveldown/abstract-leveldown.js ***!
  \************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t, r) {
    var n = a(
    /*! xtend */
    47),
        s = a(
    /*! ./abstract-iterator */
    206),
        o = a(
    /*! ./abstract-chained-batch */
    207);

    function i(e) {
      if (!arguments.length || void 0 === e) throw new Error("constructor requires at least a location argument");
      if ("string" != typeof e) throw new Error("constructor requires a location string argument");
      this.location = e, this.status = "new";
    }

    i.prototype.open = function (e, a) {
      var r = this,
          n = this.status;
      if ("function" == typeof e && (a = e), "function" != typeof a) throw new Error("open() requires a callback argument");
      "object" != typeof e && (e = {}), e.createIfMissing = 0 != e.createIfMissing, e.errorIfExists = !!e.errorIfExists, "function" == typeof this._open ? (this.status = "opening", this._open(e, function (e) {
        if (e) return r.status = n, a(e);
        r.status = "open", a();
      })) : (this.status = "open", t.nextTick(a));
    }, i.prototype.close = function (e) {
      var a = this,
          r = this.status;
      if ("function" != typeof e) throw new Error("close() requires a callback argument");
      "function" == typeof this._close ? (this.status = "closing", this._close(function (t) {
        if (t) return a.status = r, e(t);
        a.status = "closed", e();
      })) : (this.status = "closed", t.nextTick(e));
    }, i.prototype.get = function (e, a, r) {
      var n;
      if ("function" == typeof a && (r = a), "function" != typeof r) throw new Error("get() requires a callback argument");
      return (n = this._checkKey(e, "key")) ? r(n) : (e = this._serializeKey(e), "object" != typeof a && (a = {}), a.asBuffer = 0 != a.asBuffer, "function" == typeof this._get ? this._get(e, a, r) : void t.nextTick(function () {
        r(new Error("NotFound"));
      }));
    }, i.prototype.put = function (e, a, r, n) {
      var s;
      if ("function" == typeof r && (n = r), "function" != typeof n) throw new Error("put() requires a callback argument");
      return (s = this._checkKey(e, "key")) ? n(s) : (e = this._serializeKey(e), a = this._serializeValue(a), "object" != typeof r && (r = {}), "function" == typeof this._put ? this._put(e, a, r, n) : void t.nextTick(n));
    }, i.prototype.del = function (e, a, r) {
      var n;
      if ("function" == typeof a && (r = a), "function" != typeof r) throw new Error("del() requires a callback argument");
      return (n = this._checkKey(e, "key")) ? r(n) : (e = this._serializeKey(e), "object" != typeof a && (a = {}), "function" == typeof this._del ? this._del(e, a, r) : void t.nextTick(r));
    }, i.prototype.batch = function (e, a, r) {
      if (!arguments.length) return this._chainedBatch();
      if ("function" == typeof a && (r = a), "function" == typeof e && (r = e), "function" != typeof r) throw new Error("batch(array) requires a callback argument");
      if (!Array.isArray(e)) return r(new Error("batch(array) requires an array argument"));
      a && "object" == typeof a || (a = {});

      for (var n, s, o = 0, i = e.length; o < i; o++) {
        if ("object" == typeof (n = e[o])) {
          if (s = this._checkKey(n.type, "type")) return r(s);
          if (s = this._checkKey(n.key, "key")) return r(s);
        }
      }

      if ("function" == typeof this._batch) return this._batch(e, a, r);
      t.nextTick(r);
    }, i.prototype.approximateSize = function (e, a, r) {
      if (null == e || null == a || "function" == typeof e || "function" == typeof a) throw new Error("approximateSize() requires valid `start`, `end` and `callback` arguments");
      if ("function" != typeof r) throw new Error("approximateSize() requires a callback argument");
      if (e = this._serializeKey(e), a = this._serializeKey(a), "function" == typeof this._approximateSize) return this._approximateSize(e, a, r);
      t.nextTick(function () {
        r(null, 0);
      });
    }, i.prototype._setupIteratorOptions = function (e) {
      var t = this;
      return e = n(e), ["start", "end", "gt", "gte", "lt", "lte"].forEach(function (a) {
        e[a] && t._isBuffer(e[a]) && 0 === e[a].length && delete e[a];
      }), e.reverse = !!e.reverse, e.keys = 0 != e.keys, e.values = 0 != e.values, e.limit = "limit" in e ? e.limit : -1, e.keyAsBuffer = 0 != e.keyAsBuffer, e.valueAsBuffer = 0 != e.valueAsBuffer, e;
    }, i.prototype.iterator = function (e) {
      return "object" != typeof e && (e = {}), e = this._setupIteratorOptions(e), "function" == typeof this._iterator ? this._iterator(e) : new s(this);
    }, i.prototype._chainedBatch = function () {
      return new o(this);
    }, i.prototype._isBuffer = function (e) {
      return r.isBuffer(e);
    }, i.prototype._serializeKey = function (e) {
      return this._isBuffer(e) ? e : String(e);
    }, i.prototype._serializeValue = function (e) {
      return null == e ? "" : this._isBuffer(e) || t.browser ? e : String(e);
    }, i.prototype._checkKey = function (e, t) {
      return null == e ? new Error(t + " cannot be `null` or `undefined`") : this._isBuffer(e) && 0 === e.length ? new Error(t + " cannot be an empty Buffer") : "" === String(e) ? new Error(t + " cannot be an empty String") : void 0;
    }, e.exports = i;
  }).call(this, a(
  /*! ./../../../process/browser.js */
  9), a(
  /*! ./../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!***********************************************************************************!*\
  !*** ./node_modules/memdown/node_modules/abstract-leveldown/abstract-iterator.js ***!
  \***********************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    function a(e) {
      this.db = e, this._ended = !1, this._nexting = !1;
    }

    a.prototype.next = function (e) {
      var a = this;
      if ("function" != typeof e) throw new Error("next() requires a callback argument");
      return a._ended ? e(new Error("cannot call next() after end()")) : a._nexting ? e(new Error("cannot call next() before previous next() has completed")) : (a._nexting = !0, "function" == typeof a._next ? a._next(function () {
        a._nexting = !1, e.apply(null, arguments);
      }) : void t.nextTick(function () {
        a._nexting = !1, e();
      }));
    }, a.prototype.end = function (e) {
      if ("function" != typeof e) throw new Error("end() requires a callback argument");
      return this._ended ? e(new Error("end() already called on iterator")) : (this._ended = !0, "function" == typeof this._end ? this._end(e) : void t.nextTick(e));
    }, e.exports = a;
  }).call(this, a(
  /*! ./../../../process/browser.js */
  9));
},
/*!****************************************************************************************!*\
  !*** ./node_modules/memdown/node_modules/abstract-leveldown/abstract-chained-batch.js ***!
  \****************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    function a(e) {
      this._db = e, this._operations = [], this._written = !1;
    }

    a.prototype._serializeKey = function (e) {
      return this._db._serializeKey(e);
    }, a.prototype._serializeValue = function (e) {
      return this._db._serializeValue(e);
    }, a.prototype._checkWritten = function () {
      if (this._written) throw new Error("write() already called on this batch");
    }, a.prototype.put = function (e, t) {
      this._checkWritten();

      var a = this._db._checkKey(e, "key", this._db._isBuffer);

      if (a) throw a;
      return e = this._serializeKey(e), t = this._serializeValue(t), "function" == typeof this._put ? this._put(e, t) : this._operations.push({
        type: "put",
        key: e,
        value: t
      }), this;
    }, a.prototype.del = function (e) {
      this._checkWritten();

      var t = this._db._checkKey(e, "key", this._db._isBuffer);

      if (t) throw t;
      return e = this._serializeKey(e), "function" == typeof this._del ? this._del(e) : this._operations.push({
        type: "del",
        key: e
      }), this;
    }, a.prototype.clear = function () {
      return this._checkWritten(), this._operations = [], "function" == typeof this._clear && this._clear(), this;
    }, a.prototype.write = function (e, a) {
      if (this._checkWritten(), "function" == typeof e && (a = e), "function" != typeof a) throw new Error("write() requires a callback argument");
      return "object" != typeof e && (e = {}), this._written = !0, "function" == typeof this._write ? this._write(a) : "function" == typeof this._db._batch ? this._db._batch(this._operations, e, a) : void t.nextTick(a);
    }, e.exports = a;
  }).call(this, a(
  /*! ./../../../process/browser.js */
  9));
},
/*!*************************************************!*\
  !*** ./node_modules/semaphore/lib/semaphore.js ***!
  \*************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    !function (a) {
      "use strict";

      var r = function r(e) {
        setTimeout(e, 0);
      };

      void 0 !== t && t && "function" == typeof t.nextTick && (r = t.nextTick), e.exports = function (e) {
        var t = {
          capacity: e || 1,
          current: 0,
          queue: [],
          firstHere: !1,
          take: function take() {
            if (!1 === t.firstHere) {
              t.current++, t.firstHere = !0;
              var e = 1;
            } else e = 0;

            var a = {
              n: 1
            };
            "function" == typeof arguments[0] ? a.task = arguments[0] : a.n = arguments[0], arguments.length >= 2 && ("function" == typeof arguments[1] ? a.task = arguments[1] : a.n = arguments[1]);
            var r = a.task;
            if (a.task = function () {
              r(t.leave);
            }, t.current + a.n - e > t.capacity) return 1 === e && (t.current--, t.firstHere = !1), t.queue.push(a);
            t.current += a.n - e, a.task(t.leave), 1 === e && (t.firstHere = !1);
          },
          leave: function leave(e) {
            if (e = e || 1, t.current -= e, t.queue.length) {
              var a = t.queue[0];
              a.n + t.current > t.capacity || (t.queue.shift(), t.current += a.n, r(a.task));
            } else if (t.current < 0) throw new Error("leave called too many times.");
          },
          available: function available(e) {
            return e = e || 1, t.current + e <= t.capacity;
          }
        };
        return t;
      };
    }();
  }).call(this, a(
  /*! ./../../process/browser.js */
  9));
},
/*!************************************************************************************!*\
  !*** ./node_modules/level-ws/node_modules/readable-stream/lib/_stream_readable.js ***!
  \************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    e.exports = d;
    var r = a(
    /*! isarray */
    560),
        n = a(
    /*! buffer */
    1).Buffer;
    d.ReadableState = u;
    var s = a(
    /*! events */
    41).EventEmitter;
    s.listenerCount || (s.listenerCount = function (e, t) {
      return e.listeners(t).length;
    });
    var o,
        i = a(
    /*! stream */
    28),
        c = a(
    /*! core-util-is */
    27);

    function u(e, t) {
      var r = (e = e || {}).highWaterMark;
      this.highWaterMark = r || 0 === r ? r : 16384, this.highWaterMark = ~~this.highWaterMark, this.buffer = [], this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = !1, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.calledRead = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.objectMode = !!e.objectMode, this.defaultEncoding = e.defaultEncoding || "utf8", this.ranOut = !1, this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, e.encoding && (o || (o = a(
      /*! string_decoder/ */
      53).StringDecoder), this.decoder = new o(e.encoding), this.encoding = e.encoding);
    }

    function d(e) {
      if (!(this instanceof d)) return new d(e);
      this._readableState = new u(e, this), this.readable = !0, i.call(this);
    }

    function f(e, a, r, s, o) {
      var i = function (e, t) {
        var a = null;
        n.isBuffer(t) || "string" == typeof t || null == t || e.objectMode || (a = new TypeError("Invalid non-string/buffer chunk"));
        return a;
      }(a, r);

      if (i) e.emit("error", i);else if (null == r) a.reading = !1, a.ended || function (e, t) {
        if (t.decoder && !t.ended) {
          var a = t.decoder.end();
          a && a.length && (t.buffer.push(a), t.length += t.objectMode ? 1 : a.length);
        }

        t.ended = !0, t.length > 0 ? p(e) : g(e);
      }(e, a);else if (a.objectMode || r && r.length > 0) {
        if (a.ended && !o) {
          var c = new Error("stream.push() after EOF");
          e.emit("error", c);
        } else if (a.endEmitted && o) {
          c = new Error("stream.unshift() after end event");
          e.emit("error", c);
        } else !a.decoder || o || s || (r = a.decoder.write(r)), a.length += a.objectMode ? 1 : r.length, o ? a.buffer.unshift(r) : (a.reading = !1, a.buffer.push(r)), a.needReadable && p(e), function (e, a) {
          a.readingMore || (a.readingMore = !0, t.nextTick(function () {
            !function (e, t) {
              var a = t.length;

              for (; !t.reading && !t.flowing && !t.ended && t.length < t.highWaterMark && (e.read(0), a !== t.length);) {
                a = t.length;
              }

              t.readingMore = !1;
            }(e, a);
          }));
        }(e, a);
      } else o || (a.reading = !1);
      return function (e) {
        return !e.ended && (e.needReadable || e.length < e.highWaterMark || 0 === e.length);
      }(a);
    }

    c.inherits = a(
    /*! inherits */
    3), c.inherits(d, i), d.prototype.push = function (e, t) {
      var a = this._readableState;
      return "string" != typeof e || a.objectMode || (t = t || a.defaultEncoding) !== a.encoding && (e = new n(e, t), t = ""), f(this, a, e, t, !1);
    }, d.prototype.unshift = function (e) {
      return f(this, this._readableState, e, "", !0);
    }, d.prototype.setEncoding = function (e) {
      o || (o = a(
      /*! string_decoder/ */
      53).StringDecoder), this._readableState.decoder = new o(e), this._readableState.encoding = e;
    };
    var l = 8388608;

    function h(e, t) {
      return 0 === t.length && t.ended ? 0 : t.objectMode ? 0 === e ? 0 : 1 : null === e || isNaN(e) ? t.flowing && t.buffer.length ? t.buffer[0].length : t.length : e <= 0 ? 0 : (e > t.highWaterMark && (t.highWaterMark = function (e) {
        if (e >= l) e = l;else {
          e--;

          for (var t = 1; t < 32; t <<= 1) {
            e |= e >> t;
          }

          e++;
        }
        return e;
      }(e)), e > t.length ? t.ended ? t.length : (t.needReadable = !0, 0) : e);
    }

    function p(e) {
      var a = e._readableState;
      a.needReadable = !1, a.emittedReadable || (a.emittedReadable = !0, a.sync ? t.nextTick(function () {
        b(e);
      }) : b(e));
    }

    function b(e) {
      e.emit("readable");
    }

    function m(e) {
      var t,
          a = e._readableState;

      function r(e, r, n) {
        !1 === e.write(t) && a.awaitDrain++;
      }

      for (a.awaitDrain = 0; a.pipesCount && null !== (t = e.read());) {
        if (1 === a.pipesCount ? r(a.pipes) : A(a.pipes, r), e.emit("data", t), a.awaitDrain > 0) return;
      }

      if (0 === a.pipesCount) return a.flowing = !1, void (s.listenerCount(e, "data") > 0 && v(e));
      a.ranOut = !0;
    }

    function y() {
      this._readableState.ranOut && (this._readableState.ranOut = !1, m(this));
    }

    function v(e, a) {
      if (e._readableState.flowing) throw new Error("Cannot switch to old mode now.");
      var r = a || !1,
          n = !1;
      e.readable = !0, e.pipe = i.prototype.pipe, e.on = e.addListener = i.prototype.on, e.on("readable", function () {
        var t;

        for (n = !0; !r && null !== (t = e.read());) {
          e.emit("data", t);
        }

        null === t && (n = !1, e._readableState.needReadable = !0);
      }), e.pause = function () {
        r = !0, this.emit("pause");
      }, e.resume = function () {
        r = !1, n ? t.nextTick(function () {
          e.emit("readable");
        }) : this.read(0), this.emit("resume");
      }, e.emit("readable");
    }

    function _(e, t) {
      var a,
          r = t.buffer,
          s = t.length,
          o = !!t.decoder,
          i = !!t.objectMode;
      if (0 === r.length) return null;
      if (0 === s) a = null;else if (i) a = r.shift();else if (!e || e >= s) a = o ? r.join("") : n.concat(r, s), r.length = 0;else {
        if (e < r[0].length) a = (f = r[0]).slice(0, e), r[0] = f.slice(e);else if (e === r[0].length) a = r.shift();else {
          a = o ? "" : new n(e);

          for (var c = 0, u = 0, d = r.length; u < d && c < e; u++) {
            var f = r[0],
                l = Math.min(e - c, f.length);
            o ? a += f.slice(0, l) : f.copy(a, c, 0, l), l < f.length ? r[0] = f.slice(l) : r.shift(), c += l;
          }
        }
      }
      return a;
    }

    function g(e) {
      var a = e._readableState;
      if (a.length > 0) throw new Error("endReadable called on non-empty stream");
      !a.endEmitted && a.calledRead && (a.ended = !0, t.nextTick(function () {
        a.endEmitted || 0 !== a.length || (a.endEmitted = !0, e.readable = !1, e.emit("end"));
      }));
    }

    function A(e, t) {
      for (var a = 0, r = e.length; a < r; a++) {
        t(e[a], a);
      }
    }

    d.prototype.read = function (e) {
      var t = this._readableState;
      t.calledRead = !0;
      var a,
          r = e;
      if (("number" != typeof e || e > 0) && (t.emittedReadable = !1), 0 === e && t.needReadable && (t.length >= t.highWaterMark || t.ended)) return p(this), null;
      if (0 === (e = h(e, t)) && t.ended) return a = null, t.length > 0 && t.decoder && (a = _(e, t), t.length -= a.length), 0 === t.length && g(this), a;
      var n = t.needReadable;
      return t.length - e <= t.highWaterMark && (n = !0), (t.ended || t.reading) && (n = !1), n && (t.reading = !0, t.sync = !0, 0 === t.length && (t.needReadable = !0), this._read(t.highWaterMark), t.sync = !1), n && !t.reading && (e = h(r, t)), null === (a = e > 0 ? _(e, t) : null) && (t.needReadable = !0, e = 0), t.length -= e, 0 !== t.length || t.ended || (t.needReadable = !0), t.ended && !t.endEmitted && 0 === t.length && g(this), a;
    }, d.prototype._read = function (e) {
      this.emit("error", new Error("not implemented"));
    }, d.prototype.pipe = function (e, a) {
      var n = this,
          o = this._readableState;

      switch (o.pipesCount) {
        case 0:
          o.pipes = e;
          break;

        case 1:
          o.pipes = [o.pipes, e];
          break;

        default:
          o.pipes.push(e);
      }

      o.pipesCount += 1;
      var i = (!a || !1 !== a.end) && e !== t.stdout && e !== t.stderr ? u : f;

      function c(e) {
        e === n && f();
      }

      function u() {
        e.end();
      }

      o.endEmitted ? t.nextTick(i) : n.once("end", i), e.on("unpipe", c);

      var d = function (e) {
        return function () {
          var t = e._readableState;
          t.awaitDrain--, 0 === t.awaitDrain && m(e);
        };
      }(n);

      function f() {
        e.removeListener("close", h), e.removeListener("finish", p), e.removeListener("drain", d), e.removeListener("error", l), e.removeListener("unpipe", c), n.removeListener("end", u), n.removeListener("end", f), e._writableState && !e._writableState.needDrain || d();
      }

      function l(t) {
        b(), e.removeListener("error", l), 0 === s.listenerCount(e, "error") && e.emit("error", t);
      }

      function h() {
        e.removeListener("finish", p), b();
      }

      function p() {
        e.removeListener("close", h), b();
      }

      function b() {
        n.unpipe(e);
      }

      return e.on("drain", d), e._events && e._events.error ? r(e._events.error) ? e._events.error.unshift(l) : e._events.error = [l, e._events.error] : e.on("error", l), e.once("close", h), e.once("finish", p), e.emit("pipe", n), o.flowing || (this.on("readable", y), o.flowing = !0, t.nextTick(function () {
        m(n);
      })), e;
    }, d.prototype.unpipe = function (e) {
      var t = this._readableState;
      if (0 === t.pipesCount) return this;
      if (1 === t.pipesCount) return e && e !== t.pipes ? this : (e || (e = t.pipes), t.pipes = null, t.pipesCount = 0, this.removeListener("readable", y), t.flowing = !1, e && e.emit("unpipe", this), this);

      if (!e) {
        var a = t.pipes,
            r = t.pipesCount;
        t.pipes = null, t.pipesCount = 0, this.removeListener("readable", y), t.flowing = !1;

        for (var n = 0; n < r; n++) {
          a[n].emit("unpipe", this);
        }

        return this;
      }

      return -1 === (n = function (e, t) {
        for (var a = 0, r = e.length; a < r; a++) {
          if (e[a] === t) return a;
        }

        return -1;
      }(t.pipes, e)) ? this : (t.pipes.splice(n, 1), t.pipesCount -= 1, 1 === t.pipesCount && (t.pipes = t.pipes[0]), e.emit("unpipe", this), this);
    }, d.prototype.on = function (e, t) {
      var a = i.prototype.on.call(this, e, t);

      if ("data" !== e || this._readableState.flowing || v(this), "readable" === e && this.readable) {
        var r = this._readableState;
        r.readableListening || (r.readableListening = !0, r.emittedReadable = !1, r.needReadable = !0, r.reading ? r.length && p(this) : this.read(0));
      }

      return a;
    }, d.prototype.addListener = d.prototype.on, d.prototype.resume = function () {
      v(this), this.read(0), this.emit("resume");
    }, d.prototype.pause = function () {
      v(this, !0), this.emit("pause");
    }, d.prototype.wrap = function (e) {
      var t = this._readableState,
          a = !1,
          r = this;

      for (var n in e.on("end", function () {
        if (t.decoder && !t.ended) {
          var e = t.decoder.end();
          e && e.length && r.push(e);
        }

        r.push(null);
      }), e.on("data", function (n) {
        (t.decoder && (n = t.decoder.write(n)), t.objectMode && null == n) || (t.objectMode || n && n.length) && (r.push(n) || (a = !0, e.pause()));
      }), e) {
        "function" == typeof e[n] && void 0 === this[n] && (this[n] = function (t) {
          return function () {
            return e[t].apply(e, arguments);
          };
        }(n));
      }

      return A(["error", "close", "destroy", "pause", "resume"], function (t) {
        e.on(t, r.emit.bind(r, t));
      }), r._read = function (t) {
        a && (a = !1, e.resume());
      }, r;
    }, d._fromList = _;
  }).call(this, a(
  /*! ./../../../../process/browser.js */
  9));
},
/*!************************************************************************************!*\
  !*** ./node_modules/level-ws/node_modules/readable-stream/lib/_stream_writable.js ***!
  \************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    e.exports = c;
    var r = a(
    /*! buffer */
    1).Buffer;
    c.WritableState = i;
    var n = a(
    /*! core-util-is */
    27);
    n.inherits = a(
    /*! inherits */
    3);
    var s = a(
    /*! stream */
    28);

    function o(e, t, a) {
      this.chunk = e, this.encoding = t, this.callback = a;
    }

    function i(e, a) {
      var r = (e = e || {}).highWaterMark;
      this.highWaterMark = r || 0 === r ? r : 16384, this.objectMode = !!e.objectMode, this.highWaterMark = ~~this.highWaterMark, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1;
      var n = !1 === e.decodeStrings;
      this.decodeStrings = !n, this.defaultEncoding = e.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function (e) {
        !function (e, a) {
          var r = e._writableState,
              n = r.sync,
              s = r.writecb;
          if (function (e) {
            e.writing = !1, e.writecb = null, e.length -= e.writelen, e.writelen = 0;
          }(r), a) !function (e, a, r, n, s) {
            r ? t.nextTick(function () {
              s(n);
            }) : s(n);
            e._writableState.errorEmitted = !0, e.emit("error", n);
          }(e, 0, n, a, s);else {
            var o = f(e, r);
            o || r.bufferProcessing || !r.buffer.length || function (e, t) {
              t.bufferProcessing = !0;

              for (var a = 0; a < t.buffer.length; a++) {
                var r = t.buffer[a],
                    n = r.chunk,
                    s = r.encoding,
                    o = r.callback,
                    i = t.objectMode ? 1 : n.length;

                if (u(e, t, i, n, s, o), t.writing) {
                  a++;
                  break;
                }
              }

              t.bufferProcessing = !1, a < t.buffer.length ? t.buffer = t.buffer.slice(a) : t.buffer.length = 0;
            }(e, r), n ? t.nextTick(function () {
              d(e, r, o, s);
            }) : d(e, r, o, s);
          }
        }(a, e);
      }, this.writecb = null, this.writelen = 0, this.buffer = [], this.errorEmitted = !1;
    }

    function c(e) {
      var t = a(
      /*! ./_stream_duplex */
      116);
      if (!(this instanceof c || this instanceof t)) return new c(e);
      this._writableState = new i(e, this), this.writable = !0, s.call(this);
    }

    function u(e, t, a, r, n, s) {
      t.writelen = a, t.writecb = s, t.writing = !0, t.sync = !0, e._write(r, n, t.onwrite), t.sync = !1;
    }

    function d(e, t, a, r) {
      a || function (e, t) {
        0 === t.length && t.needDrain && (t.needDrain = !1, e.emit("drain"));
      }(e, t), r(), a && l(e, t);
    }

    function f(e, t) {
      return t.ending && 0 === t.length && !t.finished && !t.writing;
    }

    function l(e, t) {
      var a = f(0, t);
      return a && (t.finished = !0, e.emit("finish")), a;
    }

    n.inherits(c, s), c.prototype.pipe = function () {
      this.emit("error", new Error("Cannot pipe. Not readable."));
    }, c.prototype.write = function (e, a, n) {
      var s = this._writableState,
          i = !1;
      return "function" == typeof a && (n = a, a = null), r.isBuffer(e) ? a = "buffer" : a || (a = s.defaultEncoding), "function" != typeof n && (n = function n() {}), s.ended ? function (e, a, r) {
        var n = new Error("write after end");
        e.emit("error", n), t.nextTick(function () {
          r(n);
        });
      }(this, 0, n) : function (e, a, n, s) {
        var o = !0;

        if (!r.isBuffer(n) && "string" != typeof n && null != n && !a.objectMode) {
          var i = new TypeError("Invalid non-string/buffer chunk");
          e.emit("error", i), t.nextTick(function () {
            s(i);
          }), o = !1;
        }

        return o;
      }(this, s, e, n) && (i = function (e, t, a, n, s) {
        a = function (e, t, a) {
          e.objectMode || !1 === e.decodeStrings || "string" != typeof t || (t = new r(t, a));
          return t;
        }(t, a, n), r.isBuffer(a) && (n = "buffer");
        var i = t.objectMode ? 1 : a.length;
        t.length += i;
        var c = t.length < t.highWaterMark;
        c || (t.needDrain = !0);
        t.writing ? t.buffer.push(new o(a, n, s)) : u(e, t, i, a, n, s);
        return c;
      }(this, s, e, a, n)), i;
    }, c.prototype._write = function (e, t, a) {
      a(new Error("not implemented"));
    }, c.prototype.end = function (e, a, r) {
      var n = this._writableState;
      "function" == typeof e ? (r = e, e = null, a = null) : "function" == typeof a && (r = a, a = null), null != e && this.write(e, a), n.ending || n.finished || function (e, a, r) {
        a.ending = !0, l(e, a), r && (a.finished ? t.nextTick(r) : e.once("finish", r));
        a.ended = !0;
      }(this, n, r);
    };
  }).call(this, a(
  /*! ./../../../../process/browser.js */
  9));
},
/*!*************************************************************************************!*\
  !*** ./node_modules/level-ws/node_modules/readable-stream/lib/_stream_transform.js ***!
  \*************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  e.exports = o;
  var r = a(
  /*! ./_stream_duplex */
  116),
      n = a(
  /*! core-util-is */
  27);

  function s(e, t) {
    this.afterTransform = function (e, a) {
      return function (e, t, a) {
        var r = e._transformState;
        r.transforming = !1;
        var n = r.writecb;
        if (!n) return e.emit("error", new Error("no writecb in Transform class"));
        r.writechunk = null, r.writecb = null, null != a && e.push(a);
        n && n(t);
        var s = e._readableState;
        s.reading = !1, (s.needReadable || s.length < s.highWaterMark) && e._read(s.highWaterMark);
      }(t, e, a);
    }, this.needTransform = !1, this.transforming = !1, this.writecb = null, this.writechunk = null;
  }

  function o(e) {
    if (!(this instanceof o)) return new o(e);
    r.call(this, e);
    this._transformState = new s(e, this);
    var t = this;
    this._readableState.needReadable = !0, this._readableState.sync = !1, this.once("finish", function () {
      "function" == typeof this._flush ? this._flush(function (e) {
        i(t, e);
      }) : i(t);
    });
  }

  function i(e, t) {
    if (t) return e.emit("error", t);
    var a = e._writableState,
        r = (e._readableState, e._transformState);
    if (a.length) throw new Error("calling transform done when ws.length != 0");
    if (r.transforming) throw new Error("calling transform done when still transforming");
    return e.push(null);
  }

  n.inherits = a(
  /*! inherits */
  3), n.inherits(o, r), o.prototype.push = function (e, t) {
    return this._transformState.needTransform = !1, r.prototype.push.call(this, e, t);
  }, o.prototype._transform = function (e, t, a) {
    throw new Error("not implemented");
  }, o.prototype._write = function (e, t, a) {
    var r = this._transformState;

    if (r.writecb = a, r.writechunk = e, r.writeencoding = t, !r.transforming) {
      var n = this._readableState;
      (r.needTransform || n.needReadable || n.length < n.highWaterMark) && this._read(n.highWaterMark);
    }
  }, o.prototype._read = function (e) {
    var t = this._transformState;
    null !== t.writechunk && t.writecb && !t.transforming ? (t.transforming = !0, this._transform(t.writechunk, t.writeencoding, t.afterTransform)) : t.needTransform = !0;
  };
},
/*!*********************************************************************!*\
  !*** ./node_modules/ethashjs/node_modules/ethereumjs-util/index.js ***!
  \*********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (e) {
    var r = a(
    /*! keccakjs */
    213),
        n = a(
    /*! secp256k1 */
    30),
        s = a(
    /*! assert */
    19),
        o = a(
    /*! rlp */
    21),
        i = a(
    /*! bn.js */
    5),
        c = a(
    /*! create-hash */
    20);
    t.MAX_INTEGER = new i("ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff", 16), t.TWO_POW256 = new i("10000000000000000000000000000000000000000000000000000000000000000", 16), t.SHA3_NULL_S = "c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470", t.SHA3_NULL = new e(t.SHA3_NULL_S, "hex"), t.SHA3_RLP_ARRAY_S = "1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347", t.SHA3_RLP_ARRAY = new e(t.SHA3_RLP_ARRAY_S, "hex"), t.SHA3_RLP_S = "56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421", t.SHA3_RLP = new e(t.SHA3_RLP_S, "hex"), t.BN = i, t.rlp = o, t.secp256k1 = n, t.zeros = function (t) {
      var a = new e(t);
      return a.fill(0), a;
    }, t.setLengthLeft = t.setLength = function (e, a, r) {
      var n = t.zeros(a);
      return e = t.toBuffer(e), r ? e.length < a ? (e.copy(n), n) : e.slice(0, a) : e.length < a ? (e.copy(n, a - e.length), n) : e.slice(-a);
    }, t.setLengthRight = function (e, a) {
      return t.setLength(e, a, !0);
    }, t.unpad = t.stripZeros = function (e) {
      for (var a = (e = t.stripHexPrefix(e))[0]; e.length > 0 && "0" === a.toString();) {
        a = (e = e.slice(1))[0];
      }

      return e;
    }, t.toBuffer = function (a) {
      if (!e.isBuffer(a)) if (Array.isArray(a)) a = new e(a);else if ("string" == typeof a) a = t.isHexPrefixed(a) ? new e(t.padToEven(t.stripHexPrefix(a)), "hex") : new e(a);else if ("number" == typeof a) a = t.intToBuffer(a);else if (null == a) a = new e([]);else {
        if (!a.toArray) throw new Error("invalid type");
        a = new e(a.toArray());
      }
      return a;
    }, t.intToHex = function (e) {
      s(e % 1 == 0, "number is not a integer"), s(e >= 0, "number must be positive");
      var t = e.toString(16);
      return t.length % 2 && (t = "0" + t), "0x" + t;
    }, t.intToBuffer = function (a) {
      var r = t.intToHex(a);
      return new e(r.slice(2), "hex");
    }, t.bufferToInt = function (e) {
      return parseInt(t.bufferToHex(e), 16);
    }, t.bufferToHex = function (e) {
      return 0 === (e = t.toBuffer(e)).length ? 0 : "0x" + e.toString("hex");
    }, t.fromSigned = function (e) {
      return new i(e).fromTwos(256);
    }, t.toUnsigned = function (t) {
      return new e(t.toTwos(256).toArray());
    }, t.sha3 = function (a, n) {
      a = t.toBuffer(a), n || (n = 256);
      var s = new r(n);
      return a && s.update(a), new e(s.digest("hex"), "hex");
    }, t.sha256 = function (e) {
      return e = t.toBuffer(e), c("sha256").update(e).digest();
    }, t.ripemd160 = function (e, a) {
      e = t.toBuffer(e);
      var r = c("rmd160").update(e).digest();
      return !0 === a ? t.setLength(r, 32) : r;
    }, t.rlphash = function (e) {
      return t.sha3(o.encode(e));
    }, t.isValidPrivate = function (e) {
      return n.privateKeyVerify(e);
    }, t.isValidPublic = function (t, a) {
      return 64 === t.length ? n.publicKeyVerify(e.concat([new e([4]), t])) : !!a && n.publicKeyVerify(t);
    }, t.pubToAddress = t.publicToAddress = function (e, a) {
      return e = t.toBuffer(e), a && 64 !== e.length && (e = n.publicKeyConvert(e, !1).slice(1)), s(64 === e.length), t.sha3(e).slice(-20);
    };

    var u = t.privateToPublic = function (e) {
      return e = t.toBuffer(e), n.publicKeyCreate(e, !1).slice(1);
    };

    t.importPublic = function (e) {
      return 64 !== (e = t.toBuffer(e)).length && (e = n.publicKeyConvert(e, !1).slice(1)), e;
    }, t.ecsign = function (e, t) {
      var a = n.sign(e, t),
          r = {};
      return r.r = a.signature.slice(0, 32), r.s = a.signature.slice(32, 64), r.v = a.recovery + 27, r;
    }, t.ecrecover = function (a, r, s, o) {
      var i = e.concat([t.setLength(s, 32), t.setLength(o, 32)], 64),
          c = t.bufferToInt(r) - 27;
      if (0 !== c && 1 !== c) throw new Error("Invalid signature v value");
      var u = n.recover(a, i, c);
      return n.publicKeyConvert(u, !1).slice(1);
    }, t.toRpcSig = function (a, r, n) {
      return t.bufferToHex(e.concat([r, n, t.toBuffer(a - 27)]));
    }, t.fromRpcSig = function (e) {
      var a = (e = t.toBuffer(e))[64];
      return a < 27 && (a += 27), {
        v: a,
        r: e.slice(0, 32),
        s: e.slice(32, 64)
      };
    }, t.privateToAddress = function (e) {
      return t.publicToAddress(u(e));
    }, t.isValidAddress = function (e) {
      return /^0x[0-9a-fA-F]{40}$/i.test(e);
    }, t.toChecksumAddress = function (e) {
      e = t.stripHexPrefix(e).toLowerCase();

      for (var a = t.sha3(e).toString("hex"), r = "0x", n = 0; n < e.length; n++) {
        parseInt(a[n], 16) >= 8 ? r += e[n].toUpperCase() : r += e[n];
      }

      return r;
    }, t.isValidChecksumAddress = function (e) {
      return t.isValidAddress(e) && t.toChecksumAddress(e) === e;
    }, t.generateAddress = function (a, r) {
      return a = t.toBuffer(a), r = (r = new i(r)).isZero() ? null : new e(r.toArray()), t.rlphash([a, r]).slice(-20);
    }, t.isPrecompiled = function (e) {
      var a = t.unpad(e);
      return 1 === a.length && a[0] > 0 && a[0] < 5;
    }, t.isHexPrefixed = function (e) {
      return "0x" === e.slice(0, 2);
    }, t.stripHexPrefix = function (e) {
      return "string" != typeof e ? e : t.isHexPrefixed(e) ? e.slice(2) : e;
    }, t.addHexPrefix = function (e) {
      return "string" != typeof e ? e : t.isHexPrefixed(e) ? e : "0x" + e;
    }, t.padToEven = function (e) {
      return e.length % 2 && (e = "0" + e), e;
    }, t.baToJSON = function (a) {
      if (e.isBuffer(a)) return "0x" + a.toString("hex");

      if (a instanceof Array) {
        for (var r = [], n = 0; n < a.length; n++) {
          r.push(t.baToJSON(a[n]));
        }

        return r;
      }
    }, t.defineProperties = function (a, r, n) {
      if (a.raw = [], a._fields = [], a.toJSON = function (e) {
        if (e) {
          var r = {};
          return a._fields.forEach(function (e) {
            r[e] = "0x" + a[e].toString("hex");
          }), r;
        }

        return t.baToJSON(this.raw);
      }, a.serialize = function () {
        return o.encode(a.raw);
      }, r.forEach(function (r, n) {
        function o() {
          return a.raw[n];
        }

        function i(o) {
          "00" !== (o = t.toBuffer(o)).toString("hex") || r.allowZero || (o = new e([])), r.allowLess && r.length ? (o = t.stripZeros(o), s(r.length >= o.length, "The field " + r.name + " must not have more " + r.length + " bytes")) : r.allowZero && 0 === o.length || !r.length || s(r.length === o.length, "The field " + r.name + " must have byte length of " + r.length), a.raw[n] = o;
        }

        a._fields.push(r.name), Object.defineProperty(a, r.name, {
          enumerable: !0,
          configurable: !0,
          get: o,
          set: i
        }), r.default && (a[r.name] = r.default), r.alias && Object.defineProperty(a, r.alias, {
          enumerable: !1,
          configurable: !0,
          set: i,
          get: o
        });
      }), n) if ("string" == typeof n && (n = new e(t.stripHexPrefix(n), "hex")), e.isBuffer(n) && (n = o.decode(n)), Array.isArray(n)) {
        if (n.length > a._fields.length) throw new Error("wrong number of fields in data");
        n.forEach(function (e, r) {
          a[a._fields[r]] = t.toBuffer(e);
        });
      } else {
        if ("object" != typeof n) throw new Error("invalid data");

        for (var i in n) {
          -1 !== a._fields.indexOf(i) && (a[i] = n[i]);
        }
      }
    };
  }).call(this, a(
  /*! ./../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!******************************************!*\
  !*** ./node_modules/keccakjs/browser.js ***!
  \******************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  e.exports = a(
  /*! browserify-sha3 */
  571).SHA3Hash;
},
/*!*************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-common/dist/index.js ***!
  \*************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = this && this.__assign || function () {
    return (r = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var n = a(
  /*! ./chains */
  576),
      s = a(
  /*! ./hardforks */
  582),
      o = function () {
    function e(e, t, a) {
      this._chainParams = this.setChain(e), this._hardfork = null, this._supportedHardforks = void 0 === a ? [] : a, t && this.setHardfork(t);
    }

    return e.forCustomChain = function (t, a, n, s) {
      var o = e._getChainParams(t);

      return new e(r({}, o, a), n, s);
    }, e._getChainParams = function (e) {
      if ("number" == typeof e) {
        if (n.chains.names[e]) return n.chains[n.chains.names[e]];
        throw new Error("Chain with ID " + e + " not supported");
      }

      if (n.chains[e]) return n.chains[e];
      throw new Error("Chain with name " + e + " not supported");
    }, e.prototype.setChain = function (t) {
      if ("number" == typeof t || "string" == typeof t) this._chainParams = e._getChainParams(t);else {
        if ("object" != typeof t) throw new Error("Wrong input format");

        for (var a = 0, r = ["networkId", "genesis", "hardforks", "bootstrapNodes"]; a < r.length; a++) {
          var n = r[a];
          if (void 0 === t[n]) throw new Error("Missing required chain parameter: " + n);
        }

        this._chainParams = t;
      }
      return this._chainParams;
    }, e.prototype.setHardfork = function (e) {
      if (!this._isSupportedHardfork(e)) throw new Error("Hardfork " + e + " not set as supported in supportedHardforks");

      for (var t = !1, a = 0, r = s.hardforks; a < r.length; a++) {
        r[a][0] === e && (this._hardfork = e, t = !0);
      }

      if (!t) throw new Error("Hardfork with name " + e + " not supported");
    }, e.prototype._chooseHardfork = function (e, t) {
      if (t = void 0 === t || t, e) {
        if (t && !this._isSupportedHardfork(e)) throw new Error("Hardfork " + e + " not set as supported in supportedHardforks");
      } else {
        if (!this._hardfork) throw new Error("Method called with neither a hardfork set nor provided by param");
        e = this._hardfork;
      }

      return e;
    }, e.prototype._getHardfork = function (e) {
      for (var t = 0, a = this.hardforks(); t < a.length; t++) {
        var r = a[t];
        if (r.name === e) return r;
      }

      throw new Error("Hardfork " + e + " not defined for chain " + this.chainName());
    }, e.prototype._isSupportedHardfork = function (e) {
      if (!(this._supportedHardforks.length > 0)) return !0;

      for (var t = 0, a = this._supportedHardforks; t < a.length; t++) {
        if (e === a[t]) return !0;
      }

      return !1;
    }, e.prototype.param = function (e, t, a) {
      var r;
      a = this._chooseHardfork(a);

      for (var n = 0, o = s.hardforks; n < o.length; n++) {
        var i = o[n];
        if (!i[1][e]) throw new Error("Topic " + e + " not defined");
        if (void 0 !== i[1][e][t] && (r = i[1][e][t].v), i[0] === a) break;
      }

      if (void 0 === r) throw new Error(e + " value for " + t + " not found");
      return r;
    }, e.prototype.paramByBlock = function (e, t, a) {
      var r = this.activeHardforks(a),
          n = r[r.length - 1].name;
      return this.param(e, t, n);
    }, e.prototype.hardforkIsActiveOnBlock = function (e, t, a) {
      var r = void 0 !== (a = void 0 !== a ? a : {}).onlySupported && a.onlySupported;
      e = this._chooseHardfork(e, r);
      var n = this.hardforkBlock(e);
      return null !== n && t >= n;
    }, e.prototype.activeOnBlock = function (e, t) {
      return this.hardforkIsActiveOnBlock(null, e, t);
    }, e.prototype.hardforkGteHardfork = function (e, t, a) {
      var r = void 0 !== (a = void 0 !== a ? a : {}).onlyActive && a.onlyActive;
      e = this._chooseHardfork(e, a.onlySupported);

      for (var n = -1, s = -1, o = 0, i = 0, c = r ? this.activeHardforks(null, a) : this.hardforks(); i < c.length; i++) {
        var u = c[i];
        u.name === e && (n = o), u.name === t && (s = o), o += 1;
      }

      return n >= s;
    }, e.prototype.gteHardfork = function (e, t) {
      return this.hardforkGteHardfork(null, e, t);
    }, e.prototype.hardforkIsActiveOnChain = function (e, t) {
      var a = void 0 !== (t = void 0 !== t ? t : {}).onlySupported && t.onlySupported;
      e = this._chooseHardfork(e, a);

      for (var r = 0, n = this.hardforks(); r < n.length; r++) {
        var s = n[r];
        if (s.name === e && null !== s.block) return !0;
      }

      return !1;
    }, e.prototype.activeHardforks = function (e, t) {
      t = void 0 !== t ? t : {};

      for (var a = [], r = 0, n = this.hardforks(); r < n.length; r++) {
        var s = n[r];

        if (null !== s.block) {
          if (null != e && e < s.block) break;
          t.onlySupported && !this._isSupportedHardfork(s.name) || a.push(s);
        }
      }

      return a;
    }, e.prototype.activeHardfork = function (e, t) {
      t = void 0 !== t ? t : {};
      var a = this.activeHardforks(e, t);
      if (a.length > 0) return a[a.length - 1].name;
      throw new Error("No (supported) active hardfork found");
    }, e.prototype.hardforkBlock = function (e) {
      return e = this._chooseHardfork(e, !1), this._getHardfork(e).block;
    }, e.prototype.isHardforkBlock = function (e, t) {
      return t = this._chooseHardfork(t, !1), this.hardforkBlock(t) === e;
    }, e.prototype.consensus = function (e) {
      return e = this._chooseHardfork(e), this._getHardfork(e).consensus;
    }, e.prototype.finality = function (e) {
      return e = this._chooseHardfork(e), this._getHardfork(e).finality;
    }, e.prototype.genesis = function () {
      return this._chainParams.genesis;
    }, e.prototype.hardforks = function () {
      return this._chainParams.hardforks;
    }, e.prototype.bootstrapNodes = function () {
      return this._chainParams.bootstrapNodes;
    }, e.prototype.hardfork = function () {
      return this._hardfork;
    }, e.prototype.chainId = function () {
      return this._chainParams.chainId;
    }, e.prototype.chainName = function () {
      return n.chains.names[this.chainId()] || this._chainParams.name;
    }, e.prototype.networkId = function () {
      return this._chainParams.networkId;
    }, e;
  }();

  t.default = o;
},
/*!*******************************************************!*\
  !*** ./node_modules/core-js-pure/internals/export.js ***!
  \*******************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ../internals/global */
  38),
      n = a(
  /*! ../internals/object-get-own-property-descriptor */
  597).f,
      s = a(
  /*! ../internals/is-forced */
  599),
      o = a(
  /*! ../internals/path */
  121),
      i = a(
  /*! ../internals/bind-context */
  84),
      c = a(
  /*! ../internals/hide */
  42),
      u = a(
  /*! ../internals/has */
  51),
      d = function d(e) {
    var t = function t(_t3, a, r) {
      if (this instanceof e) {
        switch (arguments.length) {
          case 0:
            return new e();

          case 1:
            return new e(_t3);

          case 2:
            return new e(_t3, a);
        }

        return new e(_t3, a, r);
      }

      return e.apply(this, arguments);
    };

    return t.prototype = e.prototype, t;
  };

  e.exports = function (e, t) {
    var a,
        f,
        l,
        h,
        p,
        b,
        m,
        y,
        v = e.target,
        _ = e.global,
        g = e.stat,
        A = e.proto,
        w = _ ? r : g ? r[v] : (r[v] || {}).prototype,
        T = _ ? o : o[v] || (o[v] = {}),
        x = T.prototype;

    for (l in t) {
      a = !s(_ ? l : v + (g ? "." : "#") + l, e.forced) && w && u(w, l), p = T[l], a && (b = e.noTargetGet ? (y = n(w, l)) && y.value : w[l]), h = a && b ? b : t[l], a && typeof p == typeof h || (m = e.bind && a ? i(h, r) : e.wrap && a ? d(h) : A && "function" == typeof h ? i(Function.call, h) : h, (e.sham || h && h.sham || p && p.sham) && c(m, "sham", !0), T[l] = m, A && (u(o, f = v + "Prototype") || c(o, f, {}), o[f][l] = h, e.real && x && !x[l] && c(x, l, h)));
    }
  };
},
/*!***************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/indexed-object.js ***!
  \***************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/fails */
  49),
      n = a(
  /*! ../internals/classof-raw */
  119),
      s = "".split;
  e.exports = r(function () {
    return !Object("z").propertyIsEnumerable(0);
  }) ? function (e) {
    return "String" == n(e) ? s.call(e, "") : Object(e);
  } : Object;
},
/*!*************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/to-primitive.js ***!
  \*************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/is-object */
  50);

  e.exports = function (e, t) {
    if (!r(e)) return e;
    var a, n;
    if (t && "function" == typeof (a = e.toString) && !r(n = a.call(e))) return n;
    if ("function" == typeof (a = e.valueOf) && !r(n = a.call(e))) return n;
    if (!t && "function" == typeof (a = e.toString) && !r(n = a.call(e))) return n;
    throw TypeError("Can't convert object to primitive value");
  };
},
/*!***************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/ie8-dom-define.js ***!
  \***************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/descriptors */
  48),
      n = a(
  /*! ../internals/fails */
  49),
      s = a(
  /*! ../internals/document-create-element */
  219);
  e.exports = !r && !n(function () {
    return 7 != Object.defineProperty(s("div"), "a", {
      get: function get() {
        return 7;
      }
    }).a;
  });
},
/*!************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/document-create-element.js ***!
  \************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/global */
  38),
      n = a(
  /*! ../internals/is-object */
  50),
      s = r.document,
      o = n(s) && n(s.createElement);

  e.exports = function (e) {
    return o ? s.createElement(e) : {};
  };
},
/*!******************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/internal-metadata.js ***!
  \******************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/hidden-keys */
  85),
      n = a(
  /*! ../internals/is-object */
  50),
      s = a(
  /*! ../internals/has */
  51),
      o = a(
  /*! ../internals/object-define-property */
  56).f,
      i = a(
  /*! ../internals/uid */
  122),
      c = a(
  /*! ../internals/freezing */
  601),
      u = i("meta"),
      d = 0,
      f = Object.isExtensible || function () {
    return !0;
  },
      l = function l(e) {
    o(e, u, {
      value: {
        objectID: "O" + ++d,
        weakData: {}
      }
    });
  },
      h = e.exports = {
    REQUIRED: !1,
    fastKey: function fastKey(e, t) {
      if (!n(e)) return "symbol" == typeof e ? e : ("string" == typeof e ? "S" : "P") + e;

      if (!s(e, u)) {
        if (!f(e)) return "F";
        if (!t) return "E";
        l(e);
      }

      return e[u].objectID;
    },
    getWeakData: function getWeakData(e, t) {
      if (!s(e, u)) {
        if (!f(e)) return !0;
        if (!t) return !1;
        l(e);
      }

      return e[u].weakData;
    },
    onFreeze: function onFreeze(e) {
      return c && h.REQUIRED && f(e) && !s(e, u) && l(e), e;
    }
  };

  r[u] = !0;
},
/*!********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/iterate.js ***!
  \********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/an-object */
  64),
      n = a(
  /*! ../internals/is-array-iterator-method */
  602),
      s = a(
  /*! ../internals/to-length */
  125),
      o = a(
  /*! ../internals/bind-context */
  84),
      i = a(
  /*! ../internals/get-iterator-method */
  605),
      c = a(
  /*! ../internals/call-with-safe-iteration-closing */
  606),
      u = function u(e, t) {
    this.stopped = e, this.result = t;
  };

  (e.exports = function (e, t, a, d, f) {
    var l,
        h,
        p,
        b,
        m,
        y,
        v = o(t, a, d ? 2 : 1);
    if (f) l = e;else {
      if ("function" != typeof (h = i(e))) throw TypeError("Target is not iterable");

      if (n(h)) {
        for (p = 0, b = s(e.length); b > p; p++) {
          if ((m = d ? v(r(y = e[p])[0], y[1]) : v(e[p])) && m instanceof u) return m;
        }

        return new u(!1);
      }

      l = h.call(e);
    }

    for (; !(y = l.next()).done;) {
      if ((m = c(l, v, y.value, d)) && m instanceof u) return m;
    }

    return new u(!1);
  }).stop = function (e) {
    return new u(!0, e);
  };
},
/*!********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/classof.js ***!
  \********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/classof-raw */
  119),
      n = a(
  /*! ../internals/well-known-symbol */
  39)("toStringTag"),
      s = "Arguments" == r(function () {
    return arguments;
  }());

  e.exports = function (e) {
    var t, a, o;
    return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (a = function (e, t) {
      try {
        return e[t];
      } catch (e) {}
    }(t = Object(e), n)) ? a : s ? r(t) : "Object" == (o = r(t)) && "function" == typeof t.callee ? "Arguments" : o;
  };
},
/*!************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/an-instance.js ***!
  \************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = function (e, t, a) {
    if (!(e instanceof t)) throw TypeError("Incorrect " + (a ? a + " " : "") + "invocation");
    return e;
  };
},
/*!**********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/to-object.js ***!
  \**********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/require-object-coercible */
  120);

  e.exports = function (e) {
    return Object(r(e));
  };
},
/*!**************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/object-create.js ***!
  \**************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/an-object */
  64),
      n = a(
  /*! ../internals/object-define-properties */
  614),
      s = a(
  /*! ../internals/enum-bug-keys */
  226),
      o = a(
  /*! ../internals/hidden-keys */
  85),
      i = a(
  /*! ../internals/html */
  619),
      c = a(
  /*! ../internals/document-create-element */
  219),
      u = a(
  /*! ../internals/shared-key */
  128)("IE_PROTO"),
      d = function d() {},
      f = function (_f) {
    function f() {
      return _f.apply(this, arguments);
    }

    f.toString = function () {
      return _f.toString();
    };

    return f;
  }(function () {
    var e,
        t = c("iframe"),
        a = s.length;

    for (t.style.display = "none", i.appendChild(t), t.src = String("javascript:"), (e = t.contentWindow.document).open(), e.write("<script>document.F=Object<\/script>"), e.close(), f = e.F; a--;) {
      delete f.prototype[s[a]];
    }

    return f();
  });

  e.exports = Object.create || function (e, t) {
    var a;
    return null !== e ? (d.prototype = r(e), a = new d(), d.prototype = null, a[u] = e) : a = f(), void 0 === t ? a : n(a, t);
  }, o[u] = !0;
},
/*!**************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/enum-bug-keys.js ***!
  \**************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
},
/*!*************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/get-built-in.js ***!
  \*************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/path */
  121),
      n = a(
  /*! ../internals/global */
  38),
      s = function s(e) {
    return "function" == typeof e ? e : void 0;
  };

  e.exports = function (e, t) {
    return arguments.length < 2 ? s(r[e]) || s(n[e]) : r[e] && r[e][t] || n[e] && n[e][t];
  };
},
/*!*********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/redefine.js ***!
  \*********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/hide */
  42);

  e.exports = function (e, t, a, n) {
    n && n.enumerable ? e[t] = a : r(e, t, a);
  };
},
/*!***************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/iterators-core.js ***!
  \***************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r,
      n,
      s,
      o = a(
  /*! ../internals/object-get-prototype-of */
  230),
      i = a(
  /*! ../internals/hide */
  42),
      c = a(
  /*! ../internals/has */
  51),
      u = a(
  /*! ../internals/well-known-symbol */
  39),
      d = a(
  /*! ../internals/is-pure */
  124),
      f = u("iterator"),
      l = !1;
  [].keys && ("next" in (s = [].keys()) ? (n = o(o(s))) !== Object.prototype && (r = n) : l = !0), null == r && (r = {}), d || c(r, f) || i(r, f, function () {
    return this;
  }), e.exports = {
    IteratorPrototype: r,
    BUGGY_SAFARI_ITERATORS: l
  };
},
/*!************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/object-get-prototype-of.js ***!
  \************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/has */
  51),
      n = a(
  /*! ../internals/to-object */
  224),
      s = a(
  /*! ../internals/shared-key */
  128),
      o = a(
  /*! ../internals/correct-prototype-getter */
  622),
      i = s("IE_PROTO"),
      c = Object.prototype;
  e.exports = o ? Object.getPrototypeOf : function (e) {
    return e = n(e), r(e, i) ? e[i] : "function" == typeof e.constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? c : null;
  };
},
/*!*****************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/secure.js ***!
  \*****************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./index */
  112),
      n = a(
  /*! ./secure-interface */
  633),
      s = a(
  /*! util */
  23).inherits;

  function o() {
    r.apply(this, arguments), n(this);
  }

  e.exports = o, s(o, r);
},
/*!*******************************************!*\
  !*** ./node_modules/object-keys/index.js ***!
  \*******************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = Array.prototype.slice,
      n = a(
  /*! ./isArguments */
  233),
      s = Object.keys,
      o = s ? function (e) {
    return s(e);
  } : a(
  /*! ./implementation */
  642),
      i = Object.keys;
  o.shim = function () {
    Object.keys ? function () {
      var e = Object.keys(arguments);
      return e && e.length === arguments.length;
    }(1, 2) || (Object.keys = function (e) {
      return n(e) ? i(r.call(e)) : i(e);
    }) : Object.keys = o;
    return Object.keys || o;
  }, e.exports = o;
},
/*!*************************************************!*\
  !*** ./node_modules/object-keys/isArguments.js ***!
  \*************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = Object.prototype.toString;

  e.exports = function (e) {
    var t = r.call(e),
        a = "[object Arguments]" === t;
    return a || (a = "[object Array]" !== t && null !== e && "object" == typeof e && "number" == typeof e.length && e.length >= 0 && "[object Function]" === r.call(e.callee)), a;
  };
},
/*!*******************************************************!*\
  !*** ./node_modules/util.promisify/implementation.js ***!
  \*******************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  if (!("function" == typeof Object.defineProperty && "function" == typeof Object.defineProperties && "function" == typeof Object.getPrototypeOf && "function" == typeof Object.setPrototypeOf)) throw new TypeError("util.promisify requires a true ES5 environment");
  var r = a(
  /*! object.getownpropertydescriptors */
  643);
  if ("function" != typeof Promise) throw new TypeError("`Promise` must be globally available for util.promisify to work.");
  var n = Function.call.bind(Array.prototype.slice),
      s = Function.call.bind(Array.prototype.concat),
      o = Function.call.bind(Array.prototype.forEach),
      i = "function" == typeof Symbol && "symbol" == typeof Symbol(""),
      c = i ? Symbol("util.promisify.custom") : null,
      u = i ? Symbol("customPromisifyArgs") : null;
  e.exports = function (e) {
    if ("function" != typeof e) {
      var t = new TypeError('The "original" argument must be of type function');
      throw t.name = "TypeError [ERR_INVALID_ARG_TYPE]", t.code = "ERR_INVALID_ARG_TYPE", t;
    }

    if (i && e[c]) {
      var a = e[c];
      if ("function" != typeof a) throw new TypeError("The [util.promisify.custom] property must be a function");
      return Object.defineProperty(a, c, {
        configurable: !0,
        enumerable: !1,
        value: a,
        writable: !1
      }), a;
    }

    var d = e[u],
        f = function f() {
      var t = n(arguments),
          a = this;
      return new Promise(function (r, i) {
        e.apply(a, s(t, function (e) {
          var t = arguments.length > 1 ? n(arguments, 1) : [];
          if (e) i(e);else if (void 0 !== d && t.length > 1) {
            var a = {};
            o(d, function (e, r) {
              a[e] = t[r];
            }), r(a);
          } else r(t[0]);
        }));
      });
    };

    return Object.setPrototypeOf(f, Object.getPrototypeOf(e)), Object.defineProperty(f, c, {
      configurable: !0,
      enumerable: !1,
      value: f,
      writable: !1
    }), Object.defineProperties(f, r(e));
  }, e.exports.custom = c, e.exports.customPromisifyArgs = u;
},
/*!*************************************************************************!*\
  !*** ./node_modules/object.getownpropertydescriptors/implementation.js ***!
  \*************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! es-abstract/es7 */
  644),
      n = Object.defineProperty,
      s = Object.getOwnPropertyDescriptor,
      o = Object.getOwnPropertyNames,
      i = Object.getOwnPropertySymbols,
      c = Function.call.bind(Array.prototype.concat),
      u = Function.call.bind(Array.prototype.reduce),
      d = i ? function (e) {
    return c(o(e), i(e));
  } : o,
      f = r.IsCallable(s) && r.IsCallable(o);

  e.exports = function (e) {
    if (r.RequireObjectCoercible(e), !f) throw new TypeError("getOwnPropertyDescriptors requires Object.getOwnPropertyDescriptor");
    var t = r.ToObject(e);
    return u(d(t), function (e, a) {
      var r,
          o,
          i,
          c = s(t, a);
      return void 0 !== c && (r = e, o = a, i = c, n && o in r ? n(r, o, {
        configurable: !0,
        enumerable: !0,
        value: i,
        writable: !0
      }) : r[o] = i), e;
    }, {});
  };
},
/*!*************************************************************!*\
  !*** ./node_modules/es-to-primitive/helpers/isPrimitive.js ***!
  \*************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = function (e) {
    return null === e || "function" != typeof e && "object" != typeof e;
  };
},
/*!**********************************************************!*\
  !*** ./node_modules/es-abstract/helpers/assertRecord.js ***!
  \**********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ../GetIntrinsic */
  134),
      n = r("%TypeError%"),
      s = r("%SyntaxError%"),
      o = a(
  /*! has */
  89),
      i = {
    "Property Descriptor": function PropertyDescriptor(e, t) {
      if ("Object" !== e.Type(t)) return !1;
      var a = {
        "[[Configurable]]": !0,
        "[[Enumerable]]": !0,
        "[[Get]]": !0,
        "[[Set]]": !0,
        "[[Value]]": !0,
        "[[Writable]]": !0
      };

      for (var r in t) {
        if (o(t, r) && !a[r]) return !1;
      }

      var s = o(t, "[[Value]]"),
          i = o(t, "[[Get]]") || o(t, "[[Set]]");
      if (s && i) throw new n("Property Descriptors may not be both accessor and data descriptors");
      return !0;
    }
  };

  e.exports = function (e, t, a, r) {
    var o = i[t];
    if ("function" != typeof o) throw new s("unknown record type: " + t);
    if (!o(e, r)) throw new n(a + " must be a " + t);
    console.log(o(e, r), r);
  };
},
/*!***************************************************!*\
  !*** ./node_modules/es-abstract/helpers/isNaN.js ***!
  \***************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = Number.isNaN || function (e) {
    return e != e;
  };
},
/*!******************************************************!*\
  !*** ./node_modules/es-abstract/helpers/isFinite.js ***!
  \******************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  var a = Number.isNaN || function (e) {
    return e != e;
  };

  e.exports = Number.isFinite || function (e) {
    return "number" == typeof e && !a(e) && e !== 1 / 0 && e !== -1 / 0;
  };
},
/*!****************************************************!*\
  !*** ./node_modules/es-abstract/helpers/assign.js ***!
  \****************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! function-bind */
  132).call(Function.call, Object.prototype.hasOwnProperty),
      n = Object.assign;

  e.exports = function (e, t) {
    if (n) return n(e, t);

    for (var a in t) {
      r(t, a) && (e[a] = t[a]);
    }

    return e;
  };
},
/*!**************************************************!*\
  !*** ./node_modules/es-abstract/helpers/sign.js ***!
  \**************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = function (e) {
    return e >= 0 ? 1 : -1;
  };
},
/*!*************************************************!*\
  !*** ./node_modules/es-abstract/helpers/mod.js ***!
  \*************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = function (e, t) {
    var a = e % t;
    return Math.floor(a >= 0 ? a : a + t);
  };
},
/*!*******************************************************************!*\
  !*** ./node_modules/object.getownpropertydescriptors/polyfill.js ***!
  \*******************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ./implementation */
  235);

  e.exports = function () {
    return "function" == typeof Object.getOwnPropertyDescriptors ? Object.getOwnPropertyDescriptors : r;
  };
},
/*!*************************************************!*\
  !*** ./node_modules/util.promisify/polyfill.js ***!
  \*************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! util */
  23),
      n = a(
  /*! ./implementation */
  234);

  e.exports = function () {
    return "function" == typeof r.promisify ? r.promisify : n;
  };
},
/*!******************************************************!*\
  !*** ./node_modules/node-libs-browser/mock/empty.js ***!
  \******************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {},
/*!***********************************************!*\
  !*** ./node_modules/path-browserify/index.js ***!
  \***********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (e) {
    function a(e, t) {
      for (var a = 0, r = e.length - 1; r >= 0; r--) {
        var n = e[r];
        "." === n ? e.splice(r, 1) : ".." === n ? (e.splice(r, 1), a++) : a && (e.splice(r, 1), a--);
      }

      if (t) for (; a--; a) {
        e.unshift("..");
      }
      return e;
    }

    function r(e, t) {
      if (e.filter) return e.filter(t);

      for (var a = [], r = 0; r < e.length; r++) {
        t(e[r], r, e) && a.push(e[r]);
      }

      return a;
    }

    t.resolve = function () {
      for (var t = "", n = !1, s = arguments.length - 1; s >= -1 && !n; s--) {
        var o = s >= 0 ? arguments[s] : e.cwd();
        if ("string" != typeof o) throw new TypeError("Arguments to path.resolve must be strings");
        o && (t = o + "/" + t, n = "/" === o.charAt(0));
      }

      return (n ? "/" : "") + (t = a(r(t.split("/"), function (e) {
        return !!e;
      }), !n).join("/")) || ".";
    }, t.normalize = function (e) {
      var s = t.isAbsolute(e),
          o = "/" === n(e, -1);
      return (e = a(r(e.split("/"), function (e) {
        return !!e;
      }), !s).join("/")) || s || (e = "."), e && o && (e += "/"), (s ? "/" : "") + e;
    }, t.isAbsolute = function (e) {
      return "/" === e.charAt(0);
    }, t.join = function () {
      var e = Array.prototype.slice.call(arguments, 0);
      return t.normalize(r(e, function (e, t) {
        if ("string" != typeof e) throw new TypeError("Arguments to path.join must be strings");
        return e;
      }).join("/"));
    }, t.relative = function (e, a) {
      function r(e) {
        for (var t = 0; t < e.length && "" === e[t]; t++) {
          ;
        }

        for (var a = e.length - 1; a >= 0 && "" === e[a]; a--) {
          ;
        }

        return t > a ? [] : e.slice(t, a - t + 1);
      }

      e = t.resolve(e).substr(1), a = t.resolve(a).substr(1);

      for (var n = r(e.split("/")), s = r(a.split("/")), o = Math.min(n.length, s.length), i = o, c = 0; c < o; c++) {
        if (n[c] !== s[c]) {
          i = c;
          break;
        }
      }

      var u = [];

      for (c = i; c < n.length; c++) {
        u.push("..");
      }

      return (u = u.concat(s.slice(i))).join("/");
    }, t.sep = "/", t.delimiter = ":", t.dirname = function (e) {
      if ("string" != typeof e && (e += ""), 0 === e.length) return ".";

      for (var t = e.charCodeAt(0), a = 47 === t, r = -1, n = !0, s = e.length - 1; s >= 1; --s) {
        if (47 === (t = e.charCodeAt(s))) {
          if (!n) {
            r = s;
            break;
          }
        } else n = !1;
      }

      return -1 === r ? a ? "/" : "." : a && 1 === r ? "/" : e.slice(0, r);
    }, t.basename = function (e, t) {
      var a = function (e) {
        "string" != typeof e && (e += "");
        var t,
            a = 0,
            r = -1,
            n = !0;

        for (t = e.length - 1; t >= 0; --t) {
          if (47 === e.charCodeAt(t)) {
            if (!n) {
              a = t + 1;
              break;
            }
          } else -1 === r && (n = !1, r = t + 1);
        }

        return -1 === r ? "" : e.slice(a, r);
      }(e);

      return t && a.substr(-1 * t.length) === t && (a = a.substr(0, a.length - t.length)), a;
    }, t.extname = function (e) {
      "string" != typeof e && (e += "");

      for (var t = -1, a = 0, r = -1, n = !0, s = 0, o = e.length - 1; o >= 0; --o) {
        var i = e.charCodeAt(o);
        if (47 !== i) -1 === r && (n = !1, r = o + 1), 46 === i ? -1 === t ? t = o : 1 !== s && (s = 1) : -1 !== t && (s = -1);else if (!n) {
          a = o + 1;
          break;
        }
      }

      return -1 === t || -1 === r || 0 === s || 1 === s && t === r - 1 && t === a + 1 ? "" : e.slice(t, r);
    };
    var n = "b" === "ab".substr(-1) ? function (e, t, a) {
      return e.substr(t, a);
    } : function (e, t, a) {
      return t < 0 && (t = e.length + t), e.substr(t, a);
    };
  }).call(this, a(
  /*! ./../process/browser.js */
  9));
},
/*!*********************************************!*\
  !*** ./node_modules/create-hmac/browser.js ***!
  \*********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! inherits */
  3),
      n = a(
  /*! ./legacy */
  669),
      s = a(
  /*! cipher-base */
  46),
      o = a(
  /*! safe-buffer */
  7).Buffer,
      i = a(
  /*! create-hash/md5 */
  248),
      c = a(
  /*! ripemd160 */
  99),
      u = a(
  /*! sha.js */
  100),
      d = o.alloc(128);

  function f(e, t) {
    s.call(this, "digest"), "string" == typeof t && (t = o.from(t));
    var a = "sha512" === e || "sha384" === e ? 128 : 64;
    (this._alg = e, this._key = t, t.length > a) ? t = ("rmd160" === e ? new c() : u(e)).update(t).digest() : t.length < a && (t = o.concat([t, d], a));

    for (var r = this._ipad = o.allocUnsafe(a), n = this._opad = o.allocUnsafe(a), i = 0; i < a; i++) {
      r[i] = 54 ^ t[i], n[i] = 92 ^ t[i];
    }

    this._hash = "rmd160" === e ? new c() : u(e), this._hash.update(r);
  }

  r(f, s), f.prototype._update = function (e) {
    this._hash.update(e);
  }, f.prototype._final = function () {
    var e = this._hash.digest();

    return ("rmd160" === this._alg ? new c() : u(this._alg)).update(this._opad).update(e).digest();
  }, e.exports = function (e, t) {
    return "rmd160" === (e = e.toLowerCase()) || "ripemd160" === e ? new f("rmd160", t) : "md5" === e ? new n(i, t) : new f(e, t);
  };
},
/*!*****************************************!*\
  !*** ./node_modules/create-hash/md5.js ***!
  \*****************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! md5.js */
  98);

  e.exports = function (e) {
    return new r().update(e).digest();
  };
},
/*!**************************************************************!*\
  !*** ./node_modules/browserify-sign/browser/algorithms.json ***!
  \**************************************************************/

/*! exports provided: sha224WithRSAEncryption, RSA-SHA224, sha256WithRSAEncryption, RSA-SHA256, sha384WithRSAEncryption, RSA-SHA384, sha512WithRSAEncryption, RSA-SHA512, RSA-SHA1, ecdsa-with-SHA1, sha256, sha224, sha384, sha512, DSA-SHA, DSA-SHA1, DSA, DSA-WITH-SHA224, DSA-SHA224, DSA-WITH-SHA256, DSA-SHA256, DSA-WITH-SHA384, DSA-SHA384, DSA-WITH-SHA512, DSA-SHA512, DSA-RIPEMD160, ripemd160WithRSA, RSA-RIPEMD160, md5WithRSAEncryption, RSA-MD5, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}');
},
/*!****************************************!*\
  !*** ./node_modules/pbkdf2/browser.js ***!
  \****************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  t.pbkdf2 = a(
  /*! ./lib/async */
  671), t.pbkdf2Sync = a(
  /*! ./lib/sync */
  253);
},
/*!*************************************************!*\
  !*** ./node_modules/pbkdf2/lib/precondition.js ***!
  \*************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    var a = Math.pow(2, 30) - 1;

    function r(e, a) {
      if ("string" != typeof e && !t.isBuffer(e)) throw new TypeError(a + " must be a buffer or string");
    }

    e.exports = function (e, t, n, s) {
      if (r(e, "Password"), r(t, "Salt"), "number" != typeof n) throw new TypeError("Iterations not a number");
      if (n < 0) throw new TypeError("Bad iterations");
      if ("number" != typeof s) throw new TypeError("Key length not a number");
      if (s < 0 || s > a || s != s) throw new TypeError("Bad key length");
    };
  }).call(this, a(
  /*! ./../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!*****************************************************!*\
  !*** ./node_modules/pbkdf2/lib/default-encoding.js ***!
  \*****************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    var a;
    t.browser ? a = "utf-8" : a = parseInt(t.version.split(".")[0].slice(1), 10) >= 6 ? "utf-8" : "binary";
    e.exports = a;
  }).call(this, a(
  /*! ./../../process/browser.js */
  9));
},
/*!*************************************************!*\
  !*** ./node_modules/pbkdf2/lib/sync-browser.js ***!
  \*************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! create-hash/md5 */
  248),
      n = a(
  /*! ripemd160 */
  99),
      s = a(
  /*! sha.js */
  100),
      o = a(
  /*! ./precondition */
  251),
      i = a(
  /*! ./default-encoding */
  252),
      c = a(
  /*! safe-buffer */
  7).Buffer,
      u = c.alloc(128),
      d = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
  };

  function f(e, t, a) {
    var o = function (e) {
      return "rmd160" === e || "ripemd160" === e ? function (e) {
        return new n().update(e).digest();
      } : "md5" === e ? r : function (t) {
        return s(e).update(t).digest();
      };
    }(e),
        i = "sha512" === e || "sha384" === e ? 128 : 64;

    t.length > i ? t = o(t) : t.length < i && (t = c.concat([t, u], i));

    for (var f = c.allocUnsafe(i + d[e]), l = c.allocUnsafe(i + d[e]), h = 0; h < i; h++) {
      f[h] = 54 ^ t[h], l[h] = 92 ^ t[h];
    }

    var p = c.allocUnsafe(i + a + 4);
    f.copy(p, 0, 0, i), this.ipad1 = p, this.ipad2 = f, this.opad = l, this.alg = e, this.blocksize = i, this.hash = o, this.size = d[e];
  }

  f.prototype.run = function (e, t) {
    return e.copy(t, this.blocksize), this.hash(t).copy(this.opad, this.blocksize), this.hash(this.opad);
  }, e.exports = function (e, t, a, r, n) {
    o(e, t, a, r), c.isBuffer(e) || (e = c.from(e, i)), c.isBuffer(t) || (t = c.from(t, i));
    var s = new f(n = n || "sha1", e, t.length),
        u = c.allocUnsafe(r),
        l = c.allocUnsafe(t.length + 4);
    t.copy(l, 0, 0, t.length);

    for (var h = 0, p = d[n], b = Math.ceil(r / p), m = 1; m <= b; m++) {
      l.writeUInt32BE(m, t.length);

      for (var y = s.run(l, s.ipad1), v = y, _ = 1; _ < a; _++) {
        v = s.run(v, s.ipad2);

        for (var g = 0; g < p; g++) {
          y[g] ^= v[g];
        }
      }

      y.copy(u, h), h += p;
    }

    return u;
  };
},
/*!**************************************************!*\
  !*** ./node_modules/browserify-aes/modes/ctr.js ***!
  \**************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! buffer-xor */
  63),
      n = a(
  /*! safe-buffer */
  7).Buffer,
      s = a(
  /*! ../incr32 */
  255);

  function o(e) {
    var t = e._cipher.encryptBlockRaw(e._prev);

    return s(e._prev), t;
  }

  t.encrypt = function (e, t) {
    var a = Math.ceil(t.length / 16),
        s = e._cache.length;
    e._cache = n.concat([e._cache, n.allocUnsafe(16 * a)]);

    for (var i = 0; i < a; i++) {
      var c = o(e),
          u = s + 16 * i;
      e._cache.writeUInt32BE(c[0], u + 0), e._cache.writeUInt32BE(c[1], u + 4), e._cache.writeUInt32BE(c[2], u + 8), e._cache.writeUInt32BE(c[3], u + 12);
    }

    var d = e._cache.slice(0, t.length);

    return e._cache = e._cache.slice(t.length), r(t, d);
  };
},
/*!***********************************************!*\
  !*** ./node_modules/browserify-aes/incr32.js ***!
  \***********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = function (e) {
    for (var t, a = e.length; a--;) {
      if (255 !== (t = e.readUInt8(a))) {
        t++, e.writeUInt8(t, a);
        break;
      }

      e.writeUInt8(0, a);
    }
  };
},
/*!*****************************************************!*\
  !*** ./node_modules/browserify-aes/modes/list.json ***!
  \*****************************************************/

/*! exports provided: aes-128-ecb, aes-192-ecb, aes-256-ecb, aes-128-cbc, aes-192-cbc, aes-256-cbc, aes128, aes192, aes256, aes-128-cfb, aes-192-cfb, aes-256-cfb, aes-128-cfb8, aes-192-cfb8, aes-256-cfb8, aes-128-cfb1, aes-192-cfb1, aes-256-cfb1, aes-128-ofb, aes-192-ofb, aes-256-ofb, aes-128-ctr, aes-192-ctr, aes-256-ctr, aes-128-gcm, aes-192-gcm, aes-256-gcm, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}');
},
/*!***************************************************!*\
  !*** ./node_modules/browserify-aes/authCipher.js ***!
  \***************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./aes */
  90),
      n = a(
  /*! safe-buffer */
  7).Buffer,
      s = a(
  /*! cipher-base */
  46),
      o = a(
  /*! inherits */
  3),
      i = a(
  /*! ./ghash */
  686),
      c = a(
  /*! buffer-xor */
  63),
      u = a(
  /*! ./incr32 */
  255);

  function d(e, t, a, o) {
    s.call(this);
    var c = n.alloc(4, 0);
    this._cipher = new r.AES(t);

    var d = this._cipher.encryptBlock(c);

    this._ghash = new i(d), a = function (e, t, a) {
      if (12 === t.length) return e._finID = n.concat([t, n.from([0, 0, 0, 1])]), n.concat([t, n.from([0, 0, 0, 2])]);
      var r = new i(a),
          s = t.length,
          o = s % 16;
      r.update(t), o && (o = 16 - o, r.update(n.alloc(o, 0))), r.update(n.alloc(8, 0));
      var c = 8 * s,
          d = n.alloc(8);
      d.writeUIntBE(c, 0, 8), r.update(d), e._finID = r.state;
      var f = n.from(e._finID);
      return u(f), f;
    }(this, a, d), this._prev = n.from(a), this._cache = n.allocUnsafe(0), this._secCache = n.allocUnsafe(0), this._decrypt = o, this._alen = 0, this._len = 0, this._mode = e, this._authTag = null, this._called = !1;
  }

  o(d, s), d.prototype._update = function (e) {
    if (!this._called && this._alen) {
      var t = 16 - this._alen % 16;
      t < 16 && (t = n.alloc(t, 0), this._ghash.update(t));
    }

    this._called = !0;

    var a = this._mode.encrypt(this, e);

    return this._decrypt ? this._ghash.update(e) : this._ghash.update(a), this._len += e.length, a;
  }, d.prototype._final = function () {
    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
    var e = c(this._ghash.final(8 * this._alen, 8 * this._len), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && function (e, t) {
      var a = 0;
      e.length !== t.length && a++;

      for (var r = Math.min(e.length, t.length), n = 0; n < r; ++n) {
        a += e[n] ^ t[n];
      }

      return a;
    }(e, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = e, this._cipher.scrub();
  }, d.prototype.getAuthTag = function () {
    if (this._decrypt || !n.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
  }, d.prototype.setAuthTag = function (e) {
    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = e;
  }, d.prototype.setAAD = function (e) {
    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(e), this._alen += e.length;
  }, e.exports = d;
},
/*!*****************************************************!*\
  !*** ./node_modules/browserify-aes/streamCipher.js ***!
  \*****************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./aes */
  90),
      n = a(
  /*! safe-buffer */
  7).Buffer,
      s = a(
  /*! cipher-base */
  46);

  function o(e, t, a, o) {
    s.call(this), this._cipher = new r.AES(t), this._prev = n.from(a), this._cache = n.allocUnsafe(0), this._secCache = n.allocUnsafe(0), this._decrypt = o, this._mode = e;
  }

  a(
  /*! inherits */
  3)(o, s), o.prototype._update = function (e) {
    return this._mode.encrypt(this, e, this._decrypt);
  }, o.prototype._final = function () {
    this._cipher.scrub();
  }, e.exports = o;
},
/*!**********************************************************!*\
  !*** ./node_modules/diffie-hellman/lib/generatePrime.js ***!
  \**********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! randombytes */
  67);
  e.exports = v, v.simpleSieve = m, v.fermatTest = y;
  var n = a(
  /*! bn.js */
  5),
      s = new n(24),
      o = new (a(
  /*! miller-rabin */
  117))(),
      i = new n(1),
      c = new n(2),
      u = new n(5),
      d = (new n(16), new n(8), new n(10)),
      f = new n(3),
      l = (new n(7), new n(11)),
      h = new n(4),
      p = (new n(12), null);

  function b() {
    if (null !== p) return p;
    var e = [];
    e[0] = 2;

    for (var t = 1, a = 3; a < 1048576; a += 2) {
      for (var r = Math.ceil(Math.sqrt(a)), n = 0; n < t && e[n] <= r && a % e[n] != 0; n++) {
        ;
      }

      t !== n && e[n] <= r || (e[t++] = a);
    }

    return p = e, e;
  }

  function m(e) {
    for (var t = b(), a = 0; a < t.length; a++) {
      if (0 === e.modn(t[a])) return 0 === e.cmpn(t[a]);
    }

    return !0;
  }

  function y(e) {
    var t = n.mont(e);
    return 0 === c.toRed(t).redPow(e.subn(1)).fromRed().cmpn(1);
  }

  function v(e, t) {
    if (e < 16) return new n(2 === t || 5 === t ? [140, 123] : [140, 39]);
    var a, p;

    for (t = new n(t);;) {
      for (a = new n(r(Math.ceil(e / 8))); a.bitLength() > e;) {
        a.ishrn(1);
      }

      if (a.isEven() && a.iadd(i), a.testn(1) || a.iadd(c), t.cmp(c)) {
        if (!t.cmp(u)) for (; a.mod(d).cmp(f);) {
          a.iadd(h);
        }
      } else for (; a.mod(s).cmp(l);) {
        a.iadd(h);
      }

      if (m(p = a.shrn(1)) && m(a) && y(p) && y(a) && o.test(p) && o.test(a)) return a;
    }
  }
},
/*!******************************************************!*\
  !*** ./node_modules/asn1.js/lib/asn1/base/buffer.js ***!
  \******************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! inherits */
  3),
      n = a(
  /*! ../base */
  76).Reporter,
      s = a(
  /*! buffer */
  1).Buffer;

  function o(e, t) {
    n.call(this, t), s.isBuffer(e) ? (this.base = e, this.offset = 0, this.length = e.length) : this.error("Input not Buffer");
  }

  function i(e, t) {
    if (Array.isArray(e)) this.length = 0, this.value = e.map(function (e) {
      return e instanceof i || (e = new i(e, t)), this.length += e.length, e;
    }, this);else if ("number" == typeof e) {
      if (!(0 <= e && e <= 255)) return t.error("non-byte EncoderBuffer value");
      this.value = e, this.length = 1;
    } else if ("string" == typeof e) this.value = e, this.length = s.byteLength(e);else {
      if (!s.isBuffer(e)) return t.error("Unsupported type: " + typeof e);
      this.value = e, this.length = e.length;
    }
  }

  r(o, n), t.DecoderBuffer = o, o.prototype.save = function () {
    return {
      offset: this.offset,
      reporter: n.prototype.save.call(this)
    };
  }, o.prototype.restore = function (e) {
    var t = new o(this.base);
    return t.offset = e.offset, t.length = this.offset, this.offset = e.offset, n.prototype.restore.call(this, e.reporter), t;
  }, o.prototype.isEmpty = function () {
    return this.offset === this.length;
  }, o.prototype.readUInt8 = function (e) {
    return this.offset + 1 <= this.length ? this.base.readUInt8(this.offset++, !0) : this.error(e || "DecoderBuffer overrun");
  }, o.prototype.skip = function (e, t) {
    if (!(this.offset + e <= this.length)) return this.error(t || "DecoderBuffer overrun");
    var a = new o(this.base);
    return a._reporterState = this._reporterState, a.offset = this.offset, a.length = this.offset + e, this.offset += e, a;
  }, o.prototype.raw = function (e) {
    return this.base.slice(e ? e.offset : this.offset, this.length);
  }, t.EncoderBuffer = i, i.prototype.join = function (e, t) {
    return e || (e = new s(this.length)), t || (t = 0), 0 === this.length ? e : (Array.isArray(this.value) ? this.value.forEach(function (a) {
      a.join(e, t), t += a.length;
    }) : ("number" == typeof this.value ? e[t] = this.value : "string" == typeof this.value ? e.write(this.value, t) : s.isBuffer(this.value) && this.value.copy(e, t), t += this.length), e);
  };
},
/*!**********************************************************!*\
  !*** ./node_modules/asn1.js/lib/asn1/constants/index.js ***!
  \**********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = t;
  r._reverse = function (e) {
    var t = {};
    return Object.keys(e).forEach(function (a) {
      (0 | a) == a && (a |= 0);
      var r = e[a];
      t[r] = a;
    }), t;
  }, r.der = a(
  /*! ./der */
  699);
},
/*!*******************************************************!*\
  !*** ./node_modules/asn1.js/lib/asn1/decoders/der.js ***!
  \*******************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! inherits */
  3),
      n = a(
  /*! ../../asn1 */
  75),
      s = n.base,
      o = n.bignum,
      i = n.constants.der;

  function c(e) {
    this.enc = "der", this.name = e.name, this.entity = e, this.tree = new u(), this.tree._init(e.body);
  }

  function u(e) {
    s.Node.call(this, "der", e);
  }

  function d(e, t) {
    var a = e.readUInt8(t);
    if (e.isError(a)) return a;
    var r = i.tagClass[a >> 6],
        n = 0 == (32 & a);

    if (31 == (31 & a)) {
      var s = a;

      for (a = 0; 128 == (128 & s);) {
        if (s = e.readUInt8(t), e.isError(s)) return s;
        a <<= 7, a |= 127 & s;
      }
    } else a &= 31;

    return {
      cls: r,
      primitive: n,
      tag: a,
      tagStr: i.tag[a]
    };
  }

  function f(e, t, a) {
    var r = e.readUInt8(a);
    if (e.isError(r)) return r;
    if (!t && 128 === r) return null;
    if (0 == (128 & r)) return r;
    var n = 127 & r;
    if (n > 4) return e.error("length octect is too long");
    r = 0;

    for (var s = 0; s < n; s++) {
      r <<= 8;
      var o = e.readUInt8(a);
      if (e.isError(o)) return o;
      r |= o;
    }

    return r;
  }

  e.exports = c, c.prototype.decode = function (e, t) {
    return e instanceof s.DecoderBuffer || (e = new s.DecoderBuffer(e, t)), this.tree._decode(e, t);
  }, r(u, s.Node), u.prototype._peekTag = function (e, t, a) {
    if (e.isEmpty()) return !1;
    var r = e.save(),
        n = d(e, 'Failed to peek tag: "' + t + '"');
    return e.isError(n) ? n : (e.restore(r), n.tag === t || n.tagStr === t || n.tagStr + "of" === t || a);
  }, u.prototype._decodeTag = function (e, t, a) {
    var r = d(e, 'Failed to decode tag of "' + t + '"');
    if (e.isError(r)) return r;
    var n = f(e, r.primitive, 'Failed to get length of "' + t + '"');
    if (e.isError(n)) return n;
    if (!a && r.tag !== t && r.tagStr !== t && r.tagStr + "of" !== t) return e.error('Failed to match tag: "' + t + '"');
    if (r.primitive || null !== n) return e.skip(n, 'Failed to match body of: "' + t + '"');

    var s = e.save(),
        o = this._skipUntilEnd(e, 'Failed to skip indefinite length body: "' + this.tag + '"');

    return e.isError(o) ? o : (n = e.offset - s.offset, e.restore(s), e.skip(n, 'Failed to match body of: "' + t + '"'));
  }, u.prototype._skipUntilEnd = function (e, t) {
    for (;;) {
      var a = d(e, t);
      if (e.isError(a)) return a;
      var r,
          n = f(e, a.primitive, t);
      if (e.isError(n)) return n;
      if (r = a.primitive || null !== n ? e.skip(n) : this._skipUntilEnd(e, t), e.isError(r)) return r;
      if ("end" === a.tagStr) break;
    }
  }, u.prototype._decodeList = function (e, t, a, r) {
    for (var n = []; !e.isEmpty();) {
      var s = this._peekTag(e, "end");

      if (e.isError(s)) return s;
      var o = a.decode(e, "der", r);
      if (e.isError(o) && s) break;
      n.push(o);
    }

    return n;
  }, u.prototype._decodeStr = function (e, t) {
    if ("bitstr" === t) {
      var a = e.readUInt8();
      return e.isError(a) ? a : {
        unused: a,
        data: e.raw()
      };
    }

    if ("bmpstr" === t) {
      var r = e.raw();
      if (r.length % 2 == 1) return e.error("Decoding of string type: bmpstr length mismatch");

      for (var n = "", s = 0; s < r.length / 2; s++) {
        n += String.fromCharCode(r.readUInt16BE(2 * s));
      }

      return n;
    }

    if ("numstr" === t) {
      var o = e.raw().toString("ascii");
      return this._isNumstr(o) ? o : e.error("Decoding of string type: numstr unsupported characters");
    }

    if ("octstr" === t) return e.raw();
    if ("objDesc" === t) return e.raw();

    if ("printstr" === t) {
      var i = e.raw().toString("ascii");
      return this._isPrintstr(i) ? i : e.error("Decoding of string type: printstr unsupported characters");
    }

    return /str$/.test(t) ? e.raw().toString() : e.error("Decoding of string type: " + t + " unsupported");
  }, u.prototype._decodeObjid = function (e, t, a) {
    for (var r, n = [], s = 0; !e.isEmpty();) {
      var o = e.readUInt8();
      s <<= 7, s |= 127 & o, 0 == (128 & o) && (n.push(s), s = 0);
    }

    128 & o && n.push(s);
    var i = n[0] / 40 | 0,
        c = n[0] % 40;

    if (r = a ? n : [i, c].concat(n.slice(1)), t) {
      var u = t[r.join(" ")];
      void 0 === u && (u = t[r.join(".")]), void 0 !== u && (r = u);
    }

    return r;
  }, u.prototype._decodeTime = function (e, t) {
    var a = e.raw().toString();
    if ("gentime" === t) var r = 0 | a.slice(0, 4),
        n = 0 | a.slice(4, 6),
        s = 0 | a.slice(6, 8),
        o = 0 | a.slice(8, 10),
        i = 0 | a.slice(10, 12),
        c = 0 | a.slice(12, 14);else {
      if ("utctime" !== t) return e.error("Decoding " + t + " time is not supported yet");
      r = 0 | a.slice(0, 2), n = 0 | a.slice(2, 4), s = 0 | a.slice(4, 6), o = 0 | a.slice(6, 8), i = 0 | a.slice(8, 10), c = 0 | a.slice(10, 12);
      r = r < 70 ? 2e3 + r : 1900 + r;
    }
    return Date.UTC(r, n - 1, s, o, i, c, 0);
  }, u.prototype._decodeNull = function (e) {
    return null;
  }, u.prototype._decodeBool = function (e) {
    var t = e.readUInt8();
    return e.isError(t) ? t : 0 !== t;
  }, u.prototype._decodeInt = function (e, t) {
    var a = e.raw(),
        r = new o(a);
    return t && (r = t[r.toString(10)] || r), r;
  }, u.prototype._use = function (e, t) {
    return "function" == typeof e && (e = e(t)), e._getDecoder("der").tree;
  };
},
/*!*******************************************************!*\
  !*** ./node_modules/asn1.js/lib/asn1/encoders/der.js ***!
  \*******************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! inherits */
  3),
      n = a(
  /*! buffer */
  1).Buffer,
      s = a(
  /*! ../../asn1 */
  75),
      o = s.base,
      i = s.constants.der;

  function c(e) {
    this.enc = "der", this.name = e.name, this.entity = e, this.tree = new u(), this.tree._init(e.body);
  }

  function u(e) {
    o.Node.call(this, "der", e);
  }

  function d(e) {
    return e < 10 ? "0" + e : e;
  }

  e.exports = c, c.prototype.encode = function (e, t) {
    return this.tree._encode(e, t).join();
  }, r(u, o.Node), u.prototype._encodeComposite = function (e, t, a, r) {
    var s,
        o = function (e, t, a, r) {
      var n;
      "seqof" === e ? e = "seq" : "setof" === e && (e = "set");
      if (i.tagByName.hasOwnProperty(e)) n = i.tagByName[e];else {
        if ("number" != typeof e || (0 | e) !== e) return r.error("Unknown tag: " + e);
        n = e;
      }
      if (n >= 31) return r.error("Multi-octet tag encoding unsupported");
      t || (n |= 32);
      return n |= i.tagClassByName[a || "universal"] << 6;
    }(e, t, a, this.reporter);

    if (r.length < 128) return (s = new n(2))[0] = o, s[1] = r.length, this._createEncoderBuffer([s, r]);

    for (var c = 1, u = r.length; u >= 256; u >>= 8) {
      c++;
    }

    (s = new n(2 + c))[0] = o, s[1] = 128 | c;
    u = 1 + c;

    for (var d = r.length; d > 0; u--, d >>= 8) {
      s[u] = 255 & d;
    }

    return this._createEncoderBuffer([s, r]);
  }, u.prototype._encodeStr = function (e, t) {
    if ("bitstr" === t) return this._createEncoderBuffer([0 | e.unused, e.data]);

    if ("bmpstr" === t) {
      for (var a = new n(2 * e.length), r = 0; r < e.length; r++) {
        a.writeUInt16BE(e.charCodeAt(r), 2 * r);
      }

      return this._createEncoderBuffer(a);
    }

    return "numstr" === t ? this._isNumstr(e) ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: numstr supports only digits and space") : "printstr" === t ? this._isPrintstr(e) ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark") : /str$/.test(t) ? this._createEncoderBuffer(e) : "objDesc" === t ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: " + t + " unsupported");
  }, u.prototype._encodeObjid = function (e, t, a) {
    if ("string" == typeof e) {
      if (!t) return this.reporter.error("string objid given, but no values map found");
      if (!t.hasOwnProperty(e)) return this.reporter.error("objid not found in values map");
      e = t[e].split(/[\s\.]+/g);

      for (var r = 0; r < e.length; r++) {
        e[r] |= 0;
      }
    } else if (Array.isArray(e)) {
      e = e.slice();

      for (r = 0; r < e.length; r++) {
        e[r] |= 0;
      }
    }

    if (!Array.isArray(e)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(e));

    if (!a) {
      if (e[1] >= 40) return this.reporter.error("Second objid identifier OOB");
      e.splice(0, 2, 40 * e[0] + e[1]);
    }

    var s = 0;

    for (r = 0; r < e.length; r++) {
      var o = e[r];

      for (s++; o >= 128; o >>= 7) {
        s++;
      }
    }

    var i = new n(s),
        c = i.length - 1;

    for (r = e.length - 1; r >= 0; r--) {
      o = e[r];

      for (i[c--] = 127 & o; (o >>= 7) > 0;) {
        i[c--] = 128 | 127 & o;
      }
    }

    return this._createEncoderBuffer(i);
  }, u.prototype._encodeTime = function (e, t) {
    var a,
        r = new Date(e);
    return "gentime" === t ? a = [d(r.getFullYear()), d(r.getUTCMonth() + 1), d(r.getUTCDate()), d(r.getUTCHours()), d(r.getUTCMinutes()), d(r.getUTCSeconds()), "Z"].join("") : "utctime" === t ? a = [d(r.getFullYear() % 100), d(r.getUTCMonth() + 1), d(r.getUTCDate()), d(r.getUTCHours()), d(r.getUTCMinutes()), d(r.getUTCSeconds()), "Z"].join("") : this.reporter.error("Encoding " + t + " time is not supported yet"), this._encodeStr(a, "octstr");
  }, u.prototype._encodeNull = function () {
    return this._createEncoderBuffer("");
  }, u.prototype._encodeInt = function (e, t) {
    if ("string" == typeof e) {
      if (!t) return this.reporter.error("String int or enum given, but no values map");
      if (!t.hasOwnProperty(e)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(e));
      e = t[e];
    }

    if ("number" != typeof e && !n.isBuffer(e)) {
      var a = e.toArray();
      !e.sign && 128 & a[0] && a.unshift(0), e = new n(a);
    }

    if (n.isBuffer(e)) {
      var r = e.length;
      0 === e.length && r++;
      var s = new n(r);
      return e.copy(s), 0 === e.length && (s[0] = 0), this._createEncoderBuffer(s);
    }

    if (e < 128) return this._createEncoderBuffer(e);
    if (e < 256) return this._createEncoderBuffer([0, e]);
    r = 1;

    for (var o = e; o >= 256; o >>= 8) {
      r++;
    }

    for (o = (s = new Array(r)).length - 1; o >= 0; o--) {
      s[o] = 255 & e, e >>= 8;
    }

    return 128 & s[0] && s.unshift(0), this._createEncoderBuffer(new n(s));
  }, u.prototype._encodeBool = function (e) {
    return this._createEncoderBuffer(e ? 255 : 0);
  }, u.prototype._use = function (e, t) {
    return "function" == typeof e && (e = e(t)), e._getEncoder("der").tree;
  }, u.prototype._skipDefault = function (e, t, a) {
    var r,
        n = this._baseState;
    if (null === n.default) return !1;
    var s = e.join();
    if (void 0 === n.defaultBuffer && (n.defaultBuffer = this._encodeValue(n.default, t, a).join()), s.length !== n.defaultBuffer.length) return !1;

    for (r = 0; r < s.length; r++) {
      if (s[r] !== n.defaultBuffer[r]) return !1;
    }

    return !0;
  };
},
/*!**********************************************************!*\
  !*** ./node_modules/browserify-sign/browser/curves.json ***!
  \**********************************************************/

/*! exports provided: 1.3.132.0.10, 1.3.132.0.33, 1.2.840.10045.3.1.1, 1.2.840.10045.3.1.7, 1.3.132.0.34, 1.3.132.0.35, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}');
},
/*!********************************************!*\
  !*** ./node_modules/public-encrypt/mgf.js ***!
  \********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! create-hash */
  20),
      n = a(
  /*! safe-buffer */
  7).Buffer;

  function s(e) {
    var t = n.allocUnsafe(4);
    return t.writeUInt32BE(e, 0), t;
  }

  e.exports = function (e, t) {
    for (var a, o = n.alloc(0), i = 0; o.length < t;) {
      a = s(i++), o = n.concat([o, r("sha1").update(e).update(a).digest()]);
    }

    return o.slice(0, t);
  };
},
/*!********************************************!*\
  !*** ./node_modules/public-encrypt/xor.js ***!
  \********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = function (e, t) {
    for (var a = e.length, r = -1; ++r < a;) {
      e[r] ^= t[r];
    }

    return e;
  };
},
/*!***************************************************!*\
  !*** ./node_modules/public-encrypt/withPublic.js ***!
  \***************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! bn.js */
  5),
      n = a(
  /*! safe-buffer */
  7).Buffer;

  e.exports = function (e, t) {
    return n.from(e.toRed(r.mont(t.modulus)).redPow(new r(t.publicExponent)).fromRed().toArray());
  };
},
/*!***************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-vm/dist/bloom/index.js ***!
  \***************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = a(
    /*! assert */
    19),
        n = a(
    /*! ethereumjs-util */
    29),
        s = 256,
        o = function () {
      function t(e) {
        e ? (r(e.length === s, "bitvectors must be 2048 bits long"), this.bitvector = e) : this.bitvector = n.zeros(s);
      }

      return t.prototype.add = function (t) {
        r(e.isBuffer(t), "Element should be buffer"), t = n.keccak256(t);

        for (var a = 0; a < 3; a++) {
          var o = 2047 & t.readUInt16BE(2 * a),
              i = o >> 3,
              c = 1 << o % 8;
          this.bitvector[s - i - 1] |= c;
        }
      }, t.prototype.check = function (t) {
        r(e.isBuffer(t), "Element should be Buffer"), t = n.keccak256(t);

        for (var a = !0, o = 0; o < 3 && a; o++) {
          var i = 2047 & t.readUInt16BE(2 * o),
              c = i >> 3,
              u = 1 << i % 8;
          a = 0 != (this.bitvector[s - c - 1] & u);
        }

        return Boolean(a);
      }, t.prototype.multiCheck = function (e) {
        var t = this;
        return e.every(function (e) {
          return t.check(e);
        });
      }, t.prototype.or = function (e) {
        if (e) for (var t = 0; t <= s; t++) {
          this.bitvector[t] = this.bitvector[t] | e.bitvector[t];
        }
      }, t;
    }();

    t.default = o;
  }).call(this, a(
  /*! ./../../../../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!********************************************!*\
  !*** ./node_modules/lodash/isArrayLike.js ***!
  \********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./isFunction */
  734),
      n = a(
  /*! ./isLength */
  274);

  e.exports = function (e) {
    return null != e && n(e.length) && !r(e);
  };
},
/*!****************************************!*\
  !*** ./node_modules/lodash/_Symbol.js ***!
  \****************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./_root */
  271).Symbol;
  e.exports = r;
},
/*!**************************************!*\
  !*** ./node_modules/lodash/_root.js ***!
  \**************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./_freeGlobal */
  272),
      n = "object" == typeof self && self && self.Object === Object && self,
      s = r || n || Function("return this")();
  e.exports = s;
},
/*!********************************************!*\
  !*** ./node_modules/lodash/_freeGlobal.js ***!
  \********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    var a = "object" == typeof t && t && t.Object === Object && t;
    e.exports = a;
  }).call(this, a(
  /*! ./../webpack/buildin/global.js */
  18));
},
/*!*****************************************!*\
  !*** ./node_modules/lodash/isObject.js ***!
  \*****************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = function (e) {
    var t = typeof e;
    return null != e && ("object" == t || "function" == t);
  };
},
/*!*****************************************!*\
  !*** ./node_modules/lodash/isLength.js ***!
  \*****************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  var a = 9007199254740991;

  e.exports = function (e) {
    return "number" == typeof e && e > -1 && e % 1 == 0 && e <= a;
  };
},
/*!**********************************************!*\
  !*** ./node_modules/async/internal/slice.js ***!
  \**********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e, t) {
    t |= 0;

    for (var a = Math.max(e.length - t, 0), r = Array(a), n = 0; n < a; n++) {
      r[n] = e[t + n];
    }

    return r;
  }, e.exports = t.default;
},
/*!*******************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-blockstream/output/source/utilities.js ***!
  \*******************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.parseHexInt = function (e) {
    var t = Number.parseInt(e, 16);
    if (!Number.isFinite(t)) throw new Error(e + " is not a hex encoded integer, parsing returned " + t + ".");
    return t;
  };
},
/*!**************************************************!*\
  !*** ./node_modules/immutable/dist/immutable.js ***!
  \**************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  e.exports = function () {
    "use strict";

    var e = Array.prototype.slice;

    function t(e, t) {
      t && (e.prototype = Object.create(t.prototype)), e.prototype.constructor = e;
    }

    function a(e) {
      return o(e) ? e : K(e);
    }

    function r(e) {
      return i(e) ? e : q(e);
    }

    function n(e) {
      return c(e) ? e : Y(e);
    }

    function s(e) {
      return o(e) && !u(e) ? e : Z(e);
    }

    function o(e) {
      return !(!e || !e[f]);
    }

    function i(e) {
      return !(!e || !e[l]);
    }

    function c(e) {
      return !(!e || !e[h]);
    }

    function u(e) {
      return i(e) || c(e);
    }

    function d(e) {
      return !(!e || !e[p]);
    }

    t(r, a), t(n, a), t(s, a), a.isIterable = o, a.isKeyed = i, a.isIndexed = c, a.isAssociative = u, a.isOrdered = d, a.Keyed = r, a.Indexed = n, a.Set = s;
    var f = "@@__IMMUTABLE_ITERABLE__@@",
        l = "@@__IMMUTABLE_KEYED__@@",
        h = "@@__IMMUTABLE_INDEXED__@@",
        p = "@@__IMMUTABLE_ORDERED__@@",
        b = 5,
        m = 1 << b,
        y = m - 1,
        v = {},
        _ = {
      value: !1
    },
        g = {
      value: !1
    };

    function A(e) {
      return e.value = !1, e;
    }

    function w(e) {
      e && (e.value = !0);
    }

    function T() {}

    function x(e, t) {
      t = t || 0;

      for (var a = Math.max(0, e.length - t), r = new Array(a), n = 0; n < a; n++) {
        r[n] = e[n + t];
      }

      return r;
    }

    function D(e) {
      return void 0 === e.size && (e.size = e.__iterate(S)), e.size;
    }

    function C(e, t) {
      if ("number" != typeof t) {
        var a = t >>> 0;
        if ("" + a !== t || 4294967295 === a) return NaN;
        t = a;
      }

      return t < 0 ? D(e) + t : t;
    }

    function S() {
      return !0;
    }

    function E(e, t, a) {
      return (0 === e || void 0 !== a && e <= -a) && (void 0 === t || void 0 !== a && t >= a);
    }

    function B(e, t) {
      return R(e, t, 0);
    }

    function k(e, t) {
      return R(e, t, t);
    }

    function R(e, t, a) {
      return void 0 === e ? a : e < 0 ? Math.max(0, t + e) : void 0 === t ? e : Math.min(t, e);
    }

    var W = 0,
        I = 1,
        N = 2,
        M = "function" == typeof Symbol && Symbol.iterator,
        P = "@@iterator",
        L = M || P;

    function O(e) {
      this.next = e;
    }

    function F(e, t, a, r) {
      var n = 0 === e ? t : 1 === e ? a : [t, a];
      return r ? r.value = n : r = {
        value: n,
        done: !1
      }, r;
    }

    function j() {
      return {
        value: void 0,
        done: !0
      };
    }

    function G(e) {
      return !!H(e);
    }

    function V(e) {
      return e && "function" == typeof e.next;
    }

    function U(e) {
      var t = H(e);
      return t && t.call(e);
    }

    function H(e) {
      var t = e && (M && e[M] || e[P]);
      if ("function" == typeof t) return t;
    }

    function z(e) {
      return e && "number" == typeof e.length;
    }

    function K(e) {
      return null == e ? se() : o(e) ? e.toSeq() : function (e) {
        var t = ce(e) || "object" == typeof e && new te(e);
        if (!t) throw new TypeError("Expected Array or iterable object of values, or keyed object: " + e);
        return t;
      }(e);
    }

    function q(e) {
      return null == e ? se().toKeyedSeq() : o(e) ? i(e) ? e.toSeq() : e.fromEntrySeq() : oe(e);
    }

    function Y(e) {
      return null == e ? se() : o(e) ? i(e) ? e.entrySeq() : e.toIndexedSeq() : ie(e);
    }

    function Z(e) {
      return (null == e ? se() : o(e) ? i(e) ? e.entrySeq() : e : ie(e)).toSetSeq();
    }

    O.prototype.toString = function () {
      return "[Iterator]";
    }, O.KEYS = W, O.VALUES = I, O.ENTRIES = N, O.prototype.inspect = O.prototype.toSource = function () {
      return this.toString();
    }, O.prototype[L] = function () {
      return this;
    }, t(K, a), K.of = function () {
      return K(arguments);
    }, K.prototype.toSeq = function () {
      return this;
    }, K.prototype.toString = function () {
      return this.__toString("Seq {", "}");
    }, K.prototype.cacheResult = function () {
      return !this._cache && this.__iterateUncached && (this._cache = this.entrySeq().toArray(), this.size = this._cache.length), this;
    }, K.prototype.__iterate = function (e, t) {
      return ue(this, e, t, !0);
    }, K.prototype.__iterator = function (e, t) {
      return de(this, e, t, !0);
    }, t(q, K), q.prototype.toKeyedSeq = function () {
      return this;
    }, t(Y, K), Y.of = function () {
      return Y(arguments);
    }, Y.prototype.toIndexedSeq = function () {
      return this;
    }, Y.prototype.toString = function () {
      return this.__toString("Seq [", "]");
    }, Y.prototype.__iterate = function (e, t) {
      return ue(this, e, t, !1);
    }, Y.prototype.__iterator = function (e, t) {
      return de(this, e, t, !1);
    }, t(Z, K), Z.of = function () {
      return Z(arguments);
    }, Z.prototype.toSetSeq = function () {
      return this;
    }, K.isSeq = ne, K.Keyed = q, K.Set = Z, K.Indexed = Y;
    var J,
        X,
        $,
        Q = "@@__IMMUTABLE_SEQ__@@";

    function ee(e) {
      this._array = e, this.size = e.length;
    }

    function te(e) {
      var t = Object.keys(e);
      this._object = e, this._keys = t, this.size = t.length;
    }

    function ae(e) {
      this._iterable = e, this.size = e.length || e.size;
    }

    function re(e) {
      this._iterator = e, this._iteratorCache = [];
    }

    function ne(e) {
      return !(!e || !e[Q]);
    }

    function se() {
      return J || (J = new ee([]));
    }

    function oe(e) {
      var t = Array.isArray(e) ? new ee(e).fromEntrySeq() : V(e) ? new re(e).fromEntrySeq() : G(e) ? new ae(e).fromEntrySeq() : "object" == typeof e ? new te(e) : void 0;
      if (!t) throw new TypeError("Expected Array or iterable object of [k, v] entries, or keyed object: " + e);
      return t;
    }

    function ie(e) {
      var t = ce(e);
      if (!t) throw new TypeError("Expected Array or iterable object of values: " + e);
      return t;
    }

    function ce(e) {
      return z(e) ? new ee(e) : V(e) ? new re(e) : G(e) ? new ae(e) : void 0;
    }

    function ue(e, t, a, r) {
      var n = e._cache;

      if (n) {
        for (var s = n.length - 1, o = 0; o <= s; o++) {
          var i = n[a ? s - o : o];
          if (!1 === t(i[1], r ? i[0] : o, e)) return o + 1;
        }

        return o;
      }

      return e.__iterateUncached(t, a);
    }

    function de(e, t, a, r) {
      var n = e._cache;

      if (n) {
        var s = n.length - 1,
            o = 0;
        return new O(function () {
          var e = n[a ? s - o : o];
          return o++ > s ? {
            value: void 0,
            done: !0
          } : F(t, r ? e[0] : o - 1, e[1]);
        });
      }

      return e.__iteratorUncached(t, a);
    }

    function fe(e, t) {
      return t ? function e(t, a, r, n) {
        return Array.isArray(a) ? t.call(n, r, Y(a).map(function (r, n) {
          return e(t, r, n, a);
        })) : he(a) ? t.call(n, r, q(a).map(function (r, n) {
          return e(t, r, n, a);
        })) : a;
      }(t, e, "", {
        "": e
      }) : le(e);
    }

    function le(e) {
      return Array.isArray(e) ? Y(e).map(le).toList() : he(e) ? q(e).map(le).toMap() : e;
    }

    function he(e) {
      return e && (e.constructor === Object || void 0 === e.constructor);
    }

    function pe(e, t) {
      if (e === t || e != e && t != t) return !0;
      if (!e || !t) return !1;

      if ("function" == typeof e.valueOf && "function" == typeof t.valueOf) {
        if ((e = e.valueOf()) === (t = t.valueOf()) || e != e && t != t) return !0;
        if (!e || !t) return !1;
      }

      return !("function" != typeof e.equals || "function" != typeof t.equals || !e.equals(t));
    }

    function be(e, t) {
      if (e === t) return !0;
      if (!o(t) || void 0 !== e.size && void 0 !== t.size && e.size !== t.size || void 0 !== e.__hash && void 0 !== t.__hash && e.__hash !== t.__hash || i(e) !== i(t) || c(e) !== c(t) || d(e) !== d(t)) return !1;
      if (0 === e.size && 0 === t.size) return !0;
      var a = !u(e);

      if (d(e)) {
        var r = e.entries();
        return t.every(function (e, t) {
          var n = r.next().value;
          return n && pe(n[1], e) && (a || pe(n[0], t));
        }) && r.next().done;
      }

      var n = !1;
      if (void 0 === e.size) if (void 0 === t.size) "function" == typeof e.cacheResult && e.cacheResult();else {
        n = !0;
        var s = e;
        e = t, t = s;
      }

      var f = !0,
          l = t.__iterate(function (t, r) {
        if (a ? !e.has(t) : n ? !pe(t, e.get(r, v)) : !pe(e.get(r, v), t)) return f = !1, !1;
      });

      return f && e.size === l;
    }

    function me(e, t) {
      if (!(this instanceof me)) return new me(e, t);

      if (this._value = e, this.size = void 0 === t ? 1 / 0 : Math.max(0, t), 0 === this.size) {
        if (X) return X;
        X = this;
      }
    }

    function ye(e, t) {
      if (!e) throw new Error(t);
    }

    function ve(e, t, a) {
      if (!(this instanceof ve)) return new ve(e, t, a);

      if (ye(0 !== a, "Cannot step a Range by 0"), e = e || 0, void 0 === t && (t = 1 / 0), a = void 0 === a ? 1 : Math.abs(a), t < e && (a = -a), this._start = e, this._end = t, this._step = a, this.size = Math.max(0, Math.ceil((t - e) / a - 1) + 1), 0 === this.size) {
        if ($) return $;
        $ = this;
      }
    }

    function _e() {
      throw TypeError("Abstract");
    }

    function ge() {}

    function Ae() {}

    function we() {}

    K.prototype[Q] = !0, t(ee, Y), ee.prototype.get = function (e, t) {
      return this.has(e) ? this._array[C(this, e)] : t;
    }, ee.prototype.__iterate = function (e, t) {
      for (var a = this._array, r = a.length - 1, n = 0; n <= r; n++) {
        if (!1 === e(a[t ? r - n : n], n, this)) return n + 1;
      }

      return n;
    }, ee.prototype.__iterator = function (e, t) {
      var a = this._array,
          r = a.length - 1,
          n = 0;
      return new O(function () {
        return n > r ? {
          value: void 0,
          done: !0
        } : F(e, n, a[t ? r - n++ : n++]);
      });
    }, t(te, q), te.prototype.get = function (e, t) {
      return void 0 === t || this.has(e) ? this._object[e] : t;
    }, te.prototype.has = function (e) {
      return this._object.hasOwnProperty(e);
    }, te.prototype.__iterate = function (e, t) {
      for (var a = this._object, r = this._keys, n = r.length - 1, s = 0; s <= n; s++) {
        var o = r[t ? n - s : s];
        if (!1 === e(a[o], o, this)) return s + 1;
      }

      return s;
    }, te.prototype.__iterator = function (e, t) {
      var a = this._object,
          r = this._keys,
          n = r.length - 1,
          s = 0;
      return new O(function () {
        var o = r[t ? n - s : s];
        return s++ > n ? {
          value: void 0,
          done: !0
        } : F(e, o, a[o]);
      });
    }, te.prototype[p] = !0, t(ae, Y), ae.prototype.__iterateUncached = function (e, t) {
      if (t) return this.cacheResult().__iterate(e, t);
      var a = U(this._iterable),
          r = 0;
      if (V(a)) for (var n; !(n = a.next()).done && !1 !== e(n.value, r++, this);) {
        ;
      }
      return r;
    }, ae.prototype.__iteratorUncached = function (e, t) {
      if (t) return this.cacheResult().__iterator(e, t);
      var a = U(this._iterable);
      if (!V(a)) return new O(j);
      var r = 0;
      return new O(function () {
        var t = a.next();
        return t.done ? t : F(e, r++, t.value);
      });
    }, t(re, Y), re.prototype.__iterateUncached = function (e, t) {
      if (t) return this.cacheResult().__iterate(e, t);

      for (var a, r = this._iterator, n = this._iteratorCache, s = 0; s < n.length;) {
        if (!1 === e(n[s], s++, this)) return s;
      }

      for (; !(a = r.next()).done;) {
        var o = a.value;
        if (n[s] = o, !1 === e(o, s++, this)) break;
      }

      return s;
    }, re.prototype.__iteratorUncached = function (e, t) {
      if (t) return this.cacheResult().__iterator(e, t);
      var a = this._iterator,
          r = this._iteratorCache,
          n = 0;
      return new O(function () {
        if (n >= r.length) {
          var t = a.next();
          if (t.done) return t;
          r[n] = t.value;
        }

        return F(e, n, r[n++]);
      });
    }, t(me, Y), me.prototype.toString = function () {
      return 0 === this.size ? "Repeat []" : "Repeat [ " + this._value + " " + this.size + " times ]";
    }, me.prototype.get = function (e, t) {
      return this.has(e) ? this._value : t;
    }, me.prototype.includes = function (e) {
      return pe(this._value, e);
    }, me.prototype.slice = function (e, t) {
      var a = this.size;
      return E(e, t, a) ? this : new me(this._value, k(t, a) - B(e, a));
    }, me.prototype.reverse = function () {
      return this;
    }, me.prototype.indexOf = function (e) {
      return pe(this._value, e) ? 0 : -1;
    }, me.prototype.lastIndexOf = function (e) {
      return pe(this._value, e) ? this.size : -1;
    }, me.prototype.__iterate = function (e, t) {
      for (var a = 0; a < this.size; a++) {
        if (!1 === e(this._value, a, this)) return a + 1;
      }

      return a;
    }, me.prototype.__iterator = function (e, t) {
      var a = this,
          r = 0;
      return new O(function () {
        return r < a.size ? F(e, r++, a._value) : {
          value: void 0,
          done: !0
        };
      });
    }, me.prototype.equals = function (e) {
      return e instanceof me ? pe(this._value, e._value) : be(e);
    }, t(ve, Y), ve.prototype.toString = function () {
      return 0 === this.size ? "Range []" : "Range [ " + this._start + "..." + this._end + (1 !== this._step ? " by " + this._step : "") + " ]";
    }, ve.prototype.get = function (e, t) {
      return this.has(e) ? this._start + C(this, e) * this._step : t;
    }, ve.prototype.includes = function (e) {
      var t = (e - this._start) / this._step;
      return t >= 0 && t < this.size && t === Math.floor(t);
    }, ve.prototype.slice = function (e, t) {
      return E(e, t, this.size) ? this : (e = B(e, this.size), (t = k(t, this.size)) <= e ? new ve(0, 0) : new ve(this.get(e, this._end), this.get(t, this._end), this._step));
    }, ve.prototype.indexOf = function (e) {
      var t = e - this._start;

      if (t % this._step == 0) {
        var a = t / this._step;
        if (a >= 0 && a < this.size) return a;
      }

      return -1;
    }, ve.prototype.lastIndexOf = function (e) {
      return this.indexOf(e);
    }, ve.prototype.__iterate = function (e, t) {
      for (var a = this.size - 1, r = this._step, n = t ? this._start + a * r : this._start, s = 0; s <= a; s++) {
        if (!1 === e(n, s, this)) return s + 1;
        n += t ? -r : r;
      }

      return s;
    }, ve.prototype.__iterator = function (e, t) {
      var a = this.size - 1,
          r = this._step,
          n = t ? this._start + a * r : this._start,
          s = 0;
      return new O(function () {
        var o = n;
        return n += t ? -r : r, s > a ? {
          value: void 0,
          done: !0
        } : F(e, s++, o);
      });
    }, ve.prototype.equals = function (e) {
      return e instanceof ve ? this._start === e._start && this._end === e._end && this._step === e._step : be(this, e);
    }, t(_e, a), t(ge, _e), t(Ae, _e), t(we, _e), _e.Keyed = ge, _e.Indexed = Ae, _e.Set = we;
    var Te = "function" == typeof Math.imul && -2 === Math.imul(4294967295, 2) ? Math.imul : function (e, t) {
      var a = 65535 & (e |= 0),
          r = 65535 & (t |= 0);
      return a * r + ((e >>> 16) * r + a * (t >>> 16) << 16 >>> 0) | 0;
    };

    function xe(e) {
      return e >>> 1 & 1073741824 | 3221225471 & e;
    }

    function De(e) {
      if (!1 === e || null == e) return 0;
      if ("function" == typeof e.valueOf && (!1 === (e = e.valueOf()) || null == e)) return 0;
      if (!0 === e) return 1;
      var t = typeof e;

      if ("number" === t) {
        if (e != e || e === 1 / 0) return 0;
        var a = 0 | e;

        for (a !== e && (a ^= 4294967295 * e); e > 4294967295;) {
          a ^= e /= 4294967295;
        }

        return xe(a);
      }

      if ("string" === t) return e.length > Ie ? function (e) {
        var t = Pe[e];
        return void 0 === t && (t = Ce(e), Me === Ne && (Me = 0, Pe = {}), Me++, Pe[e] = t), t;
      }(e) : Ce(e);
      if ("function" == typeof e.hashCode) return e.hashCode();
      if ("object" === t) return function (e) {
        var t;
        if (ke && void 0 !== (t = Se.get(e))) return t;
        if (void 0 !== (t = e[We])) return t;

        if (!Be) {
          if (void 0 !== (t = e.propertyIsEnumerable && e.propertyIsEnumerable[We])) return t;
          if (void 0 !== (t = function (e) {
            if (e && e.nodeType > 0) switch (e.nodeType) {
              case 1:
                return e.uniqueID;

              case 9:
                return e.documentElement && e.documentElement.uniqueID;
            }
          }(e))) return t;
        }

        if (t = ++Re, 1073741824 & Re && (Re = 0), ke) Se.set(e, t);else {
          if (void 0 !== Ee && !1 === Ee(e)) throw new Error("Non-extensible objects are not allowed as keys.");
          if (Be) Object.defineProperty(e, We, {
            enumerable: !1,
            configurable: !1,
            writable: !1,
            value: t
          });else if (void 0 !== e.propertyIsEnumerable && e.propertyIsEnumerable === e.constructor.prototype.propertyIsEnumerable) e.propertyIsEnumerable = function () {
            return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
          }, e.propertyIsEnumerable[We] = t;else {
            if (void 0 === e.nodeType) throw new Error("Unable to set a non-enumerable property on object.");
            e[We] = t;
          }
        }
        return t;
      }(e);
      if ("function" == typeof e.toString) return Ce(e.toString());
      throw new Error("Value type " + t + " cannot be hashed.");
    }

    function Ce(e) {
      for (var t = 0, a = 0; a < e.length; a++) {
        t = 31 * t + e.charCodeAt(a) | 0;
      }

      return xe(t);
    }

    var Se,
        Ee = Object.isExtensible,
        Be = function () {
      try {
        return Object.defineProperty({}, "@", {}), !0;
      } catch (e) {
        return !1;
      }
    }(),
        ke = "function" == typeof WeakMap;

    ke && (Se = new WeakMap());
    var Re = 0,
        We = "__immutablehash__";
    "function" == typeof Symbol && (We = Symbol(We));
    var Ie = 16,
        Ne = 255,
        Me = 0,
        Pe = {};

    function Le(e) {
      ye(e !== 1 / 0, "Cannot perform this action with an infinite size.");
    }

    function Oe(e) {
      return null == e ? $e() : Fe(e) && !d(e) ? e : $e().withMutations(function (t) {
        var a = r(e);
        Le(a.size), a.forEach(function (e, a) {
          return t.set(a, e);
        });
      });
    }

    function Fe(e) {
      return !(!e || !e[Ge]);
    }

    t(Oe, ge), Oe.of = function () {
      var t = e.call(arguments, 0);
      return $e().withMutations(function (e) {
        for (var a = 0; a < t.length; a += 2) {
          if (a + 1 >= t.length) throw new Error("Missing value for key: " + t[a]);
          e.set(t[a], t[a + 1]);
        }
      });
    }, Oe.prototype.toString = function () {
      return this.__toString("Map {", "}");
    }, Oe.prototype.get = function (e, t) {
      return this._root ? this._root.get(0, void 0, e, t) : t;
    }, Oe.prototype.set = function (e, t) {
      return Qe(this, e, t);
    }, Oe.prototype.setIn = function (e, t) {
      return this.updateIn(e, v, function () {
        return t;
      });
    }, Oe.prototype.remove = function (e) {
      return Qe(this, e, v);
    }, Oe.prototype.deleteIn = function (e) {
      return this.updateIn(e, function () {
        return v;
      });
    }, Oe.prototype.update = function (e, t, a) {
      return 1 === arguments.length ? e(this) : this.updateIn([e], t, a);
    }, Oe.prototype.updateIn = function (e, t, a) {
      a || (a = t, t = void 0);

      var r = function e(t, a, r, n) {
        var s = t === v,
            o = a.next();

        if (o.done) {
          var i = s ? r : t,
              c = n(i);
          return c === i ? t : c;
        }

        ye(s || t && t.set, "invalid keyPath");
        var u = o.value,
            d = s ? v : t.get(u, v),
            f = e(d, a, r, n);
        return f === d ? t : f === v ? t.remove(u) : (s ? $e() : t).set(u, f);
      }(this, ra(e), t, a);

      return r === v ? void 0 : r;
    }, Oe.prototype.clear = function () {
      return 0 === this.size ? this : this.__ownerID ? (this.size = 0, this._root = null, this.__hash = void 0, this.__altered = !0, this) : $e();
    }, Oe.prototype.merge = function () {
      return rt(this, void 0, arguments);
    }, Oe.prototype.mergeWith = function (t) {
      var a = e.call(arguments, 1);
      return rt(this, t, a);
    }, Oe.prototype.mergeIn = function (t) {
      var a = e.call(arguments, 1);
      return this.updateIn(t, $e(), function (e) {
        return "function" == typeof e.merge ? e.merge.apply(e, a) : a[a.length - 1];
      });
    }, Oe.prototype.mergeDeep = function () {
      return rt(this, nt, arguments);
    }, Oe.prototype.mergeDeepWith = function (t) {
      var a = e.call(arguments, 1);
      return rt(this, st(t), a);
    }, Oe.prototype.mergeDeepIn = function (t) {
      var a = e.call(arguments, 1);
      return this.updateIn(t, $e(), function (e) {
        return "function" == typeof e.mergeDeep ? e.mergeDeep.apply(e, a) : a[a.length - 1];
      });
    }, Oe.prototype.sort = function (e) {
      return Bt(Kt(this, e));
    }, Oe.prototype.sortBy = function (e, t) {
      return Bt(Kt(this, t, e));
    }, Oe.prototype.withMutations = function (e) {
      var t = this.asMutable();
      return e(t), t.wasAltered() ? t.__ensureOwner(this.__ownerID) : this;
    }, Oe.prototype.asMutable = function () {
      return this.__ownerID ? this : this.__ensureOwner(new T());
    }, Oe.prototype.asImmutable = function () {
      return this.__ensureOwner();
    }, Oe.prototype.wasAltered = function () {
      return this.__altered;
    }, Oe.prototype.__iterator = function (e, t) {
      return new Ye(this, e, t);
    }, Oe.prototype.__iterate = function (e, t) {
      var a = this,
          r = 0;
      return this._root && this._root.iterate(function (t) {
        return r++, e(t[1], t[0], a);
      }, t), r;
    }, Oe.prototype.__ensureOwner = function (e) {
      return e === this.__ownerID ? this : e ? Xe(this.size, this._root, e, this.__hash) : (this.__ownerID = e, this.__altered = !1, this);
    }, Oe.isMap = Fe;
    var je,
        Ge = "@@__IMMUTABLE_MAP__@@",
        Ve = Oe.prototype;

    function Ue(e, t) {
      this.ownerID = e, this.entries = t;
    }

    function He(e, t, a) {
      this.ownerID = e, this.bitmap = t, this.nodes = a;
    }

    function ze(e, t, a) {
      this.ownerID = e, this.count = t, this.nodes = a;
    }

    function Ke(e, t, a) {
      this.ownerID = e, this.keyHash = t, this.entries = a;
    }

    function qe(e, t, a) {
      this.ownerID = e, this.keyHash = t, this.entry = a;
    }

    function Ye(e, t, a) {
      this._type = t, this._reverse = a, this._stack = e._root && Je(e._root);
    }

    function Ze(e, t) {
      return F(e, t[0], t[1]);
    }

    function Je(e, t) {
      return {
        node: e,
        index: 0,
        __prev: t
      };
    }

    function Xe(e, t, a, r) {
      var n = Object.create(Ve);
      return n.size = e, n._root = t, n.__ownerID = a, n.__hash = r, n.__altered = !1, n;
    }

    function $e() {
      return je || (je = Xe(0));
    }

    function Qe(e, t, a) {
      var r, n;

      if (e._root) {
        var s = A(_),
            o = A(g);
        if (r = et(e._root, e.__ownerID, 0, void 0, t, a, s, o), !o.value) return e;
        n = e.size + (s.value ? a === v ? -1 : 1 : 0);
      } else {
        if (a === v) return e;
        n = 1, r = new Ue(e.__ownerID, [[t, a]]);
      }

      return e.__ownerID ? (e.size = n, e._root = r, e.__hash = void 0, e.__altered = !0, e) : r ? Xe(n, r) : $e();
    }

    function et(e, t, a, r, n, s, o, i) {
      return e ? e.update(t, a, r, n, s, o, i) : s === v ? e : (w(i), w(o), new qe(t, r, [n, s]));
    }

    function tt(e) {
      return e.constructor === qe || e.constructor === Ke;
    }

    function at(e, t, a, r, n) {
      if (e.keyHash === r) return new Ke(t, r, [e.entry, n]);
      var s,
          o = (0 === a ? e.keyHash : e.keyHash >>> a) & y,
          i = (0 === a ? r : r >>> a) & y;
      return new He(t, 1 << o | 1 << i, o === i ? [at(e, t, a + b, r, n)] : (s = new qe(t, r, n), o < i ? [e, s] : [s, e]));
    }

    function rt(e, t, a) {
      for (var n = [], s = 0; s < a.length; s++) {
        var i = a[s],
            c = r(i);
        o(i) || (c = c.map(function (e) {
          return fe(e);
        })), n.push(c);
      }

      return ot(e, t, n);
    }

    function nt(e, t, a) {
      return e && e.mergeDeep && o(t) ? e.mergeDeep(t) : pe(e, t) ? e : t;
    }

    function st(e) {
      return function (t, a, r) {
        if (t && t.mergeDeepWith && o(a)) return t.mergeDeepWith(e, a);
        var n = e(t, a, r);
        return pe(t, n) ? t : n;
      };
    }

    function ot(e, t, a) {
      return 0 === (a = a.filter(function (e) {
        return 0 !== e.size;
      })).length ? e : 0 !== e.size || e.__ownerID || 1 !== a.length ? e.withMutations(function (e) {
        for (var r = t ? function (a, r) {
          e.update(r, v, function (e) {
            return e === v ? a : t(e, a, r);
          });
        } : function (t, a) {
          e.set(a, t);
        }, n = 0; n < a.length; n++) {
          a[n].forEach(r);
        }
      }) : e.constructor(a[0]);
    }

    function it(e) {
      return e = (e = (858993459 & (e -= e >> 1 & 1431655765)) + (e >> 2 & 858993459)) + (e >> 4) & 252645135, e += e >> 8, 127 & (e += e >> 16);
    }

    function ct(e, t, a, r) {
      var n = r ? e : x(e);
      return n[t] = a, n;
    }

    Ve[Ge] = !0, Ve.delete = Ve.remove, Ve.removeIn = Ve.deleteIn, Ue.prototype.get = function (e, t, a, r) {
      for (var n = this.entries, s = 0, o = n.length; s < o; s++) {
        if (pe(a, n[s][0])) return n[s][1];
      }

      return r;
    }, Ue.prototype.update = function (e, t, a, r, n, s, o) {
      for (var i = n === v, c = this.entries, u = 0, d = c.length; u < d && !pe(r, c[u][0]); u++) {
        ;
      }

      var f = u < d;
      if (f ? c[u][1] === n : i) return this;

      if (w(o), (i || !f) && w(s), !i || 1 !== c.length) {
        if (!f && !i && c.length >= ut) return function (e, t, a, r) {
          e || (e = new T());

          for (var n = new qe(e, De(a), [a, r]), s = 0; s < t.length; s++) {
            var o = t[s];
            n = n.update(e, 0, void 0, o[0], o[1]);
          }

          return n;
        }(e, c, r, n);
        var l = e && e === this.ownerID,
            h = l ? c : x(c);
        return f ? i ? u === d - 1 ? h.pop() : h[u] = h.pop() : h[u] = [r, n] : h.push([r, n]), l ? (this.entries = h, this) : new Ue(e, h);
      }
    }, He.prototype.get = function (e, t, a, r) {
      void 0 === t && (t = De(a));
      var n = 1 << ((0 === e ? t : t >>> e) & y),
          s = this.bitmap;
      return 0 == (s & n) ? r : this.nodes[it(s & n - 1)].get(e + b, t, a, r);
    }, He.prototype.update = function (e, t, a, r, n, s, o) {
      void 0 === a && (a = De(r));
      var i = (0 === t ? a : a >>> t) & y,
          c = 1 << i,
          u = this.bitmap,
          d = 0 != (u & c);
      if (!d && n === v) return this;
      var f = it(u & c - 1),
          l = this.nodes,
          h = d ? l[f] : void 0,
          p = et(h, e, t + b, a, r, n, s, o);
      if (p === h) return this;
      if (!d && p && l.length >= dt) return function (e, t, a, r, n) {
        for (var s = 0, o = new Array(m), i = 0; 0 !== a; i++, a >>>= 1) {
          o[i] = 1 & a ? t[s++] : void 0;
        }

        return o[r] = n, new ze(e, s + 1, o);
      }(e, l, u, i, p);
      if (d && !p && 2 === l.length && tt(l[1 ^ f])) return l[1 ^ f];
      if (d && p && 1 === l.length && tt(p)) return p;

      var _ = e && e === this.ownerID,
          g = d ? p ? u : u ^ c : u | c,
          A = d ? p ? ct(l, f, p, _) : function (e, t, a) {
        var r = e.length - 1;
        if (a && t === r) return e.pop(), e;

        for (var n = new Array(r), s = 0, o = 0; o < r; o++) {
          o === t && (s = 1), n[o] = e[o + s];
        }

        return n;
      }(l, f, _) : function (e, t, a, r) {
        var n = e.length + 1;
        if (r && t + 1 === n) return e[t] = a, e;

        for (var s = new Array(n), o = 0, i = 0; i < n; i++) {
          i === t ? (s[i] = a, o = -1) : s[i] = e[i + o];
        }

        return s;
      }(l, f, p, _);

      return _ ? (this.bitmap = g, this.nodes = A, this) : new He(e, g, A);
    }, ze.prototype.get = function (e, t, a, r) {
      void 0 === t && (t = De(a));
      var n = (0 === e ? t : t >>> e) & y,
          s = this.nodes[n];
      return s ? s.get(e + b, t, a, r) : r;
    }, ze.prototype.update = function (e, t, a, r, n, s, o) {
      void 0 === a && (a = De(r));
      var i = (0 === t ? a : a >>> t) & y,
          c = n === v,
          u = this.nodes,
          d = u[i];
      if (c && !d) return this;
      var f = et(d, e, t + b, a, r, n, s, o);
      if (f === d) return this;
      var l = this.count;

      if (d) {
        if (!f && --l < ft) return function (e, t, a, r) {
          for (var n = 0, s = 0, o = new Array(a), i = 0, c = 1, u = t.length; i < u; i++, c <<= 1) {
            var d = t[i];
            void 0 !== d && i !== r && (n |= c, o[s++] = d);
          }

          return new He(e, n, o);
        }(e, u, l, i);
      } else l++;

      var h = e && e === this.ownerID,
          p = ct(u, i, f, h);
      return h ? (this.count = l, this.nodes = p, this) : new ze(e, l, p);
    }, Ke.prototype.get = function (e, t, a, r) {
      for (var n = this.entries, s = 0, o = n.length; s < o; s++) {
        if (pe(a, n[s][0])) return n[s][1];
      }

      return r;
    }, Ke.prototype.update = function (e, t, a, r, n, s, o) {
      void 0 === a && (a = De(r));
      var i = n === v;
      if (a !== this.keyHash) return i ? this : (w(o), w(s), at(this, e, t, a, [r, n]));

      for (var c = this.entries, u = 0, d = c.length; u < d && !pe(r, c[u][0]); u++) {
        ;
      }

      var f = u < d;
      if (f ? c[u][1] === n : i) return this;
      if (w(o), (i || !f) && w(s), i && 2 === d) return new qe(e, this.keyHash, c[1 ^ u]);
      var l = e && e === this.ownerID,
          h = l ? c : x(c);
      return f ? i ? u === d - 1 ? h.pop() : h[u] = h.pop() : h[u] = [r, n] : h.push([r, n]), l ? (this.entries = h, this) : new Ke(e, this.keyHash, h);
    }, qe.prototype.get = function (e, t, a, r) {
      return pe(a, this.entry[0]) ? this.entry[1] : r;
    }, qe.prototype.update = function (e, t, a, r, n, s, o) {
      var i = n === v,
          c = pe(r, this.entry[0]);
      return (c ? n === this.entry[1] : i) ? this : (w(o), i ? void w(s) : c ? e && e === this.ownerID ? (this.entry[1] = n, this) : new qe(e, this.keyHash, [r, n]) : (w(s), at(this, e, t, De(r), [r, n])));
    }, Ue.prototype.iterate = Ke.prototype.iterate = function (e, t) {
      for (var a = this.entries, r = 0, n = a.length - 1; r <= n; r++) {
        if (!1 === e(a[t ? n - r : r])) return !1;
      }
    }, He.prototype.iterate = ze.prototype.iterate = function (e, t) {
      for (var a = this.nodes, r = 0, n = a.length - 1; r <= n; r++) {
        var s = a[t ? n - r : r];
        if (s && !1 === s.iterate(e, t)) return !1;
      }
    }, qe.prototype.iterate = function (e, t) {
      return e(this.entry);
    }, t(Ye, O), Ye.prototype.next = function () {
      for (var e = this._type, t = this._stack; t;) {
        var a,
            r = t.node,
            n = t.index++;

        if (r.entry) {
          if (0 === n) return Ze(e, r.entry);
        } else if (r.entries) {
          if (n <= (a = r.entries.length - 1)) return Ze(e, r.entries[this._reverse ? a - n : n]);
        } else if (n <= (a = r.nodes.length - 1)) {
          var s = r.nodes[this._reverse ? a - n : n];

          if (s) {
            if (s.entry) return Ze(e, s.entry);
            t = this._stack = Je(s, t);
          }

          continue;
        }

        t = this._stack = this._stack.__prev;
      }

      return {
        value: void 0,
        done: !0
      };
    };
    var ut = m / 4,
        dt = m / 2,
        ft = m / 4;

    function lt(e) {
      var t = wt();
      if (null == e) return t;
      if (ht(e)) return e;
      var a = n(e),
          r = a.size;
      return 0 === r ? t : (Le(r), r > 0 && r < m ? At(0, r, b, null, new mt(a.toArray())) : t.withMutations(function (e) {
        e.setSize(r), a.forEach(function (t, a) {
          return e.set(a, t);
        });
      }));
    }

    function ht(e) {
      return !(!e || !e[pt]);
    }

    t(lt, Ae), lt.of = function () {
      return this(arguments);
    }, lt.prototype.toString = function () {
      return this.__toString("List [", "]");
    }, lt.prototype.get = function (e, t) {
      if ((e = C(this, e)) >= 0 && e < this.size) {
        var a = Dt(this, e += this._origin);
        return a && a.array[e & y];
      }

      return t;
    }, lt.prototype.set = function (e, t) {
      return function (e, t, a) {
        if ((t = C(e, t)) != t) return e;
        if (t >= e.size || t < 0) return e.withMutations(function (e) {
          t < 0 ? Ct(e, t).set(0, a) : Ct(e, 0, t + 1).set(t, a);
        });
        t += e._origin;
        var r = e._tail,
            n = e._root,
            s = A(g);
        return t >= Et(e._capacity) ? r = Tt(r, e.__ownerID, 0, t, a, s) : n = Tt(n, e.__ownerID, e._level, t, a, s), s.value ? e.__ownerID ? (e._root = n, e._tail = r, e.__hash = void 0, e.__altered = !0, e) : At(e._origin, e._capacity, e._level, n, r) : e;
      }(this, e, t);
    }, lt.prototype.remove = function (e) {
      return this.has(e) ? 0 === e ? this.shift() : e === this.size - 1 ? this.pop() : this.splice(e, 1) : this;
    }, lt.prototype.insert = function (e, t) {
      return this.splice(e, 0, t);
    }, lt.prototype.clear = function () {
      return 0 === this.size ? this : this.__ownerID ? (this.size = this._origin = this._capacity = 0, this._level = b, this._root = this._tail = null, this.__hash = void 0, this.__altered = !0, this) : wt();
    }, lt.prototype.push = function () {
      var e = arguments,
          t = this.size;
      return this.withMutations(function (a) {
        Ct(a, 0, t + e.length);

        for (var r = 0; r < e.length; r++) {
          a.set(t + r, e[r]);
        }
      });
    }, lt.prototype.pop = function () {
      return Ct(this, 0, -1);
    }, lt.prototype.unshift = function () {
      var e = arguments;
      return this.withMutations(function (t) {
        Ct(t, -e.length);

        for (var a = 0; a < e.length; a++) {
          t.set(a, e[a]);
        }
      });
    }, lt.prototype.shift = function () {
      return Ct(this, 1);
    }, lt.prototype.merge = function () {
      return St(this, void 0, arguments);
    }, lt.prototype.mergeWith = function (t) {
      var a = e.call(arguments, 1);
      return St(this, t, a);
    }, lt.prototype.mergeDeep = function () {
      return St(this, nt, arguments);
    }, lt.prototype.mergeDeepWith = function (t) {
      var a = e.call(arguments, 1);
      return St(this, st(t), a);
    }, lt.prototype.setSize = function (e) {
      return Ct(this, 0, e);
    }, lt.prototype.slice = function (e, t) {
      var a = this.size;
      return E(e, t, a) ? this : Ct(this, B(e, a), k(t, a));
    }, lt.prototype.__iterator = function (e, t) {
      var a = 0,
          r = gt(this, t);
      return new O(function () {
        var t = r();
        return t === _t ? {
          value: void 0,
          done: !0
        } : F(e, a++, t);
      });
    }, lt.prototype.__iterate = function (e, t) {
      for (var a, r = 0, n = gt(this, t); (a = n()) !== _t && !1 !== e(a, r++, this);) {
        ;
      }

      return r;
    }, lt.prototype.__ensureOwner = function (e) {
      return e === this.__ownerID ? this : e ? At(this._origin, this._capacity, this._level, this._root, this._tail, e, this.__hash) : (this.__ownerID = e, this);
    }, lt.isList = ht;
    var pt = "@@__IMMUTABLE_LIST__@@",
        bt = lt.prototype;

    function mt(e, t) {
      this.array = e, this.ownerID = t;
    }

    bt[pt] = !0, bt.delete = bt.remove, bt.setIn = Ve.setIn, bt.deleteIn = bt.removeIn = Ve.removeIn, bt.update = Ve.update, bt.updateIn = Ve.updateIn, bt.mergeIn = Ve.mergeIn, bt.mergeDeepIn = Ve.mergeDeepIn, bt.withMutations = Ve.withMutations, bt.asMutable = Ve.asMutable, bt.asImmutable = Ve.asImmutable, bt.wasAltered = Ve.wasAltered, mt.prototype.removeBefore = function (e, t, a) {
      if (a === t ? 1 << t : 0 === this.array.length) return this;
      var r = a >>> t & y;
      if (r >= this.array.length) return new mt([], e);
      var n,
          s = 0 === r;

      if (t > 0) {
        var o = this.array[r];
        if ((n = o && o.removeBefore(e, t - b, a)) === o && s) return this;
      }

      if (s && !n) return this;
      var i = xt(this, e);
      if (!s) for (var c = 0; c < r; c++) {
        i.array[c] = void 0;
      }
      return n && (i.array[r] = n), i;
    }, mt.prototype.removeAfter = function (e, t, a) {
      if (a === (t ? 1 << t : 0) || 0 === this.array.length) return this;
      var r,
          n = a - 1 >>> t & y;
      if (n >= this.array.length) return this;

      if (t > 0) {
        var s = this.array[n];
        if ((r = s && s.removeAfter(e, t - b, a)) === s && n === this.array.length - 1) return this;
      }

      var o = xt(this, e);
      return o.array.splice(n + 1), r && (o.array[n] = r), o;
    };
    var yt,
        vt,
        _t = {};

    function gt(e, t) {
      var a = e._origin,
          r = e._capacity,
          n = Et(r),
          s = e._tail;
      return o(e._root, e._level, 0);

      function o(e, i, c) {
        return 0 === i ? function (e, o) {
          var i = o === n ? s && s.array : e && e.array,
              c = o > a ? 0 : a - o,
              u = r - o;
          return u > m && (u = m), function () {
            if (c === u) return _t;
            var e = t ? --u : c++;
            return i && i[e];
          };
        }(e, c) : function (e, n, s) {
          var i,
              c = e && e.array,
              u = s > a ? 0 : a - s >> n,
              d = 1 + (r - s >> n);
          return d > m && (d = m), function () {
            for (;;) {
              if (i) {
                var e = i();
                if (e !== _t) return e;
                i = null;
              }

              if (u === d) return _t;
              var a = t ? --d : u++;
              i = o(c && c[a], n - b, s + (a << n));
            }
          };
        }(e, i, c);
      }
    }

    function At(e, t, a, r, n, s, o) {
      var i = Object.create(bt);
      return i.size = t - e, i._origin = e, i._capacity = t, i._level = a, i._root = r, i._tail = n, i.__ownerID = s, i.__hash = o, i.__altered = !1, i;
    }

    function wt() {
      return yt || (yt = At(0, 0, b));
    }

    function Tt(e, t, a, r, n, s) {
      var o,
          i = r >>> a & y,
          c = e && i < e.array.length;
      if (!c && void 0 === n) return e;

      if (a > 0) {
        var u = e && e.array[i],
            d = Tt(u, t, a - b, r, n, s);
        return d === u ? e : ((o = xt(e, t)).array[i] = d, o);
      }

      return c && e.array[i] === n ? e : (w(s), o = xt(e, t), void 0 === n && i === o.array.length - 1 ? o.array.pop() : o.array[i] = n, o);
    }

    function xt(e, t) {
      return t && e && t === e.ownerID ? e : new mt(e ? e.array.slice() : [], t);
    }

    function Dt(e, t) {
      if (t >= Et(e._capacity)) return e._tail;

      if (t < 1 << e._level + b) {
        for (var a = e._root, r = e._level; a && r > 0;) {
          a = a.array[t >>> r & y], r -= b;
        }

        return a;
      }
    }

    function Ct(e, t, a) {
      void 0 !== t && (t |= 0), void 0 !== a && (a |= 0);
      var r = e.__ownerID || new T(),
          n = e._origin,
          s = e._capacity,
          o = n + t,
          i = void 0 === a ? s : a < 0 ? s + a : n + a;
      if (o === n && i === s) return e;
      if (o >= i) return e.clear();

      for (var c = e._level, u = e._root, d = 0; o + d < 0;) {
        u = new mt(u && u.array.length ? [void 0, u] : [], r), d += 1 << (c += b);
      }

      d && (o += d, n += d, i += d, s += d);

      for (var f = Et(s), l = Et(i); l >= 1 << c + b;) {
        u = new mt(u && u.array.length ? [u] : [], r), c += b;
      }

      var h = e._tail,
          p = l < f ? Dt(e, i - 1) : l > f ? new mt([], r) : h;

      if (h && l > f && o < s && h.array.length) {
        for (var m = u = xt(u, r), v = c; v > b; v -= b) {
          var _ = f >>> v & y;

          m = m.array[_] = xt(m.array[_], r);
        }

        m.array[f >>> b & y] = h;
      }

      if (i < s && (p = p && p.removeAfter(r, 0, i)), o >= l) o -= l, i -= l, c = b, u = null, p = p && p.removeBefore(r, 0, o);else if (o > n || l < f) {
        for (d = 0; u;) {
          var g = o >>> c & y;
          if (g !== l >>> c & y) break;
          g && (d += (1 << c) * g), c -= b, u = u.array[g];
        }

        u && o > n && (u = u.removeBefore(r, c, o - d)), u && l < f && (u = u.removeAfter(r, c, l - d)), d && (o -= d, i -= d);
      }
      return e.__ownerID ? (e.size = i - o, e._origin = o, e._capacity = i, e._level = c, e._root = u, e._tail = p, e.__hash = void 0, e.__altered = !0, e) : At(o, i, c, u, p);
    }

    function St(e, t, a) {
      for (var r = [], s = 0, i = 0; i < a.length; i++) {
        var c = a[i],
            u = n(c);
        u.size > s && (s = u.size), o(c) || (u = u.map(function (e) {
          return fe(e);
        })), r.push(u);
      }

      return s > e.size && (e = e.setSize(s)), ot(e, t, r);
    }

    function Et(e) {
      return e < m ? 0 : e - 1 >>> b << b;
    }

    function Bt(e) {
      return null == e ? Wt() : kt(e) ? e : Wt().withMutations(function (t) {
        var a = r(e);
        Le(a.size), a.forEach(function (e, a) {
          return t.set(a, e);
        });
      });
    }

    function kt(e) {
      return Fe(e) && d(e);
    }

    function Rt(e, t, a, r) {
      var n = Object.create(Bt.prototype);
      return n.size = e ? e.size : 0, n._map = e, n._list = t, n.__ownerID = a, n.__hash = r, n;
    }

    function Wt() {
      return vt || (vt = Rt($e(), wt()));
    }

    function It(e, t, a) {
      var r,
          n,
          s = e._map,
          o = e._list,
          i = s.get(t),
          c = void 0 !== i;

      if (a === v) {
        if (!c) return e;
        o.size >= m && o.size >= 2 * s.size ? (r = (n = o.filter(function (e, t) {
          return void 0 !== e && i !== t;
        })).toKeyedSeq().map(function (e) {
          return e[0];
        }).flip().toMap(), e.__ownerID && (r.__ownerID = n.__ownerID = e.__ownerID)) : (r = s.remove(t), n = i === o.size - 1 ? o.pop() : o.set(i, void 0));
      } else if (c) {
        if (a === o.get(i)[1]) return e;
        r = s, n = o.set(i, [t, a]);
      } else r = s.set(t, o.size), n = o.set(o.size, [t, a]);

      return e.__ownerID ? (e.size = r.size, e._map = r, e._list = n, e.__hash = void 0, e) : Rt(r, n);
    }

    function Nt(e, t) {
      this._iter = e, this._useKeys = t, this.size = e.size;
    }

    function Mt(e) {
      this._iter = e, this.size = e.size;
    }

    function Pt(e) {
      this._iter = e, this.size = e.size;
    }

    function Lt(e) {
      this._iter = e, this.size = e.size;
    }

    function Ot(e) {
      var t = ea(e);
      return t._iter = e, t.size = e.size, t.flip = function () {
        return e;
      }, t.reverse = function () {
        var t = e.reverse.apply(this);
        return t.flip = function () {
          return e.reverse();
        }, t;
      }, t.has = function (t) {
        return e.includes(t);
      }, t.includes = function (t) {
        return e.has(t);
      }, t.cacheResult = ta, t.__iterateUncached = function (t, a) {
        var r = this;
        return e.__iterate(function (e, a) {
          return !1 !== t(a, e, r);
        }, a);
      }, t.__iteratorUncached = function (t, a) {
        if (t === N) {
          var r = e.__iterator(t, a);

          return new O(function () {
            var e = r.next();

            if (!e.done) {
              var t = e.value[0];
              e.value[0] = e.value[1], e.value[1] = t;
            }

            return e;
          });
        }

        return e.__iterator(t === I ? W : I, a);
      }, t;
    }

    function Ft(e, t, a) {
      var r = ea(e);
      return r.size = e.size, r.has = function (t) {
        return e.has(t);
      }, r.get = function (r, n) {
        var s = e.get(r, v);
        return s === v ? n : t.call(a, s, r, e);
      }, r.__iterateUncached = function (r, n) {
        var s = this;
        return e.__iterate(function (e, n, o) {
          return !1 !== r(t.call(a, e, n, o), n, s);
        }, n);
      }, r.__iteratorUncached = function (r, n) {
        var s = e.__iterator(N, n);

        return new O(function () {
          var n = s.next();
          if (n.done) return n;
          var o = n.value,
              i = o[0];
          return F(r, i, t.call(a, o[1], i, e), n);
        });
      }, r;
    }

    function jt(e, t) {
      var a = ea(e);
      return a._iter = e, a.size = e.size, a.reverse = function () {
        return e;
      }, e.flip && (a.flip = function () {
        var t = Ot(e);
        return t.reverse = function () {
          return e.flip();
        }, t;
      }), a.get = function (a, r) {
        return e.get(t ? a : -1 - a, r);
      }, a.has = function (a) {
        return e.has(t ? a : -1 - a);
      }, a.includes = function (t) {
        return e.includes(t);
      }, a.cacheResult = ta, a.__iterate = function (t, a) {
        var r = this;
        return e.__iterate(function (e, a) {
          return t(e, a, r);
        }, !a);
      }, a.__iterator = function (t, a) {
        return e.__iterator(t, !a);
      }, a;
    }

    function Gt(e, t, a, r) {
      var n = ea(e);
      return r && (n.has = function (r) {
        var n = e.get(r, v);
        return n !== v && !!t.call(a, n, r, e);
      }, n.get = function (r, n) {
        var s = e.get(r, v);
        return s !== v && t.call(a, s, r, e) ? s : n;
      }), n.__iterateUncached = function (n, s) {
        var o = this,
            i = 0;
        return e.__iterate(function (e, s, c) {
          if (t.call(a, e, s, c)) return i++, n(e, r ? s : i - 1, o);
        }, s), i;
      }, n.__iteratorUncached = function (n, s) {
        var o = e.__iterator(N, s),
            i = 0;

        return new O(function () {
          for (;;) {
            var s = o.next();
            if (s.done) return s;
            var c = s.value,
                u = c[0],
                d = c[1];
            if (t.call(a, d, u, e)) return F(n, r ? u : i++, d, s);
          }
        });
      }, n;
    }

    function Vt(e, t, a, r) {
      var n = e.size;
      if (void 0 !== t && (t |= 0), void 0 !== a && (a === 1 / 0 ? a = n : a |= 0), E(t, a, n)) return e;
      var s = B(t, n),
          o = k(a, n);
      if (s != s || o != o) return Vt(e.toSeq().cacheResult(), t, a, r);
      var i,
          c = o - s;
      c == c && (i = c < 0 ? 0 : c);
      var u = ea(e);
      return u.size = 0 === i ? i : e.size && i || void 0, !r && ne(e) && i >= 0 && (u.get = function (t, a) {
        return (t = C(this, t)) >= 0 && t < i ? e.get(t + s, a) : a;
      }), u.__iterateUncached = function (t, a) {
        var n = this;
        if (0 === i) return 0;
        if (a) return this.cacheResult().__iterate(t, a);
        var o = 0,
            c = !0,
            u = 0;
        return e.__iterate(function (e, a) {
          if (!c || !(c = o++ < s)) return u++, !1 !== t(e, r ? a : u - 1, n) && u !== i;
        }), u;
      }, u.__iteratorUncached = function (t, a) {
        if (0 !== i && a) return this.cacheResult().__iterator(t, a);

        var n = 0 !== i && e.__iterator(t, a),
            o = 0,
            c = 0;

        return new O(function () {
          for (; o++ < s;) {
            n.next();
          }

          if (++c > i) return {
            value: void 0,
            done: !0
          };
          var e = n.next();
          return r || t === I ? e : F(t, c - 1, t === W ? void 0 : e.value[1], e);
        });
      }, u;
    }

    function Ut(e, t, a, r) {
      var n = ea(e);
      return n.__iterateUncached = function (n, s) {
        var o = this;
        if (s) return this.cacheResult().__iterate(n, s);
        var i = !0,
            c = 0;
        return e.__iterate(function (e, s, u) {
          if (!i || !(i = t.call(a, e, s, u))) return c++, n(e, r ? s : c - 1, o);
        }), c;
      }, n.__iteratorUncached = function (n, s) {
        var o = this;
        if (s) return this.cacheResult().__iterator(n, s);

        var i = e.__iterator(N, s),
            c = !0,
            u = 0;

        return new O(function () {
          var e, s, d;

          do {
            if ((e = i.next()).done) return r || n === I ? e : F(n, u++, n === W ? void 0 : e.value[1], e);
            var f = e.value;
            s = f[0], d = f[1], c && (c = t.call(a, d, s, o));
          } while (c);

          return n === N ? e : F(n, s, d, e);
        });
      }, n;
    }

    function Ht(e, t) {
      var a = i(e),
          n = [e].concat(t).map(function (e) {
        return o(e) ? a && (e = r(e)) : e = a ? oe(e) : ie(Array.isArray(e) ? e : [e]), e;
      }).filter(function (e) {
        return 0 !== e.size;
      });
      if (0 === n.length) return e;

      if (1 === n.length) {
        var s = n[0];
        if (s === e || a && i(s) || c(e) && c(s)) return s;
      }

      var u = new ee(n);
      return a ? u = u.toKeyedSeq() : c(e) || (u = u.toSetSeq()), (u = u.flatten(!0)).size = n.reduce(function (e, t) {
        if (void 0 !== e) {
          var a = t.size;
          if (void 0 !== a) return e + a;
        }
      }, 0), u;
    }

    function zt(e, t, a) {
      var r = ea(e);
      return r.__iterateUncached = function (r, n) {
        var s = 0,
            i = !1;
        return function e(c, u) {
          var d = this;

          c.__iterate(function (n, c) {
            return (!t || u < t) && o(n) ? e(n, u + 1) : !1 === r(n, a ? c : s++, d) && (i = !0), !i;
          }, n);
        }(e, 0), s;
      }, r.__iteratorUncached = function (r, n) {
        var s = e.__iterator(r, n),
            i = [],
            c = 0;

        return new O(function () {
          for (; s;) {
            var e = s.next();

            if (!1 === e.done) {
              var u = e.value;
              if (r === N && (u = u[1]), t && !(i.length < t) || !o(u)) return a ? e : F(r, c++, u, e);
              i.push(s), s = u.__iterator(r, n);
            } else s = i.pop();
          }

          return {
            value: void 0,
            done: !0
          };
        });
      }, r;
    }

    function Kt(e, t, a) {
      t || (t = aa);
      var r = i(e),
          n = 0,
          s = e.toSeq().map(function (t, r) {
        return [r, t, n++, a ? a(t, r, e) : t];
      }).toArray();
      return s.sort(function (e, a) {
        return t(e[3], a[3]) || e[2] - a[2];
      }).forEach(r ? function (e, t) {
        s[t].length = 2;
      } : function (e, t) {
        s[t] = e[1];
      }), r ? q(s) : c(e) ? Y(s) : Z(s);
    }

    function qt(e, t, a) {
      if (t || (t = aa), a) {
        var r = e.toSeq().map(function (t, r) {
          return [t, a(t, r, e)];
        }).reduce(function (e, a) {
          return Yt(t, e[1], a[1]) ? a : e;
        });
        return r && r[0];
      }

      return e.reduce(function (e, a) {
        return Yt(t, e, a) ? a : e;
      });
    }

    function Yt(e, t, a) {
      var r = e(a, t);
      return 0 === r && a !== t && (null == a || a != a) || r > 0;
    }

    function Zt(e, t, r) {
      var n = ea(e);
      return n.size = new ee(r).map(function (e) {
        return e.size;
      }).min(), n.__iterate = function (e, t) {
        for (var a, r = this.__iterator(I, t), n = 0; !(a = r.next()).done && !1 !== e(a.value, n++, this);) {
          ;
        }

        return n;
      }, n.__iteratorUncached = function (e, n) {
        var s = r.map(function (e) {
          return e = a(e), U(n ? e.reverse() : e);
        }),
            o = 0,
            i = !1;
        return new O(function () {
          var a;
          return i || (a = s.map(function (e) {
            return e.next();
          }), i = a.some(function (e) {
            return e.done;
          })), i ? {
            value: void 0,
            done: !0
          } : F(e, o++, t.apply(null, a.map(function (e) {
            return e.value;
          })));
        });
      }, n;
    }

    function Jt(e, t) {
      return ne(e) ? t : e.constructor(t);
    }

    function Xt(e) {
      if (e !== Object(e)) throw new TypeError("Expected [K, V] tuple: " + e);
    }

    function $t(e) {
      return Le(e.size), D(e);
    }

    function Qt(e) {
      return i(e) ? r : c(e) ? n : s;
    }

    function ea(e) {
      return Object.create((i(e) ? q : c(e) ? Y : Z).prototype);
    }

    function ta() {
      return this._iter.cacheResult ? (this._iter.cacheResult(), this.size = this._iter.size, this) : K.prototype.cacheResult.call(this);
    }

    function aa(e, t) {
      return e > t ? 1 : e < t ? -1 : 0;
    }

    function ra(e) {
      var t = U(e);

      if (!t) {
        if (!z(e)) throw new TypeError("Expected iterable or array-like: " + e);
        t = U(a(e));
      }

      return t;
    }

    function na(e, t) {
      var a,
          r = function r(s) {
        if (s instanceof r) return s;
        if (!(this instanceof r)) return new r(s);

        if (!a) {
          a = !0;
          var o = Object.keys(e);
          !function (e, t) {
            try {
              t.forEach(function (e, t) {
                Object.defineProperty(e, t, {
                  get: function get() {
                    return this.get(t);
                  },
                  set: function set(e) {
                    ye(this.__ownerID, "Cannot set on an immutable record."), this.set(t, e);
                  }
                });
              }.bind(void 0, e));
            } catch (e) {}
          }(n, o), n.size = o.length, n._name = t, n._keys = o, n._defaultValues = e;
        }

        this._map = Oe(s);
      },
          n = r.prototype = Object.create(sa);

      return n.constructor = r, r;
    }

    t(Bt, Oe), Bt.of = function () {
      return this(arguments);
    }, Bt.prototype.toString = function () {
      return this.__toString("OrderedMap {", "}");
    }, Bt.prototype.get = function (e, t) {
      var a = this._map.get(e);

      return void 0 !== a ? this._list.get(a)[1] : t;
    }, Bt.prototype.clear = function () {
      return 0 === this.size ? this : this.__ownerID ? (this.size = 0, this._map.clear(), this._list.clear(), this) : Wt();
    }, Bt.prototype.set = function (e, t) {
      return It(this, e, t);
    }, Bt.prototype.remove = function (e) {
      return It(this, e, v);
    }, Bt.prototype.wasAltered = function () {
      return this._map.wasAltered() || this._list.wasAltered();
    }, Bt.prototype.__iterate = function (e, t) {
      var a = this;
      return this._list.__iterate(function (t) {
        return t && e(t[1], t[0], a);
      }, t);
    }, Bt.prototype.__iterator = function (e, t) {
      return this._list.fromEntrySeq().__iterator(e, t);
    }, Bt.prototype.__ensureOwner = function (e) {
      if (e === this.__ownerID) return this;

      var t = this._map.__ensureOwner(e),
          a = this._list.__ensureOwner(e);

      return e ? Rt(t, a, e, this.__hash) : (this.__ownerID = e, this._map = t, this._list = a, this);
    }, Bt.isOrderedMap = kt, Bt.prototype[p] = !0, Bt.prototype.delete = Bt.prototype.remove, t(Nt, q), Nt.prototype.get = function (e, t) {
      return this._iter.get(e, t);
    }, Nt.prototype.has = function (e) {
      return this._iter.has(e);
    }, Nt.prototype.valueSeq = function () {
      return this._iter.valueSeq();
    }, Nt.prototype.reverse = function () {
      var e = this,
          t = jt(this, !0);
      return this._useKeys || (t.valueSeq = function () {
        return e._iter.toSeq().reverse();
      }), t;
    }, Nt.prototype.map = function (e, t) {
      var a = this,
          r = Ft(this, e, t);
      return this._useKeys || (r.valueSeq = function () {
        return a._iter.toSeq().map(e, t);
      }), r;
    }, Nt.prototype.__iterate = function (e, t) {
      var a,
          r = this;
      return this._iter.__iterate(this._useKeys ? function (t, a) {
        return e(t, a, r);
      } : (a = t ? $t(this) : 0, function (n) {
        return e(n, t ? --a : a++, r);
      }), t);
    }, Nt.prototype.__iterator = function (e, t) {
      if (this._useKeys) return this._iter.__iterator(e, t);

      var a = this._iter.__iterator(I, t),
          r = t ? $t(this) : 0;

      return new O(function () {
        var n = a.next();
        return n.done ? n : F(e, t ? --r : r++, n.value, n);
      });
    }, Nt.prototype[p] = !0, t(Mt, Y), Mt.prototype.includes = function (e) {
      return this._iter.includes(e);
    }, Mt.prototype.__iterate = function (e, t) {
      var a = this,
          r = 0;
      return this._iter.__iterate(function (t) {
        return e(t, r++, a);
      }, t);
    }, Mt.prototype.__iterator = function (e, t) {
      var a = this._iter.__iterator(I, t),
          r = 0;

      return new O(function () {
        var t = a.next();
        return t.done ? t : F(e, r++, t.value, t);
      });
    }, t(Pt, Z), Pt.prototype.has = function (e) {
      return this._iter.includes(e);
    }, Pt.prototype.__iterate = function (e, t) {
      var a = this;
      return this._iter.__iterate(function (t) {
        return e(t, t, a);
      }, t);
    }, Pt.prototype.__iterator = function (e, t) {
      var a = this._iter.__iterator(I, t);

      return new O(function () {
        var t = a.next();
        return t.done ? t : F(e, t.value, t.value, t);
      });
    }, t(Lt, q), Lt.prototype.entrySeq = function () {
      return this._iter.toSeq();
    }, Lt.prototype.__iterate = function (e, t) {
      var a = this;
      return this._iter.__iterate(function (t) {
        if (t) {
          Xt(t);
          var r = o(t);
          return e(r ? t.get(1) : t[1], r ? t.get(0) : t[0], a);
        }
      }, t);
    }, Lt.prototype.__iterator = function (e, t) {
      var a = this._iter.__iterator(I, t);

      return new O(function () {
        for (;;) {
          var t = a.next();
          if (t.done) return t;
          var r = t.value;

          if (r) {
            Xt(r);
            var n = o(r);
            return F(e, n ? r.get(0) : r[0], n ? r.get(1) : r[1], t);
          }
        }
      });
    }, Mt.prototype.cacheResult = Nt.prototype.cacheResult = Pt.prototype.cacheResult = Lt.prototype.cacheResult = ta, t(na, ge), na.prototype.toString = function () {
      return this.__toString(ia(this) + " {", "}");
    }, na.prototype.has = function (e) {
      return this._defaultValues.hasOwnProperty(e);
    }, na.prototype.get = function (e, t) {
      if (!this.has(e)) return t;
      var a = this._defaultValues[e];
      return this._map ? this._map.get(e, a) : a;
    }, na.prototype.clear = function () {
      if (this.__ownerID) return this._map && this._map.clear(), this;
      var e = this.constructor;
      return e._empty || (e._empty = oa(this, $e()));
    }, na.prototype.set = function (e, t) {
      if (!this.has(e)) throw new Error('Cannot set unknown key "' + e + '" on ' + ia(this));
      if (this._map && !this._map.has(e) && t === this._defaultValues[e]) return this;

      var a = this._map && this._map.set(e, t);

      return this.__ownerID || a === this._map ? this : oa(this, a);
    }, na.prototype.remove = function (e) {
      if (!this.has(e)) return this;

      var t = this._map && this._map.remove(e);

      return this.__ownerID || t === this._map ? this : oa(this, t);
    }, na.prototype.wasAltered = function () {
      return this._map.wasAltered();
    }, na.prototype.__iterator = function (e, t) {
      var a = this;
      return r(this._defaultValues).map(function (e, t) {
        return a.get(t);
      }).__iterator(e, t);
    }, na.prototype.__iterate = function (e, t) {
      var a = this;
      return r(this._defaultValues).map(function (e, t) {
        return a.get(t);
      }).__iterate(e, t);
    }, na.prototype.__ensureOwner = function (e) {
      if (e === this.__ownerID) return this;

      var t = this._map && this._map.__ensureOwner(e);

      return e ? oa(this, t, e) : (this.__ownerID = e, this._map = t, this);
    };
    var sa = na.prototype;

    function oa(e, t, a) {
      var r = Object.create(Object.getPrototypeOf(e));
      return r._map = t, r.__ownerID = a, r;
    }

    function ia(e) {
      return e._name || e.constructor.name || "Record";
    }

    function ca(e) {
      return null == e ? ba() : ua(e) && !d(e) ? e : ba().withMutations(function (t) {
        var a = s(e);
        Le(a.size), a.forEach(function (e) {
          return t.add(e);
        });
      });
    }

    function ua(e) {
      return !(!e || !e[fa]);
    }

    sa.delete = sa.remove, sa.deleteIn = sa.removeIn = Ve.removeIn, sa.merge = Ve.merge, sa.mergeWith = Ve.mergeWith, sa.mergeIn = Ve.mergeIn, sa.mergeDeep = Ve.mergeDeep, sa.mergeDeepWith = Ve.mergeDeepWith, sa.mergeDeepIn = Ve.mergeDeepIn, sa.setIn = Ve.setIn, sa.update = Ve.update, sa.updateIn = Ve.updateIn, sa.withMutations = Ve.withMutations, sa.asMutable = Ve.asMutable, sa.asImmutable = Ve.asImmutable, t(ca, we), ca.of = function () {
      return this(arguments);
    }, ca.fromKeys = function (e) {
      return this(r(e).keySeq());
    }, ca.prototype.toString = function () {
      return this.__toString("Set {", "}");
    }, ca.prototype.has = function (e) {
      return this._map.has(e);
    }, ca.prototype.add = function (e) {
      return ha(this, this._map.set(e, !0));
    }, ca.prototype.remove = function (e) {
      return ha(this, this._map.remove(e));
    }, ca.prototype.clear = function () {
      return ha(this, this._map.clear());
    }, ca.prototype.union = function () {
      var t = e.call(arguments, 0);
      return 0 === (t = t.filter(function (e) {
        return 0 !== e.size;
      })).length ? this : 0 !== this.size || this.__ownerID || 1 !== t.length ? this.withMutations(function (e) {
        for (var a = 0; a < t.length; a++) {
          s(t[a]).forEach(function (t) {
            return e.add(t);
          });
        }
      }) : this.constructor(t[0]);
    }, ca.prototype.intersect = function () {
      var t = e.call(arguments, 0);
      if (0 === t.length) return this;
      t = t.map(function (e) {
        return s(e);
      });
      var a = this;
      return this.withMutations(function (e) {
        a.forEach(function (a) {
          t.every(function (e) {
            return e.includes(a);
          }) || e.remove(a);
        });
      });
    }, ca.prototype.subtract = function () {
      var t = e.call(arguments, 0);
      if (0 === t.length) return this;
      t = t.map(function (e) {
        return s(e);
      });
      var a = this;
      return this.withMutations(function (e) {
        a.forEach(function (a) {
          t.some(function (e) {
            return e.includes(a);
          }) && e.remove(a);
        });
      });
    }, ca.prototype.merge = function () {
      return this.union.apply(this, arguments);
    }, ca.prototype.mergeWith = function (t) {
      var a = e.call(arguments, 1);
      return this.union.apply(this, a);
    }, ca.prototype.sort = function (e) {
      return ma(Kt(this, e));
    }, ca.prototype.sortBy = function (e, t) {
      return ma(Kt(this, t, e));
    }, ca.prototype.wasAltered = function () {
      return this._map.wasAltered();
    }, ca.prototype.__iterate = function (e, t) {
      var a = this;
      return this._map.__iterate(function (t, r) {
        return e(r, r, a);
      }, t);
    }, ca.prototype.__iterator = function (e, t) {
      return this._map.map(function (e, t) {
        return t;
      }).__iterator(e, t);
    }, ca.prototype.__ensureOwner = function (e) {
      if (e === this.__ownerID) return this;

      var t = this._map.__ensureOwner(e);

      return e ? this.__make(t, e) : (this.__ownerID = e, this._map = t, this);
    }, ca.isSet = ua;
    var da,
        fa = "@@__IMMUTABLE_SET__@@",
        la = ca.prototype;

    function ha(e, t) {
      return e.__ownerID ? (e.size = t.size, e._map = t, e) : t === e._map ? e : 0 === t.size ? e.__empty() : e.__make(t);
    }

    function pa(e, t) {
      var a = Object.create(la);
      return a.size = e ? e.size : 0, a._map = e, a.__ownerID = t, a;
    }

    function ba() {
      return da || (da = pa($e()));
    }

    function ma(e) {
      return null == e ? Aa() : ya(e) ? e : Aa().withMutations(function (t) {
        var a = s(e);
        Le(a.size), a.forEach(function (e) {
          return t.add(e);
        });
      });
    }

    function ya(e) {
      return ua(e) && d(e);
    }

    la[fa] = !0, la.delete = la.remove, la.mergeDeep = la.merge, la.mergeDeepWith = la.mergeWith, la.withMutations = Ve.withMutations, la.asMutable = Ve.asMutable, la.asImmutable = Ve.asImmutable, la.__empty = ba, la.__make = pa, t(ma, ca), ma.of = function () {
      return this(arguments);
    }, ma.fromKeys = function (e) {
      return this(r(e).keySeq());
    }, ma.prototype.toString = function () {
      return this.__toString("OrderedSet {", "}");
    }, ma.isOrderedSet = ya;
    var va,
        _a = ma.prototype;

    function ga(e, t) {
      var a = Object.create(_a);
      return a.size = e ? e.size : 0, a._map = e, a.__ownerID = t, a;
    }

    function Aa() {
      return va || (va = ga(Wt()));
    }

    function wa(e) {
      return null == e ? Ea() : Ta(e) ? e : Ea().unshiftAll(e);
    }

    function Ta(e) {
      return !(!e || !e[Da]);
    }

    _a[p] = !0, _a.__empty = Aa, _a.__make = ga, t(wa, Ae), wa.of = function () {
      return this(arguments);
    }, wa.prototype.toString = function () {
      return this.__toString("Stack [", "]");
    }, wa.prototype.get = function (e, t) {
      var a = this._head;

      for (e = C(this, e); a && e--;) {
        a = a.next;
      }

      return a ? a.value : t;
    }, wa.prototype.peek = function () {
      return this._head && this._head.value;
    }, wa.prototype.push = function () {
      if (0 === arguments.length) return this;

      for (var e = this.size + arguments.length, t = this._head, a = arguments.length - 1; a >= 0; a--) {
        t = {
          value: arguments[a],
          next: t
        };
      }

      return this.__ownerID ? (this.size = e, this._head = t, this.__hash = void 0, this.__altered = !0, this) : Sa(e, t);
    }, wa.prototype.pushAll = function (e) {
      if (0 === (e = n(e)).size) return this;
      Le(e.size);
      var t = this.size,
          a = this._head;
      return e.reverse().forEach(function (e) {
        t++, a = {
          value: e,
          next: a
        };
      }), this.__ownerID ? (this.size = t, this._head = a, this.__hash = void 0, this.__altered = !0, this) : Sa(t, a);
    }, wa.prototype.pop = function () {
      return this.slice(1);
    }, wa.prototype.unshift = function () {
      return this.push.apply(this, arguments);
    }, wa.prototype.unshiftAll = function (e) {
      return this.pushAll(e);
    }, wa.prototype.shift = function () {
      return this.pop.apply(this, arguments);
    }, wa.prototype.clear = function () {
      return 0 === this.size ? this : this.__ownerID ? (this.size = 0, this._head = void 0, this.__hash = void 0, this.__altered = !0, this) : Ea();
    }, wa.prototype.slice = function (e, t) {
      if (E(e, t, this.size)) return this;
      var a = B(e, this.size);
      if (k(t, this.size) !== this.size) return Ae.prototype.slice.call(this, e, t);

      for (var r = this.size - a, n = this._head; a--;) {
        n = n.next;
      }

      return this.__ownerID ? (this.size = r, this._head = n, this.__hash = void 0, this.__altered = !0, this) : Sa(r, n);
    }, wa.prototype.__ensureOwner = function (e) {
      return e === this.__ownerID ? this : e ? Sa(this.size, this._head, e, this.__hash) : (this.__ownerID = e, this.__altered = !1, this);
    }, wa.prototype.__iterate = function (e, t) {
      if (t) return this.reverse().__iterate(e);

      for (var a = 0, r = this._head; r && !1 !== e(r.value, a++, this);) {
        r = r.next;
      }

      return a;
    }, wa.prototype.__iterator = function (e, t) {
      if (t) return this.reverse().__iterator(e);
      var a = 0,
          r = this._head;
      return new O(function () {
        if (r) {
          var t = r.value;
          return r = r.next, F(e, a++, t);
        }

        return {
          value: void 0,
          done: !0
        };
      });
    }, wa.isStack = Ta;
    var xa,
        Da = "@@__IMMUTABLE_STACK__@@",
        Ca = wa.prototype;

    function Sa(e, t, a, r) {
      var n = Object.create(Ca);
      return n.size = e, n._head = t, n.__ownerID = a, n.__hash = r, n.__altered = !1, n;
    }

    function Ea() {
      return xa || (xa = Sa(0));
    }

    function Ba(e, t) {
      var a = function a(_a4) {
        e.prototype[_a4] = t[_a4];
      };

      return Object.keys(t).forEach(a), Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(t).forEach(a), e;
    }

    Ca[Da] = !0, Ca.withMutations = Ve.withMutations, Ca.asMutable = Ve.asMutable, Ca.asImmutable = Ve.asImmutable, Ca.wasAltered = Ve.wasAltered, a.Iterator = O, Ba(a, {
      toArray: function toArray() {
        Le(this.size);
        var e = new Array(this.size || 0);
        return this.valueSeq().__iterate(function (t, a) {
          e[a] = t;
        }), e;
      },
      toIndexedSeq: function toIndexedSeq() {
        return new Mt(this);
      },
      toJS: function toJS() {
        return this.toSeq().map(function (e) {
          return e && "function" == typeof e.toJS ? e.toJS() : e;
        }).__toJS();
      },
      toJSON: function toJSON() {
        return this.toSeq().map(function (e) {
          return e && "function" == typeof e.toJSON ? e.toJSON() : e;
        }).__toJS();
      },
      toKeyedSeq: function toKeyedSeq() {
        return new Nt(this, !0);
      },
      toMap: function toMap() {
        return Oe(this.toKeyedSeq());
      },
      toObject: function toObject() {
        Le(this.size);
        var e = {};
        return this.__iterate(function (t, a) {
          e[a] = t;
        }), e;
      },
      toOrderedMap: function toOrderedMap() {
        return Bt(this.toKeyedSeq());
      },
      toOrderedSet: function toOrderedSet() {
        return ma(i(this) ? this.valueSeq() : this);
      },
      toSet: function toSet() {
        return ca(i(this) ? this.valueSeq() : this);
      },
      toSetSeq: function toSetSeq() {
        return new Pt(this);
      },
      toSeq: function toSeq() {
        return c(this) ? this.toIndexedSeq() : i(this) ? this.toKeyedSeq() : this.toSetSeq();
      },
      toStack: function toStack() {
        return wa(i(this) ? this.valueSeq() : this);
      },
      toList: function toList() {
        return lt(i(this) ? this.valueSeq() : this);
      },
      toString: function toString() {
        return "[Iterable]";
      },
      __toString: function __toString(e, t) {
        return 0 === this.size ? e + t : e + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + t;
      },
      concat: function concat() {
        var t = e.call(arguments, 0);
        return Jt(this, Ht(this, t));
      },
      includes: function includes(e) {
        return this.some(function (t) {
          return pe(t, e);
        });
      },
      entries: function entries() {
        return this.__iterator(N);
      },
      every: function every(e, t) {
        Le(this.size);
        var a = !0;
        return this.__iterate(function (r, n, s) {
          if (!e.call(t, r, n, s)) return a = !1, !1;
        }), a;
      },
      filter: function filter(e, t) {
        return Jt(this, Gt(this, e, t, !0));
      },
      find: function find(e, t, a) {
        var r = this.findEntry(e, t);
        return r ? r[1] : a;
      },
      forEach: function forEach(e, t) {
        return Le(this.size), this.__iterate(t ? e.bind(t) : e);
      },
      join: function join(e) {
        Le(this.size), e = void 0 !== e ? "" + e : ",";
        var t = "",
            a = !0;
        return this.__iterate(function (r) {
          a ? a = !1 : t += e, t += null != r ? r.toString() : "";
        }), t;
      },
      keys: function keys() {
        return this.__iterator(W);
      },
      map: function map(e, t) {
        return Jt(this, Ft(this, e, t));
      },
      reduce: function reduce(e, t, a) {
        var r, n;
        return Le(this.size), arguments.length < 2 ? n = !0 : r = t, this.__iterate(function (t, s, o) {
          n ? (n = !1, r = t) : r = e.call(a, r, t, s, o);
        }), r;
      },
      reduceRight: function reduceRight(e, t, a) {
        var r = this.toKeyedSeq().reverse();
        return r.reduce.apply(r, arguments);
      },
      reverse: function reverse() {
        return Jt(this, jt(this, !0));
      },
      slice: function slice(e, t) {
        return Jt(this, Vt(this, e, t, !0));
      },
      some: function some(e, t) {
        return !this.every(Na(e), t);
      },
      sort: function sort(e) {
        return Jt(this, Kt(this, e));
      },
      values: function values() {
        return this.__iterator(I);
      },
      butLast: function butLast() {
        return this.slice(0, -1);
      },
      isEmpty: function isEmpty() {
        return void 0 !== this.size ? 0 === this.size : !this.some(function () {
          return !0;
        });
      },
      count: function count(e, t) {
        return D(e ? this.toSeq().filter(e, t) : this);
      },
      countBy: function countBy(e, t) {
        return function (e, t, a) {
          var r = Oe().asMutable();
          return e.__iterate(function (n, s) {
            r.update(t.call(a, n, s, e), 0, function (e) {
              return e + 1;
            });
          }), r.asImmutable();
        }(this, e, t);
      },
      equals: function equals(e) {
        return be(this, e);
      },
      entrySeq: function entrySeq() {
        var e = this;
        if (e._cache) return new ee(e._cache);
        var t = e.toSeq().map(Ia).toIndexedSeq();
        return t.fromEntrySeq = function () {
          return e.toSeq();
        }, t;
      },
      filterNot: function filterNot(e, t) {
        return this.filter(Na(e), t);
      },
      findEntry: function findEntry(e, t, a) {
        var r = a;
        return this.__iterate(function (a, n, s) {
          if (e.call(t, a, n, s)) return r = [n, a], !1;
        }), r;
      },
      findKey: function findKey(e, t) {
        var a = this.findEntry(e, t);
        return a && a[0];
      },
      findLast: function findLast(e, t, a) {
        return this.toKeyedSeq().reverse().find(e, t, a);
      },
      findLastEntry: function findLastEntry(e, t, a) {
        return this.toKeyedSeq().reverse().findEntry(e, t, a);
      },
      findLastKey: function findLastKey(e, t) {
        return this.toKeyedSeq().reverse().findKey(e, t);
      },
      first: function first() {
        return this.find(S);
      },
      flatMap: function flatMap(e, t) {
        return Jt(this, function (e, t, a) {
          var r = Qt(e);
          return e.toSeq().map(function (n, s) {
            return r(t.call(a, n, s, e));
          }).flatten(!0);
        }(this, e, t));
      },
      flatten: function flatten(e) {
        return Jt(this, zt(this, e, !0));
      },
      fromEntrySeq: function fromEntrySeq() {
        return new Lt(this);
      },
      get: function get(e, t) {
        return this.find(function (t, a) {
          return pe(a, e);
        }, void 0, t);
      },
      getIn: function getIn(e, t) {
        for (var a, r = this, n = ra(e); !(a = n.next()).done;) {
          var s = a.value;
          if ((r = r && r.get ? r.get(s, v) : v) === v) return t;
        }

        return r;
      },
      groupBy: function groupBy(e, t) {
        return function (e, t, a) {
          var r = i(e),
              n = (d(e) ? Bt() : Oe()).asMutable();

          e.__iterate(function (s, o) {
            n.update(t.call(a, s, o, e), function (e) {
              return (e = e || []).push(r ? [o, s] : s), e;
            });
          });

          var s = Qt(e);
          return n.map(function (t) {
            return Jt(e, s(t));
          });
        }(this, e, t);
      },
      has: function has(e) {
        return this.get(e, v) !== v;
      },
      hasIn: function hasIn(e) {
        return this.getIn(e, v) !== v;
      },
      isSubset: function isSubset(e) {
        return e = "function" == typeof e.includes ? e : a(e), this.every(function (t) {
          return e.includes(t);
        });
      },
      isSuperset: function isSuperset(e) {
        return (e = "function" == typeof e.isSubset ? e : a(e)).isSubset(this);
      },
      keyOf: function keyOf(e) {
        return this.findKey(function (t) {
          return pe(t, e);
        });
      },
      keySeq: function keySeq() {
        return this.toSeq().map(Wa).toIndexedSeq();
      },
      last: function last() {
        return this.toSeq().reverse().first();
      },
      lastKeyOf: function lastKeyOf(e) {
        return this.toKeyedSeq().reverse().keyOf(e);
      },
      max: function max(e) {
        return qt(this, e);
      },
      maxBy: function maxBy(e, t) {
        return qt(this, t, e);
      },
      min: function min(e) {
        return qt(this, e ? Ma(e) : Oa);
      },
      minBy: function minBy(e, t) {
        return qt(this, t ? Ma(t) : Oa, e);
      },
      rest: function rest() {
        return this.slice(1);
      },
      skip: function skip(e) {
        return this.slice(Math.max(0, e));
      },
      skipLast: function skipLast(e) {
        return Jt(this, this.toSeq().reverse().skip(e).reverse());
      },
      skipWhile: function skipWhile(e, t) {
        return Jt(this, Ut(this, e, t, !0));
      },
      skipUntil: function skipUntil(e, t) {
        return this.skipWhile(Na(e), t);
      },
      sortBy: function sortBy(e, t) {
        return Jt(this, Kt(this, t, e));
      },
      take: function take(e) {
        return this.slice(0, Math.max(0, e));
      },
      takeLast: function takeLast(e) {
        return Jt(this, this.toSeq().reverse().take(e).reverse());
      },
      takeWhile: function takeWhile(e, t) {
        return Jt(this, function (e, t, a) {
          var r = ea(e);
          return r.__iterateUncached = function (r, n) {
            var s = this;
            if (n) return this.cacheResult().__iterate(r, n);
            var o = 0;
            return e.__iterate(function (e, n, i) {
              return t.call(a, e, n, i) && ++o && r(e, n, s);
            }), o;
          }, r.__iteratorUncached = function (r, n) {
            var s = this;
            if (n) return this.cacheResult().__iterator(r, n);

            var o = e.__iterator(N, n),
                i = !0;

            return new O(function () {
              if (!i) return {
                value: void 0,
                done: !0
              };
              var e = o.next();
              if (e.done) return e;
              var n = e.value,
                  c = n[0],
                  u = n[1];
              return t.call(a, u, c, s) ? r === N ? e : F(r, c, u, e) : (i = !1, {
                value: void 0,
                done: !0
              });
            });
          }, r;
        }(this, e, t));
      },
      takeUntil: function takeUntil(e, t) {
        return this.takeWhile(Na(e), t);
      },
      valueSeq: function valueSeq() {
        return this.toIndexedSeq();
      },
      hashCode: function hashCode() {
        return this.__hash || (this.__hash = function (e) {
          if (e.size === 1 / 0) return 0;
          var t = d(e),
              a = i(e),
              r = t ? 1 : 0;
          return function (e, t) {
            return t = Te(t, 3432918353), t = Te(t << 15 | t >>> -15, 461845907), t = Te(t << 13 | t >>> -13, 5), t = Te((t = (t + 3864292196 | 0) ^ e) ^ t >>> 16, 2246822507), t = xe((t = Te(t ^ t >>> 13, 3266489909)) ^ t >>> 16);
          }(e.__iterate(a ? t ? function (e, t) {
            r = 31 * r + Fa(De(e), De(t)) | 0;
          } : function (e, t) {
            r = r + Fa(De(e), De(t)) | 0;
          } : t ? function (e) {
            r = 31 * r + De(e) | 0;
          } : function (e) {
            r = r + De(e) | 0;
          }), r);
        }(this));
      }
    });
    var ka = a.prototype;
    ka[f] = !0, ka[L] = ka.values, ka.__toJS = ka.toArray, ka.__toStringMapper = Pa, ka.inspect = ka.toSource = function () {
      return this.toString();
    }, ka.chain = ka.flatMap, ka.contains = ka.includes, Ba(r, {
      flip: function flip() {
        return Jt(this, Ot(this));
      },
      mapEntries: function mapEntries(e, t) {
        var a = this,
            r = 0;
        return Jt(this, this.toSeq().map(function (n, s) {
          return e.call(t, [s, n], r++, a);
        }).fromEntrySeq());
      },
      mapKeys: function mapKeys(e, t) {
        var a = this;
        return Jt(this, this.toSeq().flip().map(function (r, n) {
          return e.call(t, r, n, a);
        }).flip());
      }
    });
    var Ra = r.prototype;

    function Wa(e, t) {
      return t;
    }

    function Ia(e, t) {
      return [t, e];
    }

    function Na(e) {
      return function () {
        return !e.apply(this, arguments);
      };
    }

    function Ma(e) {
      return function () {
        return -e.apply(this, arguments);
      };
    }

    function Pa(e) {
      return "string" == typeof e ? JSON.stringify(e) : String(e);
    }

    function La() {
      return x(arguments);
    }

    function Oa(e, t) {
      return e < t ? 1 : e > t ? -1 : 0;
    }

    function Fa(e, t) {
      return e ^ t + 2654435769 + (e << 6) + (e >> 2) | 0;
    }

    return Ra[l] = !0, Ra[L] = ka.entries, Ra.__toJS = ka.toObject, Ra.__toStringMapper = function (e, t) {
      return JSON.stringify(t) + ": " + Pa(e);
    }, Ba(n, {
      toKeyedSeq: function toKeyedSeq() {
        return new Nt(this, !1);
      },
      filter: function filter(e, t) {
        return Jt(this, Gt(this, e, t, !1));
      },
      findIndex: function findIndex(e, t) {
        var a = this.findEntry(e, t);
        return a ? a[0] : -1;
      },
      indexOf: function indexOf(e) {
        var t = this.keyOf(e);
        return void 0 === t ? -1 : t;
      },
      lastIndexOf: function lastIndexOf(e) {
        var t = this.lastKeyOf(e);
        return void 0 === t ? -1 : t;
      },
      reverse: function reverse() {
        return Jt(this, jt(this, !1));
      },
      slice: function slice(e, t) {
        return Jt(this, Vt(this, e, t, !1));
      },
      splice: function splice(e, t) {
        var a = arguments.length;
        if (t = Math.max(0 | t, 0), 0 === a || 2 === a && !t) return this;
        e = B(e, e < 0 ? this.count() : this.size);
        var r = this.slice(0, e);
        return Jt(this, 1 === a ? r : r.concat(x(arguments, 2), this.slice(e + t)));
      },
      findLastIndex: function findLastIndex(e, t) {
        var a = this.findLastEntry(e, t);
        return a ? a[0] : -1;
      },
      first: function first() {
        return this.get(0);
      },
      flatten: function flatten(e) {
        return Jt(this, zt(this, e, !1));
      },
      get: function get(e, t) {
        return (e = C(this, e)) < 0 || this.size === 1 / 0 || void 0 !== this.size && e > this.size ? t : this.find(function (t, a) {
          return a === e;
        }, void 0, t);
      },
      has: function has(e) {
        return (e = C(this, e)) >= 0 && (void 0 !== this.size ? this.size === 1 / 0 || e < this.size : -1 !== this.indexOf(e));
      },
      interpose: function interpose(e) {
        return Jt(this, function (e, t) {
          var a = ea(e);
          return a.size = e.size && 2 * e.size - 1, a.__iterateUncached = function (a, r) {
            var n = this,
                s = 0;
            return e.__iterate(function (e, r) {
              return (!s || !1 !== a(t, s++, n)) && !1 !== a(e, s++, n);
            }, r), s;
          }, a.__iteratorUncached = function (a, r) {
            var n,
                s = e.__iterator(I, r),
                o = 0;

            return new O(function () {
              return (!n || o % 2) && (n = s.next()).done ? n : o % 2 ? F(a, o++, t) : F(a, o++, n.value, n);
            });
          }, a;
        }(this, e));
      },
      interleave: function interleave() {
        var e = [this].concat(x(arguments)),
            t = Zt(this.toSeq(), Y.of, e),
            a = t.flatten(!0);
        return t.size && (a.size = t.size * e.length), Jt(this, a);
      },
      keySeq: function keySeq() {
        return ve(0, this.size);
      },
      last: function last() {
        return this.get(-1);
      },
      skipWhile: function skipWhile(e, t) {
        return Jt(this, Ut(this, e, t, !1));
      },
      zip: function zip() {
        var e = [this].concat(x(arguments));
        return Jt(this, Zt(this, La, e));
      },
      zipWith: function zipWith(e) {
        var t = x(arguments);
        return t[0] = this, Jt(this, Zt(this, e, t));
      }
    }), n.prototype[h] = !0, n.prototype[p] = !0, Ba(s, {
      get: function get(e, t) {
        return this.has(e) ? e : t;
      },
      includes: function includes(e) {
        return this.has(e);
      },
      keySeq: function keySeq() {
        return this.valueSeq();
      }
    }), s.prototype.has = ka.includes, s.prototype.contains = s.prototype.includes, Ba(q, r.prototype), Ba(Y, n.prototype), Ba(Z, s.prototype), Ba(ge, r.prototype), Ba(Ae, n.prototype), Ba(we, s.prototype), {
      Iterable: a,
      Seq: K,
      Collection: _e,
      Map: Oe,
      OrderedMap: Bt,
      List: lt,
      Stack: wa,
      Set: ca,
      OrderedSet: ma,
      Record: na,
      Range: ve,
      Repeat: me,
      is: pe,
      fromJS: fe
    };
  }();
},
/*!*****************************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-blockstream/node_modules/uuid/lib/rng-browser.js ***!
  \*****************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  var a = "undefined" != typeof crypto && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && msCrypto.getRandomValues.bind(msCrypto);

  if (a) {
    var r = new Uint8Array(16);

    e.exports = function () {
      return a(r), r;
    };
  } else {
    var n = new Array(16);

    e.exports = function () {
      for (var e, t = 0; t < 16; t++) {
        0 == (3 & t) && (e = 4294967296 * Math.random()), n[t] = e >>> ((3 & t) << 3) & 255;
      }

      return n;
    };
  }
},
/*!*****************************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-blockstream/node_modules/uuid/lib/bytesToUuid.js ***!
  \*****************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  for (var a = [], r = 0; r < 256; ++r) {
    a[r] = (r + 256).toString(16).substr(1);
  }

  e.exports = function (e, t) {
    var r = t || 0,
        n = a;
    return n[e[r++]] + n[e[r++]] + n[e[r++]] + n[e[r++]] + "-" + n[e[r++]] + n[e[r++]] + "-" + n[e[r++]] + n[e[r++]] + "-" + n[e[r++]] + n[e[r++]] + "-" + n[e[r++]] + n[e[r++]] + n[e[r++]] + n[e[r++]] + n[e[r++]] + n[e[r++]];
  };
},
/*!*********************************************************!*\
  !*** ./node_modules/@0x/base-contract/lib/src/types.js ***!
  \*********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), function (e) {
    e.SubscriptionNotFound = "SUBSCRIPTION_NOT_FOUND", e.SubscriptionAlreadyPresent = "SUBSCRIPTION_ALREADY_PRESENT";
  }(t.SubscriptionErrors || (t.SubscriptionErrors = {}));
},
/*!*********************************!*\
  !*** ./node_modules/uuid/v4.js ***!
  \*********************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./lib/rng */
  774),
      n = a(
  /*! ./lib/bytesToUuid */
  775);

  e.exports = function (e, t, a) {
    var s = t && a || 0;
    "string" == typeof e && (t = "binary" === e ? new Array(16) : null, e = null);
    var o = (e = e || {}).random || (e.rng || r)();
    if (o[6] = 15 & o[6] | 64, o[8] = 63 & o[8] | 128, t) for (var i = 0; i < 16; ++i) {
      t[s + i] = o[i];
    }
    return t || n(o);
  };
},
/*!************************************************************************!*\
  !*** ./node_modules/ethereumjs-blockstream/output/source/utilities.js ***!
  \************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.parseHexInt = function (e) {
    var t = Number.parseInt(e, 16);
    if (!Number.isFinite(t)) throw new Error(e + " is not a hex encoded integer, parsing returned " + t + ".");
    return t;
  };
},
/*!**********************************************************************************!*\
  !*** ./node_modules/ethereumjs-blockstream/node_modules/uuid/lib/rng-browser.js ***!
  \**********************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  var a = "undefined" != typeof crypto && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && msCrypto.getRandomValues.bind(msCrypto);

  if (a) {
    var r = new Uint8Array(16);

    e.exports = function () {
      return a(r), r;
    };
  } else {
    var n = new Array(16);

    e.exports = function () {
      for (var e, t = 0; t < 16; t++) {
        0 == (3 & t) && (e = 4294967296 * Math.random()), n[t] = e >>> ((3 & t) << 3) & 255;
      }

      return n;
    };
  }
},
/*!**********************************************************************************!*\
  !*** ./node_modules/ethereumjs-blockstream/node_modules/uuid/lib/bytesToUuid.js ***!
  \**********************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  for (var a = [], r = 0; r < 256; ++r) {
    a[r] = (r + 256).toString(16).substr(1);
  }

  e.exports = function (e, t) {
    var r = t || 0,
        n = a;
    return n[e[r++]] + n[e[r++]] + n[e[r++]] + n[e[r++]] + "-" + n[e[r++]] + n[e[r++]] + "-" + n[e[r++]] + n[e[r++]] + "-" + n[e[r++]] + n[e[r++]] + "-" + n[e[r++]] + n[e[r++]] + n[e[r++]] + n[e[r++]] + n[e[r++]] + n[e[r++]];
  };
},
/*!**********************************************************************!*\
  !*** ./src/contract_wrappers/registries/feature_registry_wrapper.ts ***!
  \**********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r17,
      n = this && this.__extends || (_r17 = function r(e, t) {
    return (_r17 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r17(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      i = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var c = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      u = a(
  /*! @0x/json-schemas */
  2),
      d = i(a(
  /*! ../contract_wrapper */
  44)),
      f = i(a(
  /*! ../../utils/assert */
  15)),
      l = a(
  /*! ../../types */
  4),
      h = i(a(
  /*! ../../utils/functions_utils */
  40)),
      p = function (e) {
    function t(t, a) {
      var r = e.call(this, t, a) || this;
      return r.contractVersion = l.ContractVersion.V3_0_0, r.owner = function () {
        return s(r, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().owner.callAsync()];
            }
          });
        });
      }, r.getFeatureStatus = function (e) {
        return s(r, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, t.sent().getFeatureStatus.callAsync(e.nameKey)];
            }
          });
        });
      }, r.setFeatureStatus = function (e) {
        return s(r, void 0, void 0, function () {
          var t, a, r, n, s, i;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return a = (t = f.default).assert, n = (r = h.default).checksumAddressComparision, [4, this.owner()];

              case 1:
                return s = [o.sent()], [4, this.getCallerAddress(e.txData)];

              case 2:
                return a.apply(t, [n.apply(r, s.concat([o.sent()])), l.ErrorCode.Unauthorized, "From sender must be owner"]), [4, this.getFeatureStatus({
                  nameKey: e.nameKey
                })];

              case 3:
                return i = o.sent(), f.default.assert(i !== e.newStatus, l.ErrorCode.PreconditionRequired, "FeatureStatus must change"), [4, this.contract];

              case 4:
                return [2, o.sent().setFeatureStatus.sendTransactionAsync(e.nameKey, e.newStatus, e.txData, e.safetyFactor)];
            }
          });
        });
      }, r.getCustomModulesAllowedStatus = function () {
        return s(r, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().getFeatureStatus.callAsync(l.Feature.CustomModulesAllowed)];
            }
          });
        });
      }, r.getFreezeMintingAllowedStatus = function () {
        return s(r, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().getFeatureStatus.callAsync(l.Feature.FreezeMintingAllowed)];
            }
          });
        });
      }, r.subscribeAsync = function (e) {
        return s(r, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return f.default.doesBelongToStringEnum("eventName", e.eventName, c.FeatureRegistryEvents_3_0_0), f.default.doesConformToSchema("indexFilterValues", e.indexFilterValues, u.schemas.indexFilterValuesSchema), f.default.isFunction("callback", e.callback), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.subscribeInternal(t, e.eventName, e.indexFilterValues, e.callback, e.isVerbose)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, r.getLogsAsync = function (e) {
        return s(r, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return f.default.doesBelongToStringEnum("eventName", e.eventName, c.FeatureRegistryEvents_3_0_0), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.getLogsAsyncInternal(t, e.eventName, e.blockRange, e.indexFilterValues)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, r.contract = a, r;
    }

    return n(t, e), t;
  }(d.default);

  t.default = p;
},
/*!*********************************************************************!*\
  !*** ./src/contract_wrappers/registries/module_registry_wrapper.ts ***!
  \*********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r18,
      n = this && this.__extends || (_r18 = function r(e, t) {
    return (_r18 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r18(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      i = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var c = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      u = i(a(
  /*! lodash */
  0)),
      d = a(
  /*! @0x/json-schemas */
  2),
      f = i(a(
  /*! ../../utils/assert */
  15)),
      l = i(a(
  /*! ../contract_wrapper */
  44)),
      h = a(
  /*! ../../types */
  4),
      p = a(
  /*! ../../utils/convert */
  16),
      b = i(a(
  /*! ../../utils/functions_utils */
  40)),
      m = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a) || this;
      return n.contractVersion = h.ContractVersion.V3_0_0, n.securityTokenRegistryContract = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            return [2, this.contractFactory.getSecurityTokenRegistryContract()];
          });
        });
      }, n.featureRegistryContract = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            return [2, this.contractFactory.getFeatureRegistryContract()];
          });
        });
      }, n.moduleFactoryContract = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            return [2, this.contractFactory.getModuleFactoryContract(e)];
          });
        });
      }, n.isCompatibleModule = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, t.sent().isCompatibleModule.callAsync(e.moduleFactoryAddress, e.securityTokenAddress)];
            }
          });
        });
      }, n.registerModule = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return f.default.isETHAddressHex("moduleFactory", e.moduleFactory), [4, this.checkModuleNotPausedOrOwner()];

              case 1:
                return s.sent(), [4, this.checkModuleNotRegistered(e.moduleFactory)];

              case 2:
                return s.sent(), [4, this.getCallerAddress(e.txData)];

              case 3:
                return t = s.sent(), [4, this.owner()];

              case 4:
                return a = s.sent(), [4, this.featureRegistryContract()];

              case 5:
                return s.sent().getFeatureStatus.callAsync(h.Feature.CustomModulesAllowed) ? [4, this.moduleFactoryContract(e.moduleFactory)] : [3, 8];

              case 6:
                return [4, s.sent().owner.callAsync()];

              case 7:
                return r = s.sent(), f.default.assert(b.default.checksumAddressComparision(t, a) || b.default.checksumAddressComparision(t, r), h.ErrorCode.Unauthorized, "Calling address must be owner or factory owner with custom modules allowed feature status"), [3, 9];

              case 8:
                f.default.assert(b.default.checksumAddressComparision(t, a), h.ErrorCode.Unauthorized, "Calling address must be owner without custom modules allowed feature status"), s.label = 9;

              case 9:
                return [4, this.moduleFactoryContract(e.moduleFactory)];

              case 10:
                return [4, s.sent().getTypes.callAsync()];

              case 11:
                return (n = s.sent()).length > 1 && f.default.assert(n.length === new Set(n).size, h.ErrorCode.MismatchedArrayLength, "Type mismatch"), f.default.assert(n.length > 0, h.ErrorCode.InvalidData, "Factory must have type"), [4, this.contract];

              case 12:
                return [2, s.sent().registerModule.sendTransactionAsync(e.moduleFactory, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.removeModule = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return f.default.isETHAddressHex("moduleFactory", e.moduleFactory), [4, this.checkModuleNotPaused()];

              case 1:
                return t.sent(), [4, this.checkModuleRegistered(e.moduleFactory)];

              case 2:
                return t.sent(), [4, this.checkIsOwnerOrModuleFactoryOwner(e.moduleFactory)];

              case 3:
                return t.sent(), [4, this.contract];

              case 4:
                return [2, t.sent().removeModule.sendTransactionAsync(e.moduleFactory, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.verifyModule = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return f.default.isETHAddressHex("moduleFactory", e.moduleFactory), [4, this.checkMsgSenderIsOwner()];

              case 1:
                return t.sent(), [4, this.checkModuleRegistered(e.moduleFactory)];

              case 2:
                return t.sent(), [4, this.contract];

              case 3:
                return [2, t.sent().verifyModule.sendTransactionAsync(e.moduleFactory, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.unverifyModule = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return f.default.isETHAddressHex("moduleFactory", e.moduleFactory), [4, this.checkIsOwnerOrModuleFactoryOwner(e.moduleFactory)];

              case 1:
                return t.sent(), [4, this.checkModuleRegistered(e.moduleFactory)];

              case 2:
                return t.sent(), [4, this.contract];

              case 3:
                return [2, t.sent().unverifyModule.sendTransactionAsync(e.moduleFactory, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.getTagsByTypeAndToken = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return f.default.isETHAddressHex("securityToken", e.securityToken), [4, this.contract];

              case 1:
                return [4, s.sent().getTagsByTypeAndToken.callAsync(e.moduleType, e.securityToken)];

              case 2:
                return t = s.sent(), a = u.default.zip(t[0], t[1]), r = u.default.groupBy(a, function (e) {
                  return e[1];
                }), n = [], u.default.forEach(r, function (e, t) {
                  var a = u.default.unzip(e)[0],
                      r = {
                    module: t,
                    tags: p.bytes32ArrayToStringArray(a)
                  };
                  n.push(r);
                }), [2, n];
            }
          });
        });
      }, n.getTagsByType = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, s.sent().getTagsByType.callAsync(e.moduleType)];

              case 2:
                return t = s.sent(), a = u.default.zip(t[0], t[1]), r = u.default.groupBy(a, function (e) {
                  return e[1];
                }), n = [], u.default.forEach(r, function (e, t) {
                  var a = u.default.unzip(e)[0],
                      r = {
                    module: t,
                    tags: p.bytes32ArrayToStringArray(a)
                  };
                  n.push(r);
                }), [2, n];
            }
          });
        });
      }, n.getFactoryDetails = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, a.sent().getFactoryDetails.callAsync(e.factoryAddress)];

              case 2:
                return t = a.sent(), [2, {
                  isVerified: t[0],
                  ownerAddress: t[1],
                  securityTokenAddresses: t[2]
                }];
            }
          });
        });
      }, n.getModulesByType = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, t.sent().getModulesByType.callAsync(e.moduleType)];
            }
          });
        });
      }, n.getAllModulesByType = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, t.sent().getAllModulesByType.callAsync(e.moduleType)];
            }
          });
        });
      }, n.getModulesByTypeAndToken = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return f.default.isETHAddressHex("securityToken", e.securityToken), [4, this.contract];

              case 1:
                return [2, t.sent().getModulesByTypeAndToken.callAsync(e.moduleType, e.securityToken)];
            }
          });
        });
      }, n.reclaimERC20 = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return f.default.isNonZeroETHAddressHex("tokenContract", e.tokenContract), [4, this.checkMsgSenderIsOwner()];

              case 1:
                return t.sent(), [4, this.contract];

              case 2:
                return [2, t.sent().reclaimERC20.sendTransactionAsync(e.tokenContract, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.pause = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.checkMsgSenderIsOwner()];

              case 1:
                return r.sent(), a = (t = f.default).assert, [4, this.isPaused()];

              case 2:
                return a.apply(t, [!r.sent(), h.ErrorCode.ContractPaused, "Contract is paused"]), [4, this.contract];

              case 3:
                return [2, r.sent().pause.sendTransactionAsync(e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.unpause = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.checkMsgSenderIsOwner()];

              case 1:
                return r.sent(), a = (t = f.default).assert, [4, this.isPaused()];

              case 2:
                return a.apply(t, [r.sent(), h.ErrorCode.PreconditionRequired, "Contract is already not paused"]), [4, this.contract];

              case 3:
                return [2, r.sent().unpause.sendTransactionAsync(e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.updateFromRegistry = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.checkMsgSenderIsOwner()];

              case 1:
                return t.sent(), [4, this.contract];

              case 2:
                return [2, t.sent().updateFromRegistry.sendTransactionAsync(e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.transferOwnership = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return f.default.isNonZeroETHAddressHex("newOwner", e.newOwner), [4, this.checkMsgSenderIsOwner()];

              case 1:
                return t.sent(), [4, this.contract];

              case 2:
                return [2, t.sent().transferOwnership.sendTransactionAsync(e.newOwner, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.owner = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().owner.callAsync()];
            }
          });
        });
      }, n.isPaused = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().isPaused.callAsync()];
            }
          });
        });
      }, n.subscribeAsync = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return f.default.doesBelongToStringEnum("eventName", e.eventName, c.ModuleRegistryEvents_3_0_0), f.default.doesConformToSchema("indexFilterValues", e.indexFilterValues, d.schemas.indexFilterValuesSchema), f.default.isFunction("callback", e.callback), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.subscribeInternal(t, e.eventName, e.indexFilterValues, e.callback, e.isVerbose)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.getLogsAsync = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return f.default.doesBelongToStringEnum("eventName", e.eventName, c.ModuleRegistryEvents_3_0_0), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.getLogsAsyncInternal(t, e.eventName, e.blockRange, e.indexFilterValues)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.checkForRegisteredModule = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.getModulesByType({
                  moduleType: h.ModuleType.PermissionManager
                })];

              case 1:
                return a = [r.sent()], [4, this.getModulesByType({
                  moduleType: h.ModuleType.STO
                })];

              case 2:
                return a = a.concat([r.sent()]), [4, this.getModulesByType({
                  moduleType: h.ModuleType.Burn
                })];

              case 3:
                return a = a.concat([r.sent()]), [4, this.getModulesByType({
                  moduleType: h.ModuleType.Dividends
                })];

              case 4:
                return a = a.concat([r.sent()]), [4, this.getModulesByType({
                  moduleType: h.ModuleType.TransferManager
                })];

              case 5:
                return t = a.concat([r.sent()]), [4, Promise.all(t.map(function (t) {
                  return t.includes(e);
                }))];

              case 6:
                return [2, r.sent().includes(!0)];
            }
          });
        });
      }, n.callGetModulesByTypeAndReturnIfModuleExists = function (e, t) {
        return s(n, void 0, void 0, function () {
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.getModulesByType({
                  moduleType: e
                })];

              case 1:
                return [2, a.sent().includes(t)];
            }
          });
        });
      }, n.checkMsgSenderIsOwner = function () {
        return s(n, void 0, void 0, function () {
          var e, t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return t = (e = f.default).assert, r = (a = b.default).checksumAddressComparision, [4, this.owner()];

              case 1:
                return n = [s.sent()], [4, this.web3Wrapper.getAvailableAddressesAsync()];

              case 2:
                return t.apply(e, [r.apply(a, n.concat([s.sent()[0]])), h.ErrorCode.Unauthorized, "Msg sender must be owner"]), [2];
            }
          });
        });
      }, n.checkModuleRegistered = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.checkForRegisteredModule(e)];

              case 1:
                return a.apply(t, [r.sent(), h.ErrorCode.PreconditionRequired, "Module is not registered"]), [2];
            }
          });
        });
      }, n.checkModuleNotRegistered = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.checkForRegisteredModule(e)];

              case 1:
                return a.apply(t, [!r.sent(), h.ErrorCode.AlreadyExists, "Module is already registered"]), [2];
            }
          });
        });
      }, n.checkModuleNotPausedOrOwner = function () {
        return s(n, void 0, void 0, function () {
          var e, t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return t = (e = f.default).assert, [4, this.isPaused()];

              case 1:
                return (a = !o.sent()) ? [3, 4] : (n = (r = b.default).checksumAddressComparision, [4, this.owner()]);

              case 2:
                return s = [o.sent()], [4, this.getCallerAddress(void 0)];

              case 3:
                a = n.apply(r, s.concat([o.sent()])), o.label = 4;

              case 4:
                return t.apply(e, [a, h.ErrorCode.Unauthorized, "Contract is either paused or the calling address is not the owner"]), [2];
            }
          });
        });
      }, n.checkModuleNotPaused = function () {
        return s(n, void 0, void 0, function () {
          var e, t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return t = (e = f.default).assert, [4, this.isPaused()];

              case 1:
                return t.apply(e, [!a.sent(), h.ErrorCode.ContractPaused, "Contract is currently paused"]), [2];
            }
          });
        });
      }, n.checkIsOwnerOrModuleFactoryOwner = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, this.getCallerAddress(void 0)];

              case 1:
                return t = n.sent(), [4, this.owner()];

              case 2:
                return a = n.sent(), [4, this.moduleFactoryContract(e)];

              case 3:
                return [4, n.sent().owner.callAsync()];

              case 4:
                return r = n.sent(), f.default.assert(b.default.checksumAddressComparision(t, a) || b.default.checksumAddressComparision(t, r), h.ErrorCode.Unauthorized, "Calling address must be owner or factory owner "), [2];
            }
          });
        });
      }, n.contract = a, n.contractFactory = r, n;
    }

    return n(t, e), t;
  }(l.default);

  t.default = m;
},
/*!************************************************************!*\
  !*** ./src/contract_wrappers/tokens/poly_token_wrapper.ts ***!
  \************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r19,
      n = this && this.__extends || (_r19 = function r(e, t) {
    return (_r19 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r19(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      i = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var c = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      u = a(
  /*! @0x/json-schemas */
  2),
      d = a(
  /*! ../../types */
  4),
      f = i(a(
  /*! ../../utils/assert */
  15)),
      l = i(a(
  /*! ./erc20_wrapper */
  142)),
      h = a(
  /*! ../../utils/convert */
  16),
      p = function (e) {
    function t(t, a) {
      var r = e.call(this, t, a) || this;
      return r.contractVersion = d.ContractVersion.V3_0_0, r.increaseApproval = function (e) {
        return s(r, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return f.default.isETHAddressHex("spender", e.spender), [4, this.contract];

              case 1:
                return a = (t = o.sent().increaseApproval).sendTransactionAsync, r = [e.spender], n = h.valueToWei, s = [e.value], [4, this.decimals()];

              case 2:
                return [2, a.apply(t, r.concat([n.apply(void 0, s.concat([o.sent()])), e.txData, e.safetyFactor]))];
            }
          });
        });
      }, r.decreaseApproval = function (e) {
        return s(r, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return f.default.isETHAddressHex("spender", e.spender), [4, this.contract];

              case 1:
                return a = (t = o.sent().decreaseApproval).sendTransactionAsync, r = [e.spender], n = h.valueToWei, s = [e.value], [4, this.decimals()];

              case 2:
                return [2, a.apply(t, r.concat([n.apply(void 0, s.concat([o.sent()])), e.txData, e.safetyFactor]))];
            }
          });
        });
      }, r.decimalFactor = function () {
        return s(r, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().decimalFactor.callAsync()];
            }
          });
        });
      }, r.subscribeAsync = function (e) {
        return s(r, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return f.default.doesBelongToStringEnum("eventName", e.eventName, c.PolyTokenEvents_3_0_0), f.default.doesConformToSchema("indexFilterValues", e.indexFilterValues, u.schemas.indexFilterValuesSchema), f.default.isFunction("callback", e.callback), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.subscribeInternal(t, e.eventName, e.indexFilterValues, e.callback, e.isVerbose)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, r.getLogsAsync = function (e) {
        return s(r, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return f.default.doesBelongToStringEnum("eventName", e.eventName, c.PolyTokenEvents_3_0_0), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.getLogsAsyncInternal(t, e.eventName, e.blockRange, e.indexFilterValues)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, r.contract = a, r;
    }

    return n(t, e), t;
  }(l.default);

  t.default = p;
},
/*!***********************************************************************!*\
  !*** ./src/contract_wrappers/registries/polymath_registry_wrapper.ts ***!
  \***********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r20,
      n = this && this.__extends || (_r20 = function r(e, t) {
    return (_r20 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r20(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      i = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var c = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      u = a(
  /*! @0x/json-schemas */
  2),
      d = i(a(
  /*! ../../utils/assert */
  15)),
      f = i(a(
  /*! ../contract_wrapper */
  44)),
      l = a(
  /*! ../../types */
  4),
      h = i(a(
  /*! ../../utils/functions_utils */
  40)),
      p = function (e) {
    function t(t, a) {
      var r = e.call(this, t, a) || this;
      return r.contractVersion = l.ContractVersion.V3_0_0, r.owner = function () {
        return s(r, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().owner.callAsync()];
            }
          });
        });
      }, r.getAddress = function (e) {
        return s(r, void 0, void 0, function () {
          return o(this, function (t) {
            return [2, this.getAddressInternal(e.contractName)];
          });
        });
      }, r.getPolyTokenAddress = function () {
        return s(r, void 0, void 0, function () {
          return o(this, function (e) {
            return [2, this.getAddressInternal(l.PolymathContract.PolyToken)];
          });
        });
      }, r.getModuleRegistryAddress = function () {
        return s(r, void 0, void 0, function () {
          return o(this, function (e) {
            return [2, this.getAddressInternal(l.PolymathContract.ModuleRegistry)];
          });
        });
      }, r.getFeatureRegistryAddress = function () {
        return s(r, void 0, void 0, function () {
          return o(this, function (e) {
            return [2, this.getAddressInternal(l.PolymathContract.FeatureRegistry)];
          });
        });
      }, r.getSecurityTokenRegistryAddress = function () {
        return s(r, void 0, void 0, function () {
          return o(this, function (e) {
            return [2, this.getAddressInternal(l.PolymathContract.SecurityTokenRegistry)];
          });
        });
      }, r.getPolyUsdOracleAddress = function () {
        return s(r, void 0, void 0, function () {
          return o(this, function (e) {
            return [2, this.getAddressInternal(l.PolymathContract.PolyUsdOracle)];
          });
        });
      }, r.getEthUsdOracleAddress = function () {
        return s(r, void 0, void 0, function () {
          return o(this, function (e) {
            return [2, this.getAddressInternal(l.PolymathContract.EthUsdOracle)];
          });
        });
      }, r.changeAddress = function (e) {
        return s(r, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return a = (t = d.default).assert, n = (r = h.default).checksumAddressComparision, [4, this.owner()];

              case 1:
                return s = [o.sent()], [4, this.getCallerAddress(e.txData)];

              case 2:
                return a.apply(t, [n.apply(r, s.concat([o.sent()])), l.ErrorCode.Unauthorized, "Form sender must be owner"]), d.default.isETHAddressHex("newAddress", e.newAddress), [4, this.contract];

              case 3:
                return [2, o.sent().changeAddress.sendTransactionAsync(e.nameKey, e.newAddress, e.txData, e.safetyFactor)];
            }
          });
        });
      }, r.subscribeAsync = function (e) {
        return s(r, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return d.default.doesBelongToStringEnum("eventName", e.eventName, c.PolymathRegistryEvents_3_0_0), d.default.doesConformToSchema("indexFilterValues", e.indexFilterValues, u.schemas.indexFilterValuesSchema), d.default.isFunction("callback", e.callback), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.subscribeInternal(t, e.eventName, e.indexFilterValues, e.callback, e.isVerbose)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, r.getLogsAsync = function (e) {
        return s(r, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return d.default.doesBelongToStringEnum("eventName", e.eventName, c.PolymathRegistryEvents_3_0_0), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.getLogsAsyncInternal(t, e.eventName, e.blockRange, e.indexFilterValues)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, r.contract = a, r;
    }

    return n(t, e), t.prototype.getAddressInternal = function (e) {
      return s(this, void 0, void 0, function () {
        return o(this, function (t) {
          switch (t.label) {
            case 0:
              return [4, this.contract];

            case 1:
              return [2, t.sent().getAddress.callAsync(e)];
          }
        });
      });
    }, t;
  }(f.default);

  t.default = p;
},
/*!*****************************************************************************!*\
  !*** ./src/contract_wrappers/registries/security_token_registry_wrapper.ts ***!
  \*****************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r21,
      n = this && this.__extends || (_r21 = function r(e, t) {
    return (_r21 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r21(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      i = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var c = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      u = a(
  /*! @0x/json-schemas */
  2),
      d = i(a(
  /*! ../../utils/assert */
  15)),
      f = i(a(
  /*! ../contract_wrapper */
  44)),
      l = a(
  /*! ../../types */
  4),
      h = a(
  /*! ../../utils/convert */
  16),
      p = i(a(
  /*! ../../utils/functions_utils */
  40)),
      b = new c.BigNumber(0),
      m = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a) || this;
      return n.contractVersion = l.ContractVersion.V3_0_0, n.securityTokenContract = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            return [2, this.contractFactory.getSecurityTokenContract(e)];
          });
        });
      }, n.polyTokenContract = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            return [2, this.contractFactory.getPolyTokenContract()];
          });
        });
      }, n.getTickersByOwner = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return void 0 === e || void 0 === e.owner ? [3, 1] : (a = e.owner, [3, 3]);

              case 1:
                return [4, this.getDefaultFromAddress()];

              case 2:
                a = n.sent(), n.label = 3;

              case 3:
                return t = a, d.default.isETHAddressHex("owner", t), [4, this.contract];

              case 4:
                return [4, n.sent().getTickersByOwner.callAsync(t)];

              case 5:
                return r = n.sent(), [2, h.bytes32ArrayToStringArray(r)];
            }
          });
        });
      }, n.getSecurityTokenData = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return d.default.isETHAddressHex("securityTokenAddress", e.securityTokenAddress), [4, this.contract];

              case 1:
                return [4, a.sent().getSecurityTokenData.callAsync(e.securityTokenAddress)];

              case 2:
                return t = a.sent(), [2, {
                  ticker: t[0],
                  owner: t[1],
                  tokenDetails: t[2],
                  deployedAt: h.bigNumberToDate(t[3])
                }];
            }
          });
        });
      }, n.getIsFeeInPoly = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, e.sent().getIsFeeInPoly.callAsync()];

              case 2:
                return [2, e.sent()];
            }
          });
        });
      }, n.changeFeesAmountAndCurrency = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.getIsFeeInPoly()];

              case 1:
                return t = a.sent(), d.default.assert(t !== e.isFeeInPoly, l.ErrorCode.PreconditionRequired, "Currency unchanged"), [4, this.contract];

              case 2:
                return [2, a.sent().changeFeesAmountAndCurrency.sendTransactionAsync(h.valueToWei(e.tickerRegFee, l.FULL_DECIMALS), h.valueToWei(e.stLaunchFee, l.FULL_DECIMALS), e.isFeeInPoly, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.refreshSecurityToken = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, this.checkWhenNotPausedOrOwner()];

              case 1:
                return n.sent(), d.default.assert(e.name.length > 0, l.ErrorCode.InvalidData, "Name cannot be an empty string"), d.default.assert(e.ticker.length > 0, l.ErrorCode.InvalidData, "Ticker cannot be an empty string"), d.default.isNonZeroETHAddressHex("treasuryWallet", e.treasuryWallet), [4, this.getTickerDetails({
                  ticker: e.ticker
                })];

              case 2:
                return t = n.sent(), d.default.assert(t.status, l.ErrorCode.NotFound, "Not deployed"), r = this.securityTokenContract, [4, this.getSecurityTokenAddress({
                  ticker: e.ticker
                })];

              case 3:
                return [4, r.apply(this, [n.sent()])];

              case 4:
                return [4, n.sent().transfersFrozen.callAsync()];

              case 5:
                return a = n.sent(), d.default.assert(a, l.ErrorCode.PreconditionRequired, "Transfers not frozen"), [4, this.contract];

              case 6:
                return [2, n.sent().refreshSecurityToken.sendTransactionAsync(e.name, e.ticker, e.tokenDetails, e.divisible, e.treasuryWallet, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.removeProtocolFactory = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s, i;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return [4, this.checkOnlyOwner()];

              case 1:
                return o.sent(), [4, this.getLatestProtocolVersion()];

              case 2:
                return t = o.sent(), d.default.isValidVersion(e.version), a = e.version.split("."), r = new c.BigNumber(a[0]), n = new c.BigNumber(a[1]), s = new c.BigNumber(a[2]), i = [r, n, s], d.default.assert(JSON.stringify(t) === JSON.stringify(i), l.ErrorCode.PreconditionRequired, "Cannot remove latestVersion"), [4, this.contract];

              case 3:
                return [2, o.sent().removeProtocolFactory.sendTransactionAsync(r, n, s, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.getTokensByDelegate = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, t.sent().getTokensByDelegate.callAsync(e)];
            }
          });
        });
      }, n.getSTFactoryAddressOfVersion = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return d.default.isValidVersion(e.version), t = e.version.split("."), a = h.packVersion(t[0], t[1], t[2]), [4, this.contract];

              case 1:
                return [4, r.sent().getSTFactoryAddressOfVersion.callAsync(new c.BigNumber(a))];

              case 2:
                return [2, r.sent()];
            }
          });
        });
      }, n.getTokensByOwner = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return void 0 === e || void 0 === e.owner ? [3, 1] : (a = e.owner, [3, 3]);

              case 1:
                return [4, this.getDefaultFromAddress()];

              case 2:
                a = r.sent(), r.label = 3;

              case 3:
                return t = a, d.default.isETHAddressHex("ownerAddress", t), [4, this.contract];

              case 4:
                return [2, r.sent().getTokensByOwner.callAsync(t)];
            }
          });
        });
      }, n.generateNewSecurityToken = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s, i, u, f;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return d.default.assert(e.ticker.length > 0, l.ErrorCode.InvalidData, "Ticker cannot be an empty string"), d.default.assert(e.name.length > 0, l.ErrorCode.InvalidData, "Name cannot be an empty string"), d.default.isNonZeroETHAddressHex("treasuryWallet", e.treasuryWallet), [4, this.checkWhenNotPausedOrOwner()];

              case 1:
                return o.sent(), [4, this.getTickerDetails({
                  ticker: e.ticker
                })];

              case 2:
                return t = o.sent(), d.default.assert(!t.status, l.ErrorCode.AlreadyExists, "Ticker already deployed"), [4, this.web3Wrapper.getAvailableAddressesAsync()];

              case 3:
                return a = o.sent()[0], d.default.assert(p.default.checksumAddressComparision(a, t.owner), l.ErrorCode.Unauthorized, "Not authorised"), d.default.assert(t.expiryDate.getTime() >= Date.now(), l.ErrorCode.TickerExpired, "Ticker reservation is expired"), [4, this.getSecurityTokenLaunchFee()];

              case 4:
                return (r = o.sent()).isGreaterThan(b) ? (s = h.weiToValue, [4, this.polyTokenContract()]) : [3, 7];

              case 5:
                return [4, o.sent().balanceOf.callAsync(a)];

              case 6:
                n = s.apply(void 0, [o.sent(), l.FULL_DECIMALS]), d.default.assert(n.isGreaterThanOrEqualTo(r), l.ErrorCode.InsufficientBalance, "Insufficient poly token balance"), o.label = 7;

              case 7:
                return i = e.protocolVersion, u = new c.BigNumber(0), "0" !== i && (d.default.isValidVersion(i), f = i.split("."), u = new c.BigNumber(h.packVersion(f[0], f[1], f[3]))), [4, this.contract];

              case 8:
                return [2, o.sent().generateNewSecurityToken.sendTransactionAsync(e.name, e.ticker, e.tokenDetails, e.divisible, e.treasuryWallet, u, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.registerNewTicker = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.checkWhenNotPausedOrOwner()];

              case 1:
                return r.sent(), void 0 === e.owner ? [3, 2] : (a = e.owner, [3, 4]);

              case 2:
                return [4, this.getDefaultFromAddress()];

              case 3:
                a = r.sent(), r.label = 4;

              case 4:
                return t = a, [4, this.checkRegisterTickerRequirements(e.ticker, t)];

              case 5:
                return r.sent(), [4, this.contract];

              case 6:
                return [2, r.sent().registerNewTicker.sendTransactionAsync(e.owner, e.ticker, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.modifyExistingTicker = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.checkOnlyOwner()];

              case 1:
                return a.sent(), d.default.assert(e.ticker.length > 0 && e.ticker.length <= 10, l.ErrorCode.InvalidData, "Bad ticker"), d.default.assert(e.expiryDate.getTime() > new Date(0).getTime(), l.ErrorCode.TooEarly, "Bad expiry date"), d.default.assert(e.registrationDate.getTime() > new Date(0).getTime(), l.ErrorCode.TooEarly, "Bad registration date"), d.default.isNonZeroETHAddressHex("owner", e.owner), e.status ? [4, this.getSecurityTokenAddress({
                  ticker: e.ticker
                })] : [3, 3];

              case 2:
                t = a.sent(), d.default.isNonZeroETHAddressHex("address", t), a.label = 3;

              case 3:
                return [4, this.contract];

              case 4:
                return [2, a.sent().modifyExistingTicker.sendTransactionAsync(e.owner, e.ticker, h.dateToBigNumber(e.registrationDate), h.dateToBigNumber(e.expiryDate), e.status, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.modifyExistingSecurityToken = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.checkModifyST(e.ticker, e.deployedAt, e.owner, e.securityToken)];

              case 1:
                return t.sent(), [4, this.contract];

              case 2:
                return [2, t.sent().modifyExistingSecurityToken.sendTransactionAsync(e.ticker, e.owner, e.securityToken, e.tokenDetails, h.dateToBigNumber(e.deployedAt), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.getTickerDetails = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            return [2, this.getTickerDetailsInternal(e.ticker)];
          });
        });
      }, n.getTickerRegistrationFee = function () {
        return s(n, void 0, void 0, function () {
          var e;
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return e = h.weiToValue, [4, this.contract];

              case 1:
                return [4, t.sent().getTickerRegistrationFee.callAsync()];

              case 2:
                return [2, e.apply(void 0, [t.sent(), l.FULL_DECIMALS])];
            }
          });
        });
      }, n.registerTicker = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.checkWhenNotPausedOrOwner()];

              case 1:
                return r.sent(), void 0 === e.owner ? [3, 2] : (a = e.owner, [3, 4]);

              case 2:
                return [4, this.getDefaultFromAddress()];

              case 3:
                a = r.sent(), r.label = 4;

              case 4:
                return t = a, [4, this.checkRegisterTickerRequirements(e.ticker, t)];

              case 5:
                return r.sent(), [4, this.contract];

              case 6:
                return [2, r.sent().registerTicker.sendTransactionAsync(t, e.ticker, e.tokenName, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.transferTickerOwnership = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return d.default.isNonZeroETHAddressHex("newOwner", e.newOwner), [4, this.checkWhenNotPausedOrOwner()];

              case 1:
                return s.sent(), [4, this.getTickerDetails({
                  ticker: e.ticker
                })];

              case 2:
                return t = s.sent(), [4, this.getCallerAddress(e.txData)];

              case 3:
                return a = s.sent(), d.default.assert(p.default.checksumAddressComparision(a, t.owner), l.ErrorCode.Unauthorized, "Not authorised"), t.status ? (n = this.securityTokenContract, [4, this.getSecurityTokenAddress({
                  ticker: e.ticker
                })]) : [3, 7];

              case 4:
                return [4, n.apply(this, [s.sent()])];

              case 5:
                return [4, s.sent().owner.callAsync()];

              case 6:
                r = s.sent(), d.default.assert(r === e.newOwner, l.ErrorCode.PreconditionRequired, "New owner does not match token owner"), s.label = 7;

              case 7:
                return [4, this.contract];

              case 8:
                return [2, s.sent().transferTickerOwnership.sendTransactionAsync(e.newOwner, e.ticker, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.generateSecurityToken = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return d.default.assert(e.ticker.length > 0, l.ErrorCode.InvalidData, "Ticker cannot be an empty string"), d.default.assert(e.name.length > 0, l.ErrorCode.InvalidData, "Name cannot be an empty string"), [4, this.checkWhenNotPausedOrOwner()];

              case 1:
                return o.sent(), [4, this.getTickerDetails({
                  ticker: e.ticker
                })];

              case 2:
                return t = o.sent(), d.default.assert(!t.status, l.ErrorCode.AlreadyExists, "Ticker already deployed"), [4, this.web3Wrapper.getAvailableAddressesAsync()];

              case 3:
                return a = o.sent()[0], d.default.assert(p.default.checksumAddressComparision(a, t.owner), l.ErrorCode.Unauthorized, "Not authorised"), d.default.assert(t.expiryDate.getTime() >= Date.now(), l.ErrorCode.TooEarly, "Ticker gets expired"), [4, this.getSecurityTokenLaunchFee()];

              case 4:
                return (r = o.sent()).isGreaterThan(b) ? (s = h.weiToValue, [4, this.polyTokenContract()]) : [3, 7];

              case 5:
                return [4, o.sent().balanceOf.callAsync(a)];

              case 6:
                n = s.apply(void 0, [o.sent(), l.FULL_DECIMALS]), d.default.assert(n.isGreaterThanOrEqualTo(r), l.ErrorCode.InsufficientBalance, "Insufficient Poly token allowance"), o.label = 7;

              case 7:
                return [4, this.contract];

              case 8:
                return [2, o.sent().generateSecurityToken.sendTransactionAsync(e.name, e.ticker, e.details, e.divisible, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.getSecurityTokenLaunchFee = function () {
        return s(n, void 0, void 0, function () {
          var e;
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return e = h.weiToValue, [4, this.contract];

              case 1:
                return [4, t.sent().getSecurityTokenLaunchFee.callAsync()];

              case 2:
                return [2, e.apply(void 0, [t.sent(), l.FULL_DECIMALS])];
            }
          });
        });
      }, n.getSecurityTokenAddress = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, t.sent().getSecurityTokenAddress.callAsync(e.ticker)];
            }
          });
        });
      }, n.tickerAvailable = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return d.default.assert(e.ticker.length > 0 && e.ticker.length <= 10, l.ErrorCode.InvalidLength, "Ticker must be 1 to 10 characters long"), [4, this.contract];

              case 1:
                return [2, t.sent().tickerAvailable.callAsync(e.ticker.toUpperCase())];
            }
          });
        });
      }, n.isTickerRegisteredByCurrentIssuer = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.getTickerDetailsInternal(e.ticker)];

              case 1:
                return t = r.sent(), [4, this.tickerAvailable({
                  ticker: e.ticker
                })];

              case 2:
                return r.sent() ? [2, !1] : (a = t.owner, [4, this.getDefaultFromAddress()]);

              case 3:
                return [2, a === r.sent()];
            }
          });
        });
      }, n.isTokenLaunched = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.getTickerDetailsInternal(e.ticker)];

              case 1:
                return [2, t.sent().status];
            }
          });
        });
      }, n.modifyTicker = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return d.default.assert(e.ticker.length > 0, l.ErrorCode.InvalidData, "Ticker cannot be an empty string"), d.default.assert(e.ticker.length <= 10, l.ErrorCode.InvalidData, "Ticker length can not be greater than 10"), [4, this.checkOnlyOwner()];

              case 1:
                return a.sent(), d.default.assert(e.registrationDate.getTime() <= e.expiryDate.getTime(), l.ErrorCode.TooLate, "Registration date should < expiry date"), d.default.isETHAddressHex("owner", e.owner), e.status ? [4, this.getSecurityTokenAddress({
                  ticker: e.ticker
                })] : [3, 3];

              case 2:
                t = a.sent(), d.default.isNonZeroETHAddressHex("address", t), a.label = 3;

              case 3:
                return [4, this.contract];

              case 4:
                return [2, a.sent().modifyTicker.sendTransactionAsync(e.owner, e.ticker, e.tokenName, h.dateToBigNumber(e.registrationDate), h.dateToBigNumber(e.expiryDate), e.status, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.removeTicker = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.checkOnlyOwner()];

              case 1:
                return a.sent(), [4, this.getTickerDetails({
                  ticker: e.ticker
                })];

              case 2:
                return t = a.sent(), d.default.isNonZeroETHAddressHex("owner", t.owner), [4, this.contract];

              case 3:
                return [2, a.sent().removeTicker.sendTransactionAsync(e.ticker, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.changeExpiryLimit = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.checkOnlyOwner()];

              case 1:
                return t.sent(), d.default.assert(e.newExpiry.toNumber() >= 86400, l.ErrorCode.TooEarly, "Expiry should >= 1 day"), [4, this.contract];

              case 2:
                return [2, t.sent().changeExpiryLimit.sendTransactionAsync(e.newExpiry, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.modifySecurityToken = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.checkModifyST(e.ticker, e.deployedAt, e.owner, e.securityToken)];

              case 1:
                return t.sent(), [4, this.contract];

              case 2:
                return [2, t.sent().modifySecurityToken.sendTransactionAsync(e.name, e.ticker, e.owner, e.securityToken, e.tokenDetails, h.dateToBigNumber(e.deployedAt), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.isSecurityToken = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return d.default.isETHAddressHex("securityTokenAddress", e.securityTokenAddress), [4, this.contract];

              case 1:
                return [2, t.sent().isSecurityToken.callAsync(e.securityTokenAddress)];
            }
          });
        });
      }, n.transferOwnership = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.checkOnlyOwner()];

              case 1:
                return t.sent(), d.default.isNonZeroETHAddressHex("newOwner", e.newOwner), [4, this.contract];

              case 2:
                return [2, t.sent().transferOwnership.sendTransactionAsync(e.newOwner, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.pause = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isPaused()];

              case 1:
                return a.apply(t, [!r.sent(), l.ErrorCode.ContractPaused, "Contract is paused"]), [4, this.checkOnlyOwner()];

              case 2:
                return r.sent(), [4, this.contract];

              case 3:
                return [2, r.sent().pause.sendTransactionAsync(e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.unpause = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isPaused()];

              case 1:
                return a.apply(t, [r.sent(), l.ErrorCode.PreconditionRequired, "Contract is already not paused"]), [4, this.checkOnlyOwner()];

              case 2:
                return r.sent(), [4, this.contract];

              case 3:
                return [2, r.sent().unpause.sendTransactionAsync(e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.changeTickerRegistrationFee = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.checkOnlyOwner()];

              case 1:
                return a.sent(), [4, this.getTickerRegistrationFee()];

              case 2:
                return t = a.sent(), d.default.assert(!t.eq(e.newFee), l.ErrorCode.PreconditionRequired, "Fee not changed"), [4, this.contract];

              case 3:
                return [2, a.sent().changeTickerRegistrationFee.sendTransactionAsync(h.valueToWei(e.newFee, l.FULL_DECIMALS), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.changeSecurityLaunchFee = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.checkOnlyOwner()];

              case 1:
                return a.sent(), [4, this.getSecurityTokenLaunchFee()];

              case 2:
                return t = a.sent(), d.default.assert(!t.eq(e.newFee), l.ErrorCode.PreconditionRequired, "Fee not changed"), [4, this.contract];

              case 3:
                return [2, a.sent().changeSecurityLaunchFee.sendTransactionAsync(h.valueToWei(e.newFee, l.FULL_DECIMALS), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.reclaimERC20 = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.checkOnlyOwner()];

              case 1:
                return t.sent(), d.default.isNonZeroETHAddressHex("tokenContract", e.tokenContract), [4, this.contract];

              case 2:
                return [2, t.sent().reclaimERC20.sendTransactionAsync(e.tokenContract, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.setProtocolFactory = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return [4, this.checkOnlyOwner()];

              case 1:
                return s.sent(), d.default.isValidVersion(e.version), d.default.isNonZeroETHAddressHex("STFactoryAddress", e.STFactoryAddress), t = e.version.split("."), a = new c.BigNumber(t[0]), r = new c.BigNumber(t[1]), n = new c.BigNumber(t[2]), [4, this.contract];

              case 2:
                return [2, s.sent().setProtocolFactory.sendTransactionAsync(e.STFactoryAddress, a, r, n, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.getSTFactoryAddress = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().getSTFactoryAddress.callAsync()];
            }
          });
        });
      }, n.getLatestProtocolVersion = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().getLatestProtocolVersion.callAsync()];
            }
          });
        });
      }, n.updateFromRegistry = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.checkOnlyOwner()];

              case 1:
                return t.sent(), [4, this.contract];

              case 2:
                return [2, t.sent().updateFromRegistry.sendTransactionAsync(e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.getExpiryLimit = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().getExpiryLimit.callAsync()];
            }
          });
        });
      }, n.isPaused = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().isPaused.callAsync()];
            }
          });
        });
      }, n.owner = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().owner.callAsync()];
            }
          });
        });
      }, n.getTokens = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().getTokens.callAsync()];
            }
          });
        });
      }, n.setLatestVersion = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return [4, this.checkOnlyOwner()];

              case 1:
                return s.sent(), d.default.isValidVersion(e.version), t = e.version.split("."), a = new c.BigNumber(t[0]), r = new c.BigNumber(t[1]), n = new c.BigNumber(t[2]), [4, this.contract];

              case 2:
                return [2, s.sent().setLatestVersion.sendTransactionAsync(a, r, n, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.getFees = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return t = e.feeType, [l.FeeType.StLaunchFee, l.FeeType.TickerRegFee].includes(t) || d.default.assert(!1, l.ErrorCode.InvalidData, "Incorrect fee type"), a = h.stringToKeccak256(e.feeType), [4, this.contract];

              case 1:
                return [4, r.sent().getFees.callAsync(a)];

              case 2:
                return [2, r.sent().map(function (e) {
                  return h.weiToValue(e, l.FULL_DECIMALS);
                })];
            }
          });
        });
      }, n.getTickerStatus = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, t.sent().getTickerStatus.callAsync(e.ticker)];
            }
          });
        });
      }, n.getTickerOwner = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, t.sent().getTickerOwner.callAsync(e.ticker)];
            }
          });
        });
      }, n.subscribeAsync = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return d.default.doesBelongToStringEnum("eventName", e.eventName, c.ISecurityTokenRegistryEvents_3_0_0), d.default.doesConformToSchema("indexFilterValues", e.indexFilterValues, u.schemas.indexFilterValuesSchema), d.default.isFunction("callback", e.callback), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.subscribeInternal(t, e.eventName, e.indexFilterValues, e.callback, e.isVerbose)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.getLogsAsync = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return d.default.doesBelongToStringEnum("eventName", e.eventName, c.ISecurityTokenRegistryEvents_3_0_0), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.getLogsAsyncInternal(t, e.eventName, e.blockRange, e.indexFilterValues)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.getTickerDetailsInternal = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, a.sent().getTickerDetails.callAsync(e)];

              case 2:
                return t = a.sent(), [2, {
                  owner: t[0],
                  registrationDate: h.bigNumberToDate(t[1]),
                  expiryDate: h.bigNumberToDate(t[2]),
                  tokenName: t[3],
                  status: t[4]
                }];
            }
          });
        });
      }, n.checkWhenNotPausedOrOwner = function () {
        return s(n, void 0, void 0, function () {
          var e, t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return t = (e = p.default).checksumAddressComparision, [4, this.owner()];

              case 1:
                return a = [s.sent()], [4, this.web3Wrapper.getAvailableAddressesAsync()];

              case 2:
                return t.apply(e, a.concat([s.sent()[0]])) ? [3, 4] : (n = (r = d.default).assert, [4, this.isPaused()]);

              case 3:
                n.apply(r, [!s.sent(), l.ErrorCode.Unauthorized, "Msg sender is not owner and the contract is paused"]), s.label = 4;

              case 4:
                return [2];
            }
          });
        });
      }, n.checkOnlyOwner = function () {
        return s(n, void 0, void 0, function () {
          var e, t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return t = (e = d.default).assert, r = (a = p.default).checksumAddressComparision, [4, this.owner()];

              case 1:
                return n = [s.sent()], [4, this.web3Wrapper.getAvailableAddressesAsync()];

              case 2:
                return t.apply(e, [r.apply(a, n.concat([s.sent()[0]])), l.ErrorCode.Unauthorized, "Msg sender must be owner"]), [2];
            }
          });
        });
      }, n.checkRegisterTickerRequirements = function (e, t) {
        return s(n, void 0, void 0, function () {
          var a, r, n, s, i;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return d.default.isETHAddressHex("owner", t), d.default.assert(e.length > 0 && e.length <= 10, l.ErrorCode.InvalidData, "Bad ticker, must be 1 to 10 characters"), r = (a = d.default).assert, [4, this.tickerAvailable({
                  ticker: e
                })];

              case 1:
                return r.apply(a, [o.sent(), l.ErrorCode.AlreadyExists, "Ticker is not available"]), [4, this.getTickerRegistrationFee()];

              case 2:
                return (n = o.sent()).isGreaterThan(b) ? (i = h.weiToValue, [4, this.polyTokenContract()]) : [3, 5];

              case 3:
                return [4, o.sent().balanceOf.callAsync(t)];

              case 4:
                s = i.apply(void 0, [o.sent(), l.FULL_DECIMALS]), d.default.assert(s.isGreaterThanOrEqualTo(n), l.ErrorCode.InsufficientBalance, "Insufficient poly token balance"), o.label = 5;

              case 5:
                return [2];
            }
          });
        });
      }, n.checkModifyST = function (e, t, a, r) {
        return s(n, void 0, void 0, function () {
          var n, s, i;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return [4, this.checkOnlyOwner()];

              case 1:
                return o.sent(), d.default.assert(e.length > 0 && e.length <= 10, l.ErrorCode.InvalidData, "Bad ticker"), d.default.assert(t.getTime() > new Date(0).getTime(), l.ErrorCode.TooEarly, "Bad deployed date"), d.default.isNonZeroETHAddressHex("owner", a), d.default.isNonZeroETHAddressHex("securityToken", r), s = (n = d.default).isNonZeroETHAddressHex, i = ["Security token not registered for ticker"], [4, this.getSecurityTokenAddress({
                  ticker: e
                })];

              case 2:
                return s.apply(n, i.concat([o.sent()])), [2];
            }
          });
        });
      }, n.contract = a, n.contractFactory = r, n;
    }

    return n(t, e), t;
  }(f.default);

  t.default = m;
},
/*!***********************************************************************!*\
  !*** ./src/contract_wrappers/modules/module_factory_wrapper/index.ts ***!
  \***********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r22,
      n = this && this.__extends || (_r22 = function r(e, t) {
    return (_r22 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r22(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__importStar || function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var a in e) {
      Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t.default = e, t;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = a(
  /*! ./3.0.0 */
  828);
  t.ModuleFactory_3_0_0 = o.ModuleFactory_3_0_0, t.isModuleFactory_3_0_0 = o.isModuleFactory_3_0_0;
  var i = s(a(
  /*! ./common */
  291));
  t.isModuleFactory = i.isModuleFactory;
  var c = a(
  /*! @polymathnetwork/abi-wrappers */
  6);
  t.ModuleFactoryEvents = c.ModuleFactoryEvents_3_0_0;

  var u = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }

    return n(t, e), t;
  }(i.default);

  t.ModuleFactoryCommon = u;
},
/*!************************************************************************!*\
  !*** ./src/contract_wrappers/modules/module_factory_wrapper/common.ts ***!
  \************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r23,
      n = this && this.__extends || (_r23 = function r(e, t) {
    return (_r23 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r23(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      i = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var c = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      u = i(a(
  /*! semver */
  829)),
      d = a(
  /*! @0x/json-schemas */
  2),
      f = i(a(
  /*! ../../../utils/assert */
  15)),
      l = i(a(
  /*! ../../contract_wrapper */
  44)),
      h = a(
  /*! ../../../types */
  4),
      p = a(
  /*! ../../../utils/convert */
  16),
      b = i(a(
  /*! ../../../utils/functions_utils */
  40)),
      m = function (e) {
    function t(t, a) {
      var r = e.call(this, t, a) || this;
      return r.owner = function () {
        return s(r, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().owner.callAsync()];
            }
          });
        });
      }, r.name = function () {
        return s(r, void 0, void 0, function () {
          var e;
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, t.sent().name.callAsync()];

              case 2:
                return e = t.sent(), [2, p.bytes32ToString(e)];
            }
          });
        });
      }, r.title = function () {
        return s(r, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().title.callAsync()];
            }
          });
        });
      }, r.isCostInPoly = function () {
        return s(r, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().isCostInPoly.callAsync()];
            }
          });
        });
      }, r.description = function () {
        return s(r, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().description.callAsync()];
            }
          });
        });
      }, r.version = function () {
        return s(r, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().version.callAsync()];
            }
          });
        });
      }, r.getTypes = function () {
        return s(r, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, e.sent().getTypes.callAsync()];

              case 2:
                return [2, e.sent().map(function (e) {
                  return p.parseModuleTypeValue(new c.BigNumber(e));
                })];
            }
          });
        });
      }, r.getTags = function () {
        return s(r, void 0, void 0, function () {
          var e;
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return e = p.bytes32ArrayToStringArray, [4, this.contract];

              case 1:
                return [4, t.sent().getTags.callAsync()];

              case 2:
                return [2, e.apply(void 0, [t.sent()])];
            }
          });
        });
      }, r.changeSetupCost = function (e) {
        return s(r, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.checkOnlyOwner(e.txData)];

              case 1:
                return t.sent(), [4, this.contract];

              case 2:
                return [2, t.sent().changeSetupCost.sendTransactionAsync(e.setupCost, e.txData, e.safetyFactor)];
            }
          });
        });
      }, r.changeCostAndType = function (e) {
        return s(r, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.checkOnlyOwner(e.txData)];

              case 1:
                return t.sent(), [4, this.contract];

              case 2:
                return [2, t.sent().changeCostAndType.sendTransactionAsync(e.setupCost, e.isCostInPoly, e.txData, e.safetyFactor)];
            }
          });
        });
      }, r.changeTitle = function (e) {
        return s(r, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.checkOnlyOwner(e.txData)];

              case 1:
                return t.sent(), f.default.assert(e.title.length > 0, h.ErrorCode.InvalidData, "Invalid title"), [4, this.contract];

              case 2:
                return [2, t.sent().changeTitle.sendTransactionAsync(e.title, e.txData, e.safetyFactor)];
            }
          });
        });
      }, r.changeDescription = function (e) {
        return s(r, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.checkOnlyOwner(e.txData)];

              case 1:
                return t.sent(), f.default.assert(e.description.length > 0, h.ErrorCode.InvalidData, "Invalid description"), [4, this.contract];

              case 2:
                return [2, t.sent().changeDescription.sendTransactionAsync(e.description, e.txData, e.safetyFactor)];
            }
          });
        });
      }, r.changeName = function (e) {
        return s(r, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.checkOnlyOwner(e.txData)];

              case 1:
                return t.sent(), f.default.assert(e.name.length > 0, h.ErrorCode.InvalidData, "Invalid name"), [4, this.contract];

              case 2:
                return [2, t.sent().changeName.sendTransactionAsync(p.stringToBytes32(e.name), e.txData, e.safetyFactor)];
            }
          });
        });
      }, r.changeTags = function (e) {
        return s(r, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.checkOnlyOwner(e.txData)];

              case 1:
                return t.sent(), f.default.assert(e.tags.length > 0, h.ErrorCode.InvalidData, "Invalid, must provide one or more tags"), [4, this.contract];

              case 2:
                return [2, t.sent().changeTags.sendTransactionAsync(p.stringArrayToBytes32Array(e.tags), e.txData, e.safetyFactor)];
            }
          });
        });
      }, r.changeSTVersionBounds = function (e) {
        return s(r, void 0, void 0, function () {
          var t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, this.checkOnlyOwner(e.txData)];

              case 1:
                return n.sent(), f.default.assert(e.boundType === h.BoundType.LowerBound || e.boundType === h.BoundType.UpperBound, h.ErrorCode.InvalidBound, "Invalid bound type"), f.default.assert(3 === e.newVersion.length, h.ErrorCode.InvalidVersion, "Invalid version, number array must have 3 elements"), h.BoundType.LowerBound !== e.boundType ? [3, 3] : [4, this.getLowerSTVersionBounds()];

              case 2:
                return t = n.sent(), [3, 5];

              case 3:
                return [4, this.getUpperSTVersionBounds()];

              case 4:
                t = n.sent(), n.label = 5;

              case 5:
                return a = t.join("."), r = e.newVersion.join("."), e.boundType === h.BoundType.LowerBound ? f.default.assert(u.default.lte(r, a), h.ErrorCode.InvalidBound, "New Lower ST Bounds must be less than or equal to current") : f.default.assert(u.default.gte(r, a), h.ErrorCode.InvalidBound, "New Upper ST Bounds must be greater than or equal to current"), [4, this.contract];

              case 6:
                return [2, n.sent().changeSTVersionBounds.sendTransactionAsync(e.boundType, e.newVersion, e.txData, e.safetyFactor)];
            }
          });
        });
      }, r.setupCost = function () {
        return s(r, void 0, void 0, function () {
          var e;
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, t.sent().setupCost.callAsync()];

              case 2:
                return e = t.sent(), [2, p.weiToValue(e, h.FULL_DECIMALS)];
            }
          });
        });
      }, r.getUpperSTVersionBounds = function () {
        return s(r, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, e.sent().getUpperSTVersionBounds.callAsync()];

              case 2:
                return [2, e.sent().map(function (e) {
                  return new c.BigNumber(e);
                })];
            }
          });
        });
      }, r.getLowerSTVersionBounds = function () {
        return s(r, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, e.sent().getLowerSTVersionBounds.callAsync()];

              case 2:
                return [2, e.sent().map(function (e) {
                  return new c.BigNumber(e);
                })];
            }
          });
        });
      }, r.setupCostInPoly = function () {
        return s(r, void 0, void 0, function () {
          var e;
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, t.sent().setupCostInPoly.callAsync()];

              case 2:
                return e = t.sent(), [2, p.weiToValue(e, h.FULL_DECIMALS)];
            }
          });
        });
      }, r.checkOnlyOwner = function (e) {
        return s(r, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return a = (t = f.default).assert, n = (r = b.default).checksumAddressComparision, [4, this.owner()];

              case 1:
                return s = [o.sent()], [4, this.getCallerAddress(e)];

              case 2:
                return a.apply(t, [n.apply(r, s.concat([o.sent()])), h.ErrorCode.Unauthorized, "Msg sender must be owner"]), [2];
            }
          });
        });
      }, r.subscribeAsync = function (e) {
        return s(r, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return f.default.doesBelongToStringEnum("eventName", e.eventName, c.ModuleFactoryEvents_3_0_0), f.default.doesConformToSchema("indexFilterValues", e.indexFilterValues, d.schemas.indexFilterValuesSchema), f.default.isFunction("callback", e.callback), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.subscribeInternal(t, e.eventName, e.indexFilterValues, e.callback, e.isVerbose)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, r.getLogsAsync = function (e) {
        return s(r, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return f.default.doesBelongToStringEnum("eventName", e.eventName, c.ModuleFactoryEvents_3_0_0), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.getLogsAsyncInternal(t, e.eventName, e.blockRange, e.indexFilterValues)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, r.contract = a, r;
    }

    return n(t, e), t;
  }(l.default);

  t.default = m, t.isModuleFactory = function (e) {
    return e instanceof m;
  };
},
/*!**********************************************************************!*\
  !*** ./src/contract_wrappers/tokens/security_token_wrapper/index.ts ***!
  \**********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r24,
      n = this && this.__extends || (_r24 = function r(e, t) {
    return (_r24 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r24(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__importStar || function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var a in e) {
      Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t.default = e, t;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = a(
  /*! ./3.0.0 */
  830);
  t.SecurityToken_3_0_0 = o.SecurityToken_3_0_0, t.isSecurityToken_3_0_0 = o.isSecurityToken_3_0_0;
  var i = s(a(
  /*! ./common */
  293));
  t.isSecurityToken = i.isSecurityToken;
  var c = a(
  /*! @polymathnetwork/abi-wrappers */
  6);
  t.SecurityTokenEvents = c.ISecurityTokenEvents_3_0_0;

  var u = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }

    return n(t, e), t;
  }(i.default);

  t.SecurityTokenCommon = u;
},
/*!***********************************************************************!*\
  !*** ./src/contract_wrappers/tokens/security_token_wrapper/common.ts ***!
  \***********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r25,
      n = this && this.__extends || (_r25 = function r(e, t) {
    return (_r25 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r25(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      i = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || t-- > 0) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  },
      c = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var u = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      d = a(
  /*! @0x/json-schemas */
  2),
      f = a(
  /*! eth-sig-util */
  831),
      l = c(a(
  /*! ../../../utils/assert */
  15)),
      h = c(a(
  /*! ../erc20_wrapper */
  142)),
      p = a(
  /*! ../../../types */
  4),
      b = a(
  /*! ../../../utils/convert */
  16),
      m = c(a(
  /*! ../../../utils/functions_utils */
  40)),
      y = a(
  /*! ../../../utils/sign_utils */
  839),
      v = new u.BigNumber(Math.pow(2, 256) - 1),
      _ = new u.BigNumber(0),
      g = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a) || this;
      return n.featureRegistryContract = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            return [2, this.contractFactory.getFeatureRegistryContract()];
          });
        });
      }, n.moduleFactoryContract = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            return [2, this.contractFactory.getModuleFactoryContract(e)];
          });
        });
      }, n.polyTokenContract = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            return [2, this.contractFactory.getPolyTokenContract()];
          });
        });
      }, n.moduleRegistryContract = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            return [2, this.contractFactory.getModuleRegistryContract()];
          });
        });
      }, n.currentCheckpointId = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().currentCheckpointId.callAsync()];
            }
          });
        });
      }, n.isOperator = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, t.sent().isOperator.callAsync(e.operator, e.tokenHolder)];
            }
          });
        });
      }, n.isOperatorForPartition = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, t.sent().isOperatorForPartition.callAsync(b.stringToBytes32(e.partition), e.operator, e.tokenHolder)];
            }
          });
        });
      }, n.partitionsOf = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, t.sent().partitionsOf.callAsync(e.tokenHolder)];

              case 2:
                return [2, t.sent().map(b.parsePartitionBytes32Value)];
            }
          });
        });
      }, n.dataStore = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().dataStore.callAsync()];
            }
          });
        });
      }, n.granularity = function () {
        return s(n, void 0, void 0, function () {
          var e;
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return e = b.weiToValue, [4, this.contract];

              case 1:
                return [4, t.sent().granularity.callAsync()];

              case 2:
                return [2, e.apply(void 0, [t.sent(), p.FULL_DECIMALS]).toNumber()];
            }
          });
        });
      }, n.controller = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().controller.callAsync()];
            }
          });
        });
      }, n.decreaseAllowance = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return l.default.isETHAddressHex("spender", e.spender), [4, this.contract];

              case 1:
                return a = (t = o.sent().decreaseAllowance).sendTransactionAsync, r = [e.spender], n = b.valueToWei, s = [e.value], [4, this.decimals()];

              case 2:
                return [2, a.apply(t, r.concat([n.apply(void 0, s.concat([o.sent()])), e.txData, e.safetyFactor]))];
            }
          });
        });
      }, n.polyToken = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().polyToken.callAsync()];
            }
          });
        });
      }, n.polymathRegistry = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().polymathRegistry.callAsync()];
            }
          });
        });
      }, n.controllerDisabled = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().controllerDisabled.callAsync()];
            }
          });
        });
      }, n.owner = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().owner.callAsync()];
            }
          });
        });
      }, n.isIssuable = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().isIssuable.callAsync()];
            }
          });
        });
      }, n.isOwner = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().isOwner.callAsync()];
            }
          });
        });
      }, n.isControllable = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().isControllable.callAsync()];
            }
          });
        });
      }, n.moduleRegistry = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().moduleRegistry.callAsync()];
            }
          });
        });
      }, n.securityTokenRegistry = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().securityTokenRegistry.callAsync()];
            }
          });
        });
      }, n.tokenDetails = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().tokenDetails.callAsync()];
            }
          });
        });
      }, n.increaseAllowance = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return l.default.isETHAddressHex("spender", e.spender), [4, this.contract];

              case 1:
                return a = (t = o.sent().increaseAllowance).sendTransactionAsync, r = [e.spender], n = b.valueToWei, s = [e.value], [4, this.decimals()];

              case 2:
                return [2, a.apply(t, r.concat([n.apply(void 0, s.concat([o.sent()])), e.txData, e.safetyFactor]))];
            }
          });
        });
      }, n.transfersFrozen = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().transfersFrozen.callAsync()];
            }
          });
        });
      }, n.transferOwnership = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return l.default.isNonZeroETHAddressHex("newOwner", e.newOwner), [4, this.contract];

              case 1:
                return [2, t.sent().transferOwnership.sendTransactionAsync(e.newOwner, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.updateFromRegistry = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, t.sent().updateFromRegistry.sendTransactionAsync(e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.archiveModule = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return l.default.isETHAddressHex("moduleAddress", e.moduleAddress), [4, this.checkOnlyOwner(e.txData)];

              case 1:
                return t.sent(), [4, this.checkModuleExists(e.moduleAddress)];

              case 2:
                return t.sent(), [4, this.checkIsNotArchived(e.moduleAddress)];

              case 3:
                return t.sent(), [4, this.contract];

              case 4:
                return [2, t.sent().archiveModule.sendTransactionAsync(e.moduleAddress, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.unarchiveModule = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return l.default.isETHAddressHex("moduleAddress", e.moduleAddress), [4, this.checkOnlyOwner(e.txData)];

              case 1:
                return t.sent(), [4, this.checkModuleExists(e.moduleAddress)];

              case 2:
                return t.sent(), [4, this.checkIsArchived(e.moduleAddress)];

              case 3:
                return t.sent(), [4, this.contract];

              case 4:
                return [2, t.sent().unarchiveModule.sendTransactionAsync(e.moduleAddress, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.removeModule = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return l.default.isETHAddressHex("moduleAddress", e.moduleAddress), [4, this.checkOnlyOwner(e.txData)];

              case 1:
                return t.sent(), [4, this.checkModuleStructAddressIsNotZero(e.moduleAddress)];

              case 2:
                return t.sent(), [4, this.checkIsArchived(e.moduleAddress)];

              case 3:
                return t.sent(), [4, this.contract];

              case 4:
                return [2, t.sent().removeModule.sendTransactionAsync(e.moduleAddress, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.getModulesByName = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return t = b.stringToBytes32(e.moduleName), [4, this.contract];

              case 1:
                return [2, a.sent().getModulesByName.callAsync(t)];
            }
          });
        });
      }, n.withdrawERC20 = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return l.default.isNonZeroETHAddressHex("tokenContract", e.tokenContract), [4, this.checkOnlyOwner(e.txData)];

              case 1:
                return o.sent(), [4, this.contract];

              case 2:
                return a = (t = o.sent().withdrawERC20).sendTransactionAsync, r = [e.tokenContract], n = b.valueToWei, s = [e.value], [4, this.decimals()];

              case 3:
                return [2, a.apply(t, r.concat([n.apply(void 0, s.concat([o.sent()])), e.txData, e.safetyFactor]))];
            }
          });
        });
      }, n.changeModuleBudget = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return l.default.isETHAddressHex("module", e.module), [4, this.checkModuleStructAddressIsNotZero(e.module)];

              case 1:
                return o.sent(), [4, this.checkOnlyOwner(e.txData)];

              case 2:
                return o.sent(), [4, this.contract];

              case 3:
                return a = (t = o.sent().changeModuleBudget).sendTransactionAsync, r = [e.module], n = b.valueToWei, s = [e.change], [4, this.decimals()];

              case 4:
                return [2, a.apply(t, r.concat([n.apply(void 0, s.concat([o.sent()])), e.increase, e.txData, e.safetyFactor]))];
            }
          });
        });
      }, n.updateTokenDetails = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.checkOnlyOwner(e.txData)];

              case 1:
                return t.sent(), [4, this.contract];

              case 2:
                return [2, t.sent().updateTokenDetails.sendTransactionAsync(e.newTokenDetails, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.changeGranularity = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.checkOnlyOwner(e.txData)];

              case 1:
                return t.sent(), l.default.assert(e.granularity > 0 && e.granularity <= 18, p.ErrorCode.InvalidData, "Granularity must be between 1 and 18 decimal places"), [4, this.contract];

              case 2:
                return [2, t.sent().changeGranularity.sendTransactionAsync(b.valueToWei(new u.BigNumber(e.granularity), p.FULL_DECIMALS), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.changeName = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.checkOnlyOwner(e.txData)];

              case 1:
                return t.sent(), l.default.assert(e.name.length > 0, p.ErrorCode.InvalidData, "Name required"), [4, this.contract];

              case 2:
                return [2, t.sent().changeName.sendTransactionAsync(e.name, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.changeTreasuryWallet = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return l.default.isETHAddressHex("treasuryWallet", e.treasuryWallet), [4, this.checkOnlyOwner(e.txData)];

              case 1:
                return t.sent(), [4, this.contract];

              case 2:
                return [2, t.sent().changeTreasuryWallet.sendTransactionAsync(e.treasuryWallet, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.changeDataStore = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return l.default.isETHAddressHex("dataStore", e.dataStore), [4, this.checkOnlyOwner(e.txData)];

              case 1:
                return t.sent(), [4, this.contract];

              case 2:
                return [2, t.sent().changeDataStore.sendTransactionAsync(e.dataStore, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.getInvestors = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().getInvestors.callAsync()];
            }
          });
        });
      }, n.getInvestorsAt = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, t.sent().getInvestorsAt.callAsync(b.numberToBigNumber(e.checkpointId))];
            }
          });
        });
      }, n.getInvestorsSubsetAt = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, t.sent().getInvestorsSubsetAt.callAsync(b.numberToBigNumber(e.checkpointId), b.numberToBigNumber(e.start), b.numberToBigNumber(e.end))];
            }
          });
        });
      }, n.iterateInvestors = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, t.sent().iterateInvestors.callAsync(b.numberToBigNumber(e.start), b.numberToBigNumber(e.end))];
            }
          });
        });
      }, n.getInvestorCount = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, e.sent().getInvestorCount.callAsync()];

              case 2:
                return [2, e.sent().toNumber()];
            }
          });
        });
      }, n.holderCount = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, e.sent().holderCount.callAsync()];

              case 2:
                return [2, e.sent().toNumber()];
            }
          });
        });
      }, n.freezeTransfers = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.checkOnlyOwner(e.txData)];

              case 1:
                return r.sent(), a = (t = l.default).assert, [4, this.transfersFrozen()];

              case 2:
                return a.apply(t, [!r.sent(), p.ErrorCode.PreconditionRequired, "Transfers already frozen"]), [4, this.contract];

              case 3:
                return [2, r.sent().freezeTransfers.sendTransactionAsync(e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.unfreezeTransfers = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.checkOnlyOwner(e.txData)];

              case 1:
                return r.sent(), a = (t = l.default).assert, [4, this.transfersFrozen()];

              case 2:
                return a.apply(t, [r.sent(), p.ErrorCode.PreconditionRequired, "Transfers are not frozen"]), [4, this.contract];

              case 3:
                return [2, r.sent().unfreezeTransfers.sendTransactionAsync(e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.transferWithData = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return l.default.isNonZeroETHAddressHex("to", e.to), l.default.isHexString("data", e.data), [4, this.contract];

              case 1:
                return a = (t = o.sent().transferWithData).sendTransactionAsync, r = [e.to], n = b.valueToWei, s = [e.value], [4, this.decimals()];

              case 2:
                return [2, a.apply(t, r.concat([n.apply(void 0, s.concat([o.sent()])), e.data, e.txData, e.safetyFactor]))];
            }
          });
        });
      }, n.transferFromWithData = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return l.default.isETHAddressHex("from", e.from), l.default.isNonZeroETHAddressHex("to", e.to), l.default.isHexString("data", e.data), [4, this.contract];

              case 1:
                return a = (t = o.sent().transferFromWithData).sendTransactionAsync, r = [e.from, e.to], n = b.valueToWei, s = [e.value], [4, this.decimals()];

              case 2:
                return [2, a.apply(t, r.concat([n.apply(void 0, s.concat([o.sent()])), e.data, e.txData, e.safetyFactor]))];
            }
          });
        });
      }, n.freezeIssuance = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = l.default).assert, [4, this.isIssuable()];

              case 1:
                return a.apply(t, [s.sent(), p.ErrorCode.PreconditionRequired, "Issuance frozen"]), [4, this.checkOnlyOwner(e.txData)];

              case 2:
                return s.sent(), r = this.checkFreezeIssuanceSignature, n = [e.signature], [4, this.owner()];

              case 3:
                return [4, r.apply(this, n.concat([s.sent()]))];

              case 4:
                return s.sent(), [4, this.contract];

              case 5:
                return [2, s.sent().freezeIssuance.sendTransactionAsync(e.signature, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.issue = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s, i, c, u, d;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return l.default.isNonZeroETHAddressHex("investor", e.investor), [4, this.checkOnlyOwner(e.txData)];

              case 1:
                return o.sent(), a = (t = l.default).assert, [4, this.isIssuable()];

              case 2:
                return a.apply(t, [o.sent(), p.ErrorCode.PreconditionRequired, "Issuance frozen"]), r = e.data || b.stringToBytes32(""), l.default.isHexString("data", r), [4, this.canTransfer({
                  to: e.investor,
                  value: e.value,
                  data: r
                })];

              case 3:
                return n = o.sent(), l.default.assert(n.statusCode !== p.TransferStatusCode.TransferFailure, p.ErrorCode.InvalidTransfer, "Transfer Status: " + n.statusCode), [4, this.contract];

              case 4:
                return i = (s = o.sent().issue).sendTransactionAsync, c = [e.investor], u = b.valueToWei, d = [e.value], [4, this.decimals()];

              case 5:
                return [2, i.apply(s, c.concat([u.apply(void 0, d.concat([o.sent()])), r, e.txData, e.safetyFactor]))];
            }
          });
        });
      }, n.issueByPartition = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s, i, c, u;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return l.default.isNonZeroETHAddressHex("investor", e.investor), [4, this.checkOnlyOwner(e.txData)];

              case 1:
                return o.sent(), a = (t = l.default).assert, [4, this.isIssuable()];

              case 2:
                return a.apply(t, [o.sent(), p.ErrorCode.PreconditionRequired, "Issuance frozen"]), l.default.isValidPartition(e.partition), r = e.data || b.stringToBytes32(""), l.default.isHexString("data", r), [4, this.contract];

              case 3:
                return s = (n = o.sent().issueByPartition).sendTransactionAsync, i = [e.partition, e.investor], c = b.valueToWei, u = [e.value], [4, this.decimals()];

              case 4:
                return [2, s.apply(n, i.concat([c.apply(void 0, u.concat([o.sent()])), r, e.txData, e.safetyFactor]))];
            }
          });
        });
      }, n.issueMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s, i, c;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return e.investors.forEach(function (e) {
                  return l.default.isNonZeroETHAddressHex("investors", e);
                }), l.default.assert(e.investors.length === e.values.length, p.ErrorCode.MismatchedArrayLength, "Number of investors passed in must be equivalent to number of values"), a = (t = l.default).assert, [4, this.isIssuable()];

              case 1:
                return a.apply(t, [o.sent(), p.ErrorCode.PreconditionRequired, "Issuance frozen"]), [4, this.checkOnlyOwner(e.txData)];

              case 2:
                return o.sent(), [4, this.contract];

              case 3:
                return n = (r = o.sent().issueMulti).sendTransactionAsync, s = [e.investors], i = b.valueArrayToWeiArray, c = [e.values], [4, this.decimals()];

              case 4:
                return [2, n.apply(r, s.concat([i.apply(void 0, c.concat([o.sent()])), e.txData, e.safetyFactor]))];
            }
          });
        });
      }, n.checkPermission = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return l.default.isETHAddressHex("delegateAddress", e.delegateAddress), l.default.isETHAddressHex("moduleAddress", e.moduleAddress), [4, this.contract];

              case 1:
                return [2, t.sent().checkPermission.callAsync(e.delegateAddress, e.moduleAddress, b.stringToBytes32(e.permission))];
            }
          });
        });
      }, n.redeem = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s, i;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return t = this.checkBalanceFromGreaterThanValue, [4, this.web3Wrapper.getAvailableAddressesAsync()];

              case 1:
                return [4, t.apply(this, [o.sent()[0], e.value])];

              case 2:
                return o.sent(), a = e.data || b.stringToBytes32(""), l.default.isHexString("data", a), [4, this.contract];

              case 3:
                return n = (r = o.sent().redeem).sendTransactionAsync, s = b.valueToWei, i = [e.value], [4, this.decimals()];

              case 4:
                return [2, n.apply(r, [s.apply(void 0, i.concat([o.sent()])), a, e.txData, e.safetyFactor])];
            }
          });
        });
      }, n.redeemByPartition = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s, i, c;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return t = this.checkBalanceFromGreaterThanValue, [4, this.web3Wrapper.getAvailableAddressesAsync()];

              case 1:
                return [4, t.apply(this, [o.sent()[0], e.value])];

              case 2:
                return o.sent(), l.default.isValidPartition(e.partition), a = e.data || b.stringToBytes32(""), l.default.isHexString("data", a), [4, this.contract];

              case 3:
                return n = (r = o.sent().redeemByPartition).sendTransactionAsync, s = [e.partition], i = b.valueToWei, c = [e.value], [4, this.decimals()];

              case 4:
                return [2, n.apply(r, s.concat([i.apply(void 0, c.concat([o.sent()])), a, e.txData, e.safetyFactor]))];
            }
          });
        });
      }, n.operatorRedeemByPartition = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s, i, c;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return t = this.checkBalanceFromGreaterThanValue, [4, this.web3Wrapper.getAvailableAddressesAsync()];

              case 1:
                return [4, t.apply(this, [o.sent()[0], e.value])];

              case 2:
                return o.sent(), l.default.isNonZeroETHAddressHex("TokenHolder", e.tokenHolder), l.default.assert(e.operatorData.length > 0, p.ErrorCode.InvalidData, "Operator data cannot be 0"), l.default.isValidPartition(e.partition), a = e.data || b.stringToBytes32(""), l.default.isHexString("data", a), [4, this.contract];

              case 3:
                return n = (r = o.sent().operatorRedeemByPartition).sendTransactionAsync, s = [e.partition, e.tokenHolder], i = b.valueToWei, c = [e.value], [4, this.decimals()];

              case 4:
                return [2, n.apply(r, s.concat([i.apply(void 0, c.concat([o.sent()])), a, b.stringToBytes32(e.operatorData), e.txData, e.safetyFactor]))];
            }
          });
        });
      }, n.redeemFrom = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s, i, c, u, d, f;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return [4, this.checkBalanceFromGreaterThanValue(e.from, e.value)];

              case 1:
                return o.sent(), a = (t = l.default).assert, r = this.allowance, n = {
                  owner: e.from
                }, [4, this.web3Wrapper.getAvailableAddressesAsync()];

              case 2:
                return [4, r.apply(this, [(n.spender = o.sent()[0], n)])];

              case 3:
                return a.apply(t, [o.sent().isGreaterThanOrEqualTo(e.value), p.ErrorCode.InsufficientAllowance, "Insufficient allowance for inputted burn value"]), l.default.isETHAddressHex("from", e.from), s = e.data || b.stringToBytes32(""), l.default.isHexString("data", s), [4, this.contract];

              case 4:
                return c = (i = o.sent().redeemFrom).sendTransactionAsync, u = [e.from], d = b.valueToWei, f = [e.value], [4, this.decimals()];

              case 5:
                return [2, c.apply(i, u.concat([d.apply(void 0, f.concat([o.sent()])), s, e.txData, e.safetyFactor]))];
            }
          });
        });
      }, n.createCheckpoint = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.checkOnlyOwner(e.txData)];

              case 1:
                return r.sent(), a = (t = l.default).assert, [4, this.currentCheckpointId()];

              case 2:
                return a.apply(t, [r.sent().isLessThan(v), p.ErrorCode.PreconditionRequired, "Reached maximum checkpoint number"]), [4, this.contract];

              case 3:
                return [2, r.sent().createCheckpoint.sendTransactionAsync(e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.getCheckpointTimes = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, e.sent().getCheckpointTimes.callAsync()];

              case 2:
                return [2, e.sent().map(b.bigNumberToDate)];
            }
          });
        });
      }, n.totalSupplyAt = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = l.default).assert, [4, this.currentCheckpointId()];

              case 1:
                return a.apply(t, [s.sent().isGreaterThanOrEqualTo(e.checkpointId), p.ErrorCode.InvalidData, "Checkpoint id must be less than or equal to currentCheckpoint"]), r = b.weiToValue, [4, this.contract];

              case 2:
                return [4, s.sent().totalSupplyAt.callAsync(b.numberToBigNumber(e.checkpointId))];

              case 3:
                return n = [s.sent()], [4, this.decimals()];

              case 4:
                return [2, r.apply(void 0, n.concat([s.sent()]))];
            }
          });
        });
      }, n.balanceOfAt = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return l.default.isETHAddressHex("investor", e.investor), a = (t = l.default).assert, [4, this.currentCheckpointId()];

              case 1:
                return a.apply(t, [s.sent().isGreaterThanOrEqualTo(e.checkpointId), p.ErrorCode.InvalidData, "Checkpoint id must be less than or equal to currentCheckpoint"]), r = b.weiToValue, [4, this.contract];

              case 2:
                return [4, s.sent().balanceOfAt.callAsync(e.investor, b.numberToBigNumber(e.checkpointId))];

              case 3:
                return n = [s.sent()], [4, this.decimals()];

              case 4:
                return [2, r.apply(void 0, n.concat([s.sent()]))];
            }
          });
        });
      }, n.balanceOfByPartition = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return l.default.isETHAddressHex("investor", e.tokenHolder), t = b.weiToValue, [4, this.contract];

              case 1:
                return [4, r.sent().balanceOfByPartition.callAsync(b.stringToBytes32(e.partition), e.tokenHolder)];

              case 2:
                return a = [r.sent()], [4, this.decimals()];

              case 3:
                return [2, t.apply(void 0, a.concat([r.sent()]))];
            }
          });
        });
      }, n.transferByPartition = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s, i;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return l.default.isETHAddressHex("To", e.to), l.default.isValidPartition(e.partition), t = e.data || b.stringToBytes32(""), l.default.isHexString("data", t), [4, this.contract];

              case 1:
                return r = (a = o.sent().transferByPartition).sendTransactionAsync, n = [b.stringToBytes32(e.partition), e.to], s = b.valueToWei, i = [e.value], [4, this.decimals()];

              case 2:
                return [2, r.apply(a, n.concat([s.apply(void 0, i.concat([o.sent()])), t, e.txData, e.safetyFactor]))];
            }
          });
        });
      }, n.authorizeOperator = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return l.default.isETHAddressHex("Operator", e.operator), [4, this.contract];

              case 1:
                return [2, t.sent().authorizeOperator.sendTransactionAsync(e.operator, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.revokeOperator = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return l.default.isETHAddressHex("Operator", e.operator), [4, this.contract];

              case 1:
                return [2, t.sent().revokeOperator.sendTransactionAsync(e.operator, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.authorizeOperatorByPartition = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return l.default.isETHAddressHex("Operator", e.operator), l.default.isValidPartition(e.partition), [4, this.contract];

              case 1:
                return [2, t.sent().authorizeOperatorByPartition.sendTransactionAsync(b.stringToBytes32(e.partition), e.operator, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.revokeOperatorByPartition = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return l.default.isETHAddressHex("Operator", e.operator), l.default.isValidPartition(e.partition), [4, this.contract];

              case 1:
                return [2, t.sent().revokeOperatorByPartition.sendTransactionAsync(b.stringToBytes32(e.partition), e.operator, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.operatorTransferByPartition = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s, i;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return l.default.isETHAddressHex("To", e.to), l.default.isETHAddressHex("From", e.from), l.default.assert(e.operatorData.length > 0, p.ErrorCode.InvalidData, "Operator data cannot be 0"), l.default.isValidPartition(e.partition), t = e.data || b.stringToBytes32(""), l.default.isHexString("data", t), [4, this.contract];

              case 1:
                return r = (a = o.sent().operatorTransferByPartition).sendTransactionAsync, n = [b.stringToBytes32(e.partition), e.from, e.to], s = b.valueToWei, i = [e.value], [4, this.decimals()];

              case 2:
                return [2, r.apply(a, n.concat([s.apply(void 0, i.concat([o.sent()])), t, e.operatorData, e.txData, e.safetyFactor]))];
            }
          });
        });
      }, n.setController = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.checkOnlyOwner(e.txData)];

              case 1:
                return t.sent(), [4, this.checkIsControllable()];

              case 2:
                return t.sent(), l.default.isETHAddressHex("controller", e.controller), [4, this.contract];

              case 3:
                return [2, t.sent().setController.sendTransactionAsync(e.controller, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.disableController = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.checkOnlyOwner(e.txData)];

              case 1:
                return r.sent(), [4, this.checkIsControllable()];

              case 2:
                return r.sent(), t = this.checkDisableControllerSignature, a = [e.signature], [4, this.owner()];

              case 3:
                return [4, t.apply(this, a.concat([r.sent()]))];

              case 4:
                return r.sent(), [4, this.contract];

              case 5:
                return [2, r.sent().disableController.sendTransactionAsync(e.signature, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.controllerTransfer = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s, i;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return l.default.isETHAddressHex("from", e.from), l.default.isNonZeroETHAddressHex("to", e.to), [4, this.checkMsgSenderIsController(e.txData)];

              case 1:
                return o.sent(), [4, this.checkBalanceFromGreaterThanValue(e.from, e.value)];

              case 2:
                return o.sent(), t = e.data || b.stringToBytes32(""), l.default.isHexString("data", t), [4, this.contract];

              case 3:
                return r = (a = o.sent().controllerTransfer).sendTransactionAsync, n = [e.from, e.to], s = b.valueToWei, i = [e.value], [4, this.decimals()];

              case 4:
                return [2, r.apply(a, n.concat([s.apply(void 0, i.concat([o.sent()])), t, e.operatorData, e.txData, e.safetyFactor]))];
            }
          });
        });
      }, n.controllerRedeem = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s, i;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return l.default.isETHAddressHex("from", e.from), [4, this.checkBalanceFromGreaterThanValue(e.from, e.value)];

              case 1:
                return o.sent(), [4, this.checkMsgSenderIsController(e.txData)];

              case 2:
                return o.sent(), t = e.data || b.stringToBytes32(""), l.default.isHexString("data", t), [4, this.contract];

              case 3:
                return r = (a = o.sent().controllerRedeem).sendTransactionAsync, n = [e.from], s = b.valueToWei, i = [e.value], [4, this.decimals()];

              case 4:
                return [2, r.apply(a, n.concat([s.apply(void 0, i.concat([o.sent()])), t, e.operatorData, e.txData, e.safetyFactor]))];
            }
          });
        });
      }, n.getVersion = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().getVersion.callAsync()];
            }
          });
        });
      }, n.getModulesByType = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, t.sent().getModulesByType.callAsync(e.type)];
            }
          });
        });
      }, n.getTreasuryWallet = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().getTreasuryWallet.callAsync()];
            }
          });
        });
      }, n.addModule = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.addModuleRequirementsAndGetData(e)];

              case 1:
                return t = a.sent(), [4, this.contract];

              case 2:
                return [2, a.sent().addModule.sendTransactionAsync(e.address, t.data, t.maxCost, t.budget, e.archived, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.addModuleWithLabel = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.addModuleRequirementsAndGetData(e)];

              case 1:
                return t = a.sent(), [4, this.contract];

              case 2:
                return [2, a.sent().addModuleWithLabel.sendTransactionAsync(e.address, t.data, t.maxCost, t.budget, b.stringToBytes32(e.label || ""), e.archived, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.upgradeModule = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return l.default.isETHAddressHex("moduleAddress", e.moduleAddress), [4, this.checkOnlyOwner(e.txData)];

              case 1:
                return t.sent(), [4, this.checkModuleExists(e.moduleAddress)];

              case 2:
                return t.sent(), [4, this.contract];

              case 3:
                return [2, t.sent().upgradeModule.sendTransactionAsync(e.moduleAddress, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.upgradeToken = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.checkOnlyOwner(e.txData)];

              case 1:
                return t.sent(), [4, this.contract];

              case 2:
                return [2, t.sent().upgradeToken.sendTransactionAsync(e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.getModule = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return l.default.isETHAddressHex("moduleAddress", e.moduleAddress), [4, this.contract];

              case 1:
                return [4, a.sent().getModule.callAsync(e.moduleAddress)];

              case 2:
                return t = a.sent(), [2, {
                  name: b.bytes32ToString(t[0]),
                  address: t[1],
                  factoryAddress: t[2],
                  archived: t[3],
                  types: t[4].map(function (e) {
                    return new u.BigNumber(e).toNumber();
                  }),
                  label: b.bytes32ToString(t[5])
                }];
            }
          });
        });
      }, n.getTransferStatusCode = function (e) {
        var t = p.TransferStatusCode.TransferSuccess;

        switch (e) {
          case p.TransferStatusCode.TransferFailure:
            t = p.TransferStatusCode.TransferFailure;
            break;

          case p.TransferStatusCode.TransferSuccess:
            t = p.TransferStatusCode.TransferSuccess;
            break;

          case p.TransferStatusCode.InsufficientBalance:
            t = p.TransferStatusCode.InsufficientBalance;
            break;

          case p.TransferStatusCode.InsufficientAllowance:
            t = p.TransferStatusCode.InsufficientAllowance;
            break;

          case p.TransferStatusCode.TransfersHalted:
            t = p.TransferStatusCode.TransfersHalted;
            break;

          case p.TransferStatusCode.FundsLocked:
            t = p.TransferStatusCode.FundsLocked;
            break;

          case p.TransferStatusCode.InvalidSender:
            t = p.TransferStatusCode.InvalidSender;
            break;

          case p.TransferStatusCode.InvalidReceiver:
            t = p.TransferStatusCode.InvalidReceiver;
            break;

          case p.TransferStatusCode.InvalidOperator:
            t = p.TransferStatusCode.InvalidOperator;
        }

        return t;
      }, n.canTransfer = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s, i, c, u;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return l.default.isETHAddressHex("to", e.to), t = e.data || b.stringToBytes32(""), l.default.isHexString("data", t), [4, this.contract];

              case 1:
                return n = (r = o.sent().canTransfer).callAsync, s = [e.to], i = b.valueToWei, c = [e.value], [4, this.decimals()];

              case 2:
                return [4, n.apply(r, s.concat([i.apply(void 0, c.concat([o.sent()])), t]))];

              case 3:
                return a = o.sent(), u = this.getTransferStatusCode(a[0]), [2, {
                  statusCode: u,
                  reasonCode: b.bytes32ToString(a[1])
                }];
            }
          });
        });
      }, n.canTransferFrom = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s, i, c, u;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return l.default.isETHAddressHex("from", e.from), l.default.isETHAddressHex("to", e.to), t = e.data || b.stringToBytes32(""), l.default.isHexString("data", t), [4, this.contract];

              case 1:
                return n = (r = o.sent().canTransferFrom).callAsync, s = [e.from, e.to], i = b.valueToWei, c = [e.value], [4, this.decimals()];

              case 2:
                return [4, n.apply(r, s.concat([i.apply(void 0, c.concat([o.sent()])), t]))];

              case 3:
                return a = o.sent(), u = this.getTransferStatusCode(a[0]), [2, {
                  statusCode: u,
                  reasonCode: b.bytes32ToString(a[1])
                }];
            }
          });
        });
      }, n.canTransferByPartition = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s, i, c, u;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return l.default.isETHAddressHex("from", e.from), l.default.isETHAddressHex("to", e.to), t = e.data || b.stringToBytes32(""), l.default.isHexString("data", t), [4, this.contract];

              case 1:
                return n = (r = o.sent().canTransferByPartition).callAsync, s = [e.from, e.to, b.stringToBytes32(e.partition)], i = b.valueToWei, c = [e.value], [4, this.decimals()];

              case 2:
                return [4, n.apply(r, s.concat([i.apply(void 0, c.concat([o.sent()])), t]))];

              case 3:
                return a = o.sent(), u = this.getTransferStatusCode(a[0]), [2, {
                  statusCode: u,
                  reasonCode: b.bytes32ToString(a[1]),
                  partition: b.parsePartitionBytes32Value(a[2])
                }];
            }
          });
        });
      }, n.setDocument = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return l.default.assert(e.name.length > 0, p.ErrorCode.InvalidData, "Bad name, cannot be empty"), l.default.assert(e.uri.length > 0, p.ErrorCode.InvalidData, "Bad uri, cannot be empty"), [4, this.checkOnlyOwner(e.txData)];

              case 1:
                return t.sent(), [4, this.contract];

              case 2:
                return [2, t.sent().setDocument.sendTransactionAsync(b.stringToBytes32(e.name), e.uri, b.stringToBytes32(e.documentHash), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.removeDocument = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.checkOnlyOwner(e.txData)];

              case 1:
                return a.sent(), [4, this.getDocument({
                  name: e.name
                })];

              case 2:
                return t = a.sent(), l.default.assert(0 !== t.documentUri.length, p.ErrorCode.NotFound, "Document does not exist"), [4, this.contract];

              case 3:
                return [2, a.sent().removeDocument.sendTransactionAsync(b.stringToBytes32(e.name), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.getDocument = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, a.sent().getDocument.callAsync(b.stringToBytes32(e.name))];

              case 2:
                return t = a.sent(), [2, {
                  documentUri: t[0],
                  documentHash: b.bytes32ToString(t[1]),
                  documentTime: b.bigNumberToDate(t[2])
                }];
            }
          });
        });
      }, n.getAllDocuments = function () {
        return s(n, void 0, void 0, function () {
          var e;
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return e = b.bytes32ArrayToStringArray, [4, this.contract];

              case 1:
                return [4, t.sent().getAllDocuments.callAsync()];

              case 2:
                return [2, e.apply(void 0, [t.sent()])];
            }
          });
        });
      }, n.signTransferData = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s, c;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return [4, Promise.all([this.getCallerAddress({}), this.getModulesByName({
                  moduleName: p.ModuleName.GeneralTransferManager
                }), this.getCurrentNonce({})])];

              case 1:
                return t = i.apply(void 0, [o.sent(), 3]), a = t[0], r = t[1], n = t[2], s = y.getHashedTransferData(r[0], e.investorsData, e.validFrom, e.validTo, n), [4, this.web3Wrapper.signMessageAsync(a, s)];

              case 2:
                return c = o.sent(), [2, y.encodeSignedTransferData(r[0], e.investorsData, e.validFrom, e.validTo, n, c)];
            }
          });
        });
      }, n.signFreezeIssuanceAck = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return [4, Promise.all([this.getCallerAddress(e), this.web3Wrapper.getNetworkIdAsync(), this.address()])];

              case 1:
                return t = i.apply(void 0, [o.sent(), 3]), a = t[0], r = t[1], n = t[2], s = y.getFreezeIssuanceTypedData(r, n), [2, this.web3Wrapper.signTypedDataAsync(a, s)];
            }
          });
        });
      }, n.signDisableControllerAck = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return [4, Promise.all([this.getCallerAddress(e), this.web3Wrapper.getNetworkIdAsync(), this.address()])];

              case 1:
                return t = i.apply(void 0, [o.sent(), 3]), a = t[0], r = t[1], n = t[2], s = y.getDisableControllerTypedData(r, n), [2, this.web3Wrapper.signTypedDataAsync(a, s)];
            }
          });
        });
      }, n.getCurrentNonce = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return r = (a = this.web3Wrapper).sendRawPayloadAsync, n = {
                  method: "eth_getTransactionCount"
                }, [4, this.getCallerAddress(e)];

              case 1:
                return [4, r.apply(a, [(n.params = [s.sent(), "latest"], n)])];

              case 2:
                return t = s.sent(), [2, new u.BigNumber(t).toNumber()];
            }
          });
        });
      }, n.checkModuleExists = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = l.default).assert, [4, this.getModule({
                  moduleAddress: e
                })];

              case 1:
                return a.apply(t, ["" !== r.sent().name, p.ErrorCode.NotFound, "Module does not exist"]), [2];
            }
          });
        });
      }, n.checkIsArchived = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = l.default).assert, [4, this.getModule({
                  moduleAddress: e
                })];

              case 1:
                return a.apply(t, [r.sent().archived, p.ErrorCode.PreconditionRequired, "Module is not yet archived"]), [2];
            }
          });
        });
      }, n.checkIsNotArchived = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = l.default).assert, [4, this.getModule({
                  moduleAddress: e
                })];

              case 1:
                return a.apply(t, [!r.sent().archived, p.ErrorCode.PreconditionRequired, "Module is archived"]), [2];
            }
          });
        });
      }, n.checkModuleStructAddressIsNotZero = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return a = (t = l.default).isNonZeroETHAddressHex, r = ["address"], [4, this.getModule({
                  moduleAddress: e
                })];

              case 1:
                return a.apply(t, r.concat([n.sent().address])), [2];
            }
          });
        });
      }, n.checkModuleStructAddressIsEmpty = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = l.default).assert, n = (r = m.default).checksumAddressComparision, [4, this.getModule({
                  moduleAddress: e
                })];

              case 1:
                return a.apply(t, [n.apply(r, [s.sent().address, "0x0000000000000000000000000000000000000000"]), p.ErrorCode.AlreadyExists, "Module already exists at that address"]), [2];
            }
          });
        });
      }, n.checkIsControllable = function () {
        return s(n, void 0, void 0, function () {
          var e, t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return t = (e = l.default).assert, [4, this.isControllable()];

              case 1:
                return t.apply(e, [a.sent(), p.ErrorCode.PreconditionRequired, "Controller currently disabled"]), [2];
            }
          });
        });
      }, n.checkBalanceFromGreaterThanValue = function (e, t) {
        return s(n, void 0, void 0, function () {
          var a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return r = (a = l.default).assert, [4, this.balanceOf({
                  owner: e
                })];

              case 1:
                return r.apply(a, [n.sent().isGreaterThanOrEqualTo(t), p.ErrorCode.InsufficientBalance, "Insufficient balance for inputted value"]), [2];
            }
          });
        });
      }, n.checkModuleCostBelowMaxCost = function (e, t) {
        return s(n, void 0, void 0, function () {
          var a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return [4, this.moduleFactoryContract(e)];

              case 1:
                return [4, o.sent().setupCostInPoly.callAsync()];

              case 2:
                return a = o.sent(), l.default.assert(t.isGreaterThanOrEqualTo(a), p.ErrorCode.InsufficientBalance, "Insufficient max cost to cover module factory setup cost"), [4, this.polyTokenContract()];

              case 3:
                return s = (n = o.sent().balanceOf).callAsync, [4, this.address()];

              case 4:
                return [4, s.apply(n, [o.sent()])];

              case 5:
                return r = o.sent(), l.default.assert(r.isGreaterThanOrEqualTo(a), p.ErrorCode.InsufficientBalance, "Insufficient poly token balance for module cost"), [2];
            }
          });
        });
      }, n.checkOnlyOwner = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return a = (t = l.default).assert, n = (r = m.default).checksumAddressComparision, [4, this.owner()];

              case 1:
                return s = [o.sent()], [4, this.getCallerAddress(e)];

              case 2:
                return a.apply(t, [n.apply(r, s.concat([o.sent()])), p.ErrorCode.Unauthorized, "Msg sender must be owner"]), [2];
            }
          });
        });
      }, n.checkMsgSenderIsController = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = l.default).assert, [4, this.isControllable()];

              case 1:
                return (r = s.sent()) ? [4, this.controller()] : [3, 4];

              case 2:
                return n = s.sent(), [4, this.getCallerAddress(e)];

              case 3:
                r = n === s.sent(), s.label = 4;

              case 4:
                return a.apply(t, [r, p.ErrorCode.Unauthorized, "Msg sender must be controller"]), [2];
            }
          });
        });
      }, n.checkUseModuleVerified = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s, i, c, u;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return [4, this.featureRegistryContract()];

              case 1:
                return [4, o.sent().getFeatureStatus.callAsync(p.Feature.CustomModulesAllowed)];

              case 2:
                return o.sent() ? [4, this.moduleFactoryContract(e)] : [3, 7];

              case 3:
                return [4, o.sent().owner.callAsync()];

              case 4:
                return a = o.sent(), [4, this.owner()];

              case 5:
                return t = a === o.sent(), n = (r = l.default).assert, [4, this.checkForRegisteredModule(e)];

              case 6:
                return n.apply(r, [o.sent() || t, p.ErrorCode.Unauthorized, "ModuleFactory must be verified or SecurityToken owner must be ModuleFactory owner"]), [3, 9];

              case 7:
                return i = (s = l.default).assert, [4, this.checkForRegisteredModule(e)];

              case 8:
                i.apply(s, [o.sent(), p.ErrorCode.Unauthorized, "ModuleFactory must be verified"]), o.label = 9;

              case 9:
                return u = (c = l.default).assert, [4, this.isCompatibleModule(e)];

              case 10:
                return u.apply(c, [o.sent(), p.ErrorCode.InvalidVersion, "Version should within the compatible range of ST"]), [2];
            }
          });
        });
      }, n.checkFreezeIssuanceSignature = function (e, t) {
        return s(n, void 0, void 0, function () {
          var a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return [4, Promise.all([this.web3Wrapper.getNetworkIdAsync(), this.address()])];

              case 1:
                return a = i.apply(void 0, [o.sent(), 2]), r = a[0], n = a[1], s = y.getFreezeIssuanceTypedData(r, n), l.default.isHexString("signature", e), l.default.assert(f.recoverTypedSignature({
                  data: s,
                  sig: e
                }) === t, p.ErrorCode.PreconditionRequired, "Message must be signed by Security Token owner"), [2];
            }
          });
        });
      }, n.checkDisableControllerSignature = function (e, t) {
        return s(n, void 0, void 0, function () {
          var a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return [4, Promise.all([this.web3Wrapper.getNetworkIdAsync(), this.address()])];

              case 1:
                return a = i.apply(void 0, [o.sent(), 2]), r = a[0], n = a[1], s = y.getDisableControllerTypedData(r, n), l.default.isHexString("signature", e), l.default.assert(f.recoverTypedSignature({
                  data: s,
                  sig: e
                }) === t, p.ErrorCode.PreconditionRequired, "Message must be signed by Security Token owner"), [2];
            }
          });
        });
      }, n.checkForRegisteredModule = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, this.moduleRegistryContract()];

              case 1:
                return [4, (t = n.sent()).getModulesByType.callAsync(p.ModuleType.PermissionManager)];

              case 2:
                return r = [n.sent()], [4, t.getModulesByType.callAsync(p.ModuleType.STO)];

              case 3:
                return r = r.concat([n.sent()]), [4, t.getModulesByType.callAsync(p.ModuleType.Burn)];

              case 4:
                return r = r.concat([n.sent()]), [4, t.getModulesByType.callAsync(p.ModuleType.Dividends)];

              case 5:
                return r = r.concat([n.sent()]), [4, t.getModulesByType.callAsync(p.ModuleType.TransferManager)];

              case 6:
                return r = r.concat([n.sent()]), [4, t.getModulesByType.callAsync(p.ModuleType.Wallet)];

              case 7:
                return a = r.concat([n.sent()]), [4, Promise.all(a.map(function (t) {
                  return t.includes(e);
                }))];

              case 8:
                return [2, n.sent().includes(!0)];
            }
          });
        });
      }, n.isCompatibleModule = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s, i, c;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return [4, this.getVersion()];

              case 1:
                return t = o.sent(), [4, this.moduleFactoryContract(e)];

              case 2:
                return [4, o.sent().getUpperSTVersionBounds.callAsync()];

              case 3:
                return a = o.sent().map(function (e) {
                  return new u.BigNumber(e);
                }), [4, this.moduleFactoryContract(e)];

              case 4:
                return [4, o.sent().getLowerSTVersionBounds.callAsync()];

              case 5:
                for (r = o.sent().map(function (e) {
                  return new u.BigNumber(e);
                }), n = a.every(function (e) {
                  return e.isZero();
                }), s = r.every(function (e) {
                  return e.isZero();
                }), i = !0, c = 0; c < 3; c += 1) {
                  i = i && (s || r[c].isLessThanOrEqualTo(t[c])) && (n || a[c].isGreaterThanOrEqualTo(t[c]));
                }

                return [2, i];
            }
          });
        });
      }, n.cappedSTOAssertions = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            return l.default.isBigNumberGreaterThanZero(e.rate, "Rate of token should be greater than 0"), l.default.isNonZeroETHAddressHex("Funds Receiver", e.fundsReceiver), l.default.isNonZeroETHAddressHex("Treasury Wallet", e.treasuryWallet), l.default.isFutureDate(e.startTime, "Start time date not valid"), l.default.assert(e.endTime > e.startTime, p.ErrorCode.TooEarly, "End time not valid"), l.default.isBigNumberGreaterThanZero(e.cap, "Cap should be greater than 0"), l.default.isNonZeroETHAddressHex("Treasury wallet", e.treasuryWallet), [2];
          });
        });
      }, n.usdTieredSTOAssertions = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            for (l.default.isFutureDate(e.startTime, "Start time date not valid"), l.default.assert(e.endTime > e.startTime, p.ErrorCode.TooEarly, "End time not valid"), l.default.assert(e.tokensPerTierTotal.length > 0, p.ErrorCode.InvalidData, "No tiers provided"), l.default.areValidArrayLengths([e.ratePerTier, e.tokensPerTierTotal, e.ratePerTierDiscountPoly, e.tokensPerTierDiscountPoly], "Tier data length mismatch"), t = 0; t < e.ratePerTier.length; t += 1) {
              l.default.isBigNumberGreaterThanZero(e.ratePerTier[t], "Rate per tier should be greater than 0"), l.default.isBigNumberGreaterThanZero(e.tokensPerTierTotal[t], "Invalid token amount"), l.default.assert(e.tokensPerTierDiscountPoly[t].isLessThanOrEqualTo(e.tokensPerTierTotal[t]), p.ErrorCode.InvalidData, "Too many discounted tokens"), l.default.assert(e.ratePerTierDiscountPoly[t].isLessThanOrEqualTo(e.ratePerTier[t]), p.ErrorCode.InvalidData, "Invalid discount");
            }

            return l.default.assert(e.fundRaiseTypes.length > 0 && e.fundRaiseTypes.length <= 3, p.ErrorCode.InvalidData, "Raise type is not specified"), l.default.isNonZeroETHAddressHex("Wallet", e.wallet), l.default.isNonZeroETHAddressHex("ReserveWallet", e.treasuryWallet), e.stableTokens.forEach(function (e) {
              return l.default.isNonZeroETHAddressHex("stableTokens", e);
            }), e.customOracleAddresses.length > 0 ? (e.fundRaiseTypes.includes(p.FundRaiseType.ETH) && l.default.isNonZeroETHAddressHex("ETH Oracle Address", e.customOracleAddresses[0]), e.fundRaiseTypes.includes(p.FundRaiseType.POLY) && l.default.isNonZeroETHAddressHex("POLY Oracle Address", e.customOracleAddresses[1]), l.default.assert("" !== e.denominatedCurrency, p.ErrorCode.InvalidData, "Denominated Currency not provided"), l.default.assert(2 === e.customOracleAddresses.length, p.ErrorCode.InvalidLength, "Invalid customOracleAddresses length")) : l.default.assert("" === e.denominatedCurrency, p.ErrorCode.InvalidData, "Invalid denominatedCurrencySymbol"), [2];
          });
        });
      }, n.subscribeAsync = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return l.default.doesBelongToStringEnum("eventName", e.eventName, u.SecurityTokenEvents_3_0_0), l.default.doesConformToSchema("indexFilterValues", e.indexFilterValues, d.schemas.indexFilterValuesSchema), l.default.isFunction("callback", e.callback), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.subscribeInternal(t, e.eventName, e.indexFilterValues, e.callback, e.isVerbose)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.getLogsAsync = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return l.default.doesBelongToStringEnum("eventName", e.eventName, u.SecurityTokenEvents_3_0_0), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.getLogsAsyncInternal(t, e.eventName, e.blockRange, e.indexFilterValues)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.contract = a, n.contractFactory = r, n;
    }

    return n(t, e), t.prototype.addModuleRequirementsAndGetData = function (e) {
      return s(this, void 0, void 0, function () {
        var t, a, r, n, s;
        return o(this, function (o) {
          switch (o.label) {
            case 0:
              return t = void 0 === e.maxCost ? _ : b.valueToWei(e.maxCost, p.FULL_DECIMALS), a = void 0 === e.budget ? _ : b.valueToWei(e.budget, p.FULL_DECIMALS), l.default.isETHAddressHex("address", e.address), [4, this.checkOnlyOwner(e.txData)];

            case 1:
              return o.sent(), [4, this.checkModuleCostBelowMaxCost(e.address, t)];

            case 2:
              return o.sent(), [4, this.checkModuleStructAddressIsEmpty(e.address)];

            case 3:
              return o.sent(), [4, this.checkUseModuleVerified(e.address)];

            case 4:
              return o.sent(), [4, this.decimals()];

            case 5:
              switch (r = o.sent(), e.moduleName) {
                case p.ModuleName.VestingEscrowWallet:
                  return [3, 6];

                case p.ModuleName.CountTransferManager:
                  return [3, 7];

                case p.ModuleName.PercentageTransferManager:
                  return [3, 8];

                case p.ModuleName.RestrictedPartialSaleTM:
                  return [3, 9];

                case p.ModuleName.CappedSTO:
                  return [3, 10];

                case p.ModuleName.UsdTieredSTO:
                  return [3, 12];

                case p.ModuleName.ERC20DividendCheckpoint:
                  return [3, 14];

                case p.ModuleName.EtherDividendCheckpoint:
                  return [3, 15];
              }

              return [3, 16];

            case 6:
              return n = new u.ethersUtils.Interface(u.VestingEscrowWalletContract_3_0_0.ABI()), s = n.functions.configure.encode([e.data.treasuryWallet]), [3, 17];

            case 7:
              return n = new u.ethersUtils.Interface(u.CountTransferManagerContract_3_0_0.ABI()), s = n.functions.configure.encode([e.data.maxHolderCount]), [3, 17];

            case 8:
              return n = new u.ethersUtils.Interface(u.PercentageTransferManagerContract_3_0_0.ABI()), s = n.functions.configure.encode([b.valueToWei(e.data.maxHolderPercentage, p.PERCENTAGE_DECIMALS).toString(), e.data.allowPrimaryIssuance]), [3, 17];

            case 9:
              return n = new u.ethersUtils.Interface(u.RestrictedPartialSaleTMContract_3_1_0.ABI()), s = n.functions.configure.encode([e.data.treasuryWallet]), [3, 17];

            case 10:
              return [4, this.cappedSTOAssertions(e.data)];

            case 11:
              return o.sent(), n = new u.ethersUtils.Interface(u.CappedSTOContract_3_1_0.ABI()), s = n.functions.configure.encode([b.dateToBigNumber(e.data.startTime).toNumber(), b.dateToBigNumber(e.data.endTime).toNumber(), b.valueToWei(e.data.cap, r).toString(), b.valueToWei(e.data.rate, p.FULL_DECIMALS).toString(), [e.data.fundRaiseType], e.data.fundsReceiver, e.data.treasuryWallet]), [3, 17];

            case 12:
              return [4, this.usdTieredSTOAssertions(e.data)];

            case 13:
              return o.sent(), n = new u.ethersUtils.Interface(u.USDTieredSTOContract_3_1_0.ABI()), s = n.functions.configure.encode([b.dateToBigNumber(e.data.startTime).toNumber(), b.dateToBigNumber(e.data.endTime).toNumber(), e.data.ratePerTier.map(function (e) {
                return b.valueToWei(e, p.FULL_DECIMALS).toString();
              }), e.data.ratePerTierDiscountPoly.map(function (e) {
                return b.valueToWei(e, p.FULL_DECIMALS).toString();
              }), e.data.tokensPerTierTotal.map(function (e) {
                return b.valueToWei(e, r).toString();
              }), e.data.tokensPerTierDiscountPoly.map(function (e) {
                return b.valueToWei(e, r).toString();
              }), b.valueToWei(e.data.nonAccreditedLimitUSD, p.FULL_DECIMALS).toString(), b.valueToWei(e.data.minimumInvestmentUSD, p.FULL_DECIMALS).toString(), e.data.fundRaiseTypes, e.data.wallet, e.data.treasuryWallet, e.data.stableTokens, e.data.customOracleAddresses, b.stringToBytes32(e.data.denominatedCurrency)]), [3, 17];

            case 14:
              return l.default.isNonZeroETHAddressHex("Wallet", e.data.wallet), n = new u.ethersUtils.Interface(u.ERC20DividendCheckpointContract_3_0_0.ABI()), s = n.functions.configure.encode([e.data.wallet]), [3, 17];

            case 15:
              return l.default.isNonZeroETHAddressHex("Wallet", e.data.wallet), n = new u.ethersUtils.Interface(u.EtherDividendCheckpointContract_3_0_0.ABI()), s = n.functions.configure.encode([e.data.wallet]), [3, 17];

            case 16:
              return s = "0x0000000000000000", [3, 17];

            case 17:
              return [2, {
                maxCost: t,
                budget: a,
                data: s
              }];
          }
        });
      });
    }, t;
  }(h.default);

  t.default = g, t.isSecurityToken = function (e) {
    return e instanceof g;
  };
},
/*!****************************************************************!*\
  !*** ./src/contract_wrappers/tokens/erc20_detailed_wrapper.ts ***!
  \****************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r26,
      n = this && this.__extends || (_r26 = function r(e, t) {
    return (_r26 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r26(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      i = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var c = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      u = a(
  /*! @0x/json-schemas */
  2),
      d = i(a(
  /*! ./erc20_wrapper */
  142)),
      f = a(
  /*! ../../types */
  4),
      l = i(a(
  /*! ../../utils/assert */
  15)),
      h = function (e) {
    function t(t, a) {
      var r = e.call(this, t, a) || this;
      return r.contractVersion = f.ContractVersion.V3_0_0, r.subscribeAsync = function (e) {
        return s(r, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return l.default.doesBelongToStringEnum("eventName", e.eventName, c.ERC20DetailedEvents_3_0_0), l.default.doesConformToSchema("indexFilterValues", e.indexFilterValues, u.schemas.indexFilterValuesSchema), l.default.isFunction("callback", e.callback), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.subscribeInternal(t, e.eventName, e.indexFilterValues, e.callback, e.isVerbose)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, r.getLogsAsync = function (e) {
        return s(r, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return l.default.doesBelongToStringEnum("eventName", e.eventName, c.ERC20DetailedEvents_3_0_0), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.getLogsAsyncInternal(t, e.eventName, e.blockRange, e.indexFilterValues)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, r.contract = a, r;
    }

    return n(t, e), t;
  }(d.default);

  t.default = h;
},
/*!*********************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/checkpoint/erc20_dividend_checkpoint_wrapper/index.ts ***!
  \*********************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r27,
      n = this && this.__extends || (_r27 = function r(e, t) {
    return (_r27 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r27(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__importStar || function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var a in e) {
      Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t.default = e, t;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = a(
  /*! ./3.0.0 */
  840);
  t.ERC20DividendCheckpoint_3_0_0 = o.ERC20DividendCheckpoint_3_0_0, t.isERC20DividendCheckpoint_3_0_0 = o.isERC20DividendCheckpoint_3_0_0;
  var i = s(a(
  /*! ./common */
  296));
  t.isERC20DividendCheckpoint = i.isERC20DividendCheckpoint;
  var c = a(
  /*! @polymathnetwork/abi-wrappers */
  6);
  t.ERC20DividendCheckpointEvents = c.ERC20DividendCheckpointEvents_3_0_0;

  var u = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }

    return n(t, e), t;
  }(i.default);

  t.ERC20DividendCheckpointCommon = u;
},
/*!**********************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/checkpoint/erc20_dividend_checkpoint_wrapper/common.ts ***!
  \**********************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r28,
      n = this && this.__extends || (_r28 = function r(e, t) {
    return (_r28 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r28(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      i = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var c = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      u = a(
  /*! @0x/json-schemas */
  2),
      d = i(a(
  /*! ../../../../utils/assert */
  15)),
      f = a(
  /*! ../dividend_checkpoint_wrapper */
  93),
      l = a(
  /*! ../../../../types */
  4),
      h = a(
  /*! ../../../../utils/convert */
  16),
      p = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.erc20DetailedContract = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            return [2, this.contractFactory.getERC20DetailedContract(e)];
          });
        });
      }, n.getDecimals = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.dividendTokens({
                  dividendIndex: e
                })];

              case 1:
                return t = a.sent(), [4, this.erc20DetailedContract(t)];

              case 2:
                return [4, a.sent().decimals.callAsync()];

              case 3:
                return [2, a.sent()];
            }
          });
        });
      }, n.dividendTokens = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, t.sent().dividendTokens.callAsync(h.numberToBigNumber(e.dividendIndex))];
            }
          });
        });
      }, n.createDividend = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                return a.apply(t, [n.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.checkIfDividendCreationIsValid(e.expiry, e.maturity, e.amount, e.name, e.token, e.txData)];

              case 2:
                return n.sent(), [4, this.erc20DetailedContract(e.token)];

              case 3:
                return [4, n.sent().decimals.callAsync()];

              case 4:
                return r = n.sent(), [4, this.contract];

              case 5:
                return [2, n.sent().createDividend.sendTransactionAsync(h.dateToBigNumber(e.maturity), h.dateToBigNumber(e.expiry), e.token, h.valueToWei(e.amount, r), h.stringToBytes32(e.name), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.createDividendWithCheckpoint = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                return a.apply(t, [n.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.checkIfDividendCreationIsValid(e.expiry, e.maturity, e.amount, e.name, e.token, e.txData, e.checkpointId)];

              case 2:
                return n.sent(), [4, this.erc20DetailedContract(e.token)];

              case 3:
                return [4, n.sent().decimals.callAsync()];

              case 4:
                return r = n.sent(), [4, this.contract];

              case 5:
                return [2, n.sent().createDividendWithCheckpoint.sendTransactionAsync(h.dateToBigNumber(e.maturity), h.dateToBigNumber(e.expiry), e.token, h.valueToWei(e.amount, r), h.numberToBigNumber(e.checkpointId), h.stringToBytes32(e.name), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.createDividendWithExclusions = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                return a.apply(t, [n.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.checkIfDividendCreationIsValid(e.expiry, e.maturity, e.amount, e.name, e.token, e.txData, void 0, e.excluded)];

              case 2:
                return n.sent(), [4, this.erc20DetailedContract(e.token)];

              case 3:
                return [4, n.sent().decimals.callAsync()];

              case 4:
                return r = n.sent(), [4, this.contract];

              case 5:
                return [2, n.sent().createDividendWithExclusions.sendTransactionAsync(h.dateToBigNumber(e.maturity), h.dateToBigNumber(e.expiry), e.token, h.valueToWei(e.amount, r), e.excluded, h.stringToBytes32(e.name), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.createDividendWithCheckpointAndExclusions = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                return a.apply(t, [n.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.checkIfDividendCreationIsValid(e.expiry, e.maturity, e.amount, e.name, e.token, e.txData, e.checkpointId, e.excluded)];

              case 2:
                return n.sent(), [4, this.erc20DetailedContract(e.token)];

              case 3:
                return [4, n.sent().decimals.callAsync()];

              case 4:
                return r = n.sent(), [4, this.contract];

              case 5:
                return [2, n.sent().createDividendWithCheckpointAndExclusions.sendTransactionAsync(h.dateToBigNumber(e.maturity), h.dateToBigNumber(e.expiry), e.token, h.valueToWei(e.amount, r), h.numberToBigNumber(e.checkpointId), e.excluded, h.stringToBytes32(e.name), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.subscribeAsync = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return d.default.doesBelongToStringEnum("eventName", e.eventName, c.ERC20DividendCheckpointEvents_3_0_0), d.default.doesConformToSchema("indexFilterValues", e.indexFilterValues, u.schemas.indexFilterValuesSchema), d.default.isFunction("callback", e.callback), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.subscribeInternal(t, e.eventName, e.indexFilterValues, e.callback, e.isVerbose)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.getLogsAsync = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return d.default.doesBelongToStringEnum("eventName", e.eventName, c.ERC20DividendCheckpointEvents_3_0_0), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.getLogsAsyncInternal(t, e.eventName, e.blockRange, e.indexFilterValues)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.contract = a, n;
    }

    return n(t, e), t;
  }(f.DividendCheckpointCommon);

  t.default = p, t.isERC20DividendCheckpoint = function (e) {
    return e instanceof p;
  };
},
/*!*********************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/checkpoint/ether_dividend_checkpoint_wrapper/index.ts ***!
  \*********************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r29,
      n = this && this.__extends || (_r29 = function r(e, t) {
    return (_r29 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r29(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__importStar || function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var a in e) {
      Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t.default = e, t;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = a(
  /*! ./3.0.0 */
  845);
  t.EtherDividendCheckpoint_3_0_0 = o.EtherDividendCheckpoint_3_0_0, t.isEtherDividendCheckpoint_3_0_0 = o.isEtherDividendCheckpoint_3_0_0;
  var i = s(a(
  /*! ./common */
  298));
  t.isEtherDividendCheckpoint = i.isEtherDividendCheckpoint;
  var c = a(
  /*! @polymathnetwork/abi-wrappers */
  6);
  t.EtherDividendCheckpointEvents = c.EtherDividendCheckpointEvents_3_0_0;

  var u = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }

    return n(t, e), t;
  }(i.default);

  t.EtherDividendCheckpointCommon = u;
},
/*!**********************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/checkpoint/ether_dividend_checkpoint_wrapper/common.ts ***!
  \**********************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r30,
      n = this && this.__extends || (_r30 = function r(e, t) {
    return (_r30 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r30(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      c = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var u = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      d = a(
  /*! @0x/json-schemas */
  2),
      f = c(a(
  /*! ../../../../utils/assert */
  15)),
      l = a(
  /*! ../dividend_checkpoint_wrapper */
  93),
      h = a(
  /*! ../../../../types */
  4),
      p = a(
  /*! ../../../../utils/convert */
  16),
      b = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.contractVersion = h.ContractVersion.V3_0_0, n.getDecimals = function () {
        return o(n, void 0, void 0, function () {
          return i(this, function (e) {
            return [2, new u.BigNumber(18)];
          });
        });
      }, n.createDividend = function (e) {
        return o(n, void 0, void 0, function () {
          var t, a, r, n, o, c, u;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                return a.apply(t, [i.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), n = [{}, e.txData], o = {}, c = p.valueToWei, u = [e.value], [4, this.getDecimals()];

              case 2:
                return r = s.apply(void 0, n.concat([(o.value = c.apply(void 0, u.concat([i.sent()])), o)])), [4, this.checkIfDividendCreationIsValid(e.expiry, e.maturity, e.value, e.name, void 0, r)];

              case 3:
                return i.sent(), [4, this.contract];

              case 4:
                return [2, i.sent().createDividend.sendTransactionAsync(p.dateToBigNumber(e.maturity), p.dateToBigNumber(e.expiry), p.stringToBytes32(e.name), r, e.safetyFactor)];
            }
          });
        });
      }, n.createDividendWithCheckpoint = function (e) {
        return o(n, void 0, void 0, function () {
          var t, a, r, n, o, c, u;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                return a.apply(t, [i.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), n = [{}, e.txData], o = {}, c = p.valueToWei, u = [e.value], [4, this.getDecimals()];

              case 2:
                return r = s.apply(void 0, n.concat([(o.value = c.apply(void 0, u.concat([i.sent()])), o)])), [4, this.checkIfDividendCreationIsValid(e.expiry, e.maturity, e.value, e.name, void 0, r, e.checkpointId)];

              case 3:
                return i.sent(), [4, this.contract];

              case 4:
                return [2, i.sent().createDividendWithCheckpoint.sendTransactionAsync(p.dateToBigNumber(e.maturity), p.dateToBigNumber(e.expiry), p.numberToBigNumber(e.checkpointId), p.stringToBytes32(e.name), r, e.safetyFactor)];
            }
          });
        });
      }, n.createDividendWithExclusions = function (e) {
        return o(n, void 0, void 0, function () {
          var t, a, r, n, o, c, u;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                return a.apply(t, [i.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), n = [{}, e.txData], o = {}, c = p.valueToWei, u = [e.value], [4, this.getDecimals()];

              case 2:
                return r = s.apply(void 0, n.concat([(o.value = c.apply(void 0, u.concat([i.sent()])), o)])), [4, this.checkIfDividendCreationIsValid(e.expiry, e.maturity, e.value, e.name, void 0, r, void 0, e.excluded)];

              case 3:
                return i.sent(), [4, this.contract];

              case 4:
                return [2, i.sent().createDividendWithExclusions.sendTransactionAsync(p.dateToBigNumber(e.maturity), p.dateToBigNumber(e.expiry), e.excluded, p.stringToBytes32(e.name), r, e.safetyFactor)];
            }
          });
        });
      }, n.createDividendWithCheckpointAndExclusions = function (e) {
        return o(n, void 0, void 0, function () {
          var t, a, r, n, o, c, u;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                return a.apply(t, [i.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), n = [{}, e.txData], o = {}, c = p.valueToWei, u = [e.value], [4, this.getDecimals()];

              case 2:
                return r = s.apply(void 0, n.concat([(o.value = c.apply(void 0, u.concat([i.sent()])), o)])), [4, this.checkIfDividendCreationIsValid(e.expiry, e.maturity, e.value, e.name, void 0, r, e.checkpointId, e.excluded)];

              case 3:
                return i.sent(), [4, this.contract];

              case 4:
                return [2, i.sent().createDividendWithCheckpointAndExclusions.sendTransactionAsync(p.dateToBigNumber(e.maturity), p.dateToBigNumber(e.expiry), p.numberToBigNumber(e.checkpointId), e.excluded, p.stringToBytes32(e.name), r, e.safetyFactor)];
            }
          });
        });
      }, n.subscribeAsync = function (e) {
        return o(n, void 0, void 0, function () {
          var t;
          return i(this, function (a) {
            switch (a.label) {
              case 0:
                return f.default.doesBelongToStringEnum("eventName", e.eventName, u.EtherDividendCheckpointEvents_3_0_0), f.default.doesConformToSchema("indexFilterValues", e.indexFilterValues, d.schemas.indexFilterValuesSchema), f.default.isFunction("callback", e.callback), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.subscribeInternal(t, e.eventName, e.indexFilterValues, e.callback, e.isVerbose)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.getLogsAsync = function (e) {
        return o(n, void 0, void 0, function () {
          var t;
          return i(this, function (a) {
            switch (a.label) {
              case 0:
                return f.default.doesBelongToStringEnum("eventName", e.eventName, u.EtherDividendCheckpointEvents_3_0_0), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.getLogsAsyncInternal(t, e.eventName, e.blockRange, e.indexFilterValues)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.contract = a, n;
    }

    return n(t, e), t;
  }(l.DividendCheckpointCommon);

  t.default = b, t.isEtherDividendCheckpoint = function (e) {
    return e instanceof b;
  };
},
/*!******************************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/permission_manager/general_permission_manager_wrapper/index.ts ***!
  \******************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r31,
      n = this && this.__extends || (_r31 = function r(e, t) {
    return (_r31 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r31(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__importStar || function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var a in e) {
      Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t.default = e, t;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var i = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      c = a(
  /*! ./3.0.0 */
  846);
  t.GeneralPermissionManager_3_0_0 = c.GeneralPermissionManager_3_0_0, t.isGeneralPermissionManager_3_0_0 = c.isGeneralPermissionManager_3_0_0;
  var u = a(
  /*! ./3.1.0 */
  847);
  t.GeneralPermissionManager_3_1_0 = u.GeneralPermissionManager_3_1_0, t.isGeneralPermissionManager_3_1_0 = u.isGeneralPermissionManager_3_1_0;
  var d = o(a(
  /*! ./common */
  143));
  t.isGeneralPermissionManager = d.isGeneralPermissionManager, t.GeneralPermissionManagerEvents = s({}, i.GeneralPermissionManagerEvents_3_1_0, i.GeneralPermissionManagerEvents_3_0_0);

  var f = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }

    return n(t, e), t;
  }(d.default);

  t.GeneralPermissionManagerCommon = f;
},
/*!***********************************************************************!*\
  !*** ./src/contract_wrappers/modules/sto/capped_sto_wrapper/index.ts ***!
  \***********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r32,
      n = this && this.__extends || (_r32 = function r(e, t) {
    return (_r32 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r32(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__importStar || function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var a in e) {
      Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t.default = e, t;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var i = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      c = a(
  /*! ./3.0.0 */
  848);
  t.CappedSTO_3_0_0 = c.CappedSTO_3_0_0, t.isCappedSTO_3_0_0 = c.isCappedSTO_3_0_0;
  var u = a(
  /*! ./3.1.0 */
  852);
  t.CappedSTO_3_1_0 = u.CappedSTO_3_1_0, t.isCappedSTO_3_1_0 = u.isCappedSTO_3_1_0;
  var d = o(a(
  /*! ./common */
  144));
  t.isCappedSTO = d.isCappedSTO, t.CappedSTOEvents = s({}, i.CappedSTOEvents_3_1_0, i.CappedSTOEvents_3_0_0);

  var f = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }

    return n(t, e), t;
  }(d.default);

  t.CappedSTOCommon = f;
},
/*!***************************************************************************!*\
  !*** ./src/contract_wrappers/modules/sto/usd_tiered_sto_wrapper/index.ts ***!
  \***************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r33,
      n = this && this.__extends || (_r33 = function r(e, t) {
    return (_r33 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r33(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__importStar || function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var a in e) {
      Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t.default = e, t;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var i = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      c = a(
  /*! ./3.0.0 */
  853);
  t.USDTieredSTO_3_0_0 = c.USDTieredSTO_3_0_0, t.isUSDTieredSTO_3_0_0 = c.isUSDTieredSTO_3_0_0;
  var u = a(
  /*! ./3.1.0 */
  856);
  t.USDTieredSTO_3_1_0 = u.USDTieredSTO_3_1_0, t.isUSDTieredSTO_3_1_0 = u.isUSDTieredSTO_3_1_0;
  var d = o(a(
  /*! ./common */
  145));
  t.isUSDTieredSTO = d.isUSDTieredSTO, t.USDTieredSTOEvents = s({}, i.USDTieredSTOEvents_3_1_0, i.USDTieredSTOEvents_3_0_0);

  var f = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }

    return n(t, e), t;
  }(d.default);

  t.USDTieredSTOCommon = f;
},
/*!************************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/transfer_manager/count_transfer_manager_wrapper/index.ts ***!
  \************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r34,
      n = this && this.__extends || (_r34 = function r(e, t) {
    return (_r34 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r34(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__importStar || function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var a in e) {
      Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t.default = e, t;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = a(
  /*! ./3.0.0 */
  857);
  t.CountTransferManager_3_0_0 = o.CountTransferManager_3_0_0, t.isCountTransferManager_3_0_0 = o.isCountTransferManager_3_0_0;
  var i = s(a(
  /*! ./common */
  303));
  t.isCountTransferManager = i.isCountTransferManager;
  var c = a(
  /*! @polymathnetwork/abi-wrappers */
  6);
  t.CountTransferManagerEvents = c.CountTransferManagerEvents_3_0_0;

  var u = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }

    return n(t, e), t;
  }(i.default);

  t.CountTransferManagerCommon = u;
},
/*!*************************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/transfer_manager/count_transfer_manager_wrapper/common.ts ***!
  \*************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r35,
      n = this && this.__extends || (_r35 = function r(e, t) {
    return (_r35 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r35(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      i = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var c = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      u = a(
  /*! @0x/json-schemas */
  2),
      d = i(a(
  /*! ../../../../utils/assert */
  15)),
      f = a(
  /*! ../../../../utils/convert */
  16),
      l = a(
  /*! ../../../../types */
  4),
      h = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.maxHolderCount = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, e.sent().maxHolderCount.callAsync()];

              case 2:
                return [2, e.sent().toNumber()];
            }
          });
        });
      }, n.verifyTransfer = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return d.default.isETHAddressHex("from", e.from), d.default.isETHAddressHex("to", e.to), [4, this.securityTokenContract()];

              case 1:
                return [4, r.sent().decimals.callAsync()];

              case 2:
                return t = r.sent(), [4, this.contract];

              case 3:
                return [4, r.sent().verifyTransfer.callAsync(e.from, e.to, f.valueToWei(e.amount, t), e.data)];

              case 4:
                return a = r.sent(), [2, {
                  transferResult: f.parseTransferResult(a[0]),
                  address: a[1]
                }];
            }
          });
        });
      }, n.changeHolderCount = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                return a.apply(t, [r.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.contract];

              case 2:
                return [2, r.sent().changeHolderCount.sendTransactionAsync(f.numberToBigNumber(e.maxHolderCount), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.subscribeAsync = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return d.default.doesBelongToStringEnum("eventName", e.eventName, c.CountTransferManagerEvents_3_0_0), d.default.doesConformToSchema("indexFilterValues", e.indexFilterValues, u.schemas.indexFilterValuesSchema), d.default.isFunction("callback", e.callback), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.subscribeInternal(t, e.eventName, e.indexFilterValues, e.callback, e.isVerbose)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.getLogsAsync = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return d.default.doesBelongToStringEnum("eventName", e.eventName, c.CountTransferManagerEvents_3_0_0), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.getLogsAsyncInternal(t, e.eventName, e.blockRange, e.indexFilterValues)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.contract = a, n;
    }

    return n(t, e), t;
  }(a(
  /*! ../../module_wrapper */
  17).ModuleCommon);

  t.default = h, t.isCountTransferManager = function (e) {
    return e instanceof h;
  };
},
/*!**********************************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/transfer_manager/manual_approval_transfer_manager_wrapper/index.ts ***!
  \**********************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r36,
      n = this && this.__extends || (_r36 = function r(e, t) {
    return (_r36 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r36(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__importStar || function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var a in e) {
      Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t.default = e, t;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = a(
  /*! ./3.0.0 */
  858);
  t.ManualApprovalTransferManager_3_0_0 = o.ManualApprovalTransferManager_3_0_0, t.isManualApprovalTransferManager_3_0_0 = o.isManualApprovalTransferManager_3_0_0;
  var i = s(a(
  /*! ./common */
  305));
  t.isManualApprovalTransferManager = i.isManualApprovalTransferManager;
  var c = a(
  /*! @polymathnetwork/abi-wrappers */
  6);
  t.ManualApprovalTransferManagerEvents = c.ManualApprovalTransferManagerEvents_3_0_0;

  var u = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }

    return n(t, e), t;
  }(i.default);

  t.ManualApprovalTransferManagerCommon = u;
},
/*!***********************************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/transfer_manager/manual_approval_transfer_manager_wrapper/common.ts ***!
  \***********************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r37,
      n = this && this.__extends || (_r37 = function r(e, t) {
    return (_r37 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r37(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      i = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var c = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      u = a(
  /*! @0x/json-schemas */
  2),
      d = i(a(
  /*! ../../../../utils/assert */
  15)),
      f = a(
  /*! ../../module_wrapper */
  17),
      l = a(
  /*! ../../../../types */
  4),
      h = a(
  /*! ../../../../utils/convert */
  16),
      p = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.approvals = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, r.sent().approvals.callAsync(h.numberToBigNumber(e.index))];

              case 2:
                return t = r.sent(), [4, this.securityTokenContract()];

              case 3:
                return [4, r.sent().decimals.callAsync()];

              case 4:
                return a = r.sent(), [2, {
                  from: t[0],
                  to: t[1],
                  allowance: h.valueToWei(t[2], a),
                  expiryTime: h.bigNumberToDate(t[3]),
                  description: t[4]
                }];
            }
          });
        });
      }, n.verifyTransfer = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return d.default.isETHAddressHex("from", e.from), d.default.isETHAddressHex("to", e.to), [4, this.securityTokenContract()];

              case 1:
                return [4, r.sent().decimals.callAsync()];

              case 2:
                return t = r.sent(), [4, this.contract];

              case 3:
                return [4, r.sent().verifyTransfer.callAsync(e.from, e.to, h.valueToWei(e.amount, t), e.data)];

              case 4:
                return a = r.sent(), [2, {
                  transferResult: h.parseTransferResult(a[0]),
                  address: a[1]
                }];
            }
          });
        });
      }, n.addManualApproval = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                return a.apply(t, [n.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), d.default.isETHAddressHex("from", e.from), d.default.isNonZeroETHAddressHex("to", e.to), d.default.isFutureDate(e.expiryTime, "ExpiryTime must be in the future"), d.default.isBigNumberGreaterThanZero(e.allowance, "Allowance must be greater than 0"), [4, this.checkApprovalDoesNotExist(e.from, e.to)];

              case 2:
                return n.sent(), [4, this.securityTokenContract()];

              case 3:
                return [4, n.sent().decimals.callAsync()];

              case 4:
                return r = n.sent(), [4, this.contract];

              case 5:
                return [2, n.sent().addManualApproval.sendTransactionAsync(e.from, e.to, h.valueToWei(e.allowance, r), h.dateToBigNumber(e.expiryTime), h.stringToBytes32(e.description), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.addManualApprovalMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                for (a.apply(t, [o.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), e.from.forEach(function (e) {
                  return d.default.isETHAddressHex("from", e);
                }), e.to.forEach(function (e) {
                  return d.default.isNonZeroETHAddressHex("to", e);
                }), d.default.assert(e.from.length === e.to.length && e.from.length === e.allowances.length && e.from.length === e.expiryTimes.length && e.from.length === e.descriptions.length, l.ErrorCode.MismatchedArrayLength, "Array lengths mismatch"), e.expiryTimes.forEach(function (e) {
                  return d.default.isFutureDate(e, "ExpiryTime must be in the future");
                }), e.allowances.forEach(function (e) {
                  return d.default.isBigNumberGreaterThanZero(e, "Allowance must be greater than 0");
                }), r = [], n = 0; n < e.to.length; n += 1) {
                  r.push(this.checkApprovalDoesNotExist(e.from[n], e.to[n]));
                }

                return [4, Promise.all(r)];

              case 2:
                return o.sent(), [4, this.securityTokenContract()];

              case 3:
                return [4, o.sent().decimals.callAsync()];

              case 4:
                return s = o.sent(), [4, this.contract];

              case 5:
                return [2, o.sent().addManualApprovalMulti.sendTransactionAsync(e.from, e.to, h.valueArrayToWeiArray(e.allowances, s), h.dateArrayToBigNumberArray(e.expiryTimes), h.stringArrayToBytes32Array(e.descriptions), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.modifyManualApproval = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                return a.apply(t, [n.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), d.default.isETHAddressHex("from", e.from), d.default.isNonZeroETHAddressHex("to", e.to), d.default.isFutureDate(e.expiryTime, "ExpiryTime must be in the future"), [4, this.checkApprovalDoesExist(e.from, e.to)];

              case 2:
                return n.sent(), [4, this.securityTokenContract()];

              case 3:
                return [4, n.sent().decimals.callAsync()];

              case 4:
                return r = n.sent(), [4, this.contract];

              case 5:
                return [2, n.sent().modifyManualApproval.sendTransactionAsync(e.from, e.to, h.dateToBigNumber(e.expiryTime), h.valueToWei(e.changeInAllowance, r), h.stringToBytes32(e.description), e.increase, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.modifyManualApprovalMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                for (a.apply(t, [o.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), e.from.forEach(function (e) {
                  return d.default.isETHAddressHex("from", e);
                }), e.to.forEach(function (e) {
                  return d.default.isNonZeroETHAddressHex("to", e);
                }), d.default.assert(e.from.length === e.to.length && e.from.length === e.changedAllowances.length && e.from.length === e.expiryTimes.length && e.from.length === e.descriptions.length, l.ErrorCode.MismatchedArrayLength, "Array lengths mismatch"), e.expiryTimes.forEach(function (e) {
                  return d.default.isFutureDate(e, "ExpiryTime must be in the future");
                }), r = [], n = 0; n < e.to.length; n += 1) {
                  r.push(this.checkApprovalDoesExist(e.from[n], e.to[n]));
                }

                return [4, Promise.all(r)];

              case 2:
                return o.sent(), [4, this.securityTokenContract()];

              case 3:
                return [4, o.sent().decimals.callAsync()];

              case 4:
                return s = o.sent(), [4, this.contract];

              case 5:
                return [2, o.sent().modifyManualApprovalMulti.sendTransactionAsync(e.from, e.to, h.dateArrayToBigNumberArray(e.expiryTimes), h.valueArrayToWeiArray(e.changedAllowances, s), h.stringArrayToBytes32Array(e.descriptions), e.increase, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.revokeManualApproval = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                return a.apply(t, [r.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), d.default.isETHAddressHex("from", e.from), d.default.isETHAddressHex("to", e.to), [4, this.checkApprovalDoesExist(e.from, e.to)];

              case 2:
                return r.sent(), [4, this.contract];

              case 3:
                return [2, r.sent().revokeManualApproval.sendTransactionAsync(e.from, e.to, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.revokeManualApprovalMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                for (a.apply(t, [s.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), e.from.forEach(function (e) {
                  return d.default.isETHAddressHex("from", e);
                }), e.to.forEach(function (e) {
                  return d.default.isETHAddressHex("to", e);
                }), d.default.assert(e.to.length === e.from.length, l.ErrorCode.MismatchedArrayLength, "To and From address arrays must have the same length"), r = [], n = 0; n < e.to.length; n += 1) {
                  r.push(this.checkApprovalDoesExist(e.from[n], e.to[n]));
                }

                return [4, Promise.all(r)];

              case 2:
                return s.sent(), [4, this.contract];

              case 3:
                return [2, s.sent().revokeManualApprovalMulti.sendTransactionAsync(e.from, e.to, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.getActiveApprovalsToUser = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return d.default.isETHAddressHex("user", e.user), [4, this.contract];

              case 1:
                return [4, o.sent().getActiveApprovalsToUser.callAsync(e.user)];

              case 2:
                return t = o.sent(), a = [], [4, this.securityTokenContract()];

              case 3:
                return [4, o.sent().decimals.callAsync()];

              case 4:
                for (r = o.sent(), n = 0; n < t[0].length; n += 1) {
                  s = {
                    from: t[0][n],
                    to: t[1][n],
                    allowance: h.weiToValue(t[2][n], r),
                    expiryTime: h.bigNumberToDate(t[3][n]),
                    description: h.bytes32ToString(t[4][n])
                  }, a.push(s);
                }

                return [2, a];
            }
          });
        });
      }, n.getApprovalDetails = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return d.default.isETHAddressHex("from", e.from), d.default.isETHAddressHex("to", e.to), [4, this.contract];

              case 1:
                return [4, r.sent().getApprovalDetails.callAsync(e.from, e.to)];

              case 2:
                return t = r.sent(), [4, this.securityTokenContract()];

              case 3:
                return [4, r.sent().decimals.callAsync()];

              case 4:
                return a = r.sent(), [2, {
                  from: e.from,
                  to: e.to,
                  allowance: h.weiToValue(t[0], a),
                  expiryTime: h.bigNumberToDate(t[1]),
                  description: h.bytes32ToString(t[2])
                }];
            }
          });
        });
      }, n.getTotalApprovalsLength = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, e.sent().getTotalApprovalsLength.callAsync()];

              case 2:
                return [2, e.sent().toNumber()];
            }
          });
        });
      }, n.getAllApprovals = function () {
        return s(n, void 0, void 0, function () {
          var e, t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, s.sent().getAllApprovals.callAsync()];

              case 2:
                return e = s.sent(), [4, this.securityTokenContract()];

              case 3:
                return [4, s.sent().decimals.callAsync()];

              case 4:
                for (t = s.sent(), a = [], r = 0; r < e[0].length; r += 1) {
                  n = {
                    from: e[0][r],
                    to: e[1][r],
                    allowance: h.weiToValue(e[2][r], t),
                    expiryTime: h.bigNumberToDate(e[3][r]),
                    description: h.bytes32ToString(e[4][r])
                  }, a.push(n);
                }

                return [2, a];
            }
          });
        });
      }, n.checkApprovalDoesNotExist = function (e, t) {
        return s(n, void 0, void 0, function () {
          var a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.getApprovalDetails({
                  from: e,
                  to: t
                })];

              case 1:
                return a = r.sent(), d.default.isBigNumberZero(a.allowance, "Approval already exists with allowance"), d.default.isPastDate(a.expiryTime, "Approval already exists with valid future expiry date"), [2];
            }
          });
        });
      }, n.checkApprovalDoesExist = function (e, t) {
        return s(n, void 0, void 0, function () {
          var a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.getApprovalDetails({
                  from: e,
                  to: t
                })];

              case 1:
                return a = r.sent(), d.default.isBigNumberGreaterThanZero(a.allowance, "Approval does not exist"), d.default.isFutureDate(a.expiryTime, "Approval does not exist"), [2];
            }
          });
        });
      }, n.subscribeAsync = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return d.default.doesBelongToStringEnum("eventName", e.eventName, c.ManualApprovalTransferManagerEvents_3_0_0), d.default.doesConformToSchema("indexFilterValues", e.indexFilterValues, u.schemas.indexFilterValuesSchema), d.default.isFunction("callback", e.callback), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.subscribeInternal(t, e.eventName, e.indexFilterValues, e.callback, e.isVerbose)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.getLogsAsync = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return d.default.doesBelongToStringEnum("eventName", e.eventName, c.ManualApprovalTransferManagerEvents_3_0_0), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.getLogsAsyncInternal(t, e.eventName, e.blockRange, e.indexFilterValues)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.contract = a, n;
    }

    return n(t, e), t;
  }(f.ModuleCommon);

  t.default = p, t.isManualApprovalTransferManager = function (e) {
    return e instanceof p;
  };
},
/*!*****************************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/transfer_manager/percentage_transfer_manager_wrapper/index.ts ***!
  \*****************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r38,
      n = this && this.__extends || (_r38 = function r(e, t) {
    return (_r38 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r38(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__importStar || function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var a in e) {
      Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t.default = e, t;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = a(
  /*! ./3.0.0 */
  859);
  t.PercentageTransferManager_3_0_0 = o.PercentageTransferManager_3_0_0, t.isPercentageTransferManager_3_0_0 = o.isPercentageTransferManager_3_0_0;
  var i = s(a(
  /*! ./common */
  307));
  t.isPercentageTransferManager = i.isPercentageTransferManager;
  var c = a(
  /*! @polymathnetwork/abi-wrappers */
  6);
  t.PercentageTransferManagerEvents = c.PercentageTransferManagerEvents_3_0_0;

  var u = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }

    return n(t, e), t;
  }(i.default);

  t.PercentageTransferManagerCommon = u;
},
/*!******************************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/transfer_manager/percentage_transfer_manager_wrapper/common.ts ***!
  \******************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r39,
      n = this && this.__extends || (_r39 = function r(e, t) {
    return (_r39 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r39(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      i = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var c = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      u = a(
  /*! @0x/json-schemas */
  2),
      d = a(
  /*! ../../../../utils/convert */
  16),
      f = a(
  /*! ../../../../types */
  4),
      l = i(a(
  /*! ../../../../utils/assert */
  15)),
      h = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.allowPrimaryIssuance = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().allowPrimaryIssuance.callAsync()];
            }
          });
        });
      }, n.maxHolderPercentage = function () {
        return s(n, void 0, void 0, function () {
          var e;
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, t.sent().maxHolderPercentage.callAsync()];

              case 2:
                return e = t.sent(), [2, d.weiToValue(e, f.PERCENTAGE_DECIMALS)];
            }
          });
        });
      }, n.whitelist = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return l.default.isETHAddressHex("investorAddress", e.investorAddress), [4, this.contract];

              case 1:
                return [2, t.sent().whitelist.callAsync(e.investorAddress)];
            }
          });
        });
      }, n.verifyTransfer = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return l.default.isETHAddressHex("from", e.from), l.default.isETHAddressHex("to", e.to), [4, this.securityTokenContract()];

              case 1:
                return [4, r.sent().decimals.callAsync()];

              case 2:
                return t = r.sent(), [4, this.contract];

              case 3:
                return [4, r.sent().verifyTransfer.callAsync(e.from, e.to, d.valueToWei(e.amount, t), e.data)];

              case 4:
                return a = r.sent(), [2, {
                  transferResult: d.parseTransferResult(a[0]),
                  address: a[1]
                }];
            }
          });
        });
      }, n.changeHolderPercentage = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = l.default).assert, [4, this.isCallerAllowed(e.txData, f.Perm.Admin)];

              case 1:
                return a.apply(t, [r.sent(), f.ErrorCode.Unauthorized, "Caller is not allowed"]), l.default.isPercentage("maxHolderPercentage", e.maxHolderPercentage), [4, this.contract];

              case 2:
                return [2, r.sent().changeHolderPercentage.sendTransactionAsync(d.valueToWei(e.maxHolderPercentage, f.PERCENTAGE_DECIMALS), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.modifyWhitelist = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = l.default).assert, [4, this.isCallerAllowed(e.txData, f.Perm.Admin)];

              case 1:
                return a.apply(t, [r.sent(), f.ErrorCode.Unauthorized, "Caller is not allowed"]), l.default.isETHAddressHex("investor", e.investor), [4, this.contract];

              case 2:
                return [2, r.sent().modifyWhitelist.sendTransactionAsync(e.investor, e.valid, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.modifyWhitelistMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = l.default).assert, [4, this.isCallerAllowed(e.txData, f.Perm.Admin)];

              case 1:
                return a.apply(t, [r.sent(), f.ErrorCode.Unauthorized, "Caller is not allowed"]), l.default.assert(e.investors.length === e.valids.length, f.ErrorCode.MismatchedArrayLength, "Array lengths are not equal for investors and valids"), e.investors.forEach(function (e) {
                  return l.default.isETHAddressHex("investors", e);
                }), [4, this.contract];

              case 2:
                return [2, r.sent().modifyWhitelistMulti.sendTransactionAsync(e.investors, e.valids, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.setAllowPrimaryIssuance = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = l.default).assert, [4, this.isCallerAllowed(e.txData, f.Perm.Admin)];

              case 1:
                return a.apply(t, [s.sent(), f.ErrorCode.Unauthorized, "Caller is not allowed"]), n = (r = l.default).assert, [4, this.allowPrimaryIssuance()];

              case 2:
                return n.apply(r, [s.sent() !== e.allowPrimaryIssuance, f.ErrorCode.PreconditionRequired, "AllowPrimaryIssuance value must change "]), [4, this.contract];

              case 3:
                return [2, s.sent().setAllowPrimaryIssuance.sendTransactionAsync(e.allowPrimaryIssuance, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.subscribeAsync = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return l.default.doesBelongToStringEnum("eventName", e.eventName, c.PercentageTransferManagerEvents_3_0_0), l.default.doesConformToSchema("indexFilterValues", e.indexFilterValues, u.schemas.indexFilterValuesSchema), l.default.isFunction("callback", e.callback), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.subscribeInternal(t, e.eventName, e.indexFilterValues, e.callback, e.isVerbose)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.getLogsAsync = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return l.default.doesBelongToStringEnum("eventName", e.eventName, c.PercentageTransferManagerEvents_3_0_0), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.getLogsAsyncInternal(t, e.eventName, e.blockRange, e.indexFilterValues)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.contract = a, n;
    }

    return n(t, e), t;
  }(a(
  /*! ../../module_wrapper */
  17).ModuleCommon);

  t.default = h, t.isPercentageTransferManager = function (e) {
    return e instanceof h;
  };
},
/*!**************************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/transfer_manager/lock_up_transfer_manager_wrapper/index.ts ***!
  \**************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r40,
      n = this && this.__extends || (_r40 = function r(e, t) {
    return (_r40 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r40(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__importStar || function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var a in e) {
      Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t.default = e, t;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = a(
  /*! ./3.0.0 */
  860);
  t.LockUpTransferManager_3_0_0 = o.LockUpTransferManager_3_0_0, t.isLockUpTransferManager_3_0_0 = o.isLockUpTransferManager_3_0_0;
  var i = s(a(
  /*! ./common */
  309));
  t.isLockUpTransferManager = i.isLockUpTransferManager;
  var c = a(
  /*! @polymathnetwork/abi-wrappers */
  6);
  t.LockUpTransferManagerEvents = c.LockUpTransferManagerEvents_3_0_0;

  var u = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }

    return n(t, e), t;
  }(i.default);

  t.LockupTransferManagerCommon = u;
},
/*!***************************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/transfer_manager/lock_up_transfer_manager_wrapper/common.ts ***!
  \***************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r41,
      n = this && this.__extends || (_r41 = function r(e, t) {
    return (_r41 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r41(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      i = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var c = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      u = a(
  /*! @0x/json-schemas */
  2),
      d = i(a(
  /*! ../../../../utils/assert */
  15)),
      f = a(
  /*! ../../module_wrapper */
  17),
      l = a(
  /*! ../../../../types */
  4),
      h = a(
  /*! ../../../../utils/convert */
  16),
      p = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.lockups = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return d.default.assert(e.lockupName.length > 0, l.ErrorCode.InvalidData, "LockUp Details must not be an empty string"), [4, this.contract];

              case 1:
                return [4, r.sent().lockups.callAsync(h.stringToBytes32(e.lockupName))];

              case 2:
                return t = r.sent(), [4, this.securityTokenContract()];

              case 3:
                return [4, r.sent().decimals.callAsync()];

              case 4:
                return a = r.sent(), [2, {
                  lockupAmount: h.weiToValue(t[0], a),
                  startTime: h.bigNumberToDate(t[1]),
                  lockUpPeriodSeconds: t[2].toNumber(),
                  releaseFrequencySeconds: t[3].toNumber()
                }];
            }
          });
        });
      }, n.getLockUp = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return d.default.assert(e.lockupName.length > 0, l.ErrorCode.InvalidData, "LockUp Details must not be an empty string"), [4, this.contract];

              case 1:
                return [4, r.sent().getLockUp.callAsync(h.stringToBytes32(e.lockupName))];

              case 2:
                return t = r.sent(), [4, this.securityTokenContract()];

              case 3:
                return [4, r.sent().decimals.callAsync()];

              case 4:
                return a = r.sent(), [2, {
                  lockupAmount: h.weiToValue(t[0], a),
                  startTime: h.bigNumberToDate(t[1]),
                  lockUpPeriodSeconds: t[2].toNumber(),
                  releaseFrequencySeconds: t[3].toNumber(),
                  unlockedAmount: h.weiToValue(t[4], a)
                }];
            }
          });
        });
      }, n.getAllLockupData = function () {
        return s(n, void 0, void 0, function () {
          var e, t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, n.sent().getAllLockupData.callAsync()];

              case 2:
                return e = n.sent(), [4, this.securityTokenContract()];

              case 3:
                return [4, n.sent().decimals.callAsync()];

              case 4:
                for (t = n.sent(), a = [], r = 0; r < e[0].length; r += 1) {
                  a.push({
                    lockupName: h.bytes32ToString(e[0][r]),
                    lockupAmount: h.weiToValue(e[1][r], t),
                    startTime: h.bigNumberToDate(e[2][r]),
                    lockUpPeriodSeconds: e[3][r].toNumber(),
                    releaseFrequencySeconds: e[4][r].toNumber(),
                    unlockedAmount: h.weiToValue(e[5][r], t)
                  });
                }

                return [2, a];
            }
          });
        });
      }, n.getListOfAddresses = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return d.default.assert(e.lockupName.length > 0, l.ErrorCode.InvalidData, "LockUp name must not be an empty string"), [4, this.contract];

              case 1:
                return [2, t.sent().getListOfAddresses.callAsync(h.stringToBytes32(e.lockupName))];
            }
          });
        });
      }, n.getAllLockups = function () {
        return s(n, void 0, void 0, function () {
          var e;
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return e = h.bytes32ArrayToStringArray, [4, this.contract];

              case 1:
                return [4, t.sent().getAllLockups.callAsync()];

              case 2:
                return [2, e.apply(void 0, [t.sent()])];
            }
          });
        });
      }, n.getLockupsNamesToUser = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return d.default.isNonZeroETHAddressHex("User Address", e.user), t = h.bytes32ArrayToStringArray, [4, this.contract];

              case 1:
                return [4, a.sent().getLockupsNamesToUser.callAsync(e.user)];

              case 2:
                return [2, t.apply(void 0, [a.sent()])];
            }
          });
        });
      }, n.getLockedTokenToUser = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return d.default.isNonZeroETHAddressHex("User Address", e.user), [4, this.securityTokenContract()];

              case 1:
                return [4, r.sent().decimals.callAsync()];

              case 2:
                return t = r.sent(), a = h.weiToValue, [4, this.contract];

              case 3:
                return [4, r.sent().getLockedTokenToUser.callAsync(e.user)];

              case 4:
                return [2, a.apply(void 0, [r.sent(), t])];
            }
          });
        });
      }, n.getTokensByPartition = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return d.default.isNonZeroETHAddressHex("Token Holder", e.tokenHolder), [4, this.securityTokenContract()];

              case 1:
                return [4, r.sent().decimals.callAsync()];

              case 2:
                return t = r.sent(), a = h.weiToValue, [4, this.contract];

              case 3:
                return [4, r.sent().getTokensByPartition.callAsync(e.partition, e.tokenHolder, h.valueToWei(e.additionalBalance, t))];

              case 4:
                return [2, a.apply(void 0, [r.sent(), t])];
            }
          });
        });
      }, n.verifyTransfer = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return d.default.isETHAddressHex("from", e.from), d.default.isETHAddressHex("to", e.to), [4, this.securityTokenContract()];

              case 1:
                return [4, r.sent().decimals.callAsync()];

              case 2:
                return t = r.sent(), [4, this.contract];

              case 3:
                return [4, r.sent().verifyTransfer.callAsync(e.from, e.to, h.valueToWei(e.amount, t), e.data)];

              case 4:
                return a = r.sent(), [2, {
                  transferResult: h.parseTransferResult(a[0]),
                  address: a[1]
                }];
            }
          });
        });
      }, n.addNewLockUpType = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                return a.apply(t, [n.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.checkAddNewLockUpType(e)];

              case 2:
                return n.sent(), [4, this.securityTokenContract()];

              case 3:
                return [4, n.sent().decimals.callAsync()];

              case 4:
                return r = n.sent(), [4, this.contract];

              case 5:
                return [2, n.sent().addNewLockUpType.sendTransactionAsync(h.valueToWei(e.lockupAmount, r), h.dateToBigNumber(e.startTime), h.numberToBigNumber(e.lockUpPeriodSeconds), h.numberToBigNumber(e.releaseFrequenciesSeconds), h.stringToBytes32(e.lockupName), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.addNewLockUpTypeMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return d.default.assert(e.lockupAmounts.length > 0, l.ErrorCode.InvalidData, "Empty lockup information"), d.default.areValidArrayLengths([e.lockupAmounts, e.lockupNames, e.releaseFrequenciesSeconds, e.lockUpPeriodSeconds, e.startTimes], "Argument arrays length mismatch"), a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                for (a.apply(t, [o.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), r = [], n = 0; n < e.lockupNames.length; n += 1) {
                  r.push(this.checkAddNewLockUpType({
                    lockupAmount: e.lockupAmounts[n],
                    startTime: e.startTimes[n],
                    lockUpPeriodSeconds: e.lockUpPeriodSeconds[n],
                    releaseFrequenciesSeconds: e.releaseFrequenciesSeconds[n],
                    lockupName: e.lockupNames[n]
                  }));
                }

                return [4, Promise.all(r)];

              case 2:
                return o.sent(), [4, this.securityTokenContract()];

              case 3:
                return [4, o.sent().decimals.callAsync()];

              case 4:
                return s = o.sent(), [4, this.contract];

              case 5:
                return [2, o.sent().addNewLockUpTypeMulti.sendTransactionAsync(h.valueArrayToWeiArray(e.lockupAmounts, s), h.dateArrayToBigNumberArray(e.startTimes), h.numberArrayToBigNumberArray(e.lockUpPeriodSeconds), h.numberArrayToBigNumberArray(e.releaseFrequenciesSeconds), h.stringArrayToBytes32Array(e.lockupNames), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.addLockUpByName = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                return a.apply(t, [r.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.checkAddLockUpByName(e)];

              case 2:
                return r.sent(), [4, this.contract];

              case 3:
                return [2, r.sent().addLockUpByName.sendTransactionAsync(e.userAddress, h.stringToBytes32(e.lockupName), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.addLockUpByNameMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return d.default.assert(e.lockupNames.length > 0, l.ErrorCode.InvalidData, "Empty lockup information"), d.default.areValidArrayLengths([e.userAddresses, e.lockupNames], "Argument arrays length mismatch"), a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                for (a.apply(t, [s.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), r = [], n = 0; n < e.lockupNames.length; n += 1) {
                  r.push(this.checkAddLockUpByName({
                    lockupName: e.lockupNames[n],
                    userAddress: e.userAddresses[n]
                  }));
                }

                return [4, Promise.all(r)];

              case 2:
                return s.sent(), [4, this.contract];

              case 3:
                return [2, s.sent().addLockUpByNameMulti.sendTransactionAsync(e.userAddresses, h.stringArrayToBytes32Array(e.lockupNames), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.addNewLockUpToUser = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                return a.apply(t, [n.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), d.default.isNonZeroETHAddressHex("User Address", e.userAddress), [4, this.checkAddNewLockUpType(e)];

              case 2:
                return n.sent(), [4, this.securityTokenContract()];

              case 3:
                return [4, n.sent().decimals.callAsync()];

              case 4:
                return r = n.sent(), [4, this.contract];

              case 5:
                return [2, n.sent().addNewLockUpToUser.sendTransactionAsync(e.userAddress, h.valueToWei(e.lockupAmount, r), h.dateToBigNumber(e.startTime), h.numberToBigNumber(e.lockUpPeriodSeconds), h.numberToBigNumber(e.releaseFrequenciesSeconds), h.stringToBytes32(e.lockupName), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.addNewLockUpToUserMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                for (a.apply(t, [o.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), e.userAddresses.map(function (e) {
                  return d.default.isNonZeroETHAddressHex("User Address", e);
                }), d.default.assert(e.lockupAmounts.length > 0, l.ErrorCode.InvalidData, "Empty lockup information"), d.default.areValidArrayLengths([e.userAddresses, e.lockupAmounts, e.lockupNames, e.releaseFrequenciesSeconds, e.lockUpPeriodSeconds, e.startTimes], "Argument arrays length mismatch"), r = [], n = 0; n < e.lockupNames.length; n += 1) {
                  r.push(this.checkAddNewLockUpType({
                    lockupAmount: e.lockupAmounts[n],
                    startTime: e.startTimes[n],
                    lockUpPeriodSeconds: e.lockUpPeriodSeconds[n],
                    releaseFrequenciesSeconds: e.releaseFrequenciesSeconds[n],
                    lockupName: e.lockupNames[n]
                  }));
                }

                return [4, Promise.all(r)];

              case 2:
                return o.sent(), [4, this.securityTokenContract()];

              case 3:
                return [4, o.sent().decimals.callAsync()];

              case 4:
                return s = o.sent(), [4, this.contract];

              case 5:
                return [2, o.sent().addNewLockUpToUserMulti.sendTransactionAsync(e.userAddresses, h.valueArrayToWeiArray(e.lockupAmounts, s), h.dateArrayToBigNumberArray(e.startTimes), h.numberArrayToBigNumberArray(e.lockUpPeriodSeconds), h.numberArrayToBigNumberArray(e.releaseFrequenciesSeconds), h.stringArrayToBytes32Array(e.lockupNames), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.removeLockUpFromUser = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                return a.apply(t, [r.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.checkRemoveLockUpFromUser(e)];

              case 2:
                return r.sent(), [4, this.contract];

              case 3:
                return [2, r.sent().removeLockUpFromUser.sendTransactionAsync(e.userAddress, h.stringToBytes32(e.lockupName), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.removeLockUpFromUserMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return d.default.assert(e.lockupNames.length > 0, l.ErrorCode.InvalidData, "Empty lockup information"), d.default.areValidArrayLengths([e.userAddresses, e.lockupNames], "Argument arrays length mismatch"), a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                for (a.apply(t, [s.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), r = [], n = 0; n < e.lockupNames.length; n += 1) {
                  r.push(this.checkRemoveLockUpFromUser({
                    lockupName: e.lockupNames[n],
                    userAddress: e.userAddresses[n]
                  }));
                }

                return [4, Promise.all(r)];

              case 2:
                return s.sent(), [4, this.contract];

              case 3:
                return [2, s.sent().removeLockUpFromUserMulti.sendTransactionAsync(e.userAddresses, h.stringArrayToBytes32Array(e.lockupNames), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.removeLockupType = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                return a.apply(t, [r.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.checkRemoveLockUpType(e.lockupName)];

              case 2:
                return r.sent(), [4, this.contract];

              case 3:
                return [2, r.sent().removeLockupType.sendTransactionAsync(h.stringToBytes32(e.lockupName), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.removeLockupTypeMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return d.default.assert(e.lockupNames.length > 0, l.ErrorCode.InvalidData, "Empty lockup information"), a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                for (a.apply(t, [s.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), r = [], n = 0; n < e.lockupNames.length; n += 1) {
                  r.push(this.checkRemoveLockUpType(e.lockupNames[n]));
                }

                return [4, Promise.all(r)];

              case 2:
                return s.sent(), [4, this.contract];

              case 3:
                return [2, s.sent().removeLockupTypeMulti.sendTransactionAsync(h.stringArrayToBytes32Array(e.lockupNames), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.modifyLockUpType = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                return a.apply(t, [n.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.checkModifyLockUpType(e)];

              case 2:
                return n.sent(), [4, this.securityTokenContract()];

              case 3:
                return [4, n.sent().decimals.callAsync()];

              case 4:
                return r = n.sent(), [4, this.contract];

              case 5:
                return [2, n.sent().modifyLockUpType.sendTransactionAsync(h.valueToWei(e.lockupAmount, r), h.dateToBigNumber(e.startTime), h.numberToBigNumber(e.lockUpPeriodSeconds), h.numberToBigNumber(e.releaseFrequenciesSeconds), h.stringToBytes32(e.lockupName), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.modifyLockUpTypeMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return d.default.assert(e.lockupAmounts.length > 0, l.ErrorCode.InvalidData, "Empty lockup information"), d.default.areValidArrayLengths([e.lockupAmounts, e.lockupNames, e.releaseFrequenciesSeconds, e.lockUpPeriodSeconds, e.startTimes], "Argument arrays length mismatch"), a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                for (a.apply(t, [o.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), r = [], n = 0; n < e.lockupNames.length; n += 1) {
                  r.push(this.checkModifyLockUpType({
                    lockupAmount: e.lockupAmounts[n],
                    startTime: e.startTimes[n],
                    lockUpPeriodSeconds: e.lockUpPeriodSeconds[n],
                    releaseFrequenciesSeconds: e.releaseFrequenciesSeconds[n],
                    lockupName: e.lockupNames[n]
                  }));
                }

                return [4, Promise.all(r)];

              case 2:
                return o.sent(), [4, this.securityTokenContract()];

              case 3:
                return [4, o.sent().decimals.callAsync()];

              case 4:
                return s = o.sent(), [4, this.contract];

              case 5:
                return [2, o.sent().modifyLockUpTypeMulti.sendTransactionAsync(h.valueArrayToWeiArray(e.lockupAmounts, s), h.dateArrayToBigNumberArray(e.startTimes), h.numberArrayToBigNumberArray(e.lockUpPeriodSeconds), h.numberArrayToBigNumberArray(e.releaseFrequenciesSeconds), h.stringArrayToBytes32Array(e.lockupNames), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.checkAddNewLockUpType = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.checkLockUpTypeInformation(e)];

              case 1:
                return a.sent(), [4, this.getLockUp({
                  lockupName: e.lockupName
                })];

              case 2:
                return t = a.sent(), d.default.isBigNumberZero(t.lockupAmount, "LockUp already exists"), [2];
            }
          });
        });
      }, n.checkModifyLockUpType = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.checkLockUpTypeInformation(e)];

              case 1:
                return a.sent(), [4, this.getLockUp({
                  lockupName: e.lockupName
                })];

              case 2:
                return t = a.sent(), d.default.isNotDateZero(t.startTime, "LockUp already exists"), [2];
            }
          });
        });
      }, n.checkLockUpTypeInformation = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            return d.default.assert(e.lockupName.length > 0, l.ErrorCode.InvalidData, "Lockup Name cannot be empty string"), d.default.isFutureDate(e.startTime, "Start time must be in the future"), d.default.assert(e.lockUpPeriodSeconds > 0, l.ErrorCode.InvalidData, "Lockup period in seconds should be greater than 0"), d.default.assert(e.releaseFrequenciesSeconds > 0, l.ErrorCode.InvalidData, "Release frequency in seconds should be greater than 0"), d.default.isBigNumberGreaterThanZero(e.lockupAmount, "Lockup amount should be greater than 0"), [2];
          });
        });
      }, n.checkAddLockUpByName = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return d.default.assert(e.lockupName.length > 0, l.ErrorCode.InvalidData, "Lockup Name cannot be empty string"), d.default.isNonZeroETHAddressHex("User Address", e.userAddress), [4, this.getLockupsNamesToUser({
                  user: e.userAddress
                })];

              case 1:
                return t = r.sent(), d.default.assert(!t.includes(e.lockupName), l.ErrorCode.AlreadyExists, "User already added to this lockup name"), [4, this.getLockUp({
                  lockupName: e.lockupName
                })];

              case 2:
                return a = r.sent(), d.default.isFutureDate(a.startTime, "Start time must be in the future"), [2];
            }
          });
        });
      }, n.checkRemoveLockUpFromUser = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return d.default.assert(e.lockupName.length > 0, l.ErrorCode.InvalidData, "Lockup Name cannot be empty string"), d.default.isNonZeroETHAddressHex("User Address", e.userAddress), [4, this.getLockupsNamesToUser({
                  user: e.userAddress
                })];

              case 1:
                return t = a.sent(), d.default.assert(t.includes(e.lockupName), l.ErrorCode.PreconditionRequired, "User not added to this lockup name, not included in lookup"), [2];
            }
          });
        });
      }, n.checkRemoveLockUpType = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return d.default.assert(e.length > 0, l.ErrorCode.InvalidData, "Lockup Name cannot be empty string"), [4, this.getLockUp({
                  lockupName: e
                })];

              case 1:
                return t = r.sent(), d.default.isNotDateZero(t.startTime, "Lockup does not exist"), [4, this.getListOfAddresses({
                  lockupName: e
                })];

              case 2:
                return a = r.sent(), d.default.assert(0 === a.length, l.ErrorCode.PreconditionRequired, "There are users attached to the lockup that must be removed before removing the lockup type"), [2];
            }
          });
        });
      }, n.subscribeAsync = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return d.default.doesBelongToStringEnum("eventName", e.eventName, c.LockUpTransferManagerEvents_3_0_0), d.default.doesConformToSchema("indexFilterValues", e.indexFilterValues, u.schemas.indexFilterValuesSchema), d.default.isFunction("callback", e.callback), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.subscribeInternal(t, e.eventName, e.indexFilterValues, e.callback, e.isVerbose)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.getLogsAsync = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return d.default.doesBelongToStringEnum("eventName", e.eventName, c.LockUpTransferManagerEvents_3_0_0), d.default.doesConformToSchema("blockRange", e.blockRange, u.schemas.blockRangeSchema), d.default.doesConformToSchema("indexFilterValues", e.indexFilterValues, u.schemas.indexFilterValuesSchema), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.getLogsAsyncInternal(t, e.eventName, e.blockRange, e.indexFilterValues)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.contract = a, n;
    }

    return n(t, e), t;
  }(f.ModuleCommon);

  t.default = p, t.isLockUpTransferManager = function (e) {
    return e instanceof p;
  };
},
/*!****************************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/transfer_manager/blacklist_transfer_manager_wrapper/index.ts ***!
  \****************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r42,
      n = this && this.__extends || (_r42 = function r(e, t) {
    return (_r42 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r42(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__importStar || function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var a in e) {
      Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t.default = e, t;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = a(
  /*! ./3.0.0 */
  861);
  t.BlacklistTransferManager_3_0_0 = o.BlacklistTransferManager_3_0_0, t.isBlacklistTransferManager_3_0_0 = o.isBlacklistTransferManager_3_0_0;
  var i = s(a(
  /*! ./common */
  311));
  t.isBlacklistTransferManager = i.isBlacklistTransferManager;
  var c = a(
  /*! @polymathnetwork/abi-wrappers */
  6);
  t.BlacklistTransferManagerEvents = c.BlacklistTransferManagerEvents_3_0_0;

  var u = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }

    return n(t, e), t;
  }(i.default);

  t.BlacklistTransferManagerCommon = u;
},
/*!*****************************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/transfer_manager/blacklist_transfer_manager_wrapper/common.ts ***!
  \*****************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r43,
      n = this && this.__extends || (_r43 = function r(e, t) {
    return (_r43 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r43(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      i = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var c = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      u = a(
  /*! @0x/json-schemas */
  2),
      d = i(a(
  /*! ../../../../utils/assert */
  15)),
      f = a(
  /*! ../../module_wrapper */
  17),
      l = a(
  /*! ../../../../types */
  4),
      h = a(
  /*! ../../../../utils/convert */
  16),
      p = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.blacklists = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return d.default.assert(e.blacklistName.length > 0, l.ErrorCode.InvalidData, "Blacklist name must not be an empty string"), [4, this.contract];

              case 1:
                return [4, a.sent().blacklists.callAsync(h.stringToBytes32(e.blacklistName))];

              case 2:
                return t = a.sent(), [2, {
                  startTime: h.bigNumberToDate(t[0]),
                  endTime: h.bigNumberToDate(t[1]),
                  repeatPeriodTime: t[2].toNumber()
                }];
            }
          });
        });
      }, n.addBlacklistType = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                return a.apply(t, [r.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.checkAddBlacklistType(e)];

              case 2:
                return r.sent(), [4, this.contract];

              case 3:
                return [2, r.sent().addBlacklistType.sendTransactionAsync(h.dateToBigNumber(e.startTime), h.dateToBigNumber(e.endTime), h.stringToBytes32(e.blacklistName), h.numberToBigNumber(e.repeatPeriodTime), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.addNewBlacklistTypeMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return d.default.areValidArrayLengths([e.startTimes, e.endTimes, e.blacklistNames, e.repeatPeriodTimes], "Argument arrays length mismatch"), d.default.assert(e.startTimes.length > 0, l.ErrorCode.InvalidData, "Empty blacklist information"), a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                for (a.apply(t, [s.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), r = [], n = 0; n < e.startTimes.length; n += 1) {
                  r.push(this.checkAddBlacklistType({
                    startTime: e.startTimes[n],
                    endTime: e.endTimes[n],
                    blacklistName: e.blacklistNames[n],
                    repeatPeriodTime: e.repeatPeriodTimes[n]
                  }));
                }

                return [4, Promise.all(r)];

              case 2:
                return s.sent(), [4, this.contract];

              case 3:
                return [2, s.sent().addBlacklistTypeMulti.sendTransactionAsync(h.dateArrayToBigNumberArray(e.startTimes), h.dateArrayToBigNumberArray(e.endTimes), h.stringArrayToBytes32Array(e.blacklistNames), h.numberArrayToBigNumberArray(e.repeatPeriodTimes), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.modifyBlacklistType = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                return a.apply(t, [r.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.checkModifyBlacklistType(e)];

              case 2:
                return r.sent(), [4, this.contract];

              case 3:
                return [2, r.sent().modifyBlacklistType.sendTransactionAsync(h.dateToBigNumber(e.startTime), h.dateToBigNumber(e.endTime), h.stringToBytes32(e.blacklistName), h.numberToBigNumber(e.repeatPeriodTime), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.modifyBlacklistTypeMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return d.default.areValidArrayLengths([e.startTimes, e.endTimes, e.blacklistNames, e.repeatPeriodTimes], "Argument arrays length mismatch"), d.default.assert(e.startTimes.length > 0, l.ErrorCode.InvalidData, "Empty blacklist information"), a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                for (a.apply(t, [s.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), r = [], n = 0; n < e.startTimes.length; n += 1) {
                  r.push(this.checkModifyBlacklistType({
                    startTime: e.startTimes[n],
                    endTime: e.endTimes[n],
                    blacklistName: e.blacklistNames[n],
                    repeatPeriodTime: e.repeatPeriodTimes[n]
                  }));
                }

                return [4, Promise.all(r)];

              case 2:
                return s.sent(), [4, this.contract];

              case 3:
                return [2, s.sent().modifyBlacklistTypeMulti.sendTransactionAsync(h.dateArrayToBigNumberArray(e.startTimes), h.dateArrayToBigNumberArray(e.endTimes), h.stringArrayToBytes32Array(e.blacklistNames), h.numberArrayToBigNumberArray(e.repeatPeriodTimes), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.deleteBlacklistType = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                return a.apply(t, [r.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.checkDeleteBlacklistType(e.blacklistName)];

              case 2:
                return r.sent(), [4, this.contract];

              case 3:
                return [2, r.sent().deleteBlacklistType.sendTransactionAsync(h.stringToBytes32(e.blacklistName), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.deleteBlacklistTypeMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return d.default.assert(e.blacklistNames.length > 0, l.ErrorCode.InvalidData, "Empty blacklist information"), a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                for (a.apply(t, [s.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), r = [], n = 0; n < e.blacklistNames.length; n += 1) {
                  r.push(this.checkDeleteBlacklistType(e.blacklistNames[n]));
                }

                return [4, Promise.all(r)];

              case 2:
                return s.sent(), [4, this.contract];

              case 3:
                return [2, s.sent().deleteBlacklistTypeMulti.sendTransactionAsync(h.stringArrayToBytes32Array(e.blacklistNames), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.addInvestorToBlacklist = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                return a.apply(t, [r.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.checkAddInvestorToBlacklist(e)];

              case 2:
                return r.sent(), [4, this.contract];

              case 3:
                return [2, r.sent().addInvestorToBlacklist.sendTransactionAsync(e.userAddress, h.stringToBytes32(e.blacklistName), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.addInvestorToBlacklistMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                for (a.apply(t, [s.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), d.default.assert(e.userAddresses.length > 0, l.ErrorCode.InvalidData, "Empty user address information"), r = [], n = 0; n < e.userAddresses.length; n += 1) {
                  r.push(this.checkAddInvestorToBlacklist({
                    userAddress: e.userAddresses[n],
                    blacklistName: e.blacklistName
                  }));
                }

                return [4, Promise.all(r)];

              case 2:
                return s.sent(), [4, this.contract];

              case 3:
                return [2, s.sent().addInvestorToBlacklistMulti.sendTransactionAsync(e.userAddresses, h.stringToBytes32(e.blacklistName), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.addMultiInvestorToBlacklistMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                for (a.apply(t, [s.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), d.default.areValidArrayLengths([e.userAddresses, e.blacklistNames], "Argument arrays length mismatch"), d.default.assert(e.userAddresses.length > 0, l.ErrorCode.InvalidData, "Empty user address information"), r = [], n = 0; n < e.userAddresses.length; n += 1) {
                  r.push(this.checkAddInvestorToBlacklist({
                    userAddress: e.userAddresses[n],
                    blacklistName: e.blacklistNames[n]
                  }));
                }

                return [4, Promise.all(r)];

              case 2:
                return s.sent(), [4, this.contract];

              case 3:
                return [2, s.sent().addMultiInvestorToBlacklistMulti.sendTransactionAsync(e.userAddresses, h.stringArrayToBytes32Array(e.blacklistNames), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.addInvestorToNewBlacklist = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                return a.apply(t, [r.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.checkAddBlacklistType(e)];

              case 2:
                return r.sent(), [4, this.contract];

              case 3:
                return [2, r.sent().addInvestorToNewBlacklist.sendTransactionAsync(h.dateToBigNumber(e.startTime), h.dateToBigNumber(e.endTime), h.stringToBytes32(e.blacklistName), h.numberToBigNumber(e.repeatPeriodTime), e.investor, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.deleteInvestorFromBlacklist = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                return a.apply(t, [r.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.checkDeleteInvestorFromBlacklist(e)];

              case 2:
                return r.sent(), [4, this.contract];

              case 3:
                return [2, r.sent().deleteInvestorFromBlacklist.sendTransactionAsync(e.userAddress, h.stringToBytes32(e.blacklistName), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.deleteMultiInvestorsFromBlacklistMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                for (a.apply(t, [s.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), d.default.areValidArrayLengths([e.userAddresses, e.blacklistNames], "Argument arrays length mismatch"), d.default.assert(e.userAddresses.length > 0, l.ErrorCode.InvalidData, "Empty user address information"), r = [], n = 0; n < e.userAddresses.length; n += 1) {
                  r.push(this.checkDeleteInvestorFromBlacklist({
                    userAddress: e.userAddresses[n],
                    blacklistName: e.blacklistNames[n]
                  }));
                }

                return [4, Promise.all(r)];

              case 2:
                return s.sent(), [4, this.contract];

              case 3:
                return [2, s.sent().deleteMultiInvestorsFromBlacklistMulti.sendTransactionAsync(e.userAddresses, h.stringArrayToBytes32Array(e.blacklistNames), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.deleteInvestorFromAllBlacklist = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                return a.apply(t, [r.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.checkDeleteInvestorFromAllBlacklist(e)];

              case 2:
                return r.sent(), [4, this.contract];

              case 3:
                return [2, r.sent().deleteInvestorFromAllBlacklist.sendTransactionAsync(e.investor, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.deleteInvestorFromAllBlacklistMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, l.Perm.Admin)];

              case 1:
                for (a.apply(t, [s.sent(), l.ErrorCode.Unauthorized, "Caller is not allowed"]), r = [], n = 0; n < e.investors.length; n += 1) {
                  r.push(this.checkDeleteInvestorFromAllBlacklist({
                    investor: e.investors[n]
                  }));
                }

                return [4, Promise.all(r)];

              case 2:
                return s.sent(), [4, this.contract];

              case 3:
                return [2, s.sent().deleteInvestorFromAllBlacklistMulti.sendTransactionAsync(e.investors, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.getListOfAddresses = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return d.default.assert(e.blacklistName.length > 0, l.ErrorCode.InvalidData, "Blacklist details must not be an empty string"), [4, this.contract];

              case 1:
                return [2, t.sent().getListOfAddresses.callAsync(h.stringToBytes32(e.blacklistName))];
            }
          });
        });
      }, n.getBlacklistNamesToUser = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return d.default.isNonZeroETHAddressHex("User Address", e.user), t = h.bytes32ArrayToStringArray, [4, this.contract];

              case 1:
                return [4, a.sent().getBlacklistNamesToUser.callAsync(e.user)];

              case 2:
                return [2, t.apply(void 0, [a.sent()])];
            }
          });
        });
      }, n.getAllBlacklists = function () {
        return s(n, void 0, void 0, function () {
          var e;
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return e = h.bytes32ArrayToStringArray, [4, this.contract];

              case 1:
                return [4, t.sent().getAllBlacklists.callAsync()];

              case 2:
                return [2, e.apply(void 0, [t.sent()])];
            }
          });
        });
      }, n.getTokensByPartition = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return d.default.isNonZeroETHAddressHex("Token Holder", e.tokenHolder), [4, this.securityTokenContract()];

              case 1:
                return [4, r.sent().decimals.callAsync()];

              case 2:
                return t = r.sent(), a = h.weiToValue, [4, this.contract];

              case 3:
                return [4, r.sent().getTokensByPartition.callAsync(e.partition, e.tokenHolder, h.valueToWei(e.additionalBalance, t))];

              case 4:
                return [2, a.apply(void 0, [r.sent(), t])];
            }
          });
        });
      }, n.verifyTransfer = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return d.default.isETHAddressHex("from", e.from), d.default.isETHAddressHex("to", e.to), [4, this.securityTokenContract()];

              case 1:
                return [4, r.sent().decimals.callAsync()];

              case 2:
                return t = r.sent(), [4, this.contract];

              case 3:
                return [4, r.sent().verifyTransfer.callAsync(e.from, e.to, h.valueToWei(e.amount, t), e.data)];

              case 4:
                return a = r.sent(), [2, {
                  transferResult: h.parseTransferResult(a[0]),
                  address: a[1]
                }];
            }
          });
        });
      }, n.checkAddBlacklistType = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.blacklists({
                  blacklistName: e.blacklistName
                })];

              case 1:
                return t = a.sent(), d.default.assert(h.dateToBigNumber(t.endTime).isZero(), l.ErrorCode.AlreadyExists, "Blacklist you are trying to add already exists"), [4, this.checkBlacklistTypeDetails(e)];

              case 2:
                return a.sent(), [2];
            }
          });
        });
      }, n.checkModifyBlacklistType = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.blacklists({
                  blacklistName: e.blacklistName
                })];

              case 1:
                return t = a.sent(), d.default.isNotDateZero(t.endTime, "Blacklist you are trying to modify does not exist"), [4, this.checkBlacklistTypeDetails(e)];

              case 2:
                return a.sent(), [2];
            }
          });
        });
      }, n.checkBlacklistTypeDetails = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            return d.default.assert(e.blacklistName.length > 0, l.ErrorCode.InvalidData, "Blacklist Name cannot be empty string"), d.default.isFutureDate(e.startTime, "Start time must be in the future"), d.default.assert(e.startTime < e.endTime, l.ErrorCode.TooLate, "Start time must be before the end time"), 0 !== e.repeatPeriodTime && (t = (e.endTime.getTime() - e.startTime.getTime()) / 864e5, d.default.assert(t <= e.repeatPeriodTime, l.ErrorCode.InvalidData, "The repeat period time in days must be greater than or equal to the difference between start and end time")), [2];
          });
        });
      }, n.checkDeleteBlacklistType = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return d.default.assert(e.length > 0, l.ErrorCode.InvalidData, "Blacklist Name cannot be empty string"), [4, this.blacklists({
                  blacklistName: e
                })];

              case 1:
                return t = r.sent(), d.default.isNotDateZero(t.endTime, "Blacklist does not exist"), [4, this.getListOfAddresses({
                  blacklistName: e
                })];

              case 2:
                return a = r.sent(), d.default.assert(0 === a.length, l.ErrorCode.PreconditionRequired, "There are users attached to the blacklist that must be removed before removing the blacklist type"), [2];
            }
          });
        });
      }, n.checkBlacklistToModifyInvestors = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return d.default.assert(e.blacklistName.length > 0, l.ErrorCode.InvalidData, "Blacklist name cannot be empty string"), [4, this.blacklists({
                  blacklistName: e.blacklistName
                })];

              case 1:
                return t = a.sent(), d.default.isNotDateZero(t.endTime, "Blacklist does not exist"), [2];
            }
          });
        });
      }, n.checkAddInvestorToBlacklist = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.checkBlacklistToModifyInvestors(e)];

              case 1:
                return a.sent(), [4, this.getBlacklistNamesToUser({
                  user: e.userAddress
                })];

              case 2:
                return t = a.sent(), d.default.assert(!t.includes(e.blacklistName), l.ErrorCode.AlreadyExists, "User already added to this blacklist name"), [2];
            }
          });
        });
      }, n.checkDeleteInvestorFromBlacklist = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.checkBlacklistToModifyInvestors(e)];

              case 1:
                return a.sent(), [4, this.getBlacklistNamesToUser({
                  user: e.userAddress
                })];

              case 2:
                return t = a.sent(), d.default.assert(t.includes(e.blacklistName), l.ErrorCode.NotFound, "User is not added to this blacklist name"), [2];
            }
          });
        });
      }, n.checkDeleteInvestorFromAllBlacklist = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return d.default.isNonZeroETHAddressHex("Investor Address", e.investor), [4, this.getBlacklistNamesToUser({
                  user: e.investor
                })];

              case 1:
                return t = a.sent(), d.default.assert(t.length > 0, l.ErrorCode.NotFound, "Investor is not currently present on any blacklists"), [2];
            }
          });
        });
      }, n.subscribeAsync = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return d.default.doesBelongToStringEnum("eventName", e.eventName, c.BlacklistTransferManagerEvents_3_0_0), d.default.doesConformToSchema("indexFilterValues", e.indexFilterValues, u.schemas.indexFilterValuesSchema), d.default.isFunction("callback", e.callback), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.subscribeInternal(t, e.eventName, e.indexFilterValues, e.callback, e.isVerbose)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.getLogsAsync = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return d.default.doesBelongToStringEnum("eventName", e.eventName, c.BlacklistTransferManagerEvents_3_0_0), d.default.doesConformToSchema("blockRange", e.blockRange, u.schemas.blockRangeSchema), d.default.doesConformToSchema("indexFilterValues", e.indexFilterValues, u.schemas.indexFilterValuesSchema), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.getLogsAsyncInternal(t, e.eventName, e.blockRange, e.indexFilterValues)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.contract = a, n;
    }

    return n(t, e), t;
  }(f.ModuleCommon);

  t.default = p, t.isBlacklistTransferManager = function (e) {
    return e instanceof p;
  };
},
/*!*************************************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/transfer_manager/volume_restriction_transfer_manager_wrapper/index.ts ***!
  \*************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r44,
      n = this && this.__extends || (_r44 = function r(e, t) {
    return (_r44 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r44(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__importStar || function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var a in e) {
      Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t.default = e, t;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = a(
  /*! ./3.0.0 */
  862);
  t.VolumeRestrictionTransferManager_3_0_0 = o.VolumeRestrictionTransferManager_3_0_0, t.isVolumeRestrictionTransferManager_3_0_0 = o.isVolumeRestrictionTransferManager_3_0_0;
  var i = s(a(
  /*! ./common */
  313));
  t.isVolumeRestrictionTransferManager = i.isVolumeRestrictionTransferManager;
  var c = a(
  /*! @polymathnetwork/abi-wrappers */
  6);
  t.VolumeRestrictionTMEvents = c.VolumeRestrictionTMEvents_3_0_0;

  var u = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }

    return n(t, e), t;
  }(i.default);

  t.VolumeRestrictionTransferManagerCommon = u;
},
/*!**************************************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/transfer_manager/volume_restriction_transfer_manager_wrapper/common.ts ***!
  \**************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r45,
      n = this && this.__extends || (_r45 = function r(e, t) {
    return (_r45 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r45(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      i = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var c = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      u = a(
  /*! @0x/json-schemas */
  2),
      d = i(a(
  /*! ../../../../utils/assert */
  15)),
      f = a(
  /*! ../../module_wrapper */
  17),
      l = a(
  /*! ../../../../utils/convert */
  16),
      h = a(
  /*! ../../../../types */
  4),
      p = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.verifyTransfer = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return d.default.isETHAddressHex("from", e.from), d.default.isETHAddressHex("to", e.to), [4, this.securityTokenContract()];

              case 1:
                return [4, r.sent().decimals.callAsync()];

              case 2:
                return t = r.sent(), [4, this.contract];

              case 3:
                return [4, r.sent().verifyTransfer.callAsync(e.from, e.to, l.valueToWei(e.amount, t), e.data)];

              case 4:
                return a = r.sent(), [2, {
                  transferResult: l.parseTransferResult(a[0]),
                  address: a[1]
                }];
            }
          });
        });
      }, n.getIndividualRestriction = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, n.sent().getIndividualRestriction.callAsync(e.investor)];

              case 2:
                return t = n.sent(), a = 0 === new c.BigNumber(t[4]).toNumber() ? h.RestrictionType.Fixed : h.RestrictionType.Percentage, [4, this.decimalsByRestrictionType(a)];

              case 3:
                return r = n.sent(), [2, {
                  allowedTokens: l.weiToValue(t[0], r),
                  startTime: l.bigNumberToDate(t[1]),
                  rollingPeriodInDays: new c.BigNumber(t[2]).toNumber(),
                  endTime: l.bigNumberToDate(t[3]),
                  restrictionType: a
                }];
            }
          });
        });
      }, n.getDefaultRestriction = function () {
        return s(n, void 0, void 0, function () {
          var e, t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, r.sent().getDefaultRestriction.callAsync()];

              case 2:
                return e = r.sent(), t = 0 === new c.BigNumber(e[4]).toNumber() ? h.RestrictionType.Fixed : h.RestrictionType.Percentage, [4, this.decimalsByRestrictionType(t)];

              case 3:
                return a = r.sent(), [2, {
                  allowedTokens: l.weiToValue(e[0], a),
                  startTime: l.bigNumberToDate(e[1]),
                  rollingPeriodInDays: new c.BigNumber(e[2]).toNumber(),
                  endTime: l.bigNumberToDate(e[3]),
                  restrictionType: t
                }];
            }
          });
        });
      }, n.getDefaultDailyRestriction = function () {
        return s(n, void 0, void 0, function () {
          var e, t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, r.sent().getDefaultDailyRestriction.callAsync()];

              case 2:
                return e = r.sent(), t = 0 === new c.BigNumber(e[4]).toNumber() ? h.RestrictionType.Fixed : h.RestrictionType.Percentage, [4, this.decimalsByRestrictionType(t)];

              case 3:
                return a = r.sent(), [2, {
                  allowedTokens: l.weiToValue(e[0], a),
                  startTime: l.bigNumberToDate(e[1]),
                  rollingPeriodInDays: new c.BigNumber(e[2]).toNumber(),
                  endTime: l.bigNumberToDate(e[3]),
                  restrictionType: t
                }];
            }
          });
        });
      }, n.getExemptAddress = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().getExemptAddress.callAsync()];
            }
          });
        });
      }, n.getIndividualDailyRestriction = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, n.sent().getIndividualDailyRestriction.callAsync(e.investor)];

              case 2:
                return t = n.sent(), a = 0 === new c.BigNumber(t[4]).toNumber() ? h.RestrictionType.Fixed : h.RestrictionType.Percentage, [4, this.decimalsByRestrictionType(a)];

              case 3:
                return r = n.sent(), [2, {
                  allowedTokens: l.weiToValue(t[0], r),
                  startTime: l.bigNumberToDate(t[1]),
                  rollingPeriodInDays: new c.BigNumber(t[2]).toNumber(),
                  endTime: l.bigNumberToDate(t[3]),
                  restrictionType: a
                }];
            }
          });
        });
      }, n.changeExemptWalletList = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return d.default.isNonZeroETHAddressHex("wallet", e.wallet), a = (t = d.default).assert, [4, this.getExemptAddress()];

              case 1:
                return a.apply(t, [!r.sent().includes(e.wallet) === e.change, h.ErrorCode.PreconditionRequired, "There will be no change to exempt list"]), [4, this.contract];

              case 2:
                return [2, r.sent().changeExemptWalletList.sendTransactionAsync(e.wallet, e.change, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.addIndividualRestriction = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                return a.apply(t, [o.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), d.default.isNonZeroETHAddressHex("holder", e.holder), n = (r = d.default).assert, [4, this.getExemptAddress()];

              case 2:
                return n.apply(r, [!o.sent().includes(e.holder), h.ErrorCode.PreconditionRequired, "Holder is exempt from restriction"]), this.checkRestrictionInputParams(e.startTime, e.endTime, e.allowedTokens, e.restrictionType, e.rollingPeriodInDays), [4, this.decimalsByRestrictionType(e.restrictionType)];

              case 3:
                return s = o.sent(), [4, this.contract];

              case 4:
                return [2, o.sent().addIndividualRestriction.sendTransactionAsync(e.holder, l.valueToWei(e.allowedTokens, s), l.dateToBigNumber(e.startTime), l.numberToBigNumber(e.rollingPeriodInDays), l.dateToBigNumber(e.endTime), e.restrictionType, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.addIndividualDailyRestriction = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                return a.apply(t, [n.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), d.default.isNonZeroETHAddressHex("holder", e.holder), this.checkRestrictionInputParams(e.startTime, e.endTime, e.allowedTokens, e.restrictionType, 1), [4, this.decimalsByRestrictionType(e.restrictionType)];

              case 2:
                return r = n.sent(), [4, this.contract];

              case 3:
                return [2, n.sent().addIndividualDailyRestriction.sendTransactionAsync(e.holder, l.valueToWei(e.allowedTokens, r), l.dateToBigNumber(e.startTime), l.dateToBigNumber(e.endTime), e.restrictionType, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.addIndividualDailyRestrictionMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                for (a.apply(t, [o.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), e.holders.forEach(function (e) {
                  return d.default.isNonZeroETHAddressHex("holders", e);
                }), d.default.assert(e.startTimes.length === e.allowedTokens.length && e.startTimes.length === e.restrictionTypes.length && e.startTimes.length === e.holders.length && e.startTimes.length === e.endTimes.length, h.ErrorCode.MismatchedArrayLength, "Array lengths mismatch"), r = [], s = 0; s < e.startTimes.length; s += 1) {
                  this.checkRestrictionInputParams(e.startTimes[s], e.endTimes[s], e.allowedTokens[s], e.restrictionTypes[s], 1), r.push(this.decimalsByRestrictionType(e.restrictionTypes[s]));
                }

                return [4, Promise.all(r)];

              case 2:
                for (r = o.sent(), n = [], s = 0; s < r.length; s += 1) {
                  n.push(l.valueToWei(e.allowedTokens[s], r[s]));
                }

                return [4, this.contract];

              case 3:
                return [2, o.sent().addIndividualDailyRestrictionMulti.sendTransactionAsync(e.holders, n, l.dateArrayToBigNumberArray(e.startTimes), l.dateArrayToBigNumberArray(e.endTimes), e.restrictionTypes, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.addIndividualRestrictionMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s, i;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                return a.apply(t, [o.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), e.holders.forEach(function (e) {
                  return d.default.isNonZeroETHAddressHex("holders", e);
                }), [4, this.getExemptAddress()];

              case 2:
                for (r = o.sent(), d.default.assert(!r.some(function (t) {
                  return e.holders.includes(t);
                }), h.ErrorCode.PreconditionRequired, "Holder is exempt from restriction"), d.default.assert(e.startTimes.length === e.allowedTokens.length && e.startTimes.length === e.restrictionTypes.length && e.startTimes.length === e.rollingPeriodInDays.length && e.startTimes.length === e.holders.length && e.startTimes.length === e.endTimes.length, h.ErrorCode.MismatchedArrayLength, "Array lengths mismatch"), n = [], i = 0; i < e.startTimes.length; i += 1) {
                  this.checkRestrictionInputParams(e.startTimes[i], e.endTimes[i], e.allowedTokens[i], e.restrictionTypes[i], e.rollingPeriodInDays[i]), n.push(this.decimalsByRestrictionType(e.restrictionTypes[i]));
                }

                return [4, Promise.all(n)];

              case 3:
                for (n = o.sent(), s = [], i = 0; i < n.length; i += 1) {
                  s.push(l.valueToWei(e.allowedTokens[i], n[i]));
                }

                return [4, this.contract];

              case 4:
                return [2, o.sent().addIndividualRestrictionMulti.sendTransactionAsync(e.holders, s, l.dateArrayToBigNumberArray(e.startTimes), l.numberArrayToBigNumberArray(e.rollingPeriodInDays), l.dateArrayToBigNumberArray(e.endTimes), e.restrictionTypes, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.addDefaultRestriction = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                return a.apply(t, [n.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), this.checkRestrictionInputParams(e.startTime, e.endTime, e.allowedTokens, e.restrictionType, e.rollingPeriodInDays), [4, this.decimalsByRestrictionType(e.restrictionType)];

              case 2:
                return r = n.sent(), [4, this.contract];

              case 3:
                return [2, n.sent().addDefaultRestriction.sendTransactionAsync(l.valueToWei(e.allowedTokens, r), l.dateToBigNumber(e.startTime), l.numberToBigNumber(e.rollingPeriodInDays), l.dateToBigNumber(e.endTime), e.restrictionType, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.addDefaultDailyRestriction = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                return a.apply(t, [n.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), this.checkRestrictionInputParams(e.startTime, e.endTime, e.allowedTokens, e.restrictionType, 1), [4, this.decimalsByRestrictionType(e.restrictionType)];

              case 2:
                return r = n.sent(), [4, this.contract];

              case 3:
                return [2, n.sent().addDefaultDailyRestriction.sendTransactionAsync(l.valueToWei(e.allowedTokens, r), l.dateToBigNumber(e.startTime), l.dateToBigNumber(e.endTime), e.restrictionType, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.removeIndividualRestriction = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                return a.apply(t, [s.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), n = (r = d.default).isNotDateZero, [4, this.getIndividualRestriction({
                  investor: e.investor
                })];

              case 2:
                return n.apply(r, [s.sent().endTime, "Individual Restriction not set with end time"]), d.default.isNonZeroETHAddressHex("investor", e.investor), [4, this.contract];

              case 3:
                return [2, s.sent().removeIndividualRestriction.sendTransactionAsync(e.investor, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.removeIndividualRestrictionMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t,
              a,
              r = this;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                return a.apply(t, [n.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), e.holders.forEach(function (e) {
                  return d.default.isNonZeroETHAddressHex("holders", e);
                }), [4, Promise.all(e.holders.map(function (e) {
                  return s(r, void 0, void 0, function () {
                    var t, a;
                    return o(this, function (r) {
                      switch (r.label) {
                        case 0:
                          return a = (t = d.default).isNotDateZero, [4, this.getIndividualRestriction({
                            investor: e
                          })];

                        case 1:
                          return [2, a.apply(t, [r.sent().endTime, "Individual Restriction not set with end time"])];
                      }
                    });
                  });
                }))];

              case 2:
                return n.sent(), [4, this.contract];

              case 3:
                return [2, n.sent().removeIndividualRestrictionMulti.sendTransactionAsync(e.holders, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.removeIndividualDailyRestriction = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                return a.apply(t, [s.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), n = (r = d.default).isNotDateZero, [4, this.getIndividualDailyRestriction({
                  investor: e.investor
                })];

              case 2:
                return n.apply(r, [s.sent().endTime, "Individual Daily Restriction not set with end time"]), d.default.isNonZeroETHAddressHex("investor", e.investor), [4, this.contract];

              case 3:
                return [2, s.sent().removeIndividualDailyRestriction.sendTransactionAsync(e.investor, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.removeIndividualDailyRestrictionMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t,
              a,
              r = this;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                return a.apply(t, [n.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, Promise.all(e.holders.map(function (e) {
                  return s(r, void 0, void 0, function () {
                    var t, a;
                    return o(this, function (r) {
                      switch (r.label) {
                        case 0:
                          return a = (t = d.default).isNotDateZero, [4, this.getIndividualRestriction({
                            investor: e
                          })];

                        case 1:
                          return [2, a.apply(t, [r.sent().endTime, "Individual Restriction not set with end time"])];
                      }
                    });
                  });
                }))];

              case 2:
                return n.sent(), e.holders.forEach(function (e) {
                  return d.default.isNonZeroETHAddressHex("holders", e);
                }), [4, this.contract];

              case 3:
                return [2, n.sent().removeIndividualDailyRestrictionMulti.sendTransactionAsync(e.holders, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.removeDefaultRestriction = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                return a.apply(t, [s.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), n = (r = d.default).isNotDateZero, [4, this.getDefaultRestriction()];

              case 2:
                return n.apply(r, [s.sent().endTime, "Individual Restriction not set with end time"]), [4, this.contract];

              case 3:
                return [2, s.sent().removeDefaultRestriction.sendTransactionAsync(e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.removeDefaultDailyRestriction = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                return a.apply(t, [s.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), n = (r = d.default).isNotDateZero, [4, this.getDefaultDailyRestriction()];

              case 2:
                return n.apply(r, [s.sent().endTime, "Individual Restriction not set with end time"]), [4, this.contract];

              case 3:
                return [2, s.sent().removeDefaultDailyRestriction.sendTransactionAsync(e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.modifyIndividualRestriction = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                return a.apply(t, [n.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), d.default.isNonZeroETHAddressHex("holder", e.holder), this.checkRestrictionInputParams(e.startTime, e.endTime, e.allowedTokens, e.restrictionType, e.rollingPeriodInDays), [4, this.decimalsByRestrictionType(e.restrictionType)];

              case 2:
                return r = n.sent(), [4, this.contract];

              case 3:
                return [2, n.sent().modifyIndividualRestriction.sendTransactionAsync(e.holder, l.valueToWei(e.allowedTokens, r), l.dateToBigNumber(e.startTime), l.numberToBigNumber(e.rollingPeriodInDays), l.dateToBigNumber(e.endTime), e.restrictionType, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.modifyIndividualDailyRestriction = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                return a.apply(t, [n.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), d.default.isNonZeroETHAddressHex("holder", e.holder), this.checkRestrictionInputParams(e.startTime, e.endTime, e.allowedTokens, e.restrictionType, 1), [4, this.decimalsByRestrictionType(e.restrictionType)];

              case 2:
                return r = n.sent(), [4, this.contract];

              case 3:
                return [2, n.sent().modifyIndividualDailyRestriction.sendTransactionAsync(e.holder, l.valueToWei(e.allowedTokens, r), l.dateToBigNumber(e.startTime), l.dateToBigNumber(e.endTime), e.restrictionType, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.modifyIndividualDailyRestrictionMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                for (a.apply(t, [o.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), e.holders.forEach(function (e) {
                  return d.default.isNonZeroETHAddressHex("holders", e);
                }), d.default.assert(e.startTimes.length === e.allowedTokens.length && e.startTimes.length === e.restrictionTypes.length && e.startTimes.length === e.holders.length && e.startTimes.length === e.endTimes.length, h.ErrorCode.MismatchedArrayLength, "Array lengths mismatch"), r = [], s = 0; s < e.startTimes.length; s += 1) {
                  this.checkRestrictionInputParams(e.startTimes[s], e.endTimes[s], e.allowedTokens[s], e.restrictionTypes[s], 1), r.push(this.decimalsByRestrictionType(e.restrictionTypes[s]));
                }

                return [4, Promise.all(r)];

              case 2:
                for (r = o.sent(), n = [], s = 0; s < r.length; s += 1) {
                  n.push(l.valueToWei(e.allowedTokens[s], r[s]));
                }

                return [4, this.contract];

              case 3:
                return [2, o.sent().modifyIndividualDailyRestrictionMulti.sendTransactionAsync(e.holders, n, l.dateArrayToBigNumberArray(e.startTimes), l.dateArrayToBigNumberArray(e.endTimes), e.restrictionTypes, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.modifyIndividualRestrictionMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                for (a.apply(t, [o.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), e.holders.forEach(function (e) {
                  return d.default.isNonZeroETHAddressHex("holders", e);
                }), d.default.assert(e.startTimes.length === e.allowedTokens.length && e.startTimes.length === e.restrictionTypes.length && e.startTimes.length === e.rollingPeriodInDays.length && e.startTimes.length === e.holders.length && e.startTimes.length === e.endTimes.length, h.ErrorCode.MismatchedArrayLength, "Array lengths mismatch"), r = [], s = 0; s < e.startTimes.length; s += 1) {
                  this.checkRestrictionInputParams(e.startTimes[s], e.endTimes[s], e.allowedTokens[s], e.restrictionTypes[s], e.rollingPeriodInDays[s]), r.push(this.decimalsByRestrictionType(e.restrictionTypes[s]));
                }

                return [4, Promise.all(r)];

              case 2:
                for (r = o.sent(), n = [], s = 0; s < r.length; s += 1) {
                  n.push(l.valueToWei(e.allowedTokens[s], r[s]));
                }

                return [4, this.contract];

              case 3:
                return [2, o.sent().modifyIndividualRestrictionMulti.sendTransactionAsync(e.holders, n, l.dateArrayToBigNumberArray(e.startTimes), l.numberArrayToBigNumberArray(e.rollingPeriodInDays), l.dateArrayToBigNumberArray(e.endTimes), e.restrictionTypes, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.modifyDefaultRestriction = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                return a.apply(t, [n.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), this.checkRestrictionInputParams(e.startTime, e.endTime, e.allowedTokens, e.restrictionType, e.rollingPeriodInDays), [4, this.decimalsByRestrictionType(e.restrictionType)];

              case 2:
                return r = n.sent(), [4, this.contract];

              case 3:
                return [2, n.sent().modifyDefaultRestriction.sendTransactionAsync(l.valueToWei(e.allowedTokens, r), l.dateToBigNumber(e.startTime), l.numberToBigNumber(e.rollingPeriodInDays), l.dateToBigNumber(e.endTime), e.restrictionType, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.modifyDefaultDailyRestriction = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, h.Perm.Admin)];

              case 1:
                return a.apply(t, [n.sent(), h.ErrorCode.Unauthorized, "Caller is not allowed"]), this.checkRestrictionInputParams(e.startTime, e.endTime, e.allowedTokens, e.restrictionType, 1), [4, this.decimalsByRestrictionType(e.restrictionType)];

              case 2:
                return r = n.sent(), [4, this.contract];

              case 3:
                return [2, n.sent().modifyDefaultDailyRestriction.sendTransactionAsync(l.valueToWei(e.allowedTokens, r), l.dateToBigNumber(e.startTime), l.dateToBigNumber(e.endTime), e.restrictionType, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.getIndividualBucketDetailsToUser = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return d.default.isETHAddressHex("user", e.user), [4, this.contract];

              case 1:
                return [4, r.sent().getIndividualBucketDetailsToUser.callAsync(e.user)];

              case 2:
                return t = r.sent(), [4, this.securityTokenContract()];

              case 3:
                return [4, r.sent().decimals.callAsync()];

              case 4:
                return a = r.sent(), [2, {
                  lastTradedDayTime: l.bigNumberToDate(t[0]),
                  sumOfLastPeriod: l.weiToValue(t[1], a),
                  daysCovered: new c.BigNumber(t[2]).toNumber(),
                  dailyLastTradedDayTime: l.bigNumberToDate(t[3]),
                  lastTradedTimestamp: l.bigNumberToDate(t[4])
                }];
            }
          });
        });
      }, n.getDefaultBucketDetailsToUser = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return d.default.isETHAddressHex("user", e.user), [4, this.contract];

              case 1:
                return [4, r.sent().getDefaultBucketDetailsToUser.callAsync(e.user)];

              case 2:
                return t = r.sent(), [4, this.securityTokenContract()];

              case 3:
                return [4, r.sent().decimals.callAsync()];

              case 4:
                return a = r.sent(), [2, {
                  lastTradedDayTime: l.bigNumberToDate(t[0]),
                  sumOfLastPeriod: l.weiToValue(t[1], a),
                  daysCovered: new c.BigNumber(t[2]).toNumber(),
                  dailyLastTradedDayTime: l.bigNumberToDate(t[3]),
                  lastTradedTimestamp: l.bigNumberToDate(t[4])
                }];
            }
          });
        });
      }, n.getTotalTradedByUser = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.securityTokenContract()];

              case 1:
                return [4, r.sent().decimals.callAsync()];

              case 2:
                return t = r.sent(), a = l.weiToValue, [4, this.contract];

              case 3:
                return [4, r.sent().getTotalTradedByUser.callAsync(e.user, l.dateToBigNumber(e.at))];

              case 4:
                return [2, a.apply(void 0, [r.sent(), t])];
            }
          });
        });
      }, n.getRestrictionData = function () {
        return s(n, void 0, void 0, function () {
          var e, t, a, r, n, s, i;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, o.sent().getRestrictionData.callAsync()];

              case 2:
                for (e = o.sent(), t = [], s = 0; s < e[0].length; s += 1) {
                  a = 0 === new c.BigNumber(e[5][s]).toNumber() ? h.RestrictionType.Fixed : h.RestrictionType.Percentage, t.push(this.decimalsByRestrictionType(a));
                }

                return [4, Promise.all(t)];

              case 3:
                for (r = o.sent(), n = [], s = 0; s < e[0].length; s += 1) {
                  i = {
                    allAddresses: e[0][s],
                    allowedTokens: l.weiToValue(e[1][s], r[s]),
                    startTime: l.bigNumberToDate(e[2][s]),
                    rollingPeriodInDays: new c.BigNumber(e[3][s]).toNumber(),
                    endTime: l.bigNumberToDate(e[4][s]),
                    typeOfRestriction: e[5][s]
                  }, n.push(i);
                }

                return [2, n];
            }
          });
        });
      }, n.checkRestrictionInputParams = function (e, t, a, r, n) {
        d.default.isFutureDate(e, "Start time must be in the future"), d.default.isBigNumberGreaterThanZero(a, "Allowed Tokens must be greater than 0"), r === h.RestrictionType.Percentage && d.default.isPercentage("allowed tokens", a), d.default.assert(n <= 365 && n >= 1, h.ErrorCode.InvalidData, "Invalid number of days in rolling period");
        var s = Math.ceil(Math.abs(t.getTime() - e.getTime()) / 864e5);
        d.default.assert(new c.BigNumber(s).isGreaterThanOrEqualTo(n), h.ErrorCode.InvalidData, "Invalid times, rollingPeriodInDays must have less days than the duration");
      }, n.decimalsByRestrictionType = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return t = h.PERCENTAGE_DECIMALS, e !== h.RestrictionType.Fixed ? [3, 3] : [4, this.securityTokenContract()];

              case 1:
                return [4, a.sent().decimals.callAsync()];

              case 2:
                t = a.sent(), a.label = 3;

              case 3:
                return [2, t];
            }
          });
        });
      }, n.subscribeAsync = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return d.default.doesBelongToStringEnum("eventName", e.eventName, c.VolumeRestrictionTMEvents_3_0_0), d.default.doesConformToSchema("indexFilterValues", e.indexFilterValues, u.schemas.indexFilterValuesSchema), d.default.isFunction("callback", e.callback), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.subscribeInternal(t, e.eventName, e.indexFilterValues, e.callback, e.isVerbose)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.getLogsAsync = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return d.default.doesBelongToStringEnum("eventName", e.eventName, c.VolumeRestrictionTMEvents_3_0_0), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.getLogsAsyncInternal(t, e.eventName, e.blockRange, e.indexFilterValues)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.contract = a, n;
    }

    return n(t, e), t;
  }(f.ModuleCommon);

  t.default = p, t.isVolumeRestrictionTransferManager = function (e) {
    return e instanceof p;
  };
},
/*!******************************************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/transfer_manager/restricted_partial_sale_transfer_manager_wrapper/index.ts ***!
  \******************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r46,
      n = this && this.__extends || (_r46 = function r(e, t) {
    return (_r46 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r46(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__importStar || function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var a in e) {
      Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t.default = e, t;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = a(
  /*! ./3.1.0 */
  863);
  t.RestrictedPartialSaleTransferManager_3_1_0 = o.RestrictedPartialSaleTransferManager_3_1_0, t.isRestrictedPartialSaleTransferManager_3_1_0 = o.isRestrictedPartialSaleTransferManager_3_1_0;
  var i = s(a(
  /*! ./common */
  315));
  t.isRestrictedPartialSaleTransferManager = i.isRestrictedPartialSaleTransferManager;
  var c = a(
  /*! @polymathnetwork/abi-wrappers */
  6);
  t.RestrictedPartialSaleTransferManagerEvents = c.RestrictedPartialSaleTMEvents_3_1_0;

  var u = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }

    return n(t, e), t;
  }(i.default);

  t.RestrictedPartialSaleTransferManagerCommon = u;
},
/*!*******************************************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/transfer_manager/restricted_partial_sale_transfer_manager_wrapper/common.ts ***!
  \*******************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r47,
      n = this && this.__extends || (_r47 = function r(e, t) {
    return (_r47 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r47(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      i = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var c = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      u = a(
  /*! @0x/json-schemas */
  2),
      d = a(
  /*! ../../../../utils/convert */
  16),
      f = a(
  /*! ../../../../types */
  4),
      l = a(
  /*! ../../module_wrapper */
  17),
      h = i(a(
  /*! ../../../../utils/assert */
  15)),
      p = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.verifyTransfer = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return h.default.isETHAddressHex("from", e.from), h.default.isETHAddressHex("to", e.to), [4, this.securityTokenContract()];

              case 1:
                return [4, r.sent().decimals.callAsync()];

              case 2:
                return t = r.sent(), [4, this.contract];

              case 3:
                return [4, r.sent().verifyTransfer.callAsync(e.from, e.to, d.valueToWei(e.amount, t), e.data)];

              case 4:
                return a = r.sent(), [2, {
                  transferResult: d.parseTransferResult(a[0]),
                  address: a[1]
                }];
            }
          });
        });
      }, n.getExemptAddresses = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().getExemptAddresses.callAsync()];
            }
          });
        });
      }, n.getPermissions = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, e.sent().getPermissions.callAsync()];

              case 2:
                return [2, e.sent().map(d.parsePermBytes32Value)];
            }
          });
        });
      }, n.changeExemptWalletList = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return h.default.isNonZeroETHAddressHex("wallet", e.wallet), a = (t = h.default).assert, [4, this.getExemptAddresses()];

              case 1:
                return a.apply(t, [!r.sent().includes(e.wallet) === e.exempted, f.ErrorCode.PreconditionRequired, "There will be no change to exempt list"]), [4, this.contract];

              case 2:
                return [2, r.sent().changeExemptWalletList.sendTransactionAsync(e.wallet, e.exempted, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.changeExemptWalletListMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return h.default.areValidArrayLengths([e.wallets, e.exempted], "Change exempt wallet argument arrays length mismatch"), [4, this.getExemptAddresses()];

              case 1:
                for (t = r.sent(), a = 0; a < e.wallets.length; a += 1) {
                  h.default.isNonZeroETHAddressHex("Wallet", e.wallets[a]), h.default.assert(!t.includes(e.wallets[a]) === e.exempted[a], f.ErrorCode.PreconditionRequired, "There will be no change to exempt list");
                }

                return [4, this.contract];

              case 2:
                return [2, r.sent().changeExemptWalletListMulti.sendTransactionAsync(e.wallets, e.exempted, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.getInitFunction = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().getInitFunction.callAsync()];
            }
          });
        });
      }, n.subscribeAsync = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return h.default.doesBelongToStringEnum("eventName", e.eventName, c.RestrictedPartialSaleTMEvents_3_1_0), h.default.doesConformToSchema("indexFilterValues", e.indexFilterValues, u.schemas.indexFilterValuesSchema), h.default.isFunction("callback", e.callback), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.subscribeInternal(t, e.eventName, e.indexFilterValues, e.callback, e.isVerbose)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.getLogsAsync = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return h.default.doesBelongToStringEnum("eventName", e.eventName, c.RestrictedPartialSaleTMEvents_3_1_0), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.getLogsAsyncInternal(t, e.eventName, e.blockRange, e.indexFilterValues)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.contract = a, n;
    }

    return n(t, e), t;
  }(l.ModuleCommon);

  t.default = p, t.isRestrictedPartialSaleTransferManager = function (e) {
    return e instanceof p;
  };
},
/*!*************************************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/checkpoint/voting/advanced_p_l_c_r_voting_checkpoint_wrapper/index.ts ***!
  \*************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r48,
      n = this && this.__extends || (_r48 = function r(e, t) {
    return (_r48 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r48(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__importStar || function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var a in e) {
      Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t.default = e, t;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = a(
  /*! ./3.1.0 */
  864);
  t.AdvancedPLCRVotingCheckpoint_3_1_0 = o.AdvancedPLCRVotingCheckpoint_3_1_0, t.isAdvancedPLCRVotingCheckpoint_3_1_0 = o.isAdvancedPLCRVotingCheckpoint_3_1_0;
  var i = s(a(
  /*! ./common */
  317));
  t.isAdvancedPLCRVotingCheckpoint = i.isAdvancedPLCRVotingCheckpoint;
  var c = a(
  /*! @polymathnetwork/abi-wrappers */
  6);
  t.AdvancedPLCRVotingCheckpointEvents = c.AdvancedPLCRVotingCheckpointEvents_3_1_0;

  var u = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }

    return n(t, e), t;
  }(i.default);

  t.AdvancedPLCRVotingCheckpointCommon = u;
},
/*!**************************************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/checkpoint/voting/advanced_p_l_c_r_voting_checkpoint_wrapper/common.ts ***!
  \**************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r49,
      n = this && this.__extends || (_r49 = function r(e, t) {
    return (_r49 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r49(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      i = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || t-- > 0) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  },
      c = this && this.__spread || function () {
    for (var e = [], t = 0; t < arguments.length; t++) {
      e = e.concat(i(arguments[t]));
    }

    return e;
  },
      u = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var d = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      f = a(
  /*! lodash */
  0),
      l = a(
  /*! @0x/json-schemas */
  2),
      h = a(
  /*! ../../../../../utils/convert */
  16),
      p = a(
  /*! ../../../../../types */
  4),
      b = a(
  /*! ../../../module_wrapper */
  17),
      m = u(a(
  /*! ../../../../../utils/assert */
  15)),
      y = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.getDefaultExemptionVotersList = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().getDefaultExemptionVotersList.callAsync()];
            }
          });
        });
      }, n.getCheckpointData = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, n.sent().getCheckpointData.callAsync(h.numberToBigNumber(e.checkpointId))];

              case 2:
                for (t = n.sent(), a = [], r = 0; r < t[0].length; r += 1) {
                  a.push(this.pushCheckpointData(t, r));
                }

                return [2, Promise.all(a)];
            }
          });
        });
      }, n.pushCheckpointData = function (e, t) {
        return s(n, void 0, void 0, function () {
          var a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.securityTokenContract()];

              case 1:
                return [4, r.sent().decimals.callAsync()];

              case 2:
                return a = r.sent(), [2, {
                  investor: e[0][t],
                  balance: h.weiToValue(e[1][t], a)
                }];
            }
          });
        });
      }, n.getPendingInvestorToVote = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, t.sent().getPendingInvestorToVote.callAsync(h.numberToBigNumber(e.ballotId))];
            }
          });
        });
      }, n.getCommitedVoteCount = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, t.sent().getCommitedVoteCount.callAsync(h.numberToBigNumber(e.ballotId))];

              case 2:
                return [2, t.sent().toNumber()];
            }
          });
        });
      }, n.getAllowedVotersByBallot = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, t.sent().getAllowedVotersByBallot.callAsync(h.numberToBigNumber(e.ballotId))];
            }
          });
        });
      }, n.getAllBallots = function () {
        return s(n, void 0, void 0, function () {
          var e, t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, r.sent().getAllBallots.callAsync()];

              case 2:
                for (e = r.sent(), t = [], a = 0; a < e[0].length; a += 1) {
                  t.push({
                    ballotId: e[0][a].toNumber(),
                    name: h.bytes32ToString(e[1][a]),
                    totalProposal: e[2][a].toNumber(),
                    currentStage: h.parseBallotStageValue(e[3][a]),
                    isCancelled: e[4][a]
                  });
                }

                return [2, t];
            }
          });
        });
      }, n.getExemptedVotersByBallot = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, t.sent().getExemptedVotersByBallot.callAsync(h.numberToBigNumber(e.ballotId))];
            }
          });
        });
      }, n.pendingBallots = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, a.sent().pendingBallots.callAsync(e)];

              case 2:
                return t = a.sent(), [2, {
                  pendingCommitBallots: t[0].map(function (e) {
                    return e.toNumber();
                  }),
                  pendingRevealBallots: t[1].map(function (e) {
                    return e.toNumber();
                  })
                }];
            }
          });
        });
      }, n.getCurrentBallotStage = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, a.sent().getCurrentBallotStage.callAsync(h.numberToBigNumber(e.ballotId))];

              case 2:
                return t = a.sent(), [2, h.parseBallotStageValue(t)];
            }
          });
        });
      }, n.getVoteTokenCount = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, t.sent().getVoteTokenCount.callAsync(e.voter, h.numberToBigNumber(e.ballotId))];

              case 2:
                return [2, t.sent().toNumber()];
            }
          });
        });
      }, n.getBallotResults = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, a.sent().getBallotResults.callAsync(h.numberToBigNumber(e.ballotId))];

              case 2:
                return [2, {
                  choicesWeighting: (t = a.sent())[0].map(function (e) {
                    return h.weiToValue(e, p.FULL_DECIMALS).toNumber();
                  }),
                  noOfChoicesInProposal: t[1].map(function (e) {
                    return e.toNumber();
                  }),
                  voters: t[2]
                }];
            }
          });
        });
      }, n.getBallotDetails = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, a.sent().getBallotDetails.callAsync(h.numberToBigNumber(e.ballotId))];

              case 2:
                return t = a.sent(), [2, {
                  name: t[0],
                  totalSupplyAtCheckpoint: t[1].toNumber(),
                  checkpointId: t[2].toNumber(),
                  startTime: h.bigNumberToDate(t[3]),
                  commitDuration: t[4].toNumber(),
                  revealDuration: t[5].toNumber(),
                  totalProposals: t[6].toNumber(),
                  totalVoters: t[7].toNumber(),
                  commitedVoteCount: t[8].toNumber(),
                  isCancelled: t[9],
                  currentStage: h.parseBallotStageValue(t[10]),
                  proposalDetails: t[11],
                  proposalChoicesCounts: t[12].map(function (e) {
                    return e.toNumber();
                  })
                }];
            }
          });
        });
      }, n.getBallotsArrayLength = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, e.sent().getBallotsArrayLength.callAsync()];

              case 2:
                return [2, e.sent().toNumber()];
            }
          });
        });
      }, n.isVoterAllowed = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, t.sent().isVoterAllowed.callAsync(h.numberToBigNumber(e.ballotId), e.voter)];
            }
          });
        });
      }, n.createStatutoryBallot = function (e) {
        return s(n, void 0, void 0, function () {
          var t,
              a,
              r = this;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return a = (t = m.default).assert, [4, this.isCallerAllowed(e.txData, p.Perm.Admin)];

              case 1:
                return a.apply(t, [n.sent(), p.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.validateMaximumLimitCount()];

              case 2:
                return n.sent(), this.checkNonEmptyTitle(e.name), e.proposalTitles.map(function (e) {
                  return r.checkNonEmptyTitle(e);
                }), this.checkPositiveDurations(e.commitDuration, e.revealDuration), [4, this.contract];

              case 3:
                return [2, n.sent().createStatutoryBallot.sendTransactionAsync(h.stringToBytes32(e.name), h.dateToBigNumber(e.startTime), h.numberToBigNumber(e.commitDuration), h.numberToBigNumber(e.revealDuration), e.proposalTitles.join(","), h.stringToBytes32(e.proposalDetails), e.choices.join(","), h.numberToBigNumber(e.choicesCounts), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.createCustomStatutoryBallot = function (e) {
        return s(n, void 0, void 0, function () {
          var t,
              a,
              r = this;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return a = (t = m.default).assert, [4, this.isCallerAllowed(e.txData, p.Perm.Admin)];

              case 1:
                return a.apply(t, [n.sent(), p.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.validateMaximumLimitCount()];

              case 2:
                return n.sent(), this.checkNonEmptyTitle(e.name), e.proposalTitles.map(function (e) {
                  return r.checkNonEmptyTitle(e);
                }), this.checkPositiveDurations(e.commitDuration, e.revealDuration), [4, this.contract];

              case 3:
                return [2, n.sent().createCustomStatutoryBallot.sendTransactionAsync(h.stringToBytes32(e.name), h.dateToBigNumber(e.startTime), h.numberToBigNumber(e.commitDuration), h.numberToBigNumber(e.revealDuration), e.proposalTitles.join(","), h.stringToBytes32(e.proposalDetails), e.choices.join(","), h.numberToBigNumber(e.choicesCounts), h.numberToBigNumber(e.checkpointId), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.createCustomCumulativeBallot = function (e) {
        return s(n, void 0, void 0, function () {
          var t,
              a,
              r = this;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return a = (t = m.default).assert, [4, this.isCallerAllowed(e.txData, p.Perm.Admin)];

              case 1:
                return a.apply(t, [n.sent(), p.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.validateMaximumLimitCount()];

              case 2:
                return n.sent(), this.checkNonEmptyTitle(e.name), e.proposalTitles.map(function (e) {
                  return r.checkNonEmptyTitle(e);
                }), this.checkPositiveDurations(e.commitDuration, e.revealDuration), this.checkSameLength(e.choices.length, e.proposalDetails.length), [4, this.contract];

              case 3:
                return [2, n.sent().createCustomCumulativeBallot.sendTransactionAsync(h.stringToBytes32(e.name), h.dateToBigNumber(e.startTime), h.numberToBigNumber(e.commitDuration), h.numberToBigNumber(e.revealDuration), e.proposalTitles.join(","), e.proposalDetails.map(function (e) {
                  return h.stringToBytes32(e);
                }), e.choices.join(","), e.choicesCounts.map(function (e) {
                  return h.numberToBigNumber(e);
                }), h.numberToBigNumber(e.checkpointId), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.createCumulativeBallot = function (e) {
        return s(n, void 0, void 0, function () {
          var t,
              a,
              r = this;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return a = (t = m.default).assert, [4, this.isCallerAllowed(e.txData, p.Perm.Admin)];

              case 1:
                return a.apply(t, [n.sent(), p.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.validateMaximumLimitCount()];

              case 2:
                return n.sent(), this.checkNonEmptyTitle(e.name), e.proposalTitles.map(function (e) {
                  return r.checkNonEmptyTitle(e);
                }), this.checkPositiveDurations(e.commitDuration, e.revealDuration), this.checkSameLength(e.choices.length, e.proposalDetails.length), [4, this.contract];

              case 3:
                return [2, n.sent().createCumulativeBallot.sendTransactionAsync(h.stringToBytes32(e.name), h.dateToBigNumber(e.startTime), h.numberToBigNumber(e.commitDuration), h.numberToBigNumber(e.revealDuration), e.proposalTitles.join(","), e.proposalDetails.map(function (e) {
                  return h.stringToBytes32(e);
                }), e.choices.join(","), e.choicesCounts.map(function (e) {
                  return h.numberToBigNumber(e);
                }), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.createCustomCumulativeBallotWithExemption = function (e) {
        return s(n, void 0, void 0, function () {
          var t,
              a,
              r = this;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return a = (t = m.default).assert, [4, this.isCallerAllowed(e.txData, p.Perm.Admin)];

              case 1:
                return a.apply(t, [n.sent(), p.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.validateMaximumLimitCount()];

              case 2:
                return n.sent(), this.checkNonEmptyTitle(e.name), e.proposalTitles.map(function (e) {
                  return r.checkNonEmptyTitle(e);
                }), this.checkPositiveDurations(e.commitDuration, e.revealDuration), this.checkSameLength(e.choices.length, e.proposalDetails.length), [4, this.contract];

              case 3:
                return [2, n.sent().createCustomCumulativeBallotWithExemption.sendTransactionAsync(h.stringToBytes32(e.name), h.dateToBigNumber(e.startTime), h.numberToBigNumber(e.commitDuration), h.numberToBigNumber(e.revealDuration), e.proposalTitles.join(","), e.proposalDetails.map(function (e) {
                  return h.stringToBytes32(e);
                }), e.choices.join(","), e.choicesCounts.map(function (e) {
                  return h.numberToBigNumber(e);
                }), h.numberToBigNumber(e.checkpointId), e.exemptedAddresses, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.createCumulativeBallotWithExemption = function (e) {
        return s(n, void 0, void 0, function () {
          var t,
              a,
              r = this;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return a = (t = m.default).assert, [4, this.isCallerAllowed(e.txData, p.Perm.Admin)];

              case 1:
                return a.apply(t, [n.sent(), p.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.validateMaximumLimitCount()];

              case 2:
                return n.sent(), this.checkNonEmptyTitle(e.name), e.proposalTitles.map(function (e) {
                  return r.checkNonEmptyTitle(e);
                }), this.checkPositiveDurations(e.commitDuration, e.revealDuration), this.checkSameLength(e.choices.length, e.proposalDetails.length), [4, this.contract];

              case 3:
                return [2, n.sent().createCumulativeBallotWithExemption.sendTransactionAsync(h.stringToBytes32(e.name), h.dateToBigNumber(e.startTime), h.numberToBigNumber(e.commitDuration), h.numberToBigNumber(e.revealDuration), e.proposalTitles.join(","), e.proposalDetails.map(function (e) {
                  return h.stringToBytes32(e);
                }), e.choices.join(","), e.choicesCounts.map(function (e) {
                  return h.numberToBigNumber(e);
                }), e.exemptedAddresses, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.createStatutoryBallotWithExemption = function (e) {
        return s(n, void 0, void 0, function () {
          var t,
              a,
              r = this;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return a = (t = m.default).assert, [4, this.isCallerAllowed(e.txData, p.Perm.Admin)];

              case 1:
                return a.apply(t, [n.sent(), p.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.validateMaximumLimitCount()];

              case 2:
                return n.sent(), this.checkNonEmptyTitle(e.name), e.proposalTitles.map(function (e) {
                  return r.checkNonEmptyTitle(e);
                }), this.checkPositiveDurations(e.commitDuration, e.revealDuration), [4, this.contract];

              case 3:
                return [2, n.sent().createStatutoryBallotWithExemption.sendTransactionAsync(h.stringToBytes32(e.name), h.dateToBigNumber(e.startTime), h.numberToBigNumber(e.commitDuration), h.numberToBigNumber(e.revealDuration), e.proposalTitles.join(","), e.proposalDetails, e.choices.join(","), h.numberToBigNumber(e.choicesCounts), e.exemptedAddresses, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.createCustomStatutoryBallotWithExemption = function (e) {
        return s(n, void 0, void 0, function () {
          var t,
              a,
              r = this;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return a = (t = m.default).assert, [4, this.isCallerAllowed(e.txData, p.Perm.Admin)];

              case 1:
                return a.apply(t, [n.sent(), p.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.validateMaximumLimitCount()];

              case 2:
                return n.sent(), this.checkNonEmptyTitle(e.name), e.proposalTitles.map(function (e) {
                  return r.checkNonEmptyTitle(e);
                }), this.checkPositiveDurations(e.commitDuration, e.revealDuration), [4, this.contract];

              case 3:
                return [2, n.sent().createCustomStatutoryBallotWithExemption.sendTransactionAsync(h.stringToBytes32(e.name), h.dateToBigNumber(e.startTime), h.numberToBigNumber(e.commitDuration), h.numberToBigNumber(e.revealDuration), e.proposalTitles.join(","), e.proposalDetails, e.choices.join(","), h.numberToBigNumber(e.choicesCounts), h.numberToBigNumber(e.checkpointId), e.exemptedAddresses, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.commitVote = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s, i, u, f;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return [4, this.checkIndexOutOfBound(e.ballotId)];

              case 1:
                return o.sent(), m.default.assert(e.votes.length > 0, p.ErrorCode.InvalidData, "Invalid vote"), [4, this.checkValidStage({
                  ballotId: e.ballotId
                }, p.BallotStage.Commit)];

              case 2:
                return o.sent(), [4, this.getCallerAddress(e.txData)];

              case 3:
                return t = o.sent(), [4, this.isVoterAllowed({
                  voter: t,
                  ballotId: e.ballotId
                })];

              case 4:
                return a = o.sent(), m.default.assert(a, p.ErrorCode.PreconditionRequired, "Invalid voter"), [4, this.pendingBallots(t)];

              case 5:
                return r = o.sent(), n = r.pendingCommitBallots.find(function (t) {
                  return t === e.ballotId;
                }), m.default.assert(void 0 !== n, p.ErrorCode.PreconditionRequired, "Already voted"), [4, this.getBallotDetails({
                  ballotId: e.ballotId
                })];

              case 6:
                return s = o.sent(), m.default.assert(!s.isCancelled, p.ErrorCode.PreconditionRequired, "Cancelled ballot"), i = ["uint256"], u = e.votes.map(function (e) {
                  return i.push("uint256"), h.valueToWei(new d.BigNumber(e), p.FULL_DECIMALS).toString();
                }), f = d.ethersUtils.solidityKeccak256(i, c(u, [e.salt])), [4, this.contract];

              case 7:
                return [2, o.sent().commitVote.sendTransactionAsync(h.numberToBigNumber(e.ballotId), f, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.revealVote = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s, i, u, l, b, y, v, _, g;

          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return [4, this.checkIndexOutOfBound(e.ballotId)];

              case 1:
                return o.sent(), [4, this.checkValidStage({
                  ballotId: e.ballotId
                }, p.BallotStage.Reveal)];

              case 2:
                return o.sent(), [4, this.getBallotDetails({
                  ballotId: e.ballotId
                })];

              case 3:
                return t = o.sent(), m.default.assert(!t.isCancelled, p.ErrorCode.PreconditionRequired, "Cancelled ballot"), [4, this.getCallerAddress(e.txData)];

              case 4:
                return a = o.sent(), [4, this.pendingBallots(a)];

              case 5:
                for (r = o.sent(), n = r.pendingRevealBallots.find(function (t) {
                  return t === e.ballotId;
                }), m.default.assert(void 0 !== n, p.ErrorCode.PreconditionRequired, "Secret vote not available"), s = 0, i = 0; i <= t.totalProposals - 1; i += 1) {
                  u = t.proposalChoicesCounts[i], s += 0 === u ? 3 : u;
                }

                return m.default.assert(s === e.choices.length, p.ErrorCode.MismatchedArrayLength, "Choices count mismatch"), [4, this.getLogsAsync({
                  eventName: d.AdvancedPLCRVotingCheckpointEvents_3_1_0.VoteCommit,
                  indexFilterValues: {
                    _voter: a
                  }
                })];

              case 6:
                return l = o.sent(), b = f.map(l, function (e) {
                  return e.args;
                }), y = f.find(b, function (t) {
                  return t._ballotId.toNumber() === e.ballotId;
                }), m.default.assert(void 0 !== y, p.ErrorCode.NotFound, "Ballot id not found"), v = e.choices.map(function (e) {
                  return h.valueToWei(new d.BigNumber(e), p.FULL_DECIMALS).toString();
                }), _ = f.times(v.length + 1, f.constant("uint256")), g = d.ethersUtils.solidityKeccak256(_, c(v, [e.salt])), m.default.assert(y._secretHash === g, p.ErrorCode.InvalidData, "Invalid vote"), this.unsubscribeAll(), [4, this.contract];

              case 7:
                return [2, o.sent().revealVote.sendTransactionAsync(h.numberToBigNumber(e.ballotId), e.choices.map(function (e) {
                  return new d.BigNumber(h.valueToWei(new d.BigNumber(e), p.FULL_DECIMALS).toString());
                }), h.numberToBigNumber(e.salt), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.cancelBallot = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = m.default).assert, [4, this.isCallerAllowed(e.txData, p.Perm.Admin)];

              case 1:
                return a.apply(t, [s.sent(), p.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.checkIndexOutOfBound(e.ballotId)];

              case 2:
                return s.sent(), [4, this.getBallotDetails({
                  ballotId: e.ballotId
                })];

              case 3:
                return r = s.sent(), (n = new Date()).setSeconds(n.getSeconds() + r.commitDuration + r.revealDuration), m.default.assert(n <= r.startTime, p.ErrorCode.PreconditionRequired, "Already ended"), m.default.assert(r.isCancelled, p.ErrorCode.PreconditionRequired, "Already cancelled"), [4, this.contract];

              case 4:
                return [2, s.sent().cancelBallot.sendTransactionAsync(h.numberToBigNumber(e.ballotId), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.changeBallotExemptedVotersList = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = m.default).assert, [4, this.isCallerAllowed(e.txData, p.Perm.Admin)];

              case 1:
                return a.apply(t, [r.sent(), p.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.changeBallotExemptedVotersAssertions(e)];

              case 2:
                return r.sent(), [4, this.contract];

              case 3:
                return [2, r.sent().changeBallotExemptedVotersList.sendTransactionAsync(h.numberToBigNumber(e.ballotId), e.exemptedAddress, e.exempt, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.changeBallotExemptedVotersListMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = m.default).assert, [4, this.isCallerAllowed(e.txData, p.Perm.Admin)];

              case 1:
                for (a.apply(t, [s.sent(), p.ErrorCode.Unauthorized, "Caller is not allowed"]), r = [], n = 0; n < e.exempt.length; n += 1) {
                  r.push(this.changeBallotExemptedVotersAssertions({
                    ballotId: e.ballotId,
                    exemptedAddress: e.exemptedAddress[n],
                    exempt: e.exempt[n]
                  }));
                }

                return [4, Promise.all(r)];

              case 2:
                return s.sent(), [4, this.contract];

              case 3:
                return [2, s.sent().changeBallotExemptedVotersListMulti.sendTransactionAsync(h.numberToBigNumber(e.ballotId), e.exemptedAddress, e.exempt, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.changeBallotExemptedVotersAssertions = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, this.getBallotDetails({
                  ballotId: e.ballotId
                })];

              case 1:
                return t = n.sent(), m.default.assert(t.currentStage === p.BallotStage.Prep, p.ErrorCode.PreconditionRequired, "Ballot is not in PREP stage"), m.default.isNonZeroETHAddressHex("exemptedAddress", e.exemptedAddress), [4, this.getExemptedVotersByBallot({
                  ballotId: e.ballotId
                })];

              case 2:
                return a = n.sent(), r = a.find(function (t) {
                  return t === e.exemptedAddress;
                }), m.default.assert(!(void 0 === r) === e.exempt, p.ErrorCode.InvalidData, "No change"), [2];
            }
          });
        });
      }, n.changeDefaultExemptedVotersList = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = m.default).assert, [4, this.isCallerAllowed(e.txData, p.Perm.Admin)];

              case 1:
                return a.apply(t, [s.sent(), p.ErrorCode.Unauthorized, "Caller is not allowed"]), n = (r = m.default).assert, [4, this.isAnyBallotRunning()];

              case 2:
                return n.apply(r, [!s.sent(), p.ErrorCode.PreconditionRequired, "At least one ballot is running"]), m.default.isNonZeroETHAddressHex("voter", e.voter), [4, this.contract];

              case 3:
                return [2, s.sent().changeDefaultExemptedVotersList.sendTransactionAsync(e.voter, e.exempt, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.changeDefaultExemptedVotersListMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return a = (t = m.default).assert, [4, this.isCallerAllowed(e.txData, p.Perm.Admin)];

              case 1:
                return a.apply(t, [o.sent(), p.ErrorCode.Unauthorized, "Caller is not allowed"]), n = (r = m.default).assert, [4, this.isAnyBallotRunning()];

              case 2:
                for (n.apply(r, [!o.sent(), p.ErrorCode.PreconditionRequired, "At least one ballot is running"]), this.checkSameLength(e.voters.length, e.exempts.length), s = 0; s < e.voters.length; s += 1) {
                  m.default.isNonZeroETHAddressHex("voters", e.voters[s]);
                }

                return [4, this.contract];

              case 3:
                return [2, o.sent().changeDefaultExemptedVotersListMulti.sendTransactionAsync(e.voters, e.exempts, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.isAnyBallotRunning = function () {
        return s(n, void 0, void 0, function () {
          var e, t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return [4, this.getAllBallots()];

              case 1:
                if (!(e = s.sent()).length) return [3, 3];

                for (t = e.length - 1, a = [], n = t; n >= 0 && n < t; n -= 1) {
                  a.push(this.getCurrentBallotStage({
                    ballotId: n
                  }));
                }

                return [4, Promise.all(a)];

              case 2:
                for (r = s.sent(), n = 0; n < r.length; n += 1) {
                  if (r[n] === p.BallotStage.Commit && r[n] === p.BallotStage.Reveal && !e[n].isCancelled) return [2, !0];
                }

                s.label = 3;

              case 3:
                return [2, !1];
            }
          });
        });
      }, n.checkPositiveDurations = function (e, t) {
        m.default.assert(e > 0 && t > 0, p.ErrorCode.InvalidData, "Invalid Duration");
      }, n.checkNonEmptyTitle = function (e) {
        m.default.assert(e.length > 0, p.ErrorCode.InvalidData, "Empty title");
      }, n.checkSameLength = function (e, t) {
        m.default.assert(e === t, p.ErrorCode.InvalidData, "Length mismatch");
      }, n.checkIndexOutOfBound = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.getAllBallots()];

              case 1:
                return t = a.sent(), m.default.assert(t.length > e, p.ErrorCode.InvalidData, "Index out of bounds"), [2];
            }
          });
        });
      }, n.checkValidStage = function (e, t) {
        return s(n, void 0, void 0, function () {
          var a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.getCurrentBallotStage(e)];

              case 1:
                return a = r.sent(), m.default.assert(a === t, p.ErrorCode.InvalidData, "Invalid stage"), [2];
            }
          });
        });
      }, n.validateMaximumLimitCount = function () {
        return s(n, void 0, void 0, function () {
          var e;
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.getAllBallots()];

              case 1:
                return e = t.sent(), m.default.assert(e.length < 500, p.ErrorCode.PreconditionRequired, "Max Limit Reached"), [2];
            }
          });
        });
      }, n.subscribeAsync = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return m.default.doesBelongToStringEnum("eventName", e.eventName, d.AdvancedPLCRVotingCheckpointEvents_3_1_0), m.default.doesConformToSchema("indexFilterValues", e.indexFilterValues, l.schemas.indexFilterValuesSchema), m.default.isFunction("callback", e.callback), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.subscribeInternal(t, e.eventName, e.indexFilterValues, e.callback, e.isVerbose)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.getLogsAsync = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return m.default.doesBelongToStringEnum("eventName", e.eventName, d.AdvancedPLCRVotingCheckpointEvents_3_1_0), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.getLogsAsyncInternal(t, e.eventName, e.blockRange, e.indexFilterValues)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.contract = a, n;
    }

    return n(t, e), t;
  }(b.ModuleCommon);

  t.default = y, t.isAdvancedPLCRVotingCheckpoint = function (e) {
    return e instanceof y;
  };
},
/*!*************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/wallet/vesting_escrow_wallet_wrapper/index.ts ***!
  \*************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r50,
      n = this && this.__extends || (_r50 = function r(e, t) {
    return (_r50 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r50(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__importStar || function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var a in e) {
      Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t.default = e, t;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var i = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      c = a(
  /*! ./3.0.0 */
  865);
  t.VestingEscrowWallet_3_0_0 = c.VestingEscrowWallet_3_0_0, t.isVestingEscrowWallet_3_0_0 = c.isVestingEscrowWallet_3_0_0;
  var u = a(
  /*! ./3.1.0 */
  866);
  t.VestingEscrowWallet_3_1_0 = u.VestingEscrowWallet_3_1_0, t.isVestingEscrowWallet_3_1_0 = u.isVestingEscrowWallet_3_1_0;
  var d = o(a(
  /*! ./common */
  148));
  t.isVestingEscrowWallet = d.isVestingEscrowWallet, t.VestingEscrowWalletEvents = s({}, i.VestingEscrowWalletEvents_3_1_0, i.VestingEscrowWalletEvents_3_0_0);

  var f = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }

    return n(t, e), t;
  }(d.default);

  t.VestingEscrowWalletCommon = f;
},
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = this && this.__importStar || function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var a in e) {
      Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t.default = e, t;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = r(a(
  /*! ./utils/convert */
  16));
  t.conversionUtils = n, t.TransactionParams || (t.TransactionParams = {});
  var s = a(
  /*! ./contract_wrappers/contract_wrapper */
  44);
  t.ContractWrapper = s.default;
  var o = a(
  /*! ./contract_wrappers/registries/feature_registry_wrapper */
  285);
  t.FeatureRegistry = o.default;
  var i = a(
  /*! ./contract_wrappers/registries/module_registry_wrapper */
  286);
  t.ModuleRegistry = i.default;
  var c = a(
  /*! ./contract_wrappers/tokens/poly_token_wrapper */
  287);
  t.PolyToken = c.default;
  var u = a(
  /*! ./contract_wrappers/registries/polymath_registry_wrapper */
  288);
  t.PolymathRegistry = u.default;
  var d = a(
  /*! ./contract_wrappers/registries/security_token_registry_wrapper */
  289);
  t.SecurityTokenRegistry = d.default;
  var f = a(
  /*! ./contract_wrappers/modules/module_factory_wrapper */
  290);
  t.isModuleFactory = f.isModuleFactory, t.ModuleFactory_3_0_0 = f.ModuleFactory_3_0_0, t.isModuleFactory_3_0_0 = f.isModuleFactory_3_0_0, t.ModuleFactoryEvents = f.ModuleFactoryEvents;
  var l = a(
  /*! ./contract_wrappers/tokens/security_token_wrapper */
  292);
  t.isSecurityToken = l.isSecurityToken, t.SecurityToken_3_0_0 = l.SecurityToken_3_0_0, t.isSecurityToken_3_0_0 = l.isSecurityToken_3_0_0, t.SecurityTokenEvents = l.SecurityTokenEvents;
  var h = a(
  /*! ./contract_wrappers/tokens/erc20_detailed_wrapper */
  294);
  t.ERC20 = h.default;
  var p = a(
  /*! ./contract_wrappers/modules/checkpoint/erc20_dividend_checkpoint_wrapper */
  295);
  t.isERC20DividendCheckpoint = p.isERC20DividendCheckpoint, t.ERC20DividendCheckpoint_3_0_0 = p.ERC20DividendCheckpoint_3_0_0, t.isERC20DividendCheckpoint_3_0_0 = p.isERC20DividendCheckpoint_3_0_0, t.ERC20DividendCheckpointEvents = p.ERC20DividendCheckpointEvents;
  var b = a(
  /*! ./contract_wrappers/modules/checkpoint/ether_dividend_checkpoint_wrapper */
  297);
  t.isEtherDividendCheckpoint = b.isEtherDividendCheckpoint, t.EtherDividendCheckpoint_3_0_0 = b.EtherDividendCheckpoint_3_0_0, t.isEtherDividendCheckpoint_3_0_0 = b.isEtherDividendCheckpoint_3_0_0, t.EtherDividendCheckpointEvents = b.EtherDividendCheckpointEvents;
  var m = a(
  /*! ./contract_wrappers/modules/permission_manager/general_permission_manager_wrapper */
  299);
  t.isGeneralPermissionManager = m.isGeneralPermissionManager, t.GeneralPermissionManager_3_0_0 = m.GeneralPermissionManager_3_0_0, t.isGeneralPermissionManager_3_0_0 = m.isGeneralPermissionManager_3_0_0, t.GeneralPermissionManager_3_1_0 = m.GeneralPermissionManager_3_1_0, t.isGeneralPermissionManager_3_1_0 = m.isGeneralPermissionManager_3_1_0, t.GeneralPermissionManagerEvents = m.GeneralPermissionManagerEvents;
  var y = a(
  /*! ./contract_wrappers/modules/sto/capped_sto_wrapper */
  300);
  t.isCappedSTO = y.isCappedSTO, t.CappedSTO_3_0_0 = y.CappedSTO_3_0_0, t.isCappedSTO_3_0_0 = y.isCappedSTO_3_0_0, t.CappedSTO_3_1_0 = y.CappedSTO_3_1_0, t.isCappedSTO_3_1_0 = y.isCappedSTO_3_1_0, t.CappedSTOEvents = y.CappedSTOEvents;
  var v = a(
  /*! ./contract_wrappers/modules/sto/usd_tiered_sto_wrapper */
  301);
  t.isUSDTieredSTO = v.isUSDTieredSTO, t.USDTieredSTO_3_0_0 = v.USDTieredSTO_3_0_0, t.isUSDTieredSTO_3_0_0 = v.isUSDTieredSTO_3_0_0, t.USDTieredSTO_3_1_0 = v.USDTieredSTO_3_1_0, t.isUSDTieredSTO_3_1_0 = v.isUSDTieredSTO_3_1_0, t.USDTieredSTOEvents = v.USDTieredSTOEvents;

  var _ = a(
  /*! ./contract_wrappers/modules/transfer_manager/general_transfer_manager_wrapper */
  146);

  t.isGeneralTransferManager = _.isGeneralTransferManager, t.GeneralTransferManager_3_0_0 = _.GeneralTransferManager_3_0_0, t.isGeneralTransferManager_3_0_0 = _.isGeneralTransferManager_3_0_0, t.GeneralTransferManager_3_1_0 = _.GeneralTransferManager_3_1_0, t.isGeneralTransferManager_3_1_0 = _.isGeneralTransferManager_3_1_0, t.GeneralTransferManagerEvents = _.GeneralTransferManagerEvents;
  var g = a(
  /*! ./contract_wrappers/modules/transfer_manager/count_transfer_manager_wrapper */
  302);
  t.isCountTransferManager = g.isCountTransferManager, t.CountTransferManager_3_0_0 = g.CountTransferManager_3_0_0, t.isCountTransferManager_3_0_0 = g.isCountTransferManager_3_0_0, t.CountTransferManagerEvents = g.CountTransferManagerEvents;
  var A = a(
  /*! ./contract_wrappers/modules/transfer_manager/manual_approval_transfer_manager_wrapper */
  304);
  t.isManualApprovalTransferManager = A.isManualApprovalTransferManager, t.ManualApprovalTransferManager_3_0_0 = A.ManualApprovalTransferManager_3_0_0, t.isManualApprovalTransferManager_3_0_0 = A.isManualApprovalTransferManager_3_0_0, t.ManualApprovalTransferManagerEvents = A.ManualApprovalTransferManagerEvents;
  var w = a(
  /*! ./contract_wrappers/modules/transfer_manager/percentage_transfer_manager_wrapper */
  306);
  t.isPercentageTransferManager = w.isPercentageTransferManager, t.PercentageTransferManager_3_0_0 = w.PercentageTransferManager_3_0_0, t.isPercentageTransferManager_3_0_0 = w.isPercentageTransferManager_3_0_0, t.PercentageTransferManagerEvents = w.PercentageTransferManagerEvents;
  var T = a(
  /*! ./contract_wrappers/modules/transfer_manager/lock_up_transfer_manager_wrapper */
  308);
  t.isLockUpTransferManager = T.isLockUpTransferManager, t.LockUpTransferManager_3_0_0 = T.LockUpTransferManager_3_0_0, t.isLockUpTransferManager_3_0_0 = T.isLockUpTransferManager_3_0_0, t.LockUpTransferManagerEvents = T.LockUpTransferManagerEvents;
  var x = a(
  /*! ./contract_wrappers/modules/transfer_manager/blacklist_transfer_manager_wrapper */
  310);
  t.isBlacklistTransferManager = x.isBlacklistTransferManager, t.BlacklistTransferManager_3_0_0 = x.BlacklistTransferManager_3_0_0, t.isBlacklistTransferManager_3_0_0 = x.isBlacklistTransferManager_3_0_0, t.BlacklistTransferManagerEvents = x.BlacklistTransferManagerEvents;
  var D = a(
  /*! ./contract_wrappers/modules/transfer_manager/volume_restriction_transfer_manager_wrapper */
  312);
  t.isVolumeRestrictionTransferManager = D.isVolumeRestrictionTransferManager, t.VolumeRestrictionTransferManager_3_0_0 = D.VolumeRestrictionTransferManager_3_0_0, t.isVolumeRestrictionTransferManager_3_0_0 = D.isVolumeRestrictionTransferManager_3_0_0, t.VolumeRestrictionTMEvents = D.VolumeRestrictionTMEvents;
  var C = a(
  /*! ./contract_wrappers/modules/transfer_manager/restricted_partial_sale_transfer_manager_wrapper */
  314);
  t.isRestrictedPartialSaleTransferManager = C.isRestrictedPartialSaleTransferManager, t.RestrictedPartialSaleTransferManager_3_1_0 = C.RestrictedPartialSaleTransferManager_3_1_0, t.isRestrictedPartialSaleTransferManager_3_1_0 = C.isRestrictedPartialSaleTransferManager_3_1_0, t.RestrictedPartialSaleTransferManagerEvents = C.RestrictedPartialSaleTransferManagerEvents;
  var S = a(
  /*! ./contract_wrappers/modules/checkpoint/voting/advanced_p_l_c_r_voting_checkpoint_wrapper */
  316);
  t.isAdvancedPLCRVotingCheckpoint = S.isAdvancedPLCRVotingCheckpoint, t.AdvancedPLCRVotingCheckpoint_3_1_0 = S.AdvancedPLCRVotingCheckpoint_3_1_0, t.isAdvancedPLCRVotingCheckpoint_3_1_0 = S.isAdvancedPLCRVotingCheckpoint_3_1_0, t.AdvancedPLCRVotingCheckpointEvents = S.AdvancedPLCRVotingCheckpointEvents;
  var E = a(
  /*! ./contract_wrappers/modules/wallet/vesting_escrow_wallet_wrapper */
  318);
  t.isVestingEscrowWallet = E.isVestingEscrowWallet, t.VestingEscrowWallet_3_0_0 = E.VestingEscrowWallet_3_0_0, t.isVestingEscrowWallet_3_0_0 = E.isVestingEscrowWallet_3_0_0, t.VestingEscrowWallet_3_1_0 = E.VestingEscrowWallet_3_1_0, t.isVestingEscrowWallet_3_1_0 = E.isVestingEscrowWallet_3_1_0, t.VestingEscrowWalletEvents = E.VestingEscrowWalletEvents, function (e) {
    for (var a in e) {
      t.hasOwnProperty(a) || (t[a] = e[a]);
    }
  }(a(
  /*! ./types */
  4));
  var B = a(
  /*! ./PolymathAPI */
  867);
  t.PolymathAPI = B.PolymathAPI;
  var k = a(
  /*! @polymathnetwork/abi-wrappers */
  6);
  t.PolyResponse = k.PolyResponse, t.BlockParamLiteral = k.BlockParamLiteral, t.Web3Wrapper = k.Web3Wrapper, t.BigNumber = k.BigNumber, t.PolyTokenContract = k.PolyTokenContract_3_0_0, t.PolyTokenEvents = k.PolyTokenEvents_3_0_0, t.PolyTokenFaucetContract = k.PolyTokenFaucetContract_3_0_0, t.PolyTokenFaucetEvents = k.PolyTokenFaucetEvents_3_0_0, t.PolymathRegistryContract = k.PolymathRegistryContract_3_0_0, t.PolymathRegistryEvents = k.PolymathRegistryEvents_3_0_0, t.ModuleRegistryContract = k.ModuleRegistryContract_3_0_0, t.ModuleRegistryEvents = k.ModuleRegistryEvents_3_0_0, t.FeatureRegistryContract = k.FeatureRegistryContract_3_0_0, t.FeatureRegistryEvents = k.FeatureRegistryEvents_3_0_0, t.SecurityTokenRegistryContract = k.ISecurityTokenRegistryContract_3_0_0, t.SecurityTokenRegistryEvents = k.ISecurityTokenRegistryEvents_3_0_0, t.SecurityTokenContract_3_0_0 = k.ISecurityTokenContract_3_0_0, t.GeneralTransferManagerContract_3_0_0 = k.GeneralTransferManagerContract_3_0_0, t.GeneralTransferManagerContract_3_1_0 = k.GeneralTransferManagerContract_3_1_0, t.GeneralPermissionManagerContract_3_0_0 = k.GeneralPermissionManagerContract_3_0_0, t.GeneralPermissionManagerContract_3_1_0 = k.GeneralPermissionManagerContract_3_1_0, t.ERC20DividendCheckpointContract_3_0_0 = k.ERC20DividendCheckpointContract_3_0_0, t.EtherDividendCheckpointContract_3_0_0 = k.EtherDividendCheckpointContract_3_0_0, t.CappedSTOContract_3_0_0 = k.CappedSTOContract_3_0_0, t.CappedSTOContract_3_1_0 = k.CappedSTOContract_3_1_0, t.USDTieredSTOContract_3_0_0 = k.USDTieredSTOContract_3_0_0, t.USDTieredSTOContract_3_1_0 = k.USDTieredSTOContract_3_1_0, t.ManualApprovalTransferManagerContract_3_0_0 = k.ManualApprovalTransferManagerContract_3_0_0, t.PercentageTransferManagerContract_3_0_0 = k.PercentageTransferManagerContract_3_0_0, t.LockUpTransferManagerContract_3_0_0 = k.LockUpTransferManagerContract_3_0_0, t.BlacklistTransferManagerContract_3_0_0 = k.BlacklistTransferManagerContract_3_0_0, t.CountTransferManagerContract_3_0_0 = k.CountTransferManagerContract_3_0_0, t.VolumeRestrictionTMContract_3_0_0 = k.VolumeRestrictionTMContract_3_0_0, t.RestrictedPartialSaleTMContract_3_1_0 = k.RestrictedPartialSaleTMContract_3_1_0, t.VestingEscrowWalletContract_3_0_0 = k.VestingEscrowWalletContract_3_0_0, t.VestingEscrowWalletContract_3_1_0 = k.VestingEscrowWalletContract_3_1_0;
},
/*!*****************************************!*\
  !*** ./node_modules/base64-js/index.js ***!
  \*****************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  t.byteLength = function (e) {
    var t = u(e),
        a = t[0],
        r = t[1];
    return 3 * (a + r) / 4 - r;
  }, t.toByteArray = function (e) {
    var t,
        a,
        r = u(e),
        o = r[0],
        i = r[1],
        c = new s(function (e, t, a) {
      return 3 * (t + a) / 4 - a;
    }(0, o, i)),
        d = 0,
        f = i > 0 ? o - 4 : o;

    for (a = 0; a < f; a += 4) {
      t = n[e.charCodeAt(a)] << 18 | n[e.charCodeAt(a + 1)] << 12 | n[e.charCodeAt(a + 2)] << 6 | n[e.charCodeAt(a + 3)], c[d++] = t >> 16 & 255, c[d++] = t >> 8 & 255, c[d++] = 255 & t;
    }

    2 === i && (t = n[e.charCodeAt(a)] << 2 | n[e.charCodeAt(a + 1)] >> 4, c[d++] = 255 & t);
    1 === i && (t = n[e.charCodeAt(a)] << 10 | n[e.charCodeAt(a + 1)] << 4 | n[e.charCodeAt(a + 2)] >> 2, c[d++] = t >> 8 & 255, c[d++] = 255 & t);
    return c;
  }, t.fromByteArray = function (e) {
    for (var t, a = e.length, n = a % 3, s = [], o = 0, i = a - n; o < i; o += 16383) {
      s.push(d(e, o, o + 16383 > i ? i : o + 16383));
    }

    1 === n ? (t = e[a - 1], s.push(r[t >> 2] + r[t << 4 & 63] + "==")) : 2 === n && (t = (e[a - 2] << 8) + e[a - 1], s.push(r[t >> 10] + r[t >> 4 & 63] + r[t << 2 & 63] + "="));
    return s.join("");
  };

  for (var r = [], n = [], s = "undefined" != typeof Uint8Array ? Uint8Array : Array, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", i = 0, c = o.length; i < c; ++i) {
    r[i] = o[i], n[o.charCodeAt(i)] = i;
  }

  function u(e) {
    var t = e.length;
    if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    var a = e.indexOf("=");
    return -1 === a && (a = t), [a, a === t ? 0 : 4 - a % 4];
  }

  function d(e, t, a) {
    for (var n, s, o = [], i = t; i < a; i += 3) {
      n = (e[i] << 16 & 16711680) + (e[i + 1] << 8 & 65280) + (255 & e[i + 2]), o.push(r[(s = n) >> 18 & 63] + r[s >> 12 & 63] + r[s >> 6 & 63] + r[63 & s]);
    }

    return o.join("");
  }

  n["-".charCodeAt(0)] = 62, n["_".charCodeAt(0)] = 63;
},
/*!***************************************!*\
  !*** ./node_modules/ieee754/index.js ***!
  \***************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  t.read = function (e, t, a, r, n) {
    var s,
        o,
        i = 8 * n - r - 1,
        c = (1 << i) - 1,
        u = c >> 1,
        d = -7,
        f = a ? n - 1 : 0,
        l = a ? -1 : 1,
        h = e[t + f];

    for (f += l, s = h & (1 << -d) - 1, h >>= -d, d += i; d > 0; s = 256 * s + e[t + f], f += l, d -= 8) {
      ;
    }

    for (o = s & (1 << -d) - 1, s >>= -d, d += r; d > 0; o = 256 * o + e[t + f], f += l, d -= 8) {
      ;
    }

    if (0 === s) s = 1 - u;else {
      if (s === c) return o ? NaN : 1 / 0 * (h ? -1 : 1);
      o += Math.pow(2, r), s -= u;
    }
    return (h ? -1 : 1) * o * Math.pow(2, s - r);
  }, t.write = function (e, t, a, r, n, s) {
    var o,
        i,
        c,
        u = 8 * s - n - 1,
        d = (1 << u) - 1,
        f = d >> 1,
        l = 23 === n ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
        h = r ? 0 : s - 1,
        p = r ? 1 : -1,
        b = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;

    for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (i = isNaN(t) ? 1 : 0, o = d) : (o = Math.floor(Math.log(t) / Math.LN2), t * (c = Math.pow(2, -o)) < 1 && (o--, c *= 2), (t += o + f >= 1 ? l / c : l * Math.pow(2, 1 - f)) * c >= 2 && (o++, c /= 2), o + f >= d ? (i = 0, o = d) : o + f >= 1 ? (i = (t * c - 1) * Math.pow(2, n), o += f) : (i = t * Math.pow(2, f - 1) * Math.pow(2, n), o = 0)); n >= 8; e[a + h] = 255 & i, h += p, i /= 256, n -= 8) {
      ;
    }

    for (o = o << n | i, u += n; u > 0; e[a + h] = 255 & o, h += p, o /= 256, u -= 8) {
      ;
    }

    e[a + h - p] |= 128 * b;
  };
},
/*!**************************************************!*\
  !*** ./node_modules/jsonschema/lib/validator.js ***!
  \**************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! url */
  94),
      n = a(
  /*! ./attribute */
  328),
      s = a(
  /*! ./helpers */
  57),
      o = a(
  /*! ./scan */
  95).scan,
      i = s.ValidatorResult,
      c = s.SchemaError,
      u = s.SchemaContext,
      d = function e() {
    this.customFormats = Object.create(e.prototype.customFormats), this.schemas = {}, this.unresolvedRefs = [], this.types = Object.create(l), this.attributes = Object.create(n.validators);
  };

  function f(e) {
    var t = "string" == typeof e ? e : e.$ref;
    return "string" == typeof t && t;
  }

  d.prototype.customFormats = {}, d.prototype.schemas = null, d.prototype.types = null, d.prototype.attributes = null, d.prototype.unresolvedRefs = null, d.prototype.addSchema = function (e, t) {
    var a = this;
    if (!e) return null;
    var r = o(t || "/", e),
        n = t || e.id;

    for (var s in r.id) {
      this.schemas[s] = r.id[s];
    }

    for (var s in r.ref) {
      this.unresolvedRefs.push(s);
    }

    return this.unresolvedRefs = this.unresolvedRefs.filter(function (e) {
      return void 0 === a.schemas[e];
    }), this.schemas[n];
  }, d.prototype.addSubSchemaArray = function (e, t) {
    if (t instanceof Array) for (var a = 0; a < t.length; a++) {
      this.addSubSchema(e, t[a]);
    }
  }, d.prototype.addSubSchemaObject = function (e, t) {
    if (t && "object" == typeof t) for (var a in t) {
      this.addSubSchema(e, t[a]);
    }
  }, d.prototype.setSchemas = function (e) {
    this.schemas = e;
  }, d.prototype.getSchema = function (e) {
    return this.schemas[e];
  }, d.prototype.validate = function (e, t, a, n) {
    a || (a = {});
    var s = a.propertyName || "instance",
        i = r.resolve(a.base || "/", t.id || "");

    if (!n) {
      (n = new u(t, a, s, i, Object.create(this.schemas))).schemas[i] || (n.schemas[i] = t);
      var d = o(i, t);

      for (var f in d.id) {
        var l = d.id[f];
        n.schemas[f] = l;
      }
    }

    if (t) {
      var h = this.validateSchema(e, t, a, n);
      if (!h) throw new Error("Result undefined");
      return h;
    }

    throw new c("no schema specified", t);
  }, d.prototype.validateSchema = function (e, t, a, r) {
    var o,
        d = new i(e, t, a, r);
    if ("boolean" == typeof t) !0 === t ? t = {} : !1 === t && (t = {
      type: []
    });else if (!t) throw new Error("schema is undefined");
    if (t.extends) if (t.extends instanceof Array) {
      var l = {
        schema: t,
        ctx: r
      };
      t.extends.forEach(this.schemaTraverser.bind(this, l)), t = l.schema, l.schema = null, l.ctx = null, l = null;
    } else t = s.deepMerge(t, this.superResolve(t.extends, r));

    if (o = f(t)) {
      var h = this.resolve(t, o, r),
          p = new u(h.subschema, a, r.propertyPath, h.switchSchema, r.schemas);
      return this.validateSchema(e, h.subschema, a, p);
    }

    var b = a && a.skipAttributes || [];

    for (var m in t) {
      if (!n.ignoreProperties[m] && b.indexOf(m) < 0) {
        var y = null,
            v = this.attributes[m];
        if (v) y = v.call(this, e, t, a, r);else if (!1 === a.allowUnknownAttributes) throw new c("Unsupported attribute: " + m, t);
        y && d.importErrors(y);
      }
    }

    if ("function" == typeof a.rewrite) {
      var _ = a.rewrite.call(this, e, t, a, r);

      d.instance = _;
    }

    return d;
  }, d.prototype.schemaTraverser = function (e, t) {
    e.schema = s.deepMerge(e.schema, this.superResolve(t, e.ctx));
  }, d.prototype.superResolve = function (e, t) {
    var a;
    return (a = f(e)) ? this.resolve(e, a, t).subschema : e;
  }, d.prototype.resolve = function (e, t, a) {
    if (t = a.resolve(t), a.schemas[t]) return {
      subschema: a.schemas[t],
      switchSchema: t
    };
    var n = r.parse(t),
        o = n && n.hash,
        i = o && o.length && t.substr(0, t.length - o.length);
    if (!i || !a.schemas[i]) throw new c("no such schema <" + t + ">", e);
    var u = s.objectGetPath(a.schemas[i], o.substr(1));
    if (void 0 === u) throw new c("no such schema " + o + " located in <" + i + ">", e);
    return {
      subschema: u,
      switchSchema: t
    };
  }, d.prototype.testType = function (e, t, a, r, n) {
    if ("function" == typeof this.types[n]) return this.types[n].call(this, e);

    if (n && "object" == typeof n) {
      var s = this.validateSchema(e, n, a, r);
      return void 0 === s || !(s && s.errors.length);
    }

    return !0;
  };
  var l = d.prototype.types = {};
  l.string = function (e) {
    return "string" == typeof e;
  }, l.number = function (e) {
    return "number" == typeof e && isFinite(e);
  }, l.integer = function (e) {
    return "number" == typeof e && e % 1 == 0;
  }, l.boolean = function (e) {
    return "boolean" == typeof e;
  }, l.array = function (e) {
    return Array.isArray(e);
  }, l.null = function (e) {
    return null === e;
  }, l.date = function (e) {
    return e instanceof Date;
  }, l.any = function (e) {
    return !0;
  }, l.object = function (e) {
    return e && "object" == typeof e && !(e instanceof Array) && !(e instanceof Date);
  }, e.exports = d;
},
/*!**************************************************************************!*\
  !*** ./node_modules/node-libs-browser/node_modules/punycode/punycode.js ***!
  \**************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (e, r) {
    var n;
    /*! https://mths.be/punycode v1.4.1 by @mathias */

    !function (s) {
      t && t.nodeType, e && e.nodeType;
      var o = "object" == typeof r && r;
      o.global !== o && o.window !== o && o.self;
      var i,
          c = 2147483647,
          u = 36,
          d = 1,
          f = 26,
          l = 38,
          h = 700,
          p = 72,
          b = 128,
          m = "-",
          y = /^xn--/,
          v = /[^\x20-\x7E]/,
          _ = /[\x2E\u3002\uFF0E\uFF61]/g,
          g = {
        overflow: "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
      },
          A = u - d,
          w = Math.floor,
          T = String.fromCharCode;

      function x(e) {
        throw new RangeError(g[e]);
      }

      function D(e, t) {
        for (var a = e.length, r = []; a--;) {
          r[a] = t(e[a]);
        }

        return r;
      }

      function C(e, t) {
        var a = e.split("@"),
            r = "";
        return a.length > 1 && (r = a[0] + "@", e = a[1]), r + D((e = e.replace(_, ".")).split("."), t).join(".");
      }

      function S(e) {
        for (var t, a, r = [], n = 0, s = e.length; n < s;) {
          (t = e.charCodeAt(n++)) >= 55296 && t <= 56319 && n < s ? 56320 == (64512 & (a = e.charCodeAt(n++))) ? r.push(((1023 & t) << 10) + (1023 & a) + 65536) : (r.push(t), n--) : r.push(t);
        }

        return r;
      }

      function E(e) {
        return D(e, function (e) {
          var t = "";
          return e > 65535 && (t += T((e -= 65536) >>> 10 & 1023 | 55296), e = 56320 | 1023 & e), t += T(e);
        }).join("");
      }

      function B(e, t) {
        return e + 22 + 75 * (e < 26) - ((0 != t) << 5);
      }

      function k(e, t, a) {
        var r = 0;

        for (e = a ? w(e / h) : e >> 1, e += w(e / t); e > A * f >> 1; r += u) {
          e = w(e / A);
        }

        return w(r + (A + 1) * e / (e + l));
      }

      function R(e) {
        var t,
            a,
            r,
            n,
            s,
            o,
            i,
            l,
            h,
            y,
            v,
            _ = [],
            g = e.length,
            A = 0,
            T = b,
            D = p;

        for ((a = e.lastIndexOf(m)) < 0 && (a = 0), r = 0; r < a; ++r) {
          e.charCodeAt(r) >= 128 && x("not-basic"), _.push(e.charCodeAt(r));
        }

        for (n = a > 0 ? a + 1 : 0; n < g;) {
          for (s = A, o = 1, i = u; n >= g && x("invalid-input"), ((l = (v = e.charCodeAt(n++)) - 48 < 10 ? v - 22 : v - 65 < 26 ? v - 65 : v - 97 < 26 ? v - 97 : u) >= u || l > w((c - A) / o)) && x("overflow"), A += l * o, !(l < (h = i <= D ? d : i >= D + f ? f : i - D)); i += u) {
            o > w(c / (y = u - h)) && x("overflow"), o *= y;
          }

          D = k(A - s, t = _.length + 1, 0 == s), w(A / t) > c - T && x("overflow"), T += w(A / t), A %= t, _.splice(A++, 0, T);
        }

        return E(_);
      }

      function W(e) {
        var t,
            a,
            r,
            n,
            s,
            o,
            i,
            l,
            h,
            y,
            v,
            _,
            g,
            A,
            D,
            C = [];

        for (_ = (e = S(e)).length, t = b, a = 0, s = p, o = 0; o < _; ++o) {
          (v = e[o]) < 128 && C.push(T(v));
        }

        for (r = n = C.length, n && C.push(m); r < _;) {
          for (i = c, o = 0; o < _; ++o) {
            (v = e[o]) >= t && v < i && (i = v);
          }

          for (i - t > w((c - a) / (g = r + 1)) && x("overflow"), a += (i - t) * g, t = i, o = 0; o < _; ++o) {
            if ((v = e[o]) < t && ++a > c && x("overflow"), v == t) {
              for (l = a, h = u; !(l < (y = h <= s ? d : h >= s + f ? f : h - s)); h += u) {
                D = l - y, A = u - y, C.push(T(B(y + D % A, 0))), l = w(D / A);
              }

              C.push(T(B(l, 0))), s = k(a, g, r == n), a = 0, ++r;
            }
          }

          ++a, ++t;
        }

        return C.join("");
      }

      i = {
        version: "1.4.1",
        ucs2: {
          decode: S,
          encode: E
        },
        decode: R,
        encode: W,
        toASCII: function toASCII(e) {
          return C(e, function (e) {
            return v.test(e) ? "xn--" + W(e) : e;
          });
        },
        toUnicode: function toUnicode(e) {
          return C(e, function (e) {
            return y.test(e) ? R(e.slice(4).toLowerCase()) : e;
          });
        }
      }, void 0 === (n = function () {
        return i;
      }.call(t, a, t, e)) || (e.exports = n);
    }();
  }).call(this, a(
  /*! ./../../../webpack/buildin/module.js */
  45)(e), a(
  /*! ./../../../webpack/buildin/global.js */
  18));
},
/*!**********************************!*\
  !*** ./node_modules/url/util.js ***!
  \**********************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  e.exports = {
    isString: function isString(e) {
      return "string" == typeof e;
    },
    isObject: function isObject(e) {
      return "object" == typeof e && null !== e;
    },
    isNull: function isNull(e) {
      return null === e;
    },
    isNullOrUndefined: function isNullOrUndefined(e) {
      return null == e;
    }
  };
},
/*!***********************************************!*\
  !*** ./node_modules/querystring-es3/index.js ***!
  \***********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  t.decode = t.parse = a(
  /*! ./decode */
  326), t.encode = t.stringify = a(
  /*! ./encode */
  327);
},
/*!************************************************!*\
  !*** ./node_modules/querystring-es3/decode.js ***!
  \************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  function r(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }

  e.exports = function (e, t, a, s) {
    t = t || "&", a = a || "=";
    var o = {};
    if ("string" != typeof e || 0 === e.length) return o;
    var i = /\+/g;
    e = e.split(t);
    var c = 1e3;
    s && "number" == typeof s.maxKeys && (c = s.maxKeys);
    var u = e.length;
    c > 0 && u > c && (u = c);

    for (var d = 0; d < u; ++d) {
      var f,
          l,
          h,
          p,
          b = e[d].replace(i, "%20"),
          m = b.indexOf(a);
      m >= 0 ? (f = b.substr(0, m), l = b.substr(m + 1)) : (f = b, l = ""), h = decodeURIComponent(f), p = decodeURIComponent(l), r(o, h) ? n(o[h]) ? o[h].push(p) : o[h] = [o[h], p] : o[h] = p;
    }

    return o;
  };

  var n = Array.isArray || function (e) {
    return "[object Array]" === Object.prototype.toString.call(e);
  };
},
/*!************************************************!*\
  !*** ./node_modules/querystring-es3/encode.js ***!
  \************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = function r(e) {
    switch (typeof e) {
      case "string":
        return e;

      case "boolean":
        return e ? "true" : "false";

      case "number":
        return isFinite(e) ? e : "";

      default:
        return "";
    }
  };

  e.exports = function (e, t, a, i) {
    return t = t || "&", a = a || "=", null === e && (e = void 0), "object" == typeof e ? s(o(e), function (o) {
      var i = encodeURIComponent(r(o)) + a;
      return n(e[o]) ? s(e[o], function (e) {
        return i + encodeURIComponent(r(e));
      }).join(t) : i + encodeURIComponent(r(e[o]));
    }).join(t) : i ? encodeURIComponent(r(i)) + a + encodeURIComponent(r(e)) : "";
  };

  var n = Array.isArray || function (e) {
    return "[object Array]" === Object.prototype.toString.call(e);
  };

  function s(e, t) {
    if (e.map) return e.map(t);

    for (var a = [], r = 0; r < e.length; r++) {
      a.push(t(e[r], r));
    }

    return a;
  }

  var o = Object.keys || function (e) {
    var t = [];

    for (var a in e) {
      Object.prototype.hasOwnProperty.call(e, a) && t.push(a);
    }

    return t;
  };
},
/*!**************************************************!*\
  !*** ./node_modules/jsonschema/lib/attribute.js ***!
  \**************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ./helpers */
  57),
      n = r.ValidatorResult,
      s = r.SchemaError,
      o = {
    ignoreProperties: {
      id: !0,
      default: !0,
      description: !0,
      title: !0,
      exclusiveMinimum: !0,
      exclusiveMaximum: !0,
      additionalItems: !0,
      $schema: !0,
      $ref: !0,
      extends: !0
    }
  },
      i = o.validators = {};

  function c(e, t, a, r, n) {
    var s = t.throwError;
    t.throwError = !1;
    var o = this.validateSchema(e, n, t, a);
    return t.throwError = s, !o.valid && r instanceof Function && r(o), o.valid;
  }

  function u(e, t, a, r, n, s) {
    if (this.types.object(e) && (!t.properties || void 0 === t.properties[n])) if (!1 === t.additionalProperties) s.addError({
      name: "additionalProperties",
      argument: n,
      message: "additionalProperty " + JSON.stringify(n) + " exists in instance when not allowed"
    });else {
      var o = t.additionalProperties || {};
      "function" == typeof a.preValidateProperty && a.preValidateProperty(e, n, o, a, r);
      var i = this.validateSchema(e[n], o, a, r.makeChild(o, n));
      i.instance !== s.instance[n] && (s.instance[n] = i.instance), s.importErrors(i);
    }
  }

  i.type = function (e, t, a, r) {
    if (void 0 === e) return null;
    var s = new n(e, t, a, r),
        o = Array.isArray(t.type) ? t.type : [t.type];

    if (!o.some(this.testType.bind(this, e, t, a, r))) {
      var i = o.map(function (e) {
        return e.id && "<" + e.id + ">" || e + "";
      });
      s.addError({
        name: "type",
        argument: i,
        message: "is not of a type(s) " + i
      });
    }

    return s;
  }, i.anyOf = function (e, t, a, r) {
    if (void 0 === e) return null;
    var o = new n(e, t, a, r),
        i = new n(e, t, a, r);
    if (!Array.isArray(t.anyOf)) throw new s("anyOf must be an array");

    if (!t.anyOf.some(c.bind(this, e, a, r, function (e) {
      i.importErrors(e);
    }))) {
      var u = t.anyOf.map(function (e, t) {
        return e.id && "<" + e.id + ">" || e.title && JSON.stringify(e.title) || e.$ref && "<" + e.$ref + ">" || "[subschema " + t + "]";
      });
      a.nestedErrors && o.importErrors(i), o.addError({
        name: "anyOf",
        argument: u,
        message: "is not any of " + u.join(",")
      });
    }

    return o;
  }, i.allOf = function (e, t, a, r) {
    if (void 0 === e) return null;
    if (!Array.isArray(t.allOf)) throw new s("allOf must be an array");
    var o = new n(e, t, a, r),
        i = this;
    return t.allOf.forEach(function (t, n) {
      var s = i.validateSchema(e, t, a, r);

      if (!s.valid) {
        var c = t.id && "<" + t.id + ">" || t.title && JSON.stringify(t.title) || t.$ref && "<" + t.$ref + ">" || "[subschema " + n + "]";
        o.addError({
          name: "allOf",
          argument: {
            id: c,
            length: s.errors.length,
            valid: s
          },
          message: "does not match allOf schema " + c + " with " + s.errors.length + " error[s]:"
        }), o.importErrors(s);
      }
    }), o;
  }, i.oneOf = function (e, t, a, r) {
    if (void 0 === e) return null;
    if (!Array.isArray(t.oneOf)) throw new s("oneOf must be an array");
    var o = new n(e, t, a, r),
        i = new n(e, t, a, r),
        u = t.oneOf.filter(c.bind(this, e, a, r, function (e) {
      i.importErrors(e);
    })).length,
        d = t.oneOf.map(function (e, t) {
      return e.id && "<" + e.id + ">" || e.title && JSON.stringify(e.title) || e.$ref && "<" + e.$ref + ">" || "[subschema " + t + "]";
    });
    return 1 !== u && (a.nestedErrors && o.importErrors(i), o.addError({
      name: "oneOf",
      argument: d,
      message: "is not exactly one from " + d.join(",")
    })), o;
  }, i.properties = function (e, t, a, r) {
    if (this.types.object(e)) {
      var s = new n(e, t, a, r),
          o = t.properties || {};

      for (var i in o) {
        "function" == typeof a.preValidateProperty && a.preValidateProperty(e, i, o[i], a, r);
        var c = Object.hasOwnProperty.call(e, i) ? e[i] : void 0,
            u = this.validateSchema(c, o[i], a, r.makeChild(o[i], i));
        u.instance !== s.instance[i] && (s.instance[i] = u.instance), s.importErrors(u);
      }

      return s;
    }
  }, i.patternProperties = function (e, t, a, r) {
    if (this.types.object(e)) {
      var s = new n(e, t, a, r),
          o = t.patternProperties || {};

      for (var i in e) {
        var c = !0;

        for (var d in o) {
          if (new RegExp(d).test(i)) {
            c = !1, "function" == typeof a.preValidateProperty && a.preValidateProperty(e, i, o[d], a, r);
            var f = this.validateSchema(e[i], o[d], a, r.makeChild(o[d], i));
            f.instance !== s.instance[i] && (s.instance[i] = f.instance), s.importErrors(f);
          }
        }

        c && u.call(this, e, t, a, r, i, s);
      }

      return s;
    }
  }, i.additionalProperties = function (e, t, a, r) {
    if (this.types.object(e)) {
      if (t.patternProperties) return null;
      var s = new n(e, t, a, r);

      for (var o in e) {
        u.call(this, e, t, a, r, o, s);
      }

      return s;
    }
  }, i.minProperties = function (e, t, a, r) {
    if (this.types.object(e)) {
      var s = new n(e, t, a, r);
      return Object.keys(e).length >= t.minProperties || s.addError({
        name: "minProperties",
        argument: t.minProperties,
        message: "does not meet minimum property length of " + t.minProperties
      }), s;
    }
  }, i.maxProperties = function (e, t, a, r) {
    if (this.types.object(e)) {
      var s = new n(e, t, a, r);
      return Object.keys(e).length <= t.maxProperties || s.addError({
        name: "maxProperties",
        argument: t.maxProperties,
        message: "does not meet maximum property length of " + t.maxProperties
      }), s;
    }
  }, i.items = function (e, t, a, r) {
    var s = this;

    if (this.types.array(e) && t.items) {
      var o = new n(e, t, a, r);
      return e.every(function (e, n) {
        var i = Array.isArray(t.items) ? t.items[n] || t.additionalItems : t.items;
        if (void 0 === i) return !0;
        if (!1 === i) return o.addError({
          name: "items",
          message: "additionalItems not permitted"
        }), !1;
        var c = s.validateSchema(e, i, a, r.makeChild(i, n));
        return c.instance !== o.instance[n] && (o.instance[n] = c.instance), o.importErrors(c), !0;
      }), o;
    }
  }, i.minimum = function (e, t, a, r) {
    if (this.types.number(e)) {
      var s = new n(e, t, a, r);
      return (t.exclusiveMinimum && !0 === t.exclusiveMinimum ? e > t.minimum : e >= t.minimum) || s.addError({
        name: "minimum",
        argument: t.minimum,
        message: "must have a minimum value of " + t.minimum
      }), s;
    }
  }, i.maximum = function (e, t, a, r) {
    if (this.types.number(e)) {
      var s = new n(e, t, a, r);
      return (t.exclusiveMaximum && !0 === t.exclusiveMaximum ? e < t.maximum : e <= t.maximum) || s.addError({
        name: "maximum",
        argument: t.maximum,
        message: "must have a maximum value of " + t.maximum
      }), s;
    }
  };

  var d = function d(e, t, a, o, i, c) {
    if (this.types.number(e)) {
      var u = t[i];
      if (0 == u) throw new s(i + " cannot be zero");
      var d = new n(e, t, a, o),
          f = r.getDecimalPlaces(e),
          l = r.getDecimalPlaces(u),
          h = Math.max(f, l),
          p = Math.pow(10, h);
      return Math.round(e * p) % Math.round(u * p) != 0 && d.addError({
        name: i,
        argument: u,
        message: c + JSON.stringify(u)
      }), d;
    }
  };

  function f(e, t, a) {
    var n,
        s = a.length;

    for (n = t + 1; n < s; n++) {
      if (r.deepCompareStrict(e, a[n])) return !1;
    }

    return !0;
  }

  i.multipleOf = function (e, t, a, r) {
    return d.call(this, e, t, a, r, "multipleOf", "is not a multiple of (divisible by) ");
  }, i.divisibleBy = function (e, t, a, r) {
    return d.call(this, e, t, a, r, "divisibleBy", "is not divisible by (multiple of) ");
  }, i.required = function (e, t, a, r) {
    var s = new n(e, t, a, r);
    return void 0 === e && !0 === t.required ? s.addError({
      name: "required",
      message: "is required"
    }) : this.types.object(e) && Array.isArray(t.required) && t.required.forEach(function (t) {
      void 0 === e[t] && s.addError({
        name: "required",
        argument: t,
        message: "requires property " + JSON.stringify(t)
      });
    }), s;
  }, i.pattern = function (e, t, a, r) {
    if (this.types.string(e)) {
      var s = new n(e, t, a, r);
      return e.match(t.pattern) || s.addError({
        name: "pattern",
        argument: t.pattern,
        message: "does not match pattern " + JSON.stringify(t.pattern)
      }), s;
    }
  }, i.format = function (e, t, a, s) {
    if (void 0 !== e) {
      var o = new n(e, t, a, s);
      return o.disableFormat || r.isFormat(e, t.format, this) || o.addError({
        name: "format",
        argument: t.format,
        message: "does not conform to the " + JSON.stringify(t.format) + " format"
      }), o;
    }
  }, i.minLength = function (e, t, a, r) {
    if (this.types.string(e)) {
      var s = new n(e, t, a, r),
          o = e.match(/[\uDC00-\uDFFF]/g);
      return e.length - (o ? o.length : 0) >= t.minLength || s.addError({
        name: "minLength",
        argument: t.minLength,
        message: "does not meet minimum length of " + t.minLength
      }), s;
    }
  }, i.maxLength = function (e, t, a, r) {
    if (this.types.string(e)) {
      var s = new n(e, t, a, r),
          o = e.match(/[\uDC00-\uDFFF]/g);
      return e.length - (o ? o.length : 0) <= t.maxLength || s.addError({
        name: "maxLength",
        argument: t.maxLength,
        message: "does not meet maximum length of " + t.maxLength
      }), s;
    }
  }, i.minItems = function (e, t, a, r) {
    if (this.types.array(e)) {
      var s = new n(e, t, a, r);
      return e.length >= t.minItems || s.addError({
        name: "minItems",
        argument: t.minItems,
        message: "does not meet minimum length of " + t.minItems
      }), s;
    }
  }, i.maxItems = function (e, t, a, r) {
    if (this.types.array(e)) {
      var s = new n(e, t, a, r);
      return e.length <= t.maxItems || s.addError({
        name: "maxItems",
        argument: t.maxItems,
        message: "does not meet maximum length of " + t.maxItems
      }), s;
    }
  }, i.uniqueItems = function (e, t, a, s) {
    if (this.types.array(e)) {
      var o = new n(e, t, a, s);
      return e.every(function (e, t, a) {
        for (var n = t + 1; n < a.length; n++) {
          if (r.deepCompareStrict(e, a[n])) return !1;
        }

        return !0;
      }) || o.addError({
        name: "uniqueItems",
        message: "contains duplicate item"
      }), o;
    }
  }, i.uniqueItems = function (e, t, a, r) {
    if (this.types.array(e)) {
      var s = new n(e, t, a, r);
      return e.every(f) || s.addError({
        name: "uniqueItems",
        message: "contains duplicate item"
      }), s;
    }
  }, i.dependencies = function (e, t, a, r) {
    if (this.types.object(e)) {
      var s = new n(e, t, a, r);

      for (var o in t.dependencies) {
        if (void 0 !== e[o]) {
          var i = t.dependencies[o],
              c = r.makeChild(i, o);
          if ("string" == typeof i && (i = [i]), Array.isArray(i)) i.forEach(function (t) {
            void 0 === e[t] && s.addError({
              name: "dependencies",
              argument: c.propertyPath,
              message: "property " + t + " not found, required by " + c.propertyPath
            });
          });else {
            var u = this.validateSchema(e, i, a, c);
            s.instance !== u.instance && (s.instance = u.instance), u && u.errors.length && (s.addError({
              name: "dependencies",
              argument: c.propertyPath,
              message: "does not meet dependency required by " + c.propertyPath
            }), s.importErrors(u));
          }
        }
      }

      return s;
    }
  }, i.enum = function (e, t, a, o) {
    if (void 0 === e) return null;
    if (!Array.isArray(t.enum)) throw new s("enum expects an array", t);
    var i = new n(e, t, a, o);
    return t.enum.some(r.deepCompareStrict.bind(null, e)) || i.addError({
      name: "enum",
      argument: t.enum,
      message: "is not one of enum values: " + t.enum.map(String).join(",")
    }), i;
  }, i.const = function (e, t, a, s) {
    if (void 0 === e) return null;
    var o = new n(e, t, a, s);
    return r.deepCompareStrict(t.const, e) || o.addError({
      name: "const",
      argument: t.const,
      message: "does not exactly match expected constant: " + t.const
    }), o;
  }, i.not = i.disallow = function (e, t, a, r) {
    var s = this;
    if (void 0 === e) return null;
    var o = new n(e, t, a, r),
        i = t.not || t.disallow;
    return i ? (Array.isArray(i) || (i = [i]), i.forEach(function (n) {
      if (s.testType(e, t, a, r, n)) {
        var i = n && n.id && "<" + n.id + ">" || n;
        o.addError({
          name: "not",
          argument: i,
          message: "is of prohibited type " + i
        });
      }
    }), o) : null;
  }, e.exports = o;
},
/*!*******************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/src/schema_validator.js ***!
  \*******************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = this && this.__values || function (e) {
    var t = "function" == typeof Symbol && e[Symbol.iterator],
        a = 0;
    return t ? t.call(e) : {
      next: function next() {
        return e && a >= e.length && (e = void 0), {
          value: e && e[a++],
          done: !e
        };
      }
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var n = a(
  /*! jsonschema */
  150),
      s = a(
  /*! lodash.values */
  330),
      o = a(
  /*! ./schemas */
  151),
      i = function () {
    function e() {
      var t, a;
      this._validator = new n.Validator();

      try {
        for (var i = r(s(o.schemas)), c = i.next(); !c.done; c = i.next()) {
          var u = c.value;
          e._assertSchemaDefined(u), this._validator.addSchema(u, u.id);
        }
      } catch (e) {
        t = {
          error: e
        };
      } finally {
        try {
          c && !c.done && (a = i.return) && a.call(i);
        } finally {
          if (t) throw t.error;
        }
      }
    }

    return e._assertSchemaDefined = function (e) {
      if (void 0 === e) throw new Error("Cannot add undefined schema");
    }, e.prototype.addSchema = function (t) {
      e._assertSchemaDefined(t), this._validator.addSchema(t, t.id);
    }, e.prototype.validate = function (t, a) {
      e._assertSchemaDefined(a);

      var r = JSON.parse(JSON.stringify(t));
      return this._validator.validate(r, a);
    }, e.prototype.isValid = function (e, t) {
      return 0 === this.validate(e, t).errors.length;
    }, e;
  }();

  t.SchemaValidator = i;
},
/*!*********************************************!*\
  !*** ./node_modules/lodash.values/index.js ***!
  \*********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  var a = 9007199254740991,
      r = "[object Arguments]",
      n = "[object Function]",
      s = "[object GeneratorFunction]",
      o = /^(?:0|[1-9]\d*)$/;

  function i(e, t) {
    return function (e, t) {
      for (var a = -1, r = e ? e.length : 0, n = Array(r); ++a < r;) {
        n[a] = t(e[a], a, e);
      }

      return n;
    }(t, function (t) {
      return e[t];
    });
  }

  var c,
      u,
      d = Object.prototype,
      f = d.hasOwnProperty,
      l = d.toString,
      h = d.propertyIsEnumerable,
      p = (c = Object.keys, u = Object, function (e) {
    return c(u(e));
  });

  function b(e, t) {
    var a = v(e) || function (e) {
      return function (e) {
        return function (e) {
          return !!e && "object" == typeof e;
        }(e) && _(e);
      }(e) && f.call(e, "callee") && (!h.call(e, "callee") || l.call(e) == r);
    }(e) ? function (e, t) {
      for (var a = -1, r = Array(e); ++a < e;) {
        r[a] = t(a);
      }

      return r;
    }(e.length, String) : [],
        n = a.length,
        s = !!n;

    for (var o in e) {
      !t && !f.call(e, o) || s && ("length" == o || y(o, n)) || a.push(o);
    }

    return a;
  }

  function m(e) {
    if (a = (t = e) && t.constructor, r = "function" == typeof a && a.prototype || d, t !== r) return p(e);
    var t,
        a,
        r,
        n = [];

    for (var s in Object(e)) {
      f.call(e, s) && "constructor" != s && n.push(s);
    }

    return n;
  }

  function y(e, t) {
    return !!(t = null == t ? a : t) && ("number" == typeof e || o.test(e)) && e > -1 && e % 1 == 0 && e < t;
  }

  var v = Array.isArray;

  function _(e) {
    return null != e && function (e) {
      return "number" == typeof e && e > -1 && e % 1 == 0 && e <= a;
    }(e.length) && !function (e) {
      var t = function (e) {
        var t = typeof e;
        return !!e && ("object" == t || "function" == t);
      }(e) ? l.call(e) : "";
      return t == n || t == s;
    }(e);
  }

  e.exports = function (e) {
    return e ? i(e, function (e) {
      return _(e) ? b(e) : m(e);
    }(e)) : [];
  };
},
/*!***********************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/address_schema.json ***!
  \***********************************************************************/

/*! exports provided: id, type, pattern, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/addressSchema","type":"string","pattern":"^0x[0-9a-fA-F]{40}$"}');
},
/*!****************************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/asset_pairs_request_opts_schema.json ***!
  \****************************************************************************************/

/*! exports provided: id, type, properties, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/AssetPairsRequestOptsSchema","type":"object","properties":{"assetDataA":{"$ref":"/hexSchema"},"assetDataB":{"$ref":"/hexSchema"}}}');
},
/*!***************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/block_param_schema.json ***!
  \***************************************************************************/

/*! exports provided: id, oneOf, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/blockParamSchema","oneOf":[{"type":"number"},{"enum":["latest","earliest","pending"]}]}');
},
/*!***************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/block_range_schema.json ***!
  \***************************************************************************/

/*! exports provided: id, properties, type, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/blockRangeSchema","properties":{"fromBlock":{"$ref":"/blockParamSchema"},"toBlock":{"$ref":"/blockParamSchema"}},"type":"object"}');
},
/*!*************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/call_data_schema.json ***!
  \*************************************************************************/

/*! exports provided: id, properties, required, type, additionalProperties, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/callDataSchema","properties":{"from":{"$ref":"/addressSchema"},"to":{"$ref":"/addressSchema"},"value":{"oneOf":[{"$ref":"/numberSchema"},{"$ref":"/jsNumberSchema"}]},"gas":{"oneOf":[{"$ref":"/numberSchema"},{"$ref":"/jsNumberSchema"}]},"gasPrice":{"oneOf":[{"$ref":"/numberSchema"},{"$ref":"/jsNumberSchema"}]},"data":{"type":"string","pattern":"^0x[0-9a-f]*$"},"nonce":{"type":"number","minimum":0}},"required":[],"type":"object","additionalProperties":false}');
},
/*!**************************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/ec_signature_parameter_schema.json ***!
  \**************************************************************************************/

/*! exports provided: id, type, pattern, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/ecSignatureParameterSchema","type":"string","pattern":"^0[xX][0-9A-Fa-f]{64}$"}');
},
/*!****************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/ec_signature_schema.json ***!
  \****************************************************************************/

/*! exports provided: id, properties, required, type, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/ecSignatureSchema","properties":{"v":{"type":"number","minimum":27,"maximum":28},"r":{"$ref":"/ecSignatureParameterSchema"},"s":{"$ref":"/ecSignatureParameterSchema"}},"required":["v","r","s"],"type":"object"}');
},
/*!*********************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/eip712_typed_data_schema.json ***!
  \*********************************************************************************/

/*! exports provided: id, type, properties, required, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/eip712TypedDataSchema","type":"object","properties":{"types":{"type":"object","properties":{"EIP712Domain":{"type":"array"}},"additionalProperties":{"type":"array","items":{"type":"object","properties":{"name":{"type":"string"},"type":{"type":"string"}},"required":["name","type"]}},"required":["EIP712Domain"]},"primaryType":{"type":"string"},"domain":{"type":"object"},"message":{"type":"object"}},"required":["types","primaryType","domain","message"]}');
},
/*!*******************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/hex_schema.json ***!
  \*******************************************************************/

/*! exports provided: id, type, pattern, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/hexSchema","type":"string","pattern":"^0x(([0-9a-f][0-9a-f])+)?$"}');
},
/*!***********************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/index_filter_values_schema.json ***!
  \***********************************************************************************/

/*! exports provided: id, additionalProperties, type, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/indexFilterValuesSchema","additionalProperties":{"oneOf":[{"$ref":"/numberSchema"},{"$ref":"/addressSchema"},{"$ref":"/orderHashSchema"}]},"type":"object"}');
},
/*!*************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/js_number_schema.json ***!
  \*************************************************************************/

/*! exports provided: id, type, minimum, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/jsNumberSchema","type":"number","minimum":0}');
},
/*!**********************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/number_schema.json ***!
  \**********************************************************************/

/*! exports provided: id, type, pattern, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/numberSchema","type":"string","pattern":"^\\\\d+(\\\\.\\\\d+)?$"}');
},
/*!****************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/order_cancel_schema.json ***!
  \****************************************************************************/

/*! exports provided: id, type, items, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/orderCancellationRequestsSchema","type":"array","items":{"properties":{"order":{"$ref":"/orderSchema"},"takerTokenCancelAmount":{"$ref":"/wholeNumberSchema"}},"required":["order","takerTokenCancelAmount"],"type":"object"}}');
},
/*!************************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/order_config_request_schema.json ***!
  \************************************************************************************/

/*! exports provided: id, type, properties, required, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/OrderConfigRequestSchema","type":"object","properties":{"makerAddress":{"$ref":"/addressSchema"},"takerAddress":{"$ref":"/addressSchema"},"makerAssetAmount":{"$ref":"/wholeNumberSchema"},"takerAssetAmount":{"$ref":"/wholeNumberSchema"},"makerAssetData":{"$ref":"/hexSchema"},"takerAssetData":{"$ref":"/hexSchema"},"exchangeAddress":{"$ref":"/addressSchema"},"expirationTimeSeconds":{"$ref":"/wholeNumberSchema"}},"required":["makerAddress","takerAddress","makerAssetAmount","takerAssetAmount","makerAssetData","takerAssetData","exchangeAddress","expirationTimeSeconds"]}');
},
/*!*******************************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/order_fill_or_kill_requests_schema.json ***!
  \*******************************************************************************************/

/*! exports provided: id, type, items, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/orderFillOrKillRequestsSchema","type":"array","items":{"properties":{"signedOrder":{"$ref":"/signedOrderSchema"},"fillTakerAmount":{"$ref":"/wholeNumberSchema"}},"required":["signedOrder","fillTakerAmount"],"type":"object"}}');
},
/*!***********************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/order_fill_requests_schema.json ***!
  \***********************************************************************************/

/*! exports provided: id, type, items, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/orderFillRequestsSchema","type":"array","items":{"properties":{"signedOrder":{"$ref":"/signedOrderSchema"},"takerTokenFillAmount":{"$ref":"/wholeNumberSchema"}},"required":["signedOrder","takerTokenFillAmount"],"type":"object"}}');
},
/*!**************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/order_hash_schema.json ***!
  \**************************************************************************/

/*! exports provided: id, type, pattern, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/orderHashSchema","type":"string","pattern":"^0x[0-9a-fA-F]{64}$"}');
},
/*!*********************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/order_schema.json ***!
  \*********************************************************************/

/*! exports provided: id, properties, required, type, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/orderSchema","properties":{"makerAddress":{"$ref":"/addressSchema"},"takerAddress":{"$ref":"/addressSchema"},"makerFee":{"$ref":"/wholeNumberSchema"},"takerFee":{"$ref":"/wholeNumberSchema"},"senderAddress":{"$ref":"/addressSchema"},"makerAssetAmount":{"$ref":"/wholeNumberSchema"},"takerAssetAmount":{"$ref":"/wholeNumberSchema"},"makerAssetData":{"$ref":"/hexSchema"},"takerAssetData":{"$ref":"/hexSchema"},"salt":{"$ref":"/wholeNumberSchema"},"exchangeAddress":{"$ref":"/addressSchema"},"feeRecipientAddress":{"$ref":"/addressSchema"},"expirationTimeSeconds":{"$ref":"/wholeNumberSchema"}},"required":["makerAddress","takerAddress","makerFee","takerFee","senderAddress","makerAssetAmount","takerAssetAmount","makerAssetData","takerAssetData","salt","exchangeAddress","feeRecipientAddress","expirationTimeSeconds"],"type":"object"}');
},
/*!*********************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/orderbook_request_schema.json ***!
  \*********************************************************************************/

/*! exports provided: id, type, properties, required, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/OrderbookRequestSchema","type":"object","properties":{"baseAssetData":{"$ref":"/hexSchema"},"quoteAssetData":{"$ref":"/hexSchema"}},"required":["baseAssetData","quoteAssetData"]}');
},
/*!***********************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/orders_request_opts_schema.json ***!
  \***********************************************************************************/

/*! exports provided: id, type, properties, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/OrdersRequestOptsSchema","type":"object","properties":{"makerAssetProxyId":{"$ref":"/hexSchema"},"takerAssetProxyId":{"$ref":"/hexSchema"},"makerAssetAddress":{"$ref":"/addressSchema"},"takerAssetAddress":{"$ref":"/addressSchema"},"exchangeAddress":{"$ref":"/addressSchema"},"senderAddress":{"$ref":"/addressSchema"},"makerAssetData":{"$ref":"/hexSchema"},"takerAssetData":{"$ref":"/hexSchema"},"traderAssetData":{"$ref":"/hexSchema"},"makerAddress":{"$ref":"/addressSchema"},"takerAddress":{"$ref":"/addressSchema"},"traderAddress":{"$ref":"/addressSchema"},"feeRecipientAddress":{"$ref":"/addressSchema"}}}');
},
/*!**********************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/orders_schema.json ***!
  \**********************************************************************/

/*! exports provided: id, type, items, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/ordersSchema","type":"array","items":{"$ref":"/orderSchema"}}');
},
/*!**********************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/paged_request_opts_schema.json ***!
  \**********************************************************************************/

/*! exports provided: id, type, properties, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/PagedRequestOptsSchema","type":"object","properties":{"page":{"type":"number"},"perPage":{"type":"number"}}}');
},
/*!************************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/paginated_collection_schema.json ***!
  \************************************************************************************/

/*! exports provided: id, type, properties, required, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/paginatedCollectionSchema","type":"object","properties":{"total":{"type":"number"},"perPage":{"type":"number"},"page":{"type":"number"}},"required":["total","perPage","page"]}');
},
/*!*****************************************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/relayer_api_asset_data_pairs_response_schema.json ***!
  \*****************************************************************************************************/

/*! exports provided: id, type, allOf, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/relayerApiAssetDataPairsResponseSchema","type":"object","allOf":[{"$ref":"/paginatedCollectionSchema"},{"properties":{"records":{"$ref":"/relayerApiAssetDataPairsSchema"}},"required":["records"]}]}');
},
/*!********************************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/relayer_api_asset_data_pairs_schema.json ***!
  \********************************************************************************************/

/*! exports provided: id, type, items, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/relayerApiAssetDataPairsSchema","type":"array","items":{"properties":{"assetDataA":{"$ref":"/relayerApiAssetDataTradeInfoSchema"},"assetDataB":{"$ref":"/relayerApiAssetDataTradeInfoSchema"}},"required":["assetDataA","assetDataB"],"type":"object"}}');
},
/*!*************************************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/relayer_api_asset_data_trade_info_schema.json ***!
  \*************************************************************************************************/

/*! exports provided: id, type, properties, required, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/relayerApiAssetDataTradeInfoSchema","type":"object","properties":{"assetData":{"$ref":"/hexSchema"},"minAmount":{"$ref":"/wholeNumberSchema"},"maxAmount":{"$ref":"/wholeNumberSchema"},"precision":{"type":"number"}},"required":["assetData"]}');
},
/*!******************************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/relayer_api_error_response_schema.json ***!
  \******************************************************************************************/

/*! exports provided: id, type, properties, required, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/relayerApiErrorResponseSchema","type":"object","properties":{"code":{"type":"integer","minimum":100,"maximum":103},"reason":{"type":"string"},"validationErrors":{"type":"array","items":{"type":"object","properties":{"field":{"type":"string"},"code":{"type":"integer","minimum":1000,"maximum":1006},"reason":{"type":"string"}},"required":["field","code","reason"]}}},"required":["code","reason"]}');
},
/*!***************************************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/relayer_api_fee_recipients_response_schema.json ***!
  \***************************************************************************************************/

/*! exports provided: id, type, allOf, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/relayerApiFeeRecipientsResponseSchema","type":"object","allOf":[{"$ref":"/paginatedCollectionSchema"},{"properties":{"records":{"type":"array","items":{"$ref":"/addressSchema"}}},"required":["records"]}]}');
},
/*!************************************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/relayer_api_order_config_payload_schema.json ***!
  \************************************************************************************************/

/*! exports provided: id, type, properties, required, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/relayerApiOrderConfigPayloadSchema","type":"object","properties":{"makerAddress":{"$ref":"/addressSchema"},"takerAddress":{"$ref":"/addressSchema"},"makerAssetAmount":{"$ref":"/wholeNumberSchema"},"takerAssetAmount":{"$ref":"/wholeNumberSchema"},"makerAssetData":{"$ref":"/hexSchema"},"takerAssetData":{"$ref":"/hexSchema"},"exchangeAddress":{"$ref":"/addressSchema"},"expirationTimeSeconds":{"$ref":"/wholeNumberSchema"}},"required":["makerAddress","takerAddress","makerAssetAmount","takerAssetAmount","makerAssetData","takerAssetData","exchangeAddress","expirationTimeSeconds"]}');
},
/*!*************************************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/relayer_api_order_config_response_schema.json ***!
  \*************************************************************************************************/

/*! exports provided: id, type, properties, required, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/relayerApiOrderConfigResponseSchema","type":"object","properties":{"makerFee":{"$ref":"/wholeNumberSchema"},"takerFee":{"$ref":"/wholeNumberSchema"},"feeRecipientAddress":{"$ref":"/addressSchema"},"senderAddress":{"$ref":"/addressSchema"}},"required":["makerFee","takerFee","feeRecipientAddress","senderAddress"]}');
},
/*!*********************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/relayer_api_order_schema.json ***!
  \*********************************************************************************/

/*! exports provided: id, type, properties, required, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/relayerApiOrderSchema","type":"object","properties":{"order":{"$ref":"/orderSchema"},"metaData":{"type":"object"}},"required":["order","metaData"]}');
},
/*!**********************************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/relayer_api_orderbook_response_schema.json ***!
  \**********************************************************************************************/

/*! exports provided: id, type, properties, required, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/relayerApiOrderbookResponseSchema","type":"object","properties":{"bids":{"$ref":"/relayerApiOrdersResponseSchema"},"asks":{"$ref":"/relayerApiOrdersResponseSchema"}},"required":["bids","asks"]}');
},
/*!************************************************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/relayer_api_orders_channel_subscribe_payload_schema.json ***!
  \************************************************************************************************************/

/*! exports provided: id, type, properties, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/relayerApiOrdersChannelSubscribePayloadSchema","type":"object","properties":{"makerAssetProxyId":{"$ref":"/hexSchema"},"takerAssetProxyId":{"$ref":"/hexSchema"},"networkId":{"type":"number"},"makerAssetAddress":{"$ref":"/addressSchema"},"takerAssetAddress":{"$ref":"/addressSchema"},"makerAssetData":{"$ref":"/hexSchema"},"takerAssetData":{"$ref":"/hexSchema"},"traderAssetData":{"$ref":"/hexSchema"}}}');
},
/*!****************************************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/relayer_api_orders_channel_subscribe_schema.json ***!
  \****************************************************************************************************/

/*! exports provided: id, type, properties, required, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/relayerApiOrdersChannelSubscribeSchema","type":"object","properties":{"type":{"enum":["subscribe"]},"channel":{"enum":["orders"]},"requestId":{"type":"string"},"payload":{"$ref":"/relayerApiOrdersChannelSubscribePayloadSchema"}},"required":["type","channel","requestId"]}');
},
/*!**********************************************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/relayer_api_orders_channel_update_response_schema.json ***!
  \**********************************************************************************************************/

/*! exports provided: id, type, properties, required, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/relayerApiOrdersChannelUpdateSchema","type":"object","properties":{"type":{"enum":["update"]},"channel":{"enum":["orders"]},"requestId":{"type":"string"},"payload":{"$ref":"/relayerApiOrdersSchema"}},"required":["type","channel","requestId"]}');
},
/*!*******************************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/relayer_api_orders_response_schema.json ***!
  \*******************************************************************************************/

/*! exports provided: id, type, allOf, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/relayerApiOrdersResponseSchema","type":"object","allOf":[{"$ref":"/paginatedCollectionSchema"},{"properties":{"records":{"$ref":"/relayerApiOrdersSchema"}},"required":["records"]}]}');
},
/*!**********************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/relayer_api_orders_schema.json ***!
  \**********************************************************************************/

/*! exports provided: id, type, items, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/relayerApiOrdersSchema","type":"array","items":{"$ref":"/relayerApiOrderSchema"}}');
},
/*!****************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/request_opts_schema.json ***!
  \****************************************************************************/

/*! exports provided: id, type, properties, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/RequestOptsSchema","type":"object","properties":{"networkId":{"type":"number"}}}');
},
/*!****************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/signed_order_schema.json ***!
  \****************************************************************************/

/*! exports provided: id, allOf, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/signedOrderSchema","allOf":[{"$ref":"/orderSchema"},{"properties":{"signature":{"$ref":"/hexSchema"}},"required":["signature"]}]}');
},
/*!*****************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/signed_orders_schema.json ***!
  \*****************************************************************************/

/*! exports provided: id, type, items, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/signedOrdersSchema","type":"array","items":{"$ref":"/signedOrderSchema"}}');
},
/*!*********************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/token_schema.json ***!
  \*********************************************************************/

/*! exports provided: id, properties, required, type, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/tokenSchema","properties":{"name":{"type":"string"},"symbol":{"type":"string"},"decimals":{"type":"number"},"address":{"$ref":"/addressSchema"}},"required":["name","symbol","decimals","address"],"type":"object"}');
},
/*!***********************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/tx_data_schema.json ***!
  \***********************************************************************/

/*! exports provided: id, properties, required, type, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/txDataSchema","properties":{"from":{"$ref":"/addressSchema"},"to":{"$ref":"/addressSchema"},"value":{"oneOf":[{"$ref":"/numberSchema"},{"$ref":"/jsNumberSchema"}]},"gas":{"oneOf":[{"$ref":"/numberSchema"},{"$ref":"/jsNumberSchema"}]},"gasPrice":{"oneOf":[{"$ref":"/numberSchema"},{"$ref":"/jsNumberSchema"}]},"data":{"type":"string","pattern":"^0x[0-9a-f]*$"},"nonce":{"type":"number","minimum":0}},"required":["from"],"type":"object"}');
},
/*!****************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/whole_number_schema.json ***!
  \****************************************************************************/

/*! exports provided: id, anyOf, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/wholeNumberSchema","anyOf":[{"type":"string","pattern":"^\\\\d+$"},{"type":"integer"}]}');
},
/*!***********************************************************************************!*\
  !*** ./node_modules/@0x/json-schemas/lib/schemas/zero_ex_transaction_schema.json ***!
  \***********************************************************************************/

/*! exports provided: id, properties, required, type, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"id":"/zeroExTransactionSchema","properties":{"verifyingContractAddress":{"$ref":"/addressSchema"},"data":{"$ref":"/hexSchema"},"signerAddress":{"$ref":"/addressSchema"},"salt":{"$ref":"/wholeNumberSchema"}},"required":["verifyingContractAddress","data","salt","signerAddress"],"type":"object"}');
},
/*!*****************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/promisify.js ***!
  \*****************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      n = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      s = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || t-- > 0) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  },
      o = this && this.__spread || function () {
    for (var e = [], t = 0; t < arguments.length; t++) {
      e = e.concat(s(arguments[t]));
    }

    return e;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.promisify = function (e, t) {
    var a = this;
    return function () {
      for (var s = [], i = 0; i < arguments.length; i++) {
        s[i] = arguments[i];
      }

      return r(a, void 0, void 0, function () {
        return n(this, function (a) {
          return [2, new Promise(function (a, r) {
            e.apply(t, o(s, [function (e, t) {
              null == e ? a(t) : r(e);
            }]));
          })];
        });
      });
    };
  };
},
/*!**********************************************!*\
  !*** ./node_modules/keccak/lib/api/index.js ***!
  \**********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ./keccak */
  377),
      n = a(
  /*! ./shake */
  388);

  e.exports = function (e) {
    var t = r(e),
        a = n(e);
    return function (e, r) {
      switch ("string" == typeof e ? e.toLowerCase() : e) {
        case "keccak224":
          return new t(1152, 448, null, 224, r);

        case "keccak256":
          return new t(1088, 512, null, 256, r);

        case "keccak384":
          return new t(832, 768, null, 384, r);

        case "keccak512":
          return new t(576, 1024, null, 512, r);

        case "sha3-224":
          return new t(1152, 448, 6, 224, r);

        case "sha3-256":
          return new t(1088, 512, 6, 256, r);

        case "sha3-384":
          return new t(832, 768, 6, 384, r);

        case "sha3-512":
          return new t(576, 1024, 6, 512, r);

        case "shake128":
          return new a(1344, 256, 31, r);

        case "shake256":
          return new a(1088, 512, 31, r);

        default:
          throw new Error("Invald algorithm: " + e);
      }
    };
  };
},
/*!***********************************************!*\
  !*** ./node_modules/keccak/lib/api/keccak.js ***!
  \***********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! safe-buffer */
  7).Buffer,
      n = a(
  /*! stream */
  28).Transform,
      s = a(
  /*! inherits */
  3);

  e.exports = function (e) {
    function t(t, a, r, s, o) {
      n.call(this, o), this._rate = t, this._capacity = a, this._delimitedSuffix = r, this._hashBitLength = s, this._options = o, this._state = new e(), this._state.initialize(t, a), this._finalized = !1;
    }

    return s(t, n), t.prototype._transform = function (e, t, a) {
      var r = null;

      try {
        this.update(e, t);
      } catch (e) {
        r = e;
      }

      a(r);
    }, t.prototype._flush = function (e) {
      var t = null;

      try {
        this.push(this.digest());
      } catch (e) {
        t = e;
      }

      e(t);
    }, t.prototype.update = function (e, t) {
      if (!r.isBuffer(e) && "string" != typeof e) throw new TypeError("Data must be a string or a buffer");
      if (this._finalized) throw new Error("Digest already called");
      return r.isBuffer(e) || (e = r.from(e, t)), this._state.absorb(e), this;
    }, t.prototype.digest = function (e) {
      if (this._finalized) throw new Error("Digest already called");
      this._finalized = !0, this._delimitedSuffix && this._state.absorbLastFewBits(this._delimitedSuffix);

      var t = this._state.squeeze(this._hashBitLength / 8);

      return void 0 !== e && (t = t.toString(e)), this._resetState(), t;
    }, t.prototype._resetState = function () {
      return this._state.initialize(this._rate, this._capacity), this;
    }, t.prototype._clone = function () {
      var e = new t(this._rate, this._capacity, this._delimitedSuffix, this._hashBitLength, this._options);
      return this._state.copy(e._state), e._finalized = this._finalized, e;
    }, t;
  };
},
/*!**********************!*\
  !*** util (ignored) ***!
  \**********************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {},
/*!*************************************************************************!*\
  !*** ./node_modules/readable-stream/lib/internal/streams/BufferList.js ***!
  \*************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! safe-buffer */
  96).Buffer,
      n = a(
  /*! util */
  380);
  e.exports = function () {
    function e() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.head = null, this.tail = null, this.length = 0;
    }

    return e.prototype.push = function (e) {
      var t = {
        data: e,
        next: null
      };
      this.length > 0 ? this.tail.next = t : this.head = t, this.tail = t, ++this.length;
    }, e.prototype.unshift = function (e) {
      var t = {
        data: e,
        next: this.head
      };
      0 === this.length && (this.tail = t), this.head = t, ++this.length;
    }, e.prototype.shift = function () {
      if (0 !== this.length) {
        var e = this.head.data;
        return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, e;
      }
    }, e.prototype.clear = function () {
      this.head = this.tail = null, this.length = 0;
    }, e.prototype.join = function (e) {
      if (0 === this.length) return "";

      for (var t = this.head, a = "" + t.data; t = t.next;) {
        a += e + t.data;
      }

      return a;
    }, e.prototype.concat = function (e) {
      if (0 === this.length) return r.alloc(0);
      if (1 === this.length) return this.head.data;

      for (var t, a, n, s = r.allocUnsafe(e >>> 0), o = this.head, i = 0; o;) {
        t = o.data, a = s, n = i, t.copy(a, n), i += o.data.length, o = o.next;
      }

      return s;
    }, e;
  }(), n && n.inspect && n.inspect.custom && (e.exports.prototype[n.inspect.custom] = function () {
    var e = n.inspect({
      length: this.length
    });
    return this.constructor.name + " " + e;
  });
},
/*!**********************!*\
  !*** util (ignored) ***!
  \**********************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {},
/*!**********************************************************************************!*\
  !*** ./node_modules/timers-browserify/node_modules/setimmediate/setImmediate.js ***!
  \**********************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (e, t) {
    !function (e, a) {
      "use strict";

      if (!e.setImmediate) {
        var r,
            n,
            s,
            o,
            i,
            c = 1,
            u = {},
            d = !1,
            f = e.document,
            l = Object.getPrototypeOf && Object.getPrototypeOf(e);
        l = l && l.setTimeout ? l : e, "[object process]" === {}.toString.call(e.process) ? r = function r(e) {
          t.nextTick(function () {
            p(e);
          });
        } : !function () {
          if (e.postMessage && !e.importScripts) {
            var t = !0,
                a = e.onmessage;
            return e.onmessage = function () {
              t = !1;
            }, e.postMessage("", "*"), e.onmessage = a, t;
          }
        }() ? e.MessageChannel ? ((s = new MessageChannel()).port1.onmessage = function (e) {
          p(e.data);
        }, r = function r(e) {
          s.port2.postMessage(e);
        }) : f && "onreadystatechange" in f.createElement("script") ? (n = f.documentElement, r = function r(e) {
          var t = f.createElement("script");
          t.onreadystatechange = function () {
            p(e), t.onreadystatechange = null, n.removeChild(t), t = null;
          }, n.appendChild(t);
        }) : r = function r(e) {
          setTimeout(p, 0, e);
        } : (o = "setImmediate$" + Math.random() + "$", i = function i(t) {
          t.source === e && "string" == typeof t.data && 0 === t.data.indexOf(o) && p(+t.data.slice(o.length));
        }, e.addEventListener ? e.addEventListener("message", i, !1) : e.attachEvent("onmessage", i), r = function r(t) {
          e.postMessage(o + t, "*");
        }), l.setImmediate = function (e) {
          "function" != typeof e && (e = new Function("" + e));

          for (var t = new Array(arguments.length - 1), a = 0; a < t.length; a++) {
            t[a] = arguments[a + 1];
          }

          var n = {
            callback: e,
            args: t
          };
          return u[c] = n, r(c), c++;
        }, l.clearImmediate = h;
      }

      function h(e) {
        delete u[e];
      }

      function p(e) {
        if (d) setTimeout(p, 0, e);else {
          var t = u[e];

          if (t) {
            d = !0;

            try {
              !function (e) {
                var t = e.callback,
                    r = e.args;

                switch (r.length) {
                  case 0:
                    t();
                    break;

                  case 1:
                    t(r[0]);
                    break;

                  case 2:
                    t(r[0], r[1]);
                    break;

                  case 3:
                    t(r[0], r[1], r[2]);
                    break;

                  default:
                    t.apply(a, r);
                }
              }(t);
            } finally {
              h(e), d = !1;
            }
          }
        }
      }
    }("undefined" == typeof self ? void 0 === e ? this : e : self);
  }).call(this, a(
  /*! ./../../../webpack/buildin/global.js */
  18), a(
  /*! ./../../../process/browser.js */
  9));
},
/*!************************************************!*\
  !*** ./node_modules/util-deprecate/browser.js ***!
  \************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    function a(e) {
      try {
        if (!t.localStorage) return !1;
      } catch (e) {
        return !1;
      }

      var a = t.localStorage[e];
      return null != a && "true" === String(a).toLowerCase();
    }

    e.exports = function (e, t) {
      if (a("noDeprecation")) return e;
      var r = !1;
      return function () {
        if (!r) {
          if (a("throwDeprecation")) throw new Error(t);
          a("traceDeprecation") ? console.trace(t) : console.warn(t), r = !0;
        }

        return e.apply(this, arguments);
      };
    };
  }).call(this, a(
  /*! ./../webpack/buildin/global.js */
  18));
},
/*!*****************************************************************!*\
  !*** ./node_modules/readable-stream/lib/_stream_passthrough.js ***!
  \*****************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  e.exports = s;
  var r = a(
  /*! ./_stream_transform */
  156),
      n = a(
  /*! core-util-is */
  27);

  function s(e) {
    if (!(this instanceof s)) return new s(e);
    r.call(this, e);
  }

  n.inherits = a(
  /*! inherits */
  3), n.inherits(s, r), s.prototype._transform = function (e, t, a) {
    a(null, e);
  };
},
/*!**********************************************************!*\
  !*** ./node_modules/readable-stream/writable-browser.js ***!
  \**********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  e.exports = a(
  /*! ./lib/_stream_writable.js */
  97);
},
/*!********************************************************!*\
  !*** ./node_modules/readable-stream/duplex-browser.js ***!
  \********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  e.exports = a(
  /*! ./lib/_stream_duplex.js */
  52);
},
/*!***************************************************!*\
  !*** ./node_modules/readable-stream/transform.js ***!
  \***************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  e.exports = a(
  /*! ./readable */
  58).Transform;
},
/*!*****************************************************!*\
  !*** ./node_modules/readable-stream/passthrough.js ***!
  \*****************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  e.exports = a(
  /*! ./readable */
  58).PassThrough;
},
/*!**********************************************!*\
  !*** ./node_modules/keccak/lib/api/shake.js ***!
  \**********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! safe-buffer */
  7).Buffer,
      n = a(
  /*! stream */
  28).Transform,
      s = a(
  /*! inherits */
  3);

  e.exports = function (e) {
    function t(t, a, r, s) {
      n.call(this, s), this._rate = t, this._capacity = a, this._delimitedSuffix = r, this._options = s, this._state = new e(), this._state.initialize(t, a), this._finalized = !1;
    }

    return s(t, n), t.prototype._transform = function (e, t, a) {
      var r = null;

      try {
        this.update(e, t);
      } catch (e) {
        r = e;
      }

      a(r);
    }, t.prototype._flush = function () {}, t.prototype._read = function (e) {
      this.push(this.squeeze(e));
    }, t.prototype.update = function (e, t) {
      if (!r.isBuffer(e) && "string" != typeof e) throw new TypeError("Data must be a string or a buffer");
      if (this._finalized) throw new Error("Squeeze already called");
      return r.isBuffer(e) || (e = r.from(e, t)), this._state.absorb(e), this;
    }, t.prototype.squeeze = function (e, t) {
      this._finalized || (this._finalized = !0, this._state.absorbLastFewBits(this._delimitedSuffix));

      var a = this._state.squeeze(e);

      return void 0 !== t && (a = a.toString(t)), a;
    }, t.prototype._resetState = function () {
      return this._state.initialize(this._rate, this._capacity), this;
    }, t.prototype._clone = function () {
      var e = new t(this._rate, this._capacity, this._delimitedSuffix, this._options);
      return this._state.copy(e._state), e._finalized = this._finalized, e;
    }, t;
  };
},
/*!*******************************************!*\
  !*** ./node_modules/keccak/lib/keccak.js ***!
  \*******************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! safe-buffer */
  7).Buffer,
      n = a(
  /*! ./keccak-state-unroll */
  390);

  function s() {
    this.state = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], this.blockSize = null, this.count = 0, this.squeezing = !1;
  }

  s.prototype.initialize = function (e, t) {
    for (var a = 0; a < 50; ++a) {
      this.state[a] = 0;
    }

    this.blockSize = e / 8, this.count = 0, this.squeezing = !1;
  }, s.prototype.absorb = function (e) {
    for (var t = 0; t < e.length; ++t) {
      this.state[~~(this.count / 4)] ^= e[t] << this.count % 4 * 8, this.count += 1, this.count === this.blockSize && (n.p1600(this.state), this.count = 0);
    }
  }, s.prototype.absorbLastFewBits = function (e) {
    this.state[~~(this.count / 4)] ^= e << this.count % 4 * 8, 0 != (128 & e) && this.count === this.blockSize - 1 && n.p1600(this.state), this.state[~~((this.blockSize - 1) / 4)] ^= 128 << (this.blockSize - 1) % 4 * 8, n.p1600(this.state), this.count = 0, this.squeezing = !0;
  }, s.prototype.squeeze = function (e) {
    this.squeezing || this.absorbLastFewBits(1);

    for (var t = r.alloc(e), a = 0; a < e; ++a) {
      t[a] = this.state[~~(this.count / 4)] >>> this.count % 4 * 8 & 255, this.count += 1, this.count === this.blockSize && (n.p1600(this.state), this.count = 0);
    }

    return t;
  }, s.prototype.copy = function (e) {
    for (var t = 0; t < 50; ++t) {
      e.state[t] = this.state[t];
    }

    e.blockSize = this.blockSize, e.count = this.count, e.squeezing = this.squeezing;
  }, e.exports = s;
},
/*!********************************************************!*\
  !*** ./node_modules/keccak/lib/keccak-state-unroll.js ***!
  \********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649, 0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0, 2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771, 2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648, 2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648];

  t.p1600 = function (e) {
    for (var t = 0; t < 24; ++t) {
      var a = e[0] ^ e[10] ^ e[20] ^ e[30] ^ e[40],
          n = e[1] ^ e[11] ^ e[21] ^ e[31] ^ e[41],
          s = e[2] ^ e[12] ^ e[22] ^ e[32] ^ e[42],
          o = e[3] ^ e[13] ^ e[23] ^ e[33] ^ e[43],
          i = e[4] ^ e[14] ^ e[24] ^ e[34] ^ e[44],
          c = e[5] ^ e[15] ^ e[25] ^ e[35] ^ e[45],
          u = e[6] ^ e[16] ^ e[26] ^ e[36] ^ e[46],
          d = e[7] ^ e[17] ^ e[27] ^ e[37] ^ e[47],
          f = e[8] ^ e[18] ^ e[28] ^ e[38] ^ e[48],
          l = e[9] ^ e[19] ^ e[29] ^ e[39] ^ e[49],
          h = f ^ (s << 1 | o >>> 31),
          p = l ^ (o << 1 | s >>> 31),
          b = e[0] ^ h,
          m = e[1] ^ p,
          y = e[10] ^ h,
          v = e[11] ^ p,
          _ = e[20] ^ h,
          g = e[21] ^ p,
          A = e[30] ^ h,
          w = e[31] ^ p,
          T = e[40] ^ h,
          x = e[41] ^ p;

      h = a ^ (i << 1 | c >>> 31), p = n ^ (c << 1 | i >>> 31);
      var D = e[2] ^ h,
          C = e[3] ^ p,
          S = e[12] ^ h,
          E = e[13] ^ p,
          B = e[22] ^ h,
          k = e[23] ^ p,
          R = e[32] ^ h,
          W = e[33] ^ p,
          I = e[42] ^ h,
          N = e[43] ^ p;
      h = s ^ (u << 1 | d >>> 31), p = o ^ (d << 1 | u >>> 31);
      var M = e[4] ^ h,
          P = e[5] ^ p,
          L = e[14] ^ h,
          O = e[15] ^ p,
          F = e[24] ^ h,
          j = e[25] ^ p,
          G = e[34] ^ h,
          V = e[35] ^ p,
          U = e[44] ^ h,
          H = e[45] ^ p;
      h = i ^ (f << 1 | l >>> 31), p = c ^ (l << 1 | f >>> 31);
      var z = e[6] ^ h,
          K = e[7] ^ p,
          q = e[16] ^ h,
          Y = e[17] ^ p,
          Z = e[26] ^ h,
          J = e[27] ^ p,
          X = e[36] ^ h,
          $ = e[37] ^ p,
          Q = e[46] ^ h,
          ee = e[47] ^ p;
      h = u ^ (a << 1 | n >>> 31), p = d ^ (n << 1 | a >>> 31);

      var te = e[8] ^ h,
          ae = e[9] ^ p,
          re = e[18] ^ h,
          ne = e[19] ^ p,
          se = e[28] ^ h,
          oe = e[29] ^ p,
          ie = e[38] ^ h,
          ce = e[39] ^ p,
          ue = e[48] ^ h,
          de = e[49] ^ p,
          fe = b,
          le = m,
          he = v << 4 | y >>> 28,
          pe = y << 4 | v >>> 28,
          be = _ << 3 | g >>> 29,
          me = g << 3 | _ >>> 29,
          ye = w << 9 | A >>> 23,
          ve = A << 9 | w >>> 23,
          _e = T << 18 | x >>> 14,
          ge = x << 18 | T >>> 14,
          Ae = D << 1 | C >>> 31,
          we = C << 1 | D >>> 31,
          Te = E << 12 | S >>> 20,
          xe = S << 12 | E >>> 20,
          De = B << 10 | k >>> 22,
          Ce = k << 10 | B >>> 22,
          Se = W << 13 | R >>> 19,
          Ee = R << 13 | W >>> 19,
          Be = I << 2 | N >>> 30,
          ke = N << 2 | I >>> 30,
          Re = P << 30 | M >>> 2,
          We = M << 30 | P >>> 2,
          Ie = L << 6 | O >>> 26,
          Ne = O << 6 | L >>> 26,
          Me = j << 11 | F >>> 21,
          Pe = F << 11 | j >>> 21,
          Le = G << 15 | V >>> 17,
          Oe = V << 15 | G >>> 17,
          Fe = H << 29 | U >>> 3,
          je = U << 29 | H >>> 3,
          Ge = z << 28 | K >>> 4,
          Ve = K << 28 | z >>> 4,
          Ue = Y << 23 | q >>> 9,
          He = q << 23 | Y >>> 9,
          ze = Z << 25 | J >>> 7,
          Ke = J << 25 | Z >>> 7,
          qe = X << 21 | $ >>> 11,
          Ye = $ << 21 | X >>> 11,
          Ze = ee << 24 | Q >>> 8,
          Je = Q << 24 | ee >>> 8,
          Xe = te << 27 | ae >>> 5,
          $e = ae << 27 | te >>> 5,
          Qe = re << 20 | ne >>> 12,
          et = ne << 20 | re >>> 12,
          tt = oe << 7 | se >>> 25,
          at = se << 7 | oe >>> 25,
          rt = ie << 8 | ce >>> 24,
          nt = ce << 8 | ie >>> 24,
          st = ue << 14 | de >>> 18,
          ot = de << 14 | ue >>> 18;

      e[0] = fe ^ ~Te & Me, e[1] = le ^ ~xe & Pe, e[10] = Ge ^ ~Qe & be, e[11] = Ve ^ ~et & me, e[20] = Ae ^ ~Ie & ze, e[21] = we ^ ~Ne & Ke, e[30] = Xe ^ ~he & De, e[31] = $e ^ ~pe & Ce, e[40] = Re ^ ~Ue & tt, e[41] = We ^ ~He & at, e[2] = Te ^ ~Me & qe, e[3] = xe ^ ~Pe & Ye, e[12] = Qe ^ ~be & Se, e[13] = et ^ ~me & Ee, e[22] = Ie ^ ~ze & rt, e[23] = Ne ^ ~Ke & nt, e[32] = he ^ ~De & Le, e[33] = pe ^ ~Ce & Oe, e[42] = Ue ^ ~tt & ye, e[43] = He ^ ~at & ve, e[4] = Me ^ ~qe & st, e[5] = Pe ^ ~Ye & ot, e[14] = be ^ ~Se & Fe, e[15] = me ^ ~Ee & je, e[24] = ze ^ ~rt & _e, e[25] = Ke ^ ~nt & ge, e[34] = De ^ ~Le & Ze, e[35] = Ce ^ ~Oe & Je, e[44] = tt ^ ~ye & Be, e[45] = at ^ ~ve & ke, e[6] = qe ^ ~st & fe, e[7] = Ye ^ ~ot & le, e[16] = Se ^ ~Fe & Ge, e[17] = Ee ^ ~je & Ve, e[26] = rt ^ ~_e & Ae, e[27] = nt ^ ~ge & we, e[36] = Le ^ ~Ze & Xe, e[37] = Oe ^ ~Je & $e, e[46] = ye ^ ~Be & Re, e[47] = ve ^ ~ke & We, e[8] = st ^ ~fe & Te, e[9] = ot ^ ~le & xe, e[18] = Fe ^ ~Ge & Qe, e[19] = je ^ ~Ve & et, e[28] = _e ^ ~Ae & Ie, e[29] = ge ^ ~we & Ne, e[38] = Ze ^ ~Xe & he, e[39] = Je ^ ~$e & pe, e[48] = Be ^ ~Re & Ue, e[49] = ke ^ ~We & He, e[0] ^= r[2 * t], e[1] ^= r[2 * t + 1];
    }
  };
},
/*!*********************************************!*\
  !*** ./node_modules/secp256k1/lib/index.js ***!
  \*********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ./assert */
  392),
      n = a(
  /*! ./der */
  393),
      s = a(
  /*! ./messages.json */
  157);

  function o(e, t) {
    return void 0 === e ? t : (r.isBoolean(e, s.COMPRESSED_TYPE_INVALID), e);
  }

  e.exports = function (e) {
    return {
      privateKeyVerify: function privateKeyVerify(t) {
        return r.isBuffer(t, s.EC_PRIVATE_KEY_TYPE_INVALID), 32 === t.length && e.privateKeyVerify(t);
      },
      privateKeyExport: function privateKeyExport(t, a) {
        r.isBuffer(t, s.EC_PRIVATE_KEY_TYPE_INVALID), r.isBufferLength(t, 32, s.EC_PRIVATE_KEY_LENGTH_INVALID), a = o(a, !0);
        var i = e.privateKeyExport(t, a);
        return n.privateKeyExport(t, i, a);
      },
      privateKeyImport: function privateKeyImport(t) {
        if (r.isBuffer(t, s.EC_PRIVATE_KEY_TYPE_INVALID), (t = n.privateKeyImport(t)) && 32 === t.length && e.privateKeyVerify(t)) return t;
        throw new Error(s.EC_PRIVATE_KEY_IMPORT_DER_FAIL);
      },
      privateKeyNegate: function privateKeyNegate(t) {
        return r.isBuffer(t, s.EC_PRIVATE_KEY_TYPE_INVALID), r.isBufferLength(t, 32, s.EC_PRIVATE_KEY_LENGTH_INVALID), e.privateKeyNegate(t);
      },
      privateKeyModInverse: function privateKeyModInverse(t) {
        return r.isBuffer(t, s.EC_PRIVATE_KEY_TYPE_INVALID), r.isBufferLength(t, 32, s.EC_PRIVATE_KEY_LENGTH_INVALID), e.privateKeyModInverse(t);
      },
      privateKeyTweakAdd: function privateKeyTweakAdd(t, a) {
        return r.isBuffer(t, s.EC_PRIVATE_KEY_TYPE_INVALID), r.isBufferLength(t, 32, s.EC_PRIVATE_KEY_LENGTH_INVALID), r.isBuffer(a, s.TWEAK_TYPE_INVALID), r.isBufferLength(a, 32, s.TWEAK_LENGTH_INVALID), e.privateKeyTweakAdd(t, a);
      },
      privateKeyTweakMul: function privateKeyTweakMul(t, a) {
        return r.isBuffer(t, s.EC_PRIVATE_KEY_TYPE_INVALID), r.isBufferLength(t, 32, s.EC_PRIVATE_KEY_LENGTH_INVALID), r.isBuffer(a, s.TWEAK_TYPE_INVALID), r.isBufferLength(a, 32, s.TWEAK_LENGTH_INVALID), e.privateKeyTweakMul(t, a);
      },
      publicKeyCreate: function publicKeyCreate(t, a) {
        return r.isBuffer(t, s.EC_PRIVATE_KEY_TYPE_INVALID), r.isBufferLength(t, 32, s.EC_PRIVATE_KEY_LENGTH_INVALID), a = o(a, !0), e.publicKeyCreate(t, a);
      },
      publicKeyConvert: function publicKeyConvert(t, a) {
        return r.isBuffer(t, s.EC_PUBLIC_KEY_TYPE_INVALID), r.isBufferLength2(t, 33, 65, s.EC_PUBLIC_KEY_LENGTH_INVALID), a = o(a, !0), e.publicKeyConvert(t, a);
      },
      publicKeyVerify: function publicKeyVerify(t) {
        return r.isBuffer(t, s.EC_PUBLIC_KEY_TYPE_INVALID), e.publicKeyVerify(t);
      },
      publicKeyTweakAdd: function publicKeyTweakAdd(t, a, n) {
        return r.isBuffer(t, s.EC_PUBLIC_KEY_TYPE_INVALID), r.isBufferLength2(t, 33, 65, s.EC_PUBLIC_KEY_LENGTH_INVALID), r.isBuffer(a, s.TWEAK_TYPE_INVALID), r.isBufferLength(a, 32, s.TWEAK_LENGTH_INVALID), n = o(n, !0), e.publicKeyTweakAdd(t, a, n);
      },
      publicKeyTweakMul: function publicKeyTweakMul(t, a, n) {
        return r.isBuffer(t, s.EC_PUBLIC_KEY_TYPE_INVALID), r.isBufferLength2(t, 33, 65, s.EC_PUBLIC_KEY_LENGTH_INVALID), r.isBuffer(a, s.TWEAK_TYPE_INVALID), r.isBufferLength(a, 32, s.TWEAK_LENGTH_INVALID), n = o(n, !0), e.publicKeyTweakMul(t, a, n);
      },
      publicKeyCombine: function publicKeyCombine(t, a) {
        r.isArray(t, s.EC_PUBLIC_KEYS_TYPE_INVALID), r.isLengthGTZero(t, s.EC_PUBLIC_KEYS_LENGTH_INVALID);

        for (var n = 0; n < t.length; ++n) {
          r.isBuffer(t[n], s.EC_PUBLIC_KEY_TYPE_INVALID), r.isBufferLength2(t[n], 33, 65, s.EC_PUBLIC_KEY_LENGTH_INVALID);
        }

        return a = o(a, !0), e.publicKeyCombine(t, a);
      },
      signatureNormalize: function signatureNormalize(t) {
        return r.isBuffer(t, s.ECDSA_SIGNATURE_TYPE_INVALID), r.isBufferLength(t, 64, s.ECDSA_SIGNATURE_LENGTH_INVALID), e.signatureNormalize(t);
      },
      signatureExport: function signatureExport(t) {
        r.isBuffer(t, s.ECDSA_SIGNATURE_TYPE_INVALID), r.isBufferLength(t, 64, s.ECDSA_SIGNATURE_LENGTH_INVALID);
        var a = e.signatureExport(t);
        return n.signatureExport(a);
      },
      signatureImport: function signatureImport(t) {
        r.isBuffer(t, s.ECDSA_SIGNATURE_TYPE_INVALID), r.isLengthGTZero(t, s.ECDSA_SIGNATURE_LENGTH_INVALID);
        var a = n.signatureImport(t);
        if (a) return e.signatureImport(a);
        throw new Error(s.ECDSA_SIGNATURE_PARSE_DER_FAIL);
      },
      signatureImportLax: function signatureImportLax(t) {
        r.isBuffer(t, s.ECDSA_SIGNATURE_TYPE_INVALID), r.isLengthGTZero(t, s.ECDSA_SIGNATURE_LENGTH_INVALID);
        var a = n.signatureImportLax(t);
        if (a) return e.signatureImport(a);
        throw new Error(s.ECDSA_SIGNATURE_PARSE_DER_FAIL);
      },
      sign: function sign(t, a, n) {
        r.isBuffer(t, s.MSG32_TYPE_INVALID), r.isBufferLength(t, 32, s.MSG32_LENGTH_INVALID), r.isBuffer(a, s.EC_PRIVATE_KEY_TYPE_INVALID), r.isBufferLength(a, 32, s.EC_PRIVATE_KEY_LENGTH_INVALID);
        var o = null,
            i = null;
        return void 0 !== n && (r.isObject(n, s.OPTIONS_TYPE_INVALID), void 0 !== n.data && (r.isBuffer(n.data, s.OPTIONS_DATA_TYPE_INVALID), r.isBufferLength(n.data, 32, s.OPTIONS_DATA_LENGTH_INVALID), o = n.data), void 0 !== n.noncefn && (r.isFunction(n.noncefn, s.OPTIONS_NONCEFN_TYPE_INVALID), i = n.noncefn)), e.sign(t, a, i, o);
      },
      verify: function verify(t, a, n) {
        return r.isBuffer(t, s.MSG32_TYPE_INVALID), r.isBufferLength(t, 32, s.MSG32_LENGTH_INVALID), r.isBuffer(a, s.ECDSA_SIGNATURE_TYPE_INVALID), r.isBufferLength(a, 64, s.ECDSA_SIGNATURE_LENGTH_INVALID), r.isBuffer(n, s.EC_PUBLIC_KEY_TYPE_INVALID), r.isBufferLength2(n, 33, 65, s.EC_PUBLIC_KEY_LENGTH_INVALID), e.verify(t, a, n);
      },
      recover: function recover(t, a, n, i) {
        return r.isBuffer(t, s.MSG32_TYPE_INVALID), r.isBufferLength(t, 32, s.MSG32_LENGTH_INVALID), r.isBuffer(a, s.ECDSA_SIGNATURE_TYPE_INVALID), r.isBufferLength(a, 64, s.ECDSA_SIGNATURE_LENGTH_INVALID), r.isNumber(n, s.RECOVERY_ID_TYPE_INVALID), r.isNumberInInterval(n, -1, 4, s.RECOVERY_ID_VALUE_INVALID), i = o(i, !0), e.recover(t, a, n, i);
      },
      ecdh: function ecdh(t, a) {
        return r.isBuffer(t, s.EC_PUBLIC_KEY_TYPE_INVALID), r.isBufferLength2(t, 33, 65, s.EC_PUBLIC_KEY_LENGTH_INVALID), r.isBuffer(a, s.EC_PRIVATE_KEY_TYPE_INVALID), r.isBufferLength(a, 32, s.EC_PRIVATE_KEY_LENGTH_INVALID), e.ecdh(t, a);
      },
      ecdhUnsafe: function ecdhUnsafe(t, a, n) {
        return r.isBuffer(t, s.EC_PUBLIC_KEY_TYPE_INVALID), r.isBufferLength2(t, 33, 65, s.EC_PUBLIC_KEY_LENGTH_INVALID), r.isBuffer(a, s.EC_PRIVATE_KEY_TYPE_INVALID), r.isBufferLength(a, 32, s.EC_PRIVATE_KEY_LENGTH_INVALID), n = o(n, !0), e.ecdhUnsafe(t, a, n);
      }
    };
  };
},
/*!**********************************************!*\
  !*** ./node_modules/secp256k1/lib/assert.js ***!
  \**********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    var a = Object.prototype.toString;
    t.isArray = function (e, t) {
      if (!Array.isArray(e)) throw TypeError(t);
    }, t.isBoolean = function (e, t) {
      if ("[object Boolean]" !== a.call(e)) throw TypeError(t);
    }, t.isBuffer = function (t, a) {
      if (!e.isBuffer(t)) throw TypeError(a);
    }, t.isFunction = function (e, t) {
      if ("[object Function]" !== a.call(e)) throw TypeError(t);
    }, t.isNumber = function (e, t) {
      if ("[object Number]" !== a.call(e)) throw TypeError(t);
    }, t.isObject = function (e, t) {
      if ("[object Object]" !== a.call(e)) throw TypeError(t);
    }, t.isBufferLength = function (e, t, a) {
      if (e.length !== t) throw RangeError(a);
    }, t.isBufferLength2 = function (e, t, a, r) {
      if (e.length !== t && e.length !== a) throw RangeError(r);
    }, t.isLengthGTZero = function (e, t) {
      if (0 === e.length) throw RangeError(t);
    }, t.isNumberInInterval = function (e, t, a, r) {
      if (e <= t || e >= a) throw RangeError(r);
    };
  }).call(this, a(
  /*! ./../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!*******************************************!*\
  !*** ./node_modules/secp256k1/lib/der.js ***!
  \*******************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! safe-buffer */
  7).Buffer,
      n = a(
  /*! bip66 */
  394),
      s = r.from([48, 129, 211, 2, 1, 1, 4, 32, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 160, 129, 133, 48, 129, 130, 2, 1, 1, 48, 44, 6, 7, 42, 134, 72, 206, 61, 1, 1, 2, 33, 0, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 254, 255, 255, 252, 47, 48, 6, 4, 1, 0, 4, 1, 7, 4, 33, 2, 121, 190, 102, 126, 249, 220, 187, 172, 85, 160, 98, 149, 206, 135, 11, 7, 2, 155, 252, 219, 45, 206, 40, 217, 89, 242, 129, 91, 22, 248, 23, 152, 2, 33, 0, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 254, 186, 174, 220, 230, 175, 72, 160, 59, 191, 210, 94, 140, 208, 54, 65, 65, 2, 1, 1, 161, 36, 3, 34, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]),
      o = r.from([48, 130, 1, 19, 2, 1, 1, 4, 32, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 160, 129, 165, 48, 129, 162, 2, 1, 1, 48, 44, 6, 7, 42, 134, 72, 206, 61, 1, 1, 2, 33, 0, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 254, 255, 255, 252, 47, 48, 6, 4, 1, 0, 4, 1, 7, 4, 65, 4, 121, 190, 102, 126, 249, 220, 187, 172, 85, 160, 98, 149, 206, 135, 11, 7, 2, 155, 252, 219, 45, 206, 40, 217, 89, 242, 129, 91, 22, 248, 23, 152, 72, 58, 218, 119, 38, 163, 196, 101, 93, 164, 251, 252, 14, 17, 8, 168, 253, 23, 180, 72, 166, 133, 84, 25, 156, 71, 208, 143, 251, 16, 212, 184, 2, 33, 0, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 254, 186, 174, 220, 230, 175, 72, 160, 59, 191, 210, 94, 140, 208, 54, 65, 65, 2, 1, 1, 161, 68, 3, 66, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
  t.privateKeyExport = function (e, t, a) {
    var n = r.from(a ? s : o);
    return e.copy(n, a ? 8 : 9), t.copy(n, a ? 181 : 214), n;
  }, t.privateKeyImport = function (e) {
    var t = e.length,
        a = 0;

    if (!(t < a + 1 || 48 !== e[a]) && !(t < (a += 1) + 1) && 128 & e[a]) {
      var r = 127 & e[a];

      if (a += 1, !(r < 1 || r > 2 || t < a + r)) {
        var n = e[a + r - 1] | (r > 1 ? e[a + r - 2] << 8 : 0);
        if (!(t < (a += r) + n || t < a + 3 || 2 !== e[a] || 1 !== e[a + 1] || 1 !== e[a + 2] || t < (a += 3) + 2 || 4 !== e[a] || e[a + 1] > 32 || t < a + 2 + e[a + 1])) return e.slice(a + 2, a + 2 + e[a + 1]);
      }
    }
  }, t.signatureExport = function (e) {
    for (var t = r.concat([r.from([0]), e.r]), a = 33, s = 0; a > 1 && 0 === t[s] && !(128 & t[s + 1]); --a, ++s) {
      ;
    }

    for (var o = r.concat([r.from([0]), e.s]), i = 33, c = 0; i > 1 && 0 === o[c] && !(128 & o[c + 1]); --i, ++c) {
      ;
    }

    return n.encode(t.slice(s), o.slice(c));
  }, t.signatureImport = function (e) {
    var t = r.alloc(32, 0),
        a = r.alloc(32, 0);

    try {
      var s = n.decode(e);
      if (33 === s.r.length && 0 === s.r[0] && (s.r = s.r.slice(1)), s.r.length > 32) throw new Error("R length is too long");
      if (33 === s.s.length && 0 === s.s[0] && (s.s = s.s.slice(1)), s.s.length > 32) throw new Error("S length is too long");
    } catch (e) {
      return;
    }

    return s.r.copy(t, 32 - s.r.length), s.s.copy(a, 32 - s.s.length), {
      r: t,
      s: a
    };
  }, t.signatureImportLax = function (e) {
    var t = r.alloc(32, 0),
        a = r.alloc(32, 0),
        n = e.length,
        s = 0;

    if (48 === e[s++]) {
      var o = e[s++];

      if (!(128 & o && (s += o - 128) > n) && 2 === e[s++]) {
        var i = e[s++];

        if (128 & i) {
          if (s + (o = i - 128) > n) return;

          for (; o > 0 && 0 === e[s]; s += 1, o -= 1) {
            ;
          }

          for (i = 0; o > 0; s += 1, o -= 1) {
            i = (i << 8) + e[s];
          }
        }

        if (!(i > n - s)) {
          var c = s;

          if (s += i, 2 === e[s++]) {
            var u = e[s++];

            if (128 & u) {
              if (s + (o = u - 128) > n) return;

              for (; o > 0 && 0 === e[s]; s += 1, o -= 1) {
                ;
              }

              for (u = 0; o > 0; s += 1, o -= 1) {
                u = (u << 8) + e[s];
              }
            }

            if (!(u > n - s)) {
              var d = s;

              for (s += u; i > 0 && 0 === e[c]; i -= 1, c += 1) {
                ;
              }

              if (!(i > 32)) {
                var f = e.slice(c, c + i);

                for (f.copy(t, 32 - f.length); u > 0 && 0 === e[d]; u -= 1, d += 1) {
                  ;
                }

                if (!(u > 32)) {
                  var l = e.slice(d, d + u);
                  return l.copy(a, 32 - l.length), {
                    r: t,
                    s: a
                  };
                }
              }
            }
          }
        }
      }
    }
  };
},
/*!*************************************!*\
  !*** ./node_modules/bip66/index.js ***!
  \*************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! safe-buffer */
  7).Buffer;
  e.exports = {
    check: function check(e) {
      if (e.length < 8) return !1;
      if (e.length > 72) return !1;
      if (48 !== e[0]) return !1;
      if (e[1] !== e.length - 2) return !1;
      if (2 !== e[2]) return !1;
      var t = e[3];
      if (0 === t) return !1;
      if (5 + t >= e.length) return !1;
      if (2 !== e[4 + t]) return !1;
      var a = e[5 + t];
      return 0 !== a && 6 + t + a === e.length && !(128 & e[4]) && !(t > 1 && 0 === e[4] && !(128 & e[5])) && !(128 & e[t + 6]) && !(a > 1 && 0 === e[t + 6] && !(128 & e[t + 7]));
    },
    decode: function decode(e) {
      if (e.length < 8) throw new Error("DER sequence length is too short");
      if (e.length > 72) throw new Error("DER sequence length is too long");
      if (48 !== e[0]) throw new Error("Expected DER sequence");
      if (e[1] !== e.length - 2) throw new Error("DER sequence length is invalid");
      if (2 !== e[2]) throw new Error("Expected DER integer");
      var t = e[3];
      if (0 === t) throw new Error("R length is zero");
      if (5 + t >= e.length) throw new Error("R length is too long");
      if (2 !== e[4 + t]) throw new Error("Expected DER integer (2)");
      var a = e[5 + t];
      if (0 === a) throw new Error("S length is zero");
      if (6 + t + a !== e.length) throw new Error("S length is invalid");
      if (128 & e[4]) throw new Error("R value is negative");
      if (t > 1 && 0 === e[4] && !(128 & e[5])) throw new Error("R value excessively padded");
      if (128 & e[t + 6]) throw new Error("S value is negative");
      if (a > 1 && 0 === e[t + 6] && !(128 & e[t + 7])) throw new Error("S value excessively padded");
      return {
        r: e.slice(4, 4 + t),
        s: e.slice(6 + t)
      };
    },
    encode: function encode(e, t) {
      var a = e.length,
          n = t.length;
      if (0 === a) throw new Error("R length is zero");
      if (0 === n) throw new Error("S length is zero");
      if (a > 33) throw new Error("R length is too long");
      if (n > 33) throw new Error("S length is too long");
      if (128 & e[0]) throw new Error("R value is negative");
      if (128 & t[0]) throw new Error("S value is negative");
      if (a > 1 && 0 === e[0] && !(128 & e[1])) throw new Error("R value excessively padded");
      if (n > 1 && 0 === t[0] && !(128 & t[1])) throw new Error("S value excessively padded");
      var s = r.allocUnsafe(6 + a + n);
      return s[0] = 48, s[1] = s.length - 2, s[2] = 2, s[3] = e.length, e.copy(s, 4), s[4 + a] = 2, s[5 + a] = t.length, t.copy(s, 6 + a), s;
    }
  };
},
/*!******************************************************!*\
  !*** ./node_modules/secp256k1/lib/elliptic/index.js ***!
  \******************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! safe-buffer */
  7).Buffer,
      n = a(
  /*! create-hash */
  20),
      s = a(
  /*! bn.js */
  5),
      o = a(
  /*! elliptic */
  78).ec,
      i = a(
  /*! ../messages.json */
  157),
      c = new o("secp256k1"),
      u = c.curve;

  function d(e) {
    var t = e[0];

    switch (t) {
      case 2:
      case 3:
        return 33 !== e.length ? null : function (e, t) {
          var a = new s(t);
          if (a.cmp(u.p) >= 0) return null;
          var r = (a = a.toRed(u.red)).redSqr().redIMul(a).redIAdd(u.b).redSqrt();
          return 3 === e !== r.isOdd() && (r = r.redNeg()), c.keyPair({
            pub: {
              x: a,
              y: r
            }
          });
        }(t, e.slice(1, 33));

      case 4:
      case 6:
      case 7:
        return 65 !== e.length ? null : function (e, t, a) {
          var r = new s(t),
              n = new s(a);
          if (r.cmp(u.p) >= 0 || n.cmp(u.p) >= 0) return null;
          if (r = r.toRed(u.red), n = n.toRed(u.red), (6 === e || 7 === e) && n.isOdd() !== (7 === e)) return null;
          var o = r.redSqr().redIMul(r);
          return n.redSqr().redISub(o.redIAdd(u.b)).isZero() ? c.keyPair({
            pub: {
              x: r,
              y: n
            }
          }) : null;
        }(t, e.slice(1, 33), e.slice(33, 65));

      default:
        return null;
    }
  }

  t.privateKeyVerify = function (e) {
    var t = new s(e);
    return t.cmp(u.n) < 0 && !t.isZero();
  }, t.privateKeyExport = function (e, t) {
    var a = new s(e);
    if (a.cmp(u.n) >= 0 || a.isZero()) throw new Error(i.EC_PRIVATE_KEY_EXPORT_DER_FAIL);
    return r.from(c.keyFromPrivate(e).getPublic(t, !0));
  }, t.privateKeyNegate = function (e) {
    var t = new s(e);
    return t.isZero() ? r.alloc(32) : u.n.sub(t).umod(u.n).toArrayLike(r, "be", 32);
  }, t.privateKeyModInverse = function (e) {
    var t = new s(e);
    if (t.cmp(u.n) >= 0 || t.isZero()) throw new Error(i.EC_PRIVATE_KEY_RANGE_INVALID);
    return t.invm(u.n).toArrayLike(r, "be", 32);
  }, t.privateKeyTweakAdd = function (e, t) {
    var a = new s(t);
    if (a.cmp(u.n) >= 0) throw new Error(i.EC_PRIVATE_KEY_TWEAK_ADD_FAIL);
    if (a.iadd(new s(e)), a.cmp(u.n) >= 0 && a.isub(u.n), a.isZero()) throw new Error(i.EC_PRIVATE_KEY_TWEAK_ADD_FAIL);
    return a.toArrayLike(r, "be", 32);
  }, t.privateKeyTweakMul = function (e, t) {
    var a = new s(t);
    if (a.cmp(u.n) >= 0 || a.isZero()) throw new Error(i.EC_PRIVATE_KEY_TWEAK_MUL_FAIL);
    return a.imul(new s(e)), a.cmp(u.n) && (a = a.umod(u.n)), a.toArrayLike(r, "be", 32);
  }, t.publicKeyCreate = function (e, t) {
    var a = new s(e);
    if (a.cmp(u.n) >= 0 || a.isZero()) throw new Error(i.EC_PUBLIC_KEY_CREATE_FAIL);
    return r.from(c.keyFromPrivate(e).getPublic(t, !0));
  }, t.publicKeyConvert = function (e, t) {
    var a = d(e);
    if (null === a) throw new Error(i.EC_PUBLIC_KEY_PARSE_FAIL);
    return r.from(a.getPublic(t, !0));
  }, t.publicKeyVerify = function (e) {
    return null !== d(e);
  }, t.publicKeyTweakAdd = function (e, t, a) {
    var n = d(e);
    if (null === n) throw new Error(i.EC_PUBLIC_KEY_PARSE_FAIL);
    if ((t = new s(t)).cmp(u.n) >= 0) throw new Error(i.EC_PUBLIC_KEY_TWEAK_ADD_FAIL);
    var o = u.g.mul(t).add(n.pub);
    if (o.isInfinity()) throw new Error(i.EC_PUBLIC_KEY_TWEAK_ADD_FAIL);
    return r.from(o.encode(!0, a));
  }, t.publicKeyTweakMul = function (e, t, a) {
    var n = d(e);
    if (null === n) throw new Error(i.EC_PUBLIC_KEY_PARSE_FAIL);
    if ((t = new s(t)).cmp(u.n) >= 0 || t.isZero()) throw new Error(i.EC_PUBLIC_KEY_TWEAK_MUL_FAIL);
    return r.from(n.pub.mul(t).encode(!0, a));
  }, t.publicKeyCombine = function (e, t) {
    for (var a = new Array(e.length), n = 0; n < e.length; ++n) {
      if (a[n] = d(e[n]), null === a[n]) throw new Error(i.EC_PUBLIC_KEY_PARSE_FAIL);
    }

    for (var s = a[0].pub, o = 1; o < a.length; ++o) {
      s = s.add(a[o].pub);
    }

    if (s.isInfinity()) throw new Error(i.EC_PUBLIC_KEY_COMBINE_FAIL);
    return r.from(s.encode(!0, t));
  }, t.signatureNormalize = function (e) {
    var t = new s(e.slice(0, 32)),
        a = new s(e.slice(32, 64));
    if (t.cmp(u.n) >= 0 || a.cmp(u.n) >= 0) throw new Error(i.ECDSA_SIGNATURE_PARSE_FAIL);
    var n = r.from(e);
    return 1 === a.cmp(c.nh) && u.n.sub(a).toArrayLike(r, "be", 32).copy(n, 32), n;
  }, t.signatureExport = function (e) {
    var t = e.slice(0, 32),
        a = e.slice(32, 64);
    if (new s(t).cmp(u.n) >= 0 || new s(a).cmp(u.n) >= 0) throw new Error(i.ECDSA_SIGNATURE_PARSE_FAIL);
    return {
      r: t,
      s: a
    };
  }, t.signatureImport = function (e) {
    var t = new s(e.r);
    t.cmp(u.n) >= 0 && (t = new s(0));
    var a = new s(e.s);
    return a.cmp(u.n) >= 0 && (a = new s(0)), r.concat([t.toArrayLike(r, "be", 32), a.toArrayLike(r, "be", 32)]);
  }, t.sign = function (e, t, a, n) {
    if ("function" == typeof a) {
      var o = a;

      a = function a(_a5) {
        var c = o(e, t, null, n, _a5);
        if (!r.isBuffer(c) || 32 !== c.length) throw new Error(i.ECDSA_SIGN_FAIL);
        return new s(c);
      };
    }

    var d = new s(t);
    if (d.cmp(u.n) >= 0 || d.isZero()) throw new Error(i.ECDSA_SIGN_FAIL);
    var f = c.sign(e, t, {
      canonical: !0,
      k: a,
      pers: n
    });
    return {
      signature: r.concat([f.r.toArrayLike(r, "be", 32), f.s.toArrayLike(r, "be", 32)]),
      recovery: f.recoveryParam
    };
  }, t.verify = function (e, t, a) {
    var r = {
      r: t.slice(0, 32),
      s: t.slice(32, 64)
    },
        n = new s(r.r),
        o = new s(r.s);
    if (n.cmp(u.n) >= 0 || o.cmp(u.n) >= 0) throw new Error(i.ECDSA_SIGNATURE_PARSE_FAIL);
    if (1 === o.cmp(c.nh) || n.isZero() || o.isZero()) return !1;
    var f = d(a);
    if (null === f) throw new Error(i.EC_PUBLIC_KEY_PARSE_FAIL);
    return c.verify(e, r, {
      x: f.pub.x,
      y: f.pub.y
    });
  }, t.recover = function (e, t, a, n) {
    var o = {
      r: t.slice(0, 32),
      s: t.slice(32, 64)
    },
        d = new s(o.r),
        f = new s(o.s);
    if (d.cmp(u.n) >= 0 || f.cmp(u.n) >= 0) throw new Error(i.ECDSA_SIGNATURE_PARSE_FAIL);

    try {
      if (d.isZero() || f.isZero()) throw new Error();
      var l = c.recoverPubKey(e, o, a);
      return r.from(l.encode(!0, n));
    } catch (e) {
      throw new Error(i.ECDSA_RECOVER_FAIL);
    }
  }, t.ecdh = function (e, a) {
    var r = t.ecdhUnsafe(e, a, !0);
    return n("sha256").update(r).digest();
  }, t.ecdhUnsafe = function (e, t, a) {
    var n = d(e);
    if (null === n) throw new Error(i.EC_PUBLIC_KEY_PARSE_FAIL);
    var o = new s(t);
    if (o.cmp(u.n) >= 0 || o.isZero()) throw new Error(i.ECDH_FAIL);
    return r.from(n.pub.mul(o).encode(!0, a));
  };
},
/*!************************************!*\
  !*** ./node_modules/sha.js/sha.js ***!
  \************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! inherits */
  3),
      n = a(
  /*! ./hash */
  59),
      s = a(
  /*! safe-buffer */
  7).Buffer,
      o = [1518500249, 1859775393, -1894007588, -899497514],
      i = new Array(80);

  function c() {
    this.init(), this._w = i, n.call(this, 64, 56);
  }

  function u(e) {
    return e << 30 | e >>> 2;
  }

  function d(e, t, a, r) {
    return 0 === e ? t & a | ~t & r : 2 === e ? t & a | t & r | a & r : t ^ a ^ r;
  }

  r(c, n), c.prototype.init = function () {
    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
  }, c.prototype._update = function (e) {
    for (var t, a = this._w, r = 0 | this._a, n = 0 | this._b, s = 0 | this._c, i = 0 | this._d, c = 0 | this._e, f = 0; f < 16; ++f) {
      a[f] = e.readInt32BE(4 * f);
    }

    for (; f < 80; ++f) {
      a[f] = a[f - 3] ^ a[f - 8] ^ a[f - 14] ^ a[f - 16];
    }

    for (var l = 0; l < 80; ++l) {
      var h = ~~(l / 20),
          p = 0 | ((t = r) << 5 | t >>> 27) + d(h, n, s, i) + c + a[l] + o[h];
      c = i, i = s, s = u(n), n = r, r = p;
    }

    this._a = r + this._a | 0, this._b = n + this._b | 0, this._c = s + this._c | 0, this._d = i + this._d | 0, this._e = c + this._e | 0;
  }, c.prototype._hash = function () {
    var e = s.allocUnsafe(20);
    return e.writeInt32BE(0 | this._a, 0), e.writeInt32BE(0 | this._b, 4), e.writeInt32BE(0 | this._c, 8), e.writeInt32BE(0 | this._d, 12), e.writeInt32BE(0 | this._e, 16), e;
  }, e.exports = c;
},
/*!*************************************!*\
  !*** ./node_modules/sha.js/sha1.js ***!
  \*************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! inherits */
  3),
      n = a(
  /*! ./hash */
  59),
      s = a(
  /*! safe-buffer */
  7).Buffer,
      o = [1518500249, 1859775393, -1894007588, -899497514],
      i = new Array(80);

  function c() {
    this.init(), this._w = i, n.call(this, 64, 56);
  }

  function u(e) {
    return e << 5 | e >>> 27;
  }

  function d(e) {
    return e << 30 | e >>> 2;
  }

  function f(e, t, a, r) {
    return 0 === e ? t & a | ~t & r : 2 === e ? t & a | t & r | a & r : t ^ a ^ r;
  }

  r(c, n), c.prototype.init = function () {
    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
  }, c.prototype._update = function (e) {
    for (var t, a = this._w, r = 0 | this._a, n = 0 | this._b, s = 0 | this._c, i = 0 | this._d, c = 0 | this._e, l = 0; l < 16; ++l) {
      a[l] = e.readInt32BE(4 * l);
    }

    for (; l < 80; ++l) {
      a[l] = (t = a[l - 3] ^ a[l - 8] ^ a[l - 14] ^ a[l - 16]) << 1 | t >>> 31;
    }

    for (var h = 0; h < 80; ++h) {
      var p = ~~(h / 20),
          b = u(r) + f(p, n, s, i) + c + a[h] + o[p] | 0;
      c = i, i = s, s = d(n), n = r, r = b;
    }

    this._a = r + this._a | 0, this._b = n + this._b | 0, this._c = s + this._c | 0, this._d = i + this._d | 0, this._e = c + this._e | 0;
  }, c.prototype._hash = function () {
    var e = s.allocUnsafe(20);
    return e.writeInt32BE(0 | this._a, 0), e.writeInt32BE(0 | this._b, 4), e.writeInt32BE(0 | this._c, 8), e.writeInt32BE(0 | this._d, 12), e.writeInt32BE(0 | this._e, 16), e;
  }, e.exports = c;
},
/*!***************************************!*\
  !*** ./node_modules/sha.js/sha224.js ***!
  \***************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! inherits */
  3),
      n = a(
  /*! ./sha256 */
  159),
      s = a(
  /*! ./hash */
  59),
      o = a(
  /*! safe-buffer */
  7).Buffer,
      i = new Array(64);

  function c() {
    this.init(), this._w = i, s.call(this, 64, 56);
  }

  r(c, n), c.prototype.init = function () {
    return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
  }, c.prototype._hash = function () {
    var e = o.allocUnsafe(28);
    return e.writeInt32BE(this._a, 0), e.writeInt32BE(this._b, 4), e.writeInt32BE(this._c, 8), e.writeInt32BE(this._d, 12), e.writeInt32BE(this._e, 16), e.writeInt32BE(this._f, 20), e.writeInt32BE(this._g, 24), e;
  }, e.exports = c;
},
/*!***************************************!*\
  !*** ./node_modules/sha.js/sha384.js ***!
  \***************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! inherits */
  3),
      n = a(
  /*! ./sha512 */
  160),
      s = a(
  /*! ./hash */
  59),
      o = a(
  /*! safe-buffer */
  7).Buffer,
      i = new Array(160);

  function c() {
    this.init(), this._w = i, s.call(this, 128, 112);
  }

  r(c, n), c.prototype.init = function () {
    return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
  }, c.prototype._hash = function () {
    var e = o.allocUnsafe(48);

    function t(t, a, r) {
      e.writeInt32BE(t, r), e.writeInt32BE(a, r + 4);
    }

    return t(this._ah, this._al, 0), t(this._bh, this._bl, 8), t(this._ch, this._cl, 16), t(this._dh, this._dl, 24), t(this._eh, this._el, 32), t(this._fh, this._fl, 40), e;
  }, e.exports = c;
},
/*!************************!*\
  !*** buffer (ignored) ***!
  \************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {},
/*!********************************************!*\
  !*** ./node_modules/elliptic/package.json ***!
  \********************************************/

/*! exports provided: name, version, description, main, files, scripts, repository, keywords, author, license, bugs, homepage, devDependencies, dependencies, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"elliptic","version":"6.5.0","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"}}');
},
/*!************************!*\
  !*** crypto (ignored) ***!
  \************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {},
/*!***********************************************************!*\
  !*** ./node_modules/elliptic/lib/elliptic/curve/short.js ***!
  \***********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ../utils */
  31),
      n = a(
  /*! bn.js */
  5),
      s = a(
  /*! inherits */
  3),
      o = a(
  /*! ./base */
  79),
      i = r.assert;

  function c(e) {
    o.call(this, "short", e), this.a = new n(e.a, 16).toRed(this.red), this.b = new n(e.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = 0 === this.a.fromRed().cmpn(0), this.threeA = 0 === this.a.fromRed().sub(this.p).cmpn(-3), this.endo = this._getEndomorphism(e), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
  }

  function u(e, t, a, r) {
    o.BasePoint.call(this, e, "affine"), null === t && null === a ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new n(t, 16), this.y = new n(a, 16), r && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
  }

  function d(e, t, a, r) {
    o.BasePoint.call(this, e, "jacobian"), null === t && null === a && null === r ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new n(0)) : (this.x = new n(t, 16), this.y = new n(a, 16), this.z = new n(r, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
  }

  s(c, o), e.exports = c, c.prototype._getEndomorphism = function (e) {
    if (this.zeroA && this.g && this.n && 1 === this.p.modn(3)) {
      var t, a;
      if (e.beta) t = new n(e.beta, 16).toRed(this.red);else {
        var r = this._getEndoRoots(this.p);

        t = (t = r[0].cmp(r[1]) < 0 ? r[0] : r[1]).toRed(this.red);
      }
      if (e.lambda) a = new n(e.lambda, 16);else {
        var s = this._getEndoRoots(this.n);

        0 === this.g.mul(s[0]).x.cmp(this.g.x.redMul(t)) ? a = s[0] : (a = s[1], i(0 === this.g.mul(a).x.cmp(this.g.x.redMul(t))));
      }
      return {
        beta: t,
        lambda: a,
        basis: e.basis ? e.basis.map(function (e) {
          return {
            a: new n(e.a, 16),
            b: new n(e.b, 16)
          };
        }) : this._getEndoBasis(a)
      };
    }
  }, c.prototype._getEndoRoots = function (e) {
    var t = e === this.p ? this.red : n.mont(e),
        a = new n(2).toRed(t).redInvm(),
        r = a.redNeg(),
        s = new n(3).toRed(t).redNeg().redSqrt().redMul(a);
    return [r.redAdd(s).fromRed(), r.redSub(s).fromRed()];
  }, c.prototype._getEndoBasis = function (e) {
    for (var t, a, r, s, o, i, c, u, d, f = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), l = e, h = this.n.clone(), p = new n(1), b = new n(0), m = new n(0), y = new n(1), v = 0; 0 !== l.cmpn(0);) {
      var _ = h.div(l);

      u = h.sub(_.mul(l)), d = m.sub(_.mul(p));
      var g = y.sub(_.mul(b));
      if (!r && u.cmp(f) < 0) t = c.neg(), a = p, r = u.neg(), s = d;else if (r && 2 == ++v) break;
      c = u, h = l, l = u, m = p, p = d, y = b, b = g;
    }

    o = u.neg(), i = d;
    var A = r.sqr().add(s.sqr());
    return o.sqr().add(i.sqr()).cmp(A) >= 0 && (o = t, i = a), r.negative && (r = r.neg(), s = s.neg()), o.negative && (o = o.neg(), i = i.neg()), [{
      a: r,
      b: s
    }, {
      a: o,
      b: i
    }];
  }, c.prototype._endoSplit = function (e) {
    var t = this.endo.basis,
        a = t[0],
        r = t[1],
        n = r.b.mul(e).divRound(this.n),
        s = a.b.neg().mul(e).divRound(this.n),
        o = n.mul(a.a),
        i = s.mul(r.a),
        c = n.mul(a.b),
        u = s.mul(r.b);
    return {
      k1: e.sub(o).sub(i),
      k2: c.add(u).neg()
    };
  }, c.prototype.pointFromX = function (e, t) {
    (e = new n(e, 16)).red || (e = e.toRed(this.red));
    var a = e.redSqr().redMul(e).redIAdd(e.redMul(this.a)).redIAdd(this.b),
        r = a.redSqrt();
    if (0 !== r.redSqr().redSub(a).cmp(this.zero)) throw new Error("invalid point");
    var s = r.fromRed().isOdd();
    return (t && !s || !t && s) && (r = r.redNeg()), this.point(e, r);
  }, c.prototype.validate = function (e) {
    if (e.inf) return !0;
    var t = e.x,
        a = e.y,
        r = this.a.redMul(t),
        n = t.redSqr().redMul(t).redIAdd(r).redIAdd(this.b);
    return 0 === a.redSqr().redISub(n).cmpn(0);
  }, c.prototype._endoWnafMulAdd = function (e, t, a) {
    for (var r = this._endoWnafT1, n = this._endoWnafT2, s = 0; s < e.length; s++) {
      var o = this._endoSplit(t[s]),
          i = e[s],
          c = i._getBeta();

      o.k1.negative && (o.k1.ineg(), i = i.neg(!0)), o.k2.negative && (o.k2.ineg(), c = c.neg(!0)), r[2 * s] = i, r[2 * s + 1] = c, n[2 * s] = o.k1, n[2 * s + 1] = o.k2;
    }

    for (var u = this._wnafMulAdd(1, r, n, 2 * s, a), d = 0; d < 2 * s; d++) {
      r[d] = null, n[d] = null;
    }

    return u;
  }, s(u, o.BasePoint), c.prototype.point = function (e, t, a) {
    return new u(this, e, t, a);
  }, c.prototype.pointFromJSON = function (e, t) {
    return u.fromJSON(this, e, t);
  }, u.prototype._getBeta = function () {
    if (this.curve.endo) {
      var e = this.precomputed;
      if (e && e.beta) return e.beta;
      var t = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);

      if (e) {
        var a = this.curve,
            r = function r(e) {
          return a.point(e.x.redMul(a.endo.beta), e.y);
        };

        e.beta = t, t.precomputed = {
          beta: null,
          naf: e.naf && {
            wnd: e.naf.wnd,
            points: e.naf.points.map(r)
          },
          doubles: e.doubles && {
            step: e.doubles.step,
            points: e.doubles.points.map(r)
          }
        };
      }

      return t;
    }
  }, u.prototype.toJSON = function () {
    return this.precomputed ? [this.x, this.y, this.precomputed && {
      doubles: this.precomputed.doubles && {
        step: this.precomputed.doubles.step,
        points: this.precomputed.doubles.points.slice(1)
      },
      naf: this.precomputed.naf && {
        wnd: this.precomputed.naf.wnd,
        points: this.precomputed.naf.points.slice(1)
      }
    }] : [this.x, this.y];
  }, u.fromJSON = function (e, t, a) {
    "string" == typeof t && (t = JSON.parse(t));
    var r = e.point(t[0], t[1], a);
    if (!t[2]) return r;

    function n(t) {
      return e.point(t[0], t[1], a);
    }

    var s = t[2];
    return r.precomputed = {
      beta: null,
      doubles: s.doubles && {
        step: s.doubles.step,
        points: [r].concat(s.doubles.points.map(n))
      },
      naf: s.naf && {
        wnd: s.naf.wnd,
        points: [r].concat(s.naf.points.map(n))
      }
    }, r;
  }, u.prototype.inspect = function () {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
  }, u.prototype.isInfinity = function () {
    return this.inf;
  }, u.prototype.add = function (e) {
    if (this.inf) return e;
    if (e.inf) return this;
    if (this.eq(e)) return this.dbl();
    if (this.neg().eq(e)) return this.curve.point(null, null);
    if (0 === this.x.cmp(e.x)) return this.curve.point(null, null);
    var t = this.y.redSub(e.y);
    0 !== t.cmpn(0) && (t = t.redMul(this.x.redSub(e.x).redInvm()));
    var a = t.redSqr().redISub(this.x).redISub(e.x),
        r = t.redMul(this.x.redSub(a)).redISub(this.y);
    return this.curve.point(a, r);
  }, u.prototype.dbl = function () {
    if (this.inf) return this;
    var e = this.y.redAdd(this.y);
    if (0 === e.cmpn(0)) return this.curve.point(null, null);
    var t = this.curve.a,
        a = this.x.redSqr(),
        r = e.redInvm(),
        n = a.redAdd(a).redIAdd(a).redIAdd(t).redMul(r),
        s = n.redSqr().redISub(this.x.redAdd(this.x)),
        o = n.redMul(this.x.redSub(s)).redISub(this.y);
    return this.curve.point(s, o);
  }, u.prototype.getX = function () {
    return this.x.fromRed();
  }, u.prototype.getY = function () {
    return this.y.fromRed();
  }, u.prototype.mul = function (e) {
    return e = new n(e, 16), this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [e]) : this.curve._wnafMul(this, e);
  }, u.prototype.mulAdd = function (e, t, a) {
    var r = [this, t],
        n = [e, a];
    return this.curve.endo ? this.curve._endoWnafMulAdd(r, n) : this.curve._wnafMulAdd(1, r, n, 2);
  }, u.prototype.jmulAdd = function (e, t, a) {
    var r = [this, t],
        n = [e, a];
    return this.curve.endo ? this.curve._endoWnafMulAdd(r, n, !0) : this.curve._wnafMulAdd(1, r, n, 2, !0);
  }, u.prototype.eq = function (e) {
    return this === e || this.inf === e.inf && (this.inf || 0 === this.x.cmp(e.x) && 0 === this.y.cmp(e.y));
  }, u.prototype.neg = function (e) {
    if (this.inf) return this;
    var t = this.curve.point(this.x, this.y.redNeg());

    if (e && this.precomputed) {
      var a = this.precomputed,
          r = function r(e) {
        return e.neg();
      };

      t.precomputed = {
        naf: a.naf && {
          wnd: a.naf.wnd,
          points: a.naf.points.map(r)
        },
        doubles: a.doubles && {
          step: a.doubles.step,
          points: a.doubles.points.map(r)
        }
      };
    }

    return t;
  }, u.prototype.toJ = function () {
    return this.inf ? this.curve.jpoint(null, null, null) : this.curve.jpoint(this.x, this.y, this.curve.one);
  }, s(d, o.BasePoint), c.prototype.jpoint = function (e, t, a) {
    return new d(this, e, t, a);
  }, d.prototype.toP = function () {
    if (this.isInfinity()) return this.curve.point(null, null);
    var e = this.z.redInvm(),
        t = e.redSqr(),
        a = this.x.redMul(t),
        r = this.y.redMul(t).redMul(e);
    return this.curve.point(a, r);
  }, d.prototype.neg = function () {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
  }, d.prototype.add = function (e) {
    if (this.isInfinity()) return e;
    if (e.isInfinity()) return this;
    var t = e.z.redSqr(),
        a = this.z.redSqr(),
        r = this.x.redMul(t),
        n = e.x.redMul(a),
        s = this.y.redMul(t.redMul(e.z)),
        o = e.y.redMul(a.redMul(this.z)),
        i = r.redSub(n),
        c = s.redSub(o);
    if (0 === i.cmpn(0)) return 0 !== c.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
    var u = i.redSqr(),
        d = u.redMul(i),
        f = r.redMul(u),
        l = c.redSqr().redIAdd(d).redISub(f).redISub(f),
        h = c.redMul(f.redISub(l)).redISub(s.redMul(d)),
        p = this.z.redMul(e.z).redMul(i);
    return this.curve.jpoint(l, h, p);
  }, d.prototype.mixedAdd = function (e) {
    if (this.isInfinity()) return e.toJ();
    if (e.isInfinity()) return this;
    var t = this.z.redSqr(),
        a = this.x,
        r = e.x.redMul(t),
        n = this.y,
        s = e.y.redMul(t).redMul(this.z),
        o = a.redSub(r),
        i = n.redSub(s);
    if (0 === o.cmpn(0)) return 0 !== i.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
    var c = o.redSqr(),
        u = c.redMul(o),
        d = a.redMul(c),
        f = i.redSqr().redIAdd(u).redISub(d).redISub(d),
        l = i.redMul(d.redISub(f)).redISub(n.redMul(u)),
        h = this.z.redMul(o);
    return this.curve.jpoint(f, l, h);
  }, d.prototype.dblp = function (e) {
    if (0 === e) return this;
    if (this.isInfinity()) return this;
    if (!e) return this.dbl();

    if (this.curve.zeroA || this.curve.threeA) {
      for (var t = this, a = 0; a < e; a++) {
        t = t.dbl();
      }

      return t;
    }

    var r = this.curve.a,
        n = this.curve.tinv,
        s = this.x,
        o = this.y,
        i = this.z,
        c = i.redSqr().redSqr(),
        u = o.redAdd(o);

    for (a = 0; a < e; a++) {
      var d = s.redSqr(),
          f = u.redSqr(),
          l = f.redSqr(),
          h = d.redAdd(d).redIAdd(d).redIAdd(r.redMul(c)),
          p = s.redMul(f),
          b = h.redSqr().redISub(p.redAdd(p)),
          m = p.redISub(b),
          y = h.redMul(m);
      y = y.redIAdd(y).redISub(l);
      var v = u.redMul(i);
      a + 1 < e && (c = c.redMul(l)), s = b, i = v, u = y;
    }

    return this.curve.jpoint(s, u.redMul(n), i);
  }, d.prototype.dbl = function () {
    return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
  }, d.prototype._zeroDbl = function () {
    var e, t, a;

    if (this.zOne) {
      var r = this.x.redSqr(),
          n = this.y.redSqr(),
          s = n.redSqr(),
          o = this.x.redAdd(n).redSqr().redISub(r).redISub(s);
      o = o.redIAdd(o);
      var i = r.redAdd(r).redIAdd(r),
          c = i.redSqr().redISub(o).redISub(o),
          u = s.redIAdd(s);
      u = (u = u.redIAdd(u)).redIAdd(u), e = c, t = i.redMul(o.redISub(c)).redISub(u), a = this.y.redAdd(this.y);
    } else {
      var d = this.x.redSqr(),
          f = this.y.redSqr(),
          l = f.redSqr(),
          h = this.x.redAdd(f).redSqr().redISub(d).redISub(l);
      h = h.redIAdd(h);
      var p = d.redAdd(d).redIAdd(d),
          b = p.redSqr(),
          m = l.redIAdd(l);
      m = (m = m.redIAdd(m)).redIAdd(m), e = b.redISub(h).redISub(h), t = p.redMul(h.redISub(e)).redISub(m), a = (a = this.y.redMul(this.z)).redIAdd(a);
    }

    return this.curve.jpoint(e, t, a);
  }, d.prototype._threeDbl = function () {
    var e, t, a;

    if (this.zOne) {
      var r = this.x.redSqr(),
          n = this.y.redSqr(),
          s = n.redSqr(),
          o = this.x.redAdd(n).redSqr().redISub(r).redISub(s);
      o = o.redIAdd(o);
      var i = r.redAdd(r).redIAdd(r).redIAdd(this.curve.a),
          c = i.redSqr().redISub(o).redISub(o);
      e = c;
      var u = s.redIAdd(s);
      u = (u = u.redIAdd(u)).redIAdd(u), t = i.redMul(o.redISub(c)).redISub(u), a = this.y.redAdd(this.y);
    } else {
      var d = this.z.redSqr(),
          f = this.y.redSqr(),
          l = this.x.redMul(f),
          h = this.x.redSub(d).redMul(this.x.redAdd(d));
      h = h.redAdd(h).redIAdd(h);
      var p = l.redIAdd(l),
          b = (p = p.redIAdd(p)).redAdd(p);
      e = h.redSqr().redISub(b), a = this.y.redAdd(this.z).redSqr().redISub(f).redISub(d);
      var m = f.redSqr();
      m = (m = (m = m.redIAdd(m)).redIAdd(m)).redIAdd(m), t = h.redMul(p.redISub(e)).redISub(m);
    }

    return this.curve.jpoint(e, t, a);
  }, d.prototype._dbl = function () {
    var e = this.curve.a,
        t = this.x,
        a = this.y,
        r = this.z,
        n = r.redSqr().redSqr(),
        s = t.redSqr(),
        o = a.redSqr(),
        i = s.redAdd(s).redIAdd(s).redIAdd(e.redMul(n)),
        c = t.redAdd(t),
        u = (c = c.redIAdd(c)).redMul(o),
        d = i.redSqr().redISub(u.redAdd(u)),
        f = u.redISub(d),
        l = o.redSqr();
    l = (l = (l = l.redIAdd(l)).redIAdd(l)).redIAdd(l);
    var h = i.redMul(f).redISub(l),
        p = a.redAdd(a).redMul(r);
    return this.curve.jpoint(d, h, p);
  }, d.prototype.trpl = function () {
    if (!this.curve.zeroA) return this.dbl().add(this);
    var e = this.x.redSqr(),
        t = this.y.redSqr(),
        a = this.z.redSqr(),
        r = t.redSqr(),
        n = e.redAdd(e).redIAdd(e),
        s = n.redSqr(),
        o = this.x.redAdd(t).redSqr().redISub(e).redISub(r),
        i = (o = (o = (o = o.redIAdd(o)).redAdd(o).redIAdd(o)).redISub(s)).redSqr(),
        c = r.redIAdd(r);
    c = (c = (c = c.redIAdd(c)).redIAdd(c)).redIAdd(c);
    var u = n.redIAdd(o).redSqr().redISub(s).redISub(i).redISub(c),
        d = t.redMul(u);
    d = (d = d.redIAdd(d)).redIAdd(d);
    var f = this.x.redMul(i).redISub(d);
    f = (f = f.redIAdd(f)).redIAdd(f);
    var l = this.y.redMul(u.redMul(c.redISub(u)).redISub(o.redMul(i)));
    l = (l = (l = l.redIAdd(l)).redIAdd(l)).redIAdd(l);
    var h = this.z.redAdd(o).redSqr().redISub(a).redISub(i);
    return this.curve.jpoint(f, l, h);
  }, d.prototype.mul = function (e, t) {
    return e = new n(e, t), this.curve._wnafMul(this, e);
  }, d.prototype.eq = function (e) {
    if ("affine" === e.type) return this.eq(e.toJ());
    if (this === e) return !0;
    var t = this.z.redSqr(),
        a = e.z.redSqr();
    if (0 !== this.x.redMul(a).redISub(e.x.redMul(t)).cmpn(0)) return !1;
    var r = t.redMul(this.z),
        n = a.redMul(e.z);
    return 0 === this.y.redMul(n).redISub(e.y.redMul(r)).cmpn(0);
  }, d.prototype.eqXToP = function (e) {
    var t = this.z.redSqr(),
        a = e.toRed(this.curve.red).redMul(t);
    if (0 === this.x.cmp(a)) return !0;

    for (var r = e.clone(), n = this.curve.redN.redMul(t);;) {
      if (r.iadd(this.curve.n), r.cmp(this.curve.p) >= 0) return !1;
      if (a.redIAdd(n), 0 === this.x.cmp(a)) return !0;
    }
  }, d.prototype.inspect = function () {
    return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
  }, d.prototype.isInfinity = function () {
    return 0 === this.z.cmpn(0);
  };
},
/*!**********************************************************!*\
  !*** ./node_modules/elliptic/lib/elliptic/curve/mont.js ***!
  \**********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! bn.js */
  5),
      n = a(
  /*! inherits */
  3),
      s = a(
  /*! ./base */
  79),
      o = a(
  /*! ../utils */
  31);

  function i(e) {
    s.call(this, "mont", e), this.a = new r(e.a, 16).toRed(this.red), this.b = new r(e.b, 16).toRed(this.red), this.i4 = new r(4).toRed(this.red).redInvm(), this.two = new r(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
  }

  function c(e, t, a) {
    s.BasePoint.call(this, e, "projective"), null === t && null === a ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new r(t, 16), this.z = new r(a, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
  }

  n(i, s), e.exports = i, i.prototype.validate = function (e) {
    var t = e.normalize().x,
        a = t.redSqr(),
        r = a.redMul(t).redAdd(a.redMul(this.a)).redAdd(t);
    return 0 === r.redSqrt().redSqr().cmp(r);
  }, n(c, s.BasePoint), i.prototype.decodePoint = function (e, t) {
    return this.point(o.toArray(e, t), 1);
  }, i.prototype.point = function (e, t) {
    return new c(this, e, t);
  }, i.prototype.pointFromJSON = function (e) {
    return c.fromJSON(this, e);
  }, c.prototype.precompute = function () {}, c.prototype._encode = function () {
    return this.getX().toArray("be", this.curve.p.byteLength());
  }, c.fromJSON = function (e, t) {
    return new c(e, t[0], t[1] || e.one);
  }, c.prototype.inspect = function () {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, c.prototype.isInfinity = function () {
    return 0 === this.z.cmpn(0);
  }, c.prototype.dbl = function () {
    var e = this.x.redAdd(this.z).redSqr(),
        t = this.x.redSub(this.z).redSqr(),
        a = e.redSub(t),
        r = e.redMul(t),
        n = a.redMul(t.redAdd(this.curve.a24.redMul(a)));
    return this.curve.point(r, n);
  }, c.prototype.add = function () {
    throw new Error("Not supported on Montgomery curve");
  }, c.prototype.diffAdd = function (e, t) {
    var a = this.x.redAdd(this.z),
        r = this.x.redSub(this.z),
        n = e.x.redAdd(e.z),
        s = e.x.redSub(e.z).redMul(a),
        o = n.redMul(r),
        i = t.z.redMul(s.redAdd(o).redSqr()),
        c = t.x.redMul(s.redISub(o).redSqr());
    return this.curve.point(i, c);
  }, c.prototype.mul = function (e) {
    for (var t = e.clone(), a = this, r = this.curve.point(null, null), n = []; 0 !== t.cmpn(0); t.iushrn(1)) {
      n.push(t.andln(1));
    }

    for (var s = n.length - 1; s >= 0; s--) {
      0 === n[s] ? (a = a.diffAdd(r, this), r = r.dbl()) : (r = a.diffAdd(r, this), a = a.dbl());
    }

    return r;
  }, c.prototype.mulAdd = function () {
    throw new Error("Not supported on Montgomery curve");
  }, c.prototype.jumlAdd = function () {
    throw new Error("Not supported on Montgomery curve");
  }, c.prototype.eq = function (e) {
    return 0 === this.getX().cmp(e.getX());
  }, c.prototype.normalize = function () {
    return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
  }, c.prototype.getX = function () {
    return this.normalize(), this.x.fromRed();
  };
},
/*!*************************************************************!*\
  !*** ./node_modules/elliptic/lib/elliptic/curve/edwards.js ***!
  \*************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ../utils */
  31),
      n = a(
  /*! bn.js */
  5),
      s = a(
  /*! inherits */
  3),
      o = a(
  /*! ./base */
  79),
      i = r.assert;

  function c(e) {
    this.twisted = 1 != (0 | e.a), this.mOneA = this.twisted && -1 == (0 | e.a), this.extended = this.mOneA, o.call(this, "edwards", e), this.a = new n(e.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new n(e.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new n(e.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), i(!this.twisted || 0 === this.c.fromRed().cmpn(1)), this.oneC = 1 == (0 | e.c);
  }

  function u(e, t, a, r, s) {
    o.BasePoint.call(this, e, "projective"), null === t && null === a && null === r ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new n(t, 16), this.y = new n(a, 16), this.z = r ? new n(r, 16) : this.curve.one, this.t = s && new n(s, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
  }

  s(c, o), e.exports = c, c.prototype._mulA = function (e) {
    return this.mOneA ? e.redNeg() : this.a.redMul(e);
  }, c.prototype._mulC = function (e) {
    return this.oneC ? e : this.c.redMul(e);
  }, c.prototype.jpoint = function (e, t, a, r) {
    return this.point(e, t, a, r);
  }, c.prototype.pointFromX = function (e, t) {
    (e = new n(e, 16)).red || (e = e.toRed(this.red));
    var a = e.redSqr(),
        r = this.c2.redSub(this.a.redMul(a)),
        s = this.one.redSub(this.c2.redMul(this.d).redMul(a)),
        o = r.redMul(s.redInvm()),
        i = o.redSqrt();
    if (0 !== i.redSqr().redSub(o).cmp(this.zero)) throw new Error("invalid point");
    var c = i.fromRed().isOdd();
    return (t && !c || !t && c) && (i = i.redNeg()), this.point(e, i);
  }, c.prototype.pointFromY = function (e, t) {
    (e = new n(e, 16)).red || (e = e.toRed(this.red));
    var a = e.redSqr(),
        r = a.redSub(this.c2),
        s = a.redMul(this.d).redMul(this.c2).redSub(this.a),
        o = r.redMul(s.redInvm());

    if (0 === o.cmp(this.zero)) {
      if (t) throw new Error("invalid point");
      return this.point(this.zero, e);
    }

    var i = o.redSqrt();
    if (0 !== i.redSqr().redSub(o).cmp(this.zero)) throw new Error("invalid point");
    return i.fromRed().isOdd() !== t && (i = i.redNeg()), this.point(i, e);
  }, c.prototype.validate = function (e) {
    if (e.isInfinity()) return !0;
    e.normalize();
    var t = e.x.redSqr(),
        a = e.y.redSqr(),
        r = t.redMul(this.a).redAdd(a),
        n = this.c2.redMul(this.one.redAdd(this.d.redMul(t).redMul(a)));
    return 0 === r.cmp(n);
  }, s(u, o.BasePoint), c.prototype.pointFromJSON = function (e) {
    return u.fromJSON(this, e);
  }, c.prototype.point = function (e, t, a, r) {
    return new u(this, e, t, a, r);
  }, u.fromJSON = function (e, t) {
    return new u(e, t[0], t[1], t[2]);
  }, u.prototype.inspect = function () {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, u.prototype.isInfinity = function () {
    return 0 === this.x.cmpn(0) && (0 === this.y.cmp(this.z) || this.zOne && 0 === this.y.cmp(this.curve.c));
  }, u.prototype._extDbl = function () {
    var e = this.x.redSqr(),
        t = this.y.redSqr(),
        a = this.z.redSqr();
    a = a.redIAdd(a);

    var r = this.curve._mulA(e),
        n = this.x.redAdd(this.y).redSqr().redISub(e).redISub(t),
        s = r.redAdd(t),
        o = s.redSub(a),
        i = r.redSub(t),
        c = n.redMul(o),
        u = s.redMul(i),
        d = n.redMul(i),
        f = o.redMul(s);

    return this.curve.point(c, u, f, d);
  }, u.prototype._projDbl = function () {
    var e,
        t,
        a,
        r = this.x.redAdd(this.y).redSqr(),
        n = this.x.redSqr(),
        s = this.y.redSqr();

    if (this.curve.twisted) {
      var o = (u = this.curve._mulA(n)).redAdd(s);

      if (this.zOne) e = r.redSub(n).redSub(s).redMul(o.redSub(this.curve.two)), t = o.redMul(u.redSub(s)), a = o.redSqr().redSub(o).redSub(o);else {
        var i = this.z.redSqr(),
            c = o.redSub(i).redISub(i);
        e = r.redSub(n).redISub(s).redMul(c), t = o.redMul(u.redSub(s)), a = o.redMul(c);
      }
    } else {
      var u = n.redAdd(s);
      i = this.curve._mulC(this.z).redSqr(), c = u.redSub(i).redSub(i);
      e = this.curve._mulC(r.redISub(u)).redMul(c), t = this.curve._mulC(u).redMul(n.redISub(s)), a = u.redMul(c);
    }

    return this.curve.point(e, t, a);
  }, u.prototype.dbl = function () {
    return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
  }, u.prototype._extAdd = function (e) {
    var t = this.y.redSub(this.x).redMul(e.y.redSub(e.x)),
        a = this.y.redAdd(this.x).redMul(e.y.redAdd(e.x)),
        r = this.t.redMul(this.curve.dd).redMul(e.t),
        n = this.z.redMul(e.z.redAdd(e.z)),
        s = a.redSub(t),
        o = n.redSub(r),
        i = n.redAdd(r),
        c = a.redAdd(t),
        u = s.redMul(o),
        d = i.redMul(c),
        f = s.redMul(c),
        l = o.redMul(i);
    return this.curve.point(u, d, l, f);
  }, u.prototype._projAdd = function (e) {
    var t,
        a,
        r = this.z.redMul(e.z),
        n = r.redSqr(),
        s = this.x.redMul(e.x),
        o = this.y.redMul(e.y),
        i = this.curve.d.redMul(s).redMul(o),
        c = n.redSub(i),
        u = n.redAdd(i),
        d = this.x.redAdd(this.y).redMul(e.x.redAdd(e.y)).redISub(s).redISub(o),
        f = r.redMul(c).redMul(d);
    return this.curve.twisted ? (t = r.redMul(u).redMul(o.redSub(this.curve._mulA(s))), a = c.redMul(u)) : (t = r.redMul(u).redMul(o.redSub(s)), a = this.curve._mulC(c).redMul(u)), this.curve.point(f, t, a);
  }, u.prototype.add = function (e) {
    return this.isInfinity() ? e : e.isInfinity() ? this : this.curve.extended ? this._extAdd(e) : this._projAdd(e);
  }, u.prototype.mul = function (e) {
    return this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve._wnafMul(this, e);
  }, u.prototype.mulAdd = function (e, t, a) {
    return this.curve._wnafMulAdd(1, [this, t], [e, a], 2, !1);
  }, u.prototype.jmulAdd = function (e, t, a) {
    return this.curve._wnafMulAdd(1, [this, t], [e, a], 2, !0);
  }, u.prototype.normalize = function () {
    if (this.zOne) return this;
    var e = this.z.redInvm();
    return this.x = this.x.redMul(e), this.y = this.y.redMul(e), this.t && (this.t = this.t.redMul(e)), this.z = this.curve.one, this.zOne = !0, this;
  }, u.prototype.neg = function () {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
  }, u.prototype.getX = function () {
    return this.normalize(), this.x.fromRed();
  }, u.prototype.getY = function () {
    return this.normalize(), this.y.fromRed();
  }, u.prototype.eq = function (e) {
    return this === e || 0 === this.getX().cmp(e.getX()) && 0 === this.getY().cmp(e.getY());
  }, u.prototype.eqXToP = function (e) {
    var t = e.toRed(this.curve.red).redMul(this.z);
    if (0 === this.x.cmp(t)) return !0;

    for (var a = e.clone(), r = this.curve.redN.redMul(this.z);;) {
      if (a.iadd(this.curve.n), a.cmp(this.curve.p) >= 0) return !1;
      if (t.redIAdd(r), 0 === this.x.cmp(t)) return !0;
    }
  }, u.prototype.toP = u.prototype.normalize, u.prototype.mixedAdd = u.prototype.add;
},
/*!********************************************************************!*\
  !*** ./node_modules/elliptic/node_modules/hash.js/lib/hash/sha.js ***!
  \********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  t.sha1 = a(
  /*! ./sha/1 */
  407), t.sha224 = a(
  /*! ./sha/224 */
  408), t.sha256 = a(
  /*! ./sha/256 */
  165), t.sha384 = a(
  /*! ./sha/384 */
  409), t.sha512 = a(
  /*! ./sha/512 */
  166);
},
/*!**********************************************************************!*\
  !*** ./node_modules/elliptic/node_modules/hash.js/lib/hash/sha/1.js ***!
  \**********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ../utils */
  34),
      n = a(
  /*! ../common */
  70),
      s = a(
  /*! ./common */
  164),
      o = r.rotl32,
      i = r.sum32,
      c = r.sum32_5,
      u = s.ft_1,
      d = n.BlockHash,
      f = [1518500249, 1859775393, 2400959708, 3395469782];

  function l() {
    if (!(this instanceof l)) return new l();
    d.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.W = new Array(80);
  }

  r.inherits(l, d), e.exports = l, l.blockSize = 512, l.outSize = 160, l.hmacStrength = 80, l.padLength = 64, l.prototype._update = function (e, t) {
    for (var a = this.W, r = 0; r < 16; r++) {
      a[r] = e[t + r];
    }

    for (; r < a.length; r++) {
      a[r] = o(a[r - 3] ^ a[r - 8] ^ a[r - 14] ^ a[r - 16], 1);
    }

    var n = this.h[0],
        s = this.h[1],
        d = this.h[2],
        l = this.h[3],
        h = this.h[4];

    for (r = 0; r < a.length; r++) {
      var p = ~~(r / 20),
          b = c(o(n, 5), u(p, s, d, l), h, a[r], f[p]);
      h = l, l = d, d = o(s, 30), s = n, n = b;
    }

    this.h[0] = i(this.h[0], n), this.h[1] = i(this.h[1], s), this.h[2] = i(this.h[2], d), this.h[3] = i(this.h[3], l), this.h[4] = i(this.h[4], h);
  }, l.prototype._digest = function (e) {
    return "hex" === e ? r.toHex32(this.h, "big") : r.split32(this.h, "big");
  };
},
/*!************************************************************************!*\
  !*** ./node_modules/elliptic/node_modules/hash.js/lib/hash/sha/224.js ***!
  \************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ../utils */
  34),
      n = a(
  /*! ./256 */
  165);

  function s() {
    if (!(this instanceof s)) return new s();
    n.call(this), this.h = [3238371032, 914150663, 812702999, 4144912697, 4290775857, 1750603025, 1694076839, 3204075428];
  }

  r.inherits(s, n), e.exports = s, s.blockSize = 512, s.outSize = 224, s.hmacStrength = 192, s.padLength = 64, s.prototype._digest = function (e) {
    return "hex" === e ? r.toHex32(this.h.slice(0, 7), "big") : r.split32(this.h.slice(0, 7), "big");
  };
},
/*!************************************************************************!*\
  !*** ./node_modules/elliptic/node_modules/hash.js/lib/hash/sha/384.js ***!
  \************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ../utils */
  34),
      n = a(
  /*! ./512 */
  166);

  function s() {
    if (!(this instanceof s)) return new s();
    n.call(this), this.h = [3418070365, 3238371032, 1654270250, 914150663, 2438529370, 812702999, 355462360, 4144912697, 1731405415, 4290775857, 2394180231, 1750603025, 3675008525, 1694076839, 1203062813, 3204075428];
  }

  r.inherits(s, n), e.exports = s, s.blockSize = 1024, s.outSize = 384, s.hmacStrength = 192, s.padLength = 128, s.prototype._digest = function (e) {
    return "hex" === e ? r.toHex32(this.h.slice(0, 12), "big") : r.split32(this.h.slice(0, 12), "big");
  };
},
/*!***********************************************************************!*\
  !*** ./node_modules/elliptic/node_modules/hash.js/lib/hash/ripemd.js ***!
  \***********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ./utils */
  34),
      n = a(
  /*! ./common */
  70),
      s = r.rotl32,
      o = r.sum32,
      i = r.sum32_3,
      c = r.sum32_4,
      u = n.BlockHash;

  function d() {
    if (!(this instanceof d)) return new d();
    u.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
  }

  function f(e, t, a, r) {
    return e <= 15 ? t ^ a ^ r : e <= 31 ? t & a | ~t & r : e <= 47 ? (t | ~a) ^ r : e <= 63 ? t & r | a & ~r : t ^ (a | ~r);
  }

  function l(e) {
    return e <= 15 ? 0 : e <= 31 ? 1518500249 : e <= 47 ? 1859775393 : e <= 63 ? 2400959708 : 2840853838;
  }

  function h(e) {
    return e <= 15 ? 1352829926 : e <= 31 ? 1548603684 : e <= 47 ? 1836072691 : e <= 63 ? 2053994217 : 0;
  }

  r.inherits(d, u), t.ripemd160 = d, d.blockSize = 512, d.outSize = 160, d.hmacStrength = 192, d.padLength = 64, d.prototype._update = function (e, t) {
    for (var a = this.h[0], r = this.h[1], n = this.h[2], u = this.h[3], d = this.h[4], v = a, _ = r, g = n, A = u, w = d, T = 0; T < 80; T++) {
      var x = o(s(c(a, f(T, r, n, u), e[p[T] + t], l(T)), m[T]), d);
      a = d, d = u, u = s(n, 10), n = r, r = x, x = o(s(c(v, f(79 - T, _, g, A), e[b[T] + t], h(T)), y[T]), w), v = w, w = A, A = s(g, 10), g = _, _ = x;
    }

    x = i(this.h[1], n, A), this.h[1] = i(this.h[2], u, w), this.h[2] = i(this.h[3], d, v), this.h[3] = i(this.h[4], a, _), this.h[4] = i(this.h[0], r, g), this.h[0] = x;
  }, d.prototype._digest = function (e) {
    return "hex" === e ? r.toHex32(this.h, "little") : r.split32(this.h, "little");
  };
  var p = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13],
      b = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11],
      m = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6],
      y = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11];
},
/*!*********************************************************************!*\
  !*** ./node_modules/elliptic/node_modules/hash.js/lib/hash/hmac.js ***!
  \*********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ./utils */
  34),
      n = a(
  /*! minimalistic-assert */
  22);

  function s(e, t, a) {
    if (!(this instanceof s)) return new s(e, t, a);
    this.Hash = e, this.blockSize = e.blockSize / 8, this.outSize = e.outSize / 8, this.inner = null, this.outer = null, this._init(r.toArray(t, a));
  }

  e.exports = s, s.prototype._init = function (e) {
    e.length > this.blockSize && (e = new this.Hash().update(e).digest()), n(e.length <= this.blockSize);

    for (var t = e.length; t < this.blockSize; t++) {
      e.push(0);
    }

    for (t = 0; t < e.length; t++) {
      e[t] ^= 54;
    }

    for (this.inner = new this.Hash().update(e), t = 0; t < e.length; t++) {
      e[t] ^= 106;
    }

    this.outer = new this.Hash().update(e);
  }, s.prototype.update = function (e, t) {
    return this.inner.update(e, t), this;
  }, s.prototype.digest = function (e) {
    return this.outer.update(this.inner.digest()), this.outer.digest(e);
  };
},
/*!*********************************************************************!*\
  !*** ./node_modules/elliptic/lib/elliptic/precomputed/secp256k1.js ***!
  \*********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = {
    doubles: {
      step: 4,
      points: [["e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a", "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"], ["8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508", "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"], ["175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739", "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"], ["363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640", "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"], ["8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c", "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"], ["723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda", "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"], ["eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa", "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"], ["100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0", "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"], ["e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d", "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"], ["feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d", "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"], ["da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1", "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"], ["53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0", "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"], ["8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047", "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"], ["385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862", "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"], ["6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7", "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"], ["3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd", "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"], ["85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83", "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"], ["948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a", "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"], ["6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8", "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"], ["e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d", "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"], ["e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725", "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"], ["213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754", "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"], ["4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c", "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"], ["fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6", "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"], ["76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39", "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"], ["c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891", "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"], ["d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b", "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"], ["b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03", "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"], ["e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d", "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"], ["a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070", "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"], ["90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4", "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"], ["8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da", "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"], ["e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11", "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"], ["8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e", "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"], ["e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41", "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"], ["b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef", "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"], ["d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8", "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"], ["324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d", "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"], ["4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96", "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"], ["9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd", "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"], ["6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5", "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"], ["a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266", "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"], ["7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71", "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"], ["928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac", "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"], ["85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751", "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"], ["ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e", "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"], ["827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241", "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"], ["eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3", "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"], ["e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f", "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"], ["1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19", "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"], ["146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be", "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"], ["fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9", "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"], ["da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2", "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"], ["a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13", "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"], ["174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c", "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"], ["959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba", "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"], ["d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151", "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"], ["64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073", "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"], ["8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458", "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"], ["13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b", "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"], ["bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366", "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"], ["8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa", "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"], ["8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0", "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"], ["dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787", "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"], ["f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e", "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"]]
    },
    naf: {
      wnd: 7,
      points: [["f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9", "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"], ["2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4", "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"], ["5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc", "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"], ["acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe", "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"], ["774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb", "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"], ["f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8", "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"], ["d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e", "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"], ["defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34", "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"], ["2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c", "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"], ["352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5", "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"], ["2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f", "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"], ["9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714", "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"], ["daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729", "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"], ["c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db", "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"], ["6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4", "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"], ["1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5", "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"], ["605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479", "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"], ["62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d", "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"], ["80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f", "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"], ["7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb", "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"], ["d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9", "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"], ["49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963", "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"], ["77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74", "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"], ["f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530", "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"], ["463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b", "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"], ["f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247", "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"], ["caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1", "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"], ["2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120", "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"], ["7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435", "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"], ["754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18", "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"], ["e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8", "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"], ["186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb", "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"], ["df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f", "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"], ["5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143", "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"], ["290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba", "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"], ["af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45", "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"], ["766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a", "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"], ["59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e", "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"], ["f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8", "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"], ["7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c", "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"], ["948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519", "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"], ["7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab", "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"], ["3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca", "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"], ["d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf", "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"], ["1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610", "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"], ["733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4", "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"], ["15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c", "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"], ["a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940", "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"], ["e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980", "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"], ["311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3", "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"], ["34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf", "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"], ["f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63", "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"], ["d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448", "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"], ["32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf", "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"], ["7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5", "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"], ["ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6", "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"], ["16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5", "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"], ["eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99", "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"], ["78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51", "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"], ["494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5", "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"], ["a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5", "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"], ["c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997", "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"], ["841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881", "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"], ["5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5", "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"], ["36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66", "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"], ["336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726", "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"], ["8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede", "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"], ["1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94", "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"], ["85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31", "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"], ["29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51", "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"], ["a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252", "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"], ["4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5", "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"], ["d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b", "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"], ["ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4", "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"], ["af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f", "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"], ["e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889", "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"], ["591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246", "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"], ["11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984", "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"], ["3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a", "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"], ["cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030", "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"], ["c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197", "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"], ["c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593", "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"], ["a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef", "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"], ["347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38", "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"], ["da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a", "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"], ["c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111", "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"], ["4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502", "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"], ["3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea", "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"], ["cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26", "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"], ["b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986", "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"], ["d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e", "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"], ["48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4", "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"], ["dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda", "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"], ["6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859", "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"], ["e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f", "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"], ["eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c", "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"], ["13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942", "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"], ["ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a", "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"], ["b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80", "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"], ["ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d", "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"], ["8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1", "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"], ["52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63", "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"], ["e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352", "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"], ["7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193", "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"], ["5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00", "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"], ["32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58", "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"], ["e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7", "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"], ["8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8", "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"], ["4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e", "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"], ["3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d", "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"], ["674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b", "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"], ["d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f", "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"], ["30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6", "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"], ["be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297", "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"], ["93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a", "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"], ["b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c", "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"], ["d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52", "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"], ["d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb", "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"], ["463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065", "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"], ["7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917", "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"], ["74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9", "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"], ["30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3", "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"], ["9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57", "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"], ["176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66", "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"], ["75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8", "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"], ["809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721", "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"], ["1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180", "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"]]
    }
  };
},
/*!********************************************************!*\
  !*** ./node_modules/elliptic/lib/elliptic/ec/index.js ***!
  \********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! bn.js */
  5),
      n = a(
  /*! hmac-drbg */
  414),
      s = a(
  /*! ../utils */
  31),
      o = a(
  /*! ../curves */
  102),
      i = a(
  /*! brorand */
  101),
      c = s.assert,
      u = a(
  /*! ./key */
  422),
      d = a(
  /*! ./signature */
  423);

  function f(e) {
    if (!(this instanceof f)) return new f(e);
    "string" == typeof e && (c(o.hasOwnProperty(e), "Unknown curve " + e), e = o[e]), e instanceof o.PresetCurve && (e = {
      curve: e
    }), this.curve = e.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = e.curve.g, this.g.precompute(e.curve.n.bitLength() + 1), this.hash = e.hash || e.curve.hash;
  }

  e.exports = f, f.prototype.keyPair = function (e) {
    return new u(this, e);
  }, f.prototype.keyFromPrivate = function (e, t) {
    return u.fromPrivate(this, e, t);
  }, f.prototype.keyFromPublic = function (e, t) {
    return u.fromPublic(this, e, t);
  }, f.prototype.genKeyPair = function (e) {
    e || (e = {});

    for (var t = new n({
      hash: this.hash,
      pers: e.pers,
      persEnc: e.persEnc || "utf8",
      entropy: e.entropy || i(this.hash.hmacStrength),
      entropyEnc: e.entropy && e.entropyEnc || "utf8",
      nonce: this.n.toArray()
    }), a = this.n.byteLength(), s = this.n.sub(new r(2));;) {
      var o = new r(t.generate(a));
      if (!(o.cmp(s) > 0)) return o.iaddn(1), this.keyFromPrivate(o);
    }
  }, f.prototype._truncateToN = function (e, t) {
    var a = 8 * e.byteLength() - this.n.bitLength();
    return a > 0 && (e = e.ushrn(a)), !t && e.cmp(this.n) >= 0 ? e.sub(this.n) : e;
  }, f.prototype.sign = function (e, t, a, s) {
    "object" == typeof a && (s = a, a = null), s || (s = {}), t = this.keyFromPrivate(t, a), e = this._truncateToN(new r(e, 16));

    for (var o = this.n.byteLength(), i = t.getPrivate().toArray("be", o), c = e.toArray("be", o), u = new n({
      hash: this.hash,
      entropy: i,
      nonce: c,
      pers: s.pers,
      persEnc: s.persEnc || "utf8"
    }), f = this.n.sub(new r(1)), l = 0;; l++) {
      var h = s.k ? s.k(l) : new r(u.generate(this.n.byteLength()));

      if (!((h = this._truncateToN(h, !0)).cmpn(1) <= 0 || h.cmp(f) >= 0)) {
        var p = this.g.mul(h);

        if (!p.isInfinity()) {
          var b = p.getX(),
              m = b.umod(this.n);

          if (0 !== m.cmpn(0)) {
            var y = h.invm(this.n).mul(m.mul(t.getPrivate()).iadd(e));

            if (0 !== (y = y.umod(this.n)).cmpn(0)) {
              var v = (p.getY().isOdd() ? 1 : 0) | (0 !== b.cmp(m) ? 2 : 0);
              return s.canonical && y.cmp(this.nh) > 0 && (y = this.n.sub(y), v ^= 1), new d({
                r: m,
                s: y,
                recoveryParam: v
              });
            }
          }
        }
      }
    }
  }, f.prototype.verify = function (e, t, a, n) {
    e = this._truncateToN(new r(e, 16)), a = this.keyFromPublic(a, n);
    var s = (t = new d(t, "hex")).r,
        o = t.s;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return !1;
    if (o.cmpn(1) < 0 || o.cmp(this.n) >= 0) return !1;
    var i,
        c = o.invm(this.n),
        u = c.mul(e).umod(this.n),
        f = c.mul(s).umod(this.n);
    return this.curve._maxwellTrick ? !(i = this.g.jmulAdd(u, a.getPublic(), f)).isInfinity() && i.eqXToP(s) : !(i = this.g.mulAdd(u, a.getPublic(), f)).isInfinity() && 0 === i.getX().umod(this.n).cmp(s);
  }, f.prototype.recoverPubKey = function (e, t, a, n) {
    c((3 & a) === a, "The recovery param is more than two bits"), t = new d(t, n);
    var s = this.n,
        o = new r(e),
        i = t.r,
        u = t.s,
        f = 1 & a,
        l = a >> 1;
    if (i.cmp(this.curve.p.umod(this.curve.n)) >= 0 && l) throw new Error("Unable to find sencond key candinate");
    i = l ? this.curve.pointFromX(i.add(this.curve.n), f) : this.curve.pointFromX(i, f);
    var h = t.r.invm(s),
        p = s.sub(o).mul(h).umod(s),
        b = u.mul(h).umod(s);
    return this.g.mulAdd(p, i, b);
  }, f.prototype.getKeyRecoveryParam = function (e, t, a, r) {
    if (null !== (t = new d(t, r)).recoveryParam) return t.recoveryParam;

    for (var n = 0; n < 4; n++) {
      var s;

      try {
        s = this.recoverPubKey(e, t, n);
      } catch (e) {
        continue;
      }

      if (s.eq(a)) return n;
    }

    throw new Error("Unable to find valid recovery factor");
  };
},
/*!*************************************************!*\
  !*** ./node_modules/hmac-drbg/lib/hmac-drbg.js ***!
  \*************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! hash.js */
  415),
      n = a(
  /*! minimalistic-crypto-utils */
  161),
      s = a(
  /*! minimalistic-assert */
  22);

  function o(e) {
    if (!(this instanceof o)) return new o(e);
    this.hash = e.hash, this.predResist = !!e.predResist, this.outLen = this.hash.outSize, this.minEntropy = e.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
    var t = n.toArray(e.entropy, e.entropyEnc || "hex"),
        a = n.toArray(e.nonce, e.nonceEnc || "hex"),
        r = n.toArray(e.pers, e.persEnc || "hex");
    s(t.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._init(t, a, r);
  }

  e.exports = o, o.prototype._init = function (e, t, a) {
    var r = e.concat(t).concat(a);
    this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);

    for (var n = 0; n < this.V.length; n++) {
      this.K[n] = 0, this.V[n] = 1;
    }

    this._update(r), this._reseed = 1, this.reseedInterval = 281474976710656;
  }, o.prototype._hmac = function () {
    return new r.hmac(this.hash, this.K);
  }, o.prototype._update = function (e) {
    var t = this._hmac().update(this.V).update([0]);

    e && (t = t.update(e)), this.K = t.digest(), this.V = this._hmac().update(this.V).digest(), e && (this.K = this._hmac().update(this.V).update([1]).update(e).digest(), this.V = this._hmac().update(this.V).digest());
  }, o.prototype.reseed = function (e, t, a, r) {
    "string" != typeof t && (r = a, a = t, t = null), e = n.toArray(e, t), a = n.toArray(a, r), s(e.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._update(e.concat(a || [])), this._reseed = 1;
  }, o.prototype.generate = function (e, t, a, r) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    "string" != typeof t && (r = a, a = t, t = null), a && (a = n.toArray(a, r || "hex"), this._update(a));

    for (var s = []; s.length < e;) {
      this.V = this._hmac().update(this.V).digest(), s = s.concat(this.V);
    }

    var o = s.slice(0, e);
    return this._update(a), this._reseed++, n.encode(o, t);
  };
},
/*!*****************************************************************!*\
  !*** ./node_modules/hmac-drbg/node_modules/hash.js/lib/hash.js ***!
  \*****************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = t;
  r.utils = a(
  /*! ./hash/utils */
  35), r.common = a(
  /*! ./hash/common */
  71), r.sha = a(
  /*! ./hash/sha */
  416), r.ripemd = a(
  /*! ./hash/ripemd */
  420), r.hmac = a(
  /*! ./hash/hmac */
  421), r.sha1 = r.sha.sha1, r.sha256 = r.sha.sha256, r.sha224 = r.sha.sha224, r.sha384 = r.sha.sha384, r.sha512 = r.sha.sha512, r.ripemd160 = r.ripemd.ripemd160;
},
/*!*********************************************************************!*\
  !*** ./node_modules/hmac-drbg/node_modules/hash.js/lib/hash/sha.js ***!
  \*********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  t.sha1 = a(
  /*! ./sha/1 */
  417), t.sha224 = a(
  /*! ./sha/224 */
  418), t.sha256 = a(
  /*! ./sha/256 */
  168), t.sha384 = a(
  /*! ./sha/384 */
  419), t.sha512 = a(
  /*! ./sha/512 */
  169);
},
/*!***********************************************************************!*\
  !*** ./node_modules/hmac-drbg/node_modules/hash.js/lib/hash/sha/1.js ***!
  \***********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ../utils */
  35),
      n = a(
  /*! ../common */
  71),
      s = a(
  /*! ./common */
  167),
      o = r.rotl32,
      i = r.sum32,
      c = r.sum32_5,
      u = s.ft_1,
      d = n.BlockHash,
      f = [1518500249, 1859775393, 2400959708, 3395469782];

  function l() {
    if (!(this instanceof l)) return new l();
    d.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.W = new Array(80);
  }

  r.inherits(l, d), e.exports = l, l.blockSize = 512, l.outSize = 160, l.hmacStrength = 80, l.padLength = 64, l.prototype._update = function (e, t) {
    for (var a = this.W, r = 0; r < 16; r++) {
      a[r] = e[t + r];
    }

    for (; r < a.length; r++) {
      a[r] = o(a[r - 3] ^ a[r - 8] ^ a[r - 14] ^ a[r - 16], 1);
    }

    var n = this.h[0],
        s = this.h[1],
        d = this.h[2],
        l = this.h[3],
        h = this.h[4];

    for (r = 0; r < a.length; r++) {
      var p = ~~(r / 20),
          b = c(o(n, 5), u(p, s, d, l), h, a[r], f[p]);
      h = l, l = d, d = o(s, 30), s = n, n = b;
    }

    this.h[0] = i(this.h[0], n), this.h[1] = i(this.h[1], s), this.h[2] = i(this.h[2], d), this.h[3] = i(this.h[3], l), this.h[4] = i(this.h[4], h);
  }, l.prototype._digest = function (e) {
    return "hex" === e ? r.toHex32(this.h, "big") : r.split32(this.h, "big");
  };
},
/*!*************************************************************************!*\
  !*** ./node_modules/hmac-drbg/node_modules/hash.js/lib/hash/sha/224.js ***!
  \*************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ../utils */
  35),
      n = a(
  /*! ./256 */
  168);

  function s() {
    if (!(this instanceof s)) return new s();
    n.call(this), this.h = [3238371032, 914150663, 812702999, 4144912697, 4290775857, 1750603025, 1694076839, 3204075428];
  }

  r.inherits(s, n), e.exports = s, s.blockSize = 512, s.outSize = 224, s.hmacStrength = 192, s.padLength = 64, s.prototype._digest = function (e) {
    return "hex" === e ? r.toHex32(this.h.slice(0, 7), "big") : r.split32(this.h.slice(0, 7), "big");
  };
},
/*!*************************************************************************!*\
  !*** ./node_modules/hmac-drbg/node_modules/hash.js/lib/hash/sha/384.js ***!
  \*************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ../utils */
  35),
      n = a(
  /*! ./512 */
  169);

  function s() {
    if (!(this instanceof s)) return new s();
    n.call(this), this.h = [3418070365, 3238371032, 1654270250, 914150663, 2438529370, 812702999, 355462360, 4144912697, 1731405415, 4290775857, 2394180231, 1750603025, 3675008525, 1694076839, 1203062813, 3204075428];
  }

  r.inherits(s, n), e.exports = s, s.blockSize = 1024, s.outSize = 384, s.hmacStrength = 192, s.padLength = 128, s.prototype._digest = function (e) {
    return "hex" === e ? r.toHex32(this.h.slice(0, 12), "big") : r.split32(this.h.slice(0, 12), "big");
  };
},
/*!************************************************************************!*\
  !*** ./node_modules/hmac-drbg/node_modules/hash.js/lib/hash/ripemd.js ***!
  \************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ./utils */
  35),
      n = a(
  /*! ./common */
  71),
      s = r.rotl32,
      o = r.sum32,
      i = r.sum32_3,
      c = r.sum32_4,
      u = n.BlockHash;

  function d() {
    if (!(this instanceof d)) return new d();
    u.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
  }

  function f(e, t, a, r) {
    return e <= 15 ? t ^ a ^ r : e <= 31 ? t & a | ~t & r : e <= 47 ? (t | ~a) ^ r : e <= 63 ? t & r | a & ~r : t ^ (a | ~r);
  }

  function l(e) {
    return e <= 15 ? 0 : e <= 31 ? 1518500249 : e <= 47 ? 1859775393 : e <= 63 ? 2400959708 : 2840853838;
  }

  function h(e) {
    return e <= 15 ? 1352829926 : e <= 31 ? 1548603684 : e <= 47 ? 1836072691 : e <= 63 ? 2053994217 : 0;
  }

  r.inherits(d, u), t.ripemd160 = d, d.blockSize = 512, d.outSize = 160, d.hmacStrength = 192, d.padLength = 64, d.prototype._update = function (e, t) {
    for (var a = this.h[0], r = this.h[1], n = this.h[2], u = this.h[3], d = this.h[4], v = a, _ = r, g = n, A = u, w = d, T = 0; T < 80; T++) {
      var x = o(s(c(a, f(T, r, n, u), e[p[T] + t], l(T)), m[T]), d);
      a = d, d = u, u = s(n, 10), n = r, r = x, x = o(s(c(v, f(79 - T, _, g, A), e[b[T] + t], h(T)), y[T]), w), v = w, w = A, A = s(g, 10), g = _, _ = x;
    }

    x = i(this.h[1], n, A), this.h[1] = i(this.h[2], u, w), this.h[2] = i(this.h[3], d, v), this.h[3] = i(this.h[4], a, _), this.h[4] = i(this.h[0], r, g), this.h[0] = x;
  }, d.prototype._digest = function (e) {
    return "hex" === e ? r.toHex32(this.h, "little") : r.split32(this.h, "little");
  };
  var p = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13],
      b = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11],
      m = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6],
      y = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11];
},
/*!**********************************************************************!*\
  !*** ./node_modules/hmac-drbg/node_modules/hash.js/lib/hash/hmac.js ***!
  \**********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ./utils */
  35),
      n = a(
  /*! minimalistic-assert */
  22);

  function s(e, t, a) {
    if (!(this instanceof s)) return new s(e, t, a);
    this.Hash = e, this.blockSize = e.blockSize / 8, this.outSize = e.outSize / 8, this.inner = null, this.outer = null, this._init(r.toArray(t, a));
  }

  e.exports = s, s.prototype._init = function (e) {
    e.length > this.blockSize && (e = new this.Hash().update(e).digest()), n(e.length <= this.blockSize);

    for (var t = e.length; t < this.blockSize; t++) {
      e.push(0);
    }

    for (t = 0; t < e.length; t++) {
      e[t] ^= 54;
    }

    for (this.inner = new this.Hash().update(e), t = 0; t < e.length; t++) {
      e[t] ^= 106;
    }

    this.outer = new this.Hash().update(e);
  }, s.prototype.update = function (e, t) {
    return this.inner.update(e, t), this;
  }, s.prototype.digest = function (e) {
    return this.outer.update(this.inner.digest()), this.outer.digest(e);
  };
},
/*!******************************************************!*\
  !*** ./node_modules/elliptic/lib/elliptic/ec/key.js ***!
  \******************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! bn.js */
  5),
      n = a(
  /*! ../utils */
  31).assert;

  function s(e, t) {
    this.ec = e, this.priv = null, this.pub = null, t.priv && this._importPrivate(t.priv, t.privEnc), t.pub && this._importPublic(t.pub, t.pubEnc);
  }

  e.exports = s, s.fromPublic = function (e, t, a) {
    return t instanceof s ? t : new s(e, {
      pub: t,
      pubEnc: a
    });
  }, s.fromPrivate = function (e, t, a) {
    return t instanceof s ? t : new s(e, {
      priv: t,
      privEnc: a
    });
  }, s.prototype.validate = function () {
    var e = this.getPublic();
    return e.isInfinity() ? {
      result: !1,
      reason: "Invalid public key"
    } : e.validate() ? e.mul(this.ec.curve.n).isInfinity() ? {
      result: !0,
      reason: null
    } : {
      result: !1,
      reason: "Public key * N != O"
    } : {
      result: !1,
      reason: "Public key is not a point"
    };
  }, s.prototype.getPublic = function (e, t) {
    return "string" == typeof e && (t = e, e = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), t ? this.pub.encode(t, e) : this.pub;
  }, s.prototype.getPrivate = function (e) {
    return "hex" === e ? this.priv.toString(16, 2) : this.priv;
  }, s.prototype._importPrivate = function (e, t) {
    this.priv = new r(e, t || 16), this.priv = this.priv.umod(this.ec.curve.n);
  }, s.prototype._importPublic = function (e, t) {
    if (e.x || e.y) return "mont" === this.ec.curve.type ? n(e.x, "Need x coordinate") : "short" !== this.ec.curve.type && "edwards" !== this.ec.curve.type || n(e.x && e.y, "Need both x and y coordinate"), void (this.pub = this.ec.curve.point(e.x, e.y));
    this.pub = this.ec.curve.decodePoint(e, t);
  }, s.prototype.derive = function (e) {
    return e.mul(this.priv).getX();
  }, s.prototype.sign = function (e, t, a) {
    return this.ec.sign(e, this, t, a);
  }, s.prototype.verify = function (e, t) {
    return this.ec.verify(e, t, this);
  }, s.prototype.inspect = function () {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
  };
},
/*!************************************************************!*\
  !*** ./node_modules/elliptic/lib/elliptic/ec/signature.js ***!
  \************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! bn.js */
  5),
      n = a(
  /*! ../utils */
  31),
      s = n.assert;

  function o(e, t) {
    if (e instanceof o) return e;
    this._importDER(e, t) || (s(e.r && e.s, "Signature without r or s"), this.r = new r(e.r, 16), this.s = new r(e.s, 16), void 0 === e.recoveryParam ? this.recoveryParam = null : this.recoveryParam = e.recoveryParam);
  }

  function i() {
    this.place = 0;
  }

  function c(e, t) {
    var a = e[t.place++];
    if (!(128 & a)) return a;

    for (var r = 15 & a, n = 0, s = 0, o = t.place; s < r; s++, o++) {
      n <<= 8, n |= e[o];
    }

    return t.place = o, n;
  }

  function u(e) {
    for (var t = 0, a = e.length - 1; !e[t] && !(128 & e[t + 1]) && t < a;) {
      t++;
    }

    return 0 === t ? e : e.slice(t);
  }

  function d(e, t) {
    if (t < 128) e.push(t);else {
      var a = 1 + (Math.log(t) / Math.LN2 >>> 3);

      for (e.push(128 | a); --a;) {
        e.push(t >>> (a << 3) & 255);
      }

      e.push(t);
    }
  }

  e.exports = o, o.prototype._importDER = function (e, t) {
    e = n.toArray(e, t);
    var a = new i();
    if (48 !== e[a.place++]) return !1;
    if (c(e, a) + a.place !== e.length) return !1;
    if (2 !== e[a.place++]) return !1;
    var s = c(e, a),
        o = e.slice(a.place, s + a.place);
    if (a.place += s, 2 !== e[a.place++]) return !1;
    var u = c(e, a);
    if (e.length !== u + a.place) return !1;
    var d = e.slice(a.place, u + a.place);
    return 0 === o[0] && 128 & o[1] && (o = o.slice(1)), 0 === d[0] && 128 & d[1] && (d = d.slice(1)), this.r = new r(o), this.s = new r(d), this.recoveryParam = null, !0;
  }, o.prototype.toDER = function (e) {
    var t = this.r.toArray(),
        a = this.s.toArray();

    for (128 & t[0] && (t = [0].concat(t)), 128 & a[0] && (a = [0].concat(a)), t = u(t), a = u(a); !(a[0] || 128 & a[1]);) {
      a = a.slice(1);
    }

    var r = [2];
    d(r, t.length), (r = r.concat(t)).push(2), d(r, a.length);
    var s = r.concat(a),
        o = [48];
    return d(o, s.length), o = o.concat(s), n.encode(o, e);
  };
},
/*!***********************************************************!*\
  !*** ./node_modules/elliptic/lib/elliptic/eddsa/index.js ***!
  \***********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! hash.js */
  163),
      n = a(
  /*! ../curves */
  102),
      s = a(
  /*! ../utils */
  31),
      o = s.assert,
      i = s.parseBytes,
      c = a(
  /*! ./key */
  425),
      u = a(
  /*! ./signature */
  426);

  function d(e) {
    if (o("ed25519" === e, "only tested with ed25519 so far"), !(this instanceof d)) return new d(e);
    e = n[e].curve;
    this.curve = e, this.g = e.g, this.g.precompute(e.n.bitLength() + 1), this.pointClass = e.point().constructor, this.encodingLength = Math.ceil(e.n.bitLength() / 8), this.hash = r.sha512;
  }

  e.exports = d, d.prototype.sign = function (e, t) {
    e = i(e);
    var a = this.keyFromSecret(t),
        r = this.hashInt(a.messagePrefix(), e),
        n = this.g.mul(r),
        s = this.encodePoint(n),
        o = this.hashInt(s, a.pubBytes(), e).mul(a.priv()),
        c = r.add(o).umod(this.curve.n);
    return this.makeSignature({
      R: n,
      S: c,
      Rencoded: s
    });
  }, d.prototype.verify = function (e, t, a) {
    e = i(e), t = this.makeSignature(t);
    var r = this.keyFromPublic(a),
        n = this.hashInt(t.Rencoded(), r.pubBytes(), e),
        s = this.g.mul(t.S());
    return t.R().add(r.pub().mul(n)).eq(s);
  }, d.prototype.hashInt = function () {
    for (var e = this.hash(), t = 0; t < arguments.length; t++) {
      e.update(arguments[t]);
    }

    return s.intFromLE(e.digest()).umod(this.curve.n);
  }, d.prototype.keyFromPublic = function (e) {
    return c.fromPublic(this, e);
  }, d.prototype.keyFromSecret = function (e) {
    return c.fromSecret(this, e);
  }, d.prototype.makeSignature = function (e) {
    return e instanceof u ? e : new u(this, e);
  }, d.prototype.encodePoint = function (e) {
    var t = e.getY().toArray("le", this.encodingLength);
    return t[this.encodingLength - 1] |= e.getX().isOdd() ? 128 : 0, t;
  }, d.prototype.decodePoint = function (e) {
    var t = (e = s.parseBytes(e)).length - 1,
        a = e.slice(0, t).concat(-129 & e[t]),
        r = 0 != (128 & e[t]),
        n = s.intFromLE(a);
    return this.curve.pointFromY(n, r);
  }, d.prototype.encodeInt = function (e) {
    return e.toArray("le", this.encodingLength);
  }, d.prototype.decodeInt = function (e) {
    return s.intFromLE(e);
  }, d.prototype.isPoint = function (e) {
    return e instanceof this.pointClass;
  };
},
/*!*********************************************************!*\
  !*** ./node_modules/elliptic/lib/elliptic/eddsa/key.js ***!
  \*********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ../utils */
  31),
      n = r.assert,
      s = r.parseBytes,
      o = r.cachedProperty;

  function i(e, t) {
    this.eddsa = e, this._secret = s(t.secret), e.isPoint(t.pub) ? this._pub = t.pub : this._pubBytes = s(t.pub);
  }

  i.fromPublic = function (e, t) {
    return t instanceof i ? t : new i(e, {
      pub: t
    });
  }, i.fromSecret = function (e, t) {
    return t instanceof i ? t : new i(e, {
      secret: t
    });
  }, i.prototype.secret = function () {
    return this._secret;
  }, o(i, "pubBytes", function () {
    return this.eddsa.encodePoint(this.pub());
  }), o(i, "pub", function () {
    return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
  }), o(i, "privBytes", function () {
    var e = this.eddsa,
        t = this.hash(),
        a = e.encodingLength - 1,
        r = t.slice(0, e.encodingLength);
    return r[0] &= 248, r[a] &= 127, r[a] |= 64, r;
  }), o(i, "priv", function () {
    return this.eddsa.decodeInt(this.privBytes());
  }), o(i, "hash", function () {
    return this.eddsa.hash().update(this.secret()).digest();
  }), o(i, "messagePrefix", function () {
    return this.hash().slice(this.eddsa.encodingLength);
  }), i.prototype.sign = function (e) {
    return n(this._secret, "KeyPair can only verify"), this.eddsa.sign(e, this);
  }, i.prototype.verify = function (e, t) {
    return this.eddsa.verify(e, t, this);
  }, i.prototype.getSecret = function (e) {
    return n(this._secret, "KeyPair is public only"), r.encode(this.secret(), e);
  }, i.prototype.getPublic = function (e) {
    return r.encode(this.pubBytes(), e);
  }, e.exports = i;
},
/*!***************************************************************!*\
  !*** ./node_modules/elliptic/lib/elliptic/eddsa/signature.js ***!
  \***************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! bn.js */
  5),
      n = a(
  /*! ../utils */
  31),
      s = n.assert,
      o = n.cachedProperty,
      i = n.parseBytes;

  function c(e, t) {
    this.eddsa = e, "object" != typeof t && (t = i(t)), Array.isArray(t) && (t = {
      R: t.slice(0, e.encodingLength),
      S: t.slice(e.encodingLength)
    }), s(t.R && t.S, "Signature without R or S"), e.isPoint(t.R) && (this._R = t.R), t.S instanceof r && (this._S = t.S), this._Rencoded = Array.isArray(t.R) ? t.R : t.Rencoded, this._Sencoded = Array.isArray(t.S) ? t.S : t.Sencoded;
  }

  o(c, "S", function () {
    return this.eddsa.decodeInt(this.Sencoded());
  }), o(c, "R", function () {
    return this.eddsa.decodePoint(this.Rencoded());
  }), o(c, "Rencoded", function () {
    return this.eddsa.encodePoint(this.R());
  }), o(c, "Sencoded", function () {
    return this.eddsa.encodeInt(this.S());
  }), c.prototype.toBytes = function () {
    return this.Rencoded().concat(this.Sencoded());
  }, c.prototype.toHex = function () {
    return n.encode(this.toBytes(), "hex").toUpperCase();
  }, e.exports = c;
},
/*!*********************************************!*\
  !*** ./node_modules/object-assign/index.js ***!
  \*********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";
  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */

  var r = Object.getOwnPropertySymbols,
      n = Object.prototype.hasOwnProperty,
      s = Object.prototype.propertyIsEnumerable;

  function o(e) {
    if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(e);
  }

  e.exports = function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

      for (var t = {}, a = 0; a < 10; a++) {
        t["_" + String.fromCharCode(a)] = a;
      }

      if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
        return t[e];
      }).join("")) return !1;
      var r = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        r[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
    } catch (e) {
      return !1;
    }
  }() ? Object.assign : function (e, t) {
    for (var a, i, c = o(e), u = 1; u < arguments.length; u++) {
      for (var d in a = Object(arguments[u])) {
        n.call(a, d) && (c[d] = a[d]);
      }

      if (r) {
        i = r(a);

        for (var f = 0; f < i.length; f++) {
          s.call(a, i[f]) && (c[i[f]] = a[i[f]]);
        }
      }
    }

    return c;
  };
},
/*!******************************************************!*\
  !*** ./node_modules/util/support/isBufferBrowser.js ***!
  \******************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = function (e) {
    return e && "object" == typeof e && "function" == typeof e.copy && "function" == typeof e.fill && "function" == typeof e.readUInt8;
  };
},
/*!*********************************************************************!*\
  !*** ./node_modules/util/node_modules/inherits/inherits_browser.js ***!
  \*********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  "function" == typeof Object.create ? e.exports = function (e, t) {
    e.super_ = t, e.prototype = Object.create(t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    });
  } : e.exports = function (e, t) {
    e.super_ = t;

    var a = function a() {};

    a.prototype = t.prototype, e.prototype = new a(), e.prototype.constructor = e;
  };
},
/*!****************************************************!*\
  !*** ./node_modules/strip-hex-prefix/src/index.js ***!
  \****************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! is-hex-prefixed */
  170);

  e.exports = function (e) {
    return "string" != typeof e ? e : r(e) ? e.slice(2) : e;
  };
},
/*!*****************************************************************!*\
  !*** ./node_modules/@0x/utils/node_modules/js-sha3/src/sha3.js ***!
  \*****************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (r, n) {
    var s;
    /**
     * [js-sha3]{@link https://github.com/emn178/js-sha3}
     *
     * @version 0.7.0
     * @author Chen, Yi-Cyuan [emn178@gmail.com]
     * @copyright Chen, Yi-Cyuan 2015-2017
     * @license MIT
     */

    !function () {
      "use strict";

      var o = "input is invalid type",
          i = "object" == typeof window,
          c = i ? window : {};
      c.JS_SHA3_NO_WINDOW && (i = !1);
      var u = !i && "object" == typeof self;
      !c.JS_SHA3_NO_NODE_JS && "object" == typeof r && r.versions && r.versions.node ? c = n : u && (c = self);
      var d = !c.JS_SHA3_NO_COMMON_JS && "object" == typeof e && e.exports,
          f = a(
      /*! !webpack amd options */
      103),
          l = !c.JS_SHA3_NO_ARRAY_BUFFER && "undefined" != typeof ArrayBuffer,
          h = "0123456789abcdef".split(""),
          p = [4, 1024, 262144, 67108864],
          b = [0, 8, 16, 24],
          m = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649, 0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0, 2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771, 2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648, 2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648],
          y = [224, 256, 384, 512],
          v = [128, 256],
          _ = ["hex", "buffer", "arrayBuffer", "array", "digest"],
          g = {
        128: 168,
        256: 136
      };
      !c.JS_SHA3_NO_NODE_JS && Array.isArray || (Array.isArray = function (e) {
        return "[object Array]" === Object.prototype.toString.call(e);
      }), !l || !c.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW && ArrayBuffer.isView || (ArrayBuffer.isView = function (e) {
        return "object" == typeof e && e.buffer && e.buffer.constructor === ArrayBuffer;
      });

      for (var A = function A(e, t, a) {
        return function (r) {
          return new P(e, t, e).update(r)[a]();
        };
      }, w = function w(e, t, a) {
        return function (r, n) {
          return new P(e, t, n).update(r)[a]();
        };
      }, T = function T(e, t, a) {
        return function (t, r, n, s) {
          return E["cshake" + e].update(t, r, n, s)[a]();
        };
      }, x = function x(e, t, a) {
        return function (t, r, n, s) {
          return E["kmac" + e].update(t, r, n, s)[a]();
        };
      }, D = function D(e, t, a, r) {
        for (var n = 0; n < _.length; ++n) {
          var s = _[n];
          e[s] = t(a, r, s);
        }

        return e;
      }, C = function C(e, t) {
        var a = A(e, t, "hex");
        return a.create = function () {
          return new P(e, t, e);
        }, a.update = function (e) {
          return a.create().update(e);
        }, D(a, A, e, t);
      }, S = [{
        name: "keccak",
        padding: [1, 256, 65536, 16777216],
        bits: y,
        createMethod: C
      }, {
        name: "sha3",
        padding: [6, 1536, 393216, 100663296],
        bits: y,
        createMethod: C
      }, {
        name: "shake",
        padding: [31, 7936, 2031616, 520093696],
        bits: v,
        createMethod: function createMethod(e, t) {
          var a = w(e, t, "hex");
          return a.create = function (a) {
            return new P(e, t, a);
          }, a.update = function (e, t) {
            return a.create(t).update(e);
          }, D(a, w, e, t);
        }
      }, {
        name: "cshake",
        padding: p,
        bits: v,
        createMethod: function createMethod(e, t) {
          var a = g[e],
              r = T(e, 0, "hex");
          return r.create = function (r, n, s) {
            return n || s ? new P(e, t, r).bytepad([n, s], a) : E["shake" + e].create(r);
          }, r.update = function (e, t, a, n) {
            return r.create(t, a, n).update(e);
          }, D(r, T, e, t);
        }
      }, {
        name: "kmac",
        padding: p,
        bits: v,
        createMethod: function createMethod(e, t) {
          var a = g[e],
              r = x(e, 0, "hex");
          return r.create = function (r, n, s) {
            return new L(e, t, n).bytepad(["KMAC", s], a).bytepad([r], a);
          }, r.update = function (e, t, a, n) {
            return r.create(e, a, n).update(t);
          }, D(r, x, e, t);
        }
      }], E = {}, B = [], k = 0; k < S.length; ++k) {
        for (var R = S[k], W = R.bits, I = 0; I < W.length; ++I) {
          var N = R.name + "_" + W[I];

          if (B.push(N), E[N] = R.createMethod(W[I], R.padding), "sha3" !== R.name) {
            var M = R.name + W[I];
            B.push(M), E[M] = E[N];
          }
        }
      }

      function P(e, t, a) {
        this.blocks = [], this.s = [], this.padding = t, this.outputBits = a, this.reset = !0, this.finalized = !1, this.block = 0, this.start = 0, this.blockCount = 1600 - (e << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = a >> 5, this.extraBytes = (31 & a) >> 3;

        for (var r = 0; r < 50; ++r) {
          this.s[r] = 0;
        }
      }

      function L(e, t, a) {
        P.call(this, e, t, a);
      }

      P.prototype.update = function (e) {
        if (!this.finalized) {
          var t,
              a = typeof e;

          if ("string" !== a) {
            if ("object" !== a) throw o;
            if (null === e) throw o;
            if (l && e.constructor === ArrayBuffer) e = new Uint8Array(e);else if (!(Array.isArray(e) || l && ArrayBuffer.isView(e))) throw o;
            t = !0;
          }

          for (var r, n, s = this.blocks, i = this.byteCount, c = e.length, u = this.blockCount, d = 0, f = this.s; d < c;) {
            if (this.reset) for (this.reset = !1, s[0] = this.block, r = 1; r < u + 1; ++r) {
              s[r] = 0;
            }
            if (t) for (r = this.start; d < c && r < i; ++d) {
              s[r >> 2] |= e[d] << b[3 & r++];
            } else for (r = this.start; d < c && r < i; ++d) {
              (n = e.charCodeAt(d)) < 128 ? s[r >> 2] |= n << b[3 & r++] : n < 2048 ? (s[r >> 2] |= (192 | n >> 6) << b[3 & r++], s[r >> 2] |= (128 | 63 & n) << b[3 & r++]) : n < 55296 || n >= 57344 ? (s[r >> 2] |= (224 | n >> 12) << b[3 & r++], s[r >> 2] |= (128 | n >> 6 & 63) << b[3 & r++], s[r >> 2] |= (128 | 63 & n) << b[3 & r++]) : (n = 65536 + ((1023 & n) << 10 | 1023 & e.charCodeAt(++d)), s[r >> 2] |= (240 | n >> 18) << b[3 & r++], s[r >> 2] |= (128 | n >> 12 & 63) << b[3 & r++], s[r >> 2] |= (128 | n >> 6 & 63) << b[3 & r++], s[r >> 2] |= (128 | 63 & n) << b[3 & r++]);
            }

            if (this.lastByteIndex = r, r >= i) {
              for (this.start = r - i, this.block = s[u], r = 0; r < u; ++r) {
                f[r] ^= s[r];
              }

              O(f), this.reset = !0;
            } else this.start = r;
          }

          return this;
        }
      }, P.prototype.encode = function (e, t) {
        var a = 255 & e,
            r = 1,
            n = [a];

        for (a = 255 & (e >>= 8); a > 0;) {
          n.unshift(a), a = 255 & (e >>= 8), ++r;
        }

        return t ? n.push(r) : n.unshift(r), this.update(n), n.length;
      }, P.prototype.encodeString = function (e) {
        var t,
            a = typeof e;

        if ("string" !== a) {
          if ("object" !== a) throw o;
          if (null === e) throw o;
          if (l && e.constructor === ArrayBuffer) e = new Uint8Array(e);else if (!(Array.isArray(e) || l && ArrayBuffer.isView(e))) throw o;
          t = !0;
        }

        var r = 0,
            n = e.length;
        if (t) r = n;else for (var s = 0; s < e.length; ++s) {
          var i = e.charCodeAt(s);
          i < 128 ? r += 1 : i < 2048 ? r += 2 : i < 55296 || i >= 57344 ? r += 3 : (i = 65536 + ((1023 & i) << 10 | 1023 & e.charCodeAt(++s)), r += 4);
        }
        return r += this.encode(8 * r), this.update(e), r;
      }, P.prototype.bytepad = function (e, t) {
        for (var a = this.encode(t), r = 0; r < e.length; ++r) {
          a += this.encodeString(e[r]);
        }

        var n = t - a % t,
            s = [];
        return s.length = n, this.update(s), this;
      }, P.prototype.finalize = function () {
        if (!this.finalized) {
          this.finalized = !0;
          var e = this.blocks,
              t = this.lastByteIndex,
              a = this.blockCount,
              r = this.s;
          if (e[t >> 2] |= this.padding[3 & t], this.lastByteIndex === this.byteCount) for (e[0] = e[a], t = 1; t < a + 1; ++t) {
            e[t] = 0;
          }

          for (e[a - 1] |= 2147483648, t = 0; t < a; ++t) {
            r[t] ^= e[t];
          }

          O(r);
        }
      }, P.prototype.toString = P.prototype.hex = function () {
        this.finalize();

        for (var e, t = this.blockCount, a = this.s, r = this.outputBlocks, n = this.extraBytes, s = 0, o = 0, i = ""; o < r;) {
          for (s = 0; s < t && o < r; ++s, ++o) {
            e = a[s], i += h[e >> 4 & 15] + h[15 & e] + h[e >> 12 & 15] + h[e >> 8 & 15] + h[e >> 20 & 15] + h[e >> 16 & 15] + h[e >> 28 & 15] + h[e >> 24 & 15];
          }

          o % t == 0 && (O(a), s = 0);
        }

        return n && (e = a[s], i += h[e >> 4 & 15] + h[15 & e], n > 1 && (i += h[e >> 12 & 15] + h[e >> 8 & 15]), n > 2 && (i += h[e >> 20 & 15] + h[e >> 16 & 15])), i;
      }, P.prototype.arrayBuffer = function () {
        this.finalize();
        var e,
            t = this.blockCount,
            a = this.s,
            r = this.outputBlocks,
            n = this.extraBytes,
            s = 0,
            o = 0,
            i = this.outputBits >> 3;
        e = n ? new ArrayBuffer(r + 1 << 2) : new ArrayBuffer(i);

        for (var c = new Uint32Array(e); o < r;) {
          for (s = 0; s < t && o < r; ++s, ++o) {
            c[o] = a[s];
          }

          o % t == 0 && O(a);
        }

        return n && (c[s] = a[s], e = e.slice(0, i)), e;
      }, P.prototype.buffer = P.prototype.arrayBuffer, P.prototype.digest = P.prototype.array = function () {
        this.finalize();

        for (var e, t, a = this.blockCount, r = this.s, n = this.outputBlocks, s = this.extraBytes, o = 0, i = 0, c = []; i < n;) {
          for (o = 0; o < a && i < n; ++o, ++i) {
            e = i << 2, t = r[o], c[e] = 255 & t, c[e + 1] = t >> 8 & 255, c[e + 2] = t >> 16 & 255, c[e + 3] = t >> 24 & 255;
          }

          i % a == 0 && O(r);
        }

        return s && (e = i << 2, t = r[o], c[e] = 255 & t, s > 1 && (c[e + 1] = t >> 8 & 255), s > 2 && (c[e + 2] = t >> 16 & 255)), c;
      }, L.prototype = new P(), L.prototype.finalize = function () {
        return this.encode(this.outputBits, !0), P.prototype.finalize.call(this);
      };

      var O = function O(e) {
        var t, a, r, n, s, o, i, c, u, d, f, l, h, p, b, y, v, _, g, A, w, T, x, D, C, S, E, B, k, R, W, I, N, M, P, L, O, F, j, G, V, U, H, z, K, q, Y, Z, J, X, $, Q, ee, te, ae, re, ne, se, oe, ie, ce, ue, de;

        for (r = 0; r < 48; r += 2) {
          n = e[0] ^ e[10] ^ e[20] ^ e[30] ^ e[40], s = e[1] ^ e[11] ^ e[21] ^ e[31] ^ e[41], o = e[2] ^ e[12] ^ e[22] ^ e[32] ^ e[42], i = e[3] ^ e[13] ^ e[23] ^ e[33] ^ e[43], c = e[4] ^ e[14] ^ e[24] ^ e[34] ^ e[44], u = e[5] ^ e[15] ^ e[25] ^ e[35] ^ e[45], d = e[6] ^ e[16] ^ e[26] ^ e[36] ^ e[46], f = e[7] ^ e[17] ^ e[27] ^ e[37] ^ e[47], t = (l = e[8] ^ e[18] ^ e[28] ^ e[38] ^ e[48]) ^ (o << 1 | i >>> 31), a = (h = e[9] ^ e[19] ^ e[29] ^ e[39] ^ e[49]) ^ (i << 1 | o >>> 31), e[0] ^= t, e[1] ^= a, e[10] ^= t, e[11] ^= a, e[20] ^= t, e[21] ^= a, e[30] ^= t, e[31] ^= a, e[40] ^= t, e[41] ^= a, t = n ^ (c << 1 | u >>> 31), a = s ^ (u << 1 | c >>> 31), e[2] ^= t, e[3] ^= a, e[12] ^= t, e[13] ^= a, e[22] ^= t, e[23] ^= a, e[32] ^= t, e[33] ^= a, e[42] ^= t, e[43] ^= a, t = o ^ (d << 1 | f >>> 31), a = i ^ (f << 1 | d >>> 31), e[4] ^= t, e[5] ^= a, e[14] ^= t, e[15] ^= a, e[24] ^= t, e[25] ^= a, e[34] ^= t, e[35] ^= a, e[44] ^= t, e[45] ^= a, t = c ^ (l << 1 | h >>> 31), a = u ^ (h << 1 | l >>> 31), e[6] ^= t, e[7] ^= a, e[16] ^= t, e[17] ^= a, e[26] ^= t, e[27] ^= a, e[36] ^= t, e[37] ^= a, e[46] ^= t, e[47] ^= a, t = d ^ (n << 1 | s >>> 31), a = f ^ (s << 1 | n >>> 31), e[8] ^= t, e[9] ^= a, e[18] ^= t, e[19] ^= a, e[28] ^= t, e[29] ^= a, e[38] ^= t, e[39] ^= a, e[48] ^= t, e[49] ^= a, p = e[0], b = e[1], q = e[11] << 4 | e[10] >>> 28, Y = e[10] << 4 | e[11] >>> 28, B = e[20] << 3 | e[21] >>> 29, k = e[21] << 3 | e[20] >>> 29, ie = e[31] << 9 | e[30] >>> 23, ce = e[30] << 9 | e[31] >>> 23, U = e[40] << 18 | e[41] >>> 14, H = e[41] << 18 | e[40] >>> 14, M = e[2] << 1 | e[3] >>> 31, P = e[3] << 1 | e[2] >>> 31, y = e[13] << 12 | e[12] >>> 20, v = e[12] << 12 | e[13] >>> 20, Z = e[22] << 10 | e[23] >>> 22, J = e[23] << 10 | e[22] >>> 22, R = e[33] << 13 | e[32] >>> 19, W = e[32] << 13 | e[33] >>> 19, ue = e[42] << 2 | e[43] >>> 30, de = e[43] << 2 | e[42] >>> 30, te = e[5] << 30 | e[4] >>> 2, ae = e[4] << 30 | e[5] >>> 2, L = e[14] << 6 | e[15] >>> 26, O = e[15] << 6 | e[14] >>> 26, _ = e[25] << 11 | e[24] >>> 21, g = e[24] << 11 | e[25] >>> 21, X = e[34] << 15 | e[35] >>> 17, $ = e[35] << 15 | e[34] >>> 17, I = e[45] << 29 | e[44] >>> 3, N = e[44] << 29 | e[45] >>> 3, D = e[6] << 28 | e[7] >>> 4, C = e[7] << 28 | e[6] >>> 4, re = e[17] << 23 | e[16] >>> 9, ne = e[16] << 23 | e[17] >>> 9, F = e[26] << 25 | e[27] >>> 7, j = e[27] << 25 | e[26] >>> 7, A = e[36] << 21 | e[37] >>> 11, w = e[37] << 21 | e[36] >>> 11, Q = e[47] << 24 | e[46] >>> 8, ee = e[46] << 24 | e[47] >>> 8, z = e[8] << 27 | e[9] >>> 5, K = e[9] << 27 | e[8] >>> 5, S = e[18] << 20 | e[19] >>> 12, E = e[19] << 20 | e[18] >>> 12, se = e[29] << 7 | e[28] >>> 25, oe = e[28] << 7 | e[29] >>> 25, G = e[38] << 8 | e[39] >>> 24, V = e[39] << 8 | e[38] >>> 24, T = e[48] << 14 | e[49] >>> 18, x = e[49] << 14 | e[48] >>> 18, e[0] = p ^ ~y & _, e[1] = b ^ ~v & g, e[10] = D ^ ~S & B, e[11] = C ^ ~E & k, e[20] = M ^ ~L & F, e[21] = P ^ ~O & j, e[30] = z ^ ~q & Z, e[31] = K ^ ~Y & J, e[40] = te ^ ~re & se, e[41] = ae ^ ~ne & oe, e[2] = y ^ ~_ & A, e[3] = v ^ ~g & w, e[12] = S ^ ~B & R, e[13] = E ^ ~k & W, e[22] = L ^ ~F & G, e[23] = O ^ ~j & V, e[32] = q ^ ~Z & X, e[33] = Y ^ ~J & $, e[42] = re ^ ~se & ie, e[43] = ne ^ ~oe & ce, e[4] = _ ^ ~A & T, e[5] = g ^ ~w & x, e[14] = B ^ ~R & I, e[15] = k ^ ~W & N, e[24] = F ^ ~G & U, e[25] = j ^ ~V & H, e[34] = Z ^ ~X & Q, e[35] = J ^ ~$ & ee, e[44] = se ^ ~ie & ue, e[45] = oe ^ ~ce & de, e[6] = A ^ ~T & p, e[7] = w ^ ~x & b, e[16] = R ^ ~I & D, e[17] = W ^ ~N & C, e[26] = G ^ ~U & M, e[27] = V ^ ~H & P, e[36] = X ^ ~Q & z, e[37] = $ ^ ~ee & K, e[46] = ie ^ ~ue & te, e[47] = ce ^ ~de & ae, e[8] = T ^ ~p & y, e[9] = x ^ ~b & v, e[18] = I ^ ~D & S, e[19] = N ^ ~C & E, e[28] = U ^ ~M & L, e[29] = H ^ ~P & O, e[38] = Q ^ ~z & q, e[39] = ee ^ ~K & Y, e[48] = ue ^ ~te & re, e[49] = de ^ ~ae & ne, e[0] ^= m[r], e[1] ^= m[r + 1];
        }
      };

      if (d) e.exports = E;else {
        for (k = 0; k < B.length; ++k) {
          c[B[k]] = E[B[k]];
        }

        f && (void 0 === (s = function () {
          return E;
        }.call(t, a, t, e)) || (e.exports = s));
      }
    }();
  }).call(this, a(
  /*! ./../../../../../process/browser.js */
  9), a(
  /*! ./../../../../../webpack/buildin/global.js */
  18));
},
/*!************************************************!*\
  !*** ./node_modules/bignumber.js/bignumber.js ***!
  \************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r;
  !function (n) {
    "use strict";

    var s,
        o = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i,
        i = Math.ceil,
        c = Math.floor,
        u = "[BigNumber Error] ",
        d = u + "Number primitive has more than 15 significant digits: ",
        f = 1e14,
        l = 14,
        h = 9007199254740991,
        p = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13],
        b = 1e7,
        m = 1e9;

    function y(e) {
      var t = 0 | e;
      return e > 0 || e === t ? t : t - 1;
    }

    function v(e) {
      for (var t, a, r = 1, n = e.length, s = e[0] + ""; r < n;) {
        for (t = e[r++] + "", a = l - t.length; a--; t = "0" + t) {
          ;
        }

        s += t;
      }

      for (n = s.length; 48 === s.charCodeAt(--n);) {
        ;
      }

      return s.slice(0, n + 1 || 1);
    }

    function _(e, t) {
      var a,
          r,
          n = e.c,
          s = t.c,
          o = e.s,
          i = t.s,
          c = e.e,
          u = t.e;
      if (!o || !i) return null;
      if (a = n && !n[0], r = s && !s[0], a || r) return a ? r ? 0 : -i : o;
      if (o != i) return o;
      if (a = o < 0, r = c == u, !n || !s) return r ? 0 : !n ^ a ? 1 : -1;
      if (!r) return c > u ^ a ? 1 : -1;

      for (i = (c = n.length) < (u = s.length) ? c : u, o = 0; o < i; o++) {
        if (n[o] != s[o]) return n[o] > s[o] ^ a ? 1 : -1;
      }

      return c == u ? 0 : c > u ^ a ? 1 : -1;
    }

    function g(e, t, a, r) {
      if (e < t || e > a || e !== (e < 0 ? i(e) : c(e))) throw Error(u + (r || "Argument") + ("number" == typeof e ? e < t || e > a ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(e));
    }

    function A(e) {
      var t = e.c.length - 1;
      return y(e.e / l) == t && e.c[t] % 2 != 0;
    }

    function w(e, t) {
      return (e.length > 1 ? e.charAt(0) + "." + e.slice(1) : e) + (t < 0 ? "e" : "e+") + t;
    }

    function T(e, t, a) {
      var r, n;

      if (t < 0) {
        for (n = a + "."; ++t; n += a) {
          ;
        }

        e = n + e;
      } else if (++t > (r = e.length)) {
        for (n = a, t -= r; --t; n += a) {
          ;
        }

        e += n;
      } else t < r && (e = e.slice(0, t) + "." + e.slice(t));

      return e;
    }

    (s = function e(t) {
      var a,
          r,
          n,
          s,
          x,
          D,
          C,
          S,
          E,
          B = V.prototype = {
        constructor: V,
        toString: null,
        valueOf: null
      },
          k = new V(1),
          R = 20,
          W = 4,
          I = -7,
          N = 21,
          M = -1e7,
          P = 1e7,
          L = !1,
          O = 1,
          F = 0,
          j = {
        prefix: "",
        groupSize: 3,
        secondaryGroupSize: 0,
        groupSeparator: ",",
        decimalSeparator: ".",
        fractionGroupSize: 0,
        fractionGroupSeparator: " ",
        suffix: ""
      },
          G = "0123456789abcdefghijklmnopqrstuvwxyz";

      function V(e, t) {
        var a,
            s,
            i,
            u,
            f,
            p,
            b,
            m,
            y = this;
        if (!(y instanceof V)) return new V(e, t);

        if (null == t) {
          if (e instanceof V) return y.s = e.s, y.e = e.e, void (y.c = (e = e.c) ? e.slice() : e);

          if ((p = "number" == typeof e) && 0 * e == 0) {
            if (y.s = 1 / e < 0 ? (e = -e, -1) : 1, e === ~~e) {
              for (u = 0, f = e; f >= 10; f /= 10, u++) {
                ;
              }

              return y.e = u, void (y.c = [e]);
            }

            m = String(e);
          } else {
            if (m = String(e), !o.test(m)) return n(y, m, p);
            y.s = 45 == m.charCodeAt(0) ? (m = m.slice(1), -1) : 1;
          }

          (u = m.indexOf(".")) > -1 && (m = m.replace(".", "")), (f = m.search(/e/i)) > 0 ? (u < 0 && (u = f), u += +m.slice(f + 1), m = m.substring(0, f)) : u < 0 && (u = m.length);
        } else {
          if (g(t, 2, G.length, "Base"), m = String(e), 10 == t) return K(y = new V(e instanceof V ? e : m), R + y.e + 1, W);

          if (p = "number" == typeof e) {
            if (0 * e != 0) return n(y, m, p, t);
            if (y.s = 1 / e < 0 ? (m = m.slice(1), -1) : 1, V.DEBUG && m.replace(/^0\.0*|\./, "").length > 15) throw Error(d + e);
            p = !1;
          } else y.s = 45 === m.charCodeAt(0) ? (m = m.slice(1), -1) : 1;

          for (a = G.slice(0, t), u = f = 0, b = m.length; f < b; f++) {
            if (a.indexOf(s = m.charAt(f)) < 0) {
              if ("." == s) {
                if (f > u) {
                  u = b;
                  continue;
                }
              } else if (!i && (m == m.toUpperCase() && (m = m.toLowerCase()) || m == m.toLowerCase() && (m = m.toUpperCase()))) {
                i = !0, f = -1, u = 0;
                continue;
              }

              return n(y, String(e), p, t);
            }
          }

          (u = (m = r(m, t, 10, y.s)).indexOf(".")) > -1 ? m = m.replace(".", "") : u = m.length;
        }

        for (f = 0; 48 === m.charCodeAt(f); f++) {
          ;
        }

        for (b = m.length; 48 === m.charCodeAt(--b);) {
          ;
        }

        if (m = m.slice(f, ++b)) {
          if (b -= f, p && V.DEBUG && b > 15 && (e > h || e !== c(e))) throw Error(d + y.s * e);
          if ((u = u - f - 1) > P) y.c = y.e = null;else if (u < M) y.c = [y.e = 0];else {
            if (y.e = u, y.c = [], f = (u + 1) % l, u < 0 && (f += l), f < b) {
              for (f && y.c.push(+m.slice(0, f)), b -= l; f < b;) {
                y.c.push(+m.slice(f, f += l));
              }

              m = m.slice(f), f = l - m.length;
            } else f -= b;

            for (; f--; m += "0") {
              ;
            }

            y.c.push(+m);
          }
        } else y.c = [y.e = 0];
      }

      function U(e, t, a, r) {
        var n, s, o, i, c;
        if (null == a ? a = W : g(a, 0, 8), !e.c) return e.toString();
        if (n = e.c[0], o = e.e, null == t) c = v(e.c), c = 1 == r || 2 == r && (o <= I || o >= N) ? w(c, o) : T(c, o, "0");else if (s = (e = K(new V(e), t, a)).e, i = (c = v(e.c)).length, 1 == r || 2 == r && (t <= s || s <= I)) {
          for (; i < t; c += "0", i++) {
            ;
          }

          c = w(c, s);
        } else if (t -= o, c = T(c, s, "0"), s + 1 > i) {
          if (--t > 0) for (c += "."; t--; c += "0") {
            ;
          }
        } else if ((t += s - i) > 0) for (s + 1 == i && (c += "."); t--; c += "0") {
          ;
        }
        return e.s < 0 && n ? "-" + c : c;
      }

      function H(e, t) {
        for (var a, r = 1, n = new V(e[0]); r < e.length; r++) {
          if (!(a = new V(e[r])).s) {
            n = a;
            break;
          }

          t.call(n, a) && (n = a);
        }

        return n;
      }

      function z(e, t, a) {
        for (var r = 1, n = t.length; !t[--n]; t.pop()) {
          ;
        }

        for (n = t[0]; n >= 10; n /= 10, r++) {
          ;
        }

        return (a = r + a * l - 1) > P ? e.c = e.e = null : a < M ? e.c = [e.e = 0] : (e.e = a, e.c = t), e;
      }

      function K(e, t, a, r) {
        var n,
            s,
            o,
            u,
            d,
            h,
            b,
            m = e.c,
            y = p;

        if (m) {
          e: {
            for (n = 1, u = m[0]; u >= 10; u /= 10, n++) {
              ;
            }

            if ((s = t - n) < 0) s += l, o = t, b = (d = m[h = 0]) / y[n - o - 1] % 10 | 0;else if ((h = i((s + 1) / l)) >= m.length) {
              if (!r) break e;

              for (; m.length <= h; m.push(0)) {
                ;
              }

              d = b = 0, n = 1, o = (s %= l) - l + 1;
            } else {
              for (d = u = m[h], n = 1; u >= 10; u /= 10, n++) {
                ;
              }

              b = (o = (s %= l) - l + n) < 0 ? 0 : d / y[n - o - 1] % 10 | 0;
            }
            if (r = r || t < 0 || null != m[h + 1] || (o < 0 ? d : d % y[n - o - 1]), r = a < 4 ? (b || r) && (0 == a || a == (e.s < 0 ? 3 : 2)) : b > 5 || 5 == b && (4 == a || r || 6 == a && (s > 0 ? o > 0 ? d / y[n - o] : 0 : m[h - 1]) % 10 & 1 || a == (e.s < 0 ? 8 : 7)), t < 1 || !m[0]) return m.length = 0, r ? (t -= e.e + 1, m[0] = y[(l - t % l) % l], e.e = -t || 0) : m[0] = e.e = 0, e;
            if (0 == s ? (m.length = h, u = 1, h--) : (m.length = h + 1, u = y[l - s], m[h] = o > 0 ? c(d / y[n - o] % y[o]) * u : 0), r) for (;;) {
              if (0 == h) {
                for (s = 1, o = m[0]; o >= 10; o /= 10, s++) {
                  ;
                }

                for (o = m[0] += u, u = 1; o >= 10; o /= 10, u++) {
                  ;
                }

                s != u && (e.e++, m[0] == f && (m[0] = 1));
                break;
              }

              if (m[h] += u, m[h] != f) break;
              m[h--] = 0, u = 1;
            }

            for (s = m.length; 0 === m[--s]; m.pop()) {
              ;
            }
          }

          e.e > P ? e.c = e.e = null : e.e < M && (e.c = [e.e = 0]);
        }

        return e;
      }

      function q(e) {
        var t,
            a = e.e;
        return null === a ? e.toString() : (t = v(e.c), t = a <= I || a >= N ? w(t, a) : T(t, a, "0"), e.s < 0 ? "-" + t : t);
      }

      return V.clone = e, V.ROUND_UP = 0, V.ROUND_DOWN = 1, V.ROUND_CEIL = 2, V.ROUND_FLOOR = 3, V.ROUND_HALF_UP = 4, V.ROUND_HALF_DOWN = 5, V.ROUND_HALF_EVEN = 6, V.ROUND_HALF_CEIL = 7, V.ROUND_HALF_FLOOR = 8, V.EUCLID = 9, V.config = V.set = function (e) {
        var t, a;

        if (null != e) {
          if ("object" != typeof e) throw Error(u + "Object expected: " + e);
          if (e.hasOwnProperty(t = "DECIMAL_PLACES") && (g(a = e[t], 0, m, t), R = a), e.hasOwnProperty(t = "ROUNDING_MODE") && (g(a = e[t], 0, 8, t), W = a), e.hasOwnProperty(t = "EXPONENTIAL_AT") && ((a = e[t]) && a.pop ? (g(a[0], -m, 0, t), g(a[1], 0, m, t), I = a[0], N = a[1]) : (g(a, -m, m, t), I = -(N = a < 0 ? -a : a))), e.hasOwnProperty(t = "RANGE")) if ((a = e[t]) && a.pop) g(a[0], -m, -1, t), g(a[1], 1, m, t), M = a[0], P = a[1];else {
            if (g(a, -m, m, t), !a) throw Error(u + t + " cannot be zero: " + a);
            M = -(P = a < 0 ? -a : a);
          }

          if (e.hasOwnProperty(t = "CRYPTO")) {
            if ((a = e[t]) !== !!a) throw Error(u + t + " not true or false: " + a);

            if (a) {
              if ("undefined" == typeof crypto || !crypto || !crypto.getRandomValues && !crypto.randomBytes) throw L = !a, Error(u + "crypto unavailable");
              L = a;
            } else L = a;
          }

          if (e.hasOwnProperty(t = "MODULO_MODE") && (g(a = e[t], 0, 9, t), O = a), e.hasOwnProperty(t = "POW_PRECISION") && (g(a = e[t], 0, m, t), F = a), e.hasOwnProperty(t = "FORMAT")) {
            if ("object" != typeof (a = e[t])) throw Error(u + t + " not an object: " + a);
            j = a;
          }

          if (e.hasOwnProperty(t = "ALPHABET")) {
            if ("string" != typeof (a = e[t]) || /^.$|[+-.\s]|(.).*\1/.test(a)) throw Error(u + t + " invalid: " + a);
            G = a;
          }
        }

        return {
          DECIMAL_PLACES: R,
          ROUNDING_MODE: W,
          EXPONENTIAL_AT: [I, N],
          RANGE: [M, P],
          CRYPTO: L,
          MODULO_MODE: O,
          POW_PRECISION: F,
          FORMAT: j,
          ALPHABET: G
        };
      }, V.isBigNumber = function (e) {
        return e instanceof V || e && !0 === e._isBigNumber || !1;
      }, V.maximum = V.max = function () {
        return H(arguments, B.lt);
      }, V.minimum = V.min = function () {
        return H(arguments, B.gt);
      }, V.random = (s = 9007199254740992 * Math.random() & 2097151 ? function () {
        return c(9007199254740992 * Math.random());
      } : function () {
        return 8388608 * (1073741824 * Math.random() | 0) + (8388608 * Math.random() | 0);
      }, function (e) {
        var t,
            a,
            r,
            n,
            o,
            d = 0,
            f = [],
            h = new V(k);
        if (null == e ? e = R : g(e, 0, m), n = i(e / l), L) if (crypto.getRandomValues) {
          for (t = crypto.getRandomValues(new Uint32Array(n *= 2)); d < n;) {
            (o = 131072 * t[d] + (t[d + 1] >>> 11)) >= 9e15 ? (a = crypto.getRandomValues(new Uint32Array(2)), t[d] = a[0], t[d + 1] = a[1]) : (f.push(o % 1e14), d += 2);
          }

          d = n / 2;
        } else {
          if (!crypto.randomBytes) throw L = !1, Error(u + "crypto unavailable");

          for (t = crypto.randomBytes(n *= 7); d < n;) {
            (o = 281474976710656 * (31 & t[d]) + 1099511627776 * t[d + 1] + 4294967296 * t[d + 2] + 16777216 * t[d + 3] + (t[d + 4] << 16) + (t[d + 5] << 8) + t[d + 6]) >= 9e15 ? crypto.randomBytes(7).copy(t, d) : (f.push(o % 1e14), d += 7);
          }

          d = n / 7;
        }
        if (!L) for (; d < n;) {
          (o = s()) < 9e15 && (f[d++] = o % 1e14);
        }

        for (n = f[--d], e %= l, n && e && (o = p[l - e], f[d] = c(n / o) * o); 0 === f[d]; f.pop(), d--) {
          ;
        }

        if (d < 0) f = [r = 0];else {
          for (r = -1; 0 === f[0]; f.splice(0, 1), r -= l) {
            ;
          }

          for (d = 1, o = f[0]; o >= 10; o /= 10, d++) {
            ;
          }

          d < l && (r -= l - d);
        }
        return h.e = r, h.c = f, h;
      }), V.sum = function () {
        for (var e = 1, t = arguments, a = new V(t[0]); e < t.length;) {
          a = a.plus(t[e++]);
        }

        return a;
      }, r = function () {
        function e(e, t, a, r) {
          for (var n, s, o = [0], i = 0, c = e.length; i < c;) {
            for (s = o.length; s--; o[s] *= t) {
              ;
            }

            for (o[0] += r.indexOf(e.charAt(i++)), n = 0; n < o.length; n++) {
              o[n] > a - 1 && (null == o[n + 1] && (o[n + 1] = 0), o[n + 1] += o[n] / a | 0, o[n] %= a);
            }
          }

          return o.reverse();
        }

        return function (t, r, n, s, o) {
          var i,
              c,
              u,
              d,
              f,
              l,
              h,
              p,
              b = t.indexOf("."),
              m = R,
              y = W;

          for (b >= 0 && (d = F, F = 0, t = t.replace(".", ""), l = (p = new V(r)).pow(t.length - b), F = d, p.c = e(T(v(l.c), l.e, "0"), 10, n, "0123456789"), p.e = p.c.length), u = d = (h = e(t, r, n, o ? (i = G, "0123456789") : (i = "0123456789", G))).length; 0 == h[--d]; h.pop()) {
            ;
          }

          if (!h[0]) return i.charAt(0);
          if (b < 0 ? --u : (l.c = h, l.e = u, l.s = s, h = (l = a(l, p, m, y, n)).c, f = l.r, u = l.e), b = h[c = u + m + 1], d = n / 2, f = f || c < 0 || null != h[c + 1], f = y < 4 ? (null != b || f) && (0 == y || y == (l.s < 0 ? 3 : 2)) : b > d || b == d && (4 == y || f || 6 == y && 1 & h[c - 1] || y == (l.s < 0 ? 8 : 7)), c < 1 || !h[0]) t = f ? T(i.charAt(1), -m, i.charAt(0)) : i.charAt(0);else {
            if (h.length = c, f) for (--n; ++h[--c] > n;) {
              h[c] = 0, c || (++u, h = [1].concat(h));
            }

            for (d = h.length; !h[--d];) {
              ;
            }

            for (b = 0, t = ""; b <= d; t += i.charAt(h[b++])) {
              ;
            }

            t = T(t, u, i.charAt(0));
          }
          return t;
        };
      }(), a = function () {
        function e(e, t, a) {
          var r,
              n,
              s,
              o,
              i = 0,
              c = e.length,
              u = t % b,
              d = t / b | 0;

          for (e = e.slice(); c--;) {
            i = ((n = u * (s = e[c] % b) + (r = d * s + (o = e[c] / b | 0) * u) % b * b + i) / a | 0) + (r / b | 0) + d * o, e[c] = n % a;
          }

          return i && (e = [i].concat(e)), e;
        }

        function t(e, t, a, r) {
          var n, s;
          if (a != r) s = a > r ? 1 : -1;else for (n = s = 0; n < a; n++) {
            if (e[n] != t[n]) {
              s = e[n] > t[n] ? 1 : -1;
              break;
            }
          }
          return s;
        }

        function a(e, t, a, r) {
          for (var n = 0; a--;) {
            e[a] -= n, n = e[a] < t[a] ? 1 : 0, e[a] = n * r + e[a] - t[a];
          }

          for (; !e[0] && e.length > 1; e.splice(0, 1)) {
            ;
          }
        }

        return function (r, n, s, o, i) {
          var u,
              d,
              h,
              p,
              b,
              m,
              v,
              _,
              g,
              A,
              w,
              T,
              x,
              D,
              C,
              S,
              E,
              B = r.s == n.s ? 1 : -1,
              k = r.c,
              R = n.c;

          if (!(k && k[0] && R && R[0])) return new V(r.s && n.s && (k ? !R || k[0] != R[0] : R) ? k && 0 == k[0] || !R ? 0 * B : B / 0 : NaN);

          for (g = (_ = new V(B)).c = [], B = s + (d = r.e - n.e) + 1, i || (i = f, d = y(r.e / l) - y(n.e / l), B = B / l | 0), h = 0; R[h] == (k[h] || 0); h++) {
            ;
          }

          if (R[h] > (k[h] || 0) && d--, B < 0) g.push(1), p = !0;else {
            for (D = k.length, S = R.length, h = 0, B += 2, (b = c(i / (R[0] + 1))) > 1 && (R = e(R, b, i), k = e(k, b, i), S = R.length, D = k.length), x = S, w = (A = k.slice(0, S)).length; w < S; A[w++] = 0) {
              ;
            }

            E = R.slice(), E = [0].concat(E), C = R[0], R[1] >= i / 2 && C++;

            do {
              if (b = 0, (u = t(R, A, S, w)) < 0) {
                if (T = A[0], S != w && (T = T * i + (A[1] || 0)), (b = c(T / C)) > 1) for (b >= i && (b = i - 1), v = (m = e(R, b, i)).length, w = A.length; 1 == t(m, A, v, w);) {
                  b--, a(m, S < v ? E : R, v, i), v = m.length, u = 1;
                } else 0 == b && (u = b = 1), v = (m = R.slice()).length;
                if (v < w && (m = [0].concat(m)), a(A, m, w, i), w = A.length, -1 == u) for (; t(R, A, S, w) < 1;) {
                  b++, a(A, S < w ? E : R, w, i), w = A.length;
                }
              } else 0 === u && (b++, A = [0]);

              g[h++] = b, A[0] ? A[w++] = k[x] || 0 : (A = [k[x]], w = 1);
            } while ((x++ < D || null != A[0]) && B--);

            p = null != A[0], g[0] || g.splice(0, 1);
          }

          if (i == f) {
            for (h = 1, B = g[0]; B >= 10; B /= 10, h++) {
              ;
            }

            K(_, s + (_.e = h + d * l - 1) + 1, o, p);
          } else _.e = d, _.r = +p;

          return _;
        };
      }(), x = /^(-?)0([xbo])(?=\w[\w.]*$)/i, D = /^([^.]+)\.$/, C = /^\.([^.]+)$/, S = /^-?(Infinity|NaN)$/, E = /^\s*\+(?=[\w.])|^\s+|\s+$/g, n = function n(e, t, a, r) {
        var n,
            s = a ? t : t.replace(E, "");
        if (S.test(s)) e.s = isNaN(s) ? null : s < 0 ? -1 : 1, e.c = e.e = null;else {
          if (!a && (s = s.replace(x, function (e, t, a) {
            return n = "x" == (a = a.toLowerCase()) ? 16 : "b" == a ? 2 : 8, r && r != n ? e : t;
          }), r && (n = r, s = s.replace(D, "$1").replace(C, "0.$1")), t != s)) return new V(s, n);
          if (V.DEBUG) throw Error(u + "Not a" + (r ? " base " + r : "") + " number: " + t);
          e.c = e.e = e.s = null;
        }
      }, B.absoluteValue = B.abs = function () {
        var e = new V(this);
        return e.s < 0 && (e.s = 1), e;
      }, B.comparedTo = function (e, t) {
        return _(this, new V(e, t));
      }, B.decimalPlaces = B.dp = function (e, t) {
        var a,
            r,
            n,
            s = this;
        if (null != e) return g(e, 0, m), null == t ? t = W : g(t, 0, 8), K(new V(s), e + s.e + 1, t);
        if (!(a = s.c)) return null;
        if (r = ((n = a.length - 1) - y(this.e / l)) * l, n = a[n]) for (; n % 10 == 0; n /= 10, r--) {
          ;
        }
        return r < 0 && (r = 0), r;
      }, B.dividedBy = B.div = function (e, t) {
        return a(this, new V(e, t), R, W);
      }, B.dividedToIntegerBy = B.idiv = function (e, t) {
        return a(this, new V(e, t), 0, 1);
      }, B.exponentiatedBy = B.pow = function (e, t) {
        var a,
            r,
            n,
            s,
            o,
            d,
            f,
            h,
            p = this;
        if ((e = new V(e)).c && !e.isInteger()) throw Error(u + "Exponent not an integer: " + q(e));
        if (null != t && (t = new V(t)), o = e.e > 14, !p.c || !p.c[0] || 1 == p.c[0] && !p.e && 1 == p.c.length || !e.c || !e.c[0]) return h = new V(Math.pow(+q(p), o ? 2 - A(e) : +q(e))), t ? h.mod(t) : h;

        if (d = e.s < 0, t) {
          if (t.c ? !t.c[0] : !t.s) return new V(NaN);
          (r = !d && p.isInteger() && t.isInteger()) && (p = p.mod(t));
        } else {
          if (e.e > 9 && (p.e > 0 || p.e < -1 || (0 == p.e ? p.c[0] > 1 || o && p.c[1] >= 24e7 : p.c[0] < 8e13 || o && p.c[0] <= 9999975e7))) return s = p.s < 0 && A(e) ? -0 : 0, p.e > -1 && (s = 1 / s), new V(d ? 1 / s : s);
          F && (s = i(F / l + 2));
        }

        for (o ? (a = new V(.5), d && (e.s = 1), f = A(e)) : f = (n = Math.abs(+q(e))) % 2, h = new V(k);;) {
          if (f) {
            if (!(h = h.times(p)).c) break;
            s ? h.c.length > s && (h.c.length = s) : r && (h = h.mod(t));
          }

          if (n) {
            if (0 === (n = c(n / 2))) break;
            f = n % 2;
          } else if (K(e = e.times(a), e.e + 1, 1), e.e > 14) f = A(e);else {
            if (0 == (n = +q(e))) break;
            f = n % 2;
          }

          p = p.times(p), s ? p.c && p.c.length > s && (p.c.length = s) : r && (p = p.mod(t));
        }

        return r ? h : (d && (h = k.div(h)), t ? h.mod(t) : s ? K(h, F, W, void 0) : h);
      }, B.integerValue = function (e) {
        var t = new V(this);
        return null == e ? e = W : g(e, 0, 8), K(t, t.e + 1, e);
      }, B.isEqualTo = B.eq = function (e, t) {
        return 0 === _(this, new V(e, t));
      }, B.isFinite = function () {
        return !!this.c;
      }, B.isGreaterThan = B.gt = function (e, t) {
        return _(this, new V(e, t)) > 0;
      }, B.isGreaterThanOrEqualTo = B.gte = function (e, t) {
        return 1 === (t = _(this, new V(e, t))) || 0 === t;
      }, B.isInteger = function () {
        return !!this.c && y(this.e / l) > this.c.length - 2;
      }, B.isLessThan = B.lt = function (e, t) {
        return _(this, new V(e, t)) < 0;
      }, B.isLessThanOrEqualTo = B.lte = function (e, t) {
        return -1 === (t = _(this, new V(e, t))) || 0 === t;
      }, B.isNaN = function () {
        return !this.s;
      }, B.isNegative = function () {
        return this.s < 0;
      }, B.isPositive = function () {
        return this.s > 0;
      }, B.isZero = function () {
        return !!this.c && 0 == this.c[0];
      }, B.minus = function (e, t) {
        var a,
            r,
            n,
            s,
            o = this,
            i = o.s;
        if (t = (e = new V(e, t)).s, !i || !t) return new V(NaN);
        if (i != t) return e.s = -t, o.plus(e);
        var c = o.e / l,
            u = e.e / l,
            d = o.c,
            h = e.c;

        if (!c || !u) {
          if (!d || !h) return d ? (e.s = -t, e) : new V(h ? o : NaN);
          if (!d[0] || !h[0]) return h[0] ? (e.s = -t, e) : new V(d[0] ? o : 3 == W ? -0 : 0);
        }

        if (c = y(c), u = y(u), d = d.slice(), i = c - u) {
          for ((s = i < 0) ? (i = -i, n = d) : (u = c, n = h), n.reverse(), t = i; t--; n.push(0)) {
            ;
          }

          n.reverse();
        } else for (r = (s = (i = d.length) < (t = h.length)) ? i : t, i = t = 0; t < r; t++) {
          if (d[t] != h[t]) {
            s = d[t] < h[t];
            break;
          }
        }

        if (s && (n = d, d = h, h = n, e.s = -e.s), (t = (r = h.length) - (a = d.length)) > 0) for (; t--; d[a++] = 0) {
          ;
        }

        for (t = f - 1; r > i;) {
          if (d[--r] < h[r]) {
            for (a = r; a && !d[--a]; d[a] = t) {
              ;
            }

            --d[a], d[r] += f;
          }

          d[r] -= h[r];
        }

        for (; 0 == d[0]; d.splice(0, 1), --u) {
          ;
        }

        return d[0] ? z(e, d, u) : (e.s = 3 == W ? -1 : 1, e.c = [e.e = 0], e);
      }, B.modulo = B.mod = function (e, t) {
        var r,
            n,
            s = this;
        return e = new V(e, t), !s.c || !e.s || e.c && !e.c[0] ? new V(NaN) : !e.c || s.c && !s.c[0] ? new V(s) : (9 == O ? (n = e.s, e.s = 1, r = a(s, e, 0, 3), e.s = n, r.s *= n) : r = a(s, e, 0, O), (e = s.minus(r.times(e))).c[0] || 1 != O || (e.s = s.s), e);
      }, B.multipliedBy = B.times = function (e, t) {
        var a,
            r,
            n,
            s,
            o,
            i,
            c,
            u,
            d,
            h,
            p,
            m,
            v,
            _,
            g,
            A = this,
            w = A.c,
            T = (e = new V(e, t)).c;

        if (!(w && T && w[0] && T[0])) return !A.s || !e.s || w && !w[0] && !T || T && !T[0] && !w ? e.c = e.e = e.s = null : (e.s *= A.s, w && T ? (e.c = [0], e.e = 0) : e.c = e.e = null), e;

        for (r = y(A.e / l) + y(e.e / l), e.s *= A.s, (c = w.length) < (h = T.length) && (v = w, w = T, T = v, n = c, c = h, h = n), n = c + h, v = []; n--; v.push(0)) {
          ;
        }

        for (_ = f, g = b, n = h; --n >= 0;) {
          for (a = 0, p = T[n] % g, m = T[n] / g | 0, s = n + (o = c); s > n;) {
            a = ((u = p * (u = w[--o] % g) + (i = m * u + (d = w[o] / g | 0) * p) % g * g + v[s] + a) / _ | 0) + (i / g | 0) + m * d, v[s--] = u % _;
          }

          v[s] = a;
        }

        return a ? ++r : v.splice(0, 1), z(e, v, r);
      }, B.negated = function () {
        var e = new V(this);
        return e.s = -e.s || null, e;
      }, B.plus = function (e, t) {
        var a,
            r = this,
            n = r.s;
        if (t = (e = new V(e, t)).s, !n || !t) return new V(NaN);
        if (n != t) return e.s = -t, r.minus(e);
        var s = r.e / l,
            o = e.e / l,
            i = r.c,
            c = e.c;

        if (!s || !o) {
          if (!i || !c) return new V(n / 0);
          if (!i[0] || !c[0]) return c[0] ? e : new V(i[0] ? r : 0 * n);
        }

        if (s = y(s), o = y(o), i = i.slice(), n = s - o) {
          for (n > 0 ? (o = s, a = c) : (n = -n, a = i), a.reverse(); n--; a.push(0)) {
            ;
          }

          a.reverse();
        }

        for ((n = i.length) - (t = c.length) < 0 && (a = c, c = i, i = a, t = n), n = 0; t;) {
          n = (i[--t] = i[t] + c[t] + n) / f | 0, i[t] = f === i[t] ? 0 : i[t] % f;
        }

        return n && (i = [n].concat(i), ++o), z(e, i, o);
      }, B.precision = B.sd = function (e, t) {
        var a,
            r,
            n,
            s = this;
        if (null != e && e !== !!e) return g(e, 1, m), null == t ? t = W : g(t, 0, 8), K(new V(s), e, t);
        if (!(a = s.c)) return null;

        if (r = (n = a.length - 1) * l + 1, n = a[n]) {
          for (; n % 10 == 0; n /= 10, r--) {
            ;
          }

          for (n = a[0]; n >= 10; n /= 10, r++) {
            ;
          }
        }

        return e && s.e + 1 > r && (r = s.e + 1), r;
      }, B.shiftedBy = function (e) {
        return g(e, -h, h), this.times("1e" + e);
      }, B.squareRoot = B.sqrt = function () {
        var e,
            t,
            r,
            n,
            s,
            o = this,
            i = o.c,
            c = o.s,
            u = o.e,
            d = R + 4,
            f = new V("0.5");
        if (1 !== c || !i || !i[0]) return new V(!c || c < 0 && (!i || i[0]) ? NaN : i ? o : 1 / 0);
        if (0 == (c = Math.sqrt(+q(o))) || c == 1 / 0 ? (((t = v(i)).length + u) % 2 == 0 && (t += "0"), c = Math.sqrt(+t), u = y((u + 1) / 2) - (u < 0 || u % 2), r = new V(t = c == 1 / 0 ? "1e" + u : (t = c.toExponential()).slice(0, t.indexOf("e") + 1) + u)) : r = new V(c + ""), r.c[0]) for ((c = (u = r.e) + d) < 3 && (c = 0);;) {
          if (s = r, r = f.times(s.plus(a(o, s, d, 1))), v(s.c).slice(0, c) === (t = v(r.c)).slice(0, c)) {
            if (r.e < u && --c, "9999" != (t = t.slice(c - 3, c + 1)) && (n || "4999" != t)) {
              +t && (+t.slice(1) || "5" != t.charAt(0)) || (K(r, r.e + R + 2, 1), e = !r.times(r).eq(o));
              break;
            }

            if (!n && (K(s, s.e + R + 2, 0), s.times(s).eq(o))) {
              r = s;
              break;
            }

            d += 4, c += 4, n = 1;
          }
        }
        return K(r, r.e + R + 1, W, e);
      }, B.toExponential = function (e, t) {
        return null != e && (g(e, 0, m), e++), U(this, e, t, 1);
      }, B.toFixed = function (e, t) {
        return null != e && (g(e, 0, m), e = e + this.e + 1), U(this, e, t);
      }, B.toFormat = function (e, t, a) {
        var r,
            n = this;
        if (null == a) null != e && t && "object" == typeof t ? (a = t, t = null) : e && "object" == typeof e ? (a = e, e = t = null) : a = j;else if ("object" != typeof a) throw Error(u + "Argument not an object: " + a);

        if (r = n.toFixed(e, t), n.c) {
          var s,
              o = r.split("."),
              i = +a.groupSize,
              c = +a.secondaryGroupSize,
              d = a.groupSeparator || "",
              f = o[0],
              l = o[1],
              h = n.s < 0,
              p = h ? f.slice(1) : f,
              b = p.length;

          if (c && (s = i, i = c, c = s, b -= s), i > 0 && b > 0) {
            for (s = b % i || i, f = p.substr(0, s); s < b; s += i) {
              f += d + p.substr(s, i);
            }

            c > 0 && (f += d + p.slice(s)), h && (f = "-" + f);
          }

          r = l ? f + (a.decimalSeparator || "") + ((c = +a.fractionGroupSize) ? l.replace(new RegExp("\\d{" + c + "}\\B", "g"), "$&" + (a.fractionGroupSeparator || "")) : l) : f;
        }

        return (a.prefix || "") + r + (a.suffix || "");
      }, B.toFraction = function (e) {
        var t,
            r,
            n,
            s,
            o,
            i,
            c,
            d,
            f,
            h,
            b,
            m,
            y = this,
            _ = y.c;
        if (null != e && (!(c = new V(e)).isInteger() && (c.c || 1 !== c.s) || c.lt(k))) throw Error(u + "Argument " + (c.isInteger() ? "out of range: " : "not an integer: ") + q(c));
        if (!_) return new V(y);

        for (t = new V(k), f = r = new V(k), n = d = new V(k), m = v(_), o = t.e = m.length - y.e - 1, t.c[0] = p[(i = o % l) < 0 ? l + i : i], e = !e || c.comparedTo(t) > 0 ? o > 0 ? t : f : c, i = P, P = 1 / 0, c = new V(m), d.c[0] = 0; h = a(c, t, 0, 1), 1 != (s = r.plus(h.times(n))).comparedTo(e);) {
          r = n, n = s, f = d.plus(h.times(s = f)), d = s, t = c.minus(h.times(s = t)), c = s;
        }

        return s = a(e.minus(r), n, 0, 1), d = d.plus(s.times(f)), r = r.plus(s.times(n)), d.s = f.s = y.s, b = a(f, n, o *= 2, W).minus(y).abs().comparedTo(a(d, r, o, W).minus(y).abs()) < 1 ? [f, n] : [d, r], P = i, b;
      }, B.toNumber = function () {
        return +q(this);
      }, B.toPrecision = function (e, t) {
        return null != e && g(e, 1, m), U(this, e, t, 2);
      }, B.toString = function (e) {
        var t,
            a = this,
            n = a.s,
            s = a.e;
        return null === s ? n ? (t = "Infinity", n < 0 && (t = "-" + t)) : t = "NaN" : (null == e ? t = s <= I || s >= N ? w(v(a.c), s) : T(v(a.c), s, "0") : 10 === e ? t = T(v((a = K(new V(a), R + s + 1, W)).c), a.e, "0") : (g(e, 2, G.length, "Base"), t = r(T(v(a.c), s, "0"), 10, e, n, !0)), n < 0 && a.c[0] && (t = "-" + t)), t;
      }, B.valueOf = B.toJSON = function () {
        return q(this);
      }, B._isBigNumber = !0, "function" == typeof Symbol && "symbol" == typeof Symbol.iterator && (B[Symbol.toStringTag] = "BigNumber", B[Symbol.for("nodejs.util.inspect.custom")] = B.valueOf), null != t && V.set(t), V;
    }()).default = s.BigNumber = s, void 0 === (r = function () {
      return s;
    }.call(t, a, t, e)) || (e.exports = r);
  }();
},
/*!*******************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/class_utils.js ***!
  \*******************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = this && this.__values || function (e) {
    var t = "function" == typeof Symbol && e[Symbol.iterator],
        a = 0;
    return t ? t.call(e) : {
      next: function next() {
        return e && a >= e.length && (e = void 0), {
          value: e && e[a++],
          done: !e
        };
      }
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = a(
  /*! lodash */
  0);
  t.classUtils = {
    bindAll: function bindAll(e, a, s) {
      var o, i;
      void 0 === a && (a = ["contructor"]);

      try {
        for (var c = r(Object.getOwnPropertyNames(e)), u = c.next(); !u.done; u = c.next()) {
          var d = u.value,
              f = e[d];
          n.includes(a, d) || (n.isFunction(f) ? e[d] = f.bind(s || e) : n.isObject(f) && t.classUtils.bindAll(f, a, e));
        }
      } catch (e) {
        o = {
          error: e
        };
      } finally {
        try {
          u && !u.done && (i = c.return) && i.call(c);
        } finally {
          if (o) throw o.error;
        }
      }

      return e;
    }
  };
},
/*!******************************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/delete_nested_property.js ***!
  \******************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.deleteNestedProperty = function (e, t) {
    if (e && t) {
      for (var a = t.split("."), r = e, n = 0; n < a.length - 1; n++) {
        if (void 0 === (r = r[a[n]])) return;
      }

      for (; a.length > 0;) {
        delete r[a.pop()];
      }
    }
  };
},
/*!**********************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/interval_utils.js ***!
  \**********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      n = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.intervalUtils = {
    setAsyncExcludingInterval: function setAsyncExcludingInterval(e, t, a) {
      var s = this,
          o = !1;
      return setInterval(function () {
        return r(s, void 0, void 0, function () {
          var t;
          return n(this, function (r) {
            switch (r.label) {
              case 0:
                return o ? [2] : [3, 1];

              case 1:
                o = !0, r.label = 2;

              case 2:
                return r.trys.push([2, 4,, 5]), [4, e()];

              case 3:
                return r.sent(), [3, 5];

              case 4:
                return t = r.sent(), a(t), [3, 5];

              case 5:
                o = !1, r.label = 6;

              case 6:
                return [2];
            }
          });
        });
      }, t);
    },
    clearAsyncExcludingInterval: function clearAsyncExcludingInterval(e) {
      clearInterval(e);
    },
    setInterval: function (_setInterval) {
      function setInterval(_x, _x2, _x3) {
        return _setInterval.apply(this, arguments);
      }

      setInterval.toString = function () {
        return _setInterval.toString();
      };

      return setInterval;
    }(function (e, t, a) {
      return setInterval(function () {
        try {
          e();
        } catch (e) {
          a(e);
        }
      }, t);
    }),
    clearInterval: function (_clearInterval) {
      function clearInterval(_x4) {
        return _clearInterval.apply(this, arguments);
      }

      clearInterval.toString = function () {
        return _clearInterval.toString();
      };

      return clearInterval;
    }(function (e) {
      clearInterval(e);
    })
  };
},
/*!**********************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/provider_utils.js ***!
  \**********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = a(
  /*! lodash */
  0);
  t.providerUtils = {
    startProviderEngine: function startProviderEngine(e) {
      if (void 0 === e.start) throw new Error("Invalid Web3ProviderEngine");
      e._ready.go(), e._running = !0;
    },
    standardizeOrThrow: function standardizeOrThrow(e) {
      if (void 0 === e) throw new Error("supportedProvider cannot be 'undefined'");
      var t = {
        isStandardizedProvider: !0,
        isMetaMask: e.isMetaMask,
        isParity: e.isParity,
        stop: e.stop,
        enable: e.enable,
        sendAsync: r.noop.bind(r)
      };
      if (e.isStandardizedProvider) return e;
      if (e.isEIP1193) return t.sendAsync = function (t, a) {
        var r = t.method,
            n = t.params;
        e.send(r, n).then(function (e) {
          a(null, e);
        }).catch(function (e) {
          a(e);
        });
      }, t;
      if (void 0 !== e.sendAsync) return t.sendAsync = e.sendAsync.bind(e), t;
      if (void 0 !== e.send) return r.includes(e.send.toString(), "function (payload, callback)") ? (t.sendAsync = e.send.bind(e), t) : (t.sendAsync = function (t, a) {
        var r = t.method,
            n = t.params;
        e.send(r, n).then(function (e) {
          a(null, e);
        }).catch(function (e) {
          a(e);
        });
      }, t);
      throw new Error("Unsupported provider found. Please make sure it conforms to one of the supported providers. See 'Provider' type in 'ethereum-types' package.");
    }
  };
},
/*!*******************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/abi_decoder.js ***!
  \*******************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = this && this.__assign || function () {
    return (r = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var n = a(
  /*! ethereum-types */
  25),
      s = a(
  /*! ethers */
  104),
      o = a(
  /*! lodash */
  0),
      i = a(
  /*! . */
  8),
      c = a(
  /*! ./address_utils */
  152),
      u = a(
  /*! ./configured_bignumber */
  37),
      d = function () {
    function e(e) {
      var t = this;
      this._eventIds = {}, this._selectorToFunctionInfo = {}, o.each(e, function (e) {
        t.addABI(e);
      });
    }

    return e._getFunctionSelector = function (e) {
      if (!e.startsWith("0x") || e.length < 10) throw new Error("Malformed calldata. Must include a hex prefix '0x' and 4-byte function selector. Got '" + e + "'");
      return e.substr(0, 10);
    }, e.prototype.tryToDecodeLogOrNoop = function (e) {
      var t = e.topics[0],
          a = e.topics.length - 1;
      if (void 0 === this._eventIds[t] || void 0 === this._eventIds[t][a]) return e;
      var i,
          d = this._eventIds[t][a],
          f = new s.utils.Interface([d]),
          l = {},
          h = 1;

      try {
        i = f.events[d.name].decode(e.data);
      } catch (t) {
        if (t.code === s.errors.INVALID_ARGUMENT) return e;
        throw t;
      }

      var p = !1;
      return o.forEach(d.inputs, function (t, a) {
        var r = t.indexed ? e.topics[h++] : i[a];

        if (void 0 !== r) {
          if (t.type === n.SolidityTypes.Address) {
            r = c.addressUtils.padZeros(new u.BigNumber(r.toLowerCase()).toString(16));
          } else t.type === n.SolidityTypes.Uint256 || t.type === n.SolidityTypes.Uint ? r = new u.BigNumber(r) : t.type === n.SolidityTypes.Uint8 && (r = new u.BigNumber(r).toNumber());

          l[t.name] = r;
        } else p = !0;
      }), p ? e : r({}, e, {
        event: d.name,
        args: l
      });
    }, e.prototype.decodeCalldataOrThrow = function (t, a) {
      var r = e._getFunctionSelector(t),
          n = this._selectorToFunctionInfo[r];

      if (void 0 === n) throw new Error("No functions registered for selector '" + r + "'");
      var s = o.find(n, function (e) {
        return void 0 === a || o.toLower(a) === o.toLower(e.contractName);
      });
      if (void 0 === s) throw new Error("No function registered with selector " + r + " and contract name " + a + ".");
      if (void 0 === s.abiEncoder) throw new Error("Function ABI Encoder is not defined, for function registered with selector " + r + " and contract name " + a + ".");
      return {
        functionName: s.abiEncoder.getDataItem().name,
        functionSignature: s.abiEncoder.getSignatureType(),
        functionArguments: s.abiEncoder.decode(t)
      };
    }, e.prototype.addABI = function (e, t) {
      var a = this;

      if (void 0 !== e) {
        var r = new s.utils.Interface(e);
        o.map(e, function (e) {
          switch (e.type) {
            case n.AbiType.Event:
              a._addEventABI(e, r);

              break;

            case n.AbiType.Function:
              a._addMethodABI(e, t);

          }
        });
      }
    }, e.prototype._addEventABI = function (e, t) {
      var a,
          n = t.events[e.name].topic,
          s = o.reduce(e.inputs, function (e, t) {
        return t.indexed ? e + 1 : e;
      }, 0);
      this._eventIds[n] = r({}, this._eventIds[n], ((a = {})[s] = e, a));
    }, e.prototype._addMethodABI = function (e, t) {
      var a = new i.AbiEncoder.Method(e),
          r = a.getSelector();
      r in this._selectorToFunctionInfo || (this._selectorToFunctionInfo[r] = []);
      var n = a.getSignature();

      this._selectorToFunctionInfo[r].push({
        functionSignature: n,
        abiEncoder: a,
        contractName: t
      });
    }, e;
  }();

  t.AbiDecoder = d;
},
/*!*****************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/log_utils.js ***!
  \*****************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    var r = this && this.__read || function (e, t) {
      var a = "function" == typeof Symbol && e[Symbol.iterator];
      if (!a) return e;
      var r,
          n,
          s = a.call(e),
          o = [];

      try {
        for (; (void 0 === t || t-- > 0) && !(r = s.next()).done;) {
          o.push(r.value);
        }
      } catch (e) {
        n = {
          error: e
        };
      } finally {
        try {
          r && !r.done && (a = s.return) && a.call(s);
        } finally {
          if (n) throw n.error;
        }
      }

      return o;
    },
        n = this && this.__spread || function () {
      for (var e = [], t = 0; t < arguments.length; t++) {
        e = e.concat(r(arguments[t]));
      }

      return e;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(
    /*! chalk */
    439),
        o = a(
    /*! lodash */
    0),
        i = o.get(e, "stdout.columns") || 80;
    t.logUtils = {
      log: function log() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e[t] = arguments[t];
        }

        console.log.apply(console, n(e));
      },
      header: function header(e, t) {
        void 0 === t && (t = "=");
        var a = (i - e.length + 1) / 2,
            r = e.padStart(i - a, t).padEnd(i, t);
        console.log(r);
      },
      warn: function warn() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e[t] = arguments[t];
        }

        console.warn.apply(console, n(e));
      },
      table: function table(e) {
        var t = o.mapValues(e, function (e, t) {
          return o.isNumber(e) ? e.toLocaleString() : e;
        });
        console.table(t);
      },
      logWithTime: function logWithTime(e) {
        t.logUtils.log("[" + s.default.gray(new Date().toLocaleTimeString()) + "] " + e);
      }
    };
  }).call(this, a(
  /*! ./../../../../process/browser.js */
  9));
},
/*!*************************************!*\
  !*** ./node_modules/chalk/index.js ***!
  \*************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (t) {
    var r = a(
    /*! escape-string-regexp */
    440),
        n = a(
    /*! ansi-styles */
    441),
        s = a(
    /*! supports-color */
    445).stdout,
        o = a(
    /*! ./templates.js */
    446),
        i = "win32" === t.platform && !(t.env.TERM || "").toLowerCase().startsWith("xterm"),
        c = ["ansi", "ansi", "ansi256", "ansi16m"],
        u = new Set(["gray"]),
        d = Object.create(null);

    function f(e, t) {
      t = t || {};
      var a = s ? s.level : 0;
      e.level = void 0 === t.level ? a : t.level, e.enabled = "enabled" in t ? t.enabled : e.level > 0;
    }

    function l(e) {
      if (!this || !(this instanceof l) || this.template) {
        var _t4 = {};
        return f(_t4, e), _t4.template = function () {
          var e = [].slice.call(arguments);
          return m.apply(null, [_t4.template].concat(e));
        }, Object.setPrototypeOf(_t4, l.prototype), Object.setPrototypeOf(_t4.template, _t4), _t4.template.constructor = l, _t4.template;
      }

      f(this, e);
    }

    i && (n.blue.open = "[94m");

    var _loop = function _loop() {
      var e = _Object$keys[_i2];
      n[e].closeRe = new RegExp(r(n[e].close), "g"), d[e] = {
        get: function get() {
          var t = n[e];
          return p.call(this, this._styles ? this._styles.concat(t) : [t], this._empty, e);
        }
      };
    };

    for (var _i2 = 0, _Object$keys = Object.keys(n); _i2 < _Object$keys.length; _i2++) {
      _loop();
    }

    d.visible = {
      get: function get() {
        return p.call(this, this._styles || [], !0, "visible");
      }
    }, n.color.closeRe = new RegExp(r(n.color.close), "g");

    var _loop2 = function _loop2() {
      var e = _Object$keys2[_i3];
      u.has(e) || (d[e] = {
        get: function get() {
          var t = this.level;
          return function () {
            var a = n.color[c[t]][e].apply(null, arguments),
                r = {
              open: a,
              close: n.color.close,
              closeRe: n.color.closeRe
            };
            return p.call(this, this._styles ? this._styles.concat(r) : [r], this._empty, e);
          };
        }
      });
    };

    for (var _i3 = 0, _Object$keys2 = Object.keys(n.color.ansi); _i3 < _Object$keys2.length; _i3++) {
      _loop2();
    }

    n.bgColor.closeRe = new RegExp(r(n.bgColor.close), "g");

    var _loop3 = function _loop3() {
      var e = _Object$keys3[_i4];
      if (u.has(e)) return "continue";
      d["bg" + e[0].toUpperCase() + e.slice(1)] = {
        get: function get() {
          var t = this.level;
          return function () {
            var a = n.bgColor[c[t]][e].apply(null, arguments),
                r = {
              open: a,
              close: n.bgColor.close,
              closeRe: n.bgColor.closeRe
            };
            return p.call(this, this._styles ? this._styles.concat(r) : [r], this._empty, e);
          };
        }
      };
    };

    for (var _i4 = 0, _Object$keys3 = Object.keys(n.bgColor.ansi); _i4 < _Object$keys3.length; _i4++) {
      var _ret = _loop3();

      if (_ret === "continue") continue;
    }

    var h = Object.defineProperties(function () {}, d);

    function p(e, t, a) {
      var r = function r() {
        return b.apply(r, arguments);
      };

      r._styles = e, r._empty = t;
      var n = this;
      return Object.defineProperty(r, "level", {
        enumerable: !0,
        get: function get() {
          return n.level;
        },
        set: function set(e) {
          n.level = e;
        }
      }), Object.defineProperty(r, "enabled", {
        enumerable: !0,
        get: function get() {
          return n.enabled;
        },
        set: function set(e) {
          n.enabled = e;
        }
      }), r.hasGrey = this.hasGrey || "gray" === a || "grey" === a, r.__proto__ = h, r;
    }

    function b() {
      var e = arguments,
          t = e.length;
      var a = String(arguments[0]);
      if (0 === t) return "";
      if (t > 1) for (var _r51 = 1; _r51 < t; _r51++) {
        a += " " + e[_r51];
      }
      if (!this.enabled || this.level <= 0 || !a) return this._empty ? "" : a;
      var r = n.dim.open;
      i && this.hasGrey && (n.dim.open = "");
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this._styles.slice().reverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _e4 = _step.value;
          a = (a = _e4.open + a.replace(_e4.closeRe, _e4.open) + _e4.close).replace(/\r?\n/g, "".concat(_e4.close, "$&").concat(_e4.open));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return n.dim.open = r, a;
    }

    function m(e, t) {
      if (!Array.isArray(t)) return [].slice.call(arguments, 1).join(" ");
      var a = [].slice.call(arguments, 2),
          r = [t.raw[0]];

      for (var _e5 = 1; _e5 < t.length; _e5++) {
        r.push(String(a[_e5 - 1]).replace(/[{}\\]/g, "\\$&")), r.push(String(t.raw[_e5]));
      }

      return o(e, r.join(""));
    }

    Object.defineProperties(l.prototype, d), e.exports = l(), e.exports.supportsColor = s, e.exports.default = e.exports;
  }).call(this, a(
  /*! ./../process/browser.js */
  9));
},
/*!****************************************************!*\
  !*** ./node_modules/escape-string-regexp/index.js ***!
  \****************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = /[|\\{}()[\]^$+*?.]/g;

  e.exports = function (e) {
    if ("string" != typeof e) throw new TypeError("Expected a string");
    return e.replace(r, "\\$&");
  };
},
/*!*******************************************!*\
  !*** ./node_modules/ansi-styles/index.js ***!
  \*******************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    var t = a(
    /*! color-convert */
    442),
        r = function r(e, a) {
      return function () {
        var r = e.apply(t, arguments);
        return "\x1B[".concat(r + a, "m");
      };
    },
        n = function n(e, a) {
      return function () {
        var r = e.apply(t, arguments);
        return "\x1B[".concat(38 + a, ";5;").concat(r, "m");
      };
    },
        s = function s(e, a) {
      return function () {
        var r = e.apply(t, arguments);
        return "\x1B[".concat(38 + a, ";2;").concat(r[0], ";").concat(r[1], ";").concat(r[2], "m");
      };
    };

    Object.defineProperty(e, "exports", {
      enumerable: !0,
      get: function get() {
        var e = new Map(),
            a = {
          modifier: {
            reset: [0, 0],
            bold: [1, 22],
            dim: [2, 22],
            italic: [3, 23],
            underline: [4, 24],
            inverse: [7, 27],
            hidden: [8, 28],
            strikethrough: [9, 29]
          },
          color: {
            black: [30, 39],
            red: [31, 39],
            green: [32, 39],
            yellow: [33, 39],
            blue: [34, 39],
            magenta: [35, 39],
            cyan: [36, 39],
            white: [37, 39],
            gray: [90, 39],
            redBright: [91, 39],
            greenBright: [92, 39],
            yellowBright: [93, 39],
            blueBright: [94, 39],
            magentaBright: [95, 39],
            cyanBright: [96, 39],
            whiteBright: [97, 39]
          },
          bgColor: {
            bgBlack: [40, 49],
            bgRed: [41, 49],
            bgGreen: [42, 49],
            bgYellow: [43, 49],
            bgBlue: [44, 49],
            bgMagenta: [45, 49],
            bgCyan: [46, 49],
            bgWhite: [47, 49],
            bgBlackBright: [100, 49],
            bgRedBright: [101, 49],
            bgGreenBright: [102, 49],
            bgYellowBright: [103, 49],
            bgBlueBright: [104, 49],
            bgMagentaBright: [105, 49],
            bgCyanBright: [106, 49],
            bgWhiteBright: [107, 49]
          }
        };
        a.color.grey = a.color.gray;

        for (var _i5 = 0, _Object$keys4 = Object.keys(a); _i5 < _Object$keys4.length; _i5++) {
          var _t5 = _Object$keys4[_i5];
          var _r52 = a[_t5];

          for (var _i7 = 0, _Object$keys6 = Object.keys(_r52); _i7 < _Object$keys6.length; _i7++) {
            var _t6 = _Object$keys6[_i7];
            var _n3 = _r52[_t6];
            a[_t6] = {
              open: "\x1B[".concat(_n3[0], "m"),
              close: "\x1B[".concat(_n3[1], "m")
            }, _r52[_t6] = a[_t6], e.set(_n3[0], _n3[1]);
          }

          Object.defineProperty(a, _t5, {
            value: _r52,
            enumerable: !1
          }), Object.defineProperty(a, "codes", {
            value: e,
            enumerable: !1
          });
        }

        var o = function o(e) {
          return e;
        },
            i = function i(e, t, a) {
          return [e, t, a];
        };

        a.color.close = "[39m", a.bgColor.close = "[49m", a.color.ansi = {
          ansi: r(o, 0)
        }, a.color.ansi256 = {
          ansi256: n(o, 0)
        }, a.color.ansi16m = {
          rgb: s(i, 0)
        }, a.bgColor.ansi = {
          ansi: r(o, 10)
        }, a.bgColor.ansi256 = {
          ansi256: n(o, 10)
        }, a.bgColor.ansi16m = {
          rgb: s(i, 10)
        };

        for (var _i6 = 0, _Object$keys5 = Object.keys(t); _i6 < _Object$keys5.length; _i6++) {
          var _e6 = _Object$keys5[_i6];
          if ("object" != typeof t[_e6]) continue;
          var _o2 = t[_e6];
          "ansi16" === _e6 && (_e6 = "ansi"), "ansi16" in _o2 && (a.color.ansi[_e6] = r(_o2.ansi16, 0), a.bgColor.ansi[_e6] = r(_o2.ansi16, 10)), "ansi256" in _o2 && (a.color.ansi256[_e6] = n(_o2.ansi256, 0), a.bgColor.ansi256[_e6] = n(_o2.ansi256, 10)), "rgb" in _o2 && (a.color.ansi16m[_e6] = s(_o2.rgb, 0), a.bgColor.ansi16m[_e6] = s(_o2.rgb, 10));
        }

        return a;
      }
    });
  }).call(this, a(
  /*! ./../webpack/buildin/module.js */
  45)(e));
},
/*!*********************************************!*\
  !*** ./node_modules/color-convert/index.js ***!
  \*********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./conversions */
  173),
      n = a(
  /*! ./route */
  444),
      s = {};
  Object.keys(r).forEach(function (e) {
    s[e] = {}, Object.defineProperty(s[e], "channels", {
      value: r[e].channels
    }), Object.defineProperty(s[e], "labels", {
      value: r[e].labels
    });
    var t = n(e);
    Object.keys(t).forEach(function (a) {
      var r = t[a];
      s[e][a] = function (e) {
        var t = function t(_t7) {
          if (null == _t7) return _t7;
          arguments.length > 1 && (_t7 = Array.prototype.slice.call(arguments));
          var a = e(_t7);
          if ("object" == typeof a) for (var r = a.length, n = 0; n < r; n++) {
            a[n] = Math.round(a[n]);
          }
          return a;
        };

        return "conversion" in e && (t.conversion = e.conversion), t;
      }(r), s[e][a].raw = function (e) {
        var t = function t(_t8) {
          return null == _t8 ? _t8 : (arguments.length > 1 && (_t8 = Array.prototype.slice.call(arguments)), e(_t8));
        };

        return "conversion" in e && (t.conversion = e.conversion), t;
      }(r);
    });
  }), e.exports = s;
},
/*!******************************************!*\
  !*** ./node_modules/color-name/index.js ***!
  \******************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  e.exports = {
    aliceblue: [240, 248, 255],
    antiquewhite: [250, 235, 215],
    aqua: [0, 255, 255],
    aquamarine: [127, 255, 212],
    azure: [240, 255, 255],
    beige: [245, 245, 220],
    bisque: [255, 228, 196],
    black: [0, 0, 0],
    blanchedalmond: [255, 235, 205],
    blue: [0, 0, 255],
    blueviolet: [138, 43, 226],
    brown: [165, 42, 42],
    burlywood: [222, 184, 135],
    cadetblue: [95, 158, 160],
    chartreuse: [127, 255, 0],
    chocolate: [210, 105, 30],
    coral: [255, 127, 80],
    cornflowerblue: [100, 149, 237],
    cornsilk: [255, 248, 220],
    crimson: [220, 20, 60],
    cyan: [0, 255, 255],
    darkblue: [0, 0, 139],
    darkcyan: [0, 139, 139],
    darkgoldenrod: [184, 134, 11],
    darkgray: [169, 169, 169],
    darkgreen: [0, 100, 0],
    darkgrey: [169, 169, 169],
    darkkhaki: [189, 183, 107],
    darkmagenta: [139, 0, 139],
    darkolivegreen: [85, 107, 47],
    darkorange: [255, 140, 0],
    darkorchid: [153, 50, 204],
    darkred: [139, 0, 0],
    darksalmon: [233, 150, 122],
    darkseagreen: [143, 188, 143],
    darkslateblue: [72, 61, 139],
    darkslategray: [47, 79, 79],
    darkslategrey: [47, 79, 79],
    darkturquoise: [0, 206, 209],
    darkviolet: [148, 0, 211],
    deeppink: [255, 20, 147],
    deepskyblue: [0, 191, 255],
    dimgray: [105, 105, 105],
    dimgrey: [105, 105, 105],
    dodgerblue: [30, 144, 255],
    firebrick: [178, 34, 34],
    floralwhite: [255, 250, 240],
    forestgreen: [34, 139, 34],
    fuchsia: [255, 0, 255],
    gainsboro: [220, 220, 220],
    ghostwhite: [248, 248, 255],
    gold: [255, 215, 0],
    goldenrod: [218, 165, 32],
    gray: [128, 128, 128],
    green: [0, 128, 0],
    greenyellow: [173, 255, 47],
    grey: [128, 128, 128],
    honeydew: [240, 255, 240],
    hotpink: [255, 105, 180],
    indianred: [205, 92, 92],
    indigo: [75, 0, 130],
    ivory: [255, 255, 240],
    khaki: [240, 230, 140],
    lavender: [230, 230, 250],
    lavenderblush: [255, 240, 245],
    lawngreen: [124, 252, 0],
    lemonchiffon: [255, 250, 205],
    lightblue: [173, 216, 230],
    lightcoral: [240, 128, 128],
    lightcyan: [224, 255, 255],
    lightgoldenrodyellow: [250, 250, 210],
    lightgray: [211, 211, 211],
    lightgreen: [144, 238, 144],
    lightgrey: [211, 211, 211],
    lightpink: [255, 182, 193],
    lightsalmon: [255, 160, 122],
    lightseagreen: [32, 178, 170],
    lightskyblue: [135, 206, 250],
    lightslategray: [119, 136, 153],
    lightslategrey: [119, 136, 153],
    lightsteelblue: [176, 196, 222],
    lightyellow: [255, 255, 224],
    lime: [0, 255, 0],
    limegreen: [50, 205, 50],
    linen: [250, 240, 230],
    magenta: [255, 0, 255],
    maroon: [128, 0, 0],
    mediumaquamarine: [102, 205, 170],
    mediumblue: [0, 0, 205],
    mediumorchid: [186, 85, 211],
    mediumpurple: [147, 112, 219],
    mediumseagreen: [60, 179, 113],
    mediumslateblue: [123, 104, 238],
    mediumspringgreen: [0, 250, 154],
    mediumturquoise: [72, 209, 204],
    mediumvioletred: [199, 21, 133],
    midnightblue: [25, 25, 112],
    mintcream: [245, 255, 250],
    mistyrose: [255, 228, 225],
    moccasin: [255, 228, 181],
    navajowhite: [255, 222, 173],
    navy: [0, 0, 128],
    oldlace: [253, 245, 230],
    olive: [128, 128, 0],
    olivedrab: [107, 142, 35],
    orange: [255, 165, 0],
    orangered: [255, 69, 0],
    orchid: [218, 112, 214],
    palegoldenrod: [238, 232, 170],
    palegreen: [152, 251, 152],
    paleturquoise: [175, 238, 238],
    palevioletred: [219, 112, 147],
    papayawhip: [255, 239, 213],
    peachpuff: [255, 218, 185],
    peru: [205, 133, 63],
    pink: [255, 192, 203],
    plum: [221, 160, 221],
    powderblue: [176, 224, 230],
    purple: [128, 0, 128],
    rebeccapurple: [102, 51, 153],
    red: [255, 0, 0],
    rosybrown: [188, 143, 143],
    royalblue: [65, 105, 225],
    saddlebrown: [139, 69, 19],
    salmon: [250, 128, 114],
    sandybrown: [244, 164, 96],
    seagreen: [46, 139, 87],
    seashell: [255, 245, 238],
    sienna: [160, 82, 45],
    silver: [192, 192, 192],
    skyblue: [135, 206, 235],
    slateblue: [106, 90, 205],
    slategray: [112, 128, 144],
    slategrey: [112, 128, 144],
    snow: [255, 250, 250],
    springgreen: [0, 255, 127],
    steelblue: [70, 130, 180],
    tan: [210, 180, 140],
    teal: [0, 128, 128],
    thistle: [216, 191, 216],
    tomato: [255, 99, 71],
    turquoise: [64, 224, 208],
    violet: [238, 130, 238],
    wheat: [245, 222, 179],
    white: [255, 255, 255],
    whitesmoke: [245, 245, 245],
    yellow: [255, 255, 0],
    yellowgreen: [154, 205, 50]
  };
},
/*!*********************************************!*\
  !*** ./node_modules/color-convert/route.js ***!
  \*********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./conversions */
  173);

  function n(e) {
    var t = function () {
      for (var e = {}, t = Object.keys(r), a = t.length, n = 0; n < a; n++) {
        e[t[n]] = {
          distance: -1,
          parent: null
        };
      }

      return e;
    }(),
        a = [e];

    for (t[e].distance = 0; a.length;) {
      for (var n = a.pop(), s = Object.keys(r[n]), o = s.length, i = 0; i < o; i++) {
        var c = s[i],
            u = t[c];
        -1 === u.distance && (u.distance = t[n].distance + 1, u.parent = n, a.unshift(c));
      }
    }

    return t;
  }

  function s(e, t) {
    return function (a) {
      return t(e(a));
    };
  }

  function o(e, t) {
    for (var a = [t[e].parent, e], n = r[t[e].parent][e], o = t[e].parent; t[o].parent;) {
      a.unshift(t[o].parent), n = s(r[t[o].parent][o], n), o = t[o].parent;
    }

    return n.conversion = a, n;
  }

  e.exports = function (e) {
    for (var t = n(e), a = {}, r = Object.keys(t), s = r.length, i = 0; i < s; i++) {
      var c = r[i];
      null !== t[c].parent && (a[c] = o(c, t));
    }

    return a;
  };
},
/*!*******************************************************************!*\
  !*** ./node_modules/chalk/node_modules/supports-color/browser.js ***!
  \*******************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  e.exports = {
    stdout: !1,
    stderr: !1
  };
},
/*!*****************************************!*\
  !*** ./node_modules/chalk/templates.js ***!
  \*****************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = /(?:\\(u[a-f\d]{4}|x[a-f\d]{2}|.))|(?:\{(~)?(\w+(?:\([^)]*\))?(?:\.\w+(?:\([^)]*\))?)*)(?:[ \t]|(?=\r?\n)))|(\})|((?:.|[\r\n\f])+?)/gi,
      n = /(?:^|\.)(\w+)(?:\(([^)]*)\))?/g,
      s = /^(['"])((?:\\.|(?!\1)[^\\])*)\1$/,
      o = /\\(u[a-f\d]{4}|x[a-f\d]{2}|.)|([^\\])/gi,
      i = new Map([["n", "\n"], ["r", "\r"], ["t", "\t"], ["b", "\b"], ["f", "\f"], ["v", "\v"], ["0", "\0"], ["\\", "\\"], ["e", ""], ["a", ""]]);

  function c(e) {
    return "u" === e[0] && 5 === e.length || "x" === e[0] && 3 === e.length ? String.fromCharCode(parseInt(e.slice(1), 16)) : i.get(e) || e;
  }

  function u(e, t) {
    var a = [],
        r = t.trim().split(/\s*,\s*/g);
    var n;
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = r[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var _t9 = _step2.value;

        if (isNaN(_t9)) {
          if (!(n = _t9.match(s))) throw new Error("Invalid Chalk template style argument: ".concat(_t9, " (in style '").concat(e, "')"));
          a.push(n[2].replace(o, function (e, t, a) {
            return t ? c(t) : a;
          }));
        } else a.push(Number(_t9));
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    return a;
  }

  function d(e) {
    n.lastIndex = 0;
    var t = [];
    var a;

    for (; null !== (a = n.exec(e));) {
      var _e7 = a[1];

      if (a[2]) {
        var _r53 = u(_e7, a[2]);

        t.push([_e7].concat(_r53));
      } else t.push([_e7]);
    }

    return t;
  }

  function f(e, t) {
    var a = {};
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = t[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var _e8 = _step3.value;
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = _e8.styles[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var _t10 = _step4.value;
            a[_t10[0]] = _e8.inverse ? null : _t10.slice(1);
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    var r = e;

    for (var _i8 = 0, _Object$keys7 = Object.keys(a); _i8 < _Object$keys7.length; _i8++) {
      var _e9 = _Object$keys7[_i8];

      if (Array.isArray(a[_e9])) {
        if (!(_e9 in r)) throw new Error("Unknown Chalk style: ".concat(_e9));
        r = a[_e9].length > 0 ? r[_e9].apply(r, a[_e9]) : r[_e9];
      }
    }

    return r;
  }

  e.exports = function (e, t) {
    var a = [],
        n = [];
    var s = [];

    if (t.replace(r, function (t, r, o, i, u, l) {
      if (r) s.push(c(r));else if (i) {
        var _t11 = s.join("");

        s = [], n.push(0 === a.length ? _t11 : f(e, a)(_t11)), a.push({
          inverse: o,
          styles: d(i)
        });
      } else if (u) {
        if (0 === a.length) throw new Error("Found extraneous } in Chalk template literal");
        n.push(f(e, a)(s.join(""))), s = [], a.pop();
      } else s.push(l);
    }), n.push(s.join("")), a.length > 0) {
      var _e10 = "Chalk template literal is missing ".concat(a.length, " closing bracket").concat(1 === a.length ? "" : "s", " (`}`)");

      throw new Error(_e10);
    }

    return n.join("");
  };
},
/*!*****************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/abi_utils.js ***!
  \*****************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = this && this.__values || function (e) {
    var t = "function" == typeof Symbol && e[Symbol.iterator],
        a = 0;
    return t ? t.call(e) : {
      next: function next() {
        return e && a >= e.length && (e = void 0), {
          value: e && e[a++],
          done: !e
        };
      }
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = a(
  /*! ethereum-types */
  25),
      s = a(
  /*! lodash */
  0),
      o = a(
  /*! ./configured_bignumber */
  37);

  function i(e) {
    var t, a;
    if (s.endsWith(e, "[]")) throw new Error("Internal error: array types are not supported");
    if (!s.startsWith(e, "tuple(")) throw new Error("Internal error: expected tuple type but got non-tuple type: " + e);
    var n = e.substring("tuple(".length, e.length - 1),
        o = [],
        i = "",
        c = 0;

    try {
      for (var u = r(n), d = u.next(); !d.done; d = u.next()) {
        var f = d.value;

        switch (f) {
          case "(":
            c += 1, i += f;
            break;

          case ")":
            c -= 1, i += f;
            break;

          case ",":
            if (0 === c) {
              o.push(i), i = "";
              break;
            }

            i += f;
            break;

          default:
            i += f;
        }
      }
    } catch (e) {
      t = {
        error: e
      };
    } finally {
      try {
        d && !d.done && (a = u.return) && a.call(u);
      } finally {
        if (t) throw t.error;
      }
    }

    return o.push(i), o;
  }

  t.abiUtils = {
    parseEthersParams: function e(t) {
      var a = [],
          r = [];
      return t.forEach(function (t) {
        if (null != t.components) {
          var n = "",
              s = t.type.indexOf("[");
          s >= 0 && (n = t.type.substring(s));
          var o = e(t.components);
          a.push({
            name: t.name || null,
            names: o.names
          }), r.push("tuple(" + o.types.join(",") + ")" + n);
        } else a.push(t.name || null), r.push(t.type);
      }), {
        names: a,
        types: r
      };
    },
    isAbiDataEqual: function e(t, a, r, n) {
      if (void 0 === r && void 0 === n) return !0;
      if (void 0 === r && void 0 !== n) return !1;
      if (void 0 !== r && void 0 === n) return !1;

      if (s.endsWith(a, "[]")) {
        if (r.length !== n.length) return !1;

        for (var c = s.trimEnd(a, "[]"), u = 0; u < r.length; u++) {
          if (!e(t, c, r[u], n[u])) return !1;
        }

        return !0;
      }

      if (s.startsWith(a, "tuple(")) {
        if (s.isString(t)) throw new Error("Internal error: type was tuple but names was a string");
        if (null === t) throw new Error("Internal error: type was tuple but names was null");
        var d = i(a);
        if (d.length !== t.names.length) throw new Error("Internal error: parameter types/names length mismatch (" + d.length + " != " + t.names.length + ")");

        for (u = 0; u < d.length; u++) {
          var f = s.isString(t.names[u]) ? t.names[u] : t.names[u].name;
          if (!e(t.names[u], d[u], r[f], n[f])) return !1;
        }

        return !0;
      }

      return "address" === a || "bytes" === a ? s.isEqual(s.toLower(r), s.toLower(n)) : s.startsWith(a, "uint") || s.startsWith(a, "int") ? new o.BigNumber(r).eq(new o.BigNumber(n)) : s.isEqual(r, n);
    },
    splitTupleTypes: i,
    parseFunctionParam: function parseFunctionParam(e) {
      if ("tuple" === e.type) {
        var a = e.components;
        return "{" + s.map(a, function (e) {
          return t.abiUtils.parseFunctionParam(e);
        }) + "}";
      }

      return e.type;
    },
    getFunctionSignature: function getFunctionSignature(e) {
      return e.name + "(" + s.map(e.inputs, function (e) {
        return t.abiUtils.parseFunctionParam(e);
      }) + ")";
    },
    renameOverloadedMethods: function renameOverloadedMethods(e) {
      var a = s.cloneDeep(e),
          r = a.filter(function (e) {
        return e.type === n.AbiType.Function;
      }),
          o = s.sortBy(r, [function (e) {
        return t.abiUtils.getFunctionSignature(e);
      }]),
          i = {};
      return s.each(o, function (e) {
        (i[e.name] || (i[e.name] = [])).push(e);
      }), s.each(i, function (e) {
        s.each(e, function (t, a) {
          if (e.length > 1) {
            var n = a + 1,
                o = "" + t.name + n;

            if (s.findIndex(r, function (e) {
              return e.name === o;
            }) >= 0) {
              var i = t.name;
              throw new Error("Failed to rename overloaded method '" + i + "' to '" + o + "'. A method with this name already exists.");
            }

            t.name = o;
          }
        });
      }), a;
    }
  };
},
/*!*****************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/constants.js ***!
  \*****************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.NULL_BYTES = "0x";
},
/*!*******************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/error_utils.js ***!
  \*******************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.errorUtils = {
    spawnSwitchErr: function spawnSwitchErr(e, t) {
      return new Error("Unexpected switch value: " + t + " encountered for " + e);
    }
  };
},
/*!*******************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/fetch_async.js ***!
  \*******************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = this && this.__assign || function () {
    return (r = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      n = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      s = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      o = this;

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var i = a(
  /*! detect-node */
  172);
  a(
  /*! isomorphic-fetch */
  451), a(
  /*! abortcontroller-polyfill/dist/abortcontroller-polyfill-only */
  453), t.fetchAsync = function (e, t, a) {
    return void 0 === t && (t = {}), void 0 === a && (a = 2e4), n(o, void 0, void 0, function () {
      var n, o, c;
      return s(this, function (s) {
        switch (s.label) {
          case 0:
            if (t.signal || t.timeout) throw new Error('Cannot call fetchAsync with options.signal or options.timeout. To set a timeout, please use the supplied "timeoutMs" parameter.');
            return i ? n = r({
              timeout: a
            }, t) : (o = new AbortController(), c = o.signal, setTimeout(function () {
              o.abort();
            }, a), n = r({
              signal: c
            }, t)), [4, fetch(e, n)];

          case 1:
            return [2, s.sent()];
        }
      });
    });
  };
},
/*!***************************************************************!*\
  !*** ./node_modules/isomorphic-fetch/fetch-npm-browserify.js ***!
  \***************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  a(
  /*! whatwg-fetch */
  452), e.exports = self.fetch.bind(self);
},
/*!**************************************************************************!*\
  !*** ./node_modules/isomorphic-fetch/node_modules/whatwg-fetch/fetch.js ***!
  \**************************************************************************/

/*! exports provided: Headers, Request, Response, DOMException, fetch */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./node_modules/isomorphic-fetch/fetch-npm-browserify.js (referenced with cjs require) */
function (e, t, a) {
  "use strict";

  a.r(t), a.d(t, "Headers", function () {
    return u;
  }), a.d(t, "Request", function () {
    return m;
  }), a.d(t, "Response", function () {
    return v;
  }), a.d(t, "DOMException", function () {
    return g;
  }), a.d(t, "fetch", function () {
    return A;
  });
  var r = {
    searchParams: "URLSearchParams" in self,
    iterable: "Symbol" in self && "iterator" in Symbol,
    blob: "FileReader" in self && "Blob" in self && function () {
      try {
        return new Blob(), !0;
      } catch (e) {
        return !1;
      }
    }(),
    formData: "FormData" in self,
    arrayBuffer: "ArrayBuffer" in self
  };
  if (r.arrayBuffer) var n = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"],
      s = ArrayBuffer.isView || function (e) {
    return e && n.indexOf(Object.prototype.toString.call(e)) > -1;
  };

  function o(e) {
    if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e)) throw new TypeError("Invalid character in header field name");
    return e.toLowerCase();
  }

  function i(e) {
    return "string" != typeof e && (e = String(e)), e;
  }

  function c(e) {
    var t = {
      next: function next() {
        var t = e.shift();
        return {
          done: void 0 === t,
          value: t
        };
      }
    };
    return r.iterable && (t[Symbol.iterator] = function () {
      return t;
    }), t;
  }

  function u(e) {
    this.map = {}, e instanceof u ? e.forEach(function (e, t) {
      this.append(t, e);
    }, this) : Array.isArray(e) ? e.forEach(function (e) {
      this.append(e[0], e[1]);
    }, this) : e && Object.getOwnPropertyNames(e).forEach(function (t) {
      this.append(t, e[t]);
    }, this);
  }

  function d(e) {
    if (e.bodyUsed) return Promise.reject(new TypeError("Already read"));
    e.bodyUsed = !0;
  }

  function f(e) {
    return new Promise(function (t, a) {
      e.onload = function () {
        t(e.result);
      }, e.onerror = function () {
        a(e.error);
      };
    });
  }

  function l(e) {
    var t = new FileReader(),
        a = f(t);
    return t.readAsArrayBuffer(e), a;
  }

  function h(e) {
    if (e.slice) return e.slice(0);
    var t = new Uint8Array(e.byteLength);
    return t.set(new Uint8Array(e)), t.buffer;
  }

  function p() {
    return this.bodyUsed = !1, this._initBody = function (e) {
      var t;
      this._bodyInit = e, e ? "string" == typeof e ? this._bodyText = e : r.blob && Blob.prototype.isPrototypeOf(e) ? this._bodyBlob = e : r.formData && FormData.prototype.isPrototypeOf(e) ? this._bodyFormData = e : r.searchParams && URLSearchParams.prototype.isPrototypeOf(e) ? this._bodyText = e.toString() : r.arrayBuffer && r.blob && (t = e) && DataView.prototype.isPrototypeOf(t) ? (this._bodyArrayBuffer = h(e.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : r.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(e) || s(e)) ? this._bodyArrayBuffer = h(e) : this._bodyText = e = Object.prototype.toString.call(e) : this._bodyText = "", this.headers.get("content-type") || ("string" == typeof e ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : r.searchParams && URLSearchParams.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
    }, r.blob && (this.blob = function () {
      var e = d(this);
      if (e) return e;
      if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
      if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));
      if (this._bodyFormData) throw new Error("could not read FormData body as blob");
      return Promise.resolve(new Blob([this._bodyText]));
    }, this.arrayBuffer = function () {
      return this._bodyArrayBuffer ? d(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(l);
    }), this.text = function () {
      var e,
          t,
          a,
          r = d(this);
      if (r) return r;
      if (this._bodyBlob) return e = this._bodyBlob, t = new FileReader(), a = f(t), t.readAsText(e), a;
      if (this._bodyArrayBuffer) return Promise.resolve(function (e) {
        for (var t = new Uint8Array(e), a = new Array(t.length), r = 0; r < t.length; r++) {
          a[r] = String.fromCharCode(t[r]);
        }

        return a.join("");
      }(this._bodyArrayBuffer));
      if (this._bodyFormData) throw new Error("could not read FormData body as text");
      return Promise.resolve(this._bodyText);
    }, r.formData && (this.formData = function () {
      return this.text().then(y);
    }), this.json = function () {
      return this.text().then(JSON.parse);
    }, this;
  }

  u.prototype.append = function (e, t) {
    e = o(e), t = i(t);
    var a = this.map[e];
    this.map[e] = a ? a + ", " + t : t;
  }, u.prototype.delete = function (e) {
    delete this.map[o(e)];
  }, u.prototype.get = function (e) {
    return e = o(e), this.has(e) ? this.map[e] : null;
  }, u.prototype.has = function (e) {
    return this.map.hasOwnProperty(o(e));
  }, u.prototype.set = function (e, t) {
    this.map[o(e)] = i(t);
  }, u.prototype.forEach = function (e, t) {
    for (var a in this.map) {
      this.map.hasOwnProperty(a) && e.call(t, this.map[a], a, this);
    }
  }, u.prototype.keys = function () {
    var e = [];
    return this.forEach(function (t, a) {
      e.push(a);
    }), c(e);
  }, u.prototype.values = function () {
    var e = [];
    return this.forEach(function (t) {
      e.push(t);
    }), c(e);
  }, u.prototype.entries = function () {
    var e = [];
    return this.forEach(function (t, a) {
      e.push([a, t]);
    }), c(e);
  }, r.iterable && (u.prototype[Symbol.iterator] = u.prototype.entries);
  var b = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];

  function m(e, t) {
    var a,
        r,
        n = (t = t || {}).body;

    if (e instanceof m) {
      if (e.bodyUsed) throw new TypeError("Already read");
      this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new u(e.headers)), this.method = e.method, this.mode = e.mode, this.signal = e.signal, n || null == e._bodyInit || (n = e._bodyInit, e.bodyUsed = !0);
    } else this.url = String(e);

    if (this.credentials = t.credentials || this.credentials || "same-origin", !t.headers && this.headers || (this.headers = new u(t.headers)), this.method = (a = t.method || this.method || "GET", r = a.toUpperCase(), b.indexOf(r) > -1 ? r : a), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && n) throw new TypeError("Body not allowed for GET or HEAD requests");

    this._initBody(n);
  }

  function y(e) {
    var t = new FormData();
    return e.trim().split("&").forEach(function (e) {
      if (e) {
        var a = e.split("="),
            r = a.shift().replace(/\+/g, " "),
            n = a.join("=").replace(/\+/g, " ");
        t.append(decodeURIComponent(r), decodeURIComponent(n));
      }
    }), t;
  }

  function v(e, t) {
    t || (t = {}), this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in t ? t.statusText : "OK", this.headers = new u(t.headers), this.url = t.url || "", this._initBody(e);
  }

  m.prototype.clone = function () {
    return new m(this, {
      body: this._bodyInit
    });
  }, p.call(m.prototype), p.call(v.prototype), v.prototype.clone = function () {
    return new v(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new u(this.headers),
      url: this.url
    });
  }, v.error = function () {
    var e = new v(null, {
      status: 0,
      statusText: ""
    });
    return e.type = "error", e;
  };
  var _ = [301, 302, 303, 307, 308];

  v.redirect = function (e, t) {
    if (-1 === _.indexOf(t)) throw new RangeError("Invalid status code");
    return new v(null, {
      status: t,
      headers: {
        location: e
      }
    });
  };

  var g = self.DOMException;

  try {
    new g();
  } catch (e) {
    (g = function g(e, t) {
      this.message = e, this.name = t;
      var a = Error(e);
      this.stack = a.stack;
    }).prototype = Object.create(Error.prototype), g.prototype.constructor = g;
  }

  function A(e, t) {
    return new Promise(function (a, n) {
      var s = new m(e, t);
      if (s.signal && s.signal.aborted) return n(new g("Aborted", "AbortError"));
      var o = new XMLHttpRequest();

      function i() {
        o.abort();
      }

      o.onload = function () {
        var e,
            t,
            r = {
          status: o.status,
          statusText: o.statusText,
          headers: (e = o.getAllResponseHeaders() || "", t = new u(), e.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function (e) {
            var a = e.split(":"),
                r = a.shift().trim();

            if (r) {
              var n = a.join(":").trim();
              t.append(r, n);
            }
          }), t)
        };
        r.url = "responseURL" in o ? o.responseURL : r.headers.get("X-Request-URL");
        var n = "response" in o ? o.response : o.responseText;
        a(new v(n, r));
      }, o.onerror = function () {
        n(new TypeError("Network request failed"));
      }, o.ontimeout = function () {
        n(new TypeError("Network request failed"));
      }, o.onabort = function () {
        n(new g("Aborted", "AbortError"));
      }, o.open(s.method, s.url, !0), "include" === s.credentials ? o.withCredentials = !0 : "omit" === s.credentials && (o.withCredentials = !1), "responseType" in o && r.blob && (o.responseType = "blob"), s.headers.forEach(function (e, t) {
        o.setRequestHeader(t, e);
      }), s.signal && (s.signal.addEventListener("abort", i), o.onreadystatechange = function () {
        4 === o.readyState && s.signal.removeEventListener("abort", i);
      }), o.send(void 0 === s._bodyInit ? null : s._bodyInit);
    });
  }

  A.polyfill = !0, self.fetch || (self.fetch = A, self.Headers = u, self.Request = m, self.Response = v);
},
/*!*************************************************************************************!*\
  !*** ./node_modules/abortcontroller-polyfill/dist/abortcontroller-polyfill-only.js ***!
  \*************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (r) {
    var n, s;
    void 0 === (s = "function" == typeof (n = function n() {
      "use strict";

      function e(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function t(e, t) {
        for (var a = 0; a < t.length; a++) {
          var r = t[a];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      function a(e, a, r) {
        return a && t(e.prototype, a), r && t(e, r), e;
      }

      function n(e) {
        return (n = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }

      function s(e, t) {
        return (s = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }

      function o(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }

      function i(e, t, a) {
        return (i = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (e, t, a) {
          var r = function (e, t) {
            for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = n(e));) {
              ;
            }

            return e;
          }(e, t);

          if (r) {
            var s = Object.getOwnPropertyDescriptor(r, t);
            return s.get ? s.get.call(a) : s.value;
          }
        })(e, t, a || e);
      }

      var c = function () {
        function t() {
          e(this, t), Object.defineProperty(this, "listeners", {
            value: {},
            writable: !0,
            configurable: !0
          });
        }

        return a(t, [{
          key: "addEventListener",
          value: function value(e, t) {
            e in this.listeners || (this.listeners[e] = []), this.listeners[e].push(t);
          }
        }, {
          key: "removeEventListener",
          value: function value(e, t) {
            if (e in this.listeners) for (var a = this.listeners[e], r = 0, n = a.length; r < n; r++) {
              if (a[r] === t) return void a.splice(r, 1);
            }
          }
        }, {
          key: "dispatchEvent",
          value: function value(e) {
            var t = this;

            if (e.type in this.listeners) {
              for (var a = function a(_a6) {
                setTimeout(function () {
                  return _a6.call(t, e);
                });
              }, r = this.listeners[e.type], n = 0, s = r.length; n < s; n++) {
                a(r[n]);
              }

              return !e.defaultPrevented;
            }
          }
        }]), t;
      }(),
          u = function (t) {
        function r() {
          var t;
          return e(this, r), (t = function (e, t) {
            return !t || "object" != typeof t && "function" != typeof t ? o(e) : t;
          }(this, n(r).call(this))).listeners || c.call(o(t)), Object.defineProperty(o(t), "aborted", {
            value: !1,
            writable: !0,
            configurable: !0
          }), Object.defineProperty(o(t), "onabort", {
            value: null,
            writable: !0,
            configurable: !0
          }), t;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && s(e, t);
        }(r, c), a(r, [{
          key: "toString",
          value: function value() {
            return "[object AbortSignal]";
          }
        }, {
          key: "dispatchEvent",
          value: function value(e) {
            "abort" === e.type && (this.aborted = !0, "function" == typeof this.onabort && this.onabort.call(this, e)), i(n(r.prototype), "dispatchEvent", this).call(this, e);
          }
        }]), r;
      }(),
          d = function () {
        function t() {
          e(this, t), Object.defineProperty(this, "signal", {
            value: new u(),
            writable: !0,
            configurable: !0
          });
        }

        return a(t, [{
          key: "abort",
          value: function value() {
            var e;

            try {
              e = new Event("abort");
            } catch (t) {
              "undefined" != typeof document ? document.createEvent ? (e = document.createEvent("Event")).initEvent("abort", !1, !1) : (e = document.createEventObject()).type = "abort" : e = {
                type: "abort",
                bubbles: !1,
                cancelable: !1
              };
            }

            this.signal.dispatchEvent(e);
          }
        }, {
          key: "toString",
          value: function value() {
            return "[object AbortController]";
          }
        }]), t;
      }();

      "undefined" != typeof Symbol && Symbol.toStringTag && (d.prototype[Symbol.toStringTag] = "AbortController", u.prototype[Symbol.toStringTag] = "AbortSignal"), function (e) {
        (function (e) {
          return e.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL ? (console.log("__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL=true is set, will force install polyfill"), !0) : "function" == typeof e.Request && !e.Request.prototype.hasOwnProperty("signal") || !e.AbortController;
        })(e) && (e.AbortController = d, e.AbortSignal = u);
      }("undefined" != typeof self ? self : r);
    }) ? n.call(t, a, t, e) : n) || (e.exports = s);
  }).call(this, a(
  /*! ./../../webpack/buildin/global.js */
  18));
},
/*!*****************************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/sign_typed_data_utils.js ***!
  \*****************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    var r = this && this.__values || function (e) {
      var t = "function" == typeof Symbol && e[Symbol.iterator],
          a = 0;
      return t ? t.call(e) : {
        next: function next() {
          return e && a >= e.length && (e = void 0), {
            value: e && e[a++],
            done: !e
          };
        }
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = a(
    /*! ethereumjs-util */
    24),
        s = a(
    /*! ethers */
    104),
        o = a(
    /*! ./configured_bignumber */
    37);
    t.signTypedDataUtils = {
      generateTypedDataHash: function generateTypedDataHash(a) {
        return n.sha3(e.concat([e.from("1901", "hex"), t.signTypedDataUtils._structHash("EIP712Domain", a.domain, a.types), t.signTypedDataUtils._structHash(a.primaryType, a.message, a.types)]));
      },
      _findDependencies: function _findDependencies(e, a, n) {
        var s, o, i, c;
        if (void 0 === n && (n = []), n.includes(e) || void 0 === a[e]) return n;
        n.push(e);

        try {
          for (var u = r(a[e]), d = u.next(); !d.done; d = u.next()) {
            var f = d.value;

            try {
              for (var l = r(t.signTypedDataUtils._findDependencies(f.type, a, n)), h = l.next(); !h.done; h = l.next()) {
                var p = h.value;
                n.includes(p) || n.push(p);
              }
            } catch (e) {
              i = {
                error: e
              };
            } finally {
              try {
                h && !h.done && (c = l.return) && c.call(l);
              } finally {
                if (i) throw i.error;
              }
            }
          }
        } catch (e) {
          s = {
            error: e
          };
        } finally {
          try {
            d && !d.done && (o = u.return) && o.call(u);
          } finally {
            if (s) throw s.error;
          }
        }

        return n;
      },
      _encodeType: function _encodeType(e, a) {
        var n,
            s,
            o = t.signTypedDataUtils._findDependencies(e, a);

        o = o.filter(function (t) {
          return t !== e;
        }), o = [e].concat(o.sort());
        var i = "";

        try {
          for (var c = r(o), u = c.next(); !u.done; u = c.next()) {
            var d = u.value;
            i += d + "(" + a[d].map(function (e) {
              var t = e.name;
              return e.type + " " + t;
            }).join(",") + ")";
          }
        } catch (e) {
          n = {
            error: e
          };
        } finally {
          try {
            u && !u.done && (s = c.return) && s.call(c);
          } finally {
            if (n) throw n.error;
          }
        }

        return i;
      },
      _encodeData: function _encodeData(e, a, o) {
        var i,
            c,
            u = ["bytes32"],
            d = [t.signTypedDataUtils._typeHash(e, o)];

        try {
          for (var f = r(o[e]), l = f.next(); !l.done; l = f.next()) {
            var h = l.value,
                p = a[h.name];

            if ("string" === h.type || "bytes" === h.type) {
              var b = n.sha3(p);
              u.push("bytes32"), d.push(b);
            } else if (void 0 !== o[h.type]) {
              u.push("bytes32");
              b = n.sha3(t.signTypedDataUtils._encodeData(h.type, p, o));
              d.push(b);
            } else {
              if (h.type.lastIndexOf("]") === h.type.length - 1) throw new Error("Arrays currently unimplemented in encodeData");
              u.push(h.type);

              var m = t.signTypedDataUtils._normalizeValue(h.type, p);

              d.push(m);
            }
          }
        } catch (e) {
          i = {
            error: e
          };
        } finally {
          try {
            l && !l.done && (c = f.return) && c.call(f);
          } finally {
            if (i) throw i.error;
          }
        }

        return s.utils.defaultAbiCoder.encode(u, d);
      },
      _normalizeValue: function _normalizeValue(e, t) {
        return "uint256" === e && o.BigNumber.isBigNumber(t) ? t.toString() : t;
      },
      _typeHash: function _typeHash(e, a) {
        return n.sha3(t.signTypedDataUtils._encodeType(e, a));
      },
      _structHash: function _structHash(e, a, r) {
        return n.sha3(t.signTypedDataUtils._encodeData(e, a, r));
      }
    };
  }).call(this, a(
  /*! ./../../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!*************************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/abi_encoder/index.js ***!
  \*************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = a(
  /*! ./evm_data_type_factory */
  456);
  t.Address = r.Address, t.Array = r.Array, t.Bool = r.Bool, t.DynamicBytes = r.DynamicBytes, t.Int = r.Int, t.Method = r.Method, t.Pointer = r.Pointer, t.StaticBytes = r.StaticBytes, t.String = r.String, t.Tuple = r.Tuple, t.UInt = r.UInt, t.create = r.create, t.createMethod = r.createMethod;
  var n = a(
  /*! ./abstract_data_types/data_type */
  80);
  t.DataType = n.DataType;
},
/*!*****************************************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/abi_encoder/evm_data_type_factory.js ***!
  \*****************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r54,
      n = this && this.__extends || (_r54 = function r(e, t) {
    return (_r54 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof S && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r54(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  });

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var s = a(
  /*! lodash */
  0),
      o = a(
  /*! ./utils/signature_parser */
  457),
      i = a(
  /*! ./evm_data_types/address */
  458),
      c = a(
  /*! ./evm_data_types/array */
  462),
      u = a(
  /*! ./evm_data_types/bool */
  463),
      d = a(
  /*! ./evm_data_types/dynamic_bytes */
  464),
      f = a(
  /*! ./evm_data_types/int */
  465),
      l = a(
  /*! ./evm_data_types/method */
  466),
      h = a(
  /*! ./evm_data_types/pointer */
  467),
      p = a(
  /*! ./evm_data_types/static_bytes */
  468),
      b = a(
  /*! ./evm_data_types/string */
  469),
      m = a(
  /*! ./evm_data_types/tuple */
  178),
      y = a(
  /*! ./evm_data_types/uint */
  470),
      v = function (e) {
    function t(t) {
      return e.call(this, t, B.getInstance()) || this;
    }

    return n(t, e), t;
  }(i.AddressDataType);

  t.Address = v;

  var _ = function (e) {
    function t(t) {
      return e.call(this, t, B.getInstance()) || this;
    }

    return n(t, e), t;
  }(u.BoolDataType);

  t.Bool = _;

  var g = function (e) {
    function t(t) {
      return e.call(this, t, B.getInstance()) || this;
    }

    return n(t, e), t;
  }(f.IntDataType);

  t.Int = g;

  var A = function (e) {
    function t(t) {
      return e.call(this, t, B.getInstance()) || this;
    }

    return n(t, e), t;
  }(y.UIntDataType);

  t.UInt = A;

  var w = function (e) {
    function t(t) {
      return e.call(this, t, B.getInstance()) || this;
    }

    return n(t, e), t;
  }(p.StaticBytesDataType);

  t.StaticBytes = w;

  var T = function (e) {
    function t(t) {
      return e.call(this, t, B.getInstance()) || this;
    }

    return n(t, e), t;
  }(d.DynamicBytesDataType);

  t.DynamicBytes = T;

  var x = function (e) {
    function t(t) {
      return e.call(this, t, B.getInstance()) || this;
    }

    return n(t, e), t;
  }(b.StringDataType);

  t.String = x;

  var D = function (e) {
    function t(t, a) {
      return e.call(this, t, a, B.getInstance()) || this;
    }

    return n(t, e), t;
  }(h.PointerDataType);

  t.Pointer = D;

  var C = function (e) {
    function t(t) {
      return e.call(this, t, B.getInstance()) || this;
    }

    return n(t, e), t;
  }(m.TupleDataType);

  t.Tuple = C;

  var S = function (e) {
    function t(t) {
      return e.call(this, t, B.getInstance()) || this;
    }

    return n(t, e), t;
  }(c.ArrayDataType);

  t.Array = S;

  var E = function (e) {
    function t(t) {
      return e.call(this, t, B.getInstance()) || this;
    }

    return n(t, e), t;
  }(l.MethodDataType);

  t.Method = E;

  var B = function () {
    function e() {}

    return e.getInstance = function () {
      return e._instance || (e._instance = new e()), e._instance;
    }, e.prototype.create = function (e, t) {
      var a;
      if (S.matchType(e.type) ? a = new S(e) : v.matchType(e.type) ? a = new v(e) : _.matchType(e.type) ? a = new _(e) : g.matchType(e.type) ? a = new g(e) : A.matchType(e.type) ? a = new A(e) : w.matchType(e.type) ? a = new w(e) : C.matchType(e.type) ? a = new C(e) : T.matchType(e.type) ? a = new T(e) : x.matchType(e.type) && (a = new x(e)), void 0 === a) throw new Error("Unrecognized data type: '" + e.type + "'");
      return void 0 === t || a.isStatic() ? a : new D(a, t);
    }, e;
  }();

  function k(e) {
    var t;
    if (s.isArray(e) && s.isEmpty(e)) t = [];else if (s.isArray(e) && s.isString(e[0])) t = [], s.each(e, function (e) {
      var a = o.generateDataItemFromSignature(e);
      t.push(a);
    });else if (s.isArray(e)) t = e;else if ("string" == typeof e) {
      var a = o.generateDataItemFromSignature(e);
      t = [a];
    } else t = [e];
    return t;
  }

  t.EvmDataTypeFactory = B, t.create = function (e) {
    var t = function (e) {
      var t;

      if (s.isArray(e)) {
        t = {
          name: "",
          type: "tuple",
          components: e
        };
      } else t = s.isString(e) ? o.generateDataItemFromSignature(e) : e;

      return t;
    }(e);

    return B.getInstance().create(t);
  }, t.createMethod = function (e, t, a) {
    var r = void 0 === t ? [] : k(t),
        n = void 0 === a ? [] : k(a);
    return new E({
      name: e,
      inputs: r,
      outputs: n,
      type: "function",
      constant: !1,
      payable: !1,
      stateMutability: "nonpayable"
    });
  };
},
/*!******************************************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/abi_encoder/utils/signature_parser.js ***!
  \******************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = this && this.__values || function (e) {
    var t = "function" == typeof Symbol && e[Symbol.iterator],
        a = 0;
    return t ? t.call(e) : {
      next: function next() {
        return e && a >= e.length && (e = void 0), {
          value: e && e[a++],
          done: !e
        };
      }
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = a(
  /*! lodash */
  0);

  t.generateDataItemFromSignature = function (e) {
    var t, a;
    if (n.isEmpty(e)) throw new Error("Cannot parse data item from empty signature, ''");
    var s = {
      name: "",
      value: "",
      children: []
    };

    try {
      for (var o = r(e), i = o.next(); !i.done; i = o.next()) {
        var c = i.value;

        switch (c) {
          case "(":
            var u = {
              name: "",
              value: "",
              children: [],
              parent: s
            };
            s.value = "tuple", s.children.push(u), s = u;
            break;

          case ")":
            s = s.parent;
            break;

          case ",":
            var d = {
              name: "",
              value: "",
              children: [],
              parent: s.parent
            };
            s.parent.children.push(d), s = d;
            break;

          case " ":
            s.name = s.value, s.value = "";
            break;

          default:
            s.value += c;
        }
      }
    } catch (e) {
      t = {
        error: e
      };
    } finally {
      try {
        i && !i.done && (a = o.return) && a.call(o);
      } finally {
        if (t) throw t.error;
      }
    }

    return function e(t) {
      var a = [];
      n.each(t.children, function (t) {
        var r = e(t);
        a.push(r);
      });
      var r = {
        name: t.name,
        type: t.value
      };
      return n.isEmpty(a) || (r.components = a), r;
    }(s);
  };
},
/*!******************************************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/abi_encoder/evm_data_types/address.js ***!
  \******************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r55,
      n = this && this.__extends || (_r55 = function r(e, t) {
    return (_r55 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r55(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  });

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var s = a(
  /*! ethereum-types */
  25),
      o = a(
  /*! ethereumjs-util */
  24),
      i = a(
  /*! lodash */
  0),
      c = a(
  /*! ../abstract_data_types/types/blob */
  54),
      u = a(
  /*! ../utils/constants */
  26),
      d = function (e) {
    function t(a, r) {
      var n = e.call(this, a, r, t._SIZE_KNOWN_AT_COMPILE_TIME) || this;
      if (!t.matchType(a.type)) throw new Error("Tried to instantiate Address with bad input: " + a);
      return n;
    }

    return n(t, e), t.matchType = function (e) {
      return e === s.SolidityTypes.Address;
    }, t.prototype.encodeValue = function (e) {
      if (!o.isValidAddress(e)) throw new Error("Invalid address: '" + e + "'");
      var t = o.toBuffer(e);
      return o.setLengthLeft(t, u.constants.EVM_WORD_WIDTH_IN_BYTES);
    }, t.prototype.decodeValue = function (e) {
      var a = e.popWord().slice(t._DECODED_ADDRESS_OFFSET_IN_BYTES),
          r = o.bufferToHex(a);
      return i.toLower(r);
    }, t.prototype.getDefaultValue = function () {
      return t._DEFAULT_VALUE;
    }, t.prototype.getSignatureType = function () {
      return s.SolidityTypes.Address;
    }, t._SIZE_KNOWN_AT_COMPILE_TIME = !0, t._ADDRESS_SIZE_IN_BYTES = 20, t._DECODED_ADDRESS_OFFSET_IN_BYTES = u.constants.EVM_WORD_WIDTH_IN_BYTES - t._ADDRESS_SIZE_IN_BYTES, t._DEFAULT_VALUE = "0x0000000000000000000000000000000000000000", t;
  }(c.AbstractBlobDataType);

  t.AddressDataType = d;
},
/*!*************************************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/abi_encoder/calldata/calldata.js ***!
  \*************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    var r = this && this.__values || function (e) {
      var t = "function" == typeof Symbol && e[Symbol.iterator],
          a = 0;
      return t ? t.call(e) : {
        next: function next() {
          return e && a >= e.length && (e = void 0), {
            value: e && e[a++],
            done: !e
          };
        }
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = a(
    /*! ethereumjs-util */
    24),
        s = a(
    /*! lodash */
    0),
        o = a(
    /*! ../utils/constants */
    26),
        i = a(
    /*! ./blocks/pointer */
    106),
        c = a(
    /*! ./blocks/set */
    107),
        u = a(
    /*! ./iterator */
    460),
        d = function () {
      function t(e) {
        this._rules = e, this._selector = "", this._root = void 0;
      }

      return t.prototype.setRoot = function (e) {
        this._root = e;
      }, t.prototype.setSelector = function (e) {
        if (!s.startsWith(e, "0x")) throw new Error("Expected selector to be hex. Missing prefix '0x'");
        if (e.length !== o.constants.HEX_SELECTOR_LENGTH_IN_CHARS) throw new Error("Invalid selector '" + e + "'");
        this._selector = e;
      }, t.prototype.toString = function () {
        var e, t;
        if (void 0 === this._root) throw new Error("expected root");
        this._rules.shouldOptimize && this._optimize();
        var a = new u.CalldataIterator(this._root),
            n = 0;

        try {
          for (var s = r(a), o = s.next(); !o.done; o = s.next()) {
            var i = o.value;
            i.setOffset(n), n += i.getSizeInBytes();
          }
        } catch (t) {
          e = {
            error: t
          };
        } finally {
          try {
            o && !o.done && (t = s.return) && t.call(s);
          } finally {
            if (e) throw e.error;
          }
        }

        return this._rules.shouldAnnotate ? this._toHumanReadableCallData() : this._toEvmCompatibeCallDataHex();
      }, t.prototype._optimize = function () {
        var e, t;
        if (void 0 === this._root) throw new Error("expected root");
        var a = new u.ReverseCalldataIterator(this._root),
            s = {};

        try {
          for (var o = r(a), c = o.next(); !c.done; c = o.next()) {
            var d = c.value;

            if (d instanceof i.PointerCalldataBlock) {
              var f = d.getDependency().computeHash(),
                  l = n.bufferToHex(f);

              if (l in s) {
                var h = s[l];
                h !== d.getDependency() && d.setAlias(h);
              }
            } else {
              var p = d.computeHash(),
                  b = n.bufferToHex(p);
              b in s || (s[b] = d);
            }
          }
        } catch (t) {
          e = {
            error: t
          };
        } finally {
          try {
            c && !c.done && (t = o.return) && t.call(o);
          } finally {
            if (e) throw e.error;
          }
        }
      }, t.prototype._toEvmCompatibeCallDataHex = function () {
        var t, a;
        if (void 0 === this._root) throw new Error("expected root");
        var s = [n.toBuffer(this._selector)],
            o = new u.CalldataIterator(this._root);

        try {
          for (var i = r(o), c = i.next(); !c.done; c = i.next()) {
            var d = c.value;
            s.push(d.toBuffer());
          }
        } catch (e) {
          t = {
            error: e
          };
        } finally {
          try {
            c && !c.done && (a = i.return) && a.call(i);
          } finally {
            if (t) throw t.error;
          }
        }

        var f = e.concat(s);
        return n.bufferToHex(f);
      }, t.prototype._toHumanReadableCallData = function () {
        var e, t;
        if (void 0 === this._root) throw new Error("expected root");

        var a = "" + this._selector,
            s = 0,
            i = this._root.getName(),
            d = new u.CalldataIterator(this._root);

        try {
          for (var f = r(d), l = f.next(); !l.done; l = f.next()) {
            var h = l.value,
                p = h.getSizeInBytes(),
                b = h.getName(),
                m = h.getParentName(),
                y = b.replace(m + ".", "").replace(i + ".", ""),
                v = "",
                _ = "",
                g = "";
            0 === p ? g = "\n" + (v = " ".repeat(10)) + (_ = " ".repeat(74)) + ("### " + y.padEnd(80)) : (v = ("0x" + s.toString(o.constants.HEX_BASE)).padEnd(10), _ = n.stripHexPrefix(n.bufferToHex(h.toBuffer().slice(0, o.constants.EVM_WORD_WIDTH_IN_BYTES))).padEnd(74), g = h instanceof c.SetCalldataBlock ? "\n" + v + _ + ("### " + y.padEnd(80)) : "" + v + _ + ("    " + y.padEnd(80)));

            for (var A = o.constants.EVM_WORD_WIDTH_IN_BYTES; A < p; A += o.constants.EVM_WORD_WIDTH_IN_BYTES) {
              g = g + "\n" + (v = ("0x" + (s + A).toString(o.constants.HEX_BASE)).padEnd(10)) + (_ = n.stripHexPrefix(n.bufferToHex(h.toBuffer().slice(A, A + o.constants.EVM_WORD_WIDTH_IN_BYTES))).padEnd(74)) + " ".repeat(80);
            }

            a = a + "\n" + g, s += p;
          }
        } catch (t) {
          e = {
            error: t
          };
        } finally {
          try {
            l && !l.done && (t = f.return) && t.call(f);
          } finally {
            if (e) throw e.error;
          }
        }

        return a;
      }, t;
    }();

    t.Calldata = d;
  }).call(this, a(
  /*! ./../../../../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!*************************************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/abi_encoder/calldata/iterator.js ***!
  \*************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    var _r56,
        n = this && this.__extends || (_r56 = function r(e, t) {
      return (_r56 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var a in t) {
          t.hasOwnProperty(a) && (e[a] = t[a]);
        }
      })(e, t);
    }, function (e, t) {
      function a() {
        this.constructor = e;
      }

      _r56(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = a(
    /*! lodash */
    0),
        o = a(
    /*! ../utils/queue */
    175),
        i = a(
    /*! ./blocks/blob */
    174),
        c = a(
    /*! ./blocks/pointer */
    106),
        u = a(
    /*! ./blocks/set */
    107),
        d = function () {
      function t(e) {
        this._root = e, this._queue = t._createQueue(e);
      }

      return t._createQueue = function (e) {
        var a = new o.Queue();
        if (!(e instanceof u.SetCalldataBlock)) return a.pushBack(e), a;
        var r = e;
        return s.eachRight(r.getMembers(), function (e) {
          a.mergeFront(t._createQueue(e));
        }), s.each(r.getMembers(), function (e) {
          if (e instanceof c.PointerCalldataBlock && void 0 === e.getAlias()) {
            var r = e.getDependency();
            a.mergeBack(t._createQueue(r));
          }
        }), a.pushFront(r), a;
      }, t.prototype[Symbol.iterator] = function () {
        var t = this;
        return {
          next: function next() {
            var a = t.nextBlock();
            return void 0 !== a ? {
              value: a,
              done: !1
            } : {
              done: !0,
              value: new i.BlobCalldataBlock("", "", "", new e(""))
            };
          }
        };
      }, t;
    }(),
        f = function (e) {
      function t(t) {
        return e.call(this, t) || this;
      }

      return n(t, e), t.prototype.nextBlock = function () {
        return this._queue.popFront();
      }, t;
    }(d);

    t.CalldataIterator = f;

    var l = function (e) {
      function t(t) {
        return e.call(this, t) || this;
      }

      return n(t, e), t.prototype.nextBlock = function () {
        return this._queue.popBack();
      }, t;
    }(d);

    t.ReverseCalldataIterator = l;
  }).call(this, a(
  /*! ./../../../../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!*****************************************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/abi_encoder/calldata/raw_calldata.js ***!
  \*****************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var r = a(
  /*! ethereumjs-util */
  24),
      n = a(
  /*! lodash */
  0),
      s = a(
  /*! ../utils/constants */
  26),
      o = a(
  /*! ../utils/queue */
  175),
      i = function () {
    function e(t, a) {
      if (void 0 === a && (a = !0), "string" == typeof t && !n.startsWith(t, "0x")) throw new Error("Expected raw calldata to start with '0x'");

      if (this._value = r.toBuffer(t), this._selector = "0x", this._scopes = new o.Queue(), this._scopes.pushBack(e._INITIAL_OFFSET), this._offset = e._INITIAL_OFFSET, a) {
        var i = this._value.slice(s.constants.HEX_SELECTOR_LENGTH_IN_BYTES);

        this._value = this._value.slice(s.constants.HEX_SELECTOR_LENGTH_IN_BYTES), this._selector = r.bufferToHex(i);
      }
    }

    return e.prototype.popBytes = function (e) {
      var t = this._offset,
          a = t + e;
      if (a > this._value.byteLength) throw new Error("Tried to decode beyond the end of calldata");

      var r = this._value.slice(t, a);

      return this.setOffset(a), r;
    }, e.prototype.popWord = function () {
      return this.popBytes(32);
    }, e.prototype.popWords = function (e) {
      return this.popBytes(32 * e);
    }, e.prototype.readBytes = function (e, t) {
      return this._value.slice(e, t);
    }, e.prototype.setOffset = function (e) {
      this._offset = e;
    }, e.prototype.startScope = function () {
      this._scopes.pushFront(this._offset);
    }, e.prototype.endScope = function () {
      this._scopes.popFront();
    }, e.prototype.getOffset = function () {
      return this._offset;
    }, e.prototype.toAbsoluteOffset = function (e) {
      var t = this._scopes.peekFront();

      if (void 0 === t) throw new Error("Tried to access undefined scope.");
      return e + t;
    }, e.prototype.getSelector = function () {
      return this._selector;
    }, e.prototype.getSizeInBytes = function () {
      return this._value.byteLength;
    }, e._INITIAL_OFFSET = 0, e;
  }();

  t.RawCalldata = i;
},
/*!****************************************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/abi_encoder/evm_data_types/array.js ***!
  \****************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r57,
      n = this && this.__extends || (_r57 = function r(e, t) {
    return (_r57 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r57(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || t-- > 0) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o = a(
  /*! lodash */
  0),
      i = a(
  /*! ../abstract_data_types/types/set */
  108),
      c = a(
  /*! ../utils/constants */
  26),
      u = function (e) {
    function t(a, r) {
      var n = this,
          o = s(t._decodeElementTypeAndLengthFromType(a.type), 2),
          i = o[0],
          c = o[1];
      return (n = e.call(this, a, r, !0, c, i) || this)._elementType = i, n;
    }

    return n(t, e), t.matchType = function (e) {
      return t._MATCHER.test(e);
    }, t._decodeElementTypeAndLengthFromType = function (e) {
      var a = t._MATCHER.exec(e);

      if (null === a || 3 !== a.length) throw new Error("Could not parse array: " + e);
      if (void 0 === a[1]) throw new Error("Could not parse array type: " + e);
      if (void 0 === a[2]) throw new Error("Could not parse array length: " + e);
      return [a[1], o.isEmpty(a[2]) ? void 0 : parseInt(a[2], c.constants.DEC_BASE)];
    }, t.prototype.getSignatureType = function () {
      return this._computeSignature(!1);
    }, t.prototype.getSignature = function (e) {
      if (o.isEmpty(this.getDataItem().name) || !e) return this.getSignatureType();
      var t = this.getDataItem().name,
          a = t.lastIndexOf(".");
      return (void 0 !== a && a > 0 ? t.substr(a + 1) : t) + " " + this._computeSignature(e);
    }, t.prototype._computeSignature = function (e) {
      var t = {
        type: this._elementType,
        name: ""
      },
          a = this.getDataItem().components;
      void 0 !== a && (t.components = a);
      var r = this.getFactory().create(t).getSignature(e);
      return void 0 === this._arrayLength ? r + "[]" : r + "[" + this._arrayLength + "]";
    }, t._MATCHER = RegExp("^(.+)\\[([0-9]*)\\]$"), t;
  }(i.AbstractSetDataType);

  t.ArrayDataType = u;
},
/*!***************************************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/abi_encoder/evm_data_types/bool.js ***!
  \***************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r58,
      n = this && this.__extends || (_r58 = function r(e, t) {
    return (_r58 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r58(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  });

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var s = a(
  /*! ethereum-types */
  25),
      o = a(
  /*! ethereumjs-util */
  24),
      i = a(
  /*! ../../configured_bignumber */
  37),
      c = a(
  /*! ../abstract_data_types/types/blob */
  54),
      u = a(
  /*! ../utils/constants */
  26),
      d = function (e) {
    function t(a, r) {
      var n = e.call(this, a, r, t._SIZE_KNOWN_AT_COMPILE_TIME) || this;
      if (!t.matchType(a.type)) throw new Error("Tried to instantiate Bool with bad input: " + a);
      return n;
    }

    return n(t, e), t.matchType = function (e) {
      return e === s.SolidityTypes.Bool;
    }, t.prototype.encodeValue = function (e) {
      var t = e ? "0x1" : "0x0";
      return o.setLengthLeft(o.toBuffer(t), u.constants.EVM_WORD_WIDTH_IN_BYTES);
    }, t.prototype.decodeValue = function (e) {
      var t = e.popWord(),
          a = o.bufferToHex(t),
          r = "0x" === a ? new i.BigNumber(0) : new i.BigNumber(a, u.constants.HEX_BASE);
      if (!r.isEqualTo(0) && !r.isEqualTo(1)) throw new Error("Failed to decode boolean. Expected 0x0 or 0x1, got " + a);
      return !r.isEqualTo(0);
    }, t.prototype.getDefaultValue = function () {
      return t._DEFAULT_VALUE;
    }, t.prototype.getSignatureType = function () {
      return s.SolidityTypes.Bool;
    }, t._SIZE_KNOWN_AT_COMPILE_TIME = !0, t._DEFAULT_VALUE = !1, t;
  }(c.AbstractBlobDataType);

  t.BoolDataType = d;
},
/*!************************************************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/abi_encoder/evm_data_types/dynamic_bytes.js ***!
  \************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    var _r59,
        n = this && this.__extends || (_r59 = function r(e, t) {
      return (_r59 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var a in t) {
          t.hasOwnProperty(a) && (e[a] = t[a]);
        }
      })(e, t);
    }, function (e, t) {
      function a() {
        this.constructor = e;
      }

      _r59(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = a(
    /*! ethereum-types */
    25),
        o = a(
    /*! ethereumjs-util */
    24),
        i = a(
    /*! lodash */
    0),
        c = a(
    /*! ../abstract_data_types/types/blob */
    54),
        u = a(
    /*! ../utils/constants */
    26),
        d = function (t) {
      function a(e, r) {
        var n = t.call(this, e, r, a._SIZE_KNOWN_AT_COMPILE_TIME) || this;
        if (!a.matchType(e.type)) throw new Error("Tried to instantiate Dynamic Bytes with bad input: " + e);
        return n;
      }

      return n(a, t), a.matchType = function (e) {
        return e === s.SolidityTypes.Bytes;
      }, a._sanityCheckValue = function (e) {
        if ("string" == typeof e) {
          if (!i.startsWith(e, "0x")) throw new Error("Tried to encode non-hex value. Value must include '0x' prefix.");
          if (e.length % 2 != 0) throw new Error("Tried to assign " + e + ", which is contains a half-byte. Use full bytes only.");
        }
      }, a.prototype.encodeValue = function (t) {
        var r = o.toBuffer(t),
            n = Math.ceil(r.byteLength / u.constants.EVM_WORD_WIDTH_IN_BYTES) * u.constants.EVM_WORD_WIDTH_IN_BYTES,
            s = o.toBuffer(r.byteLength),
            i = o.setLengthLeft(s, u.constants.EVM_WORD_WIDTH_IN_BYTES);

        a._sanityCheckValue(t);

        var c = o.setLengthRight(r, n);
        return e.concat([i, c]);
      }, a.prototype.decodeValue = function (e) {
        var t = e.popWord(),
            r = o.bufferToHex(t),
            n = parseInt(r, u.constants.HEX_BASE),
            s = Math.ceil(n / u.constants.EVM_WORD_WIDTH_IN_BYTES),
            i = e.popWords(s).slice(0, n),
            c = o.bufferToHex(i);
        return a._sanityCheckValue(c), c;
      }, a.prototype.getDefaultValue = function () {
        return a._DEFAULT_VALUE;
      }, a.prototype.getSignatureType = function () {
        return s.SolidityTypes.Bytes;
      }, a._SIZE_KNOWN_AT_COMPILE_TIME = !1, a._DEFAULT_VALUE = "0x", a;
    }(c.AbstractBlobDataType);

    t.DynamicBytesDataType = d;
  }).call(this, a(
  /*! ./../../../../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!**************************************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/abi_encoder/evm_data_types/int.js ***!
  \**************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r60,
      n = this && this.__extends || (_r60 = function r(e, t) {
    return (_r60 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r60(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  });

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var s = a(
  /*! ethereum-types */
  25),
      o = a(
  /*! ../../configured_bignumber */
  37),
      i = a(
  /*! ../abstract_data_types/types/blob */
  54),
      c = a(
  /*! ../utils/constants */
  26),
      u = a(
  /*! ../utils/math */
  177),
      d = function (e) {
    function t(a, r) {
      var n = e.call(this, a, r, t._SIZE_KNOWN_AT_COMPILE_TIME) || this;
      if (!t.matchType(a.type)) throw new Error("Tried to instantiate Int with bad input: " + a);
      return n._width = t._decodeWidthFromType(a.type), n._minValue = new o.BigNumber(2).exponentiatedBy(n._width - 1).times(-1), n._maxValue = new o.BigNumber(2).exponentiatedBy(n._width - 1).minus(1), n;
    }

    return n(t, e), t.matchType = function (e) {
      return t._MATCHER.test(e);
    }, t._decodeWidthFromType = function (e) {
      var a = t._MATCHER.exec(e);

      return null !== a && 2 === a.length && void 0 !== a[1] ? parseInt(a[1], c.constants.DEC_BASE) : t._DEFAULT_WIDTH;
    }, t.prototype.encodeValue = function (e) {
      return u.safeEncodeNumericValue(e, this._minValue, this._maxValue);
    }, t.prototype.decodeValue = function (e) {
      var t = e.popWord(),
          a = u.safeDecodeNumericValue(t, this._minValue, this._maxValue);
      return this._width === c.constants.NUMBER_OF_BYTES_IN_INT8 ? a.toNumber() : a;
    }, t.prototype.getDefaultValue = function () {
      var e = t._DEFAULT_VALUE;
      return this._width === c.constants.NUMBER_OF_BYTES_IN_INT8 ? e.toNumber() : e;
    }, t.prototype.getSignatureType = function () {
      return "" + s.SolidityTypes.Int + this._width;
    }, t._MATCHER = RegExp("^int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256){0,1}$"), t._SIZE_KNOWN_AT_COMPILE_TIME = !0, t._MAX_WIDTH = 256, t._DEFAULT_WIDTH = t._MAX_WIDTH, t._DEFAULT_VALUE = new o.BigNumber(0), t;
  }(i.AbstractBlobDataType);

  t.IntDataType = d;
},
/*!*****************************************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/abi_encoder/evm_data_types/method.js ***!
  \*****************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r61,
      n = this && this.__extends || (_r61 = function r(e, t) {
    return (_r61 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r61(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  });

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var s = a(
  /*! ethereumjs-util */
  24),
      o = a(
  /*! lodash */
  0),
      i = a(
  /*! ../abstract_data_types/types/set */
  108),
      c = a(
  /*! ../utils/constants */
  26),
      u = a(
  /*! ./tuple */
  178),
      d = function (e) {
    function t(t, a) {
      var r = this,
          n = {
        type: "method",
        name: t.name,
        components: t.inputs
      };
      (r = e.call(this, n, a) || this)._methodSignature = r._computeSignature(), r._methodSelector = r._computeSelector();
      var s = {
        type: "tuple",
        name: t.name,
        components: t.outputs
      };
      return r._returnDataType = new u.TupleDataType(s, r.getFactory()), r;
    }

    return n(t, e), t.prototype.encode = function (t, a) {
      return e.prototype.encode.call(this, t, a, this._methodSelector);
    }, t.prototype.decode = function (t, a) {
      return e.prototype.decode.call(this, t, a, this._methodSelector);
    }, t.prototype.strictDecode = function (t, a) {
      var r = e.prototype.decode.call(this, t, a, this._methodSelector),
          n = o.isObject(r) ? o.values(r) : [r];

      switch (n.length) {
        case 0:
          return;

        case 1:
          return n[0];

        default:
          return n;
      }
    }, t.prototype.encodeReturnValues = function (e, t) {
      return this._returnDataType.encode(e, t);
    }, t.prototype.decodeReturnValues = function (e, t) {
      return this._returnDataType.decode(e, t);
    }, t.prototype.strictDecodeReturnValue = function (e, t) {
      var a = this._returnDataType.decode(e, t),
          r = o.isObject(a) ? o.values(a) : [a];

      switch (r.length) {
        case 0:
          return;

        case 1:
          return r[0];

        default:
          return r;
      }
    }, t.prototype.getSignatureType = function () {
      return this._methodSignature;
    }, t.prototype.getSelector = function () {
      return this._methodSelector;
    }, t.prototype.getReturnValueDataItem = function () {
      return this._returnDataType.getDataItem();
    }, t.prototype._computeSignature = function () {
      var e = this._computeSignatureOfMembers();

      return "" + this.getDataItem().name + e;
    }, t.prototype._computeSelector = function () {
      var e = this._computeSignature();

      return s.bufferToHex(s.toBuffer(s.sha3(e).slice(c.constants.HEX_SELECTOR_BYTE_OFFSET_IN_CALLDATA, c.constants.HEX_SELECTOR_LENGTH_IN_BYTES)));
    }, t;
  }(i.AbstractSetDataType);

  t.MethodDataType = d;
},
/*!******************************************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/abi_encoder/evm_data_types/pointer.js ***!
  \******************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r62,
      n = this && this.__extends || (_r62 = function r(e, t) {
    return (_r62 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r62(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  });

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var s = function (e) {
    function t(t, a, r) {
      var n = t.getDataItem(),
          s = {
        name: "ptr<" + n.name + ">",
        type: "ptr<" + n.type + ">"
      };
      return e.call(this, s, r, t, a) || this;
    }

    return n(t, e), t.prototype.getSignatureType = function () {
      return this._destination.getSignature(!1);
    }, t.prototype.getSignature = function (e) {
      return this._destination.getSignature(e);
    }, t.prototype.getDefaultValue = function () {
      return this._destination.getDefaultValue();
    }, t;
  }(a(
  /*! ../abstract_data_types/types/pointer */
  176).AbstractPointerDataType);

  t.PointerDataType = s;
},
/*!***********************************************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/abi_encoder/evm_data_types/static_bytes.js ***!
  \***********************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r63,
      n = this && this.__extends || (_r63 = function r(e, t) {
    return (_r63 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r63(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  });

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var s = a(
  /*! ethereum-types */
  25),
      o = a(
  /*! ethereumjs-util */
  24),
      i = a(
  /*! lodash */
  0),
      c = a(
  /*! ../abstract_data_types/types/blob */
  54),
      u = a(
  /*! ../utils/constants */
  26),
      d = function (e) {
    function t(a, r) {
      var n = e.call(this, a, r, t._SIZE_KNOWN_AT_COMPILE_TIME) || this;
      if (!t.matchType(a.type)) throw new Error("Tried to instantiate Static Bytes with bad input: " + a);
      return n._width = t._decodeWidthFromType(a.type), n;
    }

    return n(t, e), t.matchType = function (e) {
      return t._MATCHER.test(e);
    }, t._decodeWidthFromType = function (e) {
      var a = t._MATCHER.exec(e);

      return null !== a && 3 === a.length && void 0 !== a[2] ? parseInt(a[2], u.constants.DEC_BASE) : t._DEFAULT_WIDTH;
    }, t.prototype.getSignatureType = function () {
      return "" + s.SolidityTypes.Bytes + this._width;
    }, t.prototype.encodeValue = function (e) {
      this._sanityCheckValue(e);

      var t = o.toBuffer(e);
      return o.setLengthRight(t, u.constants.EVM_WORD_WIDTH_IN_BYTES);
    }, t.prototype.decodeValue = function (e) {
      var t = e.popWord().slice(0, this._width),
          a = o.bufferToHex(t);
      return this._sanityCheckValue(a), a;
    }, t.prototype.getDefaultValue = function () {
      var e = u.constants.EMPTY_EVM_WORD_BUFFER.slice(0, this._width);
      return o.bufferToHex(e);
    }, t.prototype._sanityCheckValue = function (e) {
      if ("string" == typeof e) {
        if (!i.startsWith(e, "0x")) throw new Error("Tried to encode non-hex value. Value must include '0x' prefix.");
        if (e.length % 2 != 0) throw new Error("Tried to assign " + e + ", which is contains a half-byte. Use full bytes only.");
      }

      var t = o.toBuffer(e);
      if (t.byteLength > this._width) throw new Error("Tried to assign " + e + " (" + t.byteLength + " bytes), which exceeds max bytes that can be stored in a " + this.getSignature());
    }, t._SIZE_KNOWN_AT_COMPILE_TIME = !0, t._MATCHER = RegExp("^(byte|bytes(1|2|3|4|5|6|7|8|9|10|11|12|13|14|15|16|17|18|19|20|21|22|23|24|25|26|27|28|29|30|31|32))$"), t._DEFAULT_WIDTH = 1, t;
  }(c.AbstractBlobDataType);

  t.StaticBytesDataType = d;
},
/*!*****************************************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/abi_encoder/evm_data_types/string.js ***!
  \*****************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    var _r64,
        n = this && this.__extends || (_r64 = function r(e, t) {
      return (_r64 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var a in t) {
          t.hasOwnProperty(a) && (e[a] = t[a]);
        }
      })(e, t);
    }, function (e, t) {
      function a() {
        this.constructor = e;
      }

      _r64(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = a(
    /*! ethereum-types */
    25),
        o = a(
    /*! ethereumjs-util */
    24),
        i = a(
    /*! ../abstract_data_types/types/blob */
    54),
        c = a(
    /*! ../utils/constants */
    26),
        u = function (t) {
      function a(e, r) {
        var n = t.call(this, e, r, a._SIZE_KNOWN_AT_COMPILE_TIME) || this;
        if (!a.matchType(e.type)) throw new Error("Tried to instantiate String with bad input: " + e);
        return n;
      }

      return n(a, t), a.matchType = function (e) {
        return e === s.SolidityTypes.String;
      }, a.prototype.encodeValue = function (t) {
        var a = new e(t),
            r = a.byteLength,
            n = Math.ceil(r / c.constants.EVM_WORD_WIDTH_IN_BYTES) * c.constants.EVM_WORD_WIDTH_IN_BYTES,
            s = o.setLengthRight(a, n),
            i = o.toBuffer(r),
            u = o.setLengthLeft(i, c.constants.EVM_WORD_WIDTH_IN_BYTES);
        return e.concat([u, s]);
      }, a.prototype.decodeValue = function (e) {
        var t = e.popWord(),
            a = o.bufferToHex(t),
            r = parseInt(a, c.constants.HEX_BASE),
            n = Math.ceil(r / c.constants.EVM_WORD_WIDTH_IN_BYTES);
        return e.popWords(n).slice(0, r).toString("UTF-8");
      }, a.prototype.getDefaultValue = function () {
        return a._DEFAULT_VALUE;
      }, a.prototype.getSignatureType = function () {
        return s.SolidityTypes.String;
      }, a._SIZE_KNOWN_AT_COMPILE_TIME = !1, a._DEFAULT_VALUE = "", a;
    }(i.AbstractBlobDataType);

    t.StringDataType = u;
  }).call(this, a(
  /*! ./../../../../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!***************************************************************************!*\
  !*** ./node_modules/@0x/utils/lib/src/abi_encoder/evm_data_types/uint.js ***!
  \***************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r65,
      n = this && this.__extends || (_r65 = function r(e, t) {
    return (_r65 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r65(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  });

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var s = a(
  /*! ethereum-types */
  25),
      o = a(
  /*! ../../configured_bignumber */
  37),
      i = a(
  /*! ../abstract_data_types/types/blob */
  54),
      c = a(
  /*! ../utils/constants */
  26),
      u = a(
  /*! ../utils/math */
  177),
      d = function (e) {
    function t(a, r) {
      var n = e.call(this, a, r, t._SIZE_KNOWN_AT_COMPILE_TIME) || this;
      if (!t.matchType(a.type)) throw new Error("Tried to instantiate UInt with bad input: " + a);
      return n._width = t._decodeWidthFromType(a.type), n._maxValue = new o.BigNumber(2).exponentiatedBy(n._width).minus(1), n;
    }

    return n(t, e), t.matchType = function (e) {
      return t._MATCHER.test(e);
    }, t._decodeWidthFromType = function (e) {
      var a = t._MATCHER.exec(e);

      return null !== a && 2 === a.length && void 0 !== a[1] ? parseInt(a[1], c.constants.DEC_BASE) : t._DEFAULT_WIDTH;
    }, t.prototype.encodeValue = function (e) {
      return u.safeEncodeNumericValue(e, t._MIN_VALUE, this._maxValue);
    }, t.prototype.decodeValue = function (e) {
      var a = e.popWord(),
          r = u.safeDecodeNumericValue(a, t._MIN_VALUE, this._maxValue);
      return this._width === c.constants.NUMBER_OF_BYTES_IN_UINT8 ? r.toNumber() : r;
    }, t.prototype.getDefaultValue = function () {
      var e = t._DEFAULT_VALUE;
      return this._width === c.constants.NUMBER_OF_BYTES_IN_UINT8 ? e.toNumber() : e;
    }, t.prototype.getSignatureType = function () {
      return "" + s.SolidityTypes.Uint + this._width;
    }, t._MATCHER = RegExp("^uint(8|16|24|32|40|48|56|64|72|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256){0,1}$"), t._SIZE_KNOWN_AT_COMPILE_TIME = !0, t._MAX_WIDTH = 256, t._DEFAULT_WIDTH = t._MAX_WIDTH, t._MIN_VALUE = new o.BigNumber(0), t._DEFAULT_VALUE = new o.BigNumber(0), t;
  }(i.AbstractBlobDataType);

  t.UIntDataType = d;
},
/*!*****************************************!*\
  !*** ./node_modules/valid-url/index.js ***!
  \*****************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (e) {
    !function (e) {
      "use strict";

      e.exports.is_uri = a, e.exports.is_http_uri = r, e.exports.is_https_uri = n, e.exports.is_web_uri = s, e.exports.isUri = a, e.exports.isHttpUri = r, e.exports.isHttpsUri = n, e.exports.isWebUri = s;

      var t = function t(e) {
        return e.match(/(?:([^:\/?#]+):)?(?:\/\/([^\/?#]*))?([^?#]*)(?:\?([^#]*))?(?:#(.*))?/);
      };

      function a(e) {
        if (e && !/[^a-z0-9\:\/\?\#\[\]\@\!\$\&\'\(\)\*\+\,\;\=\.\-\_\~\%]/i.test(e) && !/%[^0-9a-f]/i.test(e) && !/%[0-9a-f](:?[^0-9a-f]|$)/i.test(e)) {
          var a,
              r,
              n,
              s,
              o,
              i = "",
              c = "";

          if (i = (a = t(e))[1], r = a[2], n = a[3], s = a[4], o = a[5], i && i.length && n.length >= 0) {
            if (r && r.length) {
              if (0 !== n.length && !/^\//.test(n)) return;
            } else if (/^\/\//.test(n)) return;

            if (/^[a-z][a-z0-9\+\-\.]*$/.test(i.toLowerCase())) return c += i + ":", r && r.length && (c += "//" + r), c += n, s && s.length && (c += "?" + s), o && o.length && (c += "#" + o), c;
          }
        }
      }

      function r(e, r) {
        if (a(e)) {
          var n,
              s,
              o,
              i,
              c = "",
              u = "",
              d = "",
              f = "";

          if (c = (n = t(e))[1], u = n[2], s = n[3], o = n[4], i = n[5], c) {
            if (r) {
              if ("https" != c.toLowerCase()) return;
            } else if ("http" != c.toLowerCase()) return;

            if (u) return /:(\d+)$/.test(u) && (d = u.match(/:(\d+)$/)[0], u = u.replace(/:\d+$/, "")), f += c + ":", f += "//" + u, d && (f += d), f += s, o && o.length && (f += "?" + o), i && i.length && (f += "#" + i), f;
          }
        }
      }

      function n(e) {
        return r(e, !0);
      }

      function s(e) {
        return r(e) || n(e);
      }
    }(e);
  }).call(this, a(
  /*! ./../webpack/buildin/module.js */
  45)(e));
},
/*!***************************************************************!*\
  !*** ./node_modules/@0x/web3-wrapper/lib/src/web3_wrapper.js ***!
  \***************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = this && this.__assign || function () {
    return (r = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      n = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      s = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o = a(
  /*! @0x/assert */
  10),
      i = a(
  /*! @0x/json-schemas */
  2),
      c = a(
  /*! @0x/utils */
  8),
      u = a(
  /*! ethereum-types */
  25),
      d = a(
  /*! lodash */
  0),
      f = a(
  /*! ./marshaller */
  179),
      l = a(
  /*! ./types */
  181),
      h = a(
  /*! ./utils */
  180),
      p = "Geth",
      b = "EthereumJS TestRPC",
      m = function () {
    function e(e, t) {
      void 0 === t && (t = {}), this.isZeroExWeb3Wrapper = !0, this.abiDecoder = new c.AbiDecoder([]), this._supportedProvider = e, this._provider = c.providerUtils.standardizeOrThrow(e), this._callAndTxnDefaults = t, this._jsonRpcRequestId = 1;
    }

    return e.isAddress = function (e) {
      return c.addressUtils.isAddress(e);
    }, e.toUnitAmount = function (e, t) {
      o.assert.isValidBaseUnitAmount("amount", e), o.assert.isNumber("decimals", t);
      var a = new c.BigNumber(10).pow(t);
      return e.div(a);
    }, e.toBaseUnitAmount = function (e, t) {
      o.assert.isBigNumber("amount", e), o.assert.isNumber("decimals", t);
      var a = new c.BigNumber(10).pow(t),
          r = e.times(a);
      if (0 !== r.decimalPlaces()) throw new Error("Invalid unit amount: " + e.toString() + " - Too many decimal places");
      return r;
    }, e.toWei = function (t) {
      o.assert.isBigNumber("ethAmount", t);
      return e.toBaseUnitAmount(t, 18);
    }, e._assertBlockParam = function (e) {
      d.isNumber(e) || d.isString(e) && o.assert.doesBelongToStringEnum("blockParam", e, u.BlockParamLiteral);
    }, e._assertBlockParamOrString = function (t) {
      try {
        e._assertBlockParam(t);
      } catch (e) {
        try {
          return void o.assert.isHexString("blockParam", t);
        } catch (e) {
          throw new Error('Expected blockParam to be of type "string | BlockParam", encountered ' + t);
        }
      }
    }, e._normalizeTxReceiptStatus = function (e) {
      return d.isString(e) ? h.utils.convertHexToNumber(e) : void 0 === e ? null : e;
    }, e.prototype.getContractDefaults = function () {
      return this._callAndTxnDefaults;
    }, e.prototype.getProvider = function () {
      return this._supportedProvider;
    }, e.prototype.setProvider = function (e) {
      var t = c.providerUtils.standardizeOrThrow(e);
      this._provider = t;
    }, e.prototype.isSenderAddressAvailableAsync = function (e) {
      return n(this, void 0, void 0, function () {
        var t, a;
        return s(this, function (r) {
          switch (r.label) {
            case 0:
              return o.assert.isETHAddressHex("senderAddress", e), [4, this.getAvailableAddressesAsync()];

            case 1:
              return t = r.sent(), a = e.toLowerCase(), [2, d.includes(t, a)];
          }
        });
      });
    }, e.prototype.getNodeVersionAsync = function () {
      return n(this, void 0, void 0, function () {
        return s(this, function (e) {
          switch (e.label) {
            case 0:
              return [4, this.sendRawPayloadAsync({
                method: "web3_clientVersion"
              })];

            case 1:
              return [2, e.sent()];
          }
        });
      });
    }, e.prototype.getNetworkIdAsync = function () {
      return n(this, void 0, void 0, function () {
        var e;
        return s(this, function (t) {
          switch (t.label) {
            case 0:
              return [4, this.sendRawPayloadAsync({
                method: "net_version"
              })];

            case 1:
              return e = t.sent(), [2, d.parseInt(e)];
          }
        });
      });
    }, e.prototype.getTransactionReceiptIfExistsAsync = function (t) {
      return n(this, void 0, void 0, function () {
        var a;
        return s(this, function (r) {
          switch (r.label) {
            case 0:
              return o.assert.isHexString("txHash", t), [4, this.sendRawPayloadAsync({
                method: "eth_getTransactionReceipt",
                params: [t]
              })];

            case 1:
              return null !== (a = r.sent()) && null !== a.blockNumber ? (a.status = e._normalizeTxReceiptStatus(a.status), [2, f.marshaller.unmarshalTransactionReceipt(a)]) : [2, void 0];
          }
        });
      });
    }, e.prototype.getTransactionByHashAsync = function (e) {
      return n(this, void 0, void 0, function () {
        var t;
        return s(this, function (a) {
          switch (a.label) {
            case 0:
              return o.assert.isHexString("txHash", e), [4, this.sendRawPayloadAsync({
                method: "eth_getTransactionByHash",
                params: [e]
              })];

            case 1:
              return t = a.sent(), [2, f.marshaller.unmarshalTransaction(t)];
          }
        });
      });
    }, e.prototype.getBalanceInWeiAsync = function (t, a) {
      return n(this, void 0, void 0, function () {
        var r, n, i;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              return o.assert.isETHAddressHex("owner", t), void 0 !== a && e._assertBlockParam(a), r = f.marshaller.marshalBlockParam(a), n = f.marshaller.marshalAddress(t), [4, this.sendRawPayloadAsync({
                method: "eth_getBalance",
                params: [n, r]
              })];

            case 1:
              return i = s.sent(), [2, new c.BigNumber(i)];
          }
        });
      });
    }, e.prototype.doesContractExistAtAddressAsync = function (e) {
      return n(this, void 0, void 0, function () {
        var t;
        return s(this, function (a) {
          switch (a.label) {
            case 0:
              return o.assert.isETHAddressHex("address", e), [4, this.getContractCodeAsync(e)];

            case 1:
              return t = a.sent(), [2, !/^0x0{0,40}$/i.test(t)];
          }
        });
      });
    }, e.prototype.getContractCodeAsync = function (t, a) {
      return n(this, void 0, void 0, function () {
        var r, n;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              return o.assert.isETHAddressHex("address", t), void 0 !== a && e._assertBlockParam(a), r = f.marshaller.marshalBlockParam(a), n = f.marshaller.marshalAddress(t), [4, this.sendRawPayloadAsync({
                method: "eth_getCode",
                params: [n, r]
              })];

            case 1:
              return [2, s.sent()];
          }
        });
      });
    }, e.prototype.getTransactionTraceAsync = function (e, t) {
      return n(this, void 0, void 0, function () {
        return s(this, function (a) {
          switch (a.label) {
            case 0:
              return o.assert.isHexString("txHash", e), [4, this.sendRawPayloadAsync({
                method: "debug_traceTransaction",
                params: [e, t]
              })];

            case 1:
              return [2, a.sent()];
          }
        });
      });
    }, e.prototype.signMessageAsync = function (e, t) {
      return n(this, void 0, void 0, function () {
        return s(this, function (a) {
          switch (a.label) {
            case 0:
              return o.assert.isETHAddressHex("address", e), o.assert.isString("message", t), [4, this.sendRawPayloadAsync({
                method: "eth_sign",
                params: [e, t]
              })];

            case 1:
              return [2, a.sent()];
          }
        });
      });
    }, e.prototype.signTypedDataAsync = function (e, t) {
      return n(this, void 0, void 0, function () {
        return s(this, function (a) {
          switch (a.label) {
            case 0:
              return o.assert.isETHAddressHex("address", e), o.assert.doesConformToSchema("typedData", t, i.schemas.eip712TypedDataSchema), [4, this.sendRawPayloadAsync({
                method: "eth_signTypedData",
                params: [e, t]
              })];

            case 1:
              return [2, a.sent()];
          }
        });
      });
    }, e.prototype.getBlockNumberAsync = function () {
      return n(this, void 0, void 0, function () {
        var e;
        return s(this, function (t) {
          switch (t.label) {
            case 0:
              return [4, this.sendRawPayloadAsync({
                method: "eth_blockNumber",
                params: []
              })];

            case 1:
              return e = t.sent(), [2, h.utils.convertHexToNumberOrNull(e)];
          }
        });
      });
    }, e.prototype.getBlockIfExistsAsync = function (t) {
      return n(this, void 0, void 0, function () {
        var a, r, n, o;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              return e._assertBlockParamOrString(t), a = f.marshaller.marshalBlockParam(t), r = h.utils.isHexStrict(t) ? "eth_getBlockByHash" : "eth_getBlockByNumber", !1, [4, this.sendRawPayloadAsync({
                method: r,
                params: [a, !1]
              })];

            case 1:
              return null !== (n = s.sent()) && (o = f.marshaller.unmarshalIntoBlockWithoutTransactionData(n)), [2, o];
          }
        });
      });
    }, e.prototype.getBlockWithTransactionDataAsync = function (t) {
      return n(this, void 0, void 0, function () {
        var a, r, n;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              return e._assertBlockParamOrString(t), a = t, d.isNumber(t) && (a = h.utils.numberToHex(t)), r = h.utils.isHexStrict(t) ? "eth_getBlockByHash" : "eth_getBlockByNumber", !0, [4, this.sendRawPayloadAsync({
                method: r,
                params: [a, !0]
              })];

            case 1:
              return n = s.sent(), [2, f.marshaller.unmarshalIntoBlockWithTransactionData(n)];
          }
        });
      });
    }, e.prototype.getBlockTimestampAsync = function (t) {
      return n(this, void 0, void 0, function () {
        var a;
        return s(this, function (r) {
          switch (r.label) {
            case 0:
              return e._assertBlockParamOrString(t), [4, this.getBlockIfExistsAsync(t)];

            case 1:
              if (void 0 === (a = r.sent())) throw new Error("Failed to fetch block with blockParam: " + JSON.stringify(t));
              return [2, a.timestamp];
          }
        });
      });
    }, e.prototype.getAvailableAddressesAsync = function () {
      return n(this, void 0, void 0, function () {
        var e;
        return s(this, function (t) {
          switch (t.label) {
            case 0:
              return [4, this.sendRawPayloadAsync({
                method: "eth_accounts",
                params: []
              })];

            case 1:
              return e = t.sent(), [2, d.map(e, function (e) {
                return e.toLowerCase();
              })];
          }
        });
      });
    }, e.prototype.takeSnapshotAsync = function () {
      return n(this, void 0, void 0, function () {
        var e;
        return s(this, function (t) {
          switch (t.label) {
            case 0:
              return e = Number, [4, this.sendRawPayloadAsync({
                method: "evm_snapshot",
                params: []
              })];

            case 1:
              return [2, e.apply(void 0, [t.sent()])];
          }
        });
      });
    }, e.prototype.revertSnapshotAsync = function (e) {
      return n(this, void 0, void 0, function () {
        return s(this, function (t) {
          switch (t.label) {
            case 0:
              return o.assert.isNumber("snapshotId", e), [4, this.sendRawPayloadAsync({
                method: "evm_revert",
                params: [e]
              })];

            case 1:
              return [2, t.sent()];
          }
        });
      });
    }, e.prototype.mineBlockAsync = function () {
      return n(this, void 0, void 0, function () {
        return s(this, function (e) {
          switch (e.label) {
            case 0:
              return [4, this.sendRawPayloadAsync({
                method: "evm_mine",
                params: []
              })];

            case 1:
              return e.sent(), [2];
          }
        });
      });
    }, e.prototype.increaseTimeAsync = function (e) {
      return n(this, void 0, void 0, function () {
        var t;
        return s(this, function (a) {
          switch (a.label) {
            case 0:
              return o.assert.isNumber("timeDelta", e), [4, this.getNodeVersionAsync()];

            case 1:
              if (t = a.sent(), d.includes(t, p)) return [2, this.sendRawPayloadAsync({
                method: "debug_increaseTime",
                params: [e]
              })];
              if (d.includes(t, b)) return [2, this.sendRawPayloadAsync({
                method: "evm_increaseTime",
                params: [e]
              })];
              throw new Error("Unknown client version: " + t);
          }
        });
      });
    }, e.prototype.getLogsAsync = function (e) {
      return n(this, void 0, void 0, function () {
        var t, a, n, o, i;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              if (void 0 !== e.blockHash && (void 0 !== e.fromBlock || void 0 !== e.toBlock)) throw new Error("Cannot specify 'blockHash' as well as 'fromBlock'/'toBlock' in the filter supplied to 'getLogsAsync'");
              return t = e.fromBlock, d.isNumber(t) && (t = h.utils.numberToHex(t)), a = e.toBlock, d.isNumber(a) && (a = h.utils.numberToHex(a)), n = r({}, e, {
                fromBlock: t,
                toBlock: a
              }), o = {
                method: "eth_getLogs",
                params: [n]
              }, [4, this.sendRawPayloadAsync(o)];

            case 1:
              return i = s.sent(), [2, d.map(i, f.marshaller.unmarshalLog.bind(f.marshaller))];
          }
        });
      });
    }, e.prototype.estimateGasAsync = function (e) {
      return n(this, void 0, void 0, function () {
        var t, a;
        return s(this, function (r) {
          switch (r.label) {
            case 0:
              return o.assert.doesConformToSchema("txData", e, i.schemas.txDataSchema, [i.schemas.addressSchema, i.schemas.numberSchema, i.schemas.jsNumber]), t = f.marshaller.marshalTxData(e), [4, this.sendRawPayloadAsync({
                method: "eth_estimateGas",
                params: [t]
              })];

            case 1:
              return a = r.sent(), [2, h.utils.convertHexToNumber(a)];
          }
        });
      });
    }, e.prototype.callAsync = function (t, a) {
      return n(this, void 0, void 0, function () {
        var r, n;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              return o.assert.doesConformToSchema("callData", t, i.schemas.callDataSchema, [i.schemas.addressSchema, i.schemas.numberSchema, i.schemas.jsNumber]), void 0 !== a && e._assertBlockParam(a), r = f.marshaller.marshalBlockParam(a), n = f.marshaller.marshalCallData(t), [4, this.sendRawPayloadAsync({
                method: "eth_call",
                params: [n, r]
              })];

            case 1:
              return [2, s.sent()];
          }
        });
      });
    }, e.prototype.sendTransactionAsync = function (e) {
      return n(this, void 0, void 0, function () {
        var t;
        return s(this, function (a) {
          switch (a.label) {
            case 0:
              return o.assert.doesConformToSchema("txData", e, i.schemas.txDataSchema, [i.schemas.addressSchema, i.schemas.numberSchema, i.schemas.jsNumber]), t = f.marshaller.marshalTxData(e), [4, this.sendRawPayloadAsync({
                method: "eth_sendTransaction",
                params: [t]
              })];

            case 1:
              return [2, a.sent()];
          }
        });
      });
    }, e.prototype.awaitTransactionMinedAsync = function (e, t, a) {
      return void 0 === t && (t = 1e3), n(this, void 0, void 0, function () {
        var i,
            u,
            f,
            h = this;
        return s(this, function (p) {
          switch (p.label) {
            case 0:
              return o.assert.isHexString("txHash", e), o.assert.isNumber("pollingIntervalMs", t), void 0 !== a && o.assert.isNumber("timeoutMs", a), [4, this.getTransactionReceiptIfExistsAsync(e)];

            case 1:
              return void 0 !== (i = p.sent()) ? (u = d.map(i.logs, this.abiDecoder.tryToDecodeLogOrNoop.bind(this.abiDecoder)), [2, r({}, i, {
                logs: u
              })]) : (f = !1, a && setTimeout(function () {
                return f = !0;
              }, a), [4, new Promise(function (a, o) {
                var u = c.intervalUtils.setAsyncExcludingInterval(function () {
                  return n(h, void 0, void 0, function () {
                    var t, n;
                    return s(this, function (s) {
                      switch (s.label) {
                        case 0:
                          return f ? (c.intervalUtils.clearAsyncExcludingInterval(u), [2, o(l.Web3WrapperErrors.TransactionMiningTimeout)]) : [4, this.getTransactionReceiptIfExistsAsync(e)];

                        case 1:
                          return void 0 !== (i = s.sent()) && (c.intervalUtils.clearAsyncExcludingInterval(u), t = d.map(i.logs, this.abiDecoder.tryToDecodeLogOrNoop.bind(this.abiDecoder)), n = r({}, i, {
                            logs: t
                          }), a(n)), [2];
                      }
                    });
                  });
                }, t, function (e) {
                  c.intervalUtils.clearAsyncExcludingInterval(u), o(e);
                });
              })]);

            case 2:
              return [2, p.sent()];
          }
        });
      });
    }, e.prototype.awaitTransactionSuccessAsync = function (e, t, a) {
      return void 0 === t && (t = 1e3), n(this, void 0, void 0, function () {
        var r;
        return s(this, function (n) {
          switch (n.label) {
            case 0:
              return [4, this.awaitTransactionMinedAsync(e, t, a)];

            case 1:
              if (1 !== (r = n.sent()).status) throw new Error("Transaction failed: " + e);
              return [2, r];
          }
        });
      });
    }, e.prototype.setHeadAsync = function (e) {
      return n(this, void 0, void 0, function () {
        return s(this, function (t) {
          switch (t.label) {
            case 0:
              return o.assert.isNumber("blockNumber", e), [4, this.sendRawPayloadAsync({
                method: "debug_setHead",
                params: [h.utils.numberToHex(e)]
              })];

            case 1:
              return t.sent(), [2];
          }
        });
      });
    }, e.prototype.sendRawPayloadAsync = function (e) {
      return n(this, void 0, void 0, function () {
        var t, a, n;
        return s(this, function (s) {
          switch (s.label) {
            case 0:
              return t = this._provider.sendAsync.bind(this._provider), a = r({
                id: this._jsonRpcRequestId++,
                params: [],
                jsonrpc: "2.0"
              }, e), [4, c.promisify(t)(a)];

            case 1:
              if ((n = s.sent()).error) throw new Error(n.error.message);
              return [2, n.result];
          }
        });
      });
    }, e.prototype.getNodeTypeAsync = function () {
      return n(this, void 0, void 0, function () {
        var e;
        return s(this, function (t) {
          switch (t.label) {
            case 0:
              return [4, this.getNodeVersionAsync()];

            case 1:
              if (e = t.sent(), d.includes(e, p)) return [2, l.NodeType.Geth];
              if (d.includes(e, b)) return [2, l.NodeType.Ganache];
              throw new Error("Unknown client version: " + e);
          }
        });
      });
    }, e;
  }();

  t.Web3Wrapper = m;
},
/*!**********************************************************************************!*\
  !*** ./node_modules/@0x/web3-wrapper/node_modules/ethereumjs-util/dist/index.js ***!
  \**********************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
      n = a(
  /*! keccak */
  33),
      s = a(
  /*! secp256k1 */
  30),
      o = a(
  /*! assert */
  19),
      i = a(
  /*! rlp */
  21),
      c = a(
  /*! bn.js */
  5),
      u = a(
  /*! create-hash */
  20),
      d = a(
  /*! safe-buffer */
  7).Buffer;
  Object.assign(t, a(
  /*! ethjs-util */
  36)), t.MAX_INTEGER = new c("ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff", 16), t.TWO_POW256 = new c("10000000000000000000000000000000000000000000000000000000000000000", 16), t.KECCAK256_NULL_S = "c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470", t.SHA3_NULL_S = t.KECCAK256_NULL_S, t.KECCAK256_NULL = d.from(t.KECCAK256_NULL_S, "hex"), t.SHA3_NULL = t.KECCAK256_NULL, t.KECCAK256_RLP_ARRAY_S = "1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347", t.SHA3_RLP_ARRAY_S = t.KECCAK256_RLP_ARRAY_S, t.KECCAK256_RLP_ARRAY = d.from(t.KECCAK256_RLP_ARRAY_S, "hex"), t.SHA3_RLP_ARRAY = t.KECCAK256_RLP_ARRAY, t.KECCAK256_RLP_S = "56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421", t.SHA3_RLP_S = t.KECCAK256_RLP_S, t.KECCAK256_RLP = d.from(t.KECCAK256_RLP_S, "hex"), t.SHA3_RLP = t.KECCAK256_RLP, t.BN = c, t.rlp = i, t.secp256k1 = s, t.zeros = function (e) {
    return d.allocUnsafe(e).fill(0);
  }, t.zeroAddress = function () {
    var e = t.zeros(20);
    return t.bufferToHex(e);
  }, t.setLengthLeft = t.setLength = function (e, a, r) {
    var n = t.zeros(a);
    return e = t.toBuffer(e), r ? e.length < a ? (e.copy(n), n) : e.slice(0, a) : e.length < a ? (e.copy(n, a - e.length), n) : e.slice(-a);
  }, t.setLengthRight = function (e, a) {
    return t.setLength(e, a, !0);
  }, t.unpad = t.stripZeros = function (e) {
    for (var a = (e = t.stripHexPrefix(e))[0]; e.length > 0 && "0" === a.toString();) {
      a = (e = e.slice(1))[0];
    }

    return e;
  }, t.toBuffer = function (e) {
    if (!d.isBuffer(e)) if (Array.isArray(e)) e = d.from(e);else if ("string" == typeof e) e = t.isHexString(e) ? d.from(t.padToEven(t.stripHexPrefix(e)), "hex") : d.from(e);else if ("number" == typeof e) e = t.intToBuffer(e);else if (null == e) e = d.allocUnsafe(0);else if (c.isBN(e)) e = e.toArrayLike(d);else {
      if (!e.toArray) throw new Error("invalid type");
      e = d.from(e.toArray());
    }
    return e;
  }, t.bufferToInt = function (e) {
    return new c(t.toBuffer(e)).toNumber();
  }, t.bufferToHex = function (e) {
    return "0x" + (e = t.toBuffer(e)).toString("hex");
  }, t.fromSigned = function (e) {
    return new c(e).fromTwos(256);
  }, t.toUnsigned = function (e) {
    return d.from(e.toTwos(256).toArray());
  }, t.keccak = function (e, a) {
    return e = t.toBuffer(e), a || (a = 256), n("keccak" + a).update(e).digest();
  }, t.keccak256 = function (e) {
    return t.keccak(e);
  }, t.sha3 = t.keccak, t.sha256 = function (e) {
    return e = t.toBuffer(e), u("sha256").update(e).digest();
  }, t.ripemd160 = function (e, a) {
    e = t.toBuffer(e);
    var r = u("rmd160").update(e).digest();
    return !0 === a ? t.setLength(r, 32) : r;
  }, t.rlphash = function (e) {
    return t.keccak(i.encode(e));
  }, t.isValidPrivate = function (e) {
    return s.privateKeyVerify(e);
  }, t.isValidPublic = function (e, t) {
    return 64 === e.length ? s.publicKeyVerify(d.concat([d.from([4]), e])) : !!t && s.publicKeyVerify(e);
  }, t.pubToAddress = t.publicToAddress = function (e, a) {
    return e = t.toBuffer(e), a && 64 !== e.length && (e = s.publicKeyConvert(e, !1).slice(1)), o(64 === e.length), t.keccak(e).slice(-20);
  };

  var f = t.privateToPublic = function (e) {
    return e = t.toBuffer(e), s.publicKeyCreate(e, !1).slice(1);
  };

  t.importPublic = function (e) {
    return 64 !== (e = t.toBuffer(e)).length && (e = s.publicKeyConvert(e, !1).slice(1)), e;
  }, t.ecsign = function (e, t) {
    var a = s.sign(e, t),
        r = {};
    return r.r = a.signature.slice(0, 32), r.s = a.signature.slice(32, 64), r.v = a.recovery + 27, r;
  }, t.hashPersonalMessage = function (e) {
    var a = t.toBuffer("Ethereum Signed Message:\n" + e.length.toString());
    return t.keccak(d.concat([a, e]));
  }, t.ecrecover = function (e, a, r, n) {
    var o = d.concat([t.setLength(r, 32), t.setLength(n, 32)], 64),
        i = a - 27;
    if (0 !== i && 1 !== i) throw new Error("Invalid signature v value");
    var c = s.recover(e, o, i);
    return s.publicKeyConvert(c, !1).slice(1);
  }, t.toRpcSig = function (e, a, r) {
    if (27 !== e && 28 !== e) throw new Error("Invalid recovery id");
    return t.bufferToHex(d.concat([t.setLengthLeft(a, 32), t.setLengthLeft(r, 32), t.toBuffer(e - 27)]));
  }, t.fromRpcSig = function (e) {
    if (65 !== (e = t.toBuffer(e)).length) throw new Error("Invalid signature length");
    var a = e[64];
    return a < 27 && (a += 27), {
      v: a,
      r: e.slice(0, 32),
      s: e.slice(32, 64)
    };
  }, t.privateToAddress = function (e) {
    return t.publicToAddress(f(e));
  }, t.isValidAddress = function (e) {
    return /^0x[0-9a-fA-F]{40}$/.test(e);
  }, t.isZeroAddress = function (e) {
    return t.zeroAddress() === t.addHexPrefix(e);
  }, t.toChecksumAddress = function (e) {
    e = t.stripHexPrefix(e).toLowerCase();

    for (var a = t.keccak(e).toString("hex"), r = "0x", n = 0; n < e.length; n++) {
      parseInt(a[n], 16) >= 8 ? r += e[n].toUpperCase() : r += e[n];
    }

    return r;
  }, t.isValidChecksumAddress = function (e) {
    return t.isValidAddress(e) && t.toChecksumAddress(e) === e;
  }, t.generateAddress = function (e, a) {
    return e = t.toBuffer(e), a = (a = new c(a)).isZero() ? null : d.from(a.toArray()), t.rlphash([e, a]).slice(-20);
  }, t.isPrecompiled = function (e) {
    var a = t.unpad(e);
    return 1 === a.length && a[0] >= 1 && a[0] <= 8;
  }, t.addHexPrefix = function (e) {
    return "string" != typeof e ? e : t.isHexPrefixed(e) ? e : "0x" + e;
  }, t.isValidSignature = function (e, t, a, r) {
    var n = new c("7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a0", 16),
        s = new c("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", 16);
    return 32 === t.length && 32 === a.length && (27 === e || 28 === e) && (t = new c(t), a = new c(a), !(t.isZero() || t.gt(s) || a.isZero() || a.gt(s)) && (!1 !== r || 1 !== new c(a).cmp(n)));
  }, t.baToJSON = function (e) {
    if (d.isBuffer(e)) return "0x" + e.toString("hex");

    if (e instanceof Array) {
      for (var a = [], r = 0; r < e.length; r++) {
        a.push(t.baToJSON(e[r]));
      }

      return a;
    }
  }, t.defineProperties = function (e, a, n) {
    if (e.raw = [], e._fields = [], e.toJSON = function (a) {
      if (a) {
        var r = {};
        return e._fields.forEach(function (t) {
          r[t] = "0x" + e[t].toString("hex");
        }), r;
      }

      return t.baToJSON(this.raw);
    }, e.serialize = function () {
      return i.encode(e.raw);
    }, a.forEach(function (a, r) {
      function n() {
        return e.raw[r];
      }

      function s(n) {
        "00" !== (n = t.toBuffer(n)).toString("hex") || a.allowZero || (n = d.allocUnsafe(0)), a.allowLess && a.length ? (n = t.stripZeros(n), o(a.length >= n.length, "The field " + a.name + " must not have more " + a.length + " bytes")) : a.allowZero && 0 === n.length || !a.length || o(a.length === n.length, "The field " + a.name + " must have byte length of " + a.length), e.raw[r] = n;
      }

      e._fields.push(a.name), Object.defineProperty(e, a.name, {
        enumerable: !0,
        configurable: !0,
        get: n,
        set: s
      }), a.default && (e[a.name] = a.default), a.alias && Object.defineProperty(e, a.alias, {
        enumerable: !1,
        configurable: !0,
        set: s,
        get: n
      });
    }), n) if ("string" == typeof n && (n = d.from(t.stripHexPrefix(n), "hex")), d.isBuffer(n) && (n = i.decode(n)), Array.isArray(n)) {
      if (n.length > e._fields.length) throw new Error("wrong number of fields in data");
      n.forEach(function (a, r) {
        e[e._fields[r]] = t.toBuffer(a);
      });
    } else {
      if ("object" !== (void 0 === n ? "undefined" : r(n))) throw new Error("invalid data");
      var s = Object.keys(n);
      a.forEach(function (t) {
        -1 !== s.indexOf(t.name) && (e[t.name] = n[t.name]), -1 !== s.indexOf(t.alias) && (e[t.alias] = n[t.alias]);
      });
    }
  };
},
/*!*********************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-vm/dist/index.js ***!
  \*********************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    var _r66,
        n = this && this.__extends || (_r66 = function r(e, t) {
      return (_r66 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var a in t) {
          t.hasOwnProperty(a) && (e[a] = t[a]);
        }
      })(e, t);
    }, function (e, t) {
      function a() {
        this.constructor = e;
      }

      _r66(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
    }),
        s = this && this.__awaiter || function (e, t, a, r) {
      return new (a || (a = Promise))(function (n, s) {
        function o(e) {
          try {
            c(r.next(e));
          } catch (e) {
            s(e);
          }
        }

        function i(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            s(e);
          }
        }

        function c(e) {
          e.done ? n(e.value) : new a(function (t) {
            t(e.value);
          }).then(o, i);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        o = this && this.__generator || function (e, t) {
      var a,
          r,
          n,
          s,
          o = {
        label: 0,
        sent: function sent() {
          if (1 & n[0]) throw n[1];
          return n[1];
        },
        trys: [],
        ops: []
      };
      return s = {
        next: i(0),
        throw: i(1),
        return: i(2)
      }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
        return this;
      }), s;

      function i(s) {
        return function (i) {
          return function (s) {
            if (a) throw new TypeError("Generator is already executing.");

            for (; o;) {
              try {
                if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

                switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                  case 0:
                  case 1:
                    n = s;
                    break;

                  case 4:
                    return o.label++, {
                      value: s[1],
                      done: !1
                    };

                  case 5:
                    o.label++, r = s[1], s = [0];
                    continue;

                  case 7:
                    s = o.ops.pop(), o.trys.pop();
                    continue;

                  default:
                    if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                      o = 0;
                      continue;
                    }

                    if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                      o.label = s[1];
                      break;
                    }

                    if (6 === s[0] && o.label < n[1]) {
                      o.label = n[1], n = s;
                      break;
                    }

                    if (n && o.label < n[2]) {
                      o.label = n[2], o.ops.push(s);
                      break;
                    }

                    n[2] && o.ops.pop(), o.trys.pop();
                    continue;
                }

                s = t.call(e, o);
              } catch (e) {
                s = [6, e], r = 0;
              } finally {
                a = n = 0;
              }
            }

            if (5 & s[0]) throw s[1];
            return {
              value: s[0] ? s[1] : void 0,
              done: !0
            };
          }([s, i]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = a(
    /*! bn.js */
    5),
        c = a(
    /*! ethereumjs-account */
    72),
        u = a(
    /*! ethereumjs-blockchain */
    475),
        d = a(
    /*! ethereumjs-common */
    214),
        f = a(
    /*! ./state */
    592),
        l = a(
    /*! ./runCode */
    641),
        h = a(
    /*! ./runCall */
    721),
        p = a(
    /*! ./runTx */
    722),
        b = a(
    /*! ./runBlock */
    723),
        m = a(
    /*! ./evm/opcodes */
    724),
        y = a(
    /*! ./runBlockchain */
    725),
        v = a(
    /*! util.promisify */
    88),
        _ = a(
    /*! async-eventemitter */
    726),
        g = a(
    /*! merkle-patricia-tree/secure.js */
    231),
        A = function (t) {
      function a(a) {
        void 0 === a && (a = {});
        var r = t.call(this) || this;

        if (r.opts = a, a.common) {
          if (a.chain || a.hardfork) throw new Error("You can only instantiate the VM class with one of: opts.common, or opts.chain and opts.hardfork");
          r._common = a.common;
        } else {
          var n = a.chain ? a.chain : "mainnet",
              s = a.hardfork ? a.hardfork : "petersburg";
          r._common = new d.default(n, s, ["byzantium", "constantinople", "petersburg", "istanbul"]);
        }

        if (r._opcodes = m.getOpcodesForHF(r._common.hardfork()), a.stateManager) r.stateManager = a.stateManager;else {
          var o = a.state || new g();
          if (a.activatePrecompiles) for (var l = 1; l <= 8; l++) {
            o.put(new i(l).toArrayLike(e, "be", 20), new c.default().serialize());
          }
          r.stateManager = new f.StateManager({
            trie: o,
            common: r._common
          });
        }
        return r.blockchain = a.blockchain || new u.default({
          common: r._common
        }), r.allowUnlimitedContractSize = void 0 !== a.allowUnlimitedContractSize && a.allowUnlimitedContractSize, r;
      }

      return n(a, t), a.prototype.runBlockchain = function (e) {
        return y.default.bind(this)(e);
      }, a.prototype.runBlock = function (e) {
        return b.default.bind(this)(e);
      }, a.prototype.runTx = function (e) {
        return p.default.bind(this)(e);
      }, a.prototype.runCall = function (e) {
        return h.default.bind(this)(e);
      }, a.prototype.runCode = function (e) {
        return l.default.bind(this)(e);
      }, a.prototype.copy = function () {
        return new a({
          stateManager: this.stateManager.copy(),
          blockchain: this.blockchain,
          common: this._common
        });
      }, a.prototype._emit = function (e, t) {
        return s(this, void 0, void 0, function () {
          return o(this, function (a) {
            return [2, v(this.emit.bind(this))(e, t)];
          });
        });
      }, a;
    }(_);

    t.default = A;
  }).call(this, a(
  /*! ./../../../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!*****************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-blockchain/dist/index.js ***!
  \*****************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    var r = this && this.__awaiter || function (e, t, a, r) {
      return new (a || (a = Promise))(function (n, s) {
        function o(e) {
          try {
            c(r.next(e));
          } catch (e) {
            s(e);
          }
        }

        function i(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            s(e);
          }
        }

        function c(e) {
          e.done ? n(e.value) : new a(function (t) {
            t(e.value);
          }).then(o, i);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        n = this && this.__generator || function (e, t) {
      var a,
          r,
          n,
          s,
          o = {
        label: 0,
        sent: function sent() {
          if (1 & n[0]) throw n[1];
          return n[1];
        },
        trys: [],
        ops: []
      };
      return s = {
        next: i(0),
        throw: i(1),
        return: i(2)
      }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
        return this;
      }), s;

      function i(s) {
        return function (i) {
          return function (s) {
            if (a) throw new TypeError("Generator is already executing.");

            for (; o;) {
              try {
                if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

                switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                  case 0:
                  case 1:
                    n = s;
                    break;

                  case 4:
                    return o.label++, {
                      value: s[1],
                      done: !1
                    };

                  case 5:
                    o.label++, r = s[1], s = [0];
                    continue;

                  case 7:
                    s = o.ops.pop(), o.trys.pop();
                    continue;

                  default:
                    if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                      o = 0;
                      continue;
                    }

                    if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                      o.label = s[1];
                      break;
                    }

                    if (6 === s[0] && o.label < n[1]) {
                      o.label = n[1], n = s;
                      break;
                    }

                    if (n && o.label < n[2]) {
                      o.label = n[2], o.ops.push(s);
                      break;
                    }

                    n[2] && o.ops.pop(), o.trys.pop();
                    continue;
                }

                s = t.call(e, o);
              } catch (e) {
                s = [6, e], r = 0;
              } finally {
                a = n = 0;
              }
            }

            if (5 & s[0]) throw s[1];
            return {
              value: s[0] ? s[1] : void 0,
              done: !0
            };
          }([s, i]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = a(
    /*! async */
    73),
        o = a(
    /*! ethereumjs-util */
    476),
        i = a(
    /*! ethereumjs-common */
    477),
        c = a(
    /*! ./callbackify */
    494),
        u = a(
    /*! ./dbManager */
    495),
        d = a(
    /*! ./util */
    184),
        f = a(
    /*! ethereumjs-block */
    60),
        l = a(
    /*! ethashjs */
    570),
        h = a(
    /*! flow-stoplight */
    575),
        p = a(
    /*! level-mem */
    185),
        b = a(
    /*! semaphore */
    208),
        m = function () {
      function t(e) {
        void 0 === e && (e = {});
        var t = this;

        if (e.common) {
          if (e.chain) throw new Error("Instantiation with both opts.common and opts.chain parameter not allowed!");
          this._common = e.common;
        } else {
          var a = e.chain ? e.chain : "mainnet",
              r = e.hardfork ? e.hardfork : null;
          this._common = new i.default(a, r);
        }

        this.db = e.db ? e.db : p(), this.dbManager = new u.default(this.db, this._common), this.validate = void 0 === e.validate || e.validate, this.ethash = this.validate ? new l(this.db) : null, this._heads = {}, this._genesis = null, this._headHeader = null, this._headBlock = null, this._initDone = !1, this._putSemaphore = b(1), this._initLock = new h(), this._init(function (e) {
          if (e) throw e;

          t._initLock.go();
        });
      }

      return Object.defineProperty(t.prototype, "meta", {
        get: function get() {
          return {
            rawHead: this._headHeader,
            heads: this._heads,
            genesis: this._genesis
          };
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype._init = function (t) {
        var a = this;
        s.waterfall([function (e) {
          return a._numberToHash(new o.BN(0), e);
        }, c.callbackify(function (t) {
          return r(this, void 0, void 0, function () {
            var r, s;
            return n(this, function (n) {
              switch (n.label) {
                case 0:
                  a._genesis = t, n.label = 1;

                case 1:
                  return n.trys.push([1, 3,, 4]), [4, a.dbManager.getHeads()];

                case 2:
                  return r = n.sent(), Object.keys(r).forEach(function (t) {
                    r[t] = e.from(r[t]);
                  }), a._heads = r, [3, 4];

                case 3:
                  return n.sent(), a._heads = {}, [3, 4];

                case 4:
                  return n.trys.push([4, 6,, 7]), [4, a.dbManager.getHeadHeader()];

                case 5:
                  return s = n.sent(), a._headHeader = s, [3, 7];

                case 6:
                  return n.sent(), a._headHeader = t, [3, 7];

                case 7:
                  return n.trys.push([7, 9,, 10]), [4, a.dbManager.getHeadBlock()];

                case 8:
                  return s = n.sent(), a._headBlock = s, [3, 10];

                case 9:
                  return n.sent(), a._headBlock = t, [3, 10];

                case 10:
                  return [2];
              }
            });
          });
        }.bind(this))], function (e) {
          if (e) return a._setCanonicalGenesisBlock(function (e) {
            if (e) return t(e);
            a._heads = {}, a._headHeader = a._genesis, a._headBlock = a._genesis, t();
          });
          t();
        });
      }, t.prototype._setCanonicalGenesisBlock = function (e) {
        var t = new f(null, {
          common: this._common
        });
        t.setGenesisParams(), this._putBlockOrHeader(t, e, !0);
      }, t.prototype.putGenesis = function (e, t) {
        this.putBlock(e, t, !0);
      }, t.prototype.getHead = function (e, t) {
        var a = this;
        "function" == typeof e && (t = e, e = "vm"), this._initLock.await(function () {
          var r = a._heads[e] || a._headBlock;
          if (!r) return t(new Error("No head found."));
          a.getBlock(r, t);
        });
      }, t.prototype.getLatestHeader = function (e) {
        var t = this;

        this._initLock.await(function () {
          t.getBlock(t._headHeader, function (t, a) {
            if (t) return e(t);
            e(null, a.header);
          });
        });
      }, t.prototype.getLatestBlock = function (e) {
        var t = this;

        this._initLock.await(function () {
          t.getBlock(t._headBlock, e);
        });
      }, t.prototype.putBlocks = function (e, t) {
        var a = this;
        s.eachSeries(e, function (e, t) {
          a.putBlock(e, t);
        }, t);
      }, t.prototype.putBlock = function (e, t, a) {
        var r = this;

        this._initLock.await(function () {
          r._lockUnlock(function (t) {
            r._putBlockOrHeader(e, t, a);
          }, t);
        });
      }, t.prototype.putHeaders = function (e, t) {
        var a = this;
        s.eachSeries(e, function (e, t) {
          a.putHeader(e, t);
        }, t);
      }, t.prototype.putHeader = function (e, t) {
        var a = this;

        this._initLock.await(function () {
          a._lockUnlock(function (t) {
            a._putBlockOrHeader(e, t);
          }, t);
        });
      }, t.prototype._putBlockOrHeader = function (e, t, a) {
        var r = this,
            n = e instanceof f.Header,
            i = n ? new f([e.raw, [], []], {
          common: e._common
        }) : e,
            c = i.header,
            u = i.hash(),
            l = new o.BN(c.number),
            h = new o.BN(c.difficulty),
            p = {
          header: null,
          block: null
        },
            b = [];
        if (i.constructor !== f && (i = new f(i, {
          common: r._common
        })), i._common.chainId() !== r._common.chainId()) return t(new Error("Chain mismatch while trying to put block or header"));
        s.series([function (e) {
          if (!r.validate) return e();
          if (!a && i.isGenesis()) return e(new Error("already have genesis set"));
          i.validate(r, e);
        }, function (e) {
          if (!r.validate) return e();
          r.ethash.verifyPOW(i, function (t) {
            e(t ? null : new Error("invalid POW"));
          });
        }, function (e) {
          if (a) return p.header = new o.BN(0), p.block = new o.BN(0), e();
          s.parallel([function (e) {
            return r._getTd(r._headHeader, function (t, a) {
              p.header = a, e(t);
            });
          }, function (e) {
            return r._getTd(r._headBlock, function (t, a) {
              p.block = a, e(t);
            });
          }], e);
        }, function (e) {
          if (a) return e();

          r._getTd(c.parentHash, l.subn(1), function (t, a) {
            if (t) return e(t);
            h.iadd(a), e();
          });
        }, function (e) {
          var t = d.tdKey(l, u),
              f = o.rlp.encode(h);

          if (b.push({
            type: "put",
            key: t,
            keyEncoding: "binary",
            valueEncoding: "binary",
            value: f
          }), r.dbManager._cache.td.set(t, f), t = d.headerKey(l, u), f = o.rlp.encode(c.raw), b.push({
            type: "put",
            key: t,
            keyEncoding: "binary",
            valueEncoding: "binary",
            value: f
          }), r.dbManager._cache.header.set(t, f), a || i.transactions.length || i.uncleHeaders.length) {
            var m = i.serialize(!1).slice(1);
            t = d.bodyKey(l, u), f = o.rlp.encode(m), b.push({
              type: "put",
              key: t,
              keyEncoding: "binary",
              valueEncoding: "binary",
              value: f
            }), r.dbManager._cache.body.set(t, f);
          }

          i.isGenesis() || h.gt(p.header) ? (r._headHeader = u, n || (r._headBlock = u), i.isGenesis() && (r._genesis = u), s.parallel([function (e) {
            return r._deleteStaleAssignments(l.addn(1), u, b, e);
          }, function (e) {
            return r._rebuildCanonical(c, b, e);
          }], e)) : (h.gt(p.block) && !n && (r._headBlock = u), t = d.hashToNumberKey(u), f = d.bufBE8(l), b.push({
            type: "put",
            key: t,
            keyEncoding: "binary",
            valueEncoding: "binary",
            value: f
          }), r.dbManager._cache.hashToNumber.set(t, f), e());
        }, function (e) {
          return r._batchDbOps(b.concat(r._saveHeadOps()), e);
        }], t);
      }, t.prototype.getBlock = function (e, t) {
        var a = this;

        this._initLock.await(function () {
          a._getBlock(e, t);
        });
      }, t.prototype._getBlock = function (e, t) {
        c.callbackify(this.dbManager.getBlock.bind(this.dbManager))(e, t);
      }, t.prototype.getBlocks = function (e, t, a, r, n) {
        var s = this,
            i = [],
            c = -1;
        !function e(u) {
          s.getBlock(u, function (s, u) {
            if (c++, s) return s.notFound ? n(null, i) : n(s);
            var d = new o.BN(u.header.number).addn(r ? -1 : 1);
            return 0 !== c && a && c % (a + 1) != 0 ? e(d) : (i.push(u), i.length === t ? n(null, i) : void e(d));
          });
        }(e);
      }, t.prototype.getDetails = function (e, t) {
        t(null, {});
      }, t.prototype.selectNeededHashes = function (e, t) {
        var a,
            r,
            n,
            o = this;
        a = e.length - 1, r = n = 0, s.whilst(function () {
          return a >= n;
        }, function (t) {
          o._hashToNumber(e[r], function (e, s) {
            !e && s ? n = r + 1 : a = r - 1, r = Math.floor((n + a) / 2), t();
          });
        }, function (a) {
          if (a) return t(a);
          t(null, e.slice(n));
        });
      }, t.prototype._saveHeadOps = function () {
        return [{
          type: "put",
          key: "heads",
          keyEncoding: "binary",
          valueEncoding: "json",
          value: this._heads
        }, {
          type: "put",
          key: d.headHeaderKey,
          keyEncoding: "binary",
          valueEncoding: "binary",
          value: this._headHeader
        }, {
          type: "put",
          key: d.headBlockKey,
          keyEncoding: "binary",
          valueEncoding: "binary",
          value: this._headBlock
        }];
      }, t.prototype._saveHeads = function (e) {
        this._batchDbOps(this._saveHeadOps(), e);
      }, t.prototype._deleteStaleAssignments = function (e, t, a, r) {
        var n = this,
            s = d.numberToHashKey(e);

        this._numberToHash(e, function (o, i) {
          if (o) return r();
          a.push({
            type: "del",
            key: s,
            keyEncoding: "binary"
          }), n.dbManager._cache.numberToHash.del(s), Object.keys(n._heads).forEach(function (e) {
            n._heads[e].equals(i) && (n._heads[e] = t);
          }), n._headBlock.equals(i) && (n._headBlock = t), n._deleteStaleAssignments(e.addn(1), t, a, r);
        });
      }, t.prototype._rebuildCanonical = function (e, t, a) {
        var r = this,
            n = e.hash(),
            s = new o.BN(e.number);

        function i(e, a) {
          var n,
              s = d.numberToHashKey(a);
          t.push({
            type: "put",
            key: s,
            keyEncoding: "binary",
            valueEncoding: "binary",
            value: e
          }), r.dbManager._cache.numberToHash.set(s, e), s = d.hashToNumberKey(e), n = d.bufBE8(a), t.push({
            type: "put",
            key: s,
            keyEncoding: "binary",
            valueEncoding: "binary",
            value: n
          }), r.dbManager._cache.hashToNumber.set(s, n);
        }

        if (0 === s.cmpn(0)) return i(n, s), a();

        r._numberToHash(s, function (o, c) {
          o && (c = null), c && n.equals(c) ? ((r._staleHeads || []).forEach(function (e) {
            r._heads[e] = n;
          }), delete r._staleHeads, r._staleHeadBlock && (r._headBlock = n, delete r._staleHeadBlock), a()) : (i(n, s), Object.keys(r._heads).forEach(function (e) {
            c && r._heads[e].equals(c) && (r._staleHeads = r._staleHeads || [], r._staleHeads.push(e));
          }), c && r._headBlock.equals(c) && (r._staleHeadBlock = !0), r._getHeader(e.parentHash, s.subn(1), function (e, n) {
            if (e) return delete r._staleHeads, a(e);

            r._rebuildCanonical(n, t, a);
          }));
        });
      }, t.prototype.delBlock = function (e, t) {
        var a = this;

        this._initLock.await(function () {
          a._lockUnlock(function (t) {
            a._delBlock(e, t);
          }, t);
        });
      }, t.prototype._delBlock = function (t, a) {
        var r = this,
            n = [],
            i = null,
            c = null,
            u = null,
            d = null;
        e.isBuffer(t) || (t = t.hash()), s.series([function (e) {
          r._getHeader(t, function (t, a) {
            if (t) return e(t);
            i = a, c = new o.BN(i.number), u = i.parentHash, e();
          });
        }, function (e) {
          r._numberToHash(c, function (a, r) {
            d = !a && r.equals(t), e();
          });
        }, function (e) {
          r._delChild(t, c, d ? u : null, n, e);
        }, function (e) {
          d ? r._deleteStaleAssignments(c, u, n, e) : e();
        }, function (e) {
          return r._batchDbOps(n, e);
        }], a);
      }, t.prototype._delChild = function (e, t, a, r, n) {
        var s = this;
        if (r.push({
          type: "del",
          key: d.headerKey(t, e),
          keyEncoding: "binary"
        }), s.dbManager._cache.header.del(d.headerKey(t, e)), r.push({
          type: "del",
          key: d.bodyKey(t, e),
          keyEncoding: "binary"
        }), s.dbManager._cache.body.del(d.bodyKey(t, e)), r.push({
          type: "del",
          key: d.hashToNumberKey(e),
          keyEncoding: "binary"
        }), s.dbManager._cache.hashToNumber.del(d.hashToNumberKey(e)), r.push({
          type: "del",
          key: d.tdKey(t, e),
          keyEncoding: "binary"
        }), s.dbManager._cache.td.del(d.tdKey(t, e)), !a) return n();
        e.equals(s._headHeader) && (s._headHeader = a), e.equals(s._headBlock) && (s._headBlock = a), s._getCanonicalHeader(t.addn(1), function (e, t) {
          if (e) return n();

          s._delChild(t.hash(), new o.BN(t.number), a, r, n);
        });
      }, t.prototype.iterator = function (e, t, a) {
        var r = this;

        this._initLock.await(function () {
          r._iterator(e, t, a);
        });
      }, t.prototype._iterator = function (e, t, a) {
        var r,
            n,
            o = this,
            i = o._heads[e] || o._genesis;
        if (!i) return a();

        function c(a) {
          var i;
          s.series([function (t) {
            o.getBlock(r, function (a, r) {
              (i = r) && (o._heads[e] = i.hash()), t(a);
            });
          }, function (e) {
            var a = !!n && n.hash().equals(i.header.parentHash);
            n = i, t(i, a, e);
          }], function (e) {
            if (e) {
              if (r = !1, "NotFoundError" === e.type) return a();
            } else r.iaddn(1);

            a(e);
          });
        }

        o._hashToNumber(i, function (e, t) {
          if (e) return a(e);
          r = t.addn(1), s.whilst(function () {
            return r;
          }, c, function (e) {
            return e ? a(e) : o._saveHeads(a);
          });
        });
      }, t.prototype._batchDbOps = function (e, t) {
        c.callbackify(this.dbManager.batch.bind(this.dbManager))(e, t);
      }, t.prototype._hashToNumber = function (e, t) {
        c.callbackify(this.dbManager.hashToNumber.bind(this.dbManager))(e, t);
      }, t.prototype._numberToHash = function (e, t) {
        c.callbackify(this.dbManager.numberToHash.bind(this.dbManager))(e, t);
      }, t.prototype._lookupByHashNumber = function (e, t, a, r) {
        if ("function" == typeof t) return a = t, this._hashToNumber(e, function (t, n) {
          if (t) return r(t, e, null, a);
          r(null, e, n, a);
        });
        r(null, e, t, a);
      }, t.prototype._getHeader = function (e, t, a) {
        var r = this;

        this._lookupByHashNumber(e, t, a, function (e, t, a, n) {
          if (e) return n(e);
          c.callbackify(r.dbManager.getHeader.bind(r.dbManager))(t, a, n);
        });
      }, t.prototype._getCanonicalHeader = function (e, t) {
        var a = this;

        this._numberToHash(e, function (r, n) {
          if (r) return t(r);

          a._getHeader(n, e, t);
        });
      }, t.prototype._getTd = function (e, t, a) {
        var r = this;

        this._lookupByHashNumber(e, t, a, function (e, t, a, n) {
          if (e) return n(e);
          c.callbackify(r.dbManager.getTd.bind(r.dbManager))(t, a, n);
        });
      }, t.prototype._lockUnlock = function (e, t) {
        var a = this;

        this._putSemaphore.take(function () {
          e(function () {
            a._putSemaphore.leave(), t.apply(null, arguments);
          });
        });
      }, t;
    }();

    t.default = m;
  }).call(this, a(
  /*! ./../../../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!**********************************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-blockchain/node_modules/ethereumjs-util/dist/index.js ***!
  \**********************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = a(
  /*! bn.js */
  5);
  t.BN = r;
  var n = a(
  /*! rlp */
  21);
  t.rlp = n;
  var s = a(
  /*! keccak */
  33),
      o = a(
  /*! secp256k1 */
  30);
  t.secp256k1 = o;
  var i = a(
  /*! assert */
  19),
      c = a(
  /*! create-hash */
  20),
      u = a(
  /*! safe-buffer */
  7).Buffer,
      d = a(
  /*! ethjs-util */
  36);

  function f(e, t) {
    return t ? e - (2 * t + 35) : e - 27;
  }

  function l(e) {
    return 0 === e || 1 === e;
  }

  Object.assign(t, d), t.MAX_INTEGER = new r("ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff", 16), t.TWO_POW256 = new r("10000000000000000000000000000000000000000000000000000000000000000", 16), t.KECCAK256_NULL_S = "c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470", t.KECCAK256_NULL = u.from(t.KECCAK256_NULL_S, "hex"), t.KECCAK256_RLP_ARRAY_S = "1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347", t.KECCAK256_RLP_ARRAY = u.from(t.KECCAK256_RLP_ARRAY_S, "hex"), t.KECCAK256_RLP_S = "56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421", t.KECCAK256_RLP = u.from(t.KECCAK256_RLP_S, "hex"), t.zeros = function (e) {
    return u.allocUnsafe(e).fill(0);
  }, t.zeroAddress = function () {
    var e = t.zeros(20);
    return t.bufferToHex(e);
  }, t.setLengthLeft = function (e, a, r) {
    void 0 === r && (r = !1);
    var n = t.zeros(a);
    return e = t.toBuffer(e), r ? e.length < a ? (e.copy(n), n) : e.slice(0, a) : e.length < a ? (e.copy(n, a - e.length), n) : e.slice(-a);
  }, t.setLength = t.setLengthLeft, t.setLengthRight = function (e, a) {
    return t.setLength(e, a, !0);
  }, t.unpad = function (e) {
    for (var t = (e = d.stripHexPrefix(e))[0]; e.length > 0 && "0" === t.toString();) {
      t = (e = e.slice(1))[0];
    }

    return e;
  }, t.stripZeros = t.unpad, t.toBuffer = function (e) {
    if (!u.isBuffer(e)) if (Array.isArray(e)) e = u.from(e);else if ("string" == typeof e) e = t.isHexString(e) ? u.from(t.padToEven(t.stripHexPrefix(e)), "hex") : u.from(e);else if ("number" == typeof e) e = t.intToBuffer(e);else if (null == e) e = u.allocUnsafe(0);else if (r.isBN(e)) e = e.toArrayLike(u);else {
      if (!e.toArray) throw new Error("invalid type");
      e = u.from(e.toArray());
    }
    return e;
  }, t.bufferToInt = function (e) {
    return new r(t.toBuffer(e)).toNumber();
  }, t.bufferToHex = function (e) {
    return "0x" + (e = t.toBuffer(e)).toString("hex");
  }, t.fromSigned = function (e) {
    return new r(e).fromTwos(256);
  }, t.toUnsigned = function (e) {
    return u.from(e.toTwos(256).toArray());
  }, t.keccak = function (e, a) {
    return void 0 === a && (a = 256), e = t.toBuffer(e), a || (a = 256), s("keccak" + a).update(e).digest();
  }, t.keccak256 = function (e) {
    return t.keccak(e);
  }, t.sha256 = function (e) {
    return e = t.toBuffer(e), c("sha256").update(e).digest();
  }, t.ripemd160 = function (e, a) {
    e = t.toBuffer(e);
    var r = c("rmd160").update(e).digest();
    return !0 === a ? t.setLength(r, 32) : r;
  }, t.rlphash = function (e) {
    return t.keccak(n.encode(e));
  }, t.isValidPrivate = function (e) {
    return o.privateKeyVerify(e);
  }, t.isValidPublic = function (e, t) {
    return void 0 === t && (t = !1), 64 === e.length ? o.publicKeyVerify(u.concat([u.from([4]), e])) : !!t && o.publicKeyVerify(e);
  }, t.pubToAddress = function (e, a) {
    return void 0 === a && (a = !1), e = t.toBuffer(e), a && 64 !== e.length && (e = o.publicKeyConvert(e, !1).slice(1)), i(64 === e.length), t.keccak(e).slice(-20);
  }, t.publicToAddress = t.pubToAddress, t.privateToPublic = function (e) {
    return e = t.toBuffer(e), o.publicKeyCreate(e, !1).slice(1);
  }, t.importPublic = function (e) {
    return 64 !== (e = t.toBuffer(e)).length && (e = o.publicKeyConvert(e, !1).slice(1)), e;
  }, t.ecsign = function (e, t, a) {
    var r = o.sign(e, t),
        n = r.recovery;
    return {
      r: r.signature.slice(0, 32),
      s: r.signature.slice(32, 64),
      v: a ? n + (2 * a + 35) : n + 27
    };
  }, t.hashPersonalMessage = function (e) {
    var a = t.toBuffer("Ethereum Signed Message:\n" + e.length.toString());
    return t.keccak(u.concat([a, e]));
  }, t.ecrecover = function (e, a, r, n, s) {
    var i = u.concat([t.setLength(r, 32), t.setLength(n, 32)], 64),
        c = f(a, s);
    if (!l(c)) throw new Error("Invalid signature v value");
    var d = o.recover(e, i, c);
    return o.publicKeyConvert(d, !1).slice(1);
  }, t.toRpcSig = function (e, a, r, n) {
    if (!l(f(e, n))) throw new Error("Invalid signature v value");
    return t.bufferToHex(u.concat([t.setLengthLeft(a, 32), t.setLengthLeft(r, 32), t.toBuffer(e)]));
  }, t.fromRpcSig = function (e) {
    var a = t.toBuffer(e);
    if (65 !== a.length) throw new Error("Invalid signature length");
    var r = a[64];
    return r < 27 && (r += 27), {
      v: r,
      r: a.slice(0, 32),
      s: a.slice(32, 64)
    };
  }, t.privateToAddress = function (e) {
    return t.publicToAddress(t.privateToPublic(e));
  }, t.isValidAddress = function (e) {
    return /^0x[0-9a-fA-F]{40}$/.test(e);
  }, t.isZeroAddress = function (e) {
    return t.zeroAddress() === t.addHexPrefix(e);
  }, t.toChecksumAddress = function (e) {
    e = d.stripHexPrefix(e).toLowerCase();

    for (var a = t.keccak(e).toString("hex"), r = "0x", n = 0; n < e.length; n++) {
      parseInt(a[n], 16) >= 8 ? r += e[n].toUpperCase() : r += e[n];
    }

    return r;
  }, t.isValidChecksumAddress = function (e) {
    return t.isValidAddress(e) && t.toChecksumAddress(e) === e;
  }, t.generateAddress = function (e, a) {
    e = t.toBuffer(e);
    var n = new r(a);
    return n.isZero() ? t.rlphash([e, null]).slice(-20) : t.rlphash([e, u.from(n.toArray())]).slice(-20);
  }, t.generateAddress2 = function (e, a, r) {
    var n = t.toBuffer(e),
        s = t.toBuffer(a),
        o = t.toBuffer(r);
    return i(20 === n.length), i(32 === s.length), t.keccak256(u.concat([u.from("ff", "hex"), n, s, t.keccak256(o)])).slice(-20);
  }, t.isPrecompiled = function (e) {
    var a = t.unpad(e);
    return 1 === a.length && a[0] >= 1 && a[0] <= 8;
  }, t.addHexPrefix = function (e) {
    return "string" != typeof e ? e : d.isHexPrefixed(e) ? e : "0x" + e;
  }, t.isValidSignature = function (e, t, a, n, s) {
    void 0 === n && (n = !0);
    var o = new r("7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a0", 16),
        i = new r("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", 16);
    if (32 !== t.length || 32 !== a.length) return !1;
    if (!l(f(e, s))) return !1;
    var c = new r(t),
        u = new r(a);
    return !(c.isZero() || c.gt(i) || u.isZero() || u.gt(i)) && (!n || 1 !== u.cmp(o));
  }, t.baToJSON = function (e) {
    if (u.isBuffer(e)) return "0x" + e.toString("hex");

    if (e instanceof Array) {
      for (var a = [], r = 0; r < e.length; r++) {
        a.push(t.baToJSON(e[r]));
      }

      return a;
    }
  }, t.defineProperties = function (e, a, r) {
    if (e.raw = [], e._fields = [], e.toJSON = function (a) {
      if (void 0 === a && (a = !1), a) {
        var r = {};
        return e._fields.forEach(function (t) {
          r[t] = "0x" + e[t].toString("hex");
        }), r;
      }

      return t.baToJSON(e.raw);
    }, e.serialize = function () {
      return n.encode(e.raw);
    }, a.forEach(function (a, r) {
      function n() {
        return e.raw[r];
      }

      function s(n) {
        "00" !== (n = t.toBuffer(n)).toString("hex") || a.allowZero || (n = u.allocUnsafe(0)), a.allowLess && a.length ? (n = t.stripZeros(n), i(a.length >= n.length, "The field " + a.name + " must not have more " + a.length + " bytes")) : a.allowZero && 0 === n.length || !a.length || i(a.length === n.length, "The field " + a.name + " must have byte length of " + a.length), e.raw[r] = n;
      }

      e._fields.push(a.name), Object.defineProperty(e, a.name, {
        enumerable: !0,
        configurable: !0,
        get: n,
        set: s
      }), a.default && (e[a.name] = a.default), a.alias && Object.defineProperty(e, a.alias, {
        enumerable: !1,
        configurable: !0,
        set: s,
        get: n
      });
    }), r) if ("string" == typeof r && (r = u.from(d.stripHexPrefix(r), "hex")), u.isBuffer(r) && (r = n.decode(r)), Array.isArray(r)) {
      if (r.length > e._fields.length) throw new Error("wrong number of fields in data");
      r.forEach(function (a, r) {
        e[e._fields[r]] = t.toBuffer(a);
      });
    } else {
      if ("object" != typeof r) throw new Error("invalid data");
      var s = Object.keys(r);
      a.forEach(function (t) {
        -1 !== s.indexOf(t.name) && (e[t.name] = r[t.name]), -1 !== s.indexOf(t.alias) && (e[t.alias] = r[t.alias]);
      });
    }
  };
},
/*!************************************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-blockchain/node_modules/ethereumjs-common/dist/index.js ***!
  \************************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = this && this.__assign || function () {
    return (r = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var n = a(
  /*! ./chains */
  478),
      s = a(
  /*! ./hardforks */
  484),
      o = function () {
    function e(e, t, a) {
      this._chainParams = this.setChain(e), this._hardfork = null, this._supportedHardforks = void 0 === a ? [] : a, t && this.setHardfork(t);
    }

    return e.forCustomChain = function (t, a, n, s) {
      var o = e._getChainParams(t);

      return new e(r({}, o, a), n, s);
    }, e._getChainParams = function (e) {
      if ("number" == typeof e) {
        if (n.chains.names[e]) return n.chains[n.chains.names[e]];
        throw new Error("Chain with ID " + e + " not supported");
      }

      if (n.chains[e]) return n.chains[e];
      throw new Error("Chain with name " + e + " not supported");
    }, e.prototype.setChain = function (t) {
      if ("number" == typeof t || "string" == typeof t) this._chainParams = e._getChainParams(t);else {
        if ("object" != typeof t) throw new Error("Wrong input format");

        for (var a = 0, r = ["networkId", "genesis", "hardforks", "bootstrapNodes"]; a < r.length; a++) {
          var n = r[a];
          if (void 0 === t[n]) throw new Error("Missing required chain parameter: " + n);
        }

        this._chainParams = t;
      }
      return this._chainParams;
    }, e.prototype.setHardfork = function (e) {
      if (!this._isSupportedHardfork(e)) throw new Error("Hardfork " + e + " not set as supported in supportedHardforks");

      for (var t = !1, a = 0, r = s.hardforks; a < r.length; a++) {
        r[a][0] === e && (this._hardfork = e, t = !0);
      }

      if (!t) throw new Error("Hardfork with name " + e + " not supported");
    }, e.prototype._chooseHardfork = function (e, t) {
      if (t = void 0 === t || t, e) {
        if (t && !this._isSupportedHardfork(e)) throw new Error("Hardfork " + e + " not set as supported in supportedHardforks");
      } else {
        if (!this._hardfork) throw new Error("Method called with neither a hardfork set nor provided by param");
        e = this._hardfork;
      }

      return e;
    }, e.prototype._getHardfork = function (e) {
      for (var t = 0, a = this.hardforks(); t < a.length; t++) {
        var r = a[t];
        if (r.name === e) return r;
      }

      throw new Error("Hardfork " + e + " not defined for chain " + this.chainName());
    }, e.prototype._isSupportedHardfork = function (e) {
      if (!(this._supportedHardforks.length > 0)) return !0;

      for (var t = 0, a = this._supportedHardforks; t < a.length; t++) {
        if (e === a[t]) return !0;
      }

      return !1;
    }, e.prototype.param = function (e, t, a) {
      var r;
      a = this._chooseHardfork(a);

      for (var n = 0, o = s.hardforks; n < o.length; n++) {
        var i = o[n];
        if (!i[1][e]) throw new Error("Topic " + e + " not defined");
        if (void 0 !== i[1][e][t] && (r = i[1][e][t].v), i[0] === a) break;
      }

      if (void 0 === r) throw new Error(e + " value for " + t + " not found");
      return r;
    }, e.prototype.paramByBlock = function (e, t, a) {
      var r = this.activeHardforks(a),
          n = r[r.length - 1].name;
      return this.param(e, t, n);
    }, e.prototype.hardforkIsActiveOnBlock = function (e, t, a) {
      var r = void 0 !== (a = void 0 !== a ? a : {}).onlySupported && a.onlySupported;
      e = this._chooseHardfork(e, r);
      var n = this.hardforkBlock(e);
      return null !== n && t >= n;
    }, e.prototype.activeOnBlock = function (e, t) {
      return this.hardforkIsActiveOnBlock(null, e, t);
    }, e.prototype.hardforkGteHardfork = function (e, t, a) {
      var r = void 0 !== (a = void 0 !== a ? a : {}).onlyActive && a.onlyActive;
      e = this._chooseHardfork(e, a.onlySupported);

      for (var n = -1, s = -1, o = 0, i = 0, c = r ? this.activeHardforks(null, a) : this.hardforks(); i < c.length; i++) {
        var u = c[i];
        u.name === e && (n = o), u.name === t && (s = o), o += 1;
      }

      return n >= s;
    }, e.prototype.gteHardfork = function (e, t) {
      return this.hardforkGteHardfork(null, e, t);
    }, e.prototype.hardforkIsActiveOnChain = function (e, t) {
      var a = void 0 !== (t = void 0 !== t ? t : {}).onlySupported && t.onlySupported;
      e = this._chooseHardfork(e, a);

      for (var r = 0, n = this.hardforks(); r < n.length; r++) {
        var s = n[r];
        if (s.name === e && null !== s.block) return !0;
      }

      return !1;
    }, e.prototype.activeHardforks = function (e, t) {
      t = void 0 !== t ? t : {};

      for (var a = [], r = 0, n = this.hardforks(); r < n.length; r++) {
        var s = n[r];

        if (null !== s.block) {
          if (null != e && e < s.block) break;
          t.onlySupported && !this._isSupportedHardfork(s.name) || a.push(s);
        }
      }

      return a;
    }, e.prototype.activeHardfork = function (e, t) {
      t = void 0 !== t ? t : {};
      var a = this.activeHardforks(e, t);
      if (a.length > 0) return a[a.length - 1].name;
      throw new Error("No (supported) active hardfork found");
    }, e.prototype.hardforkBlock = function (e) {
      return e = this._chooseHardfork(e, !1), this._getHardfork(e).block;
    }, e.prototype.isHardforkBlock = function (e, t) {
      return t = this._chooseHardfork(t, !1), this.hardforkBlock(t) === e;
    }, e.prototype.consensus = function (e) {
      return e = this._chooseHardfork(e), this._getHardfork(e).consensus;
    }, e.prototype.finality = function (e) {
      return e = this._chooseHardfork(e), this._getHardfork(e).finality;
    }, e.prototype.genesis = function () {
      return this._chainParams.genesis;
    }, e.prototype.hardforks = function () {
      return this._chainParams.hardforks;
    }, e.prototype.bootstrapNodes = function () {
      return this._chainParams.bootstrapNodes;
    }, e.prototype.hardfork = function () {
      return this._hardfork;
    }, e.prototype.chainId = function () {
      return this._chainParams.chainId;
    }, e.prototype.chainName = function () {
      return n.chains.names[this.chainId()] || this._chainParams.name;
    }, e.prototype.networkId = function () {
      return this._chainParams.networkId;
    }, e;
  }();

  t.default = o;
},
/*!*******************************************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-blockchain/node_modules/ethereumjs-common/dist/chains/index.js ***!
  \*******************************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.chains = {
    names: {
      1: "mainnet",
      3: "ropsten",
      4: "rinkeby",
      42: "kovan",
      6284: "goerli"
    },
    mainnet: a(
    /*! ./mainnet.json */
    479),
    ropsten: a(
    /*! ./ropsten.json */
    480),
    rinkeby: a(
    /*! ./rinkeby.json */
    481),
    kovan: a(
    /*! ./kovan.json */
    482),
    goerli: a(
    /*! ./goerli.json */
    483)
  };
},
/*!***********************************************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-blockchain/node_modules/ethereumjs-common/dist/chains/mainnet.json ***!
  \***********************************************************************************************************************************/

/*! exports provided: name, chainId, networkId, comment, url, genesis, hardforks, bootstrapNodes, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"mainnet","chainId":1,"networkId":1,"comment":"The Ethereum main chain","url":"https://ethstats.net/","genesis":{"hash":"0xd4e56740f876aef8c010b86a40d5f56745a118d0906a34e69aec8c0db1cb8fa3","timestamp":null,"gasLimit":5000,"difficulty":17179869184,"nonce":"0x0000000000000042","extraData":"0x11bbe8db4e347b4e8c937c1c8370e4b5ed33adb3db69cbdb7a38e1e50b1b82fa","stateRoot":"0xd7f8974fb5ac78d9ac099b9ad5018bedc2ce0a72dad1827a1709da30580f0544"},"hardforks":[{"name":"chainstart","block":0,"consensus":"pow","finality":null},{"name":"homestead","block":1150000,"consensus":"pow","finality":null},{"name":"dao","block":1920000,"consensus":"pow","finality":null},{"name":"tangerineWhistle","block":2463000,"consensus":"pow","finality":null},{"name":"spuriousDragon","block":2675000,"consensus":"pow","finality":null},{"name":"byzantium","block":4370000,"consensus":"pow","finality":null},{"name":"constantinople","block":7280000,"consensus":"pow","finality":null},{"name":"petersburg","block":7280000,"consensus":"pow","finality":null},{"name":"istanbul","block":null,"consensus":"pow","finality":null}],"bootstrapNodes":[{"ip":"13.93.211.84","port":30303,"id":"3f1d12044546b76342d59d4a05532c14b85aa669704bfe1f864fe079415aa2c02d743e03218e57a33fb94523adb54032871a6c51b2cc5514cb7c7e35b3ed0a99","location":"US-WEST","comment":"Go Bootnode"},{"ip":"191.235.84.50","port":30303,"id":"78de8a0916848093c73790ead81d1928bec737d565119932b98c6b100d944b7a95e94f847f689fc723399d2e31129d182f7ef3863f2b4c820abbf3ab2722344d","location":"BR","comment":"Go Bootnode"},{"ip":"13.75.154.138","port":30303,"id":"158f8aab45f6d19c6cbf4a089c2670541a8da11978a2f90dbf6a502a4a3bab80d288afdbeb7ec0ef6d92de563767f3b1ea9e8e334ca711e9f8e2df5a0385e8e6","location":"AU","comment":"Go Bootnode"},{"ip":"52.74.57.123","port":30303,"id":"1118980bf48b0a3640bdba04e0fe78b1add18e1cd99bf22d53daac1fd9972ad650df52176e7c7d89d1114cfef2bc23a2959aa54998a46afcf7d91809f0855082","location":"SG","comment":"Go Bootnode"}]}');
},
/*!***********************************************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-blockchain/node_modules/ethereumjs-common/dist/chains/ropsten.json ***!
  \***********************************************************************************************************************************/

/*! exports provided: name, chainId, networkId, comment, url, genesis, hardforks, bootstrapNodes, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"ropsten","chainId":3,"networkId":3,"comment":"PoW test network","url":"https://github.com/ethereum/ropsten","genesis":{"hash":"0x41941023680923e0fe4d74a34bdac8141f2540e3ae90623718e47d66d1ca4a2d","timestamp":null,"gasLimit":16777216,"difficulty":1048576,"nonce":"0x0000000000000042","extraData":"0x3535353535353535353535353535353535353535353535353535353535353535","stateRoot":"0x217b0bbcfb72e2d57e28f33cb361b9983513177755dc3f33ce3e7022ed62b77b"},"hardforks":[{"name":"chainstart","block":0,"consensus":"pow","finality":null},{"name":"homestead","block":0,"consensus":"pow","finality":null},{"name":"dao","block":null,"consensus":"pow","finality":null},{"name":"tangerineWhistle","block":0,"consensus":"pow","finality":null},{"name":"spuriousDragon","block":10,"consensus":"pow","finality":null},{"name":"byzantium","block":1700000,"consensus":"pow","finality":null},{"name":"constantinople","block":4230000,"consensus":"pow","finality":null},{"name":"petersburg","block":4939394,"consensus":"pow","finality":null},{"name":"istanbul","block":null,"consensus":"pow","finality":null}],"bootstrapNodes":[{"ip":"52.176.7.10","port":"30303","id":"30b7ab30a01c124a6cceca36863ece12c4f5fa68e3ba9b0b51407ccc002eeed3b3102d20a88f1c1d3c3154e2449317b8ef95090e77b312d5cc39354f86d5d606","network":"Ropsten","chainId":3,"location":"US","comment":"US-Azure geth"},{"ip":"52.176.100.77","port":"30303","id":"865a63255b3bb68023b6bffd5095118fcc13e79dcf014fe4e47e065c350c7cc72af2e53eff895f11ba1bbb6a2b33271c1116ee870f266618eadfc2e78aa7349c","network":"Ropsten","chainId":3,"location":"US","comment":"US-Azure parity"},{"ip":"52.232.243.152","port":"30303","id":"6332792c4a00e3e4ee0926ed89e0d27ef985424d97b6a45bf0f23e51f0dcb5e66b875777506458aea7af6f9e4ffb69f43f3778ee73c81ed9d34c51c4b16b0b0f","network":"Ropsten","chainId":3,"location":"US","comment":"Parity"},{"ip":"192.81.208.223","port":"30303","id":"94c15d1b9e2fe7ce56e458b9a3b672ef11894ddedd0c6f247e0f1d3487f52b66208fb4aeb8179fce6e3a749ea93ed147c37976d67af557508d199d9594c35f09","network":"Ropsten","chainId":3,"location":"US","comment":"@gpip"}]}');
},
/*!***********************************************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-blockchain/node_modules/ethereumjs-common/dist/chains/rinkeby.json ***!
  \***********************************************************************************************************************************/

/*! exports provided: name, chainId, networkId, comment, url, genesis, hardforks, bootstrapNodes, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"rinkeby","chainId":4,"networkId":4,"comment":"PoA test network","url":"https://www.rinkeby.io","genesis":{"hash":"0x6341fd3daf94b748c72ced5a5b26028f2474f5f00d824504e4fa37a75767e177","timestamp":"0x58ee40ba","gasLimit":4700000,"difficulty":1,"nonce":"0x0000000000000000","extraData":"0x52657370656374206d7920617574686f7269746168207e452e436172746d616e42eb768f2244c8811c63729a21a3569731535f067ffc57839b00206d1ad20c69a1981b489f772031b279182d99e65703f0076e4812653aab85fca0f00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000","stateRoot":"0x53580584816f617295ea26c0e17641e0120cab2f0a8ffb53a866fd53aa8e8c2d"},"hardforks":[{"name":"chainstart","block":0,"consensus":"poa","finality":null},{"name":"homestead","block":1,"consensus":"poa","finality":null},{"name":"dao","block":null,"consensus":"poa","finality":null},{"name":"tangerineWhistle","block":2,"consensus":"poa","finality":null},{"name":"spuriousDragon","block":3,"consensus":"poa","finality":null},{"name":"byzantium","block":1035301,"consensus":"poa","finality":null},{"name":"constantinople","block":null,"consensus":"poa","finality":null},{"name":"istanbul","block":null,"consensus":"poa","finality":null}],"bootstrapNodes":[{"ip":"52.169.42.101","port":30303,"id":"a24ac7c5484ef4ed0c5eb2d36620ba4e4aa13b8c84684e1b4aab0cebea2ae45cb4d375b77eab56516d34bfbd3c1a833fc51296ff084b770b94fb9028c4d25ccf","location":"IE","comment":""},{"ip":"52.3.158.184","port":30303,"id":"343149e4feefa15d882d9fe4ac7d88f885bd05ebb735e547f12e12080a9fa07c8014ca6fd7f373123488102fe5e34111f8509cf0b7de3f5b44339c9f25e87cb8","location":"","comment":"INFURA"}]}');
},
/*!*********************************************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-blockchain/node_modules/ethereumjs-common/dist/chains/kovan.json ***!
  \*********************************************************************************************************************************/

/*! exports provided: name, chainId, networkId, comment, url, genesis, hardforks, bootstrapNodes, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"kovan","chainId":42,"networkId":42,"comment":"Parity PoA test network","url":"https://kovan-testnet.github.io/website/","genesis":{"hash":"0xa3c565fc15c7478862d50ccd6561e3c06b24cc509bf388941c25ea985ce32cb9","timestamp":null,"gasLimit":6000000,"difficulty":131072,"nonce":"0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000","extraData":"0x","stateRoot":"0x2480155b48a1cea17d67dbfdfaafe821c1d19cdd478c5358e8ec56dec24502b2"},"hardforks":[],"bootstrapNodes":[{"ip":"40.71.221.215","port":30303,"id":"56abaf065581a5985b8c5f4f88bd202526482761ba10be9bfdcd14846dd01f652ec33fde0f8c0fd1db19b59a4c04465681fcef50e11380ca88d25996191c52de","location":"","comment":"Parity Bootnode"},{"ip":"52.166.117.77","port":30303,"id":"d07827483dc47b368eaf88454fb04b41b7452cf454e194e2bd4c14f98a3278fed5d819dbecd0d010407fc7688d941ee1e58d4f9c6354d3da3be92f55c17d7ce3","location":"","comment":"Parity Bootnode"},{"ip":"52.165.239.18","port":30303,"id":"8fa162563a8e5a05eef3e1cd5abc5828c71344f7277bb788a395cce4a0e30baf2b34b92fe0b2dbbba2313ee40236bae2aab3c9811941b9f5a7e8e90aaa27ecba","location":"","comment":"Parity Bootnode"},{"ip":"52.243.47.56","port":30303,"id":"7e2e7f00784f516939f94e22bdc6cf96153603ca2b5df1c7cc0f90a38e7a2f218ffb1c05b156835e8b49086d11fdd1b3e2965be16baa55204167aa9bf536a4d9","location":"","comment":"Parity Bootnode"},{"ip":"40.68.248.100","port":30303,"id":"0518a3d35d4a7b3e8c433e7ffd2355d84a1304ceb5ef349787b556197f0c87fad09daed760635b97d52179d645d3e6d16a37d2cc0a9945c2ddf585684beb39ac","location":"","comment":"Parity Bootnode"}]}');
},
/*!**********************************************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-blockchain/node_modules/ethereumjs-common/dist/chains/goerli.json ***!
  \**********************************************************************************************************************************/

/*! exports provided: name, chainId, networkId, comment, url, genesis, hardforks, bootstrapNodes, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"goerli","chainId":5,"networkId":5,"comment":"Cross-client PoA test network","url":"https://github.com/goerli/testnet","genesis":{"hash":"0xbf7e331f7f7c1dd2e05159666b3bf8bc7a8a3a9eb1d518969eab529dd9b88c1a","timestamp":"0x5c51a607","gasLimit":10485760,"difficulty":1,"nonce":"0x0000000000000000","extraData":"0x22466c6578692069732061207468696e6722202d204166726900000000000000e0a2bd4258d2768837baa26a28fe71dc079f84c70000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000","stateRoot":"0x5d6cded585e73c4e322c30c2f782a336316f17dd85a4863b9d838d2d4b8b3008"},"hardforks":[{"name":"chainstart","block":0,"consensus":"poa","finality":null},{"name":"homestead","block":0,"consensus":"poa","finality":null},{"name":"dao","block":0,"consensus":"poa","finality":null},{"name":"tangerineWhistle","block":0,"consensus":"poa","finality":null},{"name":"spuriousDragon","block":0,"consensus":"poa","finality":null},{"name":"byzantium","block":0,"consensus":"poa","finality":null},{"name":"constantinople","block":0,"consensus":"poa","finality":null},{"name":"petersburg","block":0,"consensus":"poa","finality":null},{"name":"istanbul","block":null,"consensus":"poa","finality":null}],"bootstrapNodes":[{"ip":"51.141.78.53","port":30303,"id":"011f758e6552d105183b1761c5e2dea0111bc20fd5f6422bc7f91e0fabbec9a6595caf6239b37feb773dddd3f87240d99d859431891e4a642cf2a0a9e6cbb98a","location":"","comment":"Source: https://github.com/goerli/testnet/blob/master/bootnodes.txt"},{"ip":"13.93.54.137","port":30303,"id":"176b9417f511d05b6b2cf3e34b756cf0a7096b3094572a8f6ef4cdcb9d1f9d00683bf0f83347eebdf3b81c3521c2332086d9592802230bf528eaf606a1d9677b","location":"","comment":"Source: https://github.com/goerli/testnet/blob/master/bootnodes.txt"},{"ip":"94.237.54.114","port":30313,"id":"46add44b9f13965f7b9875ac6b85f016f341012d84f975377573800a863526f4da19ae2c620ec73d11591fa9510e992ecc03ad0751f53cc02f7c7ed6d55c7291","location":"","comment":"Source: https://github.com/goerli/testnet/blob/master/bootnodes.txt"},{"ip":"52.64.155.147","port":30303,"id":"c1f8b7c2ac4453271fa07d8e9ecf9a2e8285aa0bd0c07df0131f47153306b0736fd3db8924e7a9bf0bed6b1d8d4f87362a71b033dc7c64547728d953e43e59b2","location":"","comment":"Source: https://github.com/goerli/testnet/blob/master/bootnodes.txt"},{"ip":"213.186.16.82","port":30303,"id":"f4a9c6ee28586009fb5a96c8af13a58ed6d8315a9eee4772212c1d4d9cebe5a8b8a78ea4434f318726317d04a3f531a1ef0420cf9752605a562cfe858c46e263","location":"","comment":"Source: https://github.com/goerli/testnet/blob/master/bootnodes.txt"}]}');
},
/*!**********************************************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-blockchain/node_modules/ethereumjs-common/dist/hardforks/index.js ***!
  \**********************************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.hardforks = [["chainstart", a(
  /*! ./chainstart.json */
  485)], ["homestead", a(
  /*! ./homestead.json */
  486)], ["dao", a(
  /*! ./dao.json */
  487)], ["tangerineWhistle", a(
  /*! ./tangerineWhistle.json */
  488)], ["spuriousDragon", a(
  /*! ./spuriousDragon.json */
  489)], ["byzantium", a(
  /*! ./byzantium.json */
  490)], ["constantinople", a(
  /*! ./constantinople.json */
  491)], ["petersburg", a(
  /*! ./petersburg.json */
  492)], ["istanbul", a(
  /*! ./istanbul.json */
  493)]];
},
/*!*****************************************************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-blockchain/node_modules/ethereumjs-common/dist/hardforks/chainstart.json ***!
  \*****************************************************************************************************************************************/

/*! exports provided: name, comment, eip, status, gasConfig, gasPrices, vm, pow, casper, sharding, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"chainstart","comment":"Start of the Ethereum main chain","eip":{"url":"","status":""},"status":"","gasConfig":{"minGasLimit":{"v":5000,"d":"Minimum the gas limit may ever be"},"gasLimitBoundDivisor":{"v":1024,"d":"The bound divisor of the gas limit, used in update calculations"}},"gasPrices":{"base":{"v":2,"d":"Gas base cost, used e.g. for ChainID opcode (Istanbul)"},"tierStep":{"v":[0,2,3,5,8,10,20],"d":"Once per operation, for a selection of them"},"exp":{"v":10,"d":"Once per EXP instuction"},"expByte":{"v":10,"d":"Times ceil(log256(exponent)) for the EXP instruction"},"sha3":{"v":30,"d":"Once per SHA3 operation"},"sha3Word":{"v":6,"d":"Once per word of the SHA3 operation\'s data"},"sload":{"v":50,"d":"Once per SLOAD operation"},"sstoreSet":{"v":20000,"d":"Once per SSTORE operation if the zeroness changes from zero"},"sstoreReset":{"v":5000,"d":"Once per SSTORE operation if the zeroness does not change from zero"},"sstoreRefund":{"v":15000,"d":"Once per SSTORE operation if the zeroness changes to zero"},"jumpdest":{"v":1,"d":"Refunded gas, once per SSTORE operation if the zeroness changes to zero"},"log":{"v":375,"d":"Per LOG* operation"},"logData":{"v":8,"d":"Per byte in a LOG* operation\'s data"},"logTopic":{"v":375,"d":"Multiplied by the * of the LOG*, per LOG transaction. e.g. LOG0 incurs 0 * c_txLogTopicGas, LOG4 incurs 4 * c_txLogTopicGas"},"create":{"v":32000,"d":"Once per CREATE operation & contract-creation transaction"},"call":{"v":40,"d":"Once per CALL operation & message call transaction"},"callStipend":{"v":2300,"d":"Free gas given at beginning of call"},"callValueTransfer":{"v":9000,"d":"Paid for CALL when the value transfor is non-zero"},"callNewAccount":{"v":25000,"d":"Paid for CALL when the destination address didn\'t exist prior"},"selfdestructRefund":{"v":24000,"d":"Refunded following a selfdestruct operation"},"memory":{"v":3,"d":"Times the address of the (highest referenced byte in memory + 1). NOTE: referencing happens on read, write and in instructions such as RETURN and CALL"},"quadCoeffDiv":{"v":512,"d":"Divisor for the quadratic particle of the memory cost equation"},"createData":{"v":200,"d":""},"tx":{"v":21000,"d":"Per transaction. NOTE: Not payable on data of calls between transactions"},"txCreation":{"v":32000,"d":"The cost of creating a contract via tx"},"txDataZero":{"v":4,"d":"Per byte of data attached to a transaction that equals zero. NOTE: Not payable on data of calls between transactions"},"txDataNonZero":{"v":68,"d":"Per byte of data attached to a transaction that is not equal to zero. NOTE: Not payable on data of calls between transactions"},"copy":{"v":3,"d":"Multiplied by the number of 32-byte words that are copied (round up) for any *COPY operation and added"},"ecRecover":{"v":3000,"d":""},"sha256":{"v":60,"d":""},"sha256Word":{"v":12,"d":""},"ripemd160":{"v":600,"d":""},"ripemd160Word":{"v":120,"d":""},"identity":{"v":15,"d":""},"identityWord":{"v":3,"d":""}},"vm":{"stackLimit":{"v":1024,"d":"Maximum size of VM stack allowed"},"callCreateDepth":{"v":1024,"d":"Maximum depth of call/create stack"},"maxExtraDataSize":{"v":32,"d":"Maximum size extra data may be after Genesis"}},"pow":{"minimumDifficulty":{"v":131072,"d":"The minimum that the difficulty may ever be"},"difficultyBoundDivisor":{"v":2048,"d":"The bound divisor of the difficulty, used in the update calculations"},"durationLimit":{"v":13,"d":"The decision boundary on the blocktime duration used to determine whether difficulty should go up or not"},"epochDuration":{"v":30000,"d":"Duration between proof-of-work epochs"},"timebombPeriod":{"v":100000,"d":"Exponential difficulty timebomb period"},"minerReward":{"v":"5000000000000000000","d":"the amount a miner get rewarded for mining a block"}},"casper":{},"sharding":{}}');
},
/*!****************************************************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-blockchain/node_modules/ethereumjs-common/dist/hardforks/homestead.json ***!
  \****************************************************************************************************************************************/

/*! exports provided: name, comment, eip, gasConfig, gasPrices, vm, pow, casper, sharding, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"homestead","comment":"Homestead hardfork with protocol and network changes","eip":{"url":"https://eips.ethereum.org/EIPS/eip-606","status":"Final"},"gasConfig":{},"gasPrices":{},"vm":{},"pow":{},"casper":{},"sharding":{}}');
},
/*!**********************************************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-blockchain/node_modules/ethereumjs-common/dist/hardforks/dao.json ***!
  \**********************************************************************************************************************************/

/*! exports provided: name, comment, eip, gasConfig, gasPrices, vm, pow, casper, sharding, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"dao","comment":"DAO rescue hardfork","eip":{"url":"https://eips.ethereum.org/EIPS/eip-779","status":"Final"},"gasConfig":{},"gasPrices":{},"vm":{},"pow":{},"casper":{},"sharding":{}}');
},
/*!***********************************************************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-blockchain/node_modules/ethereumjs-common/dist/hardforks/tangerineWhistle.json ***!
  \***********************************************************************************************************************************************/

/*! exports provided: name, comment, eip, gasConfig, gasPrices, vm, pow, casper, sharding, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"tangerineWhistle","comment":"Hardfork with gas cost changes for IO-heavy operations","eip":{"url":"https://eips.ethereum.org/EIPS/eip-608","status":"Final"},"gasConfig":{},"gasPrices":{"sload":{"v":200,"d":"Once per SLOAD operation"},"call":{"v":700,"d":"Once per CALL operation & message call transaction"}},"vm":{},"pow":{},"casper":{},"sharding":{}}');
},
/*!*********************************************************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-blockchain/node_modules/ethereumjs-common/dist/hardforks/spuriousDragon.json ***!
  \*********************************************************************************************************************************************/

/*! exports provided: name, comment, eip, gasConfig, gasPrices, vm, pow, casper, sharding, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"spuriousDragon","comment":"HF with EIPs for simple replay attack protection, EXP cost increase, state trie clearing, contract code size limit","eip":{"url":"https://eips.ethereum.org/EIPS/eip-607","status":"Final"},"gasConfig":{},"gasPrices":{"expByte":{"v":50,"d":"Times ceil(log256(exponent)) for the EXP instruction"}},"vm":{"maxCodeSize":{"v":24576,"d":"Maximum length of contract code"}},"pow":{},"casper":{},"sharding":{}}');
},
/*!****************************************************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-blockchain/node_modules/ethereumjs-common/dist/hardforks/byzantium.json ***!
  \****************************************************************************************************************************************/

/*! exports provided: name, comment, eip, gasConfig, gasPrices, vm, pow, casper, sharding, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"byzantium","comment":"Hardfork with new precompiles, instructions and other protocol changes","eip":{"url":"https://eips.ethereum.org/EIPS/eip-609","status":"Final"},"gasConfig":{},"gasPrices":{"modexpGquaddivisor":{"v":20,"d":"Gquaddivisor from modexp precompile for gas calculation"},"ecAdd":{"v":500,"d":"Gas costs for curve addition precompile"},"ecMul":{"v":40000,"d":"Gas costs for curve multiplication precompile"},"ecPairing":{"v":100000,"d":"Base gas costs for curve pairing precompile"},"ecPairingWord":{"v":80000,"d":"Gas costs regarding curve pairing precompile input length"}},"vm":{},"pow":{"minerReward":{"v":"3000000000000000000","d":"the amount a miner get rewarded for mining a block"}},"casper":{},"sharding":{}}');
},
/*!*********************************************************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-blockchain/node_modules/ethereumjs-common/dist/hardforks/constantinople.json ***!
  \*********************************************************************************************************************************************/

/*! exports provided: name, comment, eip, gasConfig, gasPrices, vm, pow, casper, sharding, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"constantinople","comment":"Postponed hardfork including EIP-1283 (SSTORE gas metering changes)","eip":{"url":"https://eips.ethereum.org/EIPS/eip-1013","status":"Final"},"gasConfig":{},"gasPrices":{"netSstoreNoopGas":{"v":200,"d":"Once per SSTORE operation if the value doesn\'t change"},"netSstoreInitGas":{"v":20000,"d":"Once per SSTORE operation from clean zero"},"netSstoreCleanGas":{"v":5000,"d":"Once per SSTORE operation from clean non-zero"},"netSstoreDirtyGas":{"v":200,"d":"Once per SSTORE operation from dirty"},"netSstoreClearRefund":{"v":15000,"d":"Once per SSTORE operation for clearing an originally existing storage slot"},"netSstoreResetRefund":{"v":4800,"d":"Once per SSTORE operation for resetting to the original non-zero value"},"netSstoreResetClearRefund":{"v":19800,"d":"Once per SSTORE operation for resetting to the original zero value"}},"vm":{},"pow":{"minerReward":{"v":"2000000000000000000","d":"The amount a miner gets rewarded for mining a block"}},"casper":{},"sharding":{}}');
},
/*!*****************************************************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-blockchain/node_modules/ethereumjs-common/dist/hardforks/petersburg.json ***!
  \*****************************************************************************************************************************************/

/*! exports provided: name, comment, eip, gasConfig, gasPrices, vm, pow, casper, sharding, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"petersburg","comment":"Aka constantinopleFix, removes EIP-1283, activate together with or after constantinople","eip":{"url":"https://github.com/ethereum/EIPs/pull/1716","status":"Draft"},"gasConfig":{},"gasPrices":{"netSstoreNoopGas":{"v":null,"d":"Removed along EIP-1283"},"netSstoreInitGas":{"v":null,"d":"Removed along EIP-1283"},"netSstoreCleanGas":{"v":null,"d":"Removed along EIP-1283"},"netSstoreDirtyGas":{"v":null,"d":"Removed along EIP-1283"},"netSstoreClearRefund":{"v":null,"d":"Removed along EIP-1283"},"netSstoreResetRefund":{"v":null,"d":"Removed along EIP-1283"},"netSstoreResetClearRefund":{"v":null,"d":"Removed along EIP-1283"}},"vm":{},"pow":{},"casper":{},"sharding":{}}');
},
/*!***************************************************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-blockchain/node_modules/ethereumjs-common/dist/hardforks/istanbul.json ***!
  \***************************************************************************************************************************************/

/*! exports provided: name, comment, eip, gasConfig, gasPrices, vm, pow, casper, sharding, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"istanbul","comment":"HF targeted for October 2019 following the Constantinople/Petersburg HF","eip":{"url":"https://eips.ethereum.org/EIPS/eip-1679","status":"Draft"},"gasConfig":{},"gasPrices":{"blake2bRound":{"v":1,"d":"Gas cost per round for the Blake2b F precompile"},"ecAdd":{"v":150,"d":"Gas costs for curve addition precompile"},"ecMul":{"v":6000,"d":"Gas costs for curve multiplication precompile"},"ecPairing":{"v":45000,"d":"Base gas costs for curve pairing precompile"},"ecPairingWord":{"v":34000,"d":"Gas costs regarding curve pairing precompile input length"},"txDataNonZero":{"v":16,"d":"Per byte of data attached to a transaction that is not equal to zero. NOTE: Not payable on data of calls between transactions"}},"vm":{},"pow":{},"casper":{},"sharding":{}}');
},
/*!***********************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-blockchain/dist/callbackify.js ***!
  \***********************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.callbackify = function (t) {
      if ("function" != typeof t) throw new TypeError('The "original" argument must be of type Function');

      function a() {
        for (var a = [], r = 0; r < arguments.length; r++) {
          a.push(arguments[r]);
        }

        var n = a.pop();
        if ("function" != typeof n) throw new TypeError("The last argument must be of type Function");

        var s = this,
            o = function o() {
          return n.apply(s, arguments);
        };

        t.apply(this, a).then(function (t) {
          e.nextTick(o.bind(null, null, t));
        }, function (t) {
          e.nextTick(function (e, t) {
            if (!e) {
              var a = new Error("Promise was rejected with a falsy value");
              a.reason = e, e = a;
            }

            return t(e);
          }.bind(null, t, o));
        });
      }

      return Object.setPrototypeOf(a, Object.getPrototypeOf(t)), Object.defineProperties(a, Object.getOwnPropertyDescriptors(t)), a;
    };
  }).call(this, a(
  /*! ./../../../../../process/browser.js */
  9));
},
/*!*********************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-blockchain/dist/dbManager.js ***!
  \*********************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    var r = this && this.__awaiter || function (e, t, a, r) {
      return new (a || (a = Promise))(function (n, s) {
        function o(e) {
          try {
            c(r.next(e));
          } catch (e) {
            s(e);
          }
        }

        function i(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            s(e);
          }
        }

        function c(e) {
          e.done ? n(e.value) : new a(function (t) {
            t(e.value);
          }).then(o, i);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        n = this && this.__generator || function (e, t) {
      var a,
          r,
          n,
          s,
          o = {
        label: 0,
        sent: function sent() {
          if (1 & n[0]) throw n[1];
          return n[1];
        },
        trys: [],
        ops: []
      };
      return s = {
        next: i(0),
        throw: i(1),
        return: i(2)
      }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
        return this;
      }), s;

      function i(s) {
        return function (i) {
          return function (s) {
            if (a) throw new TypeError("Generator is already executing.");

            for (; o;) {
              try {
                if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

                switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                  case 0:
                  case 1:
                    n = s;
                    break;

                  case 4:
                    return o.label++, {
                      value: s[1],
                      done: !1
                    };

                  case 5:
                    o.label++, r = s[1], s = [0];
                    continue;

                  case 7:
                    s = o.ops.pop(), o.trys.pop();
                    continue;

                  default:
                    if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                      o = 0;
                      continue;
                    }

                    if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                      o.label = s[1];
                      break;
                    }

                    if (6 === s[0] && o.label < n[1]) {
                      o.label = n[1], n = s;
                      break;
                    }

                    if (n && o.label < n[2]) {
                      o.label = n[2], o.ops.push(s);
                      break;
                    }

                    n[2] && o.ops.pop(), o.trys.pop();
                    continue;
                }

                s = t.call(e, o);
              } catch (e) {
                s = [6, e], r = 0;
              } finally {
                a = n = 0;
              }
            }

            if (5 & s[0]) throw s[1];
            return {
              value: s[0] ? s[1] : void 0,
              done: !0
            };
          }([s, i]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = a(
    /*! rlp */
    21),
        o = a(
    /*! ./cache */
    496),
        i = a(
    /*! ./util */
    184),
        c = a(
    /*! bn.js */
    5),
        u = a(
    /*! level-mem */
    185),
        d = a(
    /*! ethereumjs-block */
    60),
        f = function () {
      function t(e, t) {
        this._db = e, this._common = t, this._cache = {
          td: new o.default({
            max: 1024
          }),
          header: new o.default({
            max: 512
          }),
          body: new o.default({
            max: 256
          }),
          numberToHash: new o.default({
            max: 2048
          }),
          hashToNumber: new o.default({
            max: 2048
          })
        };
      }

      return t.prototype.getHeads = function () {
        return this.get(i.headsKey, {
          valueEncoding: "json"
        });
      }, t.prototype.getHeadHeader = function () {
        return this.get(i.headHeaderKey);
      }, t.prototype.getHeadBlock = function () {
        return this.get(i.headBlockKey);
      }, t.prototype.getBlock = function (t) {
        return r(this, void 0, void 0, function () {
          var a, r, s, o;
          return n(this, function (n) {
            switch (n.label) {
              case 0:
                return "number" == typeof t && Number.isInteger(t) && (t = new c(t)), e.isBuffer(t) ? (r = t, [4, this.hashToNumber(t)]) : [3, 2];

              case 1:
                return a = n.sent(), [3, 5];

              case 2:
                return c.isBN(t) ? (a = t, [4, this.numberToHash(t)]) : [3, 4];

              case 3:
                return r = n.sent(), [3, 5];

              case 4:
                throw new Error("Unknown blockTag type");

              case 5:
                return [4, this.getHeader(r, a)];

              case 6:
                s = n.sent().raw, n.label = 7;

              case 7:
                return n.trys.push([7, 9,, 10]), [4, this.getBody(r, a)];

              case 8:
                return o = n.sent(), [3, 10];

              case 9:
                return n.sent(), o = [[], []], [3, 10];

              case 10:
                return [2, new d([s].concat(o), {
                  common: this._common
                })];
            }
          });
        });
      }, t.prototype.getBody = function (e, t) {
        return r(this, void 0, void 0, function () {
          var a, r, o;
          return n(this, function (n) {
            switch (n.label) {
              case 0:
                return a = i.bodyKey(t, e), o = (r = s).decode, [4, this.get(a, {
                  cache: "body"
                })];

              case 1:
                return [2, o.apply(r, [n.sent()])];
            }
          });
        });
      }, t.prototype.getHeader = function (e, t) {
        return r(this, void 0, void 0, function () {
          var a, r;
          return n(this, function (n) {
            switch (n.label) {
              case 0:
                return a = i.headerKey(t, e), [4, this.get(a, {
                  cache: "header"
                })];

              case 1:
                return r = n.sent(), [2, new d.Header(s.decode(r), {
                  common: this._common
                })];
            }
          });
        });
      }, t.prototype.getTd = function (e, t) {
        return r(this, void 0, void 0, function () {
          var a, r;
          return n(this, function (n) {
            switch (n.label) {
              case 0:
                return a = i.tdKey(t, e), [4, this.get(a, {
                  cache: "td"
                })];

              case 1:
                return r = n.sent(), [2, new c(s.decode(r))];
            }
          });
        });
      }, t.prototype.hashToNumber = function (e) {
        return r(this, void 0, void 0, function () {
          var t, a;
          return n(this, function (r) {
            switch (r.label) {
              case 0:
                return t = i.hashToNumberKey(e), a = c.bind, [4, this.get(t, {
                  cache: "hashToNumber"
                })];

              case 1:
                return [2, new (a.apply(c, [void 0, r.sent()]))()];
            }
          });
        });
      }, t.prototype.numberToHash = function (e) {
        return r(this, void 0, void 0, function () {
          var t;
          return n(this, function (a) {
            if (e.ltn(0)) throw new u.errors.NotFoundError();
            return t = i.numberToHashKey(e), [2, this.get(t, {
              cache: "numberToHash"
            })];
          });
        });
      }, t.prototype.get = function (e, t) {
        return void 0 === t && (t = {}), r(this, void 0, void 0, function () {
          var a, r;
          return n(this, function (n) {
            switch (n.label) {
              case 0:
                if (a = {
                  keyEncoding: t.keyEncoding || "binary",
                  valueEncoding: t.valueEncoding || "binary"
                }, !t.cache) return [3, 3];
                if (!this._cache[t.cache]) throw new Error("Invalid cache: " + t.cache);
                return (r = this._cache[t.cache].get(e)) ? [3, 2] : [4, this._db.get(e, a)];

              case 1:
                r = n.sent(), this._cache[t.cache].set(e, r), n.label = 2;

              case 2:
                return [2, r];

              case 3:
                return [2, this._db.get(e, a)];
            }
          });
        });
      }, t.prototype.batch = function (e) {
        return this._db.batch(e);
      }, t;
    }();

    t.default = f;
  }).call(this, a(
  /*! ./../../../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!*****************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-blockchain/dist/cache.js ***!
  \*****************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = a(
    /*! lru-cache */
    497),
        n = function () {
      function t(e) {
        this._cache = new r(e);
      }

      return t.prototype.set = function (t, a) {
        t instanceof e && (t = t.toString("hex")), this._cache.set(t, a);
      }, t.prototype.get = function (t) {
        return t instanceof e && (t = t.toString("hex")), this._cache.get(t);
      }, t.prototype.del = function (t) {
        t instanceof e && (t = t.toString("hex")), this._cache.del(t);
      }, t;
    }();

    t.default = n;
  }).call(this, a(
  /*! ./../../../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!*****************************************!*\
  !*** ./node_modules/lru-cache/index.js ***!
  \*****************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! yallist */
  498),
      n = Symbol("max"),
      s = Symbol("length"),
      o = Symbol("lengthCalculator"),
      i = Symbol("allowStale"),
      c = Symbol("maxAge"),
      u = Symbol("dispose"),
      d = Symbol("noDisposeOnSet"),
      f = Symbol("lruList"),
      l = Symbol("cache"),
      h = Symbol("updateAgeOnGet"),
      p = function p() {
    return 1;
  };

  var b = function b(e, t, a) {
    var r = e[l].get(t);

    if (r) {
      var _t12 = r.value;

      if (m(e, _t12)) {
        if (v(e, r), !e[i]) return;
      } else a && (e[h] && (r.value.now = Date.now()), e[f].unshiftNode(r));

      return _t12.value;
    }
  },
      m = function m(e, t) {
    if (!t || !t.maxAge && !e[c]) return !1;
    var a = Date.now() - t.now;
    return t.maxAge ? a > t.maxAge : e[c] && a > e[c];
  },
      y = function y(e) {
    if (e[s] > e[n]) for (var _t13 = e[f].tail; e[s] > e[n] && null !== _t13;) {
      var _a7 = _t13.prev;
      v(e, _t13), _t13 = _a7;
    }
  },
      v = function v(e, t) {
    if (t) {
      var _a8 = t.value;
      e[u] && e[u](_a8.key, _a8.value), e[s] -= _a8.length, e[l].delete(_a8.key), e[f].removeNode(t);
    }
  };

  var _ = function _(e, t, a, r, n) {
    _classCallCheck(this, _);

    this.key = e, this.value = t, this.length = a, this.now = r, this.maxAge = n || 0;
  };

  var g = function g(e, t, a, r) {
    var n = a.value;
    m(e, n) && (v(e, a), e[i] || (n = void 0)), n && t.call(r, n.value, n.key, e);
  };

  e.exports =
  /*#__PURE__*/
  function () {
    function _class(e) {
      _classCallCheck(this, _class);

      if ("number" == typeof e && (e = {
        max: e
      }), e || (e = {}), e.max && ("number" != typeof e.max || e.max < 0)) throw new TypeError("max must be a non-negative number");
      this[n] = e.max || 1 / 0;
      var t = e.length || p;
      if (this[o] = "function" != typeof t ? p : t, this[i] = e.stale || !1, e.maxAge && "number" != typeof e.maxAge) throw new TypeError("maxAge must be a number");
      this[c] = e.maxAge || 0, this[u] = e.dispose, this[d] = e.noDisposeOnSet || !1, this[h] = e.updateAgeOnGet || !1, this.reset();
    }

    _createClass(_class, [{
      key: "rforEach",
      value: function rforEach(e, t) {
        t = t || this;

        for (var _a9 = this[f].tail; null !== _a9;) {
          var _r67 = _a9.prev;
          g(this, e, _a9, t), _a9 = _r67;
        }
      }
    }, {
      key: "forEach",
      value: function forEach(e, t) {
        t = t || this;

        for (var _a10 = this[f].head; null !== _a10;) {
          var _r68 = _a10.next;
          g(this, e, _a10, t), _a10 = _r68;
        }
      }
    }, {
      key: "keys",
      value: function keys() {
        return this[f].toArray().map(function (e) {
          return e.key;
        });
      }
    }, {
      key: "values",
      value: function values() {
        return this[f].toArray().map(function (e) {
          return e.value;
        });
      }
    }, {
      key: "reset",
      value: function reset() {
        var _this = this;

        this[u] && this[f] && this[f].length && this[f].forEach(function (e) {
          return _this[u](e.key, e.value);
        }), this[l] = new Map(), this[f] = new r(), this[s] = 0;
      }
    }, {
      key: "dump",
      value: function dump() {
        var _this2 = this;

        return this[f].map(function (e) {
          return !m(_this2, e) && {
            k: e.key,
            v: e.value,
            e: e.now + (e.maxAge || 0)
          };
        }).toArray().filter(function (e) {
          return e;
        });
      }
    }, {
      key: "dumpLru",
      value: function dumpLru() {
        return this[f];
      }
    }, {
      key: "set",
      value: function set(e, t, a) {
        if ((a = a || this[c]) && "number" != typeof a) throw new TypeError("maxAge must be a number");
        var r = a ? Date.now() : 0,
            i = this[o](t, e);

        if (this[l].has(e)) {
          if (i > this[n]) return v(this, this[l].get(e)), !1;
          var _o3 = this[l].get(e).value;
          return this[u] && (this[d] || this[u](e, _o3.value)), _o3.now = r, _o3.maxAge = a, _o3.value = t, this[s] += i - _o3.length, _o3.length = i, this.get(e), y(this), !0;
        }

        var h = new _(e, t, i, r, a);
        return h.length > this[n] ? (this[u] && this[u](e, t), !1) : (this[s] += h.length, this[f].unshift(h), this[l].set(e, this[f].head), y(this), !0);
      }
    }, {
      key: "has",
      value: function has(e) {
        if (!this[l].has(e)) return !1;
        var t = this[l].get(e).value;
        return !m(this, t);
      }
    }, {
      key: "get",
      value: function get(e) {
        return b(this, e, !0);
      }
    }, {
      key: "peek",
      value: function peek(e) {
        return b(this, e, !1);
      }
    }, {
      key: "pop",
      value: function pop() {
        var e = this[f].tail;
        return e ? (v(this, e), e.value) : null;
      }
    }, {
      key: "del",
      value: function del(e) {
        v(this, this[l].get(e));
      }
    }, {
      key: "load",
      value: function load(e) {
        this.reset();
        var t = Date.now();

        for (var _a11 = e.length - 1; _a11 >= 0; _a11--) {
          var _r69 = e[_a11],
              _n4 = _r69.e || 0;

          if (0 === _n4) this.set(_r69.k, _r69.v);else {
            var _e11 = _n4 - t;

            _e11 > 0 && this.set(_r69.k, _r69.v, _e11);
          }
        }
      }
    }, {
      key: "prune",
      value: function prune() {
        var _this3 = this;

        this[l].forEach(function (e, t) {
          return b(_this3, t, !1);
        });
      }
    }, {
      key: "max",
      set: function set(e) {
        if ("number" != typeof e || e < 0) throw new TypeError("max must be a non-negative number");
        this[n] = e || 1 / 0, y(this);
      },
      get: function get() {
        return this[n];
      }
    }, {
      key: "allowStale",
      set: function set(e) {
        this[i] = !!e;
      },
      get: function get() {
        return this[i];
      }
    }, {
      key: "maxAge",
      set: function set(e) {
        if ("number" != typeof e) throw new TypeError("maxAge must be a non-negative number");
        this[c] = e, y(this);
      },
      get: function get() {
        return this[c];
      }
    }, {
      key: "lengthCalculator",
      set: function set(e) {
        var _this4 = this;

        "function" != typeof e && (e = p), e !== this[o] && (this[o] = e, this[s] = 0, this[f].forEach(function (e) {
          e.length = _this4[o](e.value, e.key), _this4[s] += e.length;
        })), y(this);
      },
      get: function get() {
        return this[o];
      }
    }, {
      key: "length",
      get: function get() {
        return this[s];
      }
    }, {
      key: "itemCount",
      get: function get() {
        return this[f].length;
      }
    }]);

    return _class;
  }();
},
/*!*****************************************!*\
  !*** ./node_modules/yallist/yallist.js ***!
  \*****************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  function r(e) {
    var t = this;
    if (t instanceof r || (t = new r()), t.tail = null, t.head = null, t.length = 0, e && "function" == typeof e.forEach) e.forEach(function (e) {
      t.push(e);
    });else if (arguments.length > 0) for (var a = 0, n = arguments.length; a < n; a++) {
      t.push(arguments[a]);
    }
    return t;
  }

  function n(e, t) {
    e.tail = new o(t, e.tail, null, e), e.head || (e.head = e.tail), e.length++;
  }

  function s(e, t) {
    e.head = new o(t, null, e.head, e), e.tail || (e.tail = e.head), e.length++;
  }

  function o(e, t, a, r) {
    if (!(this instanceof o)) return new o(e, t, a, r);
    this.list = r, this.value = e, t ? (t.next = this, this.prev = t) : this.prev = null, a ? (a.prev = this, this.next = a) : this.next = null;
  }

  e.exports = r, r.Node = o, r.create = r, r.prototype.removeNode = function (e) {
    if (e.list !== this) throw new Error("removing node which does not belong to this list");
    var t = e.next,
        a = e.prev;
    t && (t.prev = a), a && (a.next = t), e === this.head && (this.head = t), e === this.tail && (this.tail = a), e.list.length--, e.next = null, e.prev = null, e.list = null;
  }, r.prototype.unshiftNode = function (e) {
    if (e !== this.head) {
      e.list && e.list.removeNode(e);
      var t = this.head;
      e.list = this, e.next = t, t && (t.prev = e), this.head = e, this.tail || (this.tail = e), this.length++;
    }
  }, r.prototype.pushNode = function (e) {
    if (e !== this.tail) {
      e.list && e.list.removeNode(e);
      var t = this.tail;
      e.list = this, e.prev = t, t && (t.next = e), this.tail = e, this.head || (this.head = e), this.length++;
    }
  }, r.prototype.push = function () {
    for (var e = 0, t = arguments.length; e < t; e++) {
      n(this, arguments[e]);
    }

    return this.length;
  }, r.prototype.unshift = function () {
    for (var e = 0, t = arguments.length; e < t; e++) {
      s(this, arguments[e]);
    }

    return this.length;
  }, r.prototype.pop = function () {
    if (this.tail) {
      var e = this.tail.value;
      return this.tail = this.tail.prev, this.tail ? this.tail.next = null : this.head = null, this.length--, e;
    }
  }, r.prototype.shift = function () {
    if (this.head) {
      var e = this.head.value;
      return this.head = this.head.next, this.head ? this.head.prev = null : this.tail = null, this.length--, e;
    }
  }, r.prototype.forEach = function (e, t) {
    t = t || this;

    for (var a = this.head, r = 0; null !== a; r++) {
      e.call(t, a.value, r, this), a = a.next;
    }
  }, r.prototype.forEachReverse = function (e, t) {
    t = t || this;

    for (var a = this.tail, r = this.length - 1; null !== a; r--) {
      e.call(t, a.value, r, this), a = a.prev;
    }
  }, r.prototype.get = function (e) {
    for (var t = 0, a = this.head; null !== a && t < e; t++) {
      a = a.next;
    }

    if (t === e && null !== a) return a.value;
  }, r.prototype.getReverse = function (e) {
    for (var t = 0, a = this.tail; null !== a && t < e; t++) {
      a = a.prev;
    }

    if (t === e && null !== a) return a.value;
  }, r.prototype.map = function (e, t) {
    t = t || this;

    for (var a = new r(), n = this.head; null !== n;) {
      a.push(e.call(t, n.value, this)), n = n.next;
    }

    return a;
  }, r.prototype.mapReverse = function (e, t) {
    t = t || this;

    for (var a = new r(), n = this.tail; null !== n;) {
      a.push(e.call(t, n.value, this)), n = n.prev;
    }

    return a;
  }, r.prototype.reduce = function (e, t) {
    var a,
        r = this.head;
    if (arguments.length > 1) a = t;else {
      if (!this.head) throw new TypeError("Reduce of empty list with no initial value");
      r = this.head.next, a = this.head.value;
    }

    for (var n = 0; null !== r; n++) {
      a = e(a, r.value, n), r = r.next;
    }

    return a;
  }, r.prototype.reduceReverse = function (e, t) {
    var a,
        r = this.tail;
    if (arguments.length > 1) a = t;else {
      if (!this.tail) throw new TypeError("Reduce of empty list with no initial value");
      r = this.tail.prev, a = this.tail.value;
    }

    for (var n = this.length - 1; null !== r; n--) {
      a = e(a, r.value, n), r = r.prev;
    }

    return a;
  }, r.prototype.toArray = function () {
    for (var e = new Array(this.length), t = 0, a = this.head; null !== a; t++) {
      e[t] = a.value, a = a.next;
    }

    return e;
  }, r.prototype.toArrayReverse = function () {
    for (var e = new Array(this.length), t = 0, a = this.tail; null !== a; t++) {
      e[t] = a.value, a = a.prev;
    }

    return e;
  }, r.prototype.slice = function (e, t) {
    (t = t || this.length) < 0 && (t += this.length), (e = e || 0) < 0 && (e += this.length);
    var a = new r();
    if (t < e || t < 0) return a;
    e < 0 && (e = 0), t > this.length && (t = this.length);

    for (var n = 0, s = this.head; null !== s && n < e; n++) {
      s = s.next;
    }

    for (; null !== s && n < t; n++, s = s.next) {
      a.push(s.value);
    }

    return a;
  }, r.prototype.sliceReverse = function (e, t) {
    (t = t || this.length) < 0 && (t += this.length), (e = e || 0) < 0 && (e += this.length);
    var a = new r();
    if (t < e || t < 0) return a;
    e < 0 && (e = 0), t > this.length && (t = this.length);

    for (var n = this.length, s = this.tail; null !== s && n > t; n--) {
      s = s.prev;
    }

    for (; null !== s && n > e; n--, s = s.prev) {
      a.push(s.value);
    }

    return a;
  }, r.prototype.reverse = function () {
    for (var e = this.head, t = this.tail, a = e; null !== a; a = a.prev) {
      var r = a.prev;
      a.prev = a.next, a.next = r;
    }

    return this.head = t, this.tail = e, this;
  };

  try {
    a(
    /*! ./iterator.js */
    499)(r);
  } catch (e) {}
},
/*!******************************************!*\
  !*** ./node_modules/yallist/iterator.js ***!
  \******************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  e.exports = function (e) {
    e.prototype[Symbol.iterator] =
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var _e12;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _e12 = this.head;

            case 1:
              if (!_e12) {
                _context.next = 7;
                break;
              }

              _context.next = 4;
              return _e12.value;

            case 4:
              _e12 = _e12.next;
              _context.next = 1;
              break;

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    });
  };
},
/*!*******************************************************!*\
  !*** ./node_modules/level-packager/level-packager.js ***!
  \*******************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! levelup */
  501),
      n = a(
  /*! encoding-down */
  508);

  e.exports = function (e) {
    function t(t, a, s) {
      return "function" == typeof a && (s = a), "object" == typeof a && null !== a || (a = {}), r(n(e(t), a), a, s);
    }

    return ["destroy", "repair"].forEach(function (a) {
      "function" == typeof e[a] && (t[a] = function (t, r) {
        e[a](t, r || function () {});
      });
    }), t.errors = r.errors, t;
  };
},
/*!*********************************************!*\
  !*** ./node_modules/levelup/lib/levelup.js ***!
  \*********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    var r = a(
    /*! events */
    41).EventEmitter,
        n = a(
    /*! util */
    23).inherits,
        s = a(
    /*! xtend */
    47),
        o = a(
    /*! deferred-leveldown */
    502),
        i = a(
    /*! level-iterator-stream */
    505),
        c = a(
    /*! ./batch */
    506),
        u = a(
    /*! level-errors */
    109),
        d = a(
    /*! assert */
    19),
        f = a(
    /*! ./promisify */
    189),
        l = a(
    /*! ./common */
    81).getCallback,
        h = a(
    /*! ./common */
    81).getOptions,
        p = u.WriteError,
        b = u.ReadError,
        m = u.NotFoundError,
        y = u.OpenError,
        v = u.InitializationError;

    function _(e, a, n) {
      if (!(this instanceof _)) return new _(e, a, n);
      var s;

      if (r.call(this), this.setMaxListeners(1 / 0), "function" == typeof a && (n = a, a = {}), a = a || {}, !e || "object" != typeof e) {
        if (s = new v("First argument must be an abstract-leveldown compliant store"), "function" == typeof n) return t.nextTick(n, s);
        throw s;
      }

      d.equal(typeof e.status, "string", ".status required, old abstract-leveldown"), this.options = h(a), this._db = e, this.db = new o(e), this.open(n);
    }

    function g(e, a) {
      if (!e._isOpening() && !e.isOpen()) return t.nextTick(a, new b("Database is not open")), !0;
    }

    _.prototype.emit = r.prototype.emit, _.prototype.once = r.prototype.once, n(_, r), _.prototype.open = function (e) {
      var a,
          r = this;
      return e || (a = (e = f()).promise), this.isOpen() ? (t.nextTick(e, null, r), a) : this._isOpening() ? (this.once("open", function () {
        e(null, r);
      }), a) : (this.emit("opening"), this.db.open(this.options, function (t) {
        if (t) return e(new y(t));
        r.db = r._db, e(null, r), r.emit("open"), r.emit("ready");
      }), a);
    }, _.prototype.close = function (e) {
      var a,
          r = this;
      return e || (a = (e = f()).promise), this.isOpen() ? (this.db.close(function () {
        r.emit("closed"), e.apply(null, arguments);
      }), this.emit("closing"), this.db = new o(this._db)) : this.isClosed() ? t.nextTick(e) : "closing" === this.db.status ? this.once("closed", e) : this._isOpening() && this.once("open", function () {
        r.close(e);
      }), a;
    }, _.prototype.isOpen = function () {
      return "open" === this.db.status;
    }, _.prototype._isOpening = function () {
      return "opening" === this.db.status;
    }, _.prototype.isClosed = function () {
      return /^clos|new/.test(this.db.status);
    }, _.prototype.get = function (e, t, a) {
      if (null == e) throw new b("get() requires a key argument");
      var r;
      return (a = l(t, a)) || (r = (a = f()).promise), g(this, a) ? r : (t = h(t), this.db.get(e, t, function (t, r) {
        if (t) return t = /notfound/i.test(t) || t.notFound ? new m("Key not found in database [" + e + "]", t) : new b(t), a(t);
        a(null, r);
      }), r);
    }, _.prototype.put = function (e, t, a, r) {
      if (null == e) throw new p("put() requires a key argument");
      var n,
          s = this;
      return (r = l(a, r)) || (n = (r = f()).promise), g(this, r) ? n : (a = h(a), this.db.put(e, t, a, function (a) {
        if (a) return r(new p(a));
        s.emit("put", e, t), r();
      }), n);
    }, _.prototype.del = function (e, t, a) {
      if (null == e) throw new p("del() requires a key argument");
      var r,
          n = this;
      return (a = l(t, a)) || (r = (a = f()).promise), g(this, a) ? r : (t = h(t), this.db.del(e, t, function (t) {
        if (t) return a(new p(t));
        n.emit("del", e), a();
      }), r);
    }, _.prototype.batch = function (e, t, a) {
      if (!arguments.length) return new c(this);
      if (!Array.isArray(e)) throw new p("batch() requires an array argument");
      var r,
          n = this;
      return (a = l(t, a)) || (r = (a = f()).promise), g(this, a) ? r : (t = h(t), this.db.batch(e, t, function (t) {
        if (t) return a(new p(t));
        n.emit("batch", e), a();
      }), r);
    }, _.prototype.iterator = function (e) {
      return this.db.iterator(e);
    }, _.prototype.readStream = _.prototype.createReadStream = function (e) {
      return "number" != typeof (e = s({
        keys: !0,
        values: !0
      }, e)).limit && (e.limit = -1), new i(this.db.iterator(e), e);
    }, _.prototype.keyStream = _.prototype.createKeyStream = function (e) {
      return this.createReadStream(s(e, {
        keys: !0,
        values: !1
      }));
    }, _.prototype.valueStream = _.prototype.createValueStream = function (e) {
      return this.createReadStream(s(e, {
        keys: !1,
        values: !0
      }));
    }, _.prototype.toString = function () {
      return "LevelUP";
    }, _.errors = u, e.exports = _.default = _;
  }).call(this, a(
  /*! ./../../process/browser.js */
  9));
},
/*!***************************************************************!*\
  !*** ./node_modules/deferred-leveldown/deferred-leveldown.js ***!
  \***************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! abstract-leveldown */
  55).AbstractLevelDOWN,
      n = a(
  /*! inherits */
  3),
      s = a(
  /*! ./deferred-iterator */
  504),
      o = "put get del batch".split(" ");

  function i(e) {
    r.call(this, ""), this._db = e, this._operations = [], this._iterators = [], c(this);
  }

  function c(e) {
    o.forEach(function (t) {
      e["_" + t] = function () {
        this._operations.push({
          method: t,
          args: arguments
        });
      };
    }), "function" == typeof e._db.approximateSize && (e.approximateSize = function () {
      this._operations.push({
        method: "approximateSize",
        args: arguments
      });
    }), e._iterator = function (e) {
      var t = new s(e);
      return this._iterators.push(t), t;
    };
  }

  n(i, r), i.prototype._open = function (e, t) {
    var a = this;

    this._db.open(e, function (e) {
      if (e) return t(e);
      a._operations.forEach(function (e) {
        a._db[e.method].apply(a._db, e.args);
      }), a._operations = [], a._iterators.forEach(function (e) {
        e.setDb(a._db);
      }), a._iterators = [], function (e) {
        o.concat("iterator").forEach(function (t) {
          e["_" + t] = function () {
            return this._db[t].apply(this._db, arguments);
          };
        }), e._db.approximateSize && (e.approximateSize = function () {
          return this._db.approximateSize.apply(this._db, arguments);
        });
      }(a), t();
    });
  }, i.prototype._close = function (e) {
    var t = this;

    this._db.close(function (a) {
      if (a) return e(a);
      c(t), e();
    });
  }, i.prototype._serializeKey = function (e) {
    return e;
  }, i.prototype._serializeValue = function (e) {
    return e;
  }, e.exports = i, e.exports.DeferredIterator = s;
},
/*!***************************************************************!*\
  !*** ./node_modules/abstract-leveldown/abstract-leveldown.js ***!
  \***************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t, r) {
    var n = a(
    /*! xtend */
    47),
        s = a(
    /*! ./abstract-iterator */
    186),
        o = a(
    /*! ./abstract-chained-batch */
    187),
        i = Object.prototype.hasOwnProperty,
        c = "start end gt gte lt lte".split(" ");

    function u(e) {
      if (!arguments.length || void 0 === e) throw new Error("constructor requires at least a location argument");
      if ("string" != typeof e) throw new Error("constructor requires a location string argument");
      this.location = e, this.status = "new";
    }

    function d(e) {
      return -1 !== c.indexOf(e);
    }

    u.prototype.open = function (e, t) {
      var a = this,
          r = this.status;
      if ("function" == typeof e && (t = e), "function" != typeof t) throw new Error("open() requires a callback argument");
      "object" != typeof e && (e = {}), e.createIfMissing = !1 !== e.createIfMissing, e.errorIfExists = !!e.errorIfExists, this.status = "opening", this._open(e, function (e) {
        if (e) return a.status = r, t(e);
        a.status = "open", t();
      });
    }, u.prototype._open = function (e, a) {
      t.nextTick(a);
    }, u.prototype.close = function (e) {
      var t = this,
          a = this.status;
      if ("function" != typeof e) throw new Error("close() requires a callback argument");
      this.status = "closing", this._close(function (r) {
        if (r) return t.status = a, e(r);
        t.status = "closed", e();
      });
    }, u.prototype._close = function (e) {
      t.nextTick(e);
    }, u.prototype.get = function (e, a, r) {
      if ("function" == typeof a && (r = a), "function" != typeof r) throw new Error("get() requires a callback argument");

      var n = this._checkKey(e, "key");

      if (n) return t.nextTick(r, n);
      e = this._serializeKey(e), "object" != typeof a && (a = {}), a.asBuffer = !1 !== a.asBuffer, this._get(e, a, r);
    }, u.prototype._get = function (e, a, r) {
      t.nextTick(function () {
        r(new Error("NotFound"));
      });
    }, u.prototype.put = function (e, a, r, n) {
      if ("function" == typeof r && (n = r), "function" != typeof n) throw new Error("put() requires a callback argument");

      var s = this._checkKey(e, "key");

      if (s) return t.nextTick(n, s);
      e = this._serializeKey(e), a = this._serializeValue(a), "object" != typeof r && (r = {}), this._put(e, a, r, n);
    }, u.prototype._put = function (e, a, r, n) {
      t.nextTick(n);
    }, u.prototype.del = function (e, a, r) {
      if ("function" == typeof a && (r = a), "function" != typeof r) throw new Error("del() requires a callback argument");

      var n = this._checkKey(e, "key");

      if (n) return t.nextTick(r, n);
      e = this._serializeKey(e), "object" != typeof a && (a = {}), this._del(e, a, r);
    }, u.prototype._del = function (e, a, r) {
      t.nextTick(r);
    }, u.prototype.batch = function (e, a, r) {
      if (!arguments.length) return this._chainedBatch();
      if ("function" == typeof a && (r = a), "function" == typeof e && (r = e), "function" != typeof r) throw new Error("batch(array) requires a callback argument");
      if (!Array.isArray(e)) return t.nextTick(r, new Error("batch(array) requires an array argument"));
      a && "object" == typeof a || (a = {});

      for (var s = new Array(e.length), o = 0; o < e.length; o++) {
        if ("object" != typeof e[o] || null === e[o]) return t.nextTick(r, new Error("batch(array) element must be an object and not `null`"));
        var i = n(e[o]);
        if ("put" !== i.type && "del" !== i.type) return t.nextTick(r, new Error("`type` must be 'put' or 'del'"));

        var c = this._checkKey(i.key, "key");

        if (c) return t.nextTick(r, c);
        i.key = this._serializeKey(i.key), "put" === i.type && (i.value = this._serializeValue(i.value)), s[o] = i;
      }

      this._batch(s, a, r);
    }, u.prototype._batch = function (e, a, r) {
      t.nextTick(r);
    }, u.prototype._setupIteratorOptions = function (e) {
      return (e = function (e) {
        var t = {};

        for (var a in e) {
          i.call(e, a) && (d(a) && ("" === (n = e[a]) || null == n || function (e) {
            return r.isBuffer(e) && 0 === e.length;
          }(n)) || (t[a] = e[a]));
        }

        var n;
        return t;
      }(e)).reverse = !!e.reverse, e.keys = !1 !== e.keys, e.values = !1 !== e.values, e.limit = "limit" in e ? e.limit : -1, e.keyAsBuffer = !1 !== e.keyAsBuffer, e.valueAsBuffer = !1 !== e.valueAsBuffer, e;
    }, u.prototype.iterator = function (e) {
      return "object" != typeof e && (e = {}), e = this._setupIteratorOptions(e), this._iterator(e);
    }, u.prototype._iterator = function (e) {
      return new s(this);
    }, u.prototype._chainedBatch = function () {
      return new o(this);
    }, u.prototype._serializeKey = function (e) {
      return r.isBuffer(e) ? e : String(e);
    }, u.prototype._serializeValue = function (e) {
      return null == e ? "" : r.isBuffer(e) || t.browser ? e : String(e);
    }, u.prototype._checkKey = function (e, t) {
      return null == e ? new Error(t + " cannot be `null` or `undefined`") : r.isBuffer(e) && 0 === e.length ? new Error(t + " cannot be an empty Buffer") : "" === String(e) ? new Error(t + " cannot be an empty String") : void 0;
    }, e.exports = u;
  }).call(this, a(
  /*! ./../process/browser.js */
  9), a(
  /*! ./../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!**************************************************************!*\
  !*** ./node_modules/deferred-leveldown/deferred-iterator.js ***!
  \**************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! abstract-leveldown */
  55).AbstractIterator;

  function n(e) {
    r.call(this, e), this._options = e, this._iterator = null, this._operations = [];
  }

  a(
  /*! inherits */
  3)(n, r), n.prototype.setDb = function (e) {
    var t = this._iterator = e.iterator(this._options);

    this._operations.forEach(function (e) {
      t[e.method].apply(t, e.args);
    });
  }, n.prototype._operation = function (e, t) {
    if (this._iterator) return this._iterator[e].apply(this._iterator, t);

    this._operations.push({
      method: e,
      args: t
    });
  }, "next end".split(" ").forEach(function (e) {
    n.prototype["_" + e] = function () {
      this._operation(e, arguments);
    };
  }), e.exports = n;
},
/*!*****************************************************!*\
  !*** ./node_modules/level-iterator-stream/index.js ***!
  \*****************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    var r = a(
    /*! inherits */
    3),
        n = a(
    /*! readable-stream */
    58).Readable,
        s = a(
    /*! xtend */
    47);

    function o(e, t) {
      if (!(this instanceof o)) return new o(e, t);
      t = t || {}, n.call(this, s(t, {
        objectMode: !0
      })), this._iterator = e, this._options = t, this.on("end", this.destroy.bind(this, null, null));
    }

    e.exports = o, r(o, n), o.prototype._read = function () {
      var e = this,
          t = this._options;
      this.destroyed || this._iterator.next(function (a, r, n) {
        if (!e.destroyed) return a ? e.destroy(a) : void (void 0 === r && void 0 === n ? e.push(null) : !1 !== t.keys && !1 === t.values ? e.push(r) : !1 === t.keys && !1 !== t.values ? e.push(n) : e.push({
          key: r,
          value: n
        }));
      });
    }, o.prototype._destroy = function (e, a) {
      var r = this;

      this._iterator.end(function (n) {
        a(e || n), t.nextTick(function () {
          r.emit("close");
        });
      });
    };
  }).call(this, a(
  /*! ./../process/browser.js */
  9));
},
/*!*******************************************!*\
  !*** ./node_modules/levelup/lib/batch.js ***!
  \*******************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! level-errors */
  109).WriteError,
      n = a(
  /*! ./promisify */
  189),
      s = a(
  /*! ./common */
  81).getCallback,
      o = a(
  /*! ./common */
  81).getOptions;

  function i(e) {
    this._levelup = e, this.batch = e.db.batch(), this.ops = [], this.length = 0;
  }

  i.prototype.put = function (e, t) {
    try {
      this.batch.put(e, t);
    } catch (e) {
      throw new r(e);
    }

    return this.ops.push({
      type: "put",
      key: e,
      value: t
    }), this.length++, this;
  }, i.prototype.del = function (e) {
    try {
      this.batch.del(e);
    } catch (e) {
      throw new r(e);
    }

    return this.ops.push({
      type: "del",
      key: e
    }), this.length++, this;
  }, i.prototype.clear = function () {
    try {
      this.batch.clear();
    } catch (e) {
      throw new r(e);
    }

    return this.ops = [], this.length = 0, this;
  }, i.prototype.write = function (e, t) {
    var a,
        i = this._levelup,
        c = this.ops;
    (t = s(e, t)) || (a = (t = n()).promise), e = o(e);

    try {
      this.batch.write(e, function (e) {
        if (e) return t(new r(e));
        i.emit("batch", c), t();
      });
    } catch (e) {
      throw new r(e);
    }

    return a;
  }, e.exports = i;
},
/*!**************************************!*\
  !*** ./node_modules/errno/custom.js ***!
  \**************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! prr */
  188);

  function n(e, t, a) {
    t && "string" != typeof t && (t = t.message || t.name), r(this, {
      type: e,
      name: e,
      cause: "string" != typeof t ? t : a,
      message: t
    }, "ewr");
  }

  function s(e, t) {
    Error.call(this), Error.captureStackTrace && Error.captureStackTrace(this, this.constructor), n.call(this, "CustomError", e, t);
  }

  s.prototype = new Error(), e.exports = function (e) {
    var t = function t(_t14, a) {
      return function (e, t, a) {
        var r = function r(a, s) {
          n.call(this, t, a, s), "FilesystemError" == t && (this.code = this.cause.code, this.path = this.cause.path, this.errno = this.cause.errno, this.message = (e.errno[this.cause.errno] ? e.errno[this.cause.errno].description : this.cause.message) + (this.cause.path ? " [" + this.cause.path + "]" : "")), Error.call(this), Error.captureStackTrace && Error.captureStackTrace(this, r);
        };

        return r.prototype = a ? new a() : new s(), r;
      }(e, _t14, a);
    };

    return {
      CustomError: s,
      FilesystemError: t("FilesystemError"),
      createError: t
    };
  };
},
/*!*********************************************!*\
  !*** ./node_modules/encoding-down/index.js ***!
  \*********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! abstract-leveldown */
  55).AbstractLevelDOWN,
      n = a(
  /*! abstract-leveldown */
  55).AbstractChainedBatch,
      s = a(
  /*! abstract-leveldown */
  55).AbstractIterator,
      o = a(
  /*! inherits */
  3),
      i = a(
  /*! xtend */
  47),
      c = a(
  /*! level-codec */
  509),
      u = a(
  /*! level-errors */
  109).EncodingError;

  function d(e, t) {
    if (!(this instanceof d)) return new d(e, t);
    r.call(this, ""), void 0 === (t = t || {}).keyEncoding && (t.keyEncoding = "utf8"), void 0 === t.valueEncoding && (t.valueEncoding = "utf8"), this.db = e, this.codec = new c(t);
  }

  function f(e, t) {
    s.call(this, e), this.codec = e.codec, this.keys = t.keys, this.values = t.values, this.opts = this.codec.encodeLtgt(t), this.it = e.db.iterator(this.opts);
  }

  function l(e, t) {
    n.call(this, e), this.codec = e.codec, this.batch = e.db.batch();
  }

  e.exports = d.default = d, o(d, r), d.prototype._serializeKey = d.prototype._serializeValue = function (e) {
    return e;
  }, d.prototype._open = function (e, t) {
    this.db.open(e, t);
  }, d.prototype._close = function (e) {
    this.db.close(e);
  }, d.prototype._put = function (e, t, a, r) {
    e = this.codec.encodeKey(e, a), t = this.codec.encodeValue(t, a), this.db.put(e, t, a, r);
  }, d.prototype._get = function (e, t, a) {
    var r = this;
    e = this.codec.encodeKey(e, t), t.asBuffer = this.codec.valueAsBuffer(t), this.db.get(e, t, function (e, n) {
      if (e) return a(e);

      try {
        n = r.codec.decodeValue(n, t);
      } catch (e) {
        return a(new u(e));
      }

      a(null, n);
    });
  }, d.prototype._del = function (e, t, a) {
    e = this.codec.encodeKey(e, t), this.db.del(e, t, a);
  }, d.prototype._chainedBatch = function () {
    return new l(this);
  }, d.prototype._batch = function (e, t, a) {
    e = this.codec.encodeBatch(e, t), this.db.batch(e, t, a);
  }, d.prototype._iterator = function (e) {
    return e.keyAsBuffer = this.codec.keyAsBuffer(e), e.valueAsBuffer = this.codec.valueAsBuffer(e), new f(this, e);
  }, d.prototype._setupIteratorOptions = function (e) {
    return (e = i(e)).reverse = !!e.reverse, e.keys = !1 !== e.keys, e.values = !1 !== e.values, e.limit = "limit" in e ? e.limit : -1, e.keyAsBuffer = !1 !== e.keyAsBuffer, e.valueAsBuffer = !1 !== e.valueAsBuffer, e;
  }, d.prototype.approximateSize = function (e, t, a, r) {
    return this.db.approximateSize(e, t, a, r);
  }, o(f, s), f.prototype._next = function (e) {
    var t = this;
    this.it.next(function (a, r, n) {
      if (a) return e(a);

      try {
        r = t.keys && void 0 !== r ? t.codec.decodeKey(r, t.opts) : void 0, n = t.values && void 0 !== n ? t.codec.decodeValue(n, t.opts) : void 0;
      } catch (a) {
        return e(new u(a));
      }

      e(null, r, n);
    });
  }, f.prototype._end = function (e) {
    this.it.end(e);
  }, o(l, n), l.prototype._put = function (e, t) {
    e = this.codec.encodeKey(e), t = this.codec.encodeValue(t), this.batch.put(e, t);
  }, l.prototype._del = function (e) {
    e = this.codec.encodeKey(e), this.batch.del(e);
  }, l.prototype._clear = function () {
    this.batch.clear();
  }, l.prototype._write = function (e, t) {
    this.batch.write(e, t);
  };
},
/*!*******************************************!*\
  !*** ./node_modules/level-codec/index.js ***!
  \*******************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./lib/encodings */
  510);

  function n(e) {
    if (!(this instanceof n)) return new n(e);
    this.opts = e || {}, this.encodings = r;
  }

  e.exports = n, n.prototype._encoding = function (e) {
    return "string" == typeof e && (e = r[e]), e || (e = r.id), e;
  }, n.prototype._keyEncoding = function (e, t) {
    return this._encoding(t && t.keyEncoding || e && e.keyEncoding || this.opts.keyEncoding);
  }, n.prototype._valueEncoding = function (e, t) {
    return this._encoding(t && (t.valueEncoding || t.encoding) || e && (e.valueEncoding || e.encoding) || this.opts.valueEncoding || this.opts.encoding);
  }, n.prototype.encodeKey = function (e, t, a) {
    return this._keyEncoding(t, a).encode(e);
  }, n.prototype.encodeValue = function (e, t, a) {
    return this._valueEncoding(t, a).encode(e);
  }, n.prototype.decodeKey = function (e, t) {
    return this._keyEncoding(t).decode(e);
  }, n.prototype.decodeValue = function (e, t) {
    return this._valueEncoding(t).decode(e);
  }, n.prototype.encodeBatch = function (e, t) {
    var a = this;
    return e.map(function (e) {
      var r = {
        type: e.type,
        key: a.encodeKey(e.key, t, e)
      };
      return a.keyAsBuffer(t, e) && (r.keyEncoding = "binary"), e.prefix && (r.prefix = e.prefix), "value" in e && (r.value = a.encodeValue(e.value, t, e), a.valueAsBuffer(t, e) && (r.valueEncoding = "binary")), r;
    });
  };
  var s = ["lt", "gt", "lte", "gte", "start", "end"];
  n.prototype.encodeLtgt = function (e) {
    var t = this,
        a = {};
    return Object.keys(e).forEach(function (r) {
      a[r] = s.indexOf(r) > -1 ? t.encodeKey(e[r], e) : e[r];
    }), a;
  }, n.prototype.createStreamDecoder = function (e) {
    var t = this;
    return e.keys && e.values ? function (a, r) {
      return {
        key: t.decodeKey(a, e),
        value: t.decodeValue(r, e)
      };
    } : e.keys ? function (a) {
      return t.decodeKey(a, e);
    } : e.values ? function (a, r) {
      return t.decodeValue(r, e);
    } : function () {};
  }, n.prototype.keyAsBuffer = function (e) {
    return this._keyEncoding(e).buffer;
  }, n.prototype.valueAsBuffer = function (e) {
    return this._valueEncoding(e).buffer;
  };
},
/*!***************************************************!*\
  !*** ./node_modules/level-codec/lib/encodings.js ***!
  \***************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (e) {
    t.utf8 = t["utf-8"] = {
      encode: function encode(e) {
        return r(e) ? e : String(e);
      },
      decode: a,
      buffer: !1,
      type: "utf8"
    }, t.json = {
      encode: JSON.stringify,
      decode: JSON.parse,
      buffer: !1,
      type: "json"
    }, t.binary = {
      encode: function encode(t) {
        return r(t) ? t : e.from(t);
      },
      decode: a,
      buffer: !0,
      type: "binary"
    }, t.none = {
      encode: a,
      decode: a,
      buffer: !1,
      type: "id"
    }, t.id = t.none;

    function a(e) {
      return e;
    }

    function r(t) {
      return null == t || e.isBuffer(t);
    }

    ["hex", "ascii", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le"].forEach(function (a) {
      t[a] = {
        encode: function encode(t) {
          return r(t) ? t : e.from(t, a);
        },
        decode: function decode(e) {
          return e.toString(a);
        },
        buffer: !0,
        type: a
      };
    });
  }).call(this, a(
  /*! ./../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!****************************************************************!*\
  !*** ./node_modules/level-mem/node_modules/memdown/memdown.js ***!
  \****************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! inherits */
  3),
      n = a(
  /*! abstract-leveldown */
  55).AbstractLevelDOWN,
      s = a(
  /*! abstract-leveldown */
  55).AbstractIterator,
      o = a(
  /*! ltgt */
  190),
      i = a(
  /*! functional-red-black-tree */
  111),
      c = a(
  /*! safe-buffer */
  512).Buffer,
      u = a(
  /*! ./immediate */
  513);

  function d(e) {
    return o.compare(e, this._upperBound) > 0;
  }

  function f(e) {
    return o.compare(e, this._upperBound) >= 0;
  }

  function l(e) {
    return o.compare(e, this._upperBound) < 0;
  }

  function h(e) {
    return o.compare(e, this._upperBound) <= 0;
  }

  function p(e, t) {
    s.call(this, e), this._limit = t.limit, -1 === this._limit && (this._limit = 1 / 0);
    var a = e._store;
    this.keyAsBuffer = !1 !== t.keyAsBuffer, this.valueAsBuffer = !1 !== t.valueAsBuffer, this._reverse = t.reverse, this._options = t, this._done = 0, this._reverse ? (this._incr = "prev", this._lowerBound = o.upperBound(t), this._upperBound = o.lowerBound(t), void 0 === this._lowerBound ? this._tree = a.end : o.upperBoundInclusive(t) ? this._tree = a.le(this._lowerBound) : this._tree = a.lt(this._lowerBound), this._upperBound && (o.lowerBoundInclusive(t) ? this._test = f : this._test = d)) : (this._incr = "next", this._lowerBound = o.lowerBound(t), this._upperBound = o.upperBound(t), void 0 === this._lowerBound ? this._tree = a.begin : o.lowerBoundInclusive(t) ? this._tree = a.ge(this._lowerBound) : this._tree = a.gt(this._lowerBound), this._upperBound && (o.upperBoundInclusive(t) ? this._test = h : this._test = l));
  }

  function b() {
    if (!(this instanceof b)) return new b();
    n.call(this, ""), this._store = i(o.compare);
  }

  r(p, s), p.prototype._next = function (e) {
    var t, a;
    return this._done++ >= this._limit ? u(e) : this._tree.valid ? (t = this._tree.key, a = this._tree.value, this._test(t) ? (this.keyAsBuffer && !c.isBuffer(t) && (t = c.from(String(t))), this.valueAsBuffer && !c.isBuffer(a) && (a = c.from(String(a))), this._tree[this._incr](), void u(function () {
      e(null, t, a);
    })) : u(e)) : u(e);
  }, p.prototype._test = function () {
    return !0;
  }, r(b, n), b.prototype._open = function (e, t) {
    var a = this;
    u(function () {
      t(null, a);
    });
  }, b.prototype._serializeKey = function (e) {
    return e;
  }, b.prototype._serializeValue = function (e) {
    return null == e ? "" : e;
  }, b.prototype._put = function (e, t, a, r) {
    var n = this._store.find(e);

    n.valid ? this._store = n.update(t) : this._store = this._store.insert(e, t), u(r);
  }, b.prototype._get = function (e, t, a) {
    var r = this._store.get(e);

    if (void 0 === r) return u(function () {
      a(new Error("NotFound"));
    });
    !1 === t.asBuffer || c.isBuffer(r) || (r = c.from(String(r))), u(function () {
      a(null, r);
    });
  }, b.prototype._del = function (e, t, a) {
    this._store = this._store.remove(e), u(a);
  }, b.prototype._batch = function (e, t, a) {
    for (var r, n, s, o = -1, i = e.length, c = this._store; ++o < i;) {
      r = e[o].key, s = c.find(r), "put" === e[o].type ? (n = e[o].value, c = s.valid ? s.update(n) : c.insert(r, n)) : c = s.remove();
    }

    this._store = c, u(a);
  }, b.prototype._iterator = function (e) {
    return new p(this, e);
  }, e.exports = b.default = b;
},
/*!******************************************************************!*\
  !*** ./node_modules/level-mem/node_modules/safe-buffer/index.js ***!
  \******************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! buffer */
  1),
      n = r.Buffer;

  function s(e, t) {
    for (var a in e) {
      t[a] = e[a];
    }
  }

  function o(e, t, a) {
    return n(e, t, a);
  }

  n.from && n.alloc && n.allocUnsafe && n.allocUnsafeSlow ? e.exports = r : (s(r, t), t.Buffer = o), s(n, o), o.from = function (e, t, a) {
    if ("number" == typeof e) throw new TypeError("Argument must not be a number");
    return n(e, t, a);
  }, o.alloc = function (e, t, a) {
    if ("number" != typeof e) throw new TypeError("Argument must be a number");
    var r = n(e);
    return void 0 !== t ? "string" == typeof a ? r.fill(t, a) : r.fill(t) : r.fill(0), r;
  }, o.allocUnsafe = function (e) {
    if ("number" != typeof e) throw new TypeError("Argument must be a number");
    return n(e);
  }, o.allocUnsafeSlow = function (e) {
    if ("number" != typeof e) throw new TypeError("Argument must be a number");
    return r.SlowBuffer(e);
  };
},
/*!**************************************************************************!*\
  !*** ./node_modules/level-mem/node_modules/memdown/immediate-browser.js ***!
  \**************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  e.exports = a(
  /*! immediate */
  191);
},
/*!************************************************!*\
  !*** ./node_modules/immediate/lib/nextTick.js ***!
  \************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    t.test = function () {
      return void 0 !== e && !e.browser;
    }, t.install = function (t) {
      return function () {
        e.nextTick(t);
      };
    };
  }).call(this, a(
  /*! ./../../process/browser.js */
  9));
},
/*!************************************************!*\
  !*** ./node_modules/immediate/lib/mutation.js ***!
  \************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    var a = e.MutationObserver || e.WebKitMutationObserver;
    t.test = function () {
      return a;
    }, t.install = function (t) {
      var r = 0,
          n = new a(t),
          s = e.document.createTextNode("");
      return n.observe(s, {
        characterData: !0
      }), function () {
        s.data = r = ++r % 2;
      };
    };
  }).call(this, a(
  /*! ./../../webpack/buildin/global.js */
  18));
},
/*!******************************************************!*\
  !*** ./node_modules/immediate/lib/messageChannel.js ***!
  \******************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    t.test = function () {
      return !e.setImmediate && void 0 !== e.MessageChannel;
    }, t.install = function (t) {
      var a = new e.MessageChannel();
      return a.port1.onmessage = t, function () {
        a.port2.postMessage(0);
      };
    };
  }).call(this, a(
  /*! ./../../webpack/buildin/global.js */
  18));
},
/*!***************************************************!*\
  !*** ./node_modules/immediate/lib/stateChange.js ***!
  \***************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    t.test = function () {
      return "document" in e && "onreadystatechange" in e.document.createElement("script");
    }, t.install = function (t) {
      return function () {
        var a = e.document.createElement("script");
        return a.onreadystatechange = function () {
          t(), a.onreadystatechange = null, a.parentNode.removeChild(a), a = null;
        }, e.document.documentElement.appendChild(a), t;
      };
    };
  }).call(this, a(
  /*! ./../../webpack/buildin/global.js */
  18));
},
/*!***********************************************!*\
  !*** ./node_modules/immediate/lib/timeout.js ***!
  \***********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  t.test = function () {
    return !0;
  }, t.install = function (e) {
    return function () {
      setTimeout(e, 0);
    };
  };
},
/*!*************************************************************!*\
  !*** ./node_modules/ethereumjs-common/dist/chains/index.js ***!
  \*************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.chains = {
    names: {
      1: "mainnet",
      3: "ropsten",
      4: "rinkeby",
      42: "kovan",
      6284: "goerli"
    },
    mainnet: a(
    /*! ./mainnet.json */
    520),
    ropsten: a(
    /*! ./ropsten.json */
    521),
    rinkeby: a(
    /*! ./rinkeby.json */
    522),
    kovan: a(
    /*! ./kovan.json */
    523),
    goerli: a(
    /*! ./goerli.json */
    524)
  };
},
/*!*****************************************************************!*\
  !*** ./node_modules/ethereumjs-common/dist/chains/mainnet.json ***!
  \*****************************************************************/

/*! exports provided: name, chainId, networkId, comment, url, genesis, hardforks, bootstrapNodes, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"mainnet","chainId":1,"networkId":1,"comment":"The Ethereum main chain","url":"https://ethstats.net/","genesis":{"hash":"0xd4e56740f876aef8c010b86a40d5f56745a118d0906a34e69aec8c0db1cb8fa3","timestamp":null,"gasLimit":5000,"difficulty":17179869184,"nonce":"0x0000000000000042","extraData":"0x11bbe8db4e347b4e8c937c1c8370e4b5ed33adb3db69cbdb7a38e1e50b1b82fa","stateRoot":"0xd7f8974fb5ac78d9ac099b9ad5018bedc2ce0a72dad1827a1709da30580f0544"},"hardforks":[{"name":"chainstart","block":0,"consensus":"pow","finality":null},{"name":"homestead","block":1150000,"consensus":"pow","finality":null},{"name":"dao","block":1920000,"consensus":"pow","finality":null},{"name":"tangerineWhistle","block":2463000,"consensus":"pow","finality":null},{"name":"spuriousDragon","block":2675000,"consensus":"pow","finality":null},{"name":"byzantium","block":4370000,"consensus":"pow","finality":null},{"name":"constantinople","block":7280000,"consensus":"pow","finality":null},{"name":"petersburg","block":7280000,"consensus":"pow","finality":null},{"name":"istanbul","block":null,"consensus":"pow","finality":null}],"bootstrapNodes":[{"ip":"13.93.211.84","port":30303,"id":"3f1d12044546b76342d59d4a05532c14b85aa669704bfe1f864fe079415aa2c02d743e03218e57a33fb94523adb54032871a6c51b2cc5514cb7c7e35b3ed0a99","location":"US-WEST","comment":"Go Bootnode"},{"ip":"191.235.84.50","port":30303,"id":"78de8a0916848093c73790ead81d1928bec737d565119932b98c6b100d944b7a95e94f847f689fc723399d2e31129d182f7ef3863f2b4c820abbf3ab2722344d","location":"BR","comment":"Go Bootnode"},{"ip":"13.75.154.138","port":30303,"id":"158f8aab45f6d19c6cbf4a089c2670541a8da11978a2f90dbf6a502a4a3bab80d288afdbeb7ec0ef6d92de563767f3b1ea9e8e334ca711e9f8e2df5a0385e8e6","location":"AU","comment":"Go Bootnode"},{"ip":"52.74.57.123","port":30303,"id":"1118980bf48b0a3640bdba04e0fe78b1add18e1cd99bf22d53daac1fd9972ad650df52176e7c7d89d1114cfef2bc23a2959aa54998a46afcf7d91809f0855082","location":"SG","comment":"Go Bootnode"}]}');
},
/*!*****************************************************************!*\
  !*** ./node_modules/ethereumjs-common/dist/chains/ropsten.json ***!
  \*****************************************************************/

/*! exports provided: name, chainId, networkId, comment, url, genesis, hardforks, bootstrapNodes, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"ropsten","chainId":3,"networkId":3,"comment":"PoW test network","url":"https://github.com/ethereum/ropsten","genesis":{"hash":"0x41941023680923e0fe4d74a34bdac8141f2540e3ae90623718e47d66d1ca4a2d","timestamp":null,"gasLimit":16777216,"difficulty":1048576,"nonce":"0x0000000000000042","extraData":"0x3535353535353535353535353535353535353535353535353535353535353535","stateRoot":"0x217b0bbcfb72e2d57e28f33cb361b9983513177755dc3f33ce3e7022ed62b77b"},"hardforks":[{"name":"chainstart","block":0,"consensus":"pow","finality":null},{"name":"homestead","block":0,"consensus":"pow","finality":null},{"name":"dao","block":null,"consensus":"pow","finality":null},{"name":"tangerineWhistle","block":0,"consensus":"pow","finality":null},{"name":"spuriousDragon","block":10,"consensus":"pow","finality":null},{"name":"byzantium","block":1700000,"consensus":"pow","finality":null},{"name":"constantinople","block":4230000,"consensus":"pow","finality":null},{"name":"petersburg","block":4939394,"consensus":"pow","finality":null},{"name":"istanbul","block":null,"consensus":"pow","finality":null}],"bootstrapNodes":[{"ip":"52.176.7.10","port":"30303","id":"30b7ab30a01c124a6cceca36863ece12c4f5fa68e3ba9b0b51407ccc002eeed3b3102d20a88f1c1d3c3154e2449317b8ef95090e77b312d5cc39354f86d5d606","network":"Ropsten","chainId":3,"location":"US","comment":"US-Azure geth"},{"ip":"52.176.100.77","port":"30303","id":"865a63255b3bb68023b6bffd5095118fcc13e79dcf014fe4e47e065c350c7cc72af2e53eff895f11ba1bbb6a2b33271c1116ee870f266618eadfc2e78aa7349c","network":"Ropsten","chainId":3,"location":"US","comment":"US-Azure parity"},{"ip":"52.232.243.152","port":"30303","id":"6332792c4a00e3e4ee0926ed89e0d27ef985424d97b6a45bf0f23e51f0dcb5e66b875777506458aea7af6f9e4ffb69f43f3778ee73c81ed9d34c51c4b16b0b0f","network":"Ropsten","chainId":3,"location":"US","comment":"Parity"},{"ip":"192.81.208.223","port":"30303","id":"94c15d1b9e2fe7ce56e458b9a3b672ef11894ddedd0c6f247e0f1d3487f52b66208fb4aeb8179fce6e3a749ea93ed147c37976d67af557508d199d9594c35f09","network":"Ropsten","chainId":3,"location":"US","comment":"@gpip"}]}');
},
/*!*****************************************************************!*\
  !*** ./node_modules/ethereumjs-common/dist/chains/rinkeby.json ***!
  \*****************************************************************/

/*! exports provided: name, chainId, networkId, comment, url, genesis, hardforks, bootstrapNodes, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"rinkeby","chainId":4,"networkId":4,"comment":"PoA test network","url":"https://www.rinkeby.io","genesis":{"hash":"0x6341fd3daf94b748c72ced5a5b26028f2474f5f00d824504e4fa37a75767e177","timestamp":"0x58ee40ba","gasLimit":4700000,"difficulty":1,"nonce":"0x0000000000000000","extraData":"0x52657370656374206d7920617574686f7269746168207e452e436172746d616e42eb768f2244c8811c63729a21a3569731535f067ffc57839b00206d1ad20c69a1981b489f772031b279182d99e65703f0076e4812653aab85fca0f00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000","stateRoot":"0x53580584816f617295ea26c0e17641e0120cab2f0a8ffb53a866fd53aa8e8c2d"},"hardforks":[{"name":"chainstart","block":0,"consensus":"poa","finality":null},{"name":"homestead","block":1,"consensus":"poa","finality":null},{"name":"dao","block":null,"consensus":"poa","finality":null},{"name":"tangerineWhistle","block":2,"consensus":"poa","finality":null},{"name":"spuriousDragon","block":3,"consensus":"poa","finality":null},{"name":"byzantium","block":1035301,"consensus":"poa","finality":null},{"name":"constantinople","block":null,"consensus":"poa","finality":null},{"name":"istanbul","block":null,"consensus":"poa","finality":null}],"bootstrapNodes":[{"ip":"52.169.42.101","port":30303,"id":"a24ac7c5484ef4ed0c5eb2d36620ba4e4aa13b8c84684e1b4aab0cebea2ae45cb4d375b77eab56516d34bfbd3c1a833fc51296ff084b770b94fb9028c4d25ccf","location":"IE","comment":""},{"ip":"52.3.158.184","port":30303,"id":"343149e4feefa15d882d9fe4ac7d88f885bd05ebb735e547f12e12080a9fa07c8014ca6fd7f373123488102fe5e34111f8509cf0b7de3f5b44339c9f25e87cb8","location":"","comment":"INFURA"}]}');
},
/*!***************************************************************!*\
  !*** ./node_modules/ethereumjs-common/dist/chains/kovan.json ***!
  \***************************************************************/

/*! exports provided: name, chainId, networkId, comment, url, genesis, hardforks, bootstrapNodes, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"kovan","chainId":42,"networkId":42,"comment":"Parity PoA test network","url":"https://kovan-testnet.github.io/website/","genesis":{"hash":"0xa3c565fc15c7478862d50ccd6561e3c06b24cc509bf388941c25ea985ce32cb9","timestamp":null,"gasLimit":6000000,"difficulty":131072,"nonce":"0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000","extraData":"0x","stateRoot":"0x2480155b48a1cea17d67dbfdfaafe821c1d19cdd478c5358e8ec56dec24502b2"},"hardforks":[],"bootstrapNodes":[{"ip":"40.71.221.215","port":30303,"id":"56abaf065581a5985b8c5f4f88bd202526482761ba10be9bfdcd14846dd01f652ec33fde0f8c0fd1db19b59a4c04465681fcef50e11380ca88d25996191c52de","location":"","comment":"Parity Bootnode"},{"ip":"52.166.117.77","port":30303,"id":"d07827483dc47b368eaf88454fb04b41b7452cf454e194e2bd4c14f98a3278fed5d819dbecd0d010407fc7688d941ee1e58d4f9c6354d3da3be92f55c17d7ce3","location":"","comment":"Parity Bootnode"},{"ip":"52.165.239.18","port":30303,"id":"8fa162563a8e5a05eef3e1cd5abc5828c71344f7277bb788a395cce4a0e30baf2b34b92fe0b2dbbba2313ee40236bae2aab3c9811941b9f5a7e8e90aaa27ecba","location":"","comment":"Parity Bootnode"},{"ip":"52.243.47.56","port":30303,"id":"7e2e7f00784f516939f94e22bdc6cf96153603ca2b5df1c7cc0f90a38e7a2f218ffb1c05b156835e8b49086d11fdd1b3e2965be16baa55204167aa9bf536a4d9","location":"","comment":"Parity Bootnode"},{"ip":"40.68.248.100","port":30303,"id":"0518a3d35d4a7b3e8c433e7ffd2355d84a1304ceb5ef349787b556197f0c87fad09daed760635b97d52179d645d3e6d16a37d2cc0a9945c2ddf585684beb39ac","location":"","comment":"Parity Bootnode"}]}');
},
/*!****************************************************************!*\
  !*** ./node_modules/ethereumjs-common/dist/chains/goerli.json ***!
  \****************************************************************/

/*! exports provided: name, chainId, networkId, comment, url, genesis, hardforks, bootstrapNodes, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"goerli","chainId":5,"networkId":5,"comment":"Cross-client PoA test network","url":"https://github.com/goerli/testnet","genesis":{"hash":"0xbf7e331f7f7c1dd2e05159666b3bf8bc7a8a3a9eb1d518969eab529dd9b88c1a","timestamp":"0x5c51a607","gasLimit":10485760,"difficulty":1,"nonce":"0x0000000000000000","extraData":"0x22466c6578692069732061207468696e6722202d204166726900000000000000e0a2bd4258d2768837baa26a28fe71dc079f84c70000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000","stateRoot":"0x5d6cded585e73c4e322c30c2f782a336316f17dd85a4863b9d838d2d4b8b3008"},"hardforks":[{"name":"chainstart","block":0,"consensus":"poa","finality":null},{"name":"homestead","block":0,"consensus":"poa","finality":null},{"name":"dao","block":0,"consensus":"poa","finality":null},{"name":"tangerineWhistle","block":0,"consensus":"poa","finality":null},{"name":"spuriousDragon","block":0,"consensus":"poa","finality":null},{"name":"byzantium","block":0,"consensus":"poa","finality":null},{"name":"constantinople","block":0,"consensus":"poa","finality":null},{"name":"petersburg","block":0,"consensus":"poa","finality":null},{"name":"istanbul","block":null,"consensus":"poa","finality":null}],"bootstrapNodes":[{"ip":"51.141.78.53","port":30303,"id":"011f758e6552d105183b1761c5e2dea0111bc20fd5f6422bc7f91e0fabbec9a6595caf6239b37feb773dddd3f87240d99d859431891e4a642cf2a0a9e6cbb98a","location":"","comment":"Source: https://github.com/goerli/testnet/blob/master/bootnodes.txt"},{"ip":"13.93.54.137","port":30303,"id":"176b9417f511d05b6b2cf3e34b756cf0a7096b3094572a8f6ef4cdcb9d1f9d00683bf0f83347eebdf3b81c3521c2332086d9592802230bf528eaf606a1d9677b","location":"","comment":"Source: https://github.com/goerli/testnet/blob/master/bootnodes.txt"},{"ip":"94.237.54.114","port":30313,"id":"46add44b9f13965f7b9875ac6b85f016f341012d84f975377573800a863526f4da19ae2c620ec73d11591fa9510e992ecc03ad0751f53cc02f7c7ed6d55c7291","location":"","comment":"Source: https://github.com/goerli/testnet/blob/master/bootnodes.txt"},{"ip":"52.64.155.147","port":30303,"id":"c1f8b7c2ac4453271fa07d8e9ecf9a2e8285aa0bd0c07df0131f47153306b0736fd3db8924e7a9bf0bed6b1d8d4f87362a71b033dc7c64547728d953e43e59b2","location":"","comment":"Source: https://github.com/goerli/testnet/blob/master/bootnodes.txt"},{"ip":"213.186.16.82","port":30303,"id":"f4a9c6ee28586009fb5a96c8af13a58ed6d8315a9eee4772212c1d4d9cebe5a8b8a78ea4434f318726317d04a3f531a1ef0420cf9752605a562cfe858c46e263","location":"","comment":"Source: https://github.com/goerli/testnet/blob/master/bootnodes.txt"}]}');
},
/*!****************************************************************!*\
  !*** ./node_modules/ethereumjs-common/dist/hardforks/index.js ***!
  \****************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.hardforks = [["chainstart", a(
  /*! ./chainstart.json */
  526)], ["homestead", a(
  /*! ./homestead.json */
  527)], ["dao", a(
  /*! ./dao.json */
  528)], ["tangerineWhistle", a(
  /*! ./tangerineWhistle.json */
  529)], ["spuriousDragon", a(
  /*! ./spuriousDragon.json */
  530)], ["byzantium", a(
  /*! ./byzantium.json */
  531)], ["constantinople", a(
  /*! ./constantinople.json */
  532)], ["petersburg", a(
  /*! ./petersburg.json */
  533)], ["istanbul", a(
  /*! ./istanbul.json */
  534)]];
},
/*!***********************************************************************!*\
  !*** ./node_modules/ethereumjs-common/dist/hardforks/chainstart.json ***!
  \***********************************************************************/

/*! exports provided: name, comment, eip, status, gasConfig, gasPrices, vm, pow, casper, sharding, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"chainstart","comment":"Start of the Ethereum main chain","eip":{"url":"","status":""},"status":"","gasConfig":{"minGasLimit":{"v":5000,"d":"Minimum the gas limit may ever be"},"gasLimitBoundDivisor":{"v":1024,"d":"The bound divisor of the gas limit, used in update calculations"}},"gasPrices":{"base":{"v":2,"d":"Gas base cost, used e.g. for ChainID opcode (Istanbul)"},"tierStep":{"v":[0,2,3,5,8,10,20],"d":"Once per operation, for a selection of them"},"exp":{"v":10,"d":"Once per EXP instuction"},"expByte":{"v":10,"d":"Times ceil(log256(exponent)) for the EXP instruction"},"sha3":{"v":30,"d":"Once per SHA3 operation"},"sha3Word":{"v":6,"d":"Once per word of the SHA3 operation\'s data"},"sload":{"v":50,"d":"Once per SLOAD operation"},"sstoreSet":{"v":20000,"d":"Once per SSTORE operation if the zeroness changes from zero"},"sstoreReset":{"v":5000,"d":"Once per SSTORE operation if the zeroness does not change from zero"},"sstoreRefund":{"v":15000,"d":"Once per SSTORE operation if the zeroness changes to zero"},"jumpdest":{"v":1,"d":"Refunded gas, once per SSTORE operation if the zeroness changes to zero"},"log":{"v":375,"d":"Per LOG* operation"},"logData":{"v":8,"d":"Per byte in a LOG* operation\'s data"},"logTopic":{"v":375,"d":"Multiplied by the * of the LOG*, per LOG transaction. e.g. LOG0 incurs 0 * c_txLogTopicGas, LOG4 incurs 4 * c_txLogTopicGas"},"create":{"v":32000,"d":"Once per CREATE operation & contract-creation transaction"},"call":{"v":40,"d":"Once per CALL operation & message call transaction"},"callStipend":{"v":2300,"d":"Free gas given at beginning of call"},"callValueTransfer":{"v":9000,"d":"Paid for CALL when the value transfor is non-zero"},"callNewAccount":{"v":25000,"d":"Paid for CALL when the destination address didn\'t exist prior"},"selfdestructRefund":{"v":24000,"d":"Refunded following a selfdestruct operation"},"memory":{"v":3,"d":"Times the address of the (highest referenced byte in memory + 1). NOTE: referencing happens on read, write and in instructions such as RETURN and CALL"},"quadCoeffDiv":{"v":512,"d":"Divisor for the quadratic particle of the memory cost equation"},"createData":{"v":200,"d":""},"tx":{"v":21000,"d":"Per transaction. NOTE: Not payable on data of calls between transactions"},"txCreation":{"v":32000,"d":"The cost of creating a contract via tx"},"txDataZero":{"v":4,"d":"Per byte of data attached to a transaction that equals zero. NOTE: Not payable on data of calls between transactions"},"txDataNonZero":{"v":68,"d":"Per byte of data attached to a transaction that is not equal to zero. NOTE: Not payable on data of calls between transactions"},"copy":{"v":3,"d":"Multiplied by the number of 32-byte words that are copied (round up) for any *COPY operation and added"},"ecRecover":{"v":3000,"d":""},"sha256":{"v":60,"d":""},"sha256Word":{"v":12,"d":""},"ripemd160":{"v":600,"d":""},"ripemd160Word":{"v":120,"d":""},"identity":{"v":15,"d":""},"identityWord":{"v":3,"d":""}},"vm":{"stackLimit":{"v":1024,"d":"Maximum size of VM stack allowed"},"callCreateDepth":{"v":1024,"d":"Maximum depth of call/create stack"},"maxExtraDataSize":{"v":32,"d":"Maximum size extra data may be after Genesis"}},"pow":{"minimumDifficulty":{"v":131072,"d":"The minimum that the difficulty may ever be"},"difficultyBoundDivisor":{"v":2048,"d":"The bound divisor of the difficulty, used in the update calculations"},"durationLimit":{"v":13,"d":"The decision boundary on the blocktime duration used to determine whether difficulty should go up or not"},"epochDuration":{"v":30000,"d":"Duration between proof-of-work epochs"},"timebombPeriod":{"v":100000,"d":"Exponential difficulty timebomb period"},"minerReward":{"v":"5000000000000000000","d":"the amount a miner get rewarded for mining a block"}},"casper":{},"sharding":{}}');
},
/*!**********************************************************************!*\
  !*** ./node_modules/ethereumjs-common/dist/hardforks/homestead.json ***!
  \**********************************************************************/

/*! exports provided: name, comment, eip, gasConfig, gasPrices, vm, pow, casper, sharding, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"homestead","comment":"Homestead hardfork with protocol and network changes","eip":{"url":"https://eips.ethereum.org/EIPS/eip-606","status":"Final"},"gasConfig":{},"gasPrices":{},"vm":{},"pow":{},"casper":{},"sharding":{}}');
},
/*!****************************************************************!*\
  !*** ./node_modules/ethereumjs-common/dist/hardforks/dao.json ***!
  \****************************************************************/

/*! exports provided: name, comment, eip, gasConfig, gasPrices, vm, pow, casper, sharding, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"dao","comment":"DAO rescue hardfork","eip":{"url":"https://eips.ethereum.org/EIPS/eip-779","status":"Final"},"gasConfig":{},"gasPrices":{},"vm":{},"pow":{},"casper":{},"sharding":{}}');
},
/*!*****************************************************************************!*\
  !*** ./node_modules/ethereumjs-common/dist/hardforks/tangerineWhistle.json ***!
  \*****************************************************************************/

/*! exports provided: name, comment, eip, gasConfig, gasPrices, vm, pow, casper, sharding, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"tangerineWhistle","comment":"Hardfork with gas cost changes for IO-heavy operations","eip":{"url":"https://eips.ethereum.org/EIPS/eip-608","status":"Final"},"gasConfig":{},"gasPrices":{"sload":{"v":200,"d":"Once per SLOAD operation"},"call":{"v":700,"d":"Once per CALL operation & message call transaction"}},"vm":{},"pow":{},"casper":{},"sharding":{}}');
},
/*!***************************************************************************!*\
  !*** ./node_modules/ethereumjs-common/dist/hardforks/spuriousDragon.json ***!
  \***************************************************************************/

/*! exports provided: name, comment, eip, gasConfig, gasPrices, vm, pow, casper, sharding, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"spuriousDragon","comment":"HF with EIPs for simple replay attack protection, EXP cost increase, state trie clearing, contract code size limit","eip":{"url":"https://eips.ethereum.org/EIPS/eip-607","status":"Final"},"gasConfig":{},"gasPrices":{"expByte":{"v":50,"d":"Times ceil(log256(exponent)) for the EXP instruction"}},"vm":{"maxCodeSize":{"v":24576,"d":"Maximum length of contract code"}},"pow":{},"casper":{},"sharding":{}}');
},
/*!**********************************************************************!*\
  !*** ./node_modules/ethereumjs-common/dist/hardforks/byzantium.json ***!
  \**********************************************************************/

/*! exports provided: name, comment, eip, gasConfig, gasPrices, vm, pow, casper, sharding, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"byzantium","comment":"Hardfork with new precompiles, instructions and other protocol changes","eip":{"url":"https://eips.ethereum.org/EIPS/eip-609","status":"Final"},"gasConfig":{},"gasPrices":{"modexpGquaddivisor":{"v":20,"d":"Gquaddivisor from modexp precompile for gas calculation"},"ecAdd":{"v":500,"d":"Gas costs for curve addition precompile"},"ecMul":{"v":40000,"d":"Gas costs for curve multiplication precompile"},"ecPairing":{"v":100000,"d":"Base gas costs for curve pairing precompile"},"ecPairingWord":{"v":80000,"d":"Gas costs regarding curve pairing precompile input length"}},"vm":{},"pow":{"minerReward":{"v":"3000000000000000000","d":"the amount a miner get rewarded for mining a block"}},"casper":{},"sharding":{}}');
},
/*!***************************************************************************!*\
  !*** ./node_modules/ethereumjs-common/dist/hardforks/constantinople.json ***!
  \***************************************************************************/

/*! exports provided: name, comment, eip, gasConfig, gasPrices, vm, pow, casper, sharding, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"constantinople","comment":"Postponed hardfork including EIP-1283 (SSTORE gas metering changes)","eip":{"url":"https://eips.ethereum.org/EIPS/eip-1013","status":"Final"},"gasConfig":{},"gasPrices":{"netSstoreNoopGas":{"v":200,"d":"Once per SSTORE operation if the value doesn\'t change"},"netSstoreInitGas":{"v":20000,"d":"Once per SSTORE operation from clean zero"},"netSstoreCleanGas":{"v":5000,"d":"Once per SSTORE operation from clean non-zero"},"netSstoreDirtyGas":{"v":200,"d":"Once per SSTORE operation from dirty"},"netSstoreClearRefund":{"v":15000,"d":"Once per SSTORE operation for clearing an originally existing storage slot"},"netSstoreResetRefund":{"v":4800,"d":"Once per SSTORE operation for resetting to the original non-zero value"},"netSstoreResetClearRefund":{"v":19800,"d":"Once per SSTORE operation for resetting to the original zero value"}},"vm":{},"pow":{"minerReward":{"v":"2000000000000000000","d":"The amount a miner gets rewarded for mining a block"}},"casper":{},"sharding":{}}');
},
/*!***********************************************************************!*\
  !*** ./node_modules/ethereumjs-common/dist/hardforks/petersburg.json ***!
  \***********************************************************************/

/*! exports provided: name, comment, eip, gasConfig, gasPrices, vm, pow, casper, sharding, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"petersburg","comment":"Aka constantinopleFix, removes EIP-1283, activate together with or after constantinople","eip":{"url":"https://github.com/ethereum/EIPs/pull/1716","status":"Draft"},"gasConfig":{},"gasPrices":{"netSstoreNoopGas":{"v":null,"d":"Removed along EIP-1283"},"netSstoreInitGas":{"v":null,"d":"Removed along EIP-1283"},"netSstoreCleanGas":{"v":null,"d":"Removed along EIP-1283"},"netSstoreDirtyGas":{"v":null,"d":"Removed along EIP-1283"},"netSstoreClearRefund":{"v":null,"d":"Removed along EIP-1283"},"netSstoreResetRefund":{"v":null,"d":"Removed along EIP-1283"},"netSstoreResetClearRefund":{"v":null,"d":"Removed along EIP-1283"}},"vm":{},"pow":{},"casper":{},"sharding":{}}');
},
/*!*********************************************************************!*\
  !*** ./node_modules/ethereumjs-common/dist/hardforks/istanbul.json ***!
  \*********************************************************************/

/*! exports provided: name, comment, eip, gasConfig, gasPrices, vm, pow, casper, sharding, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"istanbul","comment":"HF targeted for October 2019 following the Constantinople/Petersburg HF","eip":{"url":"https://eips.ethereum.org/EIPS/eip-1679","status":"Draft"},"gasConfig":{},"gasPrices":{"blake2bRound":{"v":1,"d":"Gas cost per round for the Blake2b F precompile"},"ecAdd":{"v":150,"d":"Gas costs for curve addition precompile"},"ecMul":{"v":6000,"d":"Gas costs for curve multiplication precompile"},"ecPairing":{"v":45000,"d":"Base gas costs for curve pairing precompile"},"ecPairingWord":{"v":34000,"d":"Gas costs regarding curve pairing precompile input length"},"txDataNonZero":{"v":16,"d":"Per byte of data attached to a transaction that is not equal to zero. NOTE: Not payable on data of calls between transactions"}},"vm":{},"pow":{},"casper":{},"sharding":{}}');
},
/*!*************************************************!*\
  !*** ./node_modules/ethereumjs-tx/es5/index.js ***!
  \*************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (t) {
    var r = a(
    /*! ethereumjs-util */
    536),
        n = a(
    /*! ethereum-common/params.json */
    537),
        s = r.BN,
        o = new s("7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a0", 16),
        i = function () {
      function e(a) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), a = a || {};
        var n = [{
          name: "nonce",
          length: 32,
          allowLess: !0,
          default: new t([])
        }, {
          name: "gasPrice",
          length: 32,
          allowLess: !0,
          default: new t([])
        }, {
          name: "gasLimit",
          alias: "gas",
          length: 32,
          allowLess: !0,
          default: new t([])
        }, {
          name: "to",
          allowZero: !0,
          length: 20,
          default: new t([])
        }, {
          name: "value",
          length: 32,
          allowLess: !0,
          default: new t([])
        }, {
          name: "data",
          alias: "input",
          allowZero: !0,
          default: new t([])
        }, {
          name: "v",
          allowZero: !0,
          default: new t([28])
        }, {
          name: "r",
          length: 32,
          allowZero: !0,
          allowLess: !0,
          default: new t([])
        }, {
          name: "s",
          length: 32,
          allowZero: !0,
          allowLess: !0,
          default: new t([])
        }];
        r.defineProperties(this, n, a), Object.defineProperty(this, "from", {
          enumerable: !0,
          configurable: !0,
          get: this.getSenderAddress.bind(this)
        });
        var s = r.bufferToInt(this.v),
            o = Math.floor((s - 35) / 2);
        o < 0 && (o = 0), this._chainId = o || a.chainId || 0, this._homestead = !0;
      }

      return e.prototype.toCreationAddress = function () {
        return "" === this.to.toString("hex");
      }, e.prototype.hash = function (e) {
        void 0 === e && (e = !0);
        var t = void 0;
        if (e) t = this.raw;else if (this._chainId > 0) {
          var a = this.raw.slice();
          this.v = this._chainId, this.r = 0, this.s = 0, t = this.raw, this.raw = a;
        } else t = this.raw.slice(0, 6);
        return r.rlphash(t);
      }, e.prototype.getChainId = function () {
        return this._chainId;
      }, e.prototype.getSenderAddress = function () {
        if (this._from) return this._from;
        var e = this.getSenderPublicKey();
        return this._from = r.publicToAddress(e), this._from;
      }, e.prototype.getSenderPublicKey = function () {
        if (!(this._senderPubKey && this._senderPubKey.length || this.verifySignature())) throw new Error("Invalid Signature");
        return this._senderPubKey;
      }, e.prototype.verifySignature = function () {
        var e = this.hash(!1);
        if (this._homestead && 1 === new s(this.s).cmp(o)) return !1;

        try {
          var t = r.bufferToInt(this.v);
          this._chainId > 0 && (t -= 2 * this._chainId + 8), this._senderPubKey = r.ecrecover(e, t, this.r, this.s);
        } catch (e) {
          return !1;
        }

        return !!this._senderPubKey;
      }, e.prototype.sign = function (e) {
        var t = this.hash(!1),
            a = r.ecsign(t, e);
        this._chainId > 0 && (a.v += 2 * this._chainId + 8), Object.assign(this, a);
      }, e.prototype.getDataFee = function () {
        for (var e = this.raw[5], t = new s(0), a = 0; a < e.length; a++) {
          0 === e[a] ? t.iaddn(n.txDataZeroGas.v) : t.iaddn(n.txDataNonZeroGas.v);
        }

        return t;
      }, e.prototype.getBaseFee = function () {
        var e = this.getDataFee().iaddn(n.txGas.v);
        return this._homestead && this.toCreationAddress() && e.iaddn(n.txCreation.v), e;
      }, e.prototype.getUpfrontCost = function () {
        return new s(this.gasLimit).imul(new s(this.gasPrice)).iadd(new s(this.value));
      }, e.prototype.validate = function (e) {
        var t = [];
        return this.verifySignature() || t.push("Invalid Signature"), this.getBaseFee().cmp(new s(this.gasLimit)) > 0 && t.push(["gas limit is too low. Need at least " + this.getBaseFee()]), void 0 === e || !1 === e ? 0 === t.length : t.join(" ");
      }, e;
    }();

    e.exports = i;
  }).call(this, a(
  /*! ./../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!*******************************************************************************!*\
  !*** ./node_modules/ethereumjs-tx/node_modules/ethereumjs-util/dist/index.js ***!
  \*******************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
      n = a(
  /*! keccak */
  33),
      s = a(
  /*! secp256k1 */
  30),
      o = a(
  /*! assert */
  19),
      i = a(
  /*! rlp */
  21),
      c = a(
  /*! bn.js */
  5),
      u = a(
  /*! create-hash */
  20),
      d = a(
  /*! safe-buffer */
  7).Buffer;
  Object.assign(t, a(
  /*! ethjs-util */
  36)), t.MAX_INTEGER = new c("ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff", 16), t.TWO_POW256 = new c("10000000000000000000000000000000000000000000000000000000000000000", 16), t.KECCAK256_NULL_S = "c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470", t.SHA3_NULL_S = t.KECCAK256_NULL_S, t.KECCAK256_NULL = d.from(t.KECCAK256_NULL_S, "hex"), t.SHA3_NULL = t.KECCAK256_NULL, t.KECCAK256_RLP_ARRAY_S = "1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347", t.SHA3_RLP_ARRAY_S = t.KECCAK256_RLP_ARRAY_S, t.KECCAK256_RLP_ARRAY = d.from(t.KECCAK256_RLP_ARRAY_S, "hex"), t.SHA3_RLP_ARRAY = t.KECCAK256_RLP_ARRAY, t.KECCAK256_RLP_S = "56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421", t.SHA3_RLP_S = t.KECCAK256_RLP_S, t.KECCAK256_RLP = d.from(t.KECCAK256_RLP_S, "hex"), t.SHA3_RLP = t.KECCAK256_RLP, t.BN = c, t.rlp = i, t.secp256k1 = s, t.zeros = function (e) {
    return d.allocUnsafe(e).fill(0);
  }, t.zeroAddress = function () {
    var e = t.zeros(20);
    return t.bufferToHex(e);
  }, t.setLengthLeft = t.setLength = function (e, a, r) {
    var n = t.zeros(a);
    return e = t.toBuffer(e), r ? e.length < a ? (e.copy(n), n) : e.slice(0, a) : e.length < a ? (e.copy(n, a - e.length), n) : e.slice(-a);
  }, t.setLengthRight = function (e, a) {
    return t.setLength(e, a, !0);
  }, t.unpad = t.stripZeros = function (e) {
    for (var a = (e = t.stripHexPrefix(e))[0]; e.length > 0 && "0" === a.toString();) {
      a = (e = e.slice(1))[0];
    }

    return e;
  }, t.toBuffer = function (e) {
    if (!d.isBuffer(e)) if (Array.isArray(e)) e = d.from(e);else if ("string" == typeof e) e = t.isHexString(e) ? d.from(t.padToEven(t.stripHexPrefix(e)), "hex") : d.from(e);else if ("number" == typeof e) e = t.intToBuffer(e);else if (null == e) e = d.allocUnsafe(0);else if (c.isBN(e)) e = e.toArrayLike(d);else {
      if (!e.toArray) throw new Error("invalid type");
      e = d.from(e.toArray());
    }
    return e;
  }, t.bufferToInt = function (e) {
    return new c(t.toBuffer(e)).toNumber();
  }, t.bufferToHex = function (e) {
    return "0x" + (e = t.toBuffer(e)).toString("hex");
  }, t.fromSigned = function (e) {
    return new c(e).fromTwos(256);
  }, t.toUnsigned = function (e) {
    return d.from(e.toTwos(256).toArray());
  }, t.keccak = function (e, a) {
    return e = t.toBuffer(e), a || (a = 256), n("keccak" + a).update(e).digest();
  }, t.keccak256 = function (e) {
    return t.keccak(e);
  }, t.sha3 = t.keccak, t.sha256 = function (e) {
    return e = t.toBuffer(e), u("sha256").update(e).digest();
  }, t.ripemd160 = function (e, a) {
    e = t.toBuffer(e);
    var r = u("rmd160").update(e).digest();
    return !0 === a ? t.setLength(r, 32) : r;
  }, t.rlphash = function (e) {
    return t.keccak(i.encode(e));
  }, t.isValidPrivate = function (e) {
    return s.privateKeyVerify(e);
  }, t.isValidPublic = function (e, t) {
    return 64 === e.length ? s.publicKeyVerify(d.concat([d.from([4]), e])) : !!t && s.publicKeyVerify(e);
  }, t.pubToAddress = t.publicToAddress = function (e, a) {
    return e = t.toBuffer(e), a && 64 !== e.length && (e = s.publicKeyConvert(e, !1).slice(1)), o(64 === e.length), t.keccak(e).slice(-20);
  };

  var f = t.privateToPublic = function (e) {
    return e = t.toBuffer(e), s.publicKeyCreate(e, !1).slice(1);
  };

  t.importPublic = function (e) {
    return 64 !== (e = t.toBuffer(e)).length && (e = s.publicKeyConvert(e, !1).slice(1)), e;
  }, t.ecsign = function (e, t) {
    var a = s.sign(e, t),
        r = {};
    return r.r = a.signature.slice(0, 32), r.s = a.signature.slice(32, 64), r.v = a.recovery + 27, r;
  }, t.hashPersonalMessage = function (e) {
    var a = t.toBuffer("Ethereum Signed Message:\n" + e.length.toString());
    return t.keccak(d.concat([a, e]));
  }, t.ecrecover = function (e, a, r, n) {
    var o = d.concat([t.setLength(r, 32), t.setLength(n, 32)], 64),
        i = a - 27;
    if (0 !== i && 1 !== i) throw new Error("Invalid signature v value");
    var c = s.recover(e, o, i);
    return s.publicKeyConvert(c, !1).slice(1);
  }, t.toRpcSig = function (e, a, r) {
    if (27 !== e && 28 !== e) throw new Error("Invalid recovery id");
    return t.bufferToHex(d.concat([t.setLengthLeft(a, 32), t.setLengthLeft(r, 32), t.toBuffer(e - 27)]));
  }, t.fromRpcSig = function (e) {
    if (65 !== (e = t.toBuffer(e)).length) throw new Error("Invalid signature length");
    var a = e[64];
    return a < 27 && (a += 27), {
      v: a,
      r: e.slice(0, 32),
      s: e.slice(32, 64)
    };
  }, t.privateToAddress = function (e) {
    return t.publicToAddress(f(e));
  }, t.isValidAddress = function (e) {
    return /^0x[0-9a-fA-F]{40}$/.test(e);
  }, t.isZeroAddress = function (e) {
    return t.zeroAddress() === t.addHexPrefix(e);
  }, t.toChecksumAddress = function (e) {
    e = t.stripHexPrefix(e).toLowerCase();

    for (var a = t.keccak(e).toString("hex"), r = "0x", n = 0; n < e.length; n++) {
      parseInt(a[n], 16) >= 8 ? r += e[n].toUpperCase() : r += e[n];
    }

    return r;
  }, t.isValidChecksumAddress = function (e) {
    return t.isValidAddress(e) && t.toChecksumAddress(e) === e;
  }, t.generateAddress = function (e, a) {
    return e = t.toBuffer(e), a = (a = new c(a)).isZero() ? null : d.from(a.toArray()), t.rlphash([e, a]).slice(-20);
  }, t.isPrecompiled = function (e) {
    var a = t.unpad(e);
    return 1 === a.length && a[0] >= 1 && a[0] <= 8;
  }, t.addHexPrefix = function (e) {
    return "string" != typeof e ? e : t.isHexPrefixed(e) ? e : "0x" + e;
  }, t.isValidSignature = function (e, t, a, r) {
    var n = new c("7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a0", 16),
        s = new c("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", 16);
    return 32 === t.length && 32 === a.length && (27 === e || 28 === e) && (t = new c(t), a = new c(a), !(t.isZero() || t.gt(s) || a.isZero() || a.gt(s)) && (!1 !== r || 1 !== new c(a).cmp(n)));
  }, t.baToJSON = function (e) {
    if (d.isBuffer(e)) return "0x" + e.toString("hex");

    if (e instanceof Array) {
      for (var a = [], r = 0; r < e.length; r++) {
        a.push(t.baToJSON(e[r]));
      }

      return a;
    }
  }, t.defineProperties = function (e, a, n) {
    if (e.raw = [], e._fields = [], e.toJSON = function (a) {
      if (a) {
        var r = {};
        return e._fields.forEach(function (t) {
          r[t] = "0x" + e[t].toString("hex");
        }), r;
      }

      return t.baToJSON(this.raw);
    }, e.serialize = function () {
      return i.encode(e.raw);
    }, a.forEach(function (a, r) {
      function n() {
        return e.raw[r];
      }

      function s(n) {
        "00" !== (n = t.toBuffer(n)).toString("hex") || a.allowZero || (n = d.allocUnsafe(0)), a.allowLess && a.length ? (n = t.stripZeros(n), o(a.length >= n.length, "The field " + a.name + " must not have more " + a.length + " bytes")) : a.allowZero && 0 === n.length || !a.length || o(a.length === n.length, "The field " + a.name + " must have byte length of " + a.length), e.raw[r] = n;
      }

      e._fields.push(a.name), Object.defineProperty(e, a.name, {
        enumerable: !0,
        configurable: !0,
        get: n,
        set: s
      }), a.default && (e[a.name] = a.default), a.alias && Object.defineProperty(e, a.alias, {
        enumerable: !1,
        configurable: !0,
        set: s,
        get: n
      });
    }), n) if ("string" == typeof n && (n = d.from(t.stripHexPrefix(n), "hex")), d.isBuffer(n) && (n = i.decode(n)), Array.isArray(n)) {
      if (n.length > e._fields.length) throw new Error("wrong number of fields in data");
      n.forEach(function (a, r) {
        e[e._fields[r]] = t.toBuffer(a);
      });
    } else {
      if ("object" !== (void 0 === n ? "undefined" : r(n))) throw new Error("invalid data");
      var s = Object.keys(n);
      a.forEach(function (t) {
        -1 !== s.indexOf(t.name) && (e[t.name] = n[t.name]), -1 !== s.indexOf(t.alias) && (e[t.alias] = n[t.alias]);
      });
    }
  };
},
/*!**************************************************!*\
  !*** ./node_modules/ethereum-common/params.json ***!
  \**************************************************/

/*! exports provided: genesisGasLimit, genesisDifficulty, genesisNonce, genesisExtraData, genesisHash, genesisStateRoot, minGasLimit, gasLimitBoundDivisor, minimumDifficulty, difficultyBoundDivisor, durationLimit, maximumExtraDataSize, epochDuration, stackLimit, callCreateDepth, tierStepGas, expGas, expByteGas, sha3Gas, sha3WordGas, sloadGas, sstoreSetGas, sstoreResetGas, sstoreRefundGas, jumpdestGas, logGas, logDataGas, logTopicGas, createGas, callGas, callStipend, callValueTransferGas, callNewAccountGas, suicideRefundGas, memoryGas, quadCoeffDiv, createDataGas, txGas, txCreation, txDataZeroGas, txDataNonZeroGas, copyGas, ecrecoverGas, sha256Gas, sha256WordGas, ripemd160Gas, ripemd160WordGas, identityGas, identityWordGas, minerReward, ommerReward, niblingReward, homeSteadForkNumber, homesteadRepriceForkNumber, timebombPeriod, freeBlockPeriod, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"genesisGasLimit":{"v":5000,"d":"Gas limit of the Genesis block."},"genesisDifficulty":{"v":17179869184,"d":"Difficulty of the Genesis block."},"genesisNonce":{"v":"0x0000000000000042","d":"the geneis nonce"},"genesisExtraData":{"v":"0x11bbe8db4e347b4e8c937c1c8370e4b5ed33adb3db69cbdb7a38e1e50b1b82fa","d":"extra data "},"genesisHash":{"v":"0xd4e56740f876aef8c010b86a40d5f56745a118d0906a34e69aec8c0db1cb8fa3","d":"genesis hash"},"genesisStateRoot":{"v":"0xd7f8974fb5ac78d9ac099b9ad5018bedc2ce0a72dad1827a1709da30580f0544","d":"the genesis state root"},"minGasLimit":{"v":5000,"d":"Minimum the gas limit may ever be."},"gasLimitBoundDivisor":{"v":1024,"d":"The bound divisor of the gas limit, used in update calculations."},"minimumDifficulty":{"v":131072,"d":"The minimum that the difficulty may ever be."},"difficultyBoundDivisor":{"v":2048,"d":"The bound divisor of the difficulty, used in the update calculations."},"durationLimit":{"v":13,"d":"The decision boundary on the blocktime duration used to determine whether difficulty should go up or not."},"maximumExtraDataSize":{"v":32,"d":"Maximum size extra data may be after Genesis."},"epochDuration":{"v":30000,"d":"Duration between proof-of-work epochs."},"stackLimit":{"v":1024,"d":"Maximum size of VM stack allowed."},"callCreateDepth":{"v":1024,"d":"Maximum depth of call/create stack."},"tierStepGas":{"v":[0,2,3,5,8,10,20],"d":"Once per operation, for a selection of them."},"expGas":{"v":10,"d":"Once per EXP instuction."},"expByteGas":{"v":10,"d":"Times ceil(log256(exponent)) for the EXP instruction."},"sha3Gas":{"v":30,"d":"Once per SHA3 operation."},"sha3WordGas":{"v":6,"d":"Once per word of the SHA3 operation\'s data."},"sloadGas":{"v":50,"d":"Once per SLOAD operation."},"sstoreSetGas":{"v":20000,"d":"Once per SSTORE operation if the zeroness changes from zero."},"sstoreResetGas":{"v":5000,"d":"Once per SSTORE operation if the zeroness does not change from zero."},"sstoreRefundGas":{"v":15000,"d":"Once per SSTORE operation if the zeroness changes to zero."},"jumpdestGas":{"v":1,"d":"Refunded gas, once per SSTORE operation if the zeroness changes to zero."},"logGas":{"v":375,"d":"Per LOG* operation."},"logDataGas":{"v":8,"d":"Per byte in a LOG* operation\'s data."},"logTopicGas":{"v":375,"d":"Multiplied by the * of the LOG*, per LOG transaction. e.g. LOG0 incurs 0 * c_txLogTopicGas, LOG4 incurs 4 * c_txLogTopicGas."},"createGas":{"v":32000,"d":"Once per CREATE operation & contract-creation transaction."},"callGas":{"v":40,"d":"Once per CALL operation & message call transaction."},"callStipend":{"v":2300,"d":"Free gas given at beginning of call."},"callValueTransferGas":{"v":9000,"d":"Paid for CALL when the value transfor is non-zero."},"callNewAccountGas":{"v":25000,"d":"Paid for CALL when the destination address didn\'t exist prior."},"suicideRefundGas":{"v":24000,"d":"Refunded following a suicide operation."},"memoryGas":{"v":3,"d":"Times the address of the (highest referenced byte in memory + 1). NOTE: referencing happens on read, write and in instructions such as RETURN and CALL."},"quadCoeffDiv":{"v":512,"d":"Divisor for the quadratic particle of the memory cost equation."},"createDataGas":{"v":200,"d":""},"txGas":{"v":21000,"d":"Per transaction. NOTE: Not payable on data of calls between transactions."},"txCreation":{"v":32000,"d":"the cost of creating a contract via tx"},"txDataZeroGas":{"v":4,"d":"Per byte of data attached to a transaction that equals zero. NOTE: Not payable on data of calls between transactions."},"txDataNonZeroGas":{"v":68,"d":"Per byte of data attached to a transaction that is not equal to zero. NOTE: Not payable on data of calls between transactions."},"copyGas":{"v":3,"d":"Multiplied by the number of 32-byte words that are copied (round up) for any *COPY operation and added."},"ecrecoverGas":{"v":3000,"d":""},"sha256Gas":{"v":60,"d":""},"sha256WordGas":{"v":12,"d":""},"ripemd160Gas":{"v":600,"d":""},"ripemd160WordGas":{"v":120,"d":""},"identityGas":{"v":15,"d":""},"identityWordGas":{"v":3,"d":""},"minerReward":{"v":"5000000000000000000","d":"the amount a miner get rewarded for mining a block"},"ommerReward":{"v":"625000000000000000","d":"The amount of wei a miner of an uncle block gets for being inculded in the blockchain"},"niblingReward":{"v":"156250000000000000","d":"the amount a miner gets for inculding a uncle"},"homeSteadForkNumber":{"v":1150000,"d":"the block that the Homestead fork started at"},"homesteadRepriceForkNumber":{"v":2463000,"d":"the block that the Homestead Reprice (EIP150) fork started at"},"timebombPeriod":{"v":100000,"d":"Exponential difficulty timebomb period"},"freeBlockPeriod":{"v":2}}');
},
/*!*******************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/baseTrie.js ***!
  \*******************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! assert */
  19),
      n = a(
  /*! levelup */
  194),
      s = a(
  /*! memdown */
  203),
      o = a(
  /*! async */
  114),
      i = a(
  /*! rlp */
  21),
      c = a(
  /*! ethereumjs-util */
  82),
      u = a(
  /*! semaphore */
  208),
      d = a(
  /*! ./trieNode */
  115),
      f = a(
  /*! ./readStream */
  555),
      l = a(
  /*! ./prioritizedTaskExecutor */
  556),
      h = a(
  /*! ./util */
  62).matchingNibbleLength,
      p = a(
  /*! ./util */
  62).doKeysMatch,
      b = a(
  /*! ./util */
  62).callTogether,
      m = a(
  /*! ./util */
  62).asyncFirstSeries;

  function y(e, t) {
    var a = this;
    this.EMPTY_TRIE_ROOT = c.SHA3_RLP, this.sem = u(1), this.db = e || n("", {
      db: s
    }), this._getDBs = [this.db], this._putDBs = [this.db], Object.defineProperty(this, "root", {
      set: function set(e) {
        e ? (e = c.toBuffer(e), r(32 === e.length, "Invalid root length. Roots are 32 bytes")) : e = a.EMPTY_TRIE_ROOT, this._root = e;
      },
      get: function get() {
        return this._root;
      }
    }), this.root = t;
  }

  e.exports = y, y.prototype.get = function (e, t) {
    e = c.toBuffer(e), this.findPath(e, function (e, a, r, n) {
      var s = null;
      a && 0 === r.length && (s = a.value), t(e, s);
    });
  }, y.prototype.put = function (e, t, a) {
    var r = this;
    e = c.toBuffer(e), (t = c.toBuffer(t)) && "" !== t.toString() ? (a = b(a, r.sem.leave), r.sem.take(function () {
      r.root.toString("hex") !== c.SHA3_RLP.toString("hex") ? r.findPath(e, function (n, s, o, i) {
        if (n) return a(n);

        r._updateNode(e, t, o, i, a);
      }) : r._createInitialNode(e, t, a);
    })) : r.del(e, a);
  }, y.prototype.del = function (e, t) {
    var a = this;
    e = c.toBuffer(e), t = b(t, a.sem.leave), a.sem.take(function () {
      a.findPath(e, function (r, n, s, o) {
        if (r) return t(r);
        n ? a._deleteNode(e, o, t) : t();
      });
    });
  }, y.prototype.getRaw = function (e, t) {
    e = c.toBuffer(e), m(this._getDBs, function (t, a) {
      t.get(e, {
        keyEncoding: "binary",
        valueEncoding: "binary"
      }, function (e, t) {
        a(null, e || !t ? null : t);
      });
    }, t);
  }, y.prototype._lookupNode = function (e, t) {
    d.isRawNode(e) ? t(new d(e)) : this.getRaw(e, function (e, a) {
      if (e) throw e;
      a && (a = new d(i.decode(a))), t(a);
    });
  }, y.prototype._putRaw = function (e, t, a) {
    o.each(this._putDBs, function (a, r) {
      a.put(e, t, {
        keyEncoding: "binary",
        valueEncoding: "binary"
      }, r);
    }, a);
  }, y.prototype.putRaw = y.prototype._putRaw, y.prototype.delRaw = function (e, t) {
    o.each(this._putDBs, function (t, a) {
      t.del(e, {
        keyEncoding: "binary"
      }, a);
    }, t);
  }, y.prototype._putNode = function (e, t) {
    var a = e.hash(),
        r = e.serialize();

    this._putRaw(a, r, t);
  }, y.prototype._batchNodes = function (e, t) {
    o.each(this._putDBs, function (t, a) {
      t.batch(e, {
        keyEncoding: "binary",
        valueEncoding: "binary"
      }, a);
    }, t);
  }, y.prototype.findPath = function (e, t) {
    var a = this.root,
        r = [];
    e = d.stringToNibbles(e), this._walkTrie(a, function (t, a, n, s) {
      var o = a.key || [],
          i = e.slice(h(n, e)),
          c = h(i, o);
      if (r.push(a), "branch" === a.type) {
        if (0 === i.length) s.return(null, a, [], r);else {
          var u = i[0];
          a.getValue(u) ? s.only(u) : s.return(null, null, i, r);
        }
      } else "leaf" === a.type ? p(i, o) ? s.return(null, a, [], r) : s.return(null, null, i, r) : "extention" === a.type && (c !== o.length ? s.return(null, null, i, r) : s.next());
    }, t);
  }, y.prototype._findNode = function (e, t, a, r) {
    this.findPath(e, function () {
      r.apply(null, arguments);
    });
  }, y.prototype._findValueNodes = function (e, t) {
    this._walkTrie(this.root, function (t, a, r, n) {
      var s = r;
      a.key && (s = r.concat(a.key)), "leaf" === a.type ? e(t, a, s, n.next) : "branch" === a.type && a.value ? e(t, a, s, n.next) : n.next();
    }, t);
  }, y.prototype._findDbNodes = function (e, t) {
    this._walkTrie(this.root, function (t, a, r, n) {
      d.isRawNode(t) ? n.next() : e(t, a, r, n.next);
    }, t);
  }, y.prototype._updateNode = function (e, t, a, r, n) {
    var s = [],
        o = r.pop();
    e = d.stringToNibbles(e);
    var i = !1;

    if ("leaf" === o.type) {
      for (var c = 0, u = 0; u < r.length; u++) {
        var f = r[u];
        "branch" === f.type ? c++ : c += f.key.length;
      }

      h(o.key, e.slice(c)) === o.key.length && 0 === a.length && (i = !0);
    }

    if (i) o.value = t, r.push(o);else if ("branch" === o.type) {
      if (r.push(o), 0 !== a) {
        a.shift();
        var l = new d("leaf", a, t);
        r.push(l);
      } else o.value = t;
    } else {
      var p = o.key,
          b = h(p, a),
          m = new d("branch");

      if (0 !== b) {
        var y = o.key.slice(0, b),
            v = new d("extention", y, t);
        r.push(v), p.splice(0, b), a.splice(0, b);
      }

      if (r.push(m), 0 !== p.length) {
        var _ = p.shift();

        if (0 !== p.length || "leaf" === o.type) {
          o.key = p;

          var g = this._formatNode(o, !1, s);

          m.setValue(_, g);
        } else this._formatNode(o, !1, !0, s), m.setValue(_, o.value);
      } else m.value = o.value;

      if (0 !== a.length) {
        a.shift();
        var A = new d("leaf", a, t);
        r.push(A);
      } else m.value = t;
    }

    this._saveStack(e, r, s, n);
  }, y.prototype._walkTrie = function (e, t, a) {
    var r = this;
    e = e || r.root, a = a || function () {};
    var n = !1,
        s = [];
    if (e.toString("hex") === c.SHA3_RLP.toString("hex")) return a();

    r._lookupNode(e, function (c) {
      !function e(a, c, u, d) {
        if (!c) return d();
        if (n) return d();
        var f = !1;
        u = u || [];
        var l = {
          stop: function stop() {
            f = !0, d();
          },
          return: function _return() {
            n = !0, s = arguments, d();
          },
          next: function next() {
            if (n) return d();
            if (f) return d();
            var t = c.getChildren();
            o.forEachOf(t, function (t, a, n) {
              var s = t[0],
                  o = t[1],
                  c = u.concat(s),
                  d = c.length;
              i.execute(d, function (t) {
                r._lookupNode(o, function (a) {
                  t(), e(o, a, c, n);
                });
              });
            }, d);
          },
          only: function only(t) {
            var a = c.getValue(t),
                n = u.slice();
            n.push(t);
            var s = n.length;
            i.execute(s, function (t) {
              r._lookupNode(a, function (r) {
                t(), e(a, r, n, d);
              });
            });
          }
        };
        t(a, c, u, l);
      }(e, c, null, function (e) {
        if (e) return a(e);
        a.apply(null, s);
      });
    });

    var i = new l(500);
  }, y.prototype._saveStack = function (e, t, a, r) {
    for (var n; t.length;) {
      var s = t.pop();
      if ("leaf" === s.type) e.splice(e.length - s.key.length);else if ("extention" === s.type) e.splice(e.length - s.key.length), n && (s.value = n);else if ("branch" === s.type && n) {
        var o = e.pop();
        s.setValue(o, n);
      }
      n = this._formatNode(s, 0 === t.length, a);
    }

    n && (this.root = n), this._batchNodes(a, r);
  }, y.prototype._deleteNode = function (e, t, a) {
    var r = t.pop(),
        n = t.pop(),
        s = [],
        o = this;

    if (Array.isArray(e) || (e = d.stringToNibbles(e)), n) {
      if ("branch" === r.type) r.value = null;else {
        var i = r.key;
        e.splice(e.length - i.length), this._formatNode(r, !1, !0, s), n.setValue(e.pop(), null), r = n, n = t.pop();
      }
      var c = [];

      if (r.raw.forEach(function (e, t) {
        var a = r.getValue(t);
        a && c.push([t, a]);
      }), 1 === c.length) {
        var u = c[0][1],
            f = c[0][0];

        this._lookupNode(u, function (r) {
          e = function (e, t, a, r, n) {
            var s = a.key;

            if (r && "branch" !== r.type) {
              var o = r.key;
              "branch" === a.type ? (o.push(t), e.push(t), r.key = o, n.push(r)) : (s.unshift(t), e = e.concat(s), o = o.concat(s), a.key = o), n.push(a);
            } else {
              if (r && n.push(r), "branch" === a.type) {
                var i = new d("extention", [t], null);
                n.push(i), e.push(t);
              } else s.unshift(t), a.key = s, s.unshift(0), s.unshift(e.length), e.splice.apply(e, s);

              n.push(a);
            }

            return e;
          }(e, f, r, n, t), o._saveStack(e, t, s, a);
        });
      } else n && t.push(n), t.push(r), o._saveStack(e, t, s, a);
    } else this.root = this.EMPTY_TRIE_ROOT, a();
  }, y.prototype._createInitialNode = function (e, t, a) {
    var r = new d("leaf", e, t);
    this.root = r.hash(), this._putNode(r, a);
  }, y.prototype._formatNode = function (e, t, a, r) {
    3 === arguments.length && (r = a, a = !1);
    var n = e.serialize();

    if (n.length >= 32 || t) {
      var s = e.hash();
      return a && this.isCheckpoint ? r.push({
        type: "del",
        key: s
      }) : r.push({
        type: "put",
        key: s,
        value: n
      }), s;
    }

    return e.raw;
  }, y.prototype.createReadStream = function () {
    return new f(this);
  }, y.prototype.copy = function () {
    return new y(this.db, this.root);
  }, y.prototype.batch = function (e, t) {
    var a = this;
    o.eachSeries(e, function (e, t) {
      "put" === e.type ? a.put(e.key, e.value, t) : "del" === e.type ? a.del(e.key, t) : t();
    }, t);
  }, y.prototype.checkRoot = function (e, t) {
    e = c.toBuffer(e), this._lookupNode(e, function (e) {
      t(null, !!e);
    });
  };
},
/*!*************************************************************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/node_modules/deferred-leveldown/deferred-leveldown.js ***!
  \*************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t, r) {
    var n = a(
    /*! util */
    23),
        s = a(
    /*! abstract-leveldown */
    195).AbstractLevelDOWN,
        o = a(
    /*! ./deferred-iterator */
    541);

    function i(e) {
      s.call(this, "string" == typeof e ? e : ""), this._db = void 0, this._operations = [], this._iterators = [];
    }

    n.inherits(i, s), i.prototype.setDb = function (e) {
      this._db = e, this._operations.forEach(function (t) {
        e[t.method].apply(e, t.args);
      }), this._iterators.forEach(function (t) {
        t.setDb(e);
      });
    }, i.prototype._open = function (e, a) {
      return t.nextTick(a);
    }, i.prototype._operation = function (e, t) {
      if (this._db) return this._db[e].apply(this._db, t);

      this._operations.push({
        method: e,
        args: t
      });
    }, "put get del batch approximateSize".split(" ").forEach(function (e) {
      i.prototype["_" + e] = function () {
        this._operation(e, arguments);
      };
    }), i.prototype._isBuffer = function (e) {
      return r.isBuffer(e);
    }, i.prototype._iterator = function (e) {
      if (this._db) return this._db.iterator.apply(this._db, arguments);
      var t = new o(e);
      return this._iterators.push(t), t;
    }, e.exports = i, e.exports.DeferredIterator = o;
  }).call(this, a(
  /*! ./../../../process/browser.js */
  9), a(
  /*! ./../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!*******************************************************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/node_modules/abstract-leveldown/is-leveldown.js ***!
  \*******************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./abstract-leveldown */
  196);

  e.exports = function (e) {
    return !(!e || "object" != typeof e) && Object.keys(r.prototype).filter(function (e) {
      return "_" != e[0] && "approximateSize" != e;
    }).every(function (t) {
      return "function" == typeof e[t];
    });
  };
},
/*!************************************************************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/node_modules/deferred-leveldown/deferred-iterator.js ***!
  \************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! util */
  23),
      n = a(
  /*! abstract-leveldown */
  195).AbstractIterator;

  function s(e) {
    n.call(this, e), this._options = e, this._iterator = null, this._operations = [];
  }

  r.inherits(s, n), s.prototype.setDb = function (e) {
    var t = this._iterator = e.iterator(this._options);

    this._operations.forEach(function (e) {
      t[e.method].apply(t, e.args);
    });
  }, s.prototype._operation = function (e, t) {
    if (this._iterator) return this._iterator[e].apply(this._iterator, t);

    this._operations.push({
      method: e,
      args: t
    });
  }, "next end".split(" ").forEach(function (e) {
    s.prototype["_" + e] = function () {
      this._operation(e, arguments);
    };
  }), e.exports = s;
},
/*!***************************************************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/node_modules/level-iterator-stream/index.js ***!
  \***************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! inherits */
  3),
      n = a(
  /*! readable-stream */
  543).Readable,
      s = a(
  /*! xtend */
  47),
      o = a(
  /*! level-errors */
  547).EncodingError;

  function i(e, t) {
    if (!(this instanceof i)) return new i(e, t);
    n.call(this, s(t, {
      objectMode: !0
    })), this._iterator = e, this._destroyed = !1, this._decoder = null, t && t.decoder && (this._decoder = t.decoder), this.on("end", this._cleanup.bind(this));
  }

  e.exports = i, r(i, n), i.prototype._read = function () {
    var e = this;
    this._destroyed || this._iterator.next(function (t, a, r) {
      if (!e._destroyed) {
        if (t) return e.emit("error", t);
        if (void 0 === a && void 0 === r) e.push(null);else {
          if (!e._decoder) return e.push({
            key: a,
            value: r
          });

          try {
            r = e._decoder(a, r);
          } catch (t) {
            return e.emit("error", new o(t)), void e.push(null);
          }

          e.push(r);
        }
      }
    });
  }, i.prototype.destroy = i.prototype._cleanup = function () {
    var e = this;
    this._destroyed || (this._destroyed = !0, this._iterator.end(function (t) {
      if (t) return e.emit("error", t);
      e.emit("close");
    }));
  };
},
/*!***********************************************************************************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/node_modules/level-iterator-stream/node_modules/readable-stream/readable.js ***!
  \***********************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (r) {
    (t = e.exports = a(
    /*! ./lib/_stream_readable.js */
    199)).Stream = a(
    /*! stream */
    28), t.Readable = t, t.Writable = a(
    /*! ./lib/_stream_writable.js */
    200), t.Duplex = a(
    /*! ./lib/_stream_duplex.js */
    61), t.Transform = a(
    /*! ./lib/_stream_transform.js */
    201), t.PassThrough = a(
    /*! ./lib/_stream_passthrough.js */
    546), r.browser || "disable" !== r.env.READABLE_STREAM || (e.exports = a(
    /*! stream */
    28));
  }).call(this, a(
  /*! ./../../../../../process/browser.js */
  9));
},
/*!*************************************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/node_modules/isarray/index.js ***!
  \*************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = Array.isArray || function (e) {
    return "[object Array]" == Object.prototype.toString.call(e);
  };
},
/*!**********************!*\
  !*** util (ignored) ***!
  \**********************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {},
/*!**************************************************************************************************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/node_modules/level-iterator-stream/node_modules/readable-stream/lib/_stream_passthrough.js ***!
  \**************************************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  e.exports = s;
  var r = a(
  /*! ./_stream_transform */
  201),
      n = a(
  /*! core-util-is */
  27);

  function s(e) {
    if (!(this instanceof s)) return new s(e);
    r.call(this, e);
  }

  n.inherits = a(
  /*! inherits */
  3), n.inherits(s, r), s.prototype._transform = function (e, t, a) {
    a(null, e);
  };
},
/*!******************************************************************************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/node_modules/level-iterator-stream/node_modules/level-errors/errors.js ***!
  \******************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! errno */
  110).create,
      n = r("LevelUPError"),
      s = r("NotFoundError", n);
  s.prototype.notFound = !0, s.prototype.status = 404, e.exports = {
    LevelUPError: n,
    InitializationError: r("InitializationError", n),
    OpenError: r("OpenError", n),
    ReadError: r("ReadError", n),
    WriteError: r("WriteError", n),
    NotFoundError: s,
    EncodingError: r("EncodingError", n)
  };
},
/*!*****************************************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/node_modules/levelup/lib/batch.js ***!
  \*****************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./util */
  202),
      n = a(
  /*! level-errors */
  113).WriteError,
      s = r.getOptions,
      o = r.dispatchError;

  function i(e, t) {
    this._levelup = e, this._codec = t, this.batch = e.db.batch(), this.ops = [], this.length = 0;
  }

  i.prototype.put = function (e, t, a) {
    a = s(a);

    var r = this._codec.encodeKey(e, a),
        o = this._codec.encodeValue(t, a);

    try {
      this.batch.put(r, o);
    } catch (e) {
      throw new n(e);
    }

    return this.ops.push({
      type: "put",
      key: r,
      value: o
    }), this.length++, this;
  }, i.prototype.del = function (e, t) {
    t = s(t);

    var a = this._codec.encodeKey(e, t);

    try {
      this.batch.del(a);
    } catch (e) {
      throw new n(e);
    }

    return this.ops.push({
      type: "del",
      key: a
    }), this.length++, this;
  }, i.prototype.clear = function () {
    try {
      this.batch.clear();
    } catch (e) {
      throw new n(e);
    }

    return this.ops = [], this.length = 0, this;
  }, i.prototype.write = function (e) {
    var t = this._levelup,
        a = this.ops;

    try {
      this.batch.write(function (r) {
        if (r) return o(t, new n(r), e);
        t.emit("batch", a), e && e();
      });
    } catch (e) {
      throw new n(e);
    }
  }, e.exports = i;
},
/*!*****************************************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/node_modules/level-codec/index.js ***!
  \*****************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./lib/encodings */
  550);

  function n(e) {
    this.opts = e || {}, this.encodings = r;
  }

  e.exports = n, n.prototype._encoding = function (e) {
    return "string" == typeof e && (e = r[e]), e || (e = r.id), e;
  }, n.prototype._keyEncoding = function (e, t) {
    return this._encoding(t && t.keyEncoding || e && e.keyEncoding || this.opts.keyEncoding);
  }, n.prototype._valueEncoding = function (e, t) {
    return this._encoding(t && (t.valueEncoding || t.encoding) || e && (e.valueEncoding || e.encoding) || this.opts.valueEncoding || this.opts.encoding);
  }, n.prototype.encodeKey = function (e, t, a) {
    return this._keyEncoding(t, a).encode(e);
  }, n.prototype.encodeValue = function (e, t, a) {
    return this._valueEncoding(t, a).encode(e);
  }, n.prototype.decodeKey = function (e, t) {
    return this._keyEncoding(t).decode(e);
  }, n.prototype.decodeValue = function (e, t) {
    return this._valueEncoding(t).decode(e);
  }, n.prototype.encodeBatch = function (e, t) {
    var a = this;
    return e.map(function (e) {
      var r = {
        type: e.type,
        key: a.encodeKey(e.key, t, e)
      };
      return a.keyAsBuffer(t, e) && (r.keyEncoding = "binary"), e.prefix && (r.prefix = e.prefix), "value" in e && (r.value = a.encodeValue(e.value, t, e), a.valueAsBuffer(t, e) && (r.valueEncoding = "binary")), r;
    });
  };
  var s = ["lt", "gt", "lte", "gte", "start", "end"];
  n.prototype.encodeLtgt = function (e) {
    var t = this,
        a = {};
    return Object.keys(e).forEach(function (r) {
      a[r] = s.indexOf(r) > -1 ? t.encodeKey(e[r], e) : e[r];
    }), a;
  }, n.prototype.createStreamDecoder = function (e) {
    var t = this;
    return e.keys && e.values ? function (a, r) {
      return {
        key: t.decodeKey(a, e),
        value: t.decodeValue(r, e)
      };
    } : e.keys ? function (a) {
      return t.decodeKey(a, e);
    } : e.values ? function (a, r) {
      return t.decodeValue(r, e);
    } : function () {};
  }, n.prototype.keyAsBuffer = function (e) {
    return this._keyEncoding(e).buffer;
  }, n.prototype.valueAsBuffer = function (e) {
    return this._valueEncoding(e).buffer;
  };
},
/*!*************************************************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/node_modules/level-codec/lib/encodings.js ***!
  \*************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (e) {
    t.utf8 = t["utf-8"] = {
      encode: function encode(e) {
        return r(e) ? e : String(e);
      },
      decode: function decode(e) {
        return "string" == typeof e ? e : String(e);
      },
      buffer: !1,
      type: "utf8"
    }, t.json = {
      encode: JSON.stringify,
      decode: JSON.parse,
      buffer: !1,
      type: "json"
    }, t.binary = {
      encode: function encode(t) {
        return r(t) ? t : new e(t);
      },
      decode: a,
      buffer: !0,
      type: "binary"
    }, t.none = {
      encode: a,
      decode: a,
      buffer: !1,
      type: "id"
    }, t.id = t.none;

    function a(e) {
      return e;
    }

    function r(t) {
      return null == t || e.isBuffer(t);
    }

    ["hex", "ascii", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le"].forEach(function (a) {
      t[a] = {
        encode: function encode(t) {
          return r(t) ? t : new e(t, a);
        },
        decode: function decode(e) {
          return e.toString(a);
        },
        buffer: !0,
        type: a
      };
    });
  }).call(this, a(
  /*! ./../../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!*****************************!*\
  !*** ./leveldown (ignored) ***!
  \*****************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {},
/*!******************************************************************************!*\
  !*** ./node_modules/memdown/node_modules/abstract-leveldown/is-leveldown.js ***!
  \******************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./abstract-leveldown */
  205);

  e.exports = function (e) {
    return !(!e || "object" != typeof e) && Object.keys(r.prototype).filter(function (e) {
      return "_" != e[0] && "approximateSize" != e;
    }).every(function (t) {
      return "function" == typeof e[t];
    });
  };
},
/*!****************************************************************!*\
  !*** ./node_modules/memdown/node_modules/safe-buffer/index.js ***!
  \****************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! buffer */
  1),
      n = r.Buffer;

  function s(e, t) {
    for (var a in e) {
      t[a] = e[a];
    }
  }

  function o(e, t, a) {
    return n(e, t, a);
  }

  n.from && n.alloc && n.allocUnsafe && n.allocUnsafeSlow ? e.exports = r : (s(r, t), t.Buffer = o), s(n, o), o.from = function (e, t, a) {
    if ("number" == typeof e) throw new TypeError("Argument must not be a number");
    return n(e, t, a);
  }, o.alloc = function (e, t, a) {
    if ("number" != typeof e) throw new TypeError("Argument must be a number");
    var r = n(e);
    return void 0 !== t ? "string" == typeof a ? r.fill(t, a) : r.fill(t) : r.fill(0), r;
  }, o.allocUnsafe = function (e) {
    if ("number" != typeof e) throw new TypeError("Argument must be a number");
    return n(e);
  }, o.allocUnsafeSlow = function (e) {
    if ("number" != typeof e) throw new TypeError("Argument must be a number");
    return r.SlowBuffer(e);
  };
},
/*!***************************************************!*\
  !*** ./node_modules/memdown/immediate-browser.js ***!
  \***************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  e.exports = a(
  /*! immediate */
  191);
},
/*!*********************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/readStream.js ***!
  \*********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! readable-stream */
  58).Readable,
      n = a(
  /*! ./trieNode */
  115),
      s = a(
  /*! util */
  23);

  function o(e) {
    this.trie = e, this.next = null, r.call(this, {
      objectMode: !0
    });
  }

  e.exports = o, s.inherits(o, r), o.prototype._read = function () {
    var e = this;
    e._started || (e._started = !0, e.trie._findValueNodes(function (t, a, r, s) {
      e.push({
        key: n.nibblesToBuffer(r),
        value: a.value
      }), s();
    }, function () {
      e.push(null);
    }));
  };
},
/*!**********************************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/prioritizedTaskExecutor.js ***!
  \**********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  function a(e) {
    this.maxPoolSize = e, this.currentPoolSize = 0, this.queue = [];
  }

  e.exports = a, a.prototype.execute = function (e, t) {
    var a = this;
    a.currentPoolSize < a.maxPoolSize ? (a.currentPoolSize++, t(function () {
      if (a.currentPoolSize--, a.queue.length > 0) {
        a.queue.sort(function (e, t) {
          return t.priority - e.priority;
        });
        var e = a.queue.shift();
        a.execute(e.priority, e.task);
      }
    })) : a.queue.push({
      priority: e,
      task: t
    });
  };
},
/*!*******************************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/checkpoint-interface.js ***!
  \*******************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! levelup */
  194),
      n = a(
  /*! memdown */
  203),
      s = a(
  /*! async */
  114),
      o = a(
  /*! util */
  23).inherits,
      i = a(
  /*! readable-stream */
  58).Readable,
      c = a(
  /*! level-ws */
  558),
      u = a(
  /*! ./util */
  62).callTogether;

  function d(e) {
    this._scratch = null, e._checkpoints = [], Object.defineProperty(e, "isCheckpoint", {
      get: function get() {
        return !!e._checkpoints.length;
      }
    }), e.checkpoint = f, e.commit = l, e.revert = h, e._enterCpMode = p, e._exitCpMode = b, e.createScratchReadStream = y, e.copy = function (e) {
      var t = e();
      return d.call(t, t), t._scratch = this._scratch, t;
    }.bind(e, e.copy.bind(e));
  }

  function f() {
    var e = this.isCheckpoint;
    this._checkpoints.push(this.root), !e && this.isCheckpoint && this._enterCpMode();
  }

  function l(e) {
    var t = this;
    e = u(e, t.sem.leave), t.sem.take(function () {
      if (!t.isCheckpoint) throw new Error("trying to commit when not checkpointed");
      t._checkpoints.pop(), t.isCheckpoint ? e() : t._exitCpMode(!0, e);
    });
  }

  function h(e) {
    var t = this;
    e = u(e, t.sem.leave), t.sem.take(function () {
      !t.isCheckpoint || (t.root = t._checkpoints.pop(), t.isCheckpoint) ? e() : t._exitCpMode(!1, e);
    });
  }

  function p() {
    this._scratch = r("", {
      db: n
    }), this._getDBs = [this._scratch].concat(this._getDBs), this.__putDBs = this._putDBs, this._putDBs = [this._scratch], this._putRaw = this.putRaw, this.putRaw = m;
  }

  function b(e, t) {
    var a = this,
        r = this._scratch;
    this._scratch = null, this._getDBs = this._getDBs.slice(1), this._putDBs = this.__putDBs, this.putRaw = this._putRaw, e ? s.map(this._putDBs, function (e, t) {
      e.createWriteStream || (e = c(e)), a.createScratchReadStream(r).pipe(e.createWriteStream()).on("close", t);
    }, t) : t();
  }

  function m(e, t, a) {
    s.each(this.__putDBs, function (a, r) {
      a.put(e, t, {
        keyEncoding: "binary",
        valueEncoding: "binary"
      }, r);
    }, a);
  }

  function y(e) {
    var t = this.copy();
    return e = e || this._scratch, t._getDBs = [e], t._scratch = e, new v(t);
  }

  function v(e) {
    this.trie = e, this.next = null, i.call(this, {
      objectMode: !0
    });
  }

  e.exports = d, o(v, i), v.prototype._read = function () {
    var e = this;
    e._started || (e._started = !0, e.trie._findDbNodes(function (t, a, r, n) {
      e.push({
        key: t,
        value: a.serialize()
      }), n();
    }, function () {
      e.push(null);
    }));
  };
},
/*!*******************************************!*\
  !*** ./node_modules/level-ws/level-ws.js ***!
  \*******************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    var r,
        n = a(
    /*! stream */
    28).Writable || a(
    /*! readable-stream */
    559).Writable,
        s = a(
    /*! util */
    23).inherits,
        o = a(
    /*! xtend */
    562),
        i = {
      type: "put",
      keyEncoding: "utf8",
      valueEncoding: "utf8"
    },
        c = (r = {}, ["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le"].forEach(function (e) {
      r[e] = {
        valueEncoding: e
      };
    }), r);

    function u(e, t) {
      if (!(this instanceof u)) return new u(e, t);
      n.call(this, {
        objectMode: !0
      }), this._options = o(i, function (e, t) {
        var a = "string" == typeof t;
        return !a && t && t.encoding && !t.valueEncoding && (t.valueEncoding = t.encoding), o(e && e.options || {}, a ? c[t] || c[i.valueEncoding] : t);
      }(t, e)), this._db = t, this._buffer = [], this.writable = !0, this.readable = !1;
      var a = this;
      this.on("finish", function e() {
        if (a._buffer && a._buffer.length) return a._flush(e);
        a.writable = !1, a.emit("close");
      });
    }

    s(u, n), u.prototype._write = function e(a, r, n) {
      var s = this;
      if (!s._destroyed) return s._db.isOpen() ? void (s._options.maxBufferLength && s._buffer.length > s._options.maxBufferLength ? s.once("_flush", n) : (0 === s._buffer.length && t.nextTick(function () {
        s._flush();
      }), s._buffer.push(a), n())) : s._db.once("ready", function () {
        e.call(s, a, r, n);
      });
    }, u.prototype._flush = function (e) {
      var t = this,
          a = t._buffer;

      if (!t._destroyed && a) {
        if (!t._db.isOpen()) return t._db.on("ready", function () {
          t._flush(e);
        });
        t._buffer = [], t._db.batch(a.map(function (e) {
          return {
            type: e.type || t._options.type,
            key: e.key,
            value: e.value,
            keyEncoding: e.keyEncoding || t._options.keyEncoding,
            valueEncoding: e.valueEncoding || e.encoding || t._options.valueEncoding
          };
        }), function (a) {
          a ? (t.writable = !1, t.emit("error", a)) : (e && e(), t.emit("_flush"));
        });
      }
    }, u.prototype.toString = function () {
      return "LevelUP.WriteStream";
    }, u.prototype.destroy = function () {
      this._destroyed || (this._buffer = null, this._destroyed = !0, this.writable = !1, this.emit("close"));
    }, u.prototype.destroySoon = function () {
      this.end();
    }, e.exports = function (e) {
      return e.writeStream = e.createWriteStream = function (t) {
        return new u(t, e);
      }, e;
    }, e.exports.WriteStream = u;
  }).call(this, a(
  /*! ./../process/browser.js */
  9));
},
/*!************************************************************************!*\
  !*** ./node_modules/level-ws/node_modules/readable-stream/readable.js ***!
  \************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (r) {
    var n = a(
    /*! stream */
    28);
    (t = e.exports = a(
    /*! ./lib/_stream_readable.js */
    209)).Stream = n, t.Readable = t, t.Writable = a(
    /*! ./lib/_stream_writable.js */
    210), t.Duplex = a(
    /*! ./lib/_stream_duplex.js */
    116), t.Transform = a(
    /*! ./lib/_stream_transform.js */
    211), t.PassThrough = a(
    /*! ./lib/_stream_passthrough.js */
    561), r.browser || "disable" !== r.env.READABLE_STREAM || (e.exports = a(
    /*! stream */
    28));
  }).call(this, a(
  /*! ./../../../process/browser.js */
  9));
},
/*!*************************************************************!*\
  !*** ./node_modules/level-ws/node_modules/isarray/index.js ***!
  \*************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = Array.isArray || function (e) {
    return "[object Array]" == Object.prototype.toString.call(e);
  };
},
/*!***************************************************************************************!*\
  !*** ./node_modules/level-ws/node_modules/readable-stream/lib/_stream_passthrough.js ***!
  \***************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  e.exports = s;
  var r = a(
  /*! ./_stream_transform */
  211),
      n = a(
  /*! core-util-is */
  27);

  function s(e) {
    if (!(this instanceof s)) return new s(e);
    r.call(this, e);
  }

  n.inherits = a(
  /*! inherits */
  3), n.inherits(s, r), s.prototype._transform = function (e, t, a) {
    a(null, e);
  };
},
/*!***********************************************************!*\
  !*** ./node_modules/level-ws/node_modules/xtend/index.js ***!
  \***********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! object-keys */
  563),
      n = a(
  /*! ./has-keys */
  567);

  e.exports = function () {
    for (var e = {}, t = 0; t < arguments.length; t++) {
      var a = arguments[t];
      if (n(a)) for (var s = r(a), o = 0; o < s.length; o++) {
        var i = s[o];
        e[i] = a[i];
      }
    }

    return e;
  };
},
/*!*****************************************************************!*\
  !*** ./node_modules/level-ws/node_modules/object-keys/index.js ***!
  \*****************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  e.exports = Object.keys || a(
  /*! ./shim */
  564);
},
/*!****************************************************************!*\
  !*** ./node_modules/level-ws/node_modules/object-keys/shim.js ***!
  \****************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  !function () {
    "use strict";

    var t,
        r = Object.prototype.hasOwnProperty,
        n = Object.prototype.toString,
        s = a(
    /*! ./foreach */
    565),
        o = a(
    /*! ./isArguments */
    566),
        i = !{
      toString: null
    }.propertyIsEnumerable("toString"),
        c = function () {}.propertyIsEnumerable("prototype"),
        u = ["toString", "toLocaleString", "valueOf", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "constructor"];

    t = function t(e) {
      var t = null !== e && "object" == typeof e,
          a = "[object Function]" === n.call(e),
          d = o(e),
          f = [];
      if (!t && !a && !d) throw new TypeError("Object.keys called on a non-object");
      if (d) s(e, function (e) {
        f.push(e);
      });else {
        var l,
            h = c && a;

        for (l in e) {
          h && "prototype" === l || !r.call(e, l) || f.push(l);
        }
      }

      if (i) {
        var p = e.constructor,
            b = p && p.prototype === e;
        s(u, function (t) {
          b && "constructor" === t || !r.call(e, t) || f.push(t);
        });
      }

      return f;
    }, e.exports = t;
  }();
},
/*!*******************************************************************!*\
  !*** ./node_modules/level-ws/node_modules/object-keys/foreach.js ***!
  \*******************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  var a = Object.prototype.hasOwnProperty,
      r = Object.prototype.toString,
      n = function n(e) {
    var t = "function" == typeof e && !(e instanceof RegExp) || "[object Function]" === r.call(e);
    return t || "undefined" == typeof window || (t = e === window.setTimeout || e === window.alert || e === window.confirm || e === window.prompt), t;
  };

  e.exports = function (e, t) {
    if (!n(t)) throw new TypeError("iterator must be a function");
    var r,
        s,
        o = "string" == typeof e,
        i = e.length,
        c = arguments.length > 2 ? arguments[2] : null;
    if (i === +i) for (r = 0; r < i; r++) {
      null === c ? t(o ? e.charAt(r) : e[r], r, e) : t.call(c, o ? e.charAt(r) : e[r], r, e);
    } else for (s in e) {
      a.call(e, s) && (null === c ? t(e[s], s, e) : t.call(c, e[s], s, e));
    }
  };
},
/*!***********************************************************************!*\
  !*** ./node_modules/level-ws/node_modules/object-keys/isArguments.js ***!
  \***********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  var a = Object.prototype.toString;

  e.exports = function (e) {
    var t = a.call(e),
        r = "[object Arguments]" === t;
    return r || (r = "[object Array]" !== t && null !== e && "object" == typeof e && "number" == typeof e.length && e.length >= 0 && "[object Function]" === a.call(e.callee)), r;
  };
},
/*!**************************************************************!*\
  !*** ./node_modules/level-ws/node_modules/xtend/has-keys.js ***!
  \**************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = function (e) {
    return null !== e && ("object" == typeof e || "function" == typeof e);
  };
},
/*!****************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/proof.js ***!
  \****************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (e) {
    var r = a(
    /*! ./trieNode */
    115),
        n = a(
    /*! ethereumjs-util */
    82),
        s = a(
    /*! ./util */
    62).matchingNibbleLength;
    t.prove = function (e, t, a) {
      var r;
      e.findPath(t, function (e, t, n, s) {
        if (e) return a(e);
        if (n.length > 0) return a(new Error("Node does not contain the key"));
        r = s;

        for (var o = [], i = 0; i < r.length; i++) {
          var c = r[i].serialize();
          (c.length >= 32 || 0 === i) && o.push(c);
        }

        a(null, o);
      });
    }, t.verifyProof = function (t, a, o, i) {
      a = r.stringToNibbles(a);

      for (var c = n.toBuffer(t), u = 0; u < o.length; u++) {
        var d = n.toBuffer(o[u]),
            f = n.sha3(o[u]);
        if (e.compare(f, c)) return i(new Error("Bad proof node " + u + ": hash mismatch"));
        var l,
            h = new r(n.rlp.decode(d));

        if ("branch" === h.type) {
          if (0 === a.length) return u !== o.length - 1 ? i(new Error("Additional nodes at end of proof (branch)")) : i(null, h.value);

          if (l = h.raw[a[0]], a = a.slice(1), 2 === l.length) {
            var p = new r(l);
            return u !== o.length - 1 ? i(new Error("Additional nodes at end of proof (embeddedNode)")) : s(p.key, a) !== p.key.length ? i(new Error("Key length does not match with the proof one (embeddedNode)")) : 0 !== (a = a.slice(p.key.length)).length ? i(new Error("Key does not match with the proof one (embeddedNode)")) : i(null, p.value);
          }

          c = l;
        } else {
          if ("extention" !== h.type && "leaf" !== h.type) return i(new Error("Invalid node type"));
          if (s(h.key, a) !== h.key.length) return i(new Error("Key does not match with the proof one (extention|leaf)"));
          if (l = h.value, 0 === (a = a.slice(h.key.length)).length || 17 === l.length && 1 === a.length) return 17 === l.length && (l = l[a[0]][1], a = a.slice(1)), u !== o.length - 1 ? i(new Error("Additional nodes at end of proof (extention|leaf)")) : i(null, l);
          c = l;
        }
      }

      i(new Error("Unexpected end of proof"));
    };
  }).call(this, a(
  /*! ./../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!*************************************************!*\
  !*** ./node_modules/ethereumjs-block/header.js ***!
  \*************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    var r = a(
    /*! ethereumjs-common */
    192).default,
        n = a(
    /*! ethereumjs-util */
    193),
        s = n.BN;

    var o = e.exports = function (e, a) {
      if ((a = a || {}).common) {
        if (a.chain) throw new Error("Instantiation with both opts.common and opts.chain parameter not allowed!");
        this._common = a.common;
      } else {
        var _e13 = a.chain ? a.chain : "mainnet",
            _t15 = a.hardfork ? a.hardfork : null;

        this._common = new r(_e13, _t15);
      }

      var s = [{
        name: "parentHash",
        length: 32,
        default: n.zeros(32)
      }, {
        name: "uncleHash",
        default: n.SHA3_RLP_ARRAY
      }, {
        name: "coinbase",
        length: 20,
        default: n.zeros(20)
      }, {
        name: "stateRoot",
        length: 32,
        default: n.zeros(32)
      }, {
        name: "transactionsTrie",
        length: 32,
        default: n.SHA3_RLP
      }, {
        name: "receiptTrie",
        length: 32,
        default: n.SHA3_RLP
      }, {
        name: "bloom",
        default: n.zeros(256)
      }, {
        name: "difficulty",
        default: t.from([])
      }, {
        name: "number",
        default: n.intToBuffer(115e4)
      }, {
        name: "gasLimit",
        default: t.from("ffffffffffffff", "hex")
      }, {
        name: "gasUsed",
        empty: !0,
        default: t.from([])
      }, {
        name: "timestamp",
        default: t.from([])
      }, {
        name: "extraData",
        allowZero: !0,
        empty: !0,
        default: t.from([])
      }, {
        name: "mixHash",
        default: n.zeros(32)
      }, {
        name: "nonce",
        default: n.zeros(8)
      }];
      n.defineProperties(this, s, e);
    };

    o.prototype.canonicalDifficulty = function (e) {
      var t = this._common.hardfork() || this._common.activeHardfork(n.bufferToInt(this.number)),
          a = new s(this.timestamp),
          r = new s(e.header.timestamp),
          o = new s(e.header.difficulty),
          i = new s(this._common.param("pow", "minimumDifficulty", t));

      var c,
          u,
          d,
          f = o.div(new s(this._common.param("pow", "difficultyBoundDivisor", t))),
          l = new s(this.number);

      if (this._common.hardforkGteHardfork(t, "byzantium")) {
        var h = e.header.uncleHash.equals(n.SHA3_RLP_ARRAY) ? 1 : 2;
        c = a.sub(r).idivn(9).ineg().iaddn(h), 1 === (u = new s(-99)).cmp(c) && (c = u), d = o.add(f.mul(c));
      }

      this._common.hardforkGteHardfork(t, "constantinople") ? (l.isubn(5e6), l.ltn(0) && (l = new s(0))) : this._common.hardforkGteHardfork(t, "byzantium") ? (l.isubn(3e6), l.ltn(0) && (l = new s(0))) : this._common.hardforkGteHardfork(t, "homestead") ? (c = a.sub(r).idivn(10).ineg().iaddn(1), 1 === (u = new s(-99)).cmp(c) && (c = u), d = o.add(f.mul(c))) : d = 1 === r.addn(this._common.param("pow", "durationLimit", t)).cmp(a) ? f.add(o) : o.sub(f);
      var p = l.idivn(1e5).isubn(2);
      return p.isNeg() || d.iadd(new s(2).pow(p)), -1 === d.cmp(i) && (d = i), d;
    }, o.prototype.validateDifficulty = function (e) {
      return 0 === this.canonicalDifficulty(e).cmp(new s(this.difficulty));
    }, o.prototype.validateGasLimit = function (e) {
      var t = new s(e.header.gasLimit),
          a = new s(this.gasLimit),
          r = this._common.hardfork() ? this._common.hardfork() : this._common.activeHardfork(this.number),
          n = t.div(new s(this._common.param("gasConfig", "gasLimitBoundDivisor", r))),
          o = t.add(n),
          i = t.sub(n);
      return a.lt(o) && a.gt(i) && a.gte(this._common.param("gasConfig", "minGasLimit", r));
    }, o.prototype.validate = function (e, t, a) {
      var r = this;
      if (2 === arguments.length && (a = t, t = !1), this.isGenesis()) return a();
      e.getBlock(r.parentHash, function (e, o) {
        if (e) return a("could not find parent block");
        if (r.parentBlock = o, 0 !== new s(r.number).cmp(new s(o.header.number).iaddn(1))) return a("invalid number");

        if (t) {
          var i = t.sub(new s(o.header.number));
          if (-1 !== i.cmpn(8) || 1 !== i.cmpn(1)) return a("uncle block has a parent that is too old or to young");
        }

        if (!r.validateDifficulty(o)) return a("invalid Difficulty");
        if (!r.validateGasLimit(o)) return a("invalid gas limit");
        if (n.bufferToInt(o.header.number) + 1 !== n.bufferToInt(r.number)) return a("invalid heigth");
        if (n.bufferToInt(r.timestamp) <= n.bufferToInt(o.header.timestamp)) return a("invalid timestamp");
        var c = r._common.hardfork() ? r._common.hardfork() : r._common.activeHardfork(t);
        if (r.extraData.length > r._common.param("vm", "maxExtraDataSize", c)) return a("invalid amount of extra data");
        a();
      });
    }, o.prototype.hash = function () {
      return n.rlphash(this.raw);
    }, o.prototype.isGenesis = function () {
      return "" === this.number.toString("hex");
    }, o.prototype.setGenesisParams = function () {
      this.timestamp = this._common.genesis().timestamp, this.gasLimit = this._common.genesis().gasLimit, this.difficulty = this._common.genesis().difficulty, this.extraData = this._common.genesis().extraData, this.nonce = this._common.genesis().nonce, this.stateRoot = this._common.genesis().stateRoot, this.number = t.from([]);
    };
  }).call(this, a(
  /*! ./../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!****************************************!*\
  !*** ./node_modules/ethashjs/index.js ***!
  \****************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    var r = a(
    /*! ethereumjs-util */
    212),
        n = a(
    /*! ./util.js */
    573),
        s = a(
    /*! buffer-xor */
    63),
        o = r.BN,
        i = a(
    /*! async */
    574);

    var c = e.exports = function (e) {
      this.dbOpts = {
        valueEncoding: "json"
      }, this.cacheDB = e, this.cache = !1;
    };

    c.prototype.mkcache = function (e, t) {
      var a = Math.floor(e / n.params.HASH_BYTES);

      for (var o = [r.sha3(t, 512)], i = 1; i < a; i++) {
        o.push(r.sha3(o[o.length - 1], 512));
      }

      for (var c = 0; c < n.params.CACHE_ROUNDS; c++) {
        for (i = 0; i < a; i++) {
          var u = o[i].readUInt32LE(0) % a;
          o[i] = r.sha3(s(o[(i - 1 + a) % a], o[u]), 512);
        }
      }

      return this.cache = o;
    }, c.prototype.calcDatasetItem = function (e) {
      var a = this.cache.length,
          s = Math.floor(n.params.HASH_BYTES / n.params.WORD_BYTES);
      var o = new t(this.cache[e % a]);
      o.writeInt32LE(o.readUInt32LE(0) ^ e, 0), o = r.sha3(o, 512);

      for (var i = 0; i < n.params.DATASET_PARENTS; i++) {
        var c = n.fnv(e ^ i, o.readUInt32LE(i % s * 4));
        o = n.fnvBuffer(o, this.cache[c % a]);
      }

      return r.sha3(o, 512);
    }, c.prototype.run = function (e, a, s) {
      s = s || this.fullSize;
      var o = Math.floor(s / n.params.HASH_BYTES),
          i = Math.floor(n.params.MIX_BYTES / n.params.WORD_BYTES),
          c = r.sha3(t.concat([e, n.bufReverse(a)]), 512),
          u = Math.floor(n.params.MIX_BYTES / n.params.HASH_BYTES);

      for (var d = t.concat(Array(u).fill(c)), f = 0; f < n.params.ACCESSES; f++) {
        for (var l = n.fnv(f ^ c.readUInt32LE(0), d.readUInt32LE(f % i * 4)) % Math.floor(o / u) * u, h = [], p = 0; p < u; p++) {
          h.push(this.calcDatasetItem(l + p));
        }

        h = t.concat(h), d = n.fnvBuffer(d, h);
      }

      var b = new t(d.length / 4);

      for (f = 0; f < d.length / 4; f += 4) {
        var m = n.fnv(d.readUInt32LE(4 * f), d.readUInt32LE(4 * (f + 1))),
            y = n.fnv(m, d.readUInt32LE(4 * (f + 2))),
            v = n.fnv(y, d.readUInt32LE(4 * (f + 3)));
        b.writeUInt32LE(v, f);
      }

      return {
        mix: b,
        hash: r.sha3(t.concat([c, b]))
      };
    }, c.prototype.cacheHash = function () {
      return r.sha3(t.concat(this.cache));
    }, c.prototype.headerHash = function (e) {
      return r.rlphash(e.slice(0, -2));
    }, c.prototype.loadEpoc = function (e, a) {
      var s = this;
      var o = n.getEpoc(e);
      if (this.epoc === o) return a();
      this.epoc = o, s.cacheDB.get(o, s.dbOpts, function (e, i) {
        i ? (s.cache = i.cache.map(function (e) {
          return new t(e);
        }), s.cacheSize = i.cacheSize, s.fullSize = i.fullSize, s.seed = new t(i.seed), a()) : (s.cacheSize = n.getCacheSize(o), s.fullSize = n.getFullSize(o), function e(t, a) {
          if (0 === t) return a(r.zeros(32), 0);
          s.cacheDB.get(t, s.dbOpts, function (r, n) {
            r ? e(t - 1, a) : a(n.seed, t);
          });
        }(o, function (e, t) {
          s.seed = n.getSeed(e, t, o);
          var r = s.mkcache(s.cacheSize, s.seed);
          s.cacheDB.put(o, {
            cacheSize: s.cacheSize,
            fullSize: s.fullSize,
            seed: s.seed,
            cache: r
          }, s.dbOpts, a);
        }));
      });
    }, c.prototype._verifyPOW = function (e, a) {
      var n = this,
          s = this.headerHash(e.raw),
          i = r.bufferToInt(e.number);
      this.loadEpoc(i, function () {
        var i = n.run(s, new t(e.nonce, "hex")),
            c = new o(i.hash);
        a(i.mix.toString("hex") === e.mixHash.toString("hex") && 1 === r.TWO_POW256.div(new o(e.difficulty)).cmp(c));
      });
    }, c.prototype.verifyPOW = function (e, t) {
      var a = this,
          r = !0;
      e.header.isGenesis() ? t(!0) : this._verifyPOW(e.header, function (n) {
        if (!(r &= n)) return t(r);
        i.eachSeries(e.uncleHeaders, function (e, t) {
          a._verifyPOW(e, function (e) {
            (r &= e) ? t() : t(Boolean(r));
          });
        }, function () {
          t(Boolean(r));
        });
      });
    };
  }).call(this, a(
  /*! ./../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!***********************************************!*\
  !*** ./node_modules/browserify-sha3/index.js ***!
  \***********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! js-sha3 */
  572),
      n = a(
  /*! safe-buffer */
  7).Buffer,
      s = [224, 256, 384, 512],
      o = function o(e) {
    if (void 0 !== e && -1 === s.indexOf(e)) throw new Error("Unsupported hash length");
    this.content = [], this.bitcount = e ? "keccak_" + e : "keccak_512";
  };

  o.prototype.update = function (e) {
    if (n.isBuffer(e)) this.content.push(e);else {
      if ("string" != typeof e) throw new Error("Unsupported argument to update");
      this.content.push(new n(e));
    }
    return this;
  }, o.prototype.digest = function (e) {
    var t = r[this.bitcount](n.concat(this.content));
    if ("hex" === e) return t;
    if ("binary" === e || void 0 === e) return new n(t, "hex").toString("binary");
    throw new Error("Unsupported encoding for digest: " + e);
  }, e.exports = {
    SHA3Hash: o
  };
},
/*!***********************************************************************!*\
  !*** ./node_modules/browserify-sha3/node_modules/js-sha3/src/sha3.js ***!
  \***********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t, a) {
    /**
     * [js-sha3]{@link https://github.com/emn178/js-sha3}
     *
     * @version 0.6.1
     * @author Chen, Yi-Cyuan [emn178@gmail.com]
     * @copyright Chen, Yi-Cyuan 2015-2017
     * @license MIT
     */
    !function () {
      "use strict";

      var r = "object" == typeof window ? window : {};
      !r.JS_SHA3_NO_NODE_JS && "object" == typeof t && t.versions && t.versions.node && (r = a);
      var n = !r.JS_SHA3_NO_COMMON_JS && "object" == typeof e && e.exports,
          s = !r.JS_SHA3_NO_ARRAY_BUFFER && "undefined" != typeof ArrayBuffer,
          o = "0123456789abcdef".split(""),
          i = [4, 1024, 262144, 67108864],
          c = [0, 8, 16, 24],
          u = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649, 0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0, 2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771, 2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648, 2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648],
          d = [224, 256, 384, 512],
          f = [128, 256],
          l = ["hex", "buffer", "arrayBuffer", "array"],
          h = {
        128: 168,
        256: 136
      };
      !r.JS_SHA3_NO_NODE_JS && Array.isArray || (Array.isArray = function (e) {
        return "[object Array]" === Object.prototype.toString.call(e);
      });

      for (var p = function p(e, t, a) {
        return function (r) {
          return new B(e, t, e).update(r)[a]();
        };
      }, b = function b(e, t, a) {
        return function (r, n) {
          return new B(e, t, n).update(r)[a]();
        };
      }, m = function m(e, t, a) {
        return function (t, r, n, s) {
          return A["cshake" + e].update(t, r, n, s)[a]();
        };
      }, y = function y(e, t, a) {
        return function (t, r, n, s) {
          return A["kmac" + e].update(t, r, n, s)[a]();
        };
      }, v = function v(e, t, a, r) {
        for (var n = 0; n < l.length; ++n) {
          var s = l[n];
          e[s] = t(a, r, s);
        }

        return e;
      }, _ = function _(e, t) {
        var a = p(e, t, "hex");
        return a.create = function () {
          return new B(e, t, e);
        }, a.update = function (e) {
          return a.create().update(e);
        }, v(a, p, e, t);
      }, g = [{
        name: "keccak",
        padding: [1, 256, 65536, 16777216],
        bits: d,
        createMethod: _
      }, {
        name: "sha3",
        padding: [6, 1536, 393216, 100663296],
        bits: d,
        createMethod: _
      }, {
        name: "shake",
        padding: [31, 7936, 2031616, 520093696],
        bits: f,
        createMethod: function createMethod(e, t) {
          var a = b(e, t, "hex");
          return a.create = function (a) {
            return new B(e, t, a);
          }, a.update = function (e, t) {
            return a.create(t).update(e);
          }, v(a, b, e, t);
        }
      }, {
        name: "cshake",
        padding: i,
        bits: f,
        createMethod: function createMethod(e, t) {
          var a = h[e],
              r = m(e, 0, "hex");
          return r.create = function (r, n, s) {
            return n || s ? new B(e, t, r).bytepad([n, s], a) : A["shake" + e].create(r);
          }, r.update = function (e, t, a, n) {
            return r.create(t, a, n).update(e);
          }, v(r, m, e, t);
        }
      }, {
        name: "kmac",
        padding: i,
        bits: f,
        createMethod: function createMethod(e, t) {
          var a = h[e],
              r = y(e, 0, "hex");
          return r.create = function (r, n, s) {
            return new k(e, t, n).bytepad(["KMAC", s], a).bytepad([r], a);
          }, r.update = function (e, t, a, n) {
            return r.create(e, a, n).update(t);
          }, v(r, y, e, t);
        }
      }], A = {}, w = [], T = 0; T < g.length; ++T) {
        for (var x = g[T], D = x.bits, C = 0; C < D.length; ++C) {
          var S = x.name + "_" + D[C];

          if (w.push(S), A[S] = x.createMethod(D[C], x.padding), "sha3" !== x.name) {
            var E = x.name + D[C];
            w.push(E), A[E] = A[S];
          }
        }
      }

      function B(e, t, a) {
        this.blocks = [], this.s = [], this.padding = t, this.outputBits = a, this.reset = !0, this.block = 0, this.start = 0, this.blockCount = 1600 - (e << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = a >> 5, this.extraBytes = (31 & a) >> 3;

        for (var r = 0; r < 50; ++r) {
          this.s[r] = 0;
        }
      }

      function k(e, t, a) {
        B.call(this, e, t, a);
      }

      B.prototype.update = function (e) {
        var t = "string" != typeof e;
        t && e.constructor === r.ArrayBuffer && (e = new Uint8Array(e));
        var a = e.length;
        if (t && ("number" != typeof a || !Array.isArray(e) && (!s || !ArrayBuffer.isView(e)))) throw "input is invalid type";

        for (var n, o, i = this.blocks, u = this.byteCount, d = this.blockCount, f = 0, l = this.s; f < a;) {
          if (this.reset) for (this.reset = !1, i[0] = this.block, n = 1; n < d + 1; ++n) {
            i[n] = 0;
          }
          if (t) for (n = this.start; f < a && n < u; ++f) {
            i[n >> 2] |= e[f] << c[3 & n++];
          } else for (n = this.start; f < a && n < u; ++f) {
            (o = e.charCodeAt(f)) < 128 ? i[n >> 2] |= o << c[3 & n++] : o < 2048 ? (i[n >> 2] |= (192 | o >> 6) << c[3 & n++], i[n >> 2] |= (128 | 63 & o) << c[3 & n++]) : o < 55296 || o >= 57344 ? (i[n >> 2] |= (224 | o >> 12) << c[3 & n++], i[n >> 2] |= (128 | o >> 6 & 63) << c[3 & n++], i[n >> 2] |= (128 | 63 & o) << c[3 & n++]) : (o = 65536 + ((1023 & o) << 10 | 1023 & e.charCodeAt(++f)), i[n >> 2] |= (240 | o >> 18) << c[3 & n++], i[n >> 2] |= (128 | o >> 12 & 63) << c[3 & n++], i[n >> 2] |= (128 | o >> 6 & 63) << c[3 & n++], i[n >> 2] |= (128 | 63 & o) << c[3 & n++]);
          }

          if (this.lastByteIndex = n, n >= u) {
            for (this.start = n - u, this.block = i[d], n = 0; n < d; ++n) {
              l[n] ^= i[n];
            }

            R(l), this.reset = !0;
          } else this.start = n;
        }

        return this;
      }, B.prototype.encode = function (e, t) {
        var a = 255 & e,
            r = 1,
            n = [a];

        for (a = 255 & (e >>= 8); a > 0;) {
          n.unshift(a), a = 255 & (e >>= 8), ++r;
        }

        return t ? n.push(r) : n.unshift(r), this.update(n), n.length;
      }, B.prototype.encodeString = function (e) {
        var t = "string" != typeof (e = e || "");
        t && e.constructor === r.ArrayBuffer && (e = new Uint8Array(e));
        var a = e.length;
        if (t && ("number" != typeof a || !Array.isArray(e) && (!s || !ArrayBuffer.isView(e)))) throw "input is invalid type";
        var n = 0;
        if (t) n = a;else for (var o = 0; o < e.length; ++o) {
          var i = e.charCodeAt(o);
          i < 128 ? n += 1 : i < 2048 ? n += 2 : i < 55296 || i >= 57344 ? n += 3 : (i = 65536 + ((1023 & i) << 10 | 1023 & e.charCodeAt(++o)), n += 4);
        }
        return n += this.encode(8 * n), this.update(e), n;
      }, B.prototype.bytepad = function (e, t) {
        for (var a = this.encode(t), r = 0; r < e.length; ++r) {
          a += this.encodeString(e[r]);
        }

        var n = t - a % t,
            s = [];
        return s.length = n, this.update(s), this;
      }, B.prototype.finalize = function () {
        var e = this.blocks,
            t = this.lastByteIndex,
            a = this.blockCount,
            r = this.s;
        if (e[t >> 2] |= this.padding[3 & t], this.lastByteIndex === this.byteCount) for (e[0] = e[a], t = 1; t < a + 1; ++t) {
          e[t] = 0;
        }

        for (e[a - 1] |= 2147483648, t = 0; t < a; ++t) {
          r[t] ^= e[t];
        }

        R(r);
      }, B.prototype.toString = B.prototype.hex = function () {
        this.finalize();

        for (var e, t = this.blockCount, a = this.s, r = this.outputBlocks, n = this.extraBytes, s = 0, i = 0, c = ""; i < r;) {
          for (s = 0; s < t && i < r; ++s, ++i) {
            e = a[s], c += o[e >> 4 & 15] + o[15 & e] + o[e >> 12 & 15] + o[e >> 8 & 15] + o[e >> 20 & 15] + o[e >> 16 & 15] + o[e >> 28 & 15] + o[e >> 24 & 15];
          }

          i % t == 0 && (R(a), s = 0);
        }

        return n && (e = a[s], n > 0 && (c += o[e >> 4 & 15] + o[15 & e]), n > 1 && (c += o[e >> 12 & 15] + o[e >> 8 & 15]), n > 2 && (c += o[e >> 20 & 15] + o[e >> 16 & 15])), c;
      }, B.prototype.arrayBuffer = function () {
        this.finalize();
        var e,
            t = this.blockCount,
            a = this.s,
            r = this.outputBlocks,
            n = this.extraBytes,
            s = 0,
            o = 0,
            i = this.outputBits >> 3;
        e = n ? new ArrayBuffer(r + 1 << 2) : new ArrayBuffer(i);

        for (var c = new Uint32Array(e); o < r;) {
          for (s = 0; s < t && o < r; ++s, ++o) {
            c[o] = a[s];
          }

          o % t == 0 && R(a);
        }

        return n && (c[s] = a[s], e = e.slice(0, i)), e;
      }, B.prototype.buffer = B.prototype.arrayBuffer, B.prototype.digest = B.prototype.array = function () {
        this.finalize();

        for (var e, t, a = this.blockCount, r = this.s, n = this.outputBlocks, s = this.extraBytes, o = 0, i = 0, c = []; i < n;) {
          for (o = 0; o < a && i < n; ++o, ++i) {
            e = i << 2, t = r[o], c[e] = 255 & t, c[e + 1] = t >> 8 & 255, c[e + 2] = t >> 16 & 255, c[e + 3] = t >> 24 & 255;
          }

          i % a == 0 && R(r);
        }

        return s && (e = i << 2, t = r[o], s > 0 && (c[e] = 255 & t), s > 1 && (c[e + 1] = t >> 8 & 255), s > 2 && (c[e + 2] = t >> 16 & 255)), c;
      }, k.prototype = new B(), k.prototype.finalize = function () {
        return this.encode(this.outputBits, !0), B.prototype.finalize.call(this);
      };

      var R = function R(e) {
        var t, a, r, n, s, o, i, c, d, f, l, h, p, b, m, y, v, _, g, A, w, T, x, D, C, S, E, B, k, R, W, I, N, M, P, L, O, F, j, G, V, U, H, z, K, q, Y, Z, J, X, $, Q, ee, te, ae, re, ne, se, oe, ie, ce, ue, de;

        for (r = 0; r < 48; r += 2) {
          n = e[0] ^ e[10] ^ e[20] ^ e[30] ^ e[40], s = e[1] ^ e[11] ^ e[21] ^ e[31] ^ e[41], o = e[2] ^ e[12] ^ e[22] ^ e[32] ^ e[42], i = e[3] ^ e[13] ^ e[23] ^ e[33] ^ e[43], c = e[4] ^ e[14] ^ e[24] ^ e[34] ^ e[44], d = e[5] ^ e[15] ^ e[25] ^ e[35] ^ e[45], f = e[6] ^ e[16] ^ e[26] ^ e[36] ^ e[46], l = e[7] ^ e[17] ^ e[27] ^ e[37] ^ e[47], t = (h = e[8] ^ e[18] ^ e[28] ^ e[38] ^ e[48]) ^ (o << 1 | i >>> 31), a = (p = e[9] ^ e[19] ^ e[29] ^ e[39] ^ e[49]) ^ (i << 1 | o >>> 31), e[0] ^= t, e[1] ^= a, e[10] ^= t, e[11] ^= a, e[20] ^= t, e[21] ^= a, e[30] ^= t, e[31] ^= a, e[40] ^= t, e[41] ^= a, t = n ^ (c << 1 | d >>> 31), a = s ^ (d << 1 | c >>> 31), e[2] ^= t, e[3] ^= a, e[12] ^= t, e[13] ^= a, e[22] ^= t, e[23] ^= a, e[32] ^= t, e[33] ^= a, e[42] ^= t, e[43] ^= a, t = o ^ (f << 1 | l >>> 31), a = i ^ (l << 1 | f >>> 31), e[4] ^= t, e[5] ^= a, e[14] ^= t, e[15] ^= a, e[24] ^= t, e[25] ^= a, e[34] ^= t, e[35] ^= a, e[44] ^= t, e[45] ^= a, t = c ^ (h << 1 | p >>> 31), a = d ^ (p << 1 | h >>> 31), e[6] ^= t, e[7] ^= a, e[16] ^= t, e[17] ^= a, e[26] ^= t, e[27] ^= a, e[36] ^= t, e[37] ^= a, e[46] ^= t, e[47] ^= a, t = f ^ (n << 1 | s >>> 31), a = l ^ (s << 1 | n >>> 31), e[8] ^= t, e[9] ^= a, e[18] ^= t, e[19] ^= a, e[28] ^= t, e[29] ^= a, e[38] ^= t, e[39] ^= a, e[48] ^= t, e[49] ^= a, b = e[0], m = e[1], q = e[11] << 4 | e[10] >>> 28, Y = e[10] << 4 | e[11] >>> 28, B = e[20] << 3 | e[21] >>> 29, k = e[21] << 3 | e[20] >>> 29, ie = e[31] << 9 | e[30] >>> 23, ce = e[30] << 9 | e[31] >>> 23, U = e[40] << 18 | e[41] >>> 14, H = e[41] << 18 | e[40] >>> 14, M = e[2] << 1 | e[3] >>> 31, P = e[3] << 1 | e[2] >>> 31, y = e[13] << 12 | e[12] >>> 20, v = e[12] << 12 | e[13] >>> 20, Z = e[22] << 10 | e[23] >>> 22, J = e[23] << 10 | e[22] >>> 22, R = e[33] << 13 | e[32] >>> 19, W = e[32] << 13 | e[33] >>> 19, ue = e[42] << 2 | e[43] >>> 30, de = e[43] << 2 | e[42] >>> 30, te = e[5] << 30 | e[4] >>> 2, ae = e[4] << 30 | e[5] >>> 2, L = e[14] << 6 | e[15] >>> 26, O = e[15] << 6 | e[14] >>> 26, _ = e[25] << 11 | e[24] >>> 21, g = e[24] << 11 | e[25] >>> 21, X = e[34] << 15 | e[35] >>> 17, $ = e[35] << 15 | e[34] >>> 17, I = e[45] << 29 | e[44] >>> 3, N = e[44] << 29 | e[45] >>> 3, D = e[6] << 28 | e[7] >>> 4, C = e[7] << 28 | e[6] >>> 4, re = e[17] << 23 | e[16] >>> 9, ne = e[16] << 23 | e[17] >>> 9, F = e[26] << 25 | e[27] >>> 7, j = e[27] << 25 | e[26] >>> 7, A = e[36] << 21 | e[37] >>> 11, w = e[37] << 21 | e[36] >>> 11, Q = e[47] << 24 | e[46] >>> 8, ee = e[46] << 24 | e[47] >>> 8, z = e[8] << 27 | e[9] >>> 5, K = e[9] << 27 | e[8] >>> 5, S = e[18] << 20 | e[19] >>> 12, E = e[19] << 20 | e[18] >>> 12, se = e[29] << 7 | e[28] >>> 25, oe = e[28] << 7 | e[29] >>> 25, G = e[38] << 8 | e[39] >>> 24, V = e[39] << 8 | e[38] >>> 24, T = e[48] << 14 | e[49] >>> 18, x = e[49] << 14 | e[48] >>> 18, e[0] = b ^ ~y & _, e[1] = m ^ ~v & g, e[10] = D ^ ~S & B, e[11] = C ^ ~E & k, e[20] = M ^ ~L & F, e[21] = P ^ ~O & j, e[30] = z ^ ~q & Z, e[31] = K ^ ~Y & J, e[40] = te ^ ~re & se, e[41] = ae ^ ~ne & oe, e[2] = y ^ ~_ & A, e[3] = v ^ ~g & w, e[12] = S ^ ~B & R, e[13] = E ^ ~k & W, e[22] = L ^ ~F & G, e[23] = O ^ ~j & V, e[32] = q ^ ~Z & X, e[33] = Y ^ ~J & $, e[42] = re ^ ~se & ie, e[43] = ne ^ ~oe & ce, e[4] = _ ^ ~A & T, e[5] = g ^ ~w & x, e[14] = B ^ ~R & I, e[15] = k ^ ~W & N, e[24] = F ^ ~G & U, e[25] = j ^ ~V & H, e[34] = Z ^ ~X & Q, e[35] = J ^ ~$ & ee, e[44] = se ^ ~ie & ue, e[45] = oe ^ ~ce & de, e[6] = A ^ ~T & b, e[7] = w ^ ~x & m, e[16] = R ^ ~I & D, e[17] = W ^ ~N & C, e[26] = G ^ ~U & M, e[27] = V ^ ~H & P, e[36] = X ^ ~Q & z, e[37] = $ ^ ~ee & K, e[46] = ie ^ ~ue & te, e[47] = ce ^ ~de & ae, e[8] = T ^ ~b & y, e[9] = x ^ ~m & v, e[18] = I ^ ~D & S, e[19] = N ^ ~C & E, e[28] = U ^ ~M & L, e[29] = H ^ ~P & O, e[38] = Q ^ ~z & q, e[39] = ee ^ ~K & Y, e[48] = ue ^ ~te & re, e[49] = de ^ ~ae & ne, e[0] ^= u[r], e[1] ^= u[r + 1];
        }
      };

      if (n) e.exports = A;else for (T = 0; T < w.length; ++T) {
        r[w[T]] = A[w[T]];
      }
    }();
  }).call(this, a(
  /*! ./../../../../process/browser.js */
  9), a(
  /*! ./../../../../webpack/buildin/global.js */
  18));
},
/*!***************************************!*\
  !*** ./node_modules/ethashjs/util.js ***!
  \***************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (e) {
    var r = a(
    /*! ethereumjs-util */
    212),
        n = a(
    /*! miller-rabin */
    117),
        s = r.BN;
    t.params = {
      DATASET_BYTES_INIT: 1073741824,
      DATASET_BYTES_GROWTH: 8388608,
      CACHE_BYTES_INIT: 16777216,
      CACHE_BYTES_GROWTH: 131072,
      CACHE_MULTIPLIER: 1024,
      EPOCH_LENGTH: 3e4,
      MIX_BYTES: 128,
      HASH_BYTES: 64,
      DATASET_PARENTS: 256,
      CACHE_ROUNDS: 3,
      ACCESSES: 64,
      WORD_BYTES: 4
    }, t.getCacheSize = function (e) {
      var a = new n(),
          r = t.params.CACHE_BYTES_INIT + t.params.CACHE_BYTES_GROWTH * e;

      for (r -= t.params.HASH_BYTES; !a.test(new s(r / t.params.HASH_BYTES));) {
        r -= 2 * t.params.HASH_BYTES;
      }

      return r;
    }, t.getFullSize = function (e) {
      var a = new n(),
          r = t.params.DATASET_BYTES_INIT + t.params.DATASET_BYTES_GROWTH * e;

      for (r -= t.params.MIX_BYTES; !a.test(new s(r / t.params.MIX_BYTES));) {
        r -= 2 * t.params.MIX_BYTES;
      }

      return r;
    }, t.getEpoc = function (e) {
      return Math.floor(e / t.params.EPOCH_LENGTH);
    }, t.getSeed = function (e, t, a) {
      for (var n = t; n < a; n++) {
        e = r.sha3(e);
      }

      return e;
    };

    var o = t.fnv = function (e, t) {
      return ((16777216 * e | 0) + (403 * e | 0) ^ t) >>> 0;
    };

    t.fnvBuffer = function (t, a) {
      for (var r = new e(t.length), n = 0; n < t.length; n += 4) {
        r.writeUInt32LE(o(t.readUInt32LE(n), a.readUInt32LE(n)), n);
      }

      return r;
    }, t.bufReverse = function (t) {
      var a = t.length;

      for (var r = new e(a), n = 0; n < a; n++) {
        r[n] = t[a - n - 1];
      }

      return r;
    };
  }).call(this, a(
  /*! ./../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!***************************************************************!*\
  !*** ./node_modules/ethashjs/node_modules/async/lib/async.js ***!
  \***************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (a, r, n) {
    var s;
    /*!
     * async
     * https://github.com/caolan/async
     *
     * Copyright 2010-2014 Caolan McMahon
     * Released under the MIT license
     */

    !function () {
      var o,
          i = {};

      function c() {}

      function u(e) {
        return e;
      }

      function d(e) {
        return !!e;
      }

      function f(e) {
        return !e;
      }

      var l = "object" == typeof self && self.self === self && self || "object" == typeof a && a.global === a && a || this;

      function h(e) {
        return function () {
          if (null === e) throw new Error("Callback was already called.");
          e.apply(this, arguments), e = null;
        };
      }

      function p(e) {
        return function () {
          null !== e && (e.apply(this, arguments), e = null);
        };
      }

      null != l && (o = l.async), i.noConflict = function () {
        return l.async = o, i;
      };

      var b = Object.prototype.toString,
          m = Array.isArray || function (e) {
        return "[object Array]" === b.call(e);
      };

      function y(e) {
        return m(e) || "number" == typeof e.length && e.length >= 0 && e.length % 1 == 0;
      }

      function v(e, t) {
        for (var a = -1, r = e.length; ++a < r;) {
          t(e[a], a, e);
        }
      }

      function _(e, t) {
        for (var a = -1, r = e.length, n = Array(r); ++a < r;) {
          n[a] = t(e[a], a, e);
        }

        return n;
      }

      function g(e) {
        return _(Array(e), function (e, t) {
          return t;
        });
      }

      function A(e, t, a) {
        return v(e, function (e, r, n) {
          a = t(a, e, r, n);
        }), a;
      }

      function w(e, t) {
        v(x(e), function (a) {
          t(e[a], a);
        });
      }

      function T(e, t) {
        for (var a = 0; a < e.length; a++) {
          if (e[a] === t) return a;
        }

        return -1;
      }

      var x = Object.keys || function (e) {
        var t = [];

        for (var a in e) {
          e.hasOwnProperty(a) && t.push(a);
        }

        return t;
      };

      function D(e) {
        var t,
            a,
            r = -1;
        return y(e) ? (t = e.length, function () {
          return ++r < t ? r : null;
        }) : (a = x(e), t = a.length, function () {
          return ++r < t ? a[r] : null;
        });
      }

      function C(e, t) {
        return t = null == t ? e.length - 1 : +t, function () {
          for (var a = Math.max(arguments.length - t, 0), r = Array(a), n = 0; n < a; n++) {
            r[n] = arguments[n + t];
          }

          switch (t) {
            case 0:
              return e.call(this, r);

            case 1:
              return e.call(this, arguments[0], r);
          }
        };
      }

      function S(e) {
        return function (t, a, r) {
          return e(t, r);
        };
      }

      var E = "function" == typeof r && r,
          B = E ? function (e) {
        E(e);
      } : function (e) {
        setTimeout(e, 0);
      };

      function k(e) {
        return function (t, a, r) {
          r = p(r || c);
          var n = D(t = t || []);
          if (e <= 0) return r(null);
          var s = !1,
              o = 0,
              i = !1;
          !function c() {
            if (s && o <= 0) return r(null);

            for (; o < e && !i;) {
              var u = n();
              if (null === u) return s = !0, void (o <= 0 && r(null));
              o += 1, a(t[u], u, h(function (e) {
                o -= 1, e ? (r(e), i = !0) : c();
              }));
            }
          }();
        };
      }

      function R(e) {
        return function (t, a, r) {
          return e(i.eachOf, t, a, r);
        };
      }

      function W(e) {
        return function (t, a, r, n) {
          return e(k(a), t, r, n);
        };
      }

      function I(e) {
        return function (t, a, r) {
          return e(i.eachOfSeries, t, a, r);
        };
      }

      function N(e, t, a, r) {
        r = p(r || c);
        var n = y(t = t || []) ? [] : {};
        e(t, function (e, t, r) {
          a(e, function (e, a) {
            n[t] = a, r(e);
          });
        }, function (e) {
          r(e, n);
        });
      }

      function M(e, t, a, r) {
        var n = [];
        e(t, function (e, t, r) {
          a(e, function (a) {
            a && n.push({
              index: t,
              value: e
            }), r();
          });
        }, function () {
          r(_(n.sort(function (e, t) {
            return e.index - t.index;
          }), function (e) {
            return e.value;
          }));
        });
      }

      function P(e, t, a, r) {
        M(e, t, function (e, t) {
          a(e, function (e) {
            t(!e);
          });
        }, r);
      }

      function L(e, t, a) {
        return function (r, n, s, o) {
          function i() {
            o && o(a(!1, void 0));
          }

          function c(e, r, n) {
            if (!o) return n();
            s(e, function (r) {
              o && t(r) && (o(a(!0, e)), o = s = !1), n();
            });
          }

          arguments.length > 3 ? e(r, n, c, i) : (o = s, s = n, e(r, c, i));
        };
      }

      function O(e, t) {
        return t;
      }

      function F(e, t, a) {
        a = a || c;
        var r = y(t) ? [] : {};
        e(t, function (e, t, a) {
          e(C(function (e, n) {
            n.length <= 1 && (n = n[0]), r[t] = n, a(e);
          }));
        }, function (e) {
          a(e, r);
        });
      }

      function j(e, t, a, r) {
        var n = [];
        e(t, function (e, t, r) {
          a(e, function (e, t) {
            n = n.concat(t || []), r(e);
          });
        }, function (e) {
          r(e, n);
        });
      }

      function G(e, t, a) {
        if (null == t) t = 1;else if (0 === t) throw new Error("Concurrency must not be zero");

        function r(e, t, a, r) {
          if (null != r && "function" != typeof r) throw new Error("task callback must be a function");
          if (e.started = !0, m(t) || (t = [t]), 0 === t.length && e.idle()) return i.setImmediate(function () {
            e.drain();
          });
          v(t, function (t) {
            var n = {
              data: t,
              callback: r || c
            };
            a ? e.tasks.unshift(n) : e.tasks.push(n), e.tasks.length === e.concurrency && e.saturated();
          }), i.setImmediate(e.process);
        }

        function n(e, t) {
          return function () {
            s -= 1;
            var a = !1,
                r = arguments;
            v(t, function (e) {
              v(o, function (t, r) {
                t !== e || a || (o.splice(r, 1), a = !0);
              }), e.callback.apply(e, r);
            }), e.tasks.length + s === 0 && e.drain(), e.process();
          };
        }

        var s = 0,
            o = [],
            u = {
          tasks: [],
          concurrency: t,
          payload: a,
          saturated: c,
          empty: c,
          drain: c,
          started: !1,
          paused: !1,
          push: function push(e, t) {
            r(u, e, !1, t);
          },
          kill: function kill() {
            u.drain = c, u.tasks = [];
          },
          unshift: function unshift(e, t) {
            r(u, e, !0, t);
          },
          process: function process() {
            for (; !u.paused && s < u.concurrency && u.tasks.length;) {
              var t = u.payload ? u.tasks.splice(0, u.payload) : u.tasks.splice(0, u.tasks.length),
                  a = _(t, function (e) {
                return e.data;
              });

              0 === u.tasks.length && u.empty(), s += 1, o.push(t[0]);
              var r = h(n(u, t));
              e(a, r);
            }
          },
          length: function length() {
            return u.tasks.length;
          },
          running: function running() {
            return s;
          },
          workersList: function workersList() {
            return o;
          },
          idle: function idle() {
            return u.tasks.length + s === 0;
          },
          pause: function pause() {
            u.paused = !0;
          },
          resume: function resume() {
            if (!1 !== u.paused) {
              u.paused = !1;

              for (var e = Math.min(u.concurrency, u.tasks.length), t = 1; t <= e; t++) {
                i.setImmediate(u.process);
              }
            }
          }
        };
        return u;
      }

      function V(e) {
        return C(function (t, a) {
          t.apply(null, a.concat([C(function (t, a) {
            "object" == typeof console && (t ? console.error && console.error(t) : console[e] && v(a, function (t) {
              console[e](t);
            }));
          })]));
        });
      }

      function U(e) {
        return function (t, a, r) {
          e(g(t), a, r);
        };
      }

      function H(e) {
        return C(function (t, a) {
          var r = C(function (a) {
            var r = this,
                n = a.pop();
            return e(t, function (e, t, n) {
              e.apply(r, a.concat([n]));
            }, n);
          });
          return a.length ? r.apply(this, a) : r;
        });
      }

      function z(e) {
        return C(function (t) {
          var a = t.pop();
          t.push(function () {
            var e = arguments;
            r ? i.setImmediate(function () {
              a.apply(null, e);
            }) : a.apply(null, e);
          });
          var r = !0;
          e.apply(this, t), r = !1;
        });
      }

      "object" == typeof n && "function" == typeof n.nextTick ? i.nextTick = n.nextTick : i.nextTick = B, i.setImmediate = E ? B : i.nextTick, i.forEach = i.each = function (e, t, a) {
        return i.eachOf(e, S(t), a);
      }, i.forEachSeries = i.eachSeries = function (e, t, a) {
        return i.eachOfSeries(e, S(t), a);
      }, i.forEachLimit = i.eachLimit = function (e, t, a, r) {
        return k(t)(e, S(a), r);
      }, i.forEachOf = i.eachOf = function (e, t, a) {
        a = p(a || c);

        for (var r, n = D(e = e || []), s = 0; null != (r = n());) {
          s += 1, t(e[r], r, h(o));
        }

        function o(e) {
          s--, e ? a(e) : null === r && s <= 0 && a(null);
        }

        0 === s && a(null);
      }, i.forEachOfSeries = i.eachOfSeries = function (e, t, a) {
        a = p(a || c);
        var r = D(e = e || []),
            n = r();
        !function s() {
          var o = !0;
          if (null === n) return a(null);
          t(e[n], n, h(function (e) {
            if (e) a(e);else {
              if (null === (n = r())) return a(null);
              o ? i.setImmediate(s) : s();
            }
          })), o = !1;
        }();
      }, i.forEachOfLimit = i.eachOfLimit = function (e, t, a, r) {
        k(t)(e, a, r);
      }, i.map = R(N), i.mapSeries = I(N), i.mapLimit = W(N), i.inject = i.foldl = i.reduce = function (e, t, a, r) {
        i.eachOfSeries(e, function (e, r, n) {
          a(t, e, function (e, a) {
            t = a, n(e);
          });
        }, function (e) {
          r(e, t);
        });
      }, i.foldr = i.reduceRight = function (e, t, a, r) {
        var n = _(e, u).reverse();

        i.reduce(n, t, a, r);
      }, i.transform = function (e, t, a, r) {
        3 === arguments.length && (r = a, a = t, t = m(e) ? [] : {}), i.eachOf(e, function (e, r, n) {
          a(t, e, r, n);
        }, function (e) {
          r(e, t);
        });
      }, i.select = i.filter = R(M), i.selectLimit = i.filterLimit = W(M), i.selectSeries = i.filterSeries = I(M), i.reject = R(P), i.rejectLimit = W(P), i.rejectSeries = I(P), i.any = i.some = L(i.eachOf, d, u), i.someLimit = L(i.eachOfLimit, d, u), i.all = i.every = L(i.eachOf, f, f), i.everyLimit = L(i.eachOfLimit, f, f), i.detect = L(i.eachOf, u, O), i.detectSeries = L(i.eachOfSeries, u, O), i.detectLimit = L(i.eachOfLimit, u, O), i.sortBy = function (e, t, a) {
        function r(e, t) {
          var a = e.criteria,
              r = t.criteria;
          return a < r ? -1 : a > r ? 1 : 0;
        }

        i.map(e, function (e, a) {
          t(e, function (t, r) {
            t ? a(t) : a(null, {
              value: e,
              criteria: r
            });
          });
        }, function (e, t) {
          if (e) return a(e);
          a(null, _(t.sort(r), function (e) {
            return e.value;
          }));
        });
      }, i.auto = function (e, t, a) {
        "function" == typeof arguments[1] && (a = t, t = null), a = p(a || c);
        var r = x(e),
            n = r.length;
        if (!n) return a(null);
        t || (t = n);
        var s = {},
            o = 0,
            u = !1,
            d = [];

        function f(e) {
          d.unshift(e);
        }

        function l(e) {
          var t = T(d, e);
          t >= 0 && d.splice(t, 1);
        }

        function h() {
          n--, v(d.slice(0), function (e) {
            e();
          });
        }

        f(function () {
          n || a(null, s);
        }), v(r, function (r) {
          if (!u) {
            for (var n, c = m(e[r]) ? e[r] : [e[r]], d = C(function (e, t) {
              if (o--, t.length <= 1 && (t = t[0]), e) {
                var n = {};
                w(s, function (e, t) {
                  n[t] = e;
                }), n[r] = t, u = !0, a(e, n);
              } else s[r] = t, i.setImmediate(h);
            }), p = c.slice(0, c.length - 1), b = p.length; b--;) {
              if (!(n = e[p[b]])) throw new Error("Has nonexistent dependency in " + p.join(", "));
              if (m(n) && T(n, r) >= 0) throw new Error("Has cyclic dependencies");
            }

            y() ? (o++, c[c.length - 1](d, s)) : f(function e() {
              y() && (o++, l(e), c[c.length - 1](d, s));
            });
          }

          function y() {
            return o < t && A(p, function (e, t) {
              return e && s.hasOwnProperty(t);
            }, !0) && !s.hasOwnProperty(r);
          }
        });
      }, i.retry = function (e, t, a) {
        var r = 5,
            n = 0,
            s = [],
            o = {
          times: r,
          interval: n
        };

        function c(e, t) {
          if ("number" == typeof t) e.times = parseInt(t, 10) || r;else {
            if ("object" != typeof t) throw new Error("Unsupported argument type for 'times': " + typeof t);
            e.times = parseInt(t.times, 10) || r, e.interval = parseInt(t.interval, 10) || n;
          }
        }

        var u = arguments.length;
        if (u < 1 || u > 3) throw new Error("Invalid arguments - must be either (task), (task, callback), (times, task) or (times, task, callback)");

        function d(e, t) {
          function a(e, a) {
            return function (r) {
              e(function (e, t) {
                r(!e || a, {
                  err: e,
                  result: t
                });
              }, t);
            };
          }

          function r(e) {
            return function (t) {
              setTimeout(function () {
                t(null);
              }, e);
            };
          }

          for (; o.times;) {
            var n = !(o.times -= 1);
            s.push(a(o.task, n)), !n && o.interval > 0 && s.push(r(o.interval));
          }

          i.series(s, function (t, a) {
            a = a[a.length - 1], (e || o.callback)(a.err, a.result);
          });
        }

        return u <= 2 && "function" == typeof e && (a = t, t = e), "function" != typeof e && c(o, e), o.callback = a, o.task = t, o.callback ? d() : d;
      }, i.waterfall = function (e, t) {
        if (t = p(t || c), !m(e)) {
          var a = new Error("First argument to waterfall must be an array of functions");
          return t(a);
        }

        if (!e.length) return t();
        !function e(a) {
          return C(function (r, n) {
            if (r) t.apply(null, [r].concat(n));else {
              var s = a.next();
              s ? n.push(e(s)) : n.push(t), z(a).apply(null, n);
            }
          });
        }(i.iterator(e))();
      }, i.parallel = function (e, t) {
        F(i.eachOf, e, t);
      }, i.parallelLimit = function (e, t, a) {
        F(k(t), e, a);
      }, i.series = function (e, t) {
        F(i.eachOfSeries, e, t);
      }, i.iterator = function (e) {
        return function t(a) {
          function r() {
            return e.length && e[a].apply(null, arguments), r.next();
          }

          return r.next = function () {
            return a < e.length - 1 ? t(a + 1) : null;
          }, r;
        }(0);
      }, i.apply = C(function (e, t) {
        return C(function (a) {
          return e.apply(null, t.concat(a));
        });
      }), i.concat = R(j), i.concatSeries = I(j), i.whilst = function (e, t, a) {
        if (a = a || c, e()) {
          var r = C(function (n, s) {
            n ? a(n) : e.apply(this, s) ? t(r) : a.apply(null, [null].concat(s));
          });
          t(r);
        } else a(null);
      }, i.doWhilst = function (e, t, a) {
        var r = 0;
        return i.whilst(function () {
          return ++r <= 1 || t.apply(this, arguments);
        }, e, a);
      }, i.until = function (e, t, a) {
        return i.whilst(function () {
          return !e.apply(this, arguments);
        }, t, a);
      }, i.doUntil = function (e, t, a) {
        return i.doWhilst(e, function () {
          return !t.apply(this, arguments);
        }, a);
      }, i.during = function (e, t, a) {
        a = a || c;

        var r = C(function (t, r) {
          t ? a(t) : (r.push(n), e.apply(this, r));
        }),
            n = function n(e, _n5) {
          e ? a(e) : _n5 ? t(r) : a(null);
        };

        e(n);
      }, i.doDuring = function (e, t, a) {
        var r = 0;
        i.during(function (e) {
          r++ < 1 ? e(null, !0) : t.apply(this, arguments);
        }, e, a);
      }, i.queue = function (e, t) {
        return G(function (t, a) {
          e(t[0], a);
        }, t, 1);
      }, i.priorityQueue = function (e, t) {
        function a(e, t) {
          return e.priority - t.priority;
        }

        var r = i.queue(e, t);
        return r.push = function (e, t, n) {
          !function (e, t, r, n) {
            if (null != n && "function" != typeof n) throw new Error("task callback must be a function");
            if (e.started = !0, m(t) || (t = [t]), 0 === t.length) return i.setImmediate(function () {
              e.drain();
            });
            v(t, function (t) {
              var s = {
                data: t,
                priority: r,
                callback: "function" == typeof n ? n : c
              };
              e.tasks.splice(function (e, t, a) {
                for (var r = -1, n = e.length - 1; r < n;) {
                  var s = r + (n - r + 1 >>> 1);
                  a(t, e[s]) >= 0 ? r = s : n = s - 1;
                }

                return r;
              }(e.tasks, s, a) + 1, 0, s), e.tasks.length === e.concurrency && e.saturated(), i.setImmediate(e.process);
            });
          }(r, e, t, n);
        }, delete r.unshift, r;
      }, i.cargo = function (e, t) {
        return G(e, 1, t);
      }, i.log = V("log"), i.dir = V("dir"), i.memoize = function (e, t) {
        var a = {},
            r = {},
            n = Object.prototype.hasOwnProperty;
        t = t || u;
        var s = C(function (s) {
          var o = s.pop(),
              c = t.apply(null, s);
          n.call(a, c) ? i.setImmediate(function () {
            o.apply(null, a[c]);
          }) : n.call(r, c) ? r[c].push(o) : (r[c] = [o], e.apply(null, s.concat([C(function (e) {
            a[c] = e;
            var t = r[c];
            delete r[c];

            for (var n = 0, s = t.length; n < s; n++) {
              t[n].apply(null, e);
            }
          })])));
        });
        return s.memo = a, s.unmemoized = e, s;
      }, i.unmemoize = function (e) {
        return function () {
          return (e.unmemoized || e).apply(null, arguments);
        };
      }, i.times = U(i.map), i.timesSeries = U(i.mapSeries), i.timesLimit = function (e, t, a, r) {
        return i.mapLimit(g(e), t, a, r);
      }, i.seq = function () {
        var e = arguments;
        return C(function (t) {
          var a = this,
              r = t[t.length - 1];
          "function" == typeof r ? t.pop() : r = c, i.reduce(e, t, function (e, t, r) {
            t.apply(a, e.concat([C(function (e, t) {
              r(e, t);
            })]));
          }, function (e, t) {
            r.apply(a, [e].concat(t));
          });
        });
      }, i.compose = function () {
        return i.seq.apply(null, Array.prototype.reverse.call(arguments));
      }, i.applyEach = H(i.eachOf), i.applyEachSeries = H(i.eachOfSeries), i.forever = function (e, t) {
        var a = h(t || c),
            r = z(e);
        !function e(t) {
          if (t) return a(t);
          r(e);
        }();
      }, i.ensureAsync = z, i.constant = C(function (e) {
        var t = [null].concat(e);
        return function (e) {
          return e.apply(this, t);
        };
      }), i.wrapSync = i.asyncify = function (e) {
        return C(function (t) {
          var a,
              r,
              n,
              s = t.pop();

          try {
            a = e.apply(this, t);
          } catch (e) {
            return s(e);
          }

          ("function" === (n = typeof (r = a)) || "object" === n && r) && "function" == typeof a.then ? a.then(function (e) {
            s(null, e);
          }).catch(function (e) {
            s(e.message ? e : new Error(e));
          }) : s(null, a);
        });
      }, e.exports ? e.exports = i : void 0 === (s = function () {
        return i;
      }.apply(t, [])) || (e.exports = s);
    }();
  }).call(this, a(
  /*! ./../../../../webpack/buildin/global.js */
  18), a(
  /*! ./../../../../timers-browserify/main.js */
  69).setImmediate, a(
  /*! ./../../../../process/browser.js */
  9));
},
/*!**********************************************!*\
  !*** ./node_modules/flow-stoplight/index.js ***!
  \**********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! events */
  41).EventEmitter,
      n = a(
  /*! util */
  23).inherits;

  function s() {
    r.call(this), this.isLocked = !0;
  }

  e.exports = s, n(s, r), s.prototype.go = function () {
    this.isLocked && (this.isLocked = !1, this.emit("unlock"));
  }, s.prototype.stop = function () {
    this.isLocked || (this.isLocked = !0, this.emit("lock"));
  }, s.prototype.await = function (e) {
    var t = this;
    t.isLocked ? t.once("unlock", e) : setTimeout(e);
  };
},
/*!********************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-common/dist/chains/index.js ***!
  \********************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.chains = {
    names: {
      1: "mainnet",
      3: "ropsten",
      4: "rinkeby",
      42: "kovan",
      6284: "goerli"
    },
    mainnet: a(
    /*! ./mainnet.json */
    577),
    ropsten: a(
    /*! ./ropsten.json */
    578),
    rinkeby: a(
    /*! ./rinkeby.json */
    579),
    kovan: a(
    /*! ./kovan.json */
    580),
    goerli: a(
    /*! ./goerli.json */
    581)
  };
},
/*!************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-common/dist/chains/mainnet.json ***!
  \************************************************************************************************/

/*! exports provided: name, chainId, networkId, comment, url, genesis, hardforks, bootstrapNodes, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"mainnet","chainId":1,"networkId":1,"comment":"The Ethereum main chain","url":"https://ethstats.net/","genesis":{"hash":"0xd4e56740f876aef8c010b86a40d5f56745a118d0906a34e69aec8c0db1cb8fa3","timestamp":null,"gasLimit":5000,"difficulty":17179869184,"nonce":"0x0000000000000042","extraData":"0x11bbe8db4e347b4e8c937c1c8370e4b5ed33adb3db69cbdb7a38e1e50b1b82fa","stateRoot":"0xd7f8974fb5ac78d9ac099b9ad5018bedc2ce0a72dad1827a1709da30580f0544"},"hardforks":[{"name":"chainstart","block":0,"consensus":"pow","finality":null},{"name":"homestead","block":1150000,"consensus":"pow","finality":null},{"name":"dao","block":1920000,"consensus":"pow","finality":null},{"name":"tangerineWhistle","block":2463000,"consensus":"pow","finality":null},{"name":"spuriousDragon","block":2675000,"consensus":"pow","finality":null},{"name":"byzantium","block":4370000,"consensus":"pow","finality":null},{"name":"constantinople","block":7280000,"consensus":"pow","finality":null},{"name":"petersburg","block":7280000,"consensus":"pow","finality":null},{"name":"istanbul","block":null,"consensus":"pow","finality":null}],"bootstrapNodes":[{"ip":"13.93.211.84","port":30303,"id":"3f1d12044546b76342d59d4a05532c14b85aa669704bfe1f864fe079415aa2c02d743e03218e57a33fb94523adb54032871a6c51b2cc5514cb7c7e35b3ed0a99","location":"US-WEST","comment":"Go Bootnode"},{"ip":"191.235.84.50","port":30303,"id":"78de8a0916848093c73790ead81d1928bec737d565119932b98c6b100d944b7a95e94f847f689fc723399d2e31129d182f7ef3863f2b4c820abbf3ab2722344d","location":"BR","comment":"Go Bootnode"},{"ip":"13.75.154.138","port":30303,"id":"158f8aab45f6d19c6cbf4a089c2670541a8da11978a2f90dbf6a502a4a3bab80d288afdbeb7ec0ef6d92de563767f3b1ea9e8e334ca711e9f8e2df5a0385e8e6","location":"AU","comment":"Go Bootnode"},{"ip":"52.74.57.123","port":30303,"id":"1118980bf48b0a3640bdba04e0fe78b1add18e1cd99bf22d53daac1fd9972ad650df52176e7c7d89d1114cfef2bc23a2959aa54998a46afcf7d91809f0855082","location":"SG","comment":"Go Bootnode"}]}');
},
/*!************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-common/dist/chains/ropsten.json ***!
  \************************************************************************************************/

/*! exports provided: name, chainId, networkId, comment, url, genesis, hardforks, bootstrapNodes, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"ropsten","chainId":3,"networkId":3,"comment":"PoW test network","url":"https://github.com/ethereum/ropsten","genesis":{"hash":"0x41941023680923e0fe4d74a34bdac8141f2540e3ae90623718e47d66d1ca4a2d","timestamp":null,"gasLimit":16777216,"difficulty":1048576,"nonce":"0x0000000000000042","extraData":"0x3535353535353535353535353535353535353535353535353535353535353535","stateRoot":"0x217b0bbcfb72e2d57e28f33cb361b9983513177755dc3f33ce3e7022ed62b77b"},"hardforks":[{"name":"chainstart","block":0,"consensus":"pow","finality":null},{"name":"homestead","block":0,"consensus":"pow","finality":null},{"name":"dao","block":null,"consensus":"pow","finality":null},{"name":"tangerineWhistle","block":0,"consensus":"pow","finality":null},{"name":"spuriousDragon","block":10,"consensus":"pow","finality":null},{"name":"byzantium","block":1700000,"consensus":"pow","finality":null},{"name":"constantinople","block":4230000,"consensus":"pow","finality":null},{"name":"petersburg","block":4939394,"consensus":"pow","finality":null},{"name":"istanbul","block":null,"consensus":"pow","finality":null}],"bootstrapNodes":[{"ip":"52.176.7.10","port":"30303","id":"30b7ab30a01c124a6cceca36863ece12c4f5fa68e3ba9b0b51407ccc002eeed3b3102d20a88f1c1d3c3154e2449317b8ef95090e77b312d5cc39354f86d5d606","network":"Ropsten","chainId":3,"location":"US","comment":"US-Azure geth"},{"ip":"52.176.100.77","port":"30303","id":"865a63255b3bb68023b6bffd5095118fcc13e79dcf014fe4e47e065c350c7cc72af2e53eff895f11ba1bbb6a2b33271c1116ee870f266618eadfc2e78aa7349c","network":"Ropsten","chainId":3,"location":"US","comment":"US-Azure parity"},{"ip":"52.232.243.152","port":"30303","id":"6332792c4a00e3e4ee0926ed89e0d27ef985424d97b6a45bf0f23e51f0dcb5e66b875777506458aea7af6f9e4ffb69f43f3778ee73c81ed9d34c51c4b16b0b0f","network":"Ropsten","chainId":3,"location":"US","comment":"Parity"},{"ip":"192.81.208.223","port":"30303","id":"94c15d1b9e2fe7ce56e458b9a3b672ef11894ddedd0c6f247e0f1d3487f52b66208fb4aeb8179fce6e3a749ea93ed147c37976d67af557508d199d9594c35f09","network":"Ropsten","chainId":3,"location":"US","comment":"@gpip"}]}');
},
/*!************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-common/dist/chains/rinkeby.json ***!
  \************************************************************************************************/

/*! exports provided: name, chainId, networkId, comment, url, genesis, hardforks, bootstrapNodes, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"rinkeby","chainId":4,"networkId":4,"comment":"PoA test network","url":"https://www.rinkeby.io","genesis":{"hash":"0x6341fd3daf94b748c72ced5a5b26028f2474f5f00d824504e4fa37a75767e177","timestamp":"0x58ee40ba","gasLimit":4700000,"difficulty":1,"nonce":"0x0000000000000000","extraData":"0x52657370656374206d7920617574686f7269746168207e452e436172746d616e42eb768f2244c8811c63729a21a3569731535f067ffc57839b00206d1ad20c69a1981b489f772031b279182d99e65703f0076e4812653aab85fca0f00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000","stateRoot":"0x53580584816f617295ea26c0e17641e0120cab2f0a8ffb53a866fd53aa8e8c2d"},"hardforks":[{"name":"chainstart","block":0,"consensus":"poa","finality":null},{"name":"homestead","block":1,"consensus":"poa","finality":null},{"name":"dao","block":null,"consensus":"poa","finality":null},{"name":"tangerineWhistle","block":2,"consensus":"poa","finality":null},{"name":"spuriousDragon","block":3,"consensus":"poa","finality":null},{"name":"byzantium","block":1035301,"consensus":"poa","finality":null},{"name":"constantinople","block":null,"consensus":"poa","finality":null},{"name":"istanbul","block":null,"consensus":"poa","finality":null}],"bootstrapNodes":[{"ip":"52.169.42.101","port":30303,"id":"a24ac7c5484ef4ed0c5eb2d36620ba4e4aa13b8c84684e1b4aab0cebea2ae45cb4d375b77eab56516d34bfbd3c1a833fc51296ff084b770b94fb9028c4d25ccf","location":"IE","comment":""},{"ip":"52.3.158.184","port":30303,"id":"343149e4feefa15d882d9fe4ac7d88f885bd05ebb735e547f12e12080a9fa07c8014ca6fd7f373123488102fe5e34111f8509cf0b7de3f5b44339c9f25e87cb8","location":"","comment":"INFURA"}]}');
},
/*!**********************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-common/dist/chains/kovan.json ***!
  \**********************************************************************************************/

/*! exports provided: name, chainId, networkId, comment, url, genesis, hardforks, bootstrapNodes, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"kovan","chainId":42,"networkId":42,"comment":"Parity PoA test network","url":"https://kovan-testnet.github.io/website/","genesis":{"hash":"0xa3c565fc15c7478862d50ccd6561e3c06b24cc509bf388941c25ea985ce32cb9","timestamp":null,"gasLimit":6000000,"difficulty":131072,"nonce":"0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000","extraData":"0x","stateRoot":"0x2480155b48a1cea17d67dbfdfaafe821c1d19cdd478c5358e8ec56dec24502b2"},"hardforks":[],"bootstrapNodes":[{"ip":"40.71.221.215","port":30303,"id":"56abaf065581a5985b8c5f4f88bd202526482761ba10be9bfdcd14846dd01f652ec33fde0f8c0fd1db19b59a4c04465681fcef50e11380ca88d25996191c52de","location":"","comment":"Parity Bootnode"},{"ip":"52.166.117.77","port":30303,"id":"d07827483dc47b368eaf88454fb04b41b7452cf454e194e2bd4c14f98a3278fed5d819dbecd0d010407fc7688d941ee1e58d4f9c6354d3da3be92f55c17d7ce3","location":"","comment":"Parity Bootnode"},{"ip":"52.165.239.18","port":30303,"id":"8fa162563a8e5a05eef3e1cd5abc5828c71344f7277bb788a395cce4a0e30baf2b34b92fe0b2dbbba2313ee40236bae2aab3c9811941b9f5a7e8e90aaa27ecba","location":"","comment":"Parity Bootnode"},{"ip":"52.243.47.56","port":30303,"id":"7e2e7f00784f516939f94e22bdc6cf96153603ca2b5df1c7cc0f90a38e7a2f218ffb1c05b156835e8b49086d11fdd1b3e2965be16baa55204167aa9bf536a4d9","location":"","comment":"Parity Bootnode"},{"ip":"40.68.248.100","port":30303,"id":"0518a3d35d4a7b3e8c433e7ffd2355d84a1304ceb5ef349787b556197f0c87fad09daed760635b97d52179d645d3e6d16a37d2cc0a9945c2ddf585684beb39ac","location":"","comment":"Parity Bootnode"}]}');
},
/*!***********************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-common/dist/chains/goerli.json ***!
  \***********************************************************************************************/

/*! exports provided: name, chainId, networkId, comment, url, genesis, hardforks, bootstrapNodes, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"goerli","chainId":5,"networkId":5,"comment":"Cross-client PoA test network","url":"https://github.com/goerli/testnet","genesis":{"hash":"0xbf7e331f7f7c1dd2e05159666b3bf8bc7a8a3a9eb1d518969eab529dd9b88c1a","timestamp":"0x5c51a607","gasLimit":10485760,"difficulty":1,"nonce":"0x0000000000000000","extraData":"0x22466c6578692069732061207468696e6722202d204166726900000000000000e0a2bd4258d2768837baa26a28fe71dc079f84c70000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000","stateRoot":"0x5d6cded585e73c4e322c30c2f782a336316f17dd85a4863b9d838d2d4b8b3008"},"hardforks":[{"name":"chainstart","block":0,"consensus":"poa","finality":null},{"name":"homestead","block":0,"consensus":"poa","finality":null},{"name":"dao","block":0,"consensus":"poa","finality":null},{"name":"tangerineWhistle","block":0,"consensus":"poa","finality":null},{"name":"spuriousDragon","block":0,"consensus":"poa","finality":null},{"name":"byzantium","block":0,"consensus":"poa","finality":null},{"name":"constantinople","block":0,"consensus":"poa","finality":null},{"name":"petersburg","block":0,"consensus":"poa","finality":null},{"name":"istanbul","block":null,"consensus":"poa","finality":null}],"bootstrapNodes":[{"ip":"51.141.78.53","port":30303,"id":"011f758e6552d105183b1761c5e2dea0111bc20fd5f6422bc7f91e0fabbec9a6595caf6239b37feb773dddd3f87240d99d859431891e4a642cf2a0a9e6cbb98a","location":"","comment":"Source: https://github.com/goerli/testnet/blob/master/bootnodes.txt"},{"ip":"13.93.54.137","port":30303,"id":"176b9417f511d05b6b2cf3e34b756cf0a7096b3094572a8f6ef4cdcb9d1f9d00683bf0f83347eebdf3b81c3521c2332086d9592802230bf528eaf606a1d9677b","location":"","comment":"Source: https://github.com/goerli/testnet/blob/master/bootnodes.txt"},{"ip":"94.237.54.114","port":30313,"id":"46add44b9f13965f7b9875ac6b85f016f341012d84f975377573800a863526f4da19ae2c620ec73d11591fa9510e992ecc03ad0751f53cc02f7c7ed6d55c7291","location":"","comment":"Source: https://github.com/goerli/testnet/blob/master/bootnodes.txt"},{"ip":"52.64.155.147","port":30303,"id":"c1f8b7c2ac4453271fa07d8e9ecf9a2e8285aa0bd0c07df0131f47153306b0736fd3db8924e7a9bf0bed6b1d8d4f87362a71b033dc7c64547728d953e43e59b2","location":"","comment":"Source: https://github.com/goerli/testnet/blob/master/bootnodes.txt"},{"ip":"213.186.16.82","port":30303,"id":"f4a9c6ee28586009fb5a96c8af13a58ed6d8315a9eee4772212c1d4d9cebe5a8b8a78ea4434f318726317d04a3f531a1ef0420cf9752605a562cfe858c46e263","location":"","comment":"Source: https://github.com/goerli/testnet/blob/master/bootnodes.txt"}]}');
},
/*!***********************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-common/dist/hardforks/index.js ***!
  \***********************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.hardforks = [["chainstart", a(
  /*! ./chainstart.json */
  583)], ["homestead", a(
  /*! ./homestead.json */
  584)], ["dao", a(
  /*! ./dao.json */
  585)], ["tangerineWhistle", a(
  /*! ./tangerineWhistle.json */
  586)], ["spuriousDragon", a(
  /*! ./spuriousDragon.json */
  587)], ["byzantium", a(
  /*! ./byzantium.json */
  588)], ["constantinople", a(
  /*! ./constantinople.json */
  589)], ["petersburg", a(
  /*! ./petersburg.json */
  590)], ["istanbul", a(
  /*! ./istanbul.json */
  591)]];
},
/*!******************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-common/dist/hardforks/chainstart.json ***!
  \******************************************************************************************************/

/*! exports provided: name, comment, eip, status, gasConfig, gasPrices, vm, pow, casper, sharding, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"chainstart","comment":"Start of the Ethereum main chain","eip":{"url":"","status":""},"status":"","gasConfig":{"minGasLimit":{"v":5000,"d":"Minimum the gas limit may ever be"},"gasLimitBoundDivisor":{"v":1024,"d":"The bound divisor of the gas limit, used in update calculations"}},"gasPrices":{"base":{"v":2,"d":"Gas base cost, used e.g. for ChainID opcode (Istanbul)"},"tierStep":{"v":[0,2,3,5,8,10,20],"d":"Once per operation, for a selection of them"},"exp":{"v":10,"d":"Once per EXP instuction"},"expByte":{"v":10,"d":"Times ceil(log256(exponent)) for the EXP instruction"},"sha3":{"v":30,"d":"Once per SHA3 operation"},"sha3Word":{"v":6,"d":"Once per word of the SHA3 operation\'s data"},"sload":{"v":50,"d":"Once per SLOAD operation"},"sstoreSet":{"v":20000,"d":"Once per SSTORE operation if the zeroness changes from zero"},"sstoreReset":{"v":5000,"d":"Once per SSTORE operation if the zeroness does not change from zero"},"sstoreRefund":{"v":15000,"d":"Once per SSTORE operation if the zeroness changes to zero"},"jumpdest":{"v":1,"d":"Refunded gas, once per SSTORE operation if the zeroness changes to zero"},"log":{"v":375,"d":"Per LOG* operation"},"logData":{"v":8,"d":"Per byte in a LOG* operation\'s data"},"logTopic":{"v":375,"d":"Multiplied by the * of the LOG*, per LOG transaction. e.g. LOG0 incurs 0 * c_txLogTopicGas, LOG4 incurs 4 * c_txLogTopicGas"},"create":{"v":32000,"d":"Once per CREATE operation & contract-creation transaction"},"call":{"v":40,"d":"Once per CALL operation & message call transaction"},"callStipend":{"v":2300,"d":"Free gas given at beginning of call"},"callValueTransfer":{"v":9000,"d":"Paid for CALL when the value transfor is non-zero"},"callNewAccount":{"v":25000,"d":"Paid for CALL when the destination address didn\'t exist prior"},"selfdestructRefund":{"v":24000,"d":"Refunded following a selfdestruct operation"},"memory":{"v":3,"d":"Times the address of the (highest referenced byte in memory + 1). NOTE: referencing happens on read, write and in instructions such as RETURN and CALL"},"quadCoeffDiv":{"v":512,"d":"Divisor for the quadratic particle of the memory cost equation"},"createData":{"v":200,"d":""},"tx":{"v":21000,"d":"Per transaction. NOTE: Not payable on data of calls between transactions"},"txCreation":{"v":32000,"d":"The cost of creating a contract via tx"},"txDataZero":{"v":4,"d":"Per byte of data attached to a transaction that equals zero. NOTE: Not payable on data of calls between transactions"},"txDataNonZero":{"v":68,"d":"Per byte of data attached to a transaction that is not equal to zero. NOTE: Not payable on data of calls between transactions"},"copy":{"v":3,"d":"Multiplied by the number of 32-byte words that are copied (round up) for any *COPY operation and added"},"ecRecover":{"v":3000,"d":""},"sha256":{"v":60,"d":""},"sha256Word":{"v":12,"d":""},"ripemd160":{"v":600,"d":""},"ripemd160Word":{"v":120,"d":""},"identity":{"v":15,"d":""},"identityWord":{"v":3,"d":""}},"vm":{"stackLimit":{"v":1024,"d":"Maximum size of VM stack allowed"},"callCreateDepth":{"v":1024,"d":"Maximum depth of call/create stack"},"maxExtraDataSize":{"v":32,"d":"Maximum size extra data may be after Genesis"}},"pow":{"minimumDifficulty":{"v":131072,"d":"The minimum that the difficulty may ever be"},"difficultyBoundDivisor":{"v":2048,"d":"The bound divisor of the difficulty, used in the update calculations"},"durationLimit":{"v":13,"d":"The decision boundary on the blocktime duration used to determine whether difficulty should go up or not"},"epochDuration":{"v":30000,"d":"Duration between proof-of-work epochs"},"timebombPeriod":{"v":100000,"d":"Exponential difficulty timebomb period"},"minerReward":{"v":"5000000000000000000","d":"the amount a miner get rewarded for mining a block"}},"casper":{},"sharding":{}}');
},
/*!*****************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-common/dist/hardforks/homestead.json ***!
  \*****************************************************************************************************/

/*! exports provided: name, comment, eip, gasConfig, gasPrices, vm, pow, casper, sharding, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"homestead","comment":"Homestead hardfork with protocol and network changes","eip":{"url":"https://eips.ethereum.org/EIPS/eip-606","status":"Final"},"gasConfig":{},"gasPrices":{},"vm":{},"pow":{},"casper":{},"sharding":{}}');
},
/*!***********************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-common/dist/hardforks/dao.json ***!
  \***********************************************************************************************/

/*! exports provided: name, comment, eip, gasConfig, gasPrices, vm, pow, casper, sharding, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"dao","comment":"DAO rescue hardfork","eip":{"url":"https://eips.ethereum.org/EIPS/eip-779","status":"Final"},"gasConfig":{},"gasPrices":{},"vm":{},"pow":{},"casper":{},"sharding":{}}');
},
/*!************************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-common/dist/hardforks/tangerineWhistle.json ***!
  \************************************************************************************************************/

/*! exports provided: name, comment, eip, gasConfig, gasPrices, vm, pow, casper, sharding, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"tangerineWhistle","comment":"Hardfork with gas cost changes for IO-heavy operations","eip":{"url":"https://eips.ethereum.org/EIPS/eip-608","status":"Final"},"gasConfig":{},"gasPrices":{"sload":{"v":200,"d":"Once per SLOAD operation"},"call":{"v":700,"d":"Once per CALL operation & message call transaction"}},"vm":{},"pow":{},"casper":{},"sharding":{}}');
},
/*!**********************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-common/dist/hardforks/spuriousDragon.json ***!
  \**********************************************************************************************************/

/*! exports provided: name, comment, eip, gasConfig, gasPrices, vm, pow, casper, sharding, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"spuriousDragon","comment":"HF with EIPs for simple replay attack protection, EXP cost increase, state trie clearing, contract code size limit","eip":{"url":"https://eips.ethereum.org/EIPS/eip-607","status":"Final"},"gasConfig":{},"gasPrices":{"expByte":{"v":50,"d":"Times ceil(log256(exponent)) for the EXP instruction"}},"vm":{"maxCodeSize":{"v":24576,"d":"Maximum length of contract code"}},"pow":{},"casper":{},"sharding":{}}');
},
/*!*****************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-common/dist/hardforks/byzantium.json ***!
  \*****************************************************************************************************/

/*! exports provided: name, comment, eip, gasConfig, gasPrices, vm, pow, casper, sharding, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"byzantium","comment":"Hardfork with new precompiles, instructions and other protocol changes","eip":{"url":"https://eips.ethereum.org/EIPS/eip-609","status":"Final"},"gasConfig":{},"gasPrices":{"modexpGquaddivisor":{"v":20,"d":"Gquaddivisor from modexp precompile for gas calculation"},"ecAdd":{"v":500,"d":"Gas costs for curve addition precompile"},"ecMul":{"v":40000,"d":"Gas costs for curve multiplication precompile"},"ecPairing":{"v":100000,"d":"Base gas costs for curve pairing precompile"},"ecPairingWord":{"v":80000,"d":"Gas costs regarding curve pairing precompile input length"}},"vm":{},"pow":{"minerReward":{"v":"3000000000000000000","d":"the amount a miner get rewarded for mining a block"}},"casper":{},"sharding":{}}');
},
/*!**********************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-common/dist/hardforks/constantinople.json ***!
  \**********************************************************************************************************/

/*! exports provided: name, comment, eip, gasConfig, gasPrices, vm, pow, casper, sharding, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"constantinople","comment":"Postponed hardfork including EIP-1283 (SSTORE gas metering changes)","eip":{"url":"https://eips.ethereum.org/EIPS/eip-1013","status":"Final"},"gasConfig":{},"gasPrices":{"netSstoreNoopGas":{"v":200,"d":"Once per SSTORE operation if the value doesn\'t change"},"netSstoreInitGas":{"v":20000,"d":"Once per SSTORE operation from clean zero"},"netSstoreCleanGas":{"v":5000,"d":"Once per SSTORE operation from clean non-zero"},"netSstoreDirtyGas":{"v":200,"d":"Once per SSTORE operation from dirty"},"netSstoreClearRefund":{"v":15000,"d":"Once per SSTORE operation for clearing an originally existing storage slot"},"netSstoreResetRefund":{"v":4800,"d":"Once per SSTORE operation for resetting to the original non-zero value"},"netSstoreResetClearRefund":{"v":19800,"d":"Once per SSTORE operation for resetting to the original zero value"}},"vm":{},"pow":{"minerReward":{"v":"2000000000000000000","d":"The amount a miner gets rewarded for mining a block"}},"casper":{},"sharding":{}}');
},
/*!******************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-common/dist/hardforks/petersburg.json ***!
  \******************************************************************************************************/

/*! exports provided: name, comment, eip, gasConfig, gasPrices, vm, pow, casper, sharding, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"petersburg","comment":"Aka constantinopleFix, removes EIP-1283, activate together with or after constantinople","eip":{"url":"https://github.com/ethereum/EIPs/pull/1716","status":"Draft"},"gasConfig":{},"gasPrices":{"netSstoreNoopGas":{"v":null,"d":"Removed along EIP-1283"},"netSstoreInitGas":{"v":null,"d":"Removed along EIP-1283"},"netSstoreCleanGas":{"v":null,"d":"Removed along EIP-1283"},"netSstoreDirtyGas":{"v":null,"d":"Removed along EIP-1283"},"netSstoreClearRefund":{"v":null,"d":"Removed along EIP-1283"},"netSstoreResetRefund":{"v":null,"d":"Removed along EIP-1283"},"netSstoreResetClearRefund":{"v":null,"d":"Removed along EIP-1283"}},"vm":{},"pow":{},"casper":{},"sharding":{}}');
},
/*!****************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-common/dist/hardforks/istanbul.json ***!
  \****************************************************************************************************/

/*! exports provided: name, comment, eip, gasConfig, gasPrices, vm, pow, casper, sharding, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"name":"istanbul","comment":"HF targeted for October 2019 following the Constantinople/Petersburg HF","eip":{"url":"https://eips.ethereum.org/EIPS/eip-1679","status":"Draft"},"gasConfig":{},"gasPrices":{"blake2Round":{"v":1,"d":"Gas cost per round for the Blake2 F precompile"},"ecAdd":{"v":150,"d":"Gas costs for curve addition precompile"},"ecMul":{"v":6000,"d":"Gas costs for curve multiplication precompile"},"ecPairing":{"v":45000,"d":"Base gas costs for curve pairing precompile"},"ecPairingWord":{"v":34000,"d":"Gas costs regarding curve pairing precompile input length"},"txDataNonZero":{"v":16,"d":"Per byte of data attached to a transaction that is not equal to zero. NOTE: Not payable on data of calls between transactions"},"sstoreSentryGasEIP2200":{"v":2300,"d":"Minimum gas required to be present for an SSTORE call, not consumed"},"sstoreNoopGasEIP2200":{"v":800,"d":"Once per SSTORE operation if the value doesn\'t change"},"sstoreDirtyGasEIP2200":{"v":800,"d":"Once per SSTORE operation if a dirty value is changed"},"sstoreInitGasEIP2200":{"v":20000,"d":"Once per SSTORE operation from clean zero to non-zero"},"sstoreInitRefundEIP2200":{"v":19200,"d":"Once per SSTORE operation for resetting to the original zero value"},"sstoreCleanGasEIP2200":{"v":5000,"d":"Once per SSTORE operation from clean non-zero to something else"},"sstoreCleanRefundEIP2200":{"v":4200,"d":"Once per SSTORE operation for resetting to the original non-zero value"},"sstoreClearRefundEIP2200":{"v":15000,"d":"Once per SSTORE operation for clearing an originally existing storage slot"}},"vm":{},"pow":{},"casper":{},"sharding":{}}');
},
/*!***************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-vm/dist/state/index.js ***!
  \***************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = a(
  /*! ./stateManager */
  593);
  t.StateManager = r.default;
},
/*!**********************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-vm/dist/state/stateManager.js ***!
  \**********************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = a(
    /*! core-js-pure/es/set */
    594),
        n = a(
    /*! merkle-patricia-tree/secure.js */
    231),
        s = a(
    /*! async */
    73),
        o = a(
    /*! ethereumjs-util */
    29),
        i = a(
    /*! bn.js */
    5),
        c = a(
    /*! rlp */
    21),
        u = a(
    /*! ethereumjs-common */
    214),
        d = a(
    /*! ethereumjs-common/dist/genesisStates */
    634),
        f = a(
    /*! ethereumjs-account */
    72),
        l = a(
    /*! ./cache */
    640),
        h = function () {
      function t(e) {
        void 0 === e && (e = {});
        var t = e.common;
        t || (t = new u.default("mainnet", "petersburg")), this._common = t, this._trie = e.trie || new n(), this._storageTries = {}, this._cache = new l.default(this._trie), this._touched = new r(), this._touchedStack = [], this._checkpointCount = 0, this._originalStorageCache = new Map();
      }

      return t.prototype.copy = function () {
        return new t({
          trie: this._trie.copy(),
          common: this._common
        });
      }, t.prototype.getAccount = function (e, t) {
        this._cache.getOrLoad(e, t);
      }, t.prototype.putAccount = function (e, t, a) {
        this._cache.put(e, t), this._touched.add(e.toString("hex")), a();
      }, t.prototype.putContractCode = function (e, t, a) {
        var r = this;
        this.getAccount(e, function (n, s) {
          if (n) return a(n);
          s.setCode(r._trie, t, function (t) {
            if (t) return a(t);
            r.putAccount(e, s, a);
          });
        });
      }, t.prototype.getContractCode = function (e, t) {
        var a = this;
        this.getAccount(e, function (e, r) {
          if (e) return t(e);
          r.getCode(a._trie, t);
        });
      }, t.prototype._lookupStorageTrie = function (e, t) {
        var a = this;
        this.getAccount(e, function (e, r) {
          if (e) return t(e);

          var n = a._trie.copy();

          n.root = r.stateRoot, n._checkpoints = [], t(null, n);
        });
      }, t.prototype._getStorageTrie = function (e, t) {
        var a = this._storageTries[e.toString("hex")];

        if (a) return t(null, a);

        this._lookupStorageTrie(e, t);
      }, t.prototype.getContractStorage = function (e, t, a) {
        if (32 !== t.length) return a(new Error("Storage key must be 32 bytes long"));

        this._getStorageTrie(e, function (e, r) {
          if (e) return a(e);
          r.get(t, function (e, t) {
            if (e) return a(e);
            var r = c.decode(t);
            a(null, r);
          });
        });
      }, t.prototype.getOriginalContractStorage = function (e, t, a) {
        if (32 !== t.length) return a(new Error("Storage key must be 32 bytes long"));
        var r,
            n = e.toString("hex"),
            s = t.toString("hex");
        this._originalStorageCache.has(n) ? r = this._originalStorageCache.get(n) : (r = new Map(), this._originalStorageCache.set(n, r)), r.has(s) ? a(null, r.get(s)) : this.getContractStorage(e, t, function (e, t) {
          if (e) return a(e);
          r.set(s, t), a(null, t);
        });
      }, t.prototype._modifyContractStorage = function (e, t, a) {
        var r = this;

        this._getStorageTrie(e, function (n, s) {
          if (n) return a(n);
          t(s, function (t) {
            if (t) return a(t);
            r._storageTries[e.toString("hex")] = s;

            var n = r._cache.get(e);

            n.stateRoot = s.root, r.putAccount(e, n, a), r._touched.add(e.toString("hex"));
          });
        });
      }, t.prototype.putContractStorage = function (e, t, a, r) {
        if (32 !== t.length) return r(new Error("Storage key must be 32 bytes long"));

        this._modifyContractStorage(e, function (e, r) {
          if (a && a.length) {
            var n = c.encode(a);
            e.put(t, n, r);
          } else e.del(t, r);
        }, r);
      }, t.prototype.clearContractStorage = function (e, t) {
        this._modifyContractStorage(e, function (e, t) {
          e.root = e.EMPTY_TRIE_ROOT, t();
        }, t);
      }, t.prototype.checkpoint = function (e) {
        this._trie.checkpoint(), this._cache.checkpoint(), this._touchedStack.push(new r(Array.from(this._touched))), this._checkpointCount++, e();
      }, t.prototype.commit = function (e) {
        var t = this;

        this._trie.commit(function () {
          t._cache.commit(), t._touchedStack.pop(), t._checkpointCount--, 0 === t._checkpointCount ? t._cache.flush(e) : e();
        });
      }, t.prototype.revert = function (e) {
        this._trie.revert(), this._cache.revert(), this._storageTries = {};

        var t = this._touchedStack.pop();

        if (!t) throw new Error("Reverting to invalid state checkpoint failed");
        this._touched = t, this._checkpointCount--, 0 === this._checkpointCount ? this._cache.flush(e) : e();
      }, t.prototype.getStateRoot = function (e) {
        var t = this;
        if (0 !== this._checkpointCount) return e(new Error("Cannot get state root with uncommitted checkpoints"));

        this._cache.flush(function (a) {
          if (a) return e(a);
          var r = t._trie.root;
          e(null, r);
        });
      }, t.prototype.setStateRoot = function (e, t) {
        var a = this;
        if (0 !== this._checkpointCount) return t(new Error("Cannot set state root with uncommitted checkpoints"));

        this._cache.flush(function (r) {
          return r ? t(r) : e === a._trie.EMPTY_TRIE_ROOT ? (a._trie.root = e, a._cache.clear(), a._storageTries = {}, t()) : void a._trie.checkRoot(e, function (r, n) {
            r || !n ? t(r || new Error("State trie does not contain state root")) : (a._trie.root = e, a._cache.clear(), a._storageTries = {}, t());
          });
        });
      }, t.prototype.dumpStorage = function (e, t) {
        this._getStorageTrie(e, function (e, a) {
          if (e) return t(e);
          var r = {},
              n = a.createReadStream();
          n.on("data", function (e) {
            r[e.key.toString("hex")] = e.value.toString("hex");
          }), n.on("end", function () {
            t(r);
          });
        });
      }, t.prototype.hasGenesisState = function (e) {
        var t = this._common.genesis().stateRoot;

        this._trie.checkRoot(t, e);
      }, t.prototype.generateCanonicalGenesis = function (e) {
        var t = this;
        if (0 !== this._checkpointCount) return e(new Error("Cannot create genesis state with uncommitted checkpoints"));
        this.hasGenesisState(function (a, r) {
          r || a ? e(a) : t.generateGenesis(d.genesisStateByName(t._common.chainName()), e);
        });
      }, t.prototype.generateGenesis = function (t, a) {
        var r = this;
        if (0 !== this._checkpointCount) return a(new Error("Cannot create genesis state with uncommitted checkpoints"));
        var n = Object.keys(t);
        s.eachSeries(n, function (a, n) {
          var s = new f.default();
          "0x" === t[a].slice(0, 2) ? s.balance = new i(t[a].slice(2), 16).toArrayLike(e) : s.balance = new i(t[a]).toArrayLike(e);
          var c = o.toBuffer(a);

          r._trie.put(c, s.serialize(), n);
        }, a);
      }, t.prototype.accountIsEmpty = function (e, t) {
        this.getAccount.bind(this)(e, function (e, a) {
          if (e) return t(e);
          t(null, "" === a.nonce.toString("hex") && "" === a.balance.toString("hex") && a.codeHash.toString("hex") === o.KECCAK256_NULL_S);
        });
      }, t.prototype.cleanupTouchedAccounts = function (t) {
        var a = this,
            r = Array.from(this._touched);
        s.forEach(r, function (t, r) {
          var n = e.from(t, "hex");
          a.accountIsEmpty(n, function (e, t) {
            e ? r(e) : (t && a._cache.del(n), r(null));
          });
        }, function () {
          a._touched.clear(), t();
        });
      }, t.prototype._clearOriginalStorageCache = function () {
        this._originalStorageCache = new Map();
      }, t;
    }();

    t.default = h;
  }).call(this, a(
  /*! ./../../../../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!***************************************************!*\
  !*** ./node_modules/core-js-pure/es/set/index.js ***!
  \***************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  a(
  /*! ../../modules/es.set */
  595), a(
  /*! ../../modules/es.object.to-string */
  626), a(
  /*! ../../modules/es.string.iterator */
  627), a(
  /*! ../../modules/web.dom-collections.iterator */
  629);
  var r = a(
  /*! ../../internals/path */
  121);
  e.exports = r.Set;
},
/*!*****************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.set.js ***!
  \*****************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ../internals/collection */
  596),
      n = a(
  /*! ../internals/collection-strong */
  613);
  e.exports = r("Set", function (e) {
    return function () {
      return e(this, arguments.length ? arguments[0] : void 0);
    };
  }, n);
},
/*!***********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/collection.js ***!
  \***********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ./export */
  215),
      n = a(
  /*! ../internals/global */
  38),
      s = a(
  /*! ../internals/internal-metadata */
  220),
      o = a(
  /*! ../internals/fails */
  49),
      i = a(
  /*! ../internals/hide */
  42),
      c = a(
  /*! ../internals/iterate */
  221),
      u = a(
  /*! ../internals/an-instance */
  223),
      d = a(
  /*! ../internals/is-object */
  50),
      f = a(
  /*! ../internals/set-to-string-tag */
  127),
      l = a(
  /*! ../internals/object-define-property */
  56).f,
      h = a(
  /*! ../internals/array-iteration */
  608).forEach,
      p = a(
  /*! ../internals/descriptors */
  48),
      b = a(
  /*! ../internals/internal-state */
  86),
      m = b.set,
      y = b.getterFor;

  e.exports = function (e, t, a, b, v) {
    var _,
        g = n[e],
        A = g && g.prototype,
        w = b ? "set" : "add",
        T = {};

    if (p && "function" == typeof g && (v || A.forEach && !o(function () {
      new g().entries().next();
    }))) {
      _ = t(function (t, a) {
        m(u(t, _, e), {
          type: e,
          collection: new g()
        }), null != a && c(a, t[w], t, b);
      });
      var x = y(e);
      h(["add", "clear", "delete", "forEach", "get", "has", "set", "keys", "values", "entries"], function (e) {
        var t = "add" == e || "set" == e;
        e in A && (!v || "clear" != e) && i(_.prototype, e, function (a, r) {
          var n = x(this).collection;
          if (!t && v && !d(a)) return "get" == e && void 0;
          var s = n[e](0 === a ? 0 : a, r);
          return t ? this : s;
        });
      }), v || l(_.prototype, "size", {
        get: function get() {
          return x(this).collection.size;
        }
      });
    } else _ = a.getConstructor(t, e, b, w), s.REQUIRED = !0;

    return f(_, e, !1, !0), T[e] = _, r({
      global: !0,
      forced: !0
    }, T), v || a.setStrong(_, e, b), _;
  };
},
/*!***********************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/object-get-own-property-descriptor.js ***!
  \***********************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/descriptors */
  48),
      n = a(
  /*! ../internals/object-property-is-enumerable */
  598),
      s = a(
  /*! ../internals/create-property-descriptor */
  118),
      o = a(
  /*! ../internals/to-indexed-object */
  83),
      i = a(
  /*! ../internals/to-primitive */
  217),
      c = a(
  /*! ../internals/has */
  51),
      u = a(
  /*! ../internals/ie8-dom-define */
  218),
      d = Object.getOwnPropertyDescriptor;
  t.f = r ? d : function (e, t) {
    if (e = o(e), t = i(t, !0), u) try {
      return d(e, t);
    } catch (e) {}
    if (c(e, t)) return s(!n.f.call(e, t), e[t]);
  };
},
/*!******************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/object-property-is-enumerable.js ***!
  \******************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = {}.propertyIsEnumerable,
      n = Object.getOwnPropertyDescriptor,
      s = n && !r.call({
    1: 2
  }, 1);
  t.f = s ? function (e) {
    var t = n(this, e);
    return !!t && t.enumerable;
  } : r;
},
/*!**********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/is-forced.js ***!
  \**********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/fails */
  49),
      n = /#|\.prototype\./,
      s = function s(e, t) {
    var a = i[o(e)];
    return a == u || a != c && ("function" == typeof t ? r(t) : !!t);
  },
      o = s.normalize = function (e) {
    return String(e).replace(n, ".").toLowerCase();
  },
      i = s.data = {},
      c = s.NATIVE = "N",
      u = s.POLYFILL = "P";

  e.exports = s;
},
/*!***********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/a-function.js ***!
  \***********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = function (e) {
    if ("function" != typeof e) throw TypeError(String(e) + " is not a function");
    return e;
  };
},
/*!*********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/freezing.js ***!
  \*********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/fails */
  49);
  e.exports = !r(function () {
    return Object.isExtensible(Object.preventExtensions({}));
  });
},
/*!*************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/is-array-iterator-method.js ***!
  \*************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/well-known-symbol */
  39),
      n = a(
  /*! ../internals/iterators */
  65),
      s = r("iterator"),
      o = Array.prototype;

  e.exports = function (e) {
    return void 0 !== e && (n.Array === e || o[s] === e);
  };
},
/*!***********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/set-global.js ***!
  \***********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/global */
  38),
      n = a(
  /*! ../internals/hide */
  42);

  e.exports = function (e, t) {
    try {
      n(r, e, t);
    } catch (a) {
      r[e] = t;
    }

    return t;
  };
},
/*!**************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/native-symbol.js ***!
  \**************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/fails */
  49);
  e.exports = !!Object.getOwnPropertySymbols && !r(function () {
    return !String(Symbol());
  });
},
/*!********************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/get-iterator-method.js ***!
  \********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/classof */
  222),
      n = a(
  /*! ../internals/iterators */
  65),
      s = a(
  /*! ../internals/well-known-symbol */
  39)("iterator");

  e.exports = function (e) {
    if (null != e) return e[s] || e["@@iterator"] || n[r(e)];
  };
},
/*!*********************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/call-with-safe-iteration-closing.js ***!
  \*********************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/an-object */
  64);

  e.exports = function (e, t, a, n) {
    try {
      return n ? t(r(a)[0], a[1]) : t(a);
    } catch (t) {
      var s = e.return;
      throw void 0 !== s && r(s.call(e)), t;
    }
  };
},
/*!*****************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/object-to-string.js ***!
  \*****************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ../internals/classof */
  222),
      n = {};
  n[a(
  /*! ../internals/well-known-symbol */
  39)("toStringTag")] = "z", e.exports = "[object z]" !== String(n) ? function () {
    return "[object " + r(this) + "]";
  } : n.toString;
},
/*!****************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/array-iteration.js ***!
  \****************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/bind-context */
  84),
      n = a(
  /*! ../internals/indexed-object */
  216),
      s = a(
  /*! ../internals/to-object */
  224),
      o = a(
  /*! ../internals/to-length */
  125),
      i = a(
  /*! ../internals/array-species-create */
  609),
      c = [].push,
      u = function u(e) {
    var t = 1 == e,
        a = 2 == e,
        u = 3 == e,
        d = 4 == e,
        f = 6 == e,
        l = 5 == e || f;
    return function (h, p, b, m) {
      for (var y, v, _ = s(h), g = n(_), A = r(p, b, 3), w = o(g.length), T = 0, x = m || i, D = t ? x(h, w) : a ? x(h, 0) : void 0; w > T; T++) {
        if ((l || T in g) && (v = A(y = g[T], T, _), e)) if (t) D[T] = v;else if (v) switch (e) {
          case 3:
            return !0;

          case 5:
            return y;

          case 6:
            return T;

          case 2:
            c.call(D, y);
        } else if (d) return !1;
      }

      return f ? -1 : u || d ? d : D;
    };
  };

  e.exports = {
    forEach: u(0),
    map: u(1),
    filter: u(2),
    some: u(3),
    every: u(4),
    find: u(5),
    findIndex: u(6)
  };
},
/*!*********************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/array-species-create.js ***!
  \*********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/is-object */
  50),
      n = a(
  /*! ../internals/is-array */
  610),
      s = a(
  /*! ../internals/well-known-symbol */
  39)("species");

  e.exports = function (e, t) {
    var a;
    return n(e) && ("function" != typeof (a = e.constructor) || a !== Array && !n(a.prototype) ? r(a) && null === (a = a[s]) && (a = void 0) : a = void 0), new (void 0 === a ? Array : a)(0 === t ? 0 : t);
  };
},
/*!*********************************************************!*\
  !*** ./node_modules/core-js-pure/internals/is-array.js ***!
  \*********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/classof-raw */
  119);

  e.exports = Array.isArray || function (e) {
    return "Array" == r(e);
  };
},
/*!****************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/native-weak-map.js ***!
  \****************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/global */
  38),
      n = a(
  /*! ../internals/function-to-string */
  612),
      s = r.WeakMap;
  e.exports = "function" == typeof s && /native code/.test(n.call(s));
},
/*!*******************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/function-to-string.js ***!
  \*******************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/shared */
  123);
  e.exports = r("native-function-to-string", Function.toString);
},
/*!******************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/collection-strong.js ***!
  \******************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ../internals/object-define-property */
  56).f,
      n = a(
  /*! ../internals/object-create */
  225),
      s = a(
  /*! ../internals/redefine-all */
  620),
      o = a(
  /*! ../internals/bind-context */
  84),
      i = a(
  /*! ../internals/an-instance */
  223),
      c = a(
  /*! ../internals/iterate */
  221),
      u = a(
  /*! ../internals/define-iterator */
  129),
      d = a(
  /*! ../internals/set-species */
  625),
      f = a(
  /*! ../internals/descriptors */
  48),
      l = a(
  /*! ../internals/internal-metadata */
  220).fastKey,
      h = a(
  /*! ../internals/internal-state */
  86),
      p = h.set,
      b = h.getterFor;
  e.exports = {
    getConstructor: function getConstructor(e, t, a, u) {
      var d = e(function (e, r) {
        i(e, d, t), p(e, {
          type: t,
          index: n(null),
          first: void 0,
          last: void 0,
          size: 0
        }), f || (e.size = 0), null != r && c(r, e[u], e, a);
      }),
          h = b(t),
          m = function m(e, t, a) {
        var r,
            n,
            s = h(e),
            o = y(e, t);
        return o ? o.value = a : (s.last = o = {
          index: n = l(t, !0),
          key: t,
          value: a,
          previous: r = s.last,
          next: void 0,
          removed: !1
        }, s.first || (s.first = o), r && (r.next = o), f ? s.size++ : e.size++, "F" !== n && (s.index[n] = o)), e;
      },
          y = function y(e, t) {
        var a,
            r = h(e),
            n = l(t);
        if ("F" !== n) return r.index[n];

        for (a = r.first; a; a = a.next) {
          if (a.key == t) return a;
        }
      };

      return s(d.prototype, {
        clear: function clear() {
          for (var e = h(this), t = e.index, a = e.first; a;) {
            a.removed = !0, a.previous && (a.previous = a.previous.next = void 0), delete t[a.index], a = a.next;
          }

          e.first = e.last = void 0, f ? e.size = 0 : this.size = 0;
        },
        delete: function _delete(e) {
          var t = h(this),
              a = y(this, e);

          if (a) {
            var r = a.next,
                n = a.previous;
            delete t.index[a.index], a.removed = !0, n && (n.next = r), r && (r.previous = n), t.first == a && (t.first = r), t.last == a && (t.last = n), f ? t.size-- : this.size--;
          }

          return !!a;
        },
        forEach: function forEach(e) {
          for (var t, a = h(this), r = o(e, arguments.length > 1 ? arguments[1] : void 0, 3); t = t ? t.next : a.first;) {
            for (r(t.value, t.key, this); t && t.removed;) {
              t = t.previous;
            }
          }
        },
        has: function has(e) {
          return !!y(this, e);
        }
      }), s(d.prototype, a ? {
        get: function get(e) {
          var t = y(this, e);
          return t && t.value;
        },
        set: function set(e, t) {
          return m(this, 0 === e ? 0 : e, t);
        }
      } : {
        add: function add(e) {
          return m(this, e = 0 === e ? 0 : e, e);
        }
      }), f && r(d.prototype, "size", {
        get: function get() {
          return h(this).size;
        }
      }), d;
    },
    setStrong: function setStrong(e, t, a) {
      var r = t + " Iterator",
          n = b(t),
          s = b(r);
      u(e, t, function (e, t) {
        p(this, {
          type: r,
          target: e,
          state: n(e),
          kind: t,
          last: void 0
        });
      }, function () {
        for (var e = s(this), t = e.kind, a = e.last; a && a.removed;) {
          a = a.previous;
        }

        return e.target && (e.last = a = a ? a.next : e.state.first) ? "keys" == t ? {
          value: a.key,
          done: !1
        } : "values" == t ? {
          value: a.value,
          done: !1
        } : {
          value: [a.key, a.value],
          done: !1
        } : (e.target = void 0, {
          value: void 0,
          done: !0
        });
      }, a ? "entries" : "values", !a, !0), d(t);
    }
  };
},
/*!*************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/object-define-properties.js ***!
  \*************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/descriptors */
  48),
      n = a(
  /*! ../internals/object-define-property */
  56),
      s = a(
  /*! ../internals/an-object */
  64),
      o = a(
  /*! ../internals/object-keys */
  615);
  e.exports = r ? Object.defineProperties : function (e, t) {
    s(e);

    for (var a, r = o(t), i = r.length, c = 0; i > c;) {
      n.f(e, a = r[c++], t[a]);
    }

    return e;
  };
},
/*!************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/object-keys.js ***!
  \************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/object-keys-internal */
  616),
      n = a(
  /*! ../internals/enum-bug-keys */
  226);

  e.exports = Object.keys || function (e) {
    return r(e, n);
  };
},
/*!*********************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/object-keys-internal.js ***!
  \*********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/has */
  51),
      n = a(
  /*! ../internals/to-indexed-object */
  83),
      s = a(
  /*! ../internals/array-includes */
  617).indexOf,
      o = a(
  /*! ../internals/hidden-keys */
  85);

  e.exports = function (e, t) {
    var a,
        i = n(e),
        c = 0,
        u = [];

    for (a in i) {
      !r(o, a) && r(i, a) && u.push(a);
    }

    for (; t.length > c;) {
      r(i, a = t[c++]) && (~s(u, a) || u.push(a));
    }

    return u;
  };
},
/*!***************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/array-includes.js ***!
  \***************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/to-indexed-object */
  83),
      n = a(
  /*! ../internals/to-length */
  125),
      s = a(
  /*! ../internals/to-absolute-index */
  618),
      o = function o(e) {
    return function (t, a, o) {
      var i,
          c = r(t),
          u = n(c.length),
          d = s(o, u);

      if (e && a != a) {
        for (; u > d;) {
          if ((i = c[d++]) != i) return !0;
        }
      } else for (; u > d; d++) {
        if ((e || d in c) && c[d] === a) return e || d || 0;
      }

      return !e && -1;
    };
  };

  e.exports = {
    includes: o(!0),
    indexOf: o(!1)
  };
},
/*!******************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/to-absolute-index.js ***!
  \******************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/to-integer */
  126),
      n = Math.max,
      s = Math.min;

  e.exports = function (e, t) {
    var a = r(e);
    return a < 0 ? n(a + t, 0) : s(a, t);
  };
},
/*!*****************************************************!*\
  !*** ./node_modules/core-js-pure/internals/html.js ***!
  \*****************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/get-built-in */
  227);
  e.exports = r("document", "documentElement");
},
/*!*************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/redefine-all.js ***!
  \*************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/redefine */
  228);

  e.exports = function (e, t, a) {
    for (var n in t) {
      a && a.unsafe && e[n] ? e[n] = t[n] : r(e, n, t[n], a);
    }

    return e;
  };
},
/*!****************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/create-iterator-constructor.js ***!
  \****************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ../internals/iterators-core */
  229).IteratorPrototype,
      n = a(
  /*! ../internals/object-create */
  225),
      s = a(
  /*! ../internals/create-property-descriptor */
  118),
      o = a(
  /*! ../internals/set-to-string-tag */
  127),
      i = a(
  /*! ../internals/iterators */
  65),
      c = function c() {
    return this;
  };

  e.exports = function (e, t, a) {
    var u = t + " Iterator";
    return e.prototype = n(r, {
      next: s(1, a)
    }), o(e, u, !1, !0), i[u] = c, e;
  };
},
/*!*************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/correct-prototype-getter.js ***!
  \*************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/fails */
  49);
  e.exports = !r(function () {
    function e() {}

    return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
  });
},
/*!************************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/object-set-prototype-of.js ***!
  \************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/an-object */
  64),
      n = a(
  /*! ../internals/a-possible-prototype */
  624);
  e.exports = Object.setPrototypeOf || ("__proto__" in {} ? function () {
    var e,
        t = !1,
        a = {};

    try {
      (e = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set).call(a, []), t = a instanceof Array;
    } catch (e) {}

    return function (a, s) {
      return r(a), n(s), t ? e.call(a, s) : a.__proto__ = s, a;
    };
  }() : void 0);
},
/*!*********************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/a-possible-prototype.js ***!
  \*********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/is-object */
  50);

  e.exports = function (e) {
    if (!r(e) && null !== e) throw TypeError("Can't set " + String(e) + " as a prototype");
    return e;
  };
},
/*!************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/set-species.js ***!
  \************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ../internals/get-built-in */
  227),
      n = a(
  /*! ../internals/object-define-property */
  56),
      s = a(
  /*! ../internals/well-known-symbol */
  39),
      o = a(
  /*! ../internals/descriptors */
  48),
      i = s("species");

  e.exports = function (e) {
    var t = r(e),
        a = n.f;
    o && t && !t[i] && a(t, i, {
      configurable: !0,
      get: function get() {
        return this;
      }
    });
  };
},
/*!******************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.object.to-string.js ***!
  \******************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {},
/*!*****************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.string.iterator.js ***!
  \*****************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ../internals/string-multibyte */
  628).charAt,
      n = a(
  /*! ../internals/internal-state */
  86),
      s = a(
  /*! ../internals/define-iterator */
  129),
      o = n.set,
      i = n.getterFor("String Iterator");
  s(String, "String", function (e) {
    o(this, {
      type: "String Iterator",
      string: String(e),
      index: 0
    });
  }, function () {
    var e,
        t = i(this),
        a = t.string,
        n = t.index;
    return n >= a.length ? {
      value: void 0,
      done: !0
    } : (e = r(a, n), t.index += e.length, {
      value: e,
      done: !1
    });
  });
},
/*!*****************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/string-multibyte.js ***!
  \*****************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../internals/to-integer */
  126),
      n = a(
  /*! ../internals/require-object-coercible */
  120),
      s = function s(e) {
    return function (t, a) {
      var s,
          o,
          i = String(n(t)),
          c = r(a),
          u = i.length;
      return c < 0 || c >= u ? e ? "" : void 0 : (s = i.charCodeAt(c)) < 55296 || s > 56319 || c + 1 === u || (o = i.charCodeAt(c + 1)) < 56320 || o > 57343 ? e ? i.charAt(c) : s : e ? i.slice(c, c + 2) : o - 56320 + (s - 55296 << 10) + 65536;
    };
  };

  e.exports = {
    codeAt: s(!1),
    charAt: s(!0)
  };
},
/*!***************************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/web.dom-collections.iterator.js ***!
  \***************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  a(
  /*! ./es.array.iterator */
  630);
  var r = a(
  /*! ../internals/dom-iterables */
  632),
      n = a(
  /*! ../internals/global */
  38),
      s = a(
  /*! ../internals/hide */
  42),
      o = a(
  /*! ../internals/iterators */
  65),
      i = a(
  /*! ../internals/well-known-symbol */
  39)("toStringTag");

  for (var c in r) {
    var u = n[c],
        d = u && u.prototype;
    d && !d[i] && s(d, i, c), o[c] = o.Array;
  }
},
/*!****************************************************************!*\
  !*** ./node_modules/core-js-pure/modules/es.array.iterator.js ***!
  \****************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ../internals/to-indexed-object */
  83),
      n = a(
  /*! ../internals/add-to-unscopables */
  631),
      s = a(
  /*! ../internals/iterators */
  65),
      o = a(
  /*! ../internals/internal-state */
  86),
      i = a(
  /*! ../internals/define-iterator */
  129),
      c = o.set,
      u = o.getterFor("Array Iterator");
  e.exports = i(Array, "Array", function (e, t) {
    c(this, {
      type: "Array Iterator",
      target: r(e),
      index: 0,
      kind: t
    });
  }, function () {
    var e = u(this),
        t = e.target,
        a = e.kind,
        r = e.index++;
    return !t || r >= t.length ? (e.target = void 0, {
      value: void 0,
      done: !0
    }) : "keys" == a ? {
      value: r,
      done: !1
    } : "values" == a ? {
      value: t[r],
      done: !1
    } : {
      value: [r, t[r]],
      done: !1
    };
  }, "values"), s.Arguments = s.Array, n("keys"), n("values"), n("entries");
},
/*!*******************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/add-to-unscopables.js ***!
  \*******************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = function () {};
},
/*!**************************************************************!*\
  !*** ./node_modules/core-js-pure/internals/dom-iterables.js ***!
  \**************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
  };
},
/*!***************************************************************!*\
  !*** ./node_modules/merkle-patricia-tree/secure-interface.js ***!
  \***************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ethereumjs-util */
  82);

  function n(e) {
    e.copy = function (e) {
      var t = e();
      return n(t), t;
    }.bind(e, e.copy.bind(e)), e.get = function (e, t, a) {
      var n = r.sha3(t);
      e(n, a);
    }.bind(e, e.get.bind(e)), e.put = function (e, t, a, n) {
      if (a) {
        var s = r.sha3(t);
        e(s, a, n);
      } else this.del(t, n);
    }.bind(e, e.put.bind(e)), e.del = function (e, t, a) {
      var n = r.sha3(t);
      e(n, a);
    }.bind(e, e.del.bind(e));
  }

  e.exports = n;
},
/*!***************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-common/dist/genesisStates/index.js ***!
  \***************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = {
    names: {
      1: "mainnet",
      3: "ropsten",
      4: "rinkeby",
      42: "kovan",
      6284: "goerli"
    },
    mainnet: a(
    /*! ./mainnet.json */
    635),
    ropsten: a(
    /*! ./ropsten.json */
    636),
    rinkeby: a(
    /*! ./rinkeby.json */
    637),
    kovan: a(
    /*! ./kovan.json */
    638),
    goerli: a(
    /*! ./goerli.json */
    639)
  };
  t.genesisStateById = function (e) {
    return r[r.names[e]];
  }, t.genesisStateByName = function (e) {
    return r[e];
  };
},
/*!*******************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-common/dist/genesisStates/mainnet.json ***!
  \*******************************************************************************************************/

/*! exports provided: 0x3282791d6fd713f1e94f4bfd565eaa78b3a0599d, 0x17961d633bcf20a7b029a7d94b7df4da2ec5427f, 0x493a67fe23decc63b10dda75f3287695a81bd5ab, 0x01fb8ec12425a04f813e46c54c05748ca6b29aa9, 0xd2a030ac8952325f9e1db378a71485a24e1b07b2, 0x77a34907f305a54c85db09c363fde3c47e6ae21f, 0x391a77405c09a72b5e8436237aaaf95d68da1709, 0x00aada25ea2286709abb422d41923fd380cd04c7, 0xacc46a2a555c74ded4a2bd094e821b97843b40c0, 0xde07fb5b7a464e3ba7fbe09e9acb271af5338c58, 0x4c696be99f3a690440c3436a59a7d7e937d6ba0d, 0xfa33553285a973719a0d5f956ff861b2d89ed304, 0x67cfda6e70bf7657d39059b59790e5145afdbe61, 0xa321091d3018064279db399d2b2a88a6f440ae24, 0xfb3fa1ac08aba9cc3bf0fe9d483820688f65b410, 0x6715c14035fb57bb3d667f7b707498c41074b855, 0xd4344f7d5cad65d17e5c2d0e7323943d6f62fe92, 0xa3294626ec2984c43b43da4d5d8e4669b11d4b59, 0x656018584130db83ab0591a8128d9381666a8d0e, 0x0fa010ce0c731d3b628e36b91f571300e49dbeab, 0x3098b65db93ecacaf7353c48808390a223d57684, 0xae635bf73831119d2d29c0d04ff8f8d8d0a57a46, 0x0f7515ff0e808f695e0c20485ff96ed2f7b79310, 0x8b30c04098d7a7e6420c357ea7bfa49bac9a8a18, 0x64dba2d6615b8bd7571836dc75bc79d314f5ecee, 0xe7912d4cf4562c573ddc5b71e37310e378ef86c9, 0xa4da34450d22ec0ffcede0004b02f7872ee0b73a, 0x34437d1465640b136cb5841c3f934f9ba0b7097d, 0xc652871d192422c6bc235fa063b44a7e1d43e385, 0xa8a708e84f82db86a35502193b4c6ee9a76ebe8f, 0x5c3f567faff7bad1b5120022e8cbcaa82b4917b3, 0xdbc1d0ee2bab531140de137722cd36bdb4e47194, 0xf59dab1bf8df11327e61f9b7a14b563a96ec3554, 0x456f8d746682b224679349064d1b368c7c05b176, 0x5f13154631466dcb1353c890932a7c97e0878e90, 0xf4b1626e24f30bcad9273c527fcc714b5d007b8f, 0xa8db0b9b201453333c757f6ad9bcb555c02da93b, 0xa0fc7e53c5ebd27a2abdac45261f84ab3b51aefb, 0x1b636b7a496f044d7359596e353a104616436f6b, 0x74bce9ec38362d6c94ccac26d5c0e13a8b3b1d40, 0x9834682180b982d166badb9d9d1d9bbf016d87ee, 0x1e6e0153fc161bc05e656bbb144c7187bf4fe84d, 0x989c0ccff654da03aeb11af701054561d6297e1d, 0x78a1e254409fb1b55a7cb4dd8eba3b30c8bad9ef, 0x9ef1896b007c32a15114fb89d73dbd47f9122b69, 0x33320dd90f2baa110dd334872a998f148426453c, 0xe72e1d335cc29a96b9b1c02f003a16d971e90b9d, 0x0921605f99164e3bcc28f31caece78973182561d, 0xfc00a420a36107dfd5f495128a5fe5abb2db0f34, 0xdfcbdf09454e1a5e4a40d3eef7c5cf1cd3de9486, 0x646e043d0597a664948fbb0dc15475a3a4f3a6ed, 0x79aeb34566b974c35a5881dec020927da7df5d25, 0xdbadc61ed5f0460a7f18e51b2fb2614d9264a0e0, 0x97b91efe7350c2d57e7e406bab18f3617bcde14a, 0x8398e07ebcb4f75ff2116de77c1c2a99f303a4cf, 0xf02796295101674288c1d93467053d042219b794, 0xf4ed848ec961739c2c7e352f435ba70a7cd5db38, 0x82485728d0e281563758c75ab27ed9e882a0002d, 0x427ec668ac9404e895cc861511d1620a4912be98, 0x1bbc199e586790be87afedc849c04726745c5d7b, 0x10d945334ecde47beb9ca3816c173dfbbd0b5333, 0x1dcebcb7656df5dcaa3368a055d22f9ed6cdd940, 0x2ac1f8d7bf721f3cfe74d20fea9b87a28aaa982c, 0x0a47ad9059a249fc936b2662353da6905f75c2b9, 0x768498934e37e905f1d0e77b44b574bcf3ec4ae8, 0xf46b6b9c7cb552829c1d3dfd8ffb11aabae782f6, 0x7aea25d42b2612286e99c53697c6bc4100e2dbbf, 0xaf3615c789d0b1152ad4db25fe5dcf222804cf62, 0x92e6581e1da1f9b846e09347333dc818e2d2ac66, 0x240305727313d01e73542c775ff59d11cd35f819, 0xb95cfda8465ba9c2661b249fc3ab661bdfa35ff0, 0x1b0d076817e8d68ee2df4e1da1c1142d198c4435, 0x93c2e64e5de5589ed25006e843196ee9b1cf0b3e, 0x0e2e504a2d1122b5a9feee5cb1451bf4c2ace87b, 0x22b96ab2cad55db100b53001f9e4db378104c807, 0xa927d48bb6cb814bc609cbcaa9151f5d459a27e1, 0x5cbd8daf27ddf704cdd0d909a789ba36ed4f37b2, 0x9adbd3bc7b0afc05d1d2eda49ff863939c48db46, 0xac7e03702723cb16ee27e22dd0b815dc2d5cae9f, 0x1e210e7047886daa52aaf70f4b991dac68e3025e, 0xc98048687f2bfcc9bd90ed18736c57edd352b65d, 0x81c18c2a238ddc4cba230a072dd7dc101e620273, 0xcb3d766c983f192bcecac70f4ee03dd9ff714d51, 0x44a63d18424587b9b307bfc3c364ae10cd04c713, 0x4ab2d34f04834fbf7479649cab923d2c4725c553, 0xb834acf3015322c58382eeb2b79638906e88b6de, 0x7d551397f79a2988b064afd0efebee802c7721bc, 0xb537d36a70eeb8d3e5c80de815225c1158cb92c4, 0x805ce51297a0793b812067f017b3e7b2df9bb1f9, 0x085ba65febe23eefc2c802666ab1262382cfc494, 0xb1c0d08b36e184f9952a4037e3e53a667d070a4e, 0x83fe5a1b328bae440711beaf6aad6026eda6d220, 0x7fd679e5fb0da2a5d116194dcb508318edc580f3, 0x41ad369f758fef38a19aa3149379832c818ef2a0, 0x6d846dc12657e91af25008519c3e857f51707dd6, 0xc02d6eadeacf1b78b3ca85035c637bb1ce01f490, 0x826eb7cd7319b82dd07a1f3b409071d96e39677f, 0x4ac9905a4cb6ab1cfd62546ee5917300b87c4fde, 0xcf6e52e6b77480b1867efec6446d9fc3cc3577e8, 0x2476b2bb751ce748e1a4c4ff7b230be0c15d2245, 0x1a505e62a74e87e577473e4f3afa16bedd3cfa52, 0x21d02705f3f64905d80ed9147913ea8c7307d695, 0x7b1daf14891b8a1e1bd429d8b36b9a4aa1d9afbf, 0x5338ef70eac9dd9af5a0503b5efad1039e67e725, 0x50ca86b5eb1d01874df8e5f34945d49c6c1ab848, 0xf3cc8bcb559465f81bfe583bd7ab0a2306453b9e, 0x5c323457e187761a8276e359b7b7af3f3b6e3df6, 0x4d82d7700c123bb919419bbaf046799c6b0e2c66, 0x8a66abbc2d30ce21a833b0db8e561d5105e0a72c, 0x2ae53866fc2d14d572ab73b4a065a1188267f527, 0x9af5c9894c33e42c2c518e3ac670ea9505d1b53e, 0xcba25c7a503cc8e0d04971ca05c762f9b762b48b, 0xfda3042819af3e662900e1b92b4358eda6e92590, 0x9bd7c38a4210304a4d653edeff1b3ce45fce7843, 0xedc22fb92c638e1e21ff5cf039daa6e734dafb29, 0xa1f193a0592f1feb9fdfc90aa813784eb80471c9, 0xe97fde0b67716325cf0ecce8a191a3761b2c791d, 0x110237cf9117e767922fc4a1b78d7964da82df20, 0xe32f95766d57b5cd4b173289d6876f9e64558194, 0xf2d59c8923759073d6f415aaf8eb065ff2f3b685, 0xc53d79f7cb9b70952fd30fce58d54b9f0b59f647, 0x9eb281c32719c40fdb3e216db0f37fbc73a026b7, 0x2d6511fd7a3800b26854c7ec39c0dcb5f4c4e8e8, 0x61ba87c77e9b596de7ba0e326fddfeec2163ef66, 0xde1121829c9a08284087a43fbd2fc1142a3233b4, 0x22a25812ab56dcc423175ed1d8adacce33cd1810, 0x518cef27b10582b6d14f69483ddaa0dd3c87bb5c, 0x59161749fedcf1c721f2202d13ade2abcf460b3d, 0x3e36c17253c11cf38974ed0db1b759160da63783, 0xcbfa76db04ce38fb205d37b8d377cf1380da0317, 0xa7e83772bc200f9006aa2a260dbaa8483dc52b30, 0xe87eac6d602b4109c9671bf57b950c2cfdb99d55, 0x9b06ad841dffbe4ccf46f1039fc386f3c321446e, 0xe0f903c1e48ac421ab48528f3d4a2648080fe043, 0x5d872b122e994ef27c71d7deb457bf65429eca6c, 0xf34083ecea385017aa40bdd35ef7effb4ce7762d, 0x7f3709391f3fbeba3592d175c740e87a09541d02, 0x888e94917083d152202b53163939869d271175b4, 0xbed4c8f006a27c1e5f7ce205de75f516bfb9f764, 0xb3a6bd41f9d9c3201e050b87198fbda399342210, 0x550aadae1221b07afea39fba2ed62e05e5b7b5f9, 0xbcedc4267ccb89b31bb764d7211171008d94d44d, 0x6229dcc203b1edccfdf06e87910c452a1f4d7a72, 0x94be3ae54f62d663b0d4cc9e1ea8fe9556ea9ebf, 0x0e0c9d005ea016c295cd795cc9213e87febc33eb, 0x55d057bcc04bd0f4af9642513aa5090bb3ff93fe, 0xed9e030ca75cb1d29ea01d0d4cdfdccd3844b6e4, 0x86c4ce06d9ac185bb148d96f7b7abe73f441006d, 0x2c04115c3e52961b0dc0b0bf31fba4546f5966fd, 0xb959dce02e91d9db02b1bd8b7d17a9c41a97af09, 0xe01547ba42fcafaf93938becf7699f74290af74f, 0xc593d6e37d14b566643ac4135f243caa0787c182, 0x2c0ee134d8b36145b47beee7af8d2738dbda08e8, 0x0ef54ac7264d2254abbb5f8b41adde875157db7c, 0x0349634dc2a9e80c3f7721ee2b5046aeaaedfbb5, 0x873e49135c3391991060290aa7f6ccb8f85a78db, 0x05236d4c90d065f9e3938358aaffd777b86aec49, 0xd2abd84a181093e5e229136f42d835e8235de109, 0xb56a780028039c81caf37b6775c620e786954764, 0x86df73bd377f2c09de63c45d67f283eaefa0f4ab, 0x7670b02f2c3cf8fd4f4730f3381a71ea431c33c7, 0x24aa1151bb765fa3a89ca50eb6e1b1c706417fd4, 0x43227d65334e691cf231b4a4e1d339b95d598afb, 0x695550656cbf90b75d92ad9122d90d23ca68ca4d, 0x5281733473e00d87f11e9955e589b59f4ac28e7a, 0x99a96bf2242ea1b39ece6fcc0d18aed00c0179f3, 0xb1cf94f8091505055f010ab4bac696e0ca0f67a1, 0x54391b4d176d476cea164e5fb535c69700cb2535, 0x152f2bd229ddf3cb0fdaf455c183209c0e1e39a2, 0xaffc99d5ebb4a84fe7788d97dce274b038240438, 0x23df8f48ee009256ea797e1fa369beebcf6bc663, 0x3a72d635aadeee4382349db98a1813a4cfeb3df1, 0xce26f9a5305f8381094354dbfc92664e84f902b5, 0xd283b8edb10a25528a4404de1c65e7410dbcaa67, 0xa7859fc07f756ea7dcebbccd42f05817582d973f, 0xb28181a458a440f1c6bb1de8400281a3148f4c35, 0x27b1694eafa165ebd7cc7bc99e74814a951419dc, 0x66cc8ab23c00d1b82acd7d73f38c99e0d05a4fa6, 0x926082cb7eed4b1993ad245a477267e1c33cd568, 0x4a47fc3e177f567a1e3893e000e36bba23520ab8, 0x594a76f06935388dde5e234696a0668bc20d2ddc, 0xe91fa0badaddb9a97e88d3f4db7c55d6bb7430fe, 0x574de1b3f38d915846ae3718564a5ada20c2f3ed, 0x5816c2687777b6d7d2a2432d59a41fa059e3a406, 0xb50955aa6e341571986608bdc891c2139f540cdf, 0x6d44974a31d187eda16ddd47b9c7ec5002d61fbe, 0x80abec5aa36e5c9d098f1b942881bd5acac6963d, 0x294f494b3f2e143c2ffc9738cbfd9501850b874e, 0xbca3ffd4683fba0ad3bbc90734b611da9cfb457e, 0x5992624c54cdec60a5ae938033af8be0c50cbb0a, 0x6560941328ff587cbc56c38c78238a7bb5f442f6, 0x74b7e0228baed65957aebb4d916d333aae164f0e, 0x8516fcaf77c893970fcd1a958ba9a00e49044019, 0xb992a967308c02b98af91ee760fd3b6b4824ab0e, 0x30bb4357cd6910c86d2238bf727cbe8156680e62, 0xb8cc0f060aad92d4eb8b36b3b95ce9e90eb383d7, 0x28d4ebf41e3d3c451e943bdd7e1f175fae932a3d, 0x8c83d424a3cf24d51f01923dd54a18d6b6fede7b, 0x7efc90766a00bc52372cac97fabd8a3c831f8ecd, 0x7c2b9603884a4f2e464eceb97d17938d828bc02c, 0x9d250ae4f110d71cafc7b0adb52e8d9acb6679b8, 0x61b3df2e9e9fd968131f1e88f0a0eb5bd765464d, 0x9ae13bd882f2576575921a94974cbea861ba0d35, 0x3d09688d93ad07f3abe68c722723cd680990435e, 0x5e58e255fc19870a04305ff2a04631f2ff294bb1, 0xbcaed0acb6a76f113f7c613555a2c3b0f5bf34a5, 0x159adce27aa10b47236429a34a5ac42cad5b6416, 0xe834c64318205ca7dd4a21abcb08266cb21ff02c, 0x7b6a84718dd86e63338429ac811d7c8a860f21f1, 0x2118c116ab0cdf6fd11d54a4309307b477c3fc0f, 0x34a901a69f036bcf9f7843c0ba01b426e8c3dc2b, 0xc7d44fe32c7f8cd5f1a97427b6cd3afc9e45023e, 0xc6045b3c350b4ce9ca0c6b754fb41a69b97e9900, 0xcf5a6f9df75579c644f794711215b30d77a0ce40, 0xe2904b1aefa056398b6234cb35811288d736db67, 0x7101bd799e411cde14bdfac25b067ac890eab8e8, 0xcc45fb3a555bad807b388a0357c855205f7c75e8, 0xff0c3c7798e8733dd2668152891bab80a8be955c, 0x3536453322c1466cb905af5c335ca8db74bff1e6, 0x08cac8952641d8fc526ec1ab4f2df826a5e7710f, 0x0d8aab8f74ea862cdf766805009d3f3e42d8d00b, 0x8908760cd39b9c1e8184e6a752ee888e3f0b7045, 0x8156360bbd370961ceca6b6691d75006ad204cf2, 0xa304588f0d850cd8d38f76e9e83c1bf63e333ede, 0x14c63ba2dcb1dd4df33ddab11c4f0007fa96a62d, 0xa009bf076f1ba3fa57d2a7217218bed5565a7a7a, 0x1c89060f987c518fa079ec2c0a5ebfa30f5d20f7, 0x8895eb726226edc3f78cc6a515077b3296fdb95e, 0x7919e7627f9b7d54ea3b14bb4dd4649f4f39dee0, 0xb3c65b845aba6cd816fbaae983e0e46c82aa8622, 0xeff51d72adfae143edf3a42b1aec55a2ccdd0b90, 0x05bb64a916be66f460f5e3b64332110d209e19ae, 0xd5b117ec116eb846418961eb7edb629cd0dd697f, 0x05e97b09492cd68f63b12b892ed1d11d152c0eca, 0x84cc7878da605fdb019fab9b4ccfc157709cdda5, 0x79cac6494f11ef2798748cb53285bd8e22f97cda, 0xbd5a8c94bd8be6470644f70c8f8a33a8a55c6341, 0xb119e79aa9b916526581cbf521ef474ae84dcff4, 0xaff1045adf27a1aa329461b24de1bae9948a698b, 0x4398628ea6632d393e929cbd928464c568aa4a0c, 0x99997668f7c1a4ff9e31f9977ae3224bcb887a85, 0xbc0e8745c3a549445c2be900f52300804ab56289, 0xe5bab4f0afd8a9d1a381b45761aa18f3d3cce105, 0xbe60037e90714a4b917e61f193d834906703b13a, 0x8ed4284c0f47449c15b8d9b3245de8beb6ce80bf, 0x333ad1596401e05aea2d36ca47318ef4cd2cb3df, 0x22db559f2c3c1475a2e6ffe83a5979599196a7fa, 0xfdf449f108c6fb4f5a2b081eed7e45e6919e4d25, 0x0be1bcb90343fae5303173f461bd914a4839056c, 0xb981ad5e6b7793a23fc6c1e8692eb2965d18d0da, 0xc75d2259306aec7df022768c69899a652185dbc4, 0x6c2e9be6d4ab450fd12531f33f028c614674f197, 0x6dcc7e64fcafcbc2dc6c0e5e662cb347bffcd702, 0xaabdb35c1514984a039213793f3345a168e81ff1, 0xd315deea1d8c1271f9d1311263ab47c007afb6f5, 0x4faf90b76ecfb9631bf9022176032d8b2c207009, 0x3e7a966b5dc357ffb07e9fe067c45791fd8e3049, 0x2e64a8d71111a22f4c5de1e039b336f68d398a7c, 0x181fbba852a7f50178b1c7f03ed9e58d54162929, 0x4f7330096f79ed264ee0127f5d30d2f73c52b3d8, 0xa8a8dbdd1a85d1beee2569e91ccc4d09ae7f6ea1, 0x1f9c3268458da301a2be5ab08257f77bb5a98aa4, 0xfc372ff6927cb396d9cf29803500110da632bc52, 0x4fa554ab955c249217386a4d3263bbf72895434e, 0x2a59e47ea5d8f0e7c028a3e8e093a49c1b50b9a3, 0x5e32c72191b8392c55f510d8e3326e3a60501d62, 0x1dfaee077212f1beaf0e6f2f1840537ae154ad86, 0x7eaba035e2af3793fd74674b102540cf190addb9, 0xd62edb96fce2969aaf6c545e967cf1c0bc805205, 0x220dc68df019b6b0ccbffb784b5a5ab4b15d4060, 0x45bb829652d8bfb58b8527f0ecb621c29e212ec3, 0x79b120eb8806732321288f675a27a9225f1cd2eb, 0x740af1eefd3365d78ba7b12cb1a673e06a077246, 0x0f042c9c2fb18766f836bb59f735f27dc329fe3c, 0x6dda5f788a6c688ddf921fa3852eb6d6c6c62966, 0x96ad579bbfa8db8ebec9d286a72e4661eed8e356, 0x0c2073ba44d3ddbdb639c04e191039a71716237f, 0x1a3520453582c718a21c42375bc50773255253e1, 0xefcaae9ff64d2cd95b5249dcffe7faa0a0c0e44d, 0x0a3de155d5ecd8e81c1ff9bbf0378301f8d4c623, 0x80f07ac09e7b2c3c0a3d1e9413a544c73a41becb, 0xc3631c7698b6c5111989bf452727b3f9395a6dea, 0x4cc22c9bc9ad05d875a397dbe847ed221c920c67, 0x1a987e3f83de75a42f1bde7c997c19217b4a5f24, 0x5b2b64e9c058e382a8b299224eecaa16e09c8d92, 0x86caafacf32aa0317c032ac36babed974791dc03, 0x1cd1f0a314cbb200de0a0cb1ef97e920709d97c2, 0x7d980f4b566bb045517e4c14c87750de9346744b, 0x8b5f29cc2faa262cdef30ef554f50eb488146eac, 0x5153a0c3c8912881bf1c3501bf64b45649e48222, 0xd21a7341eb84fd151054e5e387bb25d36e499c09, 0x9560e8ac6718a6a1cdcff189d603c9063e413da6, 0xe49ba0cd96816c4607773cf8a5970bb5bc16a1e6, 0xb8ac117d9f0dba80901445823c4c9d4fa3fedc6e, 0xaf67fd3e127fd9dc36eb3fcd6a80c7be4f7532b2, 0xb43c27f7a0a122084b98f483922541c8836cee2c, 0x4d9279962029a8bd45639737e98b511eff074c21, 0xc667441e7f29799aba616451d53b3f489f9e0f48, 0x275875ff4fbb0cf3a430213127487f7608d04cba, 0x9a953b5bcc709379fcb559d7b916afdaa50cadcc, 0x7ea791ebab0445a00efdfc4e4a8e9a7e7565136d, 0x6ffe5cf82cc9ea5e36cad7c2974ce7249f3749e6, 0xf1b4ecc63525f7432c3d834ffe2b970fbeb87212, 0x6b72a8f061cfe6996ad447d3c72c28c0c08ab3a7, 0xbba3c68004248e489573abb2743677066b24c8a7, 0xb7c0d0cc0b4d342d4062bac624ccc3c70cc6da3f, 0xfe98c664c3e447a95e69bd582171b7176ea2a685, 0xce71086d4c602554b82dcbfce88d20634d53cc4d, 0x1c601993789207f965bb865cbb4cd657cce76fc0, 0x476b5599089a3fb6f29c6c72e49b2e4740ea808d, 0x3439998b247cb4bf8bc80a6d2b3527f1dfe9a6d2, 0xc4f7d2e2e22084c44f70feaab6c32105f3da376f, 0xc1eba5684aa1b24cba63150263b7a9131aeec28d, 0x94ad4bad824bd0eb9ea49c58cebcc0ff5e08346b, 0xded877378407b94e781c4ef4af7cfc5bc220b516, 0x699c9ee47195511f35f862ca4c22fd35ae8ffbf4, 0xe3a89a1927cc4e2d43fbcda1e414d324a7d9e057, 0x4d93696fa24859f5d2939aebfa54b4b51ae1dccc, 0x0af65f14784e55a6f95667fd73252a1c94072d2a, 0x5b70c49cc98b3df3fbe2b1597f5c1b6347a388b7, 0x426f78f70db259ac8534145b2934f4ef1098b5d8, 0x58b8ae8f63ef35ed0762f0b6233d4ac14e64b64d, 0x8eae29435598ba8f1c93428cdb3e2b4d31078e00, 0x17fd9b551a98cb61c2e07fbf41d3e8c9a530cba5, 0xab3e78294ba886a0cfd5d3487fb3a3078d338d6e, 0xbdf6e68c0cd7584080e847d72cbb23aad46aeb1d, 0xf989346772995ec1906faffeba2a7fe7de9c6bab, 0xdc5f5ad663a6f263327d64cac9cb133d2c960597, 0x68fe1357218d095849cd579842c4aa02ff888d93, 0xe09c68e61998d9c81b14e4ee802ba7adf6d74cdb, 0x890fe11f3c24db8732d6c2e772e2297c7e65f139, 0xa76929890a7b47fb859196016c6fdd8289ceb755, 0x2dc79d6e7f55bce2e2d0c02ad07ceca8bb529354, 0x19687daa39c368139b6e7be60dc1753a9f0cbea3, 0xc69be440134d6280980144a9f64d84748a37f349, 0x3d8d0723721e73a6c0d860aa0557abd14c1ee362, 0x2b241f037337eb4acc61849bd272ac133f7cdf4b, 0x24b95ebef79500baa0eda72e77f877415df75c33, 0x106ed5c719b5261477890425ae7551dc59bd255c, 0x5b2e2f1618552eab0db98add55637c2951f1fb19, 0x403145cb4ae7489fcc90cd985c6dc782b3cc4e44, 0xe8be24f289443ee473bc76822f55098d89b91cc5, 0xf6bc37b1d2a3788d589b6de212dc1713b2f6e78e, 0x67fc527dce1785f0fb8bc7e518b1c669f7ecdfb5, 0x6580b1bc94390f04b397bd73e95d96ef11eaf3a8, 0x98bf4af3810b842387db70c14d46099626003d10, 0x17993d312aa1106957868f6a55a5e8f12f77c843, 0x0729b4b47c09eb16158464c8aa7fd9690b438839, 0xae70e69d2c4a0af818807b1a2705f79fd0b5dbc4, 0x38b50146e71916a5448de12a4d742135dcf39833, 0x38439aaa24e3636f3a18e020ea1da7e145160d86, 0x54b4429b182f0377be7e626939c5db6440f75d7a, 0x7179726f5c71ae1b6d16a68428174e6b34b23646, 0xc2ee91d3ef58c9d1a589844ea1ae3125d6c5ba69, 0x912304118b80473d9e9fe3ee458fbe610ffda2bb, 0x3308b03466c27a17dfe1aafceb81e16d2934566f, 0x10346414bec6d3dcc44e50e54d54c2b8c3734e3e, 0x4fee50c5f988206b09a573469fb1d0b42ebb6dce, 0x9ece1400800936c7c6485fcdd3626017d09afbf6, 0xddf3ad76353810be6a89d731b787f6f17188612b, 0x72402300e81d146c2e644e2bbda1da163ca3fb56, 0xbb4b4a4b548070ff41432c9e08a0ca6fa7bc9f76, 0xc3dd58903886303b928625257ae1a013d71ae216, 0xca6c818befd251361e02744068be99d8aa60b84a, 0xb8d2ddc66f308c0158ae3ccb7b869f7d199d7b32, 0x8e486a0442d171c8605be348fee57eb5085eff0d, 0xa807104f2703d679f8deafc442befe849e42950b, 0xbb61a04bffd57c10470d45c39103f64650347616, 0xd1c45954a62b911ad701ff2e90131e8ceb89c95c, 0x5e65458be964ae449f71773704979766f8898761, 0xf9b37825f03073d31e249378c30c795c33f83af2, 0xe309974ce39d60aadf2e69673251bf0e04760a10, 0xd541ac187ad7e090522de6da3213e9a7f4439673, 0xf33efc6397aa65fb53a8f07a0f893aae30e8bcee, 0xd2f1998e1cb1580cec4f6c047dcd3dcec54cf73c, 0x0ed76c2c3b5d50ff8fb50b3eeacd681590be1c2d, 0x637d67d87f586f0a5a479e20ee13ea310a10b647, 0x1a5ee533acbfb3a2d76d5b685277b796c56a052b, 0x323fca5ed77f699f9d9930f5ceeff8e56f59f03c, 0xa5fe2ce97f0e8c3856be0de5f4dcb2ce5d389a16, 0x93258255b37c7f58f4b10673a932dd3afd90f4f2, 0x950fe9c6cad50c18f11a9ed9c45740a6180612d0, 0xee31167f9cc93b3c6465609d79db0cde90e8484c, 0x6ebb5e6957aa821ef659b6018a393a504cae4450, 0xbe305a796e33bbf7f9aeae6512959066efda1010, 0x537f9d4d31ef70839d84b0d9cdb72b9afedbdf35, 0xfe9e1197d7974a7648dcc7a03112a88edbc9045d, 0x99f77f998b20e0bcdcd9fc838641526cf25918ef, 0x76ffc157ad6bf8d56d9a1a7fddbc0fea010aabf4, 0xdefe9141f4704599159d7b223de42bffd80496b3, 0x7b1bf53a9cbe83a7dea434579fe72aac8d2a0cd0, 0x23ccc3c6acd85c2e460c4ffdd82bc75dc849ea14, 0x9f86a066edb61fcb5856de93b75c8c791864b97b, 0x871b8a8b51dea1989a5921f13ec1a955a515ad47, 0x4efcd9c79fb4334ca6247b0a33bd9cc33208e272, 0x35ac1d3ed7464fa3db14e7729213ceaa378c095e, 0xc69d663c8d60908391c8d236191533fdf7775613, 0xc2ed5ffdd1add855a2692fe062b5d618742360d4, 0x454f0141d721d33cbdc41018bd01119aa4784818, 0x6c8687e3417710bb8a93559021a1469e6a86bc77, 0xec5b198a00cfb55a97b5d53644cffa8a04d2ab45, 0xcd59f3dde77e09940befb6ee58031965cae7a336, 0x8eebec1a62c08b05a7d1d59180af9ff0d18e3f36, 0x92a971a739799f8cb48ea8475d72b2d2474172e6, 0xbed4649df646e2819229032d8868556fe1e053d3, 0xc50fe415a641b0856c4e75bf960515441afa358d, 0x91f516146cda20281719978060c6be4149067c88, 0x54a1370116fe22099e015d07cd2669dd291cc9d1, 0x80c04efd310f440483c73f744b5b9e64599ce3ec, 0xa8914c95b560ec13f140577338c32bcbb77d3a7a, 0xe3c812737ac606baf7522ad817428a36050e7a34, 0x6d1456fff0104ee844a3314737843338d24cd66c, 0x0e6ece99111cad1961c748ed3df51edd69d2a3b1, 0x019d709579ff4bc09fdcdde431dc1447d2c260bc, 0xebff84bbef423071e604c361bba677f5593def4e, 0xe10c540088113fa6ec00b4b2c8824f8796e96ec4, 0xe03220c697bcd28f26ef0b74404a8beb06b2ba7b, 0xe69a6cdb3a8a7db8e1f30c8b84cd73bae02bc0f8, 0xe5fb31a5caee6a96de393bdbf89fbe65fe125bb3, 0x030fb3401f72bd3418b7d1da75bf8c519dd707dc, 0x1c751e7f24df9d94a637a5dedeffc58277b5db19, 0xbded7e07d0711e684de65ac8b2ab57c55c1a8645, 0xdd7ff441ba6ffe3671f3c0dabbff1823a5043370, 0xb55474ba58f0f2f40e6cbabed4ea176e011fcad6, 0xb92427ad7578b4bfe20a9f63a7c5506d5ca12dc8, 0x91a8baaed012ea2e63803b593d0d0c2aab4c5b0a, 0xa97e072144499fe5ebbd354acc7e7efb58985d08, 0x75c2ffa1bef54919d2097f7a142d2e14f9b04a58, 0x53faf165be031ec18330d9fce5bd1281a1af08db, 0x055ab658c6f0ed4f875ed6742e4bc7292d1abbf0, 0x6f18ec767e320508195f1374500e3f2e125689ff, 0x90fc537b210658660a83baa9ac4a8402f65746a8, 0x34664d220fa7f37958024a3332d684bcc6d4c8bd, 0x15acb61568ec4af7ea2819386181b116a6c5ee70, 0x69d98f38a3ba3dbc01fa5c2c1427d862832f2f70, 0xece1152682b7598fe2d1e21ec15533885435ac85, 0xf618d9b104411480a863e623fc55232d1a4f48aa, 0xf9debaecb5f339beea4894e5204bfa340d067f25, 0x5e731b55ced452bb3f3fe871ddc3ed7ee6510a8f, 0x67df242d240dd4b8071d72f8fcf35bb3809d71e8, 0xc4cf930e5d116ab8d13b9f9a7ec4ab5003a6abde, 0x01a25a5f5af0169b30864c3be4d7563ccd44f09e, 0x7f6efb6f4318876d2ee624e27595f44446f68e93, 0x82249fe70f61c6b16f19a324840fdc020231bb02, 0x205237c4be146fba99478f3a7dad17b09138da95, 0xfd1fb5a89a89a721b8797068fbc47f3e9d52e149, 0xe47fbaed99fc209962604ebd20e240f74f4591f1, 0xa24c3ab62181e9a15b78c4621e4c7c588127be26, 0xb6cd7432d5161be79768ad45de3e447a07982063, 0x32a70691255c9fc9791a4f75c8b81f388e0a2503, 0x562f16d79abfcec3943e34b20f05f97bdfcda605, 0xdbc66965e426ff1ac87ad6eb78c1d95271158f9f, 0x7e87863ec43a481df04d017762edcb5caa629b5a, 0x587d6849b168f6c3332b7abae7eb6c42c37f48bf, 0x721158be5762b119cc9b2035e88ee4ee78f29b82, 0x84b91e2e2902d05e2b591b41083bd7beb2d52c74, 0x632cecb10cfcf38ec986b43b8770adece9200221, 0xc34e3ba1322ed0571183a24f94204ee49c186641, 0xae78bb849139a6ba38ae92a09a69601cc4cb62d1, 0x5ce0b6862cce9162e87e0849e387cb5df4f9118c, 0xf52c0a7877345fe0c233bb0f04fd6ab18b6f14ba, 0xe016dc138e25815b90be3fe9eee8ffb2e105624f, 0x5789d01db12c816ac268e9af19dc0dd6d99f15df, 0xd8b77db9b81bbe90427b62f702b201ffc29ff618, 0x5dff811dad819ece3ba602c383fb5dc64c0a3a48, 0xaf3087e62e04bf900d5a54dc3e946274da92423b, 0x8c1023fde1574db8bb54f1739670157ca47da652, 0xbb3b010b18e6e2be1135871026b7ba15ea0fde24, 0xcabdaf354f4720a466a764a528d60e3a482a393c, 0x94bbc67d13f89ebca594be94bc5170920c30d9f3, 0x3275496fd4dd8931fd69fb0a0b04c4d1ff879ef5, 0x281250a29121270a4ee5d78d24feafe82c70ba3a, 0x590ccb5911cf78f6f622f535c474375f4a12cfcf, 0x542e8096bafb88162606002e8c8a3ed19814aeac, 0xa65426cff378ed23253513b19f496de45fa7e18f, 0x4aa693b122f314482a47b11cc77c68a497876162, 0xd9b783d31d32adc50fa3eacaa15d92b568eaeb47, 0x068e655766b944fb263619658740b850c94afa31, 0x9e23c5e4b782b00a5fadf1aead87dacf5b0367a1, 0xbf17f397f8f46f1bae45d187148c06eeb959fa4d, 0x8578e10212ca14ff0732a8241e37467db85632a9, 0x2cb5495a505336c2465410d1cae095b8e1ba5cdd, 0x695b0f5242753701b264a67071a2dc880836b8db, 0xf2edde37f9a8c39ddea24d79f4015757d06bf786, 0x480f31b989311e4124c6a7465f5a44094d36f9d0, 0xcf157612764e0fd696c8cb5fba85df4c0ddc3cb0, 0x27521deb3b6ef1416ea4c781a2e5d7b36ee81c61, 0x6efd90b535e00bbd889fda7e9c3184f879a151db, 0xb635a4bc71fb28fdd5d2c322983a56c284426e69, 0xa17c9e4323069518189d5207a0728dcb92306a3f, 0x6af940f63ec9b8d876272aca96fef65cdacecdea, 0x469358709332c82b887e20bcddd0220f8edba7d0, 0xa257ad594bd88328a7d90fc0a907df95eecae316, 0x6f051666cb4f7bd2b1907221b829b555d7a3db74, 0x46bfc5b207eb2013e2e60f775fecd71810c5990c, 0x62b9081e7710345e38e02e16449ace1b85bcfc4e, 0xbc73f7b1ca3b773b34249ada2e2c8a9274cc17c2, 0x1adaf4abfa867db17f99af6abebf707a3cf55df6, 0x8d629c20608135491b5013f1002586a0383130e5, 0x38e46de4453c38e941e7930f43304f94bb7b2be8, 0x3485f621256433b98a4200dad857efe55937ec98, 0x775c10c93e0db7205b2643458233c64fc33fd75b, 0x7c4401ae98f12ef6de39ae24cf9fc51f80eba16b, 0x17b807afa3ddd647e723542e7b52fee39527f306, 0x0ab366e6e7d5abbce6b44a438d69a1cabb90d133, 0x194ffe78bbf5d20dd18a1f01da552e00b7b11db1, 0xc45d47ab0c9aa98a5bd62d16223ea2471b121ca4, 0x2487c3c4be86a2723d917c06b458550170c3edba, 0xec4d08aa2e47496dca87225de33f2b40a8a5b36f, 0xaaa8defe11e3613f11067fb983625a08995a8dfc, 0x50bb67c8b8d8bd0f63c4760904f2d333f400aace, 0x1227e10a4dbf9caca31b1780239f557615fc35c1, 0x44a8989e32308121f72466978db395d1f76c3a4b, 0x59569a21d28fba4bda37753405a081f2063da150, 0xc3756bcdcc7eec74ed896adfc335275930266e08, 0xce3a61f0461b00935e85fa1ead82c45e5a64d488, 0x012f396a2b5eb83559bac515e5210df2c8c362ba, 0x93bc7d9a4abd44c8bbb8fe8ba804c61ad8d6576c, 0xe20bb9f3966419e14bbbaaaa6789e92496cfa479, 0x9eef442d291a447d74c5d253c49ef324eac1d8f0, 0xdb6c2a73dac7424ab0d031b66761122566c01043, 0x704d243c2978e46c2c86adbecd246e3b295ff633, 0xd2ff672016f63b2f85398f4a6fedbb60a50d3cce, 0xd2051cb3cb6704f0548cc890ab0a19db3415b42a, 0x1111e5dbf45e6f906d62866f1708101788ddd571, 0x6a686bf220b593deb9b7324615fb9144ded3f39d, 0x911feea61fe0ed50c5b9e5a0d66071399d28bdc6, 0x3881defae1c07b3ce04c78abe26b0cdc8d73f010, 0xea94f32808a2ef8a9bf0861d1d2404f7b7be258a, 0x2eef6b1417d7b10ecfc19b123a8a89e73e526c58, 0xdd8af9e7765223f4446f44d3d509819a3d3db411, 0x2efc4c647dac6acac35577ad221758fef6616faa, 0x1547b9bf7ad66274f3413827231ba405ee8c88c1, 0x250a40cef3202397f240469548beb5626af4f23c, 0xc175be3194e669422d15fee81eb9f2c56c67d9c9, 0xc9e02608066828848aeb28c73672a12925181f4d, 0x8229ceb9f0d70839498d44e6abed93c5ca059f5d, 0x39f198331e4b21c1b760a3155f4ab2fe00a74619, 0x3ffcb870d4023d255d5167d8a507cefc366b68ba, 0x00dae27b350bae20c5652124af5d8b5cba001ec1, 0xfc5500825105cf712a318a5e9c3bfc69c89d0c12, 0x1ed8bb3f06778b039e9961d81cb71a73e6787c8e, 0x530ffac3bc3412e2ec0ea47b7981c770f5bb2f35, 0x5f344b01c7191a32d0762ac188f0ec2dd460911d, 0x5cfa9877f719c79d9e494a08d1e41cf103fc87c9, 0xf6eaac7032d492ef17fd6095afc11d634f56b382, 0x962c0dec8a3d464bf39b1215eafd26480ae490cd, 0x262a8bfd7d9dc5dd3ad78161b6bb560824373655, 0x9b4824ff9fb2abda554dee4fb8cf549165570631, 0xbb3b9005f46fd2ca3b30162599928c77d9f6b601, 0xf7dc251196fbcbb77c947d7c1946b0ff65021cea, 0xaf1148ef6c8e103d7530efc91679c9ac27000993, 0x0bb2650ea01aca755bc0c017b64b1ab5a66d82e3, 0x0cda12bf72d461bbc479eb92e6491d057e6b5ad1, 0x4e5b77f9066159e615933f2dda7477fa4e47d648, 0x391161b0e43c302066e8a68d2ce7e199ecdb1d57, 0xc7e330cd0c890ac99fe771fcc7e7b009b7413d8a, 0xd4b38a5fdb63e01714e9801db47bc990bd509183, 0xbc0f98598f88056a26339620923b8f1eb074a9fd, 0xdbc59ed88973dead310884223af49763c05030f1, 0x0f85e42b1df321a4b3e835b50c00b06173968436, 0xd7788ef28658aa06cc53e1f3f0de58e5c371be78, 0xecd276af64c79d1bd9a92b86b5e88d9a95eb88f8, 0x81c9e1aee2d3365d53bcfdcd96c7c538b0fd7eec, 0x5d39ef9ea6bdfff15d11fe91f561a6f9e31f5da5, 0x99878f9d6e0a7ed9aec78297b73879a80195afe0, 0x7294c918b1aefb4d25927ef9d799e71f93a28e85, 0xa33f70da7275ef057104dfa7db64f472e9f5d553, 0x255bdd6474cc8262f26a22c38f45940e1ceea69b, 0x52f8b509fee1a874ab6f9d87367fbeaf15ac137f, 0xe2728a3e8c2aaac983d05dc6877374a8f446eee9, 0xed0206cb23315128f8caff26f6a30b985467d022, 0x87cf36ad03c9eae9053abb5242de9117bb0f2a0b, 0xa929c8bd71db0c308dac06080a1747f21b1465aa, 0x9da6e075989c7419094cc9f6d2e49393bb199688, 0x763eece0b08ac89e32bfa4bece769514d8cb5b85, 0x5df3277ca85936c7a0d2c0795605ad25095e7159, 0x7163758cbb6c4c525e0414a40a049dcccce919bb, 0x14cdddbc8b09e6675a9e9e05091cb92238c39e1e, 0xb3b7f493b44a2c8d80ec78b1cdc75a652b73b06c, 0xc69b855539ce1b04714728eec25a37f367951de7, 0x052eab1f61b6d45517283f41d1441824878749d0, 0x515651d6db4faf9ecd103a921bbbbe6ae970fdd4, 0xc7aff91929797489555a2ff1d14d5c695a108355, 0xd7ca7fdcfebe4588eff5421d1522b61328df7bf3, 0xeefba12dfc996742db790464ca7d273be6e81b3e, 0xebaa216de9cc5a43031707d36fe6d5bedc05bdf0, 0x559194304f14b1b93afe444f0624e053c23a0009, 0x4ecc19948dd9cd87b4c7201ab48e758f28e7cc76, 0xf224eb900b37b4490eee6a0b6420d85c947d8733, 0x97810bafc37e84306332aacb35e92ad911d23d24, 0xbd67d2e2f82da8861341bc96a2c0791fddf39e40, 0x1b6495891240e64e594493c2662171db5e30ce13, 0x00bdd4013aa31c04616c2bc9785f2788f915679b, 0xc6ae287ddbe1149ba16ddcca4fe06aa2eaa988a9, 0xb7c9f12b038e73436d17e1c12ffe1aeccdb3f58c, 0xc1b500011cfba95d7cd636e95e6cbf6167464b25, 0x39e0db4d60568c800b8c5500026c2594f5768960, 0x40e3c283f7e24de0410c121bee60a5607f3e29a6, 0x2f7d3290851be5c6b4b43f7d4574329f61a792c3, 0xc33ece935a8f4ef938ea7e1bac87cb925d8490ca, 0x57bddf078834009c89d88e6282759dc45335b470, 0x50ad187ab21167c2b6e78be0153f44504a07945e, 0x5bd24aac3612b20c609eb46779bf95698407c57c, 0x16526c9edf943efa4f6d0f0bae81e18b31c54079, 0x4c6a9dc2cab10abb2e7c137006f08fecb5b779e1, 0x02c9f7940a7b8b7a410bf83dc9c22333d4275dd3, 0xb9fd3833e88e7cf1fa9879bdf55af4b99cd5ce3f, 0x7e268f131ddf687cc325c412f78ba961205e9112, 0x180478a655d78d0f3b0c4f202b61485bc4002fd5, 0xed4014538cee664a2fbcb6dc669f7ab16d0ba57c, 0xf63a579bc3eac2a9490410128dbcebe6d9de8243, 0x5d822d9b3ef4b502627407da272f67814a6becd4, 0xeb52ab10553492329c1c54833ae610f398a65b9d, 0x63340a57716bfa63eb6cd133721202575bf796f0, 0x933bf33f8299702b3a902642c33e0bfaea5c1ca3, 0x25bc49ef288cd165e525c661a812cf84fbec8f33, 0xc8231ba5a411a13e222b29bfc1083f763158f226, 0x6c15ec3520bf8ebbc820bd0ff19778375494cf9d, 0xaaced8a9563b1bc311dbdffc1ae7f57519c4440c, 0xd90f3009db437e4e11c780bec8896f738d65ef0d, 0x5603241eb8f08f721e348c9d9ad92f48e390aa24, 0x53cec6c88092f756efe56f7db11228a2db45b122, 0x194cebb4929882bf3b4bf9864c2b1b0f62c283f9, 0x4be8628a8154874e048d80c142181022b180bcc1, 0x5fd973af366aa5157c54659bcfb27cbfa5ac15d6, 0x303139bc596403d5d3931f774c66c4ba467454db, 0x87584a3f613bd4fac74c1e780b86d6caeb890cb2, 0x77f4e3bdf056883cc87280dbe640a18a0d02a207, 0x4de3fe34a6fbf634c051997f47cc7f48791f5824, 0xc45a1ca1036b95004187cdac44a36e33a94ab5c3, 0x65d33eb39cda6453b19e61c1fe4db93170ef9d34, 0xf65616be9c8b797e7415227c9138faa0891742d7, 0xe17812f66c5e65941e186c46922b6e7b2f0eeb46, 0xd47f50df89a1cff96513bef1b2ae3a2971accf2c, 0x8ed1528b447ed4297902f639c514d0944a88f8c8, 0xa4fb14409a67b45688a8593e5cc2cf596ced6f11, 0x855d9aef2c39c6230d09c99ef6494989abe68785, 0x778c43d11afe3b586ff374192d96a7f23d2b9b7f, 0xe3ece1f632711d13bfffa1f8f6840871ee58fb27, 0xbeb3358c50cf9f75ffc76d443c2c7f55075a0589, 0xf156dc0b2a981e5b55d3f2f03b8134e331dbadb7, 0xeb9cc9fe0869d2dab52cc7aae8fd57adb35f9feb, 0x2467c6a5c696ede9a1e542bf1ad06bcc4b06aca0, 0xec75b4a47513120ba5f86039814f1998e3817ac3, 0x9c3d0692ceeef80aa4965ceed262ffc7f069f2dc, 0xe05029aceb0778675bef1741ab2cd2931ef7c84b, 0x41d3b731a326e76858baa5f4bd89b57b36932343, 0xc346cb1fbce2ab285d8e5401f42dd7234d37e86d, 0x45f4fc60f08eaca10598f0336329801e3c92cb46, 0xf04a6a379708b9428d722aa2b06b77e88935cf89, 0x232832cd5977e00a4c30d0163f2e24f088a6cb09, 0xd2ac0d3a58605e1d0f0eb3de25b2cad129ed6058, 0xa356551bb77d4f45a6d7e09f0a089e79cca249cb, 0xb50c9f5789ae44e2dce017c714caf00c830084c2, 0x21fd6c5d97f9c600b76821ddd4e776350fce2be0, 0xf0d5c31ccb6cbe30c7c9ea19f268d159851f8c9c, 0xab7091932e4bc39dbb552380ca934fd7166d1e6e, 0xacd8dd91f714764c45677c63d852e56eb9eece2e, 0x57d032a43d164e71aa2ef3ffd8491b0a4ef1ea5b, 0x5af46a25ac09cb73616b53b14fb42ff0a51cddb2, 0x1ea6bf2f15ae9c1dbc64daa7f8ea4d0d81aad3eb, 0x03337012ae1d7ff3ee7f697c403e7780188bf0ef, 0x32eb64be1b5dede408c6bdefbe6e405c16b7ed02, 0x22e2488e2da26a49ae84c01bd54b21f2947891c6, 0xbe98a77fd41097b34f59d7589baad021659ff712, 0xdda4ed2a58a8dd20a73275347b580d71b95bf99a, 0x671110d96aaff11523cc546bf9940eedffb2faf7, 0x5d71799c8df3bccb7ee446df50b8312bc4eb71c5, 0xae179a460db66326743d24e67523a57b246daf7f, 0x198bfcf1b07ae308fa2c02069ac9dafe7135fb47, 0x4662a1765ee921842ddc88898d1dc8627597bd7e, 0x783eec8aa5dac77b2e6623ed5198a431abbaee07, 0xed6643c0e8884b2d3211853785a08bf8f33ed29f, 0x5cc7d3066d45d27621f78bb4b339473e442a860f, 0x94ef8be45077c7d4c5652740de946a62624f713f, 0x2f853817afd3b8f3b86e9f60ee77b5d97773c0e3, 0x3e0b8ed86ed669e12723af7572fbacfe829b1e16, 0xfa68e0cb3edf51f0a6f211c9b2cb5e073c9bffe6, 0x2c234f505ca8dcc77d9b7e01d257c318cc19396d, 0xf3f24fc29e20403fc0e8f5ebbb553426f78270a2, 0x91546b79ecf69f936b5a561508b0d7e50cc5992f, 0x435443b81dfdb9bd8c6787bc2518e2d47e57c15f, 0x3a06e3bb1edcfd0c44c3074de0bb606b049894a2, 0x3a3108c1e680a33b336c21131334409d97e5adec, 0x2caf6bf4ec7d5a19c5e0897a5eeb011dcece4210, 0xf44f8551ace933720712c5c491cdb6f2f951736c, 0x5bc1f95507b1018642e45cd9c0e22733b9b1a326, 0x94ca56de777fd453177f5e0694c478e66aff8a84, 0xafdd1b786162b8317e20f0e979f4b2ce486d765d, 0x3a805fa0f7387f73055b7858ca8519edd93d634f, 0x8b36224c7356e751f0c066c35e3b44860364bfc2, 0xcfecbea07c27002f65fe534bb8842d0925c78402, 0x482982ac1f1c6d1721feecd9b9c96cd949805055, 0xaf880fc7567d5595cacce15c3fc14c8742c26c9e, 0xacc1c78786ab4d2b3b277135b5ba123e0400486b, 0x41f27e744bd29de2b0598f02a0bb9f98e681eaa4, 0x09a025316f967fa8b9a1d60700063f5a68001caa, 0x391f20176d12360d724d51470a90703675594a4d, 0xfe4d8403216fd571572bf1bdb01d00578978d688, 0x900f0b8e35b668f81ef252b13855aa5007d012e7, 0xc35b95a2a3737cb8f0f596b34524872bd30da234, 0x412a68f6c645559cc977fc4964047a201d1bb0e2, 0xd3dad1b6d08d4581ccae65a8732db6ac69f0c69e, 0x35855ec641ab9e081ed0c2a6dcd81354d0244a87, 0x88015d7203c5e0224aeda286ed12f1a51b789333, 0x251c12722c6879227992a304eb3576cd18434ea5, 0x1f6f0030349752061c96072bc3d6eb3549208d6b, 0x86153063a1ae7f02f1a88136d4d69c7c5e3e4327, 0x78355df0a230f83d032c703154414de3eedab557, 0xc5b56cd234267c28e89c6f6b2266b086a12f970c, 0x3e3cd3bec06591d6346f254b621eb41c89008d31, 0x378ea1dc8edc19bae82638029ea8752ce98bcfcd, 0x67632046dcb25a54936928a96f423f3320cbed92, 0xddbee6f094eae63420b003fb4757142aea6cd0fd, 0xb555d00f9190cc3677aef314acd73fdc39399259, 0xe230fe1bff03186d0219f15d4c481b7d59be286a, 0x3e4e9265223c9738324cf20bd06006d0073edb8c, 0x7450ff7f99eaa9116275deac68e428df5bbcd8b9, 0x021f69043de88c4917ca10f1842897eec0589c7c, 0x351787843505f8e4eff46566cce6a59f4d1c5fe7, 0xebd37b256563e30c6f9289a8e2702f0852880833, 0xed41e1a28f5caa843880ef4e8b08bd6c33141edf, 0x8d238e036596987643d73173c37b0ad06055b96c, 0x478e524ef2a381d70c82588a93ca7a5fa9d51cbf, 0x4419ac618d5dea7cdc6077206fb07dbdd71c1702, 0xca25ff34934c1942e22a4e7bd56f14021a1af088, 0x5552f4b3ed3e1da79a2f78bb13e8ae5a68a9df3b, 0x4354221e62dc09e6406436163a185ef06d114a81, 0xca0432cb157b5179f02ebba5c9d1b54fec4d88ca, 0x8a780ab87a9145fe10ed60fa476a740af4cab1d2, 0x4ff676e27f681a982d8fd9d20e648b3dce05e945, 0x6c63fc85029a2654d79b2bea4de349e4524577c5, 0x1ac089c3bc4d82f06a20051a9d732dc0e734cb61, 0x4bf4479799ef82eea20943374f56a1bf54001e5e, 0x08411652c871713609af0062a8a1281bf1bbcfd9, 0xe1bfaa5a45c504428923c4a61192a55b1400b45d, 0x5e1fbd4e58e2312b3c78d7aaaafa10bf9c3189e3, 0xbb27c6a7f91075475ab229619040f804c8ec7a6a, 0x5d8d31faa864e22159cd6f5175ccecc53fa54d72, 0x2dd8eeef87194abc2ce7585da1e35b7cea780cb7, 0x0e1801e70b6262861b1134ccbc391f568afc92f7, 0x61042b80fd6095d1b87be2f00f109fabafd157a6, 0xfb5518714cefc36d04865de5915ef0ff47dfe743, 0xb5add1e7809f7d03069bfe883b0a932210be8712, 0xc2e2d498f70dcd0859e50b023a710a6d4b2133bd, 0x4ad047fae67ef162fe68fedbc27d3b65caf10c36, 0x69cb3e2153998d86e5ee20c1fcd1a6baeeb2863f, 0x683633010a88686bea5a98ea53e87997cbf73e69, 0x6cb11ecb32d3ce829601310636f5a10cf7cf9b5f, 0xa613456996408af1c2e93e177788ab55895e2b32, 0x8308ed0af7f8a3c1751fafc877b5a42af7d35882, 0xe5edf8123f2403ce1a0299becf7aac744d075f23, 0x05665155cc49cbf6aabdd5ae92cbfaad82b8c0c1, 0x00b277b099a8e866ca0ec65bcb87284fd142a582, 0x4b9e068fc4680976e61504912985fd5ce94bab0d, 0x12134e7f6b017bf48e855a399ca58e2e892fa5c8, 0xdffcea5421ec15900c6ecfc777184e140e209e24, 0x2132c0516a2e17174ac547c43b7b0020d1eb4c59, 0xd39a5da460392b940b3c69bc03757bf3f2e82489, 0x66c8331efe7198e98b2d32b938688e3241d0e24f, 0xbdca2a0ff34588af625fa8e28fc3015ab5a3aa00, 0x7dfc342dffcf45dfee74f84c0995397bd1a63172, 0xa202547242806f6e70e74058d6e5292defc8c8d4, 0x3bbc13d04accc0707aebdcaef087d0b87e0b5ee3, 0xbe5cba8d37427986e8ca2600e858bb03c359520f, 0x4174fa1bc12a3b7183cbabb77a0b59557ba5f1db, 0x9eb3a7cb5e6726427a3a361cfa8d6164dbd0ba16, 0x25e661c939863acc044e6f17b5698cce379ec3cc, 0x24bd5904059091d2f9e12d6a26a010ca22ab14e8, 0xc96626728aaa4c4fb3d31c26df3af310081710d1, 0x0fb5d2c673bfb1ddca141b9894fd6d3f05da6720, 0x2de31afd189a13a76ff6fe73ead9f74bb5c4a629, 0xbd09126c891c4a83068059fe0e15796c4661a9f4, 0x496f5843f6d24cd98d255e4c23d1e1f023227545, 0x540cf23dd95c4d558a279d778d2b3735b3164191, 0x9b5ec18e8313887df461d2902e81e67a8f113bb1, 0xb7a7f77c348f92a9f1100c6bd829a8ac6d7fcf91, 0x2590126870e0bde8a663ab040a72a5573d8d41c2, 0x090fa9367bda57d0d3253a0a8ff76ce0b8e19a73, 0x2a5ba9e34cd58da54c9a2712663a3be274c8e47b, 0x3e8641d43c42003f0a33c929f711079deb2b9e46, 0xf4d97664cc4eec9edbe7fa09f4750a663b507d79, 0xb1540e94cff3465cc3d187e7c8e3bdaf984659e2, 0xf96883582459908c827627e86f28e646f9c7fc7a, 0xd4feed99e8917c5c5458635f3603ecb7e817a7d0, 0x14b1603ec62b20022033eec4d6d6655ac24a015a, 0xaf8e1dcb314c950d3687434d309858e1a8739cd4, 0x4b9206ba6b549a1a7f969e1d5dba867539d1fa67, 0x471010da492f4018833b088d9872901e06129174, 0xd243184c801e5d79d2063f3578dbae81e7b3a9cb, 0x3eada8c92f56067e1bb73ce378da56dc2cdfd365, 0x33ea6b7855e05b07ab80dab1e14de9b649e99b6c, 0x700711e311bb947355f755b579250ca7fd765a3e, 0x87fb26c31e48644d693134205cae43b21f18614b, 0x001d14804b399c6ef80e64576f657660804fec0b, 0xf9642086b1fbae61a6804dbe5fb15ec2d2b537f4, 0x6919dd5e5dfb1afa404703b9faea8cee35d00d70, 0x9ac4da51d27822d1e208c96ea64a1e5b55299723, 0x1bd8ebaa7674bb18e19198db244f570313075f43, 0xe64ef012658d54f8e8609c4e9023c09fe865c83b, 0x43b079baf0727999e66bf743d5bcbf776c3b0922, 0x06ac26ad92cb859bd5905ddce4266aa0ec50a9c5, 0x99c1d9f40c6ab7f8a92fce2fdce47a54a586c53f, 0x4ae93082e45187c26160e66792f57fad3551c73a, 0x7da7613445a21299aa74f0ad71431ec43fbb1be9, 0x4a9a26fd0a8ba10f977da4f77c31908dab4a8016, 0x972c2f96aa00cf8a2f205abcf8937c0c75f5d8d9, 0xb5046cb3dc1dedbd364514a2848e44c1de4ed147, 0x48c2ee91a50756d8ce9abeeb7589d22c6fee5dfb, 0x46c1aa2244b9c8a957ca8fac431b0595a3b86824, 0x21fd0bade5f4ef7474d058b7f3d854cb1300524e, 0x1864a3c7b48155448c54c88c708f166709736d31, 0x5dd53ae897526b167d39f1744ef7c3da5b37a293, 0xece111670b563ccdbebca52384290ecd68fe5c92, 0x74d671d99cbea1ab57906375b63ff42b50451d17, 0x5717cc9301511d4a81b9f583148beed3d3cc8309, 0x8f92844f282a92999ee5b4a8d773d06b694dbd9f, 0xb5a606f4ddcbb9471ec67f658caf2b00ee73025e, 0xbdb60b823a1173d45a0792245fb496f1fd3301cf, 0x1d2615f8b6ca5012b663bdd094b0c5137c778ddf, 0x82ff716fdf033ec7e942c909d9831867b8b6e2ef, 0x44c14765127cde11fab46c5d2cf4d4b2890023fd, 0xc72cb301258e91bc08998a805dd192f25c2f9a35, 0xad732c976593eec4783b4e2ecd793979780bfedb, 0xd8f62036f03b7635b858f1103f8a1d9019a892b6, 0x0a06fad7dcd7a492cbc053eeabde6934b39d8637, 0x67f2bb78b8d3e11f7c458a10b5c8e0a1d374467d, 0x4b5cdb1e428c91dd7cb54a6aed4571da054bfe52, 0xb3557d39b5411b84445f5f54f38f62d2714d0087, 0x0b0e055b28cbd03dc5ff44aa64f3dce04f5e63fb, 0x9b2be7f56754f505e3441a10f7f0e20fd3ddf849, 0x0b93fca4a4f09cac20db60e065edcccc11e0a5b6, 0x3bc85d6c735b9cda4bba5f48b24b13e70630307b, 0x52102354a6aca95d8a2e86d5debda6de69346076, 0xcda4530f4b9bc50905b79d17c28fc46f95349bdf, 0xff545bbb66fbd00eb5e6373ff4e326f5feb5fe12, 0x4030a925706b2c101c8c5cb9bd05fbb4f6759b18, 0xf11e01c7a9d12499005f4dae7716095a34176277, 0xa4826b6c3882fad0ed5c8fbb25cc40cc4f33759f, 0x28510e6eff1fc829b6576f4328bc3938ec7a6580, 0x9ce5363b13e8238aa4dd15acd0b2e8afe0873247, 0xd97bc84abd47c05bbf457b2ef659d61ca5e5e48f, 0x4a719061f5285495b37b9d7ef8a51b07d6e6acac, 0x8b714522fa2839620470edcf0c4401b713663df1, 0xb6decf82969819ba02de29b9b593f21b64eeda0f, 0xc87d3ae3d88704d9ab0009dcc1a0067131f8ba3c, 0xdccb370ed68aa922283043ef7cad1b9d403fc34a, 0x2d532df4c63911d1ce91f6d1fcbff7960f78a885, 0x1fcfd1d57f872290560cb62d600e1defbefccc1c, 0xd9e27eb07dfc71a706060c7f079238ca93e88539, 0xda7732f02f2e272eaf28df972ecc0ddeed9cf498, 0xbf09d77048e270b662330e9486b38b43cd781495, 0x619f171445d42b02e2e07004ad8afe694fa53d6a, 0x2bdd03bebbee273b6ca1059b34999a5bbd61bb79, 0x8da1d359ba6cb4bcc57d7a437720d55db2f01c72, 0xbe935793f45b70d8045d2654d8dd3ad24b5b6137, 0xee71793e3acf12a7274f563961f537529d89c7de, 0x86f05d19063e9369c6004eb3f123943a7cff4eab, 0x87b10f9c280098179a2b76e9ce90be61fc844d0d, 0x243c84d12420570cc4ef3baba1c959c283249520, 0x6bc85acd5928722ef5095331ee88f484b8cf8357, 0x2561a138dcf83bd813e0e7f108642be3de3d6f05, 0x7d0350e40b338dda736661872be33f1f9752d755, 0xe5dc9349cb52e161196122cf87a38936e2c57f34, 0x543a8c0efb8bcd15c543e2a6a4f807597631adef, 0x0413d0cf78c001898a378b918cd6e498ea773c4d, 0x3708e59de6b4055088782902e0579c7201a8bf50, 0x699fc6d68a4775573c1dcdaec830fefd50397c4e, 0x379a7f755a81a17edb7daaa28afc665dfa6be63a, 0x260a230e4465077e0b14ee4442a482d5b0c914bf, 0x3daa01ceb70eaf9591fa521ba4a27ea9fb8ede4a, 0x7f3a1e45f67e92c880e573b43379d71ee089db54, 0x38643babea6011316cc797d9b093c897a17bdae7, 0x84675e9177726d45eaa46b3992a340ba7f710c95, 0x0f83461ba224bb1e8fdd9dae535172b735acb4e0, 0x31aa3b1ebe8c4dbcb6a708b1d74831e60e497660, 0xa32cf7dde20c3dd5679ff5e325845c70c5962662, 0xc007f0bdb6e7009202b7af3ea90902697c721413, 0x05c64004a9a826e94e5e4ee267fa2a7632dd4e6f, 0xf622e584a6623eaaf99f2be49e5380c5cbcf5cd8, 0x9dc10fa38f9fb06810e11f60173ec3d2fd6a751e, 0x423c3107f4bace414e499c64390a51f74615ca5e, 0x92438e5203b6346ff886d7c36288aacccc78ceca, 0xbef07d97c3481f9d6aee1c98f9d91a180a32442b, 0x55aa5d313ebb084da0e7801091e29e92c5dec3aa, 0x89c433d601fad714da6369308fd26c1dc9942bbf, 0x25106ab6755df86d6b63a187703b0cfea0e594a0, 0x494256e99b0f9cd6e5ebca3899863252900165c8, 0x5f4ace4c1cc13391e01f00b198e1f20b5f91cbf5, 0x135cecd955e5798370769230159303d9b1839f66, 0xced81ec3533ff1bfebf3e3843ee740ad11758d3e, 0x688eb3853bbcc50ecfee0fa87f0ab693cabdef02, 0x2159240813a73095a7ebf7c3b3743e8028ae5f09, 0x99d1579cd42682b7644e1d4f7128441eeffe339d, 0x8a243a0a9fea49b839547745ff2d11af3f4b0522, 0xc1a41a5a27199226e4c7eb198b031b59196f9842, 0x7514adbdc63f483f304d8e94b67ff3309f180b82, 0x74aeec915de01cc69b2cb5a6356feea14658c6c5, 0x76f9ad3d9bbd04ae055c1477c0c35e7592cb2a20, 0xa8a7b68adab4e3eadff19ffa58e34a3fcec0d96a, 0x60de22a1507432a47b01cc68c52a0bf8a2e0d098, 0xceb33d78e7547a9da2e87d51aec5f3441c87923a, 0x432809a2390f07c665921ff37d547d12f1c9966a, 0xd5e656a1b916f9bf45afb07dd8afaf73b4c56f41, 0xe3410bb7557cf91d79fa69d0dfea0aa075402651, 0xdee942d5caf5fac11421d86b010b458e5c392990, 0xa98f109835f5eacd0543647c34a6b269e3802fac, 0x932b9c04d40d2ac83083d94298169dae81ab2ed0, 0xba10f2764290f875434372f79dbf713801caac01, 0xa2c7eaffdc2c9d937345206c909a52dfb14c478f, 0x6c67e0d7b62e2a08506945a5dfe38263339f1f22, 0x60c3714fdddb634659e4a2b1ea42c4728cc7b8ba, 0x73b4d499de3f38bf35aaf769a6e318bc6d123692, 0x3b22dea3c25f1b59c7bd27bb91d3a3eaecef3984, 0x1e3badb1b6e1380e27039c576ae6222e963a5b53, 0xabd4d6c1666358c0406fdf3af248f78ece830104, 0x0c925ad5eb352c8ef76d0c222d115b0791b962a1, 0xbe9186c34a52514abb9107860f674f97b821bd5b, 0xb7f67314cb832e32e63b15a40ce0d7ffbdb26985, 0x3f30d3bc9f602232bc724288ca46cd0b0788f715, 0x970abd53a54fca4a6429207c182d4d57bb39d4a0, 0x36d85dc3683156e63bf880a9fab7788cf8143a27, 0x2836123046b284e5ef102bfd22b1765e508116ad, 0xde06d5ea777a4eb1475e605dbcbf43444e8037ea, 0x9af11399511c213181bfda3a8b264c05fc81b3ce, 0xe2191215983f33fd33e22cd4a2490054da53fddc, 0x2eebf59432b52892f9380bd140aa99dcf8ad0c0f, 0xdc087f9390fb9e976ac23ab689544a0942ec2021, 0xfd4b989558ae11be0c3b36e2d6f2a54a9343ca2e, 0x770c2fb2c4a81753ac0182ea460ec09c90a516f8, 0xb28dbfc6499894f73a71faa00abe0f4bc9d19f2a, 0xb0cef8e8fb8984a6019f01c679f272bbe68f5c77, 0xf400f93d5f5c7e3fc303129ac8fb0c2f786407fa, 0xf2133431d1d9a37ba2f0762bc40c5acc8aa6978e, 0x9003d270891ba2df643da8341583193545e3e000, 0x8938d1b4daee55a54d738cf17e4477f6794e46f7, 0x98e6f547db88e75f1f9c8ac2c5cf1627ba580b3e, 0x009fdbf44e1f4a6362b769c39a475f95a96c2bc7, 0xd0f9597811b0b992bb7d3757aa25b4c2561d32e2, 0xdcd10c55bb854f754434f1219c2c9a98ace79f03, 0x67048f3a12a4dd1f626c64264cb1d7971de2ca38, 0xd33cf82bf14c592640a08608914c237079d5be34, 0xf5b068989df29c253577d0405ade6e0e7528f89e, 0xa9a8eca11a23d64689a2aa3e417dbb3d336bb59a, 0x99413704b1a32e70f3bc0d69dd881c38566b54cb, 0x2a085e25b64862f5e68d768e2b0f7a8529858eee, 0x833d3fae542ad5f8b50ce19bde2bec579180c88c, 0xc3483d6e88ac1f4ae73cc4408d6c03abe0e49dca, 0xfde395bc0b6d5cbb4c1d8fea3e0b4bff635e9db7, 0xeddacd94ec89a2ef968fcf977a08f1fae2757869, 0xdc29119745d2337320da51e19100c948d980b915, 0x640bf87415e0cf407301e5599a68366da09bbac8, 0xafcc7dbb8356d842d43ae7e23c8422b022a30803, 0x9120e71173e1ba19ba8f9f4fdbdcaa34e1d6bb78, 0x9092918707c621fdbd1d90fb80eb787fd26f7350, 0x263e57dacbe0149f82fe65a2664898866ff5b463, 0x315db7439fa1d5b423afa7dd7198c1cf74c918bc, 0x09b4668696f86a080f8bebb91db8e6f87015915a, 0x5c31996dcac015f9be985b611f468730ef244d90, 0xb1179589e19db9d41557bbec1cb24ccc2dec1c7f, 0x3b1937d5e793b89b63fb8eb5f1b1c9ca6ba0fa8e, 0xc9127b7f6629ee13fc3f60bc2f4467a20745a762, 0x7306de0e288b56cfdf987ef0d3cc29660793f6dd, 0x2aa192777ca5b978b6b2c2ff800ac1860f753f47, 0x55da9dcdca61cbfe1f133c7bcefc867b9c8122f9, 0xcdd9efac4d6d60bd71d95585dce5d59705c13564, 0xad8e48a377695de014363a523a28b1a40c78f208, 0x252b6555afdc80f2d96d972d17db84ea5ad521ac, 0x60ab71cd26ea6d6e59a7a0f627ee079c885ebbf6, 0xf40b134fea22c6b29c8457f49f000f9cda789adb, 0x85a2f6ea94d05e8c1d9ae2f4910338a358e98ded, 0xae13a08511110f32e53be4127845c843a1a57c7b, 0x40db1ba585ce34531edec5494849391381e6ccd3, 0x0c5589a7a89b9ad15b02751930415948a875fbef, 0x89054430dcdc28ac15fa635ef87c105e602bf70c, 0x6c882c27732cef5c7c13a686f0a2ea77555ac289, 0xde374299c1d07d79537385190f442ef9ca24061f, 0xb146a0b925553cf06fcaf54a1b4dfea621290757, 0x09ae49e37f121df5dc158cfde806f173a06b0c7f, 0xb758896f1baa864f17ebed16d953886fee68aae6, 0x30730466b8eb6dc90d5496aa76a3472d7dbe0bbe, 0xfc02734033e57f70517e0afc7ee62461f06fad8e, 0xa9b2d2e0494eab18e07d37bbb856d80e80f84cd3, 0x95278b08dee7c0f2c8c0f722f9fcbbb9a5241fda, 0xdab6bcdb83cf24a0ae1cb21b3b5b83c2f3824927, 0x94439ca9cc169a79d4a09cae5e67764a6f871a21, 0xe06c29a81517e0d487b67fb0b6aabc4f57368388, 0x458e3cc99e947844a18e6a42918fef7e7f5f5eb3, 0x0a9804137803ba6868d93a55f9985fcd540451e4, 0x40630024bd2c58d248edd8465617b2bf1647da0e, 0x15224ad1c0face46f9f556e4774a3025ad06bd52, 0x2e2810dee44ae4dff3d86342ab126657d653c336, 0x48a30de1c919d3fd3180e97d5f2b2a9dbd964d2d, 0x46a30b8a808931217445c3f5a93e882c0345b426, 0x455396a4bbd9bae8af9fb7c4d64d471db9c24505, 0xedfda2d5db98f9380714664d54b4ee971a1cae03, 0xf5eadcd2d1b8657a121f33c458a8b13e76b65526, 0x90e7070f4d033fe6910c9efe5a278e1fc6234def, 0xd55508adbbbe9be81b80f97a6ea89add68da674f, 0x66925de3e43f4b41bf9dadde27d5488ef569ea0d, 0xb7c077946674ba9341fb4c747a5d50f5d2da6415, 0xc52d1a0c73c2a1be84915185f8b34faa0adf1de3, 0x79b8aad879dd30567e8778d2d231c8f37ab8734e, 0x3aae4872fd9093cbcad1406f1e8078bab50359e2, 0xb2e9d76bf50fc36bf7d3944b63e9ca889b699968, 0x405f596b94b947344c033ce2dcbff12e25b79784, 0x232cb1cd49993c144a3f88b3611e233569a86bd6, 0x9e232c08c14dc1a6ed0b8a3b2868977ba5c17d10, 0x095270cc42141dd998ad2862dbd1fe9b44e7e650, 0x15d99468507aa0413fb60dca2adc7f569cb36b54, 0x04852732b4c652f6c2e58eb36587e60a62da14db, 0xecf24cdd7c22928c441e694de4aa31b0fab59778, 0x512b91bbfaa9e581ef683fc90d9db22a8f49f48b, 0xa88577a073fbaf33c4cd202e00ea70ef711b4006, 0x00acc6f082a442828764d11f58d6894ae408f073, 0x0355bcacbd21441e95adeedc30c17218c8a408ce, 0x4e73cf2379f124860f73d6d91bf59acc5cfc845b, 0x2a742b8910941e0932830a1d9692cfd28494cf40, 0x41a8c2830081b102df6e0131657c07ab635b54ce, 0xb63064bd3355e6e07e2d377024125a33776c4afa, 0x1a25e1c5bc7e5f50ec16f8885f210ea1b938800e, 0x09b59b8698a7fbd3d2f8c73a008988de3e406b2b, 0xc555b93156f09101233c6f7cf6eb3c4f196d3346, 0x12f32c0a1f2daab676fe69abd9e018352d4ccd45, 0x5956b28ec7890b76fc061a1feb52d82ae81fb635, 0xc739259e7f85f2659bef5f609ed86b3d596c201e, 0xfae92c1370e9e1859a5df83b56d0f586aa3b404c, 0xd5a7bec332adde18b3104b5792546aa59b879b52, 0x4f88dfd01091a45a9e2676021e64286cd36b8d34, 0x102c477d69aadba9a0b0f62b7459e17fbb1c1561, 0x34272d5e7574315dcae9abbd317bac90289d4765, 0xfe615d975c0887e0c9113ec7298420a793af8b96, 0x487adf7d70a6740f8d51cbdd68bb3f91c4a5ce68, 0x7e5d9993104e4cb545e179a2a3f971f744f98482, 0x5529830a61c1f13c197e550beddfd6bd195c9d02, 0x2f282abbb6d4a3c3cd3b5ca812f7643e80305f06, 0x7352586d021ad0cf77e0e928404a59f374ff4582, 0x03f7b92008813ae0a676eb212814afab35221069, 0x056686078fb6bcf9ba0a8a8dc63a906f5feac0ea, 0x8063379a7bf2cb923a84c5093e68dac7f75481c5, 0x200264a09f8c68e3e6629795280f56254f8640d0, 0x5a891155f50e42074374c739baadf7df2651153a, 0x80022a1207e910911fc92849b069ab0cdad043d3, 0xe781ec732d401202bb9bd13860910dd6c29ac0b6, 0x4c2f1afef7c5868c44832fc77cb03b55f89e6d6e, 0x34ff582952ff24458f7b13d51f0b4f987022c1fe, 0x73914b22fc2f131584247d82be4fecbf978ad4ba, 0x562be95aba17c5371fe2ba828799b1f55d2177d6, 0x648f5bd2a2ae8902db37847d1cb0db9390b06248, 0x6a9758743b603eea3aa0524b42889723c4153948, 0x5985c59a449dfc5da787d8244e746c6d70caa55f, 0x56ee197f4bbf9f1b0662e41c2bbd9aa1f799e846, 0xd47c242edffea091bc54d57df5d1fdb93101476c, 0xd482e7f68e41f238fe517829de15477fe0f6dd1d, 0x05bf4fcfe772e45b826443852e6c351350ce72a2, 0xf10462e58fcc07f39584a187639451167e859201, 0x1aa27699cada8dc3a76f7933aa66c71919040e88, 0x24046b91da9b61b629cb8b8ec0c351a07e0703e4, 0x41033c1b6d05e1ca89b0948fc64453fbe87ab25e, 0x369822f5578b40dd1f4471706b22cd971352da6b, 0x044e853144e3364495e7a69fa1d46abea3ac0964, 0xabf728cf9312f22128024e7046c251f5dc5901ed, 0xd781f7fc09184611568570b4986e2c72872b7ed0, 0x6bb4a661a33a71d424d49bb5df28622ed4dffcf4, 0xfef3b3dead1a6926d49aa32b12c22af54d9ff985, 0xfa410971ad229c3036f41acf852f2ac999281950, 0xde176b5284bcee3a838ba24f67fc7cbf67d78ef6, 0x23120046f6832102a752a76656691c863e17e59c, 0xa2f472fe4f22b77db489219ea4023d11582a9329, 0xf0d64cf9df09741133d170485fd24b005011d520, 0x8b505e2871f7deb7a63895208e8227dcaa1bff05, 0x481e3a91bfdc2f1c8428a0119d03a41601417e1c, 0xbc69a0d2a31c3dbf7a9122116901b2bdfe9802a0, 0x20a81680e465f88790f0074f60b4f35f5d1e6aa5, 0x194a6bb302b8aba7a5b579df93e0df1574967625, 0x264cc8086a8710f91b21720905912cd7964ae868, 0x24aca08d5be85ebb9f3132dfc1b620824edfedf9, 0x1851a063ccdb30549077f1d139e72de7971197d5, 0xf64a4ac8d540a9289c68d960d5fb7cc45a77831c, 0xc3db5657bb72f10d58f231fddf11980aff678693, 0xb46ace865e2c50ea4698d216ab455dff5a11cd72, 0x9faea13c733412dc4b490402bfef27a0397a9bc3, 0xb40594c4f3664ef849cca6227b8a25aa690925ee, 0x672fa0a019088db3166f6119438d07a99f8ba224, 0xc1ffad07db96138c4b2a530ec1c7de29b8a0592c, 0x87af25d3f6f8eea15313d5fe4557e810c524c083, 0xd6a22e598dabd38ea6e958bd79d48ddd9604f4df, 0xa2a435de44a01bd0ecb29e44e47644e46a0cdffb, 0x549b47649cfad993e4064d2636a4baa0623305cc, 0x1321b605026f4ffb296a3e0edcb390c9c85608b7, 0xb4bf24cb83686bc469869fefb044b909716993e2, 0x12d91a92d74fc861a729646db192a125b79f5374, 0x7f0662b410298c99f311d3a1454a1eedba2fea76, 0x83908aa7478a6d1c9b9b0281148f8f9f242b9fdc, 0xc1438c99dd51ef1ca8386af0a317e9b041457888, 0x545bb070e781172eb1608af7fc2895d6cb87197e, 0x161d26ef6759ba5b9f20fdcd66f16132c352415e, 0xd7f370d4bed9d57c6f49c999de729ee569d3f4e4, 0x90e35aabb2deef408bb9b5acef714457dfde6272, 0x0fcfc4065008cfd323305f6286b57a4dd7eee23b, 0xcd725d70be97e677e3c8e85c0b26ef31e9955045, 0xdcf6b657266e91a4dae6033ddac15332dd8d2b34, 0x31f006f3494ed6c16eb92aaf9044fa8abb5fd5a3, 0xcdea386f9d0fd804d02818f237b7d9fa7646d35e, 0xd45b3341e8f15c80329320c3977e3b90e7826a7e, 0x0b649da3b96a102cdc6db652a0c07d65b1e443e6, 0x0a58fddd71898de773a74fdae45e7bd84ef43646, 0x0256149f5b5063bea14e15661ffb58f9b459a957, 0x4438e880cb2766b0c1ceaec9d2418fceb952a044, 0x9ed80eda7f55054db9fb5282451688f26bb374c1, 0x8dab948ae81da301d972e3f617a912e5a753712e, 0x5b5d8c8eed6c85ac215661de026676823faa0a0c, 0x46722a36a01e841d03f780935e917d85d5a67abd, 0xd4b8bdf3df9a51b0b91d16abbea05bb4783c8661, 0x98f6b8e6213dbc9a5581f4cce6655f95252bdb07, 0x3599493ce65772cf93e98af1195ec0955dc98002, 0xecab5aba5b828de1705381f38bc744b32ba1b437, 0x9a82826d3c29481dcc2bd2950047e8b60486c338, 0x6c474bc66a54780066aa4f512eefa773abf919c7, 0xd5903e9978ee20a38c3f498d63d57f31a39f6a06, 0x341480cc8cb476f8d01ff30812e7c70e05afaf5d, 0xaf771039345a343001bc0f8a5923b126b60d509c, 0xb5a4679685fa14196c2e9230c8c4e33bffbc10e2, 0x2a400dff8594de7228b4fd15c32322b75bb87da8, 0xa1336dfb96b6bcbe4b3edf3205be5723c90fad52, 0xe9b1f1fca3fa47269f21b061c353b7f5e96d905a, 0x0ee414940487fd24e390378285c5d7b9334d8b65, 0x6ab5b4c41cddb829690c2fda7f20c85e629dd5d5, 0xdd63042f25ed32884ad26e3ad959eb94ea36bf67, 0xc0b3f244bca7b7de5b48a53edb9cbeab0b6d88c0, 0xed1a5c43c574d4e934299b24f1472cdc9fd6f010, 0xb2d9ab9664bcf6df203c346fc692fd9cbab9205e, 0xede8c2cb876fbe8a4cca8290361a7ea01a69fdf8, 0x6a7c252042e7468a3ff773d6450bba85efa26391, 0xa106e6923edd53ca8ed650968a9108d6ccfd9670, 0x031e25db516b0f099faebfd94f890cf96660836b, 0x7fdbc3a844e40d96b2f3a635322e6065f4ca0e84, 0xdf47a61b72535193c561cccc75c3f3ce0804a20e, 0xed31305c319f9273d3936d8f5b2f71e9b1b22963, 0xa6b2d573297360102c07a18fc21df2e7499ff4eb, 0xf68464bf64f2411356e4d3250efefe5c50a5f65b, 0x927cc2bfda0e088d02eff70b38b08aa53cc30941, 0x41cb9896445f70a10a14215296daf614e32cf4d5, 0x3ad70243d88bf0400f57c8c1fd57811848af162a, 0x63b9754d75d12d384039ec69063c0be210d5e0e3, 0xad1799aad7602b4540cd832f9db5f11150f1687a, 0xa8b65ba3171a3f77a6350b9daf1f8d55b4d201eb, 0xad0a4ae478e9636e88c604f242cf5439c6d45639, 0x4cd0b0a6436362595ceade052ebc9b929fb6c6c0, 0xc1d4af38e9ba799040894849b8a8219375f1ac78, 0x49ddee902e1d0c99d1b11af3cc8a96f78e4dcf1a, 0xae842210f44d14c4a4db91fc9d3b3b50014f7bf7, 0x10a1c42dc1ba746986b985a522a73c93eae64c63, 0x5103bc09933e9921fd53dc536f11f05d0d47107d, 0xc88eec54d305c928cc2848c2fee23531acb96d49, 0x9a2ce43b5d89d6936b8e8c354791b8afff962425, 0x562020e3ed792d2f1835fe5f55417d5111460c6a, 0xed16ce39feef3bd7f5d162045e0f67c0f00046bb, 0xab948a4ae3795cbca13126e19253bdc21d3a8514, 0xc12b7f40df9a2f7bf983661422ab84c9c1f50858, 0x62e6b2f5eb94fa7a43831fc87e254a3fe3bf8f89, 0x423bca47abc00c7057e3ad34fca63e375fbd8b4a, 0x5ff326cd60fd136b245e29e9087a6ad3a6527f0d, 0x79ffb4ac13812a0b78c4a37b8275223e176bfda5, 0xf757fc8720d3c4fa5277075e60bd5c411aebd977, 0x0bdbc54cc8bdbbb402a08911e2232a5460ce866b, 0x9ee9760cc273d4706aa08375c3e46fa230aff3d5, 0xd23a24d7f9468343c143a41d73b88f7cbe63be5e, 0x46d80631284203f6288ecd4e5758bb9d41d05dbe, 0x3f4cd1399f8a34eddb9a17a471fc922b5870aafc, 0x44c54eaa8ac940f9e80f1e74e82fc14f1676856a, 0xaec27ff5d7f9ddda91183f46f9d52543b6cd2b2f, 0x203c6283f20df7bc86542fdfb4e763ecdbbbeef5, 0xbcaf347918efb2d63dde03e39275bbe97d26df50, 0x974d0541ab4a47ec7f75369c0069b64a1b817710, 0x5da54785c9bd30575c89deb59d2041d20a39e17b, 0x1fb463a0389983df7d593f7bdd6d78497fed8879, 0x6e1ea4b183e252c9bb7767a006d4b43696cb8ae9, 0xc2aa74847e86edfdd3f3db22f8a2152feee5b7f7, 0xa13b9d82a99b3c9bba5ae72ef2199edc7d3bb36c, 0x5135fb8757600cf474546252f74dc0746d06262c, 0x43e7ec846358d7d0f937ad1c350ba069d7bf72bf, 0xf2ed3e77254acb83231dc0860e1a11242ba627db, 0xc0a02ab94ebe56d045b41b629b98462e3a024a93, 0xf21549bdd1487912f900a7523db5f7626121bba3, 0x886d0a9e17c9c095af2ea2358b89ec705212ee94, 0x211b29cefc79ae976744fdebcebd3cbb32c51303, 0xb8c2703d8c3f2f44c584bc10e7c0a6b64c1c097e, 0xec30addd895b82ee319e54fb04cb2bb03971f36b, 0xb71b62f4b448c02b1201cb5e394ae627b0a560ee, 0xe1334e998379dfe983177062791b90f80ee22d8d, 0x1d633097a85225a1ff4321b12988fdd55c2b3844, 0x8bd8d4c4e943f6c8073921dc17e3e8d7a0761627, 0xa5d96e697d46358d119af7819dc7087f6ae47fef, 0xd0809498c548047a1e2a2aa6a29cd61a0ee268bd, 0x3cd6b7593cbee77830a8b19d0801958fcd4bc57a, 0xead4d2eefb76abae5533961edd11400406b298fc, 0x6331028cbb5a21485bc51b565142993bdb2582a9, 0x163bad4a122b457d64e8150a413eae4d07023e6b, 0xc522e20fbf04ed7f6b05a37b4718d6fce0142e1a, 0x2d9bad6f1ee02a70f1f13def5cccb27a9a274031, 0x5ed0d6338559ef44dc7a61edeb893fa5d83fa1b5, 0xec8c1d7b6aaccd429db3a91ee4c9eb1ca4f6f73c, 0x3896ad743579d38e2302454d1fb6e2ab69e01bfd, 0xe73ccf436725c151e255ccf5210cfce5a43f13e3, 0x9483d98f14a33fdc118d403955c29935edfc5f70, 0x1cfcf7517f0c08459720942b647ad192aa9c8828, 0x8d378f0edc0bb0f0686d6a20be6a7692c4fa24b8, 0x06f68de3d739db41121eacf779aada3de8762107, 0x9909650dd5b1397b8b8b0eb69499b291b0ad1213, 0xb66675142e3111a1c2ea1eb2419cfa42aaf7a234, 0x7836f7ef6bc7bd0ff3acaf449c84dd6b1e2c939f, 0x3ddedbe48923fbf9e536bf9ffb0747c9cdd39eef, 0xc47d610b399250f70ecf1389bab6292c91264f23, 0x51a6d627f66a8923d88d6094c4715380d3057cb6, 0x6c0cc917cbee7d7c099763f14e64df7d34e2bf09, 0xaaaae68b321402c8ebc13468f341c63c0cf03fce, 0x819cdaa5303678ef7cec59d48c82163acc60b952, 0xd071192966eb69c3520fca3aa4dd04297ea04b4e, 0xe53425d8df1f11c341ff58ae5f1438abf1ca53cf, 0x8ffe322997b8e404422d19c54aadb18f5bc8e9b7, 0x305f78d618b990b4295bac8a2dfa262884f804ea, 0x274d69170fe7141401882b886ac4618c6ae40edb, 0x69c94e07c4a9be3384d95dfa3cb9290051873b7b, 0x859c600cf13d1d0273d5d1da3cd789e495899f27, 0xc06cebbbf7f5149a66f7eb976b3e47d56516da2f, 0x37bbc47212d82fcb5ee08f5225ecc2041ad2da7d, 0x11e7997edd904503d77da6038ab0a4c834bbd563, 0xd333627445f2d787901ef33bb2a8a3675e27ffec, 0x16a58e985dccd707a594d193e7cca78b5d027849, 0xf8ae857b67a4a2893a3fbe7c7a87ff1c01c6a6e7, 0x491561db8b6fafb9007e62d050c282e92c4b6bc8, 0x21df1ec24b4e4bfe79b0c095cebae198f291fbd1, 0xe208812a684098f3da4efe6aba256256adfe3fe6, 0xf4ec8e97a20aa5f8dd206f55207e06b813df2cc0, 0x29eb7eefdae9feb449c63ff5f279d67510eb1422, 0x0d678706d037187f3e22e6f69b99a592d11ebc59, 0xde6d363106cc6238d2f092f0f0372136d1cd50c6, 0xc8710d7e8b5a3bd69a42fe0fa8b87c357fddcdc8, 0x5267f4d41292f370863c90d793296903843625c7, 0x4cda41dd533991290794e22ae324143e309b3d3d, 0xf8a50cee2e688ceee3aca4d4a29725d4072cc483, 0x5ed3bbc05240e0d399eb6ddfe60f62de4d9509af, 0x0befb54707f61b2c9fb04715ab026e1bb72042bd, 0xcab9a301e6bd46e940355028eccd40ce4d5a1ac3, 0x64672da3ab052821a0243d1ce4b6e0a36517b8eb, 0xeac0827eff0c6e3ff28a7d4a54f65cb7689d7b99, 0xf4b6cdcfcb24230b337d770df6034dfbd4e1503f, 0x7be2f7680c802da6154c92c0194ae732517a7169, 0x869f1aa30e4455beb1822091de5cadec79a8f946, 0xc4681e73bb0e32f6b726204831ff69baa4877e32, 0x962cd22a8edf1e4f4e55b4b15ddbfb5d9d541971, 0x131df8d330eb7cc7147d0a55576f05de8d26a8b7, 0x19f99f2c0b46ce8906875dc9f90ae104dae35594, 0x91bb3f79022bf3c453f4ff256e269b15cf2c9cbd, 0x7301dc4cf26d7186f2a11bf8b08bf229463f64a3, 0x7cbca88fca6a0060b960985c9aa1b02534dc2208, 0xf3c1abd29dc57b41dc192d0e384d021df0b4f6d4, 0x5d32f6f86e787ff78e63d78b0ef95fe6071852b8, 0x1678c5f2a522393225196361894f53cc752fe2f3, 0x1cf04cb14380059efd3f238b65d5beb86afa14d8, 0x52e1731350f983cc2c4189842fde0613fad50ce1, 0xd0b11d6f2bce945e0c6a5020c3b52753f803f9d1, 0x409bd75085821c1de70cdc3b11ffc3d923c74010, 0x0bb7160aba293762f8734f3e0326ffc9a4cac190, 0x7aad4dbcd3acf997df93586956f72b64d8ad94ee, 0x2dec98329d1f96c3a59caa7981755452d4da49d5, 0xc18ab467feb5a0aadfff91230ff056464d78d800, 0xc90c3765156bca8e4897ab802419153cbe5225a9, 0x85c8f3cc7a354feac99a5e7bfe7cdfa351cfe355, 0xf4fc4d39bc0c2c4068a36de50e4ab4d4db7e340a, 0xf50abbd4aa45d3eb88515465a8ba0b310fd9b521, 0x4d200110124008d56f76981256420c946a6ff45c, 0xf4ba6a46d55140c439cbcf076cc657136262f4f8, 0xfa7adf660b8d99ce15933d7c5f072f3cbeb99d33, 0x84503334630d77f74147f68b2e086613c8f1ade9, 0x31ed858788bda4d5270992221cc04206ec62610d, 0xbfbca418d3529cb393081062032a6e1183c6b2dc, 0x8263ece5d709e0d7ae71cca868ed37cd2fef807b, 0x23ba3864da583dab56f420873c37679690e02f00, 0xcedcb3a1d6843fb6bef643617deaf38f8e98dd5f, 0x8fac748f784a0fed68dba43319b42a75b4649c6e, 0x18b8bcf98321da61fb4e3eacc1ec5417272dc27e, 0x776943ffb2ef5cdd35b83c28bc046bd4f4677098, 0xfb8113f94d9173eefd5a3073f516803a10b286ae, 0x3e8349b67f5745449f659367d9ad4712db5b895a, 0x79cfa9780ae6d87b2c31883f09276986c89a6735, 0x5006fe4c22173980f00c74342b39cd231c653129, 0x13848b46ea75beb7eaa85f59d866d77fd24cf21a, 0xd64a2d50f8858537188a24e0f50df1681ab07ed7, 0x4f9ce2af9b8c5e42c6808a3870ec576f313545d1, 0x8764d02722000996ecd475b433298e9f540b05bf, 0x3b7c77dbe95dc2602ce3269a9545d04965fefdbd, 0xc9dcbb056f4db7d9da39936202c5bd8230b3b477, 0x9ecbabb0b22782b3754429e1757aaba04b81189f, 0x831c44b3084047184b2ad218680640903750c45d, 0xff8eb07de3d49d9d52bbe8e5b26dbe1d160fa834, 0x8ccf3aa21ab742576ad8c422f71bb188591dea8a, 0xddac312a9655426a9c0c9efa3fd82559ef4505bf, 0x9a3e2b1bf346dd070b027357feac44a4b2c97db8, 0x69d39d510889e552a396135bfcdb06e37e387633, 0x83a3148833d9644984f7c475a7850716efb480ff, 0x62b4a9226e61683c72c183254690daf511b4117a, 0x50763add868fd7361178342fc055eaa2b95f6846, 0x91898eab8c05c0222883cd4db23b7795e1a24ad7, 0x066647cfc85d23d37605573d208ca154b244d76c, 0xaaf9ee4b886c6d1e95496fd274235bf4ecfcb07d, 0x06860a93525955ff624940fadcffb8e149fd599c, 0xe81c2d346c0adf4cc56708f6394ba6c8c8a64a1e, 0x41a8e236a30e6d63c1ff644d132aa25c89537e01, 0x6a679e378fdce6bfd97fe62f043c6f6405d79e99, 0x933436c8472655f64c3afaaf7c4c621c83a62b38, 0xabe07ced6ac5ddf991eff6c3da226a741bd243fe, 0xbb56a404723cff20d0685488b05a02cdc35aacaa, 0x0d551ec1a2133c981d5fc6a8c8173f9e7c4f47af, 0x23376ecabf746ce53321cf42c86649b92b67b2ff, 0x644ba6c61082e989109f5c11d4b40e991660d403, 0x680d5911ed8dd9eec45c060c223f89a7f620bbd5, 0xcb1bb6f1da5eb10d4899f7e61d06c1b00fdfb52d, 0x303a30ac4286ae17cf483dad7b870c6bd64d7b4a, 0x7b0b31ff6e24745ead8ed9bb85fc0bf2fe1d55d4, 0x854691ce714f325ced55ce5928ce9ba12facd1b8, 0xa13cfe826d6d1841dcae443be8c387518136b5e8, 0x5fcd84546896dd081db1a320bd4d8c1dd1528c4c, 0x3db5fe6a68bd3612ac15a99a61e555928eeceaf3, 0x7a79e30ff057f70a3d0191f7f53f761537af7dff, 0x3d3fad49c9e5d2759c8e8e5a7a4d60a0dd135692, 0x05a830724302bc0f6ebdaa1ebeeeb46e6ce00b39, 0xe4b6ae22c7735f5b89f34dd77ad0975f0acc9181, 0x3f2dd55db7eab0ebee65b33ed8202c1e992e958b, 0x395d6d255520a8db29abc47d83a5db8a1a7df087, 0x1cc90876004109cd79a3dea866cb840ac364ba1b, 0xc83e9d6a58253beebeb793e6f28b054a58491b74, 0x901d99b699e5c6911519cb2076b4c76330c54d22, 0x3a9132b7093d3ec42e1e4fb8cb31ecdd43ae773c, 0xb41eaf5d51a5ba1ba39bb418dbb54fab750efb1f, 0xaa493d3f4fb866491cf8f800efb7e2324ed7cfe5, 0x509982f56237ee458951047e0a2230f804e2e895, 0x316e92a91bbda68b9e2f98b3c048934e3cc0b416, 0xa3430e1f647f321ed34739562323c7d623410b56, 0xfca43bbc23a0d321ba9e46b929735ce7d8ef0c18, 0xff45cb34c928364d9cc9d8bb00373474618f06f3, 0x8c999591fd72ef7111efca7a9e97a2356b3b000a, 0x8579dadf1a395a3471e20b6f763d9a0ff19a3f6f, 0xc8d4e1599d03b79809e0130a8dc38408f05e8cd3, 0x2abce1808940cd4ef5b5e05285f82df7a9ab5e03, 0x0bb0c12682a2f15c9b5741b2385cbe41f034068e, 0x08b7bdcf944d5570838be70460243a8694485858, 0xc452e0e4b3d6ae06b836f032ca09db409ddfe0fb, 0x48d4f2468f963fd79a006198bb67895d2d5aa4d3, 0xf9e7222faaf0f4da40c1c4a40630373a09bed7b6, 0xbf59aee281fa43fe97194351a9857e01a3b897b2, 0xda0d4b7ef91fb55ad265f251142067f10376ced6, 0x2c6f5c124cc789f8bb398e3f889751bc4b602d9e, 0xc85ef27d820403805fc9ed259fff64acb8d6346a, 0x9aa8308f42910e5ade09c1a5e282d6d91710bdbf, 0x9e4cec353ac3e381835e3c0991f8faa5b7d0a8e6, 0x137cf341e8516c815814ebcd73e6569af14cf7bc, 0x889da662eb4a0a2a069d2bc24b05b4ee2e92c41b, 0x0998d8273115b56af43c505e087aff0676ed3659, 0x3e4d13c55a84e46ed7e9cb90fd355e8ad991e38f, 0xabc068b4979b0ea64a62d3b7aa897d73810dc533, 0xd8fdf546674738c984d8fab857880b3e4280c09e, 0xaff161740a6d909fe99c59a9b77945c91cc91448, 0x92ad1b3d75fba67d54663da9fc848a8ade10fa67, 0x819eb4990b5aba5547093da12b6b3c1093df6d46, 0x643d9aeed4b180947ed2b9207cce4c3ddc55e1f7, 0xab3e62e77a8b225e411592b1af300752fe412463, 0x650b425555e4e4c51718146836a2c1ee77a5b421, 0xba8e46d69d2e2343d86c60d82cf42c2041a0c1c2, 0xf9570e924c95debb7061369792cf2efec2a82d5e, 0x4dc4bf5e7589c47b28378d7503cf96488061dbbd, 0x3d7ea5bf03528100ed8af8aed2653e921b6e6725, 0xa02bde6461686e19ac650c970d0672e76dcb4fc2, 0xb0e760bb07c081777345e0578e8bc898226d4e3b, 0x979cbf21dfec8ace3f1c196d82df962534df394f, 0x9f8245c3ab7d173164861cd3991b94f1ba40a93a, 0xc25cf826550c8eaf10af2234fef904ddb95213be, 0x967bfaf76243cdb9403c67d2ceefdee90a3feb73, 0x0b2113504534642a1daf102eee10b9ebde76e261, 0x74bc4a5e2045f4ff8db184cf3a9b0c065ad807d2, 0xf1da40736f99d5df3b068a5d745fafc6463fc9b1, 0x0fa6c7b0973d0bae2940540e247d3627e37ca347, 0x72b05962fb2ad589d65ad16a22559eba1458f387, 0x6ceae3733d8fa43d6cd80c1a96e8eb93109c83b7, 0x28eaea78cd4d95faecfb68836eafe83520f3bbb7, 0xf49f6f9baabc018c8f8e119e0115f491fc92a8a4, 0x833316985d47742bfed410604a91953c05fb12b0, 0xead75016e3a0815072b6b108bcc1b799acf0383e, 0x0032403587947b9f15622a68d104d54d33dbd1cd, 0x8f64b9c1246d857831643107d355b5c75fef5d4f, 0x15dcafcc2bace7b55b54c01a1c514626bf61ebd8, 0x6886ada7bbb0617bda842191c68c922ea3a8ac82, 0xf736dc96760012388fe88b66c06efe57e0d7cf0a, 0x0b288a5a8b75f3dc4191eb0457e1c83dbd204d25, 0x56b6c23dd2ec90b4728f3bb2e764c3c50c85f144, 0x6310b020fd98044957995092090f17f04e52cdfd, 0xb0baeb30e313776c4c6d247402ba4167afcda1cc, 0x7641f7d26a86cddb2be13081810e01c9c83c4b20, 0x07a8dadec142571a7d53a4297051786d072cba55, 0xcc73dd356b4979b579b401d4cc7a31a268ddce5a, 0xadf1acfe99bc8c14b304c8d905ba27657b8a7bc4, 0x72dabb5b6eed9e99be915888f6568056381608f8, 0x9de20ae76aa08263b205d5142461961e2408d266, 0x9d4ff989b7bed9ab109d10c8c7e55f02d76734ad, 0xe58dd23238ee6ea7c2138d385df500c325f376be, 0x4bd6dd0cff23400e1730ba7b894504577d14e74a, 0x35147430c3106500e79fa2f502462e94703c23b1, 0xc0ae14d724832e2fce2778de7f7b8daf7b12a93e, 0xb57413060af3f14eb479065f1e9d19b3757ae8cc, 0x7d04d2edc058a1afc761d9c99ae4fc5c85d4c8a6, 0x1c94d636e684eb155895ce6db4a2588fba1d001b, 0xc721b2a7aa44c21298e85039d00e2e460e670b9c, 0x2d89a8006a4f137a20dc2bec46fe2eb312ea9654, 0x646afba71d849e80c0ed59cac519b278e7f7abe4, 0x71f2cdd1b046e2da2fbb5a26723422b8325e25a3, 0x2c9fa72c95f37d08e9a36009e7a4b07f29bad41a, 0x848fbd29d67cf4a013cb02a4b176ef244e9ee68d, 0x68190ca885da4231874c1cfb42b1580a21737f38, 0x9adf458bff3599eee1a26398853c575bc38c6313, 0xb72220ade364d0369f2d2da783ca474d7b9b34ce, 0x38e2af73393ea98a1d993a74df5cd754b98d529a, 0x4d38d90f83f4515c03cc78326a154d358bd882b7, 0xaa8eb0823b07b0e6d20aadda0e95cf3835be192e, 0x008639dabbe3aeac887b5dc0e43e13bcd287d76c, 0xfa3a0c4b903f6ea52ea7ab7b8863b6a616ad6650, 0xe26bf322774e18288769d67e3107deb7447707b8, 0xe061a4f2fc77b296d19ada238e49a5cb8ecbfa70, 0xb320834836d1dbfda9e7a3184d1ad1fd4320ccc0, 0x0ed3bb3a4eb554cfca97947d575507cdfd6d21d8, 0x32fa0e86cd087dd68d693190f32d93310909ed53, 0x5b759fa110a31c88469f54d44ba303d57dd3e10f, 0x136f4907cab41e27084b9845069ff2fd0c9ade79, 0x3d89e505cb46e211a53f32f167a877bec87f4b0a, 0x57a852fdb9b1405bf53ccf9508f83299d3206c52, 0x747abc9649056d3926044d28c3ad09ed17b67d70, 0x5c29f9e9a523c1f8669448b55c48cbd47c25e610, 0x30a9da72574c51e7ee0904ba1f73a6b7b83b9b9d, 0x220e2b92c0f6c902b513d9f1e6fab6a8b0def3d7, 0x5af7c072b2c5acd71c76addcce535cf7f8f93585, 0x81556db27349ab8b27004944ed50a46e941a0f5f, 0x987618c85656207c7bac1507c0ffefa2fb64b092, 0xe0f372347c96b55f7d4306034beb83266fd90966, 0x71784c105117c1f68935797fe159abc74e43d16a, 0x9284f96ddb47b5186ee558aa31324df5361c0f73, 0xa60c1209754f5d87b181da4f0817a81859ef9fd8, 0x5afda9405c8e9736514574da928de67456010918, 0x6978696d5150a9a263513f8f74c696f8b1397cab, 0xa9ad1926bc66bdb331588ea8193788534d982c98, 0xe3f80b40fb83fb97bb0d5230af4f6ed59b1c7cc8, 0xe207578e1f4ddb8ff6d5867b39582d71b9812ac5, 0x86883d54cd3915e549095530f9ab1805e8c5432d, 0x6974c8a414ceaefd3c2e4dfdbef430568d9a960b, 0x532d32b00f305bcc24dcef56817d622f34fb2c24, 0x761f8a3a2af0a8bdbe1da009321fb29764eb62a1, 0x4677b04e0343a32131fd6abb39b1b6156bba3d5b, 0xef69781f32ffce33346f2c9ae3f08493f3e82f89, 0xe3b3d2c9bf570be6a2f72adca1862c310936a43c, 0xd19caf39bb377fdf2cf19bd4fb52591c2631a63c, 0x5d68324bcb776d3ffd0bf9fea91d9f037fd6ab0f, 0x1c99fe9bb6c6d1066d912099547fd1f4809eacd9, 0xbbfe0a830cace87b7293993a7e9496ce64f8e394, 0x26c0054b700d3a7c2dcbe275689d4f4cad16a335, 0x7d7e7c61779adb7706c94d32409a2bb4e994bf60, 0xd037d215d11d1df3d54fbd321cd295c5465e273b, 0x08166f02313feae18bb044e7877c808b55b5bf58, 0x781b1501647a2e06c0ed43ff197fccec35e1700b, 0x74316adf25378c10f576d5b41a6f47fa98fce33d, 0x44e2fdc679e6bee01e93ef4a3ab1bcce012abc7c, 0x178eaf6b8554c45dfde16b78ce0c157f2ee31351, 0xcf923a5d8fbc3d01aa079d1cfe4b43ce071b1611, 0x0c28847e4f09dfce5f9b25af7c4e530f59c880fe, 0x54ce88275956def5f9458e3b95decacd484021a0, 0x9d4213339a01551861764c87a93ce8f85f87959a, 0xe559b5fd337b9c5572a9bf9e0f2521f7d446dbe4, 0xdcb03bfa6c1131234e56b7ea7c4f721487546b7a, 0xdb6ff71b3db0928f839e05a7323bfb57d29c87aa, 0xeb7c202b462b7cc5855d7484755f6e26ef43a115, 0x323486ca64b375474fb2b759a9e7a135859bd9f6, 0x2c1df8a76f48f6b54bcf9caf56f0ee1cf57ab33d, 0x2cd87866568dd81ad47d9d3ad0846e5a65507373, 0x8566610901aace38b83244f3a9c831306a67b9dc, 0x1c257ad4a55105ea3b58ed374b198da266c85f63, 0xcf4f1138f1bd6bf5b6d485cce4c1017fcb85f07d, 0xc934becaf71f225f8b4a4bf7b197f4ac9630345c, 0x1e2bf4ba8e5ef18d37de6d6ad636c4cae489d0cc, 0x9d78a975b7db5e4d8e28845cfbe7e31401be0dd9, 0x16aa52cb0b554723e7060f21f327b0a68315fea3, 0x97e28973b860c567402800fbb63ce39a048a3d79, 0x4ac5acad000b8877214cb1ae00eac9a37d59a0fd, 0x01226e0ad8d62277b162621c62c928e96e0b9a8c, 0x479abf2da4d58716fd973a0d13a75f530150260a, 0x31d81d526c195e3f10b5c6db52b5e59afbe0a995, 0x749087ac0f5a97c6fad021538bf1d6cda18e0daa, 0x1565af837ef3b0bd4e2b23568d5023cd34b16498, 0x997d6592a31589acc31b9901fbeb3cc3d65b3215, 0x9d207517422cc0d60de7c237097a4d4fce20940c, 0x24b8b446debd1947955dd084f2c544933346d3ad, 0x107a03cf0842dbdeb0618fb587ca69189ec92ff5, 0x7f603aec1759ea5f07c7f8d41a1428fbbaf9e762, 0x53a244672895480f4a2b1cdf7da5e5a242ec4dbc, 0x7db4c7d5b797e9296e6382f203693db409449d62, 0x2ae82dab92a66389eea1abb901d1d57f5a7cca0b, 0x16bc40215abbd9ae5d280b95b8010b4514ff1292, 0xbba4fac3c42039d828e742cde0efffe774941b39, 0x5431ca427e6165a644bae326bd09750a178c650d, 0xdcf33965531380163168fc11f67e89c6f1bc178a, 0x65fd02d704a12a4dace9471b0645f962a89671c8, 0x135d1719bf03e3f866312479fe338118cd387e70, 0xf3159866c2bc86bba40f9d73bb99f1eee57bb9d7, 0xe3a4621b66004588e31206f718cb00a319889cf0, 0xabcdbc8f1dd13af578d4a4774a62182bedf9f9be, 0x9fbe066de57236dc830725d32a02aef9246c6c5e, 0x81cfad760913d3c322fcc77b49c2ae3907e74f6e, 0x0ab59d390702c9c059db148eb4f3fcfa7d04c7e7, 0x2c2db28c3309375eea3c6d72cd6d0eec145afcc0, 0x08306de51981e7aca1856859b7c778696a6b69f9, 0xf814799f6ddf4dcb29c7ee870e75f9cc2d35326d, 0xee867d20916bd2e9c9ece08aa04385db667c912e, 0x97a86f01ce3f7cfd4441330e1c9b19e1b10606ef, 0x4c759813ad1386bed27ffae9e4815e3630cca312, 0x8f226096c184ebb40105e08dac4d22e1c2d54d30, 0x13acada8980affc7504921be84eb4944c8fbb2bd, 0x122dcfd81addb97d1a0e4925c4b549806e9f3beb, 0x232f525d55859b7d4e608d20487faadb00293135, 0x6f7ac681d45e418fce8b3a1db5bc3be6f06c9849, 0x0c8692eeff2a53d6d1688ed56a9ddbbd68dabba1, 0x6a6337833f8f6a6bf10ca7ec21aa810ed444f4cb, 0x209377b6ad3fe101c9685b3576545c6b1684e73c, 0x560fc08d079f047ed8d7df75551aa53501f57013, 0x8e78f351457d016f4ad2755ec7424e5c21ba6d51, 0x2ce11a92fad024ff2b3e87e3b542e6c60dcbd996, 0x8ab839aeaf2ad37cb78bacbbb633bcc5c099dc46, 0x673144f0ec142e770f4834fee0ee311832f3087b, 0xba8a63f3f40de4a88388bc50212fea8e064fbb86, 0xee899b02cbcb3939cd61de1342d50482abb68532, 0xc2d9eedbc9019263d9d16cc5ae072d1d3dd9db03, 0x355c0c39f5d5700b41d375b3f17851dcd52401f9, 0x8179c80970182cc5b7d82a4df06ea94db63a25f3, 0xb388b5dfecd2c5e4b596577c642556dbfe277855, 0xa9e28337e6357193d9e2cb236b01be44b81427df, 0x04ba4bb87140022c214a6fac42db5a16dd954045, 0x67c926093e9b8927933810d98222d62e2b8206bb, 0xed7346766e1a676d0d06ec821867a276a083bf31, 0x92558226b384626cad48e09d966bf1395ee7ea5d, 0xbdf693f833c3fe471753184788eb4bfe4adc3f96, 0x4474299d0ee090dc90789a1486489c3d0d645e6d, 0xb1178ad47383c31c8134a1941cbcd474d06244e2, 0x979d681c617da16f21bcaca101ed16ed015ab696, 0x6b20c080606a79c73bd8e75b11717a4e8db3f1c3, 0xb85218f342f8012eda9f274e63ce2152b2dcfdab, 0x530b61e42f39426d2408d40852b9e34ab5ebebc5, 0x76afc225f4fa307de484552bbe1d9d3f15074c4a, 0x1e783e522ab7df0acaac9eeed3593039e5ac7579, 0x0f7bf6373f771a4601762c4dae5fbbf4fedd9cc9, 0x7a8797690ab77b5470bf7c0c1bba612508e1ac7d, 0x2a2ab6b74c7af1d9476bb5bcb4524797bedc3552, 0x523e140dc811b186dee5d6c88bf68e90b8e096fd, 0xea8168fbf225e786459ca6bb18d963d26b505309, 0x20ff3ede8cadb5c37b48cb14580fb65e23090a7b, 0xe482d255ede56b04c3e8df151f56e9ca62aaa8c2, 0x2e0880a34596230720f05ac8f065af8681dcb6c2, 0xc674f28c8afd073f8b799691b2f0584df942e844, 0xb646df98b49442746b61525c81a3b04ba3106250, 0xd55c1c8dfbe1e02cacbca60fdbdd405b09f0b75f, 0x65ebaed27edb9dcc1957aee5f452ac2105a65c0e, 0xf079e1b1265f50e8c8a98ec0c7815eb3aeac9eb4, 0x867eba56748a5904350d2ca2a5ce9ca00b670a9b, 0x51ee0cca3bcb10cd3e983722ced8493d926c0866, 0x88d541c840ce43cefbaf6d19af6b9859b573c145, 0xf851b010f633c40af1a8f06a73ebbaab65077ab5, 0xe0aa69365555b73f282333d1e30c1bbd072854e8, 0xc7b1c83e63203f9547263ef6282e7da33b6ed659, 0xaf06f5fa6d1214ec43967d1bd4dde74ab814a938, 0x991173601947c2084a62d639527e961512579af9, 0x7a381122bada791a7ab1f6037dac80432753baad, 0xe766f34ff16f3cfcc97321721f43ddf5a38b0cf4, 0xd785a8f18c38b9bc4ffb9b8fa8c7727bd642ee1c, 0xaebd4f205de799b64b3564b256d42a711d37ef99, 0xa2fa17c0fb506ce494008b9557841c3f641b8cae, 0xa8aca748f9d312ec747f8b6578142694c7e9f399, 0x950c68a40988154d2393fff8da7ccda99614f72c, 0x075d15e2d33d8b4fa7dba8b9e607f04a261e340b, 0x3616d448985f5d32aefa8b93a993e094bd854986, 0x4bb9655cfb2a36ea7c637a7b859b4a3154e26ebe, 0x84949dba559a63bfc845ded06e9f2d9b7f11ef24, 0x937563d8a80fd5a537b0e66d20a02525d5d88660, 0xb183ebee4fcb42c220e47774f59d6c54d5e32ab1, 0x21e5d77320304c201c1e53b261a123d0a1063e81, 0xfa14b566234abee73042c31d21717182cba14aa1, 0x2da617695009cc57d26ad490b32a5dfbeb934e5e, 0x3326b88de806184454c40b27f309d9dd6dcfb978, 0x95e6a54b2d5f67a24a4875af75107ca7ea9fd2fa, 0x8db58e406e202df9bc703c480bd8ed248d52a032, 0xf777361a3dd8ab62e5f1b9b047568cc0b555704c, 0x83a93b5ba41bf88720e415790cdc0b67b4af34c4, 0x8a1cc5ac111c49bfcfd848f37dd768aa65c88802, 0x52214378b54004056a7cc08c891327798ac6b248, 0xad80d865b85c34d2e6494b2e7aefea6b9af184db, 0xe7d6240620f42c5edbb2ede6aec43da4ed9b5757, 0xd0e35e047646e759f4517093d6408642517f084d, 0x9340345ca6a3eabdb77363f2586043f29438ce0b, 0x6640ccf053555c130ae2b656647ea6e31637b9ab, 0x184d86f3466ae6683b19729982e7a7e1a48347b2, 0x84ec06f24700fe42414cb9897c154c88de2f6132, 0xd1e5e234a9f44266a4a6241a84d7a1a55ad5a7fe, 0xe8a9a41740f44f54c3688b53e1ddd42e43c9fe94, 0x6e3a51db743d334d2fe88224b5fe7c008e80e624, 0x3e94df5313fa520570ef232bc3311d5f622ff183, 0x8957727e72cf629020f4e05edf799aa7458062d0, 0xcf5e0eacd1b39d0655f2f77535ef6608eb950ba0, 0xf4aaa3a6163e3706577b49c0767e948a681e16ee, 0x97f1fe4c8083e596212a187728dd5cf80a31bec5, 0x57d5fd0e3d3049330ffcdcd020456917657ba2da, 0x49bdbc7ba5abebb6389e91a3285220d3451bd253, 0xae126b382cf257fad7f0bc7d16297e54cc7267da, 0xbbf8616d97724af3def165d0e28cda89b800009a, 0xadb948b1b6fefe207de65e9bbc2de98e605d0b57, 0x8a217db38bc35f215fd92906be42436fe7e6ed19, 0xe28b062259e96eeb3c8d4104943f9eb325893cf5, 0x6a6b18a45a76467e2e5d5a2ef911c3e12929857b, 0xcb68ae5abe02dcf8cbc5aa719c25814651af8b85, 0x4c7e2e2b77ad0cd6f44acb2861f0fb8b28750ef9, 0x58ba1569650e5bbbb21d35d3e175c0d6b0c651a9, 0x1eb4bf73156a82a0a6822080c6edf49c469af8b9, 0x4103299671d46763978fa4aa19ee34b1fc952784, 0xe321bb4a946adafdade4571fb15c0043d39ee35f, 0x893608751d68d046e85802926673cdf2f57f7cb8, 0x70fee08b00c6c2c04a3c625c1ff77caf1c32df01, 0x7b0fea1176d52159333a143c294943da36bbddb4, 0xd331c823825a9e5263d052d8915d4dcde07a5c37, 0xa45432a6f2ac9d56577b938a37fabac8cc7c461c, 0x764fc46d428b6dbc228a0f5f55c9508c772eab9f, 0x1a95a8a8082e4652e4170df9271cb4bb4305f0b2, 0x08c9f1bfb689fdf804d769f82123360215aff93b, 0x1572cdfab72a01ce968e78f5b5448da29853fbdd, 0x379c7166849bc24a02d6535e2def13daeef8aa8d, 0xe0a254ac09b9725bebc8e460431dd0732ebcabbf, 0x3225c1ca5f2a9c88156bb7d9cdc44a326653c214, 0x84686c7bad762c54b667d59f90943cd14d117a26, 0x3d5a8b2b80be8b35d8ecf789b5ed7a0775c5076c, 0x2ccf80e21898125eb4e807cd82e09b9d28592f6e, 0xdde969aef34ea87ac299b7597e292b4a0155cc8a, 0x19e94e620050aad766b9e1bad931238312d4bf49, 0x959f57fded6ae37913d900b81e5f48a79322c627, 0xb9b0a3219a3288d9b35b091b14650b8fe23dce2b, 0x3575c770668a9d179f1ef768c293f80166e2aa3d, 0x58f05b262560503ca761c61890a4035f4c737280, 0x3286d1bc657a312c8847d93cb3cb7950f2b0c6e3, 0x1d9e6aaf8019a05f230e5def05af5d889bd4d0f2, 0xa375b4bc24a24e1f797593cc302b2f331063fa5c, 0x108ba7c2895c50e072dc6f964932d50c282d3034, 0xb6b34a263f10c3d2eceb0acc559a7b2ab85ce565, 0xa4d2b429f1ad5349e31704969edc5f25ee8aca10, 0x674adb21df4c98c7a347ac4c3c24266757dd7039, 0x33565ba9da2c03e778ce12294f081dfe81064d24, 0x4ddda7586b2237b053a7f3289cf460dc57d37a09, 0xcc4faac00be6628f92ef6b8cb1b1e76aac81fa18, 0x5f99dc8e49e61d57daef606acdd91b4d7007326a, 0xb8a979352759ba09e35aa5935df175bff678a108, 0x86fff220e59305c09f483860d6f94e96fbe32f57, 0x03e8b084537557e709eae2e1e1a5a6bce1ef8314, 0xdda4ff7de491c687df4574dd1b17ff8f246ba3d1, 0x2538532936813c91e653284f017c80c3b8f8a36f, 0x5a82f96cd4b7e2d93d10f3185dc8f43d4b75aa69, 0x86740a46648e845a5d96461b18091ff57be8a16f, 0x7e3f63e13129a221ba1ab06326342cd98b5126ae, 0x1f5f3b34bd134b2781afe5a0424ac5846cdefd11, 0x39936c2719450b9420cc2522cf91db01f227c1c1, 0x967076a877b18ec15a415bb116f06ef32645dba3, 0xa42908e7fe53980a9abf4044e957a54b70e99cbe, 0x5eb371c407406c427b3b7de271ad3c1e04269579, 0xa570223ae3caa851418a9843a1ac55db4824f4fd, 0x764692cccb33405dd0ab0c3379b49caf8e6221ba, 0xa365918bfe3f2627b9f3a86775d8756e0fd8a94b, 0x069ed0ab7aa77de571f16106051d92afe195f2d0, 0xbd432a3916249b4724293af9146e49b8280a7f2a, 0x61c9dce8b2981cb40e98b0402bc3eb28348f03ac, 0x8f1fcc3c51e252b693bc5b0ec3f63529fe69281e, 0x55fd08d18064bd202c0ec3d2cce0ce0b9d169c4d, 0x383a7c899ee18bc214969870bc7482f6d8f3570e, 0xb14cc8de33d6338236539a489020ce4655a32bc6, 0x448bf410ad9bbc2fecc4508d87a7fc2e4b8561ad, 0x06f7dc8d1b9462cef6feb13368a7e3974b097f9f, 0x9c9f89a3910f6a2ae8a91047a17ab788bddec170, 0x5de598aba344378cab4431555b4f79992dc290c6, 0x87e6034ecf23f8b5639d5f0ea70a22538a920423, 0x8b27392206b958cd375d7ef8af2cf8ef0598c0bc, 0x49136fe6e28b7453fcb16b6bbbe9aaacba8337fd, 0x6982fe8a867e93eb4a0bd051589399f2ec9a5292, 0x9fd1052a60506bd1a9ef003afd9d033c267d8e99, 0xd38fa2c4cc147ad06ad5a2f75579281f22a7cc1f, 0x6f794dbdf623daa6e0d00774ad6962737c921ea4, 0xe96b184e1f0f54924ac874f60bbf44707446b72b, 0xb5ba29917c78a1d9e5c5c713666c1e411d7f693a, 0x81d619ff5726f2405f12904c72eb1e24a0aaee4f, 0xb02fa29387ec12e37f6922ac4ce98c5b09e0b00f, 0xb7230d1d1ff2aca366963914a79df9f7c5ea2c98, 0x7b4007c45e5a573fdbb6f8bd746bf94ad04a3c26, 0x8d9a0c70d2262042df1017d6c303132024772712, 0x323aad41df4b6fc8fece8c93958aa901fa680843, 0xdb04fad9c49f9e880beb8fcf1d3a3890e4b3846f, 0x27824666d278d70423f03dfe1dc7a3f02f43e2b5, 0xe04920dc6ecc1d6ecc084f88aa0af5db97bf893a, 0xb0c1b177a220e41f7c74d07cde8569c21c75c2f9, 0x7864dc999fe4f8e003c0f43decc39aae1522dc0f, 0xc75c37ce2da06bbc40081159c6ba0f976e3993b1, 0x179a825e0f1f6e985309668465cffed436f6aea9, 0x2c6b699d9ead349f067f45711a074a641db6a897, 0x068ce8bd6e902a45cb83b51541b40f39c4469712, 0x767ac690791c2e23451089fe6c7083fe55deb62b, 0xb34f04b8db65bba9c26efc4ce6efc50481f3d65d, 0x29aef48de8c9fbad4b9e4ca970797a5533eb722d, 0x0a0ecda6636f7716ef1973614687fd89a820a706, 0xb32825d5f3db249ef4e85cc4f33153958976e8bc, 0x7ef16fd8d15b378a0fba306b8d03dd98fc92619f, 0xb58b52865ea55d8036f2fab26098b352ca837e18, 0x9b658fb361e046d4fcaa8aef6d02a99111223625, 0xb2a498f03bd7178bd8a789a00f5237af79a3e3f8, 0xcb48fe8265d9af55eb7006bc335645b0a3a183be, 0x3cf9a1d465e78b7039e3694478e2627b36fcd141, 0x5db84400570069a9573cab04b4e6b69535e202b8, 0x214c89c5bd8e7d22bc574bb35e48950211c6f776, 0x53396f4a26c2b4604496306c5442e7fcba272e36, 0x720994dbe56a3a95929774e20e1fe525cf3704e4, 0x3571cf7ad304ecaee595792f4bbfa484418549d6, 0x6042c644bae2b96f25f94d31f678c90dc96690db, 0x2e24b597873bb141bdb237ea8a5ab747799af02d, 0x08c802f87758349fa03e6bc2e2fd0791197eea9a, 0x297a88921b5fca10e5bb9ded60025437ae221694, 0xaee49d68adedb081fd43705a5f78c778fb90de48, 0x4cee901b4ac8b156c5e2f8a6f1bef572a7dceb7e, 0xdfaf31e622c03d9e18a0ddb8be60fbe3e661be0a, 0x00aa5381b2138ebeffc191d5d8c391753b7098d2, 0x5b4c0c60f10ed2894bdb42d9dd1d210587810a0d, 0xc44f4ab5bc60397c737eb0683391b633f83c48fa, 0x50bef2756248f9a7a380f91b051ba3be28a649ed, 0x1bd909ac0d4a1102ec98dcf2cca96a0adcd7a951, 0x9ec03e02e587b7769def538413e97f7e55be71d8, 0x9874803fe1f3a0365e7922b14270eaeb032cc1b5, 0x4e2310191ead8d3bc6489873a5f0c2ec6b87e1be, 0x93678a3c57151aeb68efdc43ef4d36cb59a009f3, 0xf483f607a21fcc28100a018c568ffbe140380410, 0x2a91a9fed41b7d0e5cd2d83158d3e8a41a9a2d71, 0x240e559e274aaef0c258998c979f671d1173b88b, 0x108a2b7c336f784779d8b54d02a8d31d9a139c0a, 0x9c98fdf1fdcd8ba8f4c5b04c3ae8587efdf0f6e6, 0x194ff44aefc17bd20efd7a204c47d1620c86db5d, 0x1f8116bd0af5570eaf0c56c49c7ab5e37a580458, 0xd79835e404fb86bf845fba090d6ba25e0c8866a6, 0xa8e7201ff619faffc332e6ad37ed41e301bf014a, 0x286906b6bd4972e3c71655e04baf36260c7cb153, 0xdb4bc83b0e6baadb1156c5cf06e0f721808c52c7, 0xa158148a2e0f3e92dc2ce38febc20107e3253c96, 0x9f6a322a6d469981426ae844865d7ee0bb15c7b3, 0x32f29e8727a74c6b4301e3ffff0687c1b870dae9, 0x19918aa09e7d494e98ffa5db50350892f7156ac6, 0x5a5f8508da0ebebb90be9033bd4d9e274105ae00, 0x6fc25e7e00ca4f60a9fe6f28d1fde3542e2d1079, 0x72094f3951ffc9771dced23ada080bcaf9c7cca7, 0x43f7e86e381ec51ec4906d1476cba97a3db584e4, 0x05696b73916bd3033e05521e3211dfec026e98e4, 0x5e7f70378775589fc66a81d3f653e954f55560eb, 0x895613236f3584216ad75c5d3e07e3fa6863a778, 0x4eb1454b573805c8aca37edec7149a41f61202f4, 0xd99999a2490d9494a530cae4daf38554f4dd633e, 0x1704cefcfb1331ec7a78388b29393e85c1af7916, 0xac4acfc36ed6094a27e118ecc911cd473e8fb91f, 0xa975b077fcb4cc8efcbf838459b6fa243a4159d6, 0x9c405cf697956138065e11c5f7559e67245bd1a5, 0xcafde855864c2598da3cafc05ad98df2898e8048, 0x8ef711e43a13918f1303e81d0ea78c9eefd67eb2, 0x0b14891999a65c9ef73308efe3100ca1b20e8192, 0x47cf9cdaf92fc999cc5efbb7203c61e4f1cdd4c3, 0x04ba8a3f03f08b895095994dda619edaacee3e7a, 0x02b6d65cb00b7b36e1fb5ed3632c4cb20a894130, 0xf99aee444b5783c093cfffd1c4632cf93c6f050c, 0x2541314a0b408e95a694444977712a50713591ab, 0x3096dca34108085bcf04ae72b94574a13e1a3e1d, 0x56df05bad46c3f00ae476ecf017bb8c877383ff1, 0x6d59b21cd0e2748804d9abe064eac2bef0c95f27, 0xb29f5b7c1930d9f97a115e067066f0b54db44b3b, 0x888c16144933197cac26504dd76e06fd6600c789, 0xdfe3c52a92c30396a4e33a50170dc900fcf8c9cf, 0xf76f69cee4faa0a63b30ae1e7881f4f715657010, 0xee0007b0960d00908a94432a737557876aac7c31, 0xeffc15e487b1beda0a8d1325bdb4172240dc540a, 0x40ab0a3e83d0c8ac9366910520eab1772bac3b1a, 0x1895a0eb4a4372722fcbc5afe6936f289c88a419, 0x81efe296ae76c860d1c5fbd33d47e8ce9996d157, 0x9ddd355e634ee9927e4b7f6c97e7bf3a2f1e687a, 0xf2b4ab2c9427a9015ef6eefff5edb60139b719d1, 0x765be2e12f629e6349b97d21b62a17b7c830edab, 0xff61c9c1b7a3d8b53bba20b34466544b7b216644, 0x36a08fd6fd1ac17ce15ed57eefb12a2be28188bf, 0x17049311101d817efb1d65910f663662a699c98c, 0x30511832918d8034a7bee72ef2bfee440ecbbcf6, 0xd27c234ff7accace3d996708f8f9b04970f97d36, 0xa961171f5342b173dd70e7bfe5b5ca238b13bcdd, 0x30bf61b2d877fe10635126326fa189e4b0b1c3b0, 0x4bb6d86b8314c22d8d37ea516d0019f156aae12d, 0x5f363e0ab747e02d1b3b66abb69ea53c7baf523a, 0x283e11203749b1fa4f32febb71e49d135919382a, 0xac5999a89d2dd286d5a80c6dee7e86aad40f9e12, 0x3f6dd3650ee428dcb7759553b017a96a94286ac9, 0xb3fc1d6881abfcb8becc0bb021b8b73b7233dd91, 0xf0832a6bb25503eeca435be31b0bf905ca1fcf57, 0x9d7fda7070bf3ee9bbd9a41f55cad4854ae6c22c, 0x4b0bd8acfcbc53a6010b40d4d08ddd2d9d69622d, 0xf3b668b3f14d920ebc379092db98031b67b219b3, 0xd91d889164479ce436ece51763e22cda19b22d6b, 0xffe28db53c9044b4ecd4053fd1b4b10d7056c688, 0xc77b01a6e911fa988d01a3ab33646beef9c138f3, 0xc0064f1d9474ab915d56906c9fb320a2c7098c9b, 0x4e3edad4864dab64cae4c5417a76774053dc6432, 0x71d2cc6d02578c65f73c575e76ce8fbcfadcf356, 0x9971df60f0ae66dce9e8c84e17149f09f9c52f64, 0x58e661d0ba73d6cf24099a5562b808f7b3673b68, 0x84b0ee6bb837d3a4c4c5011c3a228c0edab4634a, 0x84375afbf59b3a1d61a1be32d075e0e15a4fbca5, 0x9ae9476bfecd3591964dd325cf8c2a24faed82c1, 0x6a4c8907b600248057b1e46354b19bdc859c991a, 0x1c045649cd53dc23541f8ed4d341812808d5dd9c, 0xc5e488cf2b5677933971f64cb8202dd05752a2c0, 0xeb25481fcd9c221f1ac7e5fd1ecd9307a16215b8, 0xa61887818f914a20e31077290b83715a6b2d6ef9, 0x679437eacf437878dc293d48a39c87b7421a216c, 0x331a1c26cc6994cdd3c14bece276ffff4b9df77c, 0x75b95696e8ec4510d56868a7c1a735c68b244890, 0xa77f3ee19e9388bbbb2215c62397b96560132360, 0xbc7afc8477412274fc265df13c054473427d43c6, 0x91050a5cffadedb4bb6eaafbc9e5013428e96c80, 0x24586ec5451735eeaaeb470dc8736aae752f82e5, 0x51039377eed0c573f986c5e8a95fb99a59e9330f, 0xfbb161fe875f09290a4b262bc60110848f0d2226, 0xed52a2cc0869dc9e9f842bd0957c47a8e9b0c9ff, 0xbad235d5085dc7b068a67c412677b03e1836884c, 0x055eac4f1ad3f58f0bd024d68ea60dbe01c6afb3, 0x4058808816fdaa3a5fc98ed47cfae6c18315422e, 0x3540c7bd7a8442d5bee21a2180a1c4edff1649e0, 0xc5edbbd2ca0357654ad0ea4793f8c5cecd30e254, 0xb5906b0ae9a28158e8ac550e39da086ee3157623, 0x4d801093c19ca9b8f342e33cc9c77bbd4c8312cf, 0x206482ee6f138a778fe1ad62b180ce856fbb23e6, 0xc0ed0d4ad10de03435b153a0fc25de3b93f45204, 0x29e67990e1b6d52e1055ffe049c53195a81542cf, 0xe6d22209ffd0b87509ade3a8e2ef429879cb89b5, 0xd6644d40e90bc97fe7dfe7cabd3269fd579ba4b3, 0xece1290877b583e361a2d41b009346e6274e2538, 0xab3861226ffec1289187fb84a08ec3ed043264e8, 0x60e0bdd0a259bb9cb09d3f37e5cd8b9daceabf8a, 0x28b77585cb3d55a199ab291d3a18c68fe89a848a, 0x73128173489528012e76b41a5e28c68ba4e3a9d4, 0x018492488ba1a292342247b31855a55905fef269, 0x0bb54c72fd6610bfa4363397e020384b022b0c49, 0x520f66a0e2657ff0ac4195f2f064cf2fa4b24250, 0xa1432ed2c6b7777a88e8d46d388e70477f208ca5, 0x149ba10f0da2725dc704733e87f5a524ca88515e, 0xb287f7f8d8c3872c1b586bcd7d0aedbf7e732732, 0xc46bbdef76d4ca60d316c07f5d1a780e3b165f7e, 0xb5a589dd9f4071dbb6fba89b3f5d5dae7d96c163, 0xd218efb4db981cdd6a797f4bd48c7c26293ceb40, 0xaf87d2371ef378957fbd05ba2f1d66931b01e2b8, 0x86ef6426211949cc37f4c75e7850369d0cf5f479, 0xfb3a0b0d6b6a718f6fc0292a825dc9247a90a5d0, 0xda16dd5c3d1a2714358fe3752cae53dbab2be98c, 0x9eb7834e171d41e069a77947fca87622f0ba4e48, 0xe1d91b0954cede221d6f24c7985fc59965fb98b8, 0x85d0d88754ac84b8b21ba93dd2bfec72626faba8, 0x695b4cce085856d9e1f9ff3e79942023359e5fbc, 0x9156d18029350e470408f15f1aa3be9f040a67c6, 0xa9d64b4f3bb7850722b58b478ba691375e224e42, 0x17e4a0e52bac3ee44efe0954e753d4b85d644e05, 0xb8a79c84945e47a9c3438683d6b5842cff7684b1, 0xcfac2e1bf33205b05533691a02267ee19cd81836, 0x6b992521ec852370848ad697cc2df64e63cc06ff, 0x60af0ee118443c9b37d2fead77f5e521debe1573, 0xc6dbdb9efd5ec1b3786e0671eb2279b253f215ed, 0x659c0a72c767a3a65ced0e1ca885a4c51fd9b779, 0xed1276513b6fc68628a74185c2e20cbbca7817bf, 0x5ad12c5ed4fa827e2150cfa0d68c0aa37b1769b8, 0x17c0fef6986cfb2e4041f9979d9940b69dff3de2, 0xca98c7988efa08e925ef9c9945520326e9f43b99, 0xfe8f1fdcab7fbec9a6a3fcc507619600505c36a3, 0x4420aa35465be617ad2498f370de0a3cc4d230af, 0x8232d1f9742edf8dd927da353b2ae7b4cbce7592, 0xeca5f58792b8c62d2af556717ee3ee3028be4dce, 0x6bf86f1e2f2b8032a95c4d7738a109d3d0ed8104, 0x3ac2f0ff1612e4a1c346d53382abf6d8a25baa53, 0xdaa1bd7a9148fb865cd612dd35f162861d0f3bdc, 0x5169c60aee4ceed1849ab36d664cff97061e8ea8, 0x2a5e3a40d2cd0325766de73a3d671896b362c73b, 0xa83382b6e15267974a8550b98f7176c1a353f9be, 0xb50c149a1906fad2786ffb135aab501737e9e56f, 0xd9775965b716476675a8d513eb14bbf7b07cd14a, 0x66662006015c1f8e3ccfcaebc8ee6807ee196303, 0x78746a958dced4c764f876508c414a68342cecb9, 0xe982e6f28c548f5f96f45e63f7ab708724f53fa1, 0x740bfd52e01667a3419b029a1b8e45576a86a2db, 0x2bd252e0d732ff1d7c78f0a02e6cb25423cf1b1a, 0x2e2d7ea66b9f47d8cc52c01c52b6e191bc7d4786, 0x3e3161f1ea2fbf126e79da1801da9512b37988c9, 0x7e2ba86da52e785d8625334f3397ba1c4bf2e8d1, 0x7608f437b31f18bc0b64d381ae86fd978ed7b31f, 0x25a5a44d38a2f44c6a9db9cdbc6b1e2e97abb509, 0x745ad3abc6eeeb2471689b539e789ce2b8268306, 0x09e437d448861228a232b62ee8d37965a904ed9c, 0xbe53322f43fbb58494d7cce19dda272b2450e827, 0x4166fc08ca85f766fde831460e9dc93c0e21aa6c, 0x99c0174cf84e0783c220b4eb6ae18fe703854ad3, 0x3cf484524fbdfadae26dc185e32b2b630fd2e726, 0xfdcd5d80b105897a57abc47865768b2900524295, 0xf22f4078febbbaa8b0e78e642c8a42f35d433905, 0xeac768bf14b8f9432e69eaa82a99fbeb94cd0c9c, 0x2639eee9873ceec26fcc9454b548b9e7c54aa65c, 0xc3c3c2510d678020485a63735d1307ec4ca6302b, 0xb73d6a77559c86cf6574242903394bacf96e3570, 0x5ce2e7ceaaa18af0f8aafa7fbad74cc89e3cd436, 0x03377c0e556b640103289a6189e1aeae63493467, 0x6eb0a5a9ae96d22cf01d8fd6483b9f38f08c2c8b, 0xfc8215a0a69913f62a43bf1c8590b9ddcd0d8ddb, 0x4a835c25824c47ecbfc79439bf3f5c3481aa75cd, 0xb5493ef173724445cf345c035d279ba759f28d51, 0xb9e90c1192b3d5d3e3ab0700f1bf655f5dd4347a, 0x419bde7316cc1ed295c885ace342c79bf7ee33ea, 0xe4625501f52b7af52b19ed612e9d54fdd006b492, 0xe9d599456b2543e6db80ea9b210e908026e2146e, 0x2c06dd922b61514aafedd84488c0c28e6dcf0e99, 0x06b5ede6fdf1d6e9a34721379aeaa17c713dd82a, 0xd8930a39c77357c30ad3a060f00b06046331fd62, 0xb2a2c2111612fb8bbb8e7dd9378d67f1a384f050, 0x1f174f40a0447234e66653914d75bc003e5690dc, 0xe06cb6294704eea7437c2fc3d30773b7bf38889a, 0xcd06f8c1b5cdbd28e2d96b6346c3e85a0483ba24, 0xf316ef1df2ff4d6c1808dba663ec8093697968e0, 0x1e6915ebd9a19c81b692ad99b1218a592c1ac7b1, 0x885493bda36a0432976546c1ddce71c3f4570021, 0x18b0407cdad4ce52600623bd5e1f6a81ab61f026, 0x187d9f0c07f8eb74faaad15ebc7b80447417f782, 0x5d6ccf806738091042ad97a6e095fe8c36aa79c5, 0x53437fecf34ab9d435f4deb8ca181519e2592035, 0xfd1faa347b0fcc804c2da86c36d5f1d18b7087bb, 0x650cf67db060cce17568d5f2a423687c49647609, 0xbcd95ef962462b6edfa10fda87d72242fe3edb5c, 0x3b5e8b3c77f792decb7a8985df916efb490aac23, 0xf13b083093ba564e2dc631568cf7540d9a0ec719, 0x373c547e0cb5ce632e1c5ad66155720c01c40995, 0x7313461208455455465445a459b06c3773b0eb30, 0x441f37e8a029fd02482f289c49b5d06d00e408a4, 0xd30d4c43adcf55b2cb53d68323264134498d89ce, 0xf648ea89c27525710172944e79edff847803b775, 0x0c7f869f8e90d53fdc03e8b2819b016b9d18eb26, 0xc71f92a3a54a7b8c2f5ea44305fccb84eee23148, 0x7988901331e387f713faceb9005cb9b65136eb14, 0xe9a39a8bac0f01c349c64cedb69897f633234ed2, 0xad2a5c00f923aaf21ab9f3fb066efa0a03de2fb2, 0xf25259a5c939cd25966c9b6303d3731c53ddbc4c, 0xd1682c2159018dc3d07f08240a8c606daf65f8e1, 0xa99991cebd98d9c838c25f7a7416d9e244ca250d, 0x5a285755391e914e58025faa48cc685f4fd4f5b8, 0x4d24b7ac47d2f27de90974ba3de5ead203544bcd, 0x21b182f2da2b384493cf5f35f83d9d1ee14f2a21, 0x31ab088966ecc7229258f6098fce68cf39b38485, 0x4977a7939d0939689455ce2639d0ee5a4cd910ed, 0x07af938c1237a27c9030094dcf240750246e3d2c, 0x4e2bfa4a466f82671b800eee426ad00c071ba170, 0x107379d4c467464f235bc18e55938aad3e688ad7, 0xf7b29b82195c882dab7897c2ae95e77710f57875, 0x56586391040c57eec6f5affd8cd4abde10b50acc, 0xac608e2bac9dd20728d2947effbbbf900a9ce94b, 0x48548b4ba62bcb2f0d34a88dc69a680e539cf046, 0x1665ab1739d71119ee6132abbd926a279fe67948, 0xaf4493e8521ca89d95f5267c1ab63f9f45411e1b, 0xbf6925c00751008440a6739a02bf2b6cdaab5e3a, 0x3fe40fbd919aad2818df01ee4df46c46842ac539, 0x455b9296921a74d1fc41617f43b8303e6f3ed76c, 0x7086b4bde3e35d4aeb24b825f1a215f99d85f745, 0xd4ee4919fb37f2bb970c3fff54aaf1f3dda6c03f, 0xa4489a50ead5d5445a7bee4d2d5536c2a76c41f8, 0x505e4f7c275588c533a20ebd2ac13b409bbdea3c, 0x3bb53598cc20e2055dc553b049404ac9b7dd1e83, 0x52cd20403ba7eda6bc307a3d63b5911b817c1263, 0xa211da03cc0e31ecce5309998718515528a090df, 0xbcb422dc4dd2aae94abae95ea45dd1731bb6b0ba, 0xcbde9734b8e6aa538c291d6d7facedb0f338f857, 0x171ca02a8b6d62bf4ca47e906914079861972cb2, 0xd40d0055fd9a38488aff923fd03d35ec46d711b3, 0x3887192c7f705006b630091276b39ac680448d6b, 0x3f3c8e61e5604cef0605d436dd22accd862217fc, 0x4258fd662fc4ce3295f0d4ed8f7bb1449600a0a9, 0x4571de672b9904bad8743692c21c4fdcea4c2e01, 0x5be045512a026e3f1cebfd5a7ec0cfc36f2dc16b, 0xd6300b3215b11de762ecde4b70b7927d01291582, 0xf9e37447406c412197b2e2aebc001d6e30c98c60, 0xbd047ff1e69cc6b29ad26497a9a6f27a903fc4dd, 0x23fa7eb51a48229598f97e762be0869652dffc66, 0x6679aeecd87a57a73f3356811d2cf49d0c4d96dc, 0x23c55aeb5739876f0ac8d7ebea13be729685f000, 0x757b65876dbf29bf911d4f0692a2c9beb1139808, 0xe8fc36b0131ec120ac9e85afc10ce70b56d8b6ba, 0x1a89899cbebdbb64bb26a195a63c08491fcd9eee, 0x6edf7f5283725c953ee64317f66188af1184b033, 0x297385e88634465685c231a314a0d5dcd146af01, 0x018f20a27b27ec441af723fd9099f2cbb79d6263, 0xa5a4227f6cf98825c0d5baff5315752ccc1a1391, 0x69517083e303d4fbb6c2114514215d69bc46a299, 0x1dab172effa6fbee534c94b17e794edac54f55f8, 0xc6ee35934229693529dc41d9bb71a2496658b88e, 0xa8ee1df5d44b128469e913569ef6ac81eeda4fc8, 0x35bd246865fab490ac087ac1f1d4f2c10d0cda03, 0x4bf8bf1d35a231315764fc8001809a949294fc49, 0xc70fa45576bf9c865f983893002c414926f61029, 0xfdeaac2acf1d138e19f2fc3f9fb74592e3ed818a, 0xbfbfbcb656c2992be8fcde8219fbc54aadd59f29, 0x1722c4cbe70a94b6559d425084caeed4d6e66e21, 0x00e681bc2d10db62de85848324492250348e90bf, 0x5c308bac4857d33baea074f3956d3621d9fa28e1, 0x68c08490c89bf0d6b6f320b1aca95c8312c00608, 0xce1884ddbbb8e10e4dba6e44feeec2a7e5f92f05, 0x427417bd16b1b3d22dbb902d8f9657016f24a61c, 0x5ff93de6ee054cad459b2d5eb0f6870389dfcb74, 0x71946b7117fc915ed107385f42d99ddac63249c2, 0x11ec00f849b6319cf51aa8dd8f66b35529c0be77, 0x610fd6ee4eebab10a8c55d0b4bd2e7d6ef817156, 0xa422e4bf0bf74147cc895bed8f16d3cef3426154, 0x745aecbaf9bb39b74a67ea1ce623de368481baa6, 0x9f496cb2069563144d0811677ba0e4713a0a4143, 0xc500b720734ed22938d78c5e48b2ba9367a575ba, 0xcd072e6e1833137995196d7bb1725fef8761f655, 0x94644ad116a41ce2ca7fbec609bdef738a2ac7c7, 0xe8d942d82f175ecb1c16a405b10143b3f46b963a, 0xf73dd9c142b71bce11d06e30e7e7d032f2ec9c9e, 0x1327d759d56e0ab87af37ecf63fe01f310be100a, 0x28fa2580f9ebe420f3e5eefdd371638e3b7af499, 0x024bdd2c7bfd500ee7404f7fb3e9fb31dd20fbd1, 0xb4b14bf45455d0ab0803358b7524a72be1a2045b, 0xb1e2dd95e39ae9775c55aeb13f12c2fa233053ba, 0x35b03ea4245736f57b85d2eb79628f036ddcd705, 0xeb2ef3d38fe652403cd4c9d85ed7f0682cd7c2de, 0x690594d306613cd3e2fd24bca9994ad98a3d73f8, 0x8397a1bc47acd647418159b99cea57e1e6532d6e, 0xb44815a0f28e569d0e921a4ade8fb2642526497a, 0xe24109be2f513d87498e926a286499754f9ed49e, 0x37ac29bda93f497bc4aeaab935452c431510341e, 0x4a81abe4984c7c6bef63d69820e55743c61f201c, 0x66dcc5fb4ee7fee046e141819aa968799d644491, 0x43ff38743ed0cd43308c066509cc8e7e72c862aa, 0xb8f20005b61352ffa7699a1b52f01f5ab39167f1, 0x1cda411bd5163baeca1e558563601ce720e24ee1, 0x86245f596691093ece3f3d3ca2263eace81941d9, 0xf52a5882e8927d944b359b26366ba2b9cacfbae8, 0x118c18b2dce170e8f445753ba5d7513cb7636d2d, 0x7168b3bb8c167321d9bdb023a6e9fd11afc9afd9, 0xd9103bb6b67a55a7fece2d1af62d457c2178946d, 0x8b9fda7d981fe9d64287f85c94d83f9074849fcc, 0x91211712719f2b084d3b3875a85069f466363141, 0x4863849739265a63b0a2bf236a5913e6f959ce15, 0xc2d1778ef6ee5fe488c145f3586b6ebbe3fbb445, 0x2b77a4d88c0d56a3dbe3bae04a05f4fcd1b757e1, 0xfe9c0fffefb803081256c0cf4d6659e6d33eb4fb, 0x893017ff1adad499aa065401b4236ce6e92b625a, 0x073c67e09b5c713c5221c8a0c7f3f74466c347b0, 0x93e303411afaf6c107a44101c9ac5b36e9d6538b, 0x0ec50aa823f465b9464b0bc0c4a57724a555f5d6, 0xa3e3a6ea509573e21bd0239ece0523a7b7d89b2f, 0xc069ef0eb34299abd2e32dabc47944b272334824, 0x28a3da09a8194819ae199f2e6d9d1304817e28a5, 0xe9495ba5842728c0ed97be37d0e422b98d69202c, 0xbba976f1a1215f7512871892d45f7048acd356c8, 0x887cac41cd706f3345f2d34ac34e01752a6e5909, 0xe0e0b2e29dde73af75987ee4446c829a189c95bc, 0x4a5fae3b0372c230c125d6d470140337ab915656, 0x425177eb74ad0a9d9a5752228147ee6d6356a6e6, 0x5db7bba1f9573f24115d8c8c62e9ce8895068e9f, 0xfa6a37f018e97967937fc5e8617ba1d786dd5f77, 0x45e3a93e72144ada860cbc56ff85145ada38c6da, 0x67da922effa472a6b124e84ea8f86b24e0f515aa, 0xaa9bd4589535db27fa2bc903ca17d679dd654806, 0x16a9e9b73ae98b864d1728798b8766dbc6ea8d12, 0xd6580ab5ed4c7dfa506fa6fe64ad5ce129707732, 0x984a7985e3cc7eb5c93691f6f8cc7b8f245d01b2, 0x7746b6c6699c8f34ca2768a820f1ffa4c207fe05, 0x2fa491fb5920a6574ebd289f39c1b2430d2d9a6a, 0xfae76719d97eac41870428e940279d97dd57b2f6, 0x41b2dbd79dda9b864f6a7030275419c39d3efd3b, 0xdd8254121a6e942fc90828f2431f511dad7f32e6, 0x37fac1e6bc122e936dfb84de0c4bef6e0d60c2d7, 0x3a10888b7e149cae272c01302c327d0af01a0b24, 0x401354a297952fa972ad383ca07a0a2811d74a71, 0x51865db148881951f51251710e82b9be0d7eadb2, 0xbbbd6ecbb5752891b4ceb3cce73a8f477059376f, 0x3f236108eec72289bac3a65cd283f95e041d144c, 0xdc83b6fd0d512131204707eaf72ea0c8c9bef976, 0x036eeff5ba90a6879a14dff4c5043b18ca0460c9, 0xfac5ca94758078fbfccd19db3558da7ee8a0a768, 0xd0d62c47ea60fb90a3639209bbfdd4d933991cc6, 0x891cb8238c88e93a1bcf61db49bd82b47a7f4f84, 0xdf53003346d65c5e7a646bc034f2b7d32fcbe56a, 0x6e89c51ea6de13e06cdc748b67c4410fe9bcab03, 0xa61cdbadf04b1e54c883de6005fcdf16beb8eb2f, 0xe3951de5aefaf0458768d774c254f7157735e505, 0xf2732cf2c13b8bb8e7492a988f5f89e38273ddc8, 0x4752218e54de423f86c0501933917aea08c8fed5, 0x152f4e860ef3ee806a502777a1b8dbc91a907668, 0x15b96f30c23b8664e7490651066b00c4391fbf84, 0x8693e9b8be94425eef7969bc69f9d42f7cad671e, 0xf41557dfdfb1a1bdcefefe2eba1e21fe0a4a9942, 0x38458e0685573cb4d28f53098829904570179266, 0x53e4d9696dcb3f4d7b3f70dcaa4eecb71782ff5c, 0x2dca0e449ab646dbdfd393a96662960bcab5ae1e, 0x87d7ac0653ccc67aa9c3469eef4352193f7dbb86, 0xae9f5c3fbbe0c9bcbf1af8ff74ea280b3a5d8b08, 0x7751f363a0a7fd0533190809ddaf9340d8d11291, 0x708a2af425ceb01e87ffc1be54c0f532b20eacd6, 0xac122a03cd058c122e5fe17b872f4877f9df9572, 0x5da4ca88935c27f55c311048840e589e04a8a049, 0xe67c2c1665c88338688187629f49e99b60b2d3ba, 0xdec82373ade8ebcf2acb6f8bc2414dd7abb70d77, 0x47c247f53b9fbeb17bba0703a00c009fdb0f6eae, 0x9a522e52c195bfb7cf5ffaaedb91a3ba7468161d, 0x3159e90c48a915904adfe292b22fa5fd5e72796b, 0xdefddfd59b8d2c154eecf5c7c167bf0ba2905d3e, 0xad1d68a038fd2586067ef6d135d9628e79c2c924, 0x038e45eadd3d88b87fe4dab066680522f0dfc8f9, 0x2561ec0f379218fe5ed4e028a3f744aa41754c72, 0xb95396daaa490df2569324fcc6623be052f132ca, 0x2376ada90333b1d181084c97e645e810aa5b76f1, 0x07800d2f8068e448c79a4f69b1f15ef682aae5f6, 0xadeb204aa0c38e179e81a94ed8b3e7d53047c26b, 0x0dc100b107011c7fc0a1339612a16ccec3285208, 0xf0b1340b996f6f0bf0d9561c849caf7f4430befa, 0xe1443dbd95cc41237f613a48456988a04f683282, 0xd3c6f1e0f50ec3d2a67e6bcd193ec7ae38f1657f, 0xb68899e7610d4c93a23535bcc448945ba1666f1c, 0xa7253763cf4a75df92ca1e766dc4ee8a2745147b, 0x75d67ce14e8d29e8c2ffe381917b930b1aff1a87, 0x493d48bda015a9bfcf1603936eab68024ce551e0, 0x7ddd57165c87a2707f025dcfc2508c09834759bc, 0xcff7f89a4d4219a38295251331568210ffc1c134, 0x168d30e53fa681092b52e9bae15a0dcb41a8c9bb, 0x99b743d1d9eff90d9a1934b4db21d519d89b4a38, 0xa3d0b03cffbb269f796ac29d80bfb07dc7c6ad06, 0x816d9772cf11399116cc1e72c26c6774c9edd739, 0xa880e2a8bf88a1a82648b4013c49c4594c433cc8, 0x2a44a7218fe44d65a1b4b7a7d9b1c2c52c8c3e34, 0xcb86edbc8bbb1f9131022be649565ebdb09e32a1, 0x3915eab5ab2e5977d075dec47d96b68b4b5cf515, 0x8165cab0eafb5a328fc41ac64dae715b2eef2c65, 0x416c86b72083d1f8907d84efd2d2d783dffa3efb, 0xc524086d46c8112b128b2faf6f7c7d8160a8386c, 0x902d74a157f7d2b9a3378b1f56703730e03a1719, 0x74ef2869cbe608856045d8c2041118579f2236ea, 0xaf992dd669c0883e5515d3f3112a13f617a4c367, 0x4c6a248fc97d705def495ca20759169ef0d36471, 0x974d2f17895f2902049deaaecf09c3046507402d, 0x0239b4f21f8e05cd01512b2be7a0e18a6d974607, 0xb97a6733cd5fe99864b3b33460d1672434d5cafd, 0xf558a2b2dd26dd9593aae04531fd3c3cc3854b67, 0xb577b6befa054e9c040461855094b002d7f57bd7, 0x73bfe7710f31cab949b7a2604fbf5239cee79015, 0x5717f2d8f18ffcc0e5fe247d3a4219037c3a649c, 0x20707e425d2a11d2c89f391b2b809f556c592421, 0x9a6708ddb8903c289f83fe889c1edcd61f854423, 0xfa27cc49d00b6c987336a875ae39da58fb041b2e, 0xd688e785c98f00f84b3aa1533355c7a258e87948, 0x927cb7dc187036b5427bc7e200c5ec450c1d27d4, 0xb2bfaa58b5196c5cb7f89de15f479d1838de713d, 0xe180de9e86f57bafacd7904f9826b6b4b26337a3, 0xa1204dad5f560728a35c0d8fc79481057bf77386, 0x6b0da25af267d7836c226bcae8d872d2ce52c941, 0x0517448dada761cc5ba4033ee881c83037036400, 0x7ed0a5a847bef9a9da7cba1d6411f5c316312619, 0x5b5d517029321562111b43086d0b043591109a70, 0x56fc1a7bad4047237ce116146296238e078f93ad, 0x6c5422fb4b14e6d98b6091fdec71f1f08640419d, 0x108fe8ee2a13da487b22c6ab6d582ea71064d98c, 0x0ad3e44d3c001fa290b393617030544108ac6eb9, 0x25aee68d09afb71d8817f3f184ec562f7897b734, 0xc2340a4ca94c9678b7494c3c852528ede5ee529f, 0x44901e0d0e08ac3d5e95b8ec9d5e0ff5f12e0393, 0x8775a610c502b9f1e6ad4cdadb8ce29bff75f6e4, 0x682897bc4f8e89029120fcffb787c01a93e64184, 0xf7acff934b84da0969dc37a8fcf643b7d7fbed41, 0xf05fcd4c0d73aa167e5553c8c0d6d4f2faa39757, 0xc981d312d287d558871edd973abb76b979e5c35e, 0x9da61ccd62bf860656e0325d7157e2f160d93bb5, 0xd284a50382f83a616d39b8a9c0f396e0ebbfa95d, 0xd6cf5c1bcf9da662bcea2255905099f9d6e84dcc, 0xc71b2a3d7135d2a85fb5a571dcbe695e13fc43cd, 0xb22dadd7e1e05232a93237baed98e0df92b1869e, 0xb09fe6d4349b99bc37938054022d54fca366f7af, 0x427e4751c3babe78cff8830886febc10f9908d74, 0x60b358cb3dbefa37f47df2d7365840da8e3bc98c, 0xdcd5bca2005395b675fde5035659b26bfefc49ee, 0x81186931184137d1192ac88cd3e1e5d0fdb86a74, 0xde212293f8f1d231fa10e609470d512cb8ffc512, 0x1937c5c515057553ccbd46d5866455ce66290284, 0x592777261e3bd852c48eca95b3a44c5b7f2d422c, 0xbbf84292d954acd9e4072fb860b1504106e077ae, 0x3b4100e30a73b0c734b18ffa8426d19b19312f1a, 0xa03a3dc7c533d1744295be955d61af3f52b51af5, 0x4aa148c2c33401e66a2b586e6577c4b292d3f240, 0xff850e3be1eb6a4d726c08fa73aad358f39706da, 0x743651b55ef8429df50cf81938c2508de5c8870f, 0x3700e3027424d939dbde5d42fb78f6c4dbec1a8f, 0xc1cbd2e2332a524cf219b10d871ccc20af1fb0fa, 0xe25b9f76b8ad023f057eb11ad94257a0862e4e8c, 0x719e891fbcc0a33e19c12dc0f02039ca05b801df, 0x39636b25811b176abfcfeeca64bc87452f1fdff4, 0x631030a5b27b07288a45696f189e1114f12a81c0, 0xbcc84597b91e73d5c5b4d69c80ecf146860f779a, 0x095e0174829f34c3781be1a5e38d1541ea439b7f, 0x2e7e05e29edda7e4ae25c5173543efd71f6d3d80, 0xdbb6ac484027041642bbfd8d80f9d0c1cf33c1eb, 0x153c08aa8b96a611ef63c0253e2a4334829e579d, 0x10f4bff0caa5027c0a6a2dcfc952824de2940909, 0x2ef869f0350b57d53478d701e3fee529bc911c75, 0x70ab34bc17b66f9c3b63f151274f2a727c539263, 0x3201259caf734ad7581c561051ba0bca7fd6946b, 0x84e9cf8166c36abfa49053b7a1ad4036202681ef, 0x4ebc5629f9a6a66b2cf3363ac4895c0348e8bf87, 0xe50b464ac9de35a5618b7cbf254674182b81b97e, 0x2abdf1a637ef6c42a7e2fe217773d677e804ebdd, 0x7a0a78a9cc393f91c3d9e39a6b8c069f075e6bf5, 0x2d9c5fecd2b44fbb6a1ec732ea059f4f1f9d2b5c, 0x7b712c7af11676006a66d2fc5c1ab4c479ce6037, 0x3466f67e39636c01f43b3a21a0e8529325c08624, 0xfdd502a74e813bcfa355ceda3c176f6a6871af7f, 0x26475419c06d5f147aa597248eb46cf7befa64a5, 0x9243d7762d77287b12638688b9854e88a769b271, 0x723d8baa2551d2addc43c21b45e8af4ca2bfb2c2, 0xf2fbb6d887f8b8cc3a869aba847f3d1f643c53d6, 0x2cdb3944650616e47cb182e060322fa1487978ce, 0xf0d21663d8b0176e05fde1b90ef31f8530fda95f, 0x77cc02f623a9cf98530997ea67d95c3b491859ae, 0xd1b5a454ac3405bb4179208c6c84de006bcb9be9, 0xb9920fd0e2c735c256463caa240fb7ac86a93dfa, 0xed1f1e115a0d60ce02fb25df014d289e3a0cbe7d, 0x23e2c6a8be8e0acfa5c4df5e36058bb7cbac5a81, 0xf0be0faf4d7923fc444622d1980cf2d990aab307, 0x0829d0f7bb7c446cfbb0deadb2394d9db7249a87, 0x2ecac504b233866eb5a4a99e7bd2901359e43b3d, 0x06d6cb308481c336a6e1a225a912f6e6355940a1, 0xd4879fd12b1f3a27f7e109761b23ca343c48e3d8, 0x857f100b1a5930225efc7e9020d78327b41c02cb, 0x3aa42c21b9b31c3e27ccd17e099af679cdf56907, 0x764d5212263aff4a2a14f031f04ec749dc883e45, 0xd03a2da41e868ed3fef5745b96f5eca462ff6fda, 0x4f26690c992b7a312ab12e1385d94acd58288e7b, 0x7b122162c913e7146cad0b7ed37affc92a0bf27f, 0xc87352dba582ee2066b9c002a962e003134f78b1, 0x9f4ac9c9e7e24cb2444a0454fa5b9ad9d92d3853, 0xccf62a663f1353ba2ef8e6521dc1ecb673ec8ef7, 0x557f5e65e0da33998219ad4e99570545b2a9d511, 0xa5f0077b351f6c505cd515dfa6d2fa7f5c4cd287, 0x79c6002f8452ca157f1317e80a2faf24475559b7, 0x3aa07a34a1afc8967d3d1383b96b62cf96d5fa90, 0x7f389c12f3c6164f6446566c77669503c2792527, 0xac4cc256ae74d624ace80db078b2207f57198f6b, 0x823ba7647238d113bce9964a43d0a098118bfe4d, 0xf5a7676ad148ae9c1ef8b6f5e5a0c2c473be850b, 0x7d34803569e00bd6b59fff081dfa5c0ab4197a62, 0x061ea4877cd08944eb64c2966e9db8dedcfec06b, 0xdf37c22e603aedb60a627253c47d8ba866f6d972, 0x529aa002c6962a3a8545027fd8b05f22b5bf9564, 0xeb89a882670909cf377e9e78286ee97ba78d46c2, 0x9ac85397792a69d78f286b86432a07aeceb60e64, 0x9610592202c282ab9bd8a884518b3e0bd4758137, 0x73932709a97f02c98e51b091312865122385ae8e, 0x5ef8c96186b37984cbfe04c598406e3b0ac3171f, 0xb6f78da4f4d041b3bc14bc5ba519a5ba0c32f128, 0x6f0edd23bcd85f6015f9289c28841fe04c83efeb, 0xa8a43c009100616cb4ae4e033f1fc5d7e0b6f152, 0x7081fa6baad6cfb7f51b2cca16fb8970991a64ba, 0x9de7386dde401ce4c67b71b6553f8aa34ea5a17d, 0x54ec7300b81ac84333ed1b033cd5d7a33972e234, 0x67a80e0190721f94390d6802729dd12c31a895ad, 0x3a4297da3c555e46c073669d0478fce75f2f790e, 0xc2e0584a71348cc314b73b2029b6230b92dbb116, 0x0a2ade95b2e8c66d8ae6f0ba64ca57d783be6d44, 0x544b5b351d1bc82e9297439948cf4861dac9ae11, 0x3ae62bd271a760637fad79c31c94ff62b4cd12f7, 0x0d8023929d917234ae40512b1aabb5e8a4512771, 0x2858acacaf21ea81cab7598fdbd86b452e9e8e15, 0xc033b1325a0af45472c25527853b1f1c21fa35de, 0xbbf85aaaa683738f073baef44ac9dc34c4c779ea, 0x6ae57f27917c562a132a4d1bf7ec0ac785832926, 0x88e6f9b247f988f6c0fc14c56f1de53ec69d43cc, 0xb72c2a011c0df50fbb6e28b20ae1aad217886790, 0x161caf5a972ace8379a6d0a04ae6e163fe21df2b, 0x2a63590efe9986c3fee09b0a0a338b15bed91f21, 0x50e1c8ec98415bef442618708799437b86e6c205, 0x33f4a6471eb1bca6a9f85b3b4872e10755c82be1, 0x9c49deff47085fc09704caa2dca8c287a9a137da, 0xe1173a247d29d8238df0922f4df25a05f2af77c3, 0x51891b2ccdd2f5a44b2a8bc49a5d9bca6477251c, 0xecaf3350b7ce144d068b186010852c84dd0ce0f0, 0x72393d37b451effb9e1ff3b8552712e2a970d8c2, 0x1bbc60bcc80e5cdc35c5416a1f0a40a83dae867b, 0xb8ab39805bd821184f6cbd3d2473347b12bf175c, 0xc55a6b4761fd11e8c85f15174d74767cd8bd9a68, 0x99d1b585965f406a42a49a1ca70f769e765a3f98, 0x9ab988b505cfee1dbe9cd18e9b5473b9a2d4f536, 0x7fef8c38779fb307ec6f044bebe47f3cfae796f1, 0x322d6f9a140d213f4c80cd051afe25c620bf4c7d, 0x3bd9a06d1bd36c4edd27fc0d1f5b088ddae3c72a, 0x5dcdb6b87a503c6d8a3c65c2cf9a9aa883479a1e, 0x6e84c2fd18d8095714a96817189ca21cca62bab1, 0xa5bad86509fbe0e0e3c0e93f6d381f1af6e9d481, 0x3954bdfe0bf587c695a305d9244c3d5bdddac9bb, 0x63f0e5a752f79f67124eed633ad3fd2705a397d4, 0x33fd718f0b91b5cec88a5dc15eecf0ecefa4ef3d, 0x68027d19558ed7339a08aee8de3559be063ec2ea, 0x96f0462ae6f8b96088f7e9c68c74b9d8ad34b347, 0xf1f391ca92808817b755a8b8f4e2ca08d1fd1108, 0x7fcf5ba6666f966c5448c17bf1cb0bbcd8019b06, 0xe9b9a2747510e310241d2ece98f56b3301d757e0, 0x2100381d60a5b54adc09d19683a8f6d5bb4bfbcb, 0x7495ae78c0d90261e2140ef2063104731a60d1ed, 0xdc911cf7dc5dd0813656670528e9338e67034786, 0x262aed4bc0f4a4b2c6fb35793e835a49189cdfec, 0x9ee93f339e6726ec65eea44f8a4bfe10da3d3282, 0xa3a57b0716132804d60aac281197ff2b3d237b01, 0xc799e34e88ff88be7de28e15e4f2a63d0b33c4cb, 0xc7506c1019121ff08a2c8c1591a65eb4bdfb4a3f, 0x795ebc2626fc39b0c86294e0e837dcf523553090, 0x441aca82631324acbfa2468bda325bbd78477bbf, 0x9f271d285500d73846b18f733e25dd8b4f5d4a8b, 0xd77892e2273b235d7689e430e7aeed9cbce8a1f3, 0x4f8972838f70c903c9b6c6c46162e99d6216d451, 0x4c85ed362f24f6b9f04cdfccd022ae535147cbb9, 0x3807eff43aa97c76910a19752dd715ee0182d94e, 0x3a9e5441d44b243be55b75027a1ceb9eacf50df2, 0x3deae43327913f62808faa1b6276a2bd6368ead9, 0xc270456885342b640b4cfc1b520e1a544ee0d571, 0x77798f201257b9c35204957057b54674aefa51df, 0x225f9eb3fb6ff3e9e3c8447e14a66e8d4f3779f6, 0x78df2681d6d602e22142d54116dea15d454957aa, 0x283396ce3cac398bcbe7227f323e78ff96d08767, 0x747ff7943b71dc4dcdb1668078f83dd7cc4520c2, 0xa4ed11b072d89fb136759fc69b428c48aa5d4ced, 0xcc043c4388d345f884c6855e71142a9f41fd6935, 0xab14d221e33d544629198cd096ed63dfa28d9f47, 0x251e6838f7cec5b383c1d90146341274daf8e502, 0x36a0e61e1be47fa87e30d32888ee0330901ca991, 0xbcfc98e5c82b6adb180a3fcb120b9a7690c86a3f, 0x18a6d2fc52be73084023c91802f05bc24a4be09f, 0x80591a42179f34e64d9df75dcd463b28686f5574, 0x881230047c211d2d5b00d8de4c5139de5e3227c7, 0x9eb1ff71798f28d6e989fa1ea0588e27ba86cb7d, 0xa01fd1906a908506dedae1e208128872b56ee792, 0x1b05ea6a6ac8af7cb6a8b911a8cce8fe1a2acfc8, 0x6add932193cd38494aa3f03aeccc4b7ab7fabca2, 0x2aaa35274d742546670b7426264521032af4f4c3, 0x67b8a6e90fdf0a1cac441793301e8750a9fa7957, 0x5b5be0d8c67276baabd8edb30d48ea75640b8b29, 0x28d7e5866f1d85fd1ceb32bfbe1dfc36db434566, 0x98e3e90b28fccaee828779b8d40a5568c4116e21, 0x2dd578f7407dfbd548d05e95ccc39c485429626a, 0x8ca6989746b06e32e2487461b1ce996a273acfd7, 0xa6f93307f8bce03195fece872043e8a03f7bd11a, 0xefbd52f97da5fd3a673a46cbf330447b7e8aad5c, 0x52bdd9af5978850bc24110718b3723759b437e59, 0x6e073b66d1b8c66744d88096a8dd99ec7e0228da, 0xa29d661a6376f66d0b74e2fe9d8f26c0247ec84c, 0x7d34ff59ae840a7413c6ba4c5bb2ba2c75eab018, 0x2eca6a3c5d9f449d0956bd43fa7b4d7be8435958, 0xf59f9f02bbc98efe097eabb78210979021898bfd, 0x90e300ac71451e401f887f6e7728851647a80e07, 0x05ae7fd4bbcc80ca11a90a1ec7a301f7cccc83db, 0xe54102534de8f23effb093b31242ad3b233facfd, 0xc127aab59065a28644a56ba3f15e2eac13da2995, 0xed60c4ab6e540206317e35947a63a9ca6b03e2cb, 0xd855b03ccb029a7747b1f07303e0a664793539c8, 0x1178501ff94add1c5881fe886136f6dfdbe61a94, 0xf447108b98df64b57e871033885c1ad71db1a3f9, 0xdeee2689fa9006b59cf285237de53b3a7fd01438, 0x7f01dc7c3747ca608f983dfc8c9b39e755a3b914, 0x9edeac4c026b93054dc5b1d6610c6f3960f2ad73, 0xe3cffe239c64e7e20388e622117391301b298696, 0xebbb4f2c3da8be3eb62d1ffb1f950261cf98ecda, 0x38c10b90c859cbb7815692f99dae520ab5febf5e, 0x23f9ecf3e5dddca38815d3e59ed34b5b90b4a353, 0xd7fa5ffb6048f96fb1aba09ef87b1c11dd7005e4, 0x9ca42ee7a0b898f6a5cc60b5a5d7b1bfa3c33231, 0x8b9577920053b1a00189304d888010d9ef2cb4bf, 0xfcd0b4827cd208ffbf5e759dba8c3cc61d8c2c3c, 0x01ff1eb1dead50a7f2f9638fdee6eccf3a7b2ac8, 0xabde147b2af789eaa586547e66c4fa2664d328a4, 0x64042ba68b12d4c151651ca2813b7352bd56f08e, 0xdccca42045ec3e16508b603fd936e7fd7de5f36a, 0xe77a89bd45dc04eeb4e41d7b596b707e6e51e74c, 0xf77c7b845149efba19e261bc7c75157908afa990, 0xfa5201fe1342af11307b9142a041243ca92e2f09, 0x40df495ecf3f8b4cef2a6c189957248fe884bc2b, 0x3d79a853d71be0621b44e29759656ca075fdf409, 0x6de02f2dd67efdb7393402fa9eaacbcf589d2e56, 0x729aad4627744e53f5d66309aa74448b3acdf46f, 0x4e4318f5e13e824a54edfe30a7ed4f26cd3da504, 0xc6a286e065c85f3af74812ed8bd3a8ce5d25e21d, 0xfd686de53fa97f99639e2568549720bc588c9efc, 0x06b0ff834073cce1cbc9ea557ea87b605963e8b4, 0x72b5633fe477fe542e742facfd690c137854f216, 0x8bf373d076814cbc57e1c6d16a82c5be13c73d37, 0xcf264e6925130906c4d7c18591aa41b2a67f6f58, 0x0ea2a210312b3e867ee0d1cc682ce1d666f18ed5, 0xd02afecf8e2ec2b62ac8ad204161fd1fae771d0e, 0xe6b20f980ad853ad04cbfc887ce6601c6be0b24c, 0x4280a58f8bb10b9440de94f42b4f592120820191, 0xa914cdb571bfd93d64da66a4e108ea134e50d000, 0x60864236930d04d8402b5dcbeb807f3caf611ea2, 0xf9dd239008182fb519fb30eedd2093fed1639be8, 0x18e53243981aabc8767da10c73449f1391560eaa, 0xc3a9226ae275df2cab312b911040634a9c9c9ef6, 0x4fcc19ea9f4c57dcbce893193cfb166aa914edc5, 0xc1e1409ca52c25435134d006c2a6a8542dfb7273, 0x981ddf0404e4d22dda556a0726f00b2d98ab9569, 0xe5bcc88c3b256f6ed5fe550e4a18198b943356ad, 0x74a17f064b344e84db6365da9591ff1628257643, 0x2720f9ca426ef2f2cbd2fecd39920c4f1a89e16d, 0x8d04a5ebfb5db409db0617c9fa5631c192861f4a, 0xf18b14cbf6694336d0fe12ac1f25df2da0c05dbb, 0x56ac20d63bd803595cec036da7ed1dc66e0a9e07, 0x92c94c2820dfcf7156e6f13088ece7958b3676fd, 0x968dea60df3e09ae3c8d3505e9c080454be0e819, 0x9268d62646563611dc3b832a30aa2394c64613e3, 0x5a192b964afd80773e5f5eda6a56f14e25e0c6f3, 0xdf8d48b1eb07b3c217790e6c2df04dc319e7e848, 0x7f61fa6cf5f898b440dac5abd8600d6d691fdef9, 0x929d368eb46a2d1fbdc8ffa0607ede4ba88f59ad, 0x9982a5890ffb5406d3aca8d2bfc1dd70aaa80ae0, 0xbf2aea5a1dcf6ed3b5e8323944e983fedfd1acfb, 0x46aa501870677e7f0a504876b4e8801a0ad01c46, 0x8f473d0ab876ddaa15608621d7013e6ff714b675, 0x02290fb5f9a517f82845acdeca0fc846039be233, 0x8a5831282ce14a657a730dc18826f7f9b99db968, 0x0328510c09dbcd85194a98d67c33ac49f2f94d60, 0xcf883a20329667ea226a1e3c765dbb6bab32219f, 0x2615100ea7e25bba9bca746058afbbb4ffbe4244, 0xb115ee3ab7641e1aa6d000e41bfc1ec7210c2f32, 0x5cfa8d568575658ca4c1a593ac4c5d0e44c60745, 0xd3c24d4b3a5e0ff8a4622d518edd73f16ab28610, 0xa639acd96b31ba53b0d08763229e1f06fd105e9d, 0xffa4aff1a37f984b0a67272149273ae9bd41e3bc, 0xcf684dfb8304729355b58315e8019b1aa2ad1bac, 0x5797b60fd2894ab3c2f4aede86daf2e788d745ad, 0xa6a0de421ae54f6d17281308f5646d2f39f7775d, 0x08504f05643fab5919f5eea55925d7a3ed7d807a, 0x7a7068e1c3375c0e599db1fbe6b2ea23b8f407d2, 0x1078d7f61b0e56c74ee6635b2e1819ef1e3d8785, 0x6e12b51e225b4a4372e59ad7a2a1a13ea3d3a137, 0x6a2e86469a5bf37cee82e88b4c3863895d28fcaf, 0x197672fd39d6f246ce66a790d13aa922d70ea109, 0x8009a7cbd192b3aed4adb983d5284552c16c7451, 0xf6c3c48a1ac0a34799f04db86ec7a975fe7768f3, 0x16be75e98a995a395222d00bd79ff4b6e638e191, 0x6c05e34e5ef2f42ed09deff1026cd66bcb6960bb, 0x5d6ae8cbd6b3393c22d16254100d0238e808147c, 0x1a376e1b2d2f590769bb858d4575320d4e149970, 0xf6ead67dbf5b7eb13358e10f36189d53e643cfcf, 0x467d5988249a68614716659840ed0ae6f6f457bc, 0xaa960e10c52391c54e15387cc67af827b5316dcc, 0x483ba99034e900e3aedf61499d3b2bce39beb7aa, 0x86f23e9c0aafc78b9c404dcd60339a925bffa266, 0xd05a447c911dbb275bfb2e5a37e5a703a56f9997, 0xedb71ec41bda7dce86e766e6e8c3e9907723a69b, 0xf86a3ea8071f7095c7db8a05ae507a8929dbb876, 0x323b3cfe3ee62bbde2a261e53cb3ecc05810f2c6, 0x936f3813f5f6a13b8e4ffec83fe7f826186a71cd, 0x6db72bfd43fef465ca5632b45aab7261404e13bf, 0x9bb76204186af2f63be79168601687fc9bad661f, 0x28ab165ffb69eda0c549ae38e9826f5f7f92f853, 0xc73e2112282215dc0762f32b7e807dcd1a7aae3e, 0xf8086e42661ea929d2dda1ab6c748ce3055d111e, 0x4db21284bcd4f787a7556500d6d7d8f36623cf35, 0xc48651c1d9c16bff4c9554886c3f3f26431f6f68, 0x9bdbdc9b973431d13c89a3f9757e9b3b6275bfc7, 0x560da37e956d862f81a75fd580a7135c1b246352, 0x4b60a3e253bf38c8d5662010bb93a473c965c3e5, 0x64e02abb016cc23a2934f6bcddb681905021d563, 0xac2c8e09d06493a63858437bd20be01962450365, 0x9bf9b3b2f23cf461eb591f28340bc719931c8364, 0x9b5c39f7e0ac168c8ed0ed340477117d1b682ee9, 0xf75bb39c799779ebc04a336d260da63146ed98d0, 0xa7966c489f4c748a7ae980aa27a574251767caf9, 0xea53c954f4ed97fd4810111bdab69ef981ef25b9, 0x03a26cfc4c18316f70d59e9e1a79ee3e8b962f4c, 0x3e63ce3b24ca2865b4c5a687b7aea3597ef6e548, 0x500c902958f6421594d1b6ded712490d52ed6c44, 0x6f44ca09f0c6a8294cbd519cdc594ad42c67579f, 0x3616fb46c81578c9c8eb4d3bf880451a88379d7d, 0x57bc20e2d62b3d19663cdb4c309d5b4f2fc2db8f, 0x1cebf0985d7f680aaa915c44cc62edb49eab269e, 0xc0cbf6032fa39e7c46ff778a94f7d445fe22cf30, 0xc58b9cc61dedbb98c33f224d271f0e228b583433, 0xe9c6dfae97f7099fc5f4e94b784db802923a1419, 0x9bacd3d40f3b82ac91a264d9d88d908eac8664b9, 0x63d80048877596e0c28489e650cd4ac180096a49, 0xe6a6f6dd6f70a456f4ec15ef7ad5e5dbb68bd7dc, 0xd418870bc2e4fa7b8a6121ae0872d55247b62501, 0xe2f9383d5810ea7b43182b8704b62b27f5925d39, 0xbd5e473abce8f97a6932f77c2facaf9cc0a00514, 0x2ff1ca55fd9cec1b1fe9f0a9abb74c513c1e2aaa, 0x9d99b189bbd9a48fc2e16e8fcda33bb99a317bbb, 0x6e96faeda3054302c45f58f161324c99a3eebb62, 0xef93818f684db0c3675ec81332b3183ecc28a495, 0x2659facb1e83436553b5b42989adb8075f9953ed, 0xc4ffadaaf2823fbea7bff702021bffc4853eb5c9, 0xe9864c1afc8eaad37f3ba56fcb7477cc622009b7, 0x87ef6d8b6a7cbf9b5c8c97f67ee2adc2a73b3f77, 0xc043f2452dcb9602ef62bd360e033dd23971fe84, 0x0fdd65402395df9bd19fee4507ef5345f745104c, 0x939c4313d2280edf5e071bced846063f0a975d54, 0xb28245037cb192f75785cb86cbfe7c930da258b0, 0xa80cb1738bac08d4f9c08b4deff515545fa8584f, 0x62971bf2634cee0be3c9890f51a56099dbb9519b, 0xf2efe96560c9d97b72bd36447843885c1d90c231, 0x0e390f44053ddfcef0d608b35e4d9c2cbe9871bb, 0x61d101a033ee0e2ebb3100ede766df1ad0244954, 0x6785513cf732e47e87670770b5419be10cd1fc74, 0x167699f48a78c615512515739958993312574f07, 0x68ec79d5be7155716c40941c79d78d17de9ef803, 0xa0e8ba661b48154cf843d4c2a5c0f792d528ee29, 0x1a201b4327cea7f399046246a3c87e6e03a3cda8, 0xf60f62d73937953fef35169e11d872d2ea317eec, 0xc0c04d0106810e3ec0e54a19f2ab8597e69a573d, 0xef47cf073e36f271d522d7fa4e7120ad5007a0bc, 0xa44fe800d96fcad73b7170d0f610cb8c0682d6ce, 0x010f4a98dfa1d9799bf5c796fb550efbe7ecd877, 0x708fa11fe33d85ad1befcbae3818acb71f6a7d7e, 0xb38c4e537b5df930d65a74d043831d6b485bbde4, 0x250a69430776f6347703f9529783955a6197b682, 0x2d35a9df62757f7ffad1049afb06ca4afc464c51, 0x6aff1466c2623675e3cb0e75e423d37a25e442eb, 0xfc15cb99a8d1030b12770add033a79ee0d0c908c, 0xe784dcc873aa8c1513ec26ff36bc92eac6d4c968, 0xb1c328fb98f2f19ab6646f0a7c8c566fda5a8540, 0x247a0a11c57f0383b949de540b66dee68604b0a1, 0x1af60343360e0b2d75255210375720df21db5c7d, 0x8794bf47d54540ece5c72237a1ffb511ddb74762, 0xe76d945aa89df1e457aa342b31028a5e9130b2ce, 0xa30e0acb534c9b3084e8501da090b4eb16a2c0cd, 0x7099d12f6ec656899b049a7657065d62996892c8, 0x7be7f2456971883b9a8dbe4c91dec08ac34e8862, 0x42746aeea14f27beff0c0da64253f1e7971890a0, 0x736b44503dd2f6dd5469ff4c5b2db8ea4fec65d0, 0x822edff636563a6106e52e9a2598f7e6d0ef2782, 0x03c647a9f929b0781fe9ae01caa3e183e876777e, 0x63612e7862c27b587cfb6daf9912cb051f030a9f, 0xd46bae61b027e5bb422e83a3f9c93f3c8fc77d27, 0x5f23ba1f37a96c45bc490259538a54c28ba3b0d5, 0xd41d7fb49fe701baac257170426cc9b38ca3a9b2, 0x1ebacb7844fdc322f805904fbf1962802db1537c, 0x9c80bc18e9f8d4968b185da8c79fa6e11ffc3e23, 0xe4ca0a5238564dfc91e8bf22bade2901619a1cd4, 0x1ad72d20a76e7fcc6b764058f48d417d496fa6cd, 0xd3bc730937fa75d8452616ad1ef1fe7fffe0d0e7, 0xeac1482826acb6111e19d340a45fb851576bed60, 0x01e40521122530d9ac91113c06a0190b6d63850b, 0x9e20e5fd361eabcf63891f5b87b09268b8eb3793, 0x69ff429074cb9b6c63bc914284bce5f0c8fbf7d0, 0x0d3265d3e7bdb93d5e8e8b1ca47f210a793ecc8e, 0x5b4ea16db6809b0352d4b6e81c3913f76a51bb32, 0xd8fe088fffce948f5137ee23b01d959e84ac4223, 0x7e4e9409704121d1d77997026ff06ea9b19a8b90, 0x96b434fe0657e42acc8212b6865139dede15979c, 0x22f004df8de9e6ebf523ccace457accb26f97281, 0xd8f9240c55cff035523c6d5bd300d370dc8f0c95, 0x9d9e57fde30e5068c03e49848edce343b7028358, 0x317cf4a23cb191cdc56312c29d15e210b3b9b784, 0x79f08e01ce0988e63c7f8f2908fade43c7f9f5c9, 0x04e5f5bc7c923fd1e31735e72ef968fd67110c6e, 0x1ec4ec4b77bf19d091a868e6f49154180541f90e, 0x8737dae671823a8d5917e0157ace9c43468d946b, 0xf998ca3411730a6cd10e7455b0410fb0f6d3ff80, 0x6e2eab85dc89fe29dc0aa1853247dab43a523d56, 0x72c083beadbdc227c5fb43881597e32e83c26056, 0x5902e44af769a87246a21e079c08bf36b06efeb3, 0xcc2d04f0a4017189b340ca77198641dcf6456b91, 0xbde4c73f969b89e9ceae66a2b51844480e038e9a, 0xadff0d1d0b97471e76d789d2e49c8a74f9bd54ff, 0x397cdb8c80c67950b18d654229610e93bfa6ee1a, 0xa3e051fb744aa3410c3b88f899f5d57f168df12d, 0x810db25675f45ea4c7f3177f37ce29e22d67999c, 0x1e13ec51142cebb7a26083412c3ce35144ba56a1, 0x25bdfa3ee26f3849617b230062588a97e3cae701, 0xae538c73c5b38d8d584d7ebdadefb15cabe48357, 0xa2ecce2c49f72a0995a0bda57aacf1e9f001e22a, 0x7e24fbdad290175eb2df6d180a19b9a9f41370be, 0xe8cc43bc4f8acf39bff04ebfbf42aac06a328470, 0xc2779771f0536d79a8708f6931abc44b3035e999, 0xab27ba78c8e5e3daef31ad05aef0ff0325721e08, 0x563cb8803c1d32a25b27b64114852bd04d9c20cd, 0x08d4267feb15da9700f7ccc3c84a8918bf17cfde, 0xd1778c13fbd968bc083cb7d1024ffe1f49d02caa, 0x1796bcc97b8abc717f4b4a7c6b1036ea2182639f, 0xbeecd6af900c8b064afcc6073f2d85d59af11956, 0x045ed7f6d9ee9f252e073268db022c6326adfc5b, 0xb88a37c27f78a617d5c091b7d5b73a3761e65f2a, 0x72fb49c29d23a18950c4b2dc0ddf410f532d6f53, 0x6ecaefa6fc3ee534626db02c6f85a0c395571e77, 0xd1811c55976980f083901d8a0db269222dfb5cfe, 0x98855c7dfbee335344904a12c40c731795b13a54, 0x92a898d46f19719c38126a8a3c27867ae2cee596, 0xca428863a5ca30369892d612183ef9fb1a04bcea, 0x797427e3dbf0feae7a2506f12df1dc40326e8505, 0x3d574fcf00fae1d98cc8bf9ddfa1b3953b9741bc, 0x28818e18b610001321b31df6fe7d2815cdadc9f5, 0x5f3e1e6739b0c62200e00a003691d9efb238d89f, 0xd9d370fec63576ab15b318bf9e58364dc2a3552a, 0xb223bf1fbf80485ca2b5567d98db7bc3534dd669, 0x7b27d0d1f3dd3c140294d0488b783ebf4015277d, 0x7930c2d9cbfa87f510f8f98777ff8a8448ca5629, 0x820c19291196505b65059d9914b7090be1db87de, 0xe545ee84ea48e564161e9482d59bcf406a602ca2, 0xaf4cf41785161f571d0ca69c94f8021f41294eca, 0x7a4f9b850690c7c94600dbee0ca4b0a411e9c221, 0xddab6b51a9030b40fb95cf0b748a059c2417bec7, 0x315ef2da620fd330d12ee55de5f329a696e0a968, 0x4db1c43a0f834d7d0478b8960767ec1ac44c9aeb, 0x2fef81478a4b2e8098db5ff387ba2153f4e22b79, 0x6c6aa0d30b64721990b9504a863fa0bfb5e57da7, 0x33380c6fff5acd2651309629db9a71bf3f20c5ba, 0x4eebf1205d0cc20cee6c7f8ff3115f56d48fba26, 0x03cc9d2d21f86b84ac8ceaf971dba78a90e62570, 0x728f9ab080157db3073156dbca1a169ef3179407, 0x30ed11b77bc17e5e6694c8bc5b6e4798f68d9ca7, 0xf617b967b9bd485f7695d2ef51fb7792d898f500, 0xc0cbad3ccdf654da22cbcf5c786597ca1955c115, 0x80522ddf944ec52e27d724ed4c93e1f7be6083d6, 0x4e90ccb13258acaa9f4febc0a34292f95991e230, 0xff207308ced238a6c01ad0213ca9eb4465d42590, 0x35f2949cf78bc219bb4f01907cf3b4b3d3865482, 0x68f525921dc11c329b754fbf3e529fc723c834cd, 0x81139bfdcca656c430203f72958c543b6580d40c, 0x9d511543b3d9dc60d47f09d49d01b6c498d82078, 0x084d103254759b343cb2b9c2d8ff9e1ac5f14596, 0xb323dcbf2eddc5382ee4bbbb201ca3931be8b438, 0x349d2c918fd09e2807318e66ce432909176bd50b, 0xb535f8db879fc67fec58824a5cbe6e5498aba692, 0x824074312806da4748434266ee002140e3819ac2, 0xe8ef100d7ce0895832f2678df72d4acf8c28b8e3, 0x84af1b157342d54368260d17876230a534b54b0e, 0x419a71a36c11d105e0f2aef5a3e598078e85c80b, 0x55af092f94ba6a79918b0cf939eab3f01b3f51c7, 0x35a549e8fd6c368d6dcca6d2e7d18e4db95f5284, 0xf0e2649c7e6a3f2c5dfe33bbfbd927ca3c350a58, 0xf4b759cc8a1c75f80849ebbcda878dc8f0d66de4, 0x21846f2fdf5a41ed8df36e5ed8544df75988ece3, 0x229ff80bf5708009a9f739e0f8b560914016d5a6, 0xda505537537ffb33c415fec64e69bae090c5f60f, 0xb91d9e916cd40d193db60e79202778a0087716fc, 0xbb6823a1bd819f13515538264a2de052b4442208, 0x459393d63a063ef3721e16bd9fde45ee9dbd77fb, 0x95f62d0243ede61dad9a3165f53905270d54e242, 0xb0bb29a861ea1d424d45acd4bfc492fb8ed809b7, 0x5e74ed80e9655788e1bb269752319667fe754e5a, 0xa276b058cb98d88beedb67e543506c9a0d9470d8, 0x8ae9ef8c8a8adfa6ab798ab2cdc405082a1bbb70, 0xe5102c3b711b810344197419b1cd8a7059f13e32, 0xc32038ca52aee19745be5c31fcdc54148bb2c4d0, 0x13e321728c9c57628058e93fc866a032dd0bda90, 0xc2bae4a233c2d85724f0dabebda0249d833e37d3, 0x10d32416722ca4e648630548ead91edd79c06aff, 0xd5f07552b5c693c20067b378b809cee853b8f136, 0x8668af868a1e98885f937f2615ded6751804eb2d, 0x139d3531c9922ad56269f6309aa789fb2485f98c, 0x1d29c7aab42b2048d2b25225d498dba67a03fbb2, 0xd35075ca61fe59d123969c36a82d1ab2d918aa38, 0xd6fc0446c6a8d40ae3551db7e701d1fa876e4a49, 0xfccd0d1ecee27addea95f6857aeec8c7a04b28ee, 0xc12cfb7b3df70fceca0ede263500e27873f8ed16, 0xd0db456178206f5c4430fe005063903c3d7a49a7, 0x73cf80ae9688e1580e68e782cd0811f7aa494d2c, 0xd60651e393783423e5cc1bc5f889e44ef7ea243e, 0x048a8970ea4145c64d5517b8de5b46d0595aad06, 0xdd9b485a3b1cd33a6a9c62f1e5bee92701856d25, 0x5b287c7e734299e727626f93fb1187a60d5057fe, 0x635c00fdf035bca15fa3610df3384e0fb79068b1, 0x630a913a9031c9492abd4c41dbb15054cfec4416, 0xaf3614dcb68a36e45a4e911e62796247222d595b, 0x335e22025b7a77c3a074c78b8e3dfe071341946e, 0xf0e1dfa42adeac2f17f6fdf584c94862fd563393, 0x1a9e702f385dcd105e8b9fa428eea21c57ff528a, 0x8ce4949d8a16542d423c17984e6739fa72ceb177, 0x5f29c9de765dde25852af07d33f2ce468fd20982, 0xdbf5f061a0f48e5e69618739a77d2ec19768d201, 0xb247cf9c72ec482af3eaa759658f793d670a570c, 0x99f4147ccc6bcb80cc842e69f6d00e30fa4133d9, 0xba6d31b9a261d640b5dea51ef2162c3109f1eba8, 0xf05ba8d7b68539d933300bc9289c3d9474d0419e, 0x682e96276f518d31d7e56e30dfb009c1218201bd, 0x0927220492194b2eda9fc4bbe38f25d681dfd36c, 0xa3c33afc8cb4704e23153de2049d35ae71332472, 0x05c736d365aa37b5c0be9c12c8ad5cd903c32cf9, 0xd8eef4cf4beb01ee20d111748b61cb4d3f641a01, 0x16c1bf5b7dc9c83c179efacbcf2eb174e3561cb3, 0xd79db5ab43621a7a3da795e58929f3dd25af67d9, 0x28efae6356509edface89fc61a7fdcdb39eea8e5, 0xc55005a6c37e8ca7e543ce259973a3cace961a4a, 0xab3d86bc82927e0cd421d146e07f919327cdf6f9, 0xb74ed2666001c16333cf7af59e4a3d4860363b9c, 0x1899f69f653b05a5a6e81f480711d09bbf97588c, 0x27fc85a49cff90dbcfdadc9ddd40d6b9a2210a6c, 0xcd1ed263fbf6f6f7b48aef8f733d329d4382c7c7, 0xd97fe6f53f2a58f6d76d752adf74a8a2c18e9074, 0x80da2fdda29a9e27f9e115975e69ae9cfbf3f27e, 0x09146ea3885176f07782e1fe30dce3ce24c49e1f, 0x393ff4255e5c658f2e7f10ecbd292572671bc2d2, 0xa390ca122b8501ee3e5e07a8ca4b419f7e4dae15, 0x6d9193996b194617211106d1635eb26cc4b66c6c, 0x999c49c174ca13bc836c1e0a92bff48b271543ca, 0x7421ce5be381738ddc83f02621974ff0686c79b8, 0x6be9030ee6e2fbc491aca3de4022d301772b7b7d, 0x81bd75abd865e0c3f04a0b4fdbcb74d34082fbb7, 0x8bc1ff8714828bf286ff7e8a7709106548ed1b18, 0xa0aadbd9509722705f6d2358a5c79f37970f00f6, 0x3d881433f04a7d0d27f84944e08a512da3555287, 0xcc1d6ead01aada3e8dc7b95dca25df26eefa639d, 0x35106ba94e8563d4b3cb3c5c692c10e604b7ced8, 0x4d8697af0fbf2ca36e8768f4af22133570685a60, 0x1afcc585896cd0ede129ee2de5c19ea811540b64, 0xe5215631b14248d45a255296bed1fbfa0330ff35, 0xe3878f91ca86053fced5444686a330e09cc388fb, 0x555df19390c16d01298772bae8bc3a1152199cbd, 0xdc3dae59ed0fe18b58511e6fe2fb69b219689423, 0x74648caac748dd135cd91ea14c28e1bd4d7ff6ae, 0xcf2e2ad635e9861ae95cb9bafcca036b5281f5ce, 0x14eec09bf03e352bd6ff1b1e876be664ceffd0cf, 0x856e5ab3f64c9ab56b009393b01664fc0324050e, 0x632b9149d70178a7333634275e82d5953f27967b, 0x2a39190a4fde83dfb3ddcb4c5fbb83ac6c49755c, 0x369ef761195f3a373e24ece6cd22520fe0b9e86e, 0x16afa787fc9f94bdff6976b1a42f430a8bf6fb0f, 0x1b0b31afff4b6df3653a94d7c87978ae35f34aae, 0xb4d82f2e69943f7de0f5f7743879406fac2e9cec, 0x09d6cefd75b0c4b3f8f1d687a522c96123f1f539, 0x01577afd4e50890247c9b10d44af73229aec884f, 0xa35606d51220ee7f2146d411582ee4ee4a45596e, 0x352e77c861696ef96ad54934f894aa8ea35151dd, 0xb87f5376c2de0b6cc3c179c06087aa473d6b4674, 0x5b49afcd75447838f6e7ceda8d21777d4fc1c3c0, 0xb884add88d83dc564ab8e0e02cbdb63919aea844, 0x5c312a56c784b122099b764d059c21ece95e84ca, 0x4697baaf9ccb603fd30430689d435445e9c98bf5, 0xc625f8c98d27a09a1bcabd5128b1c2a94856af30, 0x19f5caf4c40e6908813c0745b0aea9586d9dd931, 0x1e596a81b357c6f24970cc313df6dbdaabd0d09e, 0xc1631228efbf2a2e3a4092ee8900c639ed34fbc8, 0x6f6cf20649a9e973177ac67dbadee4ebe5c7bdda, 0x5fa7bfe043886127d4011d8356a47e947963aca8, 0x6af8e55969682c715f48ad4fc0fbb67eb59795a3, 0x122f56122549d168a5c5e267f52662e5c5cce5c8, 0x7713ab8037411c09ba687f6f9364f0d3239fac28, 0x31ccc616b3118268e75d9ab8996c8858ebd7f3c3, 0x09c88f917e4d6ad473fa12e98ea3c4472a5ed6da, 0xe796fd4e839b4c95d7510fb7c5c72b83c6c3e3c7, 0xa8285539869d88f8a961533755717d7eb65576ae, 0xd929c65d69d5bbaea59762662ef418bc21ad924a, 0xf7418aa0e713d248228776b2e7434222ae75e3a5, 0x7f0b90a1fdd48f27b268feb38382e55ddb50ef0f, 0x34a0431fff5ead927f3c69649616dc6e97945f6f, 0x1b3cb81e51011b549d78bf720b0d924ac763a7c2, 0x155b3779bb6d56342e2fda817b5b2d81c7f41327, 0xecd486fc196791b92cf612d348614f9156488b7e, 0x82a8cbbfdff02b2e38ae4bbfca15f1f0e83b1aea, 0x06b0c1e37f5a5ec4bbf50840548f9d3ac0288897, 0xe6d49f86c228f47367a35e886caacb271e539429, 0x704a6eb41ba34f13addde7d2db7df04915c7a221, 0x745ccf2d819edbbddea8117b5c49ed3c2a066e93, 0x6d3b7836a2b9d899721a4d237b522385dce8dfcd, 0x856aa23c82d7215bec8d57f60ad75ef14fa35f44, 0xea79057dabef5e64e7b44f7f18648e7e533718d2, 0x9df057cd03a4e27e8e032f857985fd7f01adc8d7, 0x5f2f07d2d697e8c567fcfdfe020f49f360be2139, 0x5efbdfe5389999633c26605a5bfc2c1bb5959393, 0x047e87c8f7d1fce3b01353a85862a948ac049f3e, 0x265383d68b52d034161bfab01ae1b047942fbc32, 0x760ff3354e0fde938d0fb5b82cef5ba15c3d2916, 0xbc46d537cf2edd403565bde733b2e34b215001bd, 0xee58fb3db29070d0130188ce472be0a172b89055, 0x75abe5270f3a78ce007cf37f8fbc045d489b7bb1, 0x5fc6c11426b4a1eae7e51dd512ad1090c6f1a85b, 0x26cfffd052152bb3f957b478d5f98b233a7c2b92, 0x0a4a011995c681bc999fdd79754e9a324ae3b379, 0x6fa60df818a5446418b1bbd62826e0b9825e1318, 0x63d55ad99b9137fd1b20cc2b4f03d42cbaddf334, 0x679b9a109930517e8999099ccf2a914c4c8dd934, 0x3e83544f0082552572c782bee5d218f1ef064a9d, 0x968b14648f018333687cd213fa640aec04ce6323, 0x427b462ab84e5091f48a46eb0cdc92ddcb26e078, 0xdf8510793eee811c2dab1c93c6f4473f30fbef5b, 0x362fbcb10662370a068fc2652602a2577937cce6, 0x5d83b21bd2712360436b67a597ee3378db3e7ae4, 0x5777441c83e03f0be8dd340bde636850847c620b, 0xc94a585203da7bbafd93e15884e660d4b1ead854, 0x35a08081799173e001cc5bd46a02406dc95d1787, 0x21d13f0c4024e967d9470791b50f22de3afecf1b, 0xfdfd6134c04a8ab7eb16f00643f8fed7daaaecb2, 0xfd812bc69fb170ef57e2327e80affd14f8e4b6d2, 0x7148aef33261d8031fac3f7182ff35928daf54d9, 0x0b06390f2437b20ec4a3d3431b3279c6583e5ed7, 0x4909b31998ead414b8fb0e846bd5cbde393935be, 0xb70dba9391682b4a364e77fe99256301a6c0bf1f, 0x6b83bae7b565244558555bcf4ba8da2011891c17, 0x70a03549aa6168e97e88a508330a5a0bea74711a, 0x0fc9a0e34145fbfdd2c9d2a499b617d7a02969b9, 0x2ddf40905769bcc426cb2c2938ffe077e1e89d98, 0x794b51c39e53d9e762b0613b829a44b472f4fff3, 0xd062588171cf99bbeb58f126b870f9a3728d61ec, 0x8db185fe1b70a94a6a080e7e23a8bedc4acbf34b, 0xe73bfeada6f0fd016fbc843ebcf6e370a65be70c, 0x79ed10cf1f6db48206b50919b9b697081fbdaaf3, 0x276b0521b0e68b277df0bb32f3fd48326350bfb2, 0x2e439348df8a4277b22a768457d1158e97c40904, 0x6c25327f8dcbb2f45e561e86e35d8850e53ab059, 0x04d73896cf6593a691972a13a6e4871ff2c42b13, 0xb10fd2a647102f881f74c9fbc37da632949f2375, 0x615f82365c5101f071e7d2cb6af14f7aad2c16c6, 0x93aa8f92ebfff991fc055e906e651ac768d32bc8, 0x0cbf8770f0d1082e5c20c5aead34e5fca9ae7ae2, 0xffc9cc3094b041ad0e076f968a0de3b167255866, 0x46531e8b1bde097fdf849d6d119885608a008df7, 0x23cd2598a20e149ead2ad69379576ecedb60e38e, 0x85ca8bc6da2803d0725f5e1a456c89f9bc774e2f, 0xc0725ec2bdc33a1d826071dea29d62d4385a8c25, 0x0e4765790352656bc656682c24fc5ef3e76a23c7, 0x2ef9e465716acacfb8c8252fa8e7bc7969ebf6e4, 0x0ec5308b31282e218fc9e759d4fec5db3708cec4, 0xbf7701fc6225d5a17815438a8941d21ebc5d059d, 0xc489c83ffbb0252ac0dbe3521217630e0f491f14, 0x8eb51774af206b966b8909c45aa6722748802c0c, 0x7b9226d46fe751940bc416a798b69ccf0dfab667, 0x8f660f8b2e4c7cc2b4ac9c47ed28508d5f8f8650, 0x9f19fac8a32437d80ac6837a0bb7841729f4972e, 0x201864a8f784c2277b0b7c9ee734f7b377eab648, 0xa6101c961e8e1c15798ffcd0e3201d7786ec373a, 0xd4ff46203efa23064b1caf00516e28704a82a4f8, 0xaa136b47962bb8b4fb540db4ccf5fdd042ffb8cf, 0x704ae21d762d6e1dde28c235d13104597236db1a, 0xf17a92e0361dbacecdc5de0d1894955af6a9b606, 0x8b48e19d39dd35b66e6e1bb6b9c657cb2cf59d04, 0x9ad47fdcf9cd942d28effd5b84115b31a658a13e, 0xdf0d08617bd252a911df8bd41a39b83ddf809673, 0x4c666b86f1c5ee8ca41285f5bde4f79052081406, 0x88dec5bd3f4eba2d18b8aacefa7b721548c319ba, 0x9f9fe0c95f10fee87af1af207236c8f3614ef02f, 0xf7d0d310acea18406138baaabbfe0571e80de85f, 0x9569c63a9284a805626db3a32e9d236393476151, 0x5d5c2c1099bbeefb267e74b58880b444d94449e0, 0x8c6ae7a05a1de57582ae2768204276c0ff47ed03, 0x432d884bd69db1acc0d89c64ade4cb4fc3a88b7a, 0x672cbca8440a8577097b19aff593a2ad9d28a756, 0x19df9445a81c1b3d804aeaeb6f6e204e4236663f, 0x1cb5f33b4d488936d13e3161da33a1da7df70d1b, 0xdf60f18c812a11ed4e2776e7a80ecf5e5305b3d6, 0xc99a9cd6c9c1be3534eecd92ecc22f5c38e9515b, 0x00c40fe2095423509b9fd9b754323158af2310f3, 0xda4a5f557f3bab390a92f49b9b900af30c46ae80, 0xf36df02fbd89607347afce2969b9c4236a58a506, 0xc549df83c6f65eec0f1dc9a0934a5c5f3a50fd88, 0x9f662e95274121f177566e636d23964cf1fd686f, 0x5a267331facb262daaecd9dd63a9700c5f5259df, 0x117d9aa3c4d13bee12c7500f09f5dd1c66c46504, 0x1b4d07acd38183a61bb2783d2b7b178dd502ac8d, 0x3c0c3defac9cea7acc319a96c30b8e1fedab4574, 0xe4dc22ed595bf0a337c01e03cc6be744255fc9e8, 0x8f067c7c1bbd57780b7b9eeb9ec0032f90d0dcf9, 0x40e2440ae142c880366a12c6d4102f4b8434b62a, 0xf9ece022bccd2c92346911e79dd50303c01e0188, 0xf70328ef97625fe745faa49ee0f9d4aa3b0dfb69, 0xb6aacb8cb30bab2ae4a2424626e6e12b02d04605, 0x154459fa2f21318e3434449789d826cdc1570ce5, 0x684a44c069339d08e19a75668bdba303be855332, 0x9fe501aa57ead79278937cd6308c5cfa7a5629fe, 0x3e45bd55db9060eced923bb9cb733cb3573fb531, 0x9c9f3b8a811b21f3ff3fe20fe970051ce66a824f, 0xe99aece90541cae224b87da673965e0aeb296afd, 0x2f6dce1330c59ef921602154572d4d4bacbd048a, 0x6a6353b971589f18f2955cba28abe8acce6a5761, 0x98c10ebf2c4f97cba5a1ab3f2aafe1cac423f8cb, 0x8077c3e4c445586e094ce102937fa05b737b568c, 0x13371f92a56ea8381e43059a95128bdc4d43c5a6, 0x35a6885083c899dabbf530ed6c12f4dd3a204cf5, 0x36b2c85e3aeeebb70d63c4a4730ce2e8e88a3624, 0x5ce44068b8f4a3fe799e6a8311dbfdeda29dee0e, 0x6fa6388d402b30afe59934c3b9e13d1186476018, 0x8251358ca4e060ddb559ca58bc0bddbeb4070203, 0x17e86f3b5b30c0ba59f2b2e858425ba89f0a10b0, 0x298ec76b440d8807b3f78b5f90979bee42ed43db, 0xce4b065dbcb23047203262fb48c1188364977470, 0xc8e2adeb545e499d982c0c117363ceb489c5b11f, 0x9928ff715afc3a2b60f8eb4cc4ba4ee8dab6e59d, 0xc76130c73cb9210238025c9df95d0be54ac67fbe, 0x72d03d4dfab3500cf89b86866f15d4528e14a195, 0xd193e583d6070563e7b862b9614a47e99489f3e5, 0x4df140ba796585dd5489315bca4bba680adbb818, 0x009eef0a0886056e3f69211853b9b7457f3782e4, 0x6e255b700ae7138a4bacf22888a9e2c00a285eec, 0xaa47a4ffc979363232c99b99fada0f2734b0aeee, 0x9d069197d1de50045a186f5ec744ac40e8af91c6, 0xb514882c979bb642a80dd38754d5b8c8296d9a07, 0x17c0478657e1d3d17aaa331dd429cecf91f8ae5d, 0x5f9616c47b4a67f406b95a14fe6fc268396f1721, 0xf70a998a717b338d1dd99854409b1a338deea4b0, 0xd1ee905957fe7cc70ec8f2868b43fe47b13febff, 0xfc018a690ad6746dbe3acf9712ddca52b6250039, 0x5118557d600d05c2fcbf3806ffbd93d02025d730, 0x1ef5c9c73650cfbbde5c885531d427c7c3fe5544, 0xd1a396dcdab2c7494130b3fd307820340dfd8c1f, 0x2d8e061892a5dcce21966ae1bb0788fd3e8ba059, 0x8834b2453471f324fb26be5b25166b5b5726025d, 0x14f221159518783bc4a706676fc4f3c5ee405829, 0xc056d4bd6bf3cbacac65f8f5a0e3980b852740ae, 0x560536794a9e2b0049d10233c41adc5f418a264a, 0xbc9e0ec6788f7df4c7fc210aacd220c27e45c910, 0x54bcb8e7f73cda3d73f4d38b2d0847e600ba0df8, 0x4361d4846fafb377b6c0ee49a596a78ddf3516a3, 0x41c3c2367534d13ba2b33f185cdbe6ac43c2fa31, 0x5dc6f45fef26b06e3302313f884daf48e2746fb9, 0xad414d29cb7ee973fec54e22a388491786cf5402, 0x802dc3c4ff2d7d925ee2859f4a06d7ba60f1308c, 0x2aed2ce531c056b0097efc3c6de10c4762004ed9, 0x39782ffe06ac78822a3c3a8afe305e50a56188ce, 0xec73833de4b810bb027810fc8f69f544e83c12d1, 0x8d51a4cc62011322c696fd725b9fb8f53feaaa07, 0x29298ccbdff689f87fe41aa6e98fdfb53deaf37a, 0x827531a6c5817ae35f82b00b9754fcf74c55e232, 0x9c581a60b61028d934167929b22d70b313c34fd0, 0x0a077db13ffeb09484c217709d5886b8bf9c5a8b, 0x07b7a57033f8f11330e4665e185d234e83ec140b, 0x17f523f117bc9fe978aa481eb4f5561711371bc8, 0xde42fcd24ce4239383304367595f068f0c610740, 0x2a46d353777176ff8e83ffa8001f4f70f9733aa5, 0x92e4392816e5f2ef5fb65837cec2c2325cc64922, 0x9a3da65023a13020d22145cfc18bab10bd19ce4e, 0x1a085d43ec92414ea27b914fe767b6d46b1eef44, 0x3b2367f8494b5fe18d683c055d89999c9f3d1b34, 0x84244fc95a6957ed7c1504e49f30b8c35eca4b79, 0x5e031b0a724471d476f3bcd2eb078338bf67fbef, 0x97e5cc6127c4f885be02f44b42d1c8b0ac91e493, 0xeb1cea7b45d1bd4d0e2a007bd3bfb354759e2c16, 0x72feaf124579523954645b7fafff0378d1c8242e, 0x8d07d42d831c2d7c838aa1872b3ad5d277176823, 0x9637dc12723d9c78588542eab082664f3f038d9d, 0xe84b55b525f1039e744b918cb3332492e45eca7a, 0xb1d6b01b94d854fe8b374aa65e895cf22aa2560e, 0x8161d940c3760100b9080529f8a60325030f6edc, 0xd30ee9a12b4d68abace6baca9ad7bf5cd1faf91c, 0x057949e1ca0570469e4ce3c690ae613a6b01c559, 0x4bf8e26f4c2790da6533a2ac9abac3c69a199433, 0x36fec62c2c425e219b18448ad757009d8c54026f, 0x77bfe93ccda750847e41a1affee6b2da96e7214e, 0xcc48414d2ac4d42a5962f29eee4497092f431352, 0xddbddd1bbd38ffade0305d30f02028d92e9f3aa8, 0x30c01142907acb1565f70438b9980ae731818738, 0xcffc49c1787eebb2b56cabe92404b636147d4558, 0xf99eeece39fa7ef5076d855061384009792cf2e0, 0xe9b6a790009bc16642c8d820b7cde0e9fd16d8f5, 0x03b41b51f41df20dd279bae18c12775f77ad771c, 0x787d313fd36b053eeeaedbce74b9fb0678333289, 0x35d2970f49dcc81ea9ee707e9c8a0ab2a8bb7463, 0x4c0aca508b3caf5ee028bc707dd1e800b838f453, 0x514632efbd642c04de6ca342315d40dd90a2dba6, 0x36810ff9d213a271eda2b8aa798be654fa4bbe06, 0x0c088006c64b30c4ddafbc36cb5f05469eb62834, 0x568df31856699bb5acfc1fe1d680df9960ca4359, 0xd48e3f9357e303513841b3f84bda83fc89727587, 0x953ef652e7b769f53d6e786a58952fa93ee6abe7, 0x7c60a05f7a4a5f8cf2784391362e755a8341ef59, 0x7a6b26f438d9a352449155b8876cbd17c9d99b64, 0x68f719ae342bd7fef18a05cbb02f705ad38ed5b2, 0x45ca8d956608f9e00a2f9974028640888465668f, 0x3eaf316b87615d88f7adc77c58e712ed4d77966b, 0x1f0412bfedcd964e837d092c71a5fcbaf30126e2, 0x7471f72eeb300624eb282eab4d03723c649b1b58, 0x9bf71f7fb537ac54f4e514947fa7ff6728f16d2f, 0x1098c774c20ca1daac5ddb620365316d353f109c, 0x7dd8d7a1a34fa1f8e73ccb005fc2a03a15b8229c, 0x0151fa5d17a2dce2d7f1eb39ef7fe2ad213d5d89, 0xad6628352ed3390bafa86d923e56014cfcb360f4, 0x02af2459a93d0b3f4d062636236cd4b29e3bcecf, 0xace2abb63b0604409fbde3e716d2876d44e8e5dd, 0xe710dcd09b8101f9437bd97db90a73ef993d0bf4, 0xd43ee438d83de9a37562bb4e286cb1bd19f4964d, 0xea3779d14a13f6c78566bcde403591413a6239db, 0x6704f169e0d0b36b57bbc39f3c45437b5ee3d28d, 0x5584423050e3c2051f0bbd8f44bd6dbc27ecb62c, 0x2f315d9016e8ee5f536681202f9084b032544d4d, 0xe1b63201fae1f129f95c7a116bd9dde5159c6cda, 0x2bbe62eac80ca7f4d6fdee7e7d8e28b63acf770e, 0x38da1ba2de9e2c954b092dd9d81204fd016ba016, 0x8a86e4a51c013b1fb4c76bcf30667c78d52eedef, 0x8f717ec1552f4c440084fba1154a81dc003ebdc0, 0xc760971bbc181c6a7cf77441f24247d19ce9b4cf, 0x7f150afb1a77c2b45928c268c1e9bdb4641d47d8, 0x1ea334b5750807ea74aac5ab8694ec5f28aa77cf, 0x2afb058c3d31032b353bf24f09ae20d54de57dbe, 0xcaef027b1ab504c73f41f2a10979b474f97e309f, 0x5dd112f368c0e6ceff77a9df02a5481651a02fb7, 0xbd93e550403e2a06113ed4c3fba1a8913b19407e, 0x500c16352e901d48ba8d04e2c767121772790b02, 0xd2a80327cbe55c4c7bd51ff9dde4ca648f9eb3f8, 0x355ccfe0e77d557b971be1a558bc02df9eee0594, 0x5aed0e6cfe95f9d680c76472a81a2b680a7f93e2, 0xf56442f60e21691395d0bffaa9194dcaff12e2b7, 0x7db9eacc52e429dc83b461c5f4d86010e5383a28, 0x4b984ef26c576e815a2eaed2f5177f07dbb1c476, 0x9846648836a307a057184fd51f628a5f8c12427c, 0x4af0db077bb9ba5e443e21e148e59f379105c592, 0xe96e2d3813efd1165f12f602f97f4a62909d3c66, 0x30e789b3d2465e946e6210fa5b35de4e8c93085f, 0x97f99b6ba31346cd98a9fe4c308f87c5a58c5151, 0x595e23d788a2d4bb85a15df7136d264a635511b3, 0x2f61efa5819d705f2b1e4ee754aeb8a819506a75, 0x3554947b7b947b0040da52ca180925c6d3b88ffe, 0x8feffadb387a1547fb284da9b8147f3e7c6dc6da, 0x258939bbf00c9de9af5338f5d714abf6d0c1c671, 0x5b333696e04cca1692e71986579c920d6b2916f9, 0x5381448503c0c702542b1de7cc5fb5f6ab1cf6a5, 0x7e81f6449a03374191f3b7cb05d938b72e090dff, 0x4ef1c214633ad9c0703b4e2374a2e33e3e429291, 0xfed8476d10d584b38bfa6737600ef19d35c41ed8, 0x1a95c9b7546b5d1786c3858fb1236446bc0ca4ce, 0x3b07db5a357f5af2484cbc9d77d73b1fd0519fc7, 0x5f68a24c7eb4117667737b33393fb3c2148a53b6, 0xd8f665fd8cd5c2bcc6ddc0a8ae521e4dc6aa6060, 0xd66acc0d11b689cea6d9ea5ff4014c224a5dc7c4, 0x6e72b2a1186a8e2916543b1cb36a68870ea5d197, 0x5102a4a42077e11c58df4773e3ac944623a66d9f, 0x72480bede81ad96423f2228b5c61be44fb523100, 0xe076db30ab486f79194ebbc45d8fab9a9242f654, 0x8ceea15eec3bdad8023f98ecf25b2b8fef27db29, 0x40652360d6716dc55cf9aab21f3482f816cc2cbd, 0x13e02fb448d6c84ae17db310ad286d056160da95, 0xd6598b1386e93c5ccb9602ff4bbbecdbd3701dc4, 0xd5ea472cb9466018110af00c37495b5c2c713112, 0xbb75cb5051a0b0944b4673ca752a97037f7c8c15, 0x8af626a5f327d7506589eeb7010ff9c9446020d2, 0x318c76ecfd8af68d70555352e1f601e35988042d, 0x5c3d19441d196cb443662020fcad7fbb79b29e78, 0x27101a0f56d39a88c5a84f9b324cdde33e5cb68c, 0xe229e746a83f2ce253b0b03eb1472411b57e5700, 0x604cdf18628dbfa8329194d478dd5201eecc4be7, 0x657473774f63ac3d6279fd0743d5790c4f161503, 0x1ddefefd35ab8f658b2471e54790bc17af98dea4, 0xac3900298dd14d7cc96d4abb428da1bae213ffed, 0x944f07b96f90c5f0d7c0c580533149f3f585a078, 0x232c6d03b5b6e6711efff190e49c28eef36c82b0, 0xc87c77e3c24adecdcd1038a38b56e18dead3b702, 0xc4b6e5f09cc1b90df07803ce3d4d13766a9c46f4, 0xd44334b4e23a169a0c16bd21e866bba52d970587, 0x7757a4b9cc3d0247ccaaeb9909a0e56e1dd6dcc2, 0xcf694081c76d18c64ca71382be5cd63b3cb476f8, 0x133e4f15e1e39c53435930aaedf3e0fe56fde843, 0xf067fb10dfb293e998abe564c055e3348f9fbf1e, 0x94449c01b32a7fa55af8104f42cdd844aa8cbc40, 0x0e2094ac1654a46ba1c4d3a40bb8c17da7f39688, 0x738ca94db7ce8be1c3056cd6988eb376359f3353, 0x0cfb172335b16c87d519cd1475530d20577f5e0e, 0x3cb561ce86424b359891e364ec925ffeff277df7, 0x5f981039fcf50225e2adf762752112d1cc26b6e3, 0xb43657a50eecbc3077e005d8f8d94f377876bad4, 0xd07e511864b1cf9969e3560602829e32fc4e71f5, 0x11306c7d57588637780fc9fde8e98ecb008f0164, 0x45ca9862003b4e40a3171fb5cafa9028cac8de19, 0x231d94155dbcfe2a93a319b6171f63b20bd2b6fa, 0xe7533e270cc61fa164ac1553455c105d04887e14, 0x070d5d364cb7bbf822fc2ca91a35bdd441b215d5, 0xd475477fa56390d33017518d6711027f05f28dbf, 0xcea34a4dd93dd9aefd399002a97d997a1b4b89cd, 0x560becdf52b71f3d8827d927610f1a980f33716f, 0xf632adff490da4b72d1236d04b510f74d2faa3cd, 0x2fdd9b79df8df530ad63c20e62af431ae99216b8, 0x535201a0a1d73422801f55ded4dfaee4fbaa6e3b, 0x409d5a962edeeebea178018c0f38b9cdb213f289, 0x9d911f3682f32fe0792e9fb6ff3cfc47f589fca5, 0x9f7a0392f857732e3004a375e6b1068d49d83031, 0x6a04f5d53fc0f515be942b8f12a9cb7ab0f39778, 0xbe478e8e3dde6bd403bb2d1c657c4310ee192723, 0x007622d84a234bb8b078230fcf84b67ae9a8acae, 0x9475c510ec9a26979247744c3d8c3b0e0b5f44d3, 0xdf47a8ef95f2f49f8e6f58184154145d11f72797, 0x13ce332dff65a6ab933897588aa23e000980fa82, 0x9c4bbcd5f1644a6f075824ddfe85c571d6abf69c, 0xd42b20bd0311608b66f8a6d15b2a95e6de27c5bf, 0xa4dd59ab5e517d398e49fa537f899fed4c15e95d, 0x1a8a5ce414de9cd172937e37f2d59cff71ce57a0, 0x55c564664166a1edf3913e0169f1cd451fdb5d0c, 0x58ae2ddc5f4c8ada97e06c0086171767c423f5d7, 0xfb79abdb925c55b9f98efeef64cfc9eb61f51bb1, 0xe7a42f59fee074e4fb13ea9e57ecf1cc48282249, 0x07e2b4cdeed9d087b12e556d9e770c13c099615f, 0x68473b7a7d965904bedba556dfbc17136cd5d434, 0x6c5c3a54cda7c2f118edba434ed81e6ebb11dd7a, 0x24c117d1d2b3a97ab11a4679c99a774a9eade8d1, 0xf68c5e33fa97139df5b2e63886ce34ebf3e4979c, 0xbd7419dc2a090a46e2873d7de6eaaad59e19c479, 0x1a0a1ddfb031e5c8cc1d46cf05842d50fddc7130, 0x2b3a68db6b0cae8a7c7a476bdfcfbd6205e10687, 0x426d15f407a01135b13a6b72f8f2520b3531e302, 0x0394b90fadb8604f86f43fc1e35d3124b32a5989, 0x7412c9bc30b4df439f023100e63924066afd53af, 0x80e7b3205230a566a1f061d922819bb4d4d2a0e1, 0xff4fc66069046c525658c337a917f2d4b832b409, 0xf5061ee2e5ee26b815503677130e1de07a52db07, 0x49793463e1681083d6abd6e725d5bba745dccde8, 0x23551f56975fe92b31fa469c49ea66ee6662f41e, 0xfad96ab6ac768ad5099452ac4777bd1a47edc48f, 0x2a746cd44027af3ebd37c378c85ef7f754ab5f28, 0xb8d389e624a3a7aebce4d3e5dbdf6cdc29932aed, 0x7b761feb7fcfa7ded1f0eb058f4a600bf3a708cb, 0x5435c6c1793317d32ce13bba4c4ffeb973b78adc, 0xdd04eee74e0bf30c3f8d6c2c7f52e0519210df93, 0x4331ab3747d35720a9d8ca25165cd285acd4bda8, 0xb84c8b9fd33ece00af9199f3cf5fe0cce28cd14a, 0x393f783b5cdb86221bf0294fb714959c7b45899c, 0x259ec4d265f3ab536b7c70fa97aca142692c13fc, 0x5d2f7f0b04ba4be161e19cb6f112ce7a5e7d7fe4, 0xd54ba2d85681dc130e5b9b02c4e8c851391fd9b9, 0x5cd8af60de65f24dc3ce5730ba92653022dc5963, 0x3b42a66d979f582834747a8b60428e9b4eeccd23, 0x4b19eb0c354bc1393960eb06063b83926f0d67b2, 0x8cf3546fd1cda33d58845fc8fcfecabca7c5642a, 0x113612bc3ba0ee4898b49dd20233905f2f458f62, 0x1f2afc0aed11bfc71e77a907657b36ea76e3fb99, 0x03714b41d2a6f751008ef8dd4d2b29aecab8f36e, 0x25721c87b0dc21377c7200e524b14a22f0af69fb, 0x335858f749f169cabcfe52b796e3c11ec47ea3c2, 0x52fb46ac5d00c3518b2c3a1c177d442f8165555f, 0x7a8c89c014509d56d7b68130668ff6a3ecec7370, 0x7d5d2f73949dadda0856b206989df0078d51a1e5, 0xbe538246dd4e6f0c20bf5ad1373c3b463a131e86, 0x62680a15f8ccb8bdc02f7360c25ad8cfb57b8ccd, 0xaa0ca3737337178a0caac3099c584b056c56301c, 0x1d341fa5a3a1bd051f7db807b6db2fc7ba4f9b45, 0x6463f715d594a1a4ace4bb9c3b288a74decf294d, 0xe00d153b10369143f97f54b8d4ca229eb3e8f324, 0x8d0b9ea53fd263415eac11391f7ce9123c447062, 0xcacb675e0996235404efafbb2ecb8152271b55e0, 0xb615e940143eb57f875893bc98a61b3d618c1e8c, 0x606f177121f7855c21a5062330c8762264a97b31, 0xe3925509c8d0b2a6738c5f6a72f35314491248ce, 0x3f08d9ad894f813e8e2148c160d24b353a8e74b0, 0x40f4f4c06c732cd35b119b893b127e7d9d0771e4, 0x1406854d149e081ac09cb4ca560da463f3123059, 0xecf05d07ea026e7ebf4941002335baf2fed0f002, 0x9a990b8aeb588d7ee7ec2ed8c2e64f7382a9fee2, 0xa2e0683a805de6a05edb2ffbb5e96f0570b637c3, 0xfba5486d53c6e240494241abf87e43c7600d413a, 0xd81bd54ba2c44a6f6beb1561d68b80b5444e6dc6, 0x5298ab182a19359ffcecafd7d1b5fa212dede6dd, 0xd1acb5adc1183973258d6b8524ffa28ffeb23de3, 0x4e7aa67e12183ef9d7468ea28ad239c2eef71b76, 0x509a20bc48e72be1cdaf9569c711e8648d957334, 0x949f84f0b1d7c4a7cf49ee7f8b2c4a134de32878, 0xedbac9527b54d6df7ae2e000cca3613ba015cae3, 0xc697b70477cab42e2b8b266681f4ae7375bb2541, 0x86c934e38e53be3b33f274d0539cfca159a4d0d1, 0x0877eeaeab78d5c00e83c32b2d98fa79ad51482f, 0x5e11ecf69d551d7f4f84df128046b3a13240a328, 0x43ff8853e98ed8406b95000ada848362d6a0392a, 0xf11cf5d363746fee6864d3ca336dd80679bb87ae, 0xfb223c1e22eac1269b32ee156a5385922ed36fb8, 0x4e6600806289454acda330a2a3556010dfacade6, 0xcfe2caaf3cec97061d0939748739bffe684ae91f, 0xadeb52b604e5f77faaac88275b8d6b49e9f9f97f, 0xd53c567f0c3ff2e08b7d59e2b5c73485437fc58d, 0xfbf75933e01b75b154ef0669076be87f62dffae1, 0x7dfd2962b575bcbeee97f49142d63c30ab009f66, 0xdf6485c4297ac152b289b19dde32c77ec417f47d, 0xffb974673367f5c07be5fd270dc4b7138b074d57, 0xf7d7af204c56f31fd94398e40df1964bd8bf123c, 0x4506fe19fa4b006baa3984529d8516db2b2b50ab, 0xf4dc7ba85480bbb3f535c09568aaa3af6f3721c6, 0xd171c3f2258aef35e599c7da1aa07300234da9a6, 0x33581cee233088c0860d944e0cf1ceabb8261c2e, 0x1c2e3607e127caca0fbd5c5948adad7dd830b285, 0xfd7ede8f5240a06541eb699d782c2f9afb2170f6, 0x368c5414b56b8455171fbf076220c1cba4b5ca31, 0x3e8745ba322f5fd6cb50124ec46688c7a69a7fae, 0x76506eb4a780c951c74a06b03d3b8362f0999d71, 0x96d62dfd46087f62409d93dd606188e70e381257, 0x37eada93c475ded2f7e15e7787d400470fa52062, 0x26babf42b267fdcf3861fdd4236a5e474848b358, 0x3526eece1a6bdc3ee7b400fe935b48463f31bed7, 0x27b62816e1e3b8d19b79d1513d5dfa855b0c3a2a, 0xb3e3c439069880156600c2892e448d4136c92d9b, 0x574ad9355390e4889ef42acd138b2a27e78c00ae, 0xf0b9d683cea12ba600baace219b0b3c97e8c00e4, 0xa437fe6ec103ca8d158f63b334224eccac5b3ea3, 0x7a48d877b63a8f8f9383e9d01e53e80c528e955f, 0xe965daa34039f7f0df62375a37e5ab8a72b301e7, 0x72cd048a110574482983492dfb1bd27942a696ba, 0x6611ce59a98b072ae959dc49ad511daaaaa19d6b, 0x0d92582fdba05eabc3e51538c56db8813785b328, 0xe87e9bbfbbb71c1a740c74c723426df55d063dd9, 0x9c99a1da91d5920bc14e0cb914fdf62b94cb8358, 0xfe8e6e3665570dff7a1bda697aa589c0b4e9024a, 0x811461a2b0ca90badac06a9ea16e787b33b196cc, 0xd211b21f1b12b5096181590de07ef81a89537ead, 0x01155057002f6b0d18acb9388d3bc8129f8f7a20, 0x8ce22f9fa372449a420610b47ae0c8d565481232, 0xe02b74a47628be315b1f76b315054ad44ae9716f, 0x92a7c5a64362e9f842a23deca21035857f889800, 0x5213f459e078ad3ab95a0920239fcf1633dc04ca, 0xc9957ba94c1b29e5277ec36622704904c63dc023, 0x6ac40f532dfee5118117d2ad352da77d4f6da2c8, 0xea1efb3ce789bedec3d67c3e1b3bc0e9aa227f90, 0xb01e389b28a31d8e4995bdd7d7c81beeab1e4119, 0xee97aa8ac69edf7a987d6d70979f8ec1fbca7a94, 0x0fad05507cdc8f24b2be4cb7fa5d927ddb911b88, 0xb6e8afd93dfa9af27f39b4df06076710bee3dfab, 0x7d0b255efb57e10f7008aa22d40e9752dfcf0378, 0xaef5b12258a18dec07d5ec2e316574919d79d6d6, 0x63666755bd41b5986997783c13043008242b3cb5, 0x921f5261f4f612760706892625c75e7bce96b708, 0x10e1e3377885c42d7df218522ee7766887c05e6a, 0x134163be9fbbe1c5696ee255e90b13254395c318, 0x870f15e5df8b0eabd02569537a8ef93b56785c42, 0x68eec1e288ac31b6eaba7e1fbd4f04ad579a6b5d, 0x1a2694ec07cf5e4d68ba40f3e7a14c53f3038c6e, 0xcd9b4cef73390c83a8fd71d7b540a7f9cf8b8c92, 0xc8de7a564c7f4012a6f6d10fd08f47890fbf07d4, 0xc0345b33f49ce27fe82cf7c84d141c68f590ce76, 0xfe53b94989d89964da2061539526bbe979dd2ea9, 0x14410fb310711be074a80883c635d0ef6afb2539, 0x1d344e962567cb27e44db9f2fac7b68df1c1e6f7, 0xfe016ec17ec5f10e3bb98ff4a1eda045157682ab, 0xe89da96e06beaf6bd880b378f0680c43fd2e9d30, 0x0fee81ac331efd8f81161c57382bb4507bb9ebec, 0x40cf90ef5b768c5da585002ccbe6617650d8e837, 0x256fa150cc87b5056a07d004efc84524739e62b5, 0x1b9b2dc2960e4cb9408f7405827c9b59071612fd, 0x0efd1789eb1244a3dede0f5de582d8963cb1f39f, 0x049c5d4bc6f25d4e456c697b52a07811ccd19fb1, 0x02b7b1d6b34ce053a40eb65cd4a4f7dddd0e9f30, 0xc1827686c0169485ec15b3a7c8c01517a2874de1, 0xd8e5c9675ef4deed266b86956fc4590ea7d4a27d, 0x48f883e567b436a27bb5a3124dbc84dec775a800, 0xa34076f84bd917f20f8342c98ba79e6fb08ecd31, 0x21ce6d5b9018cec04ad6967944bea39e8030b6b8, 0x0596a27dc3ee115fce2f94b481bc207a9e261525, 0x717cf9beab3638308ded7e195e0c86132d163fed, 0xd5ce55d1b62f59433c2126bcec09bafc9dfaa514, 0x7dd46da677e161825e12e80dc446f58276e1127c, 0x98c5494a03ac91a768dffc0ea1dde0acbf889019, 0x617ff2cc803e31c9082233b825d025be3f7b1056, 0x1091176be19b9964a8f72e0ece6bf8e3cfad6e9c, 0x4ea56e1112641c038d0565a9c296c463afefc17e, 0xe303167f3d4960fe881b32800a2b4aeff1b088d4, 0x773141127d8cf318aebf88365add3d5527d85b6a, 0xb916b1a01cdc4e56e7657715ea37e2a0f087d106, 0x46a430a2d4a894a0d8aa3feac615361415c3f81f, 0xe6a3010f0201bc94ff67a2f699dfc206f9e76742, 0xd7ad09c6d32657685355b5c6ec8e9f57b4ebb982, 0x95e80a82c20cbe3d2060242cb92d735810d034a2, 0x9a390162535e398877e416787d6239e0754e937c, 0xd85fdeaf2a61f95db902f9b5a53c9b8f9266c3ac, 0xc3e20c96df8d4e38f50b265a98a906d61bc51a71, 0x2949fd1def5c76a286b3872424809a07db3966f3, 0x86cdb7e51ac44772be3690f61d0e59766e8bfc18, 0x749a4a768b5f237248938a12c623847bd4e688dc, 0x3524a000234ebaaf0789a134a2a417383ce5282a, 0x7b43c7eea8d62355b0a8a81da081c6446b33e9e0, 0x0eb189ef2c2d5762a963d6b7bdf9698ea8e7b48a, 0x767fd7797d5169a05f7364321c19843a8c348e1e, 0x1b2639588b55c344b023e8de5fd4087b1f040361, 0x1e33d1c2fb5e084f2f1d54bc5267727fec3f985d, 0x06b106649aa8c421ddcd1b8c32cd0418cf30da1f, 0x3c5a241459c6abbf630239c98a30d20b8b3ac561, 0x0f4f94b9191bb7bb556aaad7c74ddb288417a50b, 0xd6f4a7d04e8faf20e8c6eb859cf7f78dd23d7a15, 0x61adf5929a5e2981684ea243baa01f7d1f5e148a, 0x8f58d8348fc1dc4e0dd8343b6543c857045ee940, 0xa6e3baa38e104a1e27a4d82869afb1c0ae6eff8d, 0x67350b5331926f5e28f3c1e986f96443809c8b8c, 0x0b5d66b13c87b392e94d91d5f76c0d450a552843, 0x562a8dcbbeeef7b360685d27303bd69e094accf6, 0xb5d9934d7b292bcf603b2880741eb760288383a0, 0x6fc53662371dca587b59850de78606e2359df383, 0xe069c0173352b10bf6834719db5bed01adf97bbc, 0x10a93457496f1108cd98e140a1ecdbae5e6de171, 0x69ff8901b541763f817c5f2998f02dcfc1df2997, 0x00c27d63fde24b92ee8a1e7ed5d26d8dc5c83b03, 0x77f81b1b26fc84d6de97ef8b9fbd72a33130cc4a, 0x6d20ef9704670a500bb269b5832e859802049f01, 0x186afdc085f2a3dce4615edffbadf71a11780f50, 0x7ff0c63f70241bece19b737e5341b12b109031d8, 0x9d4174aa6af28476e229dadb46180808c67505c1, 0x5fec49c665e64ee89dd441ee74056e1f01e92870, 0x6cd228dc712169307fe27ceb7477b48cfc8272e5, 0xfd918536a8efa6f6cefe1fa1153995fef5e33d3b, 0x2fbb504a5dc527d3e3eb0085e2fc3c7dd538cb7a, 0x6ab323ae5056ed0a453072c5abe2e42fcf5d7139, 0x67d682a282ef73fb8d6e9071e2614f47ab1d0f5e, 0x1858cf11aea79f5398ad2bb22267b5a3c952ea74, 0x39d6caca22bccd6a72f87ee7d6b59e0bde21d719, 0xdaa63cbda45dd487a3f1cd4a746a01bb5e060b90, 0xa90476e2efdfee4f387b0f32a50678b0efb573b5, 0xae5aa1e6c2b60f6fd3efe721bb4a719cbe3d6f5d, 0xac2e766dac3f648f637ac6713fddb068e4a4f04d, 0x6191ddc9b64a8e0890b4323709d7a07c48b92a64, 0xcc4f0ff2aeb67d54ce3bc8c6510b9ae83e9d328b, 0xca23f62dff0d6460036c62e840aec5577e0befd2, 0x97dc26ec670a31e0221d2a75bc5dc9f90c1f6fd4, 0x848c994a79003fe7b7c26cc63212e1fc2f9c19eb, 0x20c284ba10a20830fc3d699ec97d2dfa27e1b95e, 0x4fa3f32ef4086448b344d5f0a9890d1ce4d617c3, 0x255abc8d08a096a88f3d6ab55fbc7352bddcb9ce, 0x7c60e51f0be228e4d56fdd2992c814da7740c6bc, 0x1c356cfdb95febb714633b28d5c132dd84a9b436, 0x5062e5134c612f12694dbd0e131d4ce197d1b6a4, 0xed862616fcbfb3becb7406f73c5cbff00c940755, 0x62c9b271ffd5b770a5eee4edc9787b5cdc709714, 0x3c925619c9b33144463f0537d896358706c520b0, 0xffe2e28c3fb74749d7e780dc8a5d422538e6e451, 0x37195a635dcc62f56a718049d47e8f9f96832891, 0x90e9a9a82edaa814c284d232b6e9ba90701d4952, 0xe0c4ab9072b4e6e3654a49f8a8db026a4b3386a9, 0x439dee3f7679ff1030733f9340c096686b49390b, 0x548558d08cfcb101181dac1eb6094b4e1a896fa6, 0x3090f8130ec44466afadb36ed3c926133963677b, 0xd1648503b1ccc5b8be03fa1ec4f3ee267e6adf7b, 0x65b42faecc1edfb14283ca979af545f63b30e60c, 0x6420f8bcc8164a6152a99d6b99693005ccf7e053, 0x84b4b74e6623ba9d1583e0cfbe49643f16384149, 0xb8310a16cc6abc465007694b930f978ece1930bd, 0x16019a4dafab43f4d9bf4163fae0847d848afca2, 0x479298a9de147e63a1c7d6d2fce089c7e64083bd, 0x030973807b2f426914ad00181270acd27b8ff61f, 0xb07bcf1cc5d4462e5124c965ecf0d70dc27aca75, 0xa2f798e077b07d86124e1407df32890dbb4b6379, 0x0cbd921dbe121563b98a6871fecb14f1cc7e88d7, 0x6042276df2983fe2bc4759dc1943e18fdbc34f77, 0xbe2b2280523768ea8ac35cd9e888d60a719300d4, 0x2f4da753430fc09e73acbccdcde9da647f2b5d37, 0x734223d27ff23e5906caed22595701bb34830ca1, 0x5b430d779696a3653fc60e74fbcbacf6b9c2baf1, 0x84232107932b12e03186583525ce023a703ef8d9, 0x4ed14d81b60b23fb25054d8925dfa573dcae6168, 0x8b338411f26ccf37658cc75521d77629099e467d, 0xa37622ac9bbdc4d82b75015d745b9f8de65a28ec, 0x1dd77441844afe9cc18f15d8c77bccfb655ee034, 0x65849be1af20100eb8a3ba5a5be4d3ae8db5a70e, 0xd5586da4e59583c8d86cccf71a86197f17996749, 0x4b53ae59c784b6b5c43616b9a0809558e684e10c, 0x55d42eb495bf46a634997b5f2ea362814918e2b0, 0x959ff17f1d51b473b44010052755a7fa8c75bd54, 0x5a2daab25c31a61a92a4c82c9925a1d2ef58585e, 0x24c0c88b54a3544709828ab4ab06840559f6c5e2, 0x7e8649e690fc8c1bfda1b5e186581f649b50fe33, 0x4acfa9d94eda6625c9dfa5f9f4f5d107c4031fdf, 0x5778ffdc9b94c5a59e224eb965b6de90f222d170, 0x825a7f4e10949cb6f8964268f1fa5f57e712b4c4, 0x6f39cc37caaa2ddc9b610f6131e0619fae772a3c, 0x5b437365ae3a9a2ff97c68e6f90a7620188c7d19, 0x6710c2c03c65992b2e774be52d3ab4a6ba217ef7, 0x896e335ca47af57962fa0f4dbf3e45e688cba584, 0xb57549bfbc9bdd18f736b22650e48a73601fa65c, 0x85ca1e727e9d1a87991cc2c41840ebb9edf21d1b, 0xcf4166746e1d3bc1f8d0714b01f17e8a62df1464, 0x4a75c3d4fa6fccbd5dd5a703c15379a1e783e9b7, 0x9e5811b40be1e2a1e1d28c3b0774acde0a09603d, 0x763886e333c56feff85be3951ab0b889ce262e95, 0x2b101e822cd962962a06800a2c08d3b15d82b735, 0xa01e9476df84431825c836e8803a97e22fa5a0cd, 0xbe4e7d983f2e2a636b1102ec7039efebc842e98d, 0x9e427272516b3e67d4fcbf82f59390d04c8e28e5, 0xe0d231e144ec9107386c7c9b02f1702ceaa4f700, 0x6a0f056066c2d56628850273d7ecb7f8e6e9129e, 0xd1538e9a87e59ca9ec8e5826a5b793f99f96c4c3, 0xf85bab1cb3710fc05fa19ffac22e67521a0ba21d, 0xf7cbdba6be6cfe68dbc23c2b0ff530ee05226f84, 0x4eb87ba8788eba0df87e5b9bd50a8e45368091c1, 0x1479a9ec7480b74b5db8fc499be352da7f84ee9c, 0xd311bcd7aa4e9b4f383ff3d0d6b6e07e21e3705d, 0x425c1816868f7777cc2ba6c6d28c9e1e796c52b3, 0x8510ee934f0cbc900e1007eb38a21e2a5101b8b2, 0x01e864d354741b423e6f42851724468c74f5aa9c, 0xa543a066fb32a8668aa0736a0c9cd40d78098727, 0xf3eb1948b951e22df1617829bf3b8d8680ec6b68, 0xf6b782f4dcd745a6c0e2e030600e04a24b25e542, 0x229f4f1a2a4f540774505b4707a81de44410255b, 0xcff8d06b00e3f50c191099ad56ba6ae26571cd88, 0x910b7d577a7e39aa23acf62ad7f1ef342934b968, 0x392433d2ce83d3fb4a7602cca3faca4ec140a4b0, 0x8ff46045687723dc33e4d099a06904f1ebb584dc, 0x9ca0429f874f8dcee2e9c062a9020a842a587ab9, 0x160ceb6f980e04315f53c4fc988b2bf69e284d7d, 0xc340f9b91c26728c31d121d5d6fc3bb56d3d8624, 0xafa1d5ad38fed44759c05b8993c1aa0dace19f40, 0x3969b4f71bb8751ede43c016363a7a614f76118e, 0x2bb6f578adfbe7b2a116b3554facf9969813c319, 0x8334764b7b397a4e578f50364d60ce44899bff94, 0x9dd2196624a1ddf14a9d375e5f07152baf22afa2, 0xf242da845d42d4bf779a00f295b40750fe49ea13, 0xc6234657a807384126f8968ca1708bb07baa493c, 0x94c055e858357aaa30cf2041fa9059ce164a1f91, 0x74c73c90528a157336f1e7ea20620ae53fd24728, 0x19e7f3eb7bf67f3599209ebe08b62ad3327f8cde, 0xb2b516fdd19e7f3864b6d2cf1b252a4156f1b03b, 0x8164e78314ae16b28926cc553d2ccb16f356270d, 0x4d828894752f6f25175daf2177094487954b6f9f, 0xab84a0f147ad265400002b85029a41fc9ce57f85, 0xf3fe51fde34413c73318b9c85437fe7e820f561a, 0x16c7b31e8c376282ac2271728c31c95e35d952c3, 0x80d5c40c59c7f54ea3a55fcfd175471ea35099b3, 0x7abb10f5bd9bc33b8ec1a82d64b55b6b18777541, 0x095b0ea2b218d82e0aea7c2889238a39c9bf9077, 0x5d5cdbe25b2a044b7b9be383bcaa5807b06d3c6b, 0x323749a3b971959e46c8b4822dcafaf7aaf9bd6e, 0xe0272213e8d2fd3e96bd6217b24b4ba01b617079, 0x00acbfb2f25a5485c739ef70a44eeeeb7c65a66f, 0x52f15423323c24f19ae2ab673717229d3f747d9b, 0xcb4abfc282aed76e5d57affda542c1f382fcacf4, 0xf71b4534f286e43093b1e15efea749e7597b8b57, 0x44cd77535a893fa7c4d5eb3a240e79d099a72d2d, 0xeb3ce7fc381c51db7d5fbd692f8f9e058a4c703d, 0xf1c8c4a941b4628c0d6c30fda56452d99c7e1b64, 0x277677aba1e52c3b53bfa2071d4e859a0af7e8e1, 0xa5f075fd401335577b6683c281e6d101432dc6e0, 0xe28dbc8efd5e416a762ec0e018864bb9aa83287b, 0x2b717cd432a323a4659039848d3b87de26fc9546, 0xb358e97c70b605b1d7d729dfb640b43c5eafd1e7, 0x293c2306df3604ae4fda0d207aba736f67de0792, 0x74d366b07b2f56477d7c7077ac6fe497e0eb6559, 0x490145afa8b54522bb21f352f06da5a788fa8f1d, 0x862569211e8c6327b5415e3a67e5738b15baaf6e, 0x5a74ba62e7c81a3474e27d894fed33dd24ad95fe, 0x536e4d8029b73f5579dca33e70b24eba89e11d7e, 0x25c6e74ff1d928df98137af4df8430df24f07cd7, 0x19b36b0c87ea664ed80318dc77b688dde87d95a5, 0xabc4caeb474d4627cb6eb456ecba0ecd08ed8ae1, 0x8ea656e71ec651bfa17c5a5759d86031cc359977, 0x8d620bde17228f6cbba74df6be87264d985cc179, 0xb2aa2f1f8e93e79713d92cea9ffce9a40af9c82d, 0x198ef1ec325a96cc354c7266a038be8b5c558f67, 0x6a13d5e32c1fd26d7e91ff6e053160a89b2c8aad, 0xe056bf3ff41c26256fef51716612b9d39ade999c, 0x2c128c95d957215101f043dd8fc582456d41016d, 0x2560b09b89a4ae6849ed5a3c9958426631714466, 0xd3d6e9fb82542fd29ed9ea3609891e151396b6f7, 0xa7607b42573bb6f6b4d4f23c7e2a26b3a0f6b6f0, 0x020362c3ade878ca90d6b2d889a4cc5510eed5f3, 0x14830704e99aaad5c55e1f502b27b22c12c91933, 0x8030b111c6983f0485ddaca76224c6180634789f, 0x2c5b7d7b195a371bf9abddb42fe04f2f1d9a9910, 0x77d43fa7b481dbf3db530cfbf5fdced0e6571831, 0x2d90b415a38e2e19cdd02ff3ad81a97af7cbf672, 0x2fc82ef076932341264f617a0c80dd571e6ae939, 0xdfe549fe8430e552c6d07cc3b92ccd43b12fb50f, 0x1e8e689b02917cdc29245d0c9c68b094b41a9ed6, 0x21c3a8bba267c8cca27b1a9afabad86f607af708, 0x143c639752caeecf6a997d39709fc8f19878c7e8, 0x02603d7a3bb297c67c877e5d34fbd5b913d4c63a, 0xa166f911c644ac3213d29e0e1ae010f794d5ad26, 0x6eb3819617404058268f0c3cff3596bfe9148c1c, 0x7a67dd043a504fc2f2fc7194e9becf484cecb1fb, 0xf824ee331e4ac3cc587693395b57ecf625a6c0c2, 0x1179c60dbd068b150b074da4be23033b20c68558, 0xd2a479404347c5543aab292ae1bb4a6f158357fa, 0xb0d32bd7e4e695b7b01aa3d0416f80557dba9903, 0xf734ec03724ddee5bb5279aa1afcf61b0cb448a1, 0xc04069dfb18b096c7867f8bee77a6dc7477ad062, 0x80c53ee7e3357f94ce0d7868009c208b4a130125, 0x0f32d9cb4d0fdaa0150656bb608dcc43ed7d9301, 0x6ddb6092779d5842ead378e21e8120fd4c6bc132, 0x82ea01e3bf2e83836e71704e22a2719377efd9c3, 0x44c1110b18870ec81178d93d215838c551d48e64, 0x7727af101f0aaba4d23a1cafe17c6eb5dab1c6dc, 0xa11a03c4bb26d21eff677d5d555c80b25453ee7a, 0x19e5dea3370a2c746aae34a37c531f41da264e83, 0xc325c352801ba883b3226c5feb0df9eae2d6e653, 0xae5055814cb8be0c117bb8b1c8d2b63b4698b728, 0xdeb1bc34d86d4a4dde2580d8beaf074eb0e1a244, 0x558360206883dd1b6d4a59639e5629d0f0c675d0, 0xa9d6f871ca781a759a20ac3adb972cf12829a208, 0xb0ac4eff6680ee14169cdadbffdb30804f6d25f5, 0xf1b58faffa8794f50af8e88309c7a6265455d51a, 0xa61a54df784a44d71b771b87317509211381f200, 0xbaa4b64c2b15b79f5f204246fd70bcbd86e4a92a, 0xa20d8ff60caae31d02e0b665fa435d76f77c9442, 0xf3e74f470c7d3a3f0033780f76a89f3ef691e6cb, 0xd330728131fe8e3a15487a34573c93457e2afe95, 0x9af9dbe47422d177f945bdead7e6d82930356230, 0x0eb5b662a1c718608fd52f0c25f9378830178519, 0xfda6810ea5ac985d6ffbf1c511f1c142edcfddf7, 0x832c54176bdf43d2c9bcd7b808b89556b89cbf31, 0x704d5de4846d39b53cd21d1c49f096db5c19ba29, 0x344a8db086faed4efc37131b3a22b0782dad7095, 0x8c7fa5cae82fedb69ab189d3ff27ae209293fb93, 0xad660dec825522a9f62fcec3c5b731980dc286ea, 0x13b9b10715714c09cfd610cf9c9846051cb1d513, 0x40467d80e74c35407b7db51789234615fea66818, 0x30e9d5a0088f1ddb2fd380e2a049192266c51cbf, 0xb2d1e99af91231858e7065dd1918330dc4c747d5, 0x9f21302ca5096bea7402b91b0fd506254f999a3d, 0xd24b6644f439c8051dfc64d381b8c86c75c17538, 0x8228ebc087480fd64547ca281f5eace3041453b9, 0x29da3e35b23bb1f72f8e2258cf7f553359d24bac, 0xc8e558a3c5697e6fb23a2594c880b7a1b68f9860, 0x6b951a43274eeafc8a0903b0af2ec92bf1efc839, 0xd015f6fcb84df7bb410e8c8f04894a881dcac237, 0x6ccb03acf7f53ce87aadcc21a9932de915f89804, 0x388c85a9b9207d8146033fe38143f6d34b595c47, 0x429c06b487e8546abdfc958a25a3f0fba53f6f00, 0x771507aeee6a255dc2cd9df55154062d0897b297, 0x5a2b1c853aeb28c45539af76a00ac2d8a8242896, 0xf4d67a9044b435b66e8977ff39a28dc4bd53729a, 0x063759dd1c4e362eb19398951ff9f8fad1d31068, 0xcb58990bcd90cfbf6d8f0986f6fa600276b94e2d, 0x6df5c84f7b909aab3e61fe0ecb1b3bf260222ad2, 0xdeb2495d6aca7b2a6a2d138b6e1a42e2dc311fdd, 0x59203cc37599b648312a7cc9e06dacb589a9ae6a, 0xfc9b347464b2f9929d807e039dae48d3d98de379, 0x48d2434b7a7dbbff08223b6387b05da2e5093126, 0xc9d76446d5aadff80b68b91b08cd9bc8f5551ac1, 0x3d31587b5fd5869845788725a663290a49d3678c, 0xd8715ef9176f850b2e30eb8e382707f777a6fbe9, 0x2c2147947ae33fb098b489a5c16bfff9abcd4e2a, 0xd6c0d0bc93a62e257174700e10f024c8b23f1f87, 0xd1978f2e34407fab1dc2183d95cfda6260b35982, 0x1bf974d9904f45ce81a845e11ef4cbcf27af719e, 0x6e761eaa0f345f777b5441b73a0fa5b56b85f22d, 0xea60436912de6bf187d3a472ff8f5333a0f7ed06, 0x94f8f057db7e60e675ad940f155885d1a477348e, 0x8933491760c8f0b4df8caac78ed835caee21046d, 0xa7775e4af6a23afa201fb78b915e51a515b7a728, 0xd8d64384249b776794063b569878d5e3b530a4b2, 0xbe633a3737f68439bac7c90a52142058ee8e8a6f, 0x90bd62a050845261fa4a9f7cf241ea630b05efb8, 0x552987f0651b915b2e1e5328c121960d4bdd6af4, 0x0baf6ecdb91acb3606a8357c0bc4f45cfd2d7e6f, 0x9e5a311d9f69898a7c6a9d6360680438e67a7b2f, 0x78859c5b548b700d9284cee4b6633c2f52e529c2, 0xd572309169b1402ec8131a17a6aac3222f89e6eb, 0x8e6d7485cbe990acc1ad0ee9e8ccf39c0c93440e, 0x75c11d024d12ae486c1095b7a7b9c4af3e8edeb9, 0x903413878aea3bc1086309a3fe768b65559e8cab, 0x6d0569e5558fc7df2766f2ba15dc8aeffc5beb75, 0x3815b0743f94fc8cc8654fd9d597ed7d8b77c57e, 0x0f26480a150961b8e30750713a94ee6f2e47fc00, 0xede5de7c7fb7eee0f36e64530a41440edfbefacf, 0x763a7cbab70d7a64d0a7e52980f681472593490c, 0x6e270ad529f1f0b8d9cb6d2427ec1b7e2dc64a74, 0xeb3bdd59dcdda5a9bb2ac1641fd02180f5f36560, 0xf4ebf50bc7e54f82e9b9bd24baef29438e259ce6, 0x882c8f81872c79fed521cb5f950d8b032322ea69, 0x394132600f4155e07f4d45bc3eb8d9fb72dcd784, 0x0be2b94ad950a2a62640c35bfccd6c67dae450f6, 0xd4c6ac742e7c857d4a05a04c33d4d05c1467571d, 0x1fddd85fc98be9c4045961f40f93805ecc4549e5, 0x534065361cb854fac42bfb5c9fcde0604ac919da, 0x9a6ff5f6a7af7b7ae0ed9c20ecec5023d281b786, 0x4f3a4854911145ea01c644044bdb2e5a960a982f, 0x00497e92cdc0e0b963d752b2296acb87da828b24, 0x4ff67fb87f6efba9279930cfbd1b7a343c79fade, 0x62f2e5ccecd52cc4b95e0597df27cc079715608c, 0x1eda084e796500ba14c5121c0d90846f66e4be62, 0x9836b4d30473641ab56aeee19242761d72725178, 0xde55de0458f850b37e4d78a641dd2eb2dd8f38ce, 0x140ca28ff33b9f66d7f1fc0078f8c1eef69a1bc0, 0x2014261f01089f53795630ba9dd24f9a34c2d942, 0x11415fab61e0dfd4b90676141a557a869ba0bde9, 0x88344909644c7ad4930fd873ca1c0da2d434c07f, 0x88b217ccb786a254cf4dc57f5d9ac3c455a30483, 0xdfdbcec1014b96da2158ca513e9c8d3b9af1c3d0, 0x1ba9f7997e5387b6b2aa0135ac2452fe36b4c20d, 0xd70ad2c4e9eebfa637ef56bd486ad2a1e5bce093, 0x9ce27f245e02d1c312c1d500788c9def7690453b, 0x8234f463d18485501f8f85ace4972c9b632dbccc, 0x994152fc95d5c1ca8b88113abbad4d710e40def6, 0xe5b980d28eece2c06fca6c9473068b37d4a6d6e9, 0x2d426912d059fad9740b2e390a2eeac0546ff01b, 0x6d9997509882027ea947231424bedede2965d0ba, 0x167ce7de65e84708595a525497a3eb5e5a665073, 0xe430c0024fdbf73a82e21fccf8cbd09138421c21, 0x2e52912bc10ea39d54e293f7aed6b99a0f4c73be, 0x12cf8b0e465213211a5b53dfb0dd271a282c12c9, 0x06964e2d17e9189f88a8203936b40ac96e533c06, 0x66b1a63da4dcd9f81fe54f5e3fcb4055ef7ec54f, 0x0a77e7f72b437b574f00128b21f2ac265133528c, 0x78f5c74785c5668a838072048bf8b453594ddaab, 0x58e554af3d87629620da61d538c7f5b4b54c4afe, 0x37a10451f36166cf643dd2de6c1cbba8a011cfa3, 0xfe9ad12ef05d6d90261f96c8340a0381974df477, 0x057f7f81cd7a406fc45994408b5049912c566463, 0x55a3df57b7aaec16a162fd5316f35bec082821cf, 0xc0e0b903088e0c63f53dd069575452aff52410c3, 0x63e88e2e539ffb450386b4e46789b223f5476c45, 0x3727341f26c12001e378405ee38b2d8464ec7140, 0xc96751656c0a8ef4357b7344322134b983504aca, 0x1e060dc6c5f1cb8cc7e1452e02ee167508b56542, 0x18136c9df167aa17b6f18e22a702c88f4bc28245, 0x116108c12084612eeda7a93ddcf8d2602e279e5c, 0xbbb643d2187b364afc10a6fd368d7d55f50d1a3c, 0xec83e798c396b7a55e2a2224abcd834b27ea459c, 0x973f4e361fe5decd989d4c8f7d7cc97990385daf, 0xc0f29ed0076611b5e55e130547e68a48e26df5e4, 0xfd4b551f6fdbcda6c511b5bb372250a6b783e534, 0x144b19f1f66cbe318347e48d84b14039466c5909, 0xbf183641edb886ce60b8190261e14f42d93cce01, 0x94db807873860aac3d5aea1e885e52bff2869954, 0x7a74cee4fa0f6370a7894f116cd00c1147b83e59, 0xcd32a4a8a27f1cc63954aa634f7857057334c7a3, 0x7cbeb99932e97e6e02058cfc62d0b26bc7cca52b, 0x8cde8b732e6023878eb23ed16229124b5f7afbec, 0x45c4ecb4ee891ea984a7c5cefd8dfb00310b2850, 0x8b393fb0813ee101db1e14ecc7d322c72b8c0473, 0x7b66126879844dfa34fe65c9f288117fefb449ad, 0x162ba503276214b509f97586bd842110d103d517, 0x7dece6998ae1900dd3770cf4b93812bad84f0322, 0xec0927bac7dc36669c28354ab1be83d7eec30934, 0x8d7f3e61299c2db9b9c0487cf627519ed00a9123, 0x4fc46c396e674869ad9481638f0013630c87caac, 0xbf68d28aaf1eeefef646b65e8cc8d190f6c6da9c, 0x00969747f7a5b30645fe00e44901435ace24cc37, 0x494dec4d5ee88a2771a815f1ee7264942fb58b28, 0xffeac0305ede3a915295ec8e61c7f881006f4474, 0xb39139576194a0866195151f33f2140ad1cc86cf, 0xfead1803e5e737a68e18472d9ac715f0994cc2be, 0x698ab9a2f33381e07c0c47433d0d21d6f336b127, 0xe5edc73e626f5d3441a45539b5f7a398c593edf6, 0xdd4f5fa2111db68f6bde3589b63029395b69a92d, 0x8c93c3c6db9d37717de165c3a1b4fe51952c08de, 0xf87bb07b289df7301e54c0efda6a2cf291e89200, 0xe7a4560c84b20e0fb54c49670c2903b0a96c42a4, 0x00a5797f52c9d58f189f36b1d45d1bf6041f2f6b, 0x9da3302240af0511c6fd1857e6ddb7394f77ab6b, 0x2c2d15ff39561c1b72eda1cc027ffef23743a144, 0x9b4c2715780ca4e99e60ebf219f1590c8cad500a, 0xff5e7ee7d5114821e159dca5e81f18f1bfffbff9, 0x0169c1c210eae845e56840412e1f65993ea90fb4, 0xabc45f84db7382dde54c5f7d8938c42f4f3a3bc4, 0xd9383d4b6d17b3f9cd426e10fb944015c0d44bfb, 0xc090fe23dcd86b358c32e48d2af91024259f6566, 0x9ffedcc36b7cc312ad2a9ede431a514fccb49ba3, 0x2ffe93ec1a5636e9ee34af70dff52682e6ff7079, 0x6e01e4ad569c95d007ada30d5e2db12888492294, 0xd4d92c62b280e00f626d8657f1b86166cb1f740f, 0x1d36683063b7e9eb99462dabd569bddce71686f2, 0x3a48e0a7098b06a905802b87545731118e89f439, 0xbd9e56e902f4be1fc8768d8038bac63e2acbbf8e, 0x4d67f2ab8599fef5fc413999aa01fd7fce70b43d, 0x8e74e0d1b77ebc823aca03f119854cb12027f6d7, 0x7e5b19ae1be94ff4dee635492a1b012d14db0213, 0x5de9e7d5d1b667d095dd34099c85b0421a0bc681, 0x316eb4e47df71b42e16d6fe46825b7327baf3124, 0x772c297f0ad194482ee8c3f036bdeb01c201d5cc, 0xd7052519756af42590f15391b723a03fa564a951, 0x2c6846a1aa999a2246a287056000ba4dcba8e63d, 0xde5b005fe8daae8d1f05de3eda042066c6c4691c, 0x254c1ecc630c2877de8095f0a8dba1e8bf1f550c, 0xf8f226142a428434ab17a1864a2597f64aab2f06, 0xa6c910ce4d494a919ccdaaa1fc3b82aa74ba06cf, 0xe587b16abc8a74081e3613e14342c03375bf0847, 0x6f176065e88e3c6fe626267d18a088aaa4db80bc, 0x50dcbc27bcad984093a212a9b4178eabe9017561, 0xe1953c6e975814c571311c34c0f6a99cdf48ab82, 0xbe0a2f385f09dbfce96732e12bb40ac349871ba8, 0x4712540265cbeec3847022c59f1b318d43400a9e, 0x29bdc4f28de0180f433c2694eb74f5504ce94337, 0x2f66bfbf2262efcc8d2bd0444fc5b0696298ff1e, 0x506411fd79003480f6f2b6aac26b7ba792f094b2, 0x23ea669e3564819a83b0c26c00a16d9e826f6c46, 0xe3ffb02cb7d9ea5243701689afd5d417d7ed2ece, 0x38e7dba8fd4f1f850dbc2649d8e84f0952e3eb3c, 0x8644cc281be332ccced36da483fb2a0746d9ba2e, 0xe8a91da6cf1b9d65c74a02ec1f96eecb6dd241f3, 0x0631dc40d74e5095e3729eddf49544ecd4396f67, 0x83c897a84b695eebe46679f7da19d776621c2694, 0xdb73460b59d8e85045d5e752e62559875e42502e, 0x0dd4e674bbadb1b0dc824498713dce3b5156da29, 0xe3933d61b77dcdc716407f8250bc91e4ffaeb09d, 0x58c90754d2f20a1cb1dd330625e04b45fa619d5c, 0x895ec5545644e0b78330fffab8ddeac9e833156c, 0x7e1e29721d6cb91057f6c4042d8a0bbc644afe73, 0x72b90a4dc097239492c5b9777dcd1e52ba2be2c2, 0x64241a7844290e0ab855f1d4aa75b55345032224, 0x6fd4e0f3f32bee6d3767fdbc9d353a6d3aab7899, 0x3a035594c747476d42d1ee966c36224cdd224993, 0xde97f4330700b48c496d437c91ca1de9c4b01ba4, 0x716ad3c33a9b9a0a18967357969b94ee7d2abc10, 0xbfbe05e88c9cbbcc0e92a405fac1d85de248ee24, 0xcfc4e6f7f8b011414bfba42f23adfaa78d4ecc5e, 0xd931ac2668ba6a84481ab139735aec14b7bfbabf, 0xe3263ce8af6db3e467584502ed7109125eae22a5, 0xf78258c12481bcdddbb72a8ca0c043097261c6c5, 0x4493123c021ece3b33b1a452c9268de14007f9d3, 0x431f2c19e316b044a4b3e61a0c6ff8c104a1a12f, 0xe63e787414b9048478a50733359ecdd7e3647aa6, 0xe4715956f52f15306ee9506bf82bccc406b3895e, 0xf7f91e7acb5b8129a306877ce3168e6f438b66a1, 0xdcdbbd4e2604e40e1710cc6730289dccfad3892d, 0x2b5f4b3f1e11707a227aa5e69fa49dded33fb321, 0x01488ad3da603c4cdd6cb0b7a1e30d2a30c8fc38, 0x841145b44840c946e21dbc190264b8e0d5029369, 0xbf05070c2c34219311c4548b2614a438810ded6d, 0x38f387e1a4ed4a73106ef2b462e474e2e3143ad0, 0xf116b0b4680f53ab72c968ba802e10aa1be11dc8, 0xbea0afc93aae2108a3fac059623bf86fa582a75e, 0x4c997992036c5b433ac33d25a8ea1dc3d4e4e6d8, 0xab7e0b83ed9a424c6d1e6a6f87a4dbf06409c7d6, 0xd71fb130f0150c565269e00efb43902b52a455a6, 0x99b018932bcad355b6792b255db6702dec8ce5dd, 0x4b904e934bd0cc8b20705f879e905b93ea0ccc30, 0x672ec42faa8cd69aaa71b32cc7b404881d52ff91, 0xacbc2d19e06c3babbb5b6f052b6bf7fc37e07229, 0xcea8743341533cb2f0b9c6efb8fda80d77162825, 0x9568b7de755628af359a84543de23504e15e41e6, 0x6ec96d13bdb24dc7a557293f029e02dd74b97a55, 0xd95c90ffbe5484864780b867494a83c89256d6e4, 0xade6f8163bf7c7bb4abe8e9893bd0cc112fe8872, 0x250eb7c66f869ddf49da85f3393e980c029aa434, 0xa35c19132cac1935576abfed6c0495fb07881ba0, 0xd5550caaf743b037c56fd2558a1c8ed235130750, 0x03097923ba155e16d82f3ad3f6b815540884b92c, 0xd6d9e30f0842012a7176a917d9d2048ca0738759, 0xab9ad36e5c74ce2e96399f57839431d0e79f96ab, 0x75be8ff65e5788aec6b2a52d5fa7b1e7a03ba675, 0x4f6d4737d7a940382487264886697cf7637f8015, 0x5f7b3bbac16dab831a4a0fc53b0c549dc36c31ca, 0xd843ee0863ce933e22f89c802d31287b9671e81c, 0x361f3ba9ed956b770f257d3672fe1ff9f7b0240c, 0x6c0ae9f043c834d44271f13406593dfe094f389f, 0xdb34745ede8576b499db01beb7c1ecda85cf4abe, 0x7be8ccb4f11b66ca6e1d57c0b5396221a31ba53a, 0x128b908fe743a434203de294c441c7e20a86ea67, 0xdf236bf6abf4f3293795bf0c28718f93e3b1b36b, 0x14254ea126b52d0142da0a7e188ce255d8c47178, 0xceed47ca5b899fd1623f21e9bd4db65a10e5b09d, 0x30acd858875fa24eef0d572fc7d62aad0ebddc35, 0x47a281dff64167197855bf6e705eb9f2cef632ea, 0x297d5dbe222f2fb52531acbd0b013dc446ac7368, 0xadf85203c8376a5fde9815384a350c3879c4cb93, 0xc3e0471c64ff35fa5232cc3121d1d38d1a0fb7de, 0xfdecc82ddfc56192e26f563c3d68cb544a96bfed, 0x2614f42d5da844377578e6b448dc24305bef2b03, 0x1d96bcd58457bbf1d3c2a46ffaf16dbf7d836859, 0xbd66ffedb530ea0b2e856dd12ac2296c31fe29e0, 0x6e84876dbb95c40b6656e42ba9aea08a993b54dc, 0xa1c4f45a82e1c478d845082eb18875c4ea6539ab, 0x2c964849b1f69cc7cea4442538ed87fdf16cfc8f, 0x45b47105fe42c4712dce6e2a21c05bffd5ea47a9, 0x31e9c00f0c206a4e4e7e0522170dc81e88f3eb70, 0x5fe77703808f823e6c399352108bdb2c527cb87c, 0x2272186ef27dcbe2f5fc373050fdae7f2ace2316, 0xb7576e9d314df41ec5506494293afb1bd5d3f65d, 0xac9fff68c61b011efbecf038ed72db97bb9e7281, 0xcd9529492b5c29e475acb941402b3d3ba50686b0, 0xf19b39389d47b11b8a2c3f1da9124decffbefaf7, 0x9e951f6dc5e352afb8d04299d2478a451259bf56, 0x8eb1fbe4e5d3019cd7d30dae9c0d5b4c76fb6331, 0x29cc804d922be91f5909f348b0aaa5d21b607830, 0x5c7b9ec7a2438d1e3c7698b545b9c3fd77b7cd55, 0xa16160851d2b9c349b92e46f829abfb210943595, 0xeac6b98842542ea10bb74f26d7c7488f698b6452, 0x57825aeb09076caa477887fbc9ae37e8b27cc962, 0xb35e8a1c0dac7e0e66dbac736a592abd44012561, 0x756b84eb85fcc1f4fcdcc2b08db6a86e135fbc25, 0xe13b3d2bbfdcbc8772a23315724c1425167c5688, 0x0a2dcb7a671701dbb8f495728088265873356c8e, 0x03cb4c4f4516c4ff79a1b6244fbf572e1c7fea79, 0x98ba4e9ca72fddc20c69b4396f76f8183f7a2a4e, 0xf8087786b42da04ed6d1e0fe26f6c0eefe1e9f5a, 0x02f7f67209b16a17550c694c72583819c80b54ad, 0x32bb2e9693e4e085344d2f0dbd46a283e3a087fd, 0x9c78963fbc263c09bd72e4f8def74a9475f7055c, 0x27144ca9a7771a836ad50f803f64d869b2ae2b20, 0xcc758d071d25a6320af68c5dc9c4f6955ba94520, 0xcb42b44eb5fd60b5837e4f9eb47267523d1a229c, 0xaaf5b207b88b0de4ac40d747cee06e172df6e745, 0x52d380511df19d5ec2807bbcb676581b67fd37a3, 0xaa1b3768c16d821f580e76c8e4c8e86d7dc78853, 0x41098a81452317c19e3eef0bd123bbe178e9e9ca, 0x267148fd72c54f620a592fb92799319cc4532b5c, 0xd7cdbd41fff20df727c70b6255c1ba7606055468, 0x0e33fcbbc003510be35785b52a9c5d216bc005f4, 0x6727daf5b9d68efcab489fedec96d7f7325dd423, 0xcd0a161bc367ae0927a92aac9cf6e5086714efca, 0x612667f172135b950b2cd1de10afdece6857b873, 0x900194c4b1074305d19de405b0ac78280ecaf967, 0x51f55ef47e6456a418ab32b9221ed27dba6608ee, 0x0da532c910e3ac0dfb14db61cd739a93353fd05f, 0x21df2dcdaf74b2bf803404dd4de6a35eabec1bbd, 0xf0e7fb9e420a5340d536f40408344feaefc06aef, 0x6742a2cfce8d79a2c4a51b77747498912245cd6a, 0x8663a241a0a89e70e182c845e2105c8ad7264bcf, 0x18e113d8177c691a61be785852fa5bb47aeebdaf, 0x1bec4d02ce85fc48feb62489841d85b170586a9b, 0x287cf9d0902ef819a7a5f149445bf1775ee8c47c, 0x28967280214e218a120c5dda37041b111ea36d74, 0xa0b771951ce1deee363ae2b771b73e07c4b5e800, 0x29f8fba4c30772b057edbbe62ae7420c390572e1, 0xee34c7e7995db9f187cff156918cfb6f13f6e003, 0x916bf7e3c545921d3206d900c24f14127cbd5e70, 0x93235f340d2863e18d2f4c52996516138d220267, 0x7efec0c6253caf397f71287c1c07f6c9582b5b86, 0x8d2e31b08803b2c5f13d398ecad88528209f6057, 0x964eab4b276b4cd8983e15ca72b106900fe41fce, 0xeea1e97988de75d821cd28ad6822b22cce988b31, 0x278c0bde630ec393b1e7267fc9d7d97019e4145b, 0x82e4461eb9d849f0041c1404219e4272c4900ab4, 0x4a73389298031b8816cca946421c199e18b343d6, 0x9a5af31c7e06339ac8b4628d7c4db0ce0f45c8a4, 0xcb9b5103e4ce89af4f64916150bff9eecb9faa5c, 0x740f641614779dcfa88ed1d425d60db42a060ca6, 0xa4e623451e7e94e7e89ba5ed95c8a83a62ffc4ea, 0x25a500eeec7a662a841552b5168b707b0de21e9e, 0x185a7fc4ace368d233e620b2a45935661292bdf2, 0x9b68f67416a63bf4451a31164c92f672a68759e9, 0xa38b5bd81a9db9d2b21d5ec7c60552cd02ed561b, 0x61c830f1654718f075ccaba316faacb85b7d120b, 0x8392e53776713578015bff4940cf43849d7dcba1, 0xdc57477dafa42f705c7fe40eae9c81756e0225f1, 0xfebc3173bc9072136354002b7b4fb3bfc53f22f1, 0xd78f84e38944a0e0255faece48ba4950d4bd39d2, 0xa7a3bb6139b0ada00c1f7f1f9f56d994ba4d1fa8, 0xaa3f29601a1331745e05c42830a15e71938a6237, 0xbec6640f4909b58cbf1e806342961d607595096c, 0x9be3c329b62a28b8b0886cbd8b99f8bc930ce3e6, 0xe3eb2c0a132a524f72ccc0d60fee8b41685d39e2, 0x90b1f370f9c1eb0be0fb8e2b8ad96a416371dd8a, 0xf2742e6859c569d5f2108351e0bf4dca352a48a8, 0xb134c004391ab4992878337a51ec242f42285742, 0xab7416ff32254951cbbc624ec7fb45fc7ecaa872, 0x9795f64319fc17dd0f8261f9d206fb66b64cd0c9, 0x64e03ef070a54703b7184e48276c5c0077ef4b34, 0x3430a16381f869f6ea5423915855e800883525a9, 0xf4a367b166d2991a2bfda9f56463a09f252c1b1d, 0x77c4a697e603d42b12056cbba761e7f51d0443f5, 0x153ef58a1e2e7a3eb6b459a80ab2a547c94182a2, 0x6dbe8abfa1742806263981371bf3d35590806b6e, 0x4c99dae96481e807c1f99f8b7fbde29b7547c5bf, 0xd5b9d277d8aad20697a51f76e20978996bffe055, 0x0f24105abbdaa03fa6309ef6c188e51f714a6e59, 0x1cb6b2d7cfc559b7f41e6f56ab95c7c958cd0e4c, 0xf37b426547a1642d8033324814f0ede3114fc212, 0x318f1f8bd220b0558b95fb33100ffdbb640d7ca6, 0x206d55d5792a514ec108e090599f2a065e501185, 0x11d2247a221e70c2d66d17ee138d38c55ffb8640, 0xe8de725eca5def805ff7941d31ac1c2e342dfe95, 0xd561cbbc05515de73ab8cf9eae1357341e7dfdf4, 0x0455dcec8a7fc4461bfd7f37456fce3f4c3caac7, 0x5161fd49e847f67455f1c8bb7abb36e985260d03, 0x8e073bad25e42218615f4a0e6b2ea8f8de2230c0, 0x6c08a6dc0173c7342955d1d3f2c065d62f83aec7, 0x95cb6d8a6379f94aba8b885669562c4d448e56a7, 0x2805415e1d7fdec6dedfb89e521d10592d743c10, 0xdaacdaf42226d15cb1cf98fa15048c7f4ceefe69, 0xe33df4ce80ccb62a76b12bcdfcecc46289973aa9, 0x8f8cd26e82e7c6defd02dfad07979021cbf7150c, 0x77a17122fa31b98f1711d32a99f03ec326f33d08, 0x6f791d359bc3536a315d6382b88311af8ed6da47, 0xde30e49e5ab313214d2f01dcabce8940b81b1c76, 0xcf9be9b9ab86c66b59968e67b8d4dcff46b1814a, 0x7fdfc88d78bf1b285ac64f1adb35dc11fcb03951, 0xc5134cfbb1df7a20b0ed7057622eeed280947dad, 0xfa9ec8efe08686fa58c181335872ba698560ecab, 0xf6a8635757c5e8c134d20d028cf778cf8609e46a, 0x6265b2e7730f36b776b52d0c9d02ada55d8e3cb6, 0x6a8cea2de84a8df997fd3f84e3083d93de57cda9, 0x1b7ed974b6e234ce81247498429a5bd4a0a2d139, 0x9ba53dc8c95e9a472feba2c4e32c1dc4dd7bab46, 0xd7b740dff8c457668fdf74f6a266bfc1dcb723f9, 0x07bc2cc8eedc01970700efc9c4fb36735e98cd71, 0x3e1c962063e0d5295941f210dca3ab531eec8809, 0xb447571dacbb3ecbb6d1cf0b0c8f3838e52324e2, 0x87764e3677eef604cbc59aed24abdc566b09fc25, 0x03aa622881236dd0f4940c24c324ff8b7b7e2186, 0xa4a7d306f510cd58359428c0d2f7c3609d5674d7, 0x3c83c1701db0388b68210d00f5717cd9bd322c6a, 0x047d5a26d7ad8f8e70600f70a398ddaa1c2db26f, 0x43767bf7fd2af95b72e9312da9443cb1688e4343, 0x34a85d6d243fb1dfb7d1d2d44f536e947a4cee9e, 0x65a9dad42e1632ba3e4e49623fab62a17e4d3611, 0x48e0cbd67f18acdb7a6291e1254db32e0972737f, 0xa5de5e434fdcdd688f1c31b6fb512cb196724701, 0x6d63d38ee8b90e0e6ed8f192eda051b2d6a58bfd, 0xb079bb4d9866143a6da72ae7ac0022062981315c, 0xc0413f5a7c2d9a4b8108289ef6ecd271781524f4, 0xa91a5a7b341f99c535144e20be9c6b3bb4c28e4d, 0x993f146178605e66d517be782ef0b3c61a4e1925, 0x966c04781cb5e67dde3235d7f8620e1ab663a9a5, 0xb3f82a87e59a39d0d2808f0751eb72c2329cdcc5, 0x9b77ebced7e215f0920e8c2b870024f6ecb2ff31, 0xfe697ff22ca547bfc95e33d960da605c6763f35b, 0x480af52076009ca73781b70e43b95916a62203ab, 0xa9dc0424c6969d798358b393b1933a1f51bee00a, 0x7aba56f63a48bc0817d6b97039039a7ad62fae2e, 0x59d139e2e40c7b97239d23dfaca33858f602d22b, 0x8d6170ff66978e773bb621bf72b1ba7be3a7f87e, 0xd668523a90f0293d65c538d2dd6c57673710196e, 0xbbb5a0f4802c8648009e8a6998af352cde87544f, 0xfc43829ac787ff88aaf183ba352aadbf5a15b193, 0xfe22a0b388668d1ae2643e771dacf38a434223cc, 0x092acb624b08c05510189bbbe21e6524d644ccad, 0x8f0538ed71da1155e0f3bde5667ceb84318a1a87, 0x06994cd83aa2640a97b2600b41339d1e0d3ede6c, 0x9d460c1b379ddb19a8c85b4c6747050ddf17a875, 0x77a769fafdecf4a638762d5ba3969df63120a41d, 0x5f375b86600c40cca8b2676b7a1a1d1644c5f52c, 0x15ee0fc63ebf1b1fc49d7bb38f8863823a2e17d2, 0x6651736fb59b91fee9c93aa0bd6ea2f7b2506180, 0x361d9ed80b5bd27cf9f1226f26753258ee5f9b3f, 0xc9b6b686111691ee6aa197c7231a88dc60bd295d, 0xe9b4a4853577a9dbcc2e795be0310d1bed28641a, 0x36758e049cd98bcea12277a676f9297362890023, 0x6bb50813146a9add42ee22038c9f1f7469d47f47, 0x6de4b581385cf7fc9fe8c77d131fe2ee7724c76a, 0xd2a5a024230a57ccc666760b89b0e26cafd189c7, 0x65af9087e05167715497c9a5a749189489004def, 0xead21c1deccfbf1c5cd96688a2476b69ba07ce4a, 0xe308435204793764f5fcbe65eb510f5a744a655a, 0x9376dce2af2ec8dcda741b7e7345664681d93668, 0xa1b47c4d0ed6018842e6cfc8630ac3a3142e5e6b, 0xe2198c8ca1b399f7521561fd5384a7132fba486b, 0x92c13fe0d6ce87fd50e03def9fa6400509bd7073, 0x7517f16c28d132bb40e3ba36c6aef131c462da17, 0x6a023af57d584d845e698736f130db9db40dfa9a, 0x1518627b88351fede796d3f3083364fbd4887b0c, 0xf5b6e9061a4eb096160777e26762cf48bdd8b55d, 0x28073efc17d05cab3195c2db332b61984777a612, 0xf06a854a3c5dc36d1c49f4c87d6db333b57e4add, 0x9225983860a1cb4623c72480ac16272b0c95e5f5, 0x5260dc51ee07bddaababb9ee744b393c7f4793a6, 0x0f127bbf8e311caea2ba502a33feced3f730ba42, 0x17d521a8d9779023f7164d233c3b6420ffd223ed, 0x8c2b7d8b608d28b77f5caa9cd645242a823e4cd9, 0x6e866d032d405abdd65cf651411d803796c22311, 0xdc51b2dc9d247a1d0e5bc36ca3156f7af21ff9f6, 0xc84d9bea0a7b9f140220fd8b9097cfbfd5edf564, 0xff86e5e8e15b53909600e41308dab75f0e24e46b, 0xd7164aa261c09ad9b2b5068d453ed8eb6aa13083, 0x76aaf8c1ac012f8752d4c09bb46607b6651d5ca8, 0x41786a10d447f484d33244ccb7facd8b427b5b8c, 0x2e0c57b47150f95aa6a7e16ab9b1cbf54328979a, 0x3f747237806fed3f828a6852eb0867f79027af89, 0xa568db4d57e4d67462d733c69a9e0fe26e218327, 0x1f88f8a1338fc7c10976abcd3fb8d38554b5ec9c, 0xd1ea4d72a67b5b3e0f315559f52bd0614d713069, 0xbfaeb91067617dcf8b44172b02af615674835dba, 0xb71a13ba8e95167b80331b52d69e37054fe7a826, 0xb67a80f170197d96cdcc4ab6cba627b4afa6e12c, 0x35af040a0cc2337a76af288154c7561e1a233349, 0xc86190904b8d079ec010e462cbffc90834ffaa5c, 0x383304dd7a5720b29c1a10f60342219f48032f80, 0x191313525238a21c767457a91374f02200c55448, 0xcc4a2f2cf86cf3e43375f360a4734691195f1490, 0x4e020779b5ddd3df228a00cb48c2fc979da6ae38, 0xe206fb7324e9deb79e19903496d6961b9be56603, 0x3ae160e3cd60ae31b9d6742d68e14e76bd96c517, 0x1f7d8e86d6eeb02545aad90e91327bd369d7d2f3, 0x68c7d1711b011a33f16f1f55b5c902cce970bdd7, 0x637be71b3aa815ff453d5642f73074450b64c82a, 0x1584a2c066b7a455dbd6ae2807a7334e83c35fa5, 0x9c05e9d0f0758e795303717e31da213ca157e686, 0x4f1a2da54a4c6da19d142412e56e815741db2325, 0x9a4ca8b82117894e43db72b9fa78f0b9b93ace09, 0x26c99f8849c9802b83c861217fd07a9e84cdb79d, 0x45c0d19f0b8e054f9e893836d5ecae7901af2812, 0x00dc01cbf44978a42e8de8e436edf94205cfb6ec, 0xde7dee220f0457a7187d56c1c41f2eb00ac56021, 0x1c128bd6cda5fca27575e4b43b3253c8c4172afe, 0x666746fb93d1935c5a3c684e725010c4fad0b1d8, 0x51d78b178d707e396e8710965c4f41b1a1d9179d, 0x68f7573cd457e14c03fea43e302d30347c10705c, 0x9d30cb237bc096f17036fc80dd21ca68992ca2d9, 0xfbcfcc4a7b0f26cf26e9f3332132e2fc6a230766, 0xb166e37d2e501ae73c84142b5ffb5aa655dd5a99, 0x6df24f6685a62f791ba337bf3ff67e91f3d4bc3a, 0x92e435340e9d253c00256389f52b067d55974e76, 0xea53d26564859d9e90bb0e53b7abf560e0162c38, 0xe26657f0ed201ea2392c9222b80a7003608ddf30, 0xf4177a0d85d48b0e264211ce2aa2efd3f1b47f08, 0x9d47ba5b4c8505ad8da42934280b61a0e1e8b971, 0x63c2a3d235e5eeabd0d4a6afdb89d94627396495, 0x446a8039cecf9dce4879cbcaf3493bf545a88610, 0x7fa37ed67887751a471f0eb306be44e0dbcd6089, 0x26d4a16891f52922789217fcd886f7fce296d400, 0x487e108502b0b189ef9c8c6da4d0db6261eec6c0, 0x7484d26becc1eea8c6315ec3ee0a450117dc86a0, 0xad9e97a0482f353a05c0f792b977b6c7e811fa5f, 0x2273bad7bc4e487622d175ef7a66988b6a93c4ee, 0x3b93b16136f11eaf10996c95990d3b2739ccea5f, 0xf3f1fa3918ca34e2cf7e84670b1f4d8eca160db3, 0x88a2154430c0e41147d3c1fee3b3b006f851edbd, 0x25185f325acf2d64500698f65c769ddf68301602, 0xe9cafe41a5e8bbd90ba02d9e06585b4eb546c57f, 0x95681cdae69b2049ce101e325c759892cac3f811, 0x475066f9ad26655196d5535327bbeb9b7929cb04, 0x6685fd2e2544702c360b8bb9ee78f130dad16da5, 0x45e68db94c7d0ab7ac41857a71d67147870f4e71, 0x4ad95d188d6464709add2555fb4d97fe1ebf311f, 0x73bedd6fda7ba3272185087b6351fc133d484e37, 0x1ea4715504c6af107b0194f4f7b1cb6fcccd6f4b, 0x77306ffe2e4a8f3ca826c1a249f7212da43aeffd, 0xeb453f5a3adddd8ab56750fadb0fe7f94d9c89e7, 0x7201d1c06920cd397ae8ad869bcda6e47ffb1b5a, 0x821cb5cd05c7ef909fe1be60733d8963d760dc41, 0x496e319592b341eaccd778dda7c8196d54cac775, 0x88609e0a465b6e99fce907166d57e9da0814f5c8, 0xc7ec62b804b1f69b1e3070b5d362c62fb309b070, 0x3eb9ef06d0c259040319947e8c7a6812aa0253d8, 0xcbf37ff854a2f1ce53934494777892d3ec655782, 0x02b1af72339b2a2256389fd64607de24f0de600a, 0xa8beb91c2b99c8964aa95b6b4a184b1269fc3483, 0x922a20c79a1d3a26dd3829677bf1d45c8f672bb6, 0xc5843399d150066bf7979c34ba294620368ad7c0, 0x8cd0cd22e620eda79c0461e896c93c44837e2968, 0x6170dd0687bd55ca88b87adef51cfdc55c4dd458, 0xeed384ef2d41d9d203974e57c12328ea760e08ea, 0xb129a5cb7105fe810bd895dc7206a991a4545488, 0x3872f48dc5e3f817bc6b2ad2d030fc5e0471193d, 0x514b7512c9ae5ea63cbf11715b63f21e18d296c1, 0x7ab256b204800af20137fabcc916a23258752501, 0xfc66faba277f4b5de64ad45eb19c31e00ced3ed5, 0x39824f8bced176fd3ea22ec6a493d0ccc33fc147, 0xe338e859fe2e8c15554848b75caecda877a0e832, 0xe53c68796212033e4e6f9cff56e19c461eb454f9, 0x8461ecc4a6a45eb1a5b947fb86b88069b91fcd6f, 0x6b4b99cb3fa9f7b74ce3a48317b1cd13090a1a7a, 0x97de21e421c37fe4b8025f9a51b7b390b5df7804, 0xd25aecd7eb8bd6345b063b5dbd271c77d3514494, 0x57b23d6a1adc06c652a779c6a7fb6b95b9fead66, 0x0d658014a199061cf6b39433140303c20ffd4e5a, 0x30eac740e4f02cb56eef0526e5d300322600d03e, 0x4eead40aad8c73ef08fc84bc0a92c9092f6a36bf, 0x30f7d025d16f7bee105580486f9f561c7bae3fef, 0x0977bfba038a44fb49b03970d8d8cf2cb61f8b25, 0xb14bbeff70720975dc6191b2a44ff49f2672873c, 0xd588c3a5df228185d98ee7e60748255cdea68b01, 0x225d35faedb391c7bc2db7fa9071160405996d00, 0xc0e457bd56ec36a1246bfa3230fff38e5926ef22, 0x2a9c57fe7b6b138a920d676f3c76b6c2a0eef699, 0x36df8f883c1273ec8a171f7a33cfd649b1fe6075, 0x234f46bab73fe45d31bf87f0a1e0466199f2ebac, 0xa2e1b8aa900e9c139b3fa122354f6156d92a18b1, 0x517cd7608e5d0d83a26b717f3603dac2277dc3a4, 0x75f7539d309e9039989efe2e8b2dbd865a0df088, 0x4b792e29683eb586e394bb33526c6001b397999e, 0xa34f9d568bf7afd94c2a5b8a5ff55c66c4087999, 0x4b31bf41abc75c9ae2cd8f7f35163b6e2b745054, 0xe35453eef2cc3c7a044d0ac134ba615908fa82ee, 0x7aa79ac04316cc8d08f20065baa6d4142897d54e, 0xf1dc8ac81042c67a9c3c6792b230c46ac016ca10, 0x2bb366b9edcb0da680f0e10b3b6e28748190d6c3, 0xa567770b6ae320bdde50f904d663e746a61dace6, 0xd9d42fd13ebd4bf69cac5e9c7e82483ab46dd7e9, 0x27830c5f6023afaaf79745676c204a0faccda0ba, 0x3cb179cb4801a99b95c3b0c324a2bdc101a65360, 0x976e3ceaf3f1af51f8c29aff5d7fa21f0386d8ee, 0x752a5ee232612cd3005fb26e5b597de19f776be6, 0x7d5aa33fc14b51841a06906edb2bb49c2a117269, 0x55ca6abe79ea2497f46fdbb830346010fe469cbe, 0x6bec311ad05008b4af353c958c40bd06739a3ff3, 0x30e9698cf1e08a9d048bd8d8048f28be7ed9409f, 0x9afa536b4c66bc38d875c4b30099d9261fdb38eb, 0x6b63a2dfb2bcd0caec0022b88be30c1451ea56aa, 0xd07be0f90997caf903c8ac1d53cde904fb190741, 0x893cdddf5377f3c751bf2e541120045a47cba101, 0xc1cdc601f89c0428b31302d187e0dc08ad7d1c57, 0x8f8acb107607388479f64baaabea8ff007ada97d, 0x88bc43012edb0ea9f062ac437843250a39b78fbb, 0xfcfc3a5004d678613f0b36a642269a7f371c3f6a, 0xf509557e90183fbf0f0651a786487bcc428ba175, 0xe3d915eda3b825d6ee4af9328d32ac18ada35497, 0xf237ef05261c34d79cc22b860de0f17f793c3860, 0xa3a2e319e7d3a1448b5aa2468953160c2dbcba71, 0x3a368efe4ad786e26395ec9fc6ad698cae29fe01, 0x8e3240b0810e1cf407a500804740cf8d616432a4, 0x5691dd2f6745f20e22d2e1d1b955aa2903d65656, 0x5f93ff832774db5114c55bb4bf44ccf3b58f903f, 0x2c1cc6e18c152488ba11c2cc1bcefa2df306abd1, 0xbde9786a84e75b48f18e726dd78d70e4af3ed802, 0x79551cede376f747e3716c8d79400d766d2e0195, 0x49f028395b5a86c9e07f7778630e4c2e3d373a77, 0x6a3694424c7cc6b8bcd9bccaba540cc1f5df18d7, 0x068e29b3f191c812a6393918f71ab933ae6847f2, 0x6e64e6129f224e378c0e6e736a7e7a06c211e9ec, 0xc4c15318d370c73318cc18bdd466dbaa4c6603bf, 0x8035bcffaefdeeea35830c497d14289d362023de, 0xa997dfc7986a27050848fa1c64d7a7d6e07acca2, 0x2fe13a8d0785de8758a5e41876c36e916cf75074, 0x6f24c9af2b763480515d1b0951bb77a540f1e3f9, 0x4c23b370fc992bb67cec06e26715b62f0b3a4ac3, 0x4ac07673e42f64c1a25ec2fa2d86e5aa2b34e039, 0x117db836377fe15455e02c2ebda40b1ceb551b19, 0xef1c0477f1184d60accab374d374557a0a3e10f3, 0x99fe0d201228a753145655d428eb9fd94985d36d, 0xb3731b046c8ac695a127fd79d0a5d5fa6ae6d12e, 0xdce30c31f3ca66721ecb213c809aab561d9b52e4, 0xddd69c5b9bf5eb5a39cee7c3341a120d973fdb34, 0x216e41864ef98f060da08ecae19ad1166a17d036, 0x6a53d41ae4a752b21abed5374649953a513de5e5, 0x20dd8fcbb46ea46fe381a68b8ca0ea5be21fe9a5, 0x19732bf973055dbd91a4533adaa2149a91d38380, 0x51ea1c0934e3d04022ed9c95a087a150ef705e81, 0xa0de5c601e696635c698b7ae9ca4539fc7b941ec, 0x94e1f5cb9b8abace03a1a6428256553b690c2355, 0xa539b4a401b584dfe0f344b1b422c65543167e2e, 0x50584d9206a46ce15c301117ee28f15c30e60e75, 0x856eb204241a87830fb229031343dc30854f581a, 0x9dd46b1c6d3f05e29e9c6f037eed9a595af4a9aa, 0x8925da4549e15155e57a628522cea9dddf627d81, 0xa89df34859edd7c820db887740d8ff9e15157c7b, 0xad9f4c890a3b511cee51dfe6cfd7f1093b76412c, 0xf8c7f34a38b31801da43063477b12b27d0f203ff, 0xa642501004c90ea9c9ed1998ba140a4cd62c6f5f, 0x508cf19119db70aa86454253da764a2cb1b2be1a, 0x2979741174a8c1ea0b7f9edf658177859417f512, 0x654f524847b3a6acc0d3d5f1f362b603edf65f96, 0x5cf18fa7c8a7c0a2b3d5efd1990f64ddc569242c, 0x17e82e7078dc4fd9e879fb8a50667f53a5c54591, 0x8b07d050754dc9ba230db01c310afdb5395aa1b3, 0x5f77a107ab1226b3f95f10ee83aefc6c5dff3edc, 0x475a6193572d4a4e59d7be09cb960ddd8c530e2f, 0x6470a4f92ec6b0fccd01234fa59023e9ff1f3aac, 0x2fbcef3384d420e4bf61a0669990bc7054f1a5af, 0xbbabf6643beb4bd01c120bd0598a0987d82967d1, 0x41a2f2e6ecb86394ec0e338c0fc97e9c5583ded2, 0xfb9473cf7712350a1fa0395273fc80560752e4fb, 0x38b2197106123387a0d4de368431a8bacdda30e2, 0x5ed56115bd6505a88273df5c56839470d24a2db7, 0x523f6d64690fdacd942853591bb0ff20d3656d95, 0x55caff4bba04d220c9a5d2018672ec85e31ef83e, 0x65af8d8b5b1d1eedfa77bcbc96c1b133f83306df, 0x7456c5b2c5436e3e571008933f1805ccfe34e9ec, 0xa6eebbe464d39187bf80ca9c13d72027ec5ba8be, 0xdd35cfdbcb993395537aecc9f59085a8d5ddb6f5, 0x98e2b6d606fd2d6991c9d6d4077fdf3fdd4585da, 0x860f5ffc10de767ded807f71e861d647dfd219b1, 0x1a644a50cbc2aee823bd2bf243e825be4d47df02, 0xa8455b411765d6901e311e726403091e42c56683, 0x3a86ee94862b743dd34f410969d94e2c5652d4ad, 0xa57360f002e0d64d2d74457d8ca4857ee00bcddf, 0xe59b3bd300893f97233ef947c46f7217e392f7e9, 0x9f3a74fd5e7edcc1162993171381cbb632b7cff0, 0x675d5caa609bf70a18aca580465d8fb7310d1bbb, 0x77f609ca8720a023262c55c46f2d26fb3930ac69, 0xf8ac4a39b53c11307820973b441365cffe596f66, 0x112634b4ec30ff786e024159f796a57939ea144e, 0x49d2c28ee9bc545eaaf7fd14c27c4073b4bb5f1a, 0x91cc46aa379f856a6640dccd5a648a7902f849d9, 0xb46440c797a556e04c7d9104660491f96bb076bf, 0xe5968797468ef767101b761d431fce14abffdbb4, 0xc0895efd056d9a3a81c3da578ada311bfb9356cf, 0x76846f0de03b5a76971ead298cdd08843a4bc6c6, 0x5f708eaf39d823946c51b3a3e9b7b3c003e26341, 0x24f7450ddbf18b020feb1a2032d9d54b633edf37, 0xcae3a253bcb2cf4e13ba80c298ab0402da7c2aa0, 0x91e8810652e8e6161525d63bb7751dc20f676076, 0x543629c95cdef428ad37d453ca9538a9f90900ac, 0x6e79edd4845b076e4cd88d188b6e432dd93f35aa, 0xbd325d4029e0d8729f6d399c478224ae9e7ae41e, 0x42cecfd2921079c2d7df3f08b07aa3beee5e219a, 0x3690246ba3c80679e22eac4412a1aefce6d7cd82, 0x577aeee8d4bc08fc97ab156ed57fb970925366be, 0xfe00bf439911a553982db638039245bcf032dbdc, 0x91f624b24a1fa5a056fe571229e7379db14b9a1e, 0xf206d328e471d0117b246d2a4619827709e96df3, 0x073f1ed1c9c3e9c52a9b0249a5c1caa0571fdf05, 0xf56048dd2181d4a36f64fcecc6215481e42abc15, 0xef76a4cd8febcbc9b818f17828f8d93473f3f3cb, 0x1031e0ecb54985ae21af1793950dc811888fde7c, 0x8e0fee38685a94aabcd7ce857b6b1409824f75b8, 0xf0cbef84e169630098d4e301b20208ef05846ac9, 0xbbca65b3266ea2fb73a03f921635f912c7bede00, 0x0aec2e426ed6cc0cf3c249c1897eac47a7faa9bd, 0xb8f30758faa808dbc919aa7b425ec922b93b8129, 0x936dcf000194e3bff50ac5b4243a3ba014d661d8, 0xb14ddb0386fb606398b8cc47565afae00ff1d66a, 0x2ec95822eb887bc113b4712a4dfd7f13b097b5e7, 0x0136a5af6c3299c6b5f005fdaddb148c070b299b, 0x37cb868d2c3f95b257611eb34a4188d58b749802, 0xcd7f09d7ed66d0c38bc5ad4e32b7f2b08dc1b30d, 0xb5fa8184e43ed3e0b8ab91216461b3528d84fd09, 0x3dbf0dbfd77890800533f09dea8301b9f025d2a6, 0xb553d25d6b5421e81c2ad05e0b8ba751f8f010e3, 0xdbf8b13967f55125272de0562536c450ba5655a0, 0x0f6e840a3f2a24647d8e43e09d45c7c335df4248, 0xfa2fd29d03fee9a07893df3a269f56b72f2e1e64, 0x8b57b2bc83cc8d4de331204e893f2f3b1db1079a, 0x7f541491d2ac00d2612f94aa7f0bcb014651fbd4, 0x4f4a9be10cd5d3fb5de48c17be296f895690645b, 0x45d1c9eedf7cab41a779057b79395f5428d80528, 0x662334814724935b7931ddca6100e00d467727cd, 0x2c52c984102ee0cd3e31821b84d408930efa1ac7, 0x000d836201318ec6899a67540690382780743280, 0x81498ca07b0f2f17e8bbc7e61a7f4ae7be66b78b, 0x7860a3de38df382ae4a4dce18c0c07b98bce3dfa, 0x5e8e4df18cf0af770978a8df8dac90931510a679, 0x05d68dad61d3bbdfb3f779265c49474aff3fcd30, 0x96eafbf2fb6f4db9a436a74c45b5654452e23819, 0xd7d7f2caa462a41b3b30a34aeb3ba61010e2626f, 0x0b71f554122469ef978e2f1fefd7cbb410982772, 0x504666ce8931175e11a5ed11c1dcaa06e57f4e66, 0xd00f067286c0fbd082f9f4a61083ec76deb3cee6, 0x02e4cb22be46258a40e16d4338d802fffd00c151, 0x1c13d38637b9a47ce79d37a86f50fb409c060728, 0xe30212b2011bb56bdbf1bc35690f3a4e0fd905ea, 0x1df6911672679bb0ef3509038c0c27e394fdfe30, 0x2b8fe4166e23d11963c0932b8ade8e0145ea0770, 0x6509eeb1347e842ffb413e37155e2cbc738273fd, 0x8b7e9f6f05f7e36476a16e3e7100c9031cf404af, 0xbec8caf7ee49468fee552eff3ac5234eb9b17d42, 0x38898bbb4553e00bbfd0cf268b2fc464d154add5, 0xcbb3189e4bd7f45f178b1c30c76e26314d4a4b0a, 0xbe1cd7f4c472070968f3bde268366b21eeea8321, 0x976a18536af41874426308871bcd1512a775c9f8, 0xe9c758f8da41e3346e4350e5ac3976345c6c1082, 0x64ec8a5b743f3479e707dae9ee20ddaa4f40f1d9, 0x9e01765aff08bc220550aca5ea2e1ce8e5b09923, 0xba0f39023bdb29eb1862a9f9059cab5d306e662f, 0x2baf8d6e221174124820ee492b9459ec4fadafbb, 0x655d5cd7489629e2413c2105b5a172d933c27af8, 0xbadc2aef9f5951a8d78a6b35c3d0b3a4e6e2e739, 0xe64f6e1d6401b56c076b64a1b0867d0b2f310d4e, 0x7a8563867901206f3f2bf0fa3e1c8109cabccd85, 0xd17fbe22d90462ed37280670a2ea0b3086a0d6d6, 0xe96d7d4cdd15553a4e4d316d6d6480ca3cea1e38, 0xf04d2c91efb6e9c45ffbe74b434c8c5f2b028f1f, 0x81164deb10814ae08391f32c08667b6248c27d7a, 0x7f5ae05ae0f8cbe5dfe721f044d7a7bef4c27997, 0xc982586d63b0d74c201b1af8418372e30c7616be, 0x64cf0935bf19d2cebbecd8780d27d2e2b2c34166, 0xcd566ad7b883f01fd3998a9a58a9dee4724ddca5, 0x9da609fa3a7e6cf2cc0e70cdabe78dc4e382e11e, 0x0d69100c395ce6c5eaadf95d05d872837ededd21, 0xfe91eccf2bd566afa11696c5049fa84c69630a52, 0x005d0ee8155ec0a6ff6808552ca5f16bb5be323a, 0x3e5cb8928c417825c03a3bfcc52183e5c91e42d7, 0x9c1b771f09af882af0643083de2aa79dc097c40e, 0xeba388b0da27c87b1cc0eac6c57b2c5a0b459c1a, 0x7529f3797bb6a20f7ea6492419c84c867641d81c, 0x532a7da0a5ad7407468d3be8e07e69c7dd64e861, 0xde82cc8d4a1bb1d9434392965b3e80bad3c03d4f, 0x4a82694fa29d9e213202a1a209285df6e745c209, 0x3e53ff2107a8debe3328493a92a586a7e1f49758, 0xb2ddb786d3794e270187d0451ad6c8b79e0e8745, 0x6ebcf9957f5fc5e985add475223b04b8c14a7aed, 0xc5c7590b5621ecf8358588de9b6890f2626143f1, 0xae4f122e35c0b1d1e4069291457c83c07f965fa3, 0x47885ababedf4d928e1c3c71d7ca40d563ed595f, 0x78ce3e3d474a8a047b92c41542242d0a08c70f99, 0x6134d942f037f2cc3d424a230c603d67abd3edf7, 0x1360e87df24c69ee6d51c76e73767ffe19a2131c, 0x5fd1c3e31778276cb42ea740f5eae9c641dbc701, 0x98397342ec5f3d4cb877e54ef5d6f1d366731bd4, 0x6d4b5c05d06a20957e1748ab6df206f343f92f01, 0xe6115b13f9795f7e956502d5074567dab945ce6b, 0x23730c357a91026e44b1d0e2fc2a51d071d8d77b, 0xfae881937047895a660cf229760f27e66828d643, 0xff3ef6ba151c21b59986ae64f6e8228bc9a2c733, 0xdfbd4232c17c407a980db87ffbcda03630e5c459, 0x4429a29fee198450672c0c1d073162250bec6474, 0x7e8f96cc29f57b0975120cb593b7dd833d606b53, 0x5ed3f1ebe2ae6756b5d8dc19cad02c419aa5778b, 0xdaa776a6754469d7b9267a89b86725e740da0fa0, 0x139e479764b499d666208c4a8a047a97043163dd, 0x5ad5e420755613886f35aa56ac403eebdfe4b0d0, 0x3fe801e61335c5140dc7eda2ef5204460a501230, 0xce8a6b6d5033b1498b1ffeb41a41550405fa03a2, 0x26c2ffc30efdc5273e76183a16c2698d6e531286, 0x71ec3aec3f8f9221f9149fede06903a0f9a232f2, 0xef35f6d4b1075e6aa139151c974b2f4658f70538, 0x26a68eab905a8b3dce00e317308225dab1b9f6b8, 0x63f5b53d79bf2e411489526530223845fac6f601, 0x481115296ab7db52492ff7b647d63329fb5cbc6b, 0xf19f193508393e4d2a127b20b2031f39c82581c6, 0x500e34cde5bd9e2b71bb92d7cf55eee188d5fa0c, 0x65ea67ad3fb56ad5fb94387dd38eb383001d7c68, 0x7f9f9b56e4289dfb58e70fd5f12a97b56d35c6a5, 0x60be6f953f2a4d25b6256ffd2423ac1438252e4e, 0xac1dfc984b71a19929a81d81f04a7cbb14073703, 0xa3c14ace28b192cbb062145fcbbd5869c67271f6, 0x2da76b7c39b420e388ba2c1020b0856b0270648a, 0x622be4b45495fcd93143efc412d699d6cdc23dc5, 0xd3f873bd9956135789ab00ebc195b922e94b259d, 0x975f3764e97bbccf767cbd3b795ba86d8ba9840e, 0xfc39be41094b1997d2169e8264c2c3baa6c99bc4, 0x12ffc1128605cb0c13709a7290506f2690977193, 0x9b1168de8ab64b47552f3389800a9cc08b4666cf, 0x9f1aa8fcfc89a1a5328cbd6344b71f278a2ca4a0, 0x505a33a18634dd4800693c67f48a1d693d4833f8, 0xd08fc09a0030fd0928cd321198580182a76aae9f, 0x6acddca3cd2b4990e25cd65c24149d0912099e79, 0x397a6ef8763a18f00fac217e055c0d3094101011, 0x4e0bd32473c4c51bf25654def69f797c6b29a232, 0x28d8c35fb7eea622582135e3ad47a227c9a663bd, 0xf96488698590dc3b2c555642b871348dfa067ad5, 0x4eebe80cb6f3ae5904f6f4b28d907f907189fcab, 0x8d1abd897dacd4312e18080c88fb9647eab44052, 0x457029c469c4548d168cec3e65872e4428d42b67, 0x1296acded1e063af39fe8ba0b4b63df789f70517, 0x71762c63678c18d1c6378ce068e666381315147e, 0x6cc1c878fa6cde8a9a0b8311247e741e4642fe6d, 0x8d9ed7f4553058c26f7836a3802d3064eb1b363d, 0x5032e4bcf7932b49fdba377b6f1499636513cfc3, 0x462b678b51b584f3ed7ada070b5cd99c0bf7b87f, 0xc8aa49e3809f0899f28ab57e6743709d58419033, 0x01b1cae91a3b9559afb33cdc6d689442fdbfe037, 0xb1043004ec1941a8cf4f2b00b15700ddac6ff17e, 0x5ba2c6c35dfaec296826591904d544464aeabd5e, 0xb32400fd13c5500917cb037b29fe22e7d5228f2d, 0xd59d92d2c8701980cc073c375d720af064743c0c, 0x11dd6185d9a8d73ddfdaa71e9b7774431c4dfec2, 0xd4cb21e590c5a0e06801366aff342c7d7db16424, 0x5b6d55f6712967405c659129f4b1de09acf2cb7b, 0x6179979907fe7f037e4c38029d60bcbab832b3d6, 0x33c407133b84b3ca4c3ded1f4658900c38101624, 0xcd2a36d753e9e0ed012a584d716807587b41d56a, 0x8155fa6c51eb31d808412d748aa086105018122f, 0x3ecc8e1668dde995dc570fe414f44211c534a615, 0xd6395db5a4bb66e60f4cfbcdf0057bb4d97862e2, 0xb6fb39786250081426a342c70d47ee521e5bc563, 0x510eda5601499a0d5e1a006bfffd833672f2e267, 0x98c19dba810ba611e68f2f83ee16f6e7744f0c1f, 0x34ff26eb60a8d1a95a489fae136ee91d4e58084c, 0x6ad90be252d9cd464d998125fab693060ba8e429, 0x038323b184cff7a82ae2e1bda7793fe4319ca0bf, 0xdc5305b4020a06b49d657c7ca34c35c91c5f2c56, 0xc9c80dc12e7bab86e949d01e4c3ed35f2b9bba5f, 0x7beb81fb2f5e91526b2ac9795e76c69bcff04bc0, 0xb8bc9bca7f71b4ed12e620438d620f53c114342f, 0xd288e7cb7ba9f620ab0f7452e508633d1c5aa276, 0xa2e460a989cb15565f9ecca7d121a18e4eb405b6, 0x7489cc8abe75cda4ef0d01cef2605e47eda67ab1, 0x38b403fb1fb7c14559a2d6f6564a5552bca39aff, 0xe55c80520a1b0f755b9a2cd3ce214f7625653e8a, 0x451b7070259bdba27100e36e23428a53dfe304e9, 0x8b5c914b128bf1695c088923fa467e7911f351fa, 0x17df49518d73b129f0da36b1c9b40cb66420fdc7, 0xc1950543554d8a713003f662bb612c10ad4cdf21, 0xfa7606435b356cee257bd2fcd3d9eacb3cd1c4e1, 0xe0bad98eee9698dbf6d76085b7923de5754e906d, 0xce53c8cdd74296aca987b2bc19c2b875a48749d0, 0xd0c55abf976fdc3db2afe9be99d499484d576c02, 0x238a6b7635252f5244486c0af0a73a207385e039, 0xceb389381d48a8ae4ffc483ad0bb5e204cfdb1ec, 0x3847667038f33b01c1cc795d8daf5475eff5a0d4, 0xa08d215b5b6aac4861a281ac7e400b78fef04cbf, 0x2d0dec51a6e87330a6a8fa2a0f65d88d4abcdf73, 0x9e8f64ddcde9b8b451bafaa235a9bf511a25ac91, 0xddac6bf4bbdd7d597d9c686d0695593bedccc7fa, 0x22e15158b5ee3e86eb0332e3e6a9ac6cd9b55ecd, 0x3aea4e82d2400248f99871a41ca257060d3a221b, 0xfb126f0ec769f49dcefca2f200286451583084b8, 0x1b8bd6d2eca20185a78e7d98e8e185678dac4830, 0x664cd67dccc9ac8228b45c55db8d76550b659cdc, 0x553f37d92466550e9fd775ae74362df030179132, 0x730d8763c6a4fd824ab8b859161ef7e3a96a1200, 0x04c2c64bb54c3eccd05585e10ec6f99a0cdb01a3, 0xf1624d980b65336feac5a6d54125005cfcf2aacb, 0x0b7fc9ddf70576f6330669eaaa71b6a831e99528, 0xfa2bbca15d3fe39f8a328e91f90da14f7ac6253d, 0x07feef54c136850829badc4b49c3f2a73c89fb9e, 0x3703350c4d6fe337342cddc65bf1e2386bf3f9b2, 0x6d7d1c949511f88303808c60c5ea0640fcc02683, 0x34fa7792bad8bbd7ff64056214a33eb6600c1ea8, 0x994cc2b5227ec3cf048512467c41b7b7b748909f, 0x08da3a7a0f452161cfbcec311bb68ebfdee17e88, 0xbbb4ee1d82f2e156442cc93338a2fc286fa28864, 0x7a2dfc770e24368131b7847795f203f3d50d5b56, 0x7cef4d43aa417f9ef8b787f8b99d53f1fea1ee88, 0xc6a30ef5bb3320f40dc5e981230d52ae3ac19322, 0x6a74844d8e9cb5581c45079a2e94462a6cee8821, 0xc3110be01dc9734cfc6e1ce07f87d77d1345b7e1, 0xaeb916ebf49d0f86c13f7331cef19e129937512d, 0x3e5abd09ce5af7ba8487c359e0f2a93a986b0b18, 0xcdd60d73efaad873c9bbfb178ca1b7105a81a681, 0x31eb123c95c82bf685ace7a75a1881a289efca10, 0x86e8670e27598ea09c3899ab7711d3b9fe901c17, 0xa144f6b60f72d64a21e330dadb62d8990ade2b09, 0x68883e152e5660fee59626e7e3b4f05110e6222f, 0xfe4249127950e2f896ec0e7e2e3d055aab10550f, 0x403d53cf620f0922b417848dee96c190b5bc8271, 0xbec2e6de39c07c2bae556acfbee2c4728b9982e3, 0xf3c4716d1ee5279a86d0163a14618181e16136c7, 0xe38ef28a5ed984a7db24a1ae782dfb87f397dfc6, 0x30fbe5885f9fcce9ea5edb82ed4a1196dd259aed, 0x48bf14d7b1fc84ebf3c96be12f7bce01aa69b03e, 0xb8d5c324a8209d7c8049d0d4aede02ba80ab578b, 0x43d5a71ce8b8f8ae02b2eaf8eaf2ca2840b93fb6, 0xf9a59c3cc5ffacbcb67be0fc7256f64c9b127cb4, 0x0e21af1b8dbf27fcf63f37e047b87a825cbe7c27, 0x1c35aab688a0cd8ef82e76541ba7ac39527f743b, 0x91ac5cfe67c54aa7ebfba448666c461a3b1fe2e1, 0x4ba53ab549e2016dfa223c9ed5a38fad91288d07, 0x99a4de19ded79008cfdcd45d014d2e584b8914a8, 0x4adbf4aae0e3ef44f7dd4d8985cfaf096ec48e98, 0x9a633fcd112cceeb765fe0418170732a9705e79c, 0x292f228b0a94748c8eec612d246f989363e08f08, 0x9f3497f5ef5fe63095836c004eb9ce02e9013b4b, 0x0e6dfd553b2e873d2aec15bd5fbb3f8472d8d394, 0x74ebf4425646e6cf81b109ce7bf4a2a63d84815f, 0x8ce5e3b5f591d5eca38abf228f2e3c35134bdac0, 0x90c41eba008e20cbe927f346603fc88698125969, 0x382ba76db41b75606dd48a48f0137e9174e031b6, 0x5d24bdbc1c47f0eb83d128cae48ac33c4817e91f, 0xa64e5ffb704c2c9139d77ef61d8cdfa31d7a88e9, 0xa18360e985f2062e8f8efe02ad2cbc91ad9a5aad, 0xd251f903ae18727259eee841a189a1f569a5fd76, 0xefa6b1f0db603537826891b8b4bc163984bb40cd, 0x47fff42c678551d141eb75a6ee398117df3e4a8d, 0xf2294adbb6f0dcc76e632ebef48ab49f124dbba4, 0x53700d53254d430f22781a4a76a463933b5d6b08, 0xb14a7aaa8f49f2fb9a8102d6bbe4c48ae7c06fb2, 0x9ed4e63f526542d44fddd34d59cd25388ffd6bda, 0x4cac91fb83a147d2f76c3267984b910a79933348, 0x9b32cf4f5115f4b34a00a64c617de06387354323, 0xb8bedd576a4b4c2027da735a5bc3f533252a1808, 0xc5a3b98e4593fea0b38c4f455a5065f051a2f815, 0xeaf52388546ec35aca6f6c6393d8d609de3a4bf3, 0x4c423c76930d07f93c47a5cc4f615745c45a9d72, 0x9052f2e4a3e3c12dd1c71bf78a4ec3043dc88b7e, 0x2bade91d154517620fd4b439ac97157a4102a9f7, 0xda698d64c65c7f2b2c7253059cd3d181d899b6b7, 0xc6d8954e8f3fc533d2d230ff025cb4dce14f3426, 0x349a816b17ab3d27bbc0ae0051f6a070be1ff29d, 0xff4d9c8484c43c42ff2c5ab759996498d323994d, 0x22944fbca9b57963084eb84df7c85fb9bcdfb856, 0xbfd93c90c29c07bc5fb5fc49aeea55a40e134f35, 0x3caedb5319fe806543c56e5021d372f71be9062e, 0x9a079c92a629ca15c8cafa2eb28d5bc17af82811, 0x7d2a52a7cf0c8436a8e007976b6c26b7229d1e15, 0xcf89f7460ba3dfe83c5a1d3a019ee1250f242f0f, 0x577bfe64e3a1e3800e94db1c6c184d8dc8aafc66, 0x7ffd02ed370c7060b2ae53c078c8012190dfbb75, 0x90b62f131a5f29b45571513ee7a74a8f0b232202, 0x6e8212b722afd408a7a73ed3e2395ee6454a0330, 0x515f30bc90cdf4577ee47d65d785fbe2e837c6bc, 0xc27376f45d21e15ede3b26f2655fcee02ccc0f2a, 0x3da39ce3ef4a7a3966b32ee7ea4ebc2335a8f11f, 0x25259d975a21d83ae30e33f800f53f37dfa01938, 0x8ed143701f2f72280fd04a7b4164281979ea87c9, 0x5ac99ad7816ae9020ff8adf79fa9869b7cea6601, 0xf51fded80acb502890e87369741f3722514cefff, 0xf657fcbe682eb4e8db152ecf892456000b513d15, 0x62c37c52b97f4b040b1aa391d6dec152893c4707, 0x89fc8e4d386b0d0bb4a707edf3bd560df1ad8f4e, 0x53c0bb7fc88ea422d2ef7e540e2d8f28b1bb8183, 0x56f493a3d108aaa2d18d98922f8efe1662cfb73d, 0xe9458f68bb272cb5673a04f781b403556fd3a387, 0xbe525a33ea916177f17283fca29e8b350b7f530b, 0x4feb846be43041fd6b34202897943e3f21cb7f04, 0x15aa530dc36958b4edb38eee6dd9e3c77d4c9145, 0x2458d6555ff98a129cce4037953d00206eff4287, 0x8035fe4e6b6af27ae492a578515e9d39fa6fa65b, 0x296b71c0015819c242a7861e6ff7eded8a5f71e3, 0x8f1952eed1c548d9ee9b97d0169a07933be69f63, 0xa421dbb89b3a07419084ad10c3c15dfe9b32d0c2, 0x554336ee4ea155f9f24f87bca9ca72e253e12cd2, 0xffc5fc4b7e8a0293ff39a3a0f7d60d2646d37a74, 0xea2c197d26e98b0da83e1b72c787618c979d3db0, 0x96aa573fed2f233410dbae5180145b23c31a02f0, 0xc23b2f921ce4a37a259ee4ad8b2158d15d664f59, 0xd874b9dfae456a929ba3b1a27e572c9b2cecdfb3, 0xbf8b8005d636a49664f74275ef42438acd65ac91, 0x441a52001661fac718b2d7b351b7c6fb521a7afd, 0x812a55c43caedc597218379000ce510d548836fd, 0x5e90c85877198756b0366c0e17b28e52b446505a, 0xda3017c150dd0dce7fcf881b0a48d0d1c756c4c7, 0x6baf7a2a02ae78801e8904ad7ac05108fc56cff6, 0x177dae78bc0113d8d39c4402f2a641ae2a105ab8, 0x01b5b5bc5a117fa08b34ed1db9440608597ac548, 0xaae732eda65988c3a00c7f472f351c463b1c968e, 0xd95342953c8a21e8b635eefac7819bea30f17047, 0x8d616b1eee77eef6f176e0698db3c0c141b2fc8f, 0x12d20790b7d3dbd88c81a279b812039e8a603bd0, 0x3734cb187491ede713ae5b3b2d12284af46b8101, 0xdd967c4c5f8ae47e266fb416aad1964ee3e7e8c3, 0x3dcef19c868b15d34eda426ec7e04b18b6017002, 0xce9d21c692cd3c01f2011f505f870036fa8f6cd2, 0xd44f6ac3923b5fd731a4c45944ec4f7ec52a6ae4, 0xb424d68d9d0d00cec1938c854e15ffb880ba0170, 0x1f2186ded23e0cf9521694e4e164593e690a9685, 0x7f4b5e278578c046cceaf65730a0e068329ed5b6, 0x8c50aa2a9212bcde56418ae261f0b35e7a9dbb82, 0x1953313e2ad746239cb2270f48af34d8bb9c4465, 0xa15025f595acdbf3110f77c5bf24477e6548f9e8, 0x53af32c22fef99803f178cf90b802fb571c61cb9, 0xd0a8abd80a199b54b08b65f01d209c27fef0115b, 0x2b68306ba7f8daaf73f4c644ef7d2743c0f26856, 0x96924191b7df655b3319dc6d6137f481a73a0ff3, 0x6fa72015fa78696efd9a86174f7f1f21019286b1, 0x0b119df99c6b8de58a1e2c3f297a6744bf552277, 0x61733947fab820dbd351efd67855ea0e881373a0, 0x8ae6f80b70e1f23c91fbd5a966b0e499d95df832, 0x01a7d9fa7d0eb1185c67e54da83c2e75db69e39f, 0x9932ef1c85b75a9b2a80057d508734c51085becc, 0xaefcfe88c826ccf131d54eb4ea9eb80e61e1ee25, 0xc21fa6643a1f14c02996ad7144b75926e87ecb4b, 0x97d9e46a7604d7b5a4ea4ee61a42b3d2350fc3ed, 0x3cafaf5e62505615068af8eb22a13ad8a9e55070, 0x22f2dcff5ad78c3eb6850b5cb951127b659522e6, 0xaaad1baade5af04e2b17439e935987bf8c2bb4b9, 0x298887bab57c5ba4f0615229d7525fa113b7ea89, 0x7539333046deb1ef3c4daf50619993f444e1de68, 0x9752d14f5e1093f071711c1adbc4e3eb1e5c57f3, 0xed641e06368fb0efaa1703e01fe48f4a685309eb, 0xd0ee4d02cf24382c3090d3e99560de3678735cdf, 0x47e25df8822538a8596b28c637896b4d143c351d, 0x559706c332d20779c45f8a6d046a699159b74921, 0x3a4da78dce05aeb87de9aead9185726da1926798, 0x3041445a33ba158741160d9c344eb88e5c306f94, 0x08d4311c9c1bbaf87fabe1a1d01463828d5d98ce, 0x6bd3e59f239fafe4776bb9bddd6bee83ba5d9d9f, 0x29eaae82761762f4d2db53a9c68b0f6b0b6d4e66, 0x0b7d339371e5be6727e6e331b5821fa24bdb9d5a, 0x4714cfa4f46bd6bd70737d75878197e08f88e631, 0xad92ca066edb7c711dfc5b166192d1edf8e77185, 0xf97b56ebd5b77abc9fbacbabd494b9d2c221cd03, 0x591bef3171d1c5957717a4e98d17eb142c214e56, 0x899b3c249f0c4b81df75d212004d3d6d952fd223, 0xa819d2ece122e028c8e8a04a064d02b9029b08b9, 0xe341642d40d2afce2e9107c67079ac7a2660086c, 0x0329188f080657ab3a2afa522467178279832085, 0x03317826d1f70aa4bddfa09be0c4105552d2358b, 0x3ac9dc7a436ae98fd01c7a9621aa8e9d0b8b531d, 0x93c88e2d88621e30f58a9586bed4098999eb67dd, 0xcd1e66ed539dd92fc40bbaa1fa16de8c02c14d45, 0xe6c81ffcecb47ecdc55c0b71e4855f3e5e97fc1e, 0x50f8fa4bb9e2677c990a4ee8ce70dd1523251e4f, 0x4f64a85e8e9a40498c0c75fceb0337fb49083e5e, 0x4b29437c97b4a844be71cca3b648d4ca0fdd9ba4, 0x1eee6cbee4fe96ad615a9cf5857a647940df8c78, 0x29f0edc60338e7112085a1d114da8c42ce8f55d6, 0x23b1c4917fbd93ee3d48389306957384a5496cbf, 0x1767525c5f5a22ed80e9d4d7710f0362d29efa33, 0x3064899a963c4779cbf613cd6980846af1e6ec65, 0x68531f4dda808f5320767a03113428ca0ce2f389, 0x1db9ac9a9eaeec0a523757050c71f47278c72d50, 0x7592c69d067b51b6cc639d1164d5578c60d2d244, 0xcf3fbfa1fd32d7a6e0e6f8ef4eab57be34025c4c, 0x8efec058cc546157766a632775404a334aaada87, 0xfaf5f0b7b6d558f5090d9ea1fb2d42259c586078, 0x19ecf2abf40c9e857b252fe1dbfd3d4c5d8f816e, 0x6e8a26689f7a2fdefd009cbaaa5310253450daba, 0xe2f40d358f5e3fe7463ec70480bd2ed398a7063b, 0xfa19d6f7a50f4f079893d167bf14e21d0073d196, 0x3e2ca0d234baf607ad466a1b85f4a6488ef00ae7, 0xf8a49ca2390c1f6d5c0e62513b079571743f7cc6, 0x5d3f3b1f7130b0bb21a0fd32396239179a25657f, 0xf332c0f3e05a27d9126fd0b641a8c2d4060608fd, 0xe304a32f05a83762744a9542976ff9b723fa31ea, 0xf768f321fd6433d96b4f354d3cc1652c1732f57f, 0x147af46ae9ccd18bb35ca01b353b51990e49dce1, 0x21eae6feffa9fbf4cd874f4739ace530ccbe5937, 0x6994fb3231d7e41d491a9d68d1fa4cae2cc15960, 0x51126446ab3d8032557e8eba65597d75fadc815c, 0x24daaaddf7b06bbcea9b80590085a88567682b4e, 0xcd020f8edfcf524798a9b73a640334bbf72f80a5, 0x56febf9e1003af15b1bd4907ec089a4a1b91d268, 0x3c79c863c3d372b3ff0c6f452734a7f97042d706, 0xe1203eb3a723e99c2220117ca6afeb66fa424f61, 0x18fb09188f27f1038e654031924f628a2106703d, 0x2eba0c6ee5a1145c1c573984963a605d880a7a20, 0x4cefbe2398e47d52e78db4334c8b697675f193ae, 0xc02471e3fc2ea0532615a7571d493289c13c36ef, 0xba469aa5c386b19295d4a1b5473b540353390c85, 0x7b11673cc019626b290cbdce26046f7e6d141e21, 0x26784ade91c8a83a8e39658c8d8277413ccc9954, 0x57d3df804f2beee6ef53ab94cb3ee9cf524a18d3, 0xccae0d3d852a7da3860f0636154c0a6ca31628d4, 0xbfe3a1fc6e24c8f7b3250560991f93cba2cf8047, 0x724ce858857ec5481c86bd906e83a04882e5821d, 0xfb37cf6b4f81a9e222fba22e9bd24b5098b733cf, 0x9b22a80d5c7b3374a05b446081f97d0a34079e7f, 0x0a29a8a4d5fd950075ffb34d77afeb2d823bd689, 0xd01af9134faf5257174e8b79186f42ee354e642d, 0x7f1619988f3715e94ff1d253262dc5581db3de1c, 0x6f137a71a6f197df2cbbf010dcbd3c444ef5c925, 0x11efb8a20451161b644a8ccebbc1d343a3bbcb52, 0x46504e6a215ac83bccf956befc82ab5a679371c8, 0xb523fff9749871b35388438837f7e6e0dea9cb6b, 0xc5c6a4998a33feb764437a8be929a73ba34a0764, 0x3cd7f7c7c2353780cde081eeec45822b25f2860c, 0xb3050beff9de33c80e1fa15225e28f2c413ae313, 0x59268171b833e0aa13c54b52ccc0422e4fa03aeb, 0x7169724ee72271c534cad6420fb04ee644cb86fe, 0x6e6d5bbbb9053b89d744a27316c2a7b8c09b547d, 0x3f3f46b75cabe37bfacc8760281f4341ca7f463d, 0x7a33834e8583733e2d52aead589bd1affb1dd256, 0xe94ded99dcb572b9bb1dcba32f6dee91e057984e, 0x19336a236ded755872411f2e0491d83e3e00159e, 0x63ac545c991243fa18aec41d4f6f598e555015dc, 0xcfee05c69d1f29e7714684c88de5a16098e91399, 0x77be6b64d7c733a436adec5e14bf9ad7402b1b46, 0x233bdddd5da94852f4ade8d212885682d9076bc6, 0x952c57d2fb195107d4cd5ca300774119dfad2f78, 0xe237baa4dbc9926e32a3d85d1264402d54db012f, 0xaa91237e740d25a92f7fa146faa18ce56dc6e1f3, 0x2339e9492870afea2537f389ac2f838302a33c06, 0x1d45586eb803ca2190650bf748a2b174312bb507, 0xc61446b754c24e3b1642d9e51765b4d3e46b34b6, 0xac28b5edea05b76f8c5f97084541277c96696a4c, 0x1a1c9a26e0e02418a5cf687da75a275c622c9440, 0x299368609042a858d1ecdf1fc0ada5eaceca29cf, 0x095f5a51d06f6340d80b6d29ea2e88118ad730fe, 0x751a2ca34e7187c163d28e3618db28b13c196d26, 0x75b0e9c942a4f0f6f86d3f95ff998022fa67963b, 0xd1b37f03cb107424e9c4dd575ccd4f4cee57e6cd, 0x7f993ddb7e02c282b898f6155f680ef5b9aff907, 0xa3d583a7b65b23f60b7905f3e4aa62aac87f4227, 0x526bb533b76e20c8ee1ebf123f1e9ff4148e40be, 0x2160b4c02cac0a81de9108de434590a8bfe68735, 0x010007394b8b7565a1658af88ce463499135d6b7, 0x64457fa33b0832506c4f7d1180dce48f46f3e0ff, 0xb51e558eb5512fbcfa81f8d0bd938c79ebb5242b, 0x94f13f9f0836a3ee2437a84922d2984dc0f7d53b, 0x6bd457ade051795df3f2465c3839aed3c5dee978, 0xf3dbcf135acb9dee1a489c593c024f03c2bbaece, 0x61b902c5a673885826820d1fe14549e4865fbdc2, 0x2acc9c1a32240b4d5b2f777a2ea052b42fc1271c, 0x6ddfef639155daab0a5cb4953aa8c5afaa880453, 0x96ff6f509968f36cb42cba48db32f21f5676abf8, 0xb4c8170f7b2ab536d1d9a25bdd203ae1288dc3d5, 0x78d4f8c71c1e68a69a98f52fcb45da8af56ea1a0, 0xdec99e972fca7177508c8e1a47ac22d768acab7c, 0xa07aa16d74aee8a9a3288d52db1551d593883297, 0xcf1169041c1745e45b172435a2fc99b49ace2b00, 0x526cb09ce3ada3672eec1deb46205be89a4b563e, 0xee6959de2b67967b71948c891ab00d8c8f38c7dc, 0xca7ba3ff536c7e5f0e153800bd383db8312998e0, 0x1ed06ee51662a86c634588fb62dc43c8f27e7c17, 0x730447f97ce9b25f22ba1afb36df27f9586beb9b, 0xae5c9bdad3c5c8a1220444aea5c229c1839f1d64, 0xa38306cb70baa8e49186bd68aa70a83d242f2907, 0x71213fca313404204ecba87197741aa9dfe96338, 0x10e390ad2ba33d82b37388d09c4544c6b0225de5, 0x3b6e814f770748a7c3997806347605480a3fd509, 0xfd452c3969ece3801c542020f1cdcaa1c71ed23d, 0xe742b1e6069a8ffc3c4767235defb0d49cbed222, 0xd7225738dcf3578438f8e7c8b3837e42e04a262f, 0xcd0b0257e783a3d2c2e3ba9d6e79b75ef98024d4, 0xe80e7fef18a5db15b01473f3ad6b78b2a2f8acd9, 0x261575e9cf59c8226fa7aaf91de86fb70f5ac3ae, 0x7e71171f2949fa0c3ac254254b1f0440e5e6a038, 0x96ea6ac89a2bac95347b51dba63d8bd5ebdedce1, 0xe6ec5cf0c49b9c317e1e706315ef9eb7c0bf11a7, 0x2b99b42e4f42619ee36baa7e4af2d65eacfcba35, 0xc6e4cc0c7283fc1c85bc4813effaaf72b49823c0, 0xdbc1ce0e49b1a705d22e2037aec878ee0d75c703, 0x806f44bdeb688037015e84ff218049e382332a33, 0x1a3a330e4fcb69dbef5e6901783bf50fd1c15342, 0xd2a84f75675c62d80c88756c428eee2bcb185421, 0xc593b546b7698710a205ad468b2c13152219a342, 0x3f627a769e6a950eb87017a7cd9ca20871136831, 0xf2d5763ce073127e2cedde6faba786c73ca94141, 0x162110f29eac5f7d02b543d8dcd5bb59a5e33b73, 0x59473cd300fffae240f5785626c65dfec792b9af, 0x4dcd11815818ae29b85d01367349a8a7fb12d06b, 0x9329ffdc268babde8874b366406c81445b9b2d35, 0x0ab4281ebb318590abb89a81df07fa3af904258a, 0x875061ee12e820041a01942cb0e65bb427b00060, 0xc9b698e898d20d4d4f408e4e4d061922aa856307, 0xca49a5f58adbefae23ee59eea241cf0482622eaa, 0x196e85df7e732b4a8f0ed03623f4db9db0b8fa31, 0x4c760cd9e195ee4f2d6bce2500ff96da7c43ee91, 0x024a098ae702bef5406c9c22b78bd4eb2cc7a293, 0x9d81aea69aed6ad07089d61445348c17f34bfc5b, 0x76ab87dd5a05ad839a4e2fc8c85aa6ba05641730, 0xc6e2f5af979a03fd723a1b6efa728318cf9c1800, 0x5db69fe93e6fb6fbd450966b97238b110ad8279a, 0xa4259f8345f7e3a8b72b0fec2cf75e321fda4dc2, 0x095030e4b82692dcf8b8d0912494b9b378ec9328, 0x4b470f7ba030bc7cfcf338d4bf0432a91e2ea5ff, 0x99c9f93e45fe3c1418c353e4c5ac3894eef8121e, 0xffac3db879a6c7158e8dec603b407463ba0d31cf, 0xac8e87ddda5e78fcbcb9fa7fc3ce038f9f7d2e34, 0x7a0589b143a8e5e107c9ac66a9f9f8597ab3e7ab, 0xb7d581fe0af1ec383f3b3c416783f385146a7612, 0xbb3fc0a29c034d710812dcc775c8cab9d28d6975, 0x2c603ff0fe93616c43573ef279bfea40888d6ae7, 0x15f2b7b16432ee50a5f55b41232f6334ed58bdc0, 0x7f3d7203c8a447f7bf36d88ae9b6062a5eee78ae, 0xf067e1f1d683556a4cc4fd0c0313239f32c4cfd8, 0x52738c90d860e04cb12f498d96fdb5bf36fc340e, 0x45781bbe7714a1c8f73b1c747921df4f84278b70, 0x4a97e8fcf4635ea7fc5e96ee51752ec388716b60, 0x54939ff08921b467cf2946751d856378296c63ed, 0x6485470e61db110aebdbafd536769e3c599cc908, 0xe20d1bcb71286dc7128a9fc7c6ed7f733892eef5, 0xd6eea898d4ae2b718027a19ce9a5eb7300abe3ca, 0x014974a1f46bf204944a853111e52f1602617def, 0x6aa5732f3b86fb8c81efbe6b5b47b563730b06c8, 0x6107d71dd6d0eefb11d4c916404cb98c753e117d, 0xdd7bcda65924aaa49b80984ae173750258b92847, 0x4e7b54474d01fefd388dfcd53b9f662624418a05, 0x24fc73d20793098e09ddab5798506224fa1e1850, 0x2b8488bd2d3c197a3d26151815b5a798d27168dc, 0x949131f28943925cfc97d41e0cea0b262973a730, 0x60b8d6b73b79534fb08bb8cbcefac7f393c57bfe, 0xd6acc220ba2e51dfcf21d443361eea765cbd35d8, 0xc4c6cb723dd7afa7eb535615e53f3cef14f18118, 0x4c9a862ad115d6c8274ed0b944bdd6a5500510a7, 0x85732c065cbd64119941aed430ac59670b6c51c4, 0x0126e12ebc17035f35c0e9d11dd148393c405d7a, 0x472048cc609aeb242165eaaa8705850cf3125de0, 0xd2edd1ddd6d86dc005baeb541d22b640d5c7cae5, 0x4549b15979255f7e65e99b0d5604db98dfcac8bf, 0xc6c7c191379897dd9c9d9a33839c4a5f62c0890d, 0xd367009ab658263b62c2333a1c9e4140498e1389, 0x143f5f1658d9e578f4f3d95f80c0b1bd3933cbda, 0x1a09fdc2c7a20e23574b97c69e93deba67d37220, 0xac8b509aefea1dbfaf2bb33500d6570b6fd96d51, 0x16ffac84032940f0121a09668b858a7e79ffa3bb, 0xf338459f32a159b23db30ac335769ab2351aa63c, 0xd82251456dc1380f8f5692f962828640ab9f2a03, 0x47f4696bd462b20da09fb83ed2039818d77625b3, 0x3dde8b15b3ccbaa5780112c3d674f313bba68026, 0xf70d637a845c06db6cdc91e6371ce7c4388a628e, 0x68295e8ea5afd9093fc0a465d157922b5d2ae234, 0x614e8bef3dd2c59b59a4145674401018351884ea, 0x4737d042dc6ae73ec73ae2517acea2fdd96487c5, 0xcec6fc65853f9cce5f8e844676362e1579015f02, 0xae47e2609cfafe369d66d415d939de05081a9872, 0x09a928d528ec1b3e25ffc83e218c1e0afe8928c7, 0x9b444fd337e5d75293adcfff70e1ea01db023222, 0x168bdec818eafc6d2992e5ef54aa0e1601e3c561, 0x353dbec42f92b50f975129b93c4c997375f09073, 0x6fcc2c732bdd934af6ccd16846fb26ef89b2aa9b, 0x6f2576da4de283bbe8e3ee69ddd66e5e711db3f5, 0x3a3dd104cd7eb04f21932fd433ea7affd39369f5, 0xd44f4ac5fad76bdc1537a3b3af6472319b410d9d, 0x3d9d6be57ff83e065985664f12564483f2e600b2, 0x88f1045f19f2d3191816b1df18bb6e1435ad1b38, 0xddab75fb2ff9fecb88f89476688e2b00e367ebf9, 0x092e815558402d67f90d6bfe6da0b2fffa91455a, 0xa7024cfd742c1ec13c01fea18d3042e65f1d5dee, 0x7f46bb25460dd7dae4211ca7f15ad312fc7dc75c, 0x93f18cd2526040761488c513174d1e7963768b2c, 0x352f25babf4a690673e35195efa8f79d05848aad, 0xf7b151cc5e571c17c76539dbe9964cbb6fe5de79, 0xff3eee57c34d6dae970d8b311117c53586cd3502, 0xae6f0c73fdd77c489727512174d9b50296611c4c, 0x7819b0458e314e2b53bfe00c38495fd4b9fdf8d6, 0x7fdba031c78f9c096d62d05a369eeab0bccc55e5, 0x735e328666ed5637142b3306b77ccc5460e72c3d, 0x0bfbb6925dc75e52cf2684224bbe0550fea685d3, 0x6be16313643ebc91ff9bb1a2e116b854ea933a45, 0xd6acffd0bfd99c382e7bd56ff0e6144a9e52b08e, 0x276a006e3028ecd44cdb62ba0a77ce94ebd9f10f, 0x10711c3dda32317885f0a2fd8ae92e82069b0d0b, 0x43cb9652818c6f4d6796b0e89409306c79db6349, 0x7109dd011d15f3122d9d3a27588c10d77744508b, 0x3497dd66fd118071a78c2cb36e40b6651cc82598, 0x9bf672d979b36652fc5282547a6a6bc212ae4368, 0xeaed16eaf5daab5bf0295e5e077f59fb8255900b, 0x7ac58f6ffc4f8107ae6e30378e4e9f99c57fbb24, 0x45a570dcc2090c86a6b3ea29a60863dde41f13b5, 0x433a3b68e56b0df1862b90586bbd39c840ff1936, 0xe8eaf12944092dc3599b3953fa7cb1c9761cc246, 0xec11362cec810985d0ebbd7b73451444985b369f, 0x78e83f80b3678c7a0a4e3e8c84dccde064426277, 0x0cc67f8273e1bae0867fd42e8b8193d72679dbf8, 0xc70d856d621ec145303c0a6400cd17bbd6f5eaf7, 0xf468906e7edf664ab0d8be3d83eb7ab3f7ffdc78, 0x3c286cfb30146e5fd790c2c8541552578de334d8, 0xc401c427cccff10decb864202f36f5808322a0a8, 0xafd019ff36a09155346b69974815a1c912c90aa4, 0x96fe59c3dbb3aa7cc8cb62480c65e56e6204a7e2, 0xa47779d8bc1c7bce0f011ccb39ef68b854f8de8f, 0x58c650ced40bb65641b8e8a924a039def46854df, 0x86f4f40ad984fbb80933ae626e0e42f9333fdd41, 0xb22d5055d9623135961e6abd273c90deea16a3e7, 0xee3564f5f1ba0f94ec7bac164bddbf31c6888b55, 0xcf26b47bd034bc508e6c4bcfd6c7d30034925761, 0xe87dbac636a37721df54b08a32ef4959b5e4ff82, 0x3bf86ed8a3153ec933786a02ac090301855e576b, 0xcfd2728dfb8bdbf3bf73598a6e13eaf43052ea2b, 0x85b16f0b8b34dff3804f69e2168a4f7b24d1042b, 0x84db1459bb00812ea67ecb3dc189b72187d9c501, 0x8c3a9ee71f729f236cba3867b4d79d8ceee25dbc, 0xe677c31fd9cb720075dca49f1abccd59ec33f734, 0x8889448316ccf14ed86df8e2f478dc63c4338340, 0xb279c7d355c2880392aad1aa21ee867c3b3507df, 0x12b5e28945bb2969f9c64c63cc05b6f1f8d6f4d5, 0x8d2303341e1e1eb5e8189bde03f73a60a2a54861, 0x94d81074db5ae197d2bb1373ab80a87d121c4bd3, 0x752c9febf42f66c4787bfa7eb17cf5333bba5070, 0x16816aac0ede0d2d3cd442da79e063880f0f1d67, 0xdaac91c1e859d5e57ed3084b50200f9766e2c52b, 0x32c2fde2b6aabb80e5aea2b949a217f3cb092283, 0xcdab46a5902080646fbf954204204ae88404822b, 0xfdf42343019b0b0c6bf260b173afab7e45b9d621, 0x791f6040b4e3e50dcf3553f182cd97a90630b75d, 0x4b762166dd1118e84369f804c75f9cd657bf730c, 0xa76d3f156251b72c0ccf4b47a3393cbd6f49a9c5, 0xc5eb42295e9cadeaf2af12dede8a8d53c579c469, 0xdb9371b30c4c844e59e03e924be606a938d1d310, 0x2cd39334ac7eac797257abe3736195f5b4b5ce0f, 0xad44357e017e244f476931c7b8189efee80a5d0a, 0x4ca7b717d9bc8793b04e051a8d23e1640f5ba5e3, 0x73e4a2b60cf48e8baf2b777e175a5b1e4d0c2d8f, 0x5a1d2d2d1d520304b6208849570437eb3091bb9f, 0x53047dc8ac9083d90672e8b3473c100ccd278323, 0x26fe174cbf526650e0cd009bd6126502ce8e684d, 0xe2df23f6ea04becf4ab701748dc0963184555cdb, 0xc1170dbaadb3dee6198ea544baec93251860fda5, 0x8bbeacfc29cfe93402db3c41d99ab759662e73ec, 0x165305b787322e25dc6ad0cefe6c6f334678d569, 0x095457f8ef8e2bdc362196b9a9125da09c67e3ab, 0x702802f36d00250fab53adbcd696f0176f638a49, 0x489334c2b695c8ee0794bd864217fb9fd8f8b135, 0xfa8cf4e627698c5d5788abb7880417e750231399, 0x3329eb3baf4345d600ced40e6e9975656f113742, 0xb4dd5499daeb2507fb2de12297731d4c72b16bb0, 0x88c2516a7cdb09a6276d7297d30f5a4db1e84b86, 0x612ced8dc0dc9e899ee46f7962333315f3f55e44, 0xd71e43a45177ad51cbe0f72184a5cb503917285a, 0x2fb566c94bbba4e3cb67cdda7d5fad7131539102, 0x03be5b4629aefbbcab9de26d39576cb7f691d764, 0x025367960304beee34591118e9ac2d1358d8021a, 0xa5d5b8b62d002def92413710d13b6ff8d4fc7dd3, 0xdf3b72c5bd71d4814e88a62321a93d4011e3578b, 0x3588895ac9fbafec012092dc05c0c302d90740fa, 0x6021e85a8814fce1e82a41abd1d3b2dad2faefe0, 0x17ee9f54d4ddc84d670eff11e54a659fd72f4455, 0x873c6f70efb6b1d0f2bbc57eebcd70617c6ce662, 0x1fcc7ce6a8485895a3199e16481f72e1f762defe, 0xd0a7209b80cf60db62f57d0a5d7d521a69606655, 0xa514d00edd7108a6be839a638db2415418174196, 0x046377f864b0143f282174a892a73d3ec8ec6132, 0xc126573d87b0175a5295f1dd07c575cf8cfa15f2, 0x0e123d7da6d1e6fac2dcadd27029240bb39052fe, 0xad5a8d3c6478b69f657db3837a2575ef8e1df931, 0xdb882eacedd0eff263511b312adbbc59c6b8b25b, 0x0b43bd2391025581d8956ce42a072579cbbfcb14, 0xaffea0473722cb7f0e0e86b9e11883bf428d8d54, 0xe32b1c4725a1875449e98f970eb3e54062d15800, 0x98f4af3af0aede5fafdc42a081ecc1f89e3ccf20, 0x3b4768fd71e2db2cbe7fa050483c27b4eb931df3, 0xd5f7c41e07729dfa6dfc64c4423160a22c609fd3, 0xd944c8a69ff2ca1249690c1229c7192f36251062, 0x5ae64e853ba0a51282cb8db52e41615e7c9f733f, 0xb13f93af30e8d7667381b2b95bc1a699d5e3e129, 0x8a20e5b5cee7cd1f5515bace3bf4f77ffde5cc07, 0x2448596f91c09baa30bc96106a2d37b5705e5d28, 0xccca24d8c56d6e2c07db086ec07e585be267ac8d, 0xf67bb8e2118bbcd59027666eedf6943ec9f880a5, 0x7ae659eb3bc46852fa86fac4e21c768d50388945, 0x467e0ed54f3b76ae0636176e07420815a021736e, 0xa46cd237b63eea438c8e3b6585f679e4860832ac, 0x6b760d4877e6a627c1c967bee451a8507ddddbab, 0x593044670faeff00a55b5ae051eb7be870b11694, 0x533c06928f19d0a956cc28866bf6c8d8f4191a94, 0x262dc1364ccf6df85c43268ee182554dae692e29, 0xe4368bc1420b35efda95fafbc73090521916aa34, 0xfeb92d30bf01ff9a1901666c5573532bfa07eeec, 0xee25b9a7032679b113588ed52c137d1a053a1e94, 0x20134cbff88bfadc466b52eceaa79857891d831e, 0x07b1a306cb4312df66482c2cae72d1e061400fcd, 0xe791d585b89936b25d298f9d35f9f9edc25a2932, 0x2e6933543d4f2cc00b5350bd8068ba9243d6beb0, 0xdae0d33eaa341569fa9ff5982684854a4a328a6e, 0x125cc5e4d56b2bcc2ee1c709fb9e68fb177440bd, 0xec99e95dece46ffffb175eb6400fbebb08ee9b95, 0xc538a0ff282aaa5f4b75cfb62c70037ee67d4fb5, 0x60676d1fa21fca052297e24bf96389c5b12a70d7, 0x4b3dfbdb454be5279a3b8addfd0ed1cd37a9420d, 0xcdb597299030183f6e2d238533f4642aa58754b6, 0x1ef2dcbfe0a500411d956eb8c8939c3d6cfe669d, 0xa7247c53d059eb7c9310f628d7fc6c6a0a773f08, 0x9799ca21dbcf69bfa1b3f72bac51b9e3ca587cf9, 0xddf95c1e99ce2f9f5698057c19d5c94027ee4a6e, 0x83563bc364ed81a0c6da3b56ff49bbf267827a9c, 0xa192698007cc11aa603d221d5feea076bcf7c30d, 0x0134ff38155fabae94fd35c4ffe1d79de7ef9c59, 0x80977316944e5942e79b0e3abad38da746086519, 0x193d37ed347d1c2f4e35350d9a444bc57ca4db43, 0x009a6d7db326679b77c90391a7476d238f3ba33e, 0x337b3bdf86d713dbd07b5dbfcc022b7a7b1946ae, 0x7de7fe419cc61f91f408d234cc80d5ca3d054d99, 0xf47bb134da30a812d003af8dccb888f44bbf5724, 0xfd920f722682afb5af451b0544d4f41b3b9d5742, 0x0a917f3b5cb0b883047fd9b6593dbcd557f453b9, 0xce9786d3712fa200e9f68537eeaa1a06a6f45a4b, 0x9ab98d6dbb1eaae16d45a04568541ad3d8fe06cc, 0x0b7bb342f01bc9888e6a9af4a887cbf4c2dd2caf, 0x4c0b1515dfced7a13e13ee12c0f523ae504f032b, 0xac2889b5966f0c7f9edb42895cb69d1c04f923a2, 0xd008513b27604a89ba1763b6f84ce688b346945b, 0xa4b09de6e713dc69546e76ef0acf40b94f0241e6, 0xb153f828dd076d4a7c1c2574bb2dee1a44a318a8, 0x02ade5db22f8b758ee1443626c64ec2f32aa0a15, 0x0a0650861f785ed8e4bf1005c450bbd06eb48fb6, 0xb75149e185f6e3927057739073a1822ae1cf0df2, 0x84cb7da0502df45cf561817bbd2362f451be02da, 0xc91bb562e42bd46130e2d3ae4652b6a4eb86bc0f, 0xb234035f7544463ce1e22bc553064684c513cd51, 0xe5e33800a1b2e96bde1031630a959aa007f26e51, 0xae5ce3355a7ba9b332760c0950c2bc45a85fa9a0, 0xe6f5eb649afb99599c414b27a9c9c855357fa878, 0x7010be2df57bd0ab9ae8196cd50ab0c521aba9f9, 0xca4288014eddc5632f5facb5e38517a8f8bc5d98, 0x2784903f1d7c1b5cd901f8875d14a79b3cbe2a56, 0xf8dce867f0a39c5bef9eeba609229efa02678b6c, 0xe020e86362b487752836a6de0bc02cd8d89a8b6a, 0xc4088c025f3e85013f5439fb3440a17301e544fe, 0xbefb448c0c5f683fb67ee570baf0db5686599751, 0x2f187d5a704d5a338c5b2876a090dce964284e29, 0xec0e18a01dc4dc5daae567c3fa4c7f8f9b590205, 0x637f5869d6e4695f0eb9e27311c4878aff333380, 0xd1100dd00fe2ddf18163ad964d0b69f1f2e9658a, 0x17ef4acc1bf147e326749d10e677dcffd76f9e06, 0x200dfc0b71e359b2b465440a36a6cdc352773007, 0xefe0675da98a5dda70cd96196b87f4e726b43348, 0xd5bd5e8455c130169357c471e3e681b7996a7276, 0x9c7b6dc5190fe2912963fcd579683ec7395116b0, 0xb105dd3d987cffd813e9c8500a80a1ad257d56c6, 0x145250b06e4fa7cb2749422eb817bdda8b54de5f, 0xd96db33b7b5a950c3efa2dc31b10ba10a532ef87, 0xaf529bdb459cc185bee5a1c58bf7e8cce25c150d, 0x185546e8768d506873818ac9751c1f12116a3bef, 0x51d24bc3736f88dd63b7222026886630b6eb878d, 0x69af28b0746cac0da17084b9398c5e36bb3a0df2, 0x76f83ac3da30f7092628c7339f208bfc142cb1ee, 0x00f463e137dcf625fbf3bca39eca98d2b968cf7f, 0x2084fce505d97bebf1ad8c5ff6826fc645371fb2, 0x53a714f99fa00fef758e23a2e746326dad247ca7, 0x0bf064428f83626722a7b5b26a9ab20421a7723e, 0xac6f68e837cf1961cb14ab47446da168a16dde89, 0x4b3c7388cc76da3d62d40067dabccd7ef0433d23, 0xdeb9a49a43873020f0759185e20bbb4cf381bb8f, 0x5bf9f2226e5aeacf1d80ae0a59c6e38038bc8db5, 0x9d0e7d92fb305853d798263bf15e97c72bf9d7e0, 0x2b5c60e84535eeb4d580de127a12eb2677ccb392, 0xd8d65420c18c2327cc5af97425f857e4a9fd51b3, 0x30ec9392244a2108c987bc5cdde0ed9f837a817b, 0x56a1d60d40f57f308eebf087dee3b37f1e7c2cba, 0xa9a1cdc33bfd376f1c0d76fb6c84b6b4ac274d68, 0xa67f38819565423aa85f3e3ab61bc763cbab89dd, 0x62d5cc7117e18500ac2f9e3c26c86b0a94b0de15, 0x4970d3acf72b5b1f32a7003cf102c64ee0547941, 0x76628150e2995b5b279fc83e0dd5f102a671dd1c, 0x3d8f39881b9edfe91227c33fa4cdd91e678544b0, 0xff0b7cb71da9d4c1ea6ecc28ebda504c63f82fd1, 0x8d795c5f4a5689ad62da961671f028065286d554, 0xbe2346a27ff9b702044f500deff2e7ffe6824541, 0x0dbd417c372b8b0d01bcd944706bd32e60ae28d1, 0x467fbf41441600757fe15830c8cd5f4ffbbbd560, 0x090cd67b60e81d54e7b5f6078f3e021ba65b9a1e, 0x55a4cac0cb8b582d9fef38c5c9fff9bd53093d1f, 0x3b7b4f53c45655f3dc5f017edc23b16f9bc536fa, 0xd508d39c70916f6abc4cc7f999f011f077105802, 0x037dd056e7fdbd641db5b6bea2a8780a83fae180, 0x660557bb43f4be3a1b8b85e7df7b3c5bcd548057, 0x02089361a3fe7451fb1f87f01a2d866653dc0b07, 0xc4bec96308a20f90cab18399c493fd3d065abf45, 0xcca07bb794571d4acf041dad87f0d1ef3185b319, 0xf2d0e986d814ea13c8f466a0538c53dc922651f0, 0x662cfa038fab37a01745a364e1b98127c503746d, 0x3336c3ef6e8b50ee90e037b164b7a8ea5faac65d, 0x30e33358fc21c85006e40f32357dc8895940aaf0, 0x41a9a404fc9f5bfee48ec265b12523338e29a8bf, 0x6af235d2bbe050e6291615b71ca5829658810142, 0xfd5a63157f914fd398eab19c137dd9550bb7715c, 0x8a4314fb61cd938fc33e15e816b113f2ac89a7fb, 0xb216dc59e27c3d7279f5cd5bb2becfb2606e14d9, 0xf5a5459fcdd5e5b273830df88eea4cb77ddadfb9, 0xdf31025f5649d2c6eea41ed3bdd3471a790f759a, 0x721f9d17e5a0e74205947aeb9bc6a7938961038f, 0x08d0864dc32f9acb36bf4ea447e8dd6726906a15, 0x54575c3114751e3c631971da6a2a02fd3ffbfcc8, 0x8f60895fbebbb5017fcbff3cdda397292bf25ba6, 0x91fe8a4c6164df8fa606995d6ba7adcaf1c893ce, 0x889087f66ff284f8b5efbd29493b706733ab1447, 0x051633080d07a557adde319261b074997f14692d, 0x59a12df2e3ef857aceff9306b309f6a500f70134, 0x9f64a8e8dacf4ade30d10f4d59b0a3d5abfdbf74, 0x8846928d683289a2d11df8db7a9474988ef01348, 0xdff1b220de3d8e9ca4c1b5be34a799bcded4f61c, 0x7e7c1e9a61a08a83984835c70ec31d34d3eaa87f, 0xfe210b8f04dc6d4f76216acfcbd59ba83be9b630, 0xdc8c2912f084a6d184aa73638513ccbc326e0102, 0xdddd7b9e6eab409b92263ac272da801b664f8a57, 0x86a5f8259ed5b09e188ce346ee92d34aa5dd93fa, 0xdc1f1979615f082140b8bb78c67b27a1942713b1, 0xea66e7b84dcdbf36eea3e75b85382a75f1a15d96, 0x039e7a4ebc284e2ccd42b1bdd60bd6511c0f7706, 0x36bfe1fa3b7b70c172eb042f6819a8972595413e, 0x039ef1ce52fe7963f166d5a275c4b1069fe3a832, 0xf1df55dcc34a051012b575cb968bc9c458ea09c9, 0x168b5019b818691644835fe69bf229e17112d52c, 0xf60bd735543e6bfd2ea6f11bff627340bc035a23, 0x2cbb0c73df91b91740b6693b774a7d05177e8e58, 0x9ffcf5ef46d933a519d1d16c6ba3189b27496224, 0x0e11d77a8977fac30d268445e531149b31541a24, 0xdfb1626ef48a1d7d7552a5e0298f1fc23a3b482d, 0xcc943be1222cd1400a2399dd1b459445cf6d54a9, 0xb37c2b9f50637bece0ca959208aefee6463ba720, 0x96b906ea729f4655afe3e57d35277c967dfa1577, 0x7995bd8ce2e0c67bf1c7a531d477bca1b2b97561, 0x96f820500b70f4a3e3239d619cff8f222075b135, 0xad3565d52b688added08168b2d3872d17d0a26ae, 0x9e7c2050a227bbfd60937e268cea3e68fea8d1fe, 0x7e59dc60be8b2fc19abd0a5782c52c28400bce97, 0x01ed5fba8d2eab673aec042d30e4e8a611d8c55a, 0x59a087b9351ca42f58f36e021927a22988284f38, 0x2fe0023f5722650f3a8ac01009125e74e3f82e9b, 0xbd1803370bddb129d239fd16ea8526a6188ae58e, 0xc70527d444c490e9fc3f5cc44e66eb4f306b380f, 0x0f206e1a1da7207ea518b112418baa8b06260328, 0x6e1a046caf5b4a57f4fd4bc173622126b4e2fd86, 0x84008a72f8036f3feba542e35078c057f32a8825, 0x246291165b59332df5f18ce5c98856fae95897d6, 0x7e99dfbe989d3ba529d19751b7f4317f8953a3e2, 0x748c285ef1233fe4d31c8fb1378333721c12e27a, 0x3dd12e556a603736feba4a6fa8bd4ac45d662a04, 0xd0ae735d915e946866e1fea77e5ea466b5cadd16, 0x4f767bc8794aef9a0a38fea5c81f14694ff21a13, 0x0e2f8e28a681f77c583bd0ecde16634bdd7e00cd, 0xd74a6e8d6aab34ce85976814c1327bd6ea0784d2, 0x629be7ab126a5398edd6da9f18447e78c692a4fd, 0x2e46fcee6a3bb145b594a243a3913fce5dad6fba, 0xe39b11a8ab1ff5e22e5ae6517214f73c5b9b55dc, 0x119aa64d5b7d181dae9d3cb449955c89c1f963fa, 0xce079f51887774d8021cb3b575f58f18e9acf984, 0x550c306f81ef5d9580c06cb1ab201b95c748a691, 0x06dc7f18cee7edab5b795337b1df6a9e8bd8ae59, 0xe21c778ef2a0d7f751ea8c074d1f812243863e4e, 0x45d4b54d37a8cf599821235f062fa9d170ede8a4, 0x893a6c2eb8b40ab096b4f67e74a897b840746e86, 0xd44d81e18f46e2cfb5c1fcf5041bc8569767d100, 0xc5de1203d3cc2cea31c82ee2de5916880799eafd, 0x7f0f04fcf37a53a4e24ede6e93104e78be1d3c9e, 0x3ce1dc97fcd7b7c4d3a18a49d6f2a5c1b1a906d7, 0xac4ee9d502e7d2d2e99e59d8ca7d5f00c94b4dd6, 0x7640a37f8052981515bce078da93afa4789b5734, 0x76cac488111a4fd595f568ae3a858770fc915d5f, 0xff4a408f50e9e72146a28ce4fc8d90271f116e84, 0x249db29dbc19d1235da7298a04081c315742e9ac, 0x3a04572847d31e81f7765ca5bfc9d557159f3683, 0xb6771b0bf3427f9ae7a93e7c2e61ee63941fdb08, 0x30c26a8e971baa1855d633ba703f028cc7873140, 0x167e3e3ae2003348459392f7dfce44af7c21ad59, 0x43f16f1e75c3c06a9478e8c597a40a3cb0bf04cc, 0x056b1546894f9a85e203fb336db569b16c25e04f, 0x70616e2892fa269705b2046b8fe3e72fa55816d3, 0x8f4d1d41693e462cf982fd81d0aa701d3a5374c9, 0xc518799a5925576213e21896e0539abb85b05ae3, 0x0e3a28c1dfafb0505bdce19fe025f506a6d01ceb, 0xe4a47e3933246c3fd62979a1ea19ffdf8c72ef37, 0xd231929735132102471ba59007b6644cc0c1de3e, 0x555d8d3ce1798aca902754f164b8be2a02329c6c, 0x5ab1a5615348001c7c775dc75748669b8be4de14, 0x2fee36a49ee50ecf716f1047915646779f8ba03f, 0x54db5e06b4815d31cb56a8719ba33af2d73e7252, 0x7c8bb65a6fbb49bd413396a9d7e31053bbb37aa9, 0xc1384c6e717ebe4b23014e51f31c9df7e4e25b31, 0x474158a1a9dc693c133f65e47b5c3ae2f773a86f, 0x2934c0df7bbc172b6c186b0b72547ace8bf75454, 0x6966063aa5de1db5c671f3dd699d5abe213ee902, 0x9225d46a5a80943924a39e5b84b96da0ac450581, 0x671bbca099ff899bab07ea1cf86965c3054c8960, 0xf1f766b0e46d73fcd4d52e7a72e1b9190cc632b3, 0xef0dc7dd7a53d612728bcbd2b27c19dd4d7d666f, 0x38d2e9154964b41c8d50a7487d391e7ee2c3d3c2, 0x352a785f4a921632504ce5d015f83c49aa838d6d, 0x743de50026ca67c94df54f066260e1d14acc11ac, 0xb188078444027e386798a8ae68698919d5cc230d, 0x53608105ce4b9e11f86bf497ffca3b78967b5f96, 0x3b159099075207c6807663b1f0f7eda54ac8cce3, 0x141a5e39ee2f680a600fbf6fa297de90f3225cdd, 0x44fff37be01a3888d3b8b8e18880a7ddefeeead3, 0xc5a629a3962552cb8eded889636aafbd0c18ce65, 0xfdba5359f7ec3bc770ac49975d844ec9716256f1, 0x7c1df24a4f7fb2c7b472e0bb006cb27dcd164156, 0xab7d54c7c6570efca5b4b8ce70f52a5773e5d53b, 0x3f173aa6edf469d185e59bd26ae4236b92b4d8e1, 0xa3f4ad14e0bb44e2ce2c14359c75b8e732d37054, 0xac5f627231480d0d95302e6d89fc32cb1d4fe7e3, 0xd0775dba2af4c30a3a78365939cd71c2f9de95d2, 0xad94235fc3b3f47a2413af31e884914908ef0c45, 0xeaedcc6b8b6962d5d9288c156c579d47c0a9fcff, 0x7ac48d40c664cc9a6d89f1c5f5c80a1c70e744e6, 0xec73114c5e406fdbbe09b4fa621bd70ed54ea1ef, 0xa690f1a4b20ab7ba34628620de9ca040c43c1963, 0xcad14f9ebba76680eb836b079c7f7baaf481ed6d, 0x6c714a58fff6e97d14b8a5e305eb244065688bbd, 0x3e618350fa01657ab0ef3ebac8e37012f8fc2b6f, 0xc946d5acc1346eba0a7279a0ac1d465c996d827e, 0x1164caaa8cc5977afe1fad8a7d6028ce2d57299b, 0x7917e5bd82a9790fd650d043cdd930f7799633db, 0xd52aecc6493938a28ca1c367b701c21598b6a02e, 0x98bed3a72eccfbafb923489293e429e703c7e25b, 0x42db0b902559e04087dd5c441bc7611934184b89, 0x43bc2d4ddcd6583be2c7bc094b28fb72e62ba83b, 0x85f0e7c1e3aff805a627a2aaf2cff6b4c0dbe9cb, 0x581b9fd6eae372f3501f42eb9619eec820b78a84, 0x541db20a80cf3b17f1621f1b3ff79b882f50def3, 0x4e8a6d63489ccc10a57f885f96eb04ecbb546024, 0x28349f7ef974ea55fe36a1583b34cec3c45065f0, 0xa3241d890a92baf52908dc4aa049726be426ebd3, 0xb4b11d109f608fa8edd3fea9f8c315649aeb3d11, 0x5f321b3daaa296cadf29439f9dab062a4bffedd6, 0xc5ae86b0c6c7e3900f1368105c56537faf8d743e, 0x9a8eca4189ff4aa8ff7ed4b6b7039f0902219b15, 0xa3facc50195c0b4933c85897fecc5bbd995c34b8, 0xf07bd0e5c2ce69c7c4a724bd26bbfa9d2a17ca03, 0x640aba6de984d94517377803705eaea7095f4a11, 0x204ac98867a7c9c7ed711cb82f28a878caf69b48, 0x9d34dac25bd15828faefaaf28f710753b39e89dc, 0xfe418b421a9c6d373602790475d2303e11a75930, 0x3f472963197883bbda5a9b7dfcb22db11440ad31, 0x1578bdbc371b4d243845330556fff2d5ef4dff67, 0xdba4796d0ceb4d3a836b84c96f910afc103f5ba0, 0x466fda6b9b58c5532750306a10a2a8c768103b07, 0x2770f14efb165ddeba79c10bb0af31c31e59334c, 0x7c382c0296612e4e97e440e02d3871273b55f53b, 0x1fb7bd310d95f2a6d9baaf8a8a430a9a04453a8b, 0xa9acf600081bb55bb6bfbab1815ffc4e17e85a95, 0xf93d5bcb0644b0cce5fcdda343f5168ffab2877d, 0xdb0cc78f74d9827bdc8a6473276eb84fdc976212, 0xb66411e3a02dedb726fa79107dc90bc1cae64d48, 0x4d6e8fe109ccd2158e4db114132fe75fecc8be5b, 0x6fd947d5a73b175008ae6ee8228163da289b167d, 0x32d950d5e93ea1d5b48db4714f867b0320b31c0f, 0x9c99b62606281b5cefabf36156c8fe62839ef5f3, 0x86c8d0d982b539f48f9830f9891f9d607a942659, 0xf2127d54188fedef0f338a5f38c7ff73ad9f6f42, 0xe864fec07ed1214a65311e11e329de040d04f0fd, 0x1d09ad2412691cc581c1ab36b6f9434cd4f08b54, 0x4ea70f04313fae65c3ff224a055c3d2dab28dddf, 0xe0668fa82c14d6e8d93a53113ef2862fa81581bc, 0xf0d858105e1b648101ac3f85a0f8222bf4f81d6a, 0x0f3a1023cac04dbf44f5a5fa6a9cf8508cd4fddf, 0x5793abe6f1533311fd51536891783b3f9625ef1c, 0x8d667637e29eca05b6bfbef1f96d460eefbf9984, 0xd76dbaebc30d4ef67b03e6e6ecc6d84e004d502d, 0x42d1a6399b3016a8597f8b640927b8afbce4b215, 0x21fd47c5256012198fa5abf131c06d6aa1965f75, 0x2f2bba1b1796821a766fce64b84f28ec68f15aea, 0xd24bf12d2ddf457decb17874efde2052b65cbb49, 0x88de13b09931877c910d593165c364c8a1641bd3, 0x555ca9f05cc134ab54ae9bea1c3ff87aa85198ca, 0xae9ecd6bdd952ef497c0050ae0ab8a82a91898ce, 0xad8bfef8c68a4816b3916f35cb7bfcd7d3040976, 0xdad136b88178b4837a6c780feba226b98569a94c, 0x800e7d631c6e573a90332f17f71f5fd19b528cb9, 0x94a9a71691317c2064271b51c9353fbded3501a8, 0x80a0f6cc186cf6201400736e065a391f52a9df4a, 0x712ff7370a13ed360973fedc9ff5d2c93a505e9e, 0x42399659aca6a5a863ea2245c933fe9a35b7880e, 0xae239acffd4ebe2e1ba5b4170572dc79cc6533ec, 0x007b9fc31905b4994b04c9e2cfdc5e2770503f42, 0x7480de62254f2ba82b578219c07ba5be430dc3cb, 0x917b8f9f3a8d09e9202c52c29e724196b897d35e, 0x708ea707bae4357f1ebea959c3a250acd6aa21b3, 0x6dc7053a718616cfc78bee6382ee51add0c70330, 0xc4dac5a8a0264fbc1055391c509cc3ee21a6e04c, 0xc1b2a0fb9cad45cd699192cd27540b88d3384279, 0xb07cb9c12405b711807543c4934465f87f98bd2d, 0xc7f72bb758016b374714d4899bce22b4aec70a31, 0x0c480de9f7461002908b49f60fc61e2b62d3140b, 0x83d532d38d6dee3f60adc68b936133c7a2a1b0dd, 0x12afbcba1427a6a39e7ba4849f7ab1c4358ac31b, 0xf8f6645e0dee644b3dad81d571ef9baf840021ad, 0x40cf890591eae4a18f812a2954cb295f633327e6, 0x735b97f2fc1bd24b12076efaf3d1288073d20c8c, 0x47c7e5efb48b3aed4b7c6e824b435f357df4c723, 0xd34d708d7398024533a5a2b2309b19d3c55171bb, 0x64370e87202645125a35b207af1231fb6072f9a7, 0xb055af4cadfcfdb425cf65ba6431078f07ecd5ab, 0xc7de5e8eafb5f62b1a0af2195cf793c7894c9268, 0xc63cd7882118b8a91e074d4c8f4ba91851303b9a, 0x164d7aac3eecbaeca1ad5191b753f173fe12ec33, 0xe4fb26d1ca1eecba3d8298d9d148119ac2bbf580, 0x613ac53be565d46536b820715b9b8d3ae68a4b95, 0x7f616c6f008adfa082f34da7d0650460368075fb, 0x9af100cc3dae83a33402051ce4496b16615483f6, 0xb45cca0d36826662683cf7d0b2fdac687f02d0c4, 0x93a6b3ab423010f981a7489d4aad25e2625c5741, 0xee049af005974dd1c7b3a9ca8d9aa77175ba53aa, 0x687927e3048bb5162ae7c15cf76bd124f9497b9e, 0x1aa40270d21e5cde86b6316d1ac3c533494b79ed, 0x426259b0a756701a8b663528522156c0288f0f24, 0x91c75e3cb4aa89f34619a164e2a47898f5674d9c, 0x437983388ab59a4ffc215f8e8269461029c3f1c1, 0x272a131a5a656a7a3aca35c8bd202222a7592258, 0xbc0ca4f217e052753614d6b019948824d0d8688b, 0xcc6c03bd603e09de54e9c4d5ac6d41cbce715724, 0xd79aff13ba2da75d46240cac0a2467c656949823, 0x477b24eee8839e4fd19d1250bd0b6645794a61ca, 0x79fd6d48315066c204f9651869c1096c14fc9781, 0x1463a873555bc0397e575c2471cf77fa9db146e0, 0x89ab13ee266d779c35e8bb04cd8a90cc2103a95b, 0x90acced7e48c08c6b934646dfa0adf29dc94074f, 0x31ea6eab19d00764e9a95e183f2b1b22fc7dc40f, 0x87a53ea39f59a35bada8352521645594a1a714cb, 0x1e1aed85b86c6562cb8fa1eb6f8f3bc9dcae6e79, 0xe36a8ea87f1e99e8a2dc1b2608d166667c9dfa01, 0xec2cb8b9378dff31aec3c22e0e6dadff314ab5dd, 0x3cadeb3d3eed3f62311d52553e70df4afce56f23, 0x3ceca96bb1cdc214029cbc5e181d398ab94d3d41, 0x3283eb7f9137dd39bed55ffe6b8dc845f3e1a079, 0x0954a8cb5d321fc3351a7523a617d0f58da676a7, 0xde33d708a3b89e909eaf653b30fdc3a5d5ccb4b3, 0x1c6702b3b05a5114bdbcaeca25531aeeb34835f4, 0xe5b96fc9ac03d448c1613ac91d15978145dbdfd1, 0xfbf204c813f836d83962c7870c7808ca347fd33e, 0x3b13631a1b89cb566548899a1d60915cdcc4205b, 0xa87f7abd6fa31194289678efb63cf584ee5e2a61, 0xc0a39308a80e9e84aaaf16ac01e3b01d74bd6b2d, 0xffd6da958eecbc016bab91058440d39b41c7be83, 0x0e3dd7d4e429fe3930a6414035f52bdc599d784d, 0xe0663e8cd66792a641f56e5003660147880f018e, 0x5b78eca27fbdea6f26befba8972b295e7814364b, 0xec9851bd917270610267d60518b54d3ca2b35b17, 0xbc9c95dfab97a574cea2aa803b5caa197cef0cff, 0x100b4d0977fcbad4debd5e64a0497aeae5168fab, 0x1b6610fb68bad6ed1cfaa0bbe33a24eb2e96fafb, 0xb4524c95a7860e21840296a616244019421c4aba, 0x88975a5f1ef2528c300b83c0c607b8e87dd69315, 0x853e6abaf44469c72f151d4e223819aced4e3728, 0xd604abce4330842e3d396ca73ddb5519ed3ec03f, 0xd209482bb549abc4777bea6d7f650062c9c57a1c, 0x590acbda37290c0d3ec84fc2000d7697f9a4b15d, 0x571950ea2c90c1427d939d61b4f2de4cf1cfbfb0, 0xcb94e76febe208116733e76e805d48d112ec9fca, 0xfa8e3b1f13433900737daaf1f6299c4887f85b5f, 0x162d76c2e6514a3afb6fe3d3cb93a35c5ae783f1, 0x4bea288eea42c4955eb9faad2a9faf4783cbddac, 0xc8ab1a3cf46cb8b064df2e222d39607394203277, 0x318b2ea5f0aaa879c4d5e548ac9d92a0c67487b7, 0x53c5fe0119e1e848640cee30adea96940f2a5d8b, 0x0701f9f147ec486856f5e1b71de9f117e99e2105, 0x337cfe1157a5c6912010dd561533791769c2b6a6, 0xfd60d2b5af3d35f7aaf0c393052e79c4d823d985, 0x0f049a8bdfd761de8ec02cee2829c4005b23c06b, 0x924bce7a853c970bb5ec7bb759baeb9c7410857b, 0x16abb8b021a710bdc78ea53494b20614ff4eafe8, 0x9e7f65a90e8508867bccc914256a1ea574cf07e3, 0x01d03815c61f416b71a2610a2daba59ff6a6de5b, 0x3df762049eda8ac6927d904c7af42f94e5519601, 0x5593c9d4b664730fd93ca60151c25c2eaed93c3b, 0xe023f09b2887612c7c9cf1988e3a3a602b3394c9, 0x4c13980c32dcf3920b78a4a7903312907c1b123f, 0xa282e969cac9f7a0e1c0cd90f5d0c438ac570da3, 0x3b22da2a0271c8efe102532773636a69b1c17e09, 0x1aa1021f550af158c747668dd13b463160f95a40, 0xf15178ffc43aa8070ece327e930f809ab1a54f9d, 0xdb1293a506e90cad2a59e1b8561f5e66961a6788, 0x88c361640d6b69373b081ce0c433bd590287d5ec, 0x3737216ee91f177732fb58fa4097267207e2cf55, 0xa16d9e3d63986159a800b46837f45e8bb980ee0b, 0xec76f12e57a65504033f2c0bce6fc03bd7fa0ac4, 0xd9f1b26408f0ec67ad1d0d6fe22e8515e1740624, 0x716ba01ead2a91270635f95f25bfaf2dd610ca23, 0x42a98bf16027ce589c4ed2c95831e2724205064e, 0x0f88aac9346cb0e7347fba70905475ba8b3e5ece, 0x2d8c52329f38d2a2fa9cbaf5c583daf1490bb11c, 0x3cea302a472a940379dd398a24eafdbadf88ad79, 0xa29d5bda74e003474872bd5894b88533ff64c2b5, 0x2d23766b6f6b05737dad80a419c40eda4d77103e, 0xb07249e055044a9155359a402937bbd954fe48b6, 0xf1e980c559a1a8e5e50a47f8fffdc773b7e06a54, 0x8275cd684c3679d5887d03664e338345dc3cdde1, 0xb27c1a24204c1e118d75149dd109311e07c073ab, 0x451b3699475bed5d7905f8905aa3456f1ed788fc, 0x31ad4d9946ef09d8e988d946b1227f9141901736, 0x52b8a9592634f7300b7c5c59a3345b835f01b95c, 0xb161725fdcedd17952d57b23ef285b7e4b1169e8, 0x74fc5a99c0c5460503a13b0509459da19ce7cd90, 0xd99df7421b9382e42c89b006c7f087702a0757c0, 0x8a4f4a7f52a355ba105fca2072d3065fc8f7944b, 0x12316fc7f178eac22eb2b25aedeadf3d75d00177, 0xf598db2e09a8a5ee7d720d2b5c43bb126d11ecc2, 0x37b8beac7b1ca38829d61ab552c766f48a10c32f, 0x851dc38adb4593729a76f33a8616dab6f5f59a77, 0xbf4096bc547dbfc4e74809a31c039e7b389d5e17, 0x98d3731992d1d40e1211c7f735f2189afa0702e0, 0x0f4073c1b99df60a1549d69789c7318d9403a814, 0xa430995ddb185b9865dbe62539ad90d22e4b73c2, 0x898c72dd736558ef9e4be9fdc34fef54d7fc7e08, 0xf9b617f752edecae3e909fbb911d2f8192f84209, 0xe1ae029b17e373cde3de5a9152201a14cac4e119, 0xd8e8474292e7a051604ca164c0707783bb2885e8, 0xf476f2cb7208a32e051fd94ea8662992638287a2, 0x3a84e950ed410e51b7e8801049ab2634b285fea1, 0x5b7784caea01799ca30227827667ce207c5cbc76, 0x3af65b3e28895a4a001153391d1e69c31fb9db39, 0x95fb5afb14c1ef9ab7d179c5c300503fd66a5ee2, 0xa8446c4781a737ac4328b1e15b8a0b3fbb0fd668, 0x4888fb25cd50dbb9e048f41ca47d78b78a27c7d9, 0x566c10d638e8b88b47d6e6a414497afdd00600d4, 0xbd47f5f76e3b930fd9485209efa0d4763da07568, 0x1e1c6351776ac31091397ecf16002d979a1b2d51, 0xedf603890228d7d5de9309942b5cad4219ef9ad7, 0x1923cfc68b13ea7e2055803645c1e320156bd88d, 0x8f8f37d0ad8f335d2a7101b41156b688a81a9cbe, 0x63334fcf1745840e4b094a3bb40bb76f9604c04c, 0x001762430ea9c3a26e5749afdb70da5f78ddbb8c, 0x512116817ba9aaf843d1507c65a5ea640a7b9eec, 0x2961fb391c61957cb5c9e407dda29338d3b92c80, 0xfc2952b4c49fedd0bc0528a308495e6d6a1c71d6, 0x13ec812284026e409bc066dfebf9d5a4a2bf801e, 0xef463c2679fb279164e20c3d2691358773a0ad95, 0x3aadf98b61e5c896e7d100a3391d3250225d61df, 0xe8137fc1b2ec7cc7103af921899b4a39e1d959a1, 0xb1a2b43a7433dd150bb82227ed519cd6b142d382, 0xc1f39bd35dd9cec337b96f47c677818160df37b7, 0xb587b44a2ca79e4bc1dd8bfdd43a207150f2e7e0, 0x41485612d03446ec4c05e5244e563f1cbae0f197, 0xa12623e629df93096704b16084be2cd89d562da4, 0x3f2f381491797cc5c0d48296c14fd0cd00cdfa2d, 0x9470cc36594586821821c5c996b6edc83b6d5a32, 0x3605372d93a9010988018f9f315d032ed1880fa1, 0x12632388b2765ee4452b50161d1fffd91ab81f4a, 0x274a3d771a3d709796fbc4d5f48fce2fe38c79d6, 0xd60a52580728520df7546bc1e283291788dbae0c, 0x1ab53a11bcc63ddfaa40a02b9e186496cdbb8aff, 0xc282e6993fbe7a912ea047153ffd9274270e285b, 0xa291e9c7990d552dd1ae16cebc3fca342cbaf1d1, 0x5547fdb4ae11953e01292b7807fa9223d0e4606a, 0xbded11612fb5c6da99d1e30e320bc0995466141e, 0xb73b4ff99eb88fd89b0b6d57a9bc338e886fa06a, 0xb1c751786939bba0d671a677a158c6abe7265e46, 0xe881bbbe69722d81efecaa48d1952a10a2bfac8f, 0xfe96c4cd381562401aa32a86e65b9d52fa8aee27, 0x683dba36f7e94f40ea6aea0d79b8f521de55076e, 0x5ac2908b0f398c0df5bac2cb13ca7314fba8fa3d, 0x8914a680a5aec5226d4baaec2e5552b44dd7c874, 0x041170f581de80e58b2a045c8f7c1493b001b7cb, 0x4665e47396c7db97eb2a03d90863d5d4ba319a94, 0xed4be04a052d7accb3dcce90319dba4020ab2c68, 0x4b0619d9d8aa313a9531ac7dbe04ca0d6a5ad1b6, 0xa21442ab05340ade68c915f3c3399b9955f3f7eb, 0x655934da8e744eaa3de34dbbc0894c4eda0b61f2, 0x6038740ae28d66ba93b0be08482b3205a0f7a07b, 0x99924a9816bb7ddf3fec1844828e9ad7d06bf4e6, 0x6847825bdee8240e28042c83cad642f286a3bddc, 0xa718aaad59bf395cba2b23e09b02fe0c89816247, 0x2c89f5fdca3d155409b638b98a742e55eb4652b7, 0x1a7044e2383f8708305b495bd1176b92e7ef043a, 0x282e80a554875a56799fa0a97f5510e795974c4e, 0xffb3bcc3196a8c3cb834cec94c34fed35b3e1054, 0xd135794b149a18e147d16e621a6931f0a40a969a, 0x6b94615db750656ac38c7e1cf29a9d13677f4e15, 0xecbe425e670d39094e20fb5643a9d818eed236de, 0x511e0efb04ac4e3ff2e6550e498295bfcd56ffd5, 0xff65511cada259260c1ddc41974ecaecd32d6357, 0x9ffc5fe06f33f5a480b75aa94eb8556d997a16c0, 0x57df23bebdc65eb75feb9cb2fad1c073692b2baf, 0x207ef80b5d60b6fbffc51f3a64b8c72036a5abbd, 0xc573e841fa08174a208b060ccb7b4c0d7697127f, 0x411610b178d5617dfab934d293f512a93e5c10e1, 0x9991614c5baa47dd6c96874645f97add2c3d8380, 0x2d3480bf0865074a72c7759ee5137b4d70c51ce9, 0x9d40e012f60425a340d82d03a1c757bfabc706fb, 0x47648bed01f3cd3249084e635d14daa9e7ec3c8a, 0xa5ff62222d80c013cec1a0e8850ed4d354dac16d, 0xf80d3619702fa5838c48391859a839fb9ce7160f, 0x7c0f5e072043c9ee740242197e78cc4b98cdf960, 0xa40aa2bbce0c72b4d0dfffcc42715b2b54b01bfa, 0x2eeed50471a1a2bf53ee30b1232e6e9d80ef866d, 0x0c2808b951ed9e872d7b32790fcc5994ae41ffdc, 0x7f06c89d59807fa60bc60136fcf814cbaf2543bd, 0x8d4b603c5dd4570c34669515fdcc665890840c77, 0xd5e5c135d0c4c3303934711993d0d16ff9e7baa0, 0x241361559feef80ef137302153bd9ed2f25db3ef, 0xdb63122de7037da4971531fae9af85867886c692, 0x417e4e2688b1fd66d821529e46ed4f42f8b3db3d, 0x127db1cadf1b771cbd7475e1b272690f558c8565, 0x48659d8f8c9a2fd44f68daa55d23a608fbe500dc, 0xb3a64b1176724f5409e1414a3523661baee74b4a, 0xaa14422d6f0ae5a758194ed15780c838d67f1ee1, 0xa0a0e65204541fca9b2fb282cd95138fae16f809, 0xd2107b353726c3a2b46566eaa7d9f80b5d21dbe3, 0xe4cafb727fb5c6b70bb27533b8a9ccc9ef6888e1, 0x09f3f601f605441140586ce0656fa24aa5b1d9ae, 0x87fcbe7c4193ffcb08143779c9bec83fe7fda9fc, 0x03ebc63fda6660a465045e235fbe6e5cf195735f, 0xbdbaf6434d40d6355b1e80e40cc4ab9c68d96116, 0x4e2225a1bb59bc88a2316674d333b9b0afca6655, 0x4dc3da13b2b4afd44f5d0d3189f444d4ddf91b1b, 0x4ba8e0117fc0b6a3e56b24a3a58fe6cef442ff98, 0x27146913563aa745e2588430d9348e86ea7c3510, 0x4c5afe40f18ffc48d3a1aec41fc29de179f4d297, 0x8a810114b2025db9fbb50099a6e0cb9e2efa6bdc, 0x2dee90a28f192d676a8773232b56f18f239e2fad, 0x60676e92d18b000509c61de540e6c5ddb676d509, 0x9bfc659c9c601ea42a6b21b8f17084ec87d70212, 0x5d5d6e821c6eef96810c83c491468560ef70bfb5, 0xd5787668c2c5175b01a8ee1ac3ecc9c8b2aba95a, 0x33b336f5ba5edb7b1ccc7eb1a0d984c1231d0edc, 0x3abb8adfc604f48d5984811d7f1d52fef6758270, 0x980a84b686fc31bdc83c221058546a71b11f838a, 0x0b507cf553568daaf65504ae4eaa17a8ea3cdbf5, 0x896009526a2c7b0c09a6f63a80bdf29d9c87de9c, 0x9696052138338c722f1140815cf7749d0d3b3a74, 0x3831757eae7557cb8a37a4b10644b63e4d3b3c75, 0x62dc72729024375fc37cbb9c7c2393d10233330f, 0x44098866a69b68c0b6bc168229b9603587058967, 0x25adb8f96f39492c9bb47c5edc88624e46075697, 0xfd4de8e3748a289cf7d060517d9d38388db01fb8, 0x6be7595ea0f068489a2701ec4649158ddc43e178, 0xd402b4f6a099ebe716cb14df4f79c0cd01c6071b, 0xa07682000b1bcf3002f85c80c0fa2949bd1e82fd, 0xeb4f00e28336ea09942588eeac921811c522143c, 0x8f31c7005197ec997a87e69bec48649ab94bb2a5, 0xe7fd8fd959aed2767ea7fa960ce1db53af802573, 0xa8ef9ad274436042903e413c3b0c62f5f52ed584, 0xd83ad260e9a6f432fb6ea28743299b4a09ad658c, 0xb5c816a8283ca4df68a1a73d63bd80260488df08, 0xd7d3c75920590438b82c3e9515be2eb6ed7a8b1a, 0xaf3cb5965933e7dad883693b9c3e15beb68a4873, 0x6e899e59a9b41ab7ea41df7517860f2acb59f4fd, 0x527a8ca1268633a6c939c5de1b929aee92aeac8d, 0x1680cec5021ee93050f8ae127251839e74c1f1fd, 0xff7843c7010aa7e61519b762dfe49124a76b0e4e, 0x140fba58dbc04803d84c2130f01978f9e0c73129, 0x0261ad3a172abf1315f0ffec3270986a8409cb25, 0xab5a79016176320973e8cd38f6375530022531c0, 0xfca73eff8771c0103ba3cc1a9c259448c72abf0b, 0x07d41217badca5e0e60327d845a3464f0f27f84a, 0x2c1c19114e3d6de27851484b8d2715e50f8a1065, 0xabd21eff954fc6a7de26912a7cbb303a6607804e, 0xf303d5a816affd97e83d9e4dac2f79072bb0098f, 0x114cfefe50170dd97ae08f0a44544978c599548d, 0x647b85044df2cf0b4ed4882e88819fe22ae5f793, 0x1b130d6fa51d5c48ec8d1d52dc8a227be8735c8a, 0x0d9d3f9bc4a4c6efbd59679b69826bc1f63d9916, 0xc765e00476810947816af142d46d2ee7bca8cc4f, 0xb57b04fa23d1203fae061eac4542cb60f3a57637, 0xe192489b85a982c1883246d915b229cb13207f38, 0x5f483ffb8f680aedf2a38f7833afdcde59b61e4b, 0xb46d1182e5aacaff0d26b2fcf72f3c9ffbcdd97d, 0x59c7f785c93160e5807ed34e5e534bc6188647a7, 0x18e4ce47483b53040adbab35172c01ef64506e0c, 0x296d66b521571a4e4103a7f562c511e6aa732d81, 0xbcd99edc2160f210a05e3a1fa0b0434ced00439b, 0xf14f0eb86db0eb68753f16918e5d4b807437bd3e, 0x60d5667140d12614b21c8e5e8a33082e32dfcf23, 0x8ccabf25077f3aa41545344d53be1b2b9c339000, 0x8cc0d7c016fa7aa950114aa1db094882eda274ea, 0xc71145e529c7a714e67903ee6206e4c3042b6727, 0xc5e9939334f1252ed2ba26814487dfd2982b3128, 0xf09b3e87f913ddfd57ae8049c731dba9b636dfc3, 0x4349225a62f70aea480a029915a01e5379e64fa5, 0x666b4f37d55d63b7d056b615bb74c96b3b01991a, 0x8bd6b1c6d74d010d1008dba6ef835d4430b35c32, 0x7363cd90fbab5bb8c49ac20fc62c398fe6fb744c, 0xb7479dab5022c4d5dbaaf8de171b4e951dd1a457, 0x5a5468fa5ca226c7532ecf06e1bc1c45225d7ec9, 0x32a20d028e2c6218b9d95b445c771524636a22ef, 0x1bd28cd5c78aee51357c95c1ef9235e7c18bc854, 0x693492a5c51396a482881669ccf6d8d779f00951, 0xbd723b289a7367b6ece2455ed61edb49670ab9c4, 0x1be3542c3613687465f15a70aeeb81662b65cca8, 0x5803e68b34da121aef08b602badbafb4d12481ca, 0x9ac907ee85e6f3e223459992e256a43fa08fa8b2, 0x833b6a8ec8da408186ac8a7d2a6dd61523e7ce84, 0x64628c6fb8ec743adbd87ce5e018d531d9210437, 0x566c28e34c3808d9766fe8421ebf4f2b1c4f7d77, 0x171ad9a04bedc8b861e8ed4bddf5717813b1bb48, 0x4f85bc1fc5cbc9c001e8f1372e07505370d8c71f, 0x6d2f976734b9d0070d1883cf7acab8b3e4920fc1, 0x357a02c0a9dfe287de447fb67a70ec5b62366647, 0x44a01fb04ac0db2cce5dbe281e1c46e28b39d878, 0x3630c5e565ceaa8a0f0ffe32875eae2a6ce63c19, 0x334340ee4b9cdc81f850a75116d50ee9b69825bf, 0xc0afb7d8b79370cfd663c68cc6b9702a37cd9eff, 0x2016895df32c8ed5478269468423aea7b7fbce50, 0x1e2fe4e4a77d141ff49a0c7fbc95b0a2b283eeeb, 0x260df8943a8c9a5dba7945327fd7e0837c11ad07, 0x32fbeed6f626fcdfd51acafb730b9eeff612f564, 0x9bd88068e13075f3a8cac464a5f949d6d818c0f6, 0xab4572fbb1d72b575d69ec6ad17333873e8552fc, 0xe44ea51063405154aae736be2bf1ee3b9be639ae, 0x617f20894fa70e94a86a49cd74e03238f64d3cd9, 0x3e914e3018ac00449341c49da71d04dfeeed6221, 0x590181d445007bd0875aaf061c8d51153900836a, 0x27987110221a880826adb2e7ab5eca78c6e31aec, 0x06618e9d5762df62028601a81d4487d6a0ecb80e, 0x8cc652dd13e7fe14dabbb36d5d320db9ffee8a54, 0x8973aefd5efaee96095d9e288f6a046c97374b43, 0xdbd51cdf2c3bfacdff106221de2e19ad6d420414, 0x25697ef20cccaa70d32d376f8272d9c1070c3d78, 0x0726c42e00f45404836eb1e280d073e7059687f5, 0x5e0785532c7723e4c0af9357d5274b73bdddddde, 0x38430e931d93be01b4c3ef0dc535f1e0a9610063, 0x143d536b8b1cb84f56a39e0bc81fd5442bcacce1, 0x5c6d041da7af4487b9dc48e8e1f60766d0a56dbc, 0xf9bfb59d538afc4874d4f5941b08c9730e38e24b, 0x83dbfd8eda01d0de8e158b16d0935fc2380a5dc7, 0x0e6cd664ad9c1ed64bf98749f40644b626e3792c, 0xce2e0da8934699bb1a553e55a0b85c169435bea3, 0xa39bfee4aec9bd75bd22c6b672898ca9a1e95d32, 0x1bc44c8761231ba1f11f5faa40fa669a013e12ce, 0x68809af5d532a11c1a4d6e32aac75c4c52b08ead, 0x80cc21bd99f39005c58fe4a448909220218f66cb, 0x1080c1d8358a15bc84dac8253c6883319020df2c, 0x9eaf6a328a4076024efa6b67b48b21eedcc0f0b8, 0x1e7b5e4d1f572becf2c00fc90cb4767b4a6e33d4, 0xacbd185589f7a68a67aa4b1bd65077f8c64e4e21, 0xff78541756ab2b706e0d70b18adb700fc4f1643d, 0x7f0ec3db804692d4d1ea3245365aab0590075bc4, 0x4a918032439159bb315b6725b6830dc83697739f, 0xbc1b021a78fde42d9b5226d6ec26e06aa3670090, 0x2f2523cc834f0086052402626296675186a8e582, 0x9db2e15ca681f4c66048f6f9b7941ed08b1ff506, 0x20b9a9e6bd8880d9994ae00dd0b9282a0beab816, 0x3bddbc8134f77d55597fc97c26d26698090604eb, 0x80c3a9f695b16db1597286d1b3a8b7696c39fa27, 0x53194d8afa3e883502767edbc30586af33b114d3, 0xe2efd0a9bc407ece03d67e8ec8e9d283f48d2a49, 0x1cb450920078aab2317c7db3b38af7dd298b2d41, 0xca8276c477b4a07b80107b843594189607b53bec, 0x147f4210ab5804940a0b7db8c14c28396b62a6bf, 0xd3df3b53cb3b4755de54e180451cc44c9e8ae0aa, 0xf7c708015071d4fb0a3a2a09a45d156396e3349e, 0xa8cafac32280d021020bf6f2a9782883d7aabe12, 0x399aa6f5d078cb0970882bc9992006f8fbdf3471, 0x15669180dee29598869b08a721c7d24c4c0ee63f, 0xbba8ab22d2fedbcfc63f684c08afdf1c175090b5, 0x5e5a441974a83d74c687ebdc633fb1a49e7b1ad7, 0x98b769cc305cecfb629a00c907069d7ef9bc3a12, 0xc820c711f07705273807aaaa6de44d0e4b48be2e, 0x12aa7d86ddfbad301692feac8a08f841cb215c37, 0x6ff5d361b52ad0b68b1588607ec304ae5665fc98, 0x2382a9d48ec83ea3652890fd0ee79c907b5b2dc1, 0xb2a144b1ea67b9510f2267f9da39d3f93de26642, 0xb3e20eb4de18bd060221689894bee5aeb25351ee, 0x101a0a64f9afcc448a8a130d4dfcbee89537d854, 0x1b826fb3c012b0d159e294ba5b8a499ff3c0e03c, 0xaafb7b013aa1f8541c7e327bf650adbd194c208f, 0x96eb523e832f500a017de13ec27f5d366c560eff, 0xc7bf17c4c11f98941f507e77084fffbd2dbd3db5, 0x840ec83ea93621f034e7bb3762bb8e29ded4c479, 0x0e9c511864a177f49be78202773f60489fe04e52, 0xf6f1a44309051c6b25e47dff909b179bb9ab591c, 0x63fe6bcc4b8a9850abbe75803730c932251f145b, 0xf88b58db37420b464c0be88b45ee2b95290f8cfa, 0x9d4d321177256ebd9afbda304135d517c3dc5693, 0x8c1fbe5f0aea359c5aa1fa08c8895412ca8e05a6, 0xcb0dd7cf4e5d8661f6028943a4b9b75c914436a7, 0xa3979a92760a135adf69d72f75e167755f1cb8c3, 0xca22cda3606da5cad013b8074706d7e9e721a50c, 0x157559adc55764cc6df79323092534e3d6645a66, 0x4f52ad6170d25b2a2e850eadbb52413ff2303e7f, 0xeed28c3f068e094a304b853c950a6809ebcb03e0, 0x2e47f287f498233713850d3126823cc67dcee255, 0x6c359e58a13d4578a9338e335c67e7639f5fb4d7, 0x4968a2cedb457555a139295aea28776e54003c87, 0x4041374b0feef4792e4b33691fb86897a4ff560c, 0x83e48055327c28b5936fd9f4447e73bdb2dd3376, 0x32b7feebc5c59bf65e861c4c0be42a7611a5541a, 0x21a6db6527467bc6dad54bc16e9fe2953b6794ed, 0xe8ead1bb90ccc3aea2b0dcc5b58056554655d1d5, 0x7a94b19992ceb8ce63bc92ee4b5aded10c4d9725, 0x90e93e4dc17121487952333614002be42356498e, 0xaab00abf5828d7ebf26b47ceaccdb8ba03325166, 0x0a9ab2638b1cfd654d25dab018a0aebddf85fd55, 0xb12ed07b8a38ad5506363fc07a0b6d799936bdaf, 0xf4a9d00cefa97b7a58ef9417fc6267a5069039ee, 0x04a1cada1cc751082ff8da928e3cfa000820a9e9, 0x9018cc1f48d2308e252ab6089fb99a7c1d569410, 0x895d694e880b13ccd0848a86c5ce411f88476bbf, 0x40a7f72867a7dc86770b162b7557a434ed50cce9, 0x467ea10445827ef1e502daf76b928a209e0d4032, 0x7553aa23b68aa5f57e135fe39fdc235eaca8c98c, 0x31b43b015d0081643c6cda46a7073a6dfdbca825, 0xd82fd9fdf6996bedad2843159c06f37e0924337d, 0x24a4eb36a7e498c36f99975c1a8d729fd6b305d7, 0x91d66ea6288faa4b3d606c2aa45c7b6b8a252739, 0x83a402438e0519773d5448326bfb61f8b20cf52d, 0xc2fafdd30acb6d6706e9293cb02641f9edbe07b5, 0x79dba256472db4e058f2e4cdc3ea4e8a42773833, 0x498abdeb14c26b7b7234d70fceaef361a76dff72, 0x7b73242d75ca9ad558d650290df17692d54cd8b8, 0x6ec3659571b11f889dd439bcd4d67510a25be57e, 0xab098633eeee0ccefdf632f9575456f6dd80fc86, 0xf4a51fce4a1d5b94b0718389ba4e7814139ca738, 0x8f561b41b209f248c8a99f858788376250609cf3, 0x05d0f4d728ebe82e84bf597515ad41b60bf28b39, 0xdfdf43393c649caebe1bb18059decb39f09fb4e8, 0x0089508679abf8c71bf6781687120e3e6a84584d, 0x80907f593148b57c46c177e23d25abc4aae18361, 0x94fcceadfe5c109c5eaeaf462d43873142c88e22, 0xe89249738b7eced7cb666a663c49cbf6de8343ea, 0x23c99ba087448e19c9701df66e0cab52368331fa, 0xa68e0c30cba3bc5a883e540320f999c7cd558e5c, 0x88888a57bd9687cbf950aeeacf9740dcc4d1ef59, 0xe9b36fe9b51412ddca1a521d6e94bc901213dda8, 0xa9145046fa3628cf5fd4c613927be531e6db1fdd, 0xe82c58c579431b673546b53a86459acaf1de9b93, 0xbd6a474d66345bcdd707594adb63b30c7822af54, 0x6a6159074ab573e0ee581f0f3df2d6a594629b74, 0x2e7f465520ec35cc23d68e75651bb6689544a196, 0xac6d02e9a46b379fac4ac9b1d7b5d47bc850ce16, 0xbd59094e074f8d79142ab1489f148e32151f2089, 0x0ba6e46af25a13f57169255a34a4dac7ce12be04, 0x35145f620397c69cb8e00962961f0f4886643989, 0xd84b922f7841fc5774f00e14604ae0df42c8551e, 0x44232ff66ddad1fd841266380036afd7cf7d7f42, 0x516954025fca2608f47da81c215eedfd844a09ff, 0xe5aa0b833bb916dc19a8dd683f0ede241d988eba, 0x80ea1acc136eca4b68c842a95adf6b7fee7eb8a2, 0x98a0e54c6d9dc8be96276cebf4fec460f6235d85, 0x91620f3eb304e813d28b0297556d65dc4e5de5aa, 0x7bb984c6dbb9e279966afafda59c01d02627c804, 0x41f489a1ec747bc29c3e5f9d8db97877d4d1b4e9, 0x8dbc3e6cb433e194f40f82b40faadb1f8b856116, 0x889da40fb1b60f9ea9bd7a453e584cf7b1b4d9f7, 0xdebbdd831e0f20ae6e378252decdf92f7cf0c658, 0xa22ade0ddb5c6ef8d0cd8de94d82b11082cb2e91, 0x823219a25976bb2aa4af8bad41ac3526b493361f, 0x6d39a9e98f81f769d73aad2cead276ac1387babe, 0x751abcb6cc033059911815c96fd191360ab0442d, 0x64d80c3b8ba68282290b75e65d8978a15a87782c, 0x6ba8f7e25fc2d871618e24e40184199137f9f6aa, 0x25a74c2ac75dc8baa8b31a9c7cb4b7829b2456da, 0x0f7b61c59b016322e8226cafaee9d9e76d50a1b3, 0x7526e482529f0a14eec98871dddd0e721b0cd9a2, 0x071dd90d14d41f4ff7c413c24238d3359cd61a07, 0xa986762f7a4f294f2e0b173279ad2c81a2223458, 0xe667f652f957c28c0e66d0b63417c80c8c9db878, 0x7b98e23cb96beee80a168069ebba8f20edd55ccf, 0x2d8e5bb8d3521695c77e7c834e0291bfacee7408, 0xf23d01589eb12d439f7448ff54307529f191858d, 0xabd9605b3e91acfd777830d16463478ae0fc7720, 0xeabb90d37989aab31feae547e0e6f3999ce6a35d, 0x0abfb39b11486d79572866195ba26c630b6784db, 0xd56a144d7af0ae8df649abae535a15983aa04d02, 0x998c1f93bcdb6ff23c10d0dc924728b73be2ff9f, 0xbc62b3096a91e7dc11a1592a293dd2542150d751, 0x0c8f66c6017bce5b20347204b602b743bad78d60, 0x4c5b3dc0e2b9360f91289b1fe13ce12c0fbda3e1, 0xb44605552471a6eee4daab71ff3bb41326d473e0, 0xfc3d226bb36a58f526568857b0bb12d109ec9301, 0xadc8228ef928e18b2a807d00fb3c6c79cd1d9e96, 0x9df32a501c0b781c0281022f42a1293ffd7b892a, 0xe7da609d40cde80f00ce5b4ffb6aa9d0b03494fc, 0x9b64d3cd8d2b73f66841b5c46bb695b88a9ab75d, 0x8e9c08f738661f9676236eff82ba6261dd3f4822, 0xdeb97254474c0d2f5a7970dcdb2f52fb1098b896, 0xb4256273962bf631d014555cc1da0dcc31616b49, 0x23abd9e93e7957e5b636be6579051c15e5ce0b0e, 0x382591e7217b435e8e884cdbf415fe377a6fe29e, 0xf17adb740f45cbbde3094e7e13716f8103f563bd, 0x61ed5596c697207f3d55b2a51aa7d50f07fa09e8, 0x788e809741a3b14a22a4b1d937c82cfea489eebe, 0x992646ac1acaabf5ddaba8f9429aa6a94e7496a7, 0x51296f5044270d17707646129c86aad1645eadc1, 0x6ee8aad7e0a065d8852d7c3b9a6e5fdc4bf50c00, 0x30db6b9b107e62102f434a9dd0960c2021f5ce4c, 0x63fc93001305adfbc9b85d29d9291a05f8f1410b, 0xdf6ed6006a6abe886ed33d95a4de28fc12183927, 0x4745ab181a36aa8cbf2289d0c45165bc7ebe2381, 0x7bb0fdf5a663b5fba28d9c902af0c811e252f298, 0xe0ff0bd9154439c4a5b7233e291d7d868af53f33, 0x09261f9acb451c3788844f0c1451a35bad5098e3, 0x2813d263fc5ff2479e970595d6b6b560f8d6d6d1, 0x2cd19694d1926a0fa9189edebafc671cf1b2caa5, 0x05336e9a722728d963e7a1cf2759fd0274530fca, 0xe5b7af146986c0ff8f85d22e6cc334077d84e824, 0x3e4fbd661015f6461ed6735cefef01f31445de3a, 0x4f5df5b94357de948604c51b7893cddf6076baad, 0x9567a0de811de6ff095b7ee64e7f1b83c2615b80, 0x955db3b74360b9a268677e73cea821668af6face, 0x3e040d40cb80ba0125f3b15fdefcc83f3005da1b, 0x43f470ed659e2991c375957e5ddec5bd1d382231, 0x047f9bf1529daf87d407175e6f171b5e59e9ff3e, 0x15e3b584056b62c973cf5eb096f1733e54c15c91, 0xc03de42a109b657a64e92224c08dc1275e80d9b2, 0xe4fc13cfcbac1b17ce7783acd423a845943f6b3a, 0x65ff874fafce4da318d6c93d57e2c38a0d73e820, 0x8b997dbc078ad02961355da0a159f2927ed43d64, 0x2f5080b83f7e2dc0a1dd11b092ad042bff788f4c, 0x1b3920d001c43e72b24e7ca46f0fd6e0c20a5ff2, 0x5ade77fd81c25c0af713b10702768c1eb2f975e7, 0xacaaddcbf286cb0e215dda55598f7ff0f4ada5c6, 0x64e0217a5b38aa40583625967fa9883690388b6f, 0xae648155a658370f929be384f7e001047e49dd46, 0xf7c1b443968b117b5dd9b755572fcd39ca5ec04b, 0xde027efbb38503226ed871099cb30bdb02af1335, 0x49cf1e54be363106b920729d2d0ba46f0867989a, 0xe7f4d7fe6f561f7fa1da3005fd365451ad89df89, 0xb036916bdacf94b69e5a8a65602975eb026104dd, 0xe923c06177b3427ea448c0a6ff019b54cc548d95, 0xad927e03d1599a78ca2bf0cad2a183dceb71eac0, 0xef39ca9173df15531d73e6b72a684b51ba0f2bb4, 0x6443b8ae639de91cf73c5ae763eeeed3ddbb9253, 0x8026435aac728d497b19b3e7e57c28c563954f2b, 0xed327a14d5cfadd98103fc0999718d7ed70528ea, 0x38a3dccf2fcfe0c91a2624bd0cbf88ee4a076c33, 0xf0b1f9e27832c6de6914d70afc238c749995ace4, 0x770d98d31b4353fceee8560c4ccf803e88c0c4e0, 0xba1f0e03cb9aa021f4dcebfa94e5c889c9c7bc9e, 0x233842b1d0692fd11140cf5acda4bf9630bae5f8, 0xb5dd50a15da34968890a53b4f13fe1af081baaaa, 0x72072a0ef1cff3d567cdd260e708ddc11cbc9a31, 0x81a88196fac5f23c3e12a69dec4b880eb7d97310, 0x6c63f84556d290bfcd99e434ee9997bfd779577a, 0x5f167aa242bc4c189adecb3ac4a7c452cf192fcf, 0x445cb8de5e3df520b499efc980f52bff40f55c76, 0xaec27ce2133e82d052520afb5c576d9f7eb93ed2, 0x07dc2bf83bc6af19a842ffea661af5b41b67fda1, 0xfebd48d0ffdbd5656cd5e686363a61145228f279, 0xa86db07d9f812f4796622d40e03d135874a88a74, 0x5413c97ffa4a6e2a7bba8961dc9fce8530a787d7, 0xe2ff9ee4b6ecc14141cc74ca52a9e7a2ee14d908, 0x2e8eb30a716e5fe15c74233e039bfb1106e81d12, 0xfd88d114220f081cb3d5e15be8152ab07366576a, 0xe408fceaa1b98f3c640f48fcba39f056066d6308, 0x057dd29f2d19aa3da42327ea50bce86ff5c911d9, 0xed1065dbcf9d73c04ffc7908870d881468c1e132, 0xbbc9d8112e5beb02dd29a2257b1fe69b3536a945, 0x79c1be19711f73bee4e6316ae7549459aacea2e0, 0x1bcf3441a866bdbe963009ce33c81cbb0261b02c, 0xe2e26e4e1dcf30d048cc6ecf9d51ec1205a4e926, 0x77701e2c493da47c1b58f421b5495dee45bea39b, 0x37a05aceb9395c8635a39a7c5d266ae610d10bf2, 0xc6355ec4768c70a49af69513cd83a5bca7e3b9cd, 0xe3c0c128327a9ad80148139e269773428e638cb0, 0xf7f4898c4c526d955f21f055cb6e47b915e51964, 0x29824e94cc4348bc963279dcdf47391715324cd3, 0xeaa45cea02d87d2cc8fda9434e2d985bd4031584, 0xe08b9aba6bd9d28bc2056779d2fbf0f2855a3d9d, 0x87c498170934b8233d1ad1e769317d5c475f2f40, 0x352d29a26e8a41818181746467f582e6e84012e0, 0x403220600a36f73f24e190d1edb2d61be3f41354, 0x0a48296f7631708c95d2b74975bc4ab88ac1392a, 0xffe0e997f1977a615f5a315af413fd4869343ba0, 0xca66b2280fa282c5b67631ce552b62ee55ad8474, 0x2b6ed29a95753c3ad948348e3e7b1a251080ffb9, 0x492e70f04d18408cb41e25603730506b35a2876b, 0x0e6baaa3deb989f289620076668618e9ac332865, 0xb753a75f9ed10b21643a0a3dc0517ac96b1a4068, 0x3ad915d550b723415620f5a9b5b88a85f382f035, 0xc992be59c6721caf4e028f9e8f05c25c55515bd4, 0x02b643d6fabd437a851accbe79abb7fde126dccf, 0x88797e58675ed5cc4c19980783dbd0c956085153, 0xac142eda1157b9a9a64390df7e6ae694fac98905, 0x656579daedd29370d9b737ee3f5cd9d84bc2b342, 0x9bb9b02a26bfe1ccc3f0c6219e261c397fc5ca78, 0xbee8d0b008421954f92d000d390fb8f8e658eaee, 0x7989d09f3826c3e5af8c752a8115723a84d80970, 0x7cd5d81eab37e11e6276a3a1091251607e0d7e38, 0x6ce1b0f6adc47051e8ab38b39edb4186b03babcc, 0xabfcf5f25091ce57875fc674dcf104e2a73dd2f2, 0x1c3ef05dae9dcbd489f3024408669de244c52a02, 0xcfa8b37127149bdbfee25c34d878510951ea10eb, 0x74863acec75d03d53e860e64002f2c165e538377, 0x59b9e733cba4be00429b4bd9dfa64732053a7d55, 0xaeadfcd0978edad74a32bd01a0a51d37f246e661, 0x08090876baadfee65c3d363ba55312748cfa873d, 0xe589fa76984db5ec4004b46ee8a59492c30744ce, 0x3485361ee6bf06ef6508ccd23d94641f814d3e2f, 0x5cb731160d2e8965670bde925d9de5510935347d, 0x8ef4d8a2c23c5279187b64e96f741404085385f3, 0xe246683cc99db7c4a52bcbacaab0b32f6bfc93d7, 0x7d273e637ef1eac481119413b91c989dc5eac122, 0x6efba8fb2ac5b6730729a972ec224426a287c3ad, 0x0773eeacc050f74720b4a1bd57895b1cceeb495d, 0x88a122a2382c523931fb51a0ccad3beb5b7259c3, 0xb0b779b94bfa3c2e1f587bcc9c7e21789222378f, 0x86f95c5b11a293940e35c0b898d8b75f08aab06d, 0xcf2288ef4ebf88e86db13d8a0e0bf52a056582c3, 0x71ea5b11ad8d29b1a4cb67bf58ca6c9f9c338c16, 0x9917d68d4af341d651e7f0075c6de6d7144e7409, 0x1e5800227d4dcf75e30f5595c5bed3f72e341e3b, 0x123759f333e13e3069e2034b4f05398918119d36, 0xf798d16da4e460c460cd485fae0fa0599708eb82, 0x864bec5069f855a4fd5892a6c4491db07c88ff7c, 0xfa283299603d8758e8cab082125d2c8f7d445429, 0xc811c2e9aa1ac3462eba5e88fcb5120e9f6e2ca2, 0x61547d376e5369bcf978fc162c3c56ae453547e8, 0x0d747ee5969bf79d57381d6fe3a2406cd0d8ce27, 0xf8962b75db5d24c7e8b7cef1068c3e67cebb30a5, 0x35bf6688522f35467a7f75302314c02ba176800e, 0x05cb6c3b0072d3116761b532b218443b53e8f6c5, 0x91c80caa081b38351d2a0e0e00f80a34e56474c1, 0xd75a502a5b677287470f65c5aa51b87c10150572, 0x3e194b4ecef8bb711ea2ff24fec4e87bd032f7d1, 0x736bf1402c83800f893e583192582a134eb532e9, 0xc2cb1ada5da9a0423873814793f16144ef36b2f3, 0xefcce06bd6089d0e458ef561f5a689480afe7000, 0xbfe6bcb0f0c07852643324aa5df5fd6225abc3ca, 0x9d799e943e306ba2e5b99c8a6858cbb52c0cf735, 0xf45b1dcb2e41dc27ffa024daadf619c11175c087, 0x08e38ee0ce48c9ca645c1019f73b5355581c56e6, 0x2cb4c3c16bb1c55e7c6b7a19b127a1ac9390cc09, 0xbdc02cd4330c93d6fbda4f6db2a85df22f43c233, 0xacec91ef6941cf630ba9a3e787a012f4a2d91dd4, 0x27ac073be79ce657a93aa693ee43bf0fa41fef04, 0x22fe884d9037291b4d52e6285ae68dea0be9ffb5, 0xc3107a9af3322d5238df0132419131629539577d, 0xb5cac5ed03477d390bb267d4ebd46101fbc2c3da, 0x58fb947364e7695765361ebb1e801ffb8b95e6d0, 0x32860997d730b2d83b73241a25d3667d51c908ef, 0xc79d5062c796dd7761f1f13e558d73a59f82f38b, 0xfa142fe47eda97e6503b386b18a2bedd73ccb5b1, 0x6ca5de00817de0cedce5fd000128dede12648b3c, 0x214b743955a512de6e0d886a8cbd0282bee6d2a2, 0xede79ae1ff4f1606d59270216fa46ab2ddd4ecaa, 0x528101ce46b720a2214dcdae6618a53177ffa377, 0xb5870ce342d43343333673038b4764a46e925f3e, 0x843bd3502f45f8bc4da370b323bdac3fcf5f19a6, 0x5067f4549afbfe884c59cbc12b96934923d45db0, 0x6f2a42e6e033d01061131929f7a6ee1538021e52, 0xe9e1f7cb00a110edd0ebf8b377ef8a7bb856117f, 0xa387ecde0ee4c8079499fd8e03473bd88ad7522a, 0x6dff90e6dc359d2590882b1483edbcf887c0e423, 0x22e512149a18d369b73c71efa43e86c9edabaf1d, 0xa3203095edb7028e6871ce0a84f548459f83300a, 0x93b4bf3fdff6de3f4e56ba6d7799dc4b93a6548f, 0x8c75956e8fed50f5a7dd7cfd27da200f6746aea6, 0xafc8ebe8988bd4105acc4c018e546a1e8f9c7888, 0xbf9acd4445d9c9554689cabbbab18800ff1741c2, 0x603f2fab7afb6e017b94766069a4b43b38964923, 0xa1f765c44fe45f790677944844be4f2d42165fbd, 0x4dc9d5bb4b19cecd94f19ec25d200ea72f25d7ed, 0x48f60a35484fe7792bcc8a7b6393d0dda1f6b717, 0x588ed990a2aff44a94105d58c305257735c868ac, 0x710be8fd5e2918468be2aabea80d828435d79612, 0x03ea6d26d080e57aee3926b18e8ed73a4e5b2826, 0x20824ba1dbebbef9846ef3d0f6c1b017e6912ec4, 0xf7500c166f8bea2f82347606e5024be9e4f4ce99, 0x9d369165fb70b81a3a765f188fd60cbe5e7b0968, 0x6fddbd9bca66e28765c2162c8433548c1052ed11, 0x8b81156e698639943c01a75272ad3d35851ab282, 0x75804aac64b4199083982902994d9c5ed8828f11, 0xd6e8e97ae9839b9ee507eedb28edfb7477031439, 0x6c808cabb8ff5fbb6312d9c8e84af8cf12ef0875, 0xafa539586e4719174a3b46b9b3e663a7d1b5b987, 0xf8a065f287d91d77cd626af38ffa220d9b552a2b, 0x30e60900cacc7203f314dc604347255167fc2a0f, 0x796f87ba617a2930b1670be92ed1281fb0b346e1, 0xf114ff0d0f24eff896edde5471dea484824a99b3, 0x0b80fc70282cbdd5fde35bf78984db3bdb120188, 0xda7ad025ebde25d22243cb830ea1d3f64a566323, 0x65a52141f56bef98991724c6e7053381da8b5925, 0xbbc8eaff637e94fcc58d913c7770c88f9b479277, 0x0469e8c440450b0e512626fe817e6754a8152830, 0x0727be0a2a00212048b5520fbefb953ebc9d54a0, 0x7d858493f07415e0912d05793c972113eae8ae88, 0x7091303116d5f2389b23238b4d656a8596d984d3, 0x3702e704cc21617439ad4ea27a5714f2fda1e932, 0xb87de1bcd29269d521b8761cc39cfb4319d2ead5, 0xf639ac31da9f67271bd10402b7654e5ce763bd47, 0xe7735ec76518fc6aa92da8715a9ee3f625788f13, 0x51277fe7c81eebd252a03df69a6b9f326e272207, 0x3b8098533f7d9bdcd307dbb23e1777ca18418936, 0x2cba6d5d0dc204ea8a25ada2e26f5675bd5f2fdc, 0x5c3c1c645b917543113b3e6c1c054da1fe742b9a, 0x5ecdbaeab9106ffe5d7b519696609a05baeb85ad, 0x45a820a0672f17dc74a08112bc643fd1167736c3, 0xbeef94213879e02622142bea61290978939a60d7, 0x6cd212aee04e013f3d2abad2a023606bfb5c6ac7, 0x92698e345378c62d8eda184d94366a144b0c105b, 0x2d5b42fc59ebda0dfd66ae914bc28c1b0a6ef83a, 0xb7a6791c16eb4e2162f14b6537a02b3d63bfc602, 0xfa105f1a11b6e4b1f56012a27922e2ac2da4812f, 0x2306df931a940d58c01665fa4d0800802c02edfe, 0xf37bf78c5875154711cb640d37ea6d28cfcb1259, 0x66201bd227ae6dc6bdfed5fbde811fecfe5e9dd9, 0x2bafbf9e9ed2c219f7f2791374e7d05cb06777e7, 0x8e9b35ad4a0a86f758446fffde34269d940ceacd, 0x1b43232ccd4880d6f46fa751a96cd82473315841, 0x6eefdc850e87b715c72791773c0316c3559b58a4, 0xf2c03e2a38998c21648760f1e5ae7ea3077d8522, 0x0625d06056968b002206ff91980140242bfaa499, 0x6158e107c5eb54cb7604e0cd8dc1e07500d91c3c, 0x02477212ffdd75e5155651b76506b1646671a1eb, 0xfa44a855e404c86d0ca8ef3324251dfb349c539e, 0x49897fe932bbb3154c95d3bce6d93b6d732904dd, 0x9b6641b13e172fc072ca4b8327a3bc28a15b66a9, 0xa46b4387fb4dcce011e76e4d73547d4481e09be5, 0x72bb27cb99f3e2c2cf90a98f707d30e4a201a071, 0xb6bfe1c3ef94e1846fb9e3acfe9b50c3e9069233, 0xe6cb3f3124c9c9cc3834b1274bc3336456a38bac, 0xfcbc5c71ace79741450b012cf6b8d3f17db68a70, 0x15dbb48c98309764f99ced3692dcca35ee306bac, 0x2e10910ba6e0bc17e055556614cb87090f4d7e5b, 0xe5fbe34984b637196f331c679d0c0c47d83410e1, 0x6d120f0caae44fd94bcafe55e2e279ef96ba5c7a, 0xaa5afcfd8309c2df9d15be5e6a504e7d706624c5, 0x37959c20b7e9931d72f5a8ae869dafddad3b6d5c, 0xb041310fe9eed6864cedd4bee58df88eb4ed3cac, 0x986df47e76e4d7a789cdee913cc9831650936c9d, 0x35aaa0465d1c260c420fa30e2629869fb6559207, 0x7f655c6789eddf455cb4b88099720639389eebac, 0x9e3eb509278fe0dcd8e0bbe78a194e06b6803943, 0x3e9410d3b9a87ed5e451a6b91bb8923fe90fb2b5, 0x9e960dcd03d5ba99cb115d17ff4c09248ad4d0be, 0xf057aa66ca767ede124a1c5b9cc5fc94ef0b0137, 0xf38a6ca80168537e974d14e1c3d13990a44c2c1b, 0x229e430de2b74f442651ddcdb70176bc054cad54, 0x27bf9f44ba7d05c33540c3a53bb02cbbffe7c3c6, 0x10389858b800e8c0ec32f51ed61a355946cc409b, 0xfd2929271e9d2095a264767e7b0df52ea0d1d400, 0x44250d476e062484e9080a3967bf3a4a732ad73f, 0x0c67033dd8ee7f0c8ae534d42a51f7d9d4f7978f, 0xe083d34863e0e17f926b7928edff317e998e9c4b, 0x7f7192c0df1c7db6d9ed65d71184d8e4155a17ba, 0x51e7b55c2f9820eed73884361b5066a59b6f45c6, 0x4fa983bb5e3073a8edb557effeb4f9fb1d60ef86, 0x5a5ee8e9bb0e8ab2fecb4b33d29478be50bbd44b, 0x1f3959fc291110e88232c36b7667fc78a379613f, 0x2d7d5c40ddafc450b04a74a4dabc2bb5d665002e, 0x5215183b8f80a9bc03d26ce91207832a0d39e620, 0x5607590059a9fec1881149a44b36949aef85d560, 0xf7c50f922ad16b61c6d1baa045ed816815bac48f, 0xda10978a39a46ff0bb848cf65dd9c77509a6d70e, 0xa7dcbba9b9bf6762c145416c506a71e3b497209c, 0x54e01283cc8b384538dd646770b357c960d6cacd, 0x78cf8336b328db3d87813a472b9e89b75e0cf3bc, 0xba24fc436753a739db2c8d40e6d4d04c528e86fa, 0xdfe929a61c1b38eddbe82c25c2d6753cb1e12d68, 0x2b49fba29830360fcdb6da23bbfea5c0bbac5281, 0x76becae4a31d36f3cb577f2a43594fb1abc1bb96, 0xe0cf698a053327ebd16b7d7700092fe2e8542446, 0xa3802d8a659e89a2c47e905430b2a827978950a7, 0x75636cdb109050e43d5d6ec47e359e218e857eca, 0x3d813ff2b6ed57b937dabf2b381d148a411fa085, 0xa9252551a624ae513719dabe5207fbefb2fd7749, 0xc749668042e71123a648975e08ed6382f83e05e2, 0x04eca501630abce35218b174956b891ba25efb23, 0x790f91bd5d1c5cc4739ae91300db89e1c1303c93, 0x009560a3de627868f91fa8bfe1c1b7afaf08186b, 0x1329dd19cd4baa9fc64310efeceab22117251f12, 0x7005a772282b1f62afda63f89b5dc6ab64c84cb9, 0xabfe936425dcc7b74b955082bbaaf2a11d78bc05, 0x97d0d9725e3b70e675843173938ed371b62c7fac, 0x41ed2d8e7081482c919fc23d8f0091b3c82c4685, 0x992365d764c5ce354039ddfc912e023a75b8e168, 0xe1c607c0a8a060da8f02a8eb38a013ea8cda5b8c, 0x3b2c45990e21474451cf4f59f01955b331c7d7c9, 0x29ac2b458454a36c7e96c73a8667222a12242c71, 0xb8555010776e3c5cb311a5adeefe9e92bb9a64b9, 0x30380087786965149e81423b15e313ba32c5c783, 0xa2f86bc061884e9eef05640edd51a2f7c0596c69, 0x9f98eb34d46979b0a6de8b05aa533a89b825dcf1, 0xc81fb7d20fd2800192f0aac198d6d6a37d3fcb7d, 0xa4035ab1e5180821f0f380f1131b7387c8d981cd, 0x782f52f0a676c77716d574c81ec4684f9a020a97, 0x261e0fa64c51137465eecf5b90f197f7937fdb05, 0x276fd7d24f8f883f5a7a28295bf17151c7a84b03, 0xa1f5b840140d5a9acef402ac3cc3886a68cad248, 0xd2bf67a7f3c6ce56b7be41675dbbadfe7ea93a33, 0x8ee584337ddbc80f9e3498df55f0a21eacb57fb1, 0x34393c5d91b9de597203e75bac4309b5fa3d28c3, 0x114cbbbf6fb52ac414be7ec61f7bb71495ce1dfa, 0xab7c42c5e52d641a07ad75099c62928b7f86622f, 0x80bf995ed8ba92701d10fec49f9e7d014dbee026, 0x4a192035e2619b24b0709d56590e9183ccf2c1d9, 0x376cd7577383e902951b60a2017ba7ea29e33576, 0xf5437e158090b2a2d68f82b54a5864b95dd6dbea, 0x13a5eecb38305df94971ef2d9e179ae6cebab337, 0xefc8cf1963c9a95267b228c086239889f4dfd467, 0xdb77b88dcb712fd17ee91a5b94748d720c90a994, 0x9aaafa0067647ed999066b7a4ca5b4b3f3feaa6f, 0xae36f7452121913e800e0fcd1a65a5471c23846f, 0xb124bcb6ffa430fcae2e86b45f27e3f21e81ee08, 0xf2813a64c5265d020235cb9c319b6c96f906c41e, 0xe848ca7ebff5c24f9b9c316797a43bf7c356292d, 0x21a6feb6ab11c766fdd977f8df4121155f47a1c0, 0xe95e92bbc6de07bf3a660ebf5feb1c8a3527e1c5, 0x0b369e002e1b4c7913fcf00f2d5e19c58165478f, 0x0909648c18a3ce5bae7a047ec2f868d24cdda81d, 0xd32b45564614516c91b07fa9f72dcf787cce4e1c, 0xcf1bdb799b2ea63ce134668bdc198b54840f180b, 0xae062c448618643075de7a0030342dced63dbad7, 0x99dfd0504c06c743e46534fd7b55f1f9c7ec3329, 0x87fc4635263944ce14a46c75fa4a821f39ce7f72, 0x27c2d7ca504daa3d9066dc09137dc42f3aaab452, 0xcc60f836acdef3548a1fefcca13ec6a937db44a0, 0xc910a970556c9716ea53af66ddef93143124913d, 0x8173c835646a672e0152be10ffe84162dd256e4c, 0xe989733ca1d58d9e7b5029ba5d444858bec03172, 0x86806474c358047d9406e6a07f40945bc8328e67, 0x5395a4455d95d178b4532aa4725b193ffe512961, 0x56397638bb3cebf1f62062794b5eb942f916171d, 0x6958f83bb2fdfb27ce0409cd03f9c5edbf4cbedd, 0x26ff0a51e7cece8400276978dbd6236ef162c0e6, 0x4ca783b556e5bf53aa13c8116613d65782c9b642, 0x15a0aec37ff9ff3d5409f2a4f0c1212aaccb0296, 0x50378af7ef54043f892ab7ce97d647793511b108, 0xe7c6b5fc05fc748e5b4381726449a1c0ad0fb0f1, 0x5317ecb023052ca7f5652be2fa854cfe4563df4d, 0xc94f7c35c027d47df8ef4f9df85a9248a17dd23b, 0x6a63fc89abc7f36e282d80787b7b04afd6553e71, 0x5fd3d6777ec2620ae83a05528ed425072d3ca8fd, 0x29adcf83b6b20ac6a434abb1993cbd05c60ea2e4, 0x8c6f9f4e5b7ae276bf58497bd7bf2a7d25245f64, 0xd94a57882a52739bbe2a0647c80c24f58a2b4f1c, 0x7286e89cd9de8f7a8a00c86ffdb53992dd9251d1, 0x5773b6026721a1dd04b7828cd62b591bfb34534c, 0x11fefb5dc1a4598aa712640c517775dfa1d91f8c, 0xc6e324beeb5b36765ecd464260f7f26006c5c62e, 0x118fbd753b9792395aef7a4d78d263cdcaabd4f7, 0xf8298591523e50b103f0b701d623cbf0f74556f6, 0xab0ced762e1661fae1a92afb1408889413794825, 0xfa67b67b4f37a0150915110ede073b05b853bda2, 0xca122cf0f2948896b74843f49afed0ba1618eed7, 0x186b95f8e5effddcc94f1a315bf0295d3b1ea588, 0x2915624bcb679137b8dae9ab57d11b4905eaee4b, 0x0c6845bf41d5ee273c3ee6b5b0d69f6fd5eabbf7, 0xcb7479109b43b26657f4465f4d18c6f974be5f42, 0x8dd6a9bae57f518549ada677466fea8ab04fd9b4, 0x34958a46d30e30b273ecc6e5d358a212e5307e8c, 0x2003717907a72560f4307f1beecc5436f43d21e7, 0x55ab99b0e0e55d7bb874b7cfe834de631c97ec23, 0x79b48d2d6137c3854d611c01ea42427a0f597bb7, 0xd609ec0be70d0ad26f6e67c9d4762b52ee51122c, 0xe8c3f045bb7d38c9d2f395b0ba8492b253230901, 0xaaca60d9d700e78596bbbbb1f1e2f70f4627f9d8, 0x89d75b8e0831e46f80bc174188184e006fde0eae, 0xb3667894b7863c068ad344873fcff4b5671e0689, 0xbc1609d685b76b48ec909aa099219022f89b2ccd, 0x88ee7f0efc8f778c6b687ec32be9e7d6f020b674, 0x470ac5d1f3efe28f3802af925b571e63868b397d, 0xabf8ffe0708a99b528cc1ed4e9ce4b0d0630be8c, 0x8cee38d6595788a56e3fb94634b3ffe1fbdb26d6, 0x19798cbda715ea9a9b9d6aab942c55121e98bf91, 0xe25a167b031e84616d0f013f31bda95dcc6350b9, 0x6196c3d3c0908d254366b7bca55745222d9d4db1, 0xe8e9850586e94f5299ab494bb821a5f40c00bd04, 0x1059cbc63e36c43e88f30008aca7ce058eeaa096, 0xc4f2913b265c430fa1ab8adf26c333fc1d9b66f2, 0x26e9e2ad729702626417ef25de0dc800f7a779b3, 0x0dfbd4817050d91d9d625c02053cf61a3ee28572, 0x709fe9d2c1f1ce42207c9585044a60899f35942f, 0x7ad82caea1a8b4ed05319b9c9870173c814e06ee, 0x2a595f16eee4cb0c17d9a2d939b3c10f6c677243, 0xa8f89dd5cc6e64d7b1eeace00702022cd7d2f03d, 0xc0a6cbad77692a3d88d141ef769a99bb9e3c9951, 0x868c23be873466d4c74c220a19b245d1787e807f, 0x2905b192e83ce659aa355b9d0c204e3e95f9bb9a, 0x50b9fef0a1329b02d16506255f5a2db71ec92d1f, 0xfc10b7a67b3268d5331bfb6a14def5ea4a162ca3, 0x85eb256b51c819d60ea61a82d12c9358d59c1cae, 0x75de7e9352e90b13a59a5878ffecc7831cac4d82, 0xd32b2c79c36478c5431901f6d700b04dbe9b8810, 0x2d0326b23f0409c0c0e9236863a133075a94ba18, 0xd2e21ed56868fab28e0947927adaf29f23ebad6c, 0x2ad6c9d10c261819a1a0ca2c48d8c7b2a71728df, 0x7d445267c59ab8d2a2d9e709990e09682580c49f, 0xb6047cdf932db3e4045f4976122341537ed5961e, 0x2b3cf97311ff30f460945a9d8099f4a88e26d456, 0x7f4f593b618c330ba2c3d5f41eceeb92e27e426c, 0x72a2fc8675feb972fa41b50dffdbbae7fa2adfb7, 0x076561a856455d7ef86e63f87c73dbb628a55f45, 0x03d1724fd00e54aabcd2de2a91e8462b1049dd3a, 0x7ea0f96ee0a573a330b56897761f3d4c0130a8e3, 0xfe65c4188d7922576909642044fdc52395560165, 0x57883010b4ac857fedac03eab2551723a8447ffb, 0x0729a8a4a5ba23f579d0025b1ad0f8a0d35cdfd2, 0xe75c1fb177089f3e58b1067935a6596ef1737fb5, 0xe0e978753d982f7f9d1d238a18bd4889aefe451b, 0x5620f46d1451c2353d6243a5d4b427130be2d407, 0xf3d688f06bbdbf50f9932c4145cbe48ecdf68904, 0x3aa948ea02397755effb2f9dc9392df1058f7e33, 0x20d1417f99c569e3beb095856530fe12d0fceaaa, 0xac77bdf00fd5985b5db12bbef800380abc2a0677, 0x267a7e6e82e1b91d51deddb644f0e96dbb1f7f7e, 0x4bbcbf38b3c90163a84b1cd2a93b58b2a3348d87, 0x4c6b93a3bec16349540cbfcae96c9621d6645010, 0xc9308879056dfe138ef8208f79a915c6bc7e70a8, 0xc48b693cacefdbd6cb5d7895a42e3196327e261c, 0xa0951970dfd0832fb83bda12c23545e79041756c, 0x7cdf74213945953db39ad0e8a9781add792e4d1d, 0x75621865b6591365606ed378308c2d1def4f222c, 0x67d6a8aa1bf8d6eaf7384e993dfdf10f0af68a61, 0x8f0af37566d152802f1ae8f928b25af9b139b448, 0x2c6afcd4037c1ed14fa74ff6758e0945a185a8e8, 0xc1b2aa8cb2bf62cdc13a47ecc4657facaa995f98, 0x9e8144e08e89647811fe6b72d445d6a5f80ad244, 0xe04ff5e5a7e2af995d8857ce0290b53a2b0eda5d, 0x03dedfcd0b3c2e17c705da248790ef98a6bd5751, 0x698a8a6f01f9ab682f637c7969be885f6c5302bf, 0xd82c6fedbdac98af2eed10b00f32b00056ca5a6d, 0x2697b339813b0c2d964b2471eb1c606f4ecb9616, 0x987c9bcd6e3f3990a52be3eda4710c27518f4f72, 0xc5d48ca2db2f85d8c555cb0e9cfe826936783f9e, 0xda214c023e2326ff696c00393168ce46ffac39ec, 0x86570ab259c9b1c32c9729202f77f590c07dd612, 0xa646a95c6d6f59f104c6541d7760757ab392b08c, 0x1933e334c40f3acbad0c0b851158206924beca3a, 0x3552a496eba67f12be6eedab360cd13661dc7480, 0x2a9c96c19151ffcbe29a4616d0c52b3933b4659f, 0x3b7b8e27de33d3ce7961b98d19a52fe79f6c25be, 0xa1911405cf6e999ed011f0ddcd2a4ff7c28f2526, 0x0cae108e6db99b9e637876b064c6303eda8a65c8, 0x3883becc08b9be68ad3b0836aac3b620dc0017ef, 0xd0abcc70c0420e0e172f97d43b87d5e80c336ea9, 0xcbf16a0fe2745258cd52db2bf21954c975fc6a15, 0x1b23cb8663554871fbbe0d9e60397efb6faedc3e, 0xfbede32c349f3300ef4cd33b4de7dc18e443d326, 0x5e806e845730f8073e6cc9018ee90f5c05f909a3, 0x425c338a1325e3a1578efa299e57d986eb474f81, 0x8bf297f8f453523ed66a1acb7676856337b93bf0, 0x38e8a31af2d265e31a9fff2d8f46286d1245a467, 0x7edafba8984baf631a820b6b92bbc2c53655f6bd, 0xaa0200f1d17e9c54da0647bb96395d57a78538d8, 0x433eb94a339086ed12d9bde9cd1d458603c97dd6, 0xcd7e47909464d871b9a6dc76a8e9195db3485e7a, 0x5975d78d974ee5bb9e4d4ca2ae77c84b9c3b4b82, 0xcea2896623f4910287a2bdc5be83aea3f2e6de08, 0xcb4ad0c723da46ab56d526da0c1d25c73daff10a, 0xe2cf360aa2329eb79d2bf7ca04a27a17c532e4d8, 0xea60549ec7553f511d2149f2d4666cbd9243d93c, 0xcbb7be17953f2ccc93e1bc99805bf45511434e4c, 0x3549bd40bbbc2b30095cac8be2c07a0588e0aed6, 0x6510df42a599bcb0a519cca961b488759a6f6777, 0xed12a1ba1fb8adfcb20dfa19582e525aa3b74524, 0x135eb8c0e9e101deedec11f2ecdb66ae1aae8867, 0xee906d7d5f1748258174be4cbc38930302ab7b42, 0x253f1e742a2cec86b0d7b306e5eacb6ccb2f8554, 0xecd1a62802351a41568d23033004acc6c005a5d3, 0x558c54649a8a6e94722bd6d21d14714f71780534, 0xca657ec06fe5bc09cf23e52af7f80cc3689e6ede, 0x74bf7a5ab59293149b5c60cf364263e5ebf1aa0d, 0x7a6d781c77c4ba1fcadf687341c1e31799e93d27, 0x77028e409cc43a3bd33d21a9fc53ec606e94910e, 0x4781a10a4df5eebc82f4cfe107ba1d8a7640bd66, 0x78e08bc533413c26e291b3143ffa7cc9afb97b78, 0x03ef6ad20ff7bd4f002bac58d47544cf879ae728, 0x0e3696cf1f4217b163d1bc12a5ea730f1c32a14a, 0x825135b1a7fc1605614c8aa4d0ac6dbad08f480e, 0x286b186d61ea1fd78d9930fe12b06537b05c3d51, 0x8d6657f59711b1f803c6ebef682f915b62f92dc9, 0xda8bbee182e455d2098acb338a6d45b4b17ed8b6, 0x3f2da093bb16eb064f8bfa9e30b929d15f8e1c4c, 0xf5d9cf00d658dd45517a48a9d3f5f633541a533d, 0xc5f64babb7033142f20e46d7aa6201ed86f67103, 0xa2e2b5941e0c01944bfe1d5fb4e8a34b922ccfb1, 0x6114b0eae5576903f80bfb98842d24ed92237f1e, 0x38df0c4abe7ded5fe068eadf154ac691774324a4, 0x1c2010bd662df417f2a271879afb13ef4c88a3ae, 0x918967918cd897dd0005e36dc6c883ef438fc8c7, 0xa522de7eb6ae1250522a513133a93bd42849475c, 0x7de442c82386154d2e993cbd1280bb7ca6b12ada, 0x66424bd8785b8cb461102a900283c35dfa07ef6a, 0x7bbbec5e70bdead8bb32b42805988e9648c0aa97, 0xfec06fe27b44c784b2396ec92f7b923ad17e9077, 0x95d550427b5a514c751d73a0f6d29fb65d22ed10, 0x8dde60eb08a099d7daa356daaab2470d7b025a6b, 0x81bccbff8f44347eb7fca95b27ce7c952492aaad, 0x3995e096b08a5a726800fcd17d9c64c64e088d2b, 0x4ee13c0d41200b46d19dee5c4bcec71d82bb8e38, 0xc41461a3cfbd32c9865555a4813137c076312360, 0x3300fb149aded65bcba6c04e9cd6b7a03b893bb1, 0x29f9286c0e738d1721a691c6b95ab3d9a797ede8, 0x34c8e5f1330fcb4b14ca75cb2580a4b93d204e36, 0xec5df227bfa85d7ad76b426e1cee963bc7f519dd, 0x797510e386f56393ced8f477378a444c484f7dad, 0x0191eb547e7bf6976b9b1b577546761de65622e2, 0x615a6f36777f40d6617eb5819896186983fd3731, 0x17580b766f7453525ca4c6a88b01b50570ea088c, 0x945d96ea573e8df7262bbfa572229b4b16016b0f, 0x2de0964400c282bdd78a919c6bf77c6b5f796179, 0x304ec69a74545721d7316aef4dcfb41ac59ee2f0, 0xbe2b326e78ed10e550fee8efa8f8070396522f5a, 0x1a0841b92a7f7075569dc4627e6b76cab05ade91, 0x5fa61f152de6123516c751242979285f796ac791, 0x68c8791dc342c373769ea61fb7b510f251d32088, 0x4167cd48e733418e8f99ffd134121c4a4ab278c4, 0x598aaabae9ed833d7bc222e91fcaa0647b77580b, 0x979f30158b574b999aab348107b9eed85b1ff8c1, 0x3ad06149b21c55ff867cc3fb9740d2bcc7101231, 0x7133843a78d939c69d4486e10ebc7b602a349ff7, 0x8bdfda6c215720eda2136f91052321af4e936c1f, 0x3e1c53300e4c168912163c7e99b95da268ad280a, 0xe07ebbc7f4da416e42c8d4f842aba16233c12580, 0xbac8922c4acc7d2cb6fd59a14eb45cf3e702214b, 0xbb6c284aac8a69b75cddb00f28e145583b56bece, 0x0372ee5508bf8163ed284e5eef94ce4d7367e522, 0x17125b59ac51cee029e4bd78d7f5947d1ea49bb2, 0xc88ca1e6e5f4d558d13780f488f10d4ad3130d34, 0xa825fd5abb7926a67cf36ba246a24bd27be6f6ed, 0x04241b41ecbd0bfdf1295e9d4fa59ea09e6c6186, 0x6de4d15219182faf3aa2c5d4d2595ff23091a727, 0xb203d29e6c56b92699c4b92d1f6f84648dc4cfbc, 0x80b42de170dbd723f454e88f7716452d92985092, 0x0a5b79d8f23b6483dbe2bdaa62b1064cc76366ae, 0x32034e8581d9484e8af42a28df190132ec29c466, 0x7ee604c7a9dc2909ce321de6b9b24f5767577555, 0xa387ce4e961a7847f560075c64e1596b5641d21c, 0xfcc9d4a4262e7a027ab7519110d802c495ceea39, 0xff8a2ca5a81333f19998255f203256e1a819c0aa, 0xf9811fa19dadbf029f8bfe569adb18228c80481a, 0x0d1f2a57713ebc6e94de29846e8844d376665763, 0xeab0bd148309186cf8cbd13b7232d8095acb833a, 0x36928b55bc861509d51c8cf1d546bfec6e3e90af, 0x30480164bcd84974ebc0d90c9b9afab626cd1c73, 0x36339f84a5c2b44ce53dfdb6d4f97df78212a7df, 0xcfeacaaed57285e0ac7268ce6a4e35ecfdb242d7, 0x572dd8cd3fe399d1d0ec281231b7cefc20b9e4bb, 0x5dded049a6e1f329dc4b971e722c9c1f2ade83f0, 0x9756e176c9ef693ee1eec6b9f8b151d313beb099, 0x01e6415d587b065490f1ed7f21d6e0f386ee6747, 0xb4413576869c08f9512ad311fe925988a52d3414, 0xda9f55460946d7bfb570ddec757ca5773b58429a, 0x7180b83ee5574317f21c8072b191d895d46153c3, 0x0aca9a5626913b08cfc9a66d40508dce52b60f87, 0x5cd0e475b54421bdfc0c12ea8e082bd7a5af0a6a, 0x7edb02c61a227287611ad950696369cc4e647a68, 0xb2676841ee9f2d31c172e82303b0fe9bbf9f1e09, 0xa2222259dd9c3e3ded127084f808e92a1887302c, 0x4b3a7cc3a7d7b00ed5282221a60259f25bf6538a, 0xe33ff987541dde5cdee0a8a96dcc3f33c3f24cc2, 0x1e1a4828119be309bd88236e4d482b504dc55711, 0x9b1811c3051f46e664ae4bc9c824d18592c4574a, 0x59fe00696dbd87b7976b29d1156c8842a2e17914, 0x48010ef3b8e95e3f308f30a8cb7f4eb4bf60d965, 0xc90300cb1d4077e6a6d7e169a460468cf4a492d7, 0x6dedf62e743f4d2c2a4b87a787f5424a7aeb393c, 0xfb744b951d094b310262c8f986c860df9ab1de65, 0x193ac65183651800e23580f8f0ead3bb597eb8a4, 0xbf05ff5ecf0df2df887759fb8274d93238ac267d, 0x6c0e712f405c59725fe829e9774bf4df7f4dd965, 0x2744ff67464121e35afc2922177164fa2fcb0267, 0xd09cb2e6082d693a13e8d2f68dd1dd8461f55840, 0xbc171e53d17ac9b61241ae436deec7af452e7496, 0x71fa22cc6d33206b7d701a163a0dab31ae4d31d6, 0x4da8030769844bc34186b85cd4c7348849ff49e9, 0xc8616b4ec09128cdff39d6e4b9ac86eec471d5f2, 0x407295ebd94b48269c2d569c9b9af9aa05e83e5e, 0xd45d5daa138dd1d374c71b9019916811f4b20a4e, 0x42c6edc515d35557808d13cd44dcc4400b2504e4, 0x0bc95cb32dbb574c832fa8174a81356d38bc92ac, 0x5a6071bcebfcba4ab57f4db96fc7a68bece2ba5b, 0x54c93e03a9b2e8e4c3672835a9ee76f9615bc14e, 0x3c03bbc023e1e93fa3a3a6e428cf0cd8f95e1ec6, 0xba1531fb9e791896bcf3a80558a359f6e7c144bd, 0xaa56a65dc4abb72f11bae32b6fbb07444791d5c9, 0xe437acbe0f6227b0e36f36e4bcf7cf613335fb68, 0x39d4a931402c0c79c457186f24df8729cf957031, 0xe22b20c77894463baf774cc256d5bddbbf7ddd09, 0x70a4067d448cc25dc8e70e651cea7cf84e92109e, 0xaa3925dc220bb4ae2177b2883078b6dc346ca1b2, 0xad57aa9d00d10c439b35efcc0becac2e3955c313, 0xe93d47a8ca885d540c4e526f25d5c6f2c108c4b8, 0x232ce782506225fd9860a2edc14a7a3047736da2, 0x49a645e0667dfd7b32d075cc2467dd8c680907c4, 0xcf2e734042a355d05ffb2e3915b16811f45a695e, 0x39b1c471ae94e12164452e811fbbe2b3cd7275ac, 0xffad3dd74e2c1f796ac640de56dc99b4c792a402, 0xa69d7cd17d4842fe03f62a90b2fbf8f6af7bb380, 0x2001bef77b66f51e1599b02fb110194a0099b78d, 0x95e7616424cd0961a71727247437f0069272280e, 0xc04f4bd4049f044685b883b62959ae631d667e35, 0xede0147ec032c3618310c1ff25690bf172193dac, 0x66719c0682b2ac7f9e27abebec7edf8decf0ae0d, 0x45272b8f62e9f9fa8ce04420e1aea3eba9686eac, 0xd1da0c8fb7c210e0f2ec618f85bdae7d3e734b1c, 0xe9133e7d31845d5f2b66a2618792e869311acf66, 0xebb62cf8e22c884b1b28c6fa88fbbc17938aa787, 0x6205c2d5647470848a3840f3887e9b015d34755c, 0x76ca22bcb8799e5327c4aa2a7d0949a1fcce5f29, 0x6b925dd5d8ed6132ab6d0860b82c44e1a51f1fee, 0x797bb7f157d9feaa17f76da4f704b74dc1038341, 0xae8954f8d6166de507cf61297d0fc7ca6b9e7128, 0x75c1ad23d23f24b384d0c3149177e86697610d21, 0x805d846fb0bc02a7337226d685be9ee773b9198a, 0xc3cb6b36af443f2c6e258b4a39553a818747811f, 0xcea43f7075816b60bbfce68b993af0881270f6c4, 0xe0388aeddd3fe2ad56f85748e80e710a34b7c92e, 0xe131f87efc5ef07e43f0f2f4a747b551d750d9e6, 0xc2b2cbe65bc6c2ee7a3c75b2e47c189c062e8d8b, 0xbd8765f41299c7f479923c4fd18f126d7229047d, 0xc83ba6dd9549be1d3287a5a654d106c34c6b5da2, 0xf870995fe1e522321d754337a45c0c9d7b38951c, 0x0d8ed7d0d15638330ed7e4eaccab8a458d75737e, 0x36c510bf8d6e569bf2f37d47265dbcb502ff2bce, 0x0eccf617844fd61fba62cb0e445b7ac68bcc1fbe, 0xae10e27a014f0d306baf266d4897c89aeee2e974, 0x1827039f09570294088fddf047165c33e696a492, 0x23378f42926d0184b793b0c827a6dd3e3d334fcd, 0x467124ae7f452f26b3d574f6088894fa5d1cfb3b, 0xaae61e43cb0d0c96b30699f77e00d711d0a3979b, 0x15c7edb8118ee27b342285eb5926b47a855bc7a5, 0x0d5d98565c647ca5f177a2adb9d3022fac287f21, 0x7222fec7711781d26eaa4e8485f7aa3fac442483, 0xdc44275b1715baea1b0345735a29ac42c9f51b4f, 0x04d82af9e01a936d97f8f85940b970f9d4db9936, 0x45533390e340fe0de3b3cf5fb9fc8ea552e29e62, 0x1284f0cee9d2ff2989b65574d06ffd9ab0f7b805, 0xed9ebccba42f9815e78233266dd6e835b6afc31b, 0xe4324912d64ea3aef76b3c2ff9df82c7e13ae991, 0x94c742fd7a8b7906b3bfe4f8904fc0be5c768033, 0x62fb8bd1f0e66b90533e071e6cbe6111fef0bc63, 0x2c83aeb02fcf067d65a47082fd977833ab1cec91, 0x06cbfa08cdd4fba737bac407be8224f4eef35828, 0x67ee406ea4a7ae6a3a381eb4edd2f09f174b4928, 0x83c23d8a502124ee150f08d71dc6727410a0f901, 0xf7c00cdb1f020310d5acab7b496aaa44b779085e, 0xd096565b7c7407d06536580355fdd6d239144aa1, 0xf8d52dcc5f96cc28007b3ecbb409f7e22a646caa, 0x0c222c7c41c9b048efcce0a232434362e12d673b, 0x503bdbd8bc421c32a443032deb2e3e4cd5ba8b4e, 0x77da5e6c72fb36bce1d9798f7bcdf1d18f459c2e, 0xe62f98650712eb158753d82972b8e99ca3f61877, 0x87a7c508ef71582dd9a54372f89cb01f252fb180, 0xf61283b4bd8504058ca360e993999b62cbc8cd67, 0x9ccddcb2cfc2b25b08729a0a98d9e6f0202ea2c1, 0xd460a4b908dd2b056759b488850b66a838fc77a8, 0x5431b1d18751b98fc9e2888ac7759f1535a2db47, 0xda2a14f9724015d79014ed8e5909681d596148f1, 0xc989434f825aaf9c552f685eba7c11db4a5fc73a, 0x2b701d16c0d3cc1e4cd85445e6ad02eea4ac012d, 0x78b978a9d7e91ee529ea4fc4b76feaf8762f698c, 0xc89cf504b9f3f835181fd8424f5ccbc8e1bddf7d, 0xe94941b6036019b4016a30c1037d5a6903babaad, 0x95d98d0c1069908f067a52acac2b8b534da37afd, 0x8284923b62e68bbf7c2b9f3414d13ef6c812a904, 0x3e5a39fdda70df1126ab0dc49a7378311a537a1f, 0xa2ace4c993bb1e5383f8ac74e179066e814f0591, 0x0609d83a6ce1ffc9b690f3e9a81e983e8bdc4d9d, 0xd119417c46732cf34d1a1afb79c3e7e2cd8eece4, 0xfdb33944f2360615e5be239577c8a19ba52d9887, 0xdd95dbe30f1f1877c5dd7684aeef302ab6885192, 0x413f4b02669ccff6806bc826fcb7deca3b0ea9bc, 0x5800cd8130839e94495d2d8415a8ea2c90e0c5cb, 0x65053191319e067a25e6361d47f37f6318f83419, 0x9bc573bcda23b8b26f9073d90c230e8e71e0270b, 0x97f7760657c1e202759086963eb4211c5f8139b9, 0x126897a311a14ad43b78e0920100c4426bfd6bdd, 0xd5276f0cd5ffd5ffb63f98b5703d5594ede0838b, 0xe9c35c913ca1fceab461582fe1a5815164b4fd21, 0xb43067fe70d9b55973ba58dc64dd7f311e554259, 0x6f8f0d15cc96fb7fe94f1065bc6940f8d12957b2, 0xb1dba5250ba9625755246e067967f2ad2f0791de, 0x72b7a03dda14ca9c661a1d469fd33736f673c8e8, 0xe792349ce9f6f14f81d0674096befa1f9221cdea, 0x1815279dff9952da3be8f77249dbe22243377be7, 0x33481e856ebed48ea708a27426ef28e867f57cd1, 0x8eb8c71982a00fb84275293253f8044544b66b49, 0x65f5870f26bce089677dfc23b5001ee492483428, 0x8e23facd12c765c36ab81a6dd34d8aa9e68918ae, 0x4912d902931676ff39fc34fe3c3cc8fb2182fa7a, 0xc09a66172aea370d9a63da04ff71ffbbfcff7f94, 0xe969ea1595edc5c4a707cfde380929633251a2b0, 0x4f2b47e2775a1fa7178dad92985a5bbe493ba6d6, 0xcab9a97ada065c87816e6860a8f1426fe6b3d775, 0xcdfd8217339725d7ebac11a63655f265eff1cc3d, 0xab4004c0403f7eabb0ea586f212156c4203d67f1, 0x1c7cb2fe6bf3e09cbcdc187af38fa8f5053a70b6, 0xa951b244ff50cfae591d5e1a148df6a938ef2a1a, 0xb158db43fa62d30e65f3d09bf781c7b67372ebaa, 0x25e037f00a18270ba5ec3420229ddb0a2ce38fa2, 0x2aaea1f1046f30f109faec1c63ef5c7594eb08da, 0x73d7269ff06c9ffd33754ce588f74a966abbbbba, 0x4c767b65fd91161f4fbdcc6a69e2f6ad711bb918, 0x92ae5b7c7eb492ff1ffa16dd42ad9cad40b7f8dc, 0xa04f2ae02add14c12faf65cb259022d0830a8e26, 0x63ef2fbc3daf5edaf4a295629ccf31bcdf4038e5, 0x749ad6f2b5706bbe2f689a44c4b640b58e96b992, 0x4d836d9d3b0e2cbd4de050596faa490cffb60d5d, 0x59f6247b0d582aaa25e5114765e4bf3c774f43c2, 0x1293c78c7d6a443b9d74b0ba5ee7bb47fd418588, 0x67bc85e87dc34c4e80aafa066ba8d29dbb8e438e, 0xa09f4d5eaa65a2f4cb750a49923401dae59090af, 0xebbd4db9019952d68b1b0f6d8cf0683c00387bb5, 0xb16479ba8e7df8f63e1b95d149cd8529d735c2da, 0xe1b2aca154b8e0766c4eba30bc10c7f35036f368, 0x5c464197791c8a3da3c925436f277ab13bf2faa2, 0x170a88a8997f92d238370f1affdee6347050b013, 0xdadbfafd8b62b92a24efd75256dd83abdbd7bbdb, 0xbb993b96ee925ada7d99d786573d3f89180ce3aa, 0xf2c362b0ef991bc82fb36e66ff75932ae8dd8225, 0x7f2382ffd8f83956467937f9ba72374623f11b38, 0x74d1a4d0c7524e018d4e06ed3b648092b5b6af2c, 0x24a750eae5874711116dd7d47b7186ce990d3103, 0xa8e42a4e33d7526cca19d9a36dcd6e8040d0ea73, 0x3e1b2230afbbd310b4926a4c776d5ae7819c661d, 0x6af9f0dfeeaebb5f64bf91ab771669bf05295553, 0x41e4a20275e39bdcefeb655c0322744b765140c2, 0xceb089ec8a78337e8ef88de11b49e3dd910f748f, 0xe6bcd30a8fa138c5d9e5f6c7d2da806992812dcd, 0xe08c60313106e3f9334fe6f7e7624d211130c077, 0xf5cffbba624e7eb321bc83c60ca68199b4e36671, 0xd7c2803ed7b0e0837351411a8e6637d168bc5b05, 0x0f3665d48e9f1419cd984fc7fa92788710c8f2e4, 0xb48921c9687d5510744584936e8886bdbf2df69b, 0xa94bbb8214cf8da0c2f668a2ac73e86248528d4b, 0xbe0c2a80b9de084b172894a76cf4737a4f529e1a, 0xfcf199f8b854222f182e4e1d099d4e323e2aae01, 0xb52dfb45de5d74e3df208332bc571c809b8dcf32, 0x704819d2e44d6ed1da25bfce84c49fcca25613e5, 0x6ff6cc90d649de4e96cffee1077a5b302a848dcb, 0x4d9c77d0750c5e6fbc247f2fd79274686cb353d6, 0x68e8022740f4af29eb48db32bcecddfd148d3de3, 0x2cb615073a40dcdb99faa848572e987b3b056efb, 0x64adcceec53dd9d9dd15c8cc1a9e736de4241d2c, 0x2aec809df9325b9f483996e99f7331097f08aa0e, 0x438c2f54ff8e629bab36b1442b760b12a88f02ae, 0x9e35399071a4a101e9194daa3f09f04a0b5f9870, 0xa5c336083b04f9471b8c6ed73679b74d66c363ec, 0x7ad3f307616f19dcb143e6444dab9c3c33611f52, 0x455cb8ee39ffbc752331e5aefc588ef0ee593454, 0xc4c01afc3e0f045221da1284d7878574442fb9ac, 0x99268327c373332e06c3f6164287d455b9d5fa4b, 0x4367ae4b0ce964f4a54afd4b5c368496db169e9a, 0x2cd79eb52027b12c18828e3eaab2969bfcd287e9, 0xb96841cabbc7dbd69ef0cf8f81dff3c8a5e21570, 0xd7ebddb9f93987779b680155375438db65afcb6a, 0x0631d18bbbbd30d9e1732bf36edae2ce8901ab80, 0x5fad960f6b2c84569c9f4d47bf1985fcb2c65da6, 0x01d599ee0d5f8c38ab2d392e2c65b74c3ce31820, 0xff0cc8dac824fa24fc3caa2169e6e057cf638ad6, 0xc25266c7676632f13ef29be455ed948add567792, 0x9c344098ba615a398f11d009905b177c44a7b602, 0x3b0accaf4b607cfe61d17334c214b75cdefdbd89, 0x6d6634b5b8a40195d949027af4828802092ceeb6, 0x208c45732c0a378f17ac8324926d459ba8b658b4, 0xc24399b4bf86f7338fbf645e3b22b0e0b7973912, 0x29763dd6da9a7c161173888321eba6b63c8fb845, 0x9c2fd54089af665df5971d73b804616039647375, 0x0e09646c99af438e99fa274cb2f9c856cb65f736, 0xbe73274d8c5aa44a3cbefc8263c37ba121b20ad3, 0xecfd004d02f36cd4d8b4a8c1a9533b6af85cd716, 0xf978b025b64233555cc3c19ada7f4199c9348bf7, 0x705ddd38355482b8c7d3b515bda1500dd7d7a817, 0x2b8a0dee5cb0e1e97e15cfca6e19ad21f995efad, 0x1098cc20ef84bad5146639c4cd1ca6c3996cb99b, 0xafdac5c1cb56e245bf70330066a817eaafac4cd1, 0x910e996543344c6815fb97cda7af4b8698765a5b, 0x94612781033b57b146ee74e753c672017f5385e4, 0xd03fc165576aaed525e5502c8e140f8b2e869639, 0x293384c42b6f8f2905ce52b7205c2274376c612b, 0x09ee12b1b42b05af9cf207d5fcac255b2ec411f2, 0xdbd71efa4b93c889e76593de609c3b04cbafbe08, 0xfa86ca27bf2854d98870837fb6f6dfe4bf6453fc, 0x61ff8e67b34d9ee6f78eb36ffea1b9f7c15787af, 0x6d4cbf3d8284833ae99344303e08b4d614bfda3b, 0x2ff160c44f72a299b5ec2d71e28ce5446d2fcbaf, 0x94a7cda8f481f9d89d42c303ae1632b3b709db1d, 0x7566496162ba584377be040a4f87777a707acaeb, 0xbdc461462b6322b462bdb33f22799e8108e2417d, 0x7e47637e97c14622882be057bea229386f4052e5, 0x3b5c251d7fd7893ba209fe541cecd0ce253a990d, 0x0e498800447177b8c8afc3fdfa7f69f4051bb629, 0xb71623f35107cf7431a83fb3d204b29ee0b1a7f4, 0x1d395b30adda1cf21f091a4f4a7b753371189441, 0x2c2428e4a66974edc822d5dbfb241b2728075158, 0xa575f2891dcfcda83c5cf01474af11ee01b72dc2, 0xad728121873f0456d0518b80ab6580a203706595, 0x48669eb5a801d8b75fb6aa58c3451b7058c243bf, 0xb3ae54fba09d3ee1d6bdd1e957923919024c35fa, 0x0d35408f226566116fb8acdaa9e2c9d59b76683f, 0xdf211cd21288d6c56fae66c3ff54625dd4b15427, 0x8a746c5d67064711bfca685b95a4fe291a27028e, 0x1cf105ab23023b554c583e86d7921179ee83169f, 0x8cfedef198db0a9143f09129b3fd64dcbb9b4956, 0x1e381adcf801a3bf9fd7bfac9ccc2b8482ad5e66, 0xe74608f506866ada6bfbfdf20fea440be76989ef, 0x27e63989ca1e903bc620cf1b9c3f67b9e2ae6581, 0xbb0857f1c911b24b86c8a70681473fe6aaa1cce2, 0x4f8e8d274fb22a3fd36a47fe72980471544b3434, 0x127d3fc5003bf63c0d83e93957836515fd279045, 0x95809e8da3fbe4b7f281f0b8b1715f420f7d7d63, 0x28904bb7c4302943b709b14d7970e42b8324e1a1, 0xc07e3867ada096807a051a6c9c34cc3b3f4ad34a, 0xf0b469eae89d400ce7d5d66a9695037036b88903, 0x7445202f0c74297a004eb3726aa6a82dd7c02fa1, 0xc58f62fee9711e6a05dc0910b618420aa127f288, 0x801d65c518b11d0e3f4f470221417013c8e53ec5, 0x41010fc8baf8437d17a04369809a168a17ca56fb, 0xa1998144968a5c70a6415554cefec2824690c4a5, 0xe9559185f166fc9513cc71116144ce2deb0f1d4b, 0xed5b4c41e762d942404373caf21ed4615d25e6c1, 0x665b000f0b772750cc3c217a5ef429a92bf1ccbb, 0xfebd9f81cf78bd5fb6c4b9a24bd414bb9bfa4c4e, 0xa072691c8dd7cd4237ff72a75c1a9506d0ce5b9e, 0x6765df25280e8e4f38d4b1cf446fc5d7eb659e34, 0x524fb210522c5e23bb67dfbf8c26aa616da49955, 0xe987e6139e6146a717fef96bc24934a5447fe05d, 0xd6110276cfe31e42825a577f6b435dbcc10cf764, 0x5e51b8a3bb09d303ea7c86051582fd600fb3dc1a, 0x5c4f24e994ed8f850ea7818f471c8fac3bcf0452, 0x85b2998d0c73302cb2ba13f489313301e053be15, 0x0af6c8d539c96d50259e1ba6719e9c8060f388c2, 0x7d901b28bf7f88ef73d8f73cca97564913ea8a24, 0xe01859f242f1a0ec602fa8a3b0b57640ec89075e, 0xc66ae4cee87fb3353219f77f1d6486c580280332, 0x2d40558b06f90a3923145592123b6774e46e31f4, 0xccf43975b76bfe735fec3cb7d4dd24f805ba0962, 0x1703b4b292b8a9deddede81bb25d89179f6446b6, 0x0e9096d343c060db581a120112b278607ec6e52b, 0xf65819ac4cc14c137f05dd7977c7dae08d1a4ab5, 0xca373fe3c906b8c6559ee49ccd07f37cd4fb5266, 0xd28298524df5ec4b24b0ffb9df85170a145a9eb5, 0x5fcda847aaf8d7fa8bca08029ca2849166aa15a3, 0xbdc739a699700b2e8e2c4a4c7b058a0e513ddebe, 0x0bb05f7224bb5804856556c07eeadbed87ba8f7c, 0xab416fe30d58afe5d9454c7fce7f830bcc750356, 0x3eee6f1e96360b7689b3069adaf9af8eb60ce481, 0x9a0d3cee3d9892ea3b3700a27ff84140d9025493, 0x5dc36de5359450a1ec09cb0c44cf2bb42b3ae435, 0x35c8adc11125432b3b77acd64625fe58ebee9d66, 0xa5e9cd4b74255d22b7d9b27ae8dd43ed6ed0252b, 0x31ea12d49a35a740780ddeeaece84c0835b26270, 0x7aef7b551f0b9c46e755c0f38e5b3a73fe1199f5, 0xcc6d7b12061bc96d104d606d65ffa32b0036eb07, 0x322021022678a0166d204b3aaa7ad4ec4b88b7d0, 0xb31196714a48dff726ea9433cd2912f1a414b3b3, 0x0f2fb884c8aaff6f543ac6228bd08e4f60b0a5fd, 0x7d9d221a3df89ddd7b5f61c1468c6787d6b333e6, 0x367f59cc82795329384e41e1283115e791f26a01, 0xfd9579f119bbc819a02b61e38d8803c942f24d32, 0x3e2f26235e137a7324e4dc154b5df5af46ea1a49, 0x4c1579af3312e4f88ae93c68e9449c2e9a68d9c4, 0xffb04726dfa41afdc819168418610472970d7bfc, 0x403c64896a75cad816a9105e18d8aa5bf80f238e, 0x5cd588a14ec648ccf64729f9167aa7bf8be6eb3d, 0x24b2be118b16d8b2174769d17b4cf84f07ca946d, 0xd3bb59fa31258be62f8ed232f1a7d47b4a0b41ee, 0xcc9ac715cd6f2610c52b58676456884297018b29, 0x6f2a31900e240395b19f159c1d00dfe4d898ebdf, 0xd60b247321a32a5affb96b1e279927cc584de943, 0xf7a1ade2d0f529123d1055f19b17919f56214e67, 0xbea00df17067a43a82bc1daecafb6c14300e89e6, 0xa2968fc1c64bac0b7ae0d68ba949874d6db253f4, 0x92d8ad9a4d61683b80d4a6672e84c20d62421e80, 0x6ed2a12b02f8c688c7b5d3a6ea14d63687dab3b6, 0x7a63869fc767a4c6b1cd0e0649f3634cb121d24b, 0x84f522f0520eba52dd18ad21fa4b829f2b89cb97, 0xd6234aaf45c6f22e66a225ffb93add629b4ef80f, 0xe3d8bf4efe84b1616d1b89e427ddc6c8830685ae, 0xa3db364a332d884ba93b2617ae4d85a1489bea47, 0x9f7986924aeb02687cd64189189fb167ded2dd5c, 0x2eaf4e2a46b789ccc288c8d1d9294e3fb0853896, 0xa02dc6aa328b880de99eac546823fccf774047fb, 0x873b7f786d3c99ff012c4a7cae2677270240b9c5, 0x1d69c83d28ff0474ceebeacb3ad227a144ece7a3, 0x7b827cae7ff4740918f2e030ab26cb98c4f46cf5, 0x3083ef0ed4c4401196774a95cf4edc83edc1484f, 0x40ad74bc0bce2a45e52f36c3debb1b3ada1b7619, 0x05423a54c8d0f9707e704173d923b946edc8e700, 0x22eb7db0ba56b0f8b816ccb206e615d929185b0d, 0x66082c75a8de31a53913bbd44de3a0374f7faa41, 0xe3d3eaa299887865569e88be219be507189be1c9, 0xae57cc129a96a89981dac60d2ffb877d5dc5e432, 0x1a2434cc774422d48d53d59c5d562cce8407c94b, 0x21546914dfd3af2add41b0ff3e83ffda7414e1e0, 0x4dcf62a3de3f061db91498fd61060f1f6398ff73, 0x6fd98e563d12ce0fd60f4f1f850ae396a9823c02, 0xedf8a3e1d40f13b79ec8e3e1ecf262fd92116263, 0xc09e3cfc19f605ff3ec9c9c70e2540d7ee974366, 0x953572f0ea6df9b197cae40e4b8ecc056c4371c5, 0x163cc8be227646cb09719159f28ed09c5dc0dce0, 0xa3932a31d6ff75fb3b1271ace7caa7d5e1ff1051, 0xf9a94bd56198da245ed01d1e6430b24b2708dcc0, 0x3eb8b33b21d23cda86d8288884ab470e164691b5, 0x84bcbf22c09607ac84341d2edbc03bfb1739d744, 0x961c59adc74505d1864d1ecfcb8afa0412593c93, 0xf068dfe95d15cd3a7f98ffa688b4346842be2690, 0x291efe0081dce8c14799f7b2a43619c0c3b3fc1f, 0xbe4fd073617022b67f5c13499b827f763639e4e3, 0xe40a7c82e157540a0b00901dbb86c716e1a062da, 0x6635b46f711d2da6f0e16370cd8ee43efb2c2d52, 0x43748928e8c3ec4436a1d092fbe43ac749be1251, 0xb557ab9439ef50d237b553f02508364a466a5c03, 0x11928378d27d55c520ceedf24ceb1e822d890df0, 0x61518464fdd8b73c1bb6ac6db600654938dbf17a, 0x004bfbe1546bc6c65b5c7eaa55304b38bbfec6d3, 0xa5e0fc3c3affed3db6710947d1d6fb017f3e276d, 0x8ecbcfacbfafe9f00c3922a24e2cf0026756ca20, 0xfb5ffaa0f7615726357891475818939d2037cf96, 0xae222865799079aaf4f0674a0cdaab02a6d570ff, 0x9edc90f4be210865214ab5b35e5a8dd77415279d, 0x9d7831e834c20b1baa697af1d8e0c621c5afff9a, 0x046d274b1af615fb505a764ad8dda770b1db2f3d, 0xeaea23aa057200e7c9c15e8ff190d0e66c0c0e83, 0x417a3cd19496530a6d4204c3b5a17ce0f207b1a5, 0xa035a3652478f82dbd6d115faa8ca946ec9e681d, 0x4f5801b1eb30b712d8a0575a9a71ff965d4f34eb, 0x91dbb6aaad149585be47375c5d6de5ff09191518, 0xd043a011ec4270ee7ec8b968737515e503f83028, 0xbb371c72c9f0316cea2bd9c6fbb4079e775429ef, 0xaa1df92e51dff70b1973e0e924c66287b494a178, 0xbd5f46caab2c3d4b289396bbb07f203c4da82530, 0x4d29fc523a2c1629532121da9998e9b5ab9d1b45, 0xaddb26317227f45c87a2cb90dc4cfd02fb23caf8, 0x52e46783329a769301b175009d346768f4c87ee4, 0xcaad9dc20d589ce428d8fda3a9d53a607b7988b5, 0x95034e1621865137cd4739b346dc17da3a27c34e, 0x0c3239e2e841242db989a61518c22247e8c55208, 0x5a0d609aae2332b137ab3b2f26615a808f37e433, 0x2334c590c7a48769103045c5b6534c8a3469f44a, 0xddfcca13f934f0cfbe231da13039d70475e6a1d0, 0xee7288d91086d9e2eb910014d9ab90a02d78c2a0, 0xfb91fb1a695553f0c68e21276decf0b83909b86d, 0x38695fc7e1367ceb163ebb053751f9f68ddb07a0, 0x65093b239bbfba23c7775ca7da5a8648a9f54cf7, 0x73d8fee3cb864dce22bb26ca9c2f086d5e95e63b, 0xf7155213449892744bc60f2e04400788bd041fdd, 0xd1a71b2d0858e83270085d95a3b1549650035e23, 0xeac17b81ed5191fb0802aa54337313834107aaa4, 0xbb076aac92208069ea318a31ff8eeb14b7e996e3, 0x9f46e7c1e9078cae86305ac7060b01467d6685ee, 0x1598127982f2f8ad3b6b8fc3cf27bf617801ba2b, 0xe91dac0195b19e37b59b53f7c017c0b2395ba44c, 0xa436c75453ccca4a1f1b62e5c4a30d86dde4be68, 0x11001b89ed873e3aaec1155634b4681643986323, 0xab93b26ece0a0aa21365afed1fa9aea31cd54468, 0xe77febabdf080f0f5dca1d3f5766f2a79c0ffa7c, 0x1c4af0e863d2656c8635bc6ffec8dd9928908cb5, 0x0c48ae62d1539788eba013d75ea60b64eeba4e80, 0x423cc4594cf4abb6368de59fd2b1230734612143, 0x7f6b28c88421e4857e459281d78461692489d3fb, 0x806854588ecce541495f81c28a290373df0274b2, 0xdc76e85ba50b9b31ec1e2620bce6e7c8058c0eaf, 0xb00996b0566ecb3e7243b8227988dcb352c21899, 0xf5d14552b1dce0d6dc1f320da6ffc8a331cd6f0c, 0x55a61b109480b5b2c4fcfdef92d90584160c0d35, 0xb8947822d5ace7a6ad8326e95496221e0be6b73d, 0x492de46aaf8f1d708d59d79af1d03ad2cb60902f, 0x0e0d6633db1e0c7f234a6df163a10e0ab39c200f, 0xf8bf9c04874e5a77f38f4c38527e80c676f7b887, 0x15528350e0d9670a2ea27f7b4a33b9c0f9621d21, 0xeccf7a0457b566b346ca673a180f444130216ac3, 0x10cf560964ff83c1c9674c783c0f73fcd89943fc, 0xe7f06f699be31c440b43b4db0501ec0e25261644, 0xb6ce4dc560fc73dc69fb7a62e388db7e72ea764f, 0xf456055a11ab91ff668e2ec922961f2a23e3db25, 0x8dfbafbc0e5b5c86cd1ad697feea04f43188de96, 0x085b4ab75d8362d914435cedee1daa2b1ee1a23b, 0xe400d651bb3f2d23d5f849e6f92d9c5795c43a8a, 0x851aa91c82f42fad5dd8e8bb5ea69c8f3a5977d1, 0x4c935bb250778b3c4c7f7e07fc251fa630314aab, 0xebd356156a383123343d48843bffed6103e866b3, 0xda0b48e489d302b4b7bf204f957c1c9be383b0df, 0x7085ae7e7e4d932197b5c7858c00a3674626b7a5, 0x5b06d1e6930c1054692b79e3dbe6ecce53966420, 0x8df53d96191471e059de51c718b983e4a51d2afd, 0x0678654ac6761db904a2f7e8595ec1eaac734308, 0x89fee30d1728d96cecc1dab3da2e771afbcfaa41, 0x59c5d06b170ee4d26eb0a0eb46cb7d90c1c91019, 0x2b129c26b75dde127f8320bd0f63410c92a9f876, 0x3d6ae053fcbc318d6fd0fbc353b8bf542e680d27, 0x755a60bf522fbd8fff9723446b7e343a7068567e, 0x947e11e5ea290d6fc3b38048979e0cd44ec7c17f, 0x711ecf77d71b3d0ea95ce4758afecdb9c131079d, 0xde9eff4c798811d968dccb460d9b069cf30278e0, 0x4e892e8081bf36e488fddb3b2630f3f1e8da30d2, 0x8ede7e3dc50749c6c50e2e28168478c34db81946, 0x0c30cacc3f72269f8b4f04cf073d2b05a83d9ad1, 0xe51eb87e7fb7311f5228c479b48ec9878831ac4c, 0x8b01da34d470c1d115acf4d8113c4dd8a8c338e4, 0x4329fc0931cbeb033880fe4c9398ca45b0e2d11a, 0x540c072802014ef0d561345aec481e8e11cb3570, 0x21e5d2bae995ccfd08a5c16bb524e1f630448f82, 0x5cf8c03eb3e872e50f7cfd0c2f8d3b3f2cb5183a, 0x5c0f2e51378f6b0d7bab617331580b6e39ad3ca5, 0xd2f241255dd7c3f73c07043071ec08ddd9c5cde5, 0xcbe1b948864d8474e765145858fca4550f784b92, 0x30742ccdf4abbcd005681f8159345c9e79054b1a, 0x6aeb9f74742ea491813dbbf0d6fcde1a131d4db3, 0x821eb90994a2fbf94bdc3233910296f76f9bf6e7, 0x25c1a37ee5f08265a1e10d3d90d5472955f97806, 0x7ef98b52bee953bef992f305fda027f8911c5851, 0x8adc53ef8c18ed3051785d88e996f3e4b20ecd51, 0x007f4a23ca00cd043d25c2888c1aa5688f81a344, 0x4a735d224792376d331367c093d31c8794341582, 0x05440c5b073b529b4829209dff88090e07c4f6f5, 0x5e772e27f28800c50dda973bb33e10762e6eea20, 0xa429fa88731fdd350e8ecd6ea54296b6484fe695, 0xe0d76b7166b1f3a12b4091ee2b29de8caa7d07db, 0x7ebd95e9c470f7283583dc6e9d2c4dce0bea8f84, 0x883a78aeabaa50d8ddd8570bcd34265f14b19363, 0x51f9c432a4e59ac86282d6adab4c2eb8919160eb, 0xb86607021b62d340cf2652f3f95fd2dc67698bdf, 0xacc0909fda2ea6b7b7a88db7a0aac868091ddbf6, 0x69b80ed90f84834afa3ff82eb964703b560977d6, 0xca4ca9e4779d530ecbacd47e6a8058cfde65d98f, 0x5d6c5c720d66a6abca8397142e63d26818eaab54, 0xc2c13e72d268e7150dc799e7c6cf03c88954ced7, 0x6bbd1e719390e6b91043f8b6b9df898ea8001b34, 0xa9ba6f413b82fcddf3affbbdd09287dcf50415ca, 0xced3c7be8de7585140952aeb501dc1f876ecafb0, 0x1c63fa9e2cbbf23c49fcdef1cbabfe6e0d1e14c1, 0x7d6e990daa7105de2526339833f77b5c0b85d84f, 0x68addf019d6b9cab70acb13f0b3117999f062e12, 0xa77428bcb2a0db76fc8ef1e20e461a0a32c5ac15, 0x26048fe84d9b010a62e731627e49bc2eb73f408f, 0xff26138330274df4e0a3081e6df7dd983ec6e78f, 0xb7382d37db0398ac72410cf9813de9f8e1ec8dad, 0x44f62f2aaabc29ad3a6b04e1ff6f9ce452d1c140, 0x47fef58584465248a0810d60463ee93e5a6ee8d3, 0xbd2b70fecc37640f69514fc7f3404946aad86b11, 0x649a85b93653075fa6562c409a565d087ba3e1ba, 0x55866486ec168f79dbe0e1abb18864d98991ae2c, 0xd7e74afdbad55e96cebc5a374f2c8b768680f2b0, 0xa8c1d6aa41fe3d65f67bd01de2a866ed1ed9ae52, 0x744c0c77ba7f236920d1e434de5da33e48ebf02c, 0x9445ba5c30e98961b8602461d0385d40fbd80311, 0xeb835c1a911817878a33d167569ea3cdd387f328, 0x761a6e362c97fbbd7c5977acba2da74687365f49, 0x38202c5cd7078d4f887673ab07109ad8ada89720, 0x5abfec25f74cd88437631a7731906932776356f9, 0x28e4af30cd93f686a122ad7bb19f8a8785eee342, 0x3a9b111029ce1f20c9109c7a74eeeef34f4f2eb2, 0x7bb9571f394b0b1a8eba5664e9d8b5e840677bea, 0x50fb36c27107ee2ca9a3236e2746cca19ace6b49, 0xa3bc979b7080092fa1f92f6e0fb347e28d995045, 0xd04b861b3d9acc563a901689941ab1e1861161a2, 0x58c555bc293cdb16c6362ed97ae9550b92ea180e, 0x8bf02bd748690e1fd1c76d270833048b66b25fd3, 0xfbc01db54e47cdc3c438694ab717a856c23fe6e9, 0x9c9a07a8e57c3172a919ef64789474490f0d9f51, 0xfc7e22a503ec5abe9b08c50bd14999f520fa4884, 0x9b773669e87d76018c090f8255e54409b9dca8b2, 0xffe8cbc1681e5e9db74a0f93f8ed25897519120f, 0x4d4cf5807429615e30cdface1e5aae4dad3055e6, 0xcfde0fc75d6f16c443c3038217372d99f5d907f7, 0x818ffe271fc3973565c303f213f6d2da89897ebd, 0xba1fcaf223937ef89e85675503bdb7ca6a928b78, 0xa30a45520e5206d9004070e6af3e7bb2e8dd5313, 0xa747439ad0d393b5a03861d77296326de8bb9db9, 0x14d00aad39a0a7d19ca05350f7b03727f08dd82e, 0x551999ddd205563327b9b530785acff9bc73a4ba, 0xa4670731175893bbcff4fa85ce97d94fc51c4ba8, 0xf858171a04d357a13b4941c16e7e55ddd4941329, 0xa6484cc684c4c91db53eb68a4da45a6a6bda3067, 0x00d75ed60c774f8b3a5a5173fb1833ad7105a2d9, 0xbf92418a0c6c31244d220260cb3e867dd7b4ef49, 0x716d50cca01e938500e6421cc070c3507c67d387, 0x82a8b96b6c9e13ebec1e9f18ac02a60ea88a48ff, 0x5a565285374a49eedd504c957d510874d00455bc, 0x778c79f4de1953ebce98fe8006d53a81fb514012, 0x41b2d34fde0b1029262b4172c81c1590405b03ae, 0x4039bd50a2bde15ffe37191f410390962a2b8886, 0xc033be10cb48613bd5ebcb33ed4902f38b583003, 0x5d5751819b4f3d26ed0c1ac571552735271dbefa, 0xb600429752f399c80d0734744bae0a022eca67c6, 0xf875619d8a23e45d8998d184d480c0748970822a, 0x71c7230a1d35bdd6819ed4b9a88e94a0eb0786dd, 0xb2f9c972c1e9737755b3ff1b3088738396395b26, 0xa66a4963b27f1ee1932b172be5964e0d3ae54b51, 0x53ce88e66c5af2f29bbd8f592a56a3d15f206c32, 0x433e3ba1c51b810fc467d5ba4dea42f7a9885e69, 0xc7837ad0a0bf14186937ace06c5546a36aa54f46, 0xc3f8f67295a5cd049364d05d23502623a3e52e84, 0x3fd0bb47798cf44cdfbe4d333de637df4a00e45c, 0xa1ae8d4540d4db6fdde7146f415b431eb55c7983, 0x5cccf1508bfd35c20530aa642500c10dee65eaed, 0xa53ead54f7850af21438cbe07af686279a315b86, 0x8cf6da0204dbc4860b46ad973fc111008d9e0c46, 0x8e7936d592008fdc7aa04edeeb755ab513dbb89d, 0x4a53dcdb56ce4cdce9f82ec0eb13d67352e7c88b, 0x2b4f4507bb6b9817942ce433781b708fbcd166fd, 0x026432af37dc5113f1f46d480a4de0b28052237e, 0xe780a56306ba1e6bb331952c22539b858af9f77d, 0xd1f1694d22671b5aad6a94995c369fbe6133676f, 0x7c45f0f8442a56dbd39dbf159995415c52ed479b, 0xb65941d44c50d24666670d364766e991c02e11c2, 0x45e68db8dbbaba5fc2cb337c62bcd0d61b059189, 0x05f3631f5664bdad5d0132c8388d36d7d8920918, 0x5475d7f174bdb1f789017c7c1705989646079d49, 0xc7bf2ed1ed312940ee6aded1516e268e4a604856, 0x39aaf0854db6eb39bc7b2e43846a76171c0445de, 0xc817df1b91faf30fe3251571727c9711b45d8f06, 0x7d13d6705884ab2157dd8dcc7046caf58ee94be4, 0x478dc09a1311377c093f9cc8ae74111f65f82f39, 0x8043ed22f997e5a2a4c16e364486ae64975692c4, 0xb9a985501ee950829b17fae1c9cf348c3156542c, 0xd5cba5b26bea5d73fabb1abafacdef85def368cc, 0x6776e133d9dc354c12a951087b639650f539a433, 0x804ca94972634f633a51f3560b1d06c0b293b3b1, 0x0be1fdf626ee6189102d70d13b31012c95cd1cd6, 0xf848fce9ab611c7d99206e23fac69ad488b94fe1, 0xf01195d657ef3c942e6cb83949e5a20b5cfa8b1e, 0x78a5e89900bd3f81dd71ba869d25fec65261df15, 0xd6f1e55b1694089ebcb4fe7d7882aa66c8976176, 0xd5294b666242303b6df0b1c88d37429bc8c965aa, 0x3171877e9d820cc618fc0919b29efd333fda4934, 0x2901f8077f34190bb47a8e227fa29b30ce113b31, 0x6b2284440221ce16a8382de5ff0229472269deec, 0x1bba03ff6b4ad5bf18184acb21b188a399e9eb4a, 0x80744618de396a543197ee4894abd06398dd7c27, 0x1b799033ef6dc7127822f74542bb22dbfc09a308, 0xd513a45080ff2febe62cd5854abe29ee4467f996, 0xe761d27fa3502cc76bb1a608740e1403cf9dfc69, 0x53989ed330563fd57dfec9bd343c3760b0799390, 0xccf7110d1bd9a74bfd1d7d7d2d9d55607e7b837d, 0xf373e9daac0c8675f53b797a160f6fc034ae6b23, 0xabc9a99e8a2148a55a6d82bd51b98eb5391fdbaf, 0xffec0913c635baca2f5e57a37aa9fb7b6c9b6e26, 0x581a3af297efa4436a29af0072929abf9826f58b, 0x924efa6db595b79313277e88319625076b580a10, 0x65d8dd4e251cbc021f05b010f2d5dc520c3872e0, 0x6c67d6db1d03516c128b8ff234bf3d49b26d2941, 0x496d365534530a5fc1577c0a5241cb88c4da7072, 0xb85ff03e7b5fc422981fae5e9941dacbdaba7584, 0xe13540ecee11b212e8b775dc8e71f374aae9b3f8, 0xa02e3f8f5959a7aab7418612129b701ca1b80010, 0xa7a3f153cdc38821c20c5d8c8241b294a3f82b24, 0x366175403481e0ab15bb514615cbb989ebc68f82, 0x5104ecc0e330dd1f81b58ac9dbb1a9fbf88a3c85, 0xa466d770d898d8c9d405e4a0e551efafcde53cf9, 0x5fa8a54e68176c4fe2c01cf671c515bfbdd528a8, 0xe2e15c60dd381e3a4be25071ab249a4c5c5264da, 0x0628bfbe5535782fb588406bc96660a49b011af5, 0x04d6b8d4da867407bb997749debbcdc0b358538a, 0x0e6ec313376271dff55423ab5422cc3a8b06b22b, 0x8787d12677a5ec291e57e31ffbfad105c3324b87, 0x58e2f11223fc8237f69d99c6289c148c0604f742, 0x5600730a55f6b20ebd24811faa3de96d1662abab, 0xfce089635ce97abac06b44819be5bb0a3e2e0b37, 0xfa0c1a988c8a17ad3528eb28b3409daa58225f26, 0x7ae1c19e53c71cee4c73fae2d7fc73bf9ab5e392, 0xbd17eed82b9a2592019a1b1b3c0fbad45c408d22, 0x884a7a39d0916e05f1c242df55607f37df8c5fda, 0xca70f4ddbf069d2143bd6bbc7f696b52789b32e7, 0x7b25bb9ca8e702217e9333225250e53c36804d48, 0xea8317197959424041d9d7c67a3ece1dbb78bb55, 0x5cb953a0e42f5030812226217fffc3ce230457e4, 0xd1f4dc1ddb8abb8848a8b14e25f3b55a8591c266, 0x6a42ca971c6578d5ade295c3e7f4ad331dd3424e, 0x07e1162ceae3cf21a3f62d105990302e307f4e3b, 0x5d1dc3387b47b8451e55106c0cc67d6dc72b7f0b, 0x5d2819e8d57821922ee445650ccaec7d40544a8d, 0x4c24b78baf2bafc7fcc69016426be973e20a50b2, 0x630c5273126d517ce67101811cab16b8534cf9a8, 0x291f929ca59b54f8443e3d4d75d95dee243cef78, 0x2dd325fdffb97b19995284afa5abdb574a1df16a, 0x4fce8429ba49caa0369d1e494db57e89eab2ad39, 0x712b76510214dc620f6c3a1dd29aa22bf6d214fb, 0x266f2da7f0085ef3f3fa09baee232b93c744db2e, 0x0770c61be78772230cb5a3bb2429a72614a0b336, 0x02dfcb17a1b87441036374b762a5d3418b1cb4d4, 0x5e67df8969101adabd91accd6bb1991274af8df2, 0x7d9c59631e2ba2e8e82891f3979922aaa3b567a1, 0x949f8c107bc7f0aceaa0f17052aadbd2f9732b2e, 0xea4e809e266ae5f13cdbe38f9d0456e6386d1274, 0xcd5510a242dfb0183de925fba866e312fabc1657, 0xa36e0d94b95364a82671b608cb2d373245612909, 0x0ec46696ffac1f58005fa8439824f08eed1df89b, 0xc6fb1ee37417d080a0d048923bdabab095d077c6, 0x53c9eca40973f63bb5927be0bc6a8a8be1951f74, 0xea14bfda0a6e76668f8788321f07df37824ec5df, 0xdfb4d4ade52fcc818acc7a2c6bb2b00224658f78, 0x5997ffefb3c1d9d10f1ae2ac8ac3c8e2d2292783, 0x8eceb2e124536c5b5ffc640ed14ff15ed9a8cb71, 0x8f02bda6c36922a6be6a509be51906d393f7b99b, 0x530077c9f7b907ff9cec0c77a41a70e9029add4a, 0x08936a37df85b3a158cafd9de021f58137681347, 0x8e9c429266df057efa78dd1d5f77fc40742ad466, 0xacc59f3b30ceffc56461cc5b8df48902240e0e7b, 0xf5534815dc635efa5cc84b2ac734723e21b29372, 0xf873e57a65c93b6e18cb75f0dc077d5b8933dc5c, 0x25b78c9fad85b43343f0bfcd0fac11c9949ca5eb, 0xaad2b7f8106695078e6c138ec81a7486aaca1eb2, 0x509c8668036d143fb8ae70b11995631f3dfcad87, 0x3602458da86f6d6a9d9eb03daf97fe5619d442fa, 0x9f607b3f12469f446121cebf3475356b71b4328c, 0xfe3827d57630cf8761d512797b0b858e478bbd12, 0x9d9c4efe9f433989e23be94049215329fa55b4cb, 0x9bd905f1719fc7acd0159d4dc1f8db2f21472338, 0x7d82e523cc2dc591da3954e8b6bb2caf6461e69c, 0x74afe54902d615782576f8baac13ac970c050f6e, 0xaff11ccf699304d5f5862af86083451c26e79ae5, 0x3885fee67107dc3a3c741ee290c98918c9b99397, 0x36343aeca07b6ed58a0e62fa4ecb498a124fc971, 0xc94a28fb3230a9ddfa964e770f2ce3c253a7be4f, 0x9882967cee68d2a839fad8ab4a7c3dddf6c0adc8, 0x95df4e3445d7662624c48eba74cf9e0a53e9f732, 0xca9faa17542fafbb388eab21bc4c94e8a7b34788, 0xc8b1850525d946f2ae84f317b15188c536a5dc86, 0x39bac68d947859f59e9226089c96d62e9fbe3cde, 0xa9bfc410dddb20711e45c07387eab30a054e19ac, 0x540a1819bd7c35861e791804e5fbb3bc97c9abb1, 0x667b61c03bb937a9f5d0fc5a09f1ea3363c77035, 0x010df1df4bed23760d2d1c03781586ddf7918e54, 0xbd51ee2ea143d7b1d6b77e7e44bdd7da12f485ac, 0xfb5125bf0f5eb0b6f020e56bfc2fdf3d402c097e, 0x3f0c83aac5717962734e5ceaeaecd39b28ad06be, 0xf10661ff94140f203e7a482572437938bec9c3f7, 0xbd3097a79b3c0d2ebff0e6e86ab0edadbed47096, 0xedeb4894aadd0081bbddd3e8846804b583d19f27, 0x49c9771fca19d5b9d245c891f8158fe49f47a062, 0x6405dd13e93abcff377e700e3c1a0086eca27d29, 0xce5e04f0184369bcfa06aca66ffa91bf59fa0fb9, 0x4364309a9fa07095600f79edc65120cdcd23dc64, 0xb749b54e04d5b19bdcedfb84da7701ab478c27ae, 0xf593c65285ee6bbd6637f3be8f89ad40d489f655, 0xd224f880f9479a89d32f09e52be990b288135cef, 0x85bb51bc3bfe9a1b2a2f6b1cda95bca8b38c8d5e, 0xcaf4481d9db78dc4f25f7b4ac8bd3b1ca0106b31, 0x51ca8bd4dc644fac47af675563d5804a0da21eeb, 0x19f643e1a8fa04ae16006028138333a59a96de87, 0x58b808a65b51e6338969afb95ec70735e451d526, 0x574921838cc77d6c98b17d903a3ae0ee0da95bd0, 0x7c6924d07c3ef5891966fe0a7856c87bef9d2034, 0xf9767e4ecb4a5980527508d7bec3d45e4c649c13, 0xf3be99b9103ce7550aa74ff1db18e09dfe32e005, 0x625644c95a873ef8c06cdb9e9f6d8d7680043d62, 0x6a44af96b3f032ae641beb67f4b6c83342d37c5d, 0xd3a10ec7a5c9324999dd9e9b6bde7c911e584bda, 0xe8ddbed732ebfe754096fde9086b8ea4a4cdc616, 0x235fa66c025ef5540070ebcf0d372d8177c467ab, 0x4d08471d68007aff2ae279bc5e3fe4156fbbe3de, 0xdadc00ab7927603c2fcf31cee352f80e6c4d6351, 0x7393cbe7f9ba2165e5a7553500b6e75da3c33abf, 0x77617ebc4bebc5f5ddeb1b7a70cdeb6ae2ffa024, 0x7fea1962e35d62059768c749bedd96cab930d378, 0x243b3bca6a299359e886ce33a30341fafe4d573d, 0xb94d47b3c052a5e50e4261ae06a20f45d8eee297, 0xe727e67ef911b81f6cf9c73fcbfebc2b02b5bfc6, 0xe510d6797fba3d6693835a844ea2ad540691971b, 0x0cdc960b998c141998160dc179b36c15d28470ed, 0x3e76a62db187aa74f63817533b306cead0e8cebe, 0x495b641b1cdea362c3b4cbbd0f5cc50b1e176b9c, 0x5126460d692c71c9af6f05574d93998368a23799, 0xa008019863c1a77c1499eb39bbd7bf2dd7a31cb9, 0x65ee20b06d9ad589a7e7ce04b9f5f795f402aece, 0xf432b9dbaf11bdbd73b6519fc0a904198771aac6, 0x85946d56a4d371a93368539690b60ec825107454, 0x26f9f7cefd7e394b9d3924412bf2c2831faf1f85, 0xd4ebb1929a23871cf77fe049ab9602be08be0a73, 0x4fdac1aa517007e0089430b3316a1badd12c01c7, 0x05e671de55afec964b074de574d5158d5d21b0a3, 0x20181c4b41f6f972b66958215f19f570c15ddff1, 0xcc9519d1f3985f6b255eaded12d5624a972721e1, 0x169bbefc41cfd7d7cbb8dfc63020e9fb06d49546, 0x175a183a3a235ffbb03ba835675267229417a091, 0x8dde3cb8118568ef4503fe998ccdf536bf19a098, 0x6a05b21c4f17f9d73f5fb2b0cb89ff5356a6cc7e, 0x5cc4cba621f220637742057f6055b80dffd77e13, 0xecb94c568bfe59ade650645f4f26306c736cace4, 0xdfa6b8b8ad3184e357da282951d79161cfb089bc, 0xa3058c51737a4e96c55f2ef6bd7bb358167ec2a7, 0x051d424276b21239665186133d653bb8b1862f89, 0xd05ffb2b74f867204fe531653b0248e21c13544e, 0xe1f63ebbc62c7b7444040eb99623964f7667b376, 0xe5a3d7eb13b15c100177236d1beb30d17ee15420, 0x18fa8625c9dc843c78c7ab259ff87c9599e07f10, 0x64264aedd52dcae918a012fbcd0c030ee6f71821, 0x6f1f4907b8f61f0c51568d692806b382f50324f5, 0xbecef61c1c442bef7ce04b73adb249a8ba047e00, 0x7b893286427e72db219a21fc4dcd5fbf59283c31, 0xce5eb63a7bf4fbc2f6e4baa0c68ab1cb4cf98fb4, 0x66ec16ee9caab411c55a6629e318de6ee216491d, 0x30b66150f1a63457023fdd45d0cc6cb54e0c0f06, 0x87183160d172d2e084d327b86bcb7c1d8e6784ef, 0xc420388fbee84ad656dd68cdc1fbaa9392780b34, 0x90f774c9147dde90853ddc43f08f16d455178b8c, 0x1e1d7a5f2468b94ea826982dbf2125793c6e4a5a, 0x8043fdd0bc4c973d1663d55fc135508ec5d4f4fa, 0x7bca1da6c80a66baa5db5ac98541c4be276b447d, 0x73550beb732ba9ddafda7ae406e18f7feb0f8bb2, 0xadc19ec835afe3e58d87dc93a8a9213c90451326, 0x821d798af19989c3ae5b84a7a7283cd7fda1fabe, 0x4c4e6f13fb5e3f70c3760262a03e317982691d10, 0x664e43119870af107a448db1278b044838ffcdaf, 0x8da1178f55d97772bb1d24111a404a4f8715b95d, 0x5e6e9747e162f8b45c656e0f6cae7a84bac80e4e, 0xc7eac31abce6d5f1dea42202b6a674153db47a29, 0xd96711540e2e998343d4f590b6fc8fac3bb8b31d, 0x9da4ec407077f4b9707b2d9d2ede5ea5282bf1df, 0xf60c1b45f164b9580e20275a5c39e1d71e35f891, 0xeb6394a7bfa4d28911d5a5b23e93f35e340c2294, 0xa89ac93b23370472daac337e9afdf642543f3e57, 0xbb618e25221ad9a740b299ed1406bc3934b0b16d, 0x817ac33bd8f847567372951f4a10d7a91ce3f430, 0xfe6a895b795cb4bf85903d3ce09c5aa43953d3bf, 0x3673954399f6dfbe671818259bb278e2e92ee315, 0xdf0ff1f3d27a8ec9fb8f6b0cb254a63bba8224a5, 0xff12e49d8e06aa20f886293c0b98ed7eff788805, 0x5aef16a226dd68071f2483e1da42598319f69b2c, 0x0266ab1c6b0216230b9395443d5fa75e684568c6, 0x14a7352066364404db50f0d0d78d754a22198ef4, 0x444caf79b71338ee9aa7c733b02acaa7dc025948, 0x64e2de21200b1899c3a0c0653b5040136d0dc842, 0x36e156610cd8ff64e780d89d0054385ca76755aa, 0x0a6ebe723b6ed1f9a86a69ddda68dc47465c2b1b, 0x38bf2a1f7a69de0e2546adb808b36335645da9ff, 0x39f44663d92561091b82a70dcf593d754005973a, 0x24b9e6644f6ba4cde126270d81f6ab60f286dff4, 0x9b59eb213b1e7565e45047e04ea0374f10762d16, 0x309544b6232c3dd737f945a03193d19b5f3f65b9, 0xb28bb39f3466517cd46f979cf59653ee7d8f152e, 0x9da8e22ca10e67fea44e525e4751eeac36a31194, 0x4f8ae80238e60008557075ab6afe0a7f2e74d729, 0x74ed33acf43f35b98c9230b9e6642ecb5330839e, 0x22842ab830da509913f81dd1f04f10af9edd1c55, 0xa8f37f0ab3a1d448a9e3ce40965f97a646083a34, 0x582b70669c97aab7d68148d8d4e90411e2810d56, 0xd5e55100fbd1956bbed2ca518d4b1fa376032b0b, 0xb7cc6b1acc32d8b295df68ed9d5e60b8f64cb67b, 0xe081ca1f4882db6043d5a9190703fde0ab3bf56d, 0xc02077449a134a7ad1ef7e4d927affeceeadb5ae, 0xe09fea755aee1a44c0a89f03b5deb762ba33006f, 0xb3717731dad65132da792d876030e46ac227bb8a, 0x157eb3d3113bd3b597714d3a954edd018982a5cb, 0xdc57345b38e0f067c9a31d9deac5275a10949321, 0x40ea5044b204b23076b1a5803bf1d30c0f88871a, 0x2bab0fbe28d58420b52036770a12f9952aea6911, 0xadaa0e548c035affed64ca678a963fabe9a26bfd, 0xbb48eaf516ce2dec3e41feb4c679e4957641164f, 0x7693bdeb6fc82b5bca721355223175d47a084b4d, 0x03cb98d7acd817de9d886d22fab3f1b57d92a608, 0xf88900db737955b1519b1a7d170a18864ce590eb, 0x757fa55446c460968bb74b5ebca96c4ef2c709c5, 0xda855d53477f505ec4c8d5e8bb9180d38681119c, 0xe41aea250b877d423a63ba2bce2f3a61c0248d56, 0x8262169b615870134eb4ac6c5f471c6bf2f789fc, 0x66b0c100c49149935d14c0dc202cce907cea1a3d, 0x854c0c469c246b83b5d1b3eca443b39af5ee128a, 0xeb6810691d1ae0d19e47bd22cebee0b3ba27f88a, 0x24dcc24bd9c7210ceacfb30da98ae04a4d7b8ab9, 0xe31b4eef184c24ab098e36c802714bd4743dd0d4, 0x99b8c824869de9ed24f3bff6854cb6dd45cc3f9f, 0x2ae73a79aea0278533accf21070922b1613f8f32, 0xddbd2b932c763ba5b1b7ae3b362eac3e8d40121a, 0x1b4bbcb18165211b265b280716cb3f1f212176e8, 0xe177e0c201d335ba3956929c571588b51c5223ae, 0x1945fe377fe6d4b71e3e791f6f17db243c9b8b0f, 0x3e9b34a57f3375ae59c0a75e19c4b641228d9700, 0xa4d6c82eddae5947fbe9cdfbd548ae33d91a7191, 0xbad4425e171c3e72975eb46ac0a015db315a5d8f, 0xa2d2aa626b09d6d4e4b13f7ffc5a88bd7ad36742, 0xb61c34fcacda701a5aa8702459deb0e4ae838df8, 0x145e0600e2a927b2dd8d379356b45a2e7d51d3ae, 0x8df339214b6ad1b24663ce716034749d6ef838d9, 0x8fd9a5c33a7d9edce0997bdf77ab306424a11ea9, 0x097da12cfc1f7c1a2464def08c29bed5e2f851e9, 0xddabf13c3c8ea4e3d73d78ec717afafa430e5479, 0x9eeb07bd2b7890195e7d46bdf2071b6617514ddb, 0x819af9a1c27332b1c369bbda1b3de1c6e933d640, 0xd7d2c6fca8ad1f75395210b57de5dfd673933909, 0xcdd5d881a7362c9070073bdfbc75e72453ac510e, 0xe9ac36376efa06109d40726307dd1a57e213eaa9, 0x1bea4df5122fafdeb3607eddda1ea4ffdb9abf2a, 0x3e5e93fb4c9c9d1246f8f247358e22c3c5d17b6a, 0x6c1ddd33c81966dc8621776071a4129482f2c65f, 0x2ccb66494d0af689abf9483d365d782444e7dead, 0x19571a2b8f81c6bcf66ab3a10083295617150003, 0x38ac664ee8e0795e4275cb852bcba6a479ad9c8d, 0xc4803bb407c762f90b7596e6fde194931e769590, 0x93507e9e8119cbceda8ab087e7ecb071383d6981, 0xb672734afcc224e2e609fc51d4f059732744c948, 0xfbbbebcfbe235e57dd2306ad1a9ec581c7f9f48f, 0x8c81410ea8354cc5c65c41be8bd5de733c0b111d, 0x942c6b8c955bc0d88812678a236725b32739d947, 0xd2e817738abf1fb486583f80c350318bed860c80, 0xbff5df769934b8943ca9137d0efef2fe6ebbb34e, 0x6c4e426e8dc005dfa3516cb8a680b02eea95ae8e, 0xf645dd7c890093e8e4c8aa92a6bb353522d3dc98, 0x4bac846af4169f1d95431b341d8800b22180af1a, 0x0514954c3c2fb657f9a06f510ea22748f027cdd3, 0x163dca73d7d6ea3f3e6062322a8734180c0b78ef, 0xfeaca2ac74624bf348dac9985143cfd652a4be55, 0xfe80e9232deaff19baf99869883a4bdf0004e53c, 0x17108dab2c50f99de110e1b3b3b4cd82f5df28e7, 0x837a645dc95c49549f899c4e8bcf875324b2f57c, 0x762998e1d75227fced7a70be109a4c0b4ed86414, 0xc0a7e8435dff14c25577739db55c24d5bf57a3d9, 0xaead88d689416b1c91f2364421375b7d3c70fb2e, 0x9279b2228cec8f7b4dda3f320e9a0466c2f585ca, 0x36726f3b885a24f92996da81625ec8ad16d8cbe6, 0x3951e48e3c869e6b72a143b6a45068cdb9d466d0, 0xf5d61ac4ca95475e5b7bffd5f2f690b316759615, 0x158a0d619253bf4432b5cd02c7b862f7c2b75636, 0xe56d431324c92911a1749df292709c14b77a65cd, 0x9976947eff5f6ae5da08dd541192f378b428ff94, 0x83210583c16a4e1e1dac84ebd37e3d0f7c57eba4, 0xdcb64df43758c7cf974fa660484fbb718f8c67c1, 0xd4205592844055b3c7a1f80cefe3b8eb509bcde7, 0xd0648a581b3508e135a2935d12c9657045d871ca, 0xe7d17524d00bad82497c0f27156a647ff51d2792, 0x21582e99e502cbf3d3c23bdffb76e901ac6d56b2, 0xe61f280915c774a31d223cf80c069266e5adf19b, 0x03c91d92943603e752203e05340e566013b90045, 0x22561c5931143536309c17e832587b625c390b9a, 0xe399c81a1d701b44f0b66f3399e66b275aaaf8c1, 0x7f8dbce180ed9c563635aad2d97b4cbc428906d9, 0x9f61beb46f5e853d0a8521c7446e68e34c7d0973, 0x6d3f2ba856ccbb0237fa7661156b14b013f21240, 0x5f742e487e3ab81af2f94afdbe1b9b8f5ccc81bc, 0xb600feab4aa96c537504d96057223141692c193a, 0xfab487500df20fb83ebed916791d561772adbebf, 0xf8704c16d2fd5ba3a2c01d0eb20484e6ecfa3109, 0x3f1bc420c53c002c9e90037c44fe6a8ef4ddc962, 0x82e577b515cb2b0860aafe1ce09a59e09fe7d040, 0xbc999e385c5aebcac8d6f3f0d60d5aa725336d0d, 0xe16ce35961cd74bd590d04c4ad4a1989e05691c6, 0xeb76424c0fd597d3e341a9642ad1ee118b2b579d, 0xc440c7ca2f964b6972ef664a2261dde892619d9c, 0x460d5355b2ceeb6e62107d81e51270b26bf45620, 0xfcada300283f6bcc134a91456760b0d77de410e0, 0xbe8d7f18adfe5d6cc775394989e1930c979d007d, 0xa7f9220c8047826bd5d5183f4e676a6d77bfed36, 0x98d204f9085f8c8e7de23e589b64c6eff692cc63, 0x5a2916b8d2e8cc12e207ab464d433e2370d823d9, 0xc42d6aeb710e3a50bfb44d6c31092969a11aa7f3, 0x04ce45f600db18a9d0851b29d9393ebdaafe3dc5, 0x7a1370a742ec2687e761a19ac5a794329ee67404, 0xda2ad58e77deddede2187646c465945a8dc3f641, 0xec58bc0d0c20d8f49465664153c5c196fe59e6be, 0xf8063af4cc1dd9619ab5d8bff3fcd1faa8488221, 0xb9231eb26e5f9e4b4d288f03906704fab96c87d6, 0x6e5c2d9b1c546a86eefd5d0a5120c9e4e730190e, 0xe49936a92a8ccf710eaac342bc454b9b14ebecb1, 0x21dbdb817a0d8404c6bdd61504374e9c43c9210e, 0x5cebe30b2a95f4aefda665651dc0cf7ef5758199, 0x597038ff91a0900cbbab488af483c790e6ec00a0, 0x0fa5d8c5b3f294efd495ab69d768f81872508548, 0xfeef3b6eabc94affd3310c1c4d0e65375e131119, 0x1ce81d31a7923022e125bf48a3e03693b98dc9dd, 0x5887dc6a33dfed5ac1edefe35ef91a216231ac96, 0x4e8e47ae3b1ef50c9d54a38e14208c1abd3603c2, 0xe845e387c4cbdf982280f6aa01c40e4be958ddb2, 0x71d9494e50c5dd59c599dba3810ba1755e6537f0, 0x6eb5578a6bb7c32153195b0d8020a6914852c059, 0x543f8c674e2462d8d5daa0e80195a8708e11a29e, 0xa0459ef3693aacd1647cd5d8929839204cef53be, 0xdda371e600d30688d4710e088e02fdf2b9524d5f, 0xdd4dd6d36033b0636fcc8d0938609f4dd64f4a86, 0x3bd624b548cb659736907ed8aa3c0c705e24b575, 0x414599092e879ae25372a84d735af5c4e510cd6d, 0x3d66cd4bd64d5c8c1b5eea281e106d1c5aad2373, 0x5948bc3650ed519bf891a572679fd992f8780c57, 0x8b74a7cb1bb8c58fce267466a30358adaf527f61, 0x3f10800282d1b7ddc78fa92d8230074e1bf6aeae, 0x32dbb6716c54e83165829a4abb36757849b6e47d, 0xe6b3ac3f5d4da5a8857d0b3f30fc4b2b692b77d7, 0x052a58e035f1fe9cdd169bcf20970345d12b9c51, 0x581bdf1bb276dbdd86aedcdb397a01efc0e00c5b, 0x604e9477ebf4727c745bcabbedcb6ccf29994022, 0x59b96deb8784885d8d3b4a166143cc435d2555a1, 0x37d980a12ee3bf23cc5cdb63b4ae45691f74c837, 0x3bfbd3847c17a61cf3f17b52f8eba1b960b3f39f, 0x49c941e0e5018726b7290fc473b471d41dae80d1, 0xf26bcedce3feadcea3bc3e96eb1040dfd8ffe1a0, 0xd0944aa185a1337061ae20dc9dd96c83b2ba4602, 0x904caa429c619d940f8e6741826a0db692b19728, 0xb95c9b10aa981cf4a67a71cc52c504dee8cf58bd, 0x15874686b6733d10d703c9f9bec6c52eb8628d67, 0x1374facd7b3f8d68649d60d4550ee69ff0484133, 0xb0e469c886593815b3495638595daef0665fae62, 0x47ff6feb43212060bb1503d7a397fc08f4e70352, 0xc60b04654e003b4683041f1cbd6bc38fda7cdbd6, 0x3ecdb532e397579662b2a46141e78f8235936a5f, 0xb3a8c2cb7d358e5739941d945ba9045a023a8bbb, 0x32ef5cdc671df5562a901aee5db716b9be76dcf6, 0xc94110e71afe578aa218e4fc286403b0330ace8d, 0x9b43dcb95fde318075a567f1e6b57617055ef9e8, 0xefeea010756f81da4ba25b721787f058170befbd, 0xc88255eddcf521c6f81d97f5a42181c9073d4ef1, 0xdd47189a3e64397167f0620e484565b762bfbbf4, 0x82f39b2758ae42277b86d69f75e628d958ebcab0, 0xe37f5fdc6ec97d2f866a1cfd0d3a4da4387b22b5, 0x62331df2a3cbee3520e911dea9f73e905f892505, 0x8c5d16ed65e3ed7e8b96ca972bc86173e3500b03, 0x8b9841862e77fbbe919470935583a93cf027e450, 0xc8dd27f16bf22450f5771b9fe4ed4ffcb30936f4, 0xdec8a1a898f1b895d8301fe64ab3ad5de941f689, 0x61c4ee7c864c4d6b5e37ea1331c203739e826b2f, 0x3250e3e858c26adeccadf36a5663c22aa84c4170, 0x299e0bca55e069de8504e89aca6eca21d38a9a5d, 0xd50f7fa03e389876d3908b60a537a6706304fb56, 0x69073269729e6414b26ec8dc0fd935c73b579f1e, 0x14fcd1391e7d732f41766cdacd84fa1deb9ffdd2, 0x823768746737ce6da312d53e54534e106f967cf3, 0x882f75708386653c80171d0663bfe30b017ed0ad, 0xa25b086437fd2192d0a0f64f6ed044f38ef3da32, 0x5a9c8b69fc614d69564999b00dcb42db67f97e90, 0xa2b701f9f5cdd09e4ba62baebae3a88257105885, 0x5e7b8c54dc57b0402062719dee7ef5e37ea35d62, 0x7ffabfbc390cbe43ce89188f0868b27dcb0f0cad, 0xb5cdbc4115406f52e5aa85d0fea170d2979cc7ba, 0x263814309de4e635cf585e0d365477fc40e66cf7, 0x24cff0e9336a9f80f9b1cb968caf6b1d1c4932a4, 0xd3a941c961e8ca8b1070f23c6d6d0d2a758a4444, 0xa97beb3a48c45f1528284cb6a95f7de453358ec6, 0x4dd131c74a068a37c90aded4f309c2409f6478d3, 0x653675b842d7d8b461f722b4117cb81dac8e639d, 0x561be9299b3e6b3e63b79b09169d1a948ae6db01, 0xdc067ed3e12d711ed475f5156ef7e71a80d934b9, 0x08d97eadfcb7b064e1ccd9c8979fbee5e77a9719, 0x6e4c2ab7db026939dbd3bc68384af660a61816b2, 0xbf4c73a7ede7b164fe072114843654e4d8781dde, 0xf504943aaf16796e0b341bbcdf21d11cc586cdd1, 0xea81ca8638540cd9d4d73d060f2cebf2241ffc3e, 0x9944fee9d34a4a880023c78932c00b59d5c82a82, 0x12f460ae646cd2780fd35c50a6af4b9accfa85c6, 0x4e232d53b3e6be8f895361d31c34d4762b12c82e, 0x6bb2aca23fa1626d18efd6777fb97db02d8e0ae4, 0xbc4e471560c99c8a2a4b1b1ad0c36aa6502b7c4b, 0x2e2cbd7ad82547b4f5ff8b3ab56f942a6445a3b0, 0x21ecb2dfa65779c7592d041cd2105a81f4fd4e46, 0x34318625818ec13f11835ae97353ce377d6f590a, 0xa7ef35ce87eda6c28df248785815053ec97a5045, 0x6a514e6242f6b68c137e97fea1e78eb555a7e5f7, 0x9340b5f678e45ee05eb708bb7abb6ec8f08f1b6b, 0x43cc08d0732aa58adef7619bed46558ad7774173, 0x12e9a4ad2ad57484dd700565bddb46423bd9bd31, 0xebbeeb259184a6e01cccfc2207bbd883785ac90a, 0x704ab1150d5e10f5e3499508f0bf70650f028d4b, 0xfc361105dd90f9ede566499d69e9130395f12ac8, 0xc1b9a5704d351cfe983f79abeec3dbbbae3bb629, 0x66f50406eb1b11a946cab45927cca37470e5a208, 0x53942e7949d6788bb780a7e8a0792781b1614b84, 0x32ba9a7d0423e03a525fe2ebeb661d2085778bd8, 0x11c0358aa6479de21866fe21071924b65e70f8b9, 0x76cb9c8b69f4387675c48253e234cb7e0d74a426, 0x9f5f44026b576a4adb41e95961561d41039ca391, 0x533a73a4a2228eee05c4ffd718bbf3f9c1b129a7, 0xdcc52d8f8d9fc742a8b82767f0555387c563efff, 0xf456a75bb99655a7412ce97da081816dfdb2b1f2, 0xd0c101fd1f01c63f6b1d19bc920d9f932314b136, 0xdabc225042a6592cfa13ebe54efa41040878a5a2, 0x38eec6e217f4d41aa920e424b9525197041cd4c6, 0x8a247d186510809f71cffc4559471c3910858121, 0x4f152b2fb8659d43776ebb1e81673aa84169be96, 0xb4496ddb27799a222457d73979116728e8a1845b, 0x4a4053b31d0ee5dbafb1d06bd7ac7ff3222c47d6, 0x0f7bea4ef3f73ae0233df1e100718cbe29310bb0, 0xc836e24a6fcf29943b3608e662290a215f6529ea, 0x1765361c2ec2f83616ce8363aae21025f2566f40, 0xb6e6c3222b6b6f9be2875d2a89f127fb64100fe2, 0x01bbc14f67af0639aab1441e6a08d4ce7162090f, 0xaf2058c7282cf67c8c3cf930133c89617ce75d29, 0x464d9c89cce484df000277198ed8075fa63572d1, 0x50cd97e9378b5cf18f173963236c9951ef7438a5, 0xcb47bd30cfa8ec5468aaa6a94642ced9c819c8d4, 0x6b10f8f8b3e3b60de90aa12d155f9ff5ffb22c50, 0x09b7a988d13ff89186736f03fdf46175b53d16e0, 0x5bfafe97b1dd1d712be86d41df79895345875a87, 0xa06cd1f396396c0a64464651d7c205efaf387ca3, 0xfc0096b21e95acb8d619d176a4a1d8d529badbef, 0xa74444f90fbb54e56f3ac9b6cfccaa4819e4614a, 0x3c15b3511df6f0342e7348cc89af39a168b7730f, 0x3d6ff82c9377059fb30d9215723f60c775c891fe, 0xa524a8cccc49518d170a328270a2f88133fbaf5d, 0x8a7a06be199a3a58019d846ac9cbd4d95dd757de, 0xd744ac7e5310be696a63b003c40bd039370561c6, 0xfe362688845fa244cc807e4b1130eb3741a8051e, 0xb2d0360515f17daba90fcbac8205d569b915d6ac, 0xc53594c7cfb2a08f284cc9d7a63bbdfc0b319732, 0xb3c228731d186d2ded5b5fbe004c666c8e469b86, 0x63e414603e80d4e5a0f5c18774204642258208e4, 0x826ce5790532e0548c6102a30d3eac836bd6388f, 0xc5e812f76f15f2e1f2f9bc4823483c8804636f67, 0x116fef5e601642c918cb89160fc2293ba71da936, 0x08b84536b74c8c01543da88b84d78bb95747d822, 0x04a80afad53ef1f84165cfd852b0fdf1b1c24ba8, 0x2b0362633614bfcb583569438ecc4ea57b1d337e, 0xe95179527deca5916ca9a38f215c1e9ce737b4c9, 0x2c5df866666a194b26cebb407e4a1fd73e208d5e, 0x529e824fa072582b4032683ac7eecc1c04b4cac1, 0x78634371e17304cbf339b1452a4ce438dc764cce, 0xe172dfc8f80cd1f8cd8539dc26082014f5a8e3e8, 0xb07618328a901307a1b7a0d058fcd5786e9e72fe, 0xb0571153db1c4ed7acaefe13ecdfdb72e7e4f06a, 0xad910a23d6850613654af786337ad2a70868ac6d, 0x4da5edc688b0cb62e1403d1700d9dcb99ffe3fd3, 0xbe2471a67f6047918772d0e36839255ed9d691ae, 0x28868324337e11ba106cb481da962f3a8453808d, 0xd8f94579496725b5cb53d7985c989749aff849c0, 0x4981c5ff66cc4e9680251fc4cd2ff907cb327865, 0xfd2872d19e57853cfa16effe93d0b1d47b4f93fb, 0x63c8dfde0b8e01dadc2e748c824cc0369df090b3, 0xc4dd048bfb840e2bc85cb53fcb75abc443c7e90f, 0xf579714a45eb8f52c3d57bbdefd2c15b2e2f11df, 0xcc7b0481cc32e6faef2386a07022bcb6d2c3b4fc, 0xa0aa5f0201f04d3bbeb898132f7c11679466d901, 0xf3df63a97199933330383b3ed7570b96c4812334, 0x42732d8ef49ffda04b19780fd3c18469fb374106, 0x6f92d6e4548c78996509ee684b2ee29ba3c532b4, 0xfff4bad596633479a2a29f9a8b3f78eefd07e6ee, 0xac4460a76e6db2b9fcd152d9c7718d9ac6ed8c6f, 0x553b6b1c57050e88cf0c31067b8d4cd1ff80cb09, 0x84b6b6adbe2f5b3e2d682c66af1bc4905340c3ed, 0x9f4a7195ac7c151ca258cafda0cab083e049c602, 0x2955c357fd8f75d5159a3dfa69c5b87a359dea8c, 0x11d7844a471ef89a8d877555583ceebd1439ea26, 0x34b454416e9fb4274e6addf853428a0198d62ee1, 0x308dd21cebe755126704b48c0f0dc234c60ba9b1, 0x381db4c8465df446a4ce15bf81d47e2f17c980bf, 0x1abc4e253b080aeb437984ab05bca0979aa43e1c, 0x53e35b12231f19c3fd774c88fec8cbeedf1408b2, 0x69e2e2e704307ccc5b5ca3f164fece2ea7b2e512, 0x1914f1eb95d1277e93b6e61b668b7d77f13a11a1, 0x50e13023bd9ca96ad4c53fdfd410cb6b1f420bdf, 0x46224f32f4ece5c8867090d4409d55e50b18432d, 0xff83855051ee8ffb70b4817dba3211ed2355869d, 0xfb39189af876e762c71d6c3e741893df226cedd6, 0x9875623495a46cdbf259530ff838a1799ec38991, 0xe1b39b88d9900dbc4a6cdc481e1060080a8aec3c, 0x5baf6d749620803e8348af3710e5c4fbf20fc894, 0x9c54e4ed479a856829c6bb42da9f0b692a75f728, 0x486a6c8583a84484e3df43a123837f8c7e2317d0, 0xd235d15cb5eceebb61299e0e827fa82748911d89, 0x47d792a756779aedf1343e8883a6619c6c281184, 0x70c213488a020c3cfb39014ef5ba6404724bcaa3, 0x133c490fa5bf7f372888e607d958fab7f955bae1, 0xa9e194661aac704ee9dea043974e9692ded84a5d, 0xbc6b58364bf7f1951c309e0cba0595201cd73f9a, 0x2309d34091445b3232590bd70f4f10025b2c9509, 0xd89bc271b27ba3ab6962c94a559006ae38d5f56a, 0xff0e2fec304207467e1e3307f64cbf30af8fd9cd, 0xc0b0b7a8a6e1acdd05e47f94c09688aa16c7ad8d, 0xb66f92124b5e63035859e390628869dbdea9485e, 0xa9e6e25e656b762558619f147a21985b8874edfe, 0xa43e1947a9242b355561c30a829dfeeca2815af8, 0x8b20ad3b94656dbdc0dd21a393d8a7d9e02138cb, 0xaca2a838330b17302da731d30db48a04f0f207c1, 0xfa60868aafd4ff4c5c57914b8ed58b425773dfa9, 0x1848003c25bfd4aa90e7fcb5d7b16bcd0cffc0d8, 0xb4b185d943ee2b58631e33dff5af6854c17993ac, 0x7719888795ad745924c75760ddb1827dffd8cda8, 0xccd521132d986cb96869842622a7dda26c3ed057, 0x253e32b74ea4490ab92606fda0aa257bf23dcb8b, 0x3712367e5e55a96d5a19168f6eb2bc7e9971f869, 0x8f29a14a845ad458f2d108b568d813166bcdf477, 0x51a8c2163602a32ee24cf4aa97fd9ea414516941, 0x61cea71fa464d62a07063f920b0cc917539733d8, 0x6f81f3abb1f933b1df396b8e9cc723a89b7c9806, 0x61b1b8c012cd4c78f698e470f90256e6a30f48dd, 0x4f3f2c673069ac97c2023607152981f5cd6063a0, 0xe2efa5fca79538ce6068bf31d2c516d4d53c08e5, 0x2383c222e67e969190d3219ef14da37850e26c55, 0xeac3af5784927fe9a598fc4eec38b8102f37bc58, 0x4fe56ab3bae1b0a44433458333c4b05a248f8241, 0xfe9cfc3bb293ddb285e625f3582f74a6b0a5a6cd, 0xf48e1f13f6af4d84b371d7de4b273d03a263278e, 0x1ba9228d388727f389150ea03b73c82de8eb2e09, 0x37a7a6ff4ea3d60ec307ca516a48d3053bb79cbb, 0xe33840d8bca7da98a6f3d096d83de78b70b71ef8, 0x8e7fd23848f4db07906a7d10c04b21803bb08227, 0x07d4334ec385e8aa54eedaeadb30022f0cdfa4ab, 0xd4b085fb086f3d0d68bf12926b1cc3142cae8770, 0x5a87f034e6f68f4e74ffe60c64819436036cf7d7, 0xc00ab080b643e1c2bae363e0d195de2efffc1c44, 0x22f3c779dd79023ea92a78b65c1a1780f62d5c4a, 0xc7d5c7054081e918ec687b5ab36e973d18132935, 0x9662ee021926682b31c5f200ce457abea76c6ce9, 0x116a09df66cb150e97578e297fb06e13040c893c, 0xb7240af2af90b33c08ae9764103e35dce3638428, 0xe8b28acda971725769db8f563d28666d41ddab6c, 0x17d4918dfac15d77c47f9ed400a850190d64f151, 0xc42250b0fe42e6b7dcd5c890a6f0c88f5f5fb574, 0x5da2a9a4c2c0a4a924cbe0a53ab9d0c627a1cfa0, 0x5869fb867d71f1387f863b698d09fdfb87c49b5c, 0xd49a75bb933fca1fca9aa1303a64b6cb44ea30e1, 0x76331e30796ce664b2700e0d4153700edc869777, 0x8a5fb75793d043f1bcd43885e037bd30a528c927, 0xfc0ee6f7c2b3714ae9916c45566605b656f32441, 0xbf50ce2e264b9fe2b06830617aedf502b2351b45, 0x0f6000de1578619320aba5e392706b131fb1de6f, 0xc953f934c0eb2d0f144bdab00483fd8194865ce7, 0x24fd9a6c874c2fab3ff36e9afbf8ce0d32c7de92, 0xc6cd68ec35362c5ad84c82ad4edc232125912d99, 0x2a67660a1368efcd626ef36b2b1b601980941c05, 0x9deb39027af877992b89f2ec4a1f822ecdf12693, 0xc12f881fa112b8199ecbc73ec4185790e614a20f, 0xd58a52e078a805596b0d56ea4ae1335af01c66eb, 0x4d7cfaa84cb33106800a8c802fb8aa463896c599, 0x0ee391f03c765b11d69026fd1ab35395dc3802a0, 0xa192f06ab052d5fd7f94eea8318e827815fe677a, 0x8f0ab894bd3f4e697dbcfb859d497a9ba195994a, 0x387eeafd6b4009deaf8bd5b85a72983a8dcc3487, 0x03b0f17cd4469ddccfb7da697e82a91a5f9e7774, 0x11172b278ddd44eea2fdf4cb1d16962391c453d9, 0x33d172ab075c51db1cd40a8ca8dbff0d93b843bb, 0x909b5e763a39dcc795223d73a1dbb7d94ca75ac8, 0x0ca12ab0b9666cf0cec6671a15292f2653476ab2, 0x6b5ae7bf78ec75e90cb503c778ccd3b24b4f1aaf, 0xd9e3857efd1e202a441770a777a49dcc45e2e0d3, 0xd703c6a4f11d60194579d58c2766a7ef16c30a29, 0x838bd565f99fde48053f7917fe333cf84ad548ab, 0x8168edce7f2961cf295b9fcd5a45c06cdeda6ef5, 0xde50868eb7e3c71937ec73fa89dd8b9ee10d45aa, 0x087498c0464668f31150f4d3c4bcdda5221ba102, 0x613fab44b16bbe554d44afd178ab1d02f37aeaa5, 0xe2ee691f237ee6529b6557f2fcdd3dcf0c59ec63, 0xa9ed377b7d6ec25971c1a597a3b0f3bead57c98f, 0x175feeea2aa4e0efda12e1588d2f483290ede81a, 0xb51ddcb4dd4e8ae6be336dd9654971d9fec86b41, 0x92c0f573eccf62c54810ee6ba8d1f113542b301b, 0xa109e18bb0a39c9ef82fa19597fc5ed8e9eb6d58, 0xf74e6e145382b4db821fe0f2d98388f45609c69f, 0x378f37243f3ff0bef5e1dc85eb4308d9340c29f9, 0x84e9949680bece6841b9a7e5250d08acd87d16cd, 0x882bd3a2e9d74110b24961c53777f22f1f46dc5d, 0xacce01e0a70610dc70bb91e9926fa9957f372fba, 0xc5f687717246da8a200d20e5e9bcac60b67f3861, 0xe14617f6022501e97e7b3e2d8836aa61f0ff2dba, 0x076ee99d3548623a03b5f99859d2d785a1778d48, 0x2c424ee47f583cdce07ae318b6fad462381d4d2b, 0xf98250730c4c61c57f129835f2680894794542f3, 0xed1b24b6912d51b334ac0de6e771c7c0454695ea, 0xffd5170fd1a8118d558e7511e364b24906c4f6b3, 0xbf49c14898316567d8b709c2e50594b366c6d38c, 0x65ea26eabbe2f64ccccfe06829c25d4637520225, 0x5c5419565c3aad4e714e0739328e3521c98f05cc, 0xc53b50fd3b2b72bc6c430baf194a515585d3986d, 0x2b74c373d04bfb0fd60a18a01a88fbe84770e58c, 0xd97f4526dea9b163f8e8e33a6bcf92fb907de6ec, 0xa4a49f0bc8688cc9e6dc04e1e08d521026e65574, 0x575c00c2818210c28555a0ff29010289d3f82309, 0x3f1233714f204de9de4ee96d073b368d8197989f, 0xf964d98d281730ba35b2e3a314796e7b42fedf67, 0x1deec01abe5c0d952de9106c3dc30639d85005d6, 0x12d60d65b7d9fc48840be5f891c745ce76ee501e, 0x5c6136e218de0a61a137b2b3962d2a6112b809d7, 0xcd43258b7392a930839a51b2ef8ad23412f75a9f, 0xdb3f258ab2a3c2cf339c4499f75a4bd1d3472e9e, 0x0edd4b580ff10fe06c4a03116239ef96622bae35, 0x1d157c5876c5cad553c912caf6ce2d5277e05c73, 0xcda1b886e3a795c9ba77914e0a2fe5676f0f5ccf, 0xf50cbafd397edd556c0678988cb2af5c2617e0a2, 0x327bb49e754f6fb4f733c6e06f3989b4f65d4bee, 0xc44bdec8c36c5c68baa2ddf1d431693229726c43, 0x34e2849bea583ab0cc37975190f322b395055582, 0x9221c9ce01232665741096ac07235903ad1fe2fc, 0xff3ded7a40d3aff0d7a8c45fa6136aa0433db457, 0x10b5b34d1248fcf017f8c8ffc408ce899ceef92f, 0xf1a1f320407964fd3c8f2e2cc8a4580da94f01ea, 0x6c800d4b49ba07250460f993b8cbe00b266a2553, 0xf827d56ed2d32720d4abf103d6d0ef4d3bcd559b, 0xffb9c7217e66743031eb377af65c77db7359dcda, 0x530319db0a8f93e5bb7d4dbf4816314fbed8361b, 0x9c28a2c4086091cb5da226a657ce3248e8ea7b6f, 0xdb23a6fef1af7b581e772cf91882deb2516fc0a7, 0x6636d7ac637a48f61d38b14cfd4865d36d142805, 0xb3c260609b9df4095e6c5dff398eeb5e2df49985, 0x58e5c9e344c806650dacfc904d33edba5107b0de, 0x4f67396d2553f998785f704e07a639197dd1948d, 0x510d8159cc945768c7450790ba073ec0d9f89e30, 0x593c48935beaff0fde19b04d309cd530a28e52ce, 0xc27f4e08099d8cf39ee11601838ef9fc06d7fc41, 0x07723e3c30e8b731ee456a291ee0e798b0204a77, 0x0a652e2a8b77bd97a790d0e91361c98890dbb04e, 0x671015b97670b10d5e583f3d62a61c1c79c5143f, 0x7cc24a6a958c20c7d1249660f7586226950b0d9a, 0x6ef9e8c9b6217d56769af97dbb1c8e1b8be799d2, 0x5c4368918ace6409c79eca80cdaae4391d2b624e, 0x043707071e2ae21eed977891dc79cd5d8ee1c2da, 0x39bfd978689bec048fc776aa15247f5e1d7c39a2, 0x05915d4e225a668162aee7d6c25fcfc6ed18db03, 0x3f551ba93cd54693c183fb9ad60d65e1609673c9, 0xa8c0b02faf02cb5519dda884de7bbc8c88a2da81, 0xbd0c5cd799ebc48642ef97d74e8e429064fee492, 0x0a931b449ea8f12cdbd5e2c8cc76bad2c27c0639, 0x2ea5fee63f337a376e4b918ea82148f94d48a626, 0xcc6c2df00e86eca40f21ffda1a67a1690f477c65, 0xe5e37e19408f2cfbec83349dd48153a4a795a08f, 0xf555a27bb1e2fd4e2cc784caee92939fc06e2fc9, 0xdcf9719be87c6f46756db4891db9b611d2469c50, 0x8e2f9034c9254719c38e50c9aa64305ed696df1e, 0xa01f12d70f44aa7b113b285c22dcdb45873454a7, 0xbce40475d345b0712dee703d87cd7657fc7f3b62, 0xbb19bf91cbad74cceb5f811db27e411bc2ea0656, 0xacc062702c59615d3444ef6214b8862b009a02ed, 0x449ac4fbe383e36738855e364a57f471b2bfa131, 0xad59a78eb9a74a7fbdaefafa82eada8475f07f95, 0x6b6577f3909a4d6de0f411522d4570386400345c, 0x79bf2f7b6e328aaf26e0bb093fa22da29ef2f471, 0x940f715140509ffabf974546fab39022a41952d2, 0x1d572edd2d87ca271a6714c15a3b37761dcca005, 0xd78ecd25adc86bc2051d96f65364866b42a426b7, 0xf9729d48282c9e87166d5eef2d01eda9dbf78821, 0x17762560e82a93b3f522e0e524adb8612c3a7470, 0xd500e4d1c9824ba9f5b635cfa3a8c2c38bbd4ced, 0xa11effab6cf0f5972cffe4d56596e98968144a8f, 0xf64ecf2117931c6d535a311e4ffeaef9d49405b8, 0x229cc4711b62755ea296445ac3b77fc633821cf2, 0xfc989cb487bf1a7d17e4c1b7c4b7aafdda6b0a8d, 0xea8527febfa1ade29e26419329d393b940bbb7dc, 0xbce13e22322acfb355cd21fd0df60cf93add26c6, 0x19ff244fcfe3d4fa2f4fd99f87e55bb315b81eb6, 0xd2581a55ce23ab10d8ad8c44378f59079bd6f658, 0x4073fa49b87117cb908cf1ab512da754a932d477, 0xb6a82933c9eadabd981e5d6d60a6818ff806e36b, 0xc79806032bc7d828f19ac6a640c68e3d820fa442, 0x577b2d073c590c50306f5b1195a4b2ba9ecda625, 0x7f13d760498d7193ca6859bc95c901386423d76c, 0x416784af609630b070d49a8bcd12235c6428a408, 0xfbe71622bcbd31c1a36976e7e5f670c07ffe16de, 0xa5698035391e67a49013c0002079593114feb353, 0xab2871e507c7be3965498e8fb462025a1a1c4264, 0x9c78fbb4df769ce2c156920cfedfda033a0e254a, 0x95e6f93dac228bc7585a25735ac2d076cc3a4017, 0x3c1f91f301f4b565bca24751aa1f761322709ddd, 0xf77f9587ff7a2d7295f1f571c886bd33926a527c, 0x755f587e5efff773a220726a13d0f2130d9f896b, 0x8c6aa882ee322ca848578c06cb0fa911d3608305, 0x492cb5f861b187f9df21cd4485bed90b50ffe22d, 0x95a577dc2eb3ae6cb9dfc77af697d7efdfe89a01, 0x4173419d5c9f6329551dc4d3d0ceac1b701b869e, 0x456ae0aca48ebcfae166060250525f63965e760f, 0x81f8de2c283d5fd4afbda85dedf9760eabbbb572, 0xcd0af3474e22f069ec3407870dd770443d5b12b0, 0x283c2314283c92d4b064f0aef9bb5246a7007f39, 0x29b3f561ee7a6e25941e98a5325b78adc79785f3, 0xcd4306d7f6947ac1744d4e13b8ef32cb657e1c00, 0xd9ec2efe99ff5cf00d03a8317b92a24aef441f7e, 0x83dbf8a12853b40ac61996f8bf1dc8fdbaddd329, 0x9d93fab6e22845f8f45a07496f11de71530debc7, 0xfd204f4f4aba2525ba728afdf78792cbdeb735ae, 0x99fad50038d0d9d4c3fbb4bce05606ecadcd5121, 0xd206aaddb336d45e7972e93cb075471d15897b5d, 0x428a1ee0ed331d7952ccbe1c7974b2852bd1938a, 0x690228e4bb12a8d4b5e0a797b0c5cf2a7509131e, 0xfa3a1aa4488b351aa7560cf5ee630a2fd45c3222, 0x0372e852582e0934344a0fed2178304df25d4628, 0x35ea2163a38cdf9a123f82a5ec00258dae0bc767, 0xd1fed0aee6f5dfd7e25769254c3cfad15adeccaa, 0xc05b740620f173f16e52471dc38b9c514a0b1526, 0x87e3062b2321e9dfb0875ce3849c9b2e3522d50a, 0x303fbaebbe46b35b6e5b74946a5f99bc1585cae7, 0xe7a8e471eafb798f4554cc6e526730fd56e62c7d, 0xad7dd053859edff1cb6f9d2acbed6dd5e332426f, 0xdc4345d6812e870ae90c568c67d2c567cfb4f03c, 0xa6a08252c8595177cc2e60fc27593e2379c81fb1, 0xa9af21acbe482f8131896a228036ba51b19453c3, 0x86e3fe86e93da486b14266eadf056cbfa4d91443, 0x744b03bba8582ae5498e2dc22d19949467ab53fc, 0xd3118ea3c83505a9d893bb67e2de142d537a3ee7, 0xb32f1c2689a5ce79f1bc970b31584f1bcf2283e7, 0x4828e4cbe34e1510afb72c2beeac8a4513eaebd9, 0xb07bcc085ab3f729f24400416837b69936ba8873, 0xbdc74873af922b9df474853b0fa7ff0bf8c82695, 0x15ebd1c7cad2aff19275c657c4d808d010efa0f5, 0xcbc04b4d8b82caf670996f160c362940d66fcf1a, 0x8197948121732e63d9c148194ecad46e30b749c8, 0x69797bfb12c9bed682b91fbc593591d5e4023728, 0xbe9b8c34b78ee947ff81472eda7af9d204bc8466, 0xdf3f57b8ee6434d047223def74b20f63f9e4f955, 0xa3ae1879007d801cb5f352716a4dd8ba2721de3d, 0xcb4bb1c623ba28dc42bdaaa6e74e1d2aa1256c2a, 0xe03c00d00388ecbf4f263d0ac778bb41a57a40d9, 0xfc2c1f88961d019c3e9ea33009152e0693fbf88a, 0x8599cbd5a6a9dcd4b966be387d69775da5e33c6f, 0xb7a31a7c38f3db09322eae11d2272141ea229902, 0x231a15acc199c89fa9cb22441cc70330bdcce617, 0x3fbed6e7e0ca9c84fbe9ebcf9d4ef9bb49428165, 0x92cfd60188efdfb2f8c2e7b1698abb9526c1511f, 0x5c936f3b9d22c403db5e730ff177d74eef42dbbf, 0x931fe712f64207a2fd5022728843548bfb8cbb05, 0x08d54e83ad486a934cfaeae283a33efd227c0e99, 0xa339a3d8ca280e27d2415b26d1fc793228b66043, 0x581f34b523e5b41c09c87c298e299cbc0e29d066, 0xcaaa68ee6cdf0d34454a769b0da148a1faaa1865, 0x0838a7768d9c2aca8ba279adfee4b1f491e326f1, 0xdde77a4740ba08e7f73fbe3a1674912931742eeb, 0xcbe810fe0fecc964474a1db97728bc87e973fcbd, 0x86c28b5678af37d727ec05e4447790f15f71f2ea, 0xdd6c062193eac23d2fdbf997d5063a346bb3b470, 0x5975b9528f23af1f0e2ec08ac8ebaa786a2cb8e0, 0xe29d8ae452dcf3b6ac645e630409385551faae0a, 0x2fbc85798a583598b522166d6e9dda121d627dbc, 0x7a36aba5c31ea0ca7e277baa32ec46ce93cf7506, 0xdbcbcd7a57ea9db2349b878af34b1ad642a7f1d1, 0x92aae59768eddff83cfe60bb512e730a05a161d7, 0xa5e93b49ea7c509de7c44d6cfeddef5910deaaf2, 0xe33d980220fab259af6a1f4b38cf0ef3c6e2ea1a, 0x8ed0af11ff2870da0681004afe18b013f7bd3882, 0xf23e5c633221a8f7363e65870c9f287424d2a960, 0x96334bfe04fffa590213eab36514f338b864b736, 0xfa1f1971a775c3504fef5079f640c2c4bce7ac05, 0xdf44c47fc303ac76e74f97194cca67b5bb3c023f, 0x4b74f5e58e2edf76daf70151964a0b8f1de0663c, 0xe38b91b35190b6d9deed021c30af094b953fdcaa, 0x6b38de841fad7f53fe02da115bd86aaf662466bd, 0x11675a25554607a3b6c92a9ee8f36f75edd3e336, 0x0ba8705bf55cf219c0956b5e3fc01c4474a6cdc1, 0x0f05f120c89e9fbc93d4ab0c5e2b4a0df092b424, 0xfdd1195f797d4f35717d15e6f9810a9a3ff55460, 0x63a61dc30a8e3b30a763c4213c801cbf98738178, 0xe5bdf34f4ccc483e4ca530cc7cf2bb18febe92b3, 0xd6e09e98fe1300332104c1ca34fbfac554364ed9, 0x5bd6862d517d4de4559d4eec0a06cad05e2f946e, 0x7294ec9da310bc6b4bbdf543b0ef45abfc3e1b4d, 0xae34861d342253194ffc6652dfde51ab44cad3fe, 0xf50ae7fab4cfb5a646ee04ceadf9bf9dd5a8e540, 0xdd2bdfa917c1f310e6fa35aa8af16939c233cd7d, 0xe0060462c47ff9679baef07159cae08c29f274a9, 0xb7d12e84a2e4c4a6345af1dd1da9f2504a2a996e, 0xf5500178cb998f126417831a08c2d7abfff6ab5f, 0xfd377a385272900cb436a3bb7962cdffe93f5dad, 0xa4a83a0738799b971bf2de708c2ebf911ca79eb2, 0x52a5e4de4393eeccf0581ac11b52c683c76ea15d, 0xb07fdeaff91d4460fe6cd0e8a1b0bd8d22a62e87, 0x35f5860149e4bbc04b8ac5b272be55ad1aca58e0, 0xfb135eb15a8bac72b69915342a60bbc06b7e077c, 0x02d4a30968a39e2b3498c3a6a4ed45c1c6646822, 0xe44b7264dd836bee8e87970340ed2b9aed8ed0a5, 0xe90a354cec04d69e5d96ddc0c5138d3d33150aa0, 0x693d83be09459ef8390b2e30d7f7c28de4b4284e, 0x87bf7cd5d8a929e1c785f9e5449106ac232463c9, 0xe5f8ef6d970636b0dcaa4f200ffdc9e75af1741c, 0xfef09d70243f39ed8cd800bf9651479e8f4aca3c, 0xe98c91cadd924c92579e11b41217b282956cdaa1, 0xc2836188d9a29253e0cbda6571b058c289a0bb32, 0xafa6946effd5ff53154f82010253df47ae280ccc, 0x43c7ebc5b3e7af16f47dc5617ab10e0f39b4afbb, 0x097ecda22567c2d91cb03f8c5215c22e9dcda949, 0x3e66b84769566ab67945d5fa81373556bcc3a1fa, 0x56373daab46316fd7e1576c61e6affcb6559ddd7, 0xfaaeba8fc0bbda553ca72e30ef3d732e26e82041, 0xf54c19d9ef3873bfd1f7a622d02d86249a328f06, 0x825309a7d45d1812f51e6e8df5a7b96f6c908887, 0x89009e3c6488bd5e570d1da34eabe28ed024de1b, 0x63977cad7d0dcdc52b9ac9f2ffa136e8642882b8, 0xc239abdfae3e9af5457f52ed2b91fd0ab4d9c700, 0x1a4ec6a0ae7f5a9427d23db9724c0d0cffb2ab2f, 0xa12a6c2d985daf0e4f5f207ae851aaf729b332cd, 0xcbe52fc533d7dd608c92a260b37c3f45deb4eb33, 0xabb2e6a72a40ba6ed908cdbcec3c5612583132fe, 0x6503860b191008c15583bfc88158099301762828, 0xa0228240f99e1de9cb32d82c0f2fa9a3d44b0bf3, 0xe154daeadb545838cbc6aa0c55751902f528682a, 0x8e92aba38e72a098170b92959246537a2e5556c0, 0xd23d7affacdc3e9f3dae7afcb4006f58f8a44600, 0x00d78d89b35f472716eceafebf600527d3a1f969, 0x120f9de6e0af7ec02a07c609ca8447f157e6344c, 0xe0352fdf819ba265f14c06a6315c4ac1fe131b2e, 0x8f47328ee03201c9d35ed2b5412b25decc859362, 0x453e359a3397944c5a275ab1a2f70a5e5a3f6989, 0x9bf58efbea0784eb068adecfa0bb215084c73a35, 0x21bfe1b45cacde6274fd8608d9a178bf3eeb6edc, 0xd1d5b17ffe2d7bbb79cc7d7930bcb2e518fb1bbf, 0x20a29c5079e26b3f18318bb2e50e8e8b346e5be8, 0x7d392852f3abd92ff4bb5bb26cb60874f2be6795, 0x55852943492970f8d629a15366cdda06a94f4513, 0xab5dfc1ea21adc42cf8c3f6e361e243fd0da61e5, 0x9d2bfc36106f038250c01801685785b16c86c60d, 0x6e60aee1a78f8eda8b424c73e353354ae67c3042, 0x7e29290038493559194e946d4e460b96fc38a156, 0x6006e36d929bf45d8f16231b126a011ae283d925, 0xd6d03572a45245dbd4368c4f82c95714bd2167e2, 0xd1432538e35b7664956ae495a32abdf041a7a21c, 0x2276264bec8526c0c0f270677abaf4f0e441e167, 0xc8814e34523e38e1f927a7dce8466a447a093603, 0x688a569e965524eb1d0ac3d3733eab909fb3d61e, 0x90dc09f717fc2a5b69fd60ba08ebf40bf4e8246c, 0x239a733e6b855ac592d663156186a8a174d2449e, 0xbcdfacb9d9023c3417182e9100e8ea1d373393a3, 0xba6440aeb3737b8ef0f1af9b0c15f4c214ffc7cf, 0x322e5c43b0f524389655a9b3ff24f2d4db3da10f, 0xbe5a60689998639ad75bc105a371743eef0f7940, 0xb727a9fc82e1cffc5c175fa1485a9befa2cdbdd1, 0xa3883a24f7f166205f1a6a9949076c26a76e7178, 0x5e95fe5ffcf998f9f9ac0e9a81dab83ead77003d, 0xe60955dc0bc156f6c41849f6bd776ba44b0ef0a1, 0xaf203e229d7e6d419df4378ea98715515f631485, 0x86499a1228ff2d7ee307759364506f8e8c8307a5, 0x1a04cec420ad432215246d77fe178d339ed0b595, 0xcc2b5f448f3528d3fe41cc7d1fa9c0dc76f1b776, 0xcb50587412822304ebcba07dab3a0f09fffee486, 0x4ae2a04d3909ef454e544ccfd614bfefa71089ae, 0xc8a2c4e59e1c7fc54805580438aed3e44afdf00e, 0x5792814f59a33a1843faa01baa089eb02ffb5cf1, 0xa1f2854050f872658ed82e52b0ad7bbc1cb921f6, 0x92dca5e102b3b81b60f1a504634947c374a88ccb, 0x732fead60f7bfdd6a9dec48125e3735db1b6654f, 0x6bf7b3c065f2c1e7c6eb092ba0d15066f393d1b8, 0xcde36d81d128c59da145652193eec2bfd96586ef, 0x40eddb448d690ed72e05c225d34fc8350fa1e4c5, 0x454b61b344c0ef965179238155f277c3829d0b38, 0xac3da526cfce88297302f34c49ca520dc271f9b2, 0xc989eec307e8839b9d7237cfda08822962abe487, 0xe99de258a4173ce9ac38ede26c0b3bea3c0973d5, 0xff0cb06c42e3d88948e45bd7b0d4e291aefeea51, 0x0990e81cd785599ea236bd1966cf526302c35b9c, 0x6da0ed8f1d69339f059f2a0e02471cb44fb8c3bb, 0x5d958a9bd189c2985f86c58a8c69a7a78806e8da, 0x98be696d51e390ff1c501b8a0f6331b628ddc5ad, 0x09d0b8cd077c69d9f32d9cca43b3c208a21ed48b, 0x96e7c0c9d5bf10821bf140c558a145b7cac21397, 0x5b736eb18353629bde9676dadd165034ce5ecc68, 0xe5a365343cc4eb1e770368e1f1144a77b832d7e0, 0x4cf5537b85842f89cfee359eae500fc449d2118f, 0xc71f1d75873f33dcb2dd4b3987a12d0791a5ce27, 0x9bf703b41c3624e15f4054962390bcba3052f0fd, 0x145e1de0147911ccd880875fbbea61f6a142d11d, 0x68419c6dd2d3ce6fcbb3c73e2fa079f06051bde6, 0xd8eb78503ec31a54a90136781ae109004c743257, 0xf25e4c70bc465632c89e5625a832a7722f6bffab, 0x7b4d2a38269069c18557770d591d24c5121f5e83, 0x27d158ac3d3e1109ab6e570e90e85d3892cd7680, 0xd3679a47df2d99a49b01c98d1c3e0c987ce1e158, 0x095b949de3333a377d5019d893754a5e4656ff97, 0x6b17598a8ef54f797ae515ccb6517d1859bf8011, 0x3eaf0879b5b6db159b589f84578b6a74f6c10357, 0x40d45d9d7625d15156c932b771ca7b0527130958, 0x0392549a727f81655429cb928b529f25df4d1385, 0xc5b009baeaf788a276bd35813ad65b400b849f3b, 0x6ed884459f809dfa1016e770edaf3e9fef46fa30, 0x439d2f2f5110a4d58b1757935015408740fec7f8, 0xdc46c13325cd8edf0230d068896486f007bf4ef1, 0x8c54c7f8b9896e75d7d5f5c760258699957142ad, 0x61c8f1fa43bf846999ecf47b2b324dfb6b63fe3a, 0x935069444a6a984de2084e46692ab99f671fc727, 0xfc49c1439a41d6b3cf26bb67e0365224e5e38f5f, 0xe1dfb5cc890ee8b2877e885d267c256187d019e6, 0xee7c3ded7c28f459c92fe13b4d95bafbab02367d, 0xa5874d754635a762b381a5c4c792483af8f23d1d, 0xcfbb32b7d024350e3321fa20c9a914035372ffc6, 0x2bc429d618a66a4cf82dbb2d824e9356effa126a, 0xdb244f97d9c44b158a40ed9606d9f7bd38913331, 0x55e220876262c218af4f56784798c7e55da09e91, 0xca41ccac30172052d522cd2f2f957d248153409f, 0xb11fa7fb270abcdf5a2eab95aa30c4b53636efbf, 0x0ffea06d7113fb6aec2869f4a9dfb09007facef4, 0x646628a53c2c4193da88359ce718dadd92b7a48d, 0xca8409083e01b397cf12928a05b68455ce6201df, 0xdbbcbb79bf479a42ad71dbcab77b5adfaa872c58, 0xdb7d4037081f6c65f9476b0687d97f1e044d0a1d, 0x4be90d412129d5a4d0424361d6649d4e47a62316, 0xe3ab3ca9b870e3f548517306bba4de2591afafc2, 0x5c61ab79b408dd3229f662593705d72f1e147bb8, 0x4f177f9d56953ded71a5611f393322c30279895c, 0xe6cb260b716d4c0ab726eeeb07c8707204e276ae, 0x44355253b27748e3f34fe9cae1fb718c8f249529, 0xa309df54cabce70c95ec3033149cd6678a6fd4cf, 0xec4867d2175ab5b9469361595546554684cda460, 0x8d06e464245cad614939e0af0845e6d730e20374, 0x9810e34a94db6ed156d0389a0e2b80f4fd6b0a8a, 0xdcfff3e8d23c2a34b56bd1b3bd45c79374432239, 0x7d7dd5ee614dbb6fbfbcd26305247a058c41faa1, 0x8a9eca9c5aba8e139f8003edf1163afb70aa3aa9, 0xd942de4784f7a48716c0fd4b9d54a6e54c5f2f3e, 0x07dae622630d1136381933d2ad6b22b839d82102, 0xabf12fa19e82f76c718f01bdca0003674523ef30, 0x411c831cc6f44f1965ec5757ab4e5b3ca4cffd1f, 0x99129d5b3c0cde47ea0def4dfc070d1f4a599527, 0xc5cdcee0e85d117dabbf536a3f4069bf443f54e7, 0xf218bd848ee7f9d38bfdd1c4eb2ed2496ae4305f, 0xfe549bbfe64740189892932538daaf46d2b61d4f, 0xdc3f0e7672f71fe7525ba30b9755183a20b9166a, 0x0e83b850481ab44d49e0a229a2e464902c69539b, 0x07ddd0422c86ef65bf0c7fc3452862b1228b08b8, 0xa68c313445c22d919ee46cc2d0cdff043a755825, 0xa9e9dbce7a2cb03694799897bed7c54d155fdaa8, 0x18fccf62d2c3395453b7587b9e26f5cff9eb7482, 0xff41d9e1b4effe18d8b0d1f63fc4255fb4e06c3d, 0x8f69eafd0233cadb4059ab779c46edf2a0506e48, 0x9aa48c66e4fb4ad099934e32022e827427f277ba, 0xf46980e3a4a9d29a6a6e90604537a3114bcb2897, 0x801732a481c380e57ed62d6c29de998af3fa3b13, 0x0cd6a141918d126b106d9f2ebf69e102de4d3277, 0x17589a6c006a54cad70103123aae0a82135fdeb4, 0x8725e8c753b3acbfdca55f3c62dfe1a59454968a, 0xd20dcb0b78682b94bc3000281448d557a20bfc83, 0xe84f8076a0f2969ecd333eef8de41042986291f2, 0xb3145b74506d1a8d047cdcdc55392a7b5350799a, 0x0d9a825ff2bcd397cbad5b711d9dcc95f1cc112d, 0x0ca670eb2c8b96cba379217f5929c2b892f39ef6, 0x25cfc4e25c35c13b69f7e77dbfb08baf58756b8d, 0x182db85293f606e88988c3704cb3f0c0bbbfca5a, 0xbd73c3cbc26a175062ea0320dd84b253bce64358, 0x2680713d40808e2a50ed013150a2a694b96a7f1d, 0x51e32f14f4ca5e287cdac057a7795ea9e0439953, 0xb1e9c5f1d21e61757a6b2ee75913fc5a1a4101c3, 0xd4c4d1a7c3c74984f6857b2f5f07e8face68056d, 0x4651dc420e08c3293b27d2497890eb50223ae2f4, 0xc74a3995f807de1db01a2eb9c62e97d0548f696f, 0x0505a08e22a109015a22f685305354662a5531d5, 0x39c773367c8825d3596c686f42bf0d14319e3f84, 0x0f929cf895db017af79f3ead2216b1bd69c37dc7, 0xbdd3254e1b3a6dc6cc2c697d45711aca21d516b2, 0xae5d221afcd3d29355f508eadfca408ce33ca903, 0x916cf17d71412805f4afc3444a0b8dd1d9339d16, 0x4319263f75402c0b5325f263be4a5080651087f0, 0x0f1c249cd962b00fd114a9349f6a6cc778d76c4d, 0x54febcce20fe7a9098a755bd90988602a48c089e, 0x2c1800f35fa02d3eb6ff5b25285f5e4add13b38d, 0x72b904440e90e720d6ac1c2ad79c321dcc1c1a86, 0xb0aa00950c0e81fa3210173e729aaf163a27cd71, 0x663604b0503046e624cd26a8b6fb4742dce02a6f, 0x3c98594bf68b57351e8814ae9e6dfd2d254aa06f, 0x9c45202a25f6ad0011f115a5a72204f2f2198866, 0xb02d062873334545cea29218e4057760590f7423, 0x7bddb2ee98de19ee4c91f661ee8e67a91d054b97, 0x9cf2928beef09a40f9bfc953be06a251116182fb, 0x51b4758e9e1450e7af4268c3c7b1e7bd6f5c7550, 0xeb570dba975227b1c42d6e8dea2c56c9ad960670, 0x970d8b8a0016d143054f149fb3b8e550dc0797c7, 0xc7b39b060451000ca1049ba154bcfa00ff8af262, 0x945e18769d7ee727c7013f92de24d117967ff317, 0xd18eb9e1d285dabe93e5d4bae76beefe43b521e8, 0xc618521321abaf5b26513a4a9528086f220adc6f, 0xdd65f6e17163b5d203641f51cc7b24b00f02c8fb, 0x131faed12561bb7aee04e5185af802b1c3438d9b, 0x1ced6715f862b1ff86058201fcce5082b36e62b2, 0xa0ff5b4cf016027e8323497d4428d3e5a83b8795, 0x02e816afc1b5c0f39852131959d946eb3b07b5ad, 0x153cf2842cb9de876c276fa64767d1a8ecf573bb, 0x3bc6e3ee7a56ce8f14a37532590f63716b9966e8, 0xf6d25d3f3d846d239f525fa8cac97bc43578dbac, 0x2066774d822793ff25f1760909479cf62491bf88, 0x46779a5656ff00d73eac3ad0c38b6c853094fb40, 0x22eed327f8eb1d1338a3cb7b0f8a4baa5907cd95, 0xff88ebacc41b3687f39e4b59e159599b80cba33f, 0x2874f3e2985d5f7b406627e17baa772b01abcc9e, 0xeb10458daca79e4a6b24b29a8a8ada711b7f2eb6, 0x541060fc58c750c40512f83369c0a63340c122b6, 0xfd2757cc3551a095878d97875615fe0c6a32aa8a, 0xbe659d85e7c34f8833ea7f488de1fbb5d4149bef, 0xe149b5726caf6d5eb5bf2acc41d4e2dc328de182, 0x2fe0cc424b53a31f0916be08ec81c50bf8eab0c1, 0xe3712701619ca7623c55db3a0ad30e867db0168b, 0xf8ca336c8e91bd20e314c20b2dd4608b9c8b9459, 0x68acdaa9fb17d3c309911a77b05f5391fa034ee9, 0xe77d7deab296c8b4fa07ca3be184163d5a6d606c, 0xe6b9545f7ed086e552924639f9a9edbbd5540b3e, 0x2866b81decb02ee70ae250cee5cdc77b59d7b679, 0x60e3cc43bcdb026aad759c7066f555bbf2ac66f5, 0xfcbd85feea6a754fcf3449449e37ff9784f7773c, 0x38a744efa6d5c2137defef8ef9187b649eee1c78, 0x9d7655e9f3e5ba5d6e87e412aebe9ee0d49247ee, 0x2020b81ae53926ace9f7d7415a050c031d585f20, 0x4244f1331158b9ce26bbe0b9236b9203ca351434, 0x99c236141daec837ece04fdaee1d90cf8bbdc104, 0x943d37864a4a537d35c8d99723cd6406ce2562e6, 0xd79483f6a8444f2549d611afe02c432d15e11051, 0x9fd64373f2fbcd9c0faca60547cad62e26d9851f, 0xb89c036ed7c492879921be41e10ca1698198a74c, 0x7462c89caa9d8d7891b2545def216f7464d5bb21, 0xbb0366a7cfbd3445a70db7fe5ae34885754fd468, 0x6c52cf0895bb35e656161e4dc46ae0e96dd3e62c, 0xb9cf71b226583e3a921103a5316f855a65779d1b, 0x016b60bb6d67928c29fd0313c666da8f1698d9c5, 0x9454b3a8bff9709fd0e190877e6cb6c89974dbd6, 0x84aac7fa197ff85c30e03b7a5382b957f41f3afb, 0xdb6e560c9bc620d4bea3a94d47f7880bf47f2d5f, 0xeefd05b0e3c417d55b3343060486cdd5e92aa7a6, 0x3a59a08246a8206f8d58f70bb1f0d35c5bcc71bd, 0x9bfff50db36a785555f07652a153b0c42b1b8b76, 0xd44f5edf2bcf2433f211dadd0cc450db1b008e14, 0x2378fd4382511e968ed192106737d324f454b535, 0xc94089553ae4c22ca09fbc98f57075cf2ec59504, 0x08ef3fa4c43ccdc57b22a4b9b2331a82e53818f2, 0xe48e65125421880d42bdf1018ab9778d96928f3f, 0x67518e5d02b205180f0463a32004471f753c523e, 0x0da7401262384e2e8b4b26dd154799b55145efa0, 0x0b6920a64b363b8d5d90802494cf564b547c430d, 0xa5ab4bd3588f46cb272e56e93deed386ba8b753d, 0x1788da9b57fd05edc4ff99e7fef301519c8a0a1e, 0x17b2d6cf65c6f4a347ddc6572655354d8a412b29, 0xd0319139fbab2e8e2accc1d924d4b11df6696c5a, 0x4c377bb03ab52c4cb79befa1dd114982924c4ae9, 0xfb949c647fdcfd2514c7d58e31f28a532d8c5833, 0x70e5e9da735ff077249dcb9aaf3db2a48d9498c0, 0xfe6f5f42b6193b1ad16206e4afb5239d4d7db45e, 0xbda4be317e7e4bed84c0495eee32d607ec38ca52, 0x5910106debd291a1cd80b0fbbb8d8d9e93a7cc1e, 0xba42f9aace4c184504abf5425762aca26f71fbdc, 0xbeb4fd315559436045dcb99d49dcec03f40c42dc, 0x452b64db8ef7d6df87c788639c2290be8482d575, 0x66e09427c1e63deed7e12b8c55a6a19320ef4b6a, 0xfaad905d847c7b23418aeecbe3addb8dd3f8924a, 0xa29319e81069e5d60df00f3de5adee3505ecd5fb, 0xcf348f2fe47b7e413c077a7baf3a75fbf8428692, 0xe1e8c50b80a352b240ce7342bbfdf5690cc8cb14, 0x131c792c197d18bd045d7024937c1f84b60f4438, 0xe49af4f34adaa2330b0e49dc74ec18ab2f92f827, 0xf2e99f5cbb836b7ad36247571a302cbe4b481c69, 0xc93fbde8d46d2bcc0fa9b33bd8ba7f8042125565, 0x038779ca2dbe663e63db3fe75683ea0ec62e2383, 0xa33cb450f95bb46e25afb50fe05feee6fb8cc8ea, 0x40ab66fe213ea56c3afb12c75be33f8e32fd085d, 0x6403d062549690c8e8b63eae41d6c109476e2588, 0xbfb0ea02feb61dec9e22a5070959330299c43072, 0x99c475bf02e8b9214ada5fad02fdfd15ba365c0c, 0x904966cc2213b5b8cb5bd6089ef9cddbef7edfcc, 0x767a03655af360841e810d83f5e61fb40f4cd113, 0xab209fdca979d0a647010af9a8b52fc7d20d8cd1, 0x6294eae6e420a3d5600a39c4141f838ff8e7cc48, 0x9777cc61cf756be3b3c20cd4491c69d275e7a120, 0xbcbf6ba166e2340db052ea23d28029b0de6aa380, 0x9f10f2a0463b65ae30b070b3df18cf46f51e89bd, 0x8d9952d0bb4ebfa0efd01a3aa9e8e87f0525742e, 0x4f23b6b817ffa5c664acdad79bb7b726d30af0f9, 0xb4c20040ccd9a1a3283da4d4a2f365820843d7e2, 0x7f49e7a4269882bd8722d4a6f566347629624079, 0x33629bd52f0e107bc071176c64df108f64777d49, 0x6a7b2e0d88867ff15d207c222bebf94fa6ce8397, 0xb7ce684b09abda53389a875369f71958aeac3bdd, 0xffbc3da0381ec339c1c049eb1ed9ee34fdcea6ca, 0x849ab80790b28ff1ffd6ba394efc7463105c36f7, 0xb0b36af9aeeedf97b6b02280f114f13984ea3260, 0x4d57e716876c0c95ef5eaebd35c8f41b069b6bfe, 0x2d2b032359b363964fc11a518263bfd05431e867, 0x2ccc1f1cb5f4a8002e186b20885d9dbc030c0894, 0x016c85e1613b900fa357b8283b120e65aefcdd08, 0x710b0274d712c77e08a5707d6f3e70c0ce3d92cf, 0x3cd3a6e93579c56d494171fc533e7a90e6f59464, 0xfe0e30e214290d743dd30eb082f1f0a5225ade61, 0xd0718520eae0a4d62d70de1be0ca431c5eea2482, 0xaf7f79cb415a1fb8dbbd094607ee8d41fb7c5a3b, 0xb7d252ee9402b0eef144295f0e69f0db586c0871, 0xc3b928a76fad6578f04f0555e63952cd21d1520a, 0xa7a517d7ad35820b09d497fa7e5540cde9495853, 0xe6e886317b6a66a5b4f81bf164c538c264351765, 0x0770b43dbae4b1f35a927b4fa8124d3866caf97b, 0x52b4257cf41b6e28878d50d57b99914ffa89873a, 0xe08bc29c2b48b169ff2bdc16714c586e6cb85ccf, 0x2372c4c1c9939f7aaf6cfac04090f00474840a09, 0xab6b65eab8dfc917ec0251b9db0ecfa0fa032849, 0x582e7cc46f1d7b4e6e9d95868bfd370573178f4c, 0xf167f5868dcf4233a7830609682caf2df4b1b807, 0xec82f50d06475f684df1b392e00da341aa145444, 0x0968ee5a378f8cadb3bafdbed1d19aaacf936711, 0xa86613e6c4a4c9c55f5c10bcda32175dcbb4af60, 0xa5cd123992194b34c4781314303b03c54948f4b9, 0x52f058d46147e9006d29bf2c09304ad1cddd6e15, 0x160226efe7b53a8af462d117a0108089bdecc2d1, 0x256292a191bdda34c4da6b6bd69147bf75e2a9ab, 0x1b8aa0160cd79f005f88510a714913d70ad3be33, 0xd4b2ff3bae1993ffea4d3b180231da439f7502a2, 0xe408aa99835307eea4a6c5eb801fe694117f707d, 0xe60a55f2df996dc3aedb696c08dde039b2641de8, 0x73df3c3e7955f4f2d859831be38000b1076b3884, 0x6228ade95e8bb17d1ae23bfb0518414d497e0eb8, 0x0f46c81db780c1674ac73d314f06539ee56ebc83, 0x762d6f30dab99135e4eca51d5243d6c8621102d5, 0x4ba0d9e89601772b496847a2bb4340186787d265, 0xca747576446a4c8f30b08340fee198de63ec92cf, 0x99c31fe748583787cdd3e525b281b218961739e3, 0x1210f80bdb826c175462ab0716e69e46c24ad076, 0x3f75ae61cc1d8042653b5baec4443e051c5e7abd, 0x5c4892907a0720df6fd3413e63ff767d6b398023, 0x17f14632a7e2820be6e8f6df823558283dadab2d, 0x1dc7f7dad85df53f1271152403f4e1e4fdb3afa0, 0x5a30feac37ac9f72d7b4af0f2bc73952c74fd5c3, 0x136d4b662bbd1080cfe4445b0fa213864435b7f1, 0xc1ec81dd123d4b7c2dd9b4d438a7072c11dc874c, 0x09f9575be57d004793c7a4eb84b71587f97cbb6a, 0x2c4b470307a059854055d91ec3794d80b53d0f4a, 0x6af6c7ee99df271ba15bf384c0b764adcb4da182, 0x0dae3ee5b915b36487f9161f19846d101433318a, 0x0dcf9d8c9804459f647c14138ed50fad563b4154, 0xbfa8c858df102cb12421008b0a31c4c7190ad560, 0xc2fd0bf7c725ef3e047e5ae1c29fe18f12a7299c, 0xd70a612bd6dda9eab0dddcff4aaf4122d38feae4, 0xe07137ae0d116d033533c4eab496f8a9fb09569c, 0x7f49f20726471ac1c7a83ef106e9775ceb662566, 0x1e706655e284dcf0bb37fe075d613a18dc12ff4a, 0x03af7ad9d5223cf7c8c13f20df67ebe5ffc5bb41, 0x228242f8336eecd8242e1f000f41937e71dffbbf, 0xe8ed51bbb3ace69e06024b33f86844c47348db9e, 0x3b566a8afad19682dc2ce8679a3ce444a5b0fd4f, 0xdc738fb217cead2f69594c08170de1af10c419e3, 0x13032446e7d610aa00ec8c56c9b574d36ca1c016, 0x6ca6a132ce1cd288bee30ec7cfeffb85c1f50a54, 0xb85f26dd0e72d9c29ebaf697a8af77472c2b58b5, 0x055bd02caf19d6202bbcdc836d187bd1c01cf261, 0x3c322e611fdb820d47c6f8fc64b6fad74ca95f5e, 0x8daddf52efbd74da95b969a5476f4fbbb563bfd2, 0xc63ac417992e9f9b60386ed953e6d7dff2b090e8, 0x27f03cf1abc5e1b51dbc444b289e542c9ddfb0e6, 0xd8f4bae6f84d910d6d7d5ac914b1e68372f94135, 0x9f83a293c324d4106c18faa8888f64d299054ca0, 0x39ee4fe00fbced647068d4f57c01cb22a80bccd1, 0x404100db4c5d0eec557823b58343758bcc2c8083, 0x02751dc68cb5bd737027abf7ddb77390cd77c16b, 0xd10302faa1929a326904d376bf0b8dc93ad04c4c, 0xcc419fd9912b85135659e77a93bc3df182d45115, 0x10097198b4e7ee91ff82cc2f3bd95fed73c540c0, 0x7e24d9e22ce1da3ce19f219ccee523376873f367, 0x2e4ee1ae996aa0a1d92428d06652a6bea6d2d15d, 0x91a4149a2c7b1b3a67ea28aff34725e0bf8d7524, 0xead65262ed5d122df2b2751410f98c32d1238f51, 0xe20954d0f4108c82d4dcb2148d26bbd924f6dd24, 0xebb7d2e11bc6b58f0a8d45c2f6de3010570ac891, 0xef115252b1b845cd857f002d630f1b6fa37a4e50, 0x01a818135a414210c37c62b625aca1a54611ac36, 0xea1ea0c599afb9cd36caacbbb52b5bbb97597377, 0x7a7a4f807357a4bbe68e1aa806393210c411ccb3, 0x6d40ca27826d97731b3e86effcd7b92a4161fe89, 0x8431277d7bdd10457dc017408c8dbbbd414a8df3, 0x69b81d5981141ec7a7141060dfcf8f3599ffc63e, 0x47688410ff25d654d72eb2bc06e4ad24f833b094, 0x6c101205b323d77544d6dc52af37aca3cec6f7f1, 0xfb685c15e439965ef626bf0d834cd1a89f2b5695, 0x673706b1b0e4dc7a949a7a796258a5b83bb5aa83, 0xecdaf93229b45ee672f65db506fb5eca00f7fce6, 0xec6904bae1f69790591709b0609783733f2573e3, 0x812ea7a3b2c86eed32ff4f2c73514cc63bacfbce, 0x196c02210a450ab0b36370655f717aa87bd1c004, 0xd96ac2507409c7a383ab2eee1822a5d738b36b56, 0xae2f9c19ac76136594432393b0471d08902164d3, 0x9d32962ea99700d93228e9dbdad2cc37bb99f07e, 0x17e584e810e567702c61d55d434b34cdb5ee30f6, 0xa3a93ef9dbea2636263d06d8492f6a41de907c22, 0x2b5016e2457387956562587115aa8759d8695fdf, 0x140129eaa766b5a29f5b3af2574e4409f8f6d3f1, 0x7025965d2b88da197d4459be3dc9386344cc1f31, 0x388bdcdae794fc44082e667501344118ea96cd96, 0xeee9d0526eda01e43116a395322dda8970578f39, 0x6ec89b39f9f5276a553e8da30e6ec17aa47eefc7, 0x7e236666b2d06e63ea4e2ab84357e2dfc977e50e, 0x68df947c495bebaeb8e889b3f953d533874bf106, 0xd40ed66ab3ceff24ca05ecd471efb492c15f5ffa, 0xf0c70d0d6dab7663aa9ed9ceea567ee2c6b02765, 0xb589676d15a04448344230d4ff27c95edf122c49, 0xa0347f0a98776390165c166d32963bf74dcd0a2f, 0xd47d8685faee147c520fd986709175bf2f886bef, 0xa1dcd0e5b05a977c9623e5ae2f59b9ada2f33e31, 0x4979194ec9e97db9bee8343b7c77d9d7f3f1dc9f, 0x7cd20eccb518b60cab095b720f571570caaa447e, 0x2ff830cf55fb00d5a0e03514fecd44314bd6d9f1, 0x0bb25ca7d188e71e4d693d7b170717d6f8f0a70a, 0xe9a2b4914e8553bf0d7c00ca532369b879f931bf, 0x720e6b22bf430966fa32b6acb9a506eebf662c61, 0x7ade5d66b944bb860c0efdc86276d58f4653f711, 0x2eaff9f8f8113064d3957ac6d6e11eee42c8195d, 0x0c8fd7775e54a6d9c9a3bf890e761f6577693ff0, 0x290a56d41f6e9efbdcea0342e0b7929a8cdfcb05, 0xd73ed2d985b5f21b55b274643bc6da031d8edd8d, 0x80156d10efa8b230c99410630d37e269d4093cea, 0x0989c200440b878991b69d6095dfe69e33a22e70, 0xec8014efc7cbe5b0ce50f3562cf4e67f8593cd32, 0xde612d0724e84ea4a7feaa3d2142bd5ee82d3201, 0x0f832a93df9d7f74cd0fb8546b7198bf5377d925, 0xaa2c670096d3f939305325427eb955a8a60db3c5, 0x25287b815f5c82380a73b0b13fbaf982be24c4d3, 0xe75c3b38a58a3f33d55690a5a59766be185e0284, 0x1940dc9364a852165f47414e27f5002445a4f143, 0xe5b826196c0e1bc1119b021cf6d259a610c99670, 0x82a15cef1d6c8260eaf159ea3f0180d8677dce1c, 0xda06044e293c652c467fe74146bf185b21338a1c, 0xf815c10a032d13c34b8976fa6e3bd2c9131a8ba9, 0xcd95fa423d6fc120274aacde19f4eeb766f10420, 0xe3a4f83c39f85af9c8b1b312bfe5fc3423afa634, 0x768ce0daa029b7ded022e5fc574d11cde3ecb517, 0xe3ec18a74ed43855409a26ade7830de8e42685ef, 0xb2bdbedf95908476d7148a370cc693743628057f, 0xbbb8ffe43f98de8eae184623ae5264e424d0b8d7, 0x090cebef292c3eb081a05fd8aaf7d39bf07b89d4, 0xdd2a233adede66fe1126d6c16823b62a021feddb, 0xd8cd64e0284eec53aa4639afc4750810b97fab56, 0xe5953fea497104ef9ad2d4e5841c271f073519c2, 0x967d4142af770515dd7062af93498dbfdff29f20, 0xfd191a35157d781373fb411bf9f25290047c5eef, 0x8967d7b9bdb7b4aed22e65a15dc803cb7a213f10, 0x51e43fe0d25c782860af81ea89dd793c13f0cbb1, 0xa38476691d34942eea6b2f76889223047db4617a, 0x1321ccf29739b974e5a516f18f3a843671e39642, 0x4d71a6eb3d7f327e1834278e280b039eddd31c2f, 0xdc2d15a69f6bb33b246aef40450751c2f6756ad2, 0xec89f2b678a1a15b9134ec5eb70c6a62071fbaf9, 0x27bf943c1633fe32f8bcccdb6302b407a5724e44, 0xd0a6c6f9e9c4b383d716b31de78d56414de8fa91, 0x7b6175ec9befc738249535ddde34688cd36edf25, 0x41ce79950935cff55bf78e4ccec2fe631785db95, 0x5598b3a79a48f32b1f5fc915b87b645d805d1afe, 0x5c4881165cb42bb82e97396c8ef44adbf173fb99, 0x25b0533b81d02a617b9229c7ec5d6f2f672e5b5a, 0x015f097d9acddcddafaf2a107eb93a40fc94b04c, 0xb84b53d0bb125656cddc52eb852ab71d7259f3d5, 0x1a79c7f4039c67a39d7513884cdc0e2c34222490, 0x926209b7fda54e8ddb9d9e4d3d19ebdc8e88c29f, 0xc2fe7d75731f636dcd09dbda0671393ba0c82a7d, 0x30248d58e414b20fed3a6c482b59d9d8f5a4b7e2, 0xd0e194f34b1db609288509ccd2e73b6131a2538b, 0xe8f29969e75c65e01ce3d86154207d0a9e7c76f2, 0xcb93199b9c90bc4915bd859e3d42866dc8c18749, 0xe6fe0afb9dcedd37b2e22c451ba6feab67348033, 0x82f854c9c2f087dffa985ac8201e626ca5467686, 0x63bb664f9117037628594da7e3c5089fd618b5b5, 0xf8d17424c767bea31205739a2b57a7277214eebe, 0x4ca8db4a5efefc80f4cd9bbcccb03265931332b6, 0xc56e6b62ba6e40e52aab167d21df025d0055754b, 0x0d8c40a79e18994ff99ec251ee10d088c3912e80, 0x40a331195b977325c2aa28fa2f42cb25ec3c253c, 0xa2c5854ff1599f98892c5725d262be1da98aadac, 0x23ab09e73f87aa0f3be0139df0c8eb6be5634f95, 0xb8040536958d5998ce4bec0cfc9c2204989848e9, 0x42d6b263d9e9f4116c411424fc9955783c763030, 0xc496cbb0459a6a01600fc589a55a32b454217f9d, 0x48302c311ef8e5dc664158dd583c81194d6e0d58, 0xd5b284040130abf7c1d163712371cc7e28ad66da, 0xd22f0ca4cd479e661775053bcc49e390f670dd8a, 0xe597f083a469c4591c3d2b1d2c772787befe27b2, 0x668b6ba8ab08eace39c502ef672bd5ccb6a67a20, 0xa3bff1dfa9971668360c0d82828432e27bf54e67, 0xee655bb4ee0e8d5478526fb9f15e4064e09ff3dd, 0x121f855b70149ac83473b9706fb44d47828b983b, 0x20a15256d50ce058bf0eac43aa533aa16ec9b380, 0x69bcfc1d43b4ba19de7b274bdffb35139412d3d7, 0xdb288f80ffe232c2ba47cc94c763cf6fc9b82b0d, 0xe1cb83ec5eb6f1eeb85e99b2fc63812fde957184, 0xa419a984142363267575566089340eea0ea20819, 0x8489f6ad1d9a94a297789156899db64154f1dbb5, 0xd609bf4f146eea6b0dc8e06ddcf4448a1fccc9fa, 0xdf1fa2e20e31985ebe2c0f0c93b54c0fb67a264b, 0xefe8ff87fc260e0767638dd5d02fc4672e0ec06d, 0xeef1bbb1e5a83fde8248f88ee3018afa2d1332eb, 0x4b3aab335ebbfaa870cc4d605e7d2e74c668369f, 0x8f4fb1aea7cd0f570ea5e61b40a4f4510b6264e4, 0x0b0b3862112aeec3a03492b1b05f440eca54256e, 0xdff4007931786593b229efe5959f3a4e219e51af, 0xfec14e5485de2b3eef5e74c46146db8e454e0335, 0xac21c1e5a3d7e0b50681679dd6c792dbca87decb, 0x796ebbf49b3e36d67694ad79f8ff36767ac6fab0, 0xae7739124ed153052503fc101410d1ffd8cd13b7, 0x86026cad3fe4ea1ce7fca260d3d45eb09ea6a364, 0xb2fc84a3e50a50af02f94da0383ed59f71ff01d7, 0xbbab000b0408ed015a37c04747bc461ab14e151b, 0xc4ff6fbb1f09bd9e102ba033d636ac1c4c0f5304, 0xcc606f511397a38fc7872bd3b0bd03c71bbd768b, 0xf346d7de92741c08fc58a64db55b062dde012d14, 0x33f15223310d44de8b6636685f3a4c3d9c5655a5, 0x3c860e2e663f46db53427b29fe3ea5e5bf62bbcc, 0xacb94338554bc488cc88ae2d9d94080d6bdf8410, 0x9c5cc111092c122116f1a85f4ee31408741a7d2f, 0x5f76f0a306269c78306b3d650dc3e9c37084db61, 0x2c0cc3f951482cc8a2925815684eb9f94e060200, 0xb74372dbfa181dc9242f39bf1d3731dffe2bdacf, 0x3bab4b01a7c84ba13feea9b0bb191b77a3aadca3, 0x39aa05e56d7d32385421cf9336e90d3d15a9f859, 0x4a52bad20357228faa1e996bed790c93674ba7d0, 0xff128f4b355be1dc4a6f94fa510d7f15d53c2aff, 0x92793ac5b37268774a7130de2bbd330405661773, 0xdb19a3982230368f0177219cb10cb259cdb2257c, 0x8d1794da509cb297053661a14aa892333231e3c1, 0x9b7c8810cc7cc89e804e6d3e38121850472877fe, 0xed3cbc3782cebd67989b305c4133b2cde32211eb, 0x8532490897bbb4ce8b7f6b837e4cba848fbe9976, 0xc384ac6ee27c39e2f278c220bdfa5baed626d9d3, 0xb1459285863ea2db3759e546ceb3fb3761f5909c, 0x634efc24371107b4cbf03f79a93dfd93e431d5fd, 0xef9f59aeda418c1494682d941aab4924b5f4929a, 0xe7311c9533f0092c7248c9739b5b2c864a34b1ce, 0xe6e621eaab01f20ef0836b7cad47464cb5fd3c96, 0xcd102cd6db3df14ad6af0f87c72479861bfc3d24, 0x005a9c03f69d17d66cbb8ad721008a9ebbb836fb, 0xa072cebe62a9e9f61cc3fbf88a9efbfe3e9a8d70, 0xf2ab1161750244d0ecd048ee0d3e51abb143a2fd, 0xf686785b89720b61145fea80978d6acc8e0bc196, 0x0a2b4fc5d81ace67dc4bba03f7b455413d46fe3d, 0xc32ec7e42ad16ce3e2555ad4c54306eda0b26758, 0xf3fa723552a5d0512e2b62f48dca7b2b8105305b, 0x6dc3f92baa1d21dab7382b893261a0356fa7c187, 0x4627c606842671abde8295ee5dd94c7f549534f4, 0xe39e46e15d22ce56e0c32f1877b7d1a264cf94f3, 0xd7d157e4c0a96437a6d285741dd23ec4361fa36b, 0x68f8f45155e98c5029a4ebc5b527a92e9fa83120, 0x9aba2b5e27ff78baaab5cdc988b7be855cebbdce, 0x66b39837cb3cac8a802afe3f12a258bbca62dacd, 0xd39b7cbc94003fc948f0cde27b100db8ccd6e063, 0x3db9ed7f024c7e26372feacf2b050803445e3810, 0x3fbc1e4518d73400c6d046359439fb68ea1a49f4, 0xe3da4f3240844c9b6323b4996921207122454399, 0x09afa73bc047ef46b977fd9763f87286a6be68c6, 0x1dbe8e1c2b8a009f85f1ad3ce80d2e05350ee39c, 0x2c5a2d0abda03bbe215781b4ff296c8c61bdbaf6, 0x9a9d1dc0baa77d6e20c3d849c78862dd1c054c87, 0x3ccef88679573947e94997798a1e327e08603a65, 0x850b9db18ff84bf0c7da49ea3781d92090ad7e64, 0x361c75931696bc3d427d93e76c77fd13b241f6f4, 0xc8f2b320e6dfd70906c597bad2f9501312c78259, 0x8dc1d5111d09af25fdfcac455c7cec283e6d6775, 0xcd7ece086b4b619b3b369352ee38b71ddb06439a, 0xf607c2150d3e1b99f24fa1c7d540add35c4ebe1e, 0x32485c818728c197fea487fbb6e829159eba8370, 0x8e670815fb67aeaea57b86534edc00cdf564fee5, 0x10df681506e34930ac7a5c67a54c3e89ce92b981, 0x1cf2eb7a8ccac2adeaef0ee87347d535d3b94058, 0xf0dc43f205619127507b2b1c1cfdf32d28310920, 0xf2c2904e9fa664a11ee25656d8fd2cc0d9a522a0, 0x70670fbb05d33014444b8d1e8e7700258b8caa6d, 0x5160ed612e1b48e73f3fc15bc4321b8f23b8a24b, 0x54a62bf9233e146ffec3876e45f20ee8414adeba, 0x26d4ec17d5ceb2c894bdc59d0a6a695dad2b43cc, 0x205fc843e19a4913d1881eb69b69c0fa3be5c50b, 0xe001aba77c02e172086c1950fffbcaa30b83488f, 0x21efbca09b3580b98e73f5b2f7f4dc0bf02c529c, 0xc4d916574e68c49f7ef9d3d82d1638b2b7ee0985, 0xcab0d32cf3767fa6b3537c84328baa9f50458136, 0x7ce4686446f1949ebed67215eb0d5a1dd72c11b8, 0x7837fcb876da00d1eb3b88feb3df3fa4042fac82, 0x71e38ff545f30fe14ca863d4f5297fd48c73a5ce, 0xe528a0e5a267d667e9393a6584e19b34dc9be973, 0xc5374928cdf193705443b14cc20da423473cd9cf, 0xe406f5dd72cab66d8a6ecbd6bfb494a7b6b09afe, 0xd7ef340e66b0d7afcce20a19cb7bfc81da33d94e, 0xe012db453827a58e16c1365608d36ed658720507, 0xd59638d3c5faa7711bf085745f9d5bdc23d498d8, 0x008fc7cbadffbd0d7fe44f8dfd60a79d721a1c9c, 0x8a3470282d5e2a2aefd7a75094c822c4f5aeef8a, 0x38b3965c21fa893931079beacfffaf153678b6eb, 0x57dd9471cbfa262709f5f486bcb774c5f527b8f8, 0x5a60c924162873fc7ea4da7f972e350167376031, 0xb9013c51bd078a098fae05bf2ace0849c6be17a5, 0xdc23b260fcc26e7d10f4bd044af794579460d9da, 0x45db03bccfd6a5f4d0266b82a22a368792c77d83, 0x3e0cbe6a6dcb61f110c45ba2aa361d7fcad3da73, 0x42d3a5a901f2f6bd9356f112a70180e5a1550b60, 0x47219229e8cd56659a65c2a943e2dd9a8f4bfd89, 0xa20d071b1b003063497d7990e1249dabf36c35f7, 0x6835c8e8b74a2ca2ae3f4a8d0f6b954a3e2a8392, 0x0c2d5c920538e953caaf24f0737f554cc6927742, 0xeedf6c4280e6eb05b934ace428e11d4231b5905b, 0xffa696ecbd787e66abae4fe87b635f07ca57d848, 0x3e81772175237eb4cbe0fe2dcafdadffeb6a1999, 0xb44783c8e57b480793cbd69a45d90c7b4f0c48ac, 0xf84f090adf3f8db7e194b350fbb77500699f66fd, 0x2e9824b5c132111bca24ddfba7e575a5cd7296c1, 0x5cce72d068c7c3f55b1d2819545e77317cae8240, 0xd815e1d9f4e2b5e57e34826b7cfd8881b8546890, 0xf901c00fc1db88b69c4bc3252b5ca70ea6ee5cf6, 0xa960b1cadd3b5c1a8e6cb3abcaf52ee7c3d9fa88, 0xf7e45a12aa711c709acefe95f33b78612d2ad22a, 0xc332df50b13c013490a5d7c75dbfa366da87b6d6, 0xd467cf064c0871989b90d8b2eb14ccc63b360823, 0xb9144b677c2dc614ceefdf50985f1183208ea64c, 0xea7c4d6dc729cd6b157c03ad237ca19a209346c3, 0x9c9de44724a4054da0eaa605abcc802668778bea, 0xd7140c8e5a4307fab0cc27badd9295018bf87970, 0xc33acdb3ba1aab27507b86b15d67faf91ecf6293, 0xdb2a0c9ab64df58ddfb1dbacf8ba0d89c85b31b4, 0xbfcb9730246304700da90b4153e71141622e1c41, 0x07dc8c8b927adbedfa8f5d639b4352351f2f36d2, 0x2d5391e938b34858cf965b840531d5efda410b09, 0x0b5e2011ebc25a007f21362960498afb8af280fb, 0xed9fb1f5af2fbf7ffc5029cee42b70ff5c275bf5, 0xa3232d068d50064903c9ebc563b515acc8b7b097, 0x66274fea82cd30b6c29b23350e4f4f3d310a5899, 0xdbfb1bb464b8a58e500d2ed8de972c45f5f1c0fb, 0xa1f8d8bcf90e777f19b3a649759ad95027abdfc3, 0x5bd23547477f6d09d7b2a005c5ee650c510c56d7, 0xec3b8b58a12703e581ce5ffd7e21c57d1e5c663f, 0x54310b3aa88703a725dfa57de6e646935164802c, 0x8f41b1fbf54298f5d0bc2d122f4eb95da4e5cd3d, 0xc80b36d1beafba5fcc644d60ac6e46ed2927e7dc, 0x1ea492bce1ad107e337f4bd4a7ac9a7babcccdab, 0xaaf023fef290a49bb78bb7abc95d669c50d528b0, 0x80b79f338390d1ba1b3737a29a0257e5d91e0731, 0xf382e4c20410b951089e19ba96a2fee3d91cce7e, 0x0748713145ef83c3f0ef4d31d823786f7e9cc689, 0x21e219c89ca8ac14ae4cba6130eeb77d9e6d3962, 0xca9a042a6a806ffc92179500d24429e8ab528117, 0xbcc9593b2da6df6a34d71b1aa38dacf876f95b88, 0xd1438267231704fc7280d563adf4763844a80722, 0x4989e1ab5e7cd00746b3938ef0f0d064a2025ba5, 0xbd4b60faec740a21e3071391f96aa534f7c1f44e, 0x8c7cb4e48b25031aa1c4f92925d631a8c3edc761, 0x322788b5e29bf4f5f55ae1ddb32085fda91b8ebe, 0xf15e182c4fbbad79bd93342242d4dccf2be58925, 0x1548b770a5118ede87dba2f690337f616de683ab, 0x69c2d835f13ee90580408e6a3283c8cca6a434a2, 0xa1e4380a3b1f749673e270229993ee55f35663b4, 0xc7675e5647b9d8daf4d3dff1e552f6b07154ac38, 0xa02c1e34064f0475f7fa831ccb25014c3aa31ca2, 0x517c75430de401c341032686112790f46d4d369e, 0x29681d9912ddd07eaabb88d05d90f766e862417d, 0x544dda421dc1eb73bb24e3e56a248013b87c0f44, 0x2ab97e8d59eee648ab6caf8696f89937143864d6, 0x79c130c762b8765b19d2abc9a083ab8f3aad7940, 0xf9650d6989f199ab1cc479636ded30f241021f65, 0xd1c96e70f05ae0e6cd6021b2083750a7717cde56, 0x88106c27d20b74b4b98ca62b232bd5c97411171f, 0x37ab66083a4fa23848b886f9e66d79cdc150cc70, 0x8e6156336be2cdbe32140df08a2ba55fd0a58463, 0x2982d76a15f847dd41f1922af368fe678d0e681e, 0x209e8e29d33beae8fb6baa783d133e1d9ec1bc0b, 0xb325674c01e3f7290d5226339fbeac67d221279f, 0xf20c9a99b74759d782f25c1ceca802a27e0b436c, 0x61bf84d5ab026f58c873f86ff0dfca82b55733ae, 0x0734a0a81c9562f4d9e9e10a8503da15db46d76e, 0x0521bc3a9f8711fecb10f50797d71083e341eb9d, 0x3301d9ca2f3bfe026279cd6819f79a293d98156e, 0x549d51af29f724c967f59423b85b2681e7b15136, 0x2053ac97548a0c4e8b80bc72590cd6a098fe7516, 0xaa321fdbd449180db8ddd34f0fe906ec18ee0914, 0x697f55536bf85ada51841f0287623a9f0ed09a17, 0xdf57353aaff2aadb0a04f9014e8da7884e86589c, 0x6807ddc88db489b033e6b2f9a81553571ab3c805, 0x90057af9aa66307ec9f033b29724d3b2f41eb6f9, 0x3ff836b6f57b901b440c30e4dbd065cf37d3d48c, 0x91051764af6b808e4212c77e30a5572eaa317070, 0x7faa30c31519b584e97250ed2a3cf3385ed5fd50, 0xfb842ca2c5ef133917a236a0d4ac40690110b038, 0xaa167026d39ab7a85635944ed9edb2bfeba11850, 0x57beea716cbd81700a73d67f9ff039529c2d9025, 0x654b7e808799a83d7287c67706f2abf49a496404, 0xdde8f0c31b7415511dced1cd7d46323e4bd12232, 0x8667fa1155fed732cfb8dca5a0d765ce0d0705ed, 0x905526568ac123afc0e84aa715124febe83dc87c, 0x8e98766524b0cf2747c50dd43b9567594d9731de, 0xc6df2075ebd240d44869c2be6bdf82e63d4ef1f5, 0x2ff5cab12c0d957fd333f382eeb75107a64cb8e8, 0x3055efd26029e0d11b930df4f53b162c8c3fd2ce, 0xb2c53efa33fe4a3a1a80205c73ec3b1dbcad0602, 0x766b3759e8794e926dac473d913a8fb61ad0c2c9, 0x882aa798bf41df179f85520130f15ccdf59b5e58, 0x80b23d380b825c46e0393899a85556462da0e18c, 0x51f4663ab44ff79345f427a0f6f8a6c8a53ff234, 0x8d5ef172bf77315ea64e85d0061986c794c6f519, 0x75ac547017134c04ae1e11d60e63ec04d18db4ef, 0xce1b0cb46aaecfd79b880cad0f2dda8a8dedd0b1, 0x21408b4d7a2c0e6eca4143f2cacdbbccba121bd8, 0x9c526a140683edf1431cfaa128a935e2b614d88b, 0x599728a78618d1a17b9e34e0fed8e857d5c40622, 0x6ac4d4be2db0d99da3faaaf7525af282051d6a90, 0x785c8ea774d73044a734fa790a1b1e743e77ed7c, 0xff2726294148b86c78a9372497e459898ed3fee3, 0x68a86c402388fddc59028fec7021e98cbf830eac, 0x6121af398a5b2da69f65c6381aec88ce9cc6441f, 0x5a6686b0f17e07edfc59b759c77d5bef164d3879, 0xa2d38de1c73906f6a7ca6efeb97cf6f69cc421be, 0xae3f98a443efe00f3e711d525d9894dc9a61157b, 0x5f1c8a04c90d735b8a152909aeae636fb0ce1665, 0xd687cec0059087fdc713d4d2d65e77daefedc15f, 0x845203750f7148a9aa262921e86d43bf641974fd, 0x64464a6805b462412a901d2db8174b06c22deea6, 0x053471cd9a41925b3904a5a8ffca3659e034be23, 0x911ff233e1a211c0172c92b46cf997030582c83a, 0xd930b27a78876485d0f48b70dd5336549679ca8f, 0x6ba9b21b35106be159d1c1c2657ac56cd29ffd44, 0xebac2b4408ef5431a13b8508e86250982114e145, 0x931df34d1225bcd4224e63680d5c4c09bce735a6, 0x23eb6fd85671a9063ab7678ebe265a20f61a02b3, 0xb32af3d3e8d075344926546f2e32887bf93b16bd, 0x8261fa230c901d43ff579f4780d399f31e6076bc, 0x84a74ceecff65cb93b2f949d773ef1ad7fb4a245, 0xda982e9643ffece723075a40fe776e5ace04b29b, 0xba70e8b4759c0c3c82cc00ac4e9a94dd5bafb2b8, 0x82f2e991fd324c5f5d17768e9f61335db6319d6c, 0x3e84b35c5b2265507061d30b6f12da033fe6f8b9, 0x2895e80999d406ad592e2b262737d35f7db4b699, 0x65f534346d2ffb787fa9cf185d745ba42986bd6e, 0xc7368b9709a5c1b51c0adf187a65df14e12b7dba, 0xba176dbe3249e345cd4fa967c0ed13b24c47e586, 0xcff6a6fe3e9a922a12f21faa038156918c4fcb9c, 0xbcbd31252ec288f91e298cd812c92160e738331a, 0x5543dd6d169eec8a213bbf7a8af9ffd15d4ff759, 0xb65bd780c7434115162027565223f44e5498ff8c, 0x4cadf573ce4ceec78b8e1b21b0ed78eb113b2c0e, 0x04aafc8ae5ce6f4903c89d7fac9cb19512224777, 0xfdc4d4765a942f5bf96931a9e8cc7ab8b757ff4c, 0x38c7851f5ffd4cee98df30f3b25597af8a6ca263, 0x0e320219838e859b2f9f18b72e3d4073ca50b37d, 0xbbbf39b1b67995a42241504f9703d2a14a515696, 0x5b800bfd1b3ed4a57d875aed26d42f1a7708d72a, 0x5b85e60e2af0544f2f01c64e2032900ebd38a3c7, 0xc9ac01c3fb0929033f0ccc7e1acfeaaba7945d47, 0xf355d3ec0cfb907d8dbb1bf3464e458128190bac, 0x69c08d744754de709ce96e15ae0d1d395b3a2263, 0xcef77451dfa2c643e00b156d6c6ff84e2373eb66, 0xf3034367f87d24d3077fa9a2e38a8b0ccb1104ef, 0x73473e72115110d0c3f11708f86e77be2bb0983c, 0x761e6caec189c230a162ec006530193e67cf9d19, 0xe9caf827be9d607915b365c83f0d3b7ea8c79b50, 0xeda4b2fa59d684b27a810df8978a73df308a63c2, 0x065ff575fd9c16d3cb6fd68ffc8f483fc32ec835, 0xa72ee666c4b35e82a506808b443cebd5c632c7dd, 0x5b30608c678e1ac464a8994c3b33e5cdf3497112, 0xb0c7ce4c0dc3c2bbb99cc1857b8a455f611711ce, 0xd7274d50804d9c77da93fa480156efe57ba501de, 0xa609c26dd350c235e44b2b9c1dddccd0a9d9f837, 0xbddfa34d0ebf1b04af53b99b82494a9e3d8aa100, 0xfd40242bb34a70855ef0fd90f3802dec2136b327, 0x58aed6674affd9f64233272a578dd9386b99c263, 0x24434a3e32e54ecf272fe3470b5f6f512f675520, 0xa379a5070c503d2fac89b8b3afa080fd45ed4bec, 0x37e169a93808d8035698f815c7235613c1e659f2, 0x849b116f596301c5d8bb62e0e97a8248126e39f3, 0xfe7011b698bf3371132d7445b19eb5b094356aee, 0xf16de1891d8196461395f9b136265b3b9546f6ef, 0x6c6564e5c9c24eaaa744c9c7c968c9e2c9f1fbae, 0x8bb0212f3295e029cab1d961b04133a1809e7b91, 0x408a69a40715e1b313e1354e600800a1e6dc02a5, 0xddf0cce1fe996d917635f00712f4052091dff9ea, 0x50fef296955588caae74c62ec32a23a454e09ab8, 0xd913f0771949753c4726acaa2bd3619c5c20ff77, 0x9d6ecfa03af2c6e144b7c4692a86951e902e9e1f, 0xecbe5e1c9ad2b1dccf0a305fc9522f4669dd3ae7, 0x33e9b71823952e1f66958c278fc28b1196a6c5a4, 0x9de20bc37e7f48a80ffd7ad84ffbf1a1abe1738c, 0x16f313cf8ad000914a0a176dc6a4342b79ec2538, 0x991ac7ca7097115f26205eee0ef7d41eb4e311ae, 0xddfafdbc7c90f1320e54b98f374617fbd01d109f, 0x26b11d066588ce74a572a85a6328739212aa8b40, 0xef2c34bb487d3762c3cca782ccdd7a8fbb0a9931, 0xa9be88ad1e518b0bbb024ab1d8f0e73f790e0c76, 0x4a7494cce44855cc80582842be958a0d1c0072ee, 0x23569542c97d566018c907acfcf391d14067e87e, 0xd252960b0bf6b2848fdead80136db5f507f8be02, 0x2c0f5b9df43625798e7e03c1a5fd6a6d091af82b, 0xa7c9d388ebd873e66b1713448397d0f37f8bd3a8, 0x3259bd2fddfbbc6fbad3b6e874f0bbc02cda18b5, 0xf287ff52f461117adb3e1daa71932d1493c65f2e, 0xc852428d2b586497acd30c56aa13fb5582f84402, 0x296f00de1dc3bb01d47a8ccd1e5d1dd9a1eb7791, 0x817493cd9bc623702a24a56f9f82e3fd48f3cd31, 0x7adfedb06d91f3cc7390450b85550270883c7bb7, 0x8d544c32c07fd0842c761d53a897d6c950bb7599, 0x86297d730fe0f7a9ee24e08fb1087b31adb306a7, 0xf64fe0939a8d1eea2a0ecd9a9730fd7958e33109, 0xb06eab09a610c6a53d56a946b2c43487ac1d5b2d, 0xbae9b82f7299631408659dd74e891cb8f3860fe5, 0x0eda80f4ed074aea697aeddf283b63dbca3dc4da, 0xea686c5057093c171c66db99e01b0ececb308683, 0x425725c0f08f0811f5f006eec91c5c5c126b12ae, 0xb18e67a5050a1dc9fb190919a33da838ef445014, 0x8dd484ff8a307364eb66c525a571aac701c5c318, 0x6671b182c9f741a0cd3c356c73c23126d4f9e6f4, 0xba0249e01d945bef93ee5ec61925e03c5ca509fd, 0xb2968f7d35f208871631c6687b3f3daeabc6616c, 0xa6f62b8a3d7f11220701ab9ffffcb327959a2785, 0xc885a18aabf4541b7b7b7ecd30f6fae6869d9569, 0x33fb577a4d214fe010d32cca7c3eeda63f87ceef, 0xbe86d0b0438419ceb1a038319237ba5206d72e46, 0x466292f0e80d43a78774277590a9eb45961214f4, 0xb33c0323fbf9c26c1d8ac44ef74391d0804696da, 0xf7bc4c44910d5aedd66ed2355538a6b193c361ec, 0xd0f04f52109aebec9a7b1e9332761e9fe2b97bb5, 0xcb4a914d2bb029f32e5fef5c234c4fec2d2dd577, 0x2e619f57abc1e987aa936ae3a2264962e7eb2d9a, 0x166bf6dab22d841b486c38e7ba6ab33a1487ed8c, 0xc3a046e3d2b2bf681488826e32d9c061518cfe8c, 0xd082275f745a2cac0276fbdb02d4b2a3ab1711fe, 0xa701df79f594901afe1444485e6b20c3bda2b9b3, 0xdec3eec2640a752c466e2b7e7ee685afe9ac41f4, 0x8134dd1c9df0d6c8a5812426bb55c761ca831f08, 0xbfc57aa666fae28e9f107a49cb5089a4e22151dd, 0xc3c2297329a6fd99117e54fc6af379b4d556547e, 0x40585200683a403901372912a89834aadcb55fdb, 0xcd49bf185e70d04507999f92a4de4455312827d0, 0x9c6bc9a46b03ae5404f043dfcf21883e4110cc33, 0x1f49b86d0d3945590698a6aaf1673c37755ca80d, 0xefeb1997aad277cc33430e6111ed0943594048b8, 0x7c0883054c2d02bc7a852b1f86c42777d0d5c856, 0xff49a775814ec00051a795a875de24592ea400d4, 0xf039683d7b3d225bc7d8dfadef63163441be41e2, 0xa3ba0d3a3617b1e31b4e422ce269e873828d5d69, 0xd116f3dcd5db744bd008887687aa0ec9fd7292aa, 0x5719f49b720da68856f4b9e708f25645bdbc4b41, 0x870796abc0db84af82da52a0ed68734de7e636f5, 0x68b6854788a7c6496cdbf5f84b9ec5ef392b78bb, 0x8c2fbeee8eacc5c5d77c16abd462ee9c8145f34b, 0x421684baa9c0b4b5f55338e6f6e7c8e146d41cb7, 0xdd26b429fd43d84ec179825324bad5bfb916b360, 0x3821862493242c0aeb84b90de05d250c1e50c074, 0x68a7425fe09eb28cf86eb1793e41b211e57bd68d, 0xda875e4e2f3cabe4f37e0eaed7d1f6dcc6ffef43, 0xc2663f8145dbfec6c646fc5c49961345de1c9f11, 0xe89c22f1a4e1d4746ecfaa59ed386fee12d51e37, 0xeff86b5123bcdc17ed4ce8e05b7e12e51393a1f7, 0x6c3d18704126aa99ee3342ce60f5d4c85f1867cd, 0xb8d531a964bcea13829620c0ced72422dadb4cca, 0x7c29d47d57a733f56b9b217063b513dc3b315923, 0xbc1e80c181616342ebb3fb3992072f1b28b802c6, 0x31313ffd635bf2f3324841a88c07ed146144ceeb, 0xcc4feb72df98ff35a138e01761d1203f9b7edf0a, 0x741693c30376508513082020cc2b63e9fa92131b, 0xaa3135cb54f102cbefe09e96103a1a796718ff54, 0xef61155ba009dcdebef10b28d9da3d1bc6c9ced4, 0xb3c94811e7175b148b281c1a845bfc9bb6fbc115, 0x96d9cca8f55eea0040ec6eb348a1774b95d93ef4, 0xce62125adec3370ac52110953a4e760be9451e3b, 0xaca1e6bc64cc3180f620e94dc5b1bcfd8158e45d, 0xbc237148d30c13836ffa2cad520ee4d2e5c4eeff, 0x0e024e7f029c6aaf3a8b910f5e080873b85795aa, 0x7283cd4675da58c496556151dafd80c7f995d318, 0x39b299327490d72f9a9edff11b83afd0e9d3c450, 0x5f333a3b2310765a0d1832b9be4c0a03704c1c09, 0x5aaf1c31254a6e005fba7f5ab0ec79d7fc2b630e, 0x833db42c14163c7be4cab86ac593e06266d699d5, 0xf32d25eb0ea2b8b3028a4c7a155dc1aae865784d, 0x1fa2319fed8c2d462adf2e17feec6a6f30516e95, 0xc49cfaa967f3afbf55031061fc4cef88f85da584, 0x43db7ff95a086d28ebbfb82fb8fb5f230a5ebccd, 0xcf3f9128b07203a3e10d7d5755c0c4abc6e2cac2, 0x8f4d1e7e4561284a34fef9673c0d34e12af4aa03, 0x934af21b7ebfa467e2ced65aa34edd3a0ec71332, 0x5d231a70c1dfeb360abd97f616e2d10d39f3cab5, 0x2d5d7335acb0362b47dfa3a8a4d3f5949544d380, 0xd1e1f2b9c16c309874dee7fac32675aff129c398, 0xa43b6da6cb7aac571dff27f09d39f846f53769b1, 0x779274bf1803a336e4d3b00ddd93f2d4f5f4a62e, 0xa644ed922cc237a3e5c4979a995477f36e50bc62, 0xee6c03429969ca1262cb3f0a4a54afa7d348d7f5, 0x4f06246b8d4bd29661f43e93762201d286935ab1, 0xe04972a83ca4112bc871c72d4ae1616c2f0728db, 0xdf098f5e4e3dffa51af237bda8652c4f73ed9ca6, 0xdfded2574b27d1613a7d98b715159b0d00baab28, 0x17d931d4c56294dcbe77c8655be4695f006d4a3c, 0x3ccb71aa6880cb0b84012d90e60740ec06acd78f, 0xe57d2995b0ebdf3f3ca6c015eb04260dbb98b7c6, 0xfb3860f4121c432ebdc8ec6a0331b1b709792e90, 0xfa00c376e89c05e887817a9dd0748d96f341aa89, 0xc7a018f0968a51d1f6603c5c49dc545bcb0ff293, 0x7d73863038ccca22f96affda10496e51e1e6cd48, 0x38ea6f5b5a7b88417551b4123dc127dfe9342da6, 0x014b7f67b14f5d983d87014f570c8b993b9872b5, 0x8ac89bd9b8301e6b0677fa25fcf0f58f0cc7b611, 0x7eb4b0185c92b6439a08e7322168cb353c8a774a, 0xd29dc08efbb3d72e263f78ab7610d0226de76b00, 0x72a8260826294726a75bf39cd9aa9e07a3ea14cd, 0x4cb5c6cd713ca447b848ae2f56b761ca14d7ad57, 0x49185dd7c23632f46c759473ebae966008cd3598, 0x13d67a7e25f2b12cdb85585009f8acc49b967301, 0x9d913b5d339c95d87745562563fea98b23c60cc4, 0xabdc9f1bcf4d19ee96591030e772c334302f7d83, 0xe9a5ae3c9e05977dd1069e9fd9d3aefbae04b8df, 0x1fd296be03ad737c92f9c6869e8d80a71c5714aa, 0x2f13657526b177cad547c3908c840eff647b45d9, 0xe69fcc26ed225f7b2e379834c524d70c1735e5bc, 0xbade43599e02f84f4c3014571c976b13a36c65ab, 0x184a4f0beb71ffd558a6b6e8f228b78796c4cf3e, 0xd1de5aad3a5fd803f1b1aeb6103cb8e14fe723b7, 0x0bd67dbde07a856ebd893b5edc4f3a5be4202616, 0x6b30f1823910b86d3acb5a6afc9defb6f3a30bf8, 0x9a63d185a79129fdab19b58bb631ea36a420544e, 0xdf660a91dab9f730f6190d50c8390561500756ca, 0xa1a1f0fa6d20b50a794f02ef52085c9d036aa6ca, 0x4ec768295eeabafc42958415e22be216cde77618, 0xc348fc5a461323b57be303cb89361b991913df28, 0x3a7db224acae17de7798797d82cdf8253017dfa8, 0x8bea40379347a5c891d59a6363315640f5a7e07a, 0x2257fca16a6e5c2a647c3c29f36ce229ab93b17e, 0xe492818aa684e5a676561b725d42f3cc56ae5198, 0xc841884fa4785fb773b28e9715fae99a5134305d, 0x0d9443a79468a5bbf7c13c6e225d1de91aee07df, 0x6d4008b4a888a826f248ee6a0b0dfde9f93210b9, 0x884980eb4565c1048317a8f47fdbb461965be481, 0x985d70d207892bed398590024e2421b1cc119359, 0xd9ec8fe69b7716c0865af888a11b2b12f720ed33, 0x49b74e169265f01a89ec4c9072c5a4cd72e4e835, 0x4c3e95cc3957d252ce0bf0c87d5b4f2234672e70, 0xd9ff115d01266c9f73b063c1c238ef3565e63b36, 0x48c5c6970b9161bb1c7b7adfed9cdede8a1ba864, 0xea6afe2cc928ac8391eb1e165fc40040e37421e7, 0x08ccda50e4b26a0ffc0ef92e9205310706bec2c7, 0xe6e9a39d750fe994394eb68286e5ea62a6997882, 0x4b58101f44f7e389e12d471d1635b71614fdd605, 0x8d93dac785f88f1a84bf927d53652b45a154ccdd, 0x415d096ab06293183f3c033d25f6cf7178ac3bc7, 0xc3e387b03ce95ccfd7fa51dd840183bc43532809, 0xda34b2eae30bafe8daeccde819a794cd89e09549, 0xfa279bfd8767f956bf7fa0bd5660168da75686bd, 0xb98ca31785ef06be49a1e47e864f60d076ca472e, 0xb768b5234eba3a9968b34d6ddb481c8419b3655d, 0x31047d703f63b93424fbbd6e2f1f9e74de13e709, 0x9a24ce8d485cc4c86e49deb39022f92c7430e67e, 0xe62f9d7c64e8e2635aeb883dd73ba684ee7c1079, 0xf15d9d5a21b1929e790371a17f16d95f0c69655c, 0x285ae51b9500c58d541365d97569f14bb2a3709b, 0x09c177f1ae442411ddacf187d46db956148360e7, 0x12173074980153aeaa4b0dcbc7132eadcec21b64, 0x351f16e5e0735af56751b0e225b2421171394090, 0xac52b77e15664814f39e4f271be641308d91d6cc, 0x99c883258546cc7e4e971f522e389918da5ea63a, 0xaa16269aac9c0d803068d82fc79151dadd334b66, 0x7c9a110cb11f2598b2b20e2ca400325e41e9db33, 0x583e83ba55e67e13e0e76f8392d873cd21fbf798, 0x555ebe84daa42ba256ea789105cec4b693f12f18, 0x978c430ce4359b06bc2cdf5c2985fc950e50d5c8, 0xdc1eb9b6e64351f56424509645f83e79eee76cf4, 0x5b290c01967c812e4dc4c90b174c1b4015bae71e, 0xe7d213947fcb904ad738480b1eed2f5c329f27e8, 0xc517d0315c878813c717e18cafa1eab2654e01da, 0x7e972a8a7c2a44c93b21436c38d21b9252c345fe, 0x9cb28ac1a20a106f7f373692c5ce4c73f13732a1, 0x14ab164b3b524c82d6abfbc0de831126ae8d1375, 0xd46f8223452982a1eea019a8816efc2d6fc00768, 0x5cdc4708f14f40dcc15a795f7dc8cb0b7faa9e6e, 0x66fdc9fee351fa1538eb0d87d819fcf09e7c106a, 0xe7be82c6593c1eeddd2ae0b15001ff201ab57b2f, 0x47d20e6ae4cad3f829eac07e5ac97b66fdd56cf5, 0x0f2d8daf04b5414a0261f549ff6477b80f2f1d07, 0x84bfcef0491a0ae0694b37ceac024584f2aa0467, 0xec5feafe210c12bfc9a5d05925a123f1e73fbef8, 0x7023c70956e04a92d70025aad297b539af355869, 0xd66ddf1159cf22fd8c7a4bc8d5807756d433c43e, 0xd0638ea57189a6a699024ad78c71d939c1c2ff8c, 0x70d25ed2c8ada59c088cf70dd22bf2db93acc18a, 0xa4875928458ec2005dbb578c5cd33580f0cf1452, 0xb5ad5157dda921e6bafacd9086ae73ae1f611d3f, 0xc493489e56c3bdd829007dc2f956412906f76bfa, 0xc57612de91110c482e6f505bcd23f3c5047d1d61, 0x9b18478655a4851cc906e660feac61f7f4c8bffc, 0xb21b7979bf7c5ca01fa82dd640b41c39e6c6bc75, 0xa9d4a2bcbe5b9e0869d70f0fe2e1d6aacd45edc5, 0x6f29bb375be5ed34ed999bb830ee2957dde76d16, 0xa006268446643ec5e81e7acb3f17f1c351ee2ed9, 0x42ddd014dc52bfbcc555325a40b516f4866a1dd3, 0xd6d6776958ee23143a81adadeb08382009e996c2, 0xd34e03d36a2bd4d19a5fa16218d1d61e3ffa0b15, 0xdac0c177f11c5c3e3e78f2efd663d13221488574, 0x814135da8f9811075783bf1ab67062af8d3e9f40, 0x7c3eb713c4c9e0381cd8154c7c9a7db8645cde17, 0xf49c47b3efd86b6e6a5bc9418d1f9fec814b69ef, 0x35f1da127b83376f1b88c82a3359f67a5e67dd50, 0x44dfba50b829becc5f4f14d1b04aab3320a295e5, 0x0b924df007e9c0878417cfe63b976ea1a382a897, 0x82438fd2b32a9bdd674b49d8cc5fa2eff9781847, 0x794529d09d017271359730027075b87ad83dae6e, 0xf4b49100757772f33c177b9a76ba95226c8f3dd8, 0x8563c49361b625e768771c96151dbfbd1c906976, 0x0b9df80fbe232009dacf0aa8cac59376e2476203, 0x149b6dbde632c19f5af47cb493114bebd9b03c1f, 0xd7a1431ee453d1e49a0550d1256879b4f5d10201, 0x1d37616b793f94911838ac8e19ee9449df921ec4, 0xd6670c036df754be43dadd8f50feea289d061fd6, 0x02778e390fa17510a3428af2870c4273547d386c, 0xb89f4632df5909e58b2a9964f74feb9a3b01e0c5, 0x76c27535bcb59ce1fa2d8c919cabeb4a6bba01d1, 0x36bf43ff35df90908824336c9b31ce33067e2f50, 0xb53bcb174c2518348b818aece020364596466ba3, 0xb4dd460cd016725a64b22ea4f8e06e06674e033e, 0xcda1741109c0265b3fb2bf8d5ec9c2b8a3346b63, 0xfeb8b8e2af716ae41fc7c04bcf29540156461e6b, 0xa49f523aa51364cbc7d995163d34eb590ded2f08, 0xa7e74f0bdb278ff0a805a648618ec52b166ff1be, 0x5ead29037a12896478b1296ab714e9cb95428c81, 0xcdecf5675433cdb0c2e55a68db5d8bbe78419dd2, 0xc24ccebc2344cce56417fb684cf81613f0f4b9bd, 0x5a70106f20d63f875265e48e0d35f00e17d02bc9, 0x2606c3b3b4ca1b091498602cb1978bf3b95221c0, 0x1ad4563ea5786be1159935abb0f1d5879c3e7372, 0xb782bfd1e2de70f467646f9bc09ea5b1fcf450af, 0x649a2b9879cd8fb736e6703b0c7747849796f10f, 0x1cc1d3c14f0fb8640e36724dc43229d2ea7a1e48, 0x824b3c3c443e19295d7ef6faa7f374a4798486a8, 0xa7758cecb60e8f614cce96137ef72b4fbd07774a, 0x981f712775c0dad97518ffedcb47b9ad1d6c2762, 0x26e801b62c827191dd68d31a011990947fd0ebe0, 0x95447046313b2f3a5e19b948fd3b8bedc82c717c, 0x0b701101a4109f9cb360dc57b77442673d5e5983, 0x5b25cae86dcafa2a60e7723631fc5fa49c1ad87d, 0xf73ac46c203be1538111b151ec8220c786d84144, 0xe8c3d3b0e17f97d1e756e684f94e1470f99c95a1, 0x8c900a8236b08c2b65405d39d75f20062a7561fd, 0x43898c49a34d509bfed4f76041ee91caf3aa6aa5, 0xc85325eab2a59b3ed863c86a5f2906a04229ffa9, 0x4a430170152de5172633dd8262d107a0afd96a0f, 0x6e0ee70612c976287d499ddfa6c0dcc12c06deea, 0x21c07380484f6cbc8724ad32bc864c3b5ad500b7, 0xff5162f2354dc492c75fd6e3a107268660eecb47, 0x8845e9f90e96336bac3c616be9d88402683e004c, 0xf23c7b0cb8cd59b82bd890644a57daf40c85e278, 0x1784948bf99848c89e445638504dd698271b5924, 0xb39f4c00b2630cab7db7295ef43d47d501e17fd7, 0x3fb7d197b3ba4fe045efc23d50a14585f558d9b2, 0xbd043b67c63e60f841ccca15b129cdfe6590c8e3, 0x86ca0145957e6b0dfe36875fbe7a0dec55e17a28, 0xdae7201eab8c063302930d693929d07f95e71962, 0xcc034985d3f28c2d39b1a34bced4d3b2b6ca234e, 0x40e0dbf3efef9084ea1cd7e503f40b3b4a8443f6, 0xb1896a37e5d8825a2d01765ae5de629977de8352, 0xd9f547f2c1de0ed98a53d161df57635dd21a00bd, 0x2fea1b2f834f02fc54333f8a809f0438e5870aa9, 0x68b31836a30a016ada157b638ac15da73f18cfde, 0xbc967fe4418c18b99858966d870678dca2b88879, 0x16bae5d24eff91778cd98b4d3a1cc3162f44aa77, 0xf476e1267f86247cc908816f2e7ad5388c952db0, 0x0203ae01d4c41cae1865e04b1f5b53cdfaecae31, 0xbd4bd5b122d8ef7b7c8f0667450320db2116142e, 0xa394ad4fd9e6530e6f5c53faecbede81cb172da1, 0x3a9960266df6492063538a99f487c950a3a5ec9e, 0xd8069f84b521493f4715037f3226b25f33b60586, 0x136c834bf111326d207395295b2e583ea7f33572, 0xc5c73d61cce7c8fe4c8fce29f39092cd193e0fff, 0x3cfbf066565970639e130df2a7d16b0e14d6091c, 0x61b905de663fc17386523b3a28e2f7d037a655cd, 0xfda0ce15330707f10bce3201172d2018b9ddea74, 0xf7fc45abf76f5088e2e5b5a8d132f28a4d4ec1c0, 0xc3db9fb6f46c480af34465d79753b4e2b74a67ce, 0xebe46cc3c34c32f5add6c3195bb486c4713eb918, 0x91d2a9ee1a6db20f5317cca7fbe2313895db8ef8, 0xc4cc45a2b63c27c0b4429e58cd42da59be739bd6, 0xa43b81f99356c0af141a03010d77bd042c71c1ee, 0x4c45d4c9a725d11112bfcbca00bf31186ccaadb7, 0xbf9f271f7a7e12e36dd2fe9facebf385fe6142bd, 0xe0ce80a461b648a501fd0b824690c8868b0e4de8, 0xa1f7dde1d738d8cd679ea1ee965bee224be7d04d, 0x7f1c81ee1697fc144b7c0be5493b5615ae7fddca, 0xb508f987b2de34ae4cf193de85bff61389621f88, 0x5f26cf34599bc36ea67b9e7a9f9b4330c9d542a3, 0xd02108d2ae3cab10cbcf1657af223e027c8210f6, 0x952183cfd38e352e579d36decec5b18450f7fba0, 0xeb90c793b3539761e1c814a29671148692193eb4, 0x1076212d4f758c8ec7121c1c7d74254926459284, 0xf05ceeab65410564709951773c8445ad9f4ec797, 0x05361d8eb6941d4e90fb7e1418a95a32d5257732, 0xa5783bf33432ff82ac498985d7d460ae67ec3673, 0xb1cd4bdfd104489a026ec99d597307a04279f173, 0x876c3f218b4776df3ca9dbfb270de152d94ed252, 0x8a36869ad478997cbf6d8924d20a3c8018e9855b, 0xfb3fe09bb836861529d7518da27635f538505615, 0xd093e829819fd2e25b973800bb3d5841dd152d05, 0x126d91f7ad86debb0557c612ca276eb7f96d00a1, 0x2a81d27cb6d4770ff4f3c4a3ba18e5e57f07517c, 0xc4f7b13ac6d4eb4db3d4e6a252af8a07bd5957da, 0x305d26c10bdc103f6b9c21272eb7cb2d9108c47e, 0xd0d0a2ad45f59a9dccc695d85f25ca46ed31a5a3, 0x522323aad71dbc96d85af90f084b99c3f09decb7, 0xf43da3a4e3f5fab104ca9bc1a0f7f3bb4a56f351, 0xa2dc65ee256b59a5bd7929774f904b358df3ada1, 0xf382df583155d8548f3f93440cd5f68cb79d6026, 0x0c967e3061b87a753e84507eb60986782c8f3013, 0xa3a262afd2936819230892fde84f2d5a594ab283, 0x93868ddb2a794d02ebda2fa4807c76e3609858dc, 0xcd35ff010ec501a721a1b2f07a9ca5877dfcf95a, 0x5824a7e22838277134308c5f4b50dab65e43bb31, 0x7f7a3a21b3f5a65d81e0fcb7d52dd00a1aa36dba, 0x30513fca9f36fd788cfea7a340e86df98294a244, 0x283e6252b4efcf4654391acb75f903c59b78c5fb, 0xeddbaafbc21be8f25562f1ed6d05d6afb58f02c2, 0x0dcfe837ea1cf28c65fccec3bef1f84e59d150c0, 0x828ba651cb930ed9787156299a3de44cd08b7212, 0xcfd47493c9f89fe680bda5754dd7c9cfe7cb5bbe, 0x0e89eddd3fa0d71d8ab0ff8da5580686e3d4f74f, 0x205f5166f12440d85762c967d3ae86184f8f4d98, 0x25dad495a11a86b9eeece1eeec805e57f157faff, 0x6c84cba77c6db4f7f90ef13d5ee21e8cfc7f8314, 0x91a787bc5196f34857fe0c372f4df376aaa76613, 0xb0d3c9872b85056ea0c0e6d1ecf7a77e3ce6ab85, 0x6e4d2e39c8836629e5b487b1918a669aebdd9536, 0xdc703a5f3794c84d6cb3544918cae14a35c3bd4f, 0x47beb20f759100542aa93d41118b3211d664920e, 0x5a7735007d70b06844da9901cdfadb11a2582c2f, 0xaff107960b7ec34ed690b665024d60838c190f70, 0x563a03ab9c56b600f6d25b660c21e16335517a75, 0xa106465bbd19e1b6bce50d1b1157dc59095a3630, 0xca9dec02841adf5cc920576a5187edd2bd434a18, 0x572ac1aba0de23ae41a7cae1dc0842d8abfc103b, 0x5f74ed0e24ff80d9b2c4a44baa9975428cd6b935, 0xf2049532fd458a83ca1bff2eebacb6d5ca63f4a4, 0xcee699c0707a7836252b292f047ce8ad289b2f55, 0x8b3696f3c60de32432a2e4c395ef0303b7e81e75, 0x13dee03e3799952d0738843d4be8fc0a803fb20e, 0xc853215b9b9f2d2cd0741e585e987b5fb80c212e, 0x851c0d62be4635d4777e8035e37e4ba8517c6132, 0xa76b743f981b693072a131b22ba510965c2fefd7, 0x69bd25ade1a3346c59c4e930db2a9d715ef0a27a, 0x0fec4ee0d7ca180290b6bd20f9992342f60ff68d, 0xccfd725760a68823ff1e062f4cc97e1360e8d997, 0x9f017706b830fb9c30efb0a09f506b9157457534, 0x420fb86e7d2b51401fc5e8c72015decb4ef8fc2e, 0xcb7d2b8089e9312cc9aeaa2773f35308ec6c2a7b, 0x6c822029218ac8e98a260c1e064029348839875b, 0x1c68a66138783a63c98cc675a9ec77af4598d35e, 0xf270792576f05d514493ffd1f5e84bec4b2df810, 0x9191f94698210516cf6321a142070e20597674ed, 0xc0ca3277942e7445874be31ceb902972714f1823, 0x35e096120deaa5c1ecb1645e2ccb8b4edbd9299a, 0xe2bbf84641e3541f6c33e6ed683a635a70bde2ec, 0xd12d77ae01a92d35117bac705aacd982d02e74c1, 0xdabb0889fc042926b05ef57b2520910abc4b4149, 0x5a1a336962d6e0c63031cc83c6a5c6a6f4478ecb, 0xabd154903513b8da4f019f68284b0656a1d0169b, 0xad377cd25eb53e83ae091a0a1d2b4516f484afde, 0x08c2f236ac4adcd3fda9fbc6e4532253f9da3bec, 0x71135d8f05963c905a4a07922909235a896a52ea, 0x080546508a3d2682c8b9884f13637b8847b44db3, 0x2d61bfc56873923c2b00095dc3eaa0f590d8ae0f, 0xcbfa6af6c283b046e2772c6063b0b21553c40106, 0xccabc6048a53464424fcf76eeb9e6e1801fa23d4, 0x60cc3d445ebdf76a7d7ae571c6971dff68cc8585, 0xfff33a3bd36abdbd412707b8e310d6011454a7ae, 0xd2dbebe89b0357aea98bbe8e496338debb28e805, 0x5f521282e9b278dc8c034c72af53ee29e5443d78, 0xc5a48a8500f9b4e22f0eb16c6f4649687674267d, 0x8cb3aa3fcd212854d7578fcc30fdede6742a312a, 0x90d2809ae1d1ffd8f63eda01de49dd552df3d1bc, 0x96a55f00dff405dc4de5e58c57f6f6f0cac55d2f, 0xae842e81858ecfedf6506c686dc204ac15bf8b24, 0x0be6a09e4307fe48d412b8d1a1a8284dce486261, 0xc9c7ac0bdd9342b5ead4360923f68c72a6ba633a, 0xea8f30b6e4c5e65290fb9864259bc5990fa8ee8a, 0x74d37a51747bf8b771bfbf43943933d100d21483, 0x1a04d5389eb006f9ce880c30d15353f8d11c4b31, 0x726a14c90e3f84144c765cffacba3e0df11b48be, 0x86b7bd563ceab686f96244f9ddc02ad7b0b14bc2, 0x2bbe672a1857508f630f2a5edb563d9e9de92815, 0xa17070c2e9c5a940a4ec0e4954c4d7d643be8f49, 0xf2d1b7357724ec4c03185b879b63f57e26589153, 0xd6a7ac4de7b510f0e8de519d973fa4c01ba83400, 0x593b45a1864ac5c7e8f0caaeba0d873cd5d113b2, 0x0837539b5f6a522a482cdcd3a9bb7043af39bdd2, 0xb927abd2d28aaaa24db31778d27419df8e1b04bb, 0xb2e085fddd1468ba07415b274e734e11237fb2a9, 0x970938522afb5e8f994873c9fbdc26e3b37e314c, 0xf3de5f26ef6aded6f06d3b911346ee70401da4a0, 0xbffb6929241f788693273e7022e60e3eab1fe84f, 0xb56ad2aec6c8c3f19e1515bbb7dd91285256b639, 0x47730f5f8ebf89ac72ef80e46c12195038ecdc49, 0xf39a9d7aa3581df07ee4279ae6c312ef21033658, 0x36227cdfa0fd3b9d7e6a744685f5be9aa366a7f0, 0x89e3b59a15864737d493c1d23cc53dbf8dcb1362, 0xbd08e0cddec097db7901ea819a3d1fd9de8951a2, 0x533444584082eba654e1ad30e149735c6f7ba922, 0x6a8a4317c45faa0554ccdb482548183e295a24b9, 0x22ce349159eeb144ef06ff2636588aef79f62832, 0x3cd1d9731bd548c1dd6fcea61beb75d91754f7d3, 0x8b7056f6abf3b118d026e944d5c073433ca451d7, 0x15f1b352110d68901d8f67aac46a6cfafe031477, 0x0f789e30397c53bf256fc364e6ef39f853504114, 0x750bbb8c06bbbf240843cc75782ee02f08a97453, 0xfff7ac99c8e4feb60c9750054bdc14ce1857f181, 0x5c6f36af90ab1a656c6ec8c7d521512762bba3e1, 0x6811b54cd19663b11b94da1de2448285cd9f68d9, 0x6f50929777824c291a49c46dc854f379a6bea080, 0xe83604e4ff6be7f96f6018d3ec3072ec525dff6b, 0xd731bb6b5f3c37395e09ceaccd14a918a6060789, 0x372e453a6b629f27678cc8aeb5e57ce85ec0aef9, 0x86924fb211aad23cf5ce600e0aae806396444087, 0x18c6723a6753299cb914477d04a3bd218df8c775, 0xe00484788db50fc6a48e379d123e508b0f6e5ab1, 0x150e3dbcbcfc84ccf89b73427763a565c23e60d0, 0x8ffa062122ac307418821adb9311075a3703bfa3, 0x21206ce22ea480e85940d31314e0d64f4e4d3a04, 0xac024f594f9558f04943618eb0e6b2ee501dc272, 0xb2b7cdb4ff4b61d5b7ce0b2270bbb5269743ec04, 0xabc74706964960dfe0dca3dca79e9216056f1cf4, 0xd7eb903162271c1afa35fe69e37322c8a4d29b11, 0xd7c6265dea11876c903b718e4cd8ab24fe265bde, 0xcba288cd3c1eb4d59ddb06a6421c14c345a47b24, 0x8c22426055b76f11f0a2de1a7f819a619685fe60, 0xf463a90cb3f13e1f0643423636beab84c123b06d, 0x2b5ced9987c0765f900e49cf9da2d9f9c1138855, 0x9bb760d5c289a3e1db18db095345ca413b9a43c2, 0xd66ab79294074c8b627d842dab41e17dd70c5de5, 0x0bdd58b96e7c916dd2fb30356f2aebfaaf1d8630, 0xd612597bc31743c78633f633f239b1e9426bd925, 0x140518a3194bad1350b8949e650565debe6db315, 0xdaedd4ad107b271e89486cbf80ebd621dd974578, 0xc36c0b63bfd75c2f8efb060883d868cccd6cbdb4, 0xe646665872e40b0d7aa2ff82729caaba5bc3e89e, 0xb5fb7ea2ddc1598b667a9d57dd39e85a38f35d56, 0xe51421f8ee2210c71ed870fe618276c8954afbe9, 0x08a9a44e1f41de3dbba7a363a3ab412c124cd15e, 0x562bced38ab2ab6c080f3b0541b8456e70824b3f, 0x1e484d0621f0f5331b35d5408d9aae4eb1acf21e, 0x3a476bd2c9e664c63ab266aa4c6e4a4825f516c3, 0x8d6df209484d7b94702b03a53e56b9fb0660f6f0, 0x5970fb1b144dd751e4ce2eca7caa20e363dc4da3, 0xd1dd79fb158160e5b4e8e23f312e6a907fbc4d4e, 0x7ee5ca805dce23af89c2d444e7e40766c54c7404, 0x93e0f37ecdfb0086e3e862a97034447b1e4dec1a, 0xe10ac19c546fc2547c61c139f5d1f45a6666d5b0, 0x1c73d00b6e25d8eb9c1ff4ad827b6b9e9cf6d20c, 0xd771d9e0ca8a08a113775731434eb3270599c40d, 0xe69d1c378b771e0feff051db69d966ac6779f4ed, 0x0ef85b49d08a75198692914eddb4b22cf5fa4450, 0xed70a37cdd1cbda9746d939658ae2a6181288578, 0xeee761847e33fd61d99387ee14628694d1bfd525, 0x271d3d481cb88e7671ad216949b6365e06303de0, 0x5255dc69155a45b970c604d30047e2f530690e7f, 0xcabab6274ed15089737e287be878b757934864e2, 0x9defe56a0ff1a1947dba0923f7dd258d8f12fa45, 0xb7a2c103728b7305b5ae6e961c94ee99c9fe8e2b, 0xb498bb0f520005b6216a4425b75aa9adc52d622b, 0xc1132878235c5ddba5d9f3228b5236e47020dc6f, 0xf81622e55757daea6675975dd93538da7d16991e, 0xce2deab51c0a9ae09cd212c4fa4cc52b53cc0dec, 0x86a1eadeeb30461345d9ef6bd05216fa247c0d0c, 0x7b1fe1ab4dfd0088cdd7f60163ef59ec2aee06f5, 0x6bbc3f358a668dd1a11f0380f3f73108426abd4a, 0xb1e6e810c24ab0488de9e01e574837829f7c77d0, 0x03eb3cb860f6028da554d344a2bb5a500ae8b86f, 0xe5481a7fed42b901bbed20789bd4ade50d5f83b9, 0x1f3da68fe87eaf43a829ab6d7ec5a6e009b204fb, 0x30037988702671acbe892c03fe5788aa98af287a, 0xedb473353979a206879de144c10a3c51d7d7081a, 0x22bdffc240a88ff7431af3bff50e14da37d5183e, 0x9374869d4a9911ee1eaf558bc4c2b63ec63acfdd, 0xb756ad52f3bf74a7d24c67471e0887436936504c, 0x8bd0b65a50ef5cef84fec420be7b89ed1470ceb9, 0xaf26f7c6bf453e2078f08953e4b28004a2c1e209, 0x7c532db9e0c06c26fd40acc56ac55c1ee92d3c3a, 0xdde670d01639667576a22dd05d3246d61f06e083, 0x5cf44e10540d65716423b1bcb542d21ff83a94cd, 0xf96b4c00766f53736a8574f822e6474c2f21da2d, 0x8d89170b92b2be2c08d57c48a7b190a2f146720f, 0x142b87c5043ffb5a91df18c2e109ced6fe4a71db, 0x42d34940edd2e7005d46e2188e4cfece8311d74d, 0x562105e82b099735de49f62692cc87cd38a8edcd, 0x457bcef37dd3d60b2dd019e3fe61d46b3f1e7252, 0xcf8882359c0fb23387f5674074d8b17ade512f98, 0xf0c081da52a9ae36642adf5e08205f05c54168a6, 0x551e7784778ef8e048e495df49f2614f84a4f1dc, 0x3c869c09696523ced824a070414605bb76231ff2, 0x7e7f18a02eccaa5d61ab8fbf030343c434a25ef7, 0x9328d55ccb3fce531f199382339f0e576ee840a3, 0x9d0f347e826b7dceaad279060a35c0061ecf334b, 0x680640838bd07a447b168d6d923b90cf6c43cdca, 0xc951900c341abbb3bafbf7ee2029377071dbc36a, 0xddf5810a0eb2fb2e32323bb2c99509ab320f24ac, 0x2489ac126934d4d6a94df08743da7b7691e9798e, 0xf42f905231c770f0a406f2b768877fb49eee0f21, 0x756f45e3fa69347a9a973a725e3c98bc4db0b5a0, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"0x3282791d6fd713f1e94f4bfd565eaa78b3a0599d":"1337000000000000000000","0x17961d633bcf20a7b029a7d94b7df4da2ec5427f":"229427000000000000000","0x493a67fe23decc63b10dda75f3287695a81bd5ab":"880000000000000000000","0x01fb8ec12425a04f813e46c54c05748ca6b29aa9":"259800000000000000000","0xd2a030ac8952325f9e1db378a71485a24e1b07b2":"2000000000000000000000","0x77a34907f305a54c85db09c363fde3c47e6ae21f":"985000000000000000000","0x391a77405c09a72b5e8436237aaaf95d68da1709":"49082000000000000000","0x00aada25ea2286709abb422d41923fd380cd04c7":"650100000000000000000","0xacc46a2a555c74ded4a2bd094e821b97843b40c0":"1940000000000000000000","0xde07fb5b7a464e3ba7fbe09e9acb271af5338c58":"50000000000000000000","0x4c696be99f3a690440c3436a59a7d7e937d6ba0d":"3460000000000000000000","0xfa33553285a973719a0d5f956ff861b2d89ed304":"20000000000000000000","0x67cfda6e70bf7657d39059b59790e5145afdbe61":"646000000000000000000","0xa321091d3018064279db399d2b2a88a6f440ae24":"3200000000000000000000","0xfb3fa1ac08aba9cc3bf0fe9d483820688f65b410":"30000000000000000000000","0x6715c14035fb57bb3d667f7b707498c41074b855":"700000000000000000000","0xd4344f7d5cad65d17e5c2d0e7323943d6f62fe92":"267400000000000000000","0xa3294626ec2984c43b43da4d5d8e4669b11d4b59":"1008000000000000000000","0x656018584130db83ab0591a8128d9381666a8d0e":"63960000000000000000","0x0fa010ce0c731d3b628e36b91f571300e49dbeab":"999800000000000000000","0x3098b65db93ecacaf7353c48808390a223d57684":"449965000000000000000","0xae635bf73831119d2d29c0d04ff8f8d8d0a57a46":"1337000000000000000000","0x0f7515ff0e808f695e0c20485ff96ed2f7b79310":"1000169000000000000000","0x8b30c04098d7a7e6420c357ea7bfa49bac9a8a18":"8000200000000000000000","0x64dba2d6615b8bd7571836dc75bc79d314f5ecee":"10000000000000000000000","0xe7912d4cf4562c573ddc5b71e37310e378ef86c9":"394000000000000000000","0xa4da34450d22ec0ffcede0004b02f7872ee0b73a":"93342000000000000000","0x34437d1465640b136cb5841c3f934f9ba0b7097d":"173000000000000000000","0xc652871d192422c6bc235fa063b44a7e1d43e385":"155000000000000000000","0xa8a708e84f82db86a35502193b4c6ee9a76ebe8f":"1015200000000000000000","0x5c3f567faff7bad1b5120022e8cbcaa82b4917b3":"2000000000000000000000","0xdbc1d0ee2bab531140de137722cd36bdb4e47194":"200000000000000000000","0xf59dab1bf8df11327e61f9b7a14b563a96ec3554":"6000000000000000000000","0x456f8d746682b224679349064d1b368c7c05b176":"3700000000000000000000","0x5f13154631466dcb1353c890932a7c97e0878e90":"6000000000000000000000","0xf4b1626e24f30bcad9273c527fcc714b5d007b8f":"200000000000000000000","0xa8db0b9b201453333c757f6ad9bcb555c02da93b":"2199970000000000000000","0xa0fc7e53c5ebd27a2abdac45261f84ab3b51aefb":"3008250000000000000000","0x1b636b7a496f044d7359596e353a104616436f6b":"360354000000000000000","0x74bce9ec38362d6c94ccac26d5c0e13a8b3b1d40":"999954000000000000000","0x9834682180b982d166badb9d9d1d9bbf016d87ee":"2000000000000000000000","0x1e6e0153fc161bc05e656bbb144c7187bf4fe84d":"2000000000000000000000","0x989c0ccff654da03aeb11af701054561d6297e1d":"4000000000000000000000","0x78a1e254409fb1b55a7cb4dd8eba3b30c8bad9ef":"100000000000000000000","0x9ef1896b007c32a15114fb89d73dbd47f9122b69":"4000000000000000000000","0x33320dd90f2baa110dd334872a998f148426453c":"999972000000000000000","0xe72e1d335cc29a96b9b1c02f003a16d971e90b9d":"1580000000000000000000","0x0921605f99164e3bcc28f31caece78973182561d":"793744000000000000000","0xfc00a420a36107dfd5f495128a5fe5abb2db0f34":"5960000000000000000000","0xdfcbdf09454e1a5e4a40d3eef7c5cf1cd3de9486":"4000000000000000000000","0x646e043d0597a664948fbb0dc15475a3a4f3a6ed":"20000000000000000000","0x79aeb34566b974c35a5881dec020927da7df5d25":"2000000000000000000000","0xdbadc61ed5f0460a7f18e51b2fb2614d9264a0e0":"40000000000000000000","0x97b91efe7350c2d57e7e406bab18f3617bcde14a":"9999980000000000000000","0x8398e07ebcb4f75ff2116de77c1c2a99f303a4cf":"500000000000000000000","0xf02796295101674288c1d93467053d042219b794":"740000000000000000000","0xf4ed848ec961739c2c7e352f435ba70a7cd5db38":"1970000000000000000000","0x82485728d0e281563758c75ab27ed9e882a0002d":"147000000000000000000","0x427ec668ac9404e895cc861511d1620a4912be98":"40000000000000000000000","0x1bbc199e586790be87afedc849c04726745c5d7b":"4000000000000000000000","0x10d945334ecde47beb9ca3816c173dfbbd0b5333":"1400000000000000000000","0x1dcebcb7656df5dcaa3368a055d22f9ed6cdd940":"499800000000000000000","0x2ac1f8d7bf721f3cfe74d20fea9b87a28aaa982c":"161000000000000000000","0x0a47ad9059a249fc936b2662353da6905f75c2b9":"2000000000000000000000","0x768498934e37e905f1d0e77b44b574bcf3ec4ae8":"20000000000000000000000","0xf46b6b9c7cb552829c1d3dfd8ffb11aabae782f6":"21000000000000000000","0x7aea25d42b2612286e99c53697c6bc4100e2dbbf":"2000000000000000000000","0xaf3615c789d0b1152ad4db25fe5dcf222804cf62":"1000000000000000000000","0x92e6581e1da1f9b846e09347333dc818e2d2ac66":"3640000000000000000000","0x240305727313d01e73542c775ff59d11cd35f819":"5931229000000000000000","0xb95cfda8465ba9c2661b249fc3ab661bdfa35ff0":"318949000000000000000","0x1b0d076817e8d68ee2df4e1da1c1142d198c4435":"1550000000000000000000","0x93c2e64e5de5589ed25006e843196ee9b1cf0b3e":"1670000000000000000000","0x0e2e504a2d1122b5a9feee5cb1451bf4c2ace87b":"3940000000000000000000","0x22b96ab2cad55db100b53001f9e4db378104c807":"10000000000000000000000","0xa927d48bb6cb814bc609cbcaa9151f5d459a27e1":"271600000000000000000","0x5cbd8daf27ddf704cdd0d909a789ba36ed4f37b2":"13400000000000000000","0x9adbd3bc7b0afc05d1d2eda49ff863939c48db46":"199955000000000000000","0xac7e03702723cb16ee27e22dd0b815dc2d5cae9f":"16000000000000000000000","0x1e210e7047886daa52aaf70f4b991dac68e3025e":"200000000000000000000","0xc98048687f2bfcc9bd90ed18736c57edd352b65d":"1000000000000000000000","0x81c18c2a238ddc4cba230a072dd7dc101e620273":"1337000000000000000000","0xcb3d766c983f192bcecac70f4ee03dd9ff714d51":"100000000000000000000","0x44a63d18424587b9b307bfc3c364ae10cd04c713":"20000000000000000000","0x4ab2d34f04834fbf7479649cab923d2c4725c553":"3520000000000000000000","0xb834acf3015322c58382eeb2b79638906e88b6de":"24000000000000000000000","0x7d551397f79a2988b064afd0efebee802c7721bc":"39400000000000000000000","0xb537d36a70eeb8d3e5c80de815225c1158cb92c4":"1500000000000000000000","0x805ce51297a0793b812067f017b3e7b2df9bb1f9":"100000000000000000000","0x085ba65febe23eefc2c802666ab1262382cfc494":"400000000000000000000","0xb1c0d08b36e184f9952a4037e3e53a667d070a4e":"1000000000000000000000","0x83fe5a1b328bae440711beaf6aad6026eda6d220":"20000000000000000000000","0x7fd679e5fb0da2a5d116194dcb508318edc580f3":"6560000000000000000000","0x41ad369f758fef38a19aa3149379832c818ef2a0":"1000060000000000000000","0x6d846dc12657e91af25008519c3e857f51707dd6":"4590000000000000000000","0xc02d6eadeacf1b78b3ca85035c637bb1ce01f490":"4000000000000000000000","0x826eb7cd7319b82dd07a1f3b409071d96e39677f":"1000000000000000000000","0x4ac9905a4cb6ab1cfd62546ee5917300b87c4fde":"1015200000000000000000","0xcf6e52e6b77480b1867efec6446d9fc3cc3577e8":"222010000000000000000","0x2476b2bb751ce748e1a4c4ff7b230be0c15d2245":"4000000000000000000000","0x1a505e62a74e87e577473e4f3afa16bedd3cfa52":"500000000000000000000","0x21d02705f3f64905d80ed9147913ea8c7307d695":"1363740000000000000000","0x7b1daf14891b8a1e1bd429d8b36b9a4aa1d9afbf":"500000000000000000000","0x5338ef70eac9dd9af5a0503b5efad1039e67e725":"2674000000000000000000","0x50ca86b5eb1d01874df8e5f34945d49c6c1ab848":"1000000000000000000000","0xf3cc8bcb559465f81bfe583bd7ab0a2306453b9e":"20000000000000000000000","0x5c323457e187761a8276e359b7b7af3f3b6e3df6":"10000000000000000000000","0x4d82d7700c123bb919419bbaf046799c6b0e2c66":"20000000000000000000000","0x8a66abbc2d30ce21a833b0db8e561d5105e0a72c":"699958000000000000000","0x2ae53866fc2d14d572ab73b4a065a1188267f527":"8000000000000000000000","0x9af5c9894c33e42c2c518e3ac670ea9505d1b53e":"18200000000000000000","0xcba25c7a503cc8e0d04971ca05c762f9b762b48b":"500000000000000000000","0xfda3042819af3e662900e1b92b4358eda6e92590":"118200000000000000000000","0x9bd7c38a4210304a4d653edeff1b3ce45fce7843":"282000000000000000000","0xedc22fb92c638e1e21ff5cf039daa6e734dafb29":"298000000000000000000","0xa1f193a0592f1feb9fdfc90aa813784eb80471c9":"1400000000000000000000","0xe97fde0b67716325cf0ecce8a191a3761b2c791d":"1004700000000000000000","0x110237cf9117e767922fc4a1b78d7964da82df20":"3940000000000000000000","0xe32f95766d57b5cd4b173289d6876f9e64558194":"100000000000000000000","0xf2d59c8923759073d6f415aaf8eb065ff2f3b685":"7880000000000000000000","0xc53d79f7cb9b70952fd30fce58d54b9f0b59f647":"5089200000000000000000","0x9eb281c32719c40fdb3e216db0f37fbc73a026b7":"20000000000000000000","0x2d6511fd7a3800b26854c7ec39c0dcb5f4c4e8e8":"399910000000000000000","0x61ba87c77e9b596de7ba0e326fddfeec2163ef66":"200000000000000000000","0xde1121829c9a08284087a43fbd2fc1142a3233b4":"1000000000000000000000","0x22a25812ab56dcc423175ed1d8adacce33cd1810":"1850000000000000000000","0x518cef27b10582b6d14f69483ddaa0dd3c87bb5c":"600000000000000000000","0x59161749fedcf1c721f2202d13ade2abcf460b3d":"2000000000000000000000","0x3e36c17253c11cf38974ed0db1b759160da63783":"7000000000000000000000","0xcbfa76db04ce38fb205d37b8d377cf1380da0317":"1430000000000000000000","0xa7e83772bc200f9006aa2a260dbaa8483dc52b30":"207730000000000000000","0xe87eac6d602b4109c9671bf57b950c2cfdb99d55":"49932000000000000000","0x9b06ad841dffbe4ccf46f1039fc386f3c321446e":"2000000000000000000000","0xe0f903c1e48ac421ab48528f3d4a2648080fe043":"1015200000000000000000","0x5d872b122e994ef27c71d7deb457bf65429eca6c":"7999973000000000000000","0xf34083ecea385017aa40bdd35ef7effb4ce7762d":"400000000000000000000","0x7f3709391f3fbeba3592d175c740e87a09541d02":"480000000000000000000","0x888e94917083d152202b53163939869d271175b4":"4000000000000000000000","0xbed4c8f006a27c1e5f7ce205de75f516bfb9f764":"16000000000000000000000","0xb3a6bd41f9d9c3201e050b87198fbda399342210":"3622615000000000000000","0x550aadae1221b07afea39fba2ed62e05e5b7b5f9":"20000000000000000000","0xbcedc4267ccb89b31bb764d7211171008d94d44d":"200000000000000000000","0x6229dcc203b1edccfdf06e87910c452a1f4d7a72":"32500000000000000000000","0x94be3ae54f62d663b0d4cc9e1ea8fe9556ea9ebf":"23280000000000000000","0x0e0c9d005ea016c295cd795cc9213e87febc33eb":"198000000000000000000","0x55d057bcc04bd0f4af9642513aa5090bb3ff93fe":"1106680000000000000000","0xed9e030ca75cb1d29ea01d0d4cdfdccd3844b6e4":"30895000000000000000","0x86c4ce06d9ac185bb148d96f7b7abe73f441006d":"10000000000000000000000","0x2c04115c3e52961b0dc0b0bf31fba4546f5966fd":"200000000000000000000","0xb959dce02e91d9db02b1bd8b7d17a9c41a97af09":"8000000000000000000000","0xe01547ba42fcafaf93938becf7699f74290af74f":"2000000000000000000000","0xc593d6e37d14b566643ac4135f243caa0787c182":"12000000000000000000000","0x2c0ee134d8b36145b47beee7af8d2738dbda08e8":"201000000000000000000","0x0ef54ac7264d2254abbb5f8b41adde875157db7c":"40000000000000000000","0x0349634dc2a9e80c3f7721ee2b5046aeaaedfbb5":"4000000000000000000000","0x873e49135c3391991060290aa7f6ccb8f85a78db":"20000000000000000000","0x05236d4c90d065f9e3938358aaffd777b86aec49":"500000000000000000000","0xd2abd84a181093e5e229136f42d835e8235de109":"100007000000000000000","0xb56a780028039c81caf37b6775c620e786954764":"2000000000000000000000","0x86df73bd377f2c09de63c45d67f283eaefa0f4ab":"1000000000000000000000","0x7670b02f2c3cf8fd4f4730f3381a71ea431c33c7":"267400000000000000000","0x24aa1151bb765fa3a89ca50eb6e1b1c706417fd4":"3100000000000000000000","0x43227d65334e691cf231b4a4e1d339b95d598afb":"10000000000000000000000","0x695550656cbf90b75d92ad9122d90d23ca68ca4d":"1000000000000000000000","0x5281733473e00d87f11e9955e589b59f4ac28e7a":"660360000000000000000000","0x99a96bf2242ea1b39ece6fcc0d18aed00c0179f3":"300000000000000000000","0xb1cf94f8091505055f010ab4bac696e0ca0f67a1":"1580000000000000000000","0x54391b4d176d476cea164e5fb535c69700cb2535":"100076000000000000000","0x152f2bd229ddf3cb0fdaf455c183209c0e1e39a2":"2000000000000000000000","0xaffc99d5ebb4a84fe7788d97dce274b038240438":"5000000000000000000000","0x23df8f48ee009256ea797e1fa369beebcf6bc663":"2302671000000000000000","0x3a72d635aadeee4382349db98a1813a4cfeb3df1":"200000000000000000000000","0xce26f9a5305f8381094354dbfc92664e84f902b5":"230200000000000000000","0xd283b8edb10a25528a4404de1c65e7410dbcaa67":"12000000000000000000000","0xa7859fc07f756ea7dcebbccd42f05817582d973f":"10000000000000000000000","0xb28181a458a440f1c6bb1de8400281a3148f4c35":"376000000000000000000","0x27b1694eafa165ebd7cc7bc99e74814a951419dc":"800000000000000000000","0x66cc8ab23c00d1b82acd7d73f38c99e0d05a4fa6":"100000000000000000000","0x926082cb7eed4b1993ad245a477267e1c33cd568":"374300000000000000000","0x4a47fc3e177f567a1e3893e000e36bba23520ab8":"2000000000000000000000","0x594a76f06935388dde5e234696a0668bc20d2ddc":"2800000000000000000000","0xe91fa0badaddb9a97e88d3f4db7c55d6bb7430fe":"376000000000000000000","0x574de1b3f38d915846ae3718564a5ada20c2f3ed":"4000000000000000000000","0x5816c2687777b6d7d2a2432d59a41fa059e3a406":"133700000000000000000000","0xb50955aa6e341571986608bdc891c2139f540cdf":"1970000000000000000000","0x6d44974a31d187eda16ddd47b9c7ec5002d61fbe":"940000000000000000000","0x80abec5aa36e5c9d098f1b942881bd5acac6963d":"2000000000000000000000","0x294f494b3f2e143c2ffc9738cbfd9501850b874e":"2240000000000000000000","0xbca3ffd4683fba0ad3bbc90734b611da9cfb457e":"200000000000000000000","0x5992624c54cdec60a5ae938033af8be0c50cbb0a":"3621678000000000000000","0x6560941328ff587cbc56c38c78238a7bb5f442f6":"744900000000000000000","0x74b7e0228baed65957aebb4d916d333aae164f0e":"2000000000000000000000","0x8516fcaf77c893970fcd1a958ba9a00e49044019":"196279000000000000000","0xb992a967308c02b98af91ee760fd3b6b4824ab0e":"2000000000000000000000","0x30bb4357cd6910c86d2238bf727cbe8156680e62":"100014000000000000000","0xb8cc0f060aad92d4eb8b36b3b95ce9e90eb383d7":"150000000000000000000000","0x28d4ebf41e3d3c451e943bdd7e1f175fae932a3d":"6000000000000000000000","0x8c83d424a3cf24d51f01923dd54a18d6b6fede7b":"4000000000000000000000","0x7efc90766a00bc52372cac97fabd8a3c831f8ecd":"158000000000000000000","0x7c2b9603884a4f2e464eceb97d17938d828bc02c":"3000000000000000000000","0x9d250ae4f110d71cafc7b0adb52e8d9acb6679b8":"9840000000000000000000","0x61b3df2e9e9fd968131f1e88f0a0eb5bd765464d":"4000000000000000000000","0x9ae13bd882f2576575921a94974cbea861ba0d35":"3160000000000000000000","0x3d09688d93ad07f3abe68c722723cd680990435e":"29999948000000000000000","0x5e58e255fc19870a04305ff2a04631f2ff294bb1":"17600000000000000000","0xbcaed0acb6a76f113f7c613555a2c3b0f5bf34a5":"193600000000000000000","0x159adce27aa10b47236429a34a5ac42cad5b6416":"31867951000000000000000","0xe834c64318205ca7dd4a21abcb08266cb21ff02c":"999999000000000000000","0x7b6a84718dd86e63338429ac811d7c8a860f21f1":"1790000000000000000000","0x2118c116ab0cdf6fd11d54a4309307b477c3fc0f":"10000000000000000000000","0x34a901a69f036bcf9f7843c0ba01b426e8c3dc2b":"4000000000000000000000","0xc7d44fe32c7f8cd5f1a97427b6cd3afc9e45023e":"1580000000000000000000","0xc6045b3c350b4ce9ca0c6b754fb41a69b97e9900":"925000000000000000000","0xcf5a6f9df75579c644f794711215b30d77a0ce40":"2000000000000000000000","0xe2904b1aefa056398b6234cb35811288d736db67":"40000000000000000000","0x7101bd799e411cde14bdfac25b067ac890eab8e8":"1450054000000000000000","0xcc45fb3a555bad807b388a0357c855205f7c75e8":"865000000000000000000","0xff0c3c7798e8733dd2668152891bab80a8be955c":"80220000000000000000","0x3536453322c1466cb905af5c335ca8db74bff1e6":"447000000000000000000","0x08cac8952641d8fc526ec1ab4f2df826a5e7710f":"300000000000000000000","0x0d8aab8f74ea862cdf766805009d3f3e42d8d00b":"5820000000000000000000","0x8908760cd39b9c1e8184e6a752ee888e3f0b7045":"6000000000000000000000","0x8156360bbd370961ceca6b6691d75006ad204cf2":"40000000000000000000000","0xa304588f0d850cd8d38f76e9e83c1bf63e333ede":"39800000000000000000","0x14c63ba2dcb1dd4df33ddab11c4f0007fa96a62d":"15500000000000000000000","0xa009bf076f1ba3fa57d2a7217218bed5565a7a7a":"1000000000000000000000","0x1c89060f987c518fa079ec2c0a5ebfa30f5d20f7":"38000000000000000000000","0x8895eb726226edc3f78cc6a515077b3296fdb95e":"3940000000000000000000","0x7919e7627f9b7d54ea3b14bb4dd4649f4f39dee0":"1670000000000000000000","0xb3c65b845aba6cd816fbaae983e0e46c82aa8622":"1000000000000000000000","0xeff51d72adfae143edf3a42b1aec55a2ccdd0b90":"300000000000000000000","0x05bb64a916be66f460f5e3b64332110d209e19ae":"4200000000000000000000","0xd5b117ec116eb846418961eb7edb629cd0dd697f":"3000000000000000000000","0x05e97b09492cd68f63b12b892ed1d11d152c0eca":"1015200000000000000000","0x84cc7878da605fdb019fab9b4ccfc157709cdda5":"1336922000000000000000","0x79cac6494f11ef2798748cb53285bd8e22f97cda":"2000000000000000000000","0xbd5a8c94bd8be6470644f70c8f8a33a8a55c6341":"200000000000000000000","0xb119e79aa9b916526581cbf521ef474ae84dcff4":"1470700000000000000000","0xaff1045adf27a1aa329461b24de1bae9948a698b":"33400000000000000000","0x4398628ea6632d393e929cbd928464c568aa4a0c":"1400000000000000000000","0x99997668f7c1a4ff9e31f9977ae3224bcb887a85":"291200000000000000000","0xbc0e8745c3a549445c2be900f52300804ab56289":"33104697000000000000000","0xe5bab4f0afd8a9d1a381b45761aa18f3d3cce105":"1508010000000000000000","0xbe60037e90714a4b917e61f193d834906703b13a":"1700000000000000000000","0x8ed4284c0f47449c15b8d9b3245de8beb6ce80bf":"800000000000000000000","0x333ad1596401e05aea2d36ca47318ef4cd2cb3df":"2910000000000000000000","0x22db559f2c3c1475a2e6ffe83a5979599196a7fa":"1000000000000000000000","0xfdf449f108c6fb4f5a2b081eed7e45e6919e4d25":"2000000000000000000000","0x0be1bcb90343fae5303173f461bd914a4839056c":"6000000000000000000000","0xb981ad5e6b7793a23fc6c1e8692eb2965d18d0da":"9999924000000000000000","0xc75d2259306aec7df022768c69899a652185dbc4":"4000000000000000000000","0x6c2e9be6d4ab450fd12531f33f028c614674f197":"3580000000000000000000","0x6dcc7e64fcafcbc2dc6c0e5e662cb347bffcd702":"20000000000000000000000","0xaabdb35c1514984a039213793f3345a168e81ff1":"309760000000000000000","0xd315deea1d8c1271f9d1311263ab47c007afb6f5":"69760000000000000000","0x4faf90b76ecfb9631bf9022176032d8b2c207009":"1000032000000000000000","0x3e7a966b5dc357ffb07e9fe067c45791fd8e3049":"59100000000000000000","0x2e64a8d71111a22f4c5de1e039b336f68d398a7c":"2000000000000000000000","0x181fbba852a7f50178b1c7f03ed9e58d54162929":"666000000000000000000","0x4f7330096f79ed264ee0127f5d30d2f73c52b3d8":"499970000000000000000","0xa8a8dbdd1a85d1beee2569e91ccc4d09ae7f6ea1":"5800000000000000000000","0x1f9c3268458da301a2be5ab08257f77bb5a98aa4":"200000000000000000000","0xfc372ff6927cb396d9cf29803500110da632bc52":"2000000000000000000000","0x4fa554ab955c249217386a4d3263bbf72895434e":"19982000000000000000","0x2a59e47ea5d8f0e7c028a3e8e093a49c1b50b9a3":"2000000000000000000000","0x5e32c72191b8392c55f510d8e3326e3a60501d62":"44000000000000000000000","0x1dfaee077212f1beaf0e6f2f1840537ae154ad86":"1000000000000000000000","0x7eaba035e2af3793fd74674b102540cf190addb9":"1273000000000000000000","0xd62edb96fce2969aaf6c545e967cf1c0bc805205":"85705000000000000000","0x220dc68df019b6b0ccbffb784b5a5ab4b15d4060":"3940000000000000000000","0x45bb829652d8bfb58b8527f0ecb621c29e212ec3":"2000000000000000000000","0x79b120eb8806732321288f675a27a9225f1cd2eb":"2465000000000000000000","0x740af1eefd3365d78ba7b12cb1a673e06a077246":"19700000000000000000000","0x0f042c9c2fb18766f836bb59f735f27dc329fe3c":"10000000000000000000000","0x6dda5f788a6c688ddf921fa3852eb6d6c6c62966":"40000000000000000000","0x96ad579bbfa8db8ebec9d286a72e4661eed8e356":"1070750000000000000000","0x0c2073ba44d3ddbdb639c04e191039a71716237f":"1430000000000000000000","0x1a3520453582c718a21c42375bc50773255253e1":"790000000000000000000","0xefcaae9ff64d2cd95b5249dcffe7faa0a0c0e44d":"401100000000000000000","0x0a3de155d5ecd8e81c1ff9bbf0378301f8d4c623":"4000000000000000000000","0x80f07ac09e7b2c3c0a3d1e9413a544c73a41becb":"20000000000000000000","0xc3631c7698b6c5111989bf452727b3f9395a6dea":"10683500000000000000000","0x4cc22c9bc9ad05d875a397dbe847ed221c920c67":"2000000000000000000000","0x1a987e3f83de75a42f1bde7c997c19217b4a5f24":"2000000000000000000000","0x5b2b64e9c058e382a8b299224eecaa16e09c8d92":"161000000000000000000","0x86caafacf32aa0317c032ac36babed974791dc03":"40000000000000000000000","0x1cd1f0a314cbb200de0a0cb1ef97e920709d97c2":"2000000000000000000000","0x7d980f4b566bb045517e4c14c87750de9346744b":"1337000000000000000000","0x8b5f29cc2faa262cdef30ef554f50eb488146eac":"5818250000000000000000","0x5153a0c3c8912881bf1c3501bf64b45649e48222":"4000000000000000000000","0xd21a7341eb84fd151054e5e387bb25d36e499c09":"14000000000000000000000","0x9560e8ac6718a6a1cdcff189d603c9063e413da6":"4000000000000000000000","0xe49ba0cd96816c4607773cf8a5970bb5bc16a1e6":"1670000000000000000000","0xb8ac117d9f0dba80901445823c4c9d4fa3fedc6e":"15759015000000000000000","0xaf67fd3e127fd9dc36eb3fcd6a80c7be4f7532b2":"1670000000000000000000","0xb43c27f7a0a122084b98f483922541c8836cee2c":"715000000000000000000","0x4d9279962029a8bd45639737e98b511eff074c21":"1337000000000000000000","0xc667441e7f29799aba616451d53b3f489f9e0f48":"13920000000000000000000","0x275875ff4fbb0cf3a430213127487f7608d04cba":"500080000000000000000","0x9a953b5bcc709379fcb559d7b916afdaa50cadcc":"100000000000000000000","0x7ea791ebab0445a00efdfc4e4a8e9a7e7565136d":"18200000000000000000","0x6ffe5cf82cc9ea5e36cad7c2974ce7249f3749e6":"1940000000000000000000","0xf1b4ecc63525f7432c3d834ffe2b970fbeb87212":"3000064000000000000000","0x6b72a8f061cfe6996ad447d3c72c28c0c08ab3a7":"4271316000000000000000","0xbba3c68004248e489573abb2743677066b24c8a7":"2000000000000000000000","0xb7c0d0cc0b4d342d4062bac624ccc3c70cc6da3f":"4000000000000000000000","0xfe98c664c3e447a95e69bd582171b7176ea2a685":"4000000000000000000000","0xce71086d4c602554b82dcbfce88d20634d53cc4d":"43250000000000000000000","0x1c601993789207f965bb865cbb4cd657cce76fc0":"98294000000000000000","0x476b5599089a3fb6f29c6c72e49b2e4740ea808d":"2800000000000000000000","0x3439998b247cb4bf8bc80a6d2b3527f1dfe9a6d2":"140000000000000000000","0xc4f7d2e2e22084c44f70feaab6c32105f3da376f":"1970000000000000000000","0xc1eba5684aa1b24cba63150263b7a9131aeec28d":"20000000000000000000","0x94ad4bad824bd0eb9ea49c58cebcc0ff5e08346b":"1940000000000000000000","0xded877378407b94e781c4ef4af7cfc5bc220b516":"372500000000000000000","0x699c9ee47195511f35f862ca4c22fd35ae8ffbf4":"80000000000000000000","0xe3a89a1927cc4e2d43fbcda1e414d324a7d9e057":"205500000000000000000","0x4d93696fa24859f5d2939aebfa54b4b51ae1dccc":"19100000000000000000","0x0af65f14784e55a6f95667fd73252a1c94072d2a":"192987000000000000000","0x5b70c49cc98b3df3fbe2b1597f5c1b6347a388b7":"970000000000000000000","0x426f78f70db259ac8534145b2934f4ef1098b5d8":"360000000000000000000","0x58b8ae8f63ef35ed0762f0b6233d4ac14e64b64d":"2000000000000000000000","0x8eae29435598ba8f1c93428cdb3e2b4d31078e00":"2000000000000000000000","0x17fd9b551a98cb61c2e07fbf41d3e8c9a530cba5":"26989000000000000000","0xab3e78294ba886a0cfd5d3487fb3a3078d338d6e":"1970000000000000000000","0xbdf6e68c0cd7584080e847d72cbb23aad46aeb1d":"1970000000000000000000","0xf989346772995ec1906faffeba2a7fe7de9c6bab":"6685000000000000000000","0xdc5f5ad663a6f263327d64cac9cb133d2c960597":"2000000000000000000000","0x68fe1357218d095849cd579842c4aa02ff888d93":"2000000000000000000000","0xe09c68e61998d9c81b14e4ee802ba7adf6d74cdb":"4000000000000000000000","0x890fe11f3c24db8732d6c2e772e2297c7e65f139":"62980000000000000000000","0xa76929890a7b47fb859196016c6fdd8289ceb755":"5000000000000000000000","0x2dc79d6e7f55bce2e2d0c02ad07ceca8bb529354":"1580000000000000000000","0x19687daa39c368139b6e7be60dc1753a9f0cbea3":"8000000000000000000000","0xc69be440134d6280980144a9f64d84748a37f349":"715000000000000000000","0x3d8d0723721e73a6c0d860aa0557abd14c1ee362":"5000000000000000000000","0x2b241f037337eb4acc61849bd272ac133f7cdf4b":"378000000000000000000000","0x24b95ebef79500baa0eda72e77f877415df75c33":"910000000000000000000","0x106ed5c719b5261477890425ae7551dc59bd255c":"11979600000000000000000","0x5b2e2f1618552eab0db98add55637c2951f1fb19":"12000000000000000000000","0x403145cb4ae7489fcc90cd985c6dc782b3cc4e44":"5999800000000000000000","0xe8be24f289443ee473bc76822f55098d89b91cc5":"2000000000000000000000","0xf6bc37b1d2a3788d589b6de212dc1713b2f6e78e":"5000000000000000000000","0x67fc527dce1785f0fb8bc7e518b1c669f7ecdfb5":"240000000000000000000","0x6580b1bc94390f04b397bd73e95d96ef11eaf3a8":"20000000000000000000","0x98bf4af3810b842387db70c14d46099626003d10":"4000000000000000000000","0x17993d312aa1106957868f6a55a5e8f12f77c843":"450065000000000000000","0x0729b4b47c09eb16158464c8aa7fd9690b438839":"1999800000000000000000","0xae70e69d2c4a0af818807b1a2705f79fd0b5dbc4":"985000000000000000000","0x38b50146e71916a5448de12a4d742135dcf39833":"32200000000000000000000","0x38439aaa24e3636f3a18e020ea1da7e145160d86":"2600000000000000000000","0x54b4429b182f0377be7e626939c5db6440f75d7a":"1970000000000000000000","0x7179726f5c71ae1b6d16a68428174e6b34b23646":"7353500000000000000000","0xc2ee91d3ef58c9d1a589844ea1ae3125d6c5ba69":"970000000000000000000","0x912304118b80473d9e9fe3ee458fbe610ffda2bb":"200000000000000000000","0x3308b03466c27a17dfe1aafceb81e16d2934566f":"17000000000000000000000","0x10346414bec6d3dcc44e50e54d54c2b8c3734e3e":"4000000000000000000000","0x4fee50c5f988206b09a573469fb1d0b42ebb6dce":"2009400000000000000000","0x9ece1400800936c7c6485fcdd3626017d09afbf6":"310000000000000000000","0xddf3ad76353810be6a89d731b787f6f17188612b":"20000000000000000000000","0x72402300e81d146c2e644e2bbda1da163ca3fb56":"7000000000000000000000","0xbb4b4a4b548070ff41432c9e08a0ca6fa7bc9f76":"850000000000000000000","0xc3dd58903886303b928625257ae1a013d71ae216":"2000000000000000000000","0xca6c818befd251361e02744068be99d8aa60b84a":"6000000000000000000000","0xb8d2ddc66f308c0158ae3ccb7b869f7d199d7b32":"844800000000000000000","0x8e486a0442d171c8605be348fee57eb5085eff0d":"4000000000000000000000","0xa807104f2703d679f8deafc442befe849e42950b":"2000000000000000000000","0xbb61a04bffd57c10470d45c39103f64650347616":"1000000000000000000000","0xd1c45954a62b911ad701ff2e90131e8ceb89c95c":"1394000000000000000000","0x5e65458be964ae449f71773704979766f8898761":"528600000000000000000","0xf9b37825f03073d31e249378c30c795c33f83af2":"200152000000000000000","0xe309974ce39d60aadf2e69673251bf0e04760a10":"254030000000000000000","0xd541ac187ad7e090522de6da3213e9a7f4439673":"2000000000000000000000","0xf33efc6397aa65fb53a8f07a0f893aae30e8bcee":"2304850000000000000000","0xd2f1998e1cb1580cec4f6c047dcd3dcec54cf73c":"200000000000000000000","0x0ed76c2c3b5d50ff8fb50b3eeacd681590be1c2d":"100000000000000000000","0x637d67d87f586f0a5a479e20ee13ea310a10b647":"48300000000000000000000","0x1a5ee533acbfb3a2d76d5b685277b796c56a052b":"2000000000000000000000","0x323fca5ed77f699f9d9930f5ceeff8e56f59f03c":"1337000000000000000000","0xa5fe2ce97f0e8c3856be0de5f4dcb2ce5d389a16":"22892000000000000000","0x93258255b37c7f58f4b10673a932dd3afd90f4f2":"1000000000000000000000","0x950fe9c6cad50c18f11a9ed9c45740a6180612d0":"8000000000000000000000","0xee31167f9cc93b3c6465609d79db0cde90e8484c":"2000000000000000000000","0x6ebb5e6957aa821ef659b6018a393a504cae4450":"2000000000000000000000","0xbe305a796e33bbf7f9aeae6512959066efda1010":"10880000000000000000000","0x537f9d4d31ef70839d84b0d9cdb72b9afedbdf35":"70000000000000000000000","0xfe9e1197d7974a7648dcc7a03112a88edbc9045d":"4925000000000000000000","0x99f77f998b20e0bcdcd9fc838641526cf25918ef":"1790000000000000000000","0x76ffc157ad6bf8d56d9a1a7fddbc0fea010aabf4":"1000000000000000000000","0xdefe9141f4704599159d7b223de42bffd80496b3":"100000000000000000000","0x7b1bf53a9cbe83a7dea434579fe72aac8d2a0cd0":"199800000000000000000","0x23ccc3c6acd85c2e460c4ffdd82bc75dc849ea14":"4000000000000000000000","0x9f86a066edb61fcb5856de93b75c8c791864b97b":"2000000000000000000000","0x871b8a8b51dea1989a5921f13ec1a955a515ad47":"8000000000000000000000","0x4efcd9c79fb4334ca6247b0a33bd9cc33208e272":"1337000000000000000000","0x35ac1d3ed7464fa3db14e7729213ceaa378c095e":"1520000000000000000000","0xc69d663c8d60908391c8d236191533fdf7775613":"485000000000000000000","0xc2ed5ffdd1add855a2692fe062b5d618742360d4":"1200000000000000000000","0x454f0141d721d33cbdc41018bd01119aa4784818":"6000000000000000000000","0x6c8687e3417710bb8a93559021a1469e6a86bc77":"11126675000000000000000","0xec5b198a00cfb55a97b5d53644cffa8a04d2ab45":"2000000000000000000000","0xcd59f3dde77e09940befb6ee58031965cae7a336":"10000000000000000000000","0x8eebec1a62c08b05a7d1d59180af9ff0d18e3f36":"500000000000000000000","0x92a971a739799f8cb48ea8475d72b2d2474172e6":"3940000000000000000000","0xbed4649df646e2819229032d8868556fe1e053d3":"18200000000000000000","0xc50fe415a641b0856c4e75bf960515441afa358d":"2000000000000000000000","0x91f516146cda20281719978060c6be4149067c88":"2000000000000000000000","0x54a1370116fe22099e015d07cd2669dd291cc9d1":"20000000000000000000","0x80c04efd310f440483c73f744b5b9e64599ce3ec":"1200000000000000000000","0xa8914c95b560ec13f140577338c32bcbb77d3a7a":"180000000000000000000","0xe3c812737ac606baf7522ad817428a36050e7a34":"1940000000000000000000","0x6d1456fff0104ee844a3314737843338d24cd66c":"141840000000000000000","0x0e6ece99111cad1961c748ed3df51edd69d2a3b1":"100000000000000000000000","0x019d709579ff4bc09fdcdde431dc1447d2c260bc":"20000000000000000000","0xebff84bbef423071e604c361bba677f5593def4e":"10000000000000000000000","0xe10c540088113fa6ec00b4b2c8824f8796e96ec4":"236400000000000000000000","0xe03220c697bcd28f26ef0b74404a8beb06b2ba7b":"8000000000000000000000","0xe69a6cdb3a8a7db8e1f30c8b84cd73bae02bc0f8":"16915503000000000000000","0xe5fb31a5caee6a96de393bdbf89fbe65fe125bb3":"1000000000000000000000","0x030fb3401f72bd3418b7d1da75bf8c519dd707dc":"3000000000000000000000","0x1c751e7f24df9d94a637a5dedeffc58277b5db19":"3220000000000000000000","0xbded7e07d0711e684de65ac8b2ab57c55c1a8645":"591000000000000000000","0xdd7ff441ba6ffe3671f3c0dabbff1823a5043370":"2000000000000000000000","0xb55474ba58f0f2f40e6cbabed4ea176e011fcad6":"1970000000000000000000","0xb92427ad7578b4bfe20a9f63a7c5506d5ca12dc8":"2000000000000000000000","0x91a8baaed012ea2e63803b593d0d0c2aab4c5b0a":"1500000000000000000000","0xa97e072144499fe5ebbd354acc7e7efb58985d08":"2674000000000000000000","0x75c2ffa1bef54919d2097f7a142d2e14f9b04a58":"2673866000000000000000","0x53faf165be031ec18330d9fce5bd1281a1af08db":"140000000000000000000","0x055ab658c6f0ed4f875ed6742e4bc7292d1abbf0":"83500000000000000000","0x6f18ec767e320508195f1374500e3f2e125689ff":"1000000000000000000000","0x90fc537b210658660a83baa9ac4a8402f65746a8":"1880000000000000000000","0x34664d220fa7f37958024a3332d684bcc6d4c8bd":"10000000000000000000000","0x15acb61568ec4af7ea2819386181b116a6c5ee70":"31000000000000000000000","0x69d98f38a3ba3dbc01fa5c2c1427d862832f2f70":"100000000000000000000000","0xece1152682b7598fe2d1e21ec15533885435ac85":"4000000000000000000000","0xf618d9b104411480a863e623fc55232d1a4f48aa":"265793000000000000000","0xf9debaecb5f339beea4894e5204bfa340d067f25":"1665000000000000000000","0x5e731b55ced452bb3f3fe871ddc3ed7ee6510a8f":"3000000000000000000000","0x67df242d240dd4b8071d72f8fcf35bb3809d71e8":"4000000000000000000000","0xc4cf930e5d116ab8d13b9f9a7ec4ab5003a6abde":"320000000000000000000","0x01a25a5f5af0169b30864c3be4d7563ccd44f09e":"1430000000000000000000","0x7f6efb6f4318876d2ee624e27595f44446f68e93":"1550000000000000000000","0x82249fe70f61c6b16f19a324840fdc020231bb02":"9504014000000000000000","0x205237c4be146fba99478f3a7dad17b09138da95":"2000000000000000000000","0xfd1fb5a89a89a721b8797068fbc47f3e9d52e149":"236400000000000000000","0xe47fbaed99fc209962604ebd20e240f74f4591f1":"2000000000000000000000","0xa24c3ab62181e9a15b78c4621e4c7c588127be26":"162410000000000000000","0xb6cd7432d5161be79768ad45de3e447a07982063":"4000000000000000000000","0x32a70691255c9fc9791a4f75c8b81f388e0a2503":"985000000000000000000","0x562f16d79abfcec3943e34b20f05f97bdfcda605":"4000000000000000000000","0xdbc66965e426ff1ac87ad6eb78c1d95271158f9f":"18200000000000000000","0x7e87863ec43a481df04d017762edcb5caa629b5a":"39400000000000000000","0x587d6849b168f6c3332b7abae7eb6c42c37f48bf":"880000000000000000000","0x721158be5762b119cc9b2035e88ee4ee78f29b82":"10000000000000000000000","0x84b91e2e2902d05e2b591b41083bd7beb2d52c74":"9848621000000000000000","0x632cecb10cfcf38ec986b43b8770adece9200221":"20000000000000000000","0xc34e3ba1322ed0571183a24f94204ee49c186641":"58200000000000000000","0xae78bb849139a6ba38ae92a09a69601cc4cb62d1":"500000000000000000000","0x5ce0b6862cce9162e87e0849e387cb5df4f9118c":"1670000000000000000000","0xf52c0a7877345fe0c233bb0f04fd6ab18b6f14ba":"400440000000000000000000","0xe016dc138e25815b90be3fe9eee8ffb2e105624f":"500000000000000000000","0x5789d01db12c816ac268e9af19dc0dd6d99f15df":"200000000000000000000","0xd8b77db9b81bbe90427b62f702b201ffc29ff618":"930200000000000000000","0x5dff811dad819ece3ba602c383fb5dc64c0a3a48":"186000000000000000000","0xaf3087e62e04bf900d5a54dc3e946274da92423b":"20000000000000000000","0x8c1023fde1574db8bb54f1739670157ca47da652":"6969382000000000000000","0xbb3b010b18e6e2be1135871026b7ba15ea0fde24":"10044000000000000000000","0xcabdaf354f4720a466a764a528d60e3a482a393c":"1000000000000000000000","0x94bbc67d13f89ebca594be94bc5170920c30d9f3":"80200000000000000000","0x3275496fd4dd8931fd69fb0a0b04c4d1ff879ef5":"446000000000000000000","0x281250a29121270a4ee5d78d24feafe82c70ba3a":"1000000000000000000000","0x590ccb5911cf78f6f622f535c474375f4a12cfcf":"20000000000000000000000","0x542e8096bafb88162606002e8c8a3ed19814aeac":"2000000000000000000000","0xa65426cff378ed23253513b19f496de45fa7e18f":"7200000000000000000000","0x4aa693b122f314482a47b11cc77c68a497876162":"1970000000000000000000","0xd9b783d31d32adc50fa3eacaa15d92b568eaeb47":"34010000000000000000000","0x068e655766b944fb263619658740b850c94afa31":"35200000000000000000","0x9e23c5e4b782b00a5fadf1aead87dacf5b0367a1":"20000000000000000000","0xbf17f397f8f46f1bae45d187148c06eeb959fa4d":"1001440000000000000000","0x8578e10212ca14ff0732a8241e37467db85632a9":"6000000000000000000000","0x2cb5495a505336c2465410d1cae095b8e1ba5cdd":"20000000000000000000000","0x695b0f5242753701b264a67071a2dc880836b8db":"16400000000000000000","0xf2edde37f9a8c39ddea24d79f4015757d06bf786":"100000000000000000000000","0x480f31b989311e4124c6a7465f5a44094d36f9d0":"1025000000000000000000","0xcf157612764e0fd696c8cb5fba85df4c0ddc3cb0":"30000000000000000000000","0x27521deb3b6ef1416ea4c781a2e5d7b36ee81c61":"2000000000000000000000","0x6efd90b535e00bbd889fda7e9c3184f879a151db":"10100000000000000000000","0xb635a4bc71fb28fdd5d2c322983a56c284426e69":"170000000000000000000","0xa17c9e4323069518189d5207a0728dcb92306a3f":"1000000000000000000000","0x6af940f63ec9b8d876272aca96fef65cdacecdea":"3000000000000000000000","0x469358709332c82b887e20bcddd0220f8edba7d0":"17300000000000000000000","0xa257ad594bd88328a7d90fc0a907df95eecae316":"520510000000000000000","0x6f051666cb4f7bd2b1907221b829b555d7a3db74":"1760000000000000000000","0x46bfc5b207eb2013e2e60f775fecd71810c5990c":"1550000000000000000000","0x62b9081e7710345e38e02e16449ace1b85bcfc4e":"910000000000000000000","0xbc73f7b1ca3b773b34249ada2e2c8a9274cc17c2":"2000000000000000000000","0x1adaf4abfa867db17f99af6abebf707a3cf55df6":"6000000000000000000000","0x8d629c20608135491b5013f1002586a0383130e5":"1370000000000000000000","0x38e46de4453c38e941e7930f43304f94bb7b2be8":"2005500000000000000000","0x3485f621256433b98a4200dad857efe55937ec98":"2000000000000000000000","0x775c10c93e0db7205b2643458233c64fc33fd75b":"2000000000000000000000","0x7c4401ae98f12ef6de39ae24cf9fc51f80eba16b":"200000000000000000000","0x17b807afa3ddd647e723542e7b52fee39527f306":"400010000000000000000","0x0ab366e6e7d5abbce6b44a438d69a1cabb90d133":"320000000000000000000","0x194ffe78bbf5d20dd18a1f01da552e00b7b11db1":"7000000000000000000000","0xc45d47ab0c9aa98a5bd62d16223ea2471b121ca4":"593640000000000000000","0x2487c3c4be86a2723d917c06b458550170c3edba":"1000000000000000000000","0xec4d08aa2e47496dca87225de33f2b40a8a5b36f":"158000000000000000000","0xaaa8defe11e3613f11067fb983625a08995a8dfc":"200000000000000000000","0x50bb67c8b8d8bd0f63c4760904f2d333f400aace":"2000000000000000000000","0x1227e10a4dbf9caca31b1780239f557615fc35c1":"200000000000000000000","0x44a8989e32308121f72466978db395d1f76c3a4b":"7236900000000000000000","0x59569a21d28fba4bda37753405a081f2063da150":"4000000000000000000000","0xc3756bcdcc7eec74ed896adfc335275930266e08":"6000000000000000000000","0xce3a61f0461b00935e85fa1ead82c45e5a64d488":"500000000000000000000","0x012f396a2b5eb83559bac515e5210df2c8c362ba":"200000000000000000000","0x93bc7d9a4abd44c8bbb8fe8ba804c61ad8d6576c":"3999922000000000000000","0xe20bb9f3966419e14bbbaaaa6789e92496cfa479":"3465116000000000000000","0x9eef442d291a447d74c5d253c49ef324eac1d8f0":"3420000000000000000000","0xdb6c2a73dac7424ab0d031b66761122566c01043":"3000000000000000000000","0x704d243c2978e46c2c86adbecd246e3b295ff633":"2012000000000000000000","0xd2ff672016f63b2f85398f4a6fedbb60a50d3cce":"342500000000000000000","0xd2051cb3cb6704f0548cc890ab0a19db3415b42a":"334000000000000000000","0x1111e5dbf45e6f906d62866f1708101788ddd571":"1300200000000000000000","0x6a686bf220b593deb9b7324615fb9144ded3f39d":"1460000000000000000000","0x911feea61fe0ed50c5b9e5a0d66071399d28bdc6":"60000000000000000000","0x3881defae1c07b3ce04c78abe26b0cdc8d73f010":"200000000000000000000","0xea94f32808a2ef8a9bf0861d1d2404f7b7be258a":"20000000000000000000","0x2eef6b1417d7b10ecfc19b123a8a89e73e526c58":"600000000000000000000","0xdd8af9e7765223f4446f44d3d509819a3d3db411":"10000000000000000000000","0x2efc4c647dac6acac35577ad221758fef6616faa":"8000000000000000000000","0x1547b9bf7ad66274f3413827231ba405ee8c88c1":"17300000000000000000000","0x250a40cef3202397f240469548beb5626af4f23c":"92500000000000000000","0xc175be3194e669422d15fee81eb9f2c56c67d9c9":"200000000000000000000","0xc9e02608066828848aeb28c73672a12925181f4d":"500038000000000000000","0x8229ceb9f0d70839498d44e6abed93c5ca059f5d":"123300000000000000000000","0x39f198331e4b21c1b760a3155f4ab2fe00a74619":"2000000000000000000000","0x3ffcb870d4023d255d5167d8a507cefc366b68ba":"649400000000000000000","0x00dae27b350bae20c5652124af5d8b5cba001ec1":"40000000000000000000","0xfc5500825105cf712a318a5e9c3bfc69c89d0c12":"4000000000000000000000","0x1ed8bb3f06778b039e9961d81cb71a73e6787c8e":"2000000000000000000000","0x530ffac3bc3412e2ec0ea47b7981c770f5bb2f35":"133700000000000000000","0x5f344b01c7191a32d0762ac188f0ec2dd460911d":"1000000000000000000000","0x5cfa9877f719c79d9e494a08d1e41cf103fc87c9":"200000000000000000000","0xf6eaac7032d492ef17fd6095afc11d634f56b382":"500038000000000000000","0x962c0dec8a3d464bf39b1215eafd26480ae490cd":"2001680000000000000000","0x262a8bfd7d9dc5dd3ad78161b6bb560824373655":"1169820000000000000000","0x9b4824ff9fb2abda554dee4fb8cf549165570631":"20000000000000000000","0xbb3b9005f46fd2ca3b30162599928c77d9f6b601":"8000014000000000000000","0xf7dc251196fbcbb77c947d7c1946b0ff65021cea":"1000000000000000000000","0xaf1148ef6c8e103d7530efc91679c9ac27000993":"200000000000000000000","0x0bb2650ea01aca755bc0c017b64b1ab5a66d82e3":"1337000000000000000000","0x0cda12bf72d461bbc479eb92e6491d057e6b5ad1":"10000000000000000000000","0x4e5b77f9066159e615933f2dda7477fa4e47d648":"200000000000000000000","0x391161b0e43c302066e8a68d2ce7e199ecdb1d57":"4000000000000000000000","0xc7e330cd0c890ac99fe771fcc7e7b009b7413d8a":"4000000000000000000000","0xd4b38a5fdb63e01714e9801db47bc990bd509183":"5999000000000000000000","0xbc0f98598f88056a26339620923b8f1eb074a9fd":"200000000000000000000","0xdbc59ed88973dead310884223af49763c05030f1":"20000000000000000000","0x0f85e42b1df321a4b3e835b50c00b06173968436":"985000000000000000000","0xd7788ef28658aa06cc53e1f3f0de58e5c371be78":"6685000000000000000000","0xecd276af64c79d1bd9a92b86b5e88d9a95eb88f8":"20000000000000000000","0x81c9e1aee2d3365d53bcfdcd96c7c538b0fd7eec":"1820000000000000000000","0x5d39ef9ea6bdfff15d11fe91f561a6f9e31f5da5":"2000000000000000000000","0x99878f9d6e0a7ed9aec78297b73879a80195afe0":"3980000000000000000000","0x7294c918b1aefb4d25927ef9d799e71f93a28e85":"197000000000000000000","0xa33f70da7275ef057104dfa7db64f472e9f5d553":"80220000000000000000","0x255bdd6474cc8262f26a22c38f45940e1ceea69b":"4000000000000000000000","0x52f8b509fee1a874ab6f9d87367fbeaf15ac137f":"1000000000000000000000","0xe2728a3e8c2aaac983d05dc6877374a8f446eee9":"197600000000000000000","0xed0206cb23315128f8caff26f6a30b985467d022":"40000000000000000000000","0x87cf36ad03c9eae9053abb5242de9117bb0f2a0b":"500000000000000000000","0xa929c8bd71db0c308dac06080a1747f21b1465aa":"500000000000000000000","0x9da6e075989c7419094cc9f6d2e49393bb199688":"11100000000000000000000","0x763eece0b08ac89e32bfa4bece769514d8cb5b85":"4000000000000000000000","0x5df3277ca85936c7a0d2c0795605ad25095e7159":"2000000000000000000000","0x7163758cbb6c4c525e0414a40a049dcccce919bb":"200000000000000000000","0x14cdddbc8b09e6675a9e9e05091cb92238c39e1e":"5100000000000000000000","0xb3b7f493b44a2c8d80ec78b1cdc75a652b73b06c":"2000000000000000000000","0xc69b855539ce1b04714728eec25a37f367951de7":"2000000000000000000000","0x052eab1f61b6d45517283f41d1441824878749d0":"4000000000000000000000","0x515651d6db4faf9ecd103a921bbbbe6ae970fdd4":"20000000000000000000000","0xc7aff91929797489555a2ff1d14d5c695a108355":"1000000000000000000000","0xd7ca7fdcfebe4588eff5421d1522b61328df7bf3":"4001070000000000000000","0xeefba12dfc996742db790464ca7d273be6e81b3e":"1000000000000000000000","0xebaa216de9cc5a43031707d36fe6d5bedc05bdf0":"1969606000000000000000","0x559194304f14b1b93afe444f0624e053c23a0009":"400000000000000000000","0x4ecc19948dd9cd87b4c7201ab48e758f28e7cc76":"500200000000000000000","0xf224eb900b37b4490eee6a0b6420d85c947d8733":"970000000000000000000","0x97810bafc37e84306332aacb35e92ad911d23d24":"1000000000000000000000","0xbd67d2e2f82da8861341bc96a2c0791fddf39e40":"200014000000000000000","0x1b6495891240e64e594493c2662171db5e30ce13":"172400000000000000000","0x00bdd4013aa31c04616c2bc9785f2788f915679b":"13400000000000000000","0xc6ae287ddbe1149ba16ddcca4fe06aa2eaa988a9":"400000000000000000000","0xb7c9f12b038e73436d17e1c12ffe1aeccdb3f58c":"540000000000000000000","0xc1b500011cfba95d7cd636e95e6cbf6167464b25":"200000000000000000000","0x39e0db4d60568c800b8c5500026c2594f5768960":"1000000000000000000000","0x40e3c283f7e24de0410c121bee60a5607f3e29a6":"1000000000000000000000","0x2f7d3290851be5c6b4b43f7d4574329f61a792c3":"100000000000000000000","0xc33ece935a8f4ef938ea7e1bac87cb925d8490ca":"33122000000000000000000","0x57bddf078834009c89d88e6282759dc45335b470":"2148000000000000000000","0x50ad187ab21167c2b6e78be0153f44504a07945e":"100076000000000000000","0x5bd24aac3612b20c609eb46779bf95698407c57c":"1970000000000000000000","0x16526c9edf943efa4f6d0f0bae81e18b31c54079":"985000000000000000000","0x4c6a9dc2cab10abb2e7c137006f08fecb5b779e1":"499000000000000000000","0x02c9f7940a7b8b7a410bf83dc9c22333d4275dd3":"5000000000000000000000","0xb9fd3833e88e7cf1fa9879bdf55af4b99cd5ce3f":"1000000000000000000000","0x7e268f131ddf687cc325c412f78ba961205e9112":"16000600000000000000000","0x180478a655d78d0f3b0c4f202b61485bc4002fd5":"2000000000000000000000","0xed4014538cee664a2fbcb6dc669f7ab16d0ba57c":"200000000000000000000","0xf63a579bc3eac2a9490410128dbcebe6d9de8243":"1490000000000000000000","0x5d822d9b3ef4b502627407da272f67814a6becd4":"20000000000000000000","0xeb52ab10553492329c1c54833ae610f398a65b9d":"152000000000000000000","0x63340a57716bfa63eb6cd133721202575bf796f0":"209967000000000000000","0x933bf33f8299702b3a902642c33e0bfaea5c1ca3":"15200000000000000000","0x25bc49ef288cd165e525c661a812cf84fbec8f33":"338464000000000000000","0xc8231ba5a411a13e222b29bfc1083f763158f226":"1000090000000000000000","0x6c15ec3520bf8ebbc820bd0ff19778375494cf9d":"2005500000000000000000","0xaaced8a9563b1bc311dbdffc1ae7f57519c4440c":"2000000000000000000000","0xd90f3009db437e4e11c780bec8896f738d65ef0d":"4000000000000000000000","0x5603241eb8f08f721e348c9d9ad92f48e390aa24":"200000000000000000000","0x53cec6c88092f756efe56f7db11228a2db45b122":"4000000000000000000000","0x194cebb4929882bf3b4bf9864c2b1b0f62c283f9":"571300000000000000000","0x4be8628a8154874e048d80c142181022b180bcc1":"60000000000000000000","0x5fd973af366aa5157c54659bcfb27cbfa5ac15d6":"4000000000000000000000","0x303139bc596403d5d3931f774c66c4ba467454db":"1699830000000000000000","0x87584a3f613bd4fac74c1e780b86d6caeb890cb2":"1700000000000000000000","0x77f4e3bdf056883cc87280dbe640a18a0d02a207":"193806000000000000000","0x4de3fe34a6fbf634c051997f47cc7f48791f5824":"1999000000000000000000","0xc45a1ca1036b95004187cdac44a36e33a94ab5c3":"254800000000000000000","0x65d33eb39cda6453b19e61c1fe4db93170ef9d34":"13370000000000000000","0xf65616be9c8b797e7415227c9138faa0891742d7":"790000000000000000000","0xe17812f66c5e65941e186c46922b6e7b2f0eeb46":"1820000000000000000000","0xd47f50df89a1cff96513bef1b2ae3a2971accf2c":"840000000000000000000","0x8ed1528b447ed4297902f639c514d0944a88f8c8":"198800000000000000000","0xa4fb14409a67b45688a8593e5cc2cf596ced6f11":"1790000000000000000000","0x855d9aef2c39c6230d09c99ef6494989abe68785":"161000000000000000000","0x778c43d11afe3b586ff374192d96a7f23d2b9b7f":"2577139000000000000000","0xe3ece1f632711d13bfffa1f8f6840871ee58fb27":"4000000000000000000000","0xbeb3358c50cf9f75ffc76d443c2c7f55075a0589":"2674000000000000000000","0xf156dc0b2a981e5b55d3f2f03b8134e331dbadb7":"100000000000000000000","0xeb9cc9fe0869d2dab52cc7aae8fd57adb35f9feb":"1966000000000000000000","0x2467c6a5c696ede9a1e542bf1ad06bcc4b06aca0":"18500000000000000000","0xec75b4a47513120ba5f86039814f1998e3817ac3":"178756000000000000000","0x9c3d0692ceeef80aa4965ceed262ffc7f069f2dc":"200000000000000000000","0xe05029aceb0778675bef1741ab2cd2931ef7c84b":"5000057000000000000000","0x41d3b731a326e76858baa5f4bd89b57b36932343":"394000000000000000000","0xc346cb1fbce2ab285d8e5401f42dd7234d37e86d":"83500000000000000000","0x45f4fc60f08eaca10598f0336329801e3c92cb46":"200000000000000000000","0xf04a6a379708b9428d722aa2b06b77e88935cf89":"300000000000000000000","0x232832cd5977e00a4c30d0163f2e24f088a6cb09":"3000000000000000000000","0xd2ac0d3a58605e1d0f0eb3de25b2cad129ed6058":"4000000000000000000000","0xa356551bb77d4f45a6d7e09f0a089e79cca249cb":"340000000000000000000","0xb50c9f5789ae44e2dce017c714caf00c830084c2":"394000000000000000000","0x21fd6c5d97f9c600b76821ddd4e776350fce2be0":"1999946000000000000000","0xf0d5c31ccb6cbe30c7c9ea19f268d159851f8c9c":"16700000000000000000000","0xab7091932e4bc39dbb552380ca934fd7166d1e6e":"3340000000000000000000","0xacd8dd91f714764c45677c63d852e56eb9eece2e":"2000000000000000000000","0x57d032a43d164e71aa2ef3ffd8491b0a4ef1ea5b":"2000000000000000000000","0x5af46a25ac09cb73616b53b14fb42ff0a51cddb2":"4000000000000000000000","0x1ea6bf2f15ae9c1dbc64daa7f8ea4d0d81aad3eb":"4200000000000000000000","0x03337012ae1d7ff3ee7f697c403e7780188bf0ef":"200000000000000000000","0x32eb64be1b5dede408c6bdefbe6e405c16b7ed02":"1970000000000000000000","0x22e2488e2da26a49ae84c01bd54b21f2947891c6":"1730000000000000000000","0xbe98a77fd41097b34f59d7589baad021659ff712":"900000000000000000000","0xdda4ed2a58a8dd20a73275347b580d71b95bf99a":"399000000000000000000","0x671110d96aaff11523cc546bf9940eedffb2faf7":"4000000000000000000000","0x5d71799c8df3bccb7ee446df50b8312bc4eb71c5":"200000000000000000000","0xae179a460db66326743d24e67523a57b246daf7f":"4722920000000000000000","0x198bfcf1b07ae308fa2c02069ac9dafe7135fb47":"20000000000000000000","0x4662a1765ee921842ddc88898d1dc8627597bd7e":"10000000000000000000000","0x783eec8aa5dac77b2e6623ed5198a431abbaee07":"440000000000000000000","0xed6643c0e8884b2d3211853785a08bf8f33ed29f":"1337000000000000000000","0x5cc7d3066d45d27621f78bb4b339473e442a860f":"9999908000000000000000","0x94ef8be45077c7d4c5652740de946a62624f713f":"100085000000000000000","0x2f853817afd3b8f3b86e9f60ee77b5d97773c0e3":"1451450000000000000000","0x3e0b8ed86ed669e12723af7572fbacfe829b1e16":"1499800000000000000000","0xfa68e0cb3edf51f0a6f211c9b2cb5e073c9bffe6":"291200000000000000000","0x2c234f505ca8dcc77d9b7e01d257c318cc19396d":"100000000000000000000","0xf3f24fc29e20403fc0e8f5ebbb553426f78270a2":"100000000000000000000","0x91546b79ecf69f936b5a561508b0d7e50cc5992f":"267400000000000000000","0x435443b81dfdb9bd8c6787bc2518e2d47e57c15f":"5968500000000000000000","0x3a06e3bb1edcfd0c44c3074de0bb606b049894a2":"10000000000000000000000","0x3a3108c1e680a33b336c21131334409d97e5adec":"20000000000000000000","0x2caf6bf4ec7d5a19c5e0897a5eeb011dcece4210":"139740000000000000000","0xf44f8551ace933720712c5c491cdb6f2f951736c":"4000000000000000000000","0x5bc1f95507b1018642e45cd9c0e22733b9b1a326":"100000000000000000000","0x94ca56de777fd453177f5e0694c478e66aff8a84":"500000000000000000000","0xafdd1b786162b8317e20f0e979f4b2ce486d765d":"20000000000000000000","0x3a805fa0f7387f73055b7858ca8519edd93d634f":"1850000000000000000000","0x8b36224c7356e751f0c066c35e3b44860364bfc2":"998987000000000000000","0xcfecbea07c27002f65fe534bb8842d0925c78402":"4000000000000000000000","0x482982ac1f1c6d1721feecd9b9c96cd949805055":"10000000000000000000000","0xaf880fc7567d5595cacce15c3fc14c8742c26c9e":"133700000000000000000","0xacc1c78786ab4d2b3b277135b5ba123e0400486b":"78800000000000000000","0x41f27e744bd29de2b0598f02a0bb9f98e681eaa4":"7760000000000000000000","0x09a025316f967fa8b9a1d60700063f5a68001caa":"38200000000000000000","0x391f20176d12360d724d51470a90703675594a4d":"1600000000000000000000","0xfe4d8403216fd571572bf1bdb01d00578978d688":"9850000000000000000000","0x900f0b8e35b668f81ef252b13855aa5007d012e7":"425000000000000000000","0xc35b95a2a3737cb8f0f596b34524872bd30da234":"7540000000000000000000","0x412a68f6c645559cc977fc4964047a201d1bb0e2":"50000000000000000000000","0xd3dad1b6d08d4581ccae65a8732db6ac69f0c69e":"6000000000000000000000","0x35855ec641ab9e081ed0c2a6dcd81354d0244a87":"1201897000000000000000","0x88015d7203c5e0224aeda286ed12f1a51b789333":"4999711000000000000000","0x251c12722c6879227992a304eb3576cd18434ea5":"2000000000000000000000","0x1f6f0030349752061c96072bc3d6eb3549208d6b":"23891000000000000000","0x86153063a1ae7f02f1a88136d4d69c7c5e3e4327":"1000000000000000000000","0x78355df0a230f83d032c703154414de3eedab557":"2000000000000000000000","0xc5b56cd234267c28e89c6f6b2266b086a12f970c":"4000000000000000000000","0x3e3cd3bec06591d6346f254b621eb41c89008d31":"993800000000000000000","0x378ea1dc8edc19bae82638029ea8752ce98bcfcd":"2000000000000000000000","0x67632046dcb25a54936928a96f423f3320cbed92":"2000000000000000000000","0xddbee6f094eae63420b003fb4757142aea6cd0fd":"2000000000000000000000","0xb555d00f9190cc3677aef314acd73fdc39399259":"2000000000000000000000","0xe230fe1bff03186d0219f15d4c481b7d59be286a":"36710000000000000000","0x3e4e9265223c9738324cf20bd06006d0073edb8c":"133700000000000000000","0x7450ff7f99eaa9116275deac68e428df5bbcd8b9":"2000000000000000000000","0x021f69043de88c4917ca10f1842897eec0589c7c":"1978760000000000000000","0x351787843505f8e4eff46566cce6a59f4d1c5fe7":"9250000000000000000000","0xebd37b256563e30c6f9289a8e2702f0852880833":"1999944000000000000000","0xed41e1a28f5caa843880ef4e8b08bd6c33141edf":"790174000000000000000","0x8d238e036596987643d73173c37b0ad06055b96c":"2089724000000000000000","0x478e524ef2a381d70c82588a93ca7a5fa9d51cbf":"254908000000000000000000","0x4419ac618d5dea7cdc6077206fb07dbdd71c1702":"4000000000000000000000","0xca25ff34934c1942e22a4e7bd56f14021a1af088":"197000000000000000000","0x5552f4b3ed3e1da79a2f78bb13e8ae5a68a9df3b":"1000000000000000000000","0x4354221e62dc09e6406436163a185ef06d114a81":"2000000000000000000000","0xca0432cb157b5179f02ebba5c9d1b54fec4d88ca":"1000000000000000000000","0x8a780ab87a9145fe10ed60fa476a740af4cab1d2":"334000000000000000000","0x4ff676e27f681a982d8fd9d20e648b3dce05e945":"2800000000000000000000","0x6c63fc85029a2654d79b2bea4de349e4524577c5":"660000000000000000000","0x1ac089c3bc4d82f06a20051a9d732dc0e734cb61":"700300000000000000000","0x4bf4479799ef82eea20943374f56a1bf54001e5e":"3940000000000000000000","0x08411652c871713609af0062a8a1281bf1bbcfd9":"1400000000000000000000","0xe1bfaa5a45c504428923c4a61192a55b1400b45d":"2674000000000000000000","0x5e1fbd4e58e2312b3c78d7aaaafa10bf9c3189e3":"40000000000000000000000","0xbb27c6a7f91075475ab229619040f804c8ec7a6a":"10000000000000000000000","0x5d8d31faa864e22159cd6f5175ccecc53fa54d72":"26980000000000000000000","0x2dd8eeef87194abc2ce7585da1e35b7cea780cb7":"999999000000000000000","0x0e1801e70b6262861b1134ccbc391f568afc92f7":"4000000000000000000000","0x61042b80fd6095d1b87be2f00f109fabafd157a6":"100000000000000000000","0xfb5518714cefc36d04865de5915ef0ff47dfe743":"2000000000000000000000","0xb5add1e7809f7d03069bfe883b0a932210be8712":"1000000000000000000000","0xc2e2d498f70dcd0859e50b023a710a6d4b2133bd":"1037130000000000000000","0x4ad047fae67ef162fe68fedbc27d3b65caf10c36":"1970000000000000000000","0x69cb3e2153998d86e5ee20c1fcd1a6baeeb2863f":"4000000000000000000000","0x683633010a88686bea5a98ea53e87997cbf73e69":"99960000000000000000","0x6cb11ecb32d3ce829601310636f5a10cf7cf9b5f":"20068370000000000000000","0xa613456996408af1c2e93e177788ab55895e2b32":"6366000000000000000000","0x8308ed0af7f8a3c1751fafc877b5a42af7d35882":"1000000000000000000000","0xe5edf8123f2403ce1a0299becf7aac744d075f23":"200200000000000000000","0x05665155cc49cbf6aabdd5ae92cbfaad82b8c0c1":"400000000000000000000","0x00b277b099a8e866ca0ec65bcb87284fd142a582":"1970000000000000000000","0x4b9e068fc4680976e61504912985fd5ce94bab0d":"668500000000000000000","0x12134e7f6b017bf48e855a399ca58e2e892fa5c8":"1000000000000000000000","0xdffcea5421ec15900c6ecfc777184e140e209e24":"19980000000000000000","0x2132c0516a2e17174ac547c43b7b0020d1eb4c59":"985000000000000000000","0xd39a5da460392b940b3c69bc03757bf3f2e82489":"7019250000000000000000","0x66c8331efe7198e98b2d32b938688e3241d0e24f":"9620000000000000000000","0xbdca2a0ff34588af625fa8e28fc3015ab5a3aa00":"2339800000000000000000","0x7dfc342dffcf45dfee74f84c0995397bd1a63172":"250000000000000000000","0xa202547242806f6e70e74058d6e5292defc8c8d4":"2002000000000000000000","0x3bbc13d04accc0707aebdcaef087d0b87e0b5ee3":"3520000000000000000000","0xbe5cba8d37427986e8ca2600e858bb03c359520f":"2955000000000000000000","0x4174fa1bc12a3b7183cbabb77a0b59557ba5f1db":"2000000000000000000000","0x9eb3a7cb5e6726427a3a361cfa8d6164dbd0ba16":"804000000000000000000","0x25e661c939863acc044e6f17b5698cce379ec3cc":"1370000000000000000000","0x24bd5904059091d2f9e12d6a26a010ca22ab14e8":"1880000000000000000000","0xc96626728aaa4c4fb3d31c26df3af310081710d1":"3340000000000000000000","0x0fb5d2c673bfb1ddca141b9894fd6d3f05da6720":"100000000000000000000","0x2de31afd189a13a76ff6fe73ead9f74bb5c4a629":"6000000000000000000000","0xbd09126c891c4a83068059fe0e15796c4661a9f4":"800000000000000000000","0x496f5843f6d24cd98d255e4c23d1e1f023227545":"1754143000000000000000","0x540cf23dd95c4d558a279d778d2b3735b3164191":"10000000000000000000000","0x9b5ec18e8313887df461d2902e81e67a8f113bb1":"100000000000000000000","0xb7a7f77c348f92a9f1100c6bd829a8ac6d7fcf91":"1820000000000000000000","0x2590126870e0bde8a663ab040a72a5573d8d41c2":"5000000000000000000000","0x090fa9367bda57d0d3253a0a8ff76ce0b8e19a73":"1000000000000000000000","0x2a5ba9e34cd58da54c9a2712663a3be274c8e47b":"197000000000000000000","0x3e8641d43c42003f0a33c929f711079deb2b9e46":"500000000000000000000","0xf4d97664cc4eec9edbe7fa09f4750a663b507d79":"4000000000000000000000","0xb1540e94cff3465cc3d187e7c8e3bdaf984659e2":"2989950000000000000000","0xf96883582459908c827627e86f28e646f9c7fc7a":"8350000000000000000000","0xd4feed99e8917c5c5458635f3603ecb7e817a7d0":"300031000000000000000","0x14b1603ec62b20022033eec4d6d6655ac24a015a":"50000000000000000000","0xaf8e1dcb314c950d3687434d309858e1a8739cd4":"267400000000000000000","0x4b9206ba6b549a1a7f969e1d5dba867539d1fa67":"7880000000000000000000","0x471010da492f4018833b088d9872901e06129174":"500000000000000000000","0xd243184c801e5d79d2063f3578dbae81e7b3a9cb":"1989700000000000000000","0x3eada8c92f56067e1bb73ce378da56dc2cdfd365":"2210000000000000000000","0x33ea6b7855e05b07ab80dab1e14de9b649e99b6c":"532000000000000000000","0x700711e311bb947355f755b579250ca7fd765a3e":"1790000000000000000000","0x87fb26c31e48644d693134205cae43b21f18614b":"1370000000000000000000","0x001d14804b399c6ef80e64576f657660804fec0b":"4200000000000000000000","0xf9642086b1fbae61a6804dbe5fb15ec2d2b537f4":"2000000000000000000000","0x6919dd5e5dfb1afa404703b9faea8cee35d00d70":"5910000000000000000000","0x9ac4da51d27822d1e208c96ea64a1e5b55299723":"100040000000000000000","0x1bd8ebaa7674bb18e19198db244f570313075f43":"150000000000000000000","0xe64ef012658d54f8e8609c4e9023c09fe865c83b":"28000000000000000000","0x43b079baf0727999e66bf743d5bcbf776c3b0922":"2000000000000000000000","0x06ac26ad92cb859bd5905ddce4266aa0ec50a9c5":"775000000000000000000","0x99c1d9f40c6ab7f8a92fce2fdce47a54a586c53f":"985000000000000000000","0x4ae93082e45187c26160e66792f57fad3551c73a":"21658000000000000000000","0x7da7613445a21299aa74f0ad71431ec43fbb1be9":"68000000000000000000","0x4a9a26fd0a8ba10f977da4f77c31908dab4a8016":"1790000000000000000000","0x972c2f96aa00cf8a2f205abcf8937c0c75f5d8d9":"200000000000000000000","0xb5046cb3dc1dedbd364514a2848e44c1de4ed147":"16445100000000000000000","0x48c2ee91a50756d8ce9abeeb7589d22c6fee5dfb":"3220000000000000000000","0x46c1aa2244b9c8a957ca8fac431b0595a3b86824":"4000000000000000000000","0x21fd0bade5f4ef7474d058b7f3d854cb1300524e":"20000000000000000000","0x1864a3c7b48155448c54c88c708f166709736d31":"133700000000000000000","0x5dd53ae897526b167d39f1744ef7c3da5b37a293":"8000000000000000000000","0xece111670b563ccdbebca52384290ecd68fe5c92":"20000000000000000000","0x74d671d99cbea1ab57906375b63ff42b50451d17":"1000000000000000000000","0x5717cc9301511d4a81b9f583148beed3d3cc8309":"2600000000000000000000","0x8f92844f282a92999ee5b4a8d773d06b694dbd9f":"1940000000000000000000","0xb5a606f4ddcbb9471ec67f658caf2b00ee73025e":"4325000000000000000000","0xbdb60b823a1173d45a0792245fb496f1fd3301cf":"2000000000000000000000","0x1d2615f8b6ca5012b663bdd094b0c5137c778ddf":"10000000000000000000000","0x82ff716fdf033ec7e942c909d9831867b8b6e2ef":"1790000000000000000000","0x44c14765127cde11fab46c5d2cf4d4b2890023fd":"2000000000000000000000","0xc72cb301258e91bc08998a805dd192f25c2f9a35":"591000000000000000000","0xad732c976593eec4783b4e2ecd793979780bfedb":"2000000000000000000000","0xd8f62036f03b7635b858f1103f8a1d9019a892b6":"50000000000000000000","0x0a06fad7dcd7a492cbc053eeabde6934b39d8637":"20000000000000000000","0x67f2bb78b8d3e11f7c458a10b5c8e0a1d374467d":"1790000000000000000000","0x4b5cdb1e428c91dd7cb54a6aed4571da054bfe52":"88000000000000000000","0xb3557d39b5411b84445f5f54f38f62d2714d0087":"600000000000000000000","0x0b0e055b28cbd03dc5ff44aa64f3dce04f5e63fb":"2000000000000000000000","0x9b2be7f56754f505e3441a10f7f0e20fd3ddf849":"340000000000000000000","0x0b93fca4a4f09cac20db60e065edcccc11e0a5b6":"200000000000000000000","0x3bc85d6c735b9cda4bba5f48b24b13e70630307b":"1970000000000000000000","0x52102354a6aca95d8a2e86d5debda6de69346076":"2000000000000000000000","0xcda4530f4b9bc50905b79d17c28fc46f95349bdf":"942000000000000000000","0xff545bbb66fbd00eb5e6373ff4e326f5feb5fe12":"20000000000000000000","0x4030a925706b2c101c8c5cb9bd05fbb4f6759b18":"4000000000000000000000","0xf11e01c7a9d12499005f4dae7716095a34176277":"400000000000000000000","0xa4826b6c3882fad0ed5c8fbb25cc40cc4f33759f":"2068000000000000000000","0x28510e6eff1fc829b6576f4328bc3938ec7a6580":"10000000000000000000000","0x9ce5363b13e8238aa4dd15acd0b2e8afe0873247":"200000000000000000000","0xd97bc84abd47c05bbf457b2ef659d61ca5e5e48f":"122000000000000000000","0x4a719061f5285495b37b9d7ef8a51b07d6e6acac":"199800000000000000000","0x8b714522fa2839620470edcf0c4401b713663df1":"200000000000000000000","0xb6decf82969819ba02de29b9b593f21b64eeda0f":"740000000000000000000","0xc87d3ae3d88704d9ab0009dcc1a0067131f8ba3c":"1969606000000000000000","0xdccb370ed68aa922283043ef7cad1b9d403fc34a":"4000000000000000000000","0x2d532df4c63911d1ce91f6d1fcbff7960f78a885":"1669833000000000000000","0x1fcfd1d57f872290560cb62d600e1defbefccc1c":"1490000000000000000000","0xd9e27eb07dfc71a706060c7f079238ca93e88539":"1000000000000000000000","0xda7732f02f2e272eaf28df972ecc0ddeed9cf498":"205274000000000000000","0xbf09d77048e270b662330e9486b38b43cd781495":"436000000000000000000000","0x619f171445d42b02e2e07004ad8afe694fa53d6a":"20000000000000000000","0x2bdd03bebbee273b6ca1059b34999a5bbd61bb79":"20000000000000000000","0x8da1d359ba6cb4bcc57d7a437720d55db2f01c72":"80000000000000000000","0xbe935793f45b70d8045d2654d8dd3ad24b5b6137":"880000000000000000000","0xee71793e3acf12a7274f563961f537529d89c7de":"2000000000000000000000","0x86f05d19063e9369c6004eb3f123943a7cff4eab":"1999944000000000000000","0x87b10f9c280098179a2b76e9ce90be61fc844d0d":"1337000000000000000000","0x243c84d12420570cc4ef3baba1c959c283249520":"2345000000000000000000","0x6bc85acd5928722ef5095331ee88f484b8cf8357":"180000000000000000000","0x2561a138dcf83bd813e0e7f108642be3de3d6f05":"999940000000000000000","0x7d0350e40b338dda736661872be33f1f9752d755":"49933000000000000000","0xe5dc9349cb52e161196122cf87a38936e2c57f34":"2000000000000000000000","0x543a8c0efb8bcd15c543e2a6a4f807597631adef":"5893800000000000000000","0x0413d0cf78c001898a378b918cd6e498ea773c4d":"280000000000000000000","0x3708e59de6b4055088782902e0579c7201a8bf50":"200000000000000000000000","0x699fc6d68a4775573c1dcdaec830fefd50397c4e":"60000000000000000000","0x379a7f755a81a17edb7daaa28afc665dfa6be63a":"25000000000000000000","0x260a230e4465077e0b14ee4442a482d5b0c914bf":"1677935000000000000000","0x3daa01ceb70eaf9591fa521ba4a27ea9fb8ede4a":"1667400000000000000000","0x7f3a1e45f67e92c880e573b43379d71ee089db54":"100000000000000000000000","0x38643babea6011316cc797d9b093c897a17bdae7":"334400000000000000000","0x84675e9177726d45eaa46b3992a340ba7f710c95":"1000000000000000000000","0x0f83461ba224bb1e8fdd9dae535172b735acb4e0":"200000000000000000000","0x31aa3b1ebe8c4dbcb6a708b1d74831e60e497660":"400000000000000000000","0xa32cf7dde20c3dd5679ff5e325845c70c5962662":"20000000000000000000","0xc007f0bdb6e7009202b7af3ea90902697c721413":"2999966000000000000000","0x05c64004a9a826e94e5e4ee267fa2a7632dd4e6f":"16191931000000000000000","0xf622e584a6623eaaf99f2be49e5380c5cbcf5cd8":"200000000000000000000","0x9dc10fa38f9fb06810e11f60173ec3d2fd6a751e":"1970000000000000000000","0x423c3107f4bace414e499c64390a51f74615ca5e":"2000000000000000000000","0x92438e5203b6346ff886d7c36288aacccc78ceca":"1000000000000000000000","0xbef07d97c3481f9d6aee1c98f9d91a180a32442b":"100000000000000000000000","0x55aa5d313ebb084da0e7801091e29e92c5dec3aa":"2000000000000000000000","0x89c433d601fad714da6369308fd26c1dc9942bbf":"2000000000000000000000","0x25106ab6755df86d6b63a187703b0cfea0e594a0":"27400000000000000000","0x494256e99b0f9cd6e5ebca3899863252900165c8":"14000000000000000000000","0x5f4ace4c1cc13391e01f00b198e1f20b5f91cbf5":"5000196000000000000000","0x135cecd955e5798370769230159303d9b1839f66":"5000000000000000000000","0xced81ec3533ff1bfebf3e3843ee740ad11758d3e":"1970000000000000000000","0x688eb3853bbcc50ecfee0fa87f0ab693cabdef02":"31600000000000000000000","0x2159240813a73095a7ebf7c3b3743e8028ae5f09":"2000000000000000000000","0x99d1579cd42682b7644e1d4f7128441eeffe339d":"20000000000000000000000","0x8a243a0a9fea49b839547745ff2d11af3f4b0522":"985000000000000000000","0xc1a41a5a27199226e4c7eb198b031b59196f9842":"191000000000000000000","0x7514adbdc63f483f304d8e94b67ff3309f180b82":"622911000000000000000","0x74aeec915de01cc69b2cb5a6356feea14658c6c5":"232500000000000000000","0x76f9ad3d9bbd04ae055c1477c0c35e7592cb2a20":"40200000000000000000000","0xa8a7b68adab4e3eadff19ffa58e34a3fcec0d96a":"6000000000000000000000","0x60de22a1507432a47b01cc68c52a0bf8a2e0d098":"19100000000000000000","0xceb33d78e7547a9da2e87d51aec5f3441c87923a":"20000000000000000000","0x432809a2390f07c665921ff37d547d12f1c9966a":"30000000000000000000000","0xd5e656a1b916f9bf45afb07dd8afaf73b4c56f41":"97000000000000000000","0xe3410bb7557cf91d79fa69d0dfea0aa075402651":"2000000000000000000000","0xdee942d5caf5fac11421d86b010b458e5c392990":"4000000000000000000000","0xa98f109835f5eacd0543647c34a6b269e3802fac":"400000000000000000000","0x932b9c04d40d2ac83083d94298169dae81ab2ed0":"2000000000000000000000","0xba10f2764290f875434372f79dbf713801caac01":"955000000000000000000","0xa2c7eaffdc2c9d937345206c909a52dfb14c478f":"143000000000000000000","0x6c67e0d7b62e2a08506945a5dfe38263339f1f22":"1970000000000000000000","0x60c3714fdddb634659e4a2b1ea42c4728cc7b8ba":"13370000000000000000","0x73b4d499de3f38bf35aaf769a6e318bc6d123692":"2000000000000000000000","0x3b22dea3c25f1b59c7bd27bb91d3a3eaecef3984":"100000000000000000000","0x1e3badb1b6e1380e27039c576ae6222e963a5b53":"20000000000000000000000","0xabd4d6c1666358c0406fdf3af248f78ece830104":"2112000000000000000000","0x0c925ad5eb352c8ef76d0c222d115b0791b962a1":"3180000000000000000000","0xbe9186c34a52514abb9107860f674f97b821bd5b":"509600000000000000000","0xb7f67314cb832e32e63b15a40ce0d7ffbdb26985":"1060866000000000000000","0x3f30d3bc9f602232bc724288ca46cd0b0788f715":"4000000000000000000000","0x970abd53a54fca4a6429207c182d4d57bb39d4a0":"2000000000000000000000","0x36d85dc3683156e63bf880a9fab7788cf8143a27":"20000000000000000000000","0x2836123046b284e5ef102bfd22b1765e508116ad":"411880000000000000000","0xde06d5ea777a4eb1475e605dbcbf43444e8037ea":"50000000000000000000000","0x9af11399511c213181bfda3a8b264c05fc81b3ce":"14000000000000000000000","0xe2191215983f33fd33e22cd4a2490054da53fddc":"15800000000000000000","0x2eebf59432b52892f9380bd140aa99dcf8ad0c0f":"152000000000000000000","0xdc087f9390fb9e976ac23ab689544a0942ec2021":"1820000000000000000000","0xfd4b989558ae11be0c3b36e2d6f2a54a9343ca2e":"2000000000000000000000","0x770c2fb2c4a81753ac0182ea460ec09c90a516f8":"20000000000000000000","0xb28dbfc6499894f73a71faa00abe0f4bc9d19f2a":"100000000000000000000","0xb0cef8e8fb8984a6019f01c679f272bbe68f5c77":"152000000000000000000","0xf400f93d5f5c7e3fc303129ac8fb0c2f786407fa":"2000000000000000000000","0xf2133431d1d9a37ba2f0762bc40c5acc8aa6978e":"2000000000000000000000","0x9003d270891ba2df643da8341583193545e3e000":"4000000000000000000000","0x8938d1b4daee55a54d738cf17e4477f6794e46f7":"18200000000000000000","0x98e6f547db88e75f1f9c8ac2c5cf1627ba580b3e":"1000000000000000000000","0x009fdbf44e1f4a6362b769c39a475f95a96c2bc7":"564000000000000000000","0xd0f9597811b0b992bb7d3757aa25b4c2561d32e2":"500000000000000000000","0xdcd10c55bb854f754434f1219c2c9a98ace79f03":"4000086000000000000000","0x67048f3a12a4dd1f626c64264cb1d7971de2ca38":"180000000000000000000","0xd33cf82bf14c592640a08608914c237079d5be34":"2000000000000000000000","0xf5b068989df29c253577d0405ade6e0e7528f89e":"1610000000000000000000","0xa9a8eca11a23d64689a2aa3e417dbb3d336bb59a":"262025000000000000000","0x99413704b1a32e70f3bc0d69dd881c38566b54cb":"27382708000000000000000","0x2a085e25b64862f5e68d768e2b0f7a8529858eee":"1983618000000000000000","0x833d3fae542ad5f8b50ce19bde2bec579180c88c":"346000000000000000000","0xc3483d6e88ac1f4ae73cc4408d6c03abe0e49dca":"17000000000000000000000","0xfde395bc0b6d5cbb4c1d8fea3e0b4bff635e9db7":"2000000000000000000000","0xeddacd94ec89a2ef968fcf977a08f1fae2757869":"8000000000000000000000","0xdc29119745d2337320da51e19100c948d980b915":"160000000000000000000","0x640bf87415e0cf407301e5599a68366da09bbac8":"493207000000000000000","0xafcc7dbb8356d842d43ae7e23c8422b022a30803":"30400000000000000000000","0x9120e71173e1ba19ba8f9f4fdbdcaa34e1d6bb78":"2000000000000000000000","0x9092918707c621fdbd1d90fb80eb787fd26f7350":"2460000000000000000000","0x263e57dacbe0149f82fe65a2664898866ff5b463":"38000000000000000000000","0x315db7439fa1d5b423afa7dd7198c1cf74c918bc":"600000000000000000000","0x09b4668696f86a080f8bebb91db8e6f87015915a":"656010000000000000000","0x5c31996dcac015f9be985b611f468730ef244d90":"200000000000000000000","0xb1179589e19db9d41557bbec1cb24ccc2dec1c7f":"100000000000000000000000","0x3b1937d5e793b89b63fb8eb5f1b1c9ca6ba0fa8e":"2000000000000000000000","0xc9127b7f6629ee13fc3f60bc2f4467a20745a762":"16465639000000000000000","0x7306de0e288b56cfdf987ef0d3cc29660793f6dd":"508060000000000000000","0x2aa192777ca5b978b6b2c2ff800ac1860f753f47":"335000000000000000000","0x55da9dcdca61cbfe1f133c7bcefc867b9c8122f9":"880000000000000000000","0xcdd9efac4d6d60bd71d95585dce5d59705c13564":"100000000000000000000","0xad8e48a377695de014363a523a28b1a40c78f208":"1000000000000000000000","0x252b6555afdc80f2d96d972d17db84ea5ad521ac":"7880000000000000000000","0x60ab71cd26ea6d6e59a7a0f627ee079c885ebbf6":"26740000000000000000","0xf40b134fea22c6b29c8457f49f000f9cda789adb":"600000000000000000000","0x85a2f6ea94d05e8c1d9ae2f4910338a358e98ded":"2000000000000000000000","0xae13a08511110f32e53be4127845c843a1a57c7b":"500000000000000000000","0x40db1ba585ce34531edec5494849391381e6ccd3":"1790000000000000000000","0x0c5589a7a89b9ad15b02751930415948a875fbef":"126000000000000000000","0x89054430dcdc28ac15fa635ef87c105e602bf70c":"108000000000000000000","0x6c882c27732cef5c7c13a686f0a2ea77555ac289":"100000000000000000000000","0xde374299c1d07d79537385190f442ef9ca24061f":"133700000000000000000","0xb146a0b925553cf06fcaf54a1b4dfea621290757":"2000200000000000000000","0x09ae49e37f121df5dc158cfde806f173a06b0c7f":"3988000000000000000000","0xb758896f1baa864f17ebed16d953886fee68aae6":"1000000000000000000000","0x30730466b8eb6dc90d5496aa76a3472d7dbe0bbe":"1999800000000000000000","0xfc02734033e57f70517e0afc7ee62461f06fad8e":"394000000000000000000","0xa9b2d2e0494eab18e07d37bbb856d80e80f84cd3":"10000000000000000000000","0x95278b08dee7c0f2c8c0f722f9fcbbb9a5241fda":"2408672000000000000000","0xdab6bcdb83cf24a0ae1cb21b3b5b83c2f3824927":"50000000000000000000000","0x94439ca9cc169a79d4a09cae5e67764a6f871a21":"240000000000000000000","0xe06c29a81517e0d487b67fb0b6aabc4f57368388":"401100000000000000000","0x458e3cc99e947844a18e6a42918fef7e7f5f5eb3":"36400000000000000000000","0x0a9804137803ba6868d93a55f9985fcd540451e4":"13370000000000000000","0x40630024bd2c58d248edd8465617b2bf1647da0e":"1000000000000000000000","0x15224ad1c0face46f9f556e4774a3025ad06bd52":"13370000000000000000","0x2e2810dee44ae4dff3d86342ab126657d653c336":"200000000000000000000","0x48a30de1c919d3fd3180e97d5f2b2a9dbd964d2d":"44000000000000000000","0x46a30b8a808931217445c3f5a93e882c0345b426":"250019000000000000000","0x455396a4bbd9bae8af9fb7c4d64d471db9c24505":"161000000000000000000","0xedfda2d5db98f9380714664d54b4ee971a1cae03":"40044000000000000000","0xf5eadcd2d1b8657a121f33c458a8b13e76b65526":"249828000000000000000","0x90e7070f4d033fe6910c9efe5a278e1fc6234def":"100392000000000000000","0xd55508adbbbe9be81b80f97a6ea89add68da674f":"2000000000000000000000","0x66925de3e43f4b41bf9dadde27d5488ef569ea0d":"39400000000000000000","0xb7c077946674ba9341fb4c747a5d50f5d2da6415":"1000000000000000000000","0xc52d1a0c73c2a1be84915185f8b34faa0adf1de3":"1400001000000000000000","0x79b8aad879dd30567e8778d2d231c8f37ab8734e":"2000000000000000000000","0x3aae4872fd9093cbcad1406f1e8078bab50359e2":"39400000000000000000","0xb2e9d76bf50fc36bf7d3944b63e9ca889b699968":"2660000000000000000000","0x405f596b94b947344c033ce2dcbff12e25b79784":"2000000000000000000000","0x232cb1cd49993c144a3f88b3611e233569a86bd6":"15576000000000000000000","0x9e232c08c14dc1a6ed0b8a3b2868977ba5c17d10":"20000000000000000000","0x095270cc42141dd998ad2862dbd1fe9b44e7e650":"1200000000000000000000","0x15d99468507aa0413fb60dca2adc7f569cb36b54":"2000000000000000000000","0x04852732b4c652f6c2e58eb36587e60a62da14db":"20000000000000000000000","0xecf24cdd7c22928c441e694de4aa31b0fab59778":"600000000000000000000","0x512b91bbfaa9e581ef683fc90d9db22a8f49f48b":"310000000000000000000000","0xa88577a073fbaf33c4cd202e00ea70ef711b4006":"2000000000000000000000","0x00acc6f082a442828764d11f58d6894ae408f073":"60000000000000000000000","0x0355bcacbd21441e95adeedc30c17218c8a408ce":"400000000000000000000","0x4e73cf2379f124860f73d6d91bf59acc5cfc845b":"40110000000000000000","0x2a742b8910941e0932830a1d9692cfd28494cf40":"499986000000000000000","0x41a8c2830081b102df6e0131657c07ab635b54ce":"1999944000000000000000","0xb63064bd3355e6e07e2d377024125a33776c4afa":"38800000000000000000000","0x1a25e1c5bc7e5f50ec16f8885f210ea1b938800e":"4000000000000000000000","0x09b59b8698a7fbd3d2f8c73a008988de3e406b2b":"40000000000000000000000","0xc555b93156f09101233c6f7cf6eb3c4f196d3346":"3000000000000000000000","0x12f32c0a1f2daab676fe69abd9e018352d4ccd45":"50000000000000000000","0x5956b28ec7890b76fc061a1feb52d82ae81fb635":"2000000000000000000000","0xc739259e7f85f2659bef5f609ed86b3d596c201e":"200000000000000000000","0xfae92c1370e9e1859a5df83b56d0f586aa3b404c":"106480000000000000000","0xd5a7bec332adde18b3104b5792546aa59b879b52":"2000000000000000000000","0x4f88dfd01091a45a9e2676021e64286cd36b8d34":"1000000000000000000000","0x102c477d69aadba9a0b0f62b7459e17fbb1c1561":"2000000000000000000000","0x34272d5e7574315dcae9abbd317bac90289d4765":"1820000000000000000000","0xfe615d975c0887e0c9113ec7298420a793af8b96":"8000000000000000000000","0x487adf7d70a6740f8d51cbdd68bb3f91c4a5ce68":"66850000000000000000","0x7e5d9993104e4cb545e179a2a3f971f744f98482":"2000000000000000000000","0x5529830a61c1f13c197e550beddfd6bd195c9d02":"10000000000000000000000","0x2f282abbb6d4a3c3cd3b5ca812f7643e80305f06":"1850000000000000000000","0x7352586d021ad0cf77e0e928404a59f374ff4582":"3400000000000000000000","0x03f7b92008813ae0a676eb212814afab35221069":"2000000000000000000000","0x056686078fb6bcf9ba0a8a8dc63a906f5feac0ea":"499800000000000000000","0x8063379a7bf2cb923a84c5093e68dac7f75481c5":"322102000000000000000","0x200264a09f8c68e3e6629795280f56254f8640d0":"20000000000000000000","0x5a891155f50e42074374c739baadf7df2651153a":"4775000000000000000000","0x80022a1207e910911fc92849b069ab0cdad043d3":"13370000000000000000","0xe781ec732d401202bb9bd13860910dd6c29ac0b6":"1240000000000000000000","0x4c2f1afef7c5868c44832fc77cb03b55f89e6d6e":"20000000000000000000000","0x34ff582952ff24458f7b13d51f0b4f987022c1fe":"2804400000000000000000","0x73914b22fc2f131584247d82be4fecbf978ad4ba":"2000000000000000000000","0x562be95aba17c5371fe2ba828799b1f55d2177d6":"38200000000000000000000","0x648f5bd2a2ae8902db37847d1cb0db9390b06248":"7769965000000000000000","0x6a9758743b603eea3aa0524b42889723c4153948":"10100000000000000000000","0x5985c59a449dfc5da787d8244e746c6d70caa55f":"100000000000000000000","0x56ee197f4bbf9f1b0662e41c2bbd9aa1f799e846":"1000000000000000000000","0xd47c242edffea091bc54d57df5d1fdb93101476c":"2914000000000000000000","0xd482e7f68e41f238fe517829de15477fe0f6dd1d":"500000000000000000000","0x05bf4fcfe772e45b826443852e6c351350ce72a2":"8000000000000000000000","0xf10462e58fcc07f39584a187639451167e859201":"169830000000000000000","0x1aa27699cada8dc3a76f7933aa66c71919040e88":"400000000000000000000","0x24046b91da9b61b629cb8b8ec0c351a07e0703e4":"2000000000000000000000","0x41033c1b6d05e1ca89b0948fc64453fbe87ab25e":"1337000000000000000000","0x369822f5578b40dd1f4471706b22cd971352da6b":"346000000000000000000","0x044e853144e3364495e7a69fa1d46abea3ac0964":"49225000000000000000","0xabf728cf9312f22128024e7046c251f5dc5901ed":"29550000000000000000000","0xd781f7fc09184611568570b4986e2c72872b7ed0":"20002000000000000000","0x6bb4a661a33a71d424d49bb5df28622ed4dffcf4":"630400000000000000000","0xfef3b3dead1a6926d49aa32b12c22af54d9ff985":"1000000000000000000000","0xfa410971ad229c3036f41acf852f2ac999281950":"3997400000000000000000","0xde176b5284bcee3a838ba24f67fc7cbf67d78ef6":"37600000000000000000","0x23120046f6832102a752a76656691c863e17e59c":"329800000000000000000","0xa2f472fe4f22b77db489219ea4023d11582a9329":"40000000000000000000000","0xf0d64cf9df09741133d170485fd24b005011d520":"498680000000000000000","0x8b505e2871f7deb7a63895208e8227dcaa1bff05":"61216600000000000000000","0x481e3a91bfdc2f1c8428a0119d03a41601417e1c":"1000000000000000000000","0xbc69a0d2a31c3dbf7a9122116901b2bdfe9802a0":"3000000000000000000000","0x20a81680e465f88790f0074f60b4f35f5d1e6aa5":"1279851000000000000000","0x194a6bb302b8aba7a5b579df93e0df1574967625":"500000000000000000000","0x264cc8086a8710f91b21720905912cd7964ae868":"26740000000000000000","0x24aca08d5be85ebb9f3132dfc1b620824edfedf9":"18200000000000000000","0x1851a063ccdb30549077f1d139e72de7971197d5":"2000000000000000000000","0xf64a4ac8d540a9289c68d960d5fb7cc45a77831c":"2000000000000000000000","0xc3db5657bb72f10d58f231fddf11980aff678693":"5910000000000000000000","0xb46ace865e2c50ea4698d216ab455dff5a11cd72":"1000000000000000000000","0x9faea13c733412dc4b490402bfef27a0397a9bc3":"310000000000000000000","0xb40594c4f3664ef849cca6227b8a25aa690925ee":"4000000000000000000000","0x672fa0a019088db3166f6119438d07a99f8ba224":"13370000000000000000000","0xc1ffad07db96138c4b2a530ec1c7de29b8a0592c":"17600000000000000000","0x87af25d3f6f8eea15313d5fe4557e810c524c083":"19700000000000000000000","0xd6a22e598dabd38ea6e958bd79d48ddd9604f4df":"1000000000000000000000","0xa2a435de44a01bd0ecb29e44e47644e46a0cdffb":"500171000000000000000","0x549b47649cfad993e4064d2636a4baa0623305cc":"601650000000000000000","0x1321b605026f4ffb296a3e0edcb390c9c85608b7":"2000000000000000000000","0xb4bf24cb83686bc469869fefb044b909716993e2":"2000000000000000000000","0x12d91a92d74fc861a729646db192a125b79f5374":"18200000000000000000","0x7f0662b410298c99f311d3a1454a1eedba2fea76":"200000000000000000000","0x83908aa7478a6d1c9b9b0281148f8f9f242b9fdc":"2000000000000000000000","0xc1438c99dd51ef1ca8386af0a317e9b041457888":"223500000000000000000","0x545bb070e781172eb1608af7fc2895d6cb87197e":"2244000000000000000000","0x161d26ef6759ba5b9f20fdcd66f16132c352415e":"2000000000000000000000","0xd7f370d4bed9d57c6f49c999de729ee569d3f4e4":"200000000000000000000","0x90e35aabb2deef408bb9b5acef714457dfde6272":"100076000000000000000","0x0fcfc4065008cfd323305f6286b57a4dd7eee23b":"20000000000000000000000","0xcd725d70be97e677e3c8e85c0b26ef31e9955045":"1337000000000000000000","0xdcf6b657266e91a4dae6033ddac15332dd8d2b34":"1760000000000000000000","0x31f006f3494ed6c16eb92aaf9044fa8abb5fd5a3":"500000000000000000000","0xcdea386f9d0fd804d02818f237b7d9fa7646d35e":"3012139000000000000000","0xd45b3341e8f15c80329320c3977e3b90e7826a7e":"500000000000000000000","0x0b649da3b96a102cdc6db652a0c07d65b1e443e6":"2000000000000000000000","0x0a58fddd71898de773a74fdae45e7bd84ef43646":"20000000000000000000","0x0256149f5b5063bea14e15661ffb58f9b459a957":"704000000000000000000","0x4438e880cb2766b0c1ceaec9d2418fceb952a044":"133712000000000000000","0x9ed80eda7f55054db9fb5282451688f26bb374c1":"300000000000000000000","0x8dab948ae81da301d972e3f617a912e5a753712e":"400000000000000000000","0x5b5d8c8eed6c85ac215661de026676823faa0a0c":"20000000000000000000000","0x46722a36a01e841d03f780935e917d85d5a67abd":"14900000000000000000","0xd4b8bdf3df9a51b0b91d16abbea05bb4783c8661":"1000000000000000000000","0x98f6b8e6213dbc9a5581f4cce6655f95252bdb07":"319968000000000000000","0x3599493ce65772cf93e98af1195ec0955dc98002":"1500048000000000000000","0xecab5aba5b828de1705381f38bc744b32ba1b437":"940000000000000000000","0x9a82826d3c29481dcc2bd2950047e8b60486c338":"20000000000000000000000","0x6c474bc66a54780066aa4f512eefa773abf919c7":"94000000000000000000","0xd5903e9978ee20a38c3f498d63d57f31a39f6a06":"10380000000000000000000","0x341480cc8cb476f8d01ff30812e7c70e05afaf5d":"2000000000000000000000","0xaf771039345a343001bc0f8a5923b126b60d509c":"985000000000000000000","0xb5a4679685fa14196c2e9230c8c4e33bffbc10e2":"1400000000000000000000","0x2a400dff8594de7228b4fd15c32322b75bb87da8":"95810000000000000000","0xa1336dfb96b6bcbe4b3edf3205be5723c90fad52":"5000000000000000000000","0xe9b1f1fca3fa47269f21b061c353b7f5e96d905a":"500000000000000000000","0x0ee414940487fd24e390378285c5d7b9334d8b65":"2680000000000000000000","0x6ab5b4c41cddb829690c2fda7f20c85e629dd5d5":"1860000000000000000000","0xdd63042f25ed32884ad26e3ad959eb94ea36bf67":"21340000000000000000000","0xc0b3f244bca7b7de5b48a53edb9cbeab0b6d88c0":"5820000000000000000000","0xed1a5c43c574d4e934299b24f1472cdc9fd6f010":"200000000000000000000","0xb2d9ab9664bcf6df203c346fc692fd9cbab9205e":"438000000000000000000","0xede8c2cb876fbe8a4cca8290361a7ea01a69fdf8":"7813091000000000000000","0x6a7c252042e7468a3ff773d6450bba85efa26391":"500000000000000000000","0xa106e6923edd53ca8ed650968a9108d6ccfd9670":"9499935000000000000000","0x031e25db516b0f099faebfd94f890cf96660836b":"2000000000000000000000","0x7fdbc3a844e40d96b2f3a635322e6065f4ca0e84":"2000000000000000000000","0xdf47a61b72535193c561cccc75c3f3ce0804a20e":"398000000000000000000","0xed31305c319f9273d3936d8f5b2f71e9b1b22963":"100000000000000000000","0xa6b2d573297360102c07a18fc21df2e7499ff4eb":"4011000000000000000000","0xf68464bf64f2411356e4d3250efefe5c50a5f65b":"20000000000000000000","0x927cc2bfda0e088d02eff70b38b08aa53cc30941":"1852700000000000000000","0x41cb9896445f70a10a14215296daf614e32cf4d5":"1910000000000000000000","0x3ad70243d88bf0400f57c8c1fd57811848af162a":"860000000000000000000","0x63b9754d75d12d384039ec69063c0be210d5e0e3":"2694055000000000000000","0xad1799aad7602b4540cd832f9db5f11150f1687a":"2000000000000000000000","0xa8b65ba3171a3f77a6350b9daf1f8d55b4d201eb":"745000000000000000000","0xad0a4ae478e9636e88c604f242cf5439c6d45639":"3520000000000000000000","0x4cd0b0a6436362595ceade052ebc9b929fb6c6c0":"2000000000000000000000","0xc1d4af38e9ba799040894849b8a8219375f1ac78":"20000000000000000000000","0x49ddee902e1d0c99d1b11af3cc8a96f78e4dcf1a":"199358000000000000000","0xae842210f44d14c4a4db91fc9d3b3b50014f7bf7":"4000000000000000000000","0x10a1c42dc1ba746986b985a522a73c93eae64c63":"1000000000000000000000","0x5103bc09933e9921fd53dc536f11f05d0d47107d":"4000000000000000000000","0xc88eec54d305c928cc2848c2fee23531acb96d49":"1999946000000000000000","0x9a2ce43b5d89d6936b8e8c354791b8afff962425":"2000000000000000000000","0x562020e3ed792d2f1835fe5f55417d5111460c6a":"20000000000000000000000","0xed16ce39feef3bd7f5d162045e0f67c0f00046bb":"20000000000000000000","0xab948a4ae3795cbca13126e19253bdc21d3a8514":"200000000000000000000","0xc12b7f40df9a2f7bf983661422ab84c9c1f50858":"8000000000000000000000","0x62e6b2f5eb94fa7a43831fc87e254a3fe3bf8f89":"250000000000000000000","0x423bca47abc00c7057e3ad34fca63e375fbd8b4a":"18000000000000000000000","0x5ff326cd60fd136b245e29e9087a6ad3a6527f0d":"1880000000000000000000","0x79ffb4ac13812a0b78c4a37b8275223e176bfda5":"17300000000000000000","0xf757fc8720d3c4fa5277075e60bd5c411aebd977":"2000000000000000000000","0x0bdbc54cc8bdbbb402a08911e2232a5460ce866b":"3000000000000000000000","0x9ee9760cc273d4706aa08375c3e46fa230aff3d5":"8950000000000000000000","0xd23a24d7f9468343c143a41d73b88f7cbe63be5e":"200000000000000000000","0x46d80631284203f6288ecd4e5758bb9d41d05dbe":"2000000000000000000000","0x3f4cd1399f8a34eddb9a17a471fc922b5870aafc":"200000000000000000000","0x44c54eaa8ac940f9e80f1e74e82fc14f1676856a":"7880000000000000000000","0xaec27ff5d7f9ddda91183f46f9d52543b6cd2b2f":"450000000000000000000","0x203c6283f20df7bc86542fdfb4e763ecdbbbeef5":"25000000000000000000000","0xbcaf347918efb2d63dde03e39275bbe97d26df50":"100000000000000000000","0x974d0541ab4a47ec7f75369c0069b64a1b817710":"400000000000000000000","0x5da54785c9bd30575c89deb59d2041d20a39e17b":"1967031000000000000000","0x1fb463a0389983df7d593f7bdd6d78497fed8879":"20000000000000000000","0x6e1ea4b183e252c9bb7767a006d4b43696cb8ae9":"294245000000000000000","0xc2aa74847e86edfdd3f3db22f8a2152feee5b7f7":"2048852000000000000000","0xa13b9d82a99b3c9bba5ae72ef2199edc7d3bb36c":"1999944000000000000000","0x5135fb8757600cf474546252f74dc0746d06262c":"2000000000000000000000","0x43e7ec846358d7d0f937ad1c350ba069d7bf72bf":"118800000000000000000","0xf2ed3e77254acb83231dc0860e1a11242ba627db":"1980000000000000000000","0xc0a02ab94ebe56d045b41b629b98462e3a024a93":"100000000000000000000","0xf21549bdd1487912f900a7523db5f7626121bba3":"10000000000000000000000","0x886d0a9e17c9c095af2ea2358b89ec705212ee94":"28000000000000000000","0x211b29cefc79ae976744fdebcebd3cbb32c51303":"14000000000000000000000","0xb8c2703d8c3f2f44c584bc10e7c0a6b64c1c097e":"5550000000000000000000","0xec30addd895b82ee319e54fb04cb2bb03971f36b":"2000000000000000000000","0xb71b62f4b448c02b1201cb5e394ae627b0a560ee":"500000000000000000000","0xe1334e998379dfe983177062791b90f80ee22d8d":"500000000000000000000","0x1d633097a85225a1ff4321b12988fdd55c2b3844":"4000000000000000000000","0x8bd8d4c4e943f6c8073921dc17e3e8d7a0761627":"2933330000000000000000","0xa5d96e697d46358d119af7819dc7087f6ae47fef":"14605131000000000000000","0xd0809498c548047a1e2a2aa6a29cd61a0ee268bd":"2000000000000000000000","0x3cd6b7593cbee77830a8b19d0801958fcd4bc57a":"500000000000000000000","0xead4d2eefb76abae5533961edd11400406b298fc":"3880000000000000000000","0x6331028cbb5a21485bc51b565142993bdb2582a9":"534800000000000000000","0x163bad4a122b457d64e8150a413eae4d07023e6b":"18800000000000000000","0xc522e20fbf04ed7f6b05a37b4718d6fce0142e1a":"4000000000000000000000","0x2d9bad6f1ee02a70f1f13def5cccb27a9a274031":"1790000000000000000000","0x5ed0d6338559ef44dc7a61edeb893fa5d83fa1b5":"220000000000000000000","0xec8c1d7b6aaccd429db3a91ee4c9eb1ca4f6f73c":"4250000000000000000000","0x3896ad743579d38e2302454d1fb6e2ab69e01bfd":"1880000000000000000000","0xe73ccf436725c151e255ccf5210cfce5a43f13e3":"19982000000000000000","0x9483d98f14a33fdc118d403955c29935edfc5f70":"459600000000000000000","0x1cfcf7517f0c08459720942b647ad192aa9c8828":"800000000000000000000","0x8d378f0edc0bb0f0686d6a20be6a7692c4fa24b8":"100000000000000000000","0x06f68de3d739db41121eacf779aada3de8762107":"28000000000000000000","0x9909650dd5b1397b8b8b0eb69499b291b0ad1213":"200000000000000000000","0xb66675142e3111a1c2ea1eb2419cfa42aaf7a234":"1000000000000000000000","0x7836f7ef6bc7bd0ff3acaf449c84dd6b1e2c939f":"4142296000000000000000","0x3ddedbe48923fbf9e536bf9ffb0747c9cdd39eef":"16100000000000000000000","0xc47d610b399250f70ecf1389bab6292c91264f23":"288800000000000000000","0x51a6d627f66a8923d88d6094c4715380d3057cb6":"1152044000000000000000","0x6c0cc917cbee7d7c099763f14e64df7d34e2bf09":"250000000000000000000","0xaaaae68b321402c8ebc13468f341c63c0cf03fce":"1520000000000000000000","0x819cdaa5303678ef7cec59d48c82163acc60b952":"14523448000000000000000","0xd071192966eb69c3520fca3aa4dd04297ea04b4e":"110000000000000000000","0xe53425d8df1f11c341ff58ae5f1438abf1ca53cf":"322000000000000000000","0x8ffe322997b8e404422d19c54aadb18f5bc8e9b7":"3940000000000000000000","0x305f78d618b990b4295bac8a2dfa262884f804ea":"4000000000000000000000","0x274d69170fe7141401882b886ac4618c6ae40edb":"955000000000000000000","0x69c94e07c4a9be3384d95dfa3cb9290051873b7b":"70000000000000000000","0x859c600cf13d1d0273d5d1da3cd789e495899f27":"2674000000000000000000","0xc06cebbbf7f5149a66f7eb976b3e47d56516da2f":"2000000000000000000000","0x37bbc47212d82fcb5ee08f5225ecc2041ad2da7d":"3280000000000000000000","0x11e7997edd904503d77da6038ab0a4c834bbd563":"388000000000000000000","0xd333627445f2d787901ef33bb2a8a3675e27ffec":"400000000000000000000","0x16a58e985dccd707a594d193e7cca78b5d027849":"1360000000000000000000","0xf8ae857b67a4a2893a3fbe7c7a87ff1c01c6a6e7":"4000000000000000000000","0x491561db8b6fafb9007e62d050c282e92c4b6bc8":"30000000000000000000000","0x21df1ec24b4e4bfe79b0c095cebae198f291fbd1":"20000000000000000000000","0xe208812a684098f3da4efe6aba256256adfe3fe6":"2000000000000000000000","0xf4ec8e97a20aa5f8dd206f55207e06b813df2cc0":"200000000000000000000","0x29eb7eefdae9feb449c63ff5f279d67510eb1422":"19400000000000000000","0x0d678706d037187f3e22e6f69b99a592d11ebc59":"1580000000000000000000","0xde6d363106cc6238d2f092f0f0372136d1cd50c6":"5348000000000000000000","0xc8710d7e8b5a3bd69a42fe0fa8b87c357fddcdc8":"4000000000000000000000","0x5267f4d41292f370863c90d793296903843625c7":"1400000000000000000000","0x4cda41dd533991290794e22ae324143e309b3d3d":"2400000000000000000000","0xf8a50cee2e688ceee3aca4d4a29725d4072cc483":"2000000000000000000000","0x5ed3bbc05240e0d399eb6ddfe60f62de4d9509af":"193999806000000000000000","0x0befb54707f61b2c9fb04715ab026e1bb72042bd":"4000000000000000000000","0xcab9a301e6bd46e940355028eccd40ce4d5a1ac3":"400000000000000000000","0x64672da3ab052821a0243d1ce4b6e0a36517b8eb":"200000000000000000000","0xeac0827eff0c6e3ff28a7d4a54f65cb7689d7b99":"2856500000000000000000","0xf4b6cdcfcb24230b337d770df6034dfbd4e1503f":"19000000000000000000000","0x7be2f7680c802da6154c92c0194ae732517a7169":"18200000000000000000","0x869f1aa30e4455beb1822091de5cadec79a8f946":"8000000000000000000000","0xc4681e73bb0e32f6b726204831ff69baa4877e32":"1820000000000000000000","0x962cd22a8edf1e4f4e55b4b15ddbfb5d9d541971":"2000000000000000000000","0x131df8d330eb7cc7147d0a55576f05de8d26a8b7":"188000000000000000000","0x19f99f2c0b46ce8906875dc9f90ae104dae35594":"4507300000000000000000","0x91bb3f79022bf3c453f4ff256e269b15cf2c9cbd":"1519000000000000000000","0x7301dc4cf26d7186f2a11bf8b08bf229463f64a3":"2000000000000000000000","0x7cbca88fca6a0060b960985c9aa1b02534dc2208":"462500000000000000000","0xf3c1abd29dc57b41dc192d0e384d021df0b4f6d4":"2798000000000000000000","0x5d32f6f86e787ff78e63d78b0ef95fe6071852b8":"401100000000000000000","0x1678c5f2a522393225196361894f53cc752fe2f3":"1936000000000000000000","0x1cf04cb14380059efd3f238b65d5beb86afa14d8":"20000000000000000000","0x52e1731350f983cc2c4189842fde0613fad50ce1":"11640000000000000000000","0xd0b11d6f2bce945e0c6a5020c3b52753f803f9d1":"200000000000000000000","0x409bd75085821c1de70cdc3b11ffc3d923c74010":"4000000000000000000000","0x0bb7160aba293762f8734f3e0326ffc9a4cac190":"1000000000000000000000","0x7aad4dbcd3acf997df93586956f72b64d8ad94ee":"4000000000000000000000","0x2dec98329d1f96c3a59caa7981755452d4da49d5":"200000000000000000000","0xc18ab467feb5a0aadfff91230ff056464d78d800":"2000000000000000000000","0xc90c3765156bca8e4897ab802419153cbe5225a9":"200000000000000000000","0x85c8f3cc7a354feac99a5e7bfe7cdfa351cfe355":"400000000000000000000","0xf4fc4d39bc0c2c4068a36de50e4ab4d4db7e340a":"25380000000000000000","0xf50abbd4aa45d3eb88515465a8ba0b310fd9b521":"6685000000000000000000","0x4d200110124008d56f76981256420c946a6ff45c":"199955000000000000000","0xf4ba6a46d55140c439cbcf076cc657136262f4f8":"2000000000000000000000","0xfa7adf660b8d99ce15933d7c5f072f3cbeb99d33":"5910000000000000000000","0x84503334630d77f74147f68b2e086613c8f1ade9":"1600000000000000000000","0x31ed858788bda4d5270992221cc04206ec62610d":"1176000000000000000000","0xbfbca418d3529cb393081062032a6e1183c6b2dc":"8000000000000000000000","0x8263ece5d709e0d7ae71cca868ed37cd2fef807b":"990000000000000000000","0x23ba3864da583dab56f420873c37679690e02f00":"9800000000000000000000","0xcedcb3a1d6843fb6bef643617deaf38f8e98dd5f":"477500000000000000000","0x8fac748f784a0fed68dba43319b42a75b4649c6e":"910000000000000000000","0x18b8bcf98321da61fb4e3eacc1ec5417272dc27e":"880000000000000000000","0x776943ffb2ef5cdd35b83c28bc046bd4f4677098":"3000000000000000000000","0xfb8113f94d9173eefd5a3073f516803a10b286ae":"80000000000000000000","0x3e8349b67f5745449f659367d9ad4712db5b895a":"1820000000000000000000","0x79cfa9780ae6d87b2c31883f09276986c89a6735":"1000000000000000000000","0x5006fe4c22173980f00c74342b39cd231c653129":"2000000000000000000000","0x13848b46ea75beb7eaa85f59d866d77fd24cf21a":"50000000000000000000000","0xd64a2d50f8858537188a24e0f50df1681ab07ed7":"38800000000000000000000","0x4f9ce2af9b8c5e42c6808a3870ec576f313545d1":"10000000000000000000000","0x8764d02722000996ecd475b433298e9f540b05bf":"200000000000000000000","0x3b7c77dbe95dc2602ce3269a9545d04965fefdbd":"2000000000000000000000","0xc9dcbb056f4db7d9da39936202c5bd8230b3b477":"20000000000000000000000","0x9ecbabb0b22782b3754429e1757aaba04b81189f":"823743000000000000000","0x831c44b3084047184b2ad218680640903750c45d":"1970000000000000000000","0xff8eb07de3d49d9d52bbe8e5b26dbe1d160fa834":"3986000000000000000000","0x8ccf3aa21ab742576ad8c422f71bb188591dea8a":"1000000000000000000000","0xddac312a9655426a9c0c9efa3fd82559ef4505bf":"401100000000000000000","0x9a3e2b1bf346dd070b027357feac44a4b2c97db8":"10000000000000000000000","0x69d39d510889e552a396135bfcdb06e37e387633":"4000000000000000000000","0x83a3148833d9644984f7c475a7850716efb480ff":"3400000000000000000000","0x62b4a9226e61683c72c183254690daf511b4117a":"260000000000000000000","0x50763add868fd7361178342fc055eaa2b95f6846":"66838000000000000000","0x91898eab8c05c0222883cd4db23b7795e1a24ad7":"2000000000000000000000","0x066647cfc85d23d37605573d208ca154b244d76c":"10000000000000000000000","0xaaf9ee4b886c6d1e95496fd274235bf4ecfcb07d":"1400000000000000000000","0x06860a93525955ff624940fadcffb8e149fd599c":"1999800000000000000000","0xe81c2d346c0adf4cc56708f6394ba6c8c8a64a1e":"2000000000000000000000","0x41a8e236a30e6d63c1ff644d132aa25c89537e01":"20000000000000000000","0x6a679e378fdce6bfd97fe62f043c6f6405d79e99":"4000000000000000000000","0x933436c8472655f64c3afaaf7c4c621c83a62b38":"1000000000000000000000","0xabe07ced6ac5ddf991eff6c3da226a741bd243fe":"10000000000000000000000","0xbb56a404723cff20d0685488b05a02cdc35aacaa":"20000000000000000000","0x0d551ec1a2133c981d5fc6a8c8173f9e7c4f47af":"2000000000000000000000","0x23376ecabf746ce53321cf42c86649b92b67b2ff":"2000000000000000000000","0x644ba6c61082e989109f5c11d4b40e991660d403":"4000000000000000000000","0x680d5911ed8dd9eec45c060c223f89a7f620bbd5":"20000000000000000000000","0xcb1bb6f1da5eb10d4899f7e61d06c1b00fdfb52d":"1038000000000000000000","0x303a30ac4286ae17cf483dad7b870c6bd64d7b4a":"500000000000000000000","0x7b0b31ff6e24745ead8ed9bb85fc0bf2fe1d55d4":"800000000000000000000","0x854691ce714f325ced55ce5928ce9ba12facd1b8":"4380000000000000000000","0xa13cfe826d6d1841dcae443be8c387518136b5e8":"140000000000000000000000","0x5fcd84546896dd081db1a320bd4d8c1dd1528c4c":"20000000000000000000","0x3db5fe6a68bd3612ac15a99a61e555928eeceaf3":"1580000000000000000000","0x7a79e30ff057f70a3d0191f7f53f761537af7dff":"400000000000000000000","0x3d3fad49c9e5d2759c8e8e5a7a4d60a0dd135692":"20000000000000000000","0x05a830724302bc0f6ebdaa1ebeeeb46e6ce00b39":"98500000000000000000","0xe4b6ae22c7735f5b89f34dd77ad0975f0acc9181":"1000000000000000000000","0x3f2dd55db7eab0ebee65b33ed8202c1e992e958b":"820000000000000000000","0x395d6d255520a8db29abc47d83a5db8a1a7df087":"100000000000000000000","0x1cc90876004109cd79a3dea866cb840ac364ba1b":"2000000000000000000000","0xc83e9d6a58253beebeb793e6f28b054a58491b74":"281800000000000000000","0x901d99b699e5c6911519cb2076b4c76330c54d22":"2000000000000000000000","0x3a9132b7093d3ec42e1e4fb8cb31ecdd43ae773c":"2000000000000000000000","0xb41eaf5d51a5ba1ba39bb418dbb54fab750efb1f":"1000000000000000000000","0xaa493d3f4fb866491cf8f800efb7e2324ed7cfe5":"1700000000000000000000","0x509982f56237ee458951047e0a2230f804e2e895":"17500000000000000000000","0x316e92a91bbda68b9e2f98b3c048934e3cc0b416":"2000000000000000000000","0xa3430e1f647f321ed34739562323c7d623410b56":"999942000000000000000","0xfca43bbc23a0d321ba9e46b929735ce7d8ef0c18":"20000000000000000000","0xff45cb34c928364d9cc9d8bb00373474618f06f3":"100000000000000000000","0x8c999591fd72ef7111efca7a9e97a2356b3b000a":"4084000000000000000000","0x8579dadf1a395a3471e20b6f763d9a0ff19a3f6f":"4000000000000000000000","0xc8d4e1599d03b79809e0130a8dc38408f05e8cd3":"2945500000000000000000","0x2abce1808940cd4ef5b5e05285f82df7a9ab5e03":"9800000000000000000000","0x0bb0c12682a2f15c9b5741b2385cbe41f034068e":"1500000000000000000000","0x08b7bdcf944d5570838be70460243a8694485858":"2000000000000000000000","0xc452e0e4b3d6ae06b836f032ca09db409ddfe0fb":"800000000000000000000","0x48d4f2468f963fd79a006198bb67895d2d5aa4d3":"1400000000000000000000","0xf9e7222faaf0f4da40c1c4a40630373a09bed7b6":"2865000000000000000000","0xbf59aee281fa43fe97194351a9857e01a3b897b2":"600000000000000000000","0xda0d4b7ef91fb55ad265f251142067f10376ced6":"20000000000000000000000","0x2c6f5c124cc789f8bb398e3f889751bc4b602d9e":"24928000000000000000","0xc85ef27d820403805fc9ed259fff64acb8d6346a":"2000000000000000000000","0x9aa8308f42910e5ade09c1a5e282d6d91710bdbf":"200000000000000000000","0x9e4cec353ac3e381835e3c0991f8faa5b7d0a8e6":"9999917000000000000000","0x137cf341e8516c815814ebcd73e6569af14cf7bc":"1000000000000000000000","0x889da662eb4a0a2a069d2bc24b05b4ee2e92c41b":"1663417000000000000000","0x0998d8273115b56af43c505e087aff0676ed3659":"3999984000000000000000","0x3e4d13c55a84e46ed7e9cb90fd355e8ad991e38f":"1000000000000000000000","0xabc068b4979b0ea64a62d3b7aa897d73810dc533":"1970000000000000000000","0xd8fdf546674738c984d8fab857880b3e4280c09e":"20000000000000000000","0xaff161740a6d909fe99c59a9b77945c91cc91448":"60000000000000000000","0x92ad1b3d75fba67d54663da9fc848a8ade10fa67":"2000000000000000000000","0x819eb4990b5aba5547093da12b6b3c1093df6d46":"1000000000000000000000","0x643d9aeed4b180947ed2b9207cce4c3ddc55e1f7":"200000000000000000000","0xab3e62e77a8b225e411592b1af300752fe412463":"9850000000000000000000","0x650b425555e4e4c51718146836a2c1ee77a5b421":"20000000000000000000000","0xba8e46d69d2e2343d86c60d82cf42c2041a0c1c2":"100000000000000000000","0xf9570e924c95debb7061369792cf2efec2a82d5e":"20000000000000000000","0x4dc4bf5e7589c47b28378d7503cf96488061dbbd":"1760000000000000000000","0x3d7ea5bf03528100ed8af8aed2653e921b6e6725":"1000000000000000000000","0xa02bde6461686e19ac650c970d0672e76dcb4fc2":"8865000000000000000000","0xb0e760bb07c081777345e0578e8bc898226d4e3b":"2000000000000000000000","0x979cbf21dfec8ace3f1c196d82df962534df394f":"2832860000000000000000","0x9f8245c3ab7d173164861cd3991b94f1ba40a93a":"2860000000000000000000","0xc25cf826550c8eaf10af2234fef904ddb95213be":"1000000000000000000000","0x967bfaf76243cdb9403c67d2ceefdee90a3feb73":"970582000000000000000","0x0b2113504534642a1daf102eee10b9ebde76e261":"2733351000000000000000","0x74bc4a5e2045f4ff8db184cf3a9b0c065ad807d2":"2000000000000000000000","0xf1da40736f99d5df3b068a5d745fafc6463fc9b1":"121546000000000000000","0x0fa6c7b0973d0bae2940540e247d3627e37ca347":"1000000000000000000000","0x72b05962fb2ad589d65ad16a22559eba1458f387":"133700000000000000000","0x6ceae3733d8fa43d6cd80c1a96e8eb93109c83b7":"298000000000000000000","0x28eaea78cd4d95faecfb68836eafe83520f3bbb7":"200000000000000000000","0xf49f6f9baabc018c8f8e119e0115f491fc92a8a4":"10000000000000000000000","0x833316985d47742bfed410604a91953c05fb12b0":"2000000000000000000000","0xead75016e3a0815072b6b108bcc1b799acf0383e":"2000000000000000000000","0x0032403587947b9f15622a68d104d54d33dbd1cd":"77500000000000000000","0x8f64b9c1246d857831643107d355b5c75fef5d4f":"1999944000000000000000","0x15dcafcc2bace7b55b54c01a1c514626bf61ebd8":"9400000000000000000000","0x6886ada7bbb0617bda842191c68c922ea3a8ac82":"1160000000000000000000","0xf736dc96760012388fe88b66c06efe57e0d7cf0a":"2100000000000000000000","0x0b288a5a8b75f3dc4191eb0457e1c83dbd204d25":"4853000000000000000000","0x56b6c23dd2ec90b4728f3bb2e764c3c50c85f144":"1000000000000000000000","0x6310b020fd98044957995092090f17f04e52cdfd":"1580000000000000000000","0xb0baeb30e313776c4c6d247402ba4167afcda1cc":"1970000000000000000000","0x7641f7d26a86cddb2be13081810e01c9c83c4b20":"13370000000000000000","0x07a8dadec142571a7d53a4297051786d072cba55":"22729000000000000000","0xcc73dd356b4979b579b401d4cc7a31a268ddce5a":"500000000000000000000","0xadf1acfe99bc8c14b304c8d905ba27657b8a7bc4":"20000000000000000000000","0x72dabb5b6eed9e99be915888f6568056381608f8":"208433000000000000000","0x9de20ae76aa08263b205d5142461961e2408d266":"252000000000000000000","0x9d4ff989b7bed9ab109d10c8c7e55f02d76734ad":"1000000000000000000000","0xe58dd23238ee6ea7c2138d385df500c325f376be":"1820000000000000000000","0x4bd6dd0cff23400e1730ba7b894504577d14e74a":"206028000000000000000000","0x35147430c3106500e79fa2f502462e94703c23b1":"1999944000000000000000","0xc0ae14d724832e2fce2778de7f7b8daf7b12a93e":"20000000000000000000","0xb57413060af3f14eb479065f1e9d19b3757ae8cc":"40000000000000000000","0x7d04d2edc058a1afc761d9c99ae4fc5c85d4c8a6":"314807840000000000000000","0x1c94d636e684eb155895ce6db4a2588fba1d001b":"2000000000000000000000","0xc721b2a7aa44c21298e85039d00e2e460e670b9c":"140800000000000000000","0x2d89a8006a4f137a20dc2bec46fe2eb312ea9654":"200000000000000000000","0x646afba71d849e80c0ed59cac519b278e7f7abe4":"1000000000000000000000","0x71f2cdd1b046e2da2fbb5a26723422b8325e25a3":"99960000000000000000","0x2c9fa72c95f37d08e9a36009e7a4b07f29bad41a":"16100000000000000000","0x848fbd29d67cf4a013cb02a4b176ef244e9ee68d":"20116000000000000000","0x68190ca885da4231874c1cfb42b1580a21737f38":"3820000000000000000000","0x9adf458bff3599eee1a26398853c575bc38c6313":"280000000000000000000","0xb72220ade364d0369f2d2da783ca474d7b9b34ce":"499986000000000000000","0x38e2af73393ea98a1d993a74df5cd754b98d529a":"1790000000000000000000","0x4d38d90f83f4515c03cc78326a154d358bd882b7":"185000000000000000000","0xaa8eb0823b07b0e6d20aadda0e95cf3835be192e":"32000000000000000000","0x008639dabbe3aeac887b5dc0e43e13bcd287d76c":"310200000000000000000","0xfa3a0c4b903f6ea52ea7ab7b8863b6a616ad6650":"20000000000000000000","0xe26bf322774e18288769d67e3107deb7447707b8":"2000000000000000000000","0xe061a4f2fc77b296d19ada238e49a5cb8ecbfa70":"4000000000000000000000","0xb320834836d1dbfda9e7a3184d1ad1fd4320ccc0":"1000000000000000000000","0x0ed3bb3a4eb554cfca97947d575507cdfd6d21d8":"547863000000000000000","0x32fa0e86cd087dd68d693190f32d93310909ed53":"4000000000000000000000","0x5b759fa110a31c88469f54d44ba303d57dd3e10f":"1683760000000000000000","0x136f4907cab41e27084b9845069ff2fd0c9ade79":"4000000000000000000000","0x3d89e505cb46e211a53f32f167a877bec87f4b0a":"25019000000000000000","0x57a852fdb9b1405bf53ccf9508f83299d3206c52":"2000000000000000000000","0x747abc9649056d3926044d28c3ad09ed17b67d70":"5000057000000000000000","0x5c29f9e9a523c1f8669448b55c48cbd47c25e610":"964320000000000000000","0x30a9da72574c51e7ee0904ba1f73a6b7b83b9b9d":"20200000000000000000","0x220e2b92c0f6c902b513d9f1e6fab6a8b0def3d7":"800000000000000000000","0x5af7c072b2c5acd71c76addcce535cf7f8f93585":"20000000000000000000","0x81556db27349ab8b27004944ed50a46e941a0f5f":"3998000000000000000000","0x987618c85656207c7bac1507c0ffefa2fb64b092":"64419000000000000000","0xe0f372347c96b55f7d4306034beb83266fd90966":"400000000000000000000","0x71784c105117c1f68935797fe159abc74e43d16a":"2001600000000000000000","0x9284f96ddb47b5186ee558aa31324df5361c0f73":"16000000000000000000000","0xa60c1209754f5d87b181da4f0817a81859ef9fd8":"50000000000000000000","0x5afda9405c8e9736514574da928de67456010918":"6008500000000000000000","0x6978696d5150a9a263513f8f74c696f8b1397cab":"6640000000000000000000","0xa9ad1926bc66bdb331588ea8193788534d982c98":"30000000000000000000000","0xe3f80b40fb83fb97bb0d5230af4f6ed59b1c7cc8":"1337000000000000000000","0xe207578e1f4ddb8ff6d5867b39582d71b9812ac5":"3880000000000000000000","0x86883d54cd3915e549095530f9ab1805e8c5432d":"4000000000000000000000","0x6974c8a414ceaefd3c2e4dfdbef430568d9a960b":"334250000000000000000","0x532d32b00f305bcc24dcef56817d622f34fb2c24":"1800000000000000000000","0x761f8a3a2af0a8bdbe1da009321fb29764eb62a1":"10000000000000000000000","0x4677b04e0343a32131fd6abb39b1b6156bba3d5b":"200000000000000000000","0xef69781f32ffce33346f2c9ae3f08493f3e82f89":"18200000000000000000","0xe3b3d2c9bf570be6a2f72adca1862c310936a43c":"100100000000000000000","0xd19caf39bb377fdf2cf19bd4fb52591c2631a63c":"1000000000000000000000","0x5d68324bcb776d3ffd0bf9fea91d9f037fd6ab0f":"2000000000000000000000","0x1c99fe9bb6c6d1066d912099547fd1f4809eacd9":"2000000000000000000000","0xbbfe0a830cace87b7293993a7e9496ce64f8e394":"6000000000000000000000","0x26c0054b700d3a7c2dcbe275689d4f4cad16a335":"2000000000000000000000","0x7d7e7c61779adb7706c94d32409a2bb4e994bf60":"865992000000000000000","0xd037d215d11d1df3d54fbd321cd295c5465e273b":"1400000000000000000000","0x08166f02313feae18bb044e7877c808b55b5bf58":"1970000000000000000000","0x781b1501647a2e06c0ed43ff197fccec35e1700b":"3000000000000000000000","0x74316adf25378c10f576d5b41a6f47fa98fce33d":"336082000000000000000","0x44e2fdc679e6bee01e93ef4a3ab1bcce012abc7c":"410231000000000000000","0x178eaf6b8554c45dfde16b78ce0c157f2ee31351":"320000000000000000000","0xcf923a5d8fbc3d01aa079d1cfe4b43ce071b1611":"2000000000000000000000","0x0c28847e4f09dfce5f9b25af7c4e530f59c880fe":"1000000000000000000000","0x54ce88275956def5f9458e3b95decacd484021a0":"2000000000000000000000","0x9d4213339a01551861764c87a93ce8f85f87959a":"200000000000000000000","0xe559b5fd337b9c5572a9bf9e0f2521f7d446dbe4":"200000000000000000000","0xdcb03bfa6c1131234e56b7ea7c4f721487546b7a":"1337000000000000000000","0xdb6ff71b3db0928f839e05a7323bfb57d29c87aa":"910000000000000000000","0xeb7c202b462b7cc5855d7484755f6e26ef43a115":"2000000000000000000000","0x323486ca64b375474fb2b759a9e7a135859bd9f6":"400000000000000000000","0x2c1df8a76f48f6b54bcf9caf56f0ee1cf57ab33d":"10118000000000000000000","0x2cd87866568dd81ad47d9d3ad0846e5a65507373":"400000000000000000000","0x8566610901aace38b83244f3a9c831306a67b9dc":"3256000000000000000000","0x1c257ad4a55105ea3b58ed374b198da266c85f63":"10000000000000000000000","0xcf4f1138f1bd6bf5b6d485cce4c1017fcb85f07d":"882038000000000000000","0xc934becaf71f225f8b4a4bf7b197f4ac9630345c":"20000000000000000000000","0x1e2bf4ba8e5ef18d37de6d6ad636c4cae489d0cc":"2000000000000000000000","0x9d78a975b7db5e4d8e28845cfbe7e31401be0dd9":"1340000000000000000000","0x16aa52cb0b554723e7060f21f327b0a68315fea3":"250000000000000000000","0x97e28973b860c567402800fbb63ce39a048a3d79":"97000000000000000000","0x4ac5acad000b8877214cb1ae00eac9a37d59a0fd":"4000000000000000000000","0x01226e0ad8d62277b162621c62c928e96e0b9a8c":"2000000000000000000000","0x479abf2da4d58716fd973a0d13a75f530150260a":"20000000000000000000","0x31d81d526c195e3f10b5c6db52b5e59afbe0a995":"264000000000000000000","0x749087ac0f5a97c6fad021538bf1d6cda18e0daa":"1000000000000000000000","0x1565af837ef3b0bd4e2b23568d5023cd34b16498":"393284000000000000000","0x997d6592a31589acc31b9901fbeb3cc3d65b3215":"2000000000000000000000","0x9d207517422cc0d60de7c237097a4d4fce20940c":"500000000000000000000","0x24b8b446debd1947955dd084f2c544933346d3ad":"4324135000000000000000","0x107a03cf0842dbdeb0618fb587ca69189ec92ff5":"1970000000000000000000","0x7f603aec1759ea5f07c7f8d41a1428fbbaf9e762":"20000000000000000000","0x53a244672895480f4a2b1cdf7da5e5a242ec4dbc":"1000000000000000000000","0x7db4c7d5b797e9296e6382f203693db409449d62":"400000000000000000000","0x2ae82dab92a66389eea1abb901d1d57f5a7cca0b":"2000000000000000000000","0x16bc40215abbd9ae5d280b95b8010b4514ff1292":"200000000000000000000","0xbba4fac3c42039d828e742cde0efffe774941b39":"1999946000000000000000","0x5431ca427e6165a644bae326bd09750a178c650d":"2000000000000000000000","0xdcf33965531380163168fc11f67e89c6f1bc178a":"334885000000000000000","0x65fd02d704a12a4dace9471b0645f962a89671c8":"28615000000000000000","0x135d1719bf03e3f866312479fe338118cd387e70":"2000000000000000000000","0xf3159866c2bc86bba40f9d73bb99f1eee57bb9d7":"1000000000000000000000","0xe3a4621b66004588e31206f718cb00a319889cf0":"2000000000000000000000","0xabcdbc8f1dd13af578d4a4774a62182bedf9f9be":"36660000000000000000","0x9fbe066de57236dc830725d32a02aef9246c6c5e":"2000000000000000000000","0x81cfad760913d3c322fcc77b49c2ae3907e74f6e":"197000000000000000000","0x0ab59d390702c9c059db148eb4f3fcfa7d04c7e7":"18200000000000000000","0x2c2db28c3309375eea3c6d72cd6d0eec145afcc0":"2000000000000000000000","0x08306de51981e7aca1856859b7c778696a6b69f9":"3200000000000000000000","0xf814799f6ddf4dcb29c7ee870e75f9cc2d35326d":"1000000000000000000000","0xee867d20916bd2e9c9ece08aa04385db667c912e":"50000000000000000000000","0x97a86f01ce3f7cfd4441330e1c9b19e1b10606ef":"2000000000000000000000","0x4c759813ad1386bed27ffae9e4815e3630cca312":"2000000000000000000000","0x8f226096c184ebb40105e08dac4d22e1c2d54d30":"306552000000000000000","0x13acada8980affc7504921be84eb4944c8fbb2bd":"1601600000000000000000","0x122dcfd81addb97d1a0e4925c4b549806e9f3beb":"1514954000000000000000","0x232f525d55859b7d4e608d20487faadb00293135":"4000000000000000000000","0x6f7ac681d45e418fce8b3a1db5bc3be6f06c9849":"2000000000000000000000","0x0c8692eeff2a53d6d1688ed56a9ddbbd68dabba1":"2000000000000000000000","0x6a6337833f8f6a6bf10ca7ec21aa810ed444f4cb":"1028200000000000000000","0x209377b6ad3fe101c9685b3576545c6b1684e73c":"1820000000000000000000","0x560fc08d079f047ed8d7df75551aa53501f57013":"7600000000000000000000","0x8e78f351457d016f4ad2755ec7424e5c21ba6d51":"146000000000000000000","0x2ce11a92fad024ff2b3e87e3b542e6c60dcbd996":"4000000000000000000000","0x8ab839aeaf2ad37cb78bacbbb633bcc5c099dc46":"2000000000000000000000","0x673144f0ec142e770f4834fee0ee311832f3087b":"500038000000000000000","0xba8a63f3f40de4a88388bc50212fea8e064fbb86":"2000000000000000000000","0xee899b02cbcb3939cd61de1342d50482abb68532":"1760000000000000000000","0xc2d9eedbc9019263d9d16cc5ae072d1d3dd9db03":"20000000000000000000000","0x355c0c39f5d5700b41d375b3f17851dcd52401f9":"3979000000000000000000","0x8179c80970182cc5b7d82a4df06ea94db63a25f3":"727432000000000000000","0xb388b5dfecd2c5e4b596577c642556dbfe277855":"20000000000000000000","0xa9e28337e6357193d9e2cb236b01be44b81427df":"2200000000000000000000","0x04ba4bb87140022c214a6fac42db5a16dd954045":"1000000000000000000000","0x67c926093e9b8927933810d98222d62e2b8206bb":"1910000000000000000000","0xed7346766e1a676d0d06ec821867a276a083bf31":"4012890000000000000000","0x92558226b384626cad48e09d966bf1395ee7ea5d":"334250000000000000000","0xbdf693f833c3fe471753184788eb4bfe4adc3f96":"1970000000000000000000","0x4474299d0ee090dc90789a1486489c3d0d645e6d":"1000000000000000000000","0xb1178ad47383c31c8134a1941cbcd474d06244e2":"1000000000000000000000","0x979d681c617da16f21bcaca101ed16ed015ab696":"1880000000000000000000","0x6b20c080606a79c73bd8e75b11717a4e8db3f1c3":"299720000000000000000","0xb85218f342f8012eda9f274e63ce2152b2dcfdab":"3100000000000000000000","0x530b61e42f39426d2408d40852b9e34ab5ebebc5":"267400000000000000000","0x76afc225f4fa307de484552bbe1d9d3f15074c4a":"2998800000000000000000","0x1e783e522ab7df0acaac9eeed3593039e5ac7579":"203435800000000000000000","0x0f7bf6373f771a4601762c4dae5fbbf4fedd9cc9":"2000000000000000000000","0x7a8797690ab77b5470bf7c0c1bba612508e1ac7d":"8865000000000000000000","0x2a2ab6b74c7af1d9476bb5bcb4524797bedc3552":"1000000000000000000000","0x523e140dc811b186dee5d6c88bf68e90b8e096fd":"2000000000000000000000","0xea8168fbf225e786459ca6bb18d963d26b505309":"500000000000000000000","0x20ff3ede8cadb5c37b48cb14580fb65e23090a7b":"42000000000000000000000","0xe482d255ede56b04c3e8df151f56e9ca62aaa8c2":"500000000000000000000","0x2e0880a34596230720f05ac8f065af8681dcb6c2":"100000000000000000000000","0xc674f28c8afd073f8b799691b2f0584df942e844":"2000000000000000000000","0xb646df98b49442746b61525c81a3b04ba3106250":"1970000000000000000000","0xd55c1c8dfbe1e02cacbca60fdbdd405b09f0b75f":"2000000000000000000000","0x65ebaed27edb9dcc1957aee5f452ac2105a65c0e":"43531987000000000000000","0xf079e1b1265f50e8c8a98ec0c7815eb3aeac9eb4":"20094000000000000000","0x867eba56748a5904350d2ca2a5ce9ca00b670a9b":"20000000000000000000000","0x51ee0cca3bcb10cd3e983722ced8493d926c0866":"999972000000000000000","0x88d541c840ce43cefbaf6d19af6b9859b573c145":"170000000000000000000","0xf851b010f633c40af1a8f06a73ebbaab65077ab5":"4400000000000000000000","0xe0aa69365555b73f282333d1e30c1bbd072854e8":"7000000000000000000000","0xc7b1c83e63203f9547263ef6282e7da33b6ed659":"18200000000000000000","0xaf06f5fa6d1214ec43967d1bd4dde74ab814a938":"88000000000000000000","0x991173601947c2084a62d639527e961512579af9":"600000000000000000000","0x7a381122bada791a7ab1f6037dac80432753baad":"10000000000000000000000","0xe766f34ff16f3cfcc97321721f43ddf5a38b0cf4":"1550000000000000000000","0xd785a8f18c38b9bc4ffb9b8fa8c7727bd642ee1c":"1000000000000000000000","0xaebd4f205de799b64b3564b256d42a711d37ef99":"1177100000000000000000","0xa2fa17c0fb506ce494008b9557841c3f641b8cae":"20000000000000000000","0xa8aca748f9d312ec747f8b6578142694c7e9f399":"2000000000000000000000","0x950c68a40988154d2393fff8da7ccda99614f72c":"4597943000000000000000","0x075d15e2d33d8b4fa7dba8b9e607f04a261e340b":"1910000000000000000000","0x3616d448985f5d32aefa8b93a993e094bd854986":"205400000000000000000","0x4bb9655cfb2a36ea7c637a7b859b4a3154e26ebe":"16000000000000000000000","0x84949dba559a63bfc845ded06e9f2d9b7f11ef24":"2000000000000000000000","0x937563d8a80fd5a537b0e66d20a02525d5d88660":"2500000000000000000000","0xb183ebee4fcb42c220e47774f59d6c54d5e32ab1":"1604266000000000000000","0x21e5d77320304c201c1e53b261a123d0a1063e81":"86972000000000000000","0xfa14b566234abee73042c31d21717182cba14aa1":"328000000000000000000","0x2da617695009cc57d26ad490b32a5dfbeb934e5e":"20000000000000000000000","0x3326b88de806184454c40b27f309d9dd6dcfb978":"17900000000000000000000","0x95e6a54b2d5f67a24a4875af75107ca7ea9fd2fa":"1337000000000000000000","0x8db58e406e202df9bc703c480bd8ed248d52a032":"2000000000000000000000","0xf777361a3dd8ab62e5f1b9b047568cc0b555704c":"1000000000000000000000","0x83a93b5ba41bf88720e415790cdc0b67b4af34c4":"200000000000000000000","0x8a1cc5ac111c49bfcfd848f37dd768aa65c88802":"10000000000000000000000","0x52214378b54004056a7cc08c891327798ac6b248":"15200000000000000000000","0xad80d865b85c34d2e6494b2e7aefea6b9af184db":"4000000000000000000000","0xe7d6240620f42c5edbb2ede6aec43da4ed9b5757":"1000000000000000000000","0xd0e35e047646e759f4517093d6408642517f084d":"3939507000000000000000","0x9340345ca6a3eabdb77363f2586043f29438ce0b":"530922000000000000000","0x6640ccf053555c130ae2b656647ea6e31637b9ab":"1970000000000000000000","0x184d86f3466ae6683b19729982e7a7e1a48347b2":"10000000000000000000000","0x84ec06f24700fe42414cb9897c154c88de2f6132":"1337000000000000000000","0xd1e5e234a9f44266a4a6241a84d7a1a55ad5a7fe":"20000000000000000000000","0xe8a9a41740f44f54c3688b53e1ddd42e43c9fe94":"4000000000000000000000","0x6e3a51db743d334d2fe88224b5fe7c008e80e624":"106000000000000000000","0x3e94df5313fa520570ef232bc3311d5f622ff183":"2000000000000000000000","0x8957727e72cf629020f4e05edf799aa7458062d0":"2200000000000000000000","0xcf5e0eacd1b39d0655f2f77535ef6608eb950ba0":"2000000000000000000000","0xf4aaa3a6163e3706577b49c0767e948a681e16ee":"2000000000000000000000","0x97f1fe4c8083e596212a187728dd5cf80a31bec5":"20000000000000000000","0x57d5fd0e3d3049330ffcdcd020456917657ba2da":"1991240000000000000000","0x49bdbc7ba5abebb6389e91a3285220d3451bd253":"1000000000000000000000","0xae126b382cf257fad7f0bc7d16297e54cc7267da":"300000000000000000000","0xbbf8616d97724af3def165d0e28cda89b800009a":"114063000000000000000","0xadb948b1b6fefe207de65e9bbc2de98e605d0b57":"2000000000000000000000","0x8a217db38bc35f215fd92906be42436fe7e6ed19":"6000000000000000000000","0xe28b062259e96eeb3c8d4104943f9eb325893cf5":"1337000000000000000000","0x6a6b18a45a76467e2e5d5a2ef911c3e12929857b":"82000000000000000000000","0xcb68ae5abe02dcf8cbc5aa719c25814651af8b85":"500000000000000000000","0x4c7e2e2b77ad0cd6f44acb2861f0fb8b28750ef9":"20000000000000000000","0x58ba1569650e5bbbb21d35d3e175c0d6b0c651a9":"500000000000000000000","0x1eb4bf73156a82a0a6822080c6edf49c469af8b9":"1910000000000000000000","0x4103299671d46763978fa4aa19ee34b1fc952784":"200000000000000000000","0xe321bb4a946adafdade4571fb15c0043d39ee35f":"1575212000000000000000","0x893608751d68d046e85802926673cdf2f57f7cb8":"19700000000000000000","0x70fee08b00c6c2c04a3c625c1ff77caf1c32df01":"200000000000000000000","0x7b0fea1176d52159333a143c294943da36bbddb4":"9380000000000000000000","0xd331c823825a9e5263d052d8915d4dcde07a5c37":"564000000000000000000","0xa45432a6f2ac9d56577b938a37fabac8cc7c461c":"1000000000000000000000","0x764fc46d428b6dbc228a0f5f55c9508c772eab9f":"26000000000000000000000","0x1a95a8a8082e4652e4170df9271cb4bb4305f0b2":"50000000000000000000","0x08c9f1bfb689fdf804d769f82123360215aff93b":"1970000000000000000000","0x1572cdfab72a01ce968e78f5b5448da29853fbdd":"5061500000000000000000","0x379c7166849bc24a02d6535e2def13daeef8aa8d":"100000000000000000000","0xe0a254ac09b9725bebc8e460431dd0732ebcabbf":"6000000000000000000000","0x3225c1ca5f2a9c88156bb7d9cdc44a326653c214":"400000000000000000000","0x84686c7bad762c54b667d59f90943cd14d117a26":"20000000000000000000","0x3d5a8b2b80be8b35d8ecf789b5ed7a0775c5076c":"20000000000000000000","0x2ccf80e21898125eb4e807cd82e09b9d28592f6e":"2000000000000000000000","0xdde969aef34ea87ac299b7597e292b4a0155cc8a":"298819000000000000000","0x19e94e620050aad766b9e1bad931238312d4bf49":"2396000000000000000000","0x959f57fded6ae37913d900b81e5f48a79322c627":"255599000000000000000","0xb9b0a3219a3288d9b35b091b14650b8fe23dce2b":"14000000000000000000000","0x3575c770668a9d179f1ef768c293f80166e2aa3d":"474000000000000000000","0x58f05b262560503ca761c61890a4035f4c737280":"8000000000000000000000","0x3286d1bc657a312c8847d93cb3cb7950f2b0c6e3":"20000000000000000000000","0x1d9e6aaf8019a05f230e5def05af5d889bd4d0f2":"133700000000000000000","0xa375b4bc24a24e1f797593cc302b2f331063fa5c":"200000000000000000000","0x108ba7c2895c50e072dc6f964932d50c282d3034":"500000000000000000000","0xb6b34a263f10c3d2eceb0acc559a7b2ab85ce565":"4000000000000000000000","0xa4d2b429f1ad5349e31704969edc5f25ee8aca10":"10000000000000000000000","0x674adb21df4c98c7a347ac4c3c24266757dd7039":"2000000000000000000000","0x33565ba9da2c03e778ce12294f081dfe81064d24":"16000000000000000000000","0x4ddda7586b2237b053a7f3289cf460dc57d37a09":"10000000000000000000000","0xcc4faac00be6628f92ef6b8cb1b1e76aac81fa18":"205410000000000000000","0x5f99dc8e49e61d57daef606acdd91b4d7007326a":"3000000000000000000000","0xb8a979352759ba09e35aa5935df175bff678a108":"20000000000000000000","0x86fff220e59305c09f483860d6f94e96fbe32f57":"42900000000000000000","0x03e8b084537557e709eae2e1e1a5a6bce1ef8314":"20000000000000000000","0xdda4ff7de491c687df4574dd1b17ff8f246ba3d1":"19600000000000000000000","0x2538532936813c91e653284f017c80c3b8f8a36f":"2002000000000000000000","0x5a82f96cd4b7e2d93d10f3185dc8f43d4b75aa69":"1999400000000000000000","0x86740a46648e845a5d96461b18091ff57be8a16f":"98000000000000000000000","0x7e3f63e13129a221ba1ab06326342cd98b5126ae":"1597960000000000000000","0x1f5f3b34bd134b2781afe5a0424ac5846cdefd11":"99000000000000000000","0x39936c2719450b9420cc2522cf91db01f227c1c1":"500000000000000000000","0x967076a877b18ec15a415bb116f06ef32645dba3":"2000000000000000000000","0xa42908e7fe53980a9abf4044e957a54b70e99cbe":"2000000000000000000000","0x5eb371c407406c427b3b7de271ad3c1e04269579":"3000000000000000000000","0xa570223ae3caa851418a9843a1ac55db4824f4fd":"200000000000000000000","0x764692cccb33405dd0ab0c3379b49caf8e6221ba":"20000000000000000000","0xa365918bfe3f2627b9f3a86775d8756e0fd8a94b":"400000000000000000000","0x069ed0ab7aa77de571f16106051d92afe195f2d0":"200000000000000000000","0xbd432a3916249b4724293af9146e49b8280a7f2a":"4000000000000000000000","0x61c9dce8b2981cb40e98b0402bc3eb28348f03ac":"196910000000000000000","0x8f1fcc3c51e252b693bc5b0ec3f63529fe69281e":"6000000000000000000000","0x55fd08d18064bd202c0ec3d2cce0ce0b9d169c4d":"1970000000000000000000","0x383a7c899ee18bc214969870bc7482f6d8f3570e":"10000000000000000000000","0xb14cc8de33d6338236539a489020ce4655a32bc6":"8000000000000000000000","0x448bf410ad9bbc2fecc4508d87a7fc2e4b8561ad":"199955000000000000000","0x06f7dc8d1b9462cef6feb13368a7e3974b097f9f":"2000000000000000000000","0x9c9f89a3910f6a2ae8a91047a17ab788bddec170":"10000000000000000000000","0x5de598aba344378cab4431555b4f79992dc290c6":"1337000000000000000000","0x87e6034ecf23f8b5639d5f0ea70a22538a920423":"328000000000000000000","0x8b27392206b958cd375d7ef8af2cf8ef0598c0bc":"1000000000000000000000","0x49136fe6e28b7453fcb16b6bbbe9aaacba8337fd":"2000000000000000000000","0x6982fe8a867e93eb4a0bd051589399f2ec9a5292":"2000000000000000000000","0x9fd1052a60506bd1a9ef003afd9d033c267d8e99":"1000000000000000000000","0xd38fa2c4cc147ad06ad5a2f75579281f22a7cc1f":"20000000000000000000000","0x6f794dbdf623daa6e0d00774ad6962737c921ea4":"2000000000000000000000","0xe96b184e1f0f54924ac874f60bbf44707446b72b":"2910840000000000000000","0xb5ba29917c78a1d9e5c5c713666c1e411d7f693a":"3100000000000000000000","0x81d619ff5726f2405f12904c72eb1e24a0aaee4f":"20000000000000000000000","0xb02fa29387ec12e37f6922ac4ce98c5b09e0b00f":"2000000000000000000000","0xb7230d1d1ff2aca366963914a79df9f7c5ea2c98":"8000000000000000000000","0x7b4007c45e5a573fdbb6f8bd746bf94ad04a3c26":"15202564000000000000000","0x8d9a0c70d2262042df1017d6c303132024772712":"2000000000000000000000","0x323aad41df4b6fc8fece8c93958aa901fa680843":"970000000000000000000","0xdb04fad9c49f9e880beb8fcf1d3a3890e4b3846f":"1242482000000000000000","0x27824666d278d70423f03dfe1dc7a3f02f43e2b5":"1000070000000000000000","0xe04920dc6ecc1d6ecc084f88aa0af5db97bf893a":"182000000000000000000","0xb0c1b177a220e41f7c74d07cde8569c21c75c2f9":"5600000000000000000000","0x7864dc999fe4f8e003c0f43decc39aae1522dc0f":"94400000000000000000","0xc75c37ce2da06bbc40081159c6ba0f976e3993b1":"1078640000000000000000","0x179a825e0f1f6e985309668465cffed436f6aea9":"20000000000000000000","0x2c6b699d9ead349f067f45711a074a641db6a897":"20000000000000000000","0x068ce8bd6e902a45cb83b51541b40f39c4469712":"5240000000000000000000","0x767ac690791c2e23451089fe6c7083fe55deb62b":"820000000000000000000","0xb34f04b8db65bba9c26efc4ce6efc50481f3d65d":"20000000000000000000000","0x29aef48de8c9fbad4b9e4ca970797a5533eb722d":"10000000000000000000000","0x0a0ecda6636f7716ef1973614687fd89a820a706":"394000000000000000000","0xb32825d5f3db249ef4e85cc4f33153958976e8bc":"501375000000000000000","0x7ef16fd8d15b378a0fba306b8d03dd98fc92619f":"700000000000000000000","0xb58b52865ea55d8036f2fab26098b352ca837e18":"18200000000000000000","0x9b658fb361e046d4fcaa8aef6d02a99111223625":"2000000000000000000000","0xb2a498f03bd7178bd8a789a00f5237af79a3e3f8":"19400000000000000000000","0xcb48fe8265d9af55eb7006bc335645b0a3a183be":"3000000000000000000000","0x3cf9a1d465e78b7039e3694478e2627b36fcd141":"1372000000000000000000","0x5db84400570069a9573cab04b4e6b69535e202b8":"9700000000000000000000","0x214c89c5bd8e7d22bc574bb35e48950211c6f776":"18903000000000000000","0x53396f4a26c2b4604496306c5442e7fcba272e36":"20055000000000000000000","0x720994dbe56a3a95929774e20e1fe525cf3704e4":"8000000000000000000000","0x3571cf7ad304ecaee595792f4bbfa484418549d6":"5825500000000000000000","0x6042c644bae2b96f25f94d31f678c90dc96690db":"2000000000000000000000","0x2e24b597873bb141bdb237ea8a5ab747799af02d":"20000000000000000000000","0x08c802f87758349fa03e6bc2e2fd0791197eea9a":"2000000000000000000000","0x297a88921b5fca10e5bb9ded60025437ae221694":"200000000000000000000","0xaee49d68adedb081fd43705a5f78c778fb90de48":"20000000000000000000","0x4cee901b4ac8b156c5e2f8a6f1bef572a7dceb7e":"1000000000000000000000","0xdfaf31e622c03d9e18a0ddb8be60fbe3e661be0a":"9999800000000000000000","0x00aa5381b2138ebeffc191d5d8c391753b7098d2":"990049000000000000000","0x5b4c0c60f10ed2894bdb42d9dd1d210587810a0d":"500000000000000000000","0xc44f4ab5bc60397c737eb0683391b633f83c48fa":"1000000000000000000000","0x50bef2756248f9a7a380f91b051ba3be28a649ed":"1999884000000000000000","0x1bd909ac0d4a1102ec98dcf2cca96a0adcd7a951":"20055000000000000000","0x9ec03e02e587b7769def538413e97f7e55be71d8":"19700000000000000000000","0x9874803fe1f3a0365e7922b14270eaeb032cc1b5":"1124500000000000000000","0x4e2310191ead8d3bc6489873a5f0c2ec6b87e1be":"1000000000000000000000","0x93678a3c57151aeb68efdc43ef4d36cb59a009f3":"30060000000000000000","0xf483f607a21fcc28100a018c568ffbe140380410":"1000000000000000000000","0x2a91a9fed41b7d0e5cd2d83158d3e8a41a9a2d71":"1940000000000000000000","0x240e559e274aaef0c258998c979f671d1173b88b":"4000000000000000000000","0x108a2b7c336f784779d8b54d02a8d31d9a139c0a":"10000000000000000000000","0x9c98fdf1fdcd8ba8f4c5b04c3ae8587efdf0f6e6":"6000000000000000000000","0x194ff44aefc17bd20efd7a204c47d1620c86db5d":"2999400000000000000000","0x1f8116bd0af5570eaf0c56c49c7ab5e37a580458":"2000000000000000000000","0xd79835e404fb86bf845fba090d6ba25e0c8866a6":"2400000000000000000000","0xa8e7201ff619faffc332e6ad37ed41e301bf014a":"600000000000000000000","0x286906b6bd4972e3c71655e04baf36260c7cb153":"340000000000000000000","0xdb4bc83b0e6baadb1156c5cf06e0f721808c52c7":"880000000000000000000","0xa158148a2e0f3e92dc2ce38febc20107e3253c96":"2000000000000000000000","0x9f6a322a6d469981426ae844865d7ee0bb15c7b3":"50003000000000000000","0x32f29e8727a74c6b4301e3ffff0687c1b870dae9":"1000000000000000000000","0x19918aa09e7d494e98ffa5db50350892f7156ac6":"10000000000000000000000","0x5a5f8508da0ebebb90be9033bd4d9e274105ae00":"6685000000000000000000","0x6fc25e7e00ca4f60a9fe6f28d1fde3542e2d1079":"792000000000000000000","0x72094f3951ffc9771dced23ada080bcaf9c7cca7":"6000000000000000000000","0x43f7e86e381ec51ec4906d1476cba97a3db584e4":"1000000000000000000000","0x05696b73916bd3033e05521e3211dfec026e98e4":"2000000000000000000000","0x5e7f70378775589fc66a81d3f653e954f55560eb":"2434000000000000000000","0x895613236f3584216ad75c5d3e07e3fa6863a778":"2000000000000000000000","0x4eb1454b573805c8aca37edec7149a41f61202f4":"300000000000000000000","0xd99999a2490d9494a530cae4daf38554f4dd633e":"120000000000000000000","0x1704cefcfb1331ec7a78388b29393e85c1af7916":"400000000000000000000","0xac4acfc36ed6094a27e118ecc911cd473e8fb91f":"1799800000000000000000","0xa975b077fcb4cc8efcbf838459b6fa243a4159d6":"40000000000000000000","0x9c405cf697956138065e11c5f7559e67245bd1a5":"200000000000000000000","0xcafde855864c2598da3cafc05ad98df2898e8048":"14179272000000000000000","0x8ef711e43a13918f1303e81d0ea78c9eefd67eb2":"4000000000000000000000","0x0b14891999a65c9ef73308efe3100ca1b20e8192":"800000000000000000000","0x47cf9cdaf92fc999cc5efbb7203c61e4f1cdd4c3":"131400000000000000000","0x04ba8a3f03f08b895095994dda619edaacee3e7a":"2000000000000000000000","0x02b6d65cb00b7b36e1fb5ed3632c4cb20a894130":"20000000000000000000000","0xf99aee444b5783c093cfffd1c4632cf93c6f050c":"400000000000000000000","0x2541314a0b408e95a694444977712a50713591ab":"1634706000000000000000","0x3096dca34108085bcf04ae72b94574a13e1a3e1d":"200000000000000000000","0x56df05bad46c3f00ae476ecf017bb8c877383ff1":"197248000000000000000","0x6d59b21cd0e2748804d9abe064eac2bef0c95f27":"2000000000000000000000","0xb29f5b7c1930d9f97a115e067066f0b54db44b3b":"1000000000000000000000","0x888c16144933197cac26504dd76e06fd6600c789":"100000000000000000000","0xdfe3c52a92c30396a4e33a50170dc900fcf8c9cf":"50000000000000000000","0xf76f69cee4faa0a63b30ae1e7881f4f715657010":"200000000000000000000","0xee0007b0960d00908a94432a737557876aac7c31":"53053000000000000000","0xeffc15e487b1beda0a8d1325bdb4172240dc540a":"64940000000000000000","0x40ab0a3e83d0c8ac9366910520eab1772bac3b1a":"976600000000000000000","0x1895a0eb4a4372722fcbc5afe6936f289c88a419":"910000000000000000000","0x81efe296ae76c860d1c5fbd33d47e8ce9996d157":"1000000000000000000000","0x9ddd355e634ee9927e4b7f6c97e7bf3a2f1e687a":"50000000000000000000","0xf2b4ab2c9427a9015ef6eefff5edb60139b719d1":"716800000000000000000","0x765be2e12f629e6349b97d21b62a17b7c830edab":"6000000000000000000000","0xff61c9c1b7a3d8b53bba20b34466544b7b216644":"2000000000000000000000","0x36a08fd6fd1ac17ce15ed57eefb12a2be28188bf":"1337000000000000000000","0x17049311101d817efb1d65910f663662a699c98c":"1999800000000000000000","0x30511832918d8034a7bee72ef2bfee440ecbbcf6":"16100000000000000000000","0xd27c234ff7accace3d996708f8f9b04970f97d36":"1337000000000000000000","0xa961171f5342b173dd70e7bfe5b5ca238b13bcdd":"3397053000000000000000","0x30bf61b2d877fe10635126326fa189e4b0b1c3b0":"1027580000000000000000","0x4bb6d86b8314c22d8d37ea516d0019f156aae12d":"1000000000000000000000","0x5f363e0ab747e02d1b3b66abb69ea53c7baf523a":"11640000000000000000000","0x283e11203749b1fa4f32febb71e49d135919382a":"1000000000000000000000","0xac5999a89d2dd286d5a80c6dee7e86aad40f9e12":"3880000000000000000000","0x3f6dd3650ee428dcb7759553b017a96a94286ac9":"1337000000000000000000","0xb3fc1d6881abfcb8becc0bb021b8b73b7233dd91":"50000000000000000000","0xf0832a6bb25503eeca435be31b0bf905ca1fcf57":"6685000000000000000000","0x9d7fda7070bf3ee9bbd9a41f55cad4854ae6c22c":"11027380000000000000000","0x4b0bd8acfcbc53a6010b40d4d08ddd2d9d69622d":"668500000000000000000","0xf3b668b3f14d920ebc379092db98031b67b219b3":"199955000000000000000","0xd91d889164479ce436ece51763e22cda19b22d6b":"3365200000000000000000","0xffe28db53c9044b4ecd4053fd1b4b10d7056c688":"100000000000000000000","0xc77b01a6e911fa988d01a3ab33646beef9c138f3":"721400000000000000000","0xc0064f1d9474ab915d56906c9fb320a2c7098c9b":"358000000000000000000","0x4e3edad4864dab64cae4c5417a76774053dc6432":"590943000000000000000","0x71d2cc6d02578c65f73c575e76ce8fbcfadcf356":"72400000000000000000","0x9971df60f0ae66dce9e8c84e17149f09f9c52f64":"200000000000000000000","0x58e661d0ba73d6cf24099a5562b808f7b3673b68":"2000000000000000000000","0x84b0ee6bb837d3a4c4c5011c3a228c0edab4634a":"20000000000000000000","0x84375afbf59b3a1d61a1be32d075e0e15a4fbca5":"200000000000000000000","0x9ae9476bfecd3591964dd325cf8c2a24faed82c1":"4000000000000000000000","0x6a4c8907b600248057b1e46354b19bdc859c991a":"20000000000000000000","0x1c045649cd53dc23541f8ed4d341812808d5dd9c":"7000000000000000000000","0xc5e488cf2b5677933971f64cb8202dd05752a2c0":"1000000000000000000000","0xeb25481fcd9c221f1ac7e5fd1ecd9307a16215b8":"197000000000000000000","0xa61887818f914a20e31077290b83715a6b2d6ef9":"1880000000000000000000","0x679437eacf437878dc293d48a39c87b7421a216c":"64528000000000000000","0x331a1c26cc6994cdd3c14bece276ffff4b9df77c":"18049000000000000000","0x75b95696e8ec4510d56868a7c1a735c68b244890":"6400000000000000000000","0xa77f3ee19e9388bbbb2215c62397b96560132360":"200000000000000000000","0xbc7afc8477412274fc265df13c054473427d43c6":"130034000000000000000","0x91050a5cffadedb4bb6eaafbc9e5013428e96c80":"1700000000000000000000","0x24586ec5451735eeaaeb470dc8736aae752f82e5":"17600000000000000000","0x51039377eed0c573f986c5e8a95fb99a59e9330f":"1970000000000000000000","0xfbb161fe875f09290a4b262bc60110848f0d2226":"2000000000000000000000","0xed52a2cc0869dc9e9f842bd0957c47a8e9b0c9ff":"9550000000000000000000","0xbad235d5085dc7b068a67c412677b03e1836884c":"2000000000000000000000","0x055eac4f1ad3f58f0bd024d68ea60dbe01c6afb3":"100000000000000000000","0x4058808816fdaa3a5fc98ed47cfae6c18315422e":"199800000000000000000","0x3540c7bd7a8442d5bee21a2180a1c4edff1649e0":"1239295000000000000000","0xc5edbbd2ca0357654ad0ea4793f8c5cecd30e254":"6000000000000000000000","0xb5906b0ae9a28158e8ac550e39da086ee3157623":"200000000000000000000","0x4d801093c19ca9b8f342e33cc9c77bbd4c8312cf":"345005000000000000000","0x206482ee6f138a778fe1ad62b180ce856fbb23e6":"2000000000000000000000","0xc0ed0d4ad10de03435b153a0fc25de3b93f45204":"3160000000000000000000","0x29e67990e1b6d52e1055ffe049c53195a81542cf":"20000000000000000000000","0xe6d22209ffd0b87509ade3a8e2ef429879cb89b5":"17260000000000000000000","0xd6644d40e90bc97fe7dfe7cabd3269fd579ba4b3":"159000000000000000000","0xece1290877b583e361a2d41b009346e6274e2538":"300000000000000000000","0xab3861226ffec1289187fb84a08ec3ed043264e8":"1000000000000000000000","0x60e0bdd0a259bb9cb09d3f37e5cd8b9daceabf8a":"1370000000000000000000","0x28b77585cb3d55a199ab291d3a18c68fe89a848a":"1960000000000000000000","0x73128173489528012e76b41a5e28c68ba4e3a9d4":"1000000000000000000000","0x018492488ba1a292342247b31855a55905fef269":"140000000000000000000","0x0bb54c72fd6610bfa4363397e020384b022b0c49":"1337000000000000000000","0x520f66a0e2657ff0ac4195f2f064cf2fa4b24250":"40000000000000000000","0xa1432ed2c6b7777a88e8d46d388e70477f208ca5":"7999538000000000000000","0x149ba10f0da2725dc704733e87f5a524ca88515e":"7880000000000000000000","0xb287f7f8d8c3872c1b586bcd7d0aedbf7e732732":"20000000000000000000","0xc46bbdef76d4ca60d316c07f5d1a780e3b165f7e":"2000000000000000000000","0xb5a589dd9f4071dbb6fba89b3f5d5dae7d96c163":"2000000000000000000000","0xd218efb4db981cdd6a797f4bd48c7c26293ceb40":"2975000000000000000000","0xaf87d2371ef378957fbd05ba2f1d66931b01e2b8":"700000000000000000000","0x86ef6426211949cc37f4c75e7850369d0cf5f479":"13399196000000000000000","0xfb3a0b0d6b6a718f6fc0292a825dc9247a90a5d0":"199950000000000000000","0xda16dd5c3d1a2714358fe3752cae53dbab2be98c":"19400000000000000000000","0x9eb7834e171d41e069a77947fca87622f0ba4e48":"100000000000000000000","0xe1d91b0954cede221d6f24c7985fc59965fb98b8":"2000000000000000000000","0x85d0d88754ac84b8b21ba93dd2bfec72626faba8":"1000000000000000000000","0x695b4cce085856d9e1f9ff3e79942023359e5fbc":"5000000000000000000000","0x9156d18029350e470408f15f1aa3be9f040a67c6":"1000000000000000000000","0xa9d64b4f3bb7850722b58b478ba691375e224e42":"6000000000000000000000","0x17e4a0e52bac3ee44efe0954e753d4b85d644e05":"2000000000000000000000","0xb8a79c84945e47a9c3438683d6b5842cff7684b1":"2000000000000000000000","0xcfac2e1bf33205b05533691a02267ee19cd81836":"1000000000000000000000","0x6b992521ec852370848ad697cc2df64e63cc06ff":"1000000000000000000000","0x60af0ee118443c9b37d2fead77f5e521debe1573":"1910000000000000000000","0xc6dbdb9efd5ec1b3786e0671eb2279b253f215ed":"1000000000000000000000","0x659c0a72c767a3a65ced0e1ca885a4c51fd9b779":"2000000000000000000000","0xed1276513b6fc68628a74185c2e20cbbca7817bf":"191000000000000000000","0x5ad12c5ed4fa827e2150cfa0d68c0aa37b1769b8":"800000000000000000000","0x17c0fef6986cfb2e4041f9979d9940b69dff3de2":"4000000000000000000000","0xca98c7988efa08e925ef9c9945520326e9f43b99":"4000000000000000000000","0xfe8f1fdcab7fbec9a6a3fcc507619600505c36a3":"19700000000000000000","0x4420aa35465be617ad2498f370de0a3cc4d230af":"2000000000000000000000","0x8232d1f9742edf8dd927da353b2ae7b4cbce7592":"668500000000000000000","0xeca5f58792b8c62d2af556717ee3ee3028be4dce":"2000000000000000000000","0x6bf86f1e2f2b8032a95c4d7738a109d3d0ed8104":"1820000000000000000000","0x3ac2f0ff1612e4a1c346d53382abf6d8a25baa53":"2000000000000000000000","0xdaa1bd7a9148fb865cd612dd35f162861d0f3bdc":"3066243000000000000000","0x5169c60aee4ceed1849ab36d664cff97061e8ea8":"3000000000000000000000","0x2a5e3a40d2cd0325766de73a3d671896b362c73b":"100000000000000000000000","0xa83382b6e15267974a8550b98f7176c1a353f9be":"3541608000000000000000","0xb50c149a1906fad2786ffb135aab501737e9e56f":"388000000000000000000","0xd9775965b716476675a8d513eb14bbf7b07cd14a":"5076200000000000000000","0x66662006015c1f8e3ccfcaebc8ee6807ee196303":"500024000000000000000","0x78746a958dced4c764f876508c414a68342cecb9":"50600000000000000000","0xe982e6f28c548f5f96f45e63f7ab708724f53fa1":"396238000000000000000","0x740bfd52e01667a3419b029a1b8e45576a86a2db":"16800000000000000000000","0x2bd252e0d732ff1d7c78f0a02e6cb25423cf1b1a":"2674000000000000000000","0x2e2d7ea66b9f47d8cc52c01c52b6e191bc7d4786":"3999800000000000000000","0x3e3161f1ea2fbf126e79da1801da9512b37988c9":"49250000000000000000000","0x7e2ba86da52e785d8625334f3397ba1c4bf2e8d1":"197000000000000000000","0x7608f437b31f18bc0b64d381ae86fd978ed7b31f":"50000000000000000000","0x25a5a44d38a2f44c6a9db9cdbc6b1e2e97abb509":"17000000000000000000000","0x745ad3abc6eeeb2471689b539e789ce2b8268306":"1129977000000000000000","0x09e437d448861228a232b62ee8d37965a904ed9c":"21708305000000000000000","0xbe53322f43fbb58494d7cce19dda272b2450e827":"200018000000000000000","0x4166fc08ca85f766fde831460e9dc93c0e21aa6c":"1000000000000000000000","0x99c0174cf84e0783c220b4eb6ae18fe703854ad3":"2074800000000000000000","0x3cf484524fbdfadae26dc185e32b2b630fd2e726":"448798000000000000000","0xfdcd5d80b105897a57abc47865768b2900524295":"6400000000000000000000","0xf22f4078febbbaa8b0e78e642c8a42f35d433905":"1999944000000000000000","0xeac768bf14b8f9432e69eaa82a99fbeb94cd0c9c":"98500000000000000000000","0x2639eee9873ceec26fcc9454b548b9e7c54aa65c":"1000000000000000000000","0xc3c3c2510d678020485a63735d1307ec4ca6302b":"1000000000000000000000","0xb73d6a77559c86cf6574242903394bacf96e3570":"91200000000000000000","0x5ce2e7ceaaa18af0f8aafa7fbad74cc89e3cd436":"20000000000000000000000","0x03377c0e556b640103289a6189e1aeae63493467":"20000000000000000000000","0x6eb0a5a9ae96d22cf01d8fd6483b9f38f08c2c8b":"4000000000000000000000","0xfc8215a0a69913f62a43bf1c8590b9ddcd0d8ddb":"2000000000000000000000","0x4a835c25824c47ecbfc79439bf3f5c3481aa75cd":"1400000000000000000000","0xb5493ef173724445cf345c035d279ba759f28d51":"20000000000000000000","0xb9e90c1192b3d5d3e3ab0700f1bf655f5dd4347a":"499928000000000000000","0x419bde7316cc1ed295c885ace342c79bf7ee33ea":"6000000000000000000000","0xe4625501f52b7af52b19ed612e9d54fdd006b492":"209440000000000000000","0xe9d599456b2543e6db80ea9b210e908026e2146e":"200000000000000000000","0x2c06dd922b61514aafedd84488c0c28e6dcf0e99":"100000000000000000000000","0x06b5ede6fdf1d6e9a34721379aeaa17c713dd82a":"2000000000000000000000","0xd8930a39c77357c30ad3a060f00b06046331fd62":"820000000000000000000","0xb2a2c2111612fb8bbb8e7dd9378d67f1a384f050":"20000000000000000000","0x1f174f40a0447234e66653914d75bc003e5690dc":"160000000000000000000","0xe06cb6294704eea7437c2fc3d30773b7bf38889a":"20094000000000000000","0xcd06f8c1b5cdbd28e2d96b6346c3e85a0483ba24":"1000000000000000000000","0xf316ef1df2ff4d6c1808dba663ec8093697968e0":"1794400000000000000000","0x1e6915ebd9a19c81b692ad99b1218a592c1ac7b1":"4000000000000000000000","0x885493bda36a0432976546c1ddce71c3f4570021":"216700000000000000000","0x18b0407cdad4ce52600623bd5e1f6a81ab61f026":"319489000000000000000","0x187d9f0c07f8eb74faaad15ebc7b80447417f782":"20000000000000000000","0x5d6ccf806738091042ad97a6e095fe8c36aa79c5":"188000000000000000000","0x53437fecf34ab9d435f4deb8ca181519e2592035":"188000000000000000000","0xfd1faa347b0fcc804c2da86c36d5f1d18b7087bb":"52380000000000000000","0x650cf67db060cce17568d5f2a423687c49647609":"100000000000000000000","0xbcd95ef962462b6edfa10fda87d72242fe3edb5c":"334133000000000000000","0x3b5e8b3c77f792decb7a8985df916efb490aac23":"2000000000000000000000","0xf13b083093ba564e2dc631568cf7540d9a0ec719":"1999944000000000000000","0x373c547e0cb5ce632e1c5ad66155720c01c40995":"4691588000000000000000","0x7313461208455455465445a459b06c3773b0eb30":"2000000000000000000000","0x441f37e8a029fd02482f289c49b5d06d00e408a4":"333333000000000000000","0xd30d4c43adcf55b2cb53d68323264134498d89ce":"1000000000000000000000","0xf648ea89c27525710172944e79edff847803b775":"100000000000000000000000","0x0c7f869f8e90d53fdc03e8b2819b016b9d18eb26":"20000000000000000000000","0xc71f92a3a54a7b8c2f5ea44305fccb84eee23148":"49980000000000000000","0x7988901331e387f713faceb9005cb9b65136eb14":"1970000000000000000000","0xe9a39a8bac0f01c349c64cedb69897f633234ed2":"3980000000000000000000","0xad2a5c00f923aaf21ab9f3fb066efa0a03de2fb2":"999996000000000000000","0xf25259a5c939cd25966c9b6303d3731c53ddbc4c":"200000000000000000000","0xd1682c2159018dc3d07f08240a8c606daf65f8e1":"200000000000000000000000","0xa99991cebd98d9c838c25f7a7416d9e244ca250d":"1000000000000000000000","0x5a285755391e914e58025faa48cc685f4fd4f5b8":"26000000000000000000000","0x4d24b7ac47d2f27de90974ba3de5ead203544bcd":"100000000000000000000","0x21b182f2da2b384493cf5f35f83d9d1ee14f2a21":"2000000000000000000000","0x31ab088966ecc7229258f6098fce68cf39b38485":"1000000000000000000000","0x4977a7939d0939689455ce2639d0ee5a4cd910ed":"1820000000000000000000","0x07af938c1237a27c9030094dcf240750246e3d2c":"500000000000000000000","0x4e2bfa4a466f82671b800eee426ad00c071ba170":"4000000000000000000000","0x107379d4c467464f235bc18e55938aad3e688ad7":"50000000000000000000","0xf7b29b82195c882dab7897c2ae95e77710f57875":"2199000000000000000000","0x56586391040c57eec6f5affd8cd4abde10b50acc":"4000000000000000000000","0xac608e2bac9dd20728d2947effbbbf900a9ce94b":"6000600000000000000000","0x48548b4ba62bcb2f0d34a88dc69a680e539cf046":"100084000000000000000","0x1665ab1739d71119ee6132abbd926a279fe67948":"100000000000000000000","0xaf4493e8521ca89d95f5267c1ab63f9f45411e1b":"200000000000000000000","0xbf6925c00751008440a6739a02bf2b6cdaab5e3a":"1000000000000000000000","0x3fe40fbd919aad2818df01ee4df46c46842ac539":"6000000000000000000000","0x455b9296921a74d1fc41617f43b8303e6f3ed76c":"4200000000000000000000","0x7086b4bde3e35d4aeb24b825f1a215f99d85f745":"1999800000000000000000","0xd4ee4919fb37f2bb970c3fff54aaf1f3dda6c03f":"40000000000000000000000","0xa4489a50ead5d5445a7bee4d2d5536c2a76c41f8":"200000000000000000000","0x505e4f7c275588c533a20ebd2ac13b409bbdea3c":"17600000000000000000","0x3bb53598cc20e2055dc553b049404ac9b7dd1e83":"615020000000000000000","0x52cd20403ba7eda6bc307a3d63b5911b817c1263":"20000000000000000000","0xa211da03cc0e31ecce5309998718515528a090df":"200000000000000000000","0xbcb422dc4dd2aae94abae95ea45dd1731bb6b0ba":"447500000000000000000","0xcbde9734b8e6aa538c291d6d7facedb0f338f857":"2000000000000000000000","0x171ca02a8b6d62bf4ca47e906914079861972cb2":"200000000000000000000","0xd40d0055fd9a38488aff923fd03d35ec46d711b3":"4999711000000000000000","0x3887192c7f705006b630091276b39ac680448d6b":"60000000000000000000","0x3f3c8e61e5604cef0605d436dd22accd862217fc":"1337000000000000000000","0x4258fd662fc4ce3295f0d4ed8f7bb1449600a0a9":"6719600000000000000000","0x4571de672b9904bad8743692c21c4fdcea4c2e01":"4000000000000000000000","0x5be045512a026e3f1cebfd5a7ec0cfc36f2dc16b":"120000000000000000000","0xd6300b3215b11de762ecde4b70b7927d01291582":"2000000000000000000000","0xf9e37447406c412197b2e2aebc001d6e30c98c60":"8346700000000000000000","0xbd047ff1e69cc6b29ad26497a9a6f27a903fc4dd":"865000000000000000000","0x23fa7eb51a48229598f97e762be0869652dffc66":"1000000000000000000000","0x6679aeecd87a57a73f3356811d2cf49d0c4d96dc":"600000000000000000000","0x23c55aeb5739876f0ac8d7ebea13be729685f000":"1337000000000000000000","0x757b65876dbf29bf911d4f0692a2c9beb1139808":"4124263000000000000000","0xe8fc36b0131ec120ac9e85afc10ce70b56d8b6ba":"200000000000000000000","0x1a89899cbebdbb64bb26a195a63c08491fcd9eee":"2000000000000000000000","0x6edf7f5283725c953ee64317f66188af1184b033":"8050000000000000000000","0x297385e88634465685c231a314a0d5dcd146af01":"1550000000000000000000","0x018f20a27b27ec441af723fd9099f2cbb79d6263":"2167000000000000000000","0xa5a4227f6cf98825c0d5baff5315752ccc1a1391":"10000000000000000000000","0x69517083e303d4fbb6c2114514215d69bc46a299":"100000000000000000000","0x1dab172effa6fbee534c94b17e794edac54f55f8":"1970000000000000000000","0xc6ee35934229693529dc41d9bb71a2496658b88e":"19700000000000000000000","0xa8ee1df5d44b128469e913569ef6ac81eeda4fc8":"500000000000000000000","0x35bd246865fab490ac087ac1f1d4f2c10d0cda03":"400000000000000000000","0x4bf8bf1d35a231315764fc8001809a949294fc49":"66850000000000000000","0xc70fa45576bf9c865f983893002c414926f61029":"400400000000000000000","0xfdeaac2acf1d138e19f2fc3f9fb74592e3ed818a":"668500000000000000000","0xbfbfbcb656c2992be8fcde8219fbc54aadd59f29":"9999924000000000000000","0x1722c4cbe70a94b6559d425084caeed4d6e66e21":"4000000000000000000000","0x00e681bc2d10db62de85848324492250348e90bf":"20000000000000000000000","0x5c308bac4857d33baea074f3956d3621d9fa28e1":"4999711000000000000000","0x68c08490c89bf0d6b6f320b1aca95c8312c00608":"4000000000000000000000","0xce1884ddbbb8e10e4dba6e44feeec2a7e5f92f05":"4000000000000000000000","0x427417bd16b1b3d22dbb902d8f9657016f24a61c":"2000000000000000000000","0x5ff93de6ee054cad459b2d5eb0f6870389dfcb74":"220000000000000000000","0x71946b7117fc915ed107385f42d99ddac63249c2":"2000000000000000000000","0x11ec00f849b6319cf51aa8dd8f66b35529c0be77":"2000000000000000000000","0x610fd6ee4eebab10a8c55d0b4bd2e7d6ef817156":"20002000000000000000","0xa422e4bf0bf74147cc895bed8f16d3cef3426154":"349281000000000000000","0x745aecbaf9bb39b74a67ea1ce623de368481baa6":"10000000000000000000000","0x9f496cb2069563144d0811677ba0e4713a0a4143":"1122000000000000000000","0xc500b720734ed22938d78c5e48b2ba9367a575ba":"33400000000000000000000","0xcd072e6e1833137995196d7bb1725fef8761f655":"6000000000000000000000","0x94644ad116a41ce2ca7fbec609bdef738a2ac7c7":"5000000000000000000000","0xe8d942d82f175ecb1c16a405b10143b3f46b963a":"568600000000000000000","0xf73dd9c142b71bce11d06e30e7e7d032f2ec9c9e":"1970000000000000000000","0x1327d759d56e0ab87af37ecf63fe01f310be100a":"659200000000000000000","0x28fa2580f9ebe420f3e5eefdd371638e3b7af499":"6000000000000000000000","0x024bdd2c7bfd500ee7404f7fb3e9fb31dd20fbd1":"180000000000000000000","0xb4b14bf45455d0ab0803358b7524a72be1a2045b":"500000000000000000000","0xb1e2dd95e39ae9775c55aeb13f12c2fa233053ba":"2000000000000000000000","0x35b03ea4245736f57b85d2eb79628f036ddcd705":"4000000000000000000000","0xeb2ef3d38fe652403cd4c9d85ed7f0682cd7c2de":"42784000000000000000000","0x690594d306613cd3e2fd24bca9994ad98a3d73f8":"2000000000000000000000","0x8397a1bc47acd647418159b99cea57e1e6532d6e":"9169160000000000000000","0xb44815a0f28e569d0e921a4ade8fb2642526497a":"55500000000000000000","0xe24109be2f513d87498e926a286499754f9ed49e":"886500000000000000000","0x37ac29bda93f497bc4aeaab935452c431510341e":"985000000000000000000","0x4a81abe4984c7c6bef63d69820e55743c61f201c":"16011846000000000000000","0x66dcc5fb4ee7fee046e141819aa968799d644491":"1337000000000000000000","0x43ff38743ed0cd43308c066509cc8e7e72c862aa":"1940000000000000000000","0xb8f20005b61352ffa7699a1b52f01f5ab39167f1":"10000000000000000000000","0x1cda411bd5163baeca1e558563601ce720e24ee1":"18200000000000000000","0x86245f596691093ece3f3d3ca2263eace81941d9":"188000000000000000000","0xf52a5882e8927d944b359b26366ba2b9cacfbae8":"25000080000000000000000","0x118c18b2dce170e8f445753ba5d7513cb7636d2d":"8800000000000000000000","0x7168b3bb8c167321d9bdb023a6e9fd11afc9afd9":"1790000000000000000000","0xd9103bb6b67a55a7fece2d1af62d457c2178946d":"1000000000000000000000","0x8b9fda7d981fe9d64287f85c94d83f9074849fcc":"14000000000000000000000","0x91211712719f2b084d3b3875a85069f466363141":"1000000000000000000000","0x4863849739265a63b0a2bf236a5913e6f959ce15":"1520000000000000000000","0xc2d1778ef6ee5fe488c145f3586b6ebbe3fbb445":"1146000000000000000000","0x2b77a4d88c0d56a3dbe3bae04a05f4fcd1b757e1":"300000000000000000000","0xfe9c0fffefb803081256c0cf4d6659e6d33eb4fb":"1528000000000000000000","0x893017ff1adad499aa065401b4236ce6e92b625a":"1999944000000000000000","0x073c67e09b5c713c5221c8a0c7f3f74466c347b0":"19400000000000000000000","0x93e303411afaf6c107a44101c9ac5b36e9d6538b":"66000000000000000000000","0x0ec50aa823f465b9464b0bc0c4a57724a555f5d6":"59100000000000000000000","0xa3e3a6ea509573e21bd0239ece0523a7b7d89b2f":"1970000000000000000000","0xc069ef0eb34299abd2e32dabc47944b272334824":"120000000000000000000","0x28a3da09a8194819ae199f2e6d9d1304817e28a5":"2000000000000000000000","0xe9495ba5842728c0ed97be37d0e422b98d69202c":"2000000000000000000000","0xbba976f1a1215f7512871892d45f7048acd356c8":"2000000000000000000000","0x887cac41cd706f3345f2d34ac34e01752a6e5909":"595366000000000000000","0xe0e0b2e29dde73af75987ee4446c829a189c95bc":"149000000000000000000","0x4a5fae3b0372c230c125d6d470140337ab915656":"1600000000000000000000","0x425177eb74ad0a9d9a5752228147ee6d6356a6e6":"13370000000000000000","0x5db7bba1f9573f24115d8c8c62e9ce8895068e9f":"49984000000000000000","0xfa6a37f018e97967937fc5e8617ba1d786dd5f77":"19999800000000000000000","0x45e3a93e72144ada860cbc56ff85145ada38c6da":"1610000000000000000000","0x67da922effa472a6b124e84ea8f86b24e0f515aa":"20000000000000000000","0xaa9bd4589535db27fa2bc903ca17d679dd654806":"2000000000000000000000","0x16a9e9b73ae98b864d1728798b8766dbc6ea8d12":"957480000000000000000","0xd6580ab5ed4c7dfa506fa6fe64ad5ce129707732":"4000000000000000000000","0x984a7985e3cc7eb5c93691f6f8cc7b8f245d01b2":"6000000000000000000000","0x7746b6c6699c8f34ca2768a820f1ffa4c207fe05":"4000086000000000000000","0x2fa491fb5920a6574ebd289f39c1b2430d2d9a6a":"2000000000000000000000","0xfae76719d97eac41870428e940279d97dd57b2f6":"98500000000000000000000","0x41b2dbd79dda9b864f6a7030275419c39d3efd3b":"3200000000000000000000","0xdd8254121a6e942fc90828f2431f511dad7f32e6":"3018000000000000000000","0x37fac1e6bc122e936dfb84de0c4bef6e0d60c2d7":"2000000000000000000000","0x3a10888b7e149cae272c01302c327d0af01a0b24":"17000000000000000000","0x401354a297952fa972ad383ca07a0a2811d74a71":"14000000000000000000","0x51865db148881951f51251710e82b9be0d7eadb2":"2000000000000000000000","0xbbbd6ecbb5752891b4ceb3cce73a8f477059376f":"36000000000000000000","0x3f236108eec72289bac3a65cd283f95e041d144c":"999925000000000000000","0xdc83b6fd0d512131204707eaf72ea0c8c9bef976":"2000000000000000000000","0x036eeff5ba90a6879a14dff4c5043b18ca0460c9":"100000000000000000000","0xfac5ca94758078fbfccd19db3558da7ee8a0a768":"1017500000000000000000","0xd0d62c47ea60fb90a3639209bbfdd4d933991cc6":"194000000000000000000","0x891cb8238c88e93a1bcf61db49bd82b47a7f4f84":"2680000000000000000000","0xdf53003346d65c5e7a646bc034f2b7d32fcbe56a":"2000000000000000000000","0x6e89c51ea6de13e06cdc748b67c4410fe9bcab03":"4000000000000000000000","0xa61cdbadf04b1e54c883de6005fcdf16beb8eb2f":"2000000000000000000000","0xe3951de5aefaf0458768d774c254f7157735e505":"1600930000000000000000","0xf2732cf2c13b8bb8e7492a988f5f89e38273ddc8":"600000000000000000000","0x4752218e54de423f86c0501933917aea08c8fed5":"20000000000000000000000","0x152f4e860ef3ee806a502777a1b8dbc91a907668":"600000000000000000000","0x15b96f30c23b8664e7490651066b00c4391fbf84":"410650000000000000000","0x8693e9b8be94425eef7969bc69f9d42f7cad671e":"1000090000000000000000","0xf41557dfdfb1a1bdcefefe2eba1e21fe0a4a9942":"1970000000000000000000","0x38458e0685573cb4d28f53098829904570179266":"40000000000000000000","0x53e4d9696dcb3f4d7b3f70dcaa4eecb71782ff5c":"200000000000000000000","0x2dca0e449ab646dbdfd393a96662960bcab5ae1e":"40000000000000000000000","0x87d7ac0653ccc67aa9c3469eef4352193f7dbb86":"200000000000000000000000","0xae9f5c3fbbe0c9bcbf1af8ff74ea280b3a5d8b08":"1730000000000000000000","0x7751f363a0a7fd0533190809ddaf9340d8d11291":"20000000000000000000","0x708a2af425ceb01e87ffc1be54c0f532b20eacd6":"134159000000000000000","0xac122a03cd058c122e5fe17b872f4877f9df9572":"1969606000000000000000","0x5da4ca88935c27f55c311048840e589e04a8a049":"80000000000000000000","0xe67c2c1665c88338688187629f49e99b60b2d3ba":"200000000000000000000","0xdec82373ade8ebcf2acb6f8bc2414dd7abb70d77":"200000000000000000000","0x47c247f53b9fbeb17bba0703a00c009fdb0f6eae":"20000000000000000000000","0x9a522e52c195bfb7cf5ffaaedb91a3ba7468161d":"1000000000000000000000","0x3159e90c48a915904adfe292b22fa5fd5e72796b":"1008800000000000000000","0xdefddfd59b8d2c154eecf5c7c167bf0ba2905d3e":"93588000000000000000","0xad1d68a038fd2586067ef6d135d9628e79c2c924":"4686168000000000000000","0x038e45eadd3d88b87fe4dab066680522f0dfc8f9":"10000000000000000000000","0x2561ec0f379218fe5ed4e028a3f744aa41754c72":"13370000000000000000","0xb95396daaa490df2569324fcc6623be052f132ca":"2000000000000000000000","0x2376ada90333b1d181084c97e645e810aa5b76f1":"750000000000000000000","0x07800d2f8068e448c79a4f69b1f15ef682aae5f6":"19400000000000000000000","0xadeb204aa0c38e179e81a94ed8b3e7d53047c26b":"608000000000000000000","0x0dc100b107011c7fc0a1339612a16ccec3285208":"2000000000000000000000","0xf0b1340b996f6f0bf0d9561c849caf7f4430befa":"100000000000000000000","0xe1443dbd95cc41237f613a48456988a04f683282":"4000086000000000000000","0xd3c6f1e0f50ec3d2a67e6bcd193ec7ae38f1657f":"6618150000000000000000","0xb68899e7610d4c93a23535bcc448945ba1666f1c":"200000000000000000000","0xa7253763cf4a75df92ca1e766dc4ee8a2745147b":"10740000000000000000000","0x75d67ce14e8d29e8c2ffe381917b930b1aff1a87":"3000000000000000000000","0x493d48bda015a9bfcf1603936eab68024ce551e0":"22528000000000000000","0x7ddd57165c87a2707f025dcfc2508c09834759bc":"1400000000000000000000","0xcff7f89a4d4219a38295251331568210ffc1c134":"1760000000000000000000","0x168d30e53fa681092b52e9bae15a0dcb41a8c9bb":"100000000000000000000","0x99b743d1d9eff90d9a1934b4db21d519d89b4a38":"100000000000000000000","0xa3d0b03cffbb269f796ac29d80bfb07dc7c6ad06":"2000000000000000000000","0x816d9772cf11399116cc1e72c26c6774c9edd739":"200000000000000000000","0xa880e2a8bf88a1a82648b4013c49c4594c433cc8":"4728000000000000000000","0x2a44a7218fe44d65a1b4b7a7d9b1c2c52c8c3e34":"62221355000000000000000","0xcb86edbc8bbb1f9131022be649565ebdb09e32a1":"2000000000000000000000","0x3915eab5ab2e5977d075dec47d96b68b4b5cf515":"61520000000000000000000","0x8165cab0eafb5a328fc41ac64dae715b2eef2c65":"1000000000000000000000","0x416c86b72083d1f8907d84efd2d2d783dffa3efb":"1999944000000000000000","0xc524086d46c8112b128b2faf6f7c7d8160a8386c":"400000000000000000000","0x902d74a157f7d2b9a3378b1f56703730e03a1719":"4000000000000000000000","0x74ef2869cbe608856045d8c2041118579f2236ea":"59724000000000000000","0xaf992dd669c0883e5515d3f3112a13f617a4c367":"2000000000000000000000","0x4c6a248fc97d705def495ca20759169ef0d36471":"760000000000000000000","0x974d2f17895f2902049deaaecf09c3046507402d":"14707000000000000000","0x0239b4f21f8e05cd01512b2be7a0e18a6d974607":"1000000000000000000000","0xb97a6733cd5fe99864b3b33460d1672434d5cafd":"1999579000000000000000","0xf558a2b2dd26dd9593aae04531fd3c3cc3854b67":"198000000000000000000","0xb577b6befa054e9c040461855094b002d7f57bd7":"114000000000000000000000","0x73bfe7710f31cab949b7a2604fbf5239cee79015":"2000000000000000000000","0x5717f2d8f18ffcc0e5fe247d3a4219037c3a649c":"3998000000000000000000","0x20707e425d2a11d2c89f391b2b809f556c592421":"2000000000000000000000","0x9a6708ddb8903c289f83fe889c1edcd61f854423":"1000000000000000000000","0xfa27cc49d00b6c987336a875ae39da58fb041b2e":"10000000000000000000000","0xd688e785c98f00f84b3aa1533355c7a258e87948":"500000000000000000000","0x927cb7dc187036b5427bc7e200c5ec450c1d27d4":"216000000000000000000","0xb2bfaa58b5196c5cb7f89de15f479d1838de713d":"21000000000000000000","0xe180de9e86f57bafacd7904f9826b6b4b26337a3":"830400000000000000000","0xa1204dad5f560728a35c0d8fc79481057bf77386":"1000000000000000000000","0x6b0da25af267d7836c226bcae8d872d2ce52c941":"6000000000000000000000","0x0517448dada761cc5ba4033ee881c83037036400":"1998000000000000000000","0x7ed0a5a847bef9a9da7cba1d6411f5c316312619":"39842000000000000000","0x5b5d517029321562111b43086d0b043591109a70":"2600000000000000000000","0x56fc1a7bad4047237ce116146296238e078f93ad":"178000000000000000000","0x6c5422fb4b14e6d98b6091fdec71f1f08640419d":"400000000000000000000","0x108fe8ee2a13da487b22c6ab6d582ea71064d98c":"399800000000000000000","0x0ad3e44d3c001fa290b393617030544108ac6eb9":"1969019000000000000000","0x25aee68d09afb71d8817f3f184ec562f7897b734":"2000000000000000000000","0xc2340a4ca94c9678b7494c3c852528ede5ee529f":"48669000000000000000","0x44901e0d0e08ac3d5e95b8ec9d5e0ff5f12e0393":"417500000000000000000","0x8775a610c502b9f1e6ad4cdadb8ce29bff75f6e4":"600000000000000000000","0x682897bc4f8e89029120fcffb787c01a93e64184":"10000000000000000000000","0xf7acff934b84da0969dc37a8fcf643b7d7fbed41":"1999944000000000000000","0xf05fcd4c0d73aa167e5553c8c0d6d4f2faa39757":"13334000000000000000000","0xc981d312d287d558871edd973abb76b979e5c35e":"1970000000000000000000","0x9da61ccd62bf860656e0325d7157e2f160d93bb5":"4999980000000000000000","0xd284a50382f83a616d39b8a9c0f396e0ebbfa95d":"1000070000000000000000","0xd6cf5c1bcf9da662bcea2255905099f9d6e84dcc":"8349332000000000000000","0xc71b2a3d7135d2a85fb5a571dcbe695e13fc43cd":"1000000000000000000000","0xb22dadd7e1e05232a93237baed98e0df92b1869e":"2000000000000000000000","0xb09fe6d4349b99bc37938054022d54fca366f7af":"200000000000000000000000","0x427e4751c3babe78cff8830886febc10f9908d74":"1970000000000000000000","0x60b358cb3dbefa37f47df2d7365840da8e3bc98c":"20000000000000000000","0xdcd5bca2005395b675fde5035659b26bfefc49ee":"197000000000000000000","0x81186931184137d1192ac88cd3e1e5d0fdb86a74":"2900000000000000000000","0xde212293f8f1d231fa10e609470d512cb8ffc512":"2000000000000000000000","0x1937c5c515057553ccbd46d5866455ce66290284":"1000000000000000000000000","0x592777261e3bd852c48eca95b3a44c5b7f2d422c":"20000000000000000000000","0xbbf84292d954acd9e4072fb860b1504106e077ae":"1500000000000000000000","0x3b4100e30a73b0c734b18ffa8426d19b19312f1a":"55300000000000000000000","0xa03a3dc7c533d1744295be955d61af3f52b51af5":"40000000000000000000","0x4aa148c2c33401e66a2b586e6577c4b292d3f240":"216200000000000000000","0xff850e3be1eb6a4d726c08fa73aad358f39706da":"1940000000000000000000","0x743651b55ef8429df50cf81938c2508de5c8870f":"2000000000000000000000","0x3700e3027424d939dbde5d42fb78f6c4dbec1a8f":"40000000000000000000","0xc1cbd2e2332a524cf219b10d871ccc20af1fb0fa":"1000000000000000000000","0xe25b9f76b8ad023f057eb11ad94257a0862e4e8c":"2000000000000000000000","0x719e891fbcc0a33e19c12dc0f02039ca05b801df":"6185800000000000000000","0x39636b25811b176abfcfeeca64bc87452f1fdff4":"400000000000000000000","0x631030a5b27b07288a45696f189e1114f12a81c0":"499970000000000000000","0xbcc84597b91e73d5c5b4d69c80ecf146860f779a":"4380000000000000000000","0x095e0174829f34c3781be1a5e38d1541ea439b7f":"6000000000000000000000","0x2e7e05e29edda7e4ae25c5173543efd71f6d3d80":"6000000000000000000000","0xdbb6ac484027041642bbfd8d80f9d0c1cf33c1eb":"2000000000000000000000","0x153c08aa8b96a611ef63c0253e2a4334829e579d":"394000000000000000000","0x10f4bff0caa5027c0a6a2dcfc952824de2940909":"2000000000000000000000","0x2ef869f0350b57d53478d701e3fee529bc911c75":"50000000000000000000","0x70ab34bc17b66f9c3b63f151274f2a727c539263":"2000000000000000000000","0x3201259caf734ad7581c561051ba0bca7fd6946b":"180000000000000000000000","0x84e9cf8166c36abfa49053b7a1ad4036202681ef":"2000000000000000000000","0x4ebc5629f9a6a66b2cf3363ac4895c0348e8bf87":"1000090000000000000000","0xe50b464ac9de35a5618b7cbf254674182b81b97e":"4100000000000000000000","0x2abdf1a637ef6c42a7e2fe217773d677e804ebdd":"5000000000000000000000","0x7a0a78a9cc393f91c3d9e39a6b8c069f075e6bf5":"1337000000000000000000","0x2d9c5fecd2b44fbb6a1ec732ea059f4f1f9d2b5c":"1010694000000000000000","0x7b712c7af11676006a66d2fc5c1ab4c479ce6037":"8000000000000000000000","0x3466f67e39636c01f43b3a21a0e8529325c08624":"842864000000000000000","0xfdd502a74e813bcfa355ceda3c176f6a6871af7f":"400000000000000000000","0x26475419c06d5f147aa597248eb46cf7befa64a5":"1640000000000000000000","0x9243d7762d77287b12638688b9854e88a769b271":"1000000000000000000000","0x723d8baa2551d2addc43c21b45e8af4ca2bfb2c2":"1760000000000000000000","0xf2fbb6d887f8b8cc3a869aba847f3d1f643c53d6":"3999000000000000000000","0x2cdb3944650616e47cb182e060322fa1487978ce":"1820000000000000000000","0xf0d21663d8b0176e05fde1b90ef31f8530fda95f":"1999944000000000000000","0x77cc02f623a9cf98530997ea67d95c3b491859ae":"1354900000000000000000","0xd1b5a454ac3405bb4179208c6c84de006bcb9be9":"500000000000000000000","0xb9920fd0e2c735c256463caa240fb7ac86a93dfa":"1760000000000000000000","0xed1f1e115a0d60ce02fb25df014d289e3a0cbe7d":"500000000000000000000","0x23e2c6a8be8e0acfa5c4df5e36058bb7cbac5a81":"2000000000000000000000","0xf0be0faf4d7923fc444622d1980cf2d990aab307":"2000000000000000000000","0x0829d0f7bb7c446cfbb0deadb2394d9db7249a87":"40110000000000000000","0x2ecac504b233866eb5a4a99e7bd2901359e43b3d":"20000000000000000000000","0x06d6cb308481c336a6e1a225a912f6e6355940a1":"1760000000000000000000","0xd4879fd12b1f3a27f7e109761b23ca343c48e3d8":"666000000000000000000","0x857f100b1a5930225efc7e9020d78327b41c02cb":"2000000000000000000000","0x3aa42c21b9b31c3e27ccd17e099af679cdf56907":"8000000000000000000000","0x764d5212263aff4a2a14f031f04ec749dc883e45":"1850000000000000000000","0xd03a2da41e868ed3fef5745b96f5eca462ff6fda":"3000000000000000000000","0x4f26690c992b7a312ab12e1385d94acd58288e7b":"14000000000000000000000","0x7b122162c913e7146cad0b7ed37affc92a0bf27f":"1506799000000000000000","0xc87352dba582ee2066b9c002a962e003134f78b1":"500000000000000000000","0x9f4ac9c9e7e24cb2444a0454fa5b9ad9d92d3853":"835000000000000000000","0xccf62a663f1353ba2ef8e6521dc1ecb673ec8ef7":"152000000000000000000","0x557f5e65e0da33998219ad4e99570545b2a9d511":"11024000000000000000000","0xa5f0077b351f6c505cd515dfa6d2fa7f5c4cd287":"40000000000000000000000","0x79c6002f8452ca157f1317e80a2faf24475559b7":"20000000000000000000","0x3aa07a34a1afc8967d3d1383b96b62cf96d5fa90":"20000000000000000000000","0x7f389c12f3c6164f6446566c77669503c2792527":"98500000000000000000","0xac4cc256ae74d624ace80db078b2207f57198f6b":"2001000000000000000000","0x823ba7647238d113bce9964a43d0a098118bfe4d":"200000000000000000000","0xf5a7676ad148ae9c1ef8b6f5e5a0c2c473be850b":"200000000000000000000","0x7d34803569e00bd6b59fff081dfa5c0ab4197a62":"1712700000000000000000","0x061ea4877cd08944eb64c2966e9db8dedcfec06b":"1000000000000000000000","0xdf37c22e603aedb60a627253c47d8ba866f6d972":"24000000000000000000000","0x529aa002c6962a3a8545027fd8b05f22b5bf9564":"1670000000000000000000","0xeb89a882670909cf377e9e78286ee97ba78d46c2":"802200000000000000000","0x9ac85397792a69d78f286b86432a07aeceb60e64":"14300000000000000000","0x9610592202c282ab9bd8a884518b3e0bd4758137":"268000000000000000000","0x73932709a97f02c98e51b091312865122385ae8e":"1430000000000000000000","0x5ef8c96186b37984cbfe04c598406e3b0ac3171f":"9400000000000000000000","0xb6f78da4f4d041b3bc14bc5ba519a5ba0c32f128":"172326253000000000000000","0x6f0edd23bcd85f6015f9289c28841fe04c83efeb":"19100000000000000000","0xa8a43c009100616cb4ae4e033f1fc5d7e0b6f152":"3939015000000000000000","0x7081fa6baad6cfb7f51b2cca16fb8970991a64ba":"233953000000000000000","0x9de7386dde401ce4c67b71b6553f8aa34ea5a17d":"60000000000000000000","0x54ec7300b81ac84333ed1b033cd5d7a33972e234":"200000000000000000000","0x67a80e0190721f94390d6802729dd12c31a895ad":"1999964000000000000000","0x3a4297da3c555e46c073669d0478fce75f2f790e":"1969606000000000000000","0xc2e0584a71348cc314b73b2029b6230b92dbb116":"2000000000000000000000","0x0a2ade95b2e8c66d8ae6f0ba64ca57d783be6d44":"4000000000000000000000","0x544b5b351d1bc82e9297439948cf4861dac9ae11":"22000000000000000000000","0x3ae62bd271a760637fad79c31c94ff62b4cd12f7":"2000000000000000000000","0x0d8023929d917234ae40512b1aabb5e8a4512771":"148000000000000000000","0x2858acacaf21ea81cab7598fdbd86b452e9e8e15":"666000000000000000000","0xc033b1325a0af45472c25527853b1f1c21fa35de":"2000000000000000000000","0xbbf85aaaa683738f073baef44ac9dc34c4c779ea":"2000000000000000000000","0x6ae57f27917c562a132a4d1bf7ec0ac785832926":"6000000000000000000000","0x88e6f9b247f988f6c0fc14c56f1de53ec69d43cc":"100000000000000000000","0xb72c2a011c0df50fbb6e28b20ae1aad217886790":"4000000000000000000000","0x161caf5a972ace8379a6d0a04ae6e163fe21df2b":"100000000000000000000000","0x2a63590efe9986c3fee09b0a0a338b15bed91f21":"6458400000000000000000","0x50e1c8ec98415bef442618708799437b86e6c205":"6000000000000000000000","0x33f4a6471eb1bca6a9f85b3b4872e10755c82be1":"2000000000000000000000","0x9c49deff47085fc09704caa2dca8c287a9a137da":"8000000000000000000000","0xe1173a247d29d8238df0922f4df25a05f2af77c3":"40007051000000000000000","0x51891b2ccdd2f5a44b2a8bc49a5d9bca6477251c":"310000000000000000000","0xecaf3350b7ce144d068b186010852c84dd0ce0f0":"2000000000000000000000","0x72393d37b451effb9e1ff3b8552712e2a970d8c2":"985000000000000000000","0x1bbc60bcc80e5cdc35c5416a1f0a40a83dae867b":"2000000000000000000000","0xb8ab39805bd821184f6cbd3d2473347b12bf175c":"118200000000000000000","0xc55a6b4761fd11e8c85f15174d74767cd8bd9a68":"133700000000000000000","0x99d1b585965f406a42a49a1ca70f769e765a3f98":"16700000000000000000000","0x9ab988b505cfee1dbe9cd18e9b5473b9a2d4f536":"320000000000000000000","0x7fef8c38779fb307ec6f044bebe47f3cfae796f1":"168561000000000000000","0x322d6f9a140d213f4c80cd051afe25c620bf4c7d":"20000000000000000000","0x3bd9a06d1bd36c4edd27fc0d1f5b088ddae3c72a":"499970000000000000000","0x5dcdb6b87a503c6d8a3c65c2cf9a9aa883479a1e":"9200000000000000000000","0x6e84c2fd18d8095714a96817189ca21cca62bab1":"340935000000000000000","0xa5bad86509fbe0e0e3c0e93f6d381f1af6e9d481":"6000000000000000000000","0x3954bdfe0bf587c695a305d9244c3d5bdddac9bb":"19187461000000000000000","0x63f0e5a752f79f67124eed633ad3fd2705a397d4":"3940000000000000000000","0x33fd718f0b91b5cec88a5dc15eecf0ecefa4ef3d":"432500000000000000000","0x68027d19558ed7339a08aee8de3559be063ec2ea":"2000000000000000000000","0x96f0462ae6f8b96088f7e9c68c74b9d8ad34b347":"1790000000000000000000","0xf1f391ca92808817b755a8b8f4e2ca08d1fd1108":"6000000000000000000000","0x7fcf5ba6666f966c5448c17bf1cb0bbcd8019b06":"99999000000000000000","0xe9b9a2747510e310241d2ece98f56b3301d757e0":"2000000000000000000000","0x2100381d60a5b54adc09d19683a8f6d5bb4bfbcb":"10000000000000000000000","0x7495ae78c0d90261e2140ef2063104731a60d1ed":"34250000000000000000","0xdc911cf7dc5dd0813656670528e9338e67034786":"2000000000000000000000","0x262aed4bc0f4a4b2c6fb35793e835a49189cdfec":"10000000000000000000000","0x9ee93f339e6726ec65eea44f8a4bfe10da3d3282":"2000000000000000000000","0xa3a57b0716132804d60aac281197ff2b3d237b01":"1400000000000000000000","0xc799e34e88ff88be7de28e15e4f2a63d0b33c4cb":"200000000000000000000","0xc7506c1019121ff08a2c8c1591a65eb4bdfb4a3f":"600000000000000000000","0x795ebc2626fc39b0c86294e0e837dcf523553090":"1000000000000000000000","0x441aca82631324acbfa2468bda325bbd78477bbf":"6000000000000000000000","0x9f271d285500d73846b18f733e25dd8b4f5d4a8b":"722000000000000000000","0xd77892e2273b235d7689e430e7aeed9cbce8a1f3":"2000000000000000000000","0x4f8972838f70c903c9b6c6c46162e99d6216d451":"4610000000000000000000","0x4c85ed362f24f6b9f04cdfccd022ae535147cbb9":"1500000000000000000000","0x3807eff43aa97c76910a19752dd715ee0182d94e":"250190000000000000000","0x3a9e5441d44b243be55b75027a1ceb9eacf50df2":"1000000000000000000000","0x3deae43327913f62808faa1b6276a2bd6368ead9":"2000000000000000000000","0xc270456885342b640b4cfc1b520e1a544ee0d571":"1820000000000000000000","0x77798f201257b9c35204957057b54674aefa51df":"149000000000000000000","0x225f9eb3fb6ff3e9e3c8447e14a66e8d4f3779f6":"2000000000000000000000","0x78df2681d6d602e22142d54116dea15d454957aa":"298000000000000000000","0x283396ce3cac398bcbe7227f323e78ff96d08767":"400000000000000000000","0x747ff7943b71dc4dcdb1668078f83dd7cc4520c2":"60000000000000000000","0xa4ed11b072d89fb136759fc69b428c48aa5d4ced":"262800000000000000000","0xcc043c4388d345f884c6855e71142a9f41fd6935":"20000000000000000000","0xab14d221e33d544629198cd096ed63dfa28d9f47":"6000000000000000000000","0x251e6838f7cec5b383c1d90146341274daf8e502":"147510000000000000000","0x36a0e61e1be47fa87e30d32888ee0330901ca991":"20000000000000000000","0xbcfc98e5c82b6adb180a3fcb120b9a7690c86a3f":"1970000000000000000000","0x18a6d2fc52be73084023c91802f05bc24a4be09f":"2000000000000000000000","0x80591a42179f34e64d9df75dcd463b28686f5574":"20000000000000000000000","0x881230047c211d2d5b00d8de4c5139de5e3227c7":"10000000000000000000000","0x9eb1ff71798f28d6e989fa1ea0588e27ba86cb7d":"140800000000000000000","0xa01fd1906a908506dedae1e208128872b56ee792":"3000000000000000000000","0x1b05ea6a6ac8af7cb6a8b911a8cce8fe1a2acfc8":"2000000000000000000000","0x6add932193cd38494aa3f03aeccc4b7ab7fabca2":"89600000000000000000","0x2aaa35274d742546670b7426264521032af4f4c3":"10000000000000000000000","0x67b8a6e90fdf0a1cac441793301e8750a9fa7957":"895000000000000000000","0x5b5be0d8c67276baabd8edb30d48ea75640b8b29":"824480000000000000000","0x28d7e5866f1d85fd1ceb32bfbe1dfc36db434566":"7199000000000000000000","0x98e3e90b28fccaee828779b8d40a5568c4116e21":"40000000000000000000","0x2dd578f7407dfbd548d05e95ccc39c485429626a":"4200000000000000000000","0x8ca6989746b06e32e2487461b1ce996a273acfd7":"20000000000000000000","0xa6f93307f8bce03195fece872043e8a03f7bd11a":"2886000000000000000000","0xefbd52f97da5fd3a673a46cbf330447b7e8aad5c":"100033000000000000000","0x52bdd9af5978850bc24110718b3723759b437e59":"1730000000000000000000","0x6e073b66d1b8c66744d88096a8dd99ec7e0228da":"4000000000000000000000","0xa29d661a6376f66d0b74e2fe9d8f26c0247ec84c":"4117300000000000000000","0x7d34ff59ae840a7413c6ba4c5bb2ba2c75eab018":"3000000000000000000000","0x2eca6a3c5d9f449d0956bd43fa7b4d7be8435958":"2000020000000000000000","0xf59f9f02bbc98efe097eabb78210979021898bfd":"9999800000000000000000","0x90e300ac71451e401f887f6e7728851647a80e07":"400000000000000000000","0x05ae7fd4bbcc80ca11a90a1ec7a301f7cccc83db":"910000000000000000000","0xe54102534de8f23effb093b31242ad3b233facfd":"4000000000000000000000","0xc127aab59065a28644a56ba3f15e2eac13da2995":"600000000000000000000","0xed60c4ab6e540206317e35947a63a9ca6b03e2cb":"57275000000000000000","0xd855b03ccb029a7747b1f07303e0a664793539c8":"2000000000000000000000","0x1178501ff94add1c5881fe886136f6dfdbe61a94":"158000000000000000000","0xf447108b98df64b57e871033885c1ad71db1a3f9":"6916709000000000000000","0xdeee2689fa9006b59cf285237de53b3a7fd01438":"450034000000000000000","0x7f01dc7c3747ca608f983dfc8c9b39e755a3b914":"206980000000000000000","0x9edeac4c026b93054dc5b1d6610c6f3960f2ad73":"1200000000000000000000","0xe3cffe239c64e7e20388e622117391301b298696":"500000000000000000000","0xebbb4f2c3da8be3eb62d1ffb1f950261cf98ecda":"2000000000000000000000","0x38c10b90c859cbb7815692f99dae520ab5febf5e":"13169000000000000000000","0x23f9ecf3e5dddca38815d3e59ed34b5b90b4a353":"204608000000000000000","0xd7fa5ffb6048f96fb1aba09ef87b1c11dd7005e4":"1000000000000000000000","0x9ca42ee7a0b898f6a5cc60b5a5d7b1bfa3c33231":"2000000000000000000000","0x8b9577920053b1a00189304d888010d9ef2cb4bf":"500000000000000000000","0xfcd0b4827cd208ffbf5e759dba8c3cc61d8c2c3c":"8000000000000000000000","0x01ff1eb1dead50a7f2f9638fdee6eccf3a7b2ac8":"600000000000000000000","0xabde147b2af789eaa586547e66c4fa2664d328a4":"247545000000000000000","0x64042ba68b12d4c151651ca2813b7352bd56f08e":"600000000000000000000","0xdccca42045ec3e16508b603fd936e7fd7de5f36a":"19700000000000000000","0xe77a89bd45dc04eeb4e41d7b596b707e6e51e74c":"12000000000000000000000","0xf77c7b845149efba19e261bc7c75157908afa990":"2000000000000000000000","0xfa5201fe1342af11307b9142a041243ca92e2f09":"152150000000000000000000","0x40df495ecf3f8b4cef2a6c189957248fe884bc2b":"12000000000000000000000","0x3d79a853d71be0621b44e29759656ca075fdf409":"2000000000000000000000","0x6de02f2dd67efdb7393402fa9eaacbcf589d2e56":"1182000000000000000000","0x729aad4627744e53f5d66309aa74448b3acdf46f":"2000000000000000000000","0x4e4318f5e13e824a54edfe30a7ed4f26cd3da504":"2000000000000000000000","0xc6a286e065c85f3af74812ed8bd3a8ce5d25e21d":"18200000000000000000","0xfd686de53fa97f99639e2568549720bc588c9efc":"1969606000000000000000","0x06b0ff834073cce1cbc9ea557ea87b605963e8b4":"300000000000000000000","0x72b5633fe477fe542e742facfd690c137854f216":"1670000000000000000000","0x8bf373d076814cbc57e1c6d16a82c5be13c73d37":"200000000000000000000","0xcf264e6925130906c4d7c18591aa41b2a67f6f58":"2000000000000000000000","0x0ea2a210312b3e867ee0d1cc682ce1d666f18ed5":"10000000000000000000000","0xd02afecf8e2ec2b62ac8ad204161fd1fae771d0e":"2000000000000000000000","0xe6b20f980ad853ad04cbfc887ce6601c6be0b24c":"4000000000000000000000","0x4280a58f8bb10b9440de94f42b4f592120820191":"2000000000000000000000","0xa914cdb571bfd93d64da66a4e108ea134e50d000":"1430143000000000000000","0x60864236930d04d8402b5dcbeb807f3caf611ea2":"4000000000000000000000","0xf9dd239008182fb519fb30eedd2093fed1639be8":"500000000000000000000","0x18e53243981aabc8767da10c73449f1391560eaa":"6000000000000000000000","0xc3a9226ae275df2cab312b911040634a9c9c9ef6":"4000000000000000000000","0x4fcc19ea9f4c57dcbce893193cfb166aa914edc5":"7001380000000000000000","0xc1e1409ca52c25435134d006c2a6a8542dfb7273":"34380000000000000000","0x981ddf0404e4d22dda556a0726f00b2d98ab9569":"999972000000000000000","0xe5bcc88c3b256f6ed5fe550e4a18198b943356ad":"2000000000000000000000","0x74a17f064b344e84db6365da9591ff1628257643":"20000000000000000000","0x2720f9ca426ef2f2cbd2fecd39920c4f1a89e16d":"2000000000000000000000","0x8d04a5ebfb5db409db0617c9fa5631c192861f4a":"970000000000000000000","0xf18b14cbf6694336d0fe12ac1f25df2da0c05dbb":"3999800000000000000000","0x56ac20d63bd803595cec036da7ed1dc66e0a9e07":"63927000000000000000","0x92c94c2820dfcf7156e6f13088ece7958b3676fd":"95500000000000000000","0x968dea60df3e09ae3c8d3505e9c080454be0e819":"6000000000000000000000","0x9268d62646563611dc3b832a30aa2394c64613e3":"2000000000000000000000","0x5a192b964afd80773e5f5eda6a56f14e25e0c6f3":"500000000000000000000","0xdf8d48b1eb07b3c217790e6c2df04dc319e7e848":"500000000000000000000","0x7f61fa6cf5f898b440dac5abd8600d6d691fdef9":"280000000000000000000","0x929d368eb46a2d1fbdc8ffa0607ede4ba88f59ad":"2000000000000000000000","0x9982a5890ffb5406d3aca8d2bfc1dd70aaa80ae0":"2000000000000000000000","0xbf2aea5a1dcf6ed3b5e8323944e983fedfd1acfb":"1580000000000000000000","0x46aa501870677e7f0a504876b4e8801a0ad01c46":"800000000000000000000","0x8f473d0ab876ddaa15608621d7013e6ff714b675":"470400000000000000000","0x02290fb5f9a517f82845acdeca0fc846039be233":"2000000000000000000000","0x8a5831282ce14a657a730dc18826f7f9b99db968":"4330268000000000000000","0x0328510c09dbcd85194a98d67c33ac49f2f94d60":"11000000000000000000000","0xcf883a20329667ea226a1e3c765dbb6bab32219f":"3038972000000000000000","0x2615100ea7e25bba9bca746058afbbb4ffbe4244":"500000000000000000000","0xb115ee3ab7641e1aa6d000e41bfc1ec7210c2f32":"13000000000000000000000","0x5cfa8d568575658ca4c1a593ac4c5d0e44c60745":"291000000000000000000","0xd3c24d4b3a5e0ff8a4622d518edd73f16ab28610":"20000000000000000000","0xa639acd96b31ba53b0d08763229e1f06fd105e9d":"8000000000000000000000","0xffa4aff1a37f984b0a67272149273ae9bd41e3bc":"10000000000000000000000","0xcf684dfb8304729355b58315e8019b1aa2ad1bac":"432500000000000000000","0x5797b60fd2894ab3c2f4aede86daf2e788d745ad":"6000000000000000000000","0xa6a0de421ae54f6d17281308f5646d2f39f7775d":"2000000000000000000000","0x08504f05643fab5919f5eea55925d7a3ed7d807a":"20000000000000000000","0x7a7068e1c3375c0e599db1fbe6b2ea23b8f407d2":"2000000000000000000000","0x1078d7f61b0e56c74ee6635b2e1819ef1e3d8785":"1000000000000000000000","0x6e12b51e225b4a4372e59ad7a2a1a13ea3d3a137":"14172200000000000000000","0x6a2e86469a5bf37cee82e88b4c3863895d28fcaf":"519000000000000000000","0x197672fd39d6f246ce66a790d13aa922d70ea109":"1000000000000000000000","0x8009a7cbd192b3aed4adb983d5284552c16c7451":"4000000000000000000000","0xf6c3c48a1ac0a34799f04db86ec7a975fe7768f3":"1970000000000000000000","0x16be75e98a995a395222d00bd79ff4b6e638e191":"36000000000000000000000","0x6c05e34e5ef2f42ed09deff1026cd66bcb6960bb":"2000000000000000000000","0x5d6ae8cbd6b3393c22d16254100d0238e808147c":"719992000000000000000","0x1a376e1b2d2f590769bb858d4575320d4e149970":"4841200000000000000000","0xf6ead67dbf5b7eb13358e10f36189d53e643cfcf":"40000000000000000000000","0x467d5988249a68614716659840ed0ae6f6f457bc":"387500000000000000000","0xaa960e10c52391c54e15387cc67af827b5316dcc":"2000000000000000000000","0x483ba99034e900e3aedf61499d3b2bce39beb7aa":"985000000000000000000","0x86f23e9c0aafc78b9c404dcd60339a925bffa266":"400000000000000000000","0xd05a447c911dbb275bfb2e5a37e5a703a56f9997":"200000000000000000000","0xedb71ec41bda7dce86e766e6e8c3e9907723a69b":"20000000000000000000","0xf86a3ea8071f7095c7db8a05ae507a8929dbb876":"336000000000000000000","0x323b3cfe3ee62bbde2a261e53cb3ecc05810f2c6":"13790000000000000000000","0x936f3813f5f6a13b8e4ffec83fe7f826186a71cd":"520000000000000000000","0x6db72bfd43fef465ca5632b45aab7261404e13bf":"2000000000000000000000","0x9bb76204186af2f63be79168601687fc9bad661f":"300000000000000000000","0x28ab165ffb69eda0c549ae38e9826f5f7f92f853":"1296890000000000000000","0xc73e2112282215dc0762f32b7e807dcd1a7aae3e":"6900000000000000000000","0xf8086e42661ea929d2dda1ab6c748ce3055d111e":"1000000000000000000000","0x4db21284bcd4f787a7556500d6d7d8f36623cf35":"1939806000000000000000","0xc48651c1d9c16bff4c9554886c3f3f26431f6f68":"658000000000000000000","0x9bdbdc9b973431d13c89a3f9757e9b3b6275bfc7":"499971000000000000000","0x560da37e956d862f81a75fd580a7135c1b246352":"10000000000000000000000","0x4b60a3e253bf38c8d5662010bb93a473c965c3e5":"1490000000000000000000","0x64e02abb016cc23a2934f6bcddb681905021d563":"1000000000000000000000","0xac2c8e09d06493a63858437bd20be01962450365":"1910000000000000000000","0x9bf9b3b2f23cf461eb591f28340bc719931c8364":"1000000000000000000000","0x9b5c39f7e0ac168c8ed0ed340477117d1b682ee9":"98000000000000000000","0xf75bb39c799779ebc04a336d260da63146ed98d0":"25000000000000000000","0xa7966c489f4c748a7ae980aa27a574251767caf9":"3000000000000000000000","0xea53c954f4ed97fd4810111bdab69ef981ef25b9":"17300000000000000000000","0x03a26cfc4c18316f70d59e9e1a79ee3e8b962f4c":"2000000000000000000000","0x3e63ce3b24ca2865b4c5a687b7aea3597ef6e548":"2000000000000000000000","0x500c902958f6421594d1b6ded712490d52ed6c44":"1970000000000000000000","0x6f44ca09f0c6a8294cbd519cdc594ad42c67579f":"50000000000000000000","0x3616fb46c81578c9c8eb4d3bf880451a88379d7d":"200000000000000000000","0x57bc20e2d62b3d19663cdb4c309d5b4f2fc2db8f":"100000000000000000000","0x1cebf0985d7f680aaa915c44cc62edb49eab269e":"1000000000000000000000","0xc0cbf6032fa39e7c46ff778a94f7d445fe22cf30":"310000000000000000000","0xc58b9cc61dedbb98c33f224d271f0e228b583433":"3880000000000000000000","0xe9c6dfae97f7099fc5f4e94b784db802923a1419":"48800000000000000000","0x9bacd3d40f3b82ac91a264d9d88d908eac8664b9":"20000000000000000000000","0x63d80048877596e0c28489e650cd4ac180096a49":"280000000000000000000","0xe6a6f6dd6f70a456f4ec15ef7ad5e5dbb68bd7dc":"200000000000000000000","0xd418870bc2e4fa7b8a6121ae0872d55247b62501":"1580000000000000000000","0xe2f9383d5810ea7b43182b8704b62b27f5925d39":"400000000000000000000","0xbd5e473abce8f97a6932f77c2facaf9cc0a00514":"1117350000000000000000","0x2ff1ca55fd9cec1b1fe9f0a9abb74c513c1e2aaa":"3000000000000000000000","0x9d99b189bbd9a48fc2e16e8fcda33bb99a317bbb":"1126900000000000000000","0x6e96faeda3054302c45f58f161324c99a3eebb62":"20000000000000000000","0xef93818f684db0c3675ec81332b3183ecc28a495":"1550000000000000000000","0x2659facb1e83436553b5b42989adb8075f9953ed":"29356000000000000000","0xc4ffadaaf2823fbea7bff702021bffc4853eb5c9":"42233000000000000000","0xe9864c1afc8eaad37f3ba56fcb7477cc622009b7":"79000000000000000000","0x87ef6d8b6a7cbf9b5c8c97f67ee2adc2a73b3f77":"200400000000000000000","0xc043f2452dcb9602ef62bd360e033dd23971fe84":"2000000000000000000000","0x0fdd65402395df9bd19fee4507ef5345f745104c":"5000000000000000000000","0x939c4313d2280edf5e071bced846063f0a975d54":"120000000000000000000000","0xb28245037cb192f75785cb86cbfe7c930da258b0":"16000000000000000000000","0xa80cb1738bac08d4f9c08b4deff515545fa8584f":"500000000000000000000","0x62971bf2634cee0be3c9890f51a56099dbb9519b":"656000000000000000000","0xf2efe96560c9d97b72bd36447843885c1d90c231":"2000000000000000000000","0x0e390f44053ddfcef0d608b35e4d9c2cbe9871bb":"1970000000000000000000","0x61d101a033ee0e2ebb3100ede766df1ad0244954":"500000000000000000000","0x6785513cf732e47e87670770b5419be10cd1fc74":"2000000000000000000000","0x167699f48a78c615512515739958993312574f07":"39000000000000000000","0x68ec79d5be7155716c40941c79d78d17de9ef803":"500600000000000000000","0xa0e8ba661b48154cf843d4c2a5c0f792d528ee29":"400000000000000000000","0x1a201b4327cea7f399046246a3c87e6e03a3cda8":"1000000000000000000000","0xf60f62d73937953fef35169e11d872d2ea317eec":"5348000000000000000000","0xc0c04d0106810e3ec0e54a19f2ab8597e69a573d":"50000000000000000000","0xef47cf073e36f271d522d7fa4e7120ad5007a0bc":"2500000000000000000000","0xa44fe800d96fcad73b7170d0f610cb8c0682d6ce":"4000000000000000000000","0x010f4a98dfa1d9799bf5c796fb550efbe7ecd877":"8023366000000000000000","0x708fa11fe33d85ad1befcbae3818acb71f6a7d7e":"18200000000000000000","0xb38c4e537b5df930d65a74d043831d6b485bbde4":"400000000000000000000","0x250a69430776f6347703f9529783955a6197b682":"1940000000000000000000","0x2d35a9df62757f7ffad1049afb06ca4afc464c51":"20000000000000000000","0x6aff1466c2623675e3cb0e75e423d37a25e442eb":"1730000000000000000000","0xfc15cb99a8d1030b12770add033a79ee0d0c908c":"350056000000000000000","0xe784dcc873aa8c1513ec26ff36bc92eac6d4c968":"200000000000000000000","0xb1c328fb98f2f19ab6646f0a7c8c566fda5a8540":"2500000000000000000000","0x247a0a11c57f0383b949de540b66dee68604b0a1":"1069600000000000000000","0x1af60343360e0b2d75255210375720df21db5c7d":"1000000000000000000000","0x8794bf47d54540ece5c72237a1ffb511ddb74762":"2000000000000000000000","0xe76d945aa89df1e457aa342b31028a5e9130b2ce":"1015200000000000000000","0xa30e0acb534c9b3084e8501da090b4eb16a2c0cd":"2000000000000000000000","0x7099d12f6ec656899b049a7657065d62996892c8":"400000000000000000000","0x7be7f2456971883b9a8dbe4c91dec08ac34e8862":"3000000000000000000000","0x42746aeea14f27beff0c0da64253f1e7971890a0":"1550000000000000000000","0x736b44503dd2f6dd5469ff4c5b2db8ea4fec65d0":"313950000000000000000","0x822edff636563a6106e52e9a2598f7e6d0ef2782":"36099000000000000000","0x03c647a9f929b0781fe9ae01caa3e183e876777e":"445800000000000000000","0x63612e7862c27b587cfb6daf9912cb051f030a9f":"43458000000000000000","0xd46bae61b027e5bb422e83a3f9c93f3c8fc77d27":"2000000000000000000000","0x5f23ba1f37a96c45bc490259538a54c28ba3b0d5":"1200000000000000000000","0xd41d7fb49fe701baac257170426cc9b38ca3a9b2":"176000000000000000000","0x1ebacb7844fdc322f805904fbf1962802db1537c":"10000000000000000000000","0x9c80bc18e9f8d4968b185da8c79fa6e11ffc3e23":"240000000000000000000","0xe4ca0a5238564dfc91e8bf22bade2901619a1cd4":"1000000000000000000000","0x1ad72d20a76e7fcc6b764058f48d417d496fa6cd":"2000000000000000000000","0xd3bc730937fa75d8452616ad1ef1fe7fffe0d0e7":"83363000000000000000","0xeac1482826acb6111e19d340a45fb851576bed60":"32177000000000000000","0x01e40521122530d9ac91113c06a0190b6d63850b":"1337000000000000000000","0x9e20e5fd361eabcf63891f5b87b09268b8eb3793":"100000000000000000000","0x69ff429074cb9b6c63bc914284bce5f0c8fbf7d0":"500000000000000000000","0x0d3265d3e7bdb93d5e8e8b1ca47f210a793ecc8e":"200000000000000000000","0x5b4ea16db6809b0352d4b6e81c3913f76a51bb32":"400000000000000000000","0xd8fe088fffce948f5137ee23b01d959e84ac4223":"227942000000000000000","0x7e4e9409704121d1d77997026ff06ea9b19a8b90":"2602600000000000000000","0x96b434fe0657e42acc8212b6865139dede15979c":"4000000000000000000000","0x22f004df8de9e6ebf523ccace457accb26f97281":"10000000000000000000000","0xd8f9240c55cff035523c6d5bd300d370dc8f0c95":"285000000000000000000","0x9d9e57fde30e5068c03e49848edce343b7028358":"1730000000000000000000","0x317cf4a23cb191cdc56312c29d15e210b3b9b784":"144000000000000000000","0x79f08e01ce0988e63c7f8f2908fade43c7f9f5c9":"18200000000000000000","0x04e5f5bc7c923fd1e31735e72ef968fd67110c6e":"1611000000000000000000","0x1ec4ec4b77bf19d091a868e6f49154180541f90e":"2000000000000000000000","0x8737dae671823a8d5917e0157ace9c43468d946b":"1999944000000000000000","0xf998ca3411730a6cd10e7455b0410fb0f6d3ff80":"2000000000000000000000","0x6e2eab85dc89fe29dc0aa1853247dab43a523d56":"80000000000000000000","0x72c083beadbdc227c5fb43881597e32e83c26056":"20000000000000000000000","0x5902e44af769a87246a21e079c08bf36b06efeb3":"1000000000000000000000","0xcc2d04f0a4017189b340ca77198641dcf6456b91":"3940000000000000000000","0xbde4c73f969b89e9ceae66a2b51844480e038e9a":"1000000000000000000000","0xadff0d1d0b97471e76d789d2e49c8a74f9bd54ff":"1880000000000000000000","0x397cdb8c80c67950b18d654229610e93bfa6ee1a":"1172938000000000000000","0xa3e051fb744aa3410c3b88f899f5d57f168df12d":"2955000000000000000000","0x810db25675f45ea4c7f3177f37ce29e22d67999c":"200000000000000000000","0x1e13ec51142cebb7a26083412c3ce35144ba56a1":"5000000000000000000000","0x25bdfa3ee26f3849617b230062588a97e3cae701":"1000008000000000000000","0xae538c73c5b38d8d584d7ebdadefb15cabe48357":"999000000000000000000","0xa2ecce2c49f72a0995a0bda57aacf1e9f001e22a":"4000000000000000000000","0x7e24fbdad290175eb2df6d180a19b9a9f41370be":"1000000000000000000000","0xe8cc43bc4f8acf39bff04ebfbf42aac06a328470":"400000000000000000000","0xc2779771f0536d79a8708f6931abc44b3035e999":"20002000000000000000000","0xab27ba78c8e5e3daef31ad05aef0ff0325721e08":"468000000000000000000","0x563cb8803c1d32a25b27b64114852bd04d9c20cd":"204400000000000000000","0x08d4267feb15da9700f7ccc3c84a8918bf17cfde":"1790000000000000000000","0xd1778c13fbd968bc083cb7d1024ffe1f49d02caa":"4020000000000000000000","0x1796bcc97b8abc717f4b4a7c6b1036ea2182639f":"355242000000000000000","0xbeecd6af900c8b064afcc6073f2d85d59af11956":"2000000000000000000000","0x045ed7f6d9ee9f252e073268db022c6326adfc5b":"100000000000000000000","0xb88a37c27f78a617d5c091b7d5b73a3761e65f2a":"2000000000000000000000","0x72fb49c29d23a18950c4b2dc0ddf410f532d6f53":"2000000000000000000000","0x6ecaefa6fc3ee534626db02c6f85a0c395571e77":"600000000000000000000","0xd1811c55976980f083901d8a0db269222dfb5cfe":"1550000000000000000000","0x98855c7dfbee335344904a12c40c731795b13a54":"1069600000000000000000","0x92a898d46f19719c38126a8a3c27867ae2cee596":"2000000000000000000000","0xca428863a5ca30369892d612183ef9fb1a04bcea":"1520000000000000000000","0x797427e3dbf0feae7a2506f12df1dc40326e8505":"1000000000000000000000","0x3d574fcf00fae1d98cc8bf9ddfa1b3953b9741bc":"1970000000000000000000","0x28818e18b610001321b31df6fe7d2815cdadc9f5":"1000000000000000000000","0x5f3e1e6739b0c62200e00a003691d9efb238d89f":"3000000000000000000000","0xd9d370fec63576ab15b318bf9e58364dc2a3552a":"100000000000000000000","0xb223bf1fbf80485ca2b5567d98db7bc3534dd669":"4000000000000000000000","0x7b27d0d1f3dd3c140294d0488b783ebf4015277d":"400000000000000000000","0x7930c2d9cbfa87f510f8f98777ff8a8448ca5629":"199955000000000000000","0x820c19291196505b65059d9914b7090be1db87de":"140000000000000000000","0xe545ee84ea48e564161e9482d59bcf406a602ca2":"1850000000000000000000","0xaf4cf41785161f571d0ca69c94f8021f41294eca":"9850000000000000000000","0x7a4f9b850690c7c94600dbee0ca4b0a411e9c221":"1910000000000000000000","0xddab6b51a9030b40fb95cf0b748a059c2417bec7":"2000000000000000000000","0x315ef2da620fd330d12ee55de5f329a696e0a968":"150000000000000000000","0x4db1c43a0f834d7d0478b8960767ec1ac44c9aeb":"872870000000000000000","0x2fef81478a4b2e8098db5ff387ba2153f4e22b79":"999000000000000000000","0x6c6aa0d30b64721990b9504a863fa0bfb5e57da7":"2700000000000000000000","0x33380c6fff5acd2651309629db9a71bf3f20c5ba":"16100000000000000000000","0x4eebf1205d0cc20cee6c7f8ff3115f56d48fba26":"19400000000000000000","0x03cc9d2d21f86b84ac8ceaf971dba78a90e62570":"1610000000000000000000","0x728f9ab080157db3073156dbca1a169ef3179407":"500000000000000000000","0x30ed11b77bc17e5e6694c8bc5b6e4798f68d9ca7":"143731500000000000000000","0xf617b967b9bd485f7695d2ef51fb7792d898f500":"500000000000000000000","0xc0cbad3ccdf654da22cbcf5c786597ca1955c115":"2000000000000000000000","0x80522ddf944ec52e27d724ed4c93e1f7be6083d6":"200000000000000000000","0x4e90ccb13258acaa9f4febc0a34292f95991e230":"15800000000000000000","0xff207308ced238a6c01ad0213ca9eb4465d42590":"1999944000000000000000","0x35f2949cf78bc219bb4f01907cf3b4b3d3865482":"289800000000000000000","0x68f525921dc11c329b754fbf3e529fc723c834cd":"1610000000000000000000","0x81139bfdcca656c430203f72958c543b6580d40c":"2000000000000000000000","0x9d511543b3d9dc60d47f09d49d01b6c498d82078":"11245000000000000000000","0x084d103254759b343cb2b9c2d8ff9e1ac5f14596":"7600000000000000000000","0xb323dcbf2eddc5382ee4bbbb201ca3931be8b438":"2000000000000000000000","0x349d2c918fd09e2807318e66ce432909176bd50b":"1120000000000000000000","0xb535f8db879fc67fec58824a5cbe6e5498aba692":"1910000000000000000000","0x824074312806da4748434266ee002140e3819ac2":"1507000000000000000000","0xe8ef100d7ce0895832f2678df72d4acf8c28b8e3":"500038000000000000000","0x84af1b157342d54368260d17876230a534b54b0e":"985000000000000000000","0x419a71a36c11d105e0f2aef5a3e598078e85c80b":"5000000000000000000000","0x55af092f94ba6a79918b0cf939eab3f01b3f51c7":"149940000000000000000","0x35a549e8fd6c368d6dcca6d2e7d18e4db95f5284":"499938000000000000000","0xf0e2649c7e6a3f2c5dfe33bbfbd927ca3c350a58":"2000000000000000000000","0xf4b759cc8a1c75f80849ebbcda878dc8f0d66de4":"400000000000000000000","0x21846f2fdf5a41ed8df36e5ed8544df75988ece3":"1999944000000000000000","0x229ff80bf5708009a9f739e0f8b560914016d5a6":"333333000000000000000","0xda505537537ffb33c415fec64e69bae090c5f60f":"160000000000000000000","0xb91d9e916cd40d193db60e79202778a0087716fc":"404800000000000000000","0xbb6823a1bd819f13515538264a2de052b4442208":"25610000000000000000","0x459393d63a063ef3721e16bd9fde45ee9dbd77fb":"1968818000000000000000","0x95f62d0243ede61dad9a3165f53905270d54e242":"1610000000000000000000","0xb0bb29a861ea1d424d45acd4bfc492fb8ed809b7":"80000000000000000000","0x5e74ed80e9655788e1bb269752319667fe754e5a":"56000000000000000000","0xa276b058cb98d88beedb67e543506c9a0d9470d8":"2668652000000000000000","0x8ae9ef8c8a8adfa6ab798ab2cdc405082a1bbb70":"2000000000000000000000","0xe5102c3b711b810344197419b1cd8a7059f13e32":"299999000000000000000","0xc32038ca52aee19745be5c31fcdc54148bb2c4d0":"49984000000000000000","0x13e321728c9c57628058e93fc866a032dd0bda90":"714580000000000000000","0xc2bae4a233c2d85724f0dabebda0249d833e37d3":"5000000000000000000000","0x10d32416722ca4e648630548ead91edd79c06aff":"100000000000000000000","0xd5f07552b5c693c20067b378b809cee853b8f136":"505540000000000000000","0x8668af868a1e98885f937f2615ded6751804eb2d":"20000000000000000000","0x139d3531c9922ad56269f6309aa789fb2485f98c":"4000000000000000000000","0x1d29c7aab42b2048d2b25225d498dba67a03fbb2":"200000000000000000000","0xd35075ca61fe59d123969c36a82d1ab2d918aa38":"2674000000000000000000","0xd6fc0446c6a8d40ae3551db7e701d1fa876e4a49":"2000000000000000000000","0xfccd0d1ecee27addea95f6857aeec8c7a04b28ee":"10000000000000000000000","0xc12cfb7b3df70fceca0ede263500e27873f8ed16":"1000000000000000000000","0xd0db456178206f5c4430fe005063903c3d7a49a7":"706245000000000000000","0x73cf80ae9688e1580e68e782cd0811f7aa494d2c":"7760000000000000000000","0xd60651e393783423e5cc1bc5f889e44ef7ea243e":"398800000000000000000","0x048a8970ea4145c64d5517b8de5b46d0595aad06":"20000000000000000000000","0xdd9b485a3b1cd33a6a9c62f1e5bee92701856d25":"225073000000000000000","0x5b287c7e734299e727626f93fb1187a60d5057fe":"101230000000000000000","0x635c00fdf035bca15fa3610df3384e0fb79068b1":"9000000000000000000000","0x630a913a9031c9492abd4c41dbb15054cfec4416":"5688000000000000000000","0xaf3614dcb68a36e45a4e911e62796247222d595b":"2259800000000000000000","0x335e22025b7a77c3a074c78b8e3dfe071341946e":"10178744000000000000000","0xf0e1dfa42adeac2f17f6fdf584c94862fd563393":"500000000000000000000","0x1a9e702f385dcd105e8b9fa428eea21c57ff528a":"1400000000000000000000","0x8ce4949d8a16542d423c17984e6739fa72ceb177":"24999975000000000000000","0x5f29c9de765dde25852af07d33f2ce468fd20982":"2000000000000000000000","0xdbf5f061a0f48e5e69618739a77d2ec19768d201":"152000000000000000000","0xb247cf9c72ec482af3eaa759658f793d670a570c":"912000000000000000000","0x99f4147ccc6bcb80cc842e69f6d00e30fa4133d9":"400000000000000000000","0xba6d31b9a261d640b5dea51ef2162c3109f1eba8":"5000000000000000000000","0xf05ba8d7b68539d933300bc9289c3d9474d0419e":"126400000000000000000","0x682e96276f518d31d7e56e30dfb009c1218201bd":"20000000000000000000","0x0927220492194b2eda9fc4bbe38f25d681dfd36c":"6000000000000000000000","0xa3c33afc8cb4704e23153de2049d35ae71332472":"799600000000000000000","0x05c736d365aa37b5c0be9c12c8ad5cd903c32cf9":"6002000000000000000000","0xd8eef4cf4beb01ee20d111748b61cb4d3f641a01":"2740000000000000000000","0x16c1bf5b7dc9c83c179efacbcf2eb174e3561cb3":"1000000000000000000000","0xd79db5ab43621a7a3da795e58929f3dd25af67d9":"1999944000000000000000","0x28efae6356509edface89fc61a7fdcdb39eea8e5":"5348000000000000000000","0xc55005a6c37e8ca7e543ce259973a3cace961a4a":"2000000000000000000000","0xab3d86bc82927e0cd421d146e07f919327cdf6f9":"1910000000000000000000","0xb74ed2666001c16333cf7af59e4a3d4860363b9c":"193600000000000000000","0x1899f69f653b05a5a6e81f480711d09bbf97588c":"1955000000000000000000","0x27fc85a49cff90dbcfdadc9ddd40d6b9a2210a6c":"100000000000000000000","0xcd1ed263fbf6f6f7b48aef8f733d329d4382c7c7":"18500000000000000000","0xd97fe6f53f2a58f6d76d752adf74a8a2c18e9074":"309990000000000000000","0x80da2fdda29a9e27f9e115975e69ae9cfbf3f27e":"200000000000000000000","0x09146ea3885176f07782e1fe30dce3ce24c49e1f":"20000000000000000000","0x393ff4255e5c658f2e7f10ecbd292572671bc2d2":"2000000000000000000000","0xa390ca122b8501ee3e5e07a8ca4b419f7e4dae15":"100000000000000000000","0x6d9193996b194617211106d1635eb26cc4b66c6c":"399640000000000000000","0x999c49c174ca13bc836c1e0a92bff48b271543ca":"3280000000000000000000","0x7421ce5be381738ddc83f02621974ff0686c79b8":"1632000000000000000000","0x6be9030ee6e2fbc491aca3de4022d301772b7b7d":"26740000000000000000","0x81bd75abd865e0c3f04a0b4fdbcb74d34082fbb7":"4000000000000000000000","0x8bc1ff8714828bf286ff7e8a7709106548ed1b18":"10000000000000000000000","0xa0aadbd9509722705f6d2358a5c79f37970f00f6":"200000000000000000000","0x3d881433f04a7d0d27f84944e08a512da3555287":"1200000000000000000000","0xcc1d6ead01aada3e8dc7b95dca25df26eefa639d":"2000000000000000000000","0x35106ba94e8563d4b3cb3c5c692c10e604b7ced8":"2000000000000000000000","0x4d8697af0fbf2ca36e8768f4af22133570685a60":"20000000000000000000","0x1afcc585896cd0ede129ee2de5c19ea811540b64":"3231259000000000000000","0xe5215631b14248d45a255296bed1fbfa0330ff35":"1310000000000000000000","0xe3878f91ca86053fced5444686a330e09cc388fb":"194000000000000000000","0x555df19390c16d01298772bae8bc3a1152199cbd":"200000000000000000000","0xdc3dae59ed0fe18b58511e6fe2fb69b219689423":"100000000000000000000","0x74648caac748dd135cd91ea14c28e1bd4d7ff6ae":"3100000000000000000000","0xcf2e2ad635e9861ae95cb9bafcca036b5281f5ce":"35200000000000000000000","0x14eec09bf03e352bd6ff1b1e876be664ceffd0cf":"20094000000000000000","0x856e5ab3f64c9ab56b009393b01664fc0324050e":"1790000000000000000000","0x632b9149d70178a7333634275e82d5953f27967b":"700000000000000000000","0x2a39190a4fde83dfb3ddcb4c5fbb83ac6c49755c":"1000000000000000000000","0x369ef761195f3a373e24ece6cd22520fe0b9e86e":"534933000000000000000","0x16afa787fc9f94bdff6976b1a42f430a8bf6fb0f":"2000000000000000000000","0x1b0b31afff4b6df3653a94d7c87978ae35f34aae":"354600000000000000000","0xb4d82f2e69943f7de0f5f7743879406fac2e9cec":"40000000000000000000","0x09d6cefd75b0c4b3f8f1d687a522c96123f1f539":"6000000000000000000000","0x01577afd4e50890247c9b10d44af73229aec884f":"680000000000000000000","0xa35606d51220ee7f2146d411582ee4ee4a45596e":"3996800000000000000000","0x352e77c861696ef96ad54934f894aa8ea35151dd":"1000000000000000000000","0xb87f5376c2de0b6cc3c179c06087aa473d6b4674":"1337000000000000000000","0x5b49afcd75447838f6e7ceda8d21777d4fc1c3c0":"4000000000000000000000","0xb884add88d83dc564ab8e0e02cbdb63919aea844":"2000000000000000000000","0x5c312a56c784b122099b764d059c21ece95e84ca":"95000000000000000000","0x4697baaf9ccb603fd30430689d435445e9c98bf5":"199600000000000000000","0xc625f8c98d27a09a1bcabd5128b1c2a94856af30":"200000000000000000000","0x19f5caf4c40e6908813c0745b0aea9586d9dd931":"664000000000000000000","0x1e596a81b357c6f24970cc313df6dbdaabd0d09e":"2000000000000000000000","0xc1631228efbf2a2e3a4092ee8900c639ed34fbc8":"955000000000000000000","0x6f6cf20649a9e973177ac67dbadee4ebe5c7bdda":"5080000000000000000000","0x5fa7bfe043886127d4011d8356a47e947963aca8":"1820000000000000000000","0x6af8e55969682c715f48ad4fc0fbb67eb59795a3":"2000000000000000000000","0x122f56122549d168a5c5e267f52662e5c5cce5c8":"185000000000000000000","0x7713ab8037411c09ba687f6f9364f0d3239fac28":"10000000000000000000000","0x31ccc616b3118268e75d9ab8996c8858ebd7f3c3":"399924000000000000000","0x09c88f917e4d6ad473fa12e98ea3c4472a5ed6da":"10000000000000000000000","0xe796fd4e839b4c95d7510fb7c5c72b83c6c3e3c7":"512200000000000000000","0xa8285539869d88f8a961533755717d7eb65576ae":"200000000000000000000","0xd929c65d69d5bbaea59762662ef418bc21ad924a":"1000000000000000000000","0xf7418aa0e713d248228776b2e7434222ae75e3a5":"2000000000000000000000","0x7f0b90a1fdd48f27b268feb38382e55ddb50ef0f":"940000000000000000000","0x34a0431fff5ead927f3c69649616dc6e97945f6f":"400000000000000000000","0x1b3cb81e51011b549d78bf720b0d924ac763a7c2":"560000000000000000000000","0x155b3779bb6d56342e2fda817b5b2d81c7f41327":"50200000000000000000","0xecd486fc196791b92cf612d348614f9156488b7e":"12000000000000000000000","0x82a8cbbfdff02b2e38ae4bbfca15f1f0e83b1aea":"84999000000000000000","0x06b0c1e37f5a5ec4bbf50840548f9d3ac0288897":"4000098000000000000000","0xe6d49f86c228f47367a35e886caacb271e539429":"412656000000000000000","0x704a6eb41ba34f13addde7d2db7df04915c7a221":"1820000000000000000000","0x745ccf2d819edbbddea8117b5c49ed3c2a066e93":"4000000000000000000000","0x6d3b7836a2b9d899721a4d237b522385dce8dfcd":"1000070000000000000000","0x856aa23c82d7215bec8d57f60ad75ef14fa35f44":"20000000000000000000000","0xea79057dabef5e64e7b44f7f18648e7e533718d2":"200000000000000000000","0x9df057cd03a4e27e8e032f857985fd7f01adc8d7":"2000000000000000000000","0x5f2f07d2d697e8c567fcfdfe020f49f360be2139":"2000000000000000000000","0x5efbdfe5389999633c26605a5bfc2c1bb5959393":"69200000000000000000","0x047e87c8f7d1fce3b01353a85862a948ac049f3e":"1490000000000000000000","0x265383d68b52d034161bfab01ae1b047942fbc32":"21000600000000000000000","0x760ff3354e0fde938d0fb5b82cef5ba15c3d2916":"10000000000000000000000","0xbc46d537cf2edd403565bde733b2e34b215001bd":"20000000000000000000000","0xee58fb3db29070d0130188ce472be0a172b89055":"10021400000000000000000","0x75abe5270f3a78ce007cf37f8fbc045d489b7bb1":"1999944000000000000000","0x5fc6c11426b4a1eae7e51dd512ad1090c6f1a85b":"2730000000000000000000","0x26cfffd052152bb3f957b478d5f98b233a7c2b92":"4000000000000000000000","0x0a4a011995c681bc999fdd79754e9a324ae3b379":"41350300000000000000000","0x6fa60df818a5446418b1bbd62826e0b9825e1318":"13200000000000000000000","0x63d55ad99b9137fd1b20cc2b4f03d42cbaddf334":"400000000000000000000","0x679b9a109930517e8999099ccf2a914c4c8dd934":"60000000000000000000","0x3e83544f0082552572c782bee5d218f1ef064a9d":"100076000000000000000","0x968b14648f018333687cd213fa640aec04ce6323":"1000000000000000000000","0x427b462ab84e5091f48a46eb0cdc92ddcb26e078":"2000000000000000000000","0xdf8510793eee811c2dab1c93c6f4473f30fbef5b":"1000000000000000000000","0x362fbcb10662370a068fc2652602a2577937cce6":"200000000000000000000","0x5d83b21bd2712360436b67a597ee3378db3e7ae4":"2000000000000000000000","0x5777441c83e03f0be8dd340bde636850847c620b":"10000000000000000000000","0xc94a585203da7bbafd93e15884e660d4b1ead854":"7000000000000000000000","0x35a08081799173e001cc5bd46a02406dc95d1787":"10000000000000000000000","0x21d13f0c4024e967d9470791b50f22de3afecf1b":"4452210000000000000000","0xfdfd6134c04a8ab7eb16f00643f8fed7daaaecb2":"400000000000000000000","0xfd812bc69fb170ef57e2327e80affd14f8e4b6d2":"2000000000000000000000","0x7148aef33261d8031fac3f7182ff35928daf54d9":"4100000000000000000000","0x0b06390f2437b20ec4a3d3431b3279c6583e5ed7":"194000000000000000000","0x4909b31998ead414b8fb0e846bd5cbde393935be":"4000000000000000000000","0xb70dba9391682b4a364e77fe99256301a6c0bf1f":"200000000000000000000","0x6b83bae7b565244558555bcf4ba8da2011891c17":"2000000000000000000000","0x70a03549aa6168e97e88a508330a5a0bea74711a":"1337000000000000000000","0x0fc9a0e34145fbfdd2c9d2a499b617d7a02969b9":"180000000000000000000","0x2ddf40905769bcc426cb2c2938ffe077e1e89d98":"3000000000000000000000","0x794b51c39e53d9e762b0613b829a44b472f4fff3":"667965000000000000000","0xd062588171cf99bbeb58f126b870f9a3728d61ec":"4500000000000000000000","0x8db185fe1b70a94a6a080e7e23a8bedc4acbf34b":"1400000000000000000000","0xe73bfeada6f0fd016fbc843ebcf6e370a65be70c":"1970000000000000000000","0x79ed10cf1f6db48206b50919b9b697081fbdaaf3":"2000000000000000000000","0x276b0521b0e68b277df0bb32f3fd48326350bfb2":"50000000000000000000","0x2e439348df8a4277b22a768457d1158e97c40904":"776970000000000000000","0x6c25327f8dcbb2f45e561e86e35d8850e53ab059":"1103200000000000000000","0x04d73896cf6593a691972a13a6e4871ff2c42b13":"2000000000000000000000","0xb10fd2a647102f881f74c9fbc37da632949f2375":"40000000000000000000","0x615f82365c5101f071e7d2cb6af14f7aad2c16c6":"20000000000000000000","0x93aa8f92ebfff991fc055e906e651ac768d32bc8":"940000000000000000000","0x0cbf8770f0d1082e5c20c5aead34e5fca9ae7ae2":"1000000000000000000000","0xffc9cc3094b041ad0e076f968a0de3b167255866":"432400000000000000000","0x46531e8b1bde097fdf849d6d119885608a008df7":"200000000000000000000","0x23cd2598a20e149ead2ad69379576ecedb60e38e":"2000000000000000000000","0x85ca8bc6da2803d0725f5e1a456c89f9bc774e2f":"600000000000000000000","0xc0725ec2bdc33a1d826071dea29d62d4385a8c25":"40740000000000000000000","0x0e4765790352656bc656682c24fc5ef3e76a23c7":"46610000000000000000","0x2ef9e465716acacfb8c8252fa8e7bc7969ebf6e4":"2760000000000000000000","0x0ec5308b31282e218fc9e759d4fec5db3708cec4":"1001000000000000000000","0xbf7701fc6225d5a17815438a8941d21ebc5d059d":"1880000000000000000000","0xc489c83ffbb0252ac0dbe3521217630e0f491f14":"4000000000000000000000","0x8eb51774af206b966b8909c45aa6722748802c0c":"500000000000000000000","0x7b9226d46fe751940bc416a798b69ccf0dfab667":"4200000000000000000000","0x8f660f8b2e4c7cc2b4ac9c47ed28508d5f8f8650":"20000000000000000000000","0x9f19fac8a32437d80ac6837a0bb7841729f4972e":"650100000000000000000","0x201864a8f784c2277b0b7c9ee734f7b377eab648":"4467000000000000000000","0xa6101c961e8e1c15798ffcd0e3201d7786ec373a":"6000000000000000000000","0xd4ff46203efa23064b1caf00516e28704a82a4f8":"1337000000000000000000","0xaa136b47962bb8b4fb540db4ccf5fdd042ffb8cf":"500038000000000000000","0x704ae21d762d6e1dde28c235d13104597236db1a":"2000000000000000000000","0xf17a92e0361dbacecdc5de0d1894955af6a9b606":"2000000000000000000000","0x8b48e19d39dd35b66e6e1bb6b9c657cb2cf59d04":"17844175000000000000000","0x9ad47fdcf9cd942d28effd5b84115b31a658a13e":"3290000000000000000000","0xdf0d08617bd252a911df8bd41a39b83ddf809673":"10000000000000000000000","0x4c666b86f1c5ee8ca41285f5bde4f79052081406":"500000000000000000000","0x88dec5bd3f4eba2d18b8aacefa7b721548c319ba":"1370000000000000000000","0x9f9fe0c95f10fee87af1af207236c8f3614ef02f":"6000000000000000000000","0xf7d0d310acea18406138baaabbfe0571e80de85f":"1337000000000000000000","0x9569c63a9284a805626db3a32e9d236393476151":"1970000000000000000000","0x5d5c2c1099bbeefb267e74b58880b444d94449e0":"253574000000000000000","0x8c6ae7a05a1de57582ae2768204276c0ff47ed03":"208000000000000000000000","0x432d884bd69db1acc0d89c64ade4cb4fc3a88b7a":"2483000000000000000000","0x672cbca8440a8577097b19aff593a2ad9d28a756":"80000000000000000000","0x19df9445a81c1b3d804aeaeb6f6e204e4236663f":"37387000000000000000","0x1cb5f33b4d488936d13e3161da33a1da7df70d1b":"200000000000000000000","0xdf60f18c812a11ed4e2776e7a80ecf5e5305b3d6":"900000000000000000000","0xc99a9cd6c9c1be3534eecd92ecc22f5c38e9515b":"4821030000000000000000","0x00c40fe2095423509b9fd9b754323158af2310f3":"0","0xda4a5f557f3bab390a92f49b9b900af30c46ae80":"10000000000000000000000","0xf36df02fbd89607347afce2969b9c4236a58a506":"2000000000000000000000","0xc549df83c6f65eec0f1dc9a0934a5c5f3a50fd88":"2910000000000000000000","0x9f662e95274121f177566e636d23964cf1fd686f":"2000000000000000000000","0x5a267331facb262daaecd9dd63a9700c5f5259df":"100000000000000000000","0x117d9aa3c4d13bee12c7500f09f5dd1c66c46504":"206000000000000000000","0x1b4d07acd38183a61bb2783d2b7b178dd502ac8d":"200000000000000000000","0x3c0c3defac9cea7acc319a96c30b8e1fedab4574":"1940000000000000000000","0xe4dc22ed595bf0a337c01e03cc6be744255fc9e8":"191000000000000000000","0x8f067c7c1bbd57780b7b9eeb9ec0032f90d0dcf9":"20000000000000000000000","0x40e2440ae142c880366a12c6d4102f4b8434b62a":"1000000000000000000000","0xf9ece022bccd2c92346911e79dd50303c01e0188":"1000000000000000000000","0xf70328ef97625fe745faa49ee0f9d4aa3b0dfb69":"1000000000000000000000","0xb6aacb8cb30bab2ae4a2424626e6e12b02d04605":"8000000000000000000000","0x154459fa2f21318e3434449789d826cdc1570ce5":"2000000000000000000000","0x684a44c069339d08e19a75668bdba303be855332":"70000000000000000000000","0x9fe501aa57ead79278937cd6308c5cfa7a5629fe":"50003000000000000000","0x3e45bd55db9060eced923bb9cb733cb3573fb531":"1640000000000000000000","0x9c9f3b8a811b21f3ff3fe20fe970051ce66a824f":"1157740000000000000000","0xe99aece90541cae224b87da673965e0aeb296afd":"920000000000000000000","0x2f6dce1330c59ef921602154572d4d4bacbd048a":"1000000000000000000000","0x6a6353b971589f18f2955cba28abe8acce6a5761":"3000000000000000000000","0x98c10ebf2c4f97cba5a1ab3f2aafe1cac423f8cb":"300000000000000000000","0x8077c3e4c445586e094ce102937fa05b737b568c":"100000000000000000000","0x13371f92a56ea8381e43059a95128bdc4d43c5a6":"1000000000000000000000","0x35a6885083c899dabbf530ed6c12f4dd3a204cf5":"200000000000000000000","0x36b2c85e3aeeebb70d63c4a4730ce2e8e88a3624":"10000000000000000000000","0x5ce44068b8f4a3fe799e6a8311dbfdeda29dee0e":"2000000000000000000000","0x6fa6388d402b30afe59934c3b9e13d1186476018":"670000000000000000000","0x8251358ca4e060ddb559ca58bc0bddbeb4070203":"2000000000000000000000","0x17e86f3b5b30c0ba59f2b2e858425ba89f0a10b0":"2000000000000000000000","0x298ec76b440d8807b3f78b5f90979bee42ed43db":"30000000000000000000000","0xce4b065dbcb23047203262fb48c1188364977470":"500000000000000000000","0xc8e2adeb545e499d982c0c117363ceb489c5b11f":"985000000000000000000","0x9928ff715afc3a2b60f8eb4cc4ba4ee8dab6e59d":"440000000000000000000","0xc76130c73cb9210238025c9df95d0be54ac67fbe":"1500000000000000000000","0x72d03d4dfab3500cf89b86866f15d4528e14a195":"4488000000000000000000","0xd193e583d6070563e7b862b9614a47e99489f3e5":"999972000000000000000","0x4df140ba796585dd5489315bca4bba680adbb818":"2674000000000000000000","0x009eef0a0886056e3f69211853b9b7457f3782e4":"3000512000000000000000","0x6e255b700ae7138a4bacf22888a9e2c00a285eec":"4000000000000000000000","0xaa47a4ffc979363232c99b99fada0f2734b0aeee":"8121800000000000000000","0x9d069197d1de50045a186f5ec744ac40e8af91c6":"2000000000000000000000","0xb514882c979bb642a80dd38754d5b8c8296d9a07":"955000000000000000000","0x17c0478657e1d3d17aaa331dd429cecf91f8ae5d":"999942000000000000000","0x5f9616c47b4a67f406b95a14fe6fc268396f1721":"200000000000000000000","0xf70a998a717b338d1dd99854409b1a338deea4b0":"2000000000000000000000","0xd1ee905957fe7cc70ec8f2868b43fe47b13febff":"44000000000000000000","0xfc018a690ad6746dbe3acf9712ddca52b6250039":"10000000000000000000000","0x5118557d600d05c2fcbf3806ffbd93d02025d730":"11360000000000000000000","0x1ef5c9c73650cfbbde5c885531d427c7c3fe5544":"6000000000000000000000","0xd1a396dcdab2c7494130b3fd307820340dfd8c1f":"17952000000000000000","0x2d8e061892a5dcce21966ae1bb0788fd3e8ba059":"250066000000000000000","0x8834b2453471f324fb26be5b25166b5b5726025d":"573000000000000000000","0x14f221159518783bc4a706676fc4f3c5ee405829":"200000000000000000000","0xc056d4bd6bf3cbacac65f8f5a0e3980b852740ae":"100000000000000000000","0x560536794a9e2b0049d10233c41adc5f418a264a":"1000000000000000000000","0xbc9e0ec6788f7df4c7fc210aacd220c27e45c910":"500000000000000000000","0x54bcb8e7f73cda3d73f4d38b2d0847e600ba0df8":"1078000000000000000000","0x4361d4846fafb377b6c0ee49a596a78ddf3516a3":"3580000000000000000000","0x41c3c2367534d13ba2b33f185cdbe6ac43c2fa31":"4000000000000000000000","0x5dc6f45fef26b06e3302313f884daf48e2746fb9":"500000000000000000000","0xad414d29cb7ee973fec54e22a388491786cf5402":"14000000000000000000000","0x802dc3c4ff2d7d925ee2859f4a06d7ba60f1308c":"98040000000000000000","0x2aed2ce531c056b0097efc3c6de10c4762004ed9":"10430000000000000000000","0x39782ffe06ac78822a3c3a8afe305e50a56188ce":"10000000000000000000000","0xec73833de4b810bb027810fc8f69f544e83c12d1":"1000000000000000000000","0x8d51a4cc62011322c696fd725b9fb8f53feaaa07":"1000000000000000000000","0x29298ccbdff689f87fe41aa6e98fdfb53deaf37a":"19800000000000000000000","0x827531a6c5817ae35f82b00b9754fcf74c55e232":"3600000000000000000000","0x9c581a60b61028d934167929b22d70b313c34fd0":"50000000000000000000000","0x0a077db13ffeb09484c217709d5886b8bf9c5a8b":"4000000000000000000000","0x07b7a57033f8f11330e4665e185d234e83ec140b":"4325683000000000000000","0x17f523f117bc9fe978aa481eb4f5561711371bc8":"1999884000000000000000","0xde42fcd24ce4239383304367595f068f0c610740":"45120000000000000000","0x2a46d353777176ff8e83ffa8001f4f70f9733aa5":"106000000000000000000","0x92e4392816e5f2ef5fb65837cec2c2325cc64922":"10000000000000000000000","0x9a3da65023a13020d22145cfc18bab10bd19ce4e":"456516000000000000000","0x1a085d43ec92414ea27b914fe767b6d46b1eef44":"29550000000000000000000","0x3b2367f8494b5fe18d683c055d89999c9f3d1b34":"10000000000000000000000","0x84244fc95a6957ed7c1504e49f30b8c35eca4b79":"2000000000000000000000","0x5e031b0a724471d476f3bcd2eb078338bf67fbef":"18200000000000000000","0x97e5cc6127c4f885be02f44b42d1c8b0ac91e493":"200000000000000000000","0xeb1cea7b45d1bd4d0e2a007bd3bfb354759e2c16":"198000000000000000000","0x72feaf124579523954645b7fafff0378d1c8242e":"1000000000000000000000","0x8d07d42d831c2d7c838aa1872b3ad5d277176823":"349200000000000000000","0x9637dc12723d9c78588542eab082664f3f038d9d":"1000000000000000000000","0xe84b55b525f1039e744b918cb3332492e45eca7a":"200000000000000000000","0xb1d6b01b94d854fe8b374aa65e895cf22aa2560e":"940000000000000000000","0x8161d940c3760100b9080529f8a60325030f6edc":"300000000000000000000","0xd30ee9a12b4d68abace6baca9ad7bf5cd1faf91c":"1499936000000000000000","0x057949e1ca0570469e4ce3c690ae613a6b01c559":"200000000000000000000","0x4bf8e26f4c2790da6533a2ac9abac3c69a199433":"200000000000000000000","0x36fec62c2c425e219b18448ad757009d8c54026f":"400000000000000000000","0x77bfe93ccda750847e41a1affee6b2da96e7214e":"300000000000000000000","0xcc48414d2ac4d42a5962f29eee4497092f431352":"161000000000000000000","0xddbddd1bbd38ffade0305d30f02028d92e9f3aa8":"2000000000000000000000","0x30c01142907acb1565f70438b9980ae731818738":"2000000000000000000000","0xcffc49c1787eebb2b56cabe92404b636147d4558":"5679305000000000000000","0xf99eeece39fa7ef5076d855061384009792cf2e0":"500000000000000000000","0xe9b6a790009bc16642c8d820b7cde0e9fd16d8f5":"3640000000000000000000","0x03b41b51f41df20dd279bae18c12775f77ad771c":"1000000000000000000000","0x787d313fd36b053eeeaedbce74b9fb0678333289":"27160000000000000000000","0x35d2970f49dcc81ea9ee707e9c8a0ab2a8bb7463":"1440000000000000000000","0x4c0aca508b3caf5ee028bc707dd1e800b838f453":"18200000000000000000","0x514632efbd642c04de6ca342315d40dd90a2dba6":"2674000000000000000000","0x36810ff9d213a271eda2b8aa798be654fa4bbe06":"2000000000000000000000","0x0c088006c64b30c4ddafbc36cb5f05469eb62834":"2000000000000000000000","0x568df31856699bb5acfc1fe1d680df9960ca4359":"1379999000000000000000","0xd48e3f9357e303513841b3f84bda83fc89727587":"1000000000000000000000","0x953ef652e7b769f53d6e786a58952fa93ee6abe7":"2860000000000000000000","0x7c60a05f7a4a5f8cf2784391362e755a8341ef59":"1892300000000000000000","0x7a6b26f438d9a352449155b8876cbd17c9d99b64":"6000000000000000000000","0x68f719ae342bd7fef18a05cbb02f705ad38ed5b2":"1050000000000000000000","0x45ca8d956608f9e00a2f9974028640888465668f":"2000000000000000000000","0x3eaf316b87615d88f7adc77c58e712ed4d77966b":"100141000000000000000","0x1f0412bfedcd964e837d092c71a5fcbaf30126e2":"20000000000000000000","0x7471f72eeb300624eb282eab4d03723c649b1b58":"8000000000000000000000","0x9bf71f7fb537ac54f4e514947fa7ff6728f16d2f":"33400000000000000000","0x1098c774c20ca1daac5ddb620365316d353f109c":"100000000000000000000","0x7dd8d7a1a34fa1f8e73ccb005fc2a03a15b8229c":"200000000000000000000","0x0151fa5d17a2dce2d7f1eb39ef7fe2ad213d5d89":"4000000000000000000000","0xad6628352ed3390bafa86d923e56014cfcb360f4":"2000000000000000000000","0x02af2459a93d0b3f4d062636236cd4b29e3bcecf":"1910000000000000000000","0xace2abb63b0604409fbde3e716d2876d44e8e5dd":"152000000000000000000","0xe710dcd09b8101f9437bd97db90a73ef993d0bf4":"386100000000000000000","0xd43ee438d83de9a37562bb4e286cb1bd19f4964d":"1000000000000000000000","0xea3779d14a13f6c78566bcde403591413a6239db":"197000000000000000000000","0x6704f169e0d0b36b57bbc39f3c45437b5ee3d28d":"394000000000000000000","0x5584423050e3c2051f0bbd8f44bd6dbc27ecb62c":"3000000000000000000000","0x2f315d9016e8ee5f536681202f9084b032544d4d":"1037400000000000000000","0xe1b63201fae1f129f95c7a116bd9dde5159c6cda":"22837462000000000000000","0x2bbe62eac80ca7f4d6fdee7e7d8e28b63acf770e":"2396000000000000000000","0x38da1ba2de9e2c954b092dd9d81204fd016ba016":"10156000000000000000000","0x8a86e4a51c013b1fb4c76bcf30667c78d52eedef":"2000000000000000000000","0x8f717ec1552f4c440084fba1154a81dc003ebdc0":"10000000000000000000000","0xc760971bbc181c6a7cf77441f24247d19ce9b4cf":"2000000000000000000000","0x7f150afb1a77c2b45928c268c1e9bdb4641d47d8":"2000000000000000000000","0x1ea334b5750807ea74aac5ab8694ec5f28aa77cf":"492500000000000000000","0x2afb058c3d31032b353bf24f09ae20d54de57dbe":"1100000000000000000000","0xcaef027b1ab504c73f41f2a10979b474f97e309f":"200000000000000000000","0x5dd112f368c0e6ceff77a9df02a5481651a02fb7":"169800000000000000000","0xbd93e550403e2a06113ed4c3fba1a8913b19407e":"2000000000000000000000","0x500c16352e901d48ba8d04e2c767121772790b02":"30239000000000000000","0xd2a80327cbe55c4c7bd51ff9dde4ca648f9eb3f8":"50000000000000000000","0x355ccfe0e77d557b971be1a558bc02df9eee0594":"1759120000000000000000","0x5aed0e6cfe95f9d680c76472a81a2b680a7f93e2":"197000000000000000000","0xf56442f60e21691395d0bffaa9194dcaff12e2b7":"260000000000000000000","0x7db9eacc52e429dc83b461c5f4d86010e5383a28":"1000000000000000000000","0x4b984ef26c576e815a2eaed2f5177f07dbb1c476":"1560000000000000000000","0x9846648836a307a057184fd51f628a5f8c12427c":"19100000000000000000000","0x4af0db077bb9ba5e443e21e148e59f379105c592":"600000000000000000000","0xe96e2d3813efd1165f12f602f97f4a62909d3c66":"2300000000000000000000","0x30e789b3d2465e946e6210fa5b35de4e8c93085f":"2000000000000000000000","0x97f99b6ba31346cd98a9fe4c308f87c5a58c5151":"6000000000000000000000","0x595e23d788a2d4bb85a15df7136d264a635511b3":"3940000000000000000000","0x2f61efa5819d705f2b1e4ee754aeb8a819506a75":"1460000000000000000000","0x3554947b7b947b0040da52ca180925c6d3b88ffe":"66850000000000000000","0x8feffadb387a1547fb284da9b8147f3e7c6dc6da":"837200000000000000000","0x258939bbf00c9de9af5338f5d714abf6d0c1c671":"1550000000000000000000","0x5b333696e04cca1692e71986579c920d6b2916f9":"500000000000000000000","0x5381448503c0c702542b1de7cc5fb5f6ab1cf6a5":"8000000000000000000000","0x7e81f6449a03374191f3b7cb05d938b72e090dff":"100000000000000000000","0x4ef1c214633ad9c0703b4e2374a2e33e3e429291":"1337000000000000000000","0xfed8476d10d584b38bfa6737600ef19d35c41ed8":"1820000000000000000000","0x1a95c9b7546b5d1786c3858fb1236446bc0ca4ce":"1970000000000000000000","0x3b07db5a357f5af2484cbc9d77d73b1fd0519fc7":"500000000000000000000","0x5f68a24c7eb4117667737b33393fb3c2148a53b6":"51800000000000000000","0xd8f665fd8cd5c2bcc6ddc0a8ae521e4dc6aa6060":"1700000000000000000000","0xd66acc0d11b689cea6d9ea5ff4014c224a5dc7c4":"18200000000000000000","0x6e72b2a1186a8e2916543b1cb36a68870ea5d197":"186000000000000000000","0x5102a4a42077e11c58df4773e3ac944623a66d9f":"2000325000000000000000","0x72480bede81ad96423f2228b5c61be44fb523100":"6400000000000000000000","0xe076db30ab486f79194ebbc45d8fab9a9242f654":"4840000000000000000000","0x8ceea15eec3bdad8023f98ecf25b2b8fef27db29":"2000000000000000000000","0x40652360d6716dc55cf9aab21f3482f816cc2cbd":"10000000000000000000000","0x13e02fb448d6c84ae17db310ad286d056160da95":"2000000000000000000000","0xd6598b1386e93c5ccb9602ff4bbbecdbd3701dc4":"224096000000000000000","0xd5ea472cb9466018110af00c37495b5c2c713112":"4997800000000000000000","0xbb75cb5051a0b0944b4673ca752a97037f7c8c15":"200000000000000000000","0x8af626a5f327d7506589eeb7010ff9c9446020d2":"1400000000000000000000","0x318c76ecfd8af68d70555352e1f601e35988042d":"501600000000000000000","0x5c3d19441d196cb443662020fcad7fbb79b29e78":"14300000000000000000","0x27101a0f56d39a88c5a84f9b324cdde33e5cb68c":"2000000000000000000000","0xe229e746a83f2ce253b0b03eb1472411b57e5700":"5730000000000000000000","0x604cdf18628dbfa8329194d478dd5201eecc4be7":"23000000000000000000","0x657473774f63ac3d6279fd0743d5790c4f161503":"200000000000000000000","0x1ddefefd35ab8f658b2471e54790bc17af98dea4":"1000000000000000000000","0xac3900298dd14d7cc96d4abb428da1bae213ffed":"24730250000000000000000","0x944f07b96f90c5f0d7c0c580533149f3f585a078":"74000000000000000000","0x232c6d03b5b6e6711efff190e49c28eef36c82b0":"1337000000000000000000","0xc87c77e3c24adecdcd1038a38b56e18dead3b702":"8800000000000000000000","0xc4b6e5f09cc1b90df07803ce3d4d13766a9c46f4":"6000000000000000000000","0xd44334b4e23a169a0c16bd21e866bba52d970587":"2600000000000000000000","0x7757a4b9cc3d0247ccaaeb9909a0e56e1dd6dcc2":"20000000000000000000","0xcf694081c76d18c64ca71382be5cd63b3cb476f8":"1000000000000000000000","0x133e4f15e1e39c53435930aaedf3e0fe56fde843":"20000000000000000000","0xf067fb10dfb293e998abe564c055e3348f9fbf1e":"2000000000000000000000","0x94449c01b32a7fa55af8104f42cdd844aa8cbc40":"16548000000000000000000","0x0e2094ac1654a46ba1c4d3a40bb8c17da7f39688":"358000000000000000000","0x738ca94db7ce8be1c3056cd6988eb376359f3353":"25500000000000000000000","0x0cfb172335b16c87d519cd1475530d20577f5e0e":"100000000000000000000000","0x3cb561ce86424b359891e364ec925ffeff277df7":"200000000000000000000","0x5f981039fcf50225e2adf762752112d1cc26b6e3":"499954000000000000000","0xb43657a50eecbc3077e005d8f8d94f377876bad4":"35460000000000000000","0xd07e511864b1cf9969e3560602829e32fc4e71f5":"50000000000000000000","0x11306c7d57588637780fc9fde8e98ecb008f0164":"1999944000000000000000","0x45ca9862003b4e40a3171fb5cafa9028cac8de19":"13790000000000000000000","0x231d94155dbcfe2a93a319b6171f63b20bd2b6fa":"3819952000000000000000","0xe7533e270cc61fa164ac1553455c105d04887e14":"121550000000000000000","0x070d5d364cb7bbf822fc2ca91a35bdd441b215d5":"2000000000000000000000","0xd475477fa56390d33017518d6711027f05f28dbf":"1975032000000000000000","0xcea34a4dd93dd9aefd399002a97d997a1b4b89cd":"1500000000000000000000","0x560becdf52b71f3d8827d927610f1a980f33716f":"429413000000000000000","0xf632adff490da4b72d1236d04b510f74d2faa3cd":"1400000000000000000000","0x2fdd9b79df8df530ad63c20e62af431ae99216b8":"21000000000000000000","0x535201a0a1d73422801f55ded4dfaee4fbaa6e3b":"39641000000000000000","0x409d5a962edeeebea178018c0f38b9cdb213f289":"20000000000000000000","0x9d911f3682f32fe0792e9fb6ff3cfc47f589fca5":"4000000000000000000000","0x9f7a0392f857732e3004a375e6b1068d49d83031":"2000000000000000000000","0x6a04f5d53fc0f515be942b8f12a9cb7ab0f39778":"3129800000000000000000","0xbe478e8e3dde6bd403bb2d1c657c4310ee192723":"492500000000000000000","0x007622d84a234bb8b078230fcf84b67ae9a8acae":"698800000000000000000","0x9475c510ec9a26979247744c3d8c3b0e0b5f44d3":"10000000000000000000000","0xdf47a8ef95f2f49f8e6f58184154145d11f72797":"1910000000000000000000","0x13ce332dff65a6ab933897588aa23e000980fa82":"258400000000000000000","0x9c4bbcd5f1644a6f075824ddfe85c571d6abf69c":"1800000000000000000000","0xd42b20bd0311608b66f8a6d15b2a95e6de27c5bf":"2000000000000000000000","0xa4dd59ab5e517d398e49fa537f899fed4c15e95d":"20000000000000000000000","0x1a8a5ce414de9cd172937e37f2d59cff71ce57a0":"10000000000000000000000","0x55c564664166a1edf3913e0169f1cd451fdb5d0c":"2399800000000000000000","0x58ae2ddc5f4c8ada97e06c0086171767c423f5d7":"1610000000000000000000","0xfb79abdb925c55b9f98efeef64cfc9eb61f51bb1":"1794000000000000000000","0xe7a42f59fee074e4fb13ea9e57ecf1cc48282249":"20000000000000000000000","0x07e2b4cdeed9d087b12e556d9e770c13c099615f":"668500000000000000000","0x68473b7a7d965904bedba556dfbc17136cd5d434":"100000000000000000000","0x6c5c3a54cda7c2f118edba434ed81e6ebb11dd7a":"200000000000000000000","0x24c117d1d2b3a97ab11a4679c99a774a9eade8d1":"1000000000000000000000","0xf68c5e33fa97139df5b2e63886ce34ebf3e4979c":"3320000000000000000000","0xbd7419dc2a090a46e2873d7de6eaaad59e19c479":"6802000000000000000000","0x1a0a1ddfb031e5c8cc1d46cf05842d50fddc7130":"1000000000000000000000","0x2b3a68db6b0cae8a7c7a476bdfcfbd6205e10687":"2400000000000000000000","0x426d15f407a01135b13a6b72f8f2520b3531e302":"20000000000000000000","0x0394b90fadb8604f86f43fc1e35d3124b32a5989":"764000000000000000000","0x7412c9bc30b4df439f023100e63924066afd53af":"500000000000000000000","0x80e7b3205230a566a1f061d922819bb4d4d2a0e1":"14000000000000000000000","0xff4fc66069046c525658c337a917f2d4b832b409":"2000000000000000000000","0xf5061ee2e5ee26b815503677130e1de07a52db07":"100000000000000000000","0x49793463e1681083d6abd6e725d5bba745dccde8":"545974000000000000000","0x23551f56975fe92b31fa469c49ea66ee6662f41e":"1910000000000000000000","0xfad96ab6ac768ad5099452ac4777bd1a47edc48f":"100000000000000000000","0x2a746cd44027af3ebd37c378c85ef7f754ab5f28":"394000000000000000000","0xb8d389e624a3a7aebce4d3e5dbdf6cdc29932aed":"200000000000000000000","0x7b761feb7fcfa7ded1f0eb058f4a600bf3a708cb":"4600000000000000000000","0x5435c6c1793317d32ce13bba4c4ffeb973b78adc":"250070000000000000000","0xdd04eee74e0bf30c3f8d6c2c7f52e0519210df93":"80000000000000000000","0x4331ab3747d35720a9d8ca25165cd285acd4bda8":"2000000000000000000000","0xb84c8b9fd33ece00af9199f3cf5fe0cce28cd14a":"3820000000000000000000","0x393f783b5cdb86221bf0294fb714959c7b45899c":"5910000000000000000000","0x259ec4d265f3ab536b7c70fa97aca142692c13fc":"20400000000000000000","0x5d2f7f0b04ba4be161e19cb6f112ce7a5e7d7fe4":"35200000000000000000","0xd54ba2d85681dc130e5b9b02c4e8c851391fd9b9":"3940000000000000000000","0x5cd8af60de65f24dc3ce5730ba92653022dc5963":"1790000000000000000000","0x3b42a66d979f582834747a8b60428e9b4eeccd23":"620400000000000000000","0x4b19eb0c354bc1393960eb06063b83926f0d67b2":"29000000000000000000","0x8cf3546fd1cda33d58845fc8fcfecabca7c5642a":"574027000000000000000","0x113612bc3ba0ee4898b49dd20233905f2f458f62":"14000000000000000000000","0x1f2afc0aed11bfc71e77a907657b36ea76e3fb99":"4000000000000000000000","0x03714b41d2a6f751008ef8dd4d2b29aecab8f36e":"6000000000000000000000","0x25721c87b0dc21377c7200e524b14a22f0af69fb":"4000000000000000000000","0x335858f749f169cabcfe52b796e3c11ec47ea3c2":"200000000000000000000","0x52fb46ac5d00c3518b2c3a1c177d442f8165555f":"1500000000000000000000","0x7a8c89c014509d56d7b68130668ff6a3ecec7370":"300000000000000000000","0x7d5d2f73949dadda0856b206989df0078d51a1e5":"10560000000000000000000","0xbe538246dd4e6f0c20bf5ad1373c3b463a131e86":"200000000000000000000","0x62680a15f8ccb8bdc02f7360c25ad8cfb57b8ccd":"1000000000000000000000","0xaa0ca3737337178a0caac3099c584b056c56301c":"880000000000000000000","0x1d341fa5a3a1bd051f7db807b6db2fc7ba4f9b45":"18200000000000000000","0x6463f715d594a1a4ace4bb9c3b288a74decf294d":"1970000000000000000000","0xe00d153b10369143f97f54b8d4ca229eb3e8f324":"152000000000000000000","0x8d0b9ea53fd263415eac11391f7ce9123c447062":"2000000000000000000000","0xcacb675e0996235404efafbb2ecb8152271b55e0":"700000000000000000000","0xb615e940143eb57f875893bc98a61b3d618c1e8c":"20000000000000000000","0x606f177121f7855c21a5062330c8762264a97b31":"4000000000000000000000","0xe3925509c8d0b2a6738c5f6a72f35314491248ce":"1012961000000000000000","0x3f08d9ad894f813e8e2148c160d24b353a8e74b0":"60000000000000000000000","0x40f4f4c06c732cd35b119b893b127e7d9d0771e4":"10000000000000000000000","0x1406854d149e081ac09cb4ca560da463f3123059":"1337000000000000000000","0xecf05d07ea026e7ebf4941002335baf2fed0f002":"200000000000000000000","0x9a990b8aeb588d7ee7ec2ed8c2e64f7382a9fee2":"33518000000000000000","0xa2e0683a805de6a05edb2ffbb5e96f0570b637c3":"20000000000000000000","0xfba5486d53c6e240494241abf87e43c7600d413a":"1987592000000000000000","0xd81bd54ba2c44a6f6beb1561d68b80b5444e6dc6":"1163806000000000000000","0x5298ab182a19359ffcecafd7d1b5fa212dede6dd":"20000000000000000000","0xd1acb5adc1183973258d6b8524ffa28ffeb23de3":"4000000000000000000000","0x4e7aa67e12183ef9d7468ea28ad239c2eef71b76":"4925000000000000000000","0x509a20bc48e72be1cdaf9569c711e8648d957334":"2000000000000000000000","0x949f84f0b1d7c4a7cf49ee7f8b2c4a134de32878":"685000000000000000000","0xedbac9527b54d6df7ae2e000cca3613ba015cae3":"1970000000000000000000","0xc697b70477cab42e2b8b266681f4ae7375bb2541":"5577200000000000000000","0x86c934e38e53be3b33f274d0539cfca159a4d0d1":"970000000000000000000","0x0877eeaeab78d5c00e83c32b2d98fa79ad51482f":"439420000000000000000","0x5e11ecf69d551d7f4f84df128046b3a13240a328":"20000000000000000000","0x43ff8853e98ed8406b95000ada848362d6a0392a":"22100000000000000000000","0xf11cf5d363746fee6864d3ca336dd80679bb87ae":"40000000000000000000000","0xfb223c1e22eac1269b32ee156a5385922ed36fb8":"2000000000000000000000","0x4e6600806289454acda330a2a3556010dfacade6":"6000000000000000000000","0xcfe2caaf3cec97061d0939748739bffe684ae91f":"10000000000000000000000","0xadeb52b604e5f77faaac88275b8d6b49e9f9f97f":"2089268000000000000000","0xd53c567f0c3ff2e08b7d59e2b5c73485437fc58d":"600000000000000000000","0xfbf75933e01b75b154ef0669076be87f62dffae1":"78000000000000000000000","0x7dfd2962b575bcbeee97f49142d63c30ab009f66":"4000000000000000000000","0xdf6485c4297ac152b289b19dde32c77ec417f47d":"1000000000000000000000","0xffb974673367f5c07be5fd270dc4b7138b074d57":"2470407000000000000000","0xf7d7af204c56f31fd94398e40df1964bd8bf123c":"150011000000000000000","0x4506fe19fa4b006baa3984529d8516db2b2b50ab":"2000000000000000000000","0xf4dc7ba85480bbb3f535c09568aaa3af6f3721c6":"7214962000000000000000","0xd171c3f2258aef35e599c7da1aa07300234da9a6":"2000000000000000000000","0x33581cee233088c0860d944e0cf1ceabb8261c2e":"13370000000000000000","0x1c2e3607e127caca0fbd5c5948adad7dd830b285":"19700000000000000000000","0xfd7ede8f5240a06541eb699d782c2f9afb2170f6":"1337000000000000000000","0x368c5414b56b8455171fbf076220c1cba4b5ca31":"557940000000000000000","0x3e8745ba322f5fd6cb50124ec46688c7a69a7fae":"4925000000000000000000","0x76506eb4a780c951c74a06b03d3b8362f0999d71":"500000000000000000000","0x96d62dfd46087f62409d93dd606188e70e381257":"2000000000000000000000","0x37eada93c475ded2f7e15e7787d400470fa52062":"200000000000000000000","0x26babf42b267fdcf3861fdd4236a5e474848b358":"1000000000000000000000","0x3526eece1a6bdc3ee7b400fe935b48463f31bed7":"82400000000000000000","0x27b62816e1e3b8d19b79d1513d5dfa855b0c3a2a":"99941000000000000000","0xb3e3c439069880156600c2892e448d4136c92d9b":"850000000000000000000","0x574ad9355390e4889ef42acd138b2a27e78c00ae":"1557000000000000000000","0xf0b9d683cea12ba600baace219b0b3c97e8c00e4":"100000000000000000000","0xa437fe6ec103ca8d158f63b334224eccac5b3ea3":"8000000000000000000000","0x7a48d877b63a8f8f9383e9d01e53e80c528e955f":"8000000000000000000000","0xe965daa34039f7f0df62375a37e5ab8a72b301e7":"4796000000000000000000","0x72cd048a110574482983492dfb1bd27942a696ba":"2000000000000000000000","0x6611ce59a98b072ae959dc49ad511daaaaa19d6b":"200000000000000000000","0x0d92582fdba05eabc3e51538c56db8813785b328":"191000000000000000000","0xe87e9bbfbbb71c1a740c74c723426df55d063dd9":"7998000000000000000000","0x9c99a1da91d5920bc14e0cb914fdf62b94cb8358":"20000000000000000000000","0xfe8e6e3665570dff7a1bda697aa589c0b4e9024a":"2000000000000000000000","0x811461a2b0ca90badac06a9ea16e787b33b196cc":"164000000000000000000","0xd211b21f1b12b5096181590de07ef81a89537ead":"2000000000000000000000","0x01155057002f6b0d18acb9388d3bc8129f8f7a20":"1340000000000000000000","0x8ce22f9fa372449a420610b47ae0c8d565481232":"2000000000000000000000","0xe02b74a47628be315b1f76b315054ad44ae9716f":"4000000000000000000000","0x92a7c5a64362e9f842a23deca21035857f889800":"1999944000000000000000","0x5213f459e078ad3ab95a0920239fcf1633dc04ca":"2599989000000000000000","0xc9957ba94c1b29e5277ec36622704904c63dc023":"1923000000000000000000","0x6ac40f532dfee5118117d2ad352da77d4f6da2c8":"400000000000000000000","0xea1efb3ce789bedec3d67c3e1b3bc0e9aa227f90":"734000000000000000000","0xb01e389b28a31d8e4995bdd7d7c81beeab1e4119":"1000000000000000000000","0xee97aa8ac69edf7a987d6d70979f8ec1fbca7a94":"376000000000000000000","0x0fad05507cdc8f24b2be4cb7fa5d927ddb911b88":"3004447000000000000000","0xb6e8afd93dfa9af27f39b4df06076710bee3dfab":"25000000000000000000","0x7d0b255efb57e10f7008aa22d40e9752dfcf0378":"29944000000000000000","0xaef5b12258a18dec07d5ec2e316574919d79d6d6":"2000000000000000000000","0x63666755bd41b5986997783c13043008242b3cb5":"500000000000000000000","0x921f5261f4f612760706892625c75e7bce96b708":"2000000000000000000000","0x10e1e3377885c42d7df218522ee7766887c05e6a":"300031000000000000000","0x134163be9fbbe1c5696ee255e90b13254395c318":"200000000000000000000","0x870f15e5df8b0eabd02569537a8ef93b56785c42":"388000000000000000000","0x68eec1e288ac31b6eaba7e1fbd4f04ad579a6b5d":"2000000000000000000000","0x1a2694ec07cf5e4d68ba40f3e7a14c53f3038c6e":"1000073000000000000000","0xcd9b4cef73390c83a8fd71d7b540a7f9cf8b8c92":"90000000000000000000","0xc8de7a564c7f4012a6f6d10fd08f47890fbf07d4":"300000000000000000000","0xc0345b33f49ce27fe82cf7c84d141c68f590ce76":"1000000000000000000000","0xfe53b94989d89964da2061539526bbe979dd2ea9":"1930600000000000000000","0x14410fb310711be074a80883c635d0ef6afb2539":"2000000000000000000000","0x1d344e962567cb27e44db9f2fac7b68df1c1e6f7":"1940000000000000000000","0xfe016ec17ec5f10e3bb98ff4a1eda045157682ab":"375804000000000000000","0xe89da96e06beaf6bd880b378f0680c43fd2e9d30":"601400000000000000000","0x0fee81ac331efd8f81161c57382bb4507bb9ebec":"400030000000000000000","0x40cf90ef5b768c5da585002ccbe6617650d8e837":"999800000000000000000","0x256fa150cc87b5056a07d004efc84524739e62b5":"200000000000000000000","0x1b9b2dc2960e4cb9408f7405827c9b59071612fd":"1000000000000000000000","0x0efd1789eb1244a3dede0f5de582d8963cb1f39f":"1500000000000000000000","0x049c5d4bc6f25d4e456c697b52a07811ccd19fb1":"300048000000000000000","0x02b7b1d6b34ce053a40eb65cd4a4f7dddd0e9f30":"685000000000000000000","0xc1827686c0169485ec15b3a7c8c01517a2874de1":"40000000000000000000","0xd8e5c9675ef4deed266b86956fc4590ea7d4a27d":"1000000000000000000000","0x48f883e567b436a27bb5a3124dbc84dec775a800":"771840000000000000000","0xa34076f84bd917f20f8342c98ba79e6fb08ecd31":"4200000000000000000000","0x21ce6d5b9018cec04ad6967944bea39e8030b6b8":"20000000000000000000","0x0596a27dc3ee115fce2f94b481bc207a9e261525":"1000000000000000000000","0x717cf9beab3638308ded7e195e0c86132d163fed":"15097428000000000000000","0xd5ce55d1b62f59433c2126bcec09bafc9dfaa514":"197000000000000000000","0x7dd46da677e161825e12e80dc446f58276e1127c":"820000000000000000000","0x98c5494a03ac91a768dffc0ea1dde0acbf889019":"200000000000000000000000","0x617ff2cc803e31c9082233b825d025be3f7b1056":"1970000000000000000000","0x1091176be19b9964a8f72e0ece6bf8e3cfad6e9c":"10020000000000000000000","0x4ea56e1112641c038d0565a9c296c463afefc17e":"182000000000000000000","0xe303167f3d4960fe881b32800a2b4aeff1b088d4":"2000000000000000000000","0x773141127d8cf318aebf88365add3d5527d85b6a":"1000076000000000000000","0xb916b1a01cdc4e56e7657715ea37e2a0f087d106":"2406017000000000000000","0x46a430a2d4a894a0d8aa3feac615361415c3f81f":"2000000000000000000000","0xe6a3010f0201bc94ff67a2f699dfc206f9e76742":"879088000000000000000","0xd7ad09c6d32657685355b5c6ec8e9f57b4ebb982":"1970000000000000000000","0x95e80a82c20cbe3d2060242cb92d735810d034a2":"32511000000000000000","0x9a390162535e398877e416787d6239e0754e937c":"1000000000000000000000","0xd85fdeaf2a61f95db902f9b5a53c9b8f9266c3ac":"2010000000000000000000","0xc3e20c96df8d4e38f50b265a98a906d61bc51a71":"2000000000000000000000","0x2949fd1def5c76a286b3872424809a07db3966f3":"5236067000000000000000","0x86cdb7e51ac44772be3690f61d0e59766e8bfc18":"4000000000000000000000","0x749a4a768b5f237248938a12c623847bd4e688dc":"72000000000000000000","0x3524a000234ebaaf0789a134a2a417383ce5282a":"5635000000000000000000","0x7b43c7eea8d62355b0a8a81da081c6446b33e9e0":"4000000000000000000000","0x0eb189ef2c2d5762a963d6b7bdf9698ea8e7b48a":"1337000000000000000000","0x767fd7797d5169a05f7364321c19843a8c348e1e":"18800000000000000000","0x1b2639588b55c344b023e8de5fd4087b1f040361":"1500000000000000000000","0x1e33d1c2fb5e084f2f1d54bc5267727fec3f985d":"500000000000000000000","0x06b106649aa8c421ddcd1b8c32cd0418cf30da1f":"40000000000000000000000","0x3c5a241459c6abbf630239c98a30d20b8b3ac561":"157600000000000000000","0x0f4f94b9191bb7bb556aaad7c74ddb288417a50b":"1400000000000000000000","0xd6f4a7d04e8faf20e8c6eb859cf7f78dd23d7a15":"131784000000000000000","0x61adf5929a5e2981684ea243baa01f7d1f5e148a":"110302000000000000000","0x8f58d8348fc1dc4e0dd8343b6543c857045ee940":"13632400000000000000000","0xa6e3baa38e104a1e27a4d82869afb1c0ae6eff8d":"19690000000000000000","0x67350b5331926f5e28f3c1e986f96443809c8b8c":"352000000000000000000","0x0b5d66b13c87b392e94d91d5f76c0d450a552843":"2000000000000000000000","0x562a8dcbbeeef7b360685d27303bd69e094accf6":"10000000000000000000000","0xb5d9934d7b292bcf603b2880741eb760288383a0":"16700000000000000000","0x6fc53662371dca587b59850de78606e2359df383":"180000000000000000000","0xe069c0173352b10bf6834719db5bed01adf97bbc":"18894000000000000000","0x10a93457496f1108cd98e140a1ecdbae5e6de171":"399600000000000000000","0x69ff8901b541763f817c5f2998f02dcfc1df2997":"40000000000000000000","0x00c27d63fde24b92ee8a1e7ed5d26d8dc5c83b03":"2000000000000000000000","0x77f81b1b26fc84d6de97ef8b9fbd72a33130cc4a":"1000000000000000000000","0x6d20ef9704670a500bb269b5832e859802049f01":"130000000000000000000","0x186afdc085f2a3dce4615edffbadf71a11780f50":"200000000000000000000","0x7ff0c63f70241bece19b737e5341b12b109031d8":"346000000000000000000","0x9d4174aa6af28476e229dadb46180808c67505c1":"1219430000000000000000","0x5fec49c665e64ee89dd441ee74056e1f01e92870":"6320000000000000000000","0x6cd228dc712169307fe27ceb7477b48cfc8272e5":"77600000000000000000","0xfd918536a8efa6f6cefe1fa1153995fef5e33d3b":"500000000000000000000","0x2fbb504a5dc527d3e3eb0085e2fc3c7dd538cb7a":"1249961000000000000000","0x6ab323ae5056ed0a453072c5abe2e42fcf5d7139":"880000000000000000000","0x67d682a282ef73fb8d6e9071e2614f47ab1d0f5e":"1000000000000000000000","0x1858cf11aea79f5398ad2bb22267b5a3c952ea74":"9850000000000000000000","0x39d6caca22bccd6a72f87ee7d6b59e0bde21d719":"2002000000000000000000","0xdaa63cbda45dd487a3f1cd4a746a01bb5e060b90":"4797800000000000000000","0xa90476e2efdfee4f387b0f32a50678b0efb573b5":"10000000000000000000000","0xae5aa1e6c2b60f6fd3efe721bb4a719cbe3d6f5d":"795860000000000000000","0xac2e766dac3f648f637ac6713fddb068e4a4f04d":"197000000000000000000","0x6191ddc9b64a8e0890b4323709d7a07c48b92a64":"775000000000000000000","0xcc4f0ff2aeb67d54ce3bc8c6510b9ae83e9d328b":"400000000000000000000","0xca23f62dff0d6460036c62e840aec5577e0befd2":"140800000000000000000","0x97dc26ec670a31e0221d2a75bc5dc9f90c1f6fd4":"50000000000000000000","0x848c994a79003fe7b7c26cc63212e1fc2f9c19eb":"2000000000000000000000","0x20c284ba10a20830fc3d699ec97d2dfa27e1b95e":"2000000000000000000000","0x4fa3f32ef4086448b344d5f0a9890d1ce4d617c3":"1500000000000000000000","0x255abc8d08a096a88f3d6ab55fbc7352bddcb9ce":"82161000000000000000","0x7c60e51f0be228e4d56fdd2992c814da7740c6bc":"200000000000000000000","0x1c356cfdb95febb714633b28d5c132dd84a9b436":"25000000000000000000","0x5062e5134c612f12694dbd0e131d4ce197d1b6a4":"1000000000000000000000","0xed862616fcbfb3becb7406f73c5cbff00c940755":"1700000000000000000000","0x62c9b271ffd5b770a5eee4edc9787b5cdc709714":"2000000000000000000000","0x3c925619c9b33144463f0537d896358706c520b0":"2000000000000000000000","0xffe2e28c3fb74749d7e780dc8a5d422538e6e451":"253319000000000000000","0x37195a635dcc62f56a718049d47e8f9f96832891":"1970000000000000000000","0x90e9a9a82edaa814c284d232b6e9ba90701d4952":"100007000000000000000","0xe0c4ab9072b4e6e3654a49f8a8db026a4b3386a9":"2000000000000000000000","0x439dee3f7679ff1030733f9340c096686b49390b":"2000000000000000000000","0x548558d08cfcb101181dac1eb6094b4e1a896fa6":"1999944000000000000000","0x3090f8130ec44466afadb36ed3c926133963677b":"4000000000000000000000","0xd1648503b1ccc5b8be03fa1ec4f3ee267e6adf7b":"5828000000000000000000","0x65b42faecc1edfb14283ca979af545f63b30e60c":"18200000000000000000","0x6420f8bcc8164a6152a99d6b99693005ccf7e053":"999972000000000000000","0x84b4b74e6623ba9d1583e0cfbe49643f16384149":"20000000000000000000","0xb8310a16cc6abc465007694b930f978ece1930bd":"740000000000000000000","0x16019a4dafab43f4d9bf4163fae0847d848afca2":"25060000000000000000","0x479298a9de147e63a1c7d6d2fce089c7e64083bd":"9999999000000000000000","0x030973807b2f426914ad00181270acd27b8ff61f":"5348000000000000000000","0xb07bcf1cc5d4462e5124c965ecf0d70dc27aca75":"1600000000000000000000","0xa2f798e077b07d86124e1407df32890dbb4b6379":"200000000000000000000","0x0cbd921dbe121563b98a6871fecb14f1cc7e88d7":"200000000000000000000","0x6042276df2983fe2bc4759dc1943e18fdbc34f77":"1970000000000000000000","0xbe2b2280523768ea8ac35cd9e888d60a719300d4":"2000000000000000000000","0x2f4da753430fc09e73acbccdcde9da647f2b5d37":"200000000000000000000","0x734223d27ff23e5906caed22595701bb34830ca1":"2000000000000000000000","0x5b430d779696a3653fc60e74fbcbacf6b9c2baf1":"14000000000000000000000","0x84232107932b12e03186583525ce023a703ef8d9":"2000000000000000000000","0x4ed14d81b60b23fb25054d8925dfa573dcae6168":"340000000000000000000","0x8b338411f26ccf37658cc75521d77629099e467d":"2000000000000000000000","0xa37622ac9bbdc4d82b75015d745b9f8de65a28ec":"2910000000000000000000","0x1dd77441844afe9cc18f15d8c77bccfb655ee034":"4850000000000000000000","0x65849be1af20100eb8a3ba5a5be4d3ae8db5a70e":"400000000000000000000","0xd5586da4e59583c8d86cccf71a86197f17996749":"2000000000000000000000","0x4b53ae59c784b6b5c43616b9a0809558e684e10c":"1200000000000000000000","0x55d42eb495bf46a634997b5f2ea362814918e2b0":"106128000000000000000","0x959ff17f1d51b473b44010052755a7fa8c75bd54":"1970000000000000000000","0x5a2daab25c31a61a92a4c82c9925a1d2ef58585e":"225400000000000000000","0x24c0c88b54a3544709828ab4ab06840559f6c5e2":"2674000000000000000000","0x7e8649e690fc8c1bfda1b5e186581f649b50fe33":"98500000000000000000","0x4acfa9d94eda6625c9dfa5f9f4f5d107c4031fdf":"39400000000000000000","0x5778ffdc9b94c5a59e224eb965b6de90f222d170":"335320000000000000000","0x825a7f4e10949cb6f8964268f1fa5f57e712b4c4":"20000000000000000000","0x6f39cc37caaa2ddc9b610f6131e0619fae772a3c":"500000000000000000000","0x5b437365ae3a9a2ff97c68e6f90a7620188c7d19":"2002000000000000000000","0x6710c2c03c65992b2e774be52d3ab4a6ba217ef7":"11600000000000000000000","0x896e335ca47af57962fa0f4dbf3e45e688cba584":"1368500000000000000000","0xb57549bfbc9bdd18f736b22650e48a73601fa65c":"446000000000000000000","0x85ca1e727e9d1a87991cc2c41840ebb9edf21d1b":"13370000000000000000","0xcf4166746e1d3bc1f8d0714b01f17e8a62df1464":"1004700000000000000000","0x4a75c3d4fa6fccbd5dd5a703c15379a1e783e9b7":"1820000000000000000000","0x9e5811b40be1e2a1e1d28c3b0774acde0a09603d":"3000000000000000000000","0x763886e333c56feff85be3951ab0b889ce262e95":"2000000000000000000000","0x2b101e822cd962962a06800a2c08d3b15d82b735":"152000000000000000000","0xa01e9476df84431825c836e8803a97e22fa5a0cd":"6000000000000000000000","0xbe4e7d983f2e2a636b1102ec7039efebc842e98d":"66000000000000000000","0x9e427272516b3e67d4fcbf82f59390d04c8e28e5":"4000000000000000000000","0xe0d231e144ec9107386c7c9b02f1702ceaa4f700":"5000057000000000000000","0x6a0f056066c2d56628850273d7ecb7f8e6e9129e":"5000016000000000000000","0xd1538e9a87e59ca9ec8e5826a5b793f99f96c4c3":"1000000000000000000000","0xf85bab1cb3710fc05fa19ffac22e67521a0ba21d":"2003000000000000000000","0xf7cbdba6be6cfe68dbc23c2b0ff530ee05226f84":"20000000000000000000","0x4eb87ba8788eba0df87e5b9bd50a8e45368091c1":"20000000000000000000","0x1479a9ec7480b74b5db8fc499be352da7f84ee9c":"1000000000000000000000","0xd311bcd7aa4e9b4f383ff3d0d6b6e07e21e3705d":"200000000000000000000","0x425c1816868f7777cc2ba6c6d28c9e1e796c52b3":"10000000000000000000000","0x8510ee934f0cbc900e1007eb38a21e2a5101b8b2":"106000000000000000000","0x01e864d354741b423e6f42851724468c74f5aa9c":"20000000000000000000000","0xa543a066fb32a8668aa0736a0c9cd40d78098727":"1000000000000000000000","0xf3eb1948b951e22df1617829bf3b8d8680ec6b68":"4000000000000000000000","0xf6b782f4dcd745a6c0e2e030600e04a24b25e542":"400000000000000000000","0x229f4f1a2a4f540774505b4707a81de44410255b":"2000000000000000000000","0xcff8d06b00e3f50c191099ad56ba6ae26571cd88":"1000000000000000000000","0x910b7d577a7e39aa23acf62ad7f1ef342934b968":"10000000000000000000000","0x392433d2ce83d3fb4a7602cca3faca4ec140a4b0":"51000000000000000000","0x8ff46045687723dc33e4d099a06904f1ebb584dc":"2000000000000000000000","0x9ca0429f874f8dcee2e9c062a9020a842a587ab9":"2000000000000000000000","0x160ceb6f980e04315f53c4fc988b2bf69e284d7d":"19100000000000000000","0xc340f9b91c26728c31d121d5d6fc3bb56d3d8624":"2000000000000000000000","0xafa1d5ad38fed44759c05b8993c1aa0dace19f40":"80000000000000000000","0x3969b4f71bb8751ede43c016363a7a614f76118e":"2000000000000000000000","0x2bb6f578adfbe7b2a116b3554facf9969813c319":"7400000000000000000000","0x8334764b7b397a4e578f50364d60ce44899bff94":"92500000000000000000","0x9dd2196624a1ddf14a9d375e5f07152baf22afa2":"1211747000000000000000","0xf242da845d42d4bf779a00f295b40750fe49ea13":"1000000000000000000000","0xc6234657a807384126f8968ca1708bb07baa493c":"20000000000000000000","0x94c055e858357aaa30cf2041fa9059ce164a1f91":"19999000000000000000000","0x74c73c90528a157336f1e7ea20620ae53fd24728":"8969310000000000000000","0x19e7f3eb7bf67f3599209ebe08b62ad3327f8cde":"2000000000000000000000","0xb2b516fdd19e7f3864b6d2cf1b252a4156f1b03b":"53720000000000000000","0x8164e78314ae16b28926cc553d2ccb16f356270d":"8450000000000000000000","0x4d828894752f6f25175daf2177094487954b6f9f":"1459683000000000000000","0xab84a0f147ad265400002b85029a41fc9ce57f85":"1000000000000000000000","0xf3fe51fde34413c73318b9c85437fe7e820f561a":"1003200000000000000000","0x16c7b31e8c376282ac2271728c31c95e35d952c3":"2000000000000000000000","0x80d5c40c59c7f54ea3a55fcfd175471ea35099b3":"1000000000000000000000","0x7abb10f5bd9bc33b8ec1a82d64b55b6b18777541":"20000000000000000000000","0x095b0ea2b218d82e0aea7c2889238a39c9bf9077":"20000000000000000000000","0x5d5cdbe25b2a044b7b9be383bcaa5807b06d3c6b":"2000000000000000000000","0x323749a3b971959e46c8b4822dcafaf7aaf9bd6e":"20064000000000000000","0xe0272213e8d2fd3e96bd6217b24b4ba01b617079":"20000000000000000000","0x00acbfb2f25a5485c739ef70a44eeeeb7c65a66f":"100000000000000000000","0x52f15423323c24f19ae2ab673717229d3f747d9b":"1026115000000000000000","0xcb4abfc282aed76e5d57affda542c1f382fcacf4":"8136100000000000000000","0xf71b4534f286e43093b1e15efea749e7597b8b57":"104410000000000000000000","0x44cd77535a893fa7c4d5eb3a240e79d099a72d2d":"820000000000000000000","0xeb3ce7fc381c51db7d5fbd692f8f9e058a4c703d":"200000000000000000000","0xf1c8c4a941b4628c0d6c30fda56452d99c7e1b64":"1449000000000000000000","0x277677aba1e52c3b53bfa2071d4e859a0af7e8e1":"1000000000000000000000","0xa5f075fd401335577b6683c281e6d101432dc6e0":"2680000000000000000000","0xe28dbc8efd5e416a762ec0e018864bb9aa83287b":"24533161000000000000000","0x2b717cd432a323a4659039848d3b87de26fc9546":"500000000000000000000000","0xb358e97c70b605b1d7d729dfb640b43c5eafd1e7":"20000000000000000000000","0x293c2306df3604ae4fda0d207aba736f67de0792":"200000000000000000000","0x74d366b07b2f56477d7c7077ac6fe497e0eb6559":"5000000000000000000000","0x490145afa8b54522bb21f352f06da5a788fa8f1d":"9231182000000000000000","0x862569211e8c6327b5415e3a67e5738b15baaf6e":"140000000000000000000","0x5a74ba62e7c81a3474e27d894fed33dd24ad95fe":"18200000000000000000","0x536e4d8029b73f5579dca33e70b24eba89e11d7e":"1970000000000000000000","0x25c6e74ff1d928df98137af4df8430df24f07cd7":"390000000000000000000","0x19b36b0c87ea664ed80318dc77b688dde87d95a5":"1948386000000000000000","0xabc4caeb474d4627cb6eb456ecba0ecd08ed8ae1":"3940000000000000000000","0x8ea656e71ec651bfa17c5a5759d86031cc359977":"100000000000000000000","0x8d620bde17228f6cbba74df6be87264d985cc179":"100000000000000000000","0xb2aa2f1f8e93e79713d92cea9ffce9a40af9c82d":"2000000000000000000000","0x198ef1ec325a96cc354c7266a038be8b5c558f67":"608334724000000000000000","0x6a13d5e32c1fd26d7e91ff6e053160a89b2c8aad":"53480000000000000000","0xe056bf3ff41c26256fef51716612b9d39ade999c":"100009000000000000000","0x2c128c95d957215101f043dd8fc582456d41016d":"835000000000000000000","0x2560b09b89a4ae6849ed5a3c9958426631714466":"1700000000000000000000","0xd3d6e9fb82542fd29ed9ea3609891e151396b6f7":"54000000000000000000000","0xa7607b42573bb6f6b4d4f23c7e2a26b3a0f6b6f0":"1610000000000000000000","0x020362c3ade878ca90d6b2d889a4cc5510eed5f3":"1042883000000000000000","0x14830704e99aaad5c55e1f502b27b22c12c91933":"620000000000000000000","0x8030b111c6983f0485ddaca76224c6180634789f":"80000000000000000000","0x2c5b7d7b195a371bf9abddb42fe04f2f1d9a9910":"200000000000000000000","0x77d43fa7b481dbf3db530cfbf5fdced0e6571831":"2000000000000000000000","0x2d90b415a38e2e19cdd02ff3ad81a97af7cbf672":"109800000000000000000","0x2fc82ef076932341264f617a0c80dd571e6ae939":"7160000000000000000000","0xdfe549fe8430e552c6d07cc3b92ccd43b12fb50f":"83620000000000000000","0x1e8e689b02917cdc29245d0c9c68b094b41a9ed6":"2000000000000000000000","0x21c3a8bba267c8cca27b1a9afabad86f607af708":"8940000000000000000000","0x143c639752caeecf6a997d39709fc8f19878c7e8":"1970000000000000000000","0x02603d7a3bb297c67c877e5d34fbd5b913d4c63a":"20000000000000000000","0xa166f911c644ac3213d29e0e1ae010f794d5ad26":"2000000000000000000000","0x6eb3819617404058268f0c3cff3596bfe9148c1c":"1670000000000000000000","0x7a67dd043a504fc2f2fc7194e9becf484cecb1fb":"250000000000000000000","0xf824ee331e4ac3cc587693395b57ecf625a6c0c2":"1600930000000000000000","0x1179c60dbd068b150b074da4be23033b20c68558":"680000000000000000000","0xd2a479404347c5543aab292ae1bb4a6f158357fa":"4000000000000000000000","0xb0d32bd7e4e695b7b01aa3d0416f80557dba9903":"16300000000000000000000","0xf734ec03724ddee5bb5279aa1afcf61b0cb448a1":"4238080000000000000000","0xc04069dfb18b096c7867f8bee77a6dc7477ad062":"2674000000000000000000","0x80c53ee7e3357f94ce0d7868009c208b4a130125":"2000000000000000000000","0x0f32d9cb4d0fdaa0150656bb608dcc43ed7d9301":"753978000000000000000","0x6ddb6092779d5842ead378e21e8120fd4c6bc132":"2000000000000000000000","0x82ea01e3bf2e83836e71704e22a2719377efd9c3":"3040000000000000000000","0x44c1110b18870ec81178d93d215838c551d48e64":"199958000000000000000","0x7727af101f0aaba4d23a1cafe17c6eb5dab1c6dc":"2000000000000000000000","0xa11a03c4bb26d21eff677d5d555c80b25453ee7a":"69979000000000000000","0x19e5dea3370a2c746aae34a37c531f41da264e83":"200000000000000000000","0xc325c352801ba883b3226c5feb0df9eae2d6e653":"3940000000000000000000","0xae5055814cb8be0c117bb8b1c8d2b63b4698b728":"32035000000000000000","0xdeb1bc34d86d4a4dde2580d8beaf074eb0e1a244":"1580000000000000000000","0x558360206883dd1b6d4a59639e5629d0f0c675d0":"2000000000000000000000","0xa9d6f871ca781a759a20ac3adb972cf12829a208":"925000000000000000000","0xb0ac4eff6680ee14169cdadbffdb30804f6d25f5":"2000000000000000000000","0xf1b58faffa8794f50af8e88309c7a6265455d51a":"999800000000000000000","0xa61a54df784a44d71b771b87317509211381f200":"1000000000000000000000","0xbaa4b64c2b15b79f5f204246fd70bcbd86e4a92a":"500000000000000000000","0xa20d8ff60caae31d02e0b665fa435d76f77c9442":"489600000000000000000","0xf3e74f470c7d3a3f0033780f76a89f3ef691e6cb":"3021800000000000000000","0xd330728131fe8e3a15487a34573c93457e2afe95":"4000000000000000000000","0x9af9dbe47422d177f945bdead7e6d82930356230":"3940000000000000000000","0x0eb5b662a1c718608fd52f0c25f9378830178519":"6091400000000000000000","0xfda6810ea5ac985d6ffbf1c511f1c142edcfddf7":"4000000000000000000000","0x832c54176bdf43d2c9bcd7b808b89556b89cbf31":"200000000000000000000","0x704d5de4846d39b53cd21d1c49f096db5c19ba29":"152000000000000000000","0x344a8db086faed4efc37131b3a22b0782dad7095":"500000000000000000000","0x8c7fa5cae82fedb69ab189d3ff27ae209293fb93":"400030000000000000000","0xad660dec825522a9f62fcec3c5b731980dc286ea":"3000000000000000000000","0x13b9b10715714c09cfd610cf9c9846051cb1d513":"1970000000000000000000","0x40467d80e74c35407b7db51789234615fea66818":"388000000000000000000","0x30e9d5a0088f1ddb2fd380e2a049192266c51cbf":"196910000000000000000","0xb2d1e99af91231858e7065dd1918330dc4c747d5":"16700000000000000000000","0x9f21302ca5096bea7402b91b0fd506254f999a3d":"1246832000000000000000","0xd24b6644f439c8051dfc64d381b8c86c75c17538":"2000000000000000000000","0x8228ebc087480fd64547ca281f5eace3041453b9":"1970000000000000000000","0x29da3e35b23bb1f72f8e2258cf7f553359d24bac":"20000000000000000000000","0xc8e558a3c5697e6fb23a2594c880b7a1b68f9860":"10000000000000000000000","0x6b951a43274eeafc8a0903b0af2ec92bf1efc839":"100000000000000000000","0xd015f6fcb84df7bb410e8c8f04894a881dcac237":"1038000000000000000000","0x6ccb03acf7f53ce87aadcc21a9932de915f89804":"8000000000000000000000","0x388c85a9b9207d8146033fe38143f6d34b595c47":"200000000000000000000","0x429c06b487e8546abdfc958a25a3f0fba53f6f00":"13503000000000000000","0x771507aeee6a255dc2cd9df55154062d0897b297":"334250000000000000000","0x5a2b1c853aeb28c45539af76a00ac2d8a8242896":"25000000000000000000","0xf4d67a9044b435b66e8977ff39a28dc4bd53729a":"200000000000000000000","0x063759dd1c4e362eb19398951ff9f8fad1d31068":"10000000000000000000000","0xcb58990bcd90cfbf6d8f0986f6fa600276b94e2d":"999925000000000000000","0x6df5c84f7b909aab3e61fe0ecb1b3bf260222ad2":"4000000000000000000000","0xdeb2495d6aca7b2a6a2d138b6e1a42e2dc311fdd":"2000000000000000000000","0x59203cc37599b648312a7cc9e06dacb589a9ae6a":"148689000000000000000","0xfc9b347464b2f9929d807e039dae48d3d98de379":"14000000000000000000000","0x48d2434b7a7dbbff08223b6387b05da2e5093126":"18000000000000000000000","0xc9d76446d5aadff80b68b91b08cd9bc8f5551ac1":"714000000000000000000","0x3d31587b5fd5869845788725a663290a49d3678c":"500000000000000000000","0xd8715ef9176f850b2e30eb8e382707f777a6fbe9":"2000000000000000000000","0x2c2147947ae33fb098b489a5c16bfff9abcd4e2a":"200000000000000000000","0xd6c0d0bc93a62e257174700e10f024c8b23f1f87":"2000000000000000000000","0xd1978f2e34407fab1dc2183d95cfda6260b35982":"788000000000000000000","0x1bf974d9904f45ce81a845e11ef4cbcf27af719e":"100000000000000000000","0x6e761eaa0f345f777b5441b73a0fa5b56b85f22d":"2000000000000000000000","0xea60436912de6bf187d3a472ff8f5333a0f7ed06":"19700000000000000000","0x94f8f057db7e60e675ad940f155885d1a477348e":"401100000000000000000","0x8933491760c8f0b4df8caac78ed835caee21046d":"20000000000000000000000","0xa7775e4af6a23afa201fb78b915e51a515b7a728":"120000000000000000000","0xd8d64384249b776794063b569878d5e3b530a4b2":"177569000000000000000","0xbe633a3737f68439bac7c90a52142058ee8e8a6f":"960000000000000000000","0x90bd62a050845261fa4a9f7cf241ea630b05efb8":"500000000000000000000","0x552987f0651b915b2e1e5328c121960d4bdd6af4":"1790000000000000000000","0x0baf6ecdb91acb3606a8357c0bc4f45cfd2d7e6f":"1000000000000000000000","0x9e5a311d9f69898a7c6a9d6360680438e67a7b2f":"1490000000000000000000","0x78859c5b548b700d9284cee4b6633c2f52e529c2":"2955000000000000000000","0xd572309169b1402ec8131a17a6aac3222f89e6eb":"13800000000000000000000","0x8e6d7485cbe990acc1ad0ee9e8ccf39c0c93440e":"955000000000000000000","0x75c11d024d12ae486c1095b7a7b9c4af3e8edeb9":"20000000000000000000","0x903413878aea3bc1086309a3fe768b65559e8cab":"8000000000000000000000","0x6d0569e5558fc7df2766f2ba15dc8aeffc5beb75":"4001070000000000000000","0x3815b0743f94fc8cc8654fd9d597ed7d8b77c57e":"738578000000000000000","0x0f26480a150961b8e30750713a94ee6f2e47fc00":"1000000000000000000000","0xede5de7c7fb7eee0f36e64530a41440edfbefacf":"617200000000000000000","0x763a7cbab70d7a64d0a7e52980f681472593490c":"600000000000000000000","0x6e270ad529f1f0b8d9cb6d2427ec1b7e2dc64a74":"200000000000000000000","0xeb3bdd59dcdda5a9bb2ac1641fd02180f5f36560":"6600000000000000000000","0xf4ebf50bc7e54f82e9b9bd24baef29438e259ce6":"10000000000000000000000","0x882c8f81872c79fed521cb5f950d8b032322ea69":"40000000000000000000000","0x394132600f4155e07f4d45bc3eb8d9fb72dcd784":"2941000000000000000000","0x0be2b94ad950a2a62640c35bfccd6c67dae450f6":"1940000000000000000000","0xd4c6ac742e7c857d4a05a04c33d4d05c1467571d":"200000000000000000000","0x1fddd85fc98be9c4045961f40f93805ecc4549e5":"164000000000000000000","0x534065361cb854fac42bfb5c9fcde0604ac919da":"2000000000000000000000","0x9a6ff5f6a7af7b7ae0ed9c20ecec5023d281b786":"2547000000000000000000","0x4f3a4854911145ea01c644044bdb2e5a960a982f":"4000000000000000000000","0x00497e92cdc0e0b963d752b2296acb87da828b24":"194800000000000000000","0x4ff67fb87f6efba9279930cfbd1b7a343c79fade":"400000000000000000000","0x62f2e5ccecd52cc4b95e0597df27cc079715608c":"143000000000000000000","0x1eda084e796500ba14c5121c0d90846f66e4be62":"534800000000000000000","0x9836b4d30473641ab56aeee19242761d72725178":"2000000000000000000000","0xde55de0458f850b37e4d78a641dd2eb2dd8f38ce":"4000000000000000000000","0x140ca28ff33b9f66d7f1fc0078f8c1eef69a1bc0":"1600000000000000000000","0x2014261f01089f53795630ba9dd24f9a34c2d942":"1337000000000000000000","0x11415fab61e0dfd4b90676141a557a869ba0bde9":"2048000000000000000000","0x88344909644c7ad4930fd873ca1c0da2d434c07f":"131970000000000000000","0x88b217ccb786a254cf4dc57f5d9ac3c455a30483":"925000000000000000000","0xdfdbcec1014b96da2158ca513e9c8d3b9af1c3d0":"2000000000000000000000","0x1ba9f7997e5387b6b2aa0135ac2452fe36b4c20d":"850000000000000000000","0xd70ad2c4e9eebfa637ef56bd486ad2a1e5bce093":"200000000000000000000","0x9ce27f245e02d1c312c1d500788c9def7690453b":"200000000000000000000","0x8234f463d18485501f8f85ace4972c9b632dbccc":"2000000000000000000000","0x994152fc95d5c1ca8b88113abbad4d710e40def6":"500000000000000000000","0xe5b980d28eece2c06fca6c9473068b37d4a6d6e9":"695200000000000000000","0x2d426912d059fad9740b2e390a2eeac0546ff01b":"1400000000000000000000","0x6d9997509882027ea947231424bedede2965d0ba":"2001600000000000000000","0x167ce7de65e84708595a525497a3eb5e5a665073":"575400000000000000000","0xe430c0024fdbf73a82e21fccf8cbd09138421c21":"4000000000000000000000","0x2e52912bc10ea39d54e293f7aed6b99a0f4c73be":"400000000000000000000","0x12cf8b0e465213211a5b53dfb0dd271a282c12c9":"15200000000000000000","0x06964e2d17e9189f88a8203936b40ac96e533c06":"18200000000000000000","0x66b1a63da4dcd9f81fe54f5e3fcb4055ef7ec54f":"201412000000000000000","0x0a77e7f72b437b574f00128b21f2ac265133528c":"2000000000000000000000","0x78f5c74785c5668a838072048bf8b453594ddaab":"400000000000000000000","0x58e554af3d87629620da61d538c7f5b4b54c4afe":"1297081000000000000000","0x37a10451f36166cf643dd2de6c1cbba8a011cfa3":"380000000000000000000","0xfe9ad12ef05d6d90261f96c8340a0381974df477":"2000000000000000000000","0x057f7f81cd7a406fc45994408b5049912c566463":"1700000000000000000000","0x55a3df57b7aaec16a162fd5316f35bec082821cf":"1970000000000000000000","0xc0e0b903088e0c63f53dd069575452aff52410c3":"3000000000000000000000","0x63e88e2e539ffb450386b4e46789b223f5476c45":"6292000000000000000000","0x3727341f26c12001e378405ee38b2d8464ec7140":"2000000000000000000000","0xc96751656c0a8ef4357b7344322134b983504aca":"2000000000000000000000","0x1e060dc6c5f1cb8cc7e1452e02ee167508b56542":"12715500000000000000000","0x18136c9df167aa17b6f18e22a702c88f4bc28245":"4000000000000000000000","0x116108c12084612eeda7a93ddcf8d2602e279e5c":"2000000000000000000000","0xbbb643d2187b364afc10a6fd368d7d55f50d1a3c":"1000000000000000000000","0xec83e798c396b7a55e2a2224abcd834b27ea459c":"12000000000000000000000","0x973f4e361fe5decd989d4c8f7d7cc97990385daf":"388500000000000000000","0xc0f29ed0076611b5e55e130547e68a48e26df5e4":"3000000000000000000000","0xfd4b551f6fdbcda6c511b5bb372250a6b783e534":"20600000000000000000","0x144b19f1f66cbe318347e48d84b14039466c5909":"2000000000000000000000","0xbf183641edb886ce60b8190261e14f42d93cce01":"25019000000000000000","0x94db807873860aac3d5aea1e885e52bff2869954":"3220000000000000000000","0x7a74cee4fa0f6370a7894f116cd00c1147b83e59":"800000000000000000000","0xcd32a4a8a27f1cc63954aa634f7857057334c7a3":"1085000000000000000000","0x7cbeb99932e97e6e02058cfc62d0b26bc7cca52b":"2000000000000000000000","0x8cde8b732e6023878eb23ed16229124b5f7afbec":"133700000000000000000","0x45c4ecb4ee891ea984a7c5cefd8dfb00310b2850":"1980000000000000000000","0x8b393fb0813ee101db1e14ecc7d322c72b8c0473":"455578000000000000000","0x7b66126879844dfa34fe65c9f288117fefb449ad":"6000000000000000000000","0x162ba503276214b509f97586bd842110d103d517":"9002000000000000000000","0x7dece6998ae1900dd3770cf4b93812bad84f0322":"100000000000000000000","0xec0927bac7dc36669c28354ab1be83d7eec30934":"2000000000000000000000","0x8d7f3e61299c2db9b9c0487cf627519ed00a9123":"1742400000000000000000","0x4fc46c396e674869ad9481638f0013630c87caac":"1000000000000000000000","0xbf68d28aaf1eeefef646b65e8cc8d190f6c6da9c":"2000000000000000000000","0x00969747f7a5b30645fe00e44901435ace24cc37":"1700000000000000000000","0x494dec4d5ee88a2771a815f1ee7264942fb58b28":"2000000000000000000000","0xffeac0305ede3a915295ec8e61c7f881006f4474":"98500000000000000000","0xb39139576194a0866195151f33f2140ad1cc86cf":"100000000000000000000000","0xfead1803e5e737a68e18472d9ac715f0994cc2be":"500000000000000000000","0x698ab9a2f33381e07c0c47433d0d21d6f336b127":"20000000000000000000","0xe5edc73e626f5d3441a45539b5f7a398c593edf6":"865000000000000000000","0xdd4f5fa2111db68f6bde3589b63029395b69a92d":"158400000000000000000","0x8c93c3c6db9d37717de165c3a1b4fe51952c08de":"400000000000000000000","0xf87bb07b289df7301e54c0efda6a2cf291e89200":"1400000000000000000000","0xe7a4560c84b20e0fb54c49670c2903b0a96c42a4":"598000000000000000000","0x00a5797f52c9d58f189f36b1d45d1bf6041f2f6b":"5456900000000000000000","0x9da3302240af0511c6fd1857e6ddb7394f77ab6b":"3100000000000000000000","0x2c2d15ff39561c1b72eda1cc027ffef23743a144":"3920000000000000000000","0x9b4c2715780ca4e99e60ebf219f1590c8cad500a":"1600000000000000000000","0xff5e7ee7d5114821e159dca5e81f18f1bfffbff9":"2000000000000000000000","0x0169c1c210eae845e56840412e1f65993ea90fb4":"2000000000000000000000","0xabc45f84db7382dde54c5f7d8938c42f4f3a3bc4":"200000000000000000000","0xd9383d4b6d17b3f9cd426e10fb944015c0d44bfb":"800000000000000000000","0xc090fe23dcd86b358c32e48d2af91024259f6566":"200000000000000000000","0x9ffedcc36b7cc312ad2a9ede431a514fccb49ba3":"669800000000000000000","0x2ffe93ec1a5636e9ee34af70dff52682e6ff7079":"2000000000000000000000","0x6e01e4ad569c95d007ada30d5e2db12888492294":"4000000000000000000000","0xd4d92c62b280e00f626d8657f1b86166cb1f740f":"200028000000000000000","0x1d36683063b7e9eb99462dabd569bddce71686f2":"1000000000000000000000","0x3a48e0a7098b06a905802b87545731118e89f439":"2000000000000000000000","0xbd9e56e902f4be1fc8768d8038bac63e2acbbf8e":"999972000000000000000","0x4d67f2ab8599fef5fc413999aa01fd7fce70b43d":"10000000000000000000000","0x8e74e0d1b77ebc823aca03f119854cb12027f6d7":"107200000000000000000000","0x7e5b19ae1be94ff4dee635492a1b012d14db0213":"100000000000000000000","0x5de9e7d5d1b667d095dd34099c85b0421a0bc681":"20000000000000000000","0x316eb4e47df71b42e16d6fe46825b7327baf3124":"4000000000000000000000","0x772c297f0ad194482ee8c3f036bdeb01c201d5cc":"200000000000000000000","0xd7052519756af42590f15391b723a03fa564a951":"4615591000000000000000","0x2c6846a1aa999a2246a287056000ba4dcba8e63d":"10020000000000000000000","0xde5b005fe8daae8d1f05de3eda042066c6c4691c":"1100000000000000000000","0x254c1ecc630c2877de8095f0a8dba1e8bf1f550c":"1700000000000000000000","0xf8f226142a428434ab17a1864a2597f64aab2f06":"172473000000000000000","0xa6c910ce4d494a919ccdaaa1fc3b82aa74ba06cf":"8000000000000000000000","0xe587b16abc8a74081e3613e14342c03375bf0847":"2000000000000000000000","0x6f176065e88e3c6fe626267d18a088aaa4db80bc":"3520000000000000000000","0x50dcbc27bcad984093a212a9b4178eabe9017561":"145512000000000000000","0xe1953c6e975814c571311c34c0f6a99cdf48ab82":"50000000000000000000","0xbe0a2f385f09dbfce96732e12bb40ac349871ba8":"1610348000000000000000","0x4712540265cbeec3847022c59f1b318d43400a9e":"3500000000000000000000","0x29bdc4f28de0180f433c2694eb74f5504ce94337":"2000000000000000000000","0x2f66bfbf2262efcc8d2bd0444fc5b0696298ff1e":"9940000000000000000000","0x506411fd79003480f6f2b6aac26b7ba792f094b2":"500000000000000000000","0x23ea669e3564819a83b0c26c00a16d9e826f6c46":"1430590000000000000000","0xe3ffb02cb7d9ea5243701689afd5d417d7ed2ece":"78000000000000000000","0x38e7dba8fd4f1f850dbc2649d8e84f0952e3eb3c":"50000000000000000000","0x8644cc281be332ccced36da483fb2a0746d9ba2e":"400000000000000000000","0xe8a91da6cf1b9d65c74a02ec1f96eecb6dd241f3":"1940000000000000000000","0x0631dc40d74e5095e3729eddf49544ecd4396f67":"160000000000000000000","0x83c897a84b695eebe46679f7da19d776621c2694":"500000000000000000000","0xdb73460b59d8e85045d5e752e62559875e42502e":"999800000000000000000","0x0dd4e674bbadb1b0dc824498713dce3b5156da29":"170000000000000000000","0xe3933d61b77dcdc716407f8250bc91e4ffaeb09d":"86600000000000000000000","0x58c90754d2f20a1cb1dd330625e04b45fa619d5c":"2000000000000000000000","0x895ec5545644e0b78330fffab8ddeac9e833156c":"600000000000000000000","0x7e1e29721d6cb91057f6c4042d8a0bbc644afe73":"159800000000000000000","0x72b90a4dc097239492c5b9777dcd1e52ba2be2c2":"6000000000000000000000","0x64241a7844290e0ab855f1d4aa75b55345032224":"1600000000000000000000","0x6fd4e0f3f32bee6d3767fdbc9d353a6d3aab7899":"695240000000000000000","0x3a035594c747476d42d1ee966c36224cdd224993":"355890000000000000000","0xde97f4330700b48c496d437c91ca1de9c4b01ba4":"2910840000000000000000","0x716ad3c33a9b9a0a18967357969b94ee7d2abc10":"482000000000000000000","0xbfbe05e88c9cbbcc0e92a405fac1d85de248ee24":"100000000000000000000","0xcfc4e6f7f8b011414bfba42f23adfaa78d4ecc5e":"1850000000000000000000","0xd931ac2668ba6a84481ab139735aec14b7bfbabf":"2000000000000000000000","0xe3263ce8af6db3e467584502ed7109125eae22a5":"2000000000000000000000","0xf78258c12481bcdddbb72a8ca0c043097261c6c5":"20000000000000000000","0x4493123c021ece3b33b1a452c9268de14007f9d3":"6685000000000000000000","0x431f2c19e316b044a4b3e61a0c6ff8c104a1a12f":"1000000000000000000000","0xe63e787414b9048478a50733359ecdd7e3647aa6":"1580000000000000000000","0xe4715956f52f15306ee9506bf82bccc406b3895e":"274944000000000000000","0xf7f91e7acb5b8129a306877ce3168e6f438b66a1":"176000000000000000000","0xdcdbbd4e2604e40e1710cc6730289dccfad3892d":"4600000000000000000000","0x2b5f4b3f1e11707a227aa5e69fa49dded33fb321":"6000000000000000000000","0x01488ad3da603c4cdd6cb0b7a1e30d2a30c8fc38":"200000000000000000000","0x841145b44840c946e21dbc190264b8e0d5029369":"300000000000000000000000","0xbf05070c2c34219311c4548b2614a438810ded6d":"2000000000000000000000","0x38f387e1a4ed4a73106ef2b462e474e2e3143ad0":"6000000000000000000000","0xf116b0b4680f53ab72c968ba802e10aa1be11dc8":"20000000000000000000","0xbea0afc93aae2108a3fac059623bf86fa582a75e":"1700000000000000000000","0x4c997992036c5b433ac33d25a8ea1dc3d4e4e6d8":"29200000000000000000","0xab7e0b83ed9a424c6d1e6a6f87a4dbf06409c7d6":"2400000000000000000000","0xd71fb130f0150c565269e00efb43902b52a455a6":"200000000000000000000","0x99b018932bcad355b6792b255db6702dec8ce5dd":"4000086000000000000000","0x4b904e934bd0cc8b20705f879e905b93ea0ccc30":"2000000000000000000000","0x672ec42faa8cd69aaa71b32cc7b404881d52ff91":"10000000000000000000000","0xacbc2d19e06c3babbb5b6f052b6bf7fc37e07229":"200000000000000000000","0xcea8743341533cb2f0b9c6efb8fda80d77162825":"100000000000000000000","0x9568b7de755628af359a84543de23504e15e41e6":"40000000000000000000000","0x6ec96d13bdb24dc7a557293f029e02dd74b97a55":"4000000000000000000000","0xd95c90ffbe5484864780b867494a83c89256d6e4":"1640000000000000000000","0xade6f8163bf7c7bb4abe8e9893bd0cc112fe8872":"327600000000000000000","0x250eb7c66f869ddf49da85f3393e980c029aa434":"4000000000000000000000","0xa35c19132cac1935576abfed6c0495fb07881ba0":"2000000000000000000000","0xd5550caaf743b037c56fd2558a1c8ed235130750":"5347598000000000000000","0x03097923ba155e16d82f3ad3f6b815540884b92c":"1820000000000000000000","0xd6d9e30f0842012a7176a917d9d2048ca0738759":"4000000000000000000000","0xab9ad36e5c74ce2e96399f57839431d0e79f96ab":"164000000000000000000","0x75be8ff65e5788aec6b2a52d5fa7b1e7a03ba675":"67720000000000000000","0x4f6d4737d7a940382487264886697cf7637f8015":"1670000000000000000000","0x5f7b3bbac16dab831a4a0fc53b0c549dc36c31ca":"1940000000000000000000","0xd843ee0863ce933e22f89c802d31287b9671e81c":"13370000000000000000","0x361f3ba9ed956b770f257d3672fe1ff9f7b0240c":"600000000000000000000","0x6c0ae9f043c834d44271f13406593dfe094f389f":"1517545000000000000000","0xdb34745ede8576b499db01beb7c1ecda85cf4abe":"80000000000000000000","0x7be8ccb4f11b66ca6e1d57c0b5396221a31ba53a":"20000000000000000000","0x128b908fe743a434203de294c441c7e20a86ea67":"713304000000000000000","0xdf236bf6abf4f3293795bf0c28718f93e3b1b36b":"1337000000000000000000","0x14254ea126b52d0142da0a7e188ce255d8c47178":"775000000000000000000","0xceed47ca5b899fd1623f21e9bd4db65a10e5b09d":"133196000000000000000","0x30acd858875fa24eef0d572fc7d62aad0ebddc35":"400000000000000000000","0x47a281dff64167197855bf6e705eb9f2cef632ea":"1000072000000000000000","0x297d5dbe222f2fb52531acbd0b013dc446ac7368":"20000000000000000000000","0xadf85203c8376a5fde9815384a350c3879c4cb93":"1147300000000000000000","0xc3e0471c64ff35fa5232cc3121d1d38d1a0fb7de":"2000000000000000000000","0xfdecc82ddfc56192e26f563c3d68cb544a96bfed":"440000000000000000000","0x2614f42d5da844377578e6b448dc24305bef2b03":"2000000000000000000000","0x1d96bcd58457bbf1d3c2a46ffaf16dbf7d836859":"171313000000000000000","0xbd66ffedb530ea0b2e856dd12ac2296c31fe29e0":"200000000000000000000","0x6e84876dbb95c40b6656e42ba9aea08a993b54dc":"1101932000000000000000","0xa1c4f45a82e1c478d845082eb18875c4ea6539ab":"200000000000000000000000","0x2c964849b1f69cc7cea4442538ed87fdf16cfc8f":"2000000000000000000000","0x45b47105fe42c4712dce6e2a21c05bffd5ea47a9":"2000000000000000000000","0x31e9c00f0c206a4e4e7e0522170dc81e88f3eb70":"2685000000000000000000","0x5fe77703808f823e6c399352108bdb2c527cb87c":"1960000000000000000000","0x2272186ef27dcbe2f5fc373050fdae7f2ace2316":"16100000000000000000000","0xb7576e9d314df41ec5506494293afb1bd5d3f65d":"20000000000000000000","0xac9fff68c61b011efbecf038ed72db97bb9e7281":"9550000000000000000000","0xcd9529492b5c29e475acb941402b3d3ba50686b0":"1970000000000000000000","0xf19b39389d47b11b8a2c3f1da9124decffbefaf7":"2000000000000000000000","0x9e951f6dc5e352afb8d04299d2478a451259bf56":"72004000000000000000","0x8eb1fbe4e5d3019cd7d30dae9c0d5b4c76fb6331":"2000000000000000000000","0x29cc804d922be91f5909f348b0aaa5d21b607830":"4000000000000000000000","0x5c7b9ec7a2438d1e3c7698b545b9c3fd77b7cd55":"1000000000000000000000","0xa16160851d2b9c349b92e46f829abfb210943595":"1790000000000000000000","0xeac6b98842542ea10bb74f26d7c7488f698b6452":"20000000000000000000000","0x57825aeb09076caa477887fbc9ae37e8b27cc962":"100000000000000000000","0xb35e8a1c0dac7e0e66dbac736a592abd44012561":"14974000000000000000","0x756b84eb85fcc1f4fcdcc2b08db6a86e135fbc25":"3220000000000000000000","0xe13b3d2bbfdcbc8772a23315724c1425167c5688":"1032115000000000000000","0x0a2dcb7a671701dbb8f495728088265873356c8e":"152120000000000000000","0x03cb4c4f4516c4ff79a1b6244fbf572e1c7fea79":"2740000000000000000000","0x98ba4e9ca72fddc20c69b4396f76f8183f7a2a4e":"12800000000000000000000","0xf8087786b42da04ed6d1e0fe26f6c0eefe1e9f5a":"10000000000000000000000","0x02f7f67209b16a17550c694c72583819c80b54ad":"98400000000000000000","0x32bb2e9693e4e085344d2f0dbd46a283e3a087fd":"400000000000000000000","0x9c78963fbc263c09bd72e4f8def74a9475f7055c":"13790000000000000000000","0x27144ca9a7771a836ad50f803f64d869b2ae2b20":"4000000000000000000000","0xcc758d071d25a6320af68c5dc9c4f6955ba94520":"6000000000000000000000","0xcb42b44eb5fd60b5837e4f9eb47267523d1a229c":"865000000000000000000","0xaaf5b207b88b0de4ac40d747cee06e172df6e745":"31428000000000000000000","0x52d380511df19d5ec2807bbcb676581b67fd37a3":"13400000000000000000","0xaa1b3768c16d821f580e76c8e4c8e86d7dc78853":"400000000000000000000","0x41098a81452317c19e3eef0bd123bbe178e9e9ca":"2800000000000000000000","0x267148fd72c54f620a592fb92799319cc4532b5c":"410000000000000000000","0xd7cdbd41fff20df727c70b6255c1ba7606055468":"200000000000000000000","0x0e33fcbbc003510be35785b52a9c5d216bc005f4":"1880000000000000000000","0x6727daf5b9d68efcab489fedec96d7f7325dd423":"2000000000000000000000","0xcd0a161bc367ae0927a92aac9cf6e5086714efca":"2000000000000000000000","0x612667f172135b950b2cd1de10afdece6857b873":"1000000000000000000000","0x900194c4b1074305d19de405b0ac78280ecaf967":"1000000000000000000000","0x51f55ef47e6456a418ab32b9221ed27dba6608ee":"4200000000000000000000","0x0da532c910e3ac0dfb14db61cd739a93353fd05f":"1336866000000000000000","0x21df2dcdaf74b2bf803404dd4de6a35eabec1bbd":"6920000000000000000000","0xf0e7fb9e420a5340d536f40408344feaefc06aef":"1000000000000000000000","0x6742a2cfce8d79a2c4a51b77747498912245cd6a":"258064000000000000000","0x8663a241a0a89e70e182c845e2105c8ad7264bcf":"14825507000000000000000","0x18e113d8177c691a61be785852fa5bb47aeebdaf":"1337000000000000000000","0x1bec4d02ce85fc48feb62489841d85b170586a9b":"2400000000000000000000","0x287cf9d0902ef819a7a5f149445bf1775ee8c47c":"16000000000000000000000","0x28967280214e218a120c5dda37041b111ea36d74":"200000000000000000000","0xa0b771951ce1deee363ae2b771b73e07c4b5e800":"1400000000000000000000","0x29f8fba4c30772b057edbbe62ae7420c390572e1":"1000000000000000000000","0xee34c7e7995db9f187cff156918cfb6f13f6e003":"1960000000000000000000","0x916bf7e3c545921d3206d900c24f14127cbd5e70":"18020000000000000000000","0x93235f340d2863e18d2f4c52996516138d220267":"73800000000000000000","0x7efec0c6253caf397f71287c1c07f6c9582b5b86":"482839000000000000000","0x8d2e31b08803b2c5f13d398ecad88528209f6057":"9993000000000000000000","0x964eab4b276b4cd8983e15ca72b106900fe41fce":"500000000000000000000","0xeea1e97988de75d821cd28ad6822b22cce988b31":"520000000000000000000","0x278c0bde630ec393b1e7267fc9d7d97019e4145b":"2000000000000000000000","0x82e4461eb9d849f0041c1404219e4272c4900ab4":"2000000000000000000000","0x4a73389298031b8816cca946421c199e18b343d6":"631254000000000000000","0x9a5af31c7e06339ac8b4628d7c4db0ce0f45c8a4":"500000000000000000000","0xcb9b5103e4ce89af4f64916150bff9eecb9faa5c":"500000000000000000000","0x740f641614779dcfa88ed1d425d60db42a060ca6":"998630000000000000000","0xa4e623451e7e94e7e89ba5ed95c8a83a62ffc4ea":"20000000000000000000","0x25a500eeec7a662a841552b5168b707b0de21e9e":"10020000000000000000000","0x185a7fc4ace368d233e620b2a45935661292bdf2":"20000000000000000000000","0x9b68f67416a63bf4451a31164c92f672a68759e9":"60000000000000000000000","0xa38b5bd81a9db9d2b21d5ec7c60552cd02ed561b":"6000000000000000000000","0x61c830f1654718f075ccaba316faacb85b7d120b":"400000000000000000000","0x8392e53776713578015bff4940cf43849d7dcba1":"153190000000000000000","0xdc57477dafa42f705c7fe40eae9c81756e0225f1":"500044000000000000000","0xfebc3173bc9072136354002b7b4fb3bfc53f22f1":"370000000000000000000","0xd78f84e38944a0e0255faece48ba4950d4bd39d2":"5000000000000000000000","0xa7a3bb6139b0ada00c1f7f1f9f56d994ba4d1fa8":"2000000000000000000000","0xaa3f29601a1331745e05c42830a15e71938a6237":"1700000000000000000000","0xbec6640f4909b58cbf1e806342961d607595096c":"1999944000000000000000","0x9be3c329b62a28b8b0886cbd8b99f8bc930ce3e6":"74500000000000000000","0xe3eb2c0a132a524f72ccc0d60fee8b41685d39e2":"1970000000000000000000","0x90b1f370f9c1eb0be0fb8e2b8ad96a416371dd8a":"900000000000000000000","0xf2742e6859c569d5f2108351e0bf4dca352a48a8":"10000000000000000000000","0xb134c004391ab4992878337a51ec242f42285742":"2000000000000000000000","0xab7416ff32254951cbbc624ec7fb45fc7ecaa872":"340000000000000000000","0x9795f64319fc17dd0f8261f9d206fb66b64cd0c9":"200000000000000000000","0x64e03ef070a54703b7184e48276c5c0077ef4b34":"320000000000000000000","0x3430a16381f869f6ea5423915855e800883525a9":"17900000000000000000000","0xf4a367b166d2991a2bfda9f56463a09f252c1b1d":"1970000000000000000000","0x77c4a697e603d42b12056cbba761e7f51d0443f5":"680000000000000000000","0x153ef58a1e2e7a3eb6b459a80ab2a547c94182a2":"96000000000000000000000","0x6dbe8abfa1742806263981371bf3d35590806b6e":"20000000000000000000000","0x4c99dae96481e807c1f99f8b7fbde29b7547c5bf":"150000000000000000000","0xd5b9d277d8aad20697a51f76e20978996bffe055":"143250000000000000000","0x0f24105abbdaa03fa6309ef6c188e51f714a6e59":"200000000000000000000","0x1cb6b2d7cfc559b7f41e6f56ab95c7c958cd0e4c":"1337000000000000000000","0xf37b426547a1642d8033324814f0ede3114fc212":"401100000000000000000","0x318f1f8bd220b0558b95fb33100ffdbb640d7ca6":"4000000000000000000000","0x206d55d5792a514ec108e090599f2a065e501185":"200550000000000000000","0x11d2247a221e70c2d66d17ee138d38c55ffb8640":"10000000000000000000000","0xe8de725eca5def805ff7941d31ac1c2e342dfe95":"2462500000000000000000","0xd561cbbc05515de73ab8cf9eae1357341e7dfdf4":"6000000000000000000000","0x0455dcec8a7fc4461bfd7f37456fce3f4c3caac7":"400000000000000000000","0x5161fd49e847f67455f1c8bb7abb36e985260d03":"1200000000000000000000","0x8e073bad25e42218615f4a0e6b2ea8f8de2230c0":"2402500000000000000000","0x6c08a6dc0173c7342955d1d3f2c065d62f83aec7":"20000000000000000000","0x95cb6d8a6379f94aba8b885669562c4d448e56a7":"2000000000000000000000","0x2805415e1d7fdec6dedfb89e521d10592d743c10":"100000000000000000000","0xdaacdaf42226d15cb1cf98fa15048c7f4ceefe69":"300000000000000000000","0xe33df4ce80ccb62a76b12bcdfcecc46289973aa9":"6000000000000000000000","0x8f8cd26e82e7c6defd02dfad07979021cbf7150c":"3000000000000000000000","0x77a17122fa31b98f1711d32a99f03ec326f33d08":"1700000000000000000000","0x6f791d359bc3536a315d6382b88311af8ed6da47":"92000000000000000000","0xde30e49e5ab313214d2f01dcabce8940b81b1c76":"197000000000000000000","0xcf9be9b9ab86c66b59968e67b8d4dcff46b1814a":"660000000000000000000","0x7fdfc88d78bf1b285ac64f1adb35dc11fcb03951":"2287900000000000000000","0xc5134cfbb1df7a20b0ed7057622eeed280947dad":"3800000000000000000000","0xfa9ec8efe08686fa58c181335872ba698560ecab":"1999944000000000000000","0xf6a8635757c5e8c134d20d028cf778cf8609e46a":"1459416000000000000000","0x6265b2e7730f36b776b52d0c9d02ada55d8e3cb6":"1000000000000000000000","0x6a8cea2de84a8df997fd3f84e3083d93de57cda9":"100007000000000000000","0x1b7ed974b6e234ce81247498429a5bd4a0a2d139":"2000000000000000000000","0x9ba53dc8c95e9a472feba2c4e32c1dc4dd7bab46":"1337000000000000000000","0xd7b740dff8c457668fdf74f6a266bfc1dcb723f9":"20000000000000000000","0x07bc2cc8eedc01970700efc9c4fb36735e98cd71":"4000000000000000000000","0x3e1c962063e0d5295941f210dca3ab531eec8809":"3000000000000000000000","0xb447571dacbb3ecbb6d1cf0b0c8f3838e52324e2":"30199000000000000000","0x87764e3677eef604cbc59aed24abdc566b09fc25":"3000000000000000000000","0x03aa622881236dd0f4940c24c324ff8b7b7e2186":"3200000000000000000000","0xa4a7d306f510cd58359428c0d2f7c3609d5674d7":"3349000000000000000000","0x3c83c1701db0388b68210d00f5717cd9bd322c6a":"30000000000000000000000","0x047d5a26d7ad8f8e70600f70a398ddaa1c2db26f":"6000000000000000000000","0x43767bf7fd2af95b72e9312da9443cb1688e4343":"300000000000000000000","0x34a85d6d243fb1dfb7d1d2d44f536e947a4cee9e":"20000000000000000000000","0x65a9dad42e1632ba3e4e49623fab62a17e4d3611":"93120000000000000000","0x48e0cbd67f18acdb7a6291e1254db32e0972737f":"100007000000000000000","0xa5de5e434fdcdd688f1c31b6fb512cb196724701":"800000000000000000000","0x6d63d38ee8b90e0e6ed8f192eda051b2d6a58bfd":"30000000000000000000","0xb079bb4d9866143a6da72ae7ac0022062981315c":"760000000000000000000","0xc0413f5a7c2d9a4b8108289ef6ecd271781524f4":"50000000000000000000000","0xa91a5a7b341f99c535144e20be9c6b3bb4c28e4d":"5431790000000000000000","0x993f146178605e66d517be782ef0b3c61a4e1925":"7011998000000000000000","0x966c04781cb5e67dde3235d7f8620e1ab663a9a5":"75800000000000000000000","0xb3f82a87e59a39d0d2808f0751eb72c2329cdcc5":"5000000000000000000000","0x9b77ebced7e215f0920e8c2b870024f6ecb2ff31":"1000000000000000000000","0xfe697ff22ca547bfc95e33d960da605c6763f35b":"1325000000000000000000","0x480af52076009ca73781b70e43b95916a62203ab":"924171000000000000000","0xa9dc0424c6969d798358b393b1933a1f51bee00a":"20000000000000000000000","0x7aba56f63a48bc0817d6b97039039a7ad62fae2e":"600000000000000000000","0x59d139e2e40c7b97239d23dfaca33858f602d22b":"2000000000000000000000","0x8d6170ff66978e773bb621bf72b1ba7be3a7f87e":"200000000000000000000","0xd668523a90f0293d65c538d2dd6c57673710196e":"39500000000000000000","0xbbb5a0f4802c8648009e8a6998af352cde87544f":"95500000000000000000","0xfc43829ac787ff88aaf183ba352aadbf5a15b193":"3960000000000000000000","0xfe22a0b388668d1ae2643e771dacf38a434223cc":"4000304000000000000000","0x092acb624b08c05510189bbbe21e6524d644ccad":"18200000000000000000","0x8f0538ed71da1155e0f3bde5667ceb84318a1a87":"1940000000000000000000","0x06994cd83aa2640a97b2600b41339d1e0d3ede6c":"250000000000000000000","0x9d460c1b379ddb19a8c85b4c6747050ddf17a875":"3340000000000000000000","0x77a769fafdecf4a638762d5ba3969df63120a41d":"2000000000000000000000","0x5f375b86600c40cca8b2676b7a1a1d1644c5f52c":"78838000000000000000","0x15ee0fc63ebf1b1fc49d7bb38f8863823a2e17d2":"1910000000000000000000","0x6651736fb59b91fee9c93aa0bd6ea2f7b2506180":"500000000000000000000","0x361d9ed80b5bd27cf9f1226f26753258ee5f9b3f":"3530900000000000000000","0xc9b6b686111691ee6aa197c7231a88dc60bd295d":"500000000000000000000","0xe9b4a4853577a9dbcc2e795be0310d1bed28641a":"1000000000000000000000","0x36758e049cd98bcea12277a676f9297362890023":"4000000000000000000000","0x6bb50813146a9add42ee22038c9f1f7469d47f47":"200200000000000000000","0x6de4b581385cf7fc9fe8c77d131fe2ee7724c76a":"2308840000000000000000","0xd2a5a024230a57ccc666760b89b0e26cafd189c7":"49997115000000000000000","0x65af9087e05167715497c9a5a749189489004def":"835000000000000000000","0xead21c1deccfbf1c5cd96688a2476b69ba07ce4a":"72800000000000000000","0xe308435204793764f5fcbe65eb510f5a744a655a":"200000000000000000000","0x9376dce2af2ec8dcda741b7e7345664681d93668":"1000000000000000000000","0xa1b47c4d0ed6018842e6cfc8630ac3a3142e5e6b":"20000000000000000000","0xe2198c8ca1b399f7521561fd5384a7132fba486b":"1015200000000000000000","0x92c13fe0d6ce87fd50e03def9fa6400509bd7073":"40000000000000000000","0x7517f16c28d132bb40e3ba36c6aef131c462da17":"18200000000000000000","0x6a023af57d584d845e698736f130db9db40dfa9a":"98800000000000000000","0x1518627b88351fede796d3f3083364fbd4887b0c":"16000000000000000000000","0xf5b6e9061a4eb096160777e26762cf48bdd8b55d":"254030000000000000000","0x28073efc17d05cab3195c2db332b61984777a612":"1000000000000000000000","0xf06a854a3c5dc36d1c49f4c87d6db333b57e4add":"10000000000000000000000","0x9225983860a1cb4623c72480ac16272b0c95e5f5":"2000000000000000000000","0x5260dc51ee07bddaababb9ee744b393c7f4793a6":"34040000000000000000","0x0f127bbf8e311caea2ba502a33feced3f730ba42":"188000000000000000000","0x17d521a8d9779023f7164d233c3b6420ffd223ed":"20000000000000000000","0x8c2b7d8b608d28b77f5caa9cd645242a823e4cd9":"1820000000000000000000","0x6e866d032d405abdd65cf651411d803796c22311":"2000000000000000000000","0xdc51b2dc9d247a1d0e5bc36ca3156f7af21ff9f6":"1000000000000000000000","0xc84d9bea0a7b9f140220fd8b9097cfbfd5edf564":"123047000000000000000","0xff86e5e8e15b53909600e41308dab75f0e24e46b":"902400000000000000000","0xd7164aa261c09ad9b2b5068d453ed8eb6aa13083":"3000000000000000000000","0x76aaf8c1ac012f8752d4c09bb46607b6651d5ca8":"20000000000000000000","0x41786a10d447f484d33244ccb7facd8b427b5b8c":"1000000000000000000000","0x2e0c57b47150f95aa6a7e16ab9b1cbf54328979a":"100000000000000000000","0x3f747237806fed3f828a6852eb0867f79027af89":"1500000000000000000000","0xa568db4d57e4d67462d733c69a9e0fe26e218327":"1096140000000000000000","0x1f88f8a1338fc7c10976abcd3fb8d38554b5ec9c":"13400000000000000000","0xd1ea4d72a67b5b3e0f315559f52bd0614d713069":"2000000000000000000000","0xbfaeb91067617dcf8b44172b02af615674835dba":"160661000000000000000","0xb71a13ba8e95167b80331b52d69e37054fe7a826":"200000000000000000000","0xb67a80f170197d96cdcc4ab6cba627b4afa6e12c":"2400000000000000000000","0x35af040a0cc2337a76af288154c7561e1a233349":"1000000000000000000000","0xc86190904b8d079ec010e462cbffc90834ffaa5c":"10100000000000000000000","0x383304dd7a5720b29c1a10f60342219f48032f80":"5600000000000000000000","0x191313525238a21c767457a91374f02200c55448":"116400000000000000000","0xcc4a2f2cf86cf3e43375f360a4734691195f1490":"1348127000000000000000","0x4e020779b5ddd3df228a00cb48c2fc979da6ae38":"2000000000000000000000","0xe206fb7324e9deb79e19903496d6961b9be56603":"100000000000000000000","0x3ae160e3cd60ae31b9d6742d68e14e76bd96c517":"30000000000000000000","0x1f7d8e86d6eeb02545aad90e91327bd369d7d2f3":"20000000000000000000","0x68c7d1711b011a33f16f1f55b5c902cce970bdd7":"152000000000000000000","0x637be71b3aa815ff453d5642f73074450b64c82a":"2000000000000000000000","0x1584a2c066b7a455dbd6ae2807a7334e83c35fa5":"130000000000000000000","0x9c05e9d0f0758e795303717e31da213ca157e686":"1000000000000000000000","0x4f1a2da54a4c6da19d142412e56e815741db2325":"100000000000000000000","0x9a4ca8b82117894e43db72b9fa78f0b9b93ace09":"50000000000000000000","0x26c99f8849c9802b83c861217fd07a9e84cdb79d":"300000000000000000000","0x45c0d19f0b8e054f9e893836d5ecae7901af2812":"5000000000000000000000","0x00dc01cbf44978a42e8de8e436edf94205cfb6ec":"1458440000000000000000","0xde7dee220f0457a7187d56c1c41f2eb00ac56021":"629924000000000000000","0x1c128bd6cda5fca27575e4b43b3253c8c4172afe":"2000000000000000000000","0x666746fb93d1935c5a3c684e725010c4fad0b1d8":"20000000000000000000","0x51d78b178d707e396e8710965c4f41b1a1d9179d":"110600000000000000000","0x68f7573cd457e14c03fea43e302d30347c10705c":"5000000000000000000000","0x9d30cb237bc096f17036fc80dd21ca68992ca2d9":"30380000000000000000000","0xfbcfcc4a7b0f26cf26e9f3332132e2fc6a230766":"8000000000000000000000","0xb166e37d2e501ae73c84142b5ffb5aa655dd5a99":"1999000000000000000000","0x6df24f6685a62f791ba337bf3ff67e91f3d4bc3a":"2166000000000000000000","0x92e435340e9d253c00256389f52b067d55974e76":"268000000000000000000","0xea53d26564859d9e90bb0e53b7abf560e0162c38":"400000000000000000000","0xe26657f0ed201ea2392c9222b80a7003608ddf30":"40000000000000000000","0xf4177a0d85d48b0e264211ce2aa2efd3f1b47f08":"3593425000000000000000","0x9d47ba5b4c8505ad8da42934280b61a0e1e8b971":"100000000000000000000","0x63c2a3d235e5eeabd0d4a6afdb89d94627396495":"1241620000000000000000","0x446a8039cecf9dce4879cbcaf3493bf545a88610":"7000000000000000000000","0x7fa37ed67887751a471f0eb306be44e0dbcd6089":"1060000000000000000000","0x26d4a16891f52922789217fcd886f7fce296d400":"2000000000000000000000","0x487e108502b0b189ef9c8c6da4d0db6261eec6c0":"1910000000000000000000","0x7484d26becc1eea8c6315ec3ee0a450117dc86a0":"12000000000000000000000","0xad9e97a0482f353a05c0f792b977b6c7e811fa5f":"200000000000000000000","0x2273bad7bc4e487622d175ef7a66988b6a93c4ee":"20000000000000000000","0x3b93b16136f11eaf10996c95990d3b2739ccea5f":"10000000000000000000000","0xf3f1fa3918ca34e2cf7e84670b1f4d8eca160db3":"680000000000000000000","0x88a2154430c0e41147d3c1fee3b3b006f851edbd":"999972000000000000000","0x25185f325acf2d64500698f65c769ddf68301602":"5000000000000000000000","0xe9cafe41a5e8bbd90ba02d9e06585b4eb546c57f":"2000000000000000000000","0x95681cdae69b2049ce101e325c759892cac3f811":"2857600000000000000000","0x475066f9ad26655196d5535327bbeb9b7929cb04":"3040000000000000000000","0x6685fd2e2544702c360b8bb9ee78f130dad16da5":"2000000000000000000000","0x45e68db94c7d0ab7ac41857a71d67147870f4e71":"400000000000000000000000","0x4ad95d188d6464709add2555fb4d97fe1ebf311f":"346000000000000000000","0x73bedd6fda7ba3272185087b6351fc133d484e37":"5057200000000000000000","0x1ea4715504c6af107b0194f4f7b1cb6fcccd6f4b":"590598000000000000000","0x77306ffe2e4a8f3ca826c1a249f7212da43aeffd":"20000000000000000000000","0xeb453f5a3adddd8ab56750fadb0fe7f94d9c89e7":"20000000000000000000","0x7201d1c06920cd397ae8ad869bcda6e47ffb1b5a":"20000000000000000000","0x821cb5cd05c7ef909fe1be60733d8963d760dc41":"4000000000000000000000","0x496e319592b341eaccd778dda7c8196d54cac775":"9250000000000000000000","0x88609e0a465b6e99fce907166d57e9da0814f5c8":"20000000000000000000000","0xc7ec62b804b1f69b1e3070b5d362c62fb309b070":"13068074000000000000000","0x3eb9ef06d0c259040319947e8c7a6812aa0253d8":"167000000000000000000","0xcbf37ff854a2f1ce53934494777892d3ec655782":"10000000000000000000000","0x02b1af72339b2a2256389fd64607de24f0de600a":"2000000000000000000000","0xa8beb91c2b99c8964aa95b6b4a184b1269fc3483":"400000000000000000000","0x922a20c79a1d3a26dd3829677bf1d45c8f672bb6":"4000000000000000000000","0xc5843399d150066bf7979c34ba294620368ad7c0":"200000000000000000000","0x8cd0cd22e620eda79c0461e896c93c44837e2968":"2000000000000000000000","0x6170dd0687bd55ca88b87adef51cfdc55c4dd458":"2005160000000000000000","0xeed384ef2d41d9d203974e57c12328ea760e08ea":"1000000000000000000000","0xb129a5cb7105fe810bd895dc7206a991a4545488":"30000000000000000000","0x3872f48dc5e3f817bc6b2ad2d030fc5e0471193d":"4000000000000000000000","0x514b7512c9ae5ea63cbf11715b63f21e18d296c1":"1999944000000000000000","0x7ab256b204800af20137fabcc916a23258752501":"20000000000000000000000","0xfc66faba277f4b5de64ad45eb19c31e00ced3ed5":"5640000000000000000000","0x39824f8bced176fd3ea22ec6a493d0ccc33fc147":"4000000000000000000000","0xe338e859fe2e8c15554848b75caecda877a0e832":"1801800000000000000000","0xe53c68796212033e4e6f9cff56e19c461eb454f9":"1000000000000000000000","0x8461ecc4a6a45eb1a5b947fb86b88069b91fcd6f":"2000000000000000000000","0x6b4b99cb3fa9f7b74ce3a48317b1cd13090a1a7a":"57300000000000000000","0x97de21e421c37fe4b8025f9a51b7b390b5df7804":"80000000000000000000000","0xd25aecd7eb8bd6345b063b5dbd271c77d3514494":"1820000000000000000000","0x57b23d6a1adc06c652a779c6a7fb6b95b9fead66":"200000000000000000000","0x0d658014a199061cf6b39433140303c20ffd4e5a":"8200000000000000000000","0x30eac740e4f02cb56eef0526e5d300322600d03e":"1970000000000000000000","0x4eead40aad8c73ef08fc84bc0a92c9092f6a36bf":"26740000000000000000","0x30f7d025d16f7bee105580486f9f561c7bae3fef":"500000000000000000000","0x0977bfba038a44fb49b03970d8d8cf2cb61f8b25":"420000000000000000000","0xb14bbeff70720975dc6191b2a44ff49f2672873c":"143000000000000000000","0xd588c3a5df228185d98ee7e60748255cdea68b01":"4000000000000000000000","0x225d35faedb391c7bc2db7fa9071160405996d00":"167774000000000000000","0xc0e457bd56ec36a1246bfa3230fff38e5926ef22":"1940000000000000000000","0x2a9c57fe7b6b138a920d676f3c76b6c2a0eef699":"9400000000000000000000","0x36df8f883c1273ec8a171f7a33cfd649b1fe6075":"227290000000000000000","0x234f46bab73fe45d31bf87f0a1e0466199f2ebac":"485000000000000000000","0xa2e1b8aa900e9c139b3fa122354f6156d92a18b1":"500000000000000000000","0x517cd7608e5d0d83a26b717f3603dac2277dc3a4":"2000000000000000000000","0x75f7539d309e9039989efe2e8b2dbd865a0df088":"2460000000000000000000","0x4b792e29683eb586e394bb33526c6001b397999e":"600000000000000000000","0xa34f9d568bf7afd94c2a5b8a5ff55c66c4087999":"2444000000000000000000","0x4b31bf41abc75c9ae2cd8f7f35163b6e2b745054":"382000000000000000000","0xe35453eef2cc3c7a044d0ac134ba615908fa82ee":"147510000000000000000","0x7aa79ac04316cc8d08f20065baa6d4142897d54e":"1400000000000000000000","0xf1dc8ac81042c67a9c3c6792b230c46ac016ca10":"200000000000000000000","0x2bb366b9edcb0da680f0e10b3b6e28748190d6c3":"5799400000000000000000","0xa567770b6ae320bdde50f904d663e746a61dace6":"2000000000000000000000","0xd9d42fd13ebd4bf69cac5e9c7e82483ab46dd7e9":"5348000000000000000000","0x27830c5f6023afaaf79745676c204a0faccda0ba":"240000000000000000000","0x3cb179cb4801a99b95c3b0c324a2bdc101a65360":"26000000000000000000","0x976e3ceaf3f1af51f8c29aff5d7fa21f0386d8ee":"240000000000000000000","0x752a5ee232612cd3005fb26e5b597de19f776be6":"5460000000000000000000","0x7d5aa33fc14b51841a06906edb2bb49c2a117269":"300048000000000000000","0x55ca6abe79ea2497f46fdbb830346010fe469cbe":"5730000000000000000000","0x6bec311ad05008b4af353c958c40bd06739a3ff3":"16380000000000000000000","0x30e9698cf1e08a9d048bd8d8048f28be7ed9409f":"6685000000000000000000","0x9afa536b4c66bc38d875c4b30099d9261fdb38eb":"205981000000000000000","0x6b63a2dfb2bcd0caec0022b88be30c1451ea56aa":"809021000000000000000","0xd07be0f90997caf903c8ac1d53cde904fb190741":"1000200000000000000000","0x893cdddf5377f3c751bf2e541120045a47cba101":"100000000000000000000","0xc1cdc601f89c0428b31302d187e0dc08ad7d1c57":"6000000000000000000000","0x8f8acb107607388479f64baaabea8ff007ada97d":"27281800000000000000000","0x88bc43012edb0ea9f062ac437843250a39b78fbb":"20000000000000000000000","0xfcfc3a5004d678613f0b36a642269a7f371c3f6a":"1000000000000000000000","0xf509557e90183fbf0f0651a786487bcc428ba175":"194000000000000000000","0xe3d915eda3b825d6ee4af9328d32ac18ada35497":"500000000000000000000","0xf237ef05261c34d79cc22b860de0f17f793c3860":"200000000000000000000","0xa3a2e319e7d3a1448b5aa2468953160c2dbcba71":"2000000000000000000000","0x3a368efe4ad786e26395ec9fc6ad698cae29fe01":"632200000000000000000","0x8e3240b0810e1cf407a500804740cf8d616432a4":"40309000000000000000","0x5691dd2f6745f20e22d2e1d1b955aa2903d65656":"1969606000000000000000","0x5f93ff832774db5114c55bb4bf44ccf3b58f903f":"192026650000000000000000","0x2c1cc6e18c152488ba11c2cc1bcefa2df306abd1":"1670000000000000000000","0xbde9786a84e75b48f18e726dd78d70e4af3ed802":"5730000000000000000000","0x79551cede376f747e3716c8d79400d766d2e0195":"46250000000000000000000","0x49f028395b5a86c9e07f7778630e4c2e3d373a77":"122735000000000000000","0x6a3694424c7cc6b8bcd9bccaba540cc1f5df18d7":"2000000000000000000000","0x068e29b3f191c812a6393918f71ab933ae6847f2":"1999944000000000000000","0x6e64e6129f224e378c0e6e736a7e7a06c211e9ec":"1000000000000000000000","0xc4c15318d370c73318cc18bdd466dbaa4c6603bf":"19700000000000000000","0x8035bcffaefdeeea35830c497d14289d362023de":"300000000000000000000","0xa997dfc7986a27050848fa1c64d7a7d6e07acca2":"143000000000000000000","0x2fe13a8d0785de8758a5e41876c36e916cf75074":"4000000000000000000000","0x6f24c9af2b763480515d1b0951bb77a540f1e3f9":"1970000000000000000000","0x4c23b370fc992bb67cec06e26715b62f0b3a4ac3":"10000000000000000000000","0x4ac07673e42f64c1a25ec2fa2d86e5aa2b34e039":"2000000000000000000000","0x117db836377fe15455e02c2ebda40b1ceb551b19":"6000000000000000000000","0xef1c0477f1184d60accab374d374557a0a3e10f3":"152000000000000000000","0x99fe0d201228a753145655d428eb9fd94985d36d":"1939268000000000000000","0xb3731b046c8ac695a127fd79d0a5d5fa6ae6d12e":"1998000000000000000000","0xdce30c31f3ca66721ecb213c809aab561d9b52e4":"2000000000000000000000","0xddd69c5b9bf5eb5a39cee7c3341a120d973fdb34":"1987730000000000000000","0x216e41864ef98f060da08ecae19ad1166a17d036":"5730000000000000000000","0x6a53d41ae4a752b21abed5374649953a513de5e5":"2000000000000000000000","0x20dd8fcbb46ea46fe381a68b8ca0ea5be21fe9a5":"2000000000000000000000","0x19732bf973055dbd91a4533adaa2149a91d38380":"2000000000000000000000","0x51ea1c0934e3d04022ed9c95a087a150ef705e81":"6280000000000000000000","0xa0de5c601e696635c698b7ae9ca4539fc7b941ec":"346150000000000000000","0x94e1f5cb9b8abace03a1a6428256553b690c2355":"20000000000000000000","0xa539b4a401b584dfe0f344b1b422c65543167e2e":"200000000000000000000","0x50584d9206a46ce15c301117ee28f15c30e60e75":"13400000000000000000","0x856eb204241a87830fb229031343dc30854f581a":"1000000000000000000000","0x9dd46b1c6d3f05e29e9c6f037eed9a595af4a9aa":"500000000000000000000","0x8925da4549e15155e57a628522cea9dddf627d81":"1000070000000000000000","0xa89df34859edd7c820db887740d8ff9e15157c7b":"2000000000000000000000","0xad9f4c890a3b511cee51dfe6cfd7f1093b76412c":"506600000000000000000","0xf8c7f34a38b31801da43063477b12b27d0f203ff":"494800000000000000000","0xa642501004c90ea9c9ed1998ba140a4cd62c6f5f":"250543000000000000000","0x508cf19119db70aa86454253da764a2cb1b2be1a":"1000000000000000000000","0x2979741174a8c1ea0b7f9edf658177859417f512":"461283000000000000000","0x654f524847b3a6acc0d3d5f1f362b603edf65f96":"8000000000000000000000","0x5cf18fa7c8a7c0a2b3d5efd1990f64ddc569242c":"1000000000000000000000","0x17e82e7078dc4fd9e879fb8a50667f53a5c54591":"200000000000000000000","0x8b07d050754dc9ba230db01c310afdb5395aa1b3":"118080000000000000000","0x5f77a107ab1226b3f95f10ee83aefc6c5dff3edc":"500000000000000000000","0x475a6193572d4a4e59d7be09cb960ddd8c530e2f":"667323000000000000000","0x6470a4f92ec6b0fccd01234fa59023e9ff1f3aac":"3000000000000000000000","0x2fbcef3384d420e4bf61a0669990bc7054f1a5af":"2000000000000000000000","0xbbabf6643beb4bd01c120bd0598a0987d82967d1":"3342500000000000000000","0x41a2f2e6ecb86394ec0e338c0fc97e9c5583ded2":"2009400000000000000000","0xfb9473cf7712350a1fa0395273fc80560752e4fb":"123300000000000000000","0x38b2197106123387a0d4de368431a8bacdda30e2":"20000000000000000000","0x5ed56115bd6505a88273df5c56839470d24a2db7":"65601000000000000000","0x523f6d64690fdacd942853591bb0ff20d3656d95":"1820000000000000000000","0x55caff4bba04d220c9a5d2018672ec85e31ef83e":"2000000000000000000000","0x65af8d8b5b1d1eedfa77bcbc96c1b133f83306df":"98000000000000000000","0x7456c5b2c5436e3e571008933f1805ccfe34e9ec":"1000000000000000000000","0xa6eebbe464d39187bf80ca9c13d72027ec5ba8be":"3000000000000000000000","0xdd35cfdbcb993395537aecc9f59085a8d5ddb6f5":"1000000000000000000000","0x98e2b6d606fd2d6991c9d6d4077fdf3fdd4585da":"901520000000000000000","0x860f5ffc10de767ded807f71e861d647dfd219b1":"10000000000000000000000","0x1a644a50cbc2aee823bd2bf243e825be4d47df02":"100007000000000000000","0xa8455b411765d6901e311e726403091e42c56683":"3380000000000000000000","0x3a86ee94862b743dd34f410969d94e2c5652d4ad":"201610000000000000000","0xa57360f002e0d64d2d74457d8ca4857ee00bcddf":"335780000000000000000","0xe59b3bd300893f97233ef947c46f7217e392f7e9":"1000000000000000000000","0x9f3a74fd5e7edcc1162993171381cbb632b7cff0":"10000000000000000000000","0x675d5caa609bf70a18aca580465d8fb7310d1bbb":"20000000000000000000000","0x77f609ca8720a023262c55c46f2d26fb3930ac69":"17300000000000000000","0xf8ac4a39b53c11307820973b441365cffe596f66":"2000000000000000000000","0x112634b4ec30ff786e024159f796a57939ea144e":"1999944000000000000000","0x49d2c28ee9bc545eaaf7fd14c27c4073b4bb5f1a":"1474134000000000000000","0x91cc46aa379f856a6640dccd5a648a7902f849d9":"200000000000000000000","0xb46440c797a556e04c7d9104660491f96bb076bf":"14900000000000000000","0xe5968797468ef767101b761d431fce14abffdbb4":"8040000000000000000000","0xc0895efd056d9a3a81c3da578ada311bfb9356cf":"200000000000000000000","0x76846f0de03b5a76971ead298cdd08843a4bc6c6":"15500000000000000000","0x5f708eaf39d823946c51b3a3e9b7b3c003e26341":"1820000000000000000000","0x24f7450ddbf18b020feb1a2032d9d54b633edf37":"50000000000000000000","0xcae3a253bcb2cf4e13ba80c298ab0402da7c2aa0":"5400000000000000000000","0x91e8810652e8e6161525d63bb7751dc20f676076":"725000000000000000000","0x543629c95cdef428ad37d453ca9538a9f90900ac":"43250000000000000000000","0x6e79edd4845b076e4cd88d188b6e432dd93f35aa":"955000000000000000000","0xbd325d4029e0d8729f6d399c478224ae9e7ae41e":"3880000000000000000000","0x42cecfd2921079c2d7df3f08b07aa3beee5e219a":"1000000000000000000000","0x3690246ba3c80679e22eac4412a1aefce6d7cd82":"20000000000000000000000","0x577aeee8d4bc08fc97ab156ed57fb970925366be":"333046000000000000000","0xfe00bf439911a553982db638039245bcf032dbdc":"394000000000000000000","0x91f624b24a1fa5a056fe571229e7379db14b9a1e":"11999974000000000000000","0xf206d328e471d0117b246d2a4619827709e96df3":"3001000000000000000000","0x073f1ed1c9c3e9c52a9b0249a5c1caa0571fdf05":"70400000000000000000","0xf56048dd2181d4a36f64fcecc6215481e42abc15":"200000000000000000000","0xef76a4cd8febcbc9b818f17828f8d93473f3f3cb":"4000000000000000000000","0x1031e0ecb54985ae21af1793950dc811888fde7c":"20000000000000000000","0x8e0fee38685a94aabcd7ce857b6b1409824f75b8":"500000000000000000000","0xf0cbef84e169630098d4e301b20208ef05846ac9":"259084000000000000000","0xbbca65b3266ea2fb73a03f921635f912c7bede00":"1970000000000000000000","0x0aec2e426ed6cc0cf3c249c1897eac47a7faa9bd":"200000000000000000000","0xb8f30758faa808dbc919aa7b425ec922b93b8129":"1000076000000000000000","0x936dcf000194e3bff50ac5b4243a3ba014d661d8":"10000000000000000000000","0xb14ddb0386fb606398b8cc47565afae00ff1d66a":"2973024000000000000000","0x2ec95822eb887bc113b4712a4dfd7f13b097b5e7":"1000000000000000000000","0x0136a5af6c3299c6b5f005fdaddb148c070b299b":"20368000000000000000","0x37cb868d2c3f95b257611eb34a4188d58b749802":"2000000000000000000000","0xcd7f09d7ed66d0c38bc5ad4e32b7f2b08dc1b30d":"1148000000000000000000","0xb5fa8184e43ed3e0b8ab91216461b3528d84fd09":"2680000000000000000000","0x3dbf0dbfd77890800533f09dea8301b9f025d2a6":"1000000000000000000000","0xb553d25d6b5421e81c2ad05e0b8ba751f8f010e3":"2000000000000000000000","0xdbf8b13967f55125272de0562536c450ba5655a0":"2046830000000000000000","0x0f6e840a3f2a24647d8e43e09d45c7c335df4248":"2500000000000000000000","0xfa2fd29d03fee9a07893df3a269f56b72f2e1e64":"10000000000000000000000","0x8b57b2bc83cc8d4de331204e893f2f3b1db1079a":"40000000000000000000","0x7f541491d2ac00d2612f94aa7f0bcb014651fbd4":"376000000000000000000","0x4f4a9be10cd5d3fb5de48c17be296f895690645b":"40000000000000000000000","0x45d1c9eedf7cab41a779057b79395f5428d80528":"2000000000000000000000","0x662334814724935b7931ddca6100e00d467727cd":"637000000000000000000","0x2c52c984102ee0cd3e31821b84d408930efa1ac7":"2000000000000000000000","0x000d836201318ec6899a67540690382780743280":"200000000000000000000","0x81498ca07b0f2f17e8bbc7e61a7f4ae7be66b78b":"101600000000000000000","0x7860a3de38df382ae4a4dce18c0c07b98bce3dfa":"1000000000000000000000","0x5e8e4df18cf0af770978a8df8dac90931510a679":"2000000000000000000000","0x05d68dad61d3bbdfb3f779265c49474aff3fcd30":"39399000000000000000","0x96eafbf2fb6f4db9a436a74c45b5654452e23819":"20000000000000000000","0xd7d7f2caa462a41b3b30a34aeb3ba61010e2626f":"2000000000000000000000","0x0b71f554122469ef978e2f1fefd7cbb410982772":"3880000000000000000000","0x504666ce8931175e11a5ed11c1dcaa06e57f4e66":"11792000000000000000000","0xd00f067286c0fbd082f9f4a61083ec76deb3cee6":"1000000000000000000000","0x02e4cb22be46258a40e16d4338d802fffd00c151":"379786000000000000000","0x1c13d38637b9a47ce79d37a86f50fb409c060728":"1337000000000000000000","0xe30212b2011bb56bdbf1bc35690f3a4e0fd905ea":"8022000000000000000000","0x1df6911672679bb0ef3509038c0c27e394fdfe30":"540000000000000000000","0x2b8fe4166e23d11963c0932b8ade8e0145ea0770":"43250000000000000000000","0x6509eeb1347e842ffb413e37155e2cbc738273fd":"2000000000000000000000","0x8b7e9f6f05f7e36476a16e3e7100c9031cf404af":"1000000000000000000000","0xbec8caf7ee49468fee552eff3ac5234eb9b17d42":"2000000000000000000000","0x38898bbb4553e00bbfd0cf268b2fc464d154add5":"320000000000000000000","0xcbb3189e4bd7f45f178b1c30c76e26314d4a4b0a":"295007000000000000000","0xbe1cd7f4c472070968f3bde268366b21eeea8321":"4300000000000000000000","0x976a18536af41874426308871bcd1512a775c9f8":"10000000000000000000000","0xe9c758f8da41e3346e4350e5ac3976345c6c1082":"1930050000000000000000","0x64ec8a5b743f3479e707dae9ee20ddaa4f40f1d9":"200000000000000000000","0x9e01765aff08bc220550aca5ea2e1ce8e5b09923":"1000000000000000000000","0xba0f39023bdb29eb1862a9f9059cab5d306e662f":"2000000000000000000000","0x2baf8d6e221174124820ee492b9459ec4fadafbb":"2000000000000000000000","0x655d5cd7489629e2413c2105b5a172d933c27af8":"4040060000000000000000","0xbadc2aef9f5951a8d78a6b35c3d0b3a4e6e2e739":"6000000000000000000000","0xe64f6e1d6401b56c076b64a1b0867d0b2f310d4e":"51570000000000000000","0x7a8563867901206f3f2bf0fa3e1c8109cabccd85":"137000000000000000000","0xd17fbe22d90462ed37280670a2ea0b3086a0d6d6":"199955000000000000000","0xe96d7d4cdd15553a4e4d316d6d6480ca3cea1e38":"12200000000000000000000","0xf04d2c91efb6e9c45ffbe74b434c8c5f2b028f1f":"1000000000000000000000","0x81164deb10814ae08391f32c08667b6248c27d7a":"394000000000000000000","0x7f5ae05ae0f8cbe5dfe721f044d7a7bef4c27997":"60000000000000000000","0xc982586d63b0d74c201b1af8418372e30c7616be":"100000000000000000000","0x64cf0935bf19d2cebbecd8780d27d2e2b2c34166":"1970000000000000000000","0xcd566ad7b883f01fd3998a9a58a9dee4724ddca5":"58848000000000000000","0x9da609fa3a7e6cf2cc0e70cdabe78dc4e382e11e":"1200000000000000000000","0x0d69100c395ce6c5eaadf95d05d872837ededd21":"400000000000000000000","0xfe91eccf2bd566afa11696c5049fa84c69630a52":"1940000000000000000000","0x005d0ee8155ec0a6ff6808552ca5f16bb5be323a":"197000000000000000000","0x3e5cb8928c417825c03a3bfcc52183e5c91e42d7":"4264790000000000000000","0x9c1b771f09af882af0643083de2aa79dc097c40e":"2480000000000000000000","0xeba388b0da27c87b1cc0eac6c57b2c5a0b459c1a":"6800000000000000000000","0x7529f3797bb6a20f7ea6492419c84c867641d81c":"2000000000000000000000","0x532a7da0a5ad7407468d3be8e07e69c7dd64e861":"500000000000000000000","0xde82cc8d4a1bb1d9434392965b3e80bad3c03d4f":"1477500000000000000000","0x4a82694fa29d9e213202a1a209285df6e745c209":"4000000000000000000000","0x3e53ff2107a8debe3328493a92a586a7e1f49758":"23143470000000000000000","0xb2ddb786d3794e270187d0451ad6c8b79e0e8745":"400000000000000000000","0x6ebcf9957f5fc5e985add475223b04b8c14a7aed":"1730000000000000000000","0xc5c7590b5621ecf8358588de9b6890f2626143f1":"3000000000000000000000","0xae4f122e35c0b1d1e4069291457c83c07f965fa3":"1000000000000000000000","0x47885ababedf4d928e1c3c71d7ca40d563ed595f":"1820000000000000000000","0x78ce3e3d474a8a047b92c41542242d0a08c70f99":"10000000000000000000000","0x6134d942f037f2cc3d424a230c603d67abd3edf7":"2000000000000000000000","0x1360e87df24c69ee6d51c76e73767ffe19a2131c":"92000000000000000000","0x5fd1c3e31778276cb42ea740f5eae9c641dbc701":"194000000000000000000","0x98397342ec5f3d4cb877e54ef5d6f1d366731bd4":"5910000000000000000000","0x6d4b5c05d06a20957e1748ab6df206f343f92f01":"10020475000000000000000","0xe6115b13f9795f7e956502d5074567dab945ce6b":"100000000000000000000000","0x23730c357a91026e44b1d0e2fc2a51d071d8d77b":"4000000000000000000000","0xfae881937047895a660cf229760f27e66828d643":"182000000000000000000","0xff3ef6ba151c21b59986ae64f6e8228bc9a2c733":"2000000000000000000000","0xdfbd4232c17c407a980db87ffbcda03630e5c459":"553150000000000000000","0x4429a29fee198450672c0c1d073162250bec6474":"999200000000000000000","0x7e8f96cc29f57b0975120cb593b7dd833d606b53":"197000000000000000000","0x5ed3f1ebe2ae6756b5d8dc19cad02c419aa5778b":"0","0xdaa776a6754469d7b9267a89b86725e740da0fa0":"1970000000000000000000","0x139e479764b499d666208c4a8a047a97043163dd":"598880000000000000000","0x5ad5e420755613886f35aa56ac403eebdfe4b0d0":"80000000000000000000000","0x3fe801e61335c5140dc7eda2ef5204460a501230":"2000000000000000000000","0xce8a6b6d5033b1498b1ffeb41a41550405fa03a2":"4000000000000000000000","0x26c2ffc30efdc5273e76183a16c2698d6e531286":"776000000000000000000","0x71ec3aec3f8f9221f9149fede06903a0f9a232f2":"200000000000000000000","0xef35f6d4b1075e6aa139151c974b2f4658f70538":"1111111000000000000000","0x26a68eab905a8b3dce00e317308225dab1b9f6b8":"1980000000000000000000","0x63f5b53d79bf2e411489526530223845fac6f601":"30000000000000000000000","0x481115296ab7db52492ff7b647d63329fb5cbc6b":"16100000000000000000000","0xf19f193508393e4d2a127b20b2031f39c82581c6":"3500088000000000000000","0x500e34cde5bd9e2b71bb92d7cf55eee188d5fa0c":"5348000000000000000000","0x65ea67ad3fb56ad5fb94387dd38eb383001d7c68":"100000000000000000000","0x7f9f9b56e4289dfb58e70fd5f12a97b56d35c6a5":"1970000000000000000000","0x60be6f953f2a4d25b6256ffd2423ac1438252e4e":"150000000000000000000","0xac1dfc984b71a19929a81d81f04a7cbb14073703":"600000000000000000000","0xa3c14ace28b192cbb062145fcbbd5869c67271f6":"8000000000000000000000","0x2da76b7c39b420e388ba2c1020b0856b0270648a":"2000000000000000000000","0x622be4b45495fcd93143efc412d699d6cdc23dc5":"17300000000000000000","0xd3f873bd9956135789ab00ebc195b922e94b259d":"2000000000000000000000","0x975f3764e97bbccf767cbd3b795ba86d8ba9840e":"346000000000000000000","0xfc39be41094b1997d2169e8264c2c3baa6c99bc4":"2000000000000000000000","0x12ffc1128605cb0c13709a7290506f2690977193":"3340000000000000000000","0x9b1168de8ab64b47552f3389800a9cc08b4666cf":"1730000000000000000000","0x9f1aa8fcfc89a1a5328cbd6344b71f278a2ca4a0":"500000000000000000000","0x505a33a18634dd4800693c67f48a1d693d4833f8":"7252000000000000000000","0xd08fc09a0030fd0928cd321198580182a76aae9f":"1000000000000000000000","0x6acddca3cd2b4990e25cd65c24149d0912099e79":"3000037000000000000000","0x397a6ef8763a18f00fac217e055c0d3094101011":"2000000000000000000000","0x4e0bd32473c4c51bf25654def69f797c6b29a232":"1600930000000000000000","0x28d8c35fb7eea622582135e3ad47a227c9a663bd":"18200000000000000000","0xf96488698590dc3b2c555642b871348dfa067ad5":"500000000000000000000","0x4eebe80cb6f3ae5904f6f4b28d907f907189fcab":"1999944000000000000000","0x8d1abd897dacd4312e18080c88fb9647eab44052":"216000000000000000000","0x457029c469c4548d168cec3e65872e4428d42b67":"2000000000000000000000","0x1296acded1e063af39fe8ba0b4b63df789f70517":"100014000000000000000","0x71762c63678c18d1c6378ce068e666381315147e":"2000000000000000000000","0x6cc1c878fa6cde8a9a0b8311247e741e4642fe6d":"985000000000000000000","0x8d9ed7f4553058c26f7836a3802d3064eb1b363d":"90000000000000000000","0x5032e4bcf7932b49fdba377b6f1499636513cfc3":"100000000000000000000","0x462b678b51b584f3ed7ada070b5cd99c0bf7b87f":"100000000000000000000","0xc8aa49e3809f0899f28ab57e6743709d58419033":"880000000000000000000","0x01b1cae91a3b9559afb33cdc6d689442fdbfe037":"200000000000000000000","0xb1043004ec1941a8cf4f2b00b15700ddac6ff17e":"1000000000000000000000","0x5ba2c6c35dfaec296826591904d544464aeabd5e":"20000000000000000000","0xb32400fd13c5500917cb037b29fe22e7d5228f2d":"40000000000000000000000","0xd59d92d2c8701980cc073c375d720af064743c0c":"19000000000000000000000","0x11dd6185d9a8d73ddfdaa71e9b7774431c4dfec2":"1000000000000000000000","0xd4cb21e590c5a0e06801366aff342c7d7db16424":"494000000000000000000","0x5b6d55f6712967405c659129f4b1de09acf2cb7b":"267400000000000000000","0x6179979907fe7f037e4c38029d60bcbab832b3d6":"1610000000000000000000","0x33c407133b84b3ca4c3ded1f4658900c38101624":"2800000000000000000000","0xcd2a36d753e9e0ed012a584d716807587b41d56a":"261400000000000000000","0x8155fa6c51eb31d808412d748aa086105018122f":"1880000000000000000000","0x3ecc8e1668dde995dc570fe414f44211c534a615":"2000000000000000000000","0xd6395db5a4bb66e60f4cfbcdf0057bb4d97862e2":"910000000000000000000","0xb6fb39786250081426a342c70d47ee521e5bc563":"15000000000000000000000","0x510eda5601499a0d5e1a006bfffd833672f2e267":"2000000000000000000000","0x98c19dba810ba611e68f2f83ee16f6e7744f0c1f":"200000000000000000000","0x34ff26eb60a8d1a95a489fae136ee91d4e58084c":"600000000000000000000","0x6ad90be252d9cd464d998125fab693060ba8e429":"4000000000000000000000","0x038323b184cff7a82ae2e1bda7793fe4319ca0bf":"20000000000000000000000","0xdc5305b4020a06b49d657c7ca34c35c91c5f2c56":"7045990000000000000000","0xc9c80dc12e7bab86e949d01e4c3ed35f2b9bba5f":"2000000000000000000000","0x7beb81fb2f5e91526b2ac9795e76c69bcff04bc0":"69400000000000000000000","0xb8bc9bca7f71b4ed12e620438d620f53c114342f":"500000000000000000000","0xd288e7cb7ba9f620ab0f7452e508633d1c5aa276":"4000000000000000000000","0xa2e460a989cb15565f9ecca7d121a18e4eb405b6":"2000000000000000000000","0x7489cc8abe75cda4ef0d01cef2605e47eda67ab1":"133700000000000000000","0x38b403fb1fb7c14559a2d6f6564a5552bca39aff":"2000000000000000000000","0xe55c80520a1b0f755b9a2cd3ce214f7625653e8a":"2000000000000000000000","0x451b7070259bdba27100e36e23428a53dfe304e9":"13370000000000000000","0x8b5c914b128bf1695c088923fa467e7911f351fa":"98500000000000000000","0x17df49518d73b129f0da36b1c9b40cb66420fdc7":"10000000000000000000000","0xc1950543554d8a713003f662bb612c10ad4cdf21":"18200000000000000000","0xfa7606435b356cee257bd2fcd3d9eacb3cd1c4e1":"100000000000000000000","0xe0bad98eee9698dbf6d76085b7923de5754e906d":"167000000000000000000","0xce53c8cdd74296aca987b2bc19c2b875a48749d0":"3000000000000000000000","0xd0c55abf976fdc3db2afe9be99d499484d576c02":"1000000000000000000000","0x238a6b7635252f5244486c0af0a73a207385e039":"1370000000000000000000","0xceb389381d48a8ae4ffc483ad0bb5e204cfdb1ec":"740745000000000000000","0x3847667038f33b01c1cc795d8daf5475eff5a0d4":"728330000000000000000","0xa08d215b5b6aac4861a281ac7e400b78fef04cbf":"20000000000000000000","0x2d0dec51a6e87330a6a8fa2a0f65d88d4abcdf73":"185000000000000000000","0x9e8f64ddcde9b8b451bafaa235a9bf511a25ac91":"2674000000000000000000","0xddac6bf4bbdd7d597d9c686d0695593bedccc7fa":"865000000000000000000","0x22e15158b5ee3e86eb0332e3e6a9ac6cd9b55ecd":"160000000000000000000","0x3aea4e82d2400248f99871a41ca257060d3a221b":"1000000000000000000000","0xfb126f0ec769f49dcefca2f200286451583084b8":"5013750000000000000000","0x1b8bd6d2eca20185a78e7d98e8e185678dac4830":"16700000000000000000000","0x664cd67dccc9ac8228b45c55db8d76550b659cdc":"394000000000000000000","0x553f37d92466550e9fd775ae74362df030179132":"2000000000000000000000","0x730d8763c6a4fd824ab8b859161ef7e3a96a1200":"20000000000000000000000","0x04c2c64bb54c3eccd05585e10ec6f99a0cdb01a3":"100000000000000000000","0xf1624d980b65336feac5a6d54125005cfcf2aacb":"2000000000000000000000","0x0b7fc9ddf70576f6330669eaaa71b6a831e99528":"140000000000000000000","0xfa2bbca15d3fe39f8a328e91f90da14f7ac6253d":"200000000000000000000","0x07feef54c136850829badc4b49c3f2a73c89fb9e":"118200000000000000000","0x3703350c4d6fe337342cddc65bf1e2386bf3f9b2":"2020000000000000000000","0x6d7d1c949511f88303808c60c5ea0640fcc02683":"10000000000000000000000","0x34fa7792bad8bbd7ff64056214a33eb6600c1ea8":"50000000000000000000","0x994cc2b5227ec3cf048512467c41b7b7b748909f":"2000000000000000000000","0x08da3a7a0f452161cfbcec311bb68ebfdee17e88":"2000000000000000000000","0xbbb4ee1d82f2e156442cc93338a2fc286fa28864":"1370000000000000000000","0x7a2dfc770e24368131b7847795f203f3d50d5b56":"11400000000000000000000","0x7cef4d43aa417f9ef8b787f8b99d53f1fea1ee88":"1910000000000000000000","0xc6a30ef5bb3320f40dc5e981230d52ae3ac19322":"182000000000000000000","0x6a74844d8e9cb5581c45079a2e94462a6cee8821":"1082970000000000000000","0xc3110be01dc9734cfc6e1ce07f87d77d1345b7e1":"4999998000000000000000","0xaeb916ebf49d0f86c13f7331cef19e129937512d":"599908000000000000000","0x3e5abd09ce5af7ba8487c359e0f2a93a986b0b18":"10000000000000000000000","0xcdd60d73efaad873c9bbfb178ca1b7105a81a681":"32000000000000000000","0x31eb123c95c82bf685ace7a75a1881a289efca10":"920034000000000000000","0x86e8670e27598ea09c3899ab7711d3b9fe901c17":"200000000000000000000","0xa144f6b60f72d64a21e330dadb62d8990ade2b09":"1000000000000000000000","0x68883e152e5660fee59626e7e3b4f05110e6222f":"54683300000000000000000","0xfe4249127950e2f896ec0e7e2e3d055aab10550f":"668500000000000000000","0x403d53cf620f0922b417848dee96c190b5bc8271":"9850000000000000000000","0xbec2e6de39c07c2bae556acfbee2c4728b9982e3":"573000000000000000000","0xf3c4716d1ee5279a86d0163a14618181e16136c7":"1000000000000000000000","0xe38ef28a5ed984a7db24a1ae782dfb87f397dfc6":"143000000000000000000","0x30fbe5885f9fcce9ea5edb82ed4a1196dd259aed":"5200000000000000000000","0x48bf14d7b1fc84ebf3c96be12f7bce01aa69b03e":"120000000000000000000","0xb8d5c324a8209d7c8049d0d4aede02ba80ab578b":"16889329000000000000000","0x43d5a71ce8b8f8ae02b2eaf8eaf2ca2840b93fb6":"6000000000000000000000","0xf9a59c3cc5ffacbcb67be0fc7256f64c9b127cb4":"2000000000000000000000","0x0e21af1b8dbf27fcf63f37e047b87a825cbe7c27":"3000000000000000000000","0x1c35aab688a0cd8ef82e76541ba7ac39527f743b":"500000000000000000000","0x91ac5cfe67c54aa7ebfba448666c461a3b1fe2e1":"401880000000000000000","0x4ba53ab549e2016dfa223c9ed5a38fad91288d07":"1400000000000000000000","0x99a4de19ded79008cfdcd45d014d2e584b8914a8":"1500000000000000000000","0x4adbf4aae0e3ef44f7dd4d8985cfaf096ec48e98":"150000000000000000000","0x9a633fcd112cceeb765fe0418170732a9705e79c":"18200000000000000000","0x292f228b0a94748c8eec612d246f989363e08f08":"185000000000000000000","0x9f3497f5ef5fe63095836c004eb9ce02e9013b4b":"633424000000000000000","0x0e6dfd553b2e873d2aec15bd5fbb3f8472d8d394":"12000000000000000000000","0x74ebf4425646e6cf81b109ce7bf4a2a63d84815f":"40000000000000000000","0x8ce5e3b5f591d5eca38abf228f2e3c35134bdac0":"2319920000000000000000","0x90c41eba008e20cbe927f346603fc88698125969":"42000000000000000000","0x382ba76db41b75606dd48a48f0137e9174e031b6":"20000000000000000000","0x5d24bdbc1c47f0eb83d128cae48ac33c4817e91f":"1000000000000000000000","0xa64e5ffb704c2c9139d77ef61d8cdfa31d7a88e9":"143000000000000000000","0xa18360e985f2062e8f8efe02ad2cbc91ad9a5aad":"3000000000000000000000","0xd251f903ae18727259eee841a189a1f569a5fd76":"10000000000000000000000","0xefa6b1f0db603537826891b8b4bc163984bb40cd":"985000000000000000000","0x47fff42c678551d141eb75a6ee398117df3e4a8d":"100010000000000000000","0xf2294adbb6f0dcc76e632ebef48ab49f124dbba4":"1443690000000000000000","0x53700d53254d430f22781a4a76a463933b5d6b08":"1970000000000000000000","0xb14a7aaa8f49f2fb9a8102d6bbe4c48ae7c06fb2":"8000000000000000000000","0x9ed4e63f526542d44fddd34d59cd25388ffd6bda":"3885000000000000000000","0x4cac91fb83a147d2f76c3267984b910a79933348":"2167000000000000000000","0x9b32cf4f5115f4b34a00a64c617de06387354323":"105501000000000000000","0xb8bedd576a4b4c2027da735a5bc3f533252a1808":"2000000000000000000000","0xc5a3b98e4593fea0b38c4f455a5065f051a2f815":"20309030000000000000000","0xeaf52388546ec35aca6f6c6393d8d609de3a4bf3":"20000000000000000000","0x4c423c76930d07f93c47a5cc4f615745c45a9d72":"100000000000000000000","0x9052f2e4a3e3c12dd1c71bf78a4ec3043dc88b7e":"267400000000000000000","0x2bade91d154517620fd4b439ac97157a4102a9f7":"4000000000000000000000","0xda698d64c65c7f2b2c7253059cd3d181d899b6b7":"295500000000000000000","0xc6d8954e8f3fc533d2d230ff025cb4dce14f3426":"400000000000000000000","0x349a816b17ab3d27bbc0ae0051f6a070be1ff29d":"10000000000000000000000","0xff4d9c8484c43c42ff2c5ab759996498d323994d":"4000000000000000000000","0x22944fbca9b57963084eb84df7c85fb9bcdfb856":"4649845000000000000000","0xbfd93c90c29c07bc5fb5fc49aeea55a40e134f35":"28000000000000000000000","0x3caedb5319fe806543c56e5021d372f71be9062e":"40000000000000000000000","0x9a079c92a629ca15c8cafa2eb28d5bc17af82811":"500000000000000000000","0x7d2a52a7cf0c8436a8e007976b6c26b7229d1e15":"438040000000000000000","0xcf89f7460ba3dfe83c5a1d3a019ee1250f242f0f":"985177000000000000000","0x577bfe64e3a1e3800e94db1c6c184d8dc8aafc66":"1498000000000000000000","0x7ffd02ed370c7060b2ae53c078c8012190dfbb75":"10000000000000000000000","0x90b62f131a5f29b45571513ee7a74a8f0b232202":"158000000000000000000","0x6e8212b722afd408a7a73ed3e2395ee6454a0330":"159000000000000000000","0x515f30bc90cdf4577ee47d65d785fbe2e837c6bc":"10166128000000000000000","0xc27376f45d21e15ede3b26f2655fcee02ccc0f2a":"20000000000000000000","0x3da39ce3ef4a7a3966b32ee7ea4ebc2335a8f11f":"2000000000000000000000","0x25259d975a21d83ae30e33f800f53f37dfa01938":"20000000000000000000","0x8ed143701f2f72280fd04a7b4164281979ea87c9":"14000000000000000000","0x5ac99ad7816ae9020ff8adf79fa9869b7cea6601":"21000000000000000000000","0xf51fded80acb502890e87369741f3722514cefff":"20000042000000000000000","0xf657fcbe682eb4e8db152ecf892456000b513d15":"1940000000000000000000","0x62c37c52b97f4b040b1aa391d6dec152893c4707":"1000000000000000000000","0x89fc8e4d386b0d0bb4a707edf3bd560df1ad8f4e":"2955000000000000000000","0x53c0bb7fc88ea422d2ef7e540e2d8f28b1bb8183":"20000000000000000000","0x56f493a3d108aaa2d18d98922f8efe1662cfb73d":"2020000000000000000000","0xe9458f68bb272cb5673a04f781b403556fd3a387":"61000000000000000000","0xbe525a33ea916177f17283fca29e8b350b7f530b":"2638000000000000000000","0x4feb846be43041fd6b34202897943e3f21cb7f04":"83226000000000000000","0x15aa530dc36958b4edb38eee6dd9e3c77d4c9145":"2000000000000000000000","0x2458d6555ff98a129cce4037953d00206eff4287":"197000000000000000000","0x8035fe4e6b6af27ae492a578515e9d39fa6fa65b":"4000000000000000000000","0x296b71c0015819c242a7861e6ff7eded8a5f71e3":"1999800000000000000000","0x8f1952eed1c548d9ee9b97d0169a07933be69f63":"1000000000000000000000","0xa421dbb89b3a07419084ad10c3c15dfe9b32d0c2":"20000000000000000000000","0x554336ee4ea155f9f24f87bca9ca72e253e12cd2":"100000000000000000000","0xffc5fc4b7e8a0293ff39a3a0f7d60d2646d37a74":"2000000000000000000000","0xea2c197d26e98b0da83e1b72c787618c979d3db0":"19700000000000000000","0x96aa573fed2f233410dbae5180145b23c31a02f0":"1730000000000000000000","0xc23b2f921ce4a37a259ee4ad8b2158d15d664f59":"25403000000000000000","0xd874b9dfae456a929ba3b1a27e572c9b2cecdfb3":"170000000000000000000","0xbf8b8005d636a49664f74275ef42438acd65ac91":"200000000000000000000","0x441a52001661fac718b2d7b351b7c6fb521a7afd":"400000000000000000000","0x812a55c43caedc597218379000ce510d548836fd":"18200000000000000000","0x5e90c85877198756b0366c0e17b28e52b446505a":"374288000000000000000","0xda3017c150dd0dce7fcf881b0a48d0d1c756c4c7":"100014000000000000000","0x6baf7a2a02ae78801e8904ad7ac05108fc56cff6":"1000000000000000000000","0x177dae78bc0113d8d39c4402f2a641ae2a105ab8":"1818320000000000000000","0x01b5b5bc5a117fa08b34ed1db9440608597ac548":"200000000000000000000","0xaae732eda65988c3a00c7f472f351c463b1c968e":"2000000000000000000000","0xd95342953c8a21e8b635eefac7819bea30f17047":"94160000000000000000000","0x8d616b1eee77eef6f176e0698db3c0c141b2fc8f":"500000000000000000000","0x12d20790b7d3dbd88c81a279b812039e8a603bd0":"1604400000000000000000","0x3734cb187491ede713ae5b3b2d12284af46b8101":"3000000000000000000000","0xdd967c4c5f8ae47e266fb416aad1964ee3e7e8c3":"7750000000000000000000","0x3dcef19c868b15d34eda426ec7e04b18b6017002":"1999800000000000000000","0xce9d21c692cd3c01f2011f505f870036fa8f6cd2":"400000000000000000000","0xd44f6ac3923b5fd731a4c45944ec4f7ec52a6ae4":"10000000000000000000000","0xb424d68d9d0d00cec1938c854e15ffb880ba0170":"200000000000000000000","0x1f2186ded23e0cf9521694e4e164593e690a9685":"300000000000000000000","0x7f4b5e278578c046cceaf65730a0e068329ed5b6":"1880000000000000000000","0x8c50aa2a9212bcde56418ae261f0b35e7a9dbb82":"400000000000000000000","0x1953313e2ad746239cb2270f48af34d8bb9c4465":"2000000000000000000000","0xa15025f595acdbf3110f77c5bf24477e6548f9e8":"2000000000000000000000","0x53af32c22fef99803f178cf90b802fb571c61cb9":"3880000000000000000000","0xd0a8abd80a199b54b08b65f01d209c27fef0115b":"6525979000000000000000","0x2b68306ba7f8daaf73f4c644ef7d2743c0f26856":"864800000000000000000","0x96924191b7df655b3319dc6d6137f481a73a0ff3":"4020000000000000000000","0x6fa72015fa78696efd9a86174f7f1f21019286b1":"1337000000000000000000","0x0b119df99c6b8de58a1e2c3f297a6744bf552277":"2000000000000000000000","0x61733947fab820dbd351efd67855ea0e881373a0":"20000000000000000000","0x8ae6f80b70e1f23c91fbd5a966b0e499d95df832":"197000000000000000000","0x01a7d9fa7d0eb1185c67e54da83c2e75db69e39f":"7623900000000000000000","0x9932ef1c85b75a9b2a80057d508734c51085becc":"50170000000000000000","0xaefcfe88c826ccf131d54eb4ea9eb80e61e1ee25":"340000000000000000000","0xc21fa6643a1f14c02996ad7144b75926e87ecb4b":"20000000000000000000000","0x97d9e46a7604d7b5a4ea4ee61a42b3d2350fc3ed":"2000000000000000000000","0x3cafaf5e62505615068af8eb22a13ad8a9e55070":"1999600000000000000000","0x22f2dcff5ad78c3eb6850b5cb951127b659522e6":"13700000000000000000","0xaaad1baade5af04e2b17439e935987bf8c2bb4b9":"2000000000000000000000","0x298887bab57c5ba4f0615229d7525fa113b7ea89":"40000000000000000000","0x7539333046deb1ef3c4daf50619993f444e1de68":"1182000000000000000000","0x9752d14f5e1093f071711c1adbc4e3eb1e5c57f3":"2000000000000000000000","0xed641e06368fb0efaa1703e01fe48f4a685309eb":"200000000000000000000","0xd0ee4d02cf24382c3090d3e99560de3678735cdf":"2400000000000000000000","0x47e25df8822538a8596b28c637896b4d143c351d":"80500000000000000000000","0x559706c332d20779c45f8a6d046a699159b74921":"380123000000000000000","0x3a4da78dce05aeb87de9aead9185726da1926798":"200000000000000000000","0x3041445a33ba158741160d9c344eb88e5c306f94":"60000000000000000000","0x08d4311c9c1bbaf87fabe1a1d01463828d5d98ce":"90000000000000000000000","0x6bd3e59f239fafe4776bb9bddd6bee83ba5d9d9f":"1000000000000000000000","0x29eaae82761762f4d2db53a9c68b0f6b0b6d4e66":"2000000000000000000000","0x0b7d339371e5be6727e6e331b5821fa24bdb9d5a":"857738000000000000000","0x4714cfa4f46bd6bd70737d75878197e08f88e631":"11792000000000000000000","0xad92ca066edb7c711dfc5b166192d1edf8e77185":"36000000000000000000000","0xf97b56ebd5b77abc9fbacbabd494b9d2c221cd03":"1970000000000000000000","0x591bef3171d1c5957717a4e98d17eb142c214e56":"20000000000000000000000","0x899b3c249f0c4b81df75d212004d3d6d952fd223":"2000000000000000000000","0xa819d2ece122e028c8e8a04a064d02b9029b08b9":"1000000000000000000000","0xe341642d40d2afce2e9107c67079ac7a2660086c":"400000000000000000000","0x0329188f080657ab3a2afa522467178279832085":"216700000000000000000","0x03317826d1f70aa4bddfa09be0c4105552d2358b":"38800000000000000000","0x3ac9dc7a436ae98fd01c7a9621aa8e9d0b8b531d":"1790000000000000000000","0x93c88e2d88621e30f58a9586bed4098999eb67dd":"31200000000000000000000","0xcd1e66ed539dd92fc40bbaa1fa16de8c02c14d45":"230000000000000000000","0xe6c81ffcecb47ecdc55c0b71e4855f3e5e97fc1e":"334250000000000000000","0x50f8fa4bb9e2677c990a4ee8ce70dd1523251e4f":"26030000000000000000","0x4f64a85e8e9a40498c0c75fceb0337fb49083e5e":"1000000000000000000000","0x4b29437c97b4a844be71cca3b648d4ca0fdd9ba4":"150200000000000000000","0x1eee6cbee4fe96ad615a9cf5857a647940df8c78":"19400000000000000000","0x29f0edc60338e7112085a1d114da8c42ce8f55d6":"2958000000000000000000","0x23b1c4917fbd93ee3d48389306957384a5496cbf":"4000086000000000000000","0x1767525c5f5a22ed80e9d4d7710f0362d29efa33":"400000000000000000000","0x3064899a963c4779cbf613cd6980846af1e6ec65":"6999908000000000000000","0x68531f4dda808f5320767a03113428ca0ce2f389":"19400000000000000000","0x1db9ac9a9eaeec0a523757050c71f47278c72d50":"1337000000000000000000","0x7592c69d067b51b6cc639d1164d5578c60d2d244":"20000000000000000000","0xcf3fbfa1fd32d7a6e0e6f8ef4eab57be34025c4c":"1063120000000000000000","0x8efec058cc546157766a632775404a334aaada87":"1999000000000000000000","0xfaf5f0b7b6d558f5090d9ea1fb2d42259c586078":"6401000000000000000000","0x19ecf2abf40c9e857b252fe1dbfd3d4c5d8f816e":"2000000000000000000000","0x6e8a26689f7a2fdefd009cbaaa5310253450daba":"2049982000000000000000","0xe2f40d358f5e3fe7463ec70480bd2ed398a7063b":"20000000000000000000","0xfa19d6f7a50f4f079893d167bf14e21d0073d196":"530000000000000000000","0x3e2ca0d234baf607ad466a1b85f4a6488ef00ae7":"89505000000000000000","0xf8a49ca2390c1f6d5c0e62513b079571743f7cc6":"3000000000000000000000","0x5d3f3b1f7130b0bb21a0fd32396239179a25657f":"62474000000000000000000","0xf332c0f3e05a27d9126fd0b641a8c2d4060608fd":"5001041000000000000000","0xe304a32f05a83762744a9542976ff9b723fa31ea":"1576256000000000000000","0xf768f321fd6433d96b4f354d3cc1652c1732f57f":"10000000000000000000000","0x147af46ae9ccd18bb35ca01b353b51990e49dce1":"4000000000000000000000","0x21eae6feffa9fbf4cd874f4739ace530ccbe5937":"5000000000000000000000","0x6994fb3231d7e41d491a9d68d1fa4cae2cc15960":"4000000000000000000000","0x51126446ab3d8032557e8eba65597d75fadc815c":"322000000000000000000","0x24daaaddf7b06bbcea9b80590085a88567682b4e":"319008000000000000000","0xcd020f8edfcf524798a9b73a640334bbf72f80a5":"133700000000000000000","0x56febf9e1003af15b1bd4907ec089a4a1b91d268":"200000000000000000000","0x3c79c863c3d372b3ff0c6f452734a7f97042d706":"176000000000000000000","0xe1203eb3a723e99c2220117ca6afeb66fa424f61":"9461996000000000000000","0x18fb09188f27f1038e654031924f628a2106703d":"2000000000000000000000","0x2eba0c6ee5a1145c1c573984963a605d880a7a20":"500000000000000000000","0x4cefbe2398e47d52e78db4334c8b697675f193ae":"4011000000000000000000","0xc02471e3fc2ea0532615a7571d493289c13c36ef":"20000000000000000000","0xba469aa5c386b19295d4a1b5473b540353390c85":"2000000000000000000000","0x7b11673cc019626b290cbdce26046f7e6d141e21":"500000000000000000000","0x26784ade91c8a83a8e39658c8d8277413ccc9954":"6000000000000000000000","0x57d3df804f2beee6ef53ab94cb3ee9cf524a18d3":"393606000000000000000","0xccae0d3d852a7da3860f0636154c0a6ca31628d4":"106560000000000000000","0xbfe3a1fc6e24c8f7b3250560991f93cba2cf8047":"80000000000000000000000","0x724ce858857ec5481c86bd906e83a04882e5821d":"3000000000000000000000","0xfb37cf6b4f81a9e222fba22e9bd24b5098b733cf":"38800000000000000000","0x9b22a80d5c7b3374a05b446081f97d0a34079e7f":"3000000000000000000000","0x0a29a8a4d5fd950075ffb34d77afeb2d823bd689":"200000000000000000000","0xd01af9134faf5257174e8b79186f42ee354e642d":"1000000000000000000000","0x7f1619988f3715e94ff1d253262dc5581db3de1c":"900000000000000000000","0x6f137a71a6f197df2cbbf010dcbd3c444ef5c925":"2000000000000000000000","0x11efb8a20451161b644a8ccebbc1d343a3bbcb52":"3200000000000000000000","0x46504e6a215ac83bccf956befc82ab5a679371c8":"518898000000000000000","0xb523fff9749871b35388438837f7e6e0dea9cb6b":"2000000000000000000000","0xc5c6a4998a33feb764437a8be929a73ba34a0764":"50000000000000000000000","0x3cd7f7c7c2353780cde081eeec45822b25f2860c":"200000000000000000000","0xb3050beff9de33c80e1fa15225e28f2c413ae313":"700000000000000000000","0x59268171b833e0aa13c54b52ccc0422e4fa03aeb":"3000000000000000000000","0x7169724ee72271c534cad6420fb04ee644cb86fe":"410164000000000000000","0x6e6d5bbbb9053b89d744a27316c2a7b8c09b547d":"909831000000000000000","0x3f3f46b75cabe37bfacc8760281f4341ca7f463d":"602709000000000000000","0x7a33834e8583733e2d52aead589bd1affb1dd256":"1000000000000000000000","0xe94ded99dcb572b9bb1dcba32f6dee91e057984e":"394000000000000000000","0x19336a236ded755872411f2e0491d83e3e00159e":"940000000000000000000","0x63ac545c991243fa18aec41d4f6f598e555015dc":"600000000000000000000","0xcfee05c69d1f29e7714684c88de5a16098e91399":"1970000000000000000000","0x77be6b64d7c733a436adec5e14bf9ad7402b1b46":"1000000000000000000000","0x233bdddd5da94852f4ade8d212885682d9076bc6":"4000000000000000000000","0x952c57d2fb195107d4cd5ca300774119dfad2f78":"2000000000000000000000","0xe237baa4dbc9926e32a3d85d1264402d54db012f":"2000000000000000000000","0xaa91237e740d25a92f7fa146faa18ce56dc6e1f3":"925000000000000000000","0x2339e9492870afea2537f389ac2f838302a33c06":"2000000000000000000000","0x1d45586eb803ca2190650bf748a2b174312bb507":"1400000000000000000000","0xc61446b754c24e3b1642d9e51765b4d3e46b34b6":"2000000000000000000000","0xac28b5edea05b76f8c5f97084541277c96696a4c":"1000000000000000000000","0x1a1c9a26e0e02418a5cf687da75a275c622c9440":"5000000000000000000000","0x299368609042a858d1ecdf1fc0ada5eaceca29cf":"2000000000000000000000","0x095f5a51d06f6340d80b6d29ea2e88118ad730fe":"2000200000000000000000","0x751a2ca34e7187c163d28e3618db28b13c196d26":"500000000000000000000","0x75b0e9c942a4f0f6f86d3f95ff998022fa67963b":"1490000000000000000000","0xd1b37f03cb107424e9c4dd575ccd4f4cee57e6cd":"2000000000000000000000","0x7f993ddb7e02c282b898f6155f680ef5b9aff907":"20000000000000000000000","0xa3d583a7b65b23f60b7905f3e4aa62aac87f4227":"1046779000000000000000","0x526bb533b76e20c8ee1ebf123f1e9ff4148e40be":"197000000000000000000","0x2160b4c02cac0a81de9108de434590a8bfe68735":"1970000000000000000000","0x010007394b8b7565a1658af88ce463499135d6b7":"100000000000000000000","0x64457fa33b0832506c4f7d1180dce48f46f3e0ff":"2000000000000000000000","0xb51e558eb5512fbcfa81f8d0bd938c79ebb5242b":"715000000000000000000","0x94f13f9f0836a3ee2437a84922d2984dc0f7d53b":"2999916000000000000000","0x6bd457ade051795df3f2465c3839aed3c5dee978":"999925000000000000000","0xf3dbcf135acb9dee1a489c593c024f03c2bbaece":"2000000000000000000000","0x61b902c5a673885826820d1fe14549e4865fbdc2":"334703000000000000000","0x2acc9c1a32240b4d5b2f777a2ea052b42fc1271c":"41764000000000000000000","0x6ddfef639155daab0a5cb4953aa8c5afaa880453":"1820000000000000000000","0x96ff6f509968f36cb42cba48db32f21f5676abf8":"1970000000000000000000","0xb4c8170f7b2ab536d1d9a25bdd203ae1288dc3d5":"200000000000000000000","0x78d4f8c71c1e68a69a98f52fcb45da8af56ea1a0":"2000000000000000000000","0xdec99e972fca7177508c8e1a47ac22d768acab7c":"2000000000000000000000","0xa07aa16d74aee8a9a3288d52db1551d593883297":"600000000000000000000","0xcf1169041c1745e45b172435a2fc99b49ace2b00":"31960000000000000000","0x526cb09ce3ada3672eec1deb46205be89a4b563e":"2468000000000000000000","0xee6959de2b67967b71948c891ab00d8c8f38c7dc":"118200000000000000000","0xca7ba3ff536c7e5f0e153800bd383db8312998e0":"169600000000000000000","0x1ed06ee51662a86c634588fb62dc43c8f27e7c17":"200000000000000000000","0x730447f97ce9b25f22ba1afb36df27f9586beb9b":"820000000000000000000","0xae5c9bdad3c5c8a1220444aea5c229c1839f1d64":"477500000000000000000","0xa38306cb70baa8e49186bd68aa70a83d242f2907":"2000000000000000000000","0x71213fca313404204ecba87197741aa9dfe96338":"60000000000000000000","0x10e390ad2ba33d82b37388d09c4544c6b0225de5":"200000000000000000000","0x3b6e814f770748a7c3997806347605480a3fd509":"2000000000000000000000","0xfd452c3969ece3801c542020f1cdcaa1c71ed23d":"100000000000000000000000","0xe742b1e6069a8ffc3c4767235defb0d49cbed222":"800000000000000000000","0xd7225738dcf3578438f8e7c8b3837e42e04a262f":"445860000000000000000","0xcd0b0257e783a3d2c2e3ba9d6e79b75ef98024d4":"2945500000000000000000","0xe80e7fef18a5db15b01473f3ad6b78b2a2f8acd9":"500000000000000000000","0x261575e9cf59c8226fa7aaf91de86fb70f5ac3ae":"300022000000000000000","0x7e71171f2949fa0c3ac254254b1f0440e5e6a038":"40000000000000000000","0x96ea6ac89a2bac95347b51dba63d8bd5ebdedce1":"2000000000000000000000","0xe6ec5cf0c49b9c317e1e706315ef9eb7c0bf11a7":"17200000000000000000000","0x2b99b42e4f42619ee36baa7e4af2d65eacfcba35":"40000000000000000000000","0xc6e4cc0c7283fc1c85bc4813effaaf72b49823c0":"276926000000000000000","0xdbc1ce0e49b1a705d22e2037aec878ee0d75c703":"250000000000000000000","0x806f44bdeb688037015e84ff218049e382332a33":"1999000000000000000000","0x1a3a330e4fcb69dbef5e6901783bf50fd1c15342":"4200000000000000000000","0xd2a84f75675c62d80c88756c428eee2bcb185421":"1200000000000000000000","0xc593b546b7698710a205ad468b2c13152219a342":"1550000000000000000000","0x3f627a769e6a950eb87017a7cd9ca20871136831":"13790000000000000000000","0xf2d5763ce073127e2cedde6faba786c73ca94141":"7900000000000000000000","0x162110f29eac5f7d02b543d8dcd5bb59a5e33b73":"2000000000000000000000","0x59473cd300fffae240f5785626c65dfec792b9af":"20000000000000000000","0x4dcd11815818ae29b85d01367349a8a7fb12d06b":"7900000000000000000000","0x9329ffdc268babde8874b366406c81445b9b2d35":"422415000000000000000","0x0ab4281ebb318590abb89a81df07fa3af904258a":"500000000000000000000","0x875061ee12e820041a01942cb0e65bb427b00060":"2800000000000000000000","0xc9b698e898d20d4d4f408e4e4d061922aa856307":"40000000000000000000","0xca49a5f58adbefae23ee59eea241cf0482622eaa":"1430000000000000000000","0x196e85df7e732b4a8f0ed03623f4db9db0b8fa31":"21165000000000000000","0x4c760cd9e195ee4f2d6bce2500ff96da7c43ee91":"60000000000000000000000","0x024a098ae702bef5406c9c22b78bd4eb2cc7a293":"4000000000000000000000","0x9d81aea69aed6ad07089d61445348c17f34bfc5b":"300000000000000000000","0x76ab87dd5a05ad839a4e2fc8c85aa6ba05641730":"2000000000000000000000","0xc6e2f5af979a03fd723a1b6efa728318cf9c1800":"668500000000000000000","0x5db69fe93e6fb6fbd450966b97238b110ad8279a":"40000000000000000000000","0xa4259f8345f7e3a8b72b0fec2cf75e321fda4dc2":"1910000000000000000000","0x095030e4b82692dcf8b8d0912494b9b378ec9328":"1340000000000000000000","0x4b470f7ba030bc7cfcf338d4bf0432a91e2ea5ff":"2000000000000000000000","0x99c9f93e45fe3c1418c353e4c5ac3894eef8121e":"101870000000000000000","0xffac3db879a6c7158e8dec603b407463ba0d31cf":"1970000000000000000000","0xac8e87ddda5e78fcbcb9fa7fc3ce038f9f7d2e34":"2000000000000000000000","0x7a0589b143a8e5e107c9ac66a9f9f8597ab3e7ab":"1510990000000000000000","0xb7d581fe0af1ec383f3b3c416783f385146a7612":"20000000000000000000000","0xbb3fc0a29c034d710812dcc775c8cab9d28d6975":"1066806000000000000000","0x2c603ff0fe93616c43573ef279bfea40888d6ae7":"4740000000000000000000","0x15f2b7b16432ee50a5f55b41232f6334ed58bdc0":"400000000000000000000","0x7f3d7203c8a447f7bf36d88ae9b6062a5eee78ae":"6000000000000000000000","0xf067e1f1d683556a4cc4fd0c0313239f32c4cfd8":"1000000000000000000000","0x52738c90d860e04cb12f498d96fdb5bf36fc340e":"30000000000000000000","0x45781bbe7714a1c8f73b1c747921df4f84278b70":"2000000000000000000000","0x4a97e8fcf4635ea7fc5e96ee51752ec388716b60":"546000000000000000000","0x54939ff08921b467cf2946751d856378296c63ed":"1000000000000000000000","0x6485470e61db110aebdbafd536769e3c599cc908":"600000000000000000000","0xe20d1bcb71286dc7128a9fc7c6ed7f733892eef5":"1003400000000000000000","0xd6eea898d4ae2b718027a19ce9a5eb7300abe3ca":"27475000000000000000","0x014974a1f46bf204944a853111e52f1602617def":"2000000000000000000000","0x6aa5732f3b86fb8c81efbe6b5b47b563730b06c8":"1000000000000000000000","0x6107d71dd6d0eefb11d4c916404cb98c753e117d":"2000000000000000000000","0xdd7bcda65924aaa49b80984ae173750258b92847":"10000000000000000000000","0x4e7b54474d01fefd388dfcd53b9f662624418a05":"8000000000000000000000","0x24fc73d20793098e09ddab5798506224fa1e1850":"200000000000000000000","0x2b8488bd2d3c197a3d26151815b5a798d27168dc":"6680000000000000000000","0x949131f28943925cfc97d41e0cea0b262973a730":"2800000000000000000000","0x60b8d6b73b79534fb08bb8cbcefac7f393c57bfe":"1760000000000000000000","0xd6acc220ba2e51dfcf21d443361eea765cbd35d8":"20000000000000000000","0xc4c6cb723dd7afa7eb535615e53f3cef14f18118":"1999999000000000000000","0x4c9a862ad115d6c8274ed0b944bdd6a5500510a7":"100000000000000000000","0x85732c065cbd64119941aed430ac59670b6c51c4":"731345000000000000000","0x0126e12ebc17035f35c0e9d11dd148393c405d7a":"1999600000000000000000","0x472048cc609aeb242165eaaa8705850cf3125de0":"1000000000000000000000","0xd2edd1ddd6d86dc005baeb541d22b640d5c7cae5":"20000000000000000000","0x4549b15979255f7e65e99b0d5604db98dfcac8bf":"4000000000000000000000","0xc6c7c191379897dd9c9d9a33839c4a5f62c0890d":"4000085000000000000000","0xd367009ab658263b62c2333a1c9e4140498e1389":"2000000000000000000000","0x143f5f1658d9e578f4f3d95f80c0b1bd3933cbda":"1490000000000000000000","0x1a09fdc2c7a20e23574b97c69e93deba67d37220":"1998000000000000000000","0xac8b509aefea1dbfaf2bb33500d6570b6fd96d51":"1820000000000000000000","0x16ffac84032940f0121a09668b858a7e79ffa3bb":"3879210000000000000000","0xf338459f32a159b23db30ac335769ab2351aa63c":"30000000000000000000000","0xd82251456dc1380f8f5692f962828640ab9f2a03":"4879980000000000000000","0x47f4696bd462b20da09fb83ed2039818d77625b3":"149000000000000000000","0x3dde8b15b3ccbaa5780112c3d674f313bba68026":"1773000000000000000000","0xf70d637a845c06db6cdc91e6371ce7c4388a628e":"20000000000000000000","0x68295e8ea5afd9093fc0a465d157922b5d2ae234":"19982000000000000000","0x614e8bef3dd2c59b59a4145674401018351884ea":"20000000000000000000","0x4737d042dc6ae73ec73ae2517acea2fdd96487c5":"1000000000000000000000","0xcec6fc65853f9cce5f8e844676362e1579015f02":"2000000000000000000000","0xae47e2609cfafe369d66d415d939de05081a9872":"27060000000000000000000","0x09a928d528ec1b3e25ffc83e218c1e0afe8928c7":"18200000000000000000","0x9b444fd337e5d75293adcfff70e1ea01db023222":"100000000000000000000","0x168bdec818eafc6d2992e5ef54aa0e1601e3c561":"1000110000000000000000","0x353dbec42f92b50f975129b93c4c997375f09073":"1999000000000000000000","0x6fcc2c732bdd934af6ccd16846fb26ef89b2aa9b":"10001242000000000000000","0x6f2576da4de283bbe8e3ee69ddd66e5e711db3f5":"1260800000000000000000","0x3a3dd104cd7eb04f21932fd433ea7affd39369f5":"357500000000000000000","0xd44f4ac5fad76bdc1537a3b3af6472319b410d9d":"1600000000000000000000","0x3d9d6be57ff83e065985664f12564483f2e600b2":"2041600000000000000000","0x88f1045f19f2d3191816b1df18bb6e1435ad1b38":"240000000000000000000","0xddab75fb2ff9fecb88f89476688e2b00e367ebf9":"19400000000000000000000","0x092e815558402d67f90d6bfe6da0b2fffa91455a":"60000000000000000000","0xa7024cfd742c1ec13c01fea18d3042e65f1d5dee":"11272229000000000000000","0x7f46bb25460dd7dae4211ca7f15ad312fc7dc75c":"6685000000000000000000","0x93f18cd2526040761488c513174d1e7963768b2c":"2416500000000000000000","0x352f25babf4a690673e35195efa8f79d05848aad":"66800000000000000000000","0xf7b151cc5e571c17c76539dbe9964cbb6fe5de79":"2148000000000000000000","0xff3eee57c34d6dae970d8b311117c53586cd3502":"1700000000000000000000","0xae6f0c73fdd77c489727512174d9b50296611c4c":"6000000000000000000000","0x7819b0458e314e2b53bfe00c38495fd4b9fdf8d6":"20000000000000000000","0x7fdba031c78f9c096d62d05a369eeab0bccc55e5":"2800000000000000000000","0x735e328666ed5637142b3306b77ccc5460e72c3d":"1968682000000000000000","0x0bfbb6925dc75e52cf2684224bbe0550fea685d3":"1970000000000000000000","0x6be16313643ebc91ff9bb1a2e116b854ea933a45":"500000000000000000000","0xd6acffd0bfd99c382e7bd56ff0e6144a9e52b08e":"160000000000000000000","0x276a006e3028ecd44cdb62ba0a77ce94ebd9f10f":"1800000000000000000000","0x10711c3dda32317885f0a2fd8ae92e82069b0d0b":"4000000000000000000000","0x43cb9652818c6f4d6796b0e89409306c79db6349":"2000000000000000000000","0x7109dd011d15f3122d9d3a27588c10d77744508b":"2000000000000000000000","0x3497dd66fd118071a78c2cb36e40b6651cc82598":"109600000000000000000","0x9bf672d979b36652fc5282547a6a6bc212ae4368":"656000000000000000000","0xeaed16eaf5daab5bf0295e5e077f59fb8255900b":"4000000000000000000000","0x7ac58f6ffc4f8107ae6e30378e4e9f99c57fbb24":"40000000000000000000","0x45a570dcc2090c86a6b3ea29a60863dde41f13b5":"232500000000000000000","0x433a3b68e56b0df1862b90586bbd39c840ff1936":"2000000000000000000000","0xe8eaf12944092dc3599b3953fa7cb1c9761cc246":"1800000000000000000000","0xec11362cec810985d0ebbd7b73451444985b369f":"30000047000000000000000","0x78e83f80b3678c7a0a4e3e8c84dccde064426277":"1790000000000000000000","0x0cc67f8273e1bae0867fd42e8b8193d72679dbf8":"500000000000000000000","0xc70d856d621ec145303c0a6400cd17bbd6f5eaf7":"20000000000000000000","0xf468906e7edf664ab0d8be3d83eb7ab3f7ffdc78":"1700000000000000000000","0x3c286cfb30146e5fd790c2c8541552578de334d8":"10203000000000000000000","0xc401c427cccff10decb864202f36f5808322a0a8":"3329300000000000000000","0xafd019ff36a09155346b69974815a1c912c90aa4":"2000000000000000000000","0x96fe59c3dbb3aa7cc8cb62480c65e56e6204a7e2":"20000000000000000000000","0xa47779d8bc1c7bce0f011ccb39ef68b854f8de8f":"2000000000000000000000","0x58c650ced40bb65641b8e8a924a039def46854df":"18500000000000000000","0x86f4f40ad984fbb80933ae626e0e42f9333fdd41":"1000000000000000000000","0xb22d5055d9623135961e6abd273c90deea16a3e7":"1400000000000000000000","0xee3564f5f1ba0f94ec7bac164bddbf31c6888b55":"100000000000000000000","0xcf26b47bd034bc508e6c4bcfd6c7d30034925761":"1800000000000000000000","0xe87dbac636a37721df54b08a32ef4959b5e4ff82":"2000000000000000000000","0x3bf86ed8a3153ec933786a02ac090301855e576b":"450000000000000000000000","0xcfd2728dfb8bdbf3bf73598a6e13eaf43052ea2b":"170000000000000000000","0x85b16f0b8b34dff3804f69e2168a4f7b24d1042b":"317000000000000000000","0x84db1459bb00812ea67ecb3dc189b72187d9c501":"148851000000000000000","0x8c3a9ee71f729f236cba3867b4d79d8ceee25dbc":"100000000000000000000","0xe677c31fd9cb720075dca49f1abccd59ec33f734":"7800000000000000000000","0x8889448316ccf14ed86df8e2f478dc63c4338340":"15200000000000000000","0xb279c7d355c2880392aad1aa21ee867c3b3507df":"1261000000000000000000","0x12b5e28945bb2969f9c64c63cc05b6f1f8d6f4d5":"7722162000000000000000","0x8d2303341e1e1eb5e8189bde03f73a60a2a54861":"100000000000000000000","0x94d81074db5ae197d2bb1373ab80a87d121c4bd3":"9400000000000000000000","0x752c9febf42f66c4787bfa7eb17cf5333bba5070":"1966448000000000000000","0x16816aac0ede0d2d3cd442da79e063880f0f1d67":"2000000000000000000000","0xdaac91c1e859d5e57ed3084b50200f9766e2c52b":"400000000000000000000","0x32c2fde2b6aabb80e5aea2b949a217f3cb092283":"5614827000000000000000","0xcdab46a5902080646fbf954204204ae88404822b":"544942000000000000000","0xfdf42343019b0b0c6bf260b173afab7e45b9d621":"1999944000000000000000","0x791f6040b4e3e50dcf3553f182cd97a90630b75d":"4000000000000000000000","0x4b762166dd1118e84369f804c75f9cd657bf730c":"500000000000000000000","0xa76d3f156251b72c0ccf4b47a3393cbd6f49a9c5":"1337000000000000000000","0xc5eb42295e9cadeaf2af12dede8a8d53c579c469":"3820000000000000000000","0xdb9371b30c4c844e59e03e924be606a938d1d310":"2000000000000000000000","0x2cd39334ac7eac797257abe3736195f5b4b5ce0f":"99964000000000000000","0xad44357e017e244f476931c7b8189efee80a5d0a":"300000000000000000000","0x4ca7b717d9bc8793b04e051a8d23e1640f5ba5e3":"1248980000000000000000","0x73e4a2b60cf48e8baf2b777e175a5b1e4d0c2d8f":"100000000000000000000","0x5a1d2d2d1d520304b6208849570437eb3091bb9f":"1970000000000000000000","0x53047dc8ac9083d90672e8b3473c100ccd278323":"40000000000000000000","0x26fe174cbf526650e0cd009bd6126502ce8e684d":"11640000000000000000000","0xe2df23f6ea04becf4ab701748dc0963184555cdb":"2000000000000000000000","0xc1170dbaadb3dee6198ea544baec93251860fda5":"1200000000000000000000","0x8bbeacfc29cfe93402db3c41d99ab759662e73ec":"2000000000000000000000","0x165305b787322e25dc6ad0cefe6c6f334678d569":"2000000000000000000000","0x095457f8ef8e2bdc362196b9a9125da09c67e3ab":"200000000000000000000","0x702802f36d00250fab53adbcd696f0176f638a49":"2000000000000000000000","0x489334c2b695c8ee0794bd864217fb9fd8f8b135":"18200000000000000000","0xfa8cf4e627698c5d5788abb7880417e750231399":"4244640000000000000000","0x3329eb3baf4345d600ced40e6e9975656f113742":"4999711000000000000000","0xb4dd5499daeb2507fb2de12297731d4c72b16bb0":"20000000000000000000","0x88c2516a7cdb09a6276d7297d30f5a4db1e84b86":"4000000000000000000000","0x612ced8dc0dc9e899ee46f7962333315f3f55e44":"338830000000000000000","0xd71e43a45177ad51cbe0f72184a5cb503917285a":"200000000000000000000","0x2fb566c94bbba4e3cb67cdda7d5fad7131539102":"2000000000000000000000","0x03be5b4629aefbbcab9de26d39576cb7f691d764":"200550000000000000000","0x025367960304beee34591118e9ac2d1358d8021a":"2000000000000000000000","0xa5d5b8b62d002def92413710d13b6ff8d4fc7dd3":"400000000000000000000","0xdf3b72c5bd71d4814e88a62321a93d4011e3578b":"4000000000000000000000","0x3588895ac9fbafec012092dc05c0c302d90740fa":"3000000000000000000000","0x6021e85a8814fce1e82a41abd1d3b2dad2faefe0":"2000000000000000000000","0x17ee9f54d4ddc84d670eff11e54a659fd72f4455":"16000000000000000000000","0x873c6f70efb6b1d0f2bbc57eebcd70617c6ce662":"1013478000000000000000","0x1fcc7ce6a8485895a3199e16481f72e1f762defe":"1000000000000000000000","0xd0a7209b80cf60db62f57d0a5d7d521a69606655":"160000000000000000000","0xa514d00edd7108a6be839a638db2415418174196":"30000000000000000000000","0x046377f864b0143f282174a892a73d3ec8ec6132":"191000000000000000000","0xc126573d87b0175a5295f1dd07c575cf8cfa15f2":"10000000000000000000000","0x0e123d7da6d1e6fac2dcadd27029240bb39052fe":"1000000000000000000000","0xad5a8d3c6478b69f657db3837a2575ef8e1df931":"36990000000000000000","0xdb882eacedd0eff263511b312adbbc59c6b8b25b":"9100000000000000000000","0x0b43bd2391025581d8956ce42a072579cbbfcb14":"18800000000000000000","0xaffea0473722cb7f0e0e86b9e11883bf428d8d54":"1940000000000000000000","0xe32b1c4725a1875449e98f970eb3e54062d15800":"200000000000000000000","0x98f4af3af0aede5fafdc42a081ecc1f89e3ccf20":"9400000000000000000000","0x3b4768fd71e2db2cbe7fa050483c27b4eb931df3":"2000000000000000000000","0xd5f7c41e07729dfa6dfc64c4423160a22c609fd3":"1790000000000000000000","0xd944c8a69ff2ca1249690c1229c7192f36251062":"1970000000000000000000","0x5ae64e853ba0a51282cb8db52e41615e7c9f733f":"2000000000000000000000","0xb13f93af30e8d7667381b2b95bc1a699d5e3e129":"420000000000000000000","0x8a20e5b5cee7cd1f5515bace3bf4f77ffde5cc07":"80000000000000000000","0x2448596f91c09baa30bc96106a2d37b5705e5d28":"2000000000000000000000","0xccca24d8c56d6e2c07db086ec07e585be267ac8d":"200000000000000000000","0xf67bb8e2118bbcd59027666eedf6943ec9f880a5":"4000000000000000000000","0x7ae659eb3bc46852fa86fac4e21c768d50388945":"286000000000000000000","0x467e0ed54f3b76ae0636176e07420815a021736e":"2000000000000000000000","0xa46cd237b63eea438c8e3b6585f679e4860832ac":"1000000000000000000000","0x6b760d4877e6a627c1c967bee451a8507ddddbab":"910000000000000000000","0x593044670faeff00a55b5ae051eb7be870b11694":"133700000000000000000","0x533c06928f19d0a956cc28866bf6c8d8f4191a94":"292320000000000000000","0x262dc1364ccf6df85c43268ee182554dae692e29":"4927600000000000000000","0xe4368bc1420b35efda95fafbc73090521916aa34":"4000000000000000000000","0xfeb92d30bf01ff9a1901666c5573532bfa07eeec":"1000000000000000000000","0xee25b9a7032679b113588ed52c137d1a053a1e94":"199820000000000000000","0x20134cbff88bfadc466b52eceaa79857891d831e":"1000000000000000000000","0x07b1a306cb4312df66482c2cae72d1e061400fcd":"20000000000000000000000","0xe791d585b89936b25d298f9d35f9f9edc25a2932":"2000000000000000000000","0x2e6933543d4f2cc00b5350bd8068ba9243d6beb0":"2000000000000000000000","0xdae0d33eaa341569fa9ff5982684854a4a328a6e":"1000000000000000000000","0x125cc5e4d56b2bcc2ee1c709fb9e68fb177440bd":"2000000000000000000000","0xec99e95dece46ffffb175eb6400fbebb08ee9b95":"100000000000000000000","0xc538a0ff282aaa5f4b75cfb62c70037ee67d4fb5":"2000000000000000000000","0x60676d1fa21fca052297e24bf96389c5b12a70d7":"241500000000000000000","0x4b3dfbdb454be5279a3b8addfd0ed1cd37a9420d":"2000000000000000000000","0xcdb597299030183f6e2d238533f4642aa58754b6":"400000000000000000000","0x1ef2dcbfe0a500411d956eb8c8939c3d6cfe669d":"776000000000000000000","0xa7247c53d059eb7c9310f628d7fc6c6a0a773f08":"500000000000000000000","0x9799ca21dbcf69bfa1b3f72bac51b9e3ca587cf9":"1700000000000000000000","0xddf95c1e99ce2f9f5698057c19d5c94027ee4a6e":"6000000000000000000000","0x83563bc364ed81a0c6da3b56ff49bbf267827a9c":"17332000000000000000000","0xa192698007cc11aa603d221d5feea076bcf7c30d":"2000000000000000000000","0x0134ff38155fabae94fd35c4ffe1d79de7ef9c59":"985000000000000000000","0x80977316944e5942e79b0e3abad38da746086519":"38800000000000000000","0x193d37ed347d1c2f4e35350d9a444bc57ca4db43":"60000000000000000000","0x009a6d7db326679b77c90391a7476d238f3ba33e":"200200000000000000000","0x337b3bdf86d713dbd07b5dbfcc022b7a7b1946ae":"3980000000000000000000","0x7de7fe419cc61f91f408d234cc80d5ca3d054d99":"20000000000000000000","0xf47bb134da30a812d003af8dccb888f44bbf5724":"5190000000000000000000","0xfd920f722682afb5af451b0544d4f41b3b9d5742":"2330200000000000000000","0x0a917f3b5cb0b883047fd9b6593dbcd557f453b9":"1000000000000000000000","0xce9786d3712fa200e9f68537eeaa1a06a6f45a4b":"1790000000000000000000","0x9ab98d6dbb1eaae16d45a04568541ad3d8fe06cc":"272451000000000000000","0x0b7bb342f01bc9888e6a9af4a887cbf4c2dd2caf":"16000000000000000000000","0x4c0b1515dfced7a13e13ee12c0f523ae504f032b":"50000000000000000000000","0xac2889b5966f0c7f9edb42895cb69d1c04f923a2":"5000000000000000000000","0xd008513b27604a89ba1763b6f84ce688b346945b":"1000000000000000000000","0xa4b09de6e713dc69546e76ef0acf40b94f0241e6":"322656000000000000000","0xb153f828dd076d4a7c1c2574bb2dee1a44a318a8":"400000000000000000000","0x02ade5db22f8b758ee1443626c64ec2f32aa0a15":"20000000000000000000000","0x0a0650861f785ed8e4bf1005c450bbd06eb48fb6":"3066860000000000000000","0xb75149e185f6e3927057739073a1822ae1cf0df2":"4000086000000000000000","0x84cb7da0502df45cf561817bbd2362f451be02da":"1337000000000000000000","0xc91bb562e42bd46130e2d3ae4652b6a4eb86bc0f":"540000000000000000000","0xb234035f7544463ce1e22bc553064684c513cd51":"249750000000000000000","0xe5e33800a1b2e96bde1031630a959aa007f26e51":"1337000000000000000000","0xae5ce3355a7ba9b332760c0950c2bc45a85fa9a0":"400000000000000000000","0xe6f5eb649afb99599c414b27a9c9c855357fa878":"2674000000000000000000","0x7010be2df57bd0ab9ae8196cd50ab0c521aba9f9":"1970000000000000000000","0xca4288014eddc5632f5facb5e38517a8f8bc5d98":"340000000000000000000","0x2784903f1d7c1b5cd901f8875d14a79b3cbe2a56":"22388000000000000000000","0xf8dce867f0a39c5bef9eeba609229efa02678b6c":"2000000000000000000000","0xe020e86362b487752836a6de0bc02cd8d89a8b6a":"6000000000000000000000","0xc4088c025f3e85013f5439fb3440a17301e544fe":"2325000000000000000000","0xbefb448c0c5f683fb67ee570baf0db5686599751":"1970000000000000000000","0x2f187d5a704d5a338c5b2876a090dce964284e29":"4000000000000000000000","0xec0e18a01dc4dc5daae567c3fa4c7f8f9b590205":"315900000000000000000","0x637f5869d6e4695f0eb9e27311c4878aff333380":"1969212000000000000000","0xd1100dd00fe2ddf18163ad964d0b69f1f2e9658a":"5959598000000000000000","0x17ef4acc1bf147e326749d10e677dcffd76f9e06":"39980000000000000000000","0x200dfc0b71e359b2b465440a36a6cdc352773007":"1500000000000000000000","0xefe0675da98a5dda70cd96196b87f4e726b43348":"1164000000000000000000","0xd5bd5e8455c130169357c471e3e681b7996a7276":"841500000000000000000","0x9c7b6dc5190fe2912963fcd579683ec7395116b0":"776000000000000000000","0xb105dd3d987cffd813e9c8500a80a1ad257d56c6":"1999944000000000000000","0x145250b06e4fa7cb2749422eb817bdda8b54de5f":"219000000000000000000","0xd96db33b7b5a950c3efa2dc31b10ba10a532ef87":"2000000000000000000000","0xaf529bdb459cc185bee5a1c58bf7e8cce25c150d":"197000000000000000000","0x185546e8768d506873818ac9751c1f12116a3bef":"200000000000000000000","0x51d24bc3736f88dd63b7222026886630b6eb878d":"2000000000000000000000","0x69af28b0746cac0da17084b9398c5e36bb3a0df2":"1004700000000000000000","0x76f83ac3da30f7092628c7339f208bfc142cb1ee":"2842600000000000000000","0x00f463e137dcf625fbf3bca39eca98d2b968cf7f":"5910000000000000000000","0x2084fce505d97bebf1ad8c5ff6826fc645371fb2":"30000000000000000000","0x53a714f99fa00fef758e23a2e746326dad247ca7":"1490000000000000000000","0x0bf064428f83626722a7b5b26a9ab20421a7723e":"133700000000000000000","0xac6f68e837cf1961cb14ab47446da168a16dde89":"1337000000000000000000","0x4b3c7388cc76da3d62d40067dabccd7ef0433d23":"100076000000000000000","0xdeb9a49a43873020f0759185e20bbb4cf381bb8f":"211628000000000000000","0x5bf9f2226e5aeacf1d80ae0a59c6e38038bc8db5":"6000000000000000000000","0x9d0e7d92fb305853d798263bf15e97c72bf9d7e0":"1000000000000000000000","0x2b5c60e84535eeb4d580de127a12eb2677ccb392":"20000000000000000000000","0xd8d65420c18c2327cc5af97425f857e4a9fd51b3":"1760000000000000000000","0x30ec9392244a2108c987bc5cdde0ed9f837a817b":"1560562000000000000000","0x56a1d60d40f57f308eebf087dee3b37f1e7c2cba":"1159600000000000000000","0xa9a1cdc33bfd376f1c0d76fb6c84b6b4ac274d68":"5000000000000000000000","0xa67f38819565423aa85f3e3ab61bc763cbab89dd":"2130000000000000000000","0x62d5cc7117e18500ac2f9e3c26c86b0a94b0de15":"105000000000000000000","0x4970d3acf72b5b1f32a7003cf102c64ee0547941":"140000000000000000000000","0x76628150e2995b5b279fc83e0dd5f102a671dd1c":"40000000000000000000000","0x3d8f39881b9edfe91227c33fa4cdd91e678544b0":"86111000000000000000","0xff0b7cb71da9d4c1ea6ecc28ebda504c63f82fd1":"1043000000000000000000","0x8d795c5f4a5689ad62da961671f028065286d554":"2048000000000000000000","0xbe2346a27ff9b702044f500deff2e7ffe6824541":"20000000000000000000","0x0dbd417c372b8b0d01bcd944706bd32e60ae28d1":"340000000000000000000","0x467fbf41441600757fe15830c8cd5f4ffbbbd560":"10000000000000000000000","0x090cd67b60e81d54e7b5f6078f3e021ba65b9a1e":"1000000000000000000000","0x55a4cac0cb8b582d9fef38c5c9fff9bd53093d1f":"1970000000000000000000","0x3b7b4f53c45655f3dc5f017edc23b16f9bc536fa":"100000000000000000000","0xd508d39c70916f6abc4cc7f999f011f077105802":"100470000000000000000","0x037dd056e7fdbd641db5b6bea2a8780a83fae180":"140000000000000000000","0x660557bb43f4be3a1b8b85e7df7b3c5bcd548057":"6000000000000000000000","0x02089361a3fe7451fb1f87f01a2d866653dc0b07":"39976000000000000000","0xc4bec96308a20f90cab18399c493fd3d065abf45":"14000000000000000000000","0xcca07bb794571d4acf041dad87f0d1ef3185b319":"2000000000000000000000","0xf2d0e986d814ea13c8f466a0538c53dc922651f0":"1380000000000000000000","0x662cfa038fab37a01745a364e1b98127c503746d":"3940000000000000000000","0x3336c3ef6e8b50ee90e037b164b7a8ea5faac65d":"272712000000000000000","0x30e33358fc21c85006e40f32357dc8895940aaf0":"1910000000000000000000","0x41a9a404fc9f5bfee48ec265b12523338e29a8bf":"388000000000000000000","0x6af235d2bbe050e6291615b71ca5829658810142":"3000000000000000000000","0xfd5a63157f914fd398eab19c137dd9550bb7715c":"100000000000000000000","0x8a4314fb61cd938fc33e15e816b113f2ac89a7fb":"432800000000000000000","0xb216dc59e27c3d7279f5cd5bb2becfb2606e14d9":"400000000000000000000","0xf5a5459fcdd5e5b273830df88eea4cb77ddadfb9":"74500000000000000000","0xdf31025f5649d2c6eea41ed3bdd3471a790f759a":"20000000000000000000","0x721f9d17e5a0e74205947aeb9bc6a7938961038f":"51900000000000000000","0x08d0864dc32f9acb36bf4ea447e8dd6726906a15":"2000200000000000000000","0x54575c3114751e3c631971da6a2a02fd3ffbfcc8":"1940000000000000000000","0x8f60895fbebbb5017fcbff3cdda397292bf25ba6":"429177000000000000000","0x91fe8a4c6164df8fa606995d6ba7adcaf1c893ce":"17000000000000000000000","0x889087f66ff284f8b5efbd29493b706733ab1447":"9850000000000000000000","0x051633080d07a557adde319261b074997f14692d":"5800000000000000000000","0x59a12df2e3ef857aceff9306b309f6a500f70134":"1000000000000000000000","0x9f64a8e8dacf4ade30d10f4d59b0a3d5abfdbf74":"1000060000000000000000","0x8846928d683289a2d11df8db7a9474988ef01348":"10000000000000000000000","0xdff1b220de3d8e9ca4c1b5be34a799bcded4f61c":"385428000000000000000","0x7e7c1e9a61a08a83984835c70ec31d34d3eaa87f":"191000000000000000000","0xfe210b8f04dc6d4f76216acfcbd59ba83be9b630":"20000000000000000000","0xdc8c2912f084a6d184aa73638513ccbc326e0102":"1295000000000000000000","0xdddd7b9e6eab409b92263ac272da801b664f8a57":"500000000000000000000000","0x86a5f8259ed5b09e188ce346ee92d34aa5dd93fa":"200000000000000000000","0xdc1f1979615f082140b8bb78c67b27a1942713b1":"60000000000000000000","0xea66e7b84dcdbf36eea3e75b85382a75f1a15d96":"1729135000000000000000","0x039e7a4ebc284e2ccd42b1bdd60bd6511c0f7706":"17300000000000000000","0x36bfe1fa3b7b70c172eb042f6819a8972595413e":"1000000000000000000000","0x039ef1ce52fe7963f166d5a275c4b1069fe3a832":"400008000000000000000","0xf1df55dcc34a051012b575cb968bc9c458ea09c9":"4000000000000000000000","0x168b5019b818691644835fe69bf229e17112d52c":"28000000000000000000000","0xf60bd735543e6bfd2ea6f11bff627340bc035a23":"2000000000000000000000","0x2cbb0c73df91b91740b6693b774a7d05177e8e58":"1850000000000000000000","0x9ffcf5ef46d933a519d1d16c6ba3189b27496224":"1000000000000000000000","0x0e11d77a8977fac30d268445e531149b31541a24":"2000000000000000000000","0xdfb1626ef48a1d7d7552a5e0298f1fc23a3b482d":"1713860000000000000000","0xcc943be1222cd1400a2399dd1b459445cf6d54a9":"12530000000000000000000","0xb37c2b9f50637bece0ca959208aefee6463ba720":"400000000000000000000","0x96b906ea729f4655afe3e57d35277c967dfa1577":"1000000000000000000000","0x7995bd8ce2e0c67bf1c7a531d477bca1b2b97561":"5945100000000000000000","0x96f820500b70f4a3e3239d619cff8f222075b135":"200000000000000000000","0xad3565d52b688added08168b2d3872d17d0a26ae":"100000000000000000000","0x9e7c2050a227bbfd60937e268cea3e68fea8d1fe":"100000000000000000000","0x7e59dc60be8b2fc19abd0a5782c52c28400bce97":"1000000000000000000000","0x01ed5fba8d2eab673aec042d30e4e8a611d8c55a":"2000000000000000000000","0x59a087b9351ca42f58f36e021927a22988284f38":"18500000000000000000","0x2fe0023f5722650f3a8ac01009125e74e3f82e9b":"3000000000000000000000","0xbd1803370bddb129d239fd16ea8526a6188ae58e":"500000000000000000000","0xc70527d444c490e9fc3f5cc44e66eb4f306b380f":"4000000000000000000000","0x0f206e1a1da7207ea518b112418baa8b06260328":"600000000000000000000","0x6e1a046caf5b4a57f4fd4bc173622126b4e2fd86":"1790000000000000000000","0x84008a72f8036f3feba542e35078c057f32a8825":"100000000000000000000","0x246291165b59332df5f18ce5c98856fae95897d6":"1700000000000000000000","0x7e99dfbe989d3ba529d19751b7f4317f8953a3e2":"400000000000000000000","0x748c285ef1233fe4d31c8fb1378333721c12e27a":"2000000000000000000000","0x3dd12e556a603736feba4a6fa8bd4ac45d662a04":"167450000000000000000000","0xd0ae735d915e946866e1fea77e5ea466b5cadd16":"2000000000000000000000","0x4f767bc8794aef9a0a38fea5c81f14694ff21a13":"512200000000000000000","0x0e2f8e28a681f77c583bd0ecde16634bdd7e00cd":"95060000000000000000","0xd74a6e8d6aab34ce85976814c1327bd6ea0784d2":"100000000000000000000000","0x629be7ab126a5398edd6da9f18447e78c692a4fd":"2000000000000000000000","0x2e46fcee6a3bb145b594a243a3913fce5dad6fba":"10000000000000000000000","0xe39b11a8ab1ff5e22e5ae6517214f73c5b9b55dc":"2000000000000000000000","0x119aa64d5b7d181dae9d3cb449955c89c1f963fa":"700000000000000000000","0xce079f51887774d8021cb3b575f58f18e9acf984":"180000000000000000000","0x550c306f81ef5d9580c06cb1ab201b95c748a691":"665800000000000000000","0x06dc7f18cee7edab5b795337b1df6a9e8bd8ae59":"400000000000000000000","0xe21c778ef2a0d7f751ea8c074d1f812243863e4e":"5308559000000000000000","0x45d4b54d37a8cf599821235f062fa9d170ede8a4":"324000000000000000000","0x893a6c2eb8b40ab096b4f67e74a897b840746e86":"1730000000000000000000","0xd44d81e18f46e2cfb5c1fcf5041bc8569767d100":"36381800000000000000000","0xc5de1203d3cc2cea31c82ee2de5916880799eafd":"5000000000000000000000","0x7f0f04fcf37a53a4e24ede6e93104e78be1d3c9e":"2000000000000000000000","0x3ce1dc97fcd7b7c4d3a18a49d6f2a5c1b1a906d7":"200000000000000000000","0xac4ee9d502e7d2d2e99e59d8ca7d5f00c94b4dd6":"1000000000000000000000","0x7640a37f8052981515bce078da93afa4789b5734":"2000000000000000000000","0x76cac488111a4fd595f568ae3a858770fc915d5f":"200000000000000000000","0xff4a408f50e9e72146a28ce4fc8d90271f116e84":"1970000000000000000000","0x249db29dbc19d1235da7298a04081c315742e9ac":"1801800000000000000000","0x3a04572847d31e81f7765ca5bfc9d557159f3683":"133031000000000000000","0xb6771b0bf3427f9ae7a93e7c2e61ee63941fdb08":"18800000000000000000000","0x30c26a8e971baa1855d633ba703f028cc7873140":"10000000000000000000000","0x167e3e3ae2003348459392f7dfce44af7c21ad59":"500000000000000000000","0x43f16f1e75c3c06a9478e8c597a40a3cb0bf04cc":"2914000000000000000000","0x056b1546894f9a85e203fb336db569b16c25e04f":"169397000000000000000","0x70616e2892fa269705b2046b8fe3e72fa55816d3":"20000000000000000000000","0x8f4d1d41693e462cf982fd81d0aa701d3a5374c9":"4000000000000000000000","0xc518799a5925576213e21896e0539abb85b05ae3":"1000000000000000000000","0x0e3a28c1dfafb0505bdce19fe025f506a6d01ceb":"2000000000000000000000","0xe4a47e3933246c3fd62979a1ea19ffdf8c72ef37":"148273000000000000000","0xd231929735132102471ba59007b6644cc0c1de3e":"1000090000000000000000","0x555d8d3ce1798aca902754f164b8be2a02329c6c":"10000000000000000000000","0x5ab1a5615348001c7c775dc75748669b8be4de14":"690200000000000000000","0x2fee36a49ee50ecf716f1047915646779f8ba03f":"1056230000000000000000","0x54db5e06b4815d31cb56a8719ba33af2d73e7252":"670000000000000000000","0x7c8bb65a6fbb49bd413396a9d7e31053bbb37aa9":"6000000000000000000000","0xc1384c6e717ebe4b23014e51f31c9df7e4e25b31":"500000000000000000000","0x474158a1a9dc693c133f65e47b5c3ae2f773a86f":"200200000000000000000","0x2934c0df7bbc172b6c186b0b72547ace8bf75454":"60000000000000000000","0x6966063aa5de1db5c671f3dd699d5abe213ee902":"8000000000000000000000","0x9225d46a5a80943924a39e5b84b96da0ac450581":"40000000000000000000000","0x671bbca099ff899bab07ea1cf86965c3054c8960":"50000000000000000000","0xf1f766b0e46d73fcd4d52e7a72e1b9190cc632b3":"8000000000000000000000","0xef0dc7dd7a53d612728bcbd2b27c19dd4d7d666f":"705668000000000000000","0x38d2e9154964b41c8d50a7487d391e7ee2c3d3c2":"3500000000000000000000","0x352a785f4a921632504ce5d015f83c49aa838d6d":"4314800000000000000000","0x743de50026ca67c94df54f066260e1d14acc11ac":"2000000000000000000000","0xb188078444027e386798a8ae68698919d5cc230d":"267400000000000000000","0x53608105ce4b9e11f86bf497ffca3b78967b5f96":"20000000000000000000000","0x3b159099075207c6807663b1f0f7eda54ac8cce3":"1969543000000000000000","0x141a5e39ee2f680a600fbf6fa297de90f3225cdd":"10000000000000000000000","0x44fff37be01a3888d3b8b8e18880a7ddefeeead3":"259145000000000000000","0xc5a629a3962552cb8eded889636aafbd0c18ce65":"10000000000000000000000","0xfdba5359f7ec3bc770ac49975d844ec9716256f1":"1000000000000000000000","0x7c1df24a4f7fb2c7b472e0bb006cb27dcd164156":"1000000000000000000000","0xab7d54c7c6570efca5b4b8ce70f52a5773e5d53b":"279600000000000000000","0x3f173aa6edf469d185e59bd26ae4236b92b4d8e1":"320000000000000000000","0xa3f4ad14e0bb44e2ce2c14359c75b8e732d37054":"200000000000000000000","0xac5f627231480d0d95302e6d89fc32cb1d4fe7e3":"200000000000000000000","0xd0775dba2af4c30a3a78365939cd71c2f9de95d2":"1940000000000000000000","0xad94235fc3b3f47a2413af31e884914908ef0c45":"500008000000000000000","0xeaedcc6b8b6962d5d9288c156c579d47c0a9fcff":"85000000000000000000","0x7ac48d40c664cc9a6d89f1c5f5c80a1c70e744e6":"3008000000000000000000","0xec73114c5e406fdbbe09b4fa621bd70ed54ea1ef":"24500000000000000000000","0xa690f1a4b20ab7ba34628620de9ca040c43c1963":"4000000000000000000000","0xcad14f9ebba76680eb836b079c7f7baaf481ed6d":"238600000000000000000","0x6c714a58fff6e97d14b8a5e305eb244065688bbd":"4000000000000000000000","0x3e618350fa01657ab0ef3ebac8e37012f8fc2b6f":"2804400000000000000000","0xc946d5acc1346eba0a7279a0ac1d465c996d827e":"16385128000000000000000","0x1164caaa8cc5977afe1fad8a7d6028ce2d57299b":"400000000000000000000","0x7917e5bd82a9790fd650d043cdd930f7799633db":"3999800000000000000000","0xd52aecc6493938a28ca1c367b701c21598b6a02e":"1100000000000000000000","0x98bed3a72eccfbafb923489293e429e703c7e25b":"2000000000000000000000","0x42db0b902559e04087dd5c441bc7611934184b89":"2014420000000000000000","0x43bc2d4ddcd6583be2c7bc094b28fb72e62ba83b":"2000000000000000000000","0x85f0e7c1e3aff805a627a2aaf2cff6b4c0dbe9cb":"20000000000000000000","0x581b9fd6eae372f3501f42eb9619eec820b78a84":"19699015000000000000000","0x541db20a80cf3b17f1621f1b3ff79b882f50def3":"1000000000000000000000","0x4e8a6d63489ccc10a57f885f96eb04ecbb546024":"18500000000000000000000","0x28349f7ef974ea55fe36a1583b34cec3c45065f0":"234490000000000000000","0xa3241d890a92baf52908dc4aa049726be426ebd3":"19999560000000000000000","0xb4b11d109f608fa8edd3fea9f8c315649aeb3d11":"5000000000000000000000","0x5f321b3daaa296cadf29439f9dab062a4bffedd6":"81868000000000000000","0xc5ae86b0c6c7e3900f1368105c56537faf8d743e":"188000000000000000000","0x9a8eca4189ff4aa8ff7ed4b6b7039f0902219b15":"20000000000000000000","0xa3facc50195c0b4933c85897fecc5bbd995c34b8":"20000000000000000000","0xf07bd0e5c2ce69c7c4a724bd26bbfa9d2a17ca03":"5910000000000000000000","0x640aba6de984d94517377803705eaea7095f4a11":"10000000000000000000000","0x204ac98867a7c9c7ed711cb82f28a878caf69b48":"6000000000000000000000","0x9d34dac25bd15828faefaaf28f710753b39e89dc":"1090400000000000000000","0xfe418b421a9c6d373602790475d2303e11a75930":"1015200000000000000000","0x3f472963197883bbda5a9b7dfcb22db11440ad31":"481445000000000000000","0x1578bdbc371b4d243845330556fff2d5ef4dff67":"100000000000000000000","0xdba4796d0ceb4d3a836b84c96f910afc103f5ba0":"166666000000000000000","0x466fda6b9b58c5532750306a10a2a8c768103b07":"199955000000000000000","0x2770f14efb165ddeba79c10bb0af31c31e59334c":"3000000000000000000000","0x7c382c0296612e4e97e440e02d3871273b55f53b":"197600000000000000000","0x1fb7bd310d95f2a6d9baaf8a8a430a9a04453a8b":"3000000000000000000000","0xa9acf600081bb55bb6bfbab1815ffc4e17e85a95":"200000000000000000000","0xf93d5bcb0644b0cce5fcdda343f5168ffab2877d":"209978000000000000000","0xdb0cc78f74d9827bdc8a6473276eb84fdc976212":"2000000000000000000000","0xb66411e3a02dedb726fa79107dc90bc1cae64d48":"2000000000000000000000","0x4d6e8fe109ccd2158e4db114132fe75fecc8be5b":"25019000000000000000","0x6fd947d5a73b175008ae6ee8228163da289b167d":"30000000000000000000000","0x32d950d5e93ea1d5b48db4714f867b0320b31c0f":"1015200000000000000000","0x9c99b62606281b5cefabf36156c8fe62839ef5f3":"4000000000000000000000","0x86c8d0d982b539f48f9830f9891f9d607a942659":"13260000000000000000000","0xf2127d54188fedef0f338a5f38c7ff73ad9f6f42":"20000000000000000000000","0xe864fec07ed1214a65311e11e329de040d04f0fd":"1656353000000000000000","0x1d09ad2412691cc581c1ab36b6f9434cd4f08b54":"7000000000000000000000","0x4ea70f04313fae65c3ff224a055c3d2dab28dddf":"19999800000000000000000","0xe0668fa82c14d6e8d93a53113ef2862fa81581bc":"870400000000000000000","0xf0d858105e1b648101ac3f85a0f8222bf4f81d6a":"600000000000000000000","0x0f3a1023cac04dbf44f5a5fa6a9cf8508cd4fddf":"1820000000000000000000","0x5793abe6f1533311fd51536891783b3f9625ef1c":"827268000000000000000","0x8d667637e29eca05b6bfbef1f96d460eefbf9984":"4000000000000000000000","0xd76dbaebc30d4ef67b03e6e6ecc6d84e004d502d":"2019250000000000000000","0x42d1a6399b3016a8597f8b640927b8afbce4b215":"2980000000000000000000","0x21fd47c5256012198fa5abf131c06d6aa1965f75":"7880000000000000000000","0x2f2bba1b1796821a766fce64b84f28ec68f15aea":"20000000000000000000","0xd24bf12d2ddf457decb17874efde2052b65cbb49":"14000000000000000000000","0x88de13b09931877c910d593165c364c8a1641bd3":"3000000000000000000000","0x555ca9f05cc134ab54ae9bea1c3ff87aa85198ca":"100000000000000000000","0xae9ecd6bdd952ef497c0050ae0ab8a82a91898ce":"30000000000000000000","0xad8bfef8c68a4816b3916f35cb7bfcd7d3040976":"40000000000000000000000","0xdad136b88178b4837a6c780feba226b98569a94c":"200000000000000000000","0x800e7d631c6e573a90332f17f71f5fd19b528cb9":"152000000000000000000","0x94a9a71691317c2064271b51c9353fbded3501a8":"3340000000000000000000","0x80a0f6cc186cf6201400736e065a391f52a9df4a":"10000000000000000000000","0x712ff7370a13ed360973fedc9ff5d2c93a505e9e":"3940000000000000000000","0x42399659aca6a5a863ea2245c933fe9a35b7880e":"2044000000000000000000","0xae239acffd4ebe2e1ba5b4170572dc79cc6533ec":"12000000000000000000000","0x007b9fc31905b4994b04c9e2cfdc5e2770503f42":"1999000000000000000000","0x7480de62254f2ba82b578219c07ba5be430dc3cb":"7040000000000000000000","0x917b8f9f3a8d09e9202c52c29e724196b897d35e":"161000000000000000000","0x708ea707bae4357f1ebea959c3a250acd6aa21b3":"500000000000000000000","0x6dc7053a718616cfc78bee6382ee51add0c70330":"2000000000000000000000","0xc4dac5a8a0264fbc1055391c509cc3ee21a6e04c":"6501000000000000000000","0xc1b2a0fb9cad45cd699192cd27540b88d3384279":"500000000000000000000","0xb07cb9c12405b711807543c4934465f87f98bd2d":"2000000000000000000000","0xc7f72bb758016b374714d4899bce22b4aec70a31":"1072706000000000000000","0x0c480de9f7461002908b49f60fc61e2b62d3140b":"10000000000000000000000","0x83d532d38d6dee3f60adc68b936133c7a2a1b0dd":"500000000000000000000","0x12afbcba1427a6a39e7ba4849f7ab1c4358ac31b":"20000000000000000000000","0xf8f6645e0dee644b3dad81d571ef9baf840021ad":"2000000000000000000000","0x40cf890591eae4a18f812a2954cb295f633327e6":"48132000000000000000","0x735b97f2fc1bd24b12076efaf3d1288073d20c8c":"20000000000000000000","0x47c7e5efb48b3aed4b7c6e824b435f357df4c723":"18200000000000000000","0xd34d708d7398024533a5a2b2309b19d3c55171bb":"400000000000000000000","0x64370e87202645125a35b207af1231fb6072f9a7":"200000000000000000000","0xb055af4cadfcfdb425cf65ba6431078f07ecd5ab":"100000000000000000000","0xc7de5e8eafb5f62b1a0af2195cf793c7894c9268":"1000000000000000000000","0xc63cd7882118b8a91e074d4c8f4ba91851303b9a":"260000000000000000000","0x164d7aac3eecbaeca1ad5191b753f173fe12ec33":"744090000000000000000","0xe4fb26d1ca1eecba3d8298d9d148119ac2bbf580":"400000000000000000000","0x613ac53be565d46536b820715b9b8d3ae68a4b95":"3760000000000000000000","0x7f616c6f008adfa082f34da7d0650460368075fb":"1000000000000000000000","0x9af100cc3dae83a33402051ce4496b16615483f6":"2000000000000000000000","0xb45cca0d36826662683cf7d0b2fdac687f02d0c4":"1000000000000000000000","0x93a6b3ab423010f981a7489d4aad25e2625c5741":"20190033000000000000000","0xee049af005974dd1c7b3a9ca8d9aa77175ba53aa":"333333000000000000000","0x687927e3048bb5162ae7c15cf76bd124f9497b9e":"2000000000000000000000","0x1aa40270d21e5cde86b6316d1ac3c533494b79ed":"20000000000000000000","0x426259b0a756701a8b663528522156c0288f0f24":"9900000000000000000000","0x91c75e3cb4aa89f34619a164e2a47898f5674d9c":"2000000000000000000000","0x437983388ab59a4ffc215f8e8269461029c3f1c1":"20000000000000000000000","0x272a131a5a656a7a3aca35c8bd202222a7592258":"2674000000000000000000","0xbc0ca4f217e052753614d6b019948824d0d8688b":"400000000000000000000","0xcc6c03bd603e09de54e9c4d5ac6d41cbce715724":"98500000000000000000","0xd79aff13ba2da75d46240cac0a2467c656949823":"1730000000000000000000","0x477b24eee8839e4fd19d1250bd0b6645794a61ca":"8000000000000000000000","0x79fd6d48315066c204f9651869c1096c14fc9781":"2000000000000000000000","0x1463a873555bc0397e575c2471cf77fa9db146e0":"10000000000000000000000","0x89ab13ee266d779c35e8bb04cd8a90cc2103a95b":"60000000000000000000000","0x90acced7e48c08c6b934646dfa0adf29dc94074f":"56154000000000000000","0x31ea6eab19d00764e9a95e183f2b1b22fc7dc40f":"20000000000000000000","0x87a53ea39f59a35bada8352521645594a1a714cb":"1910000000000000000000","0x1e1aed85b86c6562cb8fa1eb6f8f3bc9dcae6e79":"4516200000000000000000","0xe36a8ea87f1e99e8a2dc1b2608d166667c9dfa01":"100000000000000000000","0xec2cb8b9378dff31aec3c22e0e6dadff314ab5dd":"2000000000000000000000","0x3cadeb3d3eed3f62311d52553e70df4afce56f23":"4000000000000000000000","0x3ceca96bb1cdc214029cbc5e181d398ab94d3d41":"80000000000000000000000","0x3283eb7f9137dd39bed55ffe6b8dc845f3e1a079":"66224000000000000000","0x0954a8cb5d321fc3351a7523a617d0f58da676a7":"2506000000000000000000","0xde33d708a3b89e909eaf653b30fdc3a5d5ccb4b3":"177300000000000000000","0x1c6702b3b05a5114bdbcaeca25531aeeb34835f4":"26071500000000000000000","0xe5b96fc9ac03d448c1613ac91d15978145dbdfd1":"200000000000000000000","0xfbf204c813f836d83962c7870c7808ca347fd33e":"20000000000000000000","0x3b13631a1b89cb566548899a1d60915cdcc4205b":"2000000000000000000000","0xa87f7abd6fa31194289678efb63cf584ee5e2a61":"4000000000000000000000","0xc0a39308a80e9e84aaaf16ac01e3b01d74bd6b2d":"136499000000000000000","0xffd6da958eecbc016bab91058440d39b41c7be83":"20000000000000000000000","0x0e3dd7d4e429fe3930a6414035f52bdc599d784d":"40110000000000000000","0xe0663e8cd66792a641f56e5003660147880f018e":"2000000000000000000000","0x5b78eca27fbdea6f26befba8972b295e7814364b":"2000000000000000000000","0xec9851bd917270610267d60518b54d3ca2b35b17":"40000000000000000000000","0xbc9c95dfab97a574cea2aa803b5caa197cef0cff":"420000000000000000000","0x100b4d0977fcbad4debd5e64a0497aeae5168fab":"314500000000000000000","0x1b6610fb68bad6ed1cfaa0bbe33a24eb2e96fafb":"152000000000000000000","0xb4524c95a7860e21840296a616244019421c4aba":"8000000000000000000000","0x88975a5f1ef2528c300b83c0c607b8e87dd69315":"83500000000000000000","0x853e6abaf44469c72f151d4e223819aced4e3728":"2000000000000000000000","0xd604abce4330842e3d396ca73ddb5519ed3ec03f":"163940000000000000000","0xd209482bb549abc4777bea6d7f650062c9c57a1c":"320880000000000000000","0x590acbda37290c0d3ec84fc2000d7697f9a4b15d":"500000000000000000000","0x571950ea2c90c1427d939d61b4f2de4cf1cfbfb0":"20000000000000000000","0xcb94e76febe208116733e76e805d48d112ec9fca":"1000000000000000000000","0xfa8e3b1f13433900737daaf1f6299c4887f85b5f":"715000000000000000000","0x162d76c2e6514a3afb6fe3d3cb93a35c5ae783f1":"2000000000000000000000","0x4bea288eea42c4955eb9faad2a9faf4783cbddac":"28790618000000000000000","0xc8ab1a3cf46cb8b064df2e222d39607394203277":"2000000000000000000000","0x318b2ea5f0aaa879c4d5e548ac9d92a0c67487b7":"200000000000000000000","0x53c5fe0119e1e848640cee30adea96940f2a5d8b":"21746000000000000000000","0x0701f9f147ec486856f5e1b71de9f117e99e2105":"173360000000000000000","0x337cfe1157a5c6912010dd561533791769c2b6a6":"1000000000000000000000","0xfd60d2b5af3d35f7aaf0c393052e79c4d823d985":"56400000000000000000","0x0f049a8bdfd761de8ec02cee2829c4005b23c06b":"252000000000000000000","0x924bce7a853c970bb5ec7bb759baeb9c7410857b":"13700000000000000000","0x16abb8b021a710bdc78ea53494b20614ff4eafe8":"158000000000000000000","0x9e7f65a90e8508867bccc914256a1ea574cf07e3":"1240000000000000000000","0x01d03815c61f416b71a2610a2daba59ff6a6de5b":"9553100000000000000000","0x3df762049eda8ac6927d904c7af42f94e5519601":"2000000000000000000000","0x5593c9d4b664730fd93ca60151c25c2eaed93c3b":"200000000000000000000","0xe023f09b2887612c7c9cf1988e3a3a602b3394c9":"2000000000000000000000","0x4c13980c32dcf3920b78a4a7903312907c1b123f":"60024000000000000000","0xa282e969cac9f7a0e1c0cd90f5d0c438ac570da3":"627760000000000000000","0x3b22da2a0271c8efe102532773636a69b1c17e09":"502000000000000000000","0x1aa1021f550af158c747668dd13b463160f95a40":"1470000000000000000000","0xf15178ffc43aa8070ece327e930f809ab1a54f9d":"197600000000000000000","0xdb1293a506e90cad2a59e1b8561f5e66961a6788":"2000000000000000000000","0x88c361640d6b69373b081ce0c433bd590287d5ec":"50000000000000000000000","0x3737216ee91f177732fb58fa4097267207e2cf55":"1520000000000000000000","0xa16d9e3d63986159a800b46837f45e8bb980ee0b":"2030400000000000000000","0xec76f12e57a65504033f2c0bce6fc03bd7fa0ac4":"3580000000000000000000","0xd9f1b26408f0ec67ad1d0d6fe22e8515e1740624":"24000000000000000000","0x716ba01ead2a91270635f95f25bfaf2dd610ca23":"44750000000000000000000","0x42a98bf16027ce589c4ed2c95831e2724205064e":"10000000000000000000000","0x0f88aac9346cb0e7347fba70905475ba8b3e5ece":"10000000000000000000000","0x2d8c52329f38d2a2fa9cbaf5c583daf1490bb11c":"20000000000000000000","0x3cea302a472a940379dd398a24eafdbadf88ad79":"3000000000000000000000","0xa29d5bda74e003474872bd5894b88533ff64c2b5":"10000000000000000000000","0x2d23766b6f6b05737dad80a419c40eda4d77103e":"3820000000000000000000","0xb07249e055044a9155359a402937bbd954fe48b6":"100000000000000000000","0xf1e980c559a1a8e5e50a47f8fffdc773b7e06a54":"30104784000000000000000","0x8275cd684c3679d5887d03664e338345dc3cdde1":"15800000000000000000","0xb27c1a24204c1e118d75149dd109311e07c073ab":"3100000000000000000000","0x451b3699475bed5d7905f8905aa3456f1ed788fc":"2560000000000000000000","0x31ad4d9946ef09d8e988d946b1227f9141901736":"22880000000000000000000","0x52b8a9592634f7300b7c5c59a3345b835f01b95c":"2000000000000000000000","0xb161725fdcedd17952d57b23ef285b7e4b1169e8":"50071000000000000000","0x74fc5a99c0c5460503a13b0509459da19ce7cd90":"200000000000000000000","0xd99df7421b9382e42c89b006c7f087702a0757c0":"480000000000000000000","0x8a4f4a7f52a355ba105fca2072d3065fc8f7944b":"500000000000000000000","0x12316fc7f178eac22eb2b25aedeadf3d75d00177":"19999999000000000000000","0xf598db2e09a8a5ee7d720d2b5c43bb126d11ecc2":"200000000000000000000","0x37b8beac7b1ca38829d61ab552c766f48a10c32f":"400000000000000000000","0x851dc38adb4593729a76f33a8616dab6f5f59a77":"100000000000000000000","0xbf4096bc547dbfc4e74809a31c039e7b389d5e17":"3940000000000000000000","0x98d3731992d1d40e1211c7f735f2189afa0702e0":"8000000000000000000000","0x0f4073c1b99df60a1549d69789c7318d9403a814":"20000000000000000000000","0xa430995ddb185b9865dbe62539ad90d22e4b73c2":"10000000000000000000000","0x898c72dd736558ef9e4be9fdc34fef54d7fc7e08":"1000000000000000000000","0xf9b617f752edecae3e909fbb911d2f8192f84209":"2674000000000000000000","0xe1ae029b17e373cde3de5a9152201a14cac4e119":"99968000000000000000","0xd8e8474292e7a051604ca164c0707783bb2885e8":"13370000000000000000000","0xf476f2cb7208a32e051fd94ea8662992638287a2":"100000000000000000000","0x3a84e950ed410e51b7e8801049ab2634b285fea1":"18690000000000000000000","0x5b7784caea01799ca30227827667ce207c5cbc76":"2000000000000000000000","0x3af65b3e28895a4a001153391d1e69c31fb9db39":"3940000000000000000000","0x95fb5afb14c1ef9ab7d179c5c300503fd66a5ee2":"34225000000000000000","0xa8446c4781a737ac4328b1e15b8a0b3fbb0fd668":"21390500000000000000000","0x4888fb25cd50dbb9e048f41ca47d78b78a27c7d9":"17300000000000000000000","0x566c10d638e8b88b47d6e6a414497afdd00600d4":"99960000000000000000","0xbd47f5f76e3b930fd9485209efa0d4763da07568":"1000000000000000000000","0x1e1c6351776ac31091397ecf16002d979a1b2d51":"1400000000000000000000","0xedf603890228d7d5de9309942b5cad4219ef9ad7":"5000000000000000000000","0x1923cfc68b13ea7e2055803645c1e320156bd88d":"1337000000000000000000","0x8f8f37d0ad8f335d2a7101b41156b688a81a9cbe":"70000000000000000000","0x63334fcf1745840e4b094a3bb40bb76f9604c04c":"3978000000000000000000","0x001762430ea9c3a26e5749afdb70da5f78ddbb8c":"200000000000000000000","0x512116817ba9aaf843d1507c65a5ea640a7b9eec":"50000000000000000000","0x2961fb391c61957cb5c9e407dda29338d3b92c80":"999942000000000000000","0xfc2952b4c49fedd0bc0528a308495e6d6a1c71d6":"2000000000000000000000","0x13ec812284026e409bc066dfebf9d5a4a2bf801e":"1610000000000000000000","0xef463c2679fb279164e20c3d2691358773a0ad95":"2000000000000000000000","0x3aadf98b61e5c896e7d100a3391d3250225d61df":"234000000000000000000","0xe8137fc1b2ec7cc7103af921899b4a39e1d959a1":"1490000000000000000000","0xb1a2b43a7433dd150bb82227ed519cd6b142d382":"2738000000000000000000","0xc1f39bd35dd9cec337b96f47c677818160df37b7":"20000000000000000000","0xb587b44a2ca79e4bc1dd8bfdd43a207150f2e7e0":"630400000000000000000","0x41485612d03446ec4c05e5244e563f1cbae0f197":"970000000000000000000","0xa12623e629df93096704b16084be2cd89d562da4":"8500000000000000000000","0x3f2f381491797cc5c0d48296c14fd0cd00cdfa2d":"804000000000000000000","0x9470cc36594586821821c5c996b6edc83b6d5a32":"24000000000000000000","0x3605372d93a9010988018f9f315d032ed1880fa1":"500066000000000000000","0x12632388b2765ee4452b50161d1fffd91ab81f4a":"740000000000000000000","0x274a3d771a3d709796fbc4d5f48fce2fe38c79d6":"20000000000000000000","0xd60a52580728520df7546bc1e283291788dbae0c":"999910000000000000000","0x1ab53a11bcc63ddfaa40a02b9e186496cdbb8aff":"1996800000000000000000","0xc282e6993fbe7a912ea047153ffd9274270e285b":"139939000000000000000","0xa291e9c7990d552dd1ae16cebc3fca342cbaf1d1":"20000000000000000000000","0x5547fdb4ae11953e01292b7807fa9223d0e4606a":"98940000000000000000","0xbded11612fb5c6da99d1e30e320bc0995466141e":"400000000000000000000","0xb73b4ff99eb88fd89b0b6d57a9bc338e886fa06a":"32000000000000000000","0xb1c751786939bba0d671a677a158c6abe7265e46":"10000000000000000000000","0xe881bbbe69722d81efecaa48d1952a10a2bfac8f":"16000000000000000000000","0xfe96c4cd381562401aa32a86e65b9d52fa8aee27":"2640000000000000000000","0x683dba36f7e94f40ea6aea0d79b8f521de55076e":"140000000000000000000","0x5ac2908b0f398c0df5bac2cb13ca7314fba8fa3d":"199800000000000000000","0x8914a680a5aec5226d4baaec2e5552b44dd7c874":"100076000000000000000","0x041170f581de80e58b2a045c8f7c1493b001b7cb":"889800000000000000000","0x4665e47396c7db97eb2a03d90863d5d4ba319a94":"600000000000000000000","0xed4be04a052d7accb3dcce90319dba4020ab2c68":"37547947000000000000000","0x4b0619d9d8aa313a9531ac7dbe04ca0d6a5ad1b6":"2000000000000000000000","0xa21442ab05340ade68c915f3c3399b9955f3f7eb":"775000000000000000000","0x655934da8e744eaa3de34dbbc0894c4eda0b61f2":"200000000000000000000","0x6038740ae28d66ba93b0be08482b3205a0f7a07b":"316000000000000000000","0x99924a9816bb7ddf3fec1844828e9ad7d06bf4e6":"1760000000000000000000","0x6847825bdee8240e28042c83cad642f286a3bddc":"1500000000000000000000","0xa718aaad59bf395cba2b23e09b02fe0c89816247":"999600000000000000000","0x2c89f5fdca3d155409b638b98a742e55eb4652b7":"98500000000000000000000","0x1a7044e2383f8708305b495bd1176b92e7ef043a":"200000000000000000000","0x282e80a554875a56799fa0a97f5510e795974c4e":"1000000000000000000000","0xffb3bcc3196a8c3cb834cec94c34fed35b3e1054":"1340000000000000000000","0xd135794b149a18e147d16e621a6931f0a40a969a":"20000000000000000000000","0x6b94615db750656ac38c7e1cf29a9d13677f4e15":"12000000000000000000000","0xecbe425e670d39094e20fb5643a9d818eed236de":"5000000000000000000000","0x511e0efb04ac4e3ff2e6550e498295bfcd56ffd5":"668500000000000000000","0xff65511cada259260c1ddc41974ecaecd32d6357":"1760000000000000000000","0x9ffc5fe06f33f5a480b75aa94eb8556d997a16c0":"20000000000000000000","0x57df23bebdc65eb75feb9cb2fad1c073692b2baf":"4000000000000000000000","0x207ef80b5d60b6fbffc51f3a64b8c72036a5abbd":"6685000000000000000000","0xc573e841fa08174a208b060ccb7b4c0d7697127f":"668500000000000000000","0x411610b178d5617dfab934d293f512a93e5c10e1":"170000000000000000000","0x9991614c5baa47dd6c96874645f97add2c3d8380":"1970000000000000000000","0x2d3480bf0865074a72c7759ee5137b4d70c51ce9":"200000000000000000000","0x9d40e012f60425a340d82d03a1c757bfabc706fb":"169799000000000000000","0x47648bed01f3cd3249084e635d14daa9e7ec3c8a":"194000000000000000000","0xa5ff62222d80c013cec1a0e8850ed4d354dac16d":"207600000000000000000","0xf80d3619702fa5838c48391859a839fb9ce7160f":"1992800000000000000000","0x7c0f5e072043c9ee740242197e78cc4b98cdf960":"200000000000000000000","0xa40aa2bbce0c72b4d0dfffcc42715b2b54b01bfa":"1000000000000000000000","0x2eeed50471a1a2bf53ee30b1232e6e9d80ef866d":"20000000000000000000","0x0c2808b951ed9e872d7b32790fcc5994ae41ffdc":"102000000000000000000000","0x7f06c89d59807fa60bc60136fcf814cbaf2543bd":"10000000000000000000000","0x8d4b603c5dd4570c34669515fdcc665890840c77":"18200000000000000000","0xd5e5c135d0c4c3303934711993d0d16ff9e7baa0":"2000000000000000000000","0x241361559feef80ef137302153bd9ed2f25db3ef":"20000000000000000000000","0xdb63122de7037da4971531fae9af85867886c692":"277000000000000000000","0x417e4e2688b1fd66d821529e46ed4f42f8b3db3d":"2000000000000000000000","0x127db1cadf1b771cbd7475e1b272690f558c8565":"14000000000000000000000","0x48659d8f8c9a2fd44f68daa55d23a608fbe500dc":"2000000000000000000000","0xb3a64b1176724f5409e1414a3523661baee74b4a":"25610000000000000000","0xaa14422d6f0ae5a758194ed15780c838d67f1ee1":"28503824000000000000000","0xa0a0e65204541fca9b2fb282cd95138fae16f809":"10000000000000000000000","0xd2107b353726c3a2b46566eaa7d9f80b5d21dbe3":"20000000000000000000","0xe4cafb727fb5c6b70bb27533b8a9ccc9ef6888e1":"300443000000000000000","0x09f3f601f605441140586ce0656fa24aa5b1d9ae":"1539400000000000000000","0x87fcbe7c4193ffcb08143779c9bec83fe7fda9fc":"100275000000000000000","0x03ebc63fda6660a465045e235fbe6e5cf195735f":"141840000000000000000","0xbdbaf6434d40d6355b1e80e40cc4ab9c68d96116":"100000000000000000000","0x4e2225a1bb59bc88a2316674d333b9b0afca6655":"155000000000000000000","0x4dc3da13b2b4afd44f5d0d3189f444d4ddf91b1b":"2000000000000000000000","0x4ba8e0117fc0b6a3e56b24a3a58fe6cef442ff98":"5640000000000000000000","0x27146913563aa745e2588430d9348e86ea7c3510":"400000000000000000000","0x4c5afe40f18ffc48d3a1aec41fc29de179f4d297":"2000000000000000000000","0x8a810114b2025db9fbb50099a6e0cb9e2efa6bdc":"1910000000000000000000","0x2dee90a28f192d676a8773232b56f18f239e2fad":"18587970000000000000000","0x60676e92d18b000509c61de540e6c5ddb676d509":"1200000000000000000000","0x9bfc659c9c601ea42a6b21b8f17084ec87d70212":"10000000000000000000000","0x5d5d6e821c6eef96810c83c491468560ef70bfb5":"2000000000000000000000","0xd5787668c2c5175b01a8ee1ac3ecc9c8b2aba95a":"1999944000000000000000","0x33b336f5ba5edb7b1ccc7eb1a0d984c1231d0edc":"2000000000000000000000","0x3abb8adfc604f48d5984811d7f1d52fef6758270":"4475000000000000000000","0x980a84b686fc31bdc83c221058546a71b11f838a":"779471000000000000000","0x0b507cf553568daaf65504ae4eaa17a8ea3cdbf5":"2000000000000000000000","0x896009526a2c7b0c09a6f63a80bdf29d9c87de9c":"3462830000000000000000","0x9696052138338c722f1140815cf7749d0d3b3a74":"500000000000000000000","0x3831757eae7557cb8a37a4b10644b63e4d3b3c75":"200000000000000000000","0x62dc72729024375fc37cbb9c7c2393d10233330f":"2000000000000000000000","0x44098866a69b68c0b6bc168229b9603587058967":"188000000000000000000","0x25adb8f96f39492c9bb47c5edc88624e46075697":"26740000000000000000000","0xfd4de8e3748a289cf7d060517d9d38388db01fb8":"250000000000000000000","0x6be7595ea0f068489a2701ec4649158ddc43e178":"2000000000000000000000","0xd402b4f6a099ebe716cb14df4f79c0cd01c6071b":"2000000000000000000000","0xa07682000b1bcf3002f85c80c0fa2949bd1e82fd":"4000000000000000000000","0xeb4f00e28336ea09942588eeac921811c522143c":"2000000000000000000000","0x8f31c7005197ec997a87e69bec48649ab94bb2a5":"4000000000000000000000","0xe7fd8fd959aed2767ea7fa960ce1db53af802573":"1000000000000000000000","0xa8ef9ad274436042903e413c3b0c62f5f52ed584":"10000000000000000000000","0xd83ad260e9a6f432fb6ea28743299b4a09ad658c":"2000000000000000000000","0xb5c816a8283ca4df68a1a73d63bd80260488df08":"200000000000000000000","0xd7d3c75920590438b82c3e9515be2eb6ed7a8b1a":"60000000000000000000000","0xaf3cb5965933e7dad883693b9c3e15beb68a4873":"2000000000000000000000","0x6e899e59a9b41ab7ea41df7517860f2acb59f4fd":"20000000000000000000000","0x527a8ca1268633a6c939c5de1b929aee92aeac8d":"900000000000000000000","0x1680cec5021ee93050f8ae127251839e74c1f1fd":"13098657000000000000000","0xff7843c7010aa7e61519b762dfe49124a76b0e4e":"933580000000000000000000","0x140fba58dbc04803d84c2130f01978f9e0c73129":"400000000000000000000","0x0261ad3a172abf1315f0ffec3270986a8409cb25":"203500000000000000000","0xab5a79016176320973e8cd38f6375530022531c0":"1000000000000000000000","0xfca73eff8771c0103ba3cc1a9c259448c72abf0b":"1000000000000000000000","0x07d41217badca5e0e60327d845a3464f0f27f84a":"4000000000000000000000","0x2c1c19114e3d6de27851484b8d2715e50f8a1065":"100000000000000000000","0xabd21eff954fc6a7de26912a7cbb303a6607804e":"1517000000000000000000","0xf303d5a816affd97e83d9e4dac2f79072bb0098f":"960000000000000000000","0x114cfefe50170dd97ae08f0a44544978c599548d":"863000000000000000000","0x647b85044df2cf0b4ed4882e88819fe22ae5f793":"1000032000000000000000","0x1b130d6fa51d5c48ec8d1d52dc8a227be8735c8a":"2000000000000000000000","0x0d9d3f9bc4a4c6efbd59679b69826bc1f63d9916":"600000000000000000000","0xc765e00476810947816af142d46d2ee7bca8cc4f":"500000000000000000000","0xb57b04fa23d1203fae061eac4542cb60f3a57637":"191000000000000000000","0xe192489b85a982c1883246d915b229cb13207f38":"5000000000000000000000","0x5f483ffb8f680aedf2a38f7833afdcde59b61e4b":"2000000000000000000000","0xb46d1182e5aacaff0d26b2fcf72f3c9ffbcdd97d":"3139000000000000000000","0x59c7f785c93160e5807ed34e5e534bc6188647a7":"640000000000000000000","0x18e4ce47483b53040adbab35172c01ef64506e0c":"9000000000000000000000","0x296d66b521571a4e4103a7f562c511e6aa732d81":"668500000000000000000","0xbcd99edc2160f210a05e3a1fa0b0434ced00439b":"2000000000000000000000","0xf14f0eb86db0eb68753f16918e5d4b807437bd3e":"200000000000000000000","0x60d5667140d12614b21c8e5e8a33082e32dfcf23":"20000000000000000000000","0x8ccabf25077f3aa41545344d53be1b2b9c339000":"1695400000000000000000","0x8cc0d7c016fa7aa950114aa1db094882eda274ea":"159800000000000000000","0xc71145e529c7a714e67903ee6206e4c3042b6727":"1430000000000000000000","0xc5e9939334f1252ed2ba26814487dfd2982b3128":"70000000000000000000","0xf09b3e87f913ddfd57ae8049c731dba9b636dfc3":"608000000000000000000","0x4349225a62f70aea480a029915a01e5379e64fa5":"2598000000000000000000","0x666b4f37d55d63b7d056b615bb74c96b3b01991a":"4000000000000000000000","0x8bd6b1c6d74d010d1008dba6ef835d4430b35c32":"50000000000000000000","0x7363cd90fbab5bb8c49ac20fc62c398fe6fb744c":"2000000000000000000000","0xb7479dab5022c4d5dbaaf8de171b4e951dd1a457":"80000000000000000000","0x5a5468fa5ca226c7532ecf06e1bc1c45225d7ec9":"1910000000000000000000","0x32a20d028e2c6218b9d95b445c771524636a22ef":"9500000000000000000000","0x1bd28cd5c78aee51357c95c1ef9235e7c18bc854":"2000000000000000000000","0x693492a5c51396a482881669ccf6d8d779f00951":"345827000000000000000","0xbd723b289a7367b6ece2455ed61edb49670ab9c4":"4999995000000000000000","0x1be3542c3613687465f15a70aeeb81662b65cca8":"2000000000000000000000","0x5803e68b34da121aef08b602badbafb4d12481ca":"18000000000000000000000","0x9ac907ee85e6f3e223459992e256a43fa08fa8b2":"10000000000000000000000","0x833b6a8ec8da408186ac8a7d2a6dd61523e7ce84":"16000000000000000000000","0x64628c6fb8ec743adbd87ce5e018d531d9210437":"26740000000000000000","0x566c28e34c3808d9766fe8421ebf4f2b1c4f7d77":"1970000000000000000000","0x171ad9a04bedc8b861e8ed4bddf5717813b1bb48":"400000000000000000000","0x4f85bc1fc5cbc9c001e8f1372e07505370d8c71f":"940000000000000000000","0x6d2f976734b9d0070d1883cf7acab8b3e4920fc1":"10000000000000000000000","0x357a02c0a9dfe287de447fb67a70ec5b62366647":"26740000000000000000","0x44a01fb04ac0db2cce5dbe281e1c46e28b39d878":"1999944000000000000000","0x3630c5e565ceaa8a0f0ffe32875eae2a6ce63c19":"170016000000000000000","0x334340ee4b9cdc81f850a75116d50ee9b69825bf":"2000000000000000000000","0xc0afb7d8b79370cfd663c68cc6b9702a37cd9eff":"1000000000000000000000","0x2016895df32c8ed5478269468423aea7b7fbce50":"20000000000000000000","0x1e2fe4e4a77d141ff49a0c7fbc95b0a2b283eeeb":"2000000000000000000000","0x260df8943a8c9a5dba7945327fd7e0837c11ad07":"200000000000000000000","0x32fbeed6f626fcdfd51acafb730b9eeff612f564":"2000000000000000000000","0x9bd88068e13075f3a8cac464a5f949d6d818c0f6":"6000000000000000000000","0xab4572fbb1d72b575d69ec6ad17333873e8552fc":"1999942000000000000000","0xe44ea51063405154aae736be2bf1ee3b9be639ae":"4000000000000000000000","0x617f20894fa70e94a86a49cd74e03238f64d3cd9":"5000057000000000000000","0x3e914e3018ac00449341c49da71d04dfeeed6221":"4000000000000000000000","0x590181d445007bd0875aaf061c8d51153900836a":"2000000000000000000000","0x27987110221a880826adb2e7ab5eca78c6e31aec":"4000000000000000000000","0x06618e9d5762df62028601a81d4487d6a0ecb80e":"1337000000000000000000","0x8cc652dd13e7fe14dabbb36d5d320db9ffee8a54":"1790000000000000000000","0x8973aefd5efaee96095d9e288f6a046c97374b43":"141000000000000000000","0xdbd51cdf2c3bfacdff106221de2e19ad6d420414":"1760000000000000000000","0x25697ef20cccaa70d32d376f8272d9c1070c3d78":"200000000000000000000","0x0726c42e00f45404836eb1e280d073e7059687f5":"1623331000000000000000","0x5e0785532c7723e4c0af9357d5274b73bdddddde":"25000088000000000000000","0x38430e931d93be01b4c3ef0dc535f1e0a9610063":"10000000000000000000000","0x143d536b8b1cb84f56a39e0bc81fd5442bcacce1":"100000000000000000000","0x5c6d041da7af4487b9dc48e8e1f60766d0a56dbc":"1457800000000000000000","0xf9bfb59d538afc4874d4f5941b08c9730e38e24b":"40000000000000000000","0x83dbfd8eda01d0de8e158b16d0935fc2380a5dc7":"600000000000000000000","0x0e6cd664ad9c1ed64bf98749f40644b626e3792c":"60000000000000000000000","0xce2e0da8934699bb1a553e55a0b85c169435bea3":"4999962000000000000000","0xa39bfee4aec9bd75bd22c6b672898ca9a1e95d32":"10000000000000000000000","0x1bc44c8761231ba1f11f5faa40fa669a013e12ce":"203586000000000000000","0x68809af5d532a11c1a4d6e32aac75c4c52b08ead":"10000000000000000000000","0x80cc21bd99f39005c58fe4a448909220218f66cb":"1000072000000000000000","0x1080c1d8358a15bc84dac8253c6883319020df2c":"2674000000000000000000","0x9eaf6a328a4076024efa6b67b48b21eedcc0f0b8":"158000000000000000000","0x1e7b5e4d1f572becf2c00fc90cb4767b4a6e33d4":"112970000000000000000","0xacbd185589f7a68a67aa4b1bd65077f8c64e4e21":"200000000000000000000","0xff78541756ab2b706e0d70b18adb700fc4f1643d":"43250000000000000000000","0x7f0ec3db804692d4d1ea3245365aab0590075bc4":"4000000000000000000000","0x4a918032439159bb315b6725b6830dc83697739f":"343800000000000000000","0xbc1b021a78fde42d9b5226d6ec26e06aa3670090":"80000000000000000000","0x2f2523cc834f0086052402626296675186a8e582":"16000000000000000000000","0x9db2e15ca681f4c66048f6f9b7941ed08b1ff506":"4000000000000000000000","0x20b9a9e6bd8880d9994ae00dd0b9282a0beab816":"500000000000000000000","0x3bddbc8134f77d55597fc97c26d26698090604eb":"13700000000000000000","0x80c3a9f695b16db1597286d1b3a8b7696c39fa27":"100000000000000000000","0x53194d8afa3e883502767edbc30586af33b114d3":"2000000000000000000000","0xe2efd0a9bc407ece03d67e8ec8e9d283f48d2a49":"12280000000000000000000","0x1cb450920078aab2317c7db3b38af7dd298b2d41":"340000000000000000000","0xca8276c477b4a07b80107b843594189607b53bec":"6000000000000000000000","0x147f4210ab5804940a0b7db8c14c28396b62a6bf":"2000000000000000000000","0xd3df3b53cb3b4755de54e180451cc44c9e8ae0aa":"659801000000000000000","0xf7c708015071d4fb0a3a2a09a45d156396e3349e":"3000000000000000000000","0xa8cafac32280d021020bf6f2a9782883d7aabe12":"100000000000000000000","0x399aa6f5d078cb0970882bc9992006f8fbdf3471":"1000000000000000000000","0x15669180dee29598869b08a721c7d24c4c0ee63f":"1000000000000000000000","0xbba8ab22d2fedbcfc63f684c08afdf1c175090b5":"99091000000000000000","0x5e5a441974a83d74c687ebdc633fb1a49e7b1ad7":"3000000000000000000000","0x98b769cc305cecfb629a00c907069d7ef9bc3a12":"26000000000000000000","0xc820c711f07705273807aaaa6de44d0e4b48be2e":"155000000000000000000","0x12aa7d86ddfbad301692feac8a08f841cb215c37":"137000000000000000000","0x6ff5d361b52ad0b68b1588607ec304ae5665fc98":"1940000000000000000000","0x2382a9d48ec83ea3652890fd0ee79c907b5b2dc1":"133700000000000000000","0xb2a144b1ea67b9510f2267f9da39d3f93de26642":"2000000000000000000000","0xb3e20eb4de18bd060221689894bee5aeb25351ee":"73535000000000000000","0x101a0a64f9afcc448a8a130d4dfcbee89537d854":"15200000000000000000000","0x1b826fb3c012b0d159e294ba5b8a499ff3c0e03c":"2000000000000000000000","0xaafb7b013aa1f8541c7e327bf650adbd194c208f":"1358000000000000000000","0x96eb523e832f500a017de13ec27f5d366c560eff":"307600000000000000000","0xc7bf17c4c11f98941f507e77084fffbd2dbd3db5":"1000000000000000000000","0x840ec83ea93621f034e7bb3762bb8e29ded4c479":"2500000000000000000000","0x0e9c511864a177f49be78202773f60489fe04e52":"6000000000000000000000","0xf6f1a44309051c6b25e47dff909b179bb9ab591c":"1940000000000000000000","0x63fe6bcc4b8a9850abbe75803730c932251f145b":"18200000000000000000","0xf88b58db37420b464c0be88b45ee2b95290f8cfa":"40000000000000000000","0x9d4d321177256ebd9afbda304135d517c3dc5693":"616000000000000000000","0x8c1fbe5f0aea359c5aa1fa08c8895412ca8e05a6":"1000000000000000000000","0xcb0dd7cf4e5d8661f6028943a4b9b75c914436a7":"120000000000000000000000","0xa3979a92760a135adf69d72f75e167755f1cb8c3":"100000000000000000000","0xca22cda3606da5cad013b8074706d7e9e721a50c":"6816200000000000000000","0x157559adc55764cc6df79323092534e3d6645a66":"6000000000000000000000","0x4f52ad6170d25b2a2e850eadbb52413ff2303e7f":"3040000000000000000000","0xeed28c3f068e094a304b853c950a6809ebcb03e0":"17300000000000000000000","0x2e47f287f498233713850d3126823cc67dcee255":"14600000000000000000","0x6c359e58a13d4578a9338e335c67e7639f5fb4d7":"218000000000000000000","0x4968a2cedb457555a139295aea28776e54003c87":"10092310000000000000000","0x4041374b0feef4792e4b33691fb86897a4ff560c":"365000000000000000000","0x83e48055327c28b5936fd9f4447e73bdb2dd3376":"2674000000000000000000","0x32b7feebc5c59bf65e861c4c0be42a7611a5541a":"2212000000000000000000","0x21a6db6527467bc6dad54bc16e9fe2953b6794ed":"14000000000000000000000","0xe8ead1bb90ccc3aea2b0dcc5b58056554655d1d5":"7760000000000000000000","0x7a94b19992ceb8ce63bc92ee4b5aded10c4d9725":"16770000000000000000000","0x90e93e4dc17121487952333614002be42356498e":"1910000000000000000000","0xaab00abf5828d7ebf26b47ceaccdb8ba03325166":"10000000000000000000000","0x0a9ab2638b1cfd654d25dab018a0aebddf85fd55":"21801000000000000000","0xb12ed07b8a38ad5506363fc07a0b6d799936bdaf":"10000000000000000000000","0xf4a9d00cefa97b7a58ef9417fc6267a5069039ee":"21800000000000000000","0x04a1cada1cc751082ff8da928e3cfa000820a9e9":"40000000000000000000","0x9018cc1f48d2308e252ab6089fb99a7c1d569410":"200000000000000000000","0x895d694e880b13ccd0848a86c5ce411f88476bbf":"199955000000000000000","0x40a7f72867a7dc86770b162b7557a434ed50cce9":"1000000000000000000000","0x467ea10445827ef1e502daf76b928a209e0d4032":"2000000000000000000000","0x7553aa23b68aa5f57e135fe39fdc235eaca8c98c":"1000000000000000000000","0x31b43b015d0081643c6cda46a7073a6dfdbca825":"50019600000000000000000","0xd82fd9fdf6996bedad2843159c06f37e0924337d":"1688800000000000000000","0x24a4eb36a7e498c36f99975c1a8d729fd6b305d7":"258000000000000000000","0x91d66ea6288faa4b3d606c2aa45c7b6b8a252739":"2000000000000000000000","0x83a402438e0519773d5448326bfb61f8b20cf52d":"1520000000000000000000","0xc2fafdd30acb6d6706e9293cb02641f9edbe07b5":"1494224000000000000000","0x79dba256472db4e058f2e4cdc3ea4e8a42773833":"1460000000000000000000","0x498abdeb14c26b7b7234d70fceaef361a76dff72":"3000000000000000000000","0x7b73242d75ca9ad558d650290df17692d54cd8b8":"2000200000000000000000","0x6ec3659571b11f889dd439bcd4d67510a25be57e":"123000000000000000000","0xab098633eeee0ccefdf632f9575456f6dd80fc86":"200000000000000000000000","0xf4a51fce4a1d5b94b0718389ba4e7814139ca738":"300000000000000000000","0x8f561b41b209f248c8a99f858788376250609cf3":"1700000000000000000000","0x05d0f4d728ebe82e84bf597515ad41b60bf28b39":"4200000000000000000000","0xdfdf43393c649caebe1bb18059decb39f09fb4e8":"400000000000000000000","0x0089508679abf8c71bf6781687120e3e6a84584d":"1800000000000000000000","0x80907f593148b57c46c177e23d25abc4aae18361":"100000000000000000000","0x94fcceadfe5c109c5eaeaf462d43873142c88e22":"4800000000000000000000","0xe89249738b7eced7cb666a663c49cbf6de8343ea":"2000000000000000000000","0x23c99ba087448e19c9701df66e0cab52368331fa":"2000000000000000000000","0xa68e0c30cba3bc5a883e540320f999c7cd558e5c":"1799869000000000000000","0x88888a57bd9687cbf950aeeacf9740dcc4d1ef59":"1820000000000000000000","0xe9b36fe9b51412ddca1a521d6e94bc901213dda8":"10000000000000000000000","0xa9145046fa3628cf5fd4c613927be531e6db1fdd":"112000000000000000000","0xe82c58c579431b673546b53a86459acaf1de9b93":"1000000000000000000000","0xbd6a474d66345bcdd707594adb63b30c7822af54":"4000000000000000000000","0x6a6159074ab573e0ee581f0f3df2d6a594629b74":"310000000000000000000","0x2e7f465520ec35cc23d68e75651bb6689544a196":"1050049000000000000000","0xac6d02e9a46b379fac4ac9b1d7b5d47bc850ce16":"1760000000000000000000","0xbd59094e074f8d79142ab1489f148e32151f2089":"20000000000000000000","0x0ba6e46af25a13f57169255a34a4dac7ce12be04":"500000000000000000000","0x35145f620397c69cb8e00962961f0f4886643989":"6000000000000000000000","0xd84b922f7841fc5774f00e14604ae0df42c8551e":"4011000000000000000000","0x44232ff66ddad1fd841266380036afd7cf7d7f42":"200000000000000000000","0x516954025fca2608f47da81c215eedfd844a09ff":"382000000000000000000","0xe5aa0b833bb916dc19a8dd683f0ede241d988eba":"3000000000000000000000","0x80ea1acc136eca4b68c842a95adf6b7fee7eb8a2":"4000000000000000000000","0x98a0e54c6d9dc8be96276cebf4fec460f6235d85":"1969803000000000000000","0x91620f3eb304e813d28b0297556d65dc4e5de5aa":"3820000000000000000000","0x7bb984c6dbb9e279966afafda59c01d02627c804":"8050000000000000000000","0x41f489a1ec747bc29c3e5f9d8db97877d4d1b4e9":"133700000000000000000","0x8dbc3e6cb433e194f40f82b40faadb1f8b856116":"1910000000000000000000","0x889da40fb1b60f9ea9bd7a453e584cf7b1b4d9f7":"40000000000000000000","0xdebbdd831e0f20ae6e378252decdf92f7cf0c658":"2000000000000000000000","0xa22ade0ddb5c6ef8d0cd8de94d82b11082cb2e91":"1020000000000000000000","0x823219a25976bb2aa4af8bad41ac3526b493361f":"2000000000000000000000","0x6d39a9e98f81f769d73aad2cead276ac1387babe":"394000000000000000000","0x751abcb6cc033059911815c96fd191360ab0442d":"8000000000000000000000","0x64d80c3b8ba68282290b75e65d8978a15a87782c":"1970000000000000000000","0x6ba8f7e25fc2d871618e24e40184199137f9f6aa":"400020000000000000000","0x25a74c2ac75dc8baa8b31a9c7cb4b7829b2456da":"2000000000000000000000","0x0f7b61c59b016322e8226cafaee9d9e76d50a1b3":"4000000000000000000000","0x7526e482529f0a14eec98871dddd0e721b0cd9a2":"20000000000000000000","0x071dd90d14d41f4ff7c413c24238d3359cd61a07":"36400000000000000000000","0xa986762f7a4f294f2e0b173279ad2c81a2223458":"20000000000000000000","0xe667f652f957c28c0e66d0b63417c80c8c9db878":"601650000000000000000","0x7b98e23cb96beee80a168069ebba8f20edd55ccf":"214500000000000000000","0x2d8e5bb8d3521695c77e7c834e0291bfacee7408":"1970000000000000000000","0xf23d01589eb12d439f7448ff54307529f191858d":"2000000000000000000000","0xabd9605b3e91acfd777830d16463478ae0fc7720":"133700000000000000000","0xeabb90d37989aab31feae547e0e6f3999ce6a35d":"2000000000000000000000","0x0abfb39b11486d79572866195ba26c630b6784db":"121500000000000000000000","0xd56a144d7af0ae8df649abae535a15983aa04d02":"5000000000000000000000","0x998c1f93bcdb6ff23c10d0dc924728b73be2ff9f":"1002750000000000000000","0xbc62b3096a91e7dc11a1592a293dd2542150d751":"1000000000000000000000","0x0c8f66c6017bce5b20347204b602b743bad78d60":"2000000000000000000000","0x4c5b3dc0e2b9360f91289b1fe13ce12c0fbda3e1":"2000000000000000000000","0xb44605552471a6eee4daab71ff3bb41326d473e0":"839200000000000000000","0xfc3d226bb36a58f526568857b0bb12d109ec9301":"2000000000000000000000","0xadc8228ef928e18b2a807d00fb3c6c79cd1d9e96":"22800000000000000000","0x9df32a501c0b781c0281022f42a1293ffd7b892a":"9000000000000000000000","0xe7da609d40cde80f00ce5b4ffb6aa9d0b03494fc":"1000000000000000000000","0x9b64d3cd8d2b73f66841b5c46bb695b88a9ab75d":"20769000000000000000","0x8e9c08f738661f9676236eff82ba6261dd3f4822":"100000000000000000000","0xdeb97254474c0d2f5a7970dcdb2f52fb1098b896":"1000000000000000000000","0xb4256273962bf631d014555cc1da0dcc31616b49":"2000000000000000000000","0x23abd9e93e7957e5b636be6579051c15e5ce0b0e":"17188400000000000000000","0x382591e7217b435e8e884cdbf415fe377a6fe29e":"8022000000000000000000","0xf17adb740f45cbbde3094e7e13716f8103f563bd":"2000000000000000000000","0x61ed5596c697207f3d55b2a51aa7d50f07fa09e8":"2000000000000000000000","0x788e809741a3b14a22a4b1d937c82cfea489eebe":"7000000000000000000000","0x992646ac1acaabf5ddaba8f9429aa6a94e7496a7":"1000110000000000000000","0x51296f5044270d17707646129c86aad1645eadc1":"1337133000000000000000","0x6ee8aad7e0a065d8852d7c3b9a6e5fdc4bf50c00":"20000000000000000000","0x30db6b9b107e62102f434a9dd0960c2021f5ce4c":"599742000000000000000","0x63fc93001305adfbc9b85d29d9291a05f8f1410b":"1000000000000000000000","0xdf6ed6006a6abe886ed33d95a4de28fc12183927":"910000000000000000000","0x4745ab181a36aa8cbf2289d0c45165bc7ebe2381":"39400000000000000000","0x7bb0fdf5a663b5fba28d9c902af0c811e252f298":"200000000000000000000","0xe0ff0bd9154439c4a5b7233e291d7d868af53f33":"396110000000000000000","0x09261f9acb451c3788844f0c1451a35bad5098e3":"8664000000000000000000","0x2813d263fc5ff2479e970595d6b6b560f8d6d6d1":"2000000000000000000000","0x2cd19694d1926a0fa9189edebafc671cf1b2caa5":"1000000000000000000000","0x05336e9a722728d963e7a1cf2759fd0274530fca":"915583000000000000000","0xe5b7af146986c0ff8f85d22e6cc334077d84e824":"2000000000000000000000","0x3e4fbd661015f6461ed6735cefef01f31445de3a":"16200000000000000000000","0x4f5df5b94357de948604c51b7893cddf6076baad":"3760000000000000000000","0x9567a0de811de6ff095b7ee64e7f1b83c2615b80":"267400000000000000000","0x955db3b74360b9a268677e73cea821668af6face":"30000000000000000000000","0x3e040d40cb80ba0125f3b15fdefcc83f3005da1b":"1038000000000000000000","0x43f470ed659e2991c375957e5ddec5bd1d382231":"100000000000000000000","0x047f9bf1529daf87d407175e6f171b5e59e9ff3e":"650000000000000000000","0x15e3b584056b62c973cf5eb096f1733e54c15c91":"936702000000000000000","0xc03de42a109b657a64e92224c08dc1275e80d9b2":"20000000000000000000","0xe4fc13cfcbac1b17ce7783acd423a845943f6b3a":"20000000000000000000","0x65ff874fafce4da318d6c93d57e2c38a0d73e820":"1000160000000000000000","0x8b997dbc078ad02961355da0a159f2927ed43d64":"197000000000000000000","0x2f5080b83f7e2dc0a1dd11b092ad042bff788f4c":"3338355000000000000000","0x1b3920d001c43e72b24e7ca46f0fd6e0c20a5ff2":"2000000000000000000000","0x5ade77fd81c25c0af713b10702768c1eb2f975e7":"20000000000000000000","0xacaaddcbf286cb0e215dda55598f7ff0f4ada5c6":"1000000000000000000000","0x64e0217a5b38aa40583625967fa9883690388b6f":"200000000000000000000","0xae648155a658370f929be384f7e001047e49dd46":"13561000000000000000000","0xf7c1b443968b117b5dd9b755572fcd39ca5ec04b":"456082000000000000000","0xde027efbb38503226ed871099cb30bdb02af1335":"1000000000000000000000","0x49cf1e54be363106b920729d2d0ba46f0867989a":"268000000000000000000","0xe7f4d7fe6f561f7fa1da3005fd365451ad89df89":"200000000000000000000","0xb036916bdacf94b69e5a8a65602975eb026104dd":"20000000000000000000","0xe923c06177b3427ea448c0a6ff019b54cc548d95":"36281000000000000000","0xad927e03d1599a78ca2bf0cad2a183dceb71eac0":"1970000000000000000000","0xef39ca9173df15531d73e6b72a684b51ba0f2bb4":"1598000000000000000000","0x6443b8ae639de91cf73c5ae763eeeed3ddbb9253":"2000000000000000000000","0x8026435aac728d497b19b3e7e57c28c563954f2b":"1730000000000000000000","0xed327a14d5cfadd98103fc0999718d7ed70528ea":"1440000000000000000000","0x38a3dccf2fcfe0c91a2624bd0cbf88ee4a076c33":"2000000000000000000000","0xf0b1f9e27832c6de6914d70afc238c749995ace4":"2000000000000000000000","0x770d98d31b4353fceee8560c4ccf803e88c0c4e0":"600000000000000000000","0xba1f0e03cb9aa021f4dcebfa94e5c889c9c7bc9e":"32200000000000000000000","0x233842b1d0692fd11140cf5acda4bf9630bae5f8":"2000000000000000000000","0xb5dd50a15da34968890a53b4f13fe1af081baaaa":"4000000000000000000000","0x72072a0ef1cff3d567cdd260e708ddc11cbc9a31":"100000000000000000000","0x81a88196fac5f23c3e12a69dec4b880eb7d97310":"2000000000000000000000","0x6c63f84556d290bfcd99e434ee9997bfd779577a":"2000000000000000000000","0x5f167aa242bc4c189adecb3ac4a7c452cf192fcf":"1999980000000000000000","0x445cb8de5e3df520b499efc980f52bff40f55c76":"2000000000000000000000","0xaec27ce2133e82d052520afb5c576d9f7eb93ed2":"65232380000000000000000","0x07dc2bf83bc6af19a842ffea661af5b41b67fda1":"1500000000000000000000","0xfebd48d0ffdbd5656cd5e686363a61145228f279":"2800000000000000000000","0xa86db07d9f812f4796622d40e03d135874a88a74":"20000000000000000000","0x5413c97ffa4a6e2a7bba8961dc9fce8530a787d7":"1000000000000000000000","0xe2ff9ee4b6ecc14141cc74ca52a9e7a2ee14d908":"1400000000000000000000","0x2e8eb30a716e5fe15c74233e039bfb1106e81d12":"100000000000000000000","0xfd88d114220f081cb3d5e15be8152ab07366576a":"300000000000000000000","0xe408fceaa1b98f3c640f48fcba39f056066d6308":"10000000000000000000000","0x057dd29f2d19aa3da42327ea50bce86ff5c911d9":"4000000000000000000000","0xed1065dbcf9d73c04ffc7908870d881468c1e132":"2000000000000000000000","0xbbc9d8112e5beb02dd29a2257b1fe69b3536a945":"2000000000000000000000","0x79c1be19711f73bee4e6316ae7549459aacea2e0":"400000000000000000000","0x1bcf3441a866bdbe963009ce33c81cbb0261b02c":"182000000000000000000","0xe2e26e4e1dcf30d048cc6ecf9d51ec1205a4e926":"4000000000000000000000","0x77701e2c493da47c1b58f421b5495dee45bea39b":"6068279000000000000000","0x37a05aceb9395c8635a39a7c5d266ae610d10bf2":"30000000000000000000000","0xc6355ec4768c70a49af69513cd83a5bca7e3b9cd":"6000000000000000000000","0xe3c0c128327a9ad80148139e269773428e638cb0":"2000000000000000000000","0xf7f4898c4c526d955f21f055cb6e47b915e51964":"2288000000000000000000","0x29824e94cc4348bc963279dcdf47391715324cd3":"1940000000000000000000","0xeaa45cea02d87d2cc8fda9434e2d985bd4031584":"1920750000000000000000","0xe08b9aba6bd9d28bc2056779d2fbf0f2855a3d9d":"2000000000000000000000","0x87c498170934b8233d1ad1e769317d5c475f2f40":"1015200000000000000000","0x352d29a26e8a41818181746467f582e6e84012e0":"6000000000000000000000","0x403220600a36f73f24e190d1edb2d61be3f41354":"304000000000000000000","0x0a48296f7631708c95d2b74975bc4ab88ac1392a":"5000000000000000000000","0xffe0e997f1977a615f5a315af413fd4869343ba0":"100076000000000000000","0xca66b2280fa282c5b67631ce552b62ee55ad8474":"1969488000000000000000","0x2b6ed29a95753c3ad948348e3e7b1a251080ffb9":"250000000000000000000000","0x492e70f04d18408cb41e25603730506b35a2876b":"39400000000000000000","0x0e6baaa3deb989f289620076668618e9ac332865":"200000000000000000000","0xb753a75f9ed10b21643a0a3dc0517ac96b1a4068":"401800000000000000000","0x3ad915d550b723415620f5a9b5b88a85f382f035":"1000000000000000000000","0xc992be59c6721caf4e028f9e8f05c25c55515bd4":"20000000000000000000","0x02b643d6fabd437a851accbe79abb7fde126dccf":"7200000000000000000000","0x88797e58675ed5cc4c19980783dbd0c956085153":"2000000000000000000000","0xac142eda1157b9a9a64390df7e6ae694fac98905":"200000000000000000000","0x656579daedd29370d9b737ee3f5cd9d84bc2b342":"1430000000000000000000","0x9bb9b02a26bfe1ccc3f0c6219e261c397fc5ca78":"1337000000000000000000","0xbee8d0b008421954f92d000d390fb8f8e658eaee":"1000000000000000000000","0x7989d09f3826c3e5af8c752a8115723a84d80970":"415554000000000000000","0x7cd5d81eab37e11e6276a3a1091251607e0d7e38":"62856000000000000000","0x6ce1b0f6adc47051e8ab38b39edb4186b03babcc":"1207800000000000000000","0xabfcf5f25091ce57875fc674dcf104e2a73dd2f2":"19700000000000000000","0x1c3ef05dae9dcbd489f3024408669de244c52a02":"20000000000000000000000","0xcfa8b37127149bdbfee25c34d878510951ea10eb":"2000000000000000000000","0x74863acec75d03d53e860e64002f2c165e538377":"1000000000000000000000","0x59b9e733cba4be00429b4bd9dfa64732053a7d55":"20000000000000000000","0xaeadfcd0978edad74a32bd01a0a51d37f246e661":"260000000000000000000","0x08090876baadfee65c3d363ba55312748cfa873d":"1700170000000000000000","0xe589fa76984db5ec4004b46ee8a59492c30744ce":"2800000000000000000000","0x3485361ee6bf06ef6508ccd23d94641f814d3e2f":"2000000000000000000000","0x5cb731160d2e8965670bde925d9de5510935347d":"40000000000000000000","0x8ef4d8a2c23c5279187b64e96f741404085385f3":"299598000000000000000","0xe246683cc99db7c4a52bcbacaab0b32f6bfc93d7":"2000000000000000000000","0x7d273e637ef1eac481119413b91c989dc5eac122":"500000000000000000000","0x6efba8fb2ac5b6730729a972ec224426a287c3ad":"283152000000000000000","0x0773eeacc050f74720b4a1bd57895b1cceeb495d":"10000000000000000000000","0x88a122a2382c523931fb51a0ccad3beb5b7259c3":"2000000000000000000000","0xb0b779b94bfa3c2e1f587bcc9c7e21789222378f":"1550000000000000000000","0x86f95c5b11a293940e35c0b898d8b75f08aab06d":"29605000000000000000000","0xcf2288ef4ebf88e86db13d8a0e0bf52a056582c3":"2533000000000000000000","0x71ea5b11ad8d29b1a4cb67bf58ca6c9f9c338c16":"1600000000000000000000","0x9917d68d4af341d651e7f0075c6de6d7144e7409":"5660000000000000000000","0x1e5800227d4dcf75e30f5595c5bed3f72e341e3b":"248300000000000000000","0x123759f333e13e3069e2034b4f05398918119d36":"20000000000000000000000","0xf798d16da4e460c460cd485fae0fa0599708eb82":"1000000000000000000000","0x864bec5069f855a4fd5892a6c4491db07c88ff7c":"1000000000000000000000","0xfa283299603d8758e8cab082125d2c8f7d445429":"6415633000000000000000","0xc811c2e9aa1ac3462eba5e88fcb5120e9f6e2ca2":"1400140000000000000000","0x61547d376e5369bcf978fc162c3c56ae453547e8":"200000000000000000000","0x0d747ee5969bf79d57381d6fe3a2406cd0d8ce27":"100000000000000000000000","0xf8962b75db5d24c7e8b7cef1068c3e67cebb30a5":"280000000000000000000","0x35bf6688522f35467a7f75302314c02ba176800e":"17400000000000000000000","0x05cb6c3b0072d3116761b532b218443b53e8f6c5":"141722000000000000000000","0x91c80caa081b38351d2a0e0e00f80a34e56474c1":"1000000000000000000000","0xd75a502a5b677287470f65c5aa51b87c10150572":"907400000000000000000","0x3e194b4ecef8bb711ea2ff24fec4e87bd032f7d1":"2575465000000000000000","0x736bf1402c83800f893e583192582a134eb532e9":"9999996000000000000000","0xc2cb1ada5da9a0423873814793f16144ef36b2f3":"1334326000000000000000","0xefcce06bd6089d0e458ef561f5a689480afe7000":"600000000000000000000","0xbfe6bcb0f0c07852643324aa5df5fd6225abc3ca":"74500000000000000000","0x9d799e943e306ba2e5b99c8a6858cbb52c0cf735":"300000000000000000000","0xf45b1dcb2e41dc27ffa024daadf619c11175c087":"19700000000000000000","0x08e38ee0ce48c9ca645c1019f73b5355581c56e6":"1600000000000000000000","0x2cb4c3c16bb1c55e7c6b7a19b127a1ac9390cc09":"3397053000000000000000","0xbdc02cd4330c93d6fbda4f6db2a85df22f43c233":"2000000000000000000000","0xacec91ef6941cf630ba9a3e787a012f4a2d91dd4":"80000000000000000000000","0x27ac073be79ce657a93aa693ee43bf0fa41fef04":"50000000000000000000000","0x22fe884d9037291b4d52e6285ae68dea0be9ffb5":"2000000000000000000000","0xc3107a9af3322d5238df0132419131629539577d":"492650000000000000000","0xb5cac5ed03477d390bb267d4ebd46101fbc2c3da":"197000000000000000000","0x58fb947364e7695765361ebb1e801ffb8b95e6d0":"200000000000000000000","0x32860997d730b2d83b73241a25d3667d51c908ef":"499938000000000000000","0xc79d5062c796dd7761f1f13e558d73a59f82f38b":"8000000000000000000000","0xfa142fe47eda97e6503b386b18a2bedd73ccb5b1":"850080000000000000000","0x6ca5de00817de0cedce5fd000128dede12648b3c":"20000000000000000000","0x214b743955a512de6e0d886a8cbd0282bee6d2a2":"2000000000000000000000","0xede79ae1ff4f1606d59270216fa46ab2ddd4ecaa":"146000000000000000000","0x528101ce46b720a2214dcdae6618a53177ffa377":"508876000000000000000","0xb5870ce342d43343333673038b4764a46e925f3e":"1000000000000000000000","0x843bd3502f45f8bc4da370b323bdac3fcf5f19a6":"1476000000000000000000","0x5067f4549afbfe884c59cbc12b96934923d45db0":"1000000000000000000000","0x6f2a42e6e033d01061131929f7a6ee1538021e52":"2000000000000000000000","0xe9e1f7cb00a110edd0ebf8b377ef8a7bb856117f":"200000000000000000000","0xa387ecde0ee4c8079499fd8e03473bd88ad7522a":"1970000000000000000000","0x6dff90e6dc359d2590882b1483edbcf887c0e423":"1000000000000000000000","0x22e512149a18d369b73c71efa43e86c9edabaf1d":"1455000000000000000000","0xa3203095edb7028e6871ce0a84f548459f83300a":"4000000000000000000000","0x93b4bf3fdff6de3f4e56ba6d7799dc4b93a6548f":"19100000000000000000","0x8c75956e8fed50f5a7dd7cfd27da200f6746aea6":"1000000000000000000000","0xafc8ebe8988bd4105acc4c018e546a1e8f9c7888":"500000000000000000000","0xbf9acd4445d9c9554689cabbbab18800ff1741c2":"1000000000000000000000","0x603f2fab7afb6e017b94766069a4b43b38964923":"1656954000000000000000","0xa1f765c44fe45f790677944844be4f2d42165fbd":"3687750000000000000000","0x4dc9d5bb4b19cecd94f19ec25d200ea72f25d7ed":"2000000000000000000000","0x48f60a35484fe7792bcc8a7b6393d0dda1f6b717":"3600000000000000000000","0x588ed990a2aff44a94105d58c305257735c868ac":"16100000000000000000000","0x710be8fd5e2918468be2aabea80d828435d79612":"17600000000000000000","0x03ea6d26d080e57aee3926b18e8ed73a4e5b2826":"200000000000000000000","0x20824ba1dbebbef9846ef3d0f6c1b017e6912ec4":"7170194000000000000000","0xf7500c166f8bea2f82347606e5024be9e4f4ce99":"20000000000000000000","0x9d369165fb70b81a3a765f188fd60cbe5e7b0968":"2000000000000000000000","0x6fddbd9bca66e28765c2162c8433548c1052ed11":"82720000000000000000000","0x8b81156e698639943c01a75272ad3d35851ab282":"344946000000000000000","0x75804aac64b4199083982902994d9c5ed8828f11":"557800000000000000000","0xd6e8e97ae9839b9ee507eedb28edfb7477031439":"2000000000000000000000","0x6c808cabb8ff5fbb6312d9c8e84af8cf12ef0875":"4000086000000000000000","0xafa539586e4719174a3b46b9b3e663a7d1b5b987":"5000000000000000000000","0xf8a065f287d91d77cd626af38ffa220d9b552a2b":"1910000000000000000000","0x30e60900cacc7203f314dc604347255167fc2a0f":"2000000000000000000000","0x796f87ba617a2930b1670be92ed1281fb0b346e1":"128400000000000000000","0xf114ff0d0f24eff896edde5471dea484824a99b3":"13700000000000000000","0x0b80fc70282cbdd5fde35bf78984db3bdb120188":"1000160000000000000000","0xda7ad025ebde25d22243cb830ea1d3f64a566323":"500000000000000000000","0x65a52141f56bef98991724c6e7053381da8b5925":"60140000000000000000","0xbbc8eaff637e94fcc58d913c7770c88f9b479277":"200000000000000000000","0x0469e8c440450b0e512626fe817e6754a8152830":"2000000000000000000000","0x0727be0a2a00212048b5520fbefb953ebc9d54a0":"10000000000000000000000","0x7d858493f07415e0912d05793c972113eae8ae88":"1818000000000000000000","0x7091303116d5f2389b23238b4d656a8596d984d3":"1094014000000000000000","0x3702e704cc21617439ad4ea27a5714f2fda1e932":"1000000000000000000000","0xb87de1bcd29269d521b8761cc39cfb4319d2ead5":"1000000000000000000000","0xf639ac31da9f67271bd10402b7654e5ce763bd47":"399996000000000000000","0xe7735ec76518fc6aa92da8715a9ee3f625788f13":"1997803000000000000000","0x51277fe7c81eebd252a03df69a6b9f326e272207":"59965000000000000000","0x3b8098533f7d9bdcd307dbb23e1777ca18418936":"2000000000000000000000","0x2cba6d5d0dc204ea8a25ada2e26f5675bd5f2fdc":"1330755000000000000000","0x5c3c1c645b917543113b3e6c1c054da1fe742b9a":"800000000000000000000","0x5ecdbaeab9106ffe5d7b519696609a05baeb85ad":"20000000000000000000","0x45a820a0672f17dc74a08112bc643fd1167736c3":"199943000000000000000","0xbeef94213879e02622142bea61290978939a60d7":"5728109000000000000000","0x6cd212aee04e013f3d2abad2a023606bfb5c6ac7":"1999944000000000000000","0x92698e345378c62d8eda184d94366a144b0c105b":"1400000000000000000000","0x2d5b42fc59ebda0dfd66ae914bc28c1b0a6ef83a":"206764195000000000000000","0xb7a6791c16eb4e2162f14b6537a02b3d63bfc602":"780700000000000000000","0xfa105f1a11b6e4b1f56012a27922e2ac2da4812f":"9550000000000000000000","0x2306df931a940d58c01665fa4d0800802c02edfe":"1000000000000000000000","0xf37bf78c5875154711cb640d37ea6d28cfcb1259":"200000000000000000000","0x66201bd227ae6dc6bdfed5fbde811fecfe5e9dd9":"594808000000000000000","0x2bafbf9e9ed2c219f7f2791374e7d05cb06777e7":"220000000000000000000","0x8e9b35ad4a0a86f758446fffde34269d940ceacd":"4000000000000000000000","0x1b43232ccd4880d6f46fa751a96cd82473315841":"80000000000000000000","0x6eefdc850e87b715c72791773c0316c3559b58a4":"4000000000000000000000","0xf2c03e2a38998c21648760f1e5ae7ea3077d8522":"2642456000000000000000","0x0625d06056968b002206ff91980140242bfaa499":"1000000000000000000000","0x6158e107c5eb54cb7604e0cd8dc1e07500d91c3c":"50000000000000000000","0x02477212ffdd75e5155651b76506b1646671a1eb":"1760000000000000000000","0xfa44a855e404c86d0ca8ef3324251dfb349c539e":"1552000000000000000000","0x49897fe932bbb3154c95d3bce6d93b6d732904dd":"4000000000000000000000","0x9b6641b13e172fc072ca4b8327a3bc28a15b66a9":"120000000000000000000","0xa46b4387fb4dcce011e76e4d73547d4481e09be5":"1337000000000000000000","0x72bb27cb99f3e2c2cf90a98f707d30e4a201a071":"1640000000000000000000","0xb6bfe1c3ef94e1846fb9e3acfe9b50c3e9069233":"1999944000000000000000","0xe6cb3f3124c9c9cc3834b1274bc3336456a38bac":"427382000000000000000","0xfcbc5c71ace79741450b012cf6b8d3f17db68a70":"9550000000000000000000","0x15dbb48c98309764f99ced3692dcca35ee306bac":"150000000000000000000000","0x2e10910ba6e0bc17e055556614cb87090f4d7e5b":"200000000000000000000","0xe5fbe34984b637196f331c679d0c0c47d83410e1":"2000050000000000000000","0x6d120f0caae44fd94bcafe55e2e279ef96ba5c7a":"4000000000000000000000","0xaa5afcfd8309c2df9d15be5e6a504e7d706624c5":"5846763000000000000000","0x37959c20b7e9931d72f5a8ae869dafddad3b6d5c":"200000000000000000000","0xb041310fe9eed6864cedd4bee58df88eb4ed3cac":"10000000000000000000000","0x986df47e76e4d7a789cdee913cc9831650936c9d":"5000000000000000000000","0x35aaa0465d1c260c420fa30e2629869fb6559207":"704976000000000000000","0x7f655c6789eddf455cb4b88099720639389eebac":"6000000000000000000000","0x9e3eb509278fe0dcd8e0bbe78a194e06b6803943":"940000000000000000000","0x3e9410d3b9a87ed5e451a6b91bb8923fe90fb2b5":"200000000000000000000","0x9e960dcd03d5ba99cb115d17ff4c09248ad4d0be":"200000000000000000000","0xf057aa66ca767ede124a1c5b9cc5fc94ef0b0137":"2077730000000000000000","0xf38a6ca80168537e974d14e1c3d13990a44c2c1b":"6000000000000000000000","0x229e430de2b74f442651ddcdb70176bc054cad54":"13545000000000000000","0x27bf9f44ba7d05c33540c3a53bb02cbbffe7c3c6":"2000000000000000000000","0x10389858b800e8c0ec32f51ed61a355946cc409b":"200000000000000000000","0xfd2929271e9d2095a264767e7b0df52ea0d1d400":"3000040000000000000000","0x44250d476e062484e9080a3967bf3a4a732ad73f":"20000000000000000000","0x0c67033dd8ee7f0c8ae534d42a51f7d9d4f7978f":"200000000000000000000","0xe083d34863e0e17f926b7928edff317e998e9c4b":"400000000000000000000","0x7f7192c0df1c7db6d9ed65d71184d8e4155a17ba":"79800000000000000000","0x51e7b55c2f9820eed73884361b5066a59b6f45c6":"2000000000000000000000","0x4fa983bb5e3073a8edb557effeb4f9fb1d60ef86":"1599800000000000000000","0x5a5ee8e9bb0e8ab2fecb4b33d29478be50bbd44b":"776000000000000000000","0x1f3959fc291110e88232c36b7667fc78a379613f":"18200000000000000000","0x2d7d5c40ddafc450b04a74a4dabc2bb5d665002e":"2000000000000000000000","0x5215183b8f80a9bc03d26ce91207832a0d39e620":"1000000000000000000000","0x5607590059a9fec1881149a44b36949aef85d560":"2000000000000000000000","0xf7c50f922ad16b61c6d1baa045ed816815bac48f":"12566370000000000000000","0xda10978a39a46ff0bb848cf65dd9c77509a6d70e":"2000000000000000000000","0xa7dcbba9b9bf6762c145416c506a71e3b497209c":"1999944000000000000000","0x54e01283cc8b384538dd646770b357c960d6cacd":"5000000000000000000000","0x78cf8336b328db3d87813a472b9e89b75e0cf3bc":"1000000000000000000000","0xba24fc436753a739db2c8d40e6d4d04c528e86fa":"13000000000000000000000","0xdfe929a61c1b38eddbe82c25c2d6753cb1e12d68":"402500000000000000000","0x2b49fba29830360fcdb6da23bbfea5c0bbac5281":"20000000000000000000","0x76becae4a31d36f3cb577f2a43594fb1abc1bb96":"24860000000000000000000","0xe0cf698a053327ebd16b7d7700092fe2e8542446":"95275000000000000000","0xa3802d8a659e89a2c47e905430b2a827978950a7":"1000000000000000000000","0x75636cdb109050e43d5d6ec47e359e218e857eca":"22886800000000000000000","0x3d813ff2b6ed57b937dabf2b381d148a411fa085":"100000000000000000000","0xa9252551a624ae513719dabe5207fbefb2fd7749":"40000000000000000000","0xc749668042e71123a648975e08ed6382f83e05e2":"14000000000000000000000","0x04eca501630abce35218b174956b891ba25efb23":"1000060000000000000000","0x790f91bd5d1c5cc4739ae91300db89e1c1303c93":"2000000000000000000000","0x009560a3de627868f91fa8bfe1c1b7afaf08186b":"524000000000000000000","0x1329dd19cd4baa9fc64310efeceab22117251f12":"200000000000000000000","0x7005a772282b1f62afda63f89b5dc6ab64c84cb9":"18000000000000000000000","0xabfe936425dcc7b74b955082bbaaf2a11d78bc05":"1400000000000000000000","0x97d0d9725e3b70e675843173938ed371b62c7fac":"170000000000000000000","0x41ed2d8e7081482c919fc23d8f0091b3c82c4685":"1295460000000000000000","0x992365d764c5ce354039ddfc912e023a75b8e168":"18200000000000000000","0xe1c607c0a8a060da8f02a8eb38a013ea8cda5b8c":"805000000000000000000","0x3b2c45990e21474451cf4f59f01955b331c7d7c9":"2000000000000000000000","0x29ac2b458454a36c7e96c73a8667222a12242c71":"4000000000000000000000","0xb8555010776e3c5cb311a5adeefe9e92bb9a64b9":"4000000000000000000000","0x30380087786965149e81423b15e313ba32c5c783":"18200000000000000000","0xa2f86bc061884e9eef05640edd51a2f7c0596c69":"2000050000000000000000","0x9f98eb34d46979b0a6de8b05aa533a89b825dcf1":"86500000000000000000","0xc81fb7d20fd2800192f0aac198d6d6a37d3fcb7d":"259500000000000000000","0xa4035ab1e5180821f0f380f1131b7387c8d981cd":"20000000000000000000","0x782f52f0a676c77716d574c81ec4684f9a020a97":"850055000000000000000","0x261e0fa64c51137465eecf5b90f197f7937fdb05":"18000000000000000000000","0x276fd7d24f8f883f5a7a28295bf17151c7a84b03":"2000000000000000000000","0xa1f5b840140d5a9acef402ac3cc3886a68cad248":"2000000000000000000000","0xd2bf67a7f3c6ce56b7be41675dbbadfe7ea93a33":"400000000000000000000","0x8ee584337ddbc80f9e3498df55f0a21eacb57fb1":"20000000000000000000","0x34393c5d91b9de597203e75bac4309b5fa3d28c3":"194000000000000000000","0x114cbbbf6fb52ac414be7ec61f7bb71495ce1dfa":"3000000000000000000000","0xab7c42c5e52d641a07ad75099c62928b7f86622f":"335940000000000000000","0x80bf995ed8ba92701d10fec49f9e7d014dbee026":"572153000000000000000","0x4a192035e2619b24b0709d56590e9183ccf2c1d9":"10000000000000000000000","0x376cd7577383e902951b60a2017ba7ea29e33576":"2000000000000000000000","0xf5437e158090b2a2d68f82b54a5864b95dd6dbea":"4010732000000000000000","0x13a5eecb38305df94971ef2d9e179ae6cebab337":"330000000000000000000","0xefc8cf1963c9a95267b228c086239889f4dfd467":"10000000000000000000000","0xdb77b88dcb712fd17ee91a5b94748d720c90a994":"2000000000000000000000","0x9aaafa0067647ed999066b7a4ca5b4b3f3feaa6f":"1000000000000000000000","0xae36f7452121913e800e0fcd1a65a5471c23846f":"164000000000000000000","0xb124bcb6ffa430fcae2e86b45f27e3f21e81ee08":"2000000000000000000000","0xf2813a64c5265d020235cb9c319b6c96f906c41e":"350000000000000000000","0xe848ca7ebff5c24f9b9c316797a43bf7c356292d":"114000000000000000000","0x21a6feb6ab11c766fdd977f8df4121155f47a1c0":"57200000000000000000","0xe95e92bbc6de07bf3a660ebf5feb1c8a3527e1c5":"18200000000000000000","0x0b369e002e1b4c7913fcf00f2d5e19c58165478f":"64520000000000000000","0x0909648c18a3ce5bae7a047ec2f868d24cdda81d":"3820000000000000000000","0xd32b45564614516c91b07fa9f72dcf787cce4e1c":"291000000000000000000","0xcf1bdb799b2ea63ce134668bdc198b54840f180b":"18200000000000000000","0xae062c448618643075de7a0030342dced63dbad7":"825982000000000000000","0x99dfd0504c06c743e46534fd7b55f1f9c7ec3329":"2000000000000000000000","0x87fc4635263944ce14a46c75fa4a821f39ce7f72":"20000000000000000000","0x27c2d7ca504daa3d9066dc09137dc42f3aaab452":"600000000000000000000","0xcc60f836acdef3548a1fefcca13ec6a937db44a0":"86500000000000000000","0xc910a970556c9716ea53af66ddef93143124913d":"1580000000000000000000","0x8173c835646a672e0152be10ffe84162dd256e4c":"492000000000000000000","0xe989733ca1d58d9e7b5029ba5d444858bec03172":"581595000000000000000","0x86806474c358047d9406e6a07f40945bc8328e67":"6884000000000000000000","0x5395a4455d95d178b4532aa4725b193ffe512961":"1000000000000000000000","0x56397638bb3cebf1f62062794b5eb942f916171d":"2000000000000000000000","0x6958f83bb2fdfb27ce0409cd03f9c5edbf4cbedd":"20000000000000000000000","0x26ff0a51e7cece8400276978dbd6236ef162c0e6":"100020000000000000000000","0x4ca783b556e5bf53aa13c8116613d65782c9b642":"25200000000000000000000","0x15a0aec37ff9ff3d5409f2a4f0c1212aaccb0296":"1000000000000000000000","0x50378af7ef54043f892ab7ce97d647793511b108":"19700000000000000000","0xe7c6b5fc05fc748e5b4381726449a1c0ad0fb0f1":"2000000000000000000000","0x5317ecb023052ca7f5652be2fa854cfe4563df4d":"499986000000000000000","0xc94f7c35c027d47df8ef4f9df85a9248a17dd23b":"29944000000000000000","0x6a63fc89abc7f36e282d80787b7b04afd6553e71":"160000000000000000000","0x5fd3d6777ec2620ae83a05528ed425072d3ca8fd":"2000000000000000000000","0x29adcf83b6b20ac6a434abb1993cbd05c60ea2e4":"10000000000000000000000","0x8c6f9f4e5b7ae276bf58497bd7bf2a7d25245f64":"2730000000000000000000","0xd94a57882a52739bbe2a0647c80c24f58a2b4f1c":"1341230000000000000000","0x7286e89cd9de8f7a8a00c86ffdb53992dd9251d1":"1940000000000000000000","0x5773b6026721a1dd04b7828cd62b591bfb34534c":"27000000000000000000000","0x11fefb5dc1a4598aa712640c517775dfa1d91f8c":"10000000000000000000000","0xc6e324beeb5b36765ecd464260f7f26006c5c62e":"2000000000000000000000","0x118fbd753b9792395aef7a4d78d263cdcaabd4f7":"999800000000000000000","0xf8298591523e50b103f0b701d623cbf0f74556f6":"200000000000000000000","0xab0ced762e1661fae1a92afb1408889413794825":"1910000000000000000000","0xfa67b67b4f37a0150915110ede073b05b853bda2":"647490000000000000000","0xca122cf0f2948896b74843f49afed0ba1618eed7":"560000000000000000000","0x186b95f8e5effddcc94f1a315bf0295d3b1ea588":"1999944000000000000000","0x2915624bcb679137b8dae9ab57d11b4905eaee4b":"20000000000000000000","0x0c6845bf41d5ee273c3ee6b5b0d69f6fd5eabbf7":"3000026000000000000000","0xcb7479109b43b26657f4465f4d18c6f974be5f42":"1820000000000000000000","0x8dd6a9bae57f518549ada677466fea8ab04fd9b4":"4000000000000000000000","0x34958a46d30e30b273ecc6e5d358a212e5307e8c":"2000000000000000000000","0x2003717907a72560f4307f1beecc5436f43d21e7":"500000000000000000000","0x55ab99b0e0e55d7bb874b7cfe834de631c97ec23":"1031400000000000000000","0x79b48d2d6137c3854d611c01ea42427a0f597bb7":"191000000000000000000","0xd609ec0be70d0ad26f6e67c9d4762b52ee51122c":"1000000000000000000000","0xe8c3f045bb7d38c9d2f395b0ba8492b253230901":"9000000000000000000000","0xaaca60d9d700e78596bbbbb1f1e2f70f4627f9d8":"999996000000000000000","0x89d75b8e0831e46f80bc174188184e006fde0eae":"1000000000000000000000","0xb3667894b7863c068ad344873fcff4b5671e0689":"20000000000000000000000","0xbc1609d685b76b48ec909aa099219022f89b2ccd":"1182000000000000000000","0x88ee7f0efc8f778c6b687ec32be9e7d6f020b674":"2000000000000000000000","0x470ac5d1f3efe28f3802af925b571e63868b397d":"2000000000000000000000","0xabf8ffe0708a99b528cc1ed4e9ce4b0d0630be8c":"2263600000000000000000","0x8cee38d6595788a56e3fb94634b3ffe1fbdb26d6":"20000000000000000000000","0x19798cbda715ea9a9b9d6aab942c55121e98bf91":"1200000000000000000000","0xe25a167b031e84616d0f013f31bda95dcc6350b9":"10560000000000000000000","0x6196c3d3c0908d254366b7bca55745222d9d4db1":"4000000000000000000000","0xe8e9850586e94f5299ab494bb821a5f40c00bd04":"3820000000000000000000","0x1059cbc63e36c43e88f30008aca7ce058eeaa096":"100000000000000000000000","0xc4f2913b265c430fa1ab8adf26c333fc1d9b66f2":"20000000000000000000","0x26e9e2ad729702626417ef25de0dc800f7a779b3":"1000000000000000000000","0x0dfbd4817050d91d9d625c02053cf61a3ee28572":"340000000000000000000","0x709fe9d2c1f1ce42207c9585044a60899f35942f":"2000000000000000000000","0x7ad82caea1a8b4ed05319b9c9870173c814e06ee":"616000000000000000000","0x2a595f16eee4cb0c17d9a2d939b3c10f6c677243":"1100000000000000000000","0xa8f89dd5cc6e64d7b1eeace00702022cd7d2f03d":"700000000000000000000","0xc0a6cbad77692a3d88d141ef769a99bb9e3c9951":"100000000000000000000","0x868c23be873466d4c74c220a19b245d1787e807f":"1366481000000000000000","0x2905b192e83ce659aa355b9d0c204e3e95f9bb9a":"2160817000000000000000","0x50b9fef0a1329b02d16506255f5a2db71ec92d1f":"1325464000000000000000","0xfc10b7a67b3268d5331bfb6a14def5ea4a162ca3":"200000000000000000000","0x85eb256b51c819d60ea61a82d12c9358d59c1cae":"460000000000000000000","0x75de7e9352e90b13a59a5878ffecc7831cac4d82":"2740000000000000000000","0xd32b2c79c36478c5431901f6d700b04dbe9b8810":"396000000000000000000","0x2d0326b23f0409c0c0e9236863a133075a94ba18":"210380000000000000000","0xd2e21ed56868fab28e0947927adaf29f23ebad6c":"1994000000000000000000","0x2ad6c9d10c261819a1a0ca2c48d8c7b2a71728df":"1000000000000000000000","0x7d445267c59ab8d2a2d9e709990e09682580c49f":"1000000000000000000000","0xb6047cdf932db3e4045f4976122341537ed5961e":"20000000000000000000","0x2b3cf97311ff30f460945a9d8099f4a88e26d456":"2000000000000000000000","0x7f4f593b618c330ba2c3d5f41eceeb92e27e426c":"2775000000000000000000","0x72a2fc8675feb972fa41b50dffdbbae7fa2adfb7":"2853840000000000000000","0x076561a856455d7ef86e63f87c73dbb628a55f45":"900000000000000000000","0x03d1724fd00e54aabcd2de2a91e8462b1049dd3a":"2640000000000000000000","0x7ea0f96ee0a573a330b56897761f3d4c0130a8e3":"1337000000000000000000","0xfe65c4188d7922576909642044fdc52395560165":"4000000000000000000000","0x57883010b4ac857fedac03eab2551723a8447ffb":"1000000000000000000000","0x0729a8a4a5ba23f579d0025b1ad0f8a0d35cdfd2":"9700000000000000000000","0xe75c1fb177089f3e58b1067935a6596ef1737fb5":"99910000000000000000","0xe0e978753d982f7f9d1d238a18bd4889aefe451b":"9700000000000000000000","0x5620f46d1451c2353d6243a5d4b427130be2d407":"60000000000000000000","0xf3d688f06bbdbf50f9932c4145cbe48ecdf68904":"20000000000000000000","0x3aa948ea02397755effb2f9dc9392df1058f7e33":"850000000000000000000","0x20d1417f99c569e3beb095856530fe12d0fceaaa":"1182175000000000000000","0xac77bdf00fd5985b5db12bbef800380abc2a0677":"1000000000000000000000","0x267a7e6e82e1b91d51deddb644f0e96dbb1f7f7e":"20000000000000000000","0x4bbcbf38b3c90163a84b1cd2a93b58b2a3348d87":"8000000000000000000000","0x4c6b93a3bec16349540cbfcae96c9621d6645010":"2000000000000000000000","0xc9308879056dfe138ef8208f79a915c6bc7e70a8":"10000000000000000000000","0xc48b693cacefdbd6cb5d7895a42e3196327e261c":"1000000000000000000000","0xa0951970dfd0832fb83bda12c23545e79041756c":"600000000000000000000","0x7cdf74213945953db39ad0e8a9781add792e4d1d":"2000000000000000000000","0x75621865b6591365606ed378308c2d1def4f222c":"3100000000000000000000","0x67d6a8aa1bf8d6eaf7384e993dfdf10f0af68a61":"198067000000000000000","0x8f0af37566d152802f1ae8f928b25af9b139b448":"200000000000000000000","0x2c6afcd4037c1ed14fa74ff6758e0945a185a8e8":"17600000000000000000","0xc1b2aa8cb2bf62cdc13a47ecc4657facaa995f98":"1000129000000000000000","0x9e8144e08e89647811fe6b72d445d6a5f80ad244":"10000000000000000000000","0xe04ff5e5a7e2af995d8857ce0290b53a2b0eda5d":"1000000000000000000000","0x03dedfcd0b3c2e17c705da248790ef98a6bd5751":"1337000000000000000000","0x698a8a6f01f9ab682f637c7969be885f6c5302bf":"19400000000000000000","0xd82c6fedbdac98af2eed10b00f32b00056ca5a6d":"200000000000000000000","0x2697b339813b0c2d964b2471eb1c606f4ecb9616":"1154000000000000000000","0x987c9bcd6e3f3990a52be3eda4710c27518f4f72":"400000000000000000000","0xc5d48ca2db2f85d8c555cb0e9cfe826936783f9e":"200000000000000000000","0xda214c023e2326ff696c00393168ce46ffac39ec":"1000000000000000000000","0x86570ab259c9b1c32c9729202f77f590c07dd612":"200000000000000000000","0xa646a95c6d6f59f104c6541d7760757ab392b08c":"4200000000000000000000","0x1933e334c40f3acbad0c0b851158206924beca3a":"7551541000000000000000","0x3552a496eba67f12be6eedab360cd13661dc7480":"300000000000000000000","0x2a9c96c19151ffcbe29a4616d0c52b3933b4659f":"69263000000000000000","0x3b7b8e27de33d3ce7961b98d19a52fe79f6c25be":"100000000000000000000000","0xa1911405cf6e999ed011f0ddcd2a4ff7c28f2526":"40000000000000000000","0x0cae108e6db99b9e637876b064c6303eda8a65c8":"3000000000000000000000","0x3883becc08b9be68ad3b0836aac3b620dc0017ef":"2000000000000000000000","0xd0abcc70c0420e0e172f97d43b87d5e80c336ea9":"10000000000000000000000","0xcbf16a0fe2745258cd52db2bf21954c975fc6a15":"300000000000000000000","0x1b23cb8663554871fbbe0d9e60397efb6faedc3e":"200000000000000000000","0xfbede32c349f3300ef4cd33b4de7dc18e443d326":"3160000000000000000000","0x5e806e845730f8073e6cc9018ee90f5c05f909a3":"9480000000000000000000","0x425c338a1325e3a1578efa299e57d986eb474f81":"2000000000000000000000","0x8bf297f8f453523ed66a1acb7676856337b93bf0":"4000000000000000000000","0x38e8a31af2d265e31a9fff2d8f46286d1245a467":"20000000000000000000","0x7edafba8984baf631a820b6b92bbc2c53655f6bd":"2000000000000000000000","0xaa0200f1d17e9c54da0647bb96395d57a78538d8":"1056000000000000000000","0x433eb94a339086ed12d9bde9cd1d458603c97dd6":"100000000000000000000000","0xcd7e47909464d871b9a6dc76a8e9195db3485e7a":"9850000000000000000000","0x5975d78d974ee5bb9e4d4ca2ae77c84b9c3b4b82":"1370000000000000000000","0xcea2896623f4910287a2bdc5be83aea3f2e6de08":"9359000000000000000000","0xcb4ad0c723da46ab56d526da0c1d25c73daff10a":"510000000000000000000","0xe2cf360aa2329eb79d2bf7ca04a27a17c532e4d8":"102000000000000000000","0xea60549ec7553f511d2149f2d4666cbd9243d93c":"2000000000000000000000","0xcbb7be17953f2ccc93e1bc99805bf45511434e4c":"50440000000000000000000","0x3549bd40bbbc2b30095cac8be2c07a0588e0aed6":"20000000000000000000","0x6510df42a599bcb0a519cca961b488759a6f6777":"2000000000000000000000","0xed12a1ba1fb8adfcb20dfa19582e525aa3b74524":"6685000000000000000000","0x135eb8c0e9e101deedec11f2ecdb66ae1aae8867":"20000000000000000000000","0xee906d7d5f1748258174be4cbc38930302ab7b42":"200000000000000000000","0x253f1e742a2cec86b0d7b306e5eacb6ccb2f8554":"20040000000000000000000","0xecd1a62802351a41568d23033004acc6c005a5d3":"50000000000000000000","0x558c54649a8a6e94722bd6d21d14714f71780534":"2000000000000000000000","0xca657ec06fe5bc09cf23e52af7f80cc3689e6ede":"900000000000000000000","0x74bf7a5ab59293149b5c60cf364263e5ebf1aa0d":"115800000000000000000","0x7a6d781c77c4ba1fcadf687341c1e31799e93d27":"274000000000000000000","0x77028e409cc43a3bd33d21a9fc53ec606e94910e":"3880000000000000000000","0x4781a10a4df5eebc82f4cfe107ba1d8a7640bd66":"1790000000000000000000","0x78e08bc533413c26e291b3143ffa7cc9afb97b78":"200000000000000000000","0x03ef6ad20ff7bd4f002bac58d47544cf879ae728":"6895000000000000000000","0x0e3696cf1f4217b163d1bc12a5ea730f1c32a14a":"4000000000000000000000","0x825135b1a7fc1605614c8aa4d0ac6dbad08f480e":"1430000000000000000000","0x286b186d61ea1fd78d9930fe12b06537b05c3d51":"1000000000000000000000","0x8d6657f59711b1f803c6ebef682f915b62f92dc9":"2000000000000000000000","0xda8bbee182e455d2098acb338a6d45b4b17ed8b6":"2000000000000000000000","0x3f2da093bb16eb064f8bfa9e30b929d15f8e1c4c":"2000000000000000000000","0xf5d9cf00d658dd45517a48a9d3f5f633541a533d":"116400000000000000000","0xc5f64babb7033142f20e46d7aa6201ed86f67103":"2000000000000000000000","0xa2e2b5941e0c01944bfe1d5fb4e8a34b922ccfb1":"200000000000000000000","0x6114b0eae5576903f80bfb98842d24ed92237f1e":"100000000000000000000","0x38df0c4abe7ded5fe068eadf154ac691774324a4":"1790000000000000000000","0x1c2010bd662df417f2a271879afb13ef4c88a3ae":"4000000000000000000000","0x918967918cd897dd0005e36dc6c883ef438fc8c7":"140000000000000000000","0xa522de7eb6ae1250522a513133a93bd42849475c":"20000000000000000000000","0x7de442c82386154d2e993cbd1280bb7ca6b12ada":"4002000000000000000000","0x66424bd8785b8cb461102a900283c35dfa07ef6a":"40221000000000000000","0x7bbbec5e70bdead8bb32b42805988e9648c0aa97":"1000076000000000000000","0xfec06fe27b44c784b2396ec92f7b923ad17e9077":"2000000000000000000000","0x95d550427b5a514c751d73a0f6d29fb65d22ed10":"300000000000000000000","0x8dde60eb08a099d7daa356daaab2470d7b025a6b":"197000000000000000000","0x81bccbff8f44347eb7fca95b27ce7c952492aaad":"152240000000000000000","0x3995e096b08a5a726800fcd17d9c64c64e088d2b":"200000000000000000000","0x4ee13c0d41200b46d19dee5c4bcec71d82bb8e38":"7893915000000000000000","0xc41461a3cfbd32c9865555a4813137c076312360":"999999000000000000000","0x3300fb149aded65bcba6c04e9cd6b7a03b893bb1":"18200000000000000000","0x29f9286c0e738d1721a691c6b95ab3d9a797ede8":"200000000000000000000000","0x34c8e5f1330fcb4b14ca75cb2580a4b93d204e36":"2000000000000000000000","0xec5df227bfa85d7ad76b426e1cee963bc7f519dd":"1000000000000000000000","0x797510e386f56393ced8f477378a444c484f7dad":"1000000000000000000000","0x0191eb547e7bf6976b9b1b577546761de65622e2":"1999980000000000000000","0x615a6f36777f40d6617eb5819896186983fd3731":"5910000000000000000000","0x17580b766f7453525ca4c6a88b01b50570ea088c":"100000000000000000000","0x945d96ea573e8df7262bbfa572229b4b16016b0f":"209300000000000000000","0x2de0964400c282bdd78a919c6bf77c6b5f796179":"200000000000000000000","0x304ec69a74545721d7316aef4dcfb41ac59ee2f0":"200000000000000000000","0xbe2b326e78ed10e550fee8efa8f8070396522f5a":"39400000000000000000000","0x1a0841b92a7f7075569dc4627e6b76cab05ade91":"1520000000000000000000","0x5fa61f152de6123516c751242979285f796ac791":"204000000000000000000","0x68c8791dc342c373769ea61fb7b510f251d32088":"1000000000000000000000","0x4167cd48e733418e8f99ffd134121c4a4ab278c4":"3640000000000000000000","0x598aaabae9ed833d7bc222e91fcaa0647b77580b":"1800000000000000000000","0x979f30158b574b999aab348107b9eed85b1ff8c1":"970000000000000000000","0x3ad06149b21c55ff867cc3fb9740d2bcc7101231":"197000000000000000000000","0x7133843a78d939c69d4486e10ebc7b602a349ff7":"329000000000000000000","0x8bdfda6c215720eda2136f91052321af4e936c1f":"1000008000000000000000","0x3e1c53300e4c168912163c7e99b95da268ad280a":"1003200000000000000000","0xe07ebbc7f4da416e42c8d4f842aba16233c12580":"2000000000000000000000","0xbac8922c4acc7d2cb6fd59a14eb45cf3e702214b":"800000000000000000000","0xbb6c284aac8a69b75cddb00f28e145583b56bece":"2000000000000000000000","0x0372ee5508bf8163ed284e5eef94ce4d7367e522":"100000000000000000000","0x17125b59ac51cee029e4bd78d7f5947d1ea49bb2":"22000000000000000000000","0xc88ca1e6e5f4d558d13780f488f10d4ad3130d34":"1550000000000000000000","0xa825fd5abb7926a67cf36ba246a24bd27be6f6ed":"17600000000000000000","0x04241b41ecbd0bfdf1295e9d4fa59ea09e6c6186":"1870000000000000000000","0x6de4d15219182faf3aa2c5d4d2595ff23091a727":"1580000000000000000000","0xb203d29e6c56b92699c4b92d1f6f84648dc4cfbc":"400000000000000000000","0x80b42de170dbd723f454e88f7716452d92985092":"300202000000000000000","0x0a5b79d8f23b6483dbe2bdaa62b1064cc76366ae":"1969803000000000000000","0x32034e8581d9484e8af42a28df190132ec29c466":"3460000000000000000000","0x7ee604c7a9dc2909ce321de6b9b24f5767577555":"5533575000000000000000","0xa387ce4e961a7847f560075c64e1596b5641d21c":"668500000000000000000","0xfcc9d4a4262e7a027ab7519110d802c495ceea39":"6370000000000000000000","0xff8a2ca5a81333f19998255f203256e1a819c0aa":"224000000000000000000","0xf9811fa19dadbf029f8bfe569adb18228c80481a":"200000000000000000000","0x0d1f2a57713ebc6e94de29846e8844d376665763":"5000000000000000000000","0xeab0bd148309186cf8cbd13b7232d8095acb833a":"10691800000000000000000","0x36928b55bc861509d51c8cf1d546bfec6e3e90af":"1970000000000000000000","0x30480164bcd84974ebc0d90c9b9afab626cd1c73":"800000000000000000000","0x36339f84a5c2b44ce53dfdb6d4f97df78212a7df":"321600000000000000000","0xcfeacaaed57285e0ac7268ce6a4e35ecfdb242d7":"1086400000000000000000","0x572dd8cd3fe399d1d0ec281231b7cefc20b9e4bb":"10400000000000000000000","0x5dded049a6e1f329dc4b971e722c9c1f2ade83f0":"1000000000000000000000","0x9756e176c9ef693ee1eec6b9f8b151d313beb099":"1200000000000000000000","0x01e6415d587b065490f1ed7f21d6e0f386ee6747":"2000000000000000000000","0xb4413576869c08f9512ad311fe925988a52d3414":"10000000000000000000000","0xda9f55460946d7bfb570ddec757ca5773b58429a":"507600000000000000000","0x7180b83ee5574317f21c8072b191d895d46153c3":"460000000000000000000","0x0aca9a5626913b08cfc9a66d40508dce52b60f87":"1910000000000000000000","0x5cd0e475b54421bdfc0c12ea8e082bd7a5af0a6a":"59000000000000000000","0x7edb02c61a227287611ad950696369cc4e647a68":"274000000000000000000","0xb2676841ee9f2d31c172e82303b0fe9bbf9f1e09":"200000000000000000000","0xa2222259dd9c3e3ded127084f808e92a1887302c":"162000000000000000000","0x4b3a7cc3a7d7b00ed5282221a60259f25bf6538a":"1000000000000000000000","0xe33ff987541dde5cdee0a8a96dcc3f33c3f24cc2":"200000000000000000000000","0x1e1a4828119be309bd88236e4d482b504dc55711":"2955000000000000000000","0x9b1811c3051f46e664ae4bc9c824d18592c4574a":"199955000000000000000","0x59fe00696dbd87b7976b29d1156c8842a2e17914":"2000000000000000000000","0x48010ef3b8e95e3f308f30a8cb7f4eb4bf60d965":"2000000000000000000000","0xc90300cb1d4077e6a6d7e169a460468cf4a492d7":"2000000000000000000000","0x6dedf62e743f4d2c2a4b87a787f5424a7aeb393c":"180000000000000000000","0xfb744b951d094b310262c8f986c860df9ab1de65":"52009000000000000000","0x193ac65183651800e23580f8f0ead3bb597eb8a4":"50020000000000000000","0xbf05ff5ecf0df2df887759fb8274d93238ac267d":"800000000000000000000","0x6c0e712f405c59725fe829e9774bf4df7f4dd965":"57413800000000000000000","0x2744ff67464121e35afc2922177164fa2fcb0267":"100000000000000000000","0xd09cb2e6082d693a13e8d2f68dd1dd8461f55840":"1000000000000000000000","0xbc171e53d17ac9b61241ae436deec7af452e7496":"5348000000000000000000","0x71fa22cc6d33206b7d701a163a0dab31ae4d31d6":"1610000000000000000000","0x4da8030769844bc34186b85cd4c7348849ff49e9":"10000000000000000000000","0xc8616b4ec09128cdff39d6e4b9ac86eec471d5f2":"19400000000000000000","0x407295ebd94b48269c2d569c9b9af9aa05e83e5e":"10000000000000000000000","0xd45d5daa138dd1d374c71b9019916811f4b20a4e":"576000000000000000000","0x42c6edc515d35557808d13cd44dcc4400b2504e4":"197876000000000000000","0x0bc95cb32dbb574c832fa8174a81356d38bc92ac":"2000000000000000000000","0x5a6071bcebfcba4ab57f4db96fc7a68bece2ba5b":"2000000000000000000000","0x54c93e03a9b2e8e4c3672835a9ee76f9615bc14e":"19400000000000000000","0x3c03bbc023e1e93fa3a3a6e428cf0cd8f95e1ec6":"1520000000000000000000","0xba1531fb9e791896bcf3a80558a359f6e7c144bd":"3940000000000000000000","0xaa56a65dc4abb72f11bae32b6fbb07444791d5c9":"748600000000000000000","0xe437acbe0f6227b0e36f36e4bcf7cf613335fb68":"200000000000000000000","0x39d4a931402c0c79c457186f24df8729cf957031":"4000000000000000000000","0xe22b20c77894463baf774cc256d5bddbbf7ddd09":"1000000000000000000000","0x70a4067d448cc25dc8e70e651cea7cf84e92109e":"176000000000000000000","0xaa3925dc220bb4ae2177b2883078b6dc346ca1b2":"8000000000000000000000","0xad57aa9d00d10c439b35efcc0becac2e3955c313":"200000000000000000000","0xe93d47a8ca885d540c4e526f25d5c6f2c108c4b8":"112640000000000000000000","0x232ce782506225fd9860a2edc14a7a3047736da2":"20000000000000000000","0x49a645e0667dfd7b32d075cc2467dd8c680907c4":"129560000000000000000","0xcf2e734042a355d05ffb2e3915b16811f45a695e":"2000000000000000000000","0x39b1c471ae94e12164452e811fbbe2b3cd7275ac":"2000000000000000000000","0xffad3dd74e2c1f796ac640de56dc99b4c792a402":"5000000000000000000000","0xa69d7cd17d4842fe03f62a90b2fbf8f6af7bb380":"100000000000000000000","0x2001bef77b66f51e1599b02fb110194a0099b78d":"2000000000000000000000","0x95e7616424cd0961a71727247437f0069272280e":"400000000000000000000","0xc04f4bd4049f044685b883b62959ae631d667e35":"5820000000000000000000","0xede0147ec032c3618310c1ff25690bf172193dac":"2000000000000000000000","0x66719c0682b2ac7f9e27abebec7edf8decf0ae0d":"20000000000000000000","0x45272b8f62e9f9fa8ce04420e1aea3eba9686eac":"4000000000000000000000","0xd1da0c8fb7c210e0f2ec618f85bdae7d3e734b1c":"1970000000000000000000","0xe9133e7d31845d5f2b66a2618792e869311acf66":"24050000000000000000000","0xebb62cf8e22c884b1b28c6fa88fbbc17938aa787":"798000000000000000000","0x6205c2d5647470848a3840f3887e9b015d34755c":"1800000000000000000000","0x76ca22bcb8799e5327c4aa2a7d0949a1fcce5f29":"1524180000000000000000","0x6b925dd5d8ed6132ab6d0860b82c44e1a51f1fee":"1480000000000000000000","0x797bb7f157d9feaa17f76da4f704b74dc1038341":"3340000000000000000000","0xae8954f8d6166de507cf61297d0fc7ca6b9e7128":"300000000000000000000","0x75c1ad23d23f24b384d0c3149177e86697610d21":"6426082000000000000000","0x805d846fb0bc02a7337226d685be9ee773b9198a":"19999800000000000000000","0xc3cb6b36af443f2c6e258b4a39553a818747811f":"1610000000000000000000","0xcea43f7075816b60bbfce68b993af0881270f6c4":"2000000000000000000000","0xe0388aeddd3fe2ad56f85748e80e710a34b7c92e":"500000000000000000000","0xe131f87efc5ef07e43f0f2f4a747b551d750d9e6":"19999000000000000000000","0xc2b2cbe65bc6c2ee7a3c75b2e47c189c062e8d8b":"20000000000000000000000","0xbd8765f41299c7f479923c4fd18f126d7229047d":"4000000000000000000000","0xc83ba6dd9549be1d3287a5a654d106c34c6b5da2":"7000000000000000000000","0xf870995fe1e522321d754337a45c0c9d7b38951c":"20000000000000000000","0x0d8ed7d0d15638330ed7e4eaccab8a458d75737e":"2000000000000000000000","0x36c510bf8d6e569bf2f37d47265dbcb502ff2bce":"30000000000000000000000","0x0eccf617844fd61fba62cb0e445b7ac68bcc1fbe":"387260000000000000000","0xae10e27a014f0d306baf266d4897c89aeee2e974":"20000000000000000000000","0x1827039f09570294088fddf047165c33e696a492":"9550000000000000000000","0x23378f42926d0184b793b0c827a6dd3e3d334fcd":"56000000000000000000","0x467124ae7f452f26b3d574f6088894fa5d1cfb3b":"2700000000000000000000","0xaae61e43cb0d0c96b30699f77e00d711d0a3979b":"1000000000000000000000","0x15c7edb8118ee27b342285eb5926b47a855bc7a5":"20000000000000000000","0x0d5d98565c647ca5f177a2adb9d3022fac287f21":"200000000000000000000","0x7222fec7711781d26eaa4e8485f7aa3fac442483":"456000000000000000000","0xdc44275b1715baea1b0345735a29ac42c9f51b4f":"1164000000000000000000","0x04d82af9e01a936d97f8f85940b970f9d4db9936":"200000000000000000000","0x45533390e340fe0de3b3cf5fb9fc8ea552e29e62":"1460000000000000000000","0x1284f0cee9d2ff2989b65574d06ffd9ab0f7b805":"400000000000000000000","0xed9ebccba42f9815e78233266dd6e835b6afc31b":"6000000000000000000000","0xe4324912d64ea3aef76b3c2ff9df82c7e13ae991":"2000000000000000000000","0x94c742fd7a8b7906b3bfe4f8904fc0be5c768033":"20000000000000000000000","0x62fb8bd1f0e66b90533e071e6cbe6111fef0bc63":"17600000000000000000000","0x2c83aeb02fcf067d65a47082fd977833ab1cec91":"150400000000000000000","0x06cbfa08cdd4fba737bac407be8224f4eef35828":"593459000000000000000","0x67ee406ea4a7ae6a3a381eb4edd2f09f174b4928":"1036000000000000000000","0x83c23d8a502124ee150f08d71dc6727410a0f901":"33999600000000000000000","0xf7c00cdb1f020310d5acab7b496aaa44b779085e":"1670000000000000000000","0xd096565b7c7407d06536580355fdd6d239144aa1":"250000000000000000000","0xf8d52dcc5f96cc28007b3ecbb409f7e22a646caa":"149200000000000000000","0x0c222c7c41c9b048efcce0a232434362e12d673b":"10007600000000000000000","0x503bdbd8bc421c32a443032deb2e3e4cd5ba8b4e":"2000000000000000000000","0x77da5e6c72fb36bce1d9798f7bcdf1d18f459c2e":"22380000000000000000","0xe62f98650712eb158753d82972b8e99ca3f61877":"2000000000000000000000","0x87a7c508ef71582dd9a54372f89cb01f252fb180":"200000000000000000000","0xf61283b4bd8504058ca360e993999b62cbc8cd67":"255000000000000000000","0x9ccddcb2cfc2b25b08729a0a98d9e6f0202ea2c1":"100000000000000000000","0xd460a4b908dd2b056759b488850b66a838fc77a8":"1970000000000000000000","0x5431b1d18751b98fc9e2888ac7759f1535a2db47":"2000000000000000000000","0xda2a14f9724015d79014ed8e5909681d596148f1":"48499000000000000000","0xc989434f825aaf9c552f685eba7c11db4a5fc73a":"501000000000000000000","0x2b701d16c0d3cc1e4cd85445e6ad02eea4ac012d":"600000000000000000000","0x78b978a9d7e91ee529ea4fc4b76feaf8762f698c":"32000000000000000000000","0xc89cf504b9f3f835181fd8424f5ccbc8e1bddf7d":"10000000000000000000000","0xe94941b6036019b4016a30c1037d5a6903babaad":"780000000000000000000","0x95d98d0c1069908f067a52acac2b8b534da37afd":"2054053000000000000000","0x8284923b62e68bbf7c2b9f3414d13ef6c812a904":"3880000000000000000000","0x3e5a39fdda70df1126ab0dc49a7378311a537a1f":"2400000000000000000000","0xa2ace4c993bb1e5383f8ac74e179066e814f0591":"100000000000000000000","0x0609d83a6ce1ffc9b690f3e9a81e983e8bdc4d9d":"70000000000000000000000","0xd119417c46732cf34d1a1afb79c3e7e2cd8eece4":"2000000000000000000000","0xfdb33944f2360615e5be239577c8a19ba52d9887":"601650000000000000000","0xdd95dbe30f1f1877c5dd7684aeef302ab6885192":"8372000000000000000000","0x413f4b02669ccff6806bc826fcb7deca3b0ea9bc":"20000000000000000000","0x5800cd8130839e94495d2d8415a8ea2c90e0c5cb":"200000000000000000000","0x65053191319e067a25e6361d47f37f6318f83419":"394000000000000000000","0x9bc573bcda23b8b26f9073d90c230e8e71e0270b":"999544000000000000000","0x97f7760657c1e202759086963eb4211c5f8139b9":"49770000000000000000000","0x126897a311a14ad43b78e0920100c4426bfd6bdd":"973581000000000000000","0xd5276f0cd5ffd5ffb63f98b5703d5594ede0838b":"400000000000000000000","0xe9c35c913ca1fceab461582fe1a5815164b4fd21":"8000000000000000000000","0xb43067fe70d9b55973ba58dc64dd7f311e554259":"200000000000000000000","0x6f8f0d15cc96fb7fe94f1065bc6940f8d12957b2":"1000000000000000000000","0xb1dba5250ba9625755246e067967f2ad2f0791de":"80000000000000000000000","0x72b7a03dda14ca9c661a1d469fd33736f673c8e8":"2000000000000000000000","0xe792349ce9f6f14f81d0674096befa1f9221cdea":"1685365000000000000000","0x1815279dff9952da3be8f77249dbe22243377be7":"4749800000000000000000","0x33481e856ebed48ea708a27426ef28e867f57cd1":"200000000000000000000","0x8eb8c71982a00fb84275293253f8044544b66b49":"400000000000000000000","0x65f5870f26bce089677dfc23b5001ee492483428":"5067230000000000000000","0x8e23facd12c765c36ab81a6dd34d8aa9e68918ae":"167310000000000000000","0x4912d902931676ff39fc34fe3c3cc8fb2182fa7a":"20000000000000000000","0xc09a66172aea370d9a63da04ff71ffbbfcff7f94":"2000000000000000000000","0xe969ea1595edc5c4a707cfde380929633251a2b0":"200000000000000000000","0x4f2b47e2775a1fa7178dad92985a5bbe493ba6d6":"200000000000000000000","0xcab9a97ada065c87816e6860a8f1426fe6b3d775":"1000000000000000000000","0xcdfd8217339725d7ebac11a63655f265eff1cc3d":"4999962000000000000000","0xab4004c0403f7eabb0ea586f212156c4203d67f1":"1999944000000000000000","0x1c7cb2fe6bf3e09cbcdc187af38fa8f5053a70b6":"9970823000000000000000","0xa951b244ff50cfae591d5e1a148df6a938ef2a1a":"1734000000000000000000","0xb158db43fa62d30e65f3d09bf781c7b67372ebaa":"1999000000000000000000","0x25e037f00a18270ba5ec3420229ddb0a2ce38fa2":"10000000000000000000000","0x2aaea1f1046f30f109faec1c63ef5c7594eb08da":"4000000000000000000000","0x73d7269ff06c9ffd33754ce588f74a966abbbbba":"6600000000000000000000","0x4c767b65fd91161f4fbdcc6a69e2f6ad711bb918":"720000000000000000000","0x92ae5b7c7eb492ff1ffa16dd42ad9cad40b7f8dc":"865000000000000000000","0xa04f2ae02add14c12faf65cb259022d0830a8e26":"100000000000000000000000","0x63ef2fbc3daf5edaf4a295629ccf31bcdf4038e5":"1460000000000000000000","0x749ad6f2b5706bbe2f689a44c4b640b58e96b992":"100000000000000000000","0x4d836d9d3b0e2cbd4de050596faa490cffb60d5d":"300000000000000000000","0x59f6247b0d582aaa25e5114765e4bf3c774f43c2":"50000000000000000000","0x1293c78c7d6a443b9d74b0ba5ee7bb47fd418588":"6685000000000000000000","0x67bc85e87dc34c4e80aafa066ba8d29dbb8e438e":"402500000000000000000","0xa09f4d5eaa65a2f4cb750a49923401dae59090af":"140000000000000000000","0xebbd4db9019952d68b1b0f6d8cf0683c00387bb5":"332330000000000000000","0xb16479ba8e7df8f63e1b95d149cd8529d735c2da":"846477000000000000000","0xe1b2aca154b8e0766c4eba30bc10c7f35036f368":"19980000000000000000","0x5c464197791c8a3da3c925436f277ab13bf2faa2":"8000000000000000000000","0x170a88a8997f92d238370f1affdee6347050b013":"3000800000000000000000","0xdadbfafd8b62b92a24efd75256dd83abdbd7bbdb":"19700000000000000000","0xbb993b96ee925ada7d99d786573d3f89180ce3aa":"2000000000000000000000","0xf2c362b0ef991bc82fb36e66ff75932ae8dd8225":"74000000000000000000","0x7f2382ffd8f83956467937f9ba72374623f11b38":"600000000000000000000","0x74d1a4d0c7524e018d4e06ed3b648092b5b6af2c":"50000000000000000000","0x24a750eae5874711116dd7d47b7186ce990d3103":"200000000000000000000","0xa8e42a4e33d7526cca19d9a36dcd6e8040d0ea73":"1080000000000000000000","0x3e1b2230afbbd310b4926a4c776d5ae7819c661d":"30000000000000000000000","0x6af9f0dfeeaebb5f64bf91ab771669bf05295553":"400000000000000000000","0x41e4a20275e39bdcefeb655c0322744b765140c2":"10000000000000000000000","0xceb089ec8a78337e8ef88de11b49e3dd910f748f":"1000000000000000000000","0xe6bcd30a8fa138c5d9e5f6c7d2da806992812dcd":"260000000000000000000000","0xe08c60313106e3f9334fe6f7e7624d211130c077":"40000000000000000000","0xf5cffbba624e7eb321bc83c60ca68199b4e36671":"2000000000000000000000","0xd7c2803ed7b0e0837351411a8e6637d168bc5b05":"29549015000000000000000","0x0f3665d48e9f1419cd984fc7fa92788710c8f2e4":"2000000000000000000000","0xb48921c9687d5510744584936e8886bdbf2df69b":"1000000000000000000000","0xa94bbb8214cf8da0c2f668a2ac73e86248528d4b":"960000000000000000000","0xbe0c2a80b9de084b172894a76cf4737a4f529e1a":"1999944000000000000000","0xfcf199f8b854222f182e4e1d099d4e323e2aae01":"1000000000000000000000","0xb52dfb45de5d74e3df208332bc571c809b8dcf32":"6000000000000000000000","0x704819d2e44d6ed1da25bfce84c49fcca25613e5":"400000000000000000000","0x6ff6cc90d649de4e96cffee1077a5b302a848dcb":"28600000000000000000","0x4d9c77d0750c5e6fbc247f2fd79274686cb353d6":"20000000000000000000","0x68e8022740f4af29eb48db32bcecddfd148d3de3":"1000000000000000000000","0x2cb615073a40dcdb99faa848572e987b3b056efb":"799600000000000000000","0x64adcceec53dd9d9dd15c8cc1a9e736de4241d2c":"56000000000000000000","0x2aec809df9325b9f483996e99f7331097f08aa0e":"4000000000000000000000","0x438c2f54ff8e629bab36b1442b760b12a88f02ae":"2000000000000000000000","0x9e35399071a4a101e9194daa3f09f04a0b5f9870":"4000000000000000000000","0xa5c336083b04f9471b8c6ed73679b74d66c363ec":"3014100000000000000000","0x7ad3f307616f19dcb143e6444dab9c3c33611f52":"50000000000000000000","0x455cb8ee39ffbc752331e5aefc588ef0ee593454":"999963000000000000000","0xc4c01afc3e0f045221da1284d7878574442fb9ac":"7419944000000000000000","0x99268327c373332e06c3f6164287d455b9d5fa4b":"2000000000000000000000","0x4367ae4b0ce964f4a54afd4b5c368496db169e9a":"2000000000000000000000","0x2cd79eb52027b12c18828e3eaab2969bfcd287e9":"20000000000000000000","0xb96841cabbc7dbd69ef0cf8f81dff3c8a5e21570":"12000000000000000000000","0xd7ebddb9f93987779b680155375438db65afcb6a":"100600000000000000000","0x0631d18bbbbd30d9e1732bf36edae2ce8901ab80":"3024800000000000000000","0x5fad960f6b2c84569c9f4d47bf1985fcb2c65da6":"999972000000000000000","0x01d599ee0d5f8c38ab2d392e2c65b74c3ce31820":"510000000000000000000","0xff0cc8dac824fa24fc3caa2169e6e057cf638ad6":"4000000000000000000000","0xc25266c7676632f13ef29be455ed948add567792":"1337000000000000000000","0x9c344098ba615a398f11d009905b177c44a7b602":"1000000000000000000000","0x3b0accaf4b607cfe61d17334c214b75cdefdbd89":"2000000000000000000000","0x6d6634b5b8a40195d949027af4828802092ceeb6":"3000000000000000000000","0x208c45732c0a378f17ac8324926d459ba8b658b4":"2955000000000000000000","0xc24399b4bf86f7338fbf645e3b22b0e0b7973912":"2000000000000000000000","0x29763dd6da9a7c161173888321eba6b63c8fb845":"328000000000000000000","0x9c2fd54089af665df5971d73b804616039647375":"1000000000000000000000","0x0e09646c99af438e99fa274cb2f9c856cb65f736":"1910000000000000000000","0xbe73274d8c5aa44a3cbefc8263c37ba121b20ad3":"500000000000000000000","0xecfd004d02f36cd4d8b4a8c1a9533b6af85cd716":"5003800000000000000000","0xf978b025b64233555cc3c19ada7f4199c9348bf7":"400000000000000000000000","0x705ddd38355482b8c7d3b515bda1500dd7d7a817":"400000000000000000000","0x2b8a0dee5cb0e1e97e15cfca6e19ad21f995efad":"504206000000000000000","0x1098cc20ef84bad5146639c4cd1ca6c3996cb99b":"18200000000000000000","0xafdac5c1cb56e245bf70330066a817eaafac4cd1":"20000000000000000000","0x910e996543344c6815fb97cda7af4b8698765a5b":"103400000000000000000","0x94612781033b57b146ee74e753c672017f5385e4":"3600000000000000000000","0xd03fc165576aaed525e5502c8e140f8b2e869639":"6850000000000000000000","0x293384c42b6f8f2905ce52b7205c2274376c612b":"1400000000000000000000","0x09ee12b1b42b05af9cf207d5fcac255b2ec411f2":"58929000000000000000","0xdbd71efa4b93c889e76593de609c3b04cbafbe08":"20000000000000000000","0xfa86ca27bf2854d98870837fb6f6dfe4bf6453fc":"322061000000000000000","0x61ff8e67b34d9ee6f78eb36ffea1b9f7c15787af":"1640000000000000000000","0x6d4cbf3d8284833ae99344303e08b4d614bfda3b":"12000000000000000000000","0x2ff160c44f72a299b5ec2d71e28ce5446d2fcbaf":"360000000000000000000","0x94a7cda8f481f9d89d42c303ae1632b3b709db1d":"300000000000000000000","0x7566496162ba584377be040a4f87777a707acaeb":"4000000000000000000000","0xbdc461462b6322b462bdb33f22799e8108e2417d":"668500000000000000000","0x7e47637e97c14622882be057bea229386f4052e5":"440000000000000000000","0x3b5c251d7fd7893ba209fe541cecd0ce253a990d":"30000000000000000000000","0x0e498800447177b8c8afc3fdfa7f69f4051bb629":"2140234000000000000000","0xb71623f35107cf7431a83fb3d204b29ee0b1a7f4":"19700000000000000000","0x1d395b30adda1cf21f091a4f4a7b753371189441":"100000000000000000000000","0x2c2428e4a66974edc822d5dbfb241b2728075158":"2000000000000000000000","0xa575f2891dcfcda83c5cf01474af11ee01b72dc2":"100076000000000000000","0xad728121873f0456d0518b80ab6580a203706595":"500000000000000000000","0x48669eb5a801d8b75fb6aa58c3451b7058c243bf":"30940000000000000000000","0xb3ae54fba09d3ee1d6bdd1e957923919024c35fa":"65513000000000000000","0x0d35408f226566116fb8acdaa9e2c9d59b76683f":"940000000000000000000","0xdf211cd21288d6c56fae66c3ff54625dd4b15427":"2500024000000000000000","0x8a746c5d67064711bfca685b95a4fe291a27028e":"40000000000000000000","0x1cf105ab23023b554c583e86d7921179ee83169f":"1970000000000000000000","0x8cfedef198db0a9143f09129b3fd64dcbb9b4956":"2000000000000000000000","0x1e381adcf801a3bf9fd7bfac9ccc2b8482ad5e66":"600200000000000000000","0xe74608f506866ada6bfbfdf20fea440be76989ef":"1999944000000000000000","0x27e63989ca1e903bc620cf1b9c3f67b9e2ae6581":"1337000000000000000000","0xbb0857f1c911b24b86c8a70681473fe6aaa1cce2":"100000000000000000000","0x4f8e8d274fb22a3fd36a47fe72980471544b3434":"200000000000000000000","0x127d3fc5003bf63c0d83e93957836515fd279045":"111890000000000000000","0x95809e8da3fbe4b7f281f0b8b1715f420f7d7d63":"2000000000000000000000","0x28904bb7c4302943b709b14d7970e42b8324e1a1":"10027500000000000000000","0xc07e3867ada096807a051a6c9c34cc3b3f4ad34a":"1788210000000000000000","0xf0b469eae89d400ce7d5d66a9695037036b88903":"20000000000000000000000","0x7445202f0c74297a004eb3726aa6a82dd7c02fa1":"2000000000000000000000","0xc58f62fee9711e6a05dc0910b618420aa127f288":"3980000000000000000000","0x801d65c518b11d0e3f4f470221417013c8e53ec5":"4000000000000000000000","0x41010fc8baf8437d17a04369809a168a17ca56fb":"100000000000000000000","0xa1998144968a5c70a6415554cefec2824690c4a5":"20000000000000000000","0xe9559185f166fc9513cc71116144ce2deb0f1d4b":"20000000000000000000000","0xed5b4c41e762d942404373caf21ed4615d25e6c1":"2013960000000000000000","0x665b000f0b772750cc3c217a5ef429a92bf1ccbb":"4000000000000000000000","0xfebd9f81cf78bd5fb6c4b9a24bd414bb9bfa4c4e":"1990019000000000000000","0xa072691c8dd7cd4237ff72a75c1a9506d0ce5b9e":"370000000000000000000","0x6765df25280e8e4f38d4b1cf446fc5d7eb659e34":"100000000000000000000","0x524fb210522c5e23bb67dfbf8c26aa616da49955":"999971000000000000000","0xe987e6139e6146a717fef96bc24934a5447fe05d":"2000000000000000000000","0xd6110276cfe31e42825a577f6b435dbcc10cf764":"1000000000000000000000","0x5e51b8a3bb09d303ea7c86051582fd600fb3dc1a":"20000000000000000000","0x5c4f24e994ed8f850ea7818f471c8fac3bcf0452":"1724800000000000000000","0x85b2998d0c73302cb2ba13f489313301e053be15":"10000000000000000000000","0x0af6c8d539c96d50259e1ba6719e9c8060f388c2":"1000000000000000000000","0x7d901b28bf7f88ef73d8f73cca97564913ea8a24":"955000000000000000000","0xe01859f242f1a0ec602fa8a3b0b57640ec89075e":"555000000000000000000","0xc66ae4cee87fb3353219f77f1d6486c580280332":"29550000000000000000","0x2d40558b06f90a3923145592123b6774e46e31f4":"1000000000000000000000","0xccf43975b76bfe735fec3cb7d4dd24f805ba0962":"60000000000000000000","0x1703b4b292b8a9deddede81bb25d89179f6446b6":"19690000000000000000000","0x0e9096d343c060db581a120112b278607ec6e52b":"20000000000000000000","0xf65819ac4cc14c137f05dd7977c7dae08d1a4ab5":"102000000000000000000","0xca373fe3c906b8c6559ee49ccd07f37cd4fb5266":"1790000000000000000000","0xd28298524df5ec4b24b0ffb9df85170a145a9eb5":"287700000000000000000","0x5fcda847aaf8d7fa8bca08029ca2849166aa15a3":"623350000000000000000","0xbdc739a699700b2e8e2c4a4c7b058a0e513ddebe":"2000000000000000000000","0x0bb05f7224bb5804856556c07eeadbed87ba8f7c":"401100000000000000000","0xab416fe30d58afe5d9454c7fce7f830bcc750356":"114515000000000000000","0x3eee6f1e96360b7689b3069adaf9af8eb60ce481":"1000000000000000000000","0x9a0d3cee3d9892ea3b3700a27ff84140d9025493":"60000000000000000000","0x5dc36de5359450a1ec09cb0c44cf2bb42b3ae435":"1117500000000000000000","0x35c8adc11125432b3b77acd64625fe58ebee9d66":"2000000000000000000000","0xa5e9cd4b74255d22b7d9b27ae8dd43ed6ed0252b":"766527000000000000000","0x31ea12d49a35a740780ddeeaece84c0835b26270":"200000000000000000000","0x7aef7b551f0b9c46e755c0f38e5b3a73fe1199f5":"1490000000000000000000","0xcc6d7b12061bc96d104d606d65ffa32b0036eb07":"10000000000000000000000","0x322021022678a0166d204b3aaa7ad4ec4b88b7d0":"400000000000000000000","0xb31196714a48dff726ea9433cd2912f1a414b3b3":"2680000000000000000000","0x0f2fb884c8aaff6f543ac6228bd08e4f60b0a5fd":"3145000000000000000000","0x7d9d221a3df89ddd7b5f61c1468c6787d6b333e6":"138000000000000000000","0x367f59cc82795329384e41e1283115e791f26a01":"2000000000000000000000","0xfd9579f119bbc819a02b61e38d8803c942f24d32":"105600000000000000000","0x3e2f26235e137a7324e4dc154b5df5af46ea1a49":"22458000000000000000","0x4c1579af3312e4f88ae93c68e9449c2e9a68d9c4":"2000000000000000000000","0xffb04726dfa41afdc819168418610472970d7bfc":"4000000000000000000000","0x403c64896a75cad816a9105e18d8aa5bf80f238e":"985000000000000000000","0x5cd588a14ec648ccf64729f9167aa7bf8be6eb3d":"1000000000000000000000","0x24b2be118b16d8b2174769d17b4cf84f07ca946d":"2000000000000000000000","0xd3bb59fa31258be62f8ed232f1a7d47b4a0b41ee":"100000000000000000000","0xcc9ac715cd6f2610c52b58676456884297018b29":"13370000000000000000","0x6f2a31900e240395b19f159c1d00dfe4d898ebdf":"1999600000000000000000","0xd60b247321a32a5affb96b1e279927cc584de943":"2265500000000000000000","0xf7a1ade2d0f529123d1055f19b17919f56214e67":"500000000000000000000","0xbea00df17067a43a82bc1daecafb6c14300e89e6":"1820000000000000000000","0xa2968fc1c64bac0b7ae0d68ba949874d6db253f4":"20000000000000000000000","0x92d8ad9a4d61683b80d4a6672e84c20d62421e80":"20000000000000000000","0x6ed2a12b02f8c688c7b5d3a6ea14d63687dab3b6":"2000000000000000000000","0x7a63869fc767a4c6b1cd0e0649f3634cb121d24b":"77500000000000000000","0x84f522f0520eba52dd18ad21fa4b829f2b89cb97":"4949566000000000000000","0xd6234aaf45c6f22e66a225ffb93add629b4ef80f":"1000000000000000000000","0xe3d8bf4efe84b1616d1b89e427ddc6c8830685ae":"2000000000000000000000","0xa3db364a332d884ba93b2617ae4d85a1489bea47":"1700000000000000000000","0x9f7986924aeb02687cd64189189fb167ded2dd5c":"985000000000000000000","0x2eaf4e2a46b789ccc288c8d1d9294e3fb0853896":"2000000000000000000000","0xa02dc6aa328b880de99eac546823fccf774047fb":"1970000000000000000000","0x873b7f786d3c99ff012c4a7cae2677270240b9c5":"1730000000000000000000","0x1d69c83d28ff0474ceebeacb3ad227a144ece7a3":"5474937000000000000000","0x7b827cae7ff4740918f2e030ab26cb98c4f46cf5":"7460000000000000000000","0x3083ef0ed4c4401196774a95cf4edc83edc1484f":"170000000000000000000000","0x40ad74bc0bce2a45e52f36c3debb1b3ada1b7619":"6790000000000000000000","0x05423a54c8d0f9707e704173d923b946edc8e700":"127543000000000000000","0x22eb7db0ba56b0f8b816ccb206e615d929185b0d":"80500000000000000000","0x66082c75a8de31a53913bbd44de3a0374f7faa41":"1460000000000000000000","0xe3d3eaa299887865569e88be219be507189be1c9":"456156000000000000000","0xae57cc129a96a89981dac60d2ffb877d5dc5e432":"1110994000000000000000","0x1a2434cc774422d48d53d59c5d562cce8407c94b":"30000000000000000000","0x21546914dfd3af2add41b0ff3e83ffda7414e1e0":"5969100000000000000000","0x4dcf62a3de3f061db91498fd61060f1f6398ff73":"1999944000000000000000","0x6fd98e563d12ce0fd60f4f1f850ae396a9823c02":"1261000000000000000000","0xedf8a3e1d40f13b79ec8e3e1ecf262fd92116263":"158000000000000000000","0xc09e3cfc19f605ff3ec9c9c70e2540d7ee974366":"500000000000000000000","0x953572f0ea6df9b197cae40e4b8ecc056c4371c5":"1000000000000000000000","0x163cc8be227646cb09719159f28ed09c5dc0dce0":"1337000000000000000000","0xa3932a31d6ff75fb3b1271ace7caa7d5e1ff1051":"20000000000000000000000","0xf9a94bd56198da245ed01d1e6430b24b2708dcc0":"749938000000000000000","0x3eb8b33b21d23cda86d8288884ab470e164691b5":"500000000000000000000","0x84bcbf22c09607ac84341d2edbc03bfb1739d744":"500000000000000000000","0x961c59adc74505d1864d1ecfcb8afa0412593c93":"40000000000000000000000","0xf068dfe95d15cd3a7f98ffa688b4346842be2690":"1255160000000000000000","0x291efe0081dce8c14799f7b2a43619c0c3b3fc1f":"1200000000000000000000","0xbe4fd073617022b67f5c13499b827f763639e4e3":"2000000000000000000000","0xe40a7c82e157540a0b00901dbb86c716e1a062da":"49800000000000000000","0x6635b46f711d2da6f0e16370cd8ee43efb2c2d52":"2000000000000000000000","0x43748928e8c3ec4436a1d092fbe43ac749be1251":"400000000000000000000","0xb557ab9439ef50d237b553f02508364a466a5c03":"200000000000000000000","0x11928378d27d55c520ceedf24ceb1e822d890df0":"8000000000000000000000","0x61518464fdd8b73c1bb6ac6db600654938dbf17a":"200000000000000000000","0x004bfbe1546bc6c65b5c7eaa55304b38bbfec6d3":"2000000000000000000000","0xa5e0fc3c3affed3db6710947d1d6fb017f3e276d":"2000000000000000000000","0x8ecbcfacbfafe9f00c3922a24e2cf0026756ca20":"5640000000000000000000","0xfb5ffaa0f7615726357891475818939d2037cf96":"20000000000000000000","0xae222865799079aaf4f0674a0cdaab02a6d570ff":"2000000000000000000000","0x9edc90f4be210865214ab5b35e5a8dd77415279d":"4000000000000000000000","0x9d7831e834c20b1baa697af1d8e0c621c5afff9a":"86500000000000000000","0x046d274b1af615fb505a764ad8dda770b1db2f3d":"2000000000000000000000","0xeaea23aa057200e7c9c15e8ff190d0e66c0c0e83":"2000000000000000000000","0x417a3cd19496530a6d4204c3b5a17ce0f207b1a5":"8000000000000000000000","0xa035a3652478f82dbd6d115faa8ca946ec9e681d":"109880000000000000000","0x4f5801b1eb30b712d8a0575a9a71ff965d4f34eb":"300000000000000000000","0x91dbb6aaad149585be47375c5d6de5ff09191518":"20000000000000000000000","0xd043a011ec4270ee7ec8b968737515e503f83028":"500000000000000000000","0xbb371c72c9f0316cea2bd9c6fbb4079e775429ef":"1760000000000000000000","0xaa1df92e51dff70b1973e0e924c66287b494a178":"534400000000000000000","0xbd5f46caab2c3d4b289396bbb07f203c4da82530":"80000000000000000000","0x4d29fc523a2c1629532121da9998e9b5ab9d1b45":"15800000000000000000","0xaddb26317227f45c87a2cb90dc4cfd02fb23caf8":"1000000000000000000000","0x52e46783329a769301b175009d346768f4c87ee4":"2000000000000000000000","0xcaad9dc20d589ce428d8fda3a9d53a607b7988b5":"4000000000000000000000","0x95034e1621865137cd4739b346dc17da3a27c34e":"1580000000000000000000","0x0c3239e2e841242db989a61518c22247e8c55208":"263656000000000000000","0x5a0d609aae2332b137ab3b2f26615a808f37e433":"160000000000000000000000","0x2334c590c7a48769103045c5b6534c8a3469f44a":"17443200000000000000000","0xddfcca13f934f0cfbe231da13039d70475e6a1d0":"1000169000000000000000","0xee7288d91086d9e2eb910014d9ab90a02d78c2a0":"2000000000000000000000","0xfb91fb1a695553f0c68e21276decf0b83909b86d":"100016000000000000000","0x38695fc7e1367ceb163ebb053751f9f68ddb07a0":"2000000000000000000000","0x65093b239bbfba23c7775ca7da5a8648a9f54cf7":"400000000000000000000","0x73d8fee3cb864dce22bb26ca9c2f086d5e95e63b":"1000000000000000000000","0xf7155213449892744bc60f2e04400788bd041fdd":"66850000000000000000","0xd1a71b2d0858e83270085d95a3b1549650035e23":"14900000000000000000000","0xeac17b81ed5191fb0802aa54337313834107aaa4":"8000000000000000000000","0xbb076aac92208069ea318a31ff8eeb14b7e996e3":"149000000000000000000","0x9f46e7c1e9078cae86305ac7060b01467d6685ee":"668500000000000000000","0x1598127982f2f8ad3b6b8fc3cf27bf617801ba2b":"173000000000000000000","0xe91dac0195b19e37b59b53f7c017c0b2395ba44c":"1880000000000000000000","0xa436c75453ccca4a1f1b62e5c4a30d86dde4be68":"2000000000000000000000","0x11001b89ed873e3aaec1155634b4681643986323":"1000000000000000000000","0xab93b26ece0a0aa21365afed1fa9aea31cd54468":"1608000000000000000000","0xe77febabdf080f0f5dca1d3f5766f2a79c0ffa7c":"1386000000000000000000","0x1c4af0e863d2656c8635bc6ffec8dd9928908cb5":"2000000000000000000000","0x0c48ae62d1539788eba013d75ea60b64eeba4e80":"2213311000000000000000","0x423cc4594cf4abb6368de59fd2b1230734612143":"2000000000000000000000","0x7f6b28c88421e4857e459281d78461692489d3fb":"2000000000000000000000","0x806854588ecce541495f81c28a290373df0274b2":"582000000000000000000","0xdc76e85ba50b9b31ec1e2620bce6e7c8058c0eaf":"20000000000000000000","0xb00996b0566ecb3e7243b8227988dcb352c21899":"12000000000000000000000","0xf5d14552b1dce0d6dc1f320da6ffc8a331cd6f0c":"1337000000000000000000","0x55a61b109480b5b2c4fcfdef92d90584160c0d35":"44700000000000000000","0xb8947822d5ace7a6ad8326e95496221e0be6b73d":"20000000000000000000","0x492de46aaf8f1d708d59d79af1d03ad2cb60902f":"2000000000000000000000","0x0e0d6633db1e0c7f234a6df163a10e0ab39c200f":"200000000000000000000","0xf8bf9c04874e5a77f38f4c38527e80c676f7b887":"2000000000000000000000","0x15528350e0d9670a2ea27f7b4a33b9c0f9621d21":"4000086000000000000000","0xeccf7a0457b566b346ca673a180f444130216ac3":"100000000000000000000","0x10cf560964ff83c1c9674c783c0f73fcd89943fc":"40000000000000000000000","0xe7f06f699be31c440b43b4db0501ec0e25261644":"500000000000000000000","0xb6ce4dc560fc73dc69fb7a62e388db7e72ea764f":"966000000000000000000","0xf456055a11ab91ff668e2ec922961f2a23e3db25":"18200000000000000000","0x8dfbafbc0e5b5c86cd1ad697feea04f43188de96":"390060000000000000000","0x085b4ab75d8362d914435cedee1daa2b1ee1a23b":"3880000000000000000000","0xe400d651bb3f2d23d5f849e6f92d9c5795c43a8a":"2674000000000000000000","0x851aa91c82f42fad5dd8e8bb5ea69c8f3a5977d1":"148607000000000000000","0x4c935bb250778b3c4c7f7e07fc251fa630314aab":"1500000000000000000000","0xebd356156a383123343d48843bffed6103e866b3":"1970000000000000000000","0xda0b48e489d302b4b7bf204f957c1c9be383b0df":"2000000000000000000000","0x7085ae7e7e4d932197b5c7858c00a3674626b7a5":"6000000000000000000000","0x5b06d1e6930c1054692b79e3dbe6ecce53966420":"205400000000000000000","0x8df53d96191471e059de51c718b983e4a51d2afd":"32000000000000000000000","0x0678654ac6761db904a2f7e8595ec1eaac734308":"878000000000000000000","0x89fee30d1728d96cecc1dab3da2e771afbcfaa41":"1999944000000000000000","0x59c5d06b170ee4d26eb0a0eb46cb7d90c1c91019":"10000000000000000000000","0x2b129c26b75dde127f8320bd0f63410c92a9f876":"2200000000000000000000","0x3d6ae053fcbc318d6fd0fbc353b8bf542e680d27":"14300000000000000000","0x755a60bf522fbd8fff9723446b7e343a7068567e":"20000000000000000000000","0x947e11e5ea290d6fc3b38048979e0cd44ec7c17f":"2000000000000000000000","0x711ecf77d71b3d0ea95ce4758afecdb9c131079d":"760000000000000000000","0xde9eff4c798811d968dccb460d9b069cf30278e0":"400000000000000000000","0x4e892e8081bf36e488fddb3b2630f3f1e8da30d2":"12003800000000000000000","0x8ede7e3dc50749c6c50e2e28168478c34db81946":"19999800000000000000000","0x0c30cacc3f72269f8b4f04cf073d2b05a83d9ad1":"2001000000000000000000","0xe51eb87e7fb7311f5228c479b48ec9878831ac4c":"2000000000000000000000","0x8b01da34d470c1d115acf4d8113c4dd8a8c338e4":"25220000000000000000000","0x4329fc0931cbeb033880fe4c9398ca45b0e2d11a":"2000400000000000000000","0x540c072802014ef0d561345aec481e8e11cb3570":"8000000000000000000000","0x21e5d2bae995ccfd08a5c16bb524e1f630448f82":"2800000000000000000000","0x5cf8c03eb3e872e50f7cfd0c2f8d3b3f2cb5183a":"200000000000000000000","0x5c0f2e51378f6b0d7bab617331580b6e39ad3ca5":"9600000000000000000000","0xd2f241255dd7c3f73c07043071ec08ddd9c5cde5":"500000000000000000000","0xcbe1b948864d8474e765145858fca4550f784b92":"10000000000000000000000","0x30742ccdf4abbcd005681f8159345c9e79054b1a":"668500000000000000000","0x6aeb9f74742ea491813dbbf0d6fcde1a131d4db3":"440800000000000000000","0x821eb90994a2fbf94bdc3233910296f76f9bf6e7":"10000000000000000000000","0x25c1a37ee5f08265a1e10d3d90d5472955f97806":"1820000000000000000000","0x7ef98b52bee953bef992f305fda027f8911c5851":"514717000000000000000","0x8adc53ef8c18ed3051785d88e996f3e4b20ecd51":"42000000000000000000000","0x007f4a23ca00cd043d25c2888c1aa5688f81a344":"773658000000000000000","0x4a735d224792376d331367c093d31c8794341582":"1900000000000000000000","0x05440c5b073b529b4829209dff88090e07c4f6f5":"1288000000000000000000","0x5e772e27f28800c50dda973bb33e10762e6eea20":"1790000000000000000000","0xa429fa88731fdd350e8ecd6ea54296b6484fe695":"1969606000000000000000","0xe0d76b7166b1f3a12b4091ee2b29de8caa7d07db":"2000000000000000000000","0x7ebd95e9c470f7283583dc6e9d2c4dce0bea8f84":"14000000000000000000000","0x883a78aeabaa50d8ddd8570bcd34265f14b19363":"3879951000000000000000","0x51f9c432a4e59ac86282d6adab4c2eb8919160eb":"530000000000000000000000","0xb86607021b62d340cf2652f3f95fd2dc67698bdf":"5000000000000000000000","0xacc0909fda2ea6b7b7a88db7a0aac868091ddbf6":"22155000000000000000","0x69b80ed90f84834afa3ff82eb964703b560977d6":"26740000000000000000","0xca4ca9e4779d530ecbacd47e6a8058cfde65d98f":"800000000000000000000","0x5d6c5c720d66a6abca8397142e63d26818eaab54":"40000000000000000000","0xc2c13e72d268e7150dc799e7c6cf03c88954ced7":"700000000000000000000","0x6bbd1e719390e6b91043f8b6b9df898ea8001b34":"2000053000000000000000","0xa9ba6f413b82fcddf3affbbdd09287dcf50415ca":"4000000000000000000000","0xced3c7be8de7585140952aeb501dc1f876ecafb0":"4000000000000000000000","0x1c63fa9e2cbbf23c49fcdef1cbabfe6e0d1e14c1":"1000000000000000000000","0x7d6e990daa7105de2526339833f77b5c0b85d84f":"20000000000000000000000","0x68addf019d6b9cab70acb13f0b3117999f062e12":"49941000000000000000","0xa77428bcb2a0db76fc8ef1e20e461a0a32c5ac15":"401100000000000000000","0x26048fe84d9b010a62e731627e49bc2eb73f408f":"4000000000000000000000","0xff26138330274df4e0a3081e6df7dd983ec6e78f":"2000000000000000000000","0xb7382d37db0398ac72410cf9813de9f8e1ec8dad":"1000070000000000000000","0x44f62f2aaabc29ad3a6b04e1ff6f9ce452d1c140":"17000000000000000000000","0x47fef58584465248a0810d60463ee93e5a6ee8d3":"283100000000000000000","0xbd2b70fecc37640f69514fc7f3404946aad86b11":"1200000000000000000000","0x649a85b93653075fa6562c409a565d087ba3e1ba":"2000000000000000000000","0x55866486ec168f79dbe0e1abb18864d98991ae2c":"16100000000000000000","0xd7e74afdbad55e96cebc5a374f2c8b768680f2b0":"99000000000000000000","0xa8c1d6aa41fe3d65f67bd01de2a866ed1ed9ae52":"30000000000000000000","0x744c0c77ba7f236920d1e434de5da33e48ebf02c":"1970000000000000000000","0x9445ba5c30e98961b8602461d0385d40fbd80311":"10000000000000000000000","0xeb835c1a911817878a33d167569ea3cdd387f328":"1000000000000000000000","0x761a6e362c97fbbd7c5977acba2da74687365f49":"183840000000000000000","0x38202c5cd7078d4f887673ab07109ad8ada89720":"1000000000000000000000","0x5abfec25f74cd88437631a7731906932776356f9":"11901484239480000000000000","0x28e4af30cd93f686a122ad7bb19f8a8785eee342":"2101000000000000000000","0x3a9b111029ce1f20c9109c7a74eeeef34f4f2eb2":"4000000000000000000000","0x7bb9571f394b0b1a8eba5664e9d8b5e840677bea":"19700000000000000000","0x50fb36c27107ee2ca9a3236e2746cca19ace6b49":"2000000000000000000000","0xa3bc979b7080092fa1f92f6e0fb347e28d995045":"2800000000000000000000","0xd04b861b3d9acc563a901689941ab1e1861161a2":"20000000000000000000","0x58c555bc293cdb16c6362ed97ae9550b92ea180e":"20000000000000000000","0x8bf02bd748690e1fd1c76d270833048b66b25fd3":"11800000000000000000000","0xfbc01db54e47cdc3c438694ab717a856c23fe6e9":"8456774000000000000000","0x9c9a07a8e57c3172a919ef64789474490f0d9f51":"10000000000000000000000","0xfc7e22a503ec5abe9b08c50bd14999f520fa4884":"6387725000000000000000","0x9b773669e87d76018c090f8255e54409b9dca8b2":"20000000000000000000","0xffe8cbc1681e5e9db74a0f93f8ed25897519120f":"1507000000000000000000","0x4d4cf5807429615e30cdface1e5aae4dad3055e6":"600000000000000000000","0xcfde0fc75d6f16c443c3038217372d99f5d907f7":"2419000000000000000000","0x818ffe271fc3973565c303f213f6d2da89897ebd":"5734655000000000000000","0xba1fcaf223937ef89e85675503bdb7ca6a928b78":"640000000000000000000","0xa30a45520e5206d9004070e6af3e7bb2e8dd5313":"400000000000000000000","0xa747439ad0d393b5a03861d77296326de8bb9db9":"1000000000000000000000","0x14d00aad39a0a7d19ca05350f7b03727f08dd82e":"500000000000000000000","0x551999ddd205563327b9b530785acff9bc73a4ba":"6000000000000000000000","0xa4670731175893bbcff4fa85ce97d94fc51c4ba8":"8000000000000000000000","0xf858171a04d357a13b4941c16e7e55ddd4941329":"41984000000000000000","0xa6484cc684c4c91db53eb68a4da45a6a6bda3067":"6000000000000000000000","0x00d75ed60c774f8b3a5a5173fb1833ad7105a2d9":"2005500000000000000000","0xbf92418a0c6c31244d220260cb3e867dd7b4ef49":"99800000000000000000","0x716d50cca01e938500e6421cc070c3507c67d387":"2000000000000000000000","0x82a8b96b6c9e13ebec1e9f18ac02a60ea88a48ff":"1999998000000000000000","0x5a565285374a49eedd504c957d510874d00455bc":"100000000000000000000","0x778c79f4de1953ebce98fe8006d53a81fb514012":"999800000000000000000","0x41b2d34fde0b1029262b4172c81c1590405b03ae":"1000000000000000000000","0x4039bd50a2bde15ffe37191f410390962a2b8886":"200000000000000000000","0xc033be10cb48613bd5ebcb33ed4902f38b583003":"3000000000000000000000","0x5d5751819b4f3d26ed0c1ac571552735271dbefa":"1000000000000000000000","0xb600429752f399c80d0734744bae0a022eca67c6":"20000000000000000000","0xf875619d8a23e45d8998d184d480c0748970822a":"4000000000000000000000","0x71c7230a1d35bdd6819ed4b9a88e94a0eb0786dd":"4365000000000000000000","0xb2f9c972c1e9737755b3ff1b3088738396395b26":"20000000000000000000000","0xa66a4963b27f1ee1932b172be5964e0d3ae54b51":"173000000000000000000","0x53ce88e66c5af2f29bbd8f592a56a3d15f206c32":"140840000000000000000","0x433e3ba1c51b810fc467d5ba4dea42f7a9885e69":"40000000000000000000000","0xc7837ad0a0bf14186937ace06c5546a36aa54f46":"4000000000000000000000","0xc3f8f67295a5cd049364d05d23502623a3e52e84":"6000000000000000000000","0x3fd0bb47798cf44cdfbe4d333de637df4a00e45c":"100040000000000000000","0xa1ae8d4540d4db6fdde7146f415b431eb55c7983":"197000000000000000000","0x5cccf1508bfd35c20530aa642500c10dee65eaed":"850000000000000000000","0xa53ead54f7850af21438cbe07af686279a315b86":"10000000000000000000000","0x8cf6da0204dbc4860b46ad973fc111008d9e0c46":"200000000000000000000","0x8e7936d592008fdc7aa04edeeb755ab513dbb89d":"20000000000000000000","0x4a53dcdb56ce4cdce9f82ec0eb13d67352e7c88b":"4200000000000000000000","0x2b4f4507bb6b9817942ce433781b708fbcd166fd":"18200000000000000000","0x026432af37dc5113f1f46d480a4de0b28052237e":"355800000000000000000","0xe780a56306ba1e6bb331952c22539b858af9f77d":"50000000000000000000000","0xd1f1694d22671b5aad6a94995c369fbe6133676f":"1000000000000000000000","0x7c45f0f8442a56dbd39dbf159995415c52ed479b":"2000000000000000000000","0xb65941d44c50d24666670d364766e991c02e11c2":"600000000000000000000","0x45e68db8dbbaba5fc2cb337c62bcd0d61b059189":"2000000000000000000000","0x05f3631f5664bdad5d0132c8388d36d7d8920918":"20000000000000000000","0x5475d7f174bdb1f789017c7c1705989646079d49":"9400000000000000000000","0xc7bf2ed1ed312940ee6aded1516e268e4a604856":"6000000000000000000000","0x39aaf0854db6eb39bc7b2e43846a76171c0445de":"1850000000000000000000","0xc817df1b91faf30fe3251571727c9711b45d8f06":"1999944000000000000000","0x7d13d6705884ab2157dd8dcc7046caf58ee94be4":"137200000000000000000000","0x478dc09a1311377c093f9cc8ae74111f65f82f39":"4000000000000000000000","0x8043ed22f997e5a2a4c16e364486ae64975692c4":"1130513000000000000000","0xb9a985501ee950829b17fae1c9cf348c3156542c":"294100000000000000000","0xd5cba5b26bea5d73fabb1abafacdef85def368cc":"200000000000000000000","0x6776e133d9dc354c12a951087b639650f539a433":"120000000000000000000","0x804ca94972634f633a51f3560b1d06c0b293b3b1":"200000000000000000000","0x0be1fdf626ee6189102d70d13b31012c95cd1cd6":"2000000000000000000000","0xf848fce9ab611c7d99206e23fac69ad488b94fe1":"48500000000000000000","0xf01195d657ef3c942e6cb83949e5a20b5cfa8b1e":"25760000000000000000000","0x78a5e89900bd3f81dd71ba869d25fec65261df15":"51900000000000000000000","0xd6f1e55b1694089ebcb4fe7d7882aa66c8976176":"19998846000000000000000","0xd5294b666242303b6df0b1c88d37429bc8c965aa":"300700000000000000000","0x3171877e9d820cc618fc0919b29efd333fda4934":"1000000000000000000000","0x2901f8077f34190bb47a8e227fa29b30ce113b31":"100000000000000000000","0x6b2284440221ce16a8382de5ff0229472269deec":"1000000000000000000000","0x1bba03ff6b4ad5bf18184acb21b188a399e9eb4a":"1790000000000000000000","0x80744618de396a543197ee4894abd06398dd7c27":"2000000000000000000000","0x1b799033ef6dc7127822f74542bb22dbfc09a308":"100000000000000000000","0xd513a45080ff2febe62cd5854abe29ee4467f996":"153200000000000000000","0xe761d27fa3502cc76bb1a608740e1403cf9dfc69":"280000000000000000000","0x53989ed330563fd57dfec9bd343c3760b0799390":"6208000000000000000000","0xccf7110d1bd9a74bfd1d7d7d2d9d55607e7b837d":"900000000000000000000","0xf373e9daac0c8675f53b797a160f6fc034ae6b23":"100000000000000000000","0xabc9a99e8a2148a55a6d82bd51b98eb5391fdbaf":"6000000000000000000000","0xffec0913c635baca2f5e57a37aa9fb7b6c9b6e26":"805000000000000000000","0x581a3af297efa4436a29af0072929abf9826f58b":"2000000000000000000000","0x924efa6db595b79313277e88319625076b580a10":"2000000000000000000000","0x65d8dd4e251cbc021f05b010f2d5dc520c3872e0":"834956000000000000000","0x6c67d6db1d03516c128b8ff234bf3d49b26d2941":"100000000000000000000000","0x496d365534530a5fc1577c0a5241cb88c4da7072":"1790000000000000000000","0xb85ff03e7b5fc422981fae5e9941dacbdaba7584":"1337000000000000000000","0xe13540ecee11b212e8b775dc8e71f374aae9b3f8":"2000000000000000000000","0xa02e3f8f5959a7aab7418612129b701ca1b80010":"20000000000000000000","0xa7a3f153cdc38821c20c5d8c8241b294a3f82b24":"500000000000000000000","0x366175403481e0ab15bb514615cbb989ebc68f82":"2000000000000000000000","0x5104ecc0e330dd1f81b58ac9dbb1a9fbf88a3c85":"100000000000000000000000","0xa466d770d898d8c9d405e4a0e551efafcde53cf9":"492500000000000000000","0x5fa8a54e68176c4fe2c01cf671c515bfbdd528a8":"330000000000000000000000","0xe2e15c60dd381e3a4be25071ab249a4c5c5264da":"2350502000000000000000","0x0628bfbe5535782fb588406bc96660a49b011af5":"1520000000000000000000","0x04d6b8d4da867407bb997749debbcdc0b358538a":"1000000000000000000000","0x0e6ec313376271dff55423ab5422cc3a8b06b22b":"4000000000000000000000","0x8787d12677a5ec291e57e31ffbfad105c3324b87":"12438777000000000000000","0x58e2f11223fc8237f69d99c6289c148c0604f742":"24000000000000000000000","0x5600730a55f6b20ebd24811faa3de96d1662abab":"1880000000000000000000","0xfce089635ce97abac06b44819be5bb0a3e2e0b37":"92491000000000000000","0xfa0c1a988c8a17ad3528eb28b3409daa58225f26":"200000000000000000000","0x7ae1c19e53c71cee4c73fae2d7fc73bf9ab5e392":"1000000000000000000000","0xbd17eed82b9a2592019a1b1b3c0fbad45c408d22":"250000000000000000000","0x884a7a39d0916e05f1c242df55607f37df8c5fda":"23400000000000000000000","0xca70f4ddbf069d2143bd6bbc7f696b52789b32e7":"3000000000000000000000","0x7b25bb9ca8e702217e9333225250e53c36804d48":"1880000000000000000000","0xea8317197959424041d9d7c67a3ece1dbb78bb55":"394000000000000000000","0x5cb953a0e42f5030812226217fffc3ce230457e4":"100000000000000000000","0xd1f4dc1ddb8abb8848a8b14e25f3b55a8591c266":"250000000000000000000","0x6a42ca971c6578d5ade295c3e7f4ad331dd3424e":"6000000000000000000000","0x07e1162ceae3cf21a3f62d105990302e307f4e3b":"1530000000000000000000","0x5d1dc3387b47b8451e55106c0cc67d6dc72b7f0b":"2000000000000000000000","0x5d2819e8d57821922ee445650ccaec7d40544a8d":"200000000000000000000","0x4c24b78baf2bafc7fcc69016426be973e20a50b2":"3000000000000000000000","0x630c5273126d517ce67101811cab16b8534cf9a8":"9422595000000000000000","0x291f929ca59b54f8443e3d4d75d95dee243cef78":"499938000000000000000","0x2dd325fdffb97b19995284afa5abdb574a1df16a":"500000000000000000000","0x4fce8429ba49caa0369d1e494db57e89eab2ad39":"200000000000000000000000","0x712b76510214dc620f6c3a1dd29aa22bf6d214fb":"6000000000000000000000","0x266f2da7f0085ef3f3fa09baee232b93c744db2e":"60000000000000000000000","0x0770c61be78772230cb5a3bb2429a72614a0b336":"6767695000000000000000","0x02dfcb17a1b87441036374b762a5d3418b1cb4d4":"1340860000000000000000","0x5e67df8969101adabd91accd6bb1991274af8df2":"500000000000000000000","0x7d9c59631e2ba2e8e82891f3979922aaa3b567a1":"8000000000000000000000","0x949f8c107bc7f0aceaa0f17052aadbd2f9732b2e":"2000000000000000000000","0xea4e809e266ae5f13cdbe38f9d0456e6386d1274":"4500000000000000000000","0xcd5510a242dfb0183de925fba866e312fabc1657":"2400000000000000000000","0xa36e0d94b95364a82671b608cb2d373245612909":"150011000000000000000","0x0ec46696ffac1f58005fa8439824f08eed1df89b":"10000000000000000000000","0xc6fb1ee37417d080a0d048923bdabab095d077c6":"200000000000000000000","0x53c9eca40973f63bb5927be0bc6a8a8be1951f74":"2000000000000000000000","0xea14bfda0a6e76668f8788321f07df37824ec5df":"200000000000000000000000","0xdfb4d4ade52fcc818acc7a2c6bb2b00224658f78":"7750000000000000000000","0x5997ffefb3c1d9d10f1ae2ac8ac3c8e2d2292783":"1000000000000000000000","0x8eceb2e124536c5b5ffc640ed14ff15ed9a8cb71":"2000000000000000000000","0x8f02bda6c36922a6be6a509be51906d393f7b99b":"1019835000000000000000","0x530077c9f7b907ff9cec0c77a41a70e9029add4a":"2000000000000000000000","0x08936a37df85b3a158cafd9de021f58137681347":"18200000000000000000","0x8e9c429266df057efa78dd1d5f77fc40742ad466":"300061000000000000000","0xacc59f3b30ceffc56461cc5b8df48902240e0e7b":"2000000000000000000000","0xf5534815dc635efa5cc84b2ac734723e21b29372":"1580000000000000000000","0xf873e57a65c93b6e18cb75f0dc077d5b8933dc5c":"197000000000000000000","0x25b78c9fad85b43343f0bfcd0fac11c9949ca5eb":"2000000000000000000000","0xaad2b7f8106695078e6c138ec81a7486aaca1eb2":"200000000000000000000","0x509c8668036d143fb8ae70b11995631f3dfcad87":"1000000000000000000000","0x3602458da86f6d6a9d9eb03daf97fe5619d442fa":"2000000000000000000000","0x9f607b3f12469f446121cebf3475356b71b4328c":"4000000000000000000000","0xfe3827d57630cf8761d512797b0b858e478bbd12":"20000000000000000000","0x9d9c4efe9f433989e23be94049215329fa55b4cb":"256215000000000000000","0x9bd905f1719fc7acd0159d4dc1f8db2f21472338":"1000000000000000000000","0x7d82e523cc2dc591da3954e8b6bb2caf6461e69c":"2316058000000000000000","0x74afe54902d615782576f8baac13ac970c050f6e":"177670000000000000000","0xaff11ccf699304d5f5862af86083451c26e79ae5":"1999000000000000000000","0x3885fee67107dc3a3c741ee290c98918c9b99397":"20000000000000000000","0x36343aeca07b6ed58a0e62fa4ecb498a124fc971":"300000000000000000000","0xc94a28fb3230a9ddfa964e770f2ce3c253a7be4f":"200000000000000000000","0x9882967cee68d2a839fad8ab4a7c3dddf6c0adc8":"1336866000000000000000","0x95df4e3445d7662624c48eba74cf9e0a53e9f732":"56000000000000000000000","0xca9faa17542fafbb388eab21bc4c94e8a7b34788":"1999999000000000000000","0xc8b1850525d946f2ae84f317b15188c536a5dc86":"2685000000000000000000","0x39bac68d947859f59e9226089c96d62e9fbe3cde":"40000000000000000000","0xa9bfc410dddb20711e45c07387eab30a054e19ac":"1154750000000000000000","0x540a1819bd7c35861e791804e5fbb3bc97c9abb1":"1454400000000000000000","0x667b61c03bb937a9f5d0fc5a09f1ea3363c77035":"4250000000000000000000","0x010df1df4bed23760d2d1c03781586ddf7918e54":"60000000000000000000","0xbd51ee2ea143d7b1d6b77e7e44bdd7da12f485ac":"1318800000000000000000","0xfb5125bf0f5eb0b6f020e56bfc2fdf3d402c097e":"5910000000000000000000","0x3f0c83aac5717962734e5ceaeaecd39b28ad06be":"2000000000000000000000","0xf10661ff94140f203e7a482572437938bec9c3f7":"20000000000000000000000","0xbd3097a79b3c0d2ebff0e6e86ab0edadbed47096":"1670000000000000000000","0xedeb4894aadd0081bbddd3e8846804b583d19f27":"2000000000000000000000","0x49c9771fca19d5b9d245c891f8158fe49f47a062":"10000000000000000000000","0x6405dd13e93abcff377e700e3c1a0086eca27d29":"18200000000000000000","0xce5e04f0184369bcfa06aca66ffa91bf59fa0fb9":"40000000000000000000","0x4364309a9fa07095600f79edc65120cdcd23dc64":"10000000000000000000000","0xb749b54e04d5b19bdcedfb84da7701ab478c27ae":"2680000000000000000000","0xf593c65285ee6bbd6637f3be8f89ad40d489f655":"3000000000000000000000","0xd224f880f9479a89d32f09e52be990b288135cef":"17300000000000000000000","0x85bb51bc3bfe9a1b2a2f6b1cda95bca8b38c8d5e":"321750000000000000000","0xcaf4481d9db78dc4f25f7b4ac8bd3b1ca0106b31":"5000000000000000000000","0x51ca8bd4dc644fac47af675563d5804a0da21eeb":"788000000000000000000","0x19f643e1a8fa04ae16006028138333a59a96de87":"20000000000000000000","0x58b808a65b51e6338969afb95ec70735e451d526":"39998000000000000000000","0x574921838cc77d6c98b17d903a3ae0ee0da95bd0":"53480000000000000000000","0x7c6924d07c3ef5891966fe0a7856c87bef9d2034":"2000000000000000000000","0xf9767e4ecb4a5980527508d7bec3d45e4c649c13":"1910000000000000000000","0xf3be99b9103ce7550aa74ff1db18e09dfe32e005":"2000000000000000000000","0x625644c95a873ef8c06cdb9e9f6d8d7680043d62":"1800000000000000000000","0x6a44af96b3f032ae641beb67f4b6c83342d37c5d":"29000000000000000000","0xd3a10ec7a5c9324999dd9e9b6bde7c911e584bda":"600000000000000000000","0xe8ddbed732ebfe754096fde9086b8ea4a4cdc616":"2000000000000000000000","0x235fa66c025ef5540070ebcf0d372d8177c467ab":"33400000000000000000000","0x4d08471d68007aff2ae279bc5e3fe4156fbbe3de":"40000000000000000000000","0xdadc00ab7927603c2fcf31cee352f80e6c4d6351":"1999664000000000000000","0x7393cbe7f9ba2165e5a7553500b6e75da3c33abf":"100000000000000000000","0x77617ebc4bebc5f5ddeb1b7a70cdeb6ae2ffa024":"1970000000000000000000","0x7fea1962e35d62059768c749bedd96cab930d378":"2000000000000000000000","0x243b3bca6a299359e886ce33a30341fafe4d573d":"20000000000000000000000","0xb94d47b3c052a5e50e4261ae06a20f45d8eee297":"2000000000000000000000","0xe727e67ef911b81f6cf9c73fcbfebc2b02b5bfc6":"2000000000000000000000","0xe510d6797fba3d6693835a844ea2ad540691971b":"17381000000000000000000","0x0cdc960b998c141998160dc179b36c15d28470ed":"500038000000000000000","0x3e76a62db187aa74f63817533b306cead0e8cebe":"31200000000000000000000","0x495b641b1cdea362c3b4cbbd0f5cc50b1e176b9c":"1000000000000000000000","0x5126460d692c71c9af6f05574d93998368a23799":"52000000000000000000","0xa008019863c1a77c1499eb39bbd7bf2dd7a31cb9":"137000000000000000000","0x65ee20b06d9ad589a7e7ce04b9f5f795f402aece":"2000000000000000000000","0xf432b9dbaf11bdbd73b6519fc0a904198771aac6":"152000000000000000000","0x85946d56a4d371a93368539690b60ec825107454":"1730000000000000000000","0x26f9f7cefd7e394b9d3924412bf2c2831faf1f85":"4000000000000000000000","0xd4ebb1929a23871cf77fe049ab9602be08be0a73":"1910000000000000000000","0x4fdac1aa517007e0089430b3316a1badd12c01c7":"500000000000000000000","0x05e671de55afec964b074de574d5158d5d21b0a3":"3940000000000000000000","0x20181c4b41f6f972b66958215f19f570c15ddff1":"1600000000000000000000","0xcc9519d1f3985f6b255eaded12d5624a972721e1":"1000000000000000000000","0x169bbefc41cfd7d7cbb8dfc63020e9fb06d49546":"2000000000000000000000","0x175a183a3a235ffbb03ba835675267229417a091":"16000000000000000000000","0x8dde3cb8118568ef4503fe998ccdf536bf19a098":"4000000000000000000000","0x6a05b21c4f17f9d73f5fb2b0cb89ff5356a6cc7e":"1500000000000000000000","0x5cc4cba621f220637742057f6055b80dffd77e13":"39997692000000000000000","0xecb94c568bfe59ade650645f4f26306c736cace4":"267400000000000000000","0xdfa6b8b8ad3184e357da282951d79161cfb089bc":"400000000000000000000","0xa3058c51737a4e96c55f2ef6bd7bb358167ec2a7":"606093000000000000000","0x051d424276b21239665186133d653bb8b1862f89":"1000000000000000000000","0xd05ffb2b74f867204fe531653b0248e21c13544e":"1000000000000000000000","0xe1f63ebbc62c7b7444040eb99623964f7667b376":"20000000000000000000","0xe5a3d7eb13b15c100177236d1beb30d17ee15420":"2000000000000000000000","0x18fa8625c9dc843c78c7ab259ff87c9599e07f10":"1000000000000000000000","0x64264aedd52dcae918a012fbcd0c030ee6f71821":"1000000000000000000000","0x6f1f4907b8f61f0c51568d692806b382f50324f5":"2000000000000000000000","0xbecef61c1c442bef7ce04b73adb249a8ba047e00":"1000400000000000000000","0x7b893286427e72db219a21fc4dcd5fbf59283c31":"10000000000000000000000","0xce5eb63a7bf4fbc2f6e4baa0c68ab1cb4cf98fb4":"2000000000000000000000","0x66ec16ee9caab411c55a6629e318de6ee216491d":"865000000000000000000","0x30b66150f1a63457023fdd45d0cc6cb54e0c0f06":"1000000000000000000000","0x87183160d172d2e084d327b86bcb7c1d8e6784ef":"4000086000000000000000","0xc420388fbee84ad656dd68cdc1fbaa9392780b34":"187767000000000000000","0x90f774c9147dde90853ddc43f08f16d455178b8c":"4000000000000000000000","0x1e1d7a5f2468b94ea826982dbf2125793c6e4a5a":"999940000000000000000","0x8043fdd0bc4c973d1663d55fc135508ec5d4f4fa":"20000000000000000000","0x7bca1da6c80a66baa5db5ac98541c4be276b447d":"679000000000000000000","0x73550beb732ba9ddafda7ae406e18f7feb0f8bb2":"2800000000000000000000","0xadc19ec835afe3e58d87dc93a8a9213c90451326":"1971200000000000000000","0x821d798af19989c3ae5b84a7a7283cd7fda1fabe":"20000000000000000000000","0x4c4e6f13fb5e3f70c3760262a03e317982691d10":"100000000000000000000","0x664e43119870af107a448db1278b044838ffcdaf":"400000000000000000000","0x8da1178f55d97772bb1d24111a404a4f8715b95d":"878149000000000000000","0x5e6e9747e162f8b45c656e0f6cae7a84bac80e4e":"2000000000000000000000","0xc7eac31abce6d5f1dea42202b6a674153db47a29":"591000000000000000000","0xd96711540e2e998343d4f590b6fc8fac3bb8b31d":"1758944000000000000000","0x9da4ec407077f4b9707b2d9d2ede5ea5282bf1df":"4000000000000000000000","0xf60c1b45f164b9580e20275a5c39e1d71e35f891":"2000000000000000000000","0xeb6394a7bfa4d28911d5a5b23e93f35e340c2294":"78000000000000000000","0xa89ac93b23370472daac337e9afdf642543f3e57":"10000000000000000000000","0xbb618e25221ad9a740b299ed1406bc3934b0b16d":"1000000000000000000000","0x817ac33bd8f847567372951f4a10d7a91ce3f430":"200015000000000000000","0xfe6a895b795cb4bf85903d3ce09c5aa43953d3bf":"3400000000000000000000","0x3673954399f6dfbe671818259bb278e2e92ee315":"200000000000000000000000","0xdf0ff1f3d27a8ec9fb8f6b0cb254a63bba8224a5":"4367636000000000000000","0xff12e49d8e06aa20f886293c0b98ed7eff788805":"4000000000000000000000","0x5aef16a226dd68071f2483e1da42598319f69b2c":"2000000000000000000000","0x0266ab1c6b0216230b9395443d5fa75e684568c6":"1000000000000000000000","0x14a7352066364404db50f0d0d78d754a22198ef4":"1880000000000000000000","0x444caf79b71338ee9aa7c733b02acaa7dc025948":"40000000000000000000","0x64e2de21200b1899c3a0c0653b5040136d0dc842":"20000000000000000000000","0x36e156610cd8ff64e780d89d0054385ca76755aa":"14000000000000000000000","0x0a6ebe723b6ed1f9a86a69ddda68dc47465c2b1b":"1185000000000000000000","0x38bf2a1f7a69de0e2546adb808b36335645da9ff":"2000320000000000000000","0x39f44663d92561091b82a70dcf593d754005973a":"199999000000000000000","0x24b9e6644f6ba4cde126270d81f6ab60f286dff4":"133700000000000000000","0x9b59eb213b1e7565e45047e04ea0374f10762d16":"2000000000000000000000","0x309544b6232c3dd737f945a03193d19b5f3f65b9":"1087440000000000000000","0xb28bb39f3466517cd46f979cf59653ee7d8f152e":"450000000000000000000","0x9da8e22ca10e67fea44e525e4751eeac36a31194":"260000000000000000000","0x4f8ae80238e60008557075ab6afe0a7f2e74d729":"100000000000000000000","0x74ed33acf43f35b98c9230b9e6642ecb5330839e":"681872000000000000000","0x22842ab830da509913f81dd1f04f10af9edd1c55":"2000000000000000000000","0xa8f37f0ab3a1d448a9e3ce40965f97a646083a34":"329800000000000000000","0x582b70669c97aab7d68148d8d4e90411e2810d56":"999972000000000000000","0xd5e55100fbd1956bbed2ca518d4b1fa376032b0b":"100000000000000000000","0xb7cc6b1acc32d8b295df68ed9d5e60b8f64cb67b":"300000000000000000000","0xe081ca1f4882db6043d5a9190703fde0ab3bf56d":"400000000000000000000","0xc02077449a134a7ad1ef7e4d927affeceeadb5ae":"18200000000000000000","0xe09fea755aee1a44c0a89f03b5deb762ba33006f":"1100070000000000000000","0xb3717731dad65132da792d876030e46ac227bb8a":"1000000000000000000000","0x157eb3d3113bd3b597714d3a954edd018982a5cb":"2000000000000000000000","0xdc57345b38e0f067c9a31d9deac5275a10949321":"200000000000000000000","0x40ea5044b204b23076b1a5803bf1d30c0f88871a":"14000000000000000000000","0x2bab0fbe28d58420b52036770a12f9952aea6911":"3820000000000000000000","0xadaa0e548c035affed64ca678a963fabe9a26bfd":"70000000000000000000","0xbb48eaf516ce2dec3e41feb4c679e4957641164f":"3820000000000000000000","0x7693bdeb6fc82b5bca721355223175d47a084b4d":"22000000000000000000000","0x03cb98d7acd817de9d886d22fab3f1b57d92a608":"1600000000000000000000","0xf88900db737955b1519b1a7d170a18864ce590eb":"18200000000000000000","0x757fa55446c460968bb74b5ebca96c4ef2c709c5":"1015200000000000000000","0xda855d53477f505ec4c8d5e8bb9180d38681119c":"5600000000000000000000","0xe41aea250b877d423a63ba2bce2f3a61c0248d56":"260000000000000000000","0x8262169b615870134eb4ac6c5f471c6bf2f789fc":"462500000000000000000","0x66b0c100c49149935d14c0dc202cce907cea1a3d":"1970000000000000000000","0x854c0c469c246b83b5d1b3eca443b39af5ee128a":"1600000000000000000000","0xeb6810691d1ae0d19e47bd22cebee0b3ba27f88a":"2499922000000000000000","0x24dcc24bd9c7210ceacfb30da98ae04a4d7b8ab9":"1000000000000000000000","0xe31b4eef184c24ab098e36c802714bd4743dd0d4":"200000000000000000000","0x99b8c824869de9ed24f3bff6854cb6dd45cc3f9f":"1880000000000000000000","0x2ae73a79aea0278533accf21070922b1613f8f32":"3097417000000000000000","0xddbd2b932c763ba5b1b7ae3b362eac3e8d40121a":"10000000000000000000000","0x1b4bbcb18165211b265b280716cb3f1f212176e8":"472325000000000000000","0xe177e0c201d335ba3956929c571588b51c5223ae":"2000000000000000000000","0x1945fe377fe6d4b71e3e791f6f17db243c9b8b0f":"2185500000000000000000","0x3e9b34a57f3375ae59c0a75e19c4b641228d9700":"17900000000000000000","0xa4d6c82eddae5947fbe9cdfbd548ae33d91a7191":"8000000000000000000000","0xbad4425e171c3e72975eb46ac0a015db315a5d8f":"2000000000000000000000","0xa2d2aa626b09d6d4e4b13f7ffc5a88bd7ad36742":"4639390000000000000000","0xb61c34fcacda701a5aa8702459deb0e4ae838df8":"35000000000000000000000","0x145e0600e2a927b2dd8d379356b45a2e7d51d3ae":"2545843000000000000000","0x8df339214b6ad1b24663ce716034749d6ef838d9":"11000000000000000000000","0x8fd9a5c33a7d9edce0997bdf77ab306424a11ea9":"2000000000000000000000","0x097da12cfc1f7c1a2464def08c29bed5e2f851e9":"20000000000000000000","0xddabf13c3c8ea4e3d73d78ec717afafa430e5479":"41600000000000000000000","0x9eeb07bd2b7890195e7d46bdf2071b6617514ddb":"2000000000000000000000","0x819af9a1c27332b1c369bbda1b3de1c6e933d640":"314308000000000000000","0xd7d2c6fca8ad1f75395210b57de5dfd673933909":"340000000000000000000","0xcdd5d881a7362c9070073bdfbc75e72453ac510e":"842000000000000000000","0xe9ac36376efa06109d40726307dd1a57e213eaa9":"194000000000000000000","0x1bea4df5122fafdeb3607eddda1ea4ffdb9abf2a":"346000000000000000000","0x3e5e93fb4c9c9d1246f8f247358e22c3c5d17b6a":"150000000000000000000","0x6c1ddd33c81966dc8621776071a4129482f2c65f":"40000000000000000000000","0x2ccb66494d0af689abf9483d365d782444e7dead":"1000000000000000000000","0x19571a2b8f81c6bcf66ab3a10083295617150003":"492500000000000000000","0x38ac664ee8e0795e4275cb852bcba6a479ad9c8d":"20000000000000000000","0xc4803bb407c762f90b7596e6fde194931e769590":"4000000000000000000000","0x93507e9e8119cbceda8ab087e7ecb071383d6981":"14000000000000000000000","0xb672734afcc224e2e609fc51d4f059732744c948":"295500000000000000000","0xfbbbebcfbe235e57dd2306ad1a9ec581c7f9f48f":"40000000000000000000","0x8c81410ea8354cc5c65c41be8bd5de733c0b111d":"9550000000000000000000","0x942c6b8c955bc0d88812678a236725b32739d947":"1550000000000000000000","0xd2e817738abf1fb486583f80c350318bed860c80":"240010000000000000000","0xbff5df769934b8943ca9137d0efef2fe6ebbb34e":"100000000000000000000","0x6c4e426e8dc005dfa3516cb8a680b02eea95ae8e":"1337000000000000000000","0xf645dd7c890093e8e4c8aa92a6bb353522d3dc98":"134000000000000000000","0x4bac846af4169f1d95431b341d8800b22180af1a":"20000000000000000000","0x0514954c3c2fb657f9a06f510ea22748f027cdd3":"400000000000000000000","0x163dca73d7d6ea3f3e6062322a8734180c0b78ef":"2941400000000000000000","0xfeaca2ac74624bf348dac9985143cfd652a4be55":"26148245000000000000000","0xfe80e9232deaff19baf99869883a4bdf0004e53c":"855680000000000000000","0x17108dab2c50f99de110e1b3b3b4cd82f5df28e7":"980000000000000000000","0x837a645dc95c49549f899c4e8bcf875324b2f57c":"600400000000000000000","0x762998e1d75227fced7a70be109a4c0b4ed86414":"20000000000000000000","0xc0a7e8435dff14c25577739db55c24d5bf57a3d9":"49250000000000000000000","0xaead88d689416b1c91f2364421375b7d3c70fb2e":"2000000000000000000000","0x9279b2228cec8f7b4dda3f320e9a0466c2f585ca":"5000000000000000000000","0x36726f3b885a24f92996da81625ec8ad16d8cbe6":"1543723000000000000000","0x3951e48e3c869e6b72a143b6a45068cdb9d466d0":"20000000000000000000","0xf5d61ac4ca95475e5b7bffd5f2f690b316759615":"31040000000000000000000","0x158a0d619253bf4432b5cd02c7b862f7c2b75636":"135733000000000000000","0xe56d431324c92911a1749df292709c14b77a65cd":"8200000000000000000000","0x9976947eff5f6ae5da08dd541192f378b428ff94":"8000000000000000000000","0x83210583c16a4e1e1dac84ebd37e3d0f7c57eba4":"2000000000000000000000","0xdcb64df43758c7cf974fa660484fbb718f8c67c1":"20000000000000000000000","0xd4205592844055b3c7a1f80cefe3b8eb509bcde7":"178973000000000000000","0xd0648a581b3508e135a2935d12c9657045d871ca":"8022000000000000000000","0xe7d17524d00bad82497c0f27156a647ff51d2792":"20000000000000000000","0x21582e99e502cbf3d3c23bdffb76e901ac6d56b2":"100000000000000000000","0xe61f280915c774a31d223cf80c069266e5adf19b":"880000000000000000000","0x03c91d92943603e752203e05340e566013b90045":"802200000000000000000","0x22561c5931143536309c17e832587b625c390b9a":"4000000000000000000000","0xe399c81a1d701b44f0b66f3399e66b275aaaf8c1":"1000000000000000000000","0x7f8dbce180ed9c563635aad2d97b4cbc428906d9":"2674000000000000000000","0x9f61beb46f5e853d0a8521c7446e68e34c7d0973":"560000000000000000000","0x6d3f2ba856ccbb0237fa7661156b14b013f21240":"1000000000000000000000","0x5f742e487e3ab81af2f94afdbe1b9b8f5ccc81bc":"2172412000000000000000","0xb600feab4aa96c537504d96057223141692c193a":"400000000000000000000","0xfab487500df20fb83ebed916791d561772adbebf":"1999980000000000000000","0xf8704c16d2fd5ba3a2c01d0eb20484e6ecfa3109":"200000000000000000000","0x3f1bc420c53c002c9e90037c44fe6a8ef4ddc962":"173000000000000000000","0x82e577b515cb2b0860aafe1ce09a59e09fe7d040":"600000000000000000000","0xbc999e385c5aebcac8d6f3f0d60d5aa725336d0d":"2000000000000000000000","0xe16ce35961cd74bd590d04c4ad4a1989e05691c6":"146000000000000000000","0xeb76424c0fd597d3e341a9642ad1ee118b2b579d":"4000000000000000000000","0xc440c7ca2f964b6972ef664a2261dde892619d9c":"20000000000000000000000","0x460d5355b2ceeb6e62107d81e51270b26bf45620":"2005500000000000000000","0xfcada300283f6bcc134a91456760b0d77de410e0":"2000000000000000000000","0xbe8d7f18adfe5d6cc775394989e1930c979d007d":"1000000000000000000000","0xa7f9220c8047826bd5d5183f4e676a6d77bfed36":"153368000000000000000","0x98d204f9085f8c8e7de23e589b64c6eff692cc63":"2000000000000000000000","0x5a2916b8d2e8cc12e207ab464d433e2370d823d9":"2000000000000000000000","0xc42d6aeb710e3a50bfb44d6c31092969a11aa7f3":"150052000000000000000","0x04ce45f600db18a9d0851b29d9393ebdaafe3dc5":"20000000000000000000","0x7a1370a742ec2687e761a19ac5a794329ee67404":"2999988000000000000000","0xda2ad58e77deddede2187646c465945a8dc3f641":"660000000000000000000","0xec58bc0d0c20d8f49465664153c5c196fe59e6be":"400000000000000000000","0xf8063af4cc1dd9619ab5d8bff3fcd1faa8488221":"2000000000000000000000","0xb9231eb26e5f9e4b4d288f03906704fab96c87d6":"19700000000000000000000","0x6e5c2d9b1c546a86eefd5d0a5120c9e4e730190e":"199600000000000000000","0xe49936a92a8ccf710eaac342bc454b9b14ebecb1":"2000000000000000000000","0x21dbdb817a0d8404c6bdd61504374e9c43c9210e":"9999917000000000000000","0x5cebe30b2a95f4aefda665651dc0cf7ef5758199":"18200000000000000000","0x597038ff91a0900cbbab488af483c790e6ec00a0":"10000000000000000000000","0x0fa5d8c5b3f294efd495ab69d768f81872508548":"2000000000000000000000","0xfeef3b6eabc94affd3310c1c4d0e65375e131119":"20000000000000000000","0x1ce81d31a7923022e125bf48a3e03693b98dc9dd":"2000000000000000000000","0x5887dc6a33dfed5ac1edefe35ef91a216231ac96":"250000000000000000000","0x4e8e47ae3b1ef50c9d54a38e14208c1abd3603c2":"2235000000000000000000","0xe845e387c4cbdf982280f6aa01c40e4be958ddb2":"25000000000000000000000","0x71d9494e50c5dd59c599dba3810ba1755e6537f0":"4000000000000000000000","0x6eb5578a6bb7c32153195b0d8020a6914852c059":"660000000000000000000000","0x543f8c674e2462d8d5daa0e80195a8708e11a29e":"63940000000000000000","0xa0459ef3693aacd1647cd5d8929839204cef53be":"1000000000000000000000","0xdda371e600d30688d4710e088e02fdf2b9524d5f":"6920000000000000000000","0xdd4dd6d36033b0636fcc8d0938609f4dd64f4a86":"60000000000000000000","0x3bd624b548cb659736907ed8aa3c0c705e24b575":"2000000000000000000000","0x414599092e879ae25372a84d735af5c4e510cd6d":"400000000000000000000","0x3d66cd4bd64d5c8c1b5eea281e106d1c5aad2373":"1951100000000000000000","0x5948bc3650ed519bf891a572679fd992f8780c57":"197000000000000000000","0x8b74a7cb1bb8c58fce267466a30358adaf527f61":"13620000000000000000000","0x3f10800282d1b7ddc78fa92d8230074e1bf6aeae":"4925000000000000000000","0x32dbb6716c54e83165829a4abb36757849b6e47d":"1000000000000000000000","0xe6b3ac3f5d4da5a8857d0b3f30fc4b2b692b77d7":"1460000000000000000000","0x052a58e035f1fe9cdd169bcf20970345d12b9c51":"1490000000000000000000","0x581bdf1bb276dbdd86aedcdb397a01efc0e00c5b":"1000000000000000000000","0x604e9477ebf4727c745bcabbedcb6ccf29994022":"1000060000000000000000","0x59b96deb8784885d8d3b4a166143cc435d2555a1":"1337000000000000000000","0x37d980a12ee3bf23cc5cdb63b4ae45691f74c837":"2000000000000000000000","0x3bfbd3847c17a61cf3f17b52f8eba1b960b3f39f":"3000000000000000000000","0x49c941e0e5018726b7290fc473b471d41dae80d1":"500000000000000000000","0xf26bcedce3feadcea3bc3e96eb1040dfd8ffe1a0":"775000000000000000000","0xd0944aa185a1337061ae20dc9dd96c83b2ba4602":"200000000000000000000","0x904caa429c619d940f8e6741826a0db692b19728":"1000000000000000000000","0xb95c9b10aa981cf4a67a71cc52c504dee8cf58bd":"4000000000000000000000","0x15874686b6733d10d703c9f9bec6c52eb8628d67":"2000000000000000000000","0x1374facd7b3f8d68649d60d4550ee69ff0484133":"269700000000000000000","0xb0e469c886593815b3495638595daef0665fae62":"1940000000000000000000","0x47ff6feb43212060bb1503d7a397fc08f4e70352":"2000000000000000000000","0xc60b04654e003b4683041f1cbd6bc38fda7cdbd6":"2000000000000000000000","0x3ecdb532e397579662b2a46141e78f8235936a5f":"66850000000000000000","0xb3a8c2cb7d358e5739941d945ba9045a023a8bbb":"1000000000000000000000","0x32ef5cdc671df5562a901aee5db716b9be76dcf6":"2000000000000000000000","0xc94110e71afe578aa218e4fc286403b0330ace8d":"2000000000000000000000","0x9b43dcb95fde318075a567f1e6b57617055ef9e8":"3940000000000000000000","0xefeea010756f81da4ba25b721787f058170befbd":"32470000000000000000","0xc88255eddcf521c6f81d97f5a42181c9073d4ef1":"290793000000000000000","0xdd47189a3e64397167f0620e484565b762bfbbf4":"1850000000000000000000","0x82f39b2758ae42277b86d69f75e628d958ebcab0":"40000000000000000000000","0xe37f5fdc6ec97d2f866a1cfd0d3a4da4387b22b5":"10000000000000000000000","0x62331df2a3cbee3520e911dea9f73e905f892505":"2000000000000000000000","0x8c5d16ed65e3ed7e8b96ca972bc86173e3500b03":"2000000000000000000000","0x8b9841862e77fbbe919470935583a93cf027e450":"2000054000000000000000","0xc8dd27f16bf22450f5771b9fe4ed4ffcb30936f4":"197000000000000000000","0xdec8a1a898f1b895d8301fe64ab3ad5de941f689":"787803000000000000000","0x61c4ee7c864c4d6b5e37ea1331c203739e826b2f":"30063000000000000000","0x3250e3e858c26adeccadf36a5663c22aa84c4170":"5000000000000000000000","0x299e0bca55e069de8504e89aca6eca21d38a9a5d":"55500000000000000000","0xd50f7fa03e389876d3908b60a537a6706304fb56":"100000000000000000000","0x69073269729e6414b26ec8dc0fd935c73b579f1e":"30000000000000000000000","0x14fcd1391e7d732f41766cdacd84fa1deb9ffdd2":"2000000000000000000000","0x823768746737ce6da312d53e54534e106f967cf3":"20000000000000000000","0x882f75708386653c80171d0663bfe30b017ed0ad":"2000000000000000000000","0xa25b086437fd2192d0a0f64f6ed044f38ef3da32":"335000000000000000000","0x5a9c8b69fc614d69564999b00dcb42db67f97e90":"3429227000000000000000","0xa2b701f9f5cdd09e4ba62baebae3a88257105885":"1000000000000000000000","0x5e7b8c54dc57b0402062719dee7ef5e37ea35d62":"2877224000000000000000","0x7ffabfbc390cbe43ce89188f0868b27dcb0f0cad":"6370000000000000000000","0xb5cdbc4115406f52e5aa85d0fea170d2979cc7ba":"1337000000000000000000","0x263814309de4e635cf585e0d365477fc40e66cf7":"146000000000000000000","0x24cff0e9336a9f80f9b1cb968caf6b1d1c4932a4":"200200000000000000000","0xd3a941c961e8ca8b1070f23c6d6d0d2a758a4444":"200000000000000000000","0xa97beb3a48c45f1528284cb6a95f7de453358ec6":"31000000000000000000000","0x4dd131c74a068a37c90aded4f309c2409f6478d3":"400008000000000000000","0x653675b842d7d8b461f722b4117cb81dac8e639d":"31000000000000000000","0x561be9299b3e6b3e63b79b09169d1a948ae6db01":"500000000000000000000","0xdc067ed3e12d711ed475f5156ef7e71a80d934b9":"9550000000000000000000","0x08d97eadfcb7b064e1ccd9c8979fbee5e77a9719":"266063000000000000000","0x6e4c2ab7db026939dbd3bc68384af660a61816b2":"167000000000000000000","0xbf4c73a7ede7b164fe072114843654e4d8781dde":"2000000000000000000000","0xf504943aaf16796e0b341bbcdf21d11cc586cdd1":"9000000000000000000000","0xea81ca8638540cd9d4d73d060f2cebf2241ffc3e":"1970000000000000000000","0x9944fee9d34a4a880023c78932c00b59d5c82a82":"750022000000000000000","0x12f460ae646cd2780fd35c50a6af4b9accfa85c6":"1000000000000000000000","0x4e232d53b3e6be8f895361d31c34d4762b12c82e":"1760000000000000000000","0x6bb2aca23fa1626d18efd6777fb97db02d8e0ae4":"40000000000000000000000","0xbc4e471560c99c8a2a4b1b1ad0c36aa6502b7c4b":"12000000000000000000000","0x2e2cbd7ad82547b4f5ff8b3ab56f942a6445a3b0":"200000000000000000000","0x21ecb2dfa65779c7592d041cd2105a81f4fd4e46":"1000000000000000000000","0x34318625818ec13f11835ae97353ce377d6f590a":"1520000000000000000000","0xa7ef35ce87eda6c28df248785815053ec97a5045":"4999998000000000000000","0x6a514e6242f6b68c137e97fea1e78eb555a7e5f7":"20000000000000000000","0x9340b5f678e45ee05eb708bb7abb6ec8f08f1b6b":"6000000000000000000000","0x43cc08d0732aa58adef7619bed46558ad7774173":"4443926000000000000000","0x12e9a4ad2ad57484dd700565bddb46423bd9bd31":"19999800000000000000000","0xebbeeb259184a6e01cccfc2207bbd883785ac90a":"619966000000000000000","0x704ab1150d5e10f5e3499508f0bf70650f028d4b":"4000000000000000000000","0xfc361105dd90f9ede566499d69e9130395f12ac8":"395000000000000000000000","0xc1b9a5704d351cfe983f79abeec3dbbbae3bb629":"20000000000000000000","0x66f50406eb1b11a946cab45927cca37470e5a208":"2000000000000000000000","0x53942e7949d6788bb780a7e8a0792781b1614b84":"15899600000000000000000","0x32ba9a7d0423e03a525fe2ebeb661d2085778bd8":"20000000000000000000000","0x11c0358aa6479de21866fe21071924b65e70f8b9":"36400000000000000000000","0x76cb9c8b69f4387675c48253e234cb7e0d74a426":"7396300000000000000000","0x9f5f44026b576a4adb41e95961561d41039ca391":"250000000000000000000","0x533a73a4a2228eee05c4ffd718bbf3f9c1b129a7":"6000000000000000000000","0xdcc52d8f8d9fc742a8b82767f0555387c563efff":"500000000000000000000","0xf456a75bb99655a7412ce97da081816dfdb2b1f2":"200000000000000000000","0xd0c101fd1f01c63f6b1d19bc920d9f932314b136":"20000000000000000000000","0xdabc225042a6592cfa13ebe54efa41040878a5a2":"259550000000000000000","0x38eec6e217f4d41aa920e424b9525197041cd4c6":"4428166000000000000000","0x8a247d186510809f71cffc4559471c3910858121":"1790000000000000000000","0x4f152b2fb8659d43776ebb1e81673aa84169be96":"2000000000000000000000","0xb4496ddb27799a222457d73979116728e8a1845b":"2610331000000000000000","0x4a4053b31d0ee5dbafb1d06bd7ac7ff3222c47d6":"1400000000000000000000","0x0f7bea4ef3f73ae0233df1e100718cbe29310bb0":"2000000000000000000000","0xc836e24a6fcf29943b3608e662290a215f6529ea":"292000000000000000000","0x1765361c2ec2f83616ce8363aae21025f2566f40":"5000000000000000000000","0xb6e6c3222b6b6f9be2875d2a89f127fb64100fe2":"8008000000000000000000","0x01bbc14f67af0639aab1441e6a08d4ce7162090f":"1309500000000000000000","0xaf2058c7282cf67c8c3cf930133c89617ce75d29":"6920000000000000000000","0x464d9c89cce484df000277198ed8075fa63572d1":"20000000000000000000","0x50cd97e9378b5cf18f173963236c9951ef7438a5":"1400000000000000000000","0xcb47bd30cfa8ec5468aaa6a94642ced9c819c8d4":"4000000000000000000000","0x6b10f8f8b3e3b60de90aa12d155f9ff5ffb22c50":"2000000000000000000000","0x09b7a988d13ff89186736f03fdf46175b53d16e0":"6000000000000000000000","0x5bfafe97b1dd1d712be86d41df79895345875a87":"500000000000000000000","0xa06cd1f396396c0a64464651d7c205efaf387ca3":"1999944000000000000000","0xfc0096b21e95acb8d619d176a4a1d8d529badbef":"384601000000000000000","0xa74444f90fbb54e56f3ac9b6cfccaa4819e4614a":"20000000000000000000","0x3c15b3511df6f0342e7348cc89af39a168b7730f":"1000000000000000000000","0x3d6ff82c9377059fb30d9215723f60c775c891fe":"250066000000000000000","0xa524a8cccc49518d170a328270a2f88133fbaf5d":"294500000000000000000","0x8a7a06be199a3a58019d846ac9cbd4d95dd757de":"3000200000000000000000","0xd744ac7e5310be696a63b003c40bd039370561c6":"1670000000000000000000","0xfe362688845fa244cc807e4b1130eb3741a8051e":"1000000000000000000000","0xb2d0360515f17daba90fcbac8205d569b915d6ac":"6000000000000000000000","0xc53594c7cfb2a08f284cc9d7a63bbdfc0b319732":"49200000000000000000000","0xb3c228731d186d2ded5b5fbe004c666c8e469b86":"29000000000000000000","0x63e414603e80d4e5a0f5c18774204642258208e4":"5000000000000000000000","0x826ce5790532e0548c6102a30d3eac836bd6388f":"18000000000000000000000","0xc5e812f76f15f2e1f2f9bc4823483c8804636f67":"73000000000000000000","0x116fef5e601642c918cb89160fc2293ba71da936":"802200000000000000000","0x08b84536b74c8c01543da88b84d78bb95747d822":"200000000000000000000","0x04a80afad53ef1f84165cfd852b0fdf1b1c24ba8":"58000000000000000000","0x2b0362633614bfcb583569438ecc4ea57b1d337e":"20000000000000000000000","0xe95179527deca5916ca9a38f215c1e9ce737b4c9":"10000000000000000000000","0x2c5df866666a194b26cebb407e4a1fd73e208d5e":"1000000000000000000000","0x529e824fa072582b4032683ac7eecc1c04b4cac1":"2000000000000000000000","0x78634371e17304cbf339b1452a4ce438dc764cce":"10000000000000000000000","0xe172dfc8f80cd1f8cd8539dc26082014f5a8e3e8":"3000000000000000000000","0xb07618328a901307a1b7a0d058fcd5786e9e72fe":"30239500000000000000000","0xb0571153db1c4ed7acaefe13ecdfdb72e7e4f06a":"80520000000000000000000","0xad910a23d6850613654af786337ad2a70868ac6d":"1999800000000000000000","0x4da5edc688b0cb62e1403d1700d9dcb99ffe3fd3":"2000000000000000000000","0xbe2471a67f6047918772d0e36839255ed9d691ae":"4000000000000000000000","0x28868324337e11ba106cb481da962f3a8453808d":"2000000000000000000000","0xd8f94579496725b5cb53d7985c989749aff849c0":"17000000000000000000000","0x4981c5ff66cc4e9680251fc4cd2ff907cb327865":"750000000000000000000","0xfd2872d19e57853cfa16effe93d0b1d47b4f93fb":"4000000000000000000000","0x63c8dfde0b8e01dadc2e748c824cc0369df090b3":"3880000000000000000000","0xc4dd048bfb840e2bc85cb53fcb75abc443c7e90f":"3716000000000000000000","0xf579714a45eb8f52c3d57bbdefd2c15b2e2f11df":"1560000000000000000000","0xcc7b0481cc32e6faef2386a07022bcb6d2c3b4fc":"3160000000000000000000","0xa0aa5f0201f04d3bbeb898132f7c11679466d901":"36600000000000000000","0xf3df63a97199933330383b3ed7570b96c4812334":"2000000000000000000000","0x42732d8ef49ffda04b19780fd3c18469fb374106":"425068000000000000000","0x6f92d6e4548c78996509ee684b2ee29ba3c532b4":"1000000000000000000000","0xfff4bad596633479a2a29f9a8b3f78eefd07e6ee":"100000000000000000000","0xac4460a76e6db2b9fcd152d9c7718d9ac6ed8c6f":"200000000000000000000","0x553b6b1c57050e88cf0c31067b8d4cd1ff80cb09":"400000000000000000000","0x84b6b6adbe2f5b3e2d682c66af1bc4905340c3ed":"619333000000000000000","0x9f4a7195ac7c151ca258cafda0cab083e049c602":"1537100000000000000000","0x2955c357fd8f75d5159a3dfa69c5b87a359dea8c":"2000000000000000000000","0x11d7844a471ef89a8d877555583ceebd1439ea26":"10098000000000000000000","0x34b454416e9fb4274e6addf853428a0198d62ee1":"407000000000000000000","0x308dd21cebe755126704b48c0f0dc234c60ba9b1":"200000000000000000000","0x381db4c8465df446a4ce15bf81d47e2f17c980bf":"32000000000000000000000","0x1abc4e253b080aeb437984ab05bca0979aa43e1c":"1000000000000000000000","0x53e35b12231f19c3fd774c88fec8cbeedf1408b2":"512000000000000000000","0x69e2e2e704307ccc5b5ca3f164fece2ea7b2e512":"7000000000000000000000","0x1914f1eb95d1277e93b6e61b668b7d77f13a11a1":"970000000000000000000","0x50e13023bd9ca96ad4c53fdfd410cb6b1f420bdf":"200000000000000000000","0x46224f32f4ece5c8867090d4409d55e50b18432d":"6000000000000000000000","0xff83855051ee8ffb70b4817dba3211ed2355869d":"400000000000000000000","0xfb39189af876e762c71d6c3e741893df226cedd6":"4000000000000000000000","0x9875623495a46cdbf259530ff838a1799ec38991":"2000000000000000000000","0xe1b39b88d9900dbc4a6cdc481e1060080a8aec3c":"2000000000000000000000","0x5baf6d749620803e8348af3710e5c4fbf20fc894":"5003680000000000000000","0x9c54e4ed479a856829c6bb42da9f0b692a75f728":"7520000000000000000000","0x486a6c8583a84484e3df43a123837f8c7e2317d0":"323378000000000000000","0xd235d15cb5eceebb61299e0e827fa82748911d89":"4000000000000000000000","0x47d792a756779aedf1343e8883a6619c6c281184":"2000000000000000000000","0x70c213488a020c3cfb39014ef5ba6404724bcaa3":"1940000000000000000000","0x133c490fa5bf7f372888e607d958fab7f955bae1":"1580000000000000000000","0xa9e194661aac704ee9dea043974e9692ded84a5d":"482400000000000000000","0xbc6b58364bf7f1951c309e0cba0595201cd73f9a":"1812400000000000000000","0x2309d34091445b3232590bd70f4f10025b2c9509":"10000000000000000000000","0xd89bc271b27ba3ab6962c94a559006ae38d5f56a":"2000000000000000000000","0xff0e2fec304207467e1e3307f64cbf30af8fd9cd":"2000000000000000000000","0xc0b0b7a8a6e1acdd05e47f94c09688aa16c7ad8d":"64234000000000000000","0xb66f92124b5e63035859e390628869dbdea9485e":"9850000000000000000000","0xa9e6e25e656b762558619f147a21985b8874edfe":"2000000000000000000000","0xa43e1947a9242b355561c30a829dfeeca2815af8":"3878255000000000000000","0x8b20ad3b94656dbdc0dd21a393d8a7d9e02138cb":"3000000000000000000000","0xaca2a838330b17302da731d30db48a04f0f207c1":"1337000000000000000000","0xfa60868aafd4ff4c5c57914b8ed58b425773dfa9":"8557400000000000000000","0x1848003c25bfd4aa90e7fcb5d7b16bcd0cffc0d8":"1000000000000000000000","0xb4b185d943ee2b58631e33dff5af6854c17993ac":"1000000000000000000000","0x7719888795ad745924c75760ddb1827dffd8cda8":"1999980000000000000000","0xccd521132d986cb96869842622a7dda26c3ed057":"2000000000000000000000","0x253e32b74ea4490ab92606fda0aa257bf23dcb8b":"10000000000000000000000","0x3712367e5e55a96d5a19168f6eb2bc7e9971f869":"1000000000000000000000","0x8f29a14a845ad458f2d108b568d813166bcdf477":"10000000000000000000000","0x51a8c2163602a32ee24cf4aa97fd9ea414516941":"62904000000000000000","0x61cea71fa464d62a07063f920b0cc917539733d8":"1670000000000000000000","0x6f81f3abb1f933b1df396b8e9cc723a89b7c9806":"280000000000000000000","0x61b1b8c012cd4c78f698e470f90256e6a30f48dd":"200000000000000000000","0x4f3f2c673069ac97c2023607152981f5cd6063a0":"600000000000000000000","0xe2efa5fca79538ce6068bf31d2c516d4d53c08e5":"131200000000000000000","0x2383c222e67e969190d3219ef14da37850e26c55":"2000000000000000000000","0xeac3af5784927fe9a598fc4eec38b8102f37bc58":"1000000000000000000000","0x4fe56ab3bae1b0a44433458333c4b05a248f8241":"2180000000000000000000","0xfe9cfc3bb293ddb285e625f3582f74a6b0a5a6cd":"1970000000000000000000","0xf48e1f13f6af4d84b371d7de4b273d03a263278e":"600000000000000000000","0x1ba9228d388727f389150ea03b73c82de8eb2e09":"7258000000000000000000","0x37a7a6ff4ea3d60ec307ca516a48d3053bb79cbb":"2000000000000000000000","0xe33840d8bca7da98a6f3d096d83de78b70b71ef8":"2000000000000000000000","0x8e7fd23848f4db07906a7d10c04b21803bb08227":"1000000000000000000000","0x07d4334ec385e8aa54eedaeadb30022f0cdfa4ab":"2629946000000000000000","0xd4b085fb086f3d0d68bf12926b1cc3142cae8770":"3700000000000000000000","0x5a87f034e6f68f4e74ffe60c64819436036cf7d7":"20000000000000000000","0xc00ab080b643e1c2bae363e0d195de2efffc1c44":"500000000000000000000","0x22f3c779dd79023ea92a78b65c1a1780f62d5c4a":"1970000000000000000000","0xc7d5c7054081e918ec687b5ab36e973d18132935":"182000000000000000000","0x9662ee021926682b31c5f200ce457abea76c6ce9":"670500000000000000000","0x116a09df66cb150e97578e297fb06e13040c893c":"2000000000000000000000","0xb7240af2af90b33c08ae9764103e35dce3638428":"8464547000000000000000","0xe8b28acda971725769db8f563d28666d41ddab6c":"10000000000000000000000","0x17d4918dfac15d77c47f9ed400a850190d64f151":"2000000000000000000000","0xc42250b0fe42e6b7dcd5c890a6f0c88f5f5fb574":"149800000000000000000","0x5da2a9a4c2c0a4a924cbe0a53ab9d0c627a1cfa0":"733202000000000000000","0x5869fb867d71f1387f863b698d09fdfb87c49b5c":"3666000000000000000000","0xd49a75bb933fca1fca9aa1303a64b6cb44ea30e1":"10000000000000000000000","0x76331e30796ce664b2700e0d4153700edc869777":"2000000000000000000000","0x8a5fb75793d043f1bcd43885e037bd30a528c927":"356500000000000000000","0xfc0ee6f7c2b3714ae9916c45566605b656f32441":"1760000000000000000000","0xbf50ce2e264b9fe2b06830617aedf502b2351b45":"1000000000000000000000","0x0f6000de1578619320aba5e392706b131fb1de6f":"499986000000000000000","0xc953f934c0eb2d0f144bdab00483fd8194865ce7":"2000000000000000000000","0x24fd9a6c874c2fab3ff36e9afbf8ce0d32c7de92":"1337000000000000000000","0xc6cd68ec35362c5ad84c82ad4edc232125912d99":"27750000000000000000000","0x2a67660a1368efcd626ef36b2b1b601980941c05":"133700000000000000000","0x9deb39027af877992b89f2ec4a1f822ecdf12693":"2000000000000000000000","0xc12f881fa112b8199ecbc73ec4185790e614a20f":"2000000000000000000000","0xd58a52e078a805596b0d56ea4ae1335af01c66eb":"267400000000000000000","0x4d7cfaa84cb33106800a8c802fb8aa463896c599":"1790000000000000000000","0x0ee391f03c765b11d69026fd1ab35395dc3802a0":"200000000000000000000","0xa192f06ab052d5fd7f94eea8318e827815fe677a":"131400000000000000000","0x8f0ab894bd3f4e697dbcfb859d497a9ba195994a":"39501652000000000000000","0x387eeafd6b4009deaf8bd5b85a72983a8dcc3487":"4000000000000000000000","0x03b0f17cd4469ddccfb7da697e82a91a5f9e7774":"20000000000000000000","0x11172b278ddd44eea2fdf4cb1d16962391c453d9":"935900000000000000000000","0x33d172ab075c51db1cd40a8ca8dbff0d93b843bb":"5727139000000000000000","0x909b5e763a39dcc795223d73a1dbb7d94ca75ac8":"2000000000000000000000","0x0ca12ab0b9666cf0cec6671a15292f2653476ab2":"210000600000000000000000","0x6b5ae7bf78ec75e90cb503c778ccd3b24b4f1aaf":"800000000000000000000","0xd9e3857efd1e202a441770a777a49dcc45e2e0d3":"223500000000000000000","0xd703c6a4f11d60194579d58c2766a7ef16c30a29":"2000000000000000000000","0x838bd565f99fde48053f7917fe333cf84ad548ab":"200000000000000000000","0x8168edce7f2961cf295b9fcd5a45c06cdeda6ef5":"200000000000000000000","0xde50868eb7e3c71937ec73fa89dd8b9ee10d45aa":"1000000000000000000000","0x087498c0464668f31150f4d3c4bcdda5221ba102":"20000000000000000000","0x613fab44b16bbe554d44afd178ab1d02f37aeaa5":"2000000000000000000000","0xe2ee691f237ee6529b6557f2fcdd3dcf0c59ec63":"5450048000000000000000","0xa9ed377b7d6ec25971c1a597a3b0f3bead57c98f":"400000000000000000000","0x175feeea2aa4e0efda12e1588d2f483290ede81a":"200000000000000000000","0xb51ddcb4dd4e8ae6be336dd9654971d9fec86b41":"421133000000000000000","0x92c0f573eccf62c54810ee6ba8d1f113542b301b":"3384000000000000000000","0xa109e18bb0a39c9ef82fa19597fc5ed8e9eb6d58":"1640000000000000000000","0xf74e6e145382b4db821fe0f2d98388f45609c69f":"100000000000000000000","0x378f37243f3ff0bef5e1dc85eb4308d9340c29f9":"2000200000000000000000","0x84e9949680bece6841b9a7e5250d08acd87d16cd":"200000000000000000000","0x882bd3a2e9d74110b24961c53777f22f1f46dc5d":"13370000000000000000000","0xacce01e0a70610dc70bb91e9926fa9957f372fba":"537000000000000000000","0xc5f687717246da8a200d20e5e9bcac60b67f3861":"28650000000000000000","0xe14617f6022501e97e7b3e2d8836aa61f0ff2dba":"200000000000000000000","0x076ee99d3548623a03b5f99859d2d785a1778d48":"200000000000000000000","0x2c424ee47f583cdce07ae318b6fad462381d4d2b":"4000000000000000000000","0xf98250730c4c61c57f129835f2680894794542f3":"4000000000000000000000","0xed1b24b6912d51b334ac0de6e771c7c0454695ea":"40000000000000000000","0xffd5170fd1a8118d558e7511e364b24906c4f6b3":"60085000000000000000","0xbf49c14898316567d8b709c2e50594b366c6d38c":"733202000000000000000","0x65ea26eabbe2f64ccccfe06829c25d4637520225":"700000000000000000000","0x5c5419565c3aad4e714e0739328e3521c98f05cc":"528000000000000000000","0xc53b50fd3b2b72bc6c430baf194a515585d3986d":"20000000000000000000","0x2b74c373d04bfb0fd60a18a01a88fbe84770e58c":"40000000000000000000","0xd97f4526dea9b163f8e8e33a6bcf92fb907de6ec":"284000000000000000000","0xa4a49f0bc8688cc9e6dc04e1e08d521026e65574":"200000000000000000000","0x575c00c2818210c28555a0ff29010289d3f82309":"10000000000000000000000","0x3f1233714f204de9de4ee96d073b368d8197989f":"38606000000000000000","0xf964d98d281730ba35b2e3a314796e7b42fedf67":"1543800000000000000000","0x1deec01abe5c0d952de9106c3dc30639d85005d6":"2000000000000000000000","0x12d60d65b7d9fc48840be5f891c745ce76ee501e":"21359400000000000000000","0x5c6136e218de0a61a137b2b3962d2a6112b809d7":"294273000000000000000","0xcd43258b7392a930839a51b2ef8ad23412f75a9f":"2000000000000000000000","0xdb3f258ab2a3c2cf339c4499f75a4bd1d3472e9e":"1500000000000000000000","0x0edd4b580ff10fe06c4a03116239ef96622bae35":"197000000000000000000","0x1d157c5876c5cad553c912caf6ce2d5277e05c73":"2000000000000000000000","0xcda1b886e3a795c9ba77914e0a2fe5676f0f5ccf":"106024000000000000000","0xf50cbafd397edd556c0678988cb2af5c2617e0a2":"716000000000000000000","0x327bb49e754f6fb4f733c6e06f3989b4f65d4bee":"20000000000000000000","0xc44bdec8c36c5c68baa2ddf1d431693229726c43":"100000000000000000000000","0x34e2849bea583ab0cc37975190f322b395055582":"7780340000000000000000","0x9221c9ce01232665741096ac07235903ad1fe2fc":"126489000000000000000","0xff3ded7a40d3aff0d7a8c45fa6136aa0433db457":"1999800000000000000000","0x10b5b34d1248fcf017f8c8ffc408ce899ceef92f":"267400000000000000000","0xf1a1f320407964fd3c8f2e2cc8a4580da94f01ea":"2000040000000000000000","0x6c800d4b49ba07250460f993b8cbe00b266a2553":"492500000000000000000","0xf827d56ed2d32720d4abf103d6d0ef4d3bcd559b":"26265000000000000000","0xffb9c7217e66743031eb377af65c77db7359dcda":"40000000000000000000","0x530319db0a8f93e5bb7d4dbf4816314fbed8361b":"2000000000000000000000","0x9c28a2c4086091cb5da226a657ce3248e8ea7b6f":"280000000000000000000","0xdb23a6fef1af7b581e772cf91882deb2516fc0a7":"200000000000000000000","0x6636d7ac637a48f61d38b14cfd4865d36d142805":"500000000000000000000","0xb3c260609b9df4095e6c5dff398eeb5e2df49985":"254030000000000000000","0x58e5c9e344c806650dacfc904d33edba5107b0de":"19100000000000000000","0x4f67396d2553f998785f704e07a639197dd1948d":"300080000000000000000","0x510d8159cc945768c7450790ba073ec0d9f89e30":"2560000000000000000000","0x593c48935beaff0fde19b04d309cd530a28e52ce":"4000000000000000000000","0xc27f4e08099d8cf39ee11601838ef9fc06d7fc41":"1790000000000000000000","0x07723e3c30e8b731ee456a291ee0e798b0204a77":"2000000000000000000000","0x0a652e2a8b77bd97a790d0e91361c98890dbb04e":"1000000000000000000000","0x671015b97670b10d5e583f3d62a61c1c79c5143f":"400000000000000000000","0x7cc24a6a958c20c7d1249660f7586226950b0d9a":"1970000000000000000000","0x6ef9e8c9b6217d56769af97dbb1c8e1b8be799d2":"182000000000000000000","0x5c4368918ace6409c79eca80cdaae4391d2b624e":"4000000000000000000000","0x043707071e2ae21eed977891dc79cd5d8ee1c2da":"2000000000000000000000","0x39bfd978689bec048fc776aa15247f5e1d7c39a2":"20000000000000000000000","0x05915d4e225a668162aee7d6c25fcfc6ed18db03":"66348000000000000000","0x3f551ba93cd54693c183fb9ad60d65e1609673c9":"2000000000000000000000","0xa8c0b02faf02cb5519dda884de7bbc8c88a2da81":"16700000000000000000","0xbd0c5cd799ebc48642ef97d74e8e429064fee492":"326000000000000000000","0x0a931b449ea8f12cdbd5e2c8cc76bad2c27c0639":"23031000000000000000","0x2ea5fee63f337a376e4b918ea82148f94d48a626":"1864242000000000000000","0xcc6c2df00e86eca40f21ffda1a67a1690f477c65":"3160000000000000000000","0xe5e37e19408f2cfbec83349dd48153a4a795a08f":"4200000000000000000000","0xf555a27bb1e2fd4e2cc784caee92939fc06e2fc9":"2000000000000000000000","0xdcf9719be87c6f46756db4891db9b611d2469c50":"1000000000000000000000","0x8e2f9034c9254719c38e50c9aa64305ed696df1e":"4728000000000000000000","0xa01f12d70f44aa7b113b285c22dcdb45873454a7":"18200000000000000000","0xbce40475d345b0712dee703d87cd7657fc7f3b62":"7750000000000000000000","0xbb19bf91cbad74cceb5f811db27e411bc2ea0656":"17600000000000000000","0xacc062702c59615d3444ef6214b8862b009a02ed":"1499936000000000000000","0x449ac4fbe383e36738855e364a57f471b2bfa131":"197000000000000000000000","0xad59a78eb9a74a7fbdaefafa82eada8475f07f95":"500000000000000000000","0x6b6577f3909a4d6de0f411522d4570386400345c":"1880000000000000000000","0x79bf2f7b6e328aaf26e0bb093fa22da29ef2f471":"1790000000000000000000","0x940f715140509ffabf974546fab39022a41952d2":"1400000000000000000000","0x1d572edd2d87ca271a6714c15a3b37761dcca005":"127674000000000000000","0xd78ecd25adc86bc2051d96f65364866b42a426b7":"3877300000000000000000","0xf9729d48282c9e87166d5eef2d01eda9dbf78821":"99981000000000000000","0x17762560e82a93b3f522e0e524adb8612c3a7470":"1000000000000000000000","0xd500e4d1c9824ba9f5b635cfa3a8c2c38bbd4ced":"400000000000000000000","0xa11effab6cf0f5972cffe4d56596e98968144a8f":"1670000000000000000000","0xf64ecf2117931c6d535a311e4ffeaef9d49405b8":"2674000000000000000000","0x229cc4711b62755ea296445ac3b77fc633821cf2":"39481000000000000000","0xfc989cb487bf1a7d17e4c1b7c4b7aafdda6b0a8d":"20000000000000000000","0xea8527febfa1ade29e26419329d393b940bbb7dc":"1999944000000000000000","0xbce13e22322acfb355cd21fd0df60cf93add26c6":"200000000000000000000","0x19ff244fcfe3d4fa2f4fd99f87e55bb315b81eb6":"200000000000000000000","0xd2581a55ce23ab10d8ad8c44378f59079bd6f658":"8800000000000000000000","0x4073fa49b87117cb908cf1ab512da754a932d477":"1970000000000000000000","0xb6a82933c9eadabd981e5d6d60a6818ff806e36b":"400000000000000000000","0xc79806032bc7d828f19ac6a640c68e3d820fa442":"20000000000000000000","0x577b2d073c590c50306f5b1195a4b2ba9ecda625":"373600000000000000000","0x7f13d760498d7193ca6859bc95c901386423d76c":"5000000000000000000000","0x416784af609630b070d49a8bcd12235c6428a408":"20000000000000000000000","0xfbe71622bcbd31c1a36976e7e5f670c07ffe16de":"400000000000000000000","0xa5698035391e67a49013c0002079593114feb353":"240000000000000000000","0xab2871e507c7be3965498e8fb462025a1a1c4264":"775000000000000000000","0x9c78fbb4df769ce2c156920cfedfda033a0e254a":"1970000000000000000000","0x95e6f93dac228bc7585a25735ac2d076cc3a4017":"6000000000000000000000","0x3c1f91f301f4b565bca24751aa1f761322709ddd":"1790000000000000000000","0xf77f9587ff7a2d7295f1f571c886bd33926a527c":"1999800000000000000000","0x755f587e5efff773a220726a13d0f2130d9f896b":"1000000000000000000000","0x8c6aa882ee322ca848578c06cb0fa911d3608305":"600000000000000000000","0x492cb5f861b187f9df21cd4485bed90b50ffe22d":"499928000000000000000","0x95a577dc2eb3ae6cb9dfc77af697d7efdfe89a01":"136000000000000000000","0x4173419d5c9f6329551dc4d3d0ceac1b701b869e":"88000000000000000000","0x456ae0aca48ebcfae166060250525f63965e760f":"300000000000000000000","0x81f8de2c283d5fd4afbda85dedf9760eabbbb572":"3000000000000000000000","0xcd0af3474e22f069ec3407870dd770443d5b12b0":"2626262000000000000000","0x283c2314283c92d4b064f0aef9bb5246a7007f39":"200000000000000000000","0x29b3f561ee7a6e25941e98a5325b78adc79785f3":"100000000000000000000","0xcd4306d7f6947ac1744d4e13b8ef32cb657e1c00":"499986000000000000000","0xd9ec2efe99ff5cf00d03a8317b92a24aef441f7e":"2000000000000000000000","0x83dbf8a12853b40ac61996f8bf1dc8fdbaddd329":"970000000000000000000","0x9d93fab6e22845f8f45a07496f11de71530debc7":"1998000000000000000000","0xfd204f4f4aba2525ba728afdf78792cbdeb735ae":"2000000000000000000000","0x99fad50038d0d9d4c3fbb4bce05606ecadcd5121":"2000000000000000000000","0xd206aaddb336d45e7972e93cb075471d15897b5d":"600000000000000000000","0x428a1ee0ed331d7952ccbe1c7974b2852bd1938a":"2208370000000000000000","0x690228e4bb12a8d4b5e0a797b0c5cf2a7509131e":"1880000000000000000000","0xfa3a1aa4488b351aa7560cf5ee630a2fd45c3222":"878850000000000000000","0x0372e852582e0934344a0fed2178304df25d4628":"20000000000000000000000","0x35ea2163a38cdf9a123f82a5ec00258dae0bc767":"4000000000000000000000","0xd1fed0aee6f5dfd7e25769254c3cfad15adeccaa":"730000000000000000000","0xc05b740620f173f16e52471dc38b9c514a0b1526":"140000000000000000000","0x87e3062b2321e9dfb0875ce3849c9b2e3522d50a":"10000000000000000000000","0x303fbaebbe46b35b6e5b74946a5f99bc1585cae7":"878148000000000000000","0xe7a8e471eafb798f4554cc6e526730fd56e62c7d":"1000000000000000000000","0xad7dd053859edff1cb6f9d2acbed6dd5e332426f":"1970000000000000000000","0xdc4345d6812e870ae90c568c67d2c567cfb4f03c":"6700000000000000000000","0xa6a08252c8595177cc2e60fc27593e2379c81fb1":"20055000000000000000","0xa9af21acbe482f8131896a228036ba51b19453c3":"49999000000000000000","0x86e3fe86e93da486b14266eadf056cbfa4d91443":"2000000000000000000000","0x744b03bba8582ae5498e2dc22d19949467ab53fc":"500000000000000000000","0xd3118ea3c83505a9d893bb67e2de142d537a3ee7":"20000000000000000000","0xb32f1c2689a5ce79f1bc970b31584f1bcf2283e7":"20000000000000000000","0x4828e4cbe34e1510afb72c2beeac8a4513eaebd9":"3940000000000000000000","0xb07bcc085ab3f729f24400416837b69936ba8873":"2000140000000000000000","0xbdc74873af922b9df474853b0fa7ff0bf8c82695":"3999000000000000000000","0x15ebd1c7cad2aff19275c657c4d808d010efa0f5":"200550000000000000000","0xcbc04b4d8b82caf670996f160c362940d66fcf1a":"6000000000000000000000","0x8197948121732e63d9c148194ecad46e30b749c8":"4000000000000000000000","0x69797bfb12c9bed682b91fbc593591d5e4023728":"10000000000000000000000","0xbe9b8c34b78ee947ff81472eda7af9d204bc8466":"150000000000000000000","0xdf3f57b8ee6434d047223def74b20f63f9e4f955":"250500000000000000000","0xa3ae1879007d801cb5f352716a4dd8ba2721de3d":"200000000000000000000000","0xcb4bb1c623ba28dc42bdaaa6e74e1d2aa1256c2a":"1999944000000000000000","0xe03c00d00388ecbf4f263d0ac778bb41a57a40d9":"1000072000000000000000","0xfc2c1f88961d019c3e9ea33009152e0693fbf88a":"8000000000000000000000","0x8599cbd5a6a9dcd4b966be387d69775da5e33c6f":"58180000000000000000000","0xb7a31a7c38f3db09322eae11d2272141ea229902":"2000000000000000000000","0x231a15acc199c89fa9cb22441cc70330bdcce617":"500000000000000000000","0x3fbed6e7e0ca9c84fbe9ebcf9d4ef9bb49428165":"2000000000000000000000","0x92cfd60188efdfb2f8c2e7b1698abb9526c1511f":"2000000000000000000000","0x5c936f3b9d22c403db5e730ff177d74eef42dbbf":"75000000000000000000","0x931fe712f64207a2fd5022728843548bfb8cbb05":"2000000000000000000000","0x08d54e83ad486a934cfaeae283a33efd227c0e99":"1039000000000000000000","0xa339a3d8ca280e27d2415b26d1fc793228b66043":"1013600000000000000000","0x581f34b523e5b41c09c87c298e299cbc0e29d066":"1131607000000000000000","0xcaaa68ee6cdf0d34454a769b0da148a1faaa1865":"7216000000000000000000","0x0838a7768d9c2aca8ba279adfee4b1f491e326f1":"200000000000000000000","0xdde77a4740ba08e7f73fbe3a1674912931742eeb":"19867021000000000000000","0xcbe810fe0fecc964474a1db97728bc87e973fcbd":"10000000000000000000000","0x86c28b5678af37d727ec05e4447790f15f71f2ea":"200000000000000000000","0xdd6c062193eac23d2fdbf997d5063a346bb3b470":"20000000000000000000","0x5975b9528f23af1f0e2ec08ac8ebaa786a2cb8e0":"345827000000000000000","0xe29d8ae452dcf3b6ac645e630409385551faae0a":"80276000000000000000","0x2fbc85798a583598b522166d6e9dda121d627dbc":"200000000000000000000","0x7a36aba5c31ea0ca7e277baa32ec46ce93cf7506":"20000000000000000000000","0xdbcbcd7a57ea9db2349b878af34b1ad642a7f1d1":"200000000000000000000","0x92aae59768eddff83cfe60bb512e730a05a161d7":"1708015000000000000000","0xa5e93b49ea7c509de7c44d6cfeddef5910deaaf2":"2000000000000000000000","0xe33d980220fab259af6a1f4b38cf0ef3c6e2ea1a":"2000000000000000000000","0x8ed0af11ff2870da0681004afe18b013f7bd3882":"4000000000000000000000","0xf23e5c633221a8f7363e65870c9f287424d2a960":"1380000000000000000000","0x96334bfe04fffa590213eab36514f338b864b736":"400000000000000000000","0xfa1f1971a775c3504fef5079f640c2c4bce7ac05":"2000000000000000000000","0xdf44c47fc303ac76e74f97194cca67b5bb3c023f":"591000000000000000000","0x4b74f5e58e2edf76daf70151964a0b8f1de0663c":"324020000000000000000","0xe38b91b35190b6d9deed021c30af094b953fdcaa":"33340000000000000000","0x6b38de841fad7f53fe02da115bd86aaf662466bd":"1730000000000000000000","0x11675a25554607a3b6c92a9ee8f36f75edd3e336":"159800000000000000000","0x0ba8705bf55cf219c0956b5e3fc01c4474a6cdc1":"94963000000000000000","0x0f05f120c89e9fbc93d4ab0c5e2b4a0df092b424":"30000000000000000000000","0xfdd1195f797d4f35717d15e6f9810a9a3ff55460":"18200000000000000000","0x63a61dc30a8e3b30a763c4213c801cbf98738178":"1000000000000000000000","0xe5bdf34f4ccc483e4ca530cc7cf2bb18febe92b3":"126260000000000000000","0xd6e09e98fe1300332104c1ca34fbfac554364ed9":"2000000000000000000000","0x5bd6862d517d4de4559d4eec0a06cad05e2f946e":"200000000000000000000","0x7294ec9da310bc6b4bbdf543b0ef45abfc3e1b4d":"22000000000000000000000","0xae34861d342253194ffc6652dfde51ab44cad3fe":"466215000000000000000","0xf50ae7fab4cfb5a646ee04ceadf9bf9dd5a8e540":"3999952000000000000000","0xdd2bdfa917c1f310e6fa35aa8af16939c233cd7d":"400000000000000000000","0xe0060462c47ff9679baef07159cae08c29f274a9":"2000000000000000000000","0xb7d12e84a2e4c4a6345af1dd1da9f2504a2a996e":"200000000000000000000","0xf5500178cb998f126417831a08c2d7abfff6ab5f":"1308923000000000000000","0xfd377a385272900cb436a3bb7962cdffe93f5dad":"2000000000000000000000","0xa4a83a0738799b971bf2de708c2ebf911ca79eb2":"600000000000000000000","0x52a5e4de4393eeccf0581ac11b52c683c76ea15d":"19999800000000000000000","0xb07fdeaff91d4460fe6cd0e8a1b0bd8d22a62e87":"5260000000000000000000","0x35f5860149e4bbc04b8ac5b272be55ad1aca58e0":"200000000000000000000","0xfb135eb15a8bac72b69915342a60bbc06b7e077c":"20000000000000000000000","0x02d4a30968a39e2b3498c3a6a4ed45c1c6646822":"2000000000000000000000","0xe44b7264dd836bee8e87970340ed2b9aed8ed0a5":"5772100000000000000000","0xe90a354cec04d69e5d96ddc0c5138d3d33150aa0":"499971000000000000000","0x693d83be09459ef8390b2e30d7f7c28de4b4284e":"2000000000000000000000","0x87bf7cd5d8a929e1c785f9e5449106ac232463c9":"77800000000000000000","0xe5f8ef6d970636b0dcaa4f200ffdc9e75af1741c":"2000000000000000000000","0xfef09d70243f39ed8cd800bf9651479e8f4aca3c":"200000000000000000000","0xe98c91cadd924c92579e11b41217b282956cdaa1":"135800000000000000000","0xc2836188d9a29253e0cbda6571b058c289a0bb32":"2000000000000000000000","0xafa6946effd5ff53154f82010253df47ae280ccc":"1970000000000000000000","0x43c7ebc5b3e7af16f47dc5617ab10e0f39b4afbb":"1910000000000000000000","0x097ecda22567c2d91cb03f8c5215c22e9dcda949":"20055000000000000000","0x3e66b84769566ab67945d5fa81373556bcc3a1fa":"152000000000000000000","0x56373daab46316fd7e1576c61e6affcb6559ddd7":"215340000000000000000","0xfaaeba8fc0bbda553ca72e30ef3d732e26e82041":"1338337000000000000000","0xf54c19d9ef3873bfd1f7a622d02d86249a328f06":"44284729000000000000000","0x825309a7d45d1812f51e6e8df5a7b96f6c908887":"2365000000000000000000","0x89009e3c6488bd5e570d1da34eabe28ed024de1b":"20000000000000000000000","0x63977cad7d0dcdc52b9ac9f2ffa136e8642882b8":"75000000000000000000","0xc239abdfae3e9af5457f52ed2b91fd0ab4d9c700":"2000000000000000000000","0x1a4ec6a0ae7f5a9427d23db9724c0d0cffb2ab2f":"179000000000000000000","0xa12a6c2d985daf0e4f5f207ae851aaf729b332cd":"100000000000000000000000","0xcbe52fc533d7dd608c92a260b37c3f45deb4eb33":"1000000000000000000000","0xabb2e6a72a40ba6ed908cdbcec3c5612583132fe":"1460000000000000000000","0x6503860b191008c15583bfc88158099301762828":"1000000000000000000000","0xa0228240f99e1de9cb32d82c0f2fa9a3d44b0bf3":"1600000000000000000000","0xe154daeadb545838cbc6aa0c55751902f528682a":"4925000000000000000000","0x8e92aba38e72a098170b92959246537a2e5556c0":"267400000000000000000","0xd23d7affacdc3e9f3dae7afcb4006f58f8a44600":"3600000000000000000000","0x00d78d89b35f472716eceafebf600527d3a1f969":"27750000000000000000000","0x120f9de6e0af7ec02a07c609ca8447f157e6344c":"267400000000000000000","0xe0352fdf819ba265f14c06a6315c4ac1fe131b2e":"1000000000000000000000","0x8f47328ee03201c9d35ed2b5412b25decc859362":"2000000000000000000000","0x453e359a3397944c5a275ab1a2f70a5e5a3f6989":"240000000000000000000","0x9bf58efbea0784eb068adecfa0bb215084c73a35":"5800000000000000000000","0x21bfe1b45cacde6274fd8608d9a178bf3eeb6edc":"2009400000000000000000","0xd1d5b17ffe2d7bbb79cc7d7930bcb2e518fb1bbf":"3000000000000000000000","0x20a29c5079e26b3f18318bb2e50e8e8b346e5be8":"499986000000000000000","0x7d392852f3abd92ff4bb5bb26cb60874f2be6795":"1000070000000000000000","0x55852943492970f8d629a15366cdda06a94f4513":"2000000000000000000000","0xab5dfc1ea21adc42cf8c3f6e361e243fd0da61e5":"300000000000000000000","0x9d2bfc36106f038250c01801685785b16c86c60d":"380000000000000000000000","0x6e60aee1a78f8eda8b424c73e353354ae67c3042":"3490300000000000000000","0x7e29290038493559194e946d4e460b96fc38a156":"309072000000000000000","0x6006e36d929bf45d8f16231b126a011ae283d925":"176000000000000000000","0xd6d03572a45245dbd4368c4f82c95714bd2167e2":"1162200000000000000000","0xd1432538e35b7664956ae495a32abdf041a7a21c":"19700000000000000000000","0x2276264bec8526c0c0f270677abaf4f0e441e167":"1000000000000000000000","0xc8814e34523e38e1f927a7dce8466a447a093603":"10000000000000000000000","0x688a569e965524eb1d0ac3d3733eab909fb3d61e":"1320000000000000000000","0x90dc09f717fc2a5b69fd60ba08ebf40bf4e8246c":"4000086000000000000000","0x239a733e6b855ac592d663156186a8a174d2449e":"1637020000000000000000","0xbcdfacb9d9023c3417182e9100e8ea1d373393a3":"59100000000000000000","0xba6440aeb3737b8ef0f1af9b0c15f4c214ffc7cf":"1000000000000000000000","0x322e5c43b0f524389655a9b3ff24f2d4db3da10f":"4650000000000000000000","0xbe5a60689998639ad75bc105a371743eef0f7940":"501700000000000000000","0xb727a9fc82e1cffc5c175fa1485a9befa2cdbdd1":"999000000000000000000","0xa3883a24f7f166205f1a6a9949076c26a76e7178":"1820000000000000000000","0x5e95fe5ffcf998f9f9ac0e9a81dab83ead77003d":"539766000000000000000","0xe60955dc0bc156f6c41849f6bd776ba44b0ef0a1":"299982000000000000000","0xaf203e229d7e6d419df4378ea98715515f631485":"1970000000000000000000","0x86499a1228ff2d7ee307759364506f8e8c8307a5":"1970000000000000000000","0x1a04cec420ad432215246d77fe178d339ed0b595":"316000000000000000000","0xcc2b5f448f3528d3fe41cc7d1fa9c0dc76f1b776":"60000000000000000000","0xcb50587412822304ebcba07dab3a0f09fffee486":"1370000000000000000000","0x4ae2a04d3909ef454e544ccfd614bfefa71089ae":"442800000000000000000","0xc8a2c4e59e1c7fc54805580438aed3e44afdf00e":"44000000000000000000","0x5792814f59a33a1843faa01baa089eb02ffb5cf1":"499986000000000000000","0xa1f2854050f872658ed82e52b0ad7bbc1cb921f6":"2010918000000000000000","0x92dca5e102b3b81b60f1a504634947c374a88ccb":"2000000000000000000000","0x732fead60f7bfdd6a9dec48125e3735db1b6654f":"20000000000000000000","0x6bf7b3c065f2c1e7c6eb092ba0d15066f393d1b8":"400000000000000000000","0xcde36d81d128c59da145652193eec2bfd96586ef":"4000000000000000000000","0x40eddb448d690ed72e05c225d34fc8350fa1e4c5":"7000000000000000000000","0x454b61b344c0ef965179238155f277c3829d0b38":"2000000000000000000000","0xac3da526cfce88297302f34c49ca520dc271f9b2":"800000000000000000000","0xc989eec307e8839b9d7237cfda08822962abe487":"400000000000000000000","0xe99de258a4173ce9ac38ede26c0b3bea3c0973d5":"1656800000000000000000","0xff0cb06c42e3d88948e45bd7b0d4e291aefeea51":"1910000000000000000000","0x0990e81cd785599ea236bd1966cf526302c35b9c":"1000000000000000000000","0x6da0ed8f1d69339f059f2a0e02471cb44fb8c3bb":"935900000000000000000","0x5d958a9bd189c2985f86c58a8c69a7a78806e8da":"10200000000000000000000","0x98be696d51e390ff1c501b8a0f6331b628ddc5ad":"2000000000000000000000","0x09d0b8cd077c69d9f32d9cca43b3c208a21ed48b":"150011000000000000000","0x96e7c0c9d5bf10821bf140c558a145b7cac21397":"1056000000000000000000","0x5b736eb18353629bde9676dadd165034ce5ecc68":"1970000000000000000000","0xe5a365343cc4eb1e770368e1f1144a77b832d7e0":"20000000000000000000","0x4cf5537b85842f89cfee359eae500fc449d2118f":"1000000000000000000000","0xc71f1d75873f33dcb2dd4b3987a12d0791a5ce27":"1015200000000000000000","0x9bf703b41c3624e15f4054962390bcba3052f0fd":"6055000000000000000000","0x145e1de0147911ccd880875fbbea61f6a142d11d":"4000000000000000000000","0x68419c6dd2d3ce6fcbb3c73e2fa079f06051bde6":"1970000000000000000000","0xd8eb78503ec31a54a90136781ae109004c743257":"1000000000000000000000","0xf25e4c70bc465632c89e5625a832a7722f6bffab":"4488000000000000000000","0x7b4d2a38269069c18557770d591d24c5121f5e83":"700000000000000000000","0x27d158ac3d3e1109ab6e570e90e85d3892cd7680":"100000000000000000000","0xd3679a47df2d99a49b01c98d1c3e0c987ce1e158":"280000000000000000000","0x095b949de3333a377d5019d893754a5e4656ff97":"340000000000000000000","0x6b17598a8ef54f797ae515ccb6517d1859bf8011":"100000000000000000000","0x3eaf0879b5b6db159b589f84578b6a74f6c10357":"7253657000000000000000","0x40d45d9d7625d15156c932b771ca7b0527130958":"100000000000000000000000","0x0392549a727f81655429cb928b529f25df4d1385":"26248000000000000000","0xc5b009baeaf788a276bd35813ad65b400b849f3b":"1000000000000000000000","0x6ed884459f809dfa1016e770edaf3e9fef46fa30":"3400170000000000000000","0x439d2f2f5110a4d58b1757935015408740fec7f8":"3830421000000000000000","0xdc46c13325cd8edf0230d068896486f007bf4ef1":"1337000000000000000000","0x8c54c7f8b9896e75d7d5f5c760258699957142ad":"40000000000000000000","0x61c8f1fa43bf846999ecf47b2b324dfb6b63fe3a":"800000000000000000000","0x935069444a6a984de2084e46692ab99f671fc727":"9000000000000000000000","0xfc49c1439a41d6b3cf26bb67e0365224e5e38f5f":"1000076000000000000000","0xe1dfb5cc890ee8b2877e885d267c256187d019e6":"100000000000000000000","0xee7c3ded7c28f459c92fe13b4d95bafbab02367d":"700000000000000000000","0xa5874d754635a762b381a5c4c792483af8f23d1d":"50000000000000000000","0xcfbb32b7d024350e3321fa20c9a914035372ffc6":"401100000000000000000","0x2bc429d618a66a4cf82dbb2d824e9356effa126a":"1999944000000000000000","0xdb244f97d9c44b158a40ed9606d9f7bd38913331":"102000000000000000000","0x55e220876262c218af4f56784798c7e55da09e91":"133566000000000000000","0xca41ccac30172052d522cd2f2f957d248153409f":"1970000000000000000000","0xb11fa7fb270abcdf5a2eab95aa30c4b53636efbf":"800000000000000000000","0x0ffea06d7113fb6aec2869f4a9dfb09007facef4":"225416000000000000000","0x646628a53c2c4193da88359ce718dadd92b7a48d":"200032000000000000000","0xca8409083e01b397cf12928a05b68455ce6201df":"1600000000000000000000","0xdbbcbb79bf479a42ad71dbcab77b5adfaa872c58":"1730000000000000000000","0xdb7d4037081f6c65f9476b0687d97f1e044d0a1d":"660000000000000000000","0x4be90d412129d5a4d0424361d6649d4e47a62316":"1015200000000000000000","0xe3ab3ca9b870e3f548517306bba4de2591afafc2":"1200062000000000000000","0x5c61ab79b408dd3229f662593705d72f1e147bb8":"22729000000000000000000","0x4f177f9d56953ded71a5611f393322c30279895c":"246000000000000000000","0xe6cb260b716d4c0ab726eeeb07c8707204e276ae":"1000000000000000000000","0x44355253b27748e3f34fe9cae1fb718c8f249529":"200000000000000000000","0xa309df54cabce70c95ec3033149cd6678a6fd4cf":"223600000000000000000","0xec4867d2175ab5b9469361595546554684cda460":"3000000000000000000000","0x8d06e464245cad614939e0af0845e6d730e20374":"200359000000000000000","0x9810e34a94db6ed156d0389a0e2b80f4fd6b0a8a":"2000000000000000000000","0xdcfff3e8d23c2a34b56bd1b3bd45c79374432239":"5000000000000000000000","0x7d7dd5ee614dbb6fbfbcd26305247a058c41faa1":"2000000000000000000000","0x8a9eca9c5aba8e139f8003edf1163afb70aa3aa9":"660000000000000000000","0xd942de4784f7a48716c0fd4b9d54a6e54c5f2f3e":"20000000000000000000000","0x07dae622630d1136381933d2ad6b22b839d82102":"200000000000000000000","0xabf12fa19e82f76c718f01bdca0003674523ef30":"2000000000000000000000","0x411c831cc6f44f1965ec5757ab4e5b3ca4cffd1f":"425000000000000000000","0x99129d5b3c0cde47ea0def4dfc070d1f4a599527":"2000000000000000000000","0xc5cdcee0e85d117dabbf536a3f4069bf443f54e7":"1969606000000000000000","0xf218bd848ee7f9d38bfdd1c4eb2ed2496ae4305f":"500000000000000000000","0xfe549bbfe64740189892932538daaf46d2b61d4f":"40000000000000000000","0xdc3f0e7672f71fe7525ba30b9755183a20b9166a":"9603617000000000000000","0x0e83b850481ab44d49e0a229a2e464902c69539b":"100000000000000000000","0x07ddd0422c86ef65bf0c7fc3452862b1228b08b8":"2065302000000000000000","0xa68c313445c22d919ee46cc2d0cdff043a755825":"75189000000000000000","0xa9e9dbce7a2cb03694799897bed7c54d155fdaa8":"197559000000000000000","0x18fccf62d2c3395453b7587b9e26f5cff9eb7482":"1000000000000000000000","0xff41d9e1b4effe18d8b0d1f63fc4255fb4e06c3d":"1337000000000000000000","0x8f69eafd0233cadb4059ab779c46edf2a0506e48":"1788210000000000000000","0x9aa48c66e4fb4ad099934e32022e827427f277ba":"10000000000000000000000","0xf46980e3a4a9d29a6a6e90604537a3114bcb2897":"500000000000000000000","0x801732a481c380e57ed62d6c29de998af3fa3b13":"100000000000000000000","0x0cd6a141918d126b106d9f2ebf69e102de4d3277":"20000000000000000000","0x17589a6c006a54cad70103123aae0a82135fdeb4":"4000000000000000000000","0x8725e8c753b3acbfdca55f3c62dfe1a59454968a":"1000090000000000000000","0xd20dcb0b78682b94bc3000281448d557a20bfc83":"895000000000000000000","0xe84f8076a0f2969ecd333eef8de41042986291f2":"432000000000000000000","0xb3145b74506d1a8d047cdcdc55392a7b5350799a":"129314663000000000000000","0x0d9a825ff2bcd397cbad5b711d9dcc95f1cc112d":"12800000000000000000000","0x0ca670eb2c8b96cba379217f5929c2b892f39ef6":"2000000000000000000000","0x25cfc4e25c35c13b69f7e77dbfb08baf58756b8d":"40000000000000000000000","0x182db85293f606e88988c3704cb3f0c0bbbfca5a":"133700000000000000000","0xbd73c3cbc26a175062ea0320dd84b253bce64358":"394000000000000000000","0x2680713d40808e2a50ed013150a2a694b96a7f1d":"1790000000000000000000","0x51e32f14f4ca5e287cdac057a7795ea9e0439953":"500000000000000000000","0xb1e9c5f1d21e61757a6b2ee75913fc5a1a4101c3":"2000000000000000000000","0xd4c4d1a7c3c74984f6857b2f5f07e8face68056d":"2000000000000000000000","0x4651dc420e08c3293b27d2497890eb50223ae2f4":"20000000000000000000000","0xc74a3995f807de1db01a2eb9c62e97d0548f696f":"1000000000000000000000","0x0505a08e22a109015a22f685305354662a5531d5":"2600000000000000000000","0x39c773367c8825d3596c686f42bf0d14319e3f84":"133700000000000000000","0x0f929cf895db017af79f3ead2216b1bd69c37dc7":"2000000000000000000000","0xbdd3254e1b3a6dc6cc2c697d45711aca21d516b2":"2000000000000000000000","0xae5d221afcd3d29355f508eadfca408ce33ca903":"100000000000000000000000","0x916cf17d71412805f4afc3444a0b8dd1d9339d16":"14300000000000000000","0x4319263f75402c0b5325f263be4a5080651087f0":"983086000000000000000","0x0f1c249cd962b00fd114a9349f6a6cc778d76c4d":"2000000000000000000000","0x54febcce20fe7a9098a755bd90988602a48c089e":"640000000000000000000","0x2c1800f35fa02d3eb6ff5b25285f5e4add13b38d":"906400000000000000000","0x72b904440e90e720d6ac1c2ad79c321dcc1c1a86":"1550000000000000000000","0xb0aa00950c0e81fa3210173e729aaf163a27cd71":"40000000000000000000000","0x663604b0503046e624cd26a8b6fb4742dce02a6f":"65400000000000000000","0x3c98594bf68b57351e8814ae9e6dfd2d254aa06f":"300000000000000000000","0x9c45202a25f6ad0011f115a5a72204f2f2198866":"5014000000000000000000","0xb02d062873334545cea29218e4057760590f7423":"3186000000000000000000","0x7bddb2ee98de19ee4c91f661ee8e67a91d054b97":"1000000000000000000000","0x9cf2928beef09a40f9bfc953be06a251116182fb":"6000000000000000000000","0x51b4758e9e1450e7af4268c3c7b1e7bd6f5c7550":"1000000000000000000000","0xeb570dba975227b1c42d6e8dea2c56c9ad960670":"2000000000000000000000","0x970d8b8a0016d143054f149fb3b8e550dc0797c7":"1000000000000000000000","0xc7b39b060451000ca1049ba154bcfa00ff8af262":"100000000000000000000000","0x945e18769d7ee727c7013f92de24d117967ff317":"2000000000000000000000","0xd18eb9e1d285dabe93e5d4bae76beefe43b521e8":"668500000000000000000","0xc618521321abaf5b26513a4a9528086f220adc6f":"27000000000000000000","0xdd65f6e17163b5d203641f51cc7b24b00f02c8fb":"200000000000000000000","0x131faed12561bb7aee04e5185af802b1c3438d9b":"219000000000000000000","0x1ced6715f862b1ff86058201fcce5082b36e62b2":"6684522000000000000000","0xa0ff5b4cf016027e8323497d4428d3e5a83b8795":"6596500000000000000000","0x02e816afc1b5c0f39852131959d946eb3b07b5ad":"1000000000000000000000","0x153cf2842cb9de876c276fa64767d1a8ecf573bb":"2000000000000000000000","0x3bc6e3ee7a56ce8f14a37532590f63716b9966e8":"2000000000000000000000","0xf6d25d3f3d846d239f525fa8cac97bc43578dbac":"896000000000000000000","0x2066774d822793ff25f1760909479cf62491bf88":"55160000000000000000000","0x46779a5656ff00d73eac3ad0c38b6c853094fb40":"230752000000000000000","0x22eed327f8eb1d1338a3cb7b0f8a4baa5907cd95":"23445000000000000000","0xff88ebacc41b3687f39e4b59e159599b80cba33f":"400000000000000000000","0x2874f3e2985d5f7b406627e17baa772b01abcc9e":"6014000000000000000000","0xeb10458daca79e4a6b24b29a8a8ada711b7f2eb6":"3998000000000000000000","0x541060fc58c750c40512f83369c0a63340c122b6":"1970000000000000000000","0xfd2757cc3551a095878d97875615fe0c6a32aa8a":"598200000000000000000","0xbe659d85e7c34f8833ea7f488de1fbb5d4149bef":"9072500000000000000000","0xe149b5726caf6d5eb5bf2acc41d4e2dc328de182":"1940000000000000000000","0x2fe0cc424b53a31f0916be08ec81c50bf8eab0c1":"600000000000000000000","0xe3712701619ca7623c55db3a0ad30e867db0168b":"20000000000000000000","0xf8ca336c8e91bd20e314c20b2dd4608b9c8b9459":"846000000000000000000","0x68acdaa9fb17d3c309911a77b05f5391fa034ee9":"8950000000000000000000","0xe77d7deab296c8b4fa07ca3be184163d5a6d606c":"92538000000000000000","0xe6b9545f7ed086e552924639f9a9edbbd5540b3e":"3760000000000000000000","0x2866b81decb02ee70ae250cee5cdc77b59d7b679":"2000000000000000000000","0x60e3cc43bcdb026aad759c7066f555bbf2ac66f5":"2000000000000000000000","0xfcbd85feea6a754fcf3449449e37ff9784f7773c":"3086000000000000000000","0x38a744efa6d5c2137defef8ef9187b649eee1c78":"4000000000000000000000","0x9d7655e9f3e5ba5d6e87e412aebe9ee0d49247ee":"2620100000000000000000","0x2020b81ae53926ace9f7d7415a050c031d585f20":"341200000000000000000","0x4244f1331158b9ce26bbe0b9236b9203ca351434":"10000000000000000000000","0x99c236141daec837ece04fdaee1d90cf8bbdc104":"2184000000000000000000","0x943d37864a4a537d35c8d99723cd6406ce2562e6":"2000000000000000000000","0xd79483f6a8444f2549d611afe02c432d15e11051":"20000000000000000000","0x9fd64373f2fbcd9c0faca60547cad62e26d9851f":"1000000000000000000000","0xb89c036ed7c492879921be41e10ca1698198a74c":"1820000000000000000000","0x7462c89caa9d8d7891b2545def216f7464d5bb21":"109162000000000000000","0xbb0366a7cfbd3445a70db7fe5ae34885754fd468":"6160000000000000000000","0x6c52cf0895bb35e656161e4dc46ae0e96dd3e62c":"4000086000000000000000","0xb9cf71b226583e3a921103a5316f855a65779d1b":"24000000000000000000000","0x016b60bb6d67928c29fd0313c666da8f1698d9c5":"2000000000000000000000","0x9454b3a8bff9709fd0e190877e6cb6c89974dbd6":"2674000000000000000000","0x84aac7fa197ff85c30e03b7a5382b957f41f3afb":"157600000000000000000","0xdb6e560c9bc620d4bea3a94d47f7880bf47f2d5f":"89500000000000000000","0xeefd05b0e3c417d55b3343060486cdd5e92aa7a6":"1430000000000000000000","0x3a59a08246a8206f8d58f70bb1f0d35c5bcc71bd":"185000000000000000000","0x9bfff50db36a785555f07652a153b0c42b1b8b76":"2000000000000000000000","0xd44f5edf2bcf2433f211dadd0cc450db1b008e14":"267400000000000000000","0x2378fd4382511e968ed192106737d324f454b535":"1000000000000000000000","0xc94089553ae4c22ca09fbc98f57075cf2ec59504":"4000000000000000000000","0x08ef3fa4c43ccdc57b22a4b9b2331a82e53818f2":"4000000000000000000000","0xe48e65125421880d42bdf1018ab9778d96928f3f":"4200000000000000000000","0x67518e5d02b205180f0463a32004471f753c523e":"1984289000000000000000","0x0da7401262384e2e8b4b26dd154799b55145efa0":"300000000000000000000","0x0b6920a64b363b8d5d90802494cf564b547c430d":"1200000000000000000000","0xa5ab4bd3588f46cb272e56e93deed386ba8b753d":"1332989000000000000000","0x1788da9b57fd05edc4ff99e7fef301519c8a0a1e":"2000000000000000000000","0x17b2d6cf65c6f4a347ddc6572655354d8a412b29":"2000000000000000000000","0xd0319139fbab2e8e2accc1d924d4b11df6696c5a":"200000000000000000000","0x4c377bb03ab52c4cb79befa1dd114982924c4ae9":"1827814000000000000000","0xfb949c647fdcfd2514c7d58e31f28a532d8c5833":"20000000000000000000000","0x70e5e9da735ff077249dcb9aaf3db2a48d9498c0":"1000000000000000000000","0xfe6f5f42b6193b1ad16206e4afb5239d4d7db45e":"1730000000000000000000","0xbda4be317e7e4bed84c0495eee32d607ec38ca52":"2309457000000000000000","0x5910106debd291a1cd80b0fbbb8d8d9e93a7cc1e":"2000000000000000000000","0xba42f9aace4c184504abf5425762aca26f71fbdc":"37400000000000000000","0xbeb4fd315559436045dcb99d49dcec03f40c42dc":"2000000000000000000000","0x452b64db8ef7d6df87c788639c2290be8482d575":"8000000000000000000000","0x66e09427c1e63deed7e12b8c55a6a19320ef4b6a":"170000000000000000000","0xfaad905d847c7b23418aeecbe3addb8dd3f8924a":"1970000000000000000000","0xa29319e81069e5d60df00f3de5adee3505ecd5fb":"2000000000000000000000","0xcf348f2fe47b7e413c077a7baf3a75fbf8428692":"2000000000000000000000","0xe1e8c50b80a352b240ce7342bbfdf5690cc8cb14":"394000000000000000000","0x131c792c197d18bd045d7024937c1f84b60f4438":"4000000000000000000000","0xe49af4f34adaa2330b0e49dc74ec18ab2f92f827":"2000000000000000000000","0xf2e99f5cbb836b7ad36247571a302cbe4b481c69":"1970000000000000000000","0xc93fbde8d46d2bcc0fa9b33bd8ba7f8042125565":"1400000000000000000000","0x038779ca2dbe663e63db3fe75683ea0ec62e2383":"1670000000000000000000","0xa33cb450f95bb46e25afb50fe05feee6fb8cc8ea":"776000000000000000000","0x40ab66fe213ea56c3afb12c75be33f8e32fd085d":"4000000000000000000000","0x6403d062549690c8e8b63eae41d6c109476e2588":"2000000000000000000000","0xbfb0ea02feb61dec9e22a5070959330299c43072":"20000000000000000000000","0x99c475bf02e8b9214ada5fad02fdfd15ba365c0c":"591000000000000000000","0x904966cc2213b5b8cb5bd6089ef9cddbef7edfcc":"2000000000000000000000","0x767a03655af360841e810d83f5e61fb40f4cd113":"985000000000000000000","0xab209fdca979d0a647010af9a8b52fc7d20d8cd1":"9129000000000000000000","0x6294eae6e420a3d5600a39c4141f838ff8e7cc48":"2955000000000000000000","0x9777cc61cf756be3b3c20cd4491c69d275e7a120":"10000000000000000000000","0xbcbf6ba166e2340db052ea23d28029b0de6aa380":"3880000000000000000000","0x9f10f2a0463b65ae30b070b3df18cf46f51e89bd":"1910000000000000000000","0x8d9952d0bb4ebfa0efd01a3aa9e8e87f0525742e":"3460000000000000000000","0x4f23b6b817ffa5c664acdad79bb7b726d30af0f9":"1760000000000000000000","0xb4c20040ccd9a1a3283da4d4a2f365820843d7e2":"1000000000000000000000","0x7f49e7a4269882bd8722d4a6f566347629624079":"2000000000000000000000","0x33629bd52f0e107bc071176c64df108f64777d49":"33425000000000000000","0x6a7b2e0d88867ff15d207c222bebf94fa6ce8397":"60000000000000000000000","0xb7ce684b09abda53389a875369f71958aeac3bdd":"2000000000000000000000","0xffbc3da0381ec339c1c049eb1ed9ee34fdcea6ca":"4000000000000000000000","0x849ab80790b28ff1ffd6ba394efc7463105c36f7":"34600000000000000000","0xb0b36af9aeeedf97b6b02280f114f13984ea3260":"985000000000000000000","0x4d57e716876c0c95ef5eaebd35c8f41b069b6bfe":"2000000000000000000000","0x2d2b032359b363964fc11a518263bfd05431e867":"149600000000000000000","0x2ccc1f1cb5f4a8002e186b20885d9dbc030c0894":"2000000000000000000000","0x016c85e1613b900fa357b8283b120e65aefcdd08":"799954000000000000000","0x710b0274d712c77e08a5707d6f3e70c0ce3d92cf":"6400000000000000000000","0x3cd3a6e93579c56d494171fc533e7a90e6f59464":"2000000000000000000000","0xfe0e30e214290d743dd30eb082f1f0a5225ade61":"200000000000000000000","0xd0718520eae0a4d62d70de1be0ca431c5eea2482":"2000000000000000000000","0xaf7f79cb415a1fb8dbbd094607ee8d41fb7c5a3b":"10000000000000000000000","0xb7d252ee9402b0eef144295f0e69f0db586c0871":"660000000000000000000","0xc3b928a76fad6578f04f0555e63952cd21d1520a":"2000000000000000000000","0xa7a517d7ad35820b09d497fa7e5540cde9495853":"2000000000000000000000","0xe6e886317b6a66a5b4f81bf164c538c264351765":"2000000000000000000000","0x0770b43dbae4b1f35a927b4fa8124d3866caf97b":"1016390000000000000000","0x52b4257cf41b6e28878d50d57b99914ffa89873a":"3930150000000000000000","0xe08bc29c2b48b169ff2bdc16714c586e6cb85ccf":"20000000000000000000","0x2372c4c1c9939f7aaf6cfac04090f00474840a09":"10000000000000000000000","0xab6b65eab8dfc917ec0251b9db0ecfa0fa032849":"500000000000000000000","0x582e7cc46f1d7b4e6e9d95868bfd370573178f4c":"2000000000000000000000","0xf167f5868dcf4233a7830609682caf2df4b1b807":"2396150000000000000000","0xec82f50d06475f684df1b392e00da341aa145444":"2000000000000000000000","0x0968ee5a378f8cadb3bafdbed1d19aaacf936711":"1000000000000000000000","0xa86613e6c4a4c9c55f5c10bcda32175dcbb4af60":"10696140000000000000000","0xa5cd123992194b34c4781314303b03c54948f4b9":"2010462000000000000000","0x52f058d46147e9006d29bf2c09304ad1cddd6e15":"1500000000000000000000","0x160226efe7b53a8af462d117a0108089bdecc2d1":"200550000000000000000","0x256292a191bdda34c4da6b6bd69147bf75e2a9ab":"14051000000000000000","0x1b8aa0160cd79f005f88510a714913d70ad3be33":"201760000000000000000","0xd4b2ff3bae1993ffea4d3b180231da439f7502a2":"2000000000000000000000","0xe408aa99835307eea4a6c5eb801fe694117f707d":"500000000000000000000","0xe60a55f2df996dc3aedb696c08dde039b2641de8":"2000000000000000000000","0x73df3c3e7955f4f2d859831be38000b1076b3884":"1970000000000000000000","0x6228ade95e8bb17d1ae23bfb0518414d497e0eb8":"400000000000000000000","0x0f46c81db780c1674ac73d314f06539ee56ebc83":"9850000000000000000000","0x762d6f30dab99135e4eca51d5243d6c8621102d5":"282000000000000000000","0x4ba0d9e89601772b496847a2bb4340186787d265":"1000000000000000000000","0xca747576446a4c8f30b08340fee198de63ec92cf":"7020000000000000000000","0x99c31fe748583787cdd3e525b281b218961739e3":"1015200000000000000000","0x1210f80bdb826c175462ab0716e69e46c24ad076":"100000000000000000000","0x3f75ae61cc1d8042653b5baec4443e051c5e7abd":"95500000000000000000","0x5c4892907a0720df6fd3413e63ff767d6b398023":"13189467000000000000000","0x17f14632a7e2820be6e8f6df823558283dadab2d":"2000000000000000000000","0x1dc7f7dad85df53f1271152403f4e1e4fdb3afa0":"200000000000000000000","0x5a30feac37ac9f72d7b4af0f2bc73952c74fd5c3":"2000000000000000000000","0x136d4b662bbd1080cfe4445b0fa213864435b7f1":"4000000000000000000000","0xc1ec81dd123d4b7c2dd9b4d438a7072c11dc874c":"2000000000000000000000","0x09f9575be57d004793c7a4eb84b71587f97cbb6a":"200000000000000000000","0x2c4b470307a059854055d91ec3794d80b53d0f4a":"20000000000000000000000","0x6af6c7ee99df271ba15bf384c0b764adcb4da182":"999972000000000000000","0x0dae3ee5b915b36487f9161f19846d101433318a":"1910000000000000000000","0x0dcf9d8c9804459f647c14138ed50fad563b4154":"173000000000000000000","0xbfa8c858df102cb12421008b0a31c4c7190ad560":"200000000000000000000","0xc2fd0bf7c725ef3e047e5ae1c29fe18f12a7299c":"1337000000000000000000","0xd70a612bd6dda9eab0dddcff4aaf4122d38feae4":"540000000000000000000","0xe07137ae0d116d033533c4eab496f8a9fb09569c":"1400000000000000000000","0x7f49f20726471ac1c7a83ef106e9775ceb662566":"5910000000000000000000","0x1e706655e284dcf0bb37fe075d613a18dc12ff4a":"4376760000000000000000","0x03af7ad9d5223cf7c8c13f20df67ebe5ffc5bb41":"200000000000000000000","0x228242f8336eecd8242e1f000f41937e71dffbbf":"5000000000000000000000","0xe8ed51bbb3ace69e06024b33f86844c47348db9e":"165170600000000000000000","0x3b566a8afad19682dc2ce8679a3ce444a5b0fd4f":"2000000000000000000000","0xdc738fb217cead2f69594c08170de1af10c419e3":"100000000000000000000000","0x13032446e7d610aa00ec8c56c9b574d36ca1c016":"2000000000000000000000","0x6ca6a132ce1cd288bee30ec7cfeffb85c1f50a54":"2000000000000000000000","0xb85f26dd0e72d9c29ebaf697a8af77472c2b58b5":"11900000000000000000000","0x055bd02caf19d6202bbcdc836d187bd1c01cf261":"100000000000000000000","0x3c322e611fdb820d47c6f8fc64b6fad74ca95f5e":"242514000000000000000","0x8daddf52efbd74da95b969a5476f4fbbb563bfd2":"835000000000000000000","0xc63ac417992e9f9b60386ed953e6d7dff2b090e8":"4000086000000000000000","0x27f03cf1abc5e1b51dbc444b289e542c9ddfb0e6":"5000000000000000000000","0xd8f4bae6f84d910d6d7d5ac914b1e68372f94135":"100000000000000000000","0x9f83a293c324d4106c18faa8888f64d299054ca0":"200000000000000000000","0x39ee4fe00fbced647068d4f57c01cb22a80bccd1":"6000000000000000000000","0x404100db4c5d0eec557823b58343758bcc2c8083":"20000000000000000000","0x02751dc68cb5bd737027abf7ddb77390cd77c16b":"20000000000000000000","0xd10302faa1929a326904d376bf0b8dc93ad04c4c":"1790000000000000000000","0xcc419fd9912b85135659e77a93bc3df182d45115":"10000000000000000000000","0x10097198b4e7ee91ff82cc2f3bd95fed73c540c0":"2000000000000000000000","0x7e24d9e22ce1da3ce19f219ccee523376873f367":"5900150000000000000000","0x2e4ee1ae996aa0a1d92428d06652a6bea6d2d15d":"2000000000000000000000","0x91a4149a2c7b1b3a67ea28aff34725e0bf8d7524":"1940000000000000000000","0xead65262ed5d122df2b2751410f98c32d1238f51":"101680000000000000000","0xe20954d0f4108c82d4dcb2148d26bbd924f6dd24":"10000000000000000000000","0xebb7d2e11bc6b58f0a8d45c2f6de3010570ac891":"26740000000000000000","0xef115252b1b845cd857f002d630f1b6fa37a4e50":"1970000000000000000000","0x01a818135a414210c37c62b625aca1a54611ac36":"260000000000000000000","0xea1ea0c599afb9cd36caacbbb52b5bbb97597377":"1069600000000000000000","0x7a7a4f807357a4bbe68e1aa806393210c411ccb3":"30000000000000000000000","0x6d40ca27826d97731b3e86effcd7b92a4161fe89":"2000000000000000000000","0x8431277d7bdd10457dc017408c8dbbbd414a8df3":"39400000000000000000","0x69b81d5981141ec7a7141060dfcf8f3599ffc63e":"5000000000000000000000","0x47688410ff25d654d72eb2bc06e4ad24f833b094":"160440000000000000000","0x6c101205b323d77544d6dc52af37aca3cec6f7f1":"10000000000000000000000","0xfb685c15e439965ef626bf0d834cd1a89f2b5695":"3940000000000000000000","0x673706b1b0e4dc7a949a7a796258a5b83bb5aa83":"16100000000000000000000","0xecdaf93229b45ee672f65db506fb5eca00f7fce6":"1605009000000000000000","0xec6904bae1f69790591709b0609783733f2573e3":"500000000000000000000","0x812ea7a3b2c86eed32ff4f2c73514cc63bacfbce":"1000000000000000000000","0x196c02210a450ab0b36370655f717aa87bd1c004":"259456000000000000000","0xd96ac2507409c7a383ab2eee1822a5d738b36b56":"200000000000000000000","0xae2f9c19ac76136594432393b0471d08902164d3":"698600000000000000000","0x9d32962ea99700d93228e9dbdad2cc37bb99f07e":"3327560000000000000000","0x17e584e810e567702c61d55d434b34cdb5ee30f6":"5000000000000000000000","0xa3a93ef9dbea2636263d06d8492f6a41de907c22":"60000000000000000000","0x2b5016e2457387956562587115aa8759d8695fdf":"200000000000000000000000","0x140129eaa766b5a29f5b3af2574e4409f8f6d3f1":"6400000000000000000000","0x7025965d2b88da197d4459be3dc9386344cc1f31":"2005500000000000000000","0x388bdcdae794fc44082e667501344118ea96cd96":"1670000000000000000000","0xeee9d0526eda01e43116a395322dda8970578f39":"9999980000000000000000","0x6ec89b39f9f5276a553e8da30e6ec17aa47eefc7":"447500000000000000000","0x7e236666b2d06e63ea4e2ab84357e2dfc977e50e":"999972000000000000000","0x68df947c495bebaeb8e889b3f953d533874bf106":"546000000000000000000","0xd40ed66ab3ceff24ca05ecd471efb492c15f5ffa":"500000000000000000000","0xf0c70d0d6dab7663aa9ed9ceea567ee2c6b02765":"2089349000000000000000","0xb589676d15a04448344230d4ff27c95edf122c49":"1000000000000000000000","0xa0347f0a98776390165c166d32963bf74dcd0a2f":"1000000000000000000000","0xd47d8685faee147c520fd986709175bf2f886bef":"2000000000000000000000","0xa1dcd0e5b05a977c9623e5ae2f59b9ada2f33e31":"100000000000000000000","0x4979194ec9e97db9bee8343b7c77d9d7f3f1dc9f":"20000000000000000000","0x7cd20eccb518b60cab095b720f571570caaa447e":"500000000000000000000","0x2ff830cf55fb00d5a0e03514fecd44314bd6d9f1":"10000000000000000000000","0x0bb25ca7d188e71e4d693d7b170717d6f8f0a70a":"336870000000000000000","0xe9a2b4914e8553bf0d7c00ca532369b879f931bf":"2000000000000000000000","0x720e6b22bf430966fa32b6acb9a506eebf662c61":"152000000000000000000","0x7ade5d66b944bb860c0efdc86276d58f4653f711":"2000000000000000000000","0x2eaff9f8f8113064d3957ac6d6e11eee42c8195d":"1970000000000000000000","0x0c8fd7775e54a6d9c9a3bf890e761f6577693ff0":"9850000000000000000000","0x290a56d41f6e9efbdcea0342e0b7929a8cdfcb05":"344000000000000000000","0xd73ed2d985b5f21b55b274643bc6da031d8edd8d":"49250000000000000000000","0x80156d10efa8b230c99410630d37e269d4093cea":"2000000000000000000000","0x0989c200440b878991b69d6095dfe69e33a22e70":"1910000000000000000000","0xec8014efc7cbe5b0ce50f3562cf4e67f8593cd32":"17300000000000000000","0xde612d0724e84ea4a7feaa3d2142bd5ee82d3201":"20000000000000000000","0x0f832a93df9d7f74cd0fb8546b7198bf5377d925":"143000000000000000000","0xaa2c670096d3f939305325427eb955a8a60db3c5":"2003010000000000000000","0x25287b815f5c82380a73b0b13fbaf982be24c4d3":"40000000000000000000","0xe75c3b38a58a3f33d55690a5a59766be185e0284":"500000000000000000000","0x1940dc9364a852165f47414e27f5002445a4f143":"10850000000000000000000","0xe5b826196c0e1bc1119b021cf6d259a610c99670":"200000000000000000000","0x82a15cef1d6c8260eaf159ea3f0180d8677dce1c":"2000000000000000000000","0xda06044e293c652c467fe74146bf185b21338a1c":"1000000000000000000000","0xf815c10a032d13c34b8976fa6e3bd2c9131a8ba9":"1337000000000000000000","0xcd95fa423d6fc120274aacde19f4eeb766f10420":"200000000000000000000","0xe3a4f83c39f85af9c8b1b312bfe5fc3423afa634":"28650000000000000000","0x768ce0daa029b7ded022e5fc574d11cde3ecb517":"322000000000000000000","0xe3ec18a74ed43855409a26ade7830de8e42685ef":"19700000000000000000","0xb2bdbedf95908476d7148a370cc693743628057f":"4000000000000000000000","0xbbb8ffe43f98de8eae184623ae5264e424d0b8d7":"107600000000000000000","0x090cebef292c3eb081a05fd8aaf7d39bf07b89d4":"4000000000000000000000","0xdd2a233adede66fe1126d6c16823b62a021feddb":"2000000000000000000000","0xd8cd64e0284eec53aa4639afc4750810b97fab56":"20000000000000000000","0xe5953fea497104ef9ad2d4e5841c271f073519c2":"704000000000000000000","0x967d4142af770515dd7062af93498dbfdff29f20":"20200000000000000000","0xfd191a35157d781373fb411bf9f25290047c5eef":"1000000000000000000000","0x8967d7b9bdb7b4aed22e65a15dc803cb7a213f10":"400000000000000000000","0x51e43fe0d25c782860af81ea89dd793c13f0cbb1":"60000000000000000000","0xa38476691d34942eea6b2f76889223047db4617a":"2000000000000000000000","0x1321ccf29739b974e5a516f18f3a843671e39642":"4000000000000000000000","0x4d71a6eb3d7f327e1834278e280b039eddd31c2f":"6000000000000000000000","0xdc2d15a69f6bb33b246aef40450751c2f6756ad2":"1996000000000000000000","0xec89f2b678a1a15b9134ec5eb70c6a62071fbaf9":"200000000000000000000","0x27bf943c1633fe32f8bcccdb6302b407a5724e44":"940229000000000000000","0xd0a6c6f9e9c4b383d716b31de78d56414de8fa91":"300000000000000000000","0x7b6175ec9befc738249535ddde34688cd36edf25":"10000000000000000000000","0x41ce79950935cff55bf78e4ccec2fe631785db95":"2000000000000000000000","0x5598b3a79a48f32b1f5fc915b87b645d805d1afe":"500000000000000000000","0x5c4881165cb42bb82e97396c8ef44adbf173fb99":"110600000000000000000","0x25b0533b81d02a617b9229c7ec5d6f2f672e5b5a":"1000000000000000000000","0x015f097d9acddcddafaf2a107eb93a40fc94b04c":"20000000000000000000000","0xb84b53d0bb125656cddc52eb852ab71d7259f3d5":"16000000000000000000000","0x1a79c7f4039c67a39d7513884cdc0e2c34222490":"20000000000000000000","0x926209b7fda54e8ddb9d9e4d3d19ebdc8e88c29f":"2000000000000000000000","0xc2fe7d75731f636dcd09dbda0671393ba0c82a7d":"2200000000000000000000","0x30248d58e414b20fed3a6c482b59d9d8f5a4b7e2":"60000000000000000000","0xd0e194f34b1db609288509ccd2e73b6131a2538b":"999972000000000000000","0xe8f29969e75c65e01ce3d86154207d0a9e7c76f2":"2991807000000000000000","0xcb93199b9c90bc4915bd859e3d42866dc8c18749":"231800000000000000000","0xe6fe0afb9dcedd37b2e22c451ba6feab67348033":"10000000000000000000000","0x82f854c9c2f087dffa985ac8201e626ca5467686":"100000000000000000000000","0x63bb664f9117037628594da7e3c5089fd618b5b5":"20000000000000000000","0xf8d17424c767bea31205739a2b57a7277214eebe":"42000000000000000000","0x4ca8db4a5efefc80f4cd9bbcccb03265931332b6":"200000000000000000000","0xc56e6b62ba6e40e52aab167d21df025d0055754b":"2000000000000000000000","0x0d8c40a79e18994ff99ec251ee10d088c3912e80":"114600000000000000000","0x40a331195b977325c2aa28fa2f42cb25ec3c253c":"2000000000000000000000","0xa2c5854ff1599f98892c5725d262be1da98aadac":"314315000000000000000","0x23ab09e73f87aa0f3be0139df0c8eb6be5634f95":"8000000000000000000000","0xb8040536958d5998ce4bec0cfc9c2204989848e9":"24472420000000000000000","0x42d6b263d9e9f4116c411424fc9955783c763030":"2000000000000000000000","0xc496cbb0459a6a01600fc589a55a32b454217f9d":"274000000000000000000","0x48302c311ef8e5dc664158dd583c81194d6e0d58":"3364760000000000000000","0xd5b284040130abf7c1d163712371cc7e28ad66da":"1970000000000000000000","0xd22f0ca4cd479e661775053bcc49e390f670dd8a":"1000000000000000000000","0xe597f083a469c4591c3d2b1d2c772787befe27b2":"280000000000000000000","0x668b6ba8ab08eace39c502ef672bd5ccb6a67a20":"31135320000000000000000","0xa3bff1dfa9971668360c0d82828432e27bf54e67":"200000000000000000000","0xee655bb4ee0e8d5478526fb9f15e4064e09ff3dd":"200000000000000000000","0x121f855b70149ac83473b9706fb44d47828b983b":"1400000000000000000000","0x20a15256d50ce058bf0eac43aa533aa16ec9b380":"20000000000000000000","0x69bcfc1d43b4ba19de7b274bdffb35139412d3d7":"985000000000000000000","0xdb288f80ffe232c2ba47cc94c763cf6fc9b82b0d":"85000000000000000000","0xe1cb83ec5eb6f1eeb85e99b2fc63812fde957184":"20000000000000000000000","0xa419a984142363267575566089340eea0ea20819":"1999944000000000000000","0x8489f6ad1d9a94a297789156899db64154f1dbb5":"358849000000000000000","0xd609bf4f146eea6b0dc8e06ddcf4448a1fccc9fa":"2000000000000000000000","0xdf1fa2e20e31985ebe2c0f0c93b54c0fb67a264b":"200000000000000000000","0xefe8ff87fc260e0767638dd5d02fc4672e0ec06d":"2000000000000000000000","0xeef1bbb1e5a83fde8248f88ee3018afa2d1332eb":"200000000000000000000","0x4b3aab335ebbfaa870cc4d605e7d2e74c668369f":"60000000000000000000000","0x8f4fb1aea7cd0f570ea5e61b40a4f4510b6264e4":"4000000000000000000000","0x0b0b3862112aeec3a03492b1b05f440eca54256e":"4000000000000000000000","0xdff4007931786593b229efe5959f3a4e219e51af":"4925000000000000000000","0xfec14e5485de2b3eef5e74c46146db8e454e0335":"179000000000000000000","0xac21c1e5a3d7e0b50681679dd6c792dbca87decb":"100000000000000000000000","0x796ebbf49b3e36d67694ad79f8ff36767ac6fab0":"60800000000000000000","0xae7739124ed153052503fc101410d1ffd8cd13b7":"999942000000000000000","0x86026cad3fe4ea1ce7fca260d3d45eb09ea6a364":"200000000000000000000","0xb2fc84a3e50a50af02f94da0383ed59f71ff01d7":"30000000000000000000000","0xbbab000b0408ed015a37c04747bc461ab14e151b":"6000000000000000000000","0xc4ff6fbb1f09bd9e102ba033d636ac1c4c0f5304":"1000000000000000000000","0xcc606f511397a38fc7872bd3b0bd03c71bbd768b":"1000000000000000000000","0xf346d7de92741c08fc58a64db55b062dde012d14":"295106000000000000000","0x33f15223310d44de8b6636685f3a4c3d9c5655a5":"250500000000000000000","0x3c860e2e663f46db53427b29fe3ea5e5bf62bbcc":"98500000000000000000","0xacb94338554bc488cc88ae2d9d94080d6bdf8410":"1000000000000000000000","0x9c5cc111092c122116f1a85f4ee31408741a7d2f":"492500000000000000000","0x5f76f0a306269c78306b3d650dc3e9c37084db61":"2400000000000000000000","0x2c0cc3f951482cc8a2925815684eb9f94e060200":"6000000000000000000000","0xb74372dbfa181dc9242f39bf1d3731dffe2bdacf":"2000000000000000000000","0x3bab4b01a7c84ba13feea9b0bb191b77a3aadca3":"200000000000000000000","0x39aa05e56d7d32385421cf9336e90d3d15a9f859":"26000000000000000000","0x4a52bad20357228faa1e996bed790c93674ba7d0":"1337000000000000000000","0xff128f4b355be1dc4a6f94fa510d7f15d53c2aff":"2720000000000000000000","0x92793ac5b37268774a7130de2bbd330405661773":"40110000000000000000","0xdb19a3982230368f0177219cb10cb259cdb2257c":"2000000000000000000000","0x8d1794da509cb297053661a14aa892333231e3c1":"199600000000000000000","0x9b7c8810cc7cc89e804e6d3e38121850472877fe":"2000000000000000000000","0xed3cbc3782cebd67989b305c4133b2cde32211eb":"400000000000000000000","0x8532490897bbb4ce8b7f6b837e4cba848fbe9976":"100000000000000000000","0xc384ac6ee27c39e2f278c220bdfa5baed626d9d3":"600000000000000000000","0xb1459285863ea2db3759e546ceb3fb3761f5909c":"1122309000000000000000","0x634efc24371107b4cbf03f79a93dfd93e431d5fd":"1221341000000000000000","0xef9f59aeda418c1494682d941aab4924b5f4929a":"100000000000000000000000","0xe7311c9533f0092c7248c9739b5b2c864a34b1ce":"2803436000000000000000","0xe6e621eaab01f20ef0836b7cad47464cb5fd3c96":"316014000000000000000","0xcd102cd6db3df14ad6af0f87c72479861bfc3d24":"2000000000000000000000","0x005a9c03f69d17d66cbb8ad721008a9ebbb836fb":"2000000000000000000000","0xa072cebe62a9e9f61cc3fbf88a9efbfe3e9a8d70":"400000000000000000000","0xf2ab1161750244d0ecd048ee0d3e51abb143a2fd":"1235800000000000000000","0xf686785b89720b61145fea80978d6acc8e0bc196":"4000000000000000000000","0x0a2b4fc5d81ace67dc4bba03f7b455413d46fe3d":"197000000000000000000","0xc32ec7e42ad16ce3e2555ad4c54306eda0b26758":"2000000000000000000000","0xf3fa723552a5d0512e2b62f48dca7b2b8105305b":"137000000000000000000","0x6dc3f92baa1d21dab7382b893261a0356fa7c187":"1730000000000000000000","0x4627c606842671abde8295ee5dd94c7f549534f4":"286600000000000000000","0xe39e46e15d22ce56e0c32f1877b7d1a264cf94f3":"20000000000000000000000","0xd7d157e4c0a96437a6d285741dd23ec4361fa36b":"2000000000000000000000","0x68f8f45155e98c5029a4ebc5b527a92e9fa83120":"4436101000000000000000","0x9aba2b5e27ff78baaab5cdc988b7be855cebbdce":"9999000000000000000000","0x66b39837cb3cac8a802afe3f12a258bbca62dacd":"400000000000000000000","0xd39b7cbc94003fc948f0cde27b100db8ccd6e063":"400000000000000000000","0x3db9ed7f024c7e26372feacf2b050803445e3810":"1285600000000000000000","0x3fbc1e4518d73400c6d046359439fb68ea1a49f4":"16400000000000000000000","0xe3da4f3240844c9b6323b4996921207122454399":"11539639000000000000000","0x09afa73bc047ef46b977fd9763f87286a6be68c6":"501500000000000000000","0x1dbe8e1c2b8a009f85f1ad3ce80d2e05350ee39c":"135400000000000000000","0x2c5a2d0abda03bbe215781b4ff296c8c61bdbaf6":"30617000000000000000","0x9a9d1dc0baa77d6e20c3d849c78862dd1c054c87":"880000000000000000000","0x3ccef88679573947e94997798a1e327e08603a65":"807700000000000000000","0x850b9db18ff84bf0c7da49ea3781d92090ad7e64":"2600000000000000000000","0x361c75931696bc3d427d93e76c77fd13b241f6f4":"549212000000000000000","0xc8f2b320e6dfd70906c597bad2f9501312c78259":"1504800000000000000000","0x8dc1d5111d09af25fdfcac455c7cec283e6d6775":"2000000000000000000000","0xcd7ece086b4b619b3b369352ee38b71ddb06439a":"200000000000000000000","0xf607c2150d3e1b99f24fa1c7d540add35c4ebe1e":"3098020000000000000000","0x32485c818728c197fea487fbb6e829159eba8370":"1053893000000000000000","0x8e670815fb67aeaea57b86534edc00cdf564fee5":"3300000000000000000000","0x10df681506e34930ac7a5c67a54c3e89ce92b981":"2153800000000000000000","0x1cf2eb7a8ccac2adeaef0ee87347d535d3b94058":"2000000000000000000000","0xf0dc43f205619127507b2b1c1cfdf32d28310920":"301973000000000000000","0xf2c2904e9fa664a11ee25656d8fd2cc0d9a522a0":"13370000000000000000","0x70670fbb05d33014444b8d1e8e7700258b8caa6d":"2000000000000000000000","0x5160ed612e1b48e73f3fc15bc4321b8f23b8a24b":"562800000000000000000","0x54a62bf9233e146ffec3876e45f20ee8414adeba":"10000000000000000000000","0x26d4ec17d5ceb2c894bdc59d0a6a695dad2b43cc":"2935300000000000000000","0x205fc843e19a4913d1881eb69b69c0fa3be5c50b":"9700000000000000000000","0xe001aba77c02e172086c1950fffbcaa30b83488f":"1970000000000000000000","0x21efbca09b3580b98e73f5b2f7f4dc0bf02c529c":"2000000000000000000000","0xc4d916574e68c49f7ef9d3d82d1638b2b7ee0985":"1580000000000000000000","0xcab0d32cf3767fa6b3537c84328baa9f50458136":"8960000000000000000000","0x7ce4686446f1949ebed67215eb0d5a1dd72c11b8":"2217776000000000000000","0x7837fcb876da00d1eb3b88feb3df3fa4042fac82":"1760000000000000000000","0x71e38ff545f30fe14ca863d4f5297fd48c73a5ce":"3580000000000000000000","0xe528a0e5a267d667e9393a6584e19b34dc9be973":"5600000000000000000000","0xc5374928cdf193705443b14cc20da423473cd9cf":"138139000000000000000","0xe406f5dd72cab66d8a6ecbd6bfb494a7b6b09afe":"100000000000000000000","0xd7ef340e66b0d7afcce20a19cb7bfc81da33d94e":"3000000000000000000000","0xe012db453827a58e16c1365608d36ed658720507":"2000000000000000000000","0xd59638d3c5faa7711bf085745f9d5bdc23d498d8":"2000000000000000000000","0x008fc7cbadffbd0d7fe44f8dfd60a79d721a1c9c":"1000000000000000000000","0x8a3470282d5e2a2aefd7a75094c822c4f5aeef8a":"242743000000000000000","0x38b3965c21fa893931079beacfffaf153678b6eb":"170374000000000000000","0x57dd9471cbfa262709f5f486bcb774c5f527b8f8":"197000000000000000000","0x5a60c924162873fc7ea4da7f972e350167376031":"83583000000000000000","0xb9013c51bd078a098fae05bf2ace0849c6be17a5":"80000000000000000000","0xdc23b260fcc26e7d10f4bd044af794579460d9da":"500038000000000000000","0x45db03bccfd6a5f4d0266b82a22a368792c77d83":"8000000000000000000000","0x3e0cbe6a6dcb61f110c45ba2aa361d7fcad3da73":"8022000000000000000000","0x42d3a5a901f2f6bd9356f112a70180e5a1550b60":"925000000000000000000","0x47219229e8cd56659a65c2a943e2dd9a8f4bfd89":"1520000000000000000000","0xa20d071b1b003063497d7990e1249dabf36c35f7":"1000000000000000000000","0x6835c8e8b74a2ca2ae3f4a8d0f6b954a3e2a8392":"60140000000000000000","0x0c2d5c920538e953caaf24f0737f554cc6927742":"1000000000000000000000","0xeedf6c4280e6eb05b934ace428e11d4231b5905b":"200000000000000000000","0xffa696ecbd787e66abae4fe87b635f07ca57d848":"1337000000000000000000","0x3e81772175237eb4cbe0fe2dcafdadffeb6a1999":"8800000000000000000000","0xb44783c8e57b480793cbd69a45d90c7b4f0c48ac":"20000000000000000000","0xf84f090adf3f8db7e194b350fbb77500699f66fd":"1970000000000000000000","0x2e9824b5c132111bca24ddfba7e575a5cd7296c1":"17201900000000000000000","0x5cce72d068c7c3f55b1d2819545e77317cae8240":"1940000000000000000000","0xd815e1d9f4e2b5e57e34826b7cfd8881b8546890":"17300000000000000000","0xf901c00fc1db88b69c4bc3252b5ca70ea6ee5cf6":"400000000000000000000","0xa960b1cadd3b5c1a8e6cb3abcaf52ee7c3d9fa88":"1522704000000000000000","0xf7e45a12aa711c709acefe95f33b78612d2ad22a":"66230000000000000000000","0xc332df50b13c013490a5d7c75dbfa366da87b6d6":"4000000000000000000000","0xd467cf064c0871989b90d8b2eb14ccc63b360823":"200000000000000000000","0xb9144b677c2dc614ceefdf50985f1183208ea64c":"2000000000000000000000","0xea7c4d6dc729cd6b157c03ad237ca19a209346c3":"2000000000000000000000","0x9c9de44724a4054da0eaa605abcc802668778bea":"200020000000000000000","0xd7140c8e5a4307fab0cc27badd9295018bf87970":"109600000000000000000","0xc33acdb3ba1aab27507b86b15d67faf91ecf6293":"2000000000000000000000","0xdb2a0c9ab64df58ddfb1dbacf8ba0d89c85b31b4":"4000000000000000000000","0xbfcb9730246304700da90b4153e71141622e1c41":"1000000000000000000000","0x07dc8c8b927adbedfa8f5d639b4352351f2f36d2":"314382000000000000000","0x2d5391e938b34858cf965b840531d5efda410b09":"1400000000000000000000","0x0b5e2011ebc25a007f21362960498afb8af280fb":"2000000000000000000000","0xed9fb1f5af2fbf7ffc5029cee42b70ff5c275bf5":"280000000000000000000","0xa3232d068d50064903c9ebc563b515acc8b7b097":"2002000000000000000000","0x66274fea82cd30b6c29b23350e4f4f3d310a5899":"2070000000000000000000","0xdbfb1bb464b8a58e500d2ed8de972c45f5f1c0fb":"1600000000000000000000","0xa1f8d8bcf90e777f19b3a649759ad95027abdfc3":"200000000000000000000","0x5bd23547477f6d09d7b2a005c5ee650c510c56d7":"10000000000000000000000","0xec3b8b58a12703e581ce5ffd7e21c57d1e5c663f":"1700000000000000000000","0x54310b3aa88703a725dfa57de6e646935164802c":"1910000000000000000000","0x8f41b1fbf54298f5d0bc2d122f4eb95da4e5cd3d":"354200000000000000000","0xc80b36d1beafba5fcc644d60ac6e46ed2927e7dc":"13370000000000000000","0x1ea492bce1ad107e337f4bd4a7ac9a7babcccdab":"100000000000000000000","0xaaf023fef290a49bb78bb7abc95d669c50d528b0":"200000000000000000000","0x80b79f338390d1ba1b3737a29a0257e5d91e0731":"20000000000000000000","0xf382e4c20410b951089e19ba96a2fee3d91cce7e":"5054000000000000000000","0x0748713145ef83c3f0ef4d31d823786f7e9cc689":"4500000000000000000000","0x21e219c89ca8ac14ae4cba6130eeb77d9e6d3962":"789580000000000000000","0xca9a042a6a806ffc92179500d24429e8ab528117":"1100000000000000000000","0xbcc9593b2da6df6a34d71b1aa38dacf876f95b88":"20000000000000000000","0xd1438267231704fc7280d563adf4763844a80722":"200000000000000000000","0x4989e1ab5e7cd00746b3938ef0f0d064a2025ba5":"2000000000000000000000","0xbd4b60faec740a21e3071391f96aa534f7c1f44e":"182000000000000000000","0x8c7cb4e48b25031aa1c4f92925d631a8c3edc761":"1000000000000000000000","0x322788b5e29bf4f5f55ae1ddb32085fda91b8ebe":"200000000000000000000","0xf15e182c4fbbad79bd93342242d4dccf2be58925":"1940000000000000000000","0x1548b770a5118ede87dba2f690337f616de683ab":"527558000000000000000","0x69c2d835f13ee90580408e6a3283c8cca6a434a2":"656000000000000000000","0xa1e4380a3b1f749673e270229993ee55f35663b4":"2000000000000000000000","0xc7675e5647b9d8daf4d3dff1e552f6b07154ac38":"180000000000000000000","0xa02c1e34064f0475f7fa831ccb25014c3aa31ca2":"60000000000000000000","0x517c75430de401c341032686112790f46d4d369e":"388000000000000000000","0x29681d9912ddd07eaabb88d05d90f766e862417d":"1000000000000000000000","0x544dda421dc1eb73bb24e3e56a248013b87c0f44":"1970000000000000000000","0x2ab97e8d59eee648ab6caf8696f89937143864d6":"3820000000000000000000","0x79c130c762b8765b19d2abc9a083ab8f3aad7940":"3940000000000000000000","0xf9650d6989f199ab1cc479636ded30f241021f65":"850000000000000000000","0xd1c96e70f05ae0e6cd6021b2083750a7717cde56":"500000000000000000000","0x88106c27d20b74b4b98ca62b232bd5c97411171f":"197000000000000000000","0x37ab66083a4fa23848b886f9e66d79cdc150cc70":"88510000000000000000000","0x8e6156336be2cdbe32140df08a2ba55fd0a58463":"74480000000000000000","0x2982d76a15f847dd41f1922af368fe678d0e681e":"100000000000000000000","0x209e8e29d33beae8fb6baa783d133e1d9ec1bc0b":"835000000000000000000","0xb325674c01e3f7290d5226339fbeac67d221279f":"2800000000000000000000","0xf20c9a99b74759d782f25c1ceca802a27e0b436c":"1670000000000000000000","0x61bf84d5ab026f58c873f86ff0dfca82b55733ae":"2000000000000000000000","0x0734a0a81c9562f4d9e9e10a8503da15db46d76e":"18200000000000000000","0x0521bc3a9f8711fecb10f50797d71083e341eb9d":"20000000000000000000","0x3301d9ca2f3bfe026279cd6819f79a293d98156e":"50000000000000000000000","0x549d51af29f724c967f59423b85b2681e7b15136":"3760000000000000000000","0x2053ac97548a0c4e8b80bc72590cd6a098fe7516":"187000000000000000000","0xaa321fdbd449180db8ddd34f0fe906ec18ee0914":"685000000000000000000","0x697f55536bf85ada51841f0287623a9f0ed09a17":"10000000000000000000000","0xdf57353aaff2aadb0a04f9014e8da7884e86589c":"152800000000000000000","0x6807ddc88db489b033e6b2f9a81553571ab3c805":"29944000000000000000","0x90057af9aa66307ec9f033b29724d3b2f41eb6f9":"121930000000000000000000","0x3ff836b6f57b901b440c30e4dbd065cf37d3d48c":"200000000000000000000","0x91051764af6b808e4212c77e30a5572eaa317070":"1000000000000000000000","0x7faa30c31519b584e97250ed2a3cf3385ed5fd50":"2000000000000000000000","0xfb842ca2c5ef133917a236a0d4ac40690110b038":"306000000000000000000","0xaa167026d39ab7a85635944ed9edb2bfeba11850":"8298000000000000000000","0x57beea716cbd81700a73d67f9ff039529c2d9025":"200000000000000000000","0x654b7e808799a83d7287c67706f2abf49a496404":"1970000000000000000000","0xdde8f0c31b7415511dced1cd7d46323e4bd12232":"1610000000000000000000","0x8667fa1155fed732cfb8dca5a0d765ce0d0705ed":"81770000000000000000","0x905526568ac123afc0e84aa715124febe83dc87c":"17900000000000000000","0x8e98766524b0cf2747c50dd43b9567594d9731de":"1997200000000000000000","0xc6df2075ebd240d44869c2be6bdf82e63d4ef1f5":"20000000000000000000","0x2ff5cab12c0d957fd333f382eeb75107a64cb8e8":"10000000000000000000000","0x3055efd26029e0d11b930df4f53b162c8c3fd2ce":"499938000000000000000","0xb2c53efa33fe4a3a1a80205c73ec3b1dbcad0602":"1918595000000000000000","0x766b3759e8794e926dac473d913a8fb61ad0c2c9":"86500000000000000000","0x882aa798bf41df179f85520130f15ccdf59b5e58":"2000000000000000000000","0x80b23d380b825c46e0393899a85556462da0e18c":"2000000000000000000000","0x51f4663ab44ff79345f427a0f6f8a6c8a53ff234":"20000000000000000000000","0x8d5ef172bf77315ea64e85d0061986c794c6f519":"3940000000000000000000","0x75ac547017134c04ae1e11d60e63ec04d18db4ef":"6000000000000000000000","0xce1b0cb46aaecfd79b880cad0f2dda8a8dedd0b1":"20000000000000000000","0x21408b4d7a2c0e6eca4143f2cacdbbccba121bd8":"20000000000000000000000","0x9c526a140683edf1431cfaa128a935e2b614d88b":"111000000000000000000","0x599728a78618d1a17b9e34e0fed8e857d5c40622":"14000000000000000000000","0x6ac4d4be2db0d99da3faaaf7525af282051d6a90":"80185000000000000000","0x785c8ea774d73044a734fa790a1b1e743e77ed7c":"238750000000000000000","0xff2726294148b86c78a9372497e459898ed3fee3":"1970000000000000000000","0x68a86c402388fddc59028fec7021e98cbf830eac":"19100000000000000000","0x6121af398a5b2da69f65c6381aec88ce9cc6441f":"640000000000000000000","0x5a6686b0f17e07edfc59b759c77d5bef164d3879":"1490000000000000000000","0xa2d38de1c73906f6a7ca6efeb97cf6f69cc421be":"1000000000000000000000","0xae3f98a443efe00f3e711d525d9894dc9a61157b":"295500000000000000000","0x5f1c8a04c90d735b8a152909aeae636fb0ce1665":"6999974000000000000000","0xd687cec0059087fdc713d4d2d65e77daefedc15f":"60000000000000000000","0x845203750f7148a9aa262921e86d43bf641974fd":"100000000000000000000","0x64464a6805b462412a901d2db8174b06c22deea6":"475600000000000000000","0x053471cd9a41925b3904a5a8ffca3659e034be23":"199600000000000000000","0x911ff233e1a211c0172c92b46cf997030582c83a":"1970000000000000000000","0xd930b27a78876485d0f48b70dd5336549679ca8f":"40000000000000000000","0x6ba9b21b35106be159d1c1c2657ac56cd29ffd44":"4480000000000000000000","0xebac2b4408ef5431a13b8508e86250982114e145":"4000000000000000000000","0x931df34d1225bcd4224e63680d5c4c09bce735a6":"68000000000000000000","0x23eb6fd85671a9063ab7678ebe265a20f61a02b3":"2000000000000000000000","0xb32af3d3e8d075344926546f2e32887bf93b16bd":"200000000000000000000","0x8261fa230c901d43ff579f4780d399f31e6076bc":"2000000000000000000000","0x84a74ceecff65cb93b2f949d773ef1ad7fb4a245":"92998000000000000000","0xda982e9643ffece723075a40fe776e5ace04b29b":"160884000000000000000","0xba70e8b4759c0c3c82cc00ac4e9a94dd5bafb2b8":"890342000000000000000","0x82f2e991fd324c5f5d17768e9f61335db6319d6c":"500000000000000000000","0x3e84b35c5b2265507061d30b6f12da033fe6f8b9":"1790000000000000000000","0x2895e80999d406ad592e2b262737d35f7db4b699":"1940000000000000000000","0x65f534346d2ffb787fa9cf185d745ba42986bd6e":"500000000000000000000","0xc7368b9709a5c1b51c0adf187a65df14e12b7dba":"9489681000000000000000","0xba176dbe3249e345cd4fa967c0ed13b24c47e586":"399990000000000000000","0xcff6a6fe3e9a922a12f21faa038156918c4fcb9c":"78800000000000000000","0xbcbd31252ec288f91e298cd812c92160e738331a":"1975802000000000000000","0x5543dd6d169eec8a213bbf7a8af9ffd15d4ff759":"18200000000000000000","0xb65bd780c7434115162027565223f44e5498ff8c":"19999800000000000000000","0x4cadf573ce4ceec78b8e1b21b0ed78eb113b2c0e":"2000000000000000000000","0x04aafc8ae5ce6f4903c89d7fac9cb19512224777":"500000000000000000000","0xfdc4d4765a942f5bf96931a9e8cc7ab8b757ff4c":"87000000000000000000000","0x38c7851f5ffd4cee98df30f3b25597af8a6ca263":"2631920000000000000000","0x0e320219838e859b2f9f18b72e3d4073ca50b37d":"2000000000000000000000","0xbbbf39b1b67995a42241504f9703d2a14a515696":"1580000000000000000000","0x5b800bfd1b3ed4a57d875aed26d42f1a7708d72a":"6392000000000000000000","0x5b85e60e2af0544f2f01c64e2032900ebd38a3c7":"2000000000000000000000","0xc9ac01c3fb0929033f0ccc7e1acfeaaba7945d47":"12459235000000000000000","0xf355d3ec0cfb907d8dbb1bf3464e458128190bac":"4925600000000000000000","0x69c08d744754de709ce96e15ae0d1d395b3a2263":"1000000000000000000000","0xcef77451dfa2c643e00b156d6c6ff84e2373eb66":"188000000000000000000","0xf3034367f87d24d3077fa9a2e38a8b0ccb1104ef":"1000000000000000000000","0x73473e72115110d0c3f11708f86e77be2bb0983c":"20000000000000000000","0x761e6caec189c230a162ec006530193e67cf9d19":"2000000000000000000000","0xe9caf827be9d607915b365c83f0d3b7ea8c79b50":"3000000000000000000000","0xeda4b2fa59d684b27a810df8978a73df308a63c2":"4000000000000000000000","0x065ff575fd9c16d3cb6fd68ffc8f483fc32ec835":"200000000000000000000","0xa72ee666c4b35e82a506808b443cebd5c632c7dd":"800000000000000000000","0x5b30608c678e1ac464a8994c3b33e5cdf3497112":"400000000000000000000","0xb0c7ce4c0dc3c2bbb99cc1857b8a455f611711ce":"4000000000000000000000","0xd7274d50804d9c77da93fa480156efe57ba501de":"1940000000000000000000","0xa609c26dd350c235e44b2b9c1dddccd0a9d9f837":"1000000000000000000000","0xbddfa34d0ebf1b04af53b99b82494a9e3d8aa100":"12000000000000000000000","0xfd40242bb34a70855ef0fd90f3802dec2136b327":"1930600000000000000000","0x58aed6674affd9f64233272a578dd9386b99c263":"3400000000000000000000","0x24434a3e32e54ecf272fe3470b5f6f512f675520":"5910000000000000000000","0xa379a5070c503d2fac89b8b3afa080fd45ed4bec":"19700000000000000000000","0x37e169a93808d8035698f815c7235613c1e659f2":"1000000000000000000000","0x849b116f596301c5d8bb62e0e97a8248126e39f3":"300000000000000000000","0xfe7011b698bf3371132d7445b19eb5b094356aee":"2000000000000000000000","0xf16de1891d8196461395f9b136265b3b9546f6ef":"31313000000000000000","0x6c6564e5c9c24eaaa744c9c7c968c9e2c9f1fbae":"1357800000000000000000","0x8bb0212f3295e029cab1d961b04133a1809e7b91":"2000000000000000000000","0x408a69a40715e1b313e1354e600800a1e6dc02a5":"35144000000000000000","0xddf0cce1fe996d917635f00712f4052091dff9ea":"2000000000000000000000","0x50fef296955588caae74c62ec32a23a454e09ab8":"1201200000000000000000","0xd913f0771949753c4726acaa2bd3619c5c20ff77":"3000000000000000000000","0x9d6ecfa03af2c6e144b7c4692a86951e902e9e1f":"3000310000000000000000","0xecbe5e1c9ad2b1dccf0a305fc9522f4669dd3ae7":"5000000000000000000000","0x33e9b71823952e1f66958c278fc28b1196a6c5a4":"100000000000000000000","0x9de20bc37e7f48a80ffd7ad84ffbf1a1abe1738c":"200000000000000000000","0x16f313cf8ad000914a0a176dc6a4342b79ec2538":"2000000000000000000000","0x991ac7ca7097115f26205eee0ef7d41eb4e311ae":"20000000000000000000","0xddfafdbc7c90f1320e54b98f374617fbd01d109f":"13370000000000000000","0x26b11d066588ce74a572a85a6328739212aa8b40":"2000000000000000000000","0xef2c34bb487d3762c3cca782ccdd7a8fbb0a9931":"180000000000000000000","0xa9be88ad1e518b0bbb024ab1d8f0e73f790e0c76":"2800000000000000000000","0x4a7494cce44855cc80582842be958a0d1c0072ee":"2400000000000000000000","0x23569542c97d566018c907acfcf391d14067e87e":"2000000000000000000000","0xd252960b0bf6b2848fdead80136db5f507f8be02":"2000000000000000000000","0x2c0f5b9df43625798e7e03c1a5fd6a6d091af82b":"31200000000000000000","0xa7c9d388ebd873e66b1713448397d0f37f8bd3a8":"5000000000000000000000","0x3259bd2fddfbbc6fbad3b6e874f0bbc02cda18b5":"11886645000000000000000","0xf287ff52f461117adb3e1daa71932d1493c65f2e":"3640000000000000000000","0xc852428d2b586497acd30c56aa13fb5582f84402":"945600000000000000000","0x296f00de1dc3bb01d47a8ccd1e5d1dd9a1eb7791":"1000000000000000000000","0x817493cd9bc623702a24a56f9f82e3fd48f3cd31":"2920000000000000000000","0x7adfedb06d91f3cc7390450b85550270883c7bb7":"322312000000000000000","0x8d544c32c07fd0842c761d53a897d6c950bb7599":"200000000000000000000","0x86297d730fe0f7a9ee24e08fb1087b31adb306a7":"2000000000000000000000","0xf64fe0939a8d1eea2a0ecd9a9730fd7958e33109":"20600000000000000000","0xb06eab09a610c6a53d56a946b2c43487ac1d5b2d":"1000000000000000000000","0xbae9b82f7299631408659dd74e891cb8f3860fe5":"1970000000000000000000","0x0eda80f4ed074aea697aeddf283b63dbca3dc4da":"2000000000000000000000","0xea686c5057093c171c66db99e01b0ececb308683":"384907000000000000000","0x425725c0f08f0811f5f006eec91c5c5c126b12ae":"150000000000000000000","0xb18e67a5050a1dc9fb190919a33da838ef445014":"20000000000000000000","0x8dd484ff8a307364eb66c525a571aac701c5c318":"4000000000000000000000","0x6671b182c9f741a0cd3c356c73c23126d4f9e6f4":"200000000000000000000","0xba0249e01d945bef93ee5ec61925e03c5ca509fd":"4000000000000000000000","0xb2968f7d35f208871631c6687b3f3daeabc6616c":"156060000000000000000","0xa6f62b8a3d7f11220701ab9ffffcb327959a2785":"506000000000000000000","0xc885a18aabf4541b7b7b7ecd30f6fae6869d9569":"2000000000000000000000","0x33fb577a4d214fe010d32cca7c3eeda63f87ceef":"1000000000000000000000","0xbe86d0b0438419ceb1a038319237ba5206d72e46":"999942000000000000000","0x466292f0e80d43a78774277590a9eb45961214f4":"970000000000000000000","0xb33c0323fbf9c26c1d8ac44ef74391d0804696da":"20000000000000000000","0xf7bc4c44910d5aedd66ed2355538a6b193c361ec":"96980000000000000000","0xd0f04f52109aebec9a7b1e9332761e9fe2b97bb5":"4000000000000000000000","0xcb4a914d2bb029f32e5fef5c234c4fec2d2dd577":"1800000000000000000000","0x2e619f57abc1e987aa936ae3a2264962e7eb2d9a":"756000000000000000000","0x166bf6dab22d841b486c38e7ba6ab33a1487ed8c":"20000000000000000000000","0xc3a046e3d2b2bf681488826e32d9c061518cfe8c":"2600000000000000000000","0xd082275f745a2cac0276fbdb02d4b2a3ab1711fe":"30000000000000000000","0xa701df79f594901afe1444485e6b20c3bda2b9b3":"1000000000000000000000","0xdec3eec2640a752c466e2b7e7ee685afe9ac41f4":"1324245000000000000000","0x8134dd1c9df0d6c8a5812426bb55c761ca831f08":"122360000000000000000","0xbfc57aa666fae28e9f107a49cb5089a4e22151dd":"1000000000000000000000","0xc3c2297329a6fd99117e54fc6af379b4d556547e":"6000000000000000000000","0x40585200683a403901372912a89834aadcb55fdb":"2000000000000000000000","0xcd49bf185e70d04507999f92a4de4455312827d0":"1000000000000000000000","0x9c6bc9a46b03ae5404f043dfcf21883e4110cc33":"200000000000000000000","0x1f49b86d0d3945590698a6aaf1673c37755ca80d":"700000000000000000000","0xefeb1997aad277cc33430e6111ed0943594048b8":"2000000000000000000000","0x7c0883054c2d02bc7a852b1f86c42777d0d5c856":"500000000000000000000","0xff49a775814ec00051a795a875de24592ea400d4":"200000000000000000000000","0xf039683d7b3d225bc7d8dfadef63163441be41e2":"34380000000000000000","0xa3ba0d3a3617b1e31b4e422ce269e873828d5d69":"850000000000000000000","0xd116f3dcd5db744bd008887687aa0ec9fd7292aa":"1000000000000000000000","0x5719f49b720da68856f4b9e708f25645bdbc4b41":"640000000000000000000","0x870796abc0db84af82da52a0ed68734de7e636f5":"300000000000000000000","0x68b6854788a7c6496cdbf5f84b9ec5ef392b78bb":"19700000000000000000000","0x8c2fbeee8eacc5c5d77c16abd462ee9c8145f34b":"1940000000000000000000","0x421684baa9c0b4b5f55338e6f6e7c8e146d41cb7":"1500000000000000000000","0xdd26b429fd43d84ec179825324bad5bfb916b360":"5142000000000000000000","0x3821862493242c0aeb84b90de05d250c1e50c074":"322200000000000000000","0x68a7425fe09eb28cf86eb1793e41b211e57bd68d":"668500000000000000000","0xda875e4e2f3cabe4f37e0eaed7d1f6dcc6ffef43":"2000000000000000000000","0xc2663f8145dbfec6c646fc5c49961345de1c9f11":"690000000000000000000","0xe89c22f1a4e1d4746ecfaa59ed386fee12d51e37":"44932000000000000000","0xeff86b5123bcdc17ed4ce8e05b7e12e51393a1f7":"500000000000000000000","0x6c3d18704126aa99ee3342ce60f5d4c85f1867cd":"50000000000000000000","0xb8d531a964bcea13829620c0ced72422dadb4cca":"169990000000000000000","0x7c29d47d57a733f56b9b217063b513dc3b315923":"4000000000000000000000","0xbc1e80c181616342ebb3fb3992072f1b28b802c6":"4000000000000000000000","0x31313ffd635bf2f3324841a88c07ed146144ceeb":"1970000000000000000000","0xcc4feb72df98ff35a138e01761d1203f9b7edf0a":"7000000000000000000000","0x741693c30376508513082020cc2b63e9fa92131b":"1200000000000000000000","0xaa3135cb54f102cbefe09e96103a1a796718ff54":"57800000000000000000","0xef61155ba009dcdebef10b28d9da3d1bc6c9ced4":"59100000000000000000","0xb3c94811e7175b148b281c1a845bfc9bb6fbc115":"200000000000000000000","0x96d9cca8f55eea0040ec6eb348a1774b95d93ef4":"4000000000000000000000","0xce62125adec3370ac52110953a4e760be9451e3b":"152000000000000000000","0xaca1e6bc64cc3180f620e94dc5b1bcfd8158e45d":"2000000000000000000000","0xbc237148d30c13836ffa2cad520ee4d2e5c4eeff":"1970000000000000000000","0x0e024e7f029c6aaf3a8b910f5e080873b85795aa":"1000000000000000000000","0x7283cd4675da58c496556151dafd80c7f995d318":"760000000000000000000","0x39b299327490d72f9a9edff11b83afd0e9d3c450":"200000000000000000000","0x5f333a3b2310765a0d1832b9be4c0a03704c1c09":"1000000000000000000000","0x5aaf1c31254a6e005fba7f5ab0ec79d7fc2b630e":"5910000000000000000000","0x833db42c14163c7be4cab86ac593e06266d699d5":"174212000000000000000000","0xf32d25eb0ea2b8b3028a4c7a155dc1aae865784d":"5710684000000000000000","0x1fa2319fed8c2d462adf2e17feec6a6f30516e95":"125300000000000000000","0xc49cfaa967f3afbf55031061fc4cef88f85da584":"2000000000000000000000","0x43db7ff95a086d28ebbfb82fb8fb5f230a5ebccd":"16100000000000000000","0xcf3f9128b07203a3e10d7d5755c0c4abc6e2cac2":"5000000000000000000000","0x8f4d1e7e4561284a34fef9673c0d34e12af4aa03":"2000000000000000000000","0x934af21b7ebfa467e2ced65aa34edd3a0ec71332":"35420000000000000000000","0x5d231a70c1dfeb360abd97f616e2d10d39f3cab5":"400000000000000000000","0x2d5d7335acb0362b47dfa3a8a4d3f5949544d380":"200000000000000000000","0xd1e1f2b9c16c309874dee7fac32675aff129c398":"72800000000000000000","0xa43b6da6cb7aac571dff27f09d39f846f53769b1":"380000000000000000000","0x779274bf1803a336e4d3b00ddd93f2d4f5f4a62e":"1000000000000000000000","0xa644ed922cc237a3e5c4979a995477f36e50bc62":"583900000000000000000","0xee6c03429969ca1262cb3f0a4a54afa7d348d7f5":"256100000000000000000","0x4f06246b8d4bd29661f43e93762201d286935ab1":"4818730000000000000000","0xe04972a83ca4112bc871c72d4ae1616c2f0728db":"267606000000000000000","0xdf098f5e4e3dffa51af237bda8652c4f73ed9ca6":"502000000000000000000","0xdfded2574b27d1613a7d98b715159b0d00baab28":"20000000000000000000000","0x17d931d4c56294dcbe77c8655be4695f006d4a3c":"2000000000000000000000","0x3ccb71aa6880cb0b84012d90e60740ec06acd78f":"2000000000000000000000","0xe57d2995b0ebdf3f3ca6c015eb04260dbb98b7c6":"2000000000000000000000","0xfb3860f4121c432ebdc8ec6a0331b1b709792e90":"600400000000000000000","0xfa00c376e89c05e887817a9dd0748d96f341aa89":"300700000000000000000","0xc7a018f0968a51d1f6603c5c49dc545bcb0ff293":"4000000000000000000000","0x7d73863038ccca22f96affda10496e51e1e6cd48":"20000000000000000000","0x38ea6f5b5a7b88417551b4123dc127dfe9342da6":"400000000000000000000","0x014b7f67b14f5d983d87014f570c8b993b9872b5":"200000000000000000000","0x8ac89bd9b8301e6b0677fa25fcf0f58f0cc7b611":"20000000000000000000","0x7eb4b0185c92b6439a08e7322168cb353c8a774a":"10165988000000000000000","0xd29dc08efbb3d72e263f78ab7610d0226de76b00":"12000000000000000000000","0x72a8260826294726a75bf39cd9aa9e07a3ea14cd":"2000000000000000000000","0x4cb5c6cd713ca447b848ae2f56b761ca14d7ad57":"267400000000000000000","0x49185dd7c23632f46c759473ebae966008cd3598":"254030000000000000000","0x13d67a7e25f2b12cdb85585009f8acc49b967301":"1999944000000000000000","0x9d913b5d339c95d87745562563fea98b23c60cc4":"170718000000000000000","0xabdc9f1bcf4d19ee96591030e772c334302f7d83":"40110000000000000000000","0xe9a5ae3c9e05977dd1069e9fd9d3aefbae04b8df":"1970000000000000000000","0x1fd296be03ad737c92f9c6869e8d80a71c5714aa":"13370000000000000000","0x2f13657526b177cad547c3908c840eff647b45d9":"1170685000000000000000","0xe69fcc26ed225f7b2e379834c524d70c1735e5bc":"2000000000000000000000","0xbade43599e02f84f4c3014571c976b13a36c65ab":"4000000000000000000000","0x184a4f0beb71ffd558a6b6e8f228b78796c4cf3e":"12000000000000000000000","0xd1de5aad3a5fd803f1b1aeb6103cb8e14fe723b7":"20000000000000000000","0x0bd67dbde07a856ebd893b5edc4f3a5be4202616":"2000000000000000000000","0x6b30f1823910b86d3acb5a6afc9defb6f3a30bf8":"4200000000000000000000","0x9a63d185a79129fdab19b58bb631ea36a420544e":"42000000000000000000","0xdf660a91dab9f730f6190d50c8390561500756ca":"2000000000000000000000","0xa1a1f0fa6d20b50a794f02ef52085c9d036aa6ca":"1000000000000000000000","0x4ec768295eeabafc42958415e22be216cde77618":"59600000000000000000","0xc348fc5a461323b57be303cb89361b991913df28":"100000000000000000000000","0x3a7db224acae17de7798797d82cdf8253017dfa8":"5000000000000000000000","0x8bea40379347a5c891d59a6363315640f5a7e07a":"1999992000000000000000","0x2257fca16a6e5c2a647c3c29f36ce229ab93b17e":"4000000000000000000000","0xe492818aa684e5a676561b725d42f3cc56ae5198":"800000000000000000000","0xc841884fa4785fb773b28e9715fae99a5134305d":"2000000000000000000000","0x0d9443a79468a5bbf7c13c6e225d1de91aee07df":"70000000000000000000","0x6d4008b4a888a826f248ee6a0b0dfde9f93210b9":"5460000000000000000000","0x884980eb4565c1048317a8f47fdbb461965be481":"3999922000000000000000","0x985d70d207892bed398590024e2421b1cc119359":"20000000000000000000000","0xd9ec8fe69b7716c0865af888a11b2b12f720ed33":"4000000000000000000000","0x49b74e169265f01a89ec4c9072c5a4cd72e4e835":"16100000000000000000000","0x4c3e95cc3957d252ce0bf0c87d5b4f2234672e70":"2500000000000000000000","0xd9ff115d01266c9f73b063c1c238ef3565e63b36":"680000000000000000000","0x48c5c6970b9161bb1c7b7adfed9cdede8a1ba864":"4000000000000000000000","0xea6afe2cc928ac8391eb1e165fc40040e37421e7":"2997569000000000000000","0x08ccda50e4b26a0ffc0ef92e9205310706bec2c7":"6077440000000000000000","0xe6e9a39d750fe994394eb68286e5ea62a6997882":"600000000000000000000","0x4b58101f44f7e389e12d471d1635b71614fdd605":"160000000000000000000","0x8d93dac785f88f1a84bf927d53652b45a154ccdd":"158000000000000000000","0x415d096ab06293183f3c033d25f6cf7178ac3bc7":"40000000000000000000","0xc3e387b03ce95ccfd7fa51dd840183bc43532809":"2000000000000000000000","0xda34b2eae30bafe8daeccde819a794cd89e09549":"2000000000000000000000","0xfa279bfd8767f956bf7fa0bd5660168da75686bd":"2674000000000000000000","0xb98ca31785ef06be49a1e47e864f60d076ca472e":"4000000000000000000000","0xb768b5234eba3a9968b34d6ddb481c8419b3655d":"14974000000000000000","0x31047d703f63b93424fbbd6e2f1f9e74de13e709":"2850123000000000000000","0x9a24ce8d485cc4c86e49deb39022f92c7430e67e":"1300000000000000000000","0xe62f9d7c64e8e2635aeb883dd73ba684ee7c1079":"8000000000000000000000","0xf15d9d5a21b1929e790371a17f16d95f0c69655c":"2000000000000000000000","0x285ae51b9500c58d541365d97569f14bb2a3709b":"2000000000000000000000","0x09c177f1ae442411ddacf187d46db956148360e7":"8950000000000000000000","0x12173074980153aeaa4b0dcbc7132eadcec21b64":"240000000000000000000","0x351f16e5e0735af56751b0e225b2421171394090":"13370000000000000000000","0xac52b77e15664814f39e4f271be641308d91d6cc":"220000000000000000000","0x99c883258546cc7e4e971f522e389918da5ea63a":"4000000000000000000000","0xaa16269aac9c0d803068d82fc79151dadd334b66":"4000000000000000000000","0x7c9a110cb11f2598b2b20e2ca400325e41e9db33":"26000000000000000000000","0x583e83ba55e67e13e0e76f8392d873cd21fbf798":"20000000000000000000","0x555ebe84daa42ba256ea789105cec4b693f12f18":"100000000000000000000","0x978c430ce4359b06bc2cdf5c2985fc950e50d5c8":"480000000000000000000","0xdc1eb9b6e64351f56424509645f83e79eee76cf4":"4000000000000000000000","0x5b290c01967c812e4dc4c90b174c1b4015bae71e":"149946000000000000000","0xe7d213947fcb904ad738480b1eed2f5c329f27e8":"18718000000000000000","0xc517d0315c878813c717e18cafa1eab2654e01da":"10000000000000000000000","0x7e972a8a7c2a44c93b21436c38d21b9252c345fe":"1790000000000000000000","0x9cb28ac1a20a106f7f373692c5ce4c73f13732a1":"1000000000000000000000","0x14ab164b3b524c82d6abfbc0de831126ae8d1375":"2000000000000000000000","0xd46f8223452982a1eea019a8816efc2d6fc00768":"137000000000000000000","0x5cdc4708f14f40dcc15a795f7dc8cb0b7faa9e6e":"537000000000000000000","0x66fdc9fee351fa1538eb0d87d819fcf09e7c106a":"6016500000000000000000","0xe7be82c6593c1eeddd2ae0b15001ff201ab57b2f":"19100000000000000000","0x47d20e6ae4cad3f829eac07e5ac97b66fdd56cf5":"1000000000000000000000","0x0f2d8daf04b5414a0261f549ff6477b80f2f1d07":"200000000000000000000000","0x84bfcef0491a0ae0694b37ceac024584f2aa0467":"1999944000000000000000","0xec5feafe210c12bfc9a5d05925a123f1e73fbef8":"456000000000000000000000","0x7023c70956e04a92d70025aad297b539af355869":"2000000000000000000000","0xd66ddf1159cf22fd8c7a4bc8d5807756d433c43e":"2200000000000000000000","0xd0638ea57189a6a699024ad78c71d939c1c2ff8c":"2632000000000000000000","0x70d25ed2c8ada59c088cf70dd22bf2db93acc18a":"1056600000000000000000","0xa4875928458ec2005dbb578c5cd33580f0cf1452":"1000000000000000000000","0xb5ad5157dda921e6bafacd9086ae73ae1f611d3f":"2000000000000000000000","0xc493489e56c3bdd829007dc2f956412906f76bfa":"48968000000000000000","0xc57612de91110c482e6f505bcd23f3c5047d1d61":"3580000000000000000000","0x9b18478655a4851cc906e660feac61f7f4c8bffc":"4174120000000000000000","0xb21b7979bf7c5ca01fa82dd640b41c39e6c6bc75":"1999944000000000000000","0xa9d4a2bcbe5b9e0869d70f0fe2e1d6aacd45edc5":"198800000000000000000","0x6f29bb375be5ed34ed999bb830ee2957dde76d16":"2000000000000000000000","0xa006268446643ec5e81e7acb3f17f1c351ee2ed9":"4000000000000000000000","0x42ddd014dc52bfbcc555325a40b516f4866a1dd3":"2000000000000000000000","0xd6d6776958ee23143a81adadeb08382009e996c2":"3000000000000000000000","0xd34e03d36a2bd4d19a5fa16218d1d61e3ffa0b15":"320000000000000000000","0xdac0c177f11c5c3e3e78f2efd663d13221488574":"1000000000000000000000","0x814135da8f9811075783bf1ab67062af8d3e9f40":"20000000000000000000","0x7c3eb713c4c9e0381cd8154c7c9a7db8645cde17":"200000000000000000000","0xf49c47b3efd86b6e6a5bc9418d1f9fec814b69ef":"20000000000000000000000","0x35f1da127b83376f1b88c82a3359f67a5e67dd50":"1910000000000000000000","0x44dfba50b829becc5f4f14d1b04aab3320a295e5":"1000000000000000000000","0x0b924df007e9c0878417cfe63b976ea1a382a897":"40000000000000000000","0x82438fd2b32a9bdd674b49d8cc5fa2eff9781847":"20000000000000000000","0x794529d09d017271359730027075b87ad83dae6e":"310000000000000000000","0xf4b49100757772f33c177b9a76ba95226c8f3dd8":"6700000000000000000000","0x8563c49361b625e768771c96151dbfbd1c906976":"2000000000000000000000","0x0b9df80fbe232009dacf0aa8cac59376e2476203":"2000000000000000000000","0x149b6dbde632c19f5af47cb493114bebd9b03c1f":"12000000000000000000000","0xd7a1431ee453d1e49a0550d1256879b4f5d10201":"1670000000000000000000","0x1d37616b793f94911838ac8e19ee9449df921ec4":"1500000000000000000000","0xd6670c036df754be43dadd8f50feea289d061fd6":"5988459000000000000000","0x02778e390fa17510a3428af2870c4273547d386c":"16163700000000000000000","0xb89f4632df5909e58b2a9964f74feb9a3b01e0c5":"21406707000000000000000","0x76c27535bcb59ce1fa2d8c919cabeb4a6bba01d1":"2000000000000000000000","0x36bf43ff35df90908824336c9b31ce33067e2f50":"346837200000000000000000","0xb53bcb174c2518348b818aece020364596466ba3":"2000000000000000000000","0xb4dd460cd016725a64b22ea4f8e06e06674e033e":"5370000000000000000000","0xcda1741109c0265b3fb2bf8d5ec9c2b8a3346b63":"20000000000000000000","0xfeb8b8e2af716ae41fc7c04bcf29540156461e6b":"1555396000000000000000","0xa49f523aa51364cbc7d995163d34eb590ded2f08":"2659160000000000000000","0xa7e74f0bdb278ff0a805a648618ec52b166ff1be":"100000000000000000000","0x5ead29037a12896478b1296ab714e9cb95428c81":"71500000000000000000","0xcdecf5675433cdb0c2e55a68db5d8bbe78419dd2":"20000000000000000000","0xc24ccebc2344cce56417fb684cf81613f0f4b9bd":"1550000000000000000000","0x5a70106f20d63f875265e48e0d35f00e17d02bc9":"20000000000000000000","0x2606c3b3b4ca1b091498602cb1978bf3b95221c0":"400000000000000000000","0x1ad4563ea5786be1159935abb0f1d5879c3e7372":"6000000000000000000000","0xb782bfd1e2de70f467646f9bc09ea5b1fcf450af":"267400000000000000000","0x649a2b9879cd8fb736e6703b0c7747849796f10f":"7358102000000000000000","0x1cc1d3c14f0fb8640e36724dc43229d2ea7a1e48":"1700000000000000000000","0x824b3c3c443e19295d7ef6faa7f374a4798486a8":"20000000000000000000","0xa7758cecb60e8f614cce96137ef72b4fbd07774a":"500000000000000000000","0x981f712775c0dad97518ffedcb47b9ad1d6c2762":"6685000000000000000000","0x26e801b62c827191dd68d31a011990947fd0ebe0":"20000000000000000000","0x95447046313b2f3a5e19b948fd3b8bedc82c717c":"500000000000000000000","0x0b701101a4109f9cb360dc57b77442673d5e5983":"2000000000000000000000","0x5b25cae86dcafa2a60e7723631fc5fa49c1ad87d":"2491200000000000000000","0xf73ac46c203be1538111b151ec8220c786d84144":"294515000000000000000","0xe8c3d3b0e17f97d1e756e684f94e1470f99c95a1":"400000000000000000000","0x8c900a8236b08c2b65405d39d75f20062a7561fd":"1640000000000000000000","0x43898c49a34d509bfed4f76041ee91caf3aa6aa5":"300000000000000000000","0xc85325eab2a59b3ed863c86a5f2906a04229ffa9":"465600000000000000000","0x4a430170152de5172633dd8262d107a0afd96a0f":"3160000000000000000000","0x6e0ee70612c976287d499ddfa6c0dcc12c06deea":"129980000000000000000","0x21c07380484f6cbc8724ad32bc864c3b5ad500b7":"1000000000000000000000","0xff5162f2354dc492c75fd6e3a107268660eecb47":"1700000000000000000000","0x8845e9f90e96336bac3c616be9d88402683e004c":"2000000000000000000000","0xf23c7b0cb8cd59b82bd890644a57daf40c85e278":"50038000000000000000","0x1784948bf99848c89e445638504dd698271b5924":"6037580000000000000000","0xb39f4c00b2630cab7db7295ef43d47d501e17fd7":"4000000000000000000000","0x3fb7d197b3ba4fe045efc23d50a14585f558d9b2":"20000000000000000000","0xbd043b67c63e60f841ccca15b129cdfe6590c8e3":"200000000000000000000","0x86ca0145957e6b0dfe36875fbe7a0dec55e17a28":"10000000000000000000000","0xdae7201eab8c063302930d693929d07f95e71962":"2687370000000000000000","0xcc034985d3f28c2d39b1a34bced4d3b2b6ca234e":"182000000000000000000","0x40e0dbf3efef9084ea1cd7e503f40b3b4a8443f6":"4000000000000000000000","0xb1896a37e5d8825a2d01765ae5de629977de8352":"200000000000000000000","0xd9f547f2c1de0ed98a53d161df57635dd21a00bd":"98500000000000000000","0x2fea1b2f834f02fc54333f8a809f0438e5870aa9":"20200000000000000000","0x68b31836a30a016ada157b638ac15da73f18cfde":"26000000000000000000","0xbc967fe4418c18b99858966d870678dca2b88879":"8740000000000000000000","0x16bae5d24eff91778cd98b4d3a1cc3162f44aa77":"401100000000000000000","0xf476e1267f86247cc908816f2e7ad5388c952db0":"4000000000000000000000","0x0203ae01d4c41cae1865e04b1f5b53cdfaecae31":"1006054000000000000000","0xbd4bd5b122d8ef7b7c8f0667450320db2116142e":"600000000000000000000","0xa394ad4fd9e6530e6f5c53faecbede81cb172da1":"5600000000000000000000","0x3a9960266df6492063538a99f487c950a3a5ec9e":"24000000000000000000000","0xd8069f84b521493f4715037f3226b25f33b60586":"1910000000000000000000","0x136c834bf111326d207395295b2e583ea7f33572":"100000000000000000000","0xc5c73d61cce7c8fe4c8fce29f39092cd193e0fff":"8000000000000000000000","0x3cfbf066565970639e130df2a7d16b0e14d6091c":"1700000000000000000000","0x61b905de663fc17386523b3a28e2f7d037a655cd":"500000000000000000000","0xfda0ce15330707f10bce3201172d2018b9ddea74":"51900000000000000000","0xf7fc45abf76f5088e2e5b5a8d132f28a4d4ec1c0":"2000000000000000000000","0xc3db9fb6f46c480af34465d79753b4e2b74a67ce":"20000000000000000000000","0xebe46cc3c34c32f5add6c3195bb486c4713eb918":"1000000000000000000000","0x91d2a9ee1a6db20f5317cca7fbe2313895db8ef8":"8499600000000000000000","0xc4cc45a2b63c27c0b4429e58cd42da59be739bd6":"1000000000000000000000","0xa43b81f99356c0af141a03010d77bd042c71c1ee":"2000000000000000000000","0x4c45d4c9a725d11112bfcbca00bf31186ccaadb7":"400000000000000000000","0xbf9f271f7a7e12e36dd2fe9facebf385fe6142bd":"62760000000000000000","0xe0ce80a461b648a501fd0b824690c8868b0e4de8":"500000000000000000000","0xa1f7dde1d738d8cd679ea1ee965bee224be7d04d":"1127000000000000000000","0x7f1c81ee1697fc144b7c0be5493b5615ae7fddca":"500200000000000000000","0xb508f987b2de34ae4cf193de85bff61389621f88":"6000000000000000000000","0x5f26cf34599bc36ea67b9e7a9f9b4330c9d542a3":"1000000000000000000000","0xd02108d2ae3cab10cbcf1657af223e027c8210f6":"2000140000000000000000","0x952183cfd38e352e579d36decec5b18450f7fba0":"2000000000000000000000","0xeb90c793b3539761e1c814a29671148692193eb4":"12000000000000000000000","0x1076212d4f758c8ec7121c1c7d74254926459284":"35000056000000000000000","0xf05ceeab65410564709951773c8445ad9f4ec797":"299982000000000000000","0x05361d8eb6941d4e90fb7e1418a95a32d5257732":"20000000000000000000","0xa5783bf33432ff82ac498985d7d460ae67ec3673":"1820000000000000000000","0xb1cd4bdfd104489a026ec99d597307a04279f173":"20000000000000000000000","0x876c3f218b4776df3ca9dbfb270de152d94ed252":"100000000000000000000","0x8a36869ad478997cbf6d8924d20a3c8018e9855b":"20000000000000000000","0xfb3fe09bb836861529d7518da27635f538505615":"1399904000000000000000","0xd093e829819fd2e25b973800bb3d5841dd152d05":"4000000000000000000000","0x126d91f7ad86debb0557c612ca276eb7f96d00a1":"100000000000000000000","0x2a81d27cb6d4770ff4f3c4a3ba18e5e57f07517c":"2000000000000000000000","0xc4f7b13ac6d4eb4db3d4e6a252af8a07bd5957da":"200000000000000000000","0x305d26c10bdc103f6b9c21272eb7cb2d9108c47e":"500000000000000000000","0xd0d0a2ad45f59a9dccc695d85f25ca46ed31a5a3":"840000000000000000000","0x522323aad71dbc96d85af90f084b99c3f09decb7":"6000000000000000000000","0xf43da3a4e3f5fab104ca9bc1a0f7f3bb4a56f351":"1999944000000000000000","0xa2dc65ee256b59a5bd7929774f904b358df3ada1":"21319600000000000000000","0xf382df583155d8548f3f93440cd5f68cb79d6026":"266619800000000000000000","0x0c967e3061b87a753e84507eb60986782c8f3013":"100000000000000000000","0xa3a262afd2936819230892fde84f2d5a594ab283":"1880000000000000000000","0x93868ddb2a794d02ebda2fa4807c76e3609858dc":"2027851000000000000000","0xcd35ff010ec501a721a1b2f07a9ca5877dfcf95a":"4011000000000000000000","0x5824a7e22838277134308c5f4b50dab65e43bb31":"6000000000000000000000","0x7f7a3a21b3f5a65d81e0fcb7d52dd00a1aa36dba":"100000000000000000000","0x30513fca9f36fd788cfea7a340e86df98294a244":"447000000000000000000","0x283e6252b4efcf4654391acb75f903c59b78c5fb":"12000000000000000000000","0xeddbaafbc21be8f25562f1ed6d05d6afb58f02c2":"2000000000000000000000","0x0dcfe837ea1cf28c65fccec3bef1f84e59d150c0":"200000000000000000000","0x828ba651cb930ed9787156299a3de44cd08b7212":"1337000000000000000000","0xcfd47493c9f89fe680bda5754dd7c9cfe7cb5bbe":"54508000000000000000","0x0e89eddd3fa0d71d8ab0ff8da5580686e3d4f74f":"2000000000000000000000","0x205f5166f12440d85762c967d3ae86184f8f4d98":"432500000000000000000","0x25dad495a11a86b9eeece1eeec805e57f157faff":"16000000000000000000000","0x6c84cba77c6db4f7f90ef13d5ee21e8cfc7f8314":"2000000000000000000000","0x91a787bc5196f34857fe0c372f4df376aaa76613":"2000000000000000000000","0xb0d3c9872b85056ea0c0e6d1ecf7a77e3ce6ab85":"4999711000000000000000","0x6e4d2e39c8836629e5b487b1918a669aebdd9536":"1000000000000000000000","0xdc703a5f3794c84d6cb3544918cae14a35c3bd4f":"1850000000000000000000","0x47beb20f759100542aa93d41118b3211d664920e":"2000000000000000000000","0x5a7735007d70b06844da9901cdfadb11a2582c2f":"6000000000000000000000","0xaff107960b7ec34ed690b665024d60838c190f70":"500000000000000000000","0x563a03ab9c56b600f6d25b660c21e16335517a75":"1000000000000000000000","0xa106465bbd19e1b6bce50d1b1157dc59095a3630":"2000000000000000000000","0xca9dec02841adf5cc920576a5187edd2bd434a18":"500000000000000000000","0x572ac1aba0de23ae41a7cae1dc0842d8abfc103b":"1910000000000000000000","0x5f74ed0e24ff80d9b2c4a44baa9975428cd6b935":"2980000000000000000000","0xf2049532fd458a83ca1bff2eebacb6d5ca63f4a4":"3625693000000000000000","0xcee699c0707a7836252b292f047ce8ad289b2f55":"324700000000000000000","0x8b3696f3c60de32432a2e4c395ef0303b7e81e75":"30000000000000000000000","0x13dee03e3799952d0738843d4be8fc0a803fb20e":"2000000000000000000000","0xc853215b9b9f2d2cd0741e585e987b5fb80c212e":"1550000000000000000000","0x851c0d62be4635d4777e8035e37e4ba8517c6132":"500000000000000000000","0xa76b743f981b693072a131b22ba510965c2fefd7":"18200000000000000000","0x69bd25ade1a3346c59c4e930db2a9d715ef0a27a":"4000000000000000000000","0x0fec4ee0d7ca180290b6bd20f9992342f60ff68d":"334383000000000000000","0xccfd725760a68823ff1e062f4cc97e1360e8d997":"399800000000000000000","0x9f017706b830fb9c30efb0a09f506b9157457534":"2000000000000000000000","0x420fb86e7d2b51401fc5e8c72015decb4ef8fc2e":"1000000000000000000000","0xcb7d2b8089e9312cc9aeaa2773f35308ec6c2a7b":"10000000000000000000000","0x6c822029218ac8e98a260c1e064029348839875b":"5010000000000000000000","0x1c68a66138783a63c98cc675a9ec77af4598d35e":"50100000000000000000","0xf270792576f05d514493ffd1f5e84bec4b2df810":"1000000000000000000000","0x9191f94698210516cf6321a142070e20597674ed":"17194000000000000000","0xc0ca3277942e7445874be31ceb902972714f1823":"250000000000000000000","0x35e096120deaa5c1ecb1645e2ccb8b4edbd9299a":"500000000000000000000","0xe2bbf84641e3541f6c33e6ed683a635a70bde2ec":"502763000000000000000","0xd12d77ae01a92d35117bac705aacd982d02e74c1":"1000000000000000000000","0xdabb0889fc042926b05ef57b2520910abc4b4149":"2000000000000000000000","0x5a1a336962d6e0c63031cc83c6a5c6a6f4478ecb":"1000000000000000000000","0xabd154903513b8da4f019f68284b0656a1d0169b":"1000000000000000000000","0xad377cd25eb53e83ae091a0a1d2b4516f484afde":"1940000000000000000000","0x08c2f236ac4adcd3fda9fbc6e4532253f9da3bec":"20000000000000000000","0x71135d8f05963c905a4a07922909235a896a52ea":"3000000000000000000000","0x080546508a3d2682c8b9884f13637b8847b44db3":"2000000000000000000000","0x2d61bfc56873923c2b00095dc3eaa0f590d8ae0f":"20760000000000000000000","0xcbfa6af6c283b046e2772c6063b0b21553c40106":"2000000000000000000000","0xccabc6048a53464424fcf76eeb9e6e1801fa23d4":"49250000000000000000","0x60cc3d445ebdf76a7d7ae571c6971dff68cc8585":"1000000000000000000000","0xfff33a3bd36abdbd412707b8e310d6011454a7ae":"8000000000000000000000","0xd2dbebe89b0357aea98bbe8e496338debb28e805":"4000000000000000000000","0x5f521282e9b278dc8c034c72af53ee29e5443d78":"6520000000000000000000","0xc5a48a8500f9b4e22f0eb16c6f4649687674267d":"812721000000000000000","0x8cb3aa3fcd212854d7578fcc30fdede6742a312a":"300000000000000000000","0x90d2809ae1d1ffd8f63eda01de49dd552df3d1bc":"3998000000000000000000","0x96a55f00dff405dc4de5e58c57f6f6f0cac55d2f":"1962711000000000000000","0xae842e81858ecfedf6506c686dc204ac15bf8b24":"40000000000000000000","0x0be6a09e4307fe48d412b8d1a1a8284dce486261":"19180000000000000000000","0xc9c7ac0bdd9342b5ead4360923f68c72a6ba633a":"500000000000000000000","0xea8f30b6e4c5e65290fb9864259bc5990fa8ee8a":"20000000000000000000","0x74d37a51747bf8b771bfbf43943933d100d21483":"1000000000000000000000","0x1a04d5389eb006f9ce880c30d15353f8d11c4b31":"17072800000000000000000","0x726a14c90e3f84144c765cffacba3e0df11b48be":"10000000000000000000000","0x86b7bd563ceab686f96244f9ddc02ad7b0b14bc2":"10000000000000000000000","0x2bbe672a1857508f630f2a5edb563d9e9de92815":"2000000000000000000000","0xa17070c2e9c5a940a4ec0e4954c4d7d643be8f49":"1999965000000000000000","0xf2d1b7357724ec4c03185b879b63f57e26589153":"6000000000000000000000","0xd6a7ac4de7b510f0e8de519d973fa4c01ba83400":"1880000000000000000000","0x593b45a1864ac5c7e8f0caaeba0d873cd5d113b2":"6000000000000000000000","0x0837539b5f6a522a482cdcd3a9bb7043af39bdd2":"6000000000000000000000","0xb927abd2d28aaaa24db31778d27419df8e1b04bb":"27531000000000000000","0xb2e085fddd1468ba07415b274e734e11237fb2a9":"100000000000000000000","0x970938522afb5e8f994873c9fbdc26e3b37e314c":"1000000000000000000000","0xf3de5f26ef6aded6f06d3b911346ee70401da4a0":"354718000000000000000","0xbffb6929241f788693273e7022e60e3eab1fe84f":"2000000000000000000000","0xb56ad2aec6c8c3f19e1515bbb7dd91285256b639":"1000000000000000000000","0x47730f5f8ebf89ac72ef80e46c12195038ecdc49":"3160000000000000000000","0xf39a9d7aa3581df07ee4279ae6c312ef21033658":"4000000000000000000000","0x36227cdfa0fd3b9d7e6a744685f5be9aa366a7f0":"198479000000000000000","0x89e3b59a15864737d493c1d23cc53dbf8dcb1362":"4000000000000000000000","0xbd08e0cddec097db7901ea819a3d1fd9de8951a2":"20000000000000000000","0x533444584082eba654e1ad30e149735c6f7ba922":"1730000000000000000000","0x6a8a4317c45faa0554ccdb482548183e295a24b9":"1000000000000000000000","0x22ce349159eeb144ef06ff2636588aef79f62832":"188000000000000000000","0x3cd1d9731bd548c1dd6fcea61beb75d91754f7d3":"5130285000000000000000","0x8b7056f6abf3b118d026e944d5c073433ca451d7":"999999000000000000000","0x15f1b352110d68901d8f67aac46a6cfafe031477":"200000000000000000000","0x0f789e30397c53bf256fc364e6ef39f853504114":"3640000000000000000000","0x750bbb8c06bbbf240843cc75782ee02f08a97453":"835000000000000000000","0xfff7ac99c8e4feb60c9750054bdc14ce1857f181":"1000000000000000000000","0x5c6f36af90ab1a656c6ec8c7d521512762bba3e1":"1999800000000000000000","0x6811b54cd19663b11b94da1de2448285cd9f68d9":"1100000000000000000000","0x6f50929777824c291a49c46dc854f379a6bea080":"360000000000000000000","0xe83604e4ff6be7f96f6018d3ec3072ec525dff6b":"182000000000000000000","0xd731bb6b5f3c37395e09ceaccd14a918a6060789":"3940000000000000000000","0x372e453a6b629f27678cc8aeb5e57ce85ec0aef9":"200000000000000000000","0x86924fb211aad23cf5ce600e0aae806396444087":"10000000000000000000000","0x18c6723a6753299cb914477d04a3bd218df8c775":"1000000000000000000000","0xe00484788db50fc6a48e379d123e508b0f6e5ab1":"1000000000000000000000","0x150e3dbcbcfc84ccf89b73427763a565c23e60d0":"40000000000000000000","0x8ffa062122ac307418821adb9311075a3703bfa3":"1000000000000000000000","0x21206ce22ea480e85940d31314e0d64f4e4d3a04":"1000000000000000000000","0xac024f594f9558f04943618eb0e6b2ee501dc272":"2000000000000000000000","0xb2b7cdb4ff4b61d5b7ce0b2270bbb5269743ec04":"2000000000000000000000","0xabc74706964960dfe0dca3dca79e9216056f1cf4":"40000000000000000000000","0xd7eb903162271c1afa35fe69e37322c8a4d29b11":"10000000000000000000000","0xd7c6265dea11876c903b718e4cd8ab24fe265bde":"2000000000000000000000","0xcba288cd3c1eb4d59ddb06a6421c14c345a47b24":"4000000000000000000000","0x8c22426055b76f11f0a2de1a7f819a619685fe60":"1980000000000000000000","0xf463a90cb3f13e1f0643423636beab84c123b06d":"40000000000000000000","0x2b5ced9987c0765f900e49cf9da2d9f9c1138855":"400000000000000000000","0x9bb760d5c289a3e1db18db095345ca413b9a43c2":"197000000000000000000","0xd66ab79294074c8b627d842dab41e17dd70c5de5":"1000000000000000000000","0x0bdd58b96e7c916dd2fb30356f2aebfaaf1d8630":"2000000000000000000000","0xd612597bc31743c78633f633f239b1e9426bd925":"76000000000000000000000","0x140518a3194bad1350b8949e650565debe6db315":"2000000000000000000000","0xdaedd4ad107b271e89486cbf80ebd621dd974578":"2000000000000000000000","0xc36c0b63bfd75c2f8efb060883d868cccd6cbdb4":"3000000000000000000000","0xe646665872e40b0d7aa2ff82729caaba5bc3e89e":"400000000000000000000","0xb5fb7ea2ddc1598b667a9d57dd39e85a38f35d56":"500000000000000000000","0xe51421f8ee2210c71ed870fe618276c8954afbe9":"1337000000000000000000","0x08a9a44e1f41de3dbba7a363a3ab412c124cd15e":"200000000000000000000","0x562bced38ab2ab6c080f3b0541b8456e70824b3f":"641760000000000000000","0x1e484d0621f0f5331b35d5408d9aae4eb1acf21e":"20000000000000000000","0x3a476bd2c9e664c63ab266aa4c6e4a4825f516c3":"200000000000000000000","0x8d6df209484d7b94702b03a53e56b9fb0660f6f0":"2000000000000000000000","0x5970fb1b144dd751e4ce2eca7caa20e363dc4da3":"10000000000000000000000","0xd1dd79fb158160e5b4e8e23f312e6a907fbc4d4e":"500000000000000000000","0x7ee5ca805dce23af89c2d444e7e40766c54c7404":"240660000000000000000","0x93e0f37ecdfb0086e3e862a97034447b1e4dec1a":"30000000000000000000","0xe10ac19c546fc2547c61c139f5d1f45a6666d5b0":"4775000000000000000000","0x1c73d00b6e25d8eb9c1ff4ad827b6b9e9cf6d20c":"200000000000000000000","0xd771d9e0ca8a08a113775731434eb3270599c40d":"20000000000000000000","0xe69d1c378b771e0feff051db69d966ac6779f4ed":"553000000000000000000","0x0ef85b49d08a75198692914eddb4b22cf5fa4450":"2004800000000000000000","0xed70a37cdd1cbda9746d939658ae2a6181288578":"9600000000000000000000","0xeee761847e33fd61d99387ee14628694d1bfd525":"2000000000000000000000","0x271d3d481cb88e7671ad216949b6365e06303de0":"4000000000000000000000","0x5255dc69155a45b970c604d30047e2f530690e7f":"20000000000000000000","0xcabab6274ed15089737e287be878b757934864e2":"20000000000000000000000","0x9defe56a0ff1a1947dba0923f7dd258d8f12fa45":"26880000000000000000000","0xb7a2c103728b7305b5ae6e961c94ee99c9fe8e2b":"50000000000000000000000","0xb498bb0f520005b6216a4425b75aa9adc52d622b":"4000000000000000000000","0xc1132878235c5ddba5d9f3228b5236e47020dc6f":"1000000000000000000000","0xf81622e55757daea6675975dd93538da7d16991e":"2000000000000000000000","0xce2deab51c0a9ae09cd212c4fa4cc52b53cc0dec":"2000000000000000000000","0x86a1eadeeb30461345d9ef6bd05216fa247c0d0c":"2000000000000000000000","0x7b1fe1ab4dfd0088cdd7f60163ef59ec2aee06f5":"2000000000000000000000","0x6bbc3f358a668dd1a11f0380f3f73108426abd4a":"4000000000000000000000","0xb1e6e810c24ab0488de9e01e574837829f7c77d0":"400000000000000000000","0x03eb3cb860f6028da554d344a2bb5a500ae8b86f":"2000000000000000000000","0xe5481a7fed42b901bbed20789bd4ade50d5f83b9":"2000000000000000000000","0x1f3da68fe87eaf43a829ab6d7ec5a6e009b204fb":"554988000000000000000","0x30037988702671acbe892c03fe5788aa98af287a":"2800000000000000000000","0xedb473353979a206879de144c10a3c51d7d7081a":"6000000000000000000000","0x22bdffc240a88ff7431af3bff50e14da37d5183e":"1000000000000000000000","0x9374869d4a9911ee1eaf558bc4c2b63ec63acfdd":"1000000000000000000000","0xb756ad52f3bf74a7d24c67471e0887436936504c":"20000000000000000000000","0x8bd0b65a50ef5cef84fec420be7b89ed1470ceb9":"11999000000000000000000","0xaf26f7c6bf453e2078f08953e4b28004a2c1e209":"100000000000000000000","0x7c532db9e0c06c26fd40acc56ac55c1ee92d3c3a":"300000000000000000000000","0xdde670d01639667576a22dd05d3246d61f06e083":"26740000000000000000","0x5cf44e10540d65716423b1bcb542d21ff83a94cd":"10000000000000000000000","0xf96b4c00766f53736a8574f822e6474c2f21da2d":"400000000000000000000","0x8d89170b92b2be2c08d57c48a7b190a2f146720f":"19700000000000000000000","0x142b87c5043ffb5a91df18c2e109ced6fe4a71db":"200000000000000000000","0x42d34940edd2e7005d46e2188e4cfece8311d74d":"158000000000000000000","0x562105e82b099735de49f62692cc87cd38a8edcd":"6000000000000000000000","0x457bcef37dd3d60b2dd019e3fe61d46b3f1e7252":"20000000000000000000","0xcf8882359c0fb23387f5674074d8b17ade512f98":"6000000000000000000000","0xf0c081da52a9ae36642adf5e08205f05c54168a6":"111000000000000000000","0x551e7784778ef8e048e495df49f2614f84a4f1dc":"600000000000000000000","0x3c869c09696523ced824a070414605bb76231ff2":"1000000000000000000000","0x7e7f18a02eccaa5d61ab8fbf030343c434a25ef7":"66850000000000000000","0x9328d55ccb3fce531f199382339f0e576ee840a3":"4000000000000000000000","0x9d0f347e826b7dceaad279060a35c0061ecf334b":"4000000000000000000000","0x680640838bd07a447b168d6d923b90cf6c43cdca":"1730000000000000000000","0xc951900c341abbb3bafbf7ee2029377071dbc36a":"327600000000000000000","0xddf5810a0eb2fb2e32323bb2c99509ab320f24ac":"17900000000000000000000","0x2489ac126934d4d6a94df08743da7b7691e9798e":"1000000000000000000000","0xf42f905231c770f0a406f2b768877fb49eee0f21":"197000000000000000000","0x756f45e3fa69347a9a973a725e3c98bc4db0b5a0":"200000000000000000000"}');
},
/*!*******************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-common/dist/genesisStates/ropsten.json ***!
  \*******************************************************************************************************/

/*! exports provided: 0x0000000000000000000000000000000000000011, 0x0000000000000000000000000000000000000010, 0x0000000000000000000000000000000000000013, 0x0000000000000000000000000000000000000012, 0x0000000000000000000000000000000000000015, 0x0000000000000000000000000000000000000014, 0x0000000000000000000000000000000000000017, 0x0000000000000000000000000000000000000016, 0x0000000000000000000000000000000000000019, 0x0000000000000000000000000000000000000018, 0x00000000000000000000000000000000000000c1, 0x00000000000000000000000000000000000000c0, 0x00000000000000000000000000000000000000c7, 0x00000000000000000000000000000000000000c6, 0x00000000000000000000000000000000000000c5, 0x00000000000000000000000000000000000000c4, 0x000000000000000000000000000000000000002d, 0x000000000000000000000000000000000000002e, 0x000000000000000000000000000000000000002f, 0x00000000000000000000000000000000000000c8, 0x000000000000000000000000000000000000002a, 0x000000000000000000000000000000000000002b, 0x000000000000000000000000000000000000002c, 0x0000000000000000000000000000000000000091, 0x0000000000000000000000000000000000000090, 0x0000000000000000000000000000000000000093, 0x0000000000000000000000000000000000000092, 0x0000000000000000000000000000000000000095, 0x0000000000000000000000000000000000000094, 0x0000000000000000000000000000000000000097, 0x0000000000000000000000000000000000000096, 0x0000000000000000000000000000000000000076, 0x000000000000000000000000000000000000000c, 0x00000000000000000000000000000000000000c3, 0x00000000000000000000000000000000000000c2, 0x0000000000000000000000000000000000000081, 0x000000000000000000000000000000000000000a, 0x0000000000000000000000000000000000000024, 0x0000000000000000000000000000000000000025, 0x0000000000000000000000000000000000000026, 0x0000000000000000000000000000000000000027, 0x0000000000000000000000000000000000000020, 0x0000000000000000000000000000000000000021, 0x0000000000000000000000000000000000000022, 0x0000000000000000000000000000000000000023, 0x000000000000000000000000000000000000009a, 0x00000000000000000000000000000000000000d7, 0x000000000000000000000000000000000000009c, 0x000000000000000000000000000000000000009b, 0x0000000000000000000000000000000000000028, 0x0000000000000000000000000000000000000029, 0x00000000000000000000000000000000000000d0, 0x000000000000000000000000000000000000009f, 0x000000000000000000000000000000000000001a, 0x000000000000000000000000000000000000001c, 0x000000000000000000000000000000000000001b, 0x000000000000000000000000000000000000001e, 0x000000000000000000000000000000000000001d, 0x000000000000000000000000000000000000001f, 0x00000000000000000000000000000000000000cc, 0x00000000000000000000000000000000000000cb, 0x00000000000000000000000000000000000000ca, 0x00000000000000000000000000000000000000cf, 0x00000000000000000000000000000000000000ce, 0x00000000000000000000000000000000000000cd, 0x0000000000000000000000000000000000000099, 0x0000000000000000000000000000000000000098, 0x00000000000000000000000000000000000000ac, 0x00000000000000000000000000000000000000aa, 0x00000000000000000000000000000000000000e9, 0x00000000000000000000000000000000000000e8, 0x00000000000000000000000000000000000000e5, 0x00000000000000000000000000000000000000e4, 0x00000000000000000000000000000000000000e7, 0x00000000000000000000000000000000000000e6, 0x00000000000000000000000000000000000000e1, 0x00000000000000000000000000000000000000e0, 0x00000000000000000000000000000000000000e3, 0x00000000000000000000000000000000000000e2, 0x00000000000000000000000000000000000000df, 0x00000000000000000000000000000000000000fb, 0x00000000000000000000000000000000000000fc, 0x00000000000000000000000000000000000000fd, 0x00000000000000000000000000000000000000fe, 0x00000000000000000000000000000000000000ff, 0x00000000000000000000000000000000000000ae, 0x00000000000000000000000000000000000000dd, 0x00000000000000000000000000000000000000ad, 0x00000000000000000000000000000000000000de, 0x000000000000000000000000000000000000009e, 0x000000000000000000000000000000000000004f, 0x00000000000000000000000000000000000000db, 0x000000000000000000000000000000000000004d, 0x000000000000000000000000000000000000004e, 0x000000000000000000000000000000000000004b, 0x000000000000000000000000000000000000004c, 0x000000000000000000000000000000000000004a, 0x0000000000000000000000000000000000000039, 0x0000000000000000000000000000000000000038, 0x000000000000000000000000000000000000000e, 0x0000000000000000000000000000000000000033, 0x0000000000000000000000000000000000000032, 0x0000000000000000000000000000000000000031, 0x0000000000000000000000000000000000000030, 0x0000000000000000000000000000000000000037, 0x0000000000000000000000000000000000000036, 0x0000000000000000000000000000000000000035, 0x0000000000000000000000000000000000000034, 0x00000000000000000000000000000000000000f0, 0x00000000000000000000000000000000000000f1, 0x00000000000000000000000000000000000000f2, 0x00000000000000000000000000000000000000f3, 0x00000000000000000000000000000000000000f4, 0x00000000000000000000000000000000000000f5, 0x00000000000000000000000000000000000000f6, 0x00000000000000000000000000000000000000f7, 0x00000000000000000000000000000000000000f8, 0x00000000000000000000000000000000000000f9, 0x00000000000000000000000000000000000000ee, 0x00000000000000000000000000000000000000c9, 0x00000000000000000000000000000000000000ef, 0x00000000000000000000000000000000000000ea, 0x00000000000000000000000000000000000000ec, 0x00000000000000000000000000000000000000eb, 0x000000000000000000000000000000000000003c, 0x000000000000000000000000000000000000003b, 0x000000000000000000000000000000000000003a, 0x000000000000000000000000000000000000003f, 0x000000000000000000000000000000000000003e, 0x000000000000000000000000000000000000003d, 0x0000000000000000000000000000000000000089, 0x0000000000000000000000000000000000000048, 0x0000000000000000000000000000000000000049, 0x0000000000000000000000000000000000000046, 0x0000000000000000000000000000000000000047, 0x0000000000000000000000000000000000000044, 0x0000000000000000000000000000000000000045, 0x0000000000000000000000000000000000000042, 0x0000000000000000000000000000000000000043, 0x0000000000000000000000000000000000000040, 0x0000000000000000000000000000000000000041, 0x874b54a8bd152966d63f706bae1ffeb0411921e5, 0x00000000000000000000000000000000000000af, 0x0000000000000000000000000000000000000088, 0x000000000000000000000000000000000000000d, 0x00000000000000000000000000000000000000ed, 0x000000000000000000000000000000000000006a, 0x000000000000000000000000000000000000006b, 0x000000000000000000000000000000000000006c, 0x000000000000000000000000000000000000006d, 0x000000000000000000000000000000000000006e, 0x000000000000000000000000000000000000006f, 0x0000000000000000000000000000000000000086, 0x0000000000000000000000000000000000000087, 0x0000000000000000000000000000000000000059, 0x0000000000000000000000000000000000000058, 0x0000000000000000000000000000000000000055, 0x0000000000000000000000000000000000000054, 0x0000000000000000000000000000000000000057, 0x0000000000000000000000000000000000000056, 0x0000000000000000000000000000000000000051, 0x0000000000000000000000000000000000000050, 0x0000000000000000000000000000000000000053, 0x0000000000000000000000000000000000000052, 0x000000000000000000000000000000000000009d, 0x00000000000000000000000000000000000000dc, 0x000000000000000000000000000000000000000b, 0x00000000000000000000000000000000000000fa, 0x000000000000000000000000000000000000005e, 0x000000000000000000000000000000000000005d, 0x000000000000000000000000000000000000005f, 0x000000000000000000000000000000000000005a, 0x000000000000000000000000000000000000005c, 0x000000000000000000000000000000000000005b, 0x0000000000000000000000000000000000000060, 0x0000000000000000000000000000000000000061, 0x0000000000000000000000000000000000000062, 0x0000000000000000000000000000000000000063, 0x0000000000000000000000000000000000000064, 0x0000000000000000000000000000000000000065, 0x0000000000000000000000000000000000000066, 0x0000000000000000000000000000000000000067, 0x0000000000000000000000000000000000000068, 0x0000000000000000000000000000000000000069, 0x00000000000000000000000000000000000000bd, 0x00000000000000000000000000000000000000be, 0x00000000000000000000000000000000000000bf, 0x00000000000000000000000000000000000000ba, 0x00000000000000000000000000000000000000bb, 0x00000000000000000000000000000000000000bc, 0x000000000000000000000000000000000000008b, 0x000000000000000000000000000000000000008c, 0x000000000000000000000000000000000000008a, 0x000000000000000000000000000000000000008f, 0x000000000000000000000000000000000000008d, 0x000000000000000000000000000000000000008e, 0x00000000000000000000000000000000000000a1, 0x00000000000000000000000000000000000000a0, 0x00000000000000000000000000000000000000a3, 0x00000000000000000000000000000000000000a2, 0x00000000000000000000000000000000000000a5, 0x00000000000000000000000000000000000000a4, 0x00000000000000000000000000000000000000a7, 0x00000000000000000000000000000000000000a6, 0x00000000000000000000000000000000000000a9, 0x00000000000000000000000000000000000000a8, 0x00000000000000000000000000000000000000ab, 0x00000000000000000000000000000000000000d8, 0x00000000000000000000000000000000000000d9, 0x0000000000000000000000000000000000000077, 0x00000000000000000000000000000000000000d6, 0x0000000000000000000000000000000000000075, 0x0000000000000000000000000000000000000074, 0x0000000000000000000000000000000000000073, 0x0000000000000000000000000000000000000072, 0x0000000000000000000000000000000000000071, 0x0000000000000000000000000000000000000070, 0x00000000000000000000000000000000000000d4, 0x0000000000000000000000000000000000000079, 0x0000000000000000000000000000000000000078, 0x0000000000000000000000000000000000000002, 0x0000000000000000000000000000000000000003, 0x0000000000000000000000000000000000000000, 0x0000000000000000000000000000000000000001, 0x0000000000000000000000000000000000000006, 0x0000000000000000000000000000000000000007, 0x0000000000000000000000000000000000000004, 0x0000000000000000000000000000000000000005, 0x00000000000000000000000000000000000000d2, 0x0000000000000000000000000000000000000008, 0x0000000000000000000000000000000000000009, 0x00000000000000000000000000000000000000d3, 0x00000000000000000000000000000000000000b4, 0x00000000000000000000000000000000000000b5, 0x00000000000000000000000000000000000000b6, 0x00000000000000000000000000000000000000b7, 0x00000000000000000000000000000000000000b0, 0x00000000000000000000000000000000000000b1, 0x00000000000000000000000000000000000000b2, 0x00000000000000000000000000000000000000b3, 0x0000000000000000000000000000000000000082, 0x0000000000000000000000000000000000000083, 0x0000000000000000000000000000000000000080, 0x00000000000000000000000000000000000000d1, 0x00000000000000000000000000000000000000b8, 0x00000000000000000000000000000000000000b9, 0x0000000000000000000000000000000000000084, 0x0000000000000000000000000000000000000085, 0x000000000000000000000000000000000000007f, 0x000000000000000000000000000000000000007e, 0x000000000000000000000000000000000000007d, 0x000000000000000000000000000000000000007c, 0x000000000000000000000000000000000000007b, 0x000000000000000000000000000000000000007a, 0x000000000000000000000000000000000000000f, 0x00000000000000000000000000000000000000d5, 0x00000000000000000000000000000000000000da, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"0x0000000000000000000000000000000000000011":"0","0x0000000000000000000000000000000000000010":"0","0x0000000000000000000000000000000000000013":"0","0x0000000000000000000000000000000000000012":"0","0x0000000000000000000000000000000000000015":"0","0x0000000000000000000000000000000000000014":"0","0x0000000000000000000000000000000000000017":"0","0x0000000000000000000000000000000000000016":"0","0x0000000000000000000000000000000000000019":"0","0x0000000000000000000000000000000000000018":"0","0x00000000000000000000000000000000000000c1":"0","0x00000000000000000000000000000000000000c0":"0","0x00000000000000000000000000000000000000c7":"0","0x00000000000000000000000000000000000000c6":"0","0x00000000000000000000000000000000000000c5":"0","0x00000000000000000000000000000000000000c4":"0","0x000000000000000000000000000000000000002d":"0","0x000000000000000000000000000000000000002e":"0","0x000000000000000000000000000000000000002f":"0","0x00000000000000000000000000000000000000c8":"0","0x000000000000000000000000000000000000002a":"0","0x000000000000000000000000000000000000002b":"0","0x000000000000000000000000000000000000002c":"0","0x0000000000000000000000000000000000000091":"0","0x0000000000000000000000000000000000000090":"0","0x0000000000000000000000000000000000000093":"0","0x0000000000000000000000000000000000000092":"0","0x0000000000000000000000000000000000000095":"0","0x0000000000000000000000000000000000000094":"0","0x0000000000000000000000000000000000000097":"0","0x0000000000000000000000000000000000000096":"0","0x0000000000000000000000000000000000000076":"0","0x000000000000000000000000000000000000000c":"0","0x00000000000000000000000000000000000000c3":"0","0x00000000000000000000000000000000000000c2":"0","0x0000000000000000000000000000000000000081":"0","0x000000000000000000000000000000000000000a":"0","0x0000000000000000000000000000000000000024":"0","0x0000000000000000000000000000000000000025":"0","0x0000000000000000000000000000000000000026":"0","0x0000000000000000000000000000000000000027":"0","0x0000000000000000000000000000000000000020":"0","0x0000000000000000000000000000000000000021":"0","0x0000000000000000000000000000000000000022":"0","0x0000000000000000000000000000000000000023":"0","0x000000000000000000000000000000000000009a":"0","0x00000000000000000000000000000000000000d7":"0","0x000000000000000000000000000000000000009c":"0","0x000000000000000000000000000000000000009b":"0","0x0000000000000000000000000000000000000028":"0","0x0000000000000000000000000000000000000029":"0","0x00000000000000000000000000000000000000d0":"0","0x000000000000000000000000000000000000009f":"0","0x000000000000000000000000000000000000001a":"0","0x000000000000000000000000000000000000001c":"0","0x000000000000000000000000000000000000001b":"0","0x000000000000000000000000000000000000001e":"0","0x000000000000000000000000000000000000001d":"0","0x000000000000000000000000000000000000001f":"0","0x00000000000000000000000000000000000000cc":"0","0x00000000000000000000000000000000000000cb":"0","0x00000000000000000000000000000000000000ca":"0","0x00000000000000000000000000000000000000cf":"0","0x00000000000000000000000000000000000000ce":"0","0x00000000000000000000000000000000000000cd":"0","0x0000000000000000000000000000000000000099":"0","0x0000000000000000000000000000000000000098":"0","0x00000000000000000000000000000000000000ac":"0","0x00000000000000000000000000000000000000aa":"0","0x00000000000000000000000000000000000000e9":"0","0x00000000000000000000000000000000000000e8":"0","0x00000000000000000000000000000000000000e5":"0","0x00000000000000000000000000000000000000e4":"0","0x00000000000000000000000000000000000000e7":"0","0x00000000000000000000000000000000000000e6":"0","0x00000000000000000000000000000000000000e1":"0","0x00000000000000000000000000000000000000e0":"0","0x00000000000000000000000000000000000000e3":"0","0x00000000000000000000000000000000000000e2":"0","0x00000000000000000000000000000000000000df":"0","0x00000000000000000000000000000000000000fb":"0","0x00000000000000000000000000000000000000fc":"0","0x00000000000000000000000000000000000000fd":"0","0x00000000000000000000000000000000000000fe":"0","0x00000000000000000000000000000000000000ff":"0","0x00000000000000000000000000000000000000ae":"0","0x00000000000000000000000000000000000000dd":"0","0x00000000000000000000000000000000000000ad":"0","0x00000000000000000000000000000000000000de":"0","0x000000000000000000000000000000000000009e":"0","0x000000000000000000000000000000000000004f":"0","0x00000000000000000000000000000000000000db":"0","0x000000000000000000000000000000000000004d":"0","0x000000000000000000000000000000000000004e":"0","0x000000000000000000000000000000000000004b":"0","0x000000000000000000000000000000000000004c":"0","0x000000000000000000000000000000000000004a":"0","0x0000000000000000000000000000000000000039":"0","0x0000000000000000000000000000000000000038":"0","0x000000000000000000000000000000000000000e":"0","0x0000000000000000000000000000000000000033":"0","0x0000000000000000000000000000000000000032":"0","0x0000000000000000000000000000000000000031":"0","0x0000000000000000000000000000000000000030":"0","0x0000000000000000000000000000000000000037":"0","0x0000000000000000000000000000000000000036":"0","0x0000000000000000000000000000000000000035":"0","0x0000000000000000000000000000000000000034":"0","0x00000000000000000000000000000000000000f0":"0","0x00000000000000000000000000000000000000f1":"0","0x00000000000000000000000000000000000000f2":"0","0x00000000000000000000000000000000000000f3":"0","0x00000000000000000000000000000000000000f4":"0","0x00000000000000000000000000000000000000f5":"0","0x00000000000000000000000000000000000000f6":"0","0x00000000000000000000000000000000000000f7":"0","0x00000000000000000000000000000000000000f8":"0","0x00000000000000000000000000000000000000f9":"0","0x00000000000000000000000000000000000000ee":"0","0x00000000000000000000000000000000000000c9":"0","0x00000000000000000000000000000000000000ef":"0","0x00000000000000000000000000000000000000ea":"0","0x00000000000000000000000000000000000000ec":"0","0x00000000000000000000000000000000000000eb":"0","0x000000000000000000000000000000000000003c":"0","0x000000000000000000000000000000000000003b":"0","0x000000000000000000000000000000000000003a":"0","0x000000000000000000000000000000000000003f":"0","0x000000000000000000000000000000000000003e":"0","0x000000000000000000000000000000000000003d":"0","0x0000000000000000000000000000000000000089":"0","0x0000000000000000000000000000000000000048":"0","0x0000000000000000000000000000000000000049":"0","0x0000000000000000000000000000000000000046":"0","0x0000000000000000000000000000000000000047":"0","0x0000000000000000000000000000000000000044":"0","0x0000000000000000000000000000000000000045":"0","0x0000000000000000000000000000000000000042":"0","0x0000000000000000000000000000000000000043":"0","0x0000000000000000000000000000000000000040":"0","0x0000000000000000000000000000000000000041":"0","0x874b54a8bd152966d63f706bae1ffeb0411921e5":"1000000000000000000000000000000","0x00000000000000000000000000000000000000af":"0","0x0000000000000000000000000000000000000088":"0","0x000000000000000000000000000000000000000d":"0","0x00000000000000000000000000000000000000ed":"0","0x000000000000000000000000000000000000006a":"0","0x000000000000000000000000000000000000006b":"0","0x000000000000000000000000000000000000006c":"0","0x000000000000000000000000000000000000006d":"0","0x000000000000000000000000000000000000006e":"0","0x000000000000000000000000000000000000006f":"0","0x0000000000000000000000000000000000000086":"0","0x0000000000000000000000000000000000000087":"0","0x0000000000000000000000000000000000000059":"0","0x0000000000000000000000000000000000000058":"0","0x0000000000000000000000000000000000000055":"0","0x0000000000000000000000000000000000000054":"0","0x0000000000000000000000000000000000000057":"0","0x0000000000000000000000000000000000000056":"0","0x0000000000000000000000000000000000000051":"0","0x0000000000000000000000000000000000000050":"0","0x0000000000000000000000000000000000000053":"0","0x0000000000000000000000000000000000000052":"0","0x000000000000000000000000000000000000009d":"0","0x00000000000000000000000000000000000000dc":"0","0x000000000000000000000000000000000000000b":"0","0x00000000000000000000000000000000000000fa":"0","0x000000000000000000000000000000000000005e":"0","0x000000000000000000000000000000000000005d":"0","0x000000000000000000000000000000000000005f":"0","0x000000000000000000000000000000000000005a":"0","0x000000000000000000000000000000000000005c":"0","0x000000000000000000000000000000000000005b":"0","0x0000000000000000000000000000000000000060":"0","0x0000000000000000000000000000000000000061":"0","0x0000000000000000000000000000000000000062":"0","0x0000000000000000000000000000000000000063":"0","0x0000000000000000000000000000000000000064":"0","0x0000000000000000000000000000000000000065":"0","0x0000000000000000000000000000000000000066":"0","0x0000000000000000000000000000000000000067":"0","0x0000000000000000000000000000000000000068":"0","0x0000000000000000000000000000000000000069":"0","0x00000000000000000000000000000000000000bd":"0","0x00000000000000000000000000000000000000be":"0","0x00000000000000000000000000000000000000bf":"0","0x00000000000000000000000000000000000000ba":"0","0x00000000000000000000000000000000000000bb":"0","0x00000000000000000000000000000000000000bc":"0","0x000000000000000000000000000000000000008b":"0","0x000000000000000000000000000000000000008c":"0","0x000000000000000000000000000000000000008a":"0","0x000000000000000000000000000000000000008f":"0","0x000000000000000000000000000000000000008d":"0","0x000000000000000000000000000000000000008e":"0","0x00000000000000000000000000000000000000a1":"0","0x00000000000000000000000000000000000000a0":"0","0x00000000000000000000000000000000000000a3":"0","0x00000000000000000000000000000000000000a2":"0","0x00000000000000000000000000000000000000a5":"0","0x00000000000000000000000000000000000000a4":"0","0x00000000000000000000000000000000000000a7":"0","0x00000000000000000000000000000000000000a6":"0","0x00000000000000000000000000000000000000a9":"0","0x00000000000000000000000000000000000000a8":"0","0x00000000000000000000000000000000000000ab":"0","0x00000000000000000000000000000000000000d8":"0","0x00000000000000000000000000000000000000d9":"0","0x0000000000000000000000000000000000000077":"0","0x00000000000000000000000000000000000000d6":"0","0x0000000000000000000000000000000000000075":"0","0x0000000000000000000000000000000000000074":"0","0x0000000000000000000000000000000000000073":"0","0x0000000000000000000000000000000000000072":"0","0x0000000000000000000000000000000000000071":"0","0x0000000000000000000000000000000000000070":"0","0x00000000000000000000000000000000000000d4":"0","0x0000000000000000000000000000000000000079":"0","0x0000000000000000000000000000000000000078":"0","0x0000000000000000000000000000000000000002":"1","0x0000000000000000000000000000000000000003":"1","0x0000000000000000000000000000000000000000":"1","0x0000000000000000000000000000000000000001":"1","0x0000000000000000000000000000000000000006":"1","0x0000000000000000000000000000000000000007":"1","0x0000000000000000000000000000000000000004":"1","0x0000000000000000000000000000000000000005":"1","0x00000000000000000000000000000000000000d2":"0","0x0000000000000000000000000000000000000008":"1","0x0000000000000000000000000000000000000009":"1","0x00000000000000000000000000000000000000d3":"0","0x00000000000000000000000000000000000000b4":"0","0x00000000000000000000000000000000000000b5":"0","0x00000000000000000000000000000000000000b6":"0","0x00000000000000000000000000000000000000b7":"0","0x00000000000000000000000000000000000000b0":"0","0x00000000000000000000000000000000000000b1":"0","0x00000000000000000000000000000000000000b2":"0","0x00000000000000000000000000000000000000b3":"0","0x0000000000000000000000000000000000000082":"0","0x0000000000000000000000000000000000000083":"0","0x0000000000000000000000000000000000000080":"0","0x00000000000000000000000000000000000000d1":"0","0x00000000000000000000000000000000000000b8":"0","0x00000000000000000000000000000000000000b9":"0","0x0000000000000000000000000000000000000084":"0","0x0000000000000000000000000000000000000085":"0","0x000000000000000000000000000000000000007f":"0","0x000000000000000000000000000000000000007e":"0","0x000000000000000000000000000000000000007d":"0","0x000000000000000000000000000000000000007c":"0","0x000000000000000000000000000000000000007b":"0","0x000000000000000000000000000000000000007a":"0","0x000000000000000000000000000000000000000f":"0","0x00000000000000000000000000000000000000d5":"0","0x00000000000000000000000000000000000000da":"0"}');
},
/*!*******************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-common/dist/genesisStates/rinkeby.json ***!
  \*******************************************************************************************************/

/*! exports provided: 0x0000000000000000000000000000000000000000, 0x0000000000000000000000000000000000000001, 0x0000000000000000000000000000000000000002, 0x0000000000000000000000000000000000000003, 0x0000000000000000000000000000000000000004, 0x0000000000000000000000000000000000000005, 0x0000000000000000000000000000000000000006, 0x0000000000000000000000000000000000000007, 0x0000000000000000000000000000000000000008, 0x0000000000000000000000000000000000000009, 0x000000000000000000000000000000000000000a, 0x000000000000000000000000000000000000000b, 0x000000000000000000000000000000000000000c, 0x000000000000000000000000000000000000000d, 0x000000000000000000000000000000000000000e, 0x000000000000000000000000000000000000000f, 0x0000000000000000000000000000000000000010, 0x0000000000000000000000000000000000000011, 0x0000000000000000000000000000000000000012, 0x0000000000000000000000000000000000000013, 0x0000000000000000000000000000000000000014, 0x0000000000000000000000000000000000000015, 0x0000000000000000000000000000000000000016, 0x0000000000000000000000000000000000000017, 0x0000000000000000000000000000000000000018, 0x0000000000000000000000000000000000000019, 0x000000000000000000000000000000000000001a, 0x000000000000000000000000000000000000001b, 0x000000000000000000000000000000000000001c, 0x000000000000000000000000000000000000001d, 0x000000000000000000000000000000000000001e, 0x000000000000000000000000000000000000001f, 0x0000000000000000000000000000000000000020, 0x0000000000000000000000000000000000000021, 0x0000000000000000000000000000000000000022, 0x0000000000000000000000000000000000000023, 0x0000000000000000000000000000000000000024, 0x0000000000000000000000000000000000000025, 0x0000000000000000000000000000000000000026, 0x0000000000000000000000000000000000000027, 0x0000000000000000000000000000000000000028, 0x0000000000000000000000000000000000000029, 0x000000000000000000000000000000000000002a, 0x000000000000000000000000000000000000002b, 0x000000000000000000000000000000000000002c, 0x000000000000000000000000000000000000002d, 0x000000000000000000000000000000000000002e, 0x000000000000000000000000000000000000002f, 0x0000000000000000000000000000000000000030, 0x0000000000000000000000000000000000000031, 0x0000000000000000000000000000000000000032, 0x0000000000000000000000000000000000000033, 0x0000000000000000000000000000000000000034, 0x0000000000000000000000000000000000000035, 0x0000000000000000000000000000000000000036, 0x0000000000000000000000000000000000000037, 0x0000000000000000000000000000000000000038, 0x0000000000000000000000000000000000000039, 0x000000000000000000000000000000000000003a, 0x000000000000000000000000000000000000003b, 0x000000000000000000000000000000000000003c, 0x000000000000000000000000000000000000003d, 0x000000000000000000000000000000000000003e, 0x000000000000000000000000000000000000003f, 0x0000000000000000000000000000000000000040, 0x0000000000000000000000000000000000000041, 0x0000000000000000000000000000000000000042, 0x0000000000000000000000000000000000000043, 0x0000000000000000000000000000000000000044, 0x0000000000000000000000000000000000000045, 0x0000000000000000000000000000000000000046, 0x0000000000000000000000000000000000000047, 0x0000000000000000000000000000000000000048, 0x0000000000000000000000000000000000000049, 0x000000000000000000000000000000000000004a, 0x000000000000000000000000000000000000004b, 0x000000000000000000000000000000000000004c, 0x000000000000000000000000000000000000004d, 0x000000000000000000000000000000000000004e, 0x000000000000000000000000000000000000004f, 0x0000000000000000000000000000000000000050, 0x0000000000000000000000000000000000000051, 0x0000000000000000000000000000000000000052, 0x0000000000000000000000000000000000000053, 0x0000000000000000000000000000000000000054, 0x0000000000000000000000000000000000000055, 0x0000000000000000000000000000000000000056, 0x0000000000000000000000000000000000000057, 0x0000000000000000000000000000000000000058, 0x0000000000000000000000000000000000000059, 0x000000000000000000000000000000000000005a, 0x000000000000000000000000000000000000005b, 0x000000000000000000000000000000000000005c, 0x000000000000000000000000000000000000005d, 0x000000000000000000000000000000000000005e, 0x000000000000000000000000000000000000005f, 0x0000000000000000000000000000000000000060, 0x0000000000000000000000000000000000000061, 0x0000000000000000000000000000000000000062, 0x0000000000000000000000000000000000000063, 0x0000000000000000000000000000000000000064, 0x0000000000000000000000000000000000000065, 0x0000000000000000000000000000000000000066, 0x0000000000000000000000000000000000000067, 0x0000000000000000000000000000000000000068, 0x0000000000000000000000000000000000000069, 0x000000000000000000000000000000000000006a, 0x000000000000000000000000000000000000006b, 0x000000000000000000000000000000000000006c, 0x000000000000000000000000000000000000006d, 0x000000000000000000000000000000000000006e, 0x000000000000000000000000000000000000006f, 0x0000000000000000000000000000000000000070, 0x0000000000000000000000000000000000000071, 0x0000000000000000000000000000000000000072, 0x0000000000000000000000000000000000000073, 0x0000000000000000000000000000000000000074, 0x0000000000000000000000000000000000000075, 0x0000000000000000000000000000000000000076, 0x0000000000000000000000000000000000000077, 0x0000000000000000000000000000000000000078, 0x0000000000000000000000000000000000000079, 0x000000000000000000000000000000000000007a, 0x000000000000000000000000000000000000007b, 0x000000000000000000000000000000000000007c, 0x000000000000000000000000000000000000007d, 0x000000000000000000000000000000000000007e, 0x000000000000000000000000000000000000007f, 0x0000000000000000000000000000000000000080, 0x0000000000000000000000000000000000000081, 0x0000000000000000000000000000000000000082, 0x0000000000000000000000000000000000000083, 0x0000000000000000000000000000000000000084, 0x0000000000000000000000000000000000000085, 0x0000000000000000000000000000000000000086, 0x0000000000000000000000000000000000000087, 0x0000000000000000000000000000000000000088, 0x0000000000000000000000000000000000000089, 0x000000000000000000000000000000000000008a, 0x000000000000000000000000000000000000008b, 0x000000000000000000000000000000000000008c, 0x000000000000000000000000000000000000008d, 0x000000000000000000000000000000000000008e, 0x000000000000000000000000000000000000008f, 0x0000000000000000000000000000000000000090, 0x0000000000000000000000000000000000000091, 0x0000000000000000000000000000000000000092, 0x0000000000000000000000000000000000000093, 0x0000000000000000000000000000000000000094, 0x0000000000000000000000000000000000000095, 0x0000000000000000000000000000000000000096, 0x0000000000000000000000000000000000000097, 0x0000000000000000000000000000000000000098, 0x0000000000000000000000000000000000000099, 0x000000000000000000000000000000000000009a, 0x000000000000000000000000000000000000009b, 0x000000000000000000000000000000000000009c, 0x000000000000000000000000000000000000009d, 0x000000000000000000000000000000000000009e, 0x000000000000000000000000000000000000009f, 0x00000000000000000000000000000000000000a0, 0x00000000000000000000000000000000000000a1, 0x00000000000000000000000000000000000000a2, 0x00000000000000000000000000000000000000a3, 0x00000000000000000000000000000000000000a4, 0x00000000000000000000000000000000000000a5, 0x00000000000000000000000000000000000000a6, 0x00000000000000000000000000000000000000a7, 0x00000000000000000000000000000000000000a8, 0x00000000000000000000000000000000000000a9, 0x00000000000000000000000000000000000000aa, 0x00000000000000000000000000000000000000ab, 0x00000000000000000000000000000000000000ac, 0x00000000000000000000000000000000000000ad, 0x00000000000000000000000000000000000000ae, 0x00000000000000000000000000000000000000af, 0x00000000000000000000000000000000000000b0, 0x00000000000000000000000000000000000000b1, 0x00000000000000000000000000000000000000b2, 0x00000000000000000000000000000000000000b3, 0x00000000000000000000000000000000000000b4, 0x00000000000000000000000000000000000000b5, 0x00000000000000000000000000000000000000b6, 0x00000000000000000000000000000000000000b7, 0x00000000000000000000000000000000000000b8, 0x00000000000000000000000000000000000000b9, 0x00000000000000000000000000000000000000ba, 0x00000000000000000000000000000000000000bb, 0x00000000000000000000000000000000000000bc, 0x00000000000000000000000000000000000000bd, 0x00000000000000000000000000000000000000be, 0x00000000000000000000000000000000000000bf, 0x00000000000000000000000000000000000000c0, 0x00000000000000000000000000000000000000c1, 0x00000000000000000000000000000000000000c2, 0x00000000000000000000000000000000000000c3, 0x00000000000000000000000000000000000000c4, 0x00000000000000000000000000000000000000c5, 0x00000000000000000000000000000000000000c6, 0x00000000000000000000000000000000000000c7, 0x00000000000000000000000000000000000000c8, 0x00000000000000000000000000000000000000c9, 0x00000000000000000000000000000000000000ca, 0x00000000000000000000000000000000000000cb, 0x00000000000000000000000000000000000000cc, 0x00000000000000000000000000000000000000cd, 0x00000000000000000000000000000000000000ce, 0x00000000000000000000000000000000000000cf, 0x00000000000000000000000000000000000000d0, 0x00000000000000000000000000000000000000d1, 0x00000000000000000000000000000000000000d2, 0x00000000000000000000000000000000000000d3, 0x00000000000000000000000000000000000000d4, 0x00000000000000000000000000000000000000d5, 0x00000000000000000000000000000000000000d6, 0x00000000000000000000000000000000000000d7, 0x00000000000000000000000000000000000000d8, 0x00000000000000000000000000000000000000d9, 0x00000000000000000000000000000000000000da, 0x00000000000000000000000000000000000000db, 0x00000000000000000000000000000000000000dc, 0x00000000000000000000000000000000000000dd, 0x00000000000000000000000000000000000000de, 0x00000000000000000000000000000000000000df, 0x00000000000000000000000000000000000000e0, 0x00000000000000000000000000000000000000e1, 0x00000000000000000000000000000000000000e2, 0x00000000000000000000000000000000000000e3, 0x00000000000000000000000000000000000000e4, 0x00000000000000000000000000000000000000e5, 0x00000000000000000000000000000000000000e6, 0x00000000000000000000000000000000000000e7, 0x00000000000000000000000000000000000000e8, 0x00000000000000000000000000000000000000e9, 0x00000000000000000000000000000000000000ea, 0x00000000000000000000000000000000000000eb, 0x00000000000000000000000000000000000000ec, 0x00000000000000000000000000000000000000ed, 0x00000000000000000000000000000000000000ee, 0x00000000000000000000000000000000000000ef, 0x00000000000000000000000000000000000000f0, 0x00000000000000000000000000000000000000f1, 0x00000000000000000000000000000000000000f2, 0x00000000000000000000000000000000000000f3, 0x00000000000000000000000000000000000000f4, 0x00000000000000000000000000000000000000f5, 0x00000000000000000000000000000000000000f6, 0x00000000000000000000000000000000000000f7, 0x00000000000000000000000000000000000000f8, 0x00000000000000000000000000000000000000f9, 0x00000000000000000000000000000000000000fa, 0x00000000000000000000000000000000000000fb, 0x00000000000000000000000000000000000000fc, 0x00000000000000000000000000000000000000fd, 0x00000000000000000000000000000000000000fe, 0x00000000000000000000000000000000000000ff, 0x31b98d14007bdee637298086988a0bbd31184523, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"0x0000000000000000000000000000000000000000":"0x1","0x0000000000000000000000000000000000000001":"0x1","0x0000000000000000000000000000000000000002":"0x1","0x0000000000000000000000000000000000000003":"0x1","0x0000000000000000000000000000000000000004":"0x1","0x0000000000000000000000000000000000000005":"0x1","0x0000000000000000000000000000000000000006":"0x1","0x0000000000000000000000000000000000000007":"0x1","0x0000000000000000000000000000000000000008":"0x1","0x0000000000000000000000000000000000000009":"0x1","0x000000000000000000000000000000000000000a":"0x1","0x000000000000000000000000000000000000000b":"0x1","0x000000000000000000000000000000000000000c":"0x1","0x000000000000000000000000000000000000000d":"0x1","0x000000000000000000000000000000000000000e":"0x1","0x000000000000000000000000000000000000000f":"0x1","0x0000000000000000000000000000000000000010":"0x1","0x0000000000000000000000000000000000000011":"0x1","0x0000000000000000000000000000000000000012":"0x1","0x0000000000000000000000000000000000000013":"0x1","0x0000000000000000000000000000000000000014":"0x1","0x0000000000000000000000000000000000000015":"0x1","0x0000000000000000000000000000000000000016":"0x1","0x0000000000000000000000000000000000000017":"0x1","0x0000000000000000000000000000000000000018":"0x1","0x0000000000000000000000000000000000000019":"0x1","0x000000000000000000000000000000000000001a":"0x1","0x000000000000000000000000000000000000001b":"0x1","0x000000000000000000000000000000000000001c":"0x1","0x000000000000000000000000000000000000001d":"0x1","0x000000000000000000000000000000000000001e":"0x1","0x000000000000000000000000000000000000001f":"0x1","0x0000000000000000000000000000000000000020":"0x1","0x0000000000000000000000000000000000000021":"0x1","0x0000000000000000000000000000000000000022":"0x1","0x0000000000000000000000000000000000000023":"0x1","0x0000000000000000000000000000000000000024":"0x1","0x0000000000000000000000000000000000000025":"0x1","0x0000000000000000000000000000000000000026":"0x1","0x0000000000000000000000000000000000000027":"0x1","0x0000000000000000000000000000000000000028":"0x1","0x0000000000000000000000000000000000000029":"0x1","0x000000000000000000000000000000000000002a":"0x1","0x000000000000000000000000000000000000002b":"0x1","0x000000000000000000000000000000000000002c":"0x1","0x000000000000000000000000000000000000002d":"0x1","0x000000000000000000000000000000000000002e":"0x1","0x000000000000000000000000000000000000002f":"0x1","0x0000000000000000000000000000000000000030":"0x1","0x0000000000000000000000000000000000000031":"0x1","0x0000000000000000000000000000000000000032":"0x1","0x0000000000000000000000000000000000000033":"0x1","0x0000000000000000000000000000000000000034":"0x1","0x0000000000000000000000000000000000000035":"0x1","0x0000000000000000000000000000000000000036":"0x1","0x0000000000000000000000000000000000000037":"0x1","0x0000000000000000000000000000000000000038":"0x1","0x0000000000000000000000000000000000000039":"0x1","0x000000000000000000000000000000000000003a":"0x1","0x000000000000000000000000000000000000003b":"0x1","0x000000000000000000000000000000000000003c":"0x1","0x000000000000000000000000000000000000003d":"0x1","0x000000000000000000000000000000000000003e":"0x1","0x000000000000000000000000000000000000003f":"0x1","0x0000000000000000000000000000000000000040":"0x1","0x0000000000000000000000000000000000000041":"0x1","0x0000000000000000000000000000000000000042":"0x1","0x0000000000000000000000000000000000000043":"0x1","0x0000000000000000000000000000000000000044":"0x1","0x0000000000000000000000000000000000000045":"0x1","0x0000000000000000000000000000000000000046":"0x1","0x0000000000000000000000000000000000000047":"0x1","0x0000000000000000000000000000000000000048":"0x1","0x0000000000000000000000000000000000000049":"0x1","0x000000000000000000000000000000000000004a":"0x1","0x000000000000000000000000000000000000004b":"0x1","0x000000000000000000000000000000000000004c":"0x1","0x000000000000000000000000000000000000004d":"0x1","0x000000000000000000000000000000000000004e":"0x1","0x000000000000000000000000000000000000004f":"0x1","0x0000000000000000000000000000000000000050":"0x1","0x0000000000000000000000000000000000000051":"0x1","0x0000000000000000000000000000000000000052":"0x1","0x0000000000000000000000000000000000000053":"0x1","0x0000000000000000000000000000000000000054":"0x1","0x0000000000000000000000000000000000000055":"0x1","0x0000000000000000000000000000000000000056":"0x1","0x0000000000000000000000000000000000000057":"0x1","0x0000000000000000000000000000000000000058":"0x1","0x0000000000000000000000000000000000000059":"0x1","0x000000000000000000000000000000000000005a":"0x1","0x000000000000000000000000000000000000005b":"0x1","0x000000000000000000000000000000000000005c":"0x1","0x000000000000000000000000000000000000005d":"0x1","0x000000000000000000000000000000000000005e":"0x1","0x000000000000000000000000000000000000005f":"0x1","0x0000000000000000000000000000000000000060":"0x1","0x0000000000000000000000000000000000000061":"0x1","0x0000000000000000000000000000000000000062":"0x1","0x0000000000000000000000000000000000000063":"0x1","0x0000000000000000000000000000000000000064":"0x1","0x0000000000000000000000000000000000000065":"0x1","0x0000000000000000000000000000000000000066":"0x1","0x0000000000000000000000000000000000000067":"0x1","0x0000000000000000000000000000000000000068":"0x1","0x0000000000000000000000000000000000000069":"0x1","0x000000000000000000000000000000000000006a":"0x1","0x000000000000000000000000000000000000006b":"0x1","0x000000000000000000000000000000000000006c":"0x1","0x000000000000000000000000000000000000006d":"0x1","0x000000000000000000000000000000000000006e":"0x1","0x000000000000000000000000000000000000006f":"0x1","0x0000000000000000000000000000000000000070":"0x1","0x0000000000000000000000000000000000000071":"0x1","0x0000000000000000000000000000000000000072":"0x1","0x0000000000000000000000000000000000000073":"0x1","0x0000000000000000000000000000000000000074":"0x1","0x0000000000000000000000000000000000000075":"0x1","0x0000000000000000000000000000000000000076":"0x1","0x0000000000000000000000000000000000000077":"0x1","0x0000000000000000000000000000000000000078":"0x1","0x0000000000000000000000000000000000000079":"0x1","0x000000000000000000000000000000000000007a":"0x1","0x000000000000000000000000000000000000007b":"0x1","0x000000000000000000000000000000000000007c":"0x1","0x000000000000000000000000000000000000007d":"0x1","0x000000000000000000000000000000000000007e":"0x1","0x000000000000000000000000000000000000007f":"0x1","0x0000000000000000000000000000000000000080":"0x1","0x0000000000000000000000000000000000000081":"0x1","0x0000000000000000000000000000000000000082":"0x1","0x0000000000000000000000000000000000000083":"0x1","0x0000000000000000000000000000000000000084":"0x1","0x0000000000000000000000000000000000000085":"0x1","0x0000000000000000000000000000000000000086":"0x1","0x0000000000000000000000000000000000000087":"0x1","0x0000000000000000000000000000000000000088":"0x1","0x0000000000000000000000000000000000000089":"0x1","0x000000000000000000000000000000000000008a":"0x1","0x000000000000000000000000000000000000008b":"0x1","0x000000000000000000000000000000000000008c":"0x1","0x000000000000000000000000000000000000008d":"0x1","0x000000000000000000000000000000000000008e":"0x1","0x000000000000000000000000000000000000008f":"0x1","0x0000000000000000000000000000000000000090":"0x1","0x0000000000000000000000000000000000000091":"0x1","0x0000000000000000000000000000000000000092":"0x1","0x0000000000000000000000000000000000000093":"0x1","0x0000000000000000000000000000000000000094":"0x1","0x0000000000000000000000000000000000000095":"0x1","0x0000000000000000000000000000000000000096":"0x1","0x0000000000000000000000000000000000000097":"0x1","0x0000000000000000000000000000000000000098":"0x1","0x0000000000000000000000000000000000000099":"0x1","0x000000000000000000000000000000000000009a":"0x1","0x000000000000000000000000000000000000009b":"0x1","0x000000000000000000000000000000000000009c":"0x1","0x000000000000000000000000000000000000009d":"0x1","0x000000000000000000000000000000000000009e":"0x1","0x000000000000000000000000000000000000009f":"0x1","0x00000000000000000000000000000000000000a0":"0x1","0x00000000000000000000000000000000000000a1":"0x1","0x00000000000000000000000000000000000000a2":"0x1","0x00000000000000000000000000000000000000a3":"0x1","0x00000000000000000000000000000000000000a4":"0x1","0x00000000000000000000000000000000000000a5":"0x1","0x00000000000000000000000000000000000000a6":"0x1","0x00000000000000000000000000000000000000a7":"0x1","0x00000000000000000000000000000000000000a8":"0x1","0x00000000000000000000000000000000000000a9":"0x1","0x00000000000000000000000000000000000000aa":"0x1","0x00000000000000000000000000000000000000ab":"0x1","0x00000000000000000000000000000000000000ac":"0x1","0x00000000000000000000000000000000000000ad":"0x1","0x00000000000000000000000000000000000000ae":"0x1","0x00000000000000000000000000000000000000af":"0x1","0x00000000000000000000000000000000000000b0":"0x1","0x00000000000000000000000000000000000000b1":"0x1","0x00000000000000000000000000000000000000b2":"0x1","0x00000000000000000000000000000000000000b3":"0x1","0x00000000000000000000000000000000000000b4":"0x1","0x00000000000000000000000000000000000000b5":"0x1","0x00000000000000000000000000000000000000b6":"0x1","0x00000000000000000000000000000000000000b7":"0x1","0x00000000000000000000000000000000000000b8":"0x1","0x00000000000000000000000000000000000000b9":"0x1","0x00000000000000000000000000000000000000ba":"0x1","0x00000000000000000000000000000000000000bb":"0x1","0x00000000000000000000000000000000000000bc":"0x1","0x00000000000000000000000000000000000000bd":"0x1","0x00000000000000000000000000000000000000be":"0x1","0x00000000000000000000000000000000000000bf":"0x1","0x00000000000000000000000000000000000000c0":"0x1","0x00000000000000000000000000000000000000c1":"0x1","0x00000000000000000000000000000000000000c2":"0x1","0x00000000000000000000000000000000000000c3":"0x1","0x00000000000000000000000000000000000000c4":"0x1","0x00000000000000000000000000000000000000c5":"0x1","0x00000000000000000000000000000000000000c6":"0x1","0x00000000000000000000000000000000000000c7":"0x1","0x00000000000000000000000000000000000000c8":"0x1","0x00000000000000000000000000000000000000c9":"0x1","0x00000000000000000000000000000000000000ca":"0x1","0x00000000000000000000000000000000000000cb":"0x1","0x00000000000000000000000000000000000000cc":"0x1","0x00000000000000000000000000000000000000cd":"0x1","0x00000000000000000000000000000000000000ce":"0x1","0x00000000000000000000000000000000000000cf":"0x1","0x00000000000000000000000000000000000000d0":"0x1","0x00000000000000000000000000000000000000d1":"0x1","0x00000000000000000000000000000000000000d2":"0x1","0x00000000000000000000000000000000000000d3":"0x1","0x00000000000000000000000000000000000000d4":"0x1","0x00000000000000000000000000000000000000d5":"0x1","0x00000000000000000000000000000000000000d6":"0x1","0x00000000000000000000000000000000000000d7":"0x1","0x00000000000000000000000000000000000000d8":"0x1","0x00000000000000000000000000000000000000d9":"0x1","0x00000000000000000000000000000000000000da":"0x1","0x00000000000000000000000000000000000000db":"0x1","0x00000000000000000000000000000000000000dc":"0x1","0x00000000000000000000000000000000000000dd":"0x1","0x00000000000000000000000000000000000000de":"0x1","0x00000000000000000000000000000000000000df":"0x1","0x00000000000000000000000000000000000000e0":"0x1","0x00000000000000000000000000000000000000e1":"0x1","0x00000000000000000000000000000000000000e2":"0x1","0x00000000000000000000000000000000000000e3":"0x1","0x00000000000000000000000000000000000000e4":"0x1","0x00000000000000000000000000000000000000e5":"0x1","0x00000000000000000000000000000000000000e6":"0x1","0x00000000000000000000000000000000000000e7":"0x1","0x00000000000000000000000000000000000000e8":"0x1","0x00000000000000000000000000000000000000e9":"0x1","0x00000000000000000000000000000000000000ea":"0x1","0x00000000000000000000000000000000000000eb":"0x1","0x00000000000000000000000000000000000000ec":"0x1","0x00000000000000000000000000000000000000ed":"0x1","0x00000000000000000000000000000000000000ee":"0x1","0x00000000000000000000000000000000000000ef":"0x1","0x00000000000000000000000000000000000000f0":"0x1","0x00000000000000000000000000000000000000f1":"0x1","0x00000000000000000000000000000000000000f2":"0x1","0x00000000000000000000000000000000000000f3":"0x1","0x00000000000000000000000000000000000000f4":"0x1","0x00000000000000000000000000000000000000f5":"0x1","0x00000000000000000000000000000000000000f6":"0x1","0x00000000000000000000000000000000000000f7":"0x1","0x00000000000000000000000000000000000000f8":"0x1","0x00000000000000000000000000000000000000f9":"0x1","0x00000000000000000000000000000000000000fa":"0x1","0x00000000000000000000000000000000000000fb":"0x1","0x00000000000000000000000000000000000000fc":"0x1","0x00000000000000000000000000000000000000fd":"0x1","0x00000000000000000000000000000000000000fe":"0x1","0x00000000000000000000000000000000000000ff":"0x1","0x31b98d14007bdee637298086988a0bbd31184523":"0x200000000000000000000000000000000000000000000000000000000000000"}');
},
/*!*****************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-common/dist/genesisStates/kovan.json ***!
  \*****************************************************************************************************/

/*! exports provided: 0x0000000000000000000000000000000000000001, 0x0000000000000000000000000000000000000002, 0x0000000000000000000000000000000000000003, 0x0000000000000000000000000000000000000004, 0x00521965e7bd230323c423d96c657db5b79d099f, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"0x0000000000000000000000000000000000000001":"0x1","0x0000000000000000000000000000000000000002":"0x1","0x0000000000000000000000000000000000000003":"0x1","0x0000000000000000000000000000000000000004":"0x1","0x00521965e7bd230323c423d96c657db5b79d099f":"1606938044258990275541962092341162602522202993782792835301376"}');
},
/*!******************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-common/dist/genesisStates/goerli.json ***!
  \******************************************************************************************************/

/*! exports provided: 0x0000000000000000000000000000000000000000, 0x0000000000000000000000000000000000000001, 0x0000000000000000000000000000000000000002, 0x0000000000000000000000000000000000000003, 0x0000000000000000000000000000000000000004, 0x0000000000000000000000000000000000000005, 0x0000000000000000000000000000000000000006, 0x0000000000000000000000000000000000000007, 0x0000000000000000000000000000000000000008, 0x0000000000000000000000000000000000000009, 0x000000000000000000000000000000000000000a, 0x000000000000000000000000000000000000000b, 0x000000000000000000000000000000000000000c, 0x000000000000000000000000000000000000000d, 0x000000000000000000000000000000000000000e, 0x000000000000000000000000000000000000000f, 0x0000000000000000000000000000000000000010, 0x0000000000000000000000000000000000000011, 0x0000000000000000000000000000000000000012, 0x0000000000000000000000000000000000000013, 0x0000000000000000000000000000000000000014, 0x0000000000000000000000000000000000000015, 0x0000000000000000000000000000000000000016, 0x0000000000000000000000000000000000000017, 0x0000000000000000000000000000000000000018, 0x0000000000000000000000000000000000000019, 0x000000000000000000000000000000000000001a, 0x000000000000000000000000000000000000001b, 0x000000000000000000000000000000000000001c, 0x000000000000000000000000000000000000001d, 0x000000000000000000000000000000000000001e, 0x000000000000000000000000000000000000001f, 0x0000000000000000000000000000000000000020, 0x0000000000000000000000000000000000000021, 0x0000000000000000000000000000000000000022, 0x0000000000000000000000000000000000000023, 0x0000000000000000000000000000000000000024, 0x0000000000000000000000000000000000000025, 0x0000000000000000000000000000000000000026, 0x0000000000000000000000000000000000000027, 0x0000000000000000000000000000000000000028, 0x0000000000000000000000000000000000000029, 0x000000000000000000000000000000000000002a, 0x000000000000000000000000000000000000002b, 0x000000000000000000000000000000000000002c, 0x000000000000000000000000000000000000002d, 0x000000000000000000000000000000000000002e, 0x000000000000000000000000000000000000002f, 0x0000000000000000000000000000000000000030, 0x0000000000000000000000000000000000000031, 0x0000000000000000000000000000000000000032, 0x0000000000000000000000000000000000000033, 0x0000000000000000000000000000000000000034, 0x0000000000000000000000000000000000000035, 0x0000000000000000000000000000000000000036, 0x0000000000000000000000000000000000000037, 0x0000000000000000000000000000000000000038, 0x0000000000000000000000000000000000000039, 0x000000000000000000000000000000000000003a, 0x000000000000000000000000000000000000003b, 0x000000000000000000000000000000000000003c, 0x000000000000000000000000000000000000003d, 0x000000000000000000000000000000000000003e, 0x000000000000000000000000000000000000003f, 0x0000000000000000000000000000000000000040, 0x0000000000000000000000000000000000000041, 0x0000000000000000000000000000000000000042, 0x0000000000000000000000000000000000000043, 0x0000000000000000000000000000000000000044, 0x0000000000000000000000000000000000000045, 0x0000000000000000000000000000000000000046, 0x0000000000000000000000000000000000000047, 0x0000000000000000000000000000000000000048, 0x0000000000000000000000000000000000000049, 0x000000000000000000000000000000000000004a, 0x000000000000000000000000000000000000004b, 0x000000000000000000000000000000000000004c, 0x000000000000000000000000000000000000004d, 0x000000000000000000000000000000000000004e, 0x000000000000000000000000000000000000004f, 0x0000000000000000000000000000000000000050, 0x0000000000000000000000000000000000000051, 0x0000000000000000000000000000000000000052, 0x0000000000000000000000000000000000000053, 0x0000000000000000000000000000000000000054, 0x0000000000000000000000000000000000000055, 0x0000000000000000000000000000000000000056, 0x0000000000000000000000000000000000000057, 0x0000000000000000000000000000000000000058, 0x0000000000000000000000000000000000000059, 0x000000000000000000000000000000000000005a, 0x000000000000000000000000000000000000005b, 0x000000000000000000000000000000000000005c, 0x000000000000000000000000000000000000005d, 0x000000000000000000000000000000000000005e, 0x000000000000000000000000000000000000005f, 0x0000000000000000000000000000000000000060, 0x0000000000000000000000000000000000000061, 0x0000000000000000000000000000000000000062, 0x0000000000000000000000000000000000000063, 0x0000000000000000000000000000000000000064, 0x0000000000000000000000000000000000000065, 0x0000000000000000000000000000000000000066, 0x0000000000000000000000000000000000000067, 0x0000000000000000000000000000000000000068, 0x0000000000000000000000000000000000000069, 0x000000000000000000000000000000000000006a, 0x000000000000000000000000000000000000006b, 0x000000000000000000000000000000000000006c, 0x000000000000000000000000000000000000006d, 0x000000000000000000000000000000000000006e, 0x000000000000000000000000000000000000006f, 0x0000000000000000000000000000000000000070, 0x0000000000000000000000000000000000000071, 0x0000000000000000000000000000000000000072, 0x0000000000000000000000000000000000000073, 0x0000000000000000000000000000000000000074, 0x0000000000000000000000000000000000000075, 0x0000000000000000000000000000000000000076, 0x0000000000000000000000000000000000000077, 0x0000000000000000000000000000000000000078, 0x0000000000000000000000000000000000000079, 0x000000000000000000000000000000000000007a, 0x000000000000000000000000000000000000007b, 0x000000000000000000000000000000000000007c, 0x000000000000000000000000000000000000007d, 0x000000000000000000000000000000000000007e, 0x000000000000000000000000000000000000007f, 0x0000000000000000000000000000000000000080, 0x0000000000000000000000000000000000000081, 0x0000000000000000000000000000000000000082, 0x0000000000000000000000000000000000000083, 0x0000000000000000000000000000000000000084, 0x0000000000000000000000000000000000000085, 0x0000000000000000000000000000000000000086, 0x0000000000000000000000000000000000000087, 0x0000000000000000000000000000000000000088, 0x0000000000000000000000000000000000000089, 0x000000000000000000000000000000000000008a, 0x000000000000000000000000000000000000008b, 0x000000000000000000000000000000000000008c, 0x000000000000000000000000000000000000008d, 0x000000000000000000000000000000000000008e, 0x000000000000000000000000000000000000008f, 0x0000000000000000000000000000000000000090, 0x0000000000000000000000000000000000000091, 0x0000000000000000000000000000000000000092, 0x0000000000000000000000000000000000000093, 0x0000000000000000000000000000000000000094, 0x0000000000000000000000000000000000000095, 0x0000000000000000000000000000000000000096, 0x0000000000000000000000000000000000000097, 0x0000000000000000000000000000000000000098, 0x0000000000000000000000000000000000000099, 0x000000000000000000000000000000000000009a, 0x000000000000000000000000000000000000009b, 0x000000000000000000000000000000000000009c, 0x000000000000000000000000000000000000009d, 0x000000000000000000000000000000000000009e, 0x000000000000000000000000000000000000009f, 0x00000000000000000000000000000000000000a0, 0x00000000000000000000000000000000000000a1, 0x00000000000000000000000000000000000000a2, 0x00000000000000000000000000000000000000a3, 0x00000000000000000000000000000000000000a4, 0x00000000000000000000000000000000000000a5, 0x00000000000000000000000000000000000000a6, 0x00000000000000000000000000000000000000a7, 0x00000000000000000000000000000000000000a8, 0x00000000000000000000000000000000000000a9, 0x00000000000000000000000000000000000000aa, 0x00000000000000000000000000000000000000ab, 0x00000000000000000000000000000000000000ac, 0x00000000000000000000000000000000000000ad, 0x00000000000000000000000000000000000000ae, 0x00000000000000000000000000000000000000af, 0x00000000000000000000000000000000000000b0, 0x00000000000000000000000000000000000000b1, 0x00000000000000000000000000000000000000b2, 0x00000000000000000000000000000000000000b3, 0x00000000000000000000000000000000000000b4, 0x00000000000000000000000000000000000000b5, 0x00000000000000000000000000000000000000b6, 0x00000000000000000000000000000000000000b7, 0x00000000000000000000000000000000000000b8, 0x00000000000000000000000000000000000000b9, 0x00000000000000000000000000000000000000ba, 0x00000000000000000000000000000000000000bb, 0x00000000000000000000000000000000000000bc, 0x00000000000000000000000000000000000000bd, 0x00000000000000000000000000000000000000be, 0x00000000000000000000000000000000000000bf, 0x00000000000000000000000000000000000000c0, 0x00000000000000000000000000000000000000c1, 0x00000000000000000000000000000000000000c2, 0x00000000000000000000000000000000000000c3, 0x00000000000000000000000000000000000000c4, 0x00000000000000000000000000000000000000c5, 0x00000000000000000000000000000000000000c6, 0x00000000000000000000000000000000000000c7, 0x00000000000000000000000000000000000000c8, 0x00000000000000000000000000000000000000c9, 0x00000000000000000000000000000000000000ca, 0x00000000000000000000000000000000000000cb, 0x00000000000000000000000000000000000000cc, 0x00000000000000000000000000000000000000cd, 0x00000000000000000000000000000000000000ce, 0x00000000000000000000000000000000000000cf, 0x00000000000000000000000000000000000000d0, 0x00000000000000000000000000000000000000d1, 0x00000000000000000000000000000000000000d2, 0x00000000000000000000000000000000000000d3, 0x00000000000000000000000000000000000000d4, 0x00000000000000000000000000000000000000d5, 0x00000000000000000000000000000000000000d6, 0x00000000000000000000000000000000000000d7, 0x00000000000000000000000000000000000000d8, 0x00000000000000000000000000000000000000d9, 0x00000000000000000000000000000000000000da, 0x00000000000000000000000000000000000000db, 0x00000000000000000000000000000000000000dc, 0x00000000000000000000000000000000000000dd, 0x00000000000000000000000000000000000000de, 0x00000000000000000000000000000000000000df, 0x00000000000000000000000000000000000000e0, 0x00000000000000000000000000000000000000e1, 0x00000000000000000000000000000000000000e2, 0x00000000000000000000000000000000000000e3, 0x00000000000000000000000000000000000000e4, 0x00000000000000000000000000000000000000e5, 0x00000000000000000000000000000000000000e6, 0x00000000000000000000000000000000000000e7, 0x00000000000000000000000000000000000000e8, 0x00000000000000000000000000000000000000e9, 0x00000000000000000000000000000000000000ea, 0x00000000000000000000000000000000000000eb, 0x00000000000000000000000000000000000000ec, 0x00000000000000000000000000000000000000ed, 0x00000000000000000000000000000000000000ee, 0x00000000000000000000000000000000000000ef, 0x00000000000000000000000000000000000000f0, 0x00000000000000000000000000000000000000f1, 0x00000000000000000000000000000000000000f2, 0x00000000000000000000000000000000000000f3, 0x00000000000000000000000000000000000000f4, 0x00000000000000000000000000000000000000f5, 0x00000000000000000000000000000000000000f6, 0x00000000000000000000000000000000000000f7, 0x00000000000000000000000000000000000000f8, 0x00000000000000000000000000000000000000f9, 0x00000000000000000000000000000000000000fa, 0x00000000000000000000000000000000000000fb, 0x00000000000000000000000000000000000000fc, 0x00000000000000000000000000000000000000fd, 0x00000000000000000000000000000000000000fe, 0x00000000000000000000000000000000000000ff, 0x4c2ae482593505f0163cdefc073e81c63cda4107, 0xa8e8f14732658e4b51e8711931053a8a69baf2b1, 0xd9a5179f091d85051d3c982785efd1455cec8699, 0xe0a2bd4258d2768837baa26a28fe71dc079f84c7, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"0x0000000000000000000000000000000000000000":"0x1","0x0000000000000000000000000000000000000001":"0x1","0x0000000000000000000000000000000000000002":"0x1","0x0000000000000000000000000000000000000003":"0x1","0x0000000000000000000000000000000000000004":"0x1","0x0000000000000000000000000000000000000005":"0x1","0x0000000000000000000000000000000000000006":"0x1","0x0000000000000000000000000000000000000007":"0x1","0x0000000000000000000000000000000000000008":"0x1","0x0000000000000000000000000000000000000009":"0x1","0x000000000000000000000000000000000000000a":"0x1","0x000000000000000000000000000000000000000b":"0x1","0x000000000000000000000000000000000000000c":"0x1","0x000000000000000000000000000000000000000d":"0x1","0x000000000000000000000000000000000000000e":"0x1","0x000000000000000000000000000000000000000f":"0x1","0x0000000000000000000000000000000000000010":"0x1","0x0000000000000000000000000000000000000011":"0x1","0x0000000000000000000000000000000000000012":"0x1","0x0000000000000000000000000000000000000013":"0x1","0x0000000000000000000000000000000000000014":"0x1","0x0000000000000000000000000000000000000015":"0x1","0x0000000000000000000000000000000000000016":"0x1","0x0000000000000000000000000000000000000017":"0x1","0x0000000000000000000000000000000000000018":"0x1","0x0000000000000000000000000000000000000019":"0x1","0x000000000000000000000000000000000000001a":"0x1","0x000000000000000000000000000000000000001b":"0x1","0x000000000000000000000000000000000000001c":"0x1","0x000000000000000000000000000000000000001d":"0x1","0x000000000000000000000000000000000000001e":"0x1","0x000000000000000000000000000000000000001f":"0x1","0x0000000000000000000000000000000000000020":"0x1","0x0000000000000000000000000000000000000021":"0x1","0x0000000000000000000000000000000000000022":"0x1","0x0000000000000000000000000000000000000023":"0x1","0x0000000000000000000000000000000000000024":"0x1","0x0000000000000000000000000000000000000025":"0x1","0x0000000000000000000000000000000000000026":"0x1","0x0000000000000000000000000000000000000027":"0x1","0x0000000000000000000000000000000000000028":"0x1","0x0000000000000000000000000000000000000029":"0x1","0x000000000000000000000000000000000000002a":"0x1","0x000000000000000000000000000000000000002b":"0x1","0x000000000000000000000000000000000000002c":"0x1","0x000000000000000000000000000000000000002d":"0x1","0x000000000000000000000000000000000000002e":"0x1","0x000000000000000000000000000000000000002f":"0x1","0x0000000000000000000000000000000000000030":"0x1","0x0000000000000000000000000000000000000031":"0x1","0x0000000000000000000000000000000000000032":"0x1","0x0000000000000000000000000000000000000033":"0x1","0x0000000000000000000000000000000000000034":"0x1","0x0000000000000000000000000000000000000035":"0x1","0x0000000000000000000000000000000000000036":"0x1","0x0000000000000000000000000000000000000037":"0x1","0x0000000000000000000000000000000000000038":"0x1","0x0000000000000000000000000000000000000039":"0x1","0x000000000000000000000000000000000000003a":"0x1","0x000000000000000000000000000000000000003b":"0x1","0x000000000000000000000000000000000000003c":"0x1","0x000000000000000000000000000000000000003d":"0x1","0x000000000000000000000000000000000000003e":"0x1","0x000000000000000000000000000000000000003f":"0x1","0x0000000000000000000000000000000000000040":"0x1","0x0000000000000000000000000000000000000041":"0x1","0x0000000000000000000000000000000000000042":"0x1","0x0000000000000000000000000000000000000043":"0x1","0x0000000000000000000000000000000000000044":"0x1","0x0000000000000000000000000000000000000045":"0x1","0x0000000000000000000000000000000000000046":"0x1","0x0000000000000000000000000000000000000047":"0x1","0x0000000000000000000000000000000000000048":"0x1","0x0000000000000000000000000000000000000049":"0x1","0x000000000000000000000000000000000000004a":"0x1","0x000000000000000000000000000000000000004b":"0x1","0x000000000000000000000000000000000000004c":"0x1","0x000000000000000000000000000000000000004d":"0x1","0x000000000000000000000000000000000000004e":"0x1","0x000000000000000000000000000000000000004f":"0x1","0x0000000000000000000000000000000000000050":"0x1","0x0000000000000000000000000000000000000051":"0x1","0x0000000000000000000000000000000000000052":"0x1","0x0000000000000000000000000000000000000053":"0x1","0x0000000000000000000000000000000000000054":"0x1","0x0000000000000000000000000000000000000055":"0x1","0x0000000000000000000000000000000000000056":"0x1","0x0000000000000000000000000000000000000057":"0x1","0x0000000000000000000000000000000000000058":"0x1","0x0000000000000000000000000000000000000059":"0x1","0x000000000000000000000000000000000000005a":"0x1","0x000000000000000000000000000000000000005b":"0x1","0x000000000000000000000000000000000000005c":"0x1","0x000000000000000000000000000000000000005d":"0x1","0x000000000000000000000000000000000000005e":"0x1","0x000000000000000000000000000000000000005f":"0x1","0x0000000000000000000000000000000000000060":"0x1","0x0000000000000000000000000000000000000061":"0x1","0x0000000000000000000000000000000000000062":"0x1","0x0000000000000000000000000000000000000063":"0x1","0x0000000000000000000000000000000000000064":"0x1","0x0000000000000000000000000000000000000065":"0x1","0x0000000000000000000000000000000000000066":"0x1","0x0000000000000000000000000000000000000067":"0x1","0x0000000000000000000000000000000000000068":"0x1","0x0000000000000000000000000000000000000069":"0x1","0x000000000000000000000000000000000000006a":"0x1","0x000000000000000000000000000000000000006b":"0x1","0x000000000000000000000000000000000000006c":"0x1","0x000000000000000000000000000000000000006d":"0x1","0x000000000000000000000000000000000000006e":"0x1","0x000000000000000000000000000000000000006f":"0x1","0x0000000000000000000000000000000000000070":"0x1","0x0000000000000000000000000000000000000071":"0x1","0x0000000000000000000000000000000000000072":"0x1","0x0000000000000000000000000000000000000073":"0x1","0x0000000000000000000000000000000000000074":"0x1","0x0000000000000000000000000000000000000075":"0x1","0x0000000000000000000000000000000000000076":"0x1","0x0000000000000000000000000000000000000077":"0x1","0x0000000000000000000000000000000000000078":"0x1","0x0000000000000000000000000000000000000079":"0x1","0x000000000000000000000000000000000000007a":"0x1","0x000000000000000000000000000000000000007b":"0x1","0x000000000000000000000000000000000000007c":"0x1","0x000000000000000000000000000000000000007d":"0x1","0x000000000000000000000000000000000000007e":"0x1","0x000000000000000000000000000000000000007f":"0x1","0x0000000000000000000000000000000000000080":"0x1","0x0000000000000000000000000000000000000081":"0x1","0x0000000000000000000000000000000000000082":"0x1","0x0000000000000000000000000000000000000083":"0x1","0x0000000000000000000000000000000000000084":"0x1","0x0000000000000000000000000000000000000085":"0x1","0x0000000000000000000000000000000000000086":"0x1","0x0000000000000000000000000000000000000087":"0x1","0x0000000000000000000000000000000000000088":"0x1","0x0000000000000000000000000000000000000089":"0x1","0x000000000000000000000000000000000000008a":"0x1","0x000000000000000000000000000000000000008b":"0x1","0x000000000000000000000000000000000000008c":"0x1","0x000000000000000000000000000000000000008d":"0x1","0x000000000000000000000000000000000000008e":"0x1","0x000000000000000000000000000000000000008f":"0x1","0x0000000000000000000000000000000000000090":"0x1","0x0000000000000000000000000000000000000091":"0x1","0x0000000000000000000000000000000000000092":"0x1","0x0000000000000000000000000000000000000093":"0x1","0x0000000000000000000000000000000000000094":"0x1","0x0000000000000000000000000000000000000095":"0x1","0x0000000000000000000000000000000000000096":"0x1","0x0000000000000000000000000000000000000097":"0x1","0x0000000000000000000000000000000000000098":"0x1","0x0000000000000000000000000000000000000099":"0x1","0x000000000000000000000000000000000000009a":"0x1","0x000000000000000000000000000000000000009b":"0x1","0x000000000000000000000000000000000000009c":"0x1","0x000000000000000000000000000000000000009d":"0x1","0x000000000000000000000000000000000000009e":"0x1","0x000000000000000000000000000000000000009f":"0x1","0x00000000000000000000000000000000000000a0":"0x1","0x00000000000000000000000000000000000000a1":"0x1","0x00000000000000000000000000000000000000a2":"0x1","0x00000000000000000000000000000000000000a3":"0x1","0x00000000000000000000000000000000000000a4":"0x1","0x00000000000000000000000000000000000000a5":"0x1","0x00000000000000000000000000000000000000a6":"0x1","0x00000000000000000000000000000000000000a7":"0x1","0x00000000000000000000000000000000000000a8":"0x1","0x00000000000000000000000000000000000000a9":"0x1","0x00000000000000000000000000000000000000aa":"0x1","0x00000000000000000000000000000000000000ab":"0x1","0x00000000000000000000000000000000000000ac":"0x1","0x00000000000000000000000000000000000000ad":"0x1","0x00000000000000000000000000000000000000ae":"0x1","0x00000000000000000000000000000000000000af":"0x1","0x00000000000000000000000000000000000000b0":"0x1","0x00000000000000000000000000000000000000b1":"0x1","0x00000000000000000000000000000000000000b2":"0x1","0x00000000000000000000000000000000000000b3":"0x1","0x00000000000000000000000000000000000000b4":"0x1","0x00000000000000000000000000000000000000b5":"0x1","0x00000000000000000000000000000000000000b6":"0x1","0x00000000000000000000000000000000000000b7":"0x1","0x00000000000000000000000000000000000000b8":"0x1","0x00000000000000000000000000000000000000b9":"0x1","0x00000000000000000000000000000000000000ba":"0x1","0x00000000000000000000000000000000000000bb":"0x1","0x00000000000000000000000000000000000000bc":"0x1","0x00000000000000000000000000000000000000bd":"0x1","0x00000000000000000000000000000000000000be":"0x1","0x00000000000000000000000000000000000000bf":"0x1","0x00000000000000000000000000000000000000c0":"0x1","0x00000000000000000000000000000000000000c1":"0x1","0x00000000000000000000000000000000000000c2":"0x1","0x00000000000000000000000000000000000000c3":"0x1","0x00000000000000000000000000000000000000c4":"0x1","0x00000000000000000000000000000000000000c5":"0x1","0x00000000000000000000000000000000000000c6":"0x1","0x00000000000000000000000000000000000000c7":"0x1","0x00000000000000000000000000000000000000c8":"0x1","0x00000000000000000000000000000000000000c9":"0x1","0x00000000000000000000000000000000000000ca":"0x1","0x00000000000000000000000000000000000000cb":"0x1","0x00000000000000000000000000000000000000cc":"0x1","0x00000000000000000000000000000000000000cd":"0x1","0x00000000000000000000000000000000000000ce":"0x1","0x00000000000000000000000000000000000000cf":"0x1","0x00000000000000000000000000000000000000d0":"0x1","0x00000000000000000000000000000000000000d1":"0x1","0x00000000000000000000000000000000000000d2":"0x1","0x00000000000000000000000000000000000000d3":"0x1","0x00000000000000000000000000000000000000d4":"0x1","0x00000000000000000000000000000000000000d5":"0x1","0x00000000000000000000000000000000000000d6":"0x1","0x00000000000000000000000000000000000000d7":"0x1","0x00000000000000000000000000000000000000d8":"0x1","0x00000000000000000000000000000000000000d9":"0x1","0x00000000000000000000000000000000000000da":"0x1","0x00000000000000000000000000000000000000db":"0x1","0x00000000000000000000000000000000000000dc":"0x1","0x00000000000000000000000000000000000000dd":"0x1","0x00000000000000000000000000000000000000de":"0x1","0x00000000000000000000000000000000000000df":"0x1","0x00000000000000000000000000000000000000e0":"0x1","0x00000000000000000000000000000000000000e1":"0x1","0x00000000000000000000000000000000000000e2":"0x1","0x00000000000000000000000000000000000000e3":"0x1","0x00000000000000000000000000000000000000e4":"0x1","0x00000000000000000000000000000000000000e5":"0x1","0x00000000000000000000000000000000000000e6":"0x1","0x00000000000000000000000000000000000000e7":"0x1","0x00000000000000000000000000000000000000e8":"0x1","0x00000000000000000000000000000000000000e9":"0x1","0x00000000000000000000000000000000000000ea":"0x1","0x00000000000000000000000000000000000000eb":"0x1","0x00000000000000000000000000000000000000ec":"0x1","0x00000000000000000000000000000000000000ed":"0x1","0x00000000000000000000000000000000000000ee":"0x1","0x00000000000000000000000000000000000000ef":"0x1","0x00000000000000000000000000000000000000f0":"0x1","0x00000000000000000000000000000000000000f1":"0x1","0x00000000000000000000000000000000000000f2":"0x1","0x00000000000000000000000000000000000000f3":"0x1","0x00000000000000000000000000000000000000f4":"0x1","0x00000000000000000000000000000000000000f5":"0x1","0x00000000000000000000000000000000000000f6":"0x1","0x00000000000000000000000000000000000000f7":"0x1","0x00000000000000000000000000000000000000f8":"0x1","0x00000000000000000000000000000000000000f9":"0x1","0x00000000000000000000000000000000000000fa":"0x1","0x00000000000000000000000000000000000000fb":"0x1","0x00000000000000000000000000000000000000fc":"0x1","0x00000000000000000000000000000000000000fd":"0x1","0x00000000000000000000000000000000000000fe":"0x1","0x00000000000000000000000000000000000000ff":"0x1","0x4c2ae482593505f0163cdefc073e81c63cda4107":"0x152d02c7e14af6800000","0xa8e8f14732658e4b51e8711931053a8a69baf2b1":"0x152d02c7e14af6800000","0xd9a5179f091d85051d3c982785efd1455cec8699":"0x84595161401484a000000","0xe0a2bd4258d2768837baa26a28fe71dc079f84c7":"0x4a47e3c12448f4ad000000"}');
},
/*!***************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-vm/dist/state/cache.js ***!
  \***************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = a(
    /*! async */
    73),
        n = a(
    /*! functional-red-black-tree */
    111),
        s = a(
    /*! ethereumjs-account */
    72),
        o = function () {
      function t(e) {
        this._cache = n(), this._checkpoints = [], this._trie = e;
      }

      return t.prototype.put = function (e, t, a) {
        void 0 === a && (a = !1);
        var r = !a;

        this._update(e, t, r, !1);
      }, t.prototype.get = function (e) {
        var t = this.lookup(e);
        return t || (t = new s.default()), t;
      }, t.prototype.lookup = function (e) {
        var t = e.toString("hex"),
            a = this._cache.find(t);

        if (a.node) return new s.default(a.value.val);
      }, t.prototype._lookupAccount = function (e, t) {
        this._trie.get(e, function (e, a) {
          if (e) return t(e);
          var r = new s.default(a);
          t(null, r);
        });
      }, t.prototype.getOrLoad = function (e, t) {
        var a = this,
            n = this.lookup(e);
        n ? r.nextTick(t, null, n) : this._lookupAccount(e, function (r, n) {
          if (r) return t(r);
          a._update(e, n, !1, !1), t(null, n);
        });
      }, t.prototype.warm = function (t, a) {
        var n = this,
            s = [];
        t.forEach(function (e) {
          e && s.push(e);
        }), r.eachSeries(s, function (t, a) {
          var r = e.from(t, "hex");

          n._lookupAccount(r, function (e, t) {
            if (e) return a(e);
            n._update(r, t, !1, !1), a();
          });
        }, a);
      }, t.prototype.flush = function (t) {
        var a = this,
            n = this._cache.begin,
            o = !0;
        r.whilst(function () {
          return o;
        }, function (t) {
          n.value && n.value.modified ? (n.value.modified = !1, n.value.val = n.value.val.serialize(), a._trie.put(e.from(n.key, "hex"), n.value.val, function (e) {
            if (e) return t(e);
            o = n.hasNext, n.next(), t();
          })) : n.value && n.value.deleted ? (n.value.modified = !1, n.value.deleted = !1, n.value.val = new s.default().serialize(), a._trie.del(e.from(n.key, "hex"), function (e) {
            if (e) return t(e);
            o = n.hasNext, n.next(), t();
          })) : (o = n.hasNext, n.next(), r.nextTick(t));
        }, t);
      }, t.prototype.checkpoint = function () {
        this._checkpoints.push(this._cache);
      }, t.prototype.revert = function () {
        this._cache = this._checkpoints.pop();
      }, t.prototype.commit = function () {
        this._checkpoints.pop();
      }, t.prototype.clear = function () {
        this._cache = n();
      }, t.prototype.del = function (e) {
        this._update(e, new s.default(), !1, !0);
      }, t.prototype._update = function (e, t, a, r) {
        var n = e.toString("hex"),
            s = this._cache.find(n);

        s.node ? this._cache = s.update({
          val: t,
          modified: a,
          deleted: r
        }) : this._cache = this._cache.insert(n, {
          val: t,
          modified: a,
          deleted: r
        });
      }, t;
    }();

    t.default = o;
  }).call(this, a(
  /*! ./../../../../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!***********************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-vm/dist/runCode.js ***!
  \***********************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = a(
    /*! ethereumjs-util */
    29),
        n = a(
    /*! ./evm/txContext */
    130),
        s = a(
    /*! ./evm/message */
    87),
        o = a(
    /*! ./evm/evm */
    32),
        i = a(
    /*! ethereumjs-block */
    60);

    t.default = function (t) {
      t.block || (t.block = new i()), t.txContext || (t.txContext = new n.default(t.gasPrice || e.alloc(0), t.origin || t.caller || r.zeros(32))), t.message || (t.message = new s.default({
        code: t.code,
        data: t.data,
        gasLimit: t.gasLimit,
        to: t.address || r.zeros(32),
        caller: t.caller,
        value: t.value,
        depth: t.depth || 0,
        selfdestruct: t.selfdestruct || {},
        isStatic: t.isStatic || !1
      }));
      var a = t.evm;
      return a || (a = new o.default(this, t.txContext, t.block)), a.runInterpreter(t.message, {
        pc: t.pc
      });
    };
  }).call(this, a(
  /*! ./../../../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!****************************************************!*\
  !*** ./node_modules/object-keys/implementation.js ***!
  \****************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r;

  if (!Object.keys) {
    var n = Object.prototype.hasOwnProperty,
        s = Object.prototype.toString,
        o = a(
    /*! ./isArguments */
    233),
        i = Object.prototype.propertyIsEnumerable,
        c = !i.call({
      toString: null
    }, "toString"),
        u = i.call(function () {}, "prototype"),
        d = ["toString", "toLocaleString", "valueOf", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "constructor"],
        f = function f(e) {
      var t = e.constructor;
      return t && t.prototype === e;
    },
        l = {
      $applicationCache: !0,
      $console: !0,
      $external: !0,
      $frame: !0,
      $frameElement: !0,
      $frames: !0,
      $innerHeight: !0,
      $innerWidth: !0,
      $onmozfullscreenchange: !0,
      $onmozfullscreenerror: !0,
      $outerHeight: !0,
      $outerWidth: !0,
      $pageXOffset: !0,
      $pageYOffset: !0,
      $parent: !0,
      $scrollLeft: !0,
      $scrollTop: !0,
      $scrollX: !0,
      $scrollY: !0,
      $self: !0,
      $webkitIndexedDB: !0,
      $webkitStorageInfo: !0,
      $window: !0
    },
        h = function () {
      if ("undefined" == typeof window) return !1;

      for (var e in window) {
        try {
          if (!l["$" + e] && n.call(window, e) && null !== window[e] && "object" == typeof window[e]) try {
            f(window[e]);
          } catch (e) {
            return !0;
          }
        } catch (e) {
          return !0;
        }
      }

      return !1;
    }();

    r = function r(e) {
      var t = null !== e && "object" == typeof e,
          a = "[object Function]" === s.call(e),
          r = o(e),
          i = t && "[object String]" === s.call(e),
          l = [];
      if (!t && !a && !r) throw new TypeError("Object.keys called on a non-object");
      var p = u && a;
      if (i && e.length > 0 && !n.call(e, 0)) for (var b = 0; b < e.length; ++b) {
        l.push(String(b));
      }
      if (r && e.length > 0) for (var m = 0; m < e.length; ++m) {
        l.push(String(m));
      } else for (var y in e) {
        p && "prototype" === y || !n.call(e, y) || l.push(String(y));
      }
      if (c) for (var v = function (e) {
        if ("undefined" == typeof window || !h) return f(e);

        try {
          return f(e);
        } catch (e) {
          return !1;
        }
      }(e), _ = 0; _ < d.length; ++_) {
        v && "constructor" === d[_] || !n.call(e, d[_]) || l.push(d[_]);
      }
      return l;
    };
  }

  e.exports = r;
},
/*!****************************************************************!*\
  !*** ./node_modules/object.getownpropertydescriptors/index.js ***!
  \****************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! define-properties */
  131),
      n = a(
  /*! ./implementation */
  235);
  r(n, {
    getPolyfill: a(
    /*! ./polyfill */
    243),
    implementation: n,
    shim: a(
    /*! ./shim */
    658)
  }), e.exports = n;
},
/*!*****************************************!*\
  !*** ./node_modules/es-abstract/es7.js ***!
  \*****************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  e.exports = a(
  /*! ./es2016 */
  645);
},
/*!********************************************!*\
  !*** ./node_modules/es-abstract/es2016.js ***!
  \********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ./es2015 */
  646),
      n = a(
  /*! ./helpers/assign */
  240),
      s = n(n({}, r), {
    SameValueNonNumber: function SameValueNonNumber(e, t) {
      if ("number" == typeof e || typeof e != typeof t) throw new TypeError("SameValueNonNumber requires two non-number values of the same type.");
      return this.SameValue(e, t);
    }
  });
  e.exports = s;
},
/*!********************************************!*\
  !*** ./node_modules/es-abstract/es2015.js ***!
  \********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! has */
  89),
      n = a(
  /*! es-to-primitive/es6 */
  648),
      s = a(
  /*! object-keys */
  232),
      o = a(
  /*! ./GetIntrinsic */
  134),
      i = o("%TypeError%"),
      c = o("%SyntaxError%"),
      u = o("%Array%"),
      d = o("%String%"),
      f = o("%Object%"),
      l = o("%Number%"),
      h = o("%Symbol%", !0),
      p = o("%RegExp%"),
      b = !!h,
      m = a(
  /*! ./helpers/assertRecord */
  237),
      y = a(
  /*! ./helpers/isNaN */
  238),
      v = a(
  /*! ./helpers/isFinite */
  239),
      _ = l.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1,
      g = a(
  /*! ./helpers/assign */
  240),
      A = a(
  /*! ./helpers/sign */
  241),
      w = a(
  /*! ./helpers/mod */
  242),
      T = a(
  /*! ./helpers/isPrimitive */
  654),
      x = parseInt,
      D = a(
  /*! function-bind */
  132),
      C = D.call(Function.call, u.prototype.slice),
      S = D.call(Function.call, d.prototype.slice),
      E = D.call(Function.call, p.prototype.test, /^0b[01]+$/i),
      B = D.call(Function.call, p.prototype.test, /^0o[0-7]+$/i),
      k = D.call(Function.call, p.prototype.exec),
      R = new p("[" + ["", "​", "￾"].join("") + "]", "g"),
      W = D.call(Function.call, p.prototype.test, R),
      I = D.call(Function.call, p.prototype.test, /^[-+]0x[0-9a-f]+$/i),
      N = D.call(Function.call, d.prototype.charCodeAt),
      M = D.call(Function.call, Object.prototype.toString),
      P = D.call(Function.call, o("%NumberPrototype%").valueOf),
      L = D.call(Function.call, o("%BooleanPrototype%").valueOf),
      O = D.call(Function.call, o("%StringPrototype%").valueOf),
      F = D.call(Function.call, o("%DatePrototype%").valueOf),
      j = Math.floor,
      G = Math.abs,
      V = Object.create,
      U = f.getOwnPropertyDescriptor,
      H = f.isExtensible,
      z = f.defineProperty,
      K = ["\t\n\v\f\r   ᠎    ", "\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028", "\u2029\uFEFF"].join(""),
      q = new RegExp("(^[" + K + "]+)|([" + K + "]+$)", "g"),
      Y = D.call(Function.call, d.prototype.replace),
      Z = a(
  /*! ./es5 */
  655),
      J = a(
  /*! is-regex */
  657),
      X = g(g({}, Z), {
    Call: function Call(e, t) {
      var a = arguments.length > 2 ? arguments[2] : [];
      if (!this.IsCallable(e)) throw new i(e + " is not a function");
      return e.apply(t, a);
    },
    ToPrimitive: n,
    ToNumber: function ToNumber(e) {
      var t = T(e) ? e : n(e, l);
      if ("symbol" == typeof t) throw new i("Cannot convert a Symbol value to a number");

      if ("string" == typeof t) {
        if (E(t)) return this.ToNumber(x(S(t, 2), 2));
        if (B(t)) return this.ToNumber(x(S(t, 2), 8));
        if (W(t) || I(t)) return NaN;

        var a = function (e) {
          return Y(e, q, "");
        }(t);

        if (a !== t) return this.ToNumber(a);
      }

      return l(t);
    },
    ToInt16: function ToInt16(e) {
      var t = this.ToUint16(e);
      return t >= 32768 ? t - 65536 : t;
    },
    ToInt8: function ToInt8(e) {
      var t = this.ToUint8(e);
      return t >= 128 ? t - 256 : t;
    },
    ToUint8: function ToUint8(e) {
      var t = this.ToNumber(e);
      if (y(t) || 0 === t || !v(t)) return 0;
      var a = A(t) * j(G(t));
      return w(a, 256);
    },
    ToUint8Clamp: function ToUint8Clamp(e) {
      var t = this.ToNumber(e);
      if (y(t) || t <= 0) return 0;
      if (t >= 255) return 255;
      var a = j(e);
      return a + .5 < t ? a + 1 : t < a + .5 ? a : a % 2 != 0 ? a + 1 : a;
    },
    ToString: function ToString(e) {
      if ("symbol" == typeof e) throw new i("Cannot convert a Symbol value to a string");
      return d(e);
    },
    ToObject: function ToObject(e) {
      return this.RequireObjectCoercible(e), f(e);
    },
    ToPropertyKey: function ToPropertyKey(e) {
      var t = this.ToPrimitive(e, d);
      return "symbol" == typeof t ? t : this.ToString(t);
    },
    ToLength: function ToLength(e) {
      var t = this.ToInteger(e);
      return t <= 0 ? 0 : t > _ ? _ : t;
    },
    CanonicalNumericIndexString: function CanonicalNumericIndexString(e) {
      if ("[object String]" !== M(e)) throw new i("must be a string");
      if ("-0" === e) return -0;
      var t = this.ToNumber(e);
      return this.SameValue(this.ToString(t), e) ? t : void 0;
    },
    RequireObjectCoercible: Z.CheckObjectCoercible,
    IsArray: u.isArray || function (e) {
      return "[object Array]" === M(e);
    },
    IsConstructor: function IsConstructor(e) {
      return "function" == typeof e && !!e.prototype;
    },
    IsExtensible: Object.preventExtensions ? function (e) {
      return !T(e) && H(e);
    } : function (e) {
      return !0;
    },
    IsInteger: function IsInteger(e) {
      if ("number" != typeof e || y(e) || !v(e)) return !1;
      var t = G(e);
      return j(t) === t;
    },
    IsPropertyKey: function IsPropertyKey(e) {
      return "string" == typeof e || "symbol" == typeof e;
    },
    IsRegExp: function IsRegExp(e) {
      if (!e || "object" != typeof e) return !1;

      if (b) {
        var t = e[h.match];
        if (void 0 !== t) return Z.ToBoolean(t);
      }

      return J(e);
    },
    SameValueZero: function SameValueZero(e, t) {
      return e === t || y(e) && y(t);
    },
    GetV: function GetV(e, t) {
      if (!this.IsPropertyKey(t)) throw new i("Assertion failed: IsPropertyKey(P) is not true");
      return this.ToObject(e)[t];
    },
    GetMethod: function GetMethod(e, t) {
      if (!this.IsPropertyKey(t)) throw new i("Assertion failed: IsPropertyKey(P) is not true");
      var a = this.GetV(e, t);

      if (null != a) {
        if (!this.IsCallable(a)) throw new i(t + "is not a function");
        return a;
      }
    },
    Get: function Get(e, t) {
      if ("Object" !== this.Type(e)) throw new i("Assertion failed: Type(O) is not Object");
      if (!this.IsPropertyKey(t)) throw new i("Assertion failed: IsPropertyKey(P) is not true");
      return e[t];
    },
    Type: function Type(e) {
      return "symbol" == typeof e ? "Symbol" : Z.Type(e);
    },
    SpeciesConstructor: function SpeciesConstructor(e, t) {
      if ("Object" !== this.Type(e)) throw new i("Assertion failed: Type(O) is not Object");
      var a = e.constructor;
      if (void 0 === a) return t;
      if ("Object" !== this.Type(a)) throw new i("O.constructor is not an Object");
      var r = b && h.species ? a[h.species] : void 0;
      if (null == r) return t;
      if (this.IsConstructor(r)) return r;
      throw new i("no constructor found");
    },
    CompletePropertyDescriptor: function CompletePropertyDescriptor(e) {
      return m(this, "Property Descriptor", "Desc", e), this.IsGenericDescriptor(e) || this.IsDataDescriptor(e) ? (r(e, "[[Value]]") || (e["[[Value]]"] = void 0), r(e, "[[Writable]]") || (e["[[Writable]]"] = !1)) : (r(e, "[[Get]]") || (e["[[Get]]"] = void 0), r(e, "[[Set]]") || (e["[[Set]]"] = void 0)), r(e, "[[Enumerable]]") || (e["[[Enumerable]]"] = !1), r(e, "[[Configurable]]") || (e["[[Configurable]]"] = !1), e;
    },
    Set: function Set(e, t, a, r) {
      if ("Object" !== this.Type(e)) throw new i("O must be an Object");
      if (!this.IsPropertyKey(t)) throw new i("P must be a Property Key");
      if ("Boolean" !== this.Type(r)) throw new i("Throw must be a Boolean");
      if (r) return e[t] = a, !0;

      try {
        e[t] = a;
      } catch (e) {
        return !1;
      }
    },
    HasOwnProperty: function HasOwnProperty(e, t) {
      if ("Object" !== this.Type(e)) throw new i("O must be an Object");
      if (!this.IsPropertyKey(t)) throw new i("P must be a Property Key");
      return r(e, t);
    },
    HasProperty: function HasProperty(e, t) {
      if ("Object" !== this.Type(e)) throw new i("O must be an Object");
      if (!this.IsPropertyKey(t)) throw new i("P must be a Property Key");
      return t in e;
    },
    IsConcatSpreadable: function IsConcatSpreadable(e) {
      if ("Object" !== this.Type(e)) return !1;

      if (b && "symbol" == typeof h.isConcatSpreadable) {
        var t = this.Get(e, Symbol.isConcatSpreadable);
        if (void 0 !== t) return this.ToBoolean(t);
      }

      return this.IsArray(e);
    },
    Invoke: function Invoke(e, t) {
      if (!this.IsPropertyKey(t)) throw new i("P must be a Property Key");
      var a = C(arguments, 2),
          r = this.GetV(e, t);
      return this.Call(r, e, a);
    },
    GetIterator: function GetIterator(e, t) {
      if (!b) throw new SyntaxError("ES.GetIterator depends on native iterator support.");
      var a = t;
      arguments.length < 2 && (a = this.GetMethod(e, h.iterator));
      var r = this.Call(a, e);
      if ("Object" !== this.Type(r)) throw new i("iterator must return an object");
      return r;
    },
    IteratorNext: function IteratorNext(e, t) {
      var a = this.Invoke(e, "next", arguments.length < 2 ? [] : [t]);
      if ("Object" !== this.Type(a)) throw new i("iterator next must return an object");
      return a;
    },
    IteratorComplete: function IteratorComplete(e) {
      if ("Object" !== this.Type(e)) throw new i("Assertion failed: Type(iterResult) is not Object");
      return this.ToBoolean(this.Get(e, "done"));
    },
    IteratorValue: function IteratorValue(e) {
      if ("Object" !== this.Type(e)) throw new i("Assertion failed: Type(iterResult) is not Object");
      return this.Get(e, "value");
    },
    IteratorStep: function IteratorStep(e) {
      var t = this.IteratorNext(e);
      return !0 !== this.IteratorComplete(t) && t;
    },
    IteratorClose: function IteratorClose(e, t) {
      if ("Object" !== this.Type(e)) throw new i("Assertion failed: Type(iterator) is not Object");
      if (!this.IsCallable(t)) throw new i("Assertion failed: completion is not a thunk for a Completion Record");
      var a,
          r = t,
          n = this.GetMethod(e, "return");
      if (void 0 === n) return r();

      try {
        var s = this.Call(n, e, []);
      } catch (e) {
        throw a = r(), r = null, e;
      }

      if (a = r(), r = null, "Object" !== this.Type(s)) throw new i("iterator .return must return an object");
      return a;
    },
    CreateIterResultObject: function CreateIterResultObject(e, t) {
      if ("Boolean" !== this.Type(t)) throw new i("Assertion failed: Type(done) is not Boolean");
      return {
        value: e,
        done: t
      };
    },
    RegExpExec: function RegExpExec(e, t) {
      if ("Object" !== this.Type(e)) throw new i("R must be an Object");
      if ("String" !== this.Type(t)) throw new i("S must be a String");
      var a = this.Get(e, "exec");

      if (this.IsCallable(a)) {
        var r = this.Call(a, e, [t]);
        if (null === r || "Object" === this.Type(r)) return r;
        throw new i('"exec" method must return `null` or an Object');
      }

      return k(e, t);
    },
    ArraySpeciesCreate: function ArraySpeciesCreate(e, t) {
      if (!this.IsInteger(t) || t < 0) throw new i("Assertion failed: length must be an integer >= 0");
      var a,
          r = 0 === t ? 0 : t;
      if (this.IsArray(e) && (a = this.Get(e, "constructor"), "Object" === this.Type(a) && b && h.species && null === (a = this.Get(a, h.species)) && (a = void 0)), void 0 === a) return u(r);
      if (!this.IsConstructor(a)) throw new i("C must be a constructor");
      return new a(r);
    },
    CreateDataProperty: function CreateDataProperty(e, t, a) {
      if ("Object" !== this.Type(e)) throw new i("Assertion failed: Type(O) is not Object");
      if (!this.IsPropertyKey(t)) throw new i("Assertion failed: IsPropertyKey(P) is not true");
      var r = U(e, t),
          n = r || "function" != typeof H || H(e);
      return !(!(!r || r.writable && r.configurable) || !n) && (z(e, t, {
        configurable: !0,
        enumerable: !0,
        value: a,
        writable: !0
      }), !0);
    },
    CreateDataPropertyOrThrow: function CreateDataPropertyOrThrow(e, t, a) {
      if ("Object" !== this.Type(e)) throw new i("Assertion failed: Type(O) is not Object");
      if (!this.IsPropertyKey(t)) throw new i("Assertion failed: IsPropertyKey(P) is not true");
      var r = this.CreateDataProperty(e, t, a);
      if (!r) throw new i("unable to create data property");
      return r;
    },
    ObjectCreate: function ObjectCreate(e, t) {
      if (null !== e && "Object" !== this.Type(e)) throw new i("Assertion failed: proto must be null or an object");
      var a = arguments.length < 2 ? [] : t;
      if (a.length > 0) throw new c("es-abstract does not yet support internal slots");
      if (null === e && !V) throw new c("native Object.create support is required to create null objects");
      return V(e);
    },
    AdvanceStringIndex: function AdvanceStringIndex(e, t, a) {
      if ("String" !== this.Type(e)) throw new i("S must be a String");
      if (!this.IsInteger(t) || t < 0 || t > _) throw new i("Assertion failed: length must be an integer >= 0 and <= 2**53");
      if ("Boolean" !== this.Type(a)) throw new i("Assertion failed: unicode must be a Boolean");
      if (!a) return t + 1;
      if (t + 1 >= e.length) return t + 1;
      var r = N(e, t);
      if (r < 55296 || r > 56319) return t + 1;
      var n = N(e, t + 1);
      return n < 56320 || n > 57343 ? t + 1 : t + 2;
    },
    CreateMethodProperty: function CreateMethodProperty(e, t, a) {
      if ("Object" !== this.Type(e)) throw new i("Assertion failed: Type(O) is not Object");
      if (!this.IsPropertyKey(t)) throw new i("Assertion failed: IsPropertyKey(P) is not true");
      return !!z(e, t, {
        configurable: !0,
        enumerable: !1,
        value: a,
        writable: !0
      });
    },
    DefinePropertyOrThrow: function DefinePropertyOrThrow(e, t, a) {
      if ("Object" !== this.Type(e)) throw new i("Assertion failed: Type(O) is not Object");
      if (!this.IsPropertyKey(t)) throw new i("Assertion failed: IsPropertyKey(P) is not true");
      return !!z(e, t, a);
    },
    DeletePropertyOrThrow: function DeletePropertyOrThrow(e, t) {
      if ("Object" !== this.Type(e)) throw new i("Assertion failed: Type(O) is not Object");
      if (!this.IsPropertyKey(t)) throw new i("Assertion failed: IsPropertyKey(P) is not true");
      var a = delete e[t];
      if (!a) throw new TypeError("Attempt to delete property failed.");
      return a;
    },
    EnumerableOwnNames: function EnumerableOwnNames(e) {
      if ("Object" !== this.Type(e)) throw new i("Assertion failed: Type(O) is not Object");
      return s(e);
    },
    thisNumberValue: function thisNumberValue(e) {
      return "Number" === this.Type(e) ? e : P(e);
    },
    thisBooleanValue: function thisBooleanValue(e) {
      return "Boolean" === this.Type(e) ? e : L(e);
    },
    thisStringValue: function thisStringValue(e) {
      return "String" === this.Type(e) ? e : O(e);
    },
    thisTimeValue: function thisTimeValue(e) {
      return F(e);
    }
  });

  delete X.CheckObjectCoercible, e.exports = X;
},
/*!******************************************************!*\
  !*** ./node_modules/function-bind/implementation.js ***!
  \******************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = "Function.prototype.bind called on incompatible ",
      n = Array.prototype.slice,
      s = Object.prototype.toString;

  e.exports = function (e) {
    var t = this;
    if ("function" != typeof t || "[object Function]" !== s.call(t)) throw new TypeError(r + t);

    for (var a, o = n.call(arguments, 1), i = function i() {
      if (this instanceof a) {
        var r = t.apply(this, o.concat(n.call(arguments)));
        return Object(r) === r ? r : this;
      }

      return t.apply(e, o.concat(n.call(arguments)));
    }, c = Math.max(0, t.length - o.length), u = [], d = 0; d < c; d++) {
      u.push("$" + d);
    }

    if (a = Function("binder", "return function (" + u.join(",") + "){ return binder.apply(this,arguments); }")(i), t.prototype) {
      var f = function f() {};

      f.prototype = t.prototype, a.prototype = new f(), f.prototype = null;
    }

    return a;
  };
},
/*!*********************************************!*\
  !*** ./node_modules/es-to-primitive/es6.js ***!
  \*********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  e.exports = a(
  /*! ./es2015 */
  649);
},
/*!************************************************!*\
  !*** ./node_modules/es-to-primitive/es2015.js ***!
  \************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator,
      n = a(
  /*! ./helpers/isPrimitive */
  236),
      s = a(
  /*! is-callable */
  133),
      o = a(
  /*! is-date-object */
  650),
      i = a(
  /*! is-symbol */
  651),
      c = function c(e, t) {
    if (null == e) throw new TypeError("Cannot call method on " + e);
    if ("string" != typeof t || "number" !== t && "string" !== t) throw new TypeError('hint must be "string" or "number"');
    var a,
        r,
        o,
        i = "string" === t ? ["toString", "valueOf"] : ["valueOf", "toString"];

    for (o = 0; o < i.length; ++o) {
      if (a = e[i[o]], s(a) && (r = a.call(e), n(r))) return r;
    }

    throw new TypeError("No default value");
  },
      u = function u(e, t) {
    var a = e[t];

    if (null != a) {
      if (!s(a)) throw new TypeError(a + " returned for property " + t + " of object " + e + " is not a function");
      return a;
    }
  };

  e.exports = function (e) {
    if (n(e)) return e;
    var t,
        a = "default";

    if (arguments.length > 1 && (arguments[1] === String ? a = "string" : arguments[1] === Number && (a = "number")), r && (Symbol.toPrimitive ? t = u(e, Symbol.toPrimitive) : i(e) && (t = Symbol.prototype.valueOf)), void 0 !== t) {
      var s = t.call(e, a);
      if (n(s)) return s;
      throw new TypeError("unable to convert exotic object to primitive");
    }

    return "default" === a && (o(e) || i(e)) && (a = "string"), c(e, "default" === a ? "number" : a);
  };
},
/*!**********************************************!*\
  !*** ./node_modules/is-date-object/index.js ***!
  \**********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = Date.prototype.getDay,
      n = Object.prototype.toString,
      s = "function" == typeof Symbol && "symbol" == typeof Symbol.toStringTag;

  e.exports = function (e) {
    return "object" == typeof e && null !== e && (s ? function (e) {
      try {
        return r.call(e), !0;
      } catch (e) {
        return !1;
      }
    }(e) : "[object Date]" === n.call(e));
  };
},
/*!*****************************************!*\
  !*** ./node_modules/is-symbol/index.js ***!
  \*****************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = Object.prototype.toString;

  if (a(
  /*! has-symbols */
  652)()) {
    var n = Symbol.prototype.toString,
        s = /^Symbol\(.*\)$/;

    e.exports = function (e) {
      if ("symbol" == typeof e) return !0;
      if ("[object Symbol]" !== r.call(e)) return !1;

      try {
        return function (e) {
          return "symbol" == typeof e.valueOf() && s.test(n.call(e));
        }(e);
      } catch (e) {
        return !1;
      }
    };
  } else e.exports = function (e) {
    return !1;
  };
},
/*!*******************************************!*\
  !*** ./node_modules/has-symbols/index.js ***!
  \*******************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (t) {
    var r = t.Symbol,
        n = a(
    /*! ./shams */
    653);

    e.exports = function () {
      return "function" == typeof r && "function" == typeof Symbol && "symbol" == typeof r("foo") && "symbol" == typeof Symbol("bar") && n();
    };
  }).call(this, a(
  /*! ./../webpack/buildin/global.js */
  18));
},
/*!*******************************************!*\
  !*** ./node_modules/has-symbols/shams.js ***!
  \*******************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  e.exports = function () {
    if ("function" != typeof Symbol || "function" != typeof Object.getOwnPropertySymbols) return !1;
    if ("symbol" == typeof Symbol.iterator) return !0;
    var e = {},
        t = Symbol("test"),
        a = Object(t);
    if ("string" == typeof t) return !1;
    if ("[object Symbol]" !== Object.prototype.toString.call(t)) return !1;
    if ("[object Symbol]" !== Object.prototype.toString.call(a)) return !1;

    for (t in e[t] = 42, e) {
      return !1;
    }

    if ("function" == typeof Object.keys && 0 !== Object.keys(e).length) return !1;
    if ("function" == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(e).length) return !1;
    var r = Object.getOwnPropertySymbols(e);
    if (1 !== r.length || r[0] !== t) return !1;
    if (!Object.prototype.propertyIsEnumerable.call(e, t)) return !1;

    if ("function" == typeof Object.getOwnPropertyDescriptor) {
      var n = Object.getOwnPropertyDescriptor(e, t);
      if (42 !== n.value || !0 !== n.enumerable) return !1;
    }

    return !0;
  };
},
/*!*********************************************************!*\
  !*** ./node_modules/es-abstract/helpers/isPrimitive.js ***!
  \*********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = function (e) {
    return null === e || "function" != typeof e && "object" != typeof e;
  };
},
/*!*****************************************!*\
  !*** ./node_modules/es-abstract/es5.js ***!
  \*****************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ./GetIntrinsic */
  134),
      n = r("%Object%"),
      s = r("%TypeError%"),
      o = r("%String%"),
      i = a(
  /*! ./helpers/assertRecord */
  237),
      c = a(
  /*! ./helpers/isNaN */
  238),
      u = a(
  /*! ./helpers/isFinite */
  239),
      d = a(
  /*! ./helpers/sign */
  241),
      f = a(
  /*! ./helpers/mod */
  242),
      l = a(
  /*! is-callable */
  133),
      h = a(
  /*! es-to-primitive/es5 */
  656),
      p = a(
  /*! has */
  89),
      b = {
    ToPrimitive: h,
    ToBoolean: function ToBoolean(e) {
      return !!e;
    },
    ToNumber: function ToNumber(e) {
      return +e;
    },
    ToInteger: function ToInteger(e) {
      var t = this.ToNumber(e);
      return c(t) ? 0 : 0 !== t && u(t) ? d(t) * Math.floor(Math.abs(t)) : t;
    },
    ToInt32: function ToInt32(e) {
      return this.ToNumber(e) >> 0;
    },
    ToUint32: function ToUint32(e) {
      return this.ToNumber(e) >>> 0;
    },
    ToUint16: function ToUint16(e) {
      var t = this.ToNumber(e);
      if (c(t) || 0 === t || !u(t)) return 0;
      var a = d(t) * Math.floor(Math.abs(t));
      return f(a, 65536);
    },
    ToString: function ToString(e) {
      return o(e);
    },
    ToObject: function ToObject(e) {
      return this.CheckObjectCoercible(e), n(e);
    },
    CheckObjectCoercible: function CheckObjectCoercible(e, t) {
      if (null == e) throw new s(t || "Cannot call method on " + e);
      return e;
    },
    IsCallable: l,
    SameValue: function SameValue(e, t) {
      return e === t ? 0 !== e || 1 / e == 1 / t : c(e) && c(t);
    },
    Type: function Type(e) {
      return null === e ? "Null" : void 0 === e ? "Undefined" : "function" == typeof e || "object" == typeof e ? "Object" : "number" == typeof e ? "Number" : "boolean" == typeof e ? "Boolean" : "string" == typeof e ? "String" : void 0;
    },
    IsPropertyDescriptor: function IsPropertyDescriptor(e) {
      if ("Object" !== this.Type(e)) return !1;
      var t = {
        "[[Configurable]]": !0,
        "[[Enumerable]]": !0,
        "[[Get]]": !0,
        "[[Set]]": !0,
        "[[Value]]": !0,
        "[[Writable]]": !0
      };

      for (var a in e) {
        if (p(e, a) && !t[a]) return !1;
      }

      var r = p(e, "[[Value]]"),
          n = p(e, "[[Get]]") || p(e, "[[Set]]");
      if (r && n) throw new s("Property Descriptors may not be both accessor and data descriptors");
      return !0;
    },
    IsAccessorDescriptor: function IsAccessorDescriptor(e) {
      return void 0 !== e && (i(this, "Property Descriptor", "Desc", e), !(!p(e, "[[Get]]") && !p(e, "[[Set]]")));
    },
    IsDataDescriptor: function IsDataDescriptor(e) {
      return void 0 !== e && (i(this, "Property Descriptor", "Desc", e), !(!p(e, "[[Value]]") && !p(e, "[[Writable]]")));
    },
    IsGenericDescriptor: function IsGenericDescriptor(e) {
      return void 0 !== e && (i(this, "Property Descriptor", "Desc", e), !this.IsAccessorDescriptor(e) && !this.IsDataDescriptor(e));
    },
    FromPropertyDescriptor: function FromPropertyDescriptor(e) {
      if (void 0 === e) return e;
      if (i(this, "Property Descriptor", "Desc", e), this.IsDataDescriptor(e)) return {
        value: e["[[Value]]"],
        writable: !!e["[[Writable]]"],
        enumerable: !!e["[[Enumerable]]"],
        configurable: !!e["[[Configurable]]"]
      };
      if (this.IsAccessorDescriptor(e)) return {
        get: e["[[Get]]"],
        set: e["[[Set]]"],
        enumerable: !!e["[[Enumerable]]"],
        configurable: !!e["[[Configurable]]"]
      };
      throw new s("FromPropertyDescriptor must be called with a fully populated Property Descriptor");
    },
    ToPropertyDescriptor: function ToPropertyDescriptor(e) {
      if ("Object" !== this.Type(e)) throw new s("ToPropertyDescriptor requires an object");
      var t = {};

      if (p(e, "enumerable") && (t["[[Enumerable]]"] = this.ToBoolean(e.enumerable)), p(e, "configurable") && (t["[[Configurable]]"] = this.ToBoolean(e.configurable)), p(e, "value") && (t["[[Value]]"] = e.value), p(e, "writable") && (t["[[Writable]]"] = this.ToBoolean(e.writable)), p(e, "get")) {
        var a = e.get;
        if (void 0 !== a && !this.IsCallable(a)) throw new TypeError("getter must be a function");
        t["[[Get]]"] = a;
      }

      if (p(e, "set")) {
        var r = e.set;
        if (void 0 !== r && !this.IsCallable(r)) throw new s("setter must be a function");
        t["[[Set]]"] = r;
      }

      if ((p(t, "[[Get]]") || p(t, "[[Set]]")) && (p(t, "[[Value]]") || p(t, "[[Writable]]"))) throw new s("Invalid property descriptor. Cannot both specify accessors and a value or writable attribute");
      return t;
    }
  };
  e.exports = b;
},
/*!*********************************************!*\
  !*** ./node_modules/es-to-primitive/es5.js ***!
  \*********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = Object.prototype.toString,
      n = a(
  /*! ./helpers/isPrimitive */
  236),
      s = a(
  /*! is-callable */
  133),
      o = function o(e) {
    var t;

    if ((t = arguments.length > 1 ? arguments[1] : "[object Date]" === r.call(e) ? String : Number) === String || t === Number) {
      var a,
          o,
          i = t === String ? ["toString", "valueOf"] : ["valueOf", "toString"];

      for (o = 0; o < i.length; ++o) {
        if (s(e[i[o]]) && (a = e[i[o]](), n(a))) return a;
      }

      throw new TypeError("No default value");
    }

    throw new TypeError("invalid [[DefaultValue]] hint supplied");
  };

  e.exports = function (e) {
    return n(e) ? e : arguments.length > 1 ? o(e, arguments[1]) : o(e);
  };
},
/*!****************************************!*\
  !*** ./node_modules/is-regex/index.js ***!
  \****************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! has */
  89),
      n = RegExp.prototype.exec,
      s = Object.getOwnPropertyDescriptor,
      o = Object.prototype.toString,
      i = "function" == typeof Symbol && "symbol" == typeof Symbol.toStringTag;

  e.exports = function (e) {
    if (!e || "object" != typeof e) return !1;
    if (!i) return "[object RegExp]" === o.call(e);
    var t = s(e, "lastIndex");
    return !(!t || !r(t, "value")) && function (e) {
      try {
        var t = e.lastIndex;
        return e.lastIndex = 0, n.call(e), !0;
      } catch (e) {
        return !1;
      } finally {
        e.lastIndex = t;
      }
    }(e);
  };
},
/*!***************************************************************!*\
  !*** ./node_modules/object.getownpropertydescriptors/shim.js ***!
  \***************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! ./polyfill */
  243),
      n = a(
  /*! define-properties */
  131);

  e.exports = function () {
    var e = r();
    return n(Object, {
      getOwnPropertyDescriptors: e
    }, {
      getOwnPropertyDescriptors: function getOwnPropertyDescriptors() {
        return Object.getOwnPropertyDescriptors !== e;
      }
    }), e;
  };
},
/*!*********************************************!*\
  !*** ./node_modules/util.promisify/shim.js ***!
  \*********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! util */
  23),
      n = a(
  /*! ./polyfill */
  244);

  e.exports = function () {
    var e = n();
    return e !== r.promisify && (r.promisify = e, Object.defineProperty(r, "promisify", {
      value: e
    })), e;
  };
},
/*!*************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-vm/dist/evm/precompiles/index.js ***!
  \*************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = a(
  /*! ./01-ecrecover */
  661),
      n = a(
  /*! ./02-sha256 */
  662),
      s = a(
  /*! ./03-ripemd160 */
  663),
      o = a(
  /*! ./04-identity */
  664),
      i = a(
  /*! ./05-modexp */
  665),
      c = a(
  /*! ./06-ecadd */
  666),
      u = a(
  /*! ./07-ecmul */
  713),
      d = a(
  /*! ./08-ecpairing */
  714),
      f = a(
  /*! ./09-blake2f */
  715),
      l = {
    "0000000000000000000000000000000000000001": r.default,
    "0000000000000000000000000000000000000002": n.default,
    "0000000000000000000000000000000000000003": s.default,
    "0000000000000000000000000000000000000004": o.default,
    "0000000000000000000000000000000000000005": i.default,
    "0000000000000000000000000000000000000006": c.default,
    "0000000000000000000000000000000000000007": u.default,
    "0000000000000000000000000000000000000008": d.default,
    "0000000000000000000000000000000000000009": f.default
  };
  t.precompiles = l, t.getPrecompile = function (e) {
    return l[e];
  };
},
/*!********************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-vm/dist/evm/precompiles/01-ecrecover.js ***!
  \********************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = a(
    /*! bn.js */
    5),
        n = a(
    /*! ethereumjs-util */
    29),
        s = a(
    /*! ../evm */
    32),
        o = a(
    /*! assert */
    19);

    t.default = function (t) {
      o(t.data);
      var a = new r(t._common.param("gasPrices", "ecRecover"));
      if (t.gasLimit.lt(a)) return s.OOGResult(t.gasLimit);
      var i,
          c = n.setLengthRight(t.data, 128),
          u = c.slice(0, 32),
          d = c.slice(32, 64),
          f = c.slice(64, 96),
          l = c.slice(96, 128);

      try {
        i = n.ecrecover(u, new r(d).toNumber(), f, l);
      } catch (t) {
        return {
          gasUsed: a,
          returnValue: e.alloc(0)
        };
      }

      return {
        gasUsed: a,
        returnValue: n.setLengthLeft(n.publicToAddress(i), 32)
      };
    };
  }).call(this, a(
  /*! ./../../../../../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!*****************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-vm/dist/evm/precompiles/02-sha256.js ***!
  \*****************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = a(
  /*! bn.js */
  5),
      n = a(
  /*! ethereumjs-util */
  29),
      s = a(
  /*! ../evm */
  32),
      o = a(
  /*! assert */
  19);

  t.default = function (e) {
    o(e.data);
    var t = e.data,
        a = new r(e._common.param("gasPrices", "sha256"));
    return a.iadd(new r(e._common.param("gasPrices", "sha256Word")).imuln(Math.ceil(t.length / 32))), e.gasLimit.lt(a) ? s.OOGResult(e.gasLimit) : {
      gasUsed: a,
      returnValue: n.sha256(t)
    };
  };
},
/*!********************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-vm/dist/evm/precompiles/03-ripemd160.js ***!
  \********************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = a(
  /*! bn.js */
  5),
      n = a(
  /*! ethereumjs-util */
  29),
      s = a(
  /*! ../evm */
  32),
      o = a(
  /*! assert */
  19);

  t.default = function (e) {
    o(e.data);
    var t = e.data,
        a = new r(e._common.param("gasPrices", "ripemd160"));
    return a.iadd(new r(e._common.param("gasPrices", "ripemd160Word")).imuln(Math.ceil(t.length / 32))), e.gasLimit.lt(a) ? s.OOGResult(e.gasLimit) : {
      gasUsed: a,
      returnValue: n.ripemd160(t, !0)
    };
  };
},
/*!*******************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-vm/dist/evm/precompiles/04-identity.js ***!
  \*******************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = a(
  /*! bn.js */
  5),
      n = a(
  /*! ../evm */
  32),
      s = a(
  /*! assert */
  19);

  t.default = function (e) {
    s(e.data);
    var t = e.data,
        a = new r(e._common.param("gasPrices", "identity"));
    return a.iadd(new r(e._common.param("gasPrices", "identityWord")).imuln(Math.ceil(t.length / 32))), e.gasLimit.lt(a) ? n.OOGResult(e.gasLimit) : {
      gasUsed: a,
      returnValue: t
    };
  };
},
/*!*****************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-vm/dist/evm/precompiles/05-modexp.js ***!
  \*****************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = a(
    /*! bn.js */
    5),
        n = a(
    /*! ethereumjs-util */
    29),
        s = a(
    /*! ../evm */
    32),
        o = a(
    /*! assert */
    19);

    t.default = function (t) {
      o(t.data);

      var a = t.data,
          i = function (t) {
        var a;

        try {
          a = 96 + new r(t.slice(0, 32)).toNumber();
        } catch (e) {
          a = Number.MAX_SAFE_INTEGER - 32;
        }

        var s = new r(t.slice(32, 64)),
            o = e.from(t.slice(a, a + 32));
        o = n.setLengthRight(o, 32);
        var i = new r(o),
            c = 0;
        s.ltn(32) && (c = 32 - s.toNumber()), i = i.shrn(8 * Math.max(c, 0));

        for (var u = -1; i.gtn(0);) {
          u += 1, i = i.ushrn(1);
        }

        var d = s.subn(32);
        d.ltn(0) && (d = new r(0));
        var f = d.muln(8);
        return u > 0 && f.iaddn(u), f;
      }(a);

      i.ltn(1) && (i = new r(1));
      var c = new r(a.slice(0, 32)),
          u = new r(a.slice(32, 64)),
          d = new r(a.slice(64, 96)),
          f = c;
      f.lt(d) && (f = d);

      var l,
          h,
          p,
          b = t._common.param("gasPrices", "modexpGquaddivisor"),
          m = i.mul((l = f, l.lten(64) ? l.sqr() : l.lten(1024) ? (h = l.sqr().divn(4), p = l.muln(96), h.add(p).subn(3072)) : (h = l.sqr().divn(16), p = l.muln(480), h.add(p).subn(199680)))).divn(b);

      if (t.gasLimit.lt(m)) return s.OOGResult(t.gasLimit);
      if (c.isZero()) return {
        gasUsed: m,
        returnValue: new r(0).toArrayLike(e, "be", 1)
      };
      if (d.isZero()) return {
        gasUsed: m,
        returnValue: e.alloc(0)
      };
      var y = new r(Number.MAX_SAFE_INTEGER),
          v = new r(2147483647);
      if (c.gt(v) || u.gt(v) || d.gt(v)) return s.OOGResult(t.gasLimit);

      var _ = new r(96),
          g = _.add(c),
          A = g,
          w = A.add(u),
          T = w,
          x = T.add(d);

      if (x.gt(y)) return s.OOGResult(t.gasLimit);
      var D = new r(n.setLengthRight(a.slice(_.toNumber(), g.toNumber()), c.toNumber())),
          C = new r(n.setLengthRight(a.slice(A.toNumber(), w.toNumber()), u.toNumber())),
          S = new r(n.setLengthRight(a.slice(T.toNumber(), x.toNumber()), d.toNumber()));
      return {
        gasUsed: m,
        returnValue: (S.isZero() ? new r(0) : function (e, t, a) {
          if (t.isZero()) return new r(1).mod(a);
          if (a.lten(1)) return new r(0);
          var n = r.red(a);
          return e.toRed(n).redPow(t).fromRed();
        }(D, C, S)).toArrayLike(e, "be", d.toNumber())
      };
    };
  }).call(this, a(
  /*! ./../../../../../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!****************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-vm/dist/evm/precompiles/06-ecadd.js ***!
  \****************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = a(
  /*! bn.js */
  5),
      n = a(
  /*! ../evm */
  32),
      s = a(
  /*! assert */
  19),
      o = a(
  /*! rustbn.js */
  135);

  t.default = function (e) {
    s(e.data);
    var t = e.data,
        a = new r(e._common.param("gasPrices", "ecAdd"));
    if (e.gasLimit.lt(a)) return n.OOGResult(e.gasLimit);
    var i = o.add(t);
    return 64 !== i.length ? n.OOGResult(e.gasLimit) : {
      gasUsed: a,
      returnValue: i
    };
  };
},
/*!*************************************************!*\
  !*** ./node_modules/rustbn.js/lib/index.asm.js ***!
  \*************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (module, exports, __webpack_require__) {
  (function (process, Buffer) {
    var Module;
    Module || (Module = (void 0 !== Module ? Module : null) || {});
    var moduleOverrides = {};

    for (var key in Module) {
      Module.hasOwnProperty(key) && (moduleOverrides[key] = Module[key]);
    }

    var ENVIRONMENT_IS_WEB = !1,
        ENVIRONMENT_IS_WORKER = !1,
        ENVIRONMENT_IS_NODE = !1,
        ENVIRONMENT_IS_SHELL = !1,
        nodeFS,
        nodePath;
    if (Module.ENVIRONMENT) {
      if ("WEB" === Module.ENVIRONMENT) ENVIRONMENT_IS_WEB = !0;else if ("WORKER" === Module.ENVIRONMENT) ENVIRONMENT_IS_WORKER = !0;else if ("NODE" === Module.ENVIRONMENT) ENVIRONMENT_IS_NODE = !0;else {
        if ("SHELL" !== Module.ENVIRONMENT) throw new Error("The provided Module['ENVIRONMENT'] value is not valid. It must be one of: WEB|WORKER|NODE|SHELL.");
        ENVIRONMENT_IS_SHELL = !0;
      }
    } else ENVIRONMENT_IS_WEB = "object" == typeof window, ENVIRONMENT_IS_WORKER = "function" == typeof importScripts, ENVIRONMENT_IS_NODE = "object" == typeof process && !ENVIRONMENT_IS_WEB && !ENVIRONMENT_IS_WORKER, ENVIRONMENT_IS_SHELL = !ENVIRONMENT_IS_WEB && !ENVIRONMENT_IS_NODE && !ENVIRONMENT_IS_WORKER;
    if (ENVIRONMENT_IS_NODE) Module.print || (Module.print = console.log), Module.printErr || (Module.printErr = console.warn), Module.read = function (e, t) {
      var a;
      return (a = tryParseAsDataURI(e)) || (nodeFS || (nodeFS = __webpack_require__(
      /*! fs */
      245)), nodePath || (nodePath = __webpack_require__(
      /*! path */
      246)), e = nodePath.normalize(e), a = nodeFS.readFileSync(e)), t ? a : a.toString();
    }, Module.readBinary = function (e) {
      var t = Module.read(e, !0);
      return t.buffer || (t = new Uint8Array(t)), assert(t.buffer), t;
    }, Module.load = function (e) {
      globalEval(read(e));
    }, Module.thisProgram || (process.argv.length > 1 ? Module.thisProgram = process.argv[1].replace(/\\/g, "/") : Module.thisProgram = "unknown-program"), Module.arguments = process.argv.slice(2), module.exports = Module, Module.inspect = function () {
      return "[Emscripten Module object]";
    };else if (ENVIRONMENT_IS_SHELL) Module.print || (Module.print = print), "undefined" != typeof printErr && (Module.printErr = printErr), "undefined" != typeof read ? Module.read = function (e) {
      var t = tryParseAsDataURI(e);
      return t ? intArrayToString(t) : read(e);
    } : Module.read = function () {
      throw "no read() available";
    }, Module.readBinary = function (e) {
      var t;
      return (t = tryParseAsDataURI(e)) ? t : "function" == typeof readbuffer ? new Uint8Array(readbuffer(e)) : (assert("object" == typeof (t = read(e, "binary"))), t);
    }, "undefined" != typeof scriptArgs ? Module.arguments = scriptArgs : void 0 !== arguments && (Module.arguments = arguments), "function" == typeof quit && (Module.quit = function (e, t) {
      quit(e);
    });else {
      if (!ENVIRONMENT_IS_WEB && !ENVIRONMENT_IS_WORKER) throw new Error("Unknown runtime environment. Where are we?");
      if (Module.read = function (e) {
        try {
          var t = new XMLHttpRequest();
          return t.open("GET", e, !1), t.send(null), t.responseText;
        } catch (t) {
          var a = tryParseAsDataURI(e);
          if (a) return intArrayToString(a);
          throw t;
        }
      }, ENVIRONMENT_IS_WORKER && (Module.readBinary = function (e) {
        try {
          var t = new XMLHttpRequest();
          return t.open("GET", e, !1), t.responseType = "arraybuffer", t.send(null), new Uint8Array(t.response);
        } catch (e) {
          var a = tryParseAsDataURI(f);
          if (a) return a;
          throw e;
        }
      }), Module.readAsync = function (e, t, a) {
        var r = new XMLHttpRequest();
        r.open("GET", e, !0), r.responseType = "arraybuffer", r.onload = function () {
          if (200 == r.status || 0 == r.status && r.response) t(r.response);else {
            var n = tryParseAsDataURI(e);
            n ? t(n.buffer) : a();
          }
        }, r.onerror = a, r.send(null);
      }, void 0 !== arguments && (Module.arguments = arguments), "undefined" != typeof console) Module.print || (Module.print = function (e) {
        console.log(e);
      }), Module.printErr || (Module.printErr = function (e) {
        console.warn(e);
      });else {
        var TRY_USE_DUMP = !1;
        Module.print || (Module.print = TRY_USE_DUMP && "undefined" != typeof dump ? function (e) {
          dump(e);
        } : function (e) {});
      }
      ENVIRONMENT_IS_WORKER && (Module.load = importScripts), void 0 === Module.setWindowTitle && (Module.setWindowTitle = function (e) {
        document.title = e;
      });
    }

    function globalEval(e) {
      eval.call(null, e);
    }

    for (var key in !Module.load && Module.read && (Module.load = function (e) {
      globalEval(Module.read(e));
    }), Module.print || (Module.print = function () {}), Module.printErr || (Module.printErr = Module.print), Module.arguments || (Module.arguments = []), Module.thisProgram || (Module.thisProgram = "./this.program"), Module.quit || (Module.quit = function (e, t) {
      throw t;
    }), Module.print = Module.print, Module.printErr = Module.printErr, Module.preRun = [], Module.postRun = [], moduleOverrides) {
      moduleOverrides.hasOwnProperty(key) && (Module[key] = moduleOverrides[key]);
    }

    moduleOverrides = void 0;
    var Runtime = {
      setTempRet0: function setTempRet0(e) {
        return tempRet0 = e, e;
      },
      getTempRet0: function getTempRet0() {
        return tempRet0;
      },
      stackSave: function stackSave() {
        return STACKTOP;
      },
      stackRestore: function stackRestore(e) {
        STACKTOP = e;
      },
      getNativeTypeSize: function getNativeTypeSize(e) {
        switch (e) {
          case "i1":
          case "i8":
            return 1;

          case "i16":
            return 2;

          case "i32":
            return 4;

          case "i64":
            return 8;

          case "float":
            return 4;

          case "double":
            return 8;

          default:
            if ("*" === e[e.length - 1]) return Runtime.QUANTUM_SIZE;

            if ("i" === e[0]) {
              var t = parseInt(e.substr(1));
              return assert(t % 8 == 0), t / 8;
            }

            return 0;
        }
      },
      getNativeFieldSize: function getNativeFieldSize(e) {
        return Math.max(Runtime.getNativeTypeSize(e), Runtime.QUANTUM_SIZE);
      },
      STACK_ALIGN: 16,
      prepVararg: function prepVararg(e, t) {
        return "double" === t || "i64" === t ? 7 & e && (assert(4 == (7 & e)), e += 4) : assert(0 == (3 & e)), e;
      },
      getAlignSize: function getAlignSize(e, t, a) {
        return a || "i64" != e && "double" != e ? e ? Math.min(t || (e ? Runtime.getNativeFieldSize(e) : 0), Runtime.QUANTUM_SIZE) : Math.min(t, 8) : 8;
      },
      dynCall: function dynCall(e, t, a) {
        return a && a.length ? Module["dynCall_" + e].apply(null, [t].concat(a)) : Module["dynCall_" + e].call(null, t);
      },
      functionPointers: [],
      addFunction: function addFunction(e) {
        for (var t = 0; t < Runtime.functionPointers.length; t++) {
          if (!Runtime.functionPointers[t]) return Runtime.functionPointers[t] = e, 2 * (1 + t);
        }

        throw "Finished up all reserved function pointers. Use a higher value for RESERVED_FUNCTION_POINTERS.";
      },
      removeFunction: function removeFunction(e) {
        Runtime.functionPointers[(e - 2) / 2] = null;
      },
      warnOnce: function warnOnce(e) {
        Runtime.warnOnce.shown || (Runtime.warnOnce.shown = {}), Runtime.warnOnce.shown[e] || (Runtime.warnOnce.shown[e] = 1, Module.printErr(e));
      },
      funcWrappers: {},
      getFuncWrapper: function getFuncWrapper(e, t) {
        if (e) {
          assert(t), Runtime.funcWrappers[t] || (Runtime.funcWrappers[t] = {});
          var a = Runtime.funcWrappers[t];
          return a[e] || (1 === t.length ? a[e] = function () {
            return Runtime.dynCall(t, e);
          } : 2 === t.length ? a[e] = function (a) {
            return Runtime.dynCall(t, e, [a]);
          } : a[e] = function () {
            return Runtime.dynCall(t, e, Array.prototype.slice.call(arguments));
          }), a[e];
        }
      },
      getCompilerSetting: function getCompilerSetting(e) {
        throw "You must build with -s RETAIN_COMPILER_SETTINGS=1 for Runtime.getCompilerSetting or emscripten_get_compiler_setting to work";
      },
      stackAlloc: function stackAlloc(e) {
        var t = STACKTOP;
        return STACKTOP = (STACKTOP = STACKTOP + e | 0) + 15 & -16, t;
      },
      staticAlloc: function staticAlloc(e) {
        var t = STATICTOP;
        return STATICTOP = (STATICTOP = STATICTOP + e | 0) + 15 & -16, t;
      },
      dynamicAlloc: function dynamicAlloc(e) {
        var t = HEAP32[DYNAMICTOP_PTR >> 2],
            a = -16 & (t + e + 15 | 0);
        if ((HEAP32[DYNAMICTOP_PTR >> 2] = a, a >= TOTAL_MEMORY) && !enlargeMemory()) return HEAP32[DYNAMICTOP_PTR >> 2] = t, 0;
        return t;
      },
      alignMemory: function alignMemory(e, t) {
        return e = Math.ceil(e / (t || 16)) * (t || 16);
      },
      makeBigInt: function makeBigInt(e, t, a) {
        return a ? +(e >>> 0) + 4294967296 * +(t >>> 0) : +(e >>> 0) + 4294967296 * +(0 | t);
      },
      GLOBAL_BASE: 8,
      QUANTUM_SIZE: 4,
      __dummy__: 0
    };
    Module.Runtime = Runtime;
    var ABORT = 0,
        EXITSTATUS = 0,
        cwrap,
        ccall;

    function assert(e, t) {
      e || abort("Assertion failed: " + t);
    }

    function getCFunc(ident) {
      var func = Module["_" + ident];
      if (!func) try {
        func = eval("_" + ident);
      } catch (e) {}
      return assert(func, "Cannot call unknown function " + ident + " (perhaps LLVM optimizations or closure removed it?)"), func;
    }

    function setValue(e, t, a, r) {
      switch ("*" === (a = a || "i8").charAt(a.length - 1) && (a = "i32"), a) {
        case "i1":
        case "i8":
          HEAP8[e >> 0] = t;
          break;

        case "i16":
          HEAP16[e >> 1] = t;
          break;

        case "i32":
          HEAP32[e >> 2] = t;
          break;

        case "i64":
          tempI64 = [t >>> 0, (tempDouble = t, +Math_abs(tempDouble) >= 1 ? tempDouble > 0 ? (0 | Math_min(+Math_floor(tempDouble / 4294967296), 4294967295)) >>> 0 : ~~+Math_ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[e >> 2] = tempI64[0], HEAP32[e + 4 >> 2] = tempI64[1];
          break;

        case "float":
          HEAPF32[e >> 2] = t;
          break;

        case "double":
          HEAPF64[e >> 3] = t;
          break;

        default:
          abort("invalid type for setValue: " + a);
      }
    }

    function getValue(e, t, a) {
      switch ("*" === (t = t || "i8").charAt(t.length - 1) && (t = "i32"), t) {
        case "i1":
        case "i8":
          return HEAP8[e >> 0];

        case "i16":
          return HEAP16[e >> 1];

        case "i32":
        case "i64":
          return HEAP32[e >> 2];

        case "float":
          return HEAPF32[e >> 2];

        case "double":
          return HEAPF64[e >> 3];

        default:
          abort("invalid type for getValue: " + t);
      }

      return null;
    }

    !function () {
      var JSfuncs = {
        stackSave: function stackSave() {
          Runtime.stackSave();
        },
        stackRestore: function stackRestore() {
          Runtime.stackRestore();
        },
        arrayToC: function arrayToC(e) {
          var t = Runtime.stackAlloc(e.length);
          return writeArrayToMemory(e, t), t;
        },
        stringToC: function stringToC(e) {
          var t = 0;

          if (null != e && 0 !== e) {
            var a = 1 + (e.length << 2);
            stringToUTF8(e, t = Runtime.stackAlloc(a), a);
          }

          return t;
        }
      },
          toC = {
        string: JSfuncs.stringToC,
        array: JSfuncs.arrayToC
      };

      ccall = function ccall(e, t, a, r, n) {
        var s = getCFunc(e),
            o = [],
            i = 0;
        if (r) for (var c = 0; c < r.length; c++) {
          var u = toC[a[c]];
          u ? (0 === i && (i = Runtime.stackSave()), o[c] = u(r[c])) : o[c] = r[c];
        }
        var d = s.apply(null, o);

        if ("string" === t && (d = Pointer_stringify(d)), 0 !== i) {
          if (n && n.async) return void EmterpreterAsync.asyncFinalizers.push(function () {
            Runtime.stackRestore(i);
          });
          Runtime.stackRestore(i);
        }

        return d;
      };

      var sourceRegex = /^function\s*[a-zA-Z$_0-9]*\s*\(([^)]*)\)\s*{\s*([^*]*?)[\s;]*(?:return\s*(.*?)[;\s]*)?}$/;

      function parseJSFunc(e) {
        var t = e.toString().match(sourceRegex).slice(1);
        return {
          arguments: t[0],
          body: t[1],
          returnValue: t[2]
        };
      }

      var JSsource = null;

      function ensureJSsource() {
        if (!JSsource) for (var e in JSsource = {}, JSfuncs) {
          JSfuncs.hasOwnProperty(e) && (JSsource[e] = parseJSFunc(JSfuncs[e]));
        }
      }

      cwrap = function cwrap(ident, returnType, argTypes) {
        argTypes = argTypes || [];
        var cfunc = getCFunc(ident),
            numericArgs = argTypes.every(function (e) {
          return "number" === e;
        }),
            numericRet = "string" !== returnType;
        if (numericRet && numericArgs) return cfunc;
        var argNames = argTypes.map(function (e, t) {
          return "$" + t;
        }),
            funcstr = "(function(" + argNames.join(",") + ") {",
            nargs = argTypes.length;

        if (!numericArgs) {
          ensureJSsource(), funcstr += "var stack = " + JSsource.stackSave.body + ";";

          for (var i = 0; i < nargs; i++) {
            var arg = argNames[i],
                type = argTypes[i];

            if ("number" !== type) {
              var convertCode = JSsource[type + "ToC"];
              funcstr += "var " + convertCode.arguments + " = " + arg + ";", funcstr += convertCode.body + ";", funcstr += arg + "=(" + convertCode.returnValue + ");";
            }
          }
        }

        var cfuncname = parseJSFunc(function () {
          return cfunc;
        }).returnValue;

        if (funcstr += "var ret = " + cfuncname + "(" + argNames.join(",") + ");", !numericRet) {
          var strgfy = parseJSFunc(function () {
            return Pointer_stringify;
          }).returnValue;
          funcstr += "ret = " + strgfy + "(ret);";
        }

        return numericArgs || (ensureJSsource(), funcstr += JSsource.stackRestore.body.replace("()", "(stack)") + ";"), funcstr += "return ret})", eval(funcstr);
      };
    }(), Module.ccall = ccall, Module.cwrap = cwrap, Module.setValue = setValue, Module.getValue = getValue;
    var ALLOC_NORMAL = 0,
        ALLOC_STACK = 1,
        ALLOC_STATIC = 2,
        ALLOC_DYNAMIC = 3,
        ALLOC_NONE = 4;

    function allocate(e, t, a, r) {
      var n, s;
      "number" == typeof e ? (n = !0, s = e) : (n = !1, s = e.length);
      var o,
          i = "string" == typeof t ? t : null;

      if (o = a == ALLOC_NONE ? r : ["function" == typeof _malloc ? _malloc : Runtime.staticAlloc, Runtime.stackAlloc, Runtime.staticAlloc, Runtime.dynamicAlloc][void 0 === a ? ALLOC_STATIC : a](Math.max(s, i ? 1 : t.length)), n) {
        var c;
        r = o;

        for (assert(0 == (3 & o)), c = o + (-4 & s); r < c; r += 4) {
          HEAP32[r >> 2] = 0;
        }

        for (c = o + s; r < c;) {
          HEAP8[r++ >> 0] = 0;
        }

        return o;
      }

      if ("i8" === i) return e.subarray || e.slice ? HEAPU8.set(e, o) : HEAPU8.set(new Uint8Array(e), o), o;

      for (var u, d, f, l = 0; l < s;) {
        var h = e[l];
        "function" == typeof h && (h = Runtime.getFunctionIndex(h)), 0 !== (u = i || t[l]) ? ("i64" == u && (u = "i32"), setValue(o + l, h, u), f !== u && (d = Runtime.getNativeTypeSize(u), f = u), l += d) : l++;
      }

      return o;
    }

    function getMemory(e) {
      return staticSealed ? runtimeInitialized ? _malloc(e) : Runtime.dynamicAlloc(e) : Runtime.staticAlloc(e);
    }

    function Pointer_stringify(e, t) {
      if (0 === t || !e) return "";

      for (var a, r = 0, n = 0; r |= a = HEAPU8[e + n >> 0], (0 != a || t) && (n++, !t || n != t);) {
        ;
      }

      t || (t = n);
      var s = "";

      if (r < 128) {
        for (var o; t > 0;) {
          o = String.fromCharCode.apply(String, HEAPU8.subarray(e, e + Math.min(t, 1024))), s = s ? s + o : o, e += 1024, t -= 1024;
        }

        return s;
      }

      return Module.UTF8ToString(e);
    }

    function AsciiToString(e) {
      for (var t = "";;) {
        var a = HEAP8[e++ >> 0];
        if (!a) return t;
        t += String.fromCharCode(a);
      }
    }

    function stringToAscii(e, t) {
      return writeAsciiToMemory(e, t, !1);
    }

    Module.ALLOC_NORMAL = ALLOC_NORMAL, Module.ALLOC_STACK = ALLOC_STACK, Module.ALLOC_STATIC = ALLOC_STATIC, Module.ALLOC_DYNAMIC = ALLOC_DYNAMIC, Module.ALLOC_NONE = ALLOC_NONE, Module.allocate = allocate, Module.getMemory = getMemory, Module.Pointer_stringify = Pointer_stringify, Module.AsciiToString = AsciiToString, Module.stringToAscii = stringToAscii;
    var UTF8Decoder = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0;

    function UTF8ArrayToString(e, t) {
      for (var a = t; e[a];) {
        ++a;
      }

      if (a - t > 16 && e.subarray && UTF8Decoder) return UTF8Decoder.decode(e.subarray(t, a));

      for (var r, n, s, o, i, c = "";;) {
        if (!(r = e[t++])) return c;
        if (128 & r) {
          if (n = 63 & e[t++], 192 != (224 & r)) {
            if (s = 63 & e[t++], 224 == (240 & r) ? r = (15 & r) << 12 | n << 6 | s : (o = 63 & e[t++], 240 == (248 & r) ? r = (7 & r) << 18 | n << 12 | s << 6 | o : (i = 63 & e[t++], r = 248 == (252 & r) ? (3 & r) << 24 | n << 18 | s << 12 | o << 6 | i : (1 & r) << 30 | n << 24 | s << 18 | o << 12 | i << 6 | 63 & e[t++])), r < 65536) c += String.fromCharCode(r);else {
              var u = r - 65536;
              c += String.fromCharCode(55296 | u >> 10, 56320 | 1023 & u);
            }
          } else c += String.fromCharCode((31 & r) << 6 | n);
        } else c += String.fromCharCode(r);
      }
    }

    function UTF8ToString(e) {
      return UTF8ArrayToString(HEAPU8, e);
    }

    function stringToUTF8Array(e, t, a, r) {
      if (!(r > 0)) return 0;

      for (var n = a, s = a + r - 1, o = 0; o < e.length; ++o) {
        var i = e.charCodeAt(o);

        if (i >= 55296 && i <= 57343 && (i = 65536 + ((1023 & i) << 10) | 1023 & e.charCodeAt(++o)), i <= 127) {
          if (a >= s) break;
          t[a++] = i;
        } else if (i <= 2047) {
          if (a + 1 >= s) break;
          t[a++] = 192 | i >> 6, t[a++] = 128 | 63 & i;
        } else if (i <= 65535) {
          if (a + 2 >= s) break;
          t[a++] = 224 | i >> 12, t[a++] = 128 | i >> 6 & 63, t[a++] = 128 | 63 & i;
        } else if (i <= 2097151) {
          if (a + 3 >= s) break;
          t[a++] = 240 | i >> 18, t[a++] = 128 | i >> 12 & 63, t[a++] = 128 | i >> 6 & 63, t[a++] = 128 | 63 & i;
        } else if (i <= 67108863) {
          if (a + 4 >= s) break;
          t[a++] = 248 | i >> 24, t[a++] = 128 | i >> 18 & 63, t[a++] = 128 | i >> 12 & 63, t[a++] = 128 | i >> 6 & 63, t[a++] = 128 | 63 & i;
        } else {
          if (a + 5 >= s) break;
          t[a++] = 252 | i >> 30, t[a++] = 128 | i >> 24 & 63, t[a++] = 128 | i >> 18 & 63, t[a++] = 128 | i >> 12 & 63, t[a++] = 128 | i >> 6 & 63, t[a++] = 128 | 63 & i;
        }
      }

      return t[a] = 0, a - n;
    }

    function stringToUTF8(e, t, a) {
      return stringToUTF8Array(e, HEAPU8, t, a);
    }

    function lengthBytesUTF8(e) {
      for (var t = 0, a = 0; a < e.length; ++a) {
        var r = e.charCodeAt(a);
        r >= 55296 && r <= 57343 && (r = 65536 + ((1023 & r) << 10) | 1023 & e.charCodeAt(++a)), r <= 127 ? ++t : t += r <= 2047 ? 2 : r <= 65535 ? 3 : r <= 2097151 ? 4 : r <= 67108863 ? 5 : 6;
      }

      return t;
    }

    Module.UTF8ArrayToString = UTF8ArrayToString, Module.UTF8ToString = UTF8ToString, Module.stringToUTF8Array = stringToUTF8Array, Module.stringToUTF8 = stringToUTF8, Module.lengthBytesUTF8 = lengthBytesUTF8;
    var UTF16Decoder = "undefined" != typeof TextDecoder ? new TextDecoder("utf-16le") : void 0,
        HEAP,
        buffer,
        HEAP8,
        HEAPU8,
        HEAP16,
        HEAPU16,
        HEAP32,
        HEAPU32,
        HEAPF32,
        HEAPF64,
        STATIC_BASE,
        STATICTOP,
        staticSealed,
        STACK_BASE,
        STACKTOP,
        STACK_MAX,
        DYNAMIC_BASE,
        DYNAMICTOP_PTR;

    function demangle(e) {
      var t = Module.___cxa_demangle || Module.__cxa_demangle;

      if (t) {
        try {
          var a = e.substr(1),
              r = lengthBytesUTF8(a) + 1,
              n = _malloc(r);

          stringToUTF8(a, n, r);

          var s = _malloc(4),
              o = t(n, 0, 0, s);

          if (0 === getValue(s, "i32") && o) return Pointer_stringify(o);
        } catch (e) {} finally {
          n && _free(n), s && _free(s), o && _free(o);
        }

        return e;
      }

      return Runtime.warnOnce("warning: build with  -s DEMANGLE_SUPPORT=1  to link in libcxxabi demangling"), e;
    }

    function demangleAll(e) {
      return e.replace(/__Z[\w\d_]+/g, function (e) {
        var t = demangle(e);
        return e === t ? e : e + " [" + t + "]";
      });
    }

    function jsStackTrace() {
      var e = new Error();

      if (!e.stack) {
        try {
          throw new Error(0);
        } catch (t) {
          e = t;
        }

        if (!e.stack) return "(no stack trace available)";
      }

      return e.stack.toString();
    }

    function stackTrace() {
      var e = jsStackTrace();
      return Module.extraStackTrace && (e += "\n" + Module.extraStackTrace()), demangleAll(e);
    }

    function updateGlobalBufferViews() {
      Module.HEAP8 = HEAP8 = new Int8Array(buffer), Module.HEAP16 = HEAP16 = new Int16Array(buffer), Module.HEAP32 = HEAP32 = new Int32Array(buffer), Module.HEAPU8 = HEAPU8 = new Uint8Array(buffer), Module.HEAPU16 = HEAPU16 = new Uint16Array(buffer), Module.HEAPU32 = HEAPU32 = new Uint32Array(buffer), Module.HEAPF32 = HEAPF32 = new Float32Array(buffer), Module.HEAPF64 = HEAPF64 = new Float64Array(buffer);
    }

    function abortOnCannotGrowMemory() {
      abort("Cannot enlarge memory arrays. Either (1) compile with  -s TOTAL_MEMORY=X  with X higher than the current value " + TOTAL_MEMORY + ", (2) compile with  -s ALLOW_MEMORY_GROWTH=1  which allows increasing the size at runtime but prevents some optimizations, (3) set Module.TOTAL_MEMORY to a higher value before the program runs, or (4) if you want malloc to return NULL (0) instead of this abort, compile with  -s ABORTING_MALLOC=0 ");
    }

    function enlargeMemory() {
      abortOnCannotGrowMemory();
    }

    Module.stackTrace = stackTrace, STATIC_BASE = STATICTOP = STACK_BASE = STACKTOP = STACK_MAX = DYNAMIC_BASE = DYNAMICTOP_PTR = 0, staticSealed = !1;
    var TOTAL_STACK = Module.TOTAL_STACK || 5242880,
        TOTAL_MEMORY = Module.TOTAL_MEMORY || 16777216;

    function getTotalMemory() {
      return TOTAL_MEMORY;
    }

    if (TOTAL_MEMORY < TOTAL_STACK && Module.printErr("TOTAL_MEMORY should be larger than TOTAL_STACK, was " + TOTAL_MEMORY + "! (TOTAL_STACK=" + TOTAL_STACK + ")"), buffer = Module.buffer ? Module.buffer : new ArrayBuffer(TOTAL_MEMORY), updateGlobalBufferViews(), HEAP32[0] = 1668509029, HEAP16[1] = 25459, 115 !== HEAPU8[2] || 99 !== HEAPU8[3]) throw "Runtime error: expected the system to be little-endian!";

    function callRuntimeCallbacks(e) {
      for (; e.length > 0;) {
        var t = e.shift();

        if ("function" != typeof t) {
          var a = t.func;
          "number" == typeof a ? void 0 === t.arg ? Module.dynCall_v(a) : Module.dynCall_vi(a, t.arg) : a(void 0 === t.arg ? null : t.arg);
        } else t();
      }
    }

    Module.HEAP = HEAP, Module.buffer = buffer, Module.HEAP8 = HEAP8, Module.HEAP16 = HEAP16, Module.HEAP32 = HEAP32, Module.HEAPU8 = HEAPU8, Module.HEAPU16 = HEAPU16, Module.HEAPU32 = HEAPU32, Module.HEAPF32 = HEAPF32, Module.HEAPF64 = HEAPF64;
    var __ATPRERUN__ = [],
        __ATINIT__ = [],
        __ATMAIN__ = [],
        __ATEXIT__ = [],
        __ATPOSTRUN__ = [],
        runtimeInitialized = !1,
        runtimeExited = !1;

    function preRun() {
      if (Module.preRun) for ("function" == typeof Module.preRun && (Module.preRun = [Module.preRun]); Module.preRun.length;) {
        addOnPreRun(Module.preRun.shift());
      }
      callRuntimeCallbacks(__ATPRERUN__);
    }

    function ensureInitRuntime() {
      runtimeInitialized || (runtimeInitialized = !0, callRuntimeCallbacks(__ATINIT__));
    }

    function preMain() {
      callRuntimeCallbacks(__ATMAIN__);
    }

    function exitRuntime() {
      callRuntimeCallbacks(__ATEXIT__), runtimeExited = !0;
    }

    function postRun() {
      if (Module.postRun) for ("function" == typeof Module.postRun && (Module.postRun = [Module.postRun]); Module.postRun.length;) {
        addOnPostRun(Module.postRun.shift());
      }
      callRuntimeCallbacks(__ATPOSTRUN__);
    }

    function addOnPreRun(e) {
      __ATPRERUN__.unshift(e);
    }

    function addOnInit(e) {
      __ATINIT__.unshift(e);
    }

    function addOnPreMain(e) {
      __ATMAIN__.unshift(e);
    }

    function addOnExit(e) {
      __ATEXIT__.unshift(e);
    }

    function addOnPostRun(e) {
      __ATPOSTRUN__.unshift(e);
    }

    function writeStringToMemory(e, t, a) {
      var r, n;
      Runtime.warnOnce("writeStringToMemory is deprecated and should not be called! Use stringToUTF8() instead!"), a && (n = t + lengthBytesUTF8(e), r = HEAP8[n]), stringToUTF8(e, t, 1 / 0), a && (HEAP8[n] = r);
    }

    function writeArrayToMemory(e, t) {
      HEAP8.set(e, t);
    }

    function writeAsciiToMemory(e, t, a) {
      for (var r = 0; r < e.length; ++r) {
        HEAP8[t++ >> 0] = e.charCodeAt(r);
      }

      a || (HEAP8[t >> 0] = 0);
    }

    Module.addOnPreRun = addOnPreRun, Module.addOnInit = addOnInit, Module.addOnPreMain = addOnPreMain, Module.addOnExit = addOnExit, Module.addOnPostRun = addOnPostRun, Module.writeStringToMemory = writeStringToMemory, Module.writeArrayToMemory = writeArrayToMemory, Module.writeAsciiToMemory = writeAsciiToMemory, Math.imul && -5 === Math.imul(4294967295, 5) || (Math.imul = function (e, t) {
      var a = 65535 & e,
          r = 65535 & t;
      return a * r + ((e >>> 16) * r + a * (t >>> 16) << 16) | 0;
    }), Math.imul = Math.imul, Math.clz32 || (Math.clz32 = function (e) {
      e >>>= 0;

      for (var t = 0; t < 32; t++) {
        if (e & 1 << 31 - t) return t;
      }

      return 32;
    }), Math.clz32 = Math.clz32, Math.trunc || (Math.trunc = function (e) {
      return e < 0 ? Math.ceil(e) : Math.floor(e);
    }), Math.trunc = Math.trunc;
    var Math_abs = Math.abs,
        Math_cos = Math.cos,
        Math_sin = Math.sin,
        Math_tan = Math.tan,
        Math_acos = Math.acos,
        Math_asin = Math.asin,
        Math_atan = Math.atan,
        Math_atan2 = Math.atan2,
        Math_exp = Math.exp,
        Math_log = Math.log,
        Math_sqrt = Math.sqrt,
        Math_ceil = Math.ceil,
        Math_floor = Math.floor,
        Math_pow = Math.pow,
        Math_imul = Math.imul,
        Math_fround = Math.fround,
        Math_round = Math.round,
        Math_min = Math.min,
        Math_clz32 = Math.clz32,
        Math_trunc = Math.trunc,
        runDependencies = 0,
        runDependencyWatcher = null,
        dependenciesFulfilled = null;

    function getUniqueRunDependency(e) {
      return e;
    }

    function addRunDependency(e) {
      runDependencies++, Module.monitorRunDependencies && Module.monitorRunDependencies(runDependencies);
    }

    function removeRunDependency(e) {
      if (runDependencies--, Module.monitorRunDependencies && Module.monitorRunDependencies(runDependencies), 0 == runDependencies && (null !== runDependencyWatcher && (clearInterval(runDependencyWatcher), runDependencyWatcher = null), dependenciesFulfilled)) {
        var t = dependenciesFulfilled;
        dependenciesFulfilled = null, t();
      }
    }

    Module.addRunDependency = addRunDependency, Module.removeRunDependency = removeRunDependency, Module.preloadedImages = {}, Module.preloadedAudios = {};
    var memoryInitializer = null,
        ASM_CONSTS = [];
    STATIC_BASE = Runtime.GLOBAL_BASE, STATICTOP = STATIC_BASE + 17504, __ATINIT__.push(), memoryInitializer = "data:application/octet-stream;base64,AQAA8JP14UORcLl5SOgzKF1YgYG2RVC4KaAx4XJOZDCnbSGuRea4G+NZXOOxOv5ThYC7Uz2DSYylRE5/sdAWAon6ilNb/Czz+wFF1BEZ57X2f0EK/x6rRx81uMpxn9gG3zAV2q9tzbG2PSin5hDyYvsK2goMC3/vRCVZLZBu/SBH/XzYFowgPI3KcWiRaoGXXViBgbZFULgpoDHhck5kMAAAAAAAAP8DAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP8DAAAAAAAAAAAAAAAAAAAAAP8DAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/wMAAAAAAACgBgAADQAAAHYqAADAAQAACAcAAA0AAAAAAAAAAAEAAQABAAEAAQABAAEAAQABAAEAAgACAwAAAAAEAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAADAgAAAAAGAAIAAAcAAAIIAAAHAAAAAAAAAAAAAAAAAAAAAAAAAAkKAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAEAAAAAAAAAAgQAAAwAAgAAAAAACAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAAAAABAgMDAwQDAwMDAwMFBgMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMAAAAAAAAAAAAAAADA/wAAAAD/AwAAAAAAAAAA/wMAAP8DAAAAAAAAAAAAAADAAQDA/wAAAAAAAP8D/wMAAAAAAAAAAAAA/wMAAAAA/////+cBAAAAAAAAgAAAAP4DAAcAAP8DAAD/AwAAAAAAAAAA////////HwACBAAAAAAAAAAAPgAAAAAAAAAAAP8DAAAAAAAAwP8AAAAAAAAAAP8DAAAAAAAAwP8AAP8DAAAAAP8DAAAAAAAA/////////////////38AAADA////////pBYAABEAAAC1FgAAIQAAAAwCAAAZAAAApBYAABEAAAC1FgAAIQAAAMoCAAAJAAAAAQAAAAQAAAAEAAAAAQAAAAEAAAACAAAAUEAAAAAAAAD0FgAAAgAAAPYWAAAfAAAAlAMAAAUAAAAMGAAAKwAAADcYAAAfAAAATwEAABUAAABxGAAAKwAAAJwYAAAfAAAATwEAABUAAADaGAAAHQAAAA8GAAAKAAAA9xgAABEAAAAIGQAAIQAAAMoCAAAJAAAAPBkAAE0AAAAUAAAADgAAADwZAABNAAAAJgAAAA4AAACJGQAAKwAAALQZAAAfAAAATwEAABUAAAACAAAACAAAAAQAAAADAAAAMDEyMzQ1Njc4OWFiY2RlZhIaAAAUAAAA8RkAABMAAAAEGgAADgAAACYaAAArAAAAURoAAB8AAABPAQAAFQAAAHAaAAARAAAAgRoAACEAAAAMAgAAGQAAAHAaAAARAAAAgRoAACEAAADKAgAACQAAAMAaAAArAAAA6xoAAB8AAABPAQAAFQAAAAobAAAVAAAAIA4AAAEAAABRQAAAAAAAAEobAAACAAAAjBsAACIAAAA+AwAACgAAAGgbAAAkAAAAkwQAABQAAAADAAAABAAAAAQAAAABAAAABAAAAAQAAAAEAAAAAgAAAAEAAAACAAAAAAAAAAUAAAAGAAAADAAAAAQAAAAEAAAABwAAAAgAAAAEAAAABQAAAOQbAAAgAAAABBwAACMAAABlAAAADQAAAEQdAAAnAAAANgAAAA0AAABEHQAAJwAAADsAAAANAAAAEh0AADIAAACGHAAAKwAAAAAAAAAIAAAAAwAAAAkAAAAKAAAABAAAAAQAAAABAAAAAQAAAAIAAAABAAAAAAAAAPYcAAAIAAAA/hwAAA8AAAANHQAAAwAAABAdAAABAAAAEB0AAAEAAAARHQAAAQAAAMMcAAAzAAAAUUAAAAAAAABrHQAAAgAAAG0dAAAfAAAAlAMAAAUAAACMHQAAJAAAAMMBAAASAAAACwAAAAQAAAAEAAAAAQAAAAMAAAAEAAAADAAAAAQAAAAEAAAAAgAAAAMAAAAGAAAABQAAAAYAAAANAAAADAAAAAQAAAAEAAAABQAAAAcAAAAHAAAACAAAAA4AAAAEAAAABAAAAAkAAAAlHgAALQAAAFIeAAAMAAAAXh4AAAEAAAAPAAAABAAAAAQAAAAKAAAAEAAAAAwAAAAEAAAACwAAABEAAAABAAAAAQAAAAwAAAASAAAABAAAAAQAAAANAAAAEwAAAAQAAAAEAAAADgAAABQAAAAEAAAABAAAAA8AAABRQAAAAAAAAAQhAAALAAAA8A0AAAEAAADkIAAAIAAAANEAAAArAAAAUUAAAAAAAAAPIQAAAgAAAAEAAAAAAAAAIAAAAAgAAAADAAAAAAAAAAAAAAACAAAAAwAAABUAAAAEAAAABAAAABAAAAAWAAAABAAAAAQAAAARAAAAXx4AACgAAAA3AAAACQAAAF8eAAAoAAAAOQAAAAkAAABfHgAAKAAAADsAAAAJAAAAXx4AACgAAAA9AAAACQAAABcAAAAEAAAABAAAAAYAAAAHAAAAGSEAACsAAABEIQAAHwAAAE8BAAAVAAAAYyEAAC0AAACQIQAADAAAAJwhAAABAAAAuCEAACQAAADcIQAAAwAAAJ0hAAAbAAAA7wAAAAkAAAA4IgAAIQAAADsBAAAVAAAAOCIAACEAAABfAQAAFQAAAAIAAAA4IgAAIQAAAJEBAAAJAAAAGAAAAAQAAAAEAAAAEgAAAO0iAAAiAAAAHwQAABYAAADtIgAAIgAAACgEAAAWAAAAKyMAACwAAACaAAAADgAAAJIjAAArAAAAvSMAAB8AAABPAQAAFQAAAO0iAAAiAAAAHQMAABMAAADtIgAAIgAAAK0DAAARAAAAaiQAAFgAAABZJAAAEQAAAAoAAABrJQAAAgAAAG0lAAACAAAAbyUAAAMAAAABAAAAAAAAACAAAAAAAAAAAwAAAAAAAAAAAAAAAgAAAAMAAAABAAAAAQAAACAAAAAAAAAAAwAAAAAAAAABAAAAAgAAAAMAAABrJQAAAgAAAG0lAAACAAAAAQAAAAAAAAAgAAAAAAAAAAMAAAAAAAAAAAAAAAIAAAADAAAAPHVua25vd24+AAAAOjoAAC4AAABAAAAAKgAAACYAAAA8AAAAPgAAACgAAAApAAAALAAAAH4AAAAgAAAAJwAAAFsAAABdAAAAewAAAH0AAAA7AAAAKwAAACIAAAAKAAAASSUAACIAAAA+AwAACgAAACUlAAAkAAAA2wQAABQAAAAlJQAAJAAAAOgEAAAUAAAAciUAABEAAACDJQAAIQAAAKcBAAAZAAAApCUAACQAAACDJQAAIQAAAG0CAAAJAAAAciUAABEAAACDJQAAIQAAAAwCAAAZAAAAciUAABEAAACDJQAAIQAAAMoCAAAJAAAAGQAAAAQAAAAEAAAAAgAAABMAAAAUAAAA7CUAAC4AAAA3AAAADQAAAAQAAAAaAAAAAAAAABsAAAC1JgAALQAAAOImAAAMAAAA7iYAAAEAAACIJgAALQAAABUAAAAFAAAAWSYAAC8AAADBAAAACQAAABcnAAArAAAAQicAAB8AAABPAQAAFQAAABwAAAAMAAAABAAAAAMAAAAVAAAAFgAAAKknAAAuAAAALgAAABoAAAAkKAAAJQAAAFoAAAAJAAAAjygAACIAAAA+AwAACgAAAGsoAAAkAAAAkwQAABQAAADKKAAAFQAAAN8oAAABAAAAHQAAAAQAAAAEAAAABAAAABcAAAAYAAAA4CgAACAAAAAAKQAAJQAAACEAAAAFAAAAJSkAACgAAAAAKQAAJQAAADEAAAAFAAAAUUAAAAAAAABEKgAAEQAAAFUqAAAhAAAAygIAAAkAAAA2LAAAIgAAAD4DAAAKAAAAWCwAACYAAABWAAAAHAAAAFgsAAAmAAAAWgAAABwAAAAwMDAxMDIwMzA0MDUwNjA3MDgwOTEwMTExMjEzMTQxNTE2MTcxODE5MjAyMTIyMjMyNDI1MjYyNzI4MjkzMDMxMzIzMzM0MzUzNjM3MzgzOTQwNDE0MjQzNDQ0NTQ2NDc0ODQ5NTA1MTUyNTM1NDU1NTY1NzU4NTk2MDYxNjI2MzY0NjU2NjY3Njg2OTcwNzE3MjczNzQ3NTc2Nzc3ODc5ODA4MTgyODM4NDg1ODY4Nzg4ODk5MDkxOTI5Mzk0OTU5Njk3OTg5OR4AAAAMAAAABAAAAAUAAAAZAAAAGgAAAIAsAAAgAAAAPAQAABEAAACgLAAAKwAAAMssAAAfAAAATwEAABUAAACALAAAIAAAADAEAAAoAAAADy4AAAsAAAC7LgAAFgAAAE4uAAABAAAAAQAAAAAAAAAgAAAAAAAAAAMAAAAAAAAAAwAAAAAAAAADAAAAAQAAAAEAAAAgAAAAAAAAAAMAAAAAAAAAAwAAAAAAAAADAAAAAQAAAAIAAAAgAAAAAAAAAAMAAAAAAAAAAwAAAAAAAAADAAAA7y0AACAAAACpCAAACQAAAJkuAAAOAAAApy4AAAQAAACrLgAAEAAAAE4uAAABAAAAAQAAAAAAAAAgAAAAAAAAAAMAAAAAAAAAAwAAAAAAAAADAAAAAQAAAAEAAAAgAAAAAAAAAAMAAAAAAAAAAwAAAAAAAAADAAAAAQAAAAIAAAAgAAAAAAAAAAMAAAAAAAAAAwAAAAAAAAADAAAAAQAAAAMAAAAgAAAAAAAAAAMAAAAAAAAAAwAAAAAAAAADAAAA7y0AACAAAACtCAAABQAAAE8uAAArAAAAei4AAB8AAABPAQAAFQAAAA8uAAALAAAAGi4AACYAAABALgAACAAAAEguAAAGAAAATi4AAAEAAAABAAAAAAAAACAAAAAAAAAAAwAAAAAAAAADAAAAAAAAAAMAAAABAAAAAQAAACAAAAAAAAAAAwAAAAAAAAADAAAAAAAAAAMAAAABAAAAAgAAACAAAAAAAAAAAwAAAAAAAAADAAAAAAAAAAMAAAABAAAAAwAAACAAAAAAAAAAAwAAAAAAAAADAAAAAAAAAAMAAAABAAAABAAAACAAAAAAAAAAAwAAAAAAAAADAAAAAAAAAAMAAADvLQAAIAAAALoIAAAFAAAAHwAAAAQAAAAEAAAAGwAAACAAAAAEAAAABAAAABwAAADuLgAAIgAAAD4DAAAKAAAABA4AAAEAAAAhAAAABAAAAAQAAAAGAAAAHQAAAB4AAABRQAAAAAAAAPwNAAABAAAAIC8AAAIAAABRQAAAAAAAACIvAAACAAAAJC8AACAAAABELwAAEgAAAFFAAAAAAAAAAQAAAAAAAAAgAAAAAAAAAAMAAAAAAAAAAwAAAAAAAAADAAAAVi8AAB8AAAB7AwAABQAAACIAAAAEAAAABAAAAB8AAAAjAAAABAAAAAQAAAAgAAAAAQAAAAAAAAAgAAAAAAAAAAMAAAAAAAAAAwAAAAAAAAADAAAAAQAAAAEAAAAgAAAAAAAAAAMAAAAAAAAAAwAAAAAAAAADAAAAsC8AAAYAAAC2LwAAIgAAANgvAAAiAAAA7gIAAAUAAAD6LwAAFgAAABAwAAANAAAA2C8AACIAAAD0AgAABQAAAD41AAArAAAAaTUAAB8AAABPAQAAFQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAAACAAAAFlAAAAABAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAK/////wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJBYAAGNhcGFjaXR5IG92ZXJmbG93L2NoZWNrb3V0L3NyYy9saWJhbGxvYy9yYXdfdmVjLnJzaW52YWxpZCBsYXlvdXQgZm9yIGFsbG9jX2FycmF5OiAvY2hlY2tvdXQvc3JjL2xpYmNvcmUvcmVzdWx0LnJzY2FsbGVkIGBSZXN1bHQ6OnVud3JhcCgpYCBvbiBhbiBgRXJyYCB2YWx1ZXJlYWRpbmcgZnJvbSB6ZXJvLWV4dGVuZGVkIG1lbW9yeSBjYW5ub3QgZmFpbDsgcWVkQ2Fubm90IGZhaWwgc2luY2UgMC4uMzIgaXMgMzItYnl0ZSBsZW5ndGhDYW5ub3QgZmFpbCBzaW5jZSAzMi4uNjQgaXMgMzItYnl0ZSBsZW5ndGhJbnZhbGlkIHBvaW50IHggY29vcmRpbmF0ZUludmFsaWQgcG9pbnQgeSBjb29yZGluYXRlSW52YWxpZCBjdXJ2ZSBwb2ludGNhbGxlZCBgT3B0aW9uOjp1bndyYXAoKWAgb24gYSBgTm9uZWAgdmFsdWUvY2hlY2tvdXQvc3JjL2xpYmNvcmUvb3B0aW9uLnJzSW52YWxpZFNsaWNlTGVuZ3RoTm90TWVtYmVyY2FsbGVkIGBPcHRpb246OnVud3JhcCgpYCBvbiBhIGBOb25lYCB2YWx1ZS9jaGVja291dC9zcmMvbGliY29yZS9vcHRpb24ucnNtaWxsZXIgbG9vcCBjYW5ub3QgcHJvZHVjZSB6ZXJvL2NoZWNrb3V0L3NyYy9saWJhbGxvYy92ZWMucnNjYXBhY2l0eSBvdmVyZmxvdy9jaGVja291dC9zcmMvbGliYWxsb2MvcmF3X3ZlYy5yc25vdCB5ZXQgaW1wbGVtZW50ZWQvaG9tZS9odWdvLy5jYXJnby9naXQvY2hlY2tvdXRzL2JuLTgwMTNiNDgxODM5NWRjZmIvNjI0YzYwYi9zcmMvZmllbGRzL2ZxNi5yc2NhbGxlZCBgT3B0aW9uOjp1bndyYXAoKWAgb24gYSBgTm9uZWAgdmFsdWUvY2hlY2tvdXQvc3JjL2xpYmNvcmUvb3B0aW9uLnJzaW52YWxpZCBsYXlvdXQgZm9yIGFsbG9jX2FycmF5SW52YWxpZCBjaGFyYWN0ZXIgJycgYXQgcG9zaXRpb24gSW52YWxpZCBpbnB1dCBsZW5ndGhjYWxsZWQgYE9wdGlvbjo6dW53cmFwKClgIG9uIGEgYE5vbmVgIHZhbHVlL2NoZWNrb3V0L3NyYy9saWJjb3JlL29wdGlvbi5yc2NhcGFjaXR5IG92ZXJmbG93L2NoZWNrb3V0L3NyYy9saWJhbGxvYy9yYXdfdmVjLnJzaW52YWxpZCBsYXlvdXQgZm9yIGFsbG9jX2FycmF5Y2FsbGVkIGBPcHRpb246OnVud3JhcCgpYCBvbiBhIGBOb25lYCB2YWx1ZS9jaGVja291dC9zcmMvbGliY29yZS9vcHRpb24ucnNmYXRhbCBydW50aW1lIGVycm9yOiBtYWludW5leHBlY3RlZCByZXR1cm4gdmFsdWUgd2hpbGUgdW53aW5kaW5nOiBfX3J1c3RfYmVnaW5fc2hvcnRfYmFja3RyYWNlL2NoZWNrb3V0L3NyYy9saWJjb3JlL3N0ci9wYXR0ZXJuLnJzL2NoZWNrb3V0L3NyYy9saWJjb3JlL3NsaWNlL21vZC5yc1Vud2luZEVycm9yY2FsbGVkIGBSZXN1bHQ6OnVud3JhcCgpYCBvbiBhbiBgRXJyYCB2YWx1ZWZhaWxlZCB0byBpbml0aWF0ZSBwYW5pYywgZXJyb3IgL2NoZWNrb3V0L3NyYy9saWJzdGQvc3lzL3VuaXgvb3MucnNzdHJlcnJvcl9yIGZhaWx1cmVyd2xvY2sgbWF4aW11bSByZWFkZXIgY291bnQgZXhjZWVkZWRyd2xvY2sgcmVhZCBsb2NrIHdvdWxkIHJlc3VsdCBpbiBkZWFkbG9ja3RocmVhZCBwYW5pY2tlZCB3aGlsZSBwYW5pY2tpbmcuIGFib3J0aW5nLgpCb3g8QW55Pjx1bm5hbWVkPgFub3RlOiBSdW4gd2l0aCBgUlVTVF9CQUNLVFJBQ0U9MWAgZm9yIGEgYmFja3RyYWNlLgp0aHJlYWQgJycgcGFuaWNrZWQgYXQgJycsIDoKdGhyZWFkIHBhbmlja2VkIHdoaWxlIHByb2Nlc3NpbmcgcGFuaWMuIGFib3J0aW5nLgovY2hlY2tvdXQvc3JjL2xpYnN0ZC9zeXMvdW5peC9yd2xvY2sucnM6IC9jaGVja291dC9zcmMvbGliY29yZS9yZXN1bHQucnMvY2hlY2tvdXQvc3JjL2xpYnN0ZC9zeW5jL2NvbmR2YXIucnNhdHRlbXB0ZWQgdG8gdXNlIGEgY29uZGl0aW9uIHZhcmlhYmxlIHdpdGggdHdvIG11dGV4ZXNpbnZhbGlkIGxheW91dCBmb3IgYWxsb2NfYXJyYXlkYXRhIHByb3ZpZGVkIGNvbnRhaW5zIGEgbnVsIGJ5dGVhc3NlcnRpb24gZmFpbGVkOiBgKGxlZnQgPT0gcmlnaHQpYAogIGxlZnQ6IGBgLAogcmlnaHQ6IGBgL2NoZWNrb3V0L3NyYy9saWJzdGQvc3lzL3VuaXgvY29uZHZhci5yc0Vycm9ycmVwck9zY29kZW1lc3NhZ2VLaW5kQ3VzdG9ta2luZGVycm9yTm90Rm91bmRQZXJtaXNzaW9uRGVuaWVkQ29ubmVjdGlvblJlZnVzZWRDb25uZWN0aW9uUmVzZXRDb25uZWN0aW9uQWJvcnRlZE5vdENvbm5lY3RlZEFkZHJJblVzZUFkZHJOb3RBdmFpbGFibGVCcm9rZW5QaXBlQWxyZWFkeUV4aXN0c1dvdWxkQmxvY2tJbnZhbGlkSW5wdXRJbnZhbGlkRGF0YVRpbWVkT3V0V3JpdGVaZXJvSW50ZXJydXB0ZWRPdGhlclVuZXhwZWN0ZWRFb2ZfX05vbmV4aGF1c3RpdmVpbnRlcm5hbCBlcnJvcjogZW50ZXJlZCB1bnJlYWNoYWJsZSBjb2RlZW50aXR5IG5vdCBmb3VuZGNvbm5lY3Rpb24gcmVmdXNlZGNvbm5lY3Rpb24gcmVzZXRjb25uZWN0aW9uIGFib3J0ZWRub3QgY29ubmVjdGVkYWRkcmVzcyBpbiB1c2VhZGRyZXNzIG5vdCBhdmFpbGFibGVicm9rZW4gcGlwZWVudGl0eSBhbHJlYWR5IGV4aXN0c29wZXJhdGlvbiB3b3VsZCBibG9ja2ludmFsaWQgaW5wdXQgcGFyYW1ldGVyaW52YWxpZCBkYXRhdGltZWQgb3V0d3JpdGUgemVyb29wZXJhdGlvbiBpbnRlcnJ1cHRlZG90aGVyIG9zIGVycm9ydW5leHBlY3RlZCBlbmQgb2YgZmlsZXBlcm1pc3Npb24gZGVuaWVkL2NoZWNrb3V0L3NyYy9saWJzdGQvaW8vZXJyb3IucnMgKG9zIGVycm9yIFx4TnVsRXJyb3JjYWxsZWQgYE9wdGlvbjo6dW53cmFwKClgIG9uIGEgYE5vbmVgIHZhbHVlL2NoZWNrb3V0L3NyYy9saWJjb3JlL29wdGlvbi5yc2Fzc2VydGlvbiBmYWlsZWQ6IGAobGVmdCA9PSByaWdodClgCiAgbGVmdDogYGAsCiByaWdodDogYGAvY2hlY2tvdXQvc3JjL2xpYnN0ZC9lbnYucnNmYWlsZWQgdG8gZ2V0IGVudmlyb25tZW50IHZhcmlhYmxlIGBgOiBPbmNlIGluc3RhbmNlIGhhcyBwcmV2aW91c2x5IGJlZW4gcG9pc29uZWRhc3NlcnRpb24gZmFpbGVkOiBzdGF0ZSAmIFNUQVRFX01BU0sgPT0gUlVOTklORy9jaGVja291dC9zcmMvbGlic3RkL3N5bmMvb25jZS5yc1N0cmluZ0Vycm9yY2FsbGVkIGBSZXN1bHQ6OnVud3JhcCgpYCBvbiBhbiBgRXJyYCB2YWx1ZXVzZSBvZiBzdGQ6OnRocmVhZDo6Y3VycmVudCgpIGlzIG5vdCBwb3NzaWJsZSBhZnRlciB0aGUgdGhyZWFkJ3MgbG9jYWwgZGF0YSBoYXMgYmVlbiBkZXN0cm95ZWQvY2hlY2tvdXQvc3JjL2xpYnN0ZC90aHJlYWQvbW9kLnJzaW5jb25zaXN0ZW50IHN0YXRlIGluIHVucGFyay9jaGVja291dC9zcmMvbGlic3RkL3N5c19jb21tb24vYmFja3RyYWNlLnJzaW50ZXJuYWwgZXJyb3I6IGVudGVyZWQgdW5yZWFjaGFibGUgY29kZVJVU1RfQkFDS1RSQUNFMGZ1bGxjYWxsZWQgYE9wdGlvbjo6dW53cmFwKClgIG9uIGEgYE5vbmVgIHZhbHVlL2NoZWNrb3V0L3NyYy9saWJjb3JlL29wdGlvbi5yc2luY29uc2lzdGVudCBwYXJrIHN0YXRldGhyZWFkIG5hbWUgbWF5IG5vdCBjb250YWluIGludGVyaW9yIG51bGwgYnl0ZXNmYWlsZWQgdG8gZ2VuZXJhdGUgdW5pcXVlIHRocmVhZCBJRDogYml0c3BhY2UgZXhoYXVzdGVkc3RhY2sgYmFja3RyYWNlOgpub3RlOiBTb21lIGRldGFpbHMgYXJlIG9taXR0ZWQsIHJ1biB3aXRoIGBSVVNUX0JBQ0tUUkFDRT1mdWxsYCBmb3IgYSB2ZXJib3NlIGJhY2t0cmFjZS4KLmxsdm0uRV9aTlpOMTdoXyQkJFNQJCRCUCQkUkYkJExUJCRHVCQkTFAkJFJQJCRDJCR1N2UkJHUyMCQkdTI3JCR1NWIkJHU1ZCQkdTdiJCR1N2QkJHUzYiQkdTJiJCR1MjIkL2NoZWNrb3V0L3NyYy9saWJjb3JlL3N0ci9wYXR0ZXJuLnJzL2NoZWNrb3V0L3NyYy9saWJjb3JlL3NsaWNlL21vZC5ycyAgOiAgLSBjYXBhY2l0eSBvdmVyZmxvdy9jaGVja291dC9zcmMvbGliYWxsb2MvcmF3X3ZlYy5yc1RyaWVkIHRvIHNocmluayB0byBhIGxhcmdlciBjYXBhY2l0eWNhbm5vdCBjaGFuZ2UgYWxpZ25tZW50IG9uIGByZWFsbG9jYC9jaGVja291dC9zcmMvbGlic3RkL3N5c19jb21tb24vYXRfZXhpdF9pbXAucnNhc3NlcnRpb24gZmFpbGVkOiBxdWV1ZSBhcyB1c2l6ZSAhPSAxYXNzZXJ0aW9uIGZhaWxlZDoga2V5ICE9IDAvY2hlY2tvdXQvc3JjL2xpYnN0ZC9zeXNfY29tbW9uL3RocmVhZF9sb2NhbC5ycy9jaGVja291dC9zcmMvbGlic3RkL3N5cy91bml4L3RocmVhZF9sb2NhbC5yc2Fzc2VydGlvbiBmYWlsZWQ6IGAobGVmdCA9PSByaWdodClgCiAgbGVmdDogYGAsCiByaWdodDogYGBhbHJlYWR5IGJvcnJvd2VkYWxyZWFkeSBtdXRhYmx5IGJvcnJvd2VkY2FsbGVkIGBPcHRpb246OnVud3JhcCgpYCBvbiBhIGBOb25lYCB2YWx1ZS9jaGVja291dC9zcmMvbGliY29yZS9vcHRpb24ucnNjYW5ub3QgYWNjZXNzIGEgVExTIHZhbHVlIGR1cmluZyBvciBhZnRlciBpdCBpcyBkZXN0cm95ZWRmb3JtYXR0ZXIgZXJyb3IvY2hlY2tvdXQvc3JjL2xpYnN0ZC9zeXNfY29tbW9uL3RocmVhZF9pbmZvLnJzYXNzZXJ0aW9uIGZhaWxlZDogYy5ib3Jyb3coKS5pc19ub25lKClBY2Nlc3NFcnJvcmZhaWxlZCB0byB3cml0ZSB3aG9sZSBidWZmZXIvY2hlY2tvdXQvc3JjL2xpYnN0ZC9zeXMvdW5peC9hcmdzLnJzYXNzZXJ0aW9uIGZhaWxlZDogKCpwdHIpLmlzX25vbmUoKS9jaGVja291dC9zcmMvbGliY29yZS9zdHIvcGF0dGVybi5ycy9jaGVja291dC9zcmMvbGliY29yZS9zbGljZS9tb2QucnNQb2lzb25FcnJvciB7IGlubmVyOiAuLiB9ZmF0YWwgcnVudGltZSBlcnJvcjogCmFzc2VydGlvbiBmYWlsZWQ6ICFwdHIuaXNfbnVsbCgpL2NoZWNrb3V0L3NyYy9saWJwYW5pY191bndpbmQvZW1jYy5yc2ludGVybmFsIGVycm9yOiBlbnRlcmVkIHVucmVhY2hhYmxlIGNvZGVfVVJDX05PX1JFQVNPTl9VUkNfRk9SRUlHTl9FWENFUFRJT05fQ0FVR0hUX1VSQ19GQVRBTF9QSEFTRTJfRVJST1JfVVJDX0ZBVEFMX1BIQVNFMV9FUlJPUl9VUkNfTk9STUFMX1NUT1BfVVJDX0VORF9PRl9TVEFDS19VUkNfSEFORExFUl9GT1VORF9VUkNfSU5TVEFMTF9DT05URVhUX1VSQ19DT05USU5VRV9VTldJTkRfVVJDX0ZBSUxVUkVhbGxvY2F0b3IgbWVtb3J5IGV4aGF1c3RlZHVuc3VwcG9ydGVkIGFsbG9jYXRvciByZXF1ZXN0Y2FwYWNpdHkgb3ZlcmZsb3cvY2hlY2tvdXQvc3JjL2xpYmFsbG9jL3Jhd192ZWMucnMAAAAAAAEAAAAAAAAAAgADAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABgcAAAgAAAAGAAAAAAAIAAgAAAAAAAgACQYAAAAAAAAEAAAAAAAAAAAAAAAAAAgAAAAIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKCwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAACAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAL2NoZWNrb3V0L3NyYy9saWJjb3JlL3NsaWNlL21vZC5ycy9jaGVja291dC9zcmMvbGlic3RkX3VuaWNvZGUvdGFibGVzLnJzMHgvY2hlY2tvdXQvc3JjL2xpYmNvcmUvZm10L21vZC5yc2NhbGxlZCBgT3B0aW9uOjp1bndyYXAoKWAgb24gYSBgTm9uZWAgdmFsdWUvY2hlY2tvdXQvc3JjL2xpYmNvcmUvb3B0aW9uLnJzAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDAwMDAwMDAwMDAwMDAwMDBAQEBAQAAAAAAAAAAAAAAFsuLi5dL2NoZWNrb3V0L3NyYy9saWJjb3JlL3N0ci9tb2QucnNieXRlIGluZGV4ICBpcyBub3QgYSBjaGFyIGJvdW5kYXJ5OyBpdCBpcyBpbnNpZGUgIChieXRlcyApIG9mIGBgY2FsbGVkIGBPcHRpb246OnVud3JhcCgpYCBvbiBhIGBOb25lYCB2YWx1ZS9jaGVja291dC9zcmMvbGliY29yZS9vcHRpb24ucnNiZWdpbiA8PSBlbmQgKCA8PSApIHdoZW4gc2xpY2luZyBgIGlzIG91dCBvZiBib3VuZHMgb2YgYFV0ZjhFcnJvcnZhbGlkX3VwX3RvZXJyb3JfbGVuL2NoZWNrb3V0L3NyYy9saWJjb3JlL3NsaWNlL21vZC5ycyAgICAKCn0gfSksCiwgIHs6IC4uaW5kZXggb3V0IG9mIGJvdW5kczogdGhlIGxlbiBpcyAgYnV0IHRoZSBpbmRleCBpcyAvY2hlY2tvdXQvc3JjL2xpYmNvcmUvb3B0aW9uLnJzTm9uZVNvbWVQYXJzZUludEVycm9ya2luZEVtcHR5SW52YWxpZERpZ2l0T3ZlcmZsb3dVbmRlcmZsb3dpbmRleCAgb3V0IG9mIHJhbmdlIGZvciBzbGljZSBvZiBsZW5ndGggL2NoZWNrb3V0L3NyYy9saWJjb3JlL3NsaWNlL21vZC5yc3NsaWNlIGluZGV4IHN0YXJ0cyBhdCAgYnV0IGVuZHMgYXQgAAEDBQUIBgMHBAgICRAKGwsZDBYNEg4WDwQQAxISEwkWARcFGAIZAxoHHQEfFiADKwUsAi0LLgEwAzEDMgKnAagCqQKqBKsI+gL7Bf0E/gP/Ca14eYuNojBXWGCIi4yQHB3dDg9LTC4vP1xdX7XihI2OkZKpsbq7xcbJyt7k5QQREikxNDc6Oz1JSl2EjpKpsbS6u8bKzs/k5QAEDQ4REikxNDo7RUZJSl5kZYSRm53Jzs8EDREpRUlXZGWEjZGptLq7xcnf5OXwBA0RRUlkZYCBhLK8vr/V1/Dxg4WGiYuMmKCkpqiprLq+v8XHzs/a20iYvc3Gzs9JTk9XWV5fiY6Psba3v8HGx9cRFhdbXPb3/v+ADW1x3t8ODx9ubxwdX31+rq/6FhceH0ZHTk9YWlxefn+1xdTV3PDx9XJzj3R1lpfJL18mLi+nr7e/x8/X35pAl5gvMI8f/6/+/87/Tk9aWwcIDxAnL+7vbm83PT9CRZCR/v9TZ3XIydDR2Nnn/v8AIF8igt8EgkQIGwUFEYGsDjsFazUeFoDfAxkIAQQiAwoENAQHAwEHBgcQC1APEgdVCAIEHAoJAwgDBwMCAwMDDAQFAwsGAQ4VBToDEQcGBRAIVgcCBxUNUARDAy0DAQQRBg8MOgQdJQ0GTCBtBGolgMgFgrADGgaC/QNZBxULFwkUDBQMagYKBhoGWAgrBUYKLAQMBAEDMQssBBoGCwOArAYKBh9BTAQtA3QIPAMPAzw3CAgqBoL/ERgILxEtAyAQIQ+AjASClxkLFYdaAxYZBBCA9AUvBTsHAg4YCYCqNnQMgNYaDAWA/wWAtgUkDJvGCtIrFYSNAzcJgVwUgLgIgLg/NQQKBjgIRggMBnQLHgNaBFkJgIMYHAoWCUYKgIoGq6QMFwQxoQSB2iYHDAUFgKURgW0QeCgqBkwEgI0EgL4DGwMPDQAGAQEDAQQCCAgJAgoDCwIQAREEEgUTEhQCFQIaAxwFHQQkAWoDawK8AtEC1AzVCdYC1wLaAeAF6ALuIPAE8QH5AQwnOz5OT4+enp8GBwk2PT5W89DRBBQYVle9Nc7P4BKHiY6eBA0OERIpMTQ6O0VGSUpOT2RlWly2t4SFnQk3kJGoBwo7Pm9f7u9aYpqbJyhVnaCho6SnqK26vMQGCwwVHTo/RVGmp8zNoAcZGiIlxcYEICMlJigzODpISkxQU1VWWFpcXmBjZWZrc3h9f4qkqq+wwNAvP14iewUDBC0DZQQBLy6Agh0DMQ8cBCQJHgUrBUQEDiqAqgYkBCQEKAg0CwGAkIE3CRYKCICYOQNjCAkwFgUhAxsFAUA4BEsFKAQDBAkICQdAICcEDAk2AzoFGgcEDAdQSTczDTMHBoFgH4GBTgQeD0MOGQcKBkQMJwl1Cz9BKgY7BQoGUQYBBRADBYCLXiJICAqApl4iRQsKBg0TOAgKNhoDDwQQgWBTDAGBAEgIUx05gQdGCh0DR0k3Aw4ICoKmg5pmdQuAxIq8hC+P0YJHobmCOQcqBAJgJgpGCigFE4NwRQsvEBFAAh6X7ROC86UNgR9RgYyJBGsFDQMJBxCTYID2CnMIbhdGgLpXCRKAjoFHA4VCDxWFUCuH1YDXKUsFCgQChKA8BgEEVQUbNAKBDiwEZAxWCg0DXAQ9OR0NLAQJBwIOBoCag9ULDQMJB3QMVSsMBDgICgYoCB5SDAQ9AxwUGCgBDxeGGUJvcnJvd0Vycm9yQm9ycm93TXV0RXJyb3JjYWxsZWQgYE9wdGlvbjo6dW53cmFwKClgIG9uIGEgYE5vbmVgIHZhbHVlL2NoZWNrb3V0L3NyYy9saWJjb3JlL29wdGlvbi5yc1QhIhkNAQIDEUscDBAECx0SHidobm9wcWIgBQYPExQVGggWBygkFxgJCg4bHyUjg4J9JiorPD0+P0NHSk1YWVpbXF1eX2BhY2RlZmdpamtscnN0eXp7fABJbGxlZ2FsIGJ5dGUgc2VxdWVuY2UARG9tYWluIGVycm9yAFJlc3VsdCBub3QgcmVwcmVzZW50YWJsZQBOb3QgYSB0dHkAUGVybWlzc2lvbiBkZW5pZWQAT3BlcmF0aW9uIG5vdCBwZXJtaXR0ZWQATm8gc3VjaCBmaWxlIG9yIGRpcmVjdG9yeQBObyBzdWNoIHByb2Nlc3MARmlsZSBleGlzdHMAVmFsdWUgdG9vIGxhcmdlIGZvciBkYXRhIHR5cGUATm8gc3BhY2UgbGVmdCBvbiBkZXZpY2UAT3V0IG9mIG1lbW9yeQBSZXNvdXJjZSBidXN5AEludGVycnVwdGVkIHN5c3RlbSBjYWxsAFJlc291cmNlIHRlbXBvcmFyaWx5IHVuYXZhaWxhYmxlAEludmFsaWQgc2VlawBDcm9zcy1kZXZpY2UgbGluawBSZWFkLW9ubHkgZmlsZSBzeXN0ZW0ARGlyZWN0b3J5IG5vdCBlbXB0eQBDb25uZWN0aW9uIHJlc2V0IGJ5IHBlZXIAT3BlcmF0aW9uIHRpbWVkIG91dABDb25uZWN0aW9uIHJlZnVzZWQASG9zdCBpcyBkb3duAEhvc3QgaXMgdW5yZWFjaGFibGUAQWRkcmVzcyBpbiB1c2UAQnJva2VuIHBpcGUASS9PIGVycm9yAE5vIHN1Y2ggZGV2aWNlIG9yIGFkZHJlc3MAQmxvY2sgZGV2aWNlIHJlcXVpcmVkAE5vIHN1Y2ggZGV2aWNlAE5vdCBhIGRpcmVjdG9yeQBJcyBhIGRpcmVjdG9yeQBUZXh0IGZpbGUgYnVzeQBFeGVjIGZvcm1hdCBlcnJvcgBJbnZhbGlkIGFyZ3VtZW50AEFyZ3VtZW50IGxpc3QgdG9vIGxvbmcAU3ltYm9saWMgbGluayBsb29wAEZpbGVuYW1lIHRvbyBsb25nAFRvbyBtYW55IG9wZW4gZmlsZXMgaW4gc3lzdGVtAE5vIGZpbGUgZGVzY3JpcHRvcnMgYXZhaWxhYmxlAEJhZCBmaWxlIGRlc2NyaXB0b3IATm8gY2hpbGQgcHJvY2VzcwBCYWQgYWRkcmVzcwBGaWxlIHRvbyBsYXJnZQBUb28gbWFueSBsaW5rcwBObyBsb2NrcyBhdmFpbGFibGUAUmVzb3VyY2UgZGVhZGxvY2sgd291bGQgb2NjdXIAU3RhdGUgbm90IHJlY292ZXJhYmxlAFByZXZpb3VzIG93bmVyIGRpZWQAT3BlcmF0aW9uIGNhbmNlbGVkAEZ1bmN0aW9uIG5vdCBpbXBsZW1lbnRlZABObyBtZXNzYWdlIG9mIGRlc2lyZWQgdHlwZQBJZGVudGlmaWVyIHJlbW92ZWQARGV2aWNlIG5vdCBhIHN0cmVhbQBObyBkYXRhIGF2YWlsYWJsZQBEZXZpY2UgdGltZW91dABPdXQgb2Ygc3RyZWFtcyByZXNvdXJjZXMATGluayBoYXMgYmVlbiBzZXZlcmVkAFByb3RvY29sIGVycm9yAEJhZCBtZXNzYWdlAEZpbGUgZGVzY3JpcHRvciBpbiBiYWQgc3RhdGUATm90IGEgc29ja2V0AERlc3RpbmF0aW9uIGFkZHJlc3MgcmVxdWlyZWQATWVzc2FnZSB0b28gbGFyZ2UAUHJvdG9jb2wgd3JvbmcgdHlwZSBmb3Igc29ja2V0AFByb3RvY29sIG5vdCBhdmFpbGFibGUAUHJvdG9jb2wgbm90IHN1cHBvcnRlZABTb2NrZXQgdHlwZSBub3Qgc3VwcG9ydGVkAE5vdCBzdXBwb3J0ZWQAUHJvdG9jb2wgZmFtaWx5IG5vdCBzdXBwb3J0ZWQAQWRkcmVzcyBmYW1pbHkgbm90IHN1cHBvcnRlZCBieSBwcm90b2NvbABBZGRyZXNzIG5vdCBhdmFpbGFibGUATmV0d29yayBpcyBkb3duAE5ldHdvcmsgdW5yZWFjaGFibGUAQ29ubmVjdGlvbiByZXNldCBieSBuZXR3b3JrAENvbm5lY3Rpb24gYWJvcnRlZABObyBidWZmZXIgc3BhY2UgYXZhaWxhYmxlAFNvY2tldCBpcyBjb25uZWN0ZWQAU29ja2V0IG5vdCBjb25uZWN0ZWQAQ2Fubm90IHNlbmQgYWZ0ZXIgc29ja2V0IHNodXRkb3duAE9wZXJhdGlvbiBhbHJlYWR5IGluIHByb2dyZXNzAE9wZXJhdGlvbiBpbiBwcm9ncmVzcwBTdGFsZSBmaWxlIGhhbmRsZQBSZW1vdGUgSS9PIGVycm9yAFF1b3RhIGV4Y2VlZGVkAE5vIG1lZGl1bSBmb3VuZABXcm9uZyBtZWRpdW0gdHlwZQBObyBlcnJvciBpbmZvcm1hdGlvbg==";
    var tempDoublePtr = STATICTOP;

    function __ZSt18uncaught_exceptionv() {
      return !!__ZSt18uncaught_exceptionv.uncaught_exception;
    }

    STATICTOP += 16;
    var EXCEPTIONS = {
      last: 0,
      caught: [],
      infos: {},
      deAdjust: function deAdjust(e) {
        if (!e || EXCEPTIONS.infos[e]) return e;

        for (var t in EXCEPTIONS.infos) {
          if (EXCEPTIONS.infos[t].adjusted === e) return t;
        }

        return e;
      },
      addRef: function addRef(e) {
        e && EXCEPTIONS.infos[e].refcount++;
      },
      decRef: function decRef(e) {
        if (e) {
          var t = EXCEPTIONS.infos[e];
          assert(t.refcount > 0), t.refcount--, 0 !== t.refcount || t.rethrown || (t.destructor && Module.dynCall_vi(t.destructor, e), delete EXCEPTIONS.infos[e], ___cxa_free_exception(e));
        }
      },
      clearRef: function clearRef(e) {
        e && (EXCEPTIONS.infos[e].refcount = 0);
      }
    };

    function ___resumeException(e) {
      throw EXCEPTIONS.last || (EXCEPTIONS.last = e), e;
    }

    function ___cxa_find_matching_catch() {
      var e = EXCEPTIONS.last;
      if (!e) return 0 | (Runtime.setTempRet0(0), 0);
      var t = EXCEPTIONS.infos[e],
          a = t.type;
      if (!a) return 0 | (Runtime.setTempRet0(0), e);
      var r = Array.prototype.slice.call(arguments);

      Module.___cxa_is_pointer_type(a);

      ___cxa_find_matching_catch.buffer || (___cxa_find_matching_catch.buffer = _malloc(4)), HEAP32[___cxa_find_matching_catch.buffer >> 2] = e, e = ___cxa_find_matching_catch.buffer;

      for (var n = 0; n < r.length; n++) {
        if (r[n] && Module.___cxa_can_catch(r[n], a, e)) return e = HEAP32[e >> 2], t.adjusted = e, 0 | (Runtime.setTempRet0(r[n]), e);
      }

      return e = HEAP32[e >> 2], 0 | (Runtime.setTempRet0(a), e);
    }

    function ___cxa_throw(e, t, a) {
      throw EXCEPTIONS.infos[e] = {
        ptr: e,
        adjusted: e,
        type: t,
        destructor: a,
        refcount: 0,
        caught: !1,
        rethrown: !1
      }, EXCEPTIONS.last = e, "uncaught_exception" in __ZSt18uncaught_exceptionv ? __ZSt18uncaught_exceptionv.uncaught_exception++ : __ZSt18uncaught_exceptionv.uncaught_exception = 1, e;
    }

    function __Unwind_FindEnclosingFunction() {
      return 0;
    }

    function _emscripten_set_main_loop_timing(e, t) {
      if (Browser.mainLoop.timingMode = e, Browser.mainLoop.timingValue = t, !Browser.mainLoop.func) return 1;
      if (0 == e) Browser.mainLoop.scheduler = function () {
        var e = 0 | Math.max(0, Browser.mainLoop.tickStartTime + t - _emscripten_get_now());
        setTimeout(Browser.mainLoop.runner, e);
      }, Browser.mainLoop.method = "timeout";else if (1 == e) Browser.mainLoop.scheduler = function () {
        Browser.requestAnimationFrame(Browser.mainLoop.runner);
      }, Browser.mainLoop.method = "rAF";else if (2 == e) {
        if (!window.setImmediate) {
          var a = [],
              r = "setimmediate";
          window.addEventListener("message", function (e) {
            e.source === window && e.data === r && (e.stopPropagation(), a.shift()());
          }, !0), window.setImmediate = function (e) {
            a.push(e), ENVIRONMENT_IS_WORKER ? (void 0 === Module.setImmediates && (Module.setImmediates = []), Module.setImmediates.push(e), window.postMessage({
              target: r
            })) : window.postMessage(r, "*");
          };
        }

        Browser.mainLoop.scheduler = function () {
          window.setImmediate(Browser.mainLoop.runner);
        }, Browser.mainLoop.method = "immediate";
      }
      return 0;
    }

    function _emscripten_get_now() {
      abort();
    }

    function _emscripten_set_main_loop(e, t, a, r, n) {
      var s;
      Module.noExitRuntime = !0, assert(!Browser.mainLoop.func, "emscripten_set_main_loop: there can only be one main loop function at once: call emscripten_cancel_main_loop to cancel the previous one before setting a new one with different parameters."), Browser.mainLoop.func = e, Browser.mainLoop.arg = r, s = void 0 !== r ? function () {
        Module.dynCall_vi(e, r);
      } : function () {
        Module.dynCall_v(e);
      };
      var o = Browser.mainLoop.currentlyRunningMainloop;
      if (Browser.mainLoop.runner = function () {
        if (!ABORT) if (Browser.mainLoop.queue.length > 0) {
          var e = Date.now(),
              t = Browser.mainLoop.queue.shift();

          if (t.func(t.arg), Browser.mainLoop.remainingBlockers) {
            var a = Browser.mainLoop.remainingBlockers,
                r = a % 1 == 0 ? a - 1 : Math.floor(a);
            t.counted ? Browser.mainLoop.remainingBlockers = r : (r += .5, Browser.mainLoop.remainingBlockers = (8 * a + r) / 9);
          }

          if (console.log('main loop blocker "' + t.name + '" took ' + (Date.now() - e) + " ms"), Browser.mainLoop.updateStatus(), o < Browser.mainLoop.currentlyRunningMainloop) return;
          setTimeout(Browser.mainLoop.runner, 0);
        } else o < Browser.mainLoop.currentlyRunningMainloop || (Browser.mainLoop.currentFrameNumber = Browser.mainLoop.currentFrameNumber + 1 | 0, 1 == Browser.mainLoop.timingMode && Browser.mainLoop.timingValue > 1 && Browser.mainLoop.currentFrameNumber % Browser.mainLoop.timingValue != 0 ? Browser.mainLoop.scheduler() : (0 == Browser.mainLoop.timingMode && (Browser.mainLoop.tickStartTime = _emscripten_get_now()), "timeout" === Browser.mainLoop.method && Module.ctx && (Module.printErr("Looks like you are rendering without using requestAnimationFrame for the main loop. You should use 0 for the frame rate in emscripten_set_main_loop in order to use requestAnimationFrame, as that can greatly improve your frame rates!"), Browser.mainLoop.method = ""), Browser.mainLoop.runIter(s), o < Browser.mainLoop.currentlyRunningMainloop || ("object" == typeof SDL && SDL.audio && SDL.audio.queueNewAudioData && SDL.audio.queueNewAudioData(), Browser.mainLoop.scheduler())));
      }, n || (t && t > 0 ? _emscripten_set_main_loop_timing(0, 1e3 / t) : _emscripten_set_main_loop_timing(1, 1), Browser.mainLoop.scheduler()), a) throw "SimulateInfiniteLoop";
    }

    var Browser = {
      mainLoop: {
        scheduler: null,
        method: "",
        currentlyRunningMainloop: 0,
        func: null,
        arg: 0,
        timingMode: 0,
        timingValue: 0,
        currentFrameNumber: 0,
        queue: [],
        pause: function pause() {
          Browser.mainLoop.scheduler = null, Browser.mainLoop.currentlyRunningMainloop++;
        },
        resume: function resume() {
          Browser.mainLoop.currentlyRunningMainloop++;
          var e = Browser.mainLoop.timingMode,
              t = Browser.mainLoop.timingValue,
              a = Browser.mainLoop.func;
          Browser.mainLoop.func = null, _emscripten_set_main_loop(a, 0, !1, Browser.mainLoop.arg, !0), _emscripten_set_main_loop_timing(e, t), Browser.mainLoop.scheduler();
        },
        updateStatus: function updateStatus() {
          if (Module.setStatus) {
            var e = Module.statusMessage || "Please wait...",
                t = Browser.mainLoop.remainingBlockers,
                a = Browser.mainLoop.expectedBlockers;
            t ? t < a ? Module.setStatus(e + " (" + (a - t) + "/" + a + ")") : Module.setStatus(e) : Module.setStatus("");
          }
        },
        runIter: function runIter(e) {
          if (!ABORT) {
            if (Module.preMainLoop) if (!1 === Module.preMainLoop()) return;

            try {
              e();
            } catch (e) {
              if (e instanceof ExitStatus) return;
              throw e && "object" == typeof e && e.stack && Module.printErr("exception thrown: " + [e, e.stack]), e;
            }

            Module.postMainLoop && Module.postMainLoop();
          }
        }
      },
      isFullscreen: !1,
      pointerLock: !1,
      moduleContextCreatedCallbacks: [],
      workers: [],
      init: function init() {
        if (Module.preloadPlugins || (Module.preloadPlugins = []), !Browser.initted) {
          Browser.initted = !0;

          try {
            new Blob(), Browser.hasBlobConstructor = !0;
          } catch (e) {
            Browser.hasBlobConstructor = !1, console.log("warning: no blob constructor, cannot create blobs with mimetypes");
          }

          Browser.BlobBuilder = "undefined" != typeof MozBlobBuilder ? MozBlobBuilder : "undefined" != typeof WebKitBlobBuilder ? WebKitBlobBuilder : Browser.hasBlobConstructor ? null : console.log("warning: no BlobBuilder"), Browser.URLObject = "undefined" != typeof window ? window.URL ? window.URL : window.webkitURL : void 0, Module.noImageDecoding || void 0 !== Browser.URLObject || (console.log("warning: Browser does not support creating object URLs. Built-in browser image decoding will not be available."), Module.noImageDecoding = !0);
          var e = {
            canHandle: function canHandle(e) {
              return !Module.noImageDecoding && /\.(jpg|jpeg|png|bmp)$/i.test(e);
            },
            handle: function handle(e, t, a, r) {
              var n = null;
              if (Browser.hasBlobConstructor) try {
                (n = new Blob([e], {
                  type: Browser.getMimetype(t)
                })).size !== e.length && (n = new Blob([new Uint8Array(e).buffer], {
                  type: Browser.getMimetype(t)
                }));
              } catch (e) {
                Runtime.warnOnce("Blob constructor present but fails: " + e + "; falling back to blob builder");
              }

              if (!n) {
                var s = new Browser.BlobBuilder();
                s.append(new Uint8Array(e).buffer), n = s.getBlob();
              }

              var o = Browser.URLObject.createObjectURL(n),
                  i = new Image();
              i.onload = function () {
                assert(i.complete, "Image " + t + " could not be decoded");
                var r = document.createElement("canvas");
                r.width = i.width, r.height = i.height, r.getContext("2d").drawImage(i, 0, 0), Module.preloadedImages[t] = r, Browser.URLObject.revokeObjectURL(o), a && a(e);
              }, i.onerror = function (e) {
                console.log("Image " + o + " could not be decoded"), r && r();
              }, i.src = o;
            }
          };
          Module.preloadPlugins.push(e);
          var t = {
            canHandle: function canHandle(e) {
              return !Module.noAudioDecoding && e.substr(-4) in {
                ".ogg": 1,
                ".wav": 1,
                ".mp3": 1
              };
            },
            handle: function handle(e, t, a, r) {
              var n = !1;

              function s(r) {
                n || (n = !0, Module.preloadedAudios[t] = r, a && a(e));
              }

              function o() {
                n || (n = !0, Module.preloadedAudios[t] = new Audio(), r && r());
              }

              if (!Browser.hasBlobConstructor) return o();

              try {
                var i = new Blob([e], {
                  type: Browser.getMimetype(t)
                });
              } catch (e) {
                return o();
              }

              var c = Browser.URLObject.createObjectURL(i),
                  u = new Audio();
              u.addEventListener("canplaythrough", function () {
                s(u);
              }, !1), u.onerror = function (a) {
                n || (console.log("warning: browser could not fully decode audio " + t + ", trying slower base64 approach"), u.src = "data:audio/x-" + t.substr(-3) + ";base64," + function (e) {
                  for (var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = "", r = 0, n = 0, s = 0; s < e.length; s++) {
                    for (r = r << 8 | e[s], n += 8; n >= 6;) {
                      var o = r >> n - 6 & 63;
                      n -= 6, a += t[o];
                    }
                  }

                  return 2 == n ? (a += t[(3 & r) << 4], a += "==") : 4 == n && (a += t[(15 & r) << 2], a += "="), a;
                }(e), s(u));
              }, u.src = c, Browser.safeSetTimeout(function () {
                s(u);
              }, 1e4);
            }
          };
          Module.preloadPlugins.push(t);
          var a = Module.canvas;
          a && (a.requestPointerLock = a.requestPointerLock || a.mozRequestPointerLock || a.webkitRequestPointerLock || a.msRequestPointerLock || function () {}, a.exitPointerLock = document.exitPointerLock || document.mozExitPointerLock || document.webkitExitPointerLock || document.msExitPointerLock || function () {}, a.exitPointerLock = a.exitPointerLock.bind(document), document.addEventListener("pointerlockchange", r, !1), document.addEventListener("mozpointerlockchange", r, !1), document.addEventListener("webkitpointerlockchange", r, !1), document.addEventListener("mspointerlockchange", r, !1), Module.elementPointerLock && a.addEventListener("click", function (e) {
            !Browser.pointerLock && Module.canvas.requestPointerLock && (Module.canvas.requestPointerLock(), e.preventDefault());
          }, !1));
        }

        function r() {
          Browser.pointerLock = document.pointerLockElement === Module.canvas || document.mozPointerLockElement === Module.canvas || document.webkitPointerLockElement === Module.canvas || document.msPointerLockElement === Module.canvas;
        }
      },
      createContext: function createContext(e, t, a, r) {
        if (t && Module.ctx && e == Module.canvas) return Module.ctx;
        var n, s;

        if (t) {
          var o = {
            antialias: !1,
            alpha: !1
          };
          if (r) for (var i in r) {
            o[i] = r[i];
          }
          (s = GL.createContext(e, o)) && (n = GL.getContext(s).GLctx);
        } else n = e.getContext("2d");

        return n ? (a && (t || assert("undefined" == typeof GLctx, "cannot set in module if GLctx is used, but we are a non-GL context that would replace it"), Module.ctx = n, t && GL.makeContextCurrent(s), Module.useWebGL = t, Browser.moduleContextCreatedCallbacks.forEach(function (e) {
          e();
        }), Browser.init()), n) : null;
      },
      destroyContext: function destroyContext(e, t, a) {},
      fullscreenHandlersInstalled: !1,
      lockPointer: void 0,
      resizeCanvas: void 0,
      requestFullscreen: function requestFullscreen(e, t, a) {
        Browser.lockPointer = e, Browser.resizeCanvas = t, Browser.vrDevice = a, void 0 === Browser.lockPointer && (Browser.lockPointer = !0), void 0 === Browser.resizeCanvas && (Browser.resizeCanvas = !1), void 0 === Browser.vrDevice && (Browser.vrDevice = null);
        var r = Module.canvas;

        function n() {
          Browser.isFullscreen = !1;
          var e = r.parentNode;
          (document.fullscreenElement || document.mozFullScreenElement || document.msFullscreenElement || document.webkitFullscreenElement || document.webkitCurrentFullScreenElement) === e ? (r.exitFullscreen = document.exitFullscreen || document.cancelFullScreen || document.mozCancelFullScreen || document.msExitFullscreen || document.webkitCancelFullScreen || function () {}, r.exitFullscreen = r.exitFullscreen.bind(document), Browser.lockPointer && r.requestPointerLock(), Browser.isFullscreen = !0, Browser.resizeCanvas && Browser.setFullscreenCanvasSize()) : (e.parentNode.insertBefore(r, e), e.parentNode.removeChild(e), Browser.resizeCanvas && Browser.setWindowedCanvasSize()), Module.onFullScreen && Module.onFullScreen(Browser.isFullscreen), Module.onFullscreen && Module.onFullscreen(Browser.isFullscreen), Browser.updateCanvasDimensions(r);
        }

        Browser.fullscreenHandlersInstalled || (Browser.fullscreenHandlersInstalled = !0, document.addEventListener("fullscreenchange", n, !1), document.addEventListener("mozfullscreenchange", n, !1), document.addEventListener("webkitfullscreenchange", n, !1), document.addEventListener("MSFullscreenChange", n, !1));
        var s = document.createElement("div");
        r.parentNode.insertBefore(s, r), s.appendChild(r), s.requestFullscreen = s.requestFullscreen || s.mozRequestFullScreen || s.msRequestFullscreen || (s.webkitRequestFullscreen ? function () {
          s.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
        } : null) || (s.webkitRequestFullScreen ? function () {
          s.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
        } : null), a ? s.requestFullscreen({
          vrDisplay: a
        }) : s.requestFullscreen();
      },
      requestFullScreen: function requestFullScreen(e, t, a) {
        return Module.printErr("Browser.requestFullScreen() is deprecated. Please call Browser.requestFullscreen instead."), Browser.requestFullScreen = function (e, t, a) {
          return Browser.requestFullscreen(e, t, a);
        }, Browser.requestFullscreen(e, t, a);
      },
      nextRAF: 0,
      fakeRequestAnimationFrame: function fakeRequestAnimationFrame(e) {
        var t = Date.now();
        if (0 === Browser.nextRAF) Browser.nextRAF = t + 1e3 / 60;else for (; t + 2 >= Browser.nextRAF;) {
          Browser.nextRAF += 1e3 / 60;
        }
        var a = Math.max(Browser.nextRAF - t, 0);
        setTimeout(e, a);
      },
      requestAnimationFrame: function requestAnimationFrame(e) {
        "undefined" == typeof window ? Browser.fakeRequestAnimationFrame(e) : (window.requestAnimationFrame || (window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || window.oRequestAnimationFrame || Browser.fakeRequestAnimationFrame), window.requestAnimationFrame(e));
      },
      safeCallback: function safeCallback(e) {
        return function () {
          if (!ABORT) return e.apply(null, arguments);
        };
      },
      allowAsyncCallbacks: !0,
      queuedAsyncCallbacks: [],
      pauseAsyncCallbacks: function pauseAsyncCallbacks() {
        Browser.allowAsyncCallbacks = !1;
      },
      resumeAsyncCallbacks: function resumeAsyncCallbacks() {
        if (Browser.allowAsyncCallbacks = !0, Browser.queuedAsyncCallbacks.length > 0) {
          var e = Browser.queuedAsyncCallbacks;
          Browser.queuedAsyncCallbacks = [], e.forEach(function (e) {
            e();
          });
        }
      },
      safeRequestAnimationFrame: function safeRequestAnimationFrame(e) {
        return Browser.requestAnimationFrame(function () {
          ABORT || (Browser.allowAsyncCallbacks ? e() : Browser.queuedAsyncCallbacks.push(e));
        });
      },
      safeSetTimeout: function safeSetTimeout(e, t) {
        return Module.noExitRuntime = !0, setTimeout(function () {
          ABORT || (Browser.allowAsyncCallbacks ? e() : Browser.queuedAsyncCallbacks.push(e));
        }, t);
      },
      safeSetInterval: function safeSetInterval(e, t) {
        return Module.noExitRuntime = !0, setInterval(function () {
          ABORT || Browser.allowAsyncCallbacks && e();
        }, t);
      },
      getMimetype: function getMimetype(e) {
        return {
          jpg: "image/jpeg",
          jpeg: "image/jpeg",
          png: "image/png",
          bmp: "image/bmp",
          ogg: "audio/ogg",
          wav: "audio/wav",
          mp3: "audio/mpeg"
        }[e.substr(e.lastIndexOf(".") + 1)];
      },
      getUserMedia: function getUserMedia(e) {
        window.getUserMedia || (window.getUserMedia = navigator.getUserMedia || navigator.mozGetUserMedia), window.getUserMedia(e);
      },
      getMovementX: function getMovementX(e) {
        return e.movementX || e.mozMovementX || e.webkitMovementX || 0;
      },
      getMovementY: function getMovementY(e) {
        return e.movementY || e.mozMovementY || e.webkitMovementY || 0;
      },
      getMouseWheelDelta: function getMouseWheelDelta(e) {
        var t = 0;

        switch (e.type) {
          case "DOMMouseScroll":
            t = e.detail;
            break;

          case "mousewheel":
            t = e.wheelDelta;
            break;

          case "wheel":
            t = e.deltaY;
            break;

          default:
            throw "unrecognized mouse wheel event: " + e.type;
        }

        return t;
      },
      mouseX: 0,
      mouseY: 0,
      mouseMovementX: 0,
      mouseMovementY: 0,
      touches: {},
      lastTouches: {},
      calculateMouseEvent: function calculateMouseEvent(e) {
        if (Browser.pointerLock) "mousemove" != e.type && "mozMovementX" in e ? Browser.mouseMovementX = Browser.mouseMovementY = 0 : (Browser.mouseMovementX = Browser.getMovementX(e), Browser.mouseMovementY = Browser.getMovementY(e)), "undefined" != typeof SDL ? (Browser.mouseX = SDL.mouseX + Browser.mouseMovementX, Browser.mouseY = SDL.mouseY + Browser.mouseMovementY) : (Browser.mouseX += Browser.mouseMovementX, Browser.mouseY += Browser.mouseMovementY);else {
          var t = Module.canvas.getBoundingClientRect(),
              a = Module.canvas.width,
              r = Module.canvas.height,
              n = void 0 !== window.scrollX ? window.scrollX : window.pageXOffset,
              s = void 0 !== window.scrollY ? window.scrollY : window.pageYOffset;

          if ("touchstart" === e.type || "touchend" === e.type || "touchmove" === e.type) {
            var o = e.touch;
            if (void 0 === o) return;
            var i = o.pageX - (n + t.left),
                c = o.pageY - (s + t.top),
                u = {
              x: i *= a / t.width,
              y: c *= r / t.height
            };
            if ("touchstart" === e.type) Browser.lastTouches[o.identifier] = u, Browser.touches[o.identifier] = u;else if ("touchend" === e.type || "touchmove" === e.type) {
              var d = Browser.touches[o.identifier];
              d || (d = u), Browser.lastTouches[o.identifier] = d, Browser.touches[o.identifier] = u;
            }
            return;
          }

          var f = e.pageX - (n + t.left),
              l = e.pageY - (s + t.top);
          f *= a / t.width, l *= r / t.height, Browser.mouseMovementX = f - Browser.mouseX, Browser.mouseMovementY = l - Browser.mouseY, Browser.mouseX = f, Browser.mouseY = l;
        }
      },
      asyncLoad: function asyncLoad(e, t, a, r) {
        var n = r ? "" : getUniqueRunDependency("al " + e);
        Module.readAsync(e, function (a) {
          assert(a, 'Loading data file "' + e + '" failed (no arrayBuffer).'), t(new Uint8Array(a)), n && removeRunDependency(n);
        }, function (t) {
          if (!a) throw 'Loading data file "' + e + '" failed.';
          a();
        }), n && addRunDependency(n);
      },
      resizeListeners: [],
      updateResizeListeners: function updateResizeListeners() {
        var e = Module.canvas;
        Browser.resizeListeners.forEach(function (t) {
          t(e.width, e.height);
        });
      },
      setCanvasSize: function setCanvasSize(e, t, a) {
        var r = Module.canvas;
        Browser.updateCanvasDimensions(r, e, t), a || Browser.updateResizeListeners();
      },
      windowedWidth: 0,
      windowedHeight: 0,
      setFullscreenCanvasSize: function setFullscreenCanvasSize() {
        if ("undefined" != typeof SDL) {
          var e = HEAPU32[SDL.screen + 0 * Runtime.QUANTUM_SIZE >> 2];
          e |= 8388608, HEAP32[SDL.screen + 0 * Runtime.QUANTUM_SIZE >> 2] = e;
        }

        Browser.updateResizeListeners();
      },
      setWindowedCanvasSize: function setWindowedCanvasSize() {
        if ("undefined" != typeof SDL) {
          var e = HEAPU32[SDL.screen + 0 * Runtime.QUANTUM_SIZE >> 2];
          e &= -8388609, HEAP32[SDL.screen + 0 * Runtime.QUANTUM_SIZE >> 2] = e;
        }

        Browser.updateResizeListeners();
      },
      updateCanvasDimensions: function updateCanvasDimensions(e, t, a) {
        t && a ? (e.widthNative = t, e.heightNative = a) : (t = e.widthNative, a = e.heightNative);
        var r = t,
            n = a;

        if (Module.forcedAspectRatio && Module.forcedAspectRatio > 0 && (r / n < Module.forcedAspectRatio ? r = Math.round(n * Module.forcedAspectRatio) : n = Math.round(r / Module.forcedAspectRatio)), (document.fullscreenElement || document.mozFullScreenElement || document.msFullscreenElement || document.webkitFullscreenElement || document.webkitCurrentFullScreenElement) === e.parentNode && "undefined" != typeof screen) {
          var s = Math.min(screen.width / r, screen.height / n);
          r = Math.round(r * s), n = Math.round(n * s);
        }

        Browser.resizeCanvas ? (e.width != r && (e.width = r), e.height != n && (e.height = n), void 0 !== e.style && (e.style.removeProperty("width"), e.style.removeProperty("height"))) : (e.width != t && (e.width = t), e.height != a && (e.height = a), void 0 !== e.style && (r != t || n != a ? (e.style.setProperty("width", r + "px", "important"), e.style.setProperty("height", n + "px", "important")) : (e.style.removeProperty("width"), e.style.removeProperty("height"))));
      },
      wgetRequests: {},
      nextWgetRequestHandle: 0,
      getNextWgetRequestHandle: function getNextWgetRequestHandle() {
        var e = Browser.nextWgetRequestHandle;
        return Browser.nextWgetRequestHandle++, e;
      }
    };

    function _emscripten_exit_with_live_runtime() {
      throw Module.noExitRuntime = !0, "SimulateInfiniteLoop";
    }

    function _pthread_mutexattr_settype() {}

    function _abort() {
      Module.abort();
    }

    function _pthread_cond_destroy() {
      return 0;
    }

    function _pthread_condattr_destroy() {
      return 0;
    }

    function ___cxa_free_exception(e) {
      try {
        return _free(e);
      } catch (e) {}
    }

    function ___lock() {}

    function ___unlock() {}

    function _pthread_cond_wait() {
      return 0;
    }

    var PTHREAD_SPECIFIC = {};

    function _pthread_getspecific(e) {
      return PTHREAD_SPECIFIC[e] || 0;
    }

    var PTHREAD_SPECIFIC_NEXT_KEY = 1,
        ERRNO_CODES = {
      EPERM: 1,
      ENOENT: 2,
      ESRCH: 3,
      EINTR: 4,
      EIO: 5,
      ENXIO: 6,
      E2BIG: 7,
      ENOEXEC: 8,
      EBADF: 9,
      ECHILD: 10,
      EAGAIN: 11,
      EWOULDBLOCK: 11,
      ENOMEM: 12,
      EACCES: 13,
      EFAULT: 14,
      ENOTBLK: 15,
      EBUSY: 16,
      EEXIST: 17,
      EXDEV: 18,
      ENODEV: 19,
      ENOTDIR: 20,
      EISDIR: 21,
      EINVAL: 22,
      ENFILE: 23,
      EMFILE: 24,
      ENOTTY: 25,
      ETXTBSY: 26,
      EFBIG: 27,
      ENOSPC: 28,
      ESPIPE: 29,
      EROFS: 30,
      EMLINK: 31,
      EPIPE: 32,
      EDOM: 33,
      ERANGE: 34,
      ENOMSG: 42,
      EIDRM: 43,
      ECHRNG: 44,
      EL2NSYNC: 45,
      EL3HLT: 46,
      EL3RST: 47,
      ELNRNG: 48,
      EUNATCH: 49,
      ENOCSI: 50,
      EL2HLT: 51,
      EDEADLK: 35,
      ENOLCK: 37,
      EBADE: 52,
      EBADR: 53,
      EXFULL: 54,
      ENOANO: 55,
      EBADRQC: 56,
      EBADSLT: 57,
      EDEADLOCK: 35,
      EBFONT: 59,
      ENOSTR: 60,
      ENODATA: 61,
      ETIME: 62,
      ENOSR: 63,
      ENONET: 64,
      ENOPKG: 65,
      EREMOTE: 66,
      ENOLINK: 67,
      EADV: 68,
      ESRMNT: 69,
      ECOMM: 70,
      EPROTO: 71,
      EMULTIHOP: 72,
      EDOTDOT: 73,
      EBADMSG: 74,
      ENOTUNIQ: 76,
      EBADFD: 77,
      EREMCHG: 78,
      ELIBACC: 79,
      ELIBBAD: 80,
      ELIBSCN: 81,
      ELIBMAX: 82,
      ELIBEXEC: 83,
      ENOSYS: 38,
      ENOTEMPTY: 39,
      ENAMETOOLONG: 36,
      ELOOP: 40,
      EOPNOTSUPP: 95,
      EPFNOSUPPORT: 96,
      ECONNRESET: 104,
      ENOBUFS: 105,
      EAFNOSUPPORT: 97,
      EPROTOTYPE: 91,
      ENOTSOCK: 88,
      ENOPROTOOPT: 92,
      ESHUTDOWN: 108,
      ECONNREFUSED: 111,
      EADDRINUSE: 98,
      ECONNABORTED: 103,
      ENETUNREACH: 101,
      ENETDOWN: 100,
      ETIMEDOUT: 110,
      EHOSTDOWN: 112,
      EHOSTUNREACH: 113,
      EINPROGRESS: 115,
      EALREADY: 114,
      EDESTADDRREQ: 89,
      EMSGSIZE: 90,
      EPROTONOSUPPORT: 93,
      ESOCKTNOSUPPORT: 94,
      EADDRNOTAVAIL: 99,
      ENETRESET: 102,
      EISCONN: 106,
      ENOTCONN: 107,
      ETOOMANYREFS: 109,
      EUSERS: 87,
      EDQUOT: 122,
      ESTALE: 116,
      ENOTSUP: 95,
      ENOMEDIUM: 123,
      EILSEQ: 84,
      EOVERFLOW: 75,
      ECANCELED: 125,
      ENOTRECOVERABLE: 131,
      EOWNERDEAD: 130,
      ESTRPIPE: 86
    };

    function _pthread_key_create(e, t) {
      return 0 == e ? ERRNO_CODES.EINVAL : (HEAP32[e >> 2] = PTHREAD_SPECIFIC_NEXT_KEY, PTHREAD_SPECIFIC[PTHREAD_SPECIFIC_NEXT_KEY] = 0, PTHREAD_SPECIFIC_NEXT_KEY++, 0);
    }

    function _llvm_bswap_i64(e, t) {
      var a = _llvm_bswap_i32(t) >>> 0,
          r = _llvm_bswap_i32(e) >>> 0;
      return 0 | (Runtime.setTempRet0(r), a);
    }

    function _pthread_mutex_init() {}

    function _pthread_key_delete(e) {
      return e in PTHREAD_SPECIFIC ? (delete PTHREAD_SPECIFIC[e], 0) : ERRNO_CODES.EINVAL;
    }

    function _pthread_setspecific(e, t) {
      return e in PTHREAD_SPECIFIC ? (PTHREAD_SPECIFIC[e] = t, 0) : ERRNO_CODES.EINVAL;
    }

    function _pthread_mutexattr_destroy() {}

    function ___cxa_allocate_exception(e) {
      return _malloc(e);
    }

    var ERRNO_MESSAGES = {
      0: "Success",
      1: "Not super-user",
      2: "No such file or directory",
      3: "No such process",
      4: "Interrupted system call",
      5: "I/O error",
      6: "No such device or address",
      7: "Arg list too long",
      8: "Exec format error",
      9: "Bad file number",
      10: "No children",
      11: "No more processes",
      12: "Not enough core",
      13: "Permission denied",
      14: "Bad address",
      15: "Block device required",
      16: "Mount device busy",
      17: "File exists",
      18: "Cross-device link",
      19: "No such device",
      20: "Not a directory",
      21: "Is a directory",
      22: "Invalid argument",
      23: "Too many open files in system",
      24: "Too many open files",
      25: "Not a typewriter",
      26: "Text file busy",
      27: "File too large",
      28: "No space left on device",
      29: "Illegal seek",
      30: "Read only file system",
      31: "Too many links",
      32: "Broken pipe",
      33: "Math arg out of domain of func",
      34: "Math result not representable",
      35: "File locking deadlock error",
      36: "File or path name too long",
      37: "No record locks available",
      38: "Function not implemented",
      39: "Directory not empty",
      40: "Too many symbolic links",
      42: "No message of desired type",
      43: "Identifier removed",
      44: "Channel number out of range",
      45: "Level 2 not synchronized",
      46: "Level 3 halted",
      47: "Level 3 reset",
      48: "Link number out of range",
      49: "Protocol driver not attached",
      50: "No CSI structure available",
      51: "Level 2 halted",
      52: "Invalid exchange",
      53: "Invalid request descriptor",
      54: "Exchange full",
      55: "No anode",
      56: "Invalid request code",
      57: "Invalid slot",
      59: "Bad font file fmt",
      60: "Device not a stream",
      61: "No data (for no delay io)",
      62: "Timer expired",
      63: "Out of streams resources",
      64: "Machine is not on the network",
      65: "Package not installed",
      66: "The object is remote",
      67: "The link has been severed",
      68: "Advertise error",
      69: "Srmount error",
      70: "Communication error on send",
      71: "Protocol error",
      72: "Multihop attempted",
      73: "Cross mount point (not really error)",
      74: "Trying to read unreadable message",
      75: "Value too large for defined data type",
      76: "Given log. name not unique",
      77: "f.d. invalid for this operation",
      78: "Remote address changed",
      79: "Can   access a needed shared lib",
      80: "Accessing a corrupted shared lib",
      81: ".lib section in a.out corrupted",
      82: "Attempting to link in too many libs",
      83: "Attempting to exec a shared library",
      84: "Illegal byte sequence",
      86: "Streams pipe error",
      87: "Too many users",
      88: "Socket operation on non-socket",
      89: "Destination address required",
      90: "Message too long",
      91: "Protocol wrong type for socket",
      92: "Protocol not available",
      93: "Unknown protocol",
      94: "Socket type not supported",
      95: "Not supported",
      96: "Protocol family not supported",
      97: "Address family not supported by protocol family",
      98: "Address already in use",
      99: "Address not available",
      100: "Network interface is not configured",
      101: "Network is unreachable",
      102: "Connection reset by network",
      103: "Connection aborted",
      104: "Connection reset by peer",
      105: "No buffer space available",
      106: "Socket is already connected",
      107: "Socket is not connected",
      108: "Can't send after socket shutdown",
      109: "Too many references",
      110: "Connection timed out",
      111: "Connection refused",
      112: "Host is down",
      113: "Host is unreachable",
      114: "Socket already connected",
      115: "Connection already in progress",
      116: "Stale file handle",
      122: "Quota exceeded",
      123: "No medium (in tape drive)",
      125: "Operation canceled",
      130: "Previous owner died",
      131: "State not recoverable"
    };

    function ___setErrNo(e) {
      return Module.___errno_location && (HEAP32[Module.___errno_location() >> 2] = e), e;
    }

    var PATH = {
      splitPath: function splitPath(e) {
        return /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/.exec(e).slice(1);
      },
      normalizeArray: function normalizeArray(e, t) {
        for (var a = 0, r = e.length - 1; r >= 0; r--) {
          var n = e[r];
          "." === n ? e.splice(r, 1) : ".." === n ? (e.splice(r, 1), a++) : a && (e.splice(r, 1), a--);
        }

        if (t) for (; a; a--) {
          e.unshift("..");
        }
        return e;
      },
      normalize: function normalize(e) {
        var t = "/" === e.charAt(0),
            a = "/" === e.substr(-1);
        return (e = PATH.normalizeArray(e.split("/").filter(function (e) {
          return !!e;
        }), !t).join("/")) || t || (e = "."), e && a && (e += "/"), (t ? "/" : "") + e;
      },
      dirname: function dirname(e) {
        var t = PATH.splitPath(e),
            a = t[0],
            r = t[1];
        return a || r ? (r && (r = r.substr(0, r.length - 1)), a + r) : ".";
      },
      basename: function basename(e) {
        if ("/" === e) return "/";
        var t = e.lastIndexOf("/");
        return -1 === t ? e : e.substr(t + 1);
      },
      extname: function extname(e) {
        return PATH.splitPath(e)[3];
      },
      join: function join() {
        var e = Array.prototype.slice.call(arguments, 0);
        return PATH.normalize(e.join("/"));
      },
      join2: function join2(e, t) {
        return PATH.normalize(e + "/" + t);
      },
      resolve: function resolve() {
        for (var e = "", t = !1, a = arguments.length - 1; a >= -1 && !t; a--) {
          var r = a >= 0 ? arguments[a] : FS.cwd();
          if ("string" != typeof r) throw new TypeError("Arguments to path.resolve must be strings");
          if (!r) return "";
          e = r + "/" + e, t = "/" === r.charAt(0);
        }

        return (t ? "/" : "") + (e = PATH.normalizeArray(e.split("/").filter(function (e) {
          return !!e;
        }), !t).join("/")) || ".";
      },
      relative: function relative(e, t) {
        function a(e) {
          for (var t = 0; t < e.length && "" === e[t]; t++) {
            ;
          }

          for (var a = e.length - 1; a >= 0 && "" === e[a]; a--) {
            ;
          }

          return t > a ? [] : e.slice(t, a - t + 1);
        }

        e = PATH.resolve(e).substr(1), t = PATH.resolve(t).substr(1);

        for (var r = a(e.split("/")), n = a(t.split("/")), s = Math.min(r.length, n.length), o = s, i = 0; i < s; i++) {
          if (r[i] !== n[i]) {
            o = i;
            break;
          }
        }

        var c = [];

        for (i = o; i < r.length; i++) {
          c.push("..");
        }

        return (c = c.concat(n.slice(o))).join("/");
      }
    },
        TTY = {
      ttys: [],
      init: function init() {},
      shutdown: function shutdown() {},
      register: function register(e, t) {
        TTY.ttys[e] = {
          input: [],
          output: [],
          ops: t
        }, FS.registerDevice(e, TTY.stream_ops);
      },
      stream_ops: {
        open: function open(e) {
          var t = TTY.ttys[e.node.rdev];
          if (!t) throw new FS.ErrnoError(ERRNO_CODES.ENODEV);
          e.tty = t, e.seekable = !1;
        },
        close: function close(e) {
          e.tty.ops.flush(e.tty);
        },
        flush: function flush(e) {
          e.tty.ops.flush(e.tty);
        },
        read: function read(e, t, a, r, n) {
          if (!e.tty || !e.tty.ops.get_char) throw new FS.ErrnoError(ERRNO_CODES.ENXIO);

          for (var s = 0, o = 0; o < r; o++) {
            var i;

            try {
              i = e.tty.ops.get_char(e.tty);
            } catch (e) {
              throw new FS.ErrnoError(ERRNO_CODES.EIO);
            }

            if (void 0 === i && 0 === s) throw new FS.ErrnoError(ERRNO_CODES.EAGAIN);
            if (null == i) break;
            s++, t[a + o] = i;
          }

          return s && (e.node.timestamp = Date.now()), s;
        },
        write: function write(e, t, a, r, n) {
          if (!e.tty || !e.tty.ops.put_char) throw new FS.ErrnoError(ERRNO_CODES.ENXIO);

          for (var s = 0; s < r; s++) {
            try {
              e.tty.ops.put_char(e.tty, t[a + s]);
            } catch (e) {
              throw new FS.ErrnoError(ERRNO_CODES.EIO);
            }
          }

          return r && (e.node.timestamp = Date.now()), s;
        }
      },
      default_tty_ops: {
        get_char: function get_char(e) {
          if (!e.input.length) {
            var t = null;

            if (ENVIRONMENT_IS_NODE) {
              var a = new Buffer(256),
                  r = 0,
                  n = "win32" != process.platform,
                  s = process.stdin.fd;

              if (n) {
                var o = !1;

                try {
                  s = fs.openSync("/dev/stdin", "r"), o = !0;
                } catch (e) {}
              }

              try {
                r = fs.readSync(s, a, 0, 256, null);
              } catch (e) {
                if (-1 == e.toString().indexOf("EOF")) throw e;
                r = 0;
              }

              o && fs.closeSync(s), t = r > 0 ? a.slice(0, r).toString("utf-8") : null;
            } else "undefined" != typeof window && "function" == typeof window.prompt ? null !== (t = window.prompt("Input: ")) && (t += "\n") : "function" == typeof readline && null !== (t = readline()) && (t += "\n");

            if (!t) return null;
            e.input = intArrayFromString(t, !0);
          }

          return e.input.shift();
        },
        put_char: function put_char(e, t) {
          null === t || 10 === t ? (Module.print(UTF8ArrayToString(e.output, 0)), e.output = []) : 0 != t && e.output.push(t);
        },
        flush: function flush(e) {
          e.output && e.output.length > 0 && (Module.print(UTF8ArrayToString(e.output, 0)), e.output = []);
        }
      },
      default_tty1_ops: {
        put_char: function put_char(e, t) {
          null === t || 10 === t ? (Module.printErr(UTF8ArrayToString(e.output, 0)), e.output = []) : 0 != t && e.output.push(t);
        },
        flush: function flush(e) {
          e.output && e.output.length > 0 && (Module.printErr(UTF8ArrayToString(e.output, 0)), e.output = []);
        }
      }
    },
        MEMFS = {
      ops_table: null,
      mount: function mount(e) {
        return MEMFS.createNode(null, "/", 16895, 0);
      },
      createNode: function createNode(e, t, a, r) {
        if (FS.isBlkdev(a) || FS.isFIFO(a)) throw new FS.ErrnoError(ERRNO_CODES.EPERM);
        MEMFS.ops_table || (MEMFS.ops_table = {
          dir: {
            node: {
              getattr: MEMFS.node_ops.getattr,
              setattr: MEMFS.node_ops.setattr,
              lookup: MEMFS.node_ops.lookup,
              mknod: MEMFS.node_ops.mknod,
              rename: MEMFS.node_ops.rename,
              unlink: MEMFS.node_ops.unlink,
              rmdir: MEMFS.node_ops.rmdir,
              readdir: MEMFS.node_ops.readdir,
              symlink: MEMFS.node_ops.symlink
            },
            stream: {
              llseek: MEMFS.stream_ops.llseek
            }
          },
          file: {
            node: {
              getattr: MEMFS.node_ops.getattr,
              setattr: MEMFS.node_ops.setattr
            },
            stream: {
              llseek: MEMFS.stream_ops.llseek,
              read: MEMFS.stream_ops.read,
              write: MEMFS.stream_ops.write,
              allocate: MEMFS.stream_ops.allocate,
              mmap: MEMFS.stream_ops.mmap,
              msync: MEMFS.stream_ops.msync
            }
          },
          link: {
            node: {
              getattr: MEMFS.node_ops.getattr,
              setattr: MEMFS.node_ops.setattr,
              readlink: MEMFS.node_ops.readlink
            },
            stream: {}
          },
          chrdev: {
            node: {
              getattr: MEMFS.node_ops.getattr,
              setattr: MEMFS.node_ops.setattr
            },
            stream: FS.chrdev_stream_ops
          }
        });
        var n = FS.createNode(e, t, a, r);
        return FS.isDir(n.mode) ? (n.node_ops = MEMFS.ops_table.dir.node, n.stream_ops = MEMFS.ops_table.dir.stream, n.contents = {}) : FS.isFile(n.mode) ? (n.node_ops = MEMFS.ops_table.file.node, n.stream_ops = MEMFS.ops_table.file.stream, n.usedBytes = 0, n.contents = null) : FS.isLink(n.mode) ? (n.node_ops = MEMFS.ops_table.link.node, n.stream_ops = MEMFS.ops_table.link.stream) : FS.isChrdev(n.mode) && (n.node_ops = MEMFS.ops_table.chrdev.node, n.stream_ops = MEMFS.ops_table.chrdev.stream), n.timestamp = Date.now(), e && (e.contents[t] = n), n;
      },
      getFileDataAsRegularArray: function getFileDataAsRegularArray(e) {
        if (e.contents && e.contents.subarray) {
          for (var t = [], a = 0; a < e.usedBytes; ++a) {
            t.push(e.contents[a]);
          }

          return t;
        }

        return e.contents;
      },
      getFileDataAsTypedArray: function getFileDataAsTypedArray(e) {
        return e.contents ? e.contents.subarray ? e.contents.subarray(0, e.usedBytes) : new Uint8Array(e.contents) : new Uint8Array();
      },
      expandFileStorage: function expandFileStorage(e, t) {
        if (e.contents && e.contents.subarray && t > e.contents.length && (e.contents = MEMFS.getFileDataAsRegularArray(e), e.usedBytes = e.contents.length), !e.contents || e.contents.subarray) {
          var a = e.contents ? e.contents.length : 0;
          if (a >= t) return;
          t = Math.max(t, a * (a < 1048576 ? 2 : 1.125) | 0), 0 != a && (t = Math.max(t, 256));
          var r = e.contents;
          return e.contents = new Uint8Array(t), void (e.usedBytes > 0 && e.contents.set(r.subarray(0, e.usedBytes), 0));
        }

        for (!e.contents && t > 0 && (e.contents = []); e.contents.length < t;) {
          e.contents.push(0);
        }
      },
      resizeFileStorage: function resizeFileStorage(e, t) {
        if (e.usedBytes != t) {
          if (0 == t) return e.contents = null, void (e.usedBytes = 0);

          if (!e.contents || e.contents.subarray) {
            var a = e.contents;
            return e.contents = new Uint8Array(new ArrayBuffer(t)), a && e.contents.set(a.subarray(0, Math.min(t, e.usedBytes))), void (e.usedBytes = t);
          }

          if (e.contents || (e.contents = []), e.contents.length > t) e.contents.length = t;else for (; e.contents.length < t;) {
            e.contents.push(0);
          }
          e.usedBytes = t;
        }
      },
      node_ops: {
        getattr: function getattr(e) {
          var t = {};
          return t.dev = FS.isChrdev(e.mode) ? e.id : 1, t.ino = e.id, t.mode = e.mode, t.nlink = 1, t.uid = 0, t.gid = 0, t.rdev = e.rdev, FS.isDir(e.mode) ? t.size = 4096 : FS.isFile(e.mode) ? t.size = e.usedBytes : FS.isLink(e.mode) ? t.size = e.link.length : t.size = 0, t.atime = new Date(e.timestamp), t.mtime = new Date(e.timestamp), t.ctime = new Date(e.timestamp), t.blksize = 4096, t.blocks = Math.ceil(t.size / t.blksize), t;
        },
        setattr: function setattr(e, t) {
          void 0 !== t.mode && (e.mode = t.mode), void 0 !== t.timestamp && (e.timestamp = t.timestamp), void 0 !== t.size && MEMFS.resizeFileStorage(e, t.size);
        },
        lookup: function lookup(e, t) {
          throw FS.genericErrors[ERRNO_CODES.ENOENT];
        },
        mknod: function mknod(e, t, a, r) {
          return MEMFS.createNode(e, t, a, r);
        },
        rename: function rename(e, t, a) {
          if (FS.isDir(e.mode)) {
            var r;

            try {
              r = FS.lookupNode(t, a);
            } catch (e) {}

            if (r) for (var n in r.contents) {
              throw new FS.ErrnoError(ERRNO_CODES.ENOTEMPTY);
            }
          }

          delete e.parent.contents[e.name], e.name = a, t.contents[a] = e, e.parent = t;
        },
        unlink: function unlink(e, t) {
          delete e.contents[t];
        },
        rmdir: function rmdir(e, t) {
          var a = FS.lookupNode(e, t);

          for (var r in a.contents) {
            throw new FS.ErrnoError(ERRNO_CODES.ENOTEMPTY);
          }

          delete e.contents[t];
        },
        readdir: function readdir(e) {
          var t = [".", ".."];

          for (var a in e.contents) {
            e.contents.hasOwnProperty(a) && t.push(a);
          }

          return t;
        },
        symlink: function symlink(e, t, a) {
          var r = MEMFS.createNode(e, t, 41471, 0);
          return r.link = a, r;
        },
        readlink: function readlink(e) {
          if (!FS.isLink(e.mode)) throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
          return e.link;
        }
      },
      stream_ops: {
        read: function read(e, t, a, r, n) {
          var s = e.node.contents;
          if (n >= e.node.usedBytes) return 0;
          var o = Math.min(e.node.usedBytes - n, r);
          if (assert(o >= 0), o > 8 && s.subarray) t.set(s.subarray(n, n + o), a);else for (var i = 0; i < o; i++) {
            t[a + i] = s[n + i];
          }
          return o;
        },
        write: function write(e, t, a, r, n, s) {
          if (!r) return 0;
          var o = e.node;

          if (o.timestamp = Date.now(), t.subarray && (!o.contents || o.contents.subarray)) {
            if (s) return o.contents = t.subarray(a, a + r), o.usedBytes = r, r;
            if (0 === o.usedBytes && 0 === n) return o.contents = new Uint8Array(t.subarray(a, a + r)), o.usedBytes = r, r;
            if (n + r <= o.usedBytes) return o.contents.set(t.subarray(a, a + r), n), r;
          }

          if (MEMFS.expandFileStorage(o, n + r), o.contents.subarray && t.subarray) o.contents.set(t.subarray(a, a + r), n);else for (var i = 0; i < r; i++) {
            o.contents[n + i] = t[a + i];
          }
          return o.usedBytes = Math.max(o.usedBytes, n + r), r;
        },
        llseek: function llseek(e, t, a) {
          var r = t;
          if (1 === a ? r += e.position : 2 === a && FS.isFile(e.node.mode) && (r += e.node.usedBytes), r < 0) throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
          return r;
        },
        allocate: function allocate(e, t, a) {
          MEMFS.expandFileStorage(e.node, t + a), e.node.usedBytes = Math.max(e.node.usedBytes, t + a);
        },
        mmap: function mmap(e, t, a, r, n, s, o) {
          if (!FS.isFile(e.node.mode)) throw new FS.ErrnoError(ERRNO_CODES.ENODEV);
          var i,
              c,
              u = e.node.contents;

          if (2 & o || u.buffer !== t && u.buffer !== t.buffer) {
            if ((n > 0 || n + r < e.node.usedBytes) && (u = u.subarray ? u.subarray(n, n + r) : Array.prototype.slice.call(u, n, n + r)), c = !0, !(i = _malloc(r))) throw new FS.ErrnoError(ERRNO_CODES.ENOMEM);
            t.set(u, i);
          } else c = !1, i = u.byteOffset;

          return {
            ptr: i,
            allocated: c
          };
        },
        msync: function msync(e, t, a, r, n) {
          if (!FS.isFile(e.node.mode)) throw new FS.ErrnoError(ERRNO_CODES.ENODEV);
          if (2 & n) return 0;
          MEMFS.stream_ops.write(e, t, 0, r, a, !1);
          return 0;
        }
      }
    },
        IDBFS = {
      dbs: {},
      indexedDB: function (_indexedDB) {
        function indexedDB() {
          return _indexedDB.apply(this, arguments);
        }

        indexedDB.toString = function () {
          return _indexedDB.toString();
        };

        return indexedDB;
      }(function () {
        if ("undefined" != typeof indexedDB) return indexedDB;
        var e = null;
        return "object" == typeof window && (e = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB), assert(e, "IDBFS used, but indexedDB not supported"), e;
      }),
      DB_VERSION: 21,
      DB_STORE_NAME: "FILE_DATA",
      mount: function mount(e) {
        return MEMFS.mount.apply(null, arguments);
      },
      syncfs: function syncfs(e, t, a) {
        IDBFS.getLocalSet(e, function (r, n) {
          if (r) return a(r);
          IDBFS.getRemoteSet(e, function (e, r) {
            if (e) return a(e);
            var s = t ? r : n,
                o = t ? n : r;
            IDBFS.reconcile(s, o, a);
          });
        });
      },
      getDB: function getDB(e, t) {
        var a,
            r = IDBFS.dbs[e];
        if (r) return t(null, r);

        try {
          a = IDBFS.indexedDB().open(e, IDBFS.DB_VERSION);
        } catch (e) {
          return t(e);
        }

        if (!a) return t("Unable to connect to IndexedDB");
        a.onupgradeneeded = function (e) {
          var t,
              a = e.target.result,
              r = e.target.transaction;
          (t = a.objectStoreNames.contains(IDBFS.DB_STORE_NAME) ? r.objectStore(IDBFS.DB_STORE_NAME) : a.createObjectStore(IDBFS.DB_STORE_NAME)).indexNames.contains("timestamp") || t.createIndex("timestamp", "timestamp", {
            unique: !1
          });
        }, a.onsuccess = function () {
          r = a.result, IDBFS.dbs[e] = r, t(null, r);
        }, a.onerror = function (e) {
          t(this.error), e.preventDefault();
        };
      },
      getLocalSet: function getLocalSet(e, t) {
        var a = {};

        function r(e) {
          return "." !== e && ".." !== e;
        }

        function n(e) {
          return function (t) {
            return PATH.join2(e, t);
          };
        }

        for (var s = FS.readdir(e.mountpoint).filter(r).map(n(e.mountpoint)); s.length;) {
          var o,
              i = s.pop();

          try {
            o = FS.stat(i);
          } catch (e) {
            return t(e);
          }

          FS.isDir(o.mode) && s.push.apply(s, FS.readdir(i).filter(r).map(n(i))), a[i] = {
            timestamp: o.mtime
          };
        }

        return t(null, {
          type: "local",
          entries: a
        });
      },
      getRemoteSet: function getRemoteSet(e, t) {
        var a = {};
        IDBFS.getDB(e.mountpoint, function (e, r) {
          if (e) return t(e);

          try {
            var n = r.transaction([IDBFS.DB_STORE_NAME], "readonly");
            n.onerror = function (e) {
              t(this.error), e.preventDefault();
            }, n.objectStore(IDBFS.DB_STORE_NAME).index("timestamp").openKeyCursor().onsuccess = function (e) {
              var n = e.target.result;
              if (!n) return t(null, {
                type: "remote",
                db: r,
                entries: a
              });
              a[n.primaryKey] = {
                timestamp: n.key
              }, n.continue();
            };
          } catch (e) {
            return t(e);
          }
        });
      },
      loadLocalEntry: function loadLocalEntry(e, t) {
        var a, r;

        try {
          r = FS.lookupPath(e).node, a = FS.stat(e);
        } catch (e) {
          return t(e);
        }

        return FS.isDir(a.mode) ? t(null, {
          timestamp: a.mtime,
          mode: a.mode
        }) : FS.isFile(a.mode) ? (r.contents = MEMFS.getFileDataAsTypedArray(r), t(null, {
          timestamp: a.mtime,
          mode: a.mode,
          contents: r.contents
        })) : t(new Error("node type not supported"));
      },
      storeLocalEntry: function storeLocalEntry(e, t, a) {
        try {
          if (FS.isDir(t.mode)) FS.mkdir(e, t.mode);else {
            if (!FS.isFile(t.mode)) return a(new Error("node type not supported"));
            FS.writeFile(e, t.contents, {
              encoding: "binary",
              canOwn: !0
            });
          }
          FS.chmod(e, t.mode), FS.utime(e, t.timestamp, t.timestamp);
        } catch (e) {
          return a(e);
        }

        a(null);
      },
      removeLocalEntry: function removeLocalEntry(e, t) {
        try {
          FS.lookupPath(e);
          var a = FS.stat(e);
          FS.isDir(a.mode) ? FS.rmdir(e) : FS.isFile(a.mode) && FS.unlink(e);
        } catch (e) {
          return t(e);
        }

        t(null);
      },
      loadRemoteEntry: function loadRemoteEntry(e, t, a) {
        var r = e.get(t);
        r.onsuccess = function (e) {
          a(null, e.target.result);
        }, r.onerror = function (e) {
          a(this.error), e.preventDefault();
        };
      },
      storeRemoteEntry: function storeRemoteEntry(e, t, a, r) {
        var n = e.put(a, t);
        n.onsuccess = function () {
          r(null);
        }, n.onerror = function (e) {
          r(this.error), e.preventDefault();
        };
      },
      removeRemoteEntry: function removeRemoteEntry(e, t, a) {
        var r = e.delete(t);
        r.onsuccess = function () {
          a(null);
        }, r.onerror = function (e) {
          a(this.error), e.preventDefault();
        };
      },
      reconcile: function reconcile(e, t, a) {
        var r = 0,
            n = [];
        Object.keys(e.entries).forEach(function (a) {
          var s = e.entries[a],
              o = t.entries[a];
          (!o || s.timestamp > o.timestamp) && (n.push(a), r++);
        });
        var s = [];
        if (Object.keys(t.entries).forEach(function (a) {
          t.entries[a];
          e.entries[a] || (s.push(a), r++);
        }), !r) return a(null);
        var o = 0,
            i = ("remote" === e.type ? e.db : t.db).transaction([IDBFS.DB_STORE_NAME], "readwrite"),
            c = i.objectStore(IDBFS.DB_STORE_NAME);

        function u(e) {
          return e ? u.errored ? void 0 : (u.errored = !0, a(e)) : ++o >= r ? a(null) : void 0;
        }

        i.onerror = function (e) {
          u(this.error), e.preventDefault();
        }, n.sort().forEach(function (e) {
          "local" === t.type ? IDBFS.loadRemoteEntry(c, e, function (t, a) {
            if (t) return u(t);
            IDBFS.storeLocalEntry(e, a, u);
          }) : IDBFS.loadLocalEntry(e, function (t, a) {
            if (t) return u(t);
            IDBFS.storeRemoteEntry(c, e, a, u);
          });
        }), s.sort().reverse().forEach(function (e) {
          "local" === t.type ? IDBFS.removeLocalEntry(e, u) : IDBFS.removeRemoteEntry(c, e, u);
        });
      }
    },
        NODEFS = {
      isWindows: !1,
      staticInit: function staticInit() {
        NODEFS.isWindows = !!process.platform.match(/^win/);
      },
      mount: function mount(e) {
        return assert(ENVIRONMENT_IS_NODE), NODEFS.createNode(null, "/", NODEFS.getMode(e.opts.root), 0);
      },
      createNode: function createNode(e, t, a, r) {
        if (!FS.isDir(a) && !FS.isFile(a) && !FS.isLink(a)) throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
        var n = FS.createNode(e, t, a);
        return n.node_ops = NODEFS.node_ops, n.stream_ops = NODEFS.stream_ops, n;
      },
      getMode: function getMode(e) {
        var t;

        try {
          t = fs.lstatSync(e), NODEFS.isWindows && (t.mode = t.mode | (146 & t.mode) >> 1);
        } catch (e) {
          if (!e.code) throw e;
          throw new FS.ErrnoError(ERRNO_CODES[e.code]);
        }

        return t.mode;
      },
      realPath: function realPath(e) {
        for (var t = []; e.parent !== e;) {
          t.push(e.name), e = e.parent;
        }

        return t.push(e.mount.opts.root), t.reverse(), PATH.join.apply(null, t);
      },
      flagsToPermissionStringMap: {
        0: "r",
        1: "r+",
        2: "r+",
        64: "r",
        65: "r+",
        66: "r+",
        129: "rx+",
        193: "rx+",
        514: "w+",
        577: "w",
        578: "w+",
        705: "wx",
        706: "wx+",
        1024: "a",
        1025: "a",
        1026: "a+",
        1089: "a",
        1090: "a+",
        1153: "ax",
        1154: "ax+",
        1217: "ax",
        1218: "ax+",
        4096: "rs",
        4098: "rs+"
      },
      flagsToPermissionString: function flagsToPermissionString(e) {
        if (e &= -2097153, e &= -2049, e &= -32769, (e &= -524289) in NODEFS.flagsToPermissionStringMap) return NODEFS.flagsToPermissionStringMap[e];
        throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
      },
      node_ops: {
        getattr: function getattr(e) {
          var t,
              a = NODEFS.realPath(e);

          try {
            t = fs.lstatSync(a);
          } catch (e) {
            if (!e.code) throw e;
            throw new FS.ErrnoError(ERRNO_CODES[e.code]);
          }

          return NODEFS.isWindows && !t.blksize && (t.blksize = 4096), NODEFS.isWindows && !t.blocks && (t.blocks = (t.size + t.blksize - 1) / t.blksize | 0), {
            dev: t.dev,
            ino: t.ino,
            mode: t.mode,
            nlink: t.nlink,
            uid: t.uid,
            gid: t.gid,
            rdev: t.rdev,
            size: t.size,
            atime: t.atime,
            mtime: t.mtime,
            ctime: t.ctime,
            blksize: t.blksize,
            blocks: t.blocks
          };
        },
        setattr: function setattr(e, t) {
          var a = NODEFS.realPath(e);

          try {
            if (void 0 !== t.mode && (fs.chmodSync(a, t.mode), e.mode = t.mode), void 0 !== t.timestamp) {
              var r = new Date(t.timestamp);
              fs.utimesSync(a, r, r);
            }

            void 0 !== t.size && fs.truncateSync(a, t.size);
          } catch (e) {
            if (!e.code) throw e;
            throw new FS.ErrnoError(ERRNO_CODES[e.code]);
          }
        },
        lookup: function lookup(e, t) {
          var a = PATH.join2(NODEFS.realPath(e), t),
              r = NODEFS.getMode(a);
          return NODEFS.createNode(e, t, r);
        },
        mknod: function mknod(e, t, a, r) {
          var n = NODEFS.createNode(e, t, a, r),
              s = NODEFS.realPath(n);

          try {
            FS.isDir(n.mode) ? fs.mkdirSync(s, n.mode) : fs.writeFileSync(s, "", {
              mode: n.mode
            });
          } catch (e) {
            if (!e.code) throw e;
            throw new FS.ErrnoError(ERRNO_CODES[e.code]);
          }

          return n;
        },
        rename: function rename(e, t, a) {
          var r = NODEFS.realPath(e),
              n = PATH.join2(NODEFS.realPath(t), a);

          try {
            fs.renameSync(r, n);
          } catch (e) {
            if (!e.code) throw e;
            throw new FS.ErrnoError(ERRNO_CODES[e.code]);
          }
        },
        unlink: function unlink(e, t) {
          var a = PATH.join2(NODEFS.realPath(e), t);

          try {
            fs.unlinkSync(a);
          } catch (e) {
            if (!e.code) throw e;
            throw new FS.ErrnoError(ERRNO_CODES[e.code]);
          }
        },
        rmdir: function rmdir(e, t) {
          var a = PATH.join2(NODEFS.realPath(e), t);

          try {
            fs.rmdirSync(a);
          } catch (e) {
            if (!e.code) throw e;
            throw new FS.ErrnoError(ERRNO_CODES[e.code]);
          }
        },
        readdir: function readdir(e) {
          var t = NODEFS.realPath(e);

          try {
            return fs.readdirSync(t);
          } catch (e) {
            if (!e.code) throw e;
            throw new FS.ErrnoError(ERRNO_CODES[e.code]);
          }
        },
        symlink: function symlink(e, t, a) {
          var r = PATH.join2(NODEFS.realPath(e), t);

          try {
            fs.symlinkSync(a, r);
          } catch (e) {
            if (!e.code) throw e;
            throw new FS.ErrnoError(ERRNO_CODES[e.code]);
          }
        },
        readlink: function readlink(e) {
          var t = NODEFS.realPath(e);

          try {
            return t = fs.readlinkSync(t), t = NODEJS_PATH.relative(NODEJS_PATH.resolve(e.mount.opts.root), t);
          } catch (e) {
            if (!e.code) throw e;
            throw new FS.ErrnoError(ERRNO_CODES[e.code]);
          }
        }
      },
      stream_ops: {
        open: function open(e) {
          var t = NODEFS.realPath(e.node);

          try {
            FS.isFile(e.node.mode) && (e.nfd = fs.openSync(t, NODEFS.flagsToPermissionString(e.flags)));
          } catch (e) {
            if (!e.code) throw e;
            throw new FS.ErrnoError(ERRNO_CODES[e.code]);
          }
        },
        close: function close(e) {
          try {
            FS.isFile(e.node.mode) && e.nfd && fs.closeSync(e.nfd);
          } catch (e) {
            if (!e.code) throw e;
            throw new FS.ErrnoError(ERRNO_CODES[e.code]);
          }
        },
        read: function read(e, t, a, r, n) {
          if (0 === r) return 0;
          var s,
              o = new Buffer(r);

          try {
            s = fs.readSync(e.nfd, o, 0, r, n);
          } catch (e) {
            throw new FS.ErrnoError(ERRNO_CODES[e.code]);
          }

          if (s > 0) for (var i = 0; i < s; i++) {
            t[a + i] = o[i];
          }
          return s;
        },
        write: function write(e, t, a, r, n) {
          var s,
              o = new Buffer(t.subarray(a, a + r));

          try {
            s = fs.writeSync(e.nfd, o, 0, r, n);
          } catch (e) {
            throw new FS.ErrnoError(ERRNO_CODES[e.code]);
          }

          return s;
        },
        llseek: function llseek(e, t, a) {
          var r = t;
          if (1 === a) r += e.position;else if (2 === a && FS.isFile(e.node.mode)) try {
            r += fs.fstatSync(e.nfd).size;
          } catch (e) {
            throw new FS.ErrnoError(ERRNO_CODES[e.code]);
          }
          if (r < 0) throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
          return r;
        }
      }
    },
        WORKERFS = {
      DIR_MODE: 16895,
      FILE_MODE: 33279,
      reader: null,
      mount: function mount(e) {
        assert(ENVIRONMENT_IS_WORKER), WORKERFS.reader || (WORKERFS.reader = new FileReaderSync());
        var t = WORKERFS.createNode(null, "/", WORKERFS.DIR_MODE, 0),
            a = {};

        function r(e) {
          for (var r = e.split("/"), n = t, s = 0; s < r.length - 1; s++) {
            var o = r.slice(0, s + 1).join("/");
            a[o] || (a[o] = WORKERFS.createNode(n, r[s], WORKERFS.DIR_MODE, 0)), n = a[o];
          }

          return n;
        }

        function n(e) {
          var t = e.split("/");
          return t[t.length - 1];
        }

        return Array.prototype.forEach.call(e.opts.files || [], function (e) {
          WORKERFS.createNode(r(e.name), n(e.name), WORKERFS.FILE_MODE, 0, e, e.lastModifiedDate);
        }), (e.opts.blobs || []).forEach(function (e) {
          WORKERFS.createNode(r(e.name), n(e.name), WORKERFS.FILE_MODE, 0, e.data);
        }), (e.opts.packages || []).forEach(function (e) {
          e.metadata.files.forEach(function (t) {
            var a = t.filename.substr(1);
            WORKERFS.createNode(r(a), n(a), WORKERFS.FILE_MODE, 0, e.blob.slice(t.start, t.end));
          });
        }), t;
      },
      createNode: function createNode(e, t, a, r, n, s) {
        var o = FS.createNode(e, t, a);
        return o.mode = a, o.node_ops = WORKERFS.node_ops, o.stream_ops = WORKERFS.stream_ops, o.timestamp = (s || new Date()).getTime(), assert(WORKERFS.FILE_MODE !== WORKERFS.DIR_MODE), a === WORKERFS.FILE_MODE ? (o.size = n.size, o.contents = n) : (o.size = 4096, o.contents = {}), e && (e.contents[t] = o), o;
      },
      node_ops: {
        getattr: function getattr(e) {
          return {
            dev: 1,
            ino: void 0,
            mode: e.mode,
            nlink: 1,
            uid: 0,
            gid: 0,
            rdev: void 0,
            size: e.size,
            atime: new Date(e.timestamp),
            mtime: new Date(e.timestamp),
            ctime: new Date(e.timestamp),
            blksize: 4096,
            blocks: Math.ceil(e.size / 4096)
          };
        },
        setattr: function setattr(e, t) {
          void 0 !== t.mode && (e.mode = t.mode), void 0 !== t.timestamp && (e.timestamp = t.timestamp);
        },
        lookup: function lookup(e, t) {
          throw new FS.ErrnoError(ERRNO_CODES.ENOENT);
        },
        mknod: function mknod(e, t, a, r) {
          throw new FS.ErrnoError(ERRNO_CODES.EPERM);
        },
        rename: function rename(e, t, a) {
          throw new FS.ErrnoError(ERRNO_CODES.EPERM);
        },
        unlink: function unlink(e, t) {
          throw new FS.ErrnoError(ERRNO_CODES.EPERM);
        },
        rmdir: function rmdir(e, t) {
          throw new FS.ErrnoError(ERRNO_CODES.EPERM);
        },
        readdir: function readdir(e) {
          var t = [".", ".."];

          for (var a in e.contents) {
            e.contents.hasOwnProperty(a) && t.push(a);
          }

          return t;
        },
        symlink: function symlink(e, t, a) {
          throw new FS.ErrnoError(ERRNO_CODES.EPERM);
        },
        readlink: function readlink(e) {
          throw new FS.ErrnoError(ERRNO_CODES.EPERM);
        }
      },
      stream_ops: {
        read: function read(e, t, a, r, n) {
          if (n >= e.node.size) return 0;
          var s = e.node.contents.slice(n, n + r),
              o = WORKERFS.reader.readAsArrayBuffer(s);
          return t.set(new Uint8Array(o), a), s.size;
        },
        write: function write(e, t, a, r, n) {
          throw new FS.ErrnoError(ERRNO_CODES.EIO);
        },
        llseek: function llseek(e, t, a) {
          var r = t;
          if (1 === a ? r += e.position : 2 === a && FS.isFile(e.node.mode) && (r += e.node.size), r < 0) throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
          return r;
        }
      }
    };
    STATICTOP += 16, STATICTOP += 16, STATICTOP += 16;
    var FS = {
      root: null,
      mounts: [],
      devices: [null],
      streams: [],
      nextInode: 1,
      nameTable: null,
      currentPath: "/",
      initialized: !1,
      ignorePermissions: !0,
      trackingDelegate: {},
      tracking: {
        openFlags: {
          READ: 1,
          WRITE: 2
        }
      },
      ErrnoError: null,
      genericErrors: {},
      filesystems: null,
      syncFSRequests: 0,
      handleFSError: function handleFSError(e) {
        if (!(e instanceof FS.ErrnoError)) throw e + " : " + stackTrace();
        return ___setErrNo(e.errno);
      },
      lookupPath: function lookupPath(e, t) {
        if (t = t || {}, !(e = PATH.resolve(FS.cwd(), e))) return {
          path: "",
          node: null
        };
        var a = {
          follow_mount: !0,
          recurse_count: 0
        };

        for (var r in a) {
          void 0 === t[r] && (t[r] = a[r]);
        }

        if (t.recurse_count > 8) throw new FS.ErrnoError(ERRNO_CODES.ELOOP);

        for (var n = PATH.normalizeArray(e.split("/").filter(function (e) {
          return !!e;
        }), !1), s = FS.root, o = "/", i = 0; i < n.length; i++) {
          var c = i === n.length - 1;
          if (c && t.parent) break;
          if (s = FS.lookupNode(s, n[i]), o = PATH.join2(o, n[i]), FS.isMountpoint(s) && (!c || c && t.follow_mount) && (s = s.mounted.root), !c || t.follow) for (var u = 0; FS.isLink(s.mode);) {
            var d = FS.readlink(o);
            if (o = PATH.resolve(PATH.dirname(o), d), s = FS.lookupPath(o, {
              recurse_count: t.recurse_count
            }).node, u++ > 40) throw new FS.ErrnoError(ERRNO_CODES.ELOOP);
          }
        }

        return {
          path: o,
          node: s
        };
      },
      getPath: function getPath(e) {
        for (var t;;) {
          if (FS.isRoot(e)) {
            var a = e.mount.mountpoint;
            return t ? "/" !== a[a.length - 1] ? a + "/" + t : a + t : a;
          }

          t = t ? e.name + "/" + t : e.name, e = e.parent;
        }
      },
      hashName: function hashName(e, t) {
        for (var a = 0, r = 0; r < t.length; r++) {
          a = (a << 5) - a + t.charCodeAt(r) | 0;
        }

        return (e + a >>> 0) % FS.nameTable.length;
      },
      hashAddNode: function hashAddNode(e) {
        var t = FS.hashName(e.parent.id, e.name);
        e.name_next = FS.nameTable[t], FS.nameTable[t] = e;
      },
      hashRemoveNode: function hashRemoveNode(e) {
        var t = FS.hashName(e.parent.id, e.name);
        if (FS.nameTable[t] === e) FS.nameTable[t] = e.name_next;else for (var a = FS.nameTable[t]; a;) {
          if (a.name_next === e) {
            a.name_next = e.name_next;
            break;
          }

          a = a.name_next;
        }
      },
      lookupNode: function lookupNode(e, t) {
        var a = FS.mayLookup(e);
        if (a) throw new FS.ErrnoError(a, e);

        for (var r = FS.hashName(e.id, t), n = FS.nameTable[r]; n; n = n.name_next) {
          var s = n.name;
          if (n.parent.id === e.id && s === t) return n;
        }

        return FS.lookup(e, t);
      },
      createNode: function createNode(e, t, a, r) {
        if (!FS.FSNode) {
          FS.FSNode = function (e, t, a, r) {
            e || (e = this), this.parent = e, this.mount = e.mount, this.mounted = null, this.id = FS.nextInode++, this.name = t, this.mode = a, this.node_ops = {}, this.stream_ops = {}, this.rdev = r;
          }, FS.FSNode.prototype = {};
          Object.defineProperties(FS.FSNode.prototype, {
            read: {
              get: function get() {
                return 365 == (365 & this.mode);
              },
              set: function set(e) {
                e ? this.mode |= 365 : this.mode &= -366;
              }
            },
            write: {
              get: function get() {
                return 146 == (146 & this.mode);
              },
              set: function set(e) {
                e ? this.mode |= 146 : this.mode &= -147;
              }
            },
            isFolder: {
              get: function get() {
                return FS.isDir(this.mode);
              }
            },
            isDevice: {
              get: function get() {
                return FS.isChrdev(this.mode);
              }
            }
          });
        }

        var n = new FS.FSNode(e, t, a, r);
        return FS.hashAddNode(n), n;
      },
      destroyNode: function destroyNode(e) {
        FS.hashRemoveNode(e);
      },
      isRoot: function isRoot(e) {
        return e === e.parent;
      },
      isMountpoint: function isMountpoint(e) {
        return !!e.mounted;
      },
      isFile: function isFile(e) {
        return 32768 == (61440 & e);
      },
      isDir: function isDir(e) {
        return 16384 == (61440 & e);
      },
      isLink: function isLink(e) {
        return 40960 == (61440 & e);
      },
      isChrdev: function isChrdev(e) {
        return 8192 == (61440 & e);
      },
      isBlkdev: function isBlkdev(e) {
        return 24576 == (61440 & e);
      },
      isFIFO: function isFIFO(e) {
        return 4096 == (61440 & e);
      },
      isSocket: function isSocket(e) {
        return 49152 == (49152 & e);
      },
      flagModes: {
        r: 0,
        rs: 1052672,
        "r+": 2,
        w: 577,
        wx: 705,
        xw: 705,
        "w+": 578,
        "wx+": 706,
        "xw+": 706,
        a: 1089,
        ax: 1217,
        xa: 1217,
        "a+": 1090,
        "ax+": 1218,
        "xa+": 1218
      },
      modeStringToFlags: function modeStringToFlags(e) {
        var t = FS.flagModes[e];
        if (void 0 === t) throw new Error("Unknown file open mode: " + e);
        return t;
      },
      flagsToPermissionString: function flagsToPermissionString(e) {
        var t = ["r", "w", "rw"][3 & e];
        return 512 & e && (t += "w"), t;
      },
      nodePermissions: function nodePermissions(e, t) {
        return FS.ignorePermissions ? 0 : (-1 === t.indexOf("r") || 292 & e.mode) && (-1 === t.indexOf("w") || 146 & e.mode) && (-1 === t.indexOf("x") || 73 & e.mode) ? 0 : ERRNO_CODES.EACCES;
      },
      mayLookup: function mayLookup(e) {
        var t = FS.nodePermissions(e, "x");
        return t || (e.node_ops.lookup ? 0 : ERRNO_CODES.EACCES);
      },
      mayCreate: function mayCreate(e, t) {
        try {
          FS.lookupNode(e, t);
          return ERRNO_CODES.EEXIST;
        } catch (e) {}

        return FS.nodePermissions(e, "wx");
      },
      mayDelete: function mayDelete(e, t, a) {
        var r;

        try {
          r = FS.lookupNode(e, t);
        } catch (e) {
          return e.errno;
        }

        var n = FS.nodePermissions(e, "wx");
        if (n) return n;

        if (a) {
          if (!FS.isDir(r.mode)) return ERRNO_CODES.ENOTDIR;
          if (FS.isRoot(r) || FS.getPath(r) === FS.cwd()) return ERRNO_CODES.EBUSY;
        } else if (FS.isDir(r.mode)) return ERRNO_CODES.EISDIR;

        return 0;
      },
      mayOpen: function mayOpen(e, t) {
        return e ? FS.isLink(e.mode) ? ERRNO_CODES.ELOOP : FS.isDir(e.mode) && ("r" !== FS.flagsToPermissionString(t) || 512 & t) ? ERRNO_CODES.EISDIR : FS.nodePermissions(e, FS.flagsToPermissionString(t)) : ERRNO_CODES.ENOENT;
      },
      MAX_OPEN_FDS: 4096,
      nextfd: function nextfd(e, t) {
        e = e || 0, t = t || FS.MAX_OPEN_FDS;

        for (var a = e; a <= t; a++) {
          if (!FS.streams[a]) return a;
        }

        throw new FS.ErrnoError(ERRNO_CODES.EMFILE);
      },
      getStream: function getStream(e) {
        return FS.streams[e];
      },
      createStream: function createStream(e, t, a) {
        FS.FSStream || (FS.FSStream = function () {}, FS.FSStream.prototype = {}, Object.defineProperties(FS.FSStream.prototype, {
          object: {
            get: function get() {
              return this.node;
            },
            set: function set(e) {
              this.node = e;
            }
          },
          isRead: {
            get: function get() {
              return 1 != (2097155 & this.flags);
            }
          },
          isWrite: {
            get: function get() {
              return 0 != (2097155 & this.flags);
            }
          },
          isAppend: {
            get: function get() {
              return 1024 & this.flags;
            }
          }
        }));
        var r = new FS.FSStream();

        for (var n in e) {
          r[n] = e[n];
        }

        e = r;
        var s = FS.nextfd(t, a);
        return e.fd = s, FS.streams[s] = e, e;
      },
      closeStream: function closeStream(e) {
        FS.streams[e] = null;
      },
      chrdev_stream_ops: {
        open: function open(e) {
          var t = FS.getDevice(e.node.rdev);
          e.stream_ops = t.stream_ops, e.stream_ops.open && e.stream_ops.open(e);
        },
        llseek: function llseek() {
          throw new FS.ErrnoError(ERRNO_CODES.ESPIPE);
        }
      },
      major: function major(e) {
        return e >> 8;
      },
      minor: function minor(e) {
        return 255 & e;
      },
      makedev: function makedev(e, t) {
        return e << 8 | t;
      },
      registerDevice: function registerDevice(e, t) {
        FS.devices[e] = {
          stream_ops: t
        };
      },
      getDevice: function getDevice(e) {
        return FS.devices[e];
      },
      getMounts: function getMounts(e) {
        for (var t = [], a = [e]; a.length;) {
          var r = a.pop();
          t.push(r), a.push.apply(a, r.mounts);
        }

        return t;
      },
      syncfs: function syncfs(e, t) {
        "function" == typeof e && (t = e, e = !1), FS.syncFSRequests++, FS.syncFSRequests > 1 && console.log("warning: " + FS.syncFSRequests + " FS.syncfs operations in flight at once, probably just doing extra work");
        var a = FS.getMounts(FS.root.mount),
            r = 0;

        function n(e) {
          return assert(FS.syncFSRequests > 0), FS.syncFSRequests--, t(e);
        }

        function s(e) {
          if (e) return s.errored ? void 0 : (s.errored = !0, n(e));
          ++r >= a.length && n(null);
        }

        a.forEach(function (t) {
          if (!t.type.syncfs) return s(null);
          t.type.syncfs(t, e, s);
        });
      },
      mount: function mount(e, t, a) {
        var r,
            n = "/" === a,
            s = !a;
        if (n && FS.root) throw new FS.ErrnoError(ERRNO_CODES.EBUSY);

        if (!n && !s) {
          var o = FS.lookupPath(a, {
            follow_mount: !1
          });
          if (a = o.path, r = o.node, FS.isMountpoint(r)) throw new FS.ErrnoError(ERRNO_CODES.EBUSY);
          if (!FS.isDir(r.mode)) throw new FS.ErrnoError(ERRNO_CODES.ENOTDIR);
        }

        var i = {
          type: e,
          opts: t,
          mountpoint: a,
          mounts: []
        },
            c = e.mount(i);
        return c.mount = i, i.root = c, n ? FS.root = c : r && (r.mounted = i, r.mount && r.mount.mounts.push(i)), c;
      },
      unmount: function unmount(e) {
        var t = FS.lookupPath(e, {
          follow_mount: !1
        });
        if (!FS.isMountpoint(t.node)) throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
        var a = t.node,
            r = a.mounted,
            n = FS.getMounts(r);
        Object.keys(FS.nameTable).forEach(function (e) {
          for (var t = FS.nameTable[e]; t;) {
            var a = t.name_next;
            -1 !== n.indexOf(t.mount) && FS.destroyNode(t), t = a;
          }
        }), a.mounted = null;
        var s = a.mount.mounts.indexOf(r);
        assert(-1 !== s), a.mount.mounts.splice(s, 1);
      },
      lookup: function lookup(e, t) {
        return e.node_ops.lookup(e, t);
      },
      mknod: function mknod(e, t, a) {
        var r = FS.lookupPath(e, {
          parent: !0
        }).node,
            n = PATH.basename(e);
        if (!n || "." === n || ".." === n) throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
        var s = FS.mayCreate(r, n);
        if (s) throw new FS.ErrnoError(s);
        if (!r.node_ops.mknod) throw new FS.ErrnoError(ERRNO_CODES.EPERM);
        return r.node_ops.mknod(r, n, t, a);
      },
      create: function create(e, t) {
        return t = void 0 !== t ? t : 438, t &= 4095, t |= 32768, FS.mknod(e, t, 0);
      },
      mkdir: function mkdir(e, t) {
        return t = void 0 !== t ? t : 511, t &= 1023, t |= 16384, FS.mknod(e, t, 0);
      },
      mkdirTree: function mkdirTree(e, t) {
        for (var a = e.split("/"), r = "", n = 0; n < a.length; ++n) {
          if (a[n]) {
            r += "/" + a[n];

            try {
              FS.mkdir(r, t);
            } catch (e) {
              if (e.errno != ERRNO_CODES.EEXIST) throw e;
            }
          }
        }
      },
      mkdev: function mkdev(e, t, a) {
        return void 0 === a && (a = t, t = 438), t |= 8192, FS.mknod(e, t, a);
      },
      symlink: function symlink(e, t) {
        if (!PATH.resolve(e)) throw new FS.ErrnoError(ERRNO_CODES.ENOENT);
        var a = FS.lookupPath(t, {
          parent: !0
        }).node;
        if (!a) throw new FS.ErrnoError(ERRNO_CODES.ENOENT);
        var r = PATH.basename(t),
            n = FS.mayCreate(a, r);
        if (n) throw new FS.ErrnoError(n);
        if (!a.node_ops.symlink) throw new FS.ErrnoError(ERRNO_CODES.EPERM);
        return a.node_ops.symlink(a, r, e);
      },
      rename: function rename(e, t) {
        var a,
            r,
            n = PATH.dirname(e),
            s = PATH.dirname(t),
            o = PATH.basename(e),
            i = PATH.basename(t);

        try {
          a = FS.lookupPath(e, {
            parent: !0
          }).node, r = FS.lookupPath(t, {
            parent: !0
          }).node;
        } catch (e) {
          throw new FS.ErrnoError(ERRNO_CODES.EBUSY);
        }

        if (!a || !r) throw new FS.ErrnoError(ERRNO_CODES.ENOENT);
        if (a.mount !== r.mount) throw new FS.ErrnoError(ERRNO_CODES.EXDEV);
        var c,
            u = FS.lookupNode(a, o),
            d = PATH.relative(e, s);
        if ("." !== d.charAt(0)) throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
        if ("." !== (d = PATH.relative(t, n)).charAt(0)) throw new FS.ErrnoError(ERRNO_CODES.ENOTEMPTY);

        try {
          c = FS.lookupNode(r, i);
        } catch (e) {}

        if (u !== c) {
          var f = FS.isDir(u.mode),
              l = FS.mayDelete(a, o, f);
          if (l) throw new FS.ErrnoError(l);
          if (l = c ? FS.mayDelete(r, i, f) : FS.mayCreate(r, i)) throw new FS.ErrnoError(l);
          if (!a.node_ops.rename) throw new FS.ErrnoError(ERRNO_CODES.EPERM);
          if (FS.isMountpoint(u) || c && FS.isMountpoint(c)) throw new FS.ErrnoError(ERRNO_CODES.EBUSY);
          if (r !== a && (l = FS.nodePermissions(a, "w"))) throw new FS.ErrnoError(l);

          try {
            FS.trackingDelegate.willMovePath && FS.trackingDelegate.willMovePath(e, t);
          } catch (a) {
            console.log("FS.trackingDelegate['willMovePath']('" + e + "', '" + t + "') threw an exception: " + a.message);
          }

          FS.hashRemoveNode(u);

          try {
            a.node_ops.rename(u, r, i);
          } catch (e) {
            throw e;
          } finally {
            FS.hashAddNode(u);
          }

          try {
            FS.trackingDelegate.onMovePath && FS.trackingDelegate.onMovePath(e, t);
          } catch (a) {
            console.log("FS.trackingDelegate['onMovePath']('" + e + "', '" + t + "') threw an exception: " + a.message);
          }
        }
      },
      rmdir: function rmdir(e) {
        var t = FS.lookupPath(e, {
          parent: !0
        }).node,
            a = PATH.basename(e),
            r = FS.lookupNode(t, a),
            n = FS.mayDelete(t, a, !0);
        if (n) throw new FS.ErrnoError(n);
        if (!t.node_ops.rmdir) throw new FS.ErrnoError(ERRNO_CODES.EPERM);
        if (FS.isMountpoint(r)) throw new FS.ErrnoError(ERRNO_CODES.EBUSY);

        try {
          FS.trackingDelegate.willDeletePath && FS.trackingDelegate.willDeletePath(e);
        } catch (t) {
          console.log("FS.trackingDelegate['willDeletePath']('" + e + "') threw an exception: " + t.message);
        }

        t.node_ops.rmdir(t, a), FS.destroyNode(r);

        try {
          FS.trackingDelegate.onDeletePath && FS.trackingDelegate.onDeletePath(e);
        } catch (t) {
          console.log("FS.trackingDelegate['onDeletePath']('" + e + "') threw an exception: " + t.message);
        }
      },
      readdir: function readdir(e) {
        var t = FS.lookupPath(e, {
          follow: !0
        }).node;
        if (!t.node_ops.readdir) throw new FS.ErrnoError(ERRNO_CODES.ENOTDIR);
        return t.node_ops.readdir(t);
      },
      unlink: function unlink(e) {
        var t = FS.lookupPath(e, {
          parent: !0
        }).node,
            a = PATH.basename(e),
            r = FS.lookupNode(t, a),
            n = FS.mayDelete(t, a, !1);
        if (n) throw new FS.ErrnoError(n);
        if (!t.node_ops.unlink) throw new FS.ErrnoError(ERRNO_CODES.EPERM);
        if (FS.isMountpoint(r)) throw new FS.ErrnoError(ERRNO_CODES.EBUSY);

        try {
          FS.trackingDelegate.willDeletePath && FS.trackingDelegate.willDeletePath(e);
        } catch (t) {
          console.log("FS.trackingDelegate['willDeletePath']('" + e + "') threw an exception: " + t.message);
        }

        t.node_ops.unlink(t, a), FS.destroyNode(r);

        try {
          FS.trackingDelegate.onDeletePath && FS.trackingDelegate.onDeletePath(e);
        } catch (t) {
          console.log("FS.trackingDelegate['onDeletePath']('" + e + "') threw an exception: " + t.message);
        }
      },
      readlink: function readlink(e) {
        var t = FS.lookupPath(e).node;
        if (!t) throw new FS.ErrnoError(ERRNO_CODES.ENOENT);
        if (!t.node_ops.readlink) throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
        return PATH.resolve(FS.getPath(t.parent), t.node_ops.readlink(t));
      },
      stat: function stat(e, t) {
        var a = FS.lookupPath(e, {
          follow: !t
        }).node;
        if (!a) throw new FS.ErrnoError(ERRNO_CODES.ENOENT);
        if (!a.node_ops.getattr) throw new FS.ErrnoError(ERRNO_CODES.EPERM);
        return a.node_ops.getattr(a);
      },
      lstat: function lstat(e) {
        return FS.stat(e, !0);
      },
      chmod: function chmod(e, t, a) {
        var r;
        "string" == typeof e ? r = FS.lookupPath(e, {
          follow: !a
        }).node : r = e;
        if (!r.node_ops.setattr) throw new FS.ErrnoError(ERRNO_CODES.EPERM);
        r.node_ops.setattr(r, {
          mode: 4095 & t | -4096 & r.mode,
          timestamp: Date.now()
        });
      },
      lchmod: function lchmod(e, t) {
        FS.chmod(e, t, !0);
      },
      fchmod: function fchmod(e, t) {
        var a = FS.getStream(e);
        if (!a) throw new FS.ErrnoError(ERRNO_CODES.EBADF);
        FS.chmod(a.node, t);
      },
      chown: function chown(e, t, a, r) {
        var n;
        "string" == typeof e ? n = FS.lookupPath(e, {
          follow: !r
        }).node : n = e;
        if (!n.node_ops.setattr) throw new FS.ErrnoError(ERRNO_CODES.EPERM);
        n.node_ops.setattr(n, {
          timestamp: Date.now()
        });
      },
      lchown: function lchown(e, t, a) {
        FS.chown(e, t, a, !0);
      },
      fchown: function fchown(e, t, a) {
        var r = FS.getStream(e);
        if (!r) throw new FS.ErrnoError(ERRNO_CODES.EBADF);
        FS.chown(r.node, t, a);
      },
      truncate: function truncate(e, t) {
        if (t < 0) throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
        var a;
        "string" == typeof e ? a = FS.lookupPath(e, {
          follow: !0
        }).node : a = e;
        if (!a.node_ops.setattr) throw new FS.ErrnoError(ERRNO_CODES.EPERM);
        if (FS.isDir(a.mode)) throw new FS.ErrnoError(ERRNO_CODES.EISDIR);
        if (!FS.isFile(a.mode)) throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
        var r = FS.nodePermissions(a, "w");
        if (r) throw new FS.ErrnoError(r);
        a.node_ops.setattr(a, {
          size: t,
          timestamp: Date.now()
        });
      },
      ftruncate: function ftruncate(e, t) {
        var a = FS.getStream(e);
        if (!a) throw new FS.ErrnoError(ERRNO_CODES.EBADF);
        if (0 == (2097155 & a.flags)) throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
        FS.truncate(a.node, t);
      },
      utime: function utime(e, t, a) {
        var r = FS.lookupPath(e, {
          follow: !0
        }).node;
        r.node_ops.setattr(r, {
          timestamp: Math.max(t, a)
        });
      },
      open: function open(e, t, a, r, n) {
        if ("" === e) throw new FS.ErrnoError(ERRNO_CODES.ENOENT);
        var s;
        if (a = void 0 === a ? 438 : a, a = 64 & (t = "string" == typeof t ? FS.modeStringToFlags(t) : t) ? 4095 & a | 32768 : 0, "object" == typeof e) s = e;else {
          e = PATH.normalize(e);

          try {
            s = FS.lookupPath(e, {
              follow: !(131072 & t)
            }).node;
          } catch (e) {}
        }
        var o = !1;
        if (64 & t) if (s) {
          if (128 & t) throw new FS.ErrnoError(ERRNO_CODES.EEXIST);
        } else s = FS.mknod(e, a, 0), o = !0;
        if (!s) throw new FS.ErrnoError(ERRNO_CODES.ENOENT);
        if (FS.isChrdev(s.mode) && (t &= -513), 65536 & t && !FS.isDir(s.mode)) throw new FS.ErrnoError(ERRNO_CODES.ENOTDIR);

        if (!o) {
          var i = FS.mayOpen(s, t);
          if (i) throw new FS.ErrnoError(i);
        }

        512 & t && FS.truncate(s, 0), t &= -641;
        var c = FS.createStream({
          node: s,
          path: FS.getPath(s),
          flags: t,
          seekable: !0,
          position: 0,
          stream_ops: s.stream_ops,
          ungotten: [],
          error: !1
        }, r, n);
        c.stream_ops.open && c.stream_ops.open(c), !Module.logReadFiles || 1 & t || (FS.readFiles || (FS.readFiles = {}), e in FS.readFiles || (FS.readFiles[e] = 1, Module.printErr("read file: " + e)));

        try {
          if (FS.trackingDelegate.onOpenFile) {
            var u = 0;
            1 != (2097155 & t) && (u |= FS.tracking.openFlags.READ), 0 != (2097155 & t) && (u |= FS.tracking.openFlags.WRITE), FS.trackingDelegate.onOpenFile(e, u);
          }
        } catch (t) {
          console.log("FS.trackingDelegate['onOpenFile']('" + e + "', flags) threw an exception: " + t.message);
        }

        return c;
      },
      close: function close(e) {
        e.getdents && (e.getdents = null);

        try {
          e.stream_ops.close && e.stream_ops.close(e);
        } catch (e) {
          throw e;
        } finally {
          FS.closeStream(e.fd);
        }
      },
      llseek: function llseek(e, t, a) {
        if (!e.seekable || !e.stream_ops.llseek) throw new FS.ErrnoError(ERRNO_CODES.ESPIPE);
        return e.position = e.stream_ops.llseek(e, t, a), e.ungotten = [], e.position;
      },
      read: function read(e, t, a, r, n) {
        if (r < 0 || n < 0) throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
        if (1 == (2097155 & e.flags)) throw new FS.ErrnoError(ERRNO_CODES.EBADF);
        if (FS.isDir(e.node.mode)) throw new FS.ErrnoError(ERRNO_CODES.EISDIR);
        if (!e.stream_ops.read) throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
        var s = !0;
        if (void 0 === n) n = e.position, s = !1;else if (!e.seekable) throw new FS.ErrnoError(ERRNO_CODES.ESPIPE);
        var o = e.stream_ops.read(e, t, a, r, n);
        return s || (e.position += o), o;
      },
      write: function write(e, t, a, r, n, s) {
        if (r < 0 || n < 0) throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
        if (0 == (2097155 & e.flags)) throw new FS.ErrnoError(ERRNO_CODES.EBADF);
        if (FS.isDir(e.node.mode)) throw new FS.ErrnoError(ERRNO_CODES.EISDIR);
        if (!e.stream_ops.write) throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
        1024 & e.flags && FS.llseek(e, 0, 2);
        var o = !0;
        if (void 0 === n) n = e.position, o = !1;else if (!e.seekable) throw new FS.ErrnoError(ERRNO_CODES.ESPIPE);
        var i = e.stream_ops.write(e, t, a, r, n, s);
        o || (e.position += i);

        try {
          e.path && FS.trackingDelegate.onWriteToFile && FS.trackingDelegate.onWriteToFile(e.path);
        } catch (e) {
          console.log("FS.trackingDelegate['onWriteToFile']('" + path + "') threw an exception: " + e.message);
        }

        return i;
      },
      allocate: function allocate(e, t, a) {
        if (t < 0 || a <= 0) throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
        if (0 == (2097155 & e.flags)) throw new FS.ErrnoError(ERRNO_CODES.EBADF);
        if (!FS.isFile(e.node.mode) && !FS.isDir(e.node.mode)) throw new FS.ErrnoError(ERRNO_CODES.ENODEV);
        if (!e.stream_ops.allocate) throw new FS.ErrnoError(ERRNO_CODES.EOPNOTSUPP);
        e.stream_ops.allocate(e, t, a);
      },
      mmap: function mmap(e, t, a, r, n, s, o) {
        if (1 == (2097155 & e.flags)) throw new FS.ErrnoError(ERRNO_CODES.EACCES);
        if (!e.stream_ops.mmap) throw new FS.ErrnoError(ERRNO_CODES.ENODEV);
        return e.stream_ops.mmap(e, t, a, r, n, s, o);
      },
      msync: function msync(e, t, a, r, n) {
        return e && e.stream_ops.msync ? e.stream_ops.msync(e, t, a, r, n) : 0;
      },
      munmap: function munmap(e) {
        return 0;
      },
      ioctl: function ioctl(e, t, a) {
        if (!e.stream_ops.ioctl) throw new FS.ErrnoError(ERRNO_CODES.ENOTTY);
        return e.stream_ops.ioctl(e, t, a);
      },
      readFile: function readFile(e, t) {
        if ((t = t || {}).flags = t.flags || "r", t.encoding = t.encoding || "binary", "utf8" !== t.encoding && "binary" !== t.encoding) throw new Error('Invalid encoding type "' + t.encoding + '"');
        var a,
            r = FS.open(e, t.flags),
            n = FS.stat(e).size,
            s = new Uint8Array(n);
        return FS.read(r, s, 0, n, 0), "utf8" === t.encoding ? a = UTF8ArrayToString(s, 0) : "binary" === t.encoding && (a = s), FS.close(r), a;
      },
      writeFile: function writeFile(e, t, a) {
        if ((a = a || {}).flags = a.flags || "w", a.encoding = a.encoding || "utf8", "utf8" !== a.encoding && "binary" !== a.encoding) throw new Error('Invalid encoding type "' + a.encoding + '"');
        var r = FS.open(e, a.flags, a.mode);

        if ("utf8" === a.encoding) {
          var n = new Uint8Array(lengthBytesUTF8(t) + 1),
              s = stringToUTF8Array(t, n, 0, n.length);
          FS.write(r, n, 0, s, 0, a.canOwn);
        } else "binary" === a.encoding && FS.write(r, t, 0, t.length, 0, a.canOwn);

        FS.close(r);
      },
      cwd: function cwd() {
        return FS.currentPath;
      },
      chdir: function chdir(e) {
        var t = FS.lookupPath(e, {
          follow: !0
        });
        if (null === t.node) throw new FS.ErrnoError(ERRNO_CODES.ENOENT);
        if (!FS.isDir(t.node.mode)) throw new FS.ErrnoError(ERRNO_CODES.ENOTDIR);
        var a = FS.nodePermissions(t.node, "x");
        if (a) throw new FS.ErrnoError(a);
        FS.currentPath = t.path;
      },
      createDefaultDirectories: function createDefaultDirectories() {
        FS.mkdir("/tmp"), FS.mkdir("/home"), FS.mkdir("/home/web_user");
      },
      createDefaultDevices: function createDefaultDevices() {
        var e;

        if (FS.mkdir("/dev"), FS.registerDevice(FS.makedev(1, 3), {
          read: function read() {
            return 0;
          },
          write: function write(e, t, a, r, n) {
            return r;
          }
        }), FS.mkdev("/dev/null", FS.makedev(1, 3)), TTY.register(FS.makedev(5, 0), TTY.default_tty_ops), TTY.register(FS.makedev(6, 0), TTY.default_tty1_ops), FS.mkdev("/dev/tty", FS.makedev(5, 0)), FS.mkdev("/dev/tty1", FS.makedev(6, 0)), "undefined" != typeof crypto) {
          var t = new Uint8Array(1);

          e = function e() {
            return crypto.getRandomValues(t), t[0];
          };
        } else e = ENVIRONMENT_IS_NODE ? function () {
          return __webpack_require__(
          /*! crypto */
          668).randomBytes(1)[0];
        } : function () {
          return 256 * Math.random() | 0;
        };

        FS.createDevice("/dev", "random", e), FS.createDevice("/dev", "urandom", e), FS.mkdir("/dev/shm"), FS.mkdir("/dev/shm/tmp");
      },
      createSpecialDirectories: function createSpecialDirectories() {
        FS.mkdir("/proc"), FS.mkdir("/proc/self"), FS.mkdir("/proc/self/fd"), FS.mount({
          mount: function mount() {
            var e = FS.createNode("/proc/self", "fd", 16895, 73);
            return e.node_ops = {
              lookup: function lookup(e, t) {
                var a = +t,
                    r = FS.getStream(a);
                if (!r) throw new FS.ErrnoError(ERRNO_CODES.EBADF);
                var n = {
                  parent: null,
                  mount: {
                    mountpoint: "fake"
                  },
                  node_ops: {
                    readlink: function readlink() {
                      return r.path;
                    }
                  }
                };
                return n.parent = n, n;
              }
            }, e;
          }
        }, {}, "/proc/self/fd");
      },
      createStandardStreams: function createStandardStreams() {
        Module.stdin ? FS.createDevice("/dev", "stdin", Module.stdin) : FS.symlink("/dev/tty", "/dev/stdin"), Module.stdout ? FS.createDevice("/dev", "stdout", null, Module.stdout) : FS.symlink("/dev/tty", "/dev/stdout"), Module.stderr ? FS.createDevice("/dev", "stderr", null, Module.stderr) : FS.symlink("/dev/tty1", "/dev/stderr");
        var e = FS.open("/dev/stdin", "r");
        assert(0 === e.fd, "invalid handle for stdin (" + e.fd + ")");
        var t = FS.open("/dev/stdout", "w");
        assert(1 === t.fd, "invalid handle for stdout (" + t.fd + ")");
        var a = FS.open("/dev/stderr", "w");
        assert(2 === a.fd, "invalid handle for stderr (" + a.fd + ")");
      },
      ensureErrnoError: function ensureErrnoError() {
        FS.ErrnoError || (FS.ErrnoError = function (e, t) {
          this.node = t, this.setErrno = function (e) {
            for (var t in this.errno = e, ERRNO_CODES) {
              if (ERRNO_CODES[t] === e) {
                this.code = t;
                break;
              }
            }
          }, this.setErrno(e), this.message = ERRNO_MESSAGES[e];
        }, FS.ErrnoError.prototype = new Error(), FS.ErrnoError.prototype.constructor = FS.ErrnoError, [ERRNO_CODES.ENOENT].forEach(function (e) {
          FS.genericErrors[e] = new FS.ErrnoError(e), FS.genericErrors[e].stack = "<generic error, no stack>";
        }));
      },
      staticInit: function staticInit() {
        FS.ensureErrnoError(), FS.nameTable = new Array(4096), FS.mount(MEMFS, {}, "/"), FS.createDefaultDirectories(), FS.createDefaultDevices(), FS.createSpecialDirectories(), FS.filesystems = {
          MEMFS: MEMFS,
          IDBFS: IDBFS,
          NODEFS: NODEFS,
          WORKERFS: WORKERFS
        };
      },
      init: function init(e, t, a) {
        assert(!FS.init.initialized, "FS.init was previously called. If you want to initialize later with custom parameters, remove any earlier calls (note that one is automatically added to the generated code)"), FS.init.initialized = !0, FS.ensureErrnoError(), Module.stdin = e || Module.stdin, Module.stdout = t || Module.stdout, Module.stderr = a || Module.stderr, FS.createStandardStreams();
      },
      quit: function quit() {
        FS.init.initialized = !1;
        var e = Module._fflush;
        e && e(0);

        for (var t = 0; t < FS.streams.length; t++) {
          var a = FS.streams[t];
          a && FS.close(a);
        }
      },
      getMode: function getMode(e, t) {
        var a = 0;
        return e && (a |= 365), t && (a |= 146), a;
      },
      joinPath: function joinPath(e, t) {
        var a = PATH.join.apply(null, e);
        return t && "/" == a[0] && (a = a.substr(1)), a;
      },
      absolutePath: function absolutePath(e, t) {
        return PATH.resolve(t, e);
      },
      standardizePath: function standardizePath(e) {
        return PATH.normalize(e);
      },
      findObject: function findObject(e, t) {
        var a = FS.analyzePath(e, t);
        return a.exists ? a.object : (___setErrNo(a.error), null);
      },
      analyzePath: function analyzePath(e, t) {
        try {
          e = (r = FS.lookupPath(e, {
            follow: !t
          })).path;
        } catch (e) {}

        var a = {
          isRoot: !1,
          exists: !1,
          error: 0,
          name: null,
          path: null,
          object: null,
          parentExists: !1,
          parentPath: null,
          parentObject: null
        };

        try {
          var r = FS.lookupPath(e, {
            parent: !0
          });
          a.parentExists = !0, a.parentPath = r.path, a.parentObject = r.node, a.name = PATH.basename(e), r = FS.lookupPath(e, {
            follow: !t
          }), a.exists = !0, a.path = r.path, a.object = r.node, a.name = r.node.name, a.isRoot = "/" === r.path;
        } catch (e) {
          a.error = e.errno;
        }

        return a;
      },
      createFolder: function createFolder(e, t, a, r) {
        var n = PATH.join2("string" == typeof e ? e : FS.getPath(e), t),
            s = FS.getMode(a, r);
        return FS.mkdir(n, s);
      },
      createPath: function createPath(e, t, a, r) {
        e = "string" == typeof e ? e : FS.getPath(e);

        for (var n = t.split("/").reverse(); n.length;) {
          var s = n.pop();

          if (s) {
            var o = PATH.join2(e, s);

            try {
              FS.mkdir(o);
            } catch (e) {}

            e = o;
          }
        }

        return o;
      },
      createFile: function createFile(e, t, a, r, n) {
        var s = PATH.join2("string" == typeof e ? e : FS.getPath(e), t),
            o = FS.getMode(r, n);
        return FS.create(s, o);
      },
      createDataFile: function createDataFile(e, t, a, r, n, s) {
        var o = t ? PATH.join2("string" == typeof e ? e : FS.getPath(e), t) : e,
            i = FS.getMode(r, n),
            c = FS.create(o, i);

        if (a) {
          if ("string" == typeof a) {
            for (var u = new Array(a.length), d = 0, f = a.length; d < f; ++d) {
              u[d] = a.charCodeAt(d);
            }

            a = u;
          }

          FS.chmod(c, 146 | i);
          var l = FS.open(c, "w");
          FS.write(l, a, 0, a.length, 0, s), FS.close(l), FS.chmod(c, i);
        }

        return c;
      },
      createDevice: function createDevice(e, t, a, r) {
        var n = PATH.join2("string" == typeof e ? e : FS.getPath(e), t),
            s = FS.getMode(!!a, !!r);
        FS.createDevice.major || (FS.createDevice.major = 64);
        var o = FS.makedev(FS.createDevice.major++, 0);
        return FS.registerDevice(o, {
          open: function open(e) {
            e.seekable = !1;
          },
          close: function close(e) {
            r && r.buffer && r.buffer.length && r(10);
          },
          read: function read(e, t, r, n, s) {
            for (var o = 0, i = 0; i < n; i++) {
              var c;

              try {
                c = a();
              } catch (e) {
                throw new FS.ErrnoError(ERRNO_CODES.EIO);
              }

              if (void 0 === c && 0 === o) throw new FS.ErrnoError(ERRNO_CODES.EAGAIN);
              if (null == c) break;
              o++, t[r + i] = c;
            }

            return o && (e.node.timestamp = Date.now()), o;
          },
          write: function write(e, t, a, n, s) {
            for (var o = 0; o < n; o++) {
              try {
                r(t[a + o]);
              } catch (e) {
                throw new FS.ErrnoError(ERRNO_CODES.EIO);
              }
            }

            return n && (e.node.timestamp = Date.now()), o;
          }
        }), FS.mkdev(n, s, o);
      },
      createLink: function createLink(e, t, a, r, n) {
        var s = PATH.join2("string" == typeof e ? e : FS.getPath(e), t);
        return FS.symlink(a, s);
      },
      forceLoadFile: function forceLoadFile(e) {
        if (e.isDevice || e.isFolder || e.link || e.contents) return !0;
        var t = !0;
        if ("undefined" != typeof XMLHttpRequest) throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");
        if (!Module.read) throw new Error("Cannot load without read() or XMLHttpRequest.");

        try {
          e.contents = intArrayFromString(Module.read(e.url), !0), e.usedBytes = e.contents.length;
        } catch (e) {
          t = !1;
        }

        return t || ___setErrNo(ERRNO_CODES.EIO), t;
      },
      createLazyFile: function createLazyFile(e, t, a, r, n) {
        function s() {
          this.lengthKnown = !1, this.chunks = [];
        }

        if (s.prototype.get = function (e) {
          if (!(e > this.length - 1 || e < 0)) {
            var t = e % this.chunkSize,
                a = e / this.chunkSize | 0;
            return this.getter(a)[t];
          }
        }, s.prototype.setDataGetter = function (e) {
          this.getter = e;
        }, s.prototype.cacheLength = function () {
          var e = new XMLHttpRequest();
          if (e.open("HEAD", a, !1), e.send(null), !(e.status >= 200 && e.status < 300 || 304 === e.status)) throw new Error("Couldn't load " + a + ". Status: " + e.status);
          var t,
              r = Number(e.getResponseHeader("Content-length")),
              n = (t = e.getResponseHeader("Accept-Ranges")) && "bytes" === t,
              s = (t = e.getResponseHeader("Content-Encoding")) && "gzip" === t,
              o = 1048576;
          n || (o = r);
          var i = this;
          i.setDataGetter(function (e) {
            var t = e * o,
                n = (e + 1) * o - 1;
            if (n = Math.min(n, r - 1), void 0 === i.chunks[e] && (i.chunks[e] = function (e, t) {
              if (e > t) throw new Error("invalid range (" + e + ", " + t + ") or no bytes requested!");
              if (t > r - 1) throw new Error("only " + r + " bytes available! programmer error!");
              var n = new XMLHttpRequest();
              if (n.open("GET", a, !1), r !== o && n.setRequestHeader("Range", "bytes=" + e + "-" + t), "undefined" != typeof Uint8Array && (n.responseType = "arraybuffer"), n.overrideMimeType && n.overrideMimeType("text/plain; charset=x-user-defined"), n.send(null), !(n.status >= 200 && n.status < 300 || 304 === n.status)) throw new Error("Couldn't load " + a + ". Status: " + n.status);
              return void 0 !== n.response ? new Uint8Array(n.response || []) : intArrayFromString(n.responseText || "", !0);
            }(t, n)), void 0 === i.chunks[e]) throw new Error("doXHR failed!");
            return i.chunks[e];
          }), !s && r || (o = r = 1, r = this.getter(0).length, o = r, console.log("LazyFiles on gzip forces download of the whole file when length is accessed")), this._length = r, this._chunkSize = o, this.lengthKnown = !0;
        }, "undefined" != typeof XMLHttpRequest) {
          if (!ENVIRONMENT_IS_WORKER) throw "Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";
          var o = new s();
          Object.defineProperties(o, {
            length: {
              get: function get() {
                return this.lengthKnown || this.cacheLength(), this._length;
              }
            },
            chunkSize: {
              get: function get() {
                return this.lengthKnown || this.cacheLength(), this._chunkSize;
              }
            }
          });
          var i = {
            isDevice: !1,
            contents: o
          };
        } else i = {
          isDevice: !1,
          url: a
        };

        var c = FS.createFile(e, t, i, r, n);
        i.contents ? c.contents = i.contents : i.url && (c.contents = null, c.url = i.url), Object.defineProperties(c, {
          usedBytes: {
            get: function get() {
              return this.contents.length;
            }
          }
        });
        var u = {};
        return Object.keys(c.stream_ops).forEach(function (e) {
          var t = c.stream_ops[e];

          u[e] = function () {
            if (!FS.forceLoadFile(c)) throw new FS.ErrnoError(ERRNO_CODES.EIO);
            return t.apply(null, arguments);
          };
        }), u.read = function (e, t, a, r, n) {
          if (!FS.forceLoadFile(c)) throw new FS.ErrnoError(ERRNO_CODES.EIO);
          var s = e.node.contents;
          if (n >= s.length) return 0;
          var o = Math.min(s.length - n, r);
          if (assert(o >= 0), s.slice) for (var i = 0; i < o; i++) {
            t[a + i] = s[n + i];
          } else for (i = 0; i < o; i++) {
            t[a + i] = s.get(n + i);
          }
          return o;
        }, c.stream_ops = u, c;
      },
      createPreloadedFile: function createPreloadedFile(e, t, a, r, n, s, o, i, c, u) {
        Browser.init();
        var d = t ? PATH.resolve(PATH.join2(e, t)) : e,
            f = getUniqueRunDependency("cp " + d);

        function l(a) {
          function l(a) {
            u && u(), i || FS.createDataFile(e, t, a, r, n, c), s && s(), removeRunDependency(f);
          }

          var h = !1;
          Module.preloadPlugins.forEach(function (e) {
            h || e.canHandle(d) && (e.handle(a, d, l, function () {
              o && o(), removeRunDependency(f);
            }), h = !0);
          }), h || l(a);
        }

        addRunDependency(f), "string" == typeof a ? Browser.asyncLoad(a, function (e) {
          l(e);
        }, o) : l(a);
      },
      indexedDB: function indexedDB() {
        return window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
      },
      DB_NAME: function DB_NAME() {
        return "EM_FS_" + window.location.pathname;
      },
      DB_VERSION: 20,
      DB_STORE_NAME: "FILE_DATA",
      saveFilesToDB: function saveFilesToDB(e, t, a) {
        t = t || function () {}, a = a || function () {};
        var r = FS.indexedDB();

        try {
          var n = r.open(FS.DB_NAME(), FS.DB_VERSION);
        } catch (e) {
          return a(e);
        }

        n.onupgradeneeded = function () {
          console.log("creating db"), n.result.createObjectStore(FS.DB_STORE_NAME);
        }, n.onsuccess = function () {
          var r = n.result.transaction([FS.DB_STORE_NAME], "readwrite"),
              s = r.objectStore(FS.DB_STORE_NAME),
              o = 0,
              i = 0,
              c = e.length;

          function u() {
            0 == i ? t() : a();
          }

          e.forEach(function (e) {
            var t = s.put(FS.analyzePath(e).object.contents, e);
            t.onsuccess = function () {
              ++o + i == c && u();
            }, t.onerror = function () {
              o + ++i == c && u();
            };
          }), r.onerror = a;
        }, n.onerror = a;
      },
      loadFilesFromDB: function loadFilesFromDB(e, t, a) {
        t = t || function () {}, a = a || function () {};
        var r = FS.indexedDB();

        try {
          var n = r.open(FS.DB_NAME(), FS.DB_VERSION);
        } catch (e) {
          return a(e);
        }

        n.onupgradeneeded = a, n.onsuccess = function () {
          var r = n.result;

          try {
            var s = r.transaction([FS.DB_STORE_NAME], "readonly");
          } catch (e) {
            return void a(e);
          }

          var o = s.objectStore(FS.DB_STORE_NAME),
              i = 0,
              c = 0,
              u = e.length;

          function d() {
            0 == c ? t() : a();
          }

          e.forEach(function (e) {
            var t = o.get(e);
            t.onsuccess = function () {
              FS.analyzePath(e).exists && FS.unlink(e), FS.createDataFile(PATH.dirname(e), PATH.basename(e), t.result, !0, !0, !0), ++i + c == u && d();
            }, t.onerror = function () {
              i + ++c == u && d();
            };
          }), s.onerror = a;
        }, n.onerror = a;
      }
    },
        SYSCALLS = {
      DEFAULT_POLLMASK: 5,
      mappings: {},
      umask: 511,
      calculateAt: function calculateAt(e, t) {
        if ("/" !== t[0]) {
          var a;
          if (-100 === e) a = FS.cwd();else {
            var r = FS.getStream(e);
            if (!r) throw new FS.ErrnoError(ERRNO_CODES.EBADF);
            a = r.path;
          }
          t = PATH.join2(a, t);
        }

        return t;
      },
      doStat: function doStat(e, t, a) {
        try {
          var r = e(t);
        } catch (e) {
          if (e && e.node && PATH.normalize(t) !== PATH.normalize(FS.getPath(e.node))) return -ERRNO_CODES.ENOTDIR;
          throw e;
        }

        return HEAP32[a >> 2] = r.dev, HEAP32[a + 4 >> 2] = 0, HEAP32[a + 8 >> 2] = r.ino, HEAP32[a + 12 >> 2] = r.mode, HEAP32[a + 16 >> 2] = r.nlink, HEAP32[a + 20 >> 2] = r.uid, HEAP32[a + 24 >> 2] = r.gid, HEAP32[a + 28 >> 2] = r.rdev, HEAP32[a + 32 >> 2] = 0, HEAP32[a + 36 >> 2] = r.size, HEAP32[a + 40 >> 2] = 4096, HEAP32[a + 44 >> 2] = r.blocks, HEAP32[a + 48 >> 2] = r.atime.getTime() / 1e3 | 0, HEAP32[a + 52 >> 2] = 0, HEAP32[a + 56 >> 2] = r.mtime.getTime() / 1e3 | 0, HEAP32[a + 60 >> 2] = 0, HEAP32[a + 64 >> 2] = r.ctime.getTime() / 1e3 | 0, HEAP32[a + 68 >> 2] = 0, HEAP32[a + 72 >> 2] = r.ino, 0;
      },
      doMsync: function doMsync(e, t, a, r) {
        var n = new Uint8Array(HEAPU8.subarray(e, e + a));
        FS.msync(t, n, 0, a, r);
      },
      doMkdir: function doMkdir(e, t) {
        return "/" === (e = PATH.normalize(e))[e.length - 1] && (e = e.substr(0, e.length - 1)), FS.mkdir(e, t, 0), 0;
      },
      doMknod: function doMknod(e, t, a) {
        switch (61440 & t) {
          case 32768:
          case 8192:
          case 24576:
          case 4096:
          case 49152:
            break;

          default:
            return -ERRNO_CODES.EINVAL;
        }

        return FS.mknod(e, t, a), 0;
      },
      doReadlink: function doReadlink(e, t, a) {
        if (a <= 0) return -ERRNO_CODES.EINVAL;
        var r = FS.readlink(e),
            n = Math.min(a, lengthBytesUTF8(r)),
            s = HEAP8[t + n];
        return stringToUTF8(r, t, a + 1), HEAP8[t + n] = s, n;
      },
      doAccess: function doAccess(e, t) {
        if (-8 & t) return -ERRNO_CODES.EINVAL;
        var a;
        a = FS.lookupPath(e, {
          follow: !0
        }).node;
        var r = "";
        return 4 & t && (r += "r"), 2 & t && (r += "w"), 1 & t && (r += "x"), r && FS.nodePermissions(a, r) ? -ERRNO_CODES.EACCES : 0;
      },
      doDup: function doDup(e, t, a) {
        var r = FS.getStream(a);
        return r && FS.close(r), FS.open(e, t, 0, a, a).fd;
      },
      doReadv: function doReadv(e, t, a, r) {
        for (var n = 0, s = 0; s < a; s++) {
          var o = HEAP32[t + 8 * s >> 2],
              i = HEAP32[t + (8 * s + 4) >> 2],
              c = FS.read(e, HEAP8, o, i, r);
          if (c < 0) return -1;
          if (n += c, c < i) break;
        }

        return n;
      },
      doWritev: function doWritev(e, t, a, r) {
        for (var n = 0, s = 0; s < a; s++) {
          var o = HEAP32[t + 8 * s >> 2],
              i = HEAP32[t + (8 * s + 4) >> 2],
              c = FS.write(e, HEAP8, o, i, r);
          if (c < 0) return -1;
          n += c;
        }

        return n;
      },
      varargs: 0,
      get: function get(e) {
        return SYSCALLS.varargs += 4, HEAP32[SYSCALLS.varargs - 4 >> 2];
      },
      getStr: function getStr() {
        return Pointer_stringify(SYSCALLS.get());
      },
      getStreamFromFD: function getStreamFromFD() {
        var e = FS.getStream(SYSCALLS.get());
        if (!e) throw new FS.ErrnoError(ERRNO_CODES.EBADF);
        return e;
      },
      getSocketFromFD: function getSocketFromFD() {
        var e = SOCKFS.getSocket(SYSCALLS.get());
        if (!e) throw new FS.ErrnoError(ERRNO_CODES.EBADF);
        return e;
      },
      getSocketAddress: function getSocketAddress(e) {
        var t = SYSCALLS.get(),
            a = SYSCALLS.get();
        if (e && 0 === t) return null;

        var r = __read_sockaddr(t, a);

        if (r.errno) throw new FS.ErrnoError(r.errno);
        return r.addr = DNS.lookup_addr(r.addr) || r.addr, r;
      },
      get64: function get64() {
        var e = SYSCALLS.get(),
            t = SYSCALLS.get();
        return assert(e >= 0 ? 0 === t : -1 === t), e;
      },
      getZero: function getZero() {
        assert(0 === SYSCALLS.get());
      }
    };

    function ___syscall54(e, t) {
      SYSCALLS.varargs = t;

      try {
        var a = SYSCALLS.getStreamFromFD(),
            r = SYSCALLS.get();

        switch (r) {
          case 21505:
          case 21506:
            return a.tty ? 0 : -ERRNO_CODES.ENOTTY;

          case 21519:
            if (!a.tty) return -ERRNO_CODES.ENOTTY;
            var n = SYSCALLS.get();
            return HEAP32[n >> 2] = 0, 0;

          case 21520:
            return a.tty ? -ERRNO_CODES.EINVAL : -ERRNO_CODES.ENOTTY;

          case 21531:
            n = SYSCALLS.get();
            return FS.ioctl(a, r, n);

          case 21523:
            return a.tty ? 0 : -ERRNO_CODES.ENOTTY;

          default:
            abort("bad ioctl syscall " + r);
        }
      } catch (e) {
        return void 0 !== FS && e instanceof FS.ErrnoError || abort(e), -e.errno;
      }
    }

    function __Unwind_GetIPInfo() {
      abort("Unwind_GetIPInfo");
    }

    function _pthread_cond_init() {
      return 0;
    }

    function __emscripten_traverse_stack(e) {
      if (!e || !e.callee || !e.callee.name) return [null, "", ""];
      e.callee.toString();
      var t = e.callee.name,
          a = "(",
          r = !0;

      for (i in e) {
        var n = e[i];
        r || (a += ", "), r = !1, a += "number" == typeof n || "string" == typeof n ? n : "(" + typeof n + ")";
      }

      a += ")";
      var s = e.callee.caller;
      return r && (a = ""), [e = s ? s.arguments : [], t, a];
    }

    function _emscripten_get_callstack_js(e) {
      var t = jsStackTrace(),
          a = t.lastIndexOf("_emscripten_log"),
          r = t.lastIndexOf("_emscripten_get_callstack"),
          n = t.indexOf("\n", Math.max(a, r)) + 1;
      t = t.slice(n), 8 & e && "undefined" == typeof emscripten_source_map && (Runtime.warnOnce('Source map information is not available, emscripten_log with EM_LOG_C_STACK will be ignored. Build with "--pre-js $EMSCRIPTEN/src/emscripten-source-map.min.js" linker flag to add source map loading to code.'), e ^= 8, e |= 16);
      var s = null;
      if (128 & e) for (s = __emscripten_traverse_stack(arguments); s[1].indexOf("_emscripten_") >= 0;) {
        s = __emscripten_traverse_stack(s[0]);
      }
      lines = t.split("\n"), t = "";
      var o = new RegExp("\\s*(.*?)@(.*?):([0-9]+):([0-9]+)"),
          i = new RegExp("\\s*(.*?)@(.*):(.*)(:(.*))?"),
          c = new RegExp("\\s*at (.*?) \\((.*):(.*):(.*)\\)");

      for (l in lines) {
        var u = lines[l],
            d = "",
            f = "",
            h = 0,
            p = 0,
            b = c.exec(u);
        if (b && 5 == b.length) d = b[1], f = b[2], h = b[3], p = b[4];else {
          if ((b = o.exec(u)) || (b = i.exec(u)), !(b && b.length >= 4)) {
            t += u + "\n";
            continue;
          }

          d = b[1], f = b[2], h = b[3], p = 0 | b[4];
        }
        var m = 32 & e ? demangle(d) : d;
        m || (m = d);
        var y = !1;

        if (8 & e) {
          var v = emscripten_source_map.originalPositionFor({
            line: h,
            column: p
          });
          (y = v && v.source) && (64 & e && (v.source = v.source.substring(v.source.replace(/\\/g, "/").lastIndexOf("/") + 1)), t += "    at " + m + " (" + v.source + ":" + v.line + ":" + v.column + ")\n");
        }

        (16 & e || !y) && (64 & e && (f = f.substring(f.replace(/\\/g, "/").lastIndexOf("/") + 1)), t += (y ? "     = " + d : "    at " + m) + " (" + f + ":" + h + ":" + p + ")\n"), 128 & e && s[0] && (s[1] == d && s[2].length > 0 && (t = t.replace(/\s+$/, ""), t += " with values: " + s[1] + s[2] + "\n"), s = __emscripten_traverse_stack(s[0]));
      }

      return t = t.replace(/\s+$/, "");
    }

    function __Unwind_Backtrace(e, t) {
      for (var a = _emscripten_get_callstack_js().split("\n"), r = 0; r < a.length; r++) {
        if (0 !== Module.dynCall_iii(e, 0, t)) return;
      }
    }

    function _pthread_condattr_setclock() {
      return 0;
    }

    var _environ = STATICTOP;

    function ___buildEnvironment(e) {
      var t, a;
      ___buildEnvironment.called ? (a = HEAP32[_environ >> 2], t = HEAP32[a >> 2]) : (___buildEnvironment.called = !0, ENV.USER = ENV.LOGNAME = "web_user", ENV.PATH = "/", ENV.PWD = "/", ENV.HOME = "/home/web_user", ENV.LANG = "C", ENV._ = Module.thisProgram, t = allocate(1024, "i8", ALLOC_STATIC), a = allocate(256, "i8*", ALLOC_STATIC), HEAP32[a >> 2] = t, HEAP32[_environ >> 2] = a);
      var r = [],
          n = 0;

      for (var s in e) {
        if ("string" == typeof e[s]) {
          var o = s + "=" + e[s];
          r.push(o), n += o.length;
        }
      }

      if (n > 1024) throw new Error("Environment size exceeded TOTAL_ENV_SIZE!");

      for (var i = 0; i < r.length; i++) {
        writeAsciiToMemory(o = r[i], t), HEAP32[a + 4 * i >> 2] = t, t += o.length + 1;
      }

      HEAP32[a + 4 * r.length >> 2] = 0;
    }

    STATICTOP += 16;
    var ENV = {},
        ASSERTIONS;

    function _getenv(e) {
      return 0 === e ? 0 : (e = Pointer_stringify(e), ENV.hasOwnProperty(e) ? (_getenv.ret && _free(_getenv.ret), _getenv.ret = allocate(intArrayFromString(ENV[e]), "i8", ALLOC_NORMAL), _getenv.ret) : 0);
    }

    function _pthread_rwlock_rdlock() {
      return 0;
    }

    function ___cxa_find_matching_catch_3() {
      return ___cxa_find_matching_catch.apply(null, arguments);
    }

    function _emscripten_memcpy_big(e, t, a) {
      return HEAPU8.set(HEAPU8.subarray(t, t + a), e), e;
    }

    function ___syscall6(e, t) {
      SYSCALLS.varargs = t;

      try {
        var a = SYSCALLS.getStreamFromFD();
        return FS.close(a), 0;
      } catch (e) {
        return void 0 !== FS && e instanceof FS.ErrnoError || abort(e), -e.errno;
      }
    }

    function _pthread_cond_signal() {
      return 0;
    }

    function _dladdr(e, t) {
      var a = allocate(intArrayFromString(Module.thisProgram || "./this.program"), "i8", ALLOC_NORMAL);
      return HEAP32[e >> 2] = a, HEAP32[e + 4 >> 2] = 0, HEAP32[e + 8 >> 2] = 0, HEAP32[e + 12 >> 2] = 0, 1;
    }

    function ___gxx_personality_v0() {}

    function _pthread_mutex_destroy() {}

    function _pthread_mutexattr_init() {}

    function ___syscall4(e, t) {
      SYSCALLS.varargs = t;

      try {
        var a = SYSCALLS.getStreamFromFD(),
            r = SYSCALLS.get(),
            n = SYSCALLS.get();
        return FS.write(a, HEAP8, r, n);
      } catch (e) {
        return void 0 !== FS && e instanceof FS.ErrnoError || abort(e), -e.errno;
      }
    }

    function _pthread_condattr_init() {
      return 0;
    }

    function _llvm_trap() {
      abort("trap!");
    }

    function ___cxa_find_matching_catch_2() {
      return ___cxa_find_matching_catch.apply(null, arguments);
    }

    function ___syscall140(e, t) {
      SYSCALLS.varargs = t;

      try {
        var a = SYSCALLS.getStreamFromFD(),
            r = (SYSCALLS.get(), SYSCALLS.get()),
            n = SYSCALLS.get(),
            s = SYSCALLS.get(),
            o = r;
        return FS.llseek(a, o, s), HEAP32[n >> 2] = a.position, a.getdents && 0 === o && 0 === s && (a.getdents = null), 0;
      } catch (e) {
        return void 0 !== FS && e instanceof FS.ErrnoError || abort(e), -e.errno;
      }
    }

    function ___syscall146(e, t) {
      SYSCALLS.varargs = t;

      try {
        var a = SYSCALLS.getStreamFromFD(),
            r = SYSCALLS.get(),
            n = SYSCALLS.get();
        return SYSCALLS.doWritev(a, r, n);
      } catch (e) {
        return void 0 !== FS && e instanceof FS.ErrnoError || abort(e), -e.errno;
      }
    }

    function _pthread_rwlock_unlock() {
      return 0;
    }

    if (Module.requestFullScreen = function (e, t, a) {
      Module.printErr("Module.requestFullScreen is deprecated. Please call Module.requestFullscreen instead."), Module.requestFullScreen = Module.requestFullscreen, Browser.requestFullScreen(e, t, a);
    }, Module.requestFullscreen = function (e, t, a) {
      Browser.requestFullscreen(e, t, a);
    }, Module.requestAnimationFrame = function (e) {
      Browser.requestAnimationFrame(e);
    }, Module.setCanvasSize = function (e, t, a) {
      Browser.setCanvasSize(e, t, a);
    }, Module.pauseMainLoop = function () {
      Browser.mainLoop.pause();
    }, Module.resumeMainLoop = function () {
      Browser.mainLoop.resume();
    }, Module.getUserMedia = function () {
      Browser.getUserMedia();
    }, Module.createContext = function (e, t, a, r) {
      return Browser.createContext(e, t, a, r);
    }, _emscripten_get_now = ENVIRONMENT_IS_NODE ? function () {
      var e = process.hrtime();
      return 1e3 * e[0] + e[1] / 1e6;
    } : "undefined" != typeof dateNow ? dateNow : "object" == typeof self && self.performance && "function" == typeof self.performance.now ? function () {
      return self.performance.now();
    } : "object" == typeof performance && "function" == typeof performance.now ? function () {
      return performance.now();
    } : Date.now, FS.staticInit(), __ATINIT__.unshift(function () {
      Module.noFSInit || FS.init.initialized || FS.init();
    }), __ATMAIN__.push(function () {
      FS.ignorePermissions = !1;
    }), __ATEXIT__.push(function () {
      FS.quit();
    }), Module.FS_createFolder = FS.createFolder, Module.FS_createPath = FS.createPath, Module.FS_createDataFile = FS.createDataFile, Module.FS_createPreloadedFile = FS.createPreloadedFile, Module.FS_createLazyFile = FS.createLazyFile, Module.FS_createLink = FS.createLink, Module.FS_createDevice = FS.createDevice, Module.FS_unlink = FS.unlink, __ATINIT__.unshift(function () {
      TTY.init();
    }), __ATEXIT__.push(function () {
      TTY.shutdown();
    }), ENVIRONMENT_IS_NODE) {
      var fs = __webpack_require__(
      /*! fs */
      245),
          NODEJS_PATH = __webpack_require__(
      /*! path */
      246);

      NODEFS.staticInit();
    }

    function intArrayFromString(e, t, a) {
      var r = a > 0 ? a : lengthBytesUTF8(e) + 1,
          n = new Array(r),
          s = stringToUTF8Array(e, n, 0, n.length);
      return t && (n.length = s), n;
    }

    ___buildEnvironment(ENV), DYNAMICTOP_PTR = allocate(1, "i32", ALLOC_STATIC), STACK_BASE = STACKTOP = Runtime.alignMemory(STATICTOP), STACK_MAX = STACK_BASE + TOTAL_STACK, DYNAMIC_BASE = Runtime.alignMemory(STACK_MAX), HEAP32[DYNAMICTOP_PTR >> 2] = DYNAMIC_BASE, staticSealed = !0;
    var intArrayToString = ASSERTIONS ? function (e) {
      for (var t = [], a = 0; a < e.length; a++) {
        var r = e[a];
        r > 255 && (assert(!1, "Character code " + r + " (" + String.fromCharCode(r) + ")  at offset " + a + " not in 0x00-0xFF."), r &= 255), t.push(String.fromCharCode(r));
      }

      return t.join("");
    } : function (e) {
      for (var t = [], a = 0; a < e.length; a++) {
        var r = e[a];
        r > 255 && (r &= 255), t.push(String.fromCharCode(r));
      }

      return t.join("");
    };
    Module.intArrayFromString = intArrayFromString, Module.intArrayToString = intArrayToString;
    var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
        decodeBase64 = "function" == typeof atob ? atob : function (e) {
      var t,
          a,
          r,
          n,
          s,
          o,
          i = "",
          c = 0;
      e = e.replace(/[^A-Za-z0-9\+\/\=]/g, "");

      do {
        t = keyStr.indexOf(e.charAt(c++)) << 2 | (n = keyStr.indexOf(e.charAt(c++))) >> 4, a = (15 & n) << 4 | (s = keyStr.indexOf(e.charAt(c++))) >> 2, r = (3 & s) << 6 | (o = keyStr.indexOf(e.charAt(c++))), i += String.fromCharCode(t), 64 !== s && (i += String.fromCharCode(a)), 64 !== o && (i += String.fromCharCode(r));
      } while (c < e.length);

      return i;
    };

    function intArrayFromBase64(e) {
      if ("boolean" == typeof ENVIRONMENT_IS_NODE && ENVIRONMENT_IS_NODE) {
        var t;

        try {
          t = Buffer.from(e, "base64");
        } catch (a) {
          t = new Buffer(e, "base64");
        }

        return new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
      }

      try {
        for (var a = decodeBase64(e), r = new Uint8Array(a.length), n = 0; n < a.length; ++n) {
          r[n] = a.charCodeAt(n);
        }

        return r;
      } catch (e) {
        throw new Error("Converting base64 string to bytes failed.");
      }
    }

    function tryParseAsDataURI(e) {
      var t = "data:application/octet-stream;base64,";
      if (String.prototype.startsWith ? e.startsWith(t) : 0 === e.indexOf(t)) return intArrayFromBase64(e.slice(t.length));
    }

    function invoke_iiii(e, t, a, r) {
      try {
        return Module.dynCall_iiii(e, t, a, r);
      } catch (e) {
        if ("number" != typeof e && "longjmp" !== e) throw e;
        Module.setThrew(1, 0);
      }
    }

    function invoke_viiiii(e, t, a, r, n, s) {
      try {
        Module.dynCall_viiiii(e, t, a, r, n, s);
      } catch (e) {
        if ("number" != typeof e && "longjmp" !== e) throw e;
        Module.setThrew(1, 0);
      }
    }

    function invoke_i(e) {
      try {
        return Module.dynCall_i(e);
      } catch (e) {
        if ("number" != typeof e && "longjmp" !== e) throw e;
        Module.setThrew(1, 0);
      }
    }

    function invoke_vi(e, t) {
      try {
        Module.dynCall_vi(e, t);
      } catch (e) {
        if ("number" != typeof e && "longjmp" !== e) throw e;
        Module.setThrew(1, 0);
      }
    }

    function invoke_vii(e, t, a) {
      try {
        Module.dynCall_vii(e, t, a);
      } catch (e) {
        if ("number" != typeof e && "longjmp" !== e) throw e;
        Module.setThrew(1, 0);
      }
    }

    function invoke_ii(e, t) {
      try {
        return Module.dynCall_ii(e, t);
      } catch (e) {
        if ("number" != typeof e && "longjmp" !== e) throw e;
        Module.setThrew(1, 0);
      }
    }

    function invoke_viii(e, t, a, r) {
      try {
        Module.dynCall_viii(e, t, a, r);
      } catch (e) {
        if ("number" != typeof e && "longjmp" !== e) throw e;
        Module.setThrew(1, 0);
      }
    }

    function invoke_v(e) {
      try {
        Module.dynCall_v(e);
      } catch (e) {
        if ("number" != typeof e && "longjmp" !== e) throw e;
        Module.setThrew(1, 0);
      }
    }

    function invoke_iii(e, t, a) {
      try {
        return Module.dynCall_iii(e, t, a);
      } catch (e) {
        if ("number" != typeof e && "longjmp" !== e) throw e;
        Module.setThrew(1, 0);
      }
    }

    function invoke_iiiiii(e, t, a, r, n, s) {
      try {
        return Module.dynCall_iiiiii(e, t, a, r, n, s);
      } catch (e) {
        if ("number" != typeof e && "longjmp" !== e) throw e;
        Module.setThrew(1, 0);
      }
    }

    function invoke_viiii(e, t, a, r, n) {
      try {
        Module.dynCall_viiii(e, t, a, r, n);
      } catch (e) {
        if ("number" != typeof e && "longjmp" !== e) throw e;
        Module.setThrew(1, 0);
      }
    }

    Module.asmGlobalArg = {
      Math: Math,
      Int8Array: Int8Array,
      Int16Array: Int16Array,
      Int32Array: Int32Array,
      Uint8Array: Uint8Array,
      Uint16Array: Uint16Array,
      Uint32Array: Uint32Array,
      Float32Array: Float32Array,
      Float64Array: Float64Array,
      NaN: NaN,
      Infinity: 1 / 0
    }, Module.asmLibraryArg = {
      abort: abort,
      assert: assert,
      enlargeMemory: enlargeMemory,
      getTotalMemory: getTotalMemory,
      abortOnCannotGrowMemory: abortOnCannotGrowMemory,
      invoke_iiii: invoke_iiii,
      invoke_viiiii: invoke_viiiii,
      invoke_i: invoke_i,
      invoke_vi: invoke_vi,
      invoke_vii: invoke_vii,
      invoke_ii: invoke_ii,
      invoke_viii: invoke_viii,
      invoke_v: invoke_v,
      invoke_iii: invoke_iii,
      invoke_iiiiii: invoke_iiiiii,
      invoke_viiii: invoke_viiii,
      _pthread_cond_wait: _pthread_cond_wait,
      _llvm_bswap_i64: _llvm_bswap_i64,
      __Unwind_FindEnclosingFunction: __Unwind_FindEnclosingFunction,
      _emscripten_get_callstack_js: _emscripten_get_callstack_js,
      _pthread_key_create: _pthread_key_create,
      ___setErrNo: ___setErrNo,
      ___gxx_personality_v0: ___gxx_personality_v0,
      _pthread_rwlock_unlock: _pthread_rwlock_unlock,
      ___cxa_find_matching_catch_2: ___cxa_find_matching_catch_2,
      __ZSt18uncaught_exceptionv: __ZSt18uncaught_exceptionv,
      ___buildEnvironment: ___buildEnvironment,
      _pthread_cond_init: _pthread_cond_init,
      __Unwind_GetIPInfo: __Unwind_GetIPInfo,
      _pthread_mutexattr_destroy: _pthread_mutexattr_destroy,
      __emscripten_traverse_stack: __emscripten_traverse_stack,
      _emscripten_set_main_loop_timing: _emscripten_set_main_loop_timing,
      ___cxa_free_exception: ___cxa_free_exception,
      _pthread_key_delete: _pthread_key_delete,
      ___cxa_allocate_exception: ___cxa_allocate_exception,
      _pthread_rwlock_rdlock: _pthread_rwlock_rdlock,
      ___resumeException: ___resumeException,
      ___cxa_find_matching_catch: ___cxa_find_matching_catch,
      _pthread_condattr_setclock: _pthread_condattr_setclock,
      _pthread_getspecific: _pthread_getspecific,
      ___cxa_find_matching_catch_3: ___cxa_find_matching_catch_3,
      _emscripten_memcpy_big: _emscripten_memcpy_big,
      _pthread_cond_signal: _pthread_cond_signal,
      _pthread_mutex_destroy: _pthread_mutex_destroy,
      _abort: _abort,
      _pthread_condattr_init: _pthread_condattr_init,
      _pthread_mutexattr_settype: _pthread_mutexattr_settype,
      _getenv: _getenv,
      _pthread_condattr_destroy: _pthread_condattr_destroy,
      ___syscall54: ___syscall54,
      ___unlock: ___unlock,
      ___syscall140: ___syscall140,
      _emscripten_set_main_loop: _emscripten_set_main_loop,
      _emscripten_get_now: _emscripten_get_now,
      _pthread_mutexattr_init: _pthread_mutexattr_init,
      _pthread_setspecific: _pthread_setspecific,
      _dladdr: _dladdr,
      ___cxa_throw: ___cxa_throw,
      ___lock: ___lock,
      ___syscall6: ___syscall6,
      ___syscall4: ___syscall4,
      _pthread_cond_destroy: _pthread_cond_destroy,
      _llvm_trap: _llvm_trap,
      _pthread_mutex_init: _pthread_mutex_init,
      __Unwind_Backtrace: __Unwind_Backtrace,
      ___syscall146: ___syscall146,
      _emscripten_exit_with_live_runtime: _emscripten_exit_with_live_runtime,
      DYNAMICTOP_PTR: DYNAMICTOP_PTR,
      tempDoublePtr: tempDoublePtr,
      ABORT: ABORT,
      STACKTOP: STACKTOP,
      STACK_MAX: STACK_MAX
    };

    var asm = function (e, t, a) {
      "use asm";

      var r = new e.Int8Array(a);
      var n = new e.Int16Array(a);
      var s = new e.Int32Array(a);
      var o = new e.Uint8Array(a);
      var i = new e.Uint16Array(a);
      var c = new e.Uint32Array(a);
      var u = new e.Float32Array(a);
      var d = new e.Float64Array(a);
      var f = t.DYNAMICTOP_PTR | 0;
      var l = t.tempDoublePtr | 0;
      var h = t.ABORT | 0;
      var p = t.STACKTOP | 0;
      var b = t.STACK_MAX | 0;
      var m = 0;
      var y = 0;
      var v = 0;
      var _ = 0;
      var g = e.NaN,
          A = e.Infinity;
      var w = 0,
          T = 0,
          x = 0,
          D = 0,
          C = 0.0;
      var S = 0;
      var E = e.Math.floor;
      var B = e.Math.abs;
      var k = e.Math.sqrt;
      var R = e.Math.pow;
      var W = e.Math.cos;
      var I = e.Math.sin;
      var N = e.Math.tan;
      var M = e.Math.acos;
      var P = e.Math.asin;
      var L = e.Math.atan;
      var O = e.Math.atan2;
      var F = e.Math.exp;
      var j = e.Math.log;
      var G = e.Math.ceil;
      var V = e.Math.imul;
      var U = e.Math.min;
      var H = e.Math.max;
      var z = e.Math.clz32;
      var K = t.abort;
      var q = t.assert;
      var Y = t.enlargeMemory;
      var Z = t.getTotalMemory;
      var J = t.abortOnCannotGrowMemory;
      var X = t.invoke_iiii;
      var $ = t.invoke_viiiii;
      var Q = t.invoke_i;
      var ee = t.invoke_vi;
      var te = t.invoke_vii;
      var ae = t.invoke_ii;
      var re = t.invoke_viii;
      var ne = t.invoke_v;
      var se = t.invoke_iii;
      var oe = t.invoke_iiiiii;
      var ie = t.invoke_viiii;
      var ce = t._pthread_cond_wait;
      var ue = t._llvm_bswap_i64;
      var de = t.__Unwind_FindEnclosingFunction;
      var fe = t._emscripten_get_callstack_js;
      var le = t._pthread_key_create;
      var he = t.___setErrNo;
      var pe = t.___gxx_personality_v0;
      var be = t._pthread_rwlock_unlock;
      var me = t.___cxa_find_matching_catch_2;
      var ye = t.__ZSt18uncaught_exceptionv;
      var ve = t.___buildEnvironment;
      var _e = t._pthread_cond_init;
      var ge = t.__Unwind_GetIPInfo;
      var Ae = t._pthread_mutexattr_destroy;
      var we = t.__emscripten_traverse_stack;
      var Te = t._emscripten_set_main_loop_timing;
      var xe = t.___cxa_free_exception;
      var De = t._pthread_key_delete;
      var Ce = t.___cxa_allocate_exception;
      var Se = t._pthread_rwlock_rdlock;
      var Ee = t.___resumeException;
      var Be = t.___cxa_find_matching_catch;
      var ke = t._pthread_condattr_setclock;
      var Re = t._pthread_getspecific;
      var We = t.___cxa_find_matching_catch_3;
      var Ie = t._emscripten_memcpy_big;
      var Ne = t._pthread_cond_signal;
      var Me = t._pthread_mutex_destroy;
      var Pe = t._abort;
      var Le = t._pthread_condattr_init;
      var Oe = t._pthread_mutexattr_settype;
      var Fe = t._getenv;
      var je = t._pthread_condattr_destroy;
      var Ge = t.___syscall54;
      var Ve = t.___unlock;
      var Ue = t.___syscall140;
      var He = t._emscripten_set_main_loop;
      var ze = t._emscripten_get_now;
      var Ke = t._pthread_mutexattr_init;
      var qe = t._pthread_setspecific;
      var Ye = t._dladdr;
      var Ze = t.___cxa_throw;
      var Je = t.___lock;
      var Xe = t.___syscall6;
      var $e = t.___syscall4;
      var Qe = t._pthread_cond_destroy;
      var et = t._llvm_trap;
      var tt = t._pthread_mutex_init;
      var at = t.__Unwind_Backtrace;
      var rt = t.___syscall146;
      var nt = t._emscripten_exit_with_live_runtime;
      var st = 0.0;

      function ot(e) {
        e = e | 0;
        var t = 0;
        t = p;
        p = p + e | 0;
        p = p + 15 & -16;
        return t | 0;
      }

      function it() {
        return p | 0;
      }

      function ct(e) {
        e = e | 0;
        p = e;
      }

      function ut(e, t) {
        e = e | 0;
        t = t | 0;
        p = e;
        b = t;
      }

      function dt(e, t) {
        e = e | 0;
        t = t | 0;

        if (!m) {
          m = e;
          y = t;
        }
      }

      function ft(e) {
        e = e | 0;
        S = e;
      }

      function lt() {
        return S | 0;
      }

      function ht(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0;
        c = p;
        p = p + 16 | 0;
        o = c;
        i = e + 4 | 0;
        n = s[i >> 2] | 0;
        r = n * 288 | 0;

        if (n | 0) {
          t = n * 576 | 0;
          if ((t | 0) < 0) Kc(1928);
          t = Ht(s[e >> 2] | 0, r, 8, t, 8, o) | 0;

          if (!t) {
            a = o + 4 | 0;
            u = s[a >> 2] | 0;
            a = s[a + 4 >> 2] | 0;
            s[o >> 2] = s[o >> 2];
            r = o + 4 | 0;
            s[r >> 2] = u;
            s[r + 4 >> 2] = a;
            Vt(o);
          }

          r = t;
          o = e;
          u = n << 1;
          s[o >> 2] = r;
          s[i >> 2] = u;
          p = c;
          return;
        }

        jt(o, 288, 8, 4);

        if ((s[o >> 2] | 0) == 1) {
          t = s[o + 4 >> 2] | 0;

          if (t | 0 ? (a = Gt(t, s[o + 8 >> 2] | 0, o) | 0, a | 0) : 0) {
            n = a;
            o = e;
            u = 4;
            s[o >> 2] = n;
            s[i >> 2] = u;
            p = c;
            return;
          }
        }

        s[o >> 2] = 1;
        s[o + 4 >> 2] = 5846;
        s[o + 8 >> 2] = 30;
        Vt(o);
      }

      function pt(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0;
        u = p;
        p = p + 16 | 0;
        i = u;
        c = e + 4 | 0;
        r = s[c >> 2] | 0;

        if ((r - t | 0) >>> 0 >= a >>> 0) {
          p = u;
          return;
        }

        a = t + a | 0;
        if (a >>> 0 < t >>> 0) Zc(5796, 17);
        o = r << 1;
        o = a >>> 0 >= o >>> 0 ? a : o;
        jt(i, 1, 1, o);
        if ((s[i >> 2] | 0) != 1) Kc(1904);
        a = s[i + 4 >> 2] | 0;
        t = s[i + 8 >> 2] | 0;
        if ((a | 0) < 0) Kc(1928);
        r = s[c >> 2] | 0;

        if (!r) {
          t = Gt(a, t, i) | 0;
          a = (t | 0) == 0 & 1;
          r = 0;
          n = 0;
        } else {
          t = Ht(s[e >> 2] | 0, r, 1, a, t, i) | 0;
          r = (t | 0) == 0;
          n = i + 4 | 0;
          a = r & 1;
          t = r ? s[i >> 2] | 0 : t;
          r = s[n >> 2] | 0;
          n = s[n + 4 >> 2] | 0;
        }

        if ((a | 0) == 1) {
          s[i >> 2] = t;
          a = i + 4 | 0;
          s[a >> 2] = r;
          s[a + 4 >> 2] = n;
          Vt(i);
        }

        s[e >> 2] = t;
        s[c >> 2] = o;
        p = u;
        return;
      }

      function bt(e, t, a, n) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        n = n | 0;
        var o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            y = 0,
            v = 0;
        v = p;
        p = p + 16 | 0;
        d = v;

        if (!n) {
          r[e >> 0] = 3;
          p = v;
          return;
        }

        f = t + 9 | 0;
        l = t + 4 | 0;
        h = d + 4 | 0;
        b = t + 8 | 0;

        while (1) {
          do {
            if (!(r[f >> 0] | 0)) {
              c = s[l >> 2] | 0;
              o = n >>> 0 <= c >>> 0 ? n : c;
              i = s[t >> 2] | 0;
              c = c - o | 0;
              u = i + o | 0;

              if ((o | 0) != 1) {
                id(a | 0, i | 0, o | 0) | 0;
                s[t >> 2] = u;
                s[l >> 2] = c;

                if (!o) {
                  r[f >> 0] = 1;
                  y = 9;
                  break;
                }
              } else {
                r[a >> 0] = r[i >> 0] | 0;
                s[t >> 2] = u;
                s[l >> 2] = c;
              }

              s[d >> 2] = 0;
              s[h >> 2] = o;
            } else y = 9;
          } while (0);

          if ((y | 0) == 9) {
            y = 0;
            o = a + n | 0;
            i = a;

            do {
              r[i >> 0] = r[b >> 0] | 0;
              i = i + 1 | 0;
            } while ((i | 0) != (o | 0));

            s[d >> 2] = 0;
            s[h >> 2] = n;

            if (!n) {
              y = 3;
              break;
            } else o = n;
          }

          if (n >>> 0 < o >>> 0) {
            y = 12;
            break;
          }

          n = n - o | 0;

          if (!n) {
            y = 16;
            break;
          } else a = a + o | 0;
        }

        if ((y | 0) == 3) {
          r[e >> 0] = 3;
          p = v;
          return;
        } else if ((y | 0) == 12) {
          m = 0;
          te(8, o | 0, n | 0);
          m = 0;
          v = me() | 0;
          mt(d);
          Ee(v | 0);
        } else if ((y | 0) == 16) {
          r[e >> 0] = 3;
          p = v;
          return;
        }
      }

      function mt(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            r = 0;
        if (!(s[e >> 2] | 0)) return;
        if ((o[e + 4 >> 0] | 0) < 2) return;
        a = e + 8 | 0;
        r = s[a >> 2] | 0;
        e = r + 4 | 0;
        m = 0;
        ee(s[s[e >> 2] >> 2] | 0, s[r >> 2] | 0);
        t = m;
        m = 0;

        if (t & 1) {
          t = me() | 0;
          yt(s[r >> 2] | 0, s[e >> 2] | 0);
          vt(s[a >> 2] | 0);
          Ee(t | 0);
        }

        e = s[e >> 2] | 0;
        t = s[e + 4 >> 2] | 0;
        if (t | 0) Ut(s[r >> 2] | 0, t, s[e + 8 >> 2] | 0);
        Ut(s[a >> 2] | 0, 12, 4);
        return;
      }

      function yt(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0;
        a = s[t + 4 >> 2] | 0;
        if (!a) return;
        Ut(e, a, s[t + 8 >> 2] | 0);
        return;
      }

      function vt(e) {
        e = e | 0;
        Ut(e, 12, 4);
        return;
      }

      function _t(e) {
        e = e | 0;
        return;
      }

      function gt(e) {
        e = e | 0;
        jd[s[e >> 2] & 3]();
        return Mr() | 0;
      }

      function At(e) {
        e = e | 0;
        jd[e & 3]();
        return Mr() | 0;
      }

      function wt(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            r = 0;
        if ((o[e >> 0] | 0) < 2) return;
        a = e + 4 | 0;
        r = s[a >> 2] | 0;
        e = r + 4 | 0;
        m = 0;
        ee(s[s[e >> 2] >> 2] | 0, s[r >> 2] | 0);
        t = m;
        m = 0;

        if (t & 1) {
          t = me() | 0;
          Tt(s[r >> 2] | 0, s[e >> 2] | 0);
          xt(s[a >> 2] | 0);
          Ee(t | 0);
        }

        e = s[e >> 2] | 0;
        t = s[e + 4 >> 2] | 0;
        if (t | 0) Ut(s[r >> 2] | 0, t, s[e + 8 >> 2] | 0);
        Ut(s[a >> 2] | 0, 12, 4);
        return;
      }

      function Tt(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0;
        a = s[t + 4 >> 2] | 0;
        if (!a) return;
        Ut(e, a, s[t + 8 >> 2] | 0);
        return;
      }

      function xt(e) {
        e = e | 0;
        Ut(e, 12, 4);
        return;
      }

      function Dt(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0;
        o = p;
        p = p + 48 | 0;
        n = o + 32 | 0;
        r = o + 8 | 0;
        s[o >> 2] = e;
        s[o + 4 >> 2] = t;
        s[n >> 2] = o;
        s[n + 4 >> 2] = 33;
        s[n + 8 >> 2] = a;
        s[n + 12 >> 2] = 34;
        s[r >> 2] = 1976;
        s[r + 4 >> 2] = 2;
        s[r + 8 >> 2] = 5264;
        s[r + 12 >> 2] = 2;
        s[r + 16 >> 2] = n;
        s[r + 20 >> 2] = 2;
        m = 0;
        te(9, r | 0, 1992);
        m = 0;
        t = me() | 0;
        wt(a);
        Ee(t | 0);
      }

      function Ct(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var n = 0,
            o = 0,
            i = 0,
            c = 0;
        c = p;
        p = p + 64 | 0;
        o = c + 32 | 0;
        n = c + 8 | 0;
        i = c + 48 | 0;
        s[c >> 2] = e;
        s[c + 4 >> 2] = t;
        r[i >> 0] = a & 1;
        s[o >> 2] = c;
        s[o + 4 >> 2] = 33;
        s[o + 8 >> 2] = i;
        s[o + 12 >> 2] = 35;
        s[n >> 2] = 1976;
        s[n + 4 >> 2] = 2;
        s[n + 8 >> 2] = 5264;
        s[n + 12 >> 2] = 2;
        s[n + 16 >> 2] = o;
        s[n + 20 >> 2] = 2;
        qc(n, 1992);
      }

      function St(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0;
        o = p;
        p = p + 48 | 0;
        n = o + 32 | 0;
        r = o + 8 | 0;
        s[o >> 2] = e;
        s[o + 4 >> 2] = t;
        s[n >> 2] = o;
        s[n + 4 >> 2] = 33;
        s[n + 8 >> 2] = a;
        s[n + 12 >> 2] = 36;
        s[r >> 2] = 1976;
        s[r + 4 >> 2] = 2;
        s[r + 8 >> 2] = 5264;
        s[r + 12 >> 2] = 2;
        s[r + 16 >> 2] = n;
        s[r + 20 >> 2] = 2;
        qc(r, 1992);
      }

      function Et(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0;
        o = p;
        p = p + 48 | 0;
        n = o + 32 | 0;
        r = o + 8 | 0;
        s[o >> 2] = e;
        s[o + 4 >> 2] = t;
        s[n >> 2] = o;
        s[n + 4 >> 2] = 33;
        s[n + 8 >> 2] = a;
        s[n + 12 >> 2] = 37;
        s[r >> 2] = 1976;
        s[r + 4 >> 2] = 2;
        s[r + 8 >> 2] = 5264;
        s[r + 12 >> 2] = 2;
        s[r + 16 >> 2] = n;
        s[r + 20 >> 2] = 2;
        qc(r, 1992);
      }

      function Bt(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0,
            A = 0,
            w = 0,
            T = 0,
            x = 0,
            D = 0,
            C = 0,
            S = 0;
        S = p;
        p = p + 848 | 0;
        C = S;
        u = S + 680 | 0;
        g = S + 640 | 0;
        d = S + 632 | 0;
        f = S + 816 | 0;
        x = S + 740 | 0;
        w = S + 600 | 0;
        A = S + 568 | 0;
        T = S + 504 | 0;
        l = S + 472 | 0;
        h = S + 376 | 0;
        b = S + 280 | 0;
        y = S + 208 | 0;
        t = S + 752 | 0;
        v = S + 712 | 0;
        i = S + 104 | 0;
        _ = S + 8 | 0;
        c = S + 700 | 0;
        D = S + 688 | 0;
        Ts(C, e);
        xs(g, s[C >> 2] | 0, s[C + 4 >> 2] | 0);

        if ((s[g >> 2] | 0) == 1) {
          n = g + 4 | 0;
          o = s[n + 4 >> 2] | 0;
          C = u;
          s[C >> 2] = s[n >> 2];
          s[C + 4 >> 2] = o;
          Et(5909, 43, u);
        }

        or(g, s[g + 4 >> 2] | 0, s[g + 8 >> 2] | 0);

        if ((s[g >> 2] | 0) == 1) {
          n = g + 4 | 0;
          o = s[n + 4 >> 2] | 0;
          C = u;
          s[C >> 2] = s[n >> 2];
          s[C + 4 >> 2] = o;
          St(5909, 43, u);
        }

        e = g + 4 | 0;
        s[D >> 2] = s[e >> 2];
        s[D + 4 >> 2] = s[e + 4 >> 2];
        s[D + 8 >> 2] = s[e + 8 >> 2];
        e = s[D >> 2] | 0;
        a = s[D + 8 >> 2] | 0;
        C = e;
        m = 0;
        n = ae(9, 0) | 0;
        o = m;
        m = 0;

        e: do {
          if (!(o & 1) ? (s[c >> 2] = e, s[c + 4 >> 2] = a, r[c + 8 >> 0] = n, r[c + 9 >> 0] = 0, m = 0, te(10, i | 0, c | 0), o = m, m = 0, !(o & 1)) : 0) {
            do {
              if ((s[i >> 2] | 0) != 1) {
                o = _;
                a = i + 8 | 0;
                n = o + 96 | 0;

                do {
                  s[o >> 2] = s[a >> 2];
                  o = o + 4 | 0;
                  a = a + 4 | 0;
                } while ((o | 0) < (n | 0));

                o = f;
                n = o + 32 | 0;

                do {
                  r[o >> 0] = 0;
                  o = o + 1 | 0;
                } while ((o | 0) < (n | 0));

                m = 0;
                ie(3, d | 0, c | 0, f | 0, 32);
                c = m;
                m = 0;
                if (c & 1) break e;

                if ((r[d >> 0] | 0) != 3) {
                  x = d;
                  C = s[x + 4 >> 2] | 0;
                  S = u;
                  s[S >> 2] = s[x >> 2];
                  s[S + 4 >> 2] = C;
                  m = 0;
                  re(2, 5952, 50, u | 0);
                  m = 0;
                  break e;
                }

                m = 0;
                re(3, g | 0, f | 0, 32);
                f = m;
                m = 0;
                if (f & 1) break e;
                if ((r[g >> 0] | 0) == 1) break;
                e = s[g + 8 >> 2] | 0;
                o = g + 12 | 0;
                s[v >> 2] = s[o >> 2];
                s[v + 4 >> 2] = s[o + 4 >> 2];
                s[v + 8 >> 2] = s[o + 8 >> 2];
                s[v + 12 >> 2] = s[o + 12 >> 2];
                s[v + 16 >> 2] = s[o + 16 >> 2];
                s[v + 20 >> 2] = s[o + 20 >> 2];
                s[v + 24 >> 2] = s[o + 24 >> 2];
                o = t;
                n = o + 64 | 0;

                do {
                  r[o >> 0] = 0;
                  o = o + 1 | 0;
                } while ((o | 0) < (n | 0));

                o = h;
                a = _;
                n = o + 96 | 0;

                do {
                  s[o >> 2] = s[a >> 2];
                  o = o + 4 | 0;
                  a = a + 4 | 0;
                } while ((o | 0) < (n | 0));

                s[l >> 2] = e;
                g = l + 4 | 0;
                s[g >> 2] = s[v >> 2];
                s[g + 4 >> 2] = s[v + 4 >> 2];
                s[g + 8 >> 2] = s[v + 8 >> 2];
                s[g + 12 >> 2] = s[v + 12 >> 2];
                s[g + 16 >> 2] = s[v + 16 >> 2];
                s[g + 20 >> 2] = s[v + 20 >> 2];
                s[g + 24 >> 2] = s[v + 24 >> 2];
                m = 0;
                re(4, b | 0, h | 0, l | 0);
                g = m;
                m = 0;
                if (g & 1) break e;
                m = 0;
                te(11, y | 0, b | 0);
                g = m;
                m = 0;
                if (g & 1) break e;
                g = y;

                do {
                  if ((s[g >> 2] | 0) == 1 & (s[g + 4 >> 2] | 0) == 0) {
                    o = T;
                    a = y + 8 | 0;
                    n = o + 64 | 0;

                    do {
                      s[o >> 2] = s[a >> 2];
                      o = o + 4 | 0;
                      a = a + 4 | 0;
                    } while ((o | 0) < (n | 0));

                    m = 0;
                    te(12, A | 0, T | 0);
                    g = m;
                    m = 0;
                    if (g & 1) break e;
                    m = 0;
                    e = X(9, A | 0, t | 0, 32) | 0;
                    A = m;
                    m = 0;
                    if (A & 1) break e;

                    if (e << 24 >> 24 != 2) {
                      m = 0;
                      re(6, 6002, 41, (e & 1) != 0 | 0);
                      m = 0;
                      break e;
                    }

                    m = 0;
                    te(13, w | 0, T | 0);
                    T = m;
                    m = 0;
                    if (T & 1) break e;
                    m = 0;
                    e = X(9, w | 0, t + 32 | 0, 32) | 0;
                    T = m;
                    m = 0;
                    if (T & 1) break e;
                    if (e << 24 >> 24 == 2) break;else {
                      m = 0;
                      re(6, 6043, 42, (e & 1) != 0 | 0);
                      m = 0;
                      break e;
                    }
                  }
                } while (0);

                m = 0;
                re(5, x | 0, t | 0, 64);
                T = m;
                m = 0;
                if (T & 1) break e;
                t = x + 8 | 0;
                m = 0;
                re(7, x | 0, s[t >> 2] | 0, 1);
                T = m;
                m = 0;

                if (T & 1) {
                  S = me() | 0;
                  Wt(x);
                  kt(D);
                  Ee(S | 0);
                }

                e = s[t >> 2] | 0;
                s[t >> 2] = e + 1;
                r[(s[x >> 2] | 0) + e >> 0] = 0;
                e = s[x >> 2] | 0;
                t = s[x + 4 >> 2] | 0;
                if (t | 0) Ut(e, t, 1);
                t = s[D + 4 >> 2] | 0;
                if (t | 0) Ut(C, t, 1);
                C = e;
                p = S;
                return C | 0;
              }
            } while (0);

            t = s[D + 4 >> 2] | 0;
            if (t | 0) Ut(C, t, 1);
            C = 16464;
            p = S;
            return C | 0;
          }
        } while (0);

        S = me() | 0;
        kt(D);
        Ee(S | 0);
        return 0;
      }

      function kt(e) {
        e = e | 0;
        var t = 0;
        t = s[e + 4 >> 2] | 0;
        if (!t) return;
        Ut(s[e >> 2] | 0, t, 1);
        return;
      }

      function Rt(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0;
        m = p;
        p = p + 480 | 0;
        d = m + 264 | 0;
        n = m + 232 | 0;
        u = m + 160 | 0;
        f = m + 388 | 0;
        l = m + 328 | 0;
        h = m + 64 | 0;
        o = m + 32 | 0;
        i = m;
        a = m + 448 | 0;
        b = a;
        y = b + 32 | 0;

        do {
          r[b >> 0] = 0;
          b = b + 1 | 0;
        } while ((b | 0) < (y | 0));

        bt(n, t, a, 32);

        if ((r[n >> 0] | 0) != 3) {
          v = n;
          b = s[v + 4 >> 2] | 0;
          y = d;
          s[y >> 2] = s[v >> 2];
          s[y + 4 >> 2] = b;
          Dt(5952, 50, d);
        }

        Yt(d, a, 32);

        if ((r[d >> 0] | 0) == 1) {
          s[e >> 2] = 1;
          s[e + 4 >> 2] = 6085;
          s[e + 8 >> 2] = 26;
        } else {
          v = s[d + 8 >> 2] | 0;
          y = d + 12 | 0;
          s[n >> 2] = s[y >> 2];
          s[n + 4 >> 2] = s[y + 4 >> 2];
          s[n + 8 >> 2] = s[y + 8 >> 2];
          s[n + 12 >> 2] = s[y + 12 >> 2];
          s[n + 16 >> 2] = s[y + 16 >> 2];
          s[n + 20 >> 2] = s[y + 20 >> 2];
          s[n + 24 >> 2] = s[y + 24 >> 2];
          s[u >> 2] = s[n >> 2];
          s[u + 4 >> 2] = s[n + 4 >> 2];
          s[u + 8 >> 2] = s[n + 8 >> 2];
          s[u + 12 >> 2] = s[n + 12 >> 2];
          s[u + 16 >> 2] = s[n + 16 >> 2];
          s[u + 20 >> 2] = s[n + 20 >> 2];
          s[u + 24 >> 2] = s[n + 24 >> 2];
          s[i >> 2] = v;
          v = i + 4 | 0;
          s[v >> 2] = s[u >> 2];
          s[v + 4 >> 2] = s[u + 4 >> 2];
          s[v + 8 >> 2] = s[u + 8 >> 2];
          s[v + 12 >> 2] = s[u + 12 >> 2];
          s[v + 16 >> 2] = s[u + 16 >> 2];
          s[v + 20 >> 2] = s[u + 20 >> 2];
          s[v + 24 >> 2] = s[u + 24 >> 2];
          bt(n, t, a, 32);

          if ((r[n >> 0] | 0) != 3) {
            b = n;
            y = s[b + 4 >> 2] | 0;
            v = d;
            s[v >> 2] = s[b >> 2];
            s[v + 4 >> 2] = y;
            Dt(5952, 50, d);
          }

          Yt(d, a, 32);

          e: do {
            if ((r[d >> 0] | 0) == 1) {
              s[e >> 2] = 1;
              s[e + 4 >> 2] = 6111;
              s[e + 8 >> 2] = 26;
            } else {
              v = s[d + 8 >> 2] | 0;
              y = d + 12 | 0;
              s[n >> 2] = s[y >> 2];
              s[n + 4 >> 2] = s[y + 4 >> 2];
              s[n + 8 >> 2] = s[y + 8 >> 2];
              s[n + 12 >> 2] = s[y + 12 >> 2];
              s[n + 16 >> 2] = s[y + 16 >> 2];
              s[n + 20 >> 2] = s[y + 20 >> 2];
              s[n + 24 >> 2] = s[y + 24 >> 2];
              s[u >> 2] = s[n >> 2];
              s[u + 4 >> 2] = s[n + 4 >> 2];
              s[u + 8 >> 2] = s[n + 8 >> 2];
              s[u + 12 >> 2] = s[n + 12 >> 2];
              s[u + 16 >> 2] = s[n + 16 >> 2];
              s[u + 20 >> 2] = s[n + 20 >> 2];
              s[u + 24 >> 2] = s[n + 24 >> 2];
              s[o >> 2] = v;
              v = o + 4 | 0;
              s[v >> 2] = s[u >> 2];
              s[v + 4 >> 2] = s[u + 4 >> 2];
              s[v + 8 >> 2] = s[u + 8 >> 2];
              s[v + 12 >> 2] = s[u + 12 >> 2];
              s[v + 16 >> 2] = s[u + 16 >> 2];
              s[v + 20 >> 2] = s[u + 20 >> 2];
              s[v + 24 >> 2] = s[u + 24 >> 2];
              Kt(n);
              if ((Vu(i, n, 32) | 0) == 0 ? (Kt(d), (Vu(o, d, 32) | 0) == 0) : 0) Xt(h);else c = 13;

              do {
                if ((c | 0) == 13) {
                  s[n >> 2] = s[i >> 2];
                  s[n + 4 >> 2] = s[i + 4 >> 2];
                  s[n + 8 >> 2] = s[i + 8 >> 2];
                  s[n + 12 >> 2] = s[i + 12 >> 2];
                  s[n + 16 >> 2] = s[i + 16 >> 2];
                  s[n + 20 >> 2] = s[i + 20 >> 2];
                  s[n + 24 >> 2] = s[i + 24 >> 2];
                  s[n + 28 >> 2] = s[i + 28 >> 2];
                  s[d >> 2] = s[o >> 2];
                  s[d + 4 >> 2] = s[o + 4 >> 2];
                  s[d + 8 >> 2] = s[o + 8 >> 2];
                  s[d + 12 >> 2] = s[o + 12 >> 2];
                  s[d + 16 >> 2] = s[o + 16 >> 2];
                  s[d + 20 >> 2] = s[o + 20 >> 2];
                  s[d + 24 >> 2] = s[o + 24 >> 2];
                  s[d + 28 >> 2] = s[o + 28 >> 2];
                  ea(u, n, d);

                  if ((r[u >> 0] | 0) == 1) {
                    s[e >> 2] = 1;
                    s[e + 4 >> 2] = 6137;
                    s[e + 8 >> 2] = 19;
                    break e;
                  } else {
                    a = s[u + 8 >> 2] | 0;
                    b = f;
                    t = u + 12 | 0;
                    y = b + 60 | 0;

                    do {
                      s[b >> 2] = s[t >> 2];
                      b = b + 4 | 0;
                      t = t + 4 | 0;
                    } while ((b | 0) < (y | 0));

                    b = l;
                    t = f;
                    y = b + 60 | 0;

                    do {
                      s[b >> 2] = s[t >> 2];
                      b = b + 4 | 0;
                      t = t + 4 | 0;
                    } while ((b | 0) < (y | 0));

                    s[d >> 2] = a;
                    b = d + 4 | 0;
                    t = l;
                    y = b + 60 | 0;

                    do {
                      s[b >> 2] = s[t >> 2];
                      b = b + 4 | 0;
                      t = t + 4 | 0;
                    } while ((b | 0) < (y | 0));

                    na(h, d);
                    break;
                  }
                }
              } while (0);

              s[e >> 2] = 0;
              b = e + 8 | 0;
              t = h;
              y = b + 96 | 0;

              do {
                s[b >> 2] = s[t >> 2];
                b = b + 4 | 0;
                t = t + 4 | 0;
              } while ((b | 0) < (y | 0));

              p = m;
              return;
            }
          } while (0);
        }

        p = m;
        return;
      }

      function Wt(e) {
        e = e | 0;
        var t = 0;
        t = s[e + 4 >> 2] | 0;
        if (!t) return;
        Ut(s[e >> 2] | 0, t, 1);
        return;
      }

      function It(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0,
            A = 0,
            w = 0,
            T = 0,
            x = 0,
            D = 0,
            C = 0,
            S = 0,
            E = 0,
            B = 0;
        B = p;
        p = p + 1072 | 0;
        E = B;
        u = B + 808 | 0;
        C = B + 864 | 0;
        x = B + 776 | 0;
        g = B + 744 | 0;
        D = B + 680 | 0;
        A = B + 584 | 0;
        w = B + 488 | 0;
        T = B + 392 | 0;
        v = B + 320 | 0;
        t = B + 1008 | 0;
        b = B + 216 | 0;
        d = B + 112 | 0;
        _ = B + 16 | 0;
        y = B + 852 | 0;
        f = B + 840 | 0;
        i = B + 8 | 0;
        l = B + 880 | 0;
        c = B + 828 | 0;
        S = B + 816 | 0;
        Ts(E, e);
        xs(C, s[E >> 2] | 0, s[E + 4 >> 2] | 0);

        if ((s[C >> 2] | 0) == 1) {
          n = C + 4 | 0;
          o = s[n + 4 >> 2] | 0;
          E = u;
          s[E >> 2] = s[n >> 2];
          s[E + 4 >> 2] = o;
          Et(5909, 43, u);
        }

        or(C, s[C + 4 >> 2] | 0, s[C + 8 >> 2] | 0);

        if ((s[C >> 2] | 0) == 1) {
          n = C + 4 | 0;
          o = s[n + 4 >> 2] | 0;
          E = u;
          s[E >> 2] = s[n >> 2];
          s[E + 4 >> 2] = o;
          St(5909, 43, u);
        }

        e = C + 4 | 0;
        s[S >> 2] = s[e >> 2];
        s[S + 4 >> 2] = s[e + 4 >> 2];
        s[S + 8 >> 2] = s[e + 8 >> 2];
        e = s[S >> 2] | 0;
        a = s[S + 8 >> 2] | 0;
        E = e;
        m = 0;
        n = ae(9, 0) | 0;
        o = m;
        m = 0;

        e: do {
          if (!(o & 1)) {
            s[c >> 2] = e;
            s[c + 4 >> 2] = a;
            r[c + 8 >> 0] = n;
            r[c + 9 >> 0] = 0;
            n = l;
            o = n + 128 | 0;

            do {
              r[n >> 0] = 0;
              n = n + 1 | 0;
            } while ((n | 0) < (o | 0));

            m = 0;
            ie(3, i | 0, c | 0, l | 0, 128);
            c = m;
            m = 0;

            if (!(c & 1)) {
              if ((r[i >> 0] | 0) != 3) {
                C = i;
                E = s[C + 4 >> 2] | 0;
                B = u;
                s[B >> 2] = s[C >> 2];
                s[B + 4 >> 2] = E;
                m = 0;
                re(2, 5952, 50, u | 0);
                m = 0;
                break;
              }

              e = l + 64 | 0;
              m = 0;
              a = ae(9, 0) | 0;
              u = m;
              m = 0;

              if ((!(u & 1) ? (s[f >> 2] = l, s[f + 4 >> 2] = 64, r[f + 8 >> 0] = a, r[f + 9 >> 0] = 0, m = 0, h = ae(9, 0) | 0, l = m, m = 0, !(l & 1)) : 0) ? (s[y >> 2] = e, s[y + 4 >> 2] = 64, r[y + 8 >> 0] = h, r[y + 9 >> 0] = 0, m = 0, te(10, d | 0, f | 0), h = m, m = 0, !(h & 1)) : 0) {
                if ((s[d >> 2] | 0) == 1) {
                  t = s[S + 4 >> 2] | 0;
                  if (t | 0) Ut(E, t, 1);
                  E = 16464;
                  p = B;
                  return E | 0;
                }

                n = _;
                a = d + 8 | 0;
                o = n + 96 | 0;

                do {
                  s[n >> 2] = s[a >> 2];
                  n = n + 4 | 0;
                  a = a + 4 | 0;
                } while ((n | 0) < (o | 0));

                m = 0;
                te(10, b | 0, y | 0);
                y = m;
                m = 0;

                if (!(y & 1)) {
                  if ((s[b >> 2] | 0) == 1) e = 16464;else {
                    e = b + 8 | 0;
                    n = t;
                    o = n + 64 | 0;

                    do {
                      r[n >> 0] = 0;
                      n = n + 1 | 0;
                    } while ((n | 0) < (o | 0));

                    n = w;
                    a = _;
                    o = n + 96 | 0;

                    do {
                      s[n >> 2] = s[a >> 2];
                      n = n + 4 | 0;
                      a = a + 4 | 0;
                    } while ((n | 0) < (o | 0));

                    n = A;
                    a = e;
                    o = n + 96 | 0;

                    do {
                      s[n >> 2] = s[a >> 2];
                      n = n + 4 | 0;
                      a = a + 4 | 0;
                    } while ((n | 0) < (o | 0));

                    m = 0;
                    re(8, T | 0, w | 0, A | 0);
                    w = m;
                    m = 0;
                    if (w & 1) break;
                    m = 0;
                    te(11, v | 0, T | 0);
                    T = m;
                    m = 0;
                    if (T & 1) break;
                    T = v;

                    do {
                      if ((s[T >> 2] | 0) == 1 & (s[T + 4 >> 2] | 0) == 0) {
                        n = D;
                        a = v + 8 | 0;
                        o = n + 64 | 0;

                        do {
                          s[n >> 2] = s[a >> 2];
                          n = n + 4 | 0;
                          a = a + 4 | 0;
                        } while ((n | 0) < (o | 0));

                        m = 0;
                        te(12, g | 0, D | 0);
                        T = m;
                        m = 0;
                        if (T & 1) break e;
                        m = 0;
                        e = X(9, g | 0, t | 0, 32) | 0;
                        T = m;
                        m = 0;
                        if (T & 1) break e;

                        if (e << 24 >> 24 != 2) {
                          m = 0;
                          re(6, 6002, 41, (e & 1) != 0 | 0);
                          m = 0;
                          break e;
                        }

                        m = 0;
                        te(13, x | 0, D | 0);
                        D = m;
                        m = 0;
                        if (D & 1) break e;
                        m = 0;
                        e = X(9, x | 0, t + 32 | 0, 32) | 0;
                        D = m;
                        m = 0;
                        if (D & 1) break e;
                        if (e << 24 >> 24 == 2) break;else {
                          m = 0;
                          re(6, 6043, 42, (e & 1) != 0 | 0);
                          m = 0;
                          break e;
                        }
                      }
                    } while (0);

                    m = 0;
                    re(5, C | 0, t | 0, 64);
                    D = m;
                    m = 0;
                    if (D & 1) break;
                    t = C + 8 | 0;
                    m = 0;
                    re(7, C | 0, s[t >> 2] | 0, 1);
                    D = m;
                    m = 0;

                    if (D & 1) {
                      B = me() | 0;
                      Wt(C);
                      kt(S);
                      Ee(B | 0);
                    }

                    e = s[t >> 2] | 0;
                    s[t >> 2] = e + 1;
                    r[(s[C >> 2] | 0) + e >> 0] = 0;
                    e = s[C >> 2] | 0;
                    t = s[C + 4 >> 2] | 0;
                    if (t | 0) Ut(e, t, 1);
                  }
                  t = s[S + 4 >> 2] | 0;
                  if (t | 0) Ut(E, t, 1);
                  E = e;
                  p = B;
                  return E | 0;
                }
              }
            }
          }
        } while (0);

        B = me() | 0;
        kt(S);
        Ee(B | 0);
        return 0;
      }

      function Nt(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0,
            A = 0,
            w = 0,
            T = 0,
            x = 0,
            D = 0,
            C = 0,
            S = 0,
            E = 0,
            B = 0,
            k = 0,
            R = 0,
            W = 0,
            I = 0,
            N = 0,
            M = 0,
            P = 0,
            L = 0,
            O = 0,
            F = 0,
            j = 0,
            G = 0,
            V = 0,
            U = 0,
            H = 0,
            z = 0,
            K = 0,
            q = 0,
            Y = 0,
            Z = 0,
            J = 0,
            X = 0,
            $ = 0,
            Q = 0,
            ne = 0,
            se = 0,
            oe = 0,
            ce = 0,
            ue = 0,
            de = 0,
            fe = 0,
            le = 0,
            he = 0,
            pe = 0,
            be = 0,
            ye = 0,
            ve = 0,
            _e = 0,
            ge = 0,
            Ae = 0,
            we = 0,
            Te = 0,
            xe = 0,
            De = 0,
            Ce = 0,
            Se = 0,
            Be = 0,
            ke = 0,
            Re = 0,
            We = 0,
            Ie = 0;
        We = p;
        p = p + 6960 | 0;
        D = We;
        _e = We + 6664 | 0;
        ge = We + 6568 | 0;
        Ae = We + 6184 | 0;
        we = We + 5800 | 0;
        xe = We + 5128 | 0;
        De = We + 4456 | 0;
        Ce = We + 4072 | 0;
        Se = We + 3688 | 0;
        Re = We + 6896 | 0;
        pe = We + 6908 | 0;
        be = We + 6920 | 0;
        ye = We + 3304 | 0;
        he = We + 2920 | 0;
        ke = We + 6880 | 0;
        ve = We + 2536 | 0;
        C = We + 2248 | 0;
        S = We + 2120 | 0;
        E = We + 1928 | 0;
        B = We + 1864 | 0;
        k = We + 1800 | 0;
        R = We + 1664 | 0;
        W = We + 1472 | 0;
        I = We + 1280 | 0;
        N = We + 1248 | 0;
        M = We + 1216 | 0;
        P = We + 1152 | 0;
        L = We + 1120 | 0;
        O = We + 1088 | 0;
        F = We + 1024 | 0;
        j = We + 960 | 0;
        G = We + 864 | 0;
        V = We + 832 | 0;
        U = We + 800 | 0;
        H = We + 728 | 0;
        z = We + 632 | 0;
        K = We + 600 | 0;
        q = We + 568 | 0;
        Y = We + 472 | 0;
        Z = We + 432 | 0;
        J = We + 400 | 0;
        X = We + 360 | 0;
        $ = We + 328 | 0;
        Q = We + 288 | 0;
        ne = We + 256 | 0;
        se = We + 216 | 0;
        oe = We + 184 | 0;
        ce = We + 144 | 0;
        ue = We + 112 | 0;
        de = We + 72 | 0;
        fe = We + 40 | 0;
        le = We + 6868 | 0;
        Te = We + 8 | 0;
        Ie = We + 6856 | 0;
        Ts(D, e);
        xs(ge, s[D >> 2] | 0, s[D + 4 >> 2] | 0);

        if ((s[ge >> 2] | 0) == 1) {
          T = ge + 4 | 0;
          x = s[T + 4 >> 2] | 0;
          D = _e;
          s[D >> 2] = s[T >> 2];
          s[D + 4 >> 2] = x;
          Et(5909, 43, _e);
        }

        or(ge, s[ge + 4 >> 2] | 0, s[ge + 8 >> 2] | 0);

        if ((s[ge >> 2] | 0) == 1) {
          T = ge + 4 | 0;
          x = s[T + 4 >> 2] | 0;
          D = _e;
          s[D >> 2] = s[T >> 2];
          s[D + 4 >> 2] = x;
          St(5909, 43, _e);
        }

        x = ge + 4 | 0;
        s[Ie >> 2] = s[x >> 2];
        s[Ie + 4 >> 2] = s[x + 4 >> 2];
        s[Ie + 8 >> 2] = s[x + 8 >> 2];
        x = s[Ie + 8 >> 2] | 0;
        D = (x >>> 0) / 192 | 0;

        e: do {
          if (!((x >>> 0) % 192 | 0)) {
            if (x) {
              s[le >> 2] = 8;
              o = le + 4 | 0;
              s[o >> 2] = 0;
              i = le + 8 | 0;
              s[i >> 2] = 0;

              t: do {
                if (x >>> 0 > 191) {
                  c = de + 8 | 0;
                  u = ce + 8 | 0;
                  h = se + 8 | 0;
                  b = Q + 8 | 0;
                  y = X + 8 | 0;
                  v = Z + 8 | 0;
                  _ = C + 96 | 0;
                  g = R + 8 | 0;
                  A = H + 8 | 0;
                  w = s[Ie >> 2] | 0;
                  T = 0;

                  a: while (1) {
                    n = T * 192 | 0;
                    T = T + 1 | 0;
                    e = n | 32;

                    if (x >>> 0 < e >>> 0) {
                      Be = 16;
                      break;
                    }

                    m = 0;
                    re(9, de | 0, w + n | 0, e - n | 0);
                    l = m;
                    m = 0;

                    if (l & 1) {
                      Be = 125;
                      break;
                    }

                    if ((r[de >> 0] | 0) == 1) {
                      Be = 23;
                      break;
                    }

                    s[fe >> 2] = s[c >> 2];
                    s[fe + 4 >> 2] = s[c + 4 >> 2];
                    s[fe + 8 >> 2] = s[c + 8 >> 2];
                    s[fe + 12 >> 2] = s[c + 12 >> 2];
                    s[fe + 16 >> 2] = s[c + 16 >> 2];
                    s[fe + 20 >> 2] = s[c + 20 >> 2];
                    s[fe + 24 >> 2] = s[c + 24 >> 2];
                    s[fe + 28 >> 2] = s[c + 28 >> 2];
                    t = n + 64 | 0;

                    if (t >>> 0 < e >>> 0) {
                      Be = 20;
                      break;
                    }

                    if (x >>> 0 < t >>> 0) {
                      Be = 22;
                      break;
                    }

                    m = 0;
                    re(9, ce | 0, w + e | 0, t - e | 0);
                    l = m;
                    m = 0;

                    if (l & 1) {
                      Be = 125;
                      break;
                    }

                    if ((r[ce >> 0] | 0) == 1) {
                      Be = 31;
                      break;
                    }

                    s[ue >> 2] = s[u >> 2];
                    s[ue + 4 >> 2] = s[u + 4 >> 2];
                    s[ue + 8 >> 2] = s[u + 8 >> 2];
                    s[ue + 12 >> 2] = s[u + 12 >> 2];
                    s[ue + 16 >> 2] = s[u + 16 >> 2];
                    s[ue + 20 >> 2] = s[u + 20 >> 2];
                    s[ue + 24 >> 2] = s[u + 24 >> 2];
                    s[ue + 28 >> 2] = s[u + 28 >> 2];
                    e = n + 96 | 0;

                    if (x >>> 0 < e >>> 0) {
                      Be = 30;
                      break;
                    }

                    m = 0;
                    re(9, se | 0, w + t | 0, 32);
                    l = m;
                    m = 0;

                    if (l & 1) {
                      Be = 125;
                      break;
                    }

                    if ((r[se >> 0] | 0) == 1) {
                      Be = 37;
                      break;
                    }

                    s[oe >> 2] = s[h >> 2];
                    s[oe + 4 >> 2] = s[h + 4 >> 2];
                    s[oe + 8 >> 2] = s[h + 8 >> 2];
                    s[oe + 12 >> 2] = s[h + 12 >> 2];
                    s[oe + 16 >> 2] = s[h + 16 >> 2];
                    s[oe + 20 >> 2] = s[h + 20 >> 2];
                    s[oe + 24 >> 2] = s[h + 24 >> 2];
                    s[oe + 28 >> 2] = s[h + 28 >> 2];
                    t = n + 128 | 0;

                    if (x >>> 0 < t >>> 0) {
                      Be = 36;
                      break;
                    }

                    m = 0;
                    re(9, Q | 0, w + e | 0, 32);
                    l = m;
                    m = 0;

                    if (l & 1) {
                      Be = 125;
                      break;
                    }

                    if ((r[Q >> 0] | 0) == 1) {
                      Be = 43;
                      break;
                    }

                    s[ne >> 2] = s[b >> 2];
                    s[ne + 4 >> 2] = s[b + 4 >> 2];
                    s[ne + 8 >> 2] = s[b + 8 >> 2];
                    s[ne + 12 >> 2] = s[b + 12 >> 2];
                    s[ne + 16 >> 2] = s[b + 16 >> 2];
                    s[ne + 20 >> 2] = s[b + 20 >> 2];
                    s[ne + 24 >> 2] = s[b + 24 >> 2];
                    s[ne + 28 >> 2] = s[b + 28 >> 2];
                    a = n + 160 | 0;

                    if (x >>> 0 < a >>> 0) {
                      Be = 42;
                      break;
                    }

                    m = 0;
                    re(9, X | 0, w + t | 0, 32);
                    l = m;
                    m = 0;

                    if (l & 1) {
                      Be = 125;
                      break;
                    }

                    if ((r[X >> 0] | 0) == 1) {
                      Be = 49;
                      break;
                    }

                    s[$ >> 2] = s[y >> 2];
                    s[$ + 4 >> 2] = s[y + 4 >> 2];
                    s[$ + 8 >> 2] = s[y + 8 >> 2];
                    s[$ + 12 >> 2] = s[y + 12 >> 2];
                    s[$ + 16 >> 2] = s[y + 16 >> 2];
                    s[$ + 20 >> 2] = s[y + 20 >> 2];
                    s[$ + 24 >> 2] = s[y + 24 >> 2];
                    s[$ + 28 >> 2] = s[y + 28 >> 2];
                    e = n + 192 | 0;

                    if (x >>> 0 < e >>> 0) {
                      Be = 48;
                      break;
                    }

                    m = 0;
                    re(9, Z | 0, w + a | 0, 32);
                    l = m;
                    m = 0;

                    if (l & 1) {
                      Be = 125;
                      break;
                    }

                    if ((r[Z >> 0] | 0) == 1) {
                      Be = 54;
                      break;
                    }

                    s[J >> 2] = s[v >> 2];
                    s[J + 4 >> 2] = s[v + 4 >> 2];
                    s[J + 8 >> 2] = s[v + 8 >> 2];
                    s[J + 12 >> 2] = s[v + 12 >> 2];
                    s[J + 16 >> 2] = s[v + 16 >> 2];
                    s[J + 20 >> 2] = s[v + 20 >> 2];
                    s[J + 24 >> 2] = s[v + 24 >> 2];
                    s[J + 28 >> 2] = s[v + 28 >> 2];
                    m = 0;
                    ee(36, q | 0);
                    l = m;
                    m = 0;

                    if (l & 1) {
                      Be = 125;
                      break;
                    }

                    do {
                      if (!(Vu(fe, q, 32) | 0)) {
                        m = 0;
                        ee(36, K | 0);
                        l = m;
                        m = 0;

                        if (l & 1) {
                          Be = 125;
                          break a;
                        }

                        if (Vu(ue, K, 32) | 0) {
                          Be = 56;
                          break;
                        }

                        m = 0;
                        ee(37, z | 0);
                        l = m;
                        m = 0;

                        if (l & 1) {
                          Be = 125;
                          break a;
                        }

                        d = Y;
                        f = z;
                        l = d + 96 | 0;

                        do {
                          s[d >> 2] = s[f >> 2];
                          d = d + 4 | 0;
                          f = f + 4 | 0;
                        } while ((d | 0) < (l | 0));
                      } else Be = 56;
                    } while (0);

                    if ((Be | 0) == 56) {
                      Be = 0;
                      s[U >> 2] = s[fe >> 2];
                      s[U + 4 >> 2] = s[fe + 4 >> 2];
                      s[U + 8 >> 2] = s[fe + 8 >> 2];
                      s[U + 12 >> 2] = s[fe + 12 >> 2];
                      s[U + 16 >> 2] = s[fe + 16 >> 2];
                      s[U + 20 >> 2] = s[fe + 20 >> 2];
                      s[U + 24 >> 2] = s[fe + 24 >> 2];
                      s[U + 28 >> 2] = s[fe + 28 >> 2];
                      s[V >> 2] = s[ue >> 2];
                      s[V + 4 >> 2] = s[ue + 4 >> 2];
                      s[V + 8 >> 2] = s[ue + 8 >> 2];
                      s[V + 12 >> 2] = s[ue + 12 >> 2];
                      s[V + 16 >> 2] = s[ue + 16 >> 2];
                      s[V + 20 >> 2] = s[ue + 20 >> 2];
                      s[V + 24 >> 2] = s[ue + 24 >> 2];
                      s[V + 28 >> 2] = s[ue + 28 >> 2];
                      m = 0;
                      re(10, H | 0, U | 0, V | 0);
                      l = m;
                      m = 0;

                      if (l & 1) {
                        Be = 125;
                        break;
                      }

                      if ((r[H >> 0] | 0) == 1) {
                        Be = 65;
                        break;
                      }

                      d = j;
                      f = A;
                      l = d + 64 | 0;

                      do {
                        s[d >> 2] = s[f >> 2];
                        d = d + 4 | 0;
                        f = f + 4 | 0;
                      } while ((d | 0) < (l | 0));

                      m = 0;
                      te(15, G | 0, j | 0);
                      l = m;
                      m = 0;

                      if (l & 1) {
                        Be = 125;
                        break;
                      }

                      d = Y;
                      f = G;
                      l = d + 96 | 0;

                      do {
                        s[d >> 2] = s[f >> 2];
                        d = d + 4 | 0;
                        f = f + 4 | 0;
                      } while ((d | 0) < (l | 0));
                    }

                    s[O >> 2] = s[ne >> 2];
                    s[O + 4 >> 2] = s[ne + 4 >> 2];
                    s[O + 8 >> 2] = s[ne + 8 >> 2];
                    s[O + 12 >> 2] = s[ne + 12 >> 2];
                    s[O + 16 >> 2] = s[ne + 16 >> 2];
                    s[O + 20 >> 2] = s[ne + 20 >> 2];
                    s[O + 24 >> 2] = s[ne + 24 >> 2];
                    s[O + 28 >> 2] = s[ne + 28 >> 2];
                    s[L >> 2] = s[oe >> 2];
                    s[L + 4 >> 2] = s[oe + 4 >> 2];
                    s[L + 8 >> 2] = s[oe + 8 >> 2];
                    s[L + 12 >> 2] = s[oe + 12 >> 2];
                    s[L + 16 >> 2] = s[oe + 16 >> 2];
                    s[L + 20 >> 2] = s[oe + 20 >> 2];
                    s[L + 24 >> 2] = s[oe + 24 >> 2];
                    s[L + 28 >> 2] = s[oe + 28 >> 2];
                    m = 0;
                    re(11, F | 0, O | 0, L | 0);
                    l = m;
                    m = 0;

                    if (l & 1) {
                      Be = 125;
                      break;
                    }

                    s[M >> 2] = s[J >> 2];
                    s[M + 4 >> 2] = s[J + 4 >> 2];
                    s[M + 8 >> 2] = s[J + 8 >> 2];
                    s[M + 12 >> 2] = s[J + 12 >> 2];
                    s[M + 16 >> 2] = s[J + 16 >> 2];
                    s[M + 20 >> 2] = s[J + 20 >> 2];
                    s[M + 24 >> 2] = s[J + 24 >> 2];
                    s[M + 28 >> 2] = s[J + 28 >> 2];
                    s[N >> 2] = s[$ >> 2];
                    s[N + 4 >> 2] = s[$ + 4 >> 2];
                    s[N + 8 >> 2] = s[$ + 8 >> 2];
                    s[N + 12 >> 2] = s[$ + 12 >> 2];
                    s[N + 16 >> 2] = s[$ + 16 >> 2];
                    s[N + 20 >> 2] = s[$ + 20 >> 2];
                    s[N + 24 >> 2] = s[$ + 24 >> 2];
                    s[N + 28 >> 2] = s[$ + 28 >> 2];
                    m = 0;
                    re(11, P | 0, M | 0, N | 0);
                    l = m;
                    m = 0;

                    if (l & 1) {
                      Be = 125;
                      break;
                    }

                    m = 0;
                    e = ae(10, ne | 0) | 0;
                    l = m;
                    m = 0;

                    if (l & 1) {
                      Be = 125;
                      break;
                    }

                    do {
                      if (e) {
                        m = 0;
                        e = ae(10, oe | 0) | 0;
                        l = m;
                        m = 0;

                        if (l & 1) {
                          Be = 125;
                          break a;
                        }

                        if (!e) {
                          Be = 70;
                          break;
                        }

                        m = 0;
                        e = ae(10, J | 0) | 0;
                        l = m;
                        m = 0;

                        if (l & 1) {
                          Be = 125;
                          break a;
                        }

                        if (!e) {
                          Be = 70;
                          break;
                        }

                        m = 0;
                        e = ae(10, $ | 0) | 0;
                        l = m;
                        m = 0;

                        if (l & 1) {
                          Be = 125;
                          break a;
                        }

                        if (!e) {
                          Be = 70;
                          break;
                        }

                        m = 0;
                        ee(38, W | 0);
                        l = m;
                        m = 0;

                        if (l & 1) {
                          Be = 125;
                          break a;
                        }

                        id(I | 0, W | 0, 192) | 0;
                      } else Be = 70;
                    } while (0);

                    if ((Be | 0) == 70) {
                      Be = 0;
                      d = k;
                      f = F;
                      l = d + 64 | 0;

                      do {
                        s[d >> 2] = s[f >> 2];
                        d = d + 4 | 0;
                        f = f + 4 | 0;
                      } while ((d | 0) < (l | 0));

                      d = B;
                      f = P;
                      l = d + 64 | 0;

                      do {
                        s[d >> 2] = s[f >> 2];
                        d = d + 4 | 0;
                        f = f + 4 | 0;
                      } while ((d | 0) < (l | 0));

                      m = 0;
                      re(12, R | 0, k | 0, B | 0);
                      l = m;
                      m = 0;

                      if (l & 1) {
                        Be = 125;
                        break;
                      }

                      if ((r[R >> 0] | 0) == 1) {
                        Be = 83;
                        break;
                      }

                      d = S;
                      f = g;
                      l = d + 128 | 0;

                      do {
                        s[d >> 2] = s[f >> 2];
                        d = d + 4 | 0;
                        f = f + 4 | 0;
                      } while ((d | 0) < (l | 0));

                      m = 0;
                      te(16, E | 0, S | 0);
                      l = m;
                      m = 0;

                      if (l & 1) {
                        Be = 125;
                        break;
                      }

                      id(I | 0, E | 0, 192) | 0;
                    }

                    d = C;
                    f = Y;
                    l = d + 96 | 0;

                    do {
                      s[d >> 2] = s[f >> 2];
                      d = d + 4 | 0;
                      f = f + 4 | 0;
                    } while ((d | 0) < (l | 0));

                    id(_ | 0, I | 0, 192) | 0;
                    e = s[i >> 2] | 0;

                    if ((e | 0) == (s[o >> 2] | 0)) {
                      m = 0;
                      ee(39, le | 0);
                      l = m;
                      m = 0;

                      if (l & 1) {
                        Be = 125;
                        break;
                      }

                      e = s[i >> 2] | 0;
                    }

                    id((s[le >> 2] | 0) + (e * 288 | 0) | 0, C | 0, 288) | 0;
                    s[i >> 2] = e + 1;
                    if (T >>> 0 >= D >>> 0) break t;
                  }

                  switch (Be | 0) {
                    case 16:
                      {
                        m = 0;
                        te(14, e | 0, x | 0);
                        m = 0;
                        Be = 125;
                        break;
                      }

                    case 20:
                      {
                        m = 0;
                        te(8, e | 0, t | 0);
                        m = 0;
                        Be = 125;
                        break;
                      }

                    case 22:
                      {
                        m = 0;
                        te(14, t | 0, x | 0);
                        m = 0;
                        Be = 125;
                        break;
                      }

                    case 23:
                      break;

                    case 30:
                      {
                        m = 0;
                        te(14, e | 0, x | 0);
                        m = 0;
                        Be = 125;
                        break;
                      }

                    case 31:
                      {
                        Be = 32;
                        break;
                      }

                    case 36:
                      {
                        m = 0;
                        te(14, t | 0, x | 0);
                        m = 0;
                        Be = 125;
                        break;
                      }

                    case 37:
                      {
                        Be = 38;
                        break;
                      }

                    case 42:
                      {
                        m = 0;
                        te(14, a | 0, x | 0);
                        m = 0;
                        Be = 125;
                        break;
                      }

                    case 43:
                      {
                        Be = 44;
                        break;
                      }

                    case 48:
                      {
                        m = 0;
                        te(14, e | 0, x | 0);
                        m = 0;
                        Be = 125;
                        break;
                      }

                    case 49:
                      {
                        Be = 50;
                        break;
                      }

                    case 54:
                      {
                        Be = 55;
                        break;
                      }

                    case 65:
                      {
                        Be = 66;
                        break;
                      }

                    case 83:
                      {
                        Be = 66;
                        break;
                      }
                  }

                  if ((Be | 0) == 66) Be = 55;else if ((Be | 0) == 125) {
                    We = me() | 0;
                    Pt(le);
                    kt(Ie);
                    Ee(We | 0);
                  }
                  if ((Be | 0) == 55) Be = 50;
                  if ((Be | 0) == 50) Be = 44;
                  if ((Be | 0) == 44) Be = 38;
                  if ((Be | 0) == 38) Be = 32;
                  e = s[o >> 2] | 0;
                  if (e | 0) Ut(s[le >> 2] | 0, e * 288 | 0, 8);
                  break e;
                }
              } while (0);

              s[_e >> 2] = s[le >> 2];
              s[_e + 4 >> 2] = s[le + 4 >> 2];
              s[_e + 8 >> 2] = s[le + 8 >> 2];
              o = s[_e >> 2] | 0;
              e = s[_e + 8 >> 2] | 0;
              i = o + (e * 288 | 0) | 0;
              c = s[_e + 4 >> 2] | 0;
              s[ke >> 2] = o;
              s[ke + 4 >> 2] = c;
              u = ke + 8 | 0;
              s[u >> 2] = o;
              s[ke + 12 >> 2] = i;
              m = 0;
              ee(40, he | 0);
              le = m;
              m = 0;

              if (le & 1) {
                We = me() | 0;
                Mt(ke);
                kt(Ie);
                Ee(We | 0);
              }

              id(Se | 0, he | 0, 384) | 0;

              do {
                if (e) {
                  e = De + 384 | 0;
                  t = xe + 384 | 0;
                  a = xe + 480 | 0;
                  n = o;

                  while (1) {
                    d = n;
                    n = n + 288 | 0;
                    id(De | 0, Se | 0, 384) | 0;
                    id(e | 0, d | 0, 288) | 0;
                    id(xe | 0, Se | 0, 384) | 0;
                    id(t | 0, d | 0, 288) | 0;
                    id(we | 0, De | 0, 384) | 0;
                    d = ge;
                    f = e;
                    l = d + 96 | 0;

                    do {
                      s[d >> 2] = s[f >> 2];
                      d = d + 4 | 0;
                      f = f + 4 | 0;
                    } while ((d | 0) < (l | 0));

                    id(_e | 0, a | 0, 192) | 0;
                    m = 0;
                    re(13, Ae | 0, ge | 0, _e | 0);
                    he = m;
                    m = 0;
                    if (he & 1) break;
                    m = 0;
                    re(14, Ce | 0, we | 0, Ae | 0);
                    he = m;
                    m = 0;
                    if (he & 1) break;
                    id(Se | 0, Ce | 0, 384) | 0;

                    if ((n | 0) == (i | 0)) {
                      Be = 94;
                      break;
                    }
                  }

                  if ((Be | 0) == 94) {
                    s[u >> 2] = i;
                    id(ve | 0, Se | 0, 384) | 0;
                    break;
                  }

                  e = me() | 0;
                  s[u >> 2] = n;
                  m = 0;
                  ee(41, ke | 0);
                  We = m;
                  m = 0;

                  if (We & 1) {
                    We = me() | 0;
                    kt(Ie);
                    Ee(We | 0);
                  } else {
                    We = e;
                    kt(Ie);
                    Ee(We | 0);
                  }
                } else id(ve | 0, Se | 0, 384) | 0;
              } while (0);

              if (c | 0) Ut(o, c * 288 | 0, 8);
              m = 0;
              ee(40, ye | 0);
              ke = m;
              m = 0;

              if (ke & 1) {
                We = me() | 0;
                kt(Ie);
                Ee(We | 0);
              }

              do {
                if ((((((((Vu(ve, ye, 32) | 0) == 0 ? (Vu(ve + 32 | 0, ye + 32 | 0, 32) | 0) == 0 : 0) ? (Vu(ve + 64 | 0, ye + 64 | 0, 32) | 0) == 0 : 0) ? (Vu(ve + 96 | 0, ye + 96 | 0, 32) | 0) == 0 : 0) ? (Vu(ve + 128 | 0, ye + 128 | 0, 32) | 0) == 0 : 0) ? (Vu(ve + 160 | 0, ye + 160 | 0, 32) | 0) == 0 : 0) ? (Vu(ve + 192 | 0, ye + 192 | 0, 32) | 0) == 0 : 0) ? (Vu(ve + 224 | 0, ye + 224 | 0, 32) | 0) == 0 : 0) {
                  if (Vu(ve + 256 | 0, ye + 256 | 0, 32) | 0) {
                    Be = 113;
                    break;
                  }

                  if (Vu(ve + 288 | 0, ye + 288 | 0, 32) | 0) {
                    Be = 113;
                    break;
                  }

                  if (Vu(ve + 320 | 0, ye + 320 | 0, 32) | 0) {
                    Be = 113;
                    break;
                  }

                  if (Vu(ve + 352 | 0, ye + 352 | 0, 32) | 0) {
                    Be = 115;
                    break;
                  }

                  ke = Te;
                  s[ke >> 2] = 1;
                  s[ke + 4 >> 2] = 0;
                  ke = Te + 8 | 0;
                  s[ke >> 2] = 0;
                  s[ke + 4 >> 2] = 0;
                  s[ke + 8 >> 2] = 0;
                  s[ke + 12 >> 2] = 0;
                  s[ke + 16 >> 2] = 0;
                  s[ke + 20 >> 2] = 0;
                } else Be = 113;
              } while (0);

              if ((Be | 0) == 113) Be = 115;

              if ((Be | 0) == 115) {
                s[Te >> 2] = 0;
                s[Te + 4 >> 2] = 0;
                s[Te + 8 >> 2] = 0;
                s[Te + 12 >> 2] = 0;
                s[Te + 16 >> 2] = 0;
                s[Te + 20 >> 2] = 0;
                s[Te + 24 >> 2] = 0;
                s[Te + 28 >> 2] = 0;
              }
            } else {
              ke = Te;
              s[ke >> 2] = 1;
              s[ke + 4 >> 2] = 0;
              ke = Te + 8 | 0;
              s[ke >> 2] = 0;
              s[ke + 4 >> 2] = 0;
              s[ke + 8 >> 2] = 0;
              s[ke + 12 >> 2] = 0;
              s[ke + 16 >> 2] = 0;
              s[ke + 20 >> 2] = 0;
            }

            d = be;
            l = d + 32 | 0;

            do {
              r[d >> 0] = 0;
              d = d + 1 | 0;
            } while ((d | 0) < (l | 0));

            m = 0;
            ie(4, pe | 0, Te | 0, be | 0, 32);
            ke = m;
            m = 0;

            if (!(ke & 1) ? (m = 0, re(5, Re | 0, be | 0, 32), ke = m, m = 0, !(ke & 1)) : 0) {
              e = Re + 8 | 0;
              m = 0;
              re(7, Re | 0, s[e >> 2] | 0, 1);
              ke = m;
              m = 0;

              if (ke & 1) {
                We = me() | 0;
                Wt(Re);
                kt(Ie);
                Ee(We | 0);
              }

              t = s[e >> 2] | 0;
              s[e >> 2] = t + 1;
              r[(s[Re >> 2] | 0) + t >> 0] = 0;
              t = s[Re >> 2] | 0;
              e = s[Re + 4 >> 2] | 0;
              if (e | 0) Ut(t, e, 1);
              e = s[Ie + 4 >> 2] | 0;
              if (e | 0) Ut(s[Ie >> 2] | 0, e, 1);
              Ie = t;
              p = We;
              return Ie | 0;
            }

            We = me() | 0;
            kt(Ie);
            Ee(We | 0);
          }
        } while (0);

        e = s[Ie + 4 >> 2] | 0;
        if (e | 0) Ut(s[Ie >> 2] | 0, e, 1);
        Ie = 16464;
        p = We;
        return Ie | 0;
      }

      function Mt(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            r = 0;
        t = e + 8 | 0;
        a = s[t >> 2] | 0;
        r = s[e + 12 >> 2] | 0;
        if ((a | 0) != (r | 0)) s[t >> 2] = a + (((((r + -288 - a | 0) >>> 0) / 288 | 0) + 1 | 0) * 288 | 0);
        t = s[e + 4 >> 2] | 0;
        if (!t) return;
        Ut(s[e >> 2] | 0, t * 288 | 0, 8);
        return;
      }

      function Pt(e) {
        e = e | 0;
        var t = 0;
        t = s[e + 4 >> 2] | 0;
        if (!t) return;
        Ut(s[e >> 2] | 0, t * 288 | 0, 8);
        return;
      }

      function Lt(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0;
        a = p;
        p = p + 16 | 0;
        r = a;
        s[r >> 2] = 1;
        t = Wr(r, 1952, e, t) | 0;
        p = a;
        return t | 0;
      }

      function Ot() {
        nt();
        return;
      }

      function Ft(e, t) {
        e = e | 0;
        t = t | 0;
        return vc(s[e >> 2] | 0, s[e + 4 >> 2] | 0, t) | 0;
      }

      function jt(e, t, a, r) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        r = r | 0;
        var n = 0,
            o = 0,
            i = 0;
        o = 0 - a | 0;
        n = t + ((t + -1 + a & o) - t) | 0;

        if (n >>> 0 < t >>> 0) {
          s[e >> 2] = 0;
          return;
        }

        t = V(n, r) | 0;
        i = (r | 0) == 0;

        if (i ? 0 : ((t >>> 0) / ((i ? 1 : r) >>> 0) | 0 | 0) != (n | 0)) {
          s[e >> 2] = 0;
          return;
        }

        if ((a + -1 & (a | -2147483648) | 0) != 0 | t >>> 0 > o >>> 0) Kc(2008);
        s[e >> 2] = 1;
        s[e + 4 >> 2] = t;
        s[e + 8 >> 2] = a;
        s[e + 12 >> 2] = n;
        return;
      }

      function Gt(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        return Ro(e, t, a) | 0;
      }

      function Vt(e) {
        e = e | 0;
        Wo(e);
      }

      function Ut(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        Io(e, t, a);
        return;
      }

      function Ht(e, t, a, r, n, s) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        r = r | 0;
        n = n | 0;
        s = s | 0;
        return No(e, t, a, r, n, s) | 0;
      }

      function zt(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0;
        d = p;
        p = p + 112 | 0;
        i = d + 32 | 0;
        u = d;

        if ((a | 0) == 32) {
          f = t;
          a = f;
          f = f + 4 | 0;
          f = ue(o[a >> 0] | o[a + 1 >> 0] << 8 | o[a + 2 >> 0] << 16 | o[a + 3 >> 0] << 24 | 0, o[f >> 0] | o[f + 1 >> 0] << 8 | o[f + 2 >> 0] << 16 | o[f + 3 >> 0] << 24 | 0) | 0;
          a = S;
          h = t + 8 | 0;
          l = h;
          h = h + 4 | 0;
          h = ue(o[l >> 0] | o[l + 1 >> 0] << 8 | o[l + 2 >> 0] << 16 | o[l + 3 >> 0] << 24 | 0, o[h >> 0] | o[h + 1 >> 0] << 8 | o[h + 2 >> 0] << 16 | o[h + 3 >> 0] << 24 | 0) | 0;
          l = S;
          m = t + 16 | 0;
          b = m;
          m = m + 4 | 0;
          m = ue(o[b >> 0] | o[b + 1 >> 0] << 8 | o[b + 2 >> 0] << 16 | o[b + 3 >> 0] << 24 | 0, o[m >> 0] | o[m + 1 >> 0] << 8 | o[m + 2 >> 0] << 16 | o[m + 3 >> 0] << 24 | 0) | 0;
          b = S;
          c = t + 24 | 0;
          t = c;
          c = c + 4 | 0;
          c = ue(o[t >> 0] | o[t + 1 >> 0] << 8 | o[t + 2 >> 0] << 16 | o[t + 3 >> 0] << 24 | 0, o[c >> 0] | o[c + 1 >> 0] << 8 | o[c + 2 >> 0] << 16 | o[c + 3 >> 0] << 24 | 0) | 0;
          s[i >> 2] = c;
          s[i + 4 >> 2] = S;
          c = i + 8 | 0;
          s[c >> 2] = m;
          s[c + 4 >> 2] = b;
          c = i + 16 | 0;
          s[c >> 2] = h;
          s[c + 4 >> 2] = l;
          c = i + 24 | 0;
          s[c >> 2] = f;
          s[c + 4 >> 2] = a;
          ka(i, 40, 8, -268435457, -1025378925);
          s[u >> 2] = s[i >> 2];
          s[u + 4 >> 2] = s[i + 4 >> 2];
          s[u + 8 >> 2] = s[i + 8 >> 2];
          s[u + 12 >> 2] = s[i + 12 >> 2];
          s[u + 16 >> 2] = s[i + 16 >> 2];
          s[u + 20 >> 2] = s[i + 20 >> 2];
          s[u + 24 >> 2] = s[i + 24 >> 2];
          s[u + 28 >> 2] = s[i + 28 >> 2];
          i = d + 64 + 6 | 0;
          c = i;
          t = u;
          a = c + 32 | 0;

          do {
            n[c >> 1] = n[t >> 1] | 0;
            c = c + 2 | 0;
            t = t + 2 | 0;
          } while ((c | 0) < (a | 0));

          c = e + 8 | 0;
          t = i;
          a = c + 32 | 0;

          do {
            n[c >> 1] = n[t >> 1] | 0;
            c = c + 2 | 0;
            t = t + 2 | 0;
          } while ((c | 0) < (a | 0));

          m = 0;
          r[e >> 0] = m;
          p = d;
          return;
        } else {
          r[e + 1 >> 0] = 0;
          m = 1;
          r[e >> 0] = m;
          p = d;
          return;
        }
      }

      function Kt(e) {
        e = e | 0;
        s[e >> 2] = 0;
        s[e + 4 >> 2] = 0;
        s[e + 8 >> 2] = 0;
        s[e + 12 >> 2] = 0;
        s[e + 16 >> 2] = 0;
        s[e + 20 >> 2] = 0;
        s[e + 24 >> 2] = 0;
        s[e + 28 >> 2] = 0;
        return;
      }

      function qt(e) {
        e = e | 0;
        var t = 0;
        t = e;

        if ((((s[t >> 2] | 0) == 0 & (s[t + 4 >> 2] | 0) == 0 ? (t = e + 8 | 0, (s[t >> 2] | 0) == 0 & (s[t + 4 >> 2] | 0) == 0) : 0) ? (t = e + 16 | 0, (s[t >> 2] | 0) == 0 & (s[t + 4 >> 2] | 0) == 0) : 0) ? (t = e + 24 | 0, (s[t >> 2] | 0) == 0 & (s[t + 4 >> 2] | 0) == 0) : 0) {
          t = 1;
          return t | 0;
        }

        t = 0;
        return t | 0;
      }

      function Yt(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0;
        d = p;
        p = p + 112 | 0;
        c = d + 32 | 0;
        i = d;
        u = d + 64 | 0;

        do {
          if ((a | 0) == 32) {
            l = t;
            f = l;
            l = l + 4 | 0;
            l = ue(o[f >> 0] | o[f + 1 >> 0] << 8 | o[f + 2 >> 0] << 16 | o[f + 3 >> 0] << 24 | 0, o[l >> 0] | o[l + 1 >> 0] << 8 | o[l + 2 >> 0] << 16 | o[l + 3 >> 0] << 24 | 0) | 0;
            f = S;
            b = t + 8 | 0;
            h = b;
            b = b + 4 | 0;
            b = ue(o[h >> 0] | o[h + 1 >> 0] << 8 | o[h + 2 >> 0] << 16 | o[h + 3 >> 0] << 24 | 0, o[b >> 0] | o[b + 1 >> 0] << 8 | o[b + 2 >> 0] << 16 | o[b + 3 >> 0] << 24 | 0) | 0;
            h = S;
            y = t + 16 | 0;
            m = y;
            y = y + 4 | 0;
            y = ue(o[m >> 0] | o[m + 1 >> 0] << 8 | o[m + 2 >> 0] << 16 | o[m + 3 >> 0] << 24 | 0, o[y >> 0] | o[y + 1 >> 0] << 8 | o[y + 2 >> 0] << 16 | o[y + 3 >> 0] << 24 | 0) | 0;
            m = S;
            a = t + 24 | 0;
            t = a;
            a = a + 4 | 0;
            a = ue(o[t >> 0] | o[t + 1 >> 0] << 8 | o[t + 2 >> 0] << 16 | o[t + 3 >> 0] << 24 | 0, o[a >> 0] | o[a + 1 >> 0] << 8 | o[a + 2 >> 0] << 16 | o[a + 3 >> 0] << 24 | 0) | 0;
            s[c >> 2] = a;
            s[c + 4 >> 2] = S;
            a = c + 8 | 0;
            s[a >> 2] = y;
            s[a + 4 >> 2] = m;
            a = c + 16 | 0;
            s[a >> 2] = b;
            s[a + 4 >> 2] = h;
            a = c + 24 | 0;
            s[a >> 2] = l;
            s[a + 4 >> 2] = f;

            if (!(Na(c, 136) | 0)) {
              i = 1;
              break;
            }

            ka(c, 72, 136, -460954743, -2016278654);
            s[i >> 2] = s[c >> 2];
            s[i + 4 >> 2] = s[c + 4 >> 2];
            s[i + 8 >> 2] = s[c + 8 >> 2];
            s[i + 12 >> 2] = s[c + 12 >> 2];
            s[i + 16 >> 2] = s[c + 16 >> 2];
            s[i + 20 >> 2] = s[c + 20 >> 2];
            s[i + 24 >> 2] = s[c + 24 >> 2];
            s[i + 28 >> 2] = s[c + 28 >> 2];
            a = u + 6 | 0;
            c = a;
            t = c + 32 | 0;

            do {
              n[c >> 1] = n[i >> 1] | 0;
              c = c + 2 | 0;
              i = i + 2 | 0;
            } while ((c | 0) < (t | 0));

            c = e + 8 | 0;
            i = a;
            t = c + 32 | 0;

            do {
              n[c >> 1] = n[i >> 1] | 0;
              c = c + 2 | 0;
              i = i + 2 | 0;
            } while ((c | 0) < (t | 0));

            y = 0;
            r[e >> 0] = y;
            p = d;
            return;
          } else i = 0;
        } while (0);

        r[e + 1 >> 0] = i;
        y = 1;
        r[e >> 0] = y;
        p = d;
        return;
      }

      function Zt(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var n = 0,
            o = 0,
            i = 0,
            c = 0;
        o = p;
        p = p + 96 | 0;
        i = o + 64 | 0;
        c = o + 32 | 0;
        n = o;
        s[c >> 2] = s[e >> 2];
        s[c + 4 >> 2] = s[e + 4 >> 2];
        s[c + 8 >> 2] = s[e + 8 >> 2];
        s[c + 12 >> 2] = s[e + 12 >> 2];
        s[c + 16 >> 2] = s[e + 16 >> 2];
        s[c + 20 >> 2] = s[e + 20 >> 2];
        s[c + 24 >> 2] = s[e + 24 >> 2];
        s[c + 28 >> 2] = s[e + 28 >> 2];
        e = i;
        s[e >> 2] = 1;
        s[e + 4 >> 2] = 0;
        e = i + 8 | 0;
        s[e >> 2] = 0;
        s[e + 4 >> 2] = 0;
        s[e + 8 >> 2] = 0;
        s[e + 12 >> 2] = 0;
        s[e + 16 >> 2] = 0;
        s[e + 20 >> 2] = 0;
        ka(c, i, 136, -460954743, -2016278654);
        s[n >> 2] = s[c >> 2];
        s[n + 4 >> 2] = s[c + 4 >> 2];
        s[n + 8 >> 2] = s[c + 8 >> 2];
        s[n + 12 >> 2] = s[c + 12 >> 2];
        s[n + 16 >> 2] = s[c + 16 >> 2];
        s[n + 20 >> 2] = s[c + 20 >> 2];
        s[n + 24 >> 2] = s[c + 24 >> 2];
        s[n + 28 >> 2] = s[c + 28 >> 2];
        e = c;
        s[e >> 2] = -980480611;
        s[e + 4 >> 2] = -748862579;
        e = c + 8 | 0;
        s[e >> 2] = -171504835;
        s[e + 4 >> 2] = 175696680;
        e = c + 16 | 0;
        s[e >> 2] = 2021213740;
        s[e + 4 >> 2] = 1718526831;
        e = c + 24 | 0;
        s[e >> 2] = -1710760145;
        s[e + 4 >> 2] = 235567041;
        e = i;
        s[e >> 2] = -662897337;
        s[e + 4 >> 2] = 1008765974;
        e = i + 8 | 0;
        s[e >> 2] = 1752287885;
        s[e + 4 >> 2] = -1753126255;
        e = i + 16 | 0;
        s[e >> 2] = -2122229667;
        s[e + 4 >> 2] = -1202698826;
        e = i + 24 | 0;
        s[e >> 2] = -516841431;
        s[e + 4 >> 2] = 811880050;
        ka(n, c, i, -460954743, -2016278654);

        if ((a | 0) != 32) {
          c = 0;
          p = o;
          return c | 0;
        }

        a = n + 24 | 0;
        a = ue(s[a >> 2] | 0, s[a + 4 >> 2] | 0) | 0;
        i = S;
        c = t;
        e = c;
        r[e >> 0] = a;
        r[e + 1 >> 0] = a >> 8;
        r[e + 2 >> 0] = a >> 16;
        r[e + 3 >> 0] = a >> 24;
        c = c + 4 | 0;
        r[c >> 0] = i;
        r[c + 1 >> 0] = i >> 8;
        r[c + 2 >> 0] = i >> 16;
        r[c + 3 >> 0] = i >> 24;
        c = n + 16 | 0;
        c = ue(s[c >> 2] | 0, s[c + 4 >> 2] | 0) | 0;
        i = S;
        e = t + 8 | 0;
        a = e;
        r[a >> 0] = c;
        r[a + 1 >> 0] = c >> 8;
        r[a + 2 >> 0] = c >> 16;
        r[a + 3 >> 0] = c >> 24;
        e = e + 4 | 0;
        r[e >> 0] = i;
        r[e + 1 >> 0] = i >> 8;
        r[e + 2 >> 0] = i >> 16;
        r[e + 3 >> 0] = i >> 24;
        e = n + 8 | 0;
        e = ue(s[e >> 2] | 0, s[e + 4 >> 2] | 0) | 0;
        i = S;
        a = t + 16 | 0;
        c = a;
        r[c >> 0] = e;
        r[c + 1 >> 0] = e >> 8;
        r[c + 2 >> 0] = e >> 16;
        r[c + 3 >> 0] = e >> 24;
        a = a + 4 | 0;
        r[a >> 0] = i;
        r[a + 1 >> 0] = i >> 8;
        r[a + 2 >> 0] = i >> 16;
        r[a + 3 >> 0] = i >> 24;
        a = n;
        a = ue(s[a >> 2] | 0, s[a + 4 >> 2] | 0) | 0;
        i = S;
        c = t + 24 | 0;
        n = c;
        r[n >> 0] = a;
        r[n + 1 >> 0] = a >> 8;
        r[n + 2 >> 0] = a >> 16;
        r[n + 3 >> 0] = a >> 24;
        c = c + 4 | 0;
        r[c >> 0] = i;
        r[c + 1 >> 0] = i >> 8;
        r[c + 2 >> 0] = i >> 16;
        r[c + 3 >> 0] = i >> 24;
        c = 2;
        p = o;
        return c | 0;
      }

      function Jt(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0;
        r = p;
        p = p + 64 | 0;
        n = r;
        s[n >> 2] = s[t >> 2];
        s[n + 4 >> 2] = s[t + 4 >> 2];
        s[n + 8 >> 2] = s[t + 8 >> 2];
        s[n + 12 >> 2] = s[t + 12 >> 2];
        s[n + 16 >> 2] = s[t + 16 >> 2];
        s[n + 20 >> 2] = s[t + 20 >> 2];
        s[n + 24 >> 2] = s[t + 24 >> 2];
        s[n + 28 >> 2] = s[t + 28 >> 2];
        t = n + 32 | 0;
        s[t >> 2] = s[a >> 2];
        s[t + 4 >> 2] = s[a + 4 >> 2];
        s[t + 8 >> 2] = s[a + 8 >> 2];
        s[t + 12 >> 2] = s[a + 12 >> 2];
        s[t + 16 >> 2] = s[a + 16 >> 2];
        s[t + 20 >> 2] = s[a + 20 >> 2];
        s[t + 24 >> 2] = s[a + 24 >> 2];
        s[t + 28 >> 2] = s[a + 28 >> 2];
        t = n;
        a = e + 64 | 0;

        do {
          s[e >> 2] = s[t >> 2];
          e = e + 4 | 0;
          t = t + 4 | 0;
        } while ((e | 0) < (a | 0));

        p = r;
        return;
      }

      function Xt(e) {
        e = e | 0;
        var t = 0;
        s[e >> 2] = 0;
        s[e + 4 >> 2] = 0;
        s[e + 8 >> 2] = 0;
        s[e + 12 >> 2] = 0;
        s[e + 16 >> 2] = 0;
        s[e + 20 >> 2] = 0;
        s[e + 24 >> 2] = 0;
        s[e + 28 >> 2] = 0;
        t = e + 32 | 0;
        s[t >> 2] = -980480611;
        s[t + 4 >> 2] = -748862579;
        t = e + 40 | 0;
        s[t >> 2] = -171504835;
        s[t + 4 >> 2] = 175696680;
        t = e + 48 | 0;
        s[t >> 2] = 2021213740;
        s[t + 4 >> 2] = 1718526831;
        t = e + 56 | 0;
        s[t >> 2] = -1710760145;
        s[t + 4 >> 2] = 235567041;
        e = e + 64 | 0;
        s[e >> 2] = 0;
        s[e + 4 >> 2] = 0;
        s[e + 8 >> 2] = 0;
        s[e + 12 >> 2] = 0;
        s[e + 16 >> 2] = 0;
        s[e + 20 >> 2] = 0;
        s[e + 24 >> 2] = 0;
        s[e + 28 >> 2] = 0;
        return;
      }

      function $t(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0;
        u = p;
        p = p + 288 | 0;
        n = u + 192 | 0;
        o = u + 96 | 0;
        i = u;
        c = o;
        r = c + 96 | 0;

        do {
          s[c >> 2] = s[t >> 2];
          c = c + 4 | 0;
          t = t + 4 | 0;
        } while ((c | 0) < (r | 0));

        c = n;
        t = a;
        r = c + 96 | 0;

        do {
          s[c >> 2] = s[t >> 2];
          c = c + 4 | 0;
          t = t + 4 | 0;
        } while ((c | 0) < (r | 0));

        Aa(i, o, n);
        c = e;
        t = i;
        r = c + 96 | 0;

        do {
          s[c >> 2] = s[t >> 2];
          c = c + 4 | 0;
          t = t + 4 | 0;
        } while ((c | 0) < (r | 0));

        p = u;
        return;
      }

      function Qt(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0;
        u = p;
        p = p + 224 | 0;
        n = u + 192 | 0;
        o = u + 96 | 0;
        i = u;
        c = o;
        r = c + 96 | 0;

        do {
          s[c >> 2] = s[t >> 2];
          c = c + 4 | 0;
          t = t + 4 | 0;
        } while ((c | 0) < (r | 0));

        s[n >> 2] = s[a >> 2];
        s[n + 4 >> 2] = s[a + 4 >> 2];
        s[n + 8 >> 2] = s[a + 8 >> 2];
        s[n + 12 >> 2] = s[a + 12 >> 2];
        s[n + 16 >> 2] = s[a + 16 >> 2];
        s[n + 20 >> 2] = s[a + 20 >> 2];
        s[n + 24 >> 2] = s[a + 24 >> 2];
        s[n + 28 >> 2] = s[a + 28 >> 2];
        ga(i, o, n);
        c = e;
        t = i;
        r = c + 96 | 0;

        do {
          s[c >> 2] = s[t >> 2];
          c = c + 4 | 0;
          t = t + 4 | 0;
        } while ((c | 0) < (r | 0));

        p = u;
        return;
      }

      function ea(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0;
        d = p;
        p = p + 208 | 0;
        o = d + 104 | 0;
        c = d + 72 | 0;
        i = d;
        u = d + 136 | 0;
        s[c >> 2] = s[t >> 2];
        s[c + 4 >> 2] = s[t + 4 >> 2];
        s[c + 8 >> 2] = s[t + 8 >> 2];
        s[c + 12 >> 2] = s[t + 12 >> 2];
        s[c + 16 >> 2] = s[t + 16 >> 2];
        s[c + 20 >> 2] = s[t + 20 >> 2];
        s[c + 24 >> 2] = s[t + 24 >> 2];
        s[c + 28 >> 2] = s[t + 28 >> 2];
        s[o >> 2] = s[a >> 2];
        s[o + 4 >> 2] = s[a + 4 >> 2];
        s[o + 8 >> 2] = s[a + 8 >> 2];
        s[o + 12 >> 2] = s[a + 12 >> 2];
        s[o + 16 >> 2] = s[a + 16 >> 2];
        s[o + 20 >> 2] = s[a + 20 >> 2];
        s[o + 24 >> 2] = s[a + 24 >> 2];
        s[o + 28 >> 2] = s[a + 28 >> 2];
        la(i, c, o);
        t = r[i >> 0] | 0;
        a = r[i + 1 >> 0] | 0;
        o = u;
        i = i + 2 | 0;
        c = o + 70 | 0;

        do {
          n[o >> 1] = n[i >> 1] | 0;
          o = o + 2 | 0;
          i = i + 2 | 0;
        } while ((o | 0) < (c | 0));

        if (t << 24 >> 24 == 1) {
          r[e + 1 >> 0] = a << 24 >> 24 != 0 & 1;
          u = 1;
          r[e >> 0] = u;
          p = d;
          return;
        } else {
          o = e + 8 | 0;
          i = u + 6 | 0;
          c = o + 64 | 0;

          do {
            n[o >> 1] = n[i >> 1] | 0;
            o = o + 2 | 0;
            i = i + 2 | 0;
          } while ((o | 0) < (c | 0));

          u = 0;
          r[e >> 0] = u;
          p = d;
          return;
        }
      }

      function ta(e, t) {
        e = e | 0;
        t = t | 0;
        s[e >> 2] = s[t >> 2];
        s[e + 4 >> 2] = s[t + 4 >> 2];
        s[e + 8 >> 2] = s[t + 8 >> 2];
        s[e + 12 >> 2] = s[t + 12 >> 2];
        s[e + 16 >> 2] = s[t + 16 >> 2];
        s[e + 20 >> 2] = s[t + 20 >> 2];
        s[e + 24 >> 2] = s[t + 24 >> 2];
        s[e + 28 >> 2] = s[t + 28 >> 2];
        return;
      }

      function aa(e, t) {
        e = e | 0;
        t = t | 0;
        t = t + 32 | 0;
        s[e >> 2] = s[t >> 2];
        s[e + 4 >> 2] = s[t + 4 >> 2];
        s[e + 8 >> 2] = s[t + 8 >> 2];
        s[e + 12 >> 2] = s[t + 12 >> 2];
        s[e + 16 >> 2] = s[t + 16 >> 2];
        s[e + 20 >> 2] = s[t + 20 >> 2];
        s[e + 24 >> 2] = s[t + 24 >> 2];
        s[e + 28 >> 2] = s[t + 28 >> 2];
        return;
      }

      function ra(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0;
        n = p;
        p = p + 80 | 0;
        a = n;
        va(a, t);
        r = a;

        if ((s[r >> 2] | 0) == 1 & (s[r + 4 >> 2] | 0) == 0) {
          r = e + 8 | 0;
          t = a + 8 | 0;
          a = r + 64 | 0;

          do {
            s[r >> 2] = s[t >> 2];
            r = r + 4 | 0;
            t = t + 4 | 0;
          } while ((r | 0) < (a | 0));

          t = 1;
          a = 0;
        } else {
          t = 0;
          a = 0;
        }

        s[e >> 2] = t;
        s[e + 4 >> 2] = a;
        p = n;
        return;
      }

      function na(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0;
        n = p;
        p = p + 64 | 0;
        a = n;
        s[a >> 2] = s[t >> 2];
        s[a + 4 >> 2] = s[t + 4 >> 2];
        s[a + 8 >> 2] = s[t + 8 >> 2];
        s[a + 12 >> 2] = s[t + 12 >> 2];
        s[a + 16 >> 2] = s[t + 16 >> 2];
        s[a + 20 >> 2] = s[t + 20 >> 2];
        s[a + 24 >> 2] = s[t + 24 >> 2];
        s[a + 28 >> 2] = s[t + 28 >> 2];
        r = t + 32 | 0;
        t = a + 32 | 0;
        s[t >> 2] = s[r >> 2];
        s[t + 4 >> 2] = s[r + 4 >> 2];
        s[t + 8 >> 2] = s[r + 8 >> 2];
        s[t + 12 >> 2] = s[r + 12 >> 2];
        s[t + 16 >> 2] = s[r + 16 >> 2];
        s[t + 20 >> 2] = s[r + 20 >> 2];
        s[t + 24 >> 2] = s[r + 24 >> 2];
        s[t + 28 >> 2] = s[r + 28 >> 2];
        t = e;
        r = t + 64 | 0;

        do {
          s[t >> 2] = s[a >> 2];
          t = t + 4 | 0;
          a = a + 4 | 0;
        } while ((t | 0) < (r | 0));

        r = e + 64 | 0;
        s[r >> 2] = -980480611;
        s[r + 4 >> 2] = -748862579;
        r = e + 72 | 0;
        s[r >> 2] = -171504835;
        s[r + 4 >> 2] = 175696680;
        r = e + 80 | 0;
        s[r >> 2] = 2021213740;
        s[r + 4 >> 2] = 1718526831;
        e = e + 88 | 0;
        s[e >> 2] = -1710760145;
        s[e + 4 >> 2] = 235567041;
        p = n;
        return;
      }

      function sa(e) {
        e = e | 0;
        var t = 0,
            a = 0;
        t = e;
        a = t + 64 | 0;

        do {
          s[t >> 2] = 0;
          t = t + 4 | 0;
        } while ((t | 0) < (a | 0));

        t = e + 64 | 0;
        s[t >> 2] = -980480611;
        s[t + 4 >> 2] = -748862579;
        t = e + 72 | 0;
        s[t >> 2] = -171504835;
        s[t + 4 >> 2] = 175696680;
        t = e + 80 | 0;
        s[t >> 2] = 2021213740;
        s[t + 4 >> 2] = 1718526831;
        t = e + 88 | 0;
        s[t >> 2] = -1710760145;
        s[t + 4 >> 2] = 235567041;
        t = e + 96 | 0;
        a = t + 96 | 0;

        do {
          s[t >> 2] = 0;
          t = t + 4 | 0;
        } while ((t | 0) < (a | 0));

        return;
      }

      function oa(e) {
        e = e | 0;
        var t = 0;
        t = e;
        s[t >> 2] = -980480611;
        s[t + 4 >> 2] = -748862579;
        t = e + 8 | 0;
        s[t >> 2] = -171504835;
        s[t + 4 >> 2] = 175696680;
        t = e + 16 | 0;
        s[t >> 2] = 2021213740;
        s[t + 4 >> 2] = 1718526831;
        t = e + 24 | 0;
        s[t >> 2] = -1710760145;
        s[t + 4 >> 2] = 235567041;
        ed(e + 32 | 0, 0, 352) | 0;
        return;
      }

      function ia(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            s = 0,
            o = 0;
        r = p;
        p = p + 1152 | 0;
        s = r + 768 | 0;
        o = r + 384 | 0;
        n = r;
        id(o | 0, t | 0, 384) | 0;
        id(s | 0, a | 0, 384) | 0;
        La(n, o, s);
        id(e | 0, n | 0, 384) | 0;
        p = r;
        return;
      }

      function ca(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0;
        r = p;
        p = p + 384 | 0;
        n = r;
        wa(n, t, a);
        id(e | 0, n | 0, 384) | 0;
        p = r;
        return;
      }

      function ua(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0;
        l = p;
        p = p + 400 | 0;
        i = l + 200 | 0;
        c = l + 136 | 0;
        d = l;
        f = l + 264 | 0;
        u = c;
        o = u + 64 | 0;

        do {
          s[u >> 2] = s[t >> 2];
          u = u + 4 | 0;
          t = t + 4 | 0;
        } while ((u | 0) < (o | 0));

        u = i;
        t = a;
        o = u + 64 | 0;

        do {
          s[u >> 2] = s[t >> 2];
          u = u + 4 | 0;
          t = t + 4 | 0;
        } while ((u | 0) < (o | 0));

        ha(d, c, i);
        u = r[d >> 0] | 0;
        t = r[d + 1 >> 0] | 0;
        id(f | 0, d + 2 | 0, 134) | 0;

        if (u << 24 >> 24 == 1) {
          r[e + 1 >> 0] = t << 24 >> 24 != 0 & 1;
          f = 1;
          r[e >> 0] = f;
          p = l;
          return;
        } else {
          u = e + 8 | 0;
          t = f + 6 | 0;
          o = u + 128 | 0;

          do {
            n[u >> 1] = n[t >> 1] | 0;
            u = u + 2 | 0;
            t = t + 2 | 0;
          } while ((u | 0) < (o | 0));

          f = 0;
          r[e >> 0] = f;
          p = l;
          return;
        }
      }

      function da(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0;
        n = p;
        p = p + 128 | 0;
        a = n;
        r = a;
        o = t;
        i = r + 64 | 0;

        do {
          s[r >> 2] = s[o >> 2];
          r = r + 4 | 0;
          o = o + 4 | 0;
        } while ((r | 0) < (i | 0));

        r = a + 64 | 0;
        o = t + 64 | 0;
        i = r + 64 | 0;

        do {
          s[r >> 2] = s[o >> 2];
          r = r + 4 | 0;
          o = o + 4 | 0;
        } while ((r | 0) < (i | 0));

        r = e;
        o = a;
        i = r + 128 | 0;

        do {
          s[r >> 2] = s[o >> 2];
          r = r + 4 | 0;
          o = o + 4 | 0;
        } while ((r | 0) < (i | 0));

        i = e + 128 | 0;
        s[i >> 2] = -980480611;
        s[i + 4 >> 2] = -748862579;
        i = e + 136 | 0;
        s[i >> 2] = -171504835;
        s[i + 4 >> 2] = 175696680;
        i = e + 144 | 0;
        s[i >> 2] = 2021213740;
        s[i + 4 >> 2] = 1718526831;
        i = e + 152 | 0;
        s[i >> 2] = -1710760145;
        s[i + 4 >> 2] = 235567041;
        i = e + 160 | 0;
        s[i >> 2] = 0;
        s[i + 4 >> 2] = 0;
        s[i + 8 >> 2] = 0;
        s[i + 12 >> 2] = 0;
        s[i + 16 >> 2] = 0;
        s[i + 20 >> 2] = 0;
        s[i + 24 >> 2] = 0;
        s[i + 28 >> 2] = 0;
        p = n;
        return;
      }

      function fa(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            n = 0;
        n = p;
        p = p + 16 | 0;
        a = n;

        if ((r[e >> 0] | 0) == 1) {
          pc(a, t, 6248, 9);
          a = Oc(a) | 0;
          p = n;
          return a | 0;
        } else {
          pc(a, t, 6230, 18);
          a = Oc(a) | 0;
          p = n;
          return a | 0;
        }

        return 0;
      }

      function la(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0;
        i = p;
        p = p + 224 | 0;
        n = i + 160 | 0;
        f = i + 128 | 0;
        d = i + 96 | 0;
        u = i + 64 | 0;
        o = i + 32 | 0;
        c = i;
        s[f >> 2] = s[a >> 2];
        s[f + 4 >> 2] = s[a + 4 >> 2];
        s[f + 8 >> 2] = s[a + 8 >> 2];
        s[f + 12 >> 2] = s[a + 12 >> 2];
        s[f + 16 >> 2] = s[a + 16 >> 2];
        s[f + 20 >> 2] = s[a + 20 >> 2];
        s[f + 24 >> 2] = s[a + 24 >> 2];
        s[f + 28 >> 2] = s[a + 28 >> 2];
        s[n >> 2] = s[a >> 2];
        s[n + 4 >> 2] = s[a + 4 >> 2];
        s[n + 8 >> 2] = s[a + 8 >> 2];
        s[n + 12 >> 2] = s[a + 12 >> 2];
        s[n + 16 >> 2] = s[a + 16 >> 2];
        s[n + 20 >> 2] = s[a + 20 >> 2];
        s[n + 24 >> 2] = s[a + 24 >> 2];
        s[n + 28 >> 2] = s[a + 28 >> 2];
        ka(f, n, 136, -460954743, -2016278654);
        s[c >> 2] = s[f >> 2];
        s[c + 4 >> 2] = s[f + 4 >> 2];
        s[c + 8 >> 2] = s[f + 8 >> 2];
        s[c + 12 >> 2] = s[f + 12 >> 2];
        s[c + 16 >> 2] = s[f + 16 >> 2];
        s[c + 20 >> 2] = s[f + 20 >> 2];
        s[c + 24 >> 2] = s[f + 24 >> 2];
        s[c + 28 >> 2] = s[f + 28 >> 2];
        s[f >> 2] = s[t >> 2];
        s[f + 4 >> 2] = s[t + 4 >> 2];
        s[f + 8 >> 2] = s[t + 8 >> 2];
        s[f + 12 >> 2] = s[t + 12 >> 2];
        s[f + 16 >> 2] = s[t + 16 >> 2];
        s[f + 20 >> 2] = s[t + 20 >> 2];
        s[f + 24 >> 2] = s[t + 24 >> 2];
        s[f + 28 >> 2] = s[t + 28 >> 2];
        s[n >> 2] = s[t >> 2];
        s[n + 4 >> 2] = s[t + 4 >> 2];
        s[n + 8 >> 2] = s[t + 8 >> 2];
        s[n + 12 >> 2] = s[t + 12 >> 2];
        s[n + 16 >> 2] = s[t + 16 >> 2];
        s[n + 20 >> 2] = s[t + 20 >> 2];
        s[n + 24 >> 2] = s[t + 24 >> 2];
        s[n + 28 >> 2] = s[t + 28 >> 2];
        ka(f, n, 136, -460954743, -2016278654);
        s[d >> 2] = s[f >> 2];
        s[d + 4 >> 2] = s[f + 4 >> 2];
        s[d + 8 >> 2] = s[f + 8 >> 2];
        s[d + 12 >> 2] = s[f + 12 >> 2];
        s[d + 16 >> 2] = s[f + 16 >> 2];
        s[d + 20 >> 2] = s[f + 20 >> 2];
        s[d + 24 >> 2] = s[f + 24 >> 2];
        s[d + 28 >> 2] = s[f + 28 >> 2];
        s[n >> 2] = s[t >> 2];
        s[n + 4 >> 2] = s[t + 4 >> 2];
        s[n + 8 >> 2] = s[t + 8 >> 2];
        s[n + 12 >> 2] = s[t + 12 >> 2];
        s[n + 16 >> 2] = s[t + 16 >> 2];
        s[n + 20 >> 2] = s[t + 20 >> 2];
        s[n + 24 >> 2] = s[t + 24 >> 2];
        s[n + 28 >> 2] = s[t + 28 >> 2];
        ka(d, n, 136, -460954743, -2016278654);
        s[u >> 2] = s[d >> 2];
        s[u + 4 >> 2] = s[d + 4 >> 2];
        s[u + 8 >> 2] = s[d + 8 >> 2];
        s[u + 12 >> 2] = s[d + 12 >> 2];
        s[u + 16 >> 2] = s[d + 16 >> 2];
        s[u + 20 >> 2] = s[d + 20 >> 2];
        s[u + 24 >> 2] = s[d + 24 >> 2];
        s[u + 28 >> 2] = s[d + 28 >> 2];
        d = n;
        s[d >> 2] = 1353525463;
        s[d + 4 >> 2] = 2048379561;
        d = n + 8 | 0;
        s[d >> 2] = -514514503;
        s[d + 4 >> 2] = 527090042;
        d = n + 16 | 0;
        s[d >> 2] = 1768673924;
        s[d + 4 >> 2] = 860613198;
        d = n + 24 | 0;
        s[d >> 2] = -837313138;
        s[d + 4 >> 2] = 706701124;
        Ea(u, n, 136);
        s[o >> 2] = s[u >> 2];
        s[o + 4 >> 2] = s[u + 4 >> 2];
        s[o + 8 >> 2] = s[u + 8 >> 2];
        s[o + 12 >> 2] = s[u + 12 >> 2];
        s[o + 16 >> 2] = s[u + 16 >> 2];
        s[o + 20 >> 2] = s[u + 20 >> 2];
        s[o + 24 >> 2] = s[u + 24 >> 2];
        s[o + 28 >> 2] = s[u + 28 >> 2];

        if (!(Vu(c, o, 32) | 0)) {
          s[n >> 2] = s[t >> 2];
          s[n + 4 >> 2] = s[t + 4 >> 2];
          s[n + 8 >> 2] = s[t + 8 >> 2];
          s[n + 12 >> 2] = s[t + 12 >> 2];
          s[n + 16 >> 2] = s[t + 16 >> 2];
          s[n + 20 >> 2] = s[t + 20 >> 2];
          s[n + 24 >> 2] = s[t + 24 >> 2];
          s[n + 28 >> 2] = s[t + 28 >> 2];
          o = n + 32 | 0;
          s[o >> 2] = s[a >> 2];
          s[o + 4 >> 2] = s[a + 4 >> 2];
          s[o + 8 >> 2] = s[a + 8 >> 2];
          s[o + 12 >> 2] = s[a + 12 >> 2];
          s[o + 16 >> 2] = s[a + 16 >> 2];
          s[o + 20 >> 2] = s[a + 20 >> 2];
          s[o + 24 >> 2] = s[a + 24 >> 2];
          s[o + 28 >> 2] = s[a + 28 >> 2];
          o = e + 8 | 0;
          t = n;
          a = o + 64 | 0;

          do {
            s[o >> 2] = s[t >> 2];
            o = o + 4 | 0;
            t = t + 4 | 0;
          } while ((o | 0) < (a | 0));

          f = 0;
          r[e >> 0] = f;
          p = i;
          return;
        } else {
          r[e + 1 >> 0] = 0;
          f = 1;
          r[e >> 0] = f;
          p = i;
          return;
        }
      }

      function ha(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0;
        l = p;
        p = p + 960 | 0;
        n = l + 768 | 0;
        o = l + 704 | 0;
        i = l + 512 | 0;
        c = l + 320 | 0;
        u = l + 128 | 0;
        d = l;
        Za(d, a);
        Za(o, t);
        f = n;
        h = t;
        b = f + 64 | 0;

        do {
          s[f >> 2] = s[h >> 2];
          f = f + 4 | 0;
          h = h + 4 | 0;
        } while ((f | 0) < (b | 0));

        Ya(c, o, n);
        s[o >> 2] = s[c >> 2];
        s[o + 4 >> 2] = s[c + 4 >> 2];
        s[o + 8 >> 2] = s[c + 8 >> 2];
        s[o + 12 >> 2] = s[c + 12 >> 2];
        s[o + 16 >> 2] = s[c + 16 >> 2];
        s[o + 20 >> 2] = s[c + 20 >> 2];
        s[o + 24 >> 2] = s[c + 24 >> 2];
        s[o + 28 >> 2] = s[c + 28 >> 2];
        b = n;
        s[b >> 2] = 2008548008;
        s[b + 4 >> 2] = 1006188771;
        b = n + 8 | 0;
        s[b >> 2] = 909333341;
        s[b + 4 >> 2] = 34282279;
        b = n + 16 | 0;
        s[b >> 2] = 1232425568;
        s[b + 4 >> 2] = 649588208;
        b = n + 24 | 0;
        s[b >> 2] = 1132767341;
        s[b + 4 >> 2] = 622118450;
        Ea(o, n, 136);
        s[u >> 2] = s[o >> 2];
        s[u + 4 >> 2] = s[o + 4 >> 2];
        s[u + 8 >> 2] = s[o + 8 >> 2];
        s[u + 12 >> 2] = s[o + 12 >> 2];
        s[u + 16 >> 2] = s[o + 16 >> 2];
        s[u + 20 >> 2] = s[o + 20 >> 2];
        s[u + 24 >> 2] = s[o + 24 >> 2];
        s[u + 28 >> 2] = s[o + 28 >> 2];
        b = c + 32 | 0;
        s[o >> 2] = s[b >> 2];
        s[o + 4 >> 2] = s[b + 4 >> 2];
        s[o + 8 >> 2] = s[b + 8 >> 2];
        s[o + 12 >> 2] = s[b + 12 >> 2];
        s[o + 16 >> 2] = s[b + 16 >> 2];
        s[o + 20 >> 2] = s[b + 20 >> 2];
        s[o + 24 >> 2] = s[b + 24 >> 2];
        s[o + 28 >> 2] = s[b + 28 >> 2];
        b = n;
        s[b >> 2] = -774045849;
        s[b + 4 >> 2] = 954723532;
        b = n + 8 | 0;
        s[b >> 2] = -1815212738;
        s[b + 4 >> 2] = 1710273405;
        b = n + 16 | 0;
        s[b >> 2] = 581697706;
        s[b + 4 >> 2] = -683028259;
        b = n + 24 | 0;
        s[b >> 2] = 1248365901;
        s[b + 4 >> 2] = 21084622;
        Ea(o, n, 136);
        s[i >> 2] = s[o >> 2];
        s[i + 4 >> 2] = s[o + 4 >> 2];
        s[i + 8 >> 2] = s[o + 8 >> 2];
        s[i + 12 >> 2] = s[o + 12 >> 2];
        s[i + 16 >> 2] = s[o + 16 >> 2];
        s[i + 20 >> 2] = s[o + 20 >> 2];
        s[i + 24 >> 2] = s[o + 24 >> 2];
        s[i + 28 >> 2] = s[o + 28 >> 2];
        b = u + 32 | 0;
        s[b >> 2] = s[i >> 2];
        s[b + 4 >> 2] = s[i + 4 >> 2];
        s[b + 8 >> 2] = s[i + 8 >> 2];
        s[b + 12 >> 2] = s[i + 12 >> 2];
        s[b + 16 >> 2] = s[i + 16 >> 2];
        s[b + 20 >> 2] = s[i + 20 >> 2];
        s[b + 24 >> 2] = s[i + 24 >> 2];
        s[b + 28 >> 2] = s[i + 28 >> 2];

        if ((Vu(d, u, 32) | 0) == 0 ? (Vu(d + 32 | 0, u + 32 | 0, 32) | 0) == 0 : 0) {
          f = d;
          h = t;
          b = f + 64 | 0;

          do {
            s[f >> 2] = s[h >> 2];
            f = f + 4 | 0;
            h = h + 4 | 0;
          } while ((f | 0) < (b | 0));

          f = d + 64 | 0;
          h = a;
          b = f + 64 | 0;

          do {
            s[f >> 2] = s[h >> 2];
            f = f + 4 | 0;
            h = h + 4 | 0;
          } while ((f | 0) < (b | 0));

          f = i;
          h = d;
          b = f + 128 | 0;

          do {
            s[f >> 2] = s[h >> 2];
            f = f + 4 | 0;
            h = h + 4 | 0;
          } while ((f | 0) < (b | 0));

          f = i + 128 | 0;
          s[f >> 2] = -980480611;
          s[f + 4 >> 2] = -748862579;
          f = i + 136 | 0;
          s[f >> 2] = -171504835;
          s[f + 4 >> 2] = 175696680;
          f = i + 144 | 0;
          s[f >> 2] = 2021213740;
          s[f + 4 >> 2] = 1718526831;
          f = i + 152 | 0;
          s[f >> 2] = -1710760145;
          s[f + 4 >> 2] = 235567041;
          f = i + 160 | 0;
          s[f >> 2] = 0;
          s[f + 4 >> 2] = 0;
          s[f + 8 >> 2] = 0;
          s[f + 12 >> 2] = 0;
          s[f + 16 >> 2] = 0;
          s[f + 20 >> 2] = 0;
          s[f + 24 >> 2] = 0;
          s[f + 28 >> 2] = 0;
          f = n;
          s[f >> 2] = 1342177275;
          s[f + 4 >> 2] = -1399442404;
          f = n + 8 | 0;
          s[f >> 2] = -1621045975;
          s[f + 4 >> 2] = 922515093;
          f = n + 16 | 0;
          s[f >> 2] = 2021213742;
          s[f + 4 >> 2] = 1718526831;
          f = n + 24 | 0;
          s[f >> 2] = -1710760145;
          s[f + 4 >> 2] = 235567041;
          Ra(n, 8);
          s[o >> 2] = s[n >> 2];
          s[o + 4 >> 2] = s[n + 4 >> 2];
          s[o + 8 >> 2] = s[n + 8 >> 2];
          s[o + 12 >> 2] = s[n + 12 >> 2];
          s[o + 16 >> 2] = s[n + 16 >> 2];
          s[o + 20 >> 2] = s[n + 20 >> 2];
          s[o + 24 >> 2] = s[n + 24 >> 2];
          s[o + 28 >> 2] = s[n + 28 >> 2];
          pa(c, i, o);
          f = n;
          h = d;
          b = f + 128 | 0;

          do {
            s[f >> 2] = s[h >> 2];
            f = f + 4 | 0;
            h = h + 4 | 0;
          } while ((f | 0) < (b | 0));

          b = n + 128 | 0;
          s[b >> 2] = -980480611;
          s[b + 4 >> 2] = -748862579;
          b = n + 136 | 0;
          s[b >> 2] = -171504835;
          s[b + 4 >> 2] = 175696680;
          b = n + 144 | 0;
          s[b >> 2] = 2021213740;
          s[b + 4 >> 2] = 1718526831;
          b = n + 152 | 0;
          s[b >> 2] = -1710760145;
          s[b + 4 >> 2] = 235567041;
          b = n + 160 | 0;
          s[b >> 2] = 0;
          s[b + 4 >> 2] = 0;
          s[b + 8 >> 2] = 0;
          s[b + 12 >> 2] = 0;
          s[b + 16 >> 2] = 0;
          s[b + 20 >> 2] = 0;
          s[b + 24 >> 2] = 0;
          s[b + 28 >> 2] = 0;
          ba(u, c, n);
          b = u + 128 | 0;

          do {
            if ((s[b >> 2] | 0) == 0 & (s[b + 4 >> 2] | 0) == 0) {
              b = u + 136 | 0;
              if (!((s[b >> 2] | 0) == 0 & (s[b + 4 >> 2] | 0) == 0)) break;
              b = u + 144 | 0;
              if (!((s[b >> 2] | 0) == 0 & (s[b + 4 >> 2] | 0) == 0)) break;
              b = u + 152 | 0;
              if (!((s[b >> 2] | 0) == 0 & (s[b + 4 >> 2] | 0) == 0)) break;
              b = u + 160 | 0;
              if (!((s[b >> 2] | 0) == 0 & (s[b + 4 >> 2] | 0) == 0)) break;
              b = u + 168 | 0;
              if (!((s[b >> 2] | 0) == 0 & (s[b + 4 >> 2] | 0) == 0)) break;
              b = u + 176 | 0;
              if (!((s[b >> 2] | 0) == 0 & (s[b + 4 >> 2] | 0) == 0)) break;
              b = u + 184 | 0;

              if ((s[b >> 2] | 0) == 0 & (s[b + 4 >> 2] | 0) == 0) {
                f = n;
                h = t;
                b = f + 64 | 0;

                do {
                  s[f >> 2] = s[h >> 2];
                  f = f + 4 | 0;
                  h = h + 4 | 0;
                } while ((f | 0) < (b | 0));

                f = n + 64 | 0;
                h = a;
                b = f + 64 | 0;

                do {
                  s[f >> 2] = s[h >> 2];
                  f = f + 4 | 0;
                  h = h + 4 | 0;
                } while ((f | 0) < (b | 0));

                r[e >> 0] = 0;
                f = e + 8 | 0;
                h = n;
                b = f + 128 | 0;

                do {
                  s[f >> 2] = s[h >> 2];
                  f = f + 4 | 0;
                  h = h + 4 | 0;
                } while ((f | 0) < (b | 0));

                p = l;
                return;
              }
            }
          } while (0);

          r[e >> 0] = 1;
          r[e + 1 >> 0] = 1;
          p = l;
          return;
        }

        r[e >> 0] = 1;
        r[e + 1 >> 0] = 0;
        p = l;
        return;
      }

      function pa(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0;
        l = p;
        p = p + 800 | 0;
        i = l + 608 | 0;
        c = l + 416 | 0;
        u = l + 224 | 0;
        d = l + 192 | 0;
        f = l;
        n = f;
        o = n + 64 | 0;

        do {
          s[n >> 2] = 0;
          n = n + 4 | 0;
        } while ((n | 0) < (o | 0));

        n = f + 64 | 0;
        s[n >> 2] = -980480611;
        s[n + 4 >> 2] = -748862579;
        n = f + 72 | 0;
        s[n >> 2] = -171504835;
        s[n + 4 >> 2] = 175696680;
        n = f + 80 | 0;
        s[n >> 2] = 2021213740;
        s[n + 4 >> 2] = 1718526831;
        n = f + 88 | 0;
        s[n >> 2] = -1710760145;
        s[n + 4 >> 2] = 235567041;
        n = f + 96 | 0;
        o = n + 96 | 0;

        do {
          s[n >> 2] = 0;
          n = n + 4 | 0;
        } while ((n | 0) < (o | 0));

        s[c >> 2] = s[a >> 2];
        s[c + 4 >> 2] = s[a + 4 >> 2];
        s[c + 8 >> 2] = s[a + 8 >> 2];
        s[c + 12 >> 2] = s[a + 12 >> 2];
        s[c + 16 >> 2] = s[a + 16 >> 2];
        s[c + 20 >> 2] = s[a + 20 >> 2];
        s[c + 24 >> 2] = s[a + 24 >> 2];
        s[c + 28 >> 2] = s[a + 28 >> 2];
        a = i;
        s[a >> 2] = 1;
        s[a + 4 >> 2] = 0;
        a = i + 8 | 0;
        s[a >> 2] = 0;
        s[a + 4 >> 2] = 0;
        s[a + 8 >> 2] = 0;
        s[a + 12 >> 2] = 0;
        s[a + 16 >> 2] = 0;
        s[a + 20 >> 2] = 0;
        ka(c, i, 8, -268435457, -1025378925);
        s[d >> 2] = s[c >> 2];
        s[d + 4 >> 2] = s[c + 4 >> 2];
        s[d + 8 >> 2] = s[c + 8 >> 2];
        s[d + 12 >> 2] = s[c + 12 >> 2];
        s[d + 16 >> 2] = s[c + 16 >> 2];
        s[d + 20 >> 2] = s[c + 20 >> 2];
        s[d + 24 >> 2] = s[c + 24 >> 2];
        s[d + 28 >> 2] = s[c + 28 >> 2];
        a = 256;

        while (1) {
          if (!a) {
            a = 7;
            break;
          }

          a = a + -1 | 0;

          if (a >>> 0 > 255) {
            a = 7;
            break;
          }

          o = d + (a >>> 6 << 3) | 0;
          h = s[o >> 2] | 0;
          o = s[o + 4 >> 2] | 0;
          n = od(1, 0, a & 63 | 0) | 0;

          if (!((h & n | 0) == 0 & (o & S | 0) == 0)) {
            r = a;
            a = 9;
            break;
          }
        }

        if ((a | 0) == 7) {
          id(e | 0, f | 0, 192) | 0;
          p = l;
          return;
        } else if ((a | 0) == 9) {
          e: while (1) {
            id(c | 0, f | 0, 192) | 0;
            id(i | 0, t | 0, 192) | 0;
            ba(u, c, i);
            id(f | 0, u | 0, 192) | 0;

            while (1) {
              if (!r) {
                a = 7;
                break e;
              }

              r = r + -1 | 0;

              if (r >>> 0 > 255) {
                a = 7;
                break e;
              }

              h = d + (r >>> 6 << 3) | 0;
              n = s[h >> 2] | 0;
              h = s[h + 4 >> 2] | 0;
              o = od(1, 0, r & 63 | 0) | 0;
              h = (n & o | 0) == 0 & (h & S | 0) == 0;
              ma(i, f);
              id(f | 0, i | 0, 192) | 0;
              if (!h) continue e;
            }
          }

          if ((a | 0) == 7) {
            id(e | 0, f | 0, 192) | 0;
            p = l;
            return;
          }
        }
      }

      function ba(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0,
            A = 0,
            w = 0,
            T = 0,
            x = 0,
            D = 0,
            C = 0,
            S = 0,
            E = 0,
            B = 0,
            k = 0,
            R = 0,
            W = 0,
            I = 0,
            N = 0,
            M = 0,
            P = 0,
            L = 0;
        M = p;
        p = p + 1696 | 0;
        k = M + 1632 | 0;
        R = M + 1568 | 0;
        W = M + 1536 | 0;
        I = M + 1472 | 0;
        A = M + 1408 | 0;
        w = M + 1344 | 0;
        T = M + 1280 | 0;
        x = M + 1216 | 0;
        D = M + 1152 | 0;
        C = M + 1088 | 0;
        S = M + 1024 | 0;
        b = M + 960 | 0;
        m = M + 896 | 0;
        y = M + 832 | 0;
        v = M + 768 | 0;
        r = M + 704 | 0;
        n = M + 640 | 0;
        o = M + 576 | 0;
        E = M + 512 | 0;
        i = M + 448 | 0;
        c = M + 384 | 0;
        u = M + 320 | 0;
        d = M + 256 | 0;
        f = M + 192 | 0;
        l = M + 128 | 0;
        B = M + 64 | 0;
        _ = M;
        g = t + 128 | 0;
        L = g;

        if ((((((((s[L >> 2] | 0) == 0 & (s[L + 4 >> 2] | 0) == 0 ? (L = t + 136 | 0, (s[L >> 2] | 0) == 0 & (s[L + 4 >> 2] | 0) == 0) : 0) ? (L = t + 144 | 0, (s[L >> 2] | 0) == 0 & (s[L + 4 >> 2] | 0) == 0) : 0) ? (L = t + 152 | 0, (s[L >> 2] | 0) == 0 & (s[L + 4 >> 2] | 0) == 0) : 0) ? (L = t + 160 | 0, (s[L >> 2] | 0) == 0 & (s[L + 4 >> 2] | 0) == 0) : 0) ? (L = t + 168 | 0, (s[L >> 2] | 0) == 0 & (s[L + 4 >> 2] | 0) == 0) : 0) ? (L = t + 176 | 0, (s[L >> 2] | 0) == 0 & (s[L + 4 >> 2] | 0) == 0) : 0) ? (L = t + 184 | 0, (s[L >> 2] | 0) == 0 & (s[L + 4 >> 2] | 0) == 0) : 0) {
          id(e | 0, a | 0, 192) | 0;
          p = M;
          return;
        }

        h = a + 128 | 0;
        L = h;

        if ((((((((s[L >> 2] | 0) == 0 & (s[L + 4 >> 2] | 0) == 0 ? (L = a + 136 | 0, (s[L >> 2] | 0) == 0 & (s[L + 4 >> 2] | 0) == 0) : 0) ? (L = a + 144 | 0, (s[L >> 2] | 0) == 0 & (s[L + 4 >> 2] | 0) == 0) : 0) ? (L = a + 152 | 0, (s[L >> 2] | 0) == 0 & (s[L + 4 >> 2] | 0) == 0) : 0) ? (L = a + 160 | 0, (s[L >> 2] | 0) == 0 & (s[L + 4 >> 2] | 0) == 0) : 0) ? (L = a + 168 | 0, (s[L >> 2] | 0) == 0 & (s[L + 4 >> 2] | 0) == 0) : 0) ? (L = a + 176 | 0, (s[L >> 2] | 0) == 0 & (s[L + 4 >> 2] | 0) == 0) : 0) ? (L = a + 184 | 0, (s[L >> 2] | 0) == 0 & (s[L + 4 >> 2] | 0) == 0) : 0) {
          id(e | 0, t | 0, 192) | 0;
          p = M;
          return;
        }

        Za(_, g);
        Za(B, h);
        N = R;
        P = t;
        L = N + 64 | 0;

        do {
          s[N >> 2] = s[P >> 2];
          N = N + 4 | 0;
          P = P + 4 | 0;
        } while ((N | 0) < (L | 0));

        N = k;
        P = B;
        L = N + 64 | 0;

        do {
          s[N >> 2] = s[P >> 2];
          N = N + 4 | 0;
          P = P + 4 | 0;
        } while ((N | 0) < (L | 0));

        Ya(l, R, k);
        N = R;
        P = a;
        L = N + 64 | 0;

        do {
          s[N >> 2] = s[P >> 2];
          N = N + 4 | 0;
          P = P + 4 | 0;
        } while ((N | 0) < (L | 0));

        N = k;
        P = _;
        L = N + 64 | 0;

        do {
          s[N >> 2] = s[P >> 2];
          N = N + 4 | 0;
          P = P + 4 | 0;
        } while ((N | 0) < (L | 0));

        Ya(f, R, k);
        N = R;
        P = g;
        L = N + 64 | 0;

        do {
          s[N >> 2] = s[P >> 2];
          N = N + 4 | 0;
          P = P + 4 | 0;
        } while ((N | 0) < (L | 0));

        N = k;
        P = _;
        L = N + 64 | 0;

        do {
          s[N >> 2] = s[P >> 2];
          N = N + 4 | 0;
          P = P + 4 | 0;
        } while ((N | 0) < (L | 0));

        Ya(d, R, k);
        N = R;
        P = h;
        L = N + 64 | 0;

        do {
          s[N >> 2] = s[P >> 2];
          N = N + 4 | 0;
          P = P + 4 | 0;
        } while ((N | 0) < (L | 0));

        N = k;
        P = B;
        L = N + 64 | 0;

        do {
          s[N >> 2] = s[P >> 2];
          N = N + 4 | 0;
          P = P + 4 | 0;
        } while ((N | 0) < (L | 0));

        Ya(u, R, k);
        N = R;
        P = t + 64 | 0;
        L = N + 64 | 0;

        do {
          s[N >> 2] = s[P >> 2];
          N = N + 4 | 0;
          P = P + 4 | 0;
        } while ((N | 0) < (L | 0));

        N = k;
        P = u;
        L = N + 64 | 0;

        do {
          s[N >> 2] = s[P >> 2];
          N = N + 4 | 0;
          P = P + 4 | 0;
        } while ((N | 0) < (L | 0));

        Ya(c, R, k);
        N = R;
        P = a + 64 | 0;
        L = N + 64 | 0;

        do {
          s[N >> 2] = s[P >> 2];
          N = N + 4 | 0;
          P = P + 4 | 0;
        } while ((N | 0) < (L | 0));

        N = k;
        P = d;
        L = N + 64 | 0;

        do {
          s[N >> 2] = s[P >> 2];
          N = N + 4 | 0;
          P = P + 4 | 0;
        } while ((N | 0) < (L | 0));

        Ya(i, R, k);
        if ((((Vu(l, f, 32) | 0) == 0 ? (Vu(l + 32 | 0, f + 32 | 0, 32) | 0) == 0 : 0) ? (Vu(c, i, 32) | 0) == 0 : 0) ? (Vu(c + 32 | 0, i + 32 | 0, 32) | 0) == 0 : 0) ma(e, t);else {
          N = A;
          P = f;
          L = N + 64 | 0;

          do {
            s[N >> 2] = s[P >> 2];
            N = N + 4 | 0;
            P = P + 4 | 0;
          } while ((N | 0) < (L | 0));

          N = I;
          P = l;
          L = N + 64 | 0;

          do {
            s[N >> 2] = s[P >> 2];
            N = N + 4 | 0;
            P = P + 4 | 0;
          } while ((N | 0) < (L | 0));

          s[R >> 2] = s[f >> 2];
          s[R + 4 >> 2] = s[f + 4 >> 2];
          s[R + 8 >> 2] = s[f + 8 >> 2];
          s[R + 12 >> 2] = s[f + 12 >> 2];
          s[R + 16 >> 2] = s[f + 16 >> 2];
          s[R + 20 >> 2] = s[f + 20 >> 2];
          s[R + 24 >> 2] = s[f + 24 >> 2];
          s[R + 28 >> 2] = s[f + 28 >> 2];
          s[k >> 2] = s[l >> 2];
          s[k + 4 >> 2] = s[l + 4 >> 2];
          s[k + 8 >> 2] = s[l + 8 >> 2];
          s[k + 12 >> 2] = s[l + 12 >> 2];
          s[k + 16 >> 2] = s[l + 16 >> 2];
          s[k + 20 >> 2] = s[l + 20 >> 2];
          s[k + 24 >> 2] = s[l + 24 >> 2];
          s[k + 28 >> 2] = s[l + 28 >> 2];
          Ba(R, k, 136);
          s[E >> 2] = s[R >> 2];
          s[E + 4 >> 2] = s[R + 4 >> 2];
          s[E + 8 >> 2] = s[R + 8 >> 2];
          s[E + 12 >> 2] = s[R + 12 >> 2];
          s[E + 16 >> 2] = s[R + 16 >> 2];
          s[E + 20 >> 2] = s[R + 20 >> 2];
          s[E + 24 >> 2] = s[R + 24 >> 2];
          s[E + 28 >> 2] = s[R + 28 >> 2];
          N = A + 32 | 0;
          s[R >> 2] = s[N >> 2];
          s[R + 4 >> 2] = s[N + 4 >> 2];
          s[R + 8 >> 2] = s[N + 8 >> 2];
          s[R + 12 >> 2] = s[N + 12 >> 2];
          s[R + 16 >> 2] = s[N + 16 >> 2];
          s[R + 20 >> 2] = s[N + 20 >> 2];
          s[R + 24 >> 2] = s[N + 24 >> 2];
          s[R + 28 >> 2] = s[N + 28 >> 2];
          N = I + 32 | 0;
          s[k >> 2] = s[N >> 2];
          s[k + 4 >> 2] = s[N + 4 >> 2];
          s[k + 8 >> 2] = s[N + 8 >> 2];
          s[k + 12 >> 2] = s[N + 12 >> 2];
          s[k + 16 >> 2] = s[N + 16 >> 2];
          s[k + 20 >> 2] = s[N + 20 >> 2];
          s[k + 24 >> 2] = s[N + 24 >> 2];
          s[k + 28 >> 2] = s[N + 28 >> 2];
          Ba(R, k, 136);
          s[W >> 2] = s[R >> 2];
          s[W + 4 >> 2] = s[R + 4 >> 2];
          s[W + 8 >> 2] = s[R + 8 >> 2];
          s[W + 12 >> 2] = s[R + 12 >> 2];
          s[W + 16 >> 2] = s[R + 16 >> 2];
          s[W + 20 >> 2] = s[R + 20 >> 2];
          s[W + 24 >> 2] = s[R + 24 >> 2];
          s[W + 28 >> 2] = s[R + 28 >> 2];
          N = E + 32 | 0;
          s[N >> 2] = s[W >> 2];
          s[N + 4 >> 2] = s[W + 4 >> 2];
          s[N + 8 >> 2] = s[W + 8 >> 2];
          s[N + 12 >> 2] = s[W + 12 >> 2];
          s[N + 16 >> 2] = s[W + 16 >> 2];
          s[N + 20 >> 2] = s[W + 20 >> 2];
          s[N + 24 >> 2] = s[W + 24 >> 2];
          s[N + 28 >> 2] = s[W + 28 >> 2];
          N = A;
          P = i;
          L = N + 64 | 0;

          do {
            s[N >> 2] = s[P >> 2];
            N = N + 4 | 0;
            P = P + 4 | 0;
          } while ((N | 0) < (L | 0));

          N = I;
          P = c;
          L = N + 64 | 0;

          do {
            s[N >> 2] = s[P >> 2];
            N = N + 4 | 0;
            P = P + 4 | 0;
          } while ((N | 0) < (L | 0));

          s[R >> 2] = s[i >> 2];
          s[R + 4 >> 2] = s[i + 4 >> 2];
          s[R + 8 >> 2] = s[i + 8 >> 2];
          s[R + 12 >> 2] = s[i + 12 >> 2];
          s[R + 16 >> 2] = s[i + 16 >> 2];
          s[R + 20 >> 2] = s[i + 20 >> 2];
          s[R + 24 >> 2] = s[i + 24 >> 2];
          s[R + 28 >> 2] = s[i + 28 >> 2];
          s[k >> 2] = s[c >> 2];
          s[k + 4 >> 2] = s[c + 4 >> 2];
          s[k + 8 >> 2] = s[c + 8 >> 2];
          s[k + 12 >> 2] = s[c + 12 >> 2];
          s[k + 16 >> 2] = s[c + 16 >> 2];
          s[k + 20 >> 2] = s[c + 20 >> 2];
          s[k + 24 >> 2] = s[c + 24 >> 2];
          s[k + 28 >> 2] = s[c + 28 >> 2];
          Ba(R, k, 136);
          s[o >> 2] = s[R >> 2];
          s[o + 4 >> 2] = s[R + 4 >> 2];
          s[o + 8 >> 2] = s[R + 8 >> 2];
          s[o + 12 >> 2] = s[R + 12 >> 2];
          s[o + 16 >> 2] = s[R + 16 >> 2];
          s[o + 20 >> 2] = s[R + 20 >> 2];
          s[o + 24 >> 2] = s[R + 24 >> 2];
          s[o + 28 >> 2] = s[R + 28 >> 2];
          N = A + 32 | 0;
          s[R >> 2] = s[N >> 2];
          s[R + 4 >> 2] = s[N + 4 >> 2];
          s[R + 8 >> 2] = s[N + 8 >> 2];
          s[R + 12 >> 2] = s[N + 12 >> 2];
          s[R + 16 >> 2] = s[N + 16 >> 2];
          s[R + 20 >> 2] = s[N + 20 >> 2];
          s[R + 24 >> 2] = s[N + 24 >> 2];
          s[R + 28 >> 2] = s[N + 28 >> 2];
          N = I + 32 | 0;
          s[k >> 2] = s[N >> 2];
          s[k + 4 >> 2] = s[N + 4 >> 2];
          s[k + 8 >> 2] = s[N + 8 >> 2];
          s[k + 12 >> 2] = s[N + 12 >> 2];
          s[k + 16 >> 2] = s[N + 16 >> 2];
          s[k + 20 >> 2] = s[N + 20 >> 2];
          s[k + 24 >> 2] = s[N + 24 >> 2];
          s[k + 28 >> 2] = s[N + 28 >> 2];
          Ba(R, k, 136);
          s[W >> 2] = s[R >> 2];
          s[W + 4 >> 2] = s[R + 4 >> 2];
          s[W + 8 >> 2] = s[R + 8 >> 2];
          s[W + 12 >> 2] = s[R + 12 >> 2];
          s[W + 16 >> 2] = s[R + 16 >> 2];
          s[W + 20 >> 2] = s[R + 20 >> 2];
          s[W + 24 >> 2] = s[R + 24 >> 2];
          s[W + 28 >> 2] = s[R + 28 >> 2];
          N = o + 32 | 0;
          s[N >> 2] = s[W >> 2];
          s[N + 4 >> 2] = s[W + 4 >> 2];
          s[N + 8 >> 2] = s[W + 8 >> 2];
          s[N + 12 >> 2] = s[W + 12 >> 2];
          s[N + 16 >> 2] = s[W + 16 >> 2];
          s[N + 20 >> 2] = s[W + 20 >> 2];
          s[N + 24 >> 2] = s[W + 24 >> 2];
          s[N + 28 >> 2] = s[W + 28 >> 2];
          N = A;
          P = E;
          L = N + 64 | 0;

          do {
            s[N >> 2] = s[P >> 2];
            N = N + 4 | 0;
            P = P + 4 | 0;
          } while ((N | 0) < (L | 0));

          N = I;
          P = E;
          L = N + 64 | 0;

          do {
            s[N >> 2] = s[P >> 2];
            N = N + 4 | 0;
            P = P + 4 | 0;
          } while ((N | 0) < (L | 0));

          s[R >> 2] = s[A >> 2];
          s[R + 4 >> 2] = s[A + 4 >> 2];
          s[R + 8 >> 2] = s[A + 8 >> 2];
          s[R + 12 >> 2] = s[A + 12 >> 2];
          s[R + 16 >> 2] = s[A + 16 >> 2];
          s[R + 20 >> 2] = s[A + 20 >> 2];
          s[R + 24 >> 2] = s[A + 24 >> 2];
          s[R + 28 >> 2] = s[A + 28 >> 2];
          s[k >> 2] = s[E >> 2];
          s[k + 4 >> 2] = s[E + 4 >> 2];
          s[k + 8 >> 2] = s[E + 8 >> 2];
          s[k + 12 >> 2] = s[E + 12 >> 2];
          s[k + 16 >> 2] = s[E + 16 >> 2];
          s[k + 20 >> 2] = s[E + 20 >> 2];
          s[k + 24 >> 2] = s[E + 24 >> 2];
          s[k + 28 >> 2] = s[E + 28 >> 2];
          Ea(R, k, 136);
          s[w >> 2] = s[R >> 2];
          s[w + 4 >> 2] = s[R + 4 >> 2];
          s[w + 8 >> 2] = s[R + 8 >> 2];
          s[w + 12 >> 2] = s[R + 12 >> 2];
          s[w + 16 >> 2] = s[R + 16 >> 2];
          s[w + 20 >> 2] = s[R + 20 >> 2];
          s[w + 24 >> 2] = s[R + 24 >> 2];
          s[w + 28 >> 2] = s[R + 28 >> 2];
          N = A + 32 | 0;
          s[R >> 2] = s[N >> 2];
          s[R + 4 >> 2] = s[N + 4 >> 2];
          s[R + 8 >> 2] = s[N + 8 >> 2];
          s[R + 12 >> 2] = s[N + 12 >> 2];
          s[R + 16 >> 2] = s[N + 16 >> 2];
          s[R + 20 >> 2] = s[N + 20 >> 2];
          s[R + 24 >> 2] = s[N + 24 >> 2];
          s[R + 28 >> 2] = s[N + 28 >> 2];
          N = I + 32 | 0;
          s[k >> 2] = s[N >> 2];
          s[k + 4 >> 2] = s[N + 4 >> 2];
          s[k + 8 >> 2] = s[N + 8 >> 2];
          s[k + 12 >> 2] = s[N + 12 >> 2];
          s[k + 16 >> 2] = s[N + 16 >> 2];
          s[k + 20 >> 2] = s[N + 20 >> 2];
          s[k + 24 >> 2] = s[N + 24 >> 2];
          s[k + 28 >> 2] = s[N + 28 >> 2];
          Ea(R, k, 136);
          s[W >> 2] = s[R >> 2];
          s[W + 4 >> 2] = s[R + 4 >> 2];
          s[W + 8 >> 2] = s[R + 8 >> 2];
          s[W + 12 >> 2] = s[R + 12 >> 2];
          s[W + 16 >> 2] = s[R + 16 >> 2];
          s[W + 20 >> 2] = s[R + 20 >> 2];
          s[W + 24 >> 2] = s[R + 24 >> 2];
          s[W + 28 >> 2] = s[R + 28 >> 2];
          N = w + 32 | 0;
          s[N >> 2] = s[W >> 2];
          s[N + 4 >> 2] = s[W + 4 >> 2];
          s[N + 8 >> 2] = s[W + 8 >> 2];
          s[N + 12 >> 2] = s[W + 12 >> 2];
          s[N + 16 >> 2] = s[W + 16 >> 2];
          s[N + 20 >> 2] = s[W + 20 >> 2];
          s[N + 24 >> 2] = s[W + 24 >> 2];
          s[N + 28 >> 2] = s[W + 28 >> 2];
          Za(n, w);
          N = R;
          P = E;
          L = N + 64 | 0;

          do {
            s[N >> 2] = s[P >> 2];
            N = N + 4 | 0;
            P = P + 4 | 0;
          } while ((N | 0) < (L | 0));

          N = k;
          P = n;
          L = N + 64 | 0;

          do {
            s[N >> 2] = s[P >> 2];
            N = N + 4 | 0;
            P = P + 4 | 0;
          } while ((N | 0) < (L | 0));

          Ya(r, R, k);
          N = A;
          P = o;
          L = N + 64 | 0;

          do {
            s[N >> 2] = s[P >> 2];
            N = N + 4 | 0;
            P = P + 4 | 0;
          } while ((N | 0) < (L | 0));

          N = I;
          P = o;
          L = N + 64 | 0;

          do {
            s[N >> 2] = s[P >> 2];
            N = N + 4 | 0;
            P = P + 4 | 0;
          } while ((N | 0) < (L | 0));

          s[R >> 2] = s[A >> 2];
          s[R + 4 >> 2] = s[A + 4 >> 2];
          s[R + 8 >> 2] = s[A + 8 >> 2];
          s[R + 12 >> 2] = s[A + 12 >> 2];
          s[R + 16 >> 2] = s[A + 16 >> 2];
          s[R + 20 >> 2] = s[A + 20 >> 2];
          s[R + 24 >> 2] = s[A + 24 >> 2];
          s[R + 28 >> 2] = s[A + 28 >> 2];
          s[k >> 2] = s[o >> 2];
          s[k + 4 >> 2] = s[o + 4 >> 2];
          s[k + 8 >> 2] = s[o + 8 >> 2];
          s[k + 12 >> 2] = s[o + 12 >> 2];
          s[k + 16 >> 2] = s[o + 16 >> 2];
          s[k + 20 >> 2] = s[o + 20 >> 2];
          s[k + 24 >> 2] = s[o + 24 >> 2];
          s[k + 28 >> 2] = s[o + 28 >> 2];
          Ea(R, k, 136);
          s[v >> 2] = s[R >> 2];
          s[v + 4 >> 2] = s[R + 4 >> 2];
          s[v + 8 >> 2] = s[R + 8 >> 2];
          s[v + 12 >> 2] = s[R + 12 >> 2];
          s[v + 16 >> 2] = s[R + 16 >> 2];
          s[v + 20 >> 2] = s[R + 20 >> 2];
          s[v + 24 >> 2] = s[R + 24 >> 2];
          s[v + 28 >> 2] = s[R + 28 >> 2];
          N = A + 32 | 0;
          s[R >> 2] = s[N >> 2];
          s[R + 4 >> 2] = s[N + 4 >> 2];
          s[R + 8 >> 2] = s[N + 8 >> 2];
          s[R + 12 >> 2] = s[N + 12 >> 2];
          s[R + 16 >> 2] = s[N + 16 >> 2];
          s[R + 20 >> 2] = s[N + 20 >> 2];
          s[R + 24 >> 2] = s[N + 24 >> 2];
          s[R + 28 >> 2] = s[N + 28 >> 2];
          N = I + 32 | 0;
          s[k >> 2] = s[N >> 2];
          s[k + 4 >> 2] = s[N + 4 >> 2];
          s[k + 8 >> 2] = s[N + 8 >> 2];
          s[k + 12 >> 2] = s[N + 12 >> 2];
          s[k + 16 >> 2] = s[N + 16 >> 2];
          s[k + 20 >> 2] = s[N + 20 >> 2];
          s[k + 24 >> 2] = s[N + 24 >> 2];
          s[k + 28 >> 2] = s[N + 28 >> 2];
          Ea(R, k, 136);
          s[W >> 2] = s[R >> 2];
          s[W + 4 >> 2] = s[R + 4 >> 2];
          s[W + 8 >> 2] = s[R + 8 >> 2];
          s[W + 12 >> 2] = s[R + 12 >> 2];
          s[W + 16 >> 2] = s[R + 16 >> 2];
          s[W + 20 >> 2] = s[R + 20 >> 2];
          s[W + 24 >> 2] = s[R + 24 >> 2];
          s[W + 28 >> 2] = s[R + 28 >> 2];
          N = v + 32 | 0;
          s[N >> 2] = s[W >> 2];
          s[N + 4 >> 2] = s[W + 4 >> 2];
          s[N + 8 >> 2] = s[W + 8 >> 2];
          s[N + 12 >> 2] = s[W + 12 >> 2];
          s[N + 16 >> 2] = s[W + 16 >> 2];
          s[N + 20 >> 2] = s[W + 20 >> 2];
          s[N + 24 >> 2] = s[W + 24 >> 2];
          s[N + 28 >> 2] = s[W + 28 >> 2];
          N = R;
          P = l;
          L = N + 64 | 0;

          do {
            s[N >> 2] = s[P >> 2];
            N = N + 4 | 0;
            P = P + 4 | 0;
          } while ((N | 0) < (L | 0));

          N = k;
          P = n;
          L = N + 64 | 0;

          do {
            s[N >> 2] = s[P >> 2];
            N = N + 4 | 0;
            P = P + 4 | 0;
          } while ((N | 0) < (L | 0));

          Ya(y, R, k);
          N = R;
          P = c;
          L = N + 64 | 0;

          do {
            s[N >> 2] = s[P >> 2];
            N = N + 4 | 0;
            P = P + 4 | 0;
          } while ((N | 0) < (L | 0));

          N = k;
          P = r;
          L = N + 64 | 0;

          do {
            s[N >> 2] = s[P >> 2];
            N = N + 4 | 0;
            P = P + 4 | 0;
          } while ((N | 0) < (L | 0));

          Ya(m, R, k);
          Za(A, v);
          N = I;
          P = r;
          L = N + 64 | 0;

          do {
            s[N >> 2] = s[P >> 2];
            N = N + 4 | 0;
            P = P + 4 | 0;
          } while ((N | 0) < (L | 0));

          s[R >> 2] = s[A >> 2];
          s[R + 4 >> 2] = s[A + 4 >> 2];
          s[R + 8 >> 2] = s[A + 8 >> 2];
          s[R + 12 >> 2] = s[A + 12 >> 2];
          s[R + 16 >> 2] = s[A + 16 >> 2];
          s[R + 20 >> 2] = s[A + 20 >> 2];
          s[R + 24 >> 2] = s[A + 24 >> 2];
          s[R + 28 >> 2] = s[A + 28 >> 2];
          s[k >> 2] = s[r >> 2];
          s[k + 4 >> 2] = s[r + 4 >> 2];
          s[k + 8 >> 2] = s[r + 8 >> 2];
          s[k + 12 >> 2] = s[r + 12 >> 2];
          s[k + 16 >> 2] = s[r + 16 >> 2];
          s[k + 20 >> 2] = s[r + 20 >> 2];
          s[k + 24 >> 2] = s[r + 24 >> 2];
          s[k + 28 >> 2] = s[r + 28 >> 2];
          Ba(R, k, 136);
          s[T >> 2] = s[R >> 2];
          s[T + 4 >> 2] = s[R + 4 >> 2];
          s[T + 8 >> 2] = s[R + 8 >> 2];
          s[T + 12 >> 2] = s[R + 12 >> 2];
          s[T + 16 >> 2] = s[R + 16 >> 2];
          s[T + 20 >> 2] = s[R + 20 >> 2];
          s[T + 24 >> 2] = s[R + 24 >> 2];
          s[T + 28 >> 2] = s[R + 28 >> 2];
          t = A + 32 | 0;
          s[R >> 2] = s[t >> 2];
          s[R + 4 >> 2] = s[t + 4 >> 2];
          s[R + 8 >> 2] = s[t + 8 >> 2];
          s[R + 12 >> 2] = s[t + 12 >> 2];
          s[R + 16 >> 2] = s[t + 16 >> 2];
          s[R + 20 >> 2] = s[t + 20 >> 2];
          s[R + 24 >> 2] = s[t + 24 >> 2];
          s[R + 28 >> 2] = s[t + 28 >> 2];
          t = I + 32 | 0;
          s[k >> 2] = s[t >> 2];
          s[k + 4 >> 2] = s[t + 4 >> 2];
          s[k + 8 >> 2] = s[t + 8 >> 2];
          s[k + 12 >> 2] = s[t + 12 >> 2];
          s[k + 16 >> 2] = s[t + 16 >> 2];
          s[k + 20 >> 2] = s[t + 20 >> 2];
          s[k + 24 >> 2] = s[t + 24 >> 2];
          s[k + 28 >> 2] = s[t + 28 >> 2];
          Ba(R, k, 136);
          s[W >> 2] = s[R >> 2];
          s[W + 4 >> 2] = s[R + 4 >> 2];
          s[W + 8 >> 2] = s[R + 8 >> 2];
          s[W + 12 >> 2] = s[R + 12 >> 2];
          s[W + 16 >> 2] = s[R + 16 >> 2];
          s[W + 20 >> 2] = s[R + 20 >> 2];
          s[W + 24 >> 2] = s[R + 24 >> 2];
          s[W + 28 >> 2] = s[R + 28 >> 2];
          t = T + 32 | 0;
          s[t >> 2] = s[W >> 2];
          s[t + 4 >> 2] = s[W + 4 >> 2];
          s[t + 8 >> 2] = s[W + 8 >> 2];
          s[t + 12 >> 2] = s[W + 12 >> 2];
          s[t + 16 >> 2] = s[W + 16 >> 2];
          s[t + 20 >> 2] = s[W + 20 >> 2];
          s[t + 24 >> 2] = s[W + 24 >> 2];
          s[t + 28 >> 2] = s[W + 28 >> 2];
          N = A;
          P = y;
          L = N + 64 | 0;

          do {
            s[N >> 2] = s[P >> 2];
            N = N + 4 | 0;
            P = P + 4 | 0;
          } while ((N | 0) < (L | 0));

          N = I;
          P = y;
          L = N + 64 | 0;

          do {
            s[N >> 2] = s[P >> 2];
            N = N + 4 | 0;
            P = P + 4 | 0;
          } while ((N | 0) < (L | 0));

          s[R >> 2] = s[A >> 2];
          s[R + 4 >> 2] = s[A + 4 >> 2];
          s[R + 8 >> 2] = s[A + 8 >> 2];
          s[R + 12 >> 2] = s[A + 12 >> 2];
          s[R + 16 >> 2] = s[A + 16 >> 2];
          s[R + 20 >> 2] = s[A + 20 >> 2];
          s[R + 24 >> 2] = s[A + 24 >> 2];
          s[R + 28 >> 2] = s[A + 28 >> 2];
          s[k >> 2] = s[y >> 2];
          s[k + 4 >> 2] = s[y + 4 >> 2];
          s[k + 8 >> 2] = s[y + 8 >> 2];
          s[k + 12 >> 2] = s[y + 12 >> 2];
          s[k + 16 >> 2] = s[y + 16 >> 2];
          s[k + 20 >> 2] = s[y + 20 >> 2];
          s[k + 24 >> 2] = s[y + 24 >> 2];
          s[k + 28 >> 2] = s[y + 28 >> 2];
          Ea(R, k, 136);
          s[w >> 2] = s[R >> 2];
          s[w + 4 >> 2] = s[R + 4 >> 2];
          s[w + 8 >> 2] = s[R + 8 >> 2];
          s[w + 12 >> 2] = s[R + 12 >> 2];
          s[w + 16 >> 2] = s[R + 16 >> 2];
          s[w + 20 >> 2] = s[R + 20 >> 2];
          s[w + 24 >> 2] = s[R + 24 >> 2];
          s[w + 28 >> 2] = s[R + 28 >> 2];
          N = A + 32 | 0;
          s[R >> 2] = s[N >> 2];
          s[R + 4 >> 2] = s[N + 4 >> 2];
          s[R + 8 >> 2] = s[N + 8 >> 2];
          s[R + 12 >> 2] = s[N + 12 >> 2];
          s[R + 16 >> 2] = s[N + 16 >> 2];
          s[R + 20 >> 2] = s[N + 20 >> 2];
          s[R + 24 >> 2] = s[N + 24 >> 2];
          s[R + 28 >> 2] = s[N + 28 >> 2];
          N = I + 32 | 0;
          s[k >> 2] = s[N >> 2];
          s[k + 4 >> 2] = s[N + 4 >> 2];
          s[k + 8 >> 2] = s[N + 8 >> 2];
          s[k + 12 >> 2] = s[N + 12 >> 2];
          s[k + 16 >> 2] = s[N + 16 >> 2];
          s[k + 20 >> 2] = s[N + 20 >> 2];
          s[k + 24 >> 2] = s[N + 24 >> 2];
          s[k + 28 >> 2] = s[N + 28 >> 2];
          Ea(R, k, 136);
          s[W >> 2] = s[R >> 2];
          s[W + 4 >> 2] = s[R + 4 >> 2];
          s[W + 8 >> 2] = s[R + 8 >> 2];
          s[W + 12 >> 2] = s[R + 12 >> 2];
          s[W + 16 >> 2] = s[R + 16 >> 2];
          s[W + 20 >> 2] = s[R + 20 >> 2];
          s[W + 24 >> 2] = s[R + 24 >> 2];
          s[W + 28 >> 2] = s[R + 28 >> 2];
          N = w + 32 | 0;
          s[N >> 2] = s[W >> 2];
          s[N + 4 >> 2] = s[W + 4 >> 2];
          s[N + 8 >> 2] = s[W + 8 >> 2];
          s[N + 12 >> 2] = s[W + 12 >> 2];
          s[N + 16 >> 2] = s[W + 16 >> 2];
          s[N + 20 >> 2] = s[W + 20 >> 2];
          s[N + 24 >> 2] = s[W + 24 >> 2];
          s[N + 28 >> 2] = s[W + 28 >> 2];
          s[R >> 2] = s[T >> 2];
          s[R + 4 >> 2] = s[T + 4 >> 2];
          s[R + 8 >> 2] = s[T + 8 >> 2];
          s[R + 12 >> 2] = s[T + 12 >> 2];
          s[R + 16 >> 2] = s[T + 16 >> 2];
          s[R + 20 >> 2] = s[T + 20 >> 2];
          s[R + 24 >> 2] = s[T + 24 >> 2];
          s[R + 28 >> 2] = s[T + 28 >> 2];
          s[k >> 2] = s[w >> 2];
          s[k + 4 >> 2] = s[w + 4 >> 2];
          s[k + 8 >> 2] = s[w + 8 >> 2];
          s[k + 12 >> 2] = s[w + 12 >> 2];
          s[k + 16 >> 2] = s[w + 16 >> 2];
          s[k + 20 >> 2] = s[w + 20 >> 2];
          s[k + 24 >> 2] = s[w + 24 >> 2];
          s[k + 28 >> 2] = s[w + 28 >> 2];
          Ba(R, k, 136);
          s[b >> 2] = s[R >> 2];
          s[b + 4 >> 2] = s[R + 4 >> 2];
          s[b + 8 >> 2] = s[R + 8 >> 2];
          s[b + 12 >> 2] = s[R + 12 >> 2];
          s[b + 16 >> 2] = s[R + 16 >> 2];
          s[b + 20 >> 2] = s[R + 20 >> 2];
          s[b + 24 >> 2] = s[R + 24 >> 2];
          s[b + 28 >> 2] = s[R + 28 >> 2];
          s[R >> 2] = s[t >> 2];
          s[R + 4 >> 2] = s[t + 4 >> 2];
          s[R + 8 >> 2] = s[t + 8 >> 2];
          s[R + 12 >> 2] = s[t + 12 >> 2];
          s[R + 16 >> 2] = s[t + 16 >> 2];
          s[R + 20 >> 2] = s[t + 20 >> 2];
          s[R + 24 >> 2] = s[t + 24 >> 2];
          s[R + 28 >> 2] = s[t + 28 >> 2];
          s[k >> 2] = s[N >> 2];
          s[k + 4 >> 2] = s[N + 4 >> 2];
          s[k + 8 >> 2] = s[N + 8 >> 2];
          s[k + 12 >> 2] = s[N + 12 >> 2];
          s[k + 16 >> 2] = s[N + 16 >> 2];
          s[k + 20 >> 2] = s[N + 20 >> 2];
          s[k + 24 >> 2] = s[N + 24 >> 2];
          s[k + 28 >> 2] = s[N + 28 >> 2];
          Ba(R, k, 136);
          s[W >> 2] = s[R >> 2];
          s[W + 4 >> 2] = s[R + 4 >> 2];
          s[W + 8 >> 2] = s[R + 8 >> 2];
          s[W + 12 >> 2] = s[R + 12 >> 2];
          s[W + 16 >> 2] = s[R + 16 >> 2];
          s[W + 20 >> 2] = s[R + 20 >> 2];
          s[W + 24 >> 2] = s[R + 24 >> 2];
          s[W + 28 >> 2] = s[R + 28 >> 2];
          N = b + 32 | 0;
          s[N >> 2] = s[W >> 2];
          s[N + 4 >> 2] = s[W + 4 >> 2];
          s[N + 8 >> 2] = s[W + 8 >> 2];
          s[N + 12 >> 2] = s[W + 12 >> 2];
          s[N + 16 >> 2] = s[W + 16 >> 2];
          s[N + 20 >> 2] = s[W + 20 >> 2];
          s[N + 24 >> 2] = s[W + 24 >> 2];
          s[N + 28 >> 2] = s[W + 28 >> 2];
          N = e;
          P = b;
          L = N + 64 | 0;

          do {
            s[N >> 2] = s[P >> 2];
            N = N + 4 | 0;
            P = P + 4 | 0;
          } while ((N | 0) < (L | 0));

          N = T;
          P = v;
          L = N + 64 | 0;

          do {
            s[N >> 2] = s[P >> 2];
            N = N + 4 | 0;
            P = P + 4 | 0;
          } while ((N | 0) < (L | 0));

          N = A;
          P = y;
          L = N + 64 | 0;

          do {
            s[N >> 2] = s[P >> 2];
            N = N + 4 | 0;
            P = P + 4 | 0;
          } while ((N | 0) < (L | 0));

          N = I;
          P = b;
          L = N + 64 | 0;

          do {
            s[N >> 2] = s[P >> 2];
            N = N + 4 | 0;
            P = P + 4 | 0;
          } while ((N | 0) < (L | 0));

          s[R >> 2] = s[y >> 2];
          s[R + 4 >> 2] = s[y + 4 >> 2];
          s[R + 8 >> 2] = s[y + 8 >> 2];
          s[R + 12 >> 2] = s[y + 12 >> 2];
          s[R + 16 >> 2] = s[y + 16 >> 2];
          s[R + 20 >> 2] = s[y + 20 >> 2];
          s[R + 24 >> 2] = s[y + 24 >> 2];
          s[R + 28 >> 2] = s[y + 28 >> 2];
          s[k >> 2] = s[b >> 2];
          s[k + 4 >> 2] = s[b + 4 >> 2];
          s[k + 8 >> 2] = s[b + 8 >> 2];
          s[k + 12 >> 2] = s[b + 12 >> 2];
          s[k + 16 >> 2] = s[b + 16 >> 2];
          s[k + 20 >> 2] = s[b + 20 >> 2];
          s[k + 24 >> 2] = s[b + 24 >> 2];
          s[k + 28 >> 2] = s[b + 28 >> 2];
          Ba(R, k, 136);
          s[w >> 2] = s[R >> 2];
          s[w + 4 >> 2] = s[R + 4 >> 2];
          s[w + 8 >> 2] = s[R + 8 >> 2];
          s[w + 12 >> 2] = s[R + 12 >> 2];
          s[w + 16 >> 2] = s[R + 16 >> 2];
          s[w + 20 >> 2] = s[R + 20 >> 2];
          s[w + 24 >> 2] = s[R + 24 >> 2];
          s[w + 28 >> 2] = s[R + 28 >> 2];
          N = A + 32 | 0;
          s[R >> 2] = s[N >> 2];
          s[R + 4 >> 2] = s[N + 4 >> 2];
          s[R + 8 >> 2] = s[N + 8 >> 2];
          s[R + 12 >> 2] = s[N + 12 >> 2];
          s[R + 16 >> 2] = s[N + 16 >> 2];
          s[R + 20 >> 2] = s[N + 20 >> 2];
          s[R + 24 >> 2] = s[N + 24 >> 2];
          s[R + 28 >> 2] = s[N + 28 >> 2];
          N = I + 32 | 0;
          s[k >> 2] = s[N >> 2];
          s[k + 4 >> 2] = s[N + 4 >> 2];
          s[k + 8 >> 2] = s[N + 8 >> 2];
          s[k + 12 >> 2] = s[N + 12 >> 2];
          s[k + 16 >> 2] = s[N + 16 >> 2];
          s[k + 20 >> 2] = s[N + 20 >> 2];
          s[k + 24 >> 2] = s[N + 24 >> 2];
          s[k + 28 >> 2] = s[N + 28 >> 2];
          Ba(R, k, 136);
          s[W >> 2] = s[R >> 2];
          s[W + 4 >> 2] = s[R + 4 >> 2];
          s[W + 8 >> 2] = s[R + 8 >> 2];
          s[W + 12 >> 2] = s[R + 12 >> 2];
          s[W + 16 >> 2] = s[R + 16 >> 2];
          s[W + 20 >> 2] = s[R + 20 >> 2];
          s[W + 24 >> 2] = s[R + 24 >> 2];
          s[W + 28 >> 2] = s[R + 28 >> 2];
          N = w + 32 | 0;
          s[N >> 2] = s[W >> 2];
          s[N + 4 >> 2] = s[W + 4 >> 2];
          s[N + 8 >> 2] = s[W + 8 >> 2];
          s[N + 12 >> 2] = s[W + 12 >> 2];
          s[N + 16 >> 2] = s[W + 16 >> 2];
          s[N + 20 >> 2] = s[W + 20 >> 2];
          s[N + 24 >> 2] = s[W + 24 >> 2];
          s[N + 28 >> 2] = s[W + 28 >> 2];
          Ya(x, T, w);
          N = A;
          P = m;
          L = N + 64 | 0;

          do {
            s[N >> 2] = s[P >> 2];
            N = N + 4 | 0;
            P = P + 4 | 0;
          } while ((N | 0) < (L | 0));

          N = I;
          P = m;
          L = N + 64 | 0;

          do {
            s[N >> 2] = s[P >> 2];
            N = N + 4 | 0;
            P = P + 4 | 0;
          } while ((N | 0) < (L | 0));

          s[R >> 2] = s[A >> 2];
          s[R + 4 >> 2] = s[A + 4 >> 2];
          s[R + 8 >> 2] = s[A + 8 >> 2];
          s[R + 12 >> 2] = s[A + 12 >> 2];
          s[R + 16 >> 2] = s[A + 16 >> 2];
          s[R + 20 >> 2] = s[A + 20 >> 2];
          s[R + 24 >> 2] = s[A + 24 >> 2];
          s[R + 28 >> 2] = s[A + 28 >> 2];
          s[k >> 2] = s[m >> 2];
          s[k + 4 >> 2] = s[m + 4 >> 2];
          s[k + 8 >> 2] = s[m + 8 >> 2];
          s[k + 12 >> 2] = s[m + 12 >> 2];
          s[k + 16 >> 2] = s[m + 16 >> 2];
          s[k + 20 >> 2] = s[m + 20 >> 2];
          s[k + 24 >> 2] = s[m + 24 >> 2];
          s[k + 28 >> 2] = s[m + 28 >> 2];
          Ea(R, k, 136);
          s[w >> 2] = s[R >> 2];
          s[w + 4 >> 2] = s[R + 4 >> 2];
          s[w + 8 >> 2] = s[R + 8 >> 2];
          s[w + 12 >> 2] = s[R + 12 >> 2];
          s[w + 16 >> 2] = s[R + 16 >> 2];
          s[w + 20 >> 2] = s[R + 20 >> 2];
          s[w + 24 >> 2] = s[R + 24 >> 2];
          s[w + 28 >> 2] = s[R + 28 >> 2];
          N = A + 32 | 0;
          s[R >> 2] = s[N >> 2];
          s[R + 4 >> 2] = s[N + 4 >> 2];
          s[R + 8 >> 2] = s[N + 8 >> 2];
          s[R + 12 >> 2] = s[N + 12 >> 2];
          s[R + 16 >> 2] = s[N + 16 >> 2];
          s[R + 20 >> 2] = s[N + 20 >> 2];
          s[R + 24 >> 2] = s[N + 24 >> 2];
          s[R + 28 >> 2] = s[N + 28 >> 2];
          N = I + 32 | 0;
          s[k >> 2] = s[N >> 2];
          s[k + 4 >> 2] = s[N + 4 >> 2];
          s[k + 8 >> 2] = s[N + 8 >> 2];
          s[k + 12 >> 2] = s[N + 12 >> 2];
          s[k + 16 >> 2] = s[N + 16 >> 2];
          s[k + 20 >> 2] = s[N + 20 >> 2];
          s[k + 24 >> 2] = s[N + 24 >> 2];
          s[k + 28 >> 2] = s[N + 28 >> 2];
          Ea(R, k, 136);
          s[W >> 2] = s[R >> 2];
          s[W + 4 >> 2] = s[R + 4 >> 2];
          s[W + 8 >> 2] = s[R + 8 >> 2];
          s[W + 12 >> 2] = s[R + 12 >> 2];
          s[W + 16 >> 2] = s[R + 16 >> 2];
          s[W + 20 >> 2] = s[R + 20 >> 2];
          s[W + 24 >> 2] = s[R + 24 >> 2];
          s[W + 28 >> 2] = s[R + 28 >> 2];
          N = w + 32 | 0;
          s[N >> 2] = s[W >> 2];
          s[N + 4 >> 2] = s[W + 4 >> 2];
          s[N + 8 >> 2] = s[W + 8 >> 2];
          s[N + 12 >> 2] = s[W + 12 >> 2];
          s[N + 16 >> 2] = s[W + 16 >> 2];
          s[N + 20 >> 2] = s[W + 20 >> 2];
          s[N + 24 >> 2] = s[W + 24 >> 2];
          s[N + 28 >> 2] = s[W + 28 >> 2];
          s[R >> 2] = s[x >> 2];
          s[R + 4 >> 2] = s[x + 4 >> 2];
          s[R + 8 >> 2] = s[x + 8 >> 2];
          s[R + 12 >> 2] = s[x + 12 >> 2];
          s[R + 16 >> 2] = s[x + 16 >> 2];
          s[R + 20 >> 2] = s[x + 20 >> 2];
          s[R + 24 >> 2] = s[x + 24 >> 2];
          s[R + 28 >> 2] = s[x + 28 >> 2];
          s[k >> 2] = s[w >> 2];
          s[k + 4 >> 2] = s[w + 4 >> 2];
          s[k + 8 >> 2] = s[w + 8 >> 2];
          s[k + 12 >> 2] = s[w + 12 >> 2];
          s[k + 16 >> 2] = s[w + 16 >> 2];
          s[k + 20 >> 2] = s[w + 20 >> 2];
          s[k + 24 >> 2] = s[w + 24 >> 2];
          s[k + 28 >> 2] = s[w + 28 >> 2];
          Ba(R, k, 136);
          s[S >> 2] = s[R >> 2];
          s[S + 4 >> 2] = s[R + 4 >> 2];
          s[S + 8 >> 2] = s[R + 8 >> 2];
          s[S + 12 >> 2] = s[R + 12 >> 2];
          s[S + 16 >> 2] = s[R + 16 >> 2];
          s[S + 20 >> 2] = s[R + 20 >> 2];
          s[S + 24 >> 2] = s[R + 24 >> 2];
          s[S + 28 >> 2] = s[R + 28 >> 2];
          P = x + 32 | 0;
          s[R >> 2] = s[P >> 2];
          s[R + 4 >> 2] = s[P + 4 >> 2];
          s[R + 8 >> 2] = s[P + 8 >> 2];
          s[R + 12 >> 2] = s[P + 12 >> 2];
          s[R + 16 >> 2] = s[P + 16 >> 2];
          s[R + 20 >> 2] = s[P + 20 >> 2];
          s[R + 24 >> 2] = s[P + 24 >> 2];
          s[R + 28 >> 2] = s[P + 28 >> 2];
          s[k >> 2] = s[N >> 2];
          s[k + 4 >> 2] = s[N + 4 >> 2];
          s[k + 8 >> 2] = s[N + 8 >> 2];
          s[k + 12 >> 2] = s[N + 12 >> 2];
          s[k + 16 >> 2] = s[N + 16 >> 2];
          s[k + 20 >> 2] = s[N + 20 >> 2];
          s[k + 24 >> 2] = s[N + 24 >> 2];
          s[k + 28 >> 2] = s[N + 28 >> 2];
          Ba(R, k, 136);
          s[W >> 2] = s[R >> 2];
          s[W + 4 >> 2] = s[R + 4 >> 2];
          s[W + 8 >> 2] = s[R + 8 >> 2];
          s[W + 12 >> 2] = s[R + 12 >> 2];
          s[W + 16 >> 2] = s[R + 16 >> 2];
          s[W + 20 >> 2] = s[R + 20 >> 2];
          s[W + 24 >> 2] = s[R + 24 >> 2];
          s[W + 28 >> 2] = s[R + 28 >> 2];
          N = S + 32 | 0;
          s[N >> 2] = s[W >> 2];
          s[N + 4 >> 2] = s[W + 4 >> 2];
          s[N + 8 >> 2] = s[W + 8 >> 2];
          s[N + 12 >> 2] = s[W + 12 >> 2];
          s[N + 16 >> 2] = s[W + 16 >> 2];
          s[N + 20 >> 2] = s[W + 20 >> 2];
          s[N + 24 >> 2] = s[W + 24 >> 2];
          s[N + 28 >> 2] = s[W + 28 >> 2];
          N = A;
          P = g;
          L = N + 64 | 0;

          do {
            s[N >> 2] = s[P >> 2];
            N = N + 4 | 0;
            P = P + 4 | 0;
          } while ((N | 0) < (L | 0));

          N = I;
          P = h;
          L = N + 64 | 0;

          do {
            s[N >> 2] = s[P >> 2];
            N = N + 4 | 0;
            P = P + 4 | 0;
          } while ((N | 0) < (L | 0));

          s[R >> 2] = s[g >> 2];
          s[R + 4 >> 2] = s[g + 4 >> 2];
          s[R + 8 >> 2] = s[g + 8 >> 2];
          s[R + 12 >> 2] = s[g + 12 >> 2];
          s[R + 16 >> 2] = s[g + 16 >> 2];
          s[R + 20 >> 2] = s[g + 20 >> 2];
          s[R + 24 >> 2] = s[g + 24 >> 2];
          s[R + 28 >> 2] = s[g + 28 >> 2];
          s[k >> 2] = s[h >> 2];
          s[k + 4 >> 2] = s[h + 4 >> 2];
          s[k + 8 >> 2] = s[h + 8 >> 2];
          s[k + 12 >> 2] = s[h + 12 >> 2];
          s[k + 16 >> 2] = s[h + 16 >> 2];
          s[k + 20 >> 2] = s[h + 20 >> 2];
          s[k + 24 >> 2] = s[h + 24 >> 2];
          s[k + 28 >> 2] = s[h + 28 >> 2];
          Ea(R, k, 136);
          s[w >> 2] = s[R >> 2];
          s[w + 4 >> 2] = s[R + 4 >> 2];
          s[w + 8 >> 2] = s[R + 8 >> 2];
          s[w + 12 >> 2] = s[R + 12 >> 2];
          s[w + 16 >> 2] = s[R + 16 >> 2];
          s[w + 20 >> 2] = s[R + 20 >> 2];
          s[w + 24 >> 2] = s[R + 24 >> 2];
          s[w + 28 >> 2] = s[R + 28 >> 2];
          N = A + 32 | 0;
          s[R >> 2] = s[N >> 2];
          s[R + 4 >> 2] = s[N + 4 >> 2];
          s[R + 8 >> 2] = s[N + 8 >> 2];
          s[R + 12 >> 2] = s[N + 12 >> 2];
          s[R + 16 >> 2] = s[N + 16 >> 2];
          s[R + 20 >> 2] = s[N + 20 >> 2];
          s[R + 24 >> 2] = s[N + 24 >> 2];
          s[R + 28 >> 2] = s[N + 28 >> 2];
          N = I + 32 | 0;
          s[k >> 2] = s[N >> 2];
          s[k + 4 >> 2] = s[N + 4 >> 2];
          s[k + 8 >> 2] = s[N + 8 >> 2];
          s[k + 12 >> 2] = s[N + 12 >> 2];
          s[k + 16 >> 2] = s[N + 16 >> 2];
          s[k + 20 >> 2] = s[N + 20 >> 2];
          s[k + 24 >> 2] = s[N + 24 >> 2];
          s[k + 28 >> 2] = s[N + 28 >> 2];
          Ea(R, k, 136);
          s[W >> 2] = s[R >> 2];
          s[W + 4 >> 2] = s[R + 4 >> 2];
          s[W + 8 >> 2] = s[R + 8 >> 2];
          s[W + 12 >> 2] = s[R + 12 >> 2];
          s[W + 16 >> 2] = s[R + 16 >> 2];
          s[W + 20 >> 2] = s[R + 20 >> 2];
          s[W + 24 >> 2] = s[R + 24 >> 2];
          s[W + 28 >> 2] = s[R + 28 >> 2];
          N = w + 32 | 0;
          s[N >> 2] = s[W >> 2];
          s[N + 4 >> 2] = s[W + 4 >> 2];
          s[N + 8 >> 2] = s[W + 8 >> 2];
          s[N + 12 >> 2] = s[W + 12 >> 2];
          s[N + 16 >> 2] = s[W + 16 >> 2];
          s[N + 20 >> 2] = s[W + 20 >> 2];
          s[N + 24 >> 2] = s[W + 24 >> 2];
          s[N + 28 >> 2] = s[W + 28 >> 2];
          Za(T, w);
          N = I;
          P = _;
          L = N + 64 | 0;

          do {
            s[N >> 2] = s[P >> 2];
            N = N + 4 | 0;
            P = P + 4 | 0;
          } while ((N | 0) < (L | 0));

          s[R >> 2] = s[T >> 2];
          s[R + 4 >> 2] = s[T + 4 >> 2];
          s[R + 8 >> 2] = s[T + 8 >> 2];
          s[R + 12 >> 2] = s[T + 12 >> 2];
          s[R + 16 >> 2] = s[T + 16 >> 2];
          s[R + 20 >> 2] = s[T + 20 >> 2];
          s[R + 24 >> 2] = s[T + 24 >> 2];
          s[R + 28 >> 2] = s[T + 28 >> 2];
          s[k >> 2] = s[_ >> 2];
          s[k + 4 >> 2] = s[_ + 4 >> 2];
          s[k + 8 >> 2] = s[_ + 8 >> 2];
          s[k + 12 >> 2] = s[_ + 12 >> 2];
          s[k + 16 >> 2] = s[_ + 16 >> 2];
          s[k + 20 >> 2] = s[_ + 20 >> 2];
          s[k + 24 >> 2] = s[_ + 24 >> 2];
          s[k + 28 >> 2] = s[_ + 28 >> 2];
          Ba(R, k, 136);
          s[x >> 2] = s[R >> 2];
          s[x + 4 >> 2] = s[R + 4 >> 2];
          s[x + 8 >> 2] = s[R + 8 >> 2];
          s[x + 12 >> 2] = s[R + 12 >> 2];
          s[x + 16 >> 2] = s[R + 16 >> 2];
          s[x + 20 >> 2] = s[R + 20 >> 2];
          s[x + 24 >> 2] = s[R + 24 >> 2];
          s[x + 28 >> 2] = s[R + 28 >> 2];
          t = T + 32 | 0;
          s[R >> 2] = s[t >> 2];
          s[R + 4 >> 2] = s[t + 4 >> 2];
          s[R + 8 >> 2] = s[t + 8 >> 2];
          s[R + 12 >> 2] = s[t + 12 >> 2];
          s[R + 16 >> 2] = s[t + 16 >> 2];
          s[R + 20 >> 2] = s[t + 20 >> 2];
          s[R + 24 >> 2] = s[t + 24 >> 2];
          s[R + 28 >> 2] = s[t + 28 >> 2];
          t = I + 32 | 0;
          s[k >> 2] = s[t >> 2];
          s[k + 4 >> 2] = s[t + 4 >> 2];
          s[k + 8 >> 2] = s[t + 8 >> 2];
          s[k + 12 >> 2] = s[t + 12 >> 2];
          s[k + 16 >> 2] = s[t + 16 >> 2];
          s[k + 20 >> 2] = s[t + 20 >> 2];
          s[k + 24 >> 2] = s[t + 24 >> 2];
          s[k + 28 >> 2] = s[t + 28 >> 2];
          Ba(R, k, 136);
          s[W >> 2] = s[R >> 2];
          s[W + 4 >> 2] = s[R + 4 >> 2];
          s[W + 8 >> 2] = s[R + 8 >> 2];
          s[W + 12 >> 2] = s[R + 12 >> 2];
          s[W + 16 >> 2] = s[R + 16 >> 2];
          s[W + 20 >> 2] = s[R + 20 >> 2];
          s[W + 24 >> 2] = s[R + 24 >> 2];
          s[W + 28 >> 2] = s[R + 28 >> 2];
          t = x + 32 | 0;
          s[t >> 2] = s[W >> 2];
          s[t + 4 >> 2] = s[W + 4 >> 2];
          s[t + 8 >> 2] = s[W + 8 >> 2];
          s[t + 12 >> 2] = s[W + 12 >> 2];
          s[t + 16 >> 2] = s[W + 16 >> 2];
          s[t + 20 >> 2] = s[W + 20 >> 2];
          s[t + 24 >> 2] = s[W + 24 >> 2];
          s[t + 28 >> 2] = s[W + 28 >> 2];
          N = I;
          P = B;
          L = N + 64 | 0;

          do {
            s[N >> 2] = s[P >> 2];
            N = N + 4 | 0;
            P = P + 4 | 0;
          } while ((N | 0) < (L | 0));

          s[R >> 2] = s[x >> 2];
          s[R + 4 >> 2] = s[x + 4 >> 2];
          s[R + 8 >> 2] = s[x + 8 >> 2];
          s[R + 12 >> 2] = s[x + 12 >> 2];
          s[R + 16 >> 2] = s[x + 16 >> 2];
          s[R + 20 >> 2] = s[x + 20 >> 2];
          s[R + 24 >> 2] = s[x + 24 >> 2];
          s[R + 28 >> 2] = s[x + 28 >> 2];
          s[k >> 2] = s[B >> 2];
          s[k + 4 >> 2] = s[B + 4 >> 2];
          s[k + 8 >> 2] = s[B + 8 >> 2];
          s[k + 12 >> 2] = s[B + 12 >> 2];
          s[k + 16 >> 2] = s[B + 16 >> 2];
          s[k + 20 >> 2] = s[B + 20 >> 2];
          s[k + 24 >> 2] = s[B + 24 >> 2];
          s[k + 28 >> 2] = s[B + 28 >> 2];
          Ba(R, k, 136);
          s[D >> 2] = s[R >> 2];
          s[D + 4 >> 2] = s[R + 4 >> 2];
          s[D + 8 >> 2] = s[R + 8 >> 2];
          s[D + 12 >> 2] = s[R + 12 >> 2];
          s[D + 16 >> 2] = s[R + 16 >> 2];
          s[D + 20 >> 2] = s[R + 20 >> 2];
          s[D + 24 >> 2] = s[R + 24 >> 2];
          s[D + 28 >> 2] = s[R + 28 >> 2];
          s[R >> 2] = s[t >> 2];
          s[R + 4 >> 2] = s[t + 4 >> 2];
          s[R + 8 >> 2] = s[t + 8 >> 2];
          s[R + 12 >> 2] = s[t + 12 >> 2];
          s[R + 16 >> 2] = s[t + 16 >> 2];
          s[R + 20 >> 2] = s[t + 20 >> 2];
          s[R + 24 >> 2] = s[t + 24 >> 2];
          s[R + 28 >> 2] = s[t + 28 >> 2];
          N = I + 32 | 0;
          s[k >> 2] = s[N >> 2];
          s[k + 4 >> 2] = s[N + 4 >> 2];
          s[k + 8 >> 2] = s[N + 8 >> 2];
          s[k + 12 >> 2] = s[N + 12 >> 2];
          s[k + 16 >> 2] = s[N + 16 >> 2];
          s[k + 20 >> 2] = s[N + 20 >> 2];
          s[k + 24 >> 2] = s[N + 24 >> 2];
          s[k + 28 >> 2] = s[N + 28 >> 2];
          Ba(R, k, 136);
          s[W >> 2] = s[R >> 2];
          s[W + 4 >> 2] = s[R + 4 >> 2];
          s[W + 8 >> 2] = s[R + 8 >> 2];
          s[W + 12 >> 2] = s[R + 12 >> 2];
          s[W + 16 >> 2] = s[R + 16 >> 2];
          s[W + 20 >> 2] = s[R + 20 >> 2];
          s[W + 24 >> 2] = s[R + 24 >> 2];
          s[W + 28 >> 2] = s[R + 28 >> 2];
          N = D + 32 | 0;
          s[N >> 2] = s[W >> 2];
          s[N + 4 >> 2] = s[W + 4 >> 2];
          s[N + 8 >> 2] = s[W + 8 >> 2];
          s[N + 12 >> 2] = s[W + 12 >> 2];
          s[N + 16 >> 2] = s[W + 16 >> 2];
          s[N + 20 >> 2] = s[W + 20 >> 2];
          s[N + 24 >> 2] = s[W + 24 >> 2];
          s[N + 28 >> 2] = s[W + 28 >> 2];
          N = k;
          P = E;
          L = N + 64 | 0;

          do {
            s[N >> 2] = s[P >> 2];
            N = N + 4 | 0;
            P = P + 4 | 0;
          } while ((N | 0) < (L | 0));

          Ya(C, D, k);
          N = e + 64 | 0;
          P = S;
          L = N + 64 | 0;

          do {
            s[N >> 2] = s[P >> 2];
            N = N + 4 | 0;
            P = P + 4 | 0;
          } while ((N | 0) < (L | 0));

          N = e + 128 | 0;
          P = C;
          L = N + 64 | 0;

          do {
            s[N >> 2] = s[P >> 2];
            N = N + 4 | 0;
            P = P + 4 | 0;
          } while ((N | 0) < (L | 0));
        }
        p = M;
        return;
      }

      function ma(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0,
            A = 0,
            w = 0,
            T = 0,
            x = 0,
            D = 0,
            C = 0;
        x = p;
        p = p + 1120 | 0;
        h = x + 1056 | 0;
        m = x + 992 | 0;
        y = x + 960 | 0;
        v = x + 896 | 0;
        _ = x + 832 | 0;
        g = x + 768 | 0;
        A = x + 704 | 0;
        w = x + 640 | 0;
        i = x + 576 | 0;
        c = x + 512 | 0;
        u = x + 448 | 0;
        d = x + 384 | 0;
        r = x + 320 | 0;
        f = x + 256 | 0;
        l = x + 192 | 0;
        n = x + 128 | 0;
        a = x + 64 | 0;
        o = x;
        Za(o, t);
        b = t + 64 | 0;
        Za(a, b);
        Za(n, a);
        T = _;
        D = t;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        T = v;
        D = a;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        s[m >> 2] = s[t >> 2];
        s[m + 4 >> 2] = s[t + 4 >> 2];
        s[m + 8 >> 2] = s[t + 8 >> 2];
        s[m + 12 >> 2] = s[t + 12 >> 2];
        s[m + 16 >> 2] = s[t + 16 >> 2];
        s[m + 20 >> 2] = s[t + 20 >> 2];
        s[m + 24 >> 2] = s[t + 24 >> 2];
        s[m + 28 >> 2] = s[t + 28 >> 2];
        s[h >> 2] = s[a >> 2];
        s[h + 4 >> 2] = s[a + 4 >> 2];
        s[h + 8 >> 2] = s[a + 8 >> 2];
        s[h + 12 >> 2] = s[a + 12 >> 2];
        s[h + 16 >> 2] = s[a + 16 >> 2];
        s[h + 20 >> 2] = s[a + 20 >> 2];
        s[h + 24 >> 2] = s[a + 24 >> 2];
        s[h + 28 >> 2] = s[a + 28 >> 2];
        Ea(m, h, 136);
        s[g >> 2] = s[m >> 2];
        s[g + 4 >> 2] = s[m + 4 >> 2];
        s[g + 8 >> 2] = s[m + 8 >> 2];
        s[g + 12 >> 2] = s[m + 12 >> 2];
        s[g + 16 >> 2] = s[m + 16 >> 2];
        s[g + 20 >> 2] = s[m + 20 >> 2];
        s[g + 24 >> 2] = s[m + 24 >> 2];
        s[g + 28 >> 2] = s[m + 28 >> 2];
        T = _ + 32 | 0;
        s[m >> 2] = s[T >> 2];
        s[m + 4 >> 2] = s[T + 4 >> 2];
        s[m + 8 >> 2] = s[T + 8 >> 2];
        s[m + 12 >> 2] = s[T + 12 >> 2];
        s[m + 16 >> 2] = s[T + 16 >> 2];
        s[m + 20 >> 2] = s[T + 20 >> 2];
        s[m + 24 >> 2] = s[T + 24 >> 2];
        s[m + 28 >> 2] = s[T + 28 >> 2];
        T = v + 32 | 0;
        s[h >> 2] = s[T >> 2];
        s[h + 4 >> 2] = s[T + 4 >> 2];
        s[h + 8 >> 2] = s[T + 8 >> 2];
        s[h + 12 >> 2] = s[T + 12 >> 2];
        s[h + 16 >> 2] = s[T + 16 >> 2];
        s[h + 20 >> 2] = s[T + 20 >> 2];
        s[h + 24 >> 2] = s[T + 24 >> 2];
        s[h + 28 >> 2] = s[T + 28 >> 2];
        Ea(m, h, 136);
        s[y >> 2] = s[m >> 2];
        s[y + 4 >> 2] = s[m + 4 >> 2];
        s[y + 8 >> 2] = s[m + 8 >> 2];
        s[y + 12 >> 2] = s[m + 12 >> 2];
        s[y + 16 >> 2] = s[m + 16 >> 2];
        s[y + 20 >> 2] = s[m + 20 >> 2];
        s[y + 24 >> 2] = s[m + 24 >> 2];
        s[y + 28 >> 2] = s[m + 28 >> 2];
        T = g + 32 | 0;
        s[T >> 2] = s[y >> 2];
        s[T + 4 >> 2] = s[y + 4 >> 2];
        s[T + 8 >> 2] = s[y + 8 >> 2];
        s[T + 12 >> 2] = s[y + 12 >> 2];
        s[T + 16 >> 2] = s[y + 16 >> 2];
        s[T + 20 >> 2] = s[y + 20 >> 2];
        s[T + 24 >> 2] = s[y + 24 >> 2];
        s[T + 28 >> 2] = s[y + 28 >> 2];
        Za(A, g);
        T = v;
        D = o;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        s[m >> 2] = s[A >> 2];
        s[m + 4 >> 2] = s[A + 4 >> 2];
        s[m + 8 >> 2] = s[A + 8 >> 2];
        s[m + 12 >> 2] = s[A + 12 >> 2];
        s[m + 16 >> 2] = s[A + 16 >> 2];
        s[m + 20 >> 2] = s[A + 20 >> 2];
        s[m + 24 >> 2] = s[A + 24 >> 2];
        s[m + 28 >> 2] = s[A + 28 >> 2];
        s[h >> 2] = s[o >> 2];
        s[h + 4 >> 2] = s[o + 4 >> 2];
        s[h + 8 >> 2] = s[o + 8 >> 2];
        s[h + 12 >> 2] = s[o + 12 >> 2];
        s[h + 16 >> 2] = s[o + 16 >> 2];
        s[h + 20 >> 2] = s[o + 20 >> 2];
        s[h + 24 >> 2] = s[o + 24 >> 2];
        s[h + 28 >> 2] = s[o + 28 >> 2];
        Ba(m, h, 136);
        s[w >> 2] = s[m >> 2];
        s[w + 4 >> 2] = s[m + 4 >> 2];
        s[w + 8 >> 2] = s[m + 8 >> 2];
        s[w + 12 >> 2] = s[m + 12 >> 2];
        s[w + 16 >> 2] = s[m + 16 >> 2];
        s[w + 20 >> 2] = s[m + 20 >> 2];
        s[w + 24 >> 2] = s[m + 24 >> 2];
        s[w + 28 >> 2] = s[m + 28 >> 2];
        a = A + 32 | 0;
        s[m >> 2] = s[a >> 2];
        s[m + 4 >> 2] = s[a + 4 >> 2];
        s[m + 8 >> 2] = s[a + 8 >> 2];
        s[m + 12 >> 2] = s[a + 12 >> 2];
        s[m + 16 >> 2] = s[a + 16 >> 2];
        s[m + 20 >> 2] = s[a + 20 >> 2];
        s[m + 24 >> 2] = s[a + 24 >> 2];
        s[m + 28 >> 2] = s[a + 28 >> 2];
        a = v + 32 | 0;
        s[h >> 2] = s[a >> 2];
        s[h + 4 >> 2] = s[a + 4 >> 2];
        s[h + 8 >> 2] = s[a + 8 >> 2];
        s[h + 12 >> 2] = s[a + 12 >> 2];
        s[h + 16 >> 2] = s[a + 16 >> 2];
        s[h + 20 >> 2] = s[a + 20 >> 2];
        s[h + 24 >> 2] = s[a + 24 >> 2];
        s[h + 28 >> 2] = s[a + 28 >> 2];
        Ba(m, h, 136);
        s[y >> 2] = s[m >> 2];
        s[y + 4 >> 2] = s[m + 4 >> 2];
        s[y + 8 >> 2] = s[m + 8 >> 2];
        s[y + 12 >> 2] = s[m + 12 >> 2];
        s[y + 16 >> 2] = s[m + 16 >> 2];
        s[y + 20 >> 2] = s[m + 20 >> 2];
        s[y + 24 >> 2] = s[m + 24 >> 2];
        s[y + 28 >> 2] = s[m + 28 >> 2];
        a = w + 32 | 0;
        s[a >> 2] = s[y >> 2];
        s[a + 4 >> 2] = s[y + 4 >> 2];
        s[a + 8 >> 2] = s[y + 8 >> 2];
        s[a + 12 >> 2] = s[y + 12 >> 2];
        s[a + 16 >> 2] = s[y + 16 >> 2];
        s[a + 20 >> 2] = s[y + 20 >> 2];
        s[a + 24 >> 2] = s[y + 24 >> 2];
        s[a + 28 >> 2] = s[y + 28 >> 2];
        T = v;
        D = n;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        s[m >> 2] = s[w >> 2];
        s[m + 4 >> 2] = s[w + 4 >> 2];
        s[m + 8 >> 2] = s[w + 8 >> 2];
        s[m + 12 >> 2] = s[w + 12 >> 2];
        s[m + 16 >> 2] = s[w + 16 >> 2];
        s[m + 20 >> 2] = s[w + 20 >> 2];
        s[m + 24 >> 2] = s[w + 24 >> 2];
        s[m + 28 >> 2] = s[w + 28 >> 2];
        s[h >> 2] = s[n >> 2];
        s[h + 4 >> 2] = s[n + 4 >> 2];
        s[h + 8 >> 2] = s[n + 8 >> 2];
        s[h + 12 >> 2] = s[n + 12 >> 2];
        s[h + 16 >> 2] = s[n + 16 >> 2];
        s[h + 20 >> 2] = s[n + 20 >> 2];
        s[h + 24 >> 2] = s[n + 24 >> 2];
        s[h + 28 >> 2] = s[n + 28 >> 2];
        Ba(m, h, 136);
        s[l >> 2] = s[m >> 2];
        s[l + 4 >> 2] = s[m + 4 >> 2];
        s[l + 8 >> 2] = s[m + 8 >> 2];
        s[l + 12 >> 2] = s[m + 12 >> 2];
        s[l + 16 >> 2] = s[m + 16 >> 2];
        s[l + 20 >> 2] = s[m + 20 >> 2];
        s[l + 24 >> 2] = s[m + 24 >> 2];
        s[l + 28 >> 2] = s[m + 28 >> 2];
        s[m >> 2] = s[a >> 2];
        s[m + 4 >> 2] = s[a + 4 >> 2];
        s[m + 8 >> 2] = s[a + 8 >> 2];
        s[m + 12 >> 2] = s[a + 12 >> 2];
        s[m + 16 >> 2] = s[a + 16 >> 2];
        s[m + 20 >> 2] = s[a + 20 >> 2];
        s[m + 24 >> 2] = s[a + 24 >> 2];
        s[m + 28 >> 2] = s[a + 28 >> 2];
        a = v + 32 | 0;
        s[h >> 2] = s[a >> 2];
        s[h + 4 >> 2] = s[a + 4 >> 2];
        s[h + 8 >> 2] = s[a + 8 >> 2];
        s[h + 12 >> 2] = s[a + 12 >> 2];
        s[h + 16 >> 2] = s[a + 16 >> 2];
        s[h + 20 >> 2] = s[a + 20 >> 2];
        s[h + 24 >> 2] = s[a + 24 >> 2];
        s[h + 28 >> 2] = s[a + 28 >> 2];
        Ba(m, h, 136);
        s[y >> 2] = s[m >> 2];
        s[y + 4 >> 2] = s[m + 4 >> 2];
        s[y + 8 >> 2] = s[m + 8 >> 2];
        s[y + 12 >> 2] = s[m + 12 >> 2];
        s[y + 16 >> 2] = s[m + 16 >> 2];
        s[y + 20 >> 2] = s[m + 20 >> 2];
        s[y + 24 >> 2] = s[m + 24 >> 2];
        s[y + 28 >> 2] = s[m + 28 >> 2];
        a = l + 32 | 0;
        s[a >> 2] = s[y >> 2];
        s[a + 4 >> 2] = s[y + 4 >> 2];
        s[a + 8 >> 2] = s[y + 8 >> 2];
        s[a + 12 >> 2] = s[y + 12 >> 2];
        s[a + 16 >> 2] = s[y + 16 >> 2];
        s[a + 20 >> 2] = s[y + 20 >> 2];
        s[a + 24 >> 2] = s[y + 24 >> 2];
        s[a + 28 >> 2] = s[y + 28 >> 2];
        T = _;
        D = l;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        T = v;
        D = l;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        s[m >> 2] = s[_ >> 2];
        s[m + 4 >> 2] = s[_ + 4 >> 2];
        s[m + 8 >> 2] = s[_ + 8 >> 2];
        s[m + 12 >> 2] = s[_ + 12 >> 2];
        s[m + 16 >> 2] = s[_ + 16 >> 2];
        s[m + 20 >> 2] = s[_ + 20 >> 2];
        s[m + 24 >> 2] = s[_ + 24 >> 2];
        s[m + 28 >> 2] = s[_ + 28 >> 2];
        s[h >> 2] = s[l >> 2];
        s[h + 4 >> 2] = s[l + 4 >> 2];
        s[h + 8 >> 2] = s[l + 8 >> 2];
        s[h + 12 >> 2] = s[l + 12 >> 2];
        s[h + 16 >> 2] = s[l + 16 >> 2];
        s[h + 20 >> 2] = s[l + 20 >> 2];
        s[h + 24 >> 2] = s[l + 24 >> 2];
        s[h + 28 >> 2] = s[l + 28 >> 2];
        Ea(m, h, 136);
        s[l >> 2] = s[m >> 2];
        s[l + 4 >> 2] = s[m + 4 >> 2];
        s[l + 8 >> 2] = s[m + 8 >> 2];
        s[l + 12 >> 2] = s[m + 12 >> 2];
        s[l + 16 >> 2] = s[m + 16 >> 2];
        s[l + 20 >> 2] = s[m + 20 >> 2];
        s[l + 24 >> 2] = s[m + 24 >> 2];
        s[l + 28 >> 2] = s[m + 28 >> 2];
        T = _ + 32 | 0;
        s[m >> 2] = s[T >> 2];
        s[m + 4 >> 2] = s[T + 4 >> 2];
        s[m + 8 >> 2] = s[T + 8 >> 2];
        s[m + 12 >> 2] = s[T + 12 >> 2];
        s[m + 16 >> 2] = s[T + 16 >> 2];
        s[m + 20 >> 2] = s[T + 20 >> 2];
        s[m + 24 >> 2] = s[T + 24 >> 2];
        s[m + 28 >> 2] = s[T + 28 >> 2];
        T = v + 32 | 0;
        s[h >> 2] = s[T >> 2];
        s[h + 4 >> 2] = s[T + 4 >> 2];
        s[h + 8 >> 2] = s[T + 8 >> 2];
        s[h + 12 >> 2] = s[T + 12 >> 2];
        s[h + 16 >> 2] = s[T + 16 >> 2];
        s[h + 20 >> 2] = s[T + 20 >> 2];
        s[h + 24 >> 2] = s[T + 24 >> 2];
        s[h + 28 >> 2] = s[T + 28 >> 2];
        Ea(m, h, 136);
        s[y >> 2] = s[m >> 2];
        s[y + 4 >> 2] = s[m + 4 >> 2];
        s[y + 8 >> 2] = s[m + 8 >> 2];
        s[y + 12 >> 2] = s[m + 12 >> 2];
        s[y + 16 >> 2] = s[m + 16 >> 2];
        s[y + 20 >> 2] = s[m + 20 >> 2];
        s[y + 24 >> 2] = s[m + 24 >> 2];
        s[y + 28 >> 2] = s[m + 28 >> 2];
        s[a >> 2] = s[y >> 2];
        s[a + 4 >> 2] = s[y + 4 >> 2];
        s[a + 8 >> 2] = s[y + 8 >> 2];
        s[a + 12 >> 2] = s[y + 12 >> 2];
        s[a + 16 >> 2] = s[y + 16 >> 2];
        s[a + 20 >> 2] = s[y + 20 >> 2];
        s[a + 24 >> 2] = s[y + 24 >> 2];
        s[a + 28 >> 2] = s[y + 28 >> 2];
        T = _;
        D = o;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        T = v;
        D = o;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        s[m >> 2] = s[_ >> 2];
        s[m + 4 >> 2] = s[_ + 4 >> 2];
        s[m + 8 >> 2] = s[_ + 8 >> 2];
        s[m + 12 >> 2] = s[_ + 12 >> 2];
        s[m + 16 >> 2] = s[_ + 16 >> 2];
        s[m + 20 >> 2] = s[_ + 20 >> 2];
        s[m + 24 >> 2] = s[_ + 24 >> 2];
        s[m + 28 >> 2] = s[_ + 28 >> 2];
        s[h >> 2] = s[o >> 2];
        s[h + 4 >> 2] = s[o + 4 >> 2];
        s[h + 8 >> 2] = s[o + 8 >> 2];
        s[h + 12 >> 2] = s[o + 12 >> 2];
        s[h + 16 >> 2] = s[o + 16 >> 2];
        s[h + 20 >> 2] = s[o + 20 >> 2];
        s[h + 24 >> 2] = s[o + 24 >> 2];
        s[h + 28 >> 2] = s[o + 28 >> 2];
        Ea(m, h, 136);
        s[g >> 2] = s[m >> 2];
        s[g + 4 >> 2] = s[m + 4 >> 2];
        s[g + 8 >> 2] = s[m + 8 >> 2];
        s[g + 12 >> 2] = s[m + 12 >> 2];
        s[g + 16 >> 2] = s[m + 16 >> 2];
        s[g + 20 >> 2] = s[m + 20 >> 2];
        s[g + 24 >> 2] = s[m + 24 >> 2];
        s[g + 28 >> 2] = s[m + 28 >> 2];
        a = _ + 32 | 0;
        s[m >> 2] = s[a >> 2];
        s[m + 4 >> 2] = s[a + 4 >> 2];
        s[m + 8 >> 2] = s[a + 8 >> 2];
        s[m + 12 >> 2] = s[a + 12 >> 2];
        s[m + 16 >> 2] = s[a + 16 >> 2];
        s[m + 20 >> 2] = s[a + 20 >> 2];
        s[m + 24 >> 2] = s[a + 24 >> 2];
        s[m + 28 >> 2] = s[a + 28 >> 2];
        a = v + 32 | 0;
        s[h >> 2] = s[a >> 2];
        s[h + 4 >> 2] = s[a + 4 >> 2];
        s[h + 8 >> 2] = s[a + 8 >> 2];
        s[h + 12 >> 2] = s[a + 12 >> 2];
        s[h + 16 >> 2] = s[a + 16 >> 2];
        s[h + 20 >> 2] = s[a + 20 >> 2];
        s[h + 24 >> 2] = s[a + 24 >> 2];
        s[h + 28 >> 2] = s[a + 28 >> 2];
        Ea(m, h, 136);
        s[y >> 2] = s[m >> 2];
        s[y + 4 >> 2] = s[m + 4 >> 2];
        s[y + 8 >> 2] = s[m + 8 >> 2];
        s[y + 12 >> 2] = s[m + 12 >> 2];
        s[y + 16 >> 2] = s[m + 16 >> 2];
        s[y + 20 >> 2] = s[m + 20 >> 2];
        s[y + 24 >> 2] = s[m + 24 >> 2];
        s[y + 28 >> 2] = s[m + 28 >> 2];
        a = g + 32 | 0;
        s[a >> 2] = s[y >> 2];
        s[a + 4 >> 2] = s[y + 4 >> 2];
        s[a + 8 >> 2] = s[y + 8 >> 2];
        s[a + 12 >> 2] = s[y + 12 >> 2];
        s[a + 16 >> 2] = s[y + 16 >> 2];
        s[a + 20 >> 2] = s[y + 20 >> 2];
        s[a + 24 >> 2] = s[y + 24 >> 2];
        s[a + 28 >> 2] = s[y + 28 >> 2];
        T = v;
        D = o;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        s[m >> 2] = s[g >> 2];
        s[m + 4 >> 2] = s[g + 4 >> 2];
        s[m + 8 >> 2] = s[g + 8 >> 2];
        s[m + 12 >> 2] = s[g + 12 >> 2];
        s[m + 16 >> 2] = s[g + 16 >> 2];
        s[m + 20 >> 2] = s[g + 20 >> 2];
        s[m + 24 >> 2] = s[g + 24 >> 2];
        s[m + 28 >> 2] = s[g + 28 >> 2];
        s[h >> 2] = s[o >> 2];
        s[h + 4 >> 2] = s[o + 4 >> 2];
        s[h + 8 >> 2] = s[o + 8 >> 2];
        s[h + 12 >> 2] = s[o + 12 >> 2];
        s[h + 16 >> 2] = s[o + 16 >> 2];
        s[h + 20 >> 2] = s[o + 20 >> 2];
        s[h + 24 >> 2] = s[o + 24 >> 2];
        s[h + 28 >> 2] = s[o + 28 >> 2];
        Ea(m, h, 136);
        s[f >> 2] = s[m >> 2];
        s[f + 4 >> 2] = s[m + 4 >> 2];
        s[f + 8 >> 2] = s[m + 8 >> 2];
        s[f + 12 >> 2] = s[m + 12 >> 2];
        s[f + 16 >> 2] = s[m + 16 >> 2];
        s[f + 20 >> 2] = s[m + 20 >> 2];
        s[f + 24 >> 2] = s[m + 24 >> 2];
        s[f + 28 >> 2] = s[m + 28 >> 2];
        s[m >> 2] = s[a >> 2];
        s[m + 4 >> 2] = s[a + 4 >> 2];
        s[m + 8 >> 2] = s[a + 8 >> 2];
        s[m + 12 >> 2] = s[a + 12 >> 2];
        s[m + 16 >> 2] = s[a + 16 >> 2];
        s[m + 20 >> 2] = s[a + 20 >> 2];
        s[m + 24 >> 2] = s[a + 24 >> 2];
        s[m + 28 >> 2] = s[a + 28 >> 2];
        T = v + 32 | 0;
        s[h >> 2] = s[T >> 2];
        s[h + 4 >> 2] = s[T + 4 >> 2];
        s[h + 8 >> 2] = s[T + 8 >> 2];
        s[h + 12 >> 2] = s[T + 12 >> 2];
        s[h + 16 >> 2] = s[T + 16 >> 2];
        s[h + 20 >> 2] = s[T + 20 >> 2];
        s[h + 24 >> 2] = s[T + 24 >> 2];
        s[h + 28 >> 2] = s[T + 28 >> 2];
        Ea(m, h, 136);
        s[y >> 2] = s[m >> 2];
        s[y + 4 >> 2] = s[m + 4 >> 2];
        s[y + 8 >> 2] = s[m + 8 >> 2];
        s[y + 12 >> 2] = s[m + 12 >> 2];
        s[y + 16 >> 2] = s[m + 16 >> 2];
        s[y + 20 >> 2] = s[m + 20 >> 2];
        s[y + 24 >> 2] = s[m + 24 >> 2];
        s[y + 28 >> 2] = s[m + 28 >> 2];
        T = f + 32 | 0;
        s[T >> 2] = s[y >> 2];
        s[T + 4 >> 2] = s[y + 4 >> 2];
        s[T + 8 >> 2] = s[y + 8 >> 2];
        s[T + 12 >> 2] = s[y + 12 >> 2];
        s[T + 16 >> 2] = s[y + 16 >> 2];
        s[T + 20 >> 2] = s[y + 20 >> 2];
        s[T + 24 >> 2] = s[y + 24 >> 2];
        s[T + 28 >> 2] = s[y + 28 >> 2];
        Za(r, f);
        T = A;
        D = r;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        T = _;
        D = l;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        T = v;
        D = l;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        s[m >> 2] = s[_ >> 2];
        s[m + 4 >> 2] = s[_ + 4 >> 2];
        s[m + 8 >> 2] = s[_ + 8 >> 2];
        s[m + 12 >> 2] = s[_ + 12 >> 2];
        s[m + 16 >> 2] = s[_ + 16 >> 2];
        s[m + 20 >> 2] = s[_ + 20 >> 2];
        s[m + 24 >> 2] = s[_ + 24 >> 2];
        s[m + 28 >> 2] = s[_ + 28 >> 2];
        s[h >> 2] = s[l >> 2];
        s[h + 4 >> 2] = s[l + 4 >> 2];
        s[h + 8 >> 2] = s[l + 8 >> 2];
        s[h + 12 >> 2] = s[l + 12 >> 2];
        s[h + 16 >> 2] = s[l + 16 >> 2];
        s[h + 20 >> 2] = s[l + 20 >> 2];
        s[h + 24 >> 2] = s[l + 24 >> 2];
        s[h + 28 >> 2] = s[l + 28 >> 2];
        Ea(m, h, 136);
        s[g >> 2] = s[m >> 2];
        s[g + 4 >> 2] = s[m + 4 >> 2];
        s[g + 8 >> 2] = s[m + 8 >> 2];
        s[g + 12 >> 2] = s[m + 12 >> 2];
        s[g + 16 >> 2] = s[m + 16 >> 2];
        s[g + 20 >> 2] = s[m + 20 >> 2];
        s[g + 24 >> 2] = s[m + 24 >> 2];
        s[g + 28 >> 2] = s[m + 28 >> 2];
        T = _ + 32 | 0;
        s[m >> 2] = s[T >> 2];
        s[m + 4 >> 2] = s[T + 4 >> 2];
        s[m + 8 >> 2] = s[T + 8 >> 2];
        s[m + 12 >> 2] = s[T + 12 >> 2];
        s[m + 16 >> 2] = s[T + 16 >> 2];
        s[m + 20 >> 2] = s[T + 20 >> 2];
        s[m + 24 >> 2] = s[T + 24 >> 2];
        s[m + 28 >> 2] = s[T + 28 >> 2];
        T = v + 32 | 0;
        s[h >> 2] = s[T >> 2];
        s[h + 4 >> 2] = s[T + 4 >> 2];
        s[h + 8 >> 2] = s[T + 8 >> 2];
        s[h + 12 >> 2] = s[T + 12 >> 2];
        s[h + 16 >> 2] = s[T + 16 >> 2];
        s[h + 20 >> 2] = s[T + 20 >> 2];
        s[h + 24 >> 2] = s[T + 24 >> 2];
        s[h + 28 >> 2] = s[T + 28 >> 2];
        Ea(m, h, 136);
        s[y >> 2] = s[m >> 2];
        s[y + 4 >> 2] = s[m + 4 >> 2];
        s[y + 8 >> 2] = s[m + 8 >> 2];
        s[y + 12 >> 2] = s[m + 12 >> 2];
        s[y + 16 >> 2] = s[m + 16 >> 2];
        s[y + 20 >> 2] = s[m + 20 >> 2];
        s[y + 24 >> 2] = s[m + 24 >> 2];
        s[y + 28 >> 2] = s[m + 28 >> 2];
        T = g + 32 | 0;
        s[T >> 2] = s[y >> 2];
        s[T + 4 >> 2] = s[y + 4 >> 2];
        s[T + 8 >> 2] = s[y + 8 >> 2];
        s[T + 12 >> 2] = s[y + 12 >> 2];
        s[T + 16 >> 2] = s[y + 16 >> 2];
        s[T + 20 >> 2] = s[y + 20 >> 2];
        s[T + 24 >> 2] = s[y + 24 >> 2];
        s[T + 28 >> 2] = s[y + 28 >> 2];
        s[m >> 2] = s[r >> 2];
        s[m + 4 >> 2] = s[r + 4 >> 2];
        s[m + 8 >> 2] = s[r + 8 >> 2];
        s[m + 12 >> 2] = s[r + 12 >> 2];
        s[m + 16 >> 2] = s[r + 16 >> 2];
        s[m + 20 >> 2] = s[r + 20 >> 2];
        s[m + 24 >> 2] = s[r + 24 >> 2];
        s[m + 28 >> 2] = s[r + 28 >> 2];
        s[h >> 2] = s[g >> 2];
        s[h + 4 >> 2] = s[g + 4 >> 2];
        s[h + 8 >> 2] = s[g + 8 >> 2];
        s[h + 12 >> 2] = s[g + 12 >> 2];
        s[h + 16 >> 2] = s[g + 16 >> 2];
        s[h + 20 >> 2] = s[g + 20 >> 2];
        s[h + 24 >> 2] = s[g + 24 >> 2];
        s[h + 28 >> 2] = s[g + 28 >> 2];
        Ba(m, h, 136);
        s[d >> 2] = s[m >> 2];
        s[d + 4 >> 2] = s[m + 4 >> 2];
        s[d + 8 >> 2] = s[m + 8 >> 2];
        s[d + 12 >> 2] = s[m + 12 >> 2];
        s[d + 16 >> 2] = s[m + 16 >> 2];
        s[d + 20 >> 2] = s[m + 20 >> 2];
        s[d + 24 >> 2] = s[m + 24 >> 2];
        s[d + 28 >> 2] = s[m + 28 >> 2];
        D = A + 32 | 0;
        s[m >> 2] = s[D >> 2];
        s[m + 4 >> 2] = s[D + 4 >> 2];
        s[m + 8 >> 2] = s[D + 8 >> 2];
        s[m + 12 >> 2] = s[D + 12 >> 2];
        s[m + 16 >> 2] = s[D + 16 >> 2];
        s[m + 20 >> 2] = s[D + 20 >> 2];
        s[m + 24 >> 2] = s[D + 24 >> 2];
        s[m + 28 >> 2] = s[D + 28 >> 2];
        s[h >> 2] = s[T >> 2];
        s[h + 4 >> 2] = s[T + 4 >> 2];
        s[h + 8 >> 2] = s[T + 8 >> 2];
        s[h + 12 >> 2] = s[T + 12 >> 2];
        s[h + 16 >> 2] = s[T + 16 >> 2];
        s[h + 20 >> 2] = s[T + 20 >> 2];
        s[h + 24 >> 2] = s[T + 24 >> 2];
        s[h + 28 >> 2] = s[T + 28 >> 2];
        Ba(m, h, 136);
        s[y >> 2] = s[m >> 2];
        s[y + 4 >> 2] = s[m + 4 >> 2];
        s[y + 8 >> 2] = s[m + 8 >> 2];
        s[y + 12 >> 2] = s[m + 12 >> 2];
        s[y + 16 >> 2] = s[m + 16 >> 2];
        s[y + 20 >> 2] = s[m + 20 >> 2];
        s[y + 24 >> 2] = s[m + 24 >> 2];
        s[y + 28 >> 2] = s[m + 28 >> 2];
        T = d + 32 | 0;
        s[T >> 2] = s[y >> 2];
        s[T + 4 >> 2] = s[y + 4 >> 2];
        s[T + 8 >> 2] = s[y + 8 >> 2];
        s[T + 12 >> 2] = s[y + 12 >> 2];
        s[T + 16 >> 2] = s[y + 16 >> 2];
        s[T + 20 >> 2] = s[y + 20 >> 2];
        s[T + 24 >> 2] = s[y + 24 >> 2];
        s[T + 28 >> 2] = s[y + 28 >> 2];
        T = _;
        D = n;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        T = v;
        D = n;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        s[m >> 2] = s[_ >> 2];
        s[m + 4 >> 2] = s[_ + 4 >> 2];
        s[m + 8 >> 2] = s[_ + 8 >> 2];
        s[m + 12 >> 2] = s[_ + 12 >> 2];
        s[m + 16 >> 2] = s[_ + 16 >> 2];
        s[m + 20 >> 2] = s[_ + 20 >> 2];
        s[m + 24 >> 2] = s[_ + 24 >> 2];
        s[m + 28 >> 2] = s[_ + 28 >> 2];
        s[h >> 2] = s[n >> 2];
        s[h + 4 >> 2] = s[n + 4 >> 2];
        s[h + 8 >> 2] = s[n + 8 >> 2];
        s[h + 12 >> 2] = s[n + 12 >> 2];
        s[h + 16 >> 2] = s[n + 16 >> 2];
        s[h + 20 >> 2] = s[n + 20 >> 2];
        s[h + 24 >> 2] = s[n + 24 >> 2];
        s[h + 28 >> 2] = s[n + 28 >> 2];
        Ea(m, h, 136);
        s[u >> 2] = s[m >> 2];
        s[u + 4 >> 2] = s[m + 4 >> 2];
        s[u + 8 >> 2] = s[m + 8 >> 2];
        s[u + 12 >> 2] = s[m + 12 >> 2];
        s[u + 16 >> 2] = s[m + 16 >> 2];
        s[u + 20 >> 2] = s[m + 20 >> 2];
        s[u + 24 >> 2] = s[m + 24 >> 2];
        s[u + 28 >> 2] = s[m + 28 >> 2];
        a = _ + 32 | 0;
        s[m >> 2] = s[a >> 2];
        s[m + 4 >> 2] = s[a + 4 >> 2];
        s[m + 8 >> 2] = s[a + 8 >> 2];
        s[m + 12 >> 2] = s[a + 12 >> 2];
        s[m + 16 >> 2] = s[a + 16 >> 2];
        s[m + 20 >> 2] = s[a + 20 >> 2];
        s[m + 24 >> 2] = s[a + 24 >> 2];
        s[m + 28 >> 2] = s[a + 28 >> 2];
        a = v + 32 | 0;
        s[h >> 2] = s[a >> 2];
        s[h + 4 >> 2] = s[a + 4 >> 2];
        s[h + 8 >> 2] = s[a + 8 >> 2];
        s[h + 12 >> 2] = s[a + 12 >> 2];
        s[h + 16 >> 2] = s[a + 16 >> 2];
        s[h + 20 >> 2] = s[a + 20 >> 2];
        s[h + 24 >> 2] = s[a + 24 >> 2];
        s[h + 28 >> 2] = s[a + 28 >> 2];
        Ea(m, h, 136);
        s[y >> 2] = s[m >> 2];
        s[y + 4 >> 2] = s[m + 4 >> 2];
        s[y + 8 >> 2] = s[m + 8 >> 2];
        s[y + 12 >> 2] = s[m + 12 >> 2];
        s[y + 16 >> 2] = s[m + 16 >> 2];
        s[y + 20 >> 2] = s[m + 20 >> 2];
        s[y + 24 >> 2] = s[m + 24 >> 2];
        s[y + 28 >> 2] = s[m + 28 >> 2];
        a = u + 32 | 0;
        s[a >> 2] = s[y >> 2];
        s[a + 4 >> 2] = s[y + 4 >> 2];
        s[a + 8 >> 2] = s[y + 8 >> 2];
        s[a + 12 >> 2] = s[y + 12 >> 2];
        s[a + 16 >> 2] = s[y + 16 >> 2];
        s[a + 20 >> 2] = s[y + 20 >> 2];
        s[a + 24 >> 2] = s[y + 24 >> 2];
        s[a + 28 >> 2] = s[y + 28 >> 2];
        T = _;
        D = u;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        T = v;
        D = u;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        s[m >> 2] = s[_ >> 2];
        s[m + 4 >> 2] = s[_ + 4 >> 2];
        s[m + 8 >> 2] = s[_ + 8 >> 2];
        s[m + 12 >> 2] = s[_ + 12 >> 2];
        s[m + 16 >> 2] = s[_ + 16 >> 2];
        s[m + 20 >> 2] = s[_ + 20 >> 2];
        s[m + 24 >> 2] = s[_ + 24 >> 2];
        s[m + 28 >> 2] = s[_ + 28 >> 2];
        s[h >> 2] = s[u >> 2];
        s[h + 4 >> 2] = s[u + 4 >> 2];
        s[h + 8 >> 2] = s[u + 8 >> 2];
        s[h + 12 >> 2] = s[u + 12 >> 2];
        s[h + 16 >> 2] = s[u + 16 >> 2];
        s[h + 20 >> 2] = s[u + 20 >> 2];
        s[h + 24 >> 2] = s[u + 24 >> 2];
        s[h + 28 >> 2] = s[u + 28 >> 2];
        Ea(m, h, 136);
        s[u >> 2] = s[m >> 2];
        s[u + 4 >> 2] = s[m + 4 >> 2];
        s[u + 8 >> 2] = s[m + 8 >> 2];
        s[u + 12 >> 2] = s[m + 12 >> 2];
        s[u + 16 >> 2] = s[m + 16 >> 2];
        s[u + 20 >> 2] = s[m + 20 >> 2];
        s[u + 24 >> 2] = s[m + 24 >> 2];
        s[u + 28 >> 2] = s[m + 28 >> 2];
        T = _ + 32 | 0;
        s[m >> 2] = s[T >> 2];
        s[m + 4 >> 2] = s[T + 4 >> 2];
        s[m + 8 >> 2] = s[T + 8 >> 2];
        s[m + 12 >> 2] = s[T + 12 >> 2];
        s[m + 16 >> 2] = s[T + 16 >> 2];
        s[m + 20 >> 2] = s[T + 20 >> 2];
        s[m + 24 >> 2] = s[T + 24 >> 2];
        s[m + 28 >> 2] = s[T + 28 >> 2];
        T = v + 32 | 0;
        s[h >> 2] = s[T >> 2];
        s[h + 4 >> 2] = s[T + 4 >> 2];
        s[h + 8 >> 2] = s[T + 8 >> 2];
        s[h + 12 >> 2] = s[T + 12 >> 2];
        s[h + 16 >> 2] = s[T + 16 >> 2];
        s[h + 20 >> 2] = s[T + 20 >> 2];
        s[h + 24 >> 2] = s[T + 24 >> 2];
        s[h + 28 >> 2] = s[T + 28 >> 2];
        Ea(m, h, 136);
        s[y >> 2] = s[m >> 2];
        s[y + 4 >> 2] = s[m + 4 >> 2];
        s[y + 8 >> 2] = s[m + 8 >> 2];
        s[y + 12 >> 2] = s[m + 12 >> 2];
        s[y + 16 >> 2] = s[m + 16 >> 2];
        s[y + 20 >> 2] = s[m + 20 >> 2];
        s[y + 24 >> 2] = s[m + 24 >> 2];
        s[y + 28 >> 2] = s[m + 28 >> 2];
        s[a >> 2] = s[y >> 2];
        s[a + 4 >> 2] = s[y + 4 >> 2];
        s[a + 8 >> 2] = s[y + 8 >> 2];
        s[a + 12 >> 2] = s[y + 12 >> 2];
        s[a + 16 >> 2] = s[y + 16 >> 2];
        s[a + 20 >> 2] = s[y + 20 >> 2];
        s[a + 24 >> 2] = s[y + 24 >> 2];
        s[a + 28 >> 2] = s[y + 28 >> 2];
        T = _;
        D = u;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        T = v;
        D = u;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        s[m >> 2] = s[_ >> 2];
        s[m + 4 >> 2] = s[_ + 4 >> 2];
        s[m + 8 >> 2] = s[_ + 8 >> 2];
        s[m + 12 >> 2] = s[_ + 12 >> 2];
        s[m + 16 >> 2] = s[_ + 16 >> 2];
        s[m + 20 >> 2] = s[_ + 20 >> 2];
        s[m + 24 >> 2] = s[_ + 24 >> 2];
        s[m + 28 >> 2] = s[_ + 28 >> 2];
        s[h >> 2] = s[u >> 2];
        s[h + 4 >> 2] = s[u + 4 >> 2];
        s[h + 8 >> 2] = s[u + 8 >> 2];
        s[h + 12 >> 2] = s[u + 12 >> 2];
        s[h + 16 >> 2] = s[u + 16 >> 2];
        s[h + 20 >> 2] = s[u + 20 >> 2];
        s[h + 24 >> 2] = s[u + 24 >> 2];
        s[h + 28 >> 2] = s[u + 28 >> 2];
        Ea(m, h, 136);
        s[u >> 2] = s[m >> 2];
        s[u + 4 >> 2] = s[m + 4 >> 2];
        s[u + 8 >> 2] = s[m + 8 >> 2];
        s[u + 12 >> 2] = s[m + 12 >> 2];
        s[u + 16 >> 2] = s[m + 16 >> 2];
        s[u + 20 >> 2] = s[m + 20 >> 2];
        s[u + 24 >> 2] = s[m + 24 >> 2];
        s[u + 28 >> 2] = s[m + 28 >> 2];
        T = _ + 32 | 0;
        s[m >> 2] = s[T >> 2];
        s[m + 4 >> 2] = s[T + 4 >> 2];
        s[m + 8 >> 2] = s[T + 8 >> 2];
        s[m + 12 >> 2] = s[T + 12 >> 2];
        s[m + 16 >> 2] = s[T + 16 >> 2];
        s[m + 20 >> 2] = s[T + 20 >> 2];
        s[m + 24 >> 2] = s[T + 24 >> 2];
        s[m + 28 >> 2] = s[T + 28 >> 2];
        T = v + 32 | 0;
        s[h >> 2] = s[T >> 2];
        s[h + 4 >> 2] = s[T + 4 >> 2];
        s[h + 8 >> 2] = s[T + 8 >> 2];
        s[h + 12 >> 2] = s[T + 12 >> 2];
        s[h + 16 >> 2] = s[T + 16 >> 2];
        s[h + 20 >> 2] = s[T + 20 >> 2];
        s[h + 24 >> 2] = s[T + 24 >> 2];
        s[h + 28 >> 2] = s[T + 28 >> 2];
        Ea(m, h, 136);
        s[y >> 2] = s[m >> 2];
        s[y + 4 >> 2] = s[m + 4 >> 2];
        s[y + 8 >> 2] = s[m + 8 >> 2];
        s[y + 12 >> 2] = s[m + 12 >> 2];
        s[y + 16 >> 2] = s[m + 16 >> 2];
        s[y + 20 >> 2] = s[m + 20 >> 2];
        s[y + 24 >> 2] = s[m + 24 >> 2];
        s[y + 28 >> 2] = s[m + 28 >> 2];
        s[a >> 2] = s[y >> 2];
        s[a + 4 >> 2] = s[y + 4 >> 2];
        s[a + 8 >> 2] = s[y + 8 >> 2];
        s[a + 12 >> 2] = s[y + 12 >> 2];
        s[a + 16 >> 2] = s[y + 16 >> 2];
        s[a + 20 >> 2] = s[y + 20 >> 2];
        s[a + 24 >> 2] = s[y + 24 >> 2];
        s[a + 28 >> 2] = s[y + 28 >> 2];
        T = m;
        D = b;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        T = h;
        D = t + 128 | 0;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        Ya(c, m, h);
        T = e;
        D = d;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        T = A;
        D = f;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        T = _;
        D = l;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        T = v;
        D = d;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        s[m >> 2] = s[l >> 2];
        s[m + 4 >> 2] = s[l + 4 >> 2];
        s[m + 8 >> 2] = s[l + 8 >> 2];
        s[m + 12 >> 2] = s[l + 12 >> 2];
        s[m + 16 >> 2] = s[l + 16 >> 2];
        s[m + 20 >> 2] = s[l + 20 >> 2];
        s[m + 24 >> 2] = s[l + 24 >> 2];
        s[m + 28 >> 2] = s[l + 28 >> 2];
        s[h >> 2] = s[d >> 2];
        s[h + 4 >> 2] = s[d + 4 >> 2];
        s[h + 8 >> 2] = s[d + 8 >> 2];
        s[h + 12 >> 2] = s[d + 12 >> 2];
        s[h + 16 >> 2] = s[d + 16 >> 2];
        s[h + 20 >> 2] = s[d + 20 >> 2];
        s[h + 24 >> 2] = s[d + 24 >> 2];
        s[h + 28 >> 2] = s[d + 28 >> 2];
        Ba(m, h, 136);
        s[g >> 2] = s[m >> 2];
        s[g + 4 >> 2] = s[m + 4 >> 2];
        s[g + 8 >> 2] = s[m + 8 >> 2];
        s[g + 12 >> 2] = s[m + 12 >> 2];
        s[g + 16 >> 2] = s[m + 16 >> 2];
        s[g + 20 >> 2] = s[m + 20 >> 2];
        s[g + 24 >> 2] = s[m + 24 >> 2];
        s[g + 28 >> 2] = s[m + 28 >> 2];
        T = _ + 32 | 0;
        s[m >> 2] = s[T >> 2];
        s[m + 4 >> 2] = s[T + 4 >> 2];
        s[m + 8 >> 2] = s[T + 8 >> 2];
        s[m + 12 >> 2] = s[T + 12 >> 2];
        s[m + 16 >> 2] = s[T + 16 >> 2];
        s[m + 20 >> 2] = s[T + 20 >> 2];
        s[m + 24 >> 2] = s[T + 24 >> 2];
        s[m + 28 >> 2] = s[T + 28 >> 2];
        T = v + 32 | 0;
        s[h >> 2] = s[T >> 2];
        s[h + 4 >> 2] = s[T + 4 >> 2];
        s[h + 8 >> 2] = s[T + 8 >> 2];
        s[h + 12 >> 2] = s[T + 12 >> 2];
        s[h + 16 >> 2] = s[T + 16 >> 2];
        s[h + 20 >> 2] = s[T + 20 >> 2];
        s[h + 24 >> 2] = s[T + 24 >> 2];
        s[h + 28 >> 2] = s[T + 28 >> 2];
        Ba(m, h, 136);
        s[y >> 2] = s[m >> 2];
        s[y + 4 >> 2] = s[m + 4 >> 2];
        s[y + 8 >> 2] = s[m + 8 >> 2];
        s[y + 12 >> 2] = s[m + 12 >> 2];
        s[y + 16 >> 2] = s[m + 16 >> 2];
        s[y + 20 >> 2] = s[m + 20 >> 2];
        s[y + 24 >> 2] = s[m + 24 >> 2];
        s[y + 28 >> 2] = s[m + 28 >> 2];
        T = g + 32 | 0;
        s[T >> 2] = s[y >> 2];
        s[T + 4 >> 2] = s[y + 4 >> 2];
        s[T + 8 >> 2] = s[y + 8 >> 2];
        s[T + 12 >> 2] = s[y + 12 >> 2];
        s[T + 16 >> 2] = s[y + 16 >> 2];
        s[T + 20 >> 2] = s[y + 20 >> 2];
        s[T + 24 >> 2] = s[y + 24 >> 2];
        s[T + 28 >> 2] = s[y + 28 >> 2];
        Ya(w, A, g);
        T = v;
        D = u;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        s[m >> 2] = s[w >> 2];
        s[m + 4 >> 2] = s[w + 4 >> 2];
        s[m + 8 >> 2] = s[w + 8 >> 2];
        s[m + 12 >> 2] = s[w + 12 >> 2];
        s[m + 16 >> 2] = s[w + 16 >> 2];
        s[m + 20 >> 2] = s[w + 20 >> 2];
        s[m + 24 >> 2] = s[w + 24 >> 2];
        s[m + 28 >> 2] = s[w + 28 >> 2];
        s[h >> 2] = s[u >> 2];
        s[h + 4 >> 2] = s[u + 4 >> 2];
        s[h + 8 >> 2] = s[u + 8 >> 2];
        s[h + 12 >> 2] = s[u + 12 >> 2];
        s[h + 16 >> 2] = s[u + 16 >> 2];
        s[h + 20 >> 2] = s[u + 20 >> 2];
        s[h + 24 >> 2] = s[u + 24 >> 2];
        s[h + 28 >> 2] = s[u + 28 >> 2];
        Ba(m, h, 136);
        s[i >> 2] = s[m >> 2];
        s[i + 4 >> 2] = s[m + 4 >> 2];
        s[i + 8 >> 2] = s[m + 8 >> 2];
        s[i + 12 >> 2] = s[m + 12 >> 2];
        s[i + 16 >> 2] = s[m + 16 >> 2];
        s[i + 20 >> 2] = s[m + 20 >> 2];
        s[i + 24 >> 2] = s[m + 24 >> 2];
        s[i + 28 >> 2] = s[m + 28 >> 2];
        T = w + 32 | 0;
        s[m >> 2] = s[T >> 2];
        s[m + 4 >> 2] = s[T + 4 >> 2];
        s[m + 8 >> 2] = s[T + 8 >> 2];
        s[m + 12 >> 2] = s[T + 12 >> 2];
        s[m + 16 >> 2] = s[T + 16 >> 2];
        s[m + 20 >> 2] = s[T + 20 >> 2];
        s[m + 24 >> 2] = s[T + 24 >> 2];
        s[m + 28 >> 2] = s[T + 28 >> 2];
        T = v + 32 | 0;
        s[h >> 2] = s[T >> 2];
        s[h + 4 >> 2] = s[T + 4 >> 2];
        s[h + 8 >> 2] = s[T + 8 >> 2];
        s[h + 12 >> 2] = s[T + 12 >> 2];
        s[h + 16 >> 2] = s[T + 16 >> 2];
        s[h + 20 >> 2] = s[T + 20 >> 2];
        s[h + 24 >> 2] = s[T + 24 >> 2];
        s[h + 28 >> 2] = s[T + 28 >> 2];
        Ba(m, h, 136);
        s[y >> 2] = s[m >> 2];
        s[y + 4 >> 2] = s[m + 4 >> 2];
        s[y + 8 >> 2] = s[m + 8 >> 2];
        s[y + 12 >> 2] = s[m + 12 >> 2];
        s[y + 16 >> 2] = s[m + 16 >> 2];
        s[y + 20 >> 2] = s[m + 20 >> 2];
        s[y + 24 >> 2] = s[m + 24 >> 2];
        s[y + 28 >> 2] = s[m + 28 >> 2];
        T = i + 32 | 0;
        s[T >> 2] = s[y >> 2];
        s[T + 4 >> 2] = s[y + 4 >> 2];
        s[T + 8 >> 2] = s[y + 8 >> 2];
        s[T + 12 >> 2] = s[y + 12 >> 2];
        s[T + 16 >> 2] = s[y + 16 >> 2];
        s[T + 20 >> 2] = s[y + 20 >> 2];
        s[T + 24 >> 2] = s[y + 24 >> 2];
        s[T + 28 >> 2] = s[y + 28 >> 2];
        T = _;
        D = c;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        T = v;
        D = c;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        s[m >> 2] = s[_ >> 2];
        s[m + 4 >> 2] = s[_ + 4 >> 2];
        s[m + 8 >> 2] = s[_ + 8 >> 2];
        s[m + 12 >> 2] = s[_ + 12 >> 2];
        s[m + 16 >> 2] = s[_ + 16 >> 2];
        s[m + 20 >> 2] = s[_ + 20 >> 2];
        s[m + 24 >> 2] = s[_ + 24 >> 2];
        s[m + 28 >> 2] = s[_ + 28 >> 2];
        s[h >> 2] = s[c >> 2];
        s[h + 4 >> 2] = s[c + 4 >> 2];
        s[h + 8 >> 2] = s[c + 8 >> 2];
        s[h + 12 >> 2] = s[c + 12 >> 2];
        s[h + 16 >> 2] = s[c + 16 >> 2];
        s[h + 20 >> 2] = s[c + 20 >> 2];
        s[h + 24 >> 2] = s[c + 24 >> 2];
        s[h + 28 >> 2] = s[c + 28 >> 2];
        Ea(m, h, 136);
        s[g >> 2] = s[m >> 2];
        s[g + 4 >> 2] = s[m + 4 >> 2];
        s[g + 8 >> 2] = s[m + 8 >> 2];
        s[g + 12 >> 2] = s[m + 12 >> 2];
        s[g + 16 >> 2] = s[m + 16 >> 2];
        s[g + 20 >> 2] = s[m + 20 >> 2];
        s[g + 24 >> 2] = s[m + 24 >> 2];
        s[g + 28 >> 2] = s[m + 28 >> 2];
        T = _ + 32 | 0;
        s[m >> 2] = s[T >> 2];
        s[m + 4 >> 2] = s[T + 4 >> 2];
        s[m + 8 >> 2] = s[T + 8 >> 2];
        s[m + 12 >> 2] = s[T + 12 >> 2];
        s[m + 16 >> 2] = s[T + 16 >> 2];
        s[m + 20 >> 2] = s[T + 20 >> 2];
        s[m + 24 >> 2] = s[T + 24 >> 2];
        s[m + 28 >> 2] = s[T + 28 >> 2];
        T = v + 32 | 0;
        s[h >> 2] = s[T >> 2];
        s[h + 4 >> 2] = s[T + 4 >> 2];
        s[h + 8 >> 2] = s[T + 8 >> 2];
        s[h + 12 >> 2] = s[T + 12 >> 2];
        s[h + 16 >> 2] = s[T + 16 >> 2];
        s[h + 20 >> 2] = s[T + 20 >> 2];
        s[h + 24 >> 2] = s[T + 24 >> 2];
        s[h + 28 >> 2] = s[T + 28 >> 2];
        Ea(m, h, 136);
        s[y >> 2] = s[m >> 2];
        s[y + 4 >> 2] = s[m + 4 >> 2];
        s[y + 8 >> 2] = s[m + 8 >> 2];
        s[y + 12 >> 2] = s[m + 12 >> 2];
        s[y + 16 >> 2] = s[m + 16 >> 2];
        s[y + 20 >> 2] = s[m + 20 >> 2];
        s[y + 24 >> 2] = s[m + 24 >> 2];
        s[y + 28 >> 2] = s[m + 28 >> 2];
        T = g + 32 | 0;
        s[T >> 2] = s[y >> 2];
        s[T + 4 >> 2] = s[y + 4 >> 2];
        s[T + 8 >> 2] = s[y + 8 >> 2];
        s[T + 12 >> 2] = s[y + 12 >> 2];
        s[T + 16 >> 2] = s[y + 16 >> 2];
        s[T + 20 >> 2] = s[y + 20 >> 2];
        s[T + 24 >> 2] = s[y + 24 >> 2];
        s[T + 28 >> 2] = s[y + 28 >> 2];
        T = e + 64 | 0;
        D = i;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        T = e + 128 | 0;
        D = g;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        p = x;
        return;
      }

      function ya(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0;
        b = p;
        p = p + 656 | 0;
        o = b + 520 | 0;
        i = b + 448 | 0;
        c = b + 384 | 0;
        u = b + 320 | 0;
        d = b + 256 | 0;
        f = b + 128 | 0;
        l = b + 64 | 0;
        h = b;
        n = t + 128 | 0;
        a = n;

        if ((((((((s[a >> 2] | 0) == 0 & (s[a + 4 >> 2] | 0) == 0 ? (a = t + 136 | 0, (s[a >> 2] | 0) == 0 & (s[a + 4 >> 2] | 0) == 0) : 0) ? (a = t + 144 | 0, (s[a >> 2] | 0) == 0 & (s[a + 4 >> 2] | 0) == 0) : 0) ? (a = t + 152 | 0, (s[a >> 2] | 0) == 0 & (s[a + 4 >> 2] | 0) == 0) : 0) ? (a = t + 160 | 0, (s[a >> 2] | 0) == 0 & (s[a + 4 >> 2] | 0) == 0) : 0) ? (a = t + 168 | 0, (s[a >> 2] | 0) == 0 & (s[a + 4 >> 2] | 0) == 0) : 0) ? (a = t + 176 | 0, (s[a >> 2] | 0) == 0 & (s[a + 4 >> 2] | 0) == 0) : 0) ? (a = t + 184 | 0, (s[a >> 2] | 0) == 0 & (s[a + 4 >> 2] | 0) == 0) : 0) {
          h = e;
          s[h >> 2] = 0;
          s[h + 4 >> 2] = 0;
          p = b;
          return;
        }

        a = o;
        s[a >> 2] = -980480611;
        s[a + 4 >> 2] = -748862579;
        a = o + 8 | 0;
        s[a >> 2] = -171504835;
        s[a + 4 >> 2] = 175696680;
        a = o + 16 | 0;
        s[a >> 2] = 2021213740;
        s[a + 4 >> 2] = 1718526831;
        a = o + 24 | 0;
        s[a >> 2] = -1710760145;
        s[a + 4 >> 2] = 235567041;
        a = o + 32 | 0;
        s[a >> 2] = 0;
        s[a + 4 >> 2] = 0;
        s[a + 8 >> 2] = 0;
        s[a + 12 >> 2] = 0;
        s[a + 16 >> 2] = 0;
        s[a + 20 >> 2] = 0;
        s[a + 24 >> 2] = 0;
        s[a + 28 >> 2] = 0;
        if ((n | 0) != (o | 0) ? (Vu(n, o, 32) | 0) != 0 : 0) a = n;else r = 12;

        do {
          if ((r | 0) == 12) {
            a = t + 160 | 0;
            r = o + 32 | 0;

            if ((a | 0) != (r | 0) ? Vu(a, r, 32) | 0 : 0) {
              a = n;
              break;
            }

            n = o;
            a = t;
            r = n + 64 | 0;

            do {
              s[n >> 2] = s[a >> 2];
              n = n + 4 | 0;
              a = a + 4 | 0;
            } while ((n | 0) < (r | 0));

            n = o + 64 | 0;
            a = t + 64 | 0;
            r = n + 64 | 0;

            do {
              s[n >> 2] = s[a >> 2];
              n = n + 4 | 0;
              a = a + 4 | 0;
            } while ((n | 0) < (r | 0));

            n = e;
            s[n >> 2] = 1;
            s[n + 4 >> 2] = 0;
            n = e + 8 | 0;
            a = o;
            r = n + 128 | 0;

            do {
              s[n >> 2] = s[a >> 2];
              n = n + 4 | 0;
              a = a + 4 | 0;
            } while ((n | 0) < (r | 0));

            p = b;
            return;
          }
        } while (0);

        n = o;
        r = n + 64 | 0;

        do {
          s[n >> 2] = s[a >> 2];
          n = n + 4 | 0;
          a = a + 4 | 0;
        } while ((n | 0) < (r | 0));

        Ja(i, o);
        n = i;
        if (!((s[n >> 2] | 0) == 1 & (s[n + 4 >> 2] | 0) == 0)) Kc(2032);
        n = h;
        a = i + 8 | 0;
        r = n + 64 | 0;

        do {
          s[n >> 2] = s[a >> 2];
          n = n + 4 | 0;
          a = a + 4 | 0;
        } while ((n | 0) < (r | 0));

        Za(l, h);
        n = i;
        a = t;
        r = n + 64 | 0;

        do {
          s[n >> 2] = s[a >> 2];
          n = n + 4 | 0;
          a = a + 4 | 0;
        } while ((n | 0) < (r | 0));

        n = o;
        a = l;
        r = n + 64 | 0;

        do {
          s[n >> 2] = s[a >> 2];
          n = n + 4 | 0;
          a = a + 4 | 0;
        } while ((n | 0) < (r | 0));

        Ya(f, i, o);
        n = u;
        a = t + 64 | 0;
        r = n + 64 | 0;

        do {
          s[n >> 2] = s[a >> 2];
          n = n + 4 | 0;
          a = a + 4 | 0;
        } while ((n | 0) < (r | 0));

        n = i;
        a = l;
        r = n + 64 | 0;

        do {
          s[n >> 2] = s[a >> 2];
          n = n + 4 | 0;
          a = a + 4 | 0;
        } while ((n | 0) < (r | 0));

        n = o;
        a = h;
        r = n + 64 | 0;

        do {
          s[n >> 2] = s[a >> 2];
          n = n + 4 | 0;
          a = a + 4 | 0;
        } while ((n | 0) < (r | 0));

        Ya(c, i, o);
        Ya(d, u, c);
        n = f + 64 | 0;
        a = d;
        r = n + 64 | 0;

        do {
          s[n >> 2] = s[a >> 2];
          n = n + 4 | 0;
          a = a + 4 | 0;
        } while ((n | 0) < (r | 0));

        n = e;
        s[n >> 2] = 1;
        s[n + 4 >> 2] = 0;
        n = e + 8 | 0;
        a = f;
        r = n + 128 | 0;

        do {
          s[n >> 2] = s[a >> 2];
          n = n + 4 | 0;
          a = a + 4 | 0;
        } while ((n | 0) < (r | 0));

        p = b;
        return;
      }

      function va(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0;
        l = p;
        p = p + 320 | 0;
        a = l + 256 | 0;
        n = l + 224 | 0;
        o = l + 192 | 0;
        i = l + 160 | 0;
        c = l + 128 | 0;
        f = l + 64 | 0;
        u = l + 32 | 0;
        d = l;
        r = t + 64 | 0;
        h = r;

        if ((((s[h >> 2] | 0) == 0 & (s[h + 4 >> 2] | 0) == 0 ? (h = t + 72 | 0, (s[h >> 2] | 0) == 0 & (s[h + 4 >> 2] | 0) == 0) : 0) ? (h = t + 80 | 0, (s[h >> 2] | 0) == 0 & (s[h + 4 >> 2] | 0) == 0) : 0) ? (h = t + 88 | 0, (s[h >> 2] | 0) == 0 & (s[h + 4 >> 2] | 0) == 0) : 0) {
          h = e;
          s[h >> 2] = 0;
          s[h + 4 >> 2] = 0;
          p = l;
          return;
        }

        h = a;
        s[h >> 2] = -980480611;
        s[h + 4 >> 2] = -748862579;
        h = a + 8 | 0;
        s[h >> 2] = -171504835;
        s[h + 4 >> 2] = 175696680;
        h = a + 16 | 0;
        s[h >> 2] = 2021213740;
        s[h + 4 >> 2] = 1718526831;
        h = a + 24 | 0;
        s[h >> 2] = -1710760145;
        s[h + 4 >> 2] = 235567041;
        if ((r | 0) != (a | 0)) if (Vu(r, a, 32) | 0) {
          s[a >> 2] = s[r >> 2];
          s[a + 4 >> 2] = s[r + 4 >> 2];
          s[a + 8 >> 2] = s[r + 8 >> 2];
          s[a + 12 >> 2] = s[r + 12 >> 2];
          s[a + 16 >> 2] = s[r + 16 >> 2];
          s[a + 20 >> 2] = s[r + 20 >> 2];
          s[a + 24 >> 2] = s[r + 24 >> 2];
          s[a + 28 >> 2] = s[r + 28 >> 2];
          h = a;
          if ((((s[h >> 2] | 0) == 0 & (s[h + 4 >> 2] | 0) == 0 ? (h = a + 8 | 0, (s[h >> 2] | 0) == 0 & (s[h + 4 >> 2] | 0) == 0) : 0) ? (h = a + 16 | 0, (s[h >> 2] | 0) == 0 & (s[h + 4 >> 2] | 0) == 0) : 0) ? (h = a + 24 | 0, (s[h >> 2] | 0) == 0 & (s[h + 4 >> 2] | 0) == 0) : 0) Kc(2032);
          Wa(a, 136);
          ka(a, 104, 136, -460954743, -2016278654);
          s[d >> 2] = s[a >> 2];
          s[d + 4 >> 2] = s[a + 4 >> 2];
          s[d + 8 >> 2] = s[a + 8 >> 2];
          s[d + 12 >> 2] = s[a + 12 >> 2];
          s[d + 16 >> 2] = s[a + 16 >> 2];
          s[d + 20 >> 2] = s[a + 20 >> 2];
          s[d + 24 >> 2] = s[a + 24 >> 2];
          s[d + 28 >> 2] = s[a + 28 >> 2];
          s[n >> 2] = s[d >> 2];
          s[n + 4 >> 2] = s[d + 4 >> 2];
          s[n + 8 >> 2] = s[d + 8 >> 2];
          s[n + 12 >> 2] = s[d + 12 >> 2];
          s[n + 16 >> 2] = s[d + 16 >> 2];
          s[n + 20 >> 2] = s[d + 20 >> 2];
          s[n + 24 >> 2] = s[d + 24 >> 2];
          s[n + 28 >> 2] = s[d + 28 >> 2];
          s[a >> 2] = s[d >> 2];
          s[a + 4 >> 2] = s[d + 4 >> 2];
          s[a + 8 >> 2] = s[d + 8 >> 2];
          s[a + 12 >> 2] = s[d + 12 >> 2];
          s[a + 16 >> 2] = s[d + 16 >> 2];
          s[a + 20 >> 2] = s[d + 20 >> 2];
          s[a + 24 >> 2] = s[d + 24 >> 2];
          s[a + 28 >> 2] = s[d + 28 >> 2];
          ka(n, a, 136, -460954743, -2016278654);
          s[u >> 2] = s[n >> 2];
          s[u + 4 >> 2] = s[n + 4 >> 2];
          s[u + 8 >> 2] = s[n + 8 >> 2];
          s[u + 12 >> 2] = s[n + 12 >> 2];
          s[u + 16 >> 2] = s[n + 16 >> 2];
          s[u + 20 >> 2] = s[n + 20 >> 2];
          s[u + 24 >> 2] = s[n + 24 >> 2];
          s[u + 28 >> 2] = s[n + 28 >> 2];
          s[n >> 2] = s[t >> 2];
          s[n + 4 >> 2] = s[t + 4 >> 2];
          s[n + 8 >> 2] = s[t + 8 >> 2];
          s[n + 12 >> 2] = s[t + 12 >> 2];
          s[n + 16 >> 2] = s[t + 16 >> 2];
          s[n + 20 >> 2] = s[t + 20 >> 2];
          s[n + 24 >> 2] = s[t + 24 >> 2];
          s[n + 28 >> 2] = s[t + 28 >> 2];
          s[a >> 2] = s[u >> 2];
          s[a + 4 >> 2] = s[u + 4 >> 2];
          s[a + 8 >> 2] = s[u + 8 >> 2];
          s[a + 12 >> 2] = s[u + 12 >> 2];
          s[a + 16 >> 2] = s[u + 16 >> 2];
          s[a + 20 >> 2] = s[u + 20 >> 2];
          s[a + 24 >> 2] = s[u + 24 >> 2];
          s[a + 28 >> 2] = s[u + 28 >> 2];
          ka(n, a, 136, -460954743, -2016278654);
          s[f >> 2] = s[n >> 2];
          s[f + 4 >> 2] = s[n + 4 >> 2];
          s[f + 8 >> 2] = s[n + 8 >> 2];
          s[f + 12 >> 2] = s[n + 12 >> 2];
          s[f + 16 >> 2] = s[n + 16 >> 2];
          s[f + 20 >> 2] = s[n + 20 >> 2];
          s[f + 24 >> 2] = s[n + 24 >> 2];
          s[f + 28 >> 2] = s[n + 28 >> 2];
          t = t + 32 | 0;
          s[i >> 2] = s[t >> 2];
          s[i + 4 >> 2] = s[t + 4 >> 2];
          s[i + 8 >> 2] = s[t + 8 >> 2];
          s[i + 12 >> 2] = s[t + 12 >> 2];
          s[i + 16 >> 2] = s[t + 16 >> 2];
          s[i + 20 >> 2] = s[t + 20 >> 2];
          s[i + 24 >> 2] = s[t + 24 >> 2];
          s[i + 28 >> 2] = s[t + 28 >> 2];
          s[n >> 2] = s[u >> 2];
          s[n + 4 >> 2] = s[u + 4 >> 2];
          s[n + 8 >> 2] = s[u + 8 >> 2];
          s[n + 12 >> 2] = s[u + 12 >> 2];
          s[n + 16 >> 2] = s[u + 16 >> 2];
          s[n + 20 >> 2] = s[u + 20 >> 2];
          s[n + 24 >> 2] = s[u + 24 >> 2];
          s[n + 28 >> 2] = s[u + 28 >> 2];
          s[a >> 2] = s[d >> 2];
          s[a + 4 >> 2] = s[d + 4 >> 2];
          s[a + 8 >> 2] = s[d + 8 >> 2];
          s[a + 12 >> 2] = s[d + 12 >> 2];
          s[a + 16 >> 2] = s[d + 16 >> 2];
          s[a + 20 >> 2] = s[d + 20 >> 2];
          s[a + 24 >> 2] = s[d + 24 >> 2];
          s[a + 28 >> 2] = s[d + 28 >> 2];
          ka(n, a, 136, -460954743, -2016278654);
          s[o >> 2] = s[n >> 2];
          s[o + 4 >> 2] = s[n + 4 >> 2];
          s[o + 8 >> 2] = s[n + 8 >> 2];
          s[o + 12 >> 2] = s[n + 12 >> 2];
          s[o + 16 >> 2] = s[n + 16 >> 2];
          s[o + 20 >> 2] = s[n + 20 >> 2];
          s[o + 24 >> 2] = s[n + 24 >> 2];
          s[o + 28 >> 2] = s[n + 28 >> 2];
          ka(i, o, 136, -460954743, -2016278654);
          s[c >> 2] = s[i >> 2];
          s[c + 4 >> 2] = s[i + 4 >> 2];
          s[c + 8 >> 2] = s[i + 8 >> 2];
          s[c + 12 >> 2] = s[i + 12 >> 2];
          s[c + 16 >> 2] = s[i + 16 >> 2];
          s[c + 20 >> 2] = s[i + 20 >> 2];
          s[c + 24 >> 2] = s[i + 24 >> 2];
          s[c + 28 >> 2] = s[i + 28 >> 2];
          t = f + 32 | 0;
          s[t >> 2] = s[c >> 2];
          s[t + 4 >> 2] = s[c + 4 >> 2];
          s[t + 8 >> 2] = s[c + 8 >> 2];
          s[t + 12 >> 2] = s[c + 12 >> 2];
          s[t + 16 >> 2] = s[c + 16 >> 2];
          s[t + 20 >> 2] = s[c + 20 >> 2];
          s[t + 24 >> 2] = s[c + 24 >> 2];
          s[t + 28 >> 2] = s[c + 28 >> 2];
          t = e;
          s[t >> 2] = 1;
          s[t + 4 >> 2] = 0;
          t = e + 8 | 0;
          a = f;
          e = t + 64 | 0;

          do {
            s[t >> 2] = s[a >> 2];
            t = t + 4 | 0;
            a = a + 4 | 0;
          } while ((t | 0) < (e | 0));

          p = l;
          return;
        }
        s[a >> 2] = s[t >> 2];
        s[a + 4 >> 2] = s[t + 4 >> 2];
        s[a + 8 >> 2] = s[t + 8 >> 2];
        s[a + 12 >> 2] = s[t + 12 >> 2];
        s[a + 16 >> 2] = s[t + 16 >> 2];
        s[a + 20 >> 2] = s[t + 20 >> 2];
        s[a + 24 >> 2] = s[t + 24 >> 2];
        s[a + 28 >> 2] = s[t + 28 >> 2];
        h = t + 32 | 0;
        t = a + 32 | 0;
        s[t >> 2] = s[h >> 2];
        s[t + 4 >> 2] = s[h + 4 >> 2];
        s[t + 8 >> 2] = s[h + 8 >> 2];
        s[t + 12 >> 2] = s[h + 12 >> 2];
        s[t + 16 >> 2] = s[h + 16 >> 2];
        s[t + 20 >> 2] = s[h + 20 >> 2];
        s[t + 24 >> 2] = s[h + 24 >> 2];
        s[t + 28 >> 2] = s[h + 28 >> 2];
        t = e;
        s[t >> 2] = 1;
        s[t + 4 >> 2] = 0;
        t = e + 8 | 0;
        e = t + 64 | 0;

        do {
          s[t >> 2] = s[a >> 2];
          t = t + 4 | 0;
          a = a + 4 | 0;
        } while ((t | 0) < (e | 0));

        p = l;
        return;
      }

      function _a(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0;
        a = p;
        p = p + 480 | 0;
        i = a + 448 | 0;
        o = a + 416 | 0;
        r = a + 384 | 0;
        f = a + 352 | 0;
        u = a + 320 | 0;
        n = a + 288 | 0;
        c = a + 256 | 0;
        d = a + 224 | 0;
        l = a + 192 | 0;
        v = a + 160 | 0;
        b = a + 128 | 0;
        h = a + 96 | 0;
        y = a + 64 | 0;
        g = a + 32 | 0;
        _ = a;
        s[o >> 2] = s[t >> 2];
        s[o + 4 >> 2] = s[t + 4 >> 2];
        s[o + 8 >> 2] = s[t + 8 >> 2];
        s[o + 12 >> 2] = s[t + 12 >> 2];
        s[o + 16 >> 2] = s[t + 16 >> 2];
        s[o + 20 >> 2] = s[t + 20 >> 2];
        s[o + 24 >> 2] = s[t + 24 >> 2];
        s[o + 28 >> 2] = s[t + 28 >> 2];
        s[i >> 2] = s[t >> 2];
        s[i + 4 >> 2] = s[t + 4 >> 2];
        s[i + 8 >> 2] = s[t + 8 >> 2];
        s[i + 12 >> 2] = s[t + 12 >> 2];
        s[i + 16 >> 2] = s[t + 16 >> 2];
        s[i + 20 >> 2] = s[t + 20 >> 2];
        s[i + 24 >> 2] = s[t + 24 >> 2];
        s[i + 28 >> 2] = s[t + 28 >> 2];
        ka(o, i, 136, -460954743, -2016278654);
        s[_ >> 2] = s[o >> 2];
        s[_ + 4 >> 2] = s[o + 4 >> 2];
        s[_ + 8 >> 2] = s[o + 8 >> 2];
        s[_ + 12 >> 2] = s[o + 12 >> 2];
        s[_ + 16 >> 2] = s[o + 16 >> 2];
        s[_ + 20 >> 2] = s[o + 20 >> 2];
        s[_ + 24 >> 2] = s[o + 24 >> 2];
        s[_ + 28 >> 2] = s[o + 28 >> 2];
        m = t + 32 | 0;
        s[o >> 2] = s[m >> 2];
        s[o + 4 >> 2] = s[m + 4 >> 2];
        s[o + 8 >> 2] = s[m + 8 >> 2];
        s[o + 12 >> 2] = s[m + 12 >> 2];
        s[o + 16 >> 2] = s[m + 16 >> 2];
        s[o + 20 >> 2] = s[m + 20 >> 2];
        s[o + 24 >> 2] = s[m + 24 >> 2];
        s[o + 28 >> 2] = s[m + 28 >> 2];
        s[i >> 2] = s[m >> 2];
        s[i + 4 >> 2] = s[m + 4 >> 2];
        s[i + 8 >> 2] = s[m + 8 >> 2];
        s[i + 12 >> 2] = s[m + 12 >> 2];
        s[i + 16 >> 2] = s[m + 16 >> 2];
        s[i + 20 >> 2] = s[m + 20 >> 2];
        s[i + 24 >> 2] = s[m + 24 >> 2];
        s[i + 28 >> 2] = s[m + 28 >> 2];
        ka(o, i, 136, -460954743, -2016278654);
        s[g >> 2] = s[o >> 2];
        s[g + 4 >> 2] = s[o + 4 >> 2];
        s[g + 8 >> 2] = s[o + 8 >> 2];
        s[g + 12 >> 2] = s[o + 12 >> 2];
        s[g + 16 >> 2] = s[o + 16 >> 2];
        s[g + 20 >> 2] = s[o + 20 >> 2];
        s[g + 24 >> 2] = s[o + 24 >> 2];
        s[g + 28 >> 2] = s[o + 28 >> 2];
        s[o >> 2] = s[g >> 2];
        s[o + 4 >> 2] = s[g + 4 >> 2];
        s[o + 8 >> 2] = s[g + 8 >> 2];
        s[o + 12 >> 2] = s[g + 12 >> 2];
        s[o + 16 >> 2] = s[g + 16 >> 2];
        s[o + 20 >> 2] = s[g + 20 >> 2];
        s[o + 24 >> 2] = s[g + 24 >> 2];
        s[o + 28 >> 2] = s[g + 28 >> 2];
        s[i >> 2] = s[g >> 2];
        s[i + 4 >> 2] = s[g + 4 >> 2];
        s[i + 8 >> 2] = s[g + 8 >> 2];
        s[i + 12 >> 2] = s[g + 12 >> 2];
        s[i + 16 >> 2] = s[g + 16 >> 2];
        s[i + 20 >> 2] = s[g + 20 >> 2];
        s[i + 24 >> 2] = s[g + 24 >> 2];
        s[i + 28 >> 2] = s[g + 28 >> 2];
        ka(o, i, 136, -460954743, -2016278654);
        s[y >> 2] = s[o >> 2];
        s[y + 4 >> 2] = s[o + 4 >> 2];
        s[y + 8 >> 2] = s[o + 8 >> 2];
        s[y + 12 >> 2] = s[o + 12 >> 2];
        s[y + 16 >> 2] = s[o + 16 >> 2];
        s[y + 20 >> 2] = s[o + 20 >> 2];
        s[y + 24 >> 2] = s[o + 24 >> 2];
        s[y + 28 >> 2] = s[o + 28 >> 2];
        s[o >> 2] = s[t >> 2];
        s[o + 4 >> 2] = s[t + 4 >> 2];
        s[o + 8 >> 2] = s[t + 8 >> 2];
        s[o + 12 >> 2] = s[t + 12 >> 2];
        s[o + 16 >> 2] = s[t + 16 >> 2];
        s[o + 20 >> 2] = s[t + 20 >> 2];
        s[o + 24 >> 2] = s[t + 24 >> 2];
        s[o + 28 >> 2] = s[t + 28 >> 2];
        s[i >> 2] = s[g >> 2];
        s[i + 4 >> 2] = s[g + 4 >> 2];
        s[i + 8 >> 2] = s[g + 8 >> 2];
        s[i + 12 >> 2] = s[g + 12 >> 2];
        s[i + 16 >> 2] = s[g + 16 >> 2];
        s[i + 20 >> 2] = s[g + 20 >> 2];
        s[i + 24 >> 2] = s[g + 24 >> 2];
        s[i + 28 >> 2] = s[g + 28 >> 2];
        Ea(o, i, 136);
        s[r >> 2] = s[o >> 2];
        s[r + 4 >> 2] = s[o + 4 >> 2];
        s[r + 8 >> 2] = s[o + 8 >> 2];
        s[r + 12 >> 2] = s[o + 12 >> 2];
        s[r + 16 >> 2] = s[o + 16 >> 2];
        s[r + 20 >> 2] = s[o + 20 >> 2];
        s[r + 24 >> 2] = s[o + 24 >> 2];
        s[r + 28 >> 2] = s[o + 28 >> 2];
        s[o >> 2] = s[r >> 2];
        s[o + 4 >> 2] = s[r + 4 >> 2];
        s[o + 8 >> 2] = s[r + 8 >> 2];
        s[o + 12 >> 2] = s[r + 12 >> 2];
        s[o + 16 >> 2] = s[r + 16 >> 2];
        s[o + 20 >> 2] = s[r + 20 >> 2];
        s[o + 24 >> 2] = s[r + 24 >> 2];
        s[o + 28 >> 2] = s[r + 28 >> 2];
        s[i >> 2] = s[r >> 2];
        s[i + 4 >> 2] = s[r + 4 >> 2];
        s[i + 8 >> 2] = s[r + 8 >> 2];
        s[i + 12 >> 2] = s[r + 12 >> 2];
        s[i + 16 >> 2] = s[r + 16 >> 2];
        s[i + 20 >> 2] = s[r + 20 >> 2];
        s[i + 24 >> 2] = s[r + 24 >> 2];
        s[i + 28 >> 2] = s[r + 28 >> 2];
        ka(o, i, 136, -460954743, -2016278654);
        s[f >> 2] = s[o >> 2];
        s[f + 4 >> 2] = s[o + 4 >> 2];
        s[f + 8 >> 2] = s[o + 8 >> 2];
        s[f + 12 >> 2] = s[o + 12 >> 2];
        s[f + 16 >> 2] = s[o + 16 >> 2];
        s[f + 20 >> 2] = s[o + 20 >> 2];
        s[f + 24 >> 2] = s[o + 24 >> 2];
        s[f + 28 >> 2] = s[o + 28 >> 2];
        s[i >> 2] = s[_ >> 2];
        s[i + 4 >> 2] = s[_ + 4 >> 2];
        s[i + 8 >> 2] = s[_ + 8 >> 2];
        s[i + 12 >> 2] = s[_ + 12 >> 2];
        s[i + 16 >> 2] = s[_ + 16 >> 2];
        s[i + 20 >> 2] = s[_ + 20 >> 2];
        s[i + 24 >> 2] = s[_ + 24 >> 2];
        s[i + 28 >> 2] = s[_ + 28 >> 2];
        Ba(f, i, 136);
        s[u >> 2] = s[f >> 2];
        s[u + 4 >> 2] = s[f + 4 >> 2];
        s[u + 8 >> 2] = s[f + 8 >> 2];
        s[u + 12 >> 2] = s[f + 12 >> 2];
        s[u + 16 >> 2] = s[f + 16 >> 2];
        s[u + 20 >> 2] = s[f + 20 >> 2];
        s[u + 24 >> 2] = s[f + 24 >> 2];
        s[u + 28 >> 2] = s[f + 28 >> 2];
        s[i >> 2] = s[y >> 2];
        s[i + 4 >> 2] = s[y + 4 >> 2];
        s[i + 8 >> 2] = s[y + 8 >> 2];
        s[i + 12 >> 2] = s[y + 12 >> 2];
        s[i + 16 >> 2] = s[y + 16 >> 2];
        s[i + 20 >> 2] = s[y + 20 >> 2];
        s[i + 24 >> 2] = s[y + 24 >> 2];
        s[i + 28 >> 2] = s[y + 28 >> 2];
        Ba(u, i, 136);
        s[h >> 2] = s[u >> 2];
        s[h + 4 >> 2] = s[u + 4 >> 2];
        s[h + 8 >> 2] = s[u + 8 >> 2];
        s[h + 12 >> 2] = s[u + 12 >> 2];
        s[h + 16 >> 2] = s[u + 16 >> 2];
        s[h + 20 >> 2] = s[u + 20 >> 2];
        s[h + 24 >> 2] = s[u + 24 >> 2];
        s[h + 28 >> 2] = s[u + 28 >> 2];
        s[o >> 2] = s[h >> 2];
        s[o + 4 >> 2] = s[h + 4 >> 2];
        s[o + 8 >> 2] = s[h + 8 >> 2];
        s[o + 12 >> 2] = s[h + 12 >> 2];
        s[o + 16 >> 2] = s[h + 16 >> 2];
        s[o + 20 >> 2] = s[h + 20 >> 2];
        s[o + 24 >> 2] = s[h + 24 >> 2];
        s[o + 28 >> 2] = s[h + 28 >> 2];
        s[i >> 2] = s[h >> 2];
        s[i + 4 >> 2] = s[h + 4 >> 2];
        s[i + 8 >> 2] = s[h + 8 >> 2];
        s[i + 12 >> 2] = s[h + 12 >> 2];
        s[i + 16 >> 2] = s[h + 16 >> 2];
        s[i + 20 >> 2] = s[h + 20 >> 2];
        s[i + 24 >> 2] = s[h + 24 >> 2];
        s[i + 28 >> 2] = s[h + 28 >> 2];
        Ea(o, i, 136);
        s[h >> 2] = s[o >> 2];
        s[h + 4 >> 2] = s[o + 4 >> 2];
        s[h + 8 >> 2] = s[o + 8 >> 2];
        s[h + 12 >> 2] = s[o + 12 >> 2];
        s[h + 16 >> 2] = s[o + 16 >> 2];
        s[h + 20 >> 2] = s[o + 20 >> 2];
        s[h + 24 >> 2] = s[o + 24 >> 2];
        s[h + 28 >> 2] = s[o + 28 >> 2];
        s[o >> 2] = s[_ >> 2];
        s[o + 4 >> 2] = s[_ + 4 >> 2];
        s[o + 8 >> 2] = s[_ + 8 >> 2];
        s[o + 12 >> 2] = s[_ + 12 >> 2];
        s[o + 16 >> 2] = s[_ + 16 >> 2];
        s[o + 20 >> 2] = s[_ + 20 >> 2];
        s[o + 24 >> 2] = s[_ + 24 >> 2];
        s[o + 28 >> 2] = s[_ + 28 >> 2];
        s[i >> 2] = s[_ >> 2];
        s[i + 4 >> 2] = s[_ + 4 >> 2];
        s[i + 8 >> 2] = s[_ + 8 >> 2];
        s[i + 12 >> 2] = s[_ + 12 >> 2];
        s[i + 16 >> 2] = s[_ + 16 >> 2];
        s[i + 20 >> 2] = s[_ + 20 >> 2];
        s[i + 24 >> 2] = s[_ + 24 >> 2];
        s[i + 28 >> 2] = s[_ + 28 >> 2];
        Ea(o, i, 136);
        s[r >> 2] = s[o >> 2];
        s[r + 4 >> 2] = s[o + 4 >> 2];
        s[r + 8 >> 2] = s[o + 8 >> 2];
        s[r + 12 >> 2] = s[o + 12 >> 2];
        s[r + 16 >> 2] = s[o + 16 >> 2];
        s[r + 20 >> 2] = s[o + 20 >> 2];
        s[r + 24 >> 2] = s[o + 24 >> 2];
        s[r + 28 >> 2] = s[o + 28 >> 2];
        s[i >> 2] = s[_ >> 2];
        s[i + 4 >> 2] = s[_ + 4 >> 2];
        s[i + 8 >> 2] = s[_ + 8 >> 2];
        s[i + 12 >> 2] = s[_ + 12 >> 2];
        s[i + 16 >> 2] = s[_ + 16 >> 2];
        s[i + 20 >> 2] = s[_ + 20 >> 2];
        s[i + 24 >> 2] = s[_ + 24 >> 2];
        s[i + 28 >> 2] = s[_ + 28 >> 2];
        Ea(r, i, 136);
        s[b >> 2] = s[r >> 2];
        s[b + 4 >> 2] = s[r + 4 >> 2];
        s[b + 8 >> 2] = s[r + 8 >> 2];
        s[b + 12 >> 2] = s[r + 12 >> 2];
        s[b + 16 >> 2] = s[r + 16 >> 2];
        s[b + 20 >> 2] = s[r + 20 >> 2];
        s[b + 24 >> 2] = s[r + 24 >> 2];
        s[b + 28 >> 2] = s[r + 28 >> 2];
        s[o >> 2] = s[b >> 2];
        s[o + 4 >> 2] = s[b + 4 >> 2];
        s[o + 8 >> 2] = s[b + 8 >> 2];
        s[o + 12 >> 2] = s[b + 12 >> 2];
        s[o + 16 >> 2] = s[b + 16 >> 2];
        s[o + 20 >> 2] = s[b + 20 >> 2];
        s[o + 24 >> 2] = s[b + 24 >> 2];
        s[o + 28 >> 2] = s[b + 28 >> 2];
        s[i >> 2] = s[b >> 2];
        s[i + 4 >> 2] = s[b + 4 >> 2];
        s[i + 8 >> 2] = s[b + 8 >> 2];
        s[i + 12 >> 2] = s[b + 12 >> 2];
        s[i + 16 >> 2] = s[b + 16 >> 2];
        s[i + 20 >> 2] = s[b + 20 >> 2];
        s[i + 24 >> 2] = s[b + 24 >> 2];
        s[i + 28 >> 2] = s[b + 28 >> 2];
        ka(o, i, 136, -460954743, -2016278654);
        s[v >> 2] = s[o >> 2];
        s[v + 4 >> 2] = s[o + 4 >> 2];
        s[v + 8 >> 2] = s[o + 8 >> 2];
        s[v + 12 >> 2] = s[o + 12 >> 2];
        s[v + 16 >> 2] = s[o + 16 >> 2];
        s[v + 20 >> 2] = s[o + 20 >> 2];
        s[v + 24 >> 2] = s[o + 24 >> 2];
        s[v + 28 >> 2] = s[o + 28 >> 2];
        s[f >> 2] = s[v >> 2];
        s[f + 4 >> 2] = s[v + 4 >> 2];
        s[f + 8 >> 2] = s[v + 8 >> 2];
        s[f + 12 >> 2] = s[v + 12 >> 2];
        s[f + 16 >> 2] = s[v + 16 >> 2];
        s[f + 20 >> 2] = s[v + 20 >> 2];
        s[f + 24 >> 2] = s[v + 24 >> 2];
        s[f + 28 >> 2] = s[v + 28 >> 2];
        s[o >> 2] = s[h >> 2];
        s[o + 4 >> 2] = s[h + 4 >> 2];
        s[o + 8 >> 2] = s[h + 8 >> 2];
        s[o + 12 >> 2] = s[h + 12 >> 2];
        s[o + 16 >> 2] = s[h + 16 >> 2];
        s[o + 20 >> 2] = s[h + 20 >> 2];
        s[o + 24 >> 2] = s[h + 24 >> 2];
        s[o + 28 >> 2] = s[h + 28 >> 2];
        s[i >> 2] = s[h >> 2];
        s[i + 4 >> 2] = s[h + 4 >> 2];
        s[i + 8 >> 2] = s[h + 8 >> 2];
        s[i + 12 >> 2] = s[h + 12 >> 2];
        s[i + 16 >> 2] = s[h + 16 >> 2];
        s[i + 20 >> 2] = s[h + 20 >> 2];
        s[i + 24 >> 2] = s[h + 24 >> 2];
        s[i + 28 >> 2] = s[h + 28 >> 2];
        Ea(o, i, 136);
        s[r >> 2] = s[o >> 2];
        s[r + 4 >> 2] = s[o + 4 >> 2];
        s[r + 8 >> 2] = s[o + 8 >> 2];
        s[r + 12 >> 2] = s[o + 12 >> 2];
        s[r + 16 >> 2] = s[o + 16 >> 2];
        s[r + 20 >> 2] = s[o + 20 >> 2];
        s[r + 24 >> 2] = s[o + 24 >> 2];
        s[r + 28 >> 2] = s[o + 28 >> 2];
        Ba(f, r, 136);
        s[l >> 2] = s[f >> 2];
        s[l + 4 >> 2] = s[f + 4 >> 2];
        s[l + 8 >> 2] = s[f + 8 >> 2];
        s[l + 12 >> 2] = s[f + 12 >> 2];
        s[l + 16 >> 2] = s[f + 16 >> 2];
        s[l + 20 >> 2] = s[f + 20 >> 2];
        s[l + 24 >> 2] = s[f + 24 >> 2];
        s[l + 28 >> 2] = s[f + 28 >> 2];
        s[o >> 2] = s[y >> 2];
        s[o + 4 >> 2] = s[y + 4 >> 2];
        s[o + 8 >> 2] = s[y + 8 >> 2];
        s[o + 12 >> 2] = s[y + 12 >> 2];
        s[o + 16 >> 2] = s[y + 16 >> 2];
        s[o + 20 >> 2] = s[y + 20 >> 2];
        s[o + 24 >> 2] = s[y + 24 >> 2];
        s[o + 28 >> 2] = s[y + 28 >> 2];
        s[i >> 2] = s[y >> 2];
        s[i + 4 >> 2] = s[y + 4 >> 2];
        s[i + 8 >> 2] = s[y + 8 >> 2];
        s[i + 12 >> 2] = s[y + 12 >> 2];
        s[i + 16 >> 2] = s[y + 16 >> 2];
        s[i + 20 >> 2] = s[y + 20 >> 2];
        s[i + 24 >> 2] = s[y + 24 >> 2];
        s[i + 28 >> 2] = s[y + 28 >> 2];
        Ea(o, i, 136);
        s[d >> 2] = s[o >> 2];
        s[d + 4 >> 2] = s[o + 4 >> 2];
        s[d + 8 >> 2] = s[o + 8 >> 2];
        s[d + 12 >> 2] = s[o + 12 >> 2];
        s[d + 16 >> 2] = s[o + 16 >> 2];
        s[d + 20 >> 2] = s[o + 20 >> 2];
        s[d + 24 >> 2] = s[o + 24 >> 2];
        s[d + 28 >> 2] = s[o + 28 >> 2];
        s[o >> 2] = s[d >> 2];
        s[o + 4 >> 2] = s[d + 4 >> 2];
        s[o + 8 >> 2] = s[d + 8 >> 2];
        s[o + 12 >> 2] = s[d + 12 >> 2];
        s[o + 16 >> 2] = s[d + 16 >> 2];
        s[o + 20 >> 2] = s[d + 20 >> 2];
        s[o + 24 >> 2] = s[d + 24 >> 2];
        s[o + 28 >> 2] = s[d + 28 >> 2];
        s[i >> 2] = s[d >> 2];
        s[i + 4 >> 2] = s[d + 4 >> 2];
        s[i + 8 >> 2] = s[d + 8 >> 2];
        s[i + 12 >> 2] = s[d + 12 >> 2];
        s[i + 16 >> 2] = s[d + 16 >> 2];
        s[i + 20 >> 2] = s[d + 20 >> 2];
        s[i + 24 >> 2] = s[d + 24 >> 2];
        s[i + 28 >> 2] = s[d + 28 >> 2];
        Ea(o, i, 136);
        s[d >> 2] = s[o >> 2];
        s[d + 4 >> 2] = s[o + 4 >> 2];
        s[d + 8 >> 2] = s[o + 8 >> 2];
        s[d + 12 >> 2] = s[o + 12 >> 2];
        s[d + 16 >> 2] = s[o + 16 >> 2];
        s[d + 20 >> 2] = s[o + 20 >> 2];
        s[d + 24 >> 2] = s[o + 24 >> 2];
        s[d + 28 >> 2] = s[o + 28 >> 2];
        s[o >> 2] = s[d >> 2];
        s[o + 4 >> 2] = s[d + 4 >> 2];
        s[o + 8 >> 2] = s[d + 8 >> 2];
        s[o + 12 >> 2] = s[d + 12 >> 2];
        s[o + 16 >> 2] = s[d + 16 >> 2];
        s[o + 20 >> 2] = s[d + 20 >> 2];
        s[o + 24 >> 2] = s[d + 24 >> 2];
        s[o + 28 >> 2] = s[d + 28 >> 2];
        s[i >> 2] = s[d >> 2];
        s[i + 4 >> 2] = s[d + 4 >> 2];
        s[i + 8 >> 2] = s[d + 8 >> 2];
        s[i + 12 >> 2] = s[d + 12 >> 2];
        s[i + 16 >> 2] = s[d + 16 >> 2];
        s[i + 20 >> 2] = s[d + 20 >> 2];
        s[i + 24 >> 2] = s[d + 24 >> 2];
        s[i + 28 >> 2] = s[d + 28 >> 2];
        Ea(o, i, 136);
        s[d >> 2] = s[o >> 2];
        s[d + 4 >> 2] = s[o + 4 >> 2];
        s[d + 8 >> 2] = s[o + 8 >> 2];
        s[d + 12 >> 2] = s[o + 12 >> 2];
        s[d + 16 >> 2] = s[o + 16 >> 2];
        s[d + 20 >> 2] = s[o + 20 >> 2];
        s[d + 24 >> 2] = s[o + 24 >> 2];
        s[d + 28 >> 2] = s[o + 28 >> 2];
        s[o >> 2] = s[m >> 2];
        s[o + 4 >> 2] = s[m + 4 >> 2];
        s[o + 8 >> 2] = s[m + 8 >> 2];
        s[o + 12 >> 2] = s[m + 12 >> 2];
        s[o + 16 >> 2] = s[m + 16 >> 2];
        s[o + 20 >> 2] = s[m + 20 >> 2];
        s[o + 24 >> 2] = s[m + 24 >> 2];
        s[o + 28 >> 2] = s[m + 28 >> 2];
        t = t + 64 | 0;
        s[i >> 2] = s[t >> 2];
        s[i + 4 >> 2] = s[t + 4 >> 2];
        s[i + 8 >> 2] = s[t + 8 >> 2];
        s[i + 12 >> 2] = s[t + 12 >> 2];
        s[i + 16 >> 2] = s[t + 16 >> 2];
        s[i + 20 >> 2] = s[t + 20 >> 2];
        s[i + 24 >> 2] = s[t + 24 >> 2];
        s[i + 28 >> 2] = s[t + 28 >> 2];
        ka(o, i, 136, -460954743, -2016278654);
        s[c >> 2] = s[o >> 2];
        s[c + 4 >> 2] = s[o + 4 >> 2];
        s[c + 8 >> 2] = s[o + 8 >> 2];
        s[c + 12 >> 2] = s[o + 12 >> 2];
        s[c + 16 >> 2] = s[o + 16 >> 2];
        s[c + 20 >> 2] = s[o + 20 >> 2];
        s[c + 24 >> 2] = s[o + 24 >> 2];
        s[c + 28 >> 2] = s[o + 28 >> 2];
        s[e >> 2] = s[l >> 2];
        s[e + 4 >> 2] = s[l + 4 >> 2];
        s[e + 8 >> 2] = s[l + 8 >> 2];
        s[e + 12 >> 2] = s[l + 12 >> 2];
        s[e + 16 >> 2] = s[l + 16 >> 2];
        s[e + 20 >> 2] = s[l + 20 >> 2];
        s[e + 24 >> 2] = s[l + 24 >> 2];
        s[e + 28 >> 2] = s[l + 28 >> 2];
        s[f >> 2] = s[b >> 2];
        s[f + 4 >> 2] = s[b + 4 >> 2];
        s[f + 8 >> 2] = s[b + 8 >> 2];
        s[f + 12 >> 2] = s[b + 12 >> 2];
        s[f + 16 >> 2] = s[b + 16 >> 2];
        s[f + 20 >> 2] = s[b + 20 >> 2];
        s[f + 24 >> 2] = s[b + 24 >> 2];
        s[f + 28 >> 2] = s[b + 28 >> 2];
        s[o >> 2] = s[h >> 2];
        s[o + 4 >> 2] = s[h + 4 >> 2];
        s[o + 8 >> 2] = s[h + 8 >> 2];
        s[o + 12 >> 2] = s[h + 12 >> 2];
        s[o + 16 >> 2] = s[h + 16 >> 2];
        s[o + 20 >> 2] = s[h + 20 >> 2];
        s[o + 24 >> 2] = s[h + 24 >> 2];
        s[o + 28 >> 2] = s[h + 28 >> 2];
        s[i >> 2] = s[l >> 2];
        s[i + 4 >> 2] = s[l + 4 >> 2];
        s[i + 8 >> 2] = s[l + 8 >> 2];
        s[i + 12 >> 2] = s[l + 12 >> 2];
        s[i + 16 >> 2] = s[l + 16 >> 2];
        s[i + 20 >> 2] = s[l + 20 >> 2];
        s[i + 24 >> 2] = s[l + 24 >> 2];
        s[i + 28 >> 2] = s[l + 28 >> 2];
        Ba(o, i, 136);
        s[r >> 2] = s[o >> 2];
        s[r + 4 >> 2] = s[o + 4 >> 2];
        s[r + 8 >> 2] = s[o + 8 >> 2];
        s[r + 12 >> 2] = s[o + 12 >> 2];
        s[r + 16 >> 2] = s[o + 16 >> 2];
        s[r + 20 >> 2] = s[o + 20 >> 2];
        s[r + 24 >> 2] = s[o + 24 >> 2];
        s[r + 28 >> 2] = s[o + 28 >> 2];
        ka(f, r, 136, -460954743, -2016278654);
        s[u >> 2] = s[f >> 2];
        s[u + 4 >> 2] = s[f + 4 >> 2];
        s[u + 8 >> 2] = s[f + 8 >> 2];
        s[u + 12 >> 2] = s[f + 12 >> 2];
        s[u + 16 >> 2] = s[f + 16 >> 2];
        s[u + 20 >> 2] = s[f + 20 >> 2];
        s[u + 24 >> 2] = s[f + 24 >> 2];
        s[u + 28 >> 2] = s[f + 28 >> 2];
        s[i >> 2] = s[d >> 2];
        s[i + 4 >> 2] = s[d + 4 >> 2];
        s[i + 8 >> 2] = s[d + 8 >> 2];
        s[i + 12 >> 2] = s[d + 12 >> 2];
        s[i + 16 >> 2] = s[d + 16 >> 2];
        s[i + 20 >> 2] = s[d + 20 >> 2];
        s[i + 24 >> 2] = s[d + 24 >> 2];
        s[i + 28 >> 2] = s[d + 28 >> 2];
        Ba(u, i, 136);
        s[n >> 2] = s[u >> 2];
        s[n + 4 >> 2] = s[u + 4 >> 2];
        s[n + 8 >> 2] = s[u + 8 >> 2];
        s[n + 12 >> 2] = s[u + 12 >> 2];
        s[n + 16 >> 2] = s[u + 16 >> 2];
        s[n + 20 >> 2] = s[u + 20 >> 2];
        s[n + 24 >> 2] = s[u + 24 >> 2];
        s[n + 28 >> 2] = s[u + 28 >> 2];
        s[o >> 2] = s[c >> 2];
        s[o + 4 >> 2] = s[c + 4 >> 2];
        s[o + 8 >> 2] = s[c + 8 >> 2];
        s[o + 12 >> 2] = s[c + 12 >> 2];
        s[o + 16 >> 2] = s[c + 16 >> 2];
        s[o + 20 >> 2] = s[c + 20 >> 2];
        s[o + 24 >> 2] = s[c + 24 >> 2];
        s[o + 28 >> 2] = s[c + 28 >> 2];
        s[i >> 2] = s[c >> 2];
        s[i + 4 >> 2] = s[c + 4 >> 2];
        s[i + 8 >> 2] = s[c + 8 >> 2];
        s[i + 12 >> 2] = s[c + 12 >> 2];
        s[i + 16 >> 2] = s[c + 16 >> 2];
        s[i + 20 >> 2] = s[c + 20 >> 2];
        s[i + 24 >> 2] = s[c + 24 >> 2];
        s[i + 28 >> 2] = s[c + 28 >> 2];
        Ea(o, i, 136);
        s[r >> 2] = s[o >> 2];
        s[r + 4 >> 2] = s[o + 4 >> 2];
        s[r + 8 >> 2] = s[o + 8 >> 2];
        s[r + 12 >> 2] = s[o + 12 >> 2];
        s[r + 16 >> 2] = s[o + 16 >> 2];
        s[r + 20 >> 2] = s[o + 20 >> 2];
        s[r + 24 >> 2] = s[o + 24 >> 2];
        s[r + 28 >> 2] = s[o + 28 >> 2];
        t = e + 32 | 0;
        s[t >> 2] = s[n >> 2];
        s[t + 4 >> 2] = s[n + 4 >> 2];
        s[t + 8 >> 2] = s[n + 8 >> 2];
        s[t + 12 >> 2] = s[n + 12 >> 2];
        s[t + 16 >> 2] = s[n + 16 >> 2];
        s[t + 20 >> 2] = s[n + 20 >> 2];
        s[t + 24 >> 2] = s[n + 24 >> 2];
        s[t + 28 >> 2] = s[n + 28 >> 2];
        t = e + 64 | 0;
        s[t >> 2] = s[r >> 2];
        s[t + 4 >> 2] = s[r + 4 >> 2];
        s[t + 8 >> 2] = s[r + 8 >> 2];
        s[t + 12 >> 2] = s[r + 12 >> 2];
        s[t + 16 >> 2] = s[r + 16 >> 2];
        s[t + 20 >> 2] = s[r + 20 >> 2];
        s[t + 24 >> 2] = s[r + 24 >> 2];
        s[t + 28 >> 2] = s[r + 28 >> 2];
        p = a;
        return;
      }

      function ga(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0;
        l = p;
        p = p + 320 | 0;
        c = l + 224 | 0;
        u = l + 128 | 0;
        d = l + 96 | 0;
        f = l;
        s[f >> 2] = 0;
        s[f + 4 >> 2] = 0;
        s[f + 8 >> 2] = 0;
        s[f + 12 >> 2] = 0;
        s[f + 16 >> 2] = 0;
        s[f + 20 >> 2] = 0;
        s[f + 24 >> 2] = 0;
        s[f + 28 >> 2] = 0;
        i = f + 32 | 0;
        s[i >> 2] = -980480611;
        s[i + 4 >> 2] = -748862579;
        i = f + 40 | 0;
        s[i >> 2] = -171504835;
        s[i + 4 >> 2] = 175696680;
        i = f + 48 | 0;
        s[i >> 2] = 2021213740;
        s[i + 4 >> 2] = 1718526831;
        i = f + 56 | 0;
        s[i >> 2] = -1710760145;
        s[i + 4 >> 2] = 235567041;
        i = f + 64 | 0;
        s[i >> 2] = 0;
        s[i + 4 >> 2] = 0;
        s[i + 8 >> 2] = 0;
        s[i + 12 >> 2] = 0;
        s[i + 16 >> 2] = 0;
        s[i + 20 >> 2] = 0;
        s[i + 24 >> 2] = 0;
        s[i + 28 >> 2] = 0;
        s[u >> 2] = s[a >> 2];
        s[u + 4 >> 2] = s[a + 4 >> 2];
        s[u + 8 >> 2] = s[a + 8 >> 2];
        s[u + 12 >> 2] = s[a + 12 >> 2];
        s[u + 16 >> 2] = s[a + 16 >> 2];
        s[u + 20 >> 2] = s[a + 20 >> 2];
        s[u + 24 >> 2] = s[a + 24 >> 2];
        s[u + 28 >> 2] = s[a + 28 >> 2];
        a = c;
        s[a >> 2] = 1;
        s[a + 4 >> 2] = 0;
        a = c + 8 | 0;
        s[a >> 2] = 0;
        s[a + 4 >> 2] = 0;
        s[a + 8 >> 2] = 0;
        s[a + 12 >> 2] = 0;
        s[a + 16 >> 2] = 0;
        s[a + 20 >> 2] = 0;
        ka(u, c, 8, -268435457, -1025378925);
        s[d >> 2] = s[u >> 2];
        s[d + 4 >> 2] = s[u + 4 >> 2];
        s[d + 8 >> 2] = s[u + 8 >> 2];
        s[d + 12 >> 2] = s[u + 12 >> 2];
        s[d + 16 >> 2] = s[u + 16 >> 2];
        s[d + 20 >> 2] = s[u + 20 >> 2];
        s[d + 24 >> 2] = s[u + 24 >> 2];
        s[d + 28 >> 2] = s[u + 28 >> 2];
        a = 256;

        while (1) {
          if (!a) {
            a = 7;
            break;
          }

          a = a + -1 | 0;

          if (a >>> 0 > 255) {
            a = 7;
            break;
          }

          i = d + (a >>> 6 << 3) | 0;
          n = s[i >> 2] | 0;
          i = s[i + 4 >> 2] | 0;
          o = od(1, 0, a & 63 | 0) | 0;

          if (!((n & o | 0) == 0 & (i & S | 0) == 0)) {
            r = a;
            a = 9;
            break;
          }
        }

        if ((a | 0) == 7) {
          n = e;
          o = f;
          i = n + 96 | 0;

          do {
            s[n >> 2] = s[o >> 2];
            n = n + 4 | 0;
            o = o + 4 | 0;
          } while ((n | 0) < (i | 0));

          p = l;
          return;
        } else if ((a | 0) == 9) {
          e: while (1) {
            n = u;
            o = f;
            i = n + 96 | 0;

            do {
              s[n >> 2] = s[o >> 2];
              n = n + 4 | 0;
              o = o + 4 | 0;
            } while ((n | 0) < (i | 0));

            n = c;
            o = t;
            i = n + 96 | 0;

            do {
              s[n >> 2] = s[o >> 2];
              n = n + 4 | 0;
              o = o + 4 | 0;
            } while ((n | 0) < (i | 0));

            Aa(f, u, c);

            while (1) {
              if (!r) {
                a = 7;
                break e;
              }

              r = r + -1 | 0;

              if (r >>> 0 > 255) {
                a = 7;
                break e;
              }

              a = d + (r >>> 6 << 3) | 0;
              o = s[a >> 2] | 0;
              a = s[a + 4 >> 2] | 0;
              n = od(1, 0, r & 63 | 0) | 0;
              a = (o & n | 0) == 0 & (a & S | 0) == 0;

              _a(c, f);

              n = f;
              o = c;
              i = n + 96 | 0;

              do {
                s[n >> 2] = s[o >> 2];
                n = n + 4 | 0;
                o = o + 4 | 0;
              } while ((n | 0) < (i | 0));

              if (!a) continue e;
            }
          }

          if ((a | 0) == 7) {
            n = e;
            o = f;
            i = n + 96 | 0;

            do {
              s[n >> 2] = s[o >> 2];
              n = n + 4 | 0;
              o = o + 4 | 0;
            } while ((n | 0) < (i | 0));

            p = l;
            return;
          }
        }
      }

      function Aa(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0,
            A = 0,
            w = 0,
            T = 0,
            x = 0,
            D = 0,
            C = 0,
            S = 0,
            E = 0,
            B = 0,
            k = 0,
            R = 0,
            W = 0;
        R = p;
        p = p + 768 | 0;
        T = R + 736 | 0;
        x = R + 704 | 0;
        D = R + 672 | 0;
        C = R + 640 | 0;
        E = R + 608 | 0;
        B = R + 576 | 0;
        k = R + 544 | 0;
        r = R + 512 | 0;
        n = R + 480 | 0;
        o = R + 448 | 0;
        i = R + 416 | 0;
        c = R + 384 | 0;
        u = R + 352 | 0;
        d = R + 320 | 0;
        f = R + 288 | 0;
        l = R + 256 | 0;
        h = R + 224 | 0;
        b = R + 192 | 0;
        m = R + 160 | 0;
        y = R + 128 | 0;
        v = R + 96 | 0;
        _ = R + 64 | 0;
        g = R + 32 | 0;
        A = R;
        w = t + 64 | 0;
        S = w;

        if ((((s[S >> 2] | 0) == 0 & (s[S + 4 >> 2] | 0) == 0 ? (S = t + 72 | 0, (s[S >> 2] | 0) == 0 & (s[S + 4 >> 2] | 0) == 0) : 0) ? (S = t + 80 | 0, (s[S >> 2] | 0) == 0 & (s[S + 4 >> 2] | 0) == 0) : 0) ? (S = t + 88 | 0, (s[S >> 2] | 0) == 0 & (s[S + 4 >> 2] | 0) == 0) : 0) {
          t = a;
          r = e + 96 | 0;

          do {
            s[e >> 2] = s[t >> 2];
            e = e + 4 | 0;
            t = t + 4 | 0;
          } while ((e | 0) < (r | 0));

          p = R;
          return;
        }

        S = a + 64 | 0;
        W = S;

        if ((((s[W >> 2] | 0) == 0 & (s[W + 4 >> 2] | 0) == 0 ? (W = a + 72 | 0, (s[W >> 2] | 0) == 0 & (s[W + 4 >> 2] | 0) == 0) : 0) ? (W = a + 80 | 0, (s[W >> 2] | 0) == 0 & (s[W + 4 >> 2] | 0) == 0) : 0) ? (W = a + 88 | 0, (s[W >> 2] | 0) == 0 & (s[W + 4 >> 2] | 0) == 0) : 0) {
          r = e + 96 | 0;

          do {
            s[e >> 2] = s[t >> 2];
            e = e + 4 | 0;
            t = t + 4 | 0;
          } while ((e | 0) < (r | 0));

          p = R;
          return;
        }

        s[x >> 2] = s[w >> 2];
        s[x + 4 >> 2] = s[w + 4 >> 2];
        s[x + 8 >> 2] = s[w + 8 >> 2];
        s[x + 12 >> 2] = s[w + 12 >> 2];
        s[x + 16 >> 2] = s[w + 16 >> 2];
        s[x + 20 >> 2] = s[w + 20 >> 2];
        s[x + 24 >> 2] = s[w + 24 >> 2];
        s[x + 28 >> 2] = s[w + 28 >> 2];
        s[T >> 2] = s[w >> 2];
        s[T + 4 >> 2] = s[w + 4 >> 2];
        s[T + 8 >> 2] = s[w + 8 >> 2];
        s[T + 12 >> 2] = s[w + 12 >> 2];
        s[T + 16 >> 2] = s[w + 16 >> 2];
        s[T + 20 >> 2] = s[w + 20 >> 2];
        s[T + 24 >> 2] = s[w + 24 >> 2];
        s[T + 28 >> 2] = s[w + 28 >> 2];
        ka(x, T, 136, -460954743, -2016278654);
        s[A >> 2] = s[x >> 2];
        s[A + 4 >> 2] = s[x + 4 >> 2];
        s[A + 8 >> 2] = s[x + 8 >> 2];
        s[A + 12 >> 2] = s[x + 12 >> 2];
        s[A + 16 >> 2] = s[x + 16 >> 2];
        s[A + 20 >> 2] = s[x + 20 >> 2];
        s[A + 24 >> 2] = s[x + 24 >> 2];
        s[A + 28 >> 2] = s[x + 28 >> 2];
        s[x >> 2] = s[S >> 2];
        s[x + 4 >> 2] = s[S + 4 >> 2];
        s[x + 8 >> 2] = s[S + 8 >> 2];
        s[x + 12 >> 2] = s[S + 12 >> 2];
        s[x + 16 >> 2] = s[S + 16 >> 2];
        s[x + 20 >> 2] = s[S + 20 >> 2];
        s[x + 24 >> 2] = s[S + 24 >> 2];
        s[x + 28 >> 2] = s[S + 28 >> 2];
        s[T >> 2] = s[S >> 2];
        s[T + 4 >> 2] = s[S + 4 >> 2];
        s[T + 8 >> 2] = s[S + 8 >> 2];
        s[T + 12 >> 2] = s[S + 12 >> 2];
        s[T + 16 >> 2] = s[S + 16 >> 2];
        s[T + 20 >> 2] = s[S + 20 >> 2];
        s[T + 24 >> 2] = s[S + 24 >> 2];
        s[T + 28 >> 2] = s[S + 28 >> 2];
        ka(x, T, 136, -460954743, -2016278654);
        s[g >> 2] = s[x >> 2];
        s[g + 4 >> 2] = s[x + 4 >> 2];
        s[g + 8 >> 2] = s[x + 8 >> 2];
        s[g + 12 >> 2] = s[x + 12 >> 2];
        s[g + 16 >> 2] = s[x + 16 >> 2];
        s[g + 20 >> 2] = s[x + 20 >> 2];
        s[g + 24 >> 2] = s[x + 24 >> 2];
        s[g + 28 >> 2] = s[x + 28 >> 2];
        s[x >> 2] = s[t >> 2];
        s[x + 4 >> 2] = s[t + 4 >> 2];
        s[x + 8 >> 2] = s[t + 8 >> 2];
        s[x + 12 >> 2] = s[t + 12 >> 2];
        s[x + 16 >> 2] = s[t + 16 >> 2];
        s[x + 20 >> 2] = s[t + 20 >> 2];
        s[x + 24 >> 2] = s[t + 24 >> 2];
        s[x + 28 >> 2] = s[t + 28 >> 2];
        s[T >> 2] = s[g >> 2];
        s[T + 4 >> 2] = s[g + 4 >> 2];
        s[T + 8 >> 2] = s[g + 8 >> 2];
        s[T + 12 >> 2] = s[g + 12 >> 2];
        s[T + 16 >> 2] = s[g + 16 >> 2];
        s[T + 20 >> 2] = s[g + 20 >> 2];
        s[T + 24 >> 2] = s[g + 24 >> 2];
        s[T + 28 >> 2] = s[g + 28 >> 2];
        ka(x, T, 136, -460954743, -2016278654);
        s[_ >> 2] = s[x >> 2];
        s[_ + 4 >> 2] = s[x + 4 >> 2];
        s[_ + 8 >> 2] = s[x + 8 >> 2];
        s[_ + 12 >> 2] = s[x + 12 >> 2];
        s[_ + 16 >> 2] = s[x + 16 >> 2];
        s[_ + 20 >> 2] = s[x + 20 >> 2];
        s[_ + 24 >> 2] = s[x + 24 >> 2];
        s[_ + 28 >> 2] = s[x + 28 >> 2];
        s[x >> 2] = s[a >> 2];
        s[x + 4 >> 2] = s[a + 4 >> 2];
        s[x + 8 >> 2] = s[a + 8 >> 2];
        s[x + 12 >> 2] = s[a + 12 >> 2];
        s[x + 16 >> 2] = s[a + 16 >> 2];
        s[x + 20 >> 2] = s[a + 20 >> 2];
        s[x + 24 >> 2] = s[a + 24 >> 2];
        s[x + 28 >> 2] = s[a + 28 >> 2];
        s[T >> 2] = s[A >> 2];
        s[T + 4 >> 2] = s[A + 4 >> 2];
        s[T + 8 >> 2] = s[A + 8 >> 2];
        s[T + 12 >> 2] = s[A + 12 >> 2];
        s[T + 16 >> 2] = s[A + 16 >> 2];
        s[T + 20 >> 2] = s[A + 20 >> 2];
        s[T + 24 >> 2] = s[A + 24 >> 2];
        s[T + 28 >> 2] = s[A + 28 >> 2];
        ka(x, T, 136, -460954743, -2016278654);
        s[v >> 2] = s[x >> 2];
        s[v + 4 >> 2] = s[x + 4 >> 2];
        s[v + 8 >> 2] = s[x + 8 >> 2];
        s[v + 12 >> 2] = s[x + 12 >> 2];
        s[v + 16 >> 2] = s[x + 16 >> 2];
        s[v + 20 >> 2] = s[x + 20 >> 2];
        s[v + 24 >> 2] = s[x + 24 >> 2];
        s[v + 28 >> 2] = s[x + 28 >> 2];
        s[x >> 2] = s[w >> 2];
        s[x + 4 >> 2] = s[w + 4 >> 2];
        s[x + 8 >> 2] = s[w + 8 >> 2];
        s[x + 12 >> 2] = s[w + 12 >> 2];
        s[x + 16 >> 2] = s[w + 16 >> 2];
        s[x + 20 >> 2] = s[w + 20 >> 2];
        s[x + 24 >> 2] = s[w + 24 >> 2];
        s[x + 28 >> 2] = s[w + 28 >> 2];
        s[T >> 2] = s[A >> 2];
        s[T + 4 >> 2] = s[A + 4 >> 2];
        s[T + 8 >> 2] = s[A + 8 >> 2];
        s[T + 12 >> 2] = s[A + 12 >> 2];
        s[T + 16 >> 2] = s[A + 16 >> 2];
        s[T + 20 >> 2] = s[A + 20 >> 2];
        s[T + 24 >> 2] = s[A + 24 >> 2];
        s[T + 28 >> 2] = s[A + 28 >> 2];
        ka(x, T, 136, -460954743, -2016278654);
        s[y >> 2] = s[x >> 2];
        s[y + 4 >> 2] = s[x + 4 >> 2];
        s[y + 8 >> 2] = s[x + 8 >> 2];
        s[y + 12 >> 2] = s[x + 12 >> 2];
        s[y + 16 >> 2] = s[x + 16 >> 2];
        s[y + 20 >> 2] = s[x + 20 >> 2];
        s[y + 24 >> 2] = s[x + 24 >> 2];
        s[y + 28 >> 2] = s[x + 28 >> 2];
        s[x >> 2] = s[S >> 2];
        s[x + 4 >> 2] = s[S + 4 >> 2];
        s[x + 8 >> 2] = s[S + 8 >> 2];
        s[x + 12 >> 2] = s[S + 12 >> 2];
        s[x + 16 >> 2] = s[S + 16 >> 2];
        s[x + 20 >> 2] = s[S + 20 >> 2];
        s[x + 24 >> 2] = s[S + 24 >> 2];
        s[x + 28 >> 2] = s[S + 28 >> 2];
        s[T >> 2] = s[g >> 2];
        s[T + 4 >> 2] = s[g + 4 >> 2];
        s[T + 8 >> 2] = s[g + 8 >> 2];
        s[T + 12 >> 2] = s[g + 12 >> 2];
        s[T + 16 >> 2] = s[g + 16 >> 2];
        s[T + 20 >> 2] = s[g + 20 >> 2];
        s[T + 24 >> 2] = s[g + 24 >> 2];
        s[T + 28 >> 2] = s[g + 28 >> 2];
        ka(x, T, 136, -460954743, -2016278654);
        s[m >> 2] = s[x >> 2];
        s[m + 4 >> 2] = s[x + 4 >> 2];
        s[m + 8 >> 2] = s[x + 8 >> 2];
        s[m + 12 >> 2] = s[x + 12 >> 2];
        s[m + 16 >> 2] = s[x + 16 >> 2];
        s[m + 20 >> 2] = s[x + 20 >> 2];
        s[m + 24 >> 2] = s[x + 24 >> 2];
        s[m + 28 >> 2] = s[x + 28 >> 2];
        W = t + 32 | 0;
        s[x >> 2] = s[W >> 2];
        s[x + 4 >> 2] = s[W + 4 >> 2];
        s[x + 8 >> 2] = s[W + 8 >> 2];
        s[x + 12 >> 2] = s[W + 12 >> 2];
        s[x + 16 >> 2] = s[W + 16 >> 2];
        s[x + 20 >> 2] = s[W + 20 >> 2];
        s[x + 24 >> 2] = s[W + 24 >> 2];
        s[x + 28 >> 2] = s[W + 28 >> 2];
        s[T >> 2] = s[m >> 2];
        s[T + 4 >> 2] = s[m + 4 >> 2];
        s[T + 8 >> 2] = s[m + 8 >> 2];
        s[T + 12 >> 2] = s[m + 12 >> 2];
        s[T + 16 >> 2] = s[m + 16 >> 2];
        s[T + 20 >> 2] = s[m + 20 >> 2];
        s[T + 24 >> 2] = s[m + 24 >> 2];
        s[T + 28 >> 2] = s[m + 28 >> 2];
        ka(x, T, 136, -460954743, -2016278654);
        s[b >> 2] = s[x >> 2];
        s[b + 4 >> 2] = s[x + 4 >> 2];
        s[b + 8 >> 2] = s[x + 8 >> 2];
        s[b + 12 >> 2] = s[x + 12 >> 2];
        s[b + 16 >> 2] = s[x + 16 >> 2];
        s[b + 20 >> 2] = s[x + 20 >> 2];
        s[b + 24 >> 2] = s[x + 24 >> 2];
        s[b + 28 >> 2] = s[x + 28 >> 2];
        W = a + 32 | 0;
        s[x >> 2] = s[W >> 2];
        s[x + 4 >> 2] = s[W + 4 >> 2];
        s[x + 8 >> 2] = s[W + 8 >> 2];
        s[x + 12 >> 2] = s[W + 12 >> 2];
        s[x + 16 >> 2] = s[W + 16 >> 2];
        s[x + 20 >> 2] = s[W + 20 >> 2];
        s[x + 24 >> 2] = s[W + 24 >> 2];
        s[x + 28 >> 2] = s[W + 28 >> 2];
        s[T >> 2] = s[y >> 2];
        s[T + 4 >> 2] = s[y + 4 >> 2];
        s[T + 8 >> 2] = s[y + 8 >> 2];
        s[T + 12 >> 2] = s[y + 12 >> 2];
        s[T + 16 >> 2] = s[y + 16 >> 2];
        s[T + 20 >> 2] = s[y + 20 >> 2];
        s[T + 24 >> 2] = s[y + 24 >> 2];
        s[T + 28 >> 2] = s[y + 28 >> 2];
        ka(x, T, 136, -460954743, -2016278654);
        s[h >> 2] = s[x >> 2];
        s[h + 4 >> 2] = s[x + 4 >> 2];
        s[h + 8 >> 2] = s[x + 8 >> 2];
        s[h + 12 >> 2] = s[x + 12 >> 2];
        s[h + 16 >> 2] = s[x + 16 >> 2];
        s[h + 20 >> 2] = s[x + 20 >> 2];
        s[h + 24 >> 2] = s[x + 24 >> 2];
        s[h + 28 >> 2] = s[x + 28 >> 2];
        if ((Vu(_, v, 32) | 0) == 0 ? (Vu(b, h, 32) | 0) == 0 : 0) _a(e, t);else {
          s[x >> 2] = s[v >> 2];
          s[x + 4 >> 2] = s[v + 4 >> 2];
          s[x + 8 >> 2] = s[v + 8 >> 2];
          s[x + 12 >> 2] = s[v + 12 >> 2];
          s[x + 16 >> 2] = s[v + 16 >> 2];
          s[x + 20 >> 2] = s[v + 20 >> 2];
          s[x + 24 >> 2] = s[v + 24 >> 2];
          s[x + 28 >> 2] = s[v + 28 >> 2];
          s[T >> 2] = s[_ >> 2];
          s[T + 4 >> 2] = s[_ + 4 >> 2];
          s[T + 8 >> 2] = s[_ + 8 >> 2];
          s[T + 12 >> 2] = s[_ + 12 >> 2];
          s[T + 16 >> 2] = s[_ + 16 >> 2];
          s[T + 20 >> 2] = s[_ + 20 >> 2];
          s[T + 24 >> 2] = s[_ + 24 >> 2];
          s[T + 28 >> 2] = s[_ + 28 >> 2];
          Ba(x, T, 136);
          s[l >> 2] = s[x >> 2];
          s[l + 4 >> 2] = s[x + 4 >> 2];
          s[l + 8 >> 2] = s[x + 8 >> 2];
          s[l + 12 >> 2] = s[x + 12 >> 2];
          s[l + 16 >> 2] = s[x + 16 >> 2];
          s[l + 20 >> 2] = s[x + 20 >> 2];
          s[l + 24 >> 2] = s[x + 24 >> 2];
          s[l + 28 >> 2] = s[x + 28 >> 2];
          s[x >> 2] = s[h >> 2];
          s[x + 4 >> 2] = s[h + 4 >> 2];
          s[x + 8 >> 2] = s[h + 8 >> 2];
          s[x + 12 >> 2] = s[h + 12 >> 2];
          s[x + 16 >> 2] = s[h + 16 >> 2];
          s[x + 20 >> 2] = s[h + 20 >> 2];
          s[x + 24 >> 2] = s[h + 24 >> 2];
          s[x + 28 >> 2] = s[h + 28 >> 2];
          s[T >> 2] = s[b >> 2];
          s[T + 4 >> 2] = s[b + 4 >> 2];
          s[T + 8 >> 2] = s[b + 8 >> 2];
          s[T + 12 >> 2] = s[b + 12 >> 2];
          s[T + 16 >> 2] = s[b + 16 >> 2];
          s[T + 20 >> 2] = s[b + 20 >> 2];
          s[T + 24 >> 2] = s[b + 24 >> 2];
          s[T + 28 >> 2] = s[b + 28 >> 2];
          Ba(x, T, 136);
          s[f >> 2] = s[x >> 2];
          s[f + 4 >> 2] = s[x + 4 >> 2];
          s[f + 8 >> 2] = s[x + 8 >> 2];
          s[f + 12 >> 2] = s[x + 12 >> 2];
          s[f + 16 >> 2] = s[x + 16 >> 2];
          s[f + 20 >> 2] = s[x + 20 >> 2];
          s[f + 24 >> 2] = s[x + 24 >> 2];
          s[f + 28 >> 2] = s[x + 28 >> 2];
          s[x >> 2] = s[l >> 2];
          s[x + 4 >> 2] = s[l + 4 >> 2];
          s[x + 8 >> 2] = s[l + 8 >> 2];
          s[x + 12 >> 2] = s[l + 12 >> 2];
          s[x + 16 >> 2] = s[l + 16 >> 2];
          s[x + 20 >> 2] = s[l + 20 >> 2];
          s[x + 24 >> 2] = s[l + 24 >> 2];
          s[x + 28 >> 2] = s[l + 28 >> 2];
          s[T >> 2] = s[l >> 2];
          s[T + 4 >> 2] = s[l + 4 >> 2];
          s[T + 8 >> 2] = s[l + 8 >> 2];
          s[T + 12 >> 2] = s[l + 12 >> 2];
          s[T + 16 >> 2] = s[l + 16 >> 2];
          s[T + 20 >> 2] = s[l + 20 >> 2];
          s[T + 24 >> 2] = s[l + 24 >> 2];
          s[T + 28 >> 2] = s[l + 28 >> 2];
          Ea(x, T, 136);
          s[D >> 2] = s[x >> 2];
          s[D + 4 >> 2] = s[x + 4 >> 2];
          s[D + 8 >> 2] = s[x + 8 >> 2];
          s[D + 12 >> 2] = s[x + 12 >> 2];
          s[D + 16 >> 2] = s[x + 16 >> 2];
          s[D + 20 >> 2] = s[x + 20 >> 2];
          s[D + 24 >> 2] = s[x + 24 >> 2];
          s[D + 28 >> 2] = s[x + 28 >> 2];
          s[x >> 2] = s[D >> 2];
          s[x + 4 >> 2] = s[D + 4 >> 2];
          s[x + 8 >> 2] = s[D + 8 >> 2];
          s[x + 12 >> 2] = s[D + 12 >> 2];
          s[x + 16 >> 2] = s[D + 16 >> 2];
          s[x + 20 >> 2] = s[D + 20 >> 2];
          s[x + 24 >> 2] = s[D + 24 >> 2];
          s[x + 28 >> 2] = s[D + 28 >> 2];
          s[T >> 2] = s[D >> 2];
          s[T + 4 >> 2] = s[D + 4 >> 2];
          s[T + 8 >> 2] = s[D + 8 >> 2];
          s[T + 12 >> 2] = s[D + 12 >> 2];
          s[T + 16 >> 2] = s[D + 16 >> 2];
          s[T + 20 >> 2] = s[D + 20 >> 2];
          s[T + 24 >> 2] = s[D + 24 >> 2];
          s[T + 28 >> 2] = s[D + 28 >> 2];
          ka(x, T, 136, -460954743, -2016278654);
          s[d >> 2] = s[x >> 2];
          s[d + 4 >> 2] = s[x + 4 >> 2];
          s[d + 8 >> 2] = s[x + 8 >> 2];
          s[d + 12 >> 2] = s[x + 12 >> 2];
          s[d + 16 >> 2] = s[x + 16 >> 2];
          s[d + 20 >> 2] = s[x + 20 >> 2];
          s[d + 24 >> 2] = s[x + 24 >> 2];
          s[d + 28 >> 2] = s[x + 28 >> 2];
          s[x >> 2] = s[l >> 2];
          s[x + 4 >> 2] = s[l + 4 >> 2];
          s[x + 8 >> 2] = s[l + 8 >> 2];
          s[x + 12 >> 2] = s[l + 12 >> 2];
          s[x + 16 >> 2] = s[l + 16 >> 2];
          s[x + 20 >> 2] = s[l + 20 >> 2];
          s[x + 24 >> 2] = s[l + 24 >> 2];
          s[x + 28 >> 2] = s[l + 28 >> 2];
          s[T >> 2] = s[d >> 2];
          s[T + 4 >> 2] = s[d + 4 >> 2];
          s[T + 8 >> 2] = s[d + 8 >> 2];
          s[T + 12 >> 2] = s[d + 12 >> 2];
          s[T + 16 >> 2] = s[d + 16 >> 2];
          s[T + 20 >> 2] = s[d + 20 >> 2];
          s[T + 24 >> 2] = s[d + 24 >> 2];
          s[T + 28 >> 2] = s[d + 28 >> 2];
          ka(x, T, 136, -460954743, -2016278654);
          s[u >> 2] = s[x >> 2];
          s[u + 4 >> 2] = s[x + 4 >> 2];
          s[u + 8 >> 2] = s[x + 8 >> 2];
          s[u + 12 >> 2] = s[x + 12 >> 2];
          s[u + 16 >> 2] = s[x + 16 >> 2];
          s[u + 20 >> 2] = s[x + 20 >> 2];
          s[u + 24 >> 2] = s[x + 24 >> 2];
          s[u + 28 >> 2] = s[x + 28 >> 2];
          s[x >> 2] = s[f >> 2];
          s[x + 4 >> 2] = s[f + 4 >> 2];
          s[x + 8 >> 2] = s[f + 8 >> 2];
          s[x + 12 >> 2] = s[f + 12 >> 2];
          s[x + 16 >> 2] = s[f + 16 >> 2];
          s[x + 20 >> 2] = s[f + 20 >> 2];
          s[x + 24 >> 2] = s[f + 24 >> 2];
          s[x + 28 >> 2] = s[f + 28 >> 2];
          s[T >> 2] = s[f >> 2];
          s[T + 4 >> 2] = s[f + 4 >> 2];
          s[T + 8 >> 2] = s[f + 8 >> 2];
          s[T + 12 >> 2] = s[f + 12 >> 2];
          s[T + 16 >> 2] = s[f + 16 >> 2];
          s[T + 20 >> 2] = s[f + 20 >> 2];
          s[T + 24 >> 2] = s[f + 24 >> 2];
          s[T + 28 >> 2] = s[f + 28 >> 2];
          Ea(x, T, 136);
          s[c >> 2] = s[x >> 2];
          s[c + 4 >> 2] = s[x + 4 >> 2];
          s[c + 8 >> 2] = s[x + 8 >> 2];
          s[c + 12 >> 2] = s[x + 12 >> 2];
          s[c + 16 >> 2] = s[x + 16 >> 2];
          s[c + 20 >> 2] = s[x + 20 >> 2];
          s[c + 24 >> 2] = s[x + 24 >> 2];
          s[c + 28 >> 2] = s[x + 28 >> 2];
          s[x >> 2] = s[_ >> 2];
          s[x + 4 >> 2] = s[_ + 4 >> 2];
          s[x + 8 >> 2] = s[_ + 8 >> 2];
          s[x + 12 >> 2] = s[_ + 12 >> 2];
          s[x + 16 >> 2] = s[_ + 16 >> 2];
          s[x + 20 >> 2] = s[_ + 20 >> 2];
          s[x + 24 >> 2] = s[_ + 24 >> 2];
          s[x + 28 >> 2] = s[_ + 28 >> 2];
          s[T >> 2] = s[d >> 2];
          s[T + 4 >> 2] = s[d + 4 >> 2];
          s[T + 8 >> 2] = s[d + 8 >> 2];
          s[T + 12 >> 2] = s[d + 12 >> 2];
          s[T + 16 >> 2] = s[d + 16 >> 2];
          s[T + 20 >> 2] = s[d + 20 >> 2];
          s[T + 24 >> 2] = s[d + 24 >> 2];
          s[T + 28 >> 2] = s[d + 28 >> 2];
          ka(x, T, 136, -460954743, -2016278654);
          s[i >> 2] = s[x >> 2];
          s[i + 4 >> 2] = s[x + 4 >> 2];
          s[i + 8 >> 2] = s[x + 8 >> 2];
          s[i + 12 >> 2] = s[x + 12 >> 2];
          s[i + 16 >> 2] = s[x + 16 >> 2];
          s[i + 20 >> 2] = s[x + 20 >> 2];
          s[i + 24 >> 2] = s[x + 24 >> 2];
          s[i + 28 >> 2] = s[x + 28 >> 2];
          s[x >> 2] = s[b >> 2];
          s[x + 4 >> 2] = s[b + 4 >> 2];
          s[x + 8 >> 2] = s[b + 8 >> 2];
          s[x + 12 >> 2] = s[b + 12 >> 2];
          s[x + 16 >> 2] = s[b + 16 >> 2];
          s[x + 20 >> 2] = s[b + 20 >> 2];
          s[x + 24 >> 2] = s[b + 24 >> 2];
          s[x + 28 >> 2] = s[b + 28 >> 2];
          s[T >> 2] = s[u >> 2];
          s[T + 4 >> 2] = s[u + 4 >> 2];
          s[T + 8 >> 2] = s[u + 8 >> 2];
          s[T + 12 >> 2] = s[u + 12 >> 2];
          s[T + 16 >> 2] = s[u + 16 >> 2];
          s[T + 20 >> 2] = s[u + 20 >> 2];
          s[T + 24 >> 2] = s[u + 24 >> 2];
          s[T + 28 >> 2] = s[u + 28 >> 2];
          ka(x, T, 136, -460954743, -2016278654);
          s[o >> 2] = s[x >> 2];
          s[o + 4 >> 2] = s[x + 4 >> 2];
          s[o + 8 >> 2] = s[x + 8 >> 2];
          s[o + 12 >> 2] = s[x + 12 >> 2];
          s[o + 16 >> 2] = s[x + 16 >> 2];
          s[o + 20 >> 2] = s[x + 20 >> 2];
          s[o + 24 >> 2] = s[x + 24 >> 2];
          s[o + 28 >> 2] = s[x + 28 >> 2];
          s[x >> 2] = s[c >> 2];
          s[x + 4 >> 2] = s[c + 4 >> 2];
          s[x + 8 >> 2] = s[c + 8 >> 2];
          s[x + 12 >> 2] = s[c + 12 >> 2];
          s[x + 16 >> 2] = s[c + 16 >> 2];
          s[x + 20 >> 2] = s[c + 20 >> 2];
          s[x + 24 >> 2] = s[c + 24 >> 2];
          s[x + 28 >> 2] = s[c + 28 >> 2];
          s[T >> 2] = s[c >> 2];
          s[T + 4 >> 2] = s[c + 4 >> 2];
          s[T + 8 >> 2] = s[c + 8 >> 2];
          s[T + 12 >> 2] = s[c + 12 >> 2];
          s[T + 16 >> 2] = s[c + 16 >> 2];
          s[T + 20 >> 2] = s[c + 20 >> 2];
          s[T + 24 >> 2] = s[c + 24 >> 2];
          s[T + 28 >> 2] = s[c + 28 >> 2];
          ka(x, T, 136, -460954743, -2016278654);
          s[D >> 2] = s[x >> 2];
          s[D + 4 >> 2] = s[x + 4 >> 2];
          s[D + 8 >> 2] = s[x + 8 >> 2];
          s[D + 12 >> 2] = s[x + 12 >> 2];
          s[D + 16 >> 2] = s[x + 16 >> 2];
          s[D + 20 >> 2] = s[x + 20 >> 2];
          s[D + 24 >> 2] = s[x + 24 >> 2];
          s[D + 28 >> 2] = s[x + 28 >> 2];
          s[T >> 2] = s[u >> 2];
          s[T + 4 >> 2] = s[u + 4 >> 2];
          s[T + 8 >> 2] = s[u + 8 >> 2];
          s[T + 12 >> 2] = s[u + 12 >> 2];
          s[T + 16 >> 2] = s[u + 16 >> 2];
          s[T + 20 >> 2] = s[u + 20 >> 2];
          s[T + 24 >> 2] = s[u + 24 >> 2];
          s[T + 28 >> 2] = s[u + 28 >> 2];
          Ba(D, T, 136);
          s[C >> 2] = s[D >> 2];
          s[C + 4 >> 2] = s[D + 4 >> 2];
          s[C + 8 >> 2] = s[D + 8 >> 2];
          s[C + 12 >> 2] = s[D + 12 >> 2];
          s[C + 16 >> 2] = s[D + 16 >> 2];
          s[C + 20 >> 2] = s[D + 20 >> 2];
          s[C + 24 >> 2] = s[D + 24 >> 2];
          s[C + 28 >> 2] = s[D + 28 >> 2];
          s[x >> 2] = s[i >> 2];
          s[x + 4 >> 2] = s[i + 4 >> 2];
          s[x + 8 >> 2] = s[i + 8 >> 2];
          s[x + 12 >> 2] = s[i + 12 >> 2];
          s[x + 16 >> 2] = s[i + 16 >> 2];
          s[x + 20 >> 2] = s[i + 20 >> 2];
          s[x + 24 >> 2] = s[i + 24 >> 2];
          s[x + 28 >> 2] = s[i + 28 >> 2];
          s[T >> 2] = s[i >> 2];
          s[T + 4 >> 2] = s[i + 4 >> 2];
          s[T + 8 >> 2] = s[i + 8 >> 2];
          s[T + 12 >> 2] = s[i + 12 >> 2];
          s[T + 16 >> 2] = s[i + 16 >> 2];
          s[T + 20 >> 2] = s[i + 20 >> 2];
          s[T + 24 >> 2] = s[i + 24 >> 2];
          s[T + 28 >> 2] = s[i + 28 >> 2];
          Ea(x, T, 136);
          s[D >> 2] = s[x >> 2];
          s[D + 4 >> 2] = s[x + 4 >> 2];
          s[D + 8 >> 2] = s[x + 8 >> 2];
          s[D + 12 >> 2] = s[x + 12 >> 2];
          s[D + 16 >> 2] = s[x + 16 >> 2];
          s[D + 20 >> 2] = s[x + 20 >> 2];
          s[D + 24 >> 2] = s[x + 24 >> 2];
          s[D + 28 >> 2] = s[x + 28 >> 2];
          Ba(C, D, 136);
          s[n >> 2] = s[C >> 2];
          s[n + 4 >> 2] = s[C + 4 >> 2];
          s[n + 8 >> 2] = s[C + 8 >> 2];
          s[n + 12 >> 2] = s[C + 12 >> 2];
          s[n + 16 >> 2] = s[C + 16 >> 2];
          s[n + 20 >> 2] = s[C + 20 >> 2];
          s[n + 24 >> 2] = s[C + 24 >> 2];
          s[n + 28 >> 2] = s[C + 28 >> 2];
          s[e >> 2] = s[n >> 2];
          s[e + 4 >> 2] = s[n + 4 >> 2];
          s[e + 8 >> 2] = s[n + 8 >> 2];
          s[e + 12 >> 2] = s[n + 12 >> 2];
          s[e + 16 >> 2] = s[n + 16 >> 2];
          s[e + 20 >> 2] = s[n + 20 >> 2];
          s[e + 24 >> 2] = s[n + 24 >> 2];
          s[e + 28 >> 2] = s[n + 28 >> 2];
          s[C >> 2] = s[c >> 2];
          s[C + 4 >> 2] = s[c + 4 >> 2];
          s[C + 8 >> 2] = s[c + 8 >> 2];
          s[C + 12 >> 2] = s[c + 12 >> 2];
          s[C + 16 >> 2] = s[c + 16 >> 2];
          s[C + 20 >> 2] = s[c + 20 >> 2];
          s[C + 24 >> 2] = s[c + 24 >> 2];
          s[C + 28 >> 2] = s[c + 28 >> 2];
          s[x >> 2] = s[i >> 2];
          s[x + 4 >> 2] = s[i + 4 >> 2];
          s[x + 8 >> 2] = s[i + 8 >> 2];
          s[x + 12 >> 2] = s[i + 12 >> 2];
          s[x + 16 >> 2] = s[i + 16 >> 2];
          s[x + 20 >> 2] = s[i + 20 >> 2];
          s[x + 24 >> 2] = s[i + 24 >> 2];
          s[x + 28 >> 2] = s[i + 28 >> 2];
          s[T >> 2] = s[n >> 2];
          s[T + 4 >> 2] = s[n + 4 >> 2];
          s[T + 8 >> 2] = s[n + 8 >> 2];
          s[T + 12 >> 2] = s[n + 12 >> 2];
          s[T + 16 >> 2] = s[n + 16 >> 2];
          s[T + 20 >> 2] = s[n + 20 >> 2];
          s[T + 24 >> 2] = s[n + 24 >> 2];
          s[T + 28 >> 2] = s[n + 28 >> 2];
          Ba(x, T, 136);
          s[D >> 2] = s[x >> 2];
          s[D + 4 >> 2] = s[x + 4 >> 2];
          s[D + 8 >> 2] = s[x + 8 >> 2];
          s[D + 12 >> 2] = s[x + 12 >> 2];
          s[D + 16 >> 2] = s[x + 16 >> 2];
          s[D + 20 >> 2] = s[x + 20 >> 2];
          s[D + 24 >> 2] = s[x + 24 >> 2];
          s[D + 28 >> 2] = s[x + 28 >> 2];
          ka(C, D, 136, -460954743, -2016278654);
          s[E >> 2] = s[C >> 2];
          s[E + 4 >> 2] = s[C + 4 >> 2];
          s[E + 8 >> 2] = s[C + 8 >> 2];
          s[E + 12 >> 2] = s[C + 12 >> 2];
          s[E + 16 >> 2] = s[C + 16 >> 2];
          s[E + 20 >> 2] = s[C + 20 >> 2];
          s[E + 24 >> 2] = s[C + 24 >> 2];
          s[E + 28 >> 2] = s[C + 28 >> 2];
          s[x >> 2] = s[o >> 2];
          s[x + 4 >> 2] = s[o + 4 >> 2];
          s[x + 8 >> 2] = s[o + 8 >> 2];
          s[x + 12 >> 2] = s[o + 12 >> 2];
          s[x + 16 >> 2] = s[o + 16 >> 2];
          s[x + 20 >> 2] = s[o + 20 >> 2];
          s[x + 24 >> 2] = s[o + 24 >> 2];
          s[x + 28 >> 2] = s[o + 28 >> 2];
          s[T >> 2] = s[o >> 2];
          s[T + 4 >> 2] = s[o + 4 >> 2];
          s[T + 8 >> 2] = s[o + 8 >> 2];
          s[T + 12 >> 2] = s[o + 12 >> 2];
          s[T + 16 >> 2] = s[o + 16 >> 2];
          s[T + 20 >> 2] = s[o + 20 >> 2];
          s[T + 24 >> 2] = s[o + 24 >> 2];
          s[T + 28 >> 2] = s[o + 28 >> 2];
          Ea(x, T, 136);
          s[D >> 2] = s[x >> 2];
          s[D + 4 >> 2] = s[x + 4 >> 2];
          s[D + 8 >> 2] = s[x + 8 >> 2];
          s[D + 12 >> 2] = s[x + 12 >> 2];
          s[D + 16 >> 2] = s[x + 16 >> 2];
          s[D + 20 >> 2] = s[x + 20 >> 2];
          s[D + 24 >> 2] = s[x + 24 >> 2];
          s[D + 28 >> 2] = s[x + 28 >> 2];
          Ba(E, D, 136);
          s[r >> 2] = s[E >> 2];
          s[r + 4 >> 2] = s[E + 4 >> 2];
          s[r + 8 >> 2] = s[E + 8 >> 2];
          s[r + 12 >> 2] = s[E + 12 >> 2];
          s[r + 16 >> 2] = s[E + 16 >> 2];
          s[r + 20 >> 2] = s[E + 20 >> 2];
          s[r + 24 >> 2] = s[E + 24 >> 2];
          s[r + 28 >> 2] = s[E + 28 >> 2];
          s[x >> 2] = s[w >> 2];
          s[x + 4 >> 2] = s[w + 4 >> 2];
          s[x + 8 >> 2] = s[w + 8 >> 2];
          s[x + 12 >> 2] = s[w + 12 >> 2];
          s[x + 16 >> 2] = s[w + 16 >> 2];
          s[x + 20 >> 2] = s[w + 20 >> 2];
          s[x + 24 >> 2] = s[w + 24 >> 2];
          s[x + 28 >> 2] = s[w + 28 >> 2];
          s[T >> 2] = s[S >> 2];
          s[T + 4 >> 2] = s[S + 4 >> 2];
          s[T + 8 >> 2] = s[S + 8 >> 2];
          s[T + 12 >> 2] = s[S + 12 >> 2];
          s[T + 16 >> 2] = s[S + 16 >> 2];
          s[T + 20 >> 2] = s[S + 20 >> 2];
          s[T + 24 >> 2] = s[S + 24 >> 2];
          s[T + 28 >> 2] = s[S + 28 >> 2];
          Ea(x, T, 136);
          s[D >> 2] = s[x >> 2];
          s[D + 4 >> 2] = s[x + 4 >> 2];
          s[D + 8 >> 2] = s[x + 8 >> 2];
          s[D + 12 >> 2] = s[x + 12 >> 2];
          s[D + 16 >> 2] = s[x + 16 >> 2];
          s[D + 20 >> 2] = s[x + 20 >> 2];
          s[D + 24 >> 2] = s[x + 24 >> 2];
          s[D + 28 >> 2] = s[x + 28 >> 2];
          s[x >> 2] = s[D >> 2];
          s[x + 4 >> 2] = s[D + 4 >> 2];
          s[x + 8 >> 2] = s[D + 8 >> 2];
          s[x + 12 >> 2] = s[D + 12 >> 2];
          s[x + 16 >> 2] = s[D + 16 >> 2];
          s[x + 20 >> 2] = s[D + 20 >> 2];
          s[x + 24 >> 2] = s[D + 24 >> 2];
          s[x + 28 >> 2] = s[D + 28 >> 2];
          s[T >> 2] = s[D >> 2];
          s[T + 4 >> 2] = s[D + 4 >> 2];
          s[T + 8 >> 2] = s[D + 8 >> 2];
          s[T + 12 >> 2] = s[D + 12 >> 2];
          s[T + 16 >> 2] = s[D + 16 >> 2];
          s[T + 20 >> 2] = s[D + 20 >> 2];
          s[T + 24 >> 2] = s[D + 24 >> 2];
          s[T + 28 >> 2] = s[D + 28 >> 2];
          ka(x, T, 136, -460954743, -2016278654);
          s[C >> 2] = s[x >> 2];
          s[C + 4 >> 2] = s[x + 4 >> 2];
          s[C + 8 >> 2] = s[x + 8 >> 2];
          s[C + 12 >> 2] = s[x + 12 >> 2];
          s[C + 16 >> 2] = s[x + 16 >> 2];
          s[C + 20 >> 2] = s[x + 20 >> 2];
          s[C + 24 >> 2] = s[x + 24 >> 2];
          s[C + 28 >> 2] = s[x + 28 >> 2];
          s[T >> 2] = s[A >> 2];
          s[T + 4 >> 2] = s[A + 4 >> 2];
          s[T + 8 >> 2] = s[A + 8 >> 2];
          s[T + 12 >> 2] = s[A + 12 >> 2];
          s[T + 16 >> 2] = s[A + 16 >> 2];
          s[T + 20 >> 2] = s[A + 20 >> 2];
          s[T + 24 >> 2] = s[A + 24 >> 2];
          s[T + 28 >> 2] = s[A + 28 >> 2];
          Ba(C, T, 136);
          s[E >> 2] = s[C >> 2];
          s[E + 4 >> 2] = s[C + 4 >> 2];
          s[E + 8 >> 2] = s[C + 8 >> 2];
          s[E + 12 >> 2] = s[C + 12 >> 2];
          s[E + 16 >> 2] = s[C + 16 >> 2];
          s[E + 20 >> 2] = s[C + 20 >> 2];
          s[E + 24 >> 2] = s[C + 24 >> 2];
          s[E + 28 >> 2] = s[C + 28 >> 2];
          s[T >> 2] = s[g >> 2];
          s[T + 4 >> 2] = s[g + 4 >> 2];
          s[T + 8 >> 2] = s[g + 8 >> 2];
          s[T + 12 >> 2] = s[g + 12 >> 2];
          s[T + 16 >> 2] = s[g + 16 >> 2];
          s[T + 20 >> 2] = s[g + 20 >> 2];
          s[T + 24 >> 2] = s[g + 24 >> 2];
          s[T + 28 >> 2] = s[g + 28 >> 2];
          Ba(E, T, 136);
          s[B >> 2] = s[E >> 2];
          s[B + 4 >> 2] = s[E + 4 >> 2];
          s[B + 8 >> 2] = s[E + 8 >> 2];
          s[B + 12 >> 2] = s[E + 12 >> 2];
          s[B + 16 >> 2] = s[E + 16 >> 2];
          s[B + 20 >> 2] = s[E + 20 >> 2];
          s[B + 24 >> 2] = s[E + 24 >> 2];
          s[B + 28 >> 2] = s[E + 28 >> 2];
          s[T >> 2] = s[l >> 2];
          s[T + 4 >> 2] = s[l + 4 >> 2];
          s[T + 8 >> 2] = s[l + 8 >> 2];
          s[T + 12 >> 2] = s[l + 12 >> 2];
          s[T + 16 >> 2] = s[l + 16 >> 2];
          s[T + 20 >> 2] = s[l + 20 >> 2];
          s[T + 24 >> 2] = s[l + 24 >> 2];
          s[T + 28 >> 2] = s[l + 28 >> 2];
          ka(B, T, 136, -460954743, -2016278654);
          s[k >> 2] = s[B >> 2];
          s[k + 4 >> 2] = s[B + 4 >> 2];
          s[k + 8 >> 2] = s[B + 8 >> 2];
          s[k + 12 >> 2] = s[B + 12 >> 2];
          s[k + 16 >> 2] = s[B + 16 >> 2];
          s[k + 20 >> 2] = s[B + 20 >> 2];
          s[k + 24 >> 2] = s[B + 24 >> 2];
          s[k + 28 >> 2] = s[B + 28 >> 2];
          W = e + 32 | 0;
          s[W >> 2] = s[r >> 2];
          s[W + 4 >> 2] = s[r + 4 >> 2];
          s[W + 8 >> 2] = s[r + 8 >> 2];
          s[W + 12 >> 2] = s[r + 12 >> 2];
          s[W + 16 >> 2] = s[r + 16 >> 2];
          s[W + 20 >> 2] = s[r + 20 >> 2];
          s[W + 24 >> 2] = s[r + 24 >> 2];
          s[W + 28 >> 2] = s[r + 28 >> 2];
          W = e + 64 | 0;
          s[W >> 2] = s[k >> 2];
          s[W + 4 >> 2] = s[k + 4 >> 2];
          s[W + 8 >> 2] = s[k + 8 >> 2];
          s[W + 12 >> 2] = s[k + 12 >> 2];
          s[W + 16 >> 2] = s[k + 16 >> 2];
          s[W + 20 >> 2] = s[k + 20 >> 2];
          s[W + 24 >> 2] = s[k + 24 >> 2];
          s[W + 28 >> 2] = s[k + 28 >> 2];
        }
        p = R;
        return;
      }

      function wa(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0,
            A = 0,
            w = 0,
            T = 0,
            x = 0,
            D = 0,
            C = 0,
            E = 0,
            B = 0,
            k = 0,
            R = 0,
            W = 0,
            I = 0,
            N = 0,
            M = 0,
            P = 0,
            L = 0,
            O = 0,
            F = 0,
            j = 0,
            G = 0,
            V = 0,
            U = 0,
            H = 0,
            z = 0,
            K = 0,
            q = 0,
            Y = 0,
            Z = 0,
            J = 0,
            X = 0,
            Q = 0,
            ae = 0,
            ne = 0,
            se = 0,
            oe = 0,
            ie = 0,
            ce = 0,
            ue = 0,
            de = 0,
            fe = 0,
            le = 0,
            he = 0,
            pe = 0,
            be = 0,
            ye = 0,
            ve = 0,
            _e = 0,
            ge = 0,
            Ae = 0,
            we = 0,
            Te = 0,
            xe = 0,
            De = 0,
            Ce = 0,
            Se = 0,
            Be = 0,
            ke = 0,
            Re = 0,
            We = 0,
            Ie = 0,
            Ne = 0,
            Me = 0,
            Pe = 0,
            Le = 0,
            Oe = 0,
            Fe = 0,
            je = 0,
            Ge = 0,
            Ve = 0,
            Ue = 0,
            He = 0,
            ze = 0,
            Ke = 0,
            qe = 0,
            Ye = 0,
            Ze = 0,
            Je = 0,
            Xe = 0,
            $e = 0,
            Qe = 0,
            et = 0,
            tt = 0,
            at = 0,
            rt = 0,
            nt = 0,
            st = 0,
            ot = 0,
            it = 0,
            ct = 0,
            ut = 0,
            dt = 0,
            ft = 0,
            lt = 0,
            ht = 0,
            pt = 0,
            bt = 0,
            mt = 0,
            yt = 0,
            vt = 0,
            _t = 0,
            gt = 0,
            At = 0,
            wt = 0,
            Tt = 0,
            xt = 0,
            Dt = 0,
            Ct = 0,
            St = 0,
            Et = 0,
            Bt = 0,
            kt = 0,
            Rt = 0,
            Wt = 0,
            It = 0,
            Nt = 0,
            Mt = 0,
            Pt = 0,
            Lt = 0,
            Ot = 0,
            Ft = 0,
            jt = 0,
            Ht = 0,
            zt = 0,
            Kt = 0,
            qt = 0,
            Yt = 0,
            Zt = 0,
            Jt = 0,
            Xt = 0,
            $t = 0,
            Qt = 0,
            ea = 0,
            ta = 0,
            aa = 0,
            ra = 0,
            na = 0,
            sa = 0,
            oa = 0,
            ia = 0,
            ca = 0,
            ua = 0,
            da = 0,
            fa = 0,
            la = 0,
            ha = 0,
            pa = 0,
            ba = 0,
            ma = 0,
            _a = 0,
            ga = 0,
            Aa = 0,
            wa = 0,
            Ta = 0,
            Ca = 0,
            Sa = 0,
            Ea = 0,
            Ba = 0,
            ka = 0,
            Ra = 0,
            Wa = 0,
            Ia = 0,
            Na = 0,
            Ma = 0,
            Pa = 0,
            La = 0,
            Oa = 0,
            Fa = 0,
            ja = 0,
            Ga = 0,
            Va = 0,
            Ua = 0,
            Ha = 0,
            za = 0,
            Ka = 0,
            qa = 0,
            Ya = 0,
            Za = 0,
            Ja = 0,
            Xa = 0,
            $a = 0,
            Qa = 0,
            er = 0,
            tr = 0,
            ar = 0,
            rr = 0,
            nr = 0,
            sr = 0,
            or = 0,
            ir = 0,
            cr = 0,
            ur = 0,
            dr = 0,
            fr = 0,
            lr = 0,
            hr = 0,
            pr = 0,
            br = 0,
            mr = 0,
            yr = 0,
            vr = 0,
            _r = 0,
            gr = 0,
            Ar = 0,
            wr = 0,
            Tr = 0,
            xr = 0,
            Dr = 0,
            Cr = 0,
            Sr = 0,
            Er = 0,
            Br = 0,
            kr = 0,
            Rr = 0,
            Wr = 0,
            Ir = 0,
            Nr = 0,
            Mr = 0,
            Pr = 0,
            Lr = 0,
            Or = 0,
            Fr = 0,
            jr = 0,
            Gr = 0,
            Vr = 0,
            Ur = 0,
            Hr = 0,
            zr = 0,
            Kr = 0,
            qr = 0,
            Yr = 0,
            Zr = 0,
            Jr = 0,
            Xr = 0,
            $r = 0,
            Qr = 0,
            en = 0,
            tn = 0,
            an = 0;
        an = p;
        p = p + 12736 | 0;
        Za = an + 12576 | 0;
        tr = an + 12504 | 0;
        sr = an + 12472 | 0;
        mr = an + 12440 | 0;
        vr = an + 12408 | 0;
        _r = an + 12376 | 0;
        gr = an + 12344 | 0;
        za = an + 12312 | 0;
        Ar = an + 12280 | 0;
        wr = an + 12248 | 0;
        Tr = an + 12216 | 0;
        xr = an + 12184 | 0;
        Dr = an + 12152 | 0;
        Cr = an + 12120 | 0;
        Er = an + 12088 | 0;
        Ir = an + 12056 | 0;
        Nr = an + 12024 | 0;
        Mr = an + 11992 | 0;
        Pr = an + 11960 | 0;
        Lr = an + 11928 | 0;
        Or = an + 11896 | 0;
        Fr = an + 11864 | 0;
        jr = an + 11832 | 0;
        Gr = an + 11800 | 0;
        Ka = an + 11768 | 0;
        qa = an + 11736 | 0;
        Ya = an + 11704 | 0;
        Ja = an + 11672 | 0;
        Xa = an + 11640 | 0;
        $a = an + 11608 | 0;
        Qa = an + 11576 | 0;
        er = an + 11544 | 0;
        Vr = an + 11512 | 0;
        Ur = an + 11448 | 0;
        Hr = an + 11416 | 0;
        zr = an + 11352 | 0;
        Kr = an + 11288 | 0;
        qr = an + 10904 | 0;
        Yr = an + 10872 | 0;
        Zr = an + 10808 | 0;
        Jr = an + 10776 | 0;
        Xr = an + 10712 | 0;
        $r = an + 10648 | 0;
        Qr = an + 10264 | 0;
        ar = an + 10232 | 0;
        rr = an + 10168 | 0;
        nr = an + 10136 | 0;
        or = an + 10072 | 0;
        ir = an + 10008 | 0;
        cr = an + 9624 | 0;
        ur = an + 9592 | 0;
        dr = an + 9528 | 0;
        fr = an + 9496 | 0;
        lr = an + 9432 | 0;
        hr = an + 9368 | 0;
        pr = an + 8984 | 0;
        br = an + 8600 | 0;
        yr = an + 8568 | 0;
        en = an + 8184 | 0;
        Ft = an + 8152 | 0;
        jt = an + 8120 | 0;
        Ht = an + 8088 | 0;
        zt = an + 8056 | 0;
        Kt = an + 8024 | 0;
        qt = an + 7992 | 0;
        Yt = an + 7960 | 0;
        Zt = an + 7928 | 0;
        Jt = an + 7896 | 0;
        Xt = an + 7864 | 0;
        $t = an + 7832 | 0;
        Qt = an + 7800 | 0;
        ea = an + 7768 | 0;
        ta = an + 7736 | 0;
        aa = an + 7704 | 0;
        ra = an + 7672 | 0;
        na = an + 7640 | 0;
        ga = an + 7608 | 0;
        Aa = an + 7576 | 0;
        wa = an + 7544 | 0;
        Ta = an + 7512 | 0;
        tn = an + 7480 | 0;
        Na = an + 7416 | 0;
        Ma = an + 7352 | 0;
        Sa = an + 7288 | 0;
        Ea = an + 7224 | 0;
        Pa = an + 7160 | 0;
        Ba = an + 7096 | 0;
        ka = an + 7032 | 0;
        Ra = an + 6968 | 0;
        sa = an + 6904 | 0;
        oa = an + 6840 | 0;
        ia = an + 6776 | 0;
        ca = an + 6712 | 0;
        ua = an + 6648 | 0;
        da = an + 6584 | 0;
        fa = an + 6520 | 0;
        la = an + 6456 | 0;
        Pe = an + 6392 | 0;
        Le = an + 6328 | 0;
        Oe = an + 6264 | 0;
        Fe = an + 6200 | 0;
        je = an + 6136 | 0;
        Ge = an + 6072 | 0;
        Ve = an + 6008 | 0;
        Ue = an + 5944 | 0;
        He = an + 5880 | 0;
        ze = an + 5816 | 0;
        Ke = an + 5752 | 0;
        qe = an + 5688 | 0;
        Ye = an + 5624 | 0;
        Ze = an + 5560 | 0;
        Je = an + 5496 | 0;
        Xe = an + 5432 | 0;
        $e = an + 5368 | 0;
        Qe = an + 5304 | 0;
        et = an + 5240 | 0;
        tt = an + 5176 | 0;
        at = an + 5112 | 0;
        rt = an + 5048 | 0;
        nt = an + 4984 | 0;
        st = an + 4920 | 0;
        ot = an + 4856 | 0;
        it = an + 4792 | 0;
        ct = an + 4728 | 0;
        ut = an + 4664 | 0;
        dt = an + 4600 | 0;
        ft = an + 4536 | 0;
        lt = an + 4472 | 0;
        ht = an + 4408 | 0;
        pt = an + 4344 | 0;
        bt = an + 4280 | 0;
        mt = an + 4216 | 0;
        yt = an + 4152 | 0;
        vt = an + 4088 | 0;
        _t = an + 4024 | 0;
        gt = an + 3960 | 0;
        At = an + 3896 | 0;
        wt = an + 3832 | 0;
        Tt = an + 3768 | 0;
        xt = an + 3704 | 0;
        Dt = an + 3640 | 0;
        Ct = an + 3576 | 0;
        St = an + 3512 | 0;
        Et = an + 3448 | 0;
        Bt = an + 3384 | 0;
        kt = an + 3320 | 0;
        Rt = an + 3256 | 0;
        Wt = an + 3192 | 0;
        It = an + 3128 | 0;
        Nt = an + 3064 | 0;
        ha = an + 3e3 | 0;
        pa = an + 2936 | 0;
        Ca = an + 2872 | 0;
        ba = an + 2808 | 0;
        ma = an + 2744 | 0;
        _a = an + 2680 | 0;
        Ua = an + 2488 | 0;
        La = an + 2296 | 0;
        Wa = an + 2168 | 0;
        Oa = an + 2040 | 0;
        Ia = an + 1912 | 0;
        Mt = an + 1720 | 0;
        Pt = an + 1528 | 0;
        Lt = an + 1496 | 0;
        Ha = an + 12712 | 0;
        Fa = an + 1304 | 0;
        Sr = an + 1160 | 0;
        Br = an + 776 | 0;
        kr = an + 384 | 0;
        Rr = an + 256 | 0;
        Wr = an + 192 | 0;
        r = an + 128 | 0;
        n = an;
        va(tr, t);
        ya(Za, a);
        t = s[tr >> 2] | 0;
        ja = r;
        Ga = tr + 8 | 0;
        Va = ja + 64 | 0;

        do {
          s[ja >> 2] = s[Ga >> 2];
          ja = ja + 4 | 0;
          Ga = Ga + 4 | 0;
        } while ((ja | 0) < (Va | 0));

        a = s[Za >> 2] | 0;
        ja = n;
        Ga = Za + 8 | 0;
        Va = ja + 128 | 0;

        do {
          s[ja >> 2] = s[Ga >> 2];
          ja = ja + 4 | 0;
          Ga = Ga + 4 | 0;
        } while ((ja | 0) < (Va | 0));

        if ((t | 0) == 0 | (a | 0) == 0) {
          tn = e;
          s[tn >> 2] = -980480611;
          s[tn + 4 >> 2] = -748862579;
          tn = e + 8 | 0;
          s[tn >> 2] = -171504835;
          s[tn + 4 >> 2] = 175696680;
          tn = e + 16 | 0;
          s[tn >> 2] = 2021213740;
          s[tn + 4 >> 2] = 1718526831;
          tn = e + 24 | 0;
          s[tn >> 2] = -1710760145;
          s[tn + 4 >> 2] = 235567041;
          ed(e + 32 | 0, 0, 352) | 0;
          p = an;
          return;
        }

        ja = Rr;
        Ga = n;
        Va = ja + 128 | 0;

        do {
          s[ja >> 2] = s[Ga >> 2];
          ja = ja + 4 | 0;
          Ga = Ga + 4 | 0;
        } while ((ja | 0) < (Va | 0));

        ja = Wr;
        Ga = r;
        Va = ja + 64 | 0;

        do {
          s[ja >> 2] = s[Ga >> 2];
          ja = ja + 4 | 0;
          Ga = Ga + 4 | 0;
        } while ((ja | 0) < (Va | 0));

        ja = Fa;
        Ga = n;
        Va = ja + 64 | 0;

        do {
          s[ja >> 2] = s[Ga >> 2];
          ja = ja + 4 | 0;
          Ga = Ga + 4 | 0;
        } while ((ja | 0) < (Va | 0));

        Ne = Rr + 64 | 0;
        We = Fa + 64 | 0;
        ja = We;
        Ga = Ne;
        Va = ja + 64 | 0;

        do {
          s[ja >> 2] = s[Ga >> 2];
          ja = ja + 4 | 0;
          Ga = Ga + 4 | 0;
        } while ((ja | 0) < (Va | 0));

        Ie = Fa + 128 | 0;
        t = Fa + 128 | 0;
        s[t >> 2] = -980480611;
        s[t + 4 >> 2] = -748862579;
        t = Fa + 136 | 0;
        s[t >> 2] = -171504835;
        s[t + 4 >> 2] = 175696680;
        t = Fa + 144 | 0;
        s[t >> 2] = 2021213740;
        s[t + 4 >> 2] = 1718526831;
        t = Fa + 152 | 0;
        s[t >> 2] = -1710760145;
        s[t + 4 >> 2] = 235567041;
        t = Fa + 160 | 0;
        s[t >> 2] = 0;
        s[t + 4 >> 2] = 0;
        s[t + 8 >> 2] = 0;
        s[t + 12 >> 2] = 0;
        s[t + 16 >> 2] = 0;
        s[t + 20 >> 2] = 0;
        s[t + 24 >> 2] = 0;
        s[t + 28 >> 2] = 0;
        t = Gt(19584, 8, Za) | 0;

        if (!t) {
          s[Za >> 2] = 0;
          Vt(Za);
        }

        s[Ha >> 2] = t;
        Me = Ha + 4 | 0;
        s[Me >> 2] = 102;
        Ot = Ha + 8 | 0;
        s[Ot >> 2] = 0;
        r = Lt;
        s[r >> 2] = -1099547736;
        s[r + 4 >> 2] = -1652985799;
        r = Lt + 8 | 0;
        s[r >> 2] = 1;
        s[r + 4 >> 2] = 0;
        r = Lt + 16 | 0;
        s[r >> 2] = 0;
        s[r + 4 >> 2] = 0;
        s[r + 8 >> 2] = 0;
        s[r + 12 >> 2] = 0;
        r = Pt + 64 | 0;
        n = Pt + 128 | 0;
        o = ra + 8 | 0;
        i = ra + 16 | 0;
        c = ra + 24 | 0;
        u = It + 32 | 0;
        d = ta + 8 | 0;
        f = ta + 16 | 0;
        l = ta + 24 | 0;
        h = Nt + 32 | 0;
        b = Ct + 32 | 0;
        y = Dt + 32 | 0;
        v = St + 32 | 0;
        _ = xt + 32 | 0;
        g = Et + 32 | 0;
        A = wt + 8 | 0;
        w = wt + 16 | 0;
        T = wt + 24 | 0;
        x = wt + 32 | 0;
        D = wt + 40 | 0;
        C = wt + 48 | 0;
        E = wt + 56 | 0;
        B = vt + 32 | 0;
        k = yt + 32 | 0;
        R = _t + 32 | 0;
        W = mt + 32 | 0;
        I = gt + 32 | 0;
        N = ht + 32 | 0;
        M = lt + 32 | 0;
        P = pt + 32 | 0;
        L = ur + 8 | 0;
        O = ur + 16 | 0;
        F = ur + 24 | 0;
        j = ir + 8 | 0;
        G = ir + 16 | 0;
        V = ir + 24 | 0;
        U = bt + 32 | 0;
        H = ct + 32 | 0;
        z = it + 32 | 0;
        K = ut + 32 | 0;
        q = st + 32 | 0;
        Y = nt + 32 | 0;
        Z = ot + 32 | 0;
        J = dt + 32 | 0;
        X = ft + 32 | 0;
        Q = at + 32 | 0;
        ae = tt + 32 | 0;
        ne = rt + 32 | 0;
        se = Ze + 32 | 0;
        oe = Ye + 32 | 0;
        ie = Je + 32 | 0;
        ce = Ue + 32 | 0;
        ue = Ve + 32 | 0;
        de = He + 32 | 0;
        fe = Ge + 32 | 0;
        le = ze + 32 | 0;
        he = Ke + 32 | 0;
        pe = qe + 32 | 0;
        be = Pe + 8 | 0;
        ye = Pe + 16 | 0;
        ve = Pe + 24 | 0;
        _e = Pe + 32 | 0;
        ge = Pe + 40 | 0;
        Ae = Pe + 48 | 0;
        we = Pe + 56 | 0;
        Te = da + 32 | 0;
        xe = fa + 32 | 0;
        De = ia + 32 | 0;
        Ce = oa + 32 | 0;
        Se = ca + 32 | 0;
        Be = sa + 32 | 0;
        ke = ua + 32 | 0;
        t = 0;
        Re = 256;

        e: while (1) {
          Re = Re + -1 | 0;
          a = Lt + (Re >>> 6 << 3) | 0;
          Ga = s[a >> 2] | 0;
          a = s[a + 4 >> 2] | 0;
          Va = od(1, 0, Re & 63 | 0) | 0;
          a = (Ga & Va | 0) != 0 | (a & S | 0) != 0;

          do {
            if (t) {
              ja = Wt;
              Ga = Fa;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              ja = Rt;
              Ga = We;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              m = 0;
              re(15, It | 0, Wt | 0, Rt | 0);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[na >> 2] = s[It >> 2];
              s[na + 4 >> 2] = s[It + 4 >> 2];
              s[na + 8 >> 2] = s[It + 8 >> 2];
              s[na + 12 >> 2] = s[It + 12 >> 2];
              s[na + 16 >> 2] = s[It + 16 >> 2];
              s[na + 20 >> 2] = s[It + 20 >> 2];
              s[na + 24 >> 2] = s[It + 24 >> 2];
              s[na + 28 >> 2] = s[It + 28 >> 2];
              Va = ra;
              s[Va >> 2] = 1325794674;
              s[Va + 4 >> 2] = -2017531950;
              Va = o;
              s[Va >> 2] = 790391525;
              s[Va + 4 >> 2] = -788714787;
              Va = i;
              s[Va >> 2] = -50507964;
              s[Va + 4 >> 2] = -1889569646;
              Va = c;
              s[Va >> 2] = 1033682860;
              s[Va + 4 >> 2] = 523723546;
              m = 0;
              $(1, na | 0, ra | 0, 136, -460954743, -2016278654);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[Nt >> 2] = s[na >> 2];
              s[Nt + 4 >> 2] = s[na + 4 >> 2];
              s[Nt + 8 >> 2] = s[na + 8 >> 2];
              s[Nt + 12 >> 2] = s[na + 12 >> 2];
              s[Nt + 16 >> 2] = s[na + 16 >> 2];
              s[Nt + 20 >> 2] = s[na + 20 >> 2];
              s[Nt + 24 >> 2] = s[na + 24 >> 2];
              s[Nt + 28 >> 2] = s[na + 28 >> 2];
              s[aa >> 2] = s[u >> 2];
              s[aa + 4 >> 2] = s[u + 4 >> 2];
              s[aa + 8 >> 2] = s[u + 8 >> 2];
              s[aa + 12 >> 2] = s[u + 12 >> 2];
              s[aa + 16 >> 2] = s[u + 16 >> 2];
              s[aa + 20 >> 2] = s[u + 20 >> 2];
              s[aa + 24 >> 2] = s[u + 24 >> 2];
              s[aa + 28 >> 2] = s[u + 28 >> 2];
              Va = ta;
              s[Va >> 2] = 1325794674;
              s[Va + 4 >> 2] = -2017531950;
              Va = d;
              s[Va >> 2] = 790391525;
              s[Va + 4 >> 2] = -788714787;
              Va = f;
              s[Va >> 2] = -50507964;
              s[Va + 4 >> 2] = -1889569646;
              Va = l;
              s[Va >> 2] = 1033682860;
              s[Va + 4 >> 2] = 523723546;
              m = 0;
              $(1, aa | 0, ta | 0, 136, -460954743, -2016278654);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[tn >> 2] = s[aa >> 2];
              s[tn + 4 >> 2] = s[aa + 4 >> 2];
              s[tn + 8 >> 2] = s[aa + 8 >> 2];
              s[tn + 12 >> 2] = s[aa + 12 >> 2];
              s[tn + 16 >> 2] = s[aa + 16 >> 2];
              s[tn + 20 >> 2] = s[aa + 20 >> 2];
              s[tn + 24 >> 2] = s[aa + 24 >> 2];
              s[tn + 28 >> 2] = s[aa + 28 >> 2];
              s[h >> 2] = s[tn >> 2];
              s[h + 4 >> 2] = s[tn + 4 >> 2];
              s[h + 8 >> 2] = s[tn + 8 >> 2];
              s[h + 12 >> 2] = s[tn + 12 >> 2];
              s[h + 16 >> 2] = s[tn + 16 >> 2];
              s[h + 20 >> 2] = s[tn + 20 >> 2];
              s[h + 24 >> 2] = s[tn + 24 >> 2];
              s[h + 28 >> 2] = s[tn + 28 >> 2];
              m = 0;
              te(17, kt | 0, We | 0);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              m = 0;
              te(17, Bt | 0, Ie | 0);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              ja = Ct;
              Ga = Bt;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              ja = Dt;
              Ga = Bt;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              s[ea >> 2] = s[Ct >> 2];
              s[ea + 4 >> 2] = s[Ct + 4 >> 2];
              s[ea + 8 >> 2] = s[Ct + 8 >> 2];
              s[ea + 12 >> 2] = s[Ct + 12 >> 2];
              s[ea + 16 >> 2] = s[Ct + 16 >> 2];
              s[ea + 20 >> 2] = s[Ct + 20 >> 2];
              s[ea + 24 >> 2] = s[Ct + 24 >> 2];
              s[ea + 28 >> 2] = s[Ct + 28 >> 2];
              s[Qt >> 2] = s[Bt >> 2];
              s[Qt + 4 >> 2] = s[Bt + 4 >> 2];
              s[Qt + 8 >> 2] = s[Bt + 8 >> 2];
              s[Qt + 12 >> 2] = s[Bt + 12 >> 2];
              s[Qt + 16 >> 2] = s[Bt + 16 >> 2];
              s[Qt + 20 >> 2] = s[Bt + 20 >> 2];
              s[Qt + 24 >> 2] = s[Bt + 24 >> 2];
              s[Qt + 28 >> 2] = s[Bt + 28 >> 2];
              m = 0;
              re(16, ea | 0, Qt | 0, 136);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[St >> 2] = s[ea >> 2];
              s[St + 4 >> 2] = s[ea + 4 >> 2];
              s[St + 8 >> 2] = s[ea + 8 >> 2];
              s[St + 12 >> 2] = s[ea + 12 >> 2];
              s[St + 16 >> 2] = s[ea + 16 >> 2];
              s[St + 20 >> 2] = s[ea + 20 >> 2];
              s[St + 24 >> 2] = s[ea + 24 >> 2];
              s[St + 28 >> 2] = s[ea + 28 >> 2];
              s[$t >> 2] = s[b >> 2];
              s[$t + 4 >> 2] = s[b + 4 >> 2];
              s[$t + 8 >> 2] = s[b + 8 >> 2];
              s[$t + 12 >> 2] = s[b + 12 >> 2];
              s[$t + 16 >> 2] = s[b + 16 >> 2];
              s[$t + 20 >> 2] = s[b + 20 >> 2];
              s[$t + 24 >> 2] = s[b + 24 >> 2];
              s[$t + 28 >> 2] = s[b + 28 >> 2];
              s[Xt >> 2] = s[y >> 2];
              s[Xt + 4 >> 2] = s[y + 4 >> 2];
              s[Xt + 8 >> 2] = s[y + 8 >> 2];
              s[Xt + 12 >> 2] = s[y + 12 >> 2];
              s[Xt + 16 >> 2] = s[y + 16 >> 2];
              s[Xt + 20 >> 2] = s[y + 20 >> 2];
              s[Xt + 24 >> 2] = s[y + 24 >> 2];
              s[Xt + 28 >> 2] = s[y + 28 >> 2];
              m = 0;
              re(16, $t | 0, Xt | 0, 136);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[tn >> 2] = s[$t >> 2];
              s[tn + 4 >> 2] = s[$t + 4 >> 2];
              s[tn + 8 >> 2] = s[$t + 8 >> 2];
              s[tn + 12 >> 2] = s[$t + 12 >> 2];
              s[tn + 16 >> 2] = s[$t + 16 >> 2];
              s[tn + 20 >> 2] = s[$t + 20 >> 2];
              s[tn + 24 >> 2] = s[$t + 24 >> 2];
              s[tn + 28 >> 2] = s[$t + 28 >> 2];
              s[v >> 2] = s[tn >> 2];
              s[v + 4 >> 2] = s[tn + 4 >> 2];
              s[v + 8 >> 2] = s[tn + 8 >> 2];
              s[v + 12 >> 2] = s[tn + 12 >> 2];
              s[v + 16 >> 2] = s[tn + 16 >> 2];
              s[v + 20 >> 2] = s[tn + 20 >> 2];
              s[v + 24 >> 2] = s[tn + 24 >> 2];
              s[v + 28 >> 2] = s[tn + 28 >> 2];
              ja = xt;
              Ga = Bt;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              s[Jt >> 2] = s[St >> 2];
              s[Jt + 4 >> 2] = s[St + 4 >> 2];
              s[Jt + 8 >> 2] = s[St + 8 >> 2];
              s[Jt + 12 >> 2] = s[St + 12 >> 2];
              s[Jt + 16 >> 2] = s[St + 16 >> 2];
              s[Jt + 20 >> 2] = s[St + 20 >> 2];
              s[Jt + 24 >> 2] = s[St + 24 >> 2];
              s[Jt + 28 >> 2] = s[St + 28 >> 2];
              s[Zt >> 2] = s[Bt >> 2];
              s[Zt + 4 >> 2] = s[Bt + 4 >> 2];
              s[Zt + 8 >> 2] = s[Bt + 8 >> 2];
              s[Zt + 12 >> 2] = s[Bt + 12 >> 2];
              s[Zt + 16 >> 2] = s[Bt + 16 >> 2];
              s[Zt + 20 >> 2] = s[Bt + 20 >> 2];
              s[Zt + 24 >> 2] = s[Bt + 24 >> 2];
              s[Zt + 28 >> 2] = s[Bt + 28 >> 2];
              m = 0;
              re(16, Jt | 0, Zt | 0, 136);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[Et >> 2] = s[Jt >> 2];
              s[Et + 4 >> 2] = s[Jt + 4 >> 2];
              s[Et + 8 >> 2] = s[Jt + 8 >> 2];
              s[Et + 12 >> 2] = s[Jt + 12 >> 2];
              s[Et + 16 >> 2] = s[Jt + 16 >> 2];
              s[Et + 20 >> 2] = s[Jt + 20 >> 2];
              s[Et + 24 >> 2] = s[Jt + 24 >> 2];
              s[Et + 28 >> 2] = s[Jt + 28 >> 2];
              s[Yt >> 2] = s[v >> 2];
              s[Yt + 4 >> 2] = s[v + 4 >> 2];
              s[Yt + 8 >> 2] = s[v + 8 >> 2];
              s[Yt + 12 >> 2] = s[v + 12 >> 2];
              s[Yt + 16 >> 2] = s[v + 16 >> 2];
              s[Yt + 20 >> 2] = s[v + 20 >> 2];
              s[Yt + 24 >> 2] = s[v + 24 >> 2];
              s[Yt + 28 >> 2] = s[v + 28 >> 2];
              s[qt >> 2] = s[_ >> 2];
              s[qt + 4 >> 2] = s[_ + 4 >> 2];
              s[qt + 8 >> 2] = s[_ + 8 >> 2];
              s[qt + 12 >> 2] = s[_ + 12 >> 2];
              s[qt + 16 >> 2] = s[_ + 16 >> 2];
              s[qt + 20 >> 2] = s[_ + 20 >> 2];
              s[qt + 24 >> 2] = s[_ + 24 >> 2];
              s[qt + 28 >> 2] = s[_ + 28 >> 2];
              m = 0;
              re(16, Yt | 0, qt | 0, 136);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[tn >> 2] = s[Yt >> 2];
              s[tn + 4 >> 2] = s[Yt + 4 >> 2];
              s[tn + 8 >> 2] = s[Yt + 8 >> 2];
              s[tn + 12 >> 2] = s[Yt + 12 >> 2];
              s[tn + 16 >> 2] = s[Yt + 16 >> 2];
              s[tn + 20 >> 2] = s[Yt + 20 >> 2];
              s[tn + 24 >> 2] = s[Yt + 24 >> 2];
              s[tn + 28 >> 2] = s[Yt + 28 >> 2];
              s[g >> 2] = s[tn >> 2];
              s[g + 4 >> 2] = s[tn + 4 >> 2];
              s[g + 8 >> 2] = s[tn + 8 >> 2];
              s[g + 12 >> 2] = s[tn + 12 >> 2];
              s[g + 16 >> 2] = s[tn + 16 >> 2];
              s[g + 20 >> 2] = s[tn + 20 >> 2];
              s[g + 24 >> 2] = s[tn + 24 >> 2];
              s[g + 28 >> 2] = s[tn + 28 >> 2];
              ja = wt;
              s[ja >> 2] = 2008548008;
              s[ja + 4 >> 2] = 1006188771;
              ja = A;
              s[ja >> 2] = 909333341;
              s[ja + 4 >> 2] = 34282279;
              ja = w;
              s[ja >> 2] = 1232425568;
              s[ja + 4 >> 2] = 649588208;
              ja = T;
              s[ja >> 2] = 1132767341;
              s[ja + 4 >> 2] = 622118450;
              ja = x;
              s[ja >> 2] = -774045849;
              s[ja + 4 >> 2] = 954723532;
              ja = D;
              s[ja >> 2] = -1815212738;
              s[ja + 4 >> 2] = 1710273405;
              ja = C;
              s[ja >> 2] = 581697706;
              s[ja + 4 >> 2] = -683028259;
              ja = E;
              s[ja >> 2] = 1248365901;
              s[ja + 4 >> 2] = 21084622;
              ja = At;
              Ga = Et;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              m = 0;
              re(15, Tt | 0, wt | 0, At | 0);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              ja = vt;
              Ga = Tt;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              ja = yt;
              Ga = Tt;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              s[Kt >> 2] = s[vt >> 2];
              s[Kt + 4 >> 2] = s[vt + 4 >> 2];
              s[Kt + 8 >> 2] = s[vt + 8 >> 2];
              s[Kt + 12 >> 2] = s[vt + 12 >> 2];
              s[Kt + 16 >> 2] = s[vt + 16 >> 2];
              s[Kt + 20 >> 2] = s[vt + 20 >> 2];
              s[Kt + 24 >> 2] = s[vt + 24 >> 2];
              s[Kt + 28 >> 2] = s[vt + 28 >> 2];
              s[zt >> 2] = s[Tt >> 2];
              s[zt + 4 >> 2] = s[Tt + 4 >> 2];
              s[zt + 8 >> 2] = s[Tt + 8 >> 2];
              s[zt + 12 >> 2] = s[Tt + 12 >> 2];
              s[zt + 16 >> 2] = s[Tt + 16 >> 2];
              s[zt + 20 >> 2] = s[Tt + 20 >> 2];
              s[zt + 24 >> 2] = s[Tt + 24 >> 2];
              s[zt + 28 >> 2] = s[Tt + 28 >> 2];
              m = 0;
              re(16, Kt | 0, zt | 0, 136);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[_t >> 2] = s[Kt >> 2];
              s[_t + 4 >> 2] = s[Kt + 4 >> 2];
              s[_t + 8 >> 2] = s[Kt + 8 >> 2];
              s[_t + 12 >> 2] = s[Kt + 12 >> 2];
              s[_t + 16 >> 2] = s[Kt + 16 >> 2];
              s[_t + 20 >> 2] = s[Kt + 20 >> 2];
              s[_t + 24 >> 2] = s[Kt + 24 >> 2];
              s[_t + 28 >> 2] = s[Kt + 28 >> 2];
              s[Ht >> 2] = s[B >> 2];
              s[Ht + 4 >> 2] = s[B + 4 >> 2];
              s[Ht + 8 >> 2] = s[B + 8 >> 2];
              s[Ht + 12 >> 2] = s[B + 12 >> 2];
              s[Ht + 16 >> 2] = s[B + 16 >> 2];
              s[Ht + 20 >> 2] = s[B + 20 >> 2];
              s[Ht + 24 >> 2] = s[B + 24 >> 2];
              s[Ht + 28 >> 2] = s[B + 28 >> 2];
              s[jt >> 2] = s[k >> 2];
              s[jt + 4 >> 2] = s[k + 4 >> 2];
              s[jt + 8 >> 2] = s[k + 8 >> 2];
              s[jt + 12 >> 2] = s[k + 12 >> 2];
              s[jt + 16 >> 2] = s[k + 16 >> 2];
              s[jt + 20 >> 2] = s[k + 20 >> 2];
              s[jt + 24 >> 2] = s[k + 24 >> 2];
              s[jt + 28 >> 2] = s[k + 28 >> 2];
              m = 0;
              re(16, Ht | 0, jt | 0, 136);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[tn >> 2] = s[Ht >> 2];
              s[tn + 4 >> 2] = s[Ht + 4 >> 2];
              s[tn + 8 >> 2] = s[Ht + 8 >> 2];
              s[tn + 12 >> 2] = s[Ht + 12 >> 2];
              s[tn + 16 >> 2] = s[Ht + 16 >> 2];
              s[tn + 20 >> 2] = s[Ht + 20 >> 2];
              s[tn + 24 >> 2] = s[Ht + 24 >> 2];
              s[tn + 28 >> 2] = s[Ht + 28 >> 2];
              s[R >> 2] = s[tn >> 2];
              s[R + 4 >> 2] = s[tn + 4 >> 2];
              s[R + 8 >> 2] = s[tn + 8 >> 2];
              s[R + 12 >> 2] = s[tn + 12 >> 2];
              s[R + 16 >> 2] = s[tn + 16 >> 2];
              s[R + 20 >> 2] = s[tn + 20 >> 2];
              s[R + 24 >> 2] = s[tn + 24 >> 2];
              s[R + 28 >> 2] = s[tn + 28 >> 2];
              ja = mt;
              Ga = Tt;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              s[Ft >> 2] = s[_t >> 2];
              s[Ft + 4 >> 2] = s[_t + 4 >> 2];
              s[Ft + 8 >> 2] = s[_t + 8 >> 2];
              s[Ft + 12 >> 2] = s[_t + 12 >> 2];
              s[Ft + 16 >> 2] = s[_t + 16 >> 2];
              s[Ft + 20 >> 2] = s[_t + 20 >> 2];
              s[Ft + 24 >> 2] = s[_t + 24 >> 2];
              s[Ft + 28 >> 2] = s[_t + 28 >> 2];
              s[en >> 2] = s[Tt >> 2];
              s[en + 4 >> 2] = s[Tt + 4 >> 2];
              s[en + 8 >> 2] = s[Tt + 8 >> 2];
              s[en + 12 >> 2] = s[Tt + 12 >> 2];
              s[en + 16 >> 2] = s[Tt + 16 >> 2];
              s[en + 20 >> 2] = s[Tt + 20 >> 2];
              s[en + 24 >> 2] = s[Tt + 24 >> 2];
              s[en + 28 >> 2] = s[Tt + 28 >> 2];
              m = 0;
              re(16, Ft | 0, en | 0, 136);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[gt >> 2] = s[Ft >> 2];
              s[gt + 4 >> 2] = s[Ft + 4 >> 2];
              s[gt + 8 >> 2] = s[Ft + 8 >> 2];
              s[gt + 12 >> 2] = s[Ft + 12 >> 2];
              s[gt + 16 >> 2] = s[Ft + 16 >> 2];
              s[gt + 20 >> 2] = s[Ft + 20 >> 2];
              s[gt + 24 >> 2] = s[Ft + 24 >> 2];
              s[gt + 28 >> 2] = s[Ft + 28 >> 2];
              s[yr >> 2] = s[R >> 2];
              s[yr + 4 >> 2] = s[R + 4 >> 2];
              s[yr + 8 >> 2] = s[R + 8 >> 2];
              s[yr + 12 >> 2] = s[R + 12 >> 2];
              s[yr + 16 >> 2] = s[R + 16 >> 2];
              s[yr + 20 >> 2] = s[R + 20 >> 2];
              s[yr + 24 >> 2] = s[R + 24 >> 2];
              s[yr + 28 >> 2] = s[R + 28 >> 2];
              s[br >> 2] = s[W >> 2];
              s[br + 4 >> 2] = s[W + 4 >> 2];
              s[br + 8 >> 2] = s[W + 8 >> 2];
              s[br + 12 >> 2] = s[W + 12 >> 2];
              s[br + 16 >> 2] = s[W + 16 >> 2];
              s[br + 20 >> 2] = s[W + 20 >> 2];
              s[br + 24 >> 2] = s[W + 24 >> 2];
              s[br + 28 >> 2] = s[W + 28 >> 2];
              m = 0;
              re(16, yr | 0, br | 0, 136);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[tn >> 2] = s[yr >> 2];
              s[tn + 4 >> 2] = s[yr + 4 >> 2];
              s[tn + 8 >> 2] = s[yr + 8 >> 2];
              s[tn + 12 >> 2] = s[yr + 12 >> 2];
              s[tn + 16 >> 2] = s[yr + 16 >> 2];
              s[tn + 20 >> 2] = s[yr + 20 >> 2];
              s[tn + 24 >> 2] = s[yr + 24 >> 2];
              s[tn + 28 >> 2] = s[yr + 28 >> 2];
              s[I >> 2] = s[tn >> 2];
              s[I + 4 >> 2] = s[tn + 4 >> 2];
              s[I + 8 >> 2] = s[tn + 8 >> 2];
              s[I + 12 >> 2] = s[tn + 12 >> 2];
              s[I + 16 >> 2] = s[tn + 16 >> 2];
              s[I + 20 >> 2] = s[tn + 20 >> 2];
              s[I + 24 >> 2] = s[tn + 24 >> 2];
              s[I + 28 >> 2] = s[tn + 28 >> 2];
              ja = ht;
              Ga = kt;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              ja = lt;
              Ga = gt;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              s[pr >> 2] = s[kt >> 2];
              s[pr + 4 >> 2] = s[kt + 4 >> 2];
              s[pr + 8 >> 2] = s[kt + 8 >> 2];
              s[pr + 12 >> 2] = s[kt + 12 >> 2];
              s[pr + 16 >> 2] = s[kt + 16 >> 2];
              s[pr + 20 >> 2] = s[kt + 20 >> 2];
              s[pr + 24 >> 2] = s[kt + 24 >> 2];
              s[pr + 28 >> 2] = s[kt + 28 >> 2];
              s[hr >> 2] = s[gt >> 2];
              s[hr + 4 >> 2] = s[gt + 4 >> 2];
              s[hr + 8 >> 2] = s[gt + 8 >> 2];
              s[hr + 12 >> 2] = s[gt + 12 >> 2];
              s[hr + 16 >> 2] = s[gt + 16 >> 2];
              s[hr + 20 >> 2] = s[gt + 20 >> 2];
              s[hr + 24 >> 2] = s[gt + 24 >> 2];
              s[hr + 28 >> 2] = s[gt + 28 >> 2];
              m = 0;
              re(16, pr | 0, hr | 0, 136);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[pt >> 2] = s[pr >> 2];
              s[pt + 4 >> 2] = s[pr + 4 >> 2];
              s[pt + 8 >> 2] = s[pr + 8 >> 2];
              s[pt + 12 >> 2] = s[pr + 12 >> 2];
              s[pt + 16 >> 2] = s[pr + 16 >> 2];
              s[pt + 20 >> 2] = s[pr + 20 >> 2];
              s[pt + 24 >> 2] = s[pr + 24 >> 2];
              s[pt + 28 >> 2] = s[pr + 28 >> 2];
              s[lr >> 2] = s[N >> 2];
              s[lr + 4 >> 2] = s[N + 4 >> 2];
              s[lr + 8 >> 2] = s[N + 8 >> 2];
              s[lr + 12 >> 2] = s[N + 12 >> 2];
              s[lr + 16 >> 2] = s[N + 16 >> 2];
              s[lr + 20 >> 2] = s[N + 20 >> 2];
              s[lr + 24 >> 2] = s[N + 24 >> 2];
              s[lr + 28 >> 2] = s[N + 28 >> 2];
              s[fr >> 2] = s[M >> 2];
              s[fr + 4 >> 2] = s[M + 4 >> 2];
              s[fr + 8 >> 2] = s[M + 8 >> 2];
              s[fr + 12 >> 2] = s[M + 12 >> 2];
              s[fr + 16 >> 2] = s[M + 16 >> 2];
              s[fr + 20 >> 2] = s[M + 20 >> 2];
              s[fr + 24 >> 2] = s[M + 24 >> 2];
              s[fr + 28 >> 2] = s[M + 28 >> 2];
              m = 0;
              re(16, lr | 0, fr | 0, 136);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[tn >> 2] = s[lr >> 2];
              s[tn + 4 >> 2] = s[lr + 4 >> 2];
              s[tn + 8 >> 2] = s[lr + 8 >> 2];
              s[tn + 12 >> 2] = s[lr + 12 >> 2];
              s[tn + 16 >> 2] = s[lr + 16 >> 2];
              s[tn + 20 >> 2] = s[lr + 20 >> 2];
              s[tn + 24 >> 2] = s[lr + 24 >> 2];
              s[tn + 28 >> 2] = s[lr + 28 >> 2];
              s[P >> 2] = s[tn >> 2];
              s[P + 4 >> 2] = s[tn + 4 >> 2];
              s[P + 8 >> 2] = s[tn + 8 >> 2];
              s[P + 12 >> 2] = s[tn + 12 >> 2];
              s[P + 16 >> 2] = s[tn + 16 >> 2];
              s[P + 20 >> 2] = s[tn + 20 >> 2];
              s[P + 24 >> 2] = s[tn + 24 >> 2];
              s[P + 28 >> 2] = s[tn + 28 >> 2];
              s[dr >> 2] = s[pt >> 2];
              s[dr + 4 >> 2] = s[pt + 4 >> 2];
              s[dr + 8 >> 2] = s[pt + 8 >> 2];
              s[dr + 12 >> 2] = s[pt + 12 >> 2];
              s[dr + 16 >> 2] = s[pt + 16 >> 2];
              s[dr + 20 >> 2] = s[pt + 20 >> 2];
              s[dr + 24 >> 2] = s[pt + 24 >> 2];
              s[dr + 28 >> 2] = s[pt + 28 >> 2];
              Va = ur;
              s[Va >> 2] = 1325794674;
              s[Va + 4 >> 2] = -2017531950;
              Va = L;
              s[Va >> 2] = 790391525;
              s[Va + 4 >> 2] = -788714787;
              Va = O;
              s[Va >> 2] = -50507964;
              s[Va + 4 >> 2] = -1889569646;
              Va = F;
              s[Va >> 2] = 1033682860;
              s[Va + 4 >> 2] = 523723546;
              m = 0;
              $(1, dr | 0, ur | 0, 136, -460954743, -2016278654);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[bt >> 2] = s[dr >> 2];
              s[bt + 4 >> 2] = s[dr + 4 >> 2];
              s[bt + 8 >> 2] = s[dr + 8 >> 2];
              s[bt + 12 >> 2] = s[dr + 12 >> 2];
              s[bt + 16 >> 2] = s[dr + 16 >> 2];
              s[bt + 20 >> 2] = s[dr + 20 >> 2];
              s[bt + 24 >> 2] = s[dr + 24 >> 2];
              s[bt + 28 >> 2] = s[dr + 28 >> 2];
              s[cr >> 2] = s[P >> 2];
              s[cr + 4 >> 2] = s[P + 4 >> 2];
              s[cr + 8 >> 2] = s[P + 8 >> 2];
              s[cr + 12 >> 2] = s[P + 12 >> 2];
              s[cr + 16 >> 2] = s[P + 16 >> 2];
              s[cr + 20 >> 2] = s[P + 20 >> 2];
              s[cr + 24 >> 2] = s[P + 24 >> 2];
              s[cr + 28 >> 2] = s[P + 28 >> 2];
              Va = ir;
              s[Va >> 2] = 1325794674;
              s[Va + 4 >> 2] = -2017531950;
              Va = j;
              s[Va >> 2] = 790391525;
              s[Va + 4 >> 2] = -788714787;
              Va = G;
              s[Va >> 2] = -50507964;
              s[Va + 4 >> 2] = -1889569646;
              Va = V;
              s[Va >> 2] = 1033682860;
              s[Va + 4 >> 2] = 523723546;
              m = 0;
              $(1, cr | 0, ir | 0, 136, -460954743, -2016278654);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[tn >> 2] = s[cr >> 2];
              s[tn + 4 >> 2] = s[cr + 4 >> 2];
              s[tn + 8 >> 2] = s[cr + 8 >> 2];
              s[tn + 12 >> 2] = s[cr + 12 >> 2];
              s[tn + 16 >> 2] = s[cr + 16 >> 2];
              s[tn + 20 >> 2] = s[cr + 20 >> 2];
              s[tn + 24 >> 2] = s[cr + 24 >> 2];
              s[tn + 28 >> 2] = s[cr + 28 >> 2];
              s[U >> 2] = s[tn >> 2];
              s[U + 4 >> 2] = s[tn + 4 >> 2];
              s[U + 8 >> 2] = s[tn + 8 >> 2];
              s[U + 12 >> 2] = s[tn + 12 >> 2];
              s[U + 16 >> 2] = s[tn + 16 >> 2];
              s[U + 20 >> 2] = s[tn + 20 >> 2];
              s[U + 24 >> 2] = s[tn + 24 >> 2];
              s[U + 28 >> 2] = s[tn + 28 >> 2];
              ja = ct;
              Ga = We;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              ja = it;
              Ga = Ie;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              s[or >> 2] = s[We >> 2];
              s[or + 4 >> 2] = s[We + 4 >> 2];
              s[or + 8 >> 2] = s[We + 8 >> 2];
              s[or + 12 >> 2] = s[We + 12 >> 2];
              s[or + 16 >> 2] = s[We + 16 >> 2];
              s[or + 20 >> 2] = s[We + 20 >> 2];
              s[or + 24 >> 2] = s[We + 24 >> 2];
              s[or + 28 >> 2] = s[We + 28 >> 2];
              s[nr >> 2] = s[Ie >> 2];
              s[nr + 4 >> 2] = s[Ie + 4 >> 2];
              s[nr + 8 >> 2] = s[Ie + 8 >> 2];
              s[nr + 12 >> 2] = s[Ie + 12 >> 2];
              s[nr + 16 >> 2] = s[Ie + 16 >> 2];
              s[nr + 20 >> 2] = s[Ie + 20 >> 2];
              s[nr + 24 >> 2] = s[Ie + 24 >> 2];
              s[nr + 28 >> 2] = s[Ie + 28 >> 2];
              m = 0;
              re(16, or | 0, nr | 0, 136);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[ut >> 2] = s[or >> 2];
              s[ut + 4 >> 2] = s[or + 4 >> 2];
              s[ut + 8 >> 2] = s[or + 8 >> 2];
              s[ut + 12 >> 2] = s[or + 12 >> 2];
              s[ut + 16 >> 2] = s[or + 16 >> 2];
              s[ut + 20 >> 2] = s[or + 20 >> 2];
              s[ut + 24 >> 2] = s[or + 24 >> 2];
              s[ut + 28 >> 2] = s[or + 28 >> 2];
              s[rr >> 2] = s[H >> 2];
              s[rr + 4 >> 2] = s[H + 4 >> 2];
              s[rr + 8 >> 2] = s[H + 8 >> 2];
              s[rr + 12 >> 2] = s[H + 12 >> 2];
              s[rr + 16 >> 2] = s[H + 16 >> 2];
              s[rr + 20 >> 2] = s[H + 20 >> 2];
              s[rr + 24 >> 2] = s[H + 24 >> 2];
              s[rr + 28 >> 2] = s[H + 28 >> 2];
              s[ar >> 2] = s[z >> 2];
              s[ar + 4 >> 2] = s[z + 4 >> 2];
              s[ar + 8 >> 2] = s[z + 8 >> 2];
              s[ar + 12 >> 2] = s[z + 12 >> 2];
              s[ar + 16 >> 2] = s[z + 16 >> 2];
              s[ar + 20 >> 2] = s[z + 20 >> 2];
              s[ar + 24 >> 2] = s[z + 24 >> 2];
              s[ar + 28 >> 2] = s[z + 28 >> 2];
              m = 0;
              re(16, rr | 0, ar | 0, 136);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[tn >> 2] = s[rr >> 2];
              s[tn + 4 >> 2] = s[rr + 4 >> 2];
              s[tn + 8 >> 2] = s[rr + 8 >> 2];
              s[tn + 12 >> 2] = s[rr + 12 >> 2];
              s[tn + 16 >> 2] = s[rr + 16 >> 2];
              s[tn + 20 >> 2] = s[rr + 20 >> 2];
              s[tn + 24 >> 2] = s[rr + 24 >> 2];
              s[tn + 28 >> 2] = s[rr + 28 >> 2];
              s[K >> 2] = s[tn >> 2];
              s[K + 4 >> 2] = s[tn + 4 >> 2];
              s[K + 8 >> 2] = s[tn + 8 >> 2];
              s[K + 12 >> 2] = s[tn + 12 >> 2];
              s[K + 16 >> 2] = s[tn + 16 >> 2];
              s[K + 20 >> 2] = s[tn + 20 >> 2];
              s[K + 24 >> 2] = s[tn + 24 >> 2];
              s[K + 28 >> 2] = s[tn + 28 >> 2];
              m = 0;
              te(17, dt | 0, ut | 0);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              ja = st;
              Ga = kt;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              ja = nt;
              Ga = Bt;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              s[Qr >> 2] = s[kt >> 2];
              s[Qr + 4 >> 2] = s[kt + 4 >> 2];
              s[Qr + 8 >> 2] = s[kt + 8 >> 2];
              s[Qr + 12 >> 2] = s[kt + 12 >> 2];
              s[Qr + 16 >> 2] = s[kt + 16 >> 2];
              s[Qr + 20 >> 2] = s[kt + 20 >> 2];
              s[Qr + 24 >> 2] = s[kt + 24 >> 2];
              s[Qr + 28 >> 2] = s[kt + 28 >> 2];
              s[$r >> 2] = s[Bt >> 2];
              s[$r + 4 >> 2] = s[Bt + 4 >> 2];
              s[$r + 8 >> 2] = s[Bt + 8 >> 2];
              s[$r + 12 >> 2] = s[Bt + 12 >> 2];
              s[$r + 16 >> 2] = s[Bt + 16 >> 2];
              s[$r + 20 >> 2] = s[Bt + 20 >> 2];
              s[$r + 24 >> 2] = s[Bt + 24 >> 2];
              s[$r + 28 >> 2] = s[Bt + 28 >> 2];
              m = 0;
              re(16, Qr | 0, $r | 0, 136);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[ot >> 2] = s[Qr >> 2];
              s[ot + 4 >> 2] = s[Qr + 4 >> 2];
              s[ot + 8 >> 2] = s[Qr + 8 >> 2];
              s[ot + 12 >> 2] = s[Qr + 12 >> 2];
              s[ot + 16 >> 2] = s[Qr + 16 >> 2];
              s[ot + 20 >> 2] = s[Qr + 20 >> 2];
              s[ot + 24 >> 2] = s[Qr + 24 >> 2];
              s[ot + 28 >> 2] = s[Qr + 28 >> 2];
              s[Xr >> 2] = s[q >> 2];
              s[Xr + 4 >> 2] = s[q + 4 >> 2];
              s[Xr + 8 >> 2] = s[q + 8 >> 2];
              s[Xr + 12 >> 2] = s[q + 12 >> 2];
              s[Xr + 16 >> 2] = s[q + 16 >> 2];
              s[Xr + 20 >> 2] = s[q + 20 >> 2];
              s[Xr + 24 >> 2] = s[q + 24 >> 2];
              s[Xr + 28 >> 2] = s[q + 28 >> 2];
              s[Jr >> 2] = s[Y >> 2];
              s[Jr + 4 >> 2] = s[Y + 4 >> 2];
              s[Jr + 8 >> 2] = s[Y + 8 >> 2];
              s[Jr + 12 >> 2] = s[Y + 12 >> 2];
              s[Jr + 16 >> 2] = s[Y + 16 >> 2];
              s[Jr + 20 >> 2] = s[Y + 20 >> 2];
              s[Jr + 24 >> 2] = s[Y + 24 >> 2];
              s[Jr + 28 >> 2] = s[Y + 28 >> 2];
              m = 0;
              re(16, Xr | 0, Jr | 0, 136);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[tn >> 2] = s[Xr >> 2];
              s[tn + 4 >> 2] = s[Xr + 4 >> 2];
              s[tn + 8 >> 2] = s[Xr + 8 >> 2];
              s[tn + 12 >> 2] = s[Xr + 12 >> 2];
              s[tn + 16 >> 2] = s[Xr + 16 >> 2];
              s[tn + 20 >> 2] = s[Xr + 20 >> 2];
              s[tn + 24 >> 2] = s[Xr + 24 >> 2];
              s[tn + 28 >> 2] = s[Xr + 28 >> 2];
              s[Z >> 2] = s[tn >> 2];
              s[Z + 4 >> 2] = s[tn + 4 >> 2];
              s[Z + 8 >> 2] = s[tn + 8 >> 2];
              s[Z + 12 >> 2] = s[tn + 12 >> 2];
              s[Z + 16 >> 2] = s[tn + 16 >> 2];
              s[Z + 20 >> 2] = s[tn + 20 >> 2];
              s[Z + 24 >> 2] = s[tn + 24 >> 2];
              s[Z + 28 >> 2] = s[tn + 28 >> 2];
              s[Zr >> 2] = s[dt >> 2];
              s[Zr + 4 >> 2] = s[dt + 4 >> 2];
              s[Zr + 8 >> 2] = s[dt + 8 >> 2];
              s[Zr + 12 >> 2] = s[dt + 12 >> 2];
              s[Zr + 16 >> 2] = s[dt + 16 >> 2];
              s[Zr + 20 >> 2] = s[dt + 20 >> 2];
              s[Zr + 24 >> 2] = s[dt + 24 >> 2];
              s[Zr + 28 >> 2] = s[dt + 28 >> 2];
              s[Yr >> 2] = s[ot >> 2];
              s[Yr + 4 >> 2] = s[ot + 4 >> 2];
              s[Yr + 8 >> 2] = s[ot + 8 >> 2];
              s[Yr + 12 >> 2] = s[ot + 12 >> 2];
              s[Yr + 16 >> 2] = s[ot + 16 >> 2];
              s[Yr + 20 >> 2] = s[ot + 20 >> 2];
              s[Yr + 24 >> 2] = s[ot + 24 >> 2];
              s[Yr + 28 >> 2] = s[ot + 28 >> 2];
              m = 0;
              re(17, Zr | 0, Yr | 0, 136);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[ft >> 2] = s[Zr >> 2];
              s[ft + 4 >> 2] = s[Zr + 4 >> 2];
              s[ft + 8 >> 2] = s[Zr + 8 >> 2];
              s[ft + 12 >> 2] = s[Zr + 12 >> 2];
              s[ft + 16 >> 2] = s[Zr + 16 >> 2];
              s[ft + 20 >> 2] = s[Zr + 20 >> 2];
              s[ft + 24 >> 2] = s[Zr + 24 >> 2];
              s[ft + 28 >> 2] = s[Zr + 28 >> 2];
              s[qr >> 2] = s[J >> 2];
              s[qr + 4 >> 2] = s[J + 4 >> 2];
              s[qr + 8 >> 2] = s[J + 8 >> 2];
              s[qr + 12 >> 2] = s[J + 12 >> 2];
              s[qr + 16 >> 2] = s[J + 16 >> 2];
              s[qr + 20 >> 2] = s[J + 20 >> 2];
              s[qr + 24 >> 2] = s[J + 24 >> 2];
              s[qr + 28 >> 2] = s[J + 28 >> 2];
              s[Kr >> 2] = s[Z >> 2];
              s[Kr + 4 >> 2] = s[Z + 4 >> 2];
              s[Kr + 8 >> 2] = s[Z + 8 >> 2];
              s[Kr + 12 >> 2] = s[Z + 12 >> 2];
              s[Kr + 16 >> 2] = s[Z + 16 >> 2];
              s[Kr + 20 >> 2] = s[Z + 20 >> 2];
              s[Kr + 24 >> 2] = s[Z + 24 >> 2];
              s[Kr + 28 >> 2] = s[Z + 28 >> 2];
              m = 0;
              re(17, qr | 0, Kr | 0, 136);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[tn >> 2] = s[qr >> 2];
              s[tn + 4 >> 2] = s[qr + 4 >> 2];
              s[tn + 8 >> 2] = s[qr + 8 >> 2];
              s[tn + 12 >> 2] = s[qr + 12 >> 2];
              s[tn + 16 >> 2] = s[qr + 16 >> 2];
              s[tn + 20 >> 2] = s[qr + 20 >> 2];
              s[tn + 24 >> 2] = s[qr + 24 >> 2];
              s[tn + 28 >> 2] = s[qr + 28 >> 2];
              s[X >> 2] = s[tn >> 2];
              s[X + 4 >> 2] = s[tn + 4 >> 2];
              s[X + 8 >> 2] = s[tn + 8 >> 2];
              s[X + 12 >> 2] = s[tn + 12 >> 2];
              s[X + 16 >> 2] = s[tn + 16 >> 2];
              s[X + 20 >> 2] = s[tn + 20 >> 2];
              s[X + 24 >> 2] = s[tn + 24 >> 2];
              s[X + 28 >> 2] = s[tn + 28 >> 2];
              ja = at;
              Ga = Tt;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              ja = tt;
              Ga = kt;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              s[zr >> 2] = s[Tt >> 2];
              s[zr + 4 >> 2] = s[Tt + 4 >> 2];
              s[zr + 8 >> 2] = s[Tt + 8 >> 2];
              s[zr + 12 >> 2] = s[Tt + 12 >> 2];
              s[zr + 16 >> 2] = s[Tt + 16 >> 2];
              s[zr + 20 >> 2] = s[Tt + 20 >> 2];
              s[zr + 24 >> 2] = s[Tt + 24 >> 2];
              s[zr + 28 >> 2] = s[Tt + 28 >> 2];
              s[Hr >> 2] = s[kt >> 2];
              s[Hr + 4 >> 2] = s[kt + 4 >> 2];
              s[Hr + 8 >> 2] = s[kt + 8 >> 2];
              s[Hr + 12 >> 2] = s[kt + 12 >> 2];
              s[Hr + 16 >> 2] = s[kt + 16 >> 2];
              s[Hr + 20 >> 2] = s[kt + 20 >> 2];
              s[Hr + 24 >> 2] = s[kt + 24 >> 2];
              s[Hr + 28 >> 2] = s[kt + 28 >> 2];
              m = 0;
              re(17, zr | 0, Hr | 0, 136);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[rt >> 2] = s[zr >> 2];
              s[rt + 4 >> 2] = s[zr + 4 >> 2];
              s[rt + 8 >> 2] = s[zr + 8 >> 2];
              s[rt + 12 >> 2] = s[zr + 12 >> 2];
              s[rt + 16 >> 2] = s[zr + 16 >> 2];
              s[rt + 20 >> 2] = s[zr + 20 >> 2];
              s[rt + 24 >> 2] = s[zr + 24 >> 2];
              s[rt + 28 >> 2] = s[zr + 28 >> 2];
              s[Ur >> 2] = s[Q >> 2];
              s[Ur + 4 >> 2] = s[Q + 4 >> 2];
              s[Ur + 8 >> 2] = s[Q + 8 >> 2];
              s[Ur + 12 >> 2] = s[Q + 12 >> 2];
              s[Ur + 16 >> 2] = s[Q + 16 >> 2];
              s[Ur + 20 >> 2] = s[Q + 20 >> 2];
              s[Ur + 24 >> 2] = s[Q + 24 >> 2];
              s[Ur + 28 >> 2] = s[Q + 28 >> 2];
              s[Vr >> 2] = s[ae >> 2];
              s[Vr + 4 >> 2] = s[ae + 4 >> 2];
              s[Vr + 8 >> 2] = s[ae + 8 >> 2];
              s[Vr + 12 >> 2] = s[ae + 12 >> 2];
              s[Vr + 16 >> 2] = s[ae + 16 >> 2];
              s[Vr + 20 >> 2] = s[ae + 20 >> 2];
              s[Vr + 24 >> 2] = s[ae + 24 >> 2];
              s[Vr + 28 >> 2] = s[ae + 28 >> 2];
              m = 0;
              re(17, Ur | 0, Vr | 0, 136);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[tn >> 2] = s[Ur >> 2];
              s[tn + 4 >> 2] = s[Ur + 4 >> 2];
              s[tn + 8 >> 2] = s[Ur + 8 >> 2];
              s[tn + 12 >> 2] = s[Ur + 12 >> 2];
              s[tn + 16 >> 2] = s[Ur + 16 >> 2];
              s[tn + 20 >> 2] = s[Ur + 20 >> 2];
              s[tn + 24 >> 2] = s[Ur + 24 >> 2];
              s[tn + 28 >> 2] = s[Ur + 28 >> 2];
              s[ne >> 2] = s[tn >> 2];
              s[ne + 4 >> 2] = s[tn + 4 >> 2];
              s[ne + 8 >> 2] = s[tn + 8 >> 2];
              s[ne + 12 >> 2] = s[tn + 12 >> 2];
              s[ne + 16 >> 2] = s[tn + 16 >> 2];
              s[ne + 20 >> 2] = s[tn + 20 >> 2];
              s[ne + 24 >> 2] = s[tn + 24 >> 2];
              s[ne + 28 >> 2] = s[tn + 28 >> 2];
              m = 0;
              te(17, et | 0, Fa | 0);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              m = 0;
              te(17, Qe | 0, Tt | 0);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              ja = Xe;
              Ga = Nt;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              ja = Ze;
              Ga = kt;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              ja = Ye;
              Ga = gt;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              s[er >> 2] = s[kt >> 2];
              s[er + 4 >> 2] = s[kt + 4 >> 2];
              s[er + 8 >> 2] = s[kt + 8 >> 2];
              s[er + 12 >> 2] = s[kt + 12 >> 2];
              s[er + 16 >> 2] = s[kt + 16 >> 2];
              s[er + 20 >> 2] = s[kt + 20 >> 2];
              s[er + 24 >> 2] = s[kt + 24 >> 2];
              s[er + 28 >> 2] = s[kt + 28 >> 2];
              s[Qa >> 2] = s[gt >> 2];
              s[Qa + 4 >> 2] = s[gt + 4 >> 2];
              s[Qa + 8 >> 2] = s[gt + 8 >> 2];
              s[Qa + 12 >> 2] = s[gt + 12 >> 2];
              s[Qa + 16 >> 2] = s[gt + 16 >> 2];
              s[Qa + 20 >> 2] = s[gt + 20 >> 2];
              s[Qa + 24 >> 2] = s[gt + 24 >> 2];
              s[Qa + 28 >> 2] = s[gt + 28 >> 2];
              m = 0;
              re(17, er | 0, Qa | 0, 136);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[Je >> 2] = s[er >> 2];
              s[Je + 4 >> 2] = s[er + 4 >> 2];
              s[Je + 8 >> 2] = s[er + 8 >> 2];
              s[Je + 12 >> 2] = s[er + 12 >> 2];
              s[Je + 16 >> 2] = s[er + 16 >> 2];
              s[Je + 20 >> 2] = s[er + 20 >> 2];
              s[Je + 24 >> 2] = s[er + 24 >> 2];
              s[Je + 28 >> 2] = s[er + 28 >> 2];
              s[$a >> 2] = s[se >> 2];
              s[$a + 4 >> 2] = s[se + 4 >> 2];
              s[$a + 8 >> 2] = s[se + 8 >> 2];
              s[$a + 12 >> 2] = s[se + 12 >> 2];
              s[$a + 16 >> 2] = s[se + 16 >> 2];
              s[$a + 20 >> 2] = s[se + 20 >> 2];
              s[$a + 24 >> 2] = s[se + 24 >> 2];
              s[$a + 28 >> 2] = s[se + 28 >> 2];
              s[Xa >> 2] = s[oe >> 2];
              s[Xa + 4 >> 2] = s[oe + 4 >> 2];
              s[Xa + 8 >> 2] = s[oe + 8 >> 2];
              s[Xa + 12 >> 2] = s[oe + 12 >> 2];
              s[Xa + 16 >> 2] = s[oe + 16 >> 2];
              s[Xa + 20 >> 2] = s[oe + 20 >> 2];
              s[Xa + 24 >> 2] = s[oe + 24 >> 2];
              s[Xa + 28 >> 2] = s[oe + 28 >> 2];
              m = 0;
              re(17, $a | 0, Xa | 0, 136);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[tn >> 2] = s[$a >> 2];
              s[tn + 4 >> 2] = s[$a + 4 >> 2];
              s[tn + 8 >> 2] = s[$a + 8 >> 2];
              s[tn + 12 >> 2] = s[$a + 12 >> 2];
              s[tn + 16 >> 2] = s[$a + 16 >> 2];
              s[tn + 20 >> 2] = s[$a + 20 >> 2];
              s[tn + 24 >> 2] = s[$a + 24 >> 2];
              s[tn + 28 >> 2] = s[$a + 28 >> 2];
              s[ie >> 2] = s[tn >> 2];
              s[ie + 4 >> 2] = s[tn + 4 >> 2];
              s[ie + 8 >> 2] = s[tn + 8 >> 2];
              s[ie + 12 >> 2] = s[tn + 12 >> 2];
              s[ie + 16 >> 2] = s[tn + 16 >> 2];
              s[ie + 20 >> 2] = s[tn + 20 >> 2];
              s[ie + 24 >> 2] = s[tn + 24 >> 2];
              s[ie + 28 >> 2] = s[tn + 28 >> 2];
              m = 0;
              re(15, $e | 0, Xe | 0, Je | 0);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              ja = Fa;
              Ga = $e;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              m = 0;
              te(17, Ke | 0, bt | 0);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              ja = Ue;
              Ga = Qe;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              ja = Ve;
              Ga = Qe;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              s[Ja >> 2] = s[Ue >> 2];
              s[Ja + 4 >> 2] = s[Ue + 4 >> 2];
              s[Ja + 8 >> 2] = s[Ue + 8 >> 2];
              s[Ja + 12 >> 2] = s[Ue + 12 >> 2];
              s[Ja + 16 >> 2] = s[Ue + 16 >> 2];
              s[Ja + 20 >> 2] = s[Ue + 20 >> 2];
              s[Ja + 24 >> 2] = s[Ue + 24 >> 2];
              s[Ja + 28 >> 2] = s[Ue + 28 >> 2];
              s[Ya >> 2] = s[Qe >> 2];
              s[Ya + 4 >> 2] = s[Qe + 4 >> 2];
              s[Ya + 8 >> 2] = s[Qe + 8 >> 2];
              s[Ya + 12 >> 2] = s[Qe + 12 >> 2];
              s[Ya + 16 >> 2] = s[Qe + 16 >> 2];
              s[Ya + 20 >> 2] = s[Qe + 20 >> 2];
              s[Ya + 24 >> 2] = s[Qe + 24 >> 2];
              s[Ya + 28 >> 2] = s[Qe + 28 >> 2];
              m = 0;
              re(16, Ja | 0, Ya | 0, 136);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[He >> 2] = s[Ja >> 2];
              s[He + 4 >> 2] = s[Ja + 4 >> 2];
              s[He + 8 >> 2] = s[Ja + 8 >> 2];
              s[He + 12 >> 2] = s[Ja + 12 >> 2];
              s[He + 16 >> 2] = s[Ja + 16 >> 2];
              s[He + 20 >> 2] = s[Ja + 20 >> 2];
              s[He + 24 >> 2] = s[Ja + 24 >> 2];
              s[He + 28 >> 2] = s[Ja + 28 >> 2];
              s[qa >> 2] = s[ce >> 2];
              s[qa + 4 >> 2] = s[ce + 4 >> 2];
              s[qa + 8 >> 2] = s[ce + 8 >> 2];
              s[qa + 12 >> 2] = s[ce + 12 >> 2];
              s[qa + 16 >> 2] = s[ce + 16 >> 2];
              s[qa + 20 >> 2] = s[ce + 20 >> 2];
              s[qa + 24 >> 2] = s[ce + 24 >> 2];
              s[qa + 28 >> 2] = s[ce + 28 >> 2];
              s[Ka >> 2] = s[ue >> 2];
              s[Ka + 4 >> 2] = s[ue + 4 >> 2];
              s[Ka + 8 >> 2] = s[ue + 8 >> 2];
              s[Ka + 12 >> 2] = s[ue + 12 >> 2];
              s[Ka + 16 >> 2] = s[ue + 16 >> 2];
              s[Ka + 20 >> 2] = s[ue + 20 >> 2];
              s[Ka + 24 >> 2] = s[ue + 24 >> 2];
              s[Ka + 28 >> 2] = s[ue + 28 >> 2];
              m = 0;
              re(16, qa | 0, Ka | 0, 136);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[tn >> 2] = s[qa >> 2];
              s[tn + 4 >> 2] = s[qa + 4 >> 2];
              s[tn + 8 >> 2] = s[qa + 8 >> 2];
              s[tn + 12 >> 2] = s[qa + 12 >> 2];
              s[tn + 16 >> 2] = s[qa + 16 >> 2];
              s[tn + 20 >> 2] = s[qa + 20 >> 2];
              s[tn + 24 >> 2] = s[qa + 24 >> 2];
              s[tn + 28 >> 2] = s[qa + 28 >> 2];
              s[de >> 2] = s[tn >> 2];
              s[de + 4 >> 2] = s[tn + 4 >> 2];
              s[de + 8 >> 2] = s[tn + 8 >> 2];
              s[de + 12 >> 2] = s[tn + 12 >> 2];
              s[de + 16 >> 2] = s[tn + 16 >> 2];
              s[de + 20 >> 2] = s[tn + 20 >> 2];
              s[de + 24 >> 2] = s[tn + 24 >> 2];
              s[de + 28 >> 2] = s[tn + 28 >> 2];
              ja = Ge;
              Ga = Qe;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              s[Gr >> 2] = s[He >> 2];
              s[Gr + 4 >> 2] = s[He + 4 >> 2];
              s[Gr + 8 >> 2] = s[He + 8 >> 2];
              s[Gr + 12 >> 2] = s[He + 12 >> 2];
              s[Gr + 16 >> 2] = s[He + 16 >> 2];
              s[Gr + 20 >> 2] = s[He + 20 >> 2];
              s[Gr + 24 >> 2] = s[He + 24 >> 2];
              s[Gr + 28 >> 2] = s[He + 28 >> 2];
              s[jr >> 2] = s[Qe >> 2];
              s[jr + 4 >> 2] = s[Qe + 4 >> 2];
              s[jr + 8 >> 2] = s[Qe + 8 >> 2];
              s[jr + 12 >> 2] = s[Qe + 12 >> 2];
              s[jr + 16 >> 2] = s[Qe + 16 >> 2];
              s[jr + 20 >> 2] = s[Qe + 20 >> 2];
              s[jr + 24 >> 2] = s[Qe + 24 >> 2];
              s[jr + 28 >> 2] = s[Qe + 28 >> 2];
              m = 0;
              re(16, Gr | 0, jr | 0, 136);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[ze >> 2] = s[Gr >> 2];
              s[ze + 4 >> 2] = s[Gr + 4 >> 2];
              s[ze + 8 >> 2] = s[Gr + 8 >> 2];
              s[ze + 12 >> 2] = s[Gr + 12 >> 2];
              s[ze + 16 >> 2] = s[Gr + 16 >> 2];
              s[ze + 20 >> 2] = s[Gr + 20 >> 2];
              s[ze + 24 >> 2] = s[Gr + 24 >> 2];
              s[ze + 28 >> 2] = s[Gr + 28 >> 2];
              s[Fr >> 2] = s[de >> 2];
              s[Fr + 4 >> 2] = s[de + 4 >> 2];
              s[Fr + 8 >> 2] = s[de + 8 >> 2];
              s[Fr + 12 >> 2] = s[de + 12 >> 2];
              s[Fr + 16 >> 2] = s[de + 16 >> 2];
              s[Fr + 20 >> 2] = s[de + 20 >> 2];
              s[Fr + 24 >> 2] = s[de + 24 >> 2];
              s[Fr + 28 >> 2] = s[de + 28 >> 2];
              s[Or >> 2] = s[fe >> 2];
              s[Or + 4 >> 2] = s[fe + 4 >> 2];
              s[Or + 8 >> 2] = s[fe + 8 >> 2];
              s[Or + 12 >> 2] = s[fe + 12 >> 2];
              s[Or + 16 >> 2] = s[fe + 16 >> 2];
              s[Or + 20 >> 2] = s[fe + 20 >> 2];
              s[Or + 24 >> 2] = s[fe + 24 >> 2];
              s[Or + 28 >> 2] = s[fe + 28 >> 2];
              m = 0;
              re(16, Fr | 0, Or | 0, 136);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[tn >> 2] = s[Fr >> 2];
              s[tn + 4 >> 2] = s[Fr + 4 >> 2];
              s[tn + 8 >> 2] = s[Fr + 8 >> 2];
              s[tn + 12 >> 2] = s[Fr + 12 >> 2];
              s[tn + 16 >> 2] = s[Fr + 16 >> 2];
              s[tn + 20 >> 2] = s[Fr + 20 >> 2];
              s[tn + 24 >> 2] = s[Fr + 24 >> 2];
              s[tn + 28 >> 2] = s[Fr + 28 >> 2];
              s[le >> 2] = s[tn >> 2];
              s[le + 4 >> 2] = s[tn + 4 >> 2];
              s[le + 8 >> 2] = s[tn + 8 >> 2];
              s[le + 12 >> 2] = s[tn + 12 >> 2];
              s[le + 16 >> 2] = s[tn + 16 >> 2];
              s[le + 20 >> 2] = s[tn + 20 >> 2];
              s[le + 24 >> 2] = s[tn + 24 >> 2];
              s[le + 28 >> 2] = s[tn + 28 >> 2];
              s[Lr >> 2] = s[Ke >> 2];
              s[Lr + 4 >> 2] = s[Ke + 4 >> 2];
              s[Lr + 8 >> 2] = s[Ke + 8 >> 2];
              s[Lr + 12 >> 2] = s[Ke + 12 >> 2];
              s[Lr + 16 >> 2] = s[Ke + 16 >> 2];
              s[Lr + 20 >> 2] = s[Ke + 20 >> 2];
              s[Lr + 24 >> 2] = s[Ke + 24 >> 2];
              s[Lr + 28 >> 2] = s[Ke + 28 >> 2];
              s[Pr >> 2] = s[ze >> 2];
              s[Pr + 4 >> 2] = s[ze + 4 >> 2];
              s[Pr + 8 >> 2] = s[ze + 8 >> 2];
              s[Pr + 12 >> 2] = s[ze + 12 >> 2];
              s[Pr + 16 >> 2] = s[ze + 16 >> 2];
              s[Pr + 20 >> 2] = s[ze + 20 >> 2];
              s[Pr + 24 >> 2] = s[ze + 24 >> 2];
              s[Pr + 28 >> 2] = s[ze + 28 >> 2];
              m = 0;
              re(17, Lr | 0, Pr | 0, 136);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[qe >> 2] = s[Lr >> 2];
              s[qe + 4 >> 2] = s[Lr + 4 >> 2];
              s[qe + 8 >> 2] = s[Lr + 8 >> 2];
              s[qe + 12 >> 2] = s[Lr + 12 >> 2];
              s[qe + 16 >> 2] = s[Lr + 16 >> 2];
              s[qe + 20 >> 2] = s[Lr + 20 >> 2];
              s[qe + 24 >> 2] = s[Lr + 24 >> 2];
              s[qe + 28 >> 2] = s[Lr + 28 >> 2];
              s[Mr >> 2] = s[he >> 2];
              s[Mr + 4 >> 2] = s[he + 4 >> 2];
              s[Mr + 8 >> 2] = s[he + 8 >> 2];
              s[Mr + 12 >> 2] = s[he + 12 >> 2];
              s[Mr + 16 >> 2] = s[he + 16 >> 2];
              s[Mr + 20 >> 2] = s[he + 20 >> 2];
              s[Mr + 24 >> 2] = s[he + 24 >> 2];
              s[Mr + 28 >> 2] = s[he + 28 >> 2];
              s[Nr >> 2] = s[le >> 2];
              s[Nr + 4 >> 2] = s[le + 4 >> 2];
              s[Nr + 8 >> 2] = s[le + 8 >> 2];
              s[Nr + 12 >> 2] = s[le + 12 >> 2];
              s[Nr + 16 >> 2] = s[le + 16 >> 2];
              s[Nr + 20 >> 2] = s[le + 20 >> 2];
              s[Nr + 24 >> 2] = s[le + 24 >> 2];
              s[Nr + 28 >> 2] = s[le + 28 >> 2];
              m = 0;
              re(17, Mr | 0, Nr | 0, 136);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[tn >> 2] = s[Mr >> 2];
              s[tn + 4 >> 2] = s[Mr + 4 >> 2];
              s[tn + 8 >> 2] = s[Mr + 8 >> 2];
              s[tn + 12 >> 2] = s[Mr + 12 >> 2];
              s[tn + 16 >> 2] = s[Mr + 16 >> 2];
              s[tn + 20 >> 2] = s[Mr + 20 >> 2];
              s[tn + 24 >> 2] = s[Mr + 24 >> 2];
              s[tn + 28 >> 2] = s[Mr + 28 >> 2];
              s[pe >> 2] = s[tn >> 2];
              s[pe + 4 >> 2] = s[tn + 4 >> 2];
              s[pe + 8 >> 2] = s[tn + 8 >> 2];
              s[pe + 12 >> 2] = s[tn + 12 >> 2];
              s[pe + 16 >> 2] = s[tn + 16 >> 2];
              s[pe + 20 >> 2] = s[tn + 20 >> 2];
              s[pe + 24 >> 2] = s[tn + 24 >> 2];
              s[pe + 28 >> 2] = s[tn + 28 >> 2];
              ja = We;
              Ga = qe;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              ja = Fe;
              Ga = kt;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              ja = Oe;
              Ga = ft;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              m = 0;
              re(15, je | 0, Fe | 0, Oe | 0);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              ja = Ie;
              Ga = je;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              ja = Pe;
              s[ja >> 2] = 1091403767;
              s[ja + 4 >> 2] = -167360562;
              ja = be;
              s[ja >> 2] = -753151983;
              s[ja + 4 >> 2] = 792555341;
              ja = ye;
              s[ja >> 2] = 960546513;
              s[ja + 4 >> 2] = 692269950;
              ja = ve;
              s[ja >> 2] = -1478256553;
              s[ja + 4 >> 2] = 496343272;
              ja = _e;
              s[ja >> 2] = -980480611;
              s[ja + 4 >> 2] = -748862579;
              ja = ge;
              s[ja >> 2] = -171504835;
              s[ja + 4 >> 2] = 175696680;
              ja = Ae;
              s[ja >> 2] = 2021213740;
              s[ja + 4 >> 2] = 1718526831;
              ja = we;
              s[ja >> 2] = -1710760145;
              s[ja + 4 >> 2] = 235567041;
              ja = la;
              Ga = rt;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              m = 0;
              re(15, Le | 0, Pe | 0, la | 0);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              ja = da;
              Ga = ft;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              s[Ir >> 2] = s[ft >> 2];
              s[Ir + 4 >> 2] = s[ft + 4 >> 2];
              s[Ir + 8 >> 2] = s[ft + 8 >> 2];
              s[Ir + 12 >> 2] = s[ft + 12 >> 2];
              s[Ir + 16 >> 2] = s[ft + 16 >> 2];
              s[Ir + 20 >> 2] = s[ft + 20 >> 2];
              s[Ir + 24 >> 2] = s[ft + 24 >> 2];
              s[Ir + 28 >> 2] = s[ft + 28 >> 2];
              m = 0;
              te(18, Ir | 0, 136);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[fa >> 2] = s[Ir >> 2];
              s[fa + 4 >> 2] = s[Ir + 4 >> 2];
              s[fa + 8 >> 2] = s[Ir + 8 >> 2];
              s[fa + 12 >> 2] = s[Ir + 12 >> 2];
              s[fa + 16 >> 2] = s[Ir + 16 >> 2];
              s[fa + 20 >> 2] = s[Ir + 20 >> 2];
              s[fa + 24 >> 2] = s[Ir + 24 >> 2];
              s[fa + 28 >> 2] = s[Ir + 28 >> 2];
              s[Er >> 2] = s[Te >> 2];
              s[Er + 4 >> 2] = s[Te + 4 >> 2];
              s[Er + 8 >> 2] = s[Te + 8 >> 2];
              s[Er + 12 >> 2] = s[Te + 12 >> 2];
              s[Er + 16 >> 2] = s[Te + 16 >> 2];
              s[Er + 20 >> 2] = s[Te + 20 >> 2];
              s[Er + 24 >> 2] = s[Te + 24 >> 2];
              s[Er + 28 >> 2] = s[Te + 28 >> 2];
              m = 0;
              te(18, Er | 0, 136);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[tn >> 2] = s[Er >> 2];
              s[tn + 4 >> 2] = s[Er + 4 >> 2];
              s[tn + 8 >> 2] = s[Er + 8 >> 2];
              s[tn + 12 >> 2] = s[Er + 12 >> 2];
              s[tn + 16 >> 2] = s[Er + 16 >> 2];
              s[tn + 20 >> 2] = s[Er + 20 >> 2];
              s[tn + 24 >> 2] = s[Er + 24 >> 2];
              s[tn + 28 >> 2] = s[Er + 28 >> 2];
              s[xe >> 2] = s[tn >> 2];
              s[xe + 4 >> 2] = s[tn + 4 >> 2];
              s[xe + 8 >> 2] = s[tn + 8 >> 2];
              s[xe + 12 >> 2] = s[tn + 12 >> 2];
              s[xe + 16 >> 2] = s[tn + 16 >> 2];
              s[xe + 20 >> 2] = s[tn + 20 >> 2];
              s[xe + 24 >> 2] = s[tn + 24 >> 2];
              s[xe + 28 >> 2] = s[tn + 28 >> 2];
              ja = ia;
              Ga = et;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              ja = oa;
              Ga = et;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              s[Cr >> 2] = s[ia >> 2];
              s[Cr + 4 >> 2] = s[ia + 4 >> 2];
              s[Cr + 8 >> 2] = s[ia + 8 >> 2];
              s[Cr + 12 >> 2] = s[ia + 12 >> 2];
              s[Cr + 16 >> 2] = s[ia + 16 >> 2];
              s[Cr + 20 >> 2] = s[ia + 20 >> 2];
              s[Cr + 24 >> 2] = s[ia + 24 >> 2];
              s[Cr + 28 >> 2] = s[ia + 28 >> 2];
              s[Dr >> 2] = s[et >> 2];
              s[Dr + 4 >> 2] = s[et + 4 >> 2];
              s[Dr + 8 >> 2] = s[et + 8 >> 2];
              s[Dr + 12 >> 2] = s[et + 12 >> 2];
              s[Dr + 16 >> 2] = s[et + 16 >> 2];
              s[Dr + 20 >> 2] = s[et + 20 >> 2];
              s[Dr + 24 >> 2] = s[et + 24 >> 2];
              s[Dr + 28 >> 2] = s[et + 28 >> 2];
              m = 0;
              re(16, Cr | 0, Dr | 0, 136);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[ca >> 2] = s[Cr >> 2];
              s[ca + 4 >> 2] = s[Cr + 4 >> 2];
              s[ca + 8 >> 2] = s[Cr + 8 >> 2];
              s[ca + 12 >> 2] = s[Cr + 12 >> 2];
              s[ca + 16 >> 2] = s[Cr + 16 >> 2];
              s[ca + 20 >> 2] = s[Cr + 20 >> 2];
              s[ca + 24 >> 2] = s[Cr + 24 >> 2];
              s[ca + 28 >> 2] = s[Cr + 28 >> 2];
              s[xr >> 2] = s[De >> 2];
              s[xr + 4 >> 2] = s[De + 4 >> 2];
              s[xr + 8 >> 2] = s[De + 8 >> 2];
              s[xr + 12 >> 2] = s[De + 12 >> 2];
              s[xr + 16 >> 2] = s[De + 16 >> 2];
              s[xr + 20 >> 2] = s[De + 20 >> 2];
              s[xr + 24 >> 2] = s[De + 24 >> 2];
              s[xr + 28 >> 2] = s[De + 28 >> 2];
              s[Tr >> 2] = s[Ce >> 2];
              s[Tr + 4 >> 2] = s[Ce + 4 >> 2];
              s[Tr + 8 >> 2] = s[Ce + 8 >> 2];
              s[Tr + 12 >> 2] = s[Ce + 12 >> 2];
              s[Tr + 16 >> 2] = s[Ce + 16 >> 2];
              s[Tr + 20 >> 2] = s[Ce + 20 >> 2];
              s[Tr + 24 >> 2] = s[Ce + 24 >> 2];
              s[Tr + 28 >> 2] = s[Ce + 28 >> 2];
              m = 0;
              re(16, xr | 0, Tr | 0, 136);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[tn >> 2] = s[xr >> 2];
              s[tn + 4 >> 2] = s[xr + 4 >> 2];
              s[tn + 8 >> 2] = s[xr + 8 >> 2];
              s[tn + 12 >> 2] = s[xr + 12 >> 2];
              s[tn + 16 >> 2] = s[xr + 16 >> 2];
              s[tn + 20 >> 2] = s[xr + 20 >> 2];
              s[tn + 24 >> 2] = s[xr + 24 >> 2];
              s[tn + 28 >> 2] = s[xr + 28 >> 2];
              s[Se >> 2] = s[tn >> 2];
              s[Se + 4 >> 2] = s[tn + 4 >> 2];
              s[Se + 8 >> 2] = s[tn + 8 >> 2];
              s[Se + 12 >> 2] = s[tn + 12 >> 2];
              s[Se + 16 >> 2] = s[tn + 16 >> 2];
              s[Se + 20 >> 2] = s[tn + 20 >> 2];
              s[Se + 24 >> 2] = s[tn + 24 >> 2];
              s[Se + 28 >> 2] = s[tn + 28 >> 2];
              ja = sa;
              Ga = et;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              s[wr >> 2] = s[ca >> 2];
              s[wr + 4 >> 2] = s[ca + 4 >> 2];
              s[wr + 8 >> 2] = s[ca + 8 >> 2];
              s[wr + 12 >> 2] = s[ca + 12 >> 2];
              s[wr + 16 >> 2] = s[ca + 16 >> 2];
              s[wr + 20 >> 2] = s[ca + 20 >> 2];
              s[wr + 24 >> 2] = s[ca + 24 >> 2];
              s[wr + 28 >> 2] = s[ca + 28 >> 2];
              s[Ar >> 2] = s[et >> 2];
              s[Ar + 4 >> 2] = s[et + 4 >> 2];
              s[Ar + 8 >> 2] = s[et + 8 >> 2];
              s[Ar + 12 >> 2] = s[et + 12 >> 2];
              s[Ar + 16 >> 2] = s[et + 16 >> 2];
              s[Ar + 20 >> 2] = s[et + 20 >> 2];
              s[Ar + 24 >> 2] = s[et + 24 >> 2];
              s[Ar + 28 >> 2] = s[et + 28 >> 2];
              m = 0;
              re(16, wr | 0, Ar | 0, 136);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[ua >> 2] = s[wr >> 2];
              s[ua + 4 >> 2] = s[wr + 4 >> 2];
              s[ua + 8 >> 2] = s[wr + 8 >> 2];
              s[ua + 12 >> 2] = s[wr + 12 >> 2];
              s[ua + 16 >> 2] = s[wr + 16 >> 2];
              s[ua + 20 >> 2] = s[wr + 20 >> 2];
              s[ua + 24 >> 2] = s[wr + 24 >> 2];
              s[ua + 28 >> 2] = s[wr + 28 >> 2];
              s[za >> 2] = s[Se >> 2];
              s[za + 4 >> 2] = s[Se + 4 >> 2];
              s[za + 8 >> 2] = s[Se + 8 >> 2];
              s[za + 12 >> 2] = s[Se + 12 >> 2];
              s[za + 16 >> 2] = s[Se + 16 >> 2];
              s[za + 20 >> 2] = s[Se + 20 >> 2];
              s[za + 24 >> 2] = s[Se + 24 >> 2];
              s[za + 28 >> 2] = s[Se + 28 >> 2];
              s[gr >> 2] = s[Be >> 2];
              s[gr + 4 >> 2] = s[Be + 4 >> 2];
              s[gr + 8 >> 2] = s[Be + 8 >> 2];
              s[gr + 12 >> 2] = s[Be + 12 >> 2];
              s[gr + 16 >> 2] = s[Be + 16 >> 2];
              s[gr + 20 >> 2] = s[Be + 20 >> 2];
              s[gr + 24 >> 2] = s[Be + 24 >> 2];
              s[gr + 28 >> 2] = s[Be + 28 >> 2];
              m = 0;
              re(16, za | 0, gr | 0, 136);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              s[tn >> 2] = s[za >> 2];
              s[tn + 4 >> 2] = s[za + 4 >> 2];
              s[tn + 8 >> 2] = s[za + 8 >> 2];
              s[tn + 12 >> 2] = s[za + 12 >> 2];
              s[tn + 16 >> 2] = s[za + 16 >> 2];
              s[tn + 20 >> 2] = s[za + 20 >> 2];
              s[tn + 24 >> 2] = s[za + 24 >> 2];
              s[tn + 28 >> 2] = s[za + 28 >> 2];
              s[ke >> 2] = s[tn >> 2];
              s[ke + 4 >> 2] = s[tn + 4 >> 2];
              s[ke + 8 >> 2] = s[tn + 8 >> 2];
              s[ke + 12 >> 2] = s[tn + 12 >> 2];
              s[ke + 16 >> 2] = s[tn + 16 >> 2];
              s[ke + 20 >> 2] = s[tn + 20 >> 2];
              s[ke + 24 >> 2] = s[tn + 24 >> 2];
              s[ke + 28 >> 2] = s[tn + 28 >> 2];
              ja = Pt;
              Ga = Le;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              ja = r;
              Ga = fa;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              ja = n;
              Ga = ua;
              Va = ja + 64 | 0;

              do {
                s[ja >> 2] = s[Ga >> 2];
                ja = ja + 4 | 0;
                Ga = Ga + 4 | 0;
              } while ((ja | 0) < (Va | 0));

              t = s[Ot >> 2] | 0;

              if ((t | 0) == (s[Me >> 2] | 0)) {
                m = 0;
                ee(42, Ha | 0);
                Va = m;
                m = 0;

                if (Va & 1) {
                  t = 82;
                  break e;
                }

                t = s[Ot >> 2] | 0;
              }

              id((s[Ha >> 2] | 0) + (t * 192 | 0) | 0, Pt | 0, 192) | 0;
              s[Ot >> 2] = t + 1;

              if (!a) {
                t = 1;
                break;
              }

              m = 0;
              re(18, Mt | 0, Fa | 0, Rr | 0);
              Va = m;
              m = 0;

              if (Va & 1) {
                t = 82;
                break e;
              }

              t = s[Ot >> 2] | 0;

              if ((t | 0) == (s[Me >> 2] | 0)) {
                m = 0;
                ee(42, Ha | 0);
                Va = m;
                m = 0;

                if (Va & 1) {
                  t = 82;
                  break e;
                }

                t = s[Ot >> 2] | 0;
              }

              id((s[Ha >> 2] | 0) + (t * 192 | 0) | 0, Mt | 0, 192) | 0;
              s[Ot >> 2] = t + 1;
              t = 1;
            } else t = a;
          } while (0);

          if (!Re) {
            t = 6;
            break;
          }
        }

        if ((t | 0) == 6) {
          Va = ma;
          s[Va >> 2] = 1164159792;
          s[Va + 4 >> 2] = -1250477296;
          Va = ma + 8 | 0;
          s[Va >> 2] = -1448450988;
          s[Va + 4 >> 2] = 880775624;
          Va = ma + 16 | 0;
          s[Va >> 2] = 606996881;
          s[Va + 4 >> 2] = 2046849319;
          Va = ma + 24 | 0;
          s[Va >> 2] = 293737708;
          s[Va + 4 >> 2] = 425114840;
          Va = ma + 32 | 0;
          s[Va >> 2] = -1599453353;
          s[Va + 4 >> 2] = 1854185246;
          Va = ma + 40 | 0;
          s[Va >> 2] = -1980198591;
          s[Va + 4 >> 2] = -1440973971;
          Va = ma + 48 | 0;
          s[Va >> 2] = -85931462;
          s[Va + 4 >> 2] = -1226370099;
          Va = ma + 56 | 0;
          s[Va >> 2] = 1317202883;
          s[Va + 4 >> 2] = 644435899;
          s[ba >> 2] = s[Rr >> 2];
          s[ba + 4 >> 2] = s[Rr + 4 >> 2];
          s[ba + 8 >> 2] = s[Rr + 8 >> 2];
          s[ba + 12 >> 2] = s[Rr + 12 >> 2];
          s[ba + 16 >> 2] = s[Rr + 16 >> 2];
          s[ba + 20 >> 2] = s[Rr + 20 >> 2];
          s[ba + 24 >> 2] = s[Rr + 24 >> 2];
          s[ba + 28 >> 2] = s[Rr + 28 >> 2];
          Va = Rr + 32 | 0;
          s[Ta >> 2] = s[Va >> 2];
          s[Ta + 4 >> 2] = s[Va + 4 >> 2];
          s[Ta + 8 >> 2] = s[Va + 8 >> 2];
          s[Ta + 12 >> 2] = s[Va + 12 >> 2];
          s[Ta + 16 >> 2] = s[Va + 16 >> 2];
          s[Ta + 20 >> 2] = s[Va + 20 >> 2];
          s[Ta + 24 >> 2] = s[Va + 24 >> 2];
          s[Ta + 28 >> 2] = s[Va + 28 >> 2];
          Va = wa;
          s[Va >> 2] = 317583274;
          s[Va + 4 >> 2] = 1757628553;
          Va = wa + 8 | 0;
          s[Va >> 2] = 1923792719;
          s[Va + 4 >> 2] = -1928822936;
          Va = wa + 16 | 0;
          s[Va >> 2] = 151523889;
          s[Va + 4 >> 2] = 1373741639;
          Va = wa + 24 | 0;
          s[Va >> 2] = 1193918714;
          s[Va + 4 >> 2] = 576313009;
          m = 0;
          $(1, Ta | 0, wa | 0, 136, -460954743, -2016278654);
          Va = m;
          m = 0;

          if (Va & 1) {
            an = me() | 0;
            xa(Ha);
            Ee(an | 0);
          }

          s[tn >> 2] = s[Ta >> 2];
          s[tn + 4 >> 2] = s[Ta + 4 >> 2];
          s[tn + 8 >> 2] = s[Ta + 8 >> 2];
          s[tn + 12 >> 2] = s[Ta + 12 >> 2];
          s[tn + 16 >> 2] = s[Ta + 16 >> 2];
          s[tn + 20 >> 2] = s[Ta + 20 >> 2];
          s[tn + 24 >> 2] = s[Ta + 24 >> 2];
          s[tn + 28 >> 2] = s[Ta + 28 >> 2];
          Va = ba + 32 | 0;
          s[Va >> 2] = s[tn >> 2];
          s[Va + 4 >> 2] = s[tn + 4 >> 2];
          s[Va + 8 >> 2] = s[tn + 8 >> 2];
          s[Va + 12 >> 2] = s[tn + 12 >> 2];
          s[Va + 16 >> 2] = s[tn + 16 >> 2];
          s[Va + 20 >> 2] = s[tn + 20 >> 2];
          s[Va + 24 >> 2] = s[tn + 24 >> 2];
          s[Va + 28 >> 2] = s[tn + 28 >> 2];
          m = 0;
          re(15, _a | 0, ma | 0, ba | 0);
          Va = m;
          m = 0;

          if (Va & 1) {
            an = me() | 0;
            xa(Ha);
            Ee(an | 0);
          }

          Va = pa;
          s[Va >> 2] = 691451433;
          s[Va + 4 >> 2] = -457450228;
          Va = pa + 8 | 0;
          s[Va >> 2] = -516703541;
          s[Va + 4 >> 2] = -1154420382;
          Va = pa + 16 | 0;
          s[Va >> 2] = -110865562;
          s[Va + 4 >> 2] = 833212854;
          Va = pa + 24 | 0;
          s[Va >> 2] = -1526662947;
          s[Va + 4 >> 2] = 624259262;
          Va = pa + 32 | 0;
          s[Va >> 2] = 1610512327;
          s[Va + 4 >> 2] = -1579713308;
          Va = pa + 40 | 0;
          s[Va >> 2] = 2015810011;
          s[Va + 4 >> 2] = 128974097;
          Va = pa + 48 | 0;
          s[Va >> 2] = -1149313941;
          s[Va + 4 >> 2] = 1830206759;
          Va = pa + 56 | 0;
          s[Va >> 2] = -2048983348;
          s[Va + 4 >> 2] = 747053058;
          s[ha >> 2] = s[Ne >> 2];
          s[ha + 4 >> 2] = s[Ne + 4 >> 2];
          s[ha + 8 >> 2] = s[Ne + 8 >> 2];
          s[ha + 12 >> 2] = s[Ne + 12 >> 2];
          s[ha + 16 >> 2] = s[Ne + 16 >> 2];
          s[ha + 20 >> 2] = s[Ne + 20 >> 2];
          s[ha + 24 >> 2] = s[Ne + 24 >> 2];
          s[ha + 28 >> 2] = s[Ne + 28 >> 2];
          Va = Rr + 96 | 0;
          s[Aa >> 2] = s[Va >> 2];
          s[Aa + 4 >> 2] = s[Va + 4 >> 2];
          s[Aa + 8 >> 2] = s[Va + 8 >> 2];
          s[Aa + 12 >> 2] = s[Va + 12 >> 2];
          s[Aa + 16 >> 2] = s[Va + 16 >> 2];
          s[Aa + 20 >> 2] = s[Va + 20 >> 2];
          s[Aa + 24 >> 2] = s[Va + 24 >> 2];
          s[Aa + 28 >> 2] = s[Va + 28 >> 2];
          Va = ga;
          s[Va >> 2] = 317583274;
          s[Va + 4 >> 2] = 1757628553;
          Va = ga + 8 | 0;
          s[Va >> 2] = 1923792719;
          s[Va + 4 >> 2] = -1928822936;
          Va = ga + 16 | 0;
          s[Va >> 2] = 151523889;
          s[Va + 4 >> 2] = 1373741639;
          Va = ga + 24 | 0;
          s[Va >> 2] = 1193918714;
          s[Va + 4 >> 2] = 576313009;
          m = 0;
          $(1, Aa | 0, ga | 0, 136, -460954743, -2016278654);
          Va = m;
          m = 0;

          if (Va & 1) {
            an = me() | 0;
            xa(Ha);
            Ee(an | 0);
          }

          s[tn >> 2] = s[Aa >> 2];
          s[tn + 4 >> 2] = s[Aa + 4 >> 2];
          s[tn + 8 >> 2] = s[Aa + 8 >> 2];
          s[tn + 12 >> 2] = s[Aa + 12 >> 2];
          s[tn + 16 >> 2] = s[Aa + 16 >> 2];
          s[tn + 20 >> 2] = s[Aa + 20 >> 2];
          s[tn + 24 >> 2] = s[Aa + 24 >> 2];
          s[tn + 28 >> 2] = s[Aa + 28 >> 2];
          Va = ha + 32 | 0;
          s[Va >> 2] = s[tn >> 2];
          s[Va + 4 >> 2] = s[tn + 4 >> 2];
          s[Va + 8 >> 2] = s[tn + 8 >> 2];
          s[Va + 12 >> 2] = s[tn + 12 >> 2];
          s[Va + 16 >> 2] = s[tn + 16 >> 2];
          s[Va + 20 >> 2] = s[tn + 20 >> 2];
          s[Va + 24 >> 2] = s[tn + 24 >> 2];
          s[Va + 28 >> 2] = s[tn + 28 >> 2];
          m = 0;
          re(15, Ca | 0, pa | 0, ha | 0);
          Va = m;
          m = 0;

          if (Va & 1) {
            an = me() | 0;
            xa(Ha);
            Ee(an | 0);
          }

          ja = Ia;
          Ga = _a;
          Va = ja + 64 | 0;

          do {
            s[ja >> 2] = s[Ga >> 2];
            ja = ja + 4 | 0;
            Ga = Ga + 4 | 0;
          } while ((ja | 0) < (Va | 0));

          t = Ia + 64 | 0;
          ja = t;
          Ga = Ca;
          Va = ja + 64 | 0;

          do {
            s[ja >> 2] = s[Ga >> 2];
            ja = ja + 4 | 0;
            Ga = Ga + 4 | 0;
          } while ((ja | 0) < (Va | 0));

          Va = ka;
          s[Va >> 2] = 1164159792;
          s[Va + 4 >> 2] = -1250477296;
          Va = ka + 8 | 0;
          s[Va >> 2] = -1448450988;
          s[Va + 4 >> 2] = 880775624;
          Va = ka + 16 | 0;
          s[Va >> 2] = 606996881;
          s[Va + 4 >> 2] = 2046849319;
          Va = ka + 24 | 0;
          s[Va >> 2] = 293737708;
          s[Va + 4 >> 2] = 425114840;
          Va = ka + 32 | 0;
          s[Va >> 2] = -1599453353;
          s[Va + 4 >> 2] = 1854185246;
          Va = ka + 40 | 0;
          s[Va >> 2] = -1980198591;
          s[Va + 4 >> 2] = -1440973971;
          Va = ka + 48 | 0;
          s[Va >> 2] = -85931462;
          s[Va + 4 >> 2] = -1226370099;
          Va = ka + 56 | 0;
          s[Va >> 2] = 1317202883;
          s[Va + 4 >> 2] = 644435899;
          s[Ba >> 2] = s[Ia >> 2];
          s[Ba + 4 >> 2] = s[Ia + 4 >> 2];
          s[Ba + 8 >> 2] = s[Ia + 8 >> 2];
          s[Ba + 12 >> 2] = s[Ia + 12 >> 2];
          s[Ba + 16 >> 2] = s[Ia + 16 >> 2];
          s[Ba + 20 >> 2] = s[Ia + 20 >> 2];
          s[Ba + 24 >> 2] = s[Ia + 24 >> 2];
          s[Ba + 28 >> 2] = s[Ia + 28 >> 2];
          Va = Ia + 32 | 0;
          s[_r >> 2] = s[Va >> 2];
          s[_r + 4 >> 2] = s[Va + 4 >> 2];
          s[_r + 8 >> 2] = s[Va + 8 >> 2];
          s[_r + 12 >> 2] = s[Va + 12 >> 2];
          s[_r + 16 >> 2] = s[Va + 16 >> 2];
          s[_r + 20 >> 2] = s[Va + 20 >> 2];
          s[_r + 24 >> 2] = s[Va + 24 >> 2];
          s[_r + 28 >> 2] = s[Va + 28 >> 2];
          Va = vr;
          s[Va >> 2] = 317583274;
          s[Va + 4 >> 2] = 1757628553;
          Va = vr + 8 | 0;
          s[Va >> 2] = 1923792719;
          s[Va + 4 >> 2] = -1928822936;
          Va = vr + 16 | 0;
          s[Va >> 2] = 151523889;
          s[Va + 4 >> 2] = 1373741639;
          Va = vr + 24 | 0;
          s[Va >> 2] = 1193918714;
          s[Va + 4 >> 2] = 576313009;
          m = 0;
          $(1, _r | 0, vr | 0, 136, -460954743, -2016278654);
          Va = m;
          m = 0;

          if (Va & 1) {
            an = me() | 0;
            xa(Ha);
            Ee(an | 0);
          }

          s[tn >> 2] = s[_r >> 2];
          s[tn + 4 >> 2] = s[_r + 4 >> 2];
          s[tn + 8 >> 2] = s[_r + 8 >> 2];
          s[tn + 12 >> 2] = s[_r + 12 >> 2];
          s[tn + 16 >> 2] = s[_r + 16 >> 2];
          s[tn + 20 >> 2] = s[_r + 20 >> 2];
          s[tn + 24 >> 2] = s[_r + 24 >> 2];
          s[tn + 28 >> 2] = s[_r + 28 >> 2];
          Va = Ba + 32 | 0;
          s[Va >> 2] = s[tn >> 2];
          s[Va + 4 >> 2] = s[tn + 4 >> 2];
          s[Va + 8 >> 2] = s[tn + 8 >> 2];
          s[Va + 12 >> 2] = s[tn + 12 >> 2];
          s[Va + 16 >> 2] = s[tn + 16 >> 2];
          s[Va + 20 >> 2] = s[tn + 20 >> 2];
          s[Va + 24 >> 2] = s[tn + 24 >> 2];
          s[Va + 28 >> 2] = s[tn + 28 >> 2];
          m = 0;
          re(15, Ra | 0, ka | 0, Ba | 0);
          Va = m;
          m = 0;

          if (Va & 1) {
            an = me() | 0;
            xa(Ha);
            Ee(an | 0);
          }

          Va = Ea;
          s[Va >> 2] = 691451433;
          s[Va + 4 >> 2] = -457450228;
          Va = Ea + 8 | 0;
          s[Va >> 2] = -516703541;
          s[Va + 4 >> 2] = -1154420382;
          Va = Ea + 16 | 0;
          s[Va >> 2] = -110865562;
          s[Va + 4 >> 2] = 833212854;
          Va = Ea + 24 | 0;
          s[Va >> 2] = -1526662947;
          s[Va + 4 >> 2] = 624259262;
          Va = Ea + 32 | 0;
          s[Va >> 2] = 1610512327;
          s[Va + 4 >> 2] = -1579713308;
          Va = Ea + 40 | 0;
          s[Va >> 2] = 2015810011;
          s[Va + 4 >> 2] = 128974097;
          Va = Ea + 48 | 0;
          s[Va >> 2] = -1149313941;
          s[Va + 4 >> 2] = 1830206759;
          Va = Ea + 56 | 0;
          s[Va >> 2] = -2048983348;
          s[Va + 4 >> 2] = 747053058;
          s[Sa >> 2] = s[t >> 2];
          s[Sa + 4 >> 2] = s[t + 4 >> 2];
          s[Sa + 8 >> 2] = s[t + 8 >> 2];
          s[Sa + 12 >> 2] = s[t + 12 >> 2];
          s[Sa + 16 >> 2] = s[t + 16 >> 2];
          s[Sa + 20 >> 2] = s[t + 20 >> 2];
          s[Sa + 24 >> 2] = s[t + 24 >> 2];
          s[Sa + 28 >> 2] = s[t + 28 >> 2];
          Va = Ia + 96 | 0;
          s[mr >> 2] = s[Va >> 2];
          s[mr + 4 >> 2] = s[Va + 4 >> 2];
          s[mr + 8 >> 2] = s[Va + 8 >> 2];
          s[mr + 12 >> 2] = s[Va + 12 >> 2];
          s[mr + 16 >> 2] = s[Va + 16 >> 2];
          s[mr + 20 >> 2] = s[Va + 20 >> 2];
          s[mr + 24 >> 2] = s[Va + 24 >> 2];
          s[mr + 28 >> 2] = s[Va + 28 >> 2];
          Va = sr;
          s[Va >> 2] = 317583274;
          s[Va + 4 >> 2] = 1757628553;
          Va = sr + 8 | 0;
          s[Va >> 2] = 1923792719;
          s[Va + 4 >> 2] = -1928822936;
          Va = sr + 16 | 0;
          s[Va >> 2] = 151523889;
          s[Va + 4 >> 2] = 1373741639;
          Va = sr + 24 | 0;
          s[Va >> 2] = 1193918714;
          s[Va + 4 >> 2] = 576313009;
          m = 0;
          $(1, mr | 0, sr | 0, 136, -460954743, -2016278654);
          Va = m;
          m = 0;

          if (Va & 1) {
            an = me() | 0;
            xa(Ha);
            Ee(an | 0);
          }

          s[tn >> 2] = s[mr >> 2];
          s[tn + 4 >> 2] = s[mr + 4 >> 2];
          s[tn + 8 >> 2] = s[mr + 8 >> 2];
          s[tn + 12 >> 2] = s[mr + 12 >> 2];
          s[tn + 16 >> 2] = s[mr + 16 >> 2];
          s[tn + 20 >> 2] = s[mr + 20 >> 2];
          s[tn + 24 >> 2] = s[mr + 24 >> 2];
          s[tn + 28 >> 2] = s[mr + 28 >> 2];
          Va = Sa + 32 | 0;
          s[Va >> 2] = s[tn >> 2];
          s[Va + 4 >> 2] = s[tn + 4 >> 2];
          s[Va + 8 >> 2] = s[tn + 8 >> 2];
          s[Va + 12 >> 2] = s[tn + 12 >> 2];
          s[Va + 16 >> 2] = s[tn + 16 >> 2];
          s[Va + 20 >> 2] = s[tn + 20 >> 2];
          s[Va + 24 >> 2] = s[tn + 24 >> 2];
          s[Va + 28 >> 2] = s[tn + 28 >> 2];
          m = 0;
          re(15, Pa | 0, Ea | 0, Sa | 0);
          Va = m;
          m = 0;

          if (Va & 1) {
            an = me() | 0;
            xa(Ha);
            Ee(an | 0);
          }

          ja = Wa;
          Ga = Ra;
          Va = ja + 64 | 0;

          do {
            s[ja >> 2] = s[Ga >> 2];
            ja = ja + 4 | 0;
            Ga = Ga + 4 | 0;
          } while ((ja | 0) < (Va | 0));

          t = Wa + 64 | 0;
          ja = t;
          Ga = Pa;
          Va = ja + 64 | 0;

          do {
            s[ja >> 2] = s[Ga >> 2];
            ja = ja + 4 | 0;
            Ga = Ga + 4 | 0;
          } while ((ja | 0) < (Va | 0));

          ja = Oa;
          Ga = Wa;
          Va = ja + 64 | 0;

          do {
            s[ja >> 2] = s[Ga >> 2];
            ja = ja + 4 | 0;
            Ga = Ga + 4 | 0;
          } while ((ja | 0) < (Va | 0));

          ja = Na;
          Ga = t;
          Va = ja + 64 | 0;

          do {
            s[ja >> 2] = s[Ga >> 2];
            ja = ja + 4 | 0;
            Ga = Ga + 4 | 0;
          } while ((ja | 0) < (Va | 0));

          s[tr >> 2] = s[t >> 2];
          s[tr + 4 >> 2] = s[t + 4 >> 2];
          s[tr + 8 >> 2] = s[t + 8 >> 2];
          s[tr + 12 >> 2] = s[t + 12 >> 2];
          s[tr + 16 >> 2] = s[t + 16 >> 2];
          s[tr + 20 >> 2] = s[t + 20 >> 2];
          s[tr + 24 >> 2] = s[t + 24 >> 2];
          s[tr + 28 >> 2] = s[t + 28 >> 2];
          m = 0;
          te(18, tr | 0, 136);
          Va = m;
          m = 0;

          if (Va & 1) {
            an = me() | 0;
            xa(Ha);
            Ee(an | 0);
          }

          s[Ma >> 2] = s[tr >> 2];
          s[Ma + 4 >> 2] = s[tr + 4 >> 2];
          s[Ma + 8 >> 2] = s[tr + 8 >> 2];
          s[Ma + 12 >> 2] = s[tr + 12 >> 2];
          s[Ma + 16 >> 2] = s[tr + 16 >> 2];
          s[Ma + 20 >> 2] = s[tr + 20 >> 2];
          s[Ma + 24 >> 2] = s[tr + 24 >> 2];
          s[Ma + 28 >> 2] = s[tr + 28 >> 2];
          Va = Na + 32 | 0;
          s[Za >> 2] = s[Va >> 2];
          s[Za + 4 >> 2] = s[Va + 4 >> 2];
          s[Za + 8 >> 2] = s[Va + 8 >> 2];
          s[Za + 12 >> 2] = s[Va + 12 >> 2];
          s[Za + 16 >> 2] = s[Va + 16 >> 2];
          s[Za + 20 >> 2] = s[Va + 20 >> 2];
          s[Za + 24 >> 2] = s[Va + 24 >> 2];
          s[Za + 28 >> 2] = s[Va + 28 >> 2];
          m = 0;
          te(18, Za | 0, 136);
          Va = m;
          m = 0;

          if (Va & 1) {
            an = me() | 0;
            xa(Ha);
            Ee(an | 0);
          }

          s[tn >> 2] = s[Za >> 2];
          s[tn + 4 >> 2] = s[Za + 4 >> 2];
          s[tn + 8 >> 2] = s[Za + 8 >> 2];
          s[tn + 12 >> 2] = s[Za + 12 >> 2];
          s[tn + 16 >> 2] = s[Za + 16 >> 2];
          s[tn + 20 >> 2] = s[Za + 20 >> 2];
          s[tn + 24 >> 2] = s[Za + 24 >> 2];
          s[tn + 28 >> 2] = s[Za + 28 >> 2];
          ja = Ma + 32 | 0;
          s[ja >> 2] = s[tn >> 2];
          s[ja + 4 >> 2] = s[tn + 4 >> 2];
          s[ja + 8 >> 2] = s[tn + 8 >> 2];
          s[ja + 12 >> 2] = s[tn + 12 >> 2];
          s[ja + 16 >> 2] = s[tn + 16 >> 2];
          s[ja + 20 >> 2] = s[tn + 20 >> 2];
          s[ja + 24 >> 2] = s[tn + 24 >> 2];
          s[ja + 28 >> 2] = s[tn + 28 >> 2];
          ja = Oa + 64 | 0;
          Ga = Ma;
          Va = ja + 64 | 0;

          do {
            s[ja >> 2] = s[Ga >> 2];
            ja = ja + 4 | 0;
            Ga = Ga + 4 | 0;
          } while ((ja | 0) < (Va | 0));

          m = 0;
          re(18, La | 0, Fa | 0, Ia | 0);
          Va = m;
          m = 0;

          if (Va & 1) {
            an = me() | 0;
            xa(Ha);
            Ee(an | 0);
          }

          t = s[Ot >> 2] | 0;

          do {
            if ((t | 0) == (s[Me >> 2] | 0)) {
              m = 0;
              ee(42, Ha | 0);
              Va = m;
              m = 0;

              if (Va & 1) {
                an = me() | 0;
                xa(Ha);
                Ee(an | 0);
              } else {
                t = s[Ot >> 2] | 0;
                break;
              }
            }
          } while (0);

          id((s[Ha >> 2] | 0) + (t * 192 | 0) | 0, La | 0, 192) | 0;
          s[Ot >> 2] = t + 1;
          m = 0;
          re(18, Ua | 0, Fa | 0, Oa | 0);
          Va = m;
          m = 0;

          if (Va & 1) {
            an = me() | 0;
            xa(Ha);
            Ee(an | 0);
          }

          t = s[Ot >> 2] | 0;

          do {
            if ((t | 0) == (s[Me >> 2] | 0)) {
              m = 0;
              ee(42, Ha | 0);
              Va = m;
              m = 0;

              if (Va & 1) {
                an = me() | 0;
                xa(Ha);
                Ee(an | 0);
              } else {
                t = s[Ot >> 2] | 0;
                break;
              }
            }
          } while (0);

          id((s[Ha >> 2] | 0) + (t * 192 | 0) | 0, Ua | 0, 192) | 0;
          s[Ot >> 2] = t + 1;
          ja = Sr;
          Ga = Rr;
          Va = ja + 128 | 0;

          do {
            s[ja >> 2] = s[Ga >> 2];
            ja = ja + 4 | 0;
            Ga = Ga + 4 | 0;
          } while ((ja | 0) < (Va | 0));

          l = Sr + 128 | 0;
          s[l >> 2] = s[Ha >> 2];
          s[l + 4 >> 2] = s[Ha + 4 >> 2];
          s[l + 8 >> 2] = s[Ha + 8 >> 2];
          d = en;
          s[d >> 2] = -980480611;
          s[d + 4 >> 2] = -748862579;
          d = en + 8 | 0;
          s[d >> 2] = -171504835;
          s[d + 4 >> 2] = 175696680;
          d = en + 16 | 0;
          s[d >> 2] = 2021213740;
          s[d + 4 >> 2] = 1718526831;
          d = en + 24 | 0;
          s[d >> 2] = -1710760145;
          s[d + 4 >> 2] = 235567041;
          ed(en + 32 | 0, 0, 352) | 0;
          d = yr;
          s[d >> 2] = -1099547736;
          s[d + 4 >> 2] = -1652985799;
          d = yr + 8 | 0;
          s[d >> 2] = 1;
          s[d + 4 >> 2] = 0;
          d = yr + 16 | 0;
          s[d >> 2] = 0;
          s[d + 4 >> 2] = 0;
          s[d + 8 >> 2] = 0;
          s[d + 12 >> 2] = 0;
          l = s[l >> 2] | 0;
          d = s[Sr + 136 >> 2] | 0;
          f = Wr + 32 | 0;
          n = lr + 32 | 0;
          o = dr + 32 | 0;
          i = or + 32 | 0;
          c = rr + 32 | 0;
          a = 256;
          t = 0;
          r = 0;

          e: while (1) {
            do {
              if (!a) {
                t = 87;
                break e;
              }

              a = a + -1 | 0;

              if (a >>> 0 > 255) {
                t = 87;
                break e;
              }

              Ua = yr + (a >>> 6 << 3) | 0;
              Ga = s[Ua >> 2] | 0;
              Ua = s[Ua + 4 >> 2] | 0;
              Va = od(1, 0, a & 63 | 0) | 0;
              Ha = t;
              t = (Ga & Va | 0) != 0 | (Ua & S | 0) != 0;
            } while (!Ha);

            if (d >>> 0 <= r >>> 0) {
              t = 103;
              break;
            }

            u = r + 1 | 0;
            m = 0;
            te(19, pr | 0, en | 0);
            Ha = m;
            m = 0;

            if (Ha & 1) {
              t = 126;
              break;
            }

            ja = hr;
            Ga = l + (r * 192 | 0) | 0;
            Va = ja + 64 | 0;

            do {
              s[ja >> 2] = s[Ga >> 2];
              ja = ja + 4 | 0;
              Ga = Ga + 4 | 0;
            } while ((ja | 0) < (Va | 0));

            Ha = l + (r * 192 | 0) + 64 | 0;
            s[fr >> 2] = s[f >> 2];
            s[fr + 4 >> 2] = s[f + 4 >> 2];
            s[fr + 8 >> 2] = s[f + 8 >> 2];
            s[fr + 12 >> 2] = s[f + 12 >> 2];
            s[fr + 16 >> 2] = s[f + 16 >> 2];
            s[fr + 20 >> 2] = s[f + 20 >> 2];
            s[fr + 24 >> 2] = s[f + 24 >> 2];
            s[fr + 28 >> 2] = s[f + 28 >> 2];
            s[za >> 2] = s[Ha >> 2];
            s[za + 4 >> 2] = s[Ha + 4 >> 2];
            s[za + 8 >> 2] = s[Ha + 8 >> 2];
            s[za + 12 >> 2] = s[Ha + 12 >> 2];
            s[za + 16 >> 2] = s[Ha + 16 >> 2];
            s[za + 20 >> 2] = s[Ha + 20 >> 2];
            s[za + 24 >> 2] = s[Ha + 24 >> 2];
            s[za + 28 >> 2] = s[Ha + 28 >> 2];
            s[gr >> 2] = s[f >> 2];
            s[gr + 4 >> 2] = s[f + 4 >> 2];
            s[gr + 8 >> 2] = s[f + 8 >> 2];
            s[gr + 12 >> 2] = s[f + 12 >> 2];
            s[gr + 16 >> 2] = s[f + 16 >> 2];
            s[gr + 20 >> 2] = s[f + 20 >> 2];
            s[gr + 24 >> 2] = s[f + 24 >> 2];
            s[gr + 28 >> 2] = s[f + 28 >> 2];
            m = 0;
            $(1, za | 0, gr | 0, 136, -460954743, -2016278654);
            Ha = m;
            m = 0;

            if (Ha & 1) {
              t = 126;
              break;
            }

            s[lr >> 2] = s[za >> 2];
            s[lr + 4 >> 2] = s[za + 4 >> 2];
            s[lr + 8 >> 2] = s[za + 8 >> 2];
            s[lr + 12 >> 2] = s[za + 12 >> 2];
            s[lr + 16 >> 2] = s[za + 16 >> 2];
            s[lr + 20 >> 2] = s[za + 20 >> 2];
            s[lr + 24 >> 2] = s[za + 24 >> 2];
            s[lr + 28 >> 2] = s[za + 28 >> 2];
            Ha = l + (r * 192 | 0) + 96 | 0;
            s[_r >> 2] = s[Ha >> 2];
            s[_r + 4 >> 2] = s[Ha + 4 >> 2];
            s[_r + 8 >> 2] = s[Ha + 8 >> 2];
            s[_r + 12 >> 2] = s[Ha + 12 >> 2];
            s[_r + 16 >> 2] = s[Ha + 16 >> 2];
            s[_r + 20 >> 2] = s[Ha + 20 >> 2];
            s[_r + 24 >> 2] = s[Ha + 24 >> 2];
            s[_r + 28 >> 2] = s[Ha + 28 >> 2];
            s[vr >> 2] = s[fr >> 2];
            s[vr + 4 >> 2] = s[fr + 4 >> 2];
            s[vr + 8 >> 2] = s[fr + 8 >> 2];
            s[vr + 12 >> 2] = s[fr + 12 >> 2];
            s[vr + 16 >> 2] = s[fr + 16 >> 2];
            s[vr + 20 >> 2] = s[fr + 20 >> 2];
            s[vr + 24 >> 2] = s[fr + 24 >> 2];
            s[vr + 28 >> 2] = s[fr + 28 >> 2];
            m = 0;
            $(1, _r | 0, vr | 0, 136, -460954743, -2016278654);
            Ha = m;
            m = 0;

            if (Ha & 1) {
              t = 126;
              break;
            }

            s[tn >> 2] = s[_r >> 2];
            s[tn + 4 >> 2] = s[_r + 4 >> 2];
            s[tn + 8 >> 2] = s[_r + 8 >> 2];
            s[tn + 12 >> 2] = s[_r + 12 >> 2];
            s[tn + 16 >> 2] = s[_r + 16 >> 2];
            s[tn + 20 >> 2] = s[_r + 20 >> 2];
            s[tn + 24 >> 2] = s[_r + 24 >> 2];
            s[tn + 28 >> 2] = s[_r + 28 >> 2];
            s[n >> 2] = s[tn >> 2];
            s[n + 4 >> 2] = s[tn + 4 >> 2];
            s[n + 8 >> 2] = s[tn + 8 >> 2];
            s[n + 12 >> 2] = s[tn + 12 >> 2];
            s[n + 16 >> 2] = s[tn + 16 >> 2];
            s[n + 20 >> 2] = s[tn + 20 >> 2];
            s[n + 24 >> 2] = s[tn + 24 >> 2];
            s[n + 28 >> 2] = s[tn + 28 >> 2];
            Ha = l + (r * 192 | 0) + 128 | 0;
            s[ur >> 2] = s[Wr >> 2];
            s[ur + 4 >> 2] = s[Wr + 4 >> 2];
            s[ur + 8 >> 2] = s[Wr + 8 >> 2];
            s[ur + 12 >> 2] = s[Wr + 12 >> 2];
            s[ur + 16 >> 2] = s[Wr + 16 >> 2];
            s[ur + 20 >> 2] = s[Wr + 20 >> 2];
            s[ur + 24 >> 2] = s[Wr + 24 >> 2];
            s[ur + 28 >> 2] = s[Wr + 28 >> 2];
            s[mr >> 2] = s[Ha >> 2];
            s[mr + 4 >> 2] = s[Ha + 4 >> 2];
            s[mr + 8 >> 2] = s[Ha + 8 >> 2];
            s[mr + 12 >> 2] = s[Ha + 12 >> 2];
            s[mr + 16 >> 2] = s[Ha + 16 >> 2];
            s[mr + 20 >> 2] = s[Ha + 20 >> 2];
            s[mr + 24 >> 2] = s[Ha + 24 >> 2];
            s[mr + 28 >> 2] = s[Ha + 28 >> 2];
            s[sr >> 2] = s[Wr >> 2];
            s[sr + 4 >> 2] = s[Wr + 4 >> 2];
            s[sr + 8 >> 2] = s[Wr + 8 >> 2];
            s[sr + 12 >> 2] = s[Wr + 12 >> 2];
            s[sr + 16 >> 2] = s[Wr + 16 >> 2];
            s[sr + 20 >> 2] = s[Wr + 20 >> 2];
            s[sr + 24 >> 2] = s[Wr + 24 >> 2];
            s[sr + 28 >> 2] = s[Wr + 28 >> 2];
            m = 0;
            $(1, mr | 0, sr | 0, 136, -460954743, -2016278654);
            Ha = m;
            m = 0;

            if (Ha & 1) {
              t = 126;
              break;
            }

            s[dr >> 2] = s[mr >> 2];
            s[dr + 4 >> 2] = s[mr + 4 >> 2];
            s[dr + 8 >> 2] = s[mr + 8 >> 2];
            s[dr + 12 >> 2] = s[mr + 12 >> 2];
            s[dr + 16 >> 2] = s[mr + 16 >> 2];
            s[dr + 20 >> 2] = s[mr + 20 >> 2];
            s[dr + 24 >> 2] = s[mr + 24 >> 2];
            s[dr + 28 >> 2] = s[mr + 28 >> 2];
            Ha = l + (r * 192 | 0) + 160 | 0;
            s[tr >> 2] = s[Ha >> 2];
            s[tr + 4 >> 2] = s[Ha + 4 >> 2];
            s[tr + 8 >> 2] = s[Ha + 8 >> 2];
            s[tr + 12 >> 2] = s[Ha + 12 >> 2];
            s[tr + 16 >> 2] = s[Ha + 16 >> 2];
            s[tr + 20 >> 2] = s[Ha + 20 >> 2];
            s[tr + 24 >> 2] = s[Ha + 24 >> 2];
            s[tr + 28 >> 2] = s[Ha + 28 >> 2];
            s[Za >> 2] = s[ur >> 2];
            s[Za + 4 >> 2] = s[ur + 4 >> 2];
            s[Za + 8 >> 2] = s[ur + 8 >> 2];
            s[Za + 12 >> 2] = s[ur + 12 >> 2];
            s[Za + 16 >> 2] = s[ur + 16 >> 2];
            s[Za + 20 >> 2] = s[ur + 20 >> 2];
            s[Za + 24 >> 2] = s[ur + 24 >> 2];
            s[Za + 28 >> 2] = s[ur + 28 >> 2];
            m = 0;
            $(1, tr | 0, Za | 0, 136, -460954743, -2016278654);
            Ha = m;
            m = 0;

            if (Ha & 1) {
              t = 126;
              break;
            }

            s[tn >> 2] = s[tr >> 2];
            s[tn + 4 >> 2] = s[tr + 4 >> 2];
            s[tn + 8 >> 2] = s[tr + 8 >> 2];
            s[tn + 12 >> 2] = s[tr + 12 >> 2];
            s[tn + 16 >> 2] = s[tr + 16 >> 2];
            s[tn + 20 >> 2] = s[tr + 20 >> 2];
            s[tn + 24 >> 2] = s[tr + 24 >> 2];
            s[tn + 28 >> 2] = s[tr + 28 >> 2];
            s[o >> 2] = s[tn >> 2];
            s[o + 4 >> 2] = s[tn + 4 >> 2];
            s[o + 8 >> 2] = s[tn + 8 >> 2];
            s[o + 12 >> 2] = s[tn + 12 >> 2];
            s[o + 16 >> 2] = s[tn + 16 >> 2];
            s[o + 20 >> 2] = s[tn + 20 >> 2];
            s[o + 24 >> 2] = s[tn + 24 >> 2];
            s[o + 28 >> 2] = s[tn + 28 >> 2];
            m = 0;
            $(2, br | 0, pr | 0, hr | 0, lr | 0, dr | 0);
            Ha = m;
            m = 0;

            if (Ha & 1) {
              t = 126;
              break;
            }

            id(en | 0, br | 0, 384) | 0;

            if (!t) {
              t = 1;
              r = u;
              continue;
            }

            if (d >>> 0 <= u >>> 0) {
              t = 112;
              break;
            }

            r = r + 2 | 0;
            ja = ir;
            Ga = l + (u * 192 | 0) | 0;
            Va = ja + 64 | 0;

            do {
              s[ja >> 2] = s[Ga >> 2];
              ja = ja + 4 | 0;
              Ga = Ga + 4 | 0;
            } while ((ja | 0) < (Va | 0));

            Ha = l + (u * 192 | 0) + 64 | 0;
            s[nr >> 2] = s[f >> 2];
            s[nr + 4 >> 2] = s[f + 4 >> 2];
            s[nr + 8 >> 2] = s[f + 8 >> 2];
            s[nr + 12 >> 2] = s[f + 12 >> 2];
            s[nr + 16 >> 2] = s[f + 16 >> 2];
            s[nr + 20 >> 2] = s[f + 20 >> 2];
            s[nr + 24 >> 2] = s[f + 24 >> 2];
            s[nr + 28 >> 2] = s[f + 28 >> 2];
            s[Ja >> 2] = s[Ha >> 2];
            s[Ja + 4 >> 2] = s[Ha + 4 >> 2];
            s[Ja + 8 >> 2] = s[Ha + 8 >> 2];
            s[Ja + 12 >> 2] = s[Ha + 12 >> 2];
            s[Ja + 16 >> 2] = s[Ha + 16 >> 2];
            s[Ja + 20 >> 2] = s[Ha + 20 >> 2];
            s[Ja + 24 >> 2] = s[Ha + 24 >> 2];
            s[Ja + 28 >> 2] = s[Ha + 28 >> 2];
            s[Ya >> 2] = s[f >> 2];
            s[Ya + 4 >> 2] = s[f + 4 >> 2];
            s[Ya + 8 >> 2] = s[f + 8 >> 2];
            s[Ya + 12 >> 2] = s[f + 12 >> 2];
            s[Ya + 16 >> 2] = s[f + 16 >> 2];
            s[Ya + 20 >> 2] = s[f + 20 >> 2];
            s[Ya + 24 >> 2] = s[f + 24 >> 2];
            s[Ya + 28 >> 2] = s[f + 28 >> 2];
            m = 0;
            $(1, Ja | 0, Ya | 0, 136, -460954743, -2016278654);
            Ha = m;
            m = 0;

            if (Ha & 1) {
              t = 126;
              break;
            }

            s[or >> 2] = s[Ja >> 2];
            s[or + 4 >> 2] = s[Ja + 4 >> 2];
            s[or + 8 >> 2] = s[Ja + 8 >> 2];
            s[or + 12 >> 2] = s[Ja + 12 >> 2];
            s[or + 16 >> 2] = s[Ja + 16 >> 2];
            s[or + 20 >> 2] = s[Ja + 20 >> 2];
            s[or + 24 >> 2] = s[Ja + 24 >> 2];
            s[or + 28 >> 2] = s[Ja + 28 >> 2];
            Ha = l + (u * 192 | 0) + 96 | 0;
            s[qa >> 2] = s[Ha >> 2];
            s[qa + 4 >> 2] = s[Ha + 4 >> 2];
            s[qa + 8 >> 2] = s[Ha + 8 >> 2];
            s[qa + 12 >> 2] = s[Ha + 12 >> 2];
            s[qa + 16 >> 2] = s[Ha + 16 >> 2];
            s[qa + 20 >> 2] = s[Ha + 20 >> 2];
            s[qa + 24 >> 2] = s[Ha + 24 >> 2];
            s[qa + 28 >> 2] = s[Ha + 28 >> 2];
            s[Ka >> 2] = s[nr >> 2];
            s[Ka + 4 >> 2] = s[nr + 4 >> 2];
            s[Ka + 8 >> 2] = s[nr + 8 >> 2];
            s[Ka + 12 >> 2] = s[nr + 12 >> 2];
            s[Ka + 16 >> 2] = s[nr + 16 >> 2];
            s[Ka + 20 >> 2] = s[nr + 20 >> 2];
            s[Ka + 24 >> 2] = s[nr + 24 >> 2];
            s[Ka + 28 >> 2] = s[nr + 28 >> 2];
            m = 0;
            $(1, qa | 0, Ka | 0, 136, -460954743, -2016278654);
            Ha = m;
            m = 0;

            if (Ha & 1) {
              t = 126;
              break;
            }

            s[tn >> 2] = s[qa >> 2];
            s[tn + 4 >> 2] = s[qa + 4 >> 2];
            s[tn + 8 >> 2] = s[qa + 8 >> 2];
            s[tn + 12 >> 2] = s[qa + 12 >> 2];
            s[tn + 16 >> 2] = s[qa + 16 >> 2];
            s[tn + 20 >> 2] = s[qa + 20 >> 2];
            s[tn + 24 >> 2] = s[qa + 24 >> 2];
            s[tn + 28 >> 2] = s[qa + 28 >> 2];
            s[i >> 2] = s[tn >> 2];
            s[i + 4 >> 2] = s[tn + 4 >> 2];
            s[i + 8 >> 2] = s[tn + 8 >> 2];
            s[i + 12 >> 2] = s[tn + 12 >> 2];
            s[i + 16 >> 2] = s[tn + 16 >> 2];
            s[i + 20 >> 2] = s[tn + 20 >> 2];
            s[i + 24 >> 2] = s[tn + 24 >> 2];
            s[i + 28 >> 2] = s[tn + 28 >> 2];
            Ha = l + (u * 192 | 0) + 128 | 0;
            s[ar >> 2] = s[Wr >> 2];
            s[ar + 4 >> 2] = s[Wr + 4 >> 2];
            s[ar + 8 >> 2] = s[Wr + 8 >> 2];
            s[ar + 12 >> 2] = s[Wr + 12 >> 2];
            s[ar + 16 >> 2] = s[Wr + 16 >> 2];
            s[ar + 20 >> 2] = s[Wr + 20 >> 2];
            s[ar + 24 >> 2] = s[Wr + 24 >> 2];
            s[ar + 28 >> 2] = s[Wr + 28 >> 2];
            s[er >> 2] = s[Ha >> 2];
            s[er + 4 >> 2] = s[Ha + 4 >> 2];
            s[er + 8 >> 2] = s[Ha + 8 >> 2];
            s[er + 12 >> 2] = s[Ha + 12 >> 2];
            s[er + 16 >> 2] = s[Ha + 16 >> 2];
            s[er + 20 >> 2] = s[Ha + 20 >> 2];
            s[er + 24 >> 2] = s[Ha + 24 >> 2];
            s[er + 28 >> 2] = s[Ha + 28 >> 2];
            s[Qa >> 2] = s[Wr >> 2];
            s[Qa + 4 >> 2] = s[Wr + 4 >> 2];
            s[Qa + 8 >> 2] = s[Wr + 8 >> 2];
            s[Qa + 12 >> 2] = s[Wr + 12 >> 2];
            s[Qa + 16 >> 2] = s[Wr + 16 >> 2];
            s[Qa + 20 >> 2] = s[Wr + 20 >> 2];
            s[Qa + 24 >> 2] = s[Wr + 24 >> 2];
            s[Qa + 28 >> 2] = s[Wr + 28 >> 2];
            m = 0;
            $(1, er | 0, Qa | 0, 136, -460954743, -2016278654);
            Ha = m;
            m = 0;

            if (Ha & 1) {
              t = 126;
              break;
            }

            s[rr >> 2] = s[er >> 2];
            s[rr + 4 >> 2] = s[er + 4 >> 2];
            s[rr + 8 >> 2] = s[er + 8 >> 2];
            s[rr + 12 >> 2] = s[er + 12 >> 2];
            s[rr + 16 >> 2] = s[er + 16 >> 2];
            s[rr + 20 >> 2] = s[er + 20 >> 2];
            s[rr + 24 >> 2] = s[er + 24 >> 2];
            s[rr + 28 >> 2] = s[er + 28 >> 2];
            Ha = l + (u * 192 | 0) + 160 | 0;
            s[$a >> 2] = s[Ha >> 2];
            s[$a + 4 >> 2] = s[Ha + 4 >> 2];
            s[$a + 8 >> 2] = s[Ha + 8 >> 2];
            s[$a + 12 >> 2] = s[Ha + 12 >> 2];
            s[$a + 16 >> 2] = s[Ha + 16 >> 2];
            s[$a + 20 >> 2] = s[Ha + 20 >> 2];
            s[$a + 24 >> 2] = s[Ha + 24 >> 2];
            s[$a + 28 >> 2] = s[Ha + 28 >> 2];
            s[Xa >> 2] = s[ar >> 2];
            s[Xa + 4 >> 2] = s[ar + 4 >> 2];
            s[Xa + 8 >> 2] = s[ar + 8 >> 2];
            s[Xa + 12 >> 2] = s[ar + 12 >> 2];
            s[Xa + 16 >> 2] = s[ar + 16 >> 2];
            s[Xa + 20 >> 2] = s[ar + 20 >> 2];
            s[Xa + 24 >> 2] = s[ar + 24 >> 2];
            s[Xa + 28 >> 2] = s[ar + 28 >> 2];
            m = 0;
            $(1, $a | 0, Xa | 0, 136, -460954743, -2016278654);
            Ha = m;
            m = 0;

            if (Ha & 1) {
              t = 126;
              break;
            }

            s[tn >> 2] = s[$a >> 2];
            s[tn + 4 >> 2] = s[$a + 4 >> 2];
            s[tn + 8 >> 2] = s[$a + 8 >> 2];
            s[tn + 12 >> 2] = s[$a + 12 >> 2];
            s[tn + 16 >> 2] = s[$a + 16 >> 2];
            s[tn + 20 >> 2] = s[$a + 20 >> 2];
            s[tn + 24 >> 2] = s[$a + 24 >> 2];
            s[tn + 28 >> 2] = s[$a + 28 >> 2];
            s[c >> 2] = s[tn >> 2];
            s[c + 4 >> 2] = s[tn + 4 >> 2];
            s[c + 8 >> 2] = s[tn + 8 >> 2];
            s[c + 12 >> 2] = s[tn + 12 >> 2];
            s[c + 16 >> 2] = s[tn + 16 >> 2];
            s[c + 20 >> 2] = s[tn + 20 >> 2];
            s[c + 24 >> 2] = s[tn + 24 >> 2];
            s[c + 28 >> 2] = s[tn + 28 >> 2];
            m = 0;
            $(2, cr | 0, en | 0, ir | 0, or | 0, rr | 0);
            Ha = m;
            m = 0;

            if (Ha & 1) {
              t = 126;
              break;
            }

            id(en | 0, cr | 0, 384) | 0;
            t = 1;
          }

          if ((t | 0) == 87) {
            if (d >>> 0 <= r >>> 0) {
              m = 0;
              re(19, 2056, r | 0, d | 0);
              m = 0;
              an = me() | 0;
              Da(Sr);
              Ee(an | 0);
            }

            t = r + 1 | 0;
            ja = $r;
            Ga = l + (r * 192 | 0) | 0;
            Va = ja + 64 | 0;

            do {
              s[ja >> 2] = s[Ga >> 2];
              ja = ja + 4 | 0;
              Ga = Ga + 4 | 0;
            } while ((ja | 0) < (Va | 0));

            gr = l + (r * 192 | 0) + 64 | 0;
            s[Jr >> 2] = s[f >> 2];
            s[Jr + 4 >> 2] = s[f + 4 >> 2];
            s[Jr + 8 >> 2] = s[f + 8 >> 2];
            s[Jr + 12 >> 2] = s[f + 12 >> 2];
            s[Jr + 16 >> 2] = s[f + 16 >> 2];
            s[Jr + 20 >> 2] = s[f + 20 >> 2];
            s[Jr + 24 >> 2] = s[f + 24 >> 2];
            s[Jr + 28 >> 2] = s[f + 28 >> 2];
            s[Gr >> 2] = s[gr >> 2];
            s[Gr + 4 >> 2] = s[gr + 4 >> 2];
            s[Gr + 8 >> 2] = s[gr + 8 >> 2];
            s[Gr + 12 >> 2] = s[gr + 12 >> 2];
            s[Gr + 16 >> 2] = s[gr + 16 >> 2];
            s[Gr + 20 >> 2] = s[gr + 20 >> 2];
            s[Gr + 24 >> 2] = s[gr + 24 >> 2];
            s[Gr + 28 >> 2] = s[gr + 28 >> 2];
            s[jr >> 2] = s[f >> 2];
            s[jr + 4 >> 2] = s[f + 4 >> 2];
            s[jr + 8 >> 2] = s[f + 8 >> 2];
            s[jr + 12 >> 2] = s[f + 12 >> 2];
            s[jr + 16 >> 2] = s[f + 16 >> 2];
            s[jr + 20 >> 2] = s[f + 20 >> 2];
            s[jr + 24 >> 2] = s[f + 24 >> 2];
            s[jr + 28 >> 2] = s[f + 28 >> 2];
            m = 0;
            $(1, Gr | 0, jr | 0, 136, -460954743, -2016278654);
            jr = m;
            m = 0;

            if (jr & 1) {
              an = me() | 0;
              Da(Sr);
              Ee(an | 0);
            }

            s[Xr >> 2] = s[Gr >> 2];
            s[Xr + 4 >> 2] = s[Gr + 4 >> 2];
            s[Xr + 8 >> 2] = s[Gr + 8 >> 2];
            s[Xr + 12 >> 2] = s[Gr + 12 >> 2];
            s[Xr + 16 >> 2] = s[Gr + 16 >> 2];
            s[Xr + 20 >> 2] = s[Gr + 20 >> 2];
            s[Xr + 24 >> 2] = s[Gr + 24 >> 2];
            s[Xr + 28 >> 2] = s[Gr + 28 >> 2];
            Gr = l + (r * 192 | 0) + 96 | 0;
            s[Fr >> 2] = s[Gr >> 2];
            s[Fr + 4 >> 2] = s[Gr + 4 >> 2];
            s[Fr + 8 >> 2] = s[Gr + 8 >> 2];
            s[Fr + 12 >> 2] = s[Gr + 12 >> 2];
            s[Fr + 16 >> 2] = s[Gr + 16 >> 2];
            s[Fr + 20 >> 2] = s[Gr + 20 >> 2];
            s[Fr + 24 >> 2] = s[Gr + 24 >> 2];
            s[Fr + 28 >> 2] = s[Gr + 28 >> 2];
            s[Or >> 2] = s[Jr >> 2];
            s[Or + 4 >> 2] = s[Jr + 4 >> 2];
            s[Or + 8 >> 2] = s[Jr + 8 >> 2];
            s[Or + 12 >> 2] = s[Jr + 12 >> 2];
            s[Or + 16 >> 2] = s[Jr + 16 >> 2];
            s[Or + 20 >> 2] = s[Jr + 20 >> 2];
            s[Or + 24 >> 2] = s[Jr + 24 >> 2];
            s[Or + 28 >> 2] = s[Jr + 28 >> 2];
            m = 0;
            $(1, Fr | 0, Or | 0, 136, -460954743, -2016278654);
            Jr = m;
            m = 0;

            if (Jr & 1) {
              an = me() | 0;
              Da(Sr);
              Ee(an | 0);
            }

            s[tn >> 2] = s[Fr >> 2];
            s[tn + 4 >> 2] = s[Fr + 4 >> 2];
            s[tn + 8 >> 2] = s[Fr + 8 >> 2];
            s[tn + 12 >> 2] = s[Fr + 12 >> 2];
            s[tn + 16 >> 2] = s[Fr + 16 >> 2];
            s[tn + 20 >> 2] = s[Fr + 20 >> 2];
            s[tn + 24 >> 2] = s[Fr + 24 >> 2];
            s[tn + 28 >> 2] = s[Fr + 28 >> 2];
            Jr = Xr + 32 | 0;
            s[Jr >> 2] = s[tn >> 2];
            s[Jr + 4 >> 2] = s[tn + 4 >> 2];
            s[Jr + 8 >> 2] = s[tn + 8 >> 2];
            s[Jr + 12 >> 2] = s[tn + 12 >> 2];
            s[Jr + 16 >> 2] = s[tn + 16 >> 2];
            s[Jr + 20 >> 2] = s[tn + 20 >> 2];
            s[Jr + 24 >> 2] = s[tn + 24 >> 2];
            s[Jr + 28 >> 2] = s[tn + 28 >> 2];
            Jr = l + (r * 192 | 0) + 128 | 0;
            s[Yr >> 2] = s[Wr >> 2];
            s[Yr + 4 >> 2] = s[Wr + 4 >> 2];
            s[Yr + 8 >> 2] = s[Wr + 8 >> 2];
            s[Yr + 12 >> 2] = s[Wr + 12 >> 2];
            s[Yr + 16 >> 2] = s[Wr + 16 >> 2];
            s[Yr + 20 >> 2] = s[Wr + 20 >> 2];
            s[Yr + 24 >> 2] = s[Wr + 24 >> 2];
            s[Yr + 28 >> 2] = s[Wr + 28 >> 2];
            s[Lr >> 2] = s[Jr >> 2];
            s[Lr + 4 >> 2] = s[Jr + 4 >> 2];
            s[Lr + 8 >> 2] = s[Jr + 8 >> 2];
            s[Lr + 12 >> 2] = s[Jr + 12 >> 2];
            s[Lr + 16 >> 2] = s[Jr + 16 >> 2];
            s[Lr + 20 >> 2] = s[Jr + 20 >> 2];
            s[Lr + 24 >> 2] = s[Jr + 24 >> 2];
            s[Lr + 28 >> 2] = s[Jr + 28 >> 2];
            s[Pr >> 2] = s[Wr >> 2];
            s[Pr + 4 >> 2] = s[Wr + 4 >> 2];
            s[Pr + 8 >> 2] = s[Wr + 8 >> 2];
            s[Pr + 12 >> 2] = s[Wr + 12 >> 2];
            s[Pr + 16 >> 2] = s[Wr + 16 >> 2];
            s[Pr + 20 >> 2] = s[Wr + 20 >> 2];
            s[Pr + 24 >> 2] = s[Wr + 24 >> 2];
            s[Pr + 28 >> 2] = s[Wr + 28 >> 2];
            m = 0;
            $(1, Lr | 0, Pr | 0, 136, -460954743, -2016278654);
            Jr = m;
            m = 0;

            if (Jr & 1) {
              an = me() | 0;
              Da(Sr);
              Ee(an | 0);
            }

            s[Zr >> 2] = s[Lr >> 2];
            s[Zr + 4 >> 2] = s[Lr + 4 >> 2];
            s[Zr + 8 >> 2] = s[Lr + 8 >> 2];
            s[Zr + 12 >> 2] = s[Lr + 12 >> 2];
            s[Zr + 16 >> 2] = s[Lr + 16 >> 2];
            s[Zr + 20 >> 2] = s[Lr + 20 >> 2];
            s[Zr + 24 >> 2] = s[Lr + 24 >> 2];
            s[Zr + 28 >> 2] = s[Lr + 28 >> 2];
            Jr = l + (r * 192 | 0) + 160 | 0;
            s[Mr >> 2] = s[Jr >> 2];
            s[Mr + 4 >> 2] = s[Jr + 4 >> 2];
            s[Mr + 8 >> 2] = s[Jr + 8 >> 2];
            s[Mr + 12 >> 2] = s[Jr + 12 >> 2];
            s[Mr + 16 >> 2] = s[Jr + 16 >> 2];
            s[Mr + 20 >> 2] = s[Jr + 20 >> 2];
            s[Mr + 24 >> 2] = s[Jr + 24 >> 2];
            s[Mr + 28 >> 2] = s[Jr + 28 >> 2];
            s[Nr >> 2] = s[Yr >> 2];
            s[Nr + 4 >> 2] = s[Yr + 4 >> 2];
            s[Nr + 8 >> 2] = s[Yr + 8 >> 2];
            s[Nr + 12 >> 2] = s[Yr + 12 >> 2];
            s[Nr + 16 >> 2] = s[Yr + 16 >> 2];
            s[Nr + 20 >> 2] = s[Yr + 20 >> 2];
            s[Nr + 24 >> 2] = s[Yr + 24 >> 2];
            s[Nr + 28 >> 2] = s[Yr + 28 >> 2];
            m = 0;
            $(1, Mr | 0, Nr | 0, 136, -460954743, -2016278654);
            Jr = m;
            m = 0;

            if (Jr & 1) {
              an = me() | 0;
              Da(Sr);
              Ee(an | 0);
            }

            s[tn >> 2] = s[Mr >> 2];
            s[tn + 4 >> 2] = s[Mr + 4 >> 2];
            s[tn + 8 >> 2] = s[Mr + 8 >> 2];
            s[tn + 12 >> 2] = s[Mr + 12 >> 2];
            s[tn + 16 >> 2] = s[Mr + 16 >> 2];
            s[tn + 20 >> 2] = s[Mr + 20 >> 2];
            s[tn + 24 >> 2] = s[Mr + 24 >> 2];
            s[tn + 28 >> 2] = s[Mr + 28 >> 2];
            Jr = Zr + 32 | 0;
            s[Jr >> 2] = s[tn >> 2];
            s[Jr + 4 >> 2] = s[tn + 4 >> 2];
            s[Jr + 8 >> 2] = s[tn + 8 >> 2];
            s[Jr + 12 >> 2] = s[tn + 12 >> 2];
            s[Jr + 16 >> 2] = s[tn + 16 >> 2];
            s[Jr + 20 >> 2] = s[tn + 20 >> 2];
            s[Jr + 24 >> 2] = s[tn + 24 >> 2];
            s[Jr + 28 >> 2] = s[tn + 28 >> 2];
            m = 0;
            $(2, Qr | 0, en | 0, $r | 0, Xr | 0, Zr | 0);
            $r = m;
            m = 0;

            if ($r & 1) {
              an = me() | 0;
              Da(Sr);
              Ee(an | 0);
            }

            id(en | 0, Qr | 0, 384) | 0;

            if (d >>> 0 <= t >>> 0) {
              m = 0;
              re(19, 2056, t | 0, d | 0);
              m = 0;
              an = me() | 0;
              Da(Sr);
              Ee(an | 0);
            }

            ja = Kr;
            Ga = l + (t * 192 | 0) | 0;
            Va = ja + 64 | 0;

            do {
              s[ja >> 2] = s[Ga >> 2];
              ja = ja + 4 | 0;
              Ga = Ga + 4 | 0;
            } while ((ja | 0) < (Va | 0));

            Qr = l + (t * 192 | 0) + 64 | 0;
            s[Hr >> 2] = s[f >> 2];
            s[Hr + 4 >> 2] = s[f + 4 >> 2];
            s[Hr + 8 >> 2] = s[f + 8 >> 2];
            s[Hr + 12 >> 2] = s[f + 12 >> 2];
            s[Hr + 16 >> 2] = s[f + 16 >> 2];
            s[Hr + 20 >> 2] = s[f + 20 >> 2];
            s[Hr + 24 >> 2] = s[f + 24 >> 2];
            s[Hr + 28 >> 2] = s[f + 28 >> 2];
            s[Ir >> 2] = s[Qr >> 2];
            s[Ir + 4 >> 2] = s[Qr + 4 >> 2];
            s[Ir + 8 >> 2] = s[Qr + 8 >> 2];
            s[Ir + 12 >> 2] = s[Qr + 12 >> 2];
            s[Ir + 16 >> 2] = s[Qr + 16 >> 2];
            s[Ir + 20 >> 2] = s[Qr + 20 >> 2];
            s[Ir + 24 >> 2] = s[Qr + 24 >> 2];
            s[Ir + 28 >> 2] = s[Qr + 28 >> 2];
            s[Er >> 2] = s[f >> 2];
            s[Er + 4 >> 2] = s[f + 4 >> 2];
            s[Er + 8 >> 2] = s[f + 8 >> 2];
            s[Er + 12 >> 2] = s[f + 12 >> 2];
            s[Er + 16 >> 2] = s[f + 16 >> 2];
            s[Er + 20 >> 2] = s[f + 20 >> 2];
            s[Er + 24 >> 2] = s[f + 24 >> 2];
            s[Er + 28 >> 2] = s[f + 28 >> 2];
            m = 0;
            $(1, Ir | 0, Er | 0, 136, -460954743, -2016278654);
            Qr = m;
            m = 0;

            if (Qr & 1) {
              an = me() | 0;
              Da(Sr);
              Ee(an | 0);
            }

            s[zr >> 2] = s[Ir >> 2];
            s[zr + 4 >> 2] = s[Ir + 4 >> 2];
            s[zr + 8 >> 2] = s[Ir + 8 >> 2];
            s[zr + 12 >> 2] = s[Ir + 12 >> 2];
            s[zr + 16 >> 2] = s[Ir + 16 >> 2];
            s[zr + 20 >> 2] = s[Ir + 20 >> 2];
            s[zr + 24 >> 2] = s[Ir + 24 >> 2];
            s[zr + 28 >> 2] = s[Ir + 28 >> 2];
            Qr = l + (t * 192 | 0) + 96 | 0;
            s[Cr >> 2] = s[Qr >> 2];
            s[Cr + 4 >> 2] = s[Qr + 4 >> 2];
            s[Cr + 8 >> 2] = s[Qr + 8 >> 2];
            s[Cr + 12 >> 2] = s[Qr + 12 >> 2];
            s[Cr + 16 >> 2] = s[Qr + 16 >> 2];
            s[Cr + 20 >> 2] = s[Qr + 20 >> 2];
            s[Cr + 24 >> 2] = s[Qr + 24 >> 2];
            s[Cr + 28 >> 2] = s[Qr + 28 >> 2];
            s[Dr >> 2] = s[Hr >> 2];
            s[Dr + 4 >> 2] = s[Hr + 4 >> 2];
            s[Dr + 8 >> 2] = s[Hr + 8 >> 2];
            s[Dr + 12 >> 2] = s[Hr + 12 >> 2];
            s[Dr + 16 >> 2] = s[Hr + 16 >> 2];
            s[Dr + 20 >> 2] = s[Hr + 20 >> 2];
            s[Dr + 24 >> 2] = s[Hr + 24 >> 2];
            s[Dr + 28 >> 2] = s[Hr + 28 >> 2];
            m = 0;
            $(1, Cr | 0, Dr | 0, 136, -460954743, -2016278654);
            Qr = m;
            m = 0;

            if (Qr & 1) {
              an = me() | 0;
              Da(Sr);
              Ee(an | 0);
            }

            s[tn >> 2] = s[Cr >> 2];
            s[tn + 4 >> 2] = s[Cr + 4 >> 2];
            s[tn + 8 >> 2] = s[Cr + 8 >> 2];
            s[tn + 12 >> 2] = s[Cr + 12 >> 2];
            s[tn + 16 >> 2] = s[Cr + 16 >> 2];
            s[tn + 20 >> 2] = s[Cr + 20 >> 2];
            s[tn + 24 >> 2] = s[Cr + 24 >> 2];
            s[tn + 28 >> 2] = s[Cr + 28 >> 2];
            Qr = zr + 32 | 0;
            s[Qr >> 2] = s[tn >> 2];
            s[Qr + 4 >> 2] = s[tn + 4 >> 2];
            s[Qr + 8 >> 2] = s[tn + 8 >> 2];
            s[Qr + 12 >> 2] = s[tn + 12 >> 2];
            s[Qr + 16 >> 2] = s[tn + 16 >> 2];
            s[Qr + 20 >> 2] = s[tn + 20 >> 2];
            s[Qr + 24 >> 2] = s[tn + 24 >> 2];
            s[Qr + 28 >> 2] = s[tn + 28 >> 2];
            Qr = l + (t * 192 | 0) + 128 | 0;
            s[Vr >> 2] = s[Wr >> 2];
            s[Vr + 4 >> 2] = s[Wr + 4 >> 2];
            s[Vr + 8 >> 2] = s[Wr + 8 >> 2];
            s[Vr + 12 >> 2] = s[Wr + 12 >> 2];
            s[Vr + 16 >> 2] = s[Wr + 16 >> 2];
            s[Vr + 20 >> 2] = s[Wr + 20 >> 2];
            s[Vr + 24 >> 2] = s[Wr + 24 >> 2];
            s[Vr + 28 >> 2] = s[Wr + 28 >> 2];
            s[xr >> 2] = s[Qr >> 2];
            s[xr + 4 >> 2] = s[Qr + 4 >> 2];
            s[xr + 8 >> 2] = s[Qr + 8 >> 2];
            s[xr + 12 >> 2] = s[Qr + 12 >> 2];
            s[xr + 16 >> 2] = s[Qr + 16 >> 2];
            s[xr + 20 >> 2] = s[Qr + 20 >> 2];
            s[xr + 24 >> 2] = s[Qr + 24 >> 2];
            s[xr + 28 >> 2] = s[Qr + 28 >> 2];
            s[Tr >> 2] = s[Wr >> 2];
            s[Tr + 4 >> 2] = s[Wr + 4 >> 2];
            s[Tr + 8 >> 2] = s[Wr + 8 >> 2];
            s[Tr + 12 >> 2] = s[Wr + 12 >> 2];
            s[Tr + 16 >> 2] = s[Wr + 16 >> 2];
            s[Tr + 20 >> 2] = s[Wr + 20 >> 2];
            s[Tr + 24 >> 2] = s[Wr + 24 >> 2];
            s[Tr + 28 >> 2] = s[Wr + 28 >> 2];
            m = 0;
            $(1, xr | 0, Tr | 0, 136, -460954743, -2016278654);
            Qr = m;
            m = 0;

            if (Qr & 1) {
              an = me() | 0;
              Da(Sr);
              Ee(an | 0);
            }

            s[Ur >> 2] = s[xr >> 2];
            s[Ur + 4 >> 2] = s[xr + 4 >> 2];
            s[Ur + 8 >> 2] = s[xr + 8 >> 2];
            s[Ur + 12 >> 2] = s[xr + 12 >> 2];
            s[Ur + 16 >> 2] = s[xr + 16 >> 2];
            s[Ur + 20 >> 2] = s[xr + 20 >> 2];
            s[Ur + 24 >> 2] = s[xr + 24 >> 2];
            s[Ur + 28 >> 2] = s[xr + 28 >> 2];
            Qr = l + (t * 192 | 0) + 160 | 0;
            s[wr >> 2] = s[Qr >> 2];
            s[wr + 4 >> 2] = s[Qr + 4 >> 2];
            s[wr + 8 >> 2] = s[Qr + 8 >> 2];
            s[wr + 12 >> 2] = s[Qr + 12 >> 2];
            s[wr + 16 >> 2] = s[Qr + 16 >> 2];
            s[wr + 20 >> 2] = s[Qr + 20 >> 2];
            s[wr + 24 >> 2] = s[Qr + 24 >> 2];
            s[wr + 28 >> 2] = s[Qr + 28 >> 2];
            s[Ar >> 2] = s[Vr >> 2];
            s[Ar + 4 >> 2] = s[Vr + 4 >> 2];
            s[Ar + 8 >> 2] = s[Vr + 8 >> 2];
            s[Ar + 12 >> 2] = s[Vr + 12 >> 2];
            s[Ar + 16 >> 2] = s[Vr + 16 >> 2];
            s[Ar + 20 >> 2] = s[Vr + 20 >> 2];
            s[Ar + 24 >> 2] = s[Vr + 24 >> 2];
            s[Ar + 28 >> 2] = s[Vr + 28 >> 2];
            m = 0;
            $(1, wr | 0, Ar | 0, 136, -460954743, -2016278654);
            Qr = m;
            m = 0;

            if (Qr & 1) {
              an = me() | 0;
              Da(Sr);
              Ee(an | 0);
            }

            s[tn >> 2] = s[wr >> 2];
            s[tn + 4 >> 2] = s[wr + 4 >> 2];
            s[tn + 8 >> 2] = s[wr + 8 >> 2];
            s[tn + 12 >> 2] = s[wr + 12 >> 2];
            s[tn + 16 >> 2] = s[wr + 16 >> 2];
            s[tn + 20 >> 2] = s[wr + 20 >> 2];
            s[tn + 24 >> 2] = s[wr + 24 >> 2];
            s[tn + 28 >> 2] = s[wr + 28 >> 2];
            Qr = Ur + 32 | 0;
            s[Qr >> 2] = s[tn >> 2];
            s[Qr + 4 >> 2] = s[tn + 4 >> 2];
            s[Qr + 8 >> 2] = s[tn + 8 >> 2];
            s[Qr + 12 >> 2] = s[tn + 12 >> 2];
            s[Qr + 16 >> 2] = s[tn + 16 >> 2];
            s[Qr + 20 >> 2] = s[tn + 20 >> 2];
            s[Qr + 24 >> 2] = s[tn + 24 >> 2];
            s[Qr + 28 >> 2] = s[tn + 28 >> 2];
            m = 0;
            $(2, qr | 0, en | 0, Kr | 0, zr | 0, Ur | 0);
            tn = m;
            m = 0;

            if (tn & 1) {
              an = me() | 0;
              Da(Sr);
              Ee(an | 0);
            }

            id(en | 0, qr | 0, 384) | 0;
            id(Br | 0, en | 0, 384) | 0;
            m = 0;
            te(20, kr | 0, Br | 0);
            tn = m;
            m = 0;

            if (tn & 1) {
              an = me() | 0;
              Da(Sr);
              Ee(an | 0);
            }

            tn = kr;

            if (!((s[tn >> 2] | 0) == 1 & (s[tn + 4 >> 2] | 0) == 0)) {
              m = 0;
              te(21, 6331, 31);
              m = 0;
              an = me() | 0;
              Da(Sr);
              Ee(an | 0);
            }

            id(e | 0, kr + 8 | 0, 384) | 0;
            t = s[Sr + 132 >> 2] | 0;
            if (t | 0) Ut(l, t * 192 | 0, 8);
            p = an;
            return;
          } else if ((t | 0) == 103) {
            m = 0;
            re(19, 2056, r | 0, d | 0);
            m = 0;
            an = me() | 0;
            Da(Sr);
            Ee(an | 0);
          } else if ((t | 0) == 112) {
            m = 0;
            re(19, 2056, u | 0, d | 0);
            m = 0;
            an = me() | 0;
            Da(Sr);
            Ee(an | 0);
          } else if ((t | 0) == 126) {
            an = me() | 0;
            Da(Sr);
            Ee(an | 0);
          }
        } else if ((t | 0) == 82) {
          an = me() | 0;
          xa(Ha);
          Ee(an | 0);
        }
      }

      function Ta(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0,
            A = 0,
            w = 0,
            T = 0,
            x = 0,
            D = 0,
            C = 0,
            S = 0;
        D = p;
        p = p + 1024 | 0;
        y = D + 960 | 0;
        v = D + 896 | 0;
        _ = D + 832 | 0;
        g = D + 768 | 0;
        A = D + 704 | 0;
        w = D + 640 | 0;
        T = D + 576 | 0;
        o = D + 512 | 0;
        i = D + 448 | 0;
        c = D + 384 | 0;
        u = D + 320 | 0;
        d = D + 256 | 0;
        r = D + 192 | 0;
        n = D + 128 | 0;
        f = D + 64 | 0;
        l = D;
        x = A;
        C = t;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        h = t + 128 | 0;
        x = v;
        C = h;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        x = y;
        C = a;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        Ya(g, v, y);
        s[v >> 2] = s[A >> 2];
        s[v + 4 >> 2] = s[A + 4 >> 2];
        s[v + 8 >> 2] = s[A + 8 >> 2];
        s[v + 12 >> 2] = s[A + 12 >> 2];
        s[v + 16 >> 2] = s[A + 16 >> 2];
        s[v + 20 >> 2] = s[A + 20 >> 2];
        s[v + 24 >> 2] = s[A + 24 >> 2];
        s[v + 28 >> 2] = s[A + 28 >> 2];
        s[y >> 2] = s[g >> 2];
        s[y + 4 >> 2] = s[g + 4 >> 2];
        s[y + 8 >> 2] = s[g + 8 >> 2];
        s[y + 12 >> 2] = s[g + 12 >> 2];
        s[y + 16 >> 2] = s[g + 16 >> 2];
        s[y + 20 >> 2] = s[g + 20 >> 2];
        s[y + 24 >> 2] = s[g + 24 >> 2];
        s[y + 28 >> 2] = s[g + 28 >> 2];
        Ba(v, y, 136);
        s[l >> 2] = s[v >> 2];
        s[l + 4 >> 2] = s[v + 4 >> 2];
        s[l + 8 >> 2] = s[v + 8 >> 2];
        s[l + 12 >> 2] = s[v + 12 >> 2];
        s[l + 16 >> 2] = s[v + 16 >> 2];
        s[l + 20 >> 2] = s[v + 20 >> 2];
        s[l + 24 >> 2] = s[v + 24 >> 2];
        s[l + 28 >> 2] = s[v + 28 >> 2];
        b = A + 32 | 0;
        s[v >> 2] = s[b >> 2];
        s[v + 4 >> 2] = s[b + 4 >> 2];
        s[v + 8 >> 2] = s[b + 8 >> 2];
        s[v + 12 >> 2] = s[b + 12 >> 2];
        s[v + 16 >> 2] = s[b + 16 >> 2];
        s[v + 20 >> 2] = s[b + 20 >> 2];
        s[v + 24 >> 2] = s[b + 24 >> 2];
        s[v + 28 >> 2] = s[b + 28 >> 2];
        b = g + 32 | 0;
        s[y >> 2] = s[b >> 2];
        s[y + 4 >> 2] = s[b + 4 >> 2];
        s[y + 8 >> 2] = s[b + 8 >> 2];
        s[y + 12 >> 2] = s[b + 12 >> 2];
        s[y + 16 >> 2] = s[b + 16 >> 2];
        s[y + 20 >> 2] = s[b + 20 >> 2];
        s[y + 24 >> 2] = s[b + 24 >> 2];
        s[y + 28 >> 2] = s[b + 28 >> 2];
        Ba(v, y, 136);
        s[_ >> 2] = s[v >> 2];
        s[_ + 4 >> 2] = s[v + 4 >> 2];
        s[_ + 8 >> 2] = s[v + 8 >> 2];
        s[_ + 12 >> 2] = s[v + 12 >> 2];
        s[_ + 16 >> 2] = s[v + 16 >> 2];
        s[_ + 20 >> 2] = s[v + 20 >> 2];
        s[_ + 24 >> 2] = s[v + 24 >> 2];
        s[_ + 28 >> 2] = s[v + 28 >> 2];
        b = l + 32 | 0;
        s[b >> 2] = s[_ >> 2];
        s[b + 4 >> 2] = s[_ + 4 >> 2];
        s[b + 8 >> 2] = s[_ + 8 >> 2];
        s[b + 12 >> 2] = s[_ + 12 >> 2];
        s[b + 16 >> 2] = s[_ + 16 >> 2];
        s[b + 20 >> 2] = s[_ + 20 >> 2];
        s[b + 24 >> 2] = s[_ + 24 >> 2];
        s[b + 28 >> 2] = s[_ + 28 >> 2];
        b = t + 64 | 0;
        x = A;
        C = b;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        x = v;
        C = h;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        m = a + 64 | 0;
        x = y;
        C = m;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        Ya(g, v, y);
        s[v >> 2] = s[A >> 2];
        s[v + 4 >> 2] = s[A + 4 >> 2];
        s[v + 8 >> 2] = s[A + 8 >> 2];
        s[v + 12 >> 2] = s[A + 12 >> 2];
        s[v + 16 >> 2] = s[A + 16 >> 2];
        s[v + 20 >> 2] = s[A + 20 >> 2];
        s[v + 24 >> 2] = s[A + 24 >> 2];
        s[v + 28 >> 2] = s[A + 28 >> 2];
        s[y >> 2] = s[g >> 2];
        s[y + 4 >> 2] = s[g + 4 >> 2];
        s[y + 8 >> 2] = s[g + 8 >> 2];
        s[y + 12 >> 2] = s[g + 12 >> 2];
        s[y + 16 >> 2] = s[g + 16 >> 2];
        s[y + 20 >> 2] = s[g + 20 >> 2];
        s[y + 24 >> 2] = s[g + 24 >> 2];
        s[y + 28 >> 2] = s[g + 28 >> 2];
        Ba(v, y, 136);
        s[f >> 2] = s[v >> 2];
        s[f + 4 >> 2] = s[v + 4 >> 2];
        s[f + 8 >> 2] = s[v + 8 >> 2];
        s[f + 12 >> 2] = s[v + 12 >> 2];
        s[f + 16 >> 2] = s[v + 16 >> 2];
        s[f + 20 >> 2] = s[v + 20 >> 2];
        s[f + 24 >> 2] = s[v + 24 >> 2];
        s[f + 28 >> 2] = s[v + 28 >> 2];
        x = A + 32 | 0;
        s[v >> 2] = s[x >> 2];
        s[v + 4 >> 2] = s[x + 4 >> 2];
        s[v + 8 >> 2] = s[x + 8 >> 2];
        s[v + 12 >> 2] = s[x + 12 >> 2];
        s[v + 16 >> 2] = s[x + 16 >> 2];
        s[v + 20 >> 2] = s[x + 20 >> 2];
        s[v + 24 >> 2] = s[x + 24 >> 2];
        s[v + 28 >> 2] = s[x + 28 >> 2];
        x = g + 32 | 0;
        s[y >> 2] = s[x >> 2];
        s[y + 4 >> 2] = s[x + 4 >> 2];
        s[y + 8 >> 2] = s[x + 8 >> 2];
        s[y + 12 >> 2] = s[x + 12 >> 2];
        s[y + 16 >> 2] = s[x + 16 >> 2];
        s[y + 20 >> 2] = s[x + 20 >> 2];
        s[y + 24 >> 2] = s[x + 24 >> 2];
        s[y + 28 >> 2] = s[x + 28 >> 2];
        Ba(v, y, 136);
        s[_ >> 2] = s[v >> 2];
        s[_ + 4 >> 2] = s[v + 4 >> 2];
        s[_ + 8 >> 2] = s[v + 8 >> 2];
        s[_ + 12 >> 2] = s[v + 12 >> 2];
        s[_ + 16 >> 2] = s[v + 16 >> 2];
        s[_ + 20 >> 2] = s[v + 20 >> 2];
        s[_ + 24 >> 2] = s[v + 24 >> 2];
        s[_ + 28 >> 2] = s[v + 28 >> 2];
        x = f + 32 | 0;
        s[x >> 2] = s[_ >> 2];
        s[x + 4 >> 2] = s[_ + 4 >> 2];
        s[x + 8 >> 2] = s[_ + 8 >> 2];
        s[x + 12 >> 2] = s[_ + 12 >> 2];
        s[x + 16 >> 2] = s[_ + 16 >> 2];
        s[x + 20 >> 2] = s[_ + 20 >> 2];
        s[x + 24 >> 2] = s[_ + 24 >> 2];
        s[x + 28 >> 2] = s[_ + 28 >> 2];
        Za(n, l);
        Za(r, f);
        x = v;
        C = l;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        x = y;
        C = n;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        Ya(d, v, y);
        x = v;
        C = t;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        x = y;
        C = n;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        Ya(u, v, y);
        x = v;
        C = h;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        x = y;
        C = r;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        Ya(A, v, y);
        x = g;
        C = d;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        s[v >> 2] = s[A >> 2];
        s[v + 4 >> 2] = s[A + 4 >> 2];
        s[v + 8 >> 2] = s[A + 8 >> 2];
        s[v + 12 >> 2] = s[A + 12 >> 2];
        s[v + 16 >> 2] = s[A + 16 >> 2];
        s[v + 20 >> 2] = s[A + 20 >> 2];
        s[v + 24 >> 2] = s[A + 24 >> 2];
        s[v + 28 >> 2] = s[A + 28 >> 2];
        s[y >> 2] = s[d >> 2];
        s[y + 4 >> 2] = s[d + 4 >> 2];
        s[y + 8 >> 2] = s[d + 8 >> 2];
        s[y + 12 >> 2] = s[d + 12 >> 2];
        s[y + 16 >> 2] = s[d + 16 >> 2];
        s[y + 20 >> 2] = s[d + 20 >> 2];
        s[y + 24 >> 2] = s[d + 24 >> 2];
        s[y + 28 >> 2] = s[d + 28 >> 2];
        Ea(v, y, 136);
        s[T >> 2] = s[v >> 2];
        s[T + 4 >> 2] = s[v + 4 >> 2];
        s[T + 8 >> 2] = s[v + 8 >> 2];
        s[T + 12 >> 2] = s[v + 12 >> 2];
        s[T + 16 >> 2] = s[v + 16 >> 2];
        s[T + 20 >> 2] = s[v + 20 >> 2];
        s[T + 24 >> 2] = s[v + 24 >> 2];
        s[T + 28 >> 2] = s[v + 28 >> 2];
        r = A + 32 | 0;
        s[v >> 2] = s[r >> 2];
        s[v + 4 >> 2] = s[r + 4 >> 2];
        s[v + 8 >> 2] = s[r + 8 >> 2];
        s[v + 12 >> 2] = s[r + 12 >> 2];
        s[v + 16 >> 2] = s[r + 16 >> 2];
        s[v + 20 >> 2] = s[r + 20 >> 2];
        s[v + 24 >> 2] = s[r + 24 >> 2];
        s[v + 28 >> 2] = s[r + 28 >> 2];
        r = g + 32 | 0;
        s[y >> 2] = s[r >> 2];
        s[y + 4 >> 2] = s[r + 4 >> 2];
        s[y + 8 >> 2] = s[r + 8 >> 2];
        s[y + 12 >> 2] = s[r + 12 >> 2];
        s[y + 16 >> 2] = s[r + 16 >> 2];
        s[y + 20 >> 2] = s[r + 20 >> 2];
        s[y + 24 >> 2] = s[r + 24 >> 2];
        s[y + 28 >> 2] = s[r + 28 >> 2];
        Ea(v, y, 136);
        s[_ >> 2] = s[v >> 2];
        s[_ + 4 >> 2] = s[v + 4 >> 2];
        s[_ + 8 >> 2] = s[v + 8 >> 2];
        s[_ + 12 >> 2] = s[v + 12 >> 2];
        s[_ + 16 >> 2] = s[v + 16 >> 2];
        s[_ + 20 >> 2] = s[v + 20 >> 2];
        s[_ + 24 >> 2] = s[v + 24 >> 2];
        s[_ + 28 >> 2] = s[v + 28 >> 2];
        r = T + 32 | 0;
        s[r >> 2] = s[_ >> 2];
        s[r + 4 >> 2] = s[_ + 4 >> 2];
        s[r + 8 >> 2] = s[_ + 8 >> 2];
        s[r + 12 >> 2] = s[_ + 12 >> 2];
        s[r + 16 >> 2] = s[_ + 16 >> 2];
        s[r + 20 >> 2] = s[_ + 20 >> 2];
        s[r + 24 >> 2] = s[_ + 24 >> 2];
        s[r + 28 >> 2] = s[_ + 28 >> 2];
        x = A;
        C = u;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        x = g;
        C = u;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        s[v >> 2] = s[A >> 2];
        s[v + 4 >> 2] = s[A + 4 >> 2];
        s[v + 8 >> 2] = s[A + 8 >> 2];
        s[v + 12 >> 2] = s[A + 12 >> 2];
        s[v + 16 >> 2] = s[A + 16 >> 2];
        s[v + 20 >> 2] = s[A + 20 >> 2];
        s[v + 24 >> 2] = s[A + 24 >> 2];
        s[v + 28 >> 2] = s[A + 28 >> 2];
        s[y >> 2] = s[u >> 2];
        s[y + 4 >> 2] = s[u + 4 >> 2];
        s[y + 8 >> 2] = s[u + 8 >> 2];
        s[y + 12 >> 2] = s[u + 12 >> 2];
        s[y + 16 >> 2] = s[u + 16 >> 2];
        s[y + 20 >> 2] = s[u + 20 >> 2];
        s[y + 24 >> 2] = s[u + 24 >> 2];
        s[y + 28 >> 2] = s[u + 28 >> 2];
        Ea(v, y, 136);
        s[w >> 2] = s[v >> 2];
        s[w + 4 >> 2] = s[v + 4 >> 2];
        s[w + 8 >> 2] = s[v + 8 >> 2];
        s[w + 12 >> 2] = s[v + 12 >> 2];
        s[w + 16 >> 2] = s[v + 16 >> 2];
        s[w + 20 >> 2] = s[v + 20 >> 2];
        s[w + 24 >> 2] = s[v + 24 >> 2];
        s[w + 28 >> 2] = s[v + 28 >> 2];
        x = A + 32 | 0;
        s[v >> 2] = s[x >> 2];
        s[v + 4 >> 2] = s[x + 4 >> 2];
        s[v + 8 >> 2] = s[x + 8 >> 2];
        s[v + 12 >> 2] = s[x + 12 >> 2];
        s[v + 16 >> 2] = s[x + 16 >> 2];
        s[v + 20 >> 2] = s[x + 20 >> 2];
        s[v + 24 >> 2] = s[x + 24 >> 2];
        s[v + 28 >> 2] = s[x + 28 >> 2];
        x = g + 32 | 0;
        s[y >> 2] = s[x >> 2];
        s[y + 4 >> 2] = s[x + 4 >> 2];
        s[y + 8 >> 2] = s[x + 8 >> 2];
        s[y + 12 >> 2] = s[x + 12 >> 2];
        s[y + 16 >> 2] = s[x + 16 >> 2];
        s[y + 20 >> 2] = s[x + 20 >> 2];
        s[y + 24 >> 2] = s[x + 24 >> 2];
        s[y + 28 >> 2] = s[x + 28 >> 2];
        Ea(v, y, 136);
        s[_ >> 2] = s[v >> 2];
        s[_ + 4 >> 2] = s[v + 4 >> 2];
        s[_ + 8 >> 2] = s[v + 8 >> 2];
        s[_ + 12 >> 2] = s[v + 12 >> 2];
        s[_ + 16 >> 2] = s[v + 16 >> 2];
        s[_ + 20 >> 2] = s[v + 20 >> 2];
        s[_ + 24 >> 2] = s[v + 24 >> 2];
        s[_ + 28 >> 2] = s[v + 28 >> 2];
        x = w + 32 | 0;
        s[x >> 2] = s[_ >> 2];
        s[x + 4 >> 2] = s[_ + 4 >> 2];
        s[x + 8 >> 2] = s[_ + 8 >> 2];
        s[x + 12 >> 2] = s[_ + 12 >> 2];
        s[x + 16 >> 2] = s[_ + 16 >> 2];
        s[x + 20 >> 2] = s[_ + 20 >> 2];
        s[x + 24 >> 2] = s[_ + 24 >> 2];
        s[x + 28 >> 2] = s[_ + 28 >> 2];
        s[v >> 2] = s[T >> 2];
        s[v + 4 >> 2] = s[T + 4 >> 2];
        s[v + 8 >> 2] = s[T + 8 >> 2];
        s[v + 12 >> 2] = s[T + 12 >> 2];
        s[v + 16 >> 2] = s[T + 16 >> 2];
        s[v + 20 >> 2] = s[T + 20 >> 2];
        s[v + 24 >> 2] = s[T + 24 >> 2];
        s[v + 28 >> 2] = s[T + 28 >> 2];
        s[y >> 2] = s[w >> 2];
        s[y + 4 >> 2] = s[w + 4 >> 2];
        s[y + 8 >> 2] = s[w + 8 >> 2];
        s[y + 12 >> 2] = s[w + 12 >> 2];
        s[y + 16 >> 2] = s[w + 16 >> 2];
        s[y + 20 >> 2] = s[w + 20 >> 2];
        s[y + 24 >> 2] = s[w + 24 >> 2];
        s[y + 28 >> 2] = s[w + 28 >> 2];
        Ba(v, y, 136);
        s[c >> 2] = s[v >> 2];
        s[c + 4 >> 2] = s[v + 4 >> 2];
        s[c + 8 >> 2] = s[v + 8 >> 2];
        s[c + 12 >> 2] = s[v + 12 >> 2];
        s[c + 16 >> 2] = s[v + 16 >> 2];
        s[c + 20 >> 2] = s[v + 20 >> 2];
        s[c + 24 >> 2] = s[v + 24 >> 2];
        s[c + 28 >> 2] = s[v + 28 >> 2];
        s[v >> 2] = s[r >> 2];
        s[v + 4 >> 2] = s[r + 4 >> 2];
        s[v + 8 >> 2] = s[r + 8 >> 2];
        s[v + 12 >> 2] = s[r + 12 >> 2];
        s[v + 16 >> 2] = s[r + 16 >> 2];
        s[v + 20 >> 2] = s[r + 20 >> 2];
        s[v + 24 >> 2] = s[r + 24 >> 2];
        s[v + 28 >> 2] = s[r + 28 >> 2];
        s[y >> 2] = s[x >> 2];
        s[y + 4 >> 2] = s[x + 4 >> 2];
        s[y + 8 >> 2] = s[x + 8 >> 2];
        s[y + 12 >> 2] = s[x + 12 >> 2];
        s[y + 16 >> 2] = s[x + 16 >> 2];
        s[y + 20 >> 2] = s[x + 20 >> 2];
        s[y + 24 >> 2] = s[x + 24 >> 2];
        s[y + 28 >> 2] = s[x + 28 >> 2];
        Ba(v, y, 136);
        s[_ >> 2] = s[v >> 2];
        s[_ + 4 >> 2] = s[v + 4 >> 2];
        s[_ + 8 >> 2] = s[v + 8 >> 2];
        s[_ + 12 >> 2] = s[v + 12 >> 2];
        s[_ + 16 >> 2] = s[v + 16 >> 2];
        s[_ + 20 >> 2] = s[v + 20 >> 2];
        s[_ + 24 >> 2] = s[v + 24 >> 2];
        s[_ + 28 >> 2] = s[v + 28 >> 2];
        x = c + 32 | 0;
        s[x >> 2] = s[_ >> 2];
        s[x + 4 >> 2] = s[_ + 4 >> 2];
        s[x + 8 >> 2] = s[_ + 8 >> 2];
        s[x + 12 >> 2] = s[_ + 12 >> 2];
        s[x + 16 >> 2] = s[_ + 16 >> 2];
        s[x + 20 >> 2] = s[_ + 20 >> 2];
        s[x + 24 >> 2] = s[_ + 24 >> 2];
        s[x + 28 >> 2] = s[_ + 28 >> 2];
        x = v;
        C = l;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        x = y;
        C = c;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        Ya(_, v, y);
        x = t;
        C = _;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        x = T;
        C = f;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        x = A;
        C = u;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        x = g;
        C = c;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        s[v >> 2] = s[u >> 2];
        s[v + 4 >> 2] = s[u + 4 >> 2];
        s[v + 8 >> 2] = s[u + 8 >> 2];
        s[v + 12 >> 2] = s[u + 12 >> 2];
        s[v + 16 >> 2] = s[u + 16 >> 2];
        s[v + 20 >> 2] = s[u + 20 >> 2];
        s[v + 24 >> 2] = s[u + 24 >> 2];
        s[v + 28 >> 2] = s[u + 28 >> 2];
        s[y >> 2] = s[c >> 2];
        s[y + 4 >> 2] = s[c + 4 >> 2];
        s[y + 8 >> 2] = s[c + 8 >> 2];
        s[y + 12 >> 2] = s[c + 12 >> 2];
        s[y + 16 >> 2] = s[c + 16 >> 2];
        s[y + 20 >> 2] = s[c + 20 >> 2];
        s[y + 24 >> 2] = s[c + 24 >> 2];
        s[y + 28 >> 2] = s[c + 28 >> 2];
        Ba(v, y, 136);
        s[w >> 2] = s[v >> 2];
        s[w + 4 >> 2] = s[v + 4 >> 2];
        s[w + 8 >> 2] = s[v + 8 >> 2];
        s[w + 12 >> 2] = s[v + 12 >> 2];
        s[w + 16 >> 2] = s[v + 16 >> 2];
        s[w + 20 >> 2] = s[v + 20 >> 2];
        s[w + 24 >> 2] = s[v + 24 >> 2];
        s[w + 28 >> 2] = s[v + 28 >> 2];
        x = A + 32 | 0;
        s[v >> 2] = s[x >> 2];
        s[v + 4 >> 2] = s[x + 4 >> 2];
        s[v + 8 >> 2] = s[x + 8 >> 2];
        s[v + 12 >> 2] = s[x + 12 >> 2];
        s[v + 16 >> 2] = s[x + 16 >> 2];
        s[v + 20 >> 2] = s[x + 20 >> 2];
        s[v + 24 >> 2] = s[x + 24 >> 2];
        s[v + 28 >> 2] = s[x + 28 >> 2];
        x = g + 32 | 0;
        s[y >> 2] = s[x >> 2];
        s[y + 4 >> 2] = s[x + 4 >> 2];
        s[y + 8 >> 2] = s[x + 8 >> 2];
        s[y + 12 >> 2] = s[x + 12 >> 2];
        s[y + 16 >> 2] = s[x + 16 >> 2];
        s[y + 20 >> 2] = s[x + 20 >> 2];
        s[y + 24 >> 2] = s[x + 24 >> 2];
        s[y + 28 >> 2] = s[x + 28 >> 2];
        Ba(v, y, 136);
        s[_ >> 2] = s[v >> 2];
        s[_ + 4 >> 2] = s[v + 4 >> 2];
        s[_ + 8 >> 2] = s[v + 8 >> 2];
        s[_ + 12 >> 2] = s[v + 12 >> 2];
        s[_ + 16 >> 2] = s[v + 16 >> 2];
        s[_ + 20 >> 2] = s[v + 20 >> 2];
        s[_ + 24 >> 2] = s[v + 24 >> 2];
        s[_ + 28 >> 2] = s[v + 28 >> 2];
        x = w + 32 | 0;
        s[x >> 2] = s[_ >> 2];
        s[x + 4 >> 2] = s[_ + 4 >> 2];
        s[x + 8 >> 2] = s[_ + 8 >> 2];
        s[x + 12 >> 2] = s[_ + 12 >> 2];
        s[x + 16 >> 2] = s[_ + 16 >> 2];
        s[x + 20 >> 2] = s[_ + 20 >> 2];
        s[x + 24 >> 2] = s[_ + 24 >> 2];
        s[x + 28 >> 2] = s[_ + 28 >> 2];
        Ya(o, T, w);
        x = v;
        C = d;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        x = y;
        C = b;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        Ya(g, v, y);
        s[v >> 2] = s[o >> 2];
        s[v + 4 >> 2] = s[o + 4 >> 2];
        s[v + 8 >> 2] = s[o + 8 >> 2];
        s[v + 12 >> 2] = s[o + 12 >> 2];
        s[v + 16 >> 2] = s[o + 16 >> 2];
        s[v + 20 >> 2] = s[o + 20 >> 2];
        s[v + 24 >> 2] = s[o + 24 >> 2];
        s[v + 28 >> 2] = s[o + 28 >> 2];
        s[y >> 2] = s[g >> 2];
        s[y + 4 >> 2] = s[g + 4 >> 2];
        s[y + 8 >> 2] = s[g + 8 >> 2];
        s[y + 12 >> 2] = s[g + 12 >> 2];
        s[y + 16 >> 2] = s[g + 16 >> 2];
        s[y + 20 >> 2] = s[g + 20 >> 2];
        s[y + 24 >> 2] = s[g + 24 >> 2];
        s[y + 28 >> 2] = s[g + 28 >> 2];
        Ba(v, y, 136);
        s[i >> 2] = s[v >> 2];
        s[i + 4 >> 2] = s[v + 4 >> 2];
        s[i + 8 >> 2] = s[v + 8 >> 2];
        s[i + 12 >> 2] = s[v + 12 >> 2];
        s[i + 16 >> 2] = s[v + 16 >> 2];
        s[i + 20 >> 2] = s[v + 20 >> 2];
        s[i + 24 >> 2] = s[v + 24 >> 2];
        s[i + 28 >> 2] = s[v + 28 >> 2];
        x = o + 32 | 0;
        s[v >> 2] = s[x >> 2];
        s[v + 4 >> 2] = s[x + 4 >> 2];
        s[v + 8 >> 2] = s[x + 8 >> 2];
        s[v + 12 >> 2] = s[x + 12 >> 2];
        s[v + 16 >> 2] = s[x + 16 >> 2];
        s[v + 20 >> 2] = s[x + 20 >> 2];
        s[v + 24 >> 2] = s[x + 24 >> 2];
        s[v + 28 >> 2] = s[x + 28 >> 2];
        x = g + 32 | 0;
        s[y >> 2] = s[x >> 2];
        s[y + 4 >> 2] = s[x + 4 >> 2];
        s[y + 8 >> 2] = s[x + 8 >> 2];
        s[y + 12 >> 2] = s[x + 12 >> 2];
        s[y + 16 >> 2] = s[x + 16 >> 2];
        s[y + 20 >> 2] = s[x + 20 >> 2];
        s[y + 24 >> 2] = s[x + 24 >> 2];
        s[y + 28 >> 2] = s[x + 28 >> 2];
        Ba(v, y, 136);
        s[_ >> 2] = s[v >> 2];
        s[_ + 4 >> 2] = s[v + 4 >> 2];
        s[_ + 8 >> 2] = s[v + 8 >> 2];
        s[_ + 12 >> 2] = s[v + 12 >> 2];
        s[_ + 16 >> 2] = s[v + 16 >> 2];
        s[_ + 20 >> 2] = s[v + 20 >> 2];
        s[_ + 24 >> 2] = s[v + 24 >> 2];
        s[_ + 28 >> 2] = s[v + 28 >> 2];
        x = i + 32 | 0;
        s[x >> 2] = s[_ >> 2];
        s[x + 4 >> 2] = s[_ + 4 >> 2];
        s[x + 8 >> 2] = s[_ + 8 >> 2];
        s[x + 12 >> 2] = s[_ + 12 >> 2];
        s[x + 16 >> 2] = s[_ + 16 >> 2];
        s[x + 20 >> 2] = s[_ + 20 >> 2];
        s[x + 24 >> 2] = s[_ + 24 >> 2];
        s[x + 28 >> 2] = s[_ + 28 >> 2];
        x = b;
        C = i;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        x = v;
        C = h;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        x = y;
        C = d;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        Ya(_, v, y);
        x = h;
        C = _;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        x = T;
        s[x >> 2] = 1091403767;
        s[x + 4 >> 2] = -167360562;
        x = T + 8 | 0;
        s[x >> 2] = -753151983;
        s[x + 4 >> 2] = 792555341;
        x = T + 16 | 0;
        s[x >> 2] = 960546513;
        s[x + 4 >> 2] = 692269950;
        x = T + 24 | 0;
        s[x >> 2] = -1478256553;
        s[x + 4 >> 2] = 496343272;
        x = T + 32 | 0;
        s[x >> 2] = -980480611;
        s[x + 4 >> 2] = -748862579;
        x = T + 40 | 0;
        s[x >> 2] = -171504835;
        s[x + 4 >> 2] = 175696680;
        x = T + 48 | 0;
        s[x >> 2] = 2021213740;
        s[x + 4 >> 2] = 1718526831;
        x = T + 56 | 0;
        s[x >> 2] = -1710760145;
        s[x + 4 >> 2] = 235567041;
        x = v;
        C = f;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        x = y;
        C = a;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        Ya(A, v, y);
        x = v;
        C = l;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        x = y;
        C = m;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        Ya(g, v, y);
        s[v >> 2] = s[A >> 2];
        s[v + 4 >> 2] = s[A + 4 >> 2];
        s[v + 8 >> 2] = s[A + 8 >> 2];
        s[v + 12 >> 2] = s[A + 12 >> 2];
        s[v + 16 >> 2] = s[A + 16 >> 2];
        s[v + 20 >> 2] = s[A + 20 >> 2];
        s[v + 24 >> 2] = s[A + 24 >> 2];
        s[v + 28 >> 2] = s[A + 28 >> 2];
        s[y >> 2] = s[g >> 2];
        s[y + 4 >> 2] = s[g + 4 >> 2];
        s[y + 8 >> 2] = s[g + 8 >> 2];
        s[y + 12 >> 2] = s[g + 12 >> 2];
        s[y + 16 >> 2] = s[g + 16 >> 2];
        s[y + 20 >> 2] = s[g + 20 >> 2];
        s[y + 24 >> 2] = s[g + 24 >> 2];
        s[y + 28 >> 2] = s[g + 28 >> 2];
        Ba(v, y, 136);
        s[w >> 2] = s[v >> 2];
        s[w + 4 >> 2] = s[v + 4 >> 2];
        s[w + 8 >> 2] = s[v + 8 >> 2];
        s[w + 12 >> 2] = s[v + 12 >> 2];
        s[w + 16 >> 2] = s[v + 16 >> 2];
        s[w + 20 >> 2] = s[v + 20 >> 2];
        s[w + 24 >> 2] = s[v + 24 >> 2];
        s[w + 28 >> 2] = s[v + 28 >> 2];
        x = A + 32 | 0;
        s[v >> 2] = s[x >> 2];
        s[v + 4 >> 2] = s[x + 4 >> 2];
        s[v + 8 >> 2] = s[x + 8 >> 2];
        s[v + 12 >> 2] = s[x + 12 >> 2];
        s[v + 16 >> 2] = s[x + 16 >> 2];
        s[v + 20 >> 2] = s[x + 20 >> 2];
        s[v + 24 >> 2] = s[x + 24 >> 2];
        s[v + 28 >> 2] = s[x + 28 >> 2];
        x = g + 32 | 0;
        s[y >> 2] = s[x >> 2];
        s[y + 4 >> 2] = s[x + 4 >> 2];
        s[y + 8 >> 2] = s[x + 8 >> 2];
        s[y + 12 >> 2] = s[x + 12 >> 2];
        s[y + 16 >> 2] = s[x + 16 >> 2];
        s[y + 20 >> 2] = s[x + 20 >> 2];
        s[y + 24 >> 2] = s[x + 24 >> 2];
        s[y + 28 >> 2] = s[x + 28 >> 2];
        Ba(v, y, 136);
        s[_ >> 2] = s[v >> 2];
        s[_ + 4 >> 2] = s[v + 4 >> 2];
        s[_ + 8 >> 2] = s[v + 8 >> 2];
        s[_ + 12 >> 2] = s[v + 12 >> 2];
        s[_ + 16 >> 2] = s[v + 16 >> 2];
        s[_ + 20 >> 2] = s[v + 20 >> 2];
        s[_ + 24 >> 2] = s[v + 24 >> 2];
        s[_ + 28 >> 2] = s[v + 28 >> 2];
        x = w + 32 | 0;
        s[x >> 2] = s[_ >> 2];
        s[x + 4 >> 2] = s[_ + 4 >> 2];
        s[x + 8 >> 2] = s[_ + 8 >> 2];
        s[x + 12 >> 2] = s[_ + 12 >> 2];
        s[x + 16 >> 2] = s[_ + 16 >> 2];
        s[x + 20 >> 2] = s[_ + 20 >> 2];
        s[x + 24 >> 2] = s[_ + 24 >> 2];
        s[x + 28 >> 2] = s[_ + 28 >> 2];
        Ya(o, T, w);
        x = v;
        C = f;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        s[y >> 2] = s[f >> 2];
        s[y + 4 >> 2] = s[f + 4 >> 2];
        s[y + 8 >> 2] = s[f + 8 >> 2];
        s[y + 12 >> 2] = s[f + 12 >> 2];
        s[y + 16 >> 2] = s[f + 16 >> 2];
        s[y + 20 >> 2] = s[f + 20 >> 2];
        s[y + 24 >> 2] = s[f + 24 >> 2];
        s[y + 28 >> 2] = s[f + 28 >> 2];
        Ra(y, 136);
        s[g >> 2] = s[y >> 2];
        s[g + 4 >> 2] = s[y + 4 >> 2];
        s[g + 8 >> 2] = s[y + 8 >> 2];
        s[g + 12 >> 2] = s[y + 12 >> 2];
        s[g + 16 >> 2] = s[y + 16 >> 2];
        s[g + 20 >> 2] = s[y + 20 >> 2];
        s[g + 24 >> 2] = s[y + 24 >> 2];
        s[g + 28 >> 2] = s[y + 28 >> 2];
        x = v + 32 | 0;
        s[y >> 2] = s[x >> 2];
        s[y + 4 >> 2] = s[x + 4 >> 2];
        s[y + 8 >> 2] = s[x + 8 >> 2];
        s[y + 12 >> 2] = s[x + 12 >> 2];
        s[y + 16 >> 2] = s[x + 16 >> 2];
        s[y + 20 >> 2] = s[x + 20 >> 2];
        s[y + 24 >> 2] = s[x + 24 >> 2];
        s[y + 28 >> 2] = s[x + 28 >> 2];
        Ra(y, 136);
        s[_ >> 2] = s[y >> 2];
        s[_ + 4 >> 2] = s[y + 4 >> 2];
        s[_ + 8 >> 2] = s[y + 8 >> 2];
        s[_ + 12 >> 2] = s[y + 12 >> 2];
        s[_ + 16 >> 2] = s[y + 16 >> 2];
        s[_ + 20 >> 2] = s[y + 20 >> 2];
        s[_ + 24 >> 2] = s[y + 24 >> 2];
        s[_ + 28 >> 2] = s[y + 28 >> 2];
        x = g + 32 | 0;
        s[x >> 2] = s[_ >> 2];
        s[x + 4 >> 2] = s[_ + 4 >> 2];
        s[x + 8 >> 2] = s[_ + 8 >> 2];
        s[x + 12 >> 2] = s[_ + 12 >> 2];
        s[x + 16 >> 2] = s[_ + 16 >> 2];
        s[x + 20 >> 2] = s[_ + 20 >> 2];
        s[x + 24 >> 2] = s[_ + 24 >> 2];
        s[x + 28 >> 2] = s[_ + 28 >> 2];
        x = e;
        C = o;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        x = e + 64 | 0;
        C = l;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        x = e + 128 | 0;
        C = g;
        S = x + 64 | 0;

        do {
          s[x >> 2] = s[C >> 2];
          x = x + 4 | 0;
          C = C + 4 | 0;
        } while ((x | 0) < (S | 0));

        p = D;
        return;
      }

      function xa(e) {
        e = e | 0;
        var t = 0;
        t = s[e + 4 >> 2] | 0;
        if (!t) return;
        Ut(s[e >> 2] | 0, t * 192 | 0, 8);
        return;
      }

      function Da(e) {
        e = e | 0;
        var t = 0;
        t = s[e + 132 >> 2] | 0;
        if (!t) return;
        Ut(s[e + 128 >> 2] | 0, t * 192 | 0, 8);
        return;
      }

      function Ca(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0;
        o = 4;

        while (1) {
          if (!o) {
            e = 0;
            t = 5;
            break;
          }

          o = o + -1 | 0;
          a = e + (o << 3) | 0;
          i = s[a >> 2] | 0;
          a = s[a + 4 >> 2] | 0;
          n = t + (o << 3) | 0;
          r = s[n >> 2] | 0;
          n = s[n + 4 >> 2] | 0;

          if (a >>> 0 < n >>> 0 | (a | 0) == (n | 0) & i >>> 0 < r >>> 0) {
            e = -1;
            t = 5;
            break;
          }

          if (a >>> 0 > n >>> 0 | (a | 0) == (n | 0) & i >>> 0 > r >>> 0) {
            e = 1;
            t = 5;
            break;
          }
        }

        if ((t | 0) == 5) return e | 0;
        return 0;
      }

      function Sa(e, t, a, n) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        n = n | 0;
        var o = 0,
            i = 0,
            c = 0;

        if ((n | 0) == 32) {
          o = t + 24 | 0;
          o = ue(s[o >> 2] | 0, s[o + 4 >> 2] | 0) | 0;
          n = S;
          i = a;
          c = i;
          r[c >> 0] = o;
          r[c + 1 >> 0] = o >> 8;
          r[c + 2 >> 0] = o >> 16;
          r[c + 3 >> 0] = o >> 24;
          i = i + 4 | 0;
          r[i >> 0] = n;
          r[i + 1 >> 0] = n >> 8;
          r[i + 2 >> 0] = n >> 16;
          r[i + 3 >> 0] = n >> 24;
          i = t + 16 | 0;
          i = ue(s[i >> 2] | 0, s[i + 4 >> 2] | 0) | 0;
          n = S;
          c = a + 8 | 0;
          o = c;
          r[o >> 0] = i;
          r[o + 1 >> 0] = i >> 8;
          r[o + 2 >> 0] = i >> 16;
          r[o + 3 >> 0] = i >> 24;
          c = c + 4 | 0;
          r[c >> 0] = n;
          r[c + 1 >> 0] = n >> 8;
          r[c + 2 >> 0] = n >> 16;
          r[c + 3 >> 0] = n >> 24;
          c = t + 8 | 0;
          c = ue(s[c >> 2] | 0, s[c + 4 >> 2] | 0) | 0;
          n = S;
          o = a + 16 | 0;
          i = o;
          r[i >> 0] = c;
          r[i + 1 >> 0] = c >> 8;
          r[i + 2 >> 0] = c >> 16;
          r[i + 3 >> 0] = c >> 24;
          o = o + 4 | 0;
          r[o >> 0] = n;
          r[o + 1 >> 0] = n >> 8;
          r[o + 2 >> 0] = n >> 16;
          r[o + 3 >> 0] = n >> 24;
          o = t;
          o = ue(s[o >> 2] | 0, s[o + 4 >> 2] | 0) | 0;
          t = S;
          n = a + 24 | 0;
          a = n;
          r[a >> 0] = o;
          r[a + 1 >> 0] = o >> 8;
          r[a + 2 >> 0] = o >> 16;
          r[a + 3 >> 0] = o >> 24;
          n = n + 4 | 0;
          r[n >> 0] = t;
          r[n + 1 >> 0] = t >> 8;
          r[n + 2 >> 0] = t >> 16;
          r[n + 3 >> 0] = t >> 24;
          s[e >> 2] = 0;
          return;
        } else {
          s[e >> 2] = 1;
          s[e + 4 >> 2] = 32;
          s[e + 8 >> 2] = n;
          return;
        }
      }

      function Ea(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            p = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0;
        h = e;
        d = s[h >> 2] | 0;
        h = s[h + 4 >> 2] | 0;
        o = t;
        f = s[o >> 2] | 0;
        o = s[o + 4 >> 2] | 0;
        Qu(f | 0, 0, d | 0, 0) | 0;
        l = S;
        d = Qu(f | 0, o | 0, d | 0, h | 0) | 0;
        f = S;
        h = Qu(o | 0, 0, h | 0, 0) | 0;
        l = Qu(h | 0, S | 0, l | 0, 0) | 0;
        h = e;
        s[h >> 2] = d;
        s[h + 4 >> 2] = l;
        h = e + 8 | 0;
        o = h;
        m = s[o + 4 >> 2] | 0;
        r = t + 8 | 0;
        p = s[r >> 2] | 0;
        r = s[r + 4 >> 2] | 0;
        o = Qu(S | 0, 0, s[o >> 2] | 0, 0) | 0;
        _ = S;
        Qu(o | 0, _ | 0, p | 0, 0) | 0;
        b = S;
        p = Qu(o | 0, _ | 0, p | 0, r | 0) | 0;
        m = Qu(r | 0, 0, m | 0, 0) | 0;
        b = Qu(m | 0, S | 0, b | 0, 0) | 0;
        m = h;
        s[m >> 2] = p;
        s[m + 4 >> 2] = b;
        m = e + 16 | 0;
        r = m;
        _ = s[r + 4 >> 2] | 0;
        o = t + 16 | 0;
        y = s[o >> 2] | 0;
        o = s[o + 4 >> 2] | 0;
        r = Qu(S | 0, 0, s[r >> 2] | 0, 0) | 0;
        n = S;
        Qu(r | 0, n | 0, y | 0, 0) | 0;
        v = S;
        y = Qu(r | 0, n | 0, y | 0, o | 0) | 0;
        _ = Qu(o | 0, 0, _ | 0, 0) | 0;
        v = Qu(_ | 0, S | 0, v | 0, 0) | 0;
        _ = m;
        s[_ >> 2] = y;
        s[_ + 4 >> 2] = v;
        _ = e + 24 | 0;
        o = _;
        n = s[o >> 2] | 0;
        o = s[o + 4 >> 2] | 0;
        r = t + 24 | 0;
        i = s[r >> 2] | 0;
        r = s[r + 4 >> 2] | 0;
        t = Qu(S | 0, 0, n | 0, 0) | 0;
        u = S;
        c = Qu(t | 0, u | 0, i | 0, r | 0) | 0;
        Qu(0, r | 0, n | 0, o | 0) | 0;
        Qu(i | 0, S | 0, t | 0, u | 0) | 0;
        u = S;
        t = _;
        s[t >> 2] = c;
        s[t + 4 >> 2] = u;
        t = 4;

        do {
          if (!t) break;
          t = t + -1 | 0;
          n = e + (t << 3) | 0;
          r = s[n >> 2] | 0;
          n = s[n + 4 >> 2] | 0;
          i = a + (t << 3) | 0;
          o = s[i >> 2] | 0;
          i = s[i + 4 >> 2] | 0;

          if (n >>> 0 < i >>> 0 | (n | 0) == (i | 0) & r >>> 0 < o >>> 0) {
            g = 6;
            break;
          }
        } while (!(n >>> 0 > i >>> 0 | (n | 0) == (i | 0) & r >>> 0 > o >>> 0));

        if ((g | 0) == 6) return;
        n = a;
        g = s[n >> 2] | 0;
        n = s[n + 4 >> 2] | 0;
        i = $u(d | 0, 1, g | 0, 0) | 0;
        o = S;
        g = $u(d | 0, f | 0, g | 0, n | 0) | 0;
        l = $u(l | 0, 1, n | 0, 0) | 0;
        f = (o >>> 0 < 1 | (o | 0) == 1 & i >>> 0 < 0) << 31 >> 31;
        l = Qu(f | 0, ((f | 0) < 0) << 31 >> 31 | 0, l | 0, S | 0) | 0;
        f = S;
        d = e;
        s[d >> 2] = g;
        s[d + 4 >> 2] = l;
        d = a + 8 | 0;
        g = s[d + 4 >> 2] | 0;
        p = $u(p | 0, 1, s[d >> 2] | 0, 0) | 0;
        l = (f >>> 0 < 1 | (f | 0) == 1 & l >>> 0 < 0) << 31 >> 31;
        p = Qu(l | 0, ((l | 0) < 0) << 31 >> 31 | 0, p | 0, S | 0) | 0;
        l = S;
        b = $u(b | 0, 1, g | 0, 0) | 0;
        l = (l >>> 0 < 1 | (l | 0) == 1 & p >>> 0 < 0) << 31 >> 31;
        b = Qu(l | 0, ((l | 0) < 0) << 31 >> 31 | 0, b | 0, S | 0) | 0;
        l = S;
        g = h;
        s[g >> 2] = p;
        s[g + 4 >> 2] = b;
        g = a + 16 | 0;
        p = s[g + 4 >> 2] | 0;
        g = $u(y | 0, 1, s[g >> 2] | 0, 0) | 0;
        b = (l >>> 0 < 1 | (l | 0) == 1 & b >>> 0 < 0) << 31 >> 31;
        g = Qu(b | 0, ((b | 0) < 0) << 31 >> 31 | 0, g | 0, S | 0) | 0;
        b = S;
        v = $u(v | 0, 1, p | 0, 0) | 0;
        b = (b >>> 0 < 1 | (b | 0) == 1 & g >>> 0 < 0) << 31 >> 31;
        v = Qu(b | 0, ((b | 0) < 0) << 31 >> 31 | 0, v | 0, S | 0) | 0;
        b = S;
        y = m;
        s[y >> 2] = g;
        s[y + 4 >> 2] = v;
        y = a + 24 | 0;
        g = s[y + 4 >> 2] | 0;
        y = $u(c | 0, 1, s[y >> 2] | 0, 0) | 0;
        v = (b >>> 0 < 1 | (b | 0) == 1 & v >>> 0 < 0) << 31 >> 31;
        y = Qu(v | 0, ((v | 0) < 0) << 31 >> 31 | 0, y | 0, S | 0) | 0;
        v = S;
        g = $u(u | 0, 0, g | 0, 0) | 0;
        v = (v >>> 0 < 1 | (v | 0) == 1 & y >>> 0 < 0) << 31 >> 31;
        v = Qu(g | 0, S | 0, v | 0, ((v | 0) < 0) << 31 >> 31 | 0) | 0;
        g = _;
        s[g >> 2] = y;
        s[g + 4 >> 2] = v;
        return;
      }

      function Ba(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0;
        c = 4;

        while (1) {
          if (!c) {
            c = 6;
            break;
          }

          c = c + -1 | 0;
          n = e + (c << 3) | 0;
          r = s[n >> 2] | 0;
          n = s[n + 4 >> 2] | 0;
          i = t + (c << 3) | 0;
          o = s[i >> 2] | 0;
          i = s[i + 4 >> 2] | 0;

          if (n >>> 0 < i >>> 0 | (n | 0) == (i | 0) & r >>> 0 < o >>> 0) {
            c = 5;
            break;
          }

          if (n >>> 0 > i >>> 0 | (n | 0) == (i | 0) & r >>> 0 > o >>> 0) {
            c = 6;
            break;
          }
        }

        if ((c | 0) == 5) {
          o = e;
          i = s[o >> 2] | 0;
          o = s[o + 4 >> 2] | 0;
          l = a;
          r = s[l >> 2] | 0;
          l = s[l + 4 >> 2] | 0;
          Qu(r | 0, 0, i | 0, 0) | 0;
          u = S;
          i = Qu(r | 0, l | 0, i | 0, o | 0) | 0;
          o = Qu(l | 0, 0, o | 0, 0) | 0;
          u = Qu(o | 0, S | 0, u | 0, 0) | 0;
          o = e;
          s[o >> 2] = i;
          s[o + 4 >> 2] = u;
          o = e + 8 | 0;
          u = o;
          i = s[u + 4 >> 2] | 0;
          l = a + 8 | 0;
          r = s[l >> 2] | 0;
          l = s[l + 4 >> 2] | 0;
          u = Qu(S | 0, 0, s[u >> 2] | 0, 0) | 0;
          f = S;
          Qu(u | 0, f | 0, r | 0, 0) | 0;
          c = S;
          r = Qu(u | 0, f | 0, r | 0, l | 0) | 0;
          i = Qu(l | 0, 0, i | 0, 0) | 0;
          c = Qu(i | 0, S | 0, c | 0, 0) | 0;
          i = o;
          s[i >> 2] = r;
          s[i + 4 >> 2] = c;
          i = e + 16 | 0;
          c = i;
          r = s[c + 4 >> 2] | 0;
          l = a + 16 | 0;
          f = s[l >> 2] | 0;
          l = s[l + 4 >> 2] | 0;
          c = Qu(S | 0, 0, s[c >> 2] | 0, 0) | 0;
          u = S;
          Qu(c | 0, u | 0, f | 0, 0) | 0;
          d = S;
          f = Qu(c | 0, u | 0, f | 0, l | 0) | 0;
          r = Qu(l | 0, 0, r | 0, 0) | 0;
          d = Qu(r | 0, S | 0, d | 0, 0) | 0;
          r = i;
          s[r >> 2] = f;
          s[r + 4 >> 2] = d;
          r = e + 24 | 0;
          d = r;
          f = s[d >> 2] | 0;
          d = s[d + 4 >> 2] | 0;
          l = a + 24 | 0;
          u = s[l >> 2] | 0;
          l = s[l + 4 >> 2] | 0;
          c = Qu(S | 0, 0, f | 0, 0) | 0;
          n = S;
          a = Qu(c | 0, n | 0, u | 0, l | 0) | 0;
          Qu(0, l | 0, f | 0, d | 0) | 0;
          Qu(u | 0, S | 0, c | 0, n | 0) | 0;
          n = r;
          s[n >> 2] = a;
          s[n + 4 >> 2] = S;
          n = e;
        } else if ((c | 0) == 6) {
          n = e;
          o = e + 8 | 0;
          i = e + 16 | 0;
          r = e + 24 | 0;
        }

        a = n;
        e = s[a >> 2] | 0;
        a = s[a + 4 >> 2] | 0;
        d = t;
        l = s[d >> 2] | 0;
        d = s[d + 4 >> 2] | 0;
        u = $u(e | 0, 1, l | 0, 0) | 0;
        f = S;
        l = $u(e | 0, a | 0, l | 0, d | 0) | 0;
        d = $u(a | 0, 1, d | 0, 0) | 0;
        u = (f >>> 0 < 1 | (f | 0) == 1 & u >>> 0 < 0) << 31 >> 31;
        d = Qu(u | 0, ((u | 0) < 0) << 31 >> 31 | 0, d | 0, S | 0) | 0;
        u = S;
        f = n;
        s[f >> 2] = l;
        s[f + 4 >> 2] = d;
        f = o;
        l = s[f + 4 >> 2] | 0;
        a = t + 8 | 0;
        e = s[a + 4 >> 2] | 0;
        a = $u(s[f >> 2] | 0, 1, s[a >> 2] | 0, 0) | 0;
        d = (u >>> 0 < 1 | (u | 0) == 1 & d >>> 0 < 0) << 31 >> 31;
        a = Qu(d | 0, ((d | 0) < 0) << 31 >> 31 | 0, a | 0, S | 0) | 0;
        d = S;
        e = $u(l | 0, 1, e | 0, 0) | 0;
        d = (d >>> 0 < 1 | (d | 0) == 1 & a >>> 0 < 0) << 31 >> 31;
        e = Qu(d | 0, ((d | 0) < 0) << 31 >> 31 | 0, e | 0, S | 0) | 0;
        d = S;
        l = o;
        s[l >> 2] = a;
        s[l + 4 >> 2] = e;
        l = i;
        a = s[l + 4 >> 2] | 0;
        u = t + 16 | 0;
        f = s[u + 4 >> 2] | 0;
        u = $u(s[l >> 2] | 0, 1, s[u >> 2] | 0, 0) | 0;
        e = (d >>> 0 < 1 | (d | 0) == 1 & e >>> 0 < 0) << 31 >> 31;
        u = Qu(e | 0, ((e | 0) < 0) << 31 >> 31 | 0, u | 0, S | 0) | 0;
        e = S;
        f = $u(a | 0, 1, f | 0, 0) | 0;
        e = (e >>> 0 < 1 | (e | 0) == 1 & u >>> 0 < 0) << 31 >> 31;
        f = Qu(e | 0, ((e | 0) < 0) << 31 >> 31 | 0, f | 0, S | 0) | 0;
        e = S;
        a = i;
        s[a >> 2] = u;
        s[a + 4 >> 2] = f;
        a = r;
        u = s[a + 4 >> 2] | 0;
        d = t + 24 | 0;
        l = s[d + 4 >> 2] | 0;
        d = $u(s[a >> 2] | 0, 1, s[d >> 2] | 0, 0) | 0;
        f = (e >>> 0 < 1 | (e | 0) == 1 & f >>> 0 < 0) << 31 >> 31;
        d = Qu(f | 0, ((f | 0) < 0) << 31 >> 31 | 0, d | 0, S | 0) | 0;
        f = S;
        l = $u(u | 0, 0, l | 0, 0) | 0;
        f = (f >>> 0 < 1 | (f | 0) == 1 & d >>> 0 < 0) << 31 >> 31;
        f = Qu(l | 0, S | 0, f | 0, ((f | 0) < 0) << 31 >> 31 | 0) | 0;
        l = r;
        s[l >> 2] = d;
        s[l + 4 >> 2] = f;
        return;
      }

      function ka(e, t, a, r, n) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        r = r | 0;
        n = n | 0;
        var o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0,
            A = 0,
            w = 0,
            T = 0,
            x = 0,
            D = 0,
            C = 0,
            E = 0,
            B = 0,
            k = 0;
        T = p;
        p = p + 64 | 0;
        A = T;
        o = A;
        i = o + 64 | 0;

        do {
          s[o >> 2] = 0;
          o = o + 4 | 0;
        } while ((o | 0) < (i | 0));

        _ = e + 32 | 0;
        g = t + 32 | 0;
        h = e;
        b = 0;

        do {
          y = h;
          h = h + 8 | 0;
          o = A + (b << 3) | 0;
          m = s[y >> 2] | 0;
          y = s[y + 4 >> 2] | 0;

          e: do {
            if (!((m | 0) == 0 & (y | 0) == 0)) {
              v = o + (8 - b << 3) | 0;
              i = t;
              f = 0;
              l = 0;

              while (1) {
                d = o;
                o = o + 8 | 0;
                if ((i | 0) == (g | 0)) {
                  if ((f | 0) == 0 & (l | 0) == 0) break e;else {
                    i = g;
                    c = 0;
                    u = 0;
                  }
                } else {
                  u = i;
                  i = i + 8 | 0;
                  c = s[u >> 2] | 0;
                  u = s[u + 4 >> 2] | 0;
                }
                k = d;
                B = s[k >> 2] | 0;
                k = s[k + 4 >> 2] | 0;
                x = ud(c | 0, 0, m | 0, 0) | 0;
                B = Qu(x | 0, S | 0, B | 0, 0) | 0;
                x = S;
                Qu(B | 0, x | 0, f | 0, 0) | 0;
                E = S;
                x = Qu(B | 0, x | 0, f | 0, l | 0) | 0;
                B = ud(c | 0, 0, y | 0, 0) | 0;
                C = S;
                c = ud(u | 0, 0, m | 0, 0) | 0;
                D = S;
                l = Qu(k | 0, 0, l | 0, 0) | 0;
                l = Qu(l | 0, S | 0, B | 0, 0) | 0;
                c = Qu(l | 0, S | 0, c | 0, 0) | 0;
                c = Qu(c | 0, S | 0, E | 0, 0) | 0;
                l = S;
                u = ud(u | 0, 0, y | 0, 0) | 0;
                u = Qu(C | 0, 0, u | 0, S | 0) | 0;
                u = Qu(u | 0, S | 0, D | 0, 0) | 0;
                f = Qu(u | 0, S | 0, l | 0, 0) | 0;
                l = d;
                s[l >> 2] = x;
                s[l + 4 >> 2] = c;
                if ((o | 0) == (v | 0)) break;else l = S;
              }
            }
          } while (0);

          b = b + 1 | 0;
        } while ((h | 0) != (_ | 0));

        h = a + 32 | 0;
        b = 0;

        do {
          o = A + (b << 3) | 0;
          m = o;
          m = ud(s[m >> 2] | 0, s[m + 4 >> 2] | 0, r | 0, n | 0) | 0;
          y = S;

          e: do {
            if (!((m | 0) == 0 & (y | 0) == 0)) {
              v = o + (8 - b << 3) | 0;
              i = a;
              u = 0;
              d = 0;

              while (1) {
                c = o;
                o = o + 8 | 0;
                if ((i | 0) == (h | 0)) {
                  if ((u | 0) == 0 & (d | 0) == 0) break e;else {
                    f = 0;
                    l = 0;
                    i = h;
                  }
                } else {
                  l = i;
                  f = s[l >> 2] | 0;
                  l = s[l + 4 >> 2] | 0;
                  i = i + 8 | 0;
                }
                t = c;
                D = s[t >> 2] | 0;
                t = s[t + 4 >> 2] | 0;
                E = ud(f | 0, 0, m | 0, 0) | 0;
                D = Qu(E | 0, S | 0, D | 0, 0) | 0;
                E = S;
                Qu(D | 0, E | 0, u | 0, 0) | 0;
                B = S;
                E = Qu(D | 0, E | 0, u | 0, d | 0) | 0;
                D = ud(f | 0, 0, y | 0, 0) | 0;
                x = S;
                k = ud(l | 0, 0, m | 0, 0) | 0;
                C = S;
                t = Qu(t | 0, 0, d | 0, 0) | 0;
                D = Qu(t | 0, S | 0, D | 0, 0) | 0;
                k = Qu(D | 0, S | 0, k | 0, 0) | 0;
                B = Qu(k | 0, S | 0, B | 0, 0) | 0;
                k = S;
                D = ud(l | 0, 0, y | 0, 0) | 0;
                D = Qu(x | 0, 0, D | 0, S | 0) | 0;
                C = Qu(D | 0, S | 0, C | 0, 0) | 0;
                u = Qu(C | 0, S | 0, k | 0, 0) | 0;
                k = c;
                s[k >> 2] = E;
                s[k + 4 >> 2] = B;
                if ((o | 0) == (v | 0)) break;else d = S;
              }
            }
          } while (0);

          b = b + 1 | 0;
        } while (b >>> 0 < 4);

        o = A + 32 | 0;
        s[e >> 2] = s[o >> 2];
        s[e + 4 >> 2] = s[o + 4 >> 2];
        s[e + 8 >> 2] = s[o + 8 >> 2];
        s[e + 12 >> 2] = s[o + 12 >> 2];
        s[e + 16 >> 2] = s[o + 16 >> 2];
        s[e + 20 >> 2] = s[o + 20 >> 2];
        s[e + 24 >> 2] = s[o + 24 >> 2];
        s[e + 28 >> 2] = s[o + 28 >> 2];
        o = 4;

        do {
          if (!o) break;
          o = o + -1 | 0;
          c = e + (o << 3) | 0;
          i = s[c >> 2] | 0;
          c = s[c + 4 >> 2] | 0;
          d = a + (o << 3) | 0;
          u = s[d >> 2] | 0;
          d = s[d + 4 >> 2] | 0;

          if (c >>> 0 < d >>> 0 | (c | 0) == (d | 0) & i >>> 0 < u >>> 0) {
            w = 22;
            break;
          }
        } while (!(c >>> 0 > d >>> 0 | (c | 0) == (d | 0) & i >>> 0 > u >>> 0));

        if ((w | 0) == 22) {
          p = T;
          return;
        }

        D = e;
        C = s[D >> 2] | 0;
        D = s[D + 4 >> 2] | 0;
        E = a;
        B = s[E >> 2] | 0;
        E = s[E + 4 >> 2] | 0;
        w = $u(C | 0, 1, B | 0, 0) | 0;
        k = S;
        B = $u(C | 0, D | 0, B | 0, E | 0) | 0;
        E = $u(D | 0, 1, E | 0, 0) | 0;
        w = (k >>> 0 < 1 | (k | 0) == 1 & w >>> 0 < 0) << 31 >> 31;
        E = Qu(w | 0, ((w | 0) < 0) << 31 >> 31 | 0, E | 0, S | 0) | 0;
        w = S;
        k = e;
        s[k >> 2] = B;
        s[k + 4 >> 2] = E;
        k = e + 8 | 0;
        B = k;
        D = s[B + 4 >> 2] | 0;
        C = a + 8 | 0;
        x = s[C + 4 >> 2] | 0;
        C = $u(s[B >> 2] | 0, 1, s[C >> 2] | 0, 0) | 0;
        E = (w >>> 0 < 1 | (w | 0) == 1 & E >>> 0 < 0) << 31 >> 31;
        C = Qu(E | 0, ((E | 0) < 0) << 31 >> 31 | 0, C | 0, S | 0) | 0;
        E = S;
        x = $u(D | 0, 1, x | 0, 0) | 0;
        E = (E >>> 0 < 1 | (E | 0) == 1 & C >>> 0 < 0) << 31 >> 31;
        x = Qu(E | 0, ((E | 0) < 0) << 31 >> 31 | 0, x | 0, S | 0) | 0;
        E = S;
        s[k >> 2] = C;
        s[k + 4 >> 2] = x;
        k = e + 16 | 0;
        C = k;
        D = s[C + 4 >> 2] | 0;
        w = a + 16 | 0;
        B = s[w + 4 >> 2] | 0;
        w = $u(s[C >> 2] | 0, 1, s[w >> 2] | 0, 0) | 0;
        x = (E >>> 0 < 1 | (E | 0) == 1 & x >>> 0 < 0) << 31 >> 31;
        w = Qu(x | 0, ((x | 0) < 0) << 31 >> 31 | 0, w | 0, S | 0) | 0;
        x = S;
        B = $u(D | 0, 1, B | 0, 0) | 0;
        x = (x >>> 0 < 1 | (x | 0) == 1 & w >>> 0 < 0) << 31 >> 31;
        B = Qu(x | 0, ((x | 0) < 0) << 31 >> 31 | 0, B | 0, S | 0) | 0;
        x = S;
        s[k >> 2] = w;
        s[k + 4 >> 2] = B;
        k = e + 24 | 0;
        w = k;
        D = s[w + 4 >> 2] | 0;
        E = a + 24 | 0;
        C = s[E + 4 >> 2] | 0;
        E = $u(s[w >> 2] | 0, 1, s[E >> 2] | 0, 0) | 0;
        B = (x >>> 0 < 1 | (x | 0) == 1 & B >>> 0 < 0) << 31 >> 31;
        E = Qu(B | 0, ((B | 0) < 0) << 31 >> 31 | 0, E | 0, S | 0) | 0;
        B = S;
        C = $u(D | 0, 0, C | 0, 0) | 0;
        B = (B >>> 0 < 1 | (B | 0) == 1 & E >>> 0 < 0) << 31 >> 31;
        B = Qu(C | 0, S | 0, B | 0, ((B | 0) < 0) << 31 >> 31 | 0) | 0;
        s[k >> 2] = E;
        s[k + 4 >> 2] = B;
        p = T;
        return;
      }

      function Ra(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0;
        u = p;
        p = p + 32 | 0;
        i = u;
        s[i >> 2] = 0;
        s[i + 4 >> 2] = 0;
        s[i + 8 >> 2] = 0;
        s[i + 12 >> 2] = 0;
        s[i + 16 >> 2] = 0;
        s[i + 20 >> 2] = 0;
        s[i + 24 >> 2] = 0;
        s[i + 28 >> 2] = 0;
        c = 4;

        while (1) {
          if (!c) {
            a = 5;
            break;
          }

          c = c + -1 | 0;
          r = e + (c << 3) | 0;
          a = s[r >> 2] | 0;
          r = s[r + 4 >> 2] | 0;
          o = i + (c << 3) | 0;
          n = s[o >> 2] | 0;
          o = s[o + 4 >> 2] | 0;

          if (r >>> 0 < o >>> 0 | (r | 0) == (o | 0) & a >>> 0 < n >>> 0) {
            a = 5;
            break;
          }

          if (r >>> 0 > o >>> 0 | (r | 0) == (o | 0) & a >>> 0 > n >>> 0) {
            a = 6;
            break;
          }
        }

        if ((a | 0) == 5) {
          p = u;
          return;
        } else if ((a | 0) == 6) {
          d = t;
          a = s[d >> 2] | 0;
          d = s[d + 4 >> 2] | 0;
          r = t + 8 | 0;
          n = s[r >> 2] | 0;
          r = s[r + 4 >> 2] | 0;
          i = t + 16 | 0;
          b = s[i >> 2] | 0;
          i = s[i + 4 >> 2] | 0;
          m = t + 24 | 0;
          y = s[m >> 2] | 0;
          m = s[m + 4 >> 2] | 0;
          l = e;
          h = s[l >> 2] | 0;
          l = s[l + 4 >> 2] | 0;
          c = $u(a | 0, 1, h | 0, 0) | 0;
          f = S;
          h = $u(a | 0, d | 0, h | 0, l | 0) | 0;
          l = $u(d | 0, 1, l | 0, 0) | 0;
          c = (f >>> 0 < 1 | (f | 0) == 1 & c >>> 0 < 0) << 31 >> 31;
          l = Qu(c | 0, ((c | 0) < 0) << 31 >> 31 | 0, l | 0, S | 0) | 0;
          c = S;
          f = e + 8 | 0;
          d = f;
          a = s[d + 4 >> 2] | 0;
          d = $u(n | 0, 1, s[d >> 2] | 0, 0) | 0;
          c = (c >>> 0 < 1 | (c | 0) == 1 & l >>> 0 < 0) << 31 >> 31;
          d = Qu(c | 0, ((c | 0) < 0) << 31 >> 31 | 0, d | 0, S | 0) | 0;
          c = S;
          a = $u(r | 0, 1, a | 0, 0) | 0;
          c = (c >>> 0 < 1 | (c | 0) == 1 & d >>> 0 < 0) << 31 >> 31;
          a = Qu(c | 0, ((c | 0) < 0) << 31 >> 31 | 0, a | 0, S | 0) | 0;
          c = S;
          r = e + 16 | 0;
          n = r;
          o = s[n + 4 >> 2] | 0;
          n = $u(b | 0, 1, s[n >> 2] | 0, 0) | 0;
          c = (c >>> 0 < 1 | (c | 0) == 1 & a >>> 0 < 0) << 31 >> 31;
          n = Qu(c | 0, ((c | 0) < 0) << 31 >> 31 | 0, n | 0, S | 0) | 0;
          c = S;
          o = $u(i | 0, 1, o | 0, 0) | 0;
          c = (c >>> 0 < 1 | (c | 0) == 1 & n >>> 0 < 0) << 31 >> 31;
          o = Qu(c | 0, ((c | 0) < 0) << 31 >> 31 | 0, o | 0, S | 0) | 0;
          c = S;
          t = e + 24 | 0;
          i = t;
          b = s[i + 4 >> 2] | 0;
          i = $u(y | 0, 1, s[i >> 2] | 0, 0) | 0;
          c = (c >>> 0 < 1 | (c | 0) == 1 & o >>> 0 < 0) << 31 >> 31;
          i = Qu(c | 0, ((c | 0) < 0) << 31 >> 31 | 0, i | 0, S | 0) | 0;
          c = S;
          b = $u(m | 0, 0, b | 0, 0) | 0;
          c = (c >>> 0 < 1 | (c | 0) == 1 & i >>> 0 < 0) << 31 >> 31;
          c = Qu(b | 0, S | 0, c | 0, ((c | 0) < 0) << 31 >> 31 | 0) | 0;
          s[e >> 2] = h;
          s[e + 4 >> 2] = l;
          e = f;
          s[e >> 2] = d;
          s[e + 4 >> 2] = a;
          e = r;
          s[e >> 2] = n;
          s[e + 4 >> 2] = o;
          s[t >> 2] = i;
          s[t + 4 >> 2] = c;
          p = u;
          return;
        }
      }

      function Wa(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0,
            A = 0,
            w = 0,
            T = 0,
            x = 0,
            D = 0,
            C = 0,
            E = 0,
            B = 0,
            k = 0,
            R = 0,
            W = 0,
            I = 0,
            N = 0,
            M = 0,
            P = 0,
            L = 0,
            O = 0,
            F = 0,
            j = 0,
            G = 0,
            V = 0,
            U = 0,
            H = 0,
            z = 0,
            K = 0,
            q = 0,
            Y = 0,
            Z = 0,
            J = 0,
            X = 0,
            $ = 0,
            Q = 0,
            ee = 0,
            te = 0;
        X = p;
        p = p + 192 | 0;
        k = X + 160 | 0;
        F = X + 128 | 0;
        U = X + 96 | 0;
        Y = X + 64 | 0;
        Z = X + 32 | 0;
        J = X;
        s[J >> 2] = s[e >> 2];
        s[J + 4 >> 2] = s[e + 4 >> 2];
        s[J + 8 >> 2] = s[e + 8 >> 2];
        s[J + 12 >> 2] = s[e + 12 >> 2];
        s[J + 16 >> 2] = s[e + 16 >> 2];
        s[J + 20 >> 2] = s[e + 20 >> 2];
        s[J + 24 >> 2] = s[e + 24 >> 2];
        s[J + 28 >> 2] = s[e + 28 >> 2];
        s[Z >> 2] = s[t >> 2];
        s[Z + 4 >> 2] = s[t + 4 >> 2];
        s[Z + 8 >> 2] = s[t + 8 >> 2];
        s[Z + 12 >> 2] = s[t + 12 >> 2];
        s[Z + 16 >> 2] = s[t + 16 >> 2];
        s[Z + 20 >> 2] = s[t + 20 >> 2];
        s[Z + 24 >> 2] = s[t + 24 >> 2];
        s[Z + 28 >> 2] = s[t + 28 >> 2];
        E = Y;
        s[E >> 2] = 1;
        s[E + 4 >> 2] = 0;
        E = Y + 8 | 0;
        s[E >> 2] = 0;
        s[E + 4 >> 2] = 0;
        s[E + 8 >> 2] = 0;
        s[E + 12 >> 2] = 0;
        s[E + 16 >> 2] = 0;
        s[E + 20 >> 2] = 0;
        s[U >> 2] = 0;
        s[U + 4 >> 2] = 0;
        s[U + 8 >> 2] = 0;
        s[U + 12 >> 2] = 0;
        s[U + 16 >> 2] = 0;
        s[U + 20 >> 2] = 0;
        s[U + 24 >> 2] = 0;
        s[U + 28 >> 2] = 0;
        B = F;
        s[B >> 2] = 1;
        s[B + 4 >> 2] = 0;
        B = F + 8 | 0;
        s[B >> 2] = 0;
        s[B + 4 >> 2] = 0;
        s[B + 8 >> 2] = 0;
        s[B + 12 >> 2] = 0;
        s[B + 16 >> 2] = 0;
        s[B + 20 >> 2] = 0;

        e: do {
          if (Vu(J, F, 32) | 0) {
            R = k + 8 | 0;
            W = Z + 24 | 0;
            I = Z + 16 | 0;
            N = Z + 8 | 0;
            M = J + 24 | 0;
            P = J + 16 | 0;
            L = J + 8 | 0;
            j = t;
            O = s[j >> 2] | 0;
            j = s[j + 4 >> 2] | 0;
            V = t + 8 | 0;
            G = s[V >> 2] | 0;
            V = s[V + 4 >> 2] | 0;
            H = Y + 16 | 0;
            K = t + 16 | 0;
            z = s[K >> 2] | 0;
            K = s[K + 4 >> 2] | 0;
            q = Y + 24 | 0;
            T = t + 24 | 0;
            w = s[T >> 2] | 0;
            T = s[T + 4 >> 2] | 0;
            x = U + 8 | 0;
            D = U + 16 | 0;
            C = U + 24 | 0;

            do {
              A = k;
              s[A >> 2] = 1;
              s[A + 4 >> 2] = 0;
              s[R >> 2] = 0;
              s[R + 4 >> 2] = 0;
              s[R + 8 >> 2] = 0;
              s[R + 12 >> 2] = 0;
              s[R + 16 >> 2] = 0;
              s[R + 20 >> 2] = 0;
              if (!(Vu(Z, k, 32) | 0)) break e;
              a = J;
              t = s[a >> 2] | 0;
              a = s[a + 4 >> 2] | 0;

              if ((t & 1 | 0) == 0 & 0 == 0) {
                f = Y;
                b = M;
                y = P;
                _ = L;
                d = E;
                u = H;
                c = q;
                h = s[b >> 2] | 0;
                b = s[b + 4 >> 2] | 0;
                m = s[y >> 2] | 0;
                y = s[y + 4 >> 2] | 0;
                v = s[_ >> 2] | 0;
                _ = s[_ + 4 >> 2] | 0;
                r = s[f >> 2] | 0;
                f = s[f + 4 >> 2] | 0;
                n = s[d >> 2] | 0;
                d = s[d + 4 >> 2] | 0;
                o = s[u >> 2] | 0;
                u = s[u + 4 >> 2] | 0;
                i = s[c >> 2] | 0;
                c = s[c + 4 >> 2] | 0;

                do {
                  A = od(h | 0, b | 0, 63) | 0;
                  g = S;
                  h = rd(h | 0, b | 0, 1) | 0;
                  b = S;
                  $ = od(m | 0, y | 0, 63) | 0;
                  l = S;
                  Q = rd(m | 0, y | 0, 1) | 0;
                  m = Q | A;
                  y = S | g;
                  g = od(v | 0, _ | 0, 63) | 0;
                  A = S;
                  Q = rd(v | 0, _ | 0, 1) | 0;
                  v = Q | $;
                  _ = S | l;
                  l = rd(t | 0, a | 0, 1) | 0;
                  t = g | l;
                  a = A | S;

                  if (!((r & 1 | 0) == 0 & 0 == 0)) {
                    Qu(O | 0, 0, r | 0, 0) | 0;
                    A = S;
                    r = Qu(O | 0, j | 0, r | 0, f | 0) | 0;
                    f = Qu(j | 0, 0, f | 0, 0) | 0;
                    f = Qu(f | 0, S | 0, A | 0, 0) | 0;
                    A = Qu(S | 0, 0, n | 0, 0) | 0;
                    n = S;
                    Qu(A | 0, n | 0, G | 0, 0) | 0;
                    $ = S;
                    n = Qu(A | 0, n | 0, G | 0, V | 0) | 0;
                    d = Qu(V | 0, 0, d | 0, 0) | 0;
                    d = Qu(d | 0, S | 0, $ | 0, 0) | 0;
                    $ = Qu(S | 0, 0, o | 0, 0) | 0;
                    o = S;
                    Qu($ | 0, o | 0, z | 0, 0) | 0;
                    A = S;
                    o = Qu($ | 0, o | 0, z | 0, K | 0) | 0;
                    u = Qu(K | 0, 0, u | 0, 0) | 0;
                    u = Qu(u | 0, S | 0, A | 0, 0) | 0;
                    A = Qu(S | 0, 0, i | 0, 0) | 0;
                    $ = S;
                    Q = Qu(A | 0, $ | 0, w | 0, T | 0) | 0;
                    Qu(0, T | 0, i | 0, c | 0) | 0;
                    Qu(w | 0, S | 0, A | 0, $ | 0) | 0;
                    i = Q;
                    c = S;
                  }

                  Q = od(i | 0, c | 0, 63) | 0;
                  $ = S;
                  i = rd(i | 0, c | 0, 1) | 0;
                  c = S;
                  g = od(o | 0, u | 0, 63) | 0;
                  A = S;
                  o = rd(o | 0, u | 0, 1) | 0;
                  o = o | Q;
                  u = S | $;
                  $ = od(n | 0, d | 0, 63) | 0;
                  Q = S;
                  n = rd(n | 0, d | 0, 1) | 0;
                  n = n | g;
                  d = S | A;
                  r = rd(r | 0, f | 0, 1) | 0;
                  r = $ | r;
                  f = Q | S;
                } while ((l & 1 | 0) == 0 & 0 == 0);

                A = M;
                s[A >> 2] = h;
                s[A + 4 >> 2] = b;
                A = P;
                s[A >> 2] = m;
                s[A + 4 >> 2] = y;
                A = L;
                s[A >> 2] = v;
                s[A + 4 >> 2] = _;
                A = J;
                s[A >> 2] = t;
                s[A + 4 >> 2] = a;
                A = Y;
                s[A >> 2] = r;
                s[A + 4 >> 2] = f;
                A = E;
                s[A >> 2] = n;
                s[A + 4 >> 2] = d;
                A = H;
                s[A >> 2] = o;
                s[A + 4 >> 2] = u;
                A = q;
                s[A >> 2] = i;
                s[A + 4 >> 2] = c;
                A = a;
              } else A = a;

              c = Z;
              a = s[c >> 2] | 0;
              c = s[c + 4 >> 2] | 0;

              if ((a & 1 | 0) == 0 & 0 == 0) {
                i = U;
                m = W;
                v = I;
                g = N;
                o = x;
                n = D;
                r = C;
                b = s[m >> 2] | 0;
                m = s[m + 4 >> 2] | 0;
                y = s[v >> 2] | 0;
                v = s[v + 4 >> 2] | 0;
                _ = s[g >> 2] | 0;
                g = s[g + 4 >> 2] | 0;
                u = s[i >> 2] | 0;
                i = s[i + 4 >> 2] | 0;
                d = s[o >> 2] | 0;
                o = s[o + 4 >> 2] | 0;
                f = s[n >> 2] | 0;
                n = s[n + 4 >> 2] | 0;
                l = s[r >> 2] | 0;
                r = s[r + 4 >> 2] | 0;

                do {
                  Q = od(b | 0, m | 0, 63) | 0;
                  $ = S;
                  b = rd(b | 0, m | 0, 1) | 0;
                  m = S;
                  ee = od(y | 0, v | 0, 63) | 0;
                  h = S;
                  te = rd(y | 0, v | 0, 1) | 0;
                  y = te | Q;
                  v = S | $;
                  $ = od(_ | 0, g | 0, 63) | 0;
                  Q = S;
                  te = rd(_ | 0, g | 0, 1) | 0;
                  _ = te | ee;
                  g = S | h;
                  h = rd(a | 0, c | 0, 1) | 0;
                  a = $ | h;
                  c = Q | S;

                  if (!((u & 1 | 0) == 0 & 0 == 0)) {
                    Qu(O | 0, 0, u | 0, 0) | 0;
                    Q = S;
                    u = Qu(O | 0, j | 0, u | 0, i | 0) | 0;
                    i = Qu(j | 0, 0, i | 0, 0) | 0;
                    i = Qu(i | 0, S | 0, Q | 0, 0) | 0;
                    Q = Qu(S | 0, 0, d | 0, 0) | 0;
                    d = S;
                    Qu(Q | 0, d | 0, G | 0, 0) | 0;
                    ee = S;
                    d = Qu(Q | 0, d | 0, G | 0, V | 0) | 0;
                    o = Qu(V | 0, 0, o | 0, 0) | 0;
                    o = Qu(o | 0, S | 0, ee | 0, 0) | 0;
                    ee = Qu(S | 0, 0, f | 0, 0) | 0;
                    f = S;
                    Qu(ee | 0, f | 0, z | 0, 0) | 0;
                    Q = S;
                    f = Qu(ee | 0, f | 0, z | 0, K | 0) | 0;
                    n = Qu(K | 0, 0, n | 0, 0) | 0;
                    n = Qu(n | 0, S | 0, Q | 0, 0) | 0;
                    Q = Qu(S | 0, 0, l | 0, 0) | 0;
                    ee = S;
                    te = Qu(Q | 0, ee | 0, w | 0, T | 0) | 0;
                    Qu(0, T | 0, l | 0, r | 0) | 0;
                    Qu(w | 0, S | 0, Q | 0, ee | 0) | 0;
                    l = te;
                    r = S;
                  }

                  te = od(l | 0, r | 0, 63) | 0;
                  ee = S;
                  l = rd(l | 0, r | 0, 1) | 0;
                  r = S;
                  $ = od(f | 0, n | 0, 63) | 0;
                  Q = S;
                  f = rd(f | 0, n | 0, 1) | 0;
                  f = f | te;
                  n = S | ee;
                  ee = od(d | 0, o | 0, 63) | 0;
                  te = S;
                  d = rd(d | 0, o | 0, 1) | 0;
                  d = d | $;
                  o = S | Q;
                  u = rd(u | 0, i | 0, 1) | 0;
                  u = ee | u;
                  i = te | S;
                } while ((h & 1 | 0) == 0 & 0 == 0);

                te = W;
                s[te >> 2] = b;
                s[te + 4 >> 2] = m;
                te = I;
                s[te >> 2] = y;
                s[te + 4 >> 2] = v;
                te = N;
                s[te >> 2] = _;
                s[te + 4 >> 2] = g;
                te = Z;
                s[te >> 2] = a;
                s[te + 4 >> 2] = c;
                te = U;
                s[te >> 2] = u;
                s[te + 4 >> 2] = i;
                u = x;
                s[u >> 2] = d;
                s[u + 4 >> 2] = o;
                u = D;
                s[u >> 2] = f;
                s[u + 4 >> 2] = n;
                u = C;
                s[u >> 2] = l;
                s[u + 4 >> 2] = r;
                u = a;
              } else u = a;

              a = 4;

              while (1) {
                if (!a) {
                  d = 21;
                  break;
                }

                a = a + -1 | 0;
                n = J + (a << 3) | 0;
                r = s[n >> 2] | 0;
                n = s[n + 4 >> 2] | 0;
                i = Z + (a << 3) | 0;
                o = s[i >> 2] | 0;
                i = s[i + 4 >> 2] | 0;

                if (n >>> 0 < i >>> 0 | (n | 0) == (i | 0) & r >>> 0 < o >>> 0) {
                  d = 27;
                  break;
                }

                if (n >>> 0 > i >>> 0 | (n | 0) == (i | 0) & r >>> 0 > o >>> 0) {
                  d = 21;
                  break;
                }
              }

              if ((d | 0) == 21) {
                d = 0;
                Q = $u(t | 0, 1, u | 0, 0) | 0;
                te = S;
                t = $u(t | 0, A | 0, u | 0, c | 0) | 0;
                ee = $u(A | 0, 1, c | 0, 0) | 0;
                Q = (te >>> 0 < 1 | (te | 0) == 1 & Q >>> 0 < 0) << 31 >> 31;
                ee = Qu(Q | 0, ((Q | 0) < 0) << 31 >> 31 | 0, ee | 0, S | 0) | 0;
                Q = S;
                te = J;
                s[te >> 2] = t;
                s[te + 4 >> 2] = ee;
                te = L;
                t = s[te + 4 >> 2] | 0;
                A = N;
                $ = s[A + 4 >> 2] | 0;
                A = $u(s[te >> 2] | 0, 1, s[A >> 2] | 0, 0) | 0;
                ee = (Q >>> 0 < 1 | (Q | 0) == 1 & ee >>> 0 < 0) << 31 >> 31;
                A = Qu(ee | 0, ((ee | 0) < 0) << 31 >> 31 | 0, A | 0, S | 0) | 0;
                ee = S;
                $ = $u(t | 0, 1, $ | 0, 0) | 0;
                ee = (ee >>> 0 < 1 | (ee | 0) == 1 & A >>> 0 < 0) << 31 >> 31;
                $ = Qu(ee | 0, ((ee | 0) < 0) << 31 >> 31 | 0, $ | 0, S | 0) | 0;
                ee = S;
                t = L;
                s[t >> 2] = A;
                s[t + 4 >> 2] = $;
                t = P;
                A = s[t + 4 >> 2] | 0;
                Q = I;
                te = s[Q + 4 >> 2] | 0;
                Q = $u(s[t >> 2] | 0, 1, s[Q >> 2] | 0, 0) | 0;
                $ = (ee >>> 0 < 1 | (ee | 0) == 1 & $ >>> 0 < 0) << 31 >> 31;
                Q = Qu($ | 0, (($ | 0) < 0) << 31 >> 31 | 0, Q | 0, S | 0) | 0;
                $ = S;
                te = $u(A | 0, 1, te | 0, 0) | 0;
                $ = ($ >>> 0 < 1 | ($ | 0) == 1 & Q >>> 0 < 0) << 31 >> 31;
                te = Qu($ | 0, (($ | 0) < 0) << 31 >> 31 | 0, te | 0, S | 0) | 0;
                $ = S;
                A = P;
                s[A >> 2] = Q;
                s[A + 4 >> 2] = te;
                A = M;
                Q = s[A + 4 >> 2] | 0;
                ee = W;
                t = s[ee + 4 >> 2] | 0;
                ee = $u(s[A >> 2] | 0, 1, s[ee >> 2] | 0, 0) | 0;
                te = ($ >>> 0 < 1 | ($ | 0) == 1 & te >>> 0 < 0) << 31 >> 31;
                ee = Qu(te | 0, ((te | 0) < 0) << 31 >> 31 | 0, ee | 0, S | 0) | 0;
                te = S;
                t = $u(Q | 0, 0, t | 0, 0) | 0;
                te = (te >>> 0 < 1 | (te | 0) == 1 & ee >>> 0 < 0) << 31 >> 31;
                te = Qu(t | 0, S | 0, te | 0, ((te | 0) < 0) << 31 >> 31 | 0) | 0;
                t = M;
                s[t >> 2] = ee;
                s[t + 4 >> 2] = te;
                t = 4;

                do {
                  if (!t) break;
                  t = t + -1 | 0;
                  r = Y + (t << 3) | 0;
                  a = s[r >> 2] | 0;
                  r = s[r + 4 >> 2] | 0;
                  o = U + (t << 3) | 0;
                  n = s[o >> 2] | 0;
                  o = s[o + 4 >> 2] | 0;

                  if (r >>> 0 < o >>> 0 | (r | 0) == (o | 0) & a >>> 0 < n >>> 0) {
                    d = 25;
                    break;
                  }
                } while (!(r >>> 0 > o >>> 0 | (r | 0) == (o | 0) & a >>> 0 > n >>> 0));

                if ((d | 0) == 25) {
                  A = Y;
                  Q = s[A >> 2] | 0;
                  A = s[A + 4 >> 2] | 0;
                  Qu(O | 0, 0, Q | 0, 0) | 0;
                  te = S;
                  Q = Qu(O | 0, j | 0, Q | 0, A | 0) | 0;
                  A = Qu(j | 0, 0, A | 0, 0) | 0;
                  te = Qu(A | 0, S | 0, te | 0, 0) | 0;
                  A = Y;
                  s[A >> 2] = Q;
                  s[A + 4 >> 2] = te;
                  A = E;
                  te = s[A + 4 >> 2] | 0;
                  A = Qu(S | 0, 0, s[A >> 2] | 0, 0) | 0;
                  Q = S;
                  Qu(A | 0, Q | 0, G | 0, 0) | 0;
                  $ = S;
                  Q = Qu(A | 0, Q | 0, G | 0, V | 0) | 0;
                  te = Qu(V | 0, 0, te | 0, 0) | 0;
                  $ = Qu(te | 0, S | 0, $ | 0, 0) | 0;
                  te = E;
                  s[te >> 2] = Q;
                  s[te + 4 >> 2] = $;
                  te = H;
                  $ = s[te + 4 >> 2] | 0;
                  te = Qu(S | 0, 0, s[te >> 2] | 0, 0) | 0;
                  Q = S;
                  Qu(te | 0, Q | 0, z | 0, 0) | 0;
                  A = S;
                  Q = Qu(te | 0, Q | 0, z | 0, K | 0) | 0;
                  $ = Qu(K | 0, 0, $ | 0, 0) | 0;
                  A = Qu($ | 0, S | 0, A | 0, 0) | 0;
                  $ = H;
                  s[$ >> 2] = Q;
                  s[$ + 4 >> 2] = A;
                  $ = q;
                  A = s[$ >> 2] | 0;
                  $ = s[$ + 4 >> 2] | 0;
                  Q = Qu(S | 0, 0, A | 0, 0) | 0;
                  te = S;
                  ee = Qu(Q | 0, te | 0, w | 0, T | 0) | 0;
                  Qu(0, T | 0, A | 0, $ | 0) | 0;
                  Qu(w | 0, S | 0, Q | 0, te | 0) | 0;
                  te = q;
                  s[te >> 2] = ee;
                  s[te + 4 >> 2] = S;
                }

                o = Y;
                t = s[o >> 2] | 0;
                o = s[o + 4 >> 2] | 0;
                i = U;
                a = s[i >> 2] | 0;
                i = s[i + 4 >> 2] | 0;
                u = $u(t | 0, 1, a | 0, 0) | 0;
                c = S;
                a = $u(t | 0, o | 0, a | 0, i | 0) | 0;
                t = Y;
                r = Y;
                n = U;
              } else if ((d | 0) == 27) {
                d = 0;
                Q = $u(u | 0, 1, t | 0, 0) | 0;
                te = S;
                t = $u(u | 0, c | 0, t | 0, A | 0) | 0;
                ee = $u(c | 0, 1, A | 0, 0) | 0;
                Q = (te >>> 0 < 1 | (te | 0) == 1 & Q >>> 0 < 0) << 31 >> 31;
                ee = Qu(Q | 0, ((Q | 0) < 0) << 31 >> 31 | 0, ee | 0, S | 0) | 0;
                Q = S;
                te = Z;
                s[te >> 2] = t;
                s[te + 4 >> 2] = ee;
                te = N;
                t = s[te + 4 >> 2] | 0;
                A = L;
                $ = s[A + 4 >> 2] | 0;
                A = $u(s[te >> 2] | 0, 1, s[A >> 2] | 0, 0) | 0;
                ee = (Q >>> 0 < 1 | (Q | 0) == 1 & ee >>> 0 < 0) << 31 >> 31;
                A = Qu(ee | 0, ((ee | 0) < 0) << 31 >> 31 | 0, A | 0, S | 0) | 0;
                ee = S;
                $ = $u(t | 0, 1, $ | 0, 0) | 0;
                ee = (ee >>> 0 < 1 | (ee | 0) == 1 & A >>> 0 < 0) << 31 >> 31;
                $ = Qu(ee | 0, ((ee | 0) < 0) << 31 >> 31 | 0, $ | 0, S | 0) | 0;
                ee = S;
                t = N;
                s[t >> 2] = A;
                s[t + 4 >> 2] = $;
                t = I;
                A = s[t + 4 >> 2] | 0;
                Q = P;
                te = s[Q + 4 >> 2] | 0;
                Q = $u(s[t >> 2] | 0, 1, s[Q >> 2] | 0, 0) | 0;
                $ = (ee >>> 0 < 1 | (ee | 0) == 1 & $ >>> 0 < 0) << 31 >> 31;
                Q = Qu($ | 0, (($ | 0) < 0) << 31 >> 31 | 0, Q | 0, S | 0) | 0;
                $ = S;
                te = $u(A | 0, 1, te | 0, 0) | 0;
                $ = ($ >>> 0 < 1 | ($ | 0) == 1 & Q >>> 0 < 0) << 31 >> 31;
                te = Qu($ | 0, (($ | 0) < 0) << 31 >> 31 | 0, te | 0, S | 0) | 0;
                $ = S;
                A = I;
                s[A >> 2] = Q;
                s[A + 4 >> 2] = te;
                A = W;
                Q = s[A + 4 >> 2] | 0;
                ee = M;
                t = s[ee + 4 >> 2] | 0;
                ee = $u(s[A >> 2] | 0, 1, s[ee >> 2] | 0, 0) | 0;
                te = ($ >>> 0 < 1 | ($ | 0) == 1 & te >>> 0 < 0) << 31 >> 31;
                ee = Qu(te | 0, ((te | 0) < 0) << 31 >> 31 | 0, ee | 0, S | 0) | 0;
                te = S;
                t = $u(Q | 0, 0, t | 0, 0) | 0;
                te = (te >>> 0 < 1 | (te | 0) == 1 & ee >>> 0 < 0) << 31 >> 31;
                te = Qu(t | 0, S | 0, te | 0, ((te | 0) < 0) << 31 >> 31 | 0) | 0;
                t = W;
                s[t >> 2] = ee;
                s[t + 4 >> 2] = te;
                t = 4;

                do {
                  if (!t) break;
                  t = t + -1 | 0;
                  r = U + (t << 3) | 0;
                  a = s[r >> 2] | 0;
                  r = s[r + 4 >> 2] | 0;
                  o = Y + (t << 3) | 0;
                  n = s[o >> 2] | 0;
                  o = s[o + 4 >> 2] | 0;

                  if (r >>> 0 < o >>> 0 | (r | 0) == (o | 0) & a >>> 0 < n >>> 0) {
                    d = 31;
                    break;
                  }
                } while (!(r >>> 0 > o >>> 0 | (r | 0) == (o | 0) & a >>> 0 > n >>> 0));

                if ((d | 0) == 31) {
                  A = U;
                  Q = s[A >> 2] | 0;
                  A = s[A + 4 >> 2] | 0;
                  Qu(O | 0, 0, Q | 0, 0) | 0;
                  te = S;
                  Q = Qu(O | 0, j | 0, Q | 0, A | 0) | 0;
                  A = Qu(j | 0, 0, A | 0, 0) | 0;
                  te = Qu(A | 0, S | 0, te | 0, 0) | 0;
                  A = U;
                  s[A >> 2] = Q;
                  s[A + 4 >> 2] = te;
                  A = x;
                  te = s[A + 4 >> 2] | 0;
                  A = Qu(S | 0, 0, s[A >> 2] | 0, 0) | 0;
                  Q = S;
                  Qu(A | 0, Q | 0, G | 0, 0) | 0;
                  $ = S;
                  Q = Qu(A | 0, Q | 0, G | 0, V | 0) | 0;
                  te = Qu(V | 0, 0, te | 0, 0) | 0;
                  $ = Qu(te | 0, S | 0, $ | 0, 0) | 0;
                  te = x;
                  s[te >> 2] = Q;
                  s[te + 4 >> 2] = $;
                  te = D;
                  $ = s[te + 4 >> 2] | 0;
                  te = Qu(S | 0, 0, s[te >> 2] | 0, 0) | 0;
                  Q = S;
                  Qu(te | 0, Q | 0, z | 0, 0) | 0;
                  A = S;
                  Q = Qu(te | 0, Q | 0, z | 0, K | 0) | 0;
                  $ = Qu(K | 0, 0, $ | 0, 0) | 0;
                  A = Qu($ | 0, S | 0, A | 0, 0) | 0;
                  $ = D;
                  s[$ >> 2] = Q;
                  s[$ + 4 >> 2] = A;
                  $ = C;
                  A = s[$ >> 2] | 0;
                  $ = s[$ + 4 >> 2] | 0;
                  Q = Qu(S | 0, 0, A | 0, 0) | 0;
                  te = S;
                  ee = Qu(Q | 0, te | 0, w | 0, T | 0) | 0;
                  Qu(0, T | 0, A | 0, $ | 0) | 0;
                  Qu(w | 0, S | 0, Q | 0, te | 0) | 0;
                  te = C;
                  s[te >> 2] = ee;
                  s[te + 4 >> 2] = S;
                }

                o = U;
                t = s[o >> 2] | 0;
                o = s[o + 4 >> 2] | 0;
                i = Y;
                a = s[i >> 2] | 0;
                i = s[i + 4 >> 2] | 0;
                u = $u(t | 0, 1, a | 0, 0) | 0;
                c = S;
                a = $u(t | 0, o | 0, a | 0, i | 0) | 0;
                t = U;
                r = U;
                n = Y;
              }

              $ = $u(o | 0, 1, i | 0, 0) | 0;
              _ = (c >>> 0 < 1 | (c | 0) == 1 & u >>> 0 < 0) << 31 >> 31;
              $ = Qu(_ | 0, ((_ | 0) < 0) << 31 >> 31 | 0, $ | 0, S | 0) | 0;
              _ = S;
              te = t;
              s[te >> 2] = a;
              s[te + 4 >> 2] = $;
              te = r + 8 | 0;
              ee = te;
              A = s[ee + 4 >> 2] | 0;
              Q = n + 8 | 0;
              g = s[Q + 4 >> 2] | 0;
              Q = $u(s[ee >> 2] | 0, 1, s[Q >> 2] | 0, 0) | 0;
              $ = (_ >>> 0 < 1 | (_ | 0) == 1 & $ >>> 0 < 0) << 31 >> 31;
              $ = Qu(Q | 0, S | 0, $ | 0, (($ | 0) < 0) << 31 >> 31 | 0) | 0;
              Q = S;
              g = $u(A | 0, 1, g | 0, 0) | 0;
              Q = (Q >>> 0 < 1 | (Q | 0) == 1 & $ >>> 0 < 0) << 31 >> 31;
              g = Qu(Q | 0, ((Q | 0) < 0) << 31 >> 31 | 0, g | 0, S | 0) | 0;
              Q = S;
              s[te >> 2] = $;
              s[te + 4 >> 2] = g;
              te = r + 16 | 0;
              $ = te;
              A = s[$ + 4 >> 2] | 0;
              _ = n + 16 | 0;
              ee = s[_ + 4 >> 2] | 0;
              _ = $u(s[$ >> 2] | 0, 1, s[_ >> 2] | 0, 0) | 0;
              g = (Q >>> 0 < 1 | (Q | 0) == 1 & g >>> 0 < 0) << 31 >> 31;
              _ = Qu(g | 0, ((g | 0) < 0) << 31 >> 31 | 0, _ | 0, S | 0) | 0;
              g = S;
              ee = $u(A | 0, 1, ee | 0, 0) | 0;
              g = (g >>> 0 < 1 | (g | 0) == 1 & _ >>> 0 < 0) << 31 >> 31;
              ee = Qu(g | 0, ((g | 0) < 0) << 31 >> 31 | 0, ee | 0, S | 0) | 0;
              g = S;
              s[te >> 2] = _;
              s[te + 4 >> 2] = ee;
              te = r + 24 | 0;
              _ = te;
              A = s[_ + 4 >> 2] | 0;
              Q = n + 24 | 0;
              $ = s[Q + 4 >> 2] | 0;
              Q = $u(s[_ >> 2] | 0, 1, s[Q >> 2] | 0, 0) | 0;
              ee = (g >>> 0 < 1 | (g | 0) == 1 & ee >>> 0 < 0) << 31 >> 31;
              Q = Qu(ee | 0, ((ee | 0) < 0) << 31 >> 31 | 0, Q | 0, S | 0) | 0;
              ee = S;
              $ = $u(A | 0, 0, $ | 0, 0) | 0;
              ee = (ee >>> 0 < 1 | (ee | 0) == 1 & Q >>> 0 < 0) << 31 >> 31;
              ee = Qu($ | 0, S | 0, ee | 0, ((ee | 0) < 0) << 31 >> 31 | 0) | 0;
              s[te >> 2] = Q;
              s[te + 4 >> 2] = ee;
              te = F;
              s[te >> 2] = 1;
              s[te + 4 >> 2] = 0;
              s[B >> 2] = 0;
              s[B + 4 >> 2] = 0;
              s[B + 8 >> 2] = 0;
              s[B + 12 >> 2] = 0;
              s[B + 16 >> 2] = 0;
              s[B + 20 >> 2] = 0;
            } while ((Vu(J, F, 32) | 0) != 0);
          }
        } while (0);

        te = k;
        s[te >> 2] = 1;
        s[te + 4 >> 2] = 0;
        te = k + 8 | 0;
        s[te >> 2] = 0;
        s[te + 4 >> 2] = 0;
        s[te + 8 >> 2] = 0;
        s[te + 12 >> 2] = 0;
        s[te + 16 >> 2] = 0;
        s[te + 20 >> 2] = 0;

        if (!(Vu(J, k, 32) | 0)) {
          s[e >> 2] = s[Y >> 2];
          s[e + 4 >> 2] = s[Y + 4 >> 2];
          s[e + 8 >> 2] = s[Y + 8 >> 2];
          s[e + 12 >> 2] = s[Y + 12 >> 2];
          s[e + 16 >> 2] = s[Y + 16 >> 2];
          s[e + 20 >> 2] = s[Y + 20 >> 2];
          s[e + 24 >> 2] = s[Y + 24 >> 2];
          s[e + 28 >> 2] = s[Y + 28 >> 2];
          p = X;
          return;
        } else {
          s[e >> 2] = s[U >> 2];
          s[e + 4 >> 2] = s[U + 4 >> 2];
          s[e + 8 >> 2] = s[U + 8 >> 2];
          s[e + 12 >> 2] = s[U + 12 >> 2];
          s[e + 16 >> 2] = s[U + 16 >> 2];
          s[e + 20 >> 2] = s[U + 20 >> 2];
          s[e + 24 >> 2] = s[U + 24 >> 2];
          s[e + 28 >> 2] = s[U + 28 >> 2];
          p = X;
          return;
        }
      }

      function Ia(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0;
        n = e;
        c = s[n >> 2] | 0;
        n = s[n + 4 >> 2] | 0;
        u = t;
        a = s[u >> 2] | 0;
        u = s[u + 4 >> 2] | 0;
        o = $u(c | 0, 1, a | 0, 0) | 0;
        r = S;
        a = $u(c | 0, n | 0, a | 0, u | 0) | 0;
        u = $u(n | 0, 1, u | 0, 0) | 0;
        o = (r >>> 0 < 1 | (r | 0) == 1 & o >>> 0 < 0) << 31 >> 31;
        u = Qu(o | 0, ((o | 0) < 0) << 31 >> 31 | 0, u | 0, S | 0) | 0;
        o = S;
        r = e;
        s[r >> 2] = a;
        s[r + 4 >> 2] = u;
        r = e + 8 | 0;
        a = r;
        n = s[a + 4 >> 2] | 0;
        c = t + 8 | 0;
        i = s[c + 4 >> 2] | 0;
        c = $u(s[a >> 2] | 0, 1, s[c >> 2] | 0, 0) | 0;
        u = $u(c | 0, S | 0, (o >>> 0 < 1 | (o | 0) == 1 & u >>> 0 < 0) & 1 | 0, 0) | 0;
        o = S;
        i = $u(n | 0, 1, i | 0, 0) | 0;
        o = (o >>> 0 < 1 | (o | 0) == 1 & u >>> 0 < 0) << 31 >> 31;
        i = Qu(o | 0, ((o | 0) < 0) << 31 >> 31 | 0, i | 0, S | 0) | 0;
        o = S;
        s[r >> 2] = u;
        s[r + 4 >> 2] = i;
        r = e + 16 | 0;
        u = r;
        n = s[u + 4 >> 2] | 0;
        c = t + 16 | 0;
        a = s[c + 4 >> 2] | 0;
        c = $u(s[u >> 2] | 0, 1, s[c >> 2] | 0, 0) | 0;
        i = $u(c | 0, S | 0, (o >>> 0 < 1 | (o | 0) == 1 & i >>> 0 < 0) & 1 | 0, 0) | 0;
        o = S;
        a = $u(n | 0, 1, a | 0, 0) | 0;
        o = (o >>> 0 < 1 | (o | 0) == 1 & i >>> 0 < 0) << 31 >> 31;
        a = Qu(o | 0, ((o | 0) < 0) << 31 >> 31 | 0, a | 0, S | 0) | 0;
        o = S;
        s[r >> 2] = i;
        s[r + 4 >> 2] = a;
        r = e + 24 | 0;
        i = r;
        n = s[i + 4 >> 2] | 0;
        t = t + 24 | 0;
        e = s[t + 4 >> 2] | 0;
        t = $u(s[i >> 2] | 0, 1, s[t >> 2] | 0, 0) | 0;
        a = $u(t | 0, S | 0, (o >>> 0 < 1 | (o | 0) == 1 & a >>> 0 < 0) & 1 | 0, 0) | 0;
        t = S;
        e = $u(n | 0, 0, e | 0, 0) | 0;
        t = (t >>> 0 < 1 | (t | 0) == 1 & a >>> 0 < 0) << 31 >> 31;
        e = Qu(t | 0, ((t | 0) < 0) << 31 >> 31 | 0, e | 0, S | 0) | 0;
        t = r;
        s[t >> 2] = a;
        s[t + 4 >> 2] = e;
        return;
      }

      function Na(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0;
        o = 4;

        while (1) {
          if (!o) {
            e = 0;
            t = 5;
            break;
          }

          o = o + -1 | 0;
          a = e + (o << 3) | 0;
          i = s[a >> 2] | 0;
          a = s[a + 4 >> 2] | 0;
          n = t + (o << 3) | 0;
          r = s[n >> 2] | 0;
          n = s[n + 4 >> 2] | 0;

          if (a >>> 0 < n >>> 0 | (a | 0) == (n | 0) & i >>> 0 < r >>> 0) {
            e = 1;
            t = 5;
            break;
          }

          if (a >>> 0 > n >>> 0 | (a | 0) == (n | 0) & i >>> 0 > r >>> 0) {
            e = 0;
            t = 5;
            break;
          }
        }

        if ((t | 0) == 5) return e | 0;
        return 0;
      }

      function Ma(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0,
            A = 0,
            w = 0,
            T = 0,
            x = 0,
            D = 0,
            C = 0,
            S = 0,
            E = 0,
            B = 0,
            k = 0,
            R = 0,
            W = 0,
            I = 0,
            N = 0,
            M = 0,
            P = 0,
            L = 0;
        L = p;
        p = p + 10896 | 0;
        m = L + 10504 | 0;
        S = L + 10120 | 0;
        R = L + 10056 | 0;
        W = L + 9992 | 0;
        I = L + 9800 | 0;
        N = L + 9608 | 0;
        M = L + 9224 | 0;
        P = L + 8840 | 0;
        n = L + 8456 | 0;
        o = L + 8064 | 0;
        i = L + 7680 | 0;
        c = L + 7296 | 0;
        u = L + 6912 | 0;
        d = L + 6528 | 0;
        f = L + 6144 | 0;
        l = L + 5760 | 0;
        h = L + 5376 | 0;
        b = L + 4992 | 0;
        y = L + 4608 | 0;
        v = L + 4224 | 0;
        _ = L + 3840 | 0;
        g = L + 3456 | 0;
        A = L + 3072 | 0;
        w = L + 2688 | 0;
        T = L + 2304 | 0;
        x = L + 1920 | 0;
        D = L + 1536 | 0;
        C = L + 1152 | 0;
        E = L + 768 | 0;
        B = L + 384 | 0;
        k = L;
        id(m | 0, t | 0, 384) | 0;
        Pa(o, m);
        r = o;

        if ((s[r >> 2] | 0) == 1 & (s[r + 4 >> 2] | 0) == 0) {
          id(n | 0, t | 0, 192) | 0;
          id(m | 0, t + 192 | 0, 192) | 0;
          qa(S, m);
          id(n + 192 | 0, S | 0, 192) | 0;
          id(S | 0, n | 0, 384) | 0;
          id(m | 0, o + 8 | 0, 384) | 0;
          La(P, S, m);
          Ua(M, P, 2);
          Ua(I, P + 192 | 0, 2);
          t = S;
          a = I;
          r = t + 64 | 0;

          do {
            s[t >> 2] = s[a >> 2];
            t = t + 4 | 0;
            a = a + 4 | 0;
          } while ((t | 0) < (r | 0));

          t = m;
          s[t >> 2] = 16391154;
          s[t + 4 >> 2] = -896696315;
          t = m + 8 | 0;
          s[t >> 2] = 1756600169;
          s[t + 4 >> 2] = -255470060;
          t = m + 16 | 0;
          s[t >> 2] = -1391639528;
          s[t + 4 >> 2] = 236982897;
          t = m + 24 | 0;
          s[t >> 2] = -1160227098;
          s[t + 4 >> 2] = 69799781;
          t = m + 32 | 0;
          s[t >> 2] = 0;
          s[t + 4 >> 2] = 0;
          s[t + 8 >> 2] = 0;
          s[t + 12 >> 2] = 0;
          s[t + 16 >> 2] = 0;
          s[t + 20 >> 2] = 0;
          s[t + 24 >> 2] = 0;
          s[t + 28 >> 2] = 0;
          Ya(N, S, m);
          t = S;
          a = I + 64 | 0;
          r = t + 64 | 0;

          do {
            s[t >> 2] = s[a >> 2];
            t = t + 4 | 0;
            a = a + 4 | 0;
          } while ((t | 0) < (r | 0));

          t = m;
          s[t >> 2] = 16391154;
          s[t + 4 >> 2] = -896696315;
          t = m + 8 | 0;
          s[t >> 2] = 1756600169;
          s[t + 4 >> 2] = -255470060;
          t = m + 16 | 0;
          s[t >> 2] = -1391639528;
          s[t + 4 >> 2] = 236982897;
          t = m + 24 | 0;
          s[t >> 2] = -1160227098;
          s[t + 4 >> 2] = 69799781;
          t = m + 32 | 0;
          s[t >> 2] = 0;
          s[t + 4 >> 2] = 0;
          s[t + 8 >> 2] = 0;
          s[t + 12 >> 2] = 0;
          s[t + 16 >> 2] = 0;
          s[t + 20 >> 2] = 0;
          s[t + 24 >> 2] = 0;
          s[t + 28 >> 2] = 0;
          Ya(W, S, m);
          t = S;
          a = I + 128 | 0;
          r = t + 64 | 0;

          do {
            s[t >> 2] = s[a >> 2];
            t = t + 4 | 0;
            a = a + 4 | 0;
          } while ((t | 0) < (r | 0));

          t = m;
          s[t >> 2] = 16391154;
          s[t + 4 >> 2] = -896696315;
          t = m + 8 | 0;
          s[t >> 2] = 1756600169;
          s[t + 4 >> 2] = -255470060;
          t = m + 16 | 0;
          s[t >> 2] = -1391639528;
          s[t + 4 >> 2] = 236982897;
          t = m + 24 | 0;
          s[t >> 2] = -1160227098;
          s[t + 4 >> 2] = 69799781;
          t = m + 32 | 0;
          s[t >> 2] = 0;
          s[t + 4 >> 2] = 0;
          s[t + 8 >> 2] = 0;
          s[t + 12 >> 2] = 0;
          s[t + 16 >> 2] = 0;
          s[t + 20 >> 2] = 0;
          s[t + 24 >> 2] = 0;
          s[t + 28 >> 2] = 0;
          Ya(R, S, m);
          t = N + 64 | 0;
          a = W;
          r = t + 64 | 0;

          do {
            s[t >> 2] = s[a >> 2];
            t = t + 4 | 0;
            a = a + 4 | 0;
          } while ((t | 0) < (r | 0));

          t = N + 128 | 0;
          a = R;
          r = t + 64 | 0;

          do {
            s[t >> 2] = s[a >> 2];
            t = t + 4 | 0;
            a = a + 4 | 0;
          } while ((t | 0) < (r | 0));

          id(M + 192 | 0, N | 0, 192) | 0;
          id(S | 0, M | 0, 384) | 0;
          id(m | 0, P | 0, 384) | 0;
          La(k, S, m);
          id(B | 0, k | 0, 384) | 0;
          id(C | 0, k | 0, 384) | 0;
          Oa(D, C);
          Fa(x, D);
          Fa(T, x);
          id(S | 0, T | 0, 384) | 0;
          id(m | 0, x | 0, 384) | 0;
          La(w, S, m);
          Oa(A, w);
          Fa(g, A);
          Oa(_, g);
          id(v | 0, w | 0, 192) | 0;
          id(m | 0, w + 192 | 0, 192) | 0;
          qa(S, m);
          id(v + 192 | 0, S | 0, 192) | 0;
          id(y | 0, _ | 0, 192) | 0;
          id(m | 0, _ + 192 | 0, 192) | 0;
          qa(S, m);
          id(y + 192 | 0, S | 0, 192) | 0;
          id(S | 0, y | 0, 384) | 0;
          id(m | 0, A | 0, 384) | 0;
          La(b, S, m);
          id(S | 0, b | 0, 384) | 0;
          id(m | 0, v | 0, 384) | 0;
          La(h, S, m);
          id(S | 0, h | 0, 384) | 0;
          id(m | 0, x | 0, 384) | 0;
          La(l, S, m);
          id(S | 0, h | 0, 384) | 0;
          id(m | 0, A | 0, 384) | 0;
          La(f, S, m);
          id(S | 0, C | 0, 384) | 0;
          id(m | 0, f | 0, 384) | 0;
          La(d, S, m);
          Ua(u, l, 1);
          Ua(I, l + 192 | 0, 1);
          t = S;
          a = I;
          r = t + 64 | 0;

          do {
            s[t >> 2] = s[a >> 2];
            t = t + 4 | 0;
            a = a + 4 | 0;
          } while ((t | 0) < (r | 0));

          t = m;
          s[t >> 2] = 856967431;
          s[t + 4 >> 2] = -1348753770;
          t = m + 8 | 0;
          s[t >> 2] = -2018527350;
          s[t + 4 >> 2] = -898949773;
          t = m + 16 | 0;
          s[t >> 2] = -259383161;
          s[t + 4 >> 2] = 297659742;
          t = m + 24 | 0;
          s[t >> 2] = 438254204;
          s[t + 4 >> 2] = 49499509;
          t = m + 32 | 0;
          s[t >> 2] = 1279864178;
          s[t + 4 >> 2] = -1574785501;
          t = m + 40 | 0;
          s[t >> 2] = 1448993115;
          s[t + 4 >> 2] = -804322652;
          t = m + 48 | 0;
          s[t >> 2] = 1407174950;
          s[t + 4 >> 2] = -600837214;
          t = m + 56 | 0;
          s[t >> 2] = -1282828975;
          s[t + 4 >> 2] = 279402262;
          Ya(N, S, m);
          t = S;
          a = I + 64 | 0;
          r = t + 64 | 0;

          do {
            s[t >> 2] = s[a >> 2];
            t = t + 4 | 0;
            a = a + 4 | 0;
          } while ((t | 0) < (r | 0));

          t = m;
          s[t >> 2] = 856967431;
          s[t + 4 >> 2] = -1348753770;
          t = m + 8 | 0;
          s[t >> 2] = -2018527350;
          s[t + 4 >> 2] = -898949773;
          t = m + 16 | 0;
          s[t >> 2] = -259383161;
          s[t + 4 >> 2] = 297659742;
          t = m + 24 | 0;
          s[t >> 2] = 438254204;
          s[t + 4 >> 2] = 49499509;
          t = m + 32 | 0;
          s[t >> 2] = 1279864178;
          s[t + 4 >> 2] = -1574785501;
          t = m + 40 | 0;
          s[t >> 2] = 1448993115;
          s[t + 4 >> 2] = -804322652;
          t = m + 48 | 0;
          s[t >> 2] = 1407174950;
          s[t + 4 >> 2] = -600837214;
          t = m + 56 | 0;
          s[t >> 2] = -1282828975;
          s[t + 4 >> 2] = 279402262;
          Ya(W, S, m);
          t = S;
          a = I + 128 | 0;
          r = t + 64 | 0;

          do {
            s[t >> 2] = s[a >> 2];
            t = t + 4 | 0;
            a = a + 4 | 0;
          } while ((t | 0) < (r | 0));

          t = m;
          s[t >> 2] = 856967431;
          s[t + 4 >> 2] = -1348753770;
          t = m + 8 | 0;
          s[t >> 2] = -2018527350;
          s[t + 4 >> 2] = -898949773;
          t = m + 16 | 0;
          s[t >> 2] = -259383161;
          s[t + 4 >> 2] = 297659742;
          t = m + 24 | 0;
          s[t >> 2] = 438254204;
          s[t + 4 >> 2] = 49499509;
          t = m + 32 | 0;
          s[t >> 2] = 1279864178;
          s[t + 4 >> 2] = -1574785501;
          t = m + 40 | 0;
          s[t >> 2] = 1448993115;
          s[t + 4 >> 2] = -804322652;
          t = m + 48 | 0;
          s[t >> 2] = 1407174950;
          s[t + 4 >> 2] = -600837214;
          t = m + 56 | 0;
          s[t >> 2] = -1282828975;
          s[t + 4 >> 2] = 279402262;
          Ya(R, S, m);
          t = N + 64 | 0;
          a = W;
          r = t + 64 | 0;

          do {
            s[t >> 2] = s[a >> 2];
            t = t + 4 | 0;
            a = a + 4 | 0;
          } while ((t | 0) < (r | 0));

          t = N + 128 | 0;
          a = R;
          r = t + 64 | 0;

          do {
            s[t >> 2] = s[a >> 2];
            t = t + 4 | 0;
            a = a + 4 | 0;
          } while ((t | 0) < (r | 0));

          id(u + 192 | 0, N | 0, 192) | 0;
          id(S | 0, u | 0, 384) | 0;
          id(m | 0, d | 0, 384) | 0;
          La(c, S, m);
          Ua(i, h, 2);
          Ua(I, h + 192 | 0, 2);
          t = S;
          a = I;
          r = t + 64 | 0;

          do {
            s[t >> 2] = s[a >> 2];
            t = t + 4 | 0;
            a = a + 4 | 0;
          } while ((t | 0) < (r | 0));

          t = m;
          s[t >> 2] = 16391154;
          s[t + 4 >> 2] = -896696315;
          t = m + 8 | 0;
          s[t >> 2] = 1756600169;
          s[t + 4 >> 2] = -255470060;
          t = m + 16 | 0;
          s[t >> 2] = -1391639528;
          s[t + 4 >> 2] = 236982897;
          t = m + 24 | 0;
          s[t >> 2] = -1160227098;
          s[t + 4 >> 2] = 69799781;
          t = m + 32 | 0;
          s[t >> 2] = 0;
          s[t + 4 >> 2] = 0;
          s[t + 8 >> 2] = 0;
          s[t + 12 >> 2] = 0;
          s[t + 16 >> 2] = 0;
          s[t + 20 >> 2] = 0;
          s[t + 24 >> 2] = 0;
          s[t + 28 >> 2] = 0;
          Ya(N, S, m);
          t = S;
          a = I + 64 | 0;
          r = t + 64 | 0;

          do {
            s[t >> 2] = s[a >> 2];
            t = t + 4 | 0;
            a = a + 4 | 0;
          } while ((t | 0) < (r | 0));

          t = m;
          s[t >> 2] = 16391154;
          s[t + 4 >> 2] = -896696315;
          t = m + 8 | 0;
          s[t >> 2] = 1756600169;
          s[t + 4 >> 2] = -255470060;
          t = m + 16 | 0;
          s[t >> 2] = -1391639528;
          s[t + 4 >> 2] = 236982897;
          t = m + 24 | 0;
          s[t >> 2] = -1160227098;
          s[t + 4 >> 2] = 69799781;
          t = m + 32 | 0;
          s[t >> 2] = 0;
          s[t + 4 >> 2] = 0;
          s[t + 8 >> 2] = 0;
          s[t + 12 >> 2] = 0;
          s[t + 16 >> 2] = 0;
          s[t + 20 >> 2] = 0;
          s[t + 24 >> 2] = 0;
          s[t + 28 >> 2] = 0;
          Ya(W, S, m);
          t = S;
          a = I + 128 | 0;
          r = t + 64 | 0;

          do {
            s[t >> 2] = s[a >> 2];
            t = t + 4 | 0;
            a = a + 4 | 0;
          } while ((t | 0) < (r | 0));

          t = m;
          s[t >> 2] = 16391154;
          s[t + 4 >> 2] = -896696315;
          t = m + 8 | 0;
          s[t >> 2] = 1756600169;
          s[t + 4 >> 2] = -255470060;
          t = m + 16 | 0;
          s[t >> 2] = -1391639528;
          s[t + 4 >> 2] = 236982897;
          t = m + 24 | 0;
          s[t >> 2] = -1160227098;
          s[t + 4 >> 2] = 69799781;
          t = m + 32 | 0;
          s[t >> 2] = 0;
          s[t + 4 >> 2] = 0;
          s[t + 8 >> 2] = 0;
          s[t + 12 >> 2] = 0;
          s[t + 16 >> 2] = 0;
          s[t + 20 >> 2] = 0;
          s[t + 24 >> 2] = 0;
          s[t + 28 >> 2] = 0;
          Ya(R, S, m);
          t = N + 64 | 0;
          a = W;
          r = t + 64 | 0;

          do {
            s[t >> 2] = s[a >> 2];
            t = t + 4 | 0;
            a = a + 4 | 0;
          } while ((t | 0) < (r | 0));

          t = N + 128 | 0;
          a = R;
          r = t + 64 | 0;

          do {
            s[t >> 2] = s[a >> 2];
            t = t + 4 | 0;
            a = a + 4 | 0;
          } while ((t | 0) < (r | 0));

          id(i + 192 | 0, N | 0, 192) | 0;
          id(S | 0, i | 0, 384) | 0;
          id(m | 0, c | 0, 384) | 0;
          La(o, S, m);
          id(n | 0, C | 0, 192) | 0;
          id(m | 0, C + 192 | 0, 192) | 0;
          qa(S, m);
          id(n + 192 | 0, S | 0, 192) | 0;
          id(S | 0, n | 0, 384) | 0;
          id(m | 0, l | 0, 384) | 0;
          La(P, S, m);
          Ua(M, P, 3);
          Ua(I, P + 192 | 0, 3);
          t = S;
          a = I;
          r = t + 64 | 0;

          do {
            s[t >> 2] = s[a >> 2];
            t = t + 4 | 0;
            a = a + 4 | 0;
          } while ((t | 0) < (r | 0));

          t = m;
          s[t >> 2] = 1313266045;
          s[t + 4 >> 2] = 911414808;
          t = m + 8 | 0;
          s[t >> 2] = -724996705;
          s[t + 4 >> 2] = 183964318;
          t = m + 16 | 0;
          s[t >> 2] = -904918603;
          s[t + 4 >> 2] = 1704830767;
          t = m + 24 | 0;
          s[t >> 2] = -2086531805;
          s[t + 4 >> 2] = 135359881;
          t = m + 32 | 0;
          s[t >> 2] = -1013180103;
          s[t + 4 >> 2] = -1310766345;
          t = m + 40 | 0;
          s[t >> 2] = -1972125825;
          s[t + 4 >> 2] = 1033831047;
          t = m + 48 | 0;
          s[t >> 2] = -1934685472;
          s[t + 4 >> 2] = -1692262254;
          t = m + 56 | 0;
          s[t >> 2] = -269462362;
          s[t + 4 >> 2] = 644367637;
          Ya(N, S, m);
          t = S;
          a = I + 64 | 0;
          r = t + 64 | 0;

          do {
            s[t >> 2] = s[a >> 2];
            t = t + 4 | 0;
            a = a + 4 | 0;
          } while ((t | 0) < (r | 0));

          t = m;
          s[t >> 2] = 1313266045;
          s[t + 4 >> 2] = 911414808;
          t = m + 8 | 0;
          s[t >> 2] = -724996705;
          s[t + 4 >> 2] = 183964318;
          t = m + 16 | 0;
          s[t >> 2] = -904918603;
          s[t + 4 >> 2] = 1704830767;
          t = m + 24 | 0;
          s[t >> 2] = -2086531805;
          s[t + 4 >> 2] = 135359881;
          t = m + 32 | 0;
          s[t >> 2] = -1013180103;
          s[t + 4 >> 2] = -1310766345;
          t = m + 40 | 0;
          s[t >> 2] = -1972125825;
          s[t + 4 >> 2] = 1033831047;
          t = m + 48 | 0;
          s[t >> 2] = -1934685472;
          s[t + 4 >> 2] = -1692262254;
          t = m + 56 | 0;
          s[t >> 2] = -269462362;
          s[t + 4 >> 2] = 644367637;
          Ya(W, S, m);
          t = S;
          a = I + 128 | 0;
          r = t + 64 | 0;

          do {
            s[t >> 2] = s[a >> 2];
            t = t + 4 | 0;
            a = a + 4 | 0;
          } while ((t | 0) < (r | 0));

          t = m;
          s[t >> 2] = 1313266045;
          s[t + 4 >> 2] = 911414808;
          t = m + 8 | 0;
          s[t >> 2] = -724996705;
          s[t + 4 >> 2] = 183964318;
          t = m + 16 | 0;
          s[t >> 2] = -904918603;
          s[t + 4 >> 2] = 1704830767;
          t = m + 24 | 0;
          s[t >> 2] = -2086531805;
          s[t + 4 >> 2] = 135359881;
          t = m + 32 | 0;
          s[t >> 2] = -1013180103;
          s[t + 4 >> 2] = -1310766345;
          t = m + 40 | 0;
          s[t >> 2] = -1972125825;
          s[t + 4 >> 2] = 1033831047;
          t = m + 48 | 0;
          s[t >> 2] = -1934685472;
          s[t + 4 >> 2] = -1692262254;
          t = m + 56 | 0;
          s[t >> 2] = -269462362;
          s[t + 4 >> 2] = 644367637;
          Ya(R, S, m);
          t = N + 64 | 0;
          a = W;
          r = t + 64 | 0;

          do {
            s[t >> 2] = s[a >> 2];
            t = t + 4 | 0;
            a = a + 4 | 0;
          } while ((t | 0) < (r | 0));

          t = N + 128 | 0;
          a = R;
          r = t + 64 | 0;

          do {
            s[t >> 2] = s[a >> 2];
            t = t + 4 | 0;
            a = a + 4 | 0;
          } while ((t | 0) < (r | 0));

          id(M + 192 | 0, N | 0, 192) | 0;
          id(S | 0, M | 0, 384) | 0;
          id(m | 0, o | 0, 384) | 0;
          La(E, S, m);
          id(e + 8 | 0, E | 0, 384) | 0;
          I = 1;
          M = 0;
          P = e;
          N = P;
          s[N >> 2] = I;
          P = P + 4 | 0;
          s[P >> 2] = M;
          p = L;
          return;
        } else {
          I = 0;
          M = 0;
          P = e;
          N = P;
          s[N >> 2] = I;
          P = P + 4 | 0;
          s[P >> 2] = M;
          p = L;
          return;
        }
      }

      function Pa(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0;
        y = p;
        p = p + 2128 | 0;
        o = y + 1928 | 0;
        i = y + 1736 | 0;
        c = y + 1544 | 0;
        u = y + 1352 | 0;
        f = y + 968 | 0;
        l = y + 776 | 0;
        h = y + 584 | 0;
        b = y + 392 | 0;
        a = y + 200 | 0;
        r = y;
        Ha(b, t);
        n = t + 192 | 0;
        Ha(h, n);
        m = i;
        v = h + 128 | 0;
        _ = m + 64 | 0;

        do {
          s[m >> 2] = s[v >> 2];
          m = m + 4 | 0;
          v = v + 4 | 0;
        } while ((m | 0) < (_ | 0));

        d = o;
        s[d >> 2] = 1091403767;
        s[d + 4 >> 2] = -167360562;
        d = o + 8 | 0;
        s[d >> 2] = -753151983;
        s[d + 4 >> 2] = 792555341;
        d = o + 16 | 0;
        s[d >> 2] = 960546513;
        s[d + 4 >> 2] = 692269950;
        d = o + 24 | 0;
        s[d >> 2] = -1478256553;
        s[d + 4 >> 2] = 496343272;
        d = o + 32 | 0;
        s[d >> 2] = -980480611;
        s[d + 4 >> 2] = -748862579;
        d = o + 40 | 0;
        s[d >> 2] = -171504835;
        s[d + 4 >> 2] = 175696680;
        d = o + 48 | 0;
        s[d >> 2] = 2021213740;
        s[d + 4 >> 2] = 1718526831;
        d = o + 56 | 0;
        s[d >> 2] = -1710760145;
        s[d + 4 >> 2] = 235567041;
        Ya(f, i, o);
        d = h + 64 | 0;
        m = f + 64 | 0;
        v = h;
        _ = m + 64 | 0;

        do {
          s[m >> 2] = s[v >> 2];
          m = m + 4 | 0;
          v = v + 4 | 0;
        } while ((m | 0) < (_ | 0));

        m = f + 128 | 0;
        v = d;
        _ = m + 64 | 0;

        do {
          s[m >> 2] = s[v >> 2];
          m = m + 4 | 0;
          v = v + 4 | 0;
        } while ((m | 0) < (_ | 0));

        m = i;
        v = b;
        _ = m + 64 | 0;

        do {
          s[m >> 2] = s[v >> 2];
          m = m + 4 | 0;
          v = v + 4 | 0;
        } while ((m | 0) < (_ | 0));

        m = o;
        v = f;
        _ = m + 64 | 0;

        do {
          s[m >> 2] = s[v >> 2];
          m = m + 4 | 0;
          v = v + 4 | 0;
        } while ((m | 0) < (_ | 0));

        Xa(a, i, o);
        m = i;
        v = b + 64 | 0;
        _ = m + 64 | 0;

        do {
          s[m >> 2] = s[v >> 2];
          m = m + 4 | 0;
          v = v + 4 | 0;
        } while ((m | 0) < (_ | 0));

        m = o;
        v = h;
        _ = m + 64 | 0;

        do {
          s[m >> 2] = s[v >> 2];
          m = m + 4 | 0;
          v = v + 4 | 0;
        } while ((m | 0) < (_ | 0));

        Xa(u, i, o);
        m = i;
        v = b + 128 | 0;
        _ = m + 64 | 0;

        do {
          s[m >> 2] = s[v >> 2];
          m = m + 4 | 0;
          v = v + 4 | 0;
        } while ((m | 0) < (_ | 0));

        m = o;
        v = d;
        _ = m + 64 | 0;

        do {
          s[m >> 2] = s[v >> 2];
          m = m + 4 | 0;
          v = v + 4 | 0;
        } while ((m | 0) < (_ | 0));

        Xa(c, i, o);
        m = a + 64 | 0;
        v = u;
        _ = m + 64 | 0;

        do {
          s[m >> 2] = s[v >> 2];
          m = m + 4 | 0;
          v = v + 4 | 0;
        } while ((m | 0) < (_ | 0));

        m = a + 128 | 0;
        v = c;
        _ = m + 64 | 0;

        do {
          s[m >> 2] = s[v >> 2];
          m = m + 4 | 0;
          v = v + 4 | 0;
        } while ((m | 0) < (_ | 0));

        za(r, a);
        _ = r;

        if (!((s[_ >> 2] | 0) == 1 & (s[_ + 4 >> 2] | 0) == 0)) {
          b = 0;
          v = 0;
          _ = e;
          m = _;
          s[m >> 2] = b;
          _ = _ + 4 | 0;
          s[_ >> 2] = v;
          p = y;
          return;
        }

        b = r + 8 | 0;
        id(l | 0, b | 0, 192) | 0;
        id(i | 0, t | 0, 192) | 0;
        id(o | 0, b | 0, 192) | 0;
        Ka(f, i, o);
        id(i | 0, n | 0, 192) | 0;
        id(o | 0, l | 0, 192) | 0;
        Ka(c, i, o);
        qa(u, c);
        id(f + 192 | 0, u | 0, 192) | 0;
        id(e + 8 | 0, f | 0, 384) | 0;
        b = 1;
        v = 0;
        _ = e;
        m = _;
        s[m >> 2] = b;
        _ = _ + 4 | 0;
        s[_ >> 2] = v;
        p = y;
        return;
      }

      function La(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0,
            A = 0,
            w = 0,
            T = 0,
            x = 0,
            D = 0;
        T = p;
        p = p + 2432 | 0;
        y = T + 2240 | 0;
        v = T + 2048 | 0;
        _ = T + 1984 | 0;
        g = T + 1920 | 0;
        A = T + 1728 | 0;
        d = T + 1536 | 0;
        f = T + 1344 | 0;
        r = T + 1152 | 0;
        n = T + 960 | 0;
        l = T + 768 | 0;
        h = T + 576 | 0;
        b = T + 384 | 0;
        m = T + 192 | 0;
        o = T;
        id(v | 0, t | 0, 192) | 0;
        id(y | 0, a | 0, 192) | 0;
        Ka(o, v, y);
        i = t + 192 | 0;
        id(v | 0, i | 0, 192) | 0;
        c = a + 192 | 0;
        id(y | 0, c | 0, 192) | 0;
        Ka(m, v, y);
        w = v;
        x = m + 128 | 0;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        u = y;
        s[u >> 2] = 1091403767;
        s[u + 4 >> 2] = -167360562;
        u = y + 8 | 0;
        s[u >> 2] = -753151983;
        s[u + 4 >> 2] = 792555341;
        u = y + 16 | 0;
        s[u >> 2] = 960546513;
        s[u + 4 >> 2] = 692269950;
        u = y + 24 | 0;
        s[u >> 2] = -1478256553;
        s[u + 4 >> 2] = 496343272;
        u = y + 32 | 0;
        s[u >> 2] = -980480611;
        s[u + 4 >> 2] = -748862579;
        u = y + 40 | 0;
        s[u >> 2] = -171504835;
        s[u + 4 >> 2] = 175696680;
        u = y + 48 | 0;
        s[u >> 2] = 2021213740;
        s[u + 4 >> 2] = 1718526831;
        u = y + 56 | 0;
        s[u >> 2] = -1710760145;
        s[u + 4 >> 2] = 235567041;
        Ya(d, v, y);
        u = m + 64 | 0;
        w = d + 64 | 0;
        x = m;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        w = d + 128 | 0;
        x = u;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        id(A | 0, o | 0, 192) | 0;
        w = v;
        x = d;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        w = y;
        x = o;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        $a(b, v, y);
        w = v;
        x = m;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        w = y;
        x = A + 64 | 0;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        $a(g, v, y);
        w = v;
        x = u;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        w = y;
        x = A + 128 | 0;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        $a(_, v, y);
        w = b + 64 | 0;
        x = g;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        w = b + 128 | 0;
        x = _;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        id(d | 0, t | 0, 192) | 0;
        id(A | 0, i | 0, 192) | 0;
        w = v;
        x = t;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        w = y;
        x = i;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        $a(r, v, y);
        w = v;
        x = d + 64 | 0;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        w = y;
        x = A + 64 | 0;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        $a(g, v, y);
        w = v;
        x = d + 128 | 0;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        w = y;
        x = A + 128 | 0;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        $a(_, v, y);
        w = r + 64 | 0;
        x = g;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        w = r + 128 | 0;
        x = _;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        id(d | 0, a | 0, 192) | 0;
        id(A | 0, c | 0, 192) | 0;
        w = v;
        x = a;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        w = y;
        x = c;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        $a(f, v, y);
        w = v;
        x = d + 64 | 0;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        w = y;
        x = A + 64 | 0;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        $a(g, v, y);
        w = v;
        x = d + 128 | 0;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        w = y;
        x = A + 128 | 0;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        $a(_, v, y);
        w = f + 64 | 0;
        x = g;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        w = f + 128 | 0;
        x = _;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        Ka(n, r, f);
        id(A | 0, o | 0, 192) | 0;
        w = v;
        x = n;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        w = y;
        x = o;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        Xa(l, v, y);
        w = v;
        x = n + 64 | 0;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        w = y;
        x = A + 64 | 0;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        Xa(g, v, y);
        w = v;
        x = n + 128 | 0;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        w = y;
        x = A + 128 | 0;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        Xa(_, v, y);
        t = l + 64 | 0;
        w = t;
        x = g;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        r = l + 128 | 0;
        w = r;
        x = _;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        id(A | 0, m | 0, 192) | 0;
        w = v;
        x = l;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        w = y;
        x = m;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        Xa(h, v, y);
        w = v;
        x = t;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        w = y;
        x = A + 64 | 0;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        Xa(g, v, y);
        w = v;
        x = r;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        w = y;
        x = A + 128 | 0;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        Xa(_, v, y);
        w = h + 64 | 0;
        x = g;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        w = h + 128 | 0;
        x = _;
        D = w + 64 | 0;

        do {
          s[w >> 2] = s[x >> 2];
          w = w + 4 | 0;
          x = x + 4 | 0;
        } while ((w | 0) < (D | 0));

        id(e | 0, b | 0, 192) | 0;
        id(e + 192 | 0, h | 0, 192) | 0;
        p = T;
        return;
      }

      function Oa(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0;
        d = p;
        p = p + 1568 | 0;
        n = d + 1184 | 0;
        o = d + 800 | 0;
        i = d + 768 | 0;
        c = d + 384 | 0;
        u = d;
        a = c;
        s[a >> 2] = -980480611;
        s[a + 4 >> 2] = -748862579;
        a = c + 8 | 0;
        s[a >> 2] = -171504835;
        s[a + 4 >> 2] = 175696680;
        a = c + 16 | 0;
        s[a >> 2] = 2021213740;
        s[a + 4 >> 2] = 1718526831;
        a = c + 24 | 0;
        s[a >> 2] = -1710760145;
        s[a + 4 >> 2] = 235567041;
        ed(c + 32 | 0, 0, 160) | 0;
        ed(c + 192 | 0, 0, 192) | 0;
        a = i;
        s[a >> 2] = 1248397809;
        s[a + 4 >> 2] = 1156158132;
        a = i + 8 | 0;
        s[a >> 2] = 0;
        s[a + 4 >> 2] = 0;
        s[a + 8 >> 2] = 0;
        s[a + 12 >> 2] = 0;
        s[a + 16 >> 2] = 0;
        s[a + 20 >> 2] = 0;
        a = 256;

        while (1) {
          if (!a) break;
          a = a + -1 | 0;
          if (a >>> 0 > 255) break;
          f = i + (a >>> 6 << 3) | 0;
          h = s[f >> 2] | 0;
          f = s[f + 4 >> 2] | 0;
          l = od(1, 0, a & 63 | 0) | 0;

          if (!((h & l | 0) == 0 & (f & S | 0) == 0)) {
            r = 8;
            break;
          }
        }

        e: do {
          if ((r | 0) == 8) t: while (1) {
            id(o | 0, t | 0, 384) | 0;
            id(n | 0, c | 0, 384) | 0;
            La(c, o, n);

            while (1) {
              if (!a) break e;
              a = a + -1 | 0;
              if (a >>> 0 > 255) break e;
              h = i + (a >>> 6 << 3) | 0;
              f = s[h >> 2] | 0;
              h = s[h + 4 >> 2] | 0;
              l = od(1, 0, a & 63 | 0) | 0;
              h = (f & l | 0) == 0 & (h & S | 0) == 0;
              Fa(n, c);
              id(c | 0, n | 0, 384) | 0;

              if (!h) {
                r = 8;
                continue t;
              }
            }
          }
        } while (0);

        id(u | 0, c | 0, 384) | 0;
        id(e | 0, u | 0, 192) | 0;
        id(n | 0, u + 192 | 0, 192) | 0;
        qa(o, n);
        id(e + 192 | 0, o | 0, 192) | 0;
        p = d;
        return;
      }

      function Fa(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0,
            A = 0,
            w = 0,
            T = 0,
            x = 0,
            D = 0,
            C = 0,
            S = 0,
            E = 0,
            B = 0,
            k = 0,
            R = 0,
            W = 0,
            I = 0,
            N = 0,
            M = 0,
            P = 0,
            L = 0,
            O = 0,
            F = 0,
            j = 0,
            G = 0,
            V = 0,
            U = 0,
            H = 0,
            z = 0;
        U = p;
        p = p + 2560 | 0;
        h = U + 2368 | 0;
        D = U + 2176 | 0;
        N = U + 2112 | 0;
        L = U + 2048 | 0;
        O = U + 1984 | 0;
        F = U + 1920 | 0;
        j = U + 1856 | 0;
        G = U + 1792 | 0;
        a = U + 1728 | 0;
        r = U + 1664 | 0;
        n = U + 1600 | 0;
        o = U + 1536 | 0;
        i = U + 1472 | 0;
        c = U + 1408 | 0;
        u = U + 1344 | 0;
        d = U + 1280 | 0;
        f = U + 1216 | 0;
        l = U + 1152 | 0;
        b = U + 1088 | 0;
        m = U + 1024 | 0;
        y = U + 960 | 0;
        v = U + 896 | 0;
        _ = U + 832 | 0;
        g = U + 768 | 0;
        A = U + 704 | 0;
        w = U + 640 | 0;
        T = U + 576 | 0;
        x = U + 512 | 0;
        C = U + 448 | 0;
        S = U + 384 | 0;
        E = U + 320 | 0;
        B = U + 256 | 0;
        k = U + 192 | 0;
        R = U + 128 | 0;
        W = U + 64 | 0;
        I = U;
        V = I;
        H = t;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = W;
        H = t + 64 | 0;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = R;
        H = t + 128 | 0;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        M = t + 192 | 0;
        V = k;
        H = M;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        P = t + 256 | 0;
        V = B;
        H = P;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = E;
        H = t + 320 | 0;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = D;
        H = t;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        H = P;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        Ya(S, D, h);
        V = D;
        H = I;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        H = B;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        $a(O, D, h);
        V = D;
        H = B;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        s[V >> 2] = 1091403767;
        s[V + 4 >> 2] = -167360562;
        V = h + 8 | 0;
        s[V >> 2] = -753151983;
        s[V + 4 >> 2] = 792555341;
        V = h + 16 | 0;
        s[V >> 2] = 960546513;
        s[V + 4 >> 2] = 692269950;
        V = h + 24 | 0;
        s[V >> 2] = -1478256553;
        s[V + 4 >> 2] = 496343272;
        V = h + 32 | 0;
        s[V >> 2] = -980480611;
        s[V + 4 >> 2] = -748862579;
        V = h + 40 | 0;
        s[V >> 2] = -171504835;
        s[V + 4 >> 2] = 175696680;
        V = h + 48 | 0;
        s[V >> 2] = 2021213740;
        s[V + 4 >> 2] = 1718526831;
        V = h + 56 | 0;
        s[V >> 2] = -1710760145;
        s[V + 4 >> 2] = 235567041;
        Ya(N, D, h);
        V = h;
        H = I;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        $a(L, N, h);
        Ya(F, O, L);
        V = h;
        H = S;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        Xa(j, F, h);
        V = D;
        H = S;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        s[V >> 2] = 1091403767;
        s[V + 4 >> 2] = -167360562;
        V = h + 8 | 0;
        s[V >> 2] = -753151983;
        s[V + 4 >> 2] = 792555341;
        V = h + 16 | 0;
        s[V >> 2] = 960546513;
        s[V + 4 >> 2] = 692269950;
        V = h + 24 | 0;
        s[V >> 2] = -1478256553;
        s[V + 4 >> 2] = 496343272;
        V = h + 32 | 0;
        s[V >> 2] = -980480611;
        s[V + 4 >> 2] = -748862579;
        V = h + 40 | 0;
        s[V >> 2] = -171504835;
        s[V + 4 >> 2] = 175696680;
        V = h + 48 | 0;
        s[V >> 2] = 2021213740;
        s[V + 4 >> 2] = 1718526831;
        V = h + 56 | 0;
        s[V >> 2] = -1710760145;
        s[V + 4 >> 2] = 235567041;
        Ya(N, D, h);
        Xa(C, j, N);
        V = D;
        H = S;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        H = S;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        $a(x, D, h);
        V = D;
        H = M;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        H = R;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        Ya(T, D, h);
        V = D;
        H = k;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        H = R;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        $a(O, D, h);
        V = D;
        H = R;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        s[V >> 2] = 1091403767;
        s[V + 4 >> 2] = -167360562;
        V = h + 8 | 0;
        s[V >> 2] = -753151983;
        s[V + 4 >> 2] = 792555341;
        V = h + 16 | 0;
        s[V >> 2] = 960546513;
        s[V + 4 >> 2] = 692269950;
        V = h + 24 | 0;
        s[V >> 2] = -1478256553;
        s[V + 4 >> 2] = 496343272;
        V = h + 32 | 0;
        s[V >> 2] = -980480611;
        s[V + 4 >> 2] = -748862579;
        V = h + 40 | 0;
        s[V >> 2] = -171504835;
        s[V + 4 >> 2] = 175696680;
        V = h + 48 | 0;
        s[V >> 2] = 2021213740;
        s[V + 4 >> 2] = 1718526831;
        V = h + 56 | 0;
        s[V >> 2] = -1710760145;
        s[V + 4 >> 2] = 235567041;
        Ya(N, D, h);
        V = h;
        H = k;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        $a(L, N, h);
        Ya(F, O, L);
        V = h;
        H = T;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        Xa(j, F, h);
        V = D;
        H = T;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        s[V >> 2] = 1091403767;
        s[V + 4 >> 2] = -167360562;
        V = h + 8 | 0;
        s[V >> 2] = -753151983;
        s[V + 4 >> 2] = 792555341;
        V = h + 16 | 0;
        s[V >> 2] = 960546513;
        s[V + 4 >> 2] = 692269950;
        V = h + 24 | 0;
        s[V >> 2] = -1478256553;
        s[V + 4 >> 2] = 496343272;
        V = h + 32 | 0;
        s[V >> 2] = -980480611;
        s[V + 4 >> 2] = -748862579;
        V = h + 40 | 0;
        s[V >> 2] = -171504835;
        s[V + 4 >> 2] = 175696680;
        V = h + 48 | 0;
        s[V >> 2] = 2021213740;
        s[V + 4 >> 2] = 1718526831;
        V = h + 56 | 0;
        s[V >> 2] = -1710760145;
        s[V + 4 >> 2] = 235567041;
        Ya(N, D, h);
        Xa(w, j, N);
        V = D;
        H = T;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        H = T;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        $a(A, D, h);
        V = D;
        H = W;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        H = E;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        Ya(g, D, h);
        V = D;
        H = W;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        H = E;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        $a(O, D, h);
        V = D;
        H = E;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        s[V >> 2] = 1091403767;
        s[V + 4 >> 2] = -167360562;
        V = h + 8 | 0;
        s[V >> 2] = -753151983;
        s[V + 4 >> 2] = 792555341;
        V = h + 16 | 0;
        s[V >> 2] = 960546513;
        s[V + 4 >> 2] = 692269950;
        V = h + 24 | 0;
        s[V >> 2] = -1478256553;
        s[V + 4 >> 2] = 496343272;
        V = h + 32 | 0;
        s[V >> 2] = -980480611;
        s[V + 4 >> 2] = -748862579;
        V = h + 40 | 0;
        s[V >> 2] = -171504835;
        s[V + 4 >> 2] = 175696680;
        V = h + 48 | 0;
        s[V >> 2] = 2021213740;
        s[V + 4 >> 2] = 1718526831;
        V = h + 56 | 0;
        s[V >> 2] = -1710760145;
        s[V + 4 >> 2] = 235567041;
        Ya(N, D, h);
        V = h;
        H = W;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        $a(L, N, h);
        Ya(F, O, L);
        V = h;
        H = g;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        Xa(j, F, h);
        V = D;
        H = g;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        s[V >> 2] = 1091403767;
        s[V + 4 >> 2] = -167360562;
        V = h + 8 | 0;
        s[V >> 2] = -753151983;
        s[V + 4 >> 2] = 792555341;
        V = h + 16 | 0;
        s[V >> 2] = 960546513;
        s[V + 4 >> 2] = 692269950;
        V = h + 24 | 0;
        s[V >> 2] = -1478256553;
        s[V + 4 >> 2] = 496343272;
        V = h + 32 | 0;
        s[V >> 2] = -980480611;
        s[V + 4 >> 2] = -748862579;
        V = h + 40 | 0;
        s[V >> 2] = -171504835;
        s[V + 4 >> 2] = 175696680;
        V = h + 48 | 0;
        s[V >> 2] = 2021213740;
        s[V + 4 >> 2] = 1718526831;
        V = h + 56 | 0;
        s[V >> 2] = -1710760145;
        s[V + 4 >> 2] = 235567041;
        Ya(N, D, h);
        Xa(_, j, N);
        V = D;
        H = g;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        H = g;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        $a(v, D, h);
        V = D;
        H = C;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        H = I;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        Xa(y, D, h);
        V = D;
        H = y;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        H = y;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        $a(m, D, h);
        V = D;
        H = m;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        H = C;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        $a(b, D, h);
        V = D;
        H = x;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        H = B;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        $a(l, D, h);
        V = D;
        H = l;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        H = l;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        $a(f, D, h);
        V = D;
        H = f;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        H = x;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        $a(d, D, h);
        V = D;
        H = v;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        s[V >> 2] = 1091403767;
        s[V + 4 >> 2] = -167360562;
        V = h + 8 | 0;
        s[V >> 2] = -753151983;
        s[V + 4 >> 2] = 792555341;
        V = h + 16 | 0;
        s[V >> 2] = 960546513;
        s[V + 4 >> 2] = 692269950;
        V = h + 24 | 0;
        s[V >> 2] = -1478256553;
        s[V + 4 >> 2] = 496343272;
        V = h + 32 | 0;
        s[V >> 2] = -980480611;
        s[V + 4 >> 2] = -748862579;
        V = h + 40 | 0;
        s[V >> 2] = -171504835;
        s[V + 4 >> 2] = 175696680;
        V = h + 48 | 0;
        s[V >> 2] = 2021213740;
        s[V + 4 >> 2] = 1718526831;
        V = h + 56 | 0;
        s[V >> 2] = -1710760145;
        s[V + 4 >> 2] = 235567041;
        Ya(u, D, h);
        V = D;
        H = u;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        H = k;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        $a(c, D, h);
        V = D;
        H = c;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        H = c;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        $a(i, D, h);
        V = D;
        H = i;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        H = u;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        $a(o, D, h);
        V = D;
        H = _;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        H = R;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        Xa(n, D, h);
        V = D;
        H = n;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        H = n;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        $a(r, D, h);
        V = D;
        H = r;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        H = _;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        $a(a, D, h);
        V = D;
        H = w;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        H = W;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        Xa(G, D, h);
        V = D;
        H = G;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        H = G;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        $a(j, D, h);
        V = D;
        H = j;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        H = w;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        $a(F, D, h);
        V = D;
        H = A;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        H = E;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        $a(O, D, h);
        V = D;
        H = O;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        H = O;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        $a(L, D, h);
        V = D;
        H = L;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        H = A;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        $a(N, D, h);
        V = D;
        H = b;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = D + 64 | 0;
        H = F;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = D + 128 | 0;
        H = a;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h;
        H = o;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h + 64 | 0;
        H = d;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        V = h + 128 | 0;
        H = N;
        z = V + 64 | 0;

        do {
          s[V >> 2] = s[H >> 2];
          V = V + 4 | 0;
          H = H + 4 | 0;
        } while ((V | 0) < (z | 0));

        id(e | 0, D | 0, 192) | 0;
        id(e + 192 | 0, h | 0, 192) | 0;
        p = U;
        return;
      }

      function ja(e, t, a, r, n) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        r = r | 0;
        n = n | 0;
        var o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0,
            A = 0,
            w = 0,
            T = 0,
            x = 0,
            D = 0,
            C = 0,
            S = 0,
            E = 0,
            B = 0,
            k = 0,
            R = 0,
            W = 0,
            I = 0,
            N = 0,
            M = 0,
            P = 0,
            L = 0,
            O = 0,
            F = 0,
            j = 0,
            G = 0,
            V = 0,
            U = 0,
            H = 0,
            z = 0,
            K = 0,
            q = 0,
            Y = 0,
            Z = 0,
            J = 0,
            X = 0,
            $ = 0,
            Q = 0,
            ee = 0,
            te = 0,
            ae = 0,
            re = 0,
            ne = 0,
            se = 0,
            oe = 0,
            ie = 0,
            ce = 0,
            ue = 0,
            de = 0,
            fe = 0,
            le = 0,
            he = 0;
        fe = p;
        p = p + 3584 | 0;
        q = fe + 3392 | 0;
        ne = fe + 3200 | 0;
        ie = fe + 3136 | 0;
        ce = fe + 3072 | 0;
        ue = fe + 3008 | 0;
        o = fe + 2944 | 0;
        i = fe + 2880 | 0;
        c = fe + 2816 | 0;
        u = fe + 2752 | 0;
        d = fe + 2688 | 0;
        f = fe + 2624 | 0;
        l = fe + 2560 | 0;
        h = fe + 2496 | 0;
        b = fe + 2432 | 0;
        m = fe + 2368 | 0;
        y = fe + 2304 | 0;
        v = fe + 2240 | 0;
        _ = fe + 2176 | 0;
        g = fe + 2112 | 0;
        A = fe + 2048 | 0;
        w = fe + 1984 | 0;
        T = fe + 1920 | 0;
        x = fe + 1856 | 0;
        D = fe + 1792 | 0;
        C = fe + 1728 | 0;
        S = fe + 1664 | 0;
        E = fe + 1600 | 0;
        B = fe + 1536 | 0;
        k = fe + 1472 | 0;
        R = fe + 1408 | 0;
        W = fe + 1344 | 0;
        I = fe + 1280 | 0;
        N = fe + 1216 | 0;
        M = fe + 1152 | 0;
        P = fe + 1088 | 0;
        L = fe + 1024 | 0;
        O = fe + 960 | 0;
        F = fe + 896 | 0;
        j = fe + 832 | 0;
        G = fe + 768 | 0;
        V = fe + 704 | 0;
        U = fe + 640 | 0;
        H = fe + 576 | 0;
        z = fe + 512 | 0;
        K = fe + 448 | 0;
        Y = fe + 384 | 0;
        Z = fe + 320 | 0;
        J = fe + 256 | 0;
        X = fe + 192 | 0;
        $ = fe + 128 | 0;
        Q = fe + 64 | 0;
        ee = fe;
        de = ee;
        le = t;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        te = t + 64 | 0;
        de = Q;
        le = te;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        ae = t + 128 | 0;
        de = $;
        le = ae;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        re = t + 192 | 0;
        de = X;
        le = re;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        se = t + 256 | 0;
        de = J;
        le = se;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        oe = t + 320 | 0;
        de = Z;
        le = oe;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = Y;
        le = a;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = K;
        le = n;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = z;
        le = r;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = ne;
        le = t;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        le = a;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        Ya(H, ne, q);
        de = ne;
        le = ae;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        le = n;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        Ya(U, ne, q);
        de = ne;
        le = se;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        le = r;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        Ya(V, ne, q);
        de = ne;
        le = ee;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        le = J;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        $a(G, ne, q);
        de = ne;
        le = ee;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        le = $;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        $a(j, ne, q);
        de = ne;
        le = te;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        le = re;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        $a(ie, ne, q);
        de = q;
        le = oe;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        $a(F, ie, q);
        de = ne;
        le = Q;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        le = K;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        Ya(O, ne, q);
        de = ne;
        le = O;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        le = V;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        $a(L, ne, q);
        de = ne;
        le = L;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        s[de >> 2] = 1091403767;
        s[de + 4 >> 2] = -167360562;
        de = q + 8 | 0;
        s[de >> 2] = -753151983;
        s[de + 4 >> 2] = 792555341;
        de = q + 16 | 0;
        s[de >> 2] = 960546513;
        s[de + 4 >> 2] = 692269950;
        de = q + 24 | 0;
        s[de >> 2] = -1478256553;
        s[de + 4 >> 2] = 496343272;
        de = q + 32 | 0;
        s[de >> 2] = -980480611;
        s[de + 4 >> 2] = -748862579;
        de = q + 40 | 0;
        s[de >> 2] = -171504835;
        s[de + 4 >> 2] = 175696680;
        de = q + 48 | 0;
        s[de >> 2] = 2021213740;
        s[de + 4 >> 2] = 1718526831;
        de = q + 56 | 0;
        s[de >> 2] = -1710760145;
        s[de + 4 >> 2] = 235567041;
        Ya(ie, ne, q);
        de = q;
        le = H;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        $a(P, ie, q);
        de = M;
        le = P;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = ne;
        le = Z;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        le = z;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        Ya(N, ne, q);
        de = ne;
        le = O;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        le = N;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        $a(I, ne, q);
        de = ne;
        le = N;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        le = U;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        $a(W, ne, q);
        de = ne;
        le = W;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        s[de >> 2] = 1091403767;
        s[de + 4 >> 2] = -167360562;
        de = q + 8 | 0;
        s[de >> 2] = -753151983;
        s[de + 4 >> 2] = 792555341;
        de = q + 16 | 0;
        s[de >> 2] = 960546513;
        s[de + 4 >> 2] = 692269950;
        de = q + 24 | 0;
        s[de >> 2] = -1478256553;
        s[de + 4 >> 2] = 496343272;
        de = q + 32 | 0;
        s[de >> 2] = -980480611;
        s[de + 4 >> 2] = -748862579;
        de = q + 40 | 0;
        s[de >> 2] = -171504835;
        s[de + 4 >> 2] = 175696680;
        de = q + 48 | 0;
        s[de >> 2] = 2021213740;
        s[de + 4 >> 2] = 1718526831;
        de = q + 56 | 0;
        s[de >> 2] = -1710760145;
        s[de + 4 >> 2] = 235567041;
        Ya(R, ne, q);
        de = ne;
        le = Q;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        le = Y;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        Ya(k, ne, q);
        de = ne;
        le = I;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        le = k;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        $a(B, ne, q);
        de = ne;
        le = R;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        le = k;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        $a(E, ne, q);
        de = S;
        le = E;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = ne;
        le = Y;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        le = K;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        $a(C, ne, q);
        de = ne;
        le = j;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        le = C;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        Ya(ie, ne, q);
        de = q;
        le = H;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        Xa(ce, ie, q);
        de = q;
        le = U;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        Xa(D, ce, q);
        de = ne;
        le = X;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        le = z;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        Ya(x, ne, q);
        de = ne;
        le = B;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        le = x;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        $a(T, ne, q);
        de = ne;
        le = D;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        le = x;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        $a(w, ne, q);
        de = ne;
        le = $;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        le = J;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        $a(A, ne, q);
        de = g;
        le = w;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = ne;
        le = K;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        le = z;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        $a(_, ne, q);
        de = ne;
        le = A;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        le = _;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        Ya(ie, ne, q);
        de = q;
        le = U;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        Xa(ce, ie, q);
        de = q;
        le = V;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        Xa(v, ce, q);
        de = ne;
        le = v;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        s[de >> 2] = 1091403767;
        s[de + 4 >> 2] = -167360562;
        de = q + 8 | 0;
        s[de >> 2] = -753151983;
        s[de + 4 >> 2] = 792555341;
        de = q + 16 | 0;
        s[de >> 2] = 960546513;
        s[de + 4 >> 2] = 692269950;
        de = q + 24 | 0;
        s[de >> 2] = -1478256553;
        s[de + 4 >> 2] = 496343272;
        de = q + 32 | 0;
        s[de >> 2] = -980480611;
        s[de + 4 >> 2] = -748862579;
        de = q + 40 | 0;
        s[de >> 2] = -171504835;
        s[de + 4 >> 2] = 175696680;
        de = q + 48 | 0;
        s[de >> 2] = 2021213740;
        s[de + 4 >> 2] = 1718526831;
        de = q + 56 | 0;
        s[de >> 2] = -1710760145;
        s[de + 4 >> 2] = 235567041;
        Ya(y, ne, q);
        de = ne;
        le = X;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        le = Y;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        Ya(m, ne, q);
        de = ne;
        le = T;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        le = m;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        $a(b, ne, q);
        de = ne;
        le = y;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        le = m;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        $a(h, ne, q);
        de = l;
        le = h;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = ne;
        le = Z;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        le = K;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        Ya(f, ne, q);
        de = ne;
        le = b;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        le = f;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        $a(d, ne, q);
        de = ne;
        le = f;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        s[de >> 2] = 1091403767;
        s[de + 4 >> 2] = -167360562;
        de = q + 8 | 0;
        s[de >> 2] = -753151983;
        s[de + 4 >> 2] = 792555341;
        de = q + 16 | 0;
        s[de >> 2] = 960546513;
        s[de + 4 >> 2] = 692269950;
        de = q + 24 | 0;
        s[de >> 2] = -1478256553;
        s[de + 4 >> 2] = 496343272;
        de = q + 32 | 0;
        s[de >> 2] = -980480611;
        s[de + 4 >> 2] = -748862579;
        de = q + 40 | 0;
        s[de >> 2] = -171504835;
        s[de + 4 >> 2] = 175696680;
        de = q + 48 | 0;
        s[de >> 2] = 2021213740;
        s[de + 4 >> 2] = 1718526831;
        de = q + 56 | 0;
        s[de >> 2] = -1710760145;
        s[de + 4 >> 2] = 235567041;
        Ya(u, ne, q);
        de = ne;
        le = Y;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        le = z;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        $a(c, ne, q);
        de = ne;
        le = G;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        le = c;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        Ya(ie, ne, q);
        de = q;
        le = H;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        Xa(ce, ie, q);
        de = q;
        le = V;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        Xa(i, ce, q);
        de = ne;
        le = u;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        le = i;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        $a(o, ne, q);
        de = ne;
        le = Y;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        le = K;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        $a(ie, ne, q);
        de = q;
        le = z;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        $a(ue, ie, q);
        de = ne;
        le = F;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        le = ue;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        Ya(ie, ne, q);
        de = q;
        le = d;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        Xa(ce, ie, q);
        de = ne;
        le = M;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = ne + 64 | 0;
        le = S;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = ne + 128 | 0;
        le = g;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q;
        le = l;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q + 64 | 0;
        le = o;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        de = q + 128 | 0;
        le = ce;
        he = de + 64 | 0;

        do {
          s[de >> 2] = s[le >> 2];
          de = de + 4 | 0;
          le = le + 4 | 0;
        } while ((de | 0) < (he | 0));

        id(e | 0, ne | 0, 192) | 0;
        id(e + 192 | 0, q | 0, 192) | 0;
        p = fe;
        return;
      }

      function Ga(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0,
            A = 0;
        _ = p;
        p = p + 2048 | 0;
        d = _ + 1856 | 0;
        f = _ + 1664 | 0;
        l = _ + 1600 | 0;
        h = _ + 1536 | 0;
        b = _ + 1344 | 0;
        m = _ + 1152 | 0;
        y = _ + 960 | 0;
        o = _ + 768 | 0;
        a = _ + 576 | 0;
        i = _ + 384 | 0;
        c = _ + 192 | 0;
        u = _;
        id(f | 0, t | 0, 192) | 0;
        r = t + 192 | 0;
        id(d | 0, r | 0, 192) | 0;
        Ka(u, f, d);
        v = f;
        g = t + 320 | 0;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        n = d;
        s[n >> 2] = 1091403767;
        s[n + 4 >> 2] = -167360562;
        n = d + 8 | 0;
        s[n >> 2] = -753151983;
        s[n + 4 >> 2] = 792555341;
        n = d + 16 | 0;
        s[n >> 2] = 960546513;
        s[n + 4 >> 2] = 692269950;
        n = d + 24 | 0;
        s[n >> 2] = -1478256553;
        s[n + 4 >> 2] = 496343272;
        n = d + 32 | 0;
        s[n >> 2] = -980480611;
        s[n + 4 >> 2] = -748862579;
        n = d + 40 | 0;
        s[n >> 2] = -171504835;
        s[n + 4 >> 2] = 175696680;
        n = d + 48 | 0;
        s[n >> 2] = 2021213740;
        s[n + 4 >> 2] = 1718526831;
        n = d + 56 | 0;
        s[n >> 2] = -1710760145;
        s[n + 4 >> 2] = 235567041;
        Ya(m, f, d);
        n = t + 256 | 0;
        v = m + 64 | 0;
        g = r;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = m + 128 | 0;
        g = n;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        id(b | 0, t | 0, 192) | 0;
        v = f;
        g = m;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = d;
        g = t;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        $a(o, f, d);
        v = f;
        g = r;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = d;
        g = b + 64 | 0;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        $a(h, f, d);
        v = f;
        g = n;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = d;
        g = b + 128 | 0;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        $a(l, f, d);
        v = o + 64 | 0;
        g = h;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = o + 128 | 0;
        g = l;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        id(m | 0, t | 0, 192) | 0;
        id(b | 0, r | 0, 192) | 0;
        v = f;
        g = t;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = d;
        g = r;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        $a(y, f, d);
        v = f;
        g = m + 64 | 0;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = d;
        g = b + 64 | 0;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        $a(h, f, d);
        v = f;
        g = m + 128 | 0;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = d;
        g = b + 128 | 0;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        $a(l, f, d);
        v = y + 64 | 0;
        g = h;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = y + 128 | 0;
        g = l;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        Ka(a, o, y);
        id(b | 0, u | 0, 192) | 0;
        v = f;
        g = a;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = d;
        g = u;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        Xa(i, f, d);
        v = f;
        g = a + 64 | 0;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = d;
        g = b + 64 | 0;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        Xa(h, f, d);
        v = f;
        g = a + 128 | 0;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = d;
        g = b + 128 | 0;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        Xa(l, f, d);
        a = i + 64 | 0;
        v = a;
        g = h;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        r = i + 128 | 0;
        v = r;
        g = l;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = f;
        g = u + 128 | 0;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        t = d;
        s[t >> 2] = 1091403767;
        s[t + 4 >> 2] = -167360562;
        t = d + 8 | 0;
        s[t >> 2] = -753151983;
        s[t + 4 >> 2] = 792555341;
        t = d + 16 | 0;
        s[t >> 2] = 960546513;
        s[t + 4 >> 2] = 692269950;
        t = d + 24 | 0;
        s[t >> 2] = -1478256553;
        s[t + 4 >> 2] = 496343272;
        t = d + 32 | 0;
        s[t >> 2] = -980480611;
        s[t + 4 >> 2] = -748862579;
        t = d + 40 | 0;
        s[t >> 2] = -171504835;
        s[t + 4 >> 2] = 175696680;
        t = d + 48 | 0;
        s[t >> 2] = 2021213740;
        s[t + 4 >> 2] = 1718526831;
        t = d + 56 | 0;
        s[t >> 2] = -1710760145;
        s[t + 4 >> 2] = 235567041;
        Ya(b, f, d);
        t = u + 64 | 0;
        v = b + 64 | 0;
        g = u;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = b + 128 | 0;
        g = t;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = f;
        g = i;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = d;
        g = b;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        Xa(c, f, d);
        v = f;
        g = a;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = d;
        g = u;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        Xa(h, f, d);
        v = f;
        g = r;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = d;
        g = t;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        Xa(l, f, d);
        v = c + 64 | 0;
        g = h;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = c + 128 | 0;
        g = l;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        id(m | 0, u | 0, 192) | 0;
        id(b | 0, u | 0, 192) | 0;
        v = f;
        g = m;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = d;
        g = u;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        $a(y, f, d);
        v = f;
        g = m + 64 | 0;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = d;
        g = b + 64 | 0;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        $a(h, f, d);
        v = f;
        g = m + 128 | 0;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = d;
        g = b + 128 | 0;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        $a(l, f, d);
        v = y + 64 | 0;
        g = h;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = y + 128 | 0;
        g = l;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        id(e | 0, c | 0, 192) | 0;
        id(e + 192 | 0, y | 0, 192) | 0;
        p = _;
        return;
      }

      function Va(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0;
        c = p;
        p = p + 16 | 0;
        o = c;
        i = e + 4 | 0;
        n = s[i >> 2] | 0;
        r = n * 192 | 0;

        if (n | 0) {
          t = n * 384 | 0;
          if ((t | 0) < 0) Kc(2072);
          t = Ht(s[e >> 2] | 0, r, 8, t, 8, o) | 0;

          if (!t) {
            a = o + 4 | 0;
            u = s[a >> 2] | 0;
            a = s[a + 4 >> 2] | 0;
            s[o >> 2] = s[o >> 2];
            r = o + 4 | 0;
            s[r >> 2] = u;
            s[r + 4 >> 2] = a;
            Vt(o);
          }

          r = t;
          o = e;
          u = n << 1;
          s[o >> 2] = r;
          s[i >> 2] = u;
          p = c;
          return;
        }

        Qa(o, 192, 8, 4);

        if ((s[o >> 2] | 0) == 1) {
          t = s[o + 4 >> 2] | 0;

          if (t | 0 ? (a = Gt(t, s[o + 8 >> 2] | 0, o) | 0, a | 0) : 0) {
            n = a;
            o = e;
            u = 4;
            s[o >> 2] = n;
            s[i >> 2] = u;
            p = c;
            return;
          }
        }

        s[o >> 2] = 1;
        s[o + 4 >> 2] = 6611;
        s[o + 8 >> 2] = 30;
        Vt(o);
      }

      function Ua(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0;
        y = p;
        p = p + 384 | 0;
        c = y + 320 | 0;
        d = y + 288 | 0;
        f = y + 256 | 0;
        l = y + 192 | 0;
        h = y + 128 | 0;
        n = y + 64 | 0;
        b = y;
        i = (a & 1 | 0) == 0;

        if (i) {
          m = b;
          r = t;
          o = m + 64 | 0;

          do {
            s[m >> 2] = s[r >> 2];
            m = m + 4 | 0;
            r = r + 4 | 0;
          } while ((m | 0) < (o | 0));

          m = l;
          r = t + 64 | 0;
          o = m + 64 | 0;

          do {
            s[m >> 2] = s[r >> 2];
            m = m + 4 | 0;
            r = r + 4 | 0;
          } while ((m | 0) < (o | 0));

          u = n;
        } else {
          s[b >> 2] = s[t >> 2];
          s[b + 4 >> 2] = s[t + 4 >> 2];
          s[b + 8 >> 2] = s[t + 8 >> 2];
          s[b + 12 >> 2] = s[t + 12 >> 2];
          s[b + 16 >> 2] = s[t + 16 >> 2];
          s[b + 20 >> 2] = s[t + 20 >> 2];
          s[b + 24 >> 2] = s[t + 24 >> 2];
          s[b + 28 >> 2] = s[t + 28 >> 2];
          u = t + 32 | 0;
          s[d >> 2] = s[u >> 2];
          s[d + 4 >> 2] = s[u + 4 >> 2];
          s[d + 8 >> 2] = s[u + 8 >> 2];
          s[d + 12 >> 2] = s[u + 12 >> 2];
          s[d + 16 >> 2] = s[u + 16 >> 2];
          s[d + 20 >> 2] = s[u + 20 >> 2];
          s[d + 24 >> 2] = s[u + 24 >> 2];
          s[d + 28 >> 2] = s[u + 28 >> 2];
          u = c;
          s[u >> 2] = 317583274;
          s[u + 4 >> 2] = 1757628553;
          u = c + 8 | 0;
          s[u >> 2] = 1923792719;
          s[u + 4 >> 2] = -1928822936;
          u = c + 16 | 0;
          s[u >> 2] = 151523889;
          s[u + 4 >> 2] = 1373741639;
          u = c + 24 | 0;
          s[u >> 2] = 1193918714;
          s[u + 4 >> 2] = 576313009;
          ka(d, c, 136, -460954743, -2016278654);
          s[f >> 2] = s[d >> 2];
          s[f + 4 >> 2] = s[d + 4 >> 2];
          s[f + 8 >> 2] = s[d + 8 >> 2];
          s[f + 12 >> 2] = s[d + 12 >> 2];
          s[f + 16 >> 2] = s[d + 16 >> 2];
          s[f + 20 >> 2] = s[d + 20 >> 2];
          s[f + 24 >> 2] = s[d + 24 >> 2];
          s[f + 28 >> 2] = s[d + 28 >> 2];
          u = b + 32 | 0;
          s[u >> 2] = s[f >> 2];
          s[u + 4 >> 2] = s[f + 4 >> 2];
          s[u + 8 >> 2] = s[f + 8 >> 2];
          s[u + 12 >> 2] = s[f + 12 >> 2];
          s[u + 16 >> 2] = s[f + 16 >> 2];
          s[u + 20 >> 2] = s[f + 20 >> 2];
          s[u + 24 >> 2] = s[f + 24 >> 2];
          s[u + 28 >> 2] = s[f + 28 >> 2];
          u = t + 64 | 0;
          s[l >> 2] = s[u >> 2];
          s[l + 4 >> 2] = s[u + 4 >> 2];
          s[l + 8 >> 2] = s[u + 8 >> 2];
          s[l + 12 >> 2] = s[u + 12 >> 2];
          s[l + 16 >> 2] = s[u + 16 >> 2];
          s[l + 20 >> 2] = s[u + 20 >> 2];
          s[l + 24 >> 2] = s[u + 24 >> 2];
          s[l + 28 >> 2] = s[u + 28 >> 2];
          u = t + 96 | 0;
          s[d >> 2] = s[u >> 2];
          s[d + 4 >> 2] = s[u + 4 >> 2];
          s[d + 8 >> 2] = s[u + 8 >> 2];
          s[d + 12 >> 2] = s[u + 12 >> 2];
          s[d + 16 >> 2] = s[u + 16 >> 2];
          s[d + 20 >> 2] = s[u + 20 >> 2];
          s[d + 24 >> 2] = s[u + 24 >> 2];
          s[d + 28 >> 2] = s[u + 28 >> 2];
          u = c;
          s[u >> 2] = 317583274;
          s[u + 4 >> 2] = 1757628553;
          u = c + 8 | 0;
          s[u >> 2] = 1923792719;
          s[u + 4 >> 2] = -1928822936;
          u = c + 16 | 0;
          s[u >> 2] = 151523889;
          s[u + 4 >> 2] = 1373741639;
          u = c + 24 | 0;
          s[u >> 2] = 1193918714;
          s[u + 4 >> 2] = 576313009;
          ka(d, c, 136, -460954743, -2016278654);
          s[f >> 2] = s[d >> 2];
          s[f + 4 >> 2] = s[d + 4 >> 2];
          s[f + 8 >> 2] = s[d + 8 >> 2];
          s[f + 12 >> 2] = s[d + 12 >> 2];
          s[f + 16 >> 2] = s[d + 16 >> 2];
          s[f + 20 >> 2] = s[d + 20 >> 2];
          s[f + 24 >> 2] = s[d + 24 >> 2];
          s[f + 28 >> 2] = s[d + 28 >> 2];
          u = l + 32 | 0;
          s[u >> 2] = s[f >> 2];
          s[u + 4 >> 2] = s[f + 4 >> 2];
          s[u + 8 >> 2] = s[f + 8 >> 2];
          s[u + 12 >> 2] = s[f + 12 >> 2];
          s[u + 16 >> 2] = s[f + 16 >> 2];
          s[u + 20 >> 2] = s[f + 20 >> 2];
          s[u + 24 >> 2] = s[f + 24 >> 2];
          s[u + 28 >> 2] = s[f + 28 >> 2];
          u = n;
        }

        a = ((a >>> 0) % 6 | 0) & 255;

        switch (a & 7) {
          case 0:
            {
              m = c;
              s[m >> 2] = -980480611;
              s[m + 4 >> 2] = -748862579;
              m = c + 8 | 0;
              s[m >> 2] = -171504835;
              s[m + 4 >> 2] = 175696680;
              m = c + 16 | 0;
              s[m >> 2] = 2021213740;
              s[m + 4 >> 2] = 1718526831;
              m = c + 24 | 0;
              s[m >> 2] = -1710760145;
              s[m + 4 >> 2] = 235567041;
              m = c + 32 | 0;
              s[m >> 2] = 0;
              s[m + 4 >> 2] = 0;
              s[m + 8 >> 2] = 0;
              s[m + 12 >> 2] = 0;
              s[m + 16 >> 2] = 0;
              s[m + 20 >> 2] = 0;
              s[m + 24 >> 2] = 0;
              s[m + 28 >> 2] = 0;
              break;
            }

          case 1:
            {
              m = c;
              s[m >> 2] = 1164159792;
              s[m + 4 >> 2] = -1250477296;
              m = c + 8 | 0;
              s[m >> 2] = -1448450988;
              s[m + 4 >> 2] = 880775624;
              m = c + 16 | 0;
              s[m >> 2] = 606996881;
              s[m + 4 >> 2] = 2046849319;
              m = c + 24 | 0;
              s[m >> 2] = 293737708;
              s[m + 4 >> 2] = 425114840;
              m = c + 32 | 0;
              s[m >> 2] = -1599453353;
              s[m + 4 >> 2] = 1854185246;
              m = c + 40 | 0;
              s[m >> 2] = -1980198591;
              s[m + 4 >> 2] = -1440973971;
              m = c + 48 | 0;
              s[m >> 2] = -85931462;
              s[m + 4 >> 2] = -1226370099;
              m = c + 56 | 0;
              s[m >> 2] = 1317202883;
              s[m + 4 >> 2] = 644435899;
              break;
            }

          case 2:
            {
              m = c;
              s[m >> 2] = 333974428;
              s[m + 4 >> 2] = 860932238;
              m = c + 8 | 0;
              s[m >> 2] = -614574407;
              s[m + 4 >> 2] = 2110674300;
              m = c + 16 | 0;
              s[m >> 2] = -1240115638;
              s[m + 4 >> 2] = 1610724536;
              m = c + 24 | 0;
              s[m >> 2] = 33691616;
              s[m + 4 >> 2] = 646112791;
              m = c + 32 | 0;
              s[m >> 2] = 0;
              s[m + 4 >> 2] = 0;
              s[m + 8 >> 2] = 0;
              s[m + 12 >> 2] = 0;
              s[m + 16 >> 2] = 0;
              s[m + 20 >> 2] = 0;
              s[m + 24 >> 2] = 0;
              s[m + 28 >> 2] = 0;
              break;
            }

          case 3:
            {
              m = c;
              s[m >> 2] = 380464045;
              s[m + 4 >> 2] = -911269129;
              m = c + 8 | 0;
              s[m >> 2] = 1252418226;
              s[m + 4 >> 2] = -1290700758;
              m = c + 16 | 0;
              s[m >> 2] = -498546700;
              s[m + 4 >> 2] = 435072868;
              m = c + 24 | 0;
              s[m >> 2] = -482107518;
              s[m + 4 >> 2] = 539442807;
              m = c + 32 | 0;
              s[m >> 2] = -137456724;
              s[m + 4 >> 2] = -1396692896;
              m = c + 40 | 0;
              s[m >> 2] = 2074569548;
              s[m + 4 >> 2] = 959698305;
              m = c + 48 | 0;
              s[m >> 2] = 1147962471;
              s[m + 4 >> 2] = 1776687243;
              m = c + 56 | 0;
              s[m >> 2] = 1142410325;
              s[m + 4 >> 2] = 172360557;
              break;
            }

          default:
            tr(6441, 19, 2096);
        }

        Ya(n, l, c);
        r = t + 128 | 0;

        if (i) {
          m = l;
          o = m + 64 | 0;

          do {
            s[m >> 2] = s[r >> 2];
            m = m + 4 | 0;
            r = r + 4 | 0;
          } while ((m | 0) < (o | 0));
        } else {
          s[l >> 2] = s[r >> 2];
          s[l + 4 >> 2] = s[r + 4 >> 2];
          s[l + 8 >> 2] = s[r + 8 >> 2];
          s[l + 12 >> 2] = s[r + 12 >> 2];
          s[l + 16 >> 2] = s[r + 16 >> 2];
          s[l + 20 >> 2] = s[r + 20 >> 2];
          s[l + 24 >> 2] = s[r + 24 >> 2];
          s[l + 28 >> 2] = s[r + 28 >> 2];
          m = t + 160 | 0;
          s[d >> 2] = s[m >> 2];
          s[d + 4 >> 2] = s[m + 4 >> 2];
          s[d + 8 >> 2] = s[m + 8 >> 2];
          s[d + 12 >> 2] = s[m + 12 >> 2];
          s[d + 16 >> 2] = s[m + 16 >> 2];
          s[d + 20 >> 2] = s[m + 20 >> 2];
          s[d + 24 >> 2] = s[m + 24 >> 2];
          s[d + 28 >> 2] = s[m + 28 >> 2];
          m = c;
          s[m >> 2] = 317583274;
          s[m + 4 >> 2] = 1757628553;
          m = c + 8 | 0;
          s[m >> 2] = 1923792719;
          s[m + 4 >> 2] = -1928822936;
          m = c + 16 | 0;
          s[m >> 2] = 151523889;
          s[m + 4 >> 2] = 1373741639;
          m = c + 24 | 0;
          s[m >> 2] = 1193918714;
          s[m + 4 >> 2] = 576313009;
          ka(d, c, 136, -460954743, -2016278654);
          s[f >> 2] = s[d >> 2];
          s[f + 4 >> 2] = s[d + 4 >> 2];
          s[f + 8 >> 2] = s[d + 8 >> 2];
          s[f + 12 >> 2] = s[d + 12 >> 2];
          s[f + 16 >> 2] = s[d + 16 >> 2];
          s[f + 20 >> 2] = s[d + 20 >> 2];
          s[f + 24 >> 2] = s[d + 24 >> 2];
          s[f + 28 >> 2] = s[d + 28 >> 2];
          m = l + 32 | 0;
          s[m >> 2] = s[f >> 2];
          s[m + 4 >> 2] = s[f + 4 >> 2];
          s[m + 8 >> 2] = s[f + 8 >> 2];
          s[m + 12 >> 2] = s[f + 12 >> 2];
          s[m + 16 >> 2] = s[f + 16 >> 2];
          s[m + 20 >> 2] = s[f + 20 >> 2];
          s[m + 24 >> 2] = s[f + 24 >> 2];
          s[m + 28 >> 2] = s[f + 28 >> 2];
        }

        switch (a & 7) {
          case 0:
            {
              m = c;
              s[m >> 2] = -980480611;
              s[m + 4 >> 2] = -748862579;
              m = c + 8 | 0;
              s[m >> 2] = -171504835;
              s[m + 4 >> 2] = 175696680;
              m = c + 16 | 0;
              s[m >> 2] = 2021213740;
              s[m + 4 >> 2] = 1718526831;
              m = c + 24 | 0;
              s[m >> 2] = -1710760145;
              s[m + 4 >> 2] = 235567041;
              m = c + 32 | 0;
              s[m >> 2] = 0;
              s[m + 4 >> 2] = 0;
              s[m + 8 >> 2] = 0;
              s[m + 12 >> 2] = 0;
              s[m + 16 >> 2] = 0;
              s[m + 20 >> 2] = 0;
              s[m + 24 >> 2] = 0;
              s[m + 28 >> 2] = 0;
              Ya(h, l, c);
              m = e;
              r = b;
              o = m + 64 | 0;

              do {
                s[m >> 2] = s[r >> 2];
                m = m + 4 | 0;
                r = r + 4 | 0;
              } while ((m | 0) < (o | 0));

              m = e + 64 | 0;
              r = u;
              o = m + 64 | 0;

              do {
                s[m >> 2] = s[r >> 2];
                m = m + 4 | 0;
                r = r + 4 | 0;
              } while ((m | 0) < (o | 0));

              m = e + 128 | 0;
              r = h;
              o = m + 64 | 0;

              do {
                s[m >> 2] = s[r >> 2];
                m = m + 4 | 0;
                r = r + 4 | 0;
              } while ((m | 0) < (o | 0));

              p = y;
              return;
            }

          case 1:
            {
              m = c;
              s[m >> 2] = -2076524910;
              s[m + 4 >> 2] = 1935791999;
              m = c + 8 | 0;
              s[m >> 2] = 657723899;
              s[m + 4 >> 2] = -1514460205;
              m = c + 16 | 0;
              s[m >> 2] = 1262363545;
              s[m + 4 >> 2] = -1668014287;
              m = c + 24 | 0;
              s[m >> 2] = -1147153428;
              s[m + 4 >> 2] = 366976221;
              m = c + 32 | 0;
              s[m >> 2] = 1272498505;
              s[m + 4 >> 2] = 1574829333;
              m = c + 40 | 0;
              s[m >> 2] = -1539024032;
              s[m + 4 >> 2] = 1657481637;
              m = c + 48 | 0;
              s[m >> 2] = 209572537;
              s[m + 4 >> 2] = 935102218;
              m = c + 56 | 0;
              s[m >> 2] = 829550845;
              s[m + 4 >> 2] = 612567709;
              Ya(h, l, c);
              m = e;
              r = b;
              o = m + 64 | 0;

              do {
                s[m >> 2] = s[r >> 2];
                m = m + 4 | 0;
                r = r + 4 | 0;
              } while ((m | 0) < (o | 0));

              m = e + 64 | 0;
              r = u;
              o = m + 64 | 0;

              do {
                s[m >> 2] = s[r >> 2];
                m = m + 4 | 0;
                r = r + 4 | 0;
              } while ((m | 0) < (o | 0));

              m = e + 128 | 0;
              r = h;
              o = m + 64 | 0;

              do {
                s[m >> 2] = s[r >> 2];
                m = m + 4 | 0;
                r = r + 4 | 0;
              } while ((m | 0) < (o | 0));

              p = y;
              return;
            }

          case 2:
            {
              m = c;
              s[m >> 2] = -679288491;
              s[m + 4 >> 2] = 1905462289;
              m = c + 8 | 0;
              s[m >> 2] = -4312285;
              s[m + 4 >> 2] = -1497656196;
              m = c + 16 | 0;
              s[m >> 2] = -730590140;
              s[m + 4 >> 2] = -1439681724;
              m = c + 24 | 0;
              s[m >> 2] = 643385667;
              s[m + 4 >> 2] = 742080269;
              m = c + 32 | 0;
              s[m >> 2] = 0;
              s[m + 4 >> 2] = 0;
              s[m + 8 >> 2] = 0;
              s[m + 12 >> 2] = 0;
              s[m + 16 >> 2] = 0;
              s[m + 20 >> 2] = 0;
              s[m + 24 >> 2] = 0;
              s[m + 28 >> 2] = 0;
              Ya(h, l, c);
              m = e;
              r = b;
              o = m + 64 | 0;

              do {
                s[m >> 2] = s[r >> 2];
                m = m + 4 | 0;
                r = r + 4 | 0;
              } while ((m | 0) < (o | 0));

              m = e + 64 | 0;
              r = u;
              o = m + 64 | 0;

              do {
                s[m >> 2] = s[r >> 2];
                m = m + 4 | 0;
                r = r + 4 | 0;
              } while ((m | 0) < (o | 0));

              m = e + 128 | 0;
              r = h;
              o = m + 64 | 0;

              do {
                s[m >> 2] = s[r >> 2];
                m = m + 4 | 0;
                r = r + 4 | 0;
              } while ((m | 0) < (o | 0));

              p = y;
              return;
            }

          case 3:
            {
              m = c;
              s[m >> 2] = 2070373087;
              s[m + 4 >> 2] = 1149932453;
              m = c + 8 | 0;
              s[m >> 2] = 687729375;
              s[m + 4 >> 2] = -1076482571;
              m = c + 16 | 0;
              s[m >> 2] = 245093498;
              s[m + 4 >> 2] = -665258544;
              m = c + 24 | 0;
              s[m >> 2] = 880208984;
              s[m + 4 >> 2] = 112213325;
              m = c + 32 | 0;
              s[m >> 2] = -1127663919;
              s[m + 4 >> 2] = 723114740;
              m = c + 40 | 0;
              s[m >> 2] = 1458842015;
              s[m + 4 >> 2] = -1583001990;
              m = c + 48 | 0;
              s[m >> 2] = 1524543217;
              s[m + 4 >> 2] = -1254887712;
              m = c + 56 | 0;
              s[m >> 2] = -2065850190;
              s[m + 4 >> 2] = 386695467;
              Ya(h, l, c);
              m = e;
              r = b;
              o = m + 64 | 0;

              do {
                s[m >> 2] = s[r >> 2];
                m = m + 4 | 0;
                r = r + 4 | 0;
              } while ((m | 0) < (o | 0));

              m = e + 64 | 0;
              r = u;
              o = m + 64 | 0;

              do {
                s[m >> 2] = s[r >> 2];
                m = m + 4 | 0;
                r = r + 4 | 0;
              } while ((m | 0) < (o | 0));

              m = e + 128 | 0;
              r = h;
              o = m + 64 | 0;

              do {
                s[m >> 2] = s[r >> 2];
                m = m + 4 | 0;
                r = r + 4 | 0;
              } while ((m | 0) < (o | 0));

              p = y;
              return;
            }

          default:
            tr(6441, 19, 2112);
        }
      }

      function Ha(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0,
            A = 0,
            w = 0,
            T = 0;
        A = p;
        p = p + 960 | 0;
        f = A + 896 | 0;
        l = A + 832 | 0;
        h = A + 768 | 0;
        b = A + 704 | 0;
        m = A + 640 | 0;
        y = A + 576 | 0;
        v = A + 512 | 0;
        _ = A + 448 | 0;
        r = A + 384 | 0;
        n = A + 320 | 0;
        o = A + 256 | 0;
        i = A + 192 | 0;
        c = A + 128 | 0;
        a = A + 64 | 0;
        u = A;
        Za(u, t);
        g = l;
        w = t;
        T = g + 64 | 0;

        do {
          s[g >> 2] = s[w >> 2];
          g = g + 4 | 0;
          w = w + 4 | 0;
        } while ((g | 0) < (T | 0));

        d = t + 64 | 0;
        g = f;
        w = d;
        T = g + 64 | 0;

        do {
          s[g >> 2] = s[w >> 2];
          g = g + 4 | 0;
          w = w + 4 | 0;
        } while ((g | 0) < (T | 0));

        Ya(a, l, f);
        g = l;
        w = a;
        T = g + 64 | 0;

        do {
          s[g >> 2] = s[w >> 2];
          g = g + 4 | 0;
          w = w + 4 | 0;
        } while ((g | 0) < (T | 0));

        g = f;
        w = a;
        T = g + 64 | 0;

        do {
          s[g >> 2] = s[w >> 2];
          g = g + 4 | 0;
          w = w + 4 | 0;
        } while ((g | 0) < (T | 0));

        $a(c, l, f);
        g = l;
        w = t;
        T = g + 64 | 0;

        do {
          s[g >> 2] = s[w >> 2];
          g = g + 4 | 0;
          w = w + 4 | 0;
        } while ((g | 0) < (T | 0));

        g = f;
        w = d;
        T = g + 64 | 0;

        do {
          s[g >> 2] = s[w >> 2];
          g = g + 4 | 0;
          w = w + 4 | 0;
        } while ((g | 0) < (T | 0));

        Xa(h, l, f);
        t = t + 128 | 0;
        g = f;
        w = t;
        T = g + 64 | 0;

        do {
          s[g >> 2] = s[w >> 2];
          g = g + 4 | 0;
          w = w + 4 | 0;
        } while ((g | 0) < (T | 0));

        $a(b, h, f);
        Za(i, b);
        g = l;
        w = d;
        T = g + 64 | 0;

        do {
          s[g >> 2] = s[w >> 2];
          g = g + 4 | 0;
          w = w + 4 | 0;
        } while ((g | 0) < (T | 0));

        g = f;
        w = t;
        T = g + 64 | 0;

        do {
          s[g >> 2] = s[w >> 2];
          g = g + 4 | 0;
          w = w + 4 | 0;
        } while ((g | 0) < (T | 0));

        Ya(o, l, f);
        g = l;
        w = o;
        T = g + 64 | 0;

        do {
          s[g >> 2] = s[w >> 2];
          g = g + 4 | 0;
          w = w + 4 | 0;
        } while ((g | 0) < (T | 0));

        g = f;
        w = o;
        T = g + 64 | 0;

        do {
          s[g >> 2] = s[w >> 2];
          g = g + 4 | 0;
          w = w + 4 | 0;
        } while ((g | 0) < (T | 0));

        $a(n, l, f);
        Za(r, t);
        g = b;
        w = u;
        T = g + 64 | 0;

        do {
          s[g >> 2] = s[w >> 2];
          g = g + 4 | 0;
          w = w + 4 | 0;
        } while ((g | 0) < (T | 0));

        g = l;
        w = n;
        T = g + 64 | 0;

        do {
          s[g >> 2] = s[w >> 2];
          g = g + 4 | 0;
          w = w + 4 | 0;
        } while ((g | 0) < (T | 0));

        g = f;
        s[g >> 2] = 1091403767;
        s[g + 4 >> 2] = -167360562;
        g = f + 8 | 0;
        s[g >> 2] = -753151983;
        s[g + 4 >> 2] = 792555341;
        g = f + 16 | 0;
        s[g >> 2] = 960546513;
        s[g + 4 >> 2] = 692269950;
        g = f + 24 | 0;
        s[g >> 2] = -1478256553;
        s[g + 4 >> 2] = 496343272;
        g = f + 32 | 0;
        s[g >> 2] = -980480611;
        s[g + 4 >> 2] = -748862579;
        g = f + 40 | 0;
        s[g >> 2] = -171504835;
        s[g + 4 >> 2] = 175696680;
        g = f + 48 | 0;
        s[g >> 2] = 2021213740;
        s[g + 4 >> 2] = 1718526831;
        g = f + 56 | 0;
        s[g >> 2] = -1710760145;
        s[g + 4 >> 2] = 235567041;
        Ya(h, l, f);
        $a(_, b, h);
        g = b;
        w = c;
        T = g + 64 | 0;

        do {
          s[g >> 2] = s[w >> 2];
          g = g + 4 | 0;
          w = w + 4 | 0;
        } while ((g | 0) < (T | 0));

        g = l;
        w = r;
        T = g + 64 | 0;

        do {
          s[g >> 2] = s[w >> 2];
          g = g + 4 | 0;
          w = w + 4 | 0;
        } while ((g | 0) < (T | 0));

        g = f;
        s[g >> 2] = 1091403767;
        s[g + 4 >> 2] = -167360562;
        g = f + 8 | 0;
        s[g >> 2] = -753151983;
        s[g + 4 >> 2] = 792555341;
        g = f + 16 | 0;
        s[g >> 2] = 960546513;
        s[g + 4 >> 2] = 692269950;
        g = f + 24 | 0;
        s[g >> 2] = -1478256553;
        s[g + 4 >> 2] = 496343272;
        g = f + 32 | 0;
        s[g >> 2] = -980480611;
        s[g + 4 >> 2] = -748862579;
        g = f + 40 | 0;
        s[g >> 2] = -171504835;
        s[g + 4 >> 2] = 175696680;
        g = f + 48 | 0;
        s[g >> 2] = 2021213740;
        s[g + 4 >> 2] = 1718526831;
        g = f + 56 | 0;
        s[g >> 2] = -1710760145;
        s[g + 4 >> 2] = 235567041;
        Ya(h, l, f);
        $a(v, b, h);
        g = l;
        w = c;
        T = g + 64 | 0;

        do {
          s[g >> 2] = s[w >> 2];
          g = g + 4 | 0;
          w = w + 4 | 0;
        } while ((g | 0) < (T | 0));

        g = f;
        w = i;
        T = g + 64 | 0;

        do {
          s[g >> 2] = s[w >> 2];
          g = g + 4 | 0;
          w = w + 4 | 0;
        } while ((g | 0) < (T | 0));

        $a(h, l, f);
        g = f;
        w = n;
        T = g + 64 | 0;

        do {
          s[g >> 2] = s[w >> 2];
          g = g + 4 | 0;
          w = w + 4 | 0;
        } while ((g | 0) < (T | 0));

        $a(b, h, f);
        g = f;
        w = u;
        T = g + 64 | 0;

        do {
          s[g >> 2] = s[w >> 2];
          g = g + 4 | 0;
          w = w + 4 | 0;
        } while ((g | 0) < (T | 0));

        Xa(m, b, f);
        g = f;
        w = r;
        T = g + 64 | 0;

        do {
          s[g >> 2] = s[w >> 2];
          g = g + 4 | 0;
          w = w + 4 | 0;
        } while ((g | 0) < (T | 0));

        Xa(y, m, f);
        g = e;
        w = _;
        T = g + 64 | 0;

        do {
          s[g >> 2] = s[w >> 2];
          g = g + 4 | 0;
          w = w + 4 | 0;
        } while ((g | 0) < (T | 0));

        g = e + 64 | 0;
        w = v;
        T = g + 64 | 0;

        do {
          s[g >> 2] = s[w >> 2];
          g = g + 4 | 0;
          w = w + 4 | 0;
        } while ((g | 0) < (T | 0));

        g = e + 128 | 0;
        w = y;
        T = g + 64 | 0;

        do {
          s[g >> 2] = s[w >> 2];
          g = g + 4 | 0;
          w = w + 4 | 0;
        } while ((g | 0) < (T | 0));

        p = A;
        return;
      }

      function za(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0,
            A = 0;
        _ = p;
        p = p + 912 | 0;
        f = _ + 840 | 0;
        l = _ + 776 | 0;
        h = _ + 712 | 0;
        b = _ + 648 | 0;
        m = _ + 456 | 0;
        y = _ + 392 | 0;
        o = _ + 328 | 0;
        i = _ + 264 | 0;
        a = _ + 192 | 0;
        c = _ + 128 | 0;
        u = _ + 64 | 0;
        d = _;
        Za(o, t);
        r = t + 64 | 0;
        v = b;
        g = r;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        n = t + 128 | 0;
        v = l;
        g = n;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = f;
        s[v >> 2] = 1091403767;
        s[v + 4 >> 2] = -167360562;
        v = f + 8 | 0;
        s[v >> 2] = -753151983;
        s[v + 4 >> 2] = 792555341;
        v = f + 16 | 0;
        s[v >> 2] = 960546513;
        s[v + 4 >> 2] = 692269950;
        v = f + 24 | 0;
        s[v >> 2] = -1478256553;
        s[v + 4 >> 2] = 496343272;
        v = f + 32 | 0;
        s[v >> 2] = -980480611;
        s[v + 4 >> 2] = -748862579;
        v = f + 40 | 0;
        s[v >> 2] = -171504835;
        s[v + 4 >> 2] = 175696680;
        v = f + 48 | 0;
        s[v >> 2] = 2021213740;
        s[v + 4 >> 2] = 1718526831;
        v = f + 56 | 0;
        s[v >> 2] = -1710760145;
        s[v + 4 >> 2] = 235567041;
        Ya(h, l, f);
        Ya(m, b, h);
        Xa(d, o, m);
        Za(b, n);
        v = l;
        g = b;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = f;
        s[v >> 2] = 1091403767;
        s[v + 4 >> 2] = -167360562;
        v = f + 8 | 0;
        s[v >> 2] = -753151983;
        s[v + 4 >> 2] = 792555341;
        v = f + 16 | 0;
        s[v >> 2] = 960546513;
        s[v + 4 >> 2] = 692269950;
        v = f + 24 | 0;
        s[v >> 2] = -1478256553;
        s[v + 4 >> 2] = 496343272;
        v = f + 32 | 0;
        s[v >> 2] = -980480611;
        s[v + 4 >> 2] = -748862579;
        v = f + 40 | 0;
        s[v >> 2] = -171504835;
        s[v + 4 >> 2] = 175696680;
        v = f + 48 | 0;
        s[v >> 2] = 2021213740;
        s[v + 4 >> 2] = 1718526831;
        v = f + 56 | 0;
        s[v >> 2] = -1710760145;
        s[v + 4 >> 2] = 235567041;
        Ya(m, l, f);
        v = l;
        g = t;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = f;
        g = r;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        Ya(h, l, f);
        Xa(u, m, h);
        Za(b, r);
        v = l;
        g = t;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = f;
        g = n;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        Ya(h, l, f);
        Xa(c, b, h);
        v = l;
        g = n;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = f;
        g = u;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        Ya(b, l, f);
        v = l;
        g = r;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = f;
        g = c;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        Ya(h, l, f);
        $a(o, b, h);
        v = l;
        g = o;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = f;
        s[v >> 2] = 1091403767;
        s[v + 4 >> 2] = -167360562;
        v = f + 8 | 0;
        s[v >> 2] = -753151983;
        s[v + 4 >> 2] = 792555341;
        v = f + 16 | 0;
        s[v >> 2] = 960546513;
        s[v + 4 >> 2] = 692269950;
        v = f + 24 | 0;
        s[v >> 2] = -1478256553;
        s[v + 4 >> 2] = 496343272;
        v = f + 32 | 0;
        s[v >> 2] = -980480611;
        s[v + 4 >> 2] = -748862579;
        v = f + 40 | 0;
        s[v >> 2] = -171504835;
        s[v + 4 >> 2] = 175696680;
        v = f + 48 | 0;
        s[v >> 2] = 2021213740;
        s[v + 4 >> 2] = 1718526831;
        v = f + 56 | 0;
        s[v >> 2] = -1710760145;
        s[v + 4 >> 2] = 235567041;
        Ya(m, l, f);
        v = l;
        g = t;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = f;
        g = d;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        Ya(h, l, f);
        $a(i, m, h);
        Ja(a, i);
        A = a;

        if (!((s[A >> 2] | 0) == 1 & (s[A + 4 >> 2] | 0) == 0)) {
          y = 0;
          g = 0;
          A = e;
          v = A;
          s[v >> 2] = y;
          A = A + 4 | 0;
          s[A >> 2] = g;
          p = _;
          return;
        }

        t = a + 8 | 0;
        v = y;
        g = t;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = l;
        g = t;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = f;
        g = d;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        Ya(m, l, f);
        v = l;
        g = y;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = f;
        g = u;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        Ya(b, l, f);
        v = l;
        g = y;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = f;
        g = c;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        Ya(h, l, f);
        v = m + 64 | 0;
        g = b;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        v = m + 128 | 0;
        g = h;
        A = v + 64 | 0;

        do {
          s[v >> 2] = s[g >> 2];
          v = v + 4 | 0;
          g = g + 4 | 0;
        } while ((v | 0) < (A | 0));

        id(e + 8 | 0, m | 0, 192) | 0;
        y = 1;
        g = 0;
        A = e;
        v = A;
        s[v >> 2] = y;
        A = A + 4 | 0;
        s[A >> 2] = g;
        p = _;
        return;
      }

      function Ka(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0,
            A = 0,
            w = 0,
            T = 0,
            x = 0,
            D = 0,
            C = 0;
        x = p;
        p = p + 896 | 0;
        m = x + 832 | 0;
        y = x + 768 | 0;
        v = x + 704 | 0;
        _ = x + 640 | 0;
        g = x + 576 | 0;
        A = x + 512 | 0;
        w = x + 448 | 0;
        r = x + 384 | 0;
        n = x + 320 | 0;
        o = x + 256 | 0;
        i = x + 192 | 0;
        c = x + 128 | 0;
        u = x + 64 | 0;
        d = x;
        T = y;
        D = t;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        T = m;
        D = a;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        Ya(d, y, m);
        f = t + 64 | 0;
        T = y;
        D = f;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        l = a + 64 | 0;
        T = m;
        D = l;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        Ya(u, y, m);
        h = t + 128 | 0;
        T = y;
        D = h;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        b = a + 128 | 0;
        T = m;
        D = b;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        Ya(c, y, m);
        T = y;
        D = f;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        T = m;
        D = h;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        $a(_, y, m);
        T = y;
        D = l;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        T = m;
        D = b;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        $a(v, y, m);
        Ya(g, _, v);
        T = m;
        D = u;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        Xa(A, g, m);
        T = m;
        D = c;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        Xa(o, A, m);
        T = y;
        D = o;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        T = m;
        s[T >> 2] = 1091403767;
        s[T + 4 >> 2] = -167360562;
        T = m + 8 | 0;
        s[T >> 2] = -753151983;
        s[T + 4 >> 2] = 792555341;
        T = m + 16 | 0;
        s[T >> 2] = 960546513;
        s[T + 4 >> 2] = 692269950;
        T = m + 24 | 0;
        s[T >> 2] = -1478256553;
        s[T + 4 >> 2] = 496343272;
        T = m + 32 | 0;
        s[T >> 2] = -980480611;
        s[T + 4 >> 2] = -748862579;
        T = m + 40 | 0;
        s[T >> 2] = -171504835;
        s[T + 4 >> 2] = 175696680;
        T = m + 48 | 0;
        s[T >> 2] = 2021213740;
        s[T + 4 >> 2] = 1718526831;
        T = m + 56 | 0;
        s[T >> 2] = -1710760145;
        s[T + 4 >> 2] = 235567041;
        Ya(w, y, m);
        T = m;
        D = d;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        $a(i, w, m);
        T = y;
        D = t;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        T = m;
        D = f;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        $a(_, y, m);
        T = y;
        D = a;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        T = m;
        D = l;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        $a(v, y, m);
        Ya(g, _, v);
        T = m;
        D = d;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        Xa(A, g, m);
        T = m;
        D = u;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        Xa(w, A, m);
        T = y;
        D = c;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        T = m;
        s[T >> 2] = 1091403767;
        s[T + 4 >> 2] = -167360562;
        T = m + 8 | 0;
        s[T >> 2] = -753151983;
        s[T + 4 >> 2] = 792555341;
        T = m + 16 | 0;
        s[T >> 2] = 960546513;
        s[T + 4 >> 2] = 692269950;
        T = m + 24 | 0;
        s[T >> 2] = -1478256553;
        s[T + 4 >> 2] = 496343272;
        T = m + 32 | 0;
        s[T >> 2] = -980480611;
        s[T + 4 >> 2] = -748862579;
        T = m + 40 | 0;
        s[T >> 2] = -171504835;
        s[T + 4 >> 2] = 175696680;
        T = m + 48 | 0;
        s[T >> 2] = 2021213740;
        s[T + 4 >> 2] = 1718526831;
        T = m + 56 | 0;
        s[T >> 2] = -1710760145;
        s[T + 4 >> 2] = 235567041;
        Ya(v, y, m);
        $a(n, w, v);
        T = y;
        D = t;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        T = m;
        D = h;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        $a(_, y, m);
        T = y;
        D = a;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        T = m;
        D = b;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        $a(v, y, m);
        Ya(g, _, v);
        T = m;
        D = d;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        Xa(A, g, m);
        T = m;
        D = u;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        $a(w, A, m);
        T = m;
        D = c;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        Xa(r, w, m);
        T = e;
        D = i;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        T = e + 64 | 0;
        D = n;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        T = e + 128 | 0;
        D = r;
        C = T + 64 | 0;

        do {
          s[T >> 2] = s[D >> 2];
          T = T + 4 | 0;
          D = D + 4 | 0;
        } while ((T | 0) < (C | 0));

        p = x;
        return;
      }

      function qa(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0;
        l = p;
        p = p + 352 | 0;
        r = l + 320 | 0;
        n = l + 288 | 0;
        o = l + 256 | 0;
        i = l + 192 | 0;
        c = l + 128 | 0;
        u = l + 64 | 0;
        d = l;
        f = i;
        h = t;
        b = f + 64 | 0;

        do {
          s[f >> 2] = s[h >> 2];
          f = f + 4 | 0;
          h = h + 4 | 0;
        } while ((f | 0) < (b | 0));

        s[n >> 2] = s[t >> 2];
        s[n + 4 >> 2] = s[t + 4 >> 2];
        s[n + 8 >> 2] = s[t + 8 >> 2];
        s[n + 12 >> 2] = s[t + 12 >> 2];
        s[n + 16 >> 2] = s[t + 16 >> 2];
        s[n + 20 >> 2] = s[t + 20 >> 2];
        s[n + 24 >> 2] = s[t + 24 >> 2];
        s[n + 28 >> 2] = s[t + 28 >> 2];
        s[r >> 2] = 0;
        s[r + 4 >> 2] = 0;
        s[r + 8 >> 2] = 0;
        s[r + 12 >> 2] = 0;
        s[r + 16 >> 2] = 0;
        s[r + 20 >> 2] = 0;
        s[r + 24 >> 2] = 0;
        s[r + 28 >> 2] = 0;

        if ((Ca(n, r) | 0) << 24 >> 24 == 1) {
          s[r >> 2] = s[34];
          s[r + 4 >> 2] = s[35];
          s[r + 8 >> 2] = s[36];
          s[r + 12 >> 2] = s[37];
          s[r + 16 >> 2] = s[38];
          s[r + 20 >> 2] = s[39];
          s[r + 24 >> 2] = s[40];
          s[r + 28 >> 2] = s[41];
          Ia(r, n);
          s[n >> 2] = s[r >> 2];
          s[n + 4 >> 2] = s[r + 4 >> 2];
          s[n + 8 >> 2] = s[r + 8 >> 2];
          s[n + 12 >> 2] = s[r + 12 >> 2];
          s[n + 16 >> 2] = s[r + 16 >> 2];
          s[n + 20 >> 2] = s[r + 20 >> 2];
          s[n + 24 >> 2] = s[r + 24 >> 2];
          s[n + 28 >> 2] = s[r + 28 >> 2];
        }

        s[d >> 2] = s[n >> 2];
        s[d + 4 >> 2] = s[n + 4 >> 2];
        s[d + 8 >> 2] = s[n + 8 >> 2];
        s[d + 12 >> 2] = s[n + 12 >> 2];
        s[d + 16 >> 2] = s[n + 16 >> 2];
        s[d + 20 >> 2] = s[n + 20 >> 2];
        s[d + 24 >> 2] = s[n + 24 >> 2];
        s[d + 28 >> 2] = s[n + 28 >> 2];
        b = i + 32 | 0;
        s[n >> 2] = s[b >> 2];
        s[n + 4 >> 2] = s[b + 4 >> 2];
        s[n + 8 >> 2] = s[b + 8 >> 2];
        s[n + 12 >> 2] = s[b + 12 >> 2];
        s[n + 16 >> 2] = s[b + 16 >> 2];
        s[n + 20 >> 2] = s[b + 20 >> 2];
        s[n + 24 >> 2] = s[b + 24 >> 2];
        s[n + 28 >> 2] = s[b + 28 >> 2];
        s[r >> 2] = 0;
        s[r + 4 >> 2] = 0;
        s[r + 8 >> 2] = 0;
        s[r + 12 >> 2] = 0;
        s[r + 16 >> 2] = 0;
        s[r + 20 >> 2] = 0;
        s[r + 24 >> 2] = 0;
        s[r + 28 >> 2] = 0;

        if ((Ca(n, r) | 0) << 24 >> 24 == 1) {
          s[r >> 2] = s[34];
          s[r + 4 >> 2] = s[35];
          s[r + 8 >> 2] = s[36];
          s[r + 12 >> 2] = s[37];
          s[r + 16 >> 2] = s[38];
          s[r + 20 >> 2] = s[39];
          s[r + 24 >> 2] = s[40];
          s[r + 28 >> 2] = s[41];
          Ia(r, n);
          s[n >> 2] = s[r >> 2];
          s[n + 4 >> 2] = s[r + 4 >> 2];
          s[n + 8 >> 2] = s[r + 8 >> 2];
          s[n + 12 >> 2] = s[r + 12 >> 2];
          s[n + 16 >> 2] = s[r + 16 >> 2];
          s[n + 20 >> 2] = s[r + 20 >> 2];
          s[n + 24 >> 2] = s[r + 24 >> 2];
          s[n + 28 >> 2] = s[r + 28 >> 2];
        }

        s[o >> 2] = s[n >> 2];
        s[o + 4 >> 2] = s[n + 4 >> 2];
        s[o + 8 >> 2] = s[n + 8 >> 2];
        s[o + 12 >> 2] = s[n + 12 >> 2];
        s[o + 16 >> 2] = s[n + 16 >> 2];
        s[o + 20 >> 2] = s[n + 20 >> 2];
        s[o + 24 >> 2] = s[n + 24 >> 2];
        s[o + 28 >> 2] = s[n + 28 >> 2];
        a = d + 32 | 0;
        s[a >> 2] = s[o >> 2];
        s[a + 4 >> 2] = s[o + 4 >> 2];
        s[a + 8 >> 2] = s[o + 8 >> 2];
        s[a + 12 >> 2] = s[o + 12 >> 2];
        s[a + 16 >> 2] = s[o + 16 >> 2];
        s[a + 20 >> 2] = s[o + 20 >> 2];
        s[a + 24 >> 2] = s[o + 24 >> 2];
        s[a + 28 >> 2] = s[o + 28 >> 2];
        a = t + 64 | 0;
        f = i;
        h = a;
        b = f + 64 | 0;

        do {
          s[f >> 2] = s[h >> 2];
          f = f + 4 | 0;
          h = h + 4 | 0;
        } while ((f | 0) < (b | 0));

        s[n >> 2] = s[a >> 2];
        s[n + 4 >> 2] = s[a + 4 >> 2];
        s[n + 8 >> 2] = s[a + 8 >> 2];
        s[n + 12 >> 2] = s[a + 12 >> 2];
        s[n + 16 >> 2] = s[a + 16 >> 2];
        s[n + 20 >> 2] = s[a + 20 >> 2];
        s[n + 24 >> 2] = s[a + 24 >> 2];
        s[n + 28 >> 2] = s[a + 28 >> 2];
        s[r >> 2] = 0;
        s[r + 4 >> 2] = 0;
        s[r + 8 >> 2] = 0;
        s[r + 12 >> 2] = 0;
        s[r + 16 >> 2] = 0;
        s[r + 20 >> 2] = 0;
        s[r + 24 >> 2] = 0;
        s[r + 28 >> 2] = 0;

        if ((Ca(n, r) | 0) << 24 >> 24 == 1) {
          s[r >> 2] = s[34];
          s[r + 4 >> 2] = s[35];
          s[r + 8 >> 2] = s[36];
          s[r + 12 >> 2] = s[37];
          s[r + 16 >> 2] = s[38];
          s[r + 20 >> 2] = s[39];
          s[r + 24 >> 2] = s[40];
          s[r + 28 >> 2] = s[41];
          Ia(r, n);
          s[n >> 2] = s[r >> 2];
          s[n + 4 >> 2] = s[r + 4 >> 2];
          s[n + 8 >> 2] = s[r + 8 >> 2];
          s[n + 12 >> 2] = s[r + 12 >> 2];
          s[n + 16 >> 2] = s[r + 16 >> 2];
          s[n + 20 >> 2] = s[r + 20 >> 2];
          s[n + 24 >> 2] = s[r + 24 >> 2];
          s[n + 28 >> 2] = s[r + 28 >> 2];
        }

        s[u >> 2] = s[n >> 2];
        s[u + 4 >> 2] = s[n + 4 >> 2];
        s[u + 8 >> 2] = s[n + 8 >> 2];
        s[u + 12 >> 2] = s[n + 12 >> 2];
        s[u + 16 >> 2] = s[n + 16 >> 2];
        s[u + 20 >> 2] = s[n + 20 >> 2];
        s[u + 24 >> 2] = s[n + 24 >> 2];
        s[u + 28 >> 2] = s[n + 28 >> 2];
        b = i + 32 | 0;
        s[n >> 2] = s[b >> 2];
        s[n + 4 >> 2] = s[b + 4 >> 2];
        s[n + 8 >> 2] = s[b + 8 >> 2];
        s[n + 12 >> 2] = s[b + 12 >> 2];
        s[n + 16 >> 2] = s[b + 16 >> 2];
        s[n + 20 >> 2] = s[b + 20 >> 2];
        s[n + 24 >> 2] = s[b + 24 >> 2];
        s[n + 28 >> 2] = s[b + 28 >> 2];
        s[r >> 2] = 0;
        s[r + 4 >> 2] = 0;
        s[r + 8 >> 2] = 0;
        s[r + 12 >> 2] = 0;
        s[r + 16 >> 2] = 0;
        s[r + 20 >> 2] = 0;
        s[r + 24 >> 2] = 0;
        s[r + 28 >> 2] = 0;

        if ((Ca(n, r) | 0) << 24 >> 24 == 1) {
          s[r >> 2] = s[34];
          s[r + 4 >> 2] = s[35];
          s[r + 8 >> 2] = s[36];
          s[r + 12 >> 2] = s[37];
          s[r + 16 >> 2] = s[38];
          s[r + 20 >> 2] = s[39];
          s[r + 24 >> 2] = s[40];
          s[r + 28 >> 2] = s[41];
          Ia(r, n);
          s[n >> 2] = s[r >> 2];
          s[n + 4 >> 2] = s[r + 4 >> 2];
          s[n + 8 >> 2] = s[r + 8 >> 2];
          s[n + 12 >> 2] = s[r + 12 >> 2];
          s[n + 16 >> 2] = s[r + 16 >> 2];
          s[n + 20 >> 2] = s[r + 20 >> 2];
          s[n + 24 >> 2] = s[r + 24 >> 2];
          s[n + 28 >> 2] = s[r + 28 >> 2];
        }

        s[o >> 2] = s[n >> 2];
        s[o + 4 >> 2] = s[n + 4 >> 2];
        s[o + 8 >> 2] = s[n + 8 >> 2];
        s[o + 12 >> 2] = s[n + 12 >> 2];
        s[o + 16 >> 2] = s[n + 16 >> 2];
        s[o + 20 >> 2] = s[n + 20 >> 2];
        s[o + 24 >> 2] = s[n + 24 >> 2];
        s[o + 28 >> 2] = s[n + 28 >> 2];
        f = u + 32 | 0;
        s[f >> 2] = s[o >> 2];
        s[f + 4 >> 2] = s[o + 4 >> 2];
        s[f + 8 >> 2] = s[o + 8 >> 2];
        s[f + 12 >> 2] = s[o + 12 >> 2];
        s[f + 16 >> 2] = s[o + 16 >> 2];
        s[f + 20 >> 2] = s[o + 20 >> 2];
        s[f + 24 >> 2] = s[o + 24 >> 2];
        s[f + 28 >> 2] = s[o + 28 >> 2];
        t = t + 128 | 0;
        f = i;
        h = t;
        b = f + 64 | 0;

        do {
          s[f >> 2] = s[h >> 2];
          f = f + 4 | 0;
          h = h + 4 | 0;
        } while ((f | 0) < (b | 0));

        s[n >> 2] = s[t >> 2];
        s[n + 4 >> 2] = s[t + 4 >> 2];
        s[n + 8 >> 2] = s[t + 8 >> 2];
        s[n + 12 >> 2] = s[t + 12 >> 2];
        s[n + 16 >> 2] = s[t + 16 >> 2];
        s[n + 20 >> 2] = s[t + 20 >> 2];
        s[n + 24 >> 2] = s[t + 24 >> 2];
        s[n + 28 >> 2] = s[t + 28 >> 2];
        s[r >> 2] = 0;
        s[r + 4 >> 2] = 0;
        s[r + 8 >> 2] = 0;
        s[r + 12 >> 2] = 0;
        s[r + 16 >> 2] = 0;
        s[r + 20 >> 2] = 0;
        s[r + 24 >> 2] = 0;
        s[r + 28 >> 2] = 0;

        if ((Ca(n, r) | 0) << 24 >> 24 == 1) {
          s[r >> 2] = s[34];
          s[r + 4 >> 2] = s[35];
          s[r + 8 >> 2] = s[36];
          s[r + 12 >> 2] = s[37];
          s[r + 16 >> 2] = s[38];
          s[r + 20 >> 2] = s[39];
          s[r + 24 >> 2] = s[40];
          s[r + 28 >> 2] = s[41];
          Ia(r, n);
          s[n >> 2] = s[r >> 2];
          s[n + 4 >> 2] = s[r + 4 >> 2];
          s[n + 8 >> 2] = s[r + 8 >> 2];
          s[n + 12 >> 2] = s[r + 12 >> 2];
          s[n + 16 >> 2] = s[r + 16 >> 2];
          s[n + 20 >> 2] = s[r + 20 >> 2];
          s[n + 24 >> 2] = s[r + 24 >> 2];
          s[n + 28 >> 2] = s[r + 28 >> 2];
        }

        s[c >> 2] = s[n >> 2];
        s[c + 4 >> 2] = s[n + 4 >> 2];
        s[c + 8 >> 2] = s[n + 8 >> 2];
        s[c + 12 >> 2] = s[n + 12 >> 2];
        s[c + 16 >> 2] = s[n + 16 >> 2];
        s[c + 20 >> 2] = s[n + 20 >> 2];
        s[c + 24 >> 2] = s[n + 24 >> 2];
        s[c + 28 >> 2] = s[n + 28 >> 2];
        b = i + 32 | 0;
        s[n >> 2] = s[b >> 2];
        s[n + 4 >> 2] = s[b + 4 >> 2];
        s[n + 8 >> 2] = s[b + 8 >> 2];
        s[n + 12 >> 2] = s[b + 12 >> 2];
        s[n + 16 >> 2] = s[b + 16 >> 2];
        s[n + 20 >> 2] = s[b + 20 >> 2];
        s[n + 24 >> 2] = s[b + 24 >> 2];
        s[n + 28 >> 2] = s[b + 28 >> 2];
        s[r >> 2] = 0;
        s[r + 4 >> 2] = 0;
        s[r + 8 >> 2] = 0;
        s[r + 12 >> 2] = 0;
        s[r + 16 >> 2] = 0;
        s[r + 20 >> 2] = 0;
        s[r + 24 >> 2] = 0;
        s[r + 28 >> 2] = 0;

        if ((Ca(n, r) | 0) << 24 >> 24 != 1) {
          s[o >> 2] = s[n >> 2];
          s[o + 4 >> 2] = s[n + 4 >> 2];
          s[o + 8 >> 2] = s[n + 8 >> 2];
          s[o + 12 >> 2] = s[n + 12 >> 2];
          s[o + 16 >> 2] = s[n + 16 >> 2];
          s[o + 20 >> 2] = s[n + 20 >> 2];
          s[o + 24 >> 2] = s[n + 24 >> 2];
          s[o + 28 >> 2] = s[n + 28 >> 2];
          f = c + 32 | 0;
          s[f >> 2] = s[o >> 2];
          s[f + 4 >> 2] = s[o + 4 >> 2];
          s[f + 8 >> 2] = s[o + 8 >> 2];
          s[f + 12 >> 2] = s[o + 12 >> 2];
          s[f + 16 >> 2] = s[o + 16 >> 2];
          s[f + 20 >> 2] = s[o + 20 >> 2];
          s[f + 24 >> 2] = s[o + 24 >> 2];
          s[f + 28 >> 2] = s[o + 28 >> 2];
          f = e;
          h = d;
          b = f + 64 | 0;

          do {
            s[f >> 2] = s[h >> 2];
            f = f + 4 | 0;
            h = h + 4 | 0;
          } while ((f | 0) < (b | 0));

          f = e + 64 | 0;
          h = u;
          b = f + 64 | 0;

          do {
            s[f >> 2] = s[h >> 2];
            f = f + 4 | 0;
            h = h + 4 | 0;
          } while ((f | 0) < (b | 0));

          f = e + 128 | 0;
          h = c;
          b = f + 64 | 0;

          do {
            s[f >> 2] = s[h >> 2];
            f = f + 4 | 0;
            h = h + 4 | 0;
          } while ((f | 0) < (b | 0));

          p = l;
          return;
        }

        s[r >> 2] = s[34];
        s[r + 4 >> 2] = s[35];
        s[r + 8 >> 2] = s[36];
        s[r + 12 >> 2] = s[37];
        s[r + 16 >> 2] = s[38];
        s[r + 20 >> 2] = s[39];
        s[r + 24 >> 2] = s[40];
        s[r + 28 >> 2] = s[41];
        Ia(r, n);
        s[n >> 2] = s[r >> 2];
        s[n + 4 >> 2] = s[r + 4 >> 2];
        s[n + 8 >> 2] = s[r + 8 >> 2];
        s[n + 12 >> 2] = s[r + 12 >> 2];
        s[n + 16 >> 2] = s[r + 16 >> 2];
        s[n + 20 >> 2] = s[r + 20 >> 2];
        s[n + 24 >> 2] = s[r + 24 >> 2];
        s[n + 28 >> 2] = s[r + 28 >> 2];
        s[o >> 2] = s[n >> 2];
        s[o + 4 >> 2] = s[n + 4 >> 2];
        s[o + 8 >> 2] = s[n + 8 >> 2];
        s[o + 12 >> 2] = s[n + 12 >> 2];
        s[o + 16 >> 2] = s[n + 16 >> 2];
        s[o + 20 >> 2] = s[n + 20 >> 2];
        s[o + 24 >> 2] = s[n + 24 >> 2];
        s[o + 28 >> 2] = s[n + 28 >> 2];
        f = c + 32 | 0;
        s[f >> 2] = s[o >> 2];
        s[f + 4 >> 2] = s[o + 4 >> 2];
        s[f + 8 >> 2] = s[o + 8 >> 2];
        s[f + 12 >> 2] = s[o + 12 >> 2];
        s[f + 16 >> 2] = s[o + 16 >> 2];
        s[f + 20 >> 2] = s[o + 20 >> 2];
        s[f + 24 >> 2] = s[o + 24 >> 2];
        s[f + 28 >> 2] = s[o + 28 >> 2];
        f = e;
        h = d;
        b = f + 64 | 0;

        do {
          s[f >> 2] = s[h >> 2];
          f = f + 4 | 0;
          h = h + 4 | 0;
        } while ((f | 0) < (b | 0));

        f = e + 64 | 0;
        h = u;
        b = f + 64 | 0;

        do {
          s[f >> 2] = s[h >> 2];
          f = f + 4 | 0;
          h = h + 4 | 0;
        } while ((f | 0) < (b | 0));

        f = e + 128 | 0;
        h = c;
        b = f + 64 | 0;

        do {
          s[f >> 2] = s[h >> 2];
          f = f + 4 | 0;
          h = h + 4 | 0;
        } while ((f | 0) < (b | 0));

        p = l;
        return;
      }

      function Ya(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0;
        r = p;
        p = p + 288 | 0;
        i = r + 256 | 0;
        h = r + 224 | 0;
        l = r + 192 | 0;
        f = r + 160 | 0;
        u = r + 128 | 0;
        o = r + 96 | 0;
        n = r + 64 | 0;
        c = r + 32 | 0;
        d = r;
        s[h >> 2] = s[t >> 2];
        s[h + 4 >> 2] = s[t + 4 >> 2];
        s[h + 8 >> 2] = s[t + 8 >> 2];
        s[h + 12 >> 2] = s[t + 12 >> 2];
        s[h + 16 >> 2] = s[t + 16 >> 2];
        s[h + 20 >> 2] = s[t + 20 >> 2];
        s[h + 24 >> 2] = s[t + 24 >> 2];
        s[h + 28 >> 2] = s[t + 28 >> 2];
        s[i >> 2] = s[a >> 2];
        s[i + 4 >> 2] = s[a + 4 >> 2];
        s[i + 8 >> 2] = s[a + 8 >> 2];
        s[i + 12 >> 2] = s[a + 12 >> 2];
        s[i + 16 >> 2] = s[a + 16 >> 2];
        s[i + 20 >> 2] = s[a + 20 >> 2];
        s[i + 24 >> 2] = s[a + 24 >> 2];
        s[i + 28 >> 2] = s[a + 28 >> 2];
        ka(h, i, 136, -460954743, -2016278654);
        s[d >> 2] = s[h >> 2];
        s[d + 4 >> 2] = s[h + 4 >> 2];
        s[d + 8 >> 2] = s[h + 8 >> 2];
        s[d + 12 >> 2] = s[h + 12 >> 2];
        s[d + 16 >> 2] = s[h + 16 >> 2];
        s[d + 20 >> 2] = s[h + 20 >> 2];
        s[d + 24 >> 2] = s[h + 24 >> 2];
        s[d + 28 >> 2] = s[h + 28 >> 2];
        m = t + 32 | 0;
        s[h >> 2] = s[m >> 2];
        s[h + 4 >> 2] = s[m + 4 >> 2];
        s[h + 8 >> 2] = s[m + 8 >> 2];
        s[h + 12 >> 2] = s[m + 12 >> 2];
        s[h + 16 >> 2] = s[m + 16 >> 2];
        s[h + 20 >> 2] = s[m + 20 >> 2];
        s[h + 24 >> 2] = s[m + 24 >> 2];
        s[h + 28 >> 2] = s[m + 28 >> 2];
        b = a + 32 | 0;
        s[i >> 2] = s[b >> 2];
        s[i + 4 >> 2] = s[b + 4 >> 2];
        s[i + 8 >> 2] = s[b + 8 >> 2];
        s[i + 12 >> 2] = s[b + 12 >> 2];
        s[i + 16 >> 2] = s[b + 16 >> 2];
        s[i + 20 >> 2] = s[b + 20 >> 2];
        s[i + 24 >> 2] = s[b + 24 >> 2];
        s[i + 28 >> 2] = s[b + 28 >> 2];
        ka(h, i, 136, -460954743, -2016278654);
        s[c >> 2] = s[h >> 2];
        s[c + 4 >> 2] = s[h + 4 >> 2];
        s[c + 8 >> 2] = s[h + 8 >> 2];
        s[c + 12 >> 2] = s[h + 12 >> 2];
        s[c + 16 >> 2] = s[h + 16 >> 2];
        s[c + 20 >> 2] = s[h + 20 >> 2];
        s[c + 24 >> 2] = s[h + 24 >> 2];
        s[c + 28 >> 2] = s[h + 28 >> 2];
        s[h >> 2] = s[c >> 2];
        s[h + 4 >> 2] = s[c + 4 >> 2];
        s[h + 8 >> 2] = s[c + 8 >> 2];
        s[h + 12 >> 2] = s[c + 12 >> 2];
        s[h + 16 >> 2] = s[c + 16 >> 2];
        s[h + 20 >> 2] = s[c + 20 >> 2];
        s[h + 24 >> 2] = s[c + 24 >> 2];
        s[h + 28 >> 2] = s[c + 28 >> 2];
        y = i;
        s[y >> 2] = 317583274;
        s[y + 4 >> 2] = 1757628553;
        y = i + 8 | 0;
        s[y >> 2] = 1923792719;
        s[y + 4 >> 2] = -1928822936;
        y = i + 16 | 0;
        s[y >> 2] = 151523889;
        s[y + 4 >> 2] = 1373741639;
        y = i + 24 | 0;
        s[y >> 2] = 1193918714;
        s[y + 4 >> 2] = 576313009;
        ka(h, i, 136, -460954743, -2016278654);
        s[l >> 2] = s[h >> 2];
        s[l + 4 >> 2] = s[h + 4 >> 2];
        s[l + 8 >> 2] = s[h + 8 >> 2];
        s[l + 12 >> 2] = s[h + 12 >> 2];
        s[l + 16 >> 2] = s[h + 16 >> 2];
        s[l + 20 >> 2] = s[h + 20 >> 2];
        s[l + 24 >> 2] = s[h + 24 >> 2];
        s[l + 28 >> 2] = s[h + 28 >> 2];
        s[i >> 2] = s[d >> 2];
        s[i + 4 >> 2] = s[d + 4 >> 2];
        s[i + 8 >> 2] = s[d + 8 >> 2];
        s[i + 12 >> 2] = s[d + 12 >> 2];
        s[i + 16 >> 2] = s[d + 16 >> 2];
        s[i + 20 >> 2] = s[d + 20 >> 2];
        s[i + 24 >> 2] = s[d + 24 >> 2];
        s[i + 28 >> 2] = s[d + 28 >> 2];
        Ea(l, i, 136);
        s[e >> 2] = s[l >> 2];
        s[e + 4 >> 2] = s[l + 4 >> 2];
        s[e + 8 >> 2] = s[l + 8 >> 2];
        s[e + 12 >> 2] = s[l + 12 >> 2];
        s[e + 16 >> 2] = s[l + 16 >> 2];
        s[e + 20 >> 2] = s[l + 20 >> 2];
        s[e + 24 >> 2] = s[l + 24 >> 2];
        s[e + 28 >> 2] = s[l + 28 >> 2];
        s[h >> 2] = s[t >> 2];
        s[h + 4 >> 2] = s[t + 4 >> 2];
        s[h + 8 >> 2] = s[t + 8 >> 2];
        s[h + 12 >> 2] = s[t + 12 >> 2];
        s[h + 16 >> 2] = s[t + 16 >> 2];
        s[h + 20 >> 2] = s[t + 20 >> 2];
        s[h + 24 >> 2] = s[t + 24 >> 2];
        s[h + 28 >> 2] = s[t + 28 >> 2];
        s[i >> 2] = s[m >> 2];
        s[i + 4 >> 2] = s[m + 4 >> 2];
        s[i + 8 >> 2] = s[m + 8 >> 2];
        s[i + 12 >> 2] = s[m + 12 >> 2];
        s[i + 16 >> 2] = s[m + 16 >> 2];
        s[i + 20 >> 2] = s[m + 20 >> 2];
        s[i + 24 >> 2] = s[m + 24 >> 2];
        s[i + 28 >> 2] = s[m + 28 >> 2];
        Ea(h, i, 136);
        s[f >> 2] = s[h >> 2];
        s[f + 4 >> 2] = s[h + 4 >> 2];
        s[f + 8 >> 2] = s[h + 8 >> 2];
        s[f + 12 >> 2] = s[h + 12 >> 2];
        s[f + 16 >> 2] = s[h + 16 >> 2];
        s[f + 20 >> 2] = s[h + 20 >> 2];
        s[f + 24 >> 2] = s[h + 24 >> 2];
        s[f + 28 >> 2] = s[h + 28 >> 2];
        s[h >> 2] = s[a >> 2];
        s[h + 4 >> 2] = s[a + 4 >> 2];
        s[h + 8 >> 2] = s[a + 8 >> 2];
        s[h + 12 >> 2] = s[a + 12 >> 2];
        s[h + 16 >> 2] = s[a + 16 >> 2];
        s[h + 20 >> 2] = s[a + 20 >> 2];
        s[h + 24 >> 2] = s[a + 24 >> 2];
        s[h + 28 >> 2] = s[a + 28 >> 2];
        s[i >> 2] = s[b >> 2];
        s[i + 4 >> 2] = s[b + 4 >> 2];
        s[i + 8 >> 2] = s[b + 8 >> 2];
        s[i + 12 >> 2] = s[b + 12 >> 2];
        s[i + 16 >> 2] = s[b + 16 >> 2];
        s[i + 20 >> 2] = s[b + 20 >> 2];
        s[i + 24 >> 2] = s[b + 24 >> 2];
        s[i + 28 >> 2] = s[b + 28 >> 2];
        Ea(h, i, 136);
        s[l >> 2] = s[h >> 2];
        s[l + 4 >> 2] = s[h + 4 >> 2];
        s[l + 8 >> 2] = s[h + 8 >> 2];
        s[l + 12 >> 2] = s[h + 12 >> 2];
        s[l + 16 >> 2] = s[h + 16 >> 2];
        s[l + 20 >> 2] = s[h + 20 >> 2];
        s[l + 24 >> 2] = s[h + 24 >> 2];
        s[l + 28 >> 2] = s[h + 28 >> 2];
        ka(f, l, 136, -460954743, -2016278654);
        s[u >> 2] = s[f >> 2];
        s[u + 4 >> 2] = s[f + 4 >> 2];
        s[u + 8 >> 2] = s[f + 8 >> 2];
        s[u + 12 >> 2] = s[f + 12 >> 2];
        s[u + 16 >> 2] = s[f + 16 >> 2];
        s[u + 20 >> 2] = s[f + 20 >> 2];
        s[u + 24 >> 2] = s[f + 24 >> 2];
        s[u + 28 >> 2] = s[f + 28 >> 2];
        s[i >> 2] = s[d >> 2];
        s[i + 4 >> 2] = s[d + 4 >> 2];
        s[i + 8 >> 2] = s[d + 8 >> 2];
        s[i + 12 >> 2] = s[d + 12 >> 2];
        s[i + 16 >> 2] = s[d + 16 >> 2];
        s[i + 20 >> 2] = s[d + 20 >> 2];
        s[i + 24 >> 2] = s[d + 24 >> 2];
        s[i + 28 >> 2] = s[d + 28 >> 2];
        Ba(u, i, 136);
        s[o >> 2] = s[u >> 2];
        s[o + 4 >> 2] = s[u + 4 >> 2];
        s[o + 8 >> 2] = s[u + 8 >> 2];
        s[o + 12 >> 2] = s[u + 12 >> 2];
        s[o + 16 >> 2] = s[u + 16 >> 2];
        s[o + 20 >> 2] = s[u + 20 >> 2];
        s[o + 24 >> 2] = s[u + 24 >> 2];
        s[o + 28 >> 2] = s[u + 28 >> 2];
        s[i >> 2] = s[c >> 2];
        s[i + 4 >> 2] = s[c + 4 >> 2];
        s[i + 8 >> 2] = s[c + 8 >> 2];
        s[i + 12 >> 2] = s[c + 12 >> 2];
        s[i + 16 >> 2] = s[c + 16 >> 2];
        s[i + 20 >> 2] = s[c + 20 >> 2];
        s[i + 24 >> 2] = s[c + 24 >> 2];
        s[i + 28 >> 2] = s[c + 28 >> 2];
        Ba(o, i, 136);
        s[n >> 2] = s[o >> 2];
        s[n + 4 >> 2] = s[o + 4 >> 2];
        s[n + 8 >> 2] = s[o + 8 >> 2];
        s[n + 12 >> 2] = s[o + 12 >> 2];
        s[n + 16 >> 2] = s[o + 16 >> 2];
        s[n + 20 >> 2] = s[o + 20 >> 2];
        s[n + 24 >> 2] = s[o + 24 >> 2];
        s[n + 28 >> 2] = s[o + 28 >> 2];
        a = e + 32 | 0;
        s[a >> 2] = s[n >> 2];
        s[a + 4 >> 2] = s[n + 4 >> 2];
        s[a + 8 >> 2] = s[n + 8 >> 2];
        s[a + 12 >> 2] = s[n + 12 >> 2];
        s[a + 16 >> 2] = s[n + 16 >> 2];
        s[a + 20 >> 2] = s[n + 20 >> 2];
        s[a + 24 >> 2] = s[n + 24 >> 2];
        s[a + 28 >> 2] = s[n + 28 >> 2];
        p = r;
        return;
      }

      function Za(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0;
        a = p;
        p = p + 224 | 0;
        o = a + 192 | 0;
        n = a + 160 | 0;
        r = a + 128 | 0;
        d = a + 96 | 0;
        u = a + 64 | 0;
        c = a + 32 | 0;
        i = a;
        s[n >> 2] = s[t >> 2];
        s[n + 4 >> 2] = s[t + 4 >> 2];
        s[n + 8 >> 2] = s[t + 8 >> 2];
        s[n + 12 >> 2] = s[t + 12 >> 2];
        s[n + 16 >> 2] = s[t + 16 >> 2];
        s[n + 20 >> 2] = s[t + 20 >> 2];
        s[n + 24 >> 2] = s[t + 24 >> 2];
        s[n + 28 >> 2] = s[t + 28 >> 2];
        f = t + 32 | 0;
        s[o >> 2] = s[f >> 2];
        s[o + 4 >> 2] = s[f + 4 >> 2];
        s[o + 8 >> 2] = s[f + 8 >> 2];
        s[o + 12 >> 2] = s[f + 12 >> 2];
        s[o + 16 >> 2] = s[f + 16 >> 2];
        s[o + 20 >> 2] = s[f + 20 >> 2];
        s[o + 24 >> 2] = s[f + 24 >> 2];
        s[o + 28 >> 2] = s[f + 28 >> 2];
        ka(n, o, 136, -460954743, -2016278654);
        s[i >> 2] = s[n >> 2];
        s[i + 4 >> 2] = s[n + 4 >> 2];
        s[i + 8 >> 2] = s[n + 8 >> 2];
        s[i + 12 >> 2] = s[n + 12 >> 2];
        s[i + 16 >> 2] = s[n + 16 >> 2];
        s[i + 20 >> 2] = s[n + 20 >> 2];
        s[i + 24 >> 2] = s[n + 24 >> 2];
        s[i + 28 >> 2] = s[n + 28 >> 2];
        s[n >> 2] = s[f >> 2];
        s[n + 4 >> 2] = s[f + 4 >> 2];
        s[n + 8 >> 2] = s[f + 8 >> 2];
        s[n + 12 >> 2] = s[f + 12 >> 2];
        s[n + 16 >> 2] = s[f + 16 >> 2];
        s[n + 20 >> 2] = s[f + 20 >> 2];
        s[n + 24 >> 2] = s[f + 24 >> 2];
        s[n + 28 >> 2] = s[f + 28 >> 2];
        l = o;
        s[l >> 2] = 317583274;
        s[l + 4 >> 2] = 1757628553;
        l = o + 8 | 0;
        s[l >> 2] = 1923792719;
        s[l + 4 >> 2] = -1928822936;
        l = o + 16 | 0;
        s[l >> 2] = 151523889;
        s[l + 4 >> 2] = 1373741639;
        l = o + 24 | 0;
        s[l >> 2] = 1193918714;
        s[l + 4 >> 2] = 576313009;
        ka(n, o, 136, -460954743, -2016278654);
        s[r >> 2] = s[n >> 2];
        s[r + 4 >> 2] = s[n + 4 >> 2];
        s[r + 8 >> 2] = s[n + 8 >> 2];
        s[r + 12 >> 2] = s[n + 12 >> 2];
        s[r + 16 >> 2] = s[n + 16 >> 2];
        s[r + 20 >> 2] = s[n + 20 >> 2];
        s[r + 24 >> 2] = s[n + 24 >> 2];
        s[r + 28 >> 2] = s[n + 28 >> 2];
        s[o >> 2] = s[t >> 2];
        s[o + 4 >> 2] = s[t + 4 >> 2];
        s[o + 8 >> 2] = s[t + 8 >> 2];
        s[o + 12 >> 2] = s[t + 12 >> 2];
        s[o + 16 >> 2] = s[t + 16 >> 2];
        s[o + 20 >> 2] = s[t + 20 >> 2];
        s[o + 24 >> 2] = s[t + 24 >> 2];
        s[o + 28 >> 2] = s[t + 28 >> 2];
        Ea(r, o, 136);
        s[d >> 2] = s[r >> 2];
        s[d + 4 >> 2] = s[r + 4 >> 2];
        s[d + 8 >> 2] = s[r + 8 >> 2];
        s[d + 12 >> 2] = s[r + 12 >> 2];
        s[d + 16 >> 2] = s[r + 16 >> 2];
        s[d + 20 >> 2] = s[r + 20 >> 2];
        s[d + 24 >> 2] = s[r + 24 >> 2];
        s[d + 28 >> 2] = s[r + 28 >> 2];
        s[n >> 2] = s[t >> 2];
        s[n + 4 >> 2] = s[t + 4 >> 2];
        s[n + 8 >> 2] = s[t + 8 >> 2];
        s[n + 12 >> 2] = s[t + 12 >> 2];
        s[n + 16 >> 2] = s[t + 16 >> 2];
        s[n + 20 >> 2] = s[t + 20 >> 2];
        s[n + 24 >> 2] = s[t + 24 >> 2];
        s[n + 28 >> 2] = s[t + 28 >> 2];
        s[o >> 2] = s[f >> 2];
        s[o + 4 >> 2] = s[f + 4 >> 2];
        s[o + 8 >> 2] = s[f + 8 >> 2];
        s[o + 12 >> 2] = s[f + 12 >> 2];
        s[o + 16 >> 2] = s[f + 16 >> 2];
        s[o + 20 >> 2] = s[f + 20 >> 2];
        s[o + 24 >> 2] = s[f + 24 >> 2];
        s[o + 28 >> 2] = s[f + 28 >> 2];
        Ea(n, o, 136);
        s[r >> 2] = s[n >> 2];
        s[r + 4 >> 2] = s[n + 4 >> 2];
        s[r + 8 >> 2] = s[n + 8 >> 2];
        s[r + 12 >> 2] = s[n + 12 >> 2];
        s[r + 16 >> 2] = s[n + 16 >> 2];
        s[r + 20 >> 2] = s[n + 20 >> 2];
        s[r + 24 >> 2] = s[n + 24 >> 2];
        s[r + 28 >> 2] = s[n + 28 >> 2];
        ka(d, r, 136, -460954743, -2016278654);
        s[u >> 2] = s[d >> 2];
        s[u + 4 >> 2] = s[d + 4 >> 2];
        s[u + 8 >> 2] = s[d + 8 >> 2];
        s[u + 12 >> 2] = s[d + 12 >> 2];
        s[u + 16 >> 2] = s[d + 16 >> 2];
        s[u + 20 >> 2] = s[d + 20 >> 2];
        s[u + 24 >> 2] = s[d + 24 >> 2];
        s[u + 28 >> 2] = s[d + 28 >> 2];
        s[o >> 2] = s[i >> 2];
        s[o + 4 >> 2] = s[i + 4 >> 2];
        s[o + 8 >> 2] = s[i + 8 >> 2];
        s[o + 12 >> 2] = s[i + 12 >> 2];
        s[o + 16 >> 2] = s[i + 16 >> 2];
        s[o + 20 >> 2] = s[i + 20 >> 2];
        s[o + 24 >> 2] = s[i + 24 >> 2];
        s[o + 28 >> 2] = s[i + 28 >> 2];
        Ba(u, o, 136);
        s[c >> 2] = s[u >> 2];
        s[c + 4 >> 2] = s[u + 4 >> 2];
        s[c + 8 >> 2] = s[u + 8 >> 2];
        s[c + 12 >> 2] = s[u + 12 >> 2];
        s[c + 16 >> 2] = s[u + 16 >> 2];
        s[c + 20 >> 2] = s[u + 20 >> 2];
        s[c + 24 >> 2] = s[u + 24 >> 2];
        s[c + 28 >> 2] = s[u + 28 >> 2];
        s[n >> 2] = s[i >> 2];
        s[n + 4 >> 2] = s[i + 4 >> 2];
        s[n + 8 >> 2] = s[i + 8 >> 2];
        s[n + 12 >> 2] = s[i + 12 >> 2];
        s[n + 16 >> 2] = s[i + 16 >> 2];
        s[n + 20 >> 2] = s[i + 20 >> 2];
        s[n + 24 >> 2] = s[i + 24 >> 2];
        s[n + 28 >> 2] = s[i + 28 >> 2];
        t = o;
        s[t >> 2] = 317583274;
        s[t + 4 >> 2] = 1757628553;
        t = o + 8 | 0;
        s[t >> 2] = 1923792719;
        s[t + 4 >> 2] = -1928822936;
        t = o + 16 | 0;
        s[t >> 2] = 151523889;
        s[t + 4 >> 2] = 1373741639;
        t = o + 24 | 0;
        s[t >> 2] = 1193918714;
        s[t + 4 >> 2] = 576313009;
        ka(n, o, 136, -460954743, -2016278654);
        s[r >> 2] = s[n >> 2];
        s[r + 4 >> 2] = s[n + 4 >> 2];
        s[r + 8 >> 2] = s[n + 8 >> 2];
        s[r + 12 >> 2] = s[n + 12 >> 2];
        s[r + 16 >> 2] = s[n + 16 >> 2];
        s[r + 20 >> 2] = s[n + 20 >> 2];
        s[r + 24 >> 2] = s[n + 24 >> 2];
        s[r + 28 >> 2] = s[n + 28 >> 2];
        Ba(c, r, 136);
        s[e >> 2] = s[c >> 2];
        s[e + 4 >> 2] = s[c + 4 >> 2];
        s[e + 8 >> 2] = s[c + 8 >> 2];
        s[e + 12 >> 2] = s[c + 12 >> 2];
        s[e + 16 >> 2] = s[c + 16 >> 2];
        s[e + 20 >> 2] = s[c + 20 >> 2];
        s[e + 24 >> 2] = s[c + 24 >> 2];
        s[e + 28 >> 2] = s[c + 28 >> 2];
        s[n >> 2] = s[i >> 2];
        s[n + 4 >> 2] = s[i + 4 >> 2];
        s[n + 8 >> 2] = s[i + 8 >> 2];
        s[n + 12 >> 2] = s[i + 12 >> 2];
        s[n + 16 >> 2] = s[i + 16 >> 2];
        s[n + 20 >> 2] = s[i + 20 >> 2];
        s[n + 24 >> 2] = s[i + 24 >> 2];
        s[n + 28 >> 2] = s[i + 28 >> 2];
        s[o >> 2] = s[i >> 2];
        s[o + 4 >> 2] = s[i + 4 >> 2];
        s[o + 8 >> 2] = s[i + 8 >> 2];
        s[o + 12 >> 2] = s[i + 12 >> 2];
        s[o + 16 >> 2] = s[i + 16 >> 2];
        s[o + 20 >> 2] = s[i + 20 >> 2];
        s[o + 24 >> 2] = s[i + 24 >> 2];
        s[o + 28 >> 2] = s[i + 28 >> 2];
        Ea(n, o, 136);
        s[r >> 2] = s[n >> 2];
        s[r + 4 >> 2] = s[n + 4 >> 2];
        s[r + 8 >> 2] = s[n + 8 >> 2];
        s[r + 12 >> 2] = s[n + 12 >> 2];
        s[r + 16 >> 2] = s[n + 16 >> 2];
        s[r + 20 >> 2] = s[n + 20 >> 2];
        s[r + 24 >> 2] = s[n + 24 >> 2];
        s[r + 28 >> 2] = s[n + 28 >> 2];
        t = e + 32 | 0;
        s[t >> 2] = s[r >> 2];
        s[t + 4 >> 2] = s[r + 4 >> 2];
        s[t + 8 >> 2] = s[r + 8 >> 2];
        s[t + 12 >> 2] = s[r + 12 >> 2];
        s[t + 16 >> 2] = s[r + 16 >> 2];
        s[t + 20 >> 2] = s[r + 20 >> 2];
        s[t + 24 >> 2] = s[r + 24 >> 2];
        s[t + 28 >> 2] = s[r + 28 >> 2];
        p = a;
        return;
      }

      function Ja(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0;
        l = p;
        p = p + 288 | 0;
        n = l + 256 | 0;
        o = l + 224 | 0;
        i = l + 192 | 0;
        c = l + 160 | 0;
        a = l + 96 | 0;
        f = l + 64 | 0;
        u = l + 32 | 0;
        d = l;
        s[o >> 2] = s[t >> 2];
        s[o + 4 >> 2] = s[t + 4 >> 2];
        s[o + 8 >> 2] = s[t + 8 >> 2];
        s[o + 12 >> 2] = s[t + 12 >> 2];
        s[o + 16 >> 2] = s[t + 16 >> 2];
        s[o + 20 >> 2] = s[t + 20 >> 2];
        s[o + 24 >> 2] = s[t + 24 >> 2];
        s[o + 28 >> 2] = s[t + 28 >> 2];
        s[n >> 2] = s[t >> 2];
        s[n + 4 >> 2] = s[t + 4 >> 2];
        s[n + 8 >> 2] = s[t + 8 >> 2];
        s[n + 12 >> 2] = s[t + 12 >> 2];
        s[n + 16 >> 2] = s[t + 16 >> 2];
        s[n + 20 >> 2] = s[t + 20 >> 2];
        s[n + 24 >> 2] = s[t + 24 >> 2];
        s[n + 28 >> 2] = s[t + 28 >> 2];
        ka(o, n, 136, -460954743, -2016278654);
        s[a >> 2] = s[o >> 2];
        s[a + 4 >> 2] = s[o + 4 >> 2];
        s[a + 8 >> 2] = s[o + 8 >> 2];
        s[a + 12 >> 2] = s[o + 12 >> 2];
        s[a + 16 >> 2] = s[o + 16 >> 2];
        s[a + 20 >> 2] = s[o + 20 >> 2];
        s[a + 24 >> 2] = s[o + 24 >> 2];
        s[a + 28 >> 2] = s[o + 28 >> 2];
        r = t + 32 | 0;
        s[o >> 2] = s[r >> 2];
        s[o + 4 >> 2] = s[r + 4 >> 2];
        s[o + 8 >> 2] = s[r + 8 >> 2];
        s[o + 12 >> 2] = s[r + 12 >> 2];
        s[o + 16 >> 2] = s[r + 16 >> 2];
        s[o + 20 >> 2] = s[r + 20 >> 2];
        s[o + 24 >> 2] = s[r + 24 >> 2];
        s[o + 28 >> 2] = s[r + 28 >> 2];
        s[n >> 2] = s[r >> 2];
        s[n + 4 >> 2] = s[r + 4 >> 2];
        s[n + 8 >> 2] = s[r + 8 >> 2];
        s[n + 12 >> 2] = s[r + 12 >> 2];
        s[n + 16 >> 2] = s[r + 16 >> 2];
        s[n + 20 >> 2] = s[r + 20 >> 2];
        s[n + 24 >> 2] = s[r + 24 >> 2];
        s[n + 28 >> 2] = s[r + 28 >> 2];
        ka(o, n, 136, -460954743, -2016278654);
        s[i >> 2] = s[o >> 2];
        s[i + 4 >> 2] = s[o + 4 >> 2];
        s[i + 8 >> 2] = s[o + 8 >> 2];
        s[i + 12 >> 2] = s[o + 12 >> 2];
        s[i + 16 >> 2] = s[o + 16 >> 2];
        s[i + 20 >> 2] = s[o + 20 >> 2];
        s[i + 24 >> 2] = s[o + 24 >> 2];
        s[i + 28 >> 2] = s[o + 28 >> 2];
        h = n;
        s[h >> 2] = 317583274;
        s[h + 4 >> 2] = 1757628553;
        h = n + 8 | 0;
        s[h >> 2] = 1923792719;
        s[h + 4 >> 2] = -1928822936;
        h = n + 16 | 0;
        s[h >> 2] = 151523889;
        s[h + 4 >> 2] = 1373741639;
        h = n + 24 | 0;
        s[h >> 2] = 1193918714;
        s[h + 4 >> 2] = 576313009;
        ka(i, n, 136, -460954743, -2016278654);
        s[c >> 2] = s[i >> 2];
        s[c + 4 >> 2] = s[i + 4 >> 2];
        s[c + 8 >> 2] = s[i + 8 >> 2];
        s[c + 12 >> 2] = s[i + 12 >> 2];
        s[c + 16 >> 2] = s[i + 16 >> 2];
        s[c + 20 >> 2] = s[i + 20 >> 2];
        s[c + 24 >> 2] = s[i + 24 >> 2];
        s[c + 28 >> 2] = s[i + 28 >> 2];
        Ba(a, c, 136);
        s[u >> 2] = s[a >> 2];
        s[u + 4 >> 2] = s[a + 4 >> 2];
        s[u + 8 >> 2] = s[a + 8 >> 2];
        s[u + 12 >> 2] = s[a + 12 >> 2];
        s[u + 16 >> 2] = s[a + 16 >> 2];
        s[u + 20 >> 2] = s[a + 20 >> 2];
        s[u + 24 >> 2] = s[a + 24 >> 2];
        s[u + 28 >> 2] = s[a + 28 >> 2];
        h = u;

        if ((((s[h >> 2] | 0) == 0 & (s[h + 4 >> 2] | 0) == 0 ? (h = u + 8 | 0, (s[h >> 2] | 0) == 0 & (s[h + 4 >> 2] | 0) == 0) : 0) ? (h = u + 16 | 0, (s[h >> 2] | 0) == 0 & (s[h + 4 >> 2] | 0) == 0) : 0) ? (h = u + 24 | 0, (s[h >> 2] | 0) == 0 & (s[h + 4 >> 2] | 0) == 0) : 0) {
          d = 0;
          f = 0;
          h = e;
          e = h;
          s[e >> 2] = d;
          h = h + 4 | 0;
          s[h >> 2] = f;
          p = l;
          return;
        }

        Wa(u, 136);
        ka(u, 104, 136, -460954743, -2016278654);
        s[d >> 2] = s[u >> 2];
        s[d + 4 >> 2] = s[u + 4 >> 2];
        s[d + 8 >> 2] = s[u + 8 >> 2];
        s[d + 12 >> 2] = s[u + 12 >> 2];
        s[d + 16 >> 2] = s[u + 16 >> 2];
        s[d + 20 >> 2] = s[u + 20 >> 2];
        s[d + 24 >> 2] = s[u + 24 >> 2];
        s[d + 28 >> 2] = s[u + 28 >> 2];
        s[f >> 2] = s[d >> 2];
        s[f + 4 >> 2] = s[d + 4 >> 2];
        s[f + 8 >> 2] = s[d + 8 >> 2];
        s[f + 12 >> 2] = s[d + 12 >> 2];
        s[f + 16 >> 2] = s[d + 16 >> 2];
        s[f + 20 >> 2] = s[d + 20 >> 2];
        s[f + 24 >> 2] = s[d + 24 >> 2];
        s[f + 28 >> 2] = s[d + 28 >> 2];
        s[o >> 2] = s[t >> 2];
        s[o + 4 >> 2] = s[t + 4 >> 2];
        s[o + 8 >> 2] = s[t + 8 >> 2];
        s[o + 12 >> 2] = s[t + 12 >> 2];
        s[o + 16 >> 2] = s[t + 16 >> 2];
        s[o + 20 >> 2] = s[t + 20 >> 2];
        s[o + 24 >> 2] = s[t + 24 >> 2];
        s[o + 28 >> 2] = s[t + 28 >> 2];
        s[n >> 2] = s[d >> 2];
        s[n + 4 >> 2] = s[d + 4 >> 2];
        s[n + 8 >> 2] = s[d + 8 >> 2];
        s[n + 12 >> 2] = s[d + 12 >> 2];
        s[n + 16 >> 2] = s[d + 16 >> 2];
        s[n + 20 >> 2] = s[d + 20 >> 2];
        s[n + 24 >> 2] = s[d + 24 >> 2];
        s[n + 28 >> 2] = s[d + 28 >> 2];
        ka(o, n, 136, -460954743, -2016278654);
        s[a >> 2] = s[o >> 2];
        s[a + 4 >> 2] = s[o + 4 >> 2];
        s[a + 8 >> 2] = s[o + 8 >> 2];
        s[a + 12 >> 2] = s[o + 12 >> 2];
        s[a + 16 >> 2] = s[o + 16 >> 2];
        s[a + 20 >> 2] = s[o + 20 >> 2];
        s[a + 24 >> 2] = s[o + 24 >> 2];
        s[a + 28 >> 2] = s[o + 28 >> 2];
        s[o >> 2] = s[r >> 2];
        s[o + 4 >> 2] = s[r + 4 >> 2];
        s[o + 8 >> 2] = s[r + 8 >> 2];
        s[o + 12 >> 2] = s[r + 12 >> 2];
        s[o + 16 >> 2] = s[r + 16 >> 2];
        s[o + 20 >> 2] = s[r + 20 >> 2];
        s[o + 24 >> 2] = s[r + 24 >> 2];
        s[o + 28 >> 2] = s[r + 28 >> 2];
        s[n >> 2] = s[f >> 2];
        s[n + 4 >> 2] = s[f + 4 >> 2];
        s[n + 8 >> 2] = s[f + 8 >> 2];
        s[n + 12 >> 2] = s[f + 12 >> 2];
        s[n + 16 >> 2] = s[f + 16 >> 2];
        s[n + 20 >> 2] = s[f + 20 >> 2];
        s[n + 24 >> 2] = s[f + 24 >> 2];
        s[n + 28 >> 2] = s[f + 28 >> 2];
        ka(o, n, 136, -460954743, -2016278654);
        s[i >> 2] = s[o >> 2];
        s[i + 4 >> 2] = s[o + 4 >> 2];
        s[i + 8 >> 2] = s[o + 8 >> 2];
        s[i + 12 >> 2] = s[o + 12 >> 2];
        s[i + 16 >> 2] = s[o + 16 >> 2];
        s[i + 20 >> 2] = s[o + 20 >> 2];
        s[i + 24 >> 2] = s[o + 24 >> 2];
        s[i + 28 >> 2] = s[o + 28 >> 2];
        Ra(i, 136);
        s[c >> 2] = s[i >> 2];
        s[c + 4 >> 2] = s[i + 4 >> 2];
        s[c + 8 >> 2] = s[i + 8 >> 2];
        s[c + 12 >> 2] = s[i + 12 >> 2];
        s[c + 16 >> 2] = s[i + 16 >> 2];
        s[c + 20 >> 2] = s[i + 20 >> 2];
        s[c + 24 >> 2] = s[i + 24 >> 2];
        s[c + 28 >> 2] = s[i + 28 >> 2];
        r = a + 32 | 0;
        s[r >> 2] = s[c >> 2];
        s[r + 4 >> 2] = s[c + 4 >> 2];
        s[r + 8 >> 2] = s[c + 8 >> 2];
        s[r + 12 >> 2] = s[c + 12 >> 2];
        s[r + 16 >> 2] = s[c + 16 >> 2];
        s[r + 20 >> 2] = s[c + 20 >> 2];
        s[r + 24 >> 2] = s[c + 24 >> 2];
        s[r + 28 >> 2] = s[c + 28 >> 2];
        r = e + 8 | 0;
        t = r + 64 | 0;

        do {
          s[r >> 2] = s[a >> 2];
          r = r + 4 | 0;
          a = a + 4 | 0;
        } while ((r | 0) < (t | 0));

        d = 1;
        f = 0;
        h = e;
        e = h;
        s[e >> 2] = d;
        h = h + 4 | 0;
        s[h >> 2] = f;
        p = l;
        return;
      }

      function Xa(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0,
            i = 0;
        r = p;
        p = p + 96 | 0;
        i = r + 64 | 0;
        o = r + 32 | 0;
        n = r;
        s[o >> 2] = s[t >> 2];
        s[o + 4 >> 2] = s[t + 4 >> 2];
        s[o + 8 >> 2] = s[t + 8 >> 2];
        s[o + 12 >> 2] = s[t + 12 >> 2];
        s[o + 16 >> 2] = s[t + 16 >> 2];
        s[o + 20 >> 2] = s[t + 20 >> 2];
        s[o + 24 >> 2] = s[t + 24 >> 2];
        s[o + 28 >> 2] = s[t + 28 >> 2];
        s[i >> 2] = s[a >> 2];
        s[i + 4 >> 2] = s[a + 4 >> 2];
        s[i + 8 >> 2] = s[a + 8 >> 2];
        s[i + 12 >> 2] = s[a + 12 >> 2];
        s[i + 16 >> 2] = s[a + 16 >> 2];
        s[i + 20 >> 2] = s[a + 20 >> 2];
        s[i + 24 >> 2] = s[a + 24 >> 2];
        s[i + 28 >> 2] = s[a + 28 >> 2];
        Ba(o, i, 136);
        s[e >> 2] = s[o >> 2];
        s[e + 4 >> 2] = s[o + 4 >> 2];
        s[e + 8 >> 2] = s[o + 8 >> 2];
        s[e + 12 >> 2] = s[o + 12 >> 2];
        s[e + 16 >> 2] = s[o + 16 >> 2];
        s[e + 20 >> 2] = s[o + 20 >> 2];
        s[e + 24 >> 2] = s[o + 24 >> 2];
        s[e + 28 >> 2] = s[o + 28 >> 2];
        t = t + 32 | 0;
        s[o >> 2] = s[t >> 2];
        s[o + 4 >> 2] = s[t + 4 >> 2];
        s[o + 8 >> 2] = s[t + 8 >> 2];
        s[o + 12 >> 2] = s[t + 12 >> 2];
        s[o + 16 >> 2] = s[t + 16 >> 2];
        s[o + 20 >> 2] = s[t + 20 >> 2];
        s[o + 24 >> 2] = s[t + 24 >> 2];
        s[o + 28 >> 2] = s[t + 28 >> 2];
        a = a + 32 | 0;
        s[i >> 2] = s[a >> 2];
        s[i + 4 >> 2] = s[a + 4 >> 2];
        s[i + 8 >> 2] = s[a + 8 >> 2];
        s[i + 12 >> 2] = s[a + 12 >> 2];
        s[i + 16 >> 2] = s[a + 16 >> 2];
        s[i + 20 >> 2] = s[a + 20 >> 2];
        s[i + 24 >> 2] = s[a + 24 >> 2];
        s[i + 28 >> 2] = s[a + 28 >> 2];
        Ba(o, i, 136);
        s[n >> 2] = s[o >> 2];
        s[n + 4 >> 2] = s[o + 4 >> 2];
        s[n + 8 >> 2] = s[o + 8 >> 2];
        s[n + 12 >> 2] = s[o + 12 >> 2];
        s[n + 16 >> 2] = s[o + 16 >> 2];
        s[n + 20 >> 2] = s[o + 20 >> 2];
        s[n + 24 >> 2] = s[o + 24 >> 2];
        s[n + 28 >> 2] = s[o + 28 >> 2];
        a = e + 32 | 0;
        s[a >> 2] = s[n >> 2];
        s[a + 4 >> 2] = s[n + 4 >> 2];
        s[a + 8 >> 2] = s[n + 8 >> 2];
        s[a + 12 >> 2] = s[n + 12 >> 2];
        s[a + 16 >> 2] = s[n + 16 >> 2];
        s[a + 20 >> 2] = s[n + 20 >> 2];
        s[a + 24 >> 2] = s[n + 24 >> 2];
        s[a + 28 >> 2] = s[n + 28 >> 2];
        p = r;
        return;
      }

      function $a(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0,
            i = 0;
        r = p;
        p = p + 96 | 0;
        i = r + 64 | 0;
        o = r + 32 | 0;
        n = r;
        s[o >> 2] = s[t >> 2];
        s[o + 4 >> 2] = s[t + 4 >> 2];
        s[o + 8 >> 2] = s[t + 8 >> 2];
        s[o + 12 >> 2] = s[t + 12 >> 2];
        s[o + 16 >> 2] = s[t + 16 >> 2];
        s[o + 20 >> 2] = s[t + 20 >> 2];
        s[o + 24 >> 2] = s[t + 24 >> 2];
        s[o + 28 >> 2] = s[t + 28 >> 2];
        s[i >> 2] = s[a >> 2];
        s[i + 4 >> 2] = s[a + 4 >> 2];
        s[i + 8 >> 2] = s[a + 8 >> 2];
        s[i + 12 >> 2] = s[a + 12 >> 2];
        s[i + 16 >> 2] = s[a + 16 >> 2];
        s[i + 20 >> 2] = s[a + 20 >> 2];
        s[i + 24 >> 2] = s[a + 24 >> 2];
        s[i + 28 >> 2] = s[a + 28 >> 2];
        Ea(o, i, 136);
        s[e >> 2] = s[o >> 2];
        s[e + 4 >> 2] = s[o + 4 >> 2];
        s[e + 8 >> 2] = s[o + 8 >> 2];
        s[e + 12 >> 2] = s[o + 12 >> 2];
        s[e + 16 >> 2] = s[o + 16 >> 2];
        s[e + 20 >> 2] = s[o + 20 >> 2];
        s[e + 24 >> 2] = s[o + 24 >> 2];
        s[e + 28 >> 2] = s[o + 28 >> 2];
        t = t + 32 | 0;
        s[o >> 2] = s[t >> 2];
        s[o + 4 >> 2] = s[t + 4 >> 2];
        s[o + 8 >> 2] = s[t + 8 >> 2];
        s[o + 12 >> 2] = s[t + 12 >> 2];
        s[o + 16 >> 2] = s[t + 16 >> 2];
        s[o + 20 >> 2] = s[t + 20 >> 2];
        s[o + 24 >> 2] = s[t + 24 >> 2];
        s[o + 28 >> 2] = s[t + 28 >> 2];
        a = a + 32 | 0;
        s[i >> 2] = s[a >> 2];
        s[i + 4 >> 2] = s[a + 4 >> 2];
        s[i + 8 >> 2] = s[a + 8 >> 2];
        s[i + 12 >> 2] = s[a + 12 >> 2];
        s[i + 16 >> 2] = s[a + 16 >> 2];
        s[i + 20 >> 2] = s[a + 20 >> 2];
        s[i + 24 >> 2] = s[a + 24 >> 2];
        s[i + 28 >> 2] = s[a + 28 >> 2];
        Ea(o, i, 136);
        s[n >> 2] = s[o >> 2];
        s[n + 4 >> 2] = s[o + 4 >> 2];
        s[n + 8 >> 2] = s[o + 8 >> 2];
        s[n + 12 >> 2] = s[o + 12 >> 2];
        s[n + 16 >> 2] = s[o + 16 >> 2];
        s[n + 20 >> 2] = s[o + 20 >> 2];
        s[n + 24 >> 2] = s[o + 24 >> 2];
        s[n + 28 >> 2] = s[o + 28 >> 2];
        a = e + 32 | 0;
        s[a >> 2] = s[n >> 2];
        s[a + 4 >> 2] = s[n + 4 >> 2];
        s[a + 8 >> 2] = s[n + 8 >> 2];
        s[a + 12 >> 2] = s[n + 12 >> 2];
        s[a + 16 >> 2] = s[n + 16 >> 2];
        s[a + 20 >> 2] = s[n + 20 >> 2];
        s[a + 24 >> 2] = s[n + 24 >> 2];
        s[a + 28 >> 2] = s[n + 28 >> 2];
        p = r;
        return;
      }

      function Qa(e, t, a, r) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        r = r | 0;
        var n = 0,
            o = 0,
            i = 0;
        o = 0 - a | 0;
        n = t + ((t + -1 + a & o) - t) | 0;

        if (n >>> 0 < t >>> 0) {
          s[e >> 2] = 0;
          return;
        }

        t = V(n, r) | 0;
        i = (r | 0) == 0;

        if (i ? 0 : ((t >>> 0) / ((i ? 1 : r) >>> 0) | 0 | 0) != (n | 0)) {
          s[e >> 2] = 0;
          return;
        }

        if ((a + -1 & (a | -2147483648) | 0) != 0 | t >>> 0 > o >>> 0) Kc(2128);
        s[e >> 2] = 1;
        s[e + 4 >> 2] = t;
        s[e + 8 >> 2] = a;
        s[e + 12 >> 2] = n;
        return;
      }

      function er(e) {
        e = e | 0;
        return;
      }

      function tr(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0;
        r = p;
        p = p + 16 | 0;
        n = Gt(8, 4, r) | 0;
        if (!n) Vt(r);else {
          s[n >> 2] = e;
          s[n + 4 >> 2] = t;
          yn(n, 2152, a);
        }
      }

      function ar(e) {
        e = e | 0;
        S = 286299353;
        return 1890621284;
      }

      function rr(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0;
        h = p;
        p = p + 32 | 0;
        o = h + 12 | 0;
        l = h;
        c = a << 1;
        if ((c | 0) < 0) Kc(2256);

        if (c) {
          i = Gt(c, 1, o) | 0;

          if (!i) {
            s[o >> 2] = 0;
            Vt(o);
          } else n = i;
        } else n = 1;

        s[l >> 2] = n;
        u = l + 4 | 0;
        s[u >> 2] = c;
        d = l + 8 | 0;
        s[d >> 2] = 0;
        f = t + a | 0;

        if (!a) {
          s[e >> 2] = s[l >> 2];
          s[e + 4 >> 2] = s[l + 4 >> 2];
          s[e + 8 >> 2] = s[l + 8 >> 2];
          p = h;
          return;
        }

        n = 0;
        i = c;

        while (1) {
          a = t + 1 | 0;
          t = r[t >> 0] | 0;
          o = r[2168 + ((t & 255) >>> 4 & 255) >> 0] | 0;

          if ((n | 0) == (i | 0)) {
            m = 0;
            ee(43, l | 0);
            c = m;
            m = 0;

            if (c & 1) {
              n = 7;
              break;
            }

            n = s[d >> 2] | 0;
          }

          r[(s[l >> 2] | 0) + n >> 0] = o;
          n = (s[d >> 2] | 0) + 1 | 0;
          s[d >> 2] = n;
          o = r[2168 + (t & 15) >> 0] | 0;

          if ((n | 0) == (s[u >> 2] | 0)) {
            m = 0;
            ee(43, l | 0);
            c = m;
            m = 0;

            if (c & 1) {
              n = 7;
              break;
            }

            n = s[d >> 2] | 0;
          }

          r[(s[l >> 2] | 0) + n >> 0] = o;
          n = (s[d >> 2] | 0) + 1 | 0;
          s[d >> 2] = n;

          if ((a | 0) == (f | 0)) {
            n = 17;
            break;
          }

          t = a;
          i = s[u >> 2] | 0;
        }

        if ((n | 0) == 7) {
          h = me() | 0;
          nr(l);
          Ee(h | 0);
        } else if ((n | 0) == 17) {
          s[e >> 2] = s[l >> 2];
          s[e + 4 >> 2] = s[l + 4 >> 2];
          s[e + 8 >> 2] = s[l + 8 >> 2];
          p = h;
          return;
        }
      }

      function nr(e) {
        e = e | 0;
        var t = 0;
        t = s[e + 4 >> 2] | 0;
        if (!t) return;
        Ut(s[e >> 2] | 0, t, 1);
        return;
      }

      function sr(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0;
        c = p;
        p = p + 64 | 0;
        a = c + 32 | 0;
        r = c + 8 | 0;
        n = c + 4 | 0;
        o = c;
        i = s[e >> 2] | 0;

        if ((i | 0) == 1114112) {
          s[a >> 2] = 2184;
          s[a + 4 >> 2] = 1;
          s[a + 8 >> 2] = 0;
          s[a + 16 >> 2] = 15892;
          s[a + 20 >> 2] = 0;
          i = fc(t, a) | 0;
          p = c;
          return i | 0;
        } else {
          s[o >> 2] = i;
          s[n >> 2] = s[e + 4 >> 2];
          s[a >> 2] = o;
          s[a + 4 >> 2] = 38;
          s[a + 8 >> 2] = n;
          s[a + 12 >> 2] = 39;
          s[r >> 2] = 2192;
          s[r + 4 >> 2] = 2;
          s[r + 8 >> 2] = 5264;
          s[r + 12 >> 2] = 2;
          s[r + 16 >> 2] = a;
          s[r + 20 >> 2] = 2;
          i = fc(t, r) | 0;
          p = c;
          return i | 0;
        }

        return 0;
      }

      function or(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0;
        g = p;
        p = p + 48 | 0;
        b = g + 24 | 0;
        y = g + 12 | 0;
        _ = g;
        c = a >>> 1;

        if (c) {
          i = Gt(c, 1, b) | 0;

          if (!i) {
            s[b >> 2] = 0;
            Vt(b);
          } else o = i;
        } else o = 1;

        s[_ >> 2] = o;
        v = _ + 4 | 0;
        s[v >> 2] = c;
        l = _ + 8 | 0;
        s[l >> 2] = 0;
        h = t + a | 0;
        o = 0;
        u = 0;
        c = 0;
        i = t;

        e: while (1) {
          if ((i | 0) == (h | 0)) {
            n = 0;
            o = 7;
            break;
          } else f = u;

          while (1) {
            d = i;
            i = i + 1 | 0;
            d = r[d >> 0] | 0;
            u = f;
            f = f + 1 | 0;

            if ((d + -65 & 255) < 6) {
              u = -55;
              break;
            }

            if ((d + -97 & 255) < 6) {
              u = -87;
              break;
            }

            if ((d + -48 & 255) < 10) {
              u = -48;
              break;
            }

            switch (d << 24 >> 24) {
              case 9:
              case 10:
              case 13:
              case 32:
                break;

              default:
                {
                  c = u;
                  o = 10;
                  break e;
                }
            }

            if ((i | 0) == (h | 0)) {
              n = 0;
              o = 7;
              break e;
            } else c = c & 15;
          }

          if ((i | 0) == (h | 0)) {
            n = 1;
            o = 7;
            break;
          }

          d = u + d << 24 >> 24 | c << 4 & 255;

          while (1) {
            u = i;
            i = i + 1 | 0;
            u = r[u >> 0] | 0;
            c = f;
            f = f + 1 | 0;

            if ((u + -65 & 255) < 6) {
              c = -55;
              break;
            }

            if ((u + -97 & 255) < 6) {
              c = -87;
              break;
            }

            if ((u + -48 & 255) < 10) {
              c = -48;
              break;
            }

            switch (u << 24 >> 24) {
              case 9:
              case 10:
              case 13:
              case 32:
                break;

              default:
                {
                  o = 10;
                  break e;
                }
            }

            if ((i | 0) == (h | 0)) {
              n = 1;
              o = 7;
              break e;
            } else d = d & 15;
          }

          c = c + u << 24 >> 24 | d << 4 & 255;

          if ((o | 0) == (s[v >> 2] | 0)) {
            m = 0;
            ee(43, _ | 0);
            d = m;
            m = 0;

            if (d & 1) {
              o = 6;
              break;
            }

            o = s[l >> 2] | 0;
          }

          r[(s[_ >> 2] | 0) + o >> 0] = c;
          o = (s[l >> 2] | 0) + 1 | 0;
          s[l >> 2] = o;
          u = f;
        }

        if ((o | 0) == 6) {
          g = me() | 0;
          nr(_);
          Ee(g | 0);
        } else if ((o | 0) == 7) {
          if (n) {
            s[e >> 2] = 1;
            s[e + 4 >> 2] = 1114112;
            n = s[v >> 2] | 0;
            if (n | 0) Ut(s[_ >> 2] | 0, n, 1);
          } else {
            s[b >> 2] = s[_ >> 2];
            s[b + 4 >> 2] = s[_ + 4 >> 2];
            s[b + 8 >> 2] = s[_ + 8 >> 2];
            v = s[b >> 2] | 0;
            _ = v + (s[b + 8 >> 2] | 0) | 0;
            t = s[b + 4 >> 2] | 0;
            s[b >> 2] = v;
            s[b + 4 >> 2] = t;
            s[b + 8 >> 2] = v;
            s[b + 12 >> 2] = _;
            ir(y, b);
            s[e >> 2] = 0;
            _ = e + 4 | 0;
            s[_ >> 2] = s[y >> 2];
            s[_ + 4 >> 2] = s[y + 4 >> 2];
            s[_ + 8 >> 2] = s[y + 8 >> 2];
          }

          p = g;
          return;
        } else if ((o | 0) == 10) {
          do {
            if ((c | 0) == 0 | (c | 0) == (a | 0)) n = t + c | 0;else {
              if (c >>> 0 < a >>> 0 ? (n = t + c | 0, (r[n >> 0] | 0) > -65) : 0) break;
              m = 0;
              ie(5, t | 0, a | 0, c | 0, a | 0);
              m = 0;
              g = me() | 0;
              nr(_);
              Ee(g | 0);
            }
          } while (0);

          f = t + c + (a - c) | 0;
          a = (n | 0) == (f | 0);
          o = a ? n : t + c + 1 | 0;

          do {
            if (!a) {
              u = r[n >> 0] | 0;

              if (u << 24 >> 24 <= -1) {
                d = u & 31;

                if ((o | 0) == (f | 0)) {
                  n = 0;
                  i = f;
                } else {
                  n = r[o >> 0] & 63;
                  i = o + 1 | 0;
                }

                o = n & 255;
                n = o | d << 6;

                if ((u & 255) > 223) {
                  if ((i | 0) == (f | 0)) {
                    n = 0;
                    i = f;
                  } else {
                    n = r[i >> 0] & 63;
                    i = i + 1 | 0;
                  }

                  o = n & 255 | o << 6;
                  n = o | d << 12;

                  if ((u & 255) > 239) {
                    if ((i | 0) == (f | 0)) n = 0;else n = r[i >> 0] & 63;
                    n = o << 6 | d << 18 & 1835008 | n & 255;
                    if ((n | 0) == 1114112) break;
                  }
                }
              } else n = u & 255;

              s[e >> 2] = 1;
              s[e + 4 >> 2] = n;
              s[e + 8 >> 2] = c;
              n = s[v >> 2] | 0;
              if (n | 0) Ut(s[_ >> 2] | 0, n, 1);
              p = g;
              return;
            }
          } while (0);

          m = 0;
          ee(44, 2208);
          m = 0;
          g = me() | 0;
          nr(_);
          Ee(g | 0);
        }
      }

      function ir(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0;
        i = p;
        p = p + 32 | 0;
        c = i + 16 | 0;
        u = i;
        a = s[t >> 2] | 0;

        if ((a | 0) == (s[t + 8 >> 2] | 0)) {
          c = s[t + 4 >> 2] | 0;
          u = (s[t + 12 >> 2] | 0) - a | 0;
          s[e >> 2] = a;
          s[e + 4 >> 2] = c;
          s[e + 8 >> 2] = u;
          p = i;
          return;
        }

        s[u >> 2] = 1;
        s[u + 4 >> 2] = 0;
        o = u + 8 | 0;
        s[o >> 2] = 0;
        s[c >> 2] = s[t >> 2];
        s[c + 4 >> 2] = s[t + 4 >> 2];
        s[c + 8 >> 2] = s[t + 8 >> 2];
        s[c + 12 >> 2] = s[t + 12 >> 2];
        a = c + 8 | 0;
        t = s[a >> 2] | 0;
        r = s[c + 12 >> 2] | 0;
        n = r - t | 0;
        m = 0;
        re(20, u | 0, 0, n | 0);
        d = m;
        m = 0;

        if (d & 1) {
          a = me() | 0;
          m = 0;
          ee(45, c | 0);
          d = m;
          m = 0;

          if (!(d & 1)) {
            d = a;
            cr(u);
            Ee(d | 0);
          }

          d = me() | 0;
          cr(u);
          Ee(d | 0);
        } else {
          d = s[o >> 2] | 0;
          id((s[u >> 2] | 0) + d | 0, t | 0, n | 0) | 0;
          s[o >> 2] = d + n;
          s[a >> 2] = r;
          a = s[c + 4 >> 2] | 0;
          if (a | 0) Ut(s[c >> 2] | 0, a, 1);
          s[e >> 2] = s[u >> 2];
          s[e + 4 >> 2] = s[u + 4 >> 2];
          s[e + 8 >> 2] = s[u + 8 >> 2];
          p = i;
          return;
        }
      }

      function cr(e) {
        e = e | 0;
        var t = 0;
        t = s[e + 4 >> 2] | 0;
        if (!t) return;
        Ut(s[e >> 2] | 0, t, 1);
        return;
      }

      function ur(e) {
        e = e | 0;
        var t = 0,
            a = 0;
        t = e + 8 | 0;
        a = s[e + 12 >> 2] | 0;
        if ((s[t >> 2] | 0) != (a | 0)) s[t >> 2] = a;
        t = s[e + 4 >> 2] | 0;
        if (!t) return;
        Ut(s[e >> 2] | 0, t, 1);
        return;
      }

      function dr(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0;
        o = p;
        p = p + 16 | 0;
        r = o;
        n = e + 4 | 0;
        t = s[n >> 2] | 0;

        if (t | 0) {
          a = t << 1;
          if ((a | 0) < 0) Kc(2256);
          t = Ht(s[e >> 2] | 0, t, 1, a, 1, r) | 0;

          if (!t) {
            c = r + 4 | 0;
            u = s[c >> 2] | 0;
            c = s[c + 4 >> 2] | 0;
            s[r >> 2] = s[r >> 2];
            i = r + 4 | 0;
            s[i >> 2] = u;
            s[i + 4 >> 2] = c;
            Vt(r);
          }

          i = t;
          c = e;
          u = a;
          s[c >> 2] = i;
          s[n >> 2] = u;
          p = o;
          return;
        }

        lr(r, 1, 1, 4);

        if ((s[r >> 2] | 0) == 1) {
          t = s[r + 4 >> 2] | 0;

          if (t | 0 ? (a = Gt(t, s[r + 8 >> 2] | 0, r) | 0, a | 0) : 0) {
            i = a;
            c = e;
            u = 4;
            s[c >> 2] = i;
            s[n >> 2] = u;
            p = o;
            return;
          }
        }

        s[r >> 2] = 1;
        s[r + 4 >> 2] = 6818;
        s[r + 8 >> 2] = 30;
        Vt(r);
      }

      function fr(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0;
        u = p;
        p = p + 16 | 0;
        i = u;
        c = e + 4 | 0;
        r = s[c >> 2] | 0;

        if ((r - t | 0) >>> 0 >= a >>> 0) {
          p = u;
          return;
        }

        a = t + a | 0;
        if (a >>> 0 < t >>> 0) Zc(6768, 17);
        o = r << 1;
        o = a >>> 0 >= o >>> 0 ? a : o;
        lr(i, 1, 1, o);
        if ((s[i >> 2] | 0) != 1) Kc(2232);
        a = s[i + 4 >> 2] | 0;
        t = s[i + 8 >> 2] | 0;
        if ((a | 0) < 0) Kc(2256);
        r = s[c >> 2] | 0;

        if (!r) {
          t = Gt(a, t, i) | 0;
          a = (t | 0) == 0 & 1;
          r = 0;
          n = 0;
        } else {
          t = Ht(s[e >> 2] | 0, r, 1, a, t, i) | 0;
          r = (t | 0) == 0;
          n = i + 4 | 0;
          a = r & 1;
          t = r ? s[i >> 2] | 0 : t;
          r = s[n >> 2] | 0;
          n = s[n + 4 >> 2] | 0;
        }

        if ((a | 0) == 1) {
          s[i >> 2] = t;
          a = i + 4 | 0;
          s[a >> 2] = r;
          s[a + 4 >> 2] = n;
          Vt(i);
        }

        s[e >> 2] = t;
        s[c >> 2] = o;
        p = u;
        return;
      }

      function lr(e, t, a, r) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        r = r | 0;
        var n = 0,
            o = 0,
            i = 0;
        o = 0 - a | 0;
        n = t + ((t + -1 + a & o) - t) | 0;

        if (n >>> 0 < t >>> 0) {
          s[e >> 2] = 0;
          return;
        }

        t = V(n, r) | 0;
        i = (r | 0) == 0;

        if (i ? 0 : ((t >>> 0) / ((i ? 1 : r) >>> 0) | 0 | 0) != (n | 0)) {
          s[e >> 2] = 0;
          return;
        }

        if ((a + -1 & (a | -2147483648) | 0) != 0 | t >>> 0 > o >>> 0) Kc(2280);
        s[e >> 2] = 1;
        s[e + 4 >> 2] = t;
        s[e + 8 >> 2] = a;
        s[e + 12 >> 2] = n;
        return;
      }

      function hr(e) {
        e = e | 0;
        S = 286299353;
        return 1890621284;
      }

      function pr(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0;
        u = p;
        p = p + 16 | 0;
        n = u;
        o = t + 8 | 0;
        c = o;
        i = s[c >> 2] | 0;
        c = s[c + 4 >> 2] | 0;
        r = s[t >> 2] | 0;
        d = lc(t) | 0;
        a = s[t >> 2] | 0;

        if (d) {
          a = a | 8;
          s[t >> 2] = a;

          if (!(s[o >> 2] | 0)) {
            s[o >> 2] = 1;
            s[t + 12 >> 2] = 10;
          }
        }

        s[t >> 2] = a | 4;
        s[n >> 2] = s[e >> 2];
        d = zi(n, t) | 0;
        s[o >> 2] = i;
        s[o + 4 >> 2] = c;
        s[t >> 2] = r;
        p = u;
        return d | 0;
      }

      function br(e, t) {
        e = e | 0;
        t = t | 0;
        return Ki(s[e >> 2] | 0, t) | 0;
      }

      function mr(e, t) {
        e = e | 0;
        t = t | 0;
        return Zi(s[e >> 2] | 0, t) | 0;
      }

      function yr(e, t) {
        e = e | 0;
        t = t | 0;
        return Ji(s[e >> 2] | 0, t) | 0;
      }

      function vr(e, t) {
        e = e | 0;
        t = t | 0;
        return vc(s[e >> 2] | 0, s[e + 4 >> 2] | 0, t) | 0;
      }

      function _r(e, t) {
        e = e | 0;
        t = t | 0;
        return Yi(s[e >> 2] | 0, t) | 0;
      }

      function gr(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0;
        a = s[t + 4 >> 2] | 0;
        if (!a) return;
        Ut(e, a, s[t + 8 >> 2] | 0);
        return;
      }

      function Ar(e) {
        e = e | 0;
        Ut(e, 12, 4);
        return;
      }

      function wr(e, t) {
        e = e | 0;
        t = t | 0;
        return ns(s[e >> 2] | 0, t) | 0;
      }

      function Tr(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0;
        l = p;
        p = p + 16 | 0;
        d = l;
        f = s[e >> 2] | 0;
        e = t >>> 0 < 65536;

        if (t >>> 0 < 128) {
          a = f + 8 | 0;
          e = s[a >> 2] | 0;

          if ((e | 0) == (s[f + 4 >> 2] | 0)) {
            go(f);
            e = s[a >> 2] | 0;
          }

          r[(s[f >> 2] | 0) + e >> 0] = t;
          s[a >> 2] = (s[a >> 2] | 0) + 1;
          p = l;
          return 0;
        }

        s[d >> 2] = 0;

        if (t >>> 0 < 2048) {
          c = 31;
          n = 0;
          o = -64;
          a = 1;
          e = 2;
        } else {
          if (e) {
            a = 15;
            n = 0;
            o = -32;
            i = 1;
            u = 2;
            e = 3;
          } else {
            r[d >> 0] = t >>> 18 & 255 | -16;
            a = 63;
            n = 1;
            o = -128;
            i = 2;
            u = 3;
            e = 4;
          }

          r[d + n >> 0] = a & t >>> 12 & 255 | o;
          c = 63;
          n = i;
          o = -128;
          a = u;
        }

        r[d + n >> 0] = c & t >>> 6 & 255 | o;
        r[d + a >> 0] = t & 63 | -128;
        u = f + 8 | 0;
        Ao(f, s[u >> 2] | 0, e);
        t = s[u >> 2] | 0;
        s[u >> 2] = t + e;
        id((s[f >> 2] | 0) + t | 0, d | 0, e | 0) | 0;
        p = l;
        return 0;
      }

      function xr(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0;
        a = p;
        p = p + 32 | 0;
        r = a + 8 | 0;
        n = a;
        s[n >> 2] = s[e >> 2];
        s[r >> 2] = s[t >> 2];
        s[r + 4 >> 2] = s[t + 4 >> 2];
        s[r + 8 >> 2] = s[t + 8 >> 2];
        s[r + 12 >> 2] = s[t + 12 >> 2];
        s[r + 16 >> 2] = s[t + 16 >> 2];
        s[r + 20 >> 2] = s[t + 20 >> 2];
        t = rc(n, 2672, r) | 0;
        p = a;
        return t | 0;
      }

      function Dr(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0;
        a = p;
        p = p + 32 | 0;
        r = a + 8 | 0;
        n = a;
        s[n >> 2] = s[e >> 2];
        s[r >> 2] = s[t >> 2];
        s[r + 4 >> 2] = s[t + 4 >> 2];
        s[r + 8 >> 2] = s[t + 8 >> 2];
        s[r + 12 >> 2] = s[t + 12 >> 2];
        s[r + 16 >> 2] = s[t + 16 >> 2];
        s[r + 20 >> 2] = s[t + 20 >> 2];
        t = rc(n, 3764, r) | 0;
        p = a;
        return t | 0;
      }

      function Cr(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0;
        r = s[e >> 2] | 0;
        n = r + 8 | 0;
        Ao(r, s[n >> 2] | 0, a);
        e = s[n >> 2] | 0;
        s[n >> 2] = e + a;
        id((s[r >> 2] | 0) + e | 0, t | 0, a | 0) | 0;
        return 0;
      }

      function Sr(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var n = 0,
            o = 0,
            i = 0,
            c = 0;
        i = p;
        p = p + 16 | 0;
        c = i;
        e = s[e >> 2] | 0;
        ui(c, s[e >> 2] | 0, t, a);

        if ((r[c >> 0] | 0) == 3) {
          c = 0;
          p = i;
          return c | 0;
        }

        o = c;
        n = s[o >> 2] | 0;
        o = s[o + 4 >> 2] | 0;
        t = e + 4 | 0;
        a = n & 255;

        if ((r[t >> 0] | 0) != 3 ? (m = 0, ee(46, t | 0), e = m, m = 0, e & 1) : 0) {
          e = me() | 0;
          i = t;
          s[i >> 2] = n;
          s[i + 4 >> 2] = o;
          if (a << 24 >> 24 != 3) Ee(e | 0);
          ts(c);
          Ee(e | 0);
        }

        c = t;
        s[c >> 2] = n;
        s[c + 4 >> 2] = o;
        c = 1;
        p = i;
        return c | 0;
      }

      function Er(e, t) {
        e = e | 0;
        t = t | 0;
        s[e >> 2] = 0;
        return;
      }

      function Br(e) {
        e = e | 0;
        S = 1307671337;
        return -1091417412;
      }

      function kr(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            r = 0,
            n = 0,
            o = 0;
        n = p;
        p = p + 32 | 0;
        r = n + 8 | 0;
        a = n;
        s[r >> 2] = s[e >> 2];
        s[r + 4 >> 2] = s[e + 4 >> 2];
        s[r + 8 >> 2] = s[e + 8 >> 2];
        s[r + 12 >> 2] = s[e + 12 >> 2];
        s[r + 16 >> 2] = s[e + 16 >> 2];
        s[r + 20 >> 2] = s[e + 20 >> 2];
        di(a, n + 32 | 0, r);
        r = s[a + 4 >> 2] | 0;

        switch ((s[a >> 2] & 255) << 24 >> 24) {
          case 0:
          case 1:
          case 3:
            {
              p = n;
              return;
            }

          default:
            {}
        }

        t = r;
        a = r;
        e = t + 4 | 0;
        m = 0;
        ee(s[s[e >> 2] >> 2] | 0, s[a >> 2] | 0);
        o = m;
        m = 0;

        if (o & 1) {
          o = me() | 0;
          gr(s[a >> 2] | 0, s[e >> 2] | 0);
          Ar(t);
          Ee(o | 0);
        }

        e = s[e >> 2] | 0;
        t = s[e + 4 >> 2] | 0;
        if (t | 0) Ut(s[r >> 2] | 0, t, s[e + 8 >> 2] | 0);
        Ut(r, 12, 4);
        p = n;
        return;
      }

      function Rr(e) {
        e = e | 0;
        var t = 0,
            a = 0;
        t = p;
        p = p + 32 | 0;
        a = t + 24 | 0;
        s[a >> 2] = e;
        s[a + 4 >> 2] = 40;
        s[t >> 2] = 2304;
        s[t + 4 >> 2] = 2;
        s[t + 8 >> 2] = 5180;
        s[t + 12 >> 2] = 1;
        s[t + 16 >> 2] = a;
        s[t + 20 >> 2] = 1;
        kr(t);
        Pe();
      }

      function Wr(e, t, a, n) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        n = n | 0;
        var o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0;
        f = p;
        p = p + 48 | 0;
        c = f;
        u = f + 40 | 0;
        i = f + 24 | 0;
        d = f + 12 | 0;
        o = f + 32 | 0;
        s[o >> 2] = e;
        s[o + 4 >> 2] = t;
        Ii(c, 6943, 4);
        s[u >> 2] = io(c) | 0;
        m = 0;
        ee(47, 3804);
        t = m;
        m = 0;

        if (t & 1) {
          f = me() | 0;
          jo(u);
          Ee(f | 0);
        }

        t = s[u >> 2] | 0;
        e = c;
        s[e >> 2] = 0;
        s[e + 4 >> 2] = 0;
        s[c + 8 >> 2] = t;
        ni(3804, c);
        vi(a, n);
        s[i >> 2] = 0;
        s[u >> 2] = 0;
        s[c >> 2] = o;

        if (!(Ci(48, c, i, u) | 0)) {
          e = 0;
          t = s[c >> 2] | 0;
        } else {
          e = Md[s[600] & 7]() | 0;
          if (!e) Fn(10081, 57);

          if ((s[e >> 2] | 0) == 1) {
            e = e + 4 | 0;
            t = s[e >> 2] | 0;
          } else {
            t = Md[s[2404 >> 2] & 7]() | 0;
            o = e;
            s[o >> 2] = 1;
            s[o + 4 >> 2] = t;
            e = e + 4 | 0;
          }

          t = t + -1 | 0;
          r[e >> 0] = t;
          r[e + 1 >> 0] = t >> 8;
          r[e + 2 >> 0] = t >> 16;
          r[e + 3 >> 0] = t >> 24;
          t = s[u >> 2] | 0;
          s[d + 4 >> 2] = s[i >> 2];
          e = 1;
        }

        s[d >> 2] = e;
        s[d + 4 + (e << 2) >> 2] = t;

        do {
          if ((s[3956] | 0) != 3) {
            r[u >> 0] = 1;
            s[c >> 2] = u;
            m = 0;
            ie(6, 15824, 0, c | 0, 3084);
            u = m;
            m = 0;
            if (!(u & 1)) break;
            f = me() | 0;
            Ir(d);
            Ee(f | 0);
          }
        } while (0);

        u = s[d >> 2] | 0;
        n = s[d + 4 >> 2] | 0;
        t = s[d + 8 >> 2] | 0;
        a = (u | 0) == 1 ? 101 : n;
        e = n;

        if (!u) {
          p = f;
          return a | 0;
        }

        m = 0;
        ee(s[t >> 2] | 0, e | 0);
        d = m;
        m = 0;

        if (d & 1) {
          f = me() | 0;
          Nr(e, t);
          Ee(f | 0);
        }

        e = s[t + 4 >> 2] | 0;

        if (!e) {
          p = f;
          return a | 0;
        }

        Ut(n, e, s[t + 8 >> 2] | 0);
        p = f;
        return a | 0;
      }

      function Ir(e) {
        e = e | 0;
        var t = 0,
            a = 0;
        if (!(s[e >> 2] | 0)) return;
        a = e + 4 | 0;
        e = e + 8 | 0;
        m = 0;
        ee(s[s[e >> 2] >> 2] | 0, s[a >> 2] | 0);
        t = m;
        m = 0;

        if (t & 1) {
          t = me() | 0;
          Nr(s[a >> 2] | 0, s[e >> 2] | 0);
          Ee(t | 0);
        }

        e = s[e >> 2] | 0;
        t = s[e + 4 >> 2] | 0;
        if (!t) return;
        Ut(s[a >> 2] | 0, t, s[e + 8 >> 2] | 0);
        return;
      }

      function Nr(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0;
        a = s[t + 4 >> 2] | 0;
        if (!a) return;
        Ut(e, a, s[t + 8 >> 2] | 0);
        return;
      }

      function Mr() {
        return 0;
      }

      function Pr(e, t) {
        e = e | 0;
        t = t | 0;
        s[e >> 2] = 6947;
        s[e + 4 >> 2] = 39;
        return;
      }

      function Lr(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0;
        a = p;
        p = p + 48 | 0;
        o = a + 40 | 0;
        n = a + 24 | 0;
        r = a;
        s[o >> 2] = 6947;
        s[o + 4 >> 2] = 39;
        s[n >> 2] = o;
        s[n + 4 >> 2] = 41;
        s[n + 8 >> 2] = e;
        s[n + 12 >> 2] = 42;
        s[r >> 2] = 2320;
        s[r + 4 >> 2] = 2;
        s[r + 8 >> 2] = 5264;
        s[r + 12 >> 2] = 2;
        s[r + 16 >> 2] = n;
        s[r + 20 >> 2] = 2;
        t = fc(t, r) | 0;
        p = a;
        return t | 0;
      }

      function Or(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var n = 0,
            o = 0,
            i = 0,
            c = 0;
        c = p;
        p = p + 32 | 0;
        o = c + 12 | 0;
        i = c + 24 | 0;
        n = c;
        s[n >> 2] = 0;
        s[n + 4 >> 2] = t;
        s[n + 8 >> 2] = a;
        t = at(43, n | 0) | 0;

        switch (t | 0) {
          case 9:
          case 5:
          case 3:
            {
              o = s[n >> 2] | 0;
              s[e >> 2] = 0;
              i = 0;
              i = e + 4 + (i << 2) | 0;
              s[i >> 2] = o;
              p = c;
              return;
            }

          default:
            {}
        }

        a = Gt(4, 4, o) | 0;
        if (!a) Vt(o);
        s[a >> 2] = t;
        t = Gt(12, 4, o) | 0;
        if (!t) Vt(o);
        s[t >> 2] = a;
        s[t + 4 >> 2] = 2696;
        r[t + 8 >> 0] = 16;
        o = t + 9 | 0;
        r[o >> 0] = r[i >> 0] | 0;
        r[o + 1 >> 0] = r[i + 1 >> 0] | 0;
        r[o + 2 >> 0] = r[i + 2 >> 0] | 0;
        s[e >> 2] = 1;
        s[e + 4 >> 2] = 2;
        i = 1;
        o = t;
        i = e + 4 + (i << 2) | 0;
        s[i >> 2] = o;
        p = c;
        return;
      }

      function Fr(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0;
        n = p;
        p = p + 16 | 0;
        a = n;
        s[a >> 2] = 0;
        e = ge(e | 0, a | 0) | 0;
        e = (((e | 0) != 0 & (s[a >> 2] | 0) == 0) << 31 >> 31) + e | 0;
        a = de(e | 0) | 0;
        r = s[t >> 2] | 0;

        if (r >>> 0 >= (s[t + 8 >> 2] | 0) >>> 0) {
          p = n;
          return 0;
        }

        o = s[t + 4 >> 2] | 0;
        s[o + (r << 3) >> 2] = e;
        s[o + (r << 3) + 4 >> 2] = a;
        s[t >> 2] = (s[t >> 2] | 0) + 1;
        p = n;
        return 0;
      }

      function jr(e, t, a, n, o) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        n = n | 0;
        o = o | 0;
        var i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0;
        i = p;
        p = p + 32 | 0;
        o = i;
        a = i + 16 | 0;
        s[a >> 2] = 0;
        s[a + 4 >> 2] = 0;
        s[a + 8 >> 2] = 0;
        s[a + 12 >> 2] = 0;

        do {
          if ((Ye(t | 0, a | 0) | 0) != 0 ? (l = s[a + 8 >> 2] | 0, (l | 0) != 0) : 0) {
            a = Cu(l) | 0;
            if ((a | 0) == -1) ru(-1, 0);else {
              xc(o, l, a);
              d = (s[o >> 2] | 0) == 1;
              c = d ? 0 : s[o + 4 >> 2] | 0;
              u = 0;
              d = d ? 0 : 0;
              f = s[o + 8 >> 2] | 0;
              break;
            }
          } else {
            c = 0;
            u = 0;
            d = 0;
            f = 0;
          }
        } while (0);

        h = s[n >> 2] | 0;
        l = s[n + 12 >> 2] | 0;
        b = s[h >> 2] | 0;
        h = s[h + 4 >> 2] | 0;
        a = s[s[n + 4 >> 2] >> 2] | 0;
        n = s[s[n + 8 >> 2] >> 2] | 0;
        t = s[n >> 2] | 0;
        n = s[n + 4 >> 2] | 0;
        m = o;
        s[m >> 2] = c | u;
        s[m + 4 >> 2] = d | f;
        mo(e, b, h, a, t, n, o, r[l >> 0] | 0);
        p = i;
        return;
      }

      function Gr(e, t, a, n, o) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        n = n | 0;
        o = o | 0;
        var i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0,
            A = 0,
            w = 0,
            T = 0,
            x = 0,
            D = 0,
            C = 0,
            E = 0,
            B = 0,
            k = 0,
            R = 0,
            W = 0,
            I = 0,
            N = 0,
            M = 0,
            P = 0,
            L = 0,
            O = 0,
            F = 0,
            j = 0,
            G = 0;
        G = p;
        p = p + 96 | 0;
        u = G;
        j = G + 80 | 0;
        a = G + 64 | 0;
        s[a >> 2] = 0;
        s[a + 4 >> 2] = 0;
        s[a + 8 >> 2] = 0;
        s[a + 12 >> 2] = 0;

        if (!(Ye(t | 0, a | 0) | 0)) {
          r[e >> 0] = 3;
          p = G;
          return;
        }

        a = s[a + 8 >> 2] | 0;

        if (!a) {
          r[e >> 0] = 3;
          p = G;
          return;
        }

        o = Cu(a) | 0;
        if ((o | 0) == -1) ru(-1, 0);
        xc(u, a, o);
        a = s[u + 4 >> 2] | 0;
        o = s[u + 8 >> 2] | 0;

        if ((s[u >> 2] | 0) == 1 | (a | 0) == 0) {
          r[e >> 0] = 3;
          p = G;
          return;
        }

        Wc(u, a, o, 6988, 28);
        B = s[u >> 2] | 0;

        do {
          if ((B | 0) == 1) {
            a = u + 8 | 0;
            o = s[u + 48 >> 2] | 0;
            t = s[u + 52 >> 2] | 0;
            i = s[u + 56 >> 2] | 0;
            c = s[u + 60 >> 2] | 0;

            if ((s[u + 36 >> 2] | 0) == -1) {
              Vr(j, a, o, t, i, c, 1);
              break;
            } else {
              Vr(j, a, o, t, i, c, 0);
              break;
            }
          } else {
            O = u + 28 | 0;
            k = u + 48 | 0;
            R = u + 52 | 0;
            F = u + 36 | 0;
            W = u + 56 | 0;
            I = u + 60 | 0;
            N = u + 8 | 0;
            M = u + 16 | 0;
            P = u + 24 | 0;
            L = u + 12 | 0;
            E = u + 4 | 0;
            a = 0;

            e: while (1) {
              if ((a | 0) == 1) {
                C = s[R >> 2] | 0;
                i = s[k >> 2] | 0;
                m = s[W >> 2] | 0;
                x = s[I >> 2] | 0;
                y = x + -1 | 0;
                _ = N;
                v = s[_ >> 2] | 0;
                _ = s[_ + 4 >> 2] | 0;
                g = s[M >> 2] | 0;
                t = s[P >> 2] | 0;
                A = x - t | 0;
                o = s[O >> 2] | 0;
                c = s[F >> 2] | 0;

                if ((o | 0) == (C | 0)) {
                  t = 61;
                  break;
                }

                D = (c | 0) == -1;
                u = y + o | 0;

                t: do {
                  if (u >>> 0 < C >>> 0) {
                    a = x + o | 0;
                    w = a + y | 0;
                    T = w >>> 0 < C >>> 0;
                    f = t + o | 0;
                    l = f + y | 0;
                    h = l >>> 0 < C >>> 0;
                    b = o + 1 - g | 0;
                    t = o;

                    while (1) {
                      a: while (1) {
                        while (1) {
                          if ((o | 0) != (t | 0)) {
                            o = c;
                            break t;
                          }

                          d = od(1, 0, r[i + u >> 0] & 63 | 0) | 0;
                          if (!((d & v | 0) == 0 & (S & _ | 0) == 0)) break;
                          c = D ? c : 0;

                          if (T) {
                            t = a;
                            u = w;
                          } else {
                            t = C;
                            o = c;
                            break t;
                          }
                        }

                        t = D ? g : c >>> 0 >= g >>> 0 ? c : g;

                        while (1) {
                          if (t >>> 0 >= x >>> 0) break a;
                          if (t >>> 0 > 4294967294) break a;
                          u = t + o | 0;

                          if (u >>> 0 >= C >>> 0) {
                            t = 45;
                            break e;
                          }

                          if ((r[m + t >> 0] | 0) == (r[i + u >> 0] | 0)) t = t + 1 | 0;else break;
                        }

                        t = b + t | 0;
                        c = D ? c : 0;
                        u = t + y | 0;

                        if (u >>> 0 >= C >>> 0) {
                          t = C;
                          o = c;
                          break t;
                        }
                      }

                      t = D ? 0 : c;
                      u = g;

                      do {
                        d = u;
                        u = u + -1 | 0;

                        if (t >>> 0 >= d >>> 0) {
                          t = 49;
                          break e;
                        }

                        if (u >>> 0 >= x >>> 0) {
                          t = 56;
                          break e;
                        }

                        d = u + o | 0;

                        if (d >>> 0 >= C >>> 0) {
                          t = 52;
                          break e;
                        }
                      } while ((r[m + u >> 0] | 0) == (r[i + d >> 0] | 0));

                      c = D ? c : A;

                      if (h) {
                        t = f;
                        u = l;
                      } else {
                        t = C;
                        o = c;
                        break;
                      }
                    }
                  } else {
                    t = C;
                    o = c;
                  }
                } while (0);

                t: do {
                  if ((t | 0) == 0 | (C | 0) == (t | 0)) a = t;else {
                    a = t;

                    do {
                      if (C >>> 0 > a >>> 0 ? (r[i + a >> 0] | 0) > -65 : 0) break t;
                      a = a + 1 | 0;
                    } while (!((a | 0) == 0 | (C | 0) == (a | 0)));
                  }
                } while (0);

                s[O >> 2] = t >>> 0 >= a >>> 0 ? t : a;
                s[F >> 2] = o;
                o = C;
              } else {
                o = s[R >> 2] | 0;
                i = s[k >> 2] | 0;
              }

              d = (r[L >> 0] | 0) != 0;
              r[L >> 0] = (d ^ 1) & 1;
              f = s[E >> 2] | 0;

              if (!((f | 0) == 0 | (o | 0) == (f | 0))) {
                if (o >>> 0 <= f >>> 0) {
                  t = 13;
                  break;
                }

                a = i + f | 0;

                if ((r[a >> 0] | 0) <= -65) {
                  t = 13;
                  break;
                }
              } else a = i + f | 0;

              u = i + f + (o - f) | 0;
              C = (a | 0) == (u | 0);
              o = C ? a : i + f + 1 | 0;

              do {
                if (!C) {
                  i = r[a >> 0] | 0;

                  if (i << 24 >> 24 > -1) {
                    a = i & 255;
                    break;
                  }

                  c = i & 31;

                  if ((o | 0) == (u | 0)) {
                    a = 0;
                    t = u;
                  } else {
                    a = r[o >> 0] & 63;
                    t = o + 1 | 0;
                  }

                  o = a & 255;
                  a = o | c << 6;

                  if ((i & 255) > 223) {
                    if ((t | 0) == (u | 0)) {
                      a = 0;
                      t = u;
                    } else {
                      a = r[t >> 0] & 63;
                      t = t + 1 | 0;
                    }

                    o = a & 255 | o << 6;
                    a = o | c << 12;

                    if ((i & 255) > 239) {
                      if ((t | 0) == (u | 0)) a = 0;else a = r[t >> 0] & 63;
                      a = o << 6 | c << 18 & 1835008 | a & 255;
                    }
                  }
                } else a = 1114112;
              } while (0);

              if (d) {
                o = f;
                a = f;
                t = 63;
                break;
              }

              if ((a | 0) == 1114112) {
                t = 62;
                break;
              }

              s[E >> 2] = (a >>> 0 < 128 ? 1 : a >>> 0 < 2048 ? 2 : a >>> 0 < 65536 ? 3 : 4) + f;
              a = B;
            }

            if ((t | 0) == 13) Sc(i, o, f, o);else if ((t | 0) == 45) Yc(2336, u, C);else if ((t | 0) == 49) {
              s[F >> 2] = c;
              s[O >> 2] = a;
              if (D) t = 63;else {
                s[F >> 2] = 0;
                t = 63;
              }
            } else if ((t | 0) == 52) Yc(2336, d, C);else if ((t | 0) == 56) Yc(2352, u, x);else if ((t | 0) == 61) {
              s[O >> 2] = C;
              t = 62;
            }

            if ((t | 0) == 62) {
              s[j >> 2] = 0;
              break;
            } else if ((t | 0) == 63) {
              s[j >> 2] = 1;
              s[j + 4 >> 2] = o;
              s[j + 8 >> 2] = a;
              break;
            }
          }
        } while (0);

        if ((s[j >> 2] | 0) != 1) {
          r[e >> 0] = 3;
          p = G;
          return;
        }

        r[n >> 0] = 1;
        r[e >> 0] = 3;
        p = G;
        return;
      }

      function Vr(e, t, a, n, o, i, c) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        n = n | 0;
        o = o | 0;
        i = i | 0;
        c = c | 0;
        var u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            p = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0;
        _ = t + 20 | 0;
        y = i + -1 | 0;
        d = s[_ >> 2] | 0;
        u = d + y | 0;

        e: do {
          if (u >>> 0 < n >>> 0) {
            v = t + 28 | 0;
            b = t;
            p = s[b >> 2] | 0;
            b = s[b + 4 >> 2] | 0;
            m = s[t + 8 >> 2] | 0;
            l = s[t + 16 >> 2] | 0;
            h = i - l | 0;
            t = d;

            t: while (1) {
              a: while (1) {
                f = t;

                while (1) {
                  d = od(1, 0, r[a + u >> 0] & 63 | 0) | 0;
                  if (!((d & p | 0) == 0 & (S & b | 0) == 0)) break;
                  t = f + i | 0;
                  s[_ >> 2] = t;
                  if (!c) s[v >> 2] = 0;
                  u = t + y | 0;
                  if (u >>> 0 >= n >>> 0) break e;else f = t;
                }

                if (c) t = m;else {
                  t = s[v >> 2] | 0;
                  t = t >>> 0 >= m >>> 0 ? t : m;
                }

                do {
                  if (t >>> 0 >= i >>> 0) break a;
                  u = t;
                  t = t + 1 | 0;
                  if (u >>> 0 > 4294967294) break a;
                  d = f + u | 0;

                  if (d >>> 0 >= n >>> 0) {
                    t = 17;
                    break t;
                  }
                } while ((r[o + u >> 0] | 0) == (r[a + d >> 0] | 0));

                t = t + f - m | 0;
                s[_ >> 2] = t;
                if (!c) s[v >> 2] = 0;
                u = t + y | 0;
                if (u >>> 0 >= n >>> 0) break e;
              }

              t = c ? 0 : s[v >> 2] | 0;
              u = m;

              do {
                d = u;
                u = u + -1 | 0;

                if (t >>> 0 >= d >>> 0) {
                  t = 23;
                  break t;
                }

                if (u >>> 0 >= i >>> 0) {
                  t = 33;
                  break t;
                }

                d = u + f | 0;

                if (d >>> 0 >= n >>> 0) {
                  t = 26;
                  break t;
                }
              } while ((r[o + u >> 0] | 0) == (r[a + d >> 0] | 0));

              t = l + f | 0;
              s[_ >> 2] = t;
              if (!c) s[v >> 2] = h;
              u = t + y | 0;
              if (u >>> 0 >= n >>> 0) break e;
            }

            if ((t | 0) == 17) Yc(2336, d, n);else if ((t | 0) == 23) {
              t = f + i | 0;
              s[_ >> 2] = t;
              if (!c) s[v >> 2] = 0;
              s[e >> 2] = 1;
              s[e + 4 >> 2] = f;
              s[e + 8 >> 2] = t;
              return;
            } else if ((t | 0) == 26) Yc(2336, d, n);else if ((t | 0) == 33) Yc(2352, u, i);
          }
        } while (0);

        s[_ >> 2] = n;
        s[e >> 2] = 0;
        return;
      }

      function Ur(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0;
        a = p;
        p = p + 16 | 0;
        n = a + 12 | 0;
        r = a;
        pc(r, t, 7086, 11);
        s[n >> 2] = e;
        Lc(r, n, 2368) | 0;
        t = Oc(r) | 0;
        p = a;
        return t | 0;
      }

      function Hr(e) {
        e = e | 0;
        return;
      }

      function zr(e, t) {
        e = e | 0;
        t = t | 0;
        return Ri(s[e >> 2] | 0, t) | 0;
      }

      function Kr(e, t) {
        e = e | 0;
        t = t | 0;
        return Bs(s[e >> 2] | 0, s[e + 4 >> 2] | 0, t) | 0;
      }

      function qr(e) {
        e = e | 0;
        return;
      }

      function Yr() {
        var e = 0,
            t = 0,
            a = 0,
            r = 0;
        r = p;
        p = p + 16 | 0;
        t = r;
        e = s[602] | 0;
        if (!e) e = zo(2408) | 0;
        e = Re(e | 0) | 0;

        switch (e | 0) {
          case 0:
            {
              a = Gt(12, 4, t) | 0;
              if (!a) Vt(t);
              s[a >> 2] = 2408;
              t = a + 4 | 0;
              e = t;
              s[e >> 2] = 0;
              s[e + 4 >> 2] = 0;
              e = s[602] | 0;
              if (!e) e = zo(2408) | 0;
              qe(e | 0, a | 0) | 0;
              a = t;
              p = r;
              return a | 0;
            }

          case 1:
            {
              a = 0;
              p = r;
              return a | 0;
            }

          default:
            {
              a = e + 4 | 0;
              p = r;
              return a | 0;
            }
        }

        return 0;
      }

      function Zr() {
        return 0;
      }

      function Jr(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0;
        o = p;
        p = p + 16 | 0;
        a = o;
        s[a >> 2] = e;
        n = s[e >> 2] | 0;
        t = s[n >> 2] | 0;

        if (!t) {
          m = 0;
          t = ae(11, n | 0) | 0;
          i = m;
          m = 0;

          if (i & 1) {
            me() | 0;
            Xr(a);
            et();
          } else r = t;
        } else r = t;

        qe(r | 0, 1) | 0;
        Ut(e, 12, 4);
        t = s[n >> 2] | 0;

        if (t | 0) {
          i = t;
          qe(i | 0, 0) | 0;
          p = o;
          return;
        }

        m = 0;
        t = ae(11, n | 0) | 0;
        i = m;
        m = 0;

        if (!(i & 1)) {
          i = t;
          qe(i | 0, 0) | 0;
          p = o;
          return;
        }

        me() | 0;
        et();
      }

      function Xr(e) {
        e = e | 0;
        Ut(s[e >> 2] | 0, 12, 4);
        return;
      }

      function $r(e) {
        e = e | 0;
        var t = 0;
        t = s[e + 4 >> 2] | 0;
        if (!t) return;
        Ut(s[e >> 2] | 0, t, 1);
        return;
      }

      function Qr(e) {
        e = e | 0;
        return;
      }

      function en(e) {
        e = e | 0;
        var t = 0,
            a = 0;
        t = e + 4 | 0;
        m = 0;
        ee(s[s[t >> 2] >> 2] | 0, s[e >> 2] | 0);
        a = m;
        m = 0;

        if (a & 1) {
          a = me() | 0;
          tn(s[e >> 2] | 0, s[t >> 2] | 0);
          Ee(a | 0);
        }

        t = s[t >> 2] | 0;
        a = s[t + 4 >> 2] | 0;
        if (!a) return;
        Ut(s[e >> 2] | 0, a, s[t + 8 >> 2] | 0);
        return;
      }

      function tn(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0;
        a = s[t + 4 >> 2] | 0;
        if (!a) return;
        Ut(e, a, s[t + 8 >> 2] | 0);
        return;
      }

      function an(e) {
        e = e | 0;
        var t = 0;
        t = s[e + 4 >> 2] | 0;
        if (!t) return;
        Ut(s[e >> 2] | 0, t, 1);
        return;
      }

      function rn(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            r = 0,
            n = 0;
        n = p;
        p = p + 16 | 0;
        r = n;
        t = s[e >> 2] | 0;
        if (!t) t = zo(e) | 0;
        t = Re(t | 0) | 0;

        switch (t | 0) {
          case 0:
            {
              a = Gt(20, 4, r) | 0;
              if (!a) Vt(r);
              s[a >> 2] = e;
              s[a + 8 >> 2] = 3;
              t = s[e >> 2] | 0;
              if (!t) t = zo(e) | 0;
              qe(t | 0, a | 0) | 0;
              e = a + 4 | 0;
              p = n;
              return e | 0;
            }

          case 1:
            {
              e = 0;
              p = n;
              return e | 0;
            }

          default:
            {
              e = t + 4 | 0;
              p = n;
              return e | 0;
            }
        }

        return 0;
      }

      function nn(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            r = 0,
            n = 0;
        n = p;
        p = p + 16 | 0;
        a = n;
        t = s[e >> 2] | 0;
        if (!t) t = zo(e) | 0;
        t = Re(t | 0) | 0;

        switch (t | 0) {
          case 0:
            {
              r = Gt(20, 4, a) | 0;
              if (!r) Vt(a);
              s[r >> 2] = e;
              a = r + 4 | 0;
              s[a >> 2] = 0;
              t = s[e >> 2] | 0;
              if (!t) t = zo(e) | 0;
              qe(t | 0, r | 0) | 0;
              e = a;
              p = n;
              return e | 0;
            }

          case 1:
            {
              e = 0;
              p = n;
              return e | 0;
            }

          default:
            {
              e = t + 4 | 0;
              p = n;
              return e | 0;
            }
        }

        return 0;
      }

      function sn(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0;
        i = p;
        p = p + 16 | 0;
        a = i + 4 | 0;
        n = i;
        s[n >> 2] = e;
        o = s[e >> 2] | 0;
        t = s[o >> 2] | 0;

        if (!t) {
          m = 0;
          t = ae(11, o | 0) | 0;
          c = m;
          m = 0;

          if (c & 1) {
            me() | 0;
            on(n);
            et();
          } else r = t;
        } else r = t;

        qe(r | 0, 1) | 0;
        s[a >> 2] = e;
        m = 0;
        ee(49, a | 0);
        c = m;
        m = 0;

        if (!(c & 1)) {
          e = s[o >> 2] | 0;

          if (e | 0) {
            c = e;
            qe(c | 0, 0) | 0;
            p = i;
            return;
          }

          m = 0;
          e = ae(11, o | 0) | 0;
          c = m;
          m = 0;

          if (!(c & 1)) {
            c = e;
            qe(c | 0, 0) | 0;
            p = i;
            return;
          }
        }

        me() | 0;
        et();
      }

      function on(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            r = 0;
        t = s[e >> 2] | 0;

        if (s[t + 4 >> 2] | 0 ? (r = t + 12 | 0, a = s[r >> 2] | 0, a | 0) : 0) {
          t = t + 16 | 0;
          m = 0;
          ee(s[s[t >> 2] >> 2] | 0, a | 0);
          a = m;
          m = 0;

          if (a & 1) {
            a = me() | 0;
            cn(s[r >> 2] | 0, s[t >> 2] | 0);
            un(s[e >> 2] | 0);
            Ee(a | 0);
          }

          t = s[t >> 2] | 0;
          a = s[t + 4 >> 2] | 0;
          if (a | 0) Ut(s[r >> 2] | 0, a, s[t + 8 >> 2] | 0);
        }

        Ut(s[e >> 2] | 0, 20, 4);
        return;
      }

      function cn(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0;
        a = s[t + 4 >> 2] | 0;
        if (!a) return;
        Ut(e, a, s[t + 8 >> 2] | 0);
        return;
      }

      function un(e) {
        e = e | 0;
        Ut(e, 20, 4);
        return;
      }

      function dn(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0;
        i = p;
        p = p + 16 | 0;
        a = i;
        s[a >> 2] = e;
        o = s[e >> 2] | 0;
        t = s[o >> 2] | 0;

        if (!t) {
          m = 0;
          t = ae(11, o | 0) | 0;
          c = m;
          m = 0;

          if (c & 1) {
            me() | 0;
            ln(a);
            et();
          } else n = t;
        } else n = t;

        qe(n | 0, 1) | 0;

        if (((s[e + 8 >> 2] & 2 | 0) == 0 ? (r = e + 16 | 0, n = s[r >> 2] | 0, c = s[n >> 2] | 0, s[n >> 2] = c - 1, (c | 0) == 1) : 0) ? (m = 0, ee(50, r | 0), c = m, m = 0, c & 1) : 0) {
          me() | 0;
          fn(e);
          et();
        }

        Ut(e, 20, 4);
        t = s[o >> 2] | 0;

        if (t | 0) {
          c = t;
          qe(c | 0, 0) | 0;
          p = i;
          return;
        }

        m = 0;
        t = ae(11, o | 0) | 0;
        c = m;
        m = 0;

        if (!(c & 1)) {
          c = t;
          qe(c | 0, 0) | 0;
          p = i;
          return;
        }

        me() | 0;
        et();
      }

      function fn(e) {
        e = e | 0;
        Ut(e, 20, 4);
        return;
      }

      function ln(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            r = 0;
        t = s[e >> 2] | 0;

        if (((s[t + 8 >> 2] & 2 | 0) == 0 ? (a = t + 16 | 0, r = s[a >> 2] | 0, t = s[r >> 2] | 0, s[r >> 2] = t - 1, (t | 0) == 1) : 0) ? (m = 0, ee(50, a | 0), r = m, m = 0, r & 1) : 0) {
          r = me() | 0;
          fn(s[e >> 2] | 0);
          Ee(r | 0);
        }

        Ut(s[e >> 2] | 0, 20, 4);
        return;
      }

      function hn(e) {
        e = e | 0;
        return e | 0;
      }

      function pn(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0;
        r = p;
        p = p + 16 | 0;
        n = Gt(8, 4, r) | 0;
        if (!n) Vt(r);else {
          s[n >> 2] = e;
          s[n + 4 >> 2] = t;
          yn(n, 2432, a);
        }
      }

      function bn(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0;
        r = p;
        p = p + 48 | 0;
        a = r + 16 | 0;
        s[r >> 2] = 1;
        s[r + 4 >> 2] = 0;
        s[r + 8 >> 2] = 0;
        s[a >> 2] = s[e >> 2];
        s[a + 4 >> 2] = s[e + 4 >> 2];
        s[a + 8 >> 2] = s[e + 8 >> 2];
        s[a + 12 >> 2] = s[e + 12 >> 2];
        s[a + 16 >> 2] = s[e + 16 >> 2];
        s[a + 20 >> 2] = s[e + 20 >> 2];
        m = 0;
        se(44, r | 0, a | 0) | 0;
        e = m;
        m = 0;

        if (e & 1) {
          a = me() | 0;
          $r(r);
          Ee(a | 0);
        } else {
          s[a >> 2] = s[r >> 2];
          s[a + 4 >> 2] = s[r + 4 >> 2];
          s[a + 8 >> 2] = s[r + 8 >> 2];
          mn(a, t);
        }
      }

      function mn(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0;
        r = p;
        p = p + 32 | 0;
        a = r + 12 | 0;
        s[r >> 2] = s[e >> 2];
        s[r + 4 >> 2] = s[e + 4 >> 2];
        s[r + 8 >> 2] = s[e + 8 >> 2];
        e = Gt(12, 4, a) | 0;
        if (!e) Vt(a);else {
          s[e >> 2] = s[r >> 2];
          s[e + 4 >> 2] = s[r + 4 >> 2];
          s[e + 8 >> 2] = s[r + 8 >> 2];
          yn(e, 2416, t);
        }
      }

      function yn(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            y = 0,
            v = 0,
            _ = 0;
        y = p;
        p = p + 80 | 0;
        h = y + 56 | 0;
        b = y + 32 | 0;
        d = y + 8 | 0;
        s[y >> 2] = e;
        s[y + 4 >> 2] = t;
        f = s[a >> 2] | 0;
        c = s[a + 4 >> 2] | 0;
        u = s[a + 8 >> 2] | 0;
        n = s[a + 12 >> 2] | 0;
        o = e;
        i = t;
        m = 0;
        a = Q(1) | 0;
        _ = m;
        m = 0;

        e: do {
          if (!(_ & 1)) {
            if (!a) {
              m = 0;
              te(22, 10081, 57);
              m = 0;
              break;
            }

            if ((s[a >> 2] | 0) == 1) {
              _ = a + 4 | 0;
              a = (s[_ >> 2] | 0) + 1 | 0;
              s[_ >> 2] = a;

              if (a >>> 0 > 2) {
                s[d >> 2] = 2504;
                s[d + 4 >> 2] = 1;
                s[d + 8 >> 2] = 0;
                s[d + 16 >> 2] = 15892;
                s[d + 20 >> 2] = 0;
                m = 0;
                ee(51, d | 0);
                _ = m;
                m = 0;
                if (_ & 1) break;
                et();
              } else v = a;
            } else {
              v = a;
              s[v >> 2] = 1;
              s[v + 4 >> 2] = 0;
              s[a + 4 >> 2] = 1;
              v = 1;
            }

            s[b >> 2] = o;
            s[b + 4 >> 2] = i;
            s[b + 8 >> 2] = f;
            s[b + 12 >> 2] = c;
            s[b + 16 >> 2] = u;
            s[b + 20 >> 2] = n;
            a = Se(15608) | 0;

            switch (a | 0) {
              case 11:
                {
                  m = 0;
                  re(21, 7225, 36, 2472);
                  m = 0;
                  break e;
                }

              case 35:
                break;

              default:
                l = 9;
            }

            do {
              if ((l | 0) == 9) {
                if (r[15644] | 0) {
                  if (a | 0) break;
                  be(15608) | 0;
                  break;
                }

                s[3910] = (s[3910] | 0) + 1;
                a = s[3913] | 0;

                if (!a) {
                  m = 0;
                  ee(52, b | 0);
                  _ = m;
                  m = 0;
                  if (_ & 1) break e;
                } else {
                  m = 0;
                  te(s[a + 12 >> 2] | 0, s[3912] | 0, b | 0);
                  _ = m;
                  m = 0;
                  if (_ & 1) break e;
                }

                s[3910] = (s[3910] | 0) - 1;
                be(15608) | 0;
                if (v >>> 0 <= 1) _n(e, t);
                s[h >> 2] = 2512;
                s[h + 4 >> 2] = 1;
                s[h + 8 >> 2] = 0;
                s[h + 16 >> 2] = 15892;
                s[h + 20 >> 2] = 0;
                m = 0;
                ee(51, h | 0);
                _ = m;
                m = 0;
                if (_ & 1) break e;
                et();
              }
            } while (0);

            m = 0;
            re(21, 7261, 41, 2488);
            m = 0;
          }
        } while (0);

        _ = me() | 0;
        en(y);
        Ee(_ | 0);
      }

      function vn(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            n = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0,
            A = 0,
            w = 0,
            T = 0,
            x = 0,
            D = 0;
        x = p;
        p = p + 112 | 0;
        w = x + 88 | 0;
        g = x + 80 | 0;
        D = x;
        A = x + 56 | 0;
        f = x + 48 | 0;
        T = x + 40 | 0;
        _ = x + 97 | 0;
        h = x + 32 | 0;
        b = x + 28 | 0;
        c = x + 24 | 0;
        u = x + 16 | 0;
        d = x + 96 | 0;
        t = Yr() | 0;
        if (!t) Fn(10081, 57);
        if ((s[t >> 2] | 0) == 1) {
          if ((s[t + 4 >> 2] | 0) >>> 0 > 1) t = 2;else v = 7;
        } else {
          v = t;
          s[v >> 2] = 1;
          s[v + 4 >> 2] = 0;
          s[t + 4 >> 2] = 0;
          v = 7;
        }
        if ((v | 0) == 7) t = bo() | 0;
        r[d >> 0] = t;
        a = s[e + 12 >> 2] | 0;
        s[u >> 2] = s[e + 8 >> 2];
        s[u + 4 >> 2] = a;
        s[c >> 2] = s[e + 16 >> 2];
        s[b >> 2] = s[e + 20 >> 2];
        a = s[e >> 2] | 0;
        t = s[(s[e + 4 >> 2] | 0) + 12 >> 2] | 0;
        e = Od[t & 15](a) | 0;

        if ((e | 0) == 1890621284 & (S | 0) == 286299353) {
          t = s[a + 4 >> 2] | 0;
          s[h >> 2] = s[a >> 2];
        } else {
          e = Od[t & 15](a) | 0;

          if ((e | 0) == 2033335871 & (S | 0) == 160875347) {
            t = s[a + 8 >> 2] | 0;
            e = s[a >> 2] | 0;
          } else {
            t = 8;
            e = 7345;
          }

          s[h >> 2] = e;
        }

        s[h + 4 >> 2] = t;
        r[_ >> 0] = 1;
        t = ci(3804) | 0;
        s[T >> 2] = t;

        e: do {
          if (!t) {
            l = 0;
            i = 0;
            n = 0;
            v = 20;
          } else {
            t = t + 16 | 0;
            a = (s[t >> 2] | 0) == 0;
            t = a ? 0 : t;

            do {
              if (!a) {
                a = s[t + 4 >> 2] | 0;
                e = a + -1 | 0;

                if (!a) {
                  m = 0;
                  te(14, e | 0, 0);
                  m = 0;
                  break e;
                } else {
                  t = s[t >> 2] | 0;
                  break;
                }
              } else {
                e = 0;
                t = 0;
              }
            } while (0);

            l = t;
            i = t;
            n = e;
            v = 20;
          }
        } while (0);

        do {
          if ((v | 0) == 20 ? (y = (l | 0) == 0, s[f >> 2] = y ? 7353 : i, s[f + 4 >> 2] = y ? 9 : n, s[A >> 2] = f, s[A + 4 >> 2] = h, s[A + 8 >> 2] = u, s[A + 12 >> 2] = c, s[A + 16 >> 2] = b, s[A + 20 >> 2] = d, m = 0, y = ae(12, 2520) | 0, v = m, m = 0, !(v & 1)) : 0) {
            if (!y) {
              m = 0;
              te(22, 10081, 57);
              m = 0;
              break;
            }

            if ((s[y >> 2] | 0) != 1) {
              m = 0;
              t = se(45, 2528, y | 0) | 0;
              v = m;
              m = 0;
              if (v & 1) break;
            } else t = y + 4 | 0;

            if (s[t >> 2] | 0) {
              m = 0;
              te(23, 9967, 16);
              m = 0;
              break;
            }

            e = t + 4 | 0;
            i = e;
            n = i;
            n = o[n >> 0] | o[n + 1 >> 0] << 8 | o[n + 2 >> 0] << 16 | o[n + 3 >> 0] << 24;
            i = i + 4 | 0;
            i = o[i >> 0] | o[i + 1 >> 0] << 8 | o[i + 2 >> 0] << 16 | o[i + 3 >> 0] << 24;
            r[e >> 0] = 0;
            r[e + 1 >> 0] = 0;
            r[e + 2 >> 0] = 0;
            r[e + 3 >> 0] = 0;
            r[t >> 0] = 0;
            r[t + 1 >> 0] = 0;
            r[t + 2 >> 0] = 0;
            r[t + 3 >> 0] = 0;
            t = (r[_ >> 0] | 0) == 1 ? _ + 1 | 0 : 0;
            e = D;
            s[e >> 2] = n;
            s[e + 4 >> 2] = i;
            e = D + 8 | 0;
            s[e >> 2] = t;
            a = i;

            do {
              if (!n) {
                if ((t | 0) != 0 ? (m = 0, re(22, A | 0, e | 0, 2536), w = m, m = 0, w & 1) : 0) {
                  t = me() | 0;
                  e = 1;
                  v = 30;
                } else {
                  a = 1;
                  v = 41;
                }
              } else {
                s[g >> 2] = n;
                s[g + 4 >> 2] = a;
                m = 0;
                re(22, A | 0, n | 0, a | 0);
                A = m;
                m = 0;

                if (A & 1) {
                  t = me() | 0;
                  wn(g);
                  e = 0;
                  v = 30;
                  break;
                }

                s[w >> 2] = n;
                s[w + 4 >> 2] = i;
                m = 0;
                te(24, 2528, w | 0);
                A = m;
                m = 0;

                if (A & 1) {
                  t = me() | 0;
                  Tn(w);
                  e = 0;
                  v = 30;
                  break;
                }

                a = s[w >> 2] | 0;

                if (a | 0) {
                  t = s[w + 4 >> 2] | 0;
                  m = 0;
                  ee(s[t >> 2] | 0, a | 0);
                  w = m;
                  m = 0;

                  if (w & 1) {
                    v = me() | 0;
                    cn(a, t);
                    e = 0;
                    t = v;
                    v = 30;
                    break;
                  }

                  e = s[t + 4 >> 2] | 0;
                  if (e | 0) Ut(a, e, s[t + 8 >> 2] | 0);
                }

                a = 0;
                v = 41;
              }
            } while (0);

            do {
              if ((v | 0) == 30) gn(T);else if ((v | 0) == 41) {
                t = s[T >> 2] | 0;

                if ((t | 0 ? (w = s[t >> 2] | 0, s[t >> 2] = w - 1, (w | 0) == 1) : 0) ? (m = 0, ee(50, T | 0), T = m, m = 0, T & 1) : 0) {
                  t = me() | 0;
                  e = a << 24 >> 24 != 0;
                  break;
                }

                e = s[D >> 2] | 0;

                if (a << 24 >> 24 == 0 | (e | 0) == 0) {
                  p = x;
                  return;
                }

                t = D + 4 | 0;
                m = 0;
                ee(s[s[t >> 2] >> 2] | 0, e | 0);
                T = m;
                m = 0;

                if (T & 1) {
                  x = me() | 0;
                  cn(s[D >> 2] | 0, s[t >> 2] | 0);
                  Ee(x | 0);
                }

                t = s[t >> 2] | 0;
                e = s[t + 4 >> 2] | 0;

                if (!e) {
                  p = x;
                  return;
                }

                Ut(s[D >> 2] | 0, e, s[t + 8 >> 2] | 0);
                p = x;
                return;
              }
            } while (0);

            if (!(s[D >> 2] | 0)) {
              Tn(D);
              D = t;
              Ee(D | 0);
            }

            if (!e) {
              D = t;
              Ee(D | 0);
            }

            wn(D);
            D = t;
            Ee(D | 0);
          }
        } while (0);

        D = me() | 0;
        gn(T);
        Ee(D | 0);
      }

      function _n(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0;
        n = p;
        p = p + 48 | 0;
        r = n + 32 | 0;
        a = n + 8 | 0;
        s[n >> 2] = Si(e, t) | 0;
        s[r >> 2] = n;
        s[r + 4 >> 2] = 46;
        s[a >> 2] = 2448;
        s[a + 4 >> 2] = 1;
        s[a + 8 >> 2] = 5180;
        s[a + 12 >> 2] = 1;
        s[a + 16 >> 2] = r;
        s[a + 20 >> 2] = 1;
        Rr(a);
      }

      function gn(e) {
        e = e | 0;
        var t = 0,
            a = 0;
        t = s[e >> 2] | 0;
        if (!t) return;
        a = s[t >> 2] | 0;
        s[t >> 2] = a - 1;
        if ((a | 0) != 1) return;
        On(e);
        return;
      }

      function An(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0;
        f = p;
        p = p + 80 | 0;
        c = f + 32 | 0;
        d = f + 8 | 0;
        n = f;
        l = s[e + 4 >> 2] | 0;
        o = s[e + 8 >> 2] | 0;
        i = s[e + 12 >> 2] | 0;
        u = s[e + 16 >> 2] | 0;
        s[c >> 2] = s[e >> 2];
        s[c + 4 >> 2] = 41;
        s[c + 8 >> 2] = l;
        s[c + 12 >> 2] = 41;
        s[c + 16 >> 2] = o;
        s[c + 20 >> 2] = 41;
        s[c + 24 >> 2] = i;
        s[c + 28 >> 2] = 46;
        s[c + 32 >> 2] = u;
        s[c + 36 >> 2] = 46;
        s[d >> 2] = 2568;
        s[d + 4 >> 2] = 6;
        s[d + 8 >> 2] = 4840;
        s[d + 12 >> 2] = 5;
        s[d + 16 >> 2] = c;
        s[d + 20 >> 2] = 5;
        u = s[a + 24 >> 2] | 0;
        Fd[u & 31](n, t, d);

        switch (r[n >> 0] & 3) {
          case 0:
          case 1:
          case 3:
            break;

          default:
            {
              i = s[n + 4 >> 2] | 0;
              n = i + 4 | 0;
              m = 0;
              ee(s[s[n >> 2] >> 2] | 0, s[i >> 2] | 0);
              l = m;
              m = 0;

              if (l & 1) {
                l = me() | 0;
                xn(s[i >> 2] | 0, s[n >> 2] | 0);
                Dn(i);
                Ee(l | 0);
              }

              n = s[n >> 2] | 0;
              o = s[n + 4 >> 2] | 0;
              if (o | 0) Ut(s[i >> 2] | 0, o, s[n + 8 >> 2] | 0);
              Ut(i, 12, 4);
            }
        }

        n = r[s[e + 20 >> 2] >> 0] | 0;

        if (n << 24 >> 24 != 4) {
          lo(c, t, a, n);

          switch (r[c >> 0] & 3) {
            case 0:
            case 1:
            case 3:
              break;

            default:
              {
                i = s[c + 4 >> 2] | 0;
                n = i + 4 | 0;
                m = 0;
                ee(s[s[n >> 2] >> 2] | 0, s[i >> 2] | 0);
                l = m;
                m = 0;

                if (l & 1) {
                  l = me() | 0;
                  xn(s[i >> 2] | 0, s[n >> 2] | 0);
                  Dn(i);
                  Ee(l | 0);
                }

                n = s[n >> 2] | 0;
                o = s[n + 4 >> 2] | 0;
                if (o | 0) Ut(s[i >> 2] | 0, o, s[n + 8 >> 2] | 0);
                Ut(i, 12, 4);
              }
          }

          p = f;
          return;
        }

        n = r[7362] | 0;
        if (n << 24 >> 24 == 1) r[7362] = 0;

        if (!(n << 24 >> 24)) {
          p = f;
          return;
        }

        s[c >> 2] = 2616;
        s[c + 4 >> 2] = 1;
        s[c + 8 >> 2] = 0;
        s[c + 16 >> 2] = 15892;
        s[c + 20 >> 2] = 0;
        Fd[u & 31](d, t, c);

        switch (r[d >> 0] & 3) {
          case 0:
          case 1:
          case 3:
            break;

          default:
            {
              i = s[d + 4 >> 2] | 0;
              n = i + 4 | 0;
              m = 0;
              ee(s[s[n >> 2] >> 2] | 0, s[i >> 2] | 0);
              l = m;
              m = 0;

              if (l & 1) {
                l = me() | 0;
                xn(s[i >> 2] | 0, s[n >> 2] | 0);
                Dn(i);
                Ee(l | 0);
              }

              n = s[n >> 2] | 0;
              o = s[n + 4 >> 2] | 0;
              if (o | 0) Ut(s[i >> 2] | 0, o, s[n + 8 >> 2] | 0);
              Ut(i, 12, 4);
            }
        }

        p = f;
        return;
      }

      function wn(e) {
        e = e | 0;
        var t = 0,
            a = 0;
        t = e + 4 | 0;
        m = 0;
        ee(s[s[t >> 2] >> 2] | 0, s[e >> 2] | 0);
        a = m;
        m = 0;

        if (a & 1) {
          a = me() | 0;
          cn(s[e >> 2] | 0, s[t >> 2] | 0);
          Ee(a | 0);
        }

        t = s[t >> 2] | 0;
        a = s[t + 4 >> 2] | 0;
        if (!a) return;
        Ut(s[e >> 2] | 0, a, s[t + 8 >> 2] | 0);
        return;
      }

      function Tn(e) {
        e = e | 0;
        var t = 0,
            a = 0;
        t = s[e >> 2] | 0;
        if (!t) return;
        a = e + 4 | 0;
        m = 0;
        ee(s[s[a >> 2] >> 2] | 0, t | 0);
        t = m;
        m = 0;

        if (t & 1) {
          t = me() | 0;
          cn(s[e >> 2] | 0, s[a >> 2] | 0);
          Ee(t | 0);
        }

        a = s[a >> 2] | 0;
        t = s[a + 4 >> 2] | 0;
        if (!t) return;
        Ut(s[e >> 2] | 0, t, s[a + 8 >> 2] | 0);
        return;
      }

      function xn(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0;
        a = s[t + 4 >> 2] | 0;
        if (!a) return;
        Ut(e, a, s[t + 8 >> 2] | 0);
        return;
      }

      function Dn(e) {
        e = e | 0;
        Ut(e, 12, 4);
        return;
      }

      function Cn(e) {
        e = e | 0;
        return;
      }

      function Sn(e, t, a, r) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        r = r | 0;
        t = Ju(2, a, (r | 0) > -1 ? r : 2147483647) | 0;

        if ((t | 0) == -1) {
          r = 1;
          t = 0;
          a = s[(gu() | 0) >> 2] | 0;
        } else {
          r = 0;
          a = 0;
        }

        s[e >> 2] = r;
        e = e + 4 | 0;
        s[e >> 2] = t;
        s[e + 4 >> 2] = a;
        return;
      }

      function En(e, t) {
        e = e | 0;
        t = t | 0;
        r[e >> 0] = 3;
        return;
      }

      function Bn(e, t, a, r) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        r = r | 0;
        ui(e, s[t >> 2] | 0, a, r);
        return;
      }

      function kn(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0;
        r = p;
        p = p + 32 | 0;
        n = r;
        t = s[t >> 2] | 0;
        s[n >> 2] = s[a >> 2];
        s[n + 4 >> 2] = s[a + 4 >> 2];
        s[n + 8 >> 2] = s[a + 8 >> 2];
        s[n + 12 >> 2] = s[a + 12 >> 2];
        s[n + 16 >> 2] = s[a + 16 >> 2];
        s[n + 20 >> 2] = s[a + 20 >> 2];
        di(e, t, n);
        p = r;
        return;
      }

      function Rn() {
        return nn(2520) | 0;
      }

      function Wn(e) {
        e = e | 0;
        s[e >> 2] = 0;
        s[e + 4 >> 2] = 0;
        return;
      }

      function In(e) {
        e = e | 0;
        var t = 0;
        t = s[e >> 2] | 0;
        s[e >> 2] = po(s[t >> 2] | 0, s[t + 4 >> 2] | 0) | 0;
        return;
      }

      function Nn(e, t, a, r) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        r = r | 0;
        var n = 0,
            o = 0;
        n = p;
        p = p + 16 | 0;
        o = s[t + 4 >> 2] | 0;
        s[n >> 2] = s[t >> 2];
        s[n + 4 >> 2] = o;
        s[n + 8 >> 2] = a;
        s[n + 12 >> 2] = r;
        bn(e, n);
      }

      function Mn(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0;
        u = p;
        p = p + 160 | 0;
        o = u;
        i = u + 8 | 0;
        c = u + 24 | 0;
        a = c;
        n = a + 128 | 0;

        do {
          r[a >> 0] = 0;
          a = a + 1 | 0;
        } while ((a | 0) < (n | 0));

        if ((Zu(t, c, 128) | 0) < 0) pn(7207, 18, 2456);
        t = Cu(c) | 0;
        if ((t | 0) == -1) ru(-1, 0);
        xc(i, c, t);

        if ((s[i >> 2] | 0) == 1) {
          i = i + 4 | 0;
          c = s[i + 4 >> 2] | 0;
          u = o;
          s[u >> 2] = s[i >> 2];
          s[u + 4 >> 2] = c;
          Yn(7097, 43, o);
        } else {
          Ii(e, s[i + 4 >> 2] | 0, s[i + 8 >> 2] | 0);
          p = u;
          return;
        }
      }

      function Pn(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            y = 0,
            v = 0;
        y = p;
        p = p + 80 | 0;
        n = y;
        f = y + 56 | 0;
        h = y + 44 | 0;
        c = y + 8 | 0;
        u = y + 24 | 0;
        v = y + 16 | 0;
        Bo(h, t, a);
        a = s[h >> 2] | 0;
        t = ku(a, 0, s[h + 8 >> 2] | 0) | 0;

        if (!t) {
          s[f >> 2] = s[h >> 2];
          s[f + 4 >> 2] = s[h + 4 >> 2];
          s[f + 8 >> 2] = s[h + 8 >> 2];
          As(n, f);
          o = 0;
          i = s[n >> 2] | 0;
          a = s[n + 4 >> 2] | 0;
          t = 0;
          n = 0;
        } else {
          n = h + 4 | 0;
          o = 1;
          i = t - a | 0;
          t = s[n >> 2] | 0;
          n = s[n + 4 >> 2] | 0;
        }

        s[u >> 2] = o;
        s[u + 4 >> 2] = i;
        s[u + 8 >> 2] = a;
        d = u + 12 | 0;
        s[d >> 2] = t;
        s[d + 4 >> 2] = n;
        d = i;

        if ((o | 0) == 1) {
          v = u + 4 | 0;
          s[f >> 2] = s[v >> 2];
          s[f + 4 >> 2] = s[v + 4 >> 2];
          s[f + 8 >> 2] = s[v + 8 >> 2];
          s[f + 12 >> 2] = s[v + 12 >> 2];
          m = 0;
          te(25, c | 0, f | 0);
          v = m;
          m = 0;

          if (v & 1) {
            v = me() | 0;
            Ee(v | 0);
          } else {
            b = c;
            h = s[b >> 2] | 0;
            b = s[b + 4 >> 2] | 0;
            s[e >> 2] = 1;
            v = e + 4 | 0;
            s[v >> 2] = h;
            s[v + 4 >> 2] = b;
            p = y;
            return;
          }
        }

        s[v >> 2] = i;
        c = v + 4 | 0;
        s[c >> 2] = a;
        td(15656) | 0;
        n = Fe(i | 0) | 0;

        e: do {
          if (!n) {
            t = 0;
            a = 0;
            n = 0;
          } else {
            o = Cu(n) | 0;

            do {
              if ((o | 0) != -1) {
                if ((o | 0) < 0) {
                  m = 0;
                  ee(44, 3740);
                  m = 0;
                  b = 25;
                  break;
                }

                if (o) {
                  t = Gt(o, 1, f) | 0;

                  if (!t) {
                    s[f >> 2] = 0;
                    Vt(f);
                  } else l = t;
                } else l = 1;

                s[h >> 2] = l;
                t = h + 4 | 0;
                s[t >> 2] = o;
                a = h + 8 | 0;
                s[a >> 2] = 0;
                m = 0;
                re(23, h | 0, 0, o | 0);
                l = m;
                m = 0;

                if (l & 1) {
                  t = me() | 0;
                  m = 0;
                  ee(53, h | 0);
                  y = m;
                  m = 0;

                  if (y & 1) {
                    b = 25;
                    break;
                  } else break;
                } else {
                  b = s[a >> 2] | 0;
                  s[a >> 2] = b + o;
                  id((s[h >> 2] | 0) + b | 0, n | 0, o | 0) | 0;
                  n = t;
                  t = s[h >> 2] | 0;
                  a = s[n >> 2] | 0;
                  n = s[n + 4 >> 2] | 0;
                  break e;
                }
              } else {
                m = 0;
                te(14, -1, 0);
                m = 0;
                b = 25;
              }
            } while (0);

            if ((b | 0) == 25) t = me() | 0;
            Ln(v);
            v = t;
            Ee(v | 0);
          }
        } while (0);

        sd(15656) | 0;
        s[e >> 2] = 0;
        s[e + 4 >> 2] = t;
        t = e + 8 | 0;
        s[t >> 2] = a;
        s[t + 4 >> 2] = n;
        r[d >> 0] = 0;
        t = s[c >> 2] | 0;
        if (t | 0) Ut(s[v >> 2] | 0, t, 1);
        p = y;
        return;
      }

      function Ln(e) {
        e = e | 0;
        var t = 0;
        r[s[e >> 2] >> 0] = 0;
        t = s[e + 4 >> 2] | 0;
        if (!t) return;
        Ut(s[e >> 2] | 0, t, 1);
        return;
      }

      function On(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            n = 0,
            o = 0;
        t = s[e >> 2] | 0;
        a = t + 16 | 0;
        n = s[a >> 2] | 0;
        if (n | 0 ? (r[n >> 0] = 0, o = s[t + 20 >> 2] | 0, o | 0) : 0) Ut(s[a >> 2] | 0, o, 1);
        n = t + 28 | 0;
        Me(s[n >> 2] | 0) | 0;
        Ut(s[n >> 2] | 0, 28, 4);
        n = t + 36 | 0;
        Qe(s[n >> 2] | 0) | 0;
        Ut(s[n >> 2] | 0, 48, 4);
        n = (s[e >> 2] | 0) + 4 | 0;
        o = s[n >> 2] | 0;
        s[n >> 2] = o - 1;
        if ((o | 0) != 1) return;
        Ut(t, 48, 8);
        return;
      }

      function Fn(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0;
        n = p;
        p = p + 48 | 0;
        r = n + 32 | 0;
        a = n + 8 | 0;
        o = n;
        s[o >> 2] = e;
        s[o + 4 >> 2] = t;
        s[r >> 2] = o;
        s[r + 4 >> 2] = 41;
        s[r + 8 >> 2] = n + 48;
        s[r + 12 >> 2] = 47;
        s[a >> 2] = 2624;
        s[a + 4 >> 2] = 2;
        s[a + 8 >> 2] = 5264;
        s[a + 12 >> 2] = 2;
        s[a + 16 >> 2] = r;
        s[a + 20 >> 2] = 2;
        qc(a, 2640);
      }

      function jn(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            n = 0,
            o = 0;
        a = (s[e >> 2] | 0) + 4 | 0;

        if (!(r[e + 4 >> 0] | 0)) {
          t = Md[s[600] & 7]() | 0;
          if (!t) Fn(10081, 57);

          if ((s[t >> 2] | 0) == 1) {
            t = t + 4 | 0;
            n = s[t >> 2] | 0;
          } else {
            n = Md[s[2404 >> 2] & 7]() | 0;
            o = t;
            s[o >> 2] = 1;
            s[o + 4 >> 2] = n;
            t = t + 4 | 0;
          }

          r[t >> 0] = n;
          r[t + 1 >> 0] = n >> 8;
          r[t + 2 >> 0] = n >> 16;
          r[t + 3 >> 0] = n >> 24;
          if (n | 0) r[a >> 0] = 1;
        }

        sd(s[s[e >> 2] >> 2] | 0) | 0;
        return;
      }

      function Gn(e) {
        e = e | 0;
        var t = 0;
        t = s[e + 8 >> 2] | 0;
        if (!t) return;
        Ut(s[e + 4 >> 2] | 0, t, 1);
        return;
      }

      function Vn(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            n = 0,
            o = 0;
        a = (s[e >> 2] | 0) + 4 | 0;

        if (!(r[e + 4 >> 0] | 0)) {
          t = Md[s[600] & 7]() | 0;
          if (!t) Fn(10081, 57);

          if ((s[t >> 2] | 0) == 1) {
            t = t + 4 | 0;
            n = s[t >> 2] | 0;
          } else {
            n = Md[s[2404 >> 2] & 7]() | 0;
            o = t;
            s[o >> 2] = 1;
            s[o + 4 >> 2] = n;
            t = t + 4 | 0;
          }

          r[t >> 0] = n;
          r[t + 1 >> 0] = n >> 8;
          r[t + 2 >> 0] = n >> 16;
          r[t + 3 >> 0] = n >> 24;
          if (n | 0) r[a >> 0] = 1;
        }

        sd(s[s[e >> 2] >> 2] | 0) | 0;
        return;
      }

      function Un(e) {
        e = e | 0;
        Qe(s[e >> 2] | 0) | 0;
        Ut(s[e >> 2] | 0, 48, 4);
        return;
      }

      function Hn(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var n = 0,
            o = 0,
            i = 0,
            c = 0;
        c = p;
        p = p + 64 | 0;
        o = c + 32 | 0;
        n = c + 8 | 0;
        i = c + 48 | 0;
        s[c >> 2] = e;
        s[c + 4 >> 2] = t;
        r[i >> 0] = a;
        s[o >> 2] = c;
        s[o + 4 >> 2] = 41;
        s[o + 8 >> 2] = i;
        s[o + 12 >> 2] = 48;
        s[n >> 2] = 2624;
        s[n + 4 >> 2] = 2;
        s[n + 8 >> 2] = 5264;
        s[n + 12 >> 2] = 2;
        s[n + 16 >> 2] = o;
        s[n + 20 >> 2] = 2;
        qc(n, 2640);
      }

      function zn(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0;
        n = p;
        p = p + 48 | 0;
        r = n + 32 | 0;
        a = n + 8 | 0;
        o = n;
        s[o >> 2] = e;
        s[o + 4 >> 2] = t;
        s[r >> 2] = o;
        s[r + 4 >> 2] = 41;
        s[r + 8 >> 2] = n + 48;
        s[r + 12 >> 2] = 49;
        s[a >> 2] = 2624;
        s[a + 4 >> 2] = 2;
        s[a + 8 >> 2] = 5264;
        s[a + 12 >> 2] = 2;
        s[a + 16 >> 2] = r;
        s[a + 20 >> 2] = 2;
        qc(a, 2640);
      }

      function Kn(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0;
        n = p;
        p = p + 48 | 0;
        r = n + 32 | 0;
        a = n + 8 | 0;
        o = n;
        s[o >> 2] = e;
        s[o + 4 >> 2] = t;
        s[r >> 2] = o;
        s[r + 4 >> 2] = 41;
        s[r + 8 >> 2] = n + 48;
        s[r + 12 >> 2] = 50;
        s[a >> 2] = 2624;
        s[a + 4 >> 2] = 2;
        s[a + 8 >> 2] = 5264;
        s[a + 12 >> 2] = 2;
        s[a + 16 >> 2] = r;
        s[a + 20 >> 2] = 2;
        qc(a, 2640);
      }

      function qn(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0;
        o = p;
        p = p + 48 | 0;
        n = o + 32 | 0;
        r = o + 8 | 0;
        s[o >> 2] = e;
        s[o + 4 >> 2] = t;
        s[n >> 2] = o;
        s[n + 4 >> 2] = 41;
        s[n + 8 >> 2] = a;
        s[n + 12 >> 2] = 51;
        s[r >> 2] = 2624;
        s[r + 4 >> 2] = 2;
        s[r + 8 >> 2] = 5264;
        s[r + 12 >> 2] = 2;
        s[r + 16 >> 2] = n;
        s[r + 20 >> 2] = 2;
        m = 0;
        te(9, r | 0, 2640);
        m = 0;
        t = me() | 0;
        Gn(a);
        Ee(t | 0);
      }

      function Yn(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0;
        o = p;
        p = p + 48 | 0;
        n = o + 32 | 0;
        r = o + 8 | 0;
        s[o >> 2] = e;
        s[o + 4 >> 2] = t;
        s[n >> 2] = o;
        s[n + 4 >> 2] = 41;
        s[n + 8 >> 2] = a;
        s[n + 12 >> 2] = 37;
        s[r >> 2] = 2624;
        s[r + 4 >> 2] = 2;
        s[r + 8 >> 2] = 5264;
        s[r + 12 >> 2] = 2;
        s[r + 16 >> 2] = n;
        s[r + 20 >> 2] = 2;
        qc(r, 2640);
      }

      function Zn(e, t, a, n) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        n = n | 0;
        var o = 0,
            i = 0,
            c = 0,
            u = 0;
        u = p;
        p = p + 64 | 0;
        c = u + 40 | 0;
        i = u + 16 | 0;
        o = u + 8 | 0;
        s[u >> 2] = e;
        s[u + 4 >> 2] = t;
        s[o >> 2] = a;
        r[o + 4 >> 0] = n & 1;
        s[c >> 2] = u;
        s[c + 4 >> 2] = 41;
        s[c + 8 >> 2] = o;
        s[c + 12 >> 2] = 52;
        s[i >> 2] = 2624;
        s[i + 4 >> 2] = 2;
        s[i + 8 >> 2] = 5264;
        s[i + 12 >> 2] = 2;
        s[i + 16 >> 2] = c;
        s[i + 20 >> 2] = 2;
        m = 0;
        te(9, i | 0, 2640);
        m = 0;
        n = me() | 0;
        Vn(o);
        Ee(n | 0);
      }

      function Jn(e) {
        e = e | 0;
        return;
      }

      function Xn(e) {
        e = e | 0;
        return;
      }

      function $n(e) {
        e = e | 0;
        var t = 0;
        t = s[e + 4 >> 2] | 0;
        if (!t) return;
        Ut(s[e >> 2] | 0, t, 1);
        return;
      }

      function Qn(e) {
        e = e | 0;
        return;
      }

      function es(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            r = 0;
        if ((o[e >> 0] | 0) < 2) return;
        a = e + 4 | 0;
        r = s[a >> 2] | 0;
        e = r + 4 | 0;
        m = 0;
        ee(s[s[e >> 2] >> 2] | 0, s[r >> 2] | 0);
        t = m;
        m = 0;

        if (t & 1) {
          t = me() | 0;
          as(s[r >> 2] | 0, s[e >> 2] | 0);
          rs(s[a >> 2] | 0);
          Ee(t | 0);
        }

        e = s[e >> 2] | 0;
        t = s[e + 4 >> 2] | 0;
        if (t | 0) Ut(s[r >> 2] | 0, t, s[e + 8 >> 2] | 0);
        Ut(s[a >> 2] | 0, 12, 4);
        return;
      }

      function ts(e) {
        e = e | 0;
        if ((r[e >> 0] | 0) == 3) return;
        es(e);
        return;
      }

      function as(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0;
        a = s[t + 4 >> 2] | 0;
        if (!a) return;
        Ut(e, a, s[t + 8 >> 2] | 0);
        return;
      }

      function rs(e) {
        e = e | 0;
        Ut(e, 12, 4);
        return;
      }

      function ns(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0;
        d = p;
        p = p + 16 | 0;
        f = d;
        u = d + 8 | 0;
        s[u >> 2] = 0;

        if (t >>> 0 < 128) {
          r[u >> 0] = t;
          a = 1;
        } else {
          do {
            if (t >>> 0 >= 2048) {
              if (t >>> 0 < 65536) {
                r[u >> 0] = t >>> 12 & 15 | -32;
                n = 63;
                o = 1;
                i = -128;
                c = 2;
                a = 3;
                break;
              } else {
                r[u >> 0] = t >>> 18 & 255 | -16;
                r[u + 1 >> 0] = t >>> 12 & 63 | -128;
                n = 63;
                o = 2;
                i = -128;
                c = 3;
                a = 4;
                break;
              }
            } else {
              n = 31;
              o = 0;
              i = -64;
              c = 1;
              a = 2;
            }
          } while (0);

          r[u + o >> 0] = n & t >>> 6 & 255 | i;
          r[u + c >> 0] = t & 63 | -128;
        }

        ui(f, s[e >> 2] | 0, u, a);

        if ((r[f >> 0] | 0) == 3) {
          f = 0;
          p = d;
          return f | 0;
        }

        i = f;
        o = s[i >> 2] | 0;
        i = s[i + 4 >> 2] | 0;
        t = e + 4 | 0;
        n = o & 255;

        if ((r[t >> 0] | 0) != 3 ? (m = 0, ee(46, t | 0), e = m, m = 0, e & 1) : 0) {
          a = me() | 0;
          d = t;
          s[d >> 2] = o;
          s[d + 4 >> 2] = i;
          if (n << 24 >> 24 != 3) Ee(a | 0);
          ts(f);
          Ee(a | 0);
        }

        f = t;
        s[f >> 2] = o;
        s[f + 4 >> 2] = i;
        f = 1;
        p = d;
        return f | 0;
      }

      function ss(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0;
        a = p;
        p = p + 32 | 0;
        r = a + 8 | 0;
        n = a;
        s[n >> 2] = e;
        s[r >> 2] = s[t >> 2];
        s[r + 4 >> 2] = s[t + 4 >> 2];
        s[r + 8 >> 2] = s[t + 8 >> 2];
        s[r + 12 >> 2] = s[t + 12 >> 2];
        s[r + 16 >> 2] = s[t + 16 >> 2];
        s[r + 20 >> 2] = s[t + 20 >> 2];
        t = rc(n, 2672, r) | 0;
        p = a;
        return t | 0;
      }

      function os(e) {
        e = e | 0;
        var t = 0;
        t = s[e + 8 >> 2] | 0;
        if (!t) return;
        Ut(s[e + 4 >> 2] | 0, t, 1);
        return;
      }

      function is(e) {
        e = e | 0;
        var t = 0;
        t = s[e + 4 >> 2] | 0;
        if (!t) return;
        Ut(s[e >> 2] | 0, t, 1);
        return;
      }

      function cs(e) {
        e = e | 0;
        return;
      }

      function us(e, t) {
        e = e | 0;
        t = t | 0;
        return ds(s[e >> 2] | 0, t) | 0;
      }

      function ds(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            n = 0,
            o = 0,
            i = 0;
        i = p;
        p = p + 32 | 0;
        o = i + 8 | 0;
        a = i;
        n = i + 20 | 0;

        switch (r[e >> 0] & 3) {
          case 0:
            {
              n = e + 4 | 0;
              hc(a, t, 7824, 2);
              e = Mc(a, 7826, 4, n, 2760) | 0;
              Mn(o, s[n >> 2] | 0);
              m = 0;
              e = oe(1, e | 0, 7830, 7, o | 0, 2816) | 0;
              n = m;
              m = 0;

              if (n & 1) {
                i = me() | 0;
                fs(o);
                Ee(i | 0);
              }

              m = 0;
              e = ae(13, e | 0) | 0;
              n = m;
              m = 0;

              if (n & 1) {
                i = me() | 0;
                fs(o);
                Ee(i | 0);
              }

              t = s[o + 4 >> 2] | 0;
              if (t | 0) Ut(s[o >> 2] | 0, t, 1);
              o = e;
              p = i;
              return o | 0;
            }

          case 1:
            {
              r[n >> 0] = r[e + 1 >> 0] | 0;
              pc(o, t, 7837, 4);
              o = Oc(Lc(o, n, 2832) | 0) | 0;
              p = i;
              return o | 0;
            }

          case 2:
            {
              pc(o, t, 7841, 6);
              o = Oc(Lc(o, e + 4 | 0, 2848) | 0) | 0;
              p = i;
              return o | 0;
            }

          default:
            {}
        }

        return 0;
      }

      function fs(e) {
        e = e | 0;
        var t = 0;
        t = s[e + 4 >> 2] | 0;
        if (!t) return;
        Ut(s[e >> 2] | 0, t, 1);
        return;
      }

      function ls(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            r = 0;
        r = s[e >> 2] | 0;
        t = r + 4 | 0;
        m = 0;
        ee(s[s[t >> 2] >> 2] | 0, s[r >> 2] | 0);
        a = m;
        m = 0;

        if (a & 1) {
          a = me() | 0;
          as(s[r >> 2] | 0, s[t >> 2] | 0);
          rs(s[e >> 2] | 0);
          Ee(a | 0);
        }

        a = s[t >> 2] | 0;
        t = s[a + 4 >> 2] | 0;

        if (!t) {
          r = s[e >> 2] | 0;
          Ut(r, 12, 4);
          return;
        }

        Ut(s[r >> 2] | 0, t, s[a + 8 >> 2] | 0);
        r = s[e >> 2] | 0;
        Ut(r, 12, 4);
        return;
      }

      function hs(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0;
        a = p;
        p = p + 16 | 0;
        n = a + 8 | 0;
        r = a;
        e = s[e >> 2] | 0;
        hc(r, t, 7841, 6);
        s[n >> 2] = e + 8;
        Mc(r, 7847, 4, n, 2864) | 0;
        s[n >> 2] = e;
        Mc(r, 7851, 5, n, 2880) | 0;
        t = Pc(r) | 0;
        p = a;
        return t | 0;
      }

      function ps(e) {
        e = e | 0;
        return;
      }

      function bs(e, t) {
        e = e | 0;
        t = t | 0;
        e = s[e >> 2] | 0;
        return Gd[s[(s[e + 4 >> 2] | 0) + 28 >> 2] & 127](s[e >> 2] | 0, t) | 0;
      }

      function ms(e) {
        e = e | 0;
        return;
      }

      function ys(e, t) {
        e = e | 0;
        t = t | 0;
        return vs(s[e >> 2] | 0, t) | 0;
      }

      function vs(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            n = 0;
        n = p;
        p = p + 16 | 0;
        a = n;

        do {
          switch (r[e >> 0] & 31) {
            case 0:
              {
                pc(a, t, 7856, 8);
                a = Oc(a) | 0;
                p = n;
                return a | 0;
              }

            case 1:
              {
                pc(a, t, 7864, 16);
                a = Oc(a) | 0;
                p = n;
                return a | 0;
              }

            case 2:
              {
                pc(a, t, 7880, 17);
                a = Oc(a) | 0;
                p = n;
                return a | 0;
              }

            case 3:
              {
                pc(a, t, 7897, 15);
                a = Oc(a) | 0;
                p = n;
                return a | 0;
              }

            case 4:
              {
                pc(a, t, 7912, 17);
                a = Oc(a) | 0;
                p = n;
                return a | 0;
              }

            case 5:
              {
                pc(a, t, 7929, 12);
                a = Oc(a) | 0;
                p = n;
                return a | 0;
              }

            case 6:
              {
                pc(a, t, 7941, 9);
                a = Oc(a) | 0;
                p = n;
                return a | 0;
              }

            case 7:
              {
                pc(a, t, 7950, 16);
                a = Oc(a) | 0;
                p = n;
                return a | 0;
              }

            case 8:
              {
                pc(a, t, 7966, 10);
                a = Oc(a) | 0;
                p = n;
                return a | 0;
              }

            case 9:
              {
                pc(a, t, 7976, 13);
                a = Oc(a) | 0;
                p = n;
                return a | 0;
              }

            case 10:
              {
                pc(a, t, 7989, 10);
                a = Oc(a) | 0;
                p = n;
                return a | 0;
              }

            case 11:
              {
                pc(a, t, 7999, 12);
                a = Oc(a) | 0;
                p = n;
                return a | 0;
              }

            case 12:
              {
                pc(a, t, 8011, 11);
                a = Oc(a) | 0;
                p = n;
                return a | 0;
              }

            case 13:
              {
                pc(a, t, 8022, 8);
                a = Oc(a) | 0;
                p = n;
                return a | 0;
              }

            case 14:
              {
                pc(a, t, 8030, 9);
                a = Oc(a) | 0;
                p = n;
                return a | 0;
              }

            case 15:
              {
                pc(a, t, 8039, 11);
                a = Oc(a) | 0;
                p = n;
                return a | 0;
              }

            case 16:
              {
                pc(a, t, 8050, 5);
                a = Oc(a) | 0;
                p = n;
                return a | 0;
              }

            case 17:
              {
                pc(a, t, 8055, 13);
                a = Oc(a) | 0;
                p = n;
                return a | 0;
              }

            case 18:
              {
                pc(a, t, 8068, 15);
                a = Oc(a) | 0;
                p = n;
                return a | 0;
              }

            default:
              {}
          }
        } while (0);

        return 0;
      }

      function _s(e) {
        e = e | 0;
        return;
      }

      function gs(e, t) {
        e = e | 0;
        t = t | 0;
        return yc(s[e >> 2] | 0, s[e + 8 >> 2] | 0, t) | 0;
      }

      function As(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0;
        d = p;
        p = p + 32 | 0;
        o = d + 12 | 0;
        i = d;
        n = t + 8 | 0;
        m = 0;
        re(24, t | 0, s[n >> 2] | 0, 1);
        a = m;
        m = 0;

        if (a & 1) {
          d = me() | 0;
          is(t);
          Ee(d | 0);
        }

        a = s[n >> 2] | 0;

        do {
          if ((a | 0) == (s[t + 4 >> 2] | 0)) {
            m = 0;
            ee(54, t | 0);
            a = m;
            m = 0;

            if (a & 1) {
              d = me() | 0;
              is(t);
              Ee(d | 0);
            } else {
              a = s[n >> 2] | 0;
              break;
            }
          }
        } while (0);

        r[(s[t >> 2] | 0) + a >> 0] = 0;
        s[n >> 2] = (s[n >> 2] | 0) + 1;
        s[i >> 2] = s[t >> 2];
        s[i + 4 >> 2] = s[t + 4 >> 2];
        s[i + 8 >> 2] = s[t + 8 >> 2];
        t = s[i + 8 >> 2] | 0;
        n = i + 4 | 0;
        a = s[n >> 2] | 0;

        if (a >>> 0 < t >>> 0) {
          m = 0;
          ee(44, 3692);
          m = 0;
          d = me() | 0;
          To(i);
          Ee(d | 0);
        }

        do {
          if (t) {
            if ((a | 0) == (t | 0)) {
              c = s[i >> 2] | 0;
              u = t;
              s[e >> 2] = c;
              e = e + 4 | 0;
              s[e >> 2] = u;
              p = d;
              return;
            }

            a = Ht(s[i >> 2] | 0, a, 1, t, 1, o) | 0;

            if (!a) {
              t = o + 4 | 0;
              a = s[t >> 2] | 0;
              t = s[t + 4 >> 2] | 0;
              s[o >> 2] = s[o >> 2];
              i = o + 4 | 0;
              s[i >> 2] = a;
              s[i + 4 >> 2] = t;
              Vt(o);
            } else {
              s[i >> 2] = a;
              c = t;
              u = a;
              break;
            }
          } else {
            if (a | 0) Ut(s[i >> 2] | 0, a, 1);
            s[i >> 2] = 1;
            c = 0;
            u = 1;
          }
        } while (0);

        s[n >> 2] = c;
        i = u;
        u = c;
        s[e >> 2] = i;
        e = e + 4 | 0;
        s[e >> 2] = u;
        p = d;
        return;
      }

      function ws(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0;
        u = p;
        p = p + 48 | 0;
        a = u + 24 | 0;
        n = u;
        o = u + 12 | 0;
        m = 0;
        re(25, o | 0, 7684, 33);
        c = m;
        m = 0;

        if (c & 1) {
          u = me() | 0;
          os(t);
          Ee(u | 0);
        }

        s[n >> 2] = s[o >> 2];
        s[n + 4 >> 2] = s[o + 4 >> 2];
        s[n + 8 >> 2] = s[o + 8 >> 2];
        i = Gt(12, 4, a) | 0;
        if (!i) Vt(a);
        s[i >> 2] = s[n >> 2];
        s[i + 4 >> 2] = s[n + 4 >> 2];
        s[i + 8 >> 2] = s[n + 8 >> 2];
        c = Gt(12, 4, a) | 0;
        if (!c) Vt(a);
        s[c >> 2] = i;
        s[c + 4 >> 2] = 2728;
        r[c + 8 >> 0] = 11;
        i = c + 9 | 0;
        r[i >> 0] = r[n >> 0] | 0;
        r[i + 1 >> 0] = r[n + 1 >> 0] | 0;
        r[i + 2 >> 0] = r[n + 2 >> 0] | 0;
        r[e >> 0] = 2;
        i = e + 1 | 0;
        r[i >> 0] = r[o >> 0] | 0;
        r[i + 1 >> 0] = r[o + 1 >> 0] | 0;
        r[i + 2 >> 0] = r[o + 2 >> 0] | 0;
        s[e + 4 >> 2] = c;
        e = s[t + 8 >> 2] | 0;

        if (!e) {
          p = u;
          return;
        }

        Ut(s[t + 4 >> 2] | 0, e, 1);
        p = u;
        return;
      }

      function Ts(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0;
        a = (Cu(t) | 0) + 1 | 0;
        s[e >> 2] = t;
        s[e + 4 >> 2] = a;
        return;
      }

      function xs(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0;
        r = a + -1 | 0;
        if (!a) ru(r, 0);else {
          xc(e, t, r);
          return;
        }
      }

      function Ds(e, t, a, n) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        n = n | 0;
        var o = 0,
            i = 0,
            c = 0,
            u = 0;
        u = p;
        p = p + 48 | 0;
        o = u + 24 | 0;
        i = u;
        c = u + 12 | 0;
        Wi(c, a, n);
        s[i >> 2] = s[c >> 2];
        s[i + 4 >> 2] = s[c + 4 >> 2];
        s[i + 8 >> 2] = s[c + 8 >> 2];
        a = Gt(12, 4, o) | 0;
        if (!a) Vt(o);
        s[a >> 2] = s[i >> 2];
        s[a + 4 >> 2] = s[i + 4 >> 2];
        s[a + 8 >> 2] = s[i + 8 >> 2];
        n = Gt(12, 4, o) | 0;
        if (!n) Vt(o);else {
          s[n >> 2] = a;
          s[n + 4 >> 2] = 2728;
          r[n + 8 >> 0] = t;
          o = n + 9 | 0;
          r[o >> 0] = r[i >> 0] | 0;
          r[o + 1 >> 0] = r[i + 1 >> 0] | 0;
          r[o + 2 >> 0] = r[i + 2 >> 0] | 0;
          r[e >> 0] = 2;
          i = e + 1 | 0;
          r[i >> 0] = r[c >> 0] | 0;
          r[i + 1 >> 0] = r[c + 1 >> 0] | 0;
          r[i + 2 >> 0] = r[c + 2 >> 0] | 0;
          s[e + 4 >> 2] = n;
          p = u;
          return;
        }
      }

      function Cs(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0;
        d = p;
        p = p + 80 | 0;
        a = d + 56 | 0;
        i = d + 32 | 0;
        u = d + 8 | 0;
        c = d;

        switch (r[e >> 0] & 3) {
          case 0:
            {
              e = s[e + 4 >> 2] | 0;
              s[c >> 2] = e;
              Mn(u, e);
              s[a >> 2] = u;
              s[a + 4 >> 2] = 53;
              s[a + 8 >> 2] = c;
              s[a + 12 >> 2] = 54;
              s[i >> 2] = 2896;
              s[i + 4 >> 2] = 3;
              s[i + 8 >> 2] = 5264;
              s[i + 12 >> 2] = 2;
              s[i + 16 >> 2] = a;
              s[i + 20 >> 2] = 2;
              m = 0;
              e = se(55, t | 0, i | 0) | 0;
              c = m;
              m = 0;

              if (c & 1) {
                d = me() | 0;
                fs(u);
                Ee(d | 0);
              }

              t = s[u + 4 >> 2] | 0;
              if (t | 0) Ut(s[u >> 2] | 0, t, 1);
              u = e;
              p = d;
              return u | 0;
            }

          case 1:
            {
              do {
                switch (r[e + 1 >> 0] & 31) {
                  case 0:
                    {
                      n = 8123;
                      o = 16;
                      break;
                    }

                  case 1:
                    {
                      n = 8403;
                      o = 17;
                      break;
                    }

                  case 2:
                    {
                      n = 8139;
                      o = 18;
                      break;
                    }

                  case 3:
                    {
                      n = 8157;
                      o = 16;
                      break;
                    }

                  case 4:
                    {
                      n = 8173;
                      o = 18;
                      break;
                    }

                  case 5:
                    {
                      n = 8191;
                      o = 13;
                      break;
                    }

                  case 6:
                    {
                      n = 8204;
                      o = 14;
                      break;
                    }

                  case 7:
                    {
                      n = 8218;
                      o = 21;
                      break;
                    }

                  case 8:
                    {
                      n = 8239;
                      o = 11;
                      break;
                    }

                  case 9:
                    {
                      n = 8250;
                      o = 21;
                      break;
                    }

                  case 10:
                    {
                      n = 8271;
                      o = 21;
                      break;
                    }

                  case 11:
                    {
                      n = 8292;
                      o = 23;
                      break;
                    }

                  case 12:
                    {
                      n = 8315;
                      o = 12;
                      break;
                    }

                  case 13:
                    {
                      n = 8327;
                      o = 9;
                      break;
                    }

                  case 14:
                    {
                      n = 8336;
                      o = 10;
                      break;
                    }

                  case 15:
                    {
                      n = 8346;
                      o = 21;
                      break;
                    }

                  case 16:
                    {
                      n = 8367;
                      o = 14;
                      break;
                    }

                  case 17:
                    {
                      n = 8381;
                      o = 22;
                      break;
                    }

                  case 18:
                    {
                      pn(8083, 40, 2920);
                      break;
                    }

                  default:
                    {}
                }
              } while (0);

              s[a >> 2] = n;
              s[a + 4 >> 2] = o;
              s[i >> 2] = a;
              s[i + 4 >> 2] = 41;
              s[u >> 2] = 2936;
              s[u + 4 >> 2] = 1;
              s[u + 8 >> 2] = 5180;
              s[u + 12 >> 2] = 1;
              s[u + 16 >> 2] = i;
              s[u + 20 >> 2] = 1;
              u = fc(t, u) | 0;
              p = d;
              return u | 0;
            }

          case 2:
            {
              u = s[e + 4 >> 2] | 0;
              u = Gd[s[(s[u + 4 >> 2] | 0) + 24 >> 2] & 127](s[u >> 2] | 0, t) | 0;
              p = d;
              return u | 0;
            }

          default:
            {}
        }

        return 0;
      }

      function Ss(e, t) {
        e = e | 0;
        t = t | 0;
        return vc(s[e >> 2] | 0, s[e + 8 >> 2] | 0, t) | 0;
      }

      function Es(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var n = 0,
            o = 0,
            i = 0,
            c = 0;
        i = p;
        p = p + 16 | 0;
        c = i;
        ui(c, s[e >> 2] | 0, t, a);

        if ((r[c >> 0] | 0) == 3) {
          c = 0;
          p = i;
          return c | 0;
        }

        o = c;
        n = s[o >> 2] | 0;
        o = s[o + 4 >> 2] | 0;
        a = e + 4 | 0;
        e = n & 255;

        if ((r[a >> 0] | 0) != 3 ? (m = 0, ee(46, a | 0), t = m, m = 0, t & 1) : 0) {
          t = me() | 0;
          i = a;
          s[i >> 2] = n;
          s[i + 4 >> 2] = o;
          if (e << 24 >> 24 != 3) Ee(t | 0);
          ts(c);
          Ee(t | 0);
        }

        c = a;
        s[c >> 2] = n;
        s[c + 4 >> 2] = o;
        c = 1;
        p = i;
        return c | 0;
      }

      function Bs(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0,
            A = 0,
            w = 0,
            T = 0,
            x = 0,
            D = 0,
            C = 0,
            S = 0,
            E = 0,
            B = 0,
            k = 0,
            R = 0,
            W = 0,
            I = 0,
            N = 0,
            M = 0;
        M = p;
        p = p + 112 | 0;
        n = M + 16 | 0;
        o = M;
        k = M + 64 | 0;
        R = M + 40 | 0;
        W = M + 32 | 0;
        I = M + 24 | 0;

        if (dc(a, 3612, 1) | 0) {
          N = 1;
          p = M;
          return N | 0;
        }

        Gi(o, e, t);
        Vi(n, s[o >> 2] | 0, s[o + 4 >> 2] | 0);
        e = s[n + 4 >> 2] | 0;
        s[I >> 2] = s[n >> 2];
        s[I + 4 >> 2] = e;
        Ui(k, I);
        e = s[k >> 2] | 0;

        e: do {
          if (e | 0) {
            h = k + 4 | 0;
            b = k + 8 | 0;
            m = k + 12 | 0;
            y = k + 8 | 0;
            v = k + 4 | 0;
            _ = k + 8 | 0;
            g = k + 24 | 0;
            A = k + 4 | 0;
            w = R + 4 | 0;
            T = R + 8 | 0;
            x = R + 12 | 0;
            D = R + 16 | 0;
            C = R + 20 | 0;
            S = k + 12 | 0;
            E = k + 16 | 0;

            t: while (1) {
              f = s[b >> 2] | 0;
              l = s[m >> 2] | 0;
              d = e + (s[h >> 2] | 0) | 0;
              s[k >> 2] = e;
              s[v >> 2] = d;
              s[_ >> 2] = 4;
              s[g >> 2] = 4;
              e = 4;

              while (1) {
                a: while (1) {
                  if ((e | 0) != 4 ? (B = au(y) | 0, (B | 0) != 1114112) : 0) {
                    e = B;
                    break;
                  }

                  e = s[k >> 2] | 0;
                  c = s[v >> 2] | 0;

                  if ((e | 0) == (c | 0)) {
                    N = 29;
                    break;
                  }

                  t = e + 1 | 0;
                  s[k >> 2] = t;
                  u = r[e >> 0] | 0;

                  if (u << 24 >> 24 <= -1) {
                    d = u & 31;

                    if ((t | 0) == (c | 0)) {
                      e = 0;
                      n = c;
                    } else {
                      n = e + 2 | 0;
                      s[k >> 2] = n;
                      e = r[t >> 0] & 63;
                    }

                    o = e & 255;
                    t = o | d << 6;

                    if ((u & 255) > 223) {
                      if ((n | 0) == (c | 0)) {
                        e = 0;
                        i = c;
                      } else {
                        i = n + 1 | 0;
                        s[k >> 2] = i;
                        e = r[n >> 0] & 63;
                      }

                      n = e & 255 | o << 6;
                      t = n | d << 12;

                      if ((u & 255) > 239) {
                        if ((i | 0) == (c | 0)) e = 0;else {
                          s[k >> 2] = i + 1;
                          e = r[i >> 0] & 63;
                        }
                        t = n << 6 | d << 18 & 1835008 | e & 255;
                      }
                    }
                  } else t = u & 255;

                  r: do {
                    if ((t | 0) < 34) switch (t | 0) {
                      case 9:
                        {
                          n = 0;
                          e = 2;
                          o = 116;
                          t = 0;
                          break r;
                        }

                      case 13:
                        {
                          n = 0;
                          e = 2;
                          o = 114;
                          t = 0;
                          break r;
                        }

                      case 10:
                        {
                          n = 0;
                          e = 2;
                          o = 110;
                          t = 0;
                          break r;
                        }

                      default:
                        {
                          N = 28;
                          break r;
                        }
                    } else {
                      n: do {
                        if ((t | 0) >= 92) {
                          if ((t | 0) < 1114112) switch (t | 0) {
                            case 92:
                              break n;

                            default:
                              {
                                N = 28;
                                break r;
                              }
                          } else switch (t | 0) {
                            case 1114112:
                              {
                                N = 29;
                                break a;
                              }

                            default:
                              {
                                N = 28;
                                break r;
                              }
                          }
                        } else switch (t | 0) {
                          case 34:
                          case 39:
                            break;

                          default:
                            {
                              N = 28;
                              break r;
                            }
                        }
                      } while (0);

                      n = 0;
                      e = 2;
                      o = t;
                      t = 0;
                    }
                  } while (0);

                  if ((N | 0) == 28) {
                    N = 0;

                    if (cu(t) | 0) {
                      n = 0;
                      e = 1;
                      o = t;
                      t = 0;
                    } else {
                      n = 5;
                      e = 3;
                      o = t;
                      t = (z(t | 1 | 0) | 0) >>> 2 ^ 7;
                    }
                  }

                  s[_ >> 2] = e;
                  s[S >> 2] = o;
                  d = E;
                  s[d >> 2] = t;
                  s[d + 4 >> 2] = n;
                }

                if ((N | 0) == 29) {
                  N = 0;
                  if ((s[g >> 2] | 0) == 4) break;
                  e = au(g) | 0;
                  if ((e | 0) == 1114112) break;
                }

                if (mc(a, e) | 0) {
                  N = 36;
                  break t;
                }

                e = s[y >> 2] | 0;
              }

              t = f + l | 0;

              if (l | 0) {
                e = f;

                do {
                  s[W >> 2] = e;
                  s[k >> 2] = W;
                  s[A >> 2] = 56;
                  s[R >> 2] = 2944;
                  s[w >> 2] = 1;
                  s[T >> 2] = 2952;
                  s[x >> 2] = 1;
                  s[D >> 2] = k;
                  s[C >> 2] = 1;

                  if (fc(a, R) | 0) {
                    N = 40;
                    break t;
                  }

                  e = e + 1 | 0;
                } while ((e | 0) != (t | 0));
              }

              Ui(k, I);
              e = s[k >> 2] | 0;
              if (!e) break e;
            }

            N = 1;
            p = M;
            return N | 0;
          }
        } while (0);

        N = dc(a, 3612, 1) | 0;
        p = M;
        return N | 0;
      }

      function ks(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0;
        a = p;
        p = p + 16 | 0;
        n = a + 12 | 0;
        r = a;
        pc(r, t, 8465, 8);
        s[n >> 2] = e;
        Lc(r, n, 2988) | 0;
        s[n >> 2] = e + 4;
        Lc(r, n, 3004) | 0;
        t = Oc(r) | 0;
        p = a;
        return t | 0;
      }

      function Rs(e) {
        e = e | 0;
        return;
      }

      function Ws(e) {
        e = e | 0;
        return;
      }

      function Is(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0;
        a = p;
        p = p + 16 | 0;
        n = a + 8 | 0;
        r = a;
        hc(r, t, 7815, 5);
        s[n >> 2] = e;
        Mc(r, 7820, 4, n, 2800) | 0;
        t = Pc(r) | 0;
        p = a;
        return t | 0;
      }

      function Ns(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0;
        d = p;
        p = p + 80 | 0;
        t = d + 56 | 0;
        a = d + 32 | 0;
        r = d + 24 | 0;
        n = d + 20 | 0;
        o = d + 16 | 0;
        i = d + 12 | 0;
        c = d + 8 | 0;
        l = d + 4 | 0;
        u = d;
        f = Le(u | 0) | 0;
        s[l >> 2] = f;
        s[n >> 2] = l;
        s[r >> 2] = 15856;

        if (f | 0) {
          s[t >> 2] = n;
          s[t + 4 >> 2] = 57;
          s[t + 8 >> 2] = r;
          s[t + 12 >> 2] = 57;
          s[a >> 2] = 2776;
          s[a + 4 >> 2] = 3;
          s[a + 8 >> 2] = 5264;
          s[a + 12 >> 2] = 2;
          s[a + 16 >> 2] = t;
          s[a + 20 >> 2] = 2;
          bn(a, 3020);
        }

        l = ke(u | 0, 1) | 0;
        s[c >> 2] = l;
        s[n >> 2] = c;
        s[r >> 2] = 15856;

        if (l | 0) {
          s[t >> 2] = n;
          s[t + 4 >> 2] = 57;
          s[t + 8 >> 2] = r;
          s[t + 12 >> 2] = 57;
          s[a >> 2] = 2776;
          s[a + 4 >> 2] = 3;
          s[a + 8 >> 2] = 5264;
          s[a + 12 >> 2] = 2;
          s[a + 16 >> 2] = t;
          s[a + 20 >> 2] = 2;
          bn(a, 3036);
        }

        l = _e(e | 0, u | 0) | 0;
        s[i >> 2] = l;
        s[n >> 2] = i;
        s[r >> 2] = 15856;

        if (l | 0) {
          s[t >> 2] = n;
          s[t + 4 >> 2] = 57;
          s[t + 8 >> 2] = r;
          s[t + 12 >> 2] = 57;
          s[a >> 2] = 2776;
          s[a + 4 >> 2] = 3;
          s[a + 8 >> 2] = 5264;
          s[a + 12 >> 2] = 2;
          s[a + 16 >> 2] = t;
          s[a + 20 >> 2] = 2;
          bn(a, 3052);
        }

        l = je(u | 0) | 0;
        s[o >> 2] = l;
        s[n >> 2] = o;
        s[r >> 2] = 15856;

        if (!l) {
          p = d;
          return;
        } else {
          s[t >> 2] = n;
          s[t + 4 >> 2] = 57;
          s[t + 8 >> 2] = r;
          s[t + 12 >> 2] = 57;
          s[a >> 2] = 2776;
          s[a + 4 >> 2] = 3;
          s[a + 8 >> 2] = 5264;
          s[a + 12 >> 2] = 2;
          s[a + 16 >> 2] = t;
          s[a + 20 >> 2] = 2;
          bn(a, 3068);
        }
      }

      function Ms(e) {
        e = e | 0;
        return;
      }

      function Ps(e, t) {
        e = e | 0;
        t = t | 0;
        e = s[e >> 2] | 0;
        t = r[e >> 0] | 0;
        r[e >> 0] = 0;
        if (!(t << 24 >> 24)) Kc(3104);
        td(15864) | 0;
        m = 0;
        ee(55, 15860);
        t = m;
        m = 0;

        if (t & 1) {
          t = me() | 0;
          s[3965] = 0;
          Ee(t | 0);
        } else {
          s[3965] = 0;
          sd(15864) | 0;
          Ho();
          return;
        }
      }

      function Ls(e, t) {
        e = e | 0;
        t = t | 0;
        t = r[e >> 0] | 0;
        r[e >> 0] = 0;
        if (!(t << 24 >> 24)) Kc(3104);
        td(15864) | 0;
        m = 0;
        ee(55, 15860);
        t = m;
        m = 0;

        if (t & 1) {
          t = me() | 0;
          s[3965] = 0;
          Ee(t | 0);
        } else {
          s[3965] = 0;
          sd(15864) | 0;
          Ho();
          return;
        }
      }

      function Os(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            r = 0;
        if ((o[e >> 0] | 0) < 2) return;
        a = e + 4 | 0;
        r = s[a >> 2] | 0;
        e = r + 4 | 0;
        m = 0;
        ee(s[s[e >> 2] >> 2] | 0, s[r >> 2] | 0);
        t = m;
        m = 0;

        if (t & 1) {
          t = me() | 0;
          Fs(s[r >> 2] | 0, s[e >> 2] | 0);
          js(s[a >> 2] | 0);
          Ee(t | 0);
        }

        e = s[e >> 2] | 0;
        t = s[e + 4 >> 2] | 0;
        if (t | 0) Ut(s[r >> 2] | 0, t, s[e + 8 >> 2] | 0);
        Ut(s[a >> 2] | 0, 12, 4);
        return;
      }

      function Fs(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0;
        a = s[t + 4 >> 2] | 0;
        if (!a) return;
        Ut(e, a, s[t + 8 >> 2] | 0);
        return;
      }

      function js(e) {
        e = e | 0;
        Ut(e, 12, 4);
        return;
      }

      function Gs(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0;
        c = p;
        p = p + 80 | 0;
        r = c + 56 | 0;
        n = c + 32 | 0;
        o = c;
        u = c + 16 | 0;
        i = c + 8 | 0;
        s[i >> 2] = t;
        s[i + 4 >> 2] = a;
        Pn(u, t, a);
        t = u + 4 | 0;

        if ((s[u >> 2] | 0) == 1) {
          e = t;
          c = s[e + 4 >> 2] | 0;
          u = o;
          s[u >> 2] = s[e >> 2];
          s[u + 4 >> 2] = c;
          s[r >> 2] = i;
          s[r + 4 >> 2] = 58;
          s[r + 8 >> 2] = o;
          s[r + 12 >> 2] = 59;
          s[n >> 2] = 3152;
          s[n + 4 >> 2] = 2;
          s[n + 8 >> 2] = 5264;
          s[n + 12 >> 2] = 2;
          s[n + 16 >> 2] = r;
          s[n + 20 >> 2] = 2;
          m = 0;
          te(26, n | 0, 3168);
          m = 0;
          u = me() | 0;
          Os(o);
          Ee(u | 0);
        } else {
          s[e >> 2] = s[t >> 2];
          s[e + 4 >> 2] = s[t + 4 >> 2];
          s[e + 8 >> 2] = s[t + 8 >> 2];
          p = c;
          return;
        }
      }

      function Vs(e, t) {
        e = e | 0;
        t = t | 0;
        s[e >> 2] = 0;
        return;
      }

      function Us(e) {
        e = e | 0;
        S = 1536465966;
        return -1196322623;
      }

      function Hs(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0;
        a = s[t + 8 >> 2] | 0;
        s[e >> 2] = s[t >> 2];
        s[e + 4 >> 2] = a;
        return;
      }

      function zs(e, t) {
        e = e | 0;
        t = t | 0;
        return vc(s[e >> 2] | 0, s[e + 8 >> 2] | 0, t) | 0;
      }

      function Ks(e, t, a, n) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        n = n | 0;
        var o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            y = 0;
        b = p;
        p = p + 32 | 0;
        h = b + 16 | 0;
        u = b;
        d = u + 8 | 0;
        f = u + 4 | 0;
        c = u | 2;
        i = s[e >> 2] | 0;

        e: while (1) {
          switch (i | 0) {
            case 3:
              {
                l = 8;
                break e;
              }

            case 1:
              {
                if (!t) {
                  l = 4;
                  break e;
                }

                break;
              }

            case 0:
              break;

            default:
              {
                if ((i & 3 | 0) != 2) {
                  l = 11;
                  break e;
                }

                o = ci(3804) | 0;
                s[h >> 2] = o;

                if (!o) {
                  l = 13;
                  break e;
                }

                s[u >> 2] = o;
                r[d >> 0] = 0;
                s[f >> 2] = 0;

                while (1) {
                  if ((i & 3 | 0) != 2) {
                    l = 16;
                    break;
                  }

                  s[f >> 2] = i & -4;
                  o = s[e >> 2] | 0;
                  if ((o | 0) == (i | 0)) s[e >> 2] = c;
                  if ((o | 0) == (i | 0)) break;else i = o;
                }

                if ((l | 0) == 16) {
                  l = 0;
                  o = s[u >> 2] | 0;
                  if (o | 0 ? (y = s[o >> 2] | 0, s[o >> 2] = y - 1, (y | 0) == 1) : 0) On(u);
                  continue e;
                }

                while (1) {
                  if (r[d >> 0] | 0) break;
                  m = 0;
                  ne(2);
                  y = m;
                  m = 0;

                  if (y & 1) {
                    l = 27;
                    break e;
                  }
                }

                o = s[e >> 2] | 0;
                i = s[u >> 2] | 0;
                if (i | 0 ? (y = s[i >> 2] | 0, s[i >> 2] = y - 1, (y | 0) == 1) : 0) On(u);
                i = o;
                continue e;
              }
          }

          o = s[e >> 2] | 0;
          if ((o | 0) == (i | 0)) s[e >> 2] = 2;

          if ((o | 0) == (i | 0)) {
            l = 9;
            break;
          } else i = o;
        }

        if ((l | 0) == 4) pn(8671, 42, 3184);else if ((l | 0) == 8) {
          p = b;
          return;
        } else if ((l | 0) == 9) {
          o = h + 4 | 0;
          r[o >> 0] = 1;
          s[h >> 2] = e;
          m = 0;
          te(s[n + 12 >> 2] | 0, a | 0, (i | 0) == 1 | 0);
          y = m;
          m = 0;

          if (y & 1) {
            y = me() | 0;
            Zs(h);
            Ee(y | 0);
          } else {
            r[o >> 0] = 0;
            qs(h);
            p = b;
            return;
          }
        } else if ((l | 0) == 11) pn(8713, 47, 3200);else if ((l | 0) == 13) {
          m = 0;
          te(21, 8847, 94);
          m = 0;
          y = me() | 0;
          ro(h);
          Ee(y | 0);
        } else if ((l | 0) == 27) {
          y = me() | 0;
          Ys(u);
          Ee(y | 0);
        }
      }

      function qs(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            n = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0;
        u = p;
        p = p + 64 | 0;
        i = u + 40 | 0;
        c = u + 16 | 0;
        a = u + 8 | 0;
        n = u + 4 | 0;
        d = u;
        f = s[e >> 2] | 0;
        t = s[f >> 2] | 0;
        s[f >> 2] = (r[e + 4 >> 0] | 0) == 0 ? 3 : 1;
        e = t & 3;
        s[d >> 2] = e;
        s[n >> 2] = d;
        s[a >> 2] = 3216;

        if ((e | 0) != 2) {
          s[i >> 2] = n;
          s[i + 4 >> 2] = 16;
          s[i + 8 >> 2] = a;
          s[i + 12 >> 2] = 16;
          s[c >> 2] = 3128;
          s[c + 4 >> 2] = 3;
          s[c + 8 >> 2] = 5264;
          s[c + 12 >> 2] = 2;
          s[c + 16 >> 2] = i;
          s[c + 20 >> 2] = 2;
          bn(c, 3220);
        }

        e = t & -4;

        if (!e) {
          p = u;
          return;
        }

        while (1) {
          t = e;
          e = s[e + 4 >> 2] | 0;
          a = o[t >> 0] | o[t + 1 >> 0] << 8 | o[t + 2 >> 0] << 16 | o[t + 3 >> 0] << 24;
          r[t >> 0] = 0;
          r[t + 1 >> 0] = 0;
          r[t + 2 >> 0] = 0;
          r[t + 3 >> 0] = 0;
          s[i >> 2] = a;

          if (!a) {
            e = 7;
            break;
          }

          s[c >> 2] = a;
          r[t + 8 >> 0] = 1;
          m = 0;
          ee(56, c | 0);
          f = m;
          m = 0;

          if (f & 1) {
            e = 12;
            break;
          }

          d = s[c >> 2] | 0;
          f = s[d >> 2] | 0;
          s[d >> 2] = f - 1;
          if ((f | 0) == 1) On(c);

          if (!e) {
            e = 5;
            break;
          }
        }

        if ((e | 0) == 5) {
          p = u;
          return;
        } else if ((e | 0) == 7) {
          m = 0;
          ee(44, 3104);
          m = 0;
          f = me() | 0;
          Js(i);
          Ee(f | 0);
        } else if ((e | 0) == 12) {
          f = me() | 0;
          Xs(c);
          Ee(f | 0);
        }
      }

      function Ys(e) {
        e = e | 0;
        var t = 0,
            a = 0;
        t = s[e >> 2] | 0;
        if (!t) return;
        a = s[t >> 2] | 0;
        s[t >> 2] = a - 1;
        if ((a | 0) != 1) return;
        On(e);
        return;
      }

      function Zs(e) {
        e = e | 0;
        qs(e);
        return;
      }

      function Js(e) {
        e = e | 0;
        var t = 0,
            a = 0;
        t = s[e >> 2] | 0;
        if (!t) return;
        a = s[t >> 2] | 0;
        s[t >> 2] = a - 1;
        if ((a | 0) != 1) return;
        On(e);
        return;
      }

      function Xs(e) {
        e = e | 0;
        var t = 0,
            a = 0;
        a = s[e >> 2] | 0;
        t = s[a >> 2] | 0;
        s[a >> 2] = t - 1;
        if ((t | 0) != 1) return;
        On(e);
        return;
      }

      function $s(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0;
        a = p;
        p = p + 16 | 0;
        n = a + 12 | 0;
        r = a;
        pc(r, t, 8793, 11);
        s[n >> 2] = e;
        Lc(r, n, 3236) | 0;
        t = Oc(r) | 0;
        p = a;
        return t | 0;
      }

      function Qs(e) {
        e = e | 0;
        return;
      }

      function eo(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0;
        a = s[t + 4 >> 2] | 0;
        if (!a) return;
        Ut(e, a, s[t + 8 >> 2] | 0);
        return;
      }

      function to(e) {
        e = e | 0;
        Ut(e, 12, 4);
        return;
      }

      function ao(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            n = 0,
            o = 0;
        a = (s[e >> 2] | 0) + 4 | 0;

        if (!(r[e + 4 >> 0] | 0)) {
          t = Md[s[600] & 7]() | 0;
          if (!t) Fn(10081, 57);

          if ((s[t >> 2] | 0) == 1) {
            t = t + 4 | 0;
            n = s[t >> 2] | 0;
          } else {
            n = Md[s[2404 >> 2] & 7]() | 0;
            o = t;
            s[o >> 2] = 1;
            s[o + 4 >> 2] = n;
            t = t + 4 | 0;
          }

          r[t >> 0] = n;
          r[t + 1 >> 0] = n >> 8;
          r[t + 2 >> 0] = n >> 16;
          r[t + 3 >> 0] = n >> 24;
          if (n | 0) r[a >> 0] = 1;
        }

        sd(s[s[e >> 2] >> 2] | 0) | 0;
        return;
      }

      function ro(e) {
        e = e | 0;
        var t = 0,
            a = 0;
        t = s[e >> 2] | 0;
        if (!t) return;
        a = s[t >> 2] | 0;
        s[t >> 2] = a - 1;
        if ((a | 0) != 1) return;
        On(e);
        return;
      }

      function no(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0,
            i = 0;
        r = s[t >> 2] | 0;
        n = s[t + 4 >> 2] | 0;
        o = 0 - n | 0;
        t = r + ((r + -1 + n & o) - r) | 0;

        if (t >>> 0 < r >>> 0) {
          s[e >> 2] = 0;
          return;
        }

        r = V(t, a) | 0;
        i = (a | 0) == 0;

        if (i ? 0 : ((r >>> 0) / ((i ? 1 : a) >>> 0) | 0 | 0) != (t | 0)) {
          s[e >> 2] = 0;
          return;
        }

        if ((n + -1 & (n | -2147483648) | 0) != 0 | r >>> 0 > o >>> 0) Kc(3300);
        s[e >> 2] = 1;
        s[e + 4 >> 2] = r;
        s[e + 8 >> 2] = n;
        s[e + 12 >> 2] = t;
        return;
      }

      function so() {
        var e = 0,
            t = 0,
            a = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0;
        f = p;
        p = p + 32 | 0;
        d = f + 16 | 0;
        u = f + 8 | 0;
        l = f;
        e = ci(3804) | 0;
        s[d >> 2] = e;

        if (!e) {
          m = 0;
          te(21, 8847, 94);
          m = 0;
          l = me() | 0;
          ro(d);
          Ee(l | 0);
        }

        s[l >> 2] = e;
        t = e + 24 | 0;
        e = s[t >> 2] | 0;
        if ((e | 0) == 2) s[t >> 2] = 0;

        e: do {
          if ((e | 0) != 2) {
            n = s[l >> 2] | 0;
            a = n + 28 | 0;
            td(s[a >> 2] | 0) | 0;
            n = n + 32 | 0;
            m = 0;
            t = Q(s[600] | 0) | 0;
            c = m;
            m = 0;

            do {
              if (!(c & 1)) {
                if (!t) {
                  m = 0;
                  te(22, 10081, 57);
                  m = 0;
                  break;
                }

                if ((s[t >> 2] | 0) == 1) {
                  t = t + 4 | 0;
                  e = s[t >> 2] | 0;
                } else {
                  m = 0;
                  e = Q(s[601] | 0) | 0;
                  c = m;
                  m = 0;
                  if (c & 1) break;
                  c = t;
                  s[c >> 2] = 1;
                  s[c + 4 >> 2] = e;
                  t = t + 4 | 0;
                }

                r[t >> 0] = e;
                r[t + 1 >> 0] = e >> 8;
                r[t + 2 >> 0] = e >> 16;
                r[t + 3 >> 0] = e >> 24;
                t = (e | 0) != 0;

                if (r[n >> 0] | 0) {
                  m = 0;
                  ie(7, 8804, 43, a | 0, t | 0);
                  m = 0;
                  break;
                }

                s[u >> 2] = a;
                e = u + 4 | 0;
                r[e >> 0] = t & 1;
                t = (s[l >> 2] | 0) + 24 | 0;
                a = s[t >> 2] | 0;
                if (!a) s[t >> 2] = 1;

                t: do {
                  if (!a) {
                    c = d + 4 | 0;

                    while (1) {
                      t = s[l >> 2] | 0;
                      a = s[u >> 2] | 0;
                      n = r[e >> 0] | 0;
                      s[d >> 2] = a;
                      r[c >> 0] = n;
                      a = s[a >> 2] | 0;
                      n = a;
                      o = t + 40 | 0;
                      i = s[o >> 2] | 0;
                      if (!i) s[o >> 2] = n;

                      if (!((i | 0) == 0 | (i | 0) == (n | 0))) {
                        t = 34;
                        break;
                      }

                      ce(s[t + 36 >> 2] | 0, a | 0) | 0;
                      a = s[d >> 2] | 0;
                      n = r[c >> 0] | 0;

                      if (r[a + 4 >> 0] | 0) {
                        t = 36;
                        break;
                      }

                      s[u >> 2] = a;
                      r[e >> 0] = n;
                      t = (s[l >> 2] | 0) + 24 | 0;
                      a = s[t >> 2] | 0;
                      if ((a | 0) == 2) s[t >> 2] = 0;
                      if ((a | 0) == 2) break t;
                    }

                    if ((t | 0) == 34) {
                      m = 0;
                      re(21, 7600, 54, 2656);
                      m = 0;
                      e = me() | 0;
                      m = 0;
                      ee(57, d | 0);
                      f = m;
                      m = 0;
                      if (f & 1) t = 39;
                    } else if ((t | 0) == 36) {
                      m = 0;
                      ie(7, 8804, 43, a | 0, n << 24 >> 24 != 0 | 0);
                      m = 0;
                      t = 39;
                    }

                    if ((t | 0) == 39) e = me() | 0;
                    f = e;
                    oo(l);
                    Ee(f | 0);
                  } else {
                    if ((a | 0) == 2) break;
                    m = 0;
                    re(21, 9180, 23, 3324);
                    m = 0;
                    f = me() | 0;
                    ao(u);
                    oo(l);
                    Ee(f | 0);
                  }
                } while (0);

                a = s[u >> 2] | 0;
                n = a + 4 | 0;

                if (!(r[e >> 0] | 0)) {
                  m = 0;
                  t = Q(s[600] | 0) | 0;
                  d = m;
                  m = 0;
                  if (d & 1) break;

                  if (!t) {
                    m = 0;
                    te(22, 10081, 57);
                    m = 0;
                    break;
                  }

                  if ((s[t >> 2] | 0) == 1) {
                    t = t + 4 | 0;
                    e = s[t >> 2] | 0;
                  } else {
                    m = 0;
                    e = Q(s[601] | 0) | 0;
                    d = m;
                    m = 0;
                    if (d & 1) break;
                    d = t;
                    s[d >> 2] = 1;
                    s[d + 4 >> 2] = e;
                    t = t + 4 | 0;
                  }

                  r[t >> 0] = e;
                  r[t + 1 >> 0] = e >> 8;
                  r[t + 2 >> 0] = e >> 16;
                  r[t + 3 >> 0] = e >> 24;
                  if (e | 0) r[n >> 0] = 1;
                }

                sd(s[a >> 2] | 0) | 0;
                break e;
              }
            } while (0);

            f = me() | 0;
            oo(l);
            Ee(f | 0);
          }
        } while (0);

        u = s[l >> 2] | 0;
        d = s[u >> 2] | 0;
        s[u >> 2] = d - 1;

        if ((d | 0) != 1) {
          p = f;
          return;
        }

        On(l);
        p = f;
        return;
      }

      function oo(e) {
        e = e | 0;
        var t = 0,
            a = 0;
        a = s[e >> 2] | 0;
        t = s[a >> 2] | 0;
        s[a >> 2] = t - 1;
        if ((t | 0) != 1) return;
        On(e);
        return;
      }

      function io(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0;
        d = p;
        p = p + 64 | 0;
        a = d;
        u = d + 40 | 0;
        f = d + 28 | 0;
        l = d + 16 | 0;
        h = d + 8 | 0;
        s[l >> 2] = s[e >> 2];
        s[l + 4 >> 2] = s[e + 4 >> 2];
        s[l + 8 >> 2] = s[e + 8 >> 2];

        do {
          if (s[l >> 2] | 0) {
            s[u >> 2] = s[l >> 2];
            s[u + 4 >> 2] = s[l + 4 >> 2];
            s[u + 8 >> 2] = s[l + 8 >> 2];
            Li(f, u);
            t = s[f >> 2] | 0;
            e = ku(t, 0, s[f + 8 >> 2] | 0) | 0;

            if (!e) {
              s[u >> 2] = s[f >> 2];
              s[u + 4 >> 2] = s[f + 4 >> 2];
              s[u + 8 >> 2] = s[f + 8 >> 2];
              As(a, u);
              r = s[a >> 2] | 0;
              n = s[a + 4 >> 2] | 0;
              break;
            } else {
              i = f + 4 | 0;
              o = s[i >> 2] | 0;
              i = s[i + 4 >> 2] | 0;
              s[u >> 2] = e - t;
              s[u + 4 >> 2] = t;
              c = u + 8 | 0;
              s[c >> 2] = o;
              s[c + 4 >> 2] = i;
              qn(9203, 47, u);
            }
          } else {
            r = 0;
            n = 0;
          }
        } while (0);

        s[h >> 2] = r;
        s[h + 4 >> 2] = n;
        td(15736) | 0;
        i = 15600;
        o = s[i >> 2] | 0;
        i = s[i + 4 >> 2] | 0;

        if (!((o | 0) == -1 & (i | 0) == -1)) {
          n = Qu(o | 0, i | 0, 1, 0) | 0;
          c = 15600;
          s[c >> 2] = n;
          s[c + 4 >> 2] = S;
          sd(15736) | 0;
          m = 0;
          ee(58, l | 0);
          c = m;
          m = 0;

          if (!(c & 1)) {
            c = Gt(48, 4, u) | 0;
            if (!c) Vt(u);
            e = c;
            t = 15684;
            a = e + 48 | 0;

            do {
              s[e >> 2] = s[t >> 2];
              e = e + 4 | 0;
              t = t + 4 | 0;
            } while ((e | 0) < (a | 0));

            s[f >> 2] = c;
            s[f + 4 >> 2] = 0;
            m = 0;
            ee(60, c | 0);
            n = m;
            m = 0;

            if (!(n & 1)) {
              t = h;
              e = s[t >> 2] | 0;
              t = s[t + 4 >> 2] | 0;
              r = l;
              a = s[r >> 2] | 0;
              r = s[r + 4 >> 2] | 0;
              n = Gt(48, 8, u) | 0;
              if (!n) Vt(u);else {
                s[n >> 2] = 1;
                s[n + 4 >> 2] = 1;
                h = n + 8 | 0;
                s[h >> 2] = o;
                s[h + 4 >> 2] = i;
                h = n + 16 | 0;
                s[h >> 2] = e;
                s[h + 4 >> 2] = t;
                s[n + 24 >> 2] = 0;
                h = n + 28 | 0;
                s[h >> 2] = a;
                s[h + 4 >> 2] = r;
                s[n + 36 >> 2] = c;
                s[n + 40 >> 2] = 0;
                p = d;
                return n | 0;
              }
            }

            e = me() | 0;
            m = 0;
            ee(59, f | 0);
            f = m;
            m = 0;
            if (f & 1) e = me() | 0;
            uo(l);
            l = e;
            co(h);
            Ee(l | 0);
          }
        } else {
          sd(15736) | 0;
          m = 0;
          re(21, 9250, 55, 3340);
          m = 0;
        }

        l = me() | 0;
        co(h);
        Ee(l | 0);
        return 0;
      }

      function co(e) {
        e = e | 0;
        var t = 0;
        t = s[e >> 2] | 0;
        if (!t) return;
        r[t >> 0] = 0;
        t = s[e + 4 >> 2] | 0;
        if (!t) return;
        Ut(s[e >> 2] | 0, t, 1);
        return;
      }

      function uo(e) {
        e = e | 0;
        Me(s[e >> 2] | 0) | 0;
        Ut(s[e >> 2] | 0, 28, 4);
        return;
      }

      function fo(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0;
        l = p;
        p = p + 16 | 0;
        u = l;
        t = (s[e >> 2] | 0) + 24 | 0;
        a = s[t >> 2] | 0;
        if (!a) s[t >> 2] = 2;

        if (!a) {
          p = l;
          return;
        }

        f = u + 4 | 0;
        i = s[600] | 0;
        c = s[601] | 0;
        t = a;

        e: while (1) {
          switch (t | 0) {
            case 2:
              {
                d = 12;
                break e;
              }

            case 1:
              break;

            default:
              {
                d = 10;
                break e;
              }
          }

          n = s[e >> 2] | 0;
          o = n + 28 | 0;
          td(s[o >> 2] | 0) | 0;
          t = Md[i & 7]() | 0;

          if (!t) {
            d = 7;
            break;
          }

          if ((s[t >> 2] | 0) == 1) {
            t = t + 4 | 0;
            a = s[t >> 2] | 0;
          } else {
            a = Md[c & 7]() | 0;
            h = t;
            s[h >> 2] = 1;
            s[h + 4 >> 2] = a;
            t = t + 4 | 0;
          }

          r[t >> 0] = a;
          r[t + 1 >> 0] = a >> 8;
          r[t + 2 >> 0] = a >> 16;
          r[t + 3 >> 0] = a >> 24;
          t = (a | 0) != 0;

          if (r[n + 32 >> 0] | 0) {
            d = 9;
            break;
          }

          s[u >> 2] = o;
          r[f >> 0] = t & 1;
          t = n + 24 | 0;
          a = s[t >> 2] | 0;
          if ((a | 0) == 1) s[t >> 2] = 2;

          if ((a | 0) == 1) {
            d = 25;
            break;
          }

          switch (a | 0) {
            case 2:
              break e;

            case 0:
              break;

            default:
              {
                d = 23;
                break e;
              }
          }

          a = s[u >> 2] | 0;
          n = a + 4 | 0;

          if (!(r[f >> 0] | 0)) {
            t = Md[i & 7]() | 0;

            if (!t) {
              d = 19;
              break;
            }

            if ((s[t >> 2] | 0) == 1) {
              t = t + 4 | 0;
              o = s[t >> 2] | 0;
            } else {
              o = Md[c & 7]() | 0;
              h = t;
              s[h >> 2] = 1;
              s[h + 4 >> 2] = o;
              t = t + 4 | 0;
            }

            r[t >> 0] = o;
            r[t + 1 >> 0] = o >> 8;
            r[t + 2 >> 0] = o >> 16;
            r[t + 3 >> 0] = o >> 24;
            if (o | 0) r[n >> 0] = 1;
          }

          sd(s[a >> 2] | 0) | 0;
          a = (s[e >> 2] | 0) + 24 | 0;
          t = s[a >> 2] | 0;
          if (!t) s[a >> 2] = 2;

          if (!t) {
            d = 12;
            break;
          }
        }

        if ((d | 0) == 7) Fn(10081, 57);else if ((d | 0) == 9) Zn(8804, 43, o, t);else if ((d | 0) == 10) pn(8975, 28, 3252);else if ((d | 0) == 12) {
          p = l;
          return;
        } else if ((d | 0) == 19) Fn(10081, 57);else if ((d | 0) == 23) {
          m = 0;
          re(21, 8975, 28, 3268);
          m = 0;
          h = me() | 0;
          ao(u);
          Ee(h | 0);
        } else if ((d | 0) == 25) Ne(s[(s[e >> 2] | 0) + 36 >> 2] | 0) | 0;
        n = s[u >> 2] | 0;
        o = n + 4 | 0;

        if (!(r[f >> 0] | 0)) {
          t = Md[s[600] & 7]() | 0;
          if (!t) Fn(10081, 57);

          if ((s[t >> 2] | 0) == 1) {
            t = t + 4 | 0;
            a = s[t >> 2] | 0;
          } else {
            a = Md[s[2404 >> 2] & 7]() | 0;
            h = t;
            s[h >> 2] = 1;
            s[h + 4 >> 2] = a;
            t = t + 4 | 0;
          }

          r[t >> 0] = a;
          r[t + 1 >> 0] = a >> 8;
          r[t + 2 >> 0] = a >> 16;
          r[t + 3 >> 0] = a >> 24;
          if (a | 0) r[o >> 0] = 1;
        }

        sd(s[n >> 2] | 0) | 0;
        p = l;
        return;
      }

      function lo(e, t, a, n) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        n = n | 0;
        var o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0,
            A = 0,
            w = 0,
            T = 0;
        T = p;
        p = p + 864 | 0;
        v = T + 849 | 0;
        _ = T + 824 | 0;
        g = T;
        A = T + 820 | 0;
        w = T + 816 | 0;
        b = T + 16 | 0;
        m = T + 848 | 0;
        y = T + 8 | 0;
        td(15764) | 0;
        s[y >> 2] = t;
        l = y + 4 | 0;
        s[l >> 2] = a;
        r[m >> 0] = n;
        ed(b | 0, 0, 800) | 0;
        Or(_, b, 100);
        t = _ + 4 | 0;
        h = s[t >> 2] | 0;

        e: do {
          if ((s[_ >> 2] | 0) == 1) {
            a = rd(h | 0, s[t + 4 >> 2] | 0, 8) | 0;
            n = S;
            t = h & 255;
          } else {
            if (h >>> 0 > 100) ru(h, 100);
            s[A >> 2] = v;

            if (n << 24 >> 24 != 2) {
              f = b + (h << 3) | 0;
              i = f;
              s[g >> 2] = A;
              c = _ + 4 | 0;
              u = _ + 4 | 0;
              d = _ + 4 | 0;
              o = _ + 4 | 0;
              n = b;
              t = 0;

              while (1) {
                a = n;

                if (((i - n | 0) / 8 | 0) >>> 0 <= 3) {
                  i = 21;
                  break;
                }

                ho(_, g, t, a);
                t = s[c >> 2] | 0;

                if ((s[_ >> 2] | 0) == 1) {
                  i = 29;
                  break;
                }

                ho(_, g, t, a + 8 | 0);
                t = s[u >> 2] | 0;

                if ((s[_ >> 2] | 0) == 1) {
                  i = 29;
                  break;
                }

                ho(_, g, t, a + 16 | 0);
                t = s[d >> 2] | 0;

                if ((s[_ >> 2] | 0) == 1) {
                  i = 29;
                  break;
                }

                ho(_, g, t, a + 24 | 0);
                t = s[o >> 2] | 0;

                if ((s[_ >> 2] | 0) == 1) {
                  i = 29;
                  break;
                } else n = a + 32 | 0;
              }

              t: do {
                if ((i | 0) == 21) {
                  n = _ + 4 | 0;
                  if ((a | 0) != (f | 0)) do {
                    ho(_, g, t, a);
                    a = a + 8 | 0;
                    t = s[n >> 2] | 0;

                    if ((s[_ >> 2] | 0) == 1) {
                      i = 29;
                      break t;
                    }
                  } while ((a | 0) != (f | 0));
                  t = h;
                }
              } while (0);

              a = h - t | 0;
              if (a >>> 0 < h >>> 0) {
                if (a) {
                  n = s[y >> 2] | 0;
                  o = s[l >> 2] | 0;
                  s[_ >> 2] = 3356;
                  s[_ + 4 >> 2] = 1;
                  s[_ + 8 >> 2] = 0;
                  s[_ + 16 >> 2] = 15892;
                  s[_ + 20 >> 2] = 0;
                  Fd[s[o + 24 >> 2] & 31](g, n, _);
                  n = g;
                  o = s[n >> 2] | 0;
                  t = o & 255;
                  if (t << 24 >> 24 == 3) o = a;else {
                    a = rd(o | 0, s[n + 4 >> 2] | 0, 8) | 0;
                    n = S;
                    break;
                  }
                } else o = 0;
              } else i = 31;
            } else i = 31;

            if ((i | 0) == 31) o = 0;
            a = s[y >> 2] | 0;
            n = s[l >> 2] | 0;
            s[_ >> 2] = 3364;
            s[_ + 4 >> 2] = 1;
            s[_ + 8 >> 2] = 0;
            s[_ + 16 >> 2] = 15892;
            s[_ + 20 >> 2] = 0;
            Fd[s[n + 24 >> 2] & 31](g, a, _);
            a = g;
            n = s[a >> 2] | 0;
            t = n & 255;

            if (t << 24 >> 24 != 3) {
              a = rd(n | 0, s[a + 4 >> 2] | 0, 8) | 0;
              n = S;
              break;
            }

            t = h - o | 0;
            if (t >>> 0 > 100) ru(t, 100);
            c = b + (t << 3) | 0;
            u = _ + 4 | 0;
            d = _ + 8 | 0;
            f = _ + 12 | 0;

            t: do {
              if (t | 0) {
                a = b;
                i = 0;
                o = b;

                while (1) {
                  s[w >> 2] = i;
                  s[A >> 2] = a;
                  t = s[a >> 2] | 0;
                  n = s[a + 4 >> 2] | 0;
                  s[_ >> 2] = y;
                  s[u >> 2] = w;
                  s[d >> 2] = A;
                  s[f >> 2] = m;
                  jr(g, t, n, _, v);
                  n = g;
                  a = s[n >> 2] | 0;
                  n = s[n + 4 >> 2] | 0;
                  t = a & 255;
                  if (t << 24 >> 24 != 3) break;
                  t = o + 8 | 0;
                  if ((t | 0) == (c | 0)) break t;else {
                    a = t;
                    i = i + 1 | 0;
                    o = t;
                  }
                }

                a = rd(a | 0, n | 0, 8) | 0;
                n = S;
                break e;
              }
            } while (0);

            A = 0;
            w = 0;
            g = 3;
            sd(15764) | 0;
            A = A & 16777215;
            A = od(w | 0, A | 0, 8) | 0;
            w = S;
            g = g & 255;
            g = A | g;
            A = e;
            s[A >> 2] = g;
            e = e + 4 | 0;
            s[e >> 2] = w;
            p = T;
            return;
          }
        } while (0);

        A = n;
        w = a;
        g = t;
        sd(15764) | 0;
        A = A & 16777215;
        A = od(w | 0, A | 0, 8) | 0;
        w = S;
        g = g & 255;
        g = A | g;
        A = e;
        s[A >> 2] = g;
        e = e + 4 | 0;
        s[e >> 2] = w;
        p = T;
        return;
      }

      function ho(e, t, a, n) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        n = n | 0;
        var o = 0,
            i = 0,
            c = 0;
        c = p;
        p = p + 16 | 0;
        o = c;
        i = c + 8 | 0;
        r[i >> 0] = 0;
        Gr(o, s[n >> 2] | 0, s[n + 4 >> 2] | 0, i, s[s[t >> 2] >> 2] | 0);

        switch (r[o >> 0] & 3) {
          case 0:
          case 1:
          case 3:
            {
              o = r[i >> 0] | 0;
              i = o & 255;
              o = o ^ 1;
              o = o & 255;
              a = o + a | 0;
              s[e >> 2] = i;
              i = e + 4 | 0;
              s[i >> 2] = a;
              p = c;
              return;
            }

          default:
            {}
        }

        o = s[o + 4 >> 2] | 0;
        t = o + 4 | 0;
        m = 0;
        ee(s[s[t >> 2] >> 2] | 0, s[o >> 2] | 0);
        n = m;
        m = 0;

        if (n & 1) {
          c = me() | 0;
          eo(s[o >> 2] | 0, s[t >> 2] | 0);
          to(o);
          Ee(c | 0);
        }

        t = s[t >> 2] | 0;
        n = s[t + 4 >> 2] | 0;
        if (n | 0) Ut(s[o >> 2] | 0, n, s[t + 8 >> 2] | 0);
        Ut(o, 12, 4);
        o = r[i >> 0] | 0;
        i = o & 255;
        o = o ^ 1;
        o = o & 255;
        a = o + a | 0;
        s[e >> 2] = i;
        i = e + 4 | 0;
        s[i >> 2] = a;
        p = c;
        return;
      }

      function po(e, t) {
        e = e | 0;
        t = t | 0;
        return Od[s[t + 12 >> 2] & 15](e) | 0;
      }

      function bo() {
        var e = 0,
            t = 0,
            a = 0,
            n = 0;
        n = p;
        p = p + 32 | 0;
        t = n + 12 | 0;
        e = n;

        switch (s[3933] | 0) {
          case 0:
            {
              Gs(e, 9087, 14);

              if (!(s[e >> 2] | 0)) {
                t = 1;
                e = 4;
              } else {
                s[t >> 2] = s[e >> 2];
                s[t + 4 >> 2] = s[e + 4 >> 2];
                s[t + 8 >> 2] = s[e + 8 >> 2];
                a = s[t >> 2] | 0;

                e: do {
                  switch (s[t + 8 >> 2] | 0) {
                    case 1:
                      {
                        if ((a | 0) == 9101) e = 4;else e = (r[a >> 0] | 0) == 48 ? 4 : 3;
                        break;
                      }

                    case 4:
                      {
                        if ((a | 0) != 9102 ? Vu(a, 9102, 4) | 0 : 0) {
                          e = 3;
                          break e;
                        }

                        e = 2;
                        break;
                      }

                    default:
                      e = 3;
                  }
                } while (0);

                t = s[t + 4 >> 2] | 0;
                if (t | 0) Ut(a, t, 1);
                t = e << 24 >> 24 == 4 ? 1 : e & 255;
              }

              s[3933] = t;
              a = e;
              p = n;
              return a | 0;
            }

          case 2:
            {
              a = 2;
              p = n;
              return a | 0;
            }

          case 3:
            {
              a = 3;
              p = n;
              return a | 0;
            }

          case 1:
            {
              a = 4;
              p = n;
              return a | 0;
            }

          default:
            pn(9047, 40, 3284);
        }

        return 0;
      }

      function mo(e, t, a, n, o, i, c, u) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        n = n | 0;
        o = o | 0;
        i = i | 0;
        c = c | 0;
        u = u | 0;
        var d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0,
            A = 0,
            w = 0,
            T = 0,
            x = 0,
            D = 0,
            C = 0,
            E = 0,
            B = 0,
            k = 0,
            R = 0,
            W = 0,
            I = 0;
        I = p;
        p = p + 160 | 0;
        h = I;
        R = I + 96 | 0;
        D = I + 120 | 0;
        x = I + 8 | 0;
        f = I + 152 | 0;
        l = I + 144 | 0;
        s[l >> 2] = n;
        s[f >> 2] = o;
        s[f + 4 >> 2] = i;
        w = u << 24 >> 24 == 3;

        do {
          if (w) {
            if (!o) {
              r[e >> 0] = 3;
              p = I;
              return;
            }

            s[R >> 2] = l;
            s[R + 4 >> 2] = 39;
            s[D >> 2] = 3472;
            s[D + 4 >> 2] = 2;
            s[D + 8 >> 2] = 3488;
            s[D + 12 >> 2] = 1;
            s[D + 16 >> 2] = R;
            s[D + 20 >> 2] = 1;
            Fd[s[a + 24 >> 2] & 31](x, t, D);
            i = x;
            n = s[i >> 2] | 0;
            i = s[i + 4 >> 2] | 0;
            if ((n & 255) << 24 >> 24 == 3) break;
            s[e >> 2] = n;
            s[e + 4 >> 2] = i;
            p = I;
            return;
          } else {
            sc(h, 3372);
            n = s[h >> 2] | 0;
            i = s[h + 4 >> 2] | 0;
            s[R >> 2] = l;
            s[R + 4 >> 2] = 39;
            s[R + 8 >> 2] = f;
            s[R + 12 >> 2] = 60;
            s[R + 16 >> 2] = n;
            s[R + 20 >> 2] = i;
            s[D >> 2] = 3376;
            s[D + 4 >> 2] = 3;
            s[D + 8 >> 2] = 3400;
            s[D + 12 >> 2] = 2;
            s[D + 16 >> 2] = R;
            s[D + 20 >> 2] = 3;
            Fd[s[a + 24 >> 2] & 31](x, t, D);
            i = x;
            n = s[i >> 2] | 0;
            i = s[i + 4 >> 2] | 0;
            if ((n & 255) << 24 >> 24 == 3) break;
            s[e >> 2] = n;
            s[e + 4 >> 2] = i;
            p = I;
            return;
          }
        } while (0);

        g = s[c >> 2] | 0;

        do {
          if (!g) {
            d = s[a + 20 >> 2] | 0;
            Ud[d & 15](R, t, 3524, 9);
            i = R;
            n = s[i >> 2] | 0;
            i = s[i + 4 >> 2] | 0;

            if ((n & 255) << 24 >> 24 != 3) {
              s[e >> 2] = n;
              s[e + 4 >> 2] = i;
              p = I;
              return;
            }
          } else {
            c = s[c + 4 >> 2] | 0;
            fi(R, g, c, 9410, 6);

            e: do {
              if ((s[R >> 2] | 0) == 1) {
                m = s[R + 4 >> 2] | 0;
                n = m + 6 | 0;

                if (!((n | 0) == 0 | (c | 0) == (n | 0))) {
                  if (c >>> 0 <= n >>> 0) Sc(g, c, n, c);
                  i = g + n | 0;
                  if ((r[i >> 0] | 0) > -65) b = i;else Sc(g, c, n, c);
                } else b = g + n | 0;

                h = g + n + (c - n) | 0;
                n = b;

                while (1) {
                  _ = (n | 0) == (h | 0);
                  i = _ ? n : n + 1 | 0;
                  if (_ | (n | 0) == 0) break;
                  l = r[n >> 0] | 0;

                  if (l << 24 >> 24 <= -1) {
                    o = l & 31;

                    if ((i | 0) == (h | 0)) {
                      n = 0;
                      i = h;
                    } else {
                      n = r[i >> 0] & 63;
                      i = i + 1 | 0;
                    }

                    u = n & 255;
                    n = u | o << 6;

                    if ((l & 255) > 223) {
                      if ((i | 0) == (h | 0)) {
                        n = 0;
                        f = h;
                      } else {
                        n = r[i >> 0] & 63;
                        f = i + 1 | 0;
                      }

                      u = n & 255 | u << 6;
                      n = u | o << 12;

                      if ((l & 255) > 239) {
                        if ((f | 0) == (h | 0)) {
                          i = h;
                          n = 0;
                        } else {
                          i = f + 1 | 0;
                          n = r[f >> 0] & 63;
                        }

                        n = u << 6 | o << 18 & 1835008 | n & 255;
                        if ((n | 0) == 1114112) break;
                      } else i = f;
                    }
                  } else n = l & 255;

                  if ((n + -48 | 0) >>> 0 > 9 & (n + -65 | 0) >>> 0 > 5) {
                    T = c;
                    break e;
                  } else n = i;
                }

                if (!((m | 0) == 0 | (m | 0) == (c | 0))) {
                  if (m >>> 0 >= c >>> 0) Sc(g, c, 0, m);
                  if ((r[g + m >> 0] | 0) <= -65) Sc(g, c, 0, m);else T = m;
                } else T = m;
              } else T = c;
            } while (0);

            do {
              if (T >>> 0 > 4) {
                if ((r[g + 3 >> 0] | 0) > -65) {
                  if ((g | 0) != 9417 ? Vu(9417, g, 3) | 0 : 0) {
                    C = 57;
                    break;
                  }

                  i = T + -1 | 0;

                  if (i) {
                    n = g + i | 0;

                    if ((r[n >> 0] | 0) <= -65) {
                      C = 57;
                      break;
                    }
                  } else n = g;

                  if ((n | 0) != 9416 ? (r[n >> 0] | 0) != 69 : 0) {
                    if ((T | 0) == 2) {
                      C = 58;
                      break;
                    }

                    if (T >>> 0 > 2) {
                      C = 57;
                      break;
                    } else {
                      C = 118;
                      break;
                    }
                  }

                  if (i >>> 0 < 3) Sc(g, T, 3, i);

                  if ((r[g + i >> 0] | 0) > -65) {
                    n = 3;
                    C = 64;
                  } else Sc(g, T, 3, i);
                } else C = 57;
              } else if ((T | 0) == 4) C = 57;else C = 118;
            } while (0);

            if ((C | 0) == 57) if ((r[g + 2 >> 0] | 0) > -65) C = 58;else C = 118;

            do {
              if ((C | 0) == 58) {
                if ((g | 0) != 9420 ? Vu(9420, g, 2) | 0 : 0) {
                  C = 118;
                  break;
                }

                i = T + -1 | 0;

                if (i) {
                  n = g + i | 0;

                  if ((r[n >> 0] | 0) <= -65) {
                    C = 118;
                    break;
                  }
                } else n = g;

                if ((n | 0) != 9416 ? (r[n >> 0] | 0) != 69 : 0) {
                  C = 118;
                  break;
                }

                if (i >>> 0 < 2) Sc(g, T, 2, i);
                if ((r[g + 2 >> 0] | 0) <= -65) Sc(g, T, 2, i);

                if ((r[g + i >> 0] | 0) > -65) {
                  n = 2;
                  i = T;
                  C = 64;
                } else Sc(g, T, 2, i);
              }
            } while (0);

            e: do {
              if ((C | 0) == 64) {
                n = g + n | 0;
                i = i + -3 | 0;
                _ = n + i | 0;
                f = n;

                while (1) {
                  if ((f | 0) == (_ | 0)) break;
                  l = f + 1 | 0;
                  h = r[f >> 0] | 0;

                  if (h << 24 >> 24 <= -1) {
                    c = h & 31;

                    if ((l | 0) == (_ | 0)) {
                      u = 0;
                      o = _;
                    } else {
                      u = r[l >> 0] & 63;
                      o = f + 2 | 0;
                    }

                    f = u & 255;
                    u = f | c << 6;

                    if ((h & 255) > 223) {
                      if ((o | 0) == (_ | 0)) {
                        l = o;
                        u = 0;
                        o = _;
                      } else {
                        v = o + 1 | 0;
                        l = v;
                        u = r[o >> 0] & 63;
                        o = v;
                      }

                      f = u & 255 | f << 6;
                      u = f | c << 12;

                      if ((h & 255) > 239) {
                        if ((o | 0) == (_ | 0)) u = 0;else {
                          l = o + 1 | 0;
                          u = r[o >> 0] & 63;
                        }
                        u = f << 6 | c << 18 & 1835008 | u & 255;

                        if ((u | 0) == 1114112) {
                          A = l;
                          C = 93;
                          break;
                        } else h = 0;
                      } else h = 0;
                    } else {
                      h = 0;
                      l = o;
                    }
                  } else {
                    u = h & 255;
                    h = 0;
                  }

                  while (1) {
                    f = u + -48 | 0;

                    if (f >>> 0 >= 10) {
                      if (u >>> 0 <= 127) {
                        f = l;
                        u = h;
                        break;
                      }

                      if (!(ji(u) | 0)) {
                        f = l;
                        u = h;
                        break;
                      }
                    }

                    m = (h * 10 | 0) + f | 0;

                    if ((l | 0) == (_ | 0)) {
                      f = _;
                      u = m;
                      break;
                    }

                    f = l + 1 | 0;
                    c = r[l >> 0] | 0;

                    if (c << 24 >> 24 > -1) {
                      u = c & 255;
                      h = m;
                      l = f;
                      continue;
                    }

                    b = c & 31;

                    if ((f | 0) == (_ | 0)) {
                      u = 0;
                      l = _;
                    } else {
                      u = r[f >> 0] & 63;
                      l = l + 2 | 0;
                    }

                    o = u & 255;

                    if ((c & 255) <= 223) {
                      u = o | b << 6;
                      h = m;
                      continue;
                    }

                    if ((l | 0) == (_ | 0)) {
                      f = l;
                      u = 0;
                      h = _;
                    } else {
                      h = l + 1 | 0;
                      f = h;
                      u = r[l >> 0] & 63;
                    }

                    l = u & 255 | o << 6;

                    if ((c & 255) <= 239) {
                      u = l | b << 12;
                      h = m;
                      l = f;
                      continue;
                    }

                    if ((h | 0) == (_ | 0)) u = 0;else {
                      f = h + 1 | 0;
                      u = r[h >> 0] & 63;
                    }
                    u = l << 6 | b << 18 & 1835008 | u & 255;

                    if ((u | 0) == 1114112) {
                      u = m;
                      break;
                    } else {
                      h = m;
                      l = f;
                    }
                  }

                  if (!u) {
                    A = f;
                    C = 93;
                    break;
                  }

                  v = u + -1 | 0;

                  t: do {
                    if (!v) u = 0;else {
                      y = v;
                      u = 0;

                      do {
                        if ((f | 0) == (_ | 0)) {
                          f = _;
                          break t;
                        }

                        l = f + 1 | 0;
                        b = r[f >> 0] | 0;

                        if (b << 24 >> 24 <= -1) {
                          m = b & 255;

                          if ((l | 0) == (_ | 0)) {
                            l = 0;
                            o = _;
                          } else {
                            l = r[l >> 0] & 63;
                            o = f + 2 | 0;
                          }

                          h = l & 255;

                          if ((b & 255) > 223) {
                            if ((o | 0) == (_ | 0)) {
                              f = o;
                              l = 0;
                              c = _;
                            } else {
                              c = o + 1 | 0;
                              f = c;
                              l = r[o >> 0] & 63;
                            }

                            o = l & 255 | h << 6;

                            if ((b & 255) > 239) {
                              if ((c | 0) == (_ | 0)) l = 0;else {
                                f = c + 1 | 0;
                                l = r[c >> 0] & 63;
                              }
                              if ((o << 6 | m << 18 & 1835008 | l & 255 | 0) == 1114112) break t;
                            }
                          } else f = o;
                        } else f = l;

                        y = y + -1 | 0;
                        u = u + 1 | 0;
                      } while ((y | 0) != 0);
                    }
                  } while (0);

                  if ((u | 0) != (v | 0)) {
                    C = 118;
                    break e;
                  }
                }

                if ((C | 0) == 93 ? (A | 0) != (_ | 0) : 0) {
                  u = A + 1 | 0;
                  o = r[A >> 0] | 0;

                  if (o << 24 >> 24 > -1) {
                    C = 118;
                    break;
                  }

                  if ((u | 0) == (_ | 0)) {
                    l = 0;
                    u = _;
                  } else {
                    l = r[u >> 0] & 63;
                    u = A + 2 | 0;
                  }

                  if ((o & 255) <= 223) {
                    C = 118;
                    break;
                  }

                  if ((u | 0) == (_ | 0)) {
                    f = 0;
                    u = _;
                  } else {
                    f = r[u >> 0] & 63;
                    u = u + 1 | 0;
                  }

                  if ((o & 255) <= 239) {
                    C = 118;
                    break;
                  }

                  if ((u | 0) == (_ | 0)) u = 0;else u = r[u >> 0] & 63;

                  if (((f & 255 | (l & 255) << 6) << 6 | (o & 255) << 18 & 1835008 | u & 255 | 0) != 1114112) {
                    C = 118;
                    break;
                  }
                }

                if (w) {
                  Wc(x, n, i, 9422, 3);
                  o = x + 64 | 0;
                  s[o >> 2] = 0;
                  h = x + 68 | 0;
                  s[h >> 2] = i;
                  u = x + 72 | 0;
                  r[u >> 0] = 1;
                  c = x + 73 | 0;
                  r[c >> 0] = 0;
                  f = x + 80 | 0;
                  s[f >> 2] = 1;
                  yo(D, x);
                  l = s[f >> 2] | 0;

                  t: do {
                    switch (l | 0) {
                      case 0:
                        {
                          s[R >> 2] = 0;
                          break;
                        }

                      case 1:
                        {
                          s[f >> 2] = 0;

                          do {
                            if (!(r[c >> 0] | 0)) {
                              if (!(r[u >> 0] | 0)) {
                                f = s[h >> 2] | 0;
                                u = s[o >> 2] | 0;
                                if ((f | 0) == (u | 0)) break;
                              } else {
                                u = s[o >> 2] | 0;
                                f = s[h >> 2] | 0;
                              }

                              r[c >> 0] = 1;
                              s[R >> 2] = (s[x + 48 >> 2] | 0) + u;
                              s[R + 4 >> 2] = f - u;
                              break t;
                            }
                          } while (0);

                          s[R >> 2] = 0;
                          break;
                        }

                      default:
                        {
                          s[f >> 2] = l + -1;
                          yo(R, x);
                        }
                    }
                  } while (0);

                  u = s[D >> 2] | 0;
                  m = R;
                  y = s[m >> 2] | 0;
                  m = s[m + 4 >> 2] | 0;

                  t: do {
                    if ((u | 0) != 0 ? (s[D + 4 >> 2] | 0) == 16 : 0) {
                      b = u + 16 | 0;

                      while (1) {
                        D = (u | 0) == (b | 0);
                        f = D ? u : u + 1 | 0;
                        if (D | (u | 0) == 0) break;
                        h = r[u >> 0] | 0;

                        if (h << 24 >> 24 <= -1) {
                          c = h & 31;

                          if ((f | 0) == (b | 0)) {
                            l = 0;
                            u = b;
                          } else {
                            l = r[f >> 0] & 63;
                            u = f + 1 | 0;
                          }

                          l = l & 255;
                          f = l | c << 6;

                          if ((h & 255) > 223) {
                            if ((u | 0) == (b | 0)) {
                              f = 0;
                              o = b;
                            } else {
                              f = r[u >> 0] & 63;
                              o = u + 1 | 0;
                            }

                            l = f & 255 | l << 6;
                            f = l | c << 12;

                            if ((h & 255) > 239) {
                              if ((o | 0) == (b | 0)) {
                                u = b;
                                f = 0;
                              } else {
                                u = o + 1 | 0;
                                f = r[o >> 0] & 63;
                              }

                              f = l << 6 | c << 18 & 1835008 | f & 255;
                              if ((f | 0) == 1114112) break;
                            } else u = o;
                          }
                        } else {
                          u = f;
                          f = h & 255;
                        }

                        if ((f + -48 | 0) >>> 0 >= 10) {
                          if ((f + -97 | 0) >>> 0 >= 26) {
                            if ((f + -65 | 0) >>> 0 < 26) l = -55;else break t;
                          } else l = -87;
                        } else l = -48;
                        if ((l + f | 0) >>> 0 > 15) break t;
                      }

                      n = (y | 0) == 0;
                      i = n ? 0 : m;
                      n = n ? 16465 : y;
                    }
                  } while (0);
                }

                if (!i) C = 452;else {
                  A = R + 4 | 0;
                  w = a + 20 | 0;
                  u = 1;
                  b = n;

                  t: while (1) {
                    if (!u ? (Ud[s[w >> 2] & 15](R, t, 3536, 2), B = R, D = s[B >> 2] | 0, E = D & 255, B = rd(D | 0, s[B + 4 >> 2] | 0, 8) | 0, E << 24 >> 24 != 3) : 0) {
                      W = S;
                      d = B;
                      k = E;
                      break e;
                    }

                    y = b;
                    m = b + 1 | 0;
                    c = b + i | 0;
                    n = i;

                    while (1) {
                      o = r[y >> 0] | 0;

                      if (o << 24 >> 24 <= -1) {
                        h = o & 31;

                        if ((m | 0) == (c | 0)) {
                          u = 0;
                          l = m;
                        } else {
                          u = r[m >> 0] & 63;
                          l = m + 1 | 0;
                        }

                        f = u & 255;
                        u = f | h << 6;

                        if ((o & 255) > 223) {
                          if ((l | 0) == (c | 0)) {
                            u = 0;
                            l = c;
                          } else {
                            u = r[l >> 0] & 63;
                            l = l + 1 | 0;
                          }

                          f = u & 255 | f << 6;
                          u = f | h << 12;

                          if ((o & 255) > 239) {
                            if ((l | 0) == (c | 0)) u = 0;else u = r[l >> 0] & 63;
                            u = f << 6 | h << 18 & 1835008 | u & 255;

                            if ((u | 0) == 1114112) {
                              C = 166;
                              break t;
                            }
                          }
                        }
                      } else u = o & 255;

                      if ((u + -48 | 0) >>> 0 >= 10) {
                        if (u >>> 0 <= 127) break;
                        if (!(ji(u) | 0)) break;
                      }

                      switch (n | 0) {
                        case 0:
                          {
                            n = 0;
                            C = 188;
                            break t;
                          }

                        case 1:
                          break;

                        default:
                          if ((r[m >> 0] | 0) <= -65) {
                            C = 188;
                            break t;
                          }

                      }

                      n = n + -1 | 0;
                      c = m + n | 0;

                      if (!n) {
                        C = 166;
                        break t;
                      } else {
                        y = m;
                        m = m + 1 | 0;
                      }
                    }

                    u = i - n | 0;

                    if (u | 0) {
                      if (i >>> 0 <= u >>> 0) {
                        C = 173;
                        break;
                      }

                      if ((r[b + u >> 0] | 0) <= -65) {
                        C = 173;
                        break;
                      }
                    }

                    $c(R, b, u);

                    if ((r[R >> 0] | 0) == 1) {
                      C = 175;
                      break;
                    }

                    f = s[A >> 2] | 0;

                    if (!((f | 0) == 0 | (n | 0) == (f | 0))) {
                      if (n >>> 0 <= f >>> 0) {
                        C = 180;
                        break;
                      }

                      i = y + f | 0;
                      if ((r[i >> 0] | 0) > -65) g = i;else {
                        C = 180;
                        break;
                      }
                    } else g = y + f | 0;

                    i = n - f | 0;
                    if ((f | 0) != 2) {
                      if (f >>> 0 > 2) {
                        if ((r[y + 2 >> 0] | 0) > -65) C = 184;else C = 193;
                      } else {
                        u = y;
                        n = f;
                        C = 194;
                      }
                    } else C = 184;

                    do {
                      if ((C | 0) == 184) {
                        if ((y | 0) != 9425 ? Vu(9425, y, 2) | 0 : 0) {
                          C = 193;
                          break;
                        }

                        if ((r[m >> 0] | 0) <= -65) {
                          C = 191;
                          break t;
                        }

                        u = m;
                        n = f + -1 | 0;
                        C = 194;
                      }
                    } while (0);

                    if ((C | 0) == 193) {
                      n = f;
                      C = 195;
                    } else if ((C | 0) == 194 ? (C = 0, n | 0) : 0) {
                      y = u;
                      C = 195;
                    }

                    a: do {
                      if ((C | 0) == 195) {
                        r: while (1) {
                          u = (n | 0) == 1;
                          if (!u ? (r[y + 1 >> 0] | 0) <= -65 : 0) C = 232;else C = 197;

                          n: do {
                            if ((C | 0) == 197) {
                              C = 0;

                              do {
                                if ((y | 0) != 3540) {
                                  if ((r[y >> 0] | 0) == 46) break;

                                  if (!u ? (r[y + 1 >> 0] | 0) <= -65 : 0) {
                                    C = 232;
                                    break n;
                                  }

                                  if ((y | 0) != 9427 ? (r[y >> 0] | 0) != 36 : 0) {
                                    C = 232;
                                    break n;
                                  }

                                  l = (n | 0) == 4;

                                  do {
                                    if (!l) {
                                      if (n >>> 0 > 4) {
                                        if ((r[y + 4 >> 0] | 0) > -65) {
                                          C = 230;
                                          break;
                                        } else {
                                          C = 303;
                                          break;
                                        }
                                      } else if ((n | 0) == 3) {
                                        u = 1;
                                        C = 304;
                                        break;
                                      } else break r;
                                    } else C = 230;
                                  } while (0);

                                  s: do {
                                    if ((C | 0) == 230) {
                                      C = 0;

                                      do {
                                        if ((y | 0) != 9428) {
                                          if (!(Vu(9428, y, 4) | 0)) break;

                                          if (!l ? (r[y + 4 >> 0] | 0) <= -65 : 0) {
                                            C = 303;
                                            break s;
                                          }

                                          do {
                                            if ((y | 0) != 9432) {
                                              if (!(Vu(9432, y, 4) | 0)) break;

                                              if (!l ? (r[y + 4 >> 0] | 0) <= -65 : 0) {
                                                C = 303;
                                                break s;
                                              }

                                              do {
                                                if ((y | 0) != 9436) {
                                                  if (!(Vu(9436, y, 4) | 0)) break;

                                                  if (!l ? (r[y + 4 >> 0] | 0) <= -65 : 0) {
                                                    C = 303;
                                                    break s;
                                                  }

                                                  do {
                                                    if ((y | 0) != 9440) {
                                                      if (!(Vu(9440, y, 4) | 0)) break;

                                                      if (!l ? (r[y + 4 >> 0] | 0) <= -65 : 0) {
                                                        C = 303;
                                                        break s;
                                                      }

                                                      do {
                                                        if ((y | 0) != 9444) {
                                                          if (!(Vu(9444, y, 4) | 0)) break;

                                                          if (!l ? (r[y + 4 >> 0] | 0) <= -65 : 0) {
                                                            C = 303;
                                                            break s;
                                                          }

                                                          do {
                                                            if ((y | 0) != 9448) {
                                                              if (!(Vu(9448, y, 4) | 0)) break;

                                                              if (!l ? (r[y + 4 >> 0] | 0) <= -65 : 0) {
                                                                C = 303;
                                                                break s;
                                                              }

                                                              if ((y | 0) != 9452 ? Vu(9452, y, 4) | 0 : 0) {
                                                                C = 303;
                                                                break s;
                                                              }

                                                              Ud[s[w >> 2] & 15](R, t, 3568, 1);
                                                              f = R;
                                                              D = s[f >> 2] | 0;
                                                              u = D & 255;
                                                              f = rd(D | 0, s[f + 4 >> 2] | 0, 8) | 0;

                                                              if (u << 24 >> 24 != 3) {
                                                                W = S;
                                                                d = f;
                                                                k = u;
                                                                break e;
                                                              }

                                                              u = y + 4 | 0;

                                                              if (!l ? (r[u >> 0] | 0) <= -65 : 0) {
                                                                C = 308;
                                                                break t;
                                                              }

                                                              n = n + -4 | 0;
                                                              break n;
                                                            }
                                                          } while (0);

                                                          Ud[s[w >> 2] & 15](R, t, 3564, 1);
                                                          f = R;
                                                          D = s[f >> 2] | 0;
                                                          u = D & 255;
                                                          f = rd(D | 0, s[f + 4 >> 2] | 0, 8) | 0;

                                                          if (u << 24 >> 24 != 3) {
                                                            W = S;
                                                            d = f;
                                                            k = u;
                                                            break e;
                                                          }

                                                          u = y + 4 | 0;

                                                          if (!l ? (r[u >> 0] | 0) <= -65 : 0) {
                                                            C = 299;
                                                            break t;
                                                          }

                                                          n = n + -4 | 0;
                                                          break n;
                                                        }
                                                      } while (0);

                                                      Ud[s[w >> 2] & 15](R, t, 3560, 1);
                                                      f = R;
                                                      D = s[f >> 2] | 0;
                                                      u = D & 255;
                                                      f = rd(D | 0, s[f + 4 >> 2] | 0, 8) | 0;

                                                      if (u << 24 >> 24 != 3) {
                                                        W = S;
                                                        d = f;
                                                        k = u;
                                                        break e;
                                                      }

                                                      u = y + 4 | 0;

                                                      if (!l ? (r[u >> 0] | 0) <= -65 : 0) {
                                                        C = 290;
                                                        break t;
                                                      }

                                                      n = n + -4 | 0;
                                                      break n;
                                                    }
                                                  } while (0);

                                                  Ud[s[w >> 2] & 15](R, t, 3556, 1);
                                                  f = R;
                                                  D = s[f >> 2] | 0;
                                                  u = D & 255;
                                                  f = rd(D | 0, s[f + 4 >> 2] | 0, 8) | 0;

                                                  if (u << 24 >> 24 != 3) {
                                                    W = S;
                                                    d = f;
                                                    k = u;
                                                    break e;
                                                  }

                                                  u = y + 4 | 0;

                                                  if (!l ? (r[u >> 0] | 0) <= -65 : 0) {
                                                    C = 281;
                                                    break t;
                                                  }

                                                  n = n + -4 | 0;
                                                  break n;
                                                }
                                              } while (0);

                                              Ud[s[w >> 2] & 15](R, t, 3552, 1);
                                              f = R;
                                              D = s[f >> 2] | 0;
                                              u = D & 255;
                                              f = rd(D | 0, s[f + 4 >> 2] | 0, 8) | 0;

                                              if (u << 24 >> 24 != 3) {
                                                W = S;
                                                d = f;
                                                k = u;
                                                break e;
                                              }

                                              u = y + 4 | 0;

                                              if (!l ? (r[u >> 0] | 0) <= -65 : 0) {
                                                C = 272;
                                                break t;
                                              }

                                              n = n + -4 | 0;
                                              break n;
                                            }
                                          } while (0);

                                          Ud[s[w >> 2] & 15](R, t, 3548, 1);
                                          f = R;
                                          D = s[f >> 2] | 0;
                                          u = D & 255;
                                          f = rd(D | 0, s[f + 4 >> 2] | 0, 8) | 0;

                                          if (u << 24 >> 24 != 3) {
                                            W = S;
                                            d = f;
                                            k = u;
                                            break e;
                                          }

                                          u = y + 4 | 0;

                                          if (!l ? (r[u >> 0] | 0) <= -65 : 0) {
                                            C = 263;
                                            break t;
                                          }

                                          n = n + -4 | 0;
                                          break n;
                                        }
                                      } while (0);

                                      Ud[s[w >> 2] & 15](R, t, 3544, 1);
                                      f = R;
                                      D = s[f >> 2] | 0;
                                      u = D & 255;
                                      f = rd(D | 0, s[f + 4 >> 2] | 0, 8) | 0;

                                      if (u << 24 >> 24 != 3) {
                                        W = S;
                                        d = f;
                                        k = u;
                                        break e;
                                      }

                                      u = y + 4 | 0;

                                      if (!l ? (r[u >> 0] | 0) <= -65 : 0) {
                                        C = 254;
                                        break t;
                                      }

                                      n = n + -4 | 0;
                                      break n;
                                    }
                                  } while (0);

                                  if ((C | 0) == 303 ? (C = 0, (r[y + 3 >> 0] | 0) > -65) : 0) {
                                    u = 0;
                                    C = 304;
                                  }

                                  do {
                                    if ((C | 0) == 304) {
                                      C = 0;
                                      if ((y | 0) != 9456 ? Vu(9456, y, 3) | 0 : 0) break;
                                      Ud[s[w >> 2] & 15](R, t, 3572, 1);
                                      l = R;
                                      D = s[l >> 2] | 0;
                                      f = D & 255;
                                      l = rd(D | 0, s[l + 4 >> 2] | 0, 8) | 0;

                                      if (f << 24 >> 24 != 3) {
                                        W = S;
                                        d = l;
                                        k = f;
                                        break e;
                                      }

                                      if (!u) {
                                        if (n >>> 0 <= 3) {
                                          C = 320;
                                          break t;
                                        }

                                        u = y + 3 | 0;

                                        if ((r[u >> 0] | 0) <= -65) {
                                          C = 320;
                                          break t;
                                        }
                                      } else u = y + 3 | 0;

                                      n = n + -3 | 0;
                                      break n;
                                    }
                                  } while (0);

                                  if ((n | 0) != 5) {
                                    if (n >>> 0 <= 5) break r;
                                    if ((r[y + 5 >> 0] | 0) > -65) u = 0;else break r;
                                  } else u = 1;

                                  do {
                                    if ((y | 0) != 9459) {
                                      if (!(Vu(9459, y, 5) | 0)) break;

                                      if (!u) {
                                        if (n >>> 0 <= 5) break r;
                                        if ((r[y + 5 >> 0] | 0) > -65) u = 0;else break r;
                                      } else u = 1;

                                      do {
                                        if ((y | 0) != 9464) {
                                          if (!(Vu(9464, y, 5) | 0)) break;

                                          if (!u) {
                                            if (n >>> 0 <= 5) break r;
                                            if ((r[y + 5 >> 0] | 0) > -65) u = 0;else break r;
                                          } else u = 1;

                                          do {
                                            if ((y | 0) != 9469) {
                                              if (!(Vu(9469, y, 5) | 0)) break;

                                              if (!u) {
                                                if (n >>> 0 <= 5) break r;
                                                if ((r[y + 5 >> 0] | 0) > -65) u = 0;else break r;
                                              } else u = 1;

                                              do {
                                                if ((y | 0) != 9474) {
                                                  if (!(Vu(9474, y, 5) | 0)) break;

                                                  if (!u) {
                                                    if (n >>> 0 <= 5) break r;
                                                    if ((r[y + 5 >> 0] | 0) > -65) l = 0;else break r;
                                                  } else l = 1;

                                                  do {
                                                    if ((y | 0) != 9479) {
                                                      if (!(Vu(9479, y, 5) | 0)) break;

                                                      if (!l) {
                                                        if (n >>> 0 <= 5) break r;
                                                        if ((r[y + 5 >> 0] | 0) > -65) l = 0;else break r;
                                                      } else l = 1;

                                                      do {
                                                        if ((y | 0) != 9484) {
                                                          if (!(Vu(9484, y, 5) | 0)) break;

                                                          if (!l) {
                                                            if (n >>> 0 <= 5) break r;
                                                            if ((r[y + 5 >> 0] | 0) > -65) l = 0;else break r;
                                                          } else l = 1;

                                                          do {
                                                            if ((y | 0) != 9489) {
                                                              if (!(Vu(9489, y, 5) | 0)) break;

                                                              if (!l) {
                                                                if (n >>> 0 <= 5) break r;
                                                                if ((r[y + 5 >> 0] | 0) > -65) l = 0;else break r;
                                                              } else l = 1;

                                                              do {
                                                                if ((y | 0) != 9494) {
                                                                  if (!(Vu(9494, y, 5) | 0)) break;

                                                                  if (!l) {
                                                                    if (n >>> 0 <= 5) break r;
                                                                    if ((r[y + 5 >> 0] | 0) > -65) l = 0;else break r;
                                                                  } else l = 1;

                                                                  do {
                                                                    if ((y | 0) != 9499) {
                                                                      if (!(Vu(9499, y, 5) | 0)) break;

                                                                      if (!l) {
                                                                        if (n >>> 0 <= 5) break r;
                                                                        if ((r[y + 5 >> 0] | 0) > -65) l = 0;else break r;
                                                                      } else l = 1;

                                                                      if ((y | 0) != 9504 ? Vu(9504, y, 5) | 0 : 0) break r;
                                                                      Ud[s[w >> 2] & 15](R, t, 3612, 1);
                                                                      f = R;
                                                                      D = s[f >> 2] | 0;
                                                                      u = D & 255;
                                                                      f = rd(D | 0, s[f + 4 >> 2] | 0, 8) | 0;

                                                                      if (u << 24 >> 24 != 3) {
                                                                        W = S;
                                                                        d = f;
                                                                        k = u;
                                                                        break e;
                                                                      }

                                                                      if (!l) {
                                                                        if (n >>> 0 <= 5) {
                                                                          C = 436;
                                                                          break t;
                                                                        }

                                                                        u = y + 5 | 0;

                                                                        if ((r[u >> 0] | 0) <= -65) {
                                                                          C = 436;
                                                                          break t;
                                                                        }
                                                                      } else u = y + 5 | 0;

                                                                      n = n + -5 | 0;
                                                                      break n;
                                                                    }
                                                                  } while (0);

                                                                  Ud[s[w >> 2] & 15](R, t, 3608, 1);
                                                                  f = R;
                                                                  D = s[f >> 2] | 0;
                                                                  u = D & 255;
                                                                  f = rd(D | 0, s[f + 4 >> 2] | 0, 8) | 0;

                                                                  if (u << 24 >> 24 != 3) {
                                                                    W = S;
                                                                    d = f;
                                                                    k = u;
                                                                    break e;
                                                                  }

                                                                  if (!l) {
                                                                    if (n >>> 0 <= 5) {
                                                                      C = 428;
                                                                      break t;
                                                                    }

                                                                    u = y + 5 | 0;

                                                                    if ((r[u >> 0] | 0) <= -65) {
                                                                      C = 428;
                                                                      break t;
                                                                    }
                                                                  } else u = y + 5 | 0;

                                                                  n = n + -5 | 0;
                                                                  break n;
                                                                }
                                                              } while (0);

                                                              Ud[s[w >> 2] & 15](R, t, 3604, 1);
                                                              f = R;
                                                              D = s[f >> 2] | 0;
                                                              u = D & 255;
                                                              f = rd(D | 0, s[f + 4 >> 2] | 0, 8) | 0;

                                                              if (u << 24 >> 24 != 3) {
                                                                W = S;
                                                                d = f;
                                                                k = u;
                                                                break e;
                                                              }

                                                              if (!l) {
                                                                if (n >>> 0 <= 5) {
                                                                  C = 416;
                                                                  break t;
                                                                }

                                                                u = y + 5 | 0;

                                                                if ((r[u >> 0] | 0) <= -65) {
                                                                  C = 416;
                                                                  break t;
                                                                }
                                                              } else u = y + 5 | 0;

                                                              n = n + -5 | 0;
                                                              break n;
                                                            }
                                                          } while (0);

                                                          Ud[s[w >> 2] & 15](R, t, 3600, 1);
                                                          f = R;
                                                          D = s[f >> 2] | 0;
                                                          u = D & 255;
                                                          f = rd(D | 0, s[f + 4 >> 2] | 0, 8) | 0;

                                                          if (u << 24 >> 24 != 3) {
                                                            W = S;
                                                            d = f;
                                                            k = u;
                                                            break e;
                                                          }

                                                          if (!l) {
                                                            if (n >>> 0 <= 5) {
                                                              C = 404;
                                                              break t;
                                                            }

                                                            u = y + 5 | 0;

                                                            if ((r[u >> 0] | 0) <= -65) {
                                                              C = 404;
                                                              break t;
                                                            }
                                                          } else u = y + 5 | 0;

                                                          n = n + -5 | 0;
                                                          break n;
                                                        }
                                                      } while (0);

                                                      Ud[s[w >> 2] & 15](R, t, 3596, 1);
                                                      f = R;
                                                      D = s[f >> 2] | 0;
                                                      u = D & 255;
                                                      f = rd(D | 0, s[f + 4 >> 2] | 0, 8) | 0;

                                                      if (u << 24 >> 24 != 3) {
                                                        W = S;
                                                        d = f;
                                                        k = u;
                                                        break e;
                                                      }

                                                      if (!l) {
                                                        if (n >>> 0 <= 5) {
                                                          C = 392;
                                                          break t;
                                                        }

                                                        u = y + 5 | 0;

                                                        if ((r[u >> 0] | 0) <= -65) {
                                                          C = 392;
                                                          break t;
                                                        }
                                                      } else u = y + 5 | 0;

                                                      n = n + -5 | 0;
                                                      break n;
                                                    }
                                                  } while (0);

                                                  Ud[s[w >> 2] & 15](R, t, 3592, 1);
                                                  f = R;
                                                  D = s[f >> 2] | 0;
                                                  u = D & 255;
                                                  f = rd(D | 0, s[f + 4 >> 2] | 0, 8) | 0;

                                                  if (u << 24 >> 24 != 3) {
                                                    W = S;
                                                    d = f;
                                                    k = u;
                                                    break e;
                                                  }

                                                  if (!l) {
                                                    if (n >>> 0 <= 5) {
                                                      C = 380;
                                                      break t;
                                                    }

                                                    u = y + 5 | 0;

                                                    if ((r[u >> 0] | 0) <= -65) {
                                                      C = 380;
                                                      break t;
                                                    }
                                                  } else u = y + 5 | 0;

                                                  n = n + -5 | 0;
                                                  break n;
                                                }
                                              } while (0);

                                              Ud[s[w >> 2] & 15](R, t, 3588, 1);
                                              l = R;
                                              D = s[l >> 2] | 0;
                                              f = D & 255;
                                              l = rd(D | 0, s[l + 4 >> 2] | 0, 8) | 0;

                                              if (f << 24 >> 24 != 3) {
                                                W = S;
                                                d = l;
                                                k = f;
                                                break e;
                                              }

                                              if (!u) {
                                                if (n >>> 0 <= 5) {
                                                  C = 368;
                                                  break t;
                                                }

                                                u = y + 5 | 0;

                                                if ((r[u >> 0] | 0) <= -65) {
                                                  C = 368;
                                                  break t;
                                                }
                                              } else u = y + 5 | 0;

                                              n = n + -5 | 0;
                                              break n;
                                            }
                                          } while (0);

                                          Ud[s[w >> 2] & 15](R, t, 3584, 1);
                                          l = R;
                                          D = s[l >> 2] | 0;
                                          f = D & 255;
                                          l = rd(D | 0, s[l + 4 >> 2] | 0, 8) | 0;

                                          if (f << 24 >> 24 != 3) {
                                            W = S;
                                            d = l;
                                            k = f;
                                            break e;
                                          }

                                          if (!u) {
                                            if (n >>> 0 <= 5) {
                                              C = 356;
                                              break t;
                                            }

                                            u = y + 5 | 0;

                                            if ((r[u >> 0] | 0) <= -65) {
                                              C = 356;
                                              break t;
                                            }
                                          } else u = y + 5 | 0;

                                          n = n + -5 | 0;
                                          break n;
                                        }
                                      } while (0);

                                      Ud[s[w >> 2] & 15](R, t, 3580, 1);
                                      l = R;
                                      D = s[l >> 2] | 0;
                                      f = D & 255;
                                      l = rd(D | 0, s[l + 4 >> 2] | 0, 8) | 0;

                                      if (f << 24 >> 24 != 3) {
                                        W = S;
                                        d = l;
                                        k = f;
                                        break e;
                                      }

                                      if (!u) {
                                        if (n >>> 0 <= 5) {
                                          C = 344;
                                          break t;
                                        }

                                        u = y + 5 | 0;

                                        if ((r[u >> 0] | 0) <= -65) {
                                          C = 344;
                                          break t;
                                        }
                                      } else u = y + 5 | 0;

                                      n = n + -5 | 0;
                                      break n;
                                    }
                                  } while (0);

                                  Ud[s[w >> 2] & 15](R, t, 3576, 1);
                                  l = R;
                                  D = s[l >> 2] | 0;
                                  f = D & 255;
                                  l = rd(D | 0, s[l + 4 >> 2] | 0, 8) | 0;

                                  if (f << 24 >> 24 != 3) {
                                    W = S;
                                    d = l;
                                    k = f;
                                    break e;
                                  }

                                  if (!u) {
                                    if (n >>> 0 <= 5) {
                                      C = 332;
                                      break t;
                                    }

                                    u = y + 5 | 0;

                                    if ((r[u >> 0] | 0) <= -65) {
                                      C = 332;
                                      break t;
                                    }
                                  } else u = y + 5 | 0;

                                  n = n + -5 | 0;
                                  break n;
                                }
                              } while (0);

                              f = y + 1 | 0;

                              do {
                                if (!u) {
                                  o = r[f >> 0] | 0;

                                  if (o << 24 >> 24 <= -65) {
                                    C = 201;
                                    break t;
                                  }

                                  D = n + -1 | 0;
                                  h = f + D | 0;
                                  D = (D | 0) == 0;
                                  u = D ? f : y + 2 | 0;

                                  if (D) {
                                    C = 219;
                                    break;
                                  }

                                  do {
                                    if (o << 24 >> 24 > -1) u = o & 255;else {
                                      c = o & 31;

                                      if ((u | 0) == (h | 0)) {
                                        f = 0;
                                        l = h;
                                      } else {
                                        f = r[u >> 0] & 63;
                                        l = u + 1 | 0;
                                      }

                                      u = f & 255;

                                      if ((o & 255) <= 223) {
                                        u = u | c << 6;
                                        break;
                                      }

                                      if ((l | 0) == (h | 0)) {
                                        f = 0;
                                        l = h;
                                      } else {
                                        f = r[l >> 0] & 63;
                                        l = l + 1 | 0;
                                      }

                                      f = f & 255 | u << 6;

                                      if ((o & 255) <= 239) {
                                        u = f | c << 12;
                                        break;
                                      }

                                      if ((l | 0) == (h | 0)) u = 0;else u = r[l >> 0] & 63;
                                      u = f << 6 | c << 18 & 1835008 | u & 255;
                                    }
                                  } while (0);

                                  if ((u | 0) != 46) {
                                    C = 219;
                                    break;
                                  }

                                  Ud[s[w >> 2] & 15](R, t, 3536, 2);
                                  f = R;
                                  D = s[f >> 2] | 0;
                                  u = D & 255;
                                  f = rd(D | 0, s[f + 4 >> 2] | 0, 8) | 0;
                                  if (u << 24 >> 24 == 3) f = 2;else {
                                    W = S;
                                    d = f;
                                    k = u;
                                    break e;
                                  }
                                } else C = 219;
                              } while (0);

                              if ((C | 0) == 219) {
                                C = 0;
                                Ud[s[w >> 2] & 15](R, t, 3540, 1);
                                f = R;
                                D = s[f >> 2] | 0;
                                u = D & 255;
                                f = rd(D | 0, s[f + 4 >> 2] | 0, 8) | 0;
                                if (u << 24 >> 24 == 3) f = 1;else {
                                  W = S;
                                  d = f;
                                  k = u;
                                  break e;
                                }
                              }

                              if ((n | 0) != (f | 0)) {
                                if (n >>> 0 <= f >>> 0) {
                                  C = 225;
                                  break t;
                                }

                                u = y + f | 0;

                                if ((r[u >> 0] | 0) <= -65) {
                                  C = 225;
                                  break t;
                                }
                              } else u = y + n | 0;

                              n = n - f | 0;
                            }
                          } while (0);

                          if ((C | 0) == 232) {
                            C = 0;
                            m = y + n | 0;
                            v = y;
                            _ = 0;

                            n: while (1) {
                              u = v;
                              D = (u | 0) == (m | 0);
                              f = D ? v : u + 1 | 0;

                              if ((v | 0) == 0 | D) {
                                o = n;
                                break;
                              }

                              c = r[u >> 0] | 0;

                              do {
                                if (c << 24 >> 24 <= -1) {
                                  b = c & 31;
                                  u = f;

                                  if ((u | 0) == (m | 0)) {
                                    u = 0;
                                    l = m;
                                  } else {
                                    l = u + 1 | 0;
                                    f = l;
                                    u = r[u >> 0] & 63;
                                  }

                                  h = u & 255;

                                  if ((c & 255) <= 223) {
                                    o = f;
                                    u = h | b << 6;
                                    break;
                                  }

                                  if ((l | 0) == (m | 0)) {
                                    u = 0;
                                    o = m;
                                  } else {
                                    o = l + 1 | 0;
                                    f = o;
                                    u = r[l >> 0] & 63;
                                  }

                                  l = u & 255 | h << 6;

                                  if ((c & 255) <= 239) {
                                    o = f;
                                    u = l | b << 12;
                                    break;
                                  }

                                  if ((o | 0) == (m | 0)) u = 0;else {
                                    f = o + 1 | 0;
                                    u = r[o >> 0] & 63;
                                  }
                                  u = l << 6 | b << 18 & 1835008 | u & 255;

                                  if ((u | 0) == 1114112) {
                                    o = n;
                                    break n;
                                  } else o = f;
                                } else {
                                  o = f;
                                  u = c & 255;
                                }
                              } while (0);

                              f = _ - v + o | 0;

                              switch (u & 2097151 | 0) {
                                case 46:
                                case 36:
                                  {
                                    C = 246;
                                    break n;
                                  }

                                default:
                                  {
                                    v = o;
                                    _ = f;
                                  }
                              }
                            }

                            if ((C | 0) == 246) {
                              C = 0;
                              o = (u | 0) == 1114112 ? n : _;
                            }

                            u = (o | 0) == 0 | (n | 0) == (o | 0);

                            if (!u) {
                              if (n >>> 0 <= o >>> 0) {
                                C = 442;
                                break t;
                              }

                              if ((r[y + o >> 0] | 0) <= -65) {
                                C = 442;
                                break t;
                              }
                            }

                            Ud[s[w >> 2] & 15](R, t, y, o);
                            l = R;
                            D = s[l >> 2] | 0;
                            f = D & 255;
                            l = rd(D | 0, s[l + 4 >> 2] | 0, 8) | 0;

                            if (f << 24 >> 24 != 3) {
                              W = S;
                              d = l;
                              k = f;
                              break e;
                            }

                            if (!u) {
                              if (n >>> 0 <= o >>> 0) {
                                C = 448;
                                break t;
                              }

                              u = y + o | 0;

                              if ((r[u >> 0] | 0) <= -65) {
                                C = 448;
                                break t;
                              }
                            } else u = y + o | 0;

                            n = n - o | 0;
                          }

                          if (!n) break a;else {
                            y = u;
                            C = 195;
                          }
                        }

                        Ud[s[w >> 2] & 15](R, t, y, n);
                        u = R;
                        D = s[u >> 2] | 0;
                        n = D & 255;
                        u = rd(D | 0, s[u + 4 >> 2] | 0, 8) | 0;

                        if (n << 24 >> 24 != 3) {
                          W = S;
                          d = u;
                          k = n;
                          break e;
                        }
                      }
                    } while (0);

                    if (!i) {
                      C = 452;
                      break e;
                    } else {
                      u = 0;
                      b = g;
                    }
                  }

                  switch (C | 0) {
                    case 166:
                      {
                        Kc(3300);
                        break;
                      }

                    case 173:
                      {
                        Sc(b, i, 0, u);
                        break;
                      }

                    case 175:
                      {
                        Hn(8804, 43, r[R + 1 >> 0] | 0);
                        break;
                      }

                    case 180:
                      {
                        Sc(y, n, f, n);
                        break;
                      }

                    case 188:
                      {
                        Sc(y, n, 1, n);
                        break;
                      }

                    case 191:
                      {
                        Sc(y, f, 1, f);
                        break;
                      }

                    case 201:
                      {
                        Sc(y, n, 1, n);
                        break;
                      }

                    case 225:
                      {
                        Sc(y, n, f, n);
                        break;
                      }

                    case 254:
                      {
                        Sc(y, n, 4, n);
                        break;
                      }

                    case 263:
                      {
                        Sc(y, n, 4, n);
                        break;
                      }

                    case 272:
                      {
                        Sc(y, n, 4, n);
                        break;
                      }

                    case 281:
                      {
                        Sc(y, n, 4, n);
                        break;
                      }

                    case 290:
                      {
                        Sc(y, n, 4, n);
                        break;
                      }

                    case 299:
                      {
                        Sc(y, n, 4, n);
                        break;
                      }

                    case 308:
                      {
                        Sc(y, n, 4, n);
                        break;
                      }

                    case 320:
                      {
                        Sc(y, n, 3, n);
                        break;
                      }

                    case 332:
                      {
                        Sc(y, n, 5, n);
                        break;
                      }

                    case 344:
                      {
                        Sc(y, n, 5, n);
                        break;
                      }

                    case 356:
                      {
                        Sc(y, n, 5, n);
                        break;
                      }

                    case 368:
                      {
                        Sc(y, n, 5, n);
                        break;
                      }

                    case 380:
                      {
                        Sc(y, n, 5, n);
                        break;
                      }

                    case 392:
                      {
                        Sc(y, n, 5, n);
                        break;
                      }

                    case 404:
                      {
                        Sc(y, n, 5, n);
                        break;
                      }

                    case 416:
                      {
                        Sc(y, n, 5, n);
                        break;
                      }

                    case 428:
                      {
                        Sc(y, n, 5, n);
                        break;
                      }

                    case 436:
                      {
                        Sc(y, n, 5, n);
                        break;
                      }

                    case 442:
                      {
                        Sc(y, n, 0, o);
                        break;
                      }

                    case 448:
                      {
                        Sc(y, n, o, n);
                        break;
                      }
                  }
                }
              }
            } while (0);

            if ((C | 0) == 118) {
              Ud[s[a + 20 >> 2] & 15](R, t, g, T);
              d = R;
              W = s[d >> 2] | 0;
              n = W & 255;
              d = rd(W | 0, s[d + 4 >> 2] | 0, 8) | 0;
              if (n << 24 >> 24 == 3) C = 452;else {
                W = S;
                k = n;
              }
            }

            if ((C | 0) == 452) {
              d = s[a + 20 >> 2] | 0;
              break;
            }

            t = od(d | 0, W & 16777215 | 0, 8) | 0;
            s[e >> 2] = t | k & 255;
            s[e + 4 >> 2] = S;
            p = I;
            return;
          }
        } while (0);

        Ud[d & 15](e, t, 3616, 1);
        p = I;
        return;
      }

      function yo(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0;
        g = p;
        p = p + 16 | 0;
        v = g;
        _ = t + 73 | 0;

        if (r[_ >> 0] | 0) {
          s[e >> 2] = 0;
          p = g;
          return;
        }

        a = t + 72 | 0;

        e: do {
          if (!(r[a >> 0] | 0)) {
            r[a >> 0] = 1;
            yo(v, t);
            y = s[v >> 2] | 0;
            a = y;

            if ((y | 0) != 0 ? (n = s[v + 4 >> 2] | 0, (n | 0) != 0) : 0) {
              s[e >> 2] = a;
              s[e + 4 >> 2] = n;
            } else o = 7;

            do {
              if ((o | 0) == 7) if (!(r[_ >> 0] | 0)) break e;else {
                s[e >> 2] = 0;
                break;
              }
            } while (0);

            p = g;
            return;
          }
        } while (0);

        y = s[t + 48 >> 2] | 0;

        do {
          if ((s[t >> 2] | 0) == 1) {
            a = t + 8 | 0;
            n = s[t + 52 >> 2] | 0;
            o = s[t + 56 >> 2] | 0;
            i = s[t + 60 >> 2] | 0;

            if ((s[t + 36 >> 2] | 0) == -1) {
              vo(v, a, y, n, o, i, 1);
              break;
            } else {
              vo(v, a, y, n, o, i, 0);
              break;
            }
          } else {
            l = t + 8 | 0;
            h = t + 4 + 9 | 0;
            b = s[t + 52 >> 2] | 0;
            a = r[h >> 0] | 0;
            m = s[l >> 2] | 0;

            while (1) {
              f = a << 24 >> 24 != 0;
              a = (f ^ 1) & 1;
              r[h >> 0] = a;
              n = (m | 0) == 0;

              if (!(n | (b | 0) == (m | 0))) {
                if (b >>> 0 <= m >>> 0) {
                  o = 18;
                  break;
                }

                if ((r[y + m >> 0] | 0) <= -65) {
                  o = 18;
                  break;
                }
              }

              do {
                if (n) n = 1114112;else {
                  c = y + m | 0;
                  n = c + -1 | 0;
                  d = r[n >> 0] | 0;

                  if (d << 24 >> 24 > -1) {
                    n = d & 255;
                    break;
                  }

                  if ((n | 0) != (y | 0)) {
                    o = c + -2 | 0;
                    u = r[o >> 0] | 0;
                    n = u & 31;

                    if ((u & -64) << 24 >> 24 == -128) {
                      if ((o | 0) != (y | 0)) {
                        o = c + -3 | 0;
                        i = r[o >> 0] | 0;
                        n = i & 15;

                        if ((i & -64) << 24 >> 24 == -128) {
                          if ((o | 0) == (y | 0)) n = 0;else n = r[c + -4 >> 0] & 7;
                          n = (n & 255) << 6 | i & 63;
                        }
                      } else n = 0;

                      n = n << 6 | u & 63;
                    }
                  } else n = 0;

                  n = n << 6 | d & 63;
                }
              } while (0);

              if (f) {
                o = 35;
                break;
              }

              if ((n | 0) == 1114112) {
                o = 34;
                break;
              }

              f = m - (n >>> 0 < 128 ? 1 : n >>> 0 < 2048 ? 2 : n >>> 0 < 65536 ? 3 : 4) | 0;
              s[l >> 2] = f;
              m = f;
            }

            if ((o | 0) == 18) Sc(y, b, 0, m);else if ((o | 0) == 34) {
              s[v >> 2] = 0;
              break;
            } else if ((o | 0) == 35) {
              s[v >> 2] = 1;
              s[v + 4 >> 2] = m;
              s[v + 8 >> 2] = m;
              break;
            }
          }
        } while (0);

        if ((s[v >> 2] | 0) == 1) {
          n = s[v + 8 >> 2] | 0;
          t = t + 68 | 0;
          a = (s[t >> 2] | 0) - n | 0;
          s[t >> 2] = s[v + 4 >> 2];
        } else {
          r[_ >> 0] = 1;
          a = s[t + 64 >> 2] | 0;
          n = a;
          a = (s[t + 68 >> 2] | 0) - a | 0;
        }

        s[e >> 2] = y + n;
        s[e + 4 >> 2] = a;
        p = g;
        return;
      }

      function vo(e, t, a, n, o, i, c) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        n = n | 0;
        o = o | 0;
        i = i | 0;
        c = c | 0;
        var u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            p = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0;
        v = t + 24 | 0;
        u = s[v >> 2] | 0;
        d = u - i | 0;

        e: do {
          if (d >>> 0 < n >>> 0) {
            y = t + 32 | 0;
            b = t;
            p = s[b >> 2] | 0;
            b = s[b + 4 >> 2] | 0;
            m = s[t + 12 >> 2] | 0;
            h = s[t + 16 >> 2] | 0;
            t = d;

            t: while (1) {
              a: while (1) {
                d = t;

                while (1) {
                  l = od(1, 0, r[a + d >> 0] & 63 | 0) | 0;
                  if (!((l & p | 0) == 0 & (S & b | 0) == 0)) break;
                  s[v >> 2] = d;
                  if (!c) s[y >> 2] = i;
                  t = d - i | 0;

                  if (t >>> 0 < n >>> 0) {
                    u = d;
                    d = t;
                  } else break e;
                }

                if (c) t = m;else {
                  t = s[y >> 2] | 0;
                  t = m >>> 0 <= t >>> 0 ? m : t;
                }
                l = u - i | 0;
                d = t;

                do {
                  f = d;
                  d = d + -1 | 0;
                  if (!f) break a;

                  if (d >>> 0 >= i >>> 0) {
                    t = 35;
                    break t;
                  }

                  f = d + l | 0;

                  if (f >>> 0 >= n >>> 0) {
                    t = 18;
                    break t;
                  }
                } while ((r[o + d >> 0] | 0) == (r[a + f >> 0] | 0));

                u = d + u - m | 0;
                s[v >> 2] = u;
                if (!c) s[y >> 2] = i;
                t = u - i | 0;
                if (t >>> 0 >= n >>> 0) break e;
              }

              t = c ? i : s[y >> 2] | 0;
              d = m;

              while (1) {
                if (d >>> 0 >= t >>> 0) {
                  t = 25;
                  break t;
                }

                if (d >>> 0 > 4294967294) {
                  t = 25;
                  break t;
                }

                if (d >>> 0 >= i >>> 0) {
                  t = 36;
                  break t;
                }

                f = l + d | 0;

                if (f >>> 0 >= n >>> 0) {
                  t = 28;
                  break t;
                }

                if ((r[o + d >> 0] | 0) == (r[a + f >> 0] | 0)) d = d + 1 | 0;else break;
              }

              u = u - h | 0;
              s[v >> 2] = u;
              if (!c) s[y >> 2] = h;
              t = u - i | 0;
              if (t >>> 0 >= n >>> 0) break e;
            }

            if ((t | 0) == 18) Yc(3620, f, n);else if ((t | 0) == 25) {
              s[v >> 2] = l;
              if (!c) s[y >> 2] = i;
              s[e >> 2] = 1;
              s[e + 4 >> 2] = l;
              s[e + 8 >> 2] = u;
              return;
            } else if ((t | 0) == 28) Yc(3620, f, n);else if ((t | 0) == 35) Yc(3636, d, i);else if ((t | 0) == 36) Yc(3652, d, i);
          }
        } while (0);

        s[v >> 2] = 0;
        s[e >> 2] = 0;
        return;
      }

      function _o(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0;
        u = p;
        p = p + 32 | 0;
        i = u + 16 | 0;
        n = u;
        c = e + 4 | 0;

        if (((s[c >> 2] | 0) - t | 0) >>> 0 >= a >>> 0) {
          p = u;
          return;
        }

        o = t + a | 0;
        if (o >>> 0 < t >>> 0) Zc(9586, 17);
        s[i >> 2] = 1;
        s[i + 4 >> 2] = 1;
        no(n, i, o);
        if ((s[n >> 2] | 0) != 1) Kc(3668);
        r = s[n + 4 >> 2] | 0;
        a = s[n + 8 >> 2] | 0;
        if ((r | 0) < 0) Kc(3740);
        t = s[c >> 2] | 0;

        if (!t) {
          t = Gt(r, a, i) | 0;
          a = (t | 0) == 0 & 1;
          r = 0;
          n = 0;
        } else {
          t = Ht(s[e >> 2] | 0, t, 1, r, a, i) | 0;
          r = (t | 0) == 0;
          n = i + 4 | 0;
          a = r & 1;
          t = r ? s[i >> 2] | 0 : t;
          r = s[n >> 2] | 0;
          n = s[n + 4 >> 2] | 0;
        }

        if ((a | 0) == 1) {
          s[i >> 2] = t;
          a = i + 4 | 0;
          s[a >> 2] = r;
          s[a + 4 >> 2] = n;
          Vt(i);
        }

        s[e >> 2] = t;
        s[c >> 2] = o;
        p = u;
        return;
      }

      function go(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0;
        i = p;
        p = p + 32 | 0;
        n = i + 16 | 0;
        a = i;
        o = e + 4 | 0;
        t = s[o >> 2] | 0;

        if (t | 0) {
          a = t << 1;
          if ((a | 0) < 0) Kc(3740);
          t = Ht(s[e >> 2] | 0, t, 1, a, 1, n) | 0;

          if (!t) {
            c = n + 4 | 0;
            u = s[c >> 2] | 0;
            c = s[c + 4 >> 2] | 0;
            s[n >> 2] = s[n >> 2];
            r = n + 4 | 0;
            s[r >> 2] = u;
            s[r + 4 >> 2] = c;
            Vt(n);
          }

          n = t;
          c = e;
          u = a;
          s[c >> 2] = n;
          s[o >> 2] = u;
          p = i;
          return;
        }

        s[n >> 2] = 1;
        s[n + 4 >> 2] = 1;
        no(a, n, 4);

        if ((s[a >> 2] | 0) == 1) {
          t = s[a + 4 >> 2] | 0;

          if (t | 0 ? (r = Gt(t, s[a + 8 >> 2] | 0, n) | 0, r | 0) : 0) {
            n = r;
            c = e;
            u = 4;
            s[c >> 2] = n;
            s[o >> 2] = u;
            p = i;
            return;
          }
        }

        s[n >> 2] = 1;
        s[n + 4 >> 2] = 7654;
        s[n + 8 >> 2] = 30;
        Vt(n);
      }

      function Ao(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0;
        u = p;
        p = p + 32 | 0;
        i = u + 16 | 0;
        n = u;
        c = e + 4 | 0;
        r = s[c >> 2] | 0;

        if ((r - t | 0) >>> 0 >= a >>> 0) {
          p = u;
          return;
        }

        a = t + a | 0;
        if (a >>> 0 < t >>> 0) Zc(9586, 17);
        o = r << 1;
        o = a >>> 0 >= o >>> 0 ? a : o;
        s[i >> 2] = 1;
        s[i + 4 >> 2] = 1;
        no(n, i, o);
        if ((s[n >> 2] | 0) != 1) Kc(3716);
        r = s[n + 4 >> 2] | 0;
        a = s[n + 8 >> 2] | 0;
        if ((r | 0) < 0) Kc(3740);
        t = s[c >> 2] | 0;

        if (!t) {
          t = Gt(r, a, i) | 0;
          a = (t | 0) == 0 & 1;
          r = 0;
          n = 0;
        } else {
          t = Ht(s[e >> 2] | 0, t, 1, r, a, i) | 0;
          r = (t | 0) == 0;
          n = i + 4 | 0;
          a = r & 1;
          t = r ? s[i >> 2] | 0 : t;
          r = s[n >> 2] | 0;
          n = s[n + 4 >> 2] | 0;
        }

        if ((a | 0) == 1) {
          s[i >> 2] = t;
          a = i + 4 | 0;
          s[a >> 2] = r;
          s[a + 4 >> 2] = n;
          Vt(i);
        }

        s[e >> 2] = t;
        s[c >> 2] = o;
        p = u;
        return;
      }

      function wo(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0;
        u = p;
        p = p + 32 | 0;
        i = u + 16 | 0;
        n = u;
        c = e + 4 | 0;
        r = s[c >> 2] | 0;

        if ((r - t | 0) >>> 0 >= a >>> 0) {
          p = u;
          return;
        }

        a = t + a | 0;
        if (a >>> 0 < t >>> 0) Zc(9586, 17);
        o = r << 1;
        o = a >>> 0 >= o >>> 0 ? a : o;
        s[i >> 2] = 12;
        s[i + 4 >> 2] = 4;
        no(n, i, o);
        if ((s[n >> 2] | 0) != 1) Kc(3716);
        r = s[n + 4 >> 2] | 0;
        a = s[n + 8 >> 2] | 0;
        if ((r | 0) < 0) Kc(3740);
        t = s[c >> 2] | 0;

        if (!t) {
          t = Gt(r, a, i) | 0;
          a = (t | 0) == 0 & 1;
          r = 0;
          n = 0;
        } else {
          t = Ht(s[e >> 2] | 0, t * 12 | 0, 4, r, a, i) | 0;
          r = (t | 0) == 0;
          n = i + 4 | 0;
          a = r & 1;
          t = r ? s[i >> 2] | 0 : t;
          r = s[n >> 2] | 0;
          n = s[n + 4 >> 2] | 0;
        }

        if ((a | 0) == 1) {
          s[i >> 2] = t;
          a = i + 4 | 0;
          s[a >> 2] = r;
          s[a + 4 >> 2] = n;
          Vt(i);
        }

        s[e >> 2] = t;
        s[c >> 2] = o;
        p = u;
        return;
      }

      function To(e) {
        e = e | 0;
        var t = 0;
        t = s[e + 4 >> 2] | 0;
        if (!t) return;
        Ut(s[e >> 2] | 0, t, 1);
        return;
      }

      function xo(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0;
        a = s[t + 4 >> 2] | 0;
        if (!a) return;
        Ut(e, a, s[t + 8 >> 2] | 0);
        return;
      }

      function Do(e) {
        e = e | 0;
        s[s[e >> 2] >> 2] = s[e + 4 >> 2];
        return;
      }

      function Co(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0;
        n = p;
        p = p + 16 | 0;
        a = n + 8 | 0;
        r = n;
        o = s[e >> 2] | 0;
        e = s[o >> 2] | 0;
        o = s[o + 8 >> 2] | 0;
        bc(r, t);
        t = e + o | 0;
        if (o | 0) do {
          s[a >> 2] = e;
          e = e + 1 | 0;
          jc(r, a, 2384) | 0;
        } while ((e | 0) != (t | 0));
        o = Gc(r) | 0;
        p = n;
        return o | 0;
      }

      function So(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            r = 0;
        t = s[e >> 2] | 0;
        a = s[e + 8 >> 2] | 0;
        r = t + (a * 12 | 0) | 0;
        if (a | 0) do {
          a = s[t + 4 >> 2] | 0;
          if (a | 0) Ut(s[t >> 2] | 0, a, 1);
          t = t + 12 | 0;
        } while ((t | 0) != (r | 0));
        t = s[e + 4 >> 2] | 0;
        if (!t) return;
        Ut(s[e >> 2] | 0, t * 12 | 0, 4);
        return;
      }

      function Eo(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            y = 0,
            v = 0,
            _ = 0;
        _ = p;
        p = p + 48 | 0;
        f = _ + 36 | 0;
        h = _ + 24 | 0;
        b = _ + 16 | 0;
        y = _;
        s[y >> 2] = 4;
        s[y + 4 >> 2] = 0;
        v = y + 8 | 0;
        s[v >> 2] = 0;
        i = s[t >> 2] | 0;
        a = s[t + 4 >> 2] | 0;
        r = s[t + 8 >> 2] | 0;
        n = (a | 0) > (i | 0);
        m = 0;
        re(26, y | 0, 0, (n ? a - i | 0 : 0) | 0);
        l = m;
        m = 0;

        if (l & 1) {
          _ = me() | 0;
          So(y);
          Ee(_ | 0);
        }

        o = s[y >> 2] | 0;
        t = s[v >> 2] | 0;
        s[b >> 2] = v;
        l = b + 4 | 0;
        s[l >> 2] = t;
        s[h >> 2] = i;
        d = h + 4 | 0;
        s[d >> 2] = a;
        u = h + 8 | 0;
        s[u >> 2] = r;

        if (!n) {
          b = t;
          s[v >> 2] = b;
          s[e >> 2] = s[y >> 2];
          s[e + 4 >> 2] = s[y + 4 >> 2];
          s[e + 8 >> 2] = s[y + 8 >> 2];
          p = _;
          return;
        }

        c = f + 4 | 0;
        o = o + (t * 12 | 0) | 0;

        while (1) {
          n = i;
          i = i + 1 | 0;
          s[h >> 2] = i;
          m = 0;
          re(27, f | 0, u | 0, n | 0);
          n = m;
          m = 0;

          if (n & 1) {
            a = 9;
            break;
          }

          a = s[f >> 2] | 0;
          n = c;
          r = s[n >> 2] | 0;
          n = s[n + 4 >> 2] | 0;

          if (!a) {
            a = 10;
            break;
          }

          s[o >> 2] = a;
          a = o + 4 | 0;
          s[a >> 2] = r;
          s[a + 4 >> 2] = n;
          t = t + 1 | 0;

          if ((i | 0) >= (s[d >> 2] | 0)) {
            a = 10;
            break;
          } else o = o + 12 | 0;
        }

        if ((a | 0) == 9) {
          _ = me() | 0;
          s[l >> 2] = t;
          Do(b);
          So(y);
          Ee(_ | 0);
        } else if ((a | 0) == 10) {
          s[v >> 2] = t;
          s[e >> 2] = s[y >> 2];
          s[e + 4 >> 2] = s[y + 4 >> 2];
          s[e + 8 >> 2] = s[y + 8 >> 2];
          p = _;
          return;
        }
      }

      function Bo(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0;
        c = p;
        p = p + 32 | 0;
        r = c + 12 | 0;
        i = c;
        if ((a | 0) < 0) Kc(3740);

        if (a) {
          n = Gt(a, 1, r) | 0;

          if (!n) {
            s[r >> 2] = 0;
            Vt(r);
          } else o = n;
        } else o = 1;

        s[i >> 2] = o;
        s[i + 4 >> 2] = a;
        r = i + 8 | 0;
        s[r >> 2] = 0;
        m = 0;
        re(23, i | 0, 0, a | 0);
        o = m;
        m = 0;

        if (o & 1) {
          c = me() | 0;
          To(i);
          Ee(c | 0);
        } else {
          o = s[r >> 2] | 0;
          s[r >> 2] = o + a;
          id((s[i >> 2] | 0) + o | 0, t | 0, a | 0) | 0;
          s[e >> 2] = s[i >> 2];
          s[e + 4 >> 2] = s[i + 4 >> 2];
          s[e + 8 >> 2] = s[i + 8 >> 2];
          p = c;
          return;
        }
      }

      function ko(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            r = 0;
        r = p;
        p = p + 16 | 0;
        t = r;
        a = Gt(28, 4, t) | 0;
        if (!a) Vt(t);else {
          s[a >> 2] = s[3948];
          s[a + 4 >> 2] = s[3949];
          s[a + 8 >> 2] = s[3950];
          s[a + 12 >> 2] = s[3951];
          s[a + 16 >> 2] = s[3952];
          s[a + 20 >> 2] = s[3953];
          s[a + 24 >> 2] = s[3954];
          Ke(t | 0) | 0;
          Oe(t | 0, 0) | 0;
          tt(a | 0, t | 0) | 0;
          Ae(t | 0) | 0;
          t = e;
          s[t >> 2] = a;
          s[t + 4 >> 2] = 0;
          p = r;
          return;
        }
      }

      function Ro(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0;
        i = p;
        p = p + 16 | 0;
        n = i;

        if (t >>> 0 > 8 | t >>> 0 > e >>> 0) {
          s[n >> 2] = 0;
          c = (bu(n, t, e) | 0) == 0;

          if (c) {
            r = s[n >> 2] | 0;
            o = 4;
          }
        } else {
          r = uu(e) | 0;
          o = 4;
        }

        if ((o | 0) == 4 ? r | 0 : 0) {
          c = r;
          p = i;
          return c | 0;
        }

        s[a >> 2] = 0;
        s[a + 4 >> 2] = e;
        s[a + 8 >> 2] = t;
        c = 0;
        p = i;
        return c | 0;
      }

      function Wo(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            r = 0,
            n = 0;
        a = p;
        p = p + 16 | 0;
        t = a;
        n = s[e + 4 >> 2] | 0;
        r = s[e + 8 >> 2] | 0;
        s[t >> 2] = s[e >> 2];
        s[t + 4 >> 2] = n;
        s[t + 8 >> 2] = r;
        m = 0;
        te(27, a + 12 | 0, t | 0);
        m = 0;
        me() | 0;
        et();
      }

      function Io(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        du(e);
        return;
      }

      function No(e, t, a, r, n, o) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        r = r | 0;
        n = n | 0;
        o = o | 0;
        var i = 0,
            c = 0,
            u = 0;
        c = p;
        p = p + 16 | 0;
        i = c;

        do {
          if ((a | 0) == (n | 0)) {
            if (!(a >>> 0 > 8 | a >>> 0 > r >>> 0)) {
              n = fu(e, r) | 0;

              if (!n) {
                i = 0;
                n = a;
                break;
              }

              p = c;
              return n | 0;
            }

            s[i >> 2] = 0;
            u = (bu(i, a, r) | 0) != 0;
            n = s[i >> 2] | 0;

            if (u | (n | 0) == 0) {
              i = 0;
              n = a;
            } else {
              id(n | 0, e | 0, (t >>> 0 <= r >>> 0 ? t : r) | 0) | 0;
              du(e);
              u = n;
              p = c;
              return u | 0;
            }
          } else {
            i = 1;
            r = 9672;
            n = 36;
          }
        } while (0);

        s[o >> 2] = i;
        s[o + 4 >> 2] = r;
        s[o + 8 >> 2] = n;
        u = 0;
        p = c;
        return u | 0;
      }

      function Mo(e) {
        e = e | 0;
        return;
      }

      function Po() {
        return rn(3812) | 0;
      }

      function Lo(e) {
        e = e | 0;
        s[e >> 2] = 0;
        s[e + 4 >> 2] = 2;
        return;
      }

      function Oo(e) {
        e = e | 0;
        S = 160875347;
        return 2033335871;
      }

      function Fo(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0;
        a = p;
        p = p + 32 | 0;
        r = a + 8 | 0;
        n = a;
        s[n >> 2] = e;
        s[r >> 2] = s[t >> 2];
        s[r + 4 >> 2] = s[t + 4 >> 2];
        s[r + 8 >> 2] = s[t + 8 >> 2];
        s[r + 12 >> 2] = s[t + 12 >> 2];
        s[r + 16 >> 2] = s[t + 16 >> 2];
        s[r + 20 >> 2] = s[t + 20 >> 2];
        t = rc(n, 3764, r) | 0;
        p = a;
        return t | 0;
      }

      function jo(e) {
        e = e | 0;
        var t = 0,
            a = 0;
        a = s[e >> 2] | 0;
        t = s[a >> 2] | 0;
        s[a >> 2] = t - 1;
        if ((t | 0) != 1) return;
        On(e);
        return;
      }

      function Go(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            r = 0,
            n = 0,
            o = 0;
        n = e + 8 | 0;
        o = e + 12 | 0;
        t = s[n >> 2] | 0;

        e: do {
          if ((t | 0) != (s[o >> 2] | 0)) {
            while (1) {
              s[n >> 2] = t + 8;
              r = s[t >> 2] | 0;
              t = s[t + 4 >> 2] | 0;
              m = 0;
              ee(s[t >> 2] | 0, r | 0);
              a = m;
              m = 0;
              if (a & 1) break;
              a = s[t + 4 >> 2] | 0;
              if (a | 0) Ut(r, a, s[t + 8 >> 2] | 0);
              t = s[n >> 2] | 0;
              if ((t | 0) == (s[o >> 2] | 0)) break e;
            }

            e = me() | 0;
            xo(r, t);
            Ee(e | 0);
          }
        } while (0);

        t = s[e + 4 >> 2] | 0;
        if (!t) return;
        Ut(s[e >> 2] | 0, t << 3, 4);
        return;
      }

      function Vo(e, t) {
        e = e | 0;
        t = t | 0;
        e = s[e >> 2] | 0;
        return yc(s[e >> 2] | 0, s[e + 8 >> 2] | 0, t) | 0;
      }

      function Uo(e) {
        e = e | 0;
        Ut(e, 12, 4);
        return;
      }

      function Ho() {
        var e = 0,
            t = 0,
            a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0;
        h = p;
        p = p + 16 | 0;
        f = h;
        o = f + 8 | 0;
        i = f + 4 | 0;
        c = f + 4 | 0;
        l = f + 8 | 0;
        u = f + 12 | 0;
        e = 0;

        e: while (1) {
          t = e;

          t: while (1) {
            if (t >>> 0 >= 10) {
              e = 5;
              break e;
            }

            e = t + 1 | 0;

            if (t >>> 0 > 4294967294) {
              e = 5;
              break e;
            }

            td(15828) | 0;
            d = s[3955] | 0;
            s[3955] = (t | 0) == 9 ? 1 : 0;
            sd(15828) | 0;

            switch (d | 0) {
              case 1:
                {
                  e = 7;
                  break e;
                }

              case 0:
                {
                  t = e;
                  break;
                }

              default:
                break t;
            }
          }

          s[f >> 2] = s[d >> 2];
          s[f + 4 >> 2] = s[d + 4 >> 2];
          s[f + 8 >> 2] = s[d + 8 >> 2];
          t = s[f >> 2] | 0;
          n = s[o >> 2] | 0;
          a = t + (n << 3) | 0;
          r = s[i >> 2] | 0;
          s[f >> 2] = t;
          s[c >> 2] = r;
          s[l >> 2] = t;
          s[u >> 2] = a;

          if (n | 0) {
            n = t;

            do {
              b = n;
              n = n + 8 | 0;
              m = 0;
              ee(s[(s[b + 4 >> 2] | 0) + 12 >> 2] | 0, s[b >> 2] | 0);
              b = m;
              m = 0;

              if (b & 1) {
                e = 9;
                break e;
              }
            } while ((n | 0) != (a | 0));

            s[l >> 2] = a;
          }

          if (r | 0) Ut(t, r << 3, 4);
          Ut(d, 12, 4);
        }

        if ((e | 0) == 5) {
          p = h;
          return;
        } else if ((e | 0) == 7) pn(9754, 37, 3788);else if ((e | 0) == 9) {
          b = me() | 0;
          s[l >> 2] = n;
          Go(f);
          Uo(d);
          Ee(b | 0);
        }
      }

      function zo(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0;
        f = p;
        p = p + 64 | 0;
        t = f + 32 | 0;
        r = f + 28 | 0;
        n = f + 24 | 0;
        o = f + 20 | 0;
        i = f + 16 | 0;
        c = f;
        u = e + 4 | 0;
        a = s[u >> 2] | 0;
        s[i >> 2] = 0;
        a = le(i | 0, a | 0) | 0;
        s[o >> 2] = a;
        s[n >> 2] = o;
        s[r >> 2] = 15856;

        if (a | 0) {
          s[c >> 2] = n;
          s[c + 4 >> 2] = 57;
          s[c + 8 >> 2] = r;
          s[c + 12 >> 2] = 57;
          s[t >> 2] = 3820;
          s[t + 4 >> 2] = 3;
          s[t + 8 >> 2] = 5264;
          s[t + 12 >> 2] = 2;
          s[t + 16 >> 2] = c;
          s[t + 20 >> 2] = 2;
          bn(t, 3844);
        }

        a = s[i >> 2] | 0;

        if (!a) {
          u = s[u >> 2] | 0;
          s[i >> 2] = 0;
          u = le(i | 0, u | 0) | 0;
          s[o >> 2] = u;
          s[n >> 2] = o;
          s[r >> 2] = 15856;

          if (u | 0) {
            s[c >> 2] = n;
            s[c + 4 >> 2] = 57;
            s[c + 8 >> 2] = r;
            s[c + 12 >> 2] = 57;
            s[t >> 2] = 3820;
            s[t + 4 >> 2] = 3;
            s[t + 8 >> 2] = 5264;
            s[t + 12 >> 2] = 2;
            s[t + 16 >> 2] = c;
            s[t + 20 >> 2] = 2;
            bn(t, 3844);
          }

          t = s[i >> 2] | 0;
          De(0) | 0;
          if (!t) pn(9791, 26, 3860);else d = t;
        } else d = a;

        t = s[e >> 2] | 0;
        if (!t) s[e >> 2] = d;

        if (!t) {
          p = f;
          return d | 0;
        }

        De(d | 0) | 0;
        d = t;
        p = f;
        return d | 0;
      }

      function Ko(e) {
        e = e | 0;
        e = e + 4 | 0;
        if ((r[e >> 0] | 0) == 3) return;
        qo(e);
        return;
      }

      function qo(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            r = 0;
        if ((o[e >> 0] | 0) < 2) return;
        a = e + 4 | 0;
        r = s[a >> 2] | 0;
        e = r + 4 | 0;
        m = 0;
        ee(s[s[e >> 2] >> 2] | 0, s[r >> 2] | 0);
        t = m;
        m = 0;

        if (t & 1) {
          t = me() | 0;
          Yo(s[r >> 2] | 0, s[e >> 2] | 0);
          Zo(s[a >> 2] | 0);
          Ee(t | 0);
        }

        e = s[e >> 2] | 0;
        t = s[e + 4 >> 2] | 0;
        if (t | 0) Ut(s[r >> 2] | 0, t, s[e + 8 >> 2] | 0);
        Ut(s[a >> 2] | 0, 12, 4);
        return;
      }

      function Yo(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0;
        a = s[t + 4 >> 2] | 0;
        if (!a) return;
        Ut(e, a, s[t + 8 >> 2] | 0);
        return;
      }

      function Zo(e) {
        e = e | 0;
        Ut(e, 12, 4);
        return;
      }

      function Jo(e) {
        e = e | 0;
        var t = 0,
            a = 0;
        t = s[e >> 2] | 0;
        if (!t) return;
        a = e + 4 | 0;
        m = 0;
        ee(s[s[a >> 2] >> 2] | 0, t | 0);
        t = m;
        m = 0;

        if (t & 1) {
          t = me() | 0;
          Xo(s[e >> 2] | 0, s[a >> 2] | 0);
          Ee(t | 0);
        }

        a = s[a >> 2] | 0;
        t = s[a + 4 >> 2] | 0;
        if (!t) return;
        Ut(s[e >> 2] | 0, t, s[a + 8 >> 2] | 0);
        return;
      }

      function Xo(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0;
        a = s[t + 4 >> 2] | 0;
        if (!a) return;
        Ut(e, a, s[t + 8 >> 2] | 0);
        return;
      }

      function $o(e) {
        e = e | 0;
        if (!(s[e >> 2] | 0)) return;
        qo(e + 4 | 0);
        return;
      }

      function Qo(e) {
        e = e | 0;
        e = s[e + 4 >> 2] | 0;
        r[e >> 0] = 0;
        r[e + 1 >> 0] = 0;
        r[e + 2 >> 0] = 0;
        r[e + 3 >> 0] = 0;
        return;
      }

      function ei(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0;
        e = p;
        p = p + 16 | 0;
        a = e;
        hc(a, t, 10237, 11);
        t = Pc(a) | 0;
        p = e;
        return t | 0;
      }

      function ti(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            n = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0;
        c = p;
        p = p + 16 | 0;
        f = c;
        Pd[s[e + 4 >> 2] & 63](f);
        b = s[f >> 2] | 0;
        h = s[f + 4 >> 2] | 0;
        f = s[f + 8 >> 2] | 0;
        u = o[t >> 0] | o[t + 1 >> 0] << 8 | o[t + 2 >> 0] << 16 | o[t + 3 >> 0] << 24;
        n = t + 4 | 0;
        l = t + 8 | 0;
        i = o[l >> 0] | o[l + 1 >> 0] << 8 | o[l + 2 >> 0] << 16 | o[l + 3 >> 0] << 24;
        d = t + 12 | 0;
        e = o[d >> 0] | o[d + 1 >> 0] << 8 | o[d + 2 >> 0] << 16 | o[d + 3 >> 0] << 24;
        r[t >> 0] = 1;
        r[t + 1 >> 0] = 0;
        r[t + 2 >> 0] = 0;
        r[t + 3 >> 0] = 0;
        r[n >> 0] = b;
        r[n + 1 >> 0] = b >> 8;
        r[n + 2 >> 0] = b >> 16;
        r[n + 3 >> 0] = b >> 24;
        r[l >> 0] = h;
        r[l + 1 >> 0] = h >> 8;
        r[l + 2 >> 0] = h >> 16;
        r[l + 3 >> 0] = h >> 24;
        r[d >> 0] = f;
        r[d + 1 >> 0] = f >> 8;
        r[d + 2 >> 0] = f >> 16;
        r[d + 3 >> 0] = f >> 24;

        if (u | 0 ? (a = i, i | 0) : 0) {
          m = 0;
          ee(s[e >> 2] | 0, a | 0);
          b = m;
          m = 0;

          if (b & 1) {
            b = me() | 0;
            Xo(a, e);
            Ee(b | 0);
          }

          a = s[e + 4 >> 2] | 0;
          if (a | 0) Ut(i, a, s[e + 8 >> 2] | 0);
        }

        if ((s[t >> 2] | 0) == 1) {
          p = c;
          return n | 0;
        } else Kc(3876);

        return 0;
      }

      function ai(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0;
        c = p;
        p = p + 64 | 0;
        t = c;
        r = c + 48 | 0;
        n = c + 32 | 0;
        o = Md[s[e >> 2] & 7]() | 0;
        if (!o) Fn(10081, 57);
        i = o + 4 | 0;

        do {
          if ((s[i >> 2] | 0) == 3) {
            Pd[s[e + 4 >> 2] & 63](n);
            s[t >> 2] = s[o >> 2];
            s[t + 4 >> 2] = s[o + 4 >> 2];
            s[t + 8 >> 2] = s[o + 8 >> 2];
            s[t + 12 >> 2] = s[o + 12 >> 2];
            s[o >> 2] = s[n >> 2];
            s[o + 4 >> 2] = s[n + 4 >> 2];
            s[o + 8 >> 2] = s[n + 8 >> 2];
            s[o + 12 >> 2] = s[n + 12 >> 2];
            s[r >> 2] = s[t >> 2];
            s[r + 4 >> 2] = s[t + 4 >> 2];
            s[r + 8 >> 2] = s[t + 8 >> 2];
            s[r + 12 >> 2] = s[t + 12 >> 2];
            if ((s[r + 4 >> 2] & 2 | 0) == 0 ? (a = r + 12 | 0, r = s[a >> 2] | 0, n = s[r >> 2] | 0, s[r >> 2] = n - 1, (n | 0) == 1) : 0) On(a);
            if ((s[i >> 2] | 0) == 3) Kc(3876);else break;
          }
        } while (0);

        e = s[o >> 2] | 0;
        if ((e | 0) == -1) zn(9983, 24);
        i = s[i >> 2] | 0;
        s[o >> 2] = e;

        if ((i | 0) == 2) {
          p = c;
          return;
        } else pn(10199, 38, 3924);
      }

      function ri(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            n = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0;
        f = p;
        p = p + 16 | 0;
        u = f + 8 | 0;
        n = f;
        a = Md[s[e >> 2] & 7]() | 0;
        if (!a) Fn(10081, 57);
        if ((s[a >> 2] | 0) == 1) d = a + 4 | 0;else d = ti(e, a) | 0;
        c = t;
        i = c;
        i = o[i >> 0] | o[i + 1 >> 0] << 8 | o[i + 2 >> 0] << 16 | o[i + 3 >> 0] << 24;
        c = c + 4 | 0;
        c = o[c >> 0] | o[c + 1 >> 0] << 8 | o[c + 2 >> 0] << 16 | o[c + 3 >> 0] << 24;
        r[t >> 0] = 0;
        r[t + 1 >> 0] = 0;
        r[t + 2 >> 0] = 0;
        r[t + 3 >> 0] = 0;
        t = n;
        s[t >> 2] = i;
        s[t + 4 >> 2] = c;

        if (s[d >> 2] | 0) {
          m = 0;
          te(23, 9967, 16);
          m = 0;
          f = me() | 0;
          Jo(n);
          Ee(f | 0);
        }

        r[d >> 0] = -1;
        r[d + 1 >> 0] = -1 >> 8;
        r[d + 2 >> 0] = -1 >> 16;
        r[d + 3 >> 0] = -1 >> 24;
        t = d + 4 | 0;
        s[u >> 2] = t;
        s[u + 4 >> 2] = d;
        e = s[t >> 2] | 0;

        if (!e) {
          u = t;
          n = u;
          s[n >> 2] = i;
          u = u + 4 | 0;
          s[u >> 2] = c;
          r[d >> 0] = 0;
          r[d + 1 >> 0] = 0;
          r[d + 2 >> 0] = 0;
          r[d + 3 >> 0] = 0;
          p = f;
          return;
        }

        a = d + 8 | 0;
        m = 0;
        ee(s[s[a >> 2] >> 2] | 0, e | 0);
        n = m;
        m = 0;

        if (n & 1) {
          f = me() | 0;
          Xo(s[t >> 2] | 0, s[a >> 2] | 0);
          d = t;
          s[d >> 2] = i;
          s[d + 4 >> 2] = c;
          Qo(u);
          Ee(f | 0);
        }

        e = s[a >> 2] | 0;
        a = s[e + 4 >> 2] | 0;

        if (!a) {
          u = t;
          n = u;
          s[n >> 2] = i;
          u = u + 4 | 0;
          s[u >> 2] = c;
          r[d >> 0] = 0;
          r[d + 1 >> 0] = 0;
          r[d + 2 >> 0] = 0;
          r[d + 3 >> 0] = 0;
          p = f;
          return;
        }

        Ut(s[t >> 2] | 0, a, s[e + 8 >> 2] | 0);
        u = t;
        n = u;
        s[n >> 2] = i;
        u = u + 4 | 0;
        s[u >> 2] = c;
        r[d >> 0] = 0;
        r[d + 1 >> 0] = 0;
        r[d + 2 >> 0] = 0;
        r[d + 3 >> 0] = 0;
        p = f;
        return;
      }

      function ni(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0;
        l = p;
        p = p + 112 | 0;
        f = l + 32 | 0;
        i = l + 96 | 0;
        c = l + 80 | 0;
        h = l + 16 | 0;
        u = l;
        a = l + 64 | 0;
        s[a >> 2] = s[t >> 2];
        s[a + 4 >> 2] = s[t + 4 >> 2];
        s[a + 8 >> 2] = s[t + 8 >> 2];
        m = 0;
        d = Q(s[e >> 2] | 0) | 0;
        n = m;
        m = 0;

        if (n & 1) {
          h = me() | 0;
          ii(a);
          Ee(h | 0);
        }

        if (!d) {
          t = a + 8 | 0;
          b = s[t >> 2] | 0;
          n = s[b >> 2] | 0;
          s[b >> 2] = n - 1;

          if ((n | 0) == 1) {
            On(t);
            Fn(10081, 57);
          } else Fn(10081, 57);
        }

        s[u >> 2] = s[a >> 2];
        s[u + 4 >> 2] = s[a + 4 >> 2];
        s[u + 8 >> 2] = s[a + 8 >> 2];
        n = d + 4 | 0;

        e: do {
          if ((s[n >> 2] | 0) == 3) {
            m = 0;
            ee(s[e + 4 >> 2] | 0, c | 0);
            b = m;
            m = 0;

            do {
              if (!(b & 1)) {
                s[f >> 2] = s[d >> 2];
                s[f + 4 >> 2] = s[d + 4 >> 2];
                s[f + 8 >> 2] = s[d + 8 >> 2];
                s[f + 12 >> 2] = s[d + 12 >> 2];
                s[d >> 2] = s[c >> 2];
                s[d + 4 >> 2] = s[c + 4 >> 2];
                s[d + 8 >> 2] = s[c + 8 >> 2];
                s[d + 12 >> 2] = s[c + 12 >> 2];
                s[i >> 2] = s[f >> 2];
                s[i + 4 >> 2] = s[f + 4 >> 2];
                s[i + 8 >> 2] = s[f + 8 >> 2];
                s[i + 12 >> 2] = s[f + 12 >> 2];
                if (((s[i + 4 >> 2] & 2 | 0) == 0 ? (o = i + 12 | 0, c = s[o >> 2] | 0, b = s[c >> 2] | 0, s[c >> 2] = b - 1, (b | 0) == 1) : 0) ? (m = 0, ee(50, o | 0), b = m, m = 0, b & 1) : 0) break;

                if ((s[n >> 2] | 0) == 3) {
                  m = 0;
                  ee(44, 3876);
                  m = 0;
                  break;
                } else break e;
              }
            } while (0);

            b = me() | 0;
            ii(u);
            Ee(b | 0);
          }
        } while (0);

        i = u;
        c = s[i + 4 >> 2] | 0;
        b = s[u + 8 >> 2] | 0;
        u = h;
        s[u >> 2] = s[i >> 2];
        s[u + 4 >> 2] = c;
        s[h + 8 >> 2] = b;

        if (s[d >> 2] | 0) {
          m = 0;
          te(23, 9967, 16);
          m = 0;
          t = me() | 0;
          m = 0;
          ee(61, h | 0);
          b = m;
          m = 0;

          if (!(b & 1)) {
            b = t;
            Ee(b | 0);
          }

          b = me() | 0;
          Ee(b | 0);
        }

        s[d >> 2] = -1;
        s[f >> 2] = n;
        a = f + 4 | 0;
        s[a >> 2] = d;

        if ((s[n >> 2] | 0) == 2) {
          s[n >> 2] = s[h >> 2];
          s[n + 4 >> 2] = s[h + 4 >> 2];
          s[n + 8 >> 2] = s[h + 8 >> 2];
          b = s[a >> 2] | 0;
          r[b >> 0] = 0;
          r[b + 1 >> 0] = 0;
          r[b + 2 >> 0] = 0;
          r[b + 3 >> 0] = 0;
          p = l;
          return;
        }

        t = d + 12 | 0;
        d = s[t >> 2] | 0;
        b = s[d >> 2] | 0;
        s[d >> 2] = b - 1;

        if ((b | 0) != 1) {
          s[n >> 2] = s[h >> 2];
          s[n + 4 >> 2] = s[h + 4 >> 2];
          s[n + 8 >> 2] = s[h + 8 >> 2];
          b = s[a >> 2] | 0;
          r[b >> 0] = 0;
          r[b + 1 >> 0] = 0;
          r[b + 2 >> 0] = 0;
          r[b + 3 >> 0] = 0;
          p = l;
          return;
        }

        m = 0;
        ee(50, t | 0);
        b = m;
        m = 0;

        if (!(b & 1)) {
          s[n >> 2] = s[h >> 2];
          s[n + 4 >> 2] = s[h + 4 >> 2];
          s[n + 8 >> 2] = s[h + 8 >> 2];
          b = s[a >> 2] | 0;
          r[b >> 0] = 0;
          r[b + 1 >> 0] = 0;
          r[b + 2 >> 0] = 0;
          r[b + 3 >> 0] = 0;
          p = l;
          return;
        }

        b = me() | 0;
        s[n >> 2] = s[h >> 2];
        s[n + 4 >> 2] = s[h + 4 >> 2];
        s[n + 8 >> 2] = s[h + 8 >> 2];
        si(f);
        Ee(b | 0);
      }

      function si(e) {
        e = e | 0;
        e = s[e + 4 >> 2] | 0;
        r[e >> 0] = 0;
        r[e + 1 >> 0] = 0;
        r[e + 2 >> 0] = 0;
        r[e + 3 >> 0] = 0;
        return;
      }

      function oi(e) {
        e = e | 0;
        var t = 0,
            a = 0;
        if ((s[e >> 2] | 0) == 2) return;
        e = e + 8 | 0;
        a = s[e >> 2] | 0;
        t = s[a >> 2] | 0;
        s[a >> 2] = t - 1;
        if ((t | 0) != 1) return;
        On(e);
        return;
      }

      function ii(e) {
        e = e | 0;
        var t = 0,
            a = 0;
        e = e + 8 | 0;
        a = s[e >> 2] | 0;
        t = s[a >> 2] | 0;
        s[a >> 2] = t - 1;
        if ((t | 0) != 1) return;
        On(e);
        return;
      }

      function ci(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0;
        f = p;
        p = p + 80 | 0;
        c = f;
        n = f + 64 | 0;
        a = f + 48 | 0;
        o = f + 32 | 0;
        d = Md[s[e >> 2] & 7]() | 0;

        if (!d) {
          d = 0;
          p = f;
          return d | 0;
        }

        u = d + 4 | 0;

        do {
          if ((s[u >> 2] | 0) == 3) {
            Pd[s[e + 4 >> 2] & 63](a);
            s[c >> 2] = s[d >> 2];
            s[c + 4 >> 2] = s[d + 4 >> 2];
            s[c + 8 >> 2] = s[d + 8 >> 2];
            s[c + 12 >> 2] = s[d + 12 >> 2];
            s[d >> 2] = s[a >> 2];
            s[d + 4 >> 2] = s[a + 4 >> 2];
            s[d + 8 >> 2] = s[a + 8 >> 2];
            s[d + 12 >> 2] = s[a + 12 >> 2];
            s[n >> 2] = s[c >> 2];
            s[n + 4 >> 2] = s[c + 4 >> 2];
            s[n + 8 >> 2] = s[c + 8 >> 2];
            s[n + 12 >> 2] = s[c + 12 >> 2];
            if ((s[n + 4 >> 2] & 2 | 0) == 0 ? (t = n + 12 | 0, l = s[t >> 2] | 0, e = s[l >> 2] | 0, s[l >> 2] = e - 1, (e | 0) == 1) : 0) On(t);
            if ((s[u >> 2] | 0) == 3) Kc(3876);else break;
          }
        } while (0);

        e = s[d >> 2] | 0;

        do {
          if ((e | 0) == -1) {
            m = 0;
            te(28, 9983, 24);
            m = 0;
          } else {
            l = s[u >> 2] | 0;
            s[d >> 2] = e;

            if ((l | 0) == 2) {
              s[a >> 2] = 0;
              m = 0;
              e = ae(14, a | 0) | 0;
              l = m;
              m = 0;
              if (l & 1) break;
              s[o >> 2] = 0;
              s[o + 8 >> 2] = e;

              if (s[d >> 2] | 0) {
                m = 0;
                te(23, 9967, 16);
                m = 0;
                l = me() | 0;
                oi(o);
                Ee(l | 0);
              }

              s[d >> 2] = -1;
              s[n >> 2] = u;
              e = n + 4 | 0;
              s[e >> 2] = d;

              if (((s[u >> 2] | 0) != 2 ? (i = d + 12 | 0, a = s[i >> 2] | 0, l = s[a >> 2] | 0, s[a >> 2] = l - 1, (l | 0) == 1) : 0) ? (m = 0, ee(50, i | 0), l = m, m = 0, l & 1) : 0) {
                l = me() | 0;
                s[u >> 2] = s[o >> 2];
                s[u + 4 >> 2] = s[o + 4 >> 2];
                s[u + 8 >> 2] = s[o + 8 >> 2];
                si(n);
                Ee(l | 0);
              }

              s[u >> 2] = s[o >> 2];
              s[u + 4 >> 2] = s[o + 4 >> 2];
              s[u + 8 >> 2] = s[o + 8 >> 2];
              e = s[e >> 2] | 0;
              r[e >> 0] = 0;
              r[e + 1 >> 0] = 0;
              r[e + 2 >> 0] = 0;
              r[e + 3 >> 0] = 0;
              e = s[d >> 2] | 0;
            }

            if (e | 0) {
              m = 0;
              te(23, 9967, 16);
              m = 0;
              l = me() | 0;
              Ee(l | 0);
            }

            s[d >> 2] = -1;
            s[c >> 2] = u;
            s[c + 4 >> 2] = d;

            if ((s[u >> 2] | 0) == 2) {
              m = 0;
              ee(44, 3876);
              m = 0;
              l = me() | 0;
              si(c);
              Ee(l | 0);
            }

            e = d + 12 | 0;
            u = s[e >> 2] | 0;
            l = s[u >> 2] | 0;
            s[u >> 2] = l + 1;
            if ((l | 0) < 0) et();
            l = s[e >> 2] | 0;
            s[d >> 2] = 0;
            p = f;
            return l | 0;
          }
        } while (0);

        l = me() | 0;
        Ee(l | 0);
        return 0;
      }

      function ui(e, t, a, n) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        n = n | 0;
        var o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0;
        v = p;
        p = p + 32 | 0;
        h = v;
        b = v + 8 | 0;

        e: do {
          if (n | 0) {
            y = b + 4 | 0;
            t = 0;

            t: while (1) {
              l = (n | 0) > -1 ? n : 2147483647;
              o = t;

              while (1) {
                t = Ju(2, a, l) | 0;

                if ((t | 0) == -1) {
                  c = 1;
                  t = 0;
                  f = s[(gu() | 0) >> 2] | 0;
                } else {
                  c = 0;
                  f = o;
                }

                s[b >> 2] = c;
                i = y;
                s[i >> 2] = t;
                s[i + 4 >> 2] = f;
                i = t & 255;
                u = f;
                d = f;
                if ((c | 0) != 1) break;
                o = rd(t | 0, f | 0, 8) | 0;

                switch (t & 3) {
                  case 0:
                    {
                      if ((f | 0) != 4) {
                        g = 12;
                        break t;
                      }

                      break;
                    }

                  case 1:
                    {
                      _ = o & 255;
                      g = 18;
                      break;
                    }

                  case 2:
                    {
                      _ = r[u + 8 >> 0] | 0;
                      g = 18;
                      break;
                    }

                  default:
                    {
                      g = 15;
                      break t;
                    }
                }

                if ((g | 0) == 18 ? (g = 0, _ << 24 >> 24 != 15) : 0) {
                  g = 12;
                  break t;
                }

                if ((i & 255) >= 2) {
                  t = f;
                  o = u + 4 | 0;
                  m = 0;
                  ee(s[s[o >> 2] >> 2] | 0, s[t >> 2] | 0);
                  c = m;
                  m = 0;

                  if (c & 1) {
                    g = 25;
                    break t;
                  }

                  t = s[o >> 2] | 0;
                  o = s[t + 4 >> 2] | 0;
                  if (o | 0) Ut(s[f >> 2] | 0, o, s[t + 8 >> 2] | 0);
                  Ut(d, 12, 4);
                }

                o = f;
              }

              if (!t) {
                g = 9;
                break;
              }

              if (n >>> 0 < t >>> 0) {
                g = 11;
                break;
              }

              n = n - t | 0;
              if (!n) break e;else {
                a = a + t | 0;
                t = f;
              }
            }

            do {
              if ((g | 0) == 9) {
                m = 0;
                ie(8, h | 0, 14, 10248, 28);
                g = m;
                m = 0;

                if (g & 1) {
                  g = me() | 0;
                  $o(b);
                  Ee(g | 0);
                } else {
                  y = h;
                  _ = s[y + 4 >> 2] | 0;
                  g = e;
                  s[g >> 2] = s[y >> 2];
                  s[g + 4 >> 2] = _;
                  break;
                }
              } else if ((g | 0) == 11) {
                m = 0;
                te(8, t | 0, n | 0);
                m = 0;
                g = me() | 0;
                $o(b);
                Ee(g | 0);
              } else if ((g | 0) == 12) {
                g = e;
                s[g >> 2] = t;
                s[g + 4 >> 2] = f;
              } else if ((g | 0) != 15) if ((g | 0) == 25) {
                g = me() | 0;
                Yo(s[t >> 2] | 0, s[o >> 2] | 0);
                Zo(u);
                Ee(g | 0);
              }
            } while (0);

            p = v;
            return;
          }
        } while (0);

        r[e >> 0] = 3;
        p = v;
        return;
      }

      function di(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var n = 0,
            o = 0,
            i = 0,
            c = 0;
        i = p;
        p = p + 48 | 0;
        n = i;
        c = i + 24 | 0;
        o = i + 8 | 0;
        s[o >> 2] = t;
        t = o + 4 | 0;
        r[t >> 0] = 3;
        s[c >> 2] = s[a >> 2];
        s[c + 4 >> 2] = s[a + 4 >> 2];
        s[c + 8 >> 2] = s[a + 8 >> 2];
        s[c + 12 >> 2] = s[a + 12 >> 2];
        s[c + 16 >> 2] = s[a + 16 >> 2];
        s[c + 20 >> 2] = s[a + 20 >> 2];
        m = 0;
        a = X(10, o | 0, 3900, c | 0) | 0;
        c = m;
        m = 0;

        if (c & 1) {
          c = me() | 0;
          Ko(o);
          Ee(c | 0);
        }

        do {
          if (a) {
            t = o + 4 | 0;

            if ((r[t >> 0] | 0) != 3) {
              n = t;
              o = s[n + 4 >> 2] | 0;
              c = e;
              s[c >> 2] = s[n >> 2];
              s[c + 4 >> 2] = o;
              p = i;
              return;
            }

            m = 0;
            ie(8, n | 0, 16, 10138, 15);
            c = m;
            m = 0;

            if (c & 1) {
              c = me() | 0;
              Ko(o);
              Ee(c | 0);
            } else {
              a = n;
              n = s[a + 4 >> 2] | 0;
              c = e;
              s[c >> 2] = s[a >> 2];
              s[c + 4 >> 2] = n;
              break;
            }
          } else r[e >> 0] = 3;
        } while (0);

        switch (r[t >> 0] & 3) {
          case 0:
          case 1:
          case 3:
            {
              p = i;
              return;
            }

          default:
            {}
        }

        e = o + 8 | 0;
        n = s[e >> 2] | 0;
        t = n + 4 | 0;
        m = 0;
        ee(s[s[t >> 2] >> 2] | 0, s[n >> 2] | 0);
        c = m;
        m = 0;

        if (c & 1) {
          c = me() | 0;
          Yo(s[n >> 2] | 0, s[t >> 2] | 0);
          Zo(s[e >> 2] | 0);
          Ee(c | 0);
        }

        t = s[t >> 2] | 0;
        a = s[t + 4 >> 2] | 0;
        if (a | 0) Ut(s[n >> 2] | 0, a, s[t + 8 >> 2] | 0);
        Ut(s[e >> 2] | 0, 12, 4);
        p = i;
        return;
      }

      function fi(e, t, a, n, o) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        n = n | 0;
        o = o | 0;
        var i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0,
            A = 0,
            w = 0,
            T = 0,
            x = 0,
            D = 0,
            C = 0,
            E = 0,
            B = 0,
            k = 0,
            R = 0,
            W = 0,
            I = 0,
            N = 0,
            M = 0,
            P = 0,
            L = 0,
            O = 0,
            F = 0,
            j = 0;
        j = p;
        p = p + 80 | 0;
        c = j;
        F = j + 64 | 0;
        Wc(c, t, a, n, o);
        P = s[c >> 2] | 0;

        do {
          if ((P | 0) == 1) {
            t = c + 8 | 0;
            a = s[c + 48 >> 2] | 0;
            n = s[c + 52 >> 2] | 0;
            o = s[c + 56 >> 2] | 0;
            i = s[c + 60 >> 2] | 0;

            if ((s[c + 36 >> 2] | 0) == -1) {
              li(F, t, a, n, o, i, 1);
              break;
            } else {
              li(F, t, a, n, o, i, 0);
              break;
            }
          } else {
            O = c + 28 | 0;
            E = c + 48 | 0;
            B = c + 52 | 0;
            L = c + 36 | 0;
            k = c + 56 | 0;
            R = c + 60 | 0;
            W = c + 8 | 0;
            I = c + 16 | 0;
            N = c + 24 | 0;
            M = c + 12 | 0;
            C = c + 4 | 0;
            t = 0;

            e: while (1) {
              if ((t | 0) == 1) {
                D = s[B >> 2] | 0;
                o = s[E >> 2] | 0;
                h = s[k >> 2] | 0;
                T = s[R >> 2] | 0;
                b = T + -1 | 0;
                y = W;
                m = s[y >> 2] | 0;
                y = s[y + 4 >> 2] | 0;
                v = s[I >> 2] | 0;
                n = s[N >> 2] | 0;
                _ = T - n | 0;
                a = s[O >> 2] | 0;
                i = s[L >> 2] | 0;

                if ((a | 0) == (D | 0)) {
                  n = 56;
                  break;
                }

                x = (i | 0) == -1;
                c = b + a | 0;

                t: do {
                  if (c >>> 0 < D >>> 0) {
                    t = T + a | 0;
                    g = t + b | 0;
                    A = g >>> 0 < D >>> 0;
                    w = 1 - v + a | 0;
                    d = a + n | 0;
                    f = d + b | 0;
                    l = f >>> 0 < D >>> 0;
                    n = a;

                    while (1) {
                      a: while (1) {
                        while (1) {
                          if ((a | 0) != (n | 0)) {
                            a = i;
                            break t;
                          }

                          u = od(1, 0, r[o + c >> 0] & 63 | 0) | 0;
                          if (!((u & m | 0) == 0 & (S & y | 0) == 0)) break;
                          i = x ? i : 0;

                          if (A) {
                            n = t;
                            c = g;
                          } else {
                            n = D;
                            a = i;
                            break t;
                          }
                        }

                        n = x ? v : i >>> 0 >= v >>> 0 ? i : v;

                        while (1) {
                          if (n >>> 0 >= T >>> 0) break a;
                          if (n >>> 0 > 4294967294) break a;
                          c = n + a | 0;

                          if (c >>> 0 >= D >>> 0) {
                            n = 40;
                            break e;
                          }

                          if ((r[h + n >> 0] | 0) == (r[o + c >> 0] | 0)) n = n + 1 | 0;else break;
                        }

                        n = w + n | 0;
                        i = x ? i : 0;
                        c = n + b | 0;

                        if (c >>> 0 >= D >>> 0) {
                          n = D;
                          a = i;
                          break t;
                        }
                      }

                      n = x ? 0 : i;
                      c = v;

                      do {
                        u = c;
                        c = c + -1 | 0;

                        if (n >>> 0 >= u >>> 0) {
                          n = 44;
                          break e;
                        }

                        if (c >>> 0 >= T >>> 0) {
                          n = 51;
                          break e;
                        }

                        u = c + a | 0;

                        if (u >>> 0 >= D >>> 0) {
                          n = 47;
                          break e;
                        }
                      } while ((r[h + c >> 0] | 0) == (r[o + u >> 0] | 0));

                      i = x ? i : _;

                      if (l) {
                        n = d;
                        c = f;
                      } else {
                        n = D;
                        a = i;
                        break;
                      }
                    }
                  } else {
                    n = D;
                    a = i;
                  }
                } while (0);

                t: do {
                  if ((n | 0) == 0 | (D | 0) == (n | 0)) t = n;else {
                    t = n;

                    do {
                      if (D >>> 0 > t >>> 0 ? (r[o + t >> 0] | 0) > -65 : 0) break t;
                      t = t + 1 | 0;
                    } while (!((t | 0) == 0 | (D | 0) == (t | 0)));
                  }
                } while (0);

                s[O >> 2] = n >>> 0 >= t >>> 0 ? n : t;
                s[L >> 2] = a;
                a = D;
              } else {
                a = s[B >> 2] | 0;
                o = s[E >> 2] | 0;
              }

              u = (r[M >> 0] | 0) != 0;
              r[M >> 0] = (u ^ 1) & 1;
              d = s[C >> 2] | 0;

              if (!((d | 0) == 0 | (a | 0) == (d | 0))) {
                if (a >>> 0 <= d >>> 0) {
                  n = 8;
                  break;
                }

                t = o + d | 0;

                if ((r[t >> 0] | 0) <= -65) {
                  n = 8;
                  break;
                }
              } else t = o + d | 0;

              c = o + d + (a - d) | 0;
              D = (t | 0) == (c | 0);
              a = D ? t : o + d + 1 | 0;

              do {
                if (!D) {
                  o = r[t >> 0] | 0;

                  if (o << 24 >> 24 > -1) {
                    t = o & 255;
                    break;
                  }

                  i = o & 31;

                  if ((a | 0) == (c | 0)) {
                    t = 0;
                    n = c;
                  } else {
                    t = r[a >> 0] & 63;
                    n = a + 1 | 0;
                  }

                  a = t & 255;
                  t = a | i << 6;

                  if ((o & 255) > 223) {
                    if ((n | 0) == (c | 0)) {
                      t = 0;
                      n = c;
                    } else {
                      t = r[n >> 0] & 63;
                      n = n + 1 | 0;
                    }

                    a = t & 255 | a << 6;
                    t = a | i << 12;

                    if ((o & 255) > 239) {
                      if ((n | 0) == (c | 0)) t = 0;else t = r[n >> 0] & 63;
                      t = a << 6 | i << 18 & 1835008 | t & 255;
                    }
                  }
                } else t = 1114112;
              } while (0);

              if (u) {
                a = d;
                t = d;
                n = 58;
                break;
              }

              if ((t | 0) == 1114112) {
                n = 57;
                break;
              }

              s[C >> 2] = (t >>> 0 < 128 ? 1 : t >>> 0 < 2048 ? 2 : t >>> 0 < 65536 ? 3 : 4) + d;
              t = P;
            }

            if ((n | 0) == 8) Sc(o, a, d, a);else if ((n | 0) == 40) Yc(3956, c, D);else if ((n | 0) == 44) {
              s[L >> 2] = i;
              s[O >> 2] = t;
              if (x) n = 58;else {
                s[L >> 2] = 0;
                n = 58;
              }
            } else if ((n | 0) == 47) Yc(3956, u, D);else if ((n | 0) == 51) Yc(3972, c, T);else if ((n | 0) == 56) {
              s[O >> 2] = D;
              n = 57;
            }

            if ((n | 0) == 57) {
              s[F >> 2] = 0;
              break;
            } else if ((n | 0) == 58) {
              s[F >> 2] = 1;
              s[F + 4 >> 2] = a;
              s[F + 8 >> 2] = t;
              break;
            }
          }
        } while (0);

        if ((s[F >> 2] | 0) != 1) {
          F = 0;
          s[e >> 2] = F;
          p = j;
          return;
        }

        s[e + 4 >> 2] = s[F + 4 >> 2];
        F = 1;
        s[e >> 2] = F;
        p = j;
        return;
      }

      function li(e, t, a, n, o, i, c) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        n = n | 0;
        o = o | 0;
        i = i | 0;
        c = c | 0;
        var u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            p = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0;
        _ = t + 20 | 0;
        y = i + -1 | 0;
        d = s[_ >> 2] | 0;
        u = d + y | 0;

        e: do {
          if (u >>> 0 < n >>> 0) {
            v = t + 28 | 0;
            b = t;
            p = s[b >> 2] | 0;
            b = s[b + 4 >> 2] | 0;
            m = s[t + 8 >> 2] | 0;
            l = s[t + 16 >> 2] | 0;
            h = i - l | 0;
            t = d;

            t: while (1) {
              a: while (1) {
                f = t;

                while (1) {
                  d = od(1, 0, r[a + u >> 0] & 63 | 0) | 0;
                  if (!((d & p | 0) == 0 & (S & b | 0) == 0)) break;
                  t = f + i | 0;
                  s[_ >> 2] = t;
                  if (!c) s[v >> 2] = 0;
                  u = t + y | 0;
                  if (u >>> 0 >= n >>> 0) break e;else f = t;
                }

                if (c) t = m;else {
                  t = s[v >> 2] | 0;
                  t = t >>> 0 >= m >>> 0 ? t : m;
                }

                do {
                  if (t >>> 0 >= i >>> 0) break a;
                  u = t;
                  t = t + 1 | 0;
                  if (u >>> 0 > 4294967294) break a;
                  d = f + u | 0;

                  if (d >>> 0 >= n >>> 0) {
                    t = 17;
                    break t;
                  }
                } while ((r[o + u >> 0] | 0) == (r[a + d >> 0] | 0));

                t = t + f - m | 0;
                s[_ >> 2] = t;
                if (!c) s[v >> 2] = 0;
                u = t + y | 0;
                if (u >>> 0 >= n >>> 0) break e;
              }

              t = c ? 0 : s[v >> 2] | 0;
              u = m;

              do {
                d = u;
                u = u + -1 | 0;

                if (t >>> 0 >= d >>> 0) {
                  t = 23;
                  break t;
                }

                if (u >>> 0 >= i >>> 0) {
                  t = 33;
                  break t;
                }

                d = u + f | 0;

                if (d >>> 0 >= n >>> 0) {
                  t = 26;
                  break t;
                }
              } while ((r[o + u >> 0] | 0) == (r[a + d >> 0] | 0));

              t = l + f | 0;
              s[_ >> 2] = t;
              if (!c) s[v >> 2] = h;
              u = t + y | 0;
              if (u >>> 0 >= n >>> 0) break e;
            }

            if ((t | 0) == 17) Yc(3956, d, n);else if ((t | 0) == 23) {
              t = f + i | 0;
              s[_ >> 2] = t;
              if (!c) s[v >> 2] = 0;
              s[e >> 2] = 1;
              s[e + 4 >> 2] = f;
              s[e + 8 >> 2] = t;
              return;
            } else if ((t | 0) == 26) Yc(3956, d, n);else if ((t | 0) == 33) Yc(3972, u, i);
          }
        } while (0);

        s[_ >> 2] = n;
        s[e >> 2] = 0;
        return;
      }

      function hi(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0;
        c = p;
        p = p + 32 | 0;
        o = c + 12 | 0;
        i = c;
        a = s[(s[s[t >> 2] >> 2] | 0) + (a << 2) >> 2] | 0;
        r = Cu(a) | 0;
        if ((r | 0) == -1) ru(-1, 0);
        if ((r | 0) < 0) Kc(3740);

        if (r) {
          t = Gt(r, 1, o) | 0;

          if (!t) {
            s[o >> 2] = 0;
            Vt(o);
          } else n = t;
        } else n = 1;

        s[i >> 2] = n;
        s[i + 4 >> 2] = r;
        t = i + 8 | 0;
        s[t >> 2] = 0;
        m = 0;
        re(23, i | 0, 0, r | 0);
        o = m;
        m = 0;

        if (o & 1) {
          c = me() | 0;
          pi(i);
          Ee(c | 0);
        } else {
          o = s[t >> 2] | 0;
          s[t >> 2] = o + r;
          id((s[i >> 2] | 0) + o | 0, a | 0, r | 0) | 0;
          s[e >> 2] = s[i >> 2];
          s[e + 4 >> 2] = s[i + 4 >> 2];
          s[e + 8 >> 2] = s[i + 8 >> 2];
          p = c;
          return;
        }
      }

      function pi(e) {
        e = e | 0;
        var t = 0;
        t = s[e + 4 >> 2] | 0;
        if (!t) return;
        Ut(s[e >> 2] | 0, t, 1);
        return;
      }

      function bi(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            r = 0;
        t = s[e >> 2] | 0;
        a = s[e + 8 >> 2] | 0;
        r = t + (a * 12 | 0) | 0;
        if (a | 0) do {
          a = s[t + 4 >> 2] | 0;
          if (a | 0) Ut(s[t >> 2] | 0, a, 1);
          t = t + 12 | 0;
        } while ((t | 0) != (r | 0));
        t = s[e + 4 >> 2] | 0;
        if (!t) return;
        Ut(s[e >> 2] | 0, t * 12 | 0, 4);
        return;
      }

      function mi(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            r = 0,
            n = 0;
        n = s[e >> 2] | 0;
        if (!n) return;
        t = s[n >> 2] | 0;
        a = s[n + 8 >> 2] | 0;
        r = t + (a * 12 | 0) | 0;
        if (a | 0) do {
          a = s[t + 4 >> 2] | 0;
          if (a | 0) Ut(s[t >> 2] | 0, a, 1);
          t = t + 12 | 0;
        } while ((t | 0) != (r | 0));
        t = s[n + 4 >> 2] | 0;
        if (t | 0) Ut(s[n >> 2] | 0, t * 12 | 0, 4);
        Ut(s[e >> 2] | 0, 12, 4);
        return;
      }

      function yi(e, t) {
        e = e | 0;
        t = t | 0;
        return yc(10417, 25, t) | 0;
      }

      function vi(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0;
        n = p;
        p = p + 32 | 0;
        a = n + 16 | 0;
        r = n;
        o = n + 12 | 0;
        s[o >> 2] = t;
        s[a >> 2] = 0;
        s[a + 4 >> 2] = e;
        s[a + 8 >> 2] = o;
        Eo(r, a);
        td(15864) | 0;

        if (s[3965] | 0) {
          m = 0;
          re(21, 10313, 34, 3940);
          m = 0;
          o = me() | 0;
          bi(r);
          Ee(o | 0);
        }

        e = Gt(12, 4, a) | 0;
        if (!e) Vt(a);else {
          s[e >> 2] = s[r >> 2];
          s[e + 4 >> 2] = s[r + 4 >> 2];
          s[e + 8 >> 2] = s[r + 8 >> 2];
          s[3965] = e;
          sd(15864) | 0;
          p = n;
          return;
        }
      }

      function _i(e, t) {
        e = e | 0;
        t = t | 0;
        e = p;
        p = p + 16 | 0;
        s[e >> 2] = s[t >> 2];
        s[e + 4 >> 2] = s[t + 4 >> 2];
        s[e + 8 >> 2] = s[t + 8 >> 2];
        gi(0, e);
      }

      function gi(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0;
        a = p;
        p = p + 32 | 0;
        r = a + 24 | 0;
        e = a;
        s[r >> 2] = t;
        s[r + 4 >> 2] = 61;
        s[e >> 2] = 3988;
        s[e + 4 >> 2] = 2;
        s[e + 8 >> 2] = 5180;
        s[e + 12 >> 2] = 1;
        s[e + 16 >> 2] = r;
        s[e + 20 >> 2] = 1;
        wi(a + 32 | 0, e) | 0;
        et();
      }

      function Ai(e) {
        e = e | 0;
        return;
      }

      function wi(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0;
        a = p;
        p = p + 32 | 0;
        r = a + 8 | 0;
        n = a;
        s[n >> 2] = e;
        s[r >> 2] = s[t >> 2];
        s[r + 4 >> 2] = s[t + 4 >> 2];
        s[r + 8 >> 2] = s[t + 8 >> 2];
        s[r + 12 >> 2] = s[t + 12 >> 2];
        s[r + 16 >> 2] = s[t + 16 >> 2];
        s[r + 20 >> 2] = s[t + 20 >> 2];
        t = rc(n, 4004, r) | 0;
        p = a;
        return t | 0;
      }

      function Ti(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0;
        u = p;
        p = p + 16 | 0;
        e = u;
        s[e >> 2] = 0;

        if (t >>> 0 < 128) {
          r[e >> 0] = t;
          t = 1;
          Ju(2, e, t) | 0;
          p = u;
          return 0;
        }

        do {
          if (t >>> 0 >= 2048) {
            if (t >>> 0 < 65536) {
              r[e >> 0] = t >>> 12 & 15 | -32;
              a = 63;
              n = 1;
              o = -128;
              i = 2;
              c = 3;
              break;
            } else {
              r[e >> 0] = t >>> 18 & 255 | -16;
              r[e + 1 >> 0] = t >>> 12 & 63 | -128;
              a = 63;
              n = 2;
              o = -128;
              i = 3;
              c = 4;
              break;
            }
          } else {
            a = 31;
            n = 0;
            o = -64;
            i = 1;
            c = 2;
          }
        } while (0);

        r[e + n >> 0] = a & t >>> 6 & 255 | o;
        r[e + i >> 0] = t & 63 | -128;
        t = c;
        Ju(2, e, t) | 0;
        p = u;
        return 0;
      }

      function xi(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0;
        a = p;
        p = p + 32 | 0;
        r = a + 8 | 0;
        n = a;
        s[n >> 2] = s[e >> 2];
        s[r >> 2] = s[t >> 2];
        s[r + 4 >> 2] = s[t + 4 >> 2];
        s[r + 8 >> 2] = s[t + 8 >> 2];
        s[r + 12 >> 2] = s[t + 12 >> 2];
        s[r + 16 >> 2] = s[t + 16 >> 2];
        s[r + 20 >> 2] = s[t + 20 >> 2];
        t = rc(n, 4004, r) | 0;
        p = a;
        return t | 0;
      }

      function Di(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        Ju(2, t, a) | 0;
        return 0;
      }

      function Ci(e, t, a, r) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        r = r | 0;
        var n = 0;
        m = 0;
        ee(e | 0, t | 0);
        t = m;
        m = 0;

        if (!(t & 1)) {
          r = 0;
          return r | 0;
        }

        e = We(0) | 0;

        if (!e) {
          m = 0;
          ee(44, 4028);
          m = 0;
          me() | 0;
          et();
        }

        n = s[e >> 2] | 0;
        t = s[e + 4 >> 2] | 0;
        xe(e | 0);
        s[a >> 2] = n;
        s[r >> 2] = t;
        r = 1;
        return r | 0;
      }

      function Si(e, t) {
        e = e | 0;
        t = t | 0;
        return ki(e, t) | 0;
      }

      function Ei(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0;
        a = s[t + 4 >> 2] | 0;
        if (!a) return;
        Ut(e, a, s[t + 8 >> 2] | 0);
        return;
      }

      function Bi(e, t, a, r, n, s) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        r = r | 0;
        n = n | 0;
        s = s | 0;
        return pe(e | 0, t | 0, a | 0, r | 0, n | 0, s | 0) | 0;
      }

      function ki(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0;
        a = Ce(8) | 0;

        if (a | 0) {
          s[a >> 2] = e;
          s[a + 4 >> 2] = t;
          Ze(a | 0, 0, 0);
        }

        m = 0;
        ee(s[t >> 2] | 0, e | 0);
        a = m;
        m = 0;

        if (a & 1) {
          a = me() | 0;
          Ei(e, t);
          Ee(a | 0);
        }

        a = s[t + 4 >> 2] | 0;
        if (!a) return 3;
        Ut(e, a, s[t + 8 >> 2] | 0);
        return 3;
      }

      function Ri(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0;
        r = p;
        p = p + 16 | 0;
        a = r;

        do {
          switch (s[e >> 2] & 15) {
            case 0:
              {
                pc(a, t, 10573, 14);
                a = Oc(a) | 0;
                p = r;
                return a | 0;
              }

            case 1:
              {
                pc(a, t, 10587, 29);
                a = Oc(a) | 0;
                p = r;
                return a | 0;
              }

            case 2:
              {
                pc(a, t, 10616, 23);
                a = Oc(a) | 0;
                p = r;
                return a | 0;
              }

            case 3:
              {
                pc(a, t, 10639, 23);
                a = Oc(a) | 0;
                p = r;
                return a | 0;
              }

            case 4:
              {
                pc(a, t, 10662, 16);
                a = Oc(a) | 0;
                p = r;
                return a | 0;
              }

            case 5:
              {
                pc(a, t, 10678, 17);
                a = Oc(a) | 0;
                p = r;
                return a | 0;
              }

            case 6:
              {
                pc(a, t, 10695, 18);
                a = Oc(a) | 0;
                p = r;
                return a | 0;
              }

            case 7:
              {
                pc(a, t, 10713, 20);
                a = Oc(a) | 0;
                p = r;
                return a | 0;
              }

            case 8:
              {
                pc(a, t, 10733, 20);
                a = Oc(a) | 0;
                p = r;
                return a | 0;
              }

            case 9:
              {
                pc(a, t, 10753, 12);
                a = Oc(a) | 0;
                p = r;
                return a | 0;
              }

            default:
              {}
          }
        } while (0);

        return 0;
      }

      function Wi(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0;
        r = p;
        p = p + 16 | 0;
        n = r;
        Mi(n, t, a);
        s[e >> 2] = s[n >> 2];
        s[e + 4 >> 2] = s[n + 4 >> 2];
        s[e + 8 >> 2] = s[n + 8 >> 2];
        p = r;
        return;
      }

      function Ii(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0;
        r = p;
        p = p + 16 | 0;
        n = r;
        Mi(n, t, a);
        s[e >> 2] = s[n >> 2];
        s[e + 4 >> 2] = s[n + 4 >> 2];
        s[e + 8 >> 2] = s[n + 8 >> 2];
        p = r;
        return;
      }

      function Ni(e) {
        e = e | 0;
        var t = 0;
        t = s[e + 4 >> 2] | 0;
        if (!t) return;
        Ut(s[e >> 2] | 0, t, 1);
        return;
      }

      function Mi(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0;
        c = p;
        p = p + 32 | 0;
        r = c + 12 | 0;
        i = c;
        if ((a | 0) < 0) Kc(4084);

        if (a) {
          n = Gt(a, 1, r) | 0;

          if (!n) {
            s[r >> 2] = 0;
            Vt(r);
          } else o = n;
        } else o = 1;

        s[i >> 2] = o;
        s[i + 4 >> 2] = a;
        r = i + 8 | 0;
        s[r >> 2] = 0;
        m = 0;
        re(28, i | 0, 0, a | 0);
        o = m;
        m = 0;

        if (o & 1) {
          c = me() | 0;
          Ni(i);
          Ee(c | 0);
        } else {
          o = s[r >> 2] | 0;
          s[r >> 2] = o + a;
          id((s[i >> 2] | 0) + o | 0, t | 0, a | 0) | 0;
          s[e >> 2] = s[i >> 2];
          s[e + 4 >> 2] = s[i + 4 >> 2];
          s[e + 8 >> 2] = s[i + 8 >> 2];
          p = c;
          return;
        }
      }

      function Pi(e, t) {
        e = e | 0;
        t = t | 0;
        return vc(s[e >> 2] | 0, s[e + 4 >> 2] | 0, t) | 0;
      }

      function Li(e, t) {
        e = e | 0;
        t = t | 0;
        s[e >> 2] = s[t >> 2];
        s[e + 4 >> 2] = s[t + 4 >> 2];
        s[e + 8 >> 2] = s[t + 8 >> 2];
        return;
      }

      function Oi(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0;
        a = p;
        p = p + 48 | 0;
        o = a + 32 | 0;
        n = a + 24 | 0;
        r = a;
        e = (s[e >> 2] | 0) != 1;
        s[o >> 2] = e ? 10765 : 10791;
        s[o + 4 >> 2] = e ? 26 : 29;
        s[n >> 2] = o;
        s[n + 4 >> 2] = 62;
        s[r >> 2] = 4076;
        s[r + 4 >> 2] = 1;
        s[r + 8 >> 2] = 5180;
        s[r + 12 >> 2] = 1;
        s[r + 16 >> 2] = n;
        s[r + 20 >> 2] = 1;
        t = fc(t, r) | 0;
        p = a;
        return t | 0;
      }

      function Fi(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0;
        u = p;
        p = p + 16 | 0;
        i = u;
        c = e + 4 | 0;
        r = s[c >> 2] | 0;

        if ((r - t | 0) >>> 0 >= a >>> 0) {
          p = u;
          return;
        }

        a = t + a | 0;
        if (a >>> 0 < t >>> 0) Zc(10820, 17);
        o = r << 1;
        o = a >>> 0 >= o >>> 0 ? a : o;
        if ((o | 0) < 0) Kc(4084);

        if (!r) {
          t = Gt(o, 1, i) | 0;
          a = (t | 0) == 0 & 1;
          r = 0;
          n = 0;
        } else {
          t = Ht(s[e >> 2] | 0, r, 1, o, 1, i) | 0;
          r = (t | 0) == 0;
          n = i + 4 | 0;
          a = r & 1;
          t = r ? s[i >> 2] | 0 : t;
          r = s[n >> 2] | 0;
          n = s[n + 4 >> 2] | 0;
        }

        if ((a | 0) == 1) {
          s[i >> 2] = t;
          a = i + 4 | 0;
          s[a >> 2] = r;
          s[a + 4 >> 2] = n;
          Vt(i);
        }

        s[e >> 2] = t;
        s[c >> 2] = o;
        p = u;
        return;
      }

      function ji(e) {
        e = e | 0;
        return Hi(e, 168) | 0;
      }

      function Gi(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        s[e >> 2] = t;
        s[e + 4 >> 2] = a;
        return;
      }

      function Vi(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        s[e >> 2] = t;
        s[e + 4 >> 2] = a;
        return;
      }

      function Ui(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            p = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0;
        l = t + 4 | 0;
        h = s[l >> 2] | 0;

        if (!h) {
          s[e >> 2] = 0;
          return;
        }

        v = s[t >> 2] | 0;
        a = 0;

        e: while (1) {
          d = v + a | 0;
          c = r[d >> 0] | 0;
          n = a + 1 | 0;

          t: do {
            if (c << 24 >> 24 > -1) a = n;else switch (r[11498 + (c & 255) >> 0] | 0) {
              case 2:
                {
                  if (h >>> 0 <= n >>> 0) {
                    g = 15;
                    break e;
                  }

                  if ((r[v + n >> 0] & -64) << 24 >> 24 != -128) {
                    g = 15;
                    break e;
                  }

                  a = a + 2 | 0;
                  break t;
                }

              case 3:
                {
                  if (h >>> 0 <= n >>> 0) {
                    g = 15;
                    break e;
                  }

                  o = r[v + n >> 0] | 0;
                  i = (o & 255) < 192;

                  if (((!(c << 24 >> 24 == -32 & (o & -32) << 24 >> 24 == -96) ? (u = o << 24 >> 24 < 0, !(i & ((c + 31 & 255) < 12 & u))) : 0) ? !((o & 255) < 160 & (c << 24 >> 24 == -19 & u)) : 0) ? !(i & ((c & -2) << 24 >> 24 == -18 & u)) : 0) {
                    g = 15;
                    break e;
                  }

                  n = a + 2 | 0;

                  if (h >>> 0 <= n >>> 0) {
                    g = 15;
                    break e;
                  }

                  if ((r[v + n >> 0] & -64) << 24 >> 24 != -128) {
                    g = 15;
                    break e;
                  }

                  a = a + 3 | 0;
                  break t;
                }

              case 4:
                {
                  if (h >>> 0 <= n >>> 0) {
                    g = 15;
                    break e;
                  }

                  o = r[v + n >> 0] | 0;

                  if ((!(c << 24 >> 24 == -16 & (o + 112 & 255) < 48) ? (f = o << 24 >> 24 < 0, !((o & 255) < 192 & ((c + 15 & 255) < 3 & f))) : 0) ? !((o & 255) < 144 & (c << 24 >> 24 == -12 & f)) : 0) {
                    g = 15;
                    break e;
                  }

                  n = a + 2 | 0;

                  if (h >>> 0 <= n >>> 0) {
                    g = 15;
                    break e;
                  }

                  if ((r[v + n >> 0] & -64) << 24 >> 24 != -128) {
                    g = 15;
                    break e;
                  }

                  n = a + 3 | 0;

                  if (h >>> 0 <= n >>> 0) {
                    g = 15;
                    break e;
                  }

                  if ((r[v + n >> 0] & -64) << 24 >> 24 != -128) {
                    g = 15;
                    break e;
                  }

                  a = a + 4 | 0;
                  break t;
                }

              default:
                {
                  g = 15;
                  break e;
                }
            }
          } while (0);

          if (a >>> 0 >= h >>> 0) {
            p = 16465;
            b = 0;
            m = h;
            y = 16465;
            _ = 0;
            break;
          }
        }

        do {
          if ((g | 0) == 15) {
            if (h >>> 0 < a >>> 0) ru(a, h);
            if (n >>> 0 < a >>> 0) nu(a, n);
            if (h >>> 0 < n >>> 0) ru(n, h);else {
              p = v + n | 0;
              b = h - n | 0;
              m = a;
              y = d;
              _ = n - a | 0;
              break;
            }
          }
        } while (0);

        s[t >> 2] = p;
        s[l >> 2] = b;
        s[e >> 2] = v;
        s[e + 4 >> 2] = m;
        s[e + 8 >> 2] = y;
        s[e + 12 >> 2] = _;
        return;
      }

      function Hi(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0;

        do {
          if (e >>> 0 >= 2048) {
            if (e >>> 0 < 65536) {
              a = (e >>> 6) + -32 | 0;
              if (a >>> 0 >= 992) Yc(4108, a, 992);
              a = o[t + 280 + a >> 0] | 0;
              r = s[t + 260 >> 2] | 0;

              if (a >>> 0 < r >>> 0) {
                n = (s[t + 256 >> 2] | 0) + (a << 3) | 0;
                break;
              } else Yc(4124, a, r);
            }

            a = (e >>> 12) + -16 | 0;
            if (a >>> 0 >= 256) Yc(4108, a, 256);
            r = s[t + 268 >> 2] | 0;
            a = (o[t + 1272 + a >> 0] | 0) << 6 | e >>> 6 & 63;
            if (a >>> 0 >= r >>> 0) Yc(4108, a, r);
            a = o[(s[t + 264 >> 2] | 0) + a >> 0] | 0;
            r = s[t + 276 >> 2] | 0;

            if (a >>> 0 < r >>> 0) {
              n = (s[t + 272 >> 2] | 0) + (a << 3) | 0;
              break;
            } else Yc(4140, a, r);
          } else n = t + (e >>> 6 << 3) | 0;
        } while (0);

        r = s[n >> 2] | 0;
        n = s[n + 4 >> 2] | 0;
        t = od(1, 0, e & 63 | 0) | 0;
        return (r & t | 0) != 0 | (n & S | 0) != 0 | 0;
      }

      function zi(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0;
        u = p;
        p = p + 128 | 0;
        c = u;
        o = s[e >> 2] | 0;
        e = c;
        a = e + 128 | 0;

        do {
          r[e >> 0] = 0;
          e = e + 1 | 0;
        } while ((e | 0) < (a | 0));

        n = 128;
        i = c + 128 | 0;
        a = o;

        while (1) {
          i = i + -1 | 0;
          e = a & 15;
          a = a >>> 4;
          r[i >> 0] = ((e & 255) < 10 ? 48 : 87) + e << 24 >> 24;
          e = n + -1 | 0;
          if (!a) break;else n = e;
        }

        if (e >>> 0 > 128) nu(e, 128);else {
          c = ic(t, 1, 11390, 2, c + e | 0, 129 - n | 0) | 0;
          p = u;
          return c | 0;
        }
        return 0;
      }

      function Ki(e, t) {
        e = e | 0;
        t = t | 0;
        return qi(e, t) | 0;
      }

      function qi(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0;
        u = p;
        p = p + 48 | 0;
        c = u;
        e = s[e >> 2] | 0;

        if (e >>> 0 > 9999) {
          i = 39;
          o = e;

          while (1) {
            d = (o >>> 0) % 1e4 | 0;
            e = (o >>> 0) / 1e4 | 0;
            a = i + -4 | 0;
            f = c + a | 0;
            l = n[4156 + (((d >>> 0) / 100 | 0) << 1) >> 1] | 0;
            r[f >> 0] = l;
            r[f + 1 >> 0] = l >> 8;
            i = c + (i + -2) | 0;
            d = n[4156 + (((d >>> 0) % 100 | 0) << 1) >> 1] | 0;
            r[i >> 0] = d;
            r[i + 1 >> 0] = d >> 8;

            if (o >>> 0 > 99999999) {
              i = a;
              o = e;
            } else break;
          }
        } else a = 39;

        if ((e | 0) > 99) {
          a = a + -2 | 0;
          l = c + a | 0;
          f = n[4156 + (((e >>> 0) % 100 | 0) << 1) >> 1] | 0;
          r[l >> 0] = f;
          r[l + 1 >> 0] = f >> 8;
          e = (e >>> 0) / 100 | 0;
        }

        if ((e | 0) < 10) {
          l = a + -1 | 0;
          r[c + l >> 0] = (e & 255) + 48 << 24 >> 24;
          f = c + l | 0;
          l = 39 - l | 0;
          l = ic(t, 1, 16465, 0, f, l) | 0;
          p = u;
          return l | 0;
        } else {
          l = a + -2 | 0;
          f = c + l | 0;
          d = n[4156 + (e << 1) >> 1] | 0;
          r[f >> 0] = d;
          r[f + 1 >> 0] = d >> 8;
          f = c + l | 0;
          l = 39 - l | 0;
          l = ic(t, 1, 16465, 0, f, l) | 0;
          p = u;
          return l | 0;
        }

        return 0;
      }

      function Yi(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            n = 0,
            s = 0,
            o = 0,
            i = 0,
            c = 0;
        c = p;
        p = p + 128 | 0;
        i = c;
        s = r[e >> 0] | 0;
        e = i;
        a = e + 128 | 0;

        do {
          r[e >> 0] = 0;
          e = e + 1 | 0;
        } while ((e | 0) < (a | 0));

        n = 128;
        o = i + 128 | 0;
        a = s;

        while (1) {
          o = o + -1 | 0;
          e = a & 15;
          a = (a & 255) >>> 4;
          r[o >> 0] = ((e & 255) < 10 ? 48 : 55) + e << 24 >> 24;
          e = n + -1 | 0;
          if (!(a << 24 >> 24)) break;else n = e;
        }

        if (e >>> 0 > 128) nu(e, 128);else {
          i = ic(t, 1, 11390, 2, i + e | 0, 129 - n | 0) | 0;
          p = c;
          return i | 0;
        }
        return 0;
      }

      function Zi(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            s = 0,
            o = 0,
            i = 0;
        i = p;
        p = p + 48 | 0;
        s = i;
        e = r[e >> 0] | 0;
        a = e & 255;
        if ((e & 255) <= 99) {
          if ((e & 255) < 10) {
            e = 38;
            o = 4;
          } else {
            e = s + 37 | 0;
            a = n[4156 + (a << 1) >> 1] | 0;
            r[e >> 0] = a;
            r[e + 1 >> 0] = a >> 8;
            e = 37;
          }
        } else {
          a = s + 37 | 0;
          o = n[4156 + (((e & 255) % 100 | 0) << 1 & 255) >> 1] | 0;
          r[a >> 0] = o;
          r[a + 1 >> 0] = o >> 8;
          a = ((e & 255) / 100 | 0) & 255;
          e = 36;
          o = 4;
        }
        if ((o | 0) == 4) r[s + e >> 0] = (a & 255) + 48 << 24 >> 24;
        o = ic(t, 1, 16465, 0, s + e | 0, 39 - e | 0) | 0;
        p = i;
        return o | 0;
      }

      function Ji(e, t) {
        e = e | 0;
        t = t | 0;
        return Xi(e, t) | 0;
      }

      function Xi(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0;
        d = p;
        p = p + 48 | 0;
        u = d;
        e = s[e >> 2] | 0;
        c = (e | 0) > -1;
        e = c ? e : 0 - e | 0;

        if (e >>> 0 > 9999) {
          i = 39;
          o = e;

          while (1) {
            f = (o >>> 0) % 1e4 | 0;
            a = (o >>> 0) / 1e4 | 0;
            e = i + -4 | 0;
            l = u + e | 0;
            h = n[4156 + (((f >>> 0) / 100 | 0) << 1) >> 1] | 0;
            r[l >> 0] = h;
            r[l + 1 >> 0] = h >> 8;
            i = u + (i + -2) | 0;
            f = n[4156 + (((f >>> 0) % 100 | 0) << 1) >> 1] | 0;
            r[i >> 0] = f;
            r[i + 1 >> 0] = f >> 8;

            if (o >>> 0 > 99999999) {
              i = e;
              o = a;
            } else break;
          }
        } else {
          a = e;
          e = 39;
        }

        if ((a | 0) > 99) {
          e = e + -2 | 0;
          h = u + e | 0;
          l = n[4156 + (((a >>> 0) % 100 | 0) << 1) >> 1] | 0;
          r[h >> 0] = l;
          r[h + 1 >> 0] = l >> 8;
          a = (a >>> 0) / 100 | 0;
        }

        if ((a | 0) < 10) {
          h = e + -1 | 0;
          r[u + h >> 0] = (a & 255) + 48 << 24 >> 24;
          l = u + h | 0;
          h = 39 - h | 0;
          h = ic(t, c, 16465, 0, l, h) | 0;
          p = d;
          return h | 0;
        } else {
          h = e + -2 | 0;
          l = u + h | 0;
          f = n[4156 + (a << 1) >> 1] | 0;
          r[l >> 0] = f;
          r[l + 1 >> 0] = f >> 8;
          l = u + h | 0;
          h = 39 - h | 0;
          h = ic(t, c, 16465, 0, l, h) | 0;
          p = d;
          return h | 0;
        }

        return 0;
      }

      function $i(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0;
        u = p;
        p = p + 48 | 0;
        c = u;
        e = s[e >> 2] | 0;

        if (e >>> 0 > 9999) {
          i = 39;
          o = e;

          while (1) {
            d = (o >>> 0) % 1e4 | 0;
            e = (o >>> 0) / 1e4 | 0;
            a = i + -4 | 0;
            f = c + a | 0;
            l = n[4156 + (((d >>> 0) / 100 | 0) << 1) >> 1] | 0;
            r[f >> 0] = l;
            r[f + 1 >> 0] = l >> 8;
            i = c + (i + -2) | 0;
            d = n[4156 + (((d >>> 0) % 100 | 0) << 1) >> 1] | 0;
            r[i >> 0] = d;
            r[i + 1 >> 0] = d >> 8;

            if (o >>> 0 > 99999999) {
              i = a;
              o = e;
            } else break;
          }
        } else a = 39;

        if ((e | 0) > 99) {
          a = a + -2 | 0;
          l = c + a | 0;
          f = n[4156 + (((e >>> 0) % 100 | 0) << 1) >> 1] | 0;
          r[l >> 0] = f;
          r[l + 1 >> 0] = f >> 8;
          e = (e >>> 0) / 100 | 0;
        }

        if ((e | 0) < 10) {
          l = a + -1 | 0;
          r[c + l >> 0] = (e & 255) + 48 << 24 >> 24;
          f = c + l | 0;
          l = 39 - l | 0;
          l = ic(t, 1, 16465, 0, f, l) | 0;
          p = u;
          return l | 0;
        } else {
          l = a + -2 | 0;
          f = c + l | 0;
          d = n[4156 + (e << 1) >> 1] | 0;
          r[f >> 0] = d;
          r[f + 1 >> 0] = d >> 8;
          f = c + l | 0;
          l = 39 - l | 0;
          l = ic(t, 1, 16465, 0, f, l) | 0;
          p = u;
          return l | 0;
        }

        return 0;
      }

      function Qi(e) {
        e = e | 0;
        return;
      }

      function ec(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        return Nc(s[e >> 2] | 0, t, a) | 0;
      }

      function tc(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0;
        d = p;
        p = p + 16 | 0;
        u = d;
        c = s[e >> 2] | 0;
        s[u >> 2] = 0;

        if (t >>> 0 < 128) {
          r[u >> 0] = t;
          e = 1;
        } else {
          do {
            if (t >>> 0 >= 2048) {
              if (t >>> 0 < 65536) {
                r[u >> 0] = t >>> 12 & 15 | -32;
                a = 63;
                n = 1;
                o = -128;
                i = 2;
                e = 3;
                break;
              } else {
                r[u >> 0] = t >>> 18 & 255 | -16;
                r[u + 1 >> 0] = t >>> 12 & 63 | -128;
                a = 63;
                n = 2;
                o = -128;
                i = 3;
                e = 4;
                break;
              }
            } else {
              a = 31;
              n = 0;
              o = -64;
              i = 1;
              e = 2;
            }
          } while (0);

          r[u + n >> 0] = a & t >>> 6 & 255 | o;
          r[u + i >> 0] = t & 63 | -128;
        }

        u = Nc(c, u, e) | 0;
        p = d;
        return u | 0;
      }

      function ac(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0;
        a = p;
        p = p + 32 | 0;
        r = a + 8 | 0;
        n = a;
        s[n >> 2] = s[e >> 2];
        s[r >> 2] = s[t >> 2];
        s[r + 4 >> 2] = s[t + 4 >> 2];
        s[r + 8 >> 2] = s[t + 8 >> 2];
        s[r + 12 >> 2] = s[t + 12 >> 2];
        s[r + 16 >> 2] = s[t + 16 >> 2];
        s[r + 20 >> 2] = s[t + 20 >> 2];
        t = rc(n, 5092, r) | 0;
        p = a;
        return t | 0;
      }

      function rc(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0,
            A = 0,
            w = 0,
            T = 0,
            x = 0;
        T = p;
        p = p + 64 | 0;
        n = T + 56 | 0;
        _ = T;
        o = s[a + 16 >> 2] | 0;
        g = s[a + 20 >> 2] | 0;
        i = o + (g << 3) | 0;
        s[_ >> 2] = 0;
        y = _ + 4 | 0;
        s[y >> 2] = 32;
        v = _ + 48 | 0;
        r[v >> 0] = 3;
        s[_ + 8 >> 2] = 0;
        s[_ + 16 >> 2] = 0;
        w = _ + 24 | 0;
        s[w >> 2] = e;
        A = _ + 28 | 0;
        s[A >> 2] = t;
        s[_ + 32 >> 2] = o;
        h = _ + 36 | 0;
        s[h >> 2] = i;
        b = _ + 40 | 0;
        s[b >> 2] = o;
        m = _ + 44 | 0;
        s[m >> 2] = g;
        e = s[a >> 2] | 0;
        g = e + (s[a + 4 >> 2] << 3) | 0;
        s[n >> 2] = e;
        s[n + 4 >> 2] = g;
        t = s[a + 8 >> 2] | 0;

        do {
          if (!t) {
            while (1) {
              if ((o | 0) == (i | 0)) {
                o = 4;
                break;
              }

              if ((e | 0) == (g | 0)) {
                e = g;
                o = 4;
                break;
              }

              v = e;
              e = e + 8 | 0;

              if (Id[s[(s[A >> 2] | 0) + 12 >> 2] & 15](s[w >> 2] | 0, s[v >> 2] | 0, s[v + 4 >> 2] | 0) | 0) {
                o = 12;
                break;
              }

              if (Gd[s[o + 4 >> 2] & 127](s[o >> 2] | 0, _) | 0) {
                o = 12;
                break;
              } else o = o + 8 | 0;
            }

            if ((o | 0) == 4) {
              s[n >> 2] = e;
              o = 6;
              break;
            } else if ((o | 0) == 12) {
              s[n >> 2] = e;
              break;
            }
          } else {
            u = t + ((s[a + 12 >> 2] | 0) * 36 | 0) | 0;
            d = _ + 8 | 0;
            f = _ + 16 | 0;
            l = _ + 32 | 0;
            c = t;

            e: while (1) {
              if ((c | 0) == (u | 0)) {
                o = 5;
                break;
              }

              i = c;
              c = c + 36 | 0;

              if ((e | 0) == (g | 0)) {
                e = g;
                o = 5;
                break;
              }

              a = e;
              e = e + 8 | 0;

              if (Id[s[(s[A >> 2] | 0) + 12 >> 2] & 15](s[w >> 2] | 0, s[a >> 2] | 0, s[a + 4 >> 2] | 0) | 0) {
                o = 13;
                break;
              }

              s[y >> 2] = s[i + 8 >> 2];
              r[v >> 0] = r[i + 32 >> 0] | 0;
              s[_ >> 2] = s[i + 12 >> 2];

              switch (s[i + 24 >> 2] & 3) {
                case 0:
                  {
                    o = s[i + 28 >> 2] | 0;
                    t = 0;
                    a = 1;
                    break;
                  }

                case 1:
                  {
                    a = s[i + 28 >> 2] | 0;
                    t = s[m >> 2] | 0;

                    if (a >>> 0 >= t >>> 0) {
                      o = 27;
                      break e;
                    }

                    o = s[b >> 2] | 0;

                    if ((s[o + (a << 3) + 4 >> 2] | 0) == 63) {
                      o = s[s[o + (a << 3) >> 2] >> 2] | 0;
                      t = 0;
                      a = 1;
                    } else {
                      o = 0;
                      t = 0;
                      a = 0;
                    }

                    break;
                  }

                case 2:
                  {
                    o = s[l >> 2] | 0;

                    if ((o | 0) != (s[h >> 2] | 0) ? (s[l >> 2] = o + 8, (s[o + 4 >> 2] | 0) == 63) : 0) {
                      o = s[s[o >> 2] >> 2] | 0;
                      t = 0;
                      a = 1;
                    } else {
                      o = 0;
                      t = 0;
                      a = 0;
                    }

                    break;
                  }

                case 3:
                  {
                    o = 0;
                    t = 0;
                    a = 0;
                    break;
                  }

                default:
                  {
                    o = 22;
                    break e;
                  }
              }

              x = d;
              s[x >> 2] = a;
              s[x + 4 >> 2] = o | t;

              switch (s[i + 16 >> 2] & 3) {
                case 0:
                  {
                    o = s[i + 20 >> 2] | 0;
                    t = 0;
                    a = 1;
                    break;
                  }

                case 1:
                  {
                    a = s[i + 20 >> 2] | 0;
                    t = s[m >> 2] | 0;

                    if (a >>> 0 >= t >>> 0) {
                      o = 37;
                      break e;
                    }

                    o = s[b >> 2] | 0;

                    if ((s[o + (a << 3) + 4 >> 2] | 0) == 63) {
                      o = s[s[o + (a << 3) >> 2] >> 2] | 0;
                      t = 0;
                      a = 1;
                    } else {
                      o = 0;
                      t = 0;
                      a = 0;
                    }

                    break;
                  }

                case 2:
                  {
                    o = s[l >> 2] | 0;

                    if ((o | 0) != (s[h >> 2] | 0) ? (s[l >> 2] = o + 8, (s[o + 4 >> 2] | 0) == 63) : 0) {
                      o = s[s[o >> 2] >> 2] | 0;
                      t = 0;
                      a = 1;
                    } else {
                      o = 0;
                      t = 0;
                      a = 0;
                    }

                    break;
                  }

                case 3:
                  {
                    o = 0;
                    t = 0;
                    a = 0;
                    break;
                  }

                default:
                  {
                    o = 32;
                    break e;
                  }
              }

              x = f;
              s[x >> 2] = a;
              s[x + 4 >> 2] = o | t;

              if ((s[i >> 2] | 0) == 1) {
                t = s[i + 4 >> 2] | 0;
                a = s[m >> 2] | 0;

                if (t >>> 0 >= a >>> 0) {
                  o = 44;
                  break;
                }

                o = (s[b >> 2] | 0) + (t << 3) | 0;
              } else {
                o = s[l >> 2] | 0;

                if ((o | 0) == (s[h >> 2] | 0)) {
                  o = 40;
                  break;
                }

                s[l >> 2] = o + 8;
              }

              if (Gd[s[o + 4 >> 2] & 127](s[o >> 2] | 0, _) | 0) {
                o = 13;
                break;
              }
            }

            if ((o | 0) == 5) {
              s[n >> 2] = e;
              o = 6;
              break;
            } else if ((o | 0) == 13) {
              s[n >> 2] = e;
              break;
            } else if ((o | 0) != 22) if ((o | 0) == 27) Yc(4380, a, t);else if ((o | 0) != 32) if ((o | 0) == 37) Yc(4380, a, t);else if ((o | 0) == 40) Kc(4396);else if ((o | 0) == 44) Yc(4420, t, a);
          }
        } while (0);

        do {
          if ((o | 0) == 6) {
            if ((e | 0) != (g | 0) ? (s[n >> 2] = e + 8, Id[s[(s[A >> 2] | 0) + 12 >> 2] & 15](s[w >> 2] | 0, s[e >> 2] | 0, s[e + 4 >> 2] | 0) | 0) : 0) break;
            x = 0;
            p = T;
            return x | 0;
          }
        } while (0);

        x = 1;
        p = T;
        return x | 0;
      }

      function nc(e, t) {
        e = e | 0;
        t = t | 0;
        return qi(e, t) | 0;
      }

      function sc(e, t) {
        e = e | 0;
        t = t | 0;
        s[e >> 2] = t;
        s[e + 4 >> 2] = 63;
        return;
      }

      function oc(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0;
        a = p;
        p = p + 32 | 0;
        r = a;
        n = s[t + 24 >> 2] | 0;
        t = s[t + 28 >> 2] | 0;
        s[r >> 2] = s[e >> 2];
        s[r + 4 >> 2] = s[e + 4 >> 2];
        s[r + 8 >> 2] = s[e + 8 >> 2];
        s[r + 12 >> 2] = s[e + 12 >> 2];
        s[r + 16 >> 2] = s[e + 16 >> 2];
        s[r + 20 >> 2] = s[e + 20 >> 2];
        t = rc(n, t, r) | 0;
        p = a;
        return t | 0;
      }

      function ic(e, t, a, n, o, i) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        n = n | 0;
        o = o | 0;
        i = i | 0;
        var c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0,
            A = 0,
            w = 0;
        w = p;
        p = p + 48 | 0;
        A = w + 28 | 0;
        v = w + 16 | 0;
        l = w + 32 | 0;
        h = w;
        f = w + 8 | 0;
        s[f >> 2] = a;
        s[f + 4 >> 2] = n;
        s[h >> 2] = 1114112;

        if (t) {
          t = s[e >> 2] | 0;

          if (!(t & 1)) {
            d = t;
            u = i;
          } else {
            s[h >> 2] = 43;
            d = t;
            u = i + 1 | 0;
          }
        } else {
          s[h >> 2] = 45;
          d = s[e >> 2] | 0;
          u = i + 1 | 0;
        }

        r[l >> 0] = 0;

        if (d & 4) {
          r[l >> 0] = 1;
          c = a + n | 0;
          if (!n) t = 0;else {
            t = 0;

            do {
              t = ((r[a >> 0] & -64) << 24 >> 24 == -128 & 1) + t | 0;
              a = a + 1 | 0;
            } while ((a | 0) != (c | 0));
          }
          u = u + n - t | 0;
        }

        s[v >> 2] = h;
        s[v + 4 >> 2] = l;
        s[v + 8 >> 2] = f;

        e: do {
          if ((s[e + 8 >> 2] | 0) == 1) {
            t = s[e + 12 >> 2] | 0;

            if (t >>> 0 <= u >>> 0) {
              if (cc(v, e) | 0) {
                g = 41;
                break;
              }

              t = Id[s[(s[e + 28 >> 2] | 0) + 12 >> 2] & 15](s[e + 24 >> 2] | 0, o, i) | 0;
              g = 38;
              break;
            }

            if (!(d & 8)) {
              t = t - u | 0;
              _ = r[e + 48 >> 0] | 0;

              switch ((_ << 24 >> 24 == 3 ? 1 : _) & 3) {
                case 0:
                  {
                    m = t;
                    b = 0;
                    break;
                  }

                case 3:
                case 1:
                  {
                    m = 0;
                    b = t;
                    break;
                  }

                case 2:
                  {
                    m = (t + 1 | 0) >>> 1;
                    b = t >>> 1;
                    break;
                  }

                default:
                  {}
              }

              s[A >> 2] = 0;
              t = s[e + 4 >> 2] | 0;

              if (t >>> 0 < 128) {
                r[A >> 0] = t;
                a = 1;
              } else {
                do {
                  if (t >>> 0 >= 2048) {
                    if (t >>> 0 < 65536) {
                      r[A >> 0] = t >>> 12 & 15 | -32;
                      a = 3;
                      c = 63;
                      u = 1;
                      d = -128;
                      n = 2;
                      break;
                    } else {
                      r[A >> 0] = t >>> 18 & 255 | -16;
                      r[A + 1 >> 0] = t >>> 12 & 63 | -128;
                      a = 4;
                      c = 63;
                      u = 2;
                      d = -128;
                      n = 3;
                      break;
                    }
                  } else {
                    a = 2;
                    c = 31;
                    u = 0;
                    d = -64;
                    n = 1;
                  }
                } while (0);

                r[A + u >> 0] = c & t >>> 6 & 255 | d;
                r[A + n >> 0] = t & 63 | -128;
              }

              c = e + 24 | 0;
              u = e + 28 | 0;
              t = 0;

              while (1) {
                if (t >>> 0 >= b >>> 0) {
                  g = 29;
                  break;
                }

                if (t >>> 0 > 4294967294) {
                  g = 29;
                  break;
                }

                if (Id[s[(s[u >> 2] | 0) + 12 >> 2] & 15](s[c >> 2] | 0, A, a) | 0) break;else t = t + 1 | 0;
              }

              t: do {
                if (((g | 0) == 29 ? !(cc(v, e) | 0) : 0) ? !(Id[s[(s[u >> 2] | 0) + 12 >> 2] & 15](s[c >> 2] | 0, o, i) | 0) : 0) {
                  t = 0;

                  while (1) {
                    if (t >>> 0 >= m >>> 0) break;
                    if (t >>> 0 > 4294967294) break;
                    if (Id[s[(s[u >> 2] | 0) + 12 >> 2] & 15](s[c >> 2] | 0, A, a) | 0) break t;else t = t + 1 | 0;
                  }

                  t = 0;
                  g = 38;
                  break e;
                }
              } while (0);

              t = 1;
              g = 38;
              break;
            } else {
              a = e + 4 | 0;
              s[a >> 2] = 48;
              c = e + 48 | 0;
              r[c >> 0] = 1;

              if (cc(v, e) | 0) {
                g = 41;
                break;
              }

              t = t - u | 0;
              v = r[c >> 0] | 0;

              switch ((v << 24 >> 24 == 3 ? 1 : v) & 3) {
                case 0:
                  {
                    y = 0;
                    _ = t;
                    break;
                  }

                case 3:
                case 1:
                  {
                    y = t;
                    _ = 0;
                    break;
                  }

                case 2:
                  {
                    y = t >>> 1;
                    _ = (t + 1 | 0) >>> 1;
                    break;
                  }

                default:
                  {}
              }

              s[A >> 2] = 0;
              t = s[a >> 2] | 0;

              if (t >>> 0 < 128) {
                r[A >> 0] = t;
                u = 1;
              } else {
                do {
                  if (t >>> 0 >= 2048) {
                    if (t >>> 0 < 65536) {
                      r[A >> 0] = t >>> 12 & 15 | -32;
                      a = 63;
                      c = 1;
                      d = -128;
                      n = 2;
                      u = 3;
                      break;
                    } else {
                      r[A >> 0] = t >>> 18 & 255 | -16;
                      r[A + 1 >> 0] = t >>> 12 & 63 | -128;
                      a = 63;
                      c = 2;
                      d = -128;
                      n = 3;
                      u = 4;
                      break;
                    }
                  } else {
                    a = 31;
                    c = 0;
                    d = -64;
                    n = 1;
                    u = 2;
                  }
                } while (0);

                r[A + c >> 0] = a & t >>> 6 & 255 | d;
                r[A + n >> 0] = t & 63 | -128;
              }

              c = e + 24 | 0;
              a = e + 28 | 0;
              t = 0;

              while (1) {
                if (t >>> 0 >= y >>> 0) {
                  g = 57;
                  break;
                }

                if (t >>> 0 > 4294967294) {
                  g = 57;
                  break;
                }

                if (Id[s[(s[a >> 2] | 0) + 12 >> 2] & 15](s[c >> 2] | 0, A, u) | 0) break;else t = t + 1 | 0;
              }

              t: do {
                if ((g | 0) == 57 ? !(Id[s[(s[a >> 2] | 0) + 12 >> 2] & 15](s[c >> 2] | 0, o, i) | 0) : 0) {
                  t = 0;

                  while (1) {
                    if (t >>> 0 >= _ >>> 0) break;
                    if (t >>> 0 > 4294967294) break;
                    if (Id[s[(s[a >> 2] | 0) + 12 >> 2] & 15](s[c >> 2] | 0, A, u) | 0) break t;else t = t + 1 | 0;
                  }

                  t = 0;
                  g = 38;
                  break e;
                }
              } while (0);

              t = 1;
              g = 38;
              break;
            }
          } else if (cc(v, e) | 0) g = 41;else {
            t = Id[s[(s[e + 28 >> 2] | 0) + 12 >> 2] & 15](s[e + 24 >> 2] | 0, o, i) | 0;
            g = 38;
          }
        } while (0);

        if ((g | 0) == 38) {
          A = t;
          p = w;
          return A | 0;
        } else if ((g | 0) == 41) {
          A = 1;
          p = w;
          return A | 0;
        }

        return 0;
      }

      function cc(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0;
        h = p;
        p = p + 16 | 0;
        d = h;
        u = s[s[e >> 2] >> 2] | 0;

        if ((u | 0) != 1114112) {
          f = s[t + 24 >> 2] | 0;
          l = s[t + 28 >> 2] | 0;
          s[d >> 2] = 0;

          if (u >>> 0 < 128) {
            r[d >> 0] = u;
            a = 1;
          } else {
            do {
              if (u >>> 0 >= 2048) {
                if (u >>> 0 < 65536) {
                  r[d >> 0] = u >>> 12 & 15 | -32;
                  n = 63;
                  o = 1;
                  i = -128;
                  c = 2;
                  a = 3;
                  break;
                } else {
                  r[d >> 0] = u >>> 18 & 255 | -16;
                  r[d + 1 >> 0] = u >>> 12 & 63 | -128;
                  n = 63;
                  o = 2;
                  i = -128;
                  c = 3;
                  a = 4;
                  break;
                }
              } else {
                n = 31;
                o = 0;
                i = -64;
                c = 1;
                a = 2;
              }
            } while (0);

            r[d + o >> 0] = n & u >>> 6 & 255 | i;
            r[d + c >> 0] = u & 63 | -128;
          }

          if (Id[s[l + 12 >> 2] & 15](f, d, a) | 0) {
            l = 1;
            p = h;
            return l | 0;
          }
        }

        if (!(r[s[e + 4 >> 2] >> 0] | 0)) {
          l = 0;
          p = h;
          return l | 0;
        }

        l = s[e + 8 >> 2] | 0;
        l = Id[s[(s[t + 28 >> 2] | 0) + 12 >> 2] & 15](s[t + 24 >> 2] | 0, s[l >> 2] | 0, s[l + 4 >> 2] | 0) | 0;
        p = h;
        return l | 0;
      }

      function uc(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0,
            A = 0;
        A = p;
        p = p + 16 | 0;
        g = A;
        m = e + 8 | 0;
        n = (s[e + 16 >> 2] | 0) == 1;
        if ((s[m >> 2] | 0) == 1) {
          if (n) v = 7;else {
            f = a;
            o = t;
          }
        } else if (n) v = 7;else {
          g = Id[s[(s[e + 28 >> 2] | 0) + 12 >> 2] & 15](s[e + 24 >> 2] | 0, t, a) | 0;
          p = A;
          return g | 0;
        }

        if ((v | 0) == 7) {
          o = s[e + 20 >> 2] | 0;
          l = t + a | 0;
          s[g >> 2] = 0;
          h = g + 4 | 0;
          s[h >> 2] = t;
          d = g + 8 | 0;
          s[d >> 2] = l;
          n = g + 12 | 0;
          s[n >> 2] = o;
          b = t;

          e: do {
            if (!o) {
              if (!a) f = 0;else {
                o = t + 1 | 0;
                s[h >> 2] = o;
                n = o;
                d = r[t >> 0] | 0;

                if (d << 24 >> 24 <= -1) {
                  f = d & 255;

                  if ((a | 0) == 1) {
                    o = 0;
                    i = l;
                  } else {
                    i = t + 2 | 0;
                    s[h >> 2] = i;
                    n = i;
                    o = r[o >> 0] & 63;
                  }

                  c = o & 255;

                  if ((d & 255) > 223) {
                    if ((i | 0) == (l | 0)) {
                      o = 0;
                      u = l;
                    } else {
                      u = i + 1 | 0;
                      s[h >> 2] = u;
                      n = u;
                      o = r[i >> 0] & 63;
                    }

                    i = o & 255 | c << 6;

                    if ((d & 255) > 239) {
                      if ((u | 0) == (l | 0)) o = 0;else {
                        n = u + 1 | 0;
                        s[h >> 2] = n;
                        o = r[u >> 0] & 63;
                      }

                      if ((i << 6 | f << 18 & 1835008 | o & 255 | 0) == 1114112) {
                        f = a;
                        break;
                      }
                    }
                  }
                }

                s[g >> 2] = n - b;
                f = 0;
              }
            } else {
              s[n >> 2] = 0;
              u = g + 4 | 0;

              if ((Cc(u) | 0) != 1114112) {
                c = s[d >> 2] | 0;
                i = s[u >> 2] | 0;
                s[g >> 2] = (s[g >> 2] | 0) + a - c + i;
                n = o;

                do {
                  if ((Cc(u) | 0) == 1114112) {
                    f = a;
                    break e;
                  }

                  n = n + -1 | 0;
                  o = s[g >> 2] | 0;
                  h = c;
                  c = s[d >> 2] | 0;
                  b = i;
                  i = s[u >> 2] | 0;
                  s[g >> 2] = h - b + o - c + i;
                } while ((n | 0) != 0);

                if (!((o | 0) == 0 | (o | 0) == (a | 0))) {
                  if (o >>> 0 >= a >>> 0) Sc(t, a, 0, o);
                  if ((r[t + o >> 0] | 0) <= -65) Sc(t, a, 0, o);else f = o;
                } else f = o;
              } else f = a;
            }
          } while (0);

          if ((s[m >> 2] | 0) == 1) o = t;else {
            g = Id[s[(s[e + 28 >> 2] | 0) + 12 >> 2] & 15](s[e + 24 >> 2] | 0, t, f) | 0;
            p = A;
            return g | 0;
          }
        }

        d = s[e + 12 >> 2] | 0;
        u = t + f | 0;
        c = (f | 0) == 0;
        if (c) n = 0;else {
          i = o;
          n = 0;

          do {
            n = ((r[i >> 0] & -64) << 24 >> 24 == -128 & 1) + n | 0;
            i = i + 1 | 0;
          } while ((i | 0) != (u | 0));
        }

        if ((f - n | 0) >>> 0 >= d >>> 0) {
          g = Id[s[(s[e + 28 >> 2] | 0) + 12 >> 2] & 15](s[e + 24 >> 2] | 0, t, f) | 0;
          p = A;
          return g | 0;
        }

        if (c) n = 0;else {
          n = 0;

          do {
            n = ((r[o >> 0] & -64) << 24 >> 24 == -128 & 1) + n | 0;
            o = o + 1 | 0;
          } while ((o | 0) != (u | 0));
        }
        n = n - f + d | 0;
        m = r[e + 48 >> 0] | 0;

        switch ((m << 24 >> 24 == 3 ? 0 : m) & 3) {
          case 0:
            {
              y = 0;
              _ = n;
              break;
            }

          case 3:
          case 1:
            {
              y = n;
              _ = 0;
              break;
            }

          case 2:
            {
              y = n >>> 1;
              _ = (n + 1 | 0) >>> 1;
              break;
            }

          default:
            {}
        }

        s[g >> 2] = 0;
        n = s[e + 4 >> 2] | 0;

        if (n >>> 0 < 128) {
          r[g >> 0] = n;
          c = 1;
        } else {
          do {
            if (n >>> 0 >= 2048) {
              if (n >>> 0 < 65536) {
                r[g >> 0] = n >>> 12 & 15 | -32;
                o = 63;
                i = 1;
                u = -128;
                d = 2;
                c = 3;
                break;
              } else {
                r[g >> 0] = n >>> 18 & 255 | -16;
                r[g + 1 >> 0] = n >>> 12 & 63 | -128;
                o = 63;
                i = 2;
                u = -128;
                d = 3;
                c = 4;
                break;
              }
            } else {
              o = 31;
              i = 0;
              u = -64;
              d = 1;
              c = 2;
            }
          } while (0);

          r[g + i >> 0] = o & n >>> 6 & 255 | u;
          r[g + d >> 0] = n & 63 | -128;
        }

        i = e + 24 | 0;
        o = e + 28 | 0;
        n = 0;

        while (1) {
          if (n >>> 0 >= y >>> 0) {
            v = 47;
            break;
          }

          if (n >>> 0 > 4294967294) {
            v = 47;
            break;
          }

          if (Id[s[(s[o >> 2] | 0) + 12 >> 2] & 15](s[i >> 2] | 0, g, c) | 0) break;else n = n + 1 | 0;
        }

        e: do {
          if ((v | 0) == 47 ? !(Id[s[(s[o >> 2] | 0) + 12 >> 2] & 15](s[i >> 2] | 0, t, f) | 0) : 0) {
            n = 0;

            while (1) {
              if (n >>> 0 >= _ >>> 0) break;
              if (n >>> 0 > 4294967294) break;
              if (Id[s[(s[o >> 2] | 0) + 12 >> 2] & 15](s[i >> 2] | 0, g, c) | 0) break e;else n = n + 1 | 0;
            }

            g = 0;
            p = A;
            return g | 0;
          }
        } while (0);

        g = 1;
        p = A;
        return g | 0;
      }

      function dc(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        return Id[s[(s[e + 28 >> 2] | 0) + 12 >> 2] & 15](s[e + 24 >> 2] | 0, t, a) | 0;
      }

      function fc(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0;
        a = p;
        p = p + 32 | 0;
        r = a;
        n = s[e + 24 >> 2] | 0;
        e = s[e + 28 >> 2] | 0;
        s[r >> 2] = s[t >> 2];
        s[r + 4 >> 2] = s[t + 4 >> 2];
        s[r + 8 >> 2] = s[t + 8 >> 2];
        s[r + 12 >> 2] = s[t + 12 >> 2];
        s[r + 16 >> 2] = s[t + 16 >> 2];
        s[r + 20 >> 2] = s[t + 20 >> 2];
        t = rc(n, e, r) | 0;
        p = a;
        return t | 0;
      }

      function lc(e) {
        e = e | 0;
        return (s[e >> 2] & 4 | 0) != 0 | 0;
      }

      function hc(e, t, a, n) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        n = n | 0;
        n = Id[s[(s[t + 28 >> 2] | 0) + 12 >> 2] & 15](s[t + 24 >> 2] | 0, a, n) | 0;
        s[e >> 2] = t;
        r[e + 4 >> 0] = n & 1;
        r[e + 5 >> 0] = 0;
        return;
      }

      function pc(e, t, a, n) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        n = n | 0;
        a = Id[s[(s[t + 28 >> 2] | 0) + 12 >> 2] & 15](s[t + 24 >> 2] | 0, a, n) | 0;
        s[e >> 2] = t;
        r[e + 8 >> 0] = a & 1;
        s[e + 4 >> 2] = 0;
        r[e + 9 >> 0] = (n | 0) == 0 & 1;
        return;
      }

      function bc(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            n = 0,
            o = 0,
            i = 0;
        a = p;
        p = p + 32 | 0;
        n = a;
        i = s[t + 24 >> 2] | 0;
        o = s[t + 28 >> 2] | 0;
        s[n >> 2] = 5084;
        s[n + 4 >> 2] = 1;
        s[n + 8 >> 2] = 0;
        s[n + 16 >> 2] = 15892;
        s[n + 20 >> 2] = 0;
        n = (rc(i, o, n) | 0) & 1;
        s[e >> 2] = t;
        r[e + 4 >> 0] = n;
        r[e + 5 >> 0] = 0;
        p = a;
        return;
      }

      function mc(e, t) {
        e = e | 0;
        t = t | 0;
        return Gd[s[(s[e + 28 >> 2] | 0) + 16 >> 2] & 127](s[e + 24 >> 2] | 0, t) | 0;
      }

      function yc(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            p = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0,
            A = 0,
            w = 0;
        _ = a + 24 | 0;
        y = a + 28 | 0;

        if (Gd[s[(s[y >> 2] | 0) + 16 >> 2] & 127](s[_ >> 2] | 0, 34) | 0) {
          w = 1;
          return w | 0;
        }

        b = e + t | 0;
        m = b;

        do {
          if (t) {
            a = e + 1 | 0;
            n = a;
            u = r[e >> 0] | 0;

            if (u << 24 >> 24 <= -1) {
              d = u & 31;

              if ((t | 0) == 1) {
                a = 0;
                o = b;
              } else {
                o = e + 2 | 0;
                n = o;
                a = r[a >> 0] & 63;
              }

              i = a & 255;
              a = i | d << 6;

              if ((u & 255) > 223) {
                if ((o | 0) == (b | 0)) {
                  a = 0;
                  c = b;
                } else {
                  c = o + 1 | 0;
                  n = c;
                  a = r[o >> 0] & 63;
                }

                o = a & 255 | i << 6;
                a = o | d << 12;

                if ((u & 255) > 239) {
                  if ((c | 0) == (b | 0)) a = 0;else {
                    n = c + 1 | 0;
                    a = r[c >> 0] & 63;
                  }
                  a = o << 6 | d << 18 & 1835008 | a & 255;

                  if ((a | 0) == 1114112) {
                    a = 0;
                    w = 17;
                    break;
                  }
                }
              }
            } else a = u & 255;

            p = n;
            o = n + t | 0;
            n = a;
            l = 0;
            a = 0;

            e: while (1) {
              h = o - m | 0;

              switch (n & 2097151 | 0) {
                case 9:
                  {
                    f = 116;
                    o = 2;
                    c = 0;
                    u = 0;
                    break;
                  }

                case 13:
                  {
                    f = 114;
                    o = 2;
                    c = 0;
                    u = 0;
                    break;
                  }

                case 10:
                  {
                    f = 110;
                    o = 2;
                    c = 0;
                    u = 0;
                    break;
                  }

                case 34:
                case 39:
                case 92:
                  {
                    f = n;
                    o = 2;
                    c = 0;
                    u = 0;
                    break;
                  }

                default:
                  if (cu(n) | 0) {
                    f = n;
                    o = 1;
                    c = 0;
                    u = 0;
                  } else {
                    f = n;
                    o = 3;
                    c = 5;
                    u = (z(n | 1 | 0) | 0) >>> 2 ^ 7;
                  }

              }

              switch (o & 3) {
                case 2:
                case 0:
                  {
                    w = 38;
                    break;
                  }

                case 1:
                  break;

                case 3:
                  {
                    switch (c & 7) {
                      case 0:
                        {
                          i = 0;
                          break;
                        }

                      case 1:
                        {
                          i = 1;
                          break;
                        }

                      case 2:
                        {
                          i = 2;
                          break;
                        }

                      case 3:
                        {
                          i = 3;
                          break;
                        }

                      case 4:
                        {
                          i = 4;
                          break;
                        }

                      case 5:
                        {
                          i = 5;
                          break;
                        }

                      default:
                        {
                          w = 36;
                          break e;
                        }
                    }

                    if ((i + u | 0) != 1) w = 38;
                    break;
                  }

                default:
                  {
                    w = 29;
                    break e;
                  }
              }

              if ((w | 0) == 38) {
                w = 0;

                if (l >>> 0 < a >>> 0) {
                  w = 45;
                  break;
                }

                if (!((a | 0) == 0 | (a | 0) == (t | 0))) {
                  if (a >>> 0 >= t >>> 0) {
                    w = 45;
                    break;
                  }

                  if ((r[e + a >> 0] | 0) <= -65) {
                    w = 45;
                    break;
                  }
                }

                if (!((l | 0) == 0 | (l | 0) == (t | 0))) {
                  if (l >>> 0 >= t >>> 0) {
                    w = 45;
                    break;
                  }

                  if ((r[e + l >> 0] | 0) <= -65) {
                    w = 45;
                    break;
                  }
                }

                if (Id[s[(s[y >> 2] | 0) + 12 >> 2] & 15](s[_ >> 2] | 0, e + a | 0, l - a | 0) | 0) {
                  a = 1;
                  w = 15;
                  break;
                }

                d = (f | 0) == 1114112;
                i = u;

                t: while (1) {
                  a: do {
                    switch (o & 3) {
                      case 0:
                        break t;

                      case 1:
                        {
                          if (d) break t;else {
                            a = f;
                            o = 0;
                          }
                          break;
                        }

                      case 2:
                        {
                          a = 92;
                          o = 1;
                          break;
                        }

                      case 3:
                        switch (c & 7) {
                          case 0:
                            break t;

                          case 1:
                            {
                              a = 125;
                              c = c & -256;
                              break a;
                            }

                          case 2:
                            {
                              a = f >>> (i << 2 & 28) & 15;
                              a = ((a & 255) < 10 ? 48 : 87) + a | 0;

                              if (!i) {
                                c = c & -256 | 1;
                                break a;
                              } else {
                                i = i + -1 | 0;
                                break a;
                              }
                            }

                          case 3:
                            {
                              a = 123;
                              c = c & -256 | 2;
                              break a;
                            }

                          case 4:
                            {
                              a = 117;
                              c = c & -256 | 3;
                              break a;
                            }

                          case 5:
                            {
                              a = 92;
                              c = c & -256 | 4;
                              break a;
                            }

                          default:
                            {
                              w = 56;
                              break e;
                            }
                        }

                      default:
                        {
                          w = 49;
                          break e;
                        }
                    }
                  } while (0);

                  if (Gd[s[(s[y >> 2] | 0) + 16 >> 2] & 127](s[_ >> 2] | 0, a) | 0) {
                    a = 1;
                    w = 15;
                    break e;
                  }
                }

                a = (n >>> 0 < 128 ? 1 : n >>> 0 < 2048 ? 2 : n >>> 0 < 65536 ? 3 : 4) + l | 0;
              }

              n = p;

              if ((n | 0) == (b | 0)) {
                w = 16;
                break;
              }

              o = n + 1 | 0;
              i = o;

              if (!p) {
                w = 16;
                break;
              }

              u = r[n >> 0] | 0;

              if (u << 24 >> 24 <= -1) {
                d = u & 31;

                if ((o | 0) == (b | 0)) {
                  n = 0;
                  c = b;
                  o = i;
                } else {
                  l = n + 2 | 0;
                  n = r[o >> 0] & 63;
                  c = l;
                  o = l;
                }

                i = n & 255;
                n = i | d << 6;

                if ((u & 255) > 223) {
                  if ((c | 0) == (b | 0)) {
                    n = 0;
                    c = b;
                  } else {
                    o = c + 1 | 0;
                    n = r[c >> 0] & 63;
                    c = o;
                  }

                  i = n & 255 | i << 6;
                  n = i | d << 12;

                  if ((u & 255) > 239) {
                    if ((c | 0) == (b | 0)) n = 0;else {
                      n = r[c >> 0] & 63;
                      o = c + 1 | 0;
                    }
                    n = i << 6 | d << 18 & 1835008 | n & 255;

                    if ((n | 0) == 1114112) {
                      w = 16;
                      break;
                    }
                  }
                }
              } else {
                o = i;
                n = u & 255;
              }

              l = m - p + h + o | 0;
              p = o;
              o = l;
              l = h;
            }

            if ((w | 0) == 15) return a | 0;else if ((w | 0) == 16) {
              if ((a | 0) == 0 | (a | 0) == (t | 0)) {
                w = 17;
                break;
              }

              if (a >>> 0 >= t >>> 0) Sc(e, t, a, t);
              n = e + a | 0;

              if ((r[n >> 0] | 0) > -65) {
                g = a;
                A = y;
                v = n;
                break;
              }

              Sc(e, t, a, t);
            } else if ((w | 0) != 29) if ((w | 0) != 36) if ((w | 0) == 45) Sc(e, t, a, l);
          } else {
            a = 0;
            w = 17;
          }
        } while (0);

        if ((w | 0) == 17) {
          g = a;
          A = y;
          v = e + a | 0;
        }

        if (Id[s[(s[A >> 2] | 0) + 12 >> 2] & 15](s[_ >> 2] | 0, v, t - g | 0) | 0) {
          w = 1;
          return w | 0;
        }

        w = Gd[s[(s[y >> 2] | 0) + 16 >> 2] & 127](s[_ >> 2] | 0, 34) | 0;
        return w | 0;
      }

      function vc(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        return uc(a, e, t) | 0;
      }

      function _c(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0;
        i = t + 24 | 0;
        o = t + 28 | 0;

        if (Gd[s[(s[o >> 2] | 0) + 16 >> 2] & 127](s[i >> 2] | 0, 39) | 0) {
          i = 1;
          return i | 0;
        }

        t = s[e >> 2] | 0;

        switch (t & 2097151 | 0) {
          case 9:
            {
              n = 116;
              a = 0;
              e = 0;
              t = 2;
              break;
            }

          case 13:
            {
              n = 114;
              a = 0;
              e = 0;
              t = 2;
              break;
            }

          case 10:
            {
              n = 110;
              a = 0;
              e = 0;
              t = 2;
              break;
            }

          case 34:
          case 39:
          case 92:
            {
              n = t;
              a = 0;
              e = 0;
              t = 2;
              break;
            }

          default:
            if (cu(t) | 0) {
              n = t;
              a = 0;
              e = 0;
              t = 1;
            } else {
              n = t;
              a = (z(t | 1 | 0) | 0) >>> 2 ^ 7;
              e = 5;
              t = 3;
            }

        }

        r = e;

        e: while (1) {
          t: do {
            switch (t & 3) {
              case 0:
                {
                  e = 22;
                  break e;
                }

              case 1:
                {
                  e = n;
                  t = 0;
                  break;
                }

              case 2:
                {
                  e = 92;
                  t = 1;
                  break;
                }

              case 3:
                switch (r & 7) {
                  case 0:
                    {
                      e = 22;
                      break e;
                    }

                  case 1:
                    {
                      e = 125;
                      r = r & -256;
                      break t;
                    }

                  case 2:
                    {
                      e = n >>> (a << 2 & 28) & 15;
                      e = ((e & 255) < 10 ? 48 : 87) + e | 0;

                      if (!a) {
                        r = r & -256 | 1;
                        break t;
                      } else {
                        a = a + -1 | 0;
                        break t;
                      }
                    }

                  case 3:
                    {
                      e = 123;
                      r = r & -256 | 2;
                      break t;
                    }

                  case 4:
                    {
                      e = 117;
                      r = r & -256 | 3;
                      break t;
                    }

                  case 5:
                    {
                      e = 92;
                      r = r & -256 | 4;
                      break t;
                    }

                  default:
                    {
                      e = 19;
                      break e;
                    }
                }

              default:
                {
                  e = 11;
                  break e;
                }
            }
          } while (0);

          if (Gd[s[(s[o >> 2] | 0) + 16 >> 2] & 127](s[i >> 2] | 0, e) | 0) {
            t = 1;
            e = 9;
            break;
          }
        }

        if ((e | 0) == 9) return t | 0;else if ((e | 0) != 11) if ((e | 0) != 19) if ((e | 0) == 22) {
          i = Gd[s[(s[o >> 2] | 0) + 16 >> 2] & 127](s[i >> 2] | 0, 39) | 0;
          return i | 0;
        }
        return 0;
      }

      function gc(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0;
        d = p;
        p = p + 16 | 0;
        u = d;

        if ((s[t + 8 >> 2] | 0) != 1 ? (s[t + 16 >> 2] | 0) != 1 : 0) {
          u = Gd[s[(s[t + 28 >> 2] | 0) + 16 >> 2] & 127](s[t + 24 >> 2] | 0, s[e >> 2] | 0) | 0;
          p = d;
          return u | 0;
        }

        a = s[e >> 2] | 0;
        s[u >> 2] = 0;

        if (a >>> 0 < 128) {
          r[u >> 0] = a;
          e = 1;
        } else {
          do {
            if (a >>> 0 >= 2048) {
              if (a >>> 0 < 65536) {
                r[u >> 0] = a >>> 12 & 15 | -32;
                n = 63;
                o = 1;
                i = -128;
                c = 2;
                e = 3;
                break;
              } else {
                r[u >> 0] = a >>> 18 & 255 | -16;
                r[u + 1 >> 0] = a >>> 12 & 63 | -128;
                n = 63;
                o = 2;
                i = -128;
                c = 3;
                e = 4;
                break;
              }
            } else {
              n = 31;
              o = 0;
              i = -64;
              c = 1;
              e = 2;
            }
          } while (0);

          r[u + o >> 0] = n & a >>> 6 & 255 | i;
          r[u + c >> 0] = a & 63 | -128;
        }

        u = uc(t, u, e) | 0;
        p = d;
        return u | 0;
      }

      function Ac(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            o = 0,
            i = 0,
            c = 0;
        c = p;
        p = p + 48 | 0;
        o = c;
        e = r[s[e >> 2] >> 0] | 0;
        a = e & 255;
        if ((e & 255) <= 99) {
          if ((e & 255) < 10) {
            e = 38;
            i = 4;
          } else {
            e = o + 37 | 0;
            a = n[4156 + (a << 1) >> 1] | 0;
            r[e >> 0] = a;
            r[e + 1 >> 0] = a >> 8;
            e = 37;
          }
        } else {
          a = o + 37 | 0;
          i = n[4156 + (((e & 255) % 100 | 0) << 1 & 255) >> 1] | 0;
          r[a >> 0] = i;
          r[a + 1 >> 0] = i >> 8;
          a = ((e & 255) / 100 | 0) & 255;
          e = 36;
          i = 4;
        }
        if ((i | 0) == 4) r[o + e >> 0] = (a & 255) + 48 << 24 >> 24;
        i = ic(t, 1, 16465, 0, o + e | 0, 39 - e | 0) | 0;
        p = c;
        return i | 0;
      }

      function wc(e, t) {
        e = e | 0;
        t = t | 0;
        return qi(s[e >> 2] | 0, t) | 0;
      }

      function Tc(e, t) {
        e = e | 0;
        t = t | 0;
        return uc(t, s[e >> 2] | 0, s[e + 4 >> 2] | 0) | 0;
      }

      function xc(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0;
        o = p;
        p = p + 16 | 0;
        n = o;
        Dc(n, t, a);
        r = s[n >> 2] | 0;
        n = s[n + 4 >> 2] | 0;

        if (0 == 0 & (n & 255 | 0) == 2) {
          s[e >> 2] = 0;
          s[e + 4 >> 2] = t;
          s[e + 8 >> 2] = a;
          p = o;
          return;
        } else {
          s[e >> 2] = 1;
          a = e + 4 | 0;
          s[a >> 2] = r;
          s[a + 4 >> 2] = n;
          p = o;
          return;
        }
      }

      function Dc(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0;
        u = a >>> 0 > 7 ? a + -7 | 0 : 0;

        e: do {
          if (a | 0) {
            c = 0;

            t: while (1) {
              n = t + c | 0;
              i = r[n >> 0] | 0;

              a: do {
                if (i << 24 >> 24 >= 0) {
                  if ((n & 3 | 4 | 0) != 4) {
                    n = c + 1 | 0;
                    break;
                  }

                  r: do {
                    if (c >>> 0 < u >>> 0) {
                      n = c;

                      do {
                        c = t + n | 0;
                        if ((s[c + 4 >> 2] | s[c >> 2]) & -2139062144 | 0) break r;
                        n = n + 8 | 0;
                      } while (n >>> 0 < u >>> 0);
                    } else n = c;
                  } while (0);

                  if (n >>> 0 < a >>> 0) do {
                    if ((r[t + n >> 0] | 0) <= -1) break a;
                    n = n + 1 | 0;
                  } while (n >>> 0 < a >>> 0);
                } else {
                  switch (r[11498 + (i & 255) >> 0] | 0) {
                    case 2:
                      {
                        n = c + 1 | 0;

                        if (n >>> 0 >= a >>> 0) {
                          n = 12;
                          break t;
                        }

                        if ((r[t + n >> 0] & -64) << 24 >> 24 != -128) {
                          n = 15;
                          break t;
                        }

                        break;
                      }

                    case 3:
                      {
                        n = c + 1 | 0;

                        if (n >>> 0 >= a >>> 0) {
                          n = 16;
                          break t;
                        }

                        n = r[t + n >> 0] | 0;
                        o = (n & 255) < 192;

                        if (((!(i << 24 >> 24 == -32 & (n & -32) << 24 >> 24 == -96) ? (d = n << 24 >> 24 < 0, !(o & ((i + 31 & 255) < 12 & d))) : 0) ? !((n & 255) < 160 & (i << 24 >> 24 == -19 & d)) : 0) ? !(o & ((i & -2) << 24 >> 24 == -18 & d)) : 0) {
                          n = 19;
                          break t;
                        }

                        n = c + 2 | 0;

                        if (n >>> 0 >= a >>> 0) {
                          n = 23;
                          break t;
                        }

                        if ((r[t + n >> 0] & -64) << 24 >> 24 != -128) {
                          n = 25;
                          break t;
                        }

                        break;
                      }

                    case 4:
                      {
                        n = c + 1 | 0;

                        if (n >>> 0 >= a >>> 0) {
                          n = 26;
                          break t;
                        }

                        n = r[t + n >> 0] | 0;

                        if ((!(i << 24 >> 24 == -16 & (n + 112 & 255) < 48) ? (f = n << 24 >> 24 < 0, !((n & 255) < 192 & ((i + 15 & 255) < 3 & f))) : 0) ? !((n & 255) < 144 & (i << 24 >> 24 == -12 & f)) : 0) {
                          n = 29;
                          break t;
                        }

                        n = c + 2 | 0;

                        if (n >>> 0 >= a >>> 0) {
                          n = 32;
                          break t;
                        }

                        if ((r[t + n >> 0] & -64) << 24 >> 24 != -128) {
                          n = 34;
                          break t;
                        }

                        n = c + 3 | 0;

                        if (n >>> 0 >= a >>> 0) {
                          n = 36;
                          break t;
                        }

                        if ((r[t + n >> 0] & -64) << 24 >> 24 != -128) {
                          n = 38;
                          break t;
                        }

                        break;
                      }

                    default:
                      {
                        n = 10;
                        break t;
                      }
                  }

                  n = n + 1 | 0;
                }
              } while (0);

              if (n >>> 0 < a >>> 0) c = n;else break e;
            }

            switch (n | 0) {
              case 10:
                {
                  s[e >> 2] = c;
                  r[e + 4 >> 0] = 1;
                  r[e + 5 >> 0] = 1;
                  return;
                }

              case 12:
                {
                  s[e >> 2] = c;
                  r[e + 4 >> 0] = 0;
                  return;
                }

              case 15:
                {
                  s[e >> 2] = c;
                  r[e + 4 >> 0] = 1;
                  r[e + 5 >> 0] = 1;
                  return;
                }

              case 16:
                {
                  s[e >> 2] = c;
                  r[e + 4 >> 0] = 0;
                  return;
                }

              case 19:
                {
                  s[e >> 2] = c;
                  r[e + 4 >> 0] = 1;
                  r[e + 5 >> 0] = 1;
                  return;
                }

              case 23:
                {
                  s[e >> 2] = c;
                  r[e + 4 >> 0] = 0;
                  return;
                }

              case 25:
                {
                  s[e >> 2] = c;
                  r[e + 4 >> 0] = 1;
                  r[e + 5 >> 0] = 2;
                  return;
                }

              case 26:
                {
                  s[e >> 2] = c;
                  r[e + 4 >> 0] = 0;
                  return;
                }

              case 29:
                {
                  s[e >> 2] = c;
                  r[e + 4 >> 0] = 1;
                  r[e + 5 >> 0] = 1;
                  return;
                }

              case 32:
                {
                  s[e >> 2] = c;
                  r[e + 4 >> 0] = 0;
                  return;
                }

              case 34:
                {
                  s[e >> 2] = c;
                  r[e + 4 >> 0] = 1;
                  r[e + 5 >> 0] = 2;
                  return;
                }

              case 36:
                {
                  s[e >> 2] = c;
                  r[e + 4 >> 0] = 0;
                  return;
                }

              case 38:
                {
                  s[e >> 2] = c;
                  r[e + 4 >> 0] = 1;
                  r[e + 5 >> 0] = 3;
                  return;
                }
            }
          }
        } while (0);

        r[e + 4 >> 0] = 2;
        return;
      }

      function Cc(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0;
        t = s[e >> 2] | 0;
        i = s[e + 4 >> 2] | 0;

        if ((t | 0) == (i | 0)) {
          u = 1114112;
          return u | 0;
        }

        a = t + 1 | 0;
        s[e >> 2] = a;
        c = r[t >> 0] | 0;

        if (c << 24 >> 24 > -1) {
          u = c & 255;
          return u | 0;
        }

        u = c & 31;

        if ((a | 0) == (i | 0)) {
          t = 0;
          a = i;
        } else {
          o = t + 2 | 0;
          s[e >> 2] = o;
          t = r[a >> 0] & 63;
          a = o;
        }

        n = t & 255;

        if ((c & 255) <= 223) {
          u = n | u << 6;
          return u | 0;
        }

        if ((a | 0) == (i | 0)) {
          t = 0;
          o = i;
        } else {
          o = a + 1 | 0;
          s[e >> 2] = o;
          t = r[a >> 0] & 63;
        }

        a = t & 255 | n << 6;

        if ((c & 255) <= 239) {
          u = a | u << 12;
          return u | 0;
        }

        if ((o | 0) == (i | 0)) t = 0;else {
          s[e >> 2] = o + 1;
          t = r[o >> 0] & 63;
        }
        u = a << 6 | u << 18 & 1835008 | t & 255;
        return u | 0;
      }

      function Sc(e, t, a, n) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        n = n | 0;
        var o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0;
        u = p;
        p = p + 112 | 0;
        b = u + 64 | 0;
        m = u + 40 | 0;
        y = u + 32 | 0;
        v = u + 28 | 0;
        _ = u + 24 | 0;
        g = u + 8 | 0;
        l = u;
        c = u + 20 | 0;
        u = u + 16 | 0;
        s[u >> 2] = a;
        s[c >> 2] = n;

        e: do {
          if (t >>> 0 < 257) {
            o = t;
            i = 0;
          } else {
            o = 256;

            while (1) {
              if (o >>> 0 < t >>> 0 ? (r[e + o >> 0] | 0) > -65 : 0) {
                i = 1;
                break e;
              }

              o = o + -1 | 0;

              if ((o | 0) == 0 | (o | 0) == (t | 0)) {
                i = 1;
                break;
              }
            }
          }
        } while (0);

        s[l >> 2] = e;
        s[l + 4 >> 2] = o;
        s[g >> 2] = i ? 11754 : 16465;
        s[g + 4 >> 2] = i ? 5 : 0;
        o = a >>> 0 > t >>> 0;

        if (o | n >>> 0 > t >>> 0) {
          s[y >> 2] = o ? a : n;
          s[b >> 2] = y;
          s[b + 4 >> 2] = 39;
          s[b + 8 >> 2] = l;
          s[b + 12 >> 2] = 64;
          s[b + 16 >> 2] = g;
          s[b + 20 >> 2] = 64;
          s[m >> 2] = 4436;
          s[m + 4 >> 2] = 3;
          s[m + 8 >> 2] = 4460;
          s[m + 12 >> 2] = 3;
          s[m + 16 >> 2] = b;
          s[m + 20 >> 2] = 3;
          qc(m, 4568);
        }

        if (a >>> 0 > n >>> 0) {
          s[b >> 2] = u;
          s[b + 4 >> 2] = 39;
          s[b + 8 >> 2] = c;
          s[b + 12 >> 2] = 39;
          s[b + 16 >> 2] = l;
          s[b + 20 >> 2] = 64;
          s[b + 24 >> 2] = g;
          s[b + 28 >> 2] = 64;
          s[m >> 2] = 4584;
          s[m + 4 >> 2] = 4;
          s[m + 8 >> 2] = 4616;
          s[m + 12 >> 2] = 4;
          s[m + 16 >> 2] = b;
          s[m + 20 >> 2] = 4;
          qc(m, 4760);
        }

        if (!((a | 0) == 0 | (a | 0) == (t | 0))) {
          if (a >>> 0 < t >>> 0 ? (r[e + a >> 0] | 0) > -65 : 0) d = 12;
        } else d = 12;

        if ((d | 0) == 12) a = n;
        s[_ >> 2] = a;
        o = (a | 0) == 0;

        e: do {
          if (o | (a | 0) == (t | 0)) {
            d = a;
            a = o;
          } else while (1) {
            if (a >>> 0 < t >>> 0 ? (r[e + a >> 0] | 0) > -65 : 0) {
              d = a;
              a = 0;
              break e;
            }

            a = a + -1 | 0;
            o = (a | 0) == 0;

            if (o | (a | 0) == (t | 0)) {
              d = a;
              a = o;
              break;
            }
          }
        } while (0);

        if (!(a | (d | 0) == (t | 0))) {
          if (d >>> 0 >= t >>> 0) Sc(e, t, d, t);
          a = e + d | 0;
          if ((r[a >> 0] | 0) > -65) f = a;else Sc(e, t, d, t);
        } else f = e + d | 0;

        n = e + d + (t - d) | 0;
        t = (f | 0) == (n | 0);
        o = t ? f : e + d + 1 | 0;
        if (t) Kc(4776);
        c = r[f >> 0] | 0;

        if (c << 24 >> 24 <= -1) {
          u = c & 31;

          if ((o | 0) == (n | 0)) {
            a = 0;
            i = n;
          } else {
            a = r[o >> 0] & 63;
            i = o + 1 | 0;
          }

          o = a & 255;
          a = o | u << 6;

          if ((c & 255) > 223) {
            if ((i | 0) == (n | 0)) {
              a = 0;
              i = n;
            } else {
              a = r[i >> 0] & 63;
              i = i + 1 | 0;
            }

            o = a & 255 | o << 6;
            a = o | u << 12;

            if ((c & 255) > 239) {
              if ((i | 0) == (n | 0)) a = 0;else a = r[i >> 0] & 63;
              a = o << 6 | u << 18 & 1835008 | a & 255;
              if ((a | 0) == 1114112) Kc(4776);else h = a;
            } else h = a;
          } else h = a;
        } else h = c & 255;

        s[v >> 2] = h;
        s[y >> 2] = d;
        s[y + 4 >> 2] = (h >>> 0 < 128 ? 1 : h >>> 0 < 2048 ? 2 : h >>> 0 < 65536 ? 3 : 4) + d;
        s[b >> 2] = _;
        s[b + 4 >> 2] = 39;
        s[b + 8 >> 2] = v;
        s[b + 12 >> 2] = 65;
        s[b + 16 >> 2] = y;
        s[b + 20 >> 2] = 66;
        s[b + 24 >> 2] = l;
        s[b + 28 >> 2] = 64;
        s[b + 32 >> 2] = g;
        s[b + 36 >> 2] = 64;
        s[m >> 2] = 4800;
        s[m + 4 >> 2] = 5;
        s[m + 8 >> 2] = 4840;
        s[m + 12 >> 2] = 5;
        s[m + 16 >> 2] = b;
        s[m + 20 >> 2] = 5;
        qc(m, 5020);
      }

      function Ec(e, t, a, n) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        n = n | 0;
        var o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0,
            A = 0;
        A = p;
        p = p + 48 | 0;
        v = A + 32 | 0;
        _ = A;
        s[v >> 2] = 0;

        if (n >>> 0 < 128) {
          r[v >> 0] = n;
          o = 1;
        } else {
          d = n >>> 0 < 2048;

          do {
            if (!d) {
              if (n >>> 0 < 65536) {
                r[v >> 0] = n >>> 12 & 15 | -32;
                o = 63;
                i = 1;
                c = -128;
                u = 2;
                break;
              } else {
                r[v >> 0] = n >>> 18 & 255 | -16;
                r[v + 1 >> 0] = n >>> 12 & 63 | -128;
                o = 63;
                i = 2;
                c = -128;
                u = 3;
                break;
              }
            } else {
              o = 31;
              i = 0;
              c = -64;
              u = 1;
            }
          } while (0);

          r[v + i >> 0] = o & n >>> 6 & 255 | c;
          r[v + u >> 0] = n & 63 | -128;
          o = d ? 2 : n >>> 0 < 65536 ? 3 : 4;
        }

        h = s[v >> 2] | 0;
        s[_ >> 2] = t;
        b = _ + 4 | 0;
        s[b >> 2] = a;
        m = _ + 8 | 0;
        s[m >> 2] = 0;
        y = _ + 12 | 0;
        s[y >> 2] = a;
        s[_ + 16 >> 2] = n;
        f = _ + 20 | 0;
        s[f >> 2] = o;
        l = _ + 24 | 0;
        s[l >> 2] = h;
        h = v + 4 | 0;
        zc(v, r[o + -1 + (_ + 24) >> 0] | 0, t, a);

        do {
          if ((s[v >> 2] | 0) == 1) {
            i = 0;
            u = 0;

            while (1) {
              t = (s[h >> 2] | 0) + 1 + i | 0;
              s[m >> 2] = t;

              if (t >>> 0 >= o >>> 0) {
                n = t - o | 0;
                c = s[b >> 2] | 0;
                a = t >>> 0 < n >>> 0 | c >>> 0 < t >>> 0;
                i = (s[_ >> 2] | 0) + n | 0;
                d = a ? u : o;

                if (!a) {
                  if (o >>> 0 > 4) {
                    i = 14;
                    break;
                  }

                  if ((d | 0) == (o | 0)) {
                    if ((i | 0) == (l | 0)) {
                      i = 23;
                      break;
                    }

                    if (!(Vu(i, l, o) | 0)) {
                      i = 23;
                      break;
                    } else u = o;
                  } else u = o;
                }
              } else c = s[b >> 2] | 0;

              i = s[y >> 2] | 0;

              if (i >>> 0 < t >>> 0 | c >>> 0 < i >>> 0) {
                o = 0;
                i = 24;
                break;
              }

              zc(v, r[o + -1 + (_ + 24) >> 0] | 0, (s[_ >> 2] | 0) + t | 0, i - t | 0);

              if ((s[v >> 2] | 0) != 1) {
                i = 21;
                break;
              }

              i = s[m >> 2] | 0;
              o = s[f >> 2] | 0;
            }

            if ((i | 0) == 14) ru(o, 4);else if ((i | 0) == 21) {
              g = s[y >> 2] | 0;
              break;
            } else if ((i | 0) == 23) {
              s[e + 4 >> 2] = n;
              g = 1;
              s[e >> 2] = g;
              p = A;
              return;
            } else if ((i | 0) == 24) {
              s[e >> 2] = o;
              p = A;
              return;
            }
          } else g = a;
        } while (0);

        s[m >> 2] = g;
        g = 0;
        s[e >> 2] = g;
        p = A;
        return;
      }

      function Bc(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0;
        o = p;
        p = p + 16 | 0;
        c = o + 8 | 0;
        n = o;
        i = Id[s[(s[t + 28 >> 2] | 0) + 12 >> 2] & 15](s[t + 24 >> 2] | 0, 11985, 9) | 0;
        s[n >> 2] = t;
        a = n + 4 | 0;
        r[a >> 0] = i & 1;
        i = n + 5 | 0;
        r[i >> 0] = 0;
        s[c >> 2] = e;
        Mc(n, 11994, 11, c, 5036) | 0;
        s[c >> 2] = e + 4;
        Mc(n, 12005, 9, c, 5052) | 0;
        t = r[a >> 0] | 0;

        if (!(r[i >> 0] | 0)) {
          c = t;
          c = c << 24 >> 24 != 0;
          p = o;
          return c | 0;
        }

        if (!(t << 24 >> 24)) {
          t = s[n >> 2] | 0;
          t = (Id[s[(s[t + 28 >> 2] | 0) + 12 >> 2] & 15](s[t + 24 >> 2] | 0, s[t >> 2] & 4 | 0 ? 12053 : 12055, 2) | 0) & 1;
        } else t = 1;

        r[a >> 0] = t;
        c = t;
        c = c << 24 >> 24 != 0;
        p = o;
        return c | 0;
      }

      function kc(e) {
        e = e | 0;
        return;
      }

      function Rc(e) {
        e = e | 0;
        return;
      }

      function Wc(e, t, a, n, o) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        n = n | 0;
        o = o | 0;
        var i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            p = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0,
            A = 0,
            w = 0,
            T = 0,
            x = 0,
            D = 0,
            C = 0;

        switch (o | 0) {
          case 0:
            {
              s[e + 48 >> 2] = t;
              s[e + 52 >> 2] = a;
              s[e + 56 >> 2] = n;
              s[e + 60 >> 2] = 0;
              s[e >> 2] = 0;
              s[e + 4 >> 2] = 0;
              s[e + 8 >> 2] = a;
              r[e + 12 >> 0] = 1;
              r[e + 13 >> 0] = 1;
              return;
            }

          case 1:
            {
              v = 0;
              _ = 0;
              g = 1;
              A = 1;
              break;
            }

          default:
            {
              b = 0;
              i = 1;
              T = 3;
            }
        }

        e: do {
          if ((T | 0) == 3) {
            t: while (1) {
              T = 0;
              u = 1;

              a: while (1) {
                h = i;
                p = 0;
                l = i;

                while (1) {
                  h = r[n + h >> 0] | 0;
                  i = p + b | 0;

                  if (i >>> 0 >= o >>> 0) {
                    T = 6;
                    break t;
                  }

                  i = r[n + i >> 0] | 0;
                  if ((h & 255) < (i & 255)) break;
                  if (h << 24 >> 24 != i << 24 >> 24) break a;
                  h = p + 1 | 0;
                  w = (h | 0) == (u | 0);
                  i = w ? 0 : h;
                  l = (w ? h : 0) + l | 0;
                  h = l + i | 0;

                  if (h >>> 0 >= o >>> 0) {
                    m = b;
                    y = u;
                    break t;
                  } else p = i;
                }

                i = l + 1 + p | 0;
                u = i - b | 0;

                if (i >>> 0 >= o >>> 0) {
                  m = b;
                  y = u;
                  break t;
                }
              }

              i = l + 1 | 0;

              if (i >>> 0 >= o >>> 0) {
                m = l;
                y = 1;
                break;
              } else {
                b = l;
                T = 3;
              }
            }

            if ((T | 0) == 6) Yc(5068, i, o);
            i = 1;
            b = 0;

            t: while (1) {
              u = 1;

              a: while (1) {
                h = i;
                p = 0;
                l = i;

                while (1) {
                  h = r[n + h >> 0] | 0;
                  i = p + b | 0;
                  if (i >>> 0 >= o >>> 0) break t;
                  i = r[n + i >> 0] | 0;
                  if ((h & 255) > (i & 255)) break;
                  if (h << 24 >> 24 != i << 24 >> 24) break a;
                  h = p + 1 | 0;
                  w = (h | 0) == (u | 0);
                  i = w ? 0 : h;
                  l = (w ? h : 0) + l | 0;
                  h = l + i | 0;

                  if (h >>> 0 >= o >>> 0) {
                    v = m;
                    _ = b;
                    g = y;
                    A = u;
                    break e;
                  } else p = i;
                }

                i = l + 1 + p | 0;
                u = i - b | 0;

                if (i >>> 0 >= o >>> 0) {
                  v = m;
                  _ = b;
                  g = y;
                  A = u;
                  break e;
                }
              }

              i = l + 1 | 0;

              if (i >>> 0 >= o >>> 0) {
                v = m;
                _ = l;
                g = y;
                A = 1;
                break e;
              } else b = l;
            }

            Yc(5068, i, o);
          }
        } while (0);

        y = v >>> 0 > _ >>> 0;
        w = y ? v : _;
        _ = y ? g : A;
        if (w >>> 0 > o >>> 0) ru(w, o);
        i = _ + w | 0;
        if (i >>> 0 < _ >>> 0) nu(_, i);
        if (i >>> 0 > o >>> 0) ru(i, o);
        v = n + _ | 0;

        if ((v | 0) != (n | 0) ? (Vu(n, v, w) | 0) != 0 : 0) {
          l = o - w | 0;
          h = l >>> 0 >= w >>> 0;
          i = n + o | 0;
          u = n;
          d = 0;
          c = 0;

          do {
            C = od(1, 0, r[u >> 0] & 63 | 0) | 0;
            u = u + 1 | 0;
            d = C | d;
            c = S | c;
          } while ((u | 0) != (i | 0));

          f = w;
          x = (h ? l : w) + 1 | 0;
          D = -1;
          C = -1;
        } else T = 30;

        do {
          if ((T | 0) == 30) {
            y = o + -1 | 0;
            i = 1;
            p = 0;
            b = 1;
            l = 0;

            while (1) {
              if ((b + p | 0) >>> 0 >= o >>> 0) {
                T = 40;
                break;
              }

              u = o - p + ~b | 0;

              if (u >>> 0 >= o >>> 0) {
                T = 33;
                break;
              }

              h = r[n + u >> 0] | 0;
              u = y - p - l | 0;

              if (u >>> 0 >= o >>> 0) {
                T = 35;
                break;
              }

              u = r[n + u >> 0] | 0;

              if ((h & 255) < (u & 255)) {
                h = p + 1 + b | 0;
                i = h - l | 0;
                u = 0;
              } else {
                T = h << 24 >> 24 == u << 24 >> 24;
                h = p + 1 | 0;
                A = (h | 0) == (i | 0);
                i = T ? i : 1;
                u = T ? A ? 0 : h : 0;
                h = (T ? A ? h : 0 : 1) + b | 0;
                l = T ? l : b;
              }

              if ((i | 0) == (_ | 0)) {
                T = 40;
                break;
              } else {
                p = u;
                b = h;
              }
            }

            if ((T | 0) == 33) Yc(5068, u, o);else if ((T | 0) == 35) Yc(5068, u, o);else if ((T | 0) == 40) {
              b = 0;
              m = 1;
              i = 0;
              p = 1;

              while (1) {
                if ((m + b | 0) >>> 0 >= o >>> 0) {
                  T = 50;
                  break;
                }

                u = o - b + ~m | 0;

                if (u >>> 0 >= o >>> 0) {
                  T = 43;
                  break;
                }

                h = r[n + u >> 0] | 0;
                u = y - b - i | 0;

                if (u >>> 0 >= o >>> 0) {
                  T = 45;
                  break;
                }

                u = r[n + u >> 0] | 0;

                if ((h & 255) > (u & 255)) {
                  p = b + 1 + m | 0;
                  h = p - i | 0;
                  u = 0;
                } else {
                  T = h << 24 >> 24 == u << 24 >> 24;
                  A = b + 1 | 0;
                  g = (A | 0) == (p | 0);
                  h = T ? p : 1;
                  u = T ? g ? 0 : A : 0;
                  p = (T ? g ? A : 0 : 1) + m | 0;
                  i = T ? i : m;
                }

                if ((h | 0) == (_ | 0)) {
                  T = 50;
                  break;
                } else {
                  b = u;
                  m = p;
                  p = h;
                }
              }

              if ((T | 0) == 43) Yc(5068, u, o);else if ((T | 0) == 45) Yc(5068, u, o);else if ((T | 0) == 50) {
                f = o - (i >>> 0 >= l >>> 0 ? i : l) | 0;
                if (_ >>> 0 > o >>> 0) ru(_, o);

                if (!_) {
                  d = 0;
                  c = 0;
                  x = 0;
                  D = 0;
                  C = o;
                  break;
                }

                u = n;
                i = 0;
                c = 0;

                do {
                  C = od(1, 0, r[u >> 0] & 63 | 0) | 0;
                  u = u + 1 | 0;
                  i = C | i;
                  c = S | c;
                } while ((u | 0) != (v | 0));

                d = i;
                x = _;
                D = 0;
                C = o;
              }
            }
          }
        } while (0);

        s[e + 48 >> 2] = t;
        s[e + 52 >> 2] = a;
        s[e + 56 >> 2] = n;
        s[e + 60 >> 2] = o;
        s[e >> 2] = 1;
        o = e + 8 | 0;
        s[o >> 2] = d;
        s[o + 4 >> 2] = c;
        s[e + 16 >> 2] = w;
        s[e + 20 >> 2] = f;
        s[e + 24 >> 2] = x;
        s[e + 28 >> 2] = 0;
        s[e + 32 >> 2] = a;
        s[e + 36 >> 2] = D;
        s[e + 40 >> 2] = C;
        return;
      }

      function Ic(e) {
        e = e | 0;
        return;
      }

      function Nc(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0;
        h = p;
        p = p + 16 | 0;
        u = h;

        if (!a) {
          l = 0;
          p = h;
          return l | 0;
        }

        d = e + 8 | 0;
        f = u + 4 | 0;
        l = e + 4 | 0;
        i = a;

        while (1) {
          if (r[d >> 0] | 0 ? Id[s[(s[l >> 2] | 0) + 12 >> 2] & 15](s[e >> 2] | 0, 12048, 4) | 0 : 0) {
            t = 1;
            a = 5;
            break;
          }

          Ec(u, t, i, 10);

          if ((s[u >> 2] | 0) == 1) {
            c = s[f >> 2] | 0;
            r[d >> 0] = 1;
            c = c + 1 | 0;
          } else {
            r[d >> 0] = 0;
            c = i;
          }

          a = s[e >> 2] | 0;
          n = s[l >> 2] | 0;
          o = (c | 0) == 0 | (i | 0) == (c | 0);

          if (!o) {
            if (i >>> 0 <= c >>> 0) {
              a = 12;
              break;
            }

            if ((r[t + c >> 0] | 0) <= -65) {
              a = 12;
              break;
            }
          }

          if (Id[s[n + 12 >> 2] & 15](a, t, c) | 0) {
            t = 1;
            a = 5;
            break;
          }

          if (!o) {
            if (i >>> 0 <= c >>> 0) {
              a = 18;
              break;
            }

            a = t + c | 0;
            if ((r[a >> 0] | 0) > -65) t = a;else {
              a = 18;
              break;
            }
          } else t = t + c | 0;

          a = i - c | 0;

          if (!a) {
            t = 0;
            a = 5;
            break;
          } else i = a;
        }

        if ((a | 0) == 5) {
          p = h;
          return t | 0;
        } else if ((a | 0) == 12) Sc(t, i, 0, c);else if ((a | 0) == 18) Sc(t, i, c, i);

        return 0;
      }

      function Mc(e, t, a, n, o) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        n = n | 0;
        o = o | 0;
        var i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0,
            A = 0,
            w = 0,
            T = 0,
            x = 0,
            D = 0;
        m = p;
        p = p + 96 | 0;
        l = m + 32 | 0;
        h = m + 16 | 0;
        c = m;
        b = m + 8 | 0;
        s[b >> 2] = t;
        u = b + 4 | 0;
        s[u >> 2] = a;
        d = e + 4 | 0;

        if (r[d >> 0] | 0) {
          h = 1;
          b = e + 5 | 0;
          h = h & 1;
          r[d >> 0] = h;
          r[b >> 0] = 1;
          p = m;
          return e | 0;
        }

        f = e + 5 | 0;
        i = (r[f >> 0] | 0) != 0;
        a = i ? 3572 : 12062;
        i = i ? 1 : 2;
        s[c >> 2] = a;
        s[c + 4 >> 2] = i;
        t = s[e >> 2] | 0;

        do {
          if (!(s[t >> 2] & 4)) {
            s[h >> 2] = c;
            s[h + 4 >> 2] = 64;
            s[h + 8 >> 2] = b;
            s[h + 12 >> 2] = 64;
            u = s[t + 24 >> 2] | 0;
            b = s[t + 28 >> 2] | 0;
            s[l >> 2] = 5116;
            s[l + 4 >> 2] = 3;
            s[l + 8 >> 2] = 5264;
            s[l + 12 >> 2] = 2;
            s[l + 16 >> 2] = h;
            s[l + 20 >> 2] = 2;
            if (rc(u, b, l) | 0) a = 8;else {
              t = Gd[s[o + 12 >> 2] & 127](n, s[e >> 2] | 0) | 0;
              a = 13;
            }
          } else {
            D = s[t + 28 >> 2] | 0;
            s[h >> 2] = s[t + 24 >> 2];
            s[h + 4 >> 2] = D;
            r[h + 8 >> 0] = 0;
            D = s[t + 4 >> 2] | 0;
            x = r[t + 48 >> 0] | 0;
            w = t + 8 | 0;
            T = s[w >> 2] | 0;
            w = s[w + 4 >> 2] | 0;
            g = t + 16 | 0;
            A = s[g >> 2] | 0;
            g = s[g + 4 >> 2] | 0;
            _ = s[t + 32 >> 2] | 0;
            v = s[t + 36 >> 2] | 0;
            y = s[t + 40 >> 2] | 0;
            c = s[t + 44 >> 2] | 0;
            s[l >> 2] = s[t >> 2];
            s[l + 4 >> 2] = D;
            r[l + 48 >> 0] = x;
            t = l + 8 | 0;
            s[t >> 2] = T;
            s[t + 4 >> 2] = w;
            t = l + 16 | 0;
            s[t >> 2] = A;
            s[t + 4 >> 2] = g;
            s[l + 24 >> 2] = h;
            s[l + 28 >> 2] = 4356;
            s[l + 32 >> 2] = _;
            s[l + 36 >> 2] = v;
            s[l + 40 >> 2] = y;
            s[l + 44 >> 2] = c;
            t = s[1092] | 0;

            if (((!(Id[t & 15](h, a, i) | 0) ? !(Id[t & 15](h, 12052, 1) | 0) : 0) ? !(Id[t & 15](h, s[b >> 2] | 0, s[u >> 2] | 0) | 0) : 0) ? !(Id[t & 15](h, 12064, 2) | 0) : 0) {
              t = Gd[s[o + 12 >> 2] & 127](n, l) | 0;
              a = 13;
              break;
            }

            a = 8;
          }
        } while (0);

        if ((a | 0) == 8) {
          x = 1;
          D = f;
          x = x & 1;
          r[d >> 0] = x;
          r[D >> 0] = 1;
          p = m;
          return e | 0;
        } else if ((a | 0) == 13) {
          x = t;
          D = f;
          x = x & 1;
          r[d >> 0] = x;
          r[D >> 0] = 1;
          p = m;
          return e | 0;
        }

        return 0;
      }

      function Pc(e) {
        e = e | 0;
        var t = 0,
            a = 0;
        a = e + 4 | 0;
        t = r[a >> 0] | 0;

        if (!(r[e + 5 >> 0] | 0)) {
          a = t;
          a = a << 24 >> 24 != 0;
          return a | 0;
        }

        if (!(t << 24 >> 24)) {
          e = s[e >> 2] | 0;
          e = (Id[s[(s[e + 28 >> 2] | 0) + 12 >> 2] & 15](s[e + 24 >> 2] | 0, s[e >> 2] & 4 | 0 ? 12053 : 12055, 2) | 0) & 1;
        } else e = 1;

        r[a >> 0] = e;
        a = e;
        a = a << 24 >> 24 != 0;
        return a | 0;
      }

      function Lc(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0,
            A = 0,
            w = 0;
        h = p;
        p = p + 64 | 0;
        u = h + 12 | 0;
        d = h;
        f = e + 8 | 0;
        l = e + 4 | 0;

        do {
          if (!(r[f >> 0] | 0)) {
            o = (s[l >> 2] | 0) != 0;
            c = o ? 3572 : 3564;
            n = o ? 3580 : 16465;
            o = o & 1;
            i = s[e >> 2] | 0;

            if (!(s[i >> 2] & 4)) {
              if (Id[s[(s[i + 28 >> 2] | 0) + 12 >> 2] & 15](s[i + 24 >> 2] | 0, c, 1) | 0) {
                n = 1;
                break;
              }

              d = s[e >> 2] | 0;

              if (Id[s[(s[d + 28 >> 2] | 0) + 12 >> 2] & 15](s[d + 24 >> 2] | 0, n, o) | 0) {
                n = 1;
                break;
              }

              n = Gd[s[a + 12 >> 2] & 127](t, s[e >> 2] | 0) | 0;
              break;
            }

            w = s[i + 28 >> 2] | 0;
            s[d >> 2] = s[i + 24 >> 2];
            s[d + 4 >> 2] = w;
            r[d + 8 >> 0] = 0;
            w = s[i + 4 >> 2] | 0;
            A = r[i + 48 >> 0] | 0;
            _ = i + 8 | 0;
            g = s[_ >> 2] | 0;
            _ = s[_ + 4 >> 2] | 0;
            y = i + 16 | 0;
            v = s[y >> 2] | 0;
            y = s[y + 4 >> 2] | 0;
            m = s[i + 32 >> 2] | 0;
            b = s[i + 36 >> 2] | 0;
            o = s[i + 40 >> 2] | 0;
            n = s[i + 44 >> 2] | 0;
            s[u >> 2] = s[i >> 2];
            s[u + 4 >> 2] = w;
            r[u + 48 >> 0] = A;
            i = u + 8 | 0;
            s[i >> 2] = g;
            s[i + 4 >> 2] = _;
            i = u + 16 | 0;
            s[i >> 2] = v;
            s[i + 4 >> 2] = y;
            s[u + 24 >> 2] = d;
            s[u + 28 >> 2] = 4356;
            s[u + 32 >> 2] = m;
            s[u + 36 >> 2] = b;
            s[u + 40 >> 2] = o;
            s[u + 44 >> 2] = n;
            n = s[1092] | 0;

            if (!(Id[n & 15](d, c, 1) | 0) ? !(Id[n & 15](d, 12052, 1) | 0) : 0) {
              n = Gd[s[a + 12 >> 2] & 127](t, u) | 0;
              break;
            }

            n = 1;
          } else n = 1;
        } while (0);

        r[f >> 0] = n & 1;
        s[l >> 2] = (s[l >> 2] | 0) + 1;
        p = h;
        return e | 0;
      }

      function Oc(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            n = 0,
            o = 0;
        n = e + 4 | 0;
        t = s[n >> 2] | 0;
        o = e + 8 | 0;
        a = r[o >> 0] | 0;

        if (!t) {
          o = a;
          o = o << 24 >> 24 != 0;
          return o | 0;
        }

        do {
          if (!(a << 24 >> 24)) {
            a = s[e >> 2] | 0;

            if (s[a >> 2] & 4) {
              if (Id[s[(s[a + 28 >> 2] | 0) + 12 >> 2] & 15](s[a + 24 >> 2] | 0, 12052, 1) | 0) {
                t = 1;
                break;
              }

              t = s[n >> 2] | 0;
            }

            if (((t | 0) == 1 ? r[e + 9 >> 0] | 0 : 0) ? (n = s[e >> 2] | 0, Id[s[(s[n + 28 >> 2] | 0) + 12 >> 2] & 15](s[n + 24 >> 2] | 0, 3572, 1) | 0) : 0) {
              t = 1;
              break;
            }

            t = s[e >> 2] | 0;
            t = (Id[s[(s[t + 28 >> 2] | 0) + 12 >> 2] & 15](s[t + 24 >> 2] | 0, 12057, 1) | 0) & 1;
          } else t = 1;
        } while (0);

        r[o >> 0] = t;
        o = t;
        o = o << 24 >> 24 != 0;
        return o | 0;
      }

      function Fc(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0;
        u = p;
        p = p + 64 | 0;
        o = u + 12 | 0;
        i = u;
        c = e + 4 | 0;

        if (r[c >> 0] | 0) {
          t = 1;
          a = e + 5 | 0;
          t = t & 1;
          r[c >> 0] = t;
          r[a >> 0] = 1;
          p = u;
          return;
        }

        n = s[e >> 2] | 0;

        if (s[n >> 2] & 4 | 0) {
          g = s[n + 28 >> 2] | 0;
          s[i >> 2] = s[n + 24 >> 2];
          s[i + 4 >> 2] = g;
          r[i + 8 >> 0] = 0;
          g = s[n + 4 >> 2] | 0;
          _ = r[n + 48 >> 0] | 0;
          y = n + 8 | 0;
          v = s[y >> 2] | 0;
          y = s[y + 4 >> 2] | 0;
          b = n + 16 | 0;
          m = s[b >> 2] | 0;
          b = s[b + 4 >> 2] | 0;
          h = s[n + 32 >> 2] | 0;
          l = s[n + 36 >> 2] | 0;
          f = s[n + 40 >> 2] | 0;
          d = s[n + 44 >> 2] | 0;
          s[o >> 2] = s[n >> 2];
          s[o + 4 >> 2] = g;
          r[o + 48 >> 0] = _;
          n = o + 8 | 0;
          s[n >> 2] = v;
          s[n + 4 >> 2] = y;
          n = o + 16 | 0;
          s[n >> 2] = m;
          s[n + 4 >> 2] = b;
          s[o + 24 >> 2] = i;
          s[o + 28 >> 2] = 4356;
          s[o + 32 >> 2] = h;
          s[o + 36 >> 2] = l;
          s[o + 40 >> 2] = f;
          s[o + 44 >> 2] = d;
          n = e + 5 | 0;
          e = (r[n >> 0] | 0) != 0;

          if (Id[s[4368 >> 2] & 15](i, e ? 12058 : 12052, e ? 2 : 1) | 0) {
            _ = 1;
            g = n;
            _ = _ & 1;
            r[c >> 0] = _;
            r[g >> 0] = 1;
            p = u;
            return;
          } else {
            _ = Gd[s[a + 12 >> 2] & 127](t, o) | 0;
            g = n;
            _ = _ & 1;
            r[c >> 0] = _;
            r[g >> 0] = 1;
            p = u;
            return;
          }
        }

        o = e + 5 | 0;

        do {
          if (r[o >> 0] | 0) if (Id[s[(s[n + 28 >> 2] | 0) + 12 >> 2] & 15](s[n + 24 >> 2] | 0, 12060, 2) | 0) {
            _ = 1;
            g = o;
            _ = _ & 1;
            r[c >> 0] = _;
            r[g >> 0] = 1;
            p = u;
            return;
          } else {
            n = s[e >> 2] | 0;
            break;
          }
        } while (0);

        _ = Gd[s[a + 12 >> 2] & 127](t, n) | 0;
        g = o;
        _ = _ & 1;
        r[c >> 0] = _;
        r[g >> 0] = 1;
        p = u;
        return;
      }

      function jc(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        Fc(e, t, a);
        return e | 0;
      }

      function Gc(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            n = 0;
        t = s[e >> 2] | 0;
        if ((s[t >> 2] & 4 | 0) != 0 ? (r[e + 5 >> 0] | 0) != 0 : 0) a = 1;else a = 0;
        n = e + 4 | 0;

        if (r[n >> 0] | 0) {
          r[n >> 0] = 1;
          n = 1;
          return n | 0;
        }

        a = Id[s[(s[t + 28 >> 2] | 0) + 12 >> 2] & 15](s[t + 24 >> 2] | 0, a ? 12052 : 16465, a & 1) | 0;
        r[n >> 0] = a & 1;

        if (a) {
          n = 1;
          return n | 0;
        }

        n = s[e >> 2] | 0;
        n = Id[s[(s[n + 28 >> 2] | 0) + 12 >> 2] & 15](s[n + 24 >> 2] | 0, 3592, 1) | 0;
        return n | 0;
      }

      function Vc(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0;
        d = p;
        p = p + 16 | 0;
        u = d;
        s[u >> 2] = 0;

        if (t >>> 0 < 128) {
          r[u >> 0] = t;
          a = 1;
        } else {
          do {
            if (t >>> 0 >= 2048) {
              if (t >>> 0 < 65536) {
                r[u >> 0] = t >>> 12 & 15 | -32;
                n = 63;
                o = 1;
                i = -128;
                c = 2;
                a = 3;
                break;
              } else {
                r[u >> 0] = t >>> 18 & 255 | -16;
                r[u + 1 >> 0] = t >>> 12 & 63 | -128;
                n = 63;
                o = 2;
                i = -128;
                c = 3;
                a = 4;
                break;
              }
            } else {
              n = 31;
              o = 0;
              i = -64;
              c = 1;
              a = 2;
            }
          } while (0);

          r[u + o >> 0] = n & t >>> 6 & 255 | i;
          r[u + c >> 0] = t & 63 | -128;
        }

        u = Nc(e, u, a) | 0;
        p = d;
        return u | 0;
      }

      function Uc(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0;
        a = p;
        p = p + 32 | 0;
        r = a + 8 | 0;
        n = a;
        s[n >> 2] = e;
        s[r >> 2] = s[t >> 2];
        s[r + 4 >> 2] = s[t + 4 >> 2];
        s[r + 8 >> 2] = s[t + 8 >> 2];
        s[r + 12 >> 2] = s[t + 12 >> 2];
        s[r + 16 >> 2] = s[t + 16 >> 2];
        s[r + 20 >> 2] = s[t + 20 >> 2];
        t = rc(n, 5092, r) | 0;
        p = a;
        return t | 0;
      }

      function Hc(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0;
        a = p;
        p = p + 48 | 0;
        r = a + 16 | 0;
        n = a;
        s[n >> 2] = e;
        s[n + 4 >> 2] = 67;
        s[n + 8 >> 2] = e + 4;
        s[n + 12 >> 2] = 67;
        e = s[t + 24 >> 2] | 0;
        t = s[t + 28 >> 2] | 0;
        s[r >> 2] = 5140;
        s[r + 4 >> 2] = 2;
        s[r + 8 >> 2] = 5264;
        s[r + 12 >> 2] = 2;
        s[r + 16 >> 2] = n;
        s[r + 20 >> 2] = 2;
        t = rc(e, t, r) | 0;
        p = a;
        return t | 0;
      }

      function zc(e, t, a, n) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        n = n | 0;
        var o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            p = 0;
        d = a & 3;
        o = 4 - d | 0;

        e: do {
          if ((d | 0) == 0 | (o | 0) == 0) o = 0;else {
            u = o >>> 0 <= n >>> 0 ? o : n;
            d = a + u | 0;
            c = d;
            i = a;
            o = 0;

            while (1) {
              if ((c - i | 0) >>> 0 <= 3) {
                l = 8;
                break;
              }

              p = (r[i >> 0] | 0) == t << 24 >> 24;
              o = ((p ^ 1) & 1) + o | 0;
              if (p) break;
              p = (r[i + 1 >> 0] | 0) == t << 24 >> 24;
              o = ((p ^ 1) & 1) + o | 0;
              if (p) break;
              p = (r[i + 2 >> 0] | 0) == t << 24 >> 24;
              o = ((p ^ 1) & 1) + o | 0;
              if (p) break;
              p = (r[i + 3 >> 0] | 0) == t << 24 >> 24;
              o = ((p ^ 1) & 1) + o | 0;
              if (p) break;else i = i + 4 | 0;
            }

            if ((l | 0) == 8) while (1) {
              if ((i | 0) == (d | 0)) {
                o = u;
                break e;
              }

              p = (r[i >> 0] | 0) == t << 24 >> 24;
              o = ((p ^ 1) & 1) + o | 0;
              if (p) break;else {
                i = i + 1 | 0;
                l = 8;
              }
            }
            s[e >> 2] = 1;
            s[e + 4 >> 2] = o;
            return;
          }
        } while (0);

        i = t & 255;
        i = i << 8 | i;
        i = i << 16 | i;

        if (n >>> 0 > 7 ? (f = n + -8 | 0, o >>> 0 <= f >>> 0) : 0) {
          do {
            p = s[a + o >> 2] ^ i;
            l = s[a + (o + 4) >> 2] ^ i;
            if ((l & -2139062144 ^ -2139062144) & l + -16843009 | (p & -2139062144 ^ -2139062144) & p + -16843009 | 0) break;
            o = o + 8 | 0;
          } while (o >>> 0 <= f >>> 0);

          if (o >>> 0 > n >>> 0) nu(o, n);else h = o;
        } else h = o;

        i = a + h | 0;
        u = i + (n - h) | 0;
        c = u;
        o = 0;

        while (1) {
          if ((c - i | 0) >>> 0 <= 3) {
            l = 24;
            break;
          }

          p = (r[i >> 0] | 0) == t << 24 >> 24;
          o = ((p ^ 1) & 1) + o | 0;

          if (p) {
            l = 26;
            break;
          }

          p = (r[i + 1 >> 0] | 0) == t << 24 >> 24;
          o = ((p ^ 1) & 1) + o | 0;

          if (p) {
            l = 26;
            break;
          }

          p = (r[i + 2 >> 0] | 0) == t << 24 >> 24;
          o = ((p ^ 1) & 1) + o | 0;

          if (p) {
            l = 26;
            break;
          }

          p = (r[i + 3 >> 0] | 0) == t << 24 >> 24;
          o = ((p ^ 1) & 1) + o | 0;

          if (p) {
            l = 26;
            break;
          } else i = i + 4 | 0;
        }

        e: do {
          if ((l | 0) == 24) while (1) {
            l = 0;

            if ((i | 0) == (u | 0)) {
              o = 0;
              break e;
            }

            p = (r[i >> 0] | 0) == t << 24 >> 24;
            o = ((p ^ 1) & 1) + o | 0;

            if (p) {
              l = 26;
              break;
            } else {
              i = i + 1 | 0;
              l = 24;
            }
          }
        } while (0);

        if ((l | 0) == 26) {
          s[e + 4 >> 2] = o + h;
          o = 1;
        }

        s[e >> 2] = o;
        return;
      }

      function Kc(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0;
        a = p;
        p = p + 48 | 0;
        t = a + 32 | 0;
        c = a + 24 | 0;
        u = s[e + 4 >> 2] | 0;
        i = s[e + 8 >> 2] | 0;
        o = s[e + 12 >> 2] | 0;
        n = s[e + 16 >> 2] | 0;
        r = s[e + 20 >> 2] | 0;
        s[c >> 2] = s[e >> 2];
        s[c + 4 >> 2] = u;
        s[a >> 2] = c;
        s[a + 4 >> 2] = 1;
        s[a + 8 >> 2] = 0;
        s[a + 16 >> 2] = 15892;
        s[a + 20 >> 2] = 0;
        s[t >> 2] = i;
        s[t + 4 >> 2] = o;
        s[t + 8 >> 2] = n;
        s[t + 12 >> 2] = r;
        qc(a, t);
      }

      function qc(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0;
        i = p;
        p = p + 64 | 0;
        r = i + 56 | 0;
        n = i + 32 | 0;
        o = i;
        i = i + 8 | 0;
        u = s[t >> 2] | 0;
        c = s[t + 4 >> 2] | 0;
        a = s[t + 8 >> 2] | 0;
        t = s[t + 12 >> 2] | 0;
        s[i >> 2] = s[e >> 2];
        s[i + 4 >> 2] = s[e + 4 >> 2];
        s[i + 8 >> 2] = s[e + 8 >> 2];
        s[i + 12 >> 2] = s[e + 12 >> 2];
        s[i + 16 >> 2] = s[e + 16 >> 2];
        s[i + 20 >> 2] = s[e + 20 >> 2];
        s[o >> 2] = u;
        s[o + 4 >> 2] = c;
        s[n >> 2] = s[i >> 2];
        s[n + 4 >> 2] = s[i + 4 >> 2];
        s[n + 8 >> 2] = s[i + 8 >> 2];
        s[n + 12 >> 2] = s[i + 12 >> 2];
        s[n + 16 >> 2] = s[i + 16 >> 2];
        s[n + 20 >> 2] = s[i + 20 >> 2];
        s[r >> 2] = s[o >> 2];
        s[r + 4 >> 2] = s[o + 4 >> 2];
        Nn(n, r, a, t);
      }

      function Yc(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0,
            i = 0;
        o = p;
        p = p + 48 | 0;
        n = o + 32 | 0;
        r = o + 8 | 0;
        i = o + 4 | 0;
        s[o >> 2] = t;
        s[i >> 2] = a;
        s[n >> 2] = i;
        s[n + 4 >> 2] = 39;
        s[n + 8 >> 2] = o;
        s[n + 12 >> 2] = 39;
        s[r >> 2] = 5156;
        s[r + 4 >> 2] = 2;
        s[r + 8 >> 2] = 5264;
        s[r + 12 >> 2] = 2;
        s[r + 16 >> 2] = n;
        s[r + 20 >> 2] = 2;
        qc(r, e);
      }

      function Zc(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0;
        n = p;
        p = p + 48 | 0;
        r = n + 32 | 0;
        a = n + 8 | 0;
        s[n >> 2] = e;
        s[n + 4 >> 2] = t;
        s[r >> 2] = n;
        s[r + 4 >> 2] = 64;
        s[a >> 2] = 5172;
        s[a + 4 >> 2] = 1;
        s[a + 8 >> 2] = 5180;
        s[a + 12 >> 2] = 1;
        s[a + 16 >> 2] = r;
        s[a + 20 >> 2] = 1;
        qc(a, 5216);
      }

      function Jc(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0;
        u = p;
        p = p + 16 | 0;
        a = u + 12 | 0;
        c = u;
        e = s[e >> 2] | 0;

        if ((r[e >> 0] | 0) != 1) {
          c = Id[s[(s[t + 28 >> 2] | 0) + 12 >> 2] & 15](s[t + 24 >> 2] | 0, 12149, 4) | 0;
          p = u;
          return c | 0;
        }

        n = Id[s[(s[t + 28 >> 2] | 0) + 12 >> 2] & 15](s[t + 24 >> 2] | 0, 12153, 4) | 0;
        s[c >> 2] = t;
        i = c + 8 | 0;
        r[i >> 0] = n & 1;
        n = c + 4 | 0;
        s[n >> 2] = 0;
        o = c + 9 | 0;
        r[o >> 0] = 0;
        s[a >> 2] = e + 1;
        Lc(c, a, 5232) | 0;
        t = s[n >> 2] | 0;
        e = r[i >> 0] | 0;

        if (t) {
          do {
            if (!(e << 24 >> 24)) {
              e = s[c >> 2] | 0;
              if (!(s[e >> 2] & 4)) e = t;else {
                if (Id[s[(s[e + 28 >> 2] | 0) + 12 >> 2] & 15](s[e + 24 >> 2] | 0, 12052, 1) | 0) {
                  e = 1;
                  break;
                }

                e = s[n >> 2] | 0;
              }

              if (!((e | 0) != 1 | (r[o >> 0] | 0) == 0) ? (o = s[c >> 2] | 0, Id[s[(s[o + 28 >> 2] | 0) + 12 >> 2] & 15](s[o + 24 >> 2] | 0, 3572, 1) | 0) : 0) {
                e = 1;
                break;
              }

              e = s[c >> 2] | 0;
              e = (Id[s[(s[e + 28 >> 2] | 0) + 12 >> 2] & 15](s[e + 24 >> 2] | 0, 12057, 1) | 0) & 1;
            } else e = 1;
          } while (0);

          r[i >> 0] = e;
        }

        c = e << 24 >> 24 != 0;
        p = u;
        return c | 0;
      }

      function Xc(e) {
        e = e | 0;
        return;
      }

      function $c(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var n = 0,
            i = 0,
            c = 0;

        if (!a) {
          r[e >> 0] = 1;
          r[e + 1 >> 0] = 0;
          return;
        }

        c = (r[t >> 0] | 0) == 43;
        n = c ? t + 1 | 0 : t;
        t = (c << 31 >> 31) + a | 0;

        if (!t) {
          r[e >> 0] = 1;
          r[e + 1 >> 0] = 0;
          return;
        }

        i = n + t | 0;
        c = 0;

        while (1) {
          t = o[n >> 0] | 0;
          n = n + 1 | 0;
          if ((t + -48 | 0) >>> 0 >= 10) {
            if ((t + -97 | 0) >>> 0 >= 26) {
              if ((t + -65 | 0) >>> 0 < 26) a = -55;else {
                t = 10;
                break;
              }
            } else a = -87;
          } else a = -48;
          a = a + t | 0;

          if (a >>> 0 >= 10) {
            t = 10;
            break;
          }

          t = c * 10 | 0;

          if (c >>> 0 > 429496729) {
            t = 12;
            break;
          }

          c = t + a | 0;

          if (c >>> 0 < t >>> 0) {
            t = 14;
            break;
          }

          if ((n | 0) == (i | 0)) {
            t = 16;
            break;
          }
        }

        if ((t | 0) == 10) {
          r[e >> 0] = 1;
          r[e + 1 >> 0] = 1;
          return;
        } else if ((t | 0) == 12) {
          r[e >> 0] = 1;
          r[e + 1 >> 0] = 2;
          return;
        } else if ((t | 0) == 14) {
          r[e >> 0] = 1;
          r[e + 1 >> 0] = 2;
          return;
        } else if ((t | 0) == 16) {
          r[e >> 0] = 0;
          s[e + 4 >> 2] = c;
          return;
        }
      }

      function Qc(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0;
        o = p;
        p = p + 16 | 0;
        c = o + 8 | 0;
        n = o;
        i = Id[s[(s[t + 28 >> 2] | 0) + 12 >> 2] & 15](s[t + 24 >> 2] | 0, 12157, 13) | 0;
        s[n >> 2] = t;
        a = n + 4 | 0;
        r[a >> 0] = i & 1;
        i = n + 5 | 0;
        r[i >> 0] = 0;
        s[c >> 2] = e;
        Mc(n, 12170, 4, c, 5248) | 0;
        t = r[a >> 0] | 0;

        if (!(r[i >> 0] | 0)) {
          c = t;
          c = c << 24 >> 24 != 0;
          p = o;
          return c | 0;
        }

        if (!(t << 24 >> 24)) {
          t = s[n >> 2] | 0;
          t = (Id[s[(s[t + 28 >> 2] | 0) + 12 >> 2] & 15](s[t + 24 >> 2] | 0, s[t >> 2] & 4 | 0 ? 12053 : 12055, 2) | 0) & 1;
        } else t = 1;

        r[a >> 0] = t;
        c = t;
        c = c << 24 >> 24 != 0;
        p = o;
        return c | 0;
      }

      function eu(e) {
        e = e | 0;
        return;
      }

      function tu(e, t) {
        e = e | 0;
        t = t | 0;

        switch (r[s[e >> 2] >> 0] & 3) {
          case 0:
            {
              t = Id[s[(s[t + 28 >> 2] | 0) + 12 >> 2] & 15](s[t + 24 >> 2] | 0, 12174, 5) | 0;
              return t | 0;
            }

          case 1:
            {
              t = Id[s[(s[t + 28 >> 2] | 0) + 12 >> 2] & 15](s[t + 24 >> 2] | 0, 12179, 12) | 0;
              return t | 0;
            }

          case 2:
            {
              t = Id[s[(s[t + 28 >> 2] | 0) + 12 >> 2] & 15](s[t + 24 >> 2] | 0, 12191, 8) | 0;
              return t | 0;
            }

          case 3:
            {
              t = Id[s[(s[t + 28 >> 2] | 0) + 12 >> 2] & 15](s[t + 24 >> 2] | 0, 12199, 9) | 0;
              return t | 0;
            }

          default:
            {}
        }

        return 0;
      }

      function au(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            n = 0,
            o = 0;

        e: do {
          switch (s[e >> 2] & 3) {
            case 0:
              {
                t = 1114112;
                break;
              }

            case 1:
              {
                t = s[e + 4 >> 2] | 0;
                s[e >> 2] = 0;
                break;
              }

            case 2:
              {
                s[e >> 2] = 1;
                t = 92;
                break;
              }

            case 3:
              {
                o = e + 12 | 0;

                switch (r[o >> 0] & 7) {
                  case 0:
                    {
                      t = 1114112;
                      break e;
                    }

                  case 1:
                    {
                      r[o >> 0] = 0;
                      t = 125;
                      break e;
                    }

                  case 2:
                    {
                      n = e + 8 | 0;
                      a = s[n >> 2] | 0;
                      t = (s[e + 4 >> 2] | 0) >>> (a << 2 & 28) & 15;
                      t = ((t & 255) < 10 ? 48 : 87) + t | 0;

                      if (!a) {
                        r[o >> 0] = 1;
                        break e;
                      } else {
                        s[n >> 2] = a + -1;
                        break e;
                      }
                    }

                  case 3:
                    {
                      r[o >> 0] = 2;
                      t = 123;
                      break e;
                    }

                  case 4:
                    {
                      r[o >> 0] = 3;
                      t = 117;
                      break e;
                    }

                  case 5:
                    {
                      r[o >> 0] = 4;
                      t = 92;
                      break e;
                    }

                  default:
                    {}
                }

                break;
              }

            default:
              {}
          }
        } while (0);

        return t | 0;
      }

      function ru(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0;
        o = p;
        p = p + 48 | 0;
        r = o + 32 | 0;
        a = o + 8 | 0;
        n = o + 4 | 0;
        s[o >> 2] = e;
        s[n >> 2] = t;
        s[r >> 2] = o;
        s[r + 4 >> 2] = 39;
        s[r + 8 >> 2] = n;
        s[r + 12 >> 2] = 39;
        s[a >> 2] = 5336;
        s[a + 4 >> 2] = 2;
        s[a + 8 >> 2] = 5264;
        s[a + 12 >> 2] = 2;
        s[a + 16 >> 2] = r;
        s[a + 20 >> 2] = 2;
        qc(a, 5352);
      }

      function nu(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0;
        o = p;
        p = p + 48 | 0;
        r = o + 32 | 0;
        a = o + 8 | 0;
        n = o + 4 | 0;
        s[o >> 2] = e;
        s[n >> 2] = t;
        s[r >> 2] = o;
        s[r + 4 >> 2] = 39;
        s[r + 8 >> 2] = n;
        s[r + 12 >> 2] = 39;
        s[a >> 2] = 5368;
        s[a + 4 >> 2] = 2;
        s[a + 8 >> 2] = 5264;
        s[a + 12 >> 2] = 2;
        s[a + 16 >> 2] = r;
        s[a + 20 >> 2] = 2;
        qc(a, 5384);
      }

      function su(e, t) {
        e = e | 0;
        t = t | 0;
        return Id[s[(s[t + 28 >> 2] | 0) + 12 >> 2] & 15](s[t + 24 >> 2] | 0, 13605, 11) | 0;
      }

      function ou(e, t) {
        e = e | 0;
        t = t | 0;
        return Id[s[(s[t + 28 >> 2] | 0) + 12 >> 2] & 15](s[t + 24 >> 2] | 0, 13616, 14) | 0;
      }

      function iu(e, t, a, n, s, i, c) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        n = n | 0;
        s = s | 0;
        i = i | 0;
        c = c | 0;
        var u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            p = 0,
            b = 0,
            m = 0;
        h = (e & 65535) >>> 8 & 255;
        p = t + (a << 1) | 0;

        e: do {
          if (a | 0) {
            d = e & 255;
            l = 0;

            t: while (1) {
              u = t;
              t = t + 2 | 0;
              a = r[u >> 0] | 0;
              u = o[u + 1 >> 0] | 0;
              f = u + l | 0;
              if (h << 24 >> 24 != a << 24 >> 24) if ((t | 0) == (p | 0) | (h & 255) < (a & 255)) break e;else {
                l = f;
                continue;
              }

              if (f >>> 0 < l >>> 0) {
                a = 7;
                break;
              }

              if (f >>> 0 > s >>> 0) {
                a = 9;
                break;
              }

              m = n + l | 0;
              a = m + u | 0;
              u = m;

              while (1) {
                if ((u | 0) == (a | 0)) break;

                if ((r[u >> 0] | 0) == d << 24 >> 24) {
                  b = 0;
                  a = 15;
                  break t;
                } else u = u + 1 | 0;
              }

              if ((t | 0) == (p | 0)) break e;else l = f;
            }

            if ((a | 0) == 7) nu(l, f);else if ((a | 0) == 9) ru(f, s);else if ((a | 0) == 15) return b | 0;
          }
        } while (0);

        l = i + c | 0;

        if (!c) {
          m = 1;
          return m | 0;
        }

        f = i;
        u = i + 1 | 0;
        d = e & 65535;
        t = 1;

        while (1) {
          a = r[f >> 0] | 0;

          if (a << 24 >> 24 < 0) {
            if ((u | 0) == (l | 0)) {
              a = 18;
              break;
            }

            a = o[u >> 0] | (a & 127) << 8;
            u = u + 1 | 0;
          } else a = a & 255;

          a = d - a | 0;

          if ((a | 0) < 0) {
            b = t;
            a = 15;
            break;
          }

          t = t ^ 1;

          if ((u | 0) == (l | 0)) {
            b = t;
            a = 15;
            break;
          }

          f = u;
          u = u + 1 | 0;
          d = a;
        }

        if ((a | 0) == 15) return b | 0;else if ((a | 0) == 18) Kc(5400);
        return 0;
      }

      function cu(e) {
        e = e | 0;
        var t = 0;
        t = e & 65535;

        if (e >>> 0 < 65536) {
          t = iu(t, 12317, 41, 12399, 304, 12703, 326) | 0;
          return t | 0;
        }

        if (e >>> 0 < 131072) {
          t = iu(t, 13029, 33, 13095, 150, 13245, 360) | 0;
          return t | 0;
        }

        if ((e + -195102 | 0) >>> 0 < 722658 | ((e + -191457 | 0) >>> 0 < 3103 | ((e + -183970 | 0) >>> 0 < 14 | ((e & 2097150 | 0) == 178206 | ((e + -173783 | 0) >>> 0 < 41 | (e + -177973 | 0) >>> 0 < 11))))) {
          t = 0;
          return t | 0;
        } else return (e + -918e3 | 0) >>> 0 > 196111 | 0;

        return 0;
      }

      function uu(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0,
            m = 0,
            y = 0,
            v = 0,
            _ = 0,
            g = 0,
            A = 0,
            w = 0,
            T = 0;
        T = p;
        p = p + 16 | 0;
        h = T;

        do {
          if (e >>> 0 < 245) {
            d = e >>> 0 < 11 ? 16 : e + 11 & -8;
            e = d >>> 3;
            l = s[3973] | 0;
            a = l >>> e;

            if (a & 3 | 0) {
              r = (a & 1 ^ 1) + e | 0;
              n = 15932 + (r << 1 << 2) | 0;
              t = n + 8 | 0;
              e = s[t >> 2] | 0;
              o = e + 8 | 0;
              a = s[o >> 2] | 0;
              if ((n | 0) == (a | 0)) s[3973] = l & ~(1 << r);else {
                s[a + 12 >> 2] = n;
                s[t >> 2] = a;
              }
              w = r << 3;
              s[e + 4 >> 2] = w | 3;
              w = e + w + 4 | 0;
              s[w >> 2] = s[w >> 2] | 1;
              w = o;
              p = T;
              return w | 0;
            }

            f = s[3975] | 0;

            if (d >>> 0 > f >>> 0) {
              if (a | 0) {
                i = 2 << e;
                a = a << e & (i | 0 - i);
                a = (a & 0 - a) + -1 | 0;
                i = a >>> 12 & 16;
                a = a >>> i;
                e = a >>> 5 & 8;
                a = a >>> e;
                n = a >>> 2 & 4;
                a = a >>> n;
                t = a >>> 1 & 2;
                a = a >>> t;
                r = a >>> 1 & 1;
                r = (e | i | n | t | r) + (a >>> r) | 0;
                a = 15932 + (r << 1 << 2) | 0;
                t = a + 8 | 0;
                n = s[t >> 2] | 0;
                i = n + 8 | 0;
                e = s[i >> 2] | 0;

                if ((a | 0) == (e | 0)) {
                  e = l & ~(1 << r);
                  s[3973] = e;
                } else {
                  s[e + 12 >> 2] = a;
                  s[t >> 2] = e;
                  e = l;
                }

                o = (r << 3) - d | 0;
                s[n + 4 >> 2] = d | 3;
                n = n + d | 0;
                s[n + 4 >> 2] = o | 1;
                s[n + o >> 2] = o;

                if (f | 0) {
                  r = s[3978] | 0;
                  t = f >>> 3;
                  a = 15932 + (t << 1 << 2) | 0;
                  t = 1 << t;

                  if (!(e & t)) {
                    s[3973] = e | t;
                    t = a + 8 | 0;
                    e = a;
                  } else {
                    e = a + 8 | 0;
                    t = e;
                    e = s[e >> 2] | 0;
                  }

                  s[t >> 2] = r;
                  s[e + 12 >> 2] = r;
                  s[r + 8 >> 2] = e;
                  s[r + 12 >> 2] = a;
                }

                s[3975] = o;
                s[3978] = n;
                w = i;
                p = T;
                return w | 0;
              }

              c = s[3974] | 0;

              if (c) {
                a = (c & 0 - c) + -1 | 0;
                i = a >>> 12 & 16;
                a = a >>> i;
                o = a >>> 5 & 8;
                a = a >>> o;
                u = a >>> 2 & 4;
                a = a >>> u;
                e = a >>> 1 & 2;
                a = a >>> e;
                r = a >>> 1 & 1;
                r = s[16196 + ((o | i | u | e | r) + (a >>> r) << 2) >> 2] | 0;
                a = (s[r + 4 >> 2] & -8) - d | 0;
                e = s[r + 16 + (((s[r + 16 >> 2] | 0) == 0 & 1) << 2) >> 2] | 0;

                if (!e) {
                  u = a;
                  i = r;
                } else {
                  do {
                    i = (s[e + 4 >> 2] & -8) - d | 0;
                    u = i >>> 0 < a >>> 0;
                    a = u ? i : a;
                    r = u ? e : r;
                    e = s[e + 16 + (((s[e + 16 >> 2] | 0) == 0 & 1) << 2) >> 2] | 0;
                  } while ((e | 0) != 0);

                  u = a;
                  i = r;
                }

                o = i + d | 0;

                if (i >>> 0 < o >>> 0) {
                  n = s[i + 24 >> 2] | 0;
                  t = s[i + 12 >> 2] | 0;

                  do {
                    if ((t | 0) == (i | 0)) {
                      e = i + 20 | 0;
                      t = s[e >> 2] | 0;

                      if (!t) {
                        e = i + 16 | 0;
                        t = s[e >> 2] | 0;

                        if (!t) {
                          a = 0;
                          break;
                        }
                      }

                      while (1) {
                        r = t + 20 | 0;
                        a = s[r >> 2] | 0;

                        if (a | 0) {
                          t = a;
                          e = r;
                          continue;
                        }

                        r = t + 16 | 0;
                        a = s[r >> 2] | 0;
                        if (!a) break;else {
                          t = a;
                          e = r;
                        }
                      }

                      s[e >> 2] = 0;
                      a = t;
                    } else {
                      a = s[i + 8 >> 2] | 0;
                      s[a + 12 >> 2] = t;
                      s[t + 8 >> 2] = a;
                      a = t;
                    }
                  } while (0);

                  do {
                    if (n | 0) {
                      t = s[i + 28 >> 2] | 0;
                      e = 16196 + (t << 2) | 0;

                      if ((i | 0) == (s[e >> 2] | 0)) {
                        s[e >> 2] = a;

                        if (!a) {
                          s[3974] = c & ~(1 << t);
                          break;
                        }
                      } else {
                        s[n + 16 + (((s[n + 16 >> 2] | 0) != (i | 0) & 1) << 2) >> 2] = a;
                        if (!a) break;
                      }

                      s[a + 24 >> 2] = n;
                      t = s[i + 16 >> 2] | 0;

                      if (t | 0) {
                        s[a + 16 >> 2] = t;
                        s[t + 24 >> 2] = a;
                      }

                      t = s[i + 20 >> 2] | 0;

                      if (t | 0) {
                        s[a + 20 >> 2] = t;
                        s[t + 24 >> 2] = a;
                      }
                    }
                  } while (0);

                  if (u >>> 0 < 16) {
                    w = u + d | 0;
                    s[i + 4 >> 2] = w | 3;
                    w = i + w + 4 | 0;
                    s[w >> 2] = s[w >> 2] | 1;
                  } else {
                    s[i + 4 >> 2] = d | 3;
                    s[o + 4 >> 2] = u | 1;
                    s[o + u >> 2] = u;

                    if (f | 0) {
                      r = s[3978] | 0;
                      t = f >>> 3;
                      a = 15932 + (t << 1 << 2) | 0;
                      t = 1 << t;

                      if (!(l & t)) {
                        s[3973] = l | t;
                        t = a + 8 | 0;
                        e = a;
                      } else {
                        e = a + 8 | 0;
                        t = e;
                        e = s[e >> 2] | 0;
                      }

                      s[t >> 2] = r;
                      s[e + 12 >> 2] = r;
                      s[r + 8 >> 2] = e;
                      s[r + 12 >> 2] = a;
                    }

                    s[3975] = u;
                    s[3978] = o;
                  }

                  w = i + 8 | 0;
                  p = T;
                  return w | 0;
                } else l = d;
              } else l = d;
            } else l = d;
          } else if (e >>> 0 <= 4294967231) {
            e = e + 11 | 0;
            d = e & -8;
            r = s[3974] | 0;

            if (r) {
              a = 0 - d | 0;
              e = e >>> 8;
              if (e) {
                if (d >>> 0 > 16777215) u = 31;else {
                  l = (e + 1048320 | 0) >>> 16 & 8;
                  A = e << l;
                  f = (A + 520192 | 0) >>> 16 & 4;
                  A = A << f;
                  u = (A + 245760 | 0) >>> 16 & 2;
                  u = 14 - (f | l | u) + (A << u >>> 15) | 0;
                  u = d >>> (u + 7 | 0) & 1 | u << 1;
                }
              } else u = 0;
              e = s[16196 + (u << 2) >> 2] | 0;

              e: do {
                if (!e) {
                  n = 0;
                  e = 0;
                  A = 57;
                } else {
                  n = 0;
                  i = d << ((u | 0) == 31 ? 0 : 25 - (u >>> 1) | 0);
                  c = e;
                  e = 0;

                  while (1) {
                    o = (s[c + 4 >> 2] & -8) - d | 0;
                    if (o >>> 0 < a >>> 0) if (!o) {
                      a = 0;
                      n = c;
                      e = c;
                      A = 61;
                      break e;
                    } else {
                      a = o;
                      e = c;
                    }
                    o = s[c + 20 >> 2] | 0;
                    c = s[c + 16 + (i >>> 31 << 2) >> 2] | 0;
                    n = (o | 0) == 0 | (o | 0) == (c | 0) ? n : o;
                    o = (c | 0) == 0;

                    if (o) {
                      A = 57;
                      break;
                    } else i = i << ((o ^ 1) & 1);
                  }
                }
              } while (0);

              if ((A | 0) == 57) {
                if ((n | 0) == 0 & (e | 0) == 0) {
                  e = 2 << u;
                  e = r & (e | 0 - e);

                  if (!e) {
                    l = d;
                    break;
                  }

                  e = (e & 0 - e) + -1 | 0;
                  u = e >>> 12 & 16;
                  e = e >>> u;
                  c = e >>> 5 & 8;
                  e = e >>> c;
                  f = e >>> 2 & 4;
                  e = e >>> f;
                  l = e >>> 1 & 2;
                  e = e >>> l;
                  n = e >>> 1 & 1;
                  n = s[16196 + ((c | u | f | l | n) + (e >>> n) << 2) >> 2] | 0;
                  e = 0;
                }

                if (!n) {
                  c = a;
                  u = e;
                } else A = 61;
              }

              if ((A | 0) == 61) while (1) {
                A = 0;
                f = (s[n + 4 >> 2] & -8) - d | 0;
                l = f >>> 0 < a >>> 0;
                a = l ? f : a;
                e = l ? n : e;
                n = s[n + 16 + (((s[n + 16 >> 2] | 0) == 0 & 1) << 2) >> 2] | 0;

                if (!n) {
                  c = a;
                  u = e;
                  break;
                } else A = 61;
              }

              if ((u | 0) != 0 ? c >>> 0 < ((s[3975] | 0) - d | 0) >>> 0 : 0) {
                i = u + d | 0;

                if (u >>> 0 >= i >>> 0) {
                  w = 0;
                  p = T;
                  return w | 0;
                }

                o = s[u + 24 >> 2] | 0;
                t = s[u + 12 >> 2] | 0;

                do {
                  if ((t | 0) == (u | 0)) {
                    e = u + 20 | 0;
                    t = s[e >> 2] | 0;

                    if (!t) {
                      e = u + 16 | 0;
                      t = s[e >> 2] | 0;

                      if (!t) {
                        t = 0;
                        break;
                      }
                    }

                    while (1) {
                      n = t + 20 | 0;
                      a = s[n >> 2] | 0;

                      if (a | 0) {
                        t = a;
                        e = n;
                        continue;
                      }

                      n = t + 16 | 0;
                      a = s[n >> 2] | 0;
                      if (!a) break;else {
                        t = a;
                        e = n;
                      }
                    }

                    s[e >> 2] = 0;
                  } else {
                    w = s[u + 8 >> 2] | 0;
                    s[w + 12 >> 2] = t;
                    s[t + 8 >> 2] = w;
                  }
                } while (0);

                do {
                  if (o) {
                    e = s[u + 28 >> 2] | 0;
                    a = 16196 + (e << 2) | 0;

                    if ((u | 0) == (s[a >> 2] | 0)) {
                      s[a >> 2] = t;

                      if (!t) {
                        r = r & ~(1 << e);
                        s[3974] = r;
                        break;
                      }
                    } else {
                      s[o + 16 + (((s[o + 16 >> 2] | 0) != (u | 0) & 1) << 2) >> 2] = t;
                      if (!t) break;
                    }

                    s[t + 24 >> 2] = o;
                    e = s[u + 16 >> 2] | 0;

                    if (e | 0) {
                      s[t + 16 >> 2] = e;
                      s[e + 24 >> 2] = t;
                    }

                    e = s[u + 20 >> 2] | 0;

                    if (e) {
                      s[t + 20 >> 2] = e;
                      s[e + 24 >> 2] = t;
                    }
                  }
                } while (0);

                do {
                  if (c >>> 0 >= 16) {
                    s[u + 4 >> 2] = d | 3;
                    s[i + 4 >> 2] = c | 1;
                    s[i + c >> 2] = c;
                    t = c >>> 3;

                    if (c >>> 0 < 256) {
                      a = 15932 + (t << 1 << 2) | 0;
                      e = s[3973] | 0;
                      t = 1 << t;

                      if (!(e & t)) {
                        s[3973] = e | t;
                        t = a + 8 | 0;
                        e = a;
                      } else {
                        e = a + 8 | 0;
                        t = e;
                        e = s[e >> 2] | 0;
                      }

                      s[t >> 2] = i;
                      s[e + 12 >> 2] = i;
                      s[i + 8 >> 2] = e;
                      s[i + 12 >> 2] = a;
                      break;
                    }

                    t = c >>> 8;
                    if (t) {
                      if (c >>> 0 > 16777215) t = 31;else {
                        A = (t + 1048320 | 0) >>> 16 & 8;
                        w = t << A;
                        g = (w + 520192 | 0) >>> 16 & 4;
                        w = w << g;
                        t = (w + 245760 | 0) >>> 16 & 2;
                        t = 14 - (g | A | t) + (w << t >>> 15) | 0;
                        t = c >>> (t + 7 | 0) & 1 | t << 1;
                      }
                    } else t = 0;
                    a = 16196 + (t << 2) | 0;
                    s[i + 28 >> 2] = t;
                    e = i + 16 | 0;
                    s[e + 4 >> 2] = 0;
                    s[e >> 2] = 0;
                    e = 1 << t;

                    if (!(r & e)) {
                      s[3974] = r | e;
                      s[a >> 2] = i;
                      s[i + 24 >> 2] = a;
                      s[i + 12 >> 2] = i;
                      s[i + 8 >> 2] = i;
                      break;
                    }

                    e = c << ((t | 0) == 31 ? 0 : 25 - (t >>> 1) | 0);
                    a = s[a >> 2] | 0;

                    while (1) {
                      if ((s[a + 4 >> 2] & -8 | 0) == (c | 0)) {
                        A = 97;
                        break;
                      }

                      r = a + 16 + (e >>> 31 << 2) | 0;
                      t = s[r >> 2] | 0;

                      if (!t) {
                        A = 96;
                        break;
                      } else {
                        e = e << 1;
                        a = t;
                      }
                    }

                    if ((A | 0) == 96) {
                      s[r >> 2] = i;
                      s[i + 24 >> 2] = a;
                      s[i + 12 >> 2] = i;
                      s[i + 8 >> 2] = i;
                      break;
                    } else if ((A | 0) == 97) {
                      A = a + 8 | 0;
                      w = s[A >> 2] | 0;
                      s[w + 12 >> 2] = i;
                      s[A >> 2] = i;
                      s[i + 8 >> 2] = w;
                      s[i + 12 >> 2] = a;
                      s[i + 24 >> 2] = 0;
                      break;
                    }
                  } else {
                    w = c + d | 0;
                    s[u + 4 >> 2] = w | 3;
                    w = u + w + 4 | 0;
                    s[w >> 2] = s[w >> 2] | 1;
                  }
                } while (0);

                w = u + 8 | 0;
                p = T;
                return w | 0;
              } else l = d;
            } else l = d;
          } else l = -1;
        } while (0);

        a = s[3975] | 0;

        if (a >>> 0 >= l >>> 0) {
          e = a - l | 0;
          t = s[3978] | 0;

          if (e >>> 0 > 15) {
            w = t + l | 0;
            s[3978] = w;
            s[3975] = e;
            s[w + 4 >> 2] = e | 1;
            s[w + e >> 2] = e;
            s[t + 4 >> 2] = l | 3;
          } else {
            s[3975] = 0;
            s[3978] = 0;
            s[t + 4 >> 2] = a | 3;
            w = t + a + 4 | 0;
            s[w >> 2] = s[w >> 2] | 1;
          }

          w = t + 8 | 0;
          p = T;
          return w | 0;
        }

        i = s[3976] | 0;

        if (i >>> 0 > l >>> 0) {
          g = i - l | 0;
          s[3976] = g;
          w = s[3979] | 0;
          A = w + l | 0;
          s[3979] = A;
          s[A + 4 >> 2] = g | 1;
          s[w + 4 >> 2] = l | 3;
          w = w + 8 | 0;
          p = T;
          return w | 0;
        }

        if (!(s[4091] | 0)) {
          s[4093] = 4096;
          s[4092] = 4096;
          s[4094] = -1;
          s[4095] = -1;
          s[4096] = 0;
          s[4084] = 0;
          e = h & -16 ^ 1431655768;
          s[h >> 2] = e;
          s[4091] = e;
          e = 4096;
        } else e = s[4093] | 0;

        c = l + 48 | 0;
        u = l + 47 | 0;
        o = e + u | 0;
        r = 0 - e | 0;
        d = o & r;

        if (d >>> 0 <= l >>> 0) {
          w = 0;
          p = T;
          return w | 0;
        }

        e = s[4083] | 0;

        if (e | 0 ? (f = s[4081] | 0, h = f + d | 0, h >>> 0 <= f >>> 0 | h >>> 0 > e >>> 0) : 0) {
          w = 0;
          p = T;
          return w | 0;
        }

        e: do {
          if (!(s[4084] & 4)) {
            a = s[3979] | 0;

            t: do {
              if (a) {
                n = 16340;

                while (1) {
                  e = s[n >> 2] | 0;
                  if (e >>> 0 <= a >>> 0 ? (y = n + 4 | 0, (e + (s[y >> 2] | 0) | 0) >>> 0 > a >>> 0) : 0) break;
                  e = s[n + 8 >> 2] | 0;

                  if (!e) {
                    A = 118;
                    break t;
                  } else n = e;
                }

                t = o - i & r;

                if (t >>> 0 < 2147483647) {
                  e = dd(t | 0) | 0;

                  if ((e | 0) == ((s[n >> 2] | 0) + (s[y >> 2] | 0) | 0)) {
                    if ((e | 0) != (-1 | 0)) {
                      i = e;
                      o = t;
                      A = 135;
                      break e;
                    }
                  } else {
                    r = e;
                    A = 126;
                  }
                } else t = 0;
              } else A = 118;
            } while (0);

            do {
              if ((A | 0) == 118) {
                a = dd(0) | 0;

                if ((a | 0) != (-1 | 0) ? (t = a, b = s[4092] | 0, m = b + -1 | 0, t = ((m & t | 0) == 0 ? 0 : (m + t & 0 - b) - t | 0) + d | 0, b = s[4081] | 0, m = t + b | 0, t >>> 0 > l >>> 0 & t >>> 0 < 2147483647) : 0) {
                  y = s[4083] | 0;

                  if (y | 0 ? m >>> 0 <= b >>> 0 | m >>> 0 > y >>> 0 : 0) {
                    t = 0;
                    break;
                  }

                  e = dd(t | 0) | 0;

                  if ((e | 0) == (a | 0)) {
                    i = a;
                    o = t;
                    A = 135;
                    break e;
                  } else {
                    r = e;
                    A = 126;
                  }
                } else t = 0;
              }
            } while (0);

            do {
              if ((A | 0) == 126) {
                a = 0 - t | 0;
                if (!(c >>> 0 > t >>> 0 & (t >>> 0 < 2147483647 & (r | 0) != (-1 | 0)))) if ((r | 0) == (-1 | 0)) {
                  t = 0;
                  break;
                } else {
                  i = r;
                  o = t;
                  A = 135;
                  break e;
                }
                e = s[4093] | 0;
                e = u - t + e & 0 - e;

                if (e >>> 0 >= 2147483647) {
                  i = r;
                  o = t;
                  A = 135;
                  break e;
                }

                if ((dd(e | 0) | 0) == (-1 | 0)) {
                  dd(a | 0) | 0;
                  t = 0;
                  break;
                } else {
                  i = r;
                  o = e + t | 0;
                  A = 135;
                  break e;
                }
              }
            } while (0);

            s[4084] = s[4084] | 4;
            A = 133;
          } else {
            t = 0;
            A = 133;
          }
        } while (0);

        if (((A | 0) == 133 ? d >>> 0 < 2147483647 : 0) ? (v = dd(d | 0) | 0, y = dd(0) | 0, g = y - v | 0, _ = g >>> 0 > (l + 40 | 0) >>> 0, !((v | 0) == (-1 | 0) | _ ^ 1 | v >>> 0 < y >>> 0 & ((v | 0) != (-1 | 0) & (y | 0) != (-1 | 0)) ^ 1)) : 0) {
          i = v;
          o = _ ? g : t;
          A = 135;
        }

        if ((A | 0) == 135) {
          t = (s[4081] | 0) + o | 0;
          s[4081] = t;
          if (t >>> 0 > (s[4082] | 0) >>> 0) s[4082] = t;
          u = s[3979] | 0;

          do {
            if (u) {
              n = 16340;

              while (1) {
                t = s[n >> 2] | 0;
                r = n + 4 | 0;
                e = s[r >> 2] | 0;

                if ((i | 0) == (t + e | 0)) {
                  A = 145;
                  break;
                }

                a = s[n + 8 >> 2] | 0;
                if (!a) break;else n = a;
              }

              if (((A | 0) == 145 ? (s[n + 12 >> 2] & 8 | 0) == 0 : 0) ? u >>> 0 < i >>> 0 & u >>> 0 >= t >>> 0 : 0) {
                s[r >> 2] = e + o;
                w = u + 8 | 0;
                w = (w & 7 | 0) == 0 ? 0 : 0 - w & 7;
                A = u + w | 0;
                w = (s[3976] | 0) + (o - w) | 0;
                s[3979] = A;
                s[3976] = w;
                s[A + 4 >> 2] = w | 1;
                s[A + w + 4 >> 2] = 40;
                s[3980] = s[4095];
                break;
              }

              if (i >>> 0 < (s[3977] | 0) >>> 0) s[3977] = i;
              a = i + o | 0;
              e = 16340;

              while (1) {
                if ((s[e >> 2] | 0) == (a | 0)) {
                  A = 153;
                  break;
                }

                t = s[e + 8 >> 2] | 0;
                if (!t) break;else e = t;
              }

              if ((A | 0) == 153 ? (s[e + 12 >> 2] & 8 | 0) == 0 : 0) {
                s[e >> 2] = i;
                f = e + 4 | 0;
                s[f >> 2] = (s[f >> 2] | 0) + o;
                f = i + 8 | 0;
                f = i + ((f & 7 | 0) == 0 ? 0 : 0 - f & 7) | 0;
                t = a + 8 | 0;
                t = a + ((t & 7 | 0) == 0 ? 0 : 0 - t & 7) | 0;
                d = f + l | 0;
                c = t - f - l | 0;
                s[f + 4 >> 2] = l | 3;

                do {
                  if ((t | 0) != (u | 0)) {
                    if ((t | 0) == (s[3978] | 0)) {
                      w = (s[3975] | 0) + c | 0;
                      s[3975] = w;
                      s[3978] = d;
                      s[d + 4 >> 2] = w | 1;
                      s[d + w >> 2] = w;
                      break;
                    }

                    e = s[t + 4 >> 2] | 0;

                    if ((e & 3 | 0) == 1) {
                      i = e & -8;
                      r = e >>> 3;

                      e: do {
                        if (e >>> 0 < 256) {
                          e = s[t + 8 >> 2] | 0;
                          a = s[t + 12 >> 2] | 0;

                          if ((a | 0) == (e | 0)) {
                            s[3973] = s[3973] & ~(1 << r);
                            break;
                          } else {
                            s[e + 12 >> 2] = a;
                            s[a + 8 >> 2] = e;
                            break;
                          }
                        } else {
                          o = s[t + 24 >> 2] | 0;
                          e = s[t + 12 >> 2] | 0;

                          do {
                            if ((e | 0) == (t | 0)) {
                              r = t + 16 | 0;
                              a = r + 4 | 0;
                              e = s[a >> 2] | 0;

                              if (!e) {
                                e = s[r >> 2] | 0;

                                if (!e) {
                                  e = 0;
                                  break;
                                } else n = r;
                              } else n = a;

                              while (1) {
                                r = e + 20 | 0;
                                a = s[r >> 2] | 0;

                                if (a | 0) {
                                  e = a;
                                  n = r;
                                  continue;
                                }

                                r = e + 16 | 0;
                                a = s[r >> 2] | 0;
                                if (!a) break;else {
                                  e = a;
                                  n = r;
                                }
                              }

                              s[n >> 2] = 0;
                            } else {
                              w = s[t + 8 >> 2] | 0;
                              s[w + 12 >> 2] = e;
                              s[e + 8 >> 2] = w;
                            }
                          } while (0);

                          if (!o) break;
                          a = s[t + 28 >> 2] | 0;
                          r = 16196 + (a << 2) | 0;

                          do {
                            if ((t | 0) != (s[r >> 2] | 0)) {
                              s[o + 16 + (((s[o + 16 >> 2] | 0) != (t | 0) & 1) << 2) >> 2] = e;
                              if (!e) break e;
                            } else {
                              s[r >> 2] = e;
                              if (e | 0) break;
                              s[3974] = s[3974] & ~(1 << a);
                              break e;
                            }
                          } while (0);

                          s[e + 24 >> 2] = o;
                          r = t + 16 | 0;
                          a = s[r >> 2] | 0;

                          if (a | 0) {
                            s[e + 16 >> 2] = a;
                            s[a + 24 >> 2] = e;
                          }

                          a = s[r + 4 >> 2] | 0;
                          if (!a) break;
                          s[e + 20 >> 2] = a;
                          s[a + 24 >> 2] = e;
                        }
                      } while (0);

                      t = t + i | 0;
                      n = i + c | 0;
                    } else n = c;

                    t = t + 4 | 0;
                    s[t >> 2] = s[t >> 2] & -2;
                    s[d + 4 >> 2] = n | 1;
                    s[d + n >> 2] = n;
                    t = n >>> 3;

                    if (n >>> 0 < 256) {
                      a = 15932 + (t << 1 << 2) | 0;
                      e = s[3973] | 0;
                      t = 1 << t;

                      if (!(e & t)) {
                        s[3973] = e | t;
                        t = a + 8 | 0;
                        e = a;
                      } else {
                        e = a + 8 | 0;
                        t = e;
                        e = s[e >> 2] | 0;
                      }

                      s[t >> 2] = d;
                      s[e + 12 >> 2] = d;
                      s[d + 8 >> 2] = e;
                      s[d + 12 >> 2] = a;
                      break;
                    }

                    t = n >>> 8;

                    do {
                      if (!t) e = 0;else {
                        if (n >>> 0 > 16777215) {
                          e = 31;
                          break;
                        }

                        A = (t + 1048320 | 0) >>> 16 & 8;
                        w = t << A;
                        g = (w + 520192 | 0) >>> 16 & 4;
                        w = w << g;
                        e = (w + 245760 | 0) >>> 16 & 2;
                        e = 14 - (g | A | e) + (w << e >>> 15) | 0;
                        e = n >>> (e + 7 | 0) & 1 | e << 1;
                      }
                    } while (0);

                    r = 16196 + (e << 2) | 0;
                    s[d + 28 >> 2] = e;
                    t = d + 16 | 0;
                    s[t + 4 >> 2] = 0;
                    s[t >> 2] = 0;
                    t = s[3974] | 0;
                    a = 1 << e;

                    if (!(t & a)) {
                      s[3974] = t | a;
                      s[r >> 2] = d;
                      s[d + 24 >> 2] = r;
                      s[d + 12 >> 2] = d;
                      s[d + 8 >> 2] = d;
                      break;
                    }

                    e = n << ((e | 0) == 31 ? 0 : 25 - (e >>> 1) | 0);
                    a = s[r >> 2] | 0;

                    while (1) {
                      if ((s[a + 4 >> 2] & -8 | 0) == (n | 0)) {
                        A = 194;
                        break;
                      }

                      r = a + 16 + (e >>> 31 << 2) | 0;
                      t = s[r >> 2] | 0;

                      if (!t) {
                        A = 193;
                        break;
                      } else {
                        e = e << 1;
                        a = t;
                      }
                    }

                    if ((A | 0) == 193) {
                      s[r >> 2] = d;
                      s[d + 24 >> 2] = a;
                      s[d + 12 >> 2] = d;
                      s[d + 8 >> 2] = d;
                      break;
                    } else if ((A | 0) == 194) {
                      A = a + 8 | 0;
                      w = s[A >> 2] | 0;
                      s[w + 12 >> 2] = d;
                      s[A >> 2] = d;
                      s[d + 8 >> 2] = w;
                      s[d + 12 >> 2] = a;
                      s[d + 24 >> 2] = 0;
                      break;
                    }
                  } else {
                    w = (s[3976] | 0) + c | 0;
                    s[3976] = w;
                    s[3979] = d;
                    s[d + 4 >> 2] = w | 1;
                  }
                } while (0);

                w = f + 8 | 0;
                p = T;
                return w | 0;
              }

              e = 16340;

              while (1) {
                t = s[e >> 2] | 0;
                if (t >>> 0 <= u >>> 0 ? (w = t + (s[e + 4 >> 2] | 0) | 0, w >>> 0 > u >>> 0) : 0) break;
                e = s[e + 8 >> 2] | 0;
              }

              n = w + -47 | 0;
              e = n + 8 | 0;
              e = n + ((e & 7 | 0) == 0 ? 0 : 0 - e & 7) | 0;
              n = u + 16 | 0;
              e = e >>> 0 < n >>> 0 ? u : e;
              t = e + 8 | 0;
              a = i + 8 | 0;
              a = (a & 7 | 0) == 0 ? 0 : 0 - a & 7;
              A = i + a | 0;
              a = o + -40 - a | 0;
              s[3979] = A;
              s[3976] = a;
              s[A + 4 >> 2] = a | 1;
              s[A + a + 4 >> 2] = 40;
              s[3980] = s[4095];
              a = e + 4 | 0;
              s[a >> 2] = 27;
              s[t >> 2] = s[4085];
              s[t + 4 >> 2] = s[4086];
              s[t + 8 >> 2] = s[4087];
              s[t + 12 >> 2] = s[4088];
              s[4085] = i;
              s[4086] = o;
              s[4088] = 0;
              s[4087] = t;
              t = e + 24 | 0;

              do {
                A = t;
                t = t + 4 | 0;
                s[t >> 2] = 7;
              } while ((A + 8 | 0) >>> 0 < w >>> 0);

              if ((e | 0) != (u | 0)) {
                o = e - u | 0;
                s[a >> 2] = s[a >> 2] & -2;
                s[u + 4 >> 2] = o | 1;
                s[e >> 2] = o;
                t = o >>> 3;

                if (o >>> 0 < 256) {
                  a = 15932 + (t << 1 << 2) | 0;
                  e = s[3973] | 0;
                  t = 1 << t;

                  if (!(e & t)) {
                    s[3973] = e | t;
                    t = a + 8 | 0;
                    e = a;
                  } else {
                    e = a + 8 | 0;
                    t = e;
                    e = s[e >> 2] | 0;
                  }

                  s[t >> 2] = u;
                  s[e + 12 >> 2] = u;
                  s[u + 8 >> 2] = e;
                  s[u + 12 >> 2] = a;
                  break;
                }

                t = o >>> 8;
                if (t) {
                  if (o >>> 0 > 16777215) a = 31;else {
                    A = (t + 1048320 | 0) >>> 16 & 8;
                    w = t << A;
                    g = (w + 520192 | 0) >>> 16 & 4;
                    w = w << g;
                    a = (w + 245760 | 0) >>> 16 & 2;
                    a = 14 - (g | A | a) + (w << a >>> 15) | 0;
                    a = o >>> (a + 7 | 0) & 1 | a << 1;
                  }
                } else a = 0;
                r = 16196 + (a << 2) | 0;
                s[u + 28 >> 2] = a;
                s[u + 20 >> 2] = 0;
                s[n >> 2] = 0;
                t = s[3974] | 0;
                e = 1 << a;

                if (!(t & e)) {
                  s[3974] = t | e;
                  s[r >> 2] = u;
                  s[u + 24 >> 2] = r;
                  s[u + 12 >> 2] = u;
                  s[u + 8 >> 2] = u;
                  break;
                }

                e = o << ((a | 0) == 31 ? 0 : 25 - (a >>> 1) | 0);
                a = s[r >> 2] | 0;

                while (1) {
                  if ((s[a + 4 >> 2] & -8 | 0) == (o | 0)) {
                    A = 216;
                    break;
                  }

                  r = a + 16 + (e >>> 31 << 2) | 0;
                  t = s[r >> 2] | 0;

                  if (!t) {
                    A = 215;
                    break;
                  } else {
                    e = e << 1;
                    a = t;
                  }
                }

                if ((A | 0) == 215) {
                  s[r >> 2] = u;
                  s[u + 24 >> 2] = a;
                  s[u + 12 >> 2] = u;
                  s[u + 8 >> 2] = u;
                  break;
                } else if ((A | 0) == 216) {
                  A = a + 8 | 0;
                  w = s[A >> 2] | 0;
                  s[w + 12 >> 2] = u;
                  s[A >> 2] = u;
                  s[u + 8 >> 2] = w;
                  s[u + 12 >> 2] = a;
                  s[u + 24 >> 2] = 0;
                  break;
                }
              }
            } else {
              w = s[3977] | 0;
              if ((w | 0) == 0 | i >>> 0 < w >>> 0) s[3977] = i;
              s[4085] = i;
              s[4086] = o;
              s[4088] = 0;
              s[3982] = s[4091];
              s[3981] = -1;
              t = 0;

              do {
                w = 15932 + (t << 1 << 2) | 0;
                s[w + 12 >> 2] = w;
                s[w + 8 >> 2] = w;
                t = t + 1 | 0;
              } while ((t | 0) != 32);

              w = i + 8 | 0;
              w = (w & 7 | 0) == 0 ? 0 : 0 - w & 7;
              A = i + w | 0;
              w = o + -40 - w | 0;
              s[3979] = A;
              s[3976] = w;
              s[A + 4 >> 2] = w | 1;
              s[A + w + 4 >> 2] = 40;
              s[3980] = s[4095];
            }
          } while (0);

          t = s[3976] | 0;

          if (t >>> 0 > l >>> 0) {
            g = t - l | 0;
            s[3976] = g;
            w = s[3979] | 0;
            A = w + l | 0;
            s[3979] = A;
            s[A + 4 >> 2] = g | 1;
            s[w + 4 >> 2] = l | 3;
            w = w + 8 | 0;
            p = T;
            return w | 0;
          }
        }

        s[(gu() | 0) >> 2] = 12;
        w = 0;
        p = T;
        return w | 0;
      }

      function du(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0;
        if (!e) return;
        a = e + -8 | 0;
        r = s[3977] | 0;
        e = s[e + -4 >> 2] | 0;
        t = e & -8;
        d = a + t | 0;

        do {
          if (!(e & 1)) {
            n = s[a >> 2] | 0;
            if (!(e & 3)) return;
            o = a + (0 - n) | 0;
            i = n + t | 0;
            if (o >>> 0 < r >>> 0) return;

            if ((o | 0) == (s[3978] | 0)) {
              t = d + 4 | 0;
              e = s[t >> 2] | 0;

              if ((e & 3 | 0) != 3) {
                c = o;
                u = o;
                t = i;
                break;
              }

              s[3975] = i;
              s[t >> 2] = e & -2;
              s[o + 4 >> 2] = i | 1;
              s[o + i >> 2] = i;
              return;
            }

            a = n >>> 3;

            if (n >>> 0 < 256) {
              e = s[o + 8 >> 2] | 0;
              t = s[o + 12 >> 2] | 0;

              if ((t | 0) == (e | 0)) {
                s[3973] = s[3973] & ~(1 << a);
                c = o;
                u = o;
                t = i;
                break;
              } else {
                s[e + 12 >> 2] = t;
                s[t + 8 >> 2] = e;
                c = o;
                u = o;
                t = i;
                break;
              }
            }

            n = s[o + 24 >> 2] | 0;
            e = s[o + 12 >> 2] | 0;

            do {
              if ((e | 0) == (o | 0)) {
                a = o + 16 | 0;
                t = a + 4 | 0;
                e = s[t >> 2] | 0;

                if (!e) {
                  e = s[a >> 2] | 0;

                  if (!e) {
                    a = 0;
                    break;
                  } else r = a;
                } else r = t;

                while (1) {
                  a = e + 20 | 0;
                  t = s[a >> 2] | 0;

                  if (t | 0) {
                    e = t;
                    r = a;
                    continue;
                  }

                  a = e + 16 | 0;
                  t = s[a >> 2] | 0;
                  if (!t) break;else {
                    e = t;
                    r = a;
                  }
                }

                s[r >> 2] = 0;
                a = e;
              } else {
                a = s[o + 8 >> 2] | 0;
                s[a + 12 >> 2] = e;
                s[e + 8 >> 2] = a;
                a = e;
              }
            } while (0);

            if (n) {
              e = s[o + 28 >> 2] | 0;
              t = 16196 + (e << 2) | 0;

              if ((o | 0) == (s[t >> 2] | 0)) {
                s[t >> 2] = a;

                if (!a) {
                  s[3974] = s[3974] & ~(1 << e);
                  c = o;
                  u = o;
                  t = i;
                  break;
                }
              } else {
                s[n + 16 + (((s[n + 16 >> 2] | 0) != (o | 0) & 1) << 2) >> 2] = a;

                if (!a) {
                  c = o;
                  u = o;
                  t = i;
                  break;
                }
              }

              s[a + 24 >> 2] = n;
              t = o + 16 | 0;
              e = s[t >> 2] | 0;

              if (e | 0) {
                s[a + 16 >> 2] = e;
                s[e + 24 >> 2] = a;
              }

              e = s[t + 4 >> 2] | 0;

              if (e) {
                s[a + 20 >> 2] = e;
                s[e + 24 >> 2] = a;
                c = o;
                u = o;
                t = i;
              } else {
                c = o;
                u = o;
                t = i;
              }
            } else {
              c = o;
              u = o;
              t = i;
            }
          } else {
            c = a;
            u = a;
          }
        } while (0);

        if (c >>> 0 >= d >>> 0) return;
        e = d + 4 | 0;
        r = s[e >> 2] | 0;
        if (!(r & 1)) return;

        if (!(r & 2)) {
          e = s[3978] | 0;

          if ((d | 0) == (s[3979] | 0)) {
            d = (s[3976] | 0) + t | 0;
            s[3976] = d;
            s[3979] = u;
            s[u + 4 >> 2] = d | 1;
            if ((u | 0) != (e | 0)) return;
            s[3978] = 0;
            s[3975] = 0;
            return;
          }

          if ((d | 0) == (e | 0)) {
            d = (s[3975] | 0) + t | 0;
            s[3975] = d;
            s[3978] = c;
            s[u + 4 >> 2] = d | 1;
            s[c + d >> 2] = d;
            return;
          }

          n = (r & -8) + t | 0;
          a = r >>> 3;

          do {
            if (r >>> 0 < 256) {
              t = s[d + 8 >> 2] | 0;
              e = s[d + 12 >> 2] | 0;

              if ((e | 0) == (t | 0)) {
                s[3973] = s[3973] & ~(1 << a);
                break;
              } else {
                s[t + 12 >> 2] = e;
                s[e + 8 >> 2] = t;
                break;
              }
            } else {
              o = s[d + 24 >> 2] | 0;
              e = s[d + 12 >> 2] | 0;

              do {
                if ((e | 0) == (d | 0)) {
                  a = d + 16 | 0;
                  t = a + 4 | 0;
                  e = s[t >> 2] | 0;

                  if (!e) {
                    e = s[a >> 2] | 0;

                    if (!e) {
                      a = 0;
                      break;
                    } else r = a;
                  } else r = t;

                  while (1) {
                    a = e + 20 | 0;
                    t = s[a >> 2] | 0;

                    if (t | 0) {
                      e = t;
                      r = a;
                      continue;
                    }

                    a = e + 16 | 0;
                    t = s[a >> 2] | 0;
                    if (!t) break;else {
                      e = t;
                      r = a;
                    }
                  }

                  s[r >> 2] = 0;
                  a = e;
                } else {
                  a = s[d + 8 >> 2] | 0;
                  s[a + 12 >> 2] = e;
                  s[e + 8 >> 2] = a;
                  a = e;
                }
              } while (0);

              if (o | 0) {
                e = s[d + 28 >> 2] | 0;
                t = 16196 + (e << 2) | 0;

                if ((d | 0) == (s[t >> 2] | 0)) {
                  s[t >> 2] = a;

                  if (!a) {
                    s[3974] = s[3974] & ~(1 << e);
                    break;
                  }
                } else {
                  s[o + 16 + (((s[o + 16 >> 2] | 0) != (d | 0) & 1) << 2) >> 2] = a;
                  if (!a) break;
                }

                s[a + 24 >> 2] = o;
                t = d + 16 | 0;
                e = s[t >> 2] | 0;

                if (e | 0) {
                  s[a + 16 >> 2] = e;
                  s[e + 24 >> 2] = a;
                }

                e = s[t + 4 >> 2] | 0;

                if (e | 0) {
                  s[a + 20 >> 2] = e;
                  s[e + 24 >> 2] = a;
                }
              }
            }
          } while (0);

          s[u + 4 >> 2] = n | 1;
          s[c + n >> 2] = n;

          if ((u | 0) == (s[3978] | 0)) {
            s[3975] = n;
            return;
          }
        } else {
          s[e >> 2] = r & -2;
          s[u + 4 >> 2] = t | 1;
          s[c + t >> 2] = t;
          n = t;
        }

        e = n >>> 3;

        if (n >>> 0 < 256) {
          a = 15932 + (e << 1 << 2) | 0;
          t = s[3973] | 0;
          e = 1 << e;

          if (!(t & e)) {
            s[3973] = t | e;
            e = a + 8 | 0;
            t = a;
          } else {
            t = a + 8 | 0;
            e = t;
            t = s[t >> 2] | 0;
          }

          s[e >> 2] = u;
          s[t + 12 >> 2] = u;
          s[u + 8 >> 2] = t;
          s[u + 12 >> 2] = a;
          return;
        }

        e = n >>> 8;
        if (e) {
          if (n >>> 0 > 16777215) t = 31;else {
            c = (e + 1048320 | 0) >>> 16 & 8;
            d = e << c;
            i = (d + 520192 | 0) >>> 16 & 4;
            d = d << i;
            t = (d + 245760 | 0) >>> 16 & 2;
            t = 14 - (i | c | t) + (d << t >>> 15) | 0;
            t = n >>> (t + 7 | 0) & 1 | t << 1;
          }
        } else t = 0;
        r = 16196 + (t << 2) | 0;
        s[u + 28 >> 2] = t;
        s[u + 20 >> 2] = 0;
        s[u + 16 >> 2] = 0;
        e = s[3974] | 0;
        a = 1 << t;

        do {
          if (e & a) {
            t = n << ((t | 0) == 31 ? 0 : 25 - (t >>> 1) | 0);
            a = s[r >> 2] | 0;

            while (1) {
              if ((s[a + 4 >> 2] & -8 | 0) == (n | 0)) {
                e = 73;
                break;
              }

              r = a + 16 + (t >>> 31 << 2) | 0;
              e = s[r >> 2] | 0;

              if (!e) {
                e = 72;
                break;
              } else {
                t = t << 1;
                a = e;
              }
            }

            if ((e | 0) == 72) {
              s[r >> 2] = u;
              s[u + 24 >> 2] = a;
              s[u + 12 >> 2] = u;
              s[u + 8 >> 2] = u;
              break;
            } else if ((e | 0) == 73) {
              c = a + 8 | 0;
              d = s[c >> 2] | 0;
              s[d + 12 >> 2] = u;
              s[c >> 2] = u;
              s[u + 8 >> 2] = d;
              s[u + 12 >> 2] = a;
              s[u + 24 >> 2] = 0;
              break;
            }
          } else {
            s[3974] = e | a;
            s[r >> 2] = u;
            s[u + 24 >> 2] = r;
            s[u + 12 >> 2] = u;
            s[u + 8 >> 2] = u;
          }
        } while (0);

        d = (s[3981] | 0) + -1 | 0;
        s[3981] = d;
        if (!d) e = 16348;else return;

        while (1) {
          e = s[e >> 2] | 0;
          if (!e) break;else e = e + 8 | 0;
        }

        s[3981] = -1;
        return;
      }

      function fu(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0;

        if (!e) {
          e = uu(t) | 0;
          return e | 0;
        }

        if (t >>> 0 > 4294967231) {
          s[(gu() | 0) >> 2] = 12;
          e = 0;
          return e | 0;
        }

        a = lu(e + -8 | 0, t >>> 0 < 11 ? 16 : t + 11 & -8) | 0;

        if (a | 0) {
          e = a + 8 | 0;
          return e | 0;
        }

        a = uu(t) | 0;

        if (!a) {
          e = 0;
          return e | 0;
        }

        r = s[e + -4 >> 2] | 0;
        r = (r & -8) - ((r & 3 | 0) == 0 ? 8 : 4) | 0;
        id(a | 0, e | 0, (r >>> 0 < t >>> 0 ? r : t) | 0) | 0;
        du(e);
        e = a;
        return e | 0;
      }

      function lu(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0;
        l = e + 4 | 0;
        f = s[l >> 2] | 0;
        a = f & -8;
        c = e + a | 0;

        if (!(f & 3)) {
          if (t >>> 0 < 256) {
            e = 0;
            return e | 0;
          }

          if (a >>> 0 >= (t + 4 | 0) >>> 0 ? (a - t | 0) >>> 0 <= s[4093] << 1 >>> 0 : 0) return e | 0;
          e = 0;
          return e | 0;
        }

        if (a >>> 0 >= t >>> 0) {
          a = a - t | 0;
          if (a >>> 0 <= 15) return e | 0;
          d = e + t | 0;
          s[l >> 2] = f & 1 | t | 2;
          s[d + 4 >> 2] = a | 3;
          t = d + a + 4 | 0;
          s[t >> 2] = s[t >> 2] | 1;
          hu(d, a);
          return e | 0;
        }

        if ((c | 0) == (s[3979] | 0)) {
          d = (s[3976] | 0) + a | 0;
          r = d - t | 0;
          a = e + t | 0;

          if (d >>> 0 <= t >>> 0) {
            e = 0;
            return e | 0;
          }

          s[l >> 2] = f & 1 | t | 2;
          s[a + 4 >> 2] = r | 1;
          s[3979] = a;
          s[3976] = r;
          return e | 0;
        }

        if ((c | 0) == (s[3978] | 0)) {
          n = (s[3975] | 0) + a | 0;

          if (n >>> 0 < t >>> 0) {
            e = 0;
            return e | 0;
          }

          a = n - t | 0;
          r = f & 1;

          if (a >>> 0 > 15) {
            f = e + t | 0;
            d = f + a | 0;
            s[l >> 2] = r | t | 2;
            s[f + 4 >> 2] = a | 1;
            s[d >> 2] = a;
            r = d + 4 | 0;
            s[r >> 2] = s[r >> 2] & -2;
            r = f;
          } else {
            s[l >> 2] = r | n | 2;
            r = e + n + 4 | 0;
            s[r >> 2] = s[r >> 2] | 1;
            r = 0;
            a = 0;
          }

          s[3975] = a;
          s[3978] = r;
          return e | 0;
        }

        r = s[c + 4 >> 2] | 0;

        if (r & 2 | 0) {
          e = 0;
          return e | 0;
        }

        u = (r & -8) + a | 0;

        if (u >>> 0 < t >>> 0) {
          e = 0;
          return e | 0;
        }

        d = u - t | 0;
        n = r >>> 3;

        do {
          if (r >>> 0 < 256) {
            r = s[c + 8 >> 2] | 0;
            a = s[c + 12 >> 2] | 0;

            if ((a | 0) == (r | 0)) {
              s[3973] = s[3973] & ~(1 << n);
              break;
            } else {
              s[r + 12 >> 2] = a;
              s[a + 8 >> 2] = r;
              break;
            }
          } else {
            i = s[c + 24 >> 2] | 0;
            a = s[c + 12 >> 2] | 0;

            do {
              if ((a | 0) == (c | 0)) {
                n = c + 16 | 0;
                r = n + 4 | 0;
                a = s[r >> 2] | 0;

                if (!a) {
                  a = s[n >> 2] | 0;

                  if (!a) {
                    n = 0;
                    break;
                  } else o = n;
                } else o = r;

                while (1) {
                  n = a + 20 | 0;
                  r = s[n >> 2] | 0;

                  if (r | 0) {
                    a = r;
                    o = n;
                    continue;
                  }

                  n = a + 16 | 0;
                  r = s[n >> 2] | 0;
                  if (!r) break;else {
                    a = r;
                    o = n;
                  }
                }

                s[o >> 2] = 0;
                n = a;
              } else {
                n = s[c + 8 >> 2] | 0;
                s[n + 12 >> 2] = a;
                s[a + 8 >> 2] = n;
                n = a;
              }
            } while (0);

            if (i | 0) {
              a = s[c + 28 >> 2] | 0;
              r = 16196 + (a << 2) | 0;

              if ((c | 0) == (s[r >> 2] | 0)) {
                s[r >> 2] = n;

                if (!n) {
                  s[3974] = s[3974] & ~(1 << a);
                  break;
                }
              } else {
                s[i + 16 + (((s[i + 16 >> 2] | 0) != (c | 0) & 1) << 2) >> 2] = n;
                if (!n) break;
              }

              s[n + 24 >> 2] = i;
              r = c + 16 | 0;
              a = s[r >> 2] | 0;

              if (a | 0) {
                s[n + 16 >> 2] = a;
                s[a + 24 >> 2] = n;
              }

              a = s[r + 4 >> 2] | 0;

              if (a | 0) {
                s[n + 20 >> 2] = a;
                s[a + 24 >> 2] = n;
              }
            }
          }
        } while (0);

        a = f & 1;

        if (d >>> 0 < 16) {
          s[l >> 2] = u | a | 2;
          t = e + u + 4 | 0;
          s[t >> 2] = s[t >> 2] | 1;
          return e | 0;
        } else {
          f = e + t | 0;
          s[l >> 2] = a | t | 2;
          s[f + 4 >> 2] = d | 3;
          t = f + d + 4 | 0;
          s[t >> 2] = s[t >> 2] | 1;
          hu(f, d);
          return e | 0;
        }

        return 0;
      }

      function hu(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0;
        u = e + t | 0;
        a = s[e + 4 >> 2] | 0;

        do {
          if (!(a & 1)) {
            r = s[e >> 2] | 0;
            if (!(a & 3)) return;
            o = e + (0 - r) | 0;
            i = r + t | 0;

            if ((o | 0) == (s[3978] | 0)) {
              e = u + 4 | 0;
              a = s[e >> 2] | 0;

              if ((a & 3 | 0) != 3) {
                c = o;
                e = i;
                break;
              }

              s[3975] = i;
              s[e >> 2] = a & -2;
              s[o + 4 >> 2] = i | 1;
              s[o + i >> 2] = i;
              return;
            }

            t = r >>> 3;

            if (r >>> 0 < 256) {
              a = s[o + 8 >> 2] | 0;
              e = s[o + 12 >> 2] | 0;

              if ((e | 0) == (a | 0)) {
                s[3973] = s[3973] & ~(1 << t);
                c = o;
                e = i;
                break;
              } else {
                s[a + 12 >> 2] = e;
                s[e + 8 >> 2] = a;
                c = o;
                e = i;
                break;
              }
            }

            n = s[o + 24 >> 2] | 0;
            a = s[o + 12 >> 2] | 0;

            do {
              if ((a | 0) == (o | 0)) {
                t = o + 16 | 0;
                e = t + 4 | 0;
                a = s[e >> 2] | 0;

                if (!a) {
                  a = s[t >> 2] | 0;

                  if (!a) {
                    t = 0;
                    break;
                  } else r = t;
                } else r = e;

                while (1) {
                  t = a + 20 | 0;
                  e = s[t >> 2] | 0;

                  if (e | 0) {
                    a = e;
                    r = t;
                    continue;
                  }

                  t = a + 16 | 0;
                  e = s[t >> 2] | 0;
                  if (!e) break;else {
                    a = e;
                    r = t;
                  }
                }

                s[r >> 2] = 0;
                t = a;
              } else {
                t = s[o + 8 >> 2] | 0;
                s[t + 12 >> 2] = a;
                s[a + 8 >> 2] = t;
                t = a;
              }
            } while (0);

            if (n) {
              a = s[o + 28 >> 2] | 0;
              e = 16196 + (a << 2) | 0;

              if ((o | 0) == (s[e >> 2] | 0)) {
                s[e >> 2] = t;

                if (!t) {
                  s[3974] = s[3974] & ~(1 << a);
                  c = o;
                  e = i;
                  break;
                }
              } else {
                s[n + 16 + (((s[n + 16 >> 2] | 0) != (o | 0) & 1) << 2) >> 2] = t;

                if (!t) {
                  c = o;
                  e = i;
                  break;
                }
              }

              s[t + 24 >> 2] = n;
              e = o + 16 | 0;
              a = s[e >> 2] | 0;

              if (a | 0) {
                s[t + 16 >> 2] = a;
                s[a + 24 >> 2] = t;
              }

              a = s[e + 4 >> 2] | 0;

              if (a) {
                s[t + 20 >> 2] = a;
                s[a + 24 >> 2] = t;
                c = o;
                e = i;
              } else {
                c = o;
                e = i;
              }
            } else {
              c = o;
              e = i;
            }
          } else {
            c = e;
            e = t;
          }
        } while (0);

        a = u + 4 | 0;
        r = s[a >> 2] | 0;

        if (!(r & 2)) {
          a = s[3978] | 0;

          if ((u | 0) == (s[3979] | 0)) {
            u = (s[3976] | 0) + e | 0;
            s[3976] = u;
            s[3979] = c;
            s[c + 4 >> 2] = u | 1;
            if ((c | 0) != (a | 0)) return;
            s[3978] = 0;
            s[3975] = 0;
            return;
          }

          if ((u | 0) == (a | 0)) {
            u = (s[3975] | 0) + e | 0;
            s[3975] = u;
            s[3978] = c;
            s[c + 4 >> 2] = u | 1;
            s[c + u >> 2] = u;
            return;
          }

          n = (r & -8) + e | 0;
          t = r >>> 3;

          do {
            if (r >>> 0 < 256) {
              e = s[u + 8 >> 2] | 0;
              a = s[u + 12 >> 2] | 0;

              if ((a | 0) == (e | 0)) {
                s[3973] = s[3973] & ~(1 << t);
                break;
              } else {
                s[e + 12 >> 2] = a;
                s[a + 8 >> 2] = e;
                break;
              }
            } else {
              o = s[u + 24 >> 2] | 0;
              a = s[u + 12 >> 2] | 0;

              do {
                if ((a | 0) == (u | 0)) {
                  t = u + 16 | 0;
                  e = t + 4 | 0;
                  a = s[e >> 2] | 0;

                  if (!a) {
                    a = s[t >> 2] | 0;

                    if (!a) {
                      t = 0;
                      break;
                    } else r = t;
                  } else r = e;

                  while (1) {
                    t = a + 20 | 0;
                    e = s[t >> 2] | 0;

                    if (e | 0) {
                      a = e;
                      r = t;
                      continue;
                    }

                    t = a + 16 | 0;
                    e = s[t >> 2] | 0;
                    if (!e) break;else {
                      a = e;
                      r = t;
                    }
                  }

                  s[r >> 2] = 0;
                  t = a;
                } else {
                  t = s[u + 8 >> 2] | 0;
                  s[t + 12 >> 2] = a;
                  s[a + 8 >> 2] = t;
                  t = a;
                }
              } while (0);

              if (o | 0) {
                a = s[u + 28 >> 2] | 0;
                e = 16196 + (a << 2) | 0;

                if ((u | 0) == (s[e >> 2] | 0)) {
                  s[e >> 2] = t;

                  if (!t) {
                    s[3974] = s[3974] & ~(1 << a);
                    break;
                  }
                } else {
                  s[o + 16 + (((s[o + 16 >> 2] | 0) != (u | 0) & 1) << 2) >> 2] = t;
                  if (!t) break;
                }

                s[t + 24 >> 2] = o;
                e = u + 16 | 0;
                a = s[e >> 2] | 0;

                if (a | 0) {
                  s[t + 16 >> 2] = a;
                  s[a + 24 >> 2] = t;
                }

                a = s[e + 4 >> 2] | 0;

                if (a | 0) {
                  s[t + 20 >> 2] = a;
                  s[a + 24 >> 2] = t;
                }
              }
            }
          } while (0);

          s[c + 4 >> 2] = n | 1;
          s[c + n >> 2] = n;

          if ((c | 0) == (s[3978] | 0)) {
            s[3975] = n;
            return;
          }
        } else {
          s[a >> 2] = r & -2;
          s[c + 4 >> 2] = e | 1;
          s[c + e >> 2] = e;
          n = e;
        }

        a = n >>> 3;

        if (n >>> 0 < 256) {
          t = 15932 + (a << 1 << 2) | 0;
          e = s[3973] | 0;
          a = 1 << a;

          if (!(e & a)) {
            s[3973] = e | a;
            a = t + 8 | 0;
            e = t;
          } else {
            e = t + 8 | 0;
            a = e;
            e = s[e >> 2] | 0;
          }

          s[a >> 2] = c;
          s[e + 12 >> 2] = c;
          s[c + 8 >> 2] = e;
          s[c + 12 >> 2] = t;
          return;
        }

        a = n >>> 8;
        if (a) {
          if (n >>> 0 > 16777215) e = 31;else {
            i = (a + 1048320 | 0) >>> 16 & 8;
            u = a << i;
            o = (u + 520192 | 0) >>> 16 & 4;
            u = u << o;
            e = (u + 245760 | 0) >>> 16 & 2;
            e = 14 - (o | i | e) + (u << e >>> 15) | 0;
            e = n >>> (e + 7 | 0) & 1 | e << 1;
          }
        } else e = 0;
        r = 16196 + (e << 2) | 0;
        s[c + 28 >> 2] = e;
        s[c + 20 >> 2] = 0;
        s[c + 16 >> 2] = 0;
        a = s[3974] | 0;
        t = 1 << e;

        if (!(a & t)) {
          s[3974] = a | t;
          s[r >> 2] = c;
          s[c + 24 >> 2] = r;
          s[c + 12 >> 2] = c;
          s[c + 8 >> 2] = c;
          return;
        }

        e = n << ((e | 0) == 31 ? 0 : 25 - (e >>> 1) | 0);
        t = s[r >> 2] | 0;

        while (1) {
          if ((s[t + 4 >> 2] & -8 | 0) == (n | 0)) {
            a = 69;
            break;
          }

          r = t + 16 + (e >>> 31 << 2) | 0;
          a = s[r >> 2] | 0;

          if (!a) {
            a = 68;
            break;
          } else {
            e = e << 1;
            t = a;
          }
        }

        if ((a | 0) == 68) {
          s[r >> 2] = c;
          s[c + 24 >> 2] = t;
          s[c + 12 >> 2] = c;
          s[c + 8 >> 2] = c;
          return;
        } else if ((a | 0) == 69) {
          i = t + 8 | 0;
          u = s[i >> 2] | 0;
          s[u + 12 >> 2] = c;
          s[i >> 2] = c;
          s[c + 8 >> 2] = u;
          s[c + 12 >> 2] = t;
          s[c + 24 >> 2] = 0;
          return;
        }
      }

      function pu(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0;
        e = e >>> 0 > 16 ? e : 16;

        if (e + -1 & e) {
          a = 16;

          while (1) {
            if (a >>> 0 < e >>> 0) a = a << 1;else {
              e = a;
              break;
            }
          }
        }

        if ((-64 - e | 0) >>> 0 <= t >>> 0) {
          s[(gu() | 0) >> 2] = 12;
          i = 0;
          return i | 0;
        }

        o = t >>> 0 < 11 ? 16 : t + 11 & -8;
        a = uu(o + 12 + e | 0) | 0;

        if (!a) {
          i = 0;
          return i | 0;
        }

        n = a + -8 | 0;

        do {
          if (a & e + -1) {
            r = (a + e + -1 & 0 - e) + -8 | 0;
            t = n;
            r = (r - t | 0) >>> 0 > 15 ? r : r + e | 0;
            t = r - t | 0;
            e = a + -4 | 0;
            c = s[e >> 2] | 0;
            a = (c & -8) - t | 0;

            if (!(c & 3)) {
              s[r >> 2] = (s[n >> 2] | 0) + t;
              s[r + 4 >> 2] = a;
              t = r;
              e = r;
              break;
            } else {
              c = r + 4 | 0;
              s[c >> 2] = a | s[c >> 2] & 1 | 2;
              a = r + a + 4 | 0;
              s[a >> 2] = s[a >> 2] | 1;
              s[e >> 2] = t | s[e >> 2] & 1 | 2;
              s[c >> 2] = s[c >> 2] | 1;
              hu(n, t);
              t = r;
              e = r;
              break;
            }
          } else {
            t = n;
            e = n;
          }
        } while (0);

        a = e + 4 | 0;
        e = s[a >> 2] | 0;

        if (e & 3 | 0 ? (i = e & -8, i >>> 0 > (o + 16 | 0) >>> 0) : 0) {
          c = i - o | 0;
          i = t + o | 0;
          s[a >> 2] = o | e & 1 | 2;
          s[i + 4 >> 2] = c | 3;
          o = i + c + 4 | 0;
          s[o >> 2] = s[o >> 2] | 1;
          hu(i, c);
        }

        c = t + 8 | 0;
        return c | 0;
      }

      function bu(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0;

        do {
          if ((t | 0) != 8) {
            r = t >>> 2;

            if ((t & 3 | 0) != 0 | (r | 0) == 0) {
              e = 22;
              return e | 0;
            }

            if (r + 1073741823 & r | 0) {
              e = 22;
              return e | 0;
            }

            if ((-64 - t | 0) >>> 0 < a >>> 0) {
              e = 12;
              return e | 0;
            } else {
              t = pu(t >>> 0 > 16 ? t : 16, a) | 0;
              break;
            }
          } else t = uu(a) | 0;
        } while (0);

        if (!t) {
          e = 12;
          return e | 0;
        }

        s[e >> 2] = t;
        e = 0;
        return e | 0;
      }

      function mu() {
        return 16388;
      }

      function yu(e) {
        e = e | 0;
        var t = 0,
            a = 0;
        t = p;
        p = p + 16 | 0;
        a = t;
        s[a >> 2] = Tu(s[e + 60 >> 2] | 0) | 0;
        e = _u(Xe(6, a | 0) | 0) | 0;
        p = t;
        return e | 0;
      }

      function vu(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0;
        n = p;
        p = p + 32 | 0;
        o = n;
        r = n + 20 | 0;
        s[o >> 2] = s[e + 60 >> 2];
        s[o + 4 >> 2] = 0;
        s[o + 8 >> 2] = t;
        s[o + 12 >> 2] = r;
        s[o + 16 >> 2] = a;

        if ((_u(Ue(140, o | 0) | 0) | 0) < 0) {
          s[r >> 2] = -1;
          e = -1;
        } else e = s[r >> 2] | 0;

        p = n;
        return e | 0;
      }

      function _u(e) {
        e = e | 0;

        if (e >>> 0 > 4294963200) {
          s[(gu() | 0) >> 2] = 0 - e;
          e = -1;
        }

        return e | 0;
      }

      function gu() {
        return (Au() | 0) + 64 | 0;
      }

      function Au() {
        return wu() | 0;
      }

      function wu() {
        return 5424;
      }

      function Tu(e) {
        e = e | 0;
        return e | 0;
      }

      function xu(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var n = 0,
            o = 0;
        o = p;
        p = p + 32 | 0;
        n = o;
        s[e + 36 >> 2] = 11;
        if ((s[e >> 2] & 64 | 0) == 0 ? (s[n >> 2] = s[e + 60 >> 2], s[n + 4 >> 2] = 21523, s[n + 8 >> 2] = o + 16, Ge(54, n | 0) | 0) : 0) r[e + 75 >> 0] = -1;
        n = Du(e, t, a) | 0;
        p = o;
        return n | 0;
      }

      function Du(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            b = 0;
        l = p;
        p = p + 48 | 0;
        c = l + 16 | 0;
        n = l;
        r = l + 32 | 0;
        u = e + 28 | 0;
        o = s[u >> 2] | 0;
        s[r >> 2] = o;
        d = e + 20 | 0;
        o = (s[d >> 2] | 0) - o | 0;
        s[r + 4 >> 2] = o;
        s[r + 8 >> 2] = t;
        s[r + 12 >> 2] = a;
        o = o + a | 0;
        i = e + 60 | 0;
        s[n >> 2] = s[i >> 2];
        s[n + 4 >> 2] = r;
        s[n + 8 >> 2] = 2;
        t = _u(rt(146, n | 0) | 0) | 0;

        e: do {
          if ((o | 0) != (t | 0)) {
            n = 2;

            while (1) {
              if ((t | 0) < 0) break;
              o = o - t | 0;
              b = s[r + 4 >> 2] | 0;
              h = t >>> 0 > b >>> 0;
              r = h ? r + 8 | 0 : r;
              n = (h << 31 >> 31) + n | 0;
              b = t - (h ? b : 0) | 0;
              s[r >> 2] = (s[r >> 2] | 0) + b;
              h = r + 4 | 0;
              s[h >> 2] = (s[h >> 2] | 0) - b;
              s[c >> 2] = s[i >> 2];
              s[c + 4 >> 2] = r;
              s[c + 8 >> 2] = n;
              t = _u(rt(146, c | 0) | 0) | 0;

              if ((o | 0) == (t | 0)) {
                f = 3;
                break e;
              }
            }

            s[e + 16 >> 2] = 0;
            s[u >> 2] = 0;
            s[d >> 2] = 0;
            s[e >> 2] = s[e >> 2] | 32;
            if ((n | 0) == 2) a = 0;else a = a - (s[r + 4 >> 2] | 0) | 0;
          } else f = 3;
        } while (0);

        if ((f | 0) == 3) {
          b = s[e + 44 >> 2] | 0;
          s[e + 16 >> 2] = b + (s[e + 48 >> 2] | 0);
          s[u >> 2] = b;
          s[d >> 2] = b;
        }

        p = l;
        return a | 0;
      }

      function Cu(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            n = 0;
        n = e;

        e: do {
          if (!(n & 3)) {
            t = e;
            a = 4;
          } else {
            t = n;

            while (1) {
              if (!(r[e >> 0] | 0)) break e;
              e = e + 1 | 0;
              t = e;

              if (!(t & 3)) {
                t = e;
                a = 4;
                break;
              }
            }
          }
        } while (0);

        if ((a | 0) == 4) {
          while (1) {
            e = s[t >> 2] | 0;
            if (!((e & -2139062144 ^ -2139062144) & e + -16843009)) t = t + 4 | 0;else break;
          }

          if ((e & 255) << 24 >> 24) do {
            t = t + 1 | 0;
          } while ((r[t >> 0] | 0) != 0);
        }

        return t - n | 0;
      }

      function Su(e) {
        e = e | 0;
        return 0;
      }

      function Eu(e) {
        e = e | 0;
        return;
      }

      function Bu(e) {
        e = e | 0;
        return Wu(e, s[(Ru() | 0) + 188 >> 2] | 0) | 0;
      }

      function ku(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var n = 0,
            o = 0,
            i = 0,
            c = 0;
        i = t & 255;
        n = (a | 0) != 0;

        e: do {
          if (n & (e & 3 | 0) != 0) {
            o = t & 255;

            while (1) {
              if ((r[e >> 0] | 0) == o << 24 >> 24) {
                c = 6;
                break e;
              }

              e = e + 1 | 0;
              a = a + -1 | 0;
              n = (a | 0) != 0;

              if (!(n & (e & 3 | 0) != 0)) {
                c = 5;
                break;
              }
            }
          } else c = 5;
        } while (0);

        if ((c | 0) == 5) if (n) c = 6;else a = 0;

        e: do {
          if ((c | 0) == 6) {
            o = t & 255;

            if ((r[e >> 0] | 0) != o << 24 >> 24) {
              n = V(i, 16843009) | 0;

              t: do {
                if (a >>> 0 > 3) while (1) {
                  i = s[e >> 2] ^ n;
                  if ((i & -2139062144 ^ -2139062144) & i + -16843009 | 0) break;
                  e = e + 4 | 0;
                  a = a + -4 | 0;

                  if (a >>> 0 <= 3) {
                    c = 11;
                    break t;
                  }
                } else c = 11;
              } while (0);

              if ((c | 0) == 11) if (!a) {
                a = 0;
                break;
              }

              while (1) {
                if ((r[e >> 0] | 0) == o << 24 >> 24) break e;
                e = e + 1 | 0;
                a = a + -1 | 0;

                if (!a) {
                  a = 0;
                  break;
                }
              }
            }
          }
        } while (0);

        return (a | 0 ? e : 0) | 0;
      }

      function Ru() {
        return wu() | 0;
      }

      function Wu(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            n = 0;
        a = 0;

        while (1) {
          if ((o[13704 + a >> 0] | 0) == (e | 0)) {
            n = 2;
            break;
          }

          a = a + 1 | 0;

          if ((a | 0) == 87) {
            a = 87;
            e = 13792;
            n = 5;
            break;
          }
        }

        if ((n | 0) == 2) if (!a) a = 13792;else {
          e = 13792;
          n = 5;
        }
        if ((n | 0) == 5) while (1) {
          do {
            n = e;
            e = e + 1 | 0;
          } while ((r[n >> 0] | 0) != 0);

          a = a + -1 | 0;

          if (!a) {
            a = e;
            break;
          } else n = 5;
        }
        return Iu(a, s[t + 20 >> 2] | 0) | 0;
      }

      function Iu(e, t) {
        e = e | 0;
        t = t | 0;
        return Nu(e, t) | 0;
      }

      function Nu(e, t) {
        e = e | 0;
        t = t | 0;
        if (!t) t = 0;else t = Mu(s[t >> 2] | 0, s[t + 4 >> 2] | 0, e) | 0;
        return (t | 0 ? t : e) | 0;
      }

      function Mu(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var n = 0,
            o = 0,
            i = 0,
            c = 0,
            u = 0,
            d = 0,
            f = 0,
            l = 0,
            h = 0,
            p = 0;
        p = (s[e >> 2] | 0) + 1794895138 | 0;
        i = Pu(s[e + 8 >> 2] | 0, p) | 0;
        n = Pu(s[e + 12 >> 2] | 0, p) | 0;
        o = Pu(s[e + 16 >> 2] | 0, p) | 0;

        e: do {
          if ((i >>> 0 < t >>> 2 >>> 0 ? (h = t - (i << 2) | 0, n >>> 0 < h >>> 0 & o >>> 0 < h >>> 0) : 0) ? ((o | n) & 3 | 0) == 0 : 0) {
            h = n >>> 2;
            l = o >>> 2;
            f = 0;

            while (1) {
              d = i >>> 1;
              u = f + d | 0;
              c = u << 1;
              o = c + h | 0;
              n = Pu(s[e + (o << 2) >> 2] | 0, p) | 0;
              o = Pu(s[e + (o + 1 << 2) >> 2] | 0, p) | 0;

              if (!(o >>> 0 < t >>> 0 & n >>> 0 < (t - o | 0) >>> 0)) {
                n = 0;
                break e;
              }

              if (r[e + (o + n) >> 0] | 0) {
                n = 0;
                break e;
              }

              n = Lu(a, e + o | 0) | 0;
              if (!n) break;
              n = (n | 0) < 0;

              if ((i | 0) == 1) {
                n = 0;
                break e;
              } else {
                f = n ? f : u;
                i = n ? d : i - d | 0;
              }
            }

            n = c + l | 0;
            o = Pu(s[e + (n << 2) >> 2] | 0, p) | 0;
            n = Pu(s[e + (n + 1 << 2) >> 2] | 0, p) | 0;
            if (n >>> 0 < t >>> 0 & o >>> 0 < (t - n | 0) >>> 0) n = (r[e + (n + o) >> 0] | 0) == 0 ? e + n | 0 : 0;else n = 0;
          } else n = 0;
        } while (0);

        return n | 0;
      }

      function Pu(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0;
        a = ad(e | 0) | 0;
        return ((t | 0) == 0 ? e : a) | 0;
      }

      function Lu(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            n = 0;
        a = r[e >> 0] | 0;
        n = r[t >> 0] | 0;
        if (!(a << 24 >> 24 == 0 ? 1 : a << 24 >> 24 != n << 24 >> 24)) do {
          e = e + 1 | 0;
          t = t + 1 | 0;
          a = r[e >> 0] | 0;
          n = r[t >> 0] | 0;
        } while (!(a << 24 >> 24 == 0 ? 1 : a << 24 >> 24 != n << 24 >> 24));
        return (a & 255) - (n & 255) | 0;
      }

      function Ou() {
        Je(16452);
        return 16460;
      }

      function Fu() {
        Ve(16452);
        return;
      }

      function ju(e) {
        e = e | 0;
        var t = 0,
            a = 0;

        do {
          if (e) {
            if ((s[e + 76 >> 2] | 0) <= -1) {
              t = Gu(e) | 0;
              break;
            }

            a = (Su(e) | 0) == 0;
            t = Gu(e) | 0;
            if (!a) Eu(e);
          } else {
            if (!(s[1448] | 0)) t = 0;else t = ju(s[1448] | 0) | 0;
            e = s[(Ou() | 0) >> 2] | 0;
            if (e) do {
              if ((s[e + 76 >> 2] | 0) > -1) a = Su(e) | 0;else a = 0;
              if ((s[e + 20 >> 2] | 0) >>> 0 > (s[e + 28 >> 2] | 0) >>> 0) t = Gu(e) | 0 | t;
              if (a | 0) Eu(e);
              e = s[e + 56 >> 2] | 0;
            } while ((e | 0) != 0);
            Fu();
          }
        } while (0);

        return t | 0;
      }

      function Gu(e) {
        e = e | 0;
        var t = 0,
            a = 0,
            r = 0,
            n = 0,
            o = 0,
            i = 0;
        i = e + 20 | 0;
        o = e + 28 | 0;
        if ((s[i >> 2] | 0) >>> 0 > (s[o >> 2] | 0) >>> 0 ? (Id[s[e + 36 >> 2] & 15](e, 0, 0) | 0, (s[i >> 2] | 0) == 0) : 0) t = -1;else {
          n = e + 4 | 0;
          t = s[n >> 2] | 0;
          r = e + 8 | 0;
          a = s[r >> 2] | 0;
          if (t >>> 0 < a >>> 0) Id[s[e + 40 >> 2] & 15](e, t - a | 0, 1) | 0;
          s[e + 16 >> 2] = 0;
          s[o >> 2] = 0;
          s[i >> 2] = 0;
          s[r >> 2] = 0;
          s[n >> 2] = 0;
          t = 0;
        }
        return t | 0;
      }

      function Vu(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var n = 0,
            s = 0;

        e: do {
          if (!a) e = 0;else {
            while (1) {
              n = r[e >> 0] | 0;
              s = r[t >> 0] | 0;
              if (n << 24 >> 24 != s << 24 >> 24) break;
              a = a + -1 | 0;

              if (!a) {
                e = 0;
                break e;
              } else {
                e = e + 1 | 0;
                t = t + 1 | 0;
              }
            }

            e = (n & 255) - (s & 255) | 0;
          }
        } while (0);

        return e | 0;
      }

      function Uu(e) {
        e = e | 0;
        return Hu(e) | 0;
      }

      function Hu(e) {
        e = e | 0;
        return nd(e | 0) | 0;
      }

      function zu(e) {
        e = e | 0;
        return Ku(e) | 0;
      }

      function Ku(e) {
        e = e | 0;
        return ad(e | 0) | 0;
      }

      function qu(e) {
        e = e | 0;
        return Yu(e) | 0;
      }

      function Yu(e) {
        e = e | 0;
        return nd(e | 0) | 0;
      }

      function Zu(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var n = 0;
        n = Bu(e) | 0;
        e = Cu(n) | 0;

        if (e >>> 0 >= a >>> 0) {
          e = a + -1 | 0;
          if (!a) e = 34;else {
            id(t | 0, n | 0, e | 0) | 0;
            r[t + e >> 0] = 0;
            e = 34;
          }
        } else {
          id(t | 0, n | 0, e + 1 | 0) | 0;
          e = 0;
        }

        return e | 0;
      }

      function Ju(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var r = 0,
            n = 0;
        r = p;
        p = p + 16 | 0;
        n = r;
        s[n >> 2] = e;
        s[n + 4 >> 2] = t;
        s[n + 8 >> 2] = a;
        e = _u($e(4, n | 0) | 0) | 0;
        p = r;
        return e | 0;
      }

      function Xu() {}

      function $u(e, t, a, r) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        r = r | 0;
        r = t - r - (a >>> 0 > e >>> 0 | 0) >>> 0;
        return (S = r, e - a >>> 0 | 0) | 0;
      }

      function Qu(e, t, a, r) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        r = r | 0;
        a = e + a >>> 0;
        return (S = t + r + (a >>> 0 < e >>> 0 | 0) >>> 0, a | 0) | 0;
      }

      function ed(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var n = 0,
            o = 0,
            i = 0,
            c = 0;
        i = e + a | 0;
        t = t & 255;

        if ((a | 0) >= 67) {
          while (e & 3) {
            r[e >> 0] = t;
            e = e + 1 | 0;
          }

          n = i & -4 | 0;
          o = n - 64 | 0;
          c = t | t << 8 | t << 16 | t << 24;

          while ((e | 0) <= (o | 0)) {
            s[e >> 2] = c;
            s[e + 4 >> 2] = c;
            s[e + 8 >> 2] = c;
            s[e + 12 >> 2] = c;
            s[e + 16 >> 2] = c;
            s[e + 20 >> 2] = c;
            s[e + 24 >> 2] = c;
            s[e + 28 >> 2] = c;
            s[e + 32 >> 2] = c;
            s[e + 36 >> 2] = c;
            s[e + 40 >> 2] = c;
            s[e + 44 >> 2] = c;
            s[e + 48 >> 2] = c;
            s[e + 52 >> 2] = c;
            s[e + 56 >> 2] = c;
            s[e + 60 >> 2] = c;
            e = e + 64 | 0;
          }

          while ((e | 0) < (n | 0)) {
            s[e >> 2] = c;
            e = e + 4 | 0;
          }
        }

        while ((e | 0) < (i | 0)) {
          r[e >> 0] = t;
          e = e + 1 | 0;
        }

        return i - a | 0;
      }

      function td(e) {
        e = e | 0;
        return 0;
      }

      function ad(e) {
        e = e | 0;
        return (e & 255) << 24 | (e >> 8 & 255) << 16 | (e >> 16 & 255) << 8 | e >>> 24 | 0;
      }

      function rd(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;

        if ((a | 0) < 32) {
          S = t >>> a;
          return e >>> a | (t & (1 << a) - 1) << 32 - a;
        }

        S = 0;
        return t >>> a - 32 | 0;
      }

      function nd(e) {
        e = e | 0;
        return (e & 255) << 8 | e >> 8 & 255 | 0;
      }

      function sd(e) {
        e = e | 0;
        return 0;
      }

      function od(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;

        if ((a | 0) < 32) {
          S = t << a | (e & (1 << a) - 1 << 32 - a) >>> 32 - a;
          return e << a;
        }

        S = e << a - 32;
        return 0;
      }

      function id(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        var n = 0,
            o = 0,
            i = 0;
        if ((a | 0) >= 8192) return Ie(e | 0, t | 0, a | 0) | 0;
        i = e | 0;
        o = e + a | 0;

        if ((e & 3) == (t & 3)) {
          while (e & 3) {
            if (!a) return i | 0;
            r[e >> 0] = r[t >> 0] | 0;
            e = e + 1 | 0;
            t = t + 1 | 0;
            a = a - 1 | 0;
          }

          a = o & -4 | 0;
          n = a - 64 | 0;

          while ((e | 0) <= (n | 0)) {
            s[e >> 2] = s[t >> 2];
            s[e + 4 >> 2] = s[t + 4 >> 2];
            s[e + 8 >> 2] = s[t + 8 >> 2];
            s[e + 12 >> 2] = s[t + 12 >> 2];
            s[e + 16 >> 2] = s[t + 16 >> 2];
            s[e + 20 >> 2] = s[t + 20 >> 2];
            s[e + 24 >> 2] = s[t + 24 >> 2];
            s[e + 28 >> 2] = s[t + 28 >> 2];
            s[e + 32 >> 2] = s[t + 32 >> 2];
            s[e + 36 >> 2] = s[t + 36 >> 2];
            s[e + 40 >> 2] = s[t + 40 >> 2];
            s[e + 44 >> 2] = s[t + 44 >> 2];
            s[e + 48 >> 2] = s[t + 48 >> 2];
            s[e + 52 >> 2] = s[t + 52 >> 2];
            s[e + 56 >> 2] = s[t + 56 >> 2];
            s[e + 60 >> 2] = s[t + 60 >> 2];
            e = e + 64 | 0;
            t = t + 64 | 0;
          }

          while ((e | 0) < (a | 0)) {
            s[e >> 2] = s[t >> 2];
            e = e + 4 | 0;
            t = t + 4 | 0;
          }
        } else {
          a = o - 4 | 0;

          while ((e | 0) < (a | 0)) {
            r[e >> 0] = r[t >> 0] | 0;
            r[e + 1 >> 0] = r[t + 1 >> 0] | 0;
            r[e + 2 >> 0] = r[t + 2 >> 0] | 0;
            r[e + 3 >> 0] = r[t + 3 >> 0] | 0;
            e = e + 4 | 0;
            t = t + 4 | 0;
          }
        }

        while ((e | 0) < (o | 0)) {
          r[e >> 0] = r[t >> 0] | 0;
          e = e + 1 | 0;
          t = t + 1 | 0;
        }

        return i | 0;
      }

      function cd(e, t) {
        e = e | 0;
        t = t | 0;
        var a = 0,
            r = 0,
            n = 0,
            s = 0;
        s = e & 65535;
        n = t & 65535;
        a = V(n, s) | 0;
        r = e >>> 16;
        e = (a >>> 16) + (V(n, r) | 0) | 0;
        n = t >>> 16;
        t = V(n, s) | 0;
        return (S = (e >>> 16) + (V(n, r) | 0) + (((e & 65535) + t | 0) >>> 16) | 0, e + t << 16 | a & 65535 | 0) | 0;
      }

      function ud(e, t, a, r) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        r = r | 0;
        var n = 0,
            s = 0;
        n = e;
        s = a;
        a = cd(n, s) | 0;
        e = S;
        return (S = (V(t, s) | 0) + (V(r, n) | 0) + e | e & 0, a | 0 | 0) | 0;
      }

      function dd(e) {
        e = e | 0;
        var t = 0,
            a = 0;
        a = e + 15 & -16 | 0;
        t = s[f >> 2] | 0;
        e = t + a | 0;

        if ((a | 0) > 0 & (e | 0) < (t | 0) | (e | 0) < 0) {
          J() | 0;
          he(12);
          return -1;
        }

        s[f >> 2] = e;

        if ((e | 0) > (Z() | 0) ? (Y() | 0) == 0 : 0) {
          s[f >> 2] = t;
          he(12);
          return -1;
        }

        return t | 0;
      }

      function fd(e, t, a, r) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        r = r | 0;
        return Id[e & 15](t | 0, a | 0, r | 0) | 0;
      }

      function ld(e, t, a, r, n, s) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        r = r | 0;
        n = n | 0;
        s = s | 0;
        Nd[e & 3](t | 0, a | 0, r | 0, n | 0, s | 0);
      }

      function hd(e) {
        e = e | 0;
        return Md[e & 7]() | 0;
      }

      function pd(e, t) {
        e = e | 0;
        t = t | 0;
        Pd[e & 63](t | 0);
      }

      function bd(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        Ld[e & 31](t | 0, a | 0);
      }

      function md(e, t) {
        e = e | 0;
        t = t | 0;
        return Od[e & 15](t | 0) | 0;
      }

      function yd(e, t, a, r) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        r = r | 0;
        Fd[e & 31](t | 0, a | 0, r | 0);
      }

      function vd(e) {
        e = e | 0;
        jd[e & 3]();
      }

      function _d(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        return Gd[e & 127](t | 0, a | 0) | 0;
      }

      function gd(e, t, a, r, n, s) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        r = r | 0;
        n = n | 0;
        s = s | 0;
        return Vd[e & 1](t | 0, a | 0, r | 0, n | 0, s | 0) | 0;
      }

      function Ad(e, t, a, r, n) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        r = r | 0;
        n = n | 0;
        Ud[e & 15](t | 0, a | 0, r | 0, n | 0);
      }

      function wd(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        K(0);
        return 0;
      }

      function Td(e, t, a, r, n) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        r = r | 0;
        n = n | 0;
        K(1);
      }

      function xd() {
        K(2);
        return 0;
      }

      function Dd(e) {
        e = e | 0;
        K(3);
      }

      function Cd(e, t) {
        e = e | 0;
        t = t | 0;
        K(4);
      }

      function Sd(e) {
        e = e | 0;
        K(5);
        return 0;
      }

      function Ed(e, t, a) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        K(6);
      }

      function Bd() {
        K(7);
      }

      function kd(e, t) {
        e = e | 0;
        t = t | 0;
        K(8);
        return 0;
      }

      function Rd(e, t, a, r, n) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        r = r | 0;
        n = n | 0;
        K(9);
        return 0;
      }

      function Wd(e, t, a, r) {
        e = e | 0;
        t = t | 0;
        a = a | 0;
        r = r | 0;
        K(10);
      }

      var Id = [wd, Sr, Cr, Es, Di, Nc, ec, xu, vu, Zt, rc, Du, wd, wd, wd, wd];
      var Nd = [Td, ka, ja, Td];
      var Md = [xd, Yr, Zr, Rn, Po, xd, xd, xd];
      var Pd = [Dd, _t, er, Hr, qr, Jr, $r, Qr, sn, Wn, Cn, Jn, Xn, $n, Qn, cs, fs, _s, ls, ms, ps, Ws, Rs, Ms, Qs, Mo, Lo, dn, Ko, Ai, Qi, Rc, kc, Ic, Xc, eu, Kt, Xt, sa, ht, oa, Mt, Va, dr, Kc, ur, es, ai, In, on, On, kr, vn, an, go, mi, fo, jn, ko, Un, Ns, oi, Dd, Dd];
      var Ld = [Cd, En, Pr, Er, Hs, Vs, Ps, Ls, nu, qc, Rt, ra, ta, aa, ru, na, da, Za, Ra, Ga, Ma, Zc, Fn, Kn, ri, ws, bn, _i, zn, Cd, Cd, Cd];
      var Od = [Sd, gt, At, ar, Oo, hr, Br, Us, yu, hn, qt, zo, nn, Pc, io, Sd];
      var Fd = [Ed, kn, Dt, zt, Qt, rr, Ct, pt, $t, Yt, ea, Jt, ua, ca, ia, Ya, Ea, Ba, Ta, Yc, fr, pn, An, Ao, _o, Wi, wo, hi, Fi, Ed, Ed, Ed];
      var jd = [Bd, Ot, so, Bd];
      var Gd = [kd, zr, mr, wr, xr, Lr, Ur, zs, $s, Ji, us, gs, vs, hs, ys, bs, br, Co, Vo, Tr, Dr, ns, ss, Ti, xi, Vc, Uc, wc, Jc, tc, ac, Ac, tu, Ft, Is, fa, sr, Bc, gc, qi, oc, vr, Ri, Fr, Fo, ti, $i, ei, Qc, su, ou, ks, yi, Ss, Xi, fc, _r, yr, Kr, Cs, pr, Oi, Pi, nc, Tc, _c, Hc, Ki, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd, kd];
      var Vd = [Rd, Mc];
      var Ud = [Wd, Sn, Bn, bt, Sa, Sc, Ks, Zn, Ds, Wd, Wd, Wd, Wd, Wd, Wd, Wd];
      return {
        _main: Lt,
        dynCall_i: hd,
        stackSave: it,
        _i64Subtract: $u,
        _rust_eh_personality: Bi,
        setThrew: dt,
        dynCall_viii: yd,
        _bitshift64Lshr: rd,
        _ec_pairing: Nt,
        _bitshift64Shl: od,
        _fflush: ju,
        _htonl: zu,
        ___errno_location: gu,
        _memset: ed,
        dynCall_ii: md,
        _sbrk: dd,
        _memcpy: id,
        stackAlloc: ot,
        ___muldi3: ud,
        _ec_mul: Bt,
        dynCall_vi: pd,
        getTempRet0: lt,
        dynCall_vii: bd,
        _ntohs: qu,
        setTempRet0: ft,
        _i64Add: Qu,
        dynCall_iiii: fd,
        _pthread_mutex_unlock: sd,
        _llvm_bswap_i16: nd,
        _emscripten_get_global_libc: mu,
        _htons: Uu,
        dynCall_viiii: Ad,
        dynCall_iiiiii: gd,
        _llvm_bswap_i32: ad,
        dynCall_viiiii: ld,
        _free: du,
        runPostSets: Xu,
        establishStackSpace: ut,
        stackRestore: ct,
        _malloc: uu,
        dynCall_iii: _d,
        _pthread_mutex_lock: td,
        dynCall_v: vd,
        _ec_add: It
      };
    }(Module.asmGlobalArg, Module.asmLibraryArg, buffer),
        _main = Module._main = asm._main,
        stackSave = Module.stackSave = asm.stackSave,
        getTempRet0 = Module.getTempRet0 = asm.getTempRet0,
        _rust_eh_personality = Module._rust_eh_personality = asm._rust_eh_personality,
        setThrew = Module.setThrew = asm.setThrew,
        _bitshift64Lshr = Module._bitshift64Lshr = asm._bitshift64Lshr,
        _ec_pairing = Module._ec_pairing = asm._ec_pairing,
        _bitshift64Shl = Module._bitshift64Shl = asm._bitshift64Shl,
        _fflush = Module._fflush = asm._fflush,
        setTempRet0 = Module.setTempRet0 = asm.setTempRet0,
        _memset = Module._memset = asm._memset,
        _sbrk = Module._sbrk = asm._sbrk,
        _memcpy = Module._memcpy = asm._memcpy,
        _llvm_bswap_i32 = Module._llvm_bswap_i32 = asm._llvm_bswap_i32,
        ___muldi3 = Module.___muldi3 = asm.___muldi3,
        _ec_mul = Module._ec_mul = asm._ec_mul,
        stackAlloc = Module.stackAlloc = asm.stackAlloc,
        _i64Subtract = Module._i64Subtract = asm._i64Subtract,
        _ntohs = Module._ntohs = asm._ntohs,
        _htonl = Module._htonl = asm._htonl,
        _i64Add = Module._i64Add = asm._i64Add,
        _pthread_mutex_unlock = Module._pthread_mutex_unlock = asm._pthread_mutex_unlock,
        _llvm_bswap_i16 = Module._llvm_bswap_i16 = asm._llvm_bswap_i16,
        _emscripten_get_global_libc = Module._emscripten_get_global_libc = asm._emscripten_get_global_libc,
        _htons = Module._htons = asm._htons,
        ___errno_location = Module.___errno_location = asm.___errno_location,
        _free = Module._free = asm._free,
        runPostSets = Module.runPostSets = asm.runPostSets,
        establishStackSpace = Module.establishStackSpace = asm.establishStackSpace,
        stackRestore = Module.stackRestore = asm.stackRestore,
        _malloc = Module._malloc = asm._malloc,
        _pthread_mutex_lock = Module._pthread_mutex_lock = asm._pthread_mutex_lock,
        _ec_add = Module._ec_add = asm._ec_add,
        dynCall_iiii = Module.dynCall_iiii = asm.dynCall_iiii,
        dynCall_viiiii = Module.dynCall_viiiii = asm.dynCall_viiiii,
        dynCall_i = Module.dynCall_i = asm.dynCall_i,
        dynCall_vi = Module.dynCall_vi = asm.dynCall_vi,
        dynCall_vii = Module.dynCall_vii = asm.dynCall_vii,
        dynCall_ii = Module.dynCall_ii = asm.dynCall_ii,
        dynCall_viii = Module.dynCall_viii = asm.dynCall_viii,
        dynCall_v = Module.dynCall_v = asm.dynCall_v,
        dynCall_iii = Module.dynCall_iii = asm.dynCall_iii,
        dynCall_iiiiii = Module.dynCall_iiiiii = asm.dynCall_iiiiii,
        dynCall_viiii = Module.dynCall_viiii = asm.dynCall_viiii,
        initialStackTop;

    if (Runtime.stackAlloc = Module.stackAlloc, Runtime.stackSave = Module.stackSave, Runtime.stackRestore = Module.stackRestore, Runtime.establishStackSpace = Module.establishStackSpace, Runtime.setTempRet0 = Module.setTempRet0, Runtime.getTempRet0 = Module.getTempRet0, Module.asm = asm, memoryInitializer) if ("function" == typeof Module.locateFile ? memoryInitializer = Module.locateFile(memoryInitializer) : Module.memoryInitializerPrefixURL && (memoryInitializer = Module.memoryInitializerPrefixURL + memoryInitializer), ENVIRONMENT_IS_NODE || ENVIRONMENT_IS_SHELL) {
      var data = Module.readBinary(memoryInitializer);
      HEAPU8.set(data, Runtime.GLOBAL_BASE);
    } else {
      var doBrowserLoad = function doBrowserLoad() {
        Module.readAsync(memoryInitializer, applyMemoryInitializer, function () {
          throw "could not load memory initializer " + memoryInitializer;
        });
      };

      addRunDependency("memory initializer");

      var applyMemoryInitializer = function applyMemoryInitializer(e) {
        e.byteLength && (e = new Uint8Array(e)), HEAPU8.set(e, Runtime.GLOBAL_BASE), Module.memoryInitializerRequest && delete Module.memoryInitializerRequest.response, removeRunDependency("memory initializer");
      };

      var memoryInitializerBytes = tryParseAsDataURI(memoryInitializer);
      if (memoryInitializerBytes) applyMemoryInitializer(memoryInitializerBytes.buffer);else if (Module.memoryInitializerRequest) {
        var useRequest = function useRequest() {
          var e = Module.memoryInitializerRequest,
              t = e.response;

          if (200 !== e.status && 0 !== e.status) {
            var a = tryParseAsDataURI(Module.memoryInitializerRequestURL);
            if (!a) return console.warn("a problem seems to have happened with Module.memoryInitializerRequest, status: " + e.status + ", retrying " + memoryInitializer), void doBrowserLoad();
            t = a.buffer;
          }

          applyMemoryInitializer(t);
        };

        Module.memoryInitializerRequest.response ? setTimeout(useRequest, 0) : Module.memoryInitializerRequest.addEventListener("load", useRequest);
      } else doBrowserLoad();
    }

    function ExitStatus(e) {
      this.name = "ExitStatus", this.message = "Program terminated with exit(" + e + ")", this.status = e;
    }

    ExitStatus.prototype = new Error(), ExitStatus.prototype.constructor = ExitStatus;
    var preloadStartTime = null,
        calledMain = !1;

    function run(e) {
      function t() {
        Module.calledRun || (Module.calledRun = !0, ABORT || (ensureInitRuntime(), preMain(), Module.onRuntimeInitialized && Module.onRuntimeInitialized(), Module._main && shouldRunNow && Module.callMain(e), postRun()));
      }

      e = e || Module.arguments, null === preloadStartTime && (preloadStartTime = Date.now()), runDependencies > 0 || (preRun(), runDependencies > 0 || Module.calledRun || (Module.setStatus ? (Module.setStatus("Running..."), setTimeout(function () {
        setTimeout(function () {
          Module.setStatus("");
        }, 1), t();
      }, 1)) : t()));
    }

    function exit(e, t) {
      t && Module.noExitRuntime || (Module.noExitRuntime || (ABORT = !0, EXITSTATUS = e, STACKTOP = initialStackTop, exitRuntime(), Module.onExit && Module.onExit(e)), ENVIRONMENT_IS_NODE && process.exit(e), Module.quit(e, new ExitStatus(e)));
    }

    dependenciesFulfilled = function e() {
      Module.calledRun || run(), Module.calledRun || (dependenciesFulfilled = e);
    }, Module.callMain = Module.callMain = function (e) {
      e = e || [], ensureInitRuntime();
      var t = e.length + 1;

      function a() {
        for (var e = 0; e < 3; e++) {
          r.push(0);
        }
      }

      var r = [allocate(intArrayFromString(Module.thisProgram), "i8", ALLOC_NORMAL)];
      a();

      for (var n = 0; n < t - 1; n += 1) {
        r.push(allocate(intArrayFromString(e[n]), "i8", ALLOC_NORMAL)), a();
      }

      r.push(0), r = allocate(r, "i32", ALLOC_NORMAL);

      try {
        exit(Module._main(t, r, 0), !0);
      } catch (e) {
        if (e instanceof ExitStatus) return;
        if ("SimulateInfiniteLoop" == e) return void (Module.noExitRuntime = !0);
        var s = e;
        e && "object" == typeof e && e.stack && (s = [e, e.stack]), Module.printErr("exception thrown: " + s), Module.quit(1, e);
      } finally {
        calledMain = !0;
      }
    }, Module.run = Module.run = run, Module.exit = Module.exit = exit;
    var abortDecorators = [];

    function abort(e) {
      Module.onAbort && Module.onAbort(e), void 0 !== e ? (Module.print(e), Module.printErr(e), e = JSON.stringify(e)) : e = "", ABORT = !0, EXITSTATUS = 1;
      var t = "abort(" + e + ") at " + stackTrace() + "\nIf this abort() is unexpected, build with -s ASSERTIONS=1 which can give more information.";
      throw abortDecorators && abortDecorators.forEach(function (a) {
        t = a(t, e);
      }), t;
    }

    if (Module.abort = Module.abort = abort, Module.preInit) for ("function" == typeof Module.preInit && (Module.preInit = [Module.preInit]); Module.preInit.length > 0;) {
      Module.preInit.pop()();
    }
    var shouldRunNow = !0;
    Module.noInitialRun && (shouldRunNow = !1), Module.arguments = [], run(), module.exports = Module;
  }).call(this, __webpack_require__(
  /*! ./../../process/browser.js */
  9), __webpack_require__(
  /*! ./../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!*************************************************!*\
  !*** ./node_modules/crypto-browserify/index.js ***!
  \*************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  t.randomBytes = t.rng = t.pseudoRandomBytes = t.prng = a(
  /*! randombytes */
  67), t.createHash = t.Hash = a(
  /*! create-hash */
  20), t.createHmac = t.Hmac = a(
  /*! create-hmac */
  247);
  var r = a(
  /*! browserify-sign/algos */
  670),
      n = Object.keys(r),
      s = ["sha1", "sha224", "sha256", "sha384", "sha512", "md5", "rmd160"].concat(n);

  t.getHashes = function () {
    return s;
  };

  var o = a(
  /*! pbkdf2 */
  250);
  t.pbkdf2 = o.pbkdf2, t.pbkdf2Sync = o.pbkdf2Sync;
  var i = a(
  /*! browserify-cipher */
  672);
  t.Cipher = i.Cipher, t.createCipher = i.createCipher, t.Cipheriv = i.Cipheriv, t.createCipheriv = i.createCipheriv, t.Decipher = i.Decipher, t.createDecipher = i.createDecipher, t.Decipheriv = i.Decipheriv, t.createDecipheriv = i.createDecipheriv, t.getCiphers = i.getCiphers, t.listCiphers = i.listCiphers;
  var c = a(
  /*! diffie-hellman */
  689);
  t.DiffieHellmanGroup = c.DiffieHellmanGroup, t.createDiffieHellmanGroup = c.createDiffieHellmanGroup, t.getDiffieHellman = c.getDiffieHellman, t.createDiffieHellman = c.createDiffieHellman, t.DiffieHellman = c.DiffieHellman;
  var u = a(
  /*! browserify-sign */
  692);
  t.createSign = u.createSign, t.Sign = u.Sign, t.createVerify = u.createVerify, t.Verify = u.Verify, t.createECDH = a(
  /*! create-ecdh */
  708);
  var d = a(
  /*! public-encrypt */
  709);
  t.publicEncrypt = d.publicEncrypt, t.privateEncrypt = d.privateEncrypt, t.publicDecrypt = d.publicDecrypt, t.privateDecrypt = d.privateDecrypt;
  var f = a(
  /*! randomfill */
  712);
  t.randomFill = f.randomFill, t.randomFillSync = f.randomFillSync, t.createCredentials = function () {
    throw new Error(["sorry, createCredentials is not implemented yet", "we accept pull requests", "https://github.com/crypto-browserify/crypto-browserify"].join("\n"));
  }, t.constants = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
  };
},
/*!********************************************!*\
  !*** ./node_modules/create-hmac/legacy.js ***!
  \********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! inherits */
  3),
      n = a(
  /*! safe-buffer */
  7).Buffer,
      s = a(
  /*! cipher-base */
  46),
      o = n.alloc(128),
      i = 64;

  function c(e, t) {
    s.call(this, "digest"), "string" == typeof t && (t = n.from(t)), this._alg = e, this._key = t, t.length > i ? t = e(t) : t.length < i && (t = n.concat([t, o], i));

    for (var a = this._ipad = n.allocUnsafe(i), r = this._opad = n.allocUnsafe(i), c = 0; c < i; c++) {
      a[c] = 54 ^ t[c], r[c] = 92 ^ t[c];
    }

    this._hash = [a];
  }

  r(c, s), c.prototype._update = function (e) {
    this._hash.push(e);
  }, c.prototype._final = function () {
    var e = this._alg(n.concat(this._hash));

    return this._alg(n.concat([this._opad, e]));
  }, e.exports = c;
},
/*!***********************************************!*\
  !*** ./node_modules/browserify-sign/algos.js ***!
  \***********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  e.exports = a(
  /*! ./browser/algorithms.json */
  249);
},
/*!******************************************!*\
  !*** ./node_modules/pbkdf2/lib/async.js ***!
  \******************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t, r) {
    var n,
        s = a(
    /*! ./precondition */
    251),
        o = a(
    /*! ./default-encoding */
    252),
        i = a(
    /*! ./sync */
    253),
        c = a(
    /*! safe-buffer */
    7).Buffer,
        u = t.crypto && t.crypto.subtle,
        d = {
      sha: "SHA-1",
      "sha-1": "SHA-1",
      sha1: "SHA-1",
      sha256: "SHA-256",
      "sha-256": "SHA-256",
      sha384: "SHA-384",
      "sha-384": "SHA-384",
      "sha-512": "SHA-512",
      sha512: "SHA-512"
    },
        f = [];

    function l(e, t, a, r, n) {
      return u.importKey("raw", e, {
        name: "PBKDF2"
      }, !1, ["deriveBits"]).then(function (e) {
        return u.deriveBits({
          name: "PBKDF2",
          salt: t,
          iterations: a,
          hash: {
            name: n
          }
        }, e, r << 3);
      }).then(function (e) {
        return c.from(e);
      });
    }

    e.exports = function (e, a, h, p, b, m) {
      "function" == typeof b && (m = b, b = void 0);
      var y = d[(b = b || "sha1").toLowerCase()];
      if (!y || "function" != typeof t.Promise) return r.nextTick(function () {
        var t;

        try {
          t = i(e, a, h, p, b);
        } catch (e) {
          return m(e);
        }

        m(null, t);
      });
      if (s(e, a, h, p), "function" != typeof m) throw new Error("No callback provided to pbkdf2");
      c.isBuffer(e) || (e = c.from(e, o)), c.isBuffer(a) || (a = c.from(a, o)), function (e, t) {
        e.then(function (e) {
          r.nextTick(function () {
            t(null, e);
          });
        }, function (e) {
          r.nextTick(function () {
            t(e);
          });
        });
      }(function (e) {
        if (t.process && !t.process.browser) return Promise.resolve(!1);
        if (!u || !u.importKey || !u.deriveBits) return Promise.resolve(!1);
        if (void 0 !== f[e]) return f[e];
        var a = l(n = n || c.alloc(8), n, 10, 128, e).then(function () {
          return !0;
        }).catch(function () {
          return !1;
        });
        return f[e] = a, a;
      }(y).then(function (t) {
        return t ? l(e, a, h, p, y) : i(e, a, h, p, b);
      }), m);
    };
  }).call(this, a(
  /*! ./../../webpack/buildin/global.js */
  18), a(
  /*! ./../../process/browser.js */
  9));
},
/*!***************************************************!*\
  !*** ./node_modules/browserify-cipher/browser.js ***!
  \***************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! browserify-des */
  673),
      n = a(
  /*! browserify-aes/browser */
  137),
      s = a(
  /*! browserify-aes/modes */
  138),
      o = a(
  /*! browserify-des/modes */
  688),
      i = a(
  /*! evp_bytestokey */
  91);

  function c(e, t, a) {
    if (e = e.toLowerCase(), s[e]) return n.createCipheriv(e, t, a);
    if (o[e]) return new r({
      key: t,
      iv: a,
      mode: e
    });
    throw new TypeError("invalid suite type");
  }

  function u(e, t, a) {
    if (e = e.toLowerCase(), s[e]) return n.createDecipheriv(e, t, a);
    if (o[e]) return new r({
      key: t,
      iv: a,
      mode: e,
      decrypt: !0
    });
    throw new TypeError("invalid suite type");
  }

  t.createCipher = t.Cipher = function (e, t) {
    var a, r;
    if (e = e.toLowerCase(), s[e]) a = s[e].key, r = s[e].iv;else {
      if (!o[e]) throw new TypeError("invalid suite type");
      a = 8 * o[e].key, r = o[e].iv;
    }
    var n = i(t, !1, a, r);
    return c(e, n.key, n.iv);
  }, t.createCipheriv = t.Cipheriv = c, t.createDecipher = t.Decipher = function (e, t) {
    var a, r;
    if (e = e.toLowerCase(), s[e]) a = s[e].key, r = s[e].iv;else {
      if (!o[e]) throw new TypeError("invalid suite type");
      a = 8 * o[e].key, r = o[e].iv;
    }
    var n = i(t, !1, a, r);
    return u(e, n.key, n.iv);
  }, t.createDecipheriv = t.Decipheriv = u, t.listCiphers = t.getCiphers = function () {
    return Object.keys(o).concat(n.getCiphers());
  };
},
/*!**********************************************!*\
  !*** ./node_modules/browserify-des/index.js ***!
  \**********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! cipher-base */
  46),
      n = a(
  /*! des.js */
  136),
      s = a(
  /*! inherits */
  3),
      o = a(
  /*! safe-buffer */
  7).Buffer,
      i = {
    "des-ede3-cbc": n.CBC.instantiate(n.EDE),
    "des-ede3": n.EDE,
    "des-ede-cbc": n.CBC.instantiate(n.EDE),
    "des-ede": n.EDE,
    "des-cbc": n.CBC.instantiate(n.DES),
    "des-ecb": n.DES
  };

  function c(e) {
    r.call(this);
    var t,
        a = e.mode.toLowerCase(),
        n = i[a];
    t = e.decrypt ? "decrypt" : "encrypt";
    var s = e.key;
    o.isBuffer(s) || (s = o.from(s)), "des-ede" !== a && "des-ede-cbc" !== a || (s = o.concat([s, s.slice(0, 8)]));
    var c = e.iv;
    o.isBuffer(c) || (c = o.from(c)), this._des = n.create({
      key: s,
      iv: c,
      type: t
    });
  }

  i.des = i["des-cbc"], i.des3 = i["des-ede3-cbc"], e.exports = c, s(c, r), c.prototype._update = function (e) {
    return o.from(this._des.update(e));
  }, c.prototype._final = function () {
    return o.from(this._des.final());
  };
},
/*!**********************************************!*\
  !*** ./node_modules/des.js/lib/des/utils.js ***!
  \**********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  t.readUInt32BE = function (e, t) {
    return (e[0 + t] << 24 | e[1 + t] << 16 | e[2 + t] << 8 | e[3 + t]) >>> 0;
  }, t.writeUInt32BE = function (e, t, a) {
    e[0 + a] = t >>> 24, e[1 + a] = t >>> 16 & 255, e[2 + a] = t >>> 8 & 255, e[3 + a] = 255 & t;
  }, t.ip = function (e, t, a, r) {
    for (var n = 0, s = 0, o = 6; o >= 0; o -= 2) {
      for (var i = 0; i <= 24; i += 8) {
        n <<= 1, n |= t >>> i + o & 1;
      }

      for (i = 0; i <= 24; i += 8) {
        n <<= 1, n |= e >>> i + o & 1;
      }
    }

    for (o = 6; o >= 0; o -= 2) {
      for (i = 1; i <= 25; i += 8) {
        s <<= 1, s |= t >>> i + o & 1;
      }

      for (i = 1; i <= 25; i += 8) {
        s <<= 1, s |= e >>> i + o & 1;
      }
    }

    a[r + 0] = n >>> 0, a[r + 1] = s >>> 0;
  }, t.rip = function (e, t, a, r) {
    for (var n = 0, s = 0, o = 0; o < 4; o++) {
      for (var i = 24; i >= 0; i -= 8) {
        n <<= 1, n |= t >>> i + o & 1, n <<= 1, n |= e >>> i + o & 1;
      }
    }

    for (o = 4; o < 8; o++) {
      for (i = 24; i >= 0; i -= 8) {
        s <<= 1, s |= t >>> i + o & 1, s <<= 1, s |= e >>> i + o & 1;
      }
    }

    a[r + 0] = n >>> 0, a[r + 1] = s >>> 0;
  }, t.pc1 = function (e, t, a, r) {
    for (var n = 0, s = 0, o = 7; o >= 5; o--) {
      for (var i = 0; i <= 24; i += 8) {
        n <<= 1, n |= t >> i + o & 1;
      }

      for (i = 0; i <= 24; i += 8) {
        n <<= 1, n |= e >> i + o & 1;
      }
    }

    for (i = 0; i <= 24; i += 8) {
      n <<= 1, n |= t >> i + o & 1;
    }

    for (o = 1; o <= 3; o++) {
      for (i = 0; i <= 24; i += 8) {
        s <<= 1, s |= t >> i + o & 1;
      }

      for (i = 0; i <= 24; i += 8) {
        s <<= 1, s |= e >> i + o & 1;
      }
    }

    for (i = 0; i <= 24; i += 8) {
      s <<= 1, s |= e >> i + o & 1;
    }

    a[r + 0] = n >>> 0, a[r + 1] = s >>> 0;
  }, t.r28shl = function (e, t) {
    return e << t & 268435455 | e >>> 28 - t;
  };
  var r = [14, 11, 17, 4, 27, 23, 25, 0, 13, 22, 7, 18, 5, 9, 16, 24, 2, 20, 12, 21, 1, 8, 15, 26, 15, 4, 25, 19, 9, 1, 26, 16, 5, 11, 23, 8, 12, 7, 17, 0, 22, 3, 10, 14, 6, 20, 27, 24];
  t.pc2 = function (e, t, a, n) {
    for (var s = 0, o = 0, i = r.length >>> 1, c = 0; c < i; c++) {
      s <<= 1, s |= e >>> r[c] & 1;
    }

    for (c = i; c < r.length; c++) {
      o <<= 1, o |= t >>> r[c] & 1;
    }

    a[n + 0] = s >>> 0, a[n + 1] = o >>> 0;
  }, t.expand = function (e, t, a) {
    var r = 0,
        n = 0;
    r = (1 & e) << 5 | e >>> 27;

    for (var s = 23; s >= 15; s -= 4) {
      r <<= 6, r |= e >>> s & 63;
    }

    for (s = 11; s >= 3; s -= 4) {
      n |= e >>> s & 63, n <<= 6;
    }

    n |= (31 & e) << 1 | e >>> 31, t[a + 0] = r >>> 0, t[a + 1] = n >>> 0;
  };
  var n = [14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1, 3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8, 4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7, 15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13, 15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14, 9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5, 0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2, 5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9, 10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10, 1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1, 13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7, 11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12, 7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3, 1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9, 10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8, 15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14, 2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1, 8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6, 4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13, 15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3, 12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5, 0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8, 9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10, 7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13, 4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10, 3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6, 1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7, 10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12, 13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4, 10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2, 7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13, 0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11];

  t.substitute = function (e, t) {
    for (var a = 0, r = 0; r < 4; r++) {
      a <<= 4, a |= n[64 * r + (e >>> 18 - 6 * r & 63)];
    }

    for (r = 0; r < 4; r++) {
      a <<= 4, a |= n[256 + 64 * r + (t >>> 18 - 6 * r & 63)];
    }

    return a >>> 0;
  };

  var s = [16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22, 30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7];
  t.permute = function (e) {
    for (var t = 0, a = 0; a < s.length; a++) {
      t <<= 1, t |= e >>> s[a] & 1;
    }

    return t >>> 0;
  }, t.padSplit = function (e, t, a) {
    for (var r = e.toString(2); r.length < t;) {
      r = "0" + r;
    }

    for (var n = [], s = 0; s < t; s += a) {
      n.push(r.slice(s, s + a));
    }

    return n.join(" ");
  };
},
/*!***********************************************!*\
  !*** ./node_modules/des.js/lib/des/cipher.js ***!
  \***********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! minimalistic-assert */
  22);

  function n(e) {
    this.options = e, this.type = this.options.type, this.blockSize = 8, this._init(), this.buffer = new Array(this.blockSize), this.bufferOff = 0;
  }

  e.exports = n, n.prototype._init = function () {}, n.prototype.update = function (e) {
    return 0 === e.length ? [] : "decrypt" === this.type ? this._updateDecrypt(e) : this._updateEncrypt(e);
  }, n.prototype._buffer = function (e, t) {
    for (var a = Math.min(this.buffer.length - this.bufferOff, e.length - t), r = 0; r < a; r++) {
      this.buffer[this.bufferOff + r] = e[t + r];
    }

    return this.bufferOff += a, a;
  }, n.prototype._flushBuffer = function (e, t) {
    return this._update(this.buffer, 0, e, t), this.bufferOff = 0, this.blockSize;
  }, n.prototype._updateEncrypt = function (e) {
    var t = 0,
        a = 0,
        r = (this.bufferOff + e.length) / this.blockSize | 0,
        n = new Array(r * this.blockSize);
    0 !== this.bufferOff && (t += this._buffer(e, t), this.bufferOff === this.buffer.length && (a += this._flushBuffer(n, a)));

    for (var s = e.length - (e.length - t) % this.blockSize; t < s; t += this.blockSize) {
      this._update(e, t, n, a), a += this.blockSize;
    }

    for (; t < e.length; t++, this.bufferOff++) {
      this.buffer[this.bufferOff] = e[t];
    }

    return n;
  }, n.prototype._updateDecrypt = function (e) {
    for (var t = 0, a = 0, r = Math.ceil((this.bufferOff + e.length) / this.blockSize) - 1, n = new Array(r * this.blockSize); r > 0; r--) {
      t += this._buffer(e, t), a += this._flushBuffer(n, a);
    }

    return t += this._buffer(e, t), n;
  }, n.prototype.final = function (e) {
    var t, a;
    return e && (t = this.update(e)), a = "encrypt" === this.type ? this._finalEncrypt() : this._finalDecrypt(), t ? t.concat(a) : a;
  }, n.prototype._pad = function (e, t) {
    if (0 === t) return !1;

    for (; t < e.length;) {
      e[t++] = 0;
    }

    return !0;
  }, n.prototype._finalEncrypt = function () {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var e = new Array(this.blockSize);
    return this._update(this.buffer, 0, e, 0), e;
  }, n.prototype._unpad = function (e) {
    return e;
  }, n.prototype._finalDecrypt = function () {
    r.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var e = new Array(this.blockSize);
    return this._flushBuffer(e, 0), this._unpad(e);
  };
},
/*!********************************************!*\
  !*** ./node_modules/des.js/lib/des/des.js ***!
  \********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! minimalistic-assert */
  22),
      n = a(
  /*! inherits */
  3),
      s = a(
  /*! ../des */
  136),
      o = s.utils,
      i = s.Cipher;

  function c() {
    this.tmp = new Array(2), this.keys = null;
  }

  function u(e) {
    i.call(this, e);
    var t = new c();
    this._desState = t, this.deriveKeys(t, e.key);
  }

  n(u, i), e.exports = u, u.create = function (e) {
    return new u(e);
  };
  var d = [1, 1, 2, 2, 2, 2, 2, 2, 1, 2, 2, 2, 2, 2, 2, 1];
  u.prototype.deriveKeys = function (e, t) {
    e.keys = new Array(32), r.equal(t.length, this.blockSize, "Invalid key length");
    var a = o.readUInt32BE(t, 0),
        n = o.readUInt32BE(t, 4);
    o.pc1(a, n, e.tmp, 0), a = e.tmp[0], n = e.tmp[1];

    for (var s = 0; s < e.keys.length; s += 2) {
      var i = d[s >>> 1];
      a = o.r28shl(a, i), n = o.r28shl(n, i), o.pc2(a, n, e.keys, s);
    }
  }, u.prototype._update = function (e, t, a, r) {
    var n = this._desState,
        s = o.readUInt32BE(e, t),
        i = o.readUInt32BE(e, t + 4);
    o.ip(s, i, n.tmp, 0), s = n.tmp[0], i = n.tmp[1], "encrypt" === this.type ? this._encrypt(n, s, i, n.tmp, 0) : this._decrypt(n, s, i, n.tmp, 0), s = n.tmp[0], i = n.tmp[1], o.writeUInt32BE(a, s, r), o.writeUInt32BE(a, i, r + 4);
  }, u.prototype._pad = function (e, t) {
    for (var a = e.length - t, r = t; r < e.length; r++) {
      e[r] = a;
    }

    return !0;
  }, u.prototype._unpad = function (e) {
    for (var t = e[e.length - 1], a = e.length - t; a < e.length; a++) {
      r.equal(e[a], t);
    }

    return e.slice(0, e.length - t);
  }, u.prototype._encrypt = function (e, t, a, r, n) {
    for (var s = t, i = a, c = 0; c < e.keys.length; c += 2) {
      var u = e.keys[c],
          d = e.keys[c + 1];
      o.expand(i, e.tmp, 0), u ^= e.tmp[0], d ^= e.tmp[1];
      var f = o.substitute(u, d),
          l = i;
      i = (s ^ o.permute(f)) >>> 0, s = l;
    }

    o.rip(i, s, r, n);
  }, u.prototype._decrypt = function (e, t, a, r, n) {
    for (var s = a, i = t, c = e.keys.length - 2; c >= 0; c -= 2) {
      var u = e.keys[c],
          d = e.keys[c + 1];
      o.expand(s, e.tmp, 0), u ^= e.tmp[0], d ^= e.tmp[1];
      var f = o.substitute(u, d),
          l = s;
      s = (i ^ o.permute(f)) >>> 0, i = l;
    }

    o.rip(s, i, r, n);
  };
},
/*!********************************************!*\
  !*** ./node_modules/des.js/lib/des/cbc.js ***!
  \********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! minimalistic-assert */
  22),
      n = a(
  /*! inherits */
  3),
      s = {};

  function o(e) {
    r.equal(e.length, 8, "Invalid IV length"), this.iv = new Array(8);

    for (var t = 0; t < this.iv.length; t++) {
      this.iv[t] = e[t];
    }
  }

  t.instantiate = function (e) {
    function t(t) {
      e.call(this, t), this._cbcInit();
    }

    n(t, e);

    for (var a = Object.keys(s), r = 0; r < a.length; r++) {
      var o = a[r];
      t.prototype[o] = s[o];
    }

    return t.create = function (e) {
      return new t(e);
    }, t;
  }, s._cbcInit = function () {
    var e = new o(this.options.iv);
    this._cbcState = e;
  }, s._update = function (e, t, a, r) {
    var n = this._cbcState,
        s = this.constructor.super_.prototype,
        o = n.iv;

    if ("encrypt" === this.type) {
      for (var i = 0; i < this.blockSize; i++) {
        o[i] ^= e[t + i];
      }

      s._update.call(this, o, 0, a, r);

      for (i = 0; i < this.blockSize; i++) {
        o[i] = a[r + i];
      }
    } else {
      s._update.call(this, e, t, a, r);

      for (i = 0; i < this.blockSize; i++) {
        a[r + i] ^= o[i];
      }

      for (i = 0; i < this.blockSize; i++) {
        o[i] = e[t + i];
      }
    }
  };
},
/*!********************************************!*\
  !*** ./node_modules/des.js/lib/des/ede.js ***!
  \********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! minimalistic-assert */
  22),
      n = a(
  /*! inherits */
  3),
      s = a(
  /*! ../des */
  136),
      o = s.Cipher,
      i = s.DES;

  function c(e, t) {
    r.equal(t.length, 24, "Invalid key length");
    var a = t.slice(0, 8),
        n = t.slice(8, 16),
        s = t.slice(16, 24);
    this.ciphers = "encrypt" === e ? [i.create({
      type: "encrypt",
      key: a
    }), i.create({
      type: "decrypt",
      key: n
    }), i.create({
      type: "encrypt",
      key: s
    })] : [i.create({
      type: "decrypt",
      key: s
    }), i.create({
      type: "encrypt",
      key: n
    }), i.create({
      type: "decrypt",
      key: a
    })];
  }

  function u(e) {
    o.call(this, e);
    var t = new c(this.type, this.options.key);
    this._edeState = t;
  }

  n(u, o), e.exports = u, u.create = function (e) {
    return new u(e);
  }, u.prototype._update = function (e, t, a, r) {
    var n = this._edeState;
    n.ciphers[0]._update(e, t, a, r), n.ciphers[1]._update(a, r, a, r), n.ciphers[2]._update(a, r, a, r);
  }, u.prototype._pad = i.prototype._pad, u.prototype._unpad = i.prototype._unpad;
},
/*!**************************************************!*\
  !*** ./node_modules/browserify-aes/encrypter.js ***!
  \**************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./modes */
  138),
      n = a(
  /*! ./authCipher */
  257),
      s = a(
  /*! safe-buffer */
  7).Buffer,
      o = a(
  /*! ./streamCipher */
  258),
      i = a(
  /*! cipher-base */
  46),
      c = a(
  /*! ./aes */
  90),
      u = a(
  /*! evp_bytestokey */
  91);

  function d(e, t, a) {
    i.call(this), this._cache = new l(), this._cipher = new c.AES(t), this._prev = s.from(a), this._mode = e, this._autopadding = !0;
  }

  a(
  /*! inherits */
  3)(d, i), d.prototype._update = function (e) {
    var t, a;

    this._cache.add(e);

    for (var r = []; t = this._cache.get();) {
      a = this._mode.encrypt(this, t), r.push(a);
    }

    return s.concat(r);
  };
  var f = s.alloc(16, 16);

  function l() {
    this.cache = s.allocUnsafe(0);
  }

  function h(e, t, a) {
    var i = r[e.toLowerCase()];
    if (!i) throw new TypeError("invalid suite type");
    if ("string" == typeof t && (t = s.from(t)), t.length !== i.key / 8) throw new TypeError("invalid key length " + t.length);
    if ("string" == typeof a && (a = s.from(a)), "GCM" !== i.mode && a.length !== i.iv) throw new TypeError("invalid iv length " + a.length);
    return "stream" === i.type ? new o(i.module, t, a) : "auth" === i.type ? new n(i.module, t, a) : new d(i.module, t, a);
  }

  d.prototype._final = function () {
    var e = this._cache.flush();

    if (this._autopadding) return e = this._mode.encrypt(this, e), this._cipher.scrub(), e;
    if (!e.equals(f)) throw this._cipher.scrub(), new Error("data not multiple of block length");
  }, d.prototype.setAutoPadding = function (e) {
    return this._autopadding = !!e, this;
  }, l.prototype.add = function (e) {
    this.cache = s.concat([this.cache, e]);
  }, l.prototype.get = function () {
    if (this.cache.length > 15) {
      var e = this.cache.slice(0, 16);
      return this.cache = this.cache.slice(16), e;
    }

    return null;
  }, l.prototype.flush = function () {
    for (var e = 16 - this.cache.length, t = s.allocUnsafe(e), a = -1; ++a < e;) {
      t.writeUInt8(e, a);
    }

    return s.concat([this.cache, t]);
  }, t.createCipheriv = h, t.createCipher = function (e, t) {
    var a = r[e.toLowerCase()];
    if (!a) throw new TypeError("invalid suite type");
    var n = u(t, !1, a.key, a.iv);
    return h(e, n.key, n.iv);
  };
},
/*!**************************************************!*\
  !*** ./node_modules/browserify-aes/modes/ecb.js ***!
  \**************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  t.encrypt = function (e, t) {
    return e._cipher.encryptBlock(t);
  }, t.decrypt = function (e, t) {
    return e._cipher.decryptBlock(t);
  };
},
/*!**************************************************!*\
  !*** ./node_modules/browserify-aes/modes/cbc.js ***!
  \**************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! buffer-xor */
  63);
  t.encrypt = function (e, t) {
    var a = r(t, e._prev);
    return e._prev = e._cipher.encryptBlock(a), e._prev;
  }, t.decrypt = function (e, t) {
    var a = e._prev;
    e._prev = t;

    var n = e._cipher.decryptBlock(t);

    return r(n, a);
  };
},
/*!**************************************************!*\
  !*** ./node_modules/browserify-aes/modes/cfb.js ***!
  \**************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! safe-buffer */
  7).Buffer,
      n = a(
  /*! buffer-xor */
  63);

  function s(e, t, a) {
    var s = t.length,
        o = n(t, e._cache);
    return e._cache = e._cache.slice(s), e._prev = r.concat([e._prev, a ? t : o]), o;
  }

  t.encrypt = function (e, t, a) {
    for (var n, o = r.allocUnsafe(0); t.length;) {
      if (0 === e._cache.length && (e._cache = e._cipher.encryptBlock(e._prev), e._prev = r.allocUnsafe(0)), !(e._cache.length <= t.length)) {
        o = r.concat([o, s(e, t, a)]);
        break;
      }

      n = e._cache.length, o = r.concat([o, s(e, t.slice(0, n), a)]), t = t.slice(n);
    }

    return o;
  };
},
/*!***************************************************!*\
  !*** ./node_modules/browserify-aes/modes/cfb8.js ***!
  \***************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! safe-buffer */
  7).Buffer;

  function n(e, t, a) {
    var n = e._cipher.encryptBlock(e._prev)[0] ^ t;
    return e._prev = r.concat([e._prev.slice(1), r.from([a ? t : n])]), n;
  }

  t.encrypt = function (e, t, a) {
    for (var s = t.length, o = r.allocUnsafe(s), i = -1; ++i < s;) {
      o[i] = n(e, t[i], a);
    }

    return o;
  };
},
/*!***************************************************!*\
  !*** ./node_modules/browserify-aes/modes/cfb1.js ***!
  \***************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! safe-buffer */
  7).Buffer;

  function n(e, t, a) {
    for (var r, n, o = -1, i = 0; ++o < 8;) {
      r = t & 1 << 7 - o ? 128 : 0, i += (128 & (n = e._cipher.encryptBlock(e._prev)[0] ^ r)) >> o % 8, e._prev = s(e._prev, a ? r : n);
    }

    return i;
  }

  function s(e, t) {
    var a = e.length,
        n = -1,
        s = r.allocUnsafe(e.length);

    for (e = r.concat([e, r.from([t])]); ++n < a;) {
      s[n] = e[n] << 1 | e[n + 1] >> 7;
    }

    return s;
  }

  t.encrypt = function (e, t, a) {
    for (var s = t.length, o = r.allocUnsafe(s), i = -1; ++i < s;) {
      o[i] = n(e, t[i], a);
    }

    return o;
  };
},
/*!**************************************************!*\
  !*** ./node_modules/browserify-aes/modes/ofb.js ***!
  \**************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (e) {
    var r = a(
    /*! buffer-xor */
    63);

    function n(e) {
      return e._prev = e._cipher.encryptBlock(e._prev), e._prev;
    }

    t.encrypt = function (t, a) {
      for (; t._cache.length < a.length;) {
        t._cache = e.concat([t._cache, n(t)]);
      }

      var s = t._cache.slice(0, a.length);

      return t._cache = t._cache.slice(a.length), r(a, s);
    };
  }).call(this, a(
  /*! ./../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!**********************************************!*\
  !*** ./node_modules/browserify-aes/ghash.js ***!
  \**********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! safe-buffer */
  7).Buffer,
      n = r.alloc(16, 0);

  function s(e) {
    var t = r.allocUnsafe(16);
    return t.writeUInt32BE(e[0] >>> 0, 0), t.writeUInt32BE(e[1] >>> 0, 4), t.writeUInt32BE(e[2] >>> 0, 8), t.writeUInt32BE(e[3] >>> 0, 12), t;
  }

  function o(e) {
    this.h = e, this.state = r.alloc(16, 0), this.cache = r.allocUnsafe(0);
  }

  o.prototype.ghash = function (e) {
    for (var t = -1; ++t < e.length;) {
      this.state[t] ^= e[t];
    }

    this._multiply();
  }, o.prototype._multiply = function () {
    for (var e, t, a, r = [(e = this.h).readUInt32BE(0), e.readUInt32BE(4), e.readUInt32BE(8), e.readUInt32BE(12)], n = [0, 0, 0, 0], o = -1; ++o < 128;) {
      for (0 != (this.state[~~(o / 8)] & 1 << 7 - o % 8) && (n[0] ^= r[0], n[1] ^= r[1], n[2] ^= r[2], n[3] ^= r[3]), a = 0 != (1 & r[3]), t = 3; t > 0; t--) {
        r[t] = r[t] >>> 1 | (1 & r[t - 1]) << 31;
      }

      r[0] = r[0] >>> 1, a && (r[0] = r[0] ^ 225 << 24);
    }

    this.state = s(n);
  }, o.prototype.update = function (e) {
    var t;

    for (this.cache = r.concat([this.cache, e]); this.cache.length >= 16;) {
      t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), this.ghash(t);
    }
  }, o.prototype.final = function (e, t) {
    return this.cache.length && this.ghash(r.concat([this.cache, n], 16)), this.ghash(s([0, e, 0, t])), this.state;
  }, e.exports = o;
},
/*!**************************************************!*\
  !*** ./node_modules/browserify-aes/decrypter.js ***!
  \**************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./authCipher */
  257),
      n = a(
  /*! safe-buffer */
  7).Buffer,
      s = a(
  /*! ./modes */
  138),
      o = a(
  /*! ./streamCipher */
  258),
      i = a(
  /*! cipher-base */
  46),
      c = a(
  /*! ./aes */
  90),
      u = a(
  /*! evp_bytestokey */
  91);

  function d(e, t, a) {
    i.call(this), this._cache = new f(), this._last = void 0, this._cipher = new c.AES(t), this._prev = n.from(a), this._mode = e, this._autopadding = !0;
  }

  function f() {
    this.cache = n.allocUnsafe(0);
  }

  function l(e, t, a) {
    var i = s[e.toLowerCase()];
    if (!i) throw new TypeError("invalid suite type");
    if ("string" == typeof a && (a = n.from(a)), "GCM" !== i.mode && a.length !== i.iv) throw new TypeError("invalid iv length " + a.length);
    if ("string" == typeof t && (t = n.from(t)), t.length !== i.key / 8) throw new TypeError("invalid key length " + t.length);
    return "stream" === i.type ? new o(i.module, t, a, !0) : "auth" === i.type ? new r(i.module, t, a, !0) : new d(i.module, t, a);
  }

  a(
  /*! inherits */
  3)(d, i), d.prototype._update = function (e) {
    var t, a;

    this._cache.add(e);

    for (var r = []; t = this._cache.get(this._autopadding);) {
      a = this._mode.decrypt(this, t), r.push(a);
    }

    return n.concat(r);
  }, d.prototype._final = function () {
    var e = this._cache.flush();

    if (this._autopadding) return function (e) {
      var t = e[15];
      if (t < 1 || t > 16) throw new Error("unable to decrypt data");
      var a = -1;

      for (; ++a < t;) {
        if (e[a + (16 - t)] !== t) throw new Error("unable to decrypt data");
      }

      if (16 === t) return;
      return e.slice(0, 16 - t);
    }(this._mode.decrypt(this, e));
    if (e) throw new Error("data not multiple of block length");
  }, d.prototype.setAutoPadding = function (e) {
    return this._autopadding = !!e, this;
  }, f.prototype.add = function (e) {
    this.cache = n.concat([this.cache, e]);
  }, f.prototype.get = function (e) {
    var t;

    if (e) {
      if (this.cache.length > 16) return t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), t;
    } else if (this.cache.length >= 16) return t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), t;

    return null;
  }, f.prototype.flush = function () {
    if (this.cache.length) return this.cache;
  }, t.createDecipher = function (e, t) {
    var a = s[e.toLowerCase()];
    if (!a) throw new TypeError("invalid suite type");
    var r = u(t, !1, a.key, a.iv);
    return l(e, r.key, r.iv);
  }, t.createDecipheriv = l;
},
/*!**********************************************!*\
  !*** ./node_modules/browserify-des/modes.js ***!
  \**********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  t["des-ecb"] = {
    key: 8,
    iv: 0
  }, t["des-cbc"] = t.des = {
    key: 8,
    iv: 8
  }, t["des-ede3-cbc"] = t.des3 = {
    key: 24,
    iv: 8
  }, t["des-ede3"] = {
    key: 24,
    iv: 0
  }, t["des-ede-cbc"] = {
    key: 16,
    iv: 8
  }, t["des-ede"] = {
    key: 16,
    iv: 0
  };
},
/*!************************************************!*\
  !*** ./node_modules/diffie-hellman/browser.js ***!
  \************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (e) {
    var r = a(
    /*! ./lib/generatePrime */
    259),
        n = a(
    /*! ./lib/primes.json */
    690),
        s = a(
    /*! ./lib/dh */
    691);
    var o = {
      binary: !0,
      hex: !0,
      base64: !0
    };
    t.DiffieHellmanGroup = t.createDiffieHellmanGroup = t.getDiffieHellman = function (t) {
      var a = new e(n[t].prime, "hex"),
          r = new e(n[t].gen, "hex");
      return new s(a, r);
    }, t.createDiffieHellman = t.DiffieHellman = function t(a, n, i, c) {
      return e.isBuffer(n) || void 0 === o[n] ? t(a, "binary", n, i) : (n = n || "binary", c = c || "binary", i = i || new e([2]), e.isBuffer(i) || (i = new e(i, c)), "number" == typeof a ? new s(r(a, i), i, !0) : (e.isBuffer(a) || (a = new e(a, n)), new s(a, i, !0)));
    };
  }).call(this, a(
  /*! ./../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!*****************************************************!*\
  !*** ./node_modules/diffie-hellman/lib/primes.json ***!
  \*****************************************************/

/*! exports provided: modp1, modp2, modp5, modp14, modp15, modp16, modp17, modp18, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}');
},
/*!***********************************************!*\
  !*** ./node_modules/diffie-hellman/lib/dh.js ***!
  \***********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    var r = a(
    /*! bn.js */
    5),
        n = new (a(
    /*! miller-rabin */
    117))(),
        s = new r(24),
        o = new r(11),
        i = new r(10),
        c = new r(3),
        u = new r(7),
        d = a(
    /*! ./generatePrime */
    259),
        f = a(
    /*! randombytes */
    67);

    function l(e, a) {
      return a = a || "utf8", t.isBuffer(e) || (e = new t(e, a)), this._pub = new r(e), this;
    }

    function h(e, a) {
      return a = a || "utf8", t.isBuffer(e) || (e = new t(e, a)), this._priv = new r(e), this;
    }

    e.exports = b;
    var p = {};

    function b(e, t, a) {
      this.setGenerator(t), this.__prime = new r(e), this._prime = r.mont(this.__prime), this._primeLen = e.length, this._pub = void 0, this._priv = void 0, this._primeCode = void 0, a ? (this.setPublicKey = l, this.setPrivateKey = h) : this._primeCode = 8;
    }

    function m(e, a) {
      var r = new t(e.toArray());
      return a ? r.toString(a) : r;
    }

    Object.defineProperty(b.prototype, "verifyError", {
      enumerable: !0,
      get: function get() {
        return "number" != typeof this._primeCode && (this._primeCode = function (e, t) {
          var a = t.toString("hex"),
              r = [a, e.toString(16)].join("_");
          if (r in p) return p[r];
          var f,
              l = 0;
          if (e.isEven() || !d.simpleSieve || !d.fermatTest(e) || !n.test(e)) return l += 1, l += "02" === a || "05" === a ? 8 : 4, p[r] = l, l;

          switch (n.test(e.shrn(1)) || (l += 2), a) {
            case "02":
              e.mod(s).cmp(o) && (l += 8);
              break;

            case "05":
              (f = e.mod(i)).cmp(c) && f.cmp(u) && (l += 8);
              break;

            default:
              l += 4;
          }

          return p[r] = l, l;
        }(this.__prime, this.__gen)), this._primeCode;
      }
    }), b.prototype.generateKeys = function () {
      return this._priv || (this._priv = new r(f(this._primeLen))), this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed(), this.getPublicKey();
    }, b.prototype.computeSecret = function (e) {
      var a = (e = (e = new r(e)).toRed(this._prime)).redPow(this._priv).fromRed(),
          n = new t(a.toArray()),
          s = this.getPrime();

      if (n.length < s.length) {
        var o = new t(s.length - n.length);
        o.fill(0), n = t.concat([o, n]);
      }

      return n;
    }, b.prototype.getPublicKey = function (e) {
      return m(this._pub, e);
    }, b.prototype.getPrivateKey = function (e) {
      return m(this._priv, e);
    }, b.prototype.getPrime = function (e) {
      return m(this.__prime, e);
    }, b.prototype.getGenerator = function (e) {
      return m(this._gen, e);
    }, b.prototype.setGenerator = function (e, a) {
      return a = a || "utf8", t.isBuffer(e) || (e = new t(e, a)), this.__gen = e, this._gen = new r(e), this;
    };
  }).call(this, a(
  /*! ./../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!*******************************************************!*\
  !*** ./node_modules/browserify-sign/browser/index.js ***!
  \*******************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    var r = a(
    /*! create-hash */
    20),
        n = a(
    /*! stream */
    28),
        s = a(
    /*! inherits */
    3),
        o = a(
    /*! ./sign */
    693),
        i = a(
    /*! ./verify */
    707),
        c = a(
    /*! ./algorithms.json */
    249);

    function u(e) {
      n.Writable.call(this);
      var t = c[e];
      if (!t) throw new Error("Unknown message digest");
      this._hashType = t.hash, this._hash = r(t.hash), this._tag = t.id, this._signType = t.sign;
    }

    function d(e) {
      n.Writable.call(this);
      var t = c[e];
      if (!t) throw new Error("Unknown message digest");
      this._hash = r(t.hash), this._tag = t.id, this._signType = t.sign;
    }

    function f(e) {
      return new u(e);
    }

    function l(e) {
      return new d(e);
    }

    Object.keys(c).forEach(function (e) {
      c[e].id = new t(c[e].id, "hex"), c[e.toLowerCase()] = c[e];
    }), s(u, n.Writable), u.prototype._write = function (e, t, a) {
      this._hash.update(e), a();
    }, u.prototype.update = function (e, a) {
      return "string" == typeof e && (e = new t(e, a)), this._hash.update(e), this;
    }, u.prototype.sign = function (e, t) {
      this.end();

      var a = this._hash.digest(),
          r = o(a, e, this._hashType, this._signType, this._tag);

      return t ? r.toString(t) : r;
    }, s(d, n.Writable), d.prototype._write = function (e, t, a) {
      this._hash.update(e), a();
    }, d.prototype.update = function (e, a) {
      return "string" == typeof e && (e = new t(e, a)), this._hash.update(e), this;
    }, d.prototype.verify = function (e, a, r) {
      "string" == typeof a && (a = new t(a, r)), this.end();

      var n = this._hash.digest();

      return i(a, n, e, this._signType, this._tag);
    }, e.exports = {
      Sign: f,
      Verify: l,
      createSign: f,
      createVerify: l
    };
  }).call(this, a(
  /*! ./../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!******************************************************!*\
  !*** ./node_modules/browserify-sign/browser/sign.js ***!
  \******************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    var r = a(
    /*! create-hmac */
    247),
        n = a(
    /*! browserify-rsa */
    139),
        s = a(
    /*! elliptic */
    78).ec,
        o = a(
    /*! bn.js */
    5),
        i = a(
    /*! parse-asn1 */
    92),
        c = a(
    /*! ./curves.json */
    264);

    function u(e, a, n, s) {
      if ((e = new t(e.toArray())).length < a.byteLength()) {
        var o = new t(a.byteLength() - e.length);
        o.fill(0), e = t.concat([o, e]);
      }

      var i = n.length,
          c = function (e, a) {
        e = (e = d(e, a)).mod(a);
        var r = new t(e.toArray());

        if (r.length < a.byteLength()) {
          var n = new t(a.byteLength() - r.length);
          n.fill(0), r = t.concat([n, r]);
        }

        return r;
      }(n, a),
          u = new t(i);

      u.fill(1);
      var f = new t(i);
      return f.fill(0), f = r(s, f).update(u).update(new t([0])).update(e).update(c).digest(), u = r(s, f).update(u).digest(), {
        k: f = r(s, f).update(u).update(new t([1])).update(e).update(c).digest(),
        v: u = r(s, f).update(u).digest()
      };
    }

    function d(e, t) {
      var a = new o(e),
          r = (e.length << 3) - t.bitLength();
      return r > 0 && a.ishrn(r), a;
    }

    function f(e, a, n) {
      var s, o;

      do {
        for (s = new t(0); 8 * s.length < e.bitLength();) {
          a.v = r(n, a.k).update(a.v).digest(), s = t.concat([s, a.v]);
        }

        o = d(s, e), a.k = r(n, a.k).update(a.v).update(new t([0])).digest(), a.v = r(n, a.k).update(a.v).digest();
      } while (-1 !== o.cmp(e));

      return o;
    }

    function l(e, t, a, r) {
      return e.toRed(o.mont(a)).redPow(t).fromRed().mod(r);
    }

    e.exports = function (e, a, r, h, p) {
      var b = i(a);

      if (b.curve) {
        if ("ecdsa" !== h && "ecdsa/rsa" !== h) throw new Error("wrong private key type");
        return function (e, a) {
          var r = c[a.curve.join(".")];
          if (!r) throw new Error("unknown curve " + a.curve.join("."));
          var n = new s(r).keyFromPrivate(a.privateKey).sign(e);
          return new t(n.toDER());
        }(e, b);
      }

      if ("dsa" === b.type) {
        if ("dsa" !== h) throw new Error("wrong private key type");
        return function (e, a, r) {
          var n,
              s = a.params.priv_key,
              i = a.params.p,
              c = a.params.q,
              h = a.params.g,
              p = new o(0),
              b = d(e, c).mod(c),
              m = !1,
              y = u(s, c, e, r);

          for (; !1 === m;) {
            n = f(c, y, r), p = l(h, n, i, c), 0 === (m = n.invm(c).imul(b.add(s.mul(p))).mod(c)).cmpn(0) && (m = !1, p = new o(0));
          }

          return function (e, a) {
            e = e.toArray(), a = a.toArray(), 128 & e[0] && (e = [0].concat(e));
            128 & a[0] && (a = [0].concat(a));
            var r = [48, e.length + a.length + 4, 2, e.length];
            return r = r.concat(e, [2, a.length], a), new t(r);
          }(p, m);
        }(e, b, r);
      }

      if ("rsa" !== h && "ecdsa/rsa" !== h) throw new Error("wrong private key type");
      e = t.concat([p, e]);

      for (var m = b.modulus.byteLength(), y = [0, 1]; e.length + y.length + 1 < m;) {
        y.push(255);
      }

      y.push(0);

      for (var v = -1; ++v < e.length;) {
        y.push(e[v]);
      }

      return n(y, b);
    }, e.exports.getKey = u, e.exports.makeKey = f;
  }).call(this, a(
  /*! ./../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!*****************************************!*\
  !*** ./node_modules/parse-asn1/asn1.js ***!
  \*****************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! asn1.js */
  75);
  t.certificate = a(
  /*! ./certificate */
  704);
  var n = r.define("RSAPrivateKey", function () {
    this.seq().obj(this.key("version").int(), this.key("modulus").int(), this.key("publicExponent").int(), this.key("privateExponent").int(), this.key("prime1").int(), this.key("prime2").int(), this.key("exponent1").int(), this.key("exponent2").int(), this.key("coefficient").int());
  });
  t.RSAPrivateKey = n;
  var s = r.define("RSAPublicKey", function () {
    this.seq().obj(this.key("modulus").int(), this.key("publicExponent").int());
  });
  t.RSAPublicKey = s;
  var o = r.define("SubjectPublicKeyInfo", function () {
    this.seq().obj(this.key("algorithm").use(i), this.key("subjectPublicKey").bitstr());
  });
  t.PublicKey = o;
  var i = r.define("AlgorithmIdentifier", function () {
    this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p").int(), this.key("q").int(), this.key("g").int()).optional());
  }),
      c = r.define("PrivateKeyInfo", function () {
    this.seq().obj(this.key("version").int(), this.key("algorithm").use(i), this.key("subjectPrivateKey").octstr());
  });
  t.PrivateKey = c;
  var u = r.define("EncryptedPrivateKeyInfo", function () {
    this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters").int())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
  });
  t.EncryptedPrivateKey = u;
  var d = r.define("DSAPrivateKey", function () {
    this.seq().obj(this.key("version").int(), this.key("p").int(), this.key("q").int(), this.key("g").int(), this.key("pub_key").int(), this.key("priv_key").int());
  });
  t.DSAPrivateKey = d, t.DSAparam = r.define("DSAparam", function () {
    this.int();
  });
  var f = r.define("ECPrivateKey", function () {
    this.seq().obj(this.key("version").int(), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use(l), this.key("publicKey").optional().explicit(1).bitstr());
  });
  t.ECPrivateKey = f;
  var l = r.define("ECParameters", function () {
    this.choice({
      namedCurve: this.objid()
    });
  });
  t.signature = r.define("signature", function () {
    this.seq().obj(this.key("r").int(), this.key("s").int());
  });
},
/*!**********************************************!*\
  !*** ./node_modules/asn1.js/lib/asn1/api.js ***!
  \**********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../asn1 */
  75),
      n = a(
  /*! inherits */
  3);

  function s(e, t) {
    this.name = e, this.body = t, this.decoders = {}, this.encoders = {};
  }

  t.define = function (e, t) {
    return new s(e, t);
  }, s.prototype._createNamed = function (e) {
    var t;

    try {
      t = a(
      /*! vm */
      696).runInThisContext("(function " + this.name + "(entity) {\n  this._initNamed(entity);\n})");
    } catch (e) {
      t = function t(e) {
        this._initNamed(e);
      };
    }

    return n(t, e), t.prototype._initNamed = function (t) {
      e.call(this, t);
    }, new t(this);
  }, s.prototype._getDecoder = function (e) {
    return e = e || "der", this.decoders.hasOwnProperty(e) || (this.decoders[e] = this._createNamed(r.decoders[e])), this.decoders[e];
  }, s.prototype.decode = function (e, t, a) {
    return this._getDecoder(t).decode(e, a);
  }, s.prototype._getEncoder = function (e) {
    return e = e || "der", this.encoders.hasOwnProperty(e) || (this.encoders[e] = this._createNamed(r.encoders[e])), this.encoders[e];
  }, s.prototype.encode = function (e, t, a) {
    return this._getEncoder(t).encode(e, a);
  };
},
/*!*********************************************!*\
  !*** ./node_modules/vm-browserify/index.js ***!
  \*********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (module, exports) {
  var indexOf = function indexOf(e, t) {
    if (e.indexOf) return e.indexOf(t);

    for (var a = 0; a < e.length; a++) {
      if (e[a] === t) return a;
    }

    return -1;
  },
      Object_keys = function Object_keys(e) {
    if (Object.keys) return Object.keys(e);
    var t = [];

    for (var a in e) {
      t.push(a);
    }

    return t;
  },
      forEach = function forEach(e, t) {
    if (e.forEach) return e.forEach(t);

    for (var a = 0; a < e.length; a++) {
      t(e[a], a, e);
    }
  },
      defineProp = function () {
    try {
      return Object.defineProperty({}, "_", {}), function (e, t, a) {
        Object.defineProperty(e, t, {
          writable: !0,
          enumerable: !1,
          configurable: !0,
          value: a
        });
      };
    } catch (e) {
      return function (e, t, a) {
        e[t] = a;
      };
    }
  }(),
      globals = ["Array", "Boolean", "Date", "Error", "EvalError", "Function", "Infinity", "JSON", "Math", "NaN", "Number", "Object", "RangeError", "ReferenceError", "RegExp", "String", "SyntaxError", "TypeError", "URIError", "decodeURI", "decodeURIComponent", "encodeURI", "encodeURIComponent", "escape", "eval", "isFinite", "isNaN", "parseFloat", "parseInt", "undefined", "unescape"];

  function Context() {}

  Context.prototype = {};

  var Script = exports.Script = function (e) {
    if (!(this instanceof Script)) return new Script(e);
    this.code = e;
  };

  Script.prototype.runInContext = function (e) {
    if (!(e instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var t = document.createElement("iframe");
    t.style || (t.style = {}), t.style.display = "none", document.body.appendChild(t);
    var a = t.contentWindow,
        r = a.eval,
        n = a.execScript;
    !r && n && (n.call(a, "null"), r = a.eval), forEach(Object_keys(e), function (t) {
      a[t] = e[t];
    }), forEach(globals, function (t) {
      e[t] && (a[t] = e[t]);
    });
    var s = Object_keys(a),
        o = r.call(a, this.code);
    return forEach(Object_keys(a), function (t) {
      (t in e || -1 === indexOf(s, t)) && (e[t] = a[t]);
    }), forEach(globals, function (t) {
      t in e || defineProp(e, t, a[t]);
    }), document.body.removeChild(t), o;
  }, Script.prototype.runInThisContext = function () {
    return eval(this.code);
  }, Script.prototype.runInNewContext = function (e) {
    var t = Script.createContext(e),
        a = this.runInContext(t);
    return e && forEach(Object_keys(t), function (a) {
      e[a] = t[a];
    }), a;
  }, forEach(Object_keys(Script.prototype), function (e) {
    exports[e] = Script[e] = function (t) {
      var a = Script(t);
      return a[e].apply(a, [].slice.call(arguments, 1));
    };
  }), exports.isContext = function (e) {
    return e instanceof Context;
  }, exports.createScript = function (e) {
    return exports.Script(e);
  }, exports.createContext = Script.createContext = function (e) {
    var t = new Context();
    return "object" == typeof e && forEach(Object_keys(e), function (a) {
      t[a] = e[a];
    }), t;
  };
},
/*!********************************************************!*\
  !*** ./node_modules/asn1.js/lib/asn1/base/reporter.js ***!
  \********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! inherits */
  3);

  function n(e) {
    this._reporterState = {
      obj: null,
      path: [],
      options: e || {},
      errors: []
    };
  }

  function s(e, t) {
    this.path = e, this.rethrow(t);
  }

  t.Reporter = n, n.prototype.isError = function (e) {
    return e instanceof s;
  }, n.prototype.save = function () {
    var e = this._reporterState;
    return {
      obj: e.obj,
      pathLen: e.path.length
    };
  }, n.prototype.restore = function (e) {
    var t = this._reporterState;
    t.obj = e.obj, t.path = t.path.slice(0, e.pathLen);
  }, n.prototype.enterKey = function (e) {
    return this._reporterState.path.push(e);
  }, n.prototype.exitKey = function (e) {
    var t = this._reporterState;
    t.path = t.path.slice(0, e - 1);
  }, n.prototype.leaveKey = function (e, t, a) {
    var r = this._reporterState;
    this.exitKey(e), null !== r.obj && (r.obj[t] = a);
  }, n.prototype.path = function () {
    return this._reporterState.path.join("/");
  }, n.prototype.enterObject = function () {
    var e = this._reporterState,
        t = e.obj;
    return e.obj = {}, t;
  }, n.prototype.leaveObject = function (e) {
    var t = this._reporterState,
        a = t.obj;
    return t.obj = e, a;
  }, n.prototype.error = function (e) {
    var t,
        a = this._reporterState,
        r = e instanceof s;
    if (t = r ? e : new s(a.path.map(function (e) {
      return "[" + JSON.stringify(e) + "]";
    }).join(""), e.message || e, e.stack), !a.options.partial) throw t;
    return r || a.errors.push(t), t;
  }, n.prototype.wrapResult = function (e) {
    var t = this._reporterState;
    return t.options.partial ? {
      result: this.isError(e) ? null : e,
      errors: t.errors
    } : e;
  }, r(s, Error), s.prototype.rethrow = function (e) {
    if (this.message = e + " at: " + (this.path || "(shallow)"), Error.captureStackTrace && Error.captureStackTrace(this, s), !this.stack) try {
      throw new Error(this.message);
    } catch (e) {
      this.stack = e.stack;
    }
    return this;
  };
},
/*!****************************************************!*\
  !*** ./node_modules/asn1.js/lib/asn1/base/node.js ***!
  \****************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../base */
  76).Reporter,
      n = a(
  /*! ../base */
  76).EncoderBuffer,
      s = a(
  /*! ../base */
  76).DecoderBuffer,
      o = a(
  /*! minimalistic-assert */
  22),
      i = ["seq", "seqof", "set", "setof", "objid", "bool", "gentime", "utctime", "null_", "enum", "int", "objDesc", "bitstr", "bmpstr", "charstr", "genstr", "graphstr", "ia5str", "iso646str", "numstr", "octstr", "printstr", "t61str", "unistr", "utf8str", "videostr"],
      c = ["key", "obj", "use", "optional", "explicit", "implicit", "def", "choice", "any", "contains"].concat(i);

  function u(e, t) {
    var a = {};
    this._baseState = a, a.enc = e, a.parent = t || null, a.children = null, a.tag = null, a.args = null, a.reverseArgs = null, a.choice = null, a.optional = !1, a.any = !1, a.obj = !1, a.use = null, a.useDecoder = null, a.key = null, a.default = null, a.explicit = null, a.implicit = null, a.contains = null, a.parent || (a.children = [], this._wrap());
  }

  e.exports = u;
  var d = ["enc", "parent", "children", "tag", "args", "reverseArgs", "choice", "optional", "any", "obj", "use", "alteredUse", "key", "default", "explicit", "implicit", "contains"];
  u.prototype.clone = function () {
    var e = this._baseState,
        t = {};
    d.forEach(function (a) {
      t[a] = e[a];
    });
    var a = new this.constructor(t.parent);
    return a._baseState = t, a;
  }, u.prototype._wrap = function () {
    var e = this._baseState;
    c.forEach(function (t) {
      this[t] = function () {
        var a = new this.constructor(this);
        return e.children.push(a), a[t].apply(a, arguments);
      };
    }, this);
  }, u.prototype._init = function (e) {
    var t = this._baseState;
    o(null === t.parent), e.call(this), t.children = t.children.filter(function (e) {
      return e._baseState.parent === this;
    }, this), o.equal(t.children.length, 1, "Root node can have only one child");
  }, u.prototype._useArgs = function (e) {
    var t = this._baseState,
        a = e.filter(function (e) {
      return e instanceof this.constructor;
    }, this);
    e = e.filter(function (e) {
      return !(e instanceof this.constructor);
    }, this), 0 !== a.length && (o(null === t.children), t.children = a, a.forEach(function (e) {
      e._baseState.parent = this;
    }, this)), 0 !== e.length && (o(null === t.args), t.args = e, t.reverseArgs = e.map(function (e) {
      if ("object" != typeof e || e.constructor !== Object) return e;
      var t = {};
      return Object.keys(e).forEach(function (a) {
        a == (0 | a) && (a |= 0);
        var r = e[a];
        t[r] = a;
      }), t;
    }));
  }, ["_peekTag", "_decodeTag", "_use", "_decodeStr", "_decodeObjid", "_decodeTime", "_decodeNull", "_decodeInt", "_decodeBool", "_decodeList", "_encodeComposite", "_encodeStr", "_encodeObjid", "_encodeTime", "_encodeNull", "_encodeInt", "_encodeBool"].forEach(function (e) {
    u.prototype[e] = function () {
      var t = this._baseState;
      throw new Error(e + " not implemented for encoding: " + t.enc);
    };
  }), i.forEach(function (e) {
    u.prototype[e] = function () {
      var t = this._baseState,
          a = Array.prototype.slice.call(arguments);
      return o(null === t.tag), t.tag = e, this._useArgs(a), this;
    };
  }), u.prototype.use = function (e) {
    o(e);
    var t = this._baseState;
    return o(null === t.use), t.use = e, this;
  }, u.prototype.optional = function () {
    return this._baseState.optional = !0, this;
  }, u.prototype.def = function (e) {
    var t = this._baseState;
    return o(null === t.default), t.default = e, t.optional = !0, this;
  }, u.prototype.explicit = function (e) {
    var t = this._baseState;
    return o(null === t.explicit && null === t.implicit), t.explicit = e, this;
  }, u.prototype.implicit = function (e) {
    var t = this._baseState;
    return o(null === t.explicit && null === t.implicit), t.implicit = e, this;
  }, u.prototype.obj = function () {
    var e = this._baseState,
        t = Array.prototype.slice.call(arguments);
    return e.obj = !0, 0 !== t.length && this._useArgs(t), this;
  }, u.prototype.key = function (e) {
    var t = this._baseState;
    return o(null === t.key), t.key = e, this;
  }, u.prototype.any = function () {
    return this._baseState.any = !0, this;
  }, u.prototype.choice = function (e) {
    var t = this._baseState;
    return o(null === t.choice), t.choice = e, this._useArgs(Object.keys(e).map(function (t) {
      return e[t];
    })), this;
  }, u.prototype.contains = function (e) {
    var t = this._baseState;
    return o(null === t.use), t.contains = e, this;
  }, u.prototype._decode = function (e, t) {
    var a = this._baseState;
    if (null === a.parent) return e.wrapResult(a.children[0]._decode(e, t));
    var r,
        n = a.default,
        o = !0,
        i = null;

    if (null !== a.key && (i = e.enterKey(a.key)), a.optional) {
      var c = null;

      if (null !== a.explicit ? c = a.explicit : null !== a.implicit ? c = a.implicit : null !== a.tag && (c = a.tag), null !== c || a.any) {
        if (o = this._peekTag(e, c, a.any), e.isError(o)) return o;
      } else {
        var u = e.save();

        try {
          null === a.choice ? this._decodeGeneric(a.tag, e, t) : this._decodeChoice(e, t), o = !0;
        } catch (e) {
          o = !1;
        }

        e.restore(u);
      }
    }

    if (a.obj && o && (r = e.enterObject()), o) {
      if (null !== a.explicit) {
        var d = this._decodeTag(e, a.explicit);

        if (e.isError(d)) return d;
        e = d;
      }

      var f = e.offset;

      if (null === a.use && null === a.choice) {
        if (a.any) u = e.save();

        var l = this._decodeTag(e, null !== a.implicit ? a.implicit : a.tag, a.any);

        if (e.isError(l)) return l;
        a.any ? n = e.raw(u) : e = l;
      }

      if (t && t.track && null !== a.tag && t.track(e.path(), f, e.length, "tagged"), t && t.track && null !== a.tag && t.track(e.path(), e.offset, e.length, "content"), n = a.any ? n : null === a.choice ? this._decodeGeneric(a.tag, e, t) : this._decodeChoice(e, t), e.isError(n)) return n;

      if (a.any || null !== a.choice || null === a.children || a.children.forEach(function (a) {
        a._decode(e, t);
      }), a.contains && ("octstr" === a.tag || "bitstr" === a.tag)) {
        var h = new s(n);
        n = this._getUse(a.contains, e._reporterState.obj)._decode(h, t);
      }
    }

    return a.obj && o && (n = e.leaveObject(r)), null === a.key || null === n && !0 !== o ? null !== i && e.exitKey(i) : e.leaveKey(i, a.key, n), n;
  }, u.prototype._decodeGeneric = function (e, t, a) {
    var r = this._baseState;
    return "seq" === e || "set" === e ? null : "seqof" === e || "setof" === e ? this._decodeList(t, e, r.args[0], a) : /str$/.test(e) ? this._decodeStr(t, e, a) : "objid" === e && r.args ? this._decodeObjid(t, r.args[0], r.args[1], a) : "objid" === e ? this._decodeObjid(t, null, null, a) : "gentime" === e || "utctime" === e ? this._decodeTime(t, e, a) : "null_" === e ? this._decodeNull(t, a) : "bool" === e ? this._decodeBool(t, a) : "objDesc" === e ? this._decodeStr(t, e, a) : "int" === e || "enum" === e ? this._decodeInt(t, r.args && r.args[0], a) : null !== r.use ? this._getUse(r.use, t._reporterState.obj)._decode(t, a) : t.error("unknown tag: " + e);
  }, u.prototype._getUse = function (e, t) {
    var a = this._baseState;
    return a.useDecoder = this._use(e, t), o(null === a.useDecoder._baseState.parent), a.useDecoder = a.useDecoder._baseState.children[0], a.implicit !== a.useDecoder._baseState.implicit && (a.useDecoder = a.useDecoder.clone(), a.useDecoder._baseState.implicit = a.implicit), a.useDecoder;
  }, u.prototype._decodeChoice = function (e, t) {
    var a = this._baseState,
        r = null,
        n = !1;
    return Object.keys(a.choice).some(function (s) {
      var o = e.save(),
          i = a.choice[s];

      try {
        var c = i._decode(e, t);

        if (e.isError(c)) return !1;
        r = {
          type: s,
          value: c
        }, n = !0;
      } catch (t) {
        return e.restore(o), !1;
      }

      return !0;
    }, this), n ? r : e.error("Choice not matched");
  }, u.prototype._createEncoderBuffer = function (e) {
    return new n(e, this.reporter);
  }, u.prototype._encode = function (e, t, a) {
    var r = this._baseState;

    if (null === r.default || r.default !== e) {
      var n = this._encodeValue(e, t, a);

      if (void 0 !== n && !this._skipDefault(n, t, a)) return n;
    }
  }, u.prototype._encodeValue = function (e, t, a) {
    var n = this._baseState;
    if (null === n.parent) return n.children[0]._encode(e, t || new r());
    var s = null;

    if (this.reporter = t, n.optional && void 0 === e) {
      if (null === n.default) return;
      e = n.default;
    }

    var o = null,
        i = !1;
    if (n.any) s = this._createEncoderBuffer(e);else if (n.choice) s = this._encodeChoice(e, t);else if (n.contains) o = this._getUse(n.contains, a)._encode(e, t), i = !0;else if (n.children) o = n.children.map(function (a) {
      if ("null_" === a._baseState.tag) return a._encode(null, t, e);
      if (null === a._baseState.key) return t.error("Child should have a key");
      var r = t.enterKey(a._baseState.key);
      if ("object" != typeof e) return t.error("Child expected, but input is not object");

      var n = a._encode(e[a._baseState.key], t, e);

      return t.leaveKey(r), n;
    }, this).filter(function (e) {
      return e;
    }), o = this._createEncoderBuffer(o);else if ("seqof" === n.tag || "setof" === n.tag) {
      if (!n.args || 1 !== n.args.length) return t.error("Too many args for : " + n.tag);
      if (!Array.isArray(e)) return t.error("seqof/setof, but data is not Array");
      var c = this.clone();
      c._baseState.implicit = null, o = this._createEncoderBuffer(e.map(function (a) {
        var r = this._baseState;
        return this._getUse(r.args[0], e)._encode(a, t);
      }, c));
    } else null !== n.use ? s = this._getUse(n.use, a)._encode(e, t) : (o = this._encodePrimitive(n.tag, e), i = !0);

    if (!n.any && null === n.choice) {
      var u = null !== n.implicit ? n.implicit : n.tag,
          d = null === n.implicit ? "universal" : "context";
      null === u ? null === n.use && t.error("Tag could be omitted only for .use()") : null === n.use && (s = this._encodeComposite(u, i, d, o));
    }

    return null !== n.explicit && (s = this._encodeComposite(n.explicit, !1, "context", s)), s;
  }, u.prototype._encodeChoice = function (e, t) {
    var a = this._baseState,
        r = a.choice[e.type];
    return r || o(!1, e.type + " not found in " + JSON.stringify(Object.keys(a.choice))), r._encode(e.value, t);
  }, u.prototype._encodePrimitive = function (e, t) {
    var a = this._baseState;
    if (/str$/.test(e)) return this._encodeStr(t, e);
    if ("objid" === e && a.args) return this._encodeObjid(t, a.reverseArgs[0], a.args[1]);
    if ("objid" === e) return this._encodeObjid(t, null, null);
    if ("gentime" === e || "utctime" === e) return this._encodeTime(t, e);
    if ("null_" === e) return this._encodeNull();
    if ("int" === e || "enum" === e) return this._encodeInt(t, a.args && a.reverseArgs[0]);
    if ("bool" === e) return this._encodeBool(t);
    if ("objDesc" === e) return this._encodeStr(t, e);
    throw new Error("Unsupported tag: " + e);
  }, u.prototype._isNumstr = function (e) {
    return /^[0-9 ]*$/.test(e);
  }, u.prototype._isPrintstr = function (e) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(e);
  };
},
/*!********************************************************!*\
  !*** ./node_modules/asn1.js/lib/asn1/constants/der.js ***!
  \********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ../constants */
  261);
  t.tagClass = {
    0: "universal",
    1: "application",
    2: "context",
    3: "private"
  }, t.tagClassByName = r._reverse(t.tagClass), t.tag = {
    0: "end",
    1: "bool",
    2: "int",
    3: "bitstr",
    4: "octstr",
    5: "null_",
    6: "objid",
    7: "objDesc",
    8: "external",
    9: "real",
    10: "enum",
    11: "embed",
    12: "utf8str",
    13: "relativeOid",
    16: "seq",
    17: "set",
    18: "numstr",
    19: "printstr",
    20: "t61str",
    21: "videostr",
    22: "ia5str",
    23: "utctime",
    24: "gentime",
    25: "graphstr",
    26: "iso646str",
    27: "genstr",
    28: "unistr",
    29: "charstr",
    30: "bmpstr"
  }, t.tagByName = r._reverse(t.tag);
},
/*!*********************************************************!*\
  !*** ./node_modules/asn1.js/lib/asn1/decoders/index.js ***!
  \*********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = t;
  r.der = a(
  /*! ./der */
  262), r.pem = a(
  /*! ./pem */
  701);
},
/*!*******************************************************!*\
  !*** ./node_modules/asn1.js/lib/asn1/decoders/pem.js ***!
  \*******************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! inherits */
  3),
      n = a(
  /*! buffer */
  1).Buffer,
      s = a(
  /*! ./der */
  262);

  function o(e) {
    s.call(this, e), this.enc = "pem";
  }

  r(o, s), e.exports = o, o.prototype.decode = function (e, t) {
    for (var a = e.toString().split(/[\r\n]+/g), r = t.label.toUpperCase(), o = /^-----(BEGIN|END) ([^-]+)-----$/, i = -1, c = -1, u = 0; u < a.length; u++) {
      var d = a[u].match(o);

      if (null !== d && d[2] === r) {
        if (-1 !== i) {
          if ("END" !== d[1]) break;
          c = u;
          break;
        }

        if ("BEGIN" !== d[1]) break;
        i = u;
      }
    }

    if (-1 === i || -1 === c) throw new Error("PEM section not found for: " + r);
    var f = a.slice(i + 1, c).join("");
    f.replace(/[^a-z0-9\+\/=]+/gi, "");
    var l = new n(f, "base64");
    return s.prototype.decode.call(this, l, t);
  };
},
/*!*********************************************************!*\
  !*** ./node_modules/asn1.js/lib/asn1/encoders/index.js ***!
  \*********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = t;
  r.der = a(
  /*! ./der */
  263), r.pem = a(
  /*! ./pem */
  703);
},
/*!*******************************************************!*\
  !*** ./node_modules/asn1.js/lib/asn1/encoders/pem.js ***!
  \*******************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! inherits */
  3),
      n = a(
  /*! ./der */
  263);

  function s(e) {
    n.call(this, e), this.enc = "pem";
  }

  r(s, n), e.exports = s, s.prototype.encode = function (e, t) {
    for (var a = n.prototype.encode.call(this, e).toString("base64"), r = ["-----BEGIN " + t.label + "-----"], s = 0; s < a.length; s += 64) {
      r.push(a.slice(s, s + 64));
    }

    return r.push("-----END " + t.label + "-----"), r.join("\n");
  };
},
/*!************************************************!*\
  !*** ./node_modules/parse-asn1/certificate.js ***!
  \************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = a(
  /*! asn1.js */
  75),
      n = r.define("Time", function () {
    this.choice({
      utcTime: this.utctime(),
      generalTime: this.gentime()
    });
  }),
      s = r.define("AttributeTypeValue", function () {
    this.seq().obj(this.key("type").objid(), this.key("value").any());
  }),
      o = r.define("AlgorithmIdentifier", function () {
    this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional(), this.key("curve").objid().optional());
  }),
      i = r.define("SubjectPublicKeyInfo", function () {
    this.seq().obj(this.key("algorithm").use(o), this.key("subjectPublicKey").bitstr());
  }),
      c = r.define("RelativeDistinguishedName", function () {
    this.setof(s);
  }),
      u = r.define("RDNSequence", function () {
    this.seqof(c);
  }),
      d = r.define("Name", function () {
    this.choice({
      rdnSequence: this.use(u)
    });
  }),
      f = r.define("Validity", function () {
    this.seq().obj(this.key("notBefore").use(n), this.key("notAfter").use(n));
  }),
      l = r.define("Extension", function () {
    this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(!1), this.key("extnValue").octstr());
  }),
      h = r.define("TBSCertificate", function () {
    this.seq().obj(this.key("version").explicit(0).int().optional(), this.key("serialNumber").int(), this.key("signature").use(o), this.key("issuer").use(d), this.key("validity").use(f), this.key("subject").use(d), this.key("subjectPublicKeyInfo").use(i), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof(l).optional());
  }),
      p = r.define("X509Certificate", function () {
    this.seq().obj(this.key("tbsCertificate").use(h), this.key("signatureAlgorithm").use(o), this.key("signatureValue").bitstr());
  });
  e.exports = p;
},
/*!********************************************!*\
  !*** ./node_modules/parse-asn1/aesid.json ***!
  \********************************************/

/*! exports provided: 2.16.840.1.101.3.4.1.1, 2.16.840.1.101.3.4.1.2, 2.16.840.1.101.3.4.1.3, 2.16.840.1.101.3.4.1.4, 2.16.840.1.101.3.4.1.21, 2.16.840.1.101.3.4.1.22, 2.16.840.1.101.3.4.1.23, 2.16.840.1.101.3.4.1.24, 2.16.840.1.101.3.4.1.41, 2.16.840.1.101.3.4.1.42, 2.16.840.1.101.3.4.1.43, 2.16.840.1.101.3.4.1.44, default */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e) {
  e.exports = JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}');
},
/*!********************************************!*\
  !*** ./node_modules/parse-asn1/fixProc.js ***!
  \********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r\+\/\=]+)[\n\r]+/m,
      n = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m,
      s = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r\+\/\=]+)-----END \1-----$/m,
      o = a(
  /*! evp_bytestokey */
  91),
      i = a(
  /*! browserify-aes */
  137),
      c = a(
  /*! safe-buffer */
  7).Buffer;

  e.exports = function (e, t) {
    var a,
        u = e.toString(),
        d = u.match(r);

    if (d) {
      var f = "aes" + d[1],
          l = c.from(d[2], "hex"),
          h = c.from(d[3].replace(/[\r\n]/g, ""), "base64"),
          p = o(t, l.slice(0, 8), parseInt(d[1], 10)).key,
          b = [],
          m = i.createDecipheriv(f, p, l);
      b.push(m.update(h)), b.push(m.final()), a = c.concat(b);
    } else {
      var y = u.match(s);
      a = new c(y[2].replace(/[\r\n]/g, ""), "base64");
    }

    return {
      tag: u.match(n)[1],
      data: a
    };
  };
},
/*!********************************************************!*\
  !*** ./node_modules/browserify-sign/browser/verify.js ***!
  \********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    var r = a(
    /*! bn.js */
    5),
        n = a(
    /*! elliptic */
    78).ec,
        s = a(
    /*! parse-asn1 */
    92),
        o = a(
    /*! ./curves.json */
    264);

    function i(e, t) {
      if (e.cmpn(0) <= 0) throw new Error("invalid sig");
      if (e.cmp(t) >= t) throw new Error("invalid sig");
    }

    e.exports = function (e, a, c, u, d) {
      var f = s(c);

      if ("ec" === f.type) {
        if ("ecdsa" !== u && "ecdsa/rsa" !== u) throw new Error("wrong public key type");
        return function (e, t, a) {
          var r = o[a.data.algorithm.curve.join(".")];
          if (!r) throw new Error("unknown curve " + a.data.algorithm.curve.join("."));
          var s = new n(r),
              i = a.data.subjectPrivateKey.data;
          return s.verify(t, e, i);
        }(e, a, f);
      }

      if ("dsa" === f.type) {
        if ("dsa" !== u) throw new Error("wrong public key type");
        return function (e, t, a) {
          var n = a.data.p,
              o = a.data.q,
              c = a.data.g,
              u = a.data.pub_key,
              d = s.signature.decode(e, "der"),
              f = d.s,
              l = d.r;
          i(f, o), i(l, o);
          var h = r.mont(n),
              p = f.invm(o);
          return 0 === c.toRed(h).redPow(new r(t).mul(p).mod(o)).fromRed().mul(u.toRed(h).redPow(l.mul(p).mod(o)).fromRed()).mod(n).mod(o).cmp(l);
        }(e, a, f);
      }

      if ("rsa" !== u && "ecdsa/rsa" !== u) throw new Error("wrong public key type");
      a = t.concat([d, a]);

      for (var l = f.modulus.byteLength(), h = [1], p = 0; a.length + h.length + 2 < l;) {
        h.push(255), p++;
      }

      h.push(0);

      for (var b = -1; ++b < a.length;) {
        h.push(a[b]);
      }

      h = new t(h);
      var m = r.mont(f.modulus);
      e = (e = new r(e).toRed(m)).redPow(new r(f.publicExponent)), e = new t(e.fromRed().toArray());
      var y = p < 8 ? 1 : 0;

      for (l = Math.min(e.length, h.length), e.length !== h.length && (y = 1), b = -1; ++b < l;) {
        y |= e[b] ^ h[b];
      }

      return 0 === y;
    };
  }).call(this, a(
  /*! ./../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!*********************************************!*\
  !*** ./node_modules/create-ecdh/browser.js ***!
  \*********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    var r = a(
    /*! elliptic */
    78),
        n = a(
    /*! bn.js */
    5);

    e.exports = function (e) {
      return new o(e);
    };

    var s = {
      secp256k1: {
        name: "secp256k1",
        byteLength: 32
      },
      secp224r1: {
        name: "p224",
        byteLength: 28
      },
      prime256v1: {
        name: "p256",
        byteLength: 32
      },
      prime192v1: {
        name: "p192",
        byteLength: 24
      },
      ed25519: {
        name: "ed25519",
        byteLength: 32
      },
      secp384r1: {
        name: "p384",
        byteLength: 48
      },
      secp521r1: {
        name: "p521",
        byteLength: 66
      }
    };

    function o(e) {
      this.curveType = s[e], this.curveType || (this.curveType = {
        name: e
      }), this.curve = new r.ec(this.curveType.name), this.keys = void 0;
    }

    function i(e, a, r) {
      Array.isArray(e) || (e = e.toArray());
      var n = new t(e);

      if (r && n.length < r) {
        var s = new t(r - n.length);
        s.fill(0), n = t.concat([s, n]);
      }

      return a ? n.toString(a) : n;
    }

    s.p224 = s.secp224r1, s.p256 = s.secp256r1 = s.prime256v1, s.p192 = s.secp192r1 = s.prime192v1, s.p384 = s.secp384r1, s.p521 = s.secp521r1, o.prototype.generateKeys = function (e, t) {
      return this.keys = this.curve.genKeyPair(), this.getPublicKey(e, t);
    }, o.prototype.computeSecret = function (e, a, r) {
      return a = a || "utf8", t.isBuffer(e) || (e = new t(e, a)), i(this.curve.keyFromPublic(e).getPublic().mul(this.keys.getPrivate()).getX(), r, this.curveType.byteLength);
    }, o.prototype.getPublicKey = function (e, t) {
      var a = this.keys.getPublic("compressed" === t, !0);
      return "hybrid" === t && (a[a.length - 1] % 2 ? a[0] = 7 : a[0] = 6), i(a, e);
    }, o.prototype.getPrivateKey = function (e) {
      return i(this.keys.getPrivate(), e);
    }, o.prototype.setPublicKey = function (e, a) {
      return a = a || "utf8", t.isBuffer(e) || (e = new t(e, a)), this.keys._importPublic(e), this;
    }, o.prototype.setPrivateKey = function (e, a) {
      a = a || "utf8", t.isBuffer(e) || (e = new t(e, a));
      var r = new n(e);
      return r = r.toString(16), this.keys = this.curve.genKeyPair(), this.keys._importPrivate(r), this;
    };
  }).call(this, a(
  /*! ./../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!************************************************!*\
  !*** ./node_modules/public-encrypt/browser.js ***!
  \************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  t.publicEncrypt = a(
  /*! ./publicEncrypt */
  710), t.privateDecrypt = a(
  /*! ./privateDecrypt */
  711), t.privateEncrypt = function (e, a) {
    return t.publicEncrypt(e, a, !0);
  }, t.publicDecrypt = function (e, a) {
    return t.privateDecrypt(e, a, !0);
  };
},
/*!******************************************************!*\
  !*** ./node_modules/public-encrypt/publicEncrypt.js ***!
  \******************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! parse-asn1 */
  92),
      n = a(
  /*! randombytes */
  67),
      s = a(
  /*! create-hash */
  20),
      o = a(
  /*! ./mgf */
  265),
      i = a(
  /*! ./xor */
  266),
      c = a(
  /*! bn.js */
  5),
      u = a(
  /*! ./withPublic */
  267),
      d = a(
  /*! browserify-rsa */
  139),
      f = a(
  /*! safe-buffer */
  7).Buffer;

  e.exports = function (e, t, a) {
    var l;
    l = e.padding ? e.padding : a ? 1 : 4;
    var h,
        p = r(e);
    if (4 === l) h = function (e, t) {
      var a = e.modulus.byteLength(),
          r = t.length,
          u = s("sha1").update(f.alloc(0)).digest(),
          d = u.length,
          l = 2 * d;
      if (r > a - l - 2) throw new Error("message too long");
      var h = f.alloc(a - r - l - 2),
          p = a - d - 1,
          b = n(d),
          m = i(f.concat([u, h, f.alloc(1, 1), t], p), o(b, p)),
          y = i(b, o(m, d));
      return new c(f.concat([f.alloc(1), y, m], a));
    }(p, t);else if (1 === l) h = function (e, t, a) {
      var r,
          s = t.length,
          o = e.modulus.byteLength();
      if (s > o - 11) throw new Error("message too long");
      r = a ? f.alloc(o - s - 3, 255) : function (e) {
        var t,
            a = f.allocUnsafe(e),
            r = 0,
            s = n(2 * e),
            o = 0;

        for (; r < e;) {
          o === s.length && (s = n(2 * e), o = 0), (t = s[o++]) && (a[r++] = t);
        }

        return a;
      }(o - s - 3);
      return new c(f.concat([f.from([0, a ? 1 : 2]), r, f.alloc(1), t], o));
    }(p, t, a);else {
      if (3 !== l) throw new Error("unknown padding");
      if ((h = new c(t)).cmp(p.modulus) >= 0) throw new Error("data too long for modulus");
    }
    return a ? d(h, p) : u(h, p);
  };
},
/*!*******************************************************!*\
  !*** ./node_modules/public-encrypt/privateDecrypt.js ***!
  \*******************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! parse-asn1 */
  92),
      n = a(
  /*! ./mgf */
  265),
      s = a(
  /*! ./xor */
  266),
      o = a(
  /*! bn.js */
  5),
      i = a(
  /*! browserify-rsa */
  139),
      c = a(
  /*! create-hash */
  20),
      u = a(
  /*! ./withPublic */
  267),
      d = a(
  /*! safe-buffer */
  7).Buffer;

  e.exports = function (e, t, a) {
    var f;
    f = e.padding ? e.padding : a ? 1 : 4;
    var l,
        h = r(e),
        p = h.modulus.byteLength();
    if (t.length > p || new o(t).cmp(h.modulus) >= 0) throw new Error("decryption error");
    l = a ? u(new o(t), h) : i(t, h);
    var b = d.alloc(p - l.length);
    if (l = d.concat([b, l], p), 4 === f) return function (e, t) {
      var a = e.modulus.byteLength(),
          r = c("sha1").update(d.alloc(0)).digest(),
          o = r.length;
      if (0 !== t[0]) throw new Error("decryption error");
      var i = t.slice(1, o + 1),
          u = t.slice(o + 1),
          f = s(i, n(u, o)),
          l = s(u, n(f, a - o - 1));
      if (function (e, t) {
        e = d.from(e), t = d.from(t);
        var a = 0,
            r = e.length;
        e.length !== t.length && (a++, r = Math.min(e.length, t.length));
        var n = -1;

        for (; ++n < r;) {
          a += e[n] ^ t[n];
        }

        return a;
      }(r, l.slice(0, o))) throw new Error("decryption error");
      var h = o;

      for (; 0 === l[h];) {
        h++;
      }

      if (1 !== l[h++]) throw new Error("decryption error");
      return l.slice(h);
    }(h, l);
    if (1 === f) return function (e, t, a) {
      var r = t.slice(0, 2),
          n = 2,
          s = 0;

      for (; 0 !== t[n++];) {
        if (n >= t.length) {
          s++;
          break;
        }
      }

      var o = t.slice(2, n - 1);
      ("0002" !== r.toString("hex") && !a || "0001" !== r.toString("hex") && a) && s++;
      o.length < 8 && s++;
      if (s) throw new Error("decryption error");
      return t.slice(n);
    }(0, l, a);
    if (3 === f) return l;
    throw new Error("unknown padding");
  };
},
/*!********************************************!*\
  !*** ./node_modules/randomfill/browser.js ***!
  \********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e, r) {
    function n() {
      throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
    }

    var s = a(
    /*! safe-buffer */
    7),
        o = a(
    /*! randombytes */
    67),
        i = s.Buffer,
        c = s.kMaxLength,
        u = e.crypto || e.msCrypto,
        d = Math.pow(2, 32) - 1;

    function f(e, t) {
      if ("number" != typeof e || e != e) throw new TypeError("offset must be a number");
      if (e > d || e < 0) throw new TypeError("offset must be a uint32");
      if (e > c || e > t) throw new RangeError("offset out of range");
    }

    function l(e, t, a) {
      if ("number" != typeof e || e != e) throw new TypeError("size must be a number");
      if (e > d || e < 0) throw new TypeError("size must be a uint32");
      if (e + t > a || e > c) throw new RangeError("buffer too small");
    }

    function h(e, t, a, n) {
      if (r.browser) {
        var s = e.buffer,
            i = new Uint8Array(s, t, a);
        return u.getRandomValues(i), n ? void r.nextTick(function () {
          n(null, e);
        }) : e;
      }

      if (!n) return o(a).copy(e, t), e;
      o(a, function (a, r) {
        if (a) return n(a);
        r.copy(e, t), n(null, e);
      });
    }

    u && u.getRandomValues || !r.browser ? (t.randomFill = function (t, a, r, n) {
      if (!(i.isBuffer(t) || t instanceof e.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
      if ("function" == typeof a) n = a, a = 0, r = t.length;else if ("function" == typeof r) n = r, r = t.length - a;else if ("function" != typeof n) throw new TypeError('"cb" argument must be a function');
      return f(a, t.length), l(r, a, t.length), h(t, a, r, n);
    }, t.randomFillSync = function (t, a, r) {
      void 0 === a && (a = 0);
      if (!(i.isBuffer(t) || t instanceof e.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
      f(a, t.length), void 0 === r && (r = t.length - a);
      return l(r, a, t.length), h(t, a, r);
    }) : (t.randomFill = n, t.randomFillSync = n);
  }).call(this, a(
  /*! ./../webpack/buildin/global.js */
  18), a(
  /*! ./../process/browser.js */
  9));
},
/*!****************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-vm/dist/evm/precompiles/07-ecmul.js ***!
  \****************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = a(
  /*! bn.js */
  5),
      n = a(
  /*! ../evm */
  32),
      s = a(
  /*! assert */
  19),
      o = a(
  /*! rustbn.js */
  135);

  t.default = function (e) {
    s(e.data);
    var t = e.data,
        a = new r(e._common.param("gasPrices", "ecMul"));
    if (e.gasLimit.lt(a)) return n.OOGResult(e.gasLimit);
    var i = o.mul(t);
    return 64 !== i.length ? n.OOGResult(e.gasLimit) : {
      gasUsed: a,
      returnValue: i
    };
  };
},
/*!********************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-vm/dist/evm/precompiles/08-ecpairing.js ***!
  \********************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = a(
  /*! bn.js */
  5),
      n = a(
  /*! ../evm */
  32),
      s = a(
  /*! assert */
  19),
      o = a(
  /*! rustbn.js */
  135);

  t.default = function (e) {
    s(e.data);
    var t = e.data,
        a = Math.floor(t.length / 192),
        i = new r(e._common.param("gasPrices", "ecPairing") + a * e._common.param("gasPrices", "ecPairingWord"));
    if (e.gasLimit.lt(i)) return n.OOGResult(e.gasLimit);
    var c = o.pairing(t);
    return 32 !== c.length ? n.OOGResult(e.gasLimit) : {
      gasUsed: i,
      returnValue: c
    };
  };
},
/*!******************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-vm/dist/evm/precompiles/09-blake2f.js ***!
  \******************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = a(
    /*! bn.js */
    5),
        n = a(
    /*! ../evm */
    32),
        s = a(
    /*! ../../exceptions */
    66),
        o = a(
    /*! assert */
    19);

    function i(e, t, a) {
      var r = e[t] + e[a],
          n = e[t + 1] + e[a + 1];
      r >= 4294967296 && n++, e[t] = r, e[t + 1] = n;
    }

    function c(e, t, a, r) {
      var n = e[t] + a;
      a < 0 && (n += 4294967296);
      var s = e[t + 1] + r;
      n >= 4294967296 && s++, e[t] = n, e[t + 1] = s;
    }

    function u(e, t) {
      return e[t] ^ e[t + 1] << 8 ^ e[t + 2] << 16 ^ e[t + 3] << 24;
    }

    function d(e, t, a, r, n, s, o, u) {
      var d = t[o],
          f = t[o + 1],
          l = t[u],
          h = t[u + 1];
      i(e, a, r), c(e, a, d, f);
      var p = e[s] ^ e[a],
          b = e[s + 1] ^ e[a + 1];
      e[s] = b, e[s + 1] = p, i(e, n, s), p = e[r] ^ e[n], b = e[r + 1] ^ e[n + 1], e[r] = p >>> 24 ^ b << 8, e[r + 1] = b >>> 24 ^ p << 8, i(e, a, r), c(e, a, l, h), p = e[s] ^ e[a], b = e[s + 1] ^ e[a + 1], e[s] = p >>> 16 ^ b << 16, e[s + 1] = b >>> 16 ^ p << 16, i(e, n, s), p = e[r] ^ e[n], b = e[r + 1] ^ e[n + 1], e[r] = b >>> 31 ^ p << 1, e[r + 1] = p >>> 31 ^ b << 1;
    }

    var f = new Uint32Array([4089235720, 1779033703, 2227873595, 3144134277, 4271175723, 1013904242, 1595750129, 2773480762, 2917565137, 1359893119, 725511199, 2600822924, 4215389547, 528734635, 327033209, 1541459225]),
        l = new Uint8Array([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 14, 10, 4, 8, 9, 15, 13, 6, 1, 12, 0, 2, 11, 7, 5, 3, 11, 8, 12, 0, 5, 2, 15, 13, 10, 14, 3, 6, 7, 1, 9, 4, 7, 9, 3, 1, 13, 12, 11, 14, 2, 6, 5, 10, 4, 0, 15, 8, 9, 0, 5, 7, 2, 4, 10, 15, 14, 1, 11, 12, 6, 8, 3, 13, 2, 12, 6, 10, 0, 11, 8, 3, 4, 13, 7, 5, 15, 14, 1, 9, 12, 5, 1, 15, 14, 13, 4, 10, 0, 7, 6, 3, 9, 2, 8, 11, 13, 11, 7, 14, 12, 1, 3, 9, 5, 0, 15, 4, 8, 6, 2, 10, 6, 15, 14, 9, 11, 3, 0, 8, 12, 2, 13, 7, 1, 4, 10, 5, 10, 2, 8, 4, 7, 6, 1, 5, 15, 11, 9, 14, 3, 12, 13, 0, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 14, 10, 4, 8, 9, 15, 13, 6, 1, 12, 0, 2, 11, 7, 5, 3].map(function (e) {
      return 2 * e;
    }));

    function h(e, t, a, r, n) {
      var s = new Uint32Array(32),
          o = 0;

      for (o = 0; o < 16; o++) {
        s[o] = e[o], s[o + 16] = f[o];
      }

      s[24] = s[24] ^ a[0], s[25] = s[25] ^ a[1], s[26] = s[26] ^ a[2], s[27] = s[27] ^ a[3], r && (s[28] = ~s[28], s[29] = ~s[29]);
      var i = new Uint32Array(32);

      for (o = 0; o < 32; o++) {
        i[o] = u(t, 4 * o);
      }

      for (o = 0; o < n; o++) {
        var c = o % 10 * 16;
        d(s, i, 0, 8, 16, 24, l[c + 0], l[c + 1]), d(s, i, 2, 10, 18, 26, l[c + 2], l[c + 3]), d(s, i, 4, 12, 20, 28, l[c + 4], l[c + 5]), d(s, i, 6, 14, 22, 30, l[c + 6], l[c + 7]), d(s, i, 0, 10, 20, 30, l[c + 8], l[c + 9]), d(s, i, 2, 12, 22, 24, l[c + 10], l[c + 11]), d(s, i, 4, 14, 16, 26, l[c + 12], l[c + 13]), d(s, i, 6, 8, 18, 28, l[c + 14], l[c + 15]);
      }

      for (o = 0; o < 16; o++) {
        e[o] = e[o] ^ s[o] ^ s[o + 16];
      }
    }

    t.F = h, t.default = function (t) {
      o(t.data);
      var a = t.data;
      if (213 !== a.length) return {
        returnValue: e.alloc(0),
        gasUsed: t.gasLimit,
        exceptionError: new s.VmError(s.ERROR.OUT_OF_RANGE)
      };
      var i = a.slice(212, 213)[0];
      if (1 !== i && 0 !== i) return {
        returnValue: e.alloc(0),
        gasUsed: t.gasLimit,
        exceptionError: new s.VmError(s.ERROR.OUT_OF_RANGE)
      };
      var c = a.slice(0, 4).readUInt32BE(0),
          u = a.slice(4, 68),
          d = a.slice(68, 196),
          f = a.slice(196, 212),
          l = 1 === i,
          p = new r(t._common.param("gasPrices", "blake2Round"));
      if (p.imuln(c), t.gasLimit.lt(p)) return n.OOGResult(t.gasLimit);

      for (var b = new Uint32Array(16), m = 0; m < 16; m++) {
        b[m] = u.readUInt32LE(4 * m);
      }

      var y = new Uint32Array(32);

      for (m = 0; m < 32; m++) {
        y[m] = d.readUInt32LE(4 * m);
      }

      var v = new Uint32Array(4);

      for (m = 0; m < 4; m++) {
        v[m] = f.readUInt32LE(4 * m);
      }

      h(b, y, v, l, c);

      var _ = e.alloc(64);

      for (m = 0; m < 16; m++) {
        _.writeUInt32LE(b[m], 4 * m);
      }

      return {
        gasUsed: p,
        returnValue: _
      };
    };
  }).call(this, a(
  /*! ./../../../../../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!***********************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-vm/dist/evm/eei.js ***!
  \***********************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, a = 1, r = arguments.length; a < r; a++) {
          for (var n in t = arguments[a]) {
            Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        n = this && this.__awaiter || function (e, t, a, r) {
      return new (a || (a = Promise))(function (n, s) {
        function o(e) {
          try {
            c(r.next(e));
          } catch (e) {
            s(e);
          }
        }

        function i(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            s(e);
          }
        }

        function c(e) {
          e.done ? n(e.value) : new a(function (t) {
            t(e.value);
          }).then(o, i);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        s = this && this.__generator || function (e, t) {
      var a,
          r,
          n,
          s,
          o = {
        label: 0,
        sent: function sent() {
          if (1 & n[0]) throw n[1];
          return n[1];
        },
        trys: [],
        ops: []
      };
      return s = {
        next: i(0),
        throw: i(1),
        return: i(2)
      }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
        return this;
      }), s;

      function i(s) {
        return function (i) {
          return function (s) {
            if (a) throw new TypeError("Generator is already executing.");

            for (; o;) {
              try {
                if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

                switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                  case 0:
                  case 1:
                    n = s;
                    break;

                  case 4:
                    return o.label++, {
                      value: s[1],
                      done: !1
                    };

                  case 5:
                    o.label++, r = s[1], s = [0];
                    continue;

                  case 7:
                    s = o.ops.pop(), o.trys.pop();
                    continue;

                  default:
                    if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                      o = 0;
                      continue;
                    }

                    if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                      o.label = s[1];
                      break;
                    }

                    if (6 === s[0] && o.label < n[1]) {
                      o.label = n[1], n = s;
                      break;
                    }

                    if (n && o.label < n[2]) {
                      o.label = n[2], o.ops.push(s);
                      break;
                    }

                    n[2] && o.ops.pop(), o.trys.pop();
                    continue;
                }

                s = t.call(e, o);
              } catch (e) {
                s = [6, e], r = 0;
              } finally {
                a = n = 0;
              }
            }

            if (5 & s[0]) throw s[1];
            return {
              value: s[0] ? s[1] : void 0,
              done: !0
            };
          }([s, i]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var o = a(
    /*! bn.js */
    5),
        i = a(
    /*! ethereumjs-util */
    29),
        c = a(
    /*! ../exceptions */
    66),
        u = a(
    /*! ./message */
    87),
        d = a(
    /*! util.promisify */
    88),
        f = function () {
      function t(t, a, r, n, s) {
        this._env = t, this._state = a, this._evm = r, this._lastReturned = e.alloc(0), this._common = n, this._gasLeft = s, this._result = {
          logs: [],
          returnValue: void 0,
          gasRefund: new o(0),
          selfdestruct: {}
        };
      }

      return t.prototype.useGas = function (e) {
        this._gasLeft.isub(e), this._gasLeft.ltn(0) && (this._gasLeft = new o(0), l(c.ERROR.OUT_OF_GAS));
      }, t.prototype.refundGas = function (e) {
        this._result.gasRefund.iadd(e);
      }, t.prototype.subRefund = function (e) {
        this._result.gasRefund.isub(e), this._result.gasRefund.ltn(0) && (this._result.gasRefund = new o(0), l(c.ERROR.REFUND_EXHAUSTED));
      }, t.prototype.getAddress = function () {
        return this._env.address;
      }, t.prototype.getExternalBalance = function (e) {
        return n(this, void 0, void 0, function () {
          var t;
          return s(this, function (a) {
            switch (a.label) {
              case 0:
                return e.toString("hex") === this._env.address.toString("hex") ? [2, new o(this._env.contract.balance)] : [4, this._state.getAccount(e)];

              case 1:
                return t = a.sent(), [2, new o(t.balance)];
            }
          });
        });
      }, t.prototype.getSelfBalance = function () {
        return new o(this._env.contract.balance);
      }, t.prototype.getCaller = function () {
        return new o(this._env.caller);
      }, t.prototype.getCallValue = function () {
        return new o(this._env.callValue);
      }, t.prototype.getCallData = function () {
        return this._env.callData;
      }, t.prototype.getCallDataSize = function () {
        return 1 === this._env.callData.length && 0 === this._env.callData[0] ? new o(0) : new o(this._env.callData.length);
      }, t.prototype.getCodeSize = function () {
        return new o(this._env.code.length);
      }, t.prototype.getCode = function () {
        return this._env.code;
      }, t.prototype.isStatic = function () {
        return this._env.isStatic;
      }, t.prototype.getExternalCodeSize = function (e) {
        return n(this, void 0, void 0, function () {
          var t, a;
          return s(this, function (r) {
            switch (r.label) {
              case 0:
                return t = p(e), [4, this._state.getContractCode(t)];

              case 1:
                return a = r.sent(), [2, new o(a.length)];
            }
          });
        });
      }, t.prototype.getExternalCode = function (t) {
        return n(this, void 0, void 0, function () {
          return s(this, function (a) {
            return e.isBuffer(t) || (t = p(t)), [2, this._state.getContractCode(t)];
          });
        });
      }, t.prototype.getReturnDataSize = function () {
        return new o(this._lastReturned.length);
      }, t.prototype.getReturnData = function () {
        return this._lastReturned;
      }, t.prototype.getTxGasPrice = function () {
        return new o(this._env.gasPrice);
      }, t.prototype.getTxOrigin = function () {
        return new o(this._env.origin);
      }, t.prototype.getBlockNumber = function () {
        return new o(this._env.block.header.number);
      }, t.prototype.getBlockCoinbase = function () {
        return new o(this._env.block.header.coinbase);
      }, t.prototype.getBlockTimestamp = function () {
        return new o(this._env.block.header.timestamp);
      }, t.prototype.getBlockDifficulty = function () {
        return new o(this._env.block.header.difficulty);
      }, t.prototype.getBlockGasLimit = function () {
        return new o(this._env.block.header.gasLimit);
      }, t.prototype.getChainId = function () {
        return new o(this._common.chainId());
      }, t.prototype.getBlockHash = function (e) {
        return n(this, void 0, void 0, function () {
          var t;
          return s(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, d(this._env.blockchain.getBlock).bind(this._env.blockchain)(e)];

              case 1:
                return t = a.sent(), [2, new o(t.hash())];
            }
          });
        });
      }, t.prototype.storageStore = function (e, t) {
        return n(this, void 0, void 0, function () {
          var a;
          return s(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this._state.putContractStorage(this._env.address, e, t)];

              case 1:
                return r.sent(), [4, this._state.getAccount(this._env.address)];

              case 2:
                return a = r.sent(), this._env.contract = a, [2];
            }
          });
        });
      }, t.prototype.storageLoad = function (e) {
        return n(this, void 0, void 0, function () {
          return s(this, function (t) {
            return [2, this._state.getContractStorage(this._env.address, e)];
          });
        });
      }, t.prototype.getGasLeft = function () {
        return this._gasLeft.clone();
      }, t.prototype.finish = function (e) {
        this._result.returnValue = e, l(c.ERROR.STOP);
      }, t.prototype.revert = function (e) {
        this._result.returnValue = e, l(c.ERROR.REVERT);
      }, t.prototype.selfDestruct = function (e) {
        return n(this, void 0, void 0, function () {
          return s(this, function (t) {
            return [2, this._selfDestruct(e)];
          });
        });
      }, t.prototype._selfDestruct = function (e) {
        return n(this, void 0, void 0, function () {
          var t, a, r;
          return s(this, function (n) {
            switch (n.label) {
              case 0:
                return this._result.selfdestruct[this._env.address.toString("hex")] || (this._result.gasRefund = this._result.gasRefund.addn(this._common.param("gasPrices", "selfdestructRefund"))), this._result.selfdestruct[this._env.address.toString("hex")] = e, [4, this._state.getAccount(e)];

              case 1:
                return t = n.sent(), a = new o(this._env.contract.balance).add(new o(t.balance)), t.balance = i.toBuffer(a), [4, this._state.putAccount(e, t)];

              case 2:
                return n.sent(), [4, this._state.getAccount(this._env.address)];

              case 3:
                return (r = n.sent()).balance = i.toBuffer(new o(0)), [4, this._state.putAccount(this._env.address, r)];

              case 4:
                return n.sent(), l(c.ERROR.STOP), [2];
            }
          });
        });
      }, t.prototype.log = function (e, t, a) {
        (t < 0 || t > 4) && l(c.ERROR.OUT_OF_RANGE), a.length !== t && l(c.ERROR.INTERNAL_ERROR);
        var r = [this._env.address];
        r.push(a), r.push(e), this._result.logs.push(r);
      }, t.prototype.call = function (e, t, a, r) {
        return n(this, void 0, void 0, function () {
          var n;
          return s(this, function (s) {
            return n = new u.default({
              caller: this._env.address,
              gasLimit: e,
              to: t,
              value: a,
              data: r,
              isStatic: this._env.isStatic,
              depth: this._env.depth + 1
            }), [2, this._baseCall(n)];
          });
        });
      }, t.prototype.callCode = function (e, t, a, r) {
        return n(this, void 0, void 0, function () {
          var n;
          return s(this, function (s) {
            return n = new u.default({
              caller: this._env.address,
              gasLimit: e,
              to: this._env.address,
              codeAddress: t,
              value: a,
              data: r,
              isStatic: this._env.isStatic,
              depth: this._env.depth + 1
            }), [2, this._baseCall(n)];
          });
        });
      }, t.prototype.callStatic = function (e, t, a, r) {
        return n(this, void 0, void 0, function () {
          var n;
          return s(this, function (s) {
            return n = new u.default({
              caller: this._env.address,
              gasLimit: e,
              to: t,
              value: a,
              data: r,
              isStatic: !0,
              depth: this._env.depth + 1
            }), [2, this._baseCall(n)];
          });
        });
      }, t.prototype.callDelegate = function (e, t, a, r) {
        return n(this, void 0, void 0, function () {
          var n;
          return s(this, function (s) {
            return n = new u.default({
              caller: this._env.caller,
              gasLimit: e,
              to: this._env.address,
              codeAddress: t,
              value: a,
              data: r,
              isStatic: this._env.isStatic,
              delegatecall: !0,
              depth: this._env.depth + 1
            }), [2, this._baseCall(n)];
          });
        });
      }, t.prototype._baseCall = function (t) {
        return n(this, void 0, void 0, function () {
          var a, n, i;
          return s(this, function (s) {
            switch (s.label) {
              case 0:
                return a = r({}, this._result.selfdestruct), t.selfdestruct = a, this._lastReturned = e.alloc(0), this._env.depth >= this._common.param("vm", "stackLimit") || !0 !== t.delegatecall && new o(this._env.contract.balance).lt(t.value) ? [2, new o(0)] : [4, this._evm.executeMessage(t)];

              case 1:
                return (n = s.sent()).execResult.logs && (this._result.logs = this._result.logs.concat(n.execResult.logs)), n.execResult.gasRefund && (this._result.gasRefund = this._result.gasRefund.add(n.execResult.gasRefund)), this.useGas(n.gasUsed), !n.execResult.returnValue || n.execResult.exceptionError && n.execResult.exceptionError.error !== c.ERROR.REVERT || (this._lastReturned = n.execResult.returnValue), n.execResult.exceptionError ? [3, 3] : (Object.assign(this._result.selfdestruct, a), [4, this._state.getAccount(this._env.address)]);

              case 2:
                i = s.sent(), this._env.contract = i, s.label = 3;

              case 3:
                return [2, this._getReturnCode(n)];
            }
          });
        });
      }, t.prototype.create = function (t, a, d, f) {
        return void 0 === f && (f = null), n(this, void 0, void 0, function () {
          var n, l, h, p;
          return s(this, function (s) {
            switch (s.label) {
              case 0:
                return n = r({}, this._result.selfdestruct), l = new u.default({
                  caller: this._env.address,
                  gasLimit: t,
                  value: a,
                  data: d,
                  salt: f,
                  depth: this._env.depth + 1,
                  selfdestruct: n
                }), this._lastReturned = e.alloc(0), this._env.depth >= this._common.param("vm", "stackLimit") || !0 !== l.delegatecall && new o(this._env.contract.balance).lt(l.value) ? [2, new o(0)] : (this._env.contract.nonce = i.toBuffer(new o(this._env.contract.nonce).addn(1)), [4, this._state.putAccount(this._env.address, this._env.contract)]);

              case 1:
                return s.sent(), [4, this._evm.executeMessage(l)];

              case 2:
                return (h = s.sent()).execResult.logs && (this._result.logs = this._result.logs.concat(h.execResult.logs)), h.execResult.gasRefund && (this._result.gasRefund = this._result.gasRefund.add(h.execResult.gasRefund)), this.useGas(h.gasUsed), h.execResult.exceptionError && h.execResult.exceptionError.error === c.ERROR.REVERT && (this._lastReturned = h.execResult.returnValue), h.execResult.exceptionError ? [3, 4] : (Object.assign(this._result.selfdestruct, n), [4, this._state.getAccount(this._env.address)]);

              case 3:
                if (p = s.sent(), this._env.contract = p, h.createdAddress) return [2, new o(h.createdAddress)];
                s.label = 4;

              case 4:
                return [2, this._getReturnCode(h)];
            }
          });
        });
      }, t.prototype.create2 = function (e, t, a, r) {
        return n(this, void 0, void 0, function () {
          return s(this, function (n) {
            return [2, this.create(e, t, a, r)];
          });
        });
      }, t.prototype.isAccountEmpty = function (e) {
        return n(this, void 0, void 0, function () {
          return s(this, function (t) {
            return [2, this._state.accountIsEmpty(e)];
          });
        });
      }, t.prototype._getReturnCode = function (e) {
        return e.execResult.exceptionError ? new o(0) : new o(1);
      }, t;
    }();

    function l(e) {
      throw new c.VmError(e);
    }

    t.default = f;
    var h = new o(1).shln(160).subn(1);

    function p(t) {
      return e.isBuffer(t) ? t : t.and(h).toArrayLike(e, "be", 20);
    }
  }).call(this, a(
  /*! ./../../../../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!*******************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-vm/dist/evm/interpreter.js ***!
  \*******************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    var r = this && this.__assign || function () {
      return (r = Object.assign || function (e) {
        for (var t, a = 1, r = arguments.length; a < r; a++) {
          for (var n in t = arguments[a]) {
            Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        n = this && this.__awaiter || function (e, t, a, r) {
      return new (a || (a = Promise))(function (n, s) {
        function o(e) {
          try {
            c(r.next(e));
          } catch (e) {
            s(e);
          }
        }

        function i(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            s(e);
          }
        }

        function c(e) {
          e.done ? n(e.value) : new a(function (t) {
            t(e.value);
          }).then(o, i);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        s = this && this.__generator || function (e, t) {
      var a,
          r,
          n,
          s,
          o = {
        label: 0,
        sent: function sent() {
          if (1 & n[0]) throw n[1];
          return n[1];
        },
        trys: [],
        ops: []
      };
      return s = {
        next: i(0),
        throw: i(1),
        return: i(2)
      }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
        return this;
      }), s;

      function i(s) {
        return function (i) {
          return function (s) {
            if (a) throw new TypeError("Generator is already executing.");

            for (; o;) {
              try {
                if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

                switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                  case 0:
                  case 1:
                    n = s;
                    break;

                  case 4:
                    return o.label++, {
                      value: s[1],
                      done: !1
                    };

                  case 5:
                    o.label++, r = s[1], s = [0];
                    continue;

                  case 7:
                    s = o.ops.pop(), o.trys.pop();
                    continue;

                  default:
                    if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                      o = 0;
                      continue;
                    }

                    if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                      o.label = s[1];
                      break;
                    }

                    if (6 === s[0] && o.label < n[1]) {
                      o.label = n[1], n = s;
                      break;
                    }

                    if (n && o.label < n[2]) {
                      o.label = n[2], o.ops.push(s);
                      break;
                    }

                    n[2] && o.ops.pop(), o.trys.pop();
                    continue;
                }

                s = t.call(e, o);
              } catch (e) {
                s = [6, e], r = 0;
              } finally {
                a = n = 0;
              }
            }

            if (5 & s[0]) throw s[1];
            return {
              value: s[0] ? s[1] : void 0,
              done: !0
            };
          }([s, i]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var o = a(
    /*! bn.js */
    5),
        i = a(
    /*! ../state/promisified */
    74),
        c = a(
    /*! ../exceptions */
    66),
        u = a(
    /*! ./memory */
    718),
        d = a(
    /*! ./stack */
    719),
        f = a(
    /*! ./opFns.js */
    720),
        l = function () {
      function t(t, a) {
        this._vm = t, this._state = new i.default(t.stateManager), this._eei = a, this._runState = {
          programCounter: 0,
          opCode: 254,
          memory: new u.default(),
          memoryWordCount: new o(0),
          highestMemCost: new o(0),
          stack: new d.default(),
          code: e.alloc(0),
          validJumps: [],
          _common: this._vm._common,
          stateManager: this._state._wrapped,
          eei: this._eei
        };
      }

      return t.prototype.run = function (e, t) {
        return void 0 === t && (t = {}), n(this, void 0, void 0, function () {
          var a, r, n, o;
          return s(this, function (s) {
            switch (s.label) {
              case 0:
                if (this._runState.code = e, this._runState.programCounter = t.pc || this._runState.programCounter, this._runState.validJumps = this._getValidJumpDests(e), 0 !== (a = this._runState.programCounter) && (a < 0 || a >= this._runState.code.length)) throw new Error("Internal error: program counter not in range");
                s.label = 1;

              case 1:
                return this._runState.programCounter < this._runState.code.length ? (n = this._runState.code[this._runState.programCounter], this._runState.opCode = n, [4, this._runStepHook()]) : [3, 7];

              case 2:
                s.sent(), s.label = 3;

              case 3:
                return s.trys.push([3, 5,, 6]), [4, this.runStep()];

              case 4:
                return s.sent(), [3, 6];

              case 5:
                return (o = s.sent()).error !== c.ERROR.STOP && (r = o), [3, 7];

              case 6:
                return [3, 1];

              case 7:
                return [2, {
                  runState: this._runState,
                  exceptionError: r
                }];
            }
          });
        });
      }, t.prototype.runStep = function () {
        return n(this, void 0, void 0, function () {
          var e, t;
          return s(this, function (a) {
            switch (a.label) {
              case 0:
                if ("INVALID" === (e = this.lookupOpInfo(this._runState.opCode)).name) throw new c.VmError(c.ERROR.INVALID_OPCODE);
                return this._eei.useGas(new o(e.fee)), this._runState.programCounter++, t = this.getOpHandler(e), e.isAsync ? [4, t.apply(null, [this._runState])] : [3, 2];

              case 1:
                return a.sent(), [3, 3];

              case 2:
                t.apply(null, [this._runState]), a.label = 3;

              case 3:
                return [2];
            }
          });
        });
      }, t.prototype.getOpHandler = function (e) {
        return f.handlers[e.name];
      }, t.prototype.lookupOpInfo = function (e, t) {
        void 0 === t && (t = !1);
        var a = this._vm._opcodes[e] ? this._vm._opcodes[e] : {
          name: "INVALID",
          fee: 0,
          isAsync: !1
        };

        if (t) {
          var n = a.name;
          return "LOG" === n && (n += e - 160), "PUSH" === n && (n += e - 95), "DUP" === n && (n += e - 127), "SWAP" === n && (n += e - 143), r({}, a, {
            name: n
          });
        }

        return a;
      }, t.prototype._runStepHook = function () {
        return n(this, void 0, void 0, function () {
          var e;
          return s(this, function (t) {
            return e = {
              pc: this._runState.programCounter,
              gasLeft: this._eei.getGasLeft(),
              opcode: this.lookupOpInfo(this._runState.opCode, !0),
              stack: this._runState.stack._store,
              depth: this._eei._env.depth,
              address: this._eei._env.address,
              account: this._eei._env.contract,
              stateManager: this._runState.stateManager,
              memory: this._runState.memory._store,
              memoryWordCount: this._runState.memoryWordCount
            }, [2, this._vm._emit("step", e)];
          });
        });
      }, t.prototype._getValidJumpDests = function (e) {
        for (var t = [], a = 0; a < e.length; a++) {
          var r = this.lookupOpInfo(e[a]).name;
          "PUSH" === r && (a += e[a] - 95), "JUMPDEST" === r && t.push(a);
        }

        return t;
      }, t;
    }();

    t.default = l;
  }).call(this, a(
  /*! ./../../../../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!**************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-vm/dist/evm/memory.js ***!
  \**************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = a(
    /*! assert */
    19),
        n = function () {
      function t() {
        this._store = [];
      }

      return t.prototype.extend = function (e, t) {
        if (0 !== t) {
          var a = s(e + t, 32) - this._store.length;

          a > 0 && (this._store = this._store.concat(new Array(a).fill(0)));
        }
      }, t.prototype.write = function (t, a, n) {
        if (0 !== a) {
          r(n.length === a, "Invalid value size"), r(t + a <= this._store.length, "Value exceeds memory capacity"), r(e.isBuffer(n), "Invalid value type");

          for (var s = 0; s < a; s++) {
            this._store[t + s] = n[s];
          }
        }
      }, t.prototype.read = function (t, a) {
        for (var r = this._store.slice(t, t + a), n = r.length; n < a; n++) {
          r[n] = 0;
        }

        return e.from(r);
      }, t;
    }();

    t.default = n;

    var s = function s(e, t) {
      var a = e % t;
      return 0 === a ? e : e + t - a;
    };
  }).call(this, a(
  /*! ./../../../../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!*************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-vm/dist/evm/stack.js ***!
  \*************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var r = a(
  /*! bn.js */
  5),
      n = a(
  /*! ethereumjs-util */
  29),
      s = a(
  /*! ../exceptions */
  66),
      o = s.ERROR,
      i = s.VmError,
      c = function () {
    function e() {
      this._store = [];
    }

    return Object.defineProperty(e.prototype, "length", {
      get: function get() {
        return this._store.length;
      },
      enumerable: !0,
      configurable: !0
    }), e.prototype.push = function (e) {
      if (!r.isBN(e)) throw new i(o.INTERNAL_ERROR);
      if (e.gt(n.MAX_INTEGER)) throw new i(o.OUT_OF_RANGE);
      if (this._store.length > 1023) throw new i(o.STACK_OVERFLOW);

      this._store.push(e);
    }, e.prototype.pop = function () {
      if (this._store.length < 1) throw new i(o.STACK_UNDERFLOW);
      return this._store.pop();
    }, e.prototype.popN = function (e) {
      if (void 0 === e && (e = 1), this._store.length < e) throw new i(o.STACK_UNDERFLOW);
      return 0 === e ? [] : this._store.splice(-1 * e).reverse();
    }, e.prototype.swap = function (e) {
      if (this._store.length <= e) throw new i(o.STACK_UNDERFLOW);
      var t = this._store.length - 1,
          a = this._store.length - e - 1,
          r = this._store[t];
      this._store[t] = this._store[a], this._store[a] = r;
    }, e.prototype.dup = function (e) {
      if (this._store.length < e) throw new i(o.STACK_UNDERFLOW);
      var t = this._store.length - e;
      this.push(this._store[t]);
    }, e;
  }();

  t.default = c;
},
/*!*************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-vm/dist/evm/opFns.js ***!
  \*************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    var r = this && this.__awaiter || function (e, t, a, r) {
      return new (a || (a = Promise))(function (n, s) {
        function o(e) {
          try {
            c(r.next(e));
          } catch (e) {
            s(e);
          }
        }

        function i(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            s(e);
          }
        }

        function c(e) {
          e.done ? n(e.value) : new a(function (t) {
            t(e.value);
          }).then(o, i);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        n = this && this.__generator || function (e, t) {
      var a,
          r,
          n,
          s,
          o = {
        label: 0,
        sent: function sent() {
          if (1 & n[0]) throw n[1];
          return n[1];
        },
        trys: [],
        ops: []
      };
      return s = {
        next: i(0),
        throw: i(1),
        return: i(2)
      }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
        return this;
      }), s;

      function i(s) {
        return function (i) {
          return function (s) {
            if (a) throw new TypeError("Generator is already executing.");

            for (; o;) {
              try {
                if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

                switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                  case 0:
                  case 1:
                    n = s;
                    break;

                  case 4:
                    return o.label++, {
                      value: s[1],
                      done: !1
                    };

                  case 5:
                    o.label++, r = s[1], s = [0];
                    continue;

                  case 7:
                    s = o.ops.pop(), o.trys.pop();
                    continue;

                  default:
                    if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                      o = 0;
                      continue;
                    }

                    if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                      o.label = s[1];
                      break;
                    }

                    if (6 === s[0] && o.label < n[1]) {
                      o.label = n[1], n = s;
                      break;
                    }

                    if (n && o.label < n[2]) {
                      o.label = n[2], o.ops.push(s);
                      break;
                    }

                    n[2] && o.ops.pop(), o.trys.pop();
                    continue;
                }

                s = t.call(e, o);
              } catch (e) {
                s = [6, e], r = 0;
              } finally {
                a = n = 0;
              }
            }

            if (5 & s[0]) throw s[1];
            return {
              value: s[0] ? s[1] : void 0,
              done: !0
            };
          }([s, i]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(
    /*! bn.js */
    5),
        o = a(
    /*! ethereumjs-util */
    29),
        i = a(
    /*! ../exceptions */
    66),
        c = new s(1).shln(160).subn(1);

    function u(e, t) {
      var a = e.div(t);
      return e.mod(t).isZero() ? a : a.isNeg() ? a.isubn(1) : a.iaddn(1);
    }

    function d(t) {
      return t.and(c).toArrayLike(e, "be", 20);
    }

    function f(e) {
      return o.keccak256(e.eei.getCode()).toString("hex") + "/" + e.eei.getAddress().toString("hex") + ":" + (e.programCounter - 1);
    }

    function l(e) {
      throw new i.VmError(e);
    }

    function h(e, t, a) {
      if (!a.isZero()) {
        var r = u(t.add(a), new s(32));

        if (!r.lte(e.memoryWordCount)) {
          var n = r,
              o = new s(e._common.param("gasPrices", "memory")),
              i = new s(e._common.param("gasPrices", "quadCoeffDiv")),
              c = n.mul(o).add(n.mul(n).div(i));
          c.gt(e.highestMemCost) && (e.eei.useGas(c.sub(e.highestMemCost)), e.highestMemCost = c), e.memoryWordCount = r;
        }
      }
    }

    function p(e, t, a) {
      var r = new s(e.length);
      t.gt(r) && (t = r);
      var n = t.add(a);
      return n.gt(r) && (n = r), e = e.slice(t.toNumber(), n.toNumber()), e = o.setLengthRight(e, a.toNumber());
    }

    function b(e, t) {
      return -1 !== e.validJumps.indexOf(t);
    }

    function m(e, t) {
      var a = t.sub(t.divn(64));
      return e.gt(a) ? a : e;
    }

    function y(e, t, a) {
      return new Promise(function (r, n) {
        var s = function s(e, t) {
          if (e) return n(e);
          r(t);
        };

        e.stateManager.getContractStorage(t, a, function (r, n) {
          if (r) return s(r, null);
          "constantinople" === e._common.hardfork() || e._common.gteHardfork("istanbul") ? e.stateManager.getOriginalContractStorage(t, a, function (e, t) {
            if (e) return s(e, null);
            s(null, {
              current: n,
              original: t
            });
          }) : s(null, n);
        });
      });
    }

    function v(e, t, a) {
      var r = e.eei.getReturnData();

      if (r.length > 0) {
        var n = t.toNumber(),
            o = a.toNumber();
        r.length < o && (o = r.length);
        var i = p(r, new s(0), new s(o));
        e.memory.extend(n, o), e.memory.write(n, o, i);
      }
    }

    t.handlers = {
      STOP: function STOP(e) {
        l(i.ERROR.STOP);
      },
      ADD: function ADD(e) {
        var t = e.stack.popN(2),
            a = t[0],
            r = t[1],
            n = a.add(r).mod(o.TWO_POW256);
        e.stack.push(n);
      },
      MUL: function MUL(e) {
        var t = e.stack.popN(2),
            a = t[0],
            r = t[1],
            n = a.mul(r).mod(o.TWO_POW256);
        e.stack.push(n);
      },
      SUB: function SUB(e) {
        var t = e.stack.popN(2),
            a = t[0],
            r = t[1],
            n = a.sub(r).toTwos(256);
        e.stack.push(n);
      },
      DIV: function DIV(e) {
        var t,
            a = e.stack.popN(2),
            r = a[0],
            n = a[1];
        t = n.isZero() ? new s(n) : r.div(n), e.stack.push(t);
      },
      SDIV: function SDIV(e) {
        var t,
            a = e.stack.popN(2),
            r = a[0],
            n = a[1];
        n.isZero() ? t = new s(n) : (r = r.fromTwos(256), n = n.fromTwos(256), t = r.div(n).toTwos(256)), e.stack.push(t);
      },
      MOD: function MOD(e) {
        var t,
            a = e.stack.popN(2),
            r = a[0],
            n = a[1];
        t = n.isZero() ? new s(n) : r.mod(n), e.stack.push(t);
      },
      SMOD: function SMOD(e) {
        var t,
            a = e.stack.popN(2),
            r = a[0],
            n = a[1];
        n.isZero() ? t = new s(n) : (r = r.fromTwos(256), n = n.fromTwos(256), t = r.abs().mod(n.abs()), r.isNeg() && (t = t.ineg()), t = t.toTwos(256)), e.stack.push(t);
      },
      ADDMOD: function ADDMOD(e) {
        var t,
            a = e.stack.popN(3),
            r = a[0],
            n = a[1],
            o = a[2];
        t = o.isZero() ? new s(o) : r.add(n).mod(o), e.stack.push(t);
      },
      MULMOD: function MULMOD(e) {
        var t,
            a = e.stack.popN(3),
            r = a[0],
            n = a[1],
            o = a[2];
        t = o.isZero() ? new s(o) : r.mul(n).mod(o), e.stack.push(t);
      },
      EXP: function EXP(e) {
        var t = e.stack.popN(2),
            a = t[0],
            r = t[1];
        if (r.isZero()) e.stack.push(new s(1));else {
          var n = r.byteLength();
          (n < 1 || n > 32) && l(i.ERROR.OUT_OF_RANGE);

          var c = e._common.param("gasPrices", "expByte"),
              u = new s(n).muln(c);

          if (e.eei.useGas(u), a.isZero()) e.stack.push(new s(0));else {
            var d = s.red(o.TWO_POW256),
                f = a.toRed(d).redPow(r);
            e.stack.push(f.fromRed());
          }
        }
      },
      SIGNEXTEND: function SIGNEXTEND(e) {
        var t = e.stack.popN(2),
            a = t[0],
            r = t[1];

        if (a.ltn(31)) {
          var n = a.muln(8).iaddn(7).toNumber(),
              o = new s(1).ishln(n).isubn(1);
          r = r.testn(n) ? r.or(o.notn(256)) : r.and(o);
        } else r = new s(r);

        e.stack.push(r);
      },
      LT: function LT(e) {
        var t = e.stack.popN(2),
            a = t[0],
            r = t[1],
            n = new s(a.lt(r) ? 1 : 0);
        e.stack.push(n);
      },
      GT: function GT(e) {
        var t = e.stack.popN(2),
            a = t[0],
            r = t[1],
            n = new s(a.gt(r) ? 1 : 0);
        e.stack.push(n);
      },
      SLT: function SLT(e) {
        var t = e.stack.popN(2),
            a = t[0],
            r = t[1],
            n = new s(a.fromTwos(256).lt(r.fromTwos(256)) ? 1 : 0);
        e.stack.push(n);
      },
      SGT: function SGT(e) {
        var t = e.stack.popN(2),
            a = t[0],
            r = t[1],
            n = new s(a.fromTwos(256).gt(r.fromTwos(256)) ? 1 : 0);
        e.stack.push(n);
      },
      EQ: function EQ(e) {
        var t = e.stack.popN(2),
            a = t[0],
            r = t[1],
            n = new s(a.eq(r) ? 1 : 0);
        e.stack.push(n);
      },
      ISZERO: function ISZERO(e) {
        var t = e.stack.pop(),
            a = new s(t.isZero() ? 1 : 0);
        e.stack.push(a);
      },
      AND: function AND(e) {
        var t = e.stack.popN(2),
            a = t[0],
            r = t[1],
            n = a.and(r);
        e.stack.push(n);
      },
      OR: function OR(e) {
        var t = e.stack.popN(2),
            a = t[0],
            r = t[1],
            n = a.or(r);
        e.stack.push(n);
      },
      XOR: function XOR(e) {
        var t = e.stack.popN(2),
            a = t[0],
            r = t[1],
            n = a.xor(r);
        e.stack.push(n);
      },
      NOT: function NOT(e) {
        var t = e.stack.pop().notn(256);
        e.stack.push(t);
      },
      BYTE: function BYTE(e) {
        var t = e.stack.popN(2),
            a = t[0],
            r = t[1];
        if (a.gten(32)) e.stack.push(new s(0));else {
          var n = new s(r.shrn(8 * (31 - a.toNumber())).andln(255));
          e.stack.push(n);
        }
      },
      SHL: function SHL(e) {
        var t = e.stack.popN(2),
            a = t[0],
            r = t[1];
        if (e._common.gteHardfork("constantinople") || l(i.ERROR.INVALID_OPCODE), a.gten(256)) e.stack.push(new s(0));else {
          var n = r.shln(a.toNumber()).iand(o.MAX_INTEGER);
          e.stack.push(n);
        }
      },
      SHR: function SHR(e) {
        var t = e.stack.popN(2),
            a = t[0],
            r = t[1];
        if (e._common.gteHardfork("constantinople") || l(i.ERROR.INVALID_OPCODE), a.gten(256)) e.stack.push(new s(0));else {
          var n = r.shrn(a.toNumber());
          e.stack.push(n);
        }
      },
      SAR: function SAR(e) {
        var t,
            a = e.stack.popN(2),
            r = a[0],
            n = a[1];
        e._common.gteHardfork("constantinople") || l(i.ERROR.INVALID_OPCODE);
        var c = n.testn(255);
        if (r.gten(256)) return t = new s(c ? o.MAX_INTEGER : 0), void e.stack.push(t);
        var u = n.shrn(r.toNumber());

        if (c) {
          var d = 255 - r.toNumber(),
              f = o.MAX_INTEGER.shrn(d).shln(d);
          t = u.ior(f);
        } else t = u;

        e.stack.push(t);
      },
      SHA3: function SHA3(t) {
        var a = t.stack.popN(2),
            r = a[0],
            n = a[1];
        h(t, r, n);
        var i = e.alloc(0);
        n.isZero() || (i = t.memory.read(r.toNumber(), n.toNumber())), t.eei.useGas(new s(t._common.param("gasPrices", "sha3Word")).imul(u(n, new s(32))));
        var c = new s(o.keccak256(i));
        t.stack.push(c);
      },
      ADDRESS: function ADDRESS(e) {
        e.stack.push(new s(e.eei.getAddress()));
      },
      BALANCE: function BALANCE(e) {
        return r(this, void 0, void 0, function () {
          var t, a, r;
          return n(this, function (n) {
            switch (n.label) {
              case 0:
                return t = e.stack.pop(), a = d(t), [4, e.eei.getExternalBalance(a)];

              case 1:
                return r = n.sent(), e.stack.push(r), [2];
            }
          });
        });
      },
      ORIGIN: function ORIGIN(e) {
        e.stack.push(e.eei.getTxOrigin());
      },
      CALLER: function CALLER(e) {
        e.stack.push(e.eei.getCaller());
      },
      CALLVALUE: function CALLVALUE(e) {
        e.stack.push(e.eei.getCallValue());
      },
      CALLDATALOAD: function CALLDATALOAD(t) {
        var a = t.stack.pop();
        if (a.gt(t.eei.getCallDataSize())) t.stack.push(new s(0));else {
          var r = a.toNumber(),
              n = t.eei.getCallData().slice(r, r + 32);
          n = n.length ? n : e.from([0]);
          var i = new s(o.setLengthRight(n, 32));
          t.stack.push(i);
        }
      },
      CALLDATASIZE: function CALLDATASIZE(e) {
        var t = e.eei.getCallDataSize();
        e.stack.push(t);
      },
      CALLDATACOPY: function CALLDATACOPY(e) {
        var t = e.stack.popN(3),
            a = t[0],
            r = t[1],
            n = t[2];
        h(e, a, n), e.eei.useGas(new s(e._common.param("gasPrices", "copy")).imul(u(n, new s(32))));
        var o = p(e.eei.getCallData(), r, n),
            i = a.toNumber(),
            c = n.toNumber();
        e.memory.extend(i, c), e.memory.write(i, c, o);
      },
      CODESIZE: function CODESIZE(e) {
        e.stack.push(e.eei.getCodeSize());
      },
      CODECOPY: function CODECOPY(e) {
        var t = e.stack.popN(3),
            a = t[0],
            r = t[1],
            n = t[2];
        h(e, a, n), e.eei.useGas(new s(e._common.param("gasPrices", "copy")).imul(u(n, new s(32))));
        var o = p(e.eei.getCode(), r, n),
            i = a.toNumber(),
            c = n.toNumber();
        e.memory.extend(i, c), e.memory.write(i, c, o);
      },
      EXTCODESIZE: function EXTCODESIZE(e) {
        return r(this, void 0, void 0, function () {
          var t, a;
          return n(this, function (r) {
            switch (r.label) {
              case 0:
                return t = e.stack.pop(), [4, e.eei.getExternalCodeSize(t)];

              case 1:
                return a = r.sent(), e.stack.push(a), [2];
            }
          });
        });
      },
      EXTCODECOPY: function EXTCODECOPY(e) {
        return r(this, void 0, void 0, function () {
          var t, a, r, o, i, c, d, f, l;
          return n(this, function (n) {
            switch (n.label) {
              case 0:
                return t = e.stack.popN(4), a = t[0], r = t[1], o = t[2], i = t[3], h(e, r, i), e.eei.useGas(new s(e._common.param("gasPrices", "copy")).imul(u(i, new s(32)))), [4, e.eei.getExternalCode(a)];

              case 1:
                return c = n.sent(), d = p(c, o, i), f = r.toNumber(), l = i.toNumber(), e.memory.extend(f, l), e.memory.write(f, l, d), [2];
            }
          });
        });
      },
      EXTCODEHASH: function EXTCODEHASH(e) {
        return r(this, void 0, void 0, function () {
          var t, a, r;
          return n(this, function (n) {
            switch (n.label) {
              case 0:
                return t = e.stack.pop(), e._common.gteHardfork("constantinople") || l(i.ERROR.INVALID_OPCODE), a = d(t), [4, e.eei.isAccountEmpty(a)];

              case 1:
                return n.sent() ? (e.stack.push(new s(0)), [2]) : [4, e.eei.getExternalCode(t)];

              case 2:
                return 0 === (r = n.sent()).length ? (e.stack.push(new s(o.KECCAK256_NULL)), [2]) : (e.stack.push(new s(o.keccak256(r))), [2]);
            }
          });
        });
      },
      RETURNDATASIZE: function RETURNDATASIZE(e) {
        e.stack.push(e.eei.getReturnDataSize());
      },
      RETURNDATACOPY: function RETURNDATACOPY(e) {
        var t = e.stack.popN(3),
            a = t[0],
            r = t[1],
            n = t[2];
        r.add(n).gt(e.eei.getReturnDataSize()) && l(i.ERROR.OUT_OF_GAS), h(e, a, n), e.eei.useGas(new s(e._common.param("gasPrices", "copy")).mul(u(n, new s(32))));
        var o = p(e.eei.getReturnData(), r, n),
            c = a.toNumber(),
            d = n.toNumber();
        e.memory.extend(c, d), e.memory.write(c, d, o);
      },
      GASPRICE: function GASPRICE(e) {
        e.stack.push(e.eei.getTxGasPrice());
      },
      BLOCKHASH: function BLOCKHASH(e) {
        return r(this, void 0, void 0, function () {
          var t, a, r;
          return n(this, function (n) {
            switch (n.label) {
              case 0:
                return t = e.stack.pop(), (a = e.eei.getBlockNumber().sub(t)).gtn(256) || a.lten(0) ? (e.stack.push(new s(0)), [2]) : [4, e.eei.getBlockHash(t)];

              case 1:
                return r = n.sent(), e.stack.push(r), [2];
            }
          });
        });
      },
      COINBASE: function COINBASE(e) {
        e.stack.push(e.eei.getBlockCoinbase());
      },
      TIMESTAMP: function TIMESTAMP(e) {
        e.stack.push(e.eei.getBlockTimestamp());
      },
      NUMBER: function NUMBER(e) {
        e.stack.push(e.eei.getBlockNumber());
      },
      DIFFICULTY: function DIFFICULTY(e) {
        e.stack.push(e.eei.getBlockDifficulty());
      },
      GASLIMIT: function GASLIMIT(e) {
        e.stack.push(e.eei.getBlockGasLimit());
      },
      CHAINID: function CHAINID(e) {
        e._common.gteHardfork("istanbul") || l(i.ERROR.INVALID_OPCODE), e.stack.push(e.eei.getChainId());
      },
      SELFBALANCE: function SELFBALANCE(e) {
        e._common.gteHardfork("istanbul") || l(i.ERROR.INVALID_OPCODE), e.stack.push(e.eei.getSelfBalance());
      },
      POP: function POP(e) {
        e.stack.pop();
      },
      MLOAD: function MLOAD(e) {
        var t = e.stack.pop();
        h(e, t, new s(32));
        var a = e.memory.read(t.toNumber(), 32);
        e.stack.push(new s(a));
      },
      MSTORE: function MSTORE(t) {
        var a = t.stack.popN(2),
            r = a[0],
            n = a[1].toArrayLike(e, "be", 32);
        h(t, r, new s(32));
        var o = r.toNumber();
        t.memory.extend(o, 32), t.memory.write(o, 32, n);
      },
      MSTORE8: function MSTORE8(t) {
        var a = t.stack.popN(2),
            r = a[0],
            n = a[1],
            o = e.from([n.andln(255)]);
        h(t, r, new s(1));
        var i = r.toNumber();
        t.memory.extend(i, 1), t.memory.write(i, 1, o);
      },
      SLOAD: function SLOAD(t) {
        return r(this, void 0, void 0, function () {
          var a, r, o, i;
          return n(this, function (n) {
            switch (n.label) {
              case 0:
                return a = t.stack.pop(), r = a.toArrayLike(e, "be", 32), [4, t.eei.storageLoad(r)];

              case 1:
                return o = n.sent(), i = o.length ? new s(o) : new s(0), t.stack.push(i), [2];
            }
          });
        });
      },
      SSTORE: function SSTORE(t) {
        return r(this, void 0, void 0, function () {
          var a, r, o, c, u, d;
          return n(this, function (n) {
            switch (n.label) {
              case 0:
                return t.eei.isStatic() && l(i.ERROR.STATIC_STATE_CHANGE), a = t.stack.popN(2), r = a[0], o = a[1], c = r.toArrayLike(e, "be", 32), u = o.isZero() ? e.from([]) : o.toArrayLike(e, "be"), [4, y(t, t.eei.getAddress(), c)];

              case 1:
                return d = n.sent(), function (e, t, a) {
                  if ("constantinople" === e._common.hardfork()) {
                    var r = t.original,
                        n = t.current;
                    return n.equals(a) ? void e.eei.useGas(new s(e._common.param("gasPrices", "netSstoreNoopGas"))) : r.equals(n) ? 0 === r.length ? e.eei.useGas(new s(e._common.param("gasPrices", "netSstoreInitGas"))) : (0 === a.length && e.eei.refundGas(new s(e._common.param("gasPrices", "netSstoreClearRefund"))), e.eei.useGas(new s(e._common.param("gasPrices", "netSstoreCleanGas")))) : (0 !== r.length && (0 === n.length ? e.eei._result.gasRefund.isub(new s(e._common.param("gasPrices", "netSstoreClearRefund"))) : 0 === a.length && e.eei.refundGas(new s(e._common.param("gasPrices", "netSstoreClearRefund")))), r.equals(a) && (0 === r.length ? e.eei.refundGas(new s(e._common.param("gasPrices", "netSstoreResetClearRefund"))) : e.eei.refundGas(new s(e._common.param("gasPrices", "netSstoreResetRefund")))), e.eei.useGas(new s(e._common.param("gasPrices", "netSstoreDirtyGas"))));
                  }

                  if (e._common.gteHardfork("istanbul")) {
                    var o = t.original,
                        c = t.current;
                    return e.eei.getGasLeft().lten(e._common.param("gasPrices", "sstoreSentryGasEIP2200")) && l(i.ERROR.OUT_OF_GAS), c.equals(a) ? e.eei.useGas(new s(e._common.param("gasPrices", "sstoreNoopGasEIP2200"))) : o.equals(c) ? 0 === o.length ? e.eei.useGas(new s(e._common.param("gasPrices", "sstoreInitGasEIP2200"))) : (0 === a.length && e.eei.refundGas(new s(e._common.param("gasPrices", "sstoreClearRefundEIP2200"))), e.eei.useGas(new s(e._common.param("gasPrices", "sstoreCleanGasEIP2200")))) : (o.length > 0 && (0 === c.length ? e.eei.subRefund(new s(e._common.param("gasPrices", "sstoreClearRefundEIP2200"))) : 0 === a.length && e.eei.refundGas(new s(e._common.param("gasPrices", "sstoreClearRefundEIP2200")))), o.equals(a) && (0 === o.length ? e.eei.refundGas(new s(e._common.param("gasPrices", "sstoreInitRefundEIP2200"))) : e.eei.refundGas(new s(e._common.param("gasPrices", "sstoreCleanRefundEIP2200")))), e.eei.useGas(new s(e._common.param("gasPrices", "sstoreDirtyGasEIP2200"))));
                  }

                  0 !== a.length || t.length ? 0 === a.length && t.length ? (e.eei.useGas(new s(e._common.param("gasPrices", "sstoreReset"))), e.eei.refundGas(new s(e._common.param("gasPrices", "sstoreRefund")))) : 0 === a.length || t.length ? 0 !== a.length && t.length && e.eei.useGas(new s(e._common.param("gasPrices", "sstoreReset"))) : e.eei.useGas(new s(e._common.param("gasPrices", "sstoreSet"))) : e.eei.useGas(new s(e._common.param("gasPrices", "sstoreReset")));
                }(t, d, u), [4, t.eei.storageStore(c, u)];

              case 2:
                return n.sent(), [2];
            }
          });
        });
      },
      JUMP: function JUMP(e) {
        var t = e.stack.pop();
        t.gt(e.eei.getCodeSize()) && l(i.ERROR.INVALID_JUMP + " at " + f(e));
        var a = t.toNumber();
        b(e, a) || l(i.ERROR.INVALID_JUMP + " at " + f(e)), e.programCounter = a;
      },
      JUMPI: function JUMPI(e) {
        var t = e.stack.popN(2),
            a = t[0];

        if (!t[1].isZero()) {
          a.gt(e.eei.getCodeSize()) && l(i.ERROR.INVALID_JUMP + " at " + f(e));
          var r = a.toNumber();
          b(e, r) || l(i.ERROR.INVALID_JUMP + " at " + f(e)), e.programCounter = r;
        }
      },
      PC: function PC(e) {
        e.stack.push(new s(e.programCounter - 1));
      },
      MSIZE: function MSIZE(e) {
        e.stack.push(e.memoryWordCount.muln(32));
      },
      GAS: function GAS(e) {
        e.stack.push(new s(e.eei.getGasLeft()));
      },
      JUMPDEST: function JUMPDEST(e) {},
      PUSH: function PUSH(e) {
        var t = e.opCode - 95,
            a = new s(e.eei.getCode().slice(e.programCounter, e.programCounter + t).toString("hex"), 16);
        e.programCounter += t, e.stack.push(a);
      },
      DUP: function DUP(e) {
        var t = e.opCode - 127;
        e.stack.dup(t);
      },
      SWAP: function SWAP(e) {
        var t = e.opCode - 143;
        e.stack.swap(t);
      },
      LOG: function LOG(t) {
        t.eei.isStatic() && l(i.ERROR.STATIC_STATE_CHANGE);
        var a = t.stack.popN(2),
            r = a[0],
            n = a[1],
            o = t.opCode - 160;
        (o < 0 || o > 4) && l(i.ERROR.OUT_OF_RANGE);
        var c = t.stack.popN(o).map(function (t) {
          return t.toArrayLike(e, "be", 32);
        });
        h(t, r, n);
        var u = e.alloc(0);
        n.isZero() || (u = t.memory.read(r.toNumber(), n.toNumber())), t.eei.useGas(new s(t._common.param("gasPrices", "logTopic")).imuln(o).iadd(n.muln(t._common.param("gasPrices", "logData")))), t.eei.log(u, o, c);
      },
      CREATE: function CREATE(t) {
        return r(this, void 0, void 0, function () {
          var a, r, o, c, u, d, f;
          return n(this, function (n) {
            switch (n.label) {
              case 0:
                return t.eei.isStatic() && l(i.ERROR.STATIC_STATE_CHANGE), a = t.stack.popN(3), r = a[0], o = a[1], c = a[2], h(t, o, c), u = m(u = new s(t.eei.getGasLeft()), t.eei.getGasLeft()), d = e.alloc(0), c.isZero() || (d = t.memory.read(o.toNumber(), c.toNumber())), [4, t.eei.create(u, r, d)];

              case 1:
                return f = n.sent(), t.stack.push(f), [2];
            }
          });
        });
      },
      CREATE2: function CREATE2(t) {
        return r(this, void 0, void 0, function () {
          var a, r, o, c, d, f, p, b;
          return n(this, function (n) {
            switch (n.label) {
              case 0:
                return t._common.gteHardfork("constantinople") || l(i.ERROR.INVALID_OPCODE), t.eei.isStatic() && l(i.ERROR.STATIC_STATE_CHANGE), a = t.stack.popN(4), r = a[0], o = a[1], c = a[2], d = a[3], h(t, o, c), t.eei.useGas(new s(t._common.param("gasPrices", "sha3Word")).imul(u(c, new s(32)))), f = m(f = new s(t.eei.getGasLeft()), t.eei.getGasLeft()), p = e.alloc(0), c.isZero() || (p = t.memory.read(o.toNumber(), c.toNumber())), [4, t.eei.create2(f, r, p, d.toArrayLike(e, "be", 32))];

              case 1:
                return b = n.sent(), t.stack.push(b), [2];
            }
          });
        });
      },
      CALL: function CALL(t) {
        return r(this, void 0, void 0, function () {
          var a, r, o, c, u, f, p, b, y, _, g;

          return n(this, function (n) {
            switch (n.label) {
              case 0:
                return a = t.stack.popN(7), r = a[0], o = a[1], c = a[2], u = a[3], f = a[4], p = a[5], b = a[6], y = d(o), t.eei.isStatic() && !c.isZero() && l(i.ERROR.STATIC_STATE_CHANGE), h(t, u, f), h(t, p, b), c.isZero() || t.eei.useGas(new s(t._common.param("gasPrices", "callValueTransfer"))), r = m(r, t.eei.getGasLeft()), _ = e.alloc(0), f.isZero() || (_ = t.memory.read(u.toNumber(), f.toNumber())), [4, t.eei.isAccountEmpty(y)];

              case 1:
                return n.sent() && (c.isZero() || t.eei.useGas(new s(t._common.param("gasPrices", "callNewAccount")))), c.isZero() || (t.eei._gasLeft.iaddn(t._common.param("gasPrices", "callStipend")), r.iaddn(t._common.param("gasPrices", "callStipend"))), [4, t.eei.call(r, y, c, _)];

              case 2:
                return g = n.sent(), v(t, p, b), t.stack.push(g), [2];
            }
          });
        });
      },
      CALLCODE: function CALLCODE(t) {
        return r(this, void 0, void 0, function () {
          var a, r, o, i, c, u, f, l, p, b, y;
          return n(this, function (n) {
            switch (n.label) {
              case 0:
                return a = t.stack.popN(7), r = a[0], o = a[1], i = a[2], c = a[3], u = a[4], f = a[5], l = a[6], p = d(o), h(t, c, u), h(t, f, l), i.isZero() || t.eei.useGas(new s(t._common.param("gasPrices", "callValueTransfer"))), r = m(r, t.eei.getGasLeft()), i.isZero() || (t.eei._gasLeft.iaddn(t._common.param("gasPrices", "callStipend")), r.iaddn(t._common.param("gasPrices", "callStipend"))), b = e.alloc(0), u.isZero() || (b = t.memory.read(c.toNumber(), u.toNumber())), [4, t.eei.callCode(r, p, i, b)];

              case 1:
                return y = n.sent(), v(t, f, l), t.stack.push(y), [2];
            }
          });
        });
      },
      DELEGATECALL: function DELEGATECALL(t) {
        return r(this, void 0, void 0, function () {
          var a, r, s, o, i, c, u, f, l, p, b;
          return n(this, function (n) {
            switch (n.label) {
              case 0:
                return a = t.eei.getCallValue(), r = t.stack.popN(6), s = r[0], o = r[1], i = r[2], c = r[3], u = r[4], f = r[5], l = d(o), h(t, i, c), h(t, u, f), s = m(s, t.eei.getGasLeft()), p = e.alloc(0), c.isZero() || (p = t.memory.read(i.toNumber(), c.toNumber())), [4, t.eei.callDelegate(s, l, a, p)];

              case 1:
                return b = n.sent(), v(t, u, f), t.stack.push(b), [2];
            }
          });
        });
      },
      STATICCALL: function STATICCALL(t) {
        return r(this, void 0, void 0, function () {
          var a, r, o, i, c, u, f, l, p, b, y;
          return n(this, function (n) {
            switch (n.label) {
              case 0:
                return a = new s(0), r = t.stack.popN(6), o = r[0], i = r[1], c = r[2], u = r[3], f = r[4], l = r[5], p = d(i), h(t, c, u), h(t, f, l), o = m(o, t.eei.getGasLeft()), b = e.alloc(0), u.isZero() || (b = t.memory.read(c.toNumber(), u.toNumber())), [4, t.eei.callStatic(o, p, a, b)];

              case 1:
                return y = n.sent(), v(t, f, l), t.stack.push(y), [2];
            }
          });
        });
      },
      RETURN: function RETURN(t) {
        var a = t.stack.popN(2),
            r = a[0],
            n = a[1];
        h(t, r, n);
        var s = e.alloc(0);
        n.isZero() || (s = t.memory.read(r.toNumber(), n.toNumber())), t.eei.finish(s);
      },
      REVERT: function REVERT(t) {
        var a = t.stack.popN(2),
            r = a[0],
            n = a[1];
        h(t, r, n);
        var s = e.alloc(0);
        n.isZero() || (s = t.memory.read(r.toNumber(), n.toNumber())), t.eei.revert(s);
      },
      SELFDESTRUCT: function SELFDESTRUCT(e) {
        return r(this, void 0, void 0, function () {
          var t, a;
          return n(this, function (r) {
            switch (r.label) {
              case 0:
                return t = e.stack.pop(), e.eei.isStatic() && l(i.ERROR.STATIC_STATE_CHANGE), a = d(t), [4, e.eei.getExternalBalance(e.eei.getAddress())];

              case 1:
                return r.sent().gtn(0) ? [4, e.eei.isAccountEmpty(a)] : [3, 3];

              case 2:
                r.sent() && e.eei.useGas(new s(e._common.param("gasPrices", "callNewAccount"))), r.label = 3;

              case 3:
                return [2, e.eei.selfDestruct(a)];
            }
          });
        });
      }
    };
  }).call(this, a(
  /*! ./../../../../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!***********************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-vm/dist/runCall.js ***!
  \***********************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = a(
    /*! bn.js */
    5),
        n = a(
    /*! ethereumjs-util */
    29),
        s = a(
    /*! ./evm/txContext */
    130),
        o = a(
    /*! ./evm/message */
    87),
        i = a(
    /*! ./evm/evm */
    32),
        c = a(
    /*! ethereumjs-block */
    60);

    t.default = function (t) {
      var a = t.block || new c(),
          u = new s.default(t.gasPrice || e.alloc(0), t.origin || t.caller || n.zeros(32)),
          d = new o.default({
        caller: t.caller,
        gasLimit: t.gasLimit ? new r(t.gasLimit) : new r(16777215),
        to: t.to && "" !== t.to.toString("hex") ? t.to : void 0,
        value: t.value,
        data: t.data,
        code: t.code,
        depth: t.depth || 0,
        isCompiled: t.compiled || !1,
        isStatic: t.static || !1,
        salt: t.salt || null,
        selfdestruct: t.selfdestruct || {},
        delegatecall: t.delegatecall || !1
      });
      return new i.default(this, u, a).executeMessage(d);
    };
  }).call(this, a(
  /*! ./../../../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!*********************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-vm/dist/runTx.js ***!
  \*********************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    var r = this && this.__awaiter || function (e, t, a, r) {
      return new (a || (a = Promise))(function (n, s) {
        function o(e) {
          try {
            c(r.next(e));
          } catch (e) {
            s(e);
          }
        }

        function i(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            s(e);
          }
        }

        function c(e) {
          e.done ? n(e.value) : new a(function (t) {
            t(e.value);
          }).then(o, i);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        n = this && this.__generator || function (e, t) {
      var a,
          r,
          n,
          s,
          o = {
        label: 0,
        sent: function sent() {
          if (1 & n[0]) throw n[1];
          return n[1];
        },
        trys: [],
        ops: []
      };
      return s = {
        next: i(0),
        throw: i(1),
        return: i(2)
      }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
        return this;
      }), s;

      function i(s) {
        return function (i) {
          return function (s) {
            if (a) throw new TypeError("Generator is already executing.");

            for (; o;) {
              try {
                if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

                switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                  case 0:
                  case 1:
                    n = s;
                    break;

                  case 4:
                    return o.label++, {
                      value: s[1],
                      done: !1
                    };

                  case 5:
                    o.label++, r = s[1], s = [0];
                    continue;

                  case 7:
                    s = o.ops.pop(), o.trys.pop();
                    continue;

                  default:
                    if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                      o = 0;
                      continue;
                    }

                    if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                      o.label = s[1];
                      break;
                    }

                    if (6 === s[0] && o.label < n[1]) {
                      o.label = n[1], n = s;
                      break;
                    }

                    if (n && o.label < n[2]) {
                      o.label = n[2], o.ops.push(s);
                      break;
                    }

                    n[2] && o.ops.pop(), o.trys.pop();
                    continue;
                }

                s = t.call(e, o);
              } catch (e) {
                s = [6, e], r = 0;
              } finally {
                a = n = 0;
              }
            }

            if (5 & s[0]) throw s[1];
            return {
              value: s[0] ? s[1] : void 0,
              done: !0
            };
          }([s, i]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(
    /*! bn.js */
    5),
        o = a(
    /*! ethereumjs-util */
    29),
        i = a(
    /*! ethereumjs-account */
    72),
        c = a(
    /*! ./bloom */
    268),
        u = a(
    /*! ./evm/evm */
    32),
        d = a(
    /*! ./evm/message */
    87),
        f = a(
    /*! ./evm/txContext */
    130),
        l = a(
    /*! ./state/promisified */
    74),
        h = a(
    /*! ethereumjs-block */
    60);

    function p(t) {
      return r(this, void 0, void 0, function () {
        var a, r, h, p, b, m, y, v, _, g, A, w, T, x, D;

        return n(this, function (n) {
          switch (n.label) {
            case 0:
              return a = t.block, r = t.tx, h = new l.default(this.stateManager), [4, this._emit("beforeTx", r)];

            case 1:
              if (n.sent(), p = r.getBaseFee(), (b = new s(r.gasLimit)).lt(p)) throw new Error("base fee exceeds gas limit");
              return b.isub(p), [4, h.getAccount(r.getSenderAddress())];

            case 2:
              if (m = n.sent(), !t.skipBalance && new s(m.balance).lt(r.getUpfrontCost())) throw new Error("sender doesn't have enough funds to send tx. The upfront cost is: " + r.getUpfrontCost().toString() + " and the sender's account only has: " + new s(m.balance).toString());
              if (!t.skipNonce && !new s(m.nonce).eq(new s(r.nonce))) throw new Error("the tx doesn't have the correct nonce. account has nonce of: " + new s(m.nonce).toString() + " tx has nonce of: " + new s(r.nonce).toString());
              return m.nonce = o.toBuffer(new s(m.nonce).addn(1)), m.balance = o.toBuffer(new s(m.balance).sub(new s(r.gasLimit).mul(new s(r.gasPrice)))), [4, h.putAccount(r.getSenderAddress(), m)];

            case 3:
              return n.sent(), y = new f.default(r.gasPrice, r.getSenderAddress()), v = new d.default({
                caller: r.getSenderAddress(),
                gasLimit: b,
                to: "" !== r.to.toString("hex") ? r.to : void 0,
                value: r.value,
                data: r.data
              }), h._wrapped._clearOriginalStorageCache(), [4, new u.default(this, y, a).executeMessage(v)];

            case 4:
              return (_ = n.sent()).bloom = function (e) {
                var t = new c.default();
                if (e) for (var a = 0; a < e.length; a++) {
                  var r = e[a];
                  t.add(r[0]);

                  for (var n = r[1], s = 0; s < n.length; s++) {
                    t.add(n[s]);
                  }
                }
                return t;
              }(_.execResult.logs), _.gasUsed = _.gasUsed.add(p), _.gasRefund = _.execResult.gasRefund, _.gasRefund && (_.gasRefund.lt(_.gasUsed.divn(2)) ? _.gasUsed.isub(_.gasRefund) : _.gasUsed.isub(_.gasUsed.divn(2))), _.amountSpent = _.gasUsed.mul(new s(r.gasPrice)), [4, h.getAccount(r.getSenderAddress())];

            case 5:
              return m = n.sent(), g = new s(r.gasLimit).sub(_.gasUsed).mul(new s(r.gasPrice)).add(new s(m.balance)), m.balance = o.toBuffer(g), [4, h.putAccount(o.toBuffer(r.getSenderAddress()), m)];

            case 6:
              return n.sent(), [4, h.getAccount(a.header.coinbase)];

            case 7:
              return (A = n.sent()).balance = o.toBuffer(new s(A.balance).add(_.amountSpent)), new s(A.balance).isZero() ? [3, 9] : [4, h.putAccount(a.header.coinbase, A)];

            case 8:
              n.sent(), n.label = 9;

            case 9:
              if (!_.execResult.selfdestruct) return [3, 13];
              w = Object.keys(_.execResult.selfdestruct), T = 0, x = w, n.label = 10;

            case 10:
              return T < x.length ? (D = x[T], [4, h.putAccount(e.from(D, "hex"), new i.default())]) : [3, 13];

            case 11:
              n.sent(), n.label = 12;

            case 12:
              return T++, [3, 10];

            case 13:
              return [4, h.cleanupTouchedAccounts()];

            case 14:
              return n.sent(), [4, this._emit("afterTx", _)];

            case 15:
              return n.sent(), [2, _];
          }
        });
      });
    }

    t.default = function (e) {
      return r(this, void 0, void 0, function () {
        var t, a, r;
        return n(this, function (n) {
          switch (n.label) {
            case 0:
              if (void 0 === e) throw new Error("invalid input, opts must be provided");
              if (!e.tx) throw new Error("invalid input, tx is required");
              if (e.block || (e.block = new h()), new s(e.block.header.gasLimit).lt(new s(e.tx.gasLimit))) throw new Error("tx has a higher gas limit than the block");
              return [4, (t = new l.default(this.stateManager)).checkpoint()];

            case 1:
              n.sent(), n.label = 2;

            case 2:
              return n.trys.push([2, 5,, 7]), [4, p.bind(this)(e)];

            case 3:
              return a = n.sent(), [4, t.commit()];

            case 4:
              return n.sent(), [2, a];

            case 5:
              return r = n.sent(), [4, t.revert()];

            case 6:
              throw n.sent(), r;

            case 7:
              return [2];
          }
        });
      });
    };
  }).call(this, a(
  /*! ./../../../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-vm/dist/runBlock.js ***!
  \************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e) {
    var r = this && this.__awaiter || function (e, t, a, r) {
      return new (a || (a = Promise))(function (n, s) {
        function o(e) {
          try {
            c(r.next(e));
          } catch (e) {
            s(e);
          }
        }

        function i(e) {
          try {
            c(r.throw(e));
          } catch (e) {
            s(e);
          }
        }

        function c(e) {
          e.done ? n(e.value) : new a(function (t) {
            t(e.value);
          }).then(o, i);
        }

        c((r = r.apply(e, t || [])).next());
      });
    },
        n = this && this.__generator || function (e, t) {
      var a,
          r,
          n,
          s,
          o = {
        label: 0,
        sent: function sent() {
          if (1 & n[0]) throw n[1];
          return n[1];
        },
        trys: [],
        ops: []
      };
      return s = {
        next: i(0),
        throw: i(1),
        return: i(2)
      }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
        return this;
      }), s;

      function i(s) {
        return function (i) {
          return function (s) {
            if (a) throw new TypeError("Generator is already executing.");

            for (; o;) {
              try {
                if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

                switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                  case 0:
                  case 1:
                    n = s;
                    break;

                  case 4:
                    return o.label++, {
                      value: s[1],
                      done: !1
                    };

                  case 5:
                    o.label++, r = s[1], s = [0];
                    continue;

                  case 7:
                    s = o.ops.pop(), o.trys.pop();
                    continue;

                  default:
                    if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                      o = 0;
                      continue;
                    }

                    if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                      o.label = s[1];
                      break;
                    }

                    if (6 === s[0] && o.label < n[1]) {
                      o.label = n[1], n = s;
                      break;
                    }

                    if (n && o.label < n[2]) {
                      o.label = n[2], o.ops.push(s);
                      break;
                    }

                    n[2] && o.ops.pop(), o.trys.pop();
                    continue;
                }

                s = t.call(e, o);
              } catch (e) {
                s = [6, e], r = 0;
              } finally {
                a = n = 0;
              }
            }

            if (5 & s[0]) throw s[1];
            return {
              value: s[0] ? s[1] : void 0,
              done: !0
            };
          }([s, i]);
        };
      }
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = a(
    /*! bn.js */
    5),
        o = a(
    /*! ethereumjs-util */
    29),
        i = a(
    /*! rlp */
    21),
        c = a(
    /*! ./bloom */
    268),
        u = a(
    /*! ./state/promisified */
    74),
        d = a(
    /*! util.promisify */
    88),
        f = a(
    /*! merkle-patricia-tree */
    112);

    function l(e, t) {
      return void 0 === t && (t = !1), r(this, void 0, void 0, function () {
        var a;
        return n(this, function (r) {
          switch (r.label) {
            case 0:
              if (t) return [3, 3];
              if (!new s(e.header.gasLimit).gte(new s("8000000000000000", 16))) return [3, 1];
              throw new Error("Invalid block with gas limit greater than (2^63 - 1)");

            case 1:
              return [4, d(e.validate).bind(e)(this.blockchain)];

            case 2:
              r.sent(), r.label = 3;

            case 3:
              return [4, h.bind(this)(e)];

            case 4:
              return a = r.sent(), [4, p.bind(this)(e)];

            case 5:
              return r.sent(), [2, a];
          }
        });
      });
    }

    function h(t) {
      return r(this, void 0, void 0, function () {
        var a, r, o, u, l, h, p, b, m;
        return n(this, function (n) {
          switch (n.label) {
            case 0:
              a = new c.default(), r = new s(0), o = new f(), u = [], l = [], h = 0, n.label = 1;

            case 1:
              if (!(h < t.transactions.length)) return [3, 5];
              if (p = t.transactions[h], new s(t.header.gasLimit).lt(new s(p.gasLimit).add(r))) throw new Error("tx has a higher gas limit than the block");
              return [4, this.runTx({
                tx: p,
                block: t
              })];

            case 2:
              return b = n.sent(), l.push(b), r = r.add(b.gasUsed), a.or(b.bloom), m = {
                status: b.execResult.exceptionError ? 0 : 1,
                gasUsed: r.toArrayLike(e),
                bitvector: b.bloom.bitvector,
                logs: b.execResult.logs || []
              }, u.push(m), [4, d(o.put).bind(o)(i.encode(h), i.encode(Object.values(m)))];

            case 3:
              n.sent(), n.label = 4;

            case 4:
              return h++, [3, 1];

            case 5:
              return [2, {
                bloom: a,
                gasUsed: r,
                receiptRoot: o.root,
                receipts: u,
                results: l
              }];
          }
        });
      });
    }

    function p(e) {
      return r(this, void 0, void 0, function () {
        var t, a, r, o, i, c, d, f;
        return n(this, function (n) {
          switch (n.label) {
            case 0:
              t = new u.default(this.stateManager), a = new s(this._common.param("pow", "minerReward")), r = e.uncleHeaders, o = 0, i = r, n.label = 1;

            case 1:
              return o < i.length ? (c = i[o], d = function (e, t, a) {
                var r = t.sub(e),
                    n = new s(8).sub(r).mul(a.divn(8));
                n.ltn(0) && (n = new s(0));
                return n;
              }(new s(c.number), new s(e.header.number), a), [4, b(t, c.coinbase, d)]) : [3, 4];

            case 2:
              n.sent(), n.label = 3;

            case 3:
              return o++, [3, 1];

            case 4:
              return f = function (e, t) {
                var a = e.divn(32).muln(t);
                return e.add(a);
              }(a, r.length), [4, b(t, e.header.coinbase, f)];

            case 5:
              return n.sent(), [2];
          }
        });
      });
    }

    function b(e, t, a) {
      return r(this, void 0, void 0, function () {
        var r;
        return n(this, function (n) {
          switch (n.label) {
            case 0:
              return [4, e.getAccount(t)];

            case 1:
              return (r = n.sent()).balance = o.toBuffer(new s(r.balance).add(a)), [4, e.putAccount(t, r)];

            case 2:
              return n.sent(), [2];
          }
        });
      });
    }

    t.default = function (e) {
      return r(this, void 0, void 0, function () {
        var t, a, r, s, i, c;
        return n(this, function (n) {
          switch (n.label) {
            case 0:
              if (void 0 === e) throw new Error("invalid input, opts must be provided");
              if (!e.block) throw new Error("invalid input, block must be provided");
              return t = new u.default(this.stateManager), a = e.block, r = !!e.generate, [4, this._emit("beforeBlock", e.block)];

            case 1:
              return n.sent(), e.root ? [4, t.setStateRoot(e.root)] : [3, 3];

            case 2:
              n.sent(), n.label = 3;

            case 3:
              return [4, t.checkpoint()];

            case 4:
              n.sent(), n.label = 5;

            case 5:
              return n.trys.push([5, 7,, 9]), [4, l.bind(this)(a, e.skipBlockValidation)];

            case 6:
              return s = n.sent(), [3, 9];

            case 7:
              return i = n.sent(), [4, t.revert()];

            case 8:
              throw n.sent(), i;

            case 9:
              return [4, t.commit()];

            case 10:
              return n.sent(), [4, t.getStateRoot()];

            case 11:
              if (c = n.sent(), r) a.header.stateRoot = c, a.header.bloom = s.bloom.bitvector;else {
                if (s.receiptRoot && s.receiptRoot.toString("hex") !== a.header.receiptTrie.toString("hex")) throw new Error("invalid receiptTrie ");
                if (s.bloom.bitvector.toString("hex") !== a.header.bloom.toString("hex")) throw new Error("invalid bloom ");
                if (o.bufferToInt(a.header.gasUsed) !== Number(s.gasUsed)) throw new Error("invalid gasUsed ");
                if (c.toString("hex") !== a.header.stateRoot.toString("hex")) throw new Error("invalid block stateRoot ");
              }
              return [4, this._emit("afterBlock", {
                receipts: s.receipts,
                results: s.results
              })];

            case 12:
              return n.sent(), [2, {
                receipts: s.receipts,
                results: s.results
              }];
          }
        });
      });
    };
  }).call(this, a(
  /*! ./../../../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!***************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-vm/dist/evm/opcodes.js ***!
  \***************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = this && this.__assign || function () {
    return (r = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = {
    0: {
      name: "STOP",
      fee: 0,
      isAsync: !1
    },
    1: {
      name: "ADD",
      fee: 3,
      isAsync: !1
    },
    2: {
      name: "MUL",
      fee: 5,
      isAsync: !1
    },
    3: {
      name: "SUB",
      fee: 3,
      isAsync: !1
    },
    4: {
      name: "DIV",
      fee: 5,
      isAsync: !1
    },
    5: {
      name: "SDIV",
      fee: 5,
      isAsync: !1
    },
    6: {
      name: "MOD",
      fee: 5,
      isAsync: !1
    },
    7: {
      name: "SMOD",
      fee: 5,
      isAsync: !1
    },
    8: {
      name: "ADDMOD",
      fee: 8,
      isAsync: !1
    },
    9: {
      name: "MULMOD",
      fee: 8,
      isAsync: !1
    },
    10: {
      name: "EXP",
      fee: 10,
      isAsync: !1
    },
    11: {
      name: "SIGNEXTEND",
      fee: 5,
      isAsync: !1
    },
    16: {
      name: "LT",
      fee: 3,
      isAsync: !1
    },
    17: {
      name: "GT",
      fee: 3,
      isAsync: !1
    },
    18: {
      name: "SLT",
      fee: 3,
      isAsync: !1
    },
    19: {
      name: "SGT",
      fee: 3,
      isAsync: !1
    },
    20: {
      name: "EQ",
      fee: 3,
      isAsync: !1
    },
    21: {
      name: "ISZERO",
      fee: 3,
      isAsync: !1
    },
    22: {
      name: "AND",
      fee: 3,
      isAsync: !1
    },
    23: {
      name: "OR",
      fee: 3,
      isAsync: !1
    },
    24: {
      name: "XOR",
      fee: 3,
      isAsync: !1
    },
    25: {
      name: "NOT",
      fee: 3,
      isAsync: !1
    },
    26: {
      name: "BYTE",
      fee: 3,
      isAsync: !1
    },
    27: {
      name: "SHL",
      fee: 3,
      isAsync: !1
    },
    28: {
      name: "SHR",
      fee: 3,
      isAsync: !1
    },
    29: {
      name: "SAR",
      fee: 3,
      isAsync: !1
    },
    32: {
      name: "SHA3",
      fee: 30,
      isAsync: !1
    },
    48: {
      name: "ADDRESS",
      fee: 2,
      isAsync: !0
    },
    49: {
      name: "BALANCE",
      fee: 400,
      isAsync: !0
    },
    50: {
      name: "ORIGIN",
      fee: 2,
      isAsync: !0
    },
    51: {
      name: "CALLER",
      fee: 2,
      isAsync: !0
    },
    52: {
      name: "CALLVALUE",
      fee: 2,
      isAsync: !0
    },
    53: {
      name: "CALLDATALOAD",
      fee: 3,
      isAsync: !0
    },
    54: {
      name: "CALLDATASIZE",
      fee: 2,
      isAsync: !0
    },
    55: {
      name: "CALLDATACOPY",
      fee: 3,
      isAsync: !0
    },
    56: {
      name: "CODESIZE",
      fee: 2,
      isAsync: !1
    },
    57: {
      name: "CODECOPY",
      fee: 3,
      isAsync: !1
    },
    58: {
      name: "GASPRICE",
      fee: 2,
      isAsync: !1
    },
    59: {
      name: "EXTCODESIZE",
      fee: 700,
      isAsync: !0
    },
    60: {
      name: "EXTCODECOPY",
      fee: 700,
      isAsync: !0
    },
    61: {
      name: "RETURNDATASIZE",
      fee: 2,
      isAsync: !0
    },
    62: {
      name: "RETURNDATACOPY",
      fee: 3,
      isAsync: !0
    },
    63: {
      name: "EXTCODEHASH",
      fee: 400,
      isAsync: !0
    },
    64: {
      name: "BLOCKHASH",
      fee: 20,
      isAsync: !0
    },
    65: {
      name: "COINBASE",
      fee: 2,
      isAsync: !0
    },
    66: {
      name: "TIMESTAMP",
      fee: 2,
      isAsync: !0
    },
    67: {
      name: "NUMBER",
      fee: 2,
      isAsync: !0
    },
    68: {
      name: "DIFFICULTY",
      fee: 2,
      isAsync: !0
    },
    69: {
      name: "GASLIMIT",
      fee: 2,
      isAsync: !0
    },
    80: {
      name: "POP",
      fee: 2,
      isAsync: !1
    },
    81: {
      name: "MLOAD",
      fee: 3,
      isAsync: !1
    },
    82: {
      name: "MSTORE",
      fee: 3,
      isAsync: !1
    },
    83: {
      name: "MSTORE8",
      fee: 3,
      isAsync: !1
    },
    84: {
      name: "SLOAD",
      fee: 200,
      isAsync: !0
    },
    85: {
      name: "SSTORE",
      fee: 0,
      isAsync: !0
    },
    86: {
      name: "JUMP",
      fee: 8,
      isAsync: !1
    },
    87: {
      name: "JUMPI",
      fee: 10,
      isAsync: !1
    },
    88: {
      name: "PC",
      fee: 2,
      isAsync: !1
    },
    89: {
      name: "MSIZE",
      fee: 2,
      isAsync: !1
    },
    90: {
      name: "GAS",
      fee: 2,
      isAsync: !1
    },
    91: {
      name: "JUMPDEST",
      fee: 1,
      isAsync: !1
    },
    96: {
      name: "PUSH",
      fee: 3,
      isAsync: !1
    },
    97: {
      name: "PUSH",
      fee: 3,
      isAsync: !1
    },
    98: {
      name: "PUSH",
      fee: 3,
      isAsync: !1
    },
    99: {
      name: "PUSH",
      fee: 3,
      isAsync: !1
    },
    100: {
      name: "PUSH",
      fee: 3,
      isAsync: !1
    },
    101: {
      name: "PUSH",
      fee: 3,
      isAsync: !1
    },
    102: {
      name: "PUSH",
      fee: 3,
      isAsync: !1
    },
    103: {
      name: "PUSH",
      fee: 3,
      isAsync: !1
    },
    104: {
      name: "PUSH",
      fee: 3,
      isAsync: !1
    },
    105: {
      name: "PUSH",
      fee: 3,
      isAsync: !1
    },
    106: {
      name: "PUSH",
      fee: 3,
      isAsync: !1
    },
    107: {
      name: "PUSH",
      fee: 3,
      isAsync: !1
    },
    108: {
      name: "PUSH",
      fee: 3,
      isAsync: !1
    },
    109: {
      name: "PUSH",
      fee: 3,
      isAsync: !1
    },
    110: {
      name: "PUSH",
      fee: 3,
      isAsync: !1
    },
    111: {
      name: "PUSH",
      fee: 3,
      isAsync: !1
    },
    112: {
      name: "PUSH",
      fee: 3,
      isAsync: !1
    },
    113: {
      name: "PUSH",
      fee: 3,
      isAsync: !1
    },
    114: {
      name: "PUSH",
      fee: 3,
      isAsync: !1
    },
    115: {
      name: "PUSH",
      fee: 3,
      isAsync: !1
    },
    116: {
      name: "PUSH",
      fee: 3,
      isAsync: !1
    },
    117: {
      name: "PUSH",
      fee: 3,
      isAsync: !1
    },
    118: {
      name: "PUSH",
      fee: 3,
      isAsync: !1
    },
    119: {
      name: "PUSH",
      fee: 3,
      isAsync: !1
    },
    120: {
      name: "PUSH",
      fee: 3,
      isAsync: !1
    },
    121: {
      name: "PUSH",
      fee: 3,
      isAsync: !1
    },
    122: {
      name: "PUSH",
      fee: 3,
      isAsync: !1
    },
    123: {
      name: "PUSH",
      fee: 3,
      isAsync: !1
    },
    124: {
      name: "PUSH",
      fee: 3,
      isAsync: !1
    },
    125: {
      name: "PUSH",
      fee: 3,
      isAsync: !1
    },
    126: {
      name: "PUSH",
      fee: 3,
      isAsync: !1
    },
    127: {
      name: "PUSH",
      fee: 3,
      isAsync: !1
    },
    128: {
      name: "DUP",
      fee: 3,
      isAsync: !1
    },
    129: {
      name: "DUP",
      fee: 3,
      isAsync: !1
    },
    130: {
      name: "DUP",
      fee: 3,
      isAsync: !1
    },
    131: {
      name: "DUP",
      fee: 3,
      isAsync: !1
    },
    132: {
      name: "DUP",
      fee: 3,
      isAsync: !1
    },
    133: {
      name: "DUP",
      fee: 3,
      isAsync: !1
    },
    134: {
      name: "DUP",
      fee: 3,
      isAsync: !1
    },
    135: {
      name: "DUP",
      fee: 3,
      isAsync: !1
    },
    136: {
      name: "DUP",
      fee: 3,
      isAsync: !1
    },
    137: {
      name: "DUP",
      fee: 3,
      isAsync: !1
    },
    138: {
      name: "DUP",
      fee: 3,
      isAsync: !1
    },
    139: {
      name: "DUP",
      fee: 3,
      isAsync: !1
    },
    140: {
      name: "DUP",
      fee: 3,
      isAsync: !1
    },
    141: {
      name: "DUP",
      fee: 3,
      isAsync: !1
    },
    142: {
      name: "DUP",
      fee: 3,
      isAsync: !1
    },
    143: {
      name: "DUP",
      fee: 3,
      isAsync: !1
    },
    144: {
      name: "SWAP",
      fee: 3,
      isAsync: !1
    },
    145: {
      name: "SWAP",
      fee: 3,
      isAsync: !1
    },
    146: {
      name: "SWAP",
      fee: 3,
      isAsync: !1
    },
    147: {
      name: "SWAP",
      fee: 3,
      isAsync: !1
    },
    148: {
      name: "SWAP",
      fee: 3,
      isAsync: !1
    },
    149: {
      name: "SWAP",
      fee: 3,
      isAsync: !1
    },
    150: {
      name: "SWAP",
      fee: 3,
      isAsync: !1
    },
    151: {
      name: "SWAP",
      fee: 3,
      isAsync: !1
    },
    152: {
      name: "SWAP",
      fee: 3,
      isAsync: !1
    },
    153: {
      name: "SWAP",
      fee: 3,
      isAsync: !1
    },
    154: {
      name: "SWAP",
      fee: 3,
      isAsync: !1
    },
    155: {
      name: "SWAP",
      fee: 3,
      isAsync: !1
    },
    156: {
      name: "SWAP",
      fee: 3,
      isAsync: !1
    },
    157: {
      name: "SWAP",
      fee: 3,
      isAsync: !1
    },
    158: {
      name: "SWAP",
      fee: 3,
      isAsync: !1
    },
    159: {
      name: "SWAP",
      fee: 3,
      isAsync: !1
    },
    160: {
      name: "LOG",
      fee: 375,
      isAsync: !1
    },
    161: {
      name: "LOG",
      fee: 375,
      isAsync: !1
    },
    162: {
      name: "LOG",
      fee: 375,
      isAsync: !1
    },
    163: {
      name: "LOG",
      fee: 375,
      isAsync: !1
    },
    164: {
      name: "LOG",
      fee: 375,
      isAsync: !1
    },
    240: {
      name: "CREATE",
      fee: 32e3,
      isAsync: !0
    },
    241: {
      name: "CALL",
      fee: 700,
      isAsync: !0
    },
    242: {
      name: "CALLCODE",
      fee: 700,
      isAsync: !0
    },
    243: {
      name: "RETURN",
      fee: 0,
      isAsync: !1
    },
    244: {
      name: "DELEGATECALL",
      fee: 700,
      isAsync: !0
    },
    245: {
      name: "CREATE2",
      fee: 32e3,
      isAsync: !0
    },
    250: {
      name: "STATICCALL",
      fee: 700,
      isAsync: !0
    },
    253: {
      name: "REVERT",
      fee: 0,
      isAsync: !1
    },
    254: {
      name: "INVALID",
      fee: 0,
      isAsync: !1
    },
    255: {
      name: "SELFDESTRUCT",
      fee: 5e3,
      isAsync: !0
    }
  },
      s = {
    49: {
      name: "BALANCE",
      fee: 700,
      isAsync: !0
    },
    63: {
      name: "EXTCODEHASH",
      fee: 700,
      isAsync: !0
    },
    70: {
      name: "CHAINID",
      fee: 2,
      isAsync: !1
    },
    71: {
      name: "SELFBALANCE",
      fee: 5,
      isAsync: !1
    },
    84: {
      name: "SLOAD",
      fee: 800,
      isAsync: !0
    }
  };

  t.getOpcodesForHF = function (e) {
    return "istanbul" === e ? r({}, n, s) : r({}, n);
  };
},
/*!*****************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-vm/dist/runBlockchain.js ***!
  \*****************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = a(
  /*! async */
  73);

  t.default = function (e) {
    var t = this;
    return new Promise(function (a, n) {
      var s,
          o,
          i = t;
      (e = e || t.blockchain).iterator("vm", function (t, a, n) {
        r.series([function (r) {
          !s || a ? e.getBlock(t.header.parentHash, function (e, t) {
            if (o = t.header.stateRoot, !s) return i.stateManager.generateCanonicalGenesis(r);
            r(e);
          }) : (o = s.header.stateRoot, r());
        }, function (a) {
          i.runBlock({
            block: t,
            root: o
          }).then(function () {
            s = t, a();
          }).catch(function (r) {
            e.delBlock(t.header.hash(), function () {
              a(r);
            });
          });
        }], n);
      }, function (e) {
        e ? n(e) : a();
      });
    });
  };
},
/*!**************************************************!*\
  !*** ./node_modules/async-eventemitter/index.js ***!
  \**************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  e.exports = a(
  /*! ./lib/AsyncEventEmitter */
  727);
},
/*!******************************************************************!*\
  !*** ./node_modules/async-eventemitter/lib/AsyncEventEmitter.js ***!
  \******************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r,
      n = a(
  /*! events */
  41).EventEmitter,
      s = a(
  /*! util */
  23),
      o = a(
  /*! async/eachSeries */
  728);
  e.exports = r = function r() {
    n.call(this);
  }, s.inherits(r, n), r.prototype.emit = function (e, t, a) {
    var r = this,
        n = r._events[e] || [];
    return a || "function" != typeof t || (a = t, t = void 0), "newListener" !== e && "removeListener" !== e || (t = {
      event: t,
      fn: a
    }, a = void 0), n = Array.isArray(n) ? n : [n], o(n.slice(), function (e, a) {
      var n;

      if (e.length < 2) {
        try {
          e.call(r, t);
        } catch (e) {
          n = e;
        }

        return a(n);
      }

      e.call(r, t, a);
    }, a), r;
  }, r.prototype.once = function (e, t) {
    var a,
        r = this;
    if ("function" != typeof t) throw new TypeError("listener must be a function");
    return (a = t.length >= 2 ? function (n, s) {
      r.removeListener(e, a), t(n, s);
    } : function (n) {
      r.removeListener(e, a), t(n);
    }).listener = t, r.on(e, a), r;
  }, r.prototype.first = function (e, t) {
    var a = this._events[e] || [];
    if ("function" != typeof t) throw new TypeError("listener must be a function");
    return Array.isArray(a) || (this._events[e] = a = [a]), a.unshift(t), this;
  }, r.prototype.at = function (e, t, a) {
    var r = this._events[e] || [];
    if ("function" != typeof a) throw new TypeError("listener must be a function");
    if ("number" != typeof t || t < 0) throw new TypeError("index must be a non-negative integer");
    return Array.isArray(r) || (this._events[e] = r = [r]), r.splice(t, 0, a), this;
  }, r.prototype.before = function (e, t, a) {
    return this._beforeOrAfter(e, t, a);
  }, r.prototype.after = function (e, t, a) {
    return this._beforeOrAfter(e, t, a, "after");
  }, r.prototype._beforeOrAfter = function (e, t, a, r) {
    var n,
        s,
        o = this._events[e] || [],
        i = "after" === r ? 1 : 0;
    if ("function" != typeof a) throw new TypeError("listener must be a function");
    if ("function" != typeof t) throw new TypeError("target must be a function");

    for (Array.isArray(o) || (this._events[e] = o = [o]), s = o.length, n = o.length; n--;) {
      if (o[n] === t) {
        s = n + i;
        break;
      }
    }

    return o.splice(s, 0, a), this;
  };
},
/*!******************************************!*\
  !*** ./node_modules/async/eachSeries.js ***!
  \******************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = s(a(
  /*! ./eachLimit */
  729)),
      n = s(a(
  /*! ./internal/doLimit */
  762));

  function s(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  t.default = (0, n.default)(r.default, 1), e.exports = t.default;
},
/*!*****************************************!*\
  !*** ./node_modules/async/eachLimit.js ***!
  \*****************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e, t, a, o) {
    (0, r.default)(t)(e, (0, n.default)((0, s.default)(a)), o);
  };
  var r = o(a(
  /*! ./internal/eachOfLimit */
  730)),
      n = o(a(
  /*! ./internal/withoutIndex */
  757)),
      s = o(a(
  /*! ./internal/wrapAsync */
  758));

  function o(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  e.exports = t.default;
},
/*!****************************************************!*\
  !*** ./node_modules/async/internal/eachOfLimit.js ***!
  \****************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return function (t, a, c) {
      if (c = (0, n.default)(c || r.default), e <= 0 || !t) return c(null);
      var u = (0, s.default)(t),
          d = !1,
          f = 0,
          l = !1;

      function h(e, t) {
        if (f -= 1, e) d = !0, c(e);else {
          if (t === i.default || d && f <= 0) return d = !0, c(null);
          l || p();
        }
      }

      function p() {
        for (l = !0; f < e && !d;) {
          var t = u();
          if (null === t) return d = !0, void (f <= 0 && c(null));
          f += 1, a(t.value, t.key, (0, o.default)(h));
        }

        l = !1;
      }

      p();
    };
  };
  var r = c(a(
  /*! lodash/noop */
  731)),
      n = c(a(
  /*! ./once */
  732)),
      s = c(a(
  /*! ./iterator */
  733)),
      o = c(a(
  /*! ./onlyOnce */
  755)),
      i = c(a(
  /*! ./breakLoop */
  756));

  function c(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  e.exports = t.default;
},
/*!*************************************!*\
  !*** ./node_modules/lodash/noop.js ***!
  \*************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = function () {};
},
/*!*********************************************!*\
  !*** ./node_modules/async/internal/once.js ***!
  \*********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return function () {
      if (null !== e) {
        var t = e;
        e = null, t.apply(this, arguments);
      }
    };
  }, e.exports = t.default;
},
/*!*************************************************!*\
  !*** ./node_modules/async/internal/iterator.js ***!
  \*************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    if ((0, r.default)(e)) return function (e) {
      var t = -1,
          a = e.length;
      return function () {
        return ++t < a ? {
          value: e[t],
          key: t
        } : null;
      };
    }(e);
    var t = (0, n.default)(e);
    return t ? function (e) {
      var t = -1;
      return function () {
        var a = e.next();
        return a.done ? null : (t++, {
          value: a.value,
          key: t
        });
      };
    }(t) : function (e) {
      var t = (0, s.default)(e),
          a = -1,
          r = t.length;
      return function () {
        var n = t[++a];
        return a < r ? {
          value: e[n],
          key: n
        } : null;
      };
    }(e);
  };
  var r = o(a(
  /*! lodash/isArrayLike */
  269)),
      n = o(a(
  /*! ./getIterator */
  737)),
      s = o(a(
  /*! lodash/keys */
  738));

  function o(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  e.exports = t.default;
},
/*!*******************************************!*\
  !*** ./node_modules/lodash/isFunction.js ***!
  \*******************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./_baseGetTag */
  140),
      n = a(
  /*! ./isObject */
  273),
      s = "[object AsyncFunction]",
      o = "[object Function]",
      i = "[object GeneratorFunction]",
      c = "[object Proxy]";

  e.exports = function (e) {
    if (!n(e)) return !1;
    var t = r(e);
    return t == o || t == i || t == s || t == c;
  };
},
/*!*******************************************!*\
  !*** ./node_modules/lodash/_getRawTag.js ***!
  \*******************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./_Symbol */
  270),
      n = Object.prototype,
      s = n.hasOwnProperty,
      o = n.toString,
      i = r ? r.toStringTag : void 0;

  e.exports = function (e) {
    var t = s.call(e, i),
        a = e[i];

    try {
      e[i] = void 0;
      var r = !0;
    } catch (e) {}

    var n = o.call(e);
    return r && (t ? e[i] = a : delete e[i]), n;
  };
},
/*!************************************************!*\
  !*** ./node_modules/lodash/_objectToString.js ***!
  \************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  var a = Object.prototype.toString;

  e.exports = function (e) {
    return a.call(e);
  };
},
/*!****************************************************!*\
  !*** ./node_modules/async/internal/getIterator.js ***!
  \****************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return r && e[r] && e[r]();
  };
  var r = "function" == typeof Symbol && Symbol.iterator;
  e.exports = t.default;
},
/*!*************************************!*\
  !*** ./node_modules/lodash/keys.js ***!
  \*************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./_arrayLikeKeys */
  739),
      n = a(
  /*! ./_baseKeys */
  751),
      s = a(
  /*! ./isArrayLike */
  269);

  e.exports = function (e) {
    return s(e) ? r(e) : n(e);
  };
},
/*!***********************************************!*\
  !*** ./node_modules/lodash/_arrayLikeKeys.js ***!
  \***********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./_baseTimes */
  740),
      n = a(
  /*! ./isArguments */
  741),
      s = a(
  /*! ./isArray */
  743),
      o = a(
  /*! ./isBuffer */
  744),
      i = a(
  /*! ./_isIndex */
  746),
      c = a(
  /*! ./isTypedArray */
  747),
      u = Object.prototype.hasOwnProperty;

  e.exports = function (e, t) {
    var a = s(e),
        d = !a && n(e),
        f = !a && !d && o(e),
        l = !a && !d && !f && c(e),
        h = a || d || f || l,
        p = h ? r(e.length, String) : [],
        b = p.length;

    for (var m in e) {
      !t && !u.call(e, m) || h && ("length" == m || f && ("offset" == m || "parent" == m) || l && ("buffer" == m || "byteLength" == m || "byteOffset" == m) || i(m, b)) || p.push(m);
    }

    return p;
  };
},
/*!*******************************************!*\
  !*** ./node_modules/lodash/_baseTimes.js ***!
  \*******************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = function (e, t) {
    for (var a = -1, r = Array(e); ++a < e;) {
      r[a] = t(a);
    }

    return r;
  };
},
/*!********************************************!*\
  !*** ./node_modules/lodash/isArguments.js ***!
  \********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./_baseIsArguments */
  742),
      n = a(
  /*! ./isObjectLike */
  141),
      s = Object.prototype,
      o = s.hasOwnProperty,
      i = s.propertyIsEnumerable,
      c = r(function () {
    return arguments;
  }()) ? r : function (e) {
    return n(e) && o.call(e, "callee") && !i.call(e, "callee");
  };
  e.exports = c;
},
/*!*************************************************!*\
  !*** ./node_modules/lodash/_baseIsArguments.js ***!
  \*************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./_baseGetTag */
  140),
      n = a(
  /*! ./isObjectLike */
  141),
      s = "[object Arguments]";

  e.exports = function (e) {
    return n(e) && r(e) == s;
  };
},
/*!****************************************!*\
  !*** ./node_modules/lodash/isArray.js ***!
  \****************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  var a = Array.isArray;
  e.exports = a;
},
/*!*****************************************!*\
  !*** ./node_modules/lodash/isBuffer.js ***!
  \*****************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (e) {
    var r = a(
    /*! ./_root */
    271),
        n = a(
    /*! ./stubFalse */
    745),
        s = t && !t.nodeType && t,
        o = s && "object" == typeof e && e && !e.nodeType && e,
        i = o && o.exports === s ? r.Buffer : void 0,
        c = (i ? i.isBuffer : void 0) || n;
    e.exports = c;
  }).call(this, a(
  /*! ./../webpack/buildin/module.js */
  45)(e));
},
/*!******************************************!*\
  !*** ./node_modules/lodash/stubFalse.js ***!
  \******************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = function () {
    return !1;
  };
},
/*!*****************************************!*\
  !*** ./node_modules/lodash/_isIndex.js ***!
  \*****************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  var a = 9007199254740991,
      r = /^(?:0|[1-9]\d*)$/;

  e.exports = function (e, t) {
    var n = typeof e;
    return !!(t = null == t ? a : t) && ("number" == n || "symbol" != n && r.test(e)) && e > -1 && e % 1 == 0 && e < t;
  };
},
/*!*********************************************!*\
  !*** ./node_modules/lodash/isTypedArray.js ***!
  \*********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./_baseIsTypedArray */
  748),
      n = a(
  /*! ./_baseUnary */
  749),
      s = a(
  /*! ./_nodeUtil */
  750),
      o = s && s.isTypedArray,
      i = o ? n(o) : r;
  e.exports = i;
},
/*!**************************************************!*\
  !*** ./node_modules/lodash/_baseIsTypedArray.js ***!
  \**************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./_baseGetTag */
  140),
      n = a(
  /*! ./isLength */
  274),
      s = a(
  /*! ./isObjectLike */
  141),
      o = {};
  o["[object Float32Array]"] = o["[object Float64Array]"] = o["[object Int8Array]"] = o["[object Int16Array]"] = o["[object Int32Array]"] = o["[object Uint8Array]"] = o["[object Uint8ClampedArray]"] = o["[object Uint16Array]"] = o["[object Uint32Array]"] = !0, o["[object Arguments]"] = o["[object Array]"] = o["[object ArrayBuffer]"] = o["[object Boolean]"] = o["[object DataView]"] = o["[object Date]"] = o["[object Error]"] = o["[object Function]"] = o["[object Map]"] = o["[object Number]"] = o["[object Object]"] = o["[object RegExp]"] = o["[object Set]"] = o["[object String]"] = o["[object WeakMap]"] = !1, e.exports = function (e) {
    return s(e) && n(e.length) && !!o[r(e)];
  };
},
/*!*******************************************!*\
  !*** ./node_modules/lodash/_baseUnary.js ***!
  \*******************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = function (e) {
    return function (t) {
      return e(t);
    };
  };
},
/*!******************************************!*\
  !*** ./node_modules/lodash/_nodeUtil.js ***!
  \******************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (e) {
    var r = a(
    /*! ./_freeGlobal */
    272),
        n = t && !t.nodeType && t,
        s = n && "object" == typeof e && e && !e.nodeType && e,
        o = s && s.exports === n && r.process,
        i = function () {
      try {
        var e = s && s.require && s.require("util").types;

        return e || o && o.binding && o.binding("util");
      } catch (e) {}
    }();

    e.exports = i;
  }).call(this, a(
  /*! ./../webpack/buildin/module.js */
  45)(e));
},
/*!******************************************!*\
  !*** ./node_modules/lodash/_baseKeys.js ***!
  \******************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./_isPrototype */
  752),
      n = a(
  /*! ./_nativeKeys */
  753),
      s = Object.prototype.hasOwnProperty;

  e.exports = function (e) {
    if (!r(e)) return n(e);
    var t = [];

    for (var a in Object(e)) {
      s.call(e, a) && "constructor" != a && t.push(a);
    }

    return t;
  };
},
/*!*********************************************!*\
  !*** ./node_modules/lodash/_isPrototype.js ***!
  \*********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  var a = Object.prototype;

  e.exports = function (e) {
    var t = e && e.constructor;
    return e === ("function" == typeof t && t.prototype || a);
  };
},
/*!********************************************!*\
  !*** ./node_modules/lodash/_nativeKeys.js ***!
  \********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./_overArg */
  754)(Object.keys, Object);
  e.exports = r;
},
/*!*****************************************!*\
  !*** ./node_modules/lodash/_overArg.js ***!
  \*****************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  e.exports = function (e, t) {
    return function (a) {
      return e(t(a));
    };
  };
},
/*!*************************************************!*\
  !*** ./node_modules/async/internal/onlyOnce.js ***!
  \*************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return function () {
      if (null === e) throw new Error("Callback was already called.");
      var t = e;
      e = null, t.apply(this, arguments);
    };
  }, e.exports = t.default;
},
/*!**************************************************!*\
  !*** ./node_modules/async/internal/breakLoop.js ***!
  \**************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = {}, e.exports = t.default;
},
/*!*****************************************************!*\
  !*** ./node_modules/async/internal/withoutIndex.js ***!
  \*****************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return function (t, a, r) {
      return e(t, r);
    };
  }, e.exports = t.default;
},
/*!**************************************************!*\
  !*** ./node_modules/async/internal/wrapAsync.js ***!
  \**************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.isAsync = void 0;
  var r,
      n = a(
  /*! ../asyncify */
  759),
      s = (r = n) && r.__esModule ? r : {
    default: r
  };
  var o = "function" == typeof Symbol;

  function i(e) {
    return o && "AsyncFunction" === e[Symbol.toStringTag];
  }

  t.default = function (e) {
    return i(e) ? (0, s.default)(e) : e;
  }, t.isAsync = i;
},
/*!****************************************!*\
  !*** ./node_modules/async/asyncify.js ***!
  \****************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return (0, n.default)(function (t, a) {
      var n;

      try {
        n = e.apply(this, t);
      } catch (e) {
        return a(e);
      }

      (0, r.default)(n) && "function" == typeof n.then ? n.then(function (e) {
        i(a, null, e);
      }, function (e) {
        i(a, e.message ? e : new Error(e));
      }) : a(null, n);
    });
  };
  var r = o(a(
  /*! lodash/isObject */
  273)),
      n = o(a(
  /*! ./internal/initialParams */
  760)),
      s = o(a(
  /*! ./internal/setImmediate */
  761));

  function o(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  function i(e, t, a) {
    try {
      e(t, a);
    } catch (e) {
      (0, s.default)(c, e);
    }
  }

  function c(e) {
    throw e;
  }

  e.exports = t.default;
},
/*!******************************************************!*\
  !*** ./node_modules/async/internal/initialParams.js ***!
  \******************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return function () {
      var t = (0, s.default)(arguments),
          a = t.pop();
      e.call(this, t, a);
    };
  };
  var r,
      n = a(
  /*! ./slice */
  275),
      s = (r = n) && r.__esModule ? r : {
    default: r
  };
  e.exports = t.default;
},
/*!*****************************************************!*\
  !*** ./node_modules/async/internal/setImmediate.js ***!
  \*****************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  (function (e, r) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.hasNextTick = t.hasSetImmediate = void 0, t.fallback = d, t.wrap = f;
    var n,
        s = a(
    /*! ./slice */
    275),
        o = (n = s) && n.__esModule ? n : {
      default: n
    };
    var i,
        c = t.hasSetImmediate = "function" == typeof e && e,
        u = t.hasNextTick = "object" == typeof r && "function" == typeof r.nextTick;

    function d(e) {
      setTimeout(e, 0);
    }

    function f(e) {
      return function (t) {
        var a = (0, o.default)(arguments, 1);
        e(function () {
          t.apply(null, a);
        });
      };
    }

    i = c ? e : u ? r.nextTick : d, t.default = f(i);
  }).call(this, a(
  /*! ./../../timers-browserify/main.js */
  69).setImmediate, a(
  /*! ./../../process/browser.js */
  9));
},
/*!************************************************!*\
  !*** ./node_modules/async/internal/doLimit.js ***!
  \************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e, t) {
    return function (a, r, n) {
      return e(a, t, r, n);
    };
  }, e.exports = t.default;
},
/*!*********************************************************!*\
  !*** ./node_modules/@0x/base-contract/lib/src/utils.js ***!
  \*********************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = this && this.__assign || function () {
    return (r = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = a(
  /*! lodash */
  0);

  t.formatABIDataItem = function e(t, a, s) {
    var o = /\[\d*\]$/;

    if (t.type.match(o)) {
      var i = t.type.replace(o, "");
      return n.map(a, function (a) {
        return e(r({}, t, {
          type: i
        }), a, s);
      });
    }

    if ("tuple" === t.type) {
      var c = {};
      return n.forEach(t.components, function (t) {
        c[t.name] = e(t, a[t.name], s);
      }), c;
    }

    return s(t.type, a);
  };
},
/*!************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/lib/src/subscription_manager.js ***!
  \************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      n = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var s = a(
  /*! @0x/utils */
  8),
      o = a(
  /*! @0x/web3-wrapper */
  11),
      i = a(
  /*! ethereum-types */
  25),
      c = a(
  /*! ethereumjs-blockstream */
  765),
      u = a(
  /*! lodash */
  0),
      d = a(
  /*! ./types */
  280),
      f = a(
  /*! ./utils/filter_utils */
  772),
      l = function () {
    function e(e, t) {
      this.abi = e, this._web3Wrapper = t, this._filters = {}, this._filterCallbacks = {}, this._blockAndLogStreamerIfExists = void 0, this._onLogAddedSubscriptionToken = void 0, this._onLogRemovedSubscriptionToken = void 0;
    }

    return e._onBlockAndLogStreamerError = function (e, t) {
      e && s.logUtils.warn(t);
    }, e.prototype.unsubscribeAll = function () {
      var e = this,
          t = u.keys(this._filterCallbacks);
      u.each(t, function (t) {
        e.unsubscribe(t);
      });
    }, e.prototype.unsubscribe = function (e, t) {
      if (void 0 === this._filters[e]) throw new Error(d.SubscriptionErrors.SubscriptionNotFound);
      void 0 !== t && (0, this._filterCallbacks[e])(t, void 0);
      delete this._filters[e], delete this._filterCallbacks[e], u.isEmpty(this._filters) && this._stopBlockAndLogStream();
    }, e.prototype.subscribe = function (e, t, a, r, n, s, o) {
      void 0 === s && (s = !1);
      var i = f.filterUtils.getFilter(e, t, a, r);
      void 0 === this._blockAndLogStreamerIfExists && this._startBlockAndLogStream(s, o);
      var c = f.filterUtils.generateUUID();
      return this._filters[c] = i, this._filterCallbacks[c] = n, c;
    }, e.prototype.getLogsAsync = function (e, t, a, s, o) {
      return r(this, void 0, void 0, function () {
        var r, i;
        return n(this, function (n) {
          switch (n.label) {
            case 0:
              return r = f.filterUtils.getFilter(e, t, s, o, a), [4, this._web3Wrapper.getLogsAsync(r)];

            case 1:
              return i = n.sent(), [2, u.map(i, this._tryToDecodeLogOrNoop.bind(this))];
          }
        });
      });
    }, e.prototype._tryToDecodeLogOrNoop = function (e) {
      return new s.AbiDecoder([this.abi]).tryToDecodeLogOrNoop(e);
    }, e.prototype._onLogStateChanged = function (e, t, a) {
      var r = this;
      a.map(function (e) {
        return o.marshaller.unmarshalLog(e);
      }).forEach(function (t) {
        u.forEach(r._filters, function (a, n) {
          if (f.filterUtils.matchesFilter(t, a)) {
            var s = {
              log: r._tryToDecodeLogOrNoop(t),
              isRemoved: e
            };

            r._filterCallbacks[n](null, s);
          }
        });
      });
    }, e.prototype._startBlockAndLogStream = function (t, a) {
      if (void 0 !== this._blockAndLogStreamerIfExists) throw new Error(d.SubscriptionErrors.SubscriptionAlreadyPresent);
      this._blockAndLogStreamerIfExists = new c.BlockAndLogStreamer(this._blockstreamGetBlockOrNullAsync.bind(this), this._blockstreamGetLogsAsync.bind(this), e._onBlockAndLogStreamerError.bind(this, t));

      this._blockAndLogStreamerIfExists.addLogFilter({});

      var r = void 0 === a ? 1e3 : a;
      this._blockAndLogStreamIntervalIfExists = s.intervalUtils.setAsyncExcludingInterval(this._reconcileBlockAsync.bind(this), r, e._onBlockAndLogStreamerError.bind(this, t));
      var n = !1;
      this._onLogAddedSubscriptionToken = this._blockAndLogStreamerIfExists.subscribeToOnLogsAdded(this._onLogStateChanged.bind(this, n)), n = !0, this._onLogRemovedSubscriptionToken = this._blockAndLogStreamerIfExists.subscribeToOnLogsRemoved(this._onLogStateChanged.bind(this, n));
    }, e.prototype._blockstreamGetBlockOrNullAsync = function (e) {
      return r(this, void 0, void 0, function () {
        return n(this, function (t) {
          switch (t.label) {
            case 0:
              return !1, [4, this._web3Wrapper.sendRawPayloadAsync({
                method: "eth_getBlockByHash",
                params: [e, !1]
              })];

            case 1:
              return [2, t.sent()];
          }
        });
      });
    }, e.prototype._blockstreamGetLatestBlockOrNullAsync = function () {
      return r(this, void 0, void 0, function () {
        return n(this, function (e) {
          switch (e.label) {
            case 0:
              return !1, [4, this._web3Wrapper.sendRawPayloadAsync({
                method: "eth_getBlockByNumber",
                params: [i.BlockParamLiteral.Latest, !1]
              })];

            case 1:
              return [2, e.sent()];
          }
        });
      });
    }, e.prototype._blockstreamGetLogsAsync = function (e) {
      return r(this, void 0, void 0, function () {
        return n(this, function (t) {
          switch (t.label) {
            case 0:
              return [4, this._web3Wrapper.sendRawPayloadAsync({
                method: "eth_getLogs",
                params: [e]
              })];

            case 1:
              return [2, t.sent()];
          }
        });
      });
    }, e.prototype._stopBlockAndLogStream = function () {
      if (void 0 === this._blockAndLogStreamerIfExists) throw new Error(d.SubscriptionErrors.SubscriptionNotFound);
      this._blockAndLogStreamerIfExists.unsubscribeFromOnLogsAdded(this._onLogAddedSubscriptionToken), this._blockAndLogStreamerIfExists.unsubscribeFromOnLogsRemoved(this._onLogRemovedSubscriptionToken), s.intervalUtils.clearAsyncExcludingInterval(this._blockAndLogStreamIntervalIfExists), delete this._blockAndLogStreamerIfExists;
    }, e.prototype._reconcileBlockAsync = function () {
      return r(this, void 0, void 0, function () {
        var e;
        return n(this, function (t) {
          switch (t.label) {
            case 0:
              return [4, this._blockstreamGetLatestBlockOrNullAsync()];

            case 1:
              return null === (e = t.sent()) ? [2] : void 0 === this._blockAndLogStreamerIfExists ? [3, 3] : [4, this._blockAndLogStreamerIfExists.reconcileNewBlock(e)];

            case 2:
              t.sent(), t.label = 3;

            case 3:
              return [2];
          }
        });
      });
    }, e;
  }();

  t.SubscriptionManager = l;
},
/*!***************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-blockstream/output/source/index.js ***!
  \***************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = a(
  /*! ./block-and-log-streamer */
  766);
  t.BlockAndLogStreamer = r.BlockAndLogStreamer;
},
/*!********************************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-blockstream/output/source/block-and-log-streamer.js ***!
  \********************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      n = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var s = a(
  /*! ./block-reconciler */
  767),
      o = a(
  /*! ./log-reconciler */
  768),
      i = a(
  /*! immutable */
  277),
      c = a(
  /*! uuid */
  769),
      u = function u(e, t, a, _u2) {
    var f = this;
    if (this.lastKnownGoodBlockHistory = i.List(), this.blockHistory = Promise.resolve(this.lastKnownGoodBlockHistory), this.lastKnownGoodLogHistory = i.List(), this.logHistory = Promise.resolve(this.lastKnownGoodLogHistory), this.pendingCallbacks = [], this.onError = function () {}, this.logFilters = {}, this.onBlockAddedSubscribers = {}, this.onBlockRemovedSubscribers = {}, this.onLogsAddedSubscribers = {}, this.onLogsRemovedSubscribers = {}, this.reconcileNewBlock = function (e) {
      return r(f, void 0, void 0, function () {
        var t, a, r;
        return n(this, function (n) {
          switch (n.label) {
            case 0:
              return n.trys.push([0, 3,, 4]), this.blockHistory = s.reconcileBlockHistory(this.getBlockByHash, this.blockHistory, e, this.onBlockAdded, this.onBlockRemoved, this.blockRetention), [4, this.blockHistory];

            case 1:
              return t = n.sent(), [4, this.logHistory];

            case 2:
              return a = n.sent(), this.lastKnownGoodBlockHistory = t, this.lastKnownGoodLogHistory = a, this.pendingCallbacks.forEach(function (e) {
                return e();
              }), this.pendingCallbacks = [], [3, 4];

            case 3:
              throw r = n.sent(), this.blockHistory = Promise.resolve(this.lastKnownGoodBlockHistory), this.logHistory = Promise.resolve(this.lastKnownGoodLogHistory), this.pendingCallbacks = [], r;

            case 4:
              return [2];
          }
        });
      });
    }, this.onBlockAdded = function (e) {
      return r(f, void 0, void 0, function () {
        var t,
            a = this;
        return n(this, function (r) {
          switch (r.label) {
            case 0:
              return Object.keys(this.onBlockAddedSubscribers).map(function (e) {
                return a.onBlockAddedSubscribers[e];
              }).map(function (e) {
                return d(e, a.onError);
              }).forEach(function (t) {
                return a.pendingCallbacks.push(function () {
                  return t(e);
                });
              }), t = Object.keys(this.logFilters).map(function (e) {
                return a.logFilters[e];
              }), this.logHistory = o.reconcileLogHistoryWithAddedBlock(this.getLogs, this.logHistory, e, this.onLogsAdded, t, this.blockRetention), [4, this.logHistory];

            case 1:
              return r.sent(), [2];
          }
        });
      });
    }, this.onBlockRemoved = function (e) {
      return r(f, void 0, void 0, function () {
        var t = this;
        return n(this, function (a) {
          switch (a.label) {
            case 0:
              return this.logHistory = o.reconcileLogHistoryWithRemovedBlock(this.logHistory, e, this.onLogsRemoved), [4, this.logHistory];

            case 1:
              return a.sent(), Object.keys(this.onBlockRemovedSubscribers).map(function (e) {
                return t.onBlockRemovedSubscribers[e];
              }).map(function (e) {
                return d(e, t.onError);
              }).forEach(function (a) {
                return t.pendingCallbacks.push(function () {
                  return a(e);
                });
              }), [2];
          }
        });
      });
    }, this.onLogsAdded = function (e, t) {
      return r(f, void 0, void 0, function () {
        var a = this;
        return n(this, function (r) {
          return Object.keys(this.onLogsAddedSubscribers).map(function (e) {
            return a.onLogsAddedSubscribers[e];
          }).map(function (e) {
            return d(e, a.onError);
          }).forEach(function (r) {
            return a.pendingCallbacks.push(function () {
              return r(e, t);
            });
          }), [2];
        });
      });
    }, this.onLogsRemoved = function (e, t) {
      return r(f, void 0, void 0, function () {
        var a = this;
        return n(this, function (r) {
          return Object.keys(this.onLogsRemovedSubscribers).map(function (e) {
            return a.onLogsRemovedSubscribers[e];
          }).map(function (e) {
            return d(e, a.onError);
          }).forEach(function (r) {
            return a.pendingCallbacks.push(function () {
              return r(e, t);
            });
          }), [2];
        });
      });
    }, this.getLatestReconciledBlock = function () {
      return f.lastKnownGoodBlockHistory.isEmpty() ? null : f.lastKnownGoodBlockHistory.last();
    }, this.addLogFilter = function (e) {
      var t = "log filter token " + c();
      return f.logFilters[t] = e, t;
    }, this.removeLogFilter = function (e) {
      if (!e.startsWith("log filter token ")) throw new Error("Expected a log filter token.  Actual: " + e);
      delete f.logFilters[e];
    }, this.subscribeToOnBlockAdded = function (e) {
      var t = "on block added token " + c();
      return f.onBlockAddedSubscribers[t] = e, t;
    }, this.unsubscribeFromOnBlockAdded = function (e) {
      if (!e.startsWith("on block added token ")) throw new Error("Expected a block added subscription token.  Actual: " + e);
      delete f.onBlockAddedSubscribers[e];
    }, this.subscribeToOnBlockRemoved = function (e) {
      var t = "on block removed token " + c();
      return f.onBlockRemovedSubscribers[t] = e, t;
    }, this.unsubscribeFromOnBlockRemoved = function (e) {
      if (!e.startsWith("on block removed token ")) throw new Error("Expected a block added subscription token.  Actual: " + e);
      delete f.onBlockRemovedSubscribers[e];
    }, this.subscribeToOnLogsAdded = function (e) {
      var t = "on log added token " + c();
      return f.onLogsAddedSubscribers[t] = e, t;
    }, this.unsubscribeFromOnLogsAdded = function (e) {
      if (!e.startsWith("on log added token ")) throw new Error("Expected a log added subscription token.  Actual: " + e);
      delete f.onLogsAddedSubscribers[e];
    }, this.subscribeToOnLogsRemoved = function (e) {
      var t = "on log removed token " + c();
      return f.onLogsRemovedSubscribers[t] = e, t;
    }, this.unsubscribeFromOnLogsRemoved = function (e) {
      if (!e.startsWith("on log removed token ")) throw new Error("Expected a log added subscription token.  Actual: " + e);
      delete f.onLogsRemovedSubscribers[e];
    }, void 0 === e) throw new Error("getBlockByHash must be provided");
    if (this.getBlockByHash = e, void 0 === t) throw new Error("getLogs must be provided");
    if (this.getLogs = t, void 0 === a) throw new Error("onError must be provided");
    this.onError = a, this.blockRetention = _u2 && _u2.blockRetention ? _u2.blockRetention : 100;
  };

  function d(e, t) {
    return function (a, r) {
      try {
        e(a, r);
      } catch (e) {
        t(e);
      }
    };
  }

  t.BlockAndLogStreamer = u;
},
/*!**************************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-blockstream/output/source/block-reconciler.js ***!
  \**************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      n = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      s = this;

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = a(
  /*! ./utilities */
  276);

  t.reconcileBlockHistory = function (e, t, a, o, m, y) {
    return void 0 === y && (y = 100), r(s, void 0, void 0, function () {
      return n(this, function (r) {
        switch (r.label) {
          case 0:
            return [4, t];

          case 1:
            return t = r.sent(), f(t) ? [4, u(t, a, o, y)] : [3, 3];

          case 2:
            return [2, r.sent()];

          case 3:
            return l(t, a) ? [4, i(t, m)] : [3, 6];

          case 4:
            return t = r.sent(), [4, u(t, a, o, y)];

          case 5:
            return [2, r.sent()];

          case 6:
            return h(t, a) ? [2, t] : p(t, a) ? [4, u(t, a, o, y)] : [3, 8];

          case 7:
            return [2, r.sent()];

          case 8:
            if (!b(t, a)) return [3, 13];
            r.label = 9;

          case 9:
            return t.last().hash === a.parentHash ? [3, 11] : [4, d(t, m)];

          case 10:
            return t = r.sent(), [3, 9];

          case 11:
            return [4, u(t, a, o, y)];

          case 12:
            return [2, r.sent()];

          case 13:
            return [4, c(e, t, a, o, m, y)];

          case 14:
            return [2, r.sent()];
        }
      });
    });
  };

  var i = function i(e, t) {
    return r(s, void 0, void 0, function () {
      return n(this, function (a) {
        switch (a.label) {
          case 0:
            return e.isEmpty() ? [3, 2] : [4, d(e, t)];

          case 1:
            return e = a.sent(), [3, 0];

          case 2:
            return [2, e];
        }
      });
    });
  },
      c = function c(e, a, _c2, u, d, f) {
    return r(s, void 0, void 0, function () {
      var r;
      return n(this, function (n) {
        switch (n.label) {
          case 0:
            return "0x0000000000000000000000000000000000000000000000000000000000000000" !== _c2.parentHash ? [3, 2] : [4, i(a, d)];

          case 1:
            return [2, n.sent()];

          case 2:
            return [4, e(_c2.parentHash)];

          case 3:
            if (null === (r = n.sent())) throw new Error("Failed to fetch parent block.");
            return o.parseHexInt(r.number) + f < o.parseHexInt(a.last().number) ? [4, i(a, d)] : [3, 5];

          case 4:
            return [2, n.sent()];

          case 5:
            return [4, t.reconcileBlockHistory(e, a, r, u, d, f)];

          case 6:
            return a = n.sent(), [4, t.reconcileBlockHistory(e, a, _c2, u, d, f)];

          case 7:
            return [2, n.sent()];
        }
      });
    });
  },
      u = function u(e, t, a, o) {
    return r(s, void 0, void 0, function () {
      return n(this, function (r) {
        switch (r.label) {
          case 0:
            if (!e.isEmpty() && e.last().hash !== t.parentHash) throw new Error("New head block's parent isn't our current head.");
            return [4, a(t)];

          case 1:
            return r.sent(), [2, (e = e.push(t)).takeLast(o).toList()];
        }
      });
    });
  },
      d = function d(e, t) {
    return r(s, void 0, void 0, function () {
      var a;
      return n(this, function (r) {
        switch (r.label) {
          case 0:
            return a = e.last(), e = e.pop(), [4, t(a)];

          case 1:
            return r.sent(), [2, e];
        }
      });
    });
  },
      f = function f(e) {
    return e.isEmpty();
  },
      l = function l(e, t) {
    return o.parseHexInt(e.first().number) > o.parseHexInt(t.number);
  },
      h = function h(e, t) {
    return e.some(function (e) {
      return e.hash === t.hash;
    });
  },
      p = function p(e, t) {
    return e.last().hash === t.parentHash;
  },
      b = function b(e, t) {
    return e.some(function (e) {
      return e.hash === t.parentHash;
    });
  };
},
/*!************************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-blockstream/output/source/log-reconciler.js ***!
  \************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      n = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      s = this;

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = a(
  /*! ./utilities */
  276);

  t.reconcileLogHistoryWithAddedBlock = function (e, t, a, o, d, f) {
    return void 0 === d && (d = []), void 0 === f && (f = 100), r(s, void 0, void 0, function () {
      var r;
      return n(this, function (n) {
        switch (n.label) {
          case 0:
            return [4, t];

          case 1:
            return t = n.sent(), [4, i(e, a, d)];

          case 2:
            return r = n.sent(), [4, c(a.hash, t, r, o)];

          case 3:
            return t = n.sent(), [4, u(t, a, f)];

          case 4:
            return [2, t = n.sent()];
        }
      });
    });
  };

  var i = function i(e, t, a) {
    return r(s, void 0, void 0, function () {
      var r;
      return n(this, function (n) {
        switch (n.label) {
          case 0:
            return r = a.map(function (e) {
              return {
                blockHash: t.hash,
                address: e.address,
                topics: e.topics
              };
            }).map(function (t) {
              return e(t);
            }), [4, Promise.all(r)];

          case 1:
            return [2, n.sent().reduce(function (e, t) {
              return e.concat(t);
            }, [])];
        }
      });
    });
  },
      c = function c(e, t, a, i) {
    return r(s, void 0, void 0, function () {
      var r, s, c, u, f, l;
      return n(this, function (n) {
        switch (n.label) {
          case 0:
            for (r = a.sort(function (e, t) {
              return o.parseHexInt(e.logIndex) - o.parseHexInt(t.logIndex);
            }), s = [], c = function c(e) {
              if (t.some(function (t) {
                return t.blockHash === e.blockHash && t.logIndex === e.logIndex;
              })) return "continue";
              d(t.last(), e), t = t.push(e), s.push(e);
            }, u = 0, f = r; u < f.length; u++) {
              l = f[u], c(l);
            }

            return [4, i(e, s)];

          case 1:
            return n.sent(), [2, t];
        }
      });
    });
  },
      u = function u(e, t, a) {
    return r(s, void 0, void 0, function () {
      return n(this, function (r) {
        return [2, e.skipUntil(function (e) {
          return o.parseHexInt(t.number) - o.parseHexInt(e.blockNumber) < a;
        }).toList()];
      });
    });
  },
      d = function d(e, t) {
    if (void 0 !== e) {
      var a = o.parseHexInt(e.blockNumber),
          r = o.parseHexInt(t.blockNumber);
      if (a > r) throw new Error("received log for a block (" + r + ") older than current head log's block (" + a + ")");

      if (a === r) {
        var n = o.parseHexInt(e.logIndex),
            s = o.parseHexInt(t.logIndex);
        if (n >= s) throw new Error("received log with same block number (" + r + ") but index (" + s + ") is the same or older than previous index (" + n + ")");
      }
    }
  };

  t.reconcileLogHistoryWithRemovedBlock = function (e, t, a) {
    return r(s, void 0, void 0, function () {
      var r;
      return n(this, function (n) {
        switch (n.label) {
          case 0:
            return [4, e];

          case 1:
            for (e = n.sent(), r = []; !e.isEmpty() && e.last().blockHash === t.hash;) {
              r.push(e.last()), e = e.pop();
            }

            return [4, a(t.hash, r)];

          case 2:
            if (n.sent(), e.some(function (e) {
              return e.blockHash === t.hash;
            })) throw new Error("found logs for removed block not at head of log history");
            return [2, e];
        }
      });
    });
  };
},
/*!*******************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-blockstream/node_modules/uuid/index.js ***!
  \*******************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./v1 */
  770),
      n = a(
  /*! ./v4 */
  771),
      s = n;
  s.v1 = r, s.v4 = n, e.exports = s;
},
/*!****************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-blockstream/node_modules/uuid/v1.js ***!
  \****************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r,
      n,
      s = a(
  /*! ./lib/rng */
  278),
      o = a(
  /*! ./lib/bytesToUuid */
  279),
      i = 0,
      c = 0;

  e.exports = function (e, t, a) {
    var u = t && a || 0,
        d = t || [],
        f = (e = e || {}).node || r,
        l = void 0 !== e.clockseq ? e.clockseq : n;

    if (null == f || null == l) {
      var h = s();
      null == f && (f = r = [1 | h[0], h[1], h[2], h[3], h[4], h[5]]), null == l && (l = n = 16383 & (h[6] << 8 | h[7]));
    }

    var p = void 0 !== e.msecs ? e.msecs : new Date().getTime(),
        b = void 0 !== e.nsecs ? e.nsecs : c + 1,
        m = p - i + (b - c) / 1e4;
    if (m < 0 && void 0 === e.clockseq && (l = l + 1 & 16383), (m < 0 || p > i) && void 0 === e.nsecs && (b = 0), b >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    i = p, c = b, n = l;
    var y = (1e4 * (268435455 & (p += 122192928e5)) + b) % 4294967296;
    d[u++] = y >>> 24 & 255, d[u++] = y >>> 16 & 255, d[u++] = y >>> 8 & 255, d[u++] = 255 & y;
    var v = p / 4294967296 * 1e4 & 268435455;
    d[u++] = v >>> 8 & 255, d[u++] = 255 & v, d[u++] = v >>> 24 & 15 | 16, d[u++] = v >>> 16 & 255, d[u++] = l >>> 8 | 128, d[u++] = 255 & l;

    for (var _ = 0; _ < 6; ++_) {
      d[u + _] = f[_];
    }

    return t || o(d);
  };
},
/*!****************************************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/ethereumjs-blockstream/node_modules/uuid/v4.js ***!
  \****************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./lib/rng */
  278),
      n = a(
  /*! ./lib/bytesToUuid */
  279);

  e.exports = function (e, t, a) {
    var s = t && a || 0;
    "string" == typeof e && (t = "binary" === e ? new Array(16) : null, e = null);
    var o = (e = e || {}).random || (e.rng || r)();
    if (o[6] = 15 & o[6] | 64, o[8] = 63 & o[8] | 128, t) for (var i = 0; i < 16; ++i) {
      t[s + i] = o[i];
    }
    return t || n(o);
  };
},
/*!**********************************************************************!*\
  !*** ./node_modules/@0x/base-contract/lib/src/utils/filter_utils.js ***!
  \**********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = this && this.__assign || function () {
    return (r = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      n = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || t-- > 0) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  },
      s = this && this.__spread || function () {
    for (var e = [], t = 0; t < arguments.length; t++) {
      e = e.concat(n(arguments[t]));
    }

    return e;
  },
      o = this && this.__values || function (e) {
    var t = "function" == typeof Symbol && e[Symbol.iterator],
        a = 0;
    return t ? t.call(e) : {
      next: function next() {
        return e && a >= e.length && (e = void 0), {
          value: e && e[a++],
          done: !e
        };
      }
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var i = a(
  /*! ethereumjs-util */
  183),
      c = a(
  /*! js-sha3 */
  773),
      u = a(
  /*! lodash */
  0),
      d = a(
  /*! uuid/v4 */
  281);
  t.filterUtils = {
    generateUUID: function generateUUID() {
      return d();
    },
    getFilter: function getFilter(e, a, n, o, d) {
      var f = u.find(o, {
        name: a
      }),
          l = t.filterUtils.getEventSignatureFromAbiByName(f),
          h = i.addHexPrefix(c.keccak256(l)),
          p = t.filterUtils.getTopicsForIndexedArgs(f, n),
          b = {
        address: e,
        topics: s([h], p)
      };
      return void 0 !== d && (b = r({}, d, b)), b;
    },
    getEventSignatureFromAbiByName: function getEventSignatureFromAbiByName(e) {
      var t = u.map(e.inputs, "type");
      return e.name + "(" + t.join(",") + ")";
    },
    getTopicsForIndexedArgs: function getTopicsForIndexedArgs(e, t) {
      var a,
          r,
          n = [];

      try {
        for (var s = o(e.inputs), c = s.next(); !c.done; c = s.next()) {
          var u = c.value;
          if (u.indexed) if (void 0 === t[u.name]) n.push(null);else {
            var d = t[u.name],
                f = i.toBuffer(d),
                l = i.setLengthLeft(f, 32),
                h = i.bufferToHex(l);
            n.push(h);
          }
        }
      } catch (e) {
        a = {
          error: e
        };
      } finally {
        try {
          c && !c.done && (r = s.return) && r.call(s);
        } finally {
          if (a) throw a.error;
        }
      }

      return n;
    },
    matchesFilter: function matchesFilter(e, a) {
      return (void 0 === a.address || e.address === a.address) && (void 0 === a.topics || t.filterUtils.doesMatchTopics(e.topics, a.topics));
    },
    doesMatchTopics: function doesMatchTopics(e, a) {
      var r = u.zipWith(e, a, t.filterUtils.matchesTopic.bind(t.filterUtils));
      return u.every(r);
    },
    matchesTopic: function matchesTopic(e, t) {
      return u.isArray(t) ? u.includes(t, e) : !u.isString(t) || t === e;
    }
  };
},
/*!*************************************************************************!*\
  !*** ./node_modules/@0x/base-contract/node_modules/js-sha3/src/sha3.js ***!
  \*************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (r, n) {
    var s;
    /**
     * [js-sha3]{@link https://github.com/emn178/js-sha3}
     *
     * @version 0.7.0
     * @author Chen, Yi-Cyuan [emn178@gmail.com]
     * @copyright Chen, Yi-Cyuan 2015-2017
     * @license MIT
     */

    !function () {
      "use strict";

      var o = "input is invalid type",
          i = "object" == typeof window,
          c = i ? window : {};
      c.JS_SHA3_NO_WINDOW && (i = !1);
      var u = !i && "object" == typeof self;
      !c.JS_SHA3_NO_NODE_JS && "object" == typeof r && r.versions && r.versions.node ? c = n : u && (c = self);
      var d = !c.JS_SHA3_NO_COMMON_JS && "object" == typeof e && e.exports,
          f = a(
      /*! !webpack amd options */
      103),
          l = !c.JS_SHA3_NO_ARRAY_BUFFER && "undefined" != typeof ArrayBuffer,
          h = "0123456789abcdef".split(""),
          p = [4, 1024, 262144, 67108864],
          b = [0, 8, 16, 24],
          m = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649, 0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0, 2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771, 2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648, 2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648],
          y = [224, 256, 384, 512],
          v = [128, 256],
          _ = ["hex", "buffer", "arrayBuffer", "array", "digest"],
          g = {
        128: 168,
        256: 136
      };
      !c.JS_SHA3_NO_NODE_JS && Array.isArray || (Array.isArray = function (e) {
        return "[object Array]" === Object.prototype.toString.call(e);
      }), !l || !c.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW && ArrayBuffer.isView || (ArrayBuffer.isView = function (e) {
        return "object" == typeof e && e.buffer && e.buffer.constructor === ArrayBuffer;
      });

      for (var A = function A(e, t, a) {
        return function (r) {
          return new P(e, t, e).update(r)[a]();
        };
      }, w = function w(e, t, a) {
        return function (r, n) {
          return new P(e, t, n).update(r)[a]();
        };
      }, T = function T(e, t, a) {
        return function (t, r, n, s) {
          return E["cshake" + e].update(t, r, n, s)[a]();
        };
      }, x = function x(e, t, a) {
        return function (t, r, n, s) {
          return E["kmac" + e].update(t, r, n, s)[a]();
        };
      }, D = function D(e, t, a, r) {
        for (var n = 0; n < _.length; ++n) {
          var s = _[n];
          e[s] = t(a, r, s);
        }

        return e;
      }, C = function C(e, t) {
        var a = A(e, t, "hex");
        return a.create = function () {
          return new P(e, t, e);
        }, a.update = function (e) {
          return a.create().update(e);
        }, D(a, A, e, t);
      }, S = [{
        name: "keccak",
        padding: [1, 256, 65536, 16777216],
        bits: y,
        createMethod: C
      }, {
        name: "sha3",
        padding: [6, 1536, 393216, 100663296],
        bits: y,
        createMethod: C
      }, {
        name: "shake",
        padding: [31, 7936, 2031616, 520093696],
        bits: v,
        createMethod: function createMethod(e, t) {
          var a = w(e, t, "hex");
          return a.create = function (a) {
            return new P(e, t, a);
          }, a.update = function (e, t) {
            return a.create(t).update(e);
          }, D(a, w, e, t);
        }
      }, {
        name: "cshake",
        padding: p,
        bits: v,
        createMethod: function createMethod(e, t) {
          var a = g[e],
              r = T(e, 0, "hex");
          return r.create = function (r, n, s) {
            return n || s ? new P(e, t, r).bytepad([n, s], a) : E["shake" + e].create(r);
          }, r.update = function (e, t, a, n) {
            return r.create(t, a, n).update(e);
          }, D(r, T, e, t);
        }
      }, {
        name: "kmac",
        padding: p,
        bits: v,
        createMethod: function createMethod(e, t) {
          var a = g[e],
              r = x(e, 0, "hex");
          return r.create = function (r, n, s) {
            return new L(e, t, n).bytepad(["KMAC", s], a).bytepad([r], a);
          }, r.update = function (e, t, a, n) {
            return r.create(e, a, n).update(t);
          }, D(r, x, e, t);
        }
      }], E = {}, B = [], k = 0; k < S.length; ++k) {
        for (var R = S[k], W = R.bits, I = 0; I < W.length; ++I) {
          var N = R.name + "_" + W[I];

          if (B.push(N), E[N] = R.createMethod(W[I], R.padding), "sha3" !== R.name) {
            var M = R.name + W[I];
            B.push(M), E[M] = E[N];
          }
        }
      }

      function P(e, t, a) {
        this.blocks = [], this.s = [], this.padding = t, this.outputBits = a, this.reset = !0, this.finalized = !1, this.block = 0, this.start = 0, this.blockCount = 1600 - (e << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = a >> 5, this.extraBytes = (31 & a) >> 3;

        for (var r = 0; r < 50; ++r) {
          this.s[r] = 0;
        }
      }

      function L(e, t, a) {
        P.call(this, e, t, a);
      }

      P.prototype.update = function (e) {
        if (!this.finalized) {
          var t,
              a = typeof e;

          if ("string" !== a) {
            if ("object" !== a) throw o;
            if (null === e) throw o;
            if (l && e.constructor === ArrayBuffer) e = new Uint8Array(e);else if (!(Array.isArray(e) || l && ArrayBuffer.isView(e))) throw o;
            t = !0;
          }

          for (var r, n, s = this.blocks, i = this.byteCount, c = e.length, u = this.blockCount, d = 0, f = this.s; d < c;) {
            if (this.reset) for (this.reset = !1, s[0] = this.block, r = 1; r < u + 1; ++r) {
              s[r] = 0;
            }
            if (t) for (r = this.start; d < c && r < i; ++d) {
              s[r >> 2] |= e[d] << b[3 & r++];
            } else for (r = this.start; d < c && r < i; ++d) {
              (n = e.charCodeAt(d)) < 128 ? s[r >> 2] |= n << b[3 & r++] : n < 2048 ? (s[r >> 2] |= (192 | n >> 6) << b[3 & r++], s[r >> 2] |= (128 | 63 & n) << b[3 & r++]) : n < 55296 || n >= 57344 ? (s[r >> 2] |= (224 | n >> 12) << b[3 & r++], s[r >> 2] |= (128 | n >> 6 & 63) << b[3 & r++], s[r >> 2] |= (128 | 63 & n) << b[3 & r++]) : (n = 65536 + ((1023 & n) << 10 | 1023 & e.charCodeAt(++d)), s[r >> 2] |= (240 | n >> 18) << b[3 & r++], s[r >> 2] |= (128 | n >> 12 & 63) << b[3 & r++], s[r >> 2] |= (128 | n >> 6 & 63) << b[3 & r++], s[r >> 2] |= (128 | 63 & n) << b[3 & r++]);
            }

            if (this.lastByteIndex = r, r >= i) {
              for (this.start = r - i, this.block = s[u], r = 0; r < u; ++r) {
                f[r] ^= s[r];
              }

              O(f), this.reset = !0;
            } else this.start = r;
          }

          return this;
        }
      }, P.prototype.encode = function (e, t) {
        var a = 255 & e,
            r = 1,
            n = [a];

        for (a = 255 & (e >>= 8); a > 0;) {
          n.unshift(a), a = 255 & (e >>= 8), ++r;
        }

        return t ? n.push(r) : n.unshift(r), this.update(n), n.length;
      }, P.prototype.encodeString = function (e) {
        var t,
            a = typeof e;

        if ("string" !== a) {
          if ("object" !== a) throw o;
          if (null === e) throw o;
          if (l && e.constructor === ArrayBuffer) e = new Uint8Array(e);else if (!(Array.isArray(e) || l && ArrayBuffer.isView(e))) throw o;
          t = !0;
        }

        var r = 0,
            n = e.length;
        if (t) r = n;else for (var s = 0; s < e.length; ++s) {
          var i = e.charCodeAt(s);
          i < 128 ? r += 1 : i < 2048 ? r += 2 : i < 55296 || i >= 57344 ? r += 3 : (i = 65536 + ((1023 & i) << 10 | 1023 & e.charCodeAt(++s)), r += 4);
        }
        return r += this.encode(8 * r), this.update(e), r;
      }, P.prototype.bytepad = function (e, t) {
        for (var a = this.encode(t), r = 0; r < e.length; ++r) {
          a += this.encodeString(e[r]);
        }

        var n = t - a % t,
            s = [];
        return s.length = n, this.update(s), this;
      }, P.prototype.finalize = function () {
        if (!this.finalized) {
          this.finalized = !0;
          var e = this.blocks,
              t = this.lastByteIndex,
              a = this.blockCount,
              r = this.s;
          if (e[t >> 2] |= this.padding[3 & t], this.lastByteIndex === this.byteCount) for (e[0] = e[a], t = 1; t < a + 1; ++t) {
            e[t] = 0;
          }

          for (e[a - 1] |= 2147483648, t = 0; t < a; ++t) {
            r[t] ^= e[t];
          }

          O(r);
        }
      }, P.prototype.toString = P.prototype.hex = function () {
        this.finalize();

        for (var e, t = this.blockCount, a = this.s, r = this.outputBlocks, n = this.extraBytes, s = 0, o = 0, i = ""; o < r;) {
          for (s = 0; s < t && o < r; ++s, ++o) {
            e = a[s], i += h[e >> 4 & 15] + h[15 & e] + h[e >> 12 & 15] + h[e >> 8 & 15] + h[e >> 20 & 15] + h[e >> 16 & 15] + h[e >> 28 & 15] + h[e >> 24 & 15];
          }

          o % t == 0 && (O(a), s = 0);
        }

        return n && (e = a[s], i += h[e >> 4 & 15] + h[15 & e], n > 1 && (i += h[e >> 12 & 15] + h[e >> 8 & 15]), n > 2 && (i += h[e >> 20 & 15] + h[e >> 16 & 15])), i;
      }, P.prototype.arrayBuffer = function () {
        this.finalize();
        var e,
            t = this.blockCount,
            a = this.s,
            r = this.outputBlocks,
            n = this.extraBytes,
            s = 0,
            o = 0,
            i = this.outputBits >> 3;
        e = n ? new ArrayBuffer(r + 1 << 2) : new ArrayBuffer(i);

        for (var c = new Uint32Array(e); o < r;) {
          for (s = 0; s < t && o < r; ++s, ++o) {
            c[o] = a[s];
          }

          o % t == 0 && O(a);
        }

        return n && (c[s] = a[s], e = e.slice(0, i)), e;
      }, P.prototype.buffer = P.prototype.arrayBuffer, P.prototype.digest = P.prototype.array = function () {
        this.finalize();

        for (var e, t, a = this.blockCount, r = this.s, n = this.outputBlocks, s = this.extraBytes, o = 0, i = 0, c = []; i < n;) {
          for (o = 0; o < a && i < n; ++o, ++i) {
            e = i << 2, t = r[o], c[e] = 255 & t, c[e + 1] = t >> 8 & 255, c[e + 2] = t >> 16 & 255, c[e + 3] = t >> 24 & 255;
          }

          i % a == 0 && O(r);
        }

        return s && (e = i << 2, t = r[o], c[e] = 255 & t, s > 1 && (c[e + 1] = t >> 8 & 255), s > 2 && (c[e + 2] = t >> 16 & 255)), c;
      }, L.prototype = new P(), L.prototype.finalize = function () {
        return this.encode(this.outputBits, !0), P.prototype.finalize.call(this);
      };

      var O = function O(e) {
        var t, a, r, n, s, o, i, c, u, d, f, l, h, p, b, y, v, _, g, A, w, T, x, D, C, S, E, B, k, R, W, I, N, M, P, L, O, F, j, G, V, U, H, z, K, q, Y, Z, J, X, $, Q, ee, te, ae, re, ne, se, oe, ie, ce, ue, de;

        for (r = 0; r < 48; r += 2) {
          n = e[0] ^ e[10] ^ e[20] ^ e[30] ^ e[40], s = e[1] ^ e[11] ^ e[21] ^ e[31] ^ e[41], o = e[2] ^ e[12] ^ e[22] ^ e[32] ^ e[42], i = e[3] ^ e[13] ^ e[23] ^ e[33] ^ e[43], c = e[4] ^ e[14] ^ e[24] ^ e[34] ^ e[44], u = e[5] ^ e[15] ^ e[25] ^ e[35] ^ e[45], d = e[6] ^ e[16] ^ e[26] ^ e[36] ^ e[46], f = e[7] ^ e[17] ^ e[27] ^ e[37] ^ e[47], t = (l = e[8] ^ e[18] ^ e[28] ^ e[38] ^ e[48]) ^ (o << 1 | i >>> 31), a = (h = e[9] ^ e[19] ^ e[29] ^ e[39] ^ e[49]) ^ (i << 1 | o >>> 31), e[0] ^= t, e[1] ^= a, e[10] ^= t, e[11] ^= a, e[20] ^= t, e[21] ^= a, e[30] ^= t, e[31] ^= a, e[40] ^= t, e[41] ^= a, t = n ^ (c << 1 | u >>> 31), a = s ^ (u << 1 | c >>> 31), e[2] ^= t, e[3] ^= a, e[12] ^= t, e[13] ^= a, e[22] ^= t, e[23] ^= a, e[32] ^= t, e[33] ^= a, e[42] ^= t, e[43] ^= a, t = o ^ (d << 1 | f >>> 31), a = i ^ (f << 1 | d >>> 31), e[4] ^= t, e[5] ^= a, e[14] ^= t, e[15] ^= a, e[24] ^= t, e[25] ^= a, e[34] ^= t, e[35] ^= a, e[44] ^= t, e[45] ^= a, t = c ^ (l << 1 | h >>> 31), a = u ^ (h << 1 | l >>> 31), e[6] ^= t, e[7] ^= a, e[16] ^= t, e[17] ^= a, e[26] ^= t, e[27] ^= a, e[36] ^= t, e[37] ^= a, e[46] ^= t, e[47] ^= a, t = d ^ (n << 1 | s >>> 31), a = f ^ (s << 1 | n >>> 31), e[8] ^= t, e[9] ^= a, e[18] ^= t, e[19] ^= a, e[28] ^= t, e[29] ^= a, e[38] ^= t, e[39] ^= a, e[48] ^= t, e[49] ^= a, p = e[0], b = e[1], q = e[11] << 4 | e[10] >>> 28, Y = e[10] << 4 | e[11] >>> 28, B = e[20] << 3 | e[21] >>> 29, k = e[21] << 3 | e[20] >>> 29, ie = e[31] << 9 | e[30] >>> 23, ce = e[30] << 9 | e[31] >>> 23, U = e[40] << 18 | e[41] >>> 14, H = e[41] << 18 | e[40] >>> 14, M = e[2] << 1 | e[3] >>> 31, P = e[3] << 1 | e[2] >>> 31, y = e[13] << 12 | e[12] >>> 20, v = e[12] << 12 | e[13] >>> 20, Z = e[22] << 10 | e[23] >>> 22, J = e[23] << 10 | e[22] >>> 22, R = e[33] << 13 | e[32] >>> 19, W = e[32] << 13 | e[33] >>> 19, ue = e[42] << 2 | e[43] >>> 30, de = e[43] << 2 | e[42] >>> 30, te = e[5] << 30 | e[4] >>> 2, ae = e[4] << 30 | e[5] >>> 2, L = e[14] << 6 | e[15] >>> 26, O = e[15] << 6 | e[14] >>> 26, _ = e[25] << 11 | e[24] >>> 21, g = e[24] << 11 | e[25] >>> 21, X = e[34] << 15 | e[35] >>> 17, $ = e[35] << 15 | e[34] >>> 17, I = e[45] << 29 | e[44] >>> 3, N = e[44] << 29 | e[45] >>> 3, D = e[6] << 28 | e[7] >>> 4, C = e[7] << 28 | e[6] >>> 4, re = e[17] << 23 | e[16] >>> 9, ne = e[16] << 23 | e[17] >>> 9, F = e[26] << 25 | e[27] >>> 7, j = e[27] << 25 | e[26] >>> 7, A = e[36] << 21 | e[37] >>> 11, w = e[37] << 21 | e[36] >>> 11, Q = e[47] << 24 | e[46] >>> 8, ee = e[46] << 24 | e[47] >>> 8, z = e[8] << 27 | e[9] >>> 5, K = e[9] << 27 | e[8] >>> 5, S = e[18] << 20 | e[19] >>> 12, E = e[19] << 20 | e[18] >>> 12, se = e[29] << 7 | e[28] >>> 25, oe = e[28] << 7 | e[29] >>> 25, G = e[38] << 8 | e[39] >>> 24, V = e[39] << 8 | e[38] >>> 24, T = e[48] << 14 | e[49] >>> 18, x = e[49] << 14 | e[48] >>> 18, e[0] = p ^ ~y & _, e[1] = b ^ ~v & g, e[10] = D ^ ~S & B, e[11] = C ^ ~E & k, e[20] = M ^ ~L & F, e[21] = P ^ ~O & j, e[30] = z ^ ~q & Z, e[31] = K ^ ~Y & J, e[40] = te ^ ~re & se, e[41] = ae ^ ~ne & oe, e[2] = y ^ ~_ & A, e[3] = v ^ ~g & w, e[12] = S ^ ~B & R, e[13] = E ^ ~k & W, e[22] = L ^ ~F & G, e[23] = O ^ ~j & V, e[32] = q ^ ~Z & X, e[33] = Y ^ ~J & $, e[42] = re ^ ~se & ie, e[43] = ne ^ ~oe & ce, e[4] = _ ^ ~A & T, e[5] = g ^ ~w & x, e[14] = B ^ ~R & I, e[15] = k ^ ~W & N, e[24] = F ^ ~G & U, e[25] = j ^ ~V & H, e[34] = Z ^ ~X & Q, e[35] = J ^ ~$ & ee, e[44] = se ^ ~ie & ue, e[45] = oe ^ ~ce & de, e[6] = A ^ ~T & p, e[7] = w ^ ~x & b, e[16] = R ^ ~I & D, e[17] = W ^ ~N & C, e[26] = G ^ ~U & M, e[27] = V ^ ~H & P, e[36] = X ^ ~Q & z, e[37] = $ ^ ~ee & K, e[46] = ie ^ ~ue & te, e[47] = ce ^ ~de & ae, e[8] = T ^ ~p & y, e[9] = x ^ ~b & v, e[18] = I ^ ~D & S, e[19] = N ^ ~C & E, e[28] = U ^ ~M & L, e[29] = H ^ ~P & O, e[38] = Q ^ ~z & q, e[39] = ee ^ ~K & Y, e[48] = ue ^ ~te & re, e[49] = de ^ ~ae & ne, e[0] ^= m[r], e[1] ^= m[r + 1];
        }
      };

      if (d) e.exports = E;else {
        for (k = 0; k < B.length; ++k) {
          c[B[k]] = E[B[k]];
        }

        f && (void 0 === (s = function () {
          return E;
        }.call(t, a, t, e)) || (e.exports = s));
      }
    }();
  }).call(this, a(
  /*! ./../../../../../process/browser.js */
  9), a(
  /*! ./../../../../../webpack/buildin/global.js */
  18));
},
/*!**********************************************!*\
  !*** ./node_modules/uuid/lib/rng-browser.js ***!
  \**********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  var a = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof window.msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto);

  if (a) {
    var r = new Uint8Array(16);

    e.exports = function () {
      return a(r), r;
    };
  } else {
    var n = new Array(16);

    e.exports = function () {
      for (var e, t = 0; t < 16; t++) {
        0 == (3 & t) && (e = 4294967296 * Math.random()), n[t] = e >>> ((3 & t) << 3) & 255;
      }

      return n;
    };
  }
},
/*!**********************************************!*\
  !*** ./node_modules/uuid/lib/bytesToUuid.js ***!
  \**********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {
  for (var a = [], r = 0; r < 256; ++r) {
    a[r] = (r + 256).toString(16).substr(1);
  }

  e.exports = function (e, t) {
    var r = t || 0,
        n = a;
    return [n[e[r++]], n[e[r++]], n[e[r++]], n[e[r++]], "-", n[e[r++]], n[e[r++]], "-", n[e[r++]], n[e[r++]], "-", n[e[r++]], n[e[r++]], "-", n[e[r++]], n[e[r++]], n[e[r++]], n[e[r++]], n[e[r++]], n[e[r++]]].join("");
  };
},
/*!*******************************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/blacklist_transfer_manager.js ***!
  \*******************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r70,
      n = this && this.__extends || (_r70 = function r(e, t) {
    return (_r70 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r70(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      c = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || 0 < t--) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u,
      d = a(
  /*! @0x/base-contract */
  12),
      f = a(
  /*! @0x/json-schemas */
  2),
      l = a(
  /*! @0x/utils */
  8),
      h = a(
  /*! @0x/web3-wrapper */
  11),
      p = a(
  /*! @0x/assert */
  10),
      b = a(
  /*! ../../PolyResponse */
  14),
      m = a(
  /*! lodash */
  0),
      y = a(
  /*! ethers */
  13);
  (u = t.BlacklistTransferManagerEvents_3_0_0 || (t.BlacklistTransferManagerEvents_3_0_0 = {})).AddBlacklistType = "AddBlacklistType", u.ModifyBlacklistType = "ModifyBlacklistType", u.DeleteBlacklistType = "DeleteBlacklistType", u.AddInvestorToBlacklist = "AddInvestorToBlacklist", u.DeleteInvestorFromBlacklist = "DeleteInvestorFromBlacklist", u.Pause = "Pause", u.Unpause = "Unpause";

  var v = function (e) {
    function t(a, r, n, c) {
      var u = e.call(this, "BlacklistTransferManager", t.ABI(), a, r, n) || this;
      return u.reclaimETH = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.reclaimETH.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("reclaimETH()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("reclaimETH()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("reclaimETH()", []);
        }
      }, u.blacklists = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("blacklists(bytes32)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("blacklists(bytes32)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("index_0", e), this._strictEncodeArguments("blacklists(bytes32)", [e]);
        }
      }, u.ADMIN = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("ADMIN()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("ADMIN()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("ADMIN()", []);
        }
      }, u.unpause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.unpause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("unpause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("unpause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("unpause()", []);
        }
      }, u.paused = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("paused()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("paused()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("paused()", []);
        }
      }, u.UNLOCKED = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("UNLOCKED()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("UNLOCKED()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("UNLOCKED()", []);
        }
      }, u.polyToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("polyToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("polyToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("polyToken()", []);
        }
      }, u.pause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.pause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pause()", []);
        }
      }, u.reclaimERC20 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.reclaimERC20.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("reclaimERC20(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_tokenContract", e), this._strictEncodeArguments("reclaimERC20(address)", [e]);
        }
      }, u.OPERATOR = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("OPERATOR()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("OPERATOR()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("OPERATOR()", []);
        }
      }, u.LOCKED = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("LOCKED()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("LOCKED()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("LOCKED()", []);
        }
      }, u.securityToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("securityToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("securityToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("securityToken()", []);
        }
      }, u.factory = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("factory()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("factory()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("factory()", []);
        }
      }, u.getDataStore = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDataStore()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDataStore()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDataStore()", []);
        }
      }, u.getInitFunction = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getInitFunction()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getInitFunction()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getInitFunction()", []);
        }
      }, u.executeTransfer = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("index_1", t), p.assert.isBigNumber("index_2", a), p.assert.isString("index_3", r), u = (o = this)._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.executeTransfer.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("index_1", t), p.assert.isBigNumber("index_2", a), p.assert.isString("index_3", r), u = (o = this)._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("index_1", t), p.assert.isBigNumber("index_2", a), p.assert.isString("index_3", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("executeTransfer(address,address,uint256,bytes)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isString("_from", e), p.assert.isString("index_1", t), p.assert.isBigNumber("index_2", a), p.assert.isString("index_3", r), this._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]);
        }
      }, u.verifyTransfer = {
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("index_1", t), p.assert.isBigNumber("index_2", a), p.assert.isString("index_3", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("verifyTransfer(address,address,uint256,bytes)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("verifyTransfer(address,address,uint256,bytes)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isString("_from", e), p.assert.isString("index_1", t), p.assert.isBigNumber("index_2", a), p.assert.isString("index_3", r), this._strictEncodeArguments("verifyTransfer(address,address,uint256,bytes)", [e, t, a, r]);
        }
      }, u.addBlacklistType = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), p.assert.isString("_blacklistName", a), p.assert.isBigNumber("_repeatPeriodTime", r), u = (o = this)._strictEncodeArguments("addBlacklistType(uint256,uint256,bytes32,uint256)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.addBlacklistType.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), p.assert.isString("_blacklistName", a), p.assert.isBigNumber("_repeatPeriodTime", r), u = (o = this)._strictEncodeArguments("addBlacklistType(uint256,uint256,bytes32,uint256)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), p.assert.isString("_blacklistName", a), p.assert.isBigNumber("_repeatPeriodTime", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("addBlacklistType(uint256,uint256,bytes32,uint256)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("addBlacklistType(uint256,uint256,bytes32,uint256)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), p.assert.isString("_blacklistName", a), p.assert.isBigNumber("_repeatPeriodTime", r), this._strictEncodeArguments("addBlacklistType(uint256,uint256,bytes32,uint256)", [e, t, a, r]);
        }
      }, u.addBlacklistTypeMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_startTimes", e), p.assert.isArray("_endTimes", t), p.assert.isArray("_blacklistNames", a), p.assert.isArray("_repeatPeriodTimes", r), u = (o = this)._strictEncodeArguments("addBlacklistTypeMulti(uint256[],uint256[],bytes32[],uint256[])", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.addBlacklistTypeMulti.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_startTimes", e), p.assert.isArray("_endTimes", t), p.assert.isArray("_blacklistNames", a), p.assert.isArray("_repeatPeriodTimes", r), u = (o = this)._strictEncodeArguments("addBlacklistTypeMulti(uint256[],uint256[],bytes32[],uint256[])", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_startTimes", e), p.assert.isArray("_endTimes", t), p.assert.isArray("_blacklistNames", a), p.assert.isArray("_repeatPeriodTimes", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("addBlacklistTypeMulti(uint256[],uint256[],bytes32[],uint256[])", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("addBlacklistTypeMulti(uint256[],uint256[],bytes32[],uint256[])").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isArray("_startTimes", e), p.assert.isArray("_endTimes", t), p.assert.isArray("_blacklistNames", a), p.assert.isArray("_repeatPeriodTimes", r), this._strictEncodeArguments("addBlacklistTypeMulti(uint256[],uint256[],bytes32[],uint256[])", [e, t, a, r]);
        }
      }, u.modifyBlacklistType = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), p.assert.isString("_blacklistName", a), p.assert.isBigNumber("_repeatPeriodTime", r), u = (o = this)._strictEncodeArguments("modifyBlacklistType(uint256,uint256,bytes32,uint256)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.modifyBlacklistType.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), p.assert.isString("_blacklistName", a), p.assert.isBigNumber("_repeatPeriodTime", r), u = (o = this)._strictEncodeArguments("modifyBlacklistType(uint256,uint256,bytes32,uint256)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), p.assert.isString("_blacklistName", a), p.assert.isBigNumber("_repeatPeriodTime", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("modifyBlacklistType(uint256,uint256,bytes32,uint256)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("modifyBlacklistType(uint256,uint256,bytes32,uint256)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), p.assert.isString("_blacklistName", a), p.assert.isBigNumber("_repeatPeriodTime", r), this._strictEncodeArguments("modifyBlacklistType(uint256,uint256,bytes32,uint256)", [e, t, a, r]);
        }
      }, u.modifyBlacklistTypeMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_startTimes", e), p.assert.isArray("_endTimes", t), p.assert.isArray("_blacklistNames", a), p.assert.isArray("_repeatPeriodTimes", r), u = (o = this)._strictEncodeArguments("modifyBlacklistTypeMulti(uint256[],uint256[],bytes32[],uint256[])", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.modifyBlacklistTypeMulti.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_startTimes", e), p.assert.isArray("_endTimes", t), p.assert.isArray("_blacklistNames", a), p.assert.isArray("_repeatPeriodTimes", r), u = (o = this)._strictEncodeArguments("modifyBlacklistTypeMulti(uint256[],uint256[],bytes32[],uint256[])", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_startTimes", e), p.assert.isArray("_endTimes", t), p.assert.isArray("_blacklistNames", a), p.assert.isArray("_repeatPeriodTimes", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("modifyBlacklistTypeMulti(uint256[],uint256[],bytes32[],uint256[])", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("modifyBlacklistTypeMulti(uint256[],uint256[],bytes32[],uint256[])").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isArray("_startTimes", e), p.assert.isArray("_endTimes", t), p.assert.isArray("_blacklistNames", a), p.assert.isArray("_repeatPeriodTimes", r), this._strictEncodeArguments("modifyBlacklistTypeMulti(uint256[],uint256[],bytes32[],uint256[])", [e, t, a, r]);
        }
      }, u.deleteBlacklistType = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_blacklistName", e), n = (r = this)._strictEncodeArguments("deleteBlacklistType(bytes32)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.deleteBlacklistType.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_blacklistName", e), n = (r = this)._strictEncodeArguments("deleteBlacklistType(bytes32)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_blacklistName", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("deleteBlacklistType(bytes32)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("deleteBlacklistType(bytes32)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_blacklistName", e), this._strictEncodeArguments("deleteBlacklistType(bytes32)", [e]);
        }
      }, u.deleteBlacklistTypeMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_blacklistNames", e), n = (r = this)._strictEncodeArguments("deleteBlacklistTypeMulti(bytes32[])", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.deleteBlacklistTypeMulti.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_blacklistNames", e), n = (r = this)._strictEncodeArguments("deleteBlacklistTypeMulti(bytes32[])", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_blacklistNames", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("deleteBlacklistTypeMulti(bytes32[])", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("deleteBlacklistTypeMulti(bytes32[])").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isArray("_blacklistNames", e), this._strictEncodeArguments("deleteBlacklistTypeMulti(bytes32[])", [e]);
        }
      }, u.addInvestorToBlacklist = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.isString("_blacklistName", t), o = (n = this)._strictEncodeArguments("addInvestorToBlacklist(address,bytes32)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.addInvestorToBlacklist.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.isString("_blacklistName", t), o = (n = this)._strictEncodeArguments("addInvestorToBlacklist(address,bytes32)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.isString("_blacklistName", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("addInvestorToBlacklist(address,bytes32)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("addInvestorToBlacklist(address,bytes32)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_investor", e), p.assert.isString("_blacklistName", t), this._strictEncodeArguments("addInvestorToBlacklist(address,bytes32)", [e, t]);
        }
      }, u.addInvestorToBlacklistMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isString("_blacklistName", t), o = (n = this)._strictEncodeArguments("addInvestorToBlacklistMulti(address[],bytes32)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.addInvestorToBlacklistMulti.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isString("_blacklistName", t), o = (n = this)._strictEncodeArguments("addInvestorToBlacklistMulti(address[],bytes32)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isString("_blacklistName", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("addInvestorToBlacklistMulti(address[],bytes32)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("addInvestorToBlacklistMulti(address[],bytes32)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isArray("_investors", e), p.assert.isString("_blacklistName", t), this._strictEncodeArguments("addInvestorToBlacklistMulti(address[],bytes32)", [e, t]);
        }
      }, u.addMultiInvestorToBlacklistMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isArray("_blacklistNames", t), o = (n = this)._strictEncodeArguments("addMultiInvestorToBlacklistMulti(address[],bytes32[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.addMultiInvestorToBlacklistMulti.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isArray("_blacklistNames", t), o = (n = this)._strictEncodeArguments("addMultiInvestorToBlacklistMulti(address[],bytes32[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isArray("_blacklistNames", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("addMultiInvestorToBlacklistMulti(address[],bytes32[])", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("addMultiInvestorToBlacklistMulti(address[],bytes32[])").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isArray("_investors", e), p.assert.isArray("_blacklistNames", t), this._strictEncodeArguments("addMultiInvestorToBlacklistMulti(address[],bytes32[])", [e, t]);
        }
      }, u.addInvestorToNewBlacklist = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), p.assert.isString("_blacklistName", a), p.assert.isBigNumber("_repeatPeriodTime", r), p.assert.isString("_investor", n), f = (o = this)._strictEncodeArguments("addInvestorToNewBlacklist(uint256,uint256,bytes32,uint256,address)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: f
                  }), s({
                    from: h
                  }, l), o.addInvestorToNewBlacklist.estimateGasAsync.bind(o, e, t, a, r, n, u))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(m)];

                case 3:
                  return y = i.sent(), v = o._web3Wrapper.awaitTransactionSuccessAsync(y), [2, new b.PolyResponse(y, v)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), p.assert.isString("_blacklistName", a), p.assert.isBigNumber("_repeatPeriodTime", r), p.assert.isString("_investor", n), f = (o = this)._strictEncodeArguments("addInvestorToNewBlacklist(uint256,uint256,bytes32,uint256,address)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: f
                  }), s({
                    from: h
                  }, l))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(b)];

                case 3:
                  return m = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return y = i.sent().gasLimit, v = void 0 === c ? o._defaultEstimateGasFactor : c, _ = Math.round(v * m), [2, y < _ ? y : _];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u) {
          return void 0 === c && (c = {}), o(this, void 0, void 0, function () {
            var o, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), p.assert.isString("_blacklistName", a), p.assert.isBigNumber("_repeatPeriodTime", r), p.assert.isString("_investor", n), p.assert.doesConformToSchema("callData", c, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== u && p.assert.isBlockParam("defaultBlock", u), l = (o = this)._strictEncodeArguments("addInvestorToNewBlacklist(uint256,uint256,bytes32,uint256,address)", [e, t, a, r, n]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: l
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (h = i.sent()).from = h.from ? h.from.toLowerCase() : h.from, [4, o._web3Wrapper.callAsync(h, u)];

                case 2:
                  return b = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(b), [2, o._lookupAbiEncoder("addInvestorToNewBlacklist(uint256,uint256,bytes32,uint256,address)").strictDecodeReturnValue(b)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n) {
          return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), p.assert.isString("_blacklistName", a), p.assert.isBigNumber("_repeatPeriodTime", r), p.assert.isString("_investor", n), this._strictEncodeArguments("addInvestorToNewBlacklist(uint256,uint256,bytes32,uint256,address)", [e, t, a, r, n]);
        }
      }, u.deleteInvestorFromBlacklist = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.isString("_blacklistName", t), o = (n = this)._strictEncodeArguments("deleteInvestorFromBlacklist(address,bytes32)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.deleteInvestorFromBlacklist.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.isString("_blacklistName", t), o = (n = this)._strictEncodeArguments("deleteInvestorFromBlacklist(address,bytes32)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.isString("_blacklistName", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("deleteInvestorFromBlacklist(address,bytes32)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("deleteInvestorFromBlacklist(address,bytes32)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_investor", e), p.assert.isString("_blacklistName", t), this._strictEncodeArguments("deleteInvestorFromBlacklist(address,bytes32)", [e, t]);
        }
      }, u.deleteInvestorFromAllBlacklist = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), n = (r = this)._strictEncodeArguments("deleteInvestorFromAllBlacklist(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.deleteInvestorFromAllBlacklist.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), n = (r = this)._strictEncodeArguments("deleteInvestorFromAllBlacklist(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("deleteInvestorFromAllBlacklist(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("deleteInvestorFromAllBlacklist(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_investor", e), this._strictEncodeArguments("deleteInvestorFromAllBlacklist(address)", [e]);
        }
      }, u.deleteInvestorFromAllBlacklistMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investor", e), n = (r = this)._strictEncodeArguments("deleteInvestorFromAllBlacklistMulti(address[])", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.deleteInvestorFromAllBlacklistMulti.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investor", e), n = (r = this)._strictEncodeArguments("deleteInvestorFromAllBlacklistMulti(address[])", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investor", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("deleteInvestorFromAllBlacklistMulti(address[])", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("deleteInvestorFromAllBlacklistMulti(address[])").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isArray("_investor", e), this._strictEncodeArguments("deleteInvestorFromAllBlacklistMulti(address[])", [e]);
        }
      }, u.deleteMultiInvestorsFromBlacklistMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isArray("_blacklistNames", t), o = (n = this)._strictEncodeArguments("deleteMultiInvestorsFromBlacklistMulti(address[],bytes32[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.deleteMultiInvestorsFromBlacklistMulti.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isArray("_blacklistNames", t), o = (n = this)._strictEncodeArguments("deleteMultiInvestorsFromBlacklistMulti(address[],bytes32[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isArray("_blacklistNames", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("deleteMultiInvestorsFromBlacklistMulti(address[],bytes32[])", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("deleteMultiInvestorsFromBlacklistMulti(address[],bytes32[])").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isArray("_investors", e), p.assert.isArray("_blacklistNames", t), this._strictEncodeArguments("deleteMultiInvestorsFromBlacklistMulti(address[],bytes32[])", [e, t]);
        }
      }, u.getListOfAddresses = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_blacklistName", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getListOfAddresses(bytes32)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getListOfAddresses(bytes32)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_blacklistName", e), this._strictEncodeArguments("getListOfAddresses(bytes32)", [e]);
        }
      }, u.getBlacklistNamesToUser = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_user", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getBlacklistNamesToUser(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getBlacklistNamesToUser(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_user", e), this._strictEncodeArguments("getBlacklistNamesToUser(address)", [e]);
        }
      }, u.getAllBlacklists = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getAllBlacklists()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getAllBlacklists()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getAllBlacklists()", []);
        }
      }, u.getTokensByPartition = {
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_partition", e), p.assert.isString("_tokenHolder", t), p.assert.isBigNumber("_additionalBalance", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("getTokensByPartition(bytes32,address,uint256)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("getTokensByPartition(bytes32,address,uint256)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isString("_partition", e), p.assert.isString("_tokenHolder", t), p.assert.isBigNumber("_additionalBalance", a), this._strictEncodeArguments("getTokensByPartition(bytes32,address,uint256)", [e, t, a]);
        }
      }, u.getPermissions = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getPermissions()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getPermissions()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getPermissions()", []);
        }
      }, u._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, l.classUtils.bindAll(u, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), u;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n, s, u) {
      return o(this, void 0, void 0, function () {
        var o, b, m, v, _, g, A, w, T, x, D;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return p.assert.isHexString("bytecode", e), p.assert.doesConformToSchema("txDefaults", n, f.schemas.txDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), o = l.providerUtils.standardizeOrThrow(r), b = d.BaseContract._lookupConstructorAbi(a), D = c(d.BaseContract._formatABIDataItemList(b.inputs, [s, u], d.BaseContract._bigNumberToString), 2), s = D[0], u = D[1], m = new y.utils.Interface(a), v = m.deployFunction, _ = v.encode(e, [s, u]), g = new h.Web3Wrapper(o), [4, d.BaseContract._applyDefaultsToTxDataAsync({
                data: _
              }, n, g.estimateGasAsync.bind(g))];

            case 1:
              return A = i.sent(), [4, g.sendTransactionAsync(A)];

            case 2:
              return w = i.sent(), l.logUtils.log("transactionHash: " + w), [4, g.awaitTransactionSuccessAsync(w)];

            case 3:
              return T = i.sent(), l.logUtils.log("BlacklistTransferManager successfully deployed at " + T.contractAddress), (x = new t(T.contractAddress, o, n)).constructorArgs = [s, u], [2, x];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !1,
        inputs: [],
        name: "reclaimETH",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "bytes32"
        }],
        name: "blacklists",
        outputs: [{
          name: "startTime",
          type: "uint256"
        }, {
          name: "endTime",
          type: "uint256"
        }, {
          name: "repeatPeriodTime",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "ADMIN",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "unpause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "paused",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "UNLOCKED",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "polyToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "pause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenContract",
          type: "address"
        }],
        name: "reclaimERC20",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "OPERATOR",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "LOCKED",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "securityToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "factory",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDataStore",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        inputs: [{
          name: "_securityToken",
          type: "address"
        }, {
          name: "_polyAddress",
          type: "address"
        }],
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "constructor"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_startTime",
          type: "uint256",
          indexed: !1
        }, {
          name: "_endTime",
          type: "uint256",
          indexed: !1
        }, {
          name: "_blacklistName",
          type: "bytes32",
          indexed: !1
        }, {
          name: "_repeatPeriodTime",
          type: "uint256",
          indexed: !1
        }],
        name: "AddBlacklistType",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_startTime",
          type: "uint256",
          indexed: !1
        }, {
          name: "_endTime",
          type: "uint256",
          indexed: !1
        }, {
          name: "_blacklistName",
          type: "bytes32",
          indexed: !1
        }, {
          name: "_repeatPeriodTime",
          type: "uint256",
          indexed: !1
        }],
        name: "ModifyBlacklistType",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_blacklistName",
          type: "bytes32",
          indexed: !1
        }],
        name: "DeleteBlacklistType",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_investor",
          type: "address",
          indexed: !0
        }, {
          name: "_blacklistName",
          type: "bytes32",
          indexed: !1
        }],
        name: "AddInvestorToBlacklist",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_investor",
          type: "address",
          indexed: !0
        }, {
          name: "_blacklistName",
          type: "bytes32",
          indexed: !1
        }],
        name: "DeleteInvestorFromBlacklist",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Pause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Unpause",
        outputs: [],
        type: "event"
      }, {
        constant: !0,
        inputs: [],
        name: "getInitFunction",
        outputs: [{
          name: "",
          type: "bytes4"
        }],
        payable: !1,
        stateMutability: "pure",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "index_1",
          type: "address"
        }, {
          name: "index_2",
          type: "uint256"
        }, {
          name: "index_3",
          type: "bytes"
        }],
        name: "executeTransfer",
        outputs: [{
          name: "",
          type: "uint8"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "index_1",
          type: "address"
        }, {
          name: "index_2",
          type: "uint256"
        }, {
          name: "index_3",
          type: "bytes"
        }],
        name: "verifyTransfer",
        outputs: [{
          name: "",
          type: "uint8"
        }, {
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_startTime",
          type: "uint256"
        }, {
          name: "_endTime",
          type: "uint256"
        }, {
          name: "_blacklistName",
          type: "bytes32"
        }, {
          name: "_repeatPeriodTime",
          type: "uint256"
        }],
        name: "addBlacklistType",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_startTimes",
          type: "uint256[]"
        }, {
          name: "_endTimes",
          type: "uint256[]"
        }, {
          name: "_blacklistNames",
          type: "bytes32[]"
        }, {
          name: "_repeatPeriodTimes",
          type: "uint256[]"
        }],
        name: "addBlacklistTypeMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_startTime",
          type: "uint256"
        }, {
          name: "_endTime",
          type: "uint256"
        }, {
          name: "_blacklistName",
          type: "bytes32"
        }, {
          name: "_repeatPeriodTime",
          type: "uint256"
        }],
        name: "modifyBlacklistType",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_startTimes",
          type: "uint256[]"
        }, {
          name: "_endTimes",
          type: "uint256[]"
        }, {
          name: "_blacklistNames",
          type: "bytes32[]"
        }, {
          name: "_repeatPeriodTimes",
          type: "uint256[]"
        }],
        name: "modifyBlacklistTypeMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_blacklistName",
          type: "bytes32"
        }],
        name: "deleteBlacklistType",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_blacklistNames",
          type: "bytes32[]"
        }],
        name: "deleteBlacklistTypeMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_investor",
          type: "address"
        }, {
          name: "_blacklistName",
          type: "bytes32"
        }],
        name: "addInvestorToBlacklist",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_investors",
          type: "address[]"
        }, {
          name: "_blacklistName",
          type: "bytes32"
        }],
        name: "addInvestorToBlacklistMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_investors",
          type: "address[]"
        }, {
          name: "_blacklistNames",
          type: "bytes32[]"
        }],
        name: "addMultiInvestorToBlacklistMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_startTime",
          type: "uint256"
        }, {
          name: "_endTime",
          type: "uint256"
        }, {
          name: "_blacklistName",
          type: "bytes32"
        }, {
          name: "_repeatPeriodTime",
          type: "uint256"
        }, {
          name: "_investor",
          type: "address"
        }],
        name: "addInvestorToNewBlacklist",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_investor",
          type: "address"
        }, {
          name: "_blacklistName",
          type: "bytes32"
        }],
        name: "deleteInvestorFromBlacklist",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_investor",
          type: "address"
        }],
        name: "deleteInvestorFromAllBlacklist",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_investor",
          type: "address[]"
        }],
        name: "deleteInvestorFromAllBlacklistMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_investors",
          type: "address[]"
        }, {
          name: "_blacklistNames",
          type: "bytes32[]"
        }],
        name: "deleteMultiInvestorsFromBlacklistMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_blacklistName",
          type: "bytes32"
        }],
        name: "getListOfAddresses",
        outputs: [{
          name: "",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_user",
          type: "address"
        }],
        name: "getBlacklistNamesToUser",
        outputs: [{
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getAllBlacklists",
        outputs: [{
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_partition",
          type: "bytes32"
        }, {
          name: "_tokenHolder",
          type: "address"
        }, {
          name: "_additionalBalance",
          type: "uint256"
        }],
        name: "getTokensByPartition",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getPermissions",
        outputs: [{
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(d.BaseContract);

  t.BlacklistTransferManagerContract_3_0_0 = v, t.isBlacklistTransferManagerContract_3_0_0 = function (e) {
    return m.isEqual(v.ABI(), e.abi);
  };
},
/*!*****************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/capped_s_t_o.js ***!
  \*****************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r71,
      n = this && this.__extends || (_r71 = function r(e, t) {
    return (_r71 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r71(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      c = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || 0 < t--) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u,
      d = a(
  /*! @0x/base-contract */
  12),
      f = a(
  /*! @0x/json-schemas */
  2),
      l = a(
  /*! @0x/utils */
  8),
      h = a(
  /*! @0x/web3-wrapper */
  11),
      p = a(
  /*! @0x/assert */
  10),
      b = a(
  /*! ../../PolyResponse */
  14),
      m = a(
  /*! lodash */
  0),
      y = a(
  /*! ethers */
  13);
  (u = t.CappedSTOEvents_3_0_0 || (t.CappedSTOEvents_3_0_0 = {})).TokenPurchase = "TokenPurchase", u.SetAllowBeneficialInvestments = "SetAllowBeneficialInvestments", u.Pause = "Pause", u.Unpause = "Unpause", u.SetFundRaiseTypes = "SetFundRaiseTypes";

  var v = function (e) {
    function t(a, r, n, c) {
      var u = e.call(this, "CappedSTO", t.ABI(), a, r, n) || this;
      return u.reclaimETH = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.reclaimETH.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("reclaimETH()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("reclaimETH()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("reclaimETH()", []);
        }
      }, u.ADMIN = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("ADMIN()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("ADMIN()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("ADMIN()", []);
        }
      }, u.rate = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("rate()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("rate()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("rate()", []);
        }
      }, u.allowBeneficialInvestments = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("allowBeneficialInvestments()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("allowBeneficialInvestments()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("allowBeneficialInvestments()", []);
        }
      }, u.endTime = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("endTime()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("endTime()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("endTime()", []);
        }
      }, u.cap = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("cap()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("cap()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("cap()", []);
        }
      }, u.unpause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.unpause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("unpause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("unpause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("unpause()", []);
        }
      }, u.wallet = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("wallet()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("wallet()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("wallet()", []);
        }
      }, u.paused = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("paused()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("paused()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("paused()", []);
        }
      }, u.totalTokensSold = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("totalTokensSold()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("totalTokensSold()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("totalTokensSold()", []);
        }
      }, u.investors = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("investors(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("investors(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("index_0", e), this._strictEncodeArguments("investors(address)", [e]);
        }
      }, u.polyToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("polyToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("polyToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("polyToken()", []);
        }
      }, u.startTime = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("startTime()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("startTime()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("startTime()", []);
        }
      }, u.pause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.pause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pause()", []);
        }
      }, u.reclaimERC20 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.reclaimERC20.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("reclaimERC20(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_tokenContract", e), this._strictEncodeArguments("reclaimERC20(address)", [e]);
        }
      }, u.OPERATOR = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("OPERATOR()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("OPERATOR()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("OPERATOR()", []);
        }
      }, u.getRaised = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_fundRaiseType", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getRaised(uint8)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getRaised(uint8)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isNumberOrBigNumber("_fundRaiseType", e), this._strictEncodeArguments("getRaised(uint8)", [e]);
        }
      }, u.pausedTime = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pausedTime()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pausedTime()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pausedTime()", []);
        }
      }, u.securityToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("securityToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("securityToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("securityToken()", []);
        }
      }, u.factory = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("factory()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("factory()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("factory()", []);
        }
      }, u.fundsRaised = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("fundsRaised(uint8)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("fundsRaised(uint8)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isNumberOrBigNumber("index_0", e), this._strictEncodeArguments("fundsRaised(uint8)", [e]);
        }
      }, u.fundRaiseTypes = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("fundRaiseTypes(uint8)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("fundRaiseTypes(uint8)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isNumberOrBigNumber("index_0", e), this._strictEncodeArguments("fundRaiseTypes(uint8)", [e]);
        }
      }, u.investorCount = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("investorCount()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("investorCount()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("investorCount()", []);
        }
      }, u.getDataStore = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDataStore()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDataStore()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDataStore()", []);
        }
      }, u.configure = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u, f) {
          return o(this, void 0, void 0, function () {
            var o, l, h, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), p.assert.isBigNumber("_cap", a), p.assert.isBigNumber("_rate", r), p.assert.isArray("_fundRaiseTypes", n), p.assert.isString("_fundsReceiver", c), l = (o = this)._strictEncodeArguments("configure(uint256,uint256,uint256,uint256,uint8[],address)", [e, t, a, r, n, c]), h = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return m = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: l
                  }), s({
                    from: m
                  }, h), o.configure.estimateGasAsync.bind(o, e, t, a, r, n, c, f))];

                case 2:
                  return void 0 !== (y = i.sent()).from && (y.from = y.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(y)];

                case 3:
                  return v = i.sent(), _ = o._web3Wrapper.awaitTransactionSuccessAsync(v), [2, new b.PolyResponse(v, _)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u, f) {
          return o(this, void 0, void 0, function () {
            var o, l, h, b, m, y, v, _, g;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), p.assert.isBigNumber("_cap", a), p.assert.isBigNumber("_rate", r), p.assert.isArray("_fundRaiseTypes", n), p.assert.isString("_fundsReceiver", c), l = (o = this)._strictEncodeArguments("configure(uint256,uint256,uint256,uint256,uint8[],address)", [e, t, a, r, n, c]), h = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return b = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, f, {
                    data: l
                  }), s({
                    from: b
                  }, h))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(m)];

                case 3:
                  return y = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return v = i.sent().gasLimit, _ = void 0 === u ? o._defaultEstimateGasFactor : u, g = Math.round(_ * y), [2, v < g ? v : g];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u, l) {
          return void 0 === u && (u = {}), o(this, void 0, void 0, function () {
            var o, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), p.assert.isBigNumber("_cap", a), p.assert.isBigNumber("_rate", r), p.assert.isArray("_fundRaiseTypes", n), p.assert.isString("_fundsReceiver", c), p.assert.doesConformToSchema("callData", u, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== l && p.assert.isBlockParam("defaultBlock", l), h = (o = this)._strictEncodeArguments("configure(uint256,uint256,uint256,uint256,uint8[],address)", [e, t, a, r, n, c]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: h
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (b = i.sent()).from = b.from ? b.from.toLowerCase() : b.from, [4, o._web3Wrapper.callAsync(b, l)];

                case 2:
                  return m = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(m), [2, o._lookupAbiEncoder("configure(uint256,uint256,uint256,uint256,uint8[],address)").strictDecodeReturnValue(m)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s) {
          return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), p.assert.isBigNumber("_cap", a), p.assert.isBigNumber("_rate", r), p.assert.isArray("_fundRaiseTypes", n), p.assert.isString("_fundsReceiver", s), this._strictEncodeArguments("configure(uint256,uint256,uint256,uint256,uint8[],address)", [e, t, a, r, n, s]);
        }
      }, u.getInitFunction = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getInitFunction()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getInitFunction()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getInitFunction()", []);
        }
      }, u.changeAllowBeneficialInvestments = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBoolean("_allowBeneficialInvestments", e), n = (r = this)._strictEncodeArguments("changeAllowBeneficialInvestments(bool)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeAllowBeneficialInvestments.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBoolean("_allowBeneficialInvestments", e), n = (r = this)._strictEncodeArguments("changeAllowBeneficialInvestments(bool)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBoolean("_allowBeneficialInvestments", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeAllowBeneficialInvestments(bool)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeAllowBeneficialInvestments(bool)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBoolean("_allowBeneficialInvestments", e), this._strictEncodeArguments("changeAllowBeneficialInvestments(bool)", [e]);
        }
      }, u.buyTokens = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), n = (r = this)._strictEncodeArguments("buyTokens(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.buyTokens.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), n = (r = this)._strictEncodeArguments("buyTokens(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("buyTokens(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("buyTokens(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_beneficiary", e), this._strictEncodeArguments("buyTokens(address)", [e]);
        }
      }, u.buyTokensWithPoly = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_investedPOLY", e), n = (r = this)._strictEncodeArguments("buyTokensWithPoly(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.buyTokensWithPoly.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_investedPOLY", e), n = (r = this)._strictEncodeArguments("buyTokensWithPoly(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_investedPOLY", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("buyTokensWithPoly(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("buyTokensWithPoly(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_investedPOLY", e), this._strictEncodeArguments("buyTokensWithPoly(uint256)", [e]);
        }
      }, u.capReached = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("capReached()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("capReached()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("capReached()", []);
        }
      }, u.getTokensSold = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getTokensSold()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getTokensSold()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getTokensSold()", []);
        }
      }, u.getPermissions = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getPermissions()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getPermissions()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getPermissions()", []);
        }
      }, u.getSTODetails = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getSTODetails()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getSTODetails()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getSTODetails()", []);
        }
      }, u._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, l.classUtils.bindAll(u, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), u;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n, s, u) {
      return o(this, void 0, void 0, function () {
        var o, b, m, v, _, g, A, w, T, x, D;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return p.assert.isHexString("bytecode", e), p.assert.doesConformToSchema("txDefaults", n, f.schemas.txDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), o = l.providerUtils.standardizeOrThrow(r), b = d.BaseContract._lookupConstructorAbi(a), D = c(d.BaseContract._formatABIDataItemList(b.inputs, [s, u], d.BaseContract._bigNumberToString), 2), s = D[0], u = D[1], m = new y.utils.Interface(a), v = m.deployFunction, _ = v.encode(e, [s, u]), g = new h.Web3Wrapper(o), [4, d.BaseContract._applyDefaultsToTxDataAsync({
                data: _
              }, n, g.estimateGasAsync.bind(g))];

            case 1:
              return A = i.sent(), [4, g.sendTransactionAsync(A)];

            case 2:
              return w = i.sent(), l.logUtils.log("transactionHash: " + w), [4, g.awaitTransactionSuccessAsync(w)];

            case 3:
              return T = i.sent(), l.logUtils.log("CappedSTO successfully deployed at " + T.contractAddress), (x = new t(T.contractAddress, o, n)).constructorArgs = [s, u], [2, x];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !1,
        inputs: [],
        name: "reclaimETH",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "ADMIN",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "rate",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "allowBeneficialInvestments",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "endTime",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "cap",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "unpause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "wallet",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "paused",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "totalTokensSold",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "address"
        }],
        name: "investors",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "polyToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "startTime",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "pause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenContract",
          type: "address"
        }],
        name: "reclaimERC20",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "OPERATOR",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_fundRaiseType",
          type: "uint8"
        }],
        name: "getRaised",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "pausedTime",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "securityToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "factory",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "uint8"
        }],
        name: "fundsRaised",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "uint8"
        }],
        name: "fundRaiseTypes",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "investorCount",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDataStore",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        inputs: [{
          name: "_securityToken",
          type: "address"
        }, {
          name: "_polyToken",
          type: "address"
        }],
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "constructor"
      }, {
        inputs: [],
        outputs: [],
        payable: !0,
        stateMutability: "payable",
        type: "fallback"
      }, {
        anonymous: !1,
        inputs: [{
          name: "purchaser",
          type: "address",
          indexed: !0
        }, {
          name: "beneficiary",
          type: "address",
          indexed: !0
        }, {
          name: "value",
          type: "uint256",
          indexed: !1
        }, {
          name: "amount",
          type: "uint256",
          indexed: !1
        }],
        name: "TokenPurchase",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_allowed",
          type: "bool",
          indexed: !1
        }],
        name: "SetAllowBeneficialInvestments",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Pause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Unpause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_fundRaiseTypes",
          type: "uint8[]",
          indexed: !1
        }],
        name: "SetFundRaiseTypes",
        outputs: [],
        type: "event"
      }, {
        constant: !1,
        inputs: [{
          name: "_startTime",
          type: "uint256"
        }, {
          name: "_endTime",
          type: "uint256"
        }, {
          name: "_cap",
          type: "uint256"
        }, {
          name: "_rate",
          type: "uint256"
        }, {
          name: "_fundRaiseTypes",
          type: "uint8[]"
        }, {
          name: "_fundsReceiver",
          type: "address"
        }],
        name: "configure",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getInitFunction",
        outputs: [{
          name: "",
          type: "bytes4"
        }],
        payable: !1,
        stateMutability: "pure",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_allowBeneficialInvestments",
          type: "bool"
        }],
        name: "changeAllowBeneficialInvestments",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address"
        }],
        name: "buyTokens",
        outputs: [],
        payable: !0,
        stateMutability: "payable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_investedPOLY",
          type: "uint256"
        }],
        name: "buyTokensWithPoly",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "capReached",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getTokensSold",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getPermissions",
        outputs: [{
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getSTODetails",
        outputs: [{
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(d.BaseContract);

  t.CappedSTOContract_3_0_0 = v, t.isCappedSTOContract_3_0_0 = function (e) {
    return m.isEqual(v.ABI(), e.abi);
  };
},
/*!*************************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/capped_s_t_o_factory.js ***!
  \*************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r72,
      n = this && this.__extends || (_r72 = function r(e, t) {
    return (_r72 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r72(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      c = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || 0 < t--) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u,
      d = a(
  /*! @0x/base-contract */
  12),
      f = a(
  /*! @0x/json-schemas */
  2),
      l = a(
  /*! @0x/utils */
  8),
      h = a(
  /*! @0x/web3-wrapper */
  11),
      p = a(
  /*! @0x/assert */
  10),
      b = a(
  /*! ../../PolyResponse */
  14),
      m = a(
  /*! lodash */
  0),
      y = a(
  /*! ethers */
  13);
  (u = t.CappedSTOFactoryEvents_3_0_0 || (t.CappedSTOFactoryEvents_3_0_0 = {})).LogicContractSet = "LogicContractSet", u.ModuleUpgraded = "ModuleUpgraded", u.OwnershipTransferred = "OwnershipTransferred", u.ChangeSetupCost = "ChangeSetupCost", u.ChangeCostType = "ChangeCostType", u.GenerateModuleFromFactory = "GenerateModuleFromFactory", u.ChangeSTVersionBound = "ChangeSTVersionBound";

  var v = function (e) {
    function t(a, r, n, c) {
      var u = e.call(this, "CappedSTOFactory", t.ABI(), a, r, n) || this;
      return u.name = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("name()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("name()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("name()", []);
        }
      }, u.upgrade = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_module", e), n = (r = this)._strictEncodeArguments("upgrade(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.upgrade.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_module", e), n = (r = this)._strictEncodeArguments("upgrade(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_module", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("upgrade(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("upgrade(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_module", e), this._strictEncodeArguments("upgrade(address)", [e]);
        }
      }, u.changeSetupCost = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_setupCost", e), n = (r = this)._strictEncodeArguments("changeSetupCost(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeSetupCost.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_setupCost", e), n = (r = this)._strictEncodeArguments("changeSetupCost(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_setupCost", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeSetupCost(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeSetupCost(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_setupCost", e), this._strictEncodeArguments("changeSetupCost(uint256)", [e]);
        }
      }, u.changeTags = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_tagsData", e), n = (r = this)._strictEncodeArguments("changeTags(bytes32[])", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeTags.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_tagsData", e), n = (r = this)._strictEncodeArguments("changeTags(bytes32[])", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_tagsData", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeTags(bytes32[])", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeTags(bytes32[])").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isArray("_tagsData", e), this._strictEncodeArguments("changeTags(bytes32[])", [e]);
        }
      }, u.setupCostInPoly = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("setupCostInPoly()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.setupCostInPoly.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("setupCostInPoly()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("setupCostInPoly()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("setupCostInPoly()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("setupCostInPoly()", []);
        }
      }, u.changeTitle = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_title", e), n = (r = this)._strictEncodeArguments("changeTitle(string)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeTitle.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_title", e), n = (r = this)._strictEncodeArguments("changeTitle(string)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_title", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeTitle(string)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeTitle(string)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_title", e), this._strictEncodeArguments("changeTitle(string)", [e]);
        }
      }, u.setLogicContract = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_version", e), p.assert.isString("_logicContract", t), p.assert.isString("_upgradeData", a), c = (o = this)._strictEncodeArguments("setLogicContract(string,address,bytes)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.setLogicContract.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_version", e), p.assert.isString("_logicContract", t), p.assert.isString("_upgradeData", a), c = (o = this)._strictEncodeArguments("setLogicContract(string,address,bytes)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_version", e), p.assert.isString("_logicContract", t), p.assert.isString("_upgradeData", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("setLogicContract(string,address,bytes)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("setLogicContract(string,address,bytes)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isString("_version", e), p.assert.isString("_logicContract", t), p.assert.isString("_upgradeData", a), this._strictEncodeArguments("setLogicContract(string,address,bytes)", [e, t, a]);
        }
      }, u.isCostInPoly = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("isCostInPoly()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("isCostInPoly()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("isCostInPoly()", []);
        }
      }, u.title = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("title()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("title()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("title()", []);
        }
      }, u.version = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("version()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("version()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("version()", []);
        }
      }, u.latestUpgrade = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("latestUpgrade()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("latestUpgrade()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("latestUpgrade()", []);
        }
      }, u.logicContracts = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("logicContracts(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("logicContracts(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("index_0", e), this._strictEncodeArguments("logicContracts(uint256)", [e]);
        }
      }, u.renounceOwnership = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("renounceOwnership()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.renounceOwnership.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("renounceOwnership()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("renounceOwnership()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("renounceOwnership()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("renounceOwnership()", []);
        }
      }, u.description = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("description()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("description()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("description()", []);
        }
      }, u.polymathRegistry = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("polymathRegistry()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("polymathRegistry()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("polymathRegistry()", []);
        }
      }, u.setupCost = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("setupCost()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("setupCost()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("setupCost()", []);
        }
      }, u.getLowerSTVersionBounds = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getLowerSTVersionBounds()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getLowerSTVersionBounds()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getLowerSTVersionBounds()", []);
        }
      }, u.changeName = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), n = (r = this)._strictEncodeArguments("changeName(bytes32)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeName.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), n = (r = this)._strictEncodeArguments("changeName(bytes32)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeName(bytes32)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeName(bytes32)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_name", e), this._strictEncodeArguments("changeName(bytes32)", [e]);
        }
      }, u.owner = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("owner()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("owner()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("owner()", []);
        }
      }, u.isOwner = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("isOwner()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("isOwner()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("isOwner()", []);
        }
      }, u.getTags = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getTags()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getTags()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getTags()", []);
        }
      }, u.modules = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("index_0", e), p.assert.isString("index_1", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("modules(address,address)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("modules(address,address)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("index_0", e), p.assert.isString("index_1", t), this._strictEncodeArguments("modules(address,address)", [e, t]);
        }
      }, u.moduleToSecurityToken = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("moduleToSecurityToken(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("moduleToSecurityToken(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("index_0", e), this._strictEncodeArguments("moduleToSecurityToken(address)", [e]);
        }
      }, u.getTypes = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getTypes()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getTypes()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getTypes()", []);
        }
      }, u.changeCostAndType = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_setupCost", e), p.assert.isBoolean("_isCostInPoly", t), o = (n = this)._strictEncodeArguments("changeCostAndType(uint256,bool)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.changeCostAndType.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_setupCost", e), p.assert.isBoolean("_isCostInPoly", t), o = (n = this)._strictEncodeArguments("changeCostAndType(uint256,bool)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_setupCost", e), p.assert.isBoolean("_isCostInPoly", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("changeCostAndType(uint256,bool)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("changeCostAndType(uint256,bool)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isBigNumber("_setupCost", e), p.assert.isBoolean("_isCostInPoly", t), this._strictEncodeArguments("changeCostAndType(uint256,bool)", [e, t]);
        }
      }, u.updateLogicContract = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_upgrade", e), p.assert.isString("_version", t), p.assert.isString("_logicContract", a), p.assert.isString("_upgradeData", r), u = (o = this)._strictEncodeArguments("updateLogicContract(uint256,string,address,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.updateLogicContract.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_upgrade", e), p.assert.isString("_version", t), p.assert.isString("_logicContract", a), p.assert.isString("_upgradeData", r), u = (o = this)._strictEncodeArguments("updateLogicContract(uint256,string,address,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_upgrade", e), p.assert.isString("_version", t), p.assert.isString("_logicContract", a), p.assert.isString("_upgradeData", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("updateLogicContract(uint256,string,address,bytes)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("updateLogicContract(uint256,string,address,bytes)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isBigNumber("_upgrade", e), p.assert.isString("_version", t), p.assert.isString("_logicContract", a), p.assert.isString("_upgradeData", r), this._strictEncodeArguments("updateLogicContract(uint256,string,address,bytes)", [e, t, a, r]);
        }
      }, u.changeDescription = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_description", e), n = (r = this)._strictEncodeArguments("changeDescription(string)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeDescription.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_description", e), n = (r = this)._strictEncodeArguments("changeDescription(string)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_description", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeDescription(string)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeDescription(string)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_description", e), this._strictEncodeArguments("changeDescription(string)", [e]);
        }
      }, u.transferOwnership = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("newOwner", e), n = (r = this)._strictEncodeArguments("transferOwnership(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.transferOwnership.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("newOwner", e), n = (r = this)._strictEncodeArguments("transferOwnership(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("newOwner", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("transferOwnership(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("transferOwnership(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("newOwner", e), this._strictEncodeArguments("transferOwnership(address)", [e]);
        }
      }, u.getUpperSTVersionBounds = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getUpperSTVersionBounds()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getUpperSTVersionBounds()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getUpperSTVersionBounds()", []);
        }
      }, u.changeSTVersionBounds = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_boundType", e), p.assert.isArray("_newVersion", t), o = (n = this)._strictEncodeArguments("changeSTVersionBounds(string,uint8[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.changeSTVersionBounds.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_boundType", e), p.assert.isArray("_newVersion", t), o = (n = this)._strictEncodeArguments("changeSTVersionBounds(string,uint8[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_boundType", e), p.assert.isArray("_newVersion", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("changeSTVersionBounds(string,uint8[])", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("changeSTVersionBounds(string,uint8[])").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_boundType", e), p.assert.isArray("_newVersion", t), this._strictEncodeArguments("changeSTVersionBounds(string,uint8[])", [e, t]);
        }
      }, u.deploy = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_data", e), n = (r = this)._strictEncodeArguments("deploy(bytes)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.deploy.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_data", e), n = (r = this)._strictEncodeArguments("deploy(bytes)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_data", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("deploy(bytes)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("deploy(bytes)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_data", e), this._strictEncodeArguments("deploy(bytes)", [e]);
        }
      }, u._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, l.classUtils.bindAll(u, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), u;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n, s, u, b, m) {
      return o(this, void 0, void 0, function () {
        var o, v, _, g, A, w, T, x, D, C, S;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return p.assert.isHexString("bytecode", e), p.assert.doesConformToSchema("txDefaults", n, f.schemas.txDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), o = l.providerUtils.standardizeOrThrow(r), v = d.BaseContract._lookupConstructorAbi(a), S = c(d.BaseContract._formatABIDataItemList(v.inputs, [s, u, b, m], d.BaseContract._bigNumberToString), 4), s = S[0], u = S[1], b = S[2], m = S[3], _ = new y.utils.Interface(a), g = _.deployFunction, A = g.encode(e, [s, u, b, m]), w = new h.Web3Wrapper(o), [4, d.BaseContract._applyDefaultsToTxDataAsync({
                data: A
              }, n, w.estimateGasAsync.bind(w))];

            case 1:
              return T = i.sent(), [4, w.sendTransactionAsync(T)];

            case 2:
              return x = i.sent(), l.logUtils.log("transactionHash: " + x), [4, w.awaitTransactionSuccessAsync(x)];

            case 3:
              return D = i.sent(), l.logUtils.log("CappedSTOFactory successfully deployed at " + D.contractAddress), (C = new t(D.contractAddress, o, n)).constructorArgs = [s, u, b, m], [2, C];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !0,
        inputs: [],
        name: "name",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_module",
          type: "address"
        }],
        name: "upgrade",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_setupCost",
          type: "uint256"
        }],
        name: "changeSetupCost",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tagsData",
          type: "bytes32[]"
        }],
        name: "changeTags",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "setupCostInPoly",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_title",
          type: "string"
        }],
        name: "changeTitle",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_version",
          type: "string"
        }, {
          name: "_logicContract",
          type: "address"
        }, {
          name: "_upgradeData",
          type: "bytes"
        }],
        name: "setLogicContract",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "isCostInPoly",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "title",
        outputs: [{
          name: "",
          type: "string"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "version",
        outputs: [{
          name: "",
          type: "string"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "latestUpgrade",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "uint256"
        }],
        name: "logicContracts",
        outputs: [{
          name: "version",
          type: "string"
        }, {
          name: "logicContract",
          type: "address"
        }, {
          name: "upgradeData",
          type: "bytes"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "description",
        outputs: [{
          name: "",
          type: "string"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "polymathRegistry",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "setupCost",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getLowerSTVersionBounds",
        outputs: [{
          name: "",
          type: "uint8[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_name",
          type: "bytes32"
        }],
        name: "changeName",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "owner",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "isOwner",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getTags",
        outputs: [{
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "address"
        }, {
          name: "index_1",
          type: "address"
        }],
        name: "modules",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "address"
        }],
        name: "moduleToSecurityToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getTypes",
        outputs: [{
          name: "",
          type: "uint8[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_setupCost",
          type: "uint256"
        }, {
          name: "_isCostInPoly",
          type: "bool"
        }],
        name: "changeCostAndType",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_upgrade",
          type: "uint256"
        }, {
          name: "_version",
          type: "string"
        }, {
          name: "_logicContract",
          type: "address"
        }, {
          name: "_upgradeData",
          type: "bytes"
        }],
        name: "updateLogicContract",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_description",
          type: "string"
        }],
        name: "changeDescription",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "newOwner",
          type: "address"
        }],
        name: "transferOwnership",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getUpperSTVersionBounds",
        outputs: [{
          name: "",
          type: "uint8[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_boundType",
          type: "string"
        }, {
          name: "_newVersion",
          type: "uint8[]"
        }],
        name: "changeSTVersionBounds",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        inputs: [{
          name: "_setupCost",
          type: "uint256"
        }, {
          name: "_logicContract",
          type: "address"
        }, {
          name: "_polymathRegistry",
          type: "address"
        }, {
          name: "_isCostInPoly",
          type: "bool"
        }],
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "constructor"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_version",
          type: "string",
          indexed: !1
        }, {
          name: "_upgrade",
          type: "uint256",
          indexed: !1
        }, {
          name: "_logicContract",
          type: "address",
          indexed: !1
        }, {
          name: "_upgradeData",
          type: "bytes",
          indexed: !1
        }],
        name: "LogicContractSet",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_module",
          type: "address",
          indexed: !0
        }, {
          name: "_securityToken",
          type: "address",
          indexed: !0
        }, {
          name: "_version",
          type: "uint256",
          indexed: !0
        }],
        name: "ModuleUpgraded",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "previousOwner",
          type: "address",
          indexed: !0
        }, {
          name: "newOwner",
          type: "address",
          indexed: !0
        }],
        name: "OwnershipTransferred",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_oldSetupCost",
          type: "uint256",
          indexed: !1
        }, {
          name: "_newSetupCost",
          type: "uint256",
          indexed: !1
        }],
        name: "ChangeSetupCost",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_isOldCostInPoly",
          type: "bool",
          indexed: !1
        }, {
          name: "_isNewCostInPoly",
          type: "bool",
          indexed: !1
        }],
        name: "ChangeCostType",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_module",
          type: "address",
          indexed: !1
        }, {
          name: "_moduleName",
          type: "bytes32",
          indexed: !0
        }, {
          name: "_moduleFactory",
          type: "address",
          indexed: !0
        }, {
          name: "_creator",
          type: "address",
          indexed: !1
        }, {
          name: "_setupCost",
          type: "uint256",
          indexed: !1
        }, {
          name: "_setupCostInPoly",
          type: "uint256",
          indexed: !1
        }],
        name: "GenerateModuleFromFactory",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_boundType",
          type: "string",
          indexed: !1
        }, {
          name: "_major",
          type: "uint8",
          indexed: !1
        }, {
          name: "_minor",
          type: "uint8",
          indexed: !1
        }, {
          name: "_patch",
          type: "uint8",
          indexed: !1
        }],
        name: "ChangeSTVersionBound",
        outputs: [],
        type: "event"
      }, {
        constant: !1,
        inputs: [{
          name: "_data",
          type: "bytes"
        }],
        name: "deploy",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(d.BaseContract);

  t.CappedSTOFactoryContract_3_0_0 = v, t.isCappedSTOFactoryContract_3_0_0 = function (e) {
    return m.isEqual(v.ABI(), e.abi);
  };
},
/*!***************************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/count_transfer_manager.js ***!
  \***************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r73,
      n = this && this.__extends || (_r73 = function r(e, t) {
    return (_r73 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r73(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      c = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || 0 < t--) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u,
      d = a(
  /*! @0x/base-contract */
  12),
      f = a(
  /*! @0x/json-schemas */
  2),
      l = a(
  /*! @0x/utils */
  8),
      h = a(
  /*! @0x/web3-wrapper */
  11),
      p = a(
  /*! @0x/assert */
  10),
      b = a(
  /*! ../../PolyResponse */
  14),
      m = a(
  /*! lodash */
  0),
      y = a(
  /*! ethers */
  13);
  (u = t.CountTransferManagerEvents_3_0_0 || (t.CountTransferManagerEvents_3_0_0 = {})).ModifyHolderCount = "ModifyHolderCount", u.Pause = "Pause", u.Unpause = "Unpause";

  var v = function (e) {
    function t(a, r, n, c) {
      var u = e.call(this, "CountTransferManager", t.ABI(), a, r, n) || this;
      return u.reclaimETH = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.reclaimETH.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("reclaimETH()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("reclaimETH()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("reclaimETH()", []);
        }
      }, u.getTokensByPartition = {
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_partition", e), p.assert.isString("_tokenHolder", t), p.assert.isBigNumber("index_2", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("getTokensByPartition(bytes32,address,uint256)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("getTokensByPartition(bytes32,address,uint256)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isString("_partition", e), p.assert.isString("_tokenHolder", t), p.assert.isBigNumber("index_2", a), this._strictEncodeArguments("getTokensByPartition(bytes32,address,uint256)", [e, t, a]);
        }
      }, u.ADMIN = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("ADMIN()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("ADMIN()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("ADMIN()", []);
        }
      }, u.unpause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.unpause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("unpause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("unpause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("unpause()", []);
        }
      }, u.paused = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("paused()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("paused()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("paused()", []);
        }
      }, u.UNLOCKED = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("UNLOCKED()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("UNLOCKED()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("UNLOCKED()", []);
        }
      }, u.polyToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("polyToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("polyToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("polyToken()", []);
        }
      }, u.pause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.pause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pause()", []);
        }
      }, u.reclaimERC20 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.reclaimERC20.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("reclaimERC20(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_tokenContract", e), this._strictEncodeArguments("reclaimERC20(address)", [e]);
        }
      }, u.OPERATOR = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("OPERATOR()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("OPERATOR()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("OPERATOR()", []);
        }
      }, u.LOCKED = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("LOCKED()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("LOCKED()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("LOCKED()", []);
        }
      }, u.maxHolderCount = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("maxHolderCount()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("maxHolderCount()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("maxHolderCount()", []);
        }
      }, u.securityToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("securityToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("securityToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("securityToken()", []);
        }
      }, u.factory = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("factory()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("factory()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("factory()", []);
        }
      }, u.getDataStore = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDataStore()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDataStore()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDataStore()", []);
        }
      }, u.executeTransfer = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), u = (o = this)._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.executeTransfer.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), u = (o = this)._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("executeTransfer(address,address,uint256,bytes)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), this._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]);
        }
      }, u.verifyTransfer = {
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("verifyTransfer(address,address,uint256,bytes)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("verifyTransfer(address,address,uint256,bytes)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), this._strictEncodeArguments("verifyTransfer(address,address,uint256,bytes)", [e, t, a, r]);
        }
      }, u.configure = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maxHolderCount", e), n = (r = this)._strictEncodeArguments("configure(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.configure.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maxHolderCount", e), n = (r = this)._strictEncodeArguments("configure(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maxHolderCount", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("configure(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("configure(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_maxHolderCount", e), this._strictEncodeArguments("configure(uint256)", [e]);
        }
      }, u.changeHolderCount = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maxHolderCount", e), n = (r = this)._strictEncodeArguments("changeHolderCount(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeHolderCount.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maxHolderCount", e), n = (r = this)._strictEncodeArguments("changeHolderCount(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maxHolderCount", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeHolderCount(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeHolderCount(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_maxHolderCount", e), this._strictEncodeArguments("changeHolderCount(uint256)", [e]);
        }
      }, u.getInitFunction = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getInitFunction()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getInitFunction()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getInitFunction()", []);
        }
      }, u.getPermissions = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getPermissions()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getPermissions()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getPermissions()", []);
        }
      }, u._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, l.classUtils.bindAll(u, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), u;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n, s, u) {
      return o(this, void 0, void 0, function () {
        var o, b, m, v, _, g, A, w, T, x, D;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return p.assert.isHexString("bytecode", e), p.assert.doesConformToSchema("txDefaults", n, f.schemas.txDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), o = l.providerUtils.standardizeOrThrow(r), b = d.BaseContract._lookupConstructorAbi(a), D = c(d.BaseContract._formatABIDataItemList(b.inputs, [s, u], d.BaseContract._bigNumberToString), 2), s = D[0], u = D[1], m = new y.utils.Interface(a), v = m.deployFunction, _ = v.encode(e, [s, u]), g = new h.Web3Wrapper(o), [4, d.BaseContract._applyDefaultsToTxDataAsync({
                data: _
              }, n, g.estimateGasAsync.bind(g))];

            case 1:
              return A = i.sent(), [4, g.sendTransactionAsync(A)];

            case 2:
              return w = i.sent(), l.logUtils.log("transactionHash: " + w), [4, g.awaitTransactionSuccessAsync(w)];

            case 3:
              return T = i.sent(), l.logUtils.log("CountTransferManager successfully deployed at " + T.contractAddress), (x = new t(T.contractAddress, o, n)).constructorArgs = [s, u], [2, x];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !1,
        inputs: [],
        name: "reclaimETH",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_partition",
          type: "bytes32"
        }, {
          name: "_tokenHolder",
          type: "address"
        }, {
          name: "index_2",
          type: "uint256"
        }],
        name: "getTokensByPartition",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "ADMIN",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "unpause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "paused",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "UNLOCKED",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "polyToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "pause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenContract",
          type: "address"
        }],
        name: "reclaimERC20",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "OPERATOR",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "LOCKED",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "maxHolderCount",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "securityToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "factory",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDataStore",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        inputs: [{
          name: "_securityToken",
          type: "address"
        }, {
          name: "_polyToken",
          type: "address"
        }],
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "constructor"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_oldHolderCount",
          type: "uint256",
          indexed: !1
        }, {
          name: "_newHolderCount",
          type: "uint256",
          indexed: !1
        }],
        name: "ModifyHolderCount",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Pause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Unpause",
        outputs: [],
        type: "event"
      }, {
        constant: !1,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "_to",
          type: "address"
        }, {
          name: "_amount",
          type: "uint256"
        }, {
          name: "index_3",
          type: "bytes"
        }],
        name: "executeTransfer",
        outputs: [{
          name: "",
          type: "uint8"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "_to",
          type: "address"
        }, {
          name: "_amount",
          type: "uint256"
        }, {
          name: "index_3",
          type: "bytes"
        }],
        name: "verifyTransfer",
        outputs: [{
          name: "",
          type: "uint8"
        }, {
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_maxHolderCount",
          type: "uint256"
        }],
        name: "configure",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_maxHolderCount",
          type: "uint256"
        }],
        name: "changeHolderCount",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getInitFunction",
        outputs: [{
          name: "",
          type: "bytes4"
        }],
        payable: !1,
        stateMutability: "pure",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getPermissions",
        outputs: [{
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(d.BaseContract);

  t.CountTransferManagerContract_3_0_0 = v, t.isCountTransferManagerContract_3_0_0 = function (e) {
    return m.isEqual(v.ABI(), e.abi);
  };
},
/*!************************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/dividend_checkpoint.js ***!
  \************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r74,
      n = this && this.__extends || (_r74 = function r(e, t) {
    return (_r74 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r74(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var c,
      u = a(
  /*! @0x/base-contract */
  12),
      d = a(
  /*! @0x/json-schemas */
  2),
      f = a(
  /*! @0x/utils */
  8),
      l = a(
  /*! @0x/web3-wrapper */
  11),
      h = a(
  /*! @0x/assert */
  10),
      p = a(
  /*! ../../PolyResponse */
  14),
      b = a(
  /*! lodash */
  0),
      m = a(
  /*! ethers */
  13);
  (c = t.DividendCheckpointEvents_3_0_0 || (t.DividendCheckpointEvents_3_0_0 = {})).SetDefaultExcludedAddresses = "SetDefaultExcludedAddresses", c.SetWithholding = "SetWithholding", c.SetWithholdingFixed = "SetWithholdingFixed", c.SetWallet = "SetWallet", c.UpdateDividendDates = "UpdateDividendDates", c.Pause = "Pause", c.Unpause = "Unpause";

  var y = function (e) {
    function t(a, r, n, c) {
      var l = e.call(this, "DividendCheckpoint", t.ABI(), a, r, n) || this;
      return l.EXCLUDED_ADDRESS_LIMIT = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("EXCLUDED_ADDRESS_LIMIT()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("EXCLUDED_ADDRESS_LIMIT()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("EXCLUDED_ADDRESS_LIMIT()", []);
        }
      }, l.reclaimETH = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.reclaimETH.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return d = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(d), [2, new p.PolyResponse(d, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return d = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * d), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("reclaimETH()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("reclaimETH()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("reclaimETH()", []);
        }
      }, l.ADMIN = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("ADMIN()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("ADMIN()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("ADMIN()", []);
        }
      }, l.investorWithheld = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("index_0", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("investorWithheld(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("investorWithheld(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("index_0", e), this._strictEncodeArguments("investorWithheld(address)", [e]);
        }
      }, l.unpause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.unpause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return d = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(d), [2, new p.PolyResponse(d, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return d = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * d), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("unpause()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("unpause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("unpause()", []);
        }
      }, l.wallet = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("wallet()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("wallet()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("wallet()", []);
        }
      }, l.paused = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("paused()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("paused()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("paused()", []);
        }
      }, l.polyToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("polyToken()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("polyToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("polyToken()", []);
        }
      }, l.withholdingTax = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("index_0", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("withholdingTax(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("withholdingTax(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("index_0", e), this._strictEncodeArguments("withholdingTax(address)", [e]);
        }
      }, l.dividends = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("index_0", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("dividends(uint256)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("dividends(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isBigNumber("index_0", e), this._strictEncodeArguments("dividends(uint256)", [e]);
        }
      }, l.pause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.pause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return d = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(d), [2, new p.PolyResponse(d, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return d = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * d), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pause()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pause()", []);
        }
      }, l.reclaimERC20 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.reclaimERC20.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenContract", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("reclaimERC20(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_tokenContract", e), this._strictEncodeArguments("reclaimERC20(address)", [e]);
        }
      }, l.OPERATOR = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("OPERATOR()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("OPERATOR()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("OPERATOR()", []);
        }
      }, l.securityToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("securityToken()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("securityToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("securityToken()", []);
        }
      }, l.excluded = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("index_0", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("excluded(uint256)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("excluded(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isBigNumber("index_0", e), this._strictEncodeArguments("excluded(uint256)", [e]);
        }
      }, l.factory = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("factory()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("factory()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("factory()", []);
        }
      }, l.getDataStore = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDataStore()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDataStore()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDataStore()", []);
        }
      }, l.configure = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_wallet", e), n = (r = this)._strictEncodeArguments("configure(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.configure.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_wallet", e), n = (r = this)._strictEncodeArguments("configure(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_wallet", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("configure(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("configure(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_wallet", e), this._strictEncodeArguments("configure(address)", [e]);
        }
      }, l.getInitFunction = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getInitFunction()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getInitFunction()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getInitFunction()", []);
        }
      }, l.changeWallet = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_wallet", e), n = (r = this)._strictEncodeArguments("changeWallet(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeWallet.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_wallet", e), n = (r = this)._strictEncodeArguments("changeWallet(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_wallet", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeWallet(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeWallet(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_wallet", e), this._strictEncodeArguments("changeWallet(address)", [e]);
        }
      }, l.getDefaultExcluded = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDefaultExcluded()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDefaultExcluded()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDefaultExcluded()", []);
        }
      }, l.getTreasuryWallet = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getTreasuryWallet()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getTreasuryWallet()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getTreasuryWallet()", []);
        }
      }, l.createCheckpoint = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("createCheckpoint()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.createCheckpoint.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return d = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(d), [2, new p.PolyResponse(d, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("createCheckpoint()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return d = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * d), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("createCheckpoint()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("createCheckpoint()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("createCheckpoint()", []);
        }
      }, l.setDefaultExcluded = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isArray("_excluded", e), n = (r = this)._strictEncodeArguments("setDefaultExcluded(address[])", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.setDefaultExcluded.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isArray("_excluded", e), n = (r = this)._strictEncodeArguments("setDefaultExcluded(address[])", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isArray("_excluded", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("setDefaultExcluded(address[])", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("setDefaultExcluded(address[])").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isArray("_excluded", e), this._strictEncodeArguments("setDefaultExcluded(address[])", [e]);
        }
      }, l.setWithholding = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isArray("_investors", e), h.assert.isArray("_withholding", t), o = (n = this)._strictEncodeArguments("setWithholding(address[],uint256[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: d
                  }, c), n.setWithholding.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), b = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new p.PolyResponse(l, b)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isArray("_investors", e), h.assert.isArray("_withholding", t), o = (n = this)._strictEncodeArguments("setWithholding(address[],uint256[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: d
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return p = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, p < m ? p : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isArray("_investors", e), h.assert.isArray("_withholding", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("setWithholding(address[],uint256[])", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("setWithholding(address[],uint256[])").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isArray("_investors", e), h.assert.isArray("_withholding", t), this._strictEncodeArguments("setWithholding(address[],uint256[])", [e, t]);
        }
      }, l.setWithholdingFixed = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isArray("_investors", e), h.assert.isBigNumber("_withholding", t), o = (n = this)._strictEncodeArguments("setWithholdingFixed(address[],uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: d
                  }, c), n.setWithholdingFixed.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), b = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new p.PolyResponse(l, b)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isArray("_investors", e), h.assert.isBigNumber("_withholding", t), o = (n = this)._strictEncodeArguments("setWithholdingFixed(address[],uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: d
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return p = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, p < m ? p : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isArray("_investors", e), h.assert.isBigNumber("_withholding", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("setWithholdingFixed(address[],uint256)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("setWithholdingFixed(address[],uint256)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isArray("_investors", e), h.assert.isBigNumber("_withholding", t), this._strictEncodeArguments("setWithholdingFixed(address[],uint256)", [e, t]);
        }
      }, l.pushDividendPaymentToAddresses = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_dividendIndex", e), h.assert.isArray("_payees", t), o = (n = this)._strictEncodeArguments("pushDividendPaymentToAddresses(uint256,address[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: d
                  }, c), n.pushDividendPaymentToAddresses.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), b = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new p.PolyResponse(l, b)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_dividendIndex", e), h.assert.isArray("_payees", t), o = (n = this)._strictEncodeArguments("pushDividendPaymentToAddresses(uint256,address[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: d
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return p = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, p < m ? p : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_dividendIndex", e), h.assert.isArray("_payees", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("pushDividendPaymentToAddresses(uint256,address[])", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("pushDividendPaymentToAddresses(uint256,address[])").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isBigNumber("_dividendIndex", e), h.assert.isArray("_payees", t), this._strictEncodeArguments("pushDividendPaymentToAddresses(uint256,address[])", [e, t]);
        }
      }, l.pushDividendPayment = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_dividendIndex", e), h.assert.isBigNumber("_start", t), h.assert.isBigNumber("_end", a), c = (o = this)._strictEncodeArguments("pushDividendPayment(uint256,uint256,uint256)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, d), o.pushDividendPayment.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return b = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(b), [2, new p.PolyResponse(b, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, p, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_dividendIndex", e), h.assert.isBigNumber("_start", t), h.assert.isBigNumber("_end", a), c = (o = this)._strictEncodeArguments("pushDividendPayment(uint256,uint256,uint256)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, d))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return p = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * p), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_dividendIndex", e), h.assert.isBigNumber("_start", t), h.assert.isBigNumber("_end", a), h.assert.doesConformToSchema("callData", r, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== n && h.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("pushDividendPayment(uint256,uint256,uint256)", [e, t, a]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (f = i.sent()).from = f.from ? f.from.toLowerCase() : f.from, [4, o._web3Wrapper.callAsync(f, n)];

                case 2:
                  return l = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("pushDividendPayment(uint256,uint256,uint256)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return h.assert.isBigNumber("_dividendIndex", e), h.assert.isBigNumber("_start", t), h.assert.isBigNumber("_end", a), this._strictEncodeArguments("pushDividendPayment(uint256,uint256,uint256)", [e, t, a]);
        }
      }, l.pullDividendPayment = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_dividendIndex", e), n = (r = this)._strictEncodeArguments("pullDividendPayment(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.pullDividendPayment.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_dividendIndex", e), n = (r = this)._strictEncodeArguments("pullDividendPayment(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_dividendIndex", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("pullDividendPayment(uint256)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("pullDividendPayment(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isBigNumber("_dividendIndex", e), this._strictEncodeArguments("pullDividendPayment(uint256)", [e]);
        }
      }, l.reclaimDividend = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_dividendIndex", e), n = (r = this)._strictEncodeArguments("reclaimDividend(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.reclaimDividend.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_dividendIndex", e), n = (r = this)._strictEncodeArguments("reclaimDividend(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_dividendIndex", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("reclaimDividend(uint256)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("reclaimDividend(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isBigNumber("_dividendIndex", e), this._strictEncodeArguments("reclaimDividend(uint256)", [e]);
        }
      }, l.calculateDividend = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_dividendIndex", e), h.assert.isString("_payee", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("calculateDividend(uint256,address)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("calculateDividend(uint256,address)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isBigNumber("_dividendIndex", e), h.assert.isString("_payee", t), this._strictEncodeArguments("calculateDividend(uint256,address)", [e, t]);
        }
      }, l.getDividendIndex = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_checkpointId", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getDividendIndex(uint256)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getDividendIndex(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isBigNumber("_checkpointId", e), this._strictEncodeArguments("getDividendIndex(uint256)", [e]);
        }
      }, l.withdrawWithholding = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_dividendIndex", e), n = (r = this)._strictEncodeArguments("withdrawWithholding(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.withdrawWithholding.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_dividendIndex", e), n = (r = this)._strictEncodeArguments("withdrawWithholding(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_dividendIndex", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("withdrawWithholding(uint256)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("withdrawWithholding(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isBigNumber("_dividendIndex", e), this._strictEncodeArguments("withdrawWithholding(uint256)", [e]);
        }
      }, l.updateDividendDates = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_dividendIndex", e), h.assert.isBigNumber("_maturity", t), h.assert.isBigNumber("_expiry", a), c = (o = this)._strictEncodeArguments("updateDividendDates(uint256,uint256,uint256)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, d), o.updateDividendDates.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return b = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(b), [2, new p.PolyResponse(b, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, p, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_dividendIndex", e), h.assert.isBigNumber("_maturity", t), h.assert.isBigNumber("_expiry", a), c = (o = this)._strictEncodeArguments("updateDividendDates(uint256,uint256,uint256)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, d))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return p = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * p), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_dividendIndex", e), h.assert.isBigNumber("_maturity", t), h.assert.isBigNumber("_expiry", a), h.assert.doesConformToSchema("callData", r, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== n && h.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("updateDividendDates(uint256,uint256,uint256)", [e, t, a]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (f = i.sent()).from = f.from ? f.from.toLowerCase() : f.from, [4, o._web3Wrapper.callAsync(f, n)];

                case 2:
                  return l = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("updateDividendDates(uint256,uint256,uint256)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return h.assert.isBigNumber("_dividendIndex", e), h.assert.isBigNumber("_maturity", t), h.assert.isBigNumber("_expiry", a), this._strictEncodeArguments("updateDividendDates(uint256,uint256,uint256)", [e, t, a]);
        }
      }, l.getDividendsData = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDividendsData()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDividendsData()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDividendsData()", []);
        }
      }, l.getDividendData = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_dividendIndex", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getDividendData(uint256)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getDividendData(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isBigNumber("_dividendIndex", e), this._strictEncodeArguments("getDividendData(uint256)", [e]);
        }
      }, l.getDividendProgress = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_dividendIndex", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getDividendProgress(uint256)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getDividendProgress(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isBigNumber("_dividendIndex", e), this._strictEncodeArguments("getDividendProgress(uint256)", [e]);
        }
      }, l.getCheckpointData = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_checkpointId", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getCheckpointData(uint256)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getCheckpointData(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isBigNumber("_checkpointId", e), this._strictEncodeArguments("getCheckpointData(uint256)", [e]);
        }
      }, l.isExcluded = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_investor", e), h.assert.isBigNumber("_dividendIndex", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("isExcluded(address,uint256)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("isExcluded(address,uint256)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("_investor", e), h.assert.isBigNumber("_dividendIndex", t), this._strictEncodeArguments("isExcluded(address,uint256)", [e, t]);
        }
      }, l.isClaimed = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_investor", e), h.assert.isBigNumber("_dividendIndex", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("isClaimed(address,uint256)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("isClaimed(address,uint256)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("_investor", e), h.assert.isBigNumber("_dividendIndex", t), this._strictEncodeArguments("isClaimed(address,uint256)", [e, t]);
        }
      }, l.getPermissions = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getPermissions()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getPermissions()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getPermissions()", []);
        }
      }, l._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, f.classUtils.bindAll(l, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), l;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n) {
      return o(this, void 0, void 0, function () {
        var s, o, c, p, b, y, v, _, g, A;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return h.assert.isHexString("bytecode", e), h.assert.doesConformToSchema("txDefaults", n, d.schemas.txDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), s = f.providerUtils.standardizeOrThrow(r), o = u.BaseContract._lookupConstructorAbi(a), u.BaseContract._formatABIDataItemList(o.inputs, [], u.BaseContract._bigNumberToString), c = new m.utils.Interface(a), p = c.deployFunction, b = p.encode(e, []), y = new l.Web3Wrapper(s), [4, u.BaseContract._applyDefaultsToTxDataAsync({
                data: b
              }, n, y.estimateGasAsync.bind(y))];

            case 1:
              return v = i.sent(), [4, y.sendTransactionAsync(v)];

            case 2:
              return _ = i.sent(), f.logUtils.log("transactionHash: " + _), [4, y.awaitTransactionSuccessAsync(_)];

            case 3:
              return g = i.sent(), f.logUtils.log("DividendCheckpoint successfully deployed at " + g.contractAddress), (A = new t(g.contractAddress, s, n)).constructorArgs = [], [2, A];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !0,
        inputs: [],
        name: "EXCLUDED_ADDRESS_LIMIT",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "reclaimETH",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "ADMIN",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "address"
        }],
        name: "investorWithheld",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "unpause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "wallet",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "paused",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "polyToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "address"
        }],
        name: "withholdingTax",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "uint256"
        }],
        name: "dividends",
        outputs: [{
          name: "checkpointId",
          type: "uint256"
        }, {
          name: "created",
          type: "uint256"
        }, {
          name: "maturity",
          type: "uint256"
        }, {
          name: "expiry",
          type: "uint256"
        }, {
          name: "amount",
          type: "uint256"
        }, {
          name: "claimedAmount",
          type: "uint256"
        }, {
          name: "totalSupply",
          type: "uint256"
        }, {
          name: "reclaimed",
          type: "bool"
        }, {
          name: "totalWithheld",
          type: "uint256"
        }, {
          name: "totalWithheldWithdrawn",
          type: "uint256"
        }, {
          name: "name",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "pause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenContract",
          type: "address"
        }],
        name: "reclaimERC20",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "OPERATOR",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "securityToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "uint256"
        }],
        name: "excluded",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "factory",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDataStore",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_excluded",
          type: "address[]",
          indexed: !1
        }],
        name: "SetDefaultExcludedAddresses",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_investors",
          type: "address[]",
          indexed: !1
        }, {
          name: "_withholding",
          type: "uint256[]",
          indexed: !1
        }],
        name: "SetWithholding",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_investors",
          type: "address[]",
          indexed: !1
        }, {
          name: "_withholding",
          type: "uint256",
          indexed: !1
        }],
        name: "SetWithholdingFixed",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_oldWallet",
          type: "address",
          indexed: !0
        }, {
          name: "_newWallet",
          type: "address",
          indexed: !0
        }],
        name: "SetWallet",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_dividendIndex",
          type: "uint256",
          indexed: !0
        }, {
          name: "_maturity",
          type: "uint256",
          indexed: !1
        }, {
          name: "_expiry",
          type: "uint256",
          indexed: !1
        }],
        name: "UpdateDividendDates",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Pause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Unpause",
        outputs: [],
        type: "event"
      }, {
        constant: !1,
        inputs: [{
          name: "_wallet",
          type: "address"
        }],
        name: "configure",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getInitFunction",
        outputs: [{
          name: "",
          type: "bytes4"
        }],
        payable: !1,
        stateMutability: "pure",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_wallet",
          type: "address"
        }],
        name: "changeWallet",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDefaultExcluded",
        outputs: [{
          name: "",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getTreasuryWallet",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "createCheckpoint",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_excluded",
          type: "address[]"
        }],
        name: "setDefaultExcluded",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_investors",
          type: "address[]"
        }, {
          name: "_withholding",
          type: "uint256[]"
        }],
        name: "setWithholding",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_investors",
          type: "address[]"
        }, {
          name: "_withholding",
          type: "uint256"
        }],
        name: "setWithholdingFixed",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_dividendIndex",
          type: "uint256"
        }, {
          name: "_payees",
          type: "address[]"
        }],
        name: "pushDividendPaymentToAddresses",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_dividendIndex",
          type: "uint256"
        }, {
          name: "_start",
          type: "uint256"
        }, {
          name: "_end",
          type: "uint256"
        }],
        name: "pushDividendPayment",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_dividendIndex",
          type: "uint256"
        }],
        name: "pullDividendPayment",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_dividendIndex",
          type: "uint256"
        }],
        name: "reclaimDividend",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_dividendIndex",
          type: "uint256"
        }, {
          name: "_payee",
          type: "address"
        }],
        name: "calculateDividend",
        outputs: [{
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_checkpointId",
          type: "uint256"
        }],
        name: "getDividendIndex",
        outputs: [{
          name: "",
          type: "uint256[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_dividendIndex",
          type: "uint256"
        }],
        name: "withdrawWithholding",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_dividendIndex",
          type: "uint256"
        }, {
          name: "_maturity",
          type: "uint256"
        }, {
          name: "_expiry",
          type: "uint256"
        }],
        name: "updateDividendDates",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDividendsData",
        outputs: [{
          name: "createds",
          type: "uint256[]"
        }, {
          name: "maturitys",
          type: "uint256[]"
        }, {
          name: "expirys",
          type: "uint256[]"
        }, {
          name: "amounts",
          type: "uint256[]"
        }, {
          name: "claimedAmounts",
          type: "uint256[]"
        }, {
          name: "names",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_dividendIndex",
          type: "uint256"
        }],
        name: "getDividendData",
        outputs: [{
          name: "created",
          type: "uint256"
        }, {
          name: "maturity",
          type: "uint256"
        }, {
          name: "expiry",
          type: "uint256"
        }, {
          name: "amount",
          type: "uint256"
        }, {
          name: "claimedAmount",
          type: "uint256"
        }, {
          name: "name",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_dividendIndex",
          type: "uint256"
        }],
        name: "getDividendProgress",
        outputs: [{
          name: "investors",
          type: "address[]"
        }, {
          name: "resultClaimed",
          type: "bool[]"
        }, {
          name: "resultExcluded",
          type: "bool[]"
        }, {
          name: "resultWithheld",
          type: "uint256[]"
        }, {
          name: "resultAmount",
          type: "uint256[]"
        }, {
          name: "resultBalance",
          type: "uint256[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_checkpointId",
          type: "uint256"
        }],
        name: "getCheckpointData",
        outputs: [{
          name: "investors",
          type: "address[]"
        }, {
          name: "balances",
          type: "uint256[]"
        }, {
          name: "withholdings",
          type: "uint256[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_investor",
          type: "address"
        }, {
          name: "_dividendIndex",
          type: "uint256"
        }],
        name: "isExcluded",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_investor",
          type: "address"
        }, {
          name: "_dividendIndex",
          type: "uint256"
        }],
        name: "isClaimed",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getPermissions",
        outputs: [{
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(u.BaseContract);

  t.DividendCheckpointContract_3_0_0 = y, t.isDividendCheckpointContract_3_0_0 = function (e) {
    return b.isEqual(y.ABI(), e.abi);
  };
},
/*!*******************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/erc20_detailed.js ***!
  \*******************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r75,
      n = this && this.__extends || (_r75 = function r(e, t) {
    return (_r75 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r75(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      c = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || 0 < t--) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u,
      d = a(
  /*! @0x/base-contract */
  12),
      f = a(
  /*! @0x/json-schemas */
  2),
      l = a(
  /*! @0x/utils */
  8),
      h = a(
  /*! @0x/web3-wrapper */
  11),
      p = a(
  /*! @0x/assert */
  10),
      b = a(
  /*! ../../PolyResponse */
  14),
      m = a(
  /*! lodash */
  0),
      y = a(
  /*! ethers */
  13);
  (u = t.ERC20DetailedEvents_3_0_0 || (t.ERC20DetailedEvents_3_0_0 = {})).Transfer = "Transfer", u.Approval = "Approval";

  var v = function (e) {
    function t(a, r, n, c) {
      var u = e.call(this, "ERC20Detailed", t.ABI(), a, r, n) || this;
      return u.approve = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("spender", e), p.assert.isBigNumber("value", t), o = (n = this)._strictEncodeArguments("approve(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.approve.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("spender", e), p.assert.isBigNumber("value", t), o = (n = this)._strictEncodeArguments("approve(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("spender", e), p.assert.isBigNumber("value", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("approve(address,uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("approve(address,uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("spender", e), p.assert.isBigNumber("value", t), this._strictEncodeArguments("approve(address,uint256)", [e, t]);
        }
      }, u.totalSupply = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("totalSupply()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("totalSupply()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("totalSupply()", []);
        }
      }, u.transferFrom = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("from", e), p.assert.isString("to", t), p.assert.isBigNumber("value", a), c = (o = this)._strictEncodeArguments("transferFrom(address,address,uint256)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.transferFrom.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("from", e), p.assert.isString("to", t), p.assert.isBigNumber("value", a), c = (o = this)._strictEncodeArguments("transferFrom(address,address,uint256)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("from", e), p.assert.isString("to", t), p.assert.isBigNumber("value", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("transferFrom(address,address,uint256)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("transferFrom(address,address,uint256)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isString("from", e), p.assert.isString("to", t), p.assert.isBigNumber("value", a), this._strictEncodeArguments("transferFrom(address,address,uint256)", [e, t, a]);
        }
      }, u.balanceOf = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("who", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("balanceOf(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("balanceOf(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("who", e), this._strictEncodeArguments("balanceOf(address)", [e]);
        }
      }, u.transfer = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("to", e), p.assert.isBigNumber("value", t), o = (n = this)._strictEncodeArguments("transfer(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.transfer.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("to", e), p.assert.isBigNumber("value", t), o = (n = this)._strictEncodeArguments("transfer(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("to", e), p.assert.isBigNumber("value", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("transfer(address,uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("transfer(address,uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("to", e), p.assert.isBigNumber("value", t), this._strictEncodeArguments("transfer(address,uint256)", [e, t]);
        }
      }, u.allowance = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("owner", e), p.assert.isString("spender", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("allowance(address,address)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("allowance(address,address)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("owner", e), p.assert.isString("spender", t), this._strictEncodeArguments("allowance(address,address)", [e, t]);
        }
      }, u.name = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("name()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("name()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("name()", []);
        }
      }, u.symbol = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("symbol()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("symbol()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("symbol()", []);
        }
      }, u.decimals = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("decimals()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("decimals()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("decimals()", []);
        }
      }, u._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, l.classUtils.bindAll(u, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), u;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n, s, u, b) {
      return o(this, void 0, void 0, function () {
        var o, m, v, _, g, A, w, T, x, D, C;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return p.assert.isHexString("bytecode", e), p.assert.doesConformToSchema("txDefaults", n, f.schemas.txDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), o = l.providerUtils.standardizeOrThrow(r), m = d.BaseContract._lookupConstructorAbi(a), C = c(d.BaseContract._formatABIDataItemList(m.inputs, [s, u, b], d.BaseContract._bigNumberToString), 3), s = C[0], u = C[1], b = C[2], v = new y.utils.Interface(a), _ = v.deployFunction, g = _.encode(e, [s, u, b]), A = new h.Web3Wrapper(o), [4, d.BaseContract._applyDefaultsToTxDataAsync({
                data: g
              }, n, A.estimateGasAsync.bind(A))];

            case 1:
              return w = i.sent(), [4, A.sendTransactionAsync(w)];

            case 2:
              return T = i.sent(), l.logUtils.log("transactionHash: " + T), [4, A.awaitTransactionSuccessAsync(T)];

            case 3:
              return x = i.sent(), l.logUtils.log("ERC20Detailed successfully deployed at " + x.contractAddress), (D = new t(x.contractAddress, o, n)).constructorArgs = [s, u, b], [2, D];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !1,
        inputs: [{
          name: "spender",
          type: "address"
        }, {
          name: "value",
          type: "uint256"
        }],
        name: "approve",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "totalSupply",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "from",
          type: "address"
        }, {
          name: "to",
          type: "address"
        }, {
          name: "value",
          type: "uint256"
        }],
        name: "transferFrom",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "who",
          type: "address"
        }],
        name: "balanceOf",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "to",
          type: "address"
        }, {
          name: "value",
          type: "uint256"
        }],
        name: "transfer",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "owner",
          type: "address"
        }, {
          name: "spender",
          type: "address"
        }],
        name: "allowance",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        inputs: [{
          name: "name",
          type: "string"
        }, {
          name: "symbol",
          type: "string"
        }, {
          name: "decimals",
          type: "uint8"
        }],
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "constructor"
      }, {
        anonymous: !1,
        inputs: [{
          name: "from",
          type: "address",
          indexed: !0
        }, {
          name: "to",
          type: "address",
          indexed: !0
        }, {
          name: "value",
          type: "uint256",
          indexed: !1
        }],
        name: "Transfer",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "owner",
          type: "address",
          indexed: !0
        }, {
          name: "spender",
          type: "address",
          indexed: !0
        }, {
          name: "value",
          type: "uint256",
          indexed: !1
        }],
        name: "Approval",
        outputs: [],
        type: "event"
      }, {
        constant: !0,
        inputs: [],
        name: "name",
        outputs: [{
          name: "",
          type: "string"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "symbol",
        outputs: [{
          name: "",
          type: "string"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "decimals",
        outputs: [{
          name: "",
          type: "uint8"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(d.BaseContract);

  t.ERC20DetailedContract_3_0_0 = v, t.isERC20DetailedContract_3_0_0 = function (e) {
    return m.isEqual(v.ABI(), e.abi);
  };
},
/*!******************************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/erc20_dividend_checkpoint.js ***!
  \******************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r76,
      n = this && this.__extends || (_r76 = function r(e, t) {
    return (_r76 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r76(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      c = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || 0 < t--) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u,
      d = a(
  /*! @0x/base-contract */
  12),
      f = a(
  /*! @0x/json-schemas */
  2),
      l = a(
  /*! @0x/utils */
  8),
      h = a(
  /*! @0x/web3-wrapper */
  11),
      p = a(
  /*! @0x/assert */
  10),
      b = a(
  /*! ../../PolyResponse */
  14),
      m = a(
  /*! lodash */
  0),
      y = a(
  /*! ethers */
  13);
  (u = t.ERC20DividendCheckpointEvents_3_0_0 || (t.ERC20DividendCheckpointEvents_3_0_0 = {})).ERC20DividendDeposited = "ERC20DividendDeposited", u.ERC20DividendClaimed = "ERC20DividendClaimed", u.ERC20DividendReclaimed = "ERC20DividendReclaimed", u.ERC20DividendWithholdingWithdrawn = "ERC20DividendWithholdingWithdrawn", u.SetDefaultExcludedAddresses = "SetDefaultExcludedAddresses", u.SetWithholding = "SetWithholding", u.SetWithholdingFixed = "SetWithholdingFixed", u.SetWallet = "SetWallet", u.UpdateDividendDates = "UpdateDividendDates", u.Pause = "Pause", u.Unpause = "Unpause";

  var v = function (e) {
    function t(a, r, n, c) {
      var u = e.call(this, "ERC20DividendCheckpoint", t.ABI(), a, r, n) || this;
      return u.setWithholdingFixed = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isBigNumber("_withholding", t), o = (n = this)._strictEncodeArguments("setWithholdingFixed(address[],uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.setWithholdingFixed.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isBigNumber("_withholding", t), o = (n = this)._strictEncodeArguments("setWithholdingFixed(address[],uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isBigNumber("_withholding", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("setWithholdingFixed(address[],uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("setWithholdingFixed(address[],uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isArray("_investors", e), p.assert.isBigNumber("_withholding", t), this._strictEncodeArguments("setWithholdingFixed(address[],uint256)", [e, t]);
        }
      }, u.EXCLUDED_ADDRESS_LIMIT = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("EXCLUDED_ADDRESS_LIMIT()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("EXCLUDED_ADDRESS_LIMIT()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("EXCLUDED_ADDRESS_LIMIT()", []);
        }
      }, u.reclaimETH = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.reclaimETH.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("reclaimETH()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("reclaimETH()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("reclaimETH()", []);
        }
      }, u.getInitFunction = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getInitFunction()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getInitFunction()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getInitFunction()", []);
        }
      }, u.getDividendData = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getDividendData(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getDividendData(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_dividendIndex", e), this._strictEncodeArguments("getDividendData(uint256)", [e]);
        }
      }, u.ADMIN = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("ADMIN()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("ADMIN()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("ADMIN()", []);
        }
      }, u.getTreasuryWallet = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getTreasuryWallet()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getTreasuryWallet()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getTreasuryWallet()", []);
        }
      }, u.pullDividendPayment = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), n = (r = this)._strictEncodeArguments("pullDividendPayment(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.pullDividendPayment.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), n = (r = this)._strictEncodeArguments("pullDividendPayment(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("pullDividendPayment(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("pullDividendPayment(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_dividendIndex", e), this._strictEncodeArguments("pullDividendPayment(uint256)", [e]);
        }
      }, u.investorWithheld = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("investorWithheld(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("investorWithheld(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("index_0", e), this._strictEncodeArguments("investorWithheld(address)", [e]);
        }
      }, u.unpause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.unpause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("unpause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("unpause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("unpause()", []);
        }
      }, u.pushDividendPaymentToAddresses = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), p.assert.isArray("_payees", t), o = (n = this)._strictEncodeArguments("pushDividendPaymentToAddresses(uint256,address[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.pushDividendPaymentToAddresses.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), p.assert.isArray("_payees", t), o = (n = this)._strictEncodeArguments("pushDividendPaymentToAddresses(uint256,address[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), p.assert.isArray("_payees", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("pushDividendPaymentToAddresses(uint256,address[])", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("pushDividendPaymentToAddresses(uint256,address[])").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isBigNumber("_dividendIndex", e), p.assert.isArray("_payees", t), this._strictEncodeArguments("pushDividendPaymentToAddresses(uint256,address[])", [e, t]);
        }
      }, u.wallet = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("wallet()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("wallet()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("wallet()", []);
        }
      }, u.isClaimed = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.isBigNumber("_dividendIndex", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("isClaimed(address,uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("isClaimed(address,uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_investor", e), p.assert.isBigNumber("_dividendIndex", t), this._strictEncodeArguments("isClaimed(address,uint256)", [e, t]);
        }
      }, u.calculateDividend = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), p.assert.isString("_payee", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("calculateDividend(uint256,address)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("calculateDividend(uint256,address)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isBigNumber("_dividendIndex", e), p.assert.isString("_payee", t), this._strictEncodeArguments("calculateDividend(uint256,address)", [e, t]);
        }
      }, u.paused = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("paused()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("paused()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("paused()", []);
        }
      }, u.getDividendIndex = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_checkpointId", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getDividendIndex(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getDividendIndex(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_checkpointId", e), this._strictEncodeArguments("getDividendIndex(uint256)", [e]);
        }
      }, u.polyToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("polyToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("polyToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("polyToken()", []);
        }
      }, u.updateDividendDates = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), p.assert.isBigNumber("_maturity", t), p.assert.isBigNumber("_expiry", a), c = (o = this)._strictEncodeArguments("updateDividendDates(uint256,uint256,uint256)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.updateDividendDates.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), p.assert.isBigNumber("_maturity", t), p.assert.isBigNumber("_expiry", a), c = (o = this)._strictEncodeArguments("updateDividendDates(uint256,uint256,uint256)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), p.assert.isBigNumber("_maturity", t), p.assert.isBigNumber("_expiry", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("updateDividendDates(uint256,uint256,uint256)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("updateDividendDates(uint256,uint256,uint256)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isBigNumber("_dividendIndex", e), p.assert.isBigNumber("_maturity", t), p.assert.isBigNumber("_expiry", a), this._strictEncodeArguments("updateDividendDates(uint256,uint256,uint256)", [e, t, a]);
        }
      }, u.configure = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_wallet", e), n = (r = this)._strictEncodeArguments("configure(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.configure.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_wallet", e), n = (r = this)._strictEncodeArguments("configure(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_wallet", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("configure(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("configure(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_wallet", e), this._strictEncodeArguments("configure(address)", [e]);
        }
      }, u.withholdingTax = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("withholdingTax(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("withholdingTax(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("index_0", e), this._strictEncodeArguments("withholdingTax(address)", [e]);
        }
      }, u.getCheckpointData = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_checkpointId", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getCheckpointData(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getCheckpointData(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_checkpointId", e), this._strictEncodeArguments("getCheckpointData(uint256)", [e]);
        }
      }, u.dividends = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("dividends(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("dividends(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("index_0", e), this._strictEncodeArguments("dividends(uint256)", [e]);
        }
      }, u.isExcluded = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.isBigNumber("_dividendIndex", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("isExcluded(address,uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("isExcluded(address,uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_investor", e), p.assert.isBigNumber("_dividendIndex", t), this._strictEncodeArguments("isExcluded(address,uint256)", [e, t]);
        }
      }, u.pause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.pause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pause()", []);
        }
      }, u.setWithholding = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isArray("_withholding", t), o = (n = this)._strictEncodeArguments("setWithholding(address[],uint256[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.setWithholding.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isArray("_withholding", t), o = (n = this)._strictEncodeArguments("setWithholding(address[],uint256[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isArray("_withholding", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("setWithholding(address[],uint256[])", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("setWithholding(address[],uint256[])").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isArray("_investors", e), p.assert.isArray("_withholding", t), this._strictEncodeArguments("setWithholding(address[],uint256[])", [e, t]);
        }
      }, u.reclaimERC20 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.reclaimERC20.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("reclaimERC20(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_tokenContract", e), this._strictEncodeArguments("reclaimERC20(address)", [e]);
        }
      }, u.dividendTokens = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("dividendTokens(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("dividendTokens(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("index_0", e), this._strictEncodeArguments("dividendTokens(uint256)", [e]);
        }
      }, u.OPERATOR = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("OPERATOR()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("OPERATOR()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("OPERATOR()", []);
        }
      }, u.changeWallet = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_wallet", e), n = (r = this)._strictEncodeArguments("changeWallet(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeWallet.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_wallet", e), n = (r = this)._strictEncodeArguments("changeWallet(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_wallet", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeWallet(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeWallet(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_wallet", e), this._strictEncodeArguments("changeWallet(address)", [e]);
        }
      }, u.getDividendsData = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDividendsData()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDividendsData()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDividendsData()", []);
        }
      }, u.securityToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("securityToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("securityToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("securityToken()", []);
        }
      }, u.excluded = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("excluded(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("excluded(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("index_0", e), this._strictEncodeArguments("excluded(uint256)", [e]);
        }
      }, u.getPermissions = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getPermissions()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getPermissions()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getPermissions()", []);
        }
      }, u.factory = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("factory()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("factory()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("factory()", []);
        }
      }, u.setDefaultExcluded = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_excluded", e), n = (r = this)._strictEncodeArguments("setDefaultExcluded(address[])", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.setDefaultExcluded.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_excluded", e), n = (r = this)._strictEncodeArguments("setDefaultExcluded(address[])", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_excluded", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("setDefaultExcluded(address[])", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("setDefaultExcluded(address[])").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isArray("_excluded", e), this._strictEncodeArguments("setDefaultExcluded(address[])", [e]);
        }
      }, u.pushDividendPayment = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), p.assert.isBigNumber("_start", t), p.assert.isBigNumber("_end", a), c = (o = this)._strictEncodeArguments("pushDividendPayment(uint256,uint256,uint256)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.pushDividendPayment.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), p.assert.isBigNumber("_start", t), p.assert.isBigNumber("_end", a), c = (o = this)._strictEncodeArguments("pushDividendPayment(uint256,uint256,uint256)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), p.assert.isBigNumber("_start", t), p.assert.isBigNumber("_end", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("pushDividendPayment(uint256,uint256,uint256)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("pushDividendPayment(uint256,uint256,uint256)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isBigNumber("_dividendIndex", e), p.assert.isBigNumber("_start", t), p.assert.isBigNumber("_end", a), this._strictEncodeArguments("pushDividendPayment(uint256,uint256,uint256)", [e, t, a]);
        }
      }, u.getDefaultExcluded = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDefaultExcluded()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDefaultExcluded()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDefaultExcluded()", []);
        }
      }, u.getDividendProgress = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getDividendProgress(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getDividendProgress(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_dividendIndex", e), this._strictEncodeArguments("getDividendProgress(uint256)", [e]);
        }
      }, u.getDataStore = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDataStore()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDataStore()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDataStore()", []);
        }
      }, u.createCheckpoint = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("createCheckpoint()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.createCheckpoint.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("createCheckpoint()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("createCheckpoint()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("createCheckpoint()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("createCheckpoint()", []);
        }
      }, u.createDividend = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maturity", e), p.assert.isBigNumber("_expiry", t), p.assert.isString("_token", a), p.assert.isBigNumber("_amount", r), p.assert.isString("_name", n), f = (o = this)._strictEncodeArguments("createDividend(uint256,uint256,address,uint256,bytes32)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: f
                  }), s({
                    from: h
                  }, l), o.createDividend.estimateGasAsync.bind(o, e, t, a, r, n, u))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(m)];

                case 3:
                  return y = i.sent(), v = o._web3Wrapper.awaitTransactionSuccessAsync(y), [2, new b.PolyResponse(y, v)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maturity", e), p.assert.isBigNumber("_expiry", t), p.assert.isString("_token", a), p.assert.isBigNumber("_amount", r), p.assert.isString("_name", n), f = (o = this)._strictEncodeArguments("createDividend(uint256,uint256,address,uint256,bytes32)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: f
                  }), s({
                    from: h
                  }, l))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(b)];

                case 3:
                  return m = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return y = i.sent().gasLimit, v = void 0 === c ? o._defaultEstimateGasFactor : c, _ = Math.round(v * m), [2, y < _ ? y : _];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u) {
          return void 0 === c && (c = {}), o(this, void 0, void 0, function () {
            var o, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maturity", e), p.assert.isBigNumber("_expiry", t), p.assert.isString("_token", a), p.assert.isBigNumber("_amount", r), p.assert.isString("_name", n), p.assert.doesConformToSchema("callData", c, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== u && p.assert.isBlockParam("defaultBlock", u), l = (o = this)._strictEncodeArguments("createDividend(uint256,uint256,address,uint256,bytes32)", [e, t, a, r, n]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: l
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (h = i.sent()).from = h.from ? h.from.toLowerCase() : h.from, [4, o._web3Wrapper.callAsync(h, u)];

                case 2:
                  return b = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(b), [2, o._lookupAbiEncoder("createDividend(uint256,uint256,address,uint256,bytes32)").strictDecodeReturnValue(b)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n) {
          return p.assert.isBigNumber("_maturity", e), p.assert.isBigNumber("_expiry", t), p.assert.isString("_token", a), p.assert.isBigNumber("_amount", r), p.assert.isString("_name", n), this._strictEncodeArguments("createDividend(uint256,uint256,address,uint256,bytes32)", [e, t, a, r, n]);
        }
      }, u.createDividendWithCheckpoint = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u, f) {
          return o(this, void 0, void 0, function () {
            var o, l, h, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maturity", e), p.assert.isBigNumber("_expiry", t), p.assert.isString("_token", a), p.assert.isBigNumber("_amount", r), p.assert.isBigNumber("_checkpointId", n), p.assert.isString("_name", c), l = (o = this)._strictEncodeArguments("createDividendWithCheckpoint(uint256,uint256,address,uint256,uint256,bytes32)", [e, t, a, r, n, c]), h = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return m = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: l
                  }), s({
                    from: m
                  }, h), o.createDividendWithCheckpoint.estimateGasAsync.bind(o, e, t, a, r, n, c, f))];

                case 2:
                  return void 0 !== (y = i.sent()).from && (y.from = y.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(y)];

                case 3:
                  return v = i.sent(), _ = o._web3Wrapper.awaitTransactionSuccessAsync(v), [2, new b.PolyResponse(v, _)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u, f) {
          return o(this, void 0, void 0, function () {
            var o, l, h, b, m, y, v, _, g;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maturity", e), p.assert.isBigNumber("_expiry", t), p.assert.isString("_token", a), p.assert.isBigNumber("_amount", r), p.assert.isBigNumber("_checkpointId", n), p.assert.isString("_name", c), l = (o = this)._strictEncodeArguments("createDividendWithCheckpoint(uint256,uint256,address,uint256,uint256,bytes32)", [e, t, a, r, n, c]), h = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return b = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, f, {
                    data: l
                  }), s({
                    from: b
                  }, h))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(m)];

                case 3:
                  return y = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return v = i.sent().gasLimit, _ = void 0 === u ? o._defaultEstimateGasFactor : u, g = Math.round(_ * y), [2, v < g ? v : g];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u, l) {
          return void 0 === u && (u = {}), o(this, void 0, void 0, function () {
            var o, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maturity", e), p.assert.isBigNumber("_expiry", t), p.assert.isString("_token", a), p.assert.isBigNumber("_amount", r), p.assert.isBigNumber("_checkpointId", n), p.assert.isString("_name", c), p.assert.doesConformToSchema("callData", u, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== l && p.assert.isBlockParam("defaultBlock", l), h = (o = this)._strictEncodeArguments("createDividendWithCheckpoint(uint256,uint256,address,uint256,uint256,bytes32)", [e, t, a, r, n, c]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: h
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (b = i.sent()).from = b.from ? b.from.toLowerCase() : b.from, [4, o._web3Wrapper.callAsync(b, l)];

                case 2:
                  return m = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(m), [2, o._lookupAbiEncoder("createDividendWithCheckpoint(uint256,uint256,address,uint256,uint256,bytes32)").strictDecodeReturnValue(m)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s) {
          return p.assert.isBigNumber("_maturity", e), p.assert.isBigNumber("_expiry", t), p.assert.isString("_token", a), p.assert.isBigNumber("_amount", r), p.assert.isBigNumber("_checkpointId", n), p.assert.isString("_name", s), this._strictEncodeArguments("createDividendWithCheckpoint(uint256,uint256,address,uint256,uint256,bytes32)", [e, t, a, r, n, s]);
        }
      }, u.createDividendWithExclusions = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u, f) {
          return o(this, void 0, void 0, function () {
            var o, l, h, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maturity", e), p.assert.isBigNumber("_expiry", t), p.assert.isString("_token", a), p.assert.isBigNumber("_amount", r), p.assert.isArray("_excluded", n), p.assert.isString("_name", c), l = (o = this)._strictEncodeArguments("createDividendWithExclusions(uint256,uint256,address,uint256,address[],bytes32)", [e, t, a, r, n, c]), h = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return m = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: l
                  }), s({
                    from: m
                  }, h), o.createDividendWithExclusions.estimateGasAsync.bind(o, e, t, a, r, n, c, f))];

                case 2:
                  return void 0 !== (y = i.sent()).from && (y.from = y.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(y)];

                case 3:
                  return v = i.sent(), _ = o._web3Wrapper.awaitTransactionSuccessAsync(v), [2, new b.PolyResponse(v, _)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u, f) {
          return o(this, void 0, void 0, function () {
            var o, l, h, b, m, y, v, _, g;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maturity", e), p.assert.isBigNumber("_expiry", t), p.assert.isString("_token", a), p.assert.isBigNumber("_amount", r), p.assert.isArray("_excluded", n), p.assert.isString("_name", c), l = (o = this)._strictEncodeArguments("createDividendWithExclusions(uint256,uint256,address,uint256,address[],bytes32)", [e, t, a, r, n, c]), h = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return b = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, f, {
                    data: l
                  }), s({
                    from: b
                  }, h))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(m)];

                case 3:
                  return y = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return v = i.sent().gasLimit, _ = void 0 === u ? o._defaultEstimateGasFactor : u, g = Math.round(_ * y), [2, v < g ? v : g];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u, l) {
          return void 0 === u && (u = {}), o(this, void 0, void 0, function () {
            var o, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maturity", e), p.assert.isBigNumber("_expiry", t), p.assert.isString("_token", a), p.assert.isBigNumber("_amount", r), p.assert.isArray("_excluded", n), p.assert.isString("_name", c), p.assert.doesConformToSchema("callData", u, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== l && p.assert.isBlockParam("defaultBlock", l), h = (o = this)._strictEncodeArguments("createDividendWithExclusions(uint256,uint256,address,uint256,address[],bytes32)", [e, t, a, r, n, c]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: h
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (b = i.sent()).from = b.from ? b.from.toLowerCase() : b.from, [4, o._web3Wrapper.callAsync(b, l)];

                case 2:
                  return m = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(m), [2, o._lookupAbiEncoder("createDividendWithExclusions(uint256,uint256,address,uint256,address[],bytes32)").strictDecodeReturnValue(m)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s) {
          return p.assert.isBigNumber("_maturity", e), p.assert.isBigNumber("_expiry", t), p.assert.isString("_token", a), p.assert.isBigNumber("_amount", r), p.assert.isArray("_excluded", n), p.assert.isString("_name", s), this._strictEncodeArguments("createDividendWithExclusions(uint256,uint256,address,uint256,address[],bytes32)", [e, t, a, r, n, s]);
        }
      }, u.createDividendWithCheckpointAndExclusions = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u, f, l) {
          return o(this, void 0, void 0, function () {
            var o, h, m, y, v, _, g;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maturity", e), p.assert.isBigNumber("_expiry", t), p.assert.isString("_token", a), p.assert.isBigNumber("_amount", r), p.assert.isBigNumber("_checkpointId", n), p.assert.isArray("_excluded", c), p.assert.isString("_name", u), h = (o = this)._strictEncodeArguments("createDividendWithCheckpointAndExclusions(uint256,uint256,address,uint256,uint256,address[],bytes32)", [e, t, a, r, n, c, u]), m = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return y = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, f, {
                    data: h
                  }), s({
                    from: y
                  }, m), o.createDividendWithCheckpointAndExclusions.estimateGasAsync.bind(o, e, t, a, r, n, c, u, l))];

                case 2:
                  return void 0 !== (v = i.sent()).from && (v.from = v.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(v)];

                case 3:
                  return _ = i.sent(), g = o._web3Wrapper.awaitTransactionSuccessAsync(_), [2, new b.PolyResponse(_, g)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u, f, l) {
          return o(this, void 0, void 0, function () {
            var o, h, b, m, y, v, _, g, A;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maturity", e), p.assert.isBigNumber("_expiry", t), p.assert.isString("_token", a), p.assert.isBigNumber("_amount", r), p.assert.isBigNumber("_checkpointId", n), p.assert.isArray("_excluded", c), p.assert.isString("_name", u), h = (o = this)._strictEncodeArguments("createDividendWithCheckpointAndExclusions(uint256,uint256,address,uint256,uint256,address[],bytes32)", [e, t, a, r, n, c, u]), b = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return m = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, l, {
                    data: h
                  }), s({
                    from: m
                  }, b))];

                case 2:
                  return void 0 !== (y = i.sent()).from && (y.from = y.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(y)];

                case 3:
                  return v = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return _ = i.sent().gasLimit, g = void 0 === f ? o._defaultEstimateGasFactor : f, A = Math.round(g * v), [2, _ < A ? _ : A];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u, l, h) {
          return void 0 === l && (l = {}), o(this, void 0, void 0, function () {
            var o, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maturity", e), p.assert.isBigNumber("_expiry", t), p.assert.isString("_token", a), p.assert.isBigNumber("_amount", r), p.assert.isBigNumber("_checkpointId", n), p.assert.isArray("_excluded", c), p.assert.isString("_name", u), p.assert.doesConformToSchema("callData", l, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== h && p.assert.isBlockParam("defaultBlock", h), b = (o = this)._strictEncodeArguments("createDividendWithCheckpointAndExclusions(uint256,uint256,address,uint256,uint256,address[],bytes32)", [e, t, a, r, n, c, u]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, l, {
                    data: b
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (m = i.sent()).from = m.from ? m.from.toLowerCase() : m.from, [4, o._web3Wrapper.callAsync(m, h)];

                case 2:
                  return y = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(y), [2, o._lookupAbiEncoder("createDividendWithCheckpointAndExclusions(uint256,uint256,address,uint256,uint256,address[],bytes32)").strictDecodeReturnValue(y)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s, o) {
          return p.assert.isBigNumber("_maturity", e), p.assert.isBigNumber("_expiry", t), p.assert.isString("_token", a), p.assert.isBigNumber("_amount", r), p.assert.isBigNumber("_checkpointId", n), p.assert.isArray("_excluded", s), p.assert.isString("_name", o), this._strictEncodeArguments("createDividendWithCheckpointAndExclusions(uint256,uint256,address,uint256,uint256,address[],bytes32)", [e, t, a, r, n, s, o]);
        }
      }, u.reclaimDividend = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), n = (r = this)._strictEncodeArguments("reclaimDividend(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.reclaimDividend.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), n = (r = this)._strictEncodeArguments("reclaimDividend(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("reclaimDividend(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("reclaimDividend(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_dividendIndex", e), this._strictEncodeArguments("reclaimDividend(uint256)", [e]);
        }
      }, u.withdrawWithholding = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), n = (r = this)._strictEncodeArguments("withdrawWithholding(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.withdrawWithholding.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), n = (r = this)._strictEncodeArguments("withdrawWithholding(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("withdrawWithholding(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("withdrawWithholding(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_dividendIndex", e), this._strictEncodeArguments("withdrawWithholding(uint256)", [e]);
        }
      }, u._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, l.classUtils.bindAll(u, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), u;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n, s, u) {
      return o(this, void 0, void 0, function () {
        var o, b, m, v, _, g, A, w, T, x, D;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return p.assert.isHexString("bytecode", e), p.assert.doesConformToSchema("txDefaults", n, f.schemas.txDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), o = l.providerUtils.standardizeOrThrow(r), b = d.BaseContract._lookupConstructorAbi(a), D = c(d.BaseContract._formatABIDataItemList(b.inputs, [s, u], d.BaseContract._bigNumberToString), 2), s = D[0], u = D[1], m = new y.utils.Interface(a), v = m.deployFunction, _ = v.encode(e, [s, u]), g = new h.Web3Wrapper(o), [4, d.BaseContract._applyDefaultsToTxDataAsync({
                data: _
              }, n, g.estimateGasAsync.bind(g))];

            case 1:
              return A = i.sent(), [4, g.sendTransactionAsync(A)];

            case 2:
              return w = i.sent(), l.logUtils.log("transactionHash: " + w), [4, g.awaitTransactionSuccessAsync(w)];

            case 3:
              return T = i.sent(), l.logUtils.log("ERC20DividendCheckpoint successfully deployed at " + T.contractAddress), (x = new t(T.contractAddress, o, n)).constructorArgs = [s, u], [2, x];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !1,
        inputs: [{
          name: "_investors",
          type: "address[]"
        }, {
          name: "_withholding",
          type: "uint256"
        }],
        name: "setWithholdingFixed",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "EXCLUDED_ADDRESS_LIMIT",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "reclaimETH",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getInitFunction",
        outputs: [{
          name: "",
          type: "bytes4"
        }],
        payable: !1,
        stateMutability: "pure",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_dividendIndex",
          type: "uint256"
        }],
        name: "getDividendData",
        outputs: [{
          name: "created",
          type: "uint256"
        }, {
          name: "maturity",
          type: "uint256"
        }, {
          name: "expiry",
          type: "uint256"
        }, {
          name: "amount",
          type: "uint256"
        }, {
          name: "claimedAmount",
          type: "uint256"
        }, {
          name: "name",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "ADMIN",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getTreasuryWallet",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_dividendIndex",
          type: "uint256"
        }],
        name: "pullDividendPayment",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "address"
        }],
        name: "investorWithheld",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "unpause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_dividendIndex",
          type: "uint256"
        }, {
          name: "_payees",
          type: "address[]"
        }],
        name: "pushDividendPaymentToAddresses",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "wallet",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_investor",
          type: "address"
        }, {
          name: "_dividendIndex",
          type: "uint256"
        }],
        name: "isClaimed",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_dividendIndex",
          type: "uint256"
        }, {
          name: "_payee",
          type: "address"
        }],
        name: "calculateDividend",
        outputs: [{
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "paused",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_checkpointId",
          type: "uint256"
        }],
        name: "getDividendIndex",
        outputs: [{
          name: "",
          type: "uint256[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "polyToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_dividendIndex",
          type: "uint256"
        }, {
          name: "_maturity",
          type: "uint256"
        }, {
          name: "_expiry",
          type: "uint256"
        }],
        name: "updateDividendDates",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_wallet",
          type: "address"
        }],
        name: "configure",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "address"
        }],
        name: "withholdingTax",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_checkpointId",
          type: "uint256"
        }],
        name: "getCheckpointData",
        outputs: [{
          name: "investors",
          type: "address[]"
        }, {
          name: "balances",
          type: "uint256[]"
        }, {
          name: "withholdings",
          type: "uint256[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "uint256"
        }],
        name: "dividends",
        outputs: [{
          name: "checkpointId",
          type: "uint256"
        }, {
          name: "created",
          type: "uint256"
        }, {
          name: "maturity",
          type: "uint256"
        }, {
          name: "expiry",
          type: "uint256"
        }, {
          name: "amount",
          type: "uint256"
        }, {
          name: "claimedAmount",
          type: "uint256"
        }, {
          name: "totalSupply",
          type: "uint256"
        }, {
          name: "reclaimed",
          type: "bool"
        }, {
          name: "totalWithheld",
          type: "uint256"
        }, {
          name: "totalWithheldWithdrawn",
          type: "uint256"
        }, {
          name: "name",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_investor",
          type: "address"
        }, {
          name: "_dividendIndex",
          type: "uint256"
        }],
        name: "isExcluded",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "pause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_investors",
          type: "address[]"
        }, {
          name: "_withholding",
          type: "uint256[]"
        }],
        name: "setWithholding",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenContract",
          type: "address"
        }],
        name: "reclaimERC20",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "uint256"
        }],
        name: "dividendTokens",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "OPERATOR",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_wallet",
          type: "address"
        }],
        name: "changeWallet",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDividendsData",
        outputs: [{
          name: "createds",
          type: "uint256[]"
        }, {
          name: "maturitys",
          type: "uint256[]"
        }, {
          name: "expirys",
          type: "uint256[]"
        }, {
          name: "amounts",
          type: "uint256[]"
        }, {
          name: "claimedAmounts",
          type: "uint256[]"
        }, {
          name: "names",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "securityToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "uint256"
        }],
        name: "excluded",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getPermissions",
        outputs: [{
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "factory",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_excluded",
          type: "address[]"
        }],
        name: "setDefaultExcluded",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_dividendIndex",
          type: "uint256"
        }, {
          name: "_start",
          type: "uint256"
        }, {
          name: "_end",
          type: "uint256"
        }],
        name: "pushDividendPayment",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDefaultExcluded",
        outputs: [{
          name: "",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_dividendIndex",
          type: "uint256"
        }],
        name: "getDividendProgress",
        outputs: [{
          name: "investors",
          type: "address[]"
        }, {
          name: "resultClaimed",
          type: "bool[]"
        }, {
          name: "resultExcluded",
          type: "bool[]"
        }, {
          name: "resultWithheld",
          type: "uint256[]"
        }, {
          name: "resultAmount",
          type: "uint256[]"
        }, {
          name: "resultBalance",
          type: "uint256[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDataStore",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "createCheckpoint",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        inputs: [{
          name: "_securityToken",
          type: "address"
        }, {
          name: "_polyToken",
          type: "address"
        }],
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "constructor"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_depositor",
          type: "address",
          indexed: !0
        }, {
          name: "_checkpointId",
          type: "uint256",
          indexed: !1
        }, {
          name: "_maturity",
          type: "uint256",
          indexed: !1
        }, {
          name: "_expiry",
          type: "uint256",
          indexed: !1
        }, {
          name: "_token",
          type: "address",
          indexed: !0
        }, {
          name: "_amount",
          type: "uint256",
          indexed: !1
        }, {
          name: "_totalSupply",
          type: "uint256",
          indexed: !1
        }, {
          name: "_dividendIndex",
          type: "uint256",
          indexed: !1
        }, {
          name: "_name",
          type: "bytes32",
          indexed: !0
        }],
        name: "ERC20DividendDeposited",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_payee",
          type: "address",
          indexed: !0
        }, {
          name: "_dividendIndex",
          type: "uint256",
          indexed: !0
        }, {
          name: "_token",
          type: "address",
          indexed: !0
        }, {
          name: "_amount",
          type: "uint256",
          indexed: !1
        }, {
          name: "_withheld",
          type: "uint256",
          indexed: !1
        }],
        name: "ERC20DividendClaimed",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_claimer",
          type: "address",
          indexed: !0
        }, {
          name: "_dividendIndex",
          type: "uint256",
          indexed: !0
        }, {
          name: "_token",
          type: "address",
          indexed: !0
        }, {
          name: "_claimedAmount",
          type: "uint256",
          indexed: !1
        }],
        name: "ERC20DividendReclaimed",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_claimer",
          type: "address",
          indexed: !0
        }, {
          name: "_dividendIndex",
          type: "uint256",
          indexed: !0
        }, {
          name: "_token",
          type: "address",
          indexed: !0
        }, {
          name: "_withheldAmount",
          type: "uint256",
          indexed: !1
        }],
        name: "ERC20DividendWithholdingWithdrawn",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_excluded",
          type: "address[]",
          indexed: !1
        }],
        name: "SetDefaultExcludedAddresses",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_investors",
          type: "address[]",
          indexed: !1
        }, {
          name: "_withholding",
          type: "uint256[]",
          indexed: !1
        }],
        name: "SetWithholding",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_investors",
          type: "address[]",
          indexed: !1
        }, {
          name: "_withholding",
          type: "uint256",
          indexed: !1
        }],
        name: "SetWithholdingFixed",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_oldWallet",
          type: "address",
          indexed: !0
        }, {
          name: "_newWallet",
          type: "address",
          indexed: !0
        }],
        name: "SetWallet",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_dividendIndex",
          type: "uint256",
          indexed: !0
        }, {
          name: "_maturity",
          type: "uint256",
          indexed: !1
        }, {
          name: "_expiry",
          type: "uint256",
          indexed: !1
        }],
        name: "UpdateDividendDates",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Pause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Unpause",
        outputs: [],
        type: "event"
      }, {
        constant: !1,
        inputs: [{
          name: "_maturity",
          type: "uint256"
        }, {
          name: "_expiry",
          type: "uint256"
        }, {
          name: "_token",
          type: "address"
        }, {
          name: "_amount",
          type: "uint256"
        }, {
          name: "_name",
          type: "bytes32"
        }],
        name: "createDividend",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_maturity",
          type: "uint256"
        }, {
          name: "_expiry",
          type: "uint256"
        }, {
          name: "_token",
          type: "address"
        }, {
          name: "_amount",
          type: "uint256"
        }, {
          name: "_checkpointId",
          type: "uint256"
        }, {
          name: "_name",
          type: "bytes32"
        }],
        name: "createDividendWithCheckpoint",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_maturity",
          type: "uint256"
        }, {
          name: "_expiry",
          type: "uint256"
        }, {
          name: "_token",
          type: "address"
        }, {
          name: "_amount",
          type: "uint256"
        }, {
          name: "_excluded",
          type: "address[]"
        }, {
          name: "_name",
          type: "bytes32"
        }],
        name: "createDividendWithExclusions",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_maturity",
          type: "uint256"
        }, {
          name: "_expiry",
          type: "uint256"
        }, {
          name: "_token",
          type: "address"
        }, {
          name: "_amount",
          type: "uint256"
        }, {
          name: "_checkpointId",
          type: "uint256"
        }, {
          name: "_excluded",
          type: "address[]"
        }, {
          name: "_name",
          type: "bytes32"
        }],
        name: "createDividendWithCheckpointAndExclusions",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_dividendIndex",
          type: "uint256"
        }],
        name: "reclaimDividend",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_dividendIndex",
          type: "uint256"
        }],
        name: "withdrawWithholding",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(d.BaseContract);

  t.ERC20DividendCheckpointContract_3_0_0 = v, t.isERC20DividendCheckpointContract_3_0_0 = function (e) {
    return m.isEqual(v.ABI(), e.abi);
  };
},
/*!******************************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/ether_dividend_checkpoint.js ***!
  \******************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r77,
      n = this && this.__extends || (_r77 = function r(e, t) {
    return (_r77 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r77(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      c = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || 0 < t--) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u,
      d = a(
  /*! @0x/base-contract */
  12),
      f = a(
  /*! @0x/json-schemas */
  2),
      l = a(
  /*! @0x/utils */
  8),
      h = a(
  /*! @0x/web3-wrapper */
  11),
      p = a(
  /*! @0x/assert */
  10),
      b = a(
  /*! ../../PolyResponse */
  14),
      m = a(
  /*! lodash */
  0),
      y = a(
  /*! ethers */
  13);
  (u = t.EtherDividendCheckpointEvents_3_0_0 || (t.EtherDividendCheckpointEvents_3_0_0 = {})).EtherDividendDeposited = "EtherDividendDeposited", u.EtherDividendClaimed = "EtherDividendClaimed", u.EtherDividendReclaimed = "EtherDividendReclaimed", u.EtherDividendClaimFailed = "EtherDividendClaimFailed", u.EtherDividendWithholdingWithdrawn = "EtherDividendWithholdingWithdrawn", u.SetDefaultExcludedAddresses = "SetDefaultExcludedAddresses", u.SetWithholding = "SetWithholding", u.SetWithholdingFixed = "SetWithholdingFixed", u.SetWallet = "SetWallet", u.UpdateDividendDates = "UpdateDividendDates", u.Pause = "Pause", u.Unpause = "Unpause";

  var v = function (e) {
    function t(a, r, n, c) {
      var u = e.call(this, "EtherDividendCheckpoint", t.ABI(), a, r, n) || this;
      return u.setWithholdingFixed = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isBigNumber("_withholding", t), o = (n = this)._strictEncodeArguments("setWithholdingFixed(address[],uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.setWithholdingFixed.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isBigNumber("_withholding", t), o = (n = this)._strictEncodeArguments("setWithholdingFixed(address[],uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isBigNumber("_withholding", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("setWithholdingFixed(address[],uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("setWithholdingFixed(address[],uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isArray("_investors", e), p.assert.isBigNumber("_withholding", t), this._strictEncodeArguments("setWithholdingFixed(address[],uint256)", [e, t]);
        }
      }, u.EXCLUDED_ADDRESS_LIMIT = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("EXCLUDED_ADDRESS_LIMIT()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("EXCLUDED_ADDRESS_LIMIT()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("EXCLUDED_ADDRESS_LIMIT()", []);
        }
      }, u.reclaimETH = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.reclaimETH.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("reclaimETH()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("reclaimETH()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("reclaimETH()", []);
        }
      }, u.getInitFunction = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getInitFunction()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getInitFunction()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getInitFunction()", []);
        }
      }, u.getDividendData = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getDividendData(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getDividendData(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_dividendIndex", e), this._strictEncodeArguments("getDividendData(uint256)", [e]);
        }
      }, u.ADMIN = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("ADMIN()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("ADMIN()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("ADMIN()", []);
        }
      }, u.getTreasuryWallet = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getTreasuryWallet()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getTreasuryWallet()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getTreasuryWallet()", []);
        }
      }, u.pullDividendPayment = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), n = (r = this)._strictEncodeArguments("pullDividendPayment(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.pullDividendPayment.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), n = (r = this)._strictEncodeArguments("pullDividendPayment(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("pullDividendPayment(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("pullDividendPayment(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_dividendIndex", e), this._strictEncodeArguments("pullDividendPayment(uint256)", [e]);
        }
      }, u.investorWithheld = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("investorWithheld(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("investorWithheld(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("index_0", e), this._strictEncodeArguments("investorWithheld(address)", [e]);
        }
      }, u.unpause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.unpause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("unpause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("unpause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("unpause()", []);
        }
      }, u.pushDividendPaymentToAddresses = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), p.assert.isArray("_payees", t), o = (n = this)._strictEncodeArguments("pushDividendPaymentToAddresses(uint256,address[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.pushDividendPaymentToAddresses.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), p.assert.isArray("_payees", t), o = (n = this)._strictEncodeArguments("pushDividendPaymentToAddresses(uint256,address[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), p.assert.isArray("_payees", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("pushDividendPaymentToAddresses(uint256,address[])", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("pushDividendPaymentToAddresses(uint256,address[])").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isBigNumber("_dividendIndex", e), p.assert.isArray("_payees", t), this._strictEncodeArguments("pushDividendPaymentToAddresses(uint256,address[])", [e, t]);
        }
      }, u.wallet = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("wallet()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("wallet()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("wallet()", []);
        }
      }, u.isClaimed = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.isBigNumber("_dividendIndex", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("isClaimed(address,uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("isClaimed(address,uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_investor", e), p.assert.isBigNumber("_dividendIndex", t), this._strictEncodeArguments("isClaimed(address,uint256)", [e, t]);
        }
      }, u.calculateDividend = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), p.assert.isString("_payee", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("calculateDividend(uint256,address)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("calculateDividend(uint256,address)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isBigNumber("_dividendIndex", e), p.assert.isString("_payee", t), this._strictEncodeArguments("calculateDividend(uint256,address)", [e, t]);
        }
      }, u.paused = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("paused()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("paused()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("paused()", []);
        }
      }, u.getDividendIndex = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_checkpointId", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getDividendIndex(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getDividendIndex(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_checkpointId", e), this._strictEncodeArguments("getDividendIndex(uint256)", [e]);
        }
      }, u.polyToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("polyToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("polyToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("polyToken()", []);
        }
      }, u.updateDividendDates = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), p.assert.isBigNumber("_maturity", t), p.assert.isBigNumber("_expiry", a), c = (o = this)._strictEncodeArguments("updateDividendDates(uint256,uint256,uint256)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.updateDividendDates.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), p.assert.isBigNumber("_maturity", t), p.assert.isBigNumber("_expiry", a), c = (o = this)._strictEncodeArguments("updateDividendDates(uint256,uint256,uint256)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), p.assert.isBigNumber("_maturity", t), p.assert.isBigNumber("_expiry", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("updateDividendDates(uint256,uint256,uint256)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("updateDividendDates(uint256,uint256,uint256)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isBigNumber("_dividendIndex", e), p.assert.isBigNumber("_maturity", t), p.assert.isBigNumber("_expiry", a), this._strictEncodeArguments("updateDividendDates(uint256,uint256,uint256)", [e, t, a]);
        }
      }, u.configure = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_wallet", e), n = (r = this)._strictEncodeArguments("configure(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.configure.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_wallet", e), n = (r = this)._strictEncodeArguments("configure(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_wallet", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("configure(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("configure(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_wallet", e), this._strictEncodeArguments("configure(address)", [e]);
        }
      }, u.withholdingTax = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("withholdingTax(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("withholdingTax(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("index_0", e), this._strictEncodeArguments("withholdingTax(address)", [e]);
        }
      }, u.getCheckpointData = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_checkpointId", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getCheckpointData(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getCheckpointData(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_checkpointId", e), this._strictEncodeArguments("getCheckpointData(uint256)", [e]);
        }
      }, u.dividends = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("dividends(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("dividends(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("index_0", e), this._strictEncodeArguments("dividends(uint256)", [e]);
        }
      }, u.isExcluded = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.isBigNumber("_dividendIndex", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("isExcluded(address,uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("isExcluded(address,uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_investor", e), p.assert.isBigNumber("_dividendIndex", t), this._strictEncodeArguments("isExcluded(address,uint256)", [e, t]);
        }
      }, u.pause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.pause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pause()", []);
        }
      }, u.setWithholding = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isArray("_withholding", t), o = (n = this)._strictEncodeArguments("setWithholding(address[],uint256[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.setWithholding.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isArray("_withholding", t), o = (n = this)._strictEncodeArguments("setWithholding(address[],uint256[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isArray("_withholding", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("setWithholding(address[],uint256[])", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("setWithholding(address[],uint256[])").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isArray("_investors", e), p.assert.isArray("_withholding", t), this._strictEncodeArguments("setWithholding(address[],uint256[])", [e, t]);
        }
      }, u.reclaimERC20 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.reclaimERC20.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("reclaimERC20(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_tokenContract", e), this._strictEncodeArguments("reclaimERC20(address)", [e]);
        }
      }, u.OPERATOR = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("OPERATOR()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("OPERATOR()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("OPERATOR()", []);
        }
      }, u.changeWallet = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_wallet", e), n = (r = this)._strictEncodeArguments("changeWallet(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeWallet.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_wallet", e), n = (r = this)._strictEncodeArguments("changeWallet(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_wallet", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeWallet(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeWallet(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_wallet", e), this._strictEncodeArguments("changeWallet(address)", [e]);
        }
      }, u.getDividendsData = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDividendsData()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDividendsData()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDividendsData()", []);
        }
      }, u.securityToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("securityToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("securityToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("securityToken()", []);
        }
      }, u.excluded = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("excluded(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("excluded(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("index_0", e), this._strictEncodeArguments("excluded(uint256)", [e]);
        }
      }, u.getPermissions = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getPermissions()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getPermissions()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getPermissions()", []);
        }
      }, u.factory = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("factory()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("factory()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("factory()", []);
        }
      }, u.setDefaultExcluded = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_excluded", e), n = (r = this)._strictEncodeArguments("setDefaultExcluded(address[])", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.setDefaultExcluded.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_excluded", e), n = (r = this)._strictEncodeArguments("setDefaultExcluded(address[])", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_excluded", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("setDefaultExcluded(address[])", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("setDefaultExcluded(address[])").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isArray("_excluded", e), this._strictEncodeArguments("setDefaultExcluded(address[])", [e]);
        }
      }, u.pushDividendPayment = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), p.assert.isBigNumber("_start", t), p.assert.isBigNumber("_end", a), c = (o = this)._strictEncodeArguments("pushDividendPayment(uint256,uint256,uint256)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.pushDividendPayment.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), p.assert.isBigNumber("_start", t), p.assert.isBigNumber("_end", a), c = (o = this)._strictEncodeArguments("pushDividendPayment(uint256,uint256,uint256)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), p.assert.isBigNumber("_start", t), p.assert.isBigNumber("_end", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("pushDividendPayment(uint256,uint256,uint256)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("pushDividendPayment(uint256,uint256,uint256)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isBigNumber("_dividendIndex", e), p.assert.isBigNumber("_start", t), p.assert.isBigNumber("_end", a), this._strictEncodeArguments("pushDividendPayment(uint256,uint256,uint256)", [e, t, a]);
        }
      }, u.getDefaultExcluded = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDefaultExcluded()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDefaultExcluded()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDefaultExcluded()", []);
        }
      }, u.getDividendProgress = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getDividendProgress(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getDividendProgress(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_dividendIndex", e), this._strictEncodeArguments("getDividendProgress(uint256)", [e]);
        }
      }, u.getDataStore = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDataStore()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDataStore()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDataStore()", []);
        }
      }, u.createCheckpoint = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("createCheckpoint()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.createCheckpoint.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("createCheckpoint()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("createCheckpoint()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("createCheckpoint()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("createCheckpoint()", []);
        }
      }, u.createDividend = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maturity", e), p.assert.isBigNumber("_expiry", t), p.assert.isString("_name", a), c = (o = this)._strictEncodeArguments("createDividend(uint256,uint256,bytes32)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.createDividend.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maturity", e), p.assert.isBigNumber("_expiry", t), p.assert.isString("_name", a), c = (o = this)._strictEncodeArguments("createDividend(uint256,uint256,bytes32)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maturity", e), p.assert.isBigNumber("_expiry", t), p.assert.isString("_name", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("createDividend(uint256,uint256,bytes32)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("createDividend(uint256,uint256,bytes32)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isBigNumber("_maturity", e), p.assert.isBigNumber("_expiry", t), p.assert.isString("_name", a), this._strictEncodeArguments("createDividend(uint256,uint256,bytes32)", [e, t, a]);
        }
      }, u.createDividendWithCheckpoint = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maturity", e), p.assert.isBigNumber("_expiry", t), p.assert.isBigNumber("_checkpointId", a), p.assert.isString("_name", r), u = (o = this)._strictEncodeArguments("createDividendWithCheckpoint(uint256,uint256,uint256,bytes32)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.createDividendWithCheckpoint.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maturity", e), p.assert.isBigNumber("_expiry", t), p.assert.isBigNumber("_checkpointId", a), p.assert.isString("_name", r), u = (o = this)._strictEncodeArguments("createDividendWithCheckpoint(uint256,uint256,uint256,bytes32)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maturity", e), p.assert.isBigNumber("_expiry", t), p.assert.isBigNumber("_checkpointId", a), p.assert.isString("_name", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("createDividendWithCheckpoint(uint256,uint256,uint256,bytes32)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("createDividendWithCheckpoint(uint256,uint256,uint256,bytes32)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isBigNumber("_maturity", e), p.assert.isBigNumber("_expiry", t), p.assert.isBigNumber("_checkpointId", a), p.assert.isString("_name", r), this._strictEncodeArguments("createDividendWithCheckpoint(uint256,uint256,uint256,bytes32)", [e, t, a, r]);
        }
      }, u.createDividendWithExclusions = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maturity", e), p.assert.isBigNumber("_expiry", t), p.assert.isArray("_excluded", a), p.assert.isString("_name", r), u = (o = this)._strictEncodeArguments("createDividendWithExclusions(uint256,uint256,address[],bytes32)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.createDividendWithExclusions.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maturity", e), p.assert.isBigNumber("_expiry", t), p.assert.isArray("_excluded", a), p.assert.isString("_name", r), u = (o = this)._strictEncodeArguments("createDividendWithExclusions(uint256,uint256,address[],bytes32)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maturity", e), p.assert.isBigNumber("_expiry", t), p.assert.isArray("_excluded", a), p.assert.isString("_name", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("createDividendWithExclusions(uint256,uint256,address[],bytes32)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("createDividendWithExclusions(uint256,uint256,address[],bytes32)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isBigNumber("_maturity", e), p.assert.isBigNumber("_expiry", t), p.assert.isArray("_excluded", a), p.assert.isString("_name", r), this._strictEncodeArguments("createDividendWithExclusions(uint256,uint256,address[],bytes32)", [e, t, a, r]);
        }
      }, u.createDividendWithCheckpointAndExclusions = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maturity", e), p.assert.isBigNumber("_expiry", t), p.assert.isBigNumber("_checkpointId", a), p.assert.isArray("_excluded", r), p.assert.isString("_name", n), f = (o = this)._strictEncodeArguments("createDividendWithCheckpointAndExclusions(uint256,uint256,uint256,address[],bytes32)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: f
                  }), s({
                    from: h
                  }, l), o.createDividendWithCheckpointAndExclusions.estimateGasAsync.bind(o, e, t, a, r, n, u))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(m)];

                case 3:
                  return y = i.sent(), v = o._web3Wrapper.awaitTransactionSuccessAsync(y), [2, new b.PolyResponse(y, v)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maturity", e), p.assert.isBigNumber("_expiry", t), p.assert.isBigNumber("_checkpointId", a), p.assert.isArray("_excluded", r), p.assert.isString("_name", n), f = (o = this)._strictEncodeArguments("createDividendWithCheckpointAndExclusions(uint256,uint256,uint256,address[],bytes32)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: f
                  }), s({
                    from: h
                  }, l))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(b)];

                case 3:
                  return m = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return y = i.sent().gasLimit, v = void 0 === c ? o._defaultEstimateGasFactor : c, _ = Math.round(v * m), [2, y < _ ? y : _];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u) {
          return void 0 === c && (c = {}), o(this, void 0, void 0, function () {
            var o, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maturity", e), p.assert.isBigNumber("_expiry", t), p.assert.isBigNumber("_checkpointId", a), p.assert.isArray("_excluded", r), p.assert.isString("_name", n), p.assert.doesConformToSchema("callData", c, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== u && p.assert.isBlockParam("defaultBlock", u), l = (o = this)._strictEncodeArguments("createDividendWithCheckpointAndExclusions(uint256,uint256,uint256,address[],bytes32)", [e, t, a, r, n]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: l
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (h = i.sent()).from = h.from ? h.from.toLowerCase() : h.from, [4, o._web3Wrapper.callAsync(h, u)];

                case 2:
                  return b = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(b), [2, o._lookupAbiEncoder("createDividendWithCheckpointAndExclusions(uint256,uint256,uint256,address[],bytes32)").strictDecodeReturnValue(b)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n) {
          return p.assert.isBigNumber("_maturity", e), p.assert.isBigNumber("_expiry", t), p.assert.isBigNumber("_checkpointId", a), p.assert.isArray("_excluded", r), p.assert.isString("_name", n), this._strictEncodeArguments("createDividendWithCheckpointAndExclusions(uint256,uint256,uint256,address[],bytes32)", [e, t, a, r, n]);
        }
      }, u.reclaimDividend = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), n = (r = this)._strictEncodeArguments("reclaimDividend(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.reclaimDividend.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), n = (r = this)._strictEncodeArguments("reclaimDividend(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("reclaimDividend(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("reclaimDividend(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_dividendIndex", e), this._strictEncodeArguments("reclaimDividend(uint256)", [e]);
        }
      }, u.withdrawWithholding = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), n = (r = this)._strictEncodeArguments("withdrawWithholding(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.withdrawWithholding.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), n = (r = this)._strictEncodeArguments("withdrawWithholding(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_dividendIndex", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("withdrawWithholding(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("withdrawWithholding(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_dividendIndex", e), this._strictEncodeArguments("withdrawWithholding(uint256)", [e]);
        }
      }, u._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, l.classUtils.bindAll(u, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), u;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n, s, u) {
      return o(this, void 0, void 0, function () {
        var o, b, m, v, _, g, A, w, T, x, D;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return p.assert.isHexString("bytecode", e), p.assert.doesConformToSchema("txDefaults", n, f.schemas.txDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), o = l.providerUtils.standardizeOrThrow(r), b = d.BaseContract._lookupConstructorAbi(a), D = c(d.BaseContract._formatABIDataItemList(b.inputs, [s, u], d.BaseContract._bigNumberToString), 2), s = D[0], u = D[1], m = new y.utils.Interface(a), v = m.deployFunction, _ = v.encode(e, [s, u]), g = new h.Web3Wrapper(o), [4, d.BaseContract._applyDefaultsToTxDataAsync({
                data: _
              }, n, g.estimateGasAsync.bind(g))];

            case 1:
              return A = i.sent(), [4, g.sendTransactionAsync(A)];

            case 2:
              return w = i.sent(), l.logUtils.log("transactionHash: " + w), [4, g.awaitTransactionSuccessAsync(w)];

            case 3:
              return T = i.sent(), l.logUtils.log("EtherDividendCheckpoint successfully deployed at " + T.contractAddress), (x = new t(T.contractAddress, o, n)).constructorArgs = [s, u], [2, x];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !1,
        inputs: [{
          name: "_investors",
          type: "address[]"
        }, {
          name: "_withholding",
          type: "uint256"
        }],
        name: "setWithholdingFixed",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "EXCLUDED_ADDRESS_LIMIT",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "reclaimETH",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getInitFunction",
        outputs: [{
          name: "",
          type: "bytes4"
        }],
        payable: !1,
        stateMutability: "pure",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_dividendIndex",
          type: "uint256"
        }],
        name: "getDividendData",
        outputs: [{
          name: "created",
          type: "uint256"
        }, {
          name: "maturity",
          type: "uint256"
        }, {
          name: "expiry",
          type: "uint256"
        }, {
          name: "amount",
          type: "uint256"
        }, {
          name: "claimedAmount",
          type: "uint256"
        }, {
          name: "name",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "ADMIN",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getTreasuryWallet",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_dividendIndex",
          type: "uint256"
        }],
        name: "pullDividendPayment",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "address"
        }],
        name: "investorWithheld",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "unpause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_dividendIndex",
          type: "uint256"
        }, {
          name: "_payees",
          type: "address[]"
        }],
        name: "pushDividendPaymentToAddresses",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "wallet",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_investor",
          type: "address"
        }, {
          name: "_dividendIndex",
          type: "uint256"
        }],
        name: "isClaimed",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_dividendIndex",
          type: "uint256"
        }, {
          name: "_payee",
          type: "address"
        }],
        name: "calculateDividend",
        outputs: [{
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "paused",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_checkpointId",
          type: "uint256"
        }],
        name: "getDividendIndex",
        outputs: [{
          name: "",
          type: "uint256[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "polyToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_dividendIndex",
          type: "uint256"
        }, {
          name: "_maturity",
          type: "uint256"
        }, {
          name: "_expiry",
          type: "uint256"
        }],
        name: "updateDividendDates",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_wallet",
          type: "address"
        }],
        name: "configure",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "address"
        }],
        name: "withholdingTax",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_checkpointId",
          type: "uint256"
        }],
        name: "getCheckpointData",
        outputs: [{
          name: "investors",
          type: "address[]"
        }, {
          name: "balances",
          type: "uint256[]"
        }, {
          name: "withholdings",
          type: "uint256[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "uint256"
        }],
        name: "dividends",
        outputs: [{
          name: "checkpointId",
          type: "uint256"
        }, {
          name: "created",
          type: "uint256"
        }, {
          name: "maturity",
          type: "uint256"
        }, {
          name: "expiry",
          type: "uint256"
        }, {
          name: "amount",
          type: "uint256"
        }, {
          name: "claimedAmount",
          type: "uint256"
        }, {
          name: "totalSupply",
          type: "uint256"
        }, {
          name: "reclaimed",
          type: "bool"
        }, {
          name: "totalWithheld",
          type: "uint256"
        }, {
          name: "totalWithheldWithdrawn",
          type: "uint256"
        }, {
          name: "name",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_investor",
          type: "address"
        }, {
          name: "_dividendIndex",
          type: "uint256"
        }],
        name: "isExcluded",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "pause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_investors",
          type: "address[]"
        }, {
          name: "_withholding",
          type: "uint256[]"
        }],
        name: "setWithholding",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenContract",
          type: "address"
        }],
        name: "reclaimERC20",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "OPERATOR",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_wallet",
          type: "address"
        }],
        name: "changeWallet",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDividendsData",
        outputs: [{
          name: "createds",
          type: "uint256[]"
        }, {
          name: "maturitys",
          type: "uint256[]"
        }, {
          name: "expirys",
          type: "uint256[]"
        }, {
          name: "amounts",
          type: "uint256[]"
        }, {
          name: "claimedAmounts",
          type: "uint256[]"
        }, {
          name: "names",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "securityToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "uint256"
        }],
        name: "excluded",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getPermissions",
        outputs: [{
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "factory",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_excluded",
          type: "address[]"
        }],
        name: "setDefaultExcluded",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_dividendIndex",
          type: "uint256"
        }, {
          name: "_start",
          type: "uint256"
        }, {
          name: "_end",
          type: "uint256"
        }],
        name: "pushDividendPayment",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDefaultExcluded",
        outputs: [{
          name: "",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_dividendIndex",
          type: "uint256"
        }],
        name: "getDividendProgress",
        outputs: [{
          name: "investors",
          type: "address[]"
        }, {
          name: "resultClaimed",
          type: "bool[]"
        }, {
          name: "resultExcluded",
          type: "bool[]"
        }, {
          name: "resultWithheld",
          type: "uint256[]"
        }, {
          name: "resultAmount",
          type: "uint256[]"
        }, {
          name: "resultBalance",
          type: "uint256[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDataStore",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "createCheckpoint",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        inputs: [{
          name: "_securityToken",
          type: "address"
        }, {
          name: "_polyToken",
          type: "address"
        }],
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "constructor"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_depositor",
          type: "address",
          indexed: !0
        }, {
          name: "_checkpointId",
          type: "uint256",
          indexed: !1
        }, {
          name: "_maturity",
          type: "uint256",
          indexed: !1
        }, {
          name: "_expiry",
          type: "uint256",
          indexed: !1
        }, {
          name: "_amount",
          type: "uint256",
          indexed: !1
        }, {
          name: "_totalSupply",
          type: "uint256",
          indexed: !1
        }, {
          name: "_dividendIndex",
          type: "uint256",
          indexed: !0
        }, {
          name: "_name",
          type: "bytes32",
          indexed: !0
        }],
        name: "EtherDividendDeposited",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_payee",
          type: "address",
          indexed: !0
        }, {
          name: "_dividendIndex",
          type: "uint256",
          indexed: !0
        }, {
          name: "_amount",
          type: "uint256",
          indexed: !1
        }, {
          name: "_withheld",
          type: "uint256",
          indexed: !1
        }],
        name: "EtherDividendClaimed",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_claimer",
          type: "address",
          indexed: !0
        }, {
          name: "_dividendIndex",
          type: "uint256",
          indexed: !0
        }, {
          name: "_claimedAmount",
          type: "uint256",
          indexed: !1
        }],
        name: "EtherDividendReclaimed",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_payee",
          type: "address",
          indexed: !0
        }, {
          name: "_dividendIndex",
          type: "uint256",
          indexed: !0
        }, {
          name: "_amount",
          type: "uint256",
          indexed: !1
        }, {
          name: "_withheld",
          type: "uint256",
          indexed: !1
        }],
        name: "EtherDividendClaimFailed",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_claimer",
          type: "address",
          indexed: !0
        }, {
          name: "_dividendIndex",
          type: "uint256",
          indexed: !0
        }, {
          name: "_withheldAmount",
          type: "uint256",
          indexed: !1
        }],
        name: "EtherDividendWithholdingWithdrawn",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_excluded",
          type: "address[]",
          indexed: !1
        }],
        name: "SetDefaultExcludedAddresses",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_investors",
          type: "address[]",
          indexed: !1
        }, {
          name: "_withholding",
          type: "uint256[]",
          indexed: !1
        }],
        name: "SetWithholding",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_investors",
          type: "address[]",
          indexed: !1
        }, {
          name: "_withholding",
          type: "uint256",
          indexed: !1
        }],
        name: "SetWithholdingFixed",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_oldWallet",
          type: "address",
          indexed: !0
        }, {
          name: "_newWallet",
          type: "address",
          indexed: !0
        }],
        name: "SetWallet",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_dividendIndex",
          type: "uint256",
          indexed: !0
        }, {
          name: "_maturity",
          type: "uint256",
          indexed: !1
        }, {
          name: "_expiry",
          type: "uint256",
          indexed: !1
        }],
        name: "UpdateDividendDates",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Pause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Unpause",
        outputs: [],
        type: "event"
      }, {
        constant: !1,
        inputs: [{
          name: "_maturity",
          type: "uint256"
        }, {
          name: "_expiry",
          type: "uint256"
        }, {
          name: "_name",
          type: "bytes32"
        }],
        name: "createDividend",
        outputs: [],
        payable: !0,
        stateMutability: "payable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_maturity",
          type: "uint256"
        }, {
          name: "_expiry",
          type: "uint256"
        }, {
          name: "_checkpointId",
          type: "uint256"
        }, {
          name: "_name",
          type: "bytes32"
        }],
        name: "createDividendWithCheckpoint",
        outputs: [],
        payable: !0,
        stateMutability: "payable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_maturity",
          type: "uint256"
        }, {
          name: "_expiry",
          type: "uint256"
        }, {
          name: "_excluded",
          type: "address[]"
        }, {
          name: "_name",
          type: "bytes32"
        }],
        name: "createDividendWithExclusions",
        outputs: [],
        payable: !0,
        stateMutability: "payable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_maturity",
          type: "uint256"
        }, {
          name: "_expiry",
          type: "uint256"
        }, {
          name: "_checkpointId",
          type: "uint256"
        }, {
          name: "_excluded",
          type: "address[]"
        }, {
          name: "_name",
          type: "bytes32"
        }],
        name: "createDividendWithCheckpointAndExclusions",
        outputs: [],
        payable: !0,
        stateMutability: "payable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_dividendIndex",
          type: "uint256"
        }],
        name: "reclaimDividend",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_dividendIndex",
          type: "uint256"
        }],
        name: "withdrawWithholding",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(d.BaseContract);

  t.EtherDividendCheckpointContract_3_0_0 = v, t.isEtherDividendCheckpointContract_3_0_0 = function (e) {
    return m.isEqual(v.ABI(), e.abi);
  };
},
/*!*********************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/feature_registry.js ***!
  \*********************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r78,
      n = this && this.__extends || (_r78 = function r(e, t) {
    return (_r78 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r78(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var c,
      u = a(
  /*! @0x/base-contract */
  12),
      d = a(
  /*! @0x/json-schemas */
  2),
      f = a(
  /*! @0x/utils */
  8),
      l = a(
  /*! @0x/web3-wrapper */
  11),
      h = a(
  /*! @0x/assert */
  10),
      p = a(
  /*! ../../PolyResponse */
  14),
      b = a(
  /*! lodash */
  0),
      m = a(
  /*! ethers */
  13);
  (c = t.FeatureRegistryEvents_3_0_0 || (t.FeatureRegistryEvents_3_0_0 = {})).OwnershipTransferred = "OwnershipTransferred", c.ChangeFeatureStatus = "ChangeFeatureStatus";

  var y = function (e) {
    function t(a, r, n, c) {
      var l = e.call(this, "FeatureRegistry", t.ABI(), a, r, n) || this;
      return l.renounceOwnership = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("renounceOwnership()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.renounceOwnership.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return d = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(d), [2, new p.PolyResponse(d, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("renounceOwnership()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return d = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * d), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("renounceOwnership()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("renounceOwnership()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("renounceOwnership()", []);
        }
      }, l.reclaimERC20 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.reclaimERC20.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenContract", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("reclaimERC20(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_tokenContract", e), this._strictEncodeArguments("reclaimERC20(address)", [e]);
        }
      }, l.owner = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("owner()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("owner()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("owner()", []);
        }
      }, l.isOwner = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("isOwner()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("isOwner()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("isOwner()", []);
        }
      }, l.featureStatus = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("index_0", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("featureStatus(bytes32)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("featureStatus(bytes32)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("index_0", e), this._strictEncodeArguments("featureStatus(bytes32)", [e]);
        }
      }, l.transferOwnership = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("newOwner", e), n = (r = this)._strictEncodeArguments("transferOwnership(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.transferOwnership.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("newOwner", e), n = (r = this)._strictEncodeArguments("transferOwnership(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("newOwner", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("transferOwnership(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("transferOwnership(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("newOwner", e), this._strictEncodeArguments("transferOwnership(address)", [e]);
        }
      }, l.getFeatureStatus = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_nameKey", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getFeatureStatus(string)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getFeatureStatus(string)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_nameKey", e), this._strictEncodeArguments("getFeatureStatus(string)", [e]);
        }
      }, l.setFeatureStatus = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_nameKey", e), h.assert.isBoolean("_newStatus", t), o = (n = this)._strictEncodeArguments("setFeatureStatus(string,bool)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: d
                  }, c), n.setFeatureStatus.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), b = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new p.PolyResponse(l, b)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_nameKey", e), h.assert.isBoolean("_newStatus", t), o = (n = this)._strictEncodeArguments("setFeatureStatus(string,bool)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: d
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return p = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, p < m ? p : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_nameKey", e), h.assert.isBoolean("_newStatus", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("setFeatureStatus(string,bool)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("setFeatureStatus(string,bool)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("_nameKey", e), h.assert.isBoolean("_newStatus", t), this._strictEncodeArguments("setFeatureStatus(string,bool)", [e, t]);
        }
      }, l._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, f.classUtils.bindAll(l, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), l;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n) {
      return o(this, void 0, void 0, function () {
        var s, o, c, p, b, y, v, _, g, A;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return h.assert.isHexString("bytecode", e), h.assert.doesConformToSchema("txDefaults", n, d.schemas.txDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), s = f.providerUtils.standardizeOrThrow(r), o = u.BaseContract._lookupConstructorAbi(a), u.BaseContract._formatABIDataItemList(o.inputs, [], u.BaseContract._bigNumberToString), c = new m.utils.Interface(a), p = c.deployFunction, b = p.encode(e, []), y = new l.Web3Wrapper(s), [4, u.BaseContract._applyDefaultsToTxDataAsync({
                data: b
              }, n, y.estimateGasAsync.bind(y))];

            case 1:
              return v = i.sent(), [4, y.sendTransactionAsync(v)];

            case 2:
              return _ = i.sent(), f.logUtils.log("transactionHash: " + _), [4, y.awaitTransactionSuccessAsync(_)];

            case 3:
              return g = i.sent(), f.logUtils.log("FeatureRegistry successfully deployed at " + g.contractAddress), (A = new t(g.contractAddress, s, n)).constructorArgs = [], [2, A];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !1,
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenContract",
          type: "address"
        }],
        name: "reclaimERC20",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "owner",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "isOwner",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "bytes32"
        }],
        name: "featureStatus",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "newOwner",
          type: "address"
        }],
        name: "transferOwnership",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        anonymous: !1,
        inputs: [{
          name: "previousOwner",
          type: "address",
          indexed: !0
        }, {
          name: "newOwner",
          type: "address",
          indexed: !0
        }],
        name: "OwnershipTransferred",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_nameKey",
          type: "string",
          indexed: !1
        }, {
          name: "_newStatus",
          type: "bool",
          indexed: !1
        }],
        name: "ChangeFeatureStatus",
        outputs: [],
        type: "event"
      }, {
        constant: !0,
        inputs: [{
          name: "_nameKey",
          type: "string"
        }],
        name: "getFeatureStatus",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_nameKey",
          type: "string"
        }, {
          name: "_newStatus",
          type: "bool"
        }],
        name: "setFeatureStatus",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(u.BaseContract);

  t.FeatureRegistryContract_3_0_0 = y, t.isFeatureRegistryContract_3_0_0 = function (e) {
    return b.isEqual(y.ABI(), e.abi);
  };
},
/*!*******************************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/general_permission_manager.js ***!
  \*******************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r79,
      n = this && this.__extends || (_r79 = function r(e, t) {
    return (_r79 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r79(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      c = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || 0 < t--) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u,
      d = a(
  /*! @0x/base-contract */
  12),
      f = a(
  /*! @0x/json-schemas */
  2),
      l = a(
  /*! @0x/utils */
  8),
      h = a(
  /*! @0x/web3-wrapper */
  11),
      p = a(
  /*! @0x/assert */
  10),
      b = a(
  /*! ../../PolyResponse */
  14),
      m = a(
  /*! lodash */
  0),
      y = a(
  /*! ethers */
  13);
  (u = t.GeneralPermissionManagerEvents_3_0_0 || (t.GeneralPermissionManagerEvents_3_0_0 = {})).ChangePermission = "ChangePermission", u.AddDelegate = "AddDelegate", u.Pause = "Pause", u.Unpause = "Unpause";

  var v = function (e) {
    function t(a, r, n, c) {
      var u = e.call(this, "GeneralPermissionManager", t.ABI(), a, r, n) || this;
      return u.reclaimETH = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.reclaimETH.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("reclaimETH()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("reclaimETH()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("reclaimETH()", []);
        }
      }, u.ADMIN = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("ADMIN()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("ADMIN()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("ADMIN()", []);
        }
      }, u.unpause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.unpause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("unpause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("unpause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("unpause()", []);
        }
      }, u.perms = {
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("index_0", e), p.assert.isString("index_1", t), p.assert.isString("index_2", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("perms(address,address,bytes32)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("perms(address,address,bytes32)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isString("index_0", e), p.assert.isString("index_1", t), p.assert.isString("index_2", a), this._strictEncodeArguments("perms(address,address,bytes32)", [e, t, a]);
        }
      }, u.paused = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("paused()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("paused()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("paused()", []);
        }
      }, u.polyToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("polyToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("polyToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("polyToken()", []);
        }
      }, u.pause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.pause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pause()", []);
        }
      }, u.reclaimERC20 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.reclaimERC20.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("reclaimERC20(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_tokenContract", e), this._strictEncodeArguments("reclaimERC20(address)", [e]);
        }
      }, u.allDelegates = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("allDelegates(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("allDelegates(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("index_0", e), this._strictEncodeArguments("allDelegates(uint256)", [e]);
        }
      }, u.OPERATOR = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("OPERATOR()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("OPERATOR()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("OPERATOR()", []);
        }
      }, u.securityToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("securityToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("securityToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("securityToken()", []);
        }
      }, u.factory = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("factory()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("factory()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("factory()", []);
        }
      }, u.delegateDetails = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("delegateDetails(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("delegateDetails(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("index_0", e), this._strictEncodeArguments("delegateDetails(address)", [e]);
        }
      }, u.getDataStore = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDataStore()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDataStore()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDataStore()", []);
        }
      }, u.getInitFunction = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getInitFunction()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getInitFunction()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getInitFunction()", []);
        }
      }, u.checkPermission = {
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_delegate", e), p.assert.isString("_module", t), p.assert.isString("_perm", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("checkPermission(address,address,bytes32)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("checkPermission(address,address,bytes32)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isString("_delegate", e), p.assert.isString("_module", t), p.assert.isString("_perm", a), this._strictEncodeArguments("checkPermission(address,address,bytes32)", [e, t, a]);
        }
      }, u.addDelegate = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_delegate", e), p.assert.isString("_details", t), o = (n = this)._strictEncodeArguments("addDelegate(address,bytes32)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.addDelegate.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_delegate", e), p.assert.isString("_details", t), o = (n = this)._strictEncodeArguments("addDelegate(address,bytes32)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_delegate", e), p.assert.isString("_details", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("addDelegate(address,bytes32)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("addDelegate(address,bytes32)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_delegate", e), p.assert.isString("_details", t), this._strictEncodeArguments("addDelegate(address,bytes32)", [e, t]);
        }
      }, u.deleteDelegate = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_delegate", e), n = (r = this)._strictEncodeArguments("deleteDelegate(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.deleteDelegate.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_delegate", e), n = (r = this)._strictEncodeArguments("deleteDelegate(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_delegate", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("deleteDelegate(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("deleteDelegate(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_delegate", e), this._strictEncodeArguments("deleteDelegate(address)", [e]);
        }
      }, u.checkDelegate = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_potentialDelegate", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("checkDelegate(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("checkDelegate(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_potentialDelegate", e), this._strictEncodeArguments("checkDelegate(address)", [e]);
        }
      }, u.changePermission = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_delegate", e), p.assert.isString("_module", t), p.assert.isString("_perm", a), p.assert.isBoolean("_valid", r), u = (o = this)._strictEncodeArguments("changePermission(address,address,bytes32,bool)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.changePermission.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_delegate", e), p.assert.isString("_module", t), p.assert.isString("_perm", a), p.assert.isBoolean("_valid", r), u = (o = this)._strictEncodeArguments("changePermission(address,address,bytes32,bool)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_delegate", e), p.assert.isString("_module", t), p.assert.isString("_perm", a), p.assert.isBoolean("_valid", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("changePermission(address,address,bytes32,bool)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("changePermission(address,address,bytes32,bool)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isString("_delegate", e), p.assert.isString("_module", t), p.assert.isString("_perm", a), p.assert.isBoolean("_valid", r), this._strictEncodeArguments("changePermission(address,address,bytes32,bool)", [e, t, a, r]);
        }
      }, u.changePermissionMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_delegate", e), p.assert.isArray("_modules", t), p.assert.isArray("_perms", a), p.assert.isArray("_valids", r), u = (o = this)._strictEncodeArguments("changePermissionMulti(address,address[],bytes32[],bool[])", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.changePermissionMulti.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_delegate", e), p.assert.isArray("_modules", t), p.assert.isArray("_perms", a), p.assert.isArray("_valids", r), u = (o = this)._strictEncodeArguments("changePermissionMulti(address,address[],bytes32[],bool[])", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_delegate", e), p.assert.isArray("_modules", t), p.assert.isArray("_perms", a), p.assert.isArray("_valids", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("changePermissionMulti(address,address[],bytes32[],bool[])", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("changePermissionMulti(address,address[],bytes32[],bool[])").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isString("_delegate", e), p.assert.isArray("_modules", t), p.assert.isArray("_perms", a), p.assert.isArray("_valids", r), this._strictEncodeArguments("changePermissionMulti(address,address[],bytes32[],bool[])", [e, t, a, r]);
        }
      }, u.getAllDelegatesWithPerm = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_module", e), p.assert.isString("_perm", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("getAllDelegatesWithPerm(address,bytes32)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("getAllDelegatesWithPerm(address,bytes32)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_module", e), p.assert.isString("_perm", t), this._strictEncodeArguments("getAllDelegatesWithPerm(address,bytes32)", [e, t]);
        }
      }, u.getAllModulesAndPermsFromTypes = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_delegate", e), p.assert.isArray("_types", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("getAllModulesAndPermsFromTypes(address,uint8[])", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("getAllModulesAndPermsFromTypes(address,uint8[])").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_delegate", e), p.assert.isArray("_types", t), this._strictEncodeArguments("getAllModulesAndPermsFromTypes(address,uint8[])", [e, t]);
        }
      }, u.getAllDelegates = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getAllDelegates()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getAllDelegates()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getAllDelegates()", []);
        }
      }, u.getPermissions = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getPermissions()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getPermissions()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getPermissions()", []);
        }
      }, u._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, l.classUtils.bindAll(u, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), u;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n, s, u) {
      return o(this, void 0, void 0, function () {
        var o, b, m, v, _, g, A, w, T, x, D;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return p.assert.isHexString("bytecode", e), p.assert.doesConformToSchema("txDefaults", n, f.schemas.txDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), o = l.providerUtils.standardizeOrThrow(r), b = d.BaseContract._lookupConstructorAbi(a), D = c(d.BaseContract._formatABIDataItemList(b.inputs, [s, u], d.BaseContract._bigNumberToString), 2), s = D[0], u = D[1], m = new y.utils.Interface(a), v = m.deployFunction, _ = v.encode(e, [s, u]), g = new h.Web3Wrapper(o), [4, d.BaseContract._applyDefaultsToTxDataAsync({
                data: _
              }, n, g.estimateGasAsync.bind(g))];

            case 1:
              return A = i.sent(), [4, g.sendTransactionAsync(A)];

            case 2:
              return w = i.sent(), l.logUtils.log("transactionHash: " + w), [4, g.awaitTransactionSuccessAsync(w)];

            case 3:
              return T = i.sent(), l.logUtils.log("GeneralPermissionManager successfully deployed at " + T.contractAddress), (x = new t(T.contractAddress, o, n)).constructorArgs = [s, u], [2, x];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !1,
        inputs: [],
        name: "reclaimETH",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "ADMIN",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "unpause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "address"
        }, {
          name: "index_1",
          type: "address"
        }, {
          name: "index_2",
          type: "bytes32"
        }],
        name: "perms",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "paused",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "polyToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "pause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenContract",
          type: "address"
        }],
        name: "reclaimERC20",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "uint256"
        }],
        name: "allDelegates",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "OPERATOR",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "securityToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "factory",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "address"
        }],
        name: "delegateDetails",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDataStore",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        inputs: [{
          name: "_securityToken",
          type: "address"
        }, {
          name: "_polyToken",
          type: "address"
        }],
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "constructor"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_delegate",
          type: "address",
          indexed: !0
        }, {
          name: "_module",
          type: "address",
          indexed: !1
        }, {
          name: "_perm",
          type: "bytes32",
          indexed: !1
        }, {
          name: "_valid",
          type: "bool",
          indexed: !1
        }],
        name: "ChangePermission",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_delegate",
          type: "address",
          indexed: !0
        }, {
          name: "_details",
          type: "bytes32",
          indexed: !1
        }],
        name: "AddDelegate",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Pause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Unpause",
        outputs: [],
        type: "event"
      }, {
        constant: !0,
        inputs: [],
        name: "getInitFunction",
        outputs: [{
          name: "",
          type: "bytes4"
        }],
        payable: !1,
        stateMutability: "pure",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_delegate",
          type: "address"
        }, {
          name: "_module",
          type: "address"
        }, {
          name: "_perm",
          type: "bytes32"
        }],
        name: "checkPermission",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_delegate",
          type: "address"
        }, {
          name: "_details",
          type: "bytes32"
        }],
        name: "addDelegate",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_delegate",
          type: "address"
        }],
        name: "deleteDelegate",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_potentialDelegate",
          type: "address"
        }],
        name: "checkDelegate",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_delegate",
          type: "address"
        }, {
          name: "_module",
          type: "address"
        }, {
          name: "_perm",
          type: "bytes32"
        }, {
          name: "_valid",
          type: "bool"
        }],
        name: "changePermission",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_delegate",
          type: "address"
        }, {
          name: "_modules",
          type: "address[]"
        }, {
          name: "_perms",
          type: "bytes32[]"
        }, {
          name: "_valids",
          type: "bool[]"
        }],
        name: "changePermissionMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_module",
          type: "address"
        }, {
          name: "_perm",
          type: "bytes32"
        }],
        name: "getAllDelegatesWithPerm",
        outputs: [{
          name: "",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_delegate",
          type: "address"
        }, {
          name: "_types",
          type: "uint8[]"
        }],
        name: "getAllModulesAndPermsFromTypes",
        outputs: [{
          name: "",
          type: "address[]"
        }, {
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getAllDelegates",
        outputs: [{
          name: "",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getPermissions",
        outputs: [{
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(d.BaseContract);

  t.GeneralPermissionManagerContract_3_0_0 = v, t.isGeneralPermissionManagerContract_3_0_0 = function (e) {
    return m.isEqual(v.ABI(), e.abi);
  };
},
/*!*****************************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/general_transfer_manager.js ***!
  \*****************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r80,
      n = this && this.__extends || (_r80 = function r(e, t) {
    return (_r80 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r80(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      c = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || 0 < t--) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u,
      d = a(
  /*! @0x/base-contract */
  12),
      f = a(
  /*! @0x/json-schemas */
  2),
      l = a(
  /*! @0x/utils */
  8),
      h = a(
  /*! @0x/web3-wrapper */
  11),
      p = a(
  /*! @0x/assert */
  10),
      b = a(
  /*! ../../PolyResponse */
  14),
      m = a(
  /*! lodash */
  0),
      y = a(
  /*! ethers */
  13);
  (u = t.GeneralTransferManagerEvents_3_0_0 || (t.GeneralTransferManagerEvents_3_0_0 = {})).ChangeIssuanceAddress = "ChangeIssuanceAddress", u.ChangeDefaults = "ChangeDefaults", u.ModifyKYCData = "ModifyKYCData", u.ModifyInvestorFlag = "ModifyInvestorFlag", u.ModifyTransferRequirements = "ModifyTransferRequirements", u.Pause = "Pause", u.Unpause = "Unpause";

  var v = function (e) {
    function t(a, r, n, c) {
      var u = e.call(this, "GeneralTransferManager", t.ABI(), a, r, n) || this;
      return u.reclaimETH = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.reclaimETH.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("reclaimETH()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("reclaimETH()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("reclaimETH()", []);
        }
      }, u.WHITELIST = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("WHITELIST()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("WHITELIST()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("WHITELIST()", []);
        }
      }, u.ADMIN = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("ADMIN()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("ADMIN()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("ADMIN()", []);
        }
      }, u.unpause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.unpause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("unpause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("unpause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("unpause()", []);
        }
      }, u.paused = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("paused()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("paused()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("paused()", []);
        }
      }, u.INVESTORFLAGS = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("INVESTORFLAGS()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("INVESTORFLAGS()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("INVESTORFLAGS()", []);
        }
      }, u.UNLOCKED = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("UNLOCKED()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("UNLOCKED()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("UNLOCKED()", []);
        }
      }, u.polyToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("polyToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("polyToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("polyToken()", []);
        }
      }, u.pause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.pause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pause()", []);
        }
      }, u.reclaimERC20 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.reclaimERC20.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("reclaimERC20(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_tokenContract", e), this._strictEncodeArguments("reclaimERC20(address)", [e]);
        }
      }, u.OPERATOR = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("OPERATOR()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("OPERATOR()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("OPERATOR()", []);
        }
      }, u.nonceMap = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("index_0", e), p.assert.isBigNumber("index_1", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("nonceMap(address,uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("nonceMap(address,uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("index_0", e), p.assert.isBigNumber("index_1", t), this._strictEncodeArguments("nonceMap(address,uint256)", [e, t]);
        }
      }, u.LOCKED = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("LOCKED()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("LOCKED()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("LOCKED()", []);
        }
      }, u.issuanceAddress = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("issuanceAddress()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("issuanceAddress()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("issuanceAddress()", []);
        }
      }, u.securityToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("securityToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("securityToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("securityToken()", []);
        }
      }, u.INVESTORSKEY = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("INVESTORSKEY()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("INVESTORSKEY()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("INVESTORSKEY()", []);
        }
      }, u.transferRequirements = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("transferRequirements(uint8)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("transferRequirements(uint8)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isNumberOrBigNumber("index_0", e), this._strictEncodeArguments("transferRequirements(uint8)", [e]);
        }
      }, u.factory = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("factory()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("factory()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("factory()", []);
        }
      }, u.defaults = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("defaults()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("defaults()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("defaults()", []);
        }
      }, u.getDataStore = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDataStore()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDataStore()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDataStore()", []);
        }
      }, u.getInitFunction = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getInitFunction()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getInitFunction()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getInitFunction()", []);
        }
      }, u.changeDefaults = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_defaultCanSendAfter", e), p.assert.isBigNumber("_defaultCanReceiveAfter", t), o = (n = this)._strictEncodeArguments("changeDefaults(uint64,uint64)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.changeDefaults.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_defaultCanSendAfter", e), p.assert.isBigNumber("_defaultCanReceiveAfter", t), o = (n = this)._strictEncodeArguments("changeDefaults(uint64,uint64)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_defaultCanSendAfter", e), p.assert.isBigNumber("_defaultCanReceiveAfter", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("changeDefaults(uint64,uint64)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("changeDefaults(uint64,uint64)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isBigNumber("_defaultCanSendAfter", e), p.assert.isBigNumber("_defaultCanReceiveAfter", t), this._strictEncodeArguments("changeDefaults(uint64,uint64)", [e, t]);
        }
      }, u.changeIssuanceAddress = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_issuanceAddress", e), n = (r = this)._strictEncodeArguments("changeIssuanceAddress(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeIssuanceAddress.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_issuanceAddress", e), n = (r = this)._strictEncodeArguments("changeIssuanceAddress(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_issuanceAddress", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeIssuanceAddress(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeIssuanceAddress(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_issuanceAddress", e), this._strictEncodeArguments("changeIssuanceAddress(address)", [e]);
        }
      }, u.executeTransfer = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("index_2", a), p.assert.isString("_data", r), u = (o = this)._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.executeTransfer.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("index_2", a), p.assert.isString("_data", r), u = (o = this)._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("index_2", a), p.assert.isString("_data", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("executeTransfer(address,address,uint256,bytes)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("index_2", a), p.assert.isString("_data", r), this._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]);
        }
      }, u.verifyTransfer = {
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("index_2", a), p.assert.isString("index_3", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("verifyTransfer(address,address,uint256,bytes)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("verifyTransfer(address,address,uint256,bytes)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("index_2", a), p.assert.isString("index_3", r), this._strictEncodeArguments("verifyTransfer(address,address,uint256,bytes)", [e, t, a, r]);
        }
      }, u.modifyTransferRequirements = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_transferType", e), p.assert.isBoolean("_fromValidKYC", t), p.assert.isBoolean("_toValidKYC", a), p.assert.isBoolean("_fromRestricted", r), p.assert.isBoolean("_toRestricted", n), f = (o = this)._strictEncodeArguments("modifyTransferRequirements(uint8,bool,bool,bool,bool)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: f
                  }), s({
                    from: h
                  }, l), o.modifyTransferRequirements.estimateGasAsync.bind(o, e, t, a, r, n, u))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(m)];

                case 3:
                  return y = i.sent(), v = o._web3Wrapper.awaitTransactionSuccessAsync(y), [2, new b.PolyResponse(y, v)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_transferType", e), p.assert.isBoolean("_fromValidKYC", t), p.assert.isBoolean("_toValidKYC", a), p.assert.isBoolean("_fromRestricted", r), p.assert.isBoolean("_toRestricted", n), f = (o = this)._strictEncodeArguments("modifyTransferRequirements(uint8,bool,bool,bool,bool)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: f
                  }), s({
                    from: h
                  }, l))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(b)];

                case 3:
                  return m = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return y = i.sent().gasLimit, v = void 0 === c ? o._defaultEstimateGasFactor : c, _ = Math.round(v * m), [2, y < _ ? y : _];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u) {
          return void 0 === c && (c = {}), o(this, void 0, void 0, function () {
            var o, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_transferType", e), p.assert.isBoolean("_fromValidKYC", t), p.assert.isBoolean("_toValidKYC", a), p.assert.isBoolean("_fromRestricted", r), p.assert.isBoolean("_toRestricted", n), p.assert.doesConformToSchema("callData", c, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== u && p.assert.isBlockParam("defaultBlock", u), l = (o = this)._strictEncodeArguments("modifyTransferRequirements(uint8,bool,bool,bool,bool)", [e, t, a, r, n]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: l
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (h = i.sent()).from = h.from ? h.from.toLowerCase() : h.from, [4, o._web3Wrapper.callAsync(h, u)];

                case 2:
                  return b = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(b), [2, o._lookupAbiEncoder("modifyTransferRequirements(uint8,bool,bool,bool,bool)").strictDecodeReturnValue(b)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n) {
          return p.assert.isNumberOrBigNumber("_transferType", e), p.assert.isBoolean("_fromValidKYC", t), p.assert.isBoolean("_toValidKYC", a), p.assert.isBoolean("_fromRestricted", r), p.assert.isBoolean("_toRestricted", n), this._strictEncodeArguments("modifyTransferRequirements(uint8,bool,bool,bool,bool)", [e, t, a, r, n]);
        }
      }, u.modifyTransferRequirementsMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_transferTypes", e), p.assert.isArray("_fromValidKYC", t), p.assert.isArray("_toValidKYC", a), p.assert.isArray("_fromRestricted", r), p.assert.isArray("_toRestricted", n), f = (o = this)._strictEncodeArguments("modifyTransferRequirementsMulti(uint8[],bool[],bool[],bool[],bool[])", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: f
                  }), s({
                    from: h
                  }, l), o.modifyTransferRequirementsMulti.estimateGasAsync.bind(o, e, t, a, r, n, u))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(m)];

                case 3:
                  return y = i.sent(), v = o._web3Wrapper.awaitTransactionSuccessAsync(y), [2, new b.PolyResponse(y, v)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_transferTypes", e), p.assert.isArray("_fromValidKYC", t), p.assert.isArray("_toValidKYC", a), p.assert.isArray("_fromRestricted", r), p.assert.isArray("_toRestricted", n), f = (o = this)._strictEncodeArguments("modifyTransferRequirementsMulti(uint8[],bool[],bool[],bool[],bool[])", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: f
                  }), s({
                    from: h
                  }, l))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(b)];

                case 3:
                  return m = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return y = i.sent().gasLimit, v = void 0 === c ? o._defaultEstimateGasFactor : c, _ = Math.round(v * m), [2, y < _ ? y : _];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u) {
          return void 0 === c && (c = {}), o(this, void 0, void 0, function () {
            var o, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_transferTypes", e), p.assert.isArray("_fromValidKYC", t), p.assert.isArray("_toValidKYC", a), p.assert.isArray("_fromRestricted", r), p.assert.isArray("_toRestricted", n), p.assert.doesConformToSchema("callData", c, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== u && p.assert.isBlockParam("defaultBlock", u), l = (o = this)._strictEncodeArguments("modifyTransferRequirementsMulti(uint8[],bool[],bool[],bool[],bool[])", [e, t, a, r, n]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: l
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (h = i.sent()).from = h.from ? h.from.toLowerCase() : h.from, [4, o._web3Wrapper.callAsync(h, u)];

                case 2:
                  return b = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(b), [2, o._lookupAbiEncoder("modifyTransferRequirementsMulti(uint8[],bool[],bool[],bool[],bool[])").strictDecodeReturnValue(b)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n) {
          return p.assert.isArray("_transferTypes", e), p.assert.isArray("_fromValidKYC", t), p.assert.isArray("_toValidKYC", a), p.assert.isArray("_fromRestricted", r), p.assert.isArray("_toRestricted", n), this._strictEncodeArguments("modifyTransferRequirementsMulti(uint8[],bool[],bool[],bool[],bool[])", [e, t, a, r, n]);
        }
      }, u.modifyKYCData = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.isBigNumber("_canSendAfter", t), p.assert.isBigNumber("_canReceiveAfter", a), p.assert.isBigNumber("_expiryTime", r), u = (o = this)._strictEncodeArguments("modifyKYCData(address,uint64,uint64,uint64)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.modifyKYCData.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.isBigNumber("_canSendAfter", t), p.assert.isBigNumber("_canReceiveAfter", a), p.assert.isBigNumber("_expiryTime", r), u = (o = this)._strictEncodeArguments("modifyKYCData(address,uint64,uint64,uint64)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.isBigNumber("_canSendAfter", t), p.assert.isBigNumber("_canReceiveAfter", a), p.assert.isBigNumber("_expiryTime", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("modifyKYCData(address,uint64,uint64,uint64)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("modifyKYCData(address,uint64,uint64,uint64)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isString("_investor", e), p.assert.isBigNumber("_canSendAfter", t), p.assert.isBigNumber("_canReceiveAfter", a), p.assert.isBigNumber("_expiryTime", r), this._strictEncodeArguments("modifyKYCData(address,uint64,uint64,uint64)", [e, t, a, r]);
        }
      }, u.modifyKYCDataMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isArray("_canSendAfter", t), p.assert.isArray("_canReceiveAfter", a), p.assert.isArray("_expiryTime", r), u = (o = this)._strictEncodeArguments("modifyKYCDataMulti(address[],uint64[],uint64[],uint64[])", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.modifyKYCDataMulti.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isArray("_canSendAfter", t), p.assert.isArray("_canReceiveAfter", a), p.assert.isArray("_expiryTime", r), u = (o = this)._strictEncodeArguments("modifyKYCDataMulti(address[],uint64[],uint64[],uint64[])", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isArray("_canSendAfter", t), p.assert.isArray("_canReceiveAfter", a), p.assert.isArray("_expiryTime", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("modifyKYCDataMulti(address[],uint64[],uint64[],uint64[])", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("modifyKYCDataMulti(address[],uint64[],uint64[],uint64[])").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isArray("_investors", e), p.assert.isArray("_canSendAfter", t), p.assert.isArray("_canReceiveAfter", a), p.assert.isArray("_expiryTime", r), this._strictEncodeArguments("modifyKYCDataMulti(address[],uint64[],uint64[],uint64[])", [e, t, a, r]);
        }
      }, u.modifyInvestorFlag = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.isNumberOrBigNumber("_flag", t), p.assert.isBoolean("_value", a), c = (o = this)._strictEncodeArguments("modifyInvestorFlag(address,uint8,bool)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.modifyInvestorFlag.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.isNumberOrBigNumber("_flag", t), p.assert.isBoolean("_value", a), c = (o = this)._strictEncodeArguments("modifyInvestorFlag(address,uint8,bool)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.isNumberOrBigNumber("_flag", t), p.assert.isBoolean("_value", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("modifyInvestorFlag(address,uint8,bool)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("modifyInvestorFlag(address,uint8,bool)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isString("_investor", e), p.assert.isNumberOrBigNumber("_flag", t), p.assert.isBoolean("_value", a), this._strictEncodeArguments("modifyInvestorFlag(address,uint8,bool)", [e, t, a]);
        }
      }, u.modifyInvestorFlagMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isArray("_flag", t), p.assert.isArray("_value", a), c = (o = this)._strictEncodeArguments("modifyInvestorFlagMulti(address[],uint8[],bool[])", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.modifyInvestorFlagMulti.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isArray("_flag", t), p.assert.isArray("_value", a), c = (o = this)._strictEncodeArguments("modifyInvestorFlagMulti(address[],uint8[],bool[])", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isArray("_flag", t), p.assert.isArray("_value", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("modifyInvestorFlagMulti(address[],uint8[],bool[])", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("modifyInvestorFlagMulti(address[],uint8[],bool[])").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isArray("_investors", e), p.assert.isArray("_flag", t), p.assert.isArray("_value", a), this._strictEncodeArguments("modifyInvestorFlagMulti(address[],uint8[],bool[])", [e, t, a]);
        }
      }, u.modifyKYCDataSigned = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u, f, l, h) {
          return o(this, void 0, void 0, function () {
            var o, m, y, v, _, g, A;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.isBigNumber("_canSendAfter", t), p.assert.isBigNumber("_canReceiveAfter", a), p.assert.isBigNumber("_expiryTime", r), p.assert.isBigNumber("_validFrom", n), p.assert.isBigNumber("_validTo", c), p.assert.isBigNumber("_nonce", u), p.assert.isString("_signature", f), m = (o = this)._strictEncodeArguments("modifyKYCDataSigned(address,uint256,uint256,uint256,uint256,uint256,uint256,bytes)", [e, t, a, r, n, c, u, f]), y = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return v = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, l, {
                    data: m
                  }), s({
                    from: v
                  }, y), o.modifyKYCDataSigned.estimateGasAsync.bind(o, e, t, a, r, n, c, u, f, h))];

                case 2:
                  return void 0 !== (_ = i.sent()).from && (_.from = _.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(_)];

                case 3:
                  return g = i.sent(), A = o._web3Wrapper.awaitTransactionSuccessAsync(g), [2, new b.PolyResponse(g, A)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u, f, l, h) {
          return o(this, void 0, void 0, function () {
            var o, b, m, y, v, _, g, A, w;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.isBigNumber("_canSendAfter", t), p.assert.isBigNumber("_canReceiveAfter", a), p.assert.isBigNumber("_expiryTime", r), p.assert.isBigNumber("_validFrom", n), p.assert.isBigNumber("_validTo", c), p.assert.isBigNumber("_nonce", u), p.assert.isString("_signature", f), b = (o = this)._strictEncodeArguments("modifyKYCDataSigned(address,uint256,uint256,uint256,uint256,uint256,uint256,bytes)", [e, t, a, r, n, c, u, f]), m = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return y = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, h, {
                    data: b
                  }), s({
                    from: y
                  }, m))];

                case 2:
                  return void 0 !== (v = i.sent()).from && (v.from = v.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(v)];

                case 3:
                  return _ = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return g = i.sent().gasLimit, A = void 0 === l ? o._defaultEstimateGasFactor : l, w = Math.round(A * _), [2, g < w ? g : w];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u, l, h, b) {
          return void 0 === h && (h = {}), o(this, void 0, void 0, function () {
            var o, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.isBigNumber("_canSendAfter", t), p.assert.isBigNumber("_canReceiveAfter", a), p.assert.isBigNumber("_expiryTime", r), p.assert.isBigNumber("_validFrom", n), p.assert.isBigNumber("_validTo", c), p.assert.isBigNumber("_nonce", u), p.assert.isString("_signature", l), p.assert.doesConformToSchema("callData", h, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== b && p.assert.isBlockParam("defaultBlock", b), m = (o = this)._strictEncodeArguments("modifyKYCDataSigned(address,uint256,uint256,uint256,uint256,uint256,uint256,bytes)", [e, t, a, r, n, c, u, l]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, h, {
                    data: m
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (y = i.sent()).from = y.from ? y.from.toLowerCase() : y.from, [4, o._web3Wrapper.callAsync(y, b)];

                case 2:
                  return v = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(v), [2, o._lookupAbiEncoder("modifyKYCDataSigned(address,uint256,uint256,uint256,uint256,uint256,uint256,bytes)").strictDecodeReturnValue(v)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s, o, i) {
          return p.assert.isString("_investor", e), p.assert.isBigNumber("_canSendAfter", t), p.assert.isBigNumber("_canReceiveAfter", a), p.assert.isBigNumber("_expiryTime", r), p.assert.isBigNumber("_validFrom", n), p.assert.isBigNumber("_validTo", s), p.assert.isBigNumber("_nonce", o), p.assert.isString("_signature", i), this._strictEncodeArguments("modifyKYCDataSigned(address,uint256,uint256,uint256,uint256,uint256,uint256,bytes)", [e, t, a, r, n, s, o, i]);
        }
      }, u.modifyKYCDataSignedMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u, f, l, h) {
          return o(this, void 0, void 0, function () {
            var o, m, y, v, _, g, A;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investor", e), p.assert.isArray("_canSendAfter", t), p.assert.isArray("_canReceiveAfter", a), p.assert.isArray("_expiryTime", r), p.assert.isBigNumber("_validFrom", n), p.assert.isBigNumber("_validTo", c), p.assert.isBigNumber("_nonce", u), p.assert.isString("_signature", f), m = (o = this)._strictEncodeArguments("modifyKYCDataSignedMulti(address[],uint256[],uint256[],uint256[],uint256,uint256,uint256,bytes)", [e, t, a, r, n, c, u, f]), y = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return v = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, l, {
                    data: m
                  }), s({
                    from: v
                  }, y), o.modifyKYCDataSignedMulti.estimateGasAsync.bind(o, e, t, a, r, n, c, u, f, h))];

                case 2:
                  return void 0 !== (_ = i.sent()).from && (_.from = _.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(_)];

                case 3:
                  return g = i.sent(), A = o._web3Wrapper.awaitTransactionSuccessAsync(g), [2, new b.PolyResponse(g, A)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u, f, l, h) {
          return o(this, void 0, void 0, function () {
            var o, b, m, y, v, _, g, A, w;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investor", e), p.assert.isArray("_canSendAfter", t), p.assert.isArray("_canReceiveAfter", a), p.assert.isArray("_expiryTime", r), p.assert.isBigNumber("_validFrom", n), p.assert.isBigNumber("_validTo", c), p.assert.isBigNumber("_nonce", u), p.assert.isString("_signature", f), b = (o = this)._strictEncodeArguments("modifyKYCDataSignedMulti(address[],uint256[],uint256[],uint256[],uint256,uint256,uint256,bytes)", [e, t, a, r, n, c, u, f]), m = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return y = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, h, {
                    data: b
                  }), s({
                    from: y
                  }, m))];

                case 2:
                  return void 0 !== (v = i.sent()).from && (v.from = v.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(v)];

                case 3:
                  return _ = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return g = i.sent().gasLimit, A = void 0 === l ? o._defaultEstimateGasFactor : l, w = Math.round(A * _), [2, g < w ? g : w];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u, l, h, b) {
          return void 0 === h && (h = {}), o(this, void 0, void 0, function () {
            var o, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investor", e), p.assert.isArray("_canSendAfter", t), p.assert.isArray("_canReceiveAfter", a), p.assert.isArray("_expiryTime", r), p.assert.isBigNumber("_validFrom", n), p.assert.isBigNumber("_validTo", c), p.assert.isBigNumber("_nonce", u), p.assert.isString("_signature", l), p.assert.doesConformToSchema("callData", h, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== b && p.assert.isBlockParam("defaultBlock", b), m = (o = this)._strictEncodeArguments("modifyKYCDataSignedMulti(address[],uint256[],uint256[],uint256[],uint256,uint256,uint256,bytes)", [e, t, a, r, n, c, u, l]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, h, {
                    data: m
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (y = i.sent()).from = y.from ? y.from.toLowerCase() : y.from, [4, o._web3Wrapper.callAsync(y, b)];

                case 2:
                  return v = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(v), [2, o._lookupAbiEncoder("modifyKYCDataSignedMulti(address[],uint256[],uint256[],uint256[],uint256,uint256,uint256,bytes)").strictDecodeReturnValue(v)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s, o, i) {
          return p.assert.isArray("_investor", e), p.assert.isArray("_canSendAfter", t), p.assert.isArray("_canReceiveAfter", a), p.assert.isArray("_expiryTime", r), p.assert.isBigNumber("_validFrom", n), p.assert.isBigNumber("_validTo", s), p.assert.isBigNumber("_nonce", o), p.assert.isString("_signature", i), this._strictEncodeArguments("modifyKYCDataSignedMulti(address[],uint256[],uint256[],uint256[],uint256,uint256,uint256,bytes)", [e, t, a, r, n, s, o, i]);
        }
      }, u.getAllInvestors = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getAllInvestors()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getAllInvestors()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getAllInvestors()", []);
        }
      }, u.getInvestors = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_fromIndex", e), p.assert.isBigNumber("_toIndex", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("getInvestors(uint256,uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("getInvestors(uint256,uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isBigNumber("_fromIndex", e), p.assert.isBigNumber("_toIndex", t), this._strictEncodeArguments("getInvestors(uint256,uint256)", [e, t]);
        }
      }, u.getAllInvestorFlags = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getAllInvestorFlags()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getAllInvestorFlags()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getAllInvestorFlags()", []);
        }
      }, u.getInvestorFlag = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.isNumberOrBigNumber("_flag", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("getInvestorFlag(address,uint8)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("getInvestorFlag(address,uint8)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_investor", e), p.assert.isNumberOrBigNumber("_flag", t), this._strictEncodeArguments("getInvestorFlag(address,uint8)", [e, t]);
        }
      }, u.getInvestorFlags = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getInvestorFlags(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getInvestorFlags(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_investor", e), this._strictEncodeArguments("getInvestorFlags(address)", [e]);
        }
      }, u.getAllKYCData = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getAllKYCData()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getAllKYCData()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getAllKYCData()", []);
        }
      }, u.getKYCData = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getKYCData(address[])", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getKYCData(address[])").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isArray("_investors", e), this._strictEncodeArguments("getKYCData(address[])", [e]);
        }
      }, u.getPermissions = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getPermissions()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getPermissions()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getPermissions()", []);
        }
      }, u.getTokensByPartition = {
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_partition", e), p.assert.isString("_tokenHolder", t), p.assert.isBigNumber("_additionalBalance", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("getTokensByPartition(bytes32,address,uint256)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("getTokensByPartition(bytes32,address,uint256)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isString("_partition", e), p.assert.isString("_tokenHolder", t), p.assert.isBigNumber("_additionalBalance", a), this._strictEncodeArguments("getTokensByPartition(bytes32,address,uint256)", [e, t, a]);
        }
      }, u.getAddressBytes32 = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getAddressBytes32()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getAddressBytes32()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getAddressBytes32()", []);
        }
      }, u._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, l.classUtils.bindAll(u, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), u;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n, s, u) {
      return o(this, void 0, void 0, function () {
        var o, b, m, v, _, g, A, w, T, x, D;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return p.assert.isHexString("bytecode", e), p.assert.doesConformToSchema("txDefaults", n, f.schemas.txDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), o = l.providerUtils.standardizeOrThrow(r), b = d.BaseContract._lookupConstructorAbi(a), D = c(d.BaseContract._formatABIDataItemList(b.inputs, [s, u], d.BaseContract._bigNumberToString), 2), s = D[0], u = D[1], m = new y.utils.Interface(a), v = m.deployFunction, _ = v.encode(e, [s, u]), g = new h.Web3Wrapper(o), [4, d.BaseContract._applyDefaultsToTxDataAsync({
                data: _
              }, n, g.estimateGasAsync.bind(g))];

            case 1:
              return A = i.sent(), [4, g.sendTransactionAsync(A)];

            case 2:
              return w = i.sent(), l.logUtils.log("transactionHash: " + w), [4, g.awaitTransactionSuccessAsync(w)];

            case 3:
              return T = i.sent(), l.logUtils.log("GeneralTransferManager successfully deployed at " + T.contractAddress), (x = new t(T.contractAddress, o, n)).constructorArgs = [s, u], [2, x];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !1,
        inputs: [],
        name: "reclaimETH",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "WHITELIST",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "ADMIN",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "unpause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "paused",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "INVESTORFLAGS",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "UNLOCKED",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "polyToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "pause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenContract",
          type: "address"
        }],
        name: "reclaimERC20",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "OPERATOR",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "address"
        }, {
          name: "index_1",
          type: "uint256"
        }],
        name: "nonceMap",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "LOCKED",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "issuanceAddress",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "securityToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "INVESTORSKEY",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "uint8"
        }],
        name: "transferRequirements",
        outputs: [{
          name: "fromValidKYC",
          type: "bool"
        }, {
          name: "toValidKYC",
          type: "bool"
        }, {
          name: "fromRestricted",
          type: "bool"
        }, {
          name: "toRestricted",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "factory",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "defaults",
        outputs: [{
          name: "canSendAfter",
          type: "uint64"
        }, {
          name: "canReceiveAfter",
          type: "uint64"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDataStore",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        inputs: [{
          name: "_securityToken",
          type: "address"
        }, {
          name: "_polyToken",
          type: "address"
        }],
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "constructor"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_issuanceAddress",
          type: "address",
          indexed: !1
        }],
        name: "ChangeIssuanceAddress",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_defaultCanSendAfter",
          type: "uint64",
          indexed: !1
        }, {
          name: "_defaultCanReceiveAfter",
          type: "uint64",
          indexed: !1
        }],
        name: "ChangeDefaults",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_investor",
          type: "address",
          indexed: !0
        }, {
          name: "_addedBy",
          type: "address",
          indexed: !0
        }, {
          name: "_canSendAfter",
          type: "uint64",
          indexed: !1
        }, {
          name: "_canReceiveAfter",
          type: "uint64",
          indexed: !1
        }, {
          name: "_expiryTime",
          type: "uint64",
          indexed: !1
        }],
        name: "ModifyKYCData",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_investor",
          type: "address",
          indexed: !0
        }, {
          name: "_flag",
          type: "uint8",
          indexed: !0
        }, {
          name: "_value",
          type: "bool",
          indexed: !1
        }],
        name: "ModifyInvestorFlag",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_transferType",
          type: "uint8",
          indexed: !0
        }, {
          name: "_fromValidKYC",
          type: "bool",
          indexed: !1
        }, {
          name: "_toValidKYC",
          type: "bool",
          indexed: !1
        }, {
          name: "_fromRestricted",
          type: "bool",
          indexed: !1
        }, {
          name: "_toRestricted",
          type: "bool",
          indexed: !1
        }],
        name: "ModifyTransferRequirements",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Pause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Unpause",
        outputs: [],
        type: "event"
      }, {
        constant: !0,
        inputs: [],
        name: "getInitFunction",
        outputs: [{
          name: "",
          type: "bytes4"
        }],
        payable: !1,
        stateMutability: "pure",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_defaultCanSendAfter",
          type: "uint64"
        }, {
          name: "_defaultCanReceiveAfter",
          type: "uint64"
        }],
        name: "changeDefaults",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_issuanceAddress",
          type: "address"
        }],
        name: "changeIssuanceAddress",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "_to",
          type: "address"
        }, {
          name: "index_2",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }],
        name: "executeTransfer",
        outputs: [{
          name: "",
          type: "uint8"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "_to",
          type: "address"
        }, {
          name: "index_2",
          type: "uint256"
        }, {
          name: "index_3",
          type: "bytes"
        }],
        name: "verifyTransfer",
        outputs: [{
          name: "",
          type: "uint8"
        }, {
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_transferType",
          type: "uint8"
        }, {
          name: "_fromValidKYC",
          type: "bool"
        }, {
          name: "_toValidKYC",
          type: "bool"
        }, {
          name: "_fromRestricted",
          type: "bool"
        }, {
          name: "_toRestricted",
          type: "bool"
        }],
        name: "modifyTransferRequirements",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_transferTypes",
          type: "uint8[]"
        }, {
          name: "_fromValidKYC",
          type: "bool[]"
        }, {
          name: "_toValidKYC",
          type: "bool[]"
        }, {
          name: "_fromRestricted",
          type: "bool[]"
        }, {
          name: "_toRestricted",
          type: "bool[]"
        }],
        name: "modifyTransferRequirementsMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_investor",
          type: "address"
        }, {
          name: "_canSendAfter",
          type: "uint64"
        }, {
          name: "_canReceiveAfter",
          type: "uint64"
        }, {
          name: "_expiryTime",
          type: "uint64"
        }],
        name: "modifyKYCData",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_investors",
          type: "address[]"
        }, {
          name: "_canSendAfter",
          type: "uint64[]"
        }, {
          name: "_canReceiveAfter",
          type: "uint64[]"
        }, {
          name: "_expiryTime",
          type: "uint64[]"
        }],
        name: "modifyKYCDataMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_investor",
          type: "address"
        }, {
          name: "_flag",
          type: "uint8"
        }, {
          name: "_value",
          type: "bool"
        }],
        name: "modifyInvestorFlag",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_investors",
          type: "address[]"
        }, {
          name: "_flag",
          type: "uint8[]"
        }, {
          name: "_value",
          type: "bool[]"
        }],
        name: "modifyInvestorFlagMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_investor",
          type: "address"
        }, {
          name: "_canSendAfter",
          type: "uint256"
        }, {
          name: "_canReceiveAfter",
          type: "uint256"
        }, {
          name: "_expiryTime",
          type: "uint256"
        }, {
          name: "_validFrom",
          type: "uint256"
        }, {
          name: "_validTo",
          type: "uint256"
        }, {
          name: "_nonce",
          type: "uint256"
        }, {
          name: "_signature",
          type: "bytes"
        }],
        name: "modifyKYCDataSigned",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_investor",
          type: "address[]"
        }, {
          name: "_canSendAfter",
          type: "uint256[]"
        }, {
          name: "_canReceiveAfter",
          type: "uint256[]"
        }, {
          name: "_expiryTime",
          type: "uint256[]"
        }, {
          name: "_validFrom",
          type: "uint256"
        }, {
          name: "_validTo",
          type: "uint256"
        }, {
          name: "_nonce",
          type: "uint256"
        }, {
          name: "_signature",
          type: "bytes"
        }],
        name: "modifyKYCDataSignedMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getAllInvestors",
        outputs: [{
          name: "investors",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_fromIndex",
          type: "uint256"
        }, {
          name: "_toIndex",
          type: "uint256"
        }],
        name: "getInvestors",
        outputs: [{
          name: "investors",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getAllInvestorFlags",
        outputs: [{
          name: "investors",
          type: "address[]"
        }, {
          name: "flags",
          type: "uint256[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_investor",
          type: "address"
        }, {
          name: "_flag",
          type: "uint8"
        }],
        name: "getInvestorFlag",
        outputs: [{
          name: "value",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_investor",
          type: "address"
        }],
        name: "getInvestorFlags",
        outputs: [{
          name: "flags",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getAllKYCData",
        outputs: [{
          name: "investors",
          type: "address[]"
        }, {
          name: "canSendAfters",
          type: "uint256[]"
        }, {
          name: "canReceiveAfters",
          type: "uint256[]"
        }, {
          name: "expiryTimes",
          type: "uint256[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_investors",
          type: "address[]"
        }],
        name: "getKYCData",
        outputs: [{
          name: "",
          type: "uint256[]"
        }, {
          name: "",
          type: "uint256[]"
        }, {
          name: "",
          type: "uint256[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getPermissions",
        outputs: [{
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_partition",
          type: "bytes32"
        }, {
          name: "_tokenHolder",
          type: "address"
        }, {
          name: "_additionalBalance",
          type: "uint256"
        }],
        name: "getTokensByPartition",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getAddressBytes32",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(d.BaseContract);

  t.GeneralTransferManagerContract_3_0_0 = v, t.isGeneralTransferManagerContract_3_0_0 = function (e) {
    return m.isEqual(v.ABI(), e.abi);
  };
},
/*!*********************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/isto.js ***!
  \*********************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r81,
      n = this && this.__extends || (_r81 = function r(e, t) {
    return (_r81 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r81(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var c = a(
  /*! @0x/base-contract */
  12),
      u = a(
  /*! @0x/json-schemas */
  2),
      d = a(
  /*! @0x/utils */
  8),
      f = a(
  /*! @0x/web3-wrapper */
  11),
      l = a(
  /*! @0x/assert */
  10),
      h = a(
  /*! ../../PolyResponse */
  14),
      p = a(
  /*! lodash */
  0),
      b = a(
  /*! ethers */
  13);
  (t.ISTOEvents_3_0_0 || (t.ISTOEvents_3_0_0 = {})).SetFundRaiseTypes = "SetFundRaiseTypes";

  var m = function (e) {
    function t(a, r, n, f) {
      var p = e.call(this, "ISTO", t.ABI(), a, r, n) || this;
      return p.getTokensSold = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return l.assert.doesConformToSchema("callData", e, u.schemas.callDataSchema, [u.schemas.addressSchema, u.schemas.numberSchema, u.schemas.jsNumber]), void 0 !== t && l.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getTokensSold()", []), [4, c.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), c.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getTokensSold()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getTokensSold()", []);
        }
      }, p.getRaised = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, d;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return l.assert.isNumberOrBigNumber("_fundRaiseType", e), l.assert.doesConformToSchema("callData", t, u.schemas.callDataSchema, [u.schemas.addressSchema, u.schemas.numberSchema, u.schemas.jsNumber]), void 0 !== a && l.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getRaised(uint8)", [e]), [4, c.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return d = i.sent(), c.BaseContract._throwIfRevertWithReasonCallResult(d), [2, r._lookupAbiEncoder("getRaised(uint8)").strictDecodeReturnValue(d)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return l.assert.isNumberOrBigNumber("_fundRaiseType", e), this._strictEncodeArguments("getRaised(uint8)", [e]);
        }
      }, p.pause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, u, d, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, c.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.pause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return d = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(d), [2, new h.PolyResponse(d, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, u, d, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, c.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return d = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * d), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return l.assert.doesConformToSchema("callData", e, u.schemas.callDataSchema, [u.schemas.addressSchema, u.schemas.numberSchema, u.schemas.jsNumber]), void 0 !== t && l.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pause()", []), [4, c.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), c.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pause()", []);
        }
      }, p._defaultEstimateGasFactor = void 0 === f ? 1.1 : f, d.classUtils.bindAll(p, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), p;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n) {
      return o(this, void 0, void 0, function () {
        var s, o, h, p, m, y, v, _, g, A;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return l.assert.isHexString("bytecode", e), l.assert.doesConformToSchema("txDefaults", n, u.schemas.txDataSchema, [u.schemas.addressSchema, u.schemas.numberSchema, u.schemas.jsNumber]), s = d.providerUtils.standardizeOrThrow(r), o = c.BaseContract._lookupConstructorAbi(a), c.BaseContract._formatABIDataItemList(o.inputs, [], c.BaseContract._bigNumberToString), h = new b.utils.Interface(a), p = h.deployFunction, m = p.encode(e, []), y = new f.Web3Wrapper(s), [4, c.BaseContract._applyDefaultsToTxDataAsync({
                data: m
              }, n, y.estimateGasAsync.bind(y))];

            case 1:
              return v = i.sent(), [4, y.sendTransactionAsync(v)];

            case 2:
              return _ = i.sent(), d.logUtils.log("transactionHash: " + _), [4, y.awaitTransactionSuccessAsync(_)];

            case 3:
              return g = i.sent(), d.logUtils.log("ISTO successfully deployed at " + g.contractAddress), (A = new t(g.contractAddress, s, n)).constructorArgs = [], [2, A];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        anonymous: !1,
        inputs: [{
          name: "_fundRaiseTypes",
          type: "uint8[]",
          indexed: !1
        }],
        name: "SetFundRaiseTypes",
        outputs: [],
        type: "event"
      }, {
        constant: !0,
        inputs: [],
        name: "getTokensSold",
        outputs: [{
          name: "soldTokens",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_fundRaiseType",
          type: "uint8"
        }],
        name: "getRaised",
        outputs: [{
          name: "raisedAmount",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "pause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(c.BaseContract);

  t.ISTOContract_3_0_0 = m, t.isISTOContract_3_0_0 = function (e) {
    return p.isEqual(m.ABI(), e.abi);
  };
},
/*!*************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/i_module.js ***!
  \*************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r82,
      n = this && this.__extends || (_r82 = function r(e, t) {
    return (_r82 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r82(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var c = a(
  /*! @0x/base-contract */
  12),
      u = a(
  /*! @0x/json-schemas */
  2),
      d = a(
  /*! @0x/utils */
  8),
      f = a(
  /*! @0x/web3-wrapper */
  11),
      l = a(
  /*! @0x/assert */
  10),
      h = a(
  /*! lodash */
  0),
      p = a(
  /*! ethers */
  13),
      b = function (e) {
    function t(a, r, n, f) {
      var h = e.call(this, "IModule", t.ABI(), a, r, n) || this;
      return h.getInitFunction = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return l.assert.doesConformToSchema("callData", e, u.schemas.callDataSchema, [u.schemas.addressSchema, u.schemas.numberSchema, u.schemas.jsNumber]), void 0 !== t && l.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getInitFunction()", []), [4, c.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), c.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getInitFunction()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getInitFunction()", []);
        }
      }, h.getPermissions = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return l.assert.doesConformToSchema("callData", e, u.schemas.callDataSchema, [u.schemas.addressSchema, u.schemas.numberSchema, u.schemas.jsNumber]), void 0 !== t && l.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getPermissions()", []), [4, c.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), c.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getPermissions()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getPermissions()", []);
        }
      }, h._defaultEstimateGasFactor = void 0 === f ? 1.1 : f, d.classUtils.bindAll(h, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), h;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n) {
      return o(this, void 0, void 0, function () {
        var s, o, h, b, m, y, v, _, g, A;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return l.assert.isHexString("bytecode", e), l.assert.doesConformToSchema("txDefaults", n, u.schemas.txDataSchema, [u.schemas.addressSchema, u.schemas.numberSchema, u.schemas.jsNumber]), s = d.providerUtils.standardizeOrThrow(r), o = c.BaseContract._lookupConstructorAbi(a), c.BaseContract._formatABIDataItemList(o.inputs, [], c.BaseContract._bigNumberToString), h = new p.utils.Interface(a), b = h.deployFunction, m = b.encode(e, []), y = new f.Web3Wrapper(s), [4, c.BaseContract._applyDefaultsToTxDataAsync({
                data: m
              }, n, y.estimateGasAsync.bind(y))];

            case 1:
              return v = i.sent(), [4, y.sendTransactionAsync(v)];

            case 2:
              return _ = i.sent(), d.logUtils.log("transactionHash: " + _), [4, y.awaitTransactionSuccessAsync(_)];

            case 3:
              return g = i.sent(), d.logUtils.log("IModule successfully deployed at " + g.contractAddress), (A = new t(g.contractAddress, s, n)).constructorArgs = [], [2, A];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !0,
        inputs: [],
        name: "getInitFunction",
        outputs: [{
          name: "initFunction",
          type: "bytes4"
        }],
        payable: !1,
        stateMutability: "pure",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getPermissions",
        outputs: [{
          name: "permissions",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(c.BaseContract);

  t.IModuleContract_3_0_0 = b, t.isIModuleContract_3_0_0 = function (e) {
    return h.isEqual(b.ABI(), e.abi);
  };
},
/*!*******************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/security_token.js ***!
  \*******************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r83,
      n = this && this.__extends || (_r83 = function r(e, t) {
    return (_r83 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r83(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var c,
      u = a(
  /*! @0x/base-contract */
  12),
      d = a(
  /*! @0x/json-schemas */
  2),
      f = a(
  /*! @0x/utils */
  8),
      l = a(
  /*! @0x/web3-wrapper */
  11),
      h = a(
  /*! @0x/assert */
  10),
      p = a(
  /*! ../../PolyResponse */
  14),
      b = a(
  /*! lodash */
  0),
      m = a(
  /*! ethers */
  13);
  (c = t.SecurityTokenEvents_3_0_0 || (t.SecurityTokenEvents_3_0_0 = {})).ModuleAdded = "ModuleAdded", c.ModuleUpgraded = "ModuleUpgraded", c.UpdateTokenDetails = "UpdateTokenDetails", c.UpdateTokenName = "UpdateTokenName", c.GranularityChanged = "GranularityChanged", c.FreezeIssuance = "FreezeIssuance", c.FreezeTransfers = "FreezeTransfers", c.CheckpointCreated = "CheckpointCreated", c.SetController = "SetController", c.TreasuryWalletChanged = "TreasuryWalletChanged", c.DisableController = "DisableController", c.OwnershipTransferred = "OwnershipTransferred", c.TokenUpgraded = "TokenUpgraded", c.ModuleArchived = "ModuleArchived", c.ModuleUnarchived = "ModuleUnarchived", c.ModuleRemoved = "ModuleRemoved", c.ModuleBudgetChanged = "ModuleBudgetChanged", c.TransferByPartition = "TransferByPartition", c.AuthorizedOperator = "AuthorizedOperator", c.RevokedOperator = "RevokedOperator", c.AuthorizedOperatorByPartition = "AuthorizedOperatorByPartition", c.RevokedOperatorByPartition = "RevokedOperatorByPartition", c.IssuedByPartition = "IssuedByPartition", c.RedeemedByPartition = "RedeemedByPartition", c.ControllerTransfer = "ControllerTransfer", c.ControllerRedemption = "ControllerRedemption", c.DocumentRemoved = "DocumentRemoved", c.DocumentUpdated = "DocumentUpdated", c.Issued = "Issued", c.Redeemed = "Redeemed", c.Transfer = "Transfer", c.Approval = "Approval";

  var y = function (e) {
    function t(a, r, n, c) {
      var l = e.call(this, "SecurityToken", t.ABI(), a, r, n) || this;
      return l.name = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("name()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("name()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("name()", []);
        }
      }, l.approve = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("spender", e), h.assert.isBigNumber("value", t), o = (n = this)._strictEncodeArguments("approve(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: d
                  }, c), n.approve.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), b = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new p.PolyResponse(l, b)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("spender", e), h.assert.isBigNumber("value", t), o = (n = this)._strictEncodeArguments("approve(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: d
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return p = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, p < m ? p : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("spender", e), h.assert.isBigNumber("value", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("approve(address,uint256)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("approve(address,uint256)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("spender", e), h.assert.isBigNumber("value", t), this._strictEncodeArguments("approve(address,uint256)", [e, t]);
        }
      }, l.initialized = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("initialized()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("initialized()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("initialized()", []);
        }
      }, l.totalSupply = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("totalSupply()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("totalSupply()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("totalSupply()", []);
        }
      }, l.holderCount = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("holderCount()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("holderCount()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("holderCount()", []);
        }
      }, l.getterDelegate = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getterDelegate()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getterDelegate()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getterDelegate()", []);
        }
      }, l.decimals = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("decimals()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("decimals()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("decimals()", []);
        }
      }, l.increaseAllowance = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("spender", e), h.assert.isBigNumber("addedValue", t), o = (n = this)._strictEncodeArguments("increaseAllowance(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: d
                  }, c), n.increaseAllowance.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), b = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new p.PolyResponse(l, b)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("spender", e), h.assert.isBigNumber("addedValue", t), o = (n = this)._strictEncodeArguments("increaseAllowance(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: d
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return p = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, p < m ? p : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("spender", e), h.assert.isBigNumber("addedValue", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("increaseAllowance(address,uint256)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("increaseAllowance(address,uint256)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("spender", e), h.assert.isBigNumber("addedValue", t), this._strictEncodeArguments("increaseAllowance(address,uint256)", [e, t]);
        }
      }, l.currentCheckpointId = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("currentCheckpointId()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("currentCheckpointId()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("currentCheckpointId()", []);
        }
      }, l.granularity = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("granularity()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("granularity()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("granularity()", []);
        }
      }, l.dataStore = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("dataStore()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("dataStore()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("dataStore()", []);
        }
      }, l.polyToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("polyToken()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("polyToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("polyToken()", []);
        }
      }, l.balanceOf = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("owner", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("balanceOf(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("balanceOf(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("owner", e), this._strictEncodeArguments("balanceOf(address)", [e]);
        }
      }, l.polymathRegistry = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("polymathRegistry()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("polymathRegistry()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("polymathRegistry()", []);
        }
      }, l.controllerDisabled = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("controllerDisabled()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("controllerDisabled()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("controllerDisabled()", []);
        }
      }, l.symbol = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("symbol()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("symbol()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("symbol()", []);
        }
      }, l.decreaseAllowance = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("spender", e), h.assert.isBigNumber("subtractedValue", t), o = (n = this)._strictEncodeArguments("decreaseAllowance(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: d
                  }, c), n.decreaseAllowance.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), b = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new p.PolyResponse(l, b)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("spender", e), h.assert.isBigNumber("subtractedValue", t), o = (n = this)._strictEncodeArguments("decreaseAllowance(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: d
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return p = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, p < m ? p : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("spender", e), h.assert.isBigNumber("subtractedValue", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("decreaseAllowance(address,uint256)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("decreaseAllowance(address,uint256)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("spender", e), h.assert.isBigNumber("subtractedValue", t), this._strictEncodeArguments("decreaseAllowance(address,uint256)", [e, t]);
        }
      }, l.moduleRegistry = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("moduleRegistry()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("moduleRegistry()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("moduleRegistry()", []);
        }
      }, l.securityTokenRegistry = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("securityTokenRegistry()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("securityTokenRegistry()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("securityTokenRegistry()", []);
        }
      }, l.tokenDetails = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("tokenDetails()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("tokenDetails()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("tokenDetails()", []);
        }
      }, l.allowance = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("owner", e), h.assert.isString("spender", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("allowance(address,address)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("allowance(address,address)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("owner", e), h.assert.isString("spender", t), this._strictEncodeArguments("allowance(address,address)", [e, t]);
        }
      }, l.transfersFrozen = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("transfersFrozen()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("transfersFrozen()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("transfersFrozen()", []);
        }
      }, l.tokenFactory = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("tokenFactory()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("tokenFactory()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("tokenFactory()", []);
        }
      }, l.controller = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("controller()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("controller()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("controller()", []);
        }
      }, l.initialize = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_getterDelegate", e), n = (r = this)._strictEncodeArguments("initialize(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.initialize.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_getterDelegate", e), n = (r = this)._strictEncodeArguments("initialize(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_getterDelegate", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("initialize(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("initialize(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_getterDelegate", e), this._strictEncodeArguments("initialize(address)", [e]);
        }
      }, l.isModule = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_module", e), h.assert.isNumberOrBigNumber("_type", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("isModule(address,uint8)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("isModule(address,uint8)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("_module", e), h.assert.isNumberOrBigNumber("_type", t), this._strictEncodeArguments("isModule(address,uint8)", [e, t]);
        }
      }, l.addModuleWithLabel = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, d, f) {
          return o(this, void 0, void 0, function () {
            var o, l, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_moduleFactory", e), h.assert.isString("_data", t), h.assert.isBigNumber("_maxCost", a), h.assert.isBigNumber("_budget", r), h.assert.isString("_label", n), h.assert.isBoolean("_archived", c), l = (o = this)._strictEncodeArguments("addModuleWithLabel(address,bytes,uint256,uint256,bytes32,bool)", [e, t, a, r, n, c]), b = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return m = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, d, {
                    data: l
                  }), s({
                    from: m
                  }, b), o.addModuleWithLabel.estimateGasAsync.bind(o, e, t, a, r, n, c, f))];

                case 2:
                  return void 0 !== (y = i.sent()).from && (y.from = y.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(y)];

                case 3:
                  return v = i.sent(), _ = o._web3Wrapper.awaitTransactionSuccessAsync(v), [2, new p.PolyResponse(v, _)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, d, f) {
          return o(this, void 0, void 0, function () {
            var o, l, p, b, m, y, v, _, g;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_moduleFactory", e), h.assert.isString("_data", t), h.assert.isBigNumber("_maxCost", a), h.assert.isBigNumber("_budget", r), h.assert.isString("_label", n), h.assert.isBoolean("_archived", c), l = (o = this)._strictEncodeArguments("addModuleWithLabel(address,bytes,uint256,uint256,bytes32,bool)", [e, t, a, r, n, c]), p = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return b = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, f, {
                    data: l
                  }), s({
                    from: b
                  }, p))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(m)];

                case 3:
                  return y = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return v = i.sent().gasLimit, _ = void 0 === d ? o._defaultEstimateGasFactor : d, g = Math.round(_ * y), [2, v < g ? v : g];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, f, l) {
          return void 0 === f && (f = {}), o(this, void 0, void 0, function () {
            var o, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_moduleFactory", e), h.assert.isString("_data", t), h.assert.isBigNumber("_maxCost", a), h.assert.isBigNumber("_budget", r), h.assert.isString("_label", n), h.assert.isBoolean("_archived", c), h.assert.doesConformToSchema("callData", f, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== l && h.assert.isBlockParam("defaultBlock", l), p = (o = this)._strictEncodeArguments("addModuleWithLabel(address,bytes,uint256,uint256,bytes32,bool)", [e, t, a, r, n, c]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, f, {
                    data: p
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (b = i.sent()).from = b.from ? b.from.toLowerCase() : b.from, [4, o._web3Wrapper.callAsync(b, l)];

                case 2:
                  return m = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(m), [2, o._lookupAbiEncoder("addModuleWithLabel(address,bytes,uint256,uint256,bytes32,bool)").strictDecodeReturnValue(m)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s) {
          return h.assert.isString("_moduleFactory", e), h.assert.isString("_data", t), h.assert.isBigNumber("_maxCost", a), h.assert.isBigNumber("_budget", r), h.assert.isString("_label", n), h.assert.isBoolean("_archived", s), this._strictEncodeArguments("addModuleWithLabel(address,bytes,uint256,uint256,bytes32,bool)", [e, t, a, r, n, s]);
        }
      }, l.addModule = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, d) {
          return o(this, void 0, void 0, function () {
            var o, f, l, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_moduleFactory", e), h.assert.isString("_data", t), h.assert.isBigNumber("_maxCost", a), h.assert.isBigNumber("_budget", r), h.assert.isBoolean("_archived", n), f = (o = this)._strictEncodeArguments("addModule(address,bytes,uint256,uint256,bool)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return b = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: f
                  }), s({
                    from: b
                  }, l), o.addModule.estimateGasAsync.bind(o, e, t, a, r, n, d))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(m)];

                case 3:
                  return y = i.sent(), v = o._web3Wrapper.awaitTransactionSuccessAsync(y), [2, new p.PolyResponse(y, v)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, d) {
          return o(this, void 0, void 0, function () {
            var o, f, l, p, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_moduleFactory", e), h.assert.isString("_data", t), h.assert.isBigNumber("_maxCost", a), h.assert.isBigNumber("_budget", r), h.assert.isBoolean("_archived", n), f = (o = this)._strictEncodeArguments("addModule(address,bytes,uint256,uint256,bool)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return p = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, d, {
                    data: f
                  }), s({
                    from: p
                  }, l))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(b)];

                case 3:
                  return m = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return y = i.sent().gasLimit, v = void 0 === c ? o._defaultEstimateGasFactor : c, _ = Math.round(v * m), [2, y < _ ? y : _];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, f) {
          return void 0 === c && (c = {}), o(this, void 0, void 0, function () {
            var o, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_moduleFactory", e), h.assert.isString("_data", t), h.assert.isBigNumber("_maxCost", a), h.assert.isBigNumber("_budget", r), h.assert.isBoolean("_archived", n), h.assert.doesConformToSchema("callData", c, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== f && h.assert.isBlockParam("defaultBlock", f), l = (o = this)._strictEncodeArguments("addModule(address,bytes,uint256,uint256,bool)", [e, t, a, r, n]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: l
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (p = i.sent()).from = p.from ? p.from.toLowerCase() : p.from, [4, o._web3Wrapper.callAsync(p, f)];

                case 2:
                  return b = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(b), [2, o._lookupAbiEncoder("addModule(address,bytes,uint256,uint256,bool)").strictDecodeReturnValue(b)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n) {
          return h.assert.isString("_moduleFactory", e), h.assert.isString("_data", t), h.assert.isBigNumber("_maxCost", a), h.assert.isBigNumber("_budget", r), h.assert.isBoolean("_archived", n), this._strictEncodeArguments("addModule(address,bytes,uint256,uint256,bool)", [e, t, a, r, n]);
        }
      }, l.archiveModule = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_module", e), n = (r = this)._strictEncodeArguments("archiveModule(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.archiveModule.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_module", e), n = (r = this)._strictEncodeArguments("archiveModule(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_module", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("archiveModule(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("archiveModule(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_module", e), this._strictEncodeArguments("archiveModule(address)", [e]);
        }
      }, l.upgradeModule = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_module", e), n = (r = this)._strictEncodeArguments("upgradeModule(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.upgradeModule.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_module", e), n = (r = this)._strictEncodeArguments("upgradeModule(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_module", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("upgradeModule(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("upgradeModule(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_module", e), this._strictEncodeArguments("upgradeModule(address)", [e]);
        }
      }, l.upgradeToken = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("upgradeToken()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.upgradeToken.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return d = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(d), [2, new p.PolyResponse(d, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("upgradeToken()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return d = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * d), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("upgradeToken()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("upgradeToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("upgradeToken()", []);
        }
      }, l.unarchiveModule = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_module", e), n = (r = this)._strictEncodeArguments("unarchiveModule(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.unarchiveModule.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_module", e), n = (r = this)._strictEncodeArguments("unarchiveModule(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_module", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("unarchiveModule(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("unarchiveModule(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_module", e), this._strictEncodeArguments("unarchiveModule(address)", [e]);
        }
      }, l.removeModule = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_module", e), n = (r = this)._strictEncodeArguments("removeModule(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.removeModule.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_module", e), n = (r = this)._strictEncodeArguments("removeModule(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_module", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("removeModule(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("removeModule(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_module", e), this._strictEncodeArguments("removeModule(address)", [e]);
        }
      }, l.withdrawERC20 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenContract", e), h.assert.isBigNumber("_value", t), o = (n = this)._strictEncodeArguments("withdrawERC20(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: d
                  }, c), n.withdrawERC20.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), b = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new p.PolyResponse(l, b)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenContract", e), h.assert.isBigNumber("_value", t), o = (n = this)._strictEncodeArguments("withdrawERC20(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: d
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return p = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, p < m ? p : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenContract", e), h.assert.isBigNumber("_value", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("withdrawERC20(address,uint256)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("withdrawERC20(address,uint256)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("_tokenContract", e), h.assert.isBigNumber("_value", t), this._strictEncodeArguments("withdrawERC20(address,uint256)", [e, t]);
        }
      }, l.changeModuleBudget = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_module", e), h.assert.isBigNumber("_change", t), h.assert.isBoolean("_increase", a), c = (o = this)._strictEncodeArguments("changeModuleBudget(address,uint256,bool)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, d), o.changeModuleBudget.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return b = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(b), [2, new p.PolyResponse(b, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, p, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_module", e), h.assert.isBigNumber("_change", t), h.assert.isBoolean("_increase", a), c = (o = this)._strictEncodeArguments("changeModuleBudget(address,uint256,bool)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, d))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return p = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * p), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_module", e), h.assert.isBigNumber("_change", t), h.assert.isBoolean("_increase", a), h.assert.doesConformToSchema("callData", r, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== n && h.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("changeModuleBudget(address,uint256,bool)", [e, t, a]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (f = i.sent()).from = f.from ? f.from.toLowerCase() : f.from, [4, o._web3Wrapper.callAsync(f, n)];

                case 2:
                  return l = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("changeModuleBudget(address,uint256,bool)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return h.assert.isString("_module", e), h.assert.isBigNumber("_change", t), h.assert.isBoolean("_increase", a), this._strictEncodeArguments("changeModuleBudget(address,uint256,bool)", [e, t, a]);
        }
      }, l.updateTokenDetails = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_newTokenDetails", e), n = (r = this)._strictEncodeArguments("updateTokenDetails(string)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.updateTokenDetails.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_newTokenDetails", e), n = (r = this)._strictEncodeArguments("updateTokenDetails(string)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_newTokenDetails", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("updateTokenDetails(string)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("updateTokenDetails(string)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_newTokenDetails", e), this._strictEncodeArguments("updateTokenDetails(string)", [e]);
        }
      }, l.changeGranularity = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_granularity", e), n = (r = this)._strictEncodeArguments("changeGranularity(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeGranularity.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_granularity", e), n = (r = this)._strictEncodeArguments("changeGranularity(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_granularity", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeGranularity(uint256)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeGranularity(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isBigNumber("_granularity", e), this._strictEncodeArguments("changeGranularity(uint256)", [e]);
        }
      }, l.changeDataStore = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_dataStore", e), n = (r = this)._strictEncodeArguments("changeDataStore(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeDataStore.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_dataStore", e), n = (r = this)._strictEncodeArguments("changeDataStore(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_dataStore", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeDataStore(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeDataStore(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_dataStore", e), this._strictEncodeArguments("changeDataStore(address)", [e]);
        }
      }, l.changeName = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_name", e), n = (r = this)._strictEncodeArguments("changeName(string)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeName.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_name", e), n = (r = this)._strictEncodeArguments("changeName(string)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_name", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeName(string)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeName(string)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_name", e), this._strictEncodeArguments("changeName(string)", [e]);
        }
      }, l.changeTreasuryWallet = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_wallet", e), n = (r = this)._strictEncodeArguments("changeTreasuryWallet(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeTreasuryWallet.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_wallet", e), n = (r = this)._strictEncodeArguments("changeTreasuryWallet(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_wallet", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeTreasuryWallet(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeTreasuryWallet(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_wallet", e), this._strictEncodeArguments("changeTreasuryWallet(address)", [e]);
        }
      }, l.freezeTransfers = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("freezeTransfers()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.freezeTransfers.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return d = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(d), [2, new p.PolyResponse(d, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("freezeTransfers()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return d = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * d), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("freezeTransfers()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("freezeTransfers()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("freezeTransfers()", []);
        }
      }, l.unfreezeTransfers = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unfreezeTransfers()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.unfreezeTransfers.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return d = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(d), [2, new p.PolyResponse(d, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unfreezeTransfers()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return d = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * d), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("unfreezeTransfers()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("unfreezeTransfers()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("unfreezeTransfers()", []);
        }
      }, l.transfer = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_to", e), h.assert.isBigNumber("_value", t), o = (n = this)._strictEncodeArguments("transfer(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: d
                  }, c), n.transfer.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), b = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new p.PolyResponse(l, b)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_to", e), h.assert.isBigNumber("_value", t), o = (n = this)._strictEncodeArguments("transfer(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: d
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return p = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, p < m ? p : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_to", e), h.assert.isBigNumber("_value", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("transfer(address,uint256)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("transfer(address,uint256)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("_to", e), h.assert.isBigNumber("_value", t), this._strictEncodeArguments("transfer(address,uint256)", [e, t]);
        }
      }, l.transferWithData = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_to", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), c = (o = this)._strictEncodeArguments("transferWithData(address,uint256,bytes)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, d), o.transferWithData.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return b = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(b), [2, new p.PolyResponse(b, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, p, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_to", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), c = (o = this)._strictEncodeArguments("transferWithData(address,uint256,bytes)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, d))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return p = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * p), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_to", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), h.assert.doesConformToSchema("callData", r, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== n && h.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("transferWithData(address,uint256,bytes)", [e, t, a]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (f = i.sent()).from = f.from ? f.from.toLowerCase() : f.from, [4, o._web3Wrapper.callAsync(f, n)];

                case 2:
                  return l = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("transferWithData(address,uint256,bytes)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return h.assert.isString("_to", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), this._strictEncodeArguments("transferWithData(address,uint256,bytes)", [e, t, a]);
        }
      }, l.transferFrom = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_from", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), c = (o = this)._strictEncodeArguments("transferFrom(address,address,uint256)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, d), o.transferFrom.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return b = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(b), [2, new p.PolyResponse(b, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, p, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_from", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), c = (o = this)._strictEncodeArguments("transferFrom(address,address,uint256)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, d))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return p = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * p), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_from", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), h.assert.doesConformToSchema("callData", r, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== n && h.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("transferFrom(address,address,uint256)", [e, t, a]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (f = i.sent()).from = f.from ? f.from.toLowerCase() : f.from, [4, o._web3Wrapper.callAsync(f, n)];

                case 2:
                  return l = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("transferFrom(address,address,uint256)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return h.assert.isString("_from", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), this._strictEncodeArguments("transferFrom(address,address,uint256)", [e, t, a]);
        }
      }, l.transferFromWithData = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, d, f, l, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_from", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), d = (o = this)._strictEncodeArguments("transferFromWithData(address,address,uint256,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: d
                  }), s({
                    from: l
                  }, f), o.transferFromWithData.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(b)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new p.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, d, f, l, p, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_from", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), d = (o = this)._strictEncodeArguments("transferFromWithData(address,address,uint256,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: d
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (p = i.sent()).from && (p.from = p.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(p)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, f, l, p;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_from", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), h.assert.doesConformToSchema("callData", n, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== c && h.assert.isBlockParam("defaultBlock", c), f = (o = this)._strictEncodeArguments("transferFromWithData(address,address,uint256,bytes)", [e, t, a, r]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: f
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return p = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(p), [2, o._lookupAbiEncoder("transferFromWithData(address,address,uint256,bytes)").strictDecodeReturnValue(p)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return h.assert.isString("_from", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), this._strictEncodeArguments("transferFromWithData(address,address,uint256,bytes)", [e, t, a, r]);
        }
      }, l.balanceOfByPartition = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_tokenHolder", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("balanceOfByPartition(bytes32,address)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("balanceOfByPartition(bytes32,address)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("_partition", e), h.assert.isString("_tokenHolder", t), this._strictEncodeArguments("balanceOfByPartition(bytes32,address)", [e, t]);
        }
      }, l.transferByPartition = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, d, f, l, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), d = (o = this)._strictEncodeArguments("transferByPartition(bytes32,address,uint256,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: d
                  }), s({
                    from: l
                  }, f), o.transferByPartition.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(b)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new p.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, d, f, l, p, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), d = (o = this)._strictEncodeArguments("transferByPartition(bytes32,address,uint256,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: d
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (p = i.sent()).from && (p.from = p.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(p)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, f, l, p;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), h.assert.doesConformToSchema("callData", n, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== c && h.assert.isBlockParam("defaultBlock", c), f = (o = this)._strictEncodeArguments("transferByPartition(bytes32,address,uint256,bytes)", [e, t, a, r]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: f
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return p = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(p), [2, o._lookupAbiEncoder("transferByPartition(bytes32,address,uint256,bytes)").strictDecodeReturnValue(p)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return h.assert.isString("_partition", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), this._strictEncodeArguments("transferByPartition(bytes32,address,uint256,bytes)", [e, t, a, r]);
        }
      }, l.authorizeOperator = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_operator", e), n = (r = this)._strictEncodeArguments("authorizeOperator(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.authorizeOperator.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_operator", e), n = (r = this)._strictEncodeArguments("authorizeOperator(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_operator", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("authorizeOperator(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("authorizeOperator(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_operator", e), this._strictEncodeArguments("authorizeOperator(address)", [e]);
        }
      }, l.revokeOperator = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_operator", e), n = (r = this)._strictEncodeArguments("revokeOperator(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.revokeOperator.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_operator", e), n = (r = this)._strictEncodeArguments("revokeOperator(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_operator", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("revokeOperator(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("revokeOperator(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_operator", e), this._strictEncodeArguments("revokeOperator(address)", [e]);
        }
      }, l.authorizeOperatorByPartition = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_operator", t), o = (n = this)._strictEncodeArguments("authorizeOperatorByPartition(bytes32,address)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: d
                  }, c), n.authorizeOperatorByPartition.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), b = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new p.PolyResponse(l, b)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_operator", t), o = (n = this)._strictEncodeArguments("authorizeOperatorByPartition(bytes32,address)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: d
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return p = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, p < m ? p : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_operator", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("authorizeOperatorByPartition(bytes32,address)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("authorizeOperatorByPartition(bytes32,address)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("_partition", e), h.assert.isString("_operator", t), this._strictEncodeArguments("authorizeOperatorByPartition(bytes32,address)", [e, t]);
        }
      }, l.revokeOperatorByPartition = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_operator", t), o = (n = this)._strictEncodeArguments("revokeOperatorByPartition(bytes32,address)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: d
                  }, c), n.revokeOperatorByPartition.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), b = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new p.PolyResponse(l, b)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_operator", t), o = (n = this)._strictEncodeArguments("revokeOperatorByPartition(bytes32,address)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: d
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return p = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, p < m ? p : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_operator", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("revokeOperatorByPartition(bytes32,address)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("revokeOperatorByPartition(bytes32,address)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("_partition", e), h.assert.isString("_operator", t), this._strictEncodeArguments("revokeOperatorByPartition(bytes32,address)", [e, t]);
        }
      }, l.operatorTransferByPartition = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, d, f) {
          return o(this, void 0, void 0, function () {
            var o, l, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_from", t), h.assert.isString("_to", a), h.assert.isBigNumber("_value", r), h.assert.isString("_data", n), h.assert.isString("_operatorData", c), l = (o = this)._strictEncodeArguments("operatorTransferByPartition(bytes32,address,address,uint256,bytes,bytes)", [e, t, a, r, n, c]), b = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return m = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, d, {
                    data: l
                  }), s({
                    from: m
                  }, b), o.operatorTransferByPartition.estimateGasAsync.bind(o, e, t, a, r, n, c, f))];

                case 2:
                  return void 0 !== (y = i.sent()).from && (y.from = y.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(y)];

                case 3:
                  return v = i.sent(), _ = o._web3Wrapper.awaitTransactionSuccessAsync(v), [2, new p.PolyResponse(v, _)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, d, f) {
          return o(this, void 0, void 0, function () {
            var o, l, p, b, m, y, v, _, g;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_from", t), h.assert.isString("_to", a), h.assert.isBigNumber("_value", r), h.assert.isString("_data", n), h.assert.isString("_operatorData", c), l = (o = this)._strictEncodeArguments("operatorTransferByPartition(bytes32,address,address,uint256,bytes,bytes)", [e, t, a, r, n, c]), p = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return b = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, f, {
                    data: l
                  }), s({
                    from: b
                  }, p))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(m)];

                case 3:
                  return y = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return v = i.sent().gasLimit, _ = void 0 === d ? o._defaultEstimateGasFactor : d, g = Math.round(_ * y), [2, v < g ? v : g];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, f, l) {
          return void 0 === f && (f = {}), o(this, void 0, void 0, function () {
            var o, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_from", t), h.assert.isString("_to", a), h.assert.isBigNumber("_value", r), h.assert.isString("_data", n), h.assert.isString("_operatorData", c), h.assert.doesConformToSchema("callData", f, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== l && h.assert.isBlockParam("defaultBlock", l), p = (o = this)._strictEncodeArguments("operatorTransferByPartition(bytes32,address,address,uint256,bytes,bytes)", [e, t, a, r, n, c]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, f, {
                    data: p
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (b = i.sent()).from = b.from ? b.from.toLowerCase() : b.from, [4, o._web3Wrapper.callAsync(b, l)];

                case 2:
                  return m = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(m), [2, o._lookupAbiEncoder("operatorTransferByPartition(bytes32,address,address,uint256,bytes,bytes)").strictDecodeReturnValue(m)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s) {
          return h.assert.isString("_partition", e), h.assert.isString("_from", t), h.assert.isString("_to", a), h.assert.isBigNumber("_value", r), h.assert.isString("_data", n), h.assert.isString("_operatorData", s), this._strictEncodeArguments("operatorTransferByPartition(bytes32,address,address,uint256,bytes,bytes)", [e, t, a, r, n, s]);
        }
      }, l.freezeIssuance = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_signature", e), n = (r = this)._strictEncodeArguments("freezeIssuance(bytes)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.freezeIssuance.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_signature", e), n = (r = this)._strictEncodeArguments("freezeIssuance(bytes)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_signature", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("freezeIssuance(bytes)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("freezeIssuance(bytes)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_signature", e), this._strictEncodeArguments("freezeIssuance(bytes)", [e]);
        }
      }, l.issue = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenHolder", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), c = (o = this)._strictEncodeArguments("issue(address,uint256,bytes)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, d), o.issue.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return b = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(b), [2, new p.PolyResponse(b, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, p, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenHolder", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), c = (o = this)._strictEncodeArguments("issue(address,uint256,bytes)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, d))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return p = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * p), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenHolder", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), h.assert.doesConformToSchema("callData", r, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== n && h.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("issue(address,uint256,bytes)", [e, t, a]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (f = i.sent()).from = f.from ? f.from.toLowerCase() : f.from, [4, o._web3Wrapper.callAsync(f, n)];

                case 2:
                  return l = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("issue(address,uint256,bytes)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return h.assert.isString("_tokenHolder", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), this._strictEncodeArguments("issue(address,uint256,bytes)", [e, t, a]);
        }
      }, l.issueMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isArray("_tokenHolders", e), h.assert.isArray("_values", t), o = (n = this)._strictEncodeArguments("issueMulti(address[],uint256[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: d
                  }, c), n.issueMulti.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), b = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new p.PolyResponse(l, b)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isArray("_tokenHolders", e), h.assert.isArray("_values", t), o = (n = this)._strictEncodeArguments("issueMulti(address[],uint256[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: d
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return p = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, p < m ? p : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isArray("_tokenHolders", e), h.assert.isArray("_values", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("issueMulti(address[],uint256[])", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("issueMulti(address[],uint256[])").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isArray("_tokenHolders", e), h.assert.isArray("_values", t), this._strictEncodeArguments("issueMulti(address[],uint256[])", [e, t]);
        }
      }, l.issueByPartition = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, d, f, l, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_tokenHolder", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), d = (o = this)._strictEncodeArguments("issueByPartition(bytes32,address,uint256,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: d
                  }), s({
                    from: l
                  }, f), o.issueByPartition.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(b)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new p.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, d, f, l, p, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_tokenHolder", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), d = (o = this)._strictEncodeArguments("issueByPartition(bytes32,address,uint256,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: d
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (p = i.sent()).from && (p.from = p.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(p)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, f, l, p;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_tokenHolder", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), h.assert.doesConformToSchema("callData", n, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== c && h.assert.isBlockParam("defaultBlock", c), f = (o = this)._strictEncodeArguments("issueByPartition(bytes32,address,uint256,bytes)", [e, t, a, r]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: f
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return p = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(p), [2, o._lookupAbiEncoder("issueByPartition(bytes32,address,uint256,bytes)").strictDecodeReturnValue(p)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return h.assert.isString("_partition", e), h.assert.isString("_tokenHolder", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), this._strictEncodeArguments("issueByPartition(bytes32,address,uint256,bytes)", [e, t, a, r]);
        }
      }, l.redeem = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_value", e), h.assert.isString("_data", t), o = (n = this)._strictEncodeArguments("redeem(uint256,bytes)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: d
                  }, c), n.redeem.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), b = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new p.PolyResponse(l, b)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_value", e), h.assert.isString("_data", t), o = (n = this)._strictEncodeArguments("redeem(uint256,bytes)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: d
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return p = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, p < m ? p : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_value", e), h.assert.isString("_data", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("redeem(uint256,bytes)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("redeem(uint256,bytes)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isBigNumber("_value", e), h.assert.isString("_data", t), this._strictEncodeArguments("redeem(uint256,bytes)", [e, t]);
        }
      }, l.redeemByPartition = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), c = (o = this)._strictEncodeArguments("redeemByPartition(bytes32,uint256,bytes)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, d), o.redeemByPartition.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return b = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(b), [2, new p.PolyResponse(b, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, p, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), c = (o = this)._strictEncodeArguments("redeemByPartition(bytes32,uint256,bytes)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, d))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return p = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * p), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), h.assert.doesConformToSchema("callData", r, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== n && h.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("redeemByPartition(bytes32,uint256,bytes)", [e, t, a]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (f = i.sent()).from = f.from ? f.from.toLowerCase() : f.from, [4, o._web3Wrapper.callAsync(f, n)];

                case 2:
                  return l = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("redeemByPartition(bytes32,uint256,bytes)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return h.assert.isString("_partition", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), this._strictEncodeArguments("redeemByPartition(bytes32,uint256,bytes)", [e, t, a]);
        }
      }, l.operatorRedeemByPartition = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, d) {
          return o(this, void 0, void 0, function () {
            var o, f, l, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_tokenHolder", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), h.assert.isString("_operatorData", n), f = (o = this)._strictEncodeArguments("operatorRedeemByPartition(bytes32,address,uint256,bytes,bytes)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return b = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: f
                  }), s({
                    from: b
                  }, l), o.operatorRedeemByPartition.estimateGasAsync.bind(o, e, t, a, r, n, d))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(m)];

                case 3:
                  return y = i.sent(), v = o._web3Wrapper.awaitTransactionSuccessAsync(y), [2, new p.PolyResponse(y, v)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, d) {
          return o(this, void 0, void 0, function () {
            var o, f, l, p, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_tokenHolder", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), h.assert.isString("_operatorData", n), f = (o = this)._strictEncodeArguments("operatorRedeemByPartition(bytes32,address,uint256,bytes,bytes)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return p = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, d, {
                    data: f
                  }), s({
                    from: p
                  }, l))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(b)];

                case 3:
                  return m = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return y = i.sent().gasLimit, v = void 0 === c ? o._defaultEstimateGasFactor : c, _ = Math.round(v * m), [2, y < _ ? y : _];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, f) {
          return void 0 === c && (c = {}), o(this, void 0, void 0, function () {
            var o, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_tokenHolder", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), h.assert.isString("_operatorData", n), h.assert.doesConformToSchema("callData", c, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== f && h.assert.isBlockParam("defaultBlock", f), l = (o = this)._strictEncodeArguments("operatorRedeemByPartition(bytes32,address,uint256,bytes,bytes)", [e, t, a, r, n]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: l
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (p = i.sent()).from = p.from ? p.from.toLowerCase() : p.from, [4, o._web3Wrapper.callAsync(p, f)];

                case 2:
                  return b = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(b), [2, o._lookupAbiEncoder("operatorRedeemByPartition(bytes32,address,uint256,bytes,bytes)").strictDecodeReturnValue(b)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n) {
          return h.assert.isString("_partition", e), h.assert.isString("_tokenHolder", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), h.assert.isString("_operatorData", n), this._strictEncodeArguments("operatorRedeemByPartition(bytes32,address,uint256,bytes,bytes)", [e, t, a, r, n]);
        }
      }, l.redeemFrom = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenHolder", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), c = (o = this)._strictEncodeArguments("redeemFrom(address,uint256,bytes)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, d), o.redeemFrom.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return b = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(b), [2, new p.PolyResponse(b, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, p, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenHolder", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), c = (o = this)._strictEncodeArguments("redeemFrom(address,uint256,bytes)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, d))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return p = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * p), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenHolder", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), h.assert.doesConformToSchema("callData", r, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== n && h.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("redeemFrom(address,uint256,bytes)", [e, t, a]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (f = i.sent()).from = f.from ? f.from.toLowerCase() : f.from, [4, o._web3Wrapper.callAsync(f, n)];

                case 2:
                  return l = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("redeemFrom(address,uint256,bytes)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return h.assert.isString("_tokenHolder", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), this._strictEncodeArguments("redeemFrom(address,uint256,bytes)", [e, t, a]);
        }
      }, l.createCheckpoint = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("createCheckpoint()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.createCheckpoint.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return d = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(d), [2, new p.PolyResponse(d, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("createCheckpoint()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return d = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * d), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("createCheckpoint()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("createCheckpoint()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("createCheckpoint()", []);
        }
      }, l.setController = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_controller", e), n = (r = this)._strictEncodeArguments("setController(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.setController.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_controller", e), n = (r = this)._strictEncodeArguments("setController(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_controller", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("setController(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("setController(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_controller", e), this._strictEncodeArguments("setController(address)", [e]);
        }
      }, l.disableController = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_signature", e), n = (r = this)._strictEncodeArguments("disableController(bytes)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.disableController.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_signature", e), n = (r = this)._strictEncodeArguments("disableController(bytes)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_signature", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("disableController(bytes)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("disableController(bytes)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_signature", e), this._strictEncodeArguments("disableController(bytes)", [e]);
        }
      }, l.canTransfer = {
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_to", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), h.assert.doesConformToSchema("callData", r, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== n && h.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("canTransfer(address,uint256,bytes)", [e, t, a]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (f = i.sent()).from = f.from ? f.from.toLowerCase() : f.from, [4, o._web3Wrapper.callAsync(f, n)];

                case 2:
                  return l = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("canTransfer(address,uint256,bytes)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return h.assert.isString("_to", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), this._strictEncodeArguments("canTransfer(address,uint256,bytes)", [e, t, a]);
        }
      }, l.canTransferFrom = {
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, f, l, p;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_from", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), h.assert.doesConformToSchema("callData", n, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== c && h.assert.isBlockParam("defaultBlock", c), f = (o = this)._strictEncodeArguments("canTransferFrom(address,address,uint256,bytes)", [e, t, a, r]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: f
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return p = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(p), [2, o._lookupAbiEncoder("canTransferFrom(address,address,uint256,bytes)").strictDecodeReturnValue(p)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return h.assert.isString("_from", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), this._strictEncodeArguments("canTransferFrom(address,address,uint256,bytes)", [e, t, a, r]);
        }
      }, l.canTransferByPartition = {
        callAsync: function callAsync(e, t, a, r, n, c, f) {
          return void 0 === c && (c = {}), o(this, void 0, void 0, function () {
            var o, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_from", e), h.assert.isString("_to", t), h.assert.isString("_partition", a), h.assert.isBigNumber("_value", r), h.assert.isString("_data", n), h.assert.doesConformToSchema("callData", c, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== f && h.assert.isBlockParam("defaultBlock", f), l = (o = this)._strictEncodeArguments("canTransferByPartition(address,address,bytes32,uint256,bytes)", [e, t, a, r, n]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: l
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (p = i.sent()).from = p.from ? p.from.toLowerCase() : p.from, [4, o._web3Wrapper.callAsync(p, f)];

                case 2:
                  return b = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(b), [2, o._lookupAbiEncoder("canTransferByPartition(address,address,bytes32,uint256,bytes)").strictDecodeReturnValue(b)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n) {
          return h.assert.isString("_from", e), h.assert.isString("_to", t), h.assert.isString("_partition", a), h.assert.isBigNumber("_value", r), h.assert.isString("_data", n), this._strictEncodeArguments("canTransferByPartition(address,address,bytes32,uint256,bytes)", [e, t, a, r, n]);
        }
      }, l.setDocument = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_name", e), h.assert.isString("_uri", t), h.assert.isString("_documentHash", a), c = (o = this)._strictEncodeArguments("setDocument(bytes32,string,bytes32)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, d), o.setDocument.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return b = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(b), [2, new p.PolyResponse(b, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, p, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_name", e), h.assert.isString("_uri", t), h.assert.isString("_documentHash", a), c = (o = this)._strictEncodeArguments("setDocument(bytes32,string,bytes32)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, d))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return p = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * p), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_name", e), h.assert.isString("_uri", t), h.assert.isString("_documentHash", a), h.assert.doesConformToSchema("callData", r, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== n && h.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("setDocument(bytes32,string,bytes32)", [e, t, a]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (f = i.sent()).from = f.from ? f.from.toLowerCase() : f.from, [4, o._web3Wrapper.callAsync(f, n)];

                case 2:
                  return l = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("setDocument(bytes32,string,bytes32)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return h.assert.isString("_name", e), h.assert.isString("_uri", t), h.assert.isString("_documentHash", a), this._strictEncodeArguments("setDocument(bytes32,string,bytes32)", [e, t, a]);
        }
      }, l.removeDocument = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_name", e), n = (r = this)._strictEncodeArguments("removeDocument(bytes32)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.removeDocument.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_name", e), n = (r = this)._strictEncodeArguments("removeDocument(bytes32)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_name", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("removeDocument(bytes32)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("removeDocument(bytes32)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_name", e), this._strictEncodeArguments("removeDocument(bytes32)", [e]);
        }
      }, l.isControllable = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("isControllable()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("isControllable()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("isControllable()", []);
        }
      }, l.controllerTransfer = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, d) {
          return o(this, void 0, void 0, function () {
            var o, f, l, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_from", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), h.assert.isString("_operatorData", n), f = (o = this)._strictEncodeArguments("controllerTransfer(address,address,uint256,bytes,bytes)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return b = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: f
                  }), s({
                    from: b
                  }, l), o.controllerTransfer.estimateGasAsync.bind(o, e, t, a, r, n, d))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(m)];

                case 3:
                  return y = i.sent(), v = o._web3Wrapper.awaitTransactionSuccessAsync(y), [2, new p.PolyResponse(y, v)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, d) {
          return o(this, void 0, void 0, function () {
            var o, f, l, p, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_from", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), h.assert.isString("_operatorData", n), f = (o = this)._strictEncodeArguments("controllerTransfer(address,address,uint256,bytes,bytes)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return p = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, d, {
                    data: f
                  }), s({
                    from: p
                  }, l))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(b)];

                case 3:
                  return m = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return y = i.sent().gasLimit, v = void 0 === c ? o._defaultEstimateGasFactor : c, _ = Math.round(v * m), [2, y < _ ? y : _];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, f) {
          return void 0 === c && (c = {}), o(this, void 0, void 0, function () {
            var o, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_from", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), h.assert.isString("_operatorData", n), h.assert.doesConformToSchema("callData", c, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== f && h.assert.isBlockParam("defaultBlock", f), l = (o = this)._strictEncodeArguments("controllerTransfer(address,address,uint256,bytes,bytes)", [e, t, a, r, n]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: l
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (p = i.sent()).from = p.from ? p.from.toLowerCase() : p.from, [4, o._web3Wrapper.callAsync(p, f)];

                case 2:
                  return b = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(b), [2, o._lookupAbiEncoder("controllerTransfer(address,address,uint256,bytes,bytes)").strictDecodeReturnValue(b)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n) {
          return h.assert.isString("_from", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), h.assert.isString("_operatorData", n), this._strictEncodeArguments("controllerTransfer(address,address,uint256,bytes,bytes)", [e, t, a, r, n]);
        }
      }, l.controllerRedeem = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, d, f, l, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenHolder", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), h.assert.isString("_operatorData", r), d = (o = this)._strictEncodeArguments("controllerRedeem(address,uint256,bytes,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: d
                  }), s({
                    from: l
                  }, f), o.controllerRedeem.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(b)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new p.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, d, f, l, p, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenHolder", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), h.assert.isString("_operatorData", r), d = (o = this)._strictEncodeArguments("controllerRedeem(address,uint256,bytes,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: d
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (p = i.sent()).from && (p.from = p.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(p)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, f, l, p;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenHolder", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), h.assert.isString("_operatorData", r), h.assert.doesConformToSchema("callData", n, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== c && h.assert.isBlockParam("defaultBlock", c), f = (o = this)._strictEncodeArguments("controllerRedeem(address,uint256,bytes,bytes)", [e, t, a, r]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: f
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return p = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(p), [2, o._lookupAbiEncoder("controllerRedeem(address,uint256,bytes,bytes)").strictDecodeReturnValue(p)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return h.assert.isString("_tokenHolder", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), h.assert.isString("_operatorData", r), this._strictEncodeArguments("controllerRedeem(address,uint256,bytes,bytes)", [e, t, a, r]);
        }
      }, l.updateFromRegistry = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("updateFromRegistry()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.updateFromRegistry.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return d = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(d), [2, new p.PolyResponse(d, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("updateFromRegistry()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return d = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * d), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("updateFromRegistry()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("updateFromRegistry()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("updateFromRegistry()", []);
        }
      }, l.owner = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("owner()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("owner()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("owner()", []);
        }
      }, l.isOwner = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("isOwner()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("isOwner()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("isOwner()", []);
        }
      }, l.transferOwnership = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("newOwner", e), n = (r = this)._strictEncodeArguments("transferOwnership(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.transferOwnership.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("newOwner", e), n = (r = this)._strictEncodeArguments("transferOwnership(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("newOwner", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("transferOwnership(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("transferOwnership(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("newOwner", e), this._strictEncodeArguments("transferOwnership(address)", [e]);
        }
      }, l._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, f.classUtils.bindAll(l, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), l;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n) {
      return o(this, void 0, void 0, function () {
        var s, o, c, p, b, y, v, _, g, A;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return h.assert.isHexString("bytecode", e), h.assert.doesConformToSchema("txDefaults", n, d.schemas.txDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), s = f.providerUtils.standardizeOrThrow(r), o = u.BaseContract._lookupConstructorAbi(a), u.BaseContract._formatABIDataItemList(o.inputs, [], u.BaseContract._bigNumberToString), c = new m.utils.Interface(a), p = c.deployFunction, b = p.encode(e, []), y = new l.Web3Wrapper(s), [4, u.BaseContract._applyDefaultsToTxDataAsync({
                data: b
              }, n, y.estimateGasAsync.bind(y))];

            case 1:
              return v = i.sent(), [4, y.sendTransactionAsync(v)];

            case 2:
              return _ = i.sent(), f.logUtils.log("transactionHash: " + _), [4, y.awaitTransactionSuccessAsync(_)];

            case 3:
              return g = i.sent(), f.logUtils.log("SecurityToken successfully deployed at " + g.contractAddress), (A = new t(g.contractAddress, s, n)).constructorArgs = [], [2, A];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !0,
        inputs: [],
        name: "name",
        outputs: [{
          name: "",
          type: "string"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "spender",
          type: "address"
        }, {
          name: "value",
          type: "uint256"
        }],
        name: "approve",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "initialized",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "totalSupply",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "holderCount",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getterDelegate",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "decimals",
        outputs: [{
          name: "",
          type: "uint8"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "spender",
          type: "address"
        }, {
          name: "addedValue",
          type: "uint256"
        }],
        name: "increaseAllowance",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "currentCheckpointId",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "granularity",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "dataStore",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "polyToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "owner",
          type: "address"
        }],
        name: "balanceOf",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "polymathRegistry",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "controllerDisabled",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "symbol",
        outputs: [{
          name: "",
          type: "string"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "spender",
          type: "address"
        }, {
          name: "subtractedValue",
          type: "uint256"
        }],
        name: "decreaseAllowance",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "moduleRegistry",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "securityTokenRegistry",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "tokenDetails",
        outputs: [{
          name: "",
          type: "string"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "owner",
          type: "address"
        }, {
          name: "spender",
          type: "address"
        }],
        name: "allowance",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "transfersFrozen",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "tokenFactory",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "controller",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        inputs: [],
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "constructor"
      }, {
        inputs: [],
        outputs: [],
        payable: !0,
        stateMutability: "payable",
        type: "fallback"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_types",
          type: "uint8[]",
          indexed: !1
        }, {
          name: "_name",
          type: "bytes32",
          indexed: !0
        }, {
          name: "_moduleFactory",
          type: "address",
          indexed: !0
        }, {
          name: "_module",
          type: "address",
          indexed: !1
        }, {
          name: "_moduleCost",
          type: "uint256",
          indexed: !1
        }, {
          name: "_budget",
          type: "uint256",
          indexed: !1
        }, {
          name: "_label",
          type: "bytes32",
          indexed: !1
        }, {
          name: "_archived",
          type: "bool",
          indexed: !1
        }],
        name: "ModuleAdded",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_types",
          type: "uint8[]",
          indexed: !1
        }, {
          name: "_module",
          type: "address",
          indexed: !1
        }],
        name: "ModuleUpgraded",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_oldDetails",
          type: "string",
          indexed: !1
        }, {
          name: "_newDetails",
          type: "string",
          indexed: !1
        }],
        name: "UpdateTokenDetails",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_oldName",
          type: "string",
          indexed: !1
        }, {
          name: "_newName",
          type: "string",
          indexed: !1
        }],
        name: "UpdateTokenName",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_oldGranularity",
          type: "uint256",
          indexed: !1
        }, {
          name: "_newGranularity",
          type: "uint256",
          indexed: !1
        }],
        name: "GranularityChanged",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [],
        name: "FreezeIssuance",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_status",
          type: "bool",
          indexed: !1
        }],
        name: "FreezeTransfers",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_checkpointId",
          type: "uint256",
          indexed: !0
        }, {
          name: "_investorLength",
          type: "uint256",
          indexed: !1
        }],
        name: "CheckpointCreated",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_oldController",
          type: "address",
          indexed: !0
        }, {
          name: "_newController",
          type: "address",
          indexed: !0
        }],
        name: "SetController",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_oldTreasuryWallet",
          type: "address",
          indexed: !1
        }, {
          name: "_newTreasuryWallet",
          type: "address",
          indexed: !1
        }],
        name: "TreasuryWalletChanged",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [],
        name: "DisableController",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "previousOwner",
          type: "address",
          indexed: !0
        }, {
          name: "newOwner",
          type: "address",
          indexed: !0
        }],
        name: "OwnershipTransferred",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_major",
          type: "uint8",
          indexed: !1
        }, {
          name: "_minor",
          type: "uint8",
          indexed: !1
        }, {
          name: "_patch",
          type: "uint8",
          indexed: !1
        }],
        name: "TokenUpgraded",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_types",
          type: "uint8[]",
          indexed: !1
        }, {
          name: "_module",
          type: "address",
          indexed: !1
        }],
        name: "ModuleArchived",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_types",
          type: "uint8[]",
          indexed: !1
        }, {
          name: "_module",
          type: "address",
          indexed: !1
        }],
        name: "ModuleUnarchived",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_types",
          type: "uint8[]",
          indexed: !1
        }, {
          name: "_module",
          type: "address",
          indexed: !1
        }],
        name: "ModuleRemoved",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_moduleTypes",
          type: "uint8[]",
          indexed: !1
        }, {
          name: "_module",
          type: "address",
          indexed: !1
        }, {
          name: "_oldBudget",
          type: "uint256",
          indexed: !1
        }, {
          name: "_budget",
          type: "uint256",
          indexed: !1
        }],
        name: "ModuleBudgetChanged",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_fromPartition",
          type: "bytes32",
          indexed: !0
        }, {
          name: "_operator",
          type: "address",
          indexed: !1
        }, {
          name: "_from",
          type: "address",
          indexed: !0
        }, {
          name: "_to",
          type: "address",
          indexed: !0
        }, {
          name: "_value",
          type: "uint256",
          indexed: !1
        }, {
          name: "_data",
          type: "bytes",
          indexed: !1
        }, {
          name: "_operatorData",
          type: "bytes",
          indexed: !1
        }],
        name: "TransferByPartition",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "operator",
          type: "address",
          indexed: !0
        }, {
          name: "tokenHolder",
          type: "address",
          indexed: !0
        }],
        name: "AuthorizedOperator",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "operator",
          type: "address",
          indexed: !0
        }, {
          name: "tokenHolder",
          type: "address",
          indexed: !0
        }],
        name: "RevokedOperator",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "partition",
          type: "bytes32",
          indexed: !0
        }, {
          name: "operator",
          type: "address",
          indexed: !0
        }, {
          name: "tokenHolder",
          type: "address",
          indexed: !0
        }],
        name: "AuthorizedOperatorByPartition",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "partition",
          type: "bytes32",
          indexed: !0
        }, {
          name: "operator",
          type: "address",
          indexed: !0
        }, {
          name: "tokenHolder",
          type: "address",
          indexed: !0
        }],
        name: "RevokedOperatorByPartition",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "partition",
          type: "bytes32",
          indexed: !0
        }, {
          name: "to",
          type: "address",
          indexed: !0
        }, {
          name: "value",
          type: "uint256",
          indexed: !1
        }, {
          name: "data",
          type: "bytes",
          indexed: !1
        }],
        name: "IssuedByPartition",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "partition",
          type: "bytes32",
          indexed: !0
        }, {
          name: "operator",
          type: "address",
          indexed: !0
        }, {
          name: "from",
          type: "address",
          indexed: !0
        }, {
          name: "value",
          type: "uint256",
          indexed: !1
        }, {
          name: "data",
          type: "bytes",
          indexed: !1
        }, {
          name: "operatorData",
          type: "bytes",
          indexed: !1
        }],
        name: "RedeemedByPartition",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_controller",
          type: "address",
          indexed: !1
        }, {
          name: "_from",
          type: "address",
          indexed: !0
        }, {
          name: "_to",
          type: "address",
          indexed: !0
        }, {
          name: "_value",
          type: "uint256",
          indexed: !1
        }, {
          name: "_data",
          type: "bytes",
          indexed: !1
        }, {
          name: "_operatorData",
          type: "bytes",
          indexed: !1
        }],
        name: "ControllerTransfer",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_controller",
          type: "address",
          indexed: !1
        }, {
          name: "_tokenHolder",
          type: "address",
          indexed: !0
        }, {
          name: "_value",
          type: "uint256",
          indexed: !1
        }, {
          name: "_data",
          type: "bytes",
          indexed: !1
        }, {
          name: "_operatorData",
          type: "bytes",
          indexed: !1
        }],
        name: "ControllerRedemption",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_name",
          type: "bytes32",
          indexed: !0
        }, {
          name: "_uri",
          type: "string",
          indexed: !1
        }, {
          name: "_documentHash",
          type: "bytes32",
          indexed: !1
        }],
        name: "DocumentRemoved",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_name",
          type: "bytes32",
          indexed: !0
        }, {
          name: "_uri",
          type: "string",
          indexed: !1
        }, {
          name: "_documentHash",
          type: "bytes32",
          indexed: !1
        }],
        name: "DocumentUpdated",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_operator",
          type: "address",
          indexed: !0
        }, {
          name: "_to",
          type: "address",
          indexed: !0
        }, {
          name: "_value",
          type: "uint256",
          indexed: !1
        }, {
          name: "_data",
          type: "bytes",
          indexed: !1
        }],
        name: "Issued",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_operator",
          type: "address",
          indexed: !0
        }, {
          name: "_from",
          type: "address",
          indexed: !0
        }, {
          name: "_value",
          type: "uint256",
          indexed: !1
        }, {
          name: "_data",
          type: "bytes",
          indexed: !1
        }],
        name: "Redeemed",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "from",
          type: "address",
          indexed: !0
        }, {
          name: "to",
          type: "address",
          indexed: !0
        }, {
          name: "value",
          type: "uint256",
          indexed: !1
        }],
        name: "Transfer",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "owner",
          type: "address",
          indexed: !0
        }, {
          name: "spender",
          type: "address",
          indexed: !0
        }, {
          name: "value",
          type: "uint256",
          indexed: !1
        }],
        name: "Approval",
        outputs: [],
        type: "event"
      }, {
        constant: !1,
        inputs: [{
          name: "_getterDelegate",
          type: "address"
        }],
        name: "initialize",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_module",
          type: "address"
        }, {
          name: "_type",
          type: "uint8"
        }],
        name: "isModule",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_moduleFactory",
          type: "address"
        }, {
          name: "_data",
          type: "bytes"
        }, {
          name: "_maxCost",
          type: "uint256"
        }, {
          name: "_budget",
          type: "uint256"
        }, {
          name: "_label",
          type: "bytes32"
        }, {
          name: "_archived",
          type: "bool"
        }],
        name: "addModuleWithLabel",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_moduleFactory",
          type: "address"
        }, {
          name: "_data",
          type: "bytes"
        }, {
          name: "_maxCost",
          type: "uint256"
        }, {
          name: "_budget",
          type: "uint256"
        }, {
          name: "_archived",
          type: "bool"
        }],
        name: "addModule",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_module",
          type: "address"
        }],
        name: "archiveModule",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_module",
          type: "address"
        }],
        name: "upgradeModule",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "upgradeToken",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_module",
          type: "address"
        }],
        name: "unarchiveModule",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_module",
          type: "address"
        }],
        name: "removeModule",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenContract",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }],
        name: "withdrawERC20",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_module",
          type: "address"
        }, {
          name: "_change",
          type: "uint256"
        }, {
          name: "_increase",
          type: "bool"
        }],
        name: "changeModuleBudget",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_newTokenDetails",
          type: "string"
        }],
        name: "updateTokenDetails",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_granularity",
          type: "uint256"
        }],
        name: "changeGranularity",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_dataStore",
          type: "address"
        }],
        name: "changeDataStore",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_name",
          type: "string"
        }],
        name: "changeName",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_wallet",
          type: "address"
        }],
        name: "changeTreasuryWallet",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "freezeTransfers",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "unfreezeTransfers",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_to",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }],
        name: "transfer",
        outputs: [{
          name: "success",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_to",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }],
        name: "transferWithData",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "_to",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }],
        name: "transferFrom",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "_to",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }],
        name: "transferFromWithData",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_partition",
          type: "bytes32"
        }, {
          name: "_tokenHolder",
          type: "address"
        }],
        name: "balanceOfByPartition",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_partition",
          type: "bytes32"
        }, {
          name: "_to",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }],
        name: "transferByPartition",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_operator",
          type: "address"
        }],
        name: "authorizeOperator",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_operator",
          type: "address"
        }],
        name: "revokeOperator",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_partition",
          type: "bytes32"
        }, {
          name: "_operator",
          type: "address"
        }],
        name: "authorizeOperatorByPartition",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_partition",
          type: "bytes32"
        }, {
          name: "_operator",
          type: "address"
        }],
        name: "revokeOperatorByPartition",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_partition",
          type: "bytes32"
        }, {
          name: "_from",
          type: "address"
        }, {
          name: "_to",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }, {
          name: "_operatorData",
          type: "bytes"
        }],
        name: "operatorTransferByPartition",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_signature",
          type: "bytes"
        }],
        name: "freezeIssuance",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenHolder",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }],
        name: "issue",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenHolders",
          type: "address[]"
        }, {
          name: "_values",
          type: "uint256[]"
        }],
        name: "issueMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_partition",
          type: "bytes32"
        }, {
          name: "_tokenHolder",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }],
        name: "issueByPartition",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_value",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }],
        name: "redeem",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_partition",
          type: "bytes32"
        }, {
          name: "_value",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }],
        name: "redeemByPartition",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_partition",
          type: "bytes32"
        }, {
          name: "_tokenHolder",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }, {
          name: "_operatorData",
          type: "bytes"
        }],
        name: "operatorRedeemByPartition",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenHolder",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }],
        name: "redeemFrom",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "createCheckpoint",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_controller",
          type: "address"
        }],
        name: "setController",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_signature",
          type: "bytes"
        }],
        name: "disableController",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_to",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }],
        name: "canTransfer",
        outputs: [{
          name: "",
          type: "bytes1"
        }, {
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "_to",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }],
        name: "canTransferFrom",
        outputs: [{
          name: "reasonCode",
          type: "bytes1"
        }, {
          name: "appCode",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "_to",
          type: "address"
        }, {
          name: "_partition",
          type: "bytes32"
        }, {
          name: "_value",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }],
        name: "canTransferByPartition",
        outputs: [{
          name: "reasonCode",
          type: "bytes1"
        }, {
          name: "appStatusCode",
          type: "bytes32"
        }, {
          name: "toPartition",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_name",
          type: "bytes32"
        }, {
          name: "_uri",
          type: "string"
        }, {
          name: "_documentHash",
          type: "bytes32"
        }],
        name: "setDocument",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_name",
          type: "bytes32"
        }],
        name: "removeDocument",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "isControllable",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "_to",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }, {
          name: "_operatorData",
          type: "bytes"
        }],
        name: "controllerTransfer",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenHolder",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }, {
          name: "_operatorData",
          type: "bytes"
        }],
        name: "controllerRedeem",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "updateFromRegistry",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "owner",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "isOwner",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "newOwner",
          type: "address"
        }],
        name: "transferOwnership",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(u.BaseContract);

  t.SecurityTokenContract_3_0_0 = y, t.isSecurityTokenContract_3_0_0 = function (e) {
    return b.isEqual(y.ABI(), e.abi);
  };
},
/*!*********************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/i_security_token.js ***!
  \*********************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r84,
      n = this && this.__extends || (_r84 = function r(e, t) {
    return (_r84 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r84(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var c,
      u = a(
  /*! @0x/base-contract */
  12),
      d = a(
  /*! @0x/json-schemas */
  2),
      f = a(
  /*! @0x/utils */
  8),
      l = a(
  /*! @0x/web3-wrapper */
  11),
      h = a(
  /*! @0x/assert */
  10),
      p = a(
  /*! ../../PolyResponse */
  14),
      b = a(
  /*! lodash */
  0),
      m = a(
  /*! ethers */
  13);
  (c = t.ISecurityTokenEvents_3_0_0 || (t.ISecurityTokenEvents_3_0_0 = {})).Transfer = "Transfer", c.Approval = "Approval", c.ModuleAdded = "ModuleAdded", c.UpdateTokenDetails = "UpdateTokenDetails", c.UpdateTokenName = "UpdateTokenName", c.GranularityChanged = "GranularityChanged", c.FreezeIssuance = "FreezeIssuance", c.FreezeTransfers = "FreezeTransfers", c.CheckpointCreated = "CheckpointCreated", c.SetController = "SetController", c.TreasuryWalletChanged = "TreasuryWalletChanged", c.DisableController = "DisableController", c.OwnershipTransferred = "OwnershipTransferred", c.TokenUpgraded = "TokenUpgraded", c.ModuleArchived = "ModuleArchived", c.ModuleUnarchived = "ModuleUnarchived", c.ModuleRemoved = "ModuleRemoved", c.ModuleBudgetChanged = "ModuleBudgetChanged", c.TransferByPartition = "TransferByPartition", c.AuthorizedOperator = "AuthorizedOperator", c.RevokedOperator = "RevokedOperator", c.AuthorizedOperatorByPartition = "AuthorizedOperatorByPartition", c.RevokedOperatorByPartition = "RevokedOperatorByPartition", c.IssuedByPartition = "IssuedByPartition", c.RedeemedByPartition = "RedeemedByPartition", c.DocumentRemoved = "DocumentRemoved", c.DocumentUpdated = "DocumentUpdated", c.ControllerTransfer = "ControllerTransfer", c.ControllerRedemption = "ControllerRedemption", c.Issued = "Issued", c.Redeemed = "Redeemed";

  var y = function (e) {
    function t(a, r, n, c) {
      var l = e.call(this, "ISecurityToken", t.ABI(), a, r, n) || this;
      return l.symbol = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("symbol()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("symbol()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("symbol()", []);
        }
      }, l.name = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("name()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("name()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("name()", []);
        }
      }, l.decimals = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("decimals()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("decimals()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("decimals()", []);
        }
      }, l.totalSupply = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("totalSupply()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("totalSupply()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("totalSupply()", []);
        }
      }, l.balanceOf = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("owner", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("balanceOf(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("balanceOf(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("owner", e), this._strictEncodeArguments("balanceOf(address)", [e]);
        }
      }, l.allowance = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("owner", e), h.assert.isString("spender", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("allowance(address,address)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("allowance(address,address)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("owner", e), h.assert.isString("spender", t), this._strictEncodeArguments("allowance(address,address)", [e, t]);
        }
      }, l.transfer = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("to", e), h.assert.isBigNumber("value", t), o = (n = this)._strictEncodeArguments("transfer(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: d
                  }, c), n.transfer.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), b = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new p.PolyResponse(l, b)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("to", e), h.assert.isBigNumber("value", t), o = (n = this)._strictEncodeArguments("transfer(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: d
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return p = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, p < m ? p : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("to", e), h.assert.isBigNumber("value", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("transfer(address,uint256)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("transfer(address,uint256)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("to", e), h.assert.isBigNumber("value", t), this._strictEncodeArguments("transfer(address,uint256)", [e, t]);
        }
      }, l.transferFrom = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("from", e), h.assert.isString("to", t), h.assert.isBigNumber("value", a), c = (o = this)._strictEncodeArguments("transferFrom(address,address,uint256)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, d), o.transferFrom.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return b = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(b), [2, new p.PolyResponse(b, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, p, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("from", e), h.assert.isString("to", t), h.assert.isBigNumber("value", a), c = (o = this)._strictEncodeArguments("transferFrom(address,address,uint256)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, d))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return p = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * p), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("from", e), h.assert.isString("to", t), h.assert.isBigNumber("value", a), h.assert.doesConformToSchema("callData", r, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== n && h.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("transferFrom(address,address,uint256)", [e, t, a]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (f = i.sent()).from = f.from ? f.from.toLowerCase() : f.from, [4, o._web3Wrapper.callAsync(f, n)];

                case 2:
                  return l = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("transferFrom(address,address,uint256)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return h.assert.isString("from", e), h.assert.isString("to", t), h.assert.isBigNumber("value", a), this._strictEncodeArguments("transferFrom(address,address,uint256)", [e, t, a]);
        }
      }, l.approve = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("spender", e), h.assert.isBigNumber("value", t), o = (n = this)._strictEncodeArguments("approve(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: d
                  }, c), n.approve.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), b = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new p.PolyResponse(l, b)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("spender", e), h.assert.isBigNumber("value", t), o = (n = this)._strictEncodeArguments("approve(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: d
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return p = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, p < m ? p : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("spender", e), h.assert.isBigNumber("value", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("approve(address,uint256)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("approve(address,uint256)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("spender", e), h.assert.isBigNumber("value", t), this._strictEncodeArguments("approve(address,uint256)", [e, t]);
        }
      }, l.decreaseAllowance = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("spender", e), h.assert.isBigNumber("subtractedValue", t), o = (n = this)._strictEncodeArguments("decreaseAllowance(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: d
                  }, c), n.decreaseAllowance.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), b = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new p.PolyResponse(l, b)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("spender", e), h.assert.isBigNumber("subtractedValue", t), o = (n = this)._strictEncodeArguments("decreaseAllowance(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: d
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return p = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, p < m ? p : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("spender", e), h.assert.isBigNumber("subtractedValue", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("decreaseAllowance(address,uint256)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("decreaseAllowance(address,uint256)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("spender", e), h.assert.isBigNumber("subtractedValue", t), this._strictEncodeArguments("decreaseAllowance(address,uint256)", [e, t]);
        }
      }, l.increaseAllowance = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("spender", e), h.assert.isBigNumber("addedValue", t), o = (n = this)._strictEncodeArguments("increaseAllowance(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: d
                  }, c), n.increaseAllowance.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), b = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new p.PolyResponse(l, b)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("spender", e), h.assert.isBigNumber("addedValue", t), o = (n = this)._strictEncodeArguments("increaseAllowance(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: d
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return p = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, p < m ? p : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("spender", e), h.assert.isBigNumber("addedValue", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("increaseAllowance(address,uint256)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("increaseAllowance(address,uint256)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("spender", e), h.assert.isBigNumber("addedValue", t), this._strictEncodeArguments("increaseAllowance(address,uint256)", [e, t]);
        }
      }, l.canTransfer = {
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_to", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), h.assert.doesConformToSchema("callData", r, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== n && h.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("canTransfer(address,uint256,bytes)", [e, t, a]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (f = i.sent()).from = f.from ? f.from.toLowerCase() : f.from, [4, o._web3Wrapper.callAsync(f, n)];

                case 2:
                  return l = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("canTransfer(address,uint256,bytes)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return h.assert.isString("_to", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), this._strictEncodeArguments("canTransfer(address,uint256,bytes)", [e, t, a]);
        }
      }, l.initialize = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_getterDelegate", e), n = (r = this)._strictEncodeArguments("initialize(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.initialize.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_getterDelegate", e), n = (r = this)._strictEncodeArguments("initialize(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_getterDelegate", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("initialize(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("initialize(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_getterDelegate", e), this._strictEncodeArguments("initialize(address)", [e]);
        }
      }, l.canTransferByPartition = {
        callAsync: function callAsync(e, t, a, r, n, c, f) {
          return void 0 === c && (c = {}), o(this, void 0, void 0, function () {
            var o, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_from", e), h.assert.isString("_to", t), h.assert.isString("_partition", a), h.assert.isBigNumber("_value", r), h.assert.isString("_data", n), h.assert.doesConformToSchema("callData", c, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== f && h.assert.isBlockParam("defaultBlock", f), l = (o = this)._strictEncodeArguments("canTransferByPartition(address,address,bytes32,uint256,bytes)", [e, t, a, r, n]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: l
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (p = i.sent()).from = p.from ? p.from.toLowerCase() : p.from, [4, o._web3Wrapper.callAsync(p, f)];

                case 2:
                  return b = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(b), [2, o._lookupAbiEncoder("canTransferByPartition(address,address,bytes32,uint256,bytes)").strictDecodeReturnValue(b)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n) {
          return h.assert.isString("_from", e), h.assert.isString("_to", t), h.assert.isString("_partition", a), h.assert.isBigNumber("_value", r), h.assert.isString("_data", n), this._strictEncodeArguments("canTransferByPartition(address,address,bytes32,uint256,bytes)", [e, t, a, r, n]);
        }
      }, l.canTransferFrom = {
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, f, l, p;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_from", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), h.assert.doesConformToSchema("callData", n, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== c && h.assert.isBlockParam("defaultBlock", c), f = (o = this)._strictEncodeArguments("canTransferFrom(address,address,uint256,bytes)", [e, t, a, r]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: f
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return p = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(p), [2, o._lookupAbiEncoder("canTransferFrom(address,address,uint256,bytes)").strictDecodeReturnValue(p)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return h.assert.isString("_from", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), this._strictEncodeArguments("canTransferFrom(address,address,uint256,bytes)", [e, t, a, r]);
        }
      }, l.setDocument = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_name", e), h.assert.isString("_uri", t), h.assert.isString("_documentHash", a), c = (o = this)._strictEncodeArguments("setDocument(bytes32,string,bytes32)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, d), o.setDocument.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return b = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(b), [2, new p.PolyResponse(b, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, p, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_name", e), h.assert.isString("_uri", t), h.assert.isString("_documentHash", a), c = (o = this)._strictEncodeArguments("setDocument(bytes32,string,bytes32)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, d))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return p = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * p), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_name", e), h.assert.isString("_uri", t), h.assert.isString("_documentHash", a), h.assert.doesConformToSchema("callData", r, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== n && h.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("setDocument(bytes32,string,bytes32)", [e, t, a]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (f = i.sent()).from = f.from ? f.from.toLowerCase() : f.from, [4, o._web3Wrapper.callAsync(f, n)];

                case 2:
                  return l = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("setDocument(bytes32,string,bytes32)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return h.assert.isString("_name", e), h.assert.isString("_uri", t), h.assert.isString("_documentHash", a), this._strictEncodeArguments("setDocument(bytes32,string,bytes32)", [e, t, a]);
        }
      }, l.removeDocument = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_name", e), n = (r = this)._strictEncodeArguments("removeDocument(bytes32)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.removeDocument.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_name", e), n = (r = this)._strictEncodeArguments("removeDocument(bytes32)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_name", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("removeDocument(bytes32)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("removeDocument(bytes32)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_name", e), this._strictEncodeArguments("removeDocument(bytes32)", [e]);
        }
      }, l.getDocument = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_name", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getDocument(bytes32)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getDocument(bytes32)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_name", e), this._strictEncodeArguments("getDocument(bytes32)", [e]);
        }
      }, l.getAllDocuments = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getAllDocuments()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getAllDocuments()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getAllDocuments()", []);
        }
      }, l.isControllable = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("isControllable()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("isControllable()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("isControllable()", []);
        }
      }, l.isModule = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_module", e), h.assert.isNumberOrBigNumber("_type", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("isModule(address,uint8)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("isModule(address,uint8)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("_module", e), h.assert.isNumberOrBigNumber("_type", t), this._strictEncodeArguments("isModule(address,uint8)", [e, t]);
        }
      }, l.issue = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenHolder", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), c = (o = this)._strictEncodeArguments("issue(address,uint256,bytes)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, d), o.issue.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return b = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(b), [2, new p.PolyResponse(b, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, p, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenHolder", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), c = (o = this)._strictEncodeArguments("issue(address,uint256,bytes)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, d))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return p = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * p), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenHolder", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), h.assert.doesConformToSchema("callData", r, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== n && h.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("issue(address,uint256,bytes)", [e, t, a]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (f = i.sent()).from = f.from ? f.from.toLowerCase() : f.from, [4, o._web3Wrapper.callAsync(f, n)];

                case 2:
                  return l = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("issue(address,uint256,bytes)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return h.assert.isString("_tokenHolder", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), this._strictEncodeArguments("issue(address,uint256,bytes)", [e, t, a]);
        }
      }, l.issueMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isArray("_tokenHolders", e), h.assert.isArray("_values", t), o = (n = this)._strictEncodeArguments("issueMulti(address[],uint256[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: d
                  }, c), n.issueMulti.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), b = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new p.PolyResponse(l, b)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isArray("_tokenHolders", e), h.assert.isArray("_values", t), o = (n = this)._strictEncodeArguments("issueMulti(address[],uint256[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: d
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return p = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, p < m ? p : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isArray("_tokenHolders", e), h.assert.isArray("_values", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("issueMulti(address[],uint256[])", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("issueMulti(address[],uint256[])").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isArray("_tokenHolders", e), h.assert.isArray("_values", t), this._strictEncodeArguments("issueMulti(address[],uint256[])", [e, t]);
        }
      }, l.issueByPartition = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, d, f, l, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_tokenHolder", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), d = (o = this)._strictEncodeArguments("issueByPartition(bytes32,address,uint256,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: d
                  }), s({
                    from: l
                  }, f), o.issueByPartition.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(b)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new p.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, d, f, l, p, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_tokenHolder", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), d = (o = this)._strictEncodeArguments("issueByPartition(bytes32,address,uint256,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: d
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (p = i.sent()).from && (p.from = p.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(p)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, f, l, p;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_tokenHolder", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), h.assert.doesConformToSchema("callData", n, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== c && h.assert.isBlockParam("defaultBlock", c), f = (o = this)._strictEncodeArguments("issueByPartition(bytes32,address,uint256,bytes)", [e, t, a, r]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: f
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return p = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(p), [2, o._lookupAbiEncoder("issueByPartition(bytes32,address,uint256,bytes)").strictDecodeReturnValue(p)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return h.assert.isString("_partition", e), h.assert.isString("_tokenHolder", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), this._strictEncodeArguments("issueByPartition(bytes32,address,uint256,bytes)", [e, t, a, r]);
        }
      }, l.redeemByPartition = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), c = (o = this)._strictEncodeArguments("redeemByPartition(bytes32,uint256,bytes)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, d), o.redeemByPartition.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return b = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(b), [2, new p.PolyResponse(b, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, p, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), c = (o = this)._strictEncodeArguments("redeemByPartition(bytes32,uint256,bytes)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, d))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return p = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * p), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), h.assert.doesConformToSchema("callData", r, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== n && h.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("redeemByPartition(bytes32,uint256,bytes)", [e, t, a]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (f = i.sent()).from = f.from ? f.from.toLowerCase() : f.from, [4, o._web3Wrapper.callAsync(f, n)];

                case 2:
                  return l = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("redeemByPartition(bytes32,uint256,bytes)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return h.assert.isString("_partition", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), this._strictEncodeArguments("redeemByPartition(bytes32,uint256,bytes)", [e, t, a]);
        }
      }, l.redeem = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_value", e), h.assert.isString("_data", t), o = (n = this)._strictEncodeArguments("redeem(uint256,bytes)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: d
                  }, c), n.redeem.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), b = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new p.PolyResponse(l, b)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_value", e), h.assert.isString("_data", t), o = (n = this)._strictEncodeArguments("redeem(uint256,bytes)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: d
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return p = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, p < m ? p : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_value", e), h.assert.isString("_data", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("redeem(uint256,bytes)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("redeem(uint256,bytes)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isBigNumber("_value", e), h.assert.isString("_data", t), this._strictEncodeArguments("redeem(uint256,bytes)", [e, t]);
        }
      }, l.redeemFrom = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenHolder", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), c = (o = this)._strictEncodeArguments("redeemFrom(address,uint256,bytes)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, d), o.redeemFrom.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return b = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(b), [2, new p.PolyResponse(b, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, p, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenHolder", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), c = (o = this)._strictEncodeArguments("redeemFrom(address,uint256,bytes)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, d))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return p = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * p), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenHolder", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), h.assert.doesConformToSchema("callData", r, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== n && h.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("redeemFrom(address,uint256,bytes)", [e, t, a]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (f = i.sent()).from = f.from ? f.from.toLowerCase() : f.from, [4, o._web3Wrapper.callAsync(f, n)];

                case 2:
                  return l = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("redeemFrom(address,uint256,bytes)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return h.assert.isString("_tokenHolder", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), this._strictEncodeArguments("redeemFrom(address,uint256,bytes)", [e, t, a]);
        }
      }, l.operatorRedeemByPartition = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, d) {
          return o(this, void 0, void 0, function () {
            var o, f, l, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_tokenHolder", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), h.assert.isString("_operatorData", n), f = (o = this)._strictEncodeArguments("operatorRedeemByPartition(bytes32,address,uint256,bytes,bytes)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return b = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: f
                  }), s({
                    from: b
                  }, l), o.operatorRedeemByPartition.estimateGasAsync.bind(o, e, t, a, r, n, d))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(m)];

                case 3:
                  return y = i.sent(), v = o._web3Wrapper.awaitTransactionSuccessAsync(y), [2, new p.PolyResponse(y, v)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, d) {
          return o(this, void 0, void 0, function () {
            var o, f, l, p, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_tokenHolder", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), h.assert.isString("_operatorData", n), f = (o = this)._strictEncodeArguments("operatorRedeemByPartition(bytes32,address,uint256,bytes,bytes)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return p = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, d, {
                    data: f
                  }), s({
                    from: p
                  }, l))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(b)];

                case 3:
                  return m = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return y = i.sent().gasLimit, v = void 0 === c ? o._defaultEstimateGasFactor : c, _ = Math.round(v * m), [2, y < _ ? y : _];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, f) {
          return void 0 === c && (c = {}), o(this, void 0, void 0, function () {
            var o, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_tokenHolder", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), h.assert.isString("_operatorData", n), h.assert.doesConformToSchema("callData", c, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== f && h.assert.isBlockParam("defaultBlock", f), l = (o = this)._strictEncodeArguments("operatorRedeemByPartition(bytes32,address,uint256,bytes,bytes)", [e, t, a, r, n]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: l
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (p = i.sent()).from = p.from ? p.from.toLowerCase() : p.from, [4, o._web3Wrapper.callAsync(p, f)];

                case 2:
                  return b = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(b), [2, o._lookupAbiEncoder("operatorRedeemByPartition(bytes32,address,uint256,bytes,bytes)").strictDecodeReturnValue(b)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n) {
          return h.assert.isString("_partition", e), h.assert.isString("_tokenHolder", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), h.assert.isString("_operatorData", n), this._strictEncodeArguments("operatorRedeemByPartition(bytes32,address,uint256,bytes,bytes)", [e, t, a, r, n]);
        }
      }, l.checkPermission = {
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_delegate", e), h.assert.isString("_module", t), h.assert.isString("_perm", a), h.assert.doesConformToSchema("callData", r, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== n && h.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("checkPermission(address,address,bytes32)", [e, t, a]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (f = i.sent()).from = f.from ? f.from.toLowerCase() : f.from, [4, o._web3Wrapper.callAsync(f, n)];

                case 2:
                  return l = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("checkPermission(address,address,bytes32)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return h.assert.isString("_delegate", e), h.assert.isString("_module", t), h.assert.isString("_perm", a), this._strictEncodeArguments("checkPermission(address,address,bytes32)", [e, t, a]);
        }
      }, l.getModule = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_module", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getModule(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getModule(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_module", e), this._strictEncodeArguments("getModule(address)", [e]);
        }
      }, l.getModulesByName = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_name", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getModulesByName(bytes32)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getModulesByName(bytes32)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_name", e), this._strictEncodeArguments("getModulesByName(bytes32)", [e]);
        }
      }, l.getModulesByType = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isNumberOrBigNumber("_type", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getModulesByType(uint8)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getModulesByType(uint8)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isNumberOrBigNumber("_type", e), this._strictEncodeArguments("getModulesByType(uint8)", [e]);
        }
      }, l.getTreasuryWallet = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getTreasuryWallet()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getTreasuryWallet()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getTreasuryWallet()", []);
        }
      }, l.totalSupplyAt = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_checkpointId", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("totalSupplyAt(uint256)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("totalSupplyAt(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isBigNumber("_checkpointId", e), this._strictEncodeArguments("totalSupplyAt(uint256)", [e]);
        }
      }, l.balanceOfAt = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_investor", e), h.assert.isBigNumber("_checkpointId", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("balanceOfAt(address,uint256)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("balanceOfAt(address,uint256)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("_investor", e), h.assert.isBigNumber("_checkpointId", t), this._strictEncodeArguments("balanceOfAt(address,uint256)", [e, t]);
        }
      }, l.createCheckpoint = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("createCheckpoint()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.createCheckpoint.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return d = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(d), [2, new p.PolyResponse(d, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("createCheckpoint()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return d = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * d), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("createCheckpoint()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("createCheckpoint()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("createCheckpoint()", []);
        }
      }, l.getCheckpointTimes = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getCheckpointTimes()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getCheckpointTimes()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getCheckpointTimes()", []);
        }
      }, l.getInvestors = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getInvestors()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getInvestors()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getInvestors()", []);
        }
      }, l.getInvestorsAt = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_checkpointId", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getInvestorsAt(uint256)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getInvestorsAt(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isBigNumber("_checkpointId", e), this._strictEncodeArguments("getInvestorsAt(uint256)", [e]);
        }
      }, l.getInvestorsSubsetAt = {
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_checkpointId", e), h.assert.isBigNumber("_start", t), h.assert.isBigNumber("_end", a), h.assert.doesConformToSchema("callData", r, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== n && h.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("getInvestorsSubsetAt(uint256,uint256,uint256)", [e, t, a]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (f = i.sent()).from = f.from ? f.from.toLowerCase() : f.from, [4, o._web3Wrapper.callAsync(f, n)];

                case 2:
                  return l = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("getInvestorsSubsetAt(uint256,uint256,uint256)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return h.assert.isBigNumber("_checkpointId", e), h.assert.isBigNumber("_start", t), h.assert.isBigNumber("_end", a), this._strictEncodeArguments("getInvestorsSubsetAt(uint256,uint256,uint256)", [e, t, a]);
        }
      }, l.iterateInvestors = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_start", e), h.assert.isBigNumber("_end", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("iterateInvestors(uint256,uint256)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("iterateInvestors(uint256,uint256)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isBigNumber("_start", e), h.assert.isBigNumber("_end", t), this._strictEncodeArguments("iterateInvestors(uint256,uint256)", [e, t]);
        }
      }, l.currentCheckpointId = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("currentCheckpointId()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("currentCheckpointId()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("currentCheckpointId()", []);
        }
      }, l.isOperator = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_operator", e), h.assert.isString("_tokenHolder", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("isOperator(address,address)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("isOperator(address,address)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("_operator", e), h.assert.isString("_tokenHolder", t), this._strictEncodeArguments("isOperator(address,address)", [e, t]);
        }
      }, l.isOperatorForPartition = {
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_operator", t), h.assert.isString("_tokenHolder", a), h.assert.doesConformToSchema("callData", r, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== n && h.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("isOperatorForPartition(bytes32,address,address)", [e, t, a]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (f = i.sent()).from = f.from ? f.from.toLowerCase() : f.from, [4, o._web3Wrapper.callAsync(f, n)];

                case 2:
                  return l = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("isOperatorForPartition(bytes32,address,address)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return h.assert.isString("_partition", e), h.assert.isString("_operator", t), h.assert.isString("_tokenHolder", a), this._strictEncodeArguments("isOperatorForPartition(bytes32,address,address)", [e, t, a]);
        }
      }, l.partitionsOf = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenHolder", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("partitionsOf(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("partitionsOf(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_tokenHolder", e), this._strictEncodeArguments("partitionsOf(address)", [e]);
        }
      }, l.dataStore = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("dataStore()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("dataStore()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("dataStore()", []);
        }
      }, l.changeDataStore = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_dataStore", e), n = (r = this)._strictEncodeArguments("changeDataStore(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeDataStore.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_dataStore", e), n = (r = this)._strictEncodeArguments("changeDataStore(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_dataStore", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeDataStore(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeDataStore(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_dataStore", e), this._strictEncodeArguments("changeDataStore(address)", [e]);
        }
      }, l.changeTreasuryWallet = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_wallet", e), n = (r = this)._strictEncodeArguments("changeTreasuryWallet(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeTreasuryWallet.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_wallet", e), n = (r = this)._strictEncodeArguments("changeTreasuryWallet(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_wallet", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeTreasuryWallet(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeTreasuryWallet(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_wallet", e), this._strictEncodeArguments("changeTreasuryWallet(address)", [e]);
        }
      }, l.withdrawERC20 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenContract", e), h.assert.isBigNumber("_value", t), o = (n = this)._strictEncodeArguments("withdrawERC20(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: d
                  }, c), n.withdrawERC20.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), b = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new p.PolyResponse(l, b)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenContract", e), h.assert.isBigNumber("_value", t), o = (n = this)._strictEncodeArguments("withdrawERC20(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: d
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return p = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, p < m ? p : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenContract", e), h.assert.isBigNumber("_value", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("withdrawERC20(address,uint256)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("withdrawERC20(address,uint256)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("_tokenContract", e), h.assert.isBigNumber("_value", t), this._strictEncodeArguments("withdrawERC20(address,uint256)", [e, t]);
        }
      }, l.changeModuleBudget = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_module", e), h.assert.isBigNumber("_change", t), h.assert.isBoolean("_increase", a), c = (o = this)._strictEncodeArguments("changeModuleBudget(address,uint256,bool)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, d), o.changeModuleBudget.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return b = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(b), [2, new p.PolyResponse(b, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, p, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_module", e), h.assert.isBigNumber("_change", t), h.assert.isBoolean("_increase", a), c = (o = this)._strictEncodeArguments("changeModuleBudget(address,uint256,bool)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, d))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return p = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * p), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_module", e), h.assert.isBigNumber("_change", t), h.assert.isBoolean("_increase", a), h.assert.doesConformToSchema("callData", r, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== n && h.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("changeModuleBudget(address,uint256,bool)", [e, t, a]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (f = i.sent()).from = f.from ? f.from.toLowerCase() : f.from, [4, o._web3Wrapper.callAsync(f, n)];

                case 2:
                  return l = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("changeModuleBudget(address,uint256,bool)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return h.assert.isString("_module", e), h.assert.isBigNumber("_change", t), h.assert.isBoolean("_increase", a), this._strictEncodeArguments("changeModuleBudget(address,uint256,bool)", [e, t, a]);
        }
      }, l.updateTokenDetails = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_newTokenDetails", e), n = (r = this)._strictEncodeArguments("updateTokenDetails(string)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.updateTokenDetails.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_newTokenDetails", e), n = (r = this)._strictEncodeArguments("updateTokenDetails(string)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_newTokenDetails", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("updateTokenDetails(string)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("updateTokenDetails(string)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_newTokenDetails", e), this._strictEncodeArguments("updateTokenDetails(string)", [e]);
        }
      }, l.changeName = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_name", e), n = (r = this)._strictEncodeArguments("changeName(string)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeName.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_name", e), n = (r = this)._strictEncodeArguments("changeName(string)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_name", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeName(string)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeName(string)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_name", e), this._strictEncodeArguments("changeName(string)", [e]);
        }
      }, l.changeGranularity = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_granularity", e), n = (r = this)._strictEncodeArguments("changeGranularity(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeGranularity.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_granularity", e), n = (r = this)._strictEncodeArguments("changeGranularity(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_granularity", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeGranularity(uint256)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeGranularity(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isBigNumber("_granularity", e), this._strictEncodeArguments("changeGranularity(uint256)", [e]);
        }
      }, l.freezeTransfers = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("freezeTransfers()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.freezeTransfers.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return d = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(d), [2, new p.PolyResponse(d, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("freezeTransfers()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return d = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * d), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("freezeTransfers()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("freezeTransfers()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("freezeTransfers()", []);
        }
      }, l.unfreezeTransfers = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unfreezeTransfers()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.unfreezeTransfers.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return d = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(d), [2, new p.PolyResponse(d, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unfreezeTransfers()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return d = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * d), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("unfreezeTransfers()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("unfreezeTransfers()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("unfreezeTransfers()", []);
        }
      }, l.freezeIssuance = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_signature", e), n = (r = this)._strictEncodeArguments("freezeIssuance(bytes)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.freezeIssuance.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_signature", e), n = (r = this)._strictEncodeArguments("freezeIssuance(bytes)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_signature", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("freezeIssuance(bytes)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("freezeIssuance(bytes)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_signature", e), this._strictEncodeArguments("freezeIssuance(bytes)", [e]);
        }
      }, l.addModuleWithLabel = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, d, f) {
          return o(this, void 0, void 0, function () {
            var o, l, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_moduleFactory", e), h.assert.isString("_data", t), h.assert.isBigNumber("_maxCost", a), h.assert.isBigNumber("_budget", r), h.assert.isString("_label", n), h.assert.isBoolean("_archived", c), l = (o = this)._strictEncodeArguments("addModuleWithLabel(address,bytes,uint256,uint256,bytes32,bool)", [e, t, a, r, n, c]), b = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return m = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, d, {
                    data: l
                  }), s({
                    from: m
                  }, b), o.addModuleWithLabel.estimateGasAsync.bind(o, e, t, a, r, n, c, f))];

                case 2:
                  return void 0 !== (y = i.sent()).from && (y.from = y.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(y)];

                case 3:
                  return v = i.sent(), _ = o._web3Wrapper.awaitTransactionSuccessAsync(v), [2, new p.PolyResponse(v, _)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, d, f) {
          return o(this, void 0, void 0, function () {
            var o, l, p, b, m, y, v, _, g;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_moduleFactory", e), h.assert.isString("_data", t), h.assert.isBigNumber("_maxCost", a), h.assert.isBigNumber("_budget", r), h.assert.isString("_label", n), h.assert.isBoolean("_archived", c), l = (o = this)._strictEncodeArguments("addModuleWithLabel(address,bytes,uint256,uint256,bytes32,bool)", [e, t, a, r, n, c]), p = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return b = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, f, {
                    data: l
                  }), s({
                    from: b
                  }, p))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(m)];

                case 3:
                  return y = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return v = i.sent().gasLimit, _ = void 0 === d ? o._defaultEstimateGasFactor : d, g = Math.round(_ * y), [2, v < g ? v : g];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, f, l) {
          return void 0 === f && (f = {}), o(this, void 0, void 0, function () {
            var o, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_moduleFactory", e), h.assert.isString("_data", t), h.assert.isBigNumber("_maxCost", a), h.assert.isBigNumber("_budget", r), h.assert.isString("_label", n), h.assert.isBoolean("_archived", c), h.assert.doesConformToSchema("callData", f, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== l && h.assert.isBlockParam("defaultBlock", l), p = (o = this)._strictEncodeArguments("addModuleWithLabel(address,bytes,uint256,uint256,bytes32,bool)", [e, t, a, r, n, c]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, f, {
                    data: p
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (b = i.sent()).from = b.from ? b.from.toLowerCase() : b.from, [4, o._web3Wrapper.callAsync(b, l)];

                case 2:
                  return m = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(m), [2, o._lookupAbiEncoder("addModuleWithLabel(address,bytes,uint256,uint256,bytes32,bool)").strictDecodeReturnValue(m)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s) {
          return h.assert.isString("_moduleFactory", e), h.assert.isString("_data", t), h.assert.isBigNumber("_maxCost", a), h.assert.isBigNumber("_budget", r), h.assert.isString("_label", n), h.assert.isBoolean("_archived", s), this._strictEncodeArguments("addModuleWithLabel(address,bytes,uint256,uint256,bytes32,bool)", [e, t, a, r, n, s]);
        }
      }, l.addModule = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, d) {
          return o(this, void 0, void 0, function () {
            var o, f, l, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_moduleFactory", e), h.assert.isString("_data", t), h.assert.isBigNumber("_maxCost", a), h.assert.isBigNumber("_budget", r), h.assert.isBoolean("_archived", n), f = (o = this)._strictEncodeArguments("addModule(address,bytes,uint256,uint256,bool)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return b = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: f
                  }), s({
                    from: b
                  }, l), o.addModule.estimateGasAsync.bind(o, e, t, a, r, n, d))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(m)];

                case 3:
                  return y = i.sent(), v = o._web3Wrapper.awaitTransactionSuccessAsync(y), [2, new p.PolyResponse(y, v)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, d) {
          return o(this, void 0, void 0, function () {
            var o, f, l, p, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_moduleFactory", e), h.assert.isString("_data", t), h.assert.isBigNumber("_maxCost", a), h.assert.isBigNumber("_budget", r), h.assert.isBoolean("_archived", n), f = (o = this)._strictEncodeArguments("addModule(address,bytes,uint256,uint256,bool)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return p = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, d, {
                    data: f
                  }), s({
                    from: p
                  }, l))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(b)];

                case 3:
                  return m = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return y = i.sent().gasLimit, v = void 0 === c ? o._defaultEstimateGasFactor : c, _ = Math.round(v * m), [2, y < _ ? y : _];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, f) {
          return void 0 === c && (c = {}), o(this, void 0, void 0, function () {
            var o, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_moduleFactory", e), h.assert.isString("_data", t), h.assert.isBigNumber("_maxCost", a), h.assert.isBigNumber("_budget", r), h.assert.isBoolean("_archived", n), h.assert.doesConformToSchema("callData", c, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== f && h.assert.isBlockParam("defaultBlock", f), l = (o = this)._strictEncodeArguments("addModule(address,bytes,uint256,uint256,bool)", [e, t, a, r, n]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: l
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (p = i.sent()).from = p.from ? p.from.toLowerCase() : p.from, [4, o._web3Wrapper.callAsync(p, f)];

                case 2:
                  return b = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(b), [2, o._lookupAbiEncoder("addModule(address,bytes,uint256,uint256,bool)").strictDecodeReturnValue(b)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n) {
          return h.assert.isString("_moduleFactory", e), h.assert.isString("_data", t), h.assert.isBigNumber("_maxCost", a), h.assert.isBigNumber("_budget", r), h.assert.isBoolean("_archived", n), this._strictEncodeArguments("addModule(address,bytes,uint256,uint256,bool)", [e, t, a, r, n]);
        }
      }, l.archiveModule = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_module", e), n = (r = this)._strictEncodeArguments("archiveModule(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.archiveModule.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_module", e), n = (r = this)._strictEncodeArguments("archiveModule(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_module", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("archiveModule(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("archiveModule(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_module", e), this._strictEncodeArguments("archiveModule(address)", [e]);
        }
      }, l.unarchiveModule = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_module", e), n = (r = this)._strictEncodeArguments("unarchiveModule(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.unarchiveModule.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_module", e), n = (r = this)._strictEncodeArguments("unarchiveModule(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_module", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("unarchiveModule(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("unarchiveModule(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_module", e), this._strictEncodeArguments("unarchiveModule(address)", [e]);
        }
      }, l.removeModule = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_module", e), n = (r = this)._strictEncodeArguments("removeModule(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.removeModule.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_module", e), n = (r = this)._strictEncodeArguments("removeModule(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_module", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("removeModule(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("removeModule(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_module", e), this._strictEncodeArguments("removeModule(address)", [e]);
        }
      }, l.setController = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_controller", e), n = (r = this)._strictEncodeArguments("setController(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.setController.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_controller", e), n = (r = this)._strictEncodeArguments("setController(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_controller", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("setController(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("setController(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_controller", e), this._strictEncodeArguments("setController(address)", [e]);
        }
      }, l.controllerTransfer = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, d) {
          return o(this, void 0, void 0, function () {
            var o, f, l, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_from", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), h.assert.isString("_operatorData", n), f = (o = this)._strictEncodeArguments("controllerTransfer(address,address,uint256,bytes,bytes)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return b = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: f
                  }), s({
                    from: b
                  }, l), o.controllerTransfer.estimateGasAsync.bind(o, e, t, a, r, n, d))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(m)];

                case 3:
                  return y = i.sent(), v = o._web3Wrapper.awaitTransactionSuccessAsync(y), [2, new p.PolyResponse(y, v)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, d) {
          return o(this, void 0, void 0, function () {
            var o, f, l, p, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_from", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), h.assert.isString("_operatorData", n), f = (o = this)._strictEncodeArguments("controllerTransfer(address,address,uint256,bytes,bytes)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return p = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, d, {
                    data: f
                  }), s({
                    from: p
                  }, l))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(b)];

                case 3:
                  return m = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return y = i.sent().gasLimit, v = void 0 === c ? o._defaultEstimateGasFactor : c, _ = Math.round(v * m), [2, y < _ ? y : _];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, f) {
          return void 0 === c && (c = {}), o(this, void 0, void 0, function () {
            var o, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_from", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), h.assert.isString("_operatorData", n), h.assert.doesConformToSchema("callData", c, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== f && h.assert.isBlockParam("defaultBlock", f), l = (o = this)._strictEncodeArguments("controllerTransfer(address,address,uint256,bytes,bytes)", [e, t, a, r, n]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: l
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (p = i.sent()).from = p.from ? p.from.toLowerCase() : p.from, [4, o._web3Wrapper.callAsync(p, f)];

                case 2:
                  return b = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(b), [2, o._lookupAbiEncoder("controllerTransfer(address,address,uint256,bytes,bytes)").strictDecodeReturnValue(b)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n) {
          return h.assert.isString("_from", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), h.assert.isString("_operatorData", n), this._strictEncodeArguments("controllerTransfer(address,address,uint256,bytes,bytes)", [e, t, a, r, n]);
        }
      }, l.controllerRedeem = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, d, f, l, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenHolder", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), h.assert.isString("_operatorData", r), d = (o = this)._strictEncodeArguments("controllerRedeem(address,uint256,bytes,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: d
                  }), s({
                    from: l
                  }, f), o.controllerRedeem.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(b)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new p.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, d, f, l, p, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenHolder", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), h.assert.isString("_operatorData", r), d = (o = this)._strictEncodeArguments("controllerRedeem(address,uint256,bytes,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: d
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (p = i.sent()).from && (p.from = p.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(p)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, f, l, p;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenHolder", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), h.assert.isString("_operatorData", r), h.assert.doesConformToSchema("callData", n, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== c && h.assert.isBlockParam("defaultBlock", c), f = (o = this)._strictEncodeArguments("controllerRedeem(address,uint256,bytes,bytes)", [e, t, a, r]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: f
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return p = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(p), [2, o._lookupAbiEncoder("controllerRedeem(address,uint256,bytes,bytes)").strictDecodeReturnValue(p)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return h.assert.isString("_tokenHolder", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), h.assert.isString("_operatorData", r), this._strictEncodeArguments("controllerRedeem(address,uint256,bytes,bytes)", [e, t, a, r]);
        }
      }, l.disableController = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_signature", e), n = (r = this)._strictEncodeArguments("disableController(bytes)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.disableController.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_signature", e), n = (r = this)._strictEncodeArguments("disableController(bytes)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_signature", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("disableController(bytes)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("disableController(bytes)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_signature", e), this._strictEncodeArguments("disableController(bytes)", [e]);
        }
      }, l.getVersion = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getVersion()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getVersion()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getVersion()", []);
        }
      }, l.getInvestorCount = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getInvestorCount()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getInvestorCount()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getInvestorCount()", []);
        }
      }, l.holderCount = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("holderCount()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("holderCount()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("holderCount()", []);
        }
      }, l.transferWithData = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_to", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), c = (o = this)._strictEncodeArguments("transferWithData(address,uint256,bytes)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, d), o.transferWithData.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return b = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(b), [2, new p.PolyResponse(b, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, p, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_to", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), c = (o = this)._strictEncodeArguments("transferWithData(address,uint256,bytes)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, d))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return p = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * p), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_to", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), h.assert.doesConformToSchema("callData", r, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== n && h.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("transferWithData(address,uint256,bytes)", [e, t, a]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (f = i.sent()).from = f.from ? f.from.toLowerCase() : f.from, [4, o._web3Wrapper.callAsync(f, n)];

                case 2:
                  return l = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("transferWithData(address,uint256,bytes)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return h.assert.isString("_to", e), h.assert.isBigNumber("_value", t), h.assert.isString("_data", a), this._strictEncodeArguments("transferWithData(address,uint256,bytes)", [e, t, a]);
        }
      }, l.transferFromWithData = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, d, f, l, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_from", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), d = (o = this)._strictEncodeArguments("transferFromWithData(address,address,uint256,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: d
                  }), s({
                    from: l
                  }, f), o.transferFromWithData.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(b)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new p.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, d, f, l, p, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_from", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), d = (o = this)._strictEncodeArguments("transferFromWithData(address,address,uint256,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: d
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (p = i.sent()).from && (p.from = p.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(p)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, f, l, p;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_from", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), h.assert.doesConformToSchema("callData", n, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== c && h.assert.isBlockParam("defaultBlock", c), f = (o = this)._strictEncodeArguments("transferFromWithData(address,address,uint256,bytes)", [e, t, a, r]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: f
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return p = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(p), [2, o._lookupAbiEncoder("transferFromWithData(address,address,uint256,bytes)").strictDecodeReturnValue(p)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return h.assert.isString("_from", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), this._strictEncodeArguments("transferFromWithData(address,address,uint256,bytes)", [e, t, a, r]);
        }
      }, l.transferByPartition = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, d, f, l, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), d = (o = this)._strictEncodeArguments("transferByPartition(bytes32,address,uint256,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: d
                  }), s({
                    from: l
                  }, f), o.transferByPartition.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(b)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new p.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, d, f, l, p, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), d = (o = this)._strictEncodeArguments("transferByPartition(bytes32,address,uint256,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: d
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (p = i.sent()).from && (p.from = p.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(p)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, f, l, p;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), h.assert.doesConformToSchema("callData", n, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== c && h.assert.isBlockParam("defaultBlock", c), f = (o = this)._strictEncodeArguments("transferByPartition(bytes32,address,uint256,bytes)", [e, t, a, r]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: f
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return p = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(p), [2, o._lookupAbiEncoder("transferByPartition(bytes32,address,uint256,bytes)").strictDecodeReturnValue(p)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return h.assert.isString("_partition", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), h.assert.isString("_data", r), this._strictEncodeArguments("transferByPartition(bytes32,address,uint256,bytes)", [e, t, a, r]);
        }
      }, l.balanceOfByPartition = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_tokenHolder", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("balanceOfByPartition(bytes32,address)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("balanceOfByPartition(bytes32,address)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("_partition", e), h.assert.isString("_tokenHolder", t), this._strictEncodeArguments("balanceOfByPartition(bytes32,address)", [e, t]);
        }
      }, l.granularity = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("granularity()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("granularity()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("granularity()", []);
        }
      }, l.polymathRegistry = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("polymathRegistry()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("polymathRegistry()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("polymathRegistry()", []);
        }
      }, l.upgradeModule = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_module", e), n = (r = this)._strictEncodeArguments("upgradeModule(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.upgradeModule.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_module", e), n = (r = this)._strictEncodeArguments("upgradeModule(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_module", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("upgradeModule(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("upgradeModule(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_module", e), this._strictEncodeArguments("upgradeModule(address)", [e]);
        }
      }, l.upgradeToken = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("upgradeToken()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.upgradeToken.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return d = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(d), [2, new p.PolyResponse(d, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("upgradeToken()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return d = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * d), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("upgradeToken()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("upgradeToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("upgradeToken()", []);
        }
      }, l.isIssuable = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("isIssuable()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("isIssuable()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("isIssuable()", []);
        }
      }, l.authorizeOperator = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_operator", e), n = (r = this)._strictEncodeArguments("authorizeOperator(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.authorizeOperator.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_operator", e), n = (r = this)._strictEncodeArguments("authorizeOperator(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_operator", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("authorizeOperator(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("authorizeOperator(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_operator", e), this._strictEncodeArguments("authorizeOperator(address)", [e]);
        }
      }, l.revokeOperator = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_operator", e), n = (r = this)._strictEncodeArguments("revokeOperator(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.revokeOperator.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_operator", e), n = (r = this)._strictEncodeArguments("revokeOperator(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_operator", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("revokeOperator(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("revokeOperator(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_operator", e), this._strictEncodeArguments("revokeOperator(address)", [e]);
        }
      }, l.authorizeOperatorByPartition = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_operator", t), o = (n = this)._strictEncodeArguments("authorizeOperatorByPartition(bytes32,address)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: d
                  }, c), n.authorizeOperatorByPartition.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), b = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new p.PolyResponse(l, b)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_operator", t), o = (n = this)._strictEncodeArguments("authorizeOperatorByPartition(bytes32,address)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: d
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return p = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, p < m ? p : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_operator", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("authorizeOperatorByPartition(bytes32,address)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("authorizeOperatorByPartition(bytes32,address)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("_partition", e), h.assert.isString("_operator", t), this._strictEncodeArguments("authorizeOperatorByPartition(bytes32,address)", [e, t]);
        }
      }, l.revokeOperatorByPartition = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_operator", t), o = (n = this)._strictEncodeArguments("revokeOperatorByPartition(bytes32,address)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: d
                  }, c), n.revokeOperatorByPartition.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), b = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new p.PolyResponse(l, b)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_operator", t), o = (n = this)._strictEncodeArguments("revokeOperatorByPartition(bytes32,address)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: d
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return p = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, p < m ? p : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_operator", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("revokeOperatorByPartition(bytes32,address)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("revokeOperatorByPartition(bytes32,address)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("_partition", e), h.assert.isString("_operator", t), this._strictEncodeArguments("revokeOperatorByPartition(bytes32,address)", [e, t]);
        }
      }, l.operatorTransferByPartition = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, d, f) {
          return o(this, void 0, void 0, function () {
            var o, l, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_from", t), h.assert.isString("_to", a), h.assert.isBigNumber("_value", r), h.assert.isString("_data", n), h.assert.isString("_operatorData", c), l = (o = this)._strictEncodeArguments("operatorTransferByPartition(bytes32,address,address,uint256,bytes,bytes)", [e, t, a, r, n, c]), b = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return m = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, d, {
                    data: l
                  }), s({
                    from: m
                  }, b), o.operatorTransferByPartition.estimateGasAsync.bind(o, e, t, a, r, n, c, f))];

                case 2:
                  return void 0 !== (y = i.sent()).from && (y.from = y.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(y)];

                case 3:
                  return v = i.sent(), _ = o._web3Wrapper.awaitTransactionSuccessAsync(v), [2, new p.PolyResponse(v, _)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, d, f) {
          return o(this, void 0, void 0, function () {
            var o, l, p, b, m, y, v, _, g;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_from", t), h.assert.isString("_to", a), h.assert.isBigNumber("_value", r), h.assert.isString("_data", n), h.assert.isString("_operatorData", c), l = (o = this)._strictEncodeArguments("operatorTransferByPartition(bytes32,address,address,uint256,bytes,bytes)", [e, t, a, r, n, c]), p = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return b = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, f, {
                    data: l
                  }), s({
                    from: b
                  }, p))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(m)];

                case 3:
                  return y = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return v = i.sent().gasLimit, _ = void 0 === d ? o._defaultEstimateGasFactor : d, g = Math.round(_ * y), [2, v < g ? v : g];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, f, l) {
          return void 0 === f && (f = {}), o(this, void 0, void 0, function () {
            var o, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_partition", e), h.assert.isString("_from", t), h.assert.isString("_to", a), h.assert.isBigNumber("_value", r), h.assert.isString("_data", n), h.assert.isString("_operatorData", c), h.assert.doesConformToSchema("callData", f, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== l && h.assert.isBlockParam("defaultBlock", l), p = (o = this)._strictEncodeArguments("operatorTransferByPartition(bytes32,address,address,uint256,bytes,bytes)", [e, t, a, r, n, c]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, f, {
                    data: p
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (b = i.sent()).from = b.from ? b.from.toLowerCase() : b.from, [4, o._web3Wrapper.callAsync(b, l)];

                case 2:
                  return m = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(m), [2, o._lookupAbiEncoder("operatorTransferByPartition(bytes32,address,address,uint256,bytes,bytes)").strictDecodeReturnValue(m)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s) {
          return h.assert.isString("_partition", e), h.assert.isString("_from", t), h.assert.isString("_to", a), h.assert.isBigNumber("_value", r), h.assert.isString("_data", n), h.assert.isString("_operatorData", s), this._strictEncodeArguments("operatorTransferByPartition(bytes32,address,address,uint256,bytes,bytes)", [e, t, a, r, n, s]);
        }
      }, l.transfersFrozen = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("transfersFrozen()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("transfersFrozen()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("transfersFrozen()", []);
        }
      }, l.transferOwnership = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("newOwner", e), n = (r = this)._strictEncodeArguments("transferOwnership(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.transferOwnership.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("newOwner", e), n = (r = this)._strictEncodeArguments("transferOwnership(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("newOwner", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("transferOwnership(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("transferOwnership(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("newOwner", e), this._strictEncodeArguments("transferOwnership(address)", [e]);
        }
      }, l.isOwner = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("isOwner()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("isOwner()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("isOwner()", []);
        }
      }, l.owner = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("owner()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("owner()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("owner()", []);
        }
      }, l.controller = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("controller()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("controller()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("controller()", []);
        }
      }, l.moduleRegistry = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("moduleRegistry()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("moduleRegistry()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("moduleRegistry()", []);
        }
      }, l.securityTokenRegistry = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("securityTokenRegistry()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("securityTokenRegistry()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("securityTokenRegistry()", []);
        }
      }, l.polyToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("polyToken()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("polyToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("polyToken()", []);
        }
      }, l.tokenFactory = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("tokenFactory()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("tokenFactory()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("tokenFactory()", []);
        }
      }, l.getterDelegate = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getterDelegate()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getterDelegate()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getterDelegate()", []);
        }
      }, l.controllerDisabled = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("controllerDisabled()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("controllerDisabled()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("controllerDisabled()", []);
        }
      }, l.initialized = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("initialized()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("initialized()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("initialized()", []);
        }
      }, l.tokenDetails = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("tokenDetails()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("tokenDetails()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("tokenDetails()", []);
        }
      }, l.updateFromRegistry = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("updateFromRegistry()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.updateFromRegistry.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return d = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(d), [2, new p.PolyResponse(d, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("updateFromRegistry()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return d = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * d), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("updateFromRegistry()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("updateFromRegistry()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("updateFromRegistry()", []);
        }
      }, l._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, f.classUtils.bindAll(l, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), l;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n) {
      return o(this, void 0, void 0, function () {
        var s, o, c, p, b, y, v, _, g, A;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return h.assert.isHexString("bytecode", e), h.assert.doesConformToSchema("txDefaults", n, d.schemas.txDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), s = f.providerUtils.standardizeOrThrow(r), o = u.BaseContract._lookupConstructorAbi(a), u.BaseContract._formatABIDataItemList(o.inputs, [], u.BaseContract._bigNumberToString), c = new m.utils.Interface(a), p = c.deployFunction, b = p.encode(e, []), y = new l.Web3Wrapper(s), [4, u.BaseContract._applyDefaultsToTxDataAsync({
                data: b
              }, n, y.estimateGasAsync.bind(y))];

            case 1:
              return v = i.sent(), [4, y.sendTransactionAsync(v)];

            case 2:
              return _ = i.sent(), f.logUtils.log("transactionHash: " + _), [4, y.awaitTransactionSuccessAsync(_)];

            case 3:
              return g = i.sent(), f.logUtils.log("ISecurityToken successfully deployed at " + g.contractAddress), (A = new t(g.contractAddress, s, n)).constructorArgs = [], [2, A];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        anonymous: !1,
        inputs: [{
          name: "from",
          type: "address",
          indexed: !0
        }, {
          name: "to",
          type: "address",
          indexed: !0
        }, {
          name: "value",
          type: "uint256",
          indexed: !1
        }],
        name: "Transfer",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "owner",
          type: "address",
          indexed: !0
        }, {
          name: "spender",
          type: "address",
          indexed: !0
        }, {
          name: "value",
          type: "uint256",
          indexed: !1
        }],
        name: "Approval",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_types",
          type: "uint8[]",
          indexed: !1
        }, {
          name: "_name",
          type: "bytes32",
          indexed: !0
        }, {
          name: "_moduleFactory",
          type: "address",
          indexed: !0
        }, {
          name: "_module",
          type: "address",
          indexed: !1
        }, {
          name: "_moduleCost",
          type: "uint256",
          indexed: !1
        }, {
          name: "_budget",
          type: "uint256",
          indexed: !1
        }, {
          name: "_label",
          type: "bytes32",
          indexed: !1
        }, {
          name: "_archived",
          type: "bool",
          indexed: !1
        }],
        name: "ModuleAdded",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_oldDetails",
          type: "string",
          indexed: !1
        }, {
          name: "_newDetails",
          type: "string",
          indexed: !1
        }],
        name: "UpdateTokenDetails",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_oldName",
          type: "string",
          indexed: !1
        }, {
          name: "_newName",
          type: "string",
          indexed: !1
        }],
        name: "UpdateTokenName",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_oldGranularity",
          type: "uint256",
          indexed: !1
        }, {
          name: "_newGranularity",
          type: "uint256",
          indexed: !1
        }],
        name: "GranularityChanged",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [],
        name: "FreezeIssuance",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_status",
          type: "bool",
          indexed: !1
        }],
        name: "FreezeTransfers",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_checkpointId",
          type: "uint256",
          indexed: !0
        }, {
          name: "_investorLength",
          type: "uint256",
          indexed: !1
        }],
        name: "CheckpointCreated",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_oldController",
          type: "address",
          indexed: !0
        }, {
          name: "_newController",
          type: "address",
          indexed: !0
        }],
        name: "SetController",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_oldTreasuryWallet",
          type: "address",
          indexed: !1
        }, {
          name: "_newTreasuryWallet",
          type: "address",
          indexed: !1
        }],
        name: "TreasuryWalletChanged",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [],
        name: "DisableController",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "previousOwner",
          type: "address",
          indexed: !0
        }, {
          name: "newOwner",
          type: "address",
          indexed: !0
        }],
        name: "OwnershipTransferred",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_major",
          type: "uint8",
          indexed: !1
        }, {
          name: "_minor",
          type: "uint8",
          indexed: !1
        }, {
          name: "_patch",
          type: "uint8",
          indexed: !1
        }],
        name: "TokenUpgraded",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_types",
          type: "uint8[]",
          indexed: !1
        }, {
          name: "_module",
          type: "address",
          indexed: !1
        }],
        name: "ModuleArchived",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_types",
          type: "uint8[]",
          indexed: !1
        }, {
          name: "_module",
          type: "address",
          indexed: !1
        }],
        name: "ModuleUnarchived",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_types",
          type: "uint8[]",
          indexed: !1
        }, {
          name: "_module",
          type: "address",
          indexed: !1
        }],
        name: "ModuleRemoved",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_moduleTypes",
          type: "uint8[]",
          indexed: !1
        }, {
          name: "_module",
          type: "address",
          indexed: !1
        }, {
          name: "_oldBudget",
          type: "uint256",
          indexed: !1
        }, {
          name: "_budget",
          type: "uint256",
          indexed: !1
        }],
        name: "ModuleBudgetChanged",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_fromPartition",
          type: "bytes32",
          indexed: !0
        }, {
          name: "_operator",
          type: "address",
          indexed: !1
        }, {
          name: "_from",
          type: "address",
          indexed: !0
        }, {
          name: "_to",
          type: "address",
          indexed: !0
        }, {
          name: "_value",
          type: "uint256",
          indexed: !1
        }, {
          name: "_data",
          type: "bytes",
          indexed: !1
        }, {
          name: "_operatorData",
          type: "bytes",
          indexed: !1
        }],
        name: "TransferByPartition",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "operator",
          type: "address",
          indexed: !0
        }, {
          name: "tokenHolder",
          type: "address",
          indexed: !0
        }],
        name: "AuthorizedOperator",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "operator",
          type: "address",
          indexed: !0
        }, {
          name: "tokenHolder",
          type: "address",
          indexed: !0
        }],
        name: "RevokedOperator",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "partition",
          type: "bytes32",
          indexed: !0
        }, {
          name: "operator",
          type: "address",
          indexed: !0
        }, {
          name: "tokenHolder",
          type: "address",
          indexed: !0
        }],
        name: "AuthorizedOperatorByPartition",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "partition",
          type: "bytes32",
          indexed: !0
        }, {
          name: "operator",
          type: "address",
          indexed: !0
        }, {
          name: "tokenHolder",
          type: "address",
          indexed: !0
        }],
        name: "RevokedOperatorByPartition",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "partition",
          type: "bytes32",
          indexed: !0
        }, {
          name: "to",
          type: "address",
          indexed: !0
        }, {
          name: "value",
          type: "uint256",
          indexed: !1
        }, {
          name: "data",
          type: "bytes",
          indexed: !1
        }],
        name: "IssuedByPartition",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "partition",
          type: "bytes32",
          indexed: !0
        }, {
          name: "operator",
          type: "address",
          indexed: !0
        }, {
          name: "from",
          type: "address",
          indexed: !0
        }, {
          name: "value",
          type: "uint256",
          indexed: !1
        }, {
          name: "data",
          type: "bytes",
          indexed: !1
        }, {
          name: "operatorData",
          type: "bytes",
          indexed: !1
        }],
        name: "RedeemedByPartition",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_name",
          type: "bytes32",
          indexed: !0
        }, {
          name: "_uri",
          type: "string",
          indexed: !1
        }, {
          name: "_documentHash",
          type: "bytes32",
          indexed: !1
        }],
        name: "DocumentRemoved",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_name",
          type: "bytes32",
          indexed: !0
        }, {
          name: "_uri",
          type: "string",
          indexed: !1
        }, {
          name: "_documentHash",
          type: "bytes32",
          indexed: !1
        }],
        name: "DocumentUpdated",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_controller",
          type: "address",
          indexed: !1
        }, {
          name: "_from",
          type: "address",
          indexed: !0
        }, {
          name: "_to",
          type: "address",
          indexed: !0
        }, {
          name: "_value",
          type: "uint256",
          indexed: !1
        }, {
          name: "_data",
          type: "bytes",
          indexed: !1
        }, {
          name: "_operatorData",
          type: "bytes",
          indexed: !1
        }],
        name: "ControllerTransfer",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_controller",
          type: "address",
          indexed: !1
        }, {
          name: "_tokenHolder",
          type: "address",
          indexed: !0
        }, {
          name: "_value",
          type: "uint256",
          indexed: !1
        }, {
          name: "_data",
          type: "bytes",
          indexed: !1
        }, {
          name: "_operatorData",
          type: "bytes",
          indexed: !1
        }],
        name: "ControllerRedemption",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_operator",
          type: "address",
          indexed: !0
        }, {
          name: "_to",
          type: "address",
          indexed: !0
        }, {
          name: "_value",
          type: "uint256",
          indexed: !1
        }, {
          name: "_data",
          type: "bytes",
          indexed: !1
        }],
        name: "Issued",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_operator",
          type: "address",
          indexed: !0
        }, {
          name: "_from",
          type: "address",
          indexed: !0
        }, {
          name: "_value",
          type: "uint256",
          indexed: !1
        }, {
          name: "_data",
          type: "bytes",
          indexed: !1
        }],
        name: "Redeemed",
        outputs: [],
        type: "event"
      }, {
        constant: !0,
        inputs: [],
        name: "symbol",
        outputs: [{
          name: "",
          type: "string"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "name",
        outputs: [{
          name: "",
          type: "string"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "decimals",
        outputs: [{
          name: "",
          type: "uint8"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "totalSupply",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "owner",
          type: "address"
        }],
        name: "balanceOf",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "owner",
          type: "address"
        }, {
          name: "spender",
          type: "address"
        }],
        name: "allowance",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "to",
          type: "address"
        }, {
          name: "value",
          type: "uint256"
        }],
        name: "transfer",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "from",
          type: "address"
        }, {
          name: "to",
          type: "address"
        }, {
          name: "value",
          type: "uint256"
        }],
        name: "transferFrom",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "spender",
          type: "address"
        }, {
          name: "value",
          type: "uint256"
        }],
        name: "approve",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "spender",
          type: "address"
        }, {
          name: "subtractedValue",
          type: "uint256"
        }],
        name: "decreaseAllowance",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "spender",
          type: "address"
        }, {
          name: "addedValue",
          type: "uint256"
        }],
        name: "increaseAllowance",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_to",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }],
        name: "canTransfer",
        outputs: [{
          name: "statusCode",
          type: "bytes1"
        }, {
          name: "reasonCode",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_getterDelegate",
          type: "address"
        }],
        name: "initialize",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "_to",
          type: "address"
        }, {
          name: "_partition",
          type: "bytes32"
        }, {
          name: "_value",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }],
        name: "canTransferByPartition",
        outputs: [{
          name: "statusCode",
          type: "bytes1"
        }, {
          name: "reasonCode",
          type: "bytes32"
        }, {
          name: "partition",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "_to",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }],
        name: "canTransferFrom",
        outputs: [{
          name: "statusCode",
          type: "bytes1"
        }, {
          name: "reasonCode",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_name",
          type: "bytes32"
        }, {
          name: "_uri",
          type: "string"
        }, {
          name: "_documentHash",
          type: "bytes32"
        }],
        name: "setDocument",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_name",
          type: "bytes32"
        }],
        name: "removeDocument",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_name",
          type: "bytes32"
        }],
        name: "getDocument",
        outputs: [{
          name: "documentUri",
          type: "string"
        }, {
          name: "documentHash",
          type: "bytes32"
        }, {
          name: "documentTime",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getAllDocuments",
        outputs: [{
          name: "documentNames",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "isControllable",
        outputs: [{
          name: "controlled",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_module",
          type: "address"
        }, {
          name: "_type",
          type: "uint8"
        }],
        name: "isModule",
        outputs: [{
          name: "isValid",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenHolder",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }],
        name: "issue",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenHolders",
          type: "address[]"
        }, {
          name: "_values",
          type: "uint256[]"
        }],
        name: "issueMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_partition",
          type: "bytes32"
        }, {
          name: "_tokenHolder",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }],
        name: "issueByPartition",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_partition",
          type: "bytes32"
        }, {
          name: "_value",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }],
        name: "redeemByPartition",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_value",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }],
        name: "redeem",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenHolder",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }],
        name: "redeemFrom",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_partition",
          type: "bytes32"
        }, {
          name: "_tokenHolder",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }, {
          name: "_operatorData",
          type: "bytes"
        }],
        name: "operatorRedeemByPartition",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_delegate",
          type: "address"
        }, {
          name: "_module",
          type: "address"
        }, {
          name: "_perm",
          type: "bytes32"
        }],
        name: "checkPermission",
        outputs: [{
          name: "hasPermission",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_module",
          type: "address"
        }],
        name: "getModule",
        outputs: [{
          name: "moduleName",
          type: "bytes32"
        }, {
          name: "moduleAddress",
          type: "address"
        }, {
          name: "factoryAddress",
          type: "address"
        }, {
          name: "isArchived",
          type: "bool"
        }, {
          name: "moduleTypes",
          type: "uint8[]"
        }, {
          name: "moduleLabel",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_name",
          type: "bytes32"
        }],
        name: "getModulesByName",
        outputs: [{
          name: "modules",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_type",
          type: "uint8"
        }],
        name: "getModulesByType",
        outputs: [{
          name: "modules",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getTreasuryWallet",
        outputs: [{
          name: "treasuryWallet",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_checkpointId",
          type: "uint256"
        }],
        name: "totalSupplyAt",
        outputs: [{
          name: "supply",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_investor",
          type: "address"
        }, {
          name: "_checkpointId",
          type: "uint256"
        }],
        name: "balanceOfAt",
        outputs: [{
          name: "balance",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "createCheckpoint",
        outputs: [{
          name: "checkpointId",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getCheckpointTimes",
        outputs: [{
          name: "checkpointTimes",
          type: "uint256[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getInvestors",
        outputs: [{
          name: "investors",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_checkpointId",
          type: "uint256"
        }],
        name: "getInvestorsAt",
        outputs: [{
          name: "investors",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_checkpointId",
          type: "uint256"
        }, {
          name: "_start",
          type: "uint256"
        }, {
          name: "_end",
          type: "uint256"
        }],
        name: "getInvestorsSubsetAt",
        outputs: [{
          name: "investors",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_start",
          type: "uint256"
        }, {
          name: "_end",
          type: "uint256"
        }],
        name: "iterateInvestors",
        outputs: [{
          name: "investors",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "currentCheckpointId",
        outputs: [{
          name: "checkpointId",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_operator",
          type: "address"
        }, {
          name: "_tokenHolder",
          type: "address"
        }],
        name: "isOperator",
        outputs: [{
          name: "isValid",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_partition",
          type: "bytes32"
        }, {
          name: "_operator",
          type: "address"
        }, {
          name: "_tokenHolder",
          type: "address"
        }],
        name: "isOperatorForPartition",
        outputs: [{
          name: "isValid",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_tokenHolder",
          type: "address"
        }],
        name: "partitionsOf",
        outputs: [{
          name: "partitions",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "dataStore",
        outputs: [{
          name: "dataStoreAddress",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_dataStore",
          type: "address"
        }],
        name: "changeDataStore",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_wallet",
          type: "address"
        }],
        name: "changeTreasuryWallet",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenContract",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }],
        name: "withdrawERC20",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_module",
          type: "address"
        }, {
          name: "_change",
          type: "uint256"
        }, {
          name: "_increase",
          type: "bool"
        }],
        name: "changeModuleBudget",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_newTokenDetails",
          type: "string"
        }],
        name: "updateTokenDetails",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_name",
          type: "string"
        }],
        name: "changeName",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_granularity",
          type: "uint256"
        }],
        name: "changeGranularity",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "freezeTransfers",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "unfreezeTransfers",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_signature",
          type: "bytes"
        }],
        name: "freezeIssuance",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_moduleFactory",
          type: "address"
        }, {
          name: "_data",
          type: "bytes"
        }, {
          name: "_maxCost",
          type: "uint256"
        }, {
          name: "_budget",
          type: "uint256"
        }, {
          name: "_label",
          type: "bytes32"
        }, {
          name: "_archived",
          type: "bool"
        }],
        name: "addModuleWithLabel",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_moduleFactory",
          type: "address"
        }, {
          name: "_data",
          type: "bytes"
        }, {
          name: "_maxCost",
          type: "uint256"
        }, {
          name: "_budget",
          type: "uint256"
        }, {
          name: "_archived",
          type: "bool"
        }],
        name: "addModule",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_module",
          type: "address"
        }],
        name: "archiveModule",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_module",
          type: "address"
        }],
        name: "unarchiveModule",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_module",
          type: "address"
        }],
        name: "removeModule",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_controller",
          type: "address"
        }],
        name: "setController",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "_to",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }, {
          name: "_operatorData",
          type: "bytes"
        }],
        name: "controllerTransfer",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenHolder",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }, {
          name: "_operatorData",
          type: "bytes"
        }],
        name: "controllerRedeem",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_signature",
          type: "bytes"
        }],
        name: "disableController",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getVersion",
        outputs: [{
          name: "version",
          type: "uint8[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getInvestorCount",
        outputs: [{
          name: "investorCount",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "holderCount",
        outputs: [{
          name: "count",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_to",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }],
        name: "transferWithData",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "_to",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }],
        name: "transferFromWithData",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_partition",
          type: "bytes32"
        }, {
          name: "_to",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }],
        name: "transferByPartition",
        outputs: [{
          name: "partition",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_partition",
          type: "bytes32"
        }, {
          name: "_tokenHolder",
          type: "address"
        }],
        name: "balanceOfByPartition",
        outputs: [{
          name: "balance",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "granularity",
        outputs: [{
          name: "granularityAmount",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "polymathRegistry",
        outputs: [{
          name: "registryAddress",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_module",
          type: "address"
        }],
        name: "upgradeModule",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "upgradeToken",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "isIssuable",
        outputs: [{
          name: "issuable",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_operator",
          type: "address"
        }],
        name: "authorizeOperator",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_operator",
          type: "address"
        }],
        name: "revokeOperator",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_partition",
          type: "bytes32"
        }, {
          name: "_operator",
          type: "address"
        }],
        name: "authorizeOperatorByPartition",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_partition",
          type: "bytes32"
        }, {
          name: "_operator",
          type: "address"
        }],
        name: "revokeOperatorByPartition",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_partition",
          type: "bytes32"
        }, {
          name: "_from",
          type: "address"
        }, {
          name: "_to",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }, {
          name: "_operatorData",
          type: "bytes"
        }],
        name: "operatorTransferByPartition",
        outputs: [{
          name: "partition",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "transfersFrozen",
        outputs: [{
          name: "isFrozen",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "newOwner",
          type: "address"
        }],
        name: "transferOwnership",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "isOwner",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "owner",
        outputs: [{
          name: "ownerAddress",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "controller",
        outputs: [{
          name: "controllerAddress",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "moduleRegistry",
        outputs: [{
          name: "moduleRegistryAddress",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "securityTokenRegistry",
        outputs: [{
          name: "securityTokenRegistryAddress",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "polyToken",
        outputs: [{
          name: "polyTokenAddress",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "tokenFactory",
        outputs: [{
          name: "tokenFactoryAddress",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getterDelegate",
        outputs: [{
          name: "delegate",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "controllerDisabled",
        outputs: [{
          name: "isDisabled",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "initialized",
        outputs: [{
          name: "isInitialized",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "tokenDetails",
        outputs: [{
          name: "details",
          type: "string"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "updateFromRegistry",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(u.BaseContract);

  t.ISecurityTokenContract_3_0_0 = y, t.isISecurityTokenContract_3_0_0 = function (e) {
    return b.isEqual(y.ABI(), e.abi);
  };
},
/*!******************************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/i_security_token_registry.js ***!
  \******************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r85,
      n = this && this.__extends || (_r85 = function r(e, t) {
    return (_r85 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r85(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var c,
      u = a(
  /*! @0x/base-contract */
  12),
      d = a(
  /*! @0x/json-schemas */
  2),
      f = a(
  /*! @0x/utils */
  8),
      l = a(
  /*! @0x/web3-wrapper */
  11),
      h = a(
  /*! @0x/assert */
  10),
      p = a(
  /*! ../../PolyResponse */
  14),
      b = a(
  /*! lodash */
  0),
      m = a(
  /*! ethers */
  13);
  (c = t.ISecurityTokenRegistryEvents_3_0_0 || (t.ISecurityTokenRegistryEvents_3_0_0 = {})).Pause = "Pause", c.Unpause = "Unpause", c.TickerRemoved = "TickerRemoved", c.ChangeExpiryLimit = "ChangeExpiryLimit", c.ChangeSecurityLaunchFee = "ChangeSecurityLaunchFee", c.ChangeTickerRegistrationFee = "ChangeTickerRegistrationFee", c.ChangeFeeCurrency = "ChangeFeeCurrency", c.OwnershipTransferred = "OwnershipTransferred", c.ChangeTickerOwnership = "ChangeTickerOwnership", c.NewSecurityToken = "NewSecurityToken", c.RegisterTicker = "RegisterTicker", c.SecurityTokenRefreshed = "SecurityTokenRefreshed", c.ProtocolFactorySet = "ProtocolFactorySet", c.LatestVersionSet = "LatestVersionSet", c.ProtocolFactoryRemoved = "ProtocolFactoryRemoved";

  var y = function (e) {
    function t(a, r, n, c) {
      var l = e.call(this, "ISecurityTokenRegistry", t.ABI(), a, r, n) || this;
      return l.generateSecurityToken = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, d, f, l, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_name", e), h.assert.isString("_ticker", t), h.assert.isString("_tokenDetails", a), h.assert.isBoolean("_divisible", r), d = (o = this)._strictEncodeArguments("generateSecurityToken(string,string,string,bool)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: d
                  }), s({
                    from: l
                  }, f), o.generateSecurityToken.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(b)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new p.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, d, f, l, p, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_name", e), h.assert.isString("_ticker", t), h.assert.isString("_tokenDetails", a), h.assert.isBoolean("_divisible", r), d = (o = this)._strictEncodeArguments("generateSecurityToken(string,string,string,bool)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: d
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (p = i.sent()).from && (p.from = p.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(p)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, f, l, p;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_name", e), h.assert.isString("_ticker", t), h.assert.isString("_tokenDetails", a), h.assert.isBoolean("_divisible", r), h.assert.doesConformToSchema("callData", n, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== c && h.assert.isBlockParam("defaultBlock", c), f = (o = this)._strictEncodeArguments("generateSecurityToken(string,string,string,bool)", [e, t, a, r]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: f
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return p = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(p), [2, o._lookupAbiEncoder("generateSecurityToken(string,string,string,bool)").strictDecodeReturnValue(p)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return h.assert.isString("_name", e), h.assert.isString("_ticker", t), h.assert.isString("_tokenDetails", a), h.assert.isBoolean("_divisible", r), this._strictEncodeArguments("generateSecurityToken(string,string,string,bool)", [e, t, a, r]);
        }
      }, l.generateNewSecurityToken = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, d, f) {
          return o(this, void 0, void 0, function () {
            var o, l, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_name", e), h.assert.isString("_ticker", t), h.assert.isString("_tokenDetails", a), h.assert.isBoolean("_divisible", r), h.assert.isString("_treasuryWallet", n), h.assert.isBigNumber("_protocolVersion", c), l = (o = this)._strictEncodeArguments("generateNewSecurityToken(string,string,string,bool,address,uint256)", [e, t, a, r, n, c]), b = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return m = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, d, {
                    data: l
                  }), s({
                    from: m
                  }, b), o.generateNewSecurityToken.estimateGasAsync.bind(o, e, t, a, r, n, c, f))];

                case 2:
                  return void 0 !== (y = i.sent()).from && (y.from = y.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(y)];

                case 3:
                  return v = i.sent(), _ = o._web3Wrapper.awaitTransactionSuccessAsync(v), [2, new p.PolyResponse(v, _)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, d, f) {
          return o(this, void 0, void 0, function () {
            var o, l, p, b, m, y, v, _, g;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_name", e), h.assert.isString("_ticker", t), h.assert.isString("_tokenDetails", a), h.assert.isBoolean("_divisible", r), h.assert.isString("_treasuryWallet", n), h.assert.isBigNumber("_protocolVersion", c), l = (o = this)._strictEncodeArguments("generateNewSecurityToken(string,string,string,bool,address,uint256)", [e, t, a, r, n, c]), p = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return b = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, f, {
                    data: l
                  }), s({
                    from: b
                  }, p))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(m)];

                case 3:
                  return y = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return v = i.sent().gasLimit, _ = void 0 === d ? o._defaultEstimateGasFactor : d, g = Math.round(_ * y), [2, v < g ? v : g];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, f, l) {
          return void 0 === f && (f = {}), o(this, void 0, void 0, function () {
            var o, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_name", e), h.assert.isString("_ticker", t), h.assert.isString("_tokenDetails", a), h.assert.isBoolean("_divisible", r), h.assert.isString("_treasuryWallet", n), h.assert.isBigNumber("_protocolVersion", c), h.assert.doesConformToSchema("callData", f, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== l && h.assert.isBlockParam("defaultBlock", l), p = (o = this)._strictEncodeArguments("generateNewSecurityToken(string,string,string,bool,address,uint256)", [e, t, a, r, n, c]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, f, {
                    data: p
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (b = i.sent()).from = b.from ? b.from.toLowerCase() : b.from, [4, o._web3Wrapper.callAsync(b, l)];

                case 2:
                  return m = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(m), [2, o._lookupAbiEncoder("generateNewSecurityToken(string,string,string,bool,address,uint256)").strictDecodeReturnValue(m)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s) {
          return h.assert.isString("_name", e), h.assert.isString("_ticker", t), h.assert.isString("_tokenDetails", a), h.assert.isBoolean("_divisible", r), h.assert.isString("_treasuryWallet", n), h.assert.isBigNumber("_protocolVersion", s), this._strictEncodeArguments("generateNewSecurityToken(string,string,string,bool,address,uint256)", [e, t, a, r, n, s]);
        }
      }, l.refreshSecurityToken = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, d) {
          return o(this, void 0, void 0, function () {
            var o, f, l, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_name", e), h.assert.isString("_ticker", t), h.assert.isString("_tokenDetails", a), h.assert.isBoolean("_divisible", r), h.assert.isString("_treasuryWallet", n), f = (o = this)._strictEncodeArguments("refreshSecurityToken(string,string,string,bool,address)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return b = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: f
                  }), s({
                    from: b
                  }, l), o.refreshSecurityToken.estimateGasAsync.bind(o, e, t, a, r, n, d))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(m)];

                case 3:
                  return y = i.sent(), v = o._web3Wrapper.awaitTransactionSuccessAsync(y), [2, new p.PolyResponse(y, v)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, d) {
          return o(this, void 0, void 0, function () {
            var o, f, l, p, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_name", e), h.assert.isString("_ticker", t), h.assert.isString("_tokenDetails", a), h.assert.isBoolean("_divisible", r), h.assert.isString("_treasuryWallet", n), f = (o = this)._strictEncodeArguments("refreshSecurityToken(string,string,string,bool,address)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return p = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, d, {
                    data: f
                  }), s({
                    from: p
                  }, l))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(b)];

                case 3:
                  return m = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return y = i.sent().gasLimit, v = void 0 === c ? o._defaultEstimateGasFactor : c, _ = Math.round(v * m), [2, y < _ ? y : _];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, f) {
          return void 0 === c && (c = {}), o(this, void 0, void 0, function () {
            var o, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_name", e), h.assert.isString("_ticker", t), h.assert.isString("_tokenDetails", a), h.assert.isBoolean("_divisible", r), h.assert.isString("_treasuryWallet", n), h.assert.doesConformToSchema("callData", c, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== f && h.assert.isBlockParam("defaultBlock", f), l = (o = this)._strictEncodeArguments("refreshSecurityToken(string,string,string,bool,address)", [e, t, a, r, n]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: l
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (p = i.sent()).from = p.from ? p.from.toLowerCase() : p.from, [4, o._web3Wrapper.callAsync(p, f)];

                case 2:
                  return b = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(b), [2, o._lookupAbiEncoder("refreshSecurityToken(string,string,string,bool,address)").strictDecodeReturnValue(b)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n) {
          return h.assert.isString("_name", e), h.assert.isString("_ticker", t), h.assert.isString("_tokenDetails", a), h.assert.isBoolean("_divisible", r), h.assert.isString("_treasuryWallet", n), this._strictEncodeArguments("refreshSecurityToken(string,string,string,bool,address)", [e, t, a, r, n]);
        }
      }, l.modifySecurityToken = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, d, f) {
          return o(this, void 0, void 0, function () {
            var o, l, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_name", e), h.assert.isString("_ticker", t), h.assert.isString("_owner", a), h.assert.isString("_securityToken", r), h.assert.isString("_tokenDetails", n), h.assert.isBigNumber("_deployedAt", c), l = (o = this)._strictEncodeArguments("modifySecurityToken(string,string,address,address,string,uint256)", [e, t, a, r, n, c]), b = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return m = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, d, {
                    data: l
                  }), s({
                    from: m
                  }, b), o.modifySecurityToken.estimateGasAsync.bind(o, e, t, a, r, n, c, f))];

                case 2:
                  return void 0 !== (y = i.sent()).from && (y.from = y.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(y)];

                case 3:
                  return v = i.sent(), _ = o._web3Wrapper.awaitTransactionSuccessAsync(v), [2, new p.PolyResponse(v, _)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, d, f) {
          return o(this, void 0, void 0, function () {
            var o, l, p, b, m, y, v, _, g;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_name", e), h.assert.isString("_ticker", t), h.assert.isString("_owner", a), h.assert.isString("_securityToken", r), h.assert.isString("_tokenDetails", n), h.assert.isBigNumber("_deployedAt", c), l = (o = this)._strictEncodeArguments("modifySecurityToken(string,string,address,address,string,uint256)", [e, t, a, r, n, c]), p = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return b = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, f, {
                    data: l
                  }), s({
                    from: b
                  }, p))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(m)];

                case 3:
                  return y = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return v = i.sent().gasLimit, _ = void 0 === d ? o._defaultEstimateGasFactor : d, g = Math.round(_ * y), [2, v < g ? v : g];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, f, l) {
          return void 0 === f && (f = {}), o(this, void 0, void 0, function () {
            var o, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_name", e), h.assert.isString("_ticker", t), h.assert.isString("_owner", a), h.assert.isString("_securityToken", r), h.assert.isString("_tokenDetails", n), h.assert.isBigNumber("_deployedAt", c), h.assert.doesConformToSchema("callData", f, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== l && h.assert.isBlockParam("defaultBlock", l), p = (o = this)._strictEncodeArguments("modifySecurityToken(string,string,address,address,string,uint256)", [e, t, a, r, n, c]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, f, {
                    data: p
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (b = i.sent()).from = b.from ? b.from.toLowerCase() : b.from, [4, o._web3Wrapper.callAsync(b, l)];

                case 2:
                  return m = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(m), [2, o._lookupAbiEncoder("modifySecurityToken(string,string,address,address,string,uint256)").strictDecodeReturnValue(m)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s) {
          return h.assert.isString("_name", e), h.assert.isString("_ticker", t), h.assert.isString("_owner", a), h.assert.isString("_securityToken", r), h.assert.isString("_tokenDetails", n), h.assert.isBigNumber("_deployedAt", s), this._strictEncodeArguments("modifySecurityToken(string,string,address,address,string,uint256)", [e, t, a, r, n, s]);
        }
      }, l.modifyExistingSecurityToken = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, d) {
          return o(this, void 0, void 0, function () {
            var o, f, l, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_ticker", e), h.assert.isString("_owner", t), h.assert.isString("_securityToken", a), h.assert.isString("_tokenDetails", r), h.assert.isBigNumber("_deployedAt", n), f = (o = this)._strictEncodeArguments("modifyExistingSecurityToken(string,address,address,string,uint256)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return b = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: f
                  }), s({
                    from: b
                  }, l), o.modifyExistingSecurityToken.estimateGasAsync.bind(o, e, t, a, r, n, d))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(m)];

                case 3:
                  return y = i.sent(), v = o._web3Wrapper.awaitTransactionSuccessAsync(y), [2, new p.PolyResponse(y, v)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, d) {
          return o(this, void 0, void 0, function () {
            var o, f, l, p, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_ticker", e), h.assert.isString("_owner", t), h.assert.isString("_securityToken", a), h.assert.isString("_tokenDetails", r), h.assert.isBigNumber("_deployedAt", n), f = (o = this)._strictEncodeArguments("modifyExistingSecurityToken(string,address,address,string,uint256)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return p = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, d, {
                    data: f
                  }), s({
                    from: p
                  }, l))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(b)];

                case 3:
                  return m = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return y = i.sent().gasLimit, v = void 0 === c ? o._defaultEstimateGasFactor : c, _ = Math.round(v * m), [2, y < _ ? y : _];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, f) {
          return void 0 === c && (c = {}), o(this, void 0, void 0, function () {
            var o, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_ticker", e), h.assert.isString("_owner", t), h.assert.isString("_securityToken", a), h.assert.isString("_tokenDetails", r), h.assert.isBigNumber("_deployedAt", n), h.assert.doesConformToSchema("callData", c, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== f && h.assert.isBlockParam("defaultBlock", f), l = (o = this)._strictEncodeArguments("modifyExistingSecurityToken(string,address,address,string,uint256)", [e, t, a, r, n]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: l
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (p = i.sent()).from = p.from ? p.from.toLowerCase() : p.from, [4, o._web3Wrapper.callAsync(p, f)];

                case 2:
                  return b = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(b), [2, o._lookupAbiEncoder("modifyExistingSecurityToken(string,address,address,string,uint256)").strictDecodeReturnValue(b)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n) {
          return h.assert.isString("_ticker", e), h.assert.isString("_owner", t), h.assert.isString("_securityToken", a), h.assert.isString("_tokenDetails", r), h.assert.isBigNumber("_deployedAt", n), this._strictEncodeArguments("modifyExistingSecurityToken(string,address,address,string,uint256)", [e, t, a, r, n]);
        }
      }, l.modifyExistingTicker = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, d) {
          return o(this, void 0, void 0, function () {
            var o, f, l, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_owner", e), h.assert.isString("_ticker", t), h.assert.isBigNumber("_registrationDate", a), h.assert.isBigNumber("_expiryDate", r), h.assert.isBoolean("_status", n), f = (o = this)._strictEncodeArguments("modifyExistingTicker(address,string,uint256,uint256,bool)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return b = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: f
                  }), s({
                    from: b
                  }, l), o.modifyExistingTicker.estimateGasAsync.bind(o, e, t, a, r, n, d))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(m)];

                case 3:
                  return y = i.sent(), v = o._web3Wrapper.awaitTransactionSuccessAsync(y), [2, new p.PolyResponse(y, v)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, d) {
          return o(this, void 0, void 0, function () {
            var o, f, l, p, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_owner", e), h.assert.isString("_ticker", t), h.assert.isBigNumber("_registrationDate", a), h.assert.isBigNumber("_expiryDate", r), h.assert.isBoolean("_status", n), f = (o = this)._strictEncodeArguments("modifyExistingTicker(address,string,uint256,uint256,bool)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return p = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, d, {
                    data: f
                  }), s({
                    from: p
                  }, l))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(b)];

                case 3:
                  return m = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return y = i.sent().gasLimit, v = void 0 === c ? o._defaultEstimateGasFactor : c, _ = Math.round(v * m), [2, y < _ ? y : _];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, f) {
          return void 0 === c && (c = {}), o(this, void 0, void 0, function () {
            var o, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_owner", e), h.assert.isString("_ticker", t), h.assert.isBigNumber("_registrationDate", a), h.assert.isBigNumber("_expiryDate", r), h.assert.isBoolean("_status", n), h.assert.doesConformToSchema("callData", c, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== f && h.assert.isBlockParam("defaultBlock", f), l = (o = this)._strictEncodeArguments("modifyExistingTicker(address,string,uint256,uint256,bool)", [e, t, a, r, n]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: l
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (p = i.sent()).from = p.from ? p.from.toLowerCase() : p.from, [4, o._web3Wrapper.callAsync(p, f)];

                case 2:
                  return b = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(b), [2, o._lookupAbiEncoder("modifyExistingTicker(address,string,uint256,uint256,bool)").strictDecodeReturnValue(b)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n) {
          return h.assert.isString("_owner", e), h.assert.isString("_ticker", t), h.assert.isBigNumber("_registrationDate", a), h.assert.isBigNumber("_expiryDate", r), h.assert.isBoolean("_status", n), this._strictEncodeArguments("modifyExistingTicker(address,string,uint256,uint256,bool)", [e, t, a, r, n]);
        }
      }, l.registerTicker = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_owner", e), h.assert.isString("_ticker", t), h.assert.isString("_tokenName", a), c = (o = this)._strictEncodeArguments("registerTicker(address,string,string)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, d), o.registerTicker.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return b = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(b), [2, new p.PolyResponse(b, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, p, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_owner", e), h.assert.isString("_ticker", t), h.assert.isString("_tokenName", a), c = (o = this)._strictEncodeArguments("registerTicker(address,string,string)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, d))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return p = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * p), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_owner", e), h.assert.isString("_ticker", t), h.assert.isString("_tokenName", a), h.assert.doesConformToSchema("callData", r, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== n && h.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("registerTicker(address,string,string)", [e, t, a]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (f = i.sent()).from = f.from ? f.from.toLowerCase() : f.from, [4, o._web3Wrapper.callAsync(f, n)];

                case 2:
                  return l = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("registerTicker(address,string,string)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return h.assert.isString("_owner", e), h.assert.isString("_ticker", t), h.assert.isString("_tokenName", a), this._strictEncodeArguments("registerTicker(address,string,string)", [e, t, a]);
        }
      }, l.registerNewTicker = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_owner", e), h.assert.isString("_ticker", t), o = (n = this)._strictEncodeArguments("registerNewTicker(address,string)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: d
                  }, c), n.registerNewTicker.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), b = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new p.PolyResponse(l, b)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_owner", e), h.assert.isString("_ticker", t), o = (n = this)._strictEncodeArguments("registerNewTicker(address,string)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: d
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return p = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, p < m ? p : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_owner", e), h.assert.isString("_ticker", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("registerNewTicker(address,string)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("registerNewTicker(address,string)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("_owner", e), h.assert.isString("_ticker", t), this._strictEncodeArguments("registerNewTicker(address,string)", [e, t]);
        }
      }, l.isSecurityToken = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_securityToken", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("isSecurityToken(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("isSecurityToken(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_securityToken", e), this._strictEncodeArguments("isSecurityToken(address)", [e]);
        }
      }, l.transferOwnership = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_newOwner", e), n = (r = this)._strictEncodeArguments("transferOwnership(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.transferOwnership.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_newOwner", e), n = (r = this)._strictEncodeArguments("transferOwnership(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_newOwner", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("transferOwnership(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("transferOwnership(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_newOwner", e), this._strictEncodeArguments("transferOwnership(address)", [e]);
        }
      }, l.getSecurityTokenAddress = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_ticker", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getSecurityTokenAddress(string)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getSecurityTokenAddress(string)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_ticker", e), this._strictEncodeArguments("getSecurityTokenAddress(string)", [e]);
        }
      }, l.getSecurityTokenData = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_securityToken", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getSecurityTokenData(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getSecurityTokenData(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_securityToken", e), this._strictEncodeArguments("getSecurityTokenData(address)", [e]);
        }
      }, l.getSTFactoryAddress = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getSTFactoryAddress()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getSTFactoryAddress()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getSTFactoryAddress()", []);
        }
      }, l.getSTFactoryAddressOfVersion = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_protocolVersion", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getSTFactoryAddressOfVersion(uint256)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getSTFactoryAddressOfVersion(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isBigNumber("_protocolVersion", e), this._strictEncodeArguments("getSTFactoryAddressOfVersion(uint256)", [e]);
        }
      }, l.getLatestProtocolVersion = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getLatestProtocolVersion()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getLatestProtocolVersion()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getLatestProtocolVersion()", []);
        }
      }, l.getTickersByOwner = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_owner", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getTickersByOwner(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getTickersByOwner(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_owner", e), this._strictEncodeArguments("getTickersByOwner(address)", [e]);
        }
      }, l.getTokensByOwner = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_owner", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getTokensByOwner(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getTokensByOwner(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_owner", e), this._strictEncodeArguments("getTokensByOwner(address)", [e]);
        }
      }, l.getTokens = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getTokens()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getTokens()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getTokens()", []);
        }
      }, l.getTickerDetails = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_ticker", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getTickerDetails(string)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getTickerDetails(string)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_ticker", e), this._strictEncodeArguments("getTickerDetails(string)", [e]);
        }
      }, l.modifyTicker = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, d, f) {
          return o(this, void 0, void 0, function () {
            var o, l, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_owner", e), h.assert.isString("_ticker", t), h.assert.isString("_tokenName", a), h.assert.isBigNumber("_registrationDate", r), h.assert.isBigNumber("_expiryDate", n), h.assert.isBoolean("_status", c), l = (o = this)._strictEncodeArguments("modifyTicker(address,string,string,uint256,uint256,bool)", [e, t, a, r, n, c]), b = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return m = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, d, {
                    data: l
                  }), s({
                    from: m
                  }, b), o.modifyTicker.estimateGasAsync.bind(o, e, t, a, r, n, c, f))];

                case 2:
                  return void 0 !== (y = i.sent()).from && (y.from = y.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(y)];

                case 3:
                  return v = i.sent(), _ = o._web3Wrapper.awaitTransactionSuccessAsync(v), [2, new p.PolyResponse(v, _)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, d, f) {
          return o(this, void 0, void 0, function () {
            var o, l, p, b, m, y, v, _, g;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_owner", e), h.assert.isString("_ticker", t), h.assert.isString("_tokenName", a), h.assert.isBigNumber("_registrationDate", r), h.assert.isBigNumber("_expiryDate", n), h.assert.isBoolean("_status", c), l = (o = this)._strictEncodeArguments("modifyTicker(address,string,string,uint256,uint256,bool)", [e, t, a, r, n, c]), p = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return b = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, f, {
                    data: l
                  }), s({
                    from: b
                  }, p))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(m)];

                case 3:
                  return y = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return v = i.sent().gasLimit, _ = void 0 === d ? o._defaultEstimateGasFactor : d, g = Math.round(_ * y), [2, v < g ? v : g];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, f, l) {
          return void 0 === f && (f = {}), o(this, void 0, void 0, function () {
            var o, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_owner", e), h.assert.isString("_ticker", t), h.assert.isString("_tokenName", a), h.assert.isBigNumber("_registrationDate", r), h.assert.isBigNumber("_expiryDate", n), h.assert.isBoolean("_status", c), h.assert.doesConformToSchema("callData", f, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== l && h.assert.isBlockParam("defaultBlock", l), p = (o = this)._strictEncodeArguments("modifyTicker(address,string,string,uint256,uint256,bool)", [e, t, a, r, n, c]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, f, {
                    data: p
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (b = i.sent()).from = b.from ? b.from.toLowerCase() : b.from, [4, o._web3Wrapper.callAsync(b, l)];

                case 2:
                  return m = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(m), [2, o._lookupAbiEncoder("modifyTicker(address,string,string,uint256,uint256,bool)").strictDecodeReturnValue(m)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s) {
          return h.assert.isString("_owner", e), h.assert.isString("_ticker", t), h.assert.isString("_tokenName", a), h.assert.isBigNumber("_registrationDate", r), h.assert.isBigNumber("_expiryDate", n), h.assert.isBoolean("_status", s), this._strictEncodeArguments("modifyTicker(address,string,string,uint256,uint256,bool)", [e, t, a, r, n, s]);
        }
      }, l.removeTicker = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_ticker", e), n = (r = this)._strictEncodeArguments("removeTicker(string)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.removeTicker.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_ticker", e), n = (r = this)._strictEncodeArguments("removeTicker(string)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_ticker", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("removeTicker(string)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("removeTicker(string)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_ticker", e), this._strictEncodeArguments("removeTicker(string)", [e]);
        }
      }, l.transferTickerOwnership = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_newOwner", e), h.assert.isString("_ticker", t), o = (n = this)._strictEncodeArguments("transferTickerOwnership(address,string)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: d
                  }, c), n.transferTickerOwnership.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), b = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new p.PolyResponse(l, b)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_newOwner", e), h.assert.isString("_ticker", t), o = (n = this)._strictEncodeArguments("transferTickerOwnership(address,string)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: d
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return p = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, p < m ? p : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_newOwner", e), h.assert.isString("_ticker", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("transferTickerOwnership(address,string)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("transferTickerOwnership(address,string)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("_newOwner", e), h.assert.isString("_ticker", t), this._strictEncodeArguments("transferTickerOwnership(address,string)", [e, t]);
        }
      }, l.changeExpiryLimit = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_newExpiry", e), n = (r = this)._strictEncodeArguments("changeExpiryLimit(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeExpiryLimit.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_newExpiry", e), n = (r = this)._strictEncodeArguments("changeExpiryLimit(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_newExpiry", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeExpiryLimit(uint256)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeExpiryLimit(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isBigNumber("_newExpiry", e), this._strictEncodeArguments("changeExpiryLimit(uint256)", [e]);
        }
      }, l.changeTickerRegistrationFee = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_tickerRegFee", e), n = (r = this)._strictEncodeArguments("changeTickerRegistrationFee(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeTickerRegistrationFee.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_tickerRegFee", e), n = (r = this)._strictEncodeArguments("changeTickerRegistrationFee(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_tickerRegFee", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeTickerRegistrationFee(uint256)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeTickerRegistrationFee(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isBigNumber("_tickerRegFee", e), this._strictEncodeArguments("changeTickerRegistrationFee(uint256)", [e]);
        }
      }, l.changeSecurityLaunchFee = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_stLaunchFee", e), n = (r = this)._strictEncodeArguments("changeSecurityLaunchFee(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeSecurityLaunchFee.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_stLaunchFee", e), n = (r = this)._strictEncodeArguments("changeSecurityLaunchFee(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_stLaunchFee", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeSecurityLaunchFee(uint256)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeSecurityLaunchFee(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isBigNumber("_stLaunchFee", e), this._strictEncodeArguments("changeSecurityLaunchFee(uint256)", [e]);
        }
      }, l.changeFeesAmountAndCurrency = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_tickerRegFee", e), h.assert.isBigNumber("_stLaunchFee", t), h.assert.isBoolean("_isFeeInPoly", a), c = (o = this)._strictEncodeArguments("changeFeesAmountAndCurrency(uint256,uint256,bool)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, d), o.changeFeesAmountAndCurrency.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return b = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(b), [2, new p.PolyResponse(b, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, p, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_tickerRegFee", e), h.assert.isBigNumber("_stLaunchFee", t), h.assert.isBoolean("_isFeeInPoly", a), c = (o = this)._strictEncodeArguments("changeFeesAmountAndCurrency(uint256,uint256,bool)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, d))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return p = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * p), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_tickerRegFee", e), h.assert.isBigNumber("_stLaunchFee", t), h.assert.isBoolean("_isFeeInPoly", a), h.assert.doesConformToSchema("callData", r, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== n && h.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("changeFeesAmountAndCurrency(uint256,uint256,bool)", [e, t, a]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (f = i.sent()).from = f.from ? f.from.toLowerCase() : f.from, [4, o._web3Wrapper.callAsync(f, n)];

                case 2:
                  return l = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("changeFeesAmountAndCurrency(uint256,uint256,bool)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return h.assert.isBigNumber("_tickerRegFee", e), h.assert.isBigNumber("_stLaunchFee", t), h.assert.isBoolean("_isFeeInPoly", a), this._strictEncodeArguments("changeFeesAmountAndCurrency(uint256,uint256,bool)", [e, t, a]);
        }
      }, l.setProtocolFactory = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, d, f, l, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_STFactoryAddress", e), h.assert.isNumberOrBigNumber("_major", t), h.assert.isNumberOrBigNumber("_minor", a), h.assert.isNumberOrBigNumber("_patch", r), d = (o = this)._strictEncodeArguments("setProtocolFactory(address,uint8,uint8,uint8)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: d
                  }), s({
                    from: l
                  }, f), o.setProtocolFactory.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(b)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new p.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, d, f, l, p, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_STFactoryAddress", e), h.assert.isNumberOrBigNumber("_major", t), h.assert.isNumberOrBigNumber("_minor", a), h.assert.isNumberOrBigNumber("_patch", r), d = (o = this)._strictEncodeArguments("setProtocolFactory(address,uint8,uint8,uint8)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: d
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (p = i.sent()).from && (p.from = p.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(p)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, f, l, p;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_STFactoryAddress", e), h.assert.isNumberOrBigNumber("_major", t), h.assert.isNumberOrBigNumber("_minor", a), h.assert.isNumberOrBigNumber("_patch", r), h.assert.doesConformToSchema("callData", n, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== c && h.assert.isBlockParam("defaultBlock", c), f = (o = this)._strictEncodeArguments("setProtocolFactory(address,uint8,uint8,uint8)", [e, t, a, r]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: f
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return p = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(p), [2, o._lookupAbiEncoder("setProtocolFactory(address,uint8,uint8,uint8)").strictDecodeReturnValue(p)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return h.assert.isString("_STFactoryAddress", e), h.assert.isNumberOrBigNumber("_major", t), h.assert.isNumberOrBigNumber("_minor", a), h.assert.isNumberOrBigNumber("_patch", r), this._strictEncodeArguments("setProtocolFactory(address,uint8,uint8,uint8)", [e, t, a, r]);
        }
      }, l.removeProtocolFactory = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isNumberOrBigNumber("_major", e), h.assert.isNumberOrBigNumber("_minor", t), h.assert.isNumberOrBigNumber("_patch", a), c = (o = this)._strictEncodeArguments("removeProtocolFactory(uint8,uint8,uint8)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, d), o.removeProtocolFactory.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return b = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(b), [2, new p.PolyResponse(b, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, p, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isNumberOrBigNumber("_major", e), h.assert.isNumberOrBigNumber("_minor", t), h.assert.isNumberOrBigNumber("_patch", a), c = (o = this)._strictEncodeArguments("removeProtocolFactory(uint8,uint8,uint8)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, d))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return p = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * p), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isNumberOrBigNumber("_major", e), h.assert.isNumberOrBigNumber("_minor", t), h.assert.isNumberOrBigNumber("_patch", a), h.assert.doesConformToSchema("callData", r, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== n && h.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("removeProtocolFactory(uint8,uint8,uint8)", [e, t, a]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (f = i.sent()).from = f.from ? f.from.toLowerCase() : f.from, [4, o._web3Wrapper.callAsync(f, n)];

                case 2:
                  return l = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("removeProtocolFactory(uint8,uint8,uint8)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return h.assert.isNumberOrBigNumber("_major", e), h.assert.isNumberOrBigNumber("_minor", t), h.assert.isNumberOrBigNumber("_patch", a), this._strictEncodeArguments("removeProtocolFactory(uint8,uint8,uint8)", [e, t, a]);
        }
      }, l.setLatestVersion = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isNumberOrBigNumber("_major", e), h.assert.isNumberOrBigNumber("_minor", t), h.assert.isNumberOrBigNumber("_patch", a), c = (o = this)._strictEncodeArguments("setLatestVersion(uint8,uint8,uint8)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, d), o.setLatestVersion.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return b = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(b), [2, new p.PolyResponse(b, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, p, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isNumberOrBigNumber("_major", e), h.assert.isNumberOrBigNumber("_minor", t), h.assert.isNumberOrBigNumber("_patch", a), c = (o = this)._strictEncodeArguments("setLatestVersion(uint8,uint8,uint8)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, d))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return p = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * p), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isNumberOrBigNumber("_major", e), h.assert.isNumberOrBigNumber("_minor", t), h.assert.isNumberOrBigNumber("_patch", a), h.assert.doesConformToSchema("callData", r, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== n && h.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("setLatestVersion(uint8,uint8,uint8)", [e, t, a]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (f = i.sent()).from = f.from ? f.from.toLowerCase() : f.from, [4, o._web3Wrapper.callAsync(f, n)];

                case 2:
                  return l = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("setLatestVersion(uint8,uint8,uint8)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return h.assert.isNumberOrBigNumber("_major", e), h.assert.isNumberOrBigNumber("_minor", t), h.assert.isNumberOrBigNumber("_patch", a), this._strictEncodeArguments("setLatestVersion(uint8,uint8,uint8)", [e, t, a]);
        }
      }, l.updatePolyTokenAddress = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_newAddress", e), n = (r = this)._strictEncodeArguments("updatePolyTokenAddress(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.updatePolyTokenAddress.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_newAddress", e), n = (r = this)._strictEncodeArguments("updatePolyTokenAddress(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_newAddress", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("updatePolyTokenAddress(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("updatePolyTokenAddress(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_newAddress", e), this._strictEncodeArguments("updatePolyTokenAddress(address)", [e]);
        }
      }, l.updateFromRegistry = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("updateFromRegistry()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.updateFromRegistry.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return d = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(d), [2, new p.PolyResponse(d, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("updateFromRegistry()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return d = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * d), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("updateFromRegistry()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("updateFromRegistry()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("updateFromRegistry()", []);
        }
      }, l.getSecurityTokenLaunchFee = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("getSecurityTokenLaunchFee()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.getSecurityTokenLaunchFee.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return d = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(d), [2, new p.PolyResponse(d, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("getSecurityTokenLaunchFee()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return d = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * d), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getSecurityTokenLaunchFee()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getSecurityTokenLaunchFee()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getSecurityTokenLaunchFee()", []);
        }
      }, l.getTickerRegistrationFee = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("getTickerRegistrationFee()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.getTickerRegistrationFee.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return d = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(d), [2, new p.PolyResponse(d, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("getTickerRegistrationFee()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return d = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * d), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getTickerRegistrationFee()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getTickerRegistrationFee()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getTickerRegistrationFee()", []);
        }
      }, l.setGetterRegistry = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_getterContract", e), n = (r = this)._strictEncodeArguments("setGetterRegistry(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.setGetterRegistry.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_getterContract", e), n = (r = this)._strictEncodeArguments("setGetterRegistry(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_getterContract", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("setGetterRegistry(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("setGetterRegistry(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_getterContract", e), this._strictEncodeArguments("setGetterRegistry(address)", [e]);
        }
      }, l.getFees = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_feeType", e), n = (r = this)._strictEncodeArguments("getFees(bytes32)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.getFees.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_feeType", e), n = (r = this)._strictEncodeArguments("getFees(bytes32)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_feeType", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getFees(bytes32)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getFees(bytes32)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_feeType", e), this._strictEncodeArguments("getFees(bytes32)", [e]);
        }
      }, l.getTokensByDelegate = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_delegate", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getTokensByDelegate(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getTokensByDelegate(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_delegate", e), this._strictEncodeArguments("getTokensByDelegate(address)", [e]);
        }
      }, l.getExpiryLimit = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getExpiryLimit()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getExpiryLimit()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getExpiryLimit()", []);
        }
      }, l.getTickerStatus = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_ticker", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getTickerStatus(string)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getTickerStatus(string)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_ticker", e), this._strictEncodeArguments("getTickerStatus(string)", [e]);
        }
      }, l.getIsFeeInPoly = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getIsFeeInPoly()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getIsFeeInPoly()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getIsFeeInPoly()", []);
        }
      }, l.getTickerOwner = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_ticker", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getTickerOwner(string)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getTickerOwner(string)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_ticker", e), this._strictEncodeArguments("getTickerOwner(string)", [e]);
        }
      }, l.isPaused = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("isPaused()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("isPaused()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("isPaused()", []);
        }
      }, l.pause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.pause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return d = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(d), [2, new p.PolyResponse(d, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return d = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * d), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pause()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pause()", []);
        }
      }, l.unpause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.unpause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return d = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(d), [2, new p.PolyResponse(d, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return d = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * d), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("unpause()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("unpause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("unpause()", []);
        }
      }, l.reclaimERC20 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.reclaimERC20.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenContract", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("reclaimERC20(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_tokenContract", e), this._strictEncodeArguments("reclaimERC20(address)", [e]);
        }
      }, l.owner = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("owner()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("owner()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("owner()", []);
        }
      }, l.tickerAvailable = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_ticker", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("tickerAvailable(string)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("tickerAvailable(string)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_ticker", e), this._strictEncodeArguments("tickerAvailable(string)", [e]);
        }
      }, l._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, f.classUtils.bindAll(l, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), l;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n) {
      return o(this, void 0, void 0, function () {
        var s, o, c, p, b, y, v, _, g, A;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return h.assert.isHexString("bytecode", e), h.assert.doesConformToSchema("txDefaults", n, d.schemas.txDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), s = f.providerUtils.standardizeOrThrow(r), o = u.BaseContract._lookupConstructorAbi(a), u.BaseContract._formatABIDataItemList(o.inputs, [], u.BaseContract._bigNumberToString), c = new m.utils.Interface(a), p = c.deployFunction, b = p.encode(e, []), y = new l.Web3Wrapper(s), [4, u.BaseContract._applyDefaultsToTxDataAsync({
                data: b
              }, n, y.estimateGasAsync.bind(y))];

            case 1:
              return v = i.sent(), [4, y.sendTransactionAsync(v)];

            case 2:
              return _ = i.sent(), f.logUtils.log("transactionHash: " + _), [4, y.awaitTransactionSuccessAsync(_)];

            case 3:
              return g = i.sent(), f.logUtils.log("ISecurityTokenRegistry successfully deployed at " + g.contractAddress), (A = new t(g.contractAddress, s, n)).constructorArgs = [], [2, A];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Pause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Unpause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_ticker",
          type: "string",
          indexed: !1
        }, {
          name: "_removedBy",
          type: "address",
          indexed: !1
        }],
        name: "TickerRemoved",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_oldExpiry",
          type: "uint256",
          indexed: !1
        }, {
          name: "_newExpiry",
          type: "uint256",
          indexed: !1
        }],
        name: "ChangeExpiryLimit",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_oldFee",
          type: "uint256",
          indexed: !1
        }, {
          name: "_newFee",
          type: "uint256",
          indexed: !1
        }],
        name: "ChangeSecurityLaunchFee",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_oldFee",
          type: "uint256",
          indexed: !1
        }, {
          name: "_newFee",
          type: "uint256",
          indexed: !1
        }],
        name: "ChangeTickerRegistrationFee",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_isFeeInPoly",
          type: "bool",
          indexed: !1
        }],
        name: "ChangeFeeCurrency",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "previousOwner",
          type: "address",
          indexed: !0
        }, {
          name: "newOwner",
          type: "address",
          indexed: !0
        }],
        name: "OwnershipTransferred",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_ticker",
          type: "string",
          indexed: !1
        }, {
          name: "_oldOwner",
          type: "address",
          indexed: !0
        }, {
          name: "_newOwner",
          type: "address",
          indexed: !0
        }],
        name: "ChangeTickerOwnership",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_ticker",
          type: "string",
          indexed: !1
        }, {
          name: "_name",
          type: "string",
          indexed: !1
        }, {
          name: "_securityTokenAddress",
          type: "address",
          indexed: !0
        }, {
          name: "_owner",
          type: "address",
          indexed: !0
        }, {
          name: "_addedAt",
          type: "uint256",
          indexed: !1
        }, {
          name: "_registrant",
          type: "address",
          indexed: !1
        }, {
          name: "_fromAdmin",
          type: "bool",
          indexed: !1
        }, {
          name: "_usdFee",
          type: "uint256",
          indexed: !1
        }, {
          name: "_polyFee",
          type: "uint256",
          indexed: !1
        }, {
          name: "_protocolVersion",
          type: "uint256",
          indexed: !1
        }],
        name: "NewSecurityToken",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_ticker",
          type: "string",
          indexed: !1
        }, {
          name: "_name",
          type: "string",
          indexed: !1
        }, {
          name: "_securityTokenAddress",
          type: "address",
          indexed: !0
        }, {
          name: "_owner",
          type: "address",
          indexed: !0
        }, {
          name: "_addedAt",
          type: "uint256",
          indexed: !1
        }, {
          name: "_registrant",
          type: "address",
          indexed: !1
        }, {
          name: "_fromAdmin",
          type: "bool",
          indexed: !1
        }, {
          name: "_registrationFee",
          type: "uint256",
          indexed: !1
        }],
        name: "NewSecurityToken",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_owner",
          type: "address",
          indexed: !0
        }, {
          name: "_ticker",
          type: "string",
          indexed: !1
        }, {
          name: "_registrationDate",
          type: "uint256",
          indexed: !0
        }, {
          name: "_expiryDate",
          type: "uint256",
          indexed: !0
        }, {
          name: "_fromAdmin",
          type: "bool",
          indexed: !1
        }, {
          name: "_registrationFeePoly",
          type: "uint256",
          indexed: !1
        }, {
          name: "_registrationFeeUsd",
          type: "uint256",
          indexed: !1
        }],
        name: "RegisterTicker",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_ticker",
          type: "string",
          indexed: !1
        }, {
          name: "_name",
          type: "string",
          indexed: !1
        }, {
          name: "_securityTokenAddress",
          type: "address",
          indexed: !0
        }, {
          name: "_owner",
          type: "address",
          indexed: !0
        }, {
          name: "_addedAt",
          type: "uint256",
          indexed: !1
        }, {
          name: "_registrant",
          type: "address",
          indexed: !1
        }, {
          name: "_protocolVersion",
          type: "uint256",
          indexed: !1
        }],
        name: "SecurityTokenRefreshed",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_STFactory",
          type: "address",
          indexed: !0
        }, {
          name: "_major",
          type: "uint8",
          indexed: !1
        }, {
          name: "_minor",
          type: "uint8",
          indexed: !1
        }, {
          name: "_patch",
          type: "uint8",
          indexed: !1
        }],
        name: "ProtocolFactorySet",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_major",
          type: "uint8",
          indexed: !1
        }, {
          name: "_minor",
          type: "uint8",
          indexed: !1
        }, {
          name: "_patch",
          type: "uint8",
          indexed: !1
        }],
        name: "LatestVersionSet",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_STFactory",
          type: "address",
          indexed: !0
        }, {
          name: "_major",
          type: "uint8",
          indexed: !1
        }, {
          name: "_minor",
          type: "uint8",
          indexed: !1
        }, {
          name: "_patch",
          type: "uint8",
          indexed: !1
        }],
        name: "ProtocolFactoryRemoved",
        outputs: [],
        type: "event"
      }, {
        constant: !1,
        inputs: [{
          name: "_name",
          type: "string"
        }, {
          name: "_ticker",
          type: "string"
        }, {
          name: "_tokenDetails",
          type: "string"
        }, {
          name: "_divisible",
          type: "bool"
        }],
        name: "generateSecurityToken",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_name",
          type: "string"
        }, {
          name: "_ticker",
          type: "string"
        }, {
          name: "_tokenDetails",
          type: "string"
        }, {
          name: "_divisible",
          type: "bool"
        }, {
          name: "_treasuryWallet",
          type: "address"
        }, {
          name: "_protocolVersion",
          type: "uint256"
        }],
        name: "generateNewSecurityToken",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_name",
          type: "string"
        }, {
          name: "_ticker",
          type: "string"
        }, {
          name: "_tokenDetails",
          type: "string"
        }, {
          name: "_divisible",
          type: "bool"
        }, {
          name: "_treasuryWallet",
          type: "address"
        }],
        name: "refreshSecurityToken",
        outputs: [{
          name: "securityToken",
          type: "address"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_name",
          type: "string"
        }, {
          name: "_ticker",
          type: "string"
        }, {
          name: "_owner",
          type: "address"
        }, {
          name: "_securityToken",
          type: "address"
        }, {
          name: "_tokenDetails",
          type: "string"
        }, {
          name: "_deployedAt",
          type: "uint256"
        }],
        name: "modifySecurityToken",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_ticker",
          type: "string"
        }, {
          name: "_owner",
          type: "address"
        }, {
          name: "_securityToken",
          type: "address"
        }, {
          name: "_tokenDetails",
          type: "string"
        }, {
          name: "_deployedAt",
          type: "uint256"
        }],
        name: "modifyExistingSecurityToken",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_owner",
          type: "address"
        }, {
          name: "_ticker",
          type: "string"
        }, {
          name: "_registrationDate",
          type: "uint256"
        }, {
          name: "_expiryDate",
          type: "uint256"
        }, {
          name: "_status",
          type: "bool"
        }],
        name: "modifyExistingTicker",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_owner",
          type: "address"
        }, {
          name: "_ticker",
          type: "string"
        }, {
          name: "_tokenName",
          type: "string"
        }],
        name: "registerTicker",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_owner",
          type: "address"
        }, {
          name: "_ticker",
          type: "string"
        }],
        name: "registerNewTicker",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_securityToken",
          type: "address"
        }],
        name: "isSecurityToken",
        outputs: [{
          name: "isValid",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_newOwner",
          type: "address"
        }],
        name: "transferOwnership",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_ticker",
          type: "string"
        }],
        name: "getSecurityTokenAddress",
        outputs: [{
          name: "tokenAddress",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_securityToken",
          type: "address"
        }],
        name: "getSecurityTokenData",
        outputs: [{
          name: "tokenSymbol",
          type: "string"
        }, {
          name: "tokenAddress",
          type: "address"
        }, {
          name: "tokenDetails",
          type: "string"
        }, {
          name: "tokenTime",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getSTFactoryAddress",
        outputs: [{
          name: "stFactoryAddress",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_protocolVersion",
          type: "uint256"
        }],
        name: "getSTFactoryAddressOfVersion",
        outputs: [{
          name: "stFactory",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getLatestProtocolVersion",
        outputs: [{
          name: "protocolVersion",
          type: "uint8[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_owner",
          type: "address"
        }],
        name: "getTickersByOwner",
        outputs: [{
          name: "tickers",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_owner",
          type: "address"
        }],
        name: "getTokensByOwner",
        outputs: [{
          name: "tokens",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getTokens",
        outputs: [{
          name: "tokens",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_ticker",
          type: "string"
        }],
        name: "getTickerDetails",
        outputs: [{
          name: "tickerOwner",
          type: "address"
        }, {
          name: "tickerRegistration",
          type: "uint256"
        }, {
          name: "tickerExpiry",
          type: "uint256"
        }, {
          name: "tokenName",
          type: "string"
        }, {
          name: "tickerStatus",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_owner",
          type: "address"
        }, {
          name: "_ticker",
          type: "string"
        }, {
          name: "_tokenName",
          type: "string"
        }, {
          name: "_registrationDate",
          type: "uint256"
        }, {
          name: "_expiryDate",
          type: "uint256"
        }, {
          name: "_status",
          type: "bool"
        }],
        name: "modifyTicker",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_ticker",
          type: "string"
        }],
        name: "removeTicker",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_newOwner",
          type: "address"
        }, {
          name: "_ticker",
          type: "string"
        }],
        name: "transferTickerOwnership",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_newExpiry",
          type: "uint256"
        }],
        name: "changeExpiryLimit",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tickerRegFee",
          type: "uint256"
        }],
        name: "changeTickerRegistrationFee",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_stLaunchFee",
          type: "uint256"
        }],
        name: "changeSecurityLaunchFee",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tickerRegFee",
          type: "uint256"
        }, {
          name: "_stLaunchFee",
          type: "uint256"
        }, {
          name: "_isFeeInPoly",
          type: "bool"
        }],
        name: "changeFeesAmountAndCurrency",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_STFactoryAddress",
          type: "address"
        }, {
          name: "_major",
          type: "uint8"
        }, {
          name: "_minor",
          type: "uint8"
        }, {
          name: "_patch",
          type: "uint8"
        }],
        name: "setProtocolFactory",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_major",
          type: "uint8"
        }, {
          name: "_minor",
          type: "uint8"
        }, {
          name: "_patch",
          type: "uint8"
        }],
        name: "removeProtocolFactory",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_major",
          type: "uint8"
        }, {
          name: "_minor",
          type: "uint8"
        }, {
          name: "_patch",
          type: "uint8"
        }],
        name: "setLatestVersion",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_newAddress",
          type: "address"
        }],
        name: "updatePolyTokenAddress",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "updateFromRegistry",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "getSecurityTokenLaunchFee",
        outputs: [{
          name: "fee",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "getTickerRegistrationFee",
        outputs: [{
          name: "fee",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_getterContract",
          type: "address"
        }],
        name: "setGetterRegistry",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_feeType",
          type: "bytes32"
        }],
        name: "getFees",
        outputs: [{
          name: "usdFee",
          type: "uint256"
        }, {
          name: "polyFee",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_delegate",
          type: "address"
        }],
        name: "getTokensByDelegate",
        outputs: [{
          name: "tokens",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getExpiryLimit",
        outputs: [{
          name: "expiry",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_ticker",
          type: "string"
        }],
        name: "getTickerStatus",
        outputs: [{
          name: "status",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getIsFeeInPoly",
        outputs: [{
          name: "isInPoly",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_ticker",
          type: "string"
        }],
        name: "getTickerOwner",
        outputs: [{
          name: "owner",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "isPaused",
        outputs: [{
          name: "paused",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "pause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "unpause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenContract",
          type: "address"
        }],
        name: "reclaimERC20",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "owner",
        outputs: [{
          name: "ownerAddress",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_ticker",
          type: "string"
        }],
        name: "tickerAvailable",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(u.BaseContract);

  t.ISecurityTokenRegistryContract_3_0_0 = y, t.isISecurityTokenRegistryContract_3_0_0 = function (e) {
    return b.isEqual(y.ABI(), e.abi);
  };
},
/*!***********************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/i_transfer_manager.js ***!
  \***********************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r86,
      n = this && this.__extends || (_r86 = function r(e, t) {
    return (_r86 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r86(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var c = a(
  /*! @0x/base-contract */
  12),
      u = a(
  /*! @0x/json-schemas */
  2),
      d = a(
  /*! @0x/utils */
  8),
      f = a(
  /*! @0x/web3-wrapper */
  11),
      l = a(
  /*! @0x/assert */
  10),
      h = a(
  /*! ../../PolyResponse */
  14),
      p = a(
  /*! lodash */
  0),
      b = a(
  /*! ethers */
  13),
      m = function (e) {
    function t(a, r, n, f) {
      var p = e.call(this, "ITransferManager", t.ABI(), a, r, n) || this;
      return p.executeTransfer = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, u) {
          return o(this, void 0, void 0, function () {
            var o, d, f, p, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return l.assert.isString("_from", e), l.assert.isString("_to", t), l.assert.isBigNumber("_amount", a), l.assert.isString("_data", r), d = (o = this)._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return p = i.sent()[0], [4, c.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: d
                  }), s({
                    from: p
                  }, f), o.executeTransfer.estimateGasAsync.bind(o, e, t, a, r, u))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(b)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new h.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, u) {
          return o(this, void 0, void 0, function () {
            var o, d, f, h, p, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return l.assert.isString("_from", e), l.assert.isString("_to", t), l.assert.isBigNumber("_amount", a), l.assert.isString("_data", r), d = (o = this)._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, c.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: d
                  }), s({
                    from: h
                  }, f))];

                case 2:
                  return void 0 !== (p = i.sent()).from && (p.from = p.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(p)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, d) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, f, h, p;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return l.assert.isString("_from", e), l.assert.isString("_to", t), l.assert.isBigNumber("_amount", a), l.assert.isString("_data", r), l.assert.doesConformToSchema("callData", n, u.schemas.callDataSchema, [u.schemas.addressSchema, u.schemas.numberSchema, u.schemas.jsNumber]), void 0 !== d && l.assert.isBlockParam("defaultBlock", d), f = (o = this)._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]), [4, c.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: f
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (h = i.sent()).from = h.from ? h.from.toLowerCase() : h.from, [4, o._web3Wrapper.callAsync(h, d)];

                case 2:
                  return p = i.sent(), c.BaseContract._throwIfRevertWithReasonCallResult(p), [2, o._lookupAbiEncoder("executeTransfer(address,address,uint256,bytes)").strictDecodeReturnValue(p)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return l.assert.isString("_from", e), l.assert.isString("_to", t), l.assert.isBigNumber("_amount", a), l.assert.isString("_data", r), this._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]);
        }
      }, p.verifyTransfer = {
        callAsync: function callAsync(e, t, a, r, n, d) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, f, h, p;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return l.assert.isString("_from", e), l.assert.isString("_to", t), l.assert.isBigNumber("_amount", a), l.assert.isString("_data", r), l.assert.doesConformToSchema("callData", n, u.schemas.callDataSchema, [u.schemas.addressSchema, u.schemas.numberSchema, u.schemas.jsNumber]), void 0 !== d && l.assert.isBlockParam("defaultBlock", d), f = (o = this)._strictEncodeArguments("verifyTransfer(address,address,uint256,bytes)", [e, t, a, r]), [4, c.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: f
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (h = i.sent()).from = h.from ? h.from.toLowerCase() : h.from, [4, o._web3Wrapper.callAsync(h, d)];

                case 2:
                  return p = i.sent(), c.BaseContract._throwIfRevertWithReasonCallResult(p), [2, o._lookupAbiEncoder("verifyTransfer(address,address,uint256,bytes)").strictDecodeReturnValue(p)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return l.assert.isString("_from", e), l.assert.isString("_to", t), l.assert.isBigNumber("_amount", a), l.assert.isString("_data", r), this._strictEncodeArguments("verifyTransfer(address,address,uint256,bytes)", [e, t, a, r]);
        }
      }, p.getTokensByPartition = {
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, d, f, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return l.assert.isString("_partition", e), l.assert.isString("_tokenHolder", t), l.assert.isBigNumber("_additionalBalance", a), l.assert.doesConformToSchema("callData", r, u.schemas.callDataSchema, [u.schemas.addressSchema, u.schemas.numberSchema, u.schemas.jsNumber]), void 0 !== n && l.assert.isBlockParam("defaultBlock", n), d = (o = this)._strictEncodeArguments("getTokensByPartition(bytes32,address,uint256)", [e, t, a]), [4, c.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: d
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (f = i.sent()).from = f.from ? f.from.toLowerCase() : f.from, [4, o._web3Wrapper.callAsync(f, n)];

                case 2:
                  return h = i.sent(), c.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("getTokensByPartition(bytes32,address,uint256)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return l.assert.isString("_partition", e), l.assert.isString("_tokenHolder", t), l.assert.isBigNumber("_additionalBalance", a), this._strictEncodeArguments("getTokensByPartition(bytes32,address,uint256)", [e, t, a]);
        }
      }, p._defaultEstimateGasFactor = void 0 === f ? 1.1 : f, d.classUtils.bindAll(p, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), p;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n) {
      return o(this, void 0, void 0, function () {
        var s, o, h, p, m, y, v, _, g, A;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return l.assert.isHexString("bytecode", e), l.assert.doesConformToSchema("txDefaults", n, u.schemas.txDataSchema, [u.schemas.addressSchema, u.schemas.numberSchema, u.schemas.jsNumber]), s = d.providerUtils.standardizeOrThrow(r), o = c.BaseContract._lookupConstructorAbi(a), c.BaseContract._formatABIDataItemList(o.inputs, [], c.BaseContract._bigNumberToString), h = new b.utils.Interface(a), p = h.deployFunction, m = p.encode(e, []), y = new f.Web3Wrapper(s), [4, c.BaseContract._applyDefaultsToTxDataAsync({
                data: m
              }, n, y.estimateGasAsync.bind(y))];

            case 1:
              return v = i.sent(), [4, y.sendTransactionAsync(v)];

            case 2:
              return _ = i.sent(), d.logUtils.log("transactionHash: " + _), [4, y.awaitTransactionSuccessAsync(_)];

            case 3:
              return g = i.sent(), d.logUtils.log("ITransferManager successfully deployed at " + g.contractAddress), (A = new t(g.contractAddress, s, n)).constructorArgs = [], [2, A];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !1,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "_to",
          type: "address"
        }, {
          name: "_amount",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }],
        name: "executeTransfer",
        outputs: [{
          name: "result",
          type: "uint8"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "_to",
          type: "address"
        }, {
          name: "_amount",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }],
        name: "verifyTransfer",
        outputs: [{
          name: "result",
          type: "uint8"
        }, {
          name: "partition",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_partition",
          type: "bytes32"
        }, {
          name: "_tokenHolder",
          type: "address"
        }, {
          name: "_additionalBalance",
          type: "uint256"
        }],
        name: "getTokensByPartition",
        outputs: [{
          name: "amount",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(c.BaseContract);

  t.ITransferManagerContract_3_0_0 = m, t.isITransferManagerContract_3_0_0 = function (e) {
    return p.isEqual(m.ABI(), e.abi);
  };
},
/*!*****************************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/lock_up_transfer_manager.js ***!
  \*****************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r87,
      n = this && this.__extends || (_r87 = function r(e, t) {
    return (_r87 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r87(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      c = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || 0 < t--) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u,
      d = a(
  /*! @0x/base-contract */
  12),
      f = a(
  /*! @0x/json-schemas */
  2),
      l = a(
  /*! @0x/utils */
  8),
      h = a(
  /*! @0x/web3-wrapper */
  11),
      p = a(
  /*! @0x/assert */
  10),
      b = a(
  /*! ../../PolyResponse */
  14),
      m = a(
  /*! lodash */
  0),
      y = a(
  /*! ethers */
  13);
  (u = t.LockUpTransferManagerEvents_3_0_0 || (t.LockUpTransferManagerEvents_3_0_0 = {})).AddLockUpToUser = "AddLockUpToUser", u.RemoveLockUpFromUser = "RemoveLockUpFromUser", u.ModifyLockUpType = "ModifyLockUpType", u.AddNewLockUpType = "AddNewLockUpType", u.RemoveLockUpType = "RemoveLockUpType", u.Pause = "Pause", u.Unpause = "Unpause";

  var v = function (e) {
    function t(a, r, n, c) {
      var u = e.call(this, "LockUpTransferManager", t.ABI(), a, r, n) || this;
      return u.reclaimETH = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.reclaimETH.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("reclaimETH()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("reclaimETH()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("reclaimETH()", []);
        }
      }, u.ADMIN = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("ADMIN()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("ADMIN()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("ADMIN()", []);
        }
      }, u.lockups = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("lockups(bytes32)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("lockups(bytes32)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("index_0", e), this._strictEncodeArguments("lockups(bytes32)", [e]);
        }
      }, u.unpause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.unpause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("unpause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("unpause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("unpause()", []);
        }
      }, u.paused = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("paused()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("paused()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("paused()", []);
        }
      }, u.UNLOCKED = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("UNLOCKED()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("UNLOCKED()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("UNLOCKED()", []);
        }
      }, u.polyToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("polyToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("polyToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("polyToken()", []);
        }
      }, u.pause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.pause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pause()", []);
        }
      }, u.reclaimERC20 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.reclaimERC20.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("reclaimERC20(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_tokenContract", e), this._strictEncodeArguments("reclaimERC20(address)", [e]);
        }
      }, u.OPERATOR = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("OPERATOR()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("OPERATOR()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("OPERATOR()", []);
        }
      }, u.LOCKED = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("LOCKED()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("LOCKED()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("LOCKED()", []);
        }
      }, u.securityToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("securityToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("securityToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("securityToken()", []);
        }
      }, u.factory = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("factory()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("factory()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("factory()", []);
        }
      }, u.getDataStore = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDataStore()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDataStore()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDataStore()", []);
        }
      }, u.executeTransfer = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("index_1", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), u = (o = this)._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.executeTransfer.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("index_1", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), u = (o = this)._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("index_1", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("executeTransfer(address,address,uint256,bytes)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isString("_from", e), p.assert.isString("index_1", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), this._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]);
        }
      }, u.verifyTransfer = {
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("index_1", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("verifyTransfer(address,address,uint256,bytes)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("verifyTransfer(address,address,uint256,bytes)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isString("_from", e), p.assert.isString("index_1", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), this._strictEncodeArguments("verifyTransfer(address,address,uint256,bytes)", [e, t, a, r]);
        }
      }, u.addNewLockUpType = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_lockupAmount", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_lockUpPeriodSeconds", a), p.assert.isBigNumber("_releaseFrequencySeconds", r), p.assert.isString("_lockupName", n), f = (o = this)._strictEncodeArguments("addNewLockUpType(uint256,uint256,uint256,uint256,bytes32)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: f
                  }), s({
                    from: h
                  }, l), o.addNewLockUpType.estimateGasAsync.bind(o, e, t, a, r, n, u))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(m)];

                case 3:
                  return y = i.sent(), v = o._web3Wrapper.awaitTransactionSuccessAsync(y), [2, new b.PolyResponse(y, v)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_lockupAmount", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_lockUpPeriodSeconds", a), p.assert.isBigNumber("_releaseFrequencySeconds", r), p.assert.isString("_lockupName", n), f = (o = this)._strictEncodeArguments("addNewLockUpType(uint256,uint256,uint256,uint256,bytes32)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: f
                  }), s({
                    from: h
                  }, l))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(b)];

                case 3:
                  return m = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return y = i.sent().gasLimit, v = void 0 === c ? o._defaultEstimateGasFactor : c, _ = Math.round(v * m), [2, y < _ ? y : _];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u) {
          return void 0 === c && (c = {}), o(this, void 0, void 0, function () {
            var o, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_lockupAmount", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_lockUpPeriodSeconds", a), p.assert.isBigNumber("_releaseFrequencySeconds", r), p.assert.isString("_lockupName", n), p.assert.doesConformToSchema("callData", c, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== u && p.assert.isBlockParam("defaultBlock", u), l = (o = this)._strictEncodeArguments("addNewLockUpType(uint256,uint256,uint256,uint256,bytes32)", [e, t, a, r, n]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: l
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (h = i.sent()).from = h.from ? h.from.toLowerCase() : h.from, [4, o._web3Wrapper.callAsync(h, u)];

                case 2:
                  return b = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(b), [2, o._lookupAbiEncoder("addNewLockUpType(uint256,uint256,uint256,uint256,bytes32)").strictDecodeReturnValue(b)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n) {
          return p.assert.isBigNumber("_lockupAmount", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_lockUpPeriodSeconds", a), p.assert.isBigNumber("_releaseFrequencySeconds", r), p.assert.isString("_lockupName", n), this._strictEncodeArguments("addNewLockUpType(uint256,uint256,uint256,uint256,bytes32)", [e, t, a, r, n]);
        }
      }, u.addNewLockUpTypeMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_lockupAmounts", e), p.assert.isArray("_startTimes", t), p.assert.isArray("_lockUpPeriodsSeconds", a), p.assert.isArray("_releaseFrequenciesSeconds", r), p.assert.isArray("_lockupNames", n), f = (o = this)._strictEncodeArguments("addNewLockUpTypeMulti(uint256[],uint256[],uint256[],uint256[],bytes32[])", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: f
                  }), s({
                    from: h
                  }, l), o.addNewLockUpTypeMulti.estimateGasAsync.bind(o, e, t, a, r, n, u))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(m)];

                case 3:
                  return y = i.sent(), v = o._web3Wrapper.awaitTransactionSuccessAsync(y), [2, new b.PolyResponse(y, v)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_lockupAmounts", e), p.assert.isArray("_startTimes", t), p.assert.isArray("_lockUpPeriodsSeconds", a), p.assert.isArray("_releaseFrequenciesSeconds", r), p.assert.isArray("_lockupNames", n), f = (o = this)._strictEncodeArguments("addNewLockUpTypeMulti(uint256[],uint256[],uint256[],uint256[],bytes32[])", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: f
                  }), s({
                    from: h
                  }, l))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(b)];

                case 3:
                  return m = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return y = i.sent().gasLimit, v = void 0 === c ? o._defaultEstimateGasFactor : c, _ = Math.round(v * m), [2, y < _ ? y : _];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u) {
          return void 0 === c && (c = {}), o(this, void 0, void 0, function () {
            var o, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_lockupAmounts", e), p.assert.isArray("_startTimes", t), p.assert.isArray("_lockUpPeriodsSeconds", a), p.assert.isArray("_releaseFrequenciesSeconds", r), p.assert.isArray("_lockupNames", n), p.assert.doesConformToSchema("callData", c, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== u && p.assert.isBlockParam("defaultBlock", u), l = (o = this)._strictEncodeArguments("addNewLockUpTypeMulti(uint256[],uint256[],uint256[],uint256[],bytes32[])", [e, t, a, r, n]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: l
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (h = i.sent()).from = h.from ? h.from.toLowerCase() : h.from, [4, o._web3Wrapper.callAsync(h, u)];

                case 2:
                  return b = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(b), [2, o._lookupAbiEncoder("addNewLockUpTypeMulti(uint256[],uint256[],uint256[],uint256[],bytes32[])").strictDecodeReturnValue(b)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n) {
          return p.assert.isArray("_lockupAmounts", e), p.assert.isArray("_startTimes", t), p.assert.isArray("_lockUpPeriodsSeconds", a), p.assert.isArray("_releaseFrequenciesSeconds", r), p.assert.isArray("_lockupNames", n), this._strictEncodeArguments("addNewLockUpTypeMulti(uint256[],uint256[],uint256[],uint256[],bytes32[])", [e, t, a, r, n]);
        }
      }, u.addLockUpByName = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_userAddress", e), p.assert.isString("_lockupName", t), o = (n = this)._strictEncodeArguments("addLockUpByName(address,bytes32)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.addLockUpByName.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_userAddress", e), p.assert.isString("_lockupName", t), o = (n = this)._strictEncodeArguments("addLockUpByName(address,bytes32)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_userAddress", e), p.assert.isString("_lockupName", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("addLockUpByName(address,bytes32)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("addLockUpByName(address,bytes32)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_userAddress", e), p.assert.isString("_lockupName", t), this._strictEncodeArguments("addLockUpByName(address,bytes32)", [e, t]);
        }
      }, u.addLockUpByNameMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_userAddresses", e), p.assert.isArray("_lockupNames", t), o = (n = this)._strictEncodeArguments("addLockUpByNameMulti(address[],bytes32[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.addLockUpByNameMulti.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_userAddresses", e), p.assert.isArray("_lockupNames", t), o = (n = this)._strictEncodeArguments("addLockUpByNameMulti(address[],bytes32[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_userAddresses", e), p.assert.isArray("_lockupNames", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("addLockUpByNameMulti(address[],bytes32[])", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("addLockUpByNameMulti(address[],bytes32[])").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isArray("_userAddresses", e), p.assert.isArray("_lockupNames", t), this._strictEncodeArguments("addLockUpByNameMulti(address[],bytes32[])", [e, t]);
        }
      }, u.addNewLockUpToUser = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u, f) {
          return o(this, void 0, void 0, function () {
            var o, l, h, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_userAddress", e), p.assert.isBigNumber("_lockupAmount", t), p.assert.isBigNumber("_startTime", a), p.assert.isBigNumber("_lockUpPeriodSeconds", r), p.assert.isBigNumber("_releaseFrequencySeconds", n), p.assert.isString("_lockupName", c), l = (o = this)._strictEncodeArguments("addNewLockUpToUser(address,uint256,uint256,uint256,uint256,bytes32)", [e, t, a, r, n, c]), h = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return m = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: l
                  }), s({
                    from: m
                  }, h), o.addNewLockUpToUser.estimateGasAsync.bind(o, e, t, a, r, n, c, f))];

                case 2:
                  return void 0 !== (y = i.sent()).from && (y.from = y.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(y)];

                case 3:
                  return v = i.sent(), _ = o._web3Wrapper.awaitTransactionSuccessAsync(v), [2, new b.PolyResponse(v, _)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u, f) {
          return o(this, void 0, void 0, function () {
            var o, l, h, b, m, y, v, _, g;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_userAddress", e), p.assert.isBigNumber("_lockupAmount", t), p.assert.isBigNumber("_startTime", a), p.assert.isBigNumber("_lockUpPeriodSeconds", r), p.assert.isBigNumber("_releaseFrequencySeconds", n), p.assert.isString("_lockupName", c), l = (o = this)._strictEncodeArguments("addNewLockUpToUser(address,uint256,uint256,uint256,uint256,bytes32)", [e, t, a, r, n, c]), h = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return b = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, f, {
                    data: l
                  }), s({
                    from: b
                  }, h))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(m)];

                case 3:
                  return y = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return v = i.sent().gasLimit, _ = void 0 === u ? o._defaultEstimateGasFactor : u, g = Math.round(_ * y), [2, v < g ? v : g];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u, l) {
          return void 0 === u && (u = {}), o(this, void 0, void 0, function () {
            var o, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_userAddress", e), p.assert.isBigNumber("_lockupAmount", t), p.assert.isBigNumber("_startTime", a), p.assert.isBigNumber("_lockUpPeriodSeconds", r), p.assert.isBigNumber("_releaseFrequencySeconds", n), p.assert.isString("_lockupName", c), p.assert.doesConformToSchema("callData", u, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== l && p.assert.isBlockParam("defaultBlock", l), h = (o = this)._strictEncodeArguments("addNewLockUpToUser(address,uint256,uint256,uint256,uint256,bytes32)", [e, t, a, r, n, c]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: h
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (b = i.sent()).from = b.from ? b.from.toLowerCase() : b.from, [4, o._web3Wrapper.callAsync(b, l)];

                case 2:
                  return m = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(m), [2, o._lookupAbiEncoder("addNewLockUpToUser(address,uint256,uint256,uint256,uint256,bytes32)").strictDecodeReturnValue(m)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s) {
          return p.assert.isString("_userAddress", e), p.assert.isBigNumber("_lockupAmount", t), p.assert.isBigNumber("_startTime", a), p.assert.isBigNumber("_lockUpPeriodSeconds", r), p.assert.isBigNumber("_releaseFrequencySeconds", n), p.assert.isString("_lockupName", s), this._strictEncodeArguments("addNewLockUpToUser(address,uint256,uint256,uint256,uint256,bytes32)", [e, t, a, r, n, s]);
        }
      }, u.addNewLockUpToUserMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u, f) {
          return o(this, void 0, void 0, function () {
            var o, l, h, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_userAddresses", e), p.assert.isArray("_lockupAmounts", t), p.assert.isArray("_startTimes", a), p.assert.isArray("_lockUpPeriodsSeconds", r), p.assert.isArray("_releaseFrequenciesSeconds", n), p.assert.isArray("_lockupNames", c), l = (o = this)._strictEncodeArguments("addNewLockUpToUserMulti(address[],uint256[],uint256[],uint256[],uint256[],bytes32[])", [e, t, a, r, n, c]), h = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return m = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: l
                  }), s({
                    from: m
                  }, h), o.addNewLockUpToUserMulti.estimateGasAsync.bind(o, e, t, a, r, n, c, f))];

                case 2:
                  return void 0 !== (y = i.sent()).from && (y.from = y.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(y)];

                case 3:
                  return v = i.sent(), _ = o._web3Wrapper.awaitTransactionSuccessAsync(v), [2, new b.PolyResponse(v, _)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u, f) {
          return o(this, void 0, void 0, function () {
            var o, l, h, b, m, y, v, _, g;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_userAddresses", e), p.assert.isArray("_lockupAmounts", t), p.assert.isArray("_startTimes", a), p.assert.isArray("_lockUpPeriodsSeconds", r), p.assert.isArray("_releaseFrequenciesSeconds", n), p.assert.isArray("_lockupNames", c), l = (o = this)._strictEncodeArguments("addNewLockUpToUserMulti(address[],uint256[],uint256[],uint256[],uint256[],bytes32[])", [e, t, a, r, n, c]), h = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return b = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, f, {
                    data: l
                  }), s({
                    from: b
                  }, h))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(m)];

                case 3:
                  return y = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return v = i.sent().gasLimit, _ = void 0 === u ? o._defaultEstimateGasFactor : u, g = Math.round(_ * y), [2, v < g ? v : g];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u, l) {
          return void 0 === u && (u = {}), o(this, void 0, void 0, function () {
            var o, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_userAddresses", e), p.assert.isArray("_lockupAmounts", t), p.assert.isArray("_startTimes", a), p.assert.isArray("_lockUpPeriodsSeconds", r), p.assert.isArray("_releaseFrequenciesSeconds", n), p.assert.isArray("_lockupNames", c), p.assert.doesConformToSchema("callData", u, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== l && p.assert.isBlockParam("defaultBlock", l), h = (o = this)._strictEncodeArguments("addNewLockUpToUserMulti(address[],uint256[],uint256[],uint256[],uint256[],bytes32[])", [e, t, a, r, n, c]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: h
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (b = i.sent()).from = b.from ? b.from.toLowerCase() : b.from, [4, o._web3Wrapper.callAsync(b, l)];

                case 2:
                  return m = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(m), [2, o._lookupAbiEncoder("addNewLockUpToUserMulti(address[],uint256[],uint256[],uint256[],uint256[],bytes32[])").strictDecodeReturnValue(m)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s) {
          return p.assert.isArray("_userAddresses", e), p.assert.isArray("_lockupAmounts", t), p.assert.isArray("_startTimes", a), p.assert.isArray("_lockUpPeriodsSeconds", r), p.assert.isArray("_releaseFrequenciesSeconds", n), p.assert.isArray("_lockupNames", s), this._strictEncodeArguments("addNewLockUpToUserMulti(address[],uint256[],uint256[],uint256[],uint256[],bytes32[])", [e, t, a, r, n, s]);
        }
      }, u.removeLockUpFromUser = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_userAddress", e), p.assert.isString("_lockupName", t), o = (n = this)._strictEncodeArguments("removeLockUpFromUser(address,bytes32)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.removeLockUpFromUser.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_userAddress", e), p.assert.isString("_lockupName", t), o = (n = this)._strictEncodeArguments("removeLockUpFromUser(address,bytes32)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_userAddress", e), p.assert.isString("_lockupName", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("removeLockUpFromUser(address,bytes32)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("removeLockUpFromUser(address,bytes32)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_userAddress", e), p.assert.isString("_lockupName", t), this._strictEncodeArguments("removeLockUpFromUser(address,bytes32)", [e, t]);
        }
      }, u.removeLockupType = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_lockupName", e), n = (r = this)._strictEncodeArguments("removeLockupType(bytes32)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.removeLockupType.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_lockupName", e), n = (r = this)._strictEncodeArguments("removeLockupType(bytes32)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_lockupName", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("removeLockupType(bytes32)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("removeLockupType(bytes32)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_lockupName", e), this._strictEncodeArguments("removeLockupType(bytes32)", [e]);
        }
      }, u.removeLockupTypeMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_lockupNames", e), n = (r = this)._strictEncodeArguments("removeLockupTypeMulti(bytes32[])", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.removeLockupTypeMulti.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_lockupNames", e), n = (r = this)._strictEncodeArguments("removeLockupTypeMulti(bytes32[])", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_lockupNames", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("removeLockupTypeMulti(bytes32[])", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("removeLockupTypeMulti(bytes32[])").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isArray("_lockupNames", e), this._strictEncodeArguments("removeLockupTypeMulti(bytes32[])", [e]);
        }
      }, u.removeLockUpFromUserMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_userAddresses", e), p.assert.isArray("_lockupNames", t), o = (n = this)._strictEncodeArguments("removeLockUpFromUserMulti(address[],bytes32[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.removeLockUpFromUserMulti.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_userAddresses", e), p.assert.isArray("_lockupNames", t), o = (n = this)._strictEncodeArguments("removeLockUpFromUserMulti(address[],bytes32[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_userAddresses", e), p.assert.isArray("_lockupNames", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("removeLockUpFromUserMulti(address[],bytes32[])", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("removeLockUpFromUserMulti(address[],bytes32[])").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isArray("_userAddresses", e), p.assert.isArray("_lockupNames", t), this._strictEncodeArguments("removeLockUpFromUserMulti(address[],bytes32[])", [e, t]);
        }
      }, u.modifyLockUpType = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_lockupAmount", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_lockUpPeriodSeconds", a), p.assert.isBigNumber("_releaseFrequencySeconds", r), p.assert.isString("_lockupName", n), f = (o = this)._strictEncodeArguments("modifyLockUpType(uint256,uint256,uint256,uint256,bytes32)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: f
                  }), s({
                    from: h
                  }, l), o.modifyLockUpType.estimateGasAsync.bind(o, e, t, a, r, n, u))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(m)];

                case 3:
                  return y = i.sent(), v = o._web3Wrapper.awaitTransactionSuccessAsync(y), [2, new b.PolyResponse(y, v)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_lockupAmount", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_lockUpPeriodSeconds", a), p.assert.isBigNumber("_releaseFrequencySeconds", r), p.assert.isString("_lockupName", n), f = (o = this)._strictEncodeArguments("modifyLockUpType(uint256,uint256,uint256,uint256,bytes32)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: f
                  }), s({
                    from: h
                  }, l))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(b)];

                case 3:
                  return m = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return y = i.sent().gasLimit, v = void 0 === c ? o._defaultEstimateGasFactor : c, _ = Math.round(v * m), [2, y < _ ? y : _];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u) {
          return void 0 === c && (c = {}), o(this, void 0, void 0, function () {
            var o, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_lockupAmount", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_lockUpPeriodSeconds", a), p.assert.isBigNumber("_releaseFrequencySeconds", r), p.assert.isString("_lockupName", n), p.assert.doesConformToSchema("callData", c, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== u && p.assert.isBlockParam("defaultBlock", u), l = (o = this)._strictEncodeArguments("modifyLockUpType(uint256,uint256,uint256,uint256,bytes32)", [e, t, a, r, n]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: l
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (h = i.sent()).from = h.from ? h.from.toLowerCase() : h.from, [4, o._web3Wrapper.callAsync(h, u)];

                case 2:
                  return b = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(b), [2, o._lookupAbiEncoder("modifyLockUpType(uint256,uint256,uint256,uint256,bytes32)").strictDecodeReturnValue(b)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n) {
          return p.assert.isBigNumber("_lockupAmount", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_lockUpPeriodSeconds", a), p.assert.isBigNumber("_releaseFrequencySeconds", r), p.assert.isString("_lockupName", n), this._strictEncodeArguments("modifyLockUpType(uint256,uint256,uint256,uint256,bytes32)", [e, t, a, r, n]);
        }
      }, u.modifyLockUpTypeMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_lockupAmounts", e), p.assert.isArray("_startTimes", t), p.assert.isArray("_lockUpPeriodsSeconds", a), p.assert.isArray("_releaseFrequenciesSeconds", r), p.assert.isArray("_lockupNames", n), f = (o = this)._strictEncodeArguments("modifyLockUpTypeMulti(uint256[],uint256[],uint256[],uint256[],bytes32[])", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: f
                  }), s({
                    from: h
                  }, l), o.modifyLockUpTypeMulti.estimateGasAsync.bind(o, e, t, a, r, n, u))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(m)];

                case 3:
                  return y = i.sent(), v = o._web3Wrapper.awaitTransactionSuccessAsync(y), [2, new b.PolyResponse(y, v)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_lockupAmounts", e), p.assert.isArray("_startTimes", t), p.assert.isArray("_lockUpPeriodsSeconds", a), p.assert.isArray("_releaseFrequenciesSeconds", r), p.assert.isArray("_lockupNames", n), f = (o = this)._strictEncodeArguments("modifyLockUpTypeMulti(uint256[],uint256[],uint256[],uint256[],bytes32[])", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: f
                  }), s({
                    from: h
                  }, l))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(b)];

                case 3:
                  return m = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return y = i.sent().gasLimit, v = void 0 === c ? o._defaultEstimateGasFactor : c, _ = Math.round(v * m), [2, y < _ ? y : _];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u) {
          return void 0 === c && (c = {}), o(this, void 0, void 0, function () {
            var o, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_lockupAmounts", e), p.assert.isArray("_startTimes", t), p.assert.isArray("_lockUpPeriodsSeconds", a), p.assert.isArray("_releaseFrequenciesSeconds", r), p.assert.isArray("_lockupNames", n), p.assert.doesConformToSchema("callData", c, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== u && p.assert.isBlockParam("defaultBlock", u), l = (o = this)._strictEncodeArguments("modifyLockUpTypeMulti(uint256[],uint256[],uint256[],uint256[],bytes32[])", [e, t, a, r, n]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: l
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (h = i.sent()).from = h.from ? h.from.toLowerCase() : h.from, [4, o._web3Wrapper.callAsync(h, u)];

                case 2:
                  return b = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(b), [2, o._lookupAbiEncoder("modifyLockUpTypeMulti(uint256[],uint256[],uint256[],uint256[],bytes32[])").strictDecodeReturnValue(b)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n) {
          return p.assert.isArray("_lockupAmounts", e), p.assert.isArray("_startTimes", t), p.assert.isArray("_lockUpPeriodsSeconds", a), p.assert.isArray("_releaseFrequenciesSeconds", r), p.assert.isArray("_lockupNames", n), this._strictEncodeArguments("modifyLockUpTypeMulti(uint256[],uint256[],uint256[],uint256[],bytes32[])", [e, t, a, r, n]);
        }
      }, u.getLockUp = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_lockupName", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getLockUp(bytes32)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getLockUp(bytes32)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_lockupName", e), this._strictEncodeArguments("getLockUp(bytes32)", [e]);
        }
      }, u.getAllLockupData = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getAllLockupData()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getAllLockupData()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getAllLockupData()", []);
        }
      }, u.getListOfAddresses = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_lockupName", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getListOfAddresses(bytes32)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getListOfAddresses(bytes32)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_lockupName", e), this._strictEncodeArguments("getListOfAddresses(bytes32)", [e]);
        }
      }, u.getAllLockups = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getAllLockups()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getAllLockups()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getAllLockups()", []);
        }
      }, u.getLockupsNamesToUser = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_user", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getLockupsNamesToUser(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getLockupsNamesToUser(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_user", e), this._strictEncodeArguments("getLockupsNamesToUser(address)", [e]);
        }
      }, u.getLockedTokenToUser = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_userAddress", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getLockedTokenToUser(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getLockedTokenToUser(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_userAddress", e), this._strictEncodeArguments("getLockedTokenToUser(address)", [e]);
        }
      }, u.getTokensByPartition = {
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_partition", e), p.assert.isString("_tokenHolder", t), p.assert.isBigNumber("_additionalBalance", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("getTokensByPartition(bytes32,address,uint256)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("getTokensByPartition(bytes32,address,uint256)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isString("_partition", e), p.assert.isString("_tokenHolder", t), p.assert.isBigNumber("_additionalBalance", a), this._strictEncodeArguments("getTokensByPartition(bytes32,address,uint256)", [e, t, a]);
        }
      }, u.getInitFunction = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getInitFunction()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getInitFunction()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getInitFunction()", []);
        }
      }, u.getPermissions = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getPermissions()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getPermissions()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getPermissions()", []);
        }
      }, u._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, l.classUtils.bindAll(u, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), u;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n, s, u) {
      return o(this, void 0, void 0, function () {
        var o, b, m, v, _, g, A, w, T, x, D;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return p.assert.isHexString("bytecode", e), p.assert.doesConformToSchema("txDefaults", n, f.schemas.txDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), o = l.providerUtils.standardizeOrThrow(r), b = d.BaseContract._lookupConstructorAbi(a), D = c(d.BaseContract._formatABIDataItemList(b.inputs, [s, u], d.BaseContract._bigNumberToString), 2), s = D[0], u = D[1], m = new y.utils.Interface(a), v = m.deployFunction, _ = v.encode(e, [s, u]), g = new h.Web3Wrapper(o), [4, d.BaseContract._applyDefaultsToTxDataAsync({
                data: _
              }, n, g.estimateGasAsync.bind(g))];

            case 1:
              return A = i.sent(), [4, g.sendTransactionAsync(A)];

            case 2:
              return w = i.sent(), l.logUtils.log("transactionHash: " + w), [4, g.awaitTransactionSuccessAsync(w)];

            case 3:
              return T = i.sent(), l.logUtils.log("LockUpTransferManager successfully deployed at " + T.contractAddress), (x = new t(T.contractAddress, o, n)).constructorArgs = [s, u], [2, x];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !1,
        inputs: [],
        name: "reclaimETH",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "ADMIN",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "bytes32"
        }],
        name: "lockups",
        outputs: [{
          name: "lockupAmount",
          type: "uint256"
        }, {
          name: "startTime",
          type: "uint256"
        }, {
          name: "lockUpPeriodSeconds",
          type: "uint256"
        }, {
          name: "releaseFrequencySeconds",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "unpause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "paused",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "UNLOCKED",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "polyToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "pause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenContract",
          type: "address"
        }],
        name: "reclaimERC20",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "OPERATOR",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "LOCKED",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "securityToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "factory",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDataStore",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        inputs: [{
          name: "_securityToken",
          type: "address"
        }, {
          name: "_polyAddress",
          type: "address"
        }],
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "constructor"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_userAddress",
          type: "address",
          indexed: !0
        }, {
          name: "_lockupName",
          type: "bytes32",
          indexed: !0
        }],
        name: "AddLockUpToUser",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_userAddress",
          type: "address",
          indexed: !0
        }, {
          name: "_lockupName",
          type: "bytes32",
          indexed: !0
        }],
        name: "RemoveLockUpFromUser",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_lockupAmount",
          type: "uint256",
          indexed: !1
        }, {
          name: "_startTime",
          type: "uint256",
          indexed: !1
        }, {
          name: "_lockUpPeriodSeconds",
          type: "uint256",
          indexed: !1
        }, {
          name: "_releaseFrequencySeconds",
          type: "uint256",
          indexed: !1
        }, {
          name: "_lockupName",
          type: "bytes32",
          indexed: !0
        }],
        name: "ModifyLockUpType",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_lockupName",
          type: "bytes32",
          indexed: !0
        }, {
          name: "_lockupAmount",
          type: "uint256",
          indexed: !1
        }, {
          name: "_startTime",
          type: "uint256",
          indexed: !1
        }, {
          name: "_lockUpPeriodSeconds",
          type: "uint256",
          indexed: !1
        }, {
          name: "_releaseFrequencySeconds",
          type: "uint256",
          indexed: !1
        }],
        name: "AddNewLockUpType",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_lockupName",
          type: "bytes32",
          indexed: !0
        }],
        name: "RemoveLockUpType",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Pause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Unpause",
        outputs: [],
        type: "event"
      }, {
        constant: !1,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "index_1",
          type: "address"
        }, {
          name: "_amount",
          type: "uint256"
        }, {
          name: "index_3",
          type: "bytes"
        }],
        name: "executeTransfer",
        outputs: [{
          name: "",
          type: "uint8"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "index_1",
          type: "address"
        }, {
          name: "_amount",
          type: "uint256"
        }, {
          name: "index_3",
          type: "bytes"
        }],
        name: "verifyTransfer",
        outputs: [{
          name: "",
          type: "uint8"
        }, {
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_lockupAmount",
          type: "uint256"
        }, {
          name: "_startTime",
          type: "uint256"
        }, {
          name: "_lockUpPeriodSeconds",
          type: "uint256"
        }, {
          name: "_releaseFrequencySeconds",
          type: "uint256"
        }, {
          name: "_lockupName",
          type: "bytes32"
        }],
        name: "addNewLockUpType",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_lockupAmounts",
          type: "uint256[]"
        }, {
          name: "_startTimes",
          type: "uint256[]"
        }, {
          name: "_lockUpPeriodsSeconds",
          type: "uint256[]"
        }, {
          name: "_releaseFrequenciesSeconds",
          type: "uint256[]"
        }, {
          name: "_lockupNames",
          type: "bytes32[]"
        }],
        name: "addNewLockUpTypeMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_userAddress",
          type: "address"
        }, {
          name: "_lockupName",
          type: "bytes32"
        }],
        name: "addLockUpByName",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_userAddresses",
          type: "address[]"
        }, {
          name: "_lockupNames",
          type: "bytes32[]"
        }],
        name: "addLockUpByNameMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_userAddress",
          type: "address"
        }, {
          name: "_lockupAmount",
          type: "uint256"
        }, {
          name: "_startTime",
          type: "uint256"
        }, {
          name: "_lockUpPeriodSeconds",
          type: "uint256"
        }, {
          name: "_releaseFrequencySeconds",
          type: "uint256"
        }, {
          name: "_lockupName",
          type: "bytes32"
        }],
        name: "addNewLockUpToUser",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_userAddresses",
          type: "address[]"
        }, {
          name: "_lockupAmounts",
          type: "uint256[]"
        }, {
          name: "_startTimes",
          type: "uint256[]"
        }, {
          name: "_lockUpPeriodsSeconds",
          type: "uint256[]"
        }, {
          name: "_releaseFrequenciesSeconds",
          type: "uint256[]"
        }, {
          name: "_lockupNames",
          type: "bytes32[]"
        }],
        name: "addNewLockUpToUserMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_userAddress",
          type: "address"
        }, {
          name: "_lockupName",
          type: "bytes32"
        }],
        name: "removeLockUpFromUser",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_lockupName",
          type: "bytes32"
        }],
        name: "removeLockupType",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_lockupNames",
          type: "bytes32[]"
        }],
        name: "removeLockupTypeMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_userAddresses",
          type: "address[]"
        }, {
          name: "_lockupNames",
          type: "bytes32[]"
        }],
        name: "removeLockUpFromUserMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_lockupAmount",
          type: "uint256"
        }, {
          name: "_startTime",
          type: "uint256"
        }, {
          name: "_lockUpPeriodSeconds",
          type: "uint256"
        }, {
          name: "_releaseFrequencySeconds",
          type: "uint256"
        }, {
          name: "_lockupName",
          type: "bytes32"
        }],
        name: "modifyLockUpType",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_lockupAmounts",
          type: "uint256[]"
        }, {
          name: "_startTimes",
          type: "uint256[]"
        }, {
          name: "_lockUpPeriodsSeconds",
          type: "uint256[]"
        }, {
          name: "_releaseFrequenciesSeconds",
          type: "uint256[]"
        }, {
          name: "_lockupNames",
          type: "bytes32[]"
        }],
        name: "modifyLockUpTypeMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_lockupName",
          type: "bytes32"
        }],
        name: "getLockUp",
        outputs: [{
          name: "lockupAmount",
          type: "uint256"
        }, {
          name: "startTime",
          type: "uint256"
        }, {
          name: "lockUpPeriodSeconds",
          type: "uint256"
        }, {
          name: "releaseFrequencySeconds",
          type: "uint256"
        }, {
          name: "unlockedAmount",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getAllLockupData",
        outputs: [{
          name: "lockupNames",
          type: "bytes32[]"
        }, {
          name: "lockupAmounts",
          type: "uint256[]"
        }, {
          name: "startTimes",
          type: "uint256[]"
        }, {
          name: "lockUpPeriodSeconds",
          type: "uint256[]"
        }, {
          name: "releaseFrequencySeconds",
          type: "uint256[]"
        }, {
          name: "unlockedAmounts",
          type: "uint256[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_lockupName",
          type: "bytes32"
        }],
        name: "getListOfAddresses",
        outputs: [{
          name: "",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getAllLockups",
        outputs: [{
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_user",
          type: "address"
        }],
        name: "getLockupsNamesToUser",
        outputs: [{
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_userAddress",
          type: "address"
        }],
        name: "getLockedTokenToUser",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_partition",
          type: "bytes32"
        }, {
          name: "_tokenHolder",
          type: "address"
        }, {
          name: "_additionalBalance",
          type: "uint256"
        }],
        name: "getTokensByPartition",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getInitFunction",
        outputs: [{
          name: "",
          type: "bytes4"
        }],
        payable: !1,
        stateMutability: "pure",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getPermissions",
        outputs: [{
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(d.BaseContract);

  t.LockUpTransferManagerContract_3_0_0 = v, t.isLockUpTransferManagerContract_3_0_0 = function (e) {
    return m.isEqual(v.ABI(), e.abi);
  };
},
/*!*************************************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/manual_approval_transfer_manager.js ***!
  \*************************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r88,
      n = this && this.__extends || (_r88 = function r(e, t) {
    return (_r88 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r88(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      c = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || 0 < t--) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u,
      d = a(
  /*! @0x/base-contract */
  12),
      f = a(
  /*! @0x/json-schemas */
  2),
      l = a(
  /*! @0x/utils */
  8),
      h = a(
  /*! @0x/web3-wrapper */
  11),
      p = a(
  /*! @0x/assert */
  10),
      b = a(
  /*! ../../PolyResponse */
  14),
      m = a(
  /*! lodash */
  0),
      y = a(
  /*! ethers */
  13);
  (u = t.ManualApprovalTransferManagerEvents_3_0_0 || (t.ManualApprovalTransferManagerEvents_3_0_0 = {})).AddManualApproval = "AddManualApproval", u.ModifyManualApproval = "ModifyManualApproval", u.RevokeManualApproval = "RevokeManualApproval", u.Pause = "Pause", u.Unpause = "Unpause";

  var v = function (e) {
    function t(a, r, n, c) {
      var u = e.call(this, "ManualApprovalTransferManager", t.ABI(), a, r, n) || this;
      return u.reclaimETH = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.reclaimETH.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("reclaimETH()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("reclaimETH()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("reclaimETH()", []);
        }
      }, u.getTokensByPartition = {
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_partition", e), p.assert.isString("_tokenHolder", t), p.assert.isBigNumber("index_2", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("getTokensByPartition(bytes32,address,uint256)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("getTokensByPartition(bytes32,address,uint256)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isString("_partition", e), p.assert.isString("_tokenHolder", t), p.assert.isBigNumber("index_2", a), this._strictEncodeArguments("getTokensByPartition(bytes32,address,uint256)", [e, t, a]);
        }
      }, u.ADMIN = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("ADMIN()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("ADMIN()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("ADMIN()", []);
        }
      }, u.unpause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.unpause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("unpause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("unpause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("unpause()", []);
        }
      }, u.paused = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("paused()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("paused()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("paused()", []);
        }
      }, u.approvalIndex = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("index_0", e), p.assert.isString("index_1", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("approvalIndex(address,address)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("approvalIndex(address,address)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("index_0", e), p.assert.isString("index_1", t), this._strictEncodeArguments("approvalIndex(address,address)", [e, t]);
        }
      }, u.approvals = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("approvals(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("approvals(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("index_0", e), this._strictEncodeArguments("approvals(uint256)", [e]);
        }
      }, u.UNLOCKED = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("UNLOCKED()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("UNLOCKED()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("UNLOCKED()", []);
        }
      }, u.polyToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("polyToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("polyToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("polyToken()", []);
        }
      }, u.pause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.pause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pause()", []);
        }
      }, u.reclaimERC20 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.reclaimERC20.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("reclaimERC20(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_tokenContract", e), this._strictEncodeArguments("reclaimERC20(address)", [e]);
        }
      }, u.OPERATOR = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("OPERATOR()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("OPERATOR()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("OPERATOR()", []);
        }
      }, u.LOCKED = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("LOCKED()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("LOCKED()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("LOCKED()", []);
        }
      }, u.securityToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("securityToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("securityToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("securityToken()", []);
        }
      }, u.factory = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("factory()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("factory()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("factory()", []);
        }
      }, u.getDataStore = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDataStore()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDataStore()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDataStore()", []);
        }
      }, u.getInitFunction = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getInitFunction()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getInitFunction()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getInitFunction()", []);
        }
      }, u.executeTransfer = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), u = (o = this)._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.executeTransfer.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), u = (o = this)._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("executeTransfer(address,address,uint256,bytes)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), this._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]);
        }
      }, u.verifyTransfer = {
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("verifyTransfer(address,address,uint256,bytes)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("verifyTransfer(address,address,uint256,bytes)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), this._strictEncodeArguments("verifyTransfer(address,address,uint256,bytes)", [e, t, a, r]);
        }
      }, u.addManualApproval = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("_allowance", a), p.assert.isBigNumber("_expiryTime", r), p.assert.isString("_description", n), f = (o = this)._strictEncodeArguments("addManualApproval(address,address,uint256,uint256,bytes32)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: f
                  }), s({
                    from: h
                  }, l), o.addManualApproval.estimateGasAsync.bind(o, e, t, a, r, n, u))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(m)];

                case 3:
                  return y = i.sent(), v = o._web3Wrapper.awaitTransactionSuccessAsync(y), [2, new b.PolyResponse(y, v)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("_allowance", a), p.assert.isBigNumber("_expiryTime", r), p.assert.isString("_description", n), f = (o = this)._strictEncodeArguments("addManualApproval(address,address,uint256,uint256,bytes32)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: f
                  }), s({
                    from: h
                  }, l))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(b)];

                case 3:
                  return m = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return y = i.sent().gasLimit, v = void 0 === c ? o._defaultEstimateGasFactor : c, _ = Math.round(v * m), [2, y < _ ? y : _];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u) {
          return void 0 === c && (c = {}), o(this, void 0, void 0, function () {
            var o, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("_allowance", a), p.assert.isBigNumber("_expiryTime", r), p.assert.isString("_description", n), p.assert.doesConformToSchema("callData", c, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== u && p.assert.isBlockParam("defaultBlock", u), l = (o = this)._strictEncodeArguments("addManualApproval(address,address,uint256,uint256,bytes32)", [e, t, a, r, n]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: l
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (h = i.sent()).from = h.from ? h.from.toLowerCase() : h.from, [4, o._web3Wrapper.callAsync(h, u)];

                case 2:
                  return b = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(b), [2, o._lookupAbiEncoder("addManualApproval(address,address,uint256,uint256,bytes32)").strictDecodeReturnValue(b)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n) {
          return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("_allowance", a), p.assert.isBigNumber("_expiryTime", r), p.assert.isString("_description", n), this._strictEncodeArguments("addManualApproval(address,address,uint256,uint256,bytes32)", [e, t, a, r, n]);
        }
      }, u.addManualApprovalMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_from", e), p.assert.isArray("_to", t), p.assert.isArray("_allowances", a), p.assert.isArray("_expiryTimes", r), p.assert.isArray("_descriptions", n), f = (o = this)._strictEncodeArguments("addManualApprovalMulti(address[],address[],uint256[],uint256[],bytes32[])", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: f
                  }), s({
                    from: h
                  }, l), o.addManualApprovalMulti.estimateGasAsync.bind(o, e, t, a, r, n, u))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(m)];

                case 3:
                  return y = i.sent(), v = o._web3Wrapper.awaitTransactionSuccessAsync(y), [2, new b.PolyResponse(y, v)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_from", e), p.assert.isArray("_to", t), p.assert.isArray("_allowances", a), p.assert.isArray("_expiryTimes", r), p.assert.isArray("_descriptions", n), f = (o = this)._strictEncodeArguments("addManualApprovalMulti(address[],address[],uint256[],uint256[],bytes32[])", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: f
                  }), s({
                    from: h
                  }, l))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(b)];

                case 3:
                  return m = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return y = i.sent().gasLimit, v = void 0 === c ? o._defaultEstimateGasFactor : c, _ = Math.round(v * m), [2, y < _ ? y : _];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u) {
          return void 0 === c && (c = {}), o(this, void 0, void 0, function () {
            var o, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_from", e), p.assert.isArray("_to", t), p.assert.isArray("_allowances", a), p.assert.isArray("_expiryTimes", r), p.assert.isArray("_descriptions", n), p.assert.doesConformToSchema("callData", c, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== u && p.assert.isBlockParam("defaultBlock", u), l = (o = this)._strictEncodeArguments("addManualApprovalMulti(address[],address[],uint256[],uint256[],bytes32[])", [e, t, a, r, n]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: l
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (h = i.sent()).from = h.from ? h.from.toLowerCase() : h.from, [4, o._web3Wrapper.callAsync(h, u)];

                case 2:
                  return b = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(b), [2, o._lookupAbiEncoder("addManualApprovalMulti(address[],address[],uint256[],uint256[],bytes32[])").strictDecodeReturnValue(b)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n) {
          return p.assert.isArray("_from", e), p.assert.isArray("_to", t), p.assert.isArray("_allowances", a), p.assert.isArray("_expiryTimes", r), p.assert.isArray("_descriptions", n), this._strictEncodeArguments("addManualApprovalMulti(address[],address[],uint256[],uint256[],bytes32[])", [e, t, a, r, n]);
        }
      }, u.modifyManualApproval = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u, f) {
          return o(this, void 0, void 0, function () {
            var o, l, h, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("_expiryTime", a), p.assert.isBigNumber("_changeInAllowance", r), p.assert.isString("_description", n), p.assert.isBoolean("_increase", c), l = (o = this)._strictEncodeArguments("modifyManualApproval(address,address,uint256,uint256,bytes32,bool)", [e, t, a, r, n, c]), h = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return m = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: l
                  }), s({
                    from: m
                  }, h), o.modifyManualApproval.estimateGasAsync.bind(o, e, t, a, r, n, c, f))];

                case 2:
                  return void 0 !== (y = i.sent()).from && (y.from = y.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(y)];

                case 3:
                  return v = i.sent(), _ = o._web3Wrapper.awaitTransactionSuccessAsync(v), [2, new b.PolyResponse(v, _)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u, f) {
          return o(this, void 0, void 0, function () {
            var o, l, h, b, m, y, v, _, g;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("_expiryTime", a), p.assert.isBigNumber("_changeInAllowance", r), p.assert.isString("_description", n), p.assert.isBoolean("_increase", c), l = (o = this)._strictEncodeArguments("modifyManualApproval(address,address,uint256,uint256,bytes32,bool)", [e, t, a, r, n, c]), h = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return b = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, f, {
                    data: l
                  }), s({
                    from: b
                  }, h))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(m)];

                case 3:
                  return y = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return v = i.sent().gasLimit, _ = void 0 === u ? o._defaultEstimateGasFactor : u, g = Math.round(_ * y), [2, v < g ? v : g];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u, l) {
          return void 0 === u && (u = {}), o(this, void 0, void 0, function () {
            var o, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("_expiryTime", a), p.assert.isBigNumber("_changeInAllowance", r), p.assert.isString("_description", n), p.assert.isBoolean("_increase", c), p.assert.doesConformToSchema("callData", u, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== l && p.assert.isBlockParam("defaultBlock", l), h = (o = this)._strictEncodeArguments("modifyManualApproval(address,address,uint256,uint256,bytes32,bool)", [e, t, a, r, n, c]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: h
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (b = i.sent()).from = b.from ? b.from.toLowerCase() : b.from, [4, o._web3Wrapper.callAsync(b, l)];

                case 2:
                  return m = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(m), [2, o._lookupAbiEncoder("modifyManualApproval(address,address,uint256,uint256,bytes32,bool)").strictDecodeReturnValue(m)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s) {
          return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("_expiryTime", a), p.assert.isBigNumber("_changeInAllowance", r), p.assert.isString("_description", n), p.assert.isBoolean("_increase", s), this._strictEncodeArguments("modifyManualApproval(address,address,uint256,uint256,bytes32,bool)", [e, t, a, r, n, s]);
        }
      }, u.modifyManualApprovalMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u, f) {
          return o(this, void 0, void 0, function () {
            var o, l, h, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_from", e), p.assert.isArray("_to", t), p.assert.isArray("_expiryTimes", a), p.assert.isArray("_changeInAllowance", r), p.assert.isArray("_descriptions", n), p.assert.isArray("_increase", c), l = (o = this)._strictEncodeArguments("modifyManualApprovalMulti(address[],address[],uint256[],uint256[],bytes32[],bool[])", [e, t, a, r, n, c]), h = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return m = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: l
                  }), s({
                    from: m
                  }, h), o.modifyManualApprovalMulti.estimateGasAsync.bind(o, e, t, a, r, n, c, f))];

                case 2:
                  return void 0 !== (y = i.sent()).from && (y.from = y.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(y)];

                case 3:
                  return v = i.sent(), _ = o._web3Wrapper.awaitTransactionSuccessAsync(v), [2, new b.PolyResponse(v, _)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u, f) {
          return o(this, void 0, void 0, function () {
            var o, l, h, b, m, y, v, _, g;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_from", e), p.assert.isArray("_to", t), p.assert.isArray("_expiryTimes", a), p.assert.isArray("_changeInAllowance", r), p.assert.isArray("_descriptions", n), p.assert.isArray("_increase", c), l = (o = this)._strictEncodeArguments("modifyManualApprovalMulti(address[],address[],uint256[],uint256[],bytes32[],bool[])", [e, t, a, r, n, c]), h = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return b = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, f, {
                    data: l
                  }), s({
                    from: b
                  }, h))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(m)];

                case 3:
                  return y = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return v = i.sent().gasLimit, _ = void 0 === u ? o._defaultEstimateGasFactor : u, g = Math.round(_ * y), [2, v < g ? v : g];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u, l) {
          return void 0 === u && (u = {}), o(this, void 0, void 0, function () {
            var o, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_from", e), p.assert.isArray("_to", t), p.assert.isArray("_expiryTimes", a), p.assert.isArray("_changeInAllowance", r), p.assert.isArray("_descriptions", n), p.assert.isArray("_increase", c), p.assert.doesConformToSchema("callData", u, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== l && p.assert.isBlockParam("defaultBlock", l), h = (o = this)._strictEncodeArguments("modifyManualApprovalMulti(address[],address[],uint256[],uint256[],bytes32[],bool[])", [e, t, a, r, n, c]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: h
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (b = i.sent()).from = b.from ? b.from.toLowerCase() : b.from, [4, o._web3Wrapper.callAsync(b, l)];

                case 2:
                  return m = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(m), [2, o._lookupAbiEncoder("modifyManualApprovalMulti(address[],address[],uint256[],uint256[],bytes32[],bool[])").strictDecodeReturnValue(m)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s) {
          return p.assert.isArray("_from", e), p.assert.isArray("_to", t), p.assert.isArray("_expiryTimes", a), p.assert.isArray("_changeInAllowance", r), p.assert.isArray("_descriptions", n), p.assert.isArray("_increase", s), this._strictEncodeArguments("modifyManualApprovalMulti(address[],address[],uint256[],uint256[],bytes32[],bool[])", [e, t, a, r, n, s]);
        }
      }, u.revokeManualApproval = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("_to", t), o = (n = this)._strictEncodeArguments("revokeManualApproval(address,address)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.revokeManualApproval.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("_to", t), o = (n = this)._strictEncodeArguments("revokeManualApproval(address,address)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("revokeManualApproval(address,address)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("revokeManualApproval(address,address)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_from", e), p.assert.isString("_to", t), this._strictEncodeArguments("revokeManualApproval(address,address)", [e, t]);
        }
      }, u.revokeManualApprovalMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_from", e), p.assert.isArray("_to", t), o = (n = this)._strictEncodeArguments("revokeManualApprovalMulti(address[],address[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.revokeManualApprovalMulti.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_from", e), p.assert.isArray("_to", t), o = (n = this)._strictEncodeArguments("revokeManualApprovalMulti(address[],address[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_from", e), p.assert.isArray("_to", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("revokeManualApprovalMulti(address[],address[])", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("revokeManualApprovalMulti(address[],address[])").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isArray("_from", e), p.assert.isArray("_to", t), this._strictEncodeArguments("revokeManualApprovalMulti(address[],address[])", [e, t]);
        }
      }, u.getActiveApprovalsToUser = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_user", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getActiveApprovalsToUser(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getActiveApprovalsToUser(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_user", e), this._strictEncodeArguments("getActiveApprovalsToUser(address)", [e]);
        }
      }, u.getApprovalDetails = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("getApprovalDetails(address,address)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("getApprovalDetails(address,address)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_from", e), p.assert.isString("_to", t), this._strictEncodeArguments("getApprovalDetails(address,address)", [e, t]);
        }
      }, u.getTotalApprovalsLength = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getTotalApprovalsLength()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getTotalApprovalsLength()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getTotalApprovalsLength()", []);
        }
      }, u.getAllApprovals = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getAllApprovals()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getAllApprovals()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getAllApprovals()", []);
        }
      }, u.getPermissions = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getPermissions()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getPermissions()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getPermissions()", []);
        }
      }, u._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, l.classUtils.bindAll(u, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), u;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n, s, u) {
      return o(this, void 0, void 0, function () {
        var o, b, m, v, _, g, A, w, T, x, D;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return p.assert.isHexString("bytecode", e), p.assert.doesConformToSchema("txDefaults", n, f.schemas.txDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), o = l.providerUtils.standardizeOrThrow(r), b = d.BaseContract._lookupConstructorAbi(a), D = c(d.BaseContract._formatABIDataItemList(b.inputs, [s, u], d.BaseContract._bigNumberToString), 2), s = D[0], u = D[1], m = new y.utils.Interface(a), v = m.deployFunction, _ = v.encode(e, [s, u]), g = new h.Web3Wrapper(o), [4, d.BaseContract._applyDefaultsToTxDataAsync({
                data: _
              }, n, g.estimateGasAsync.bind(g))];

            case 1:
              return A = i.sent(), [4, g.sendTransactionAsync(A)];

            case 2:
              return w = i.sent(), l.logUtils.log("transactionHash: " + w), [4, g.awaitTransactionSuccessAsync(w)];

            case 3:
              return T = i.sent(), l.logUtils.log("ManualApprovalTransferManager successfully deployed at " + T.contractAddress), (x = new t(T.contractAddress, o, n)).constructorArgs = [s, u], [2, x];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !1,
        inputs: [],
        name: "reclaimETH",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_partition",
          type: "bytes32"
        }, {
          name: "_tokenHolder",
          type: "address"
        }, {
          name: "index_2",
          type: "uint256"
        }],
        name: "getTokensByPartition",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "ADMIN",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "unpause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "paused",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "address"
        }, {
          name: "index_1",
          type: "address"
        }],
        name: "approvalIndex",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "uint256"
        }],
        name: "approvals",
        outputs: [{
          name: "from",
          type: "address"
        }, {
          name: "to",
          type: "address"
        }, {
          name: "allowance",
          type: "uint256"
        }, {
          name: "expiryTime",
          type: "uint256"
        }, {
          name: "description",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "UNLOCKED",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "polyToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "pause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenContract",
          type: "address"
        }],
        name: "reclaimERC20",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "OPERATOR",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "LOCKED",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "securityToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "factory",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDataStore",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        inputs: [{
          name: "_securityToken",
          type: "address"
        }, {
          name: "_polyToken",
          type: "address"
        }],
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "constructor"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_from",
          type: "address",
          indexed: !0
        }, {
          name: "_to",
          type: "address",
          indexed: !0
        }, {
          name: "_allowance",
          type: "uint256",
          indexed: !1
        }, {
          name: "_expiryTime",
          type: "uint256",
          indexed: !1
        }, {
          name: "_description",
          type: "bytes32",
          indexed: !1
        }, {
          name: "_addedBy",
          type: "address",
          indexed: !0
        }],
        name: "AddManualApproval",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_from",
          type: "address",
          indexed: !0
        }, {
          name: "_to",
          type: "address",
          indexed: !0
        }, {
          name: "_expiryTime",
          type: "uint256",
          indexed: !1
        }, {
          name: "_allowance",
          type: "uint256",
          indexed: !1
        }, {
          name: "_description",
          type: "bytes32",
          indexed: !1
        }, {
          name: "_edittedBy",
          type: "address",
          indexed: !0
        }],
        name: "ModifyManualApproval",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_from",
          type: "address",
          indexed: !0
        }, {
          name: "_to",
          type: "address",
          indexed: !0
        }, {
          name: "_addedBy",
          type: "address",
          indexed: !0
        }],
        name: "RevokeManualApproval",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Pause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Unpause",
        outputs: [],
        type: "event"
      }, {
        constant: !0,
        inputs: [],
        name: "getInitFunction",
        outputs: [{
          name: "",
          type: "bytes4"
        }],
        payable: !1,
        stateMutability: "pure",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "_to",
          type: "address"
        }, {
          name: "_amount",
          type: "uint256"
        }, {
          name: "index_3",
          type: "bytes"
        }],
        name: "executeTransfer",
        outputs: [{
          name: "",
          type: "uint8"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "_to",
          type: "address"
        }, {
          name: "_amount",
          type: "uint256"
        }, {
          name: "index_3",
          type: "bytes"
        }],
        name: "verifyTransfer",
        outputs: [{
          name: "",
          type: "uint8"
        }, {
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "_to",
          type: "address"
        }, {
          name: "_allowance",
          type: "uint256"
        }, {
          name: "_expiryTime",
          type: "uint256"
        }, {
          name: "_description",
          type: "bytes32"
        }],
        name: "addManualApproval",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_from",
          type: "address[]"
        }, {
          name: "_to",
          type: "address[]"
        }, {
          name: "_allowances",
          type: "uint256[]"
        }, {
          name: "_expiryTimes",
          type: "uint256[]"
        }, {
          name: "_descriptions",
          type: "bytes32[]"
        }],
        name: "addManualApprovalMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "_to",
          type: "address"
        }, {
          name: "_expiryTime",
          type: "uint256"
        }, {
          name: "_changeInAllowance",
          type: "uint256"
        }, {
          name: "_description",
          type: "bytes32"
        }, {
          name: "_increase",
          type: "bool"
        }],
        name: "modifyManualApproval",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_from",
          type: "address[]"
        }, {
          name: "_to",
          type: "address[]"
        }, {
          name: "_expiryTimes",
          type: "uint256[]"
        }, {
          name: "_changeInAllowance",
          type: "uint256[]"
        }, {
          name: "_descriptions",
          type: "bytes32[]"
        }, {
          name: "_increase",
          type: "bool[]"
        }],
        name: "modifyManualApprovalMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "_to",
          type: "address"
        }],
        name: "revokeManualApproval",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_from",
          type: "address[]"
        }, {
          name: "_to",
          type: "address[]"
        }],
        name: "revokeManualApprovalMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_user",
          type: "address"
        }],
        name: "getActiveApprovalsToUser",
        outputs: [{
          name: "",
          type: "address[]"
        }, {
          name: "",
          type: "address[]"
        }, {
          name: "",
          type: "uint256[]"
        }, {
          name: "",
          type: "uint256[]"
        }, {
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "_to",
          type: "address"
        }],
        name: "getApprovalDetails",
        outputs: [{
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getTotalApprovalsLength",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getAllApprovals",
        outputs: [{
          name: "",
          type: "address[]"
        }, {
          name: "",
          type: "address[]"
        }, {
          name: "",
          type: "uint256[]"
        }, {
          name: "",
          type: "uint256[]"
        }, {
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getPermissions",
        outputs: [{
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(d.BaseContract);

  t.ManualApprovalTransferManagerContract_3_0_0 = v, t.isManualApprovalTransferManagerContract_3_0_0 = function (e) {
    return m.isEqual(v.ABI(), e.abi);
  };
},
/*!***********************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/module.js ***!
  \***********************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r89,
      n = this && this.__extends || (_r89 = function r(e, t) {
    return (_r89 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r89(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      c = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || 0 < t--) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u,
      d = a(
  /*! @0x/base-contract */
  12),
      f = a(
  /*! @0x/json-schemas */
  2),
      l = a(
  /*! @0x/utils */
  8),
      h = a(
  /*! @0x/web3-wrapper */
  11),
      p = a(
  /*! @0x/assert */
  10),
      b = a(
  /*! ../../PolyResponse */
  14),
      m = a(
  /*! lodash */
  0),
      y = a(
  /*! ethers */
  13);
  (u = t.ModuleEvents_3_0_0 || (t.ModuleEvents_3_0_0 = {})).Pause = "Pause", u.Unpause = "Unpause";

  var v = function (e) {
    function t(a, r, n, c) {
      var u = e.call(this, "Module", t.ABI(), a, r, n) || this;
      return u.getInitFunction = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getInitFunction()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getInitFunction()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getInitFunction()", []);
        }
      }, u.ADMIN = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("ADMIN()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("ADMIN()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("ADMIN()", []);
        }
      }, u.paused = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("paused()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("paused()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("paused()", []);
        }
      }, u.polyToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("polyToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("polyToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("polyToken()", []);
        }
      }, u.OPERATOR = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("OPERATOR()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("OPERATOR()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("OPERATOR()", []);
        }
      }, u.securityToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("securityToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("securityToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("securityToken()", []);
        }
      }, u.getPermissions = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getPermissions()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getPermissions()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getPermissions()", []);
        }
      }, u.factory = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("factory()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("factory()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("factory()", []);
        }
      }, u.pause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.pause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pause()", []);
        }
      }, u.unpause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.unpause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("unpause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("unpause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("unpause()", []);
        }
      }, u.getDataStore = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDataStore()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDataStore()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDataStore()", []);
        }
      }, u.reclaimERC20 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.reclaimERC20.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("reclaimERC20(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_tokenContract", e), this._strictEncodeArguments("reclaimERC20(address)", [e]);
        }
      }, u.reclaimETH = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.reclaimETH.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("reclaimETH()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("reclaimETH()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("reclaimETH()", []);
        }
      }, u._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, l.classUtils.bindAll(u, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), u;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n, s, u) {
      return o(this, void 0, void 0, function () {
        var o, b, m, v, _, g, A, w, T, x, D;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return p.assert.isHexString("bytecode", e), p.assert.doesConformToSchema("txDefaults", n, f.schemas.txDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), o = l.providerUtils.standardizeOrThrow(r), b = d.BaseContract._lookupConstructorAbi(a), D = c(d.BaseContract._formatABIDataItemList(b.inputs, [s, u], d.BaseContract._bigNumberToString), 2), s = D[0], u = D[1], m = new y.utils.Interface(a), v = m.deployFunction, _ = v.encode(e, [s, u]), g = new h.Web3Wrapper(o), [4, d.BaseContract._applyDefaultsToTxDataAsync({
                data: _
              }, n, g.estimateGasAsync.bind(g))];

            case 1:
              return A = i.sent(), [4, g.sendTransactionAsync(A)];

            case 2:
              return w = i.sent(), l.logUtils.log("transactionHash: " + w), [4, g.awaitTransactionSuccessAsync(w)];

            case 3:
              return T = i.sent(), l.logUtils.log("Module successfully deployed at " + T.contractAddress), (x = new t(T.contractAddress, o, n)).constructorArgs = [s, u], [2, x];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !0,
        inputs: [],
        name: "getInitFunction",
        outputs: [{
          name: "initFunction",
          type: "bytes4"
        }],
        payable: !1,
        stateMutability: "pure",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "ADMIN",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "paused",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "polyToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "OPERATOR",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "securityToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getPermissions",
        outputs: [{
          name: "permissions",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "factory",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        inputs: [{
          name: "_securityToken",
          type: "address"
        }, {
          name: "_polyAddress",
          type: "address"
        }],
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "constructor"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Pause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Unpause",
        outputs: [],
        type: "event"
      }, {
        constant: !1,
        inputs: [],
        name: "pause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "unpause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDataStore",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenContract",
          type: "address"
        }],
        name: "reclaimERC20",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "reclaimETH",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(d.BaseContract);

  t.ModuleContract_3_0_0 = v, t.isModuleContract_3_0_0 = function (e) {
    return m.isEqual(v.ABI(), e.abi);
  };
},
/*!*******************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/module_factory.js ***!
  \*******************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r90,
      n = this && this.__extends || (_r90 = function r(e, t) {
    return (_r90 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r90(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      c = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || 0 < t--) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u,
      d = a(
  /*! @0x/base-contract */
  12),
      f = a(
  /*! @0x/json-schemas */
  2),
      l = a(
  /*! @0x/utils */
  8),
      h = a(
  /*! @0x/web3-wrapper */
  11),
      p = a(
  /*! @0x/assert */
  10),
      b = a(
  /*! ../../PolyResponse */
  14),
      m = a(
  /*! lodash */
  0),
      y = a(
  /*! ethers */
  13);
  (u = t.ModuleFactoryEvents_3_0_0 || (t.ModuleFactoryEvents_3_0_0 = {})).OwnershipTransferred = "OwnershipTransferred", u.ChangeSetupCost = "ChangeSetupCost", u.ChangeCostType = "ChangeCostType", u.GenerateModuleFromFactory = "GenerateModuleFromFactory", u.ChangeSTVersionBound = "ChangeSTVersionBound";

  var v = function (e) {
    function t(a, r, n, c) {
      var u = e.call(this, "ModuleFactory", t.ABI(), a, r, n) || this;
      return u.deploy = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_data", e), n = (r = this)._strictEncodeArguments("deploy(bytes)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.deploy.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_data", e), n = (r = this)._strictEncodeArguments("deploy(bytes)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_data", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("deploy(bytes)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("deploy(bytes)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_data", e), this._strictEncodeArguments("deploy(bytes)", [e]);
        }
      }, u.name = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("name()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("name()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("name()", []);
        }
      }, u.isCostInPoly = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("isCostInPoly()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("isCostInPoly()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("isCostInPoly()", []);
        }
      }, u.title = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("title()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("title()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("title()", []);
        }
      }, u.renounceOwnership = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("renounceOwnership()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.renounceOwnership.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("renounceOwnership()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("renounceOwnership()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("renounceOwnership()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("renounceOwnership()", []);
        }
      }, u.description = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("description()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("description()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("description()", []);
        }
      }, u.polymathRegistry = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("polymathRegistry()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("polymathRegistry()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("polymathRegistry()", []);
        }
      }, u.setupCost = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("setupCost()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("setupCost()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("setupCost()", []);
        }
      }, u.owner = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("owner()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("owner()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("owner()", []);
        }
      }, u.isOwner = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("isOwner()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("isOwner()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("isOwner()", []);
        }
      }, u.transferOwnership = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("newOwner", e), n = (r = this)._strictEncodeArguments("transferOwnership(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.transferOwnership.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("newOwner", e), n = (r = this)._strictEncodeArguments("transferOwnership(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("newOwner", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("transferOwnership(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("transferOwnership(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("newOwner", e), this._strictEncodeArguments("transferOwnership(address)", [e]);
        }
      }, u.getTypes = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getTypes()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getTypes()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getTypes()", []);
        }
      }, u.getTags = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getTags()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getTags()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getTags()", []);
        }
      }, u.version = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("version()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("version()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("version()", []);
        }
      }, u.changeSetupCost = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_setupCost", e), n = (r = this)._strictEncodeArguments("changeSetupCost(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeSetupCost.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_setupCost", e), n = (r = this)._strictEncodeArguments("changeSetupCost(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_setupCost", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeSetupCost(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeSetupCost(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_setupCost", e), this._strictEncodeArguments("changeSetupCost(uint256)", [e]);
        }
      }, u.changeCostAndType = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_setupCost", e), p.assert.isBoolean("_isCostInPoly", t), o = (n = this)._strictEncodeArguments("changeCostAndType(uint256,bool)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.changeCostAndType.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_setupCost", e), p.assert.isBoolean("_isCostInPoly", t), o = (n = this)._strictEncodeArguments("changeCostAndType(uint256,bool)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_setupCost", e), p.assert.isBoolean("_isCostInPoly", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("changeCostAndType(uint256,bool)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("changeCostAndType(uint256,bool)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isBigNumber("_setupCost", e), p.assert.isBoolean("_isCostInPoly", t), this._strictEncodeArguments("changeCostAndType(uint256,bool)", [e, t]);
        }
      }, u.changeTitle = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_title", e), n = (r = this)._strictEncodeArguments("changeTitle(string)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeTitle.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_title", e), n = (r = this)._strictEncodeArguments("changeTitle(string)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_title", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeTitle(string)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeTitle(string)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_title", e), this._strictEncodeArguments("changeTitle(string)", [e]);
        }
      }, u.changeDescription = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_description", e), n = (r = this)._strictEncodeArguments("changeDescription(string)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeDescription.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_description", e), n = (r = this)._strictEncodeArguments("changeDescription(string)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_description", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeDescription(string)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeDescription(string)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_description", e), this._strictEncodeArguments("changeDescription(string)", [e]);
        }
      }, u.changeName = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), n = (r = this)._strictEncodeArguments("changeName(bytes32)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeName.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), n = (r = this)._strictEncodeArguments("changeName(bytes32)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeName(bytes32)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeName(bytes32)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_name", e), this._strictEncodeArguments("changeName(bytes32)", [e]);
        }
      }, u.changeTags = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_tagsData", e), n = (r = this)._strictEncodeArguments("changeTags(bytes32[])", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeTags.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_tagsData", e), n = (r = this)._strictEncodeArguments("changeTags(bytes32[])", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_tagsData", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeTags(bytes32[])", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeTags(bytes32[])").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isArray("_tagsData", e), this._strictEncodeArguments("changeTags(bytes32[])", [e]);
        }
      }, u.changeSTVersionBounds = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_boundType", e), p.assert.isArray("_newVersion", t), o = (n = this)._strictEncodeArguments("changeSTVersionBounds(string,uint8[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.changeSTVersionBounds.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_boundType", e), p.assert.isArray("_newVersion", t), o = (n = this)._strictEncodeArguments("changeSTVersionBounds(string,uint8[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_boundType", e), p.assert.isArray("_newVersion", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("changeSTVersionBounds(string,uint8[])", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("changeSTVersionBounds(string,uint8[])").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_boundType", e), p.assert.isArray("_newVersion", t), this._strictEncodeArguments("changeSTVersionBounds(string,uint8[])", [e, t]);
        }
      }, u.getLowerSTVersionBounds = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getLowerSTVersionBounds()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getLowerSTVersionBounds()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getLowerSTVersionBounds()", []);
        }
      }, u.getUpperSTVersionBounds = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getUpperSTVersionBounds()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getUpperSTVersionBounds()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getUpperSTVersionBounds()", []);
        }
      }, u.setupCostInPoly = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("setupCostInPoly()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.setupCostInPoly.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("setupCostInPoly()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("setupCostInPoly()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("setupCostInPoly()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("setupCostInPoly()", []);
        }
      }, u._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, l.classUtils.bindAll(u, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), u;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n, s, u, b) {
      return o(this, void 0, void 0, function () {
        var o, m, v, _, g, A, w, T, x, D, C;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return p.assert.isHexString("bytecode", e), p.assert.doesConformToSchema("txDefaults", n, f.schemas.txDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), o = l.providerUtils.standardizeOrThrow(r), m = d.BaseContract._lookupConstructorAbi(a), C = c(d.BaseContract._formatABIDataItemList(m.inputs, [s, u, b], d.BaseContract._bigNumberToString), 3), s = C[0], u = C[1], b = C[2], v = new y.utils.Interface(a), _ = v.deployFunction, g = _.encode(e, [s, u, b]), A = new h.Web3Wrapper(o), [4, d.BaseContract._applyDefaultsToTxDataAsync({
                data: g
              }, n, A.estimateGasAsync.bind(A))];

            case 1:
              return w = i.sent(), [4, A.sendTransactionAsync(w)];

            case 2:
              return T = i.sent(), l.logUtils.log("transactionHash: " + T), [4, A.awaitTransactionSuccessAsync(T)];

            case 3:
              return x = i.sent(), l.logUtils.log("ModuleFactory successfully deployed at " + x.contractAddress), (D = new t(x.contractAddress, o, n)).constructorArgs = [s, u, b], [2, D];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !1,
        inputs: [{
          name: "_data",
          type: "bytes"
        }],
        name: "deploy",
        outputs: [{
          name: "moduleAddress",
          type: "address"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "name",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "isCostInPoly",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "title",
        outputs: [{
          name: "",
          type: "string"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "description",
        outputs: [{
          name: "",
          type: "string"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "polymathRegistry",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "setupCost",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "owner",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "isOwner",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "newOwner",
          type: "address"
        }],
        name: "transferOwnership",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        inputs: [{
          name: "_setupCost",
          type: "uint256"
        }, {
          name: "_polymathRegistry",
          type: "address"
        }, {
          name: "_isCostInPoly",
          type: "bool"
        }],
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "constructor"
      }, {
        anonymous: !1,
        inputs: [{
          name: "previousOwner",
          type: "address",
          indexed: !0
        }, {
          name: "newOwner",
          type: "address",
          indexed: !0
        }],
        name: "OwnershipTransferred",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_oldSetupCost",
          type: "uint256",
          indexed: !1
        }, {
          name: "_newSetupCost",
          type: "uint256",
          indexed: !1
        }],
        name: "ChangeSetupCost",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_isOldCostInPoly",
          type: "bool",
          indexed: !1
        }, {
          name: "_isNewCostInPoly",
          type: "bool",
          indexed: !1
        }],
        name: "ChangeCostType",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_module",
          type: "address",
          indexed: !1
        }, {
          name: "_moduleName",
          type: "bytes32",
          indexed: !0
        }, {
          name: "_moduleFactory",
          type: "address",
          indexed: !0
        }, {
          name: "_creator",
          type: "address",
          indexed: !1
        }, {
          name: "_setupCost",
          type: "uint256",
          indexed: !1
        }, {
          name: "_setupCostInPoly",
          type: "uint256",
          indexed: !1
        }],
        name: "GenerateModuleFromFactory",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_boundType",
          type: "string",
          indexed: !1
        }, {
          name: "_major",
          type: "uint8",
          indexed: !1
        }, {
          name: "_minor",
          type: "uint8",
          indexed: !1
        }, {
          name: "_patch",
          type: "uint8",
          indexed: !1
        }],
        name: "ChangeSTVersionBound",
        outputs: [],
        type: "event"
      }, {
        constant: !0,
        inputs: [],
        name: "getTypes",
        outputs: [{
          name: "",
          type: "uint8[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getTags",
        outputs: [{
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "version",
        outputs: [{
          name: "",
          type: "string"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_setupCost",
          type: "uint256"
        }],
        name: "changeSetupCost",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_setupCost",
          type: "uint256"
        }, {
          name: "_isCostInPoly",
          type: "bool"
        }],
        name: "changeCostAndType",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_title",
          type: "string"
        }],
        name: "changeTitle",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_description",
          type: "string"
        }],
        name: "changeDescription",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_name",
          type: "bytes32"
        }],
        name: "changeName",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tagsData",
          type: "bytes32[]"
        }],
        name: "changeTags",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_boundType",
          type: "string"
        }, {
          name: "_newVersion",
          type: "uint8[]"
        }],
        name: "changeSTVersionBounds",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getLowerSTVersionBounds",
        outputs: [{
          name: "",
          type: "uint8[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getUpperSTVersionBounds",
        outputs: [{
          name: "",
          type: "uint8[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "setupCostInPoly",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(d.BaseContract);

  t.ModuleFactoryContract_3_0_0 = v, t.isModuleFactoryContract_3_0_0 = function (e) {
    return m.isEqual(v.ABI(), e.abi);
  };
},
/*!********************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/module_registry.js ***!
  \********************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r91,
      n = this && this.__extends || (_r91 = function r(e, t) {
    return (_r91 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r91(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var c,
      u = a(
  /*! @0x/base-contract */
  12),
      d = a(
  /*! @0x/json-schemas */
  2),
      f = a(
  /*! @0x/utils */
  8),
      l = a(
  /*! @0x/web3-wrapper */
  11),
      h = a(
  /*! @0x/assert */
  10),
      p = a(
  /*! ../../PolyResponse */
  14),
      b = a(
  /*! lodash */
  0),
      m = a(
  /*! ethers */
  13);
  (c = t.ModuleRegistryEvents_3_0_0 || (t.ModuleRegistryEvents_3_0_0 = {})).Pause = "Pause", c.Unpause = "Unpause", c.ModuleUsed = "ModuleUsed", c.ModuleRegistered = "ModuleRegistered", c.ModuleVerified = "ModuleVerified", c.ModuleUnverified = "ModuleUnverified", c.ModuleRemoved = "ModuleRemoved", c.OwnershipTransferred = "OwnershipTransferred";

  var y = function (e) {
    function t(a, r, n, c) {
      var l = e.call(this, "ModuleRegistry", t.ABI(), a, r, n) || this;
      return l.getBytes32Value = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_variable", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getBytes32Value(bytes32)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getBytes32Value(bytes32)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_variable", e), this._strictEncodeArguments("getBytes32Value(bytes32)", [e]);
        }
      }, l.getBytesValue = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_variable", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getBytesValue(bytes32)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getBytesValue(bytes32)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_variable", e), this._strictEncodeArguments("getBytesValue(bytes32)", [e]);
        }
      }, l.getAddressValue = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_variable", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getAddressValue(bytes32)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getAddressValue(bytes32)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_variable", e), this._strictEncodeArguments("getAddressValue(bytes32)", [e]);
        }
      }, l.getArrayAddress = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_key", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getArrayAddress(bytes32)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getArrayAddress(bytes32)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_key", e), this._strictEncodeArguments("getArrayAddress(bytes32)", [e]);
        }
      }, l.getBoolValue = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_variable", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getBoolValue(bytes32)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getBoolValue(bytes32)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_variable", e), this._strictEncodeArguments("getBoolValue(bytes32)", [e]);
        }
      }, l.getStringValue = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_variable", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getStringValue(bytes32)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getStringValue(bytes32)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_variable", e), this._strictEncodeArguments("getStringValue(bytes32)", [e]);
        }
      }, l.getArrayBytes32 = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_key", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getArrayBytes32(bytes32)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getArrayBytes32(bytes32)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_key", e), this._strictEncodeArguments("getArrayBytes32(bytes32)", [e]);
        }
      }, l.getUintValue = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_variable", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getUintValue(bytes32)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getUintValue(bytes32)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_variable", e), this._strictEncodeArguments("getUintValue(bytes32)", [e]);
        }
      }, l.getArrayUint = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_key", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getArrayUint(bytes32)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getArrayUint(bytes32)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_key", e), this._strictEncodeArguments("getArrayUint(bytes32)", [e]);
        }
      }, l.initialize = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_polymathRegistry", e), h.assert.isString("_owner", t), o = (n = this)._strictEncodeArguments("initialize(address,address)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: d
                  }, c), n.initialize.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), b = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new p.PolyResponse(l, b)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_polymathRegistry", e), h.assert.isString("_owner", t), o = (n = this)._strictEncodeArguments("initialize(address,address)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: d
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return p = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, p < m ? p : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_polymathRegistry", e), h.assert.isString("_owner", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("initialize(address,address)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("initialize(address,address)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("_polymathRegistry", e), h.assert.isString("_owner", t), this._strictEncodeArguments("initialize(address,address)", [e, t]);
        }
      }, l.useModule2 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_moduleFactory", e), h.assert.isBoolean("_isUpgrade", t), o = (n = this)._strictEncodeArguments("useModule(address,bool)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: d
                  }, c), n.useModule2.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), b = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new p.PolyResponse(l, b)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_moduleFactory", e), h.assert.isBoolean("_isUpgrade", t), o = (n = this)._strictEncodeArguments("useModule(address,bool)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: d
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return p = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, p < m ? p : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_moduleFactory", e), h.assert.isBoolean("_isUpgrade", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("useModule(address,bool)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("useModule(address,bool)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("_moduleFactory", e), h.assert.isBoolean("_isUpgrade", t), this._strictEncodeArguments("useModule(address,bool)", [e, t]);
        }
      }, l.useModule1 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_moduleFactory", e), n = (r = this)._strictEncodeArguments("useModule(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.useModule1.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_moduleFactory", e), n = (r = this)._strictEncodeArguments("useModule(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_moduleFactory", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("useModule(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("useModule(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_moduleFactory", e), this._strictEncodeArguments("useModule(address)", [e]);
        }
      }, l.isCompatibleModule = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_moduleFactory", e), h.assert.isString("_securityToken", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("isCompatibleModule(address,address)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("isCompatibleModule(address,address)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("_moduleFactory", e), h.assert.isString("_securityToken", t), this._strictEncodeArguments("isCompatibleModule(address,address)", [e, t]);
        }
      }, l.registerModule = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_moduleFactory", e), n = (r = this)._strictEncodeArguments("registerModule(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.registerModule.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_moduleFactory", e), n = (r = this)._strictEncodeArguments("registerModule(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_moduleFactory", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("registerModule(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("registerModule(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_moduleFactory", e), this._strictEncodeArguments("registerModule(address)", [e]);
        }
      }, l.removeModule = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_moduleFactory", e), n = (r = this)._strictEncodeArguments("removeModule(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.removeModule.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_moduleFactory", e), n = (r = this)._strictEncodeArguments("removeModule(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_moduleFactory", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("removeModule(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("removeModule(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_moduleFactory", e), this._strictEncodeArguments("removeModule(address)", [e]);
        }
      }, l.verifyModule = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_moduleFactory", e), n = (r = this)._strictEncodeArguments("verifyModule(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.verifyModule.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_moduleFactory", e), n = (r = this)._strictEncodeArguments("verifyModule(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_moduleFactory", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("verifyModule(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("verifyModule(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_moduleFactory", e), this._strictEncodeArguments("verifyModule(address)", [e]);
        }
      }, l.unverifyModule = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_moduleFactory", e), n = (r = this)._strictEncodeArguments("unverifyModule(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.unverifyModule.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_moduleFactory", e), n = (r = this)._strictEncodeArguments("unverifyModule(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_moduleFactory", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("unverifyModule(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("unverifyModule(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_moduleFactory", e), this._strictEncodeArguments("unverifyModule(address)", [e]);
        }
      }, l.getTagsByTypeAndToken = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isNumberOrBigNumber("_moduleType", e), h.assert.isString("_securityToken", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("getTagsByTypeAndToken(uint8,address)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("getTagsByTypeAndToken(uint8,address)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isNumberOrBigNumber("_moduleType", e), h.assert.isString("_securityToken", t), this._strictEncodeArguments("getTagsByTypeAndToken(uint8,address)", [e, t]);
        }
      }, l.getTagsByType = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isNumberOrBigNumber("_moduleType", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getTagsByType(uint8)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getTagsByType(uint8)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isNumberOrBigNumber("_moduleType", e), this._strictEncodeArguments("getTagsByType(uint8)", [e]);
        }
      }, l.getFactoryDetails = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_factoryAddress", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getFactoryDetails(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getFactoryDetails(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_factoryAddress", e), this._strictEncodeArguments("getFactoryDetails(address)", [e]);
        }
      }, l.getModulesByType = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isNumberOrBigNumber("_moduleType", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getModulesByType(uint8)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getModulesByType(uint8)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isNumberOrBigNumber("_moduleType", e), this._strictEncodeArguments("getModulesByType(uint8)", [e]);
        }
      }, l.getAllModulesByType = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isNumberOrBigNumber("_moduleType", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getAllModulesByType(uint8)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getAllModulesByType(uint8)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isNumberOrBigNumber("_moduleType", e), this._strictEncodeArguments("getAllModulesByType(uint8)", [e]);
        }
      }, l.getModulesByTypeAndToken = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isNumberOrBigNumber("_moduleType", e), h.assert.isString("_securityToken", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("getModulesByTypeAndToken(uint8,address)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("getModulesByTypeAndToken(uint8,address)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isNumberOrBigNumber("_moduleType", e), h.assert.isString("_securityToken", t), this._strictEncodeArguments("getModulesByTypeAndToken(uint8,address)", [e, t]);
        }
      }, l.reclaimERC20 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.reclaimERC20.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenContract", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("reclaimERC20(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_tokenContract", e), this._strictEncodeArguments("reclaimERC20(address)", [e]);
        }
      }, l.pause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.pause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return d = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(d), [2, new p.PolyResponse(d, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return d = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * d), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pause()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pause()", []);
        }
      }, l.unpause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.unpause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return d = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(d), [2, new p.PolyResponse(d, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return d = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * d), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("unpause()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("unpause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("unpause()", []);
        }
      }, l.updateFromRegistry = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("updateFromRegistry()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.updateFromRegistry.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return d = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(d), [2, new p.PolyResponse(d, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("updateFromRegistry()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return d = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * d), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("updateFromRegistry()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("updateFromRegistry()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("updateFromRegistry()", []);
        }
      }, l.transferOwnership = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_newOwner", e), n = (r = this)._strictEncodeArguments("transferOwnership(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.transferOwnership.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_newOwner", e), n = (r = this)._strictEncodeArguments("transferOwnership(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_newOwner", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("transferOwnership(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("transferOwnership(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_newOwner", e), this._strictEncodeArguments("transferOwnership(address)", [e]);
        }
      }, l.owner = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("owner()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("owner()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("owner()", []);
        }
      }, l.isPaused = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("isPaused()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("isPaused()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("isPaused()", []);
        }
      }, l._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, f.classUtils.bindAll(l, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), l;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n) {
      return o(this, void 0, void 0, function () {
        var s, o, c, p, b, y, v, _, g, A;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return h.assert.isHexString("bytecode", e), h.assert.doesConformToSchema("txDefaults", n, d.schemas.txDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), s = f.providerUtils.standardizeOrThrow(r), o = u.BaseContract._lookupConstructorAbi(a), u.BaseContract._formatABIDataItemList(o.inputs, [], u.BaseContract._bigNumberToString), c = new m.utils.Interface(a), p = c.deployFunction, b = p.encode(e, []), y = new l.Web3Wrapper(s), [4, u.BaseContract._applyDefaultsToTxDataAsync({
                data: b
              }, n, y.estimateGasAsync.bind(y))];

            case 1:
              return v = i.sent(), [4, y.sendTransactionAsync(v)];

            case 2:
              return _ = i.sent(), f.logUtils.log("transactionHash: " + _), [4, y.awaitTransactionSuccessAsync(_)];

            case 3:
              return g = i.sent(), f.logUtils.log("ModuleRegistry successfully deployed at " + g.contractAddress), (A = new t(g.contractAddress, s, n)).constructorArgs = [], [2, A];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !0,
        inputs: [{
          name: "_variable",
          type: "bytes32"
        }],
        name: "getBytes32Value",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_variable",
          type: "bytes32"
        }],
        name: "getBytesValue",
        outputs: [{
          name: "",
          type: "bytes"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_variable",
          type: "bytes32"
        }],
        name: "getAddressValue",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_key",
          type: "bytes32"
        }],
        name: "getArrayAddress",
        outputs: [{
          name: "",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_variable",
          type: "bytes32"
        }],
        name: "getBoolValue",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_variable",
          type: "bytes32"
        }],
        name: "getStringValue",
        outputs: [{
          name: "",
          type: "string"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_key",
          type: "bytes32"
        }],
        name: "getArrayBytes32",
        outputs: [{
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_variable",
          type: "bytes32"
        }],
        name: "getUintValue",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_key",
          type: "bytes32"
        }],
        name: "getArrayUint",
        outputs: [{
          name: "",
          type: "uint256[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        inputs: [],
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "constructor"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Pause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Unpause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_moduleFactory",
          type: "address",
          indexed: !0
        }, {
          name: "_securityToken",
          type: "address",
          indexed: !0
        }],
        name: "ModuleUsed",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_moduleFactory",
          type: "address",
          indexed: !0
        }, {
          name: "_owner",
          type: "address",
          indexed: !0
        }],
        name: "ModuleRegistered",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_moduleFactory",
          type: "address",
          indexed: !0
        }],
        name: "ModuleVerified",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_moduleFactory",
          type: "address",
          indexed: !0
        }],
        name: "ModuleUnverified",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_moduleFactory",
          type: "address",
          indexed: !0
        }, {
          name: "_decisionMaker",
          type: "address",
          indexed: !0
        }],
        name: "ModuleRemoved",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "previousOwner",
          type: "address",
          indexed: !0
        }, {
          name: "newOwner",
          type: "address",
          indexed: !0
        }],
        name: "OwnershipTransferred",
        outputs: [],
        type: "event"
      }, {
        constant: !1,
        inputs: [{
          name: "_polymathRegistry",
          type: "address"
        }, {
          name: "_owner",
          type: "address"
        }],
        name: "initialize",
        outputs: [],
        payable: !0,
        stateMutability: "payable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_moduleFactory",
          type: "address"
        }, {
          name: "_isUpgrade",
          type: "bool"
        }],
        name: "useModule",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_moduleFactory",
          type: "address"
        }, {
          name: "_securityToken",
          type: "address"
        }],
        name: "isCompatibleModule",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_moduleFactory",
          type: "address"
        }],
        name: "registerModule",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_moduleFactory",
          type: "address"
        }],
        name: "removeModule",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_moduleFactory",
          type: "address"
        }],
        name: "verifyModule",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_moduleFactory",
          type: "address"
        }],
        name: "unverifyModule",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_moduleType",
          type: "uint8"
        }, {
          name: "_securityToken",
          type: "address"
        }],
        name: "getTagsByTypeAndToken",
        outputs: [{
          name: "",
          type: "bytes32[]"
        }, {
          name: "",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_moduleType",
          type: "uint8"
        }],
        name: "getTagsByType",
        outputs: [{
          name: "",
          type: "bytes32[]"
        }, {
          name: "",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_factoryAddress",
          type: "address"
        }],
        name: "getFactoryDetails",
        outputs: [{
          name: "",
          type: "bool"
        }, {
          name: "",
          type: "address"
        }, {
          name: "",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_moduleType",
          type: "uint8"
        }],
        name: "getModulesByType",
        outputs: [{
          name: "",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_moduleType",
          type: "uint8"
        }],
        name: "getAllModulesByType",
        outputs: [{
          name: "",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_moduleType",
          type: "uint8"
        }, {
          name: "_securityToken",
          type: "address"
        }],
        name: "getModulesByTypeAndToken",
        outputs: [{
          name: "",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenContract",
          type: "address"
        }],
        name: "reclaimERC20",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "pause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "unpause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "updateFromRegistry",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_newOwner",
          type: "address"
        }],
        name: "transferOwnership",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "owner",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "isPaused",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(u.BaseContract);

  t.ModuleRegistryContract_3_0_0 = y, t.isModuleRegistryContract_3_0_0 = function (e) {
    return b.isEqual(y.ABI(), e.abi);
  };
},
/*!************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/ownable.js ***!
  \************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r92,
      n = this && this.__extends || (_r92 = function r(e, t) {
    return (_r92 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r92(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var c = a(
  /*! @0x/base-contract */
  12),
      u = a(
  /*! @0x/json-schemas */
  2),
      d = a(
  /*! @0x/utils */
  8),
      f = a(
  /*! @0x/web3-wrapper */
  11),
      l = a(
  /*! @0x/assert */
  10),
      h = a(
  /*! ../../PolyResponse */
  14),
      p = a(
  /*! lodash */
  0),
      b = a(
  /*! ethers */
  13);
  (t.OwnableEvents_3_0_0 || (t.OwnableEvents_3_0_0 = {})).OwnershipTransferred = "OwnershipTransferred";

  var m = function (e) {
    function t(a, r, n, f) {
      var p = e.call(this, "Ownable", t.ABI(), a, r, n) || this;
      return p.owner = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return l.assert.doesConformToSchema("callData", e, u.schemas.callDataSchema, [u.schemas.addressSchema, u.schemas.numberSchema, u.schemas.jsNumber]), void 0 !== t && l.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("owner()", []), [4, c.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), c.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("owner()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("owner()", []);
        }
      }, p.isOwner = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return l.assert.doesConformToSchema("callData", e, u.schemas.callDataSchema, [u.schemas.addressSchema, u.schemas.numberSchema, u.schemas.jsNumber]), void 0 !== t && l.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("isOwner()", []), [4, c.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), c.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("isOwner()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("isOwner()", []);
        }
      }, p.renounceOwnership = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, u, d, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("renounceOwnership()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, c.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.renounceOwnership.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return d = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(d), [2, new h.PolyResponse(d, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, u, d, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("renounceOwnership()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, c.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return d = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * d), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return l.assert.doesConformToSchema("callData", e, u.schemas.callDataSchema, [u.schemas.addressSchema, u.schemas.numberSchema, u.schemas.jsNumber]), void 0 !== t && l.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("renounceOwnership()", []), [4, c.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), c.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("renounceOwnership()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("renounceOwnership()", []);
        }
      }, p.transferOwnership = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, u, d, f, p;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return l.assert.isString("newOwner", e), n = (r = this)._strictEncodeArguments("transferOwnership(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, c.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: u
                  }, o), r.transferOwnership.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), p = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new h.PolyResponse(f, p)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, u, d, f, h, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return l.assert.isString("newOwner", e), n = (r = this)._strictEncodeArguments("transferOwnership(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, c.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: u
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, h < b ? h : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, d;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return l.assert.isString("newOwner", e), l.assert.doesConformToSchema("callData", t, u.schemas.callDataSchema, [u.schemas.addressSchema, u.schemas.numberSchema, u.schemas.jsNumber]), void 0 !== a && l.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("transferOwnership(address)", [e]), [4, c.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return d = i.sent(), c.BaseContract._throwIfRevertWithReasonCallResult(d), [2, r._lookupAbiEncoder("transferOwnership(address)").strictDecodeReturnValue(d)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return l.assert.isString("newOwner", e), this._strictEncodeArguments("transferOwnership(address)", [e]);
        }
      }, p._defaultEstimateGasFactor = void 0 === f ? 1.1 : f, d.classUtils.bindAll(p, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), p;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n) {
      return o(this, void 0, void 0, function () {
        var s, o, h, p, m, y, v, _, g, A;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return l.assert.isHexString("bytecode", e), l.assert.doesConformToSchema("txDefaults", n, u.schemas.txDataSchema, [u.schemas.addressSchema, u.schemas.numberSchema, u.schemas.jsNumber]), s = d.providerUtils.standardizeOrThrow(r), o = c.BaseContract._lookupConstructorAbi(a), c.BaseContract._formatABIDataItemList(o.inputs, [], c.BaseContract._bigNumberToString), h = new b.utils.Interface(a), p = h.deployFunction, m = p.encode(e, []), y = new f.Web3Wrapper(s), [4, c.BaseContract._applyDefaultsToTxDataAsync({
                data: m
              }, n, y.estimateGasAsync.bind(y))];

            case 1:
              return v = i.sent(), [4, y.sendTransactionAsync(v)];

            case 2:
              return _ = i.sent(), d.logUtils.log("transactionHash: " + _), [4, y.awaitTransactionSuccessAsync(_)];

            case 3:
              return g = i.sent(), d.logUtils.log("Ownable successfully deployed at " + g.contractAddress), (A = new t(g.contractAddress, s, n)).constructorArgs = [], [2, A];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        inputs: [],
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "constructor"
      }, {
        anonymous: !1,
        inputs: [{
          name: "previousOwner",
          type: "address",
          indexed: !0
        }, {
          name: "newOwner",
          type: "address",
          indexed: !0
        }],
        name: "OwnershipTransferred",
        outputs: [],
        type: "event"
      }, {
        constant: !0,
        inputs: [],
        name: "owner",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "isOwner",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "newOwner",
          type: "address"
        }],
        name: "transferOwnership",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(c.BaseContract);

  t.OwnableContract_3_0_0 = m, t.isOwnableContract_3_0_0 = function (e) {
    return p.isEqual(m.ABI(), e.abi);
  };
},
/*!*************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/pausable.js ***!
  \*************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r93,
      n = this && this.__extends || (_r93 = function r(e, t) {
    return (_r93 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r93(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var c,
      u = a(
  /*! @0x/base-contract */
  12),
      d = a(
  /*! @0x/json-schemas */
  2),
      f = a(
  /*! @0x/utils */
  8),
      l = a(
  /*! @0x/web3-wrapper */
  11),
      h = a(
  /*! @0x/assert */
  10),
      p = a(
  /*! lodash */
  0),
      b = a(
  /*! ethers */
  13);
  (c = t.PausableEvents_3_0_0 || (t.PausableEvents_3_0_0 = {})).Pause = "Pause", c.Unpause = "Unpause";

  var m = function (e) {
    function t(a, r, n, c) {
      var l = e.call(this, "Pausable", t.ABI(), a, r, n) || this;
      return l.paused = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("paused()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("paused()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("paused()", []);
        }
      }, l._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, f.classUtils.bindAll(l, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), l;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n) {
      return o(this, void 0, void 0, function () {
        var s, o, c, p, m, y, v, _, g, A;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return h.assert.isHexString("bytecode", e), h.assert.doesConformToSchema("txDefaults", n, d.schemas.txDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), s = f.providerUtils.standardizeOrThrow(r), o = u.BaseContract._lookupConstructorAbi(a), u.BaseContract._formatABIDataItemList(o.inputs, [], u.BaseContract._bigNumberToString), c = new b.utils.Interface(a), p = c.deployFunction, m = p.encode(e, []), y = new l.Web3Wrapper(s), [4, u.BaseContract._applyDefaultsToTxDataAsync({
                data: m
              }, n, y.estimateGasAsync.bind(y))];

            case 1:
              return v = i.sent(), [4, y.sendTransactionAsync(v)];

            case 2:
              return _ = i.sent(), f.logUtils.log("transactionHash: " + _), [4, y.awaitTransactionSuccessAsync(_)];

            case 3:
              return g = i.sent(), f.logUtils.log("Pausable successfully deployed at " + g.contractAddress), (A = new t(g.contractAddress, s, n)).constructorArgs = [], [2, A];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !0,
        inputs: [],
        name: "paused",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Pause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Unpause",
        outputs: [],
        type: "event"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(u.BaseContract);

  t.PausableContract_3_0_0 = m, t.isPausableContract_3_0_0 = function (e) {
    return p.isEqual(m.ABI(), e.abi);
  };
},
/*!********************************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/percentage_transfer_manager.js ***!
  \********************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r94,
      n = this && this.__extends || (_r94 = function r(e, t) {
    return (_r94 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r94(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      c = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || 0 < t--) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u,
      d = a(
  /*! @0x/base-contract */
  12),
      f = a(
  /*! @0x/json-schemas */
  2),
      l = a(
  /*! @0x/utils */
  8),
      h = a(
  /*! @0x/web3-wrapper */
  11),
      p = a(
  /*! @0x/assert */
  10),
      b = a(
  /*! ../../PolyResponse */
  14),
      m = a(
  /*! lodash */
  0),
      y = a(
  /*! ethers */
  13);
  (u = t.PercentageTransferManagerEvents_3_0_0 || (t.PercentageTransferManagerEvents_3_0_0 = {})).ModifyHolderPercentage = "ModifyHolderPercentage", u.ModifyWhitelist = "ModifyWhitelist", u.SetAllowPrimaryIssuance = "SetAllowPrimaryIssuance", u.Pause = "Pause", u.Unpause = "Unpause";

  var v = function (e) {
    function t(a, r, n, c) {
      var u = e.call(this, "PercentageTransferManager", t.ABI(), a, r, n) || this;
      return u.reclaimETH = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.reclaimETH.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("reclaimETH()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("reclaimETH()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("reclaimETH()", []);
        }
      }, u.allowPrimaryIssuance = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("allowPrimaryIssuance()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("allowPrimaryIssuance()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("allowPrimaryIssuance()", []);
        }
      }, u.getTokensByPartition = {
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_partition", e), p.assert.isString("_tokenHolder", t), p.assert.isBigNumber("index_2", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("getTokensByPartition(bytes32,address,uint256)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("getTokensByPartition(bytes32,address,uint256)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isString("_partition", e), p.assert.isString("_tokenHolder", t), p.assert.isBigNumber("index_2", a), this._strictEncodeArguments("getTokensByPartition(bytes32,address,uint256)", [e, t, a]);
        }
      }, u.ADMIN = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("ADMIN()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("ADMIN()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("ADMIN()", []);
        }
      }, u.maxHolderPercentage = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("maxHolderPercentage()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("maxHolderPercentage()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("maxHolderPercentage()", []);
        }
      }, u.unpause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.unpause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("unpause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("unpause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("unpause()", []);
        }
      }, u.paused = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("paused()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("paused()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("paused()", []);
        }
      }, u.UNLOCKED = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("UNLOCKED()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("UNLOCKED()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("UNLOCKED()", []);
        }
      }, u.polyToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("polyToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("polyToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("polyToken()", []);
        }
      }, u.pause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.pause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pause()", []);
        }
      }, u.reclaimERC20 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.reclaimERC20.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("reclaimERC20(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_tokenContract", e), this._strictEncodeArguments("reclaimERC20(address)", [e]);
        }
      }, u.OPERATOR = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("OPERATOR()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("OPERATOR()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("OPERATOR()", []);
        }
      }, u.whitelist = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("whitelist(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("whitelist(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("index_0", e), this._strictEncodeArguments("whitelist(address)", [e]);
        }
      }, u.LOCKED = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("LOCKED()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("LOCKED()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("LOCKED()", []);
        }
      }, u.securityToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("securityToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("securityToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("securityToken()", []);
        }
      }, u.factory = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("factory()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("factory()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("factory()", []);
        }
      }, u.getDataStore = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDataStore()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDataStore()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDataStore()", []);
        }
      }, u.executeTransfer = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), u = (o = this)._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.executeTransfer.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), u = (o = this)._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("executeTransfer(address,address,uint256,bytes)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), this._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]);
        }
      }, u.verifyTransfer = {
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("verifyTransfer(address,address,uint256,bytes)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("verifyTransfer(address,address,uint256,bytes)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), this._strictEncodeArguments("verifyTransfer(address,address,uint256,bytes)", [e, t, a, r]);
        }
      }, u.configure = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maxHolderPercentage", e), p.assert.isBoolean("_allowPrimaryIssuance", t), o = (n = this)._strictEncodeArguments("configure(uint256,bool)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.configure.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maxHolderPercentage", e), p.assert.isBoolean("_allowPrimaryIssuance", t), o = (n = this)._strictEncodeArguments("configure(uint256,bool)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maxHolderPercentage", e), p.assert.isBoolean("_allowPrimaryIssuance", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("configure(uint256,bool)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("configure(uint256,bool)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isBigNumber("_maxHolderPercentage", e), p.assert.isBoolean("_allowPrimaryIssuance", t), this._strictEncodeArguments("configure(uint256,bool)", [e, t]);
        }
      }, u.getInitFunction = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getInitFunction()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getInitFunction()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getInitFunction()", []);
        }
      }, u.changeHolderPercentage = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maxHolderPercentage", e), n = (r = this)._strictEncodeArguments("changeHolderPercentage(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeHolderPercentage.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maxHolderPercentage", e), n = (r = this)._strictEncodeArguments("changeHolderPercentage(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_maxHolderPercentage", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeHolderPercentage(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeHolderPercentage(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_maxHolderPercentage", e), this._strictEncodeArguments("changeHolderPercentage(uint256)", [e]);
        }
      }, u.modifyWhitelist = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.isBoolean("_valid", t), o = (n = this)._strictEncodeArguments("modifyWhitelist(address,bool)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.modifyWhitelist.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.isBoolean("_valid", t), o = (n = this)._strictEncodeArguments("modifyWhitelist(address,bool)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.isBoolean("_valid", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("modifyWhitelist(address,bool)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("modifyWhitelist(address,bool)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_investor", e), p.assert.isBoolean("_valid", t), this._strictEncodeArguments("modifyWhitelist(address,bool)", [e, t]);
        }
      }, u.modifyWhitelistMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isArray("_valids", t), o = (n = this)._strictEncodeArguments("modifyWhitelistMulti(address[],bool[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.modifyWhitelistMulti.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isArray("_valids", t), o = (n = this)._strictEncodeArguments("modifyWhitelistMulti(address[],bool[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isArray("_valids", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("modifyWhitelistMulti(address[],bool[])", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("modifyWhitelistMulti(address[],bool[])").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isArray("_investors", e), p.assert.isArray("_valids", t), this._strictEncodeArguments("modifyWhitelistMulti(address[],bool[])", [e, t]);
        }
      }, u.setAllowPrimaryIssuance = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBoolean("_allowPrimaryIssuance", e), n = (r = this)._strictEncodeArguments("setAllowPrimaryIssuance(bool)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.setAllowPrimaryIssuance.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBoolean("_allowPrimaryIssuance", e), n = (r = this)._strictEncodeArguments("setAllowPrimaryIssuance(bool)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBoolean("_allowPrimaryIssuance", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("setAllowPrimaryIssuance(bool)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("setAllowPrimaryIssuance(bool)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBoolean("_allowPrimaryIssuance", e), this._strictEncodeArguments("setAllowPrimaryIssuance(bool)", [e]);
        }
      }, u.getPermissions = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getPermissions()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getPermissions()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getPermissions()", []);
        }
      }, u._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, l.classUtils.bindAll(u, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), u;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n, s, u) {
      return o(this, void 0, void 0, function () {
        var o, b, m, v, _, g, A, w, T, x, D;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return p.assert.isHexString("bytecode", e), p.assert.doesConformToSchema("txDefaults", n, f.schemas.txDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), o = l.providerUtils.standardizeOrThrow(r), b = d.BaseContract._lookupConstructorAbi(a), D = c(d.BaseContract._formatABIDataItemList(b.inputs, [s, u], d.BaseContract._bigNumberToString), 2), s = D[0], u = D[1], m = new y.utils.Interface(a), v = m.deployFunction, _ = v.encode(e, [s, u]), g = new h.Web3Wrapper(o), [4, d.BaseContract._applyDefaultsToTxDataAsync({
                data: _
              }, n, g.estimateGasAsync.bind(g))];

            case 1:
              return A = i.sent(), [4, g.sendTransactionAsync(A)];

            case 2:
              return w = i.sent(), l.logUtils.log("transactionHash: " + w), [4, g.awaitTransactionSuccessAsync(w)];

            case 3:
              return T = i.sent(), l.logUtils.log("PercentageTransferManager successfully deployed at " + T.contractAddress), (x = new t(T.contractAddress, o, n)).constructorArgs = [s, u], [2, x];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !1,
        inputs: [],
        name: "reclaimETH",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "allowPrimaryIssuance",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_partition",
          type: "bytes32"
        }, {
          name: "_tokenHolder",
          type: "address"
        }, {
          name: "index_2",
          type: "uint256"
        }],
        name: "getTokensByPartition",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "ADMIN",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "maxHolderPercentage",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "unpause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "paused",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "UNLOCKED",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "polyToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "pause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenContract",
          type: "address"
        }],
        name: "reclaimERC20",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "OPERATOR",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "address"
        }],
        name: "whitelist",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "LOCKED",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "securityToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "factory",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDataStore",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        inputs: [{
          name: "_securityToken",
          type: "address"
        }, {
          name: "_polyToken",
          type: "address"
        }],
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "constructor"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_oldHolderPercentage",
          type: "uint256",
          indexed: !1
        }, {
          name: "_newHolderPercentage",
          type: "uint256",
          indexed: !1
        }],
        name: "ModifyHolderPercentage",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_investor",
          type: "address",
          indexed: !1
        }, {
          name: "_addedBy",
          type: "address",
          indexed: !1
        }, {
          name: "_valid",
          type: "bool",
          indexed: !1
        }],
        name: "ModifyWhitelist",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_allowPrimaryIssuance",
          type: "bool",
          indexed: !1
        }],
        name: "SetAllowPrimaryIssuance",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Pause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Unpause",
        outputs: [],
        type: "event"
      }, {
        constant: !1,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "_to",
          type: "address"
        }, {
          name: "_amount",
          type: "uint256"
        }, {
          name: "index_3",
          type: "bytes"
        }],
        name: "executeTransfer",
        outputs: [{
          name: "",
          type: "uint8"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "_to",
          type: "address"
        }, {
          name: "_amount",
          type: "uint256"
        }, {
          name: "index_3",
          type: "bytes"
        }],
        name: "verifyTransfer",
        outputs: [{
          name: "",
          type: "uint8"
        }, {
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_maxHolderPercentage",
          type: "uint256"
        }, {
          name: "_allowPrimaryIssuance",
          type: "bool"
        }],
        name: "configure",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getInitFunction",
        outputs: [{
          name: "",
          type: "bytes4"
        }],
        payable: !1,
        stateMutability: "pure",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_maxHolderPercentage",
          type: "uint256"
        }],
        name: "changeHolderPercentage",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_investor",
          type: "address"
        }, {
          name: "_valid",
          type: "bool"
        }],
        name: "modifyWhitelist",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_investors",
          type: "address[]"
        }, {
          name: "_valids",
          type: "bool[]"
        }],
        name: "modifyWhitelistMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_allowPrimaryIssuance",
          type: "bool"
        }],
        name: "setAllowPrimaryIssuance",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getPermissions",
        outputs: [{
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(d.BaseContract);

  t.PercentageTransferManagerContract_3_0_0 = v, t.isPercentageTransferManagerContract_3_0_0 = function (e) {
    return m.isEqual(v.ABI(), e.abi);
  };
},
/*!**********************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/polymath_registry.js ***!
  \**********************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r95,
      n = this && this.__extends || (_r95 = function r(e, t) {
    return (_r95 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r95(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var c,
      u = a(
  /*! @0x/base-contract */
  12),
      d = a(
  /*! @0x/json-schemas */
  2),
      f = a(
  /*! @0x/utils */
  8),
      l = a(
  /*! @0x/web3-wrapper */
  11),
      h = a(
  /*! @0x/assert */
  10),
      p = a(
  /*! ../../PolyResponse */
  14),
      b = a(
  /*! lodash */
  0),
      m = a(
  /*! ethers */
  13);
  (c = t.PolymathRegistryEvents_3_0_0 || (t.PolymathRegistryEvents_3_0_0 = {})).ChangeAddress = "ChangeAddress", c.OwnershipTransferred = "OwnershipTransferred";

  var y = function (e) {
    function t(a, r, n, c) {
      var l = e.call(this, "PolymathRegistry", t.ABI(), a, r, n) || this;
      return l.storedAddresses = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("index_0", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("storedAddresses(bytes32)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("storedAddresses(bytes32)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("index_0", e), this._strictEncodeArguments("storedAddresses(bytes32)", [e]);
        }
      }, l.renounceOwnership = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("renounceOwnership()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.renounceOwnership.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return d = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(d), [2, new p.PolyResponse(d, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("renounceOwnership()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return d = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * d), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("renounceOwnership()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("renounceOwnership()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("renounceOwnership()", []);
        }
      }, l.reclaimERC20 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.reclaimERC20.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenContract", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("reclaimERC20(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_tokenContract", e), this._strictEncodeArguments("reclaimERC20(address)", [e]);
        }
      }, l.owner = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("owner()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("owner()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("owner()", []);
        }
      }, l.isOwner = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("isOwner()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("isOwner()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("isOwner()", []);
        }
      }, l.transferOwnership = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("newOwner", e), n = (r = this)._strictEncodeArguments("transferOwnership(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.transferOwnership.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("newOwner", e), n = (r = this)._strictEncodeArguments("transferOwnership(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("newOwner", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("transferOwnership(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("transferOwnership(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("newOwner", e), this._strictEncodeArguments("transferOwnership(address)", [e]);
        }
      }, l.getAddress = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_nameKey", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getAddress(string)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getAddress(string)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_nameKey", e), this._strictEncodeArguments("getAddress(string)", [e]);
        }
      }, l.changeAddress = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_nameKey", e), h.assert.isString("_newAddress", t), o = (n = this)._strictEncodeArguments("changeAddress(string,address)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: d
                  }, c), n.changeAddress.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), b = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new p.PolyResponse(l, b)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_nameKey", e), h.assert.isString("_newAddress", t), o = (n = this)._strictEncodeArguments("changeAddress(string,address)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: d
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return p = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, p < m ? p : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_nameKey", e), h.assert.isString("_newAddress", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("changeAddress(string,address)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("changeAddress(string,address)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("_nameKey", e), h.assert.isString("_newAddress", t), this._strictEncodeArguments("changeAddress(string,address)", [e, t]);
        }
      }, l._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, f.classUtils.bindAll(l, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), l;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n) {
      return o(this, void 0, void 0, function () {
        var s, o, c, p, b, y, v, _, g, A;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return h.assert.isHexString("bytecode", e), h.assert.doesConformToSchema("txDefaults", n, d.schemas.txDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), s = f.providerUtils.standardizeOrThrow(r), o = u.BaseContract._lookupConstructorAbi(a), u.BaseContract._formatABIDataItemList(o.inputs, [], u.BaseContract._bigNumberToString), c = new m.utils.Interface(a), p = c.deployFunction, b = p.encode(e, []), y = new l.Web3Wrapper(s), [4, u.BaseContract._applyDefaultsToTxDataAsync({
                data: b
              }, n, y.estimateGasAsync.bind(y))];

            case 1:
              return v = i.sent(), [4, y.sendTransactionAsync(v)];

            case 2:
              return _ = i.sent(), f.logUtils.log("transactionHash: " + _), [4, y.awaitTransactionSuccessAsync(_)];

            case 3:
              return g = i.sent(), f.logUtils.log("PolymathRegistry successfully deployed at " + g.contractAddress), (A = new t(g.contractAddress, s, n)).constructorArgs = [], [2, A];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "bytes32"
        }],
        name: "storedAddresses",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenContract",
          type: "address"
        }],
        name: "reclaimERC20",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "owner",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "isOwner",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "newOwner",
          type: "address"
        }],
        name: "transferOwnership",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_nameKey",
          type: "string",
          indexed: !1
        }, {
          name: "_oldAddress",
          type: "address",
          indexed: !0
        }, {
          name: "_newAddress",
          type: "address",
          indexed: !0
        }],
        name: "ChangeAddress",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "previousOwner",
          type: "address",
          indexed: !0
        }, {
          name: "newOwner",
          type: "address",
          indexed: !0
        }],
        name: "OwnershipTransferred",
        outputs: [],
        type: "event"
      }, {
        constant: !0,
        inputs: [{
          name: "_nameKey",
          type: "string"
        }],
        name: "getAddress",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_nameKey",
          type: "string"
        }, {
          name: "_newAddress",
          type: "address"
        }],
        name: "changeAddress",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(u.BaseContract);

  t.PolymathRegistryContract_3_0_0 = y, t.isPolymathRegistryContract_3_0_0 = function (e) {
    return b.isEqual(y.ABI(), e.abi);
  };
},
/*!***************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/poly_token.js ***!
  \***************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r96,
      n = this && this.__extends || (_r96 = function r(e, t) {
    return (_r96 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r96(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      c = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || 0 < t--) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u,
      d = a(
  /*! @0x/base-contract */
  12),
      f = a(
  /*! @0x/json-schemas */
  2),
      l = a(
  /*! @0x/utils */
  8),
      h = a(
  /*! @0x/web3-wrapper */
  11),
      p = a(
  /*! @0x/assert */
  10),
      b = a(
  /*! ../../PolyResponse */
  14),
      m = a(
  /*! lodash */
  0),
      y = a(
  /*! ethers */
  13);
  (u = t.PolyTokenEvents_3_0_0 || (t.PolyTokenEvents_3_0_0 = {})).Transfer = "Transfer", u.Approval = "Approval";

  var v = function (e) {
    function t(a, r, n, c) {
      var u = e.call(this, "PolyToken", t.ABI(), a, r, n) || this;
      return u.name = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("name()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("name()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("name()", []);
        }
      }, u.totalSupply = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("totalSupply()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("totalSupply()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("totalSupply()", []);
        }
      }, u.decimals = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("decimals()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("decimals()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("decimals()", []);
        }
      }, u.decimalFactor = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("decimalFactor()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("decimalFactor()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("decimalFactor()", []);
        }
      }, u.symbol = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("symbol()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("symbol()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("symbol()", []);
        }
      }, u.balanceOf = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_owner", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("balanceOf(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("balanceOf(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_owner", e), this._strictEncodeArguments("balanceOf(address)", [e]);
        }
      }, u.allowance = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_owner", e), p.assert.isString("_spender", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("allowance(address,address)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("allowance(address,address)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_owner", e), p.assert.isString("_spender", t), this._strictEncodeArguments("allowance(address,address)", [e, t]);
        }
      }, u.transfer = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_to", e), p.assert.isBigNumber("_value", t), o = (n = this)._strictEncodeArguments("transfer(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.transfer.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_to", e), p.assert.isBigNumber("_value", t), o = (n = this)._strictEncodeArguments("transfer(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_to", e), p.assert.isBigNumber("_value", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("transfer(address,uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("transfer(address,uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_to", e), p.assert.isBigNumber("_value", t), this._strictEncodeArguments("transfer(address,uint256)", [e, t]);
        }
      }, u.transferFrom = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("_value", a), c = (o = this)._strictEncodeArguments("transferFrom(address,address,uint256)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.transferFrom.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("_value", a), c = (o = this)._strictEncodeArguments("transferFrom(address,address,uint256)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("_value", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("transferFrom(address,address,uint256)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("transferFrom(address,address,uint256)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("_value", a), this._strictEncodeArguments("transferFrom(address,address,uint256)", [e, t, a]);
        }
      }, u.approve = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_spender", e), p.assert.isBigNumber("_value", t), o = (n = this)._strictEncodeArguments("approve(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.approve.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_spender", e), p.assert.isBigNumber("_value", t), o = (n = this)._strictEncodeArguments("approve(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_spender", e), p.assert.isBigNumber("_value", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("approve(address,uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("approve(address,uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_spender", e), p.assert.isBigNumber("_value", t), this._strictEncodeArguments("approve(address,uint256)", [e, t]);
        }
      }, u.increaseApproval = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_spender", e), p.assert.isBigNumber("_addedValue", t), o = (n = this)._strictEncodeArguments("increaseApproval(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.increaseApproval.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_spender", e), p.assert.isBigNumber("_addedValue", t), o = (n = this)._strictEncodeArguments("increaseApproval(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_spender", e), p.assert.isBigNumber("_addedValue", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("increaseApproval(address,uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("increaseApproval(address,uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_spender", e), p.assert.isBigNumber("_addedValue", t), this._strictEncodeArguments("increaseApproval(address,uint256)", [e, t]);
        }
      }, u.decreaseApproval = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_spender", e), p.assert.isBigNumber("_subtractedValue", t), o = (n = this)._strictEncodeArguments("decreaseApproval(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.decreaseApproval.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_spender", e), p.assert.isBigNumber("_subtractedValue", t), o = (n = this)._strictEncodeArguments("decreaseApproval(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_spender", e), p.assert.isBigNumber("_subtractedValue", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("decreaseApproval(address,uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("decreaseApproval(address,uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_spender", e), p.assert.isBigNumber("_subtractedValue", t), this._strictEncodeArguments("decreaseApproval(address,uint256)", [e, t]);
        }
      }, u._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, l.classUtils.bindAll(u, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), u;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n, s) {
      return o(this, void 0, void 0, function () {
        var o, u, b, m, v, _, g, A, w, T, x;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return p.assert.isHexString("bytecode", e), p.assert.doesConformToSchema("txDefaults", n, f.schemas.txDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), o = l.providerUtils.standardizeOrThrow(r), u = d.BaseContract._lookupConstructorAbi(a), x = c(d.BaseContract._formatABIDataItemList(u.inputs, [s], d.BaseContract._bigNumberToString), 1), s = x[0], b = new y.utils.Interface(a), m = b.deployFunction, v = m.encode(e, [s]), _ = new h.Web3Wrapper(o), [4, d.BaseContract._applyDefaultsToTxDataAsync({
                data: v
              }, n, _.estimateGasAsync.bind(_))];

            case 1:
              return g = i.sent(), [4, _.sendTransactionAsync(g)];

            case 2:
              return A = i.sent(), l.logUtils.log("transactionHash: " + A), [4, _.awaitTransactionSuccessAsync(A)];

            case 3:
              return w = i.sent(), l.logUtils.log("PolyToken successfully deployed at " + w.contractAddress), (T = new t(w.contractAddress, o, n)).constructorArgs = [s], [2, T];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !0,
        inputs: [],
        name: "name",
        outputs: [{
          name: "",
          type: "string"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "totalSupply",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "decimals",
        outputs: [{
          name: "",
          type: "uint8"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "decimalFactor",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "symbol",
        outputs: [{
          name: "",
          type: "string"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        inputs: [{
          name: "_polyDistributionContractAddress",
          type: "address"
        }],
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "constructor"
      }, {
        anonymous: !1,
        inputs: [{
          name: "from",
          type: "address",
          indexed: !0
        }, {
          name: "to",
          type: "address",
          indexed: !0
        }, {
          name: "value",
          type: "uint256",
          indexed: !1
        }],
        name: "Transfer",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "owner",
          type: "address",
          indexed: !0
        }, {
          name: "spender",
          type: "address",
          indexed: !0
        }, {
          name: "value",
          type: "uint256",
          indexed: !1
        }],
        name: "Approval",
        outputs: [],
        type: "event"
      }, {
        constant: !0,
        inputs: [{
          name: "_owner",
          type: "address"
        }],
        name: "balanceOf",
        outputs: [{
          name: "balance",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_owner",
          type: "address"
        }, {
          name: "_spender",
          type: "address"
        }],
        name: "allowance",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_to",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }],
        name: "transfer",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "_to",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }],
        name: "transferFrom",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_spender",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }],
        name: "approve",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_spender",
          type: "address"
        }, {
          name: "_addedValue",
          type: "uint256"
        }],
        name: "increaseApproval",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_spender",
          type: "address"
        }, {
          name: "_subtractedValue",
          type: "uint256"
        }],
        name: "decreaseApproval",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(d.BaseContract);

  t.PolyTokenContract_3_0_0 = v, t.isPolyTokenContract_3_0_0 = function (e) {
    return m.isEqual(v.ABI(), e.abi);
  };
},
/*!**********************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/poly_token_faucet.js ***!
  \**********************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r97,
      n = this && this.__extends || (_r97 = function r(e, t) {
    return (_r97 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r97(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var c,
      u = a(
  /*! @0x/base-contract */
  12),
      d = a(
  /*! @0x/json-schemas */
  2),
      f = a(
  /*! @0x/utils */
  8),
      l = a(
  /*! @0x/web3-wrapper */
  11),
      h = a(
  /*! @0x/assert */
  10),
      p = a(
  /*! ../../PolyResponse */
  14),
      b = a(
  /*! lodash */
  0),
      m = a(
  /*! ethers */
  13);
  (c = t.PolyTokenFaucetEvents_3_0_0 || (t.PolyTokenFaucetEvents_3_0_0 = {})).Transfer = "Transfer", c.Approval = "Approval";

  var y = function (e) {
    function t(a, r, n, c) {
      var l = e.call(this, "PolyTokenFaucet", t.ABI(), a, r, n) || this;
      return l.name = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("name()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("name()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("name()", []);
        }
      }, l.decimals = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("decimals()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("decimals()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("decimals()", []);
        }
      }, l.symbol = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("symbol()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("symbol()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("symbol()", []);
        }
      }, l.getTokens = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_amount", e), h.assert.isString("_recipient", t), o = (n = this)._strictEncodeArguments("getTokens(uint256,address)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: d
                  }, c), n.getTokens.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), b = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new p.PolyResponse(l, b)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_amount", e), h.assert.isString("_recipient", t), o = (n = this)._strictEncodeArguments("getTokens(uint256,address)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: d
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return p = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, p < m ? p : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isBigNumber("_amount", e), h.assert.isString("_recipient", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("getTokens(uint256,address)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("getTokens(uint256,address)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isBigNumber("_amount", e), h.assert.isString("_recipient", t), this._strictEncodeArguments("getTokens(uint256,address)", [e, t]);
        }
      }, l.transfer = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_to", e), h.assert.isBigNumber("_value", t), o = (n = this)._strictEncodeArguments("transfer(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: d
                  }, c), n.transfer.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), b = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new p.PolyResponse(l, b)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_to", e), h.assert.isBigNumber("_value", t), o = (n = this)._strictEncodeArguments("transfer(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: d
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return p = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, p < m ? p : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_to", e), h.assert.isBigNumber("_value", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("transfer(address,uint256)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("transfer(address,uint256)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("_to", e), h.assert.isBigNumber("_value", t), this._strictEncodeArguments("transfer(address,uint256)", [e, t]);
        }
      }, l.transferFrom = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_from", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), c = (o = this)._strictEncodeArguments("transferFrom(address,address,uint256)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, d), o.transferFrom.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return b = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(b), [2, new p.PolyResponse(b, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, d, f, l, p, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_from", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), c = (o = this)._strictEncodeArguments("transferFrom(address,address,uint256)", [e, t, a]), d = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, d))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return p = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * p), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_from", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), h.assert.doesConformToSchema("callData", r, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== n && h.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("transferFrom(address,address,uint256)", [e, t, a]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (f = i.sent()).from = f.from ? f.from.toLowerCase() : f.from, [4, o._web3Wrapper.callAsync(f, n)];

                case 2:
                  return l = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("transferFrom(address,address,uint256)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return h.assert.isString("_from", e), h.assert.isString("_to", t), h.assert.isBigNumber("_value", a), this._strictEncodeArguments("transferFrom(address,address,uint256)", [e, t, a]);
        }
      }, l.balanceOf = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_owner", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("balanceOf(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("balanceOf(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_owner", e), this._strictEncodeArguments("balanceOf(address)", [e]);
        }
      }, l.approve = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_spender", e), h.assert.isBigNumber("_value", t), o = (n = this)._strictEncodeArguments("approve(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: d
                  }, c), n.approve.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), b = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new p.PolyResponse(l, b)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_spender", e), h.assert.isBigNumber("_value", t), o = (n = this)._strictEncodeArguments("approve(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: d
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return p = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, p < m ? p : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_spender", e), h.assert.isBigNumber("_value", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("approve(address,uint256)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("approve(address,uint256)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("_spender", e), h.assert.isBigNumber("_value", t), this._strictEncodeArguments("approve(address,uint256)", [e, t]);
        }
      }, l.allowance = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_owner", e), h.assert.isString("_spender", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("allowance(address,address)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("allowance(address,address)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("_owner", e), h.assert.isString("_spender", t), this._strictEncodeArguments("allowance(address,address)", [e, t]);
        }
      }, l.totalSupply = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("totalSupply()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("totalSupply()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("totalSupply()", []);
        }
      }, l.increaseApproval = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_spender", e), h.assert.isBigNumber("_addedValue", t), o = (n = this)._strictEncodeArguments("increaseApproval(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: d
                  }, c), n.increaseApproval.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), b = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new p.PolyResponse(l, b)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_spender", e), h.assert.isBigNumber("_addedValue", t), o = (n = this)._strictEncodeArguments("increaseApproval(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: d
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return p = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, p < m ? p : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_spender", e), h.assert.isBigNumber("_addedValue", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("increaseApproval(address,uint256)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("increaseApproval(address,uint256)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("_spender", e), h.assert.isBigNumber("_addedValue", t), this._strictEncodeArguments("increaseApproval(address,uint256)", [e, t]);
        }
      }, l.decreaseApproval = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_spender", e), h.assert.isBigNumber("_subtractedValue", t), o = (n = this)._strictEncodeArguments("decreaseApproval(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: d
                  }, c), n.decreaseApproval.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), b = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new p.PolyResponse(l, b)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, d, f, l, p, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_spender", e), h.assert.isBigNumber("_subtractedValue", t), o = (n = this)._strictEncodeArguments("decreaseApproval(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return d = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: d
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return p = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, p < m ? p : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_spender", e), h.assert.isBigNumber("_subtractedValue", t), h.assert.doesConformToSchema("callData", a, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== r && h.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("decreaseApproval(address,uint256)", [e, t]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return f = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(f), [2, n._lookupAbiEncoder("decreaseApproval(address,uint256)").strictDecodeReturnValue(f)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return h.assert.isString("_spender", e), h.assert.isBigNumber("_subtractedValue", t), this._strictEncodeArguments("decreaseApproval(address,uint256)", [e, t]);
        }
      }, l._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, f.classUtils.bindAll(l, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), l;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n) {
      return o(this, void 0, void 0, function () {
        var s, o, c, p, b, y, v, _, g, A;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return h.assert.isHexString("bytecode", e), h.assert.doesConformToSchema("txDefaults", n, d.schemas.txDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), s = f.providerUtils.standardizeOrThrow(r), o = u.BaseContract._lookupConstructorAbi(a), u.BaseContract._formatABIDataItemList(o.inputs, [], u.BaseContract._bigNumberToString), c = new m.utils.Interface(a), p = c.deployFunction, b = p.encode(e, []), y = new l.Web3Wrapper(s), [4, u.BaseContract._applyDefaultsToTxDataAsync({
                data: b
              }, n, y.estimateGasAsync.bind(y))];

            case 1:
              return v = i.sent(), [4, y.sendTransactionAsync(v)];

            case 2:
              return _ = i.sent(), f.logUtils.log("transactionHash: " + _), [4, y.awaitTransactionSuccessAsync(_)];

            case 3:
              return g = i.sent(), f.logUtils.log("PolyTokenFaucet successfully deployed at " + g.contractAddress), (A = new t(g.contractAddress, s, n)).constructorArgs = [], [2, A];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !0,
        inputs: [],
        name: "name",
        outputs: [{
          name: "",
          type: "string"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "decimals",
        outputs: [{
          name: "",
          type: "uint8"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "symbol",
        outputs: [{
          name: "",
          type: "string"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        inputs: [],
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "constructor"
      }, {
        anonymous: !1,
        inputs: [{
          name: "from",
          type: "address",
          indexed: !0
        }, {
          name: "to",
          type: "address",
          indexed: !0
        }, {
          name: "value",
          type: "uint256",
          indexed: !1
        }],
        name: "Transfer",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "owner",
          type: "address",
          indexed: !0
        }, {
          name: "spender",
          type: "address",
          indexed: !0
        }, {
          name: "value",
          type: "uint256",
          indexed: !1
        }],
        name: "Approval",
        outputs: [],
        type: "event"
      }, {
        constant: !1,
        inputs: [{
          name: "_amount",
          type: "uint256"
        }, {
          name: "_recipient",
          type: "address"
        }],
        name: "getTokens",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_to",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }],
        name: "transfer",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "_to",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }],
        name: "transferFrom",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_owner",
          type: "address"
        }],
        name: "balanceOf",
        outputs: [{
          name: "balance",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_spender",
          type: "address"
        }, {
          name: "_value",
          type: "uint256"
        }],
        name: "approve",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_owner",
          type: "address"
        }, {
          name: "_spender",
          type: "address"
        }],
        name: "allowance",
        outputs: [{
          name: "remaining",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "totalSupply",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_spender",
          type: "address"
        }, {
          name: "_addedValue",
          type: "uint256"
        }],
        name: "increaseApproval",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_spender",
          type: "address"
        }, {
          name: "_subtractedValue",
          type: "uint256"
        }],
        name: "decreaseApproval",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(u.BaseContract);

  t.PolyTokenFaucetContract_3_0_0 = y, t.isPolyTokenFaucetContract_3_0_0 = function (e) {
    return b.isEqual(y.ABI(), e.abi);
  };
},
/*!********************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/sto.js ***!
  \********************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r98,
      n = this && this.__extends || (_r98 = function r(e, t) {
    return (_r98 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r98(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var c,
      u = a(
  /*! @0x/base-contract */
  12),
      d = a(
  /*! @0x/json-schemas */
  2),
      f = a(
  /*! @0x/utils */
  8),
      l = a(
  /*! @0x/web3-wrapper */
  11),
      h = a(
  /*! @0x/assert */
  10),
      p = a(
  /*! ../../PolyResponse */
  14),
      b = a(
  /*! lodash */
  0),
      m = a(
  /*! ethers */
  13);
  (c = t.STOEvents_3_0_0 || (t.STOEvents_3_0_0 = {})).Pause = "Pause", c.Unpause = "Unpause", c.SetFundRaiseTypes = "SetFundRaiseTypes";

  var y = function (e) {
    function t(a, r, n, c) {
      var l = e.call(this, "STO", t.ABI(), a, r, n) || this;
      return l.reclaimETH = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.reclaimETH.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return d = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(d), [2, new p.PolyResponse(d, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return d = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * d), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("reclaimETH()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("reclaimETH()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("reclaimETH()", []);
        }
      }, l.getInitFunction = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getInitFunction()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getInitFunction()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getInitFunction()", []);
        }
      }, l.ADMIN = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("ADMIN()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("ADMIN()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("ADMIN()", []);
        }
      }, l.endTime = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("endTime()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("endTime()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("endTime()", []);
        }
      }, l.unpause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.unpause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return d = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(d), [2, new p.PolyResponse(d, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return d = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * d), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("unpause()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("unpause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("unpause()", []);
        }
      }, l.wallet = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("wallet()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("wallet()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("wallet()", []);
        }
      }, l.paused = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("paused()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("paused()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("paused()", []);
        }
      }, l.totalTokensSold = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("totalTokensSold()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("totalTokensSold()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("totalTokensSold()", []);
        }
      }, l.polyToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("polyToken()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("polyToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("polyToken()", []);
        }
      }, l.startTime = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("startTime()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("startTime()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("startTime()", []);
        }
      }, l.reclaimERC20 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.reclaimERC20.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenContract", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("reclaimERC20(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_tokenContract", e), this._strictEncodeArguments("reclaimERC20(address)", [e]);
        }
      }, l.OPERATOR = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("OPERATOR()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("OPERATOR()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("OPERATOR()", []);
        }
      }, l.pausedTime = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pausedTime()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pausedTime()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pausedTime()", []);
        }
      }, l.securityToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("securityToken()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("securityToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("securityToken()", []);
        }
      }, l.getPermissions = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getPermissions()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getPermissions()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getPermissions()", []);
        }
      }, l.factory = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("factory()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("factory()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("factory()", []);
        }
      }, l.fundsRaised = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isNumberOrBigNumber("index_0", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("fundsRaised(uint8)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("fundsRaised(uint8)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isNumberOrBigNumber("index_0", e), this._strictEncodeArguments("fundsRaised(uint8)", [e]);
        }
      }, l.fundRaiseTypes = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isNumberOrBigNumber("index_0", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("fundRaiseTypes(uint8)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("fundRaiseTypes(uint8)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isNumberOrBigNumber("index_0", e), this._strictEncodeArguments("fundRaiseTypes(uint8)", [e]);
        }
      }, l.investorCount = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("investorCount()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("investorCount()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("investorCount()", []);
        }
      }, l.getDataStore = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDataStore()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDataStore()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDataStore()", []);
        }
      }, l.getRaised = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isNumberOrBigNumber("_fundRaiseType", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getRaised(uint8)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getRaised(uint8)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isNumberOrBigNumber("_fundRaiseType", e), this._strictEncodeArguments("getRaised(uint8)", [e]);
        }
      }, l.getTokensSold = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getTokensSold()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getTokensSold()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getTokensSold()", []);
        }
      }, l.pause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.pause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return d = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(d), [2, new p.PolyResponse(d, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return d = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * d), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pause()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pause()", []);
        }
      }, l._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, f.classUtils.bindAll(l, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), l;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n) {
      return o(this, void 0, void 0, function () {
        var s, o, c, p, b, y, v, _, g, A;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return h.assert.isHexString("bytecode", e), h.assert.doesConformToSchema("txDefaults", n, d.schemas.txDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), s = f.providerUtils.standardizeOrThrow(r), o = u.BaseContract._lookupConstructorAbi(a), u.BaseContract._formatABIDataItemList(o.inputs, [], u.BaseContract._bigNumberToString), c = new m.utils.Interface(a), p = c.deployFunction, b = p.encode(e, []), y = new l.Web3Wrapper(s), [4, u.BaseContract._applyDefaultsToTxDataAsync({
                data: b
              }, n, y.estimateGasAsync.bind(y))];

            case 1:
              return v = i.sent(), [4, y.sendTransactionAsync(v)];

            case 2:
              return _ = i.sent(), f.logUtils.log("transactionHash: " + _), [4, y.awaitTransactionSuccessAsync(_)];

            case 3:
              return g = i.sent(), f.logUtils.log("STO successfully deployed at " + g.contractAddress), (A = new t(g.contractAddress, s, n)).constructorArgs = [], [2, A];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !1,
        inputs: [],
        name: "reclaimETH",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getInitFunction",
        outputs: [{
          name: "initFunction",
          type: "bytes4"
        }],
        payable: !1,
        stateMutability: "pure",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "ADMIN",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "endTime",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "unpause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "wallet",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "paused",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "totalTokensSold",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "polyToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "startTime",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenContract",
          type: "address"
        }],
        name: "reclaimERC20",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "OPERATOR",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "pausedTime",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "securityToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getPermissions",
        outputs: [{
          name: "permissions",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "factory",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "uint8"
        }],
        name: "fundsRaised",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "uint8"
        }],
        name: "fundRaiseTypes",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "investorCount",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDataStore",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Pause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Unpause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_fundRaiseTypes",
          type: "uint8[]",
          indexed: !1
        }],
        name: "SetFundRaiseTypes",
        outputs: [],
        type: "event"
      }, {
        constant: !0,
        inputs: [{
          name: "_fundRaiseType",
          type: "uint8"
        }],
        name: "getRaised",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getTokensSold",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "pause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(u.BaseContract);

  t.STOContract_3_0_0 = y, t.isSTOContract_3_0_0 = function (e) {
    return b.isEqual(y.ABI(), e.abi);
  };
},
/*!***********************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/u_s_d_tiered_s_t_o.js ***!
  \***********************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r99,
      n = this && this.__extends || (_r99 = function r(e, t) {
    return (_r99 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r99(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      c = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || 0 < t--) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u,
      d = a(
  /*! @0x/base-contract */
  12),
      f = a(
  /*! @0x/json-schemas */
  2),
      l = a(
  /*! @0x/utils */
  8),
      h = a(
  /*! @0x/web3-wrapper */
  11),
      p = a(
  /*! @0x/assert */
  10),
      b = a(
  /*! ../../PolyResponse */
  14),
      m = a(
  /*! lodash */
  0),
      y = a(
  /*! ethers */
  13);
  (u = t.USDTieredSTOEvents_3_0_0 || (t.USDTieredSTOEvents_3_0_0 = {})).SetAllowBeneficialInvestments = "SetAllowBeneficialInvestments", u.SetNonAccreditedLimit = "SetNonAccreditedLimit", u.TokenPurchase = "TokenPurchase", u.FundsReceived = "FundsReceived", u.ReserveTokenMint = "ReserveTokenMint", u.SetAddresses = "SetAddresses", u.SetLimits = "SetLimits", u.SetTimes = "SetTimes", u.SetTiers = "SetTiers", u.SetTreasuryWallet = "SetTreasuryWallet", u.Pause = "Pause", u.Unpause = "Unpause", u.SetFundRaiseTypes = "SetFundRaiseTypes";

  var v = function (e) {
    function t(a, r, n, c) {
      var u = e.call(this, "USDTieredSTO", t.ABI(), a, r, n) || this;
      return u.tiers = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("tiers(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("tiers(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("index_0", e), this._strictEncodeArguments("tiers(uint256)", [e]);
        }
      }, u.reclaimETH = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.reclaimETH.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("reclaimETH()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("reclaimETH()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("reclaimETH()", []);
        }
      }, u.ADMIN = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("ADMIN()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("ADMIN()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("ADMIN()", []);
        }
      }, u.allowBeneficialInvestments = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("allowBeneficialInvestments()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("allowBeneficialInvestments()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("allowBeneficialInvestments()", []);
        }
      }, u.endTime = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("endTime()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("endTime()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("endTime()", []);
        }
      }, u.unpause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.unpause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("unpause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("unpause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("unpause()", []);
        }
      }, u.treasuryWallet = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("treasuryWallet()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("treasuryWallet()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("treasuryWallet()", []);
        }
      }, u.nonAccreditedLimitUSD = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("nonAccreditedLimitUSD()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("nonAccreditedLimitUSD()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("nonAccreditedLimitUSD()", []);
        }
      }, u.wallet = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("wallet()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("wallet()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("wallet()", []);
        }
      }, u.paused = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("paused()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("paused()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("paused()", []);
        }
      }, u.totalTokensSold = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("totalTokensSold()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("totalTokensSold()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("totalTokensSold()", []);
        }
      }, u.finalAmountReturned = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("finalAmountReturned()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("finalAmountReturned()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("finalAmountReturned()", []);
        }
      }, u.polyToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("polyToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("polyToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("polyToken()", []);
        }
      }, u.stableCoinsRaised = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("stableCoinsRaised(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("stableCoinsRaised(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("index_0", e), this._strictEncodeArguments("stableCoinsRaised(address)", [e]);
        }
      }, u.startTime = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("startTime()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("startTime()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("startTime()", []);
        }
      }, u.pause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.pause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pause()", []);
        }
      }, u.investorInvested = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("index_0", e), p.assert.isNumberOrBigNumber("index_1", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("investorInvested(address,uint8)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("investorInvested(address,uint8)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("index_0", e), p.assert.isNumberOrBigNumber("index_1", t), this._strictEncodeArguments("investorInvested(address,uint8)", [e, t]);
        }
      }, u.reclaimERC20 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.reclaimERC20.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("reclaimERC20(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_tokenContract", e), this._strictEncodeArguments("reclaimERC20(address)", [e]);
        }
      }, u.isFinalized = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("isFinalized()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("isFinalized()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("isFinalized()", []);
        }
      }, u.OPERATOR = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("OPERATOR()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("OPERATOR()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("OPERATOR()", []);
        }
      }, u.getRaised = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_fundRaiseType", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getRaised(uint8)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getRaised(uint8)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isNumberOrBigNumber("_fundRaiseType", e), this._strictEncodeArguments("getRaised(uint8)", [e]);
        }
      }, u.pausedTime = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pausedTime()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pausedTime()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pausedTime()", []);
        }
      }, u.securityToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("securityToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("securityToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("securityToken()", []);
        }
      }, u.factory = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("factory()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("factory()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("factory()", []);
        }
      }, u.fundsRaised = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("fundsRaised(uint8)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("fundsRaised(uint8)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isNumberOrBigNumber("index_0", e), this._strictEncodeArguments("fundsRaised(uint8)", [e]);
        }
      }, u.investorInvestedUSD = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("investorInvestedUSD(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("investorInvestedUSD(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("index_0", e), this._strictEncodeArguments("investorInvestedUSD(address)", [e]);
        }
      }, u.fundRaiseTypes = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("fundRaiseTypes(uint8)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("fundRaiseTypes(uint8)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isNumberOrBigNumber("index_0", e), this._strictEncodeArguments("fundRaiseTypes(uint8)", [e]);
        }
      }, u.currentTier = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("currentTier()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("currentTier()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("currentTier()", []);
        }
      }, u.investorCount = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("investorCount()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("investorCount()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("investorCount()", []);
        }
      }, u.nonAccreditedLimitUSDOverride = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("nonAccreditedLimitUSDOverride(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("nonAccreditedLimitUSDOverride(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("index_0", e), this._strictEncodeArguments("nonAccreditedLimitUSDOverride(address)", [e]);
        }
      }, u.minimumInvestmentUSD = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("minimumInvestmentUSD()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("minimumInvestmentUSD()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("minimumInvestmentUSD()", []);
        }
      }, u.getDataStore = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDataStore()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDataStore()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDataStore()", []);
        }
      }, u.fundsRaisedUSD = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("fundsRaisedUSD()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("fundsRaisedUSD()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("fundsRaisedUSD()", []);
        }
      }, u.configure = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u, f, l, h, m, y, v, _) {
          return o(this, void 0, void 0, function () {
            var o, g, A, w, T, x, D;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), p.assert.isArray("_ratePerTier", a), p.assert.isArray("_ratePerTierDiscountPoly", r), p.assert.isArray("_tokensPerTierTotal", n), p.assert.isArray("_tokensPerTierDiscountPoly", c), p.assert.isBigNumber("_nonAccreditedLimitUSD", u), p.assert.isBigNumber("_minimumInvestmentUSD", f), p.assert.isArray("_fundRaiseTypes", l), p.assert.isString("_wallet", h), p.assert.isString("_treasuryWallet", m), p.assert.isArray("_usdTokens", y), g = (o = this)._strictEncodeArguments("configure(uint256,uint256,uint256[],uint256[],uint256[],uint256[],uint256,uint256,uint8[],address,address,address[])", [e, t, a, r, n, c, u, f, l, h, m, y]), A = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return w = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, v, {
                    data: g
                  }), s({
                    from: w
                  }, A), o.configure.estimateGasAsync.bind(o, e, t, a, r, n, c, u, f, l, h, m, y, _))];

                case 2:
                  return void 0 !== (T = i.sent()).from && (T.from = T.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(T)];

                case 3:
                  return x = i.sent(), D = o._web3Wrapper.awaitTransactionSuccessAsync(x), [2, new b.PolyResponse(x, D)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u, f, l, h, b, m, y, v) {
          return o(this, void 0, void 0, function () {
            var o, _, g, A, w, T, x, D, C;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), p.assert.isArray("_ratePerTier", a), p.assert.isArray("_ratePerTierDiscountPoly", r), p.assert.isArray("_tokensPerTierTotal", n), p.assert.isArray("_tokensPerTierDiscountPoly", c), p.assert.isBigNumber("_nonAccreditedLimitUSD", u), p.assert.isBigNumber("_minimumInvestmentUSD", f), p.assert.isArray("_fundRaiseTypes", l), p.assert.isString("_wallet", h), p.assert.isString("_treasuryWallet", b), p.assert.isArray("_usdTokens", m), _ = (o = this)._strictEncodeArguments("configure(uint256,uint256,uint256[],uint256[],uint256[],uint256[],uint256,uint256,uint8[],address,address,address[])", [e, t, a, r, n, c, u, f, l, h, b, m]), g = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return A = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, v, {
                    data: _
                  }), s({
                    from: A
                  }, g))];

                case 2:
                  return void 0 !== (w = i.sent()).from && (w.from = w.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(w)];

                case 3:
                  return T = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return x = i.sent().gasLimit, D = void 0 === y ? o._defaultEstimateGasFactor : y, C = Math.round(D * T), [2, x < C ? x : C];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u, l, h, b, m, y, v, _) {
          return void 0 === v && (v = {}), o(this, void 0, void 0, function () {
            var o, g, A, w;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), p.assert.isArray("_ratePerTier", a), p.assert.isArray("_ratePerTierDiscountPoly", r), p.assert.isArray("_tokensPerTierTotal", n), p.assert.isArray("_tokensPerTierDiscountPoly", c), p.assert.isBigNumber("_nonAccreditedLimitUSD", u), p.assert.isBigNumber("_minimumInvestmentUSD", l), p.assert.isArray("_fundRaiseTypes", h), p.assert.isString("_wallet", b), p.assert.isString("_treasuryWallet", m), p.assert.isArray("_usdTokens", y), p.assert.doesConformToSchema("callData", v, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== _ && p.assert.isBlockParam("defaultBlock", _), g = (o = this)._strictEncodeArguments("configure(uint256,uint256,uint256[],uint256[],uint256[],uint256[],uint256,uint256,uint8[],address,address,address[])", [e, t, a, r, n, c, u, l, h, b, m, y]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, v, {
                    data: g
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (A = i.sent()).from = A.from ? A.from.toLowerCase() : A.from, [4, o._web3Wrapper.callAsync(A, _)];

                case 2:
                  return w = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(w), [2, o._lookupAbiEncoder("configure(uint256,uint256,uint256[],uint256[],uint256[],uint256[],uint256,uint256,uint8[],address,address,address[])").strictDecodeReturnValue(w)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s, o, i, c, u, d, f) {
          return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), p.assert.isArray("_ratePerTier", a), p.assert.isArray("_ratePerTierDiscountPoly", r), p.assert.isArray("_tokensPerTierTotal", n), p.assert.isArray("_tokensPerTierDiscountPoly", s), p.assert.isBigNumber("_nonAccreditedLimitUSD", o), p.assert.isBigNumber("_minimumInvestmentUSD", i), p.assert.isArray("_fundRaiseTypes", c), p.assert.isString("_wallet", u), p.assert.isString("_treasuryWallet", d), p.assert.isArray("_usdTokens", f), this._strictEncodeArguments("configure(uint256,uint256,uint256[],uint256[],uint256[],uint256[],uint256,uint256,uint8[],address,address,address[])", [e, t, a, r, n, s, o, i, c, u, d, f]);
        }
      }, u.modifyFunding = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_fundRaiseTypes", e), n = (r = this)._strictEncodeArguments("modifyFunding(uint8[])", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.modifyFunding.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_fundRaiseTypes", e), n = (r = this)._strictEncodeArguments("modifyFunding(uint8[])", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_fundRaiseTypes", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("modifyFunding(uint8[])", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("modifyFunding(uint8[])").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isArray("_fundRaiseTypes", e), this._strictEncodeArguments("modifyFunding(uint8[])", [e]);
        }
      }, u.modifyLimits = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_nonAccreditedLimitUSD", e), p.assert.isBigNumber("_minimumInvestmentUSD", t), o = (n = this)._strictEncodeArguments("modifyLimits(uint256,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.modifyLimits.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_nonAccreditedLimitUSD", e), p.assert.isBigNumber("_minimumInvestmentUSD", t), o = (n = this)._strictEncodeArguments("modifyLimits(uint256,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_nonAccreditedLimitUSD", e), p.assert.isBigNumber("_minimumInvestmentUSD", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("modifyLimits(uint256,uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("modifyLimits(uint256,uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isBigNumber("_nonAccreditedLimitUSD", e), p.assert.isBigNumber("_minimumInvestmentUSD", t), this._strictEncodeArguments("modifyLimits(uint256,uint256)", [e, t]);
        }
      }, u.modifyTiers = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_ratePerTier", e), p.assert.isArray("_ratePerTierDiscountPoly", t), p.assert.isArray("_tokensPerTierTotal", a), p.assert.isArray("_tokensPerTierDiscountPoly", r), u = (o = this)._strictEncodeArguments("modifyTiers(uint256[],uint256[],uint256[],uint256[])", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.modifyTiers.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_ratePerTier", e), p.assert.isArray("_ratePerTierDiscountPoly", t), p.assert.isArray("_tokensPerTierTotal", a), p.assert.isArray("_tokensPerTierDiscountPoly", r), u = (o = this)._strictEncodeArguments("modifyTiers(uint256[],uint256[],uint256[],uint256[])", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_ratePerTier", e), p.assert.isArray("_ratePerTierDiscountPoly", t), p.assert.isArray("_tokensPerTierTotal", a), p.assert.isArray("_tokensPerTierDiscountPoly", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("modifyTiers(uint256[],uint256[],uint256[],uint256[])", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("modifyTiers(uint256[],uint256[],uint256[],uint256[])").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isArray("_ratePerTier", e), p.assert.isArray("_ratePerTierDiscountPoly", t), p.assert.isArray("_tokensPerTierTotal", a), p.assert.isArray("_tokensPerTierDiscountPoly", r), this._strictEncodeArguments("modifyTiers(uint256[],uint256[],uint256[],uint256[])", [e, t, a, r]);
        }
      }, u.modifyTimes = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), o = (n = this)._strictEncodeArguments("modifyTimes(uint256,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.modifyTimes.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), o = (n = this)._strictEncodeArguments("modifyTimes(uint256,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("modifyTimes(uint256,uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("modifyTimes(uint256,uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), this._strictEncodeArguments("modifyTimes(uint256,uint256)", [e, t]);
        }
      }, u.modifyAddresses = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_wallet", e), p.assert.isString("_treasuryWallet", t), p.assert.isArray("_usdTokens", a), c = (o = this)._strictEncodeArguments("modifyAddresses(address,address,address[])", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.modifyAddresses.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_wallet", e), p.assert.isString("_treasuryWallet", t), p.assert.isArray("_usdTokens", a), c = (o = this)._strictEncodeArguments("modifyAddresses(address,address,address[])", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_wallet", e), p.assert.isString("_treasuryWallet", t), p.assert.isArray("_usdTokens", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("modifyAddresses(address,address,address[])", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("modifyAddresses(address,address,address[])").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isString("_wallet", e), p.assert.isString("_treasuryWallet", t), p.assert.isArray("_usdTokens", a), this._strictEncodeArguments("modifyAddresses(address,address,address[])", [e, t, a]);
        }
      }, u.modifyOracle = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_fundRaiseType", e), p.assert.isString("_oracleAddress", t), o = (n = this)._strictEncodeArguments("modifyOracle(uint8,address)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.modifyOracle.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_fundRaiseType", e), p.assert.isString("_oracleAddress", t), o = (n = this)._strictEncodeArguments("modifyOracle(uint8,address)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_fundRaiseType", e), p.assert.isString("_oracleAddress", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("modifyOracle(uint8,address)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("modifyOracle(uint8,address)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isNumberOrBigNumber("_fundRaiseType", e), p.assert.isString("_oracleAddress", t), this._strictEncodeArguments("modifyOracle(uint8,address)", [e, t]);
        }
      }, u.finalize = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("finalize()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.finalize.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("finalize()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("finalize()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("finalize()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("finalize()", []);
        }
      }, u.changeNonAccreditedLimit = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isArray("_nonAccreditedLimit", t), o = (n = this)._strictEncodeArguments("changeNonAccreditedLimit(address[],uint256[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.changeNonAccreditedLimit.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isArray("_nonAccreditedLimit", t), o = (n = this)._strictEncodeArguments("changeNonAccreditedLimit(address[],uint256[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isArray("_nonAccreditedLimit", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("changeNonAccreditedLimit(address[],uint256[])", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("changeNonAccreditedLimit(address[],uint256[])").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isArray("_investors", e), p.assert.isArray("_nonAccreditedLimit", t), this._strictEncodeArguments("changeNonAccreditedLimit(address[],uint256[])", [e, t]);
        }
      }, u.getAccreditedData = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getAccreditedData()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getAccreditedData()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getAccreditedData()", []);
        }
      }, u.changeAllowBeneficialInvestments = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBoolean("_allowBeneficialInvestments", e), n = (r = this)._strictEncodeArguments("changeAllowBeneficialInvestments(bool)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeAllowBeneficialInvestments.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBoolean("_allowBeneficialInvestments", e), n = (r = this)._strictEncodeArguments("changeAllowBeneficialInvestments(bool)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBoolean("_allowBeneficialInvestments", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeAllowBeneficialInvestments(bool)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeAllowBeneficialInvestments(bool)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBoolean("_allowBeneficialInvestments", e), this._strictEncodeArguments("changeAllowBeneficialInvestments(bool)", [e]);
        }
      }, u.buyWithETH = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), n = (r = this)._strictEncodeArguments("buyWithETH(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.buyWithETH.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), n = (r = this)._strictEncodeArguments("buyWithETH(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("buyWithETH(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("buyWithETH(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_beneficiary", e), this._strictEncodeArguments("buyWithETH(address)", [e]);
        }
      }, u.buyWithPOLY = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_investedPOLY", t), o = (n = this)._strictEncodeArguments("buyWithPOLY(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.buyWithPOLY.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_investedPOLY", t), o = (n = this)._strictEncodeArguments("buyWithPOLY(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_investedPOLY", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("buyWithPOLY(address,uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("buyWithPOLY(address,uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_investedPOLY", t), this._strictEncodeArguments("buyWithPOLY(address,uint256)", [e, t]);
        }
      }, u.buyWithUSD = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_investedSC", t), p.assert.isString("_usdToken", a), c = (o = this)._strictEncodeArguments("buyWithUSD(address,uint256,address)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.buyWithUSD.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_investedSC", t), p.assert.isString("_usdToken", a), c = (o = this)._strictEncodeArguments("buyWithUSD(address,uint256,address)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_investedSC", t), p.assert.isString("_usdToken", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("buyWithUSD(address,uint256,address)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("buyWithUSD(address,uint256,address)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_investedSC", t), p.assert.isString("_usdToken", a), this._strictEncodeArguments("buyWithUSD(address,uint256,address)", [e, t, a]);
        }
      }, u.buyWithETHRateLimited = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_minTokens", t), o = (n = this)._strictEncodeArguments("buyWithETHRateLimited(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.buyWithETHRateLimited.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_minTokens", t), o = (n = this)._strictEncodeArguments("buyWithETHRateLimited(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_minTokens", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("buyWithETHRateLimited(address,uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("buyWithETHRateLimited(address,uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_minTokens", t), this._strictEncodeArguments("buyWithETHRateLimited(address,uint256)", [e, t]);
        }
      }, u.buyWithPOLYRateLimited = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_investedPOLY", t), p.assert.isBigNumber("_minTokens", a), c = (o = this)._strictEncodeArguments("buyWithPOLYRateLimited(address,uint256,uint256)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.buyWithPOLYRateLimited.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_investedPOLY", t), p.assert.isBigNumber("_minTokens", a), c = (o = this)._strictEncodeArguments("buyWithPOLYRateLimited(address,uint256,uint256)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_investedPOLY", t), p.assert.isBigNumber("_minTokens", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("buyWithPOLYRateLimited(address,uint256,uint256)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("buyWithPOLYRateLimited(address,uint256,uint256)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_investedPOLY", t), p.assert.isBigNumber("_minTokens", a), this._strictEncodeArguments("buyWithPOLYRateLimited(address,uint256,uint256)", [e, t, a]);
        }
      }, u.buyWithUSDRateLimited = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_investedSC", t), p.assert.isBigNumber("_minTokens", a), p.assert.isString("_usdToken", r), u = (o = this)._strictEncodeArguments("buyWithUSDRateLimited(address,uint256,uint256,address)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.buyWithUSDRateLimited.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_investedSC", t), p.assert.isBigNumber("_minTokens", a), p.assert.isString("_usdToken", r), u = (o = this)._strictEncodeArguments("buyWithUSDRateLimited(address,uint256,uint256,address)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_investedSC", t), p.assert.isBigNumber("_minTokens", a), p.assert.isString("_usdToken", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("buyWithUSDRateLimited(address,uint256,uint256,address)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("buyWithUSDRateLimited(address,uint256,uint256,address)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_investedSC", t), p.assert.isBigNumber("_minTokens", a), p.assert.isString("_usdToken", r), this._strictEncodeArguments("buyWithUSDRateLimited(address,uint256,uint256,address)", [e, t, a, r]);
        }
      }, u.isOpen = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("isOpen()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("isOpen()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("isOpen()", []);
        }
      }, u.capReached = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("capReached()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("capReached()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("capReached()", []);
        }
      }, u.getRate = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_fundRaiseType", e), n = (r = this)._strictEncodeArguments("getRate(uint8)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.getRate.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_fundRaiseType", e), n = (r = this)._strictEncodeArguments("getRate(uint8)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_fundRaiseType", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getRate(uint8)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getRate(uint8)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isNumberOrBigNumber("_fundRaiseType", e), this._strictEncodeArguments("getRate(uint8)", [e]);
        }
      }, u.convertToUSD = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_fundRaiseType", e), p.assert.isBigNumber("_amount", t), o = (n = this)._strictEncodeArguments("convertToUSD(uint8,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.convertToUSD.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_fundRaiseType", e), p.assert.isBigNumber("_amount", t), o = (n = this)._strictEncodeArguments("convertToUSD(uint8,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_fundRaiseType", e), p.assert.isBigNumber("_amount", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("convertToUSD(uint8,uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("convertToUSD(uint8,uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isNumberOrBigNumber("_fundRaiseType", e), p.assert.isBigNumber("_amount", t), this._strictEncodeArguments("convertToUSD(uint8,uint256)", [e, t]);
        }
      }, u.convertFromUSD = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_fundRaiseType", e), p.assert.isBigNumber("_amount", t), o = (n = this)._strictEncodeArguments("convertFromUSD(uint8,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.convertFromUSD.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_fundRaiseType", e), p.assert.isBigNumber("_amount", t), o = (n = this)._strictEncodeArguments("convertFromUSD(uint8,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_fundRaiseType", e), p.assert.isBigNumber("_amount", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("convertFromUSD(uint8,uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("convertFromUSD(uint8,uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isNumberOrBigNumber("_fundRaiseType", e), p.assert.isBigNumber("_amount", t), this._strictEncodeArguments("convertFromUSD(uint8,uint256)", [e, t]);
        }
      }, u.getTokensSold = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getTokensSold()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getTokensSold()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getTokensSold()", []);
        }
      }, u.getTokensMinted = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getTokensMinted()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getTokensMinted()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getTokensMinted()", []);
        }
      }, u.getTokensSoldFor = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_fundRaiseType", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getTokensSoldFor(uint8)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getTokensSoldFor(uint8)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isNumberOrBigNumber("_fundRaiseType", e), this._strictEncodeArguments("getTokensSoldFor(uint8)", [e]);
        }
      }, u.getTokensMintedByTier = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_tier", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getTokensMintedByTier(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getTokensMintedByTier(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_tier", e), this._strictEncodeArguments("getTokensMintedByTier(uint256)", [e]);
        }
      }, u.getTokensSoldByTier = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_tier", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getTokensSoldByTier(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getTokensSoldByTier(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_tier", e), this._strictEncodeArguments("getTokensSoldByTier(uint256)", [e]);
        }
      }, u.getNumberOfTiers = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getNumberOfTiers()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getNumberOfTiers()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getNumberOfTiers()", []);
        }
      }, u.getUsdTokens = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getUsdTokens()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getUsdTokens()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getUsdTokens()", []);
        }
      }, u.getPermissions = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getPermissions()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getPermissions()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getPermissions()", []);
        }
      }, u.getSTODetails = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getSTODetails()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getSTODetails()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getSTODetails()", []);
        }
      }, u.getInitFunction = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getInitFunction()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getInitFunction()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getInitFunction()", []);
        }
      }, u._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, l.classUtils.bindAll(u, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), u;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n, s, u) {
      return o(this, void 0, void 0, function () {
        var o, b, m, v, _, g, A, w, T, x, D;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return p.assert.isHexString("bytecode", e), p.assert.doesConformToSchema("txDefaults", n, f.schemas.txDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), o = l.providerUtils.standardizeOrThrow(r), b = d.BaseContract._lookupConstructorAbi(a), D = c(d.BaseContract._formatABIDataItemList(b.inputs, [s, u], d.BaseContract._bigNumberToString), 2), s = D[0], u = D[1], m = new y.utils.Interface(a), v = m.deployFunction, _ = v.encode(e, [s, u]), g = new h.Web3Wrapper(o), [4, d.BaseContract._applyDefaultsToTxDataAsync({
                data: _
              }, n, g.estimateGasAsync.bind(g))];

            case 1:
              return A = i.sent(), [4, g.sendTransactionAsync(A)];

            case 2:
              return w = i.sent(), l.logUtils.log("transactionHash: " + w), [4, g.awaitTransactionSuccessAsync(w)];

            case 3:
              return T = i.sent(), l.logUtils.log("USDTieredSTO successfully deployed at " + T.contractAddress), (x = new t(T.contractAddress, o, n)).constructorArgs = [s, u], [2, x];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "uint256"
        }],
        name: "tiers",
        outputs: [{
          name: "rate",
          type: "uint256"
        }, {
          name: "rateDiscountPoly",
          type: "uint256"
        }, {
          name: "tokenTotal",
          type: "uint256"
        }, {
          name: "tokensDiscountPoly",
          type: "uint256"
        }, {
          name: "mintedTotal",
          type: "uint256"
        }, {
          name: "mintedDiscountPoly",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "reclaimETH",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "ADMIN",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "allowBeneficialInvestments",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "endTime",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "unpause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "treasuryWallet",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "nonAccreditedLimitUSD",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "wallet",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "paused",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "totalTokensSold",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "finalAmountReturned",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "polyToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "address"
        }],
        name: "stableCoinsRaised",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "startTime",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "pause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "address"
        }, {
          name: "index_1",
          type: "uint8"
        }],
        name: "investorInvested",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenContract",
          type: "address"
        }],
        name: "reclaimERC20",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "isFinalized",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "OPERATOR",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_fundRaiseType",
          type: "uint8"
        }],
        name: "getRaised",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "pausedTime",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "securityToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "factory",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "uint8"
        }],
        name: "fundsRaised",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "address"
        }],
        name: "investorInvestedUSD",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "uint8"
        }],
        name: "fundRaiseTypes",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "currentTier",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "investorCount",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "address"
        }],
        name: "nonAccreditedLimitUSDOverride",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "minimumInvestmentUSD",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDataStore",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "fundsRaisedUSD",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        inputs: [{
          name: "_securityToken",
          type: "address"
        }, {
          name: "_polyAddress",
          type: "address"
        }],
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "constructor"
      }, {
        inputs: [],
        outputs: [],
        payable: !0,
        stateMutability: "payable",
        type: "fallback"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_allowed",
          type: "bool",
          indexed: !1
        }],
        name: "SetAllowBeneficialInvestments",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_investor",
          type: "address",
          indexed: !1
        }, {
          name: "_limit",
          type: "uint256",
          indexed: !1
        }],
        name: "SetNonAccreditedLimit",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_purchaser",
          type: "address",
          indexed: !0
        }, {
          name: "_beneficiary",
          type: "address",
          indexed: !0
        }, {
          name: "_tokens",
          type: "uint256",
          indexed: !1
        }, {
          name: "_usdAmount",
          type: "uint256",
          indexed: !1
        }, {
          name: "_tierPrice",
          type: "uint256",
          indexed: !1
        }, {
          name: "_tier",
          type: "uint256",
          indexed: !1
        }],
        name: "TokenPurchase",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_purchaser",
          type: "address",
          indexed: !0
        }, {
          name: "_beneficiary",
          type: "address",
          indexed: !0
        }, {
          name: "_usdAmount",
          type: "uint256",
          indexed: !1
        }, {
          name: "_fundRaiseType",
          type: "uint8",
          indexed: !1
        }, {
          name: "_receivedValue",
          type: "uint256",
          indexed: !1
        }, {
          name: "_spentValue",
          type: "uint256",
          indexed: !1
        }, {
          name: "_rate",
          type: "uint256",
          indexed: !1
        }],
        name: "FundsReceived",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_owner",
          type: "address",
          indexed: !0
        }, {
          name: "_wallet",
          type: "address",
          indexed: !0
        }, {
          name: "_tokens",
          type: "uint256",
          indexed: !1
        }, {
          name: "_latestTier",
          type: "uint256",
          indexed: !1
        }],
        name: "ReserveTokenMint",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_wallet",
          type: "address",
          indexed: !0
        }, {
          name: "_usdTokens",
          type: "address[]",
          indexed: !1
        }],
        name: "SetAddresses",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_nonAccreditedLimitUSD",
          type: "uint256",
          indexed: !1
        }, {
          name: "_minimumInvestmentUSD",
          type: "uint256",
          indexed: !1
        }],
        name: "SetLimits",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_startTime",
          type: "uint256",
          indexed: !1
        }, {
          name: "_endTime",
          type: "uint256",
          indexed: !1
        }],
        name: "SetTimes",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_ratePerTier",
          type: "uint256[]",
          indexed: !1
        }, {
          name: "_ratePerTierDiscountPoly",
          type: "uint256[]",
          indexed: !1
        }, {
          name: "_tokensPerTierTotal",
          type: "uint256[]",
          indexed: !1
        }, {
          name: "_tokensPerTierDiscountPoly",
          type: "uint256[]",
          indexed: !1
        }],
        name: "SetTiers",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_oldWallet",
          type: "address",
          indexed: !1
        }, {
          name: "_newWallet",
          type: "address",
          indexed: !1
        }],
        name: "SetTreasuryWallet",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Pause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Unpause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_fundRaiseTypes",
          type: "uint8[]",
          indexed: !1
        }],
        name: "SetFundRaiseTypes",
        outputs: [],
        type: "event"
      }, {
        constant: !1,
        inputs: [{
          name: "_startTime",
          type: "uint256"
        }, {
          name: "_endTime",
          type: "uint256"
        }, {
          name: "_ratePerTier",
          type: "uint256[]"
        }, {
          name: "_ratePerTierDiscountPoly",
          type: "uint256[]"
        }, {
          name: "_tokensPerTierTotal",
          type: "uint256[]"
        }, {
          name: "_tokensPerTierDiscountPoly",
          type: "uint256[]"
        }, {
          name: "_nonAccreditedLimitUSD",
          type: "uint256"
        }, {
          name: "_minimumInvestmentUSD",
          type: "uint256"
        }, {
          name: "_fundRaiseTypes",
          type: "uint8[]"
        }, {
          name: "_wallet",
          type: "address"
        }, {
          name: "_treasuryWallet",
          type: "address"
        }, {
          name: "_usdTokens",
          type: "address[]"
        }],
        name: "configure",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_fundRaiseTypes",
          type: "uint8[]"
        }],
        name: "modifyFunding",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_nonAccreditedLimitUSD",
          type: "uint256"
        }, {
          name: "_minimumInvestmentUSD",
          type: "uint256"
        }],
        name: "modifyLimits",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_ratePerTier",
          type: "uint256[]"
        }, {
          name: "_ratePerTierDiscountPoly",
          type: "uint256[]"
        }, {
          name: "_tokensPerTierTotal",
          type: "uint256[]"
        }, {
          name: "_tokensPerTierDiscountPoly",
          type: "uint256[]"
        }],
        name: "modifyTiers",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_startTime",
          type: "uint256"
        }, {
          name: "_endTime",
          type: "uint256"
        }],
        name: "modifyTimes",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_wallet",
          type: "address"
        }, {
          name: "_treasuryWallet",
          type: "address"
        }, {
          name: "_usdTokens",
          type: "address[]"
        }],
        name: "modifyAddresses",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_fundRaiseType",
          type: "uint8"
        }, {
          name: "_oracleAddress",
          type: "address"
        }],
        name: "modifyOracle",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "finalize",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_investors",
          type: "address[]"
        }, {
          name: "_nonAccreditedLimit",
          type: "uint256[]"
        }],
        name: "changeNonAccreditedLimit",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getAccreditedData",
        outputs: [{
          name: "investors",
          type: "address[]"
        }, {
          name: "accredited",
          type: "bool[]"
        }, {
          name: "overrides",
          type: "uint256[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_allowBeneficialInvestments",
          type: "bool"
        }],
        name: "changeAllowBeneficialInvestments",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address"
        }],
        name: "buyWithETH",
        outputs: [{
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }],
        payable: !0,
        stateMutability: "payable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address"
        }, {
          name: "_investedPOLY",
          type: "uint256"
        }],
        name: "buyWithPOLY",
        outputs: [{
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address"
        }, {
          name: "_investedSC",
          type: "uint256"
        }, {
          name: "_usdToken",
          type: "address"
        }],
        name: "buyWithUSD",
        outputs: [{
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address"
        }, {
          name: "_minTokens",
          type: "uint256"
        }],
        name: "buyWithETHRateLimited",
        outputs: [{
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }],
        payable: !0,
        stateMutability: "payable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address"
        }, {
          name: "_investedPOLY",
          type: "uint256"
        }, {
          name: "_minTokens",
          type: "uint256"
        }],
        name: "buyWithPOLYRateLimited",
        outputs: [{
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address"
        }, {
          name: "_investedSC",
          type: "uint256"
        }, {
          name: "_minTokens",
          type: "uint256"
        }, {
          name: "_usdToken",
          type: "address"
        }],
        name: "buyWithUSDRateLimited",
        outputs: [{
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "isOpen",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "capReached",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_fundRaiseType",
          type: "uint8"
        }],
        name: "getRate",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_fundRaiseType",
          type: "uint8"
        }, {
          name: "_amount",
          type: "uint256"
        }],
        name: "convertToUSD",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_fundRaiseType",
          type: "uint8"
        }, {
          name: "_amount",
          type: "uint256"
        }],
        name: "convertFromUSD",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getTokensSold",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getTokensMinted",
        outputs: [{
          name: "tokensMinted",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_fundRaiseType",
          type: "uint8"
        }],
        name: "getTokensSoldFor",
        outputs: [{
          name: "tokensSold",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_tier",
          type: "uint256"
        }],
        name: "getTokensMintedByTier",
        outputs: [{
          name: "",
          type: "uint256[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_tier",
          type: "uint256"
        }],
        name: "getTokensSoldByTier",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getNumberOfTiers",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getUsdTokens",
        outputs: [{
          name: "",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getPermissions",
        outputs: [{
          name: "allPermissions",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getSTODetails",
        outputs: [{
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256[]"
        }, {
          name: "",
          type: "uint256[]"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "bool[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getInitFunction",
        outputs: [{
          name: "",
          type: "bytes4"
        }],
        payable: !1,
        stateMutability: "pure",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(d.BaseContract);

  t.USDTieredSTOContract_3_0_0 = v, t.isUSDTieredSTOContract_3_0_0 = function (e) {
    return m.isEqual(v.ABI(), e.abi);
  };
},
/*!*******************************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/u_s_d_tiered_s_t_o_factory.js ***!
  \*******************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r100,
      n = this && this.__extends || (_r100 = function r(e, t) {
    return (_r100 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r100(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      c = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || 0 < t--) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u,
      d = a(
  /*! @0x/base-contract */
  12),
      f = a(
  /*! @0x/json-schemas */
  2),
      l = a(
  /*! @0x/utils */
  8),
      h = a(
  /*! @0x/web3-wrapper */
  11),
      p = a(
  /*! @0x/assert */
  10),
      b = a(
  /*! ../../PolyResponse */
  14),
      m = a(
  /*! lodash */
  0),
      y = a(
  /*! ethers */
  13);
  (u = t.USDTieredSTOFactoryEvents_3_0_0 || (t.USDTieredSTOFactoryEvents_3_0_0 = {})).LogicContractSet = "LogicContractSet", u.ModuleUpgraded = "ModuleUpgraded", u.OwnershipTransferred = "OwnershipTransferred", u.ChangeSetupCost = "ChangeSetupCost", u.ChangeCostType = "ChangeCostType", u.GenerateModuleFromFactory = "GenerateModuleFromFactory", u.ChangeSTVersionBound = "ChangeSTVersionBound";

  var v = function (e) {
    function t(a, r, n, c) {
      var u = e.call(this, "USDTieredSTOFactory", t.ABI(), a, r, n) || this;
      return u.name = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("name()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("name()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("name()", []);
        }
      }, u.upgrade = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_module", e), n = (r = this)._strictEncodeArguments("upgrade(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.upgrade.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_module", e), n = (r = this)._strictEncodeArguments("upgrade(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_module", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("upgrade(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("upgrade(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_module", e), this._strictEncodeArguments("upgrade(address)", [e]);
        }
      }, u.changeSetupCost = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_setupCost", e), n = (r = this)._strictEncodeArguments("changeSetupCost(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeSetupCost.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_setupCost", e), n = (r = this)._strictEncodeArguments("changeSetupCost(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_setupCost", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeSetupCost(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeSetupCost(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_setupCost", e), this._strictEncodeArguments("changeSetupCost(uint256)", [e]);
        }
      }, u.changeTags = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_tagsData", e), n = (r = this)._strictEncodeArguments("changeTags(bytes32[])", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeTags.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_tagsData", e), n = (r = this)._strictEncodeArguments("changeTags(bytes32[])", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_tagsData", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeTags(bytes32[])", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeTags(bytes32[])").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isArray("_tagsData", e), this._strictEncodeArguments("changeTags(bytes32[])", [e]);
        }
      }, u.setupCostInPoly = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("setupCostInPoly()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.setupCostInPoly.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("setupCostInPoly()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("setupCostInPoly()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("setupCostInPoly()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("setupCostInPoly()", []);
        }
      }, u.changeTitle = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_title", e), n = (r = this)._strictEncodeArguments("changeTitle(string)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeTitle.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_title", e), n = (r = this)._strictEncodeArguments("changeTitle(string)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_title", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeTitle(string)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeTitle(string)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_title", e), this._strictEncodeArguments("changeTitle(string)", [e]);
        }
      }, u.setLogicContract = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_version", e), p.assert.isString("_logicContract", t), p.assert.isString("_upgradeData", a), c = (o = this)._strictEncodeArguments("setLogicContract(string,address,bytes)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.setLogicContract.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_version", e), p.assert.isString("_logicContract", t), p.assert.isString("_upgradeData", a), c = (o = this)._strictEncodeArguments("setLogicContract(string,address,bytes)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_version", e), p.assert.isString("_logicContract", t), p.assert.isString("_upgradeData", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("setLogicContract(string,address,bytes)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("setLogicContract(string,address,bytes)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isString("_version", e), p.assert.isString("_logicContract", t), p.assert.isString("_upgradeData", a), this._strictEncodeArguments("setLogicContract(string,address,bytes)", [e, t, a]);
        }
      }, u.isCostInPoly = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("isCostInPoly()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("isCostInPoly()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("isCostInPoly()", []);
        }
      }, u.title = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("title()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("title()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("title()", []);
        }
      }, u.version = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("version()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("version()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("version()", []);
        }
      }, u.latestUpgrade = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("latestUpgrade()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("latestUpgrade()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("latestUpgrade()", []);
        }
      }, u.logicContracts = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("logicContracts(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("logicContracts(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("index_0", e), this._strictEncodeArguments("logicContracts(uint256)", [e]);
        }
      }, u.renounceOwnership = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("renounceOwnership()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.renounceOwnership.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("renounceOwnership()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("renounceOwnership()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("renounceOwnership()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("renounceOwnership()", []);
        }
      }, u.description = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("description()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("description()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("description()", []);
        }
      }, u.polymathRegistry = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("polymathRegistry()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("polymathRegistry()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("polymathRegistry()", []);
        }
      }, u.setupCost = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("setupCost()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("setupCost()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("setupCost()", []);
        }
      }, u.getLowerSTVersionBounds = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getLowerSTVersionBounds()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getLowerSTVersionBounds()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getLowerSTVersionBounds()", []);
        }
      }, u.changeName = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), n = (r = this)._strictEncodeArguments("changeName(bytes32)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeName.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), n = (r = this)._strictEncodeArguments("changeName(bytes32)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeName(bytes32)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeName(bytes32)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_name", e), this._strictEncodeArguments("changeName(bytes32)", [e]);
        }
      }, u.owner = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("owner()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("owner()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("owner()", []);
        }
      }, u.isOwner = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("isOwner()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("isOwner()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("isOwner()", []);
        }
      }, u.getTags = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getTags()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getTags()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getTags()", []);
        }
      }, u.modules = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("index_0", e), p.assert.isString("index_1", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("modules(address,address)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("modules(address,address)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("index_0", e), p.assert.isString("index_1", t), this._strictEncodeArguments("modules(address,address)", [e, t]);
        }
      }, u.moduleToSecurityToken = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("moduleToSecurityToken(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("moduleToSecurityToken(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("index_0", e), this._strictEncodeArguments("moduleToSecurityToken(address)", [e]);
        }
      }, u.getTypes = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getTypes()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getTypes()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getTypes()", []);
        }
      }, u.changeCostAndType = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_setupCost", e), p.assert.isBoolean("_isCostInPoly", t), o = (n = this)._strictEncodeArguments("changeCostAndType(uint256,bool)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.changeCostAndType.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_setupCost", e), p.assert.isBoolean("_isCostInPoly", t), o = (n = this)._strictEncodeArguments("changeCostAndType(uint256,bool)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_setupCost", e), p.assert.isBoolean("_isCostInPoly", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("changeCostAndType(uint256,bool)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("changeCostAndType(uint256,bool)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isBigNumber("_setupCost", e), p.assert.isBoolean("_isCostInPoly", t), this._strictEncodeArguments("changeCostAndType(uint256,bool)", [e, t]);
        }
      }, u.updateLogicContract = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_upgrade", e), p.assert.isString("_version", t), p.assert.isString("_logicContract", a), p.assert.isString("_upgradeData", r), u = (o = this)._strictEncodeArguments("updateLogicContract(uint256,string,address,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.updateLogicContract.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_upgrade", e), p.assert.isString("_version", t), p.assert.isString("_logicContract", a), p.assert.isString("_upgradeData", r), u = (o = this)._strictEncodeArguments("updateLogicContract(uint256,string,address,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_upgrade", e), p.assert.isString("_version", t), p.assert.isString("_logicContract", a), p.assert.isString("_upgradeData", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("updateLogicContract(uint256,string,address,bytes)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("updateLogicContract(uint256,string,address,bytes)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isBigNumber("_upgrade", e), p.assert.isString("_version", t), p.assert.isString("_logicContract", a), p.assert.isString("_upgradeData", r), this._strictEncodeArguments("updateLogicContract(uint256,string,address,bytes)", [e, t, a, r]);
        }
      }, u.changeDescription = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_description", e), n = (r = this)._strictEncodeArguments("changeDescription(string)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeDescription.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_description", e), n = (r = this)._strictEncodeArguments("changeDescription(string)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_description", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeDescription(string)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeDescription(string)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_description", e), this._strictEncodeArguments("changeDescription(string)", [e]);
        }
      }, u.transferOwnership = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("newOwner", e), n = (r = this)._strictEncodeArguments("transferOwnership(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.transferOwnership.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("newOwner", e), n = (r = this)._strictEncodeArguments("transferOwnership(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("newOwner", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("transferOwnership(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("transferOwnership(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("newOwner", e), this._strictEncodeArguments("transferOwnership(address)", [e]);
        }
      }, u.getUpperSTVersionBounds = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getUpperSTVersionBounds()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getUpperSTVersionBounds()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getUpperSTVersionBounds()", []);
        }
      }, u.changeSTVersionBounds = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_boundType", e), p.assert.isArray("_newVersion", t), o = (n = this)._strictEncodeArguments("changeSTVersionBounds(string,uint8[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.changeSTVersionBounds.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_boundType", e), p.assert.isArray("_newVersion", t), o = (n = this)._strictEncodeArguments("changeSTVersionBounds(string,uint8[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_boundType", e), p.assert.isArray("_newVersion", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("changeSTVersionBounds(string,uint8[])", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("changeSTVersionBounds(string,uint8[])").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_boundType", e), p.assert.isArray("_newVersion", t), this._strictEncodeArguments("changeSTVersionBounds(string,uint8[])", [e, t]);
        }
      }, u.deploy = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_data", e), n = (r = this)._strictEncodeArguments("deploy(bytes)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.deploy.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_data", e), n = (r = this)._strictEncodeArguments("deploy(bytes)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_data", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("deploy(bytes)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("deploy(bytes)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_data", e), this._strictEncodeArguments("deploy(bytes)", [e]);
        }
      }, u._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, l.classUtils.bindAll(u, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), u;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n, s, u, b, m) {
      return o(this, void 0, void 0, function () {
        var o, v, _, g, A, w, T, x, D, C, S;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return p.assert.isHexString("bytecode", e), p.assert.doesConformToSchema("txDefaults", n, f.schemas.txDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), o = l.providerUtils.standardizeOrThrow(r), v = d.BaseContract._lookupConstructorAbi(a), S = c(d.BaseContract._formatABIDataItemList(v.inputs, [s, u, b, m], d.BaseContract._bigNumberToString), 4), s = S[0], u = S[1], b = S[2], m = S[3], _ = new y.utils.Interface(a), g = _.deployFunction, A = g.encode(e, [s, u, b, m]), w = new h.Web3Wrapper(o), [4, d.BaseContract._applyDefaultsToTxDataAsync({
                data: A
              }, n, w.estimateGasAsync.bind(w))];

            case 1:
              return T = i.sent(), [4, w.sendTransactionAsync(T)];

            case 2:
              return x = i.sent(), l.logUtils.log("transactionHash: " + x), [4, w.awaitTransactionSuccessAsync(x)];

            case 3:
              return D = i.sent(), l.logUtils.log("USDTieredSTOFactory successfully deployed at " + D.contractAddress), (C = new t(D.contractAddress, o, n)).constructorArgs = [s, u, b, m], [2, C];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !0,
        inputs: [],
        name: "name",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_module",
          type: "address"
        }],
        name: "upgrade",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_setupCost",
          type: "uint256"
        }],
        name: "changeSetupCost",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tagsData",
          type: "bytes32[]"
        }],
        name: "changeTags",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "setupCostInPoly",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_title",
          type: "string"
        }],
        name: "changeTitle",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_version",
          type: "string"
        }, {
          name: "_logicContract",
          type: "address"
        }, {
          name: "_upgradeData",
          type: "bytes"
        }],
        name: "setLogicContract",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "isCostInPoly",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "title",
        outputs: [{
          name: "",
          type: "string"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "version",
        outputs: [{
          name: "",
          type: "string"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "latestUpgrade",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "uint256"
        }],
        name: "logicContracts",
        outputs: [{
          name: "version",
          type: "string"
        }, {
          name: "logicContract",
          type: "address"
        }, {
          name: "upgradeData",
          type: "bytes"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "description",
        outputs: [{
          name: "",
          type: "string"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "polymathRegistry",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "setupCost",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getLowerSTVersionBounds",
        outputs: [{
          name: "",
          type: "uint8[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_name",
          type: "bytes32"
        }],
        name: "changeName",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "owner",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "isOwner",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getTags",
        outputs: [{
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "address"
        }, {
          name: "index_1",
          type: "address"
        }],
        name: "modules",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "address"
        }],
        name: "moduleToSecurityToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getTypes",
        outputs: [{
          name: "",
          type: "uint8[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_setupCost",
          type: "uint256"
        }, {
          name: "_isCostInPoly",
          type: "bool"
        }],
        name: "changeCostAndType",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_upgrade",
          type: "uint256"
        }, {
          name: "_version",
          type: "string"
        }, {
          name: "_logicContract",
          type: "address"
        }, {
          name: "_upgradeData",
          type: "bytes"
        }],
        name: "updateLogicContract",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_description",
          type: "string"
        }],
        name: "changeDescription",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "newOwner",
          type: "address"
        }],
        name: "transferOwnership",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getUpperSTVersionBounds",
        outputs: [{
          name: "",
          type: "uint8[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_boundType",
          type: "string"
        }, {
          name: "_newVersion",
          type: "uint8[]"
        }],
        name: "changeSTVersionBounds",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        inputs: [{
          name: "_setupCost",
          type: "uint256"
        }, {
          name: "_logicContract",
          type: "address"
        }, {
          name: "_polymathRegistry",
          type: "address"
        }, {
          name: "_isCostInPoly",
          type: "bool"
        }],
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "constructor"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_version",
          type: "string",
          indexed: !1
        }, {
          name: "_upgrade",
          type: "uint256",
          indexed: !1
        }, {
          name: "_logicContract",
          type: "address",
          indexed: !1
        }, {
          name: "_upgradeData",
          type: "bytes",
          indexed: !1
        }],
        name: "LogicContractSet",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_module",
          type: "address",
          indexed: !0
        }, {
          name: "_securityToken",
          type: "address",
          indexed: !0
        }, {
          name: "_version",
          type: "uint256",
          indexed: !0
        }],
        name: "ModuleUpgraded",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "previousOwner",
          type: "address",
          indexed: !0
        }, {
          name: "newOwner",
          type: "address",
          indexed: !0
        }],
        name: "OwnershipTransferred",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_oldSetupCost",
          type: "uint256",
          indexed: !1
        }, {
          name: "_newSetupCost",
          type: "uint256",
          indexed: !1
        }],
        name: "ChangeSetupCost",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_isOldCostInPoly",
          type: "bool",
          indexed: !1
        }, {
          name: "_isNewCostInPoly",
          type: "bool",
          indexed: !1
        }],
        name: "ChangeCostType",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_module",
          type: "address",
          indexed: !1
        }, {
          name: "_moduleName",
          type: "bytes32",
          indexed: !0
        }, {
          name: "_moduleFactory",
          type: "address",
          indexed: !0
        }, {
          name: "_creator",
          type: "address",
          indexed: !1
        }, {
          name: "_setupCost",
          type: "uint256",
          indexed: !1
        }, {
          name: "_setupCostInPoly",
          type: "uint256",
          indexed: !1
        }],
        name: "GenerateModuleFromFactory",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_boundType",
          type: "string",
          indexed: !1
        }, {
          name: "_major",
          type: "uint8",
          indexed: !1
        }, {
          name: "_minor",
          type: "uint8",
          indexed: !1
        }, {
          name: "_patch",
          type: "uint8",
          indexed: !1
        }],
        name: "ChangeSTVersionBound",
        outputs: [],
        type: "event"
      }, {
        constant: !1,
        inputs: [{
          name: "_data",
          type: "bytes"
        }],
        name: "deploy",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(d.BaseContract);

  t.USDTieredSTOFactoryContract_3_0_0 = v, t.isUSDTieredSTOFactoryContract_3_0_0 = function (e) {
    return m.isEqual(v.ABI(), e.abi);
  };
},
/*!**************************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/vesting_escrow_wallet.js ***!
  \**************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r101,
      n = this && this.__extends || (_r101 = function r(e, t) {
    return (_r101 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r101(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      c = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || 0 < t--) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u,
      d = a(
  /*! @0x/base-contract */
  12),
      f = a(
  /*! @0x/json-schemas */
  2),
      l = a(
  /*! @0x/utils */
  8),
      h = a(
  /*! @0x/web3-wrapper */
  11),
      p = a(
  /*! @0x/assert */
  10),
      b = a(
  /*! ../../PolyResponse */
  14),
      m = a(
  /*! lodash */
  0),
      y = a(
  /*! ethers */
  13);
  (u = t.VestingEscrowWalletEvents_3_0_0 || (t.VestingEscrowWalletEvents_3_0_0 = {})).AddSchedule = "AddSchedule", u.ModifySchedule = "ModifySchedule", u.RevokeAllSchedules = "RevokeAllSchedules", u.RevokeSchedule = "RevokeSchedule", u.DepositTokens = "DepositTokens", u.SendToTreasury = "SendToTreasury", u.SendTokens = "SendTokens", u.AddTemplate = "AddTemplate", u.RemoveTemplate = "RemoveTemplate", u.TreasuryWalletChanged = "TreasuryWalletChanged", u.Pause = "Pause", u.Unpause = "Unpause";

  var v = function (e) {
    function t(a, r, n, c) {
      var u = e.call(this, "VestingEscrowWallet", t.ABI(), a, r, n) || this;
      return u.reclaimETH = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.reclaimETH.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("reclaimETH()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("reclaimETH()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("reclaimETH()", []);
        }
      }, u.ADMIN = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("ADMIN()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("ADMIN()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("ADMIN()", []);
        }
      }, u.unpause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.unpause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("unpause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("unpause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("unpause()", []);
        }
      }, u.treasuryWallet = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("treasuryWallet()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("treasuryWallet()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("treasuryWallet()", []);
        }
      }, u.unassignedTokens = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("unassignedTokens()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("unassignedTokens()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("unassignedTokens()", []);
        }
      }, u.paused = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("paused()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("paused()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("paused()", []);
        }
      }, u.polyToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("polyToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("polyToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("polyToken()", []);
        }
      }, u.pause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.pause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pause()", []);
        }
      }, u.schedules = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("index_0", e), p.assert.isBigNumber("index_1", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("schedules(address,uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("schedules(address,uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("index_0", e), p.assert.isBigNumber("index_1", t), this._strictEncodeArguments("schedules(address,uint256)", [e, t]);
        }
      }, u.reclaimERC20 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.reclaimERC20.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("reclaimERC20(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_tokenContract", e), this._strictEncodeArguments("reclaimERC20(address)", [e]);
        }
      }, u.OPERATOR = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("OPERATOR()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("OPERATOR()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("OPERATOR()", []);
        }
      }, u.securityToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("securityToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("securityToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("securityToken()", []);
        }
      }, u.factory = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("factory()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("factory()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("factory()", []);
        }
      }, u.templateNames = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("templateNames(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("templateNames(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("index_0", e), this._strictEncodeArguments("templateNames(uint256)", [e]);
        }
      }, u.beneficiaries = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("beneficiaries(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("beneficiaries(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("index_0", e), this._strictEncodeArguments("beneficiaries(uint256)", [e]);
        }
      }, u.getDataStore = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDataStore()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDataStore()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDataStore()", []);
        }
      }, u.getInitFunction = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getInitFunction()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getInitFunction()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getInitFunction()", []);
        }
      }, u.configure = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_treasuryWallet", e), n = (r = this)._strictEncodeArguments("configure(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.configure.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_treasuryWallet", e), n = (r = this)._strictEncodeArguments("configure(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_treasuryWallet", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("configure(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("configure(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_treasuryWallet", e), this._strictEncodeArguments("configure(address)", [e]);
        }
      }, u.changeTreasuryWallet = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_newTreasuryWallet", e), n = (r = this)._strictEncodeArguments("changeTreasuryWallet(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeTreasuryWallet.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_newTreasuryWallet", e), n = (r = this)._strictEncodeArguments("changeTreasuryWallet(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_newTreasuryWallet", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeTreasuryWallet(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeTreasuryWallet(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_newTreasuryWallet", e), this._strictEncodeArguments("changeTreasuryWallet(address)", [e]);
        }
      }, u.depositTokens = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_numberOfTokens", e), n = (r = this)._strictEncodeArguments("depositTokens(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.depositTokens.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_numberOfTokens", e), n = (r = this)._strictEncodeArguments("depositTokens(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_numberOfTokens", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("depositTokens(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("depositTokens(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_numberOfTokens", e), this._strictEncodeArguments("depositTokens(uint256)", [e]);
        }
      }, u.sendToTreasury = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_amount", e), n = (r = this)._strictEncodeArguments("sendToTreasury(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.sendToTreasury.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_amount", e), n = (r = this)._strictEncodeArguments("sendToTreasury(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_amount", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("sendToTreasury(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("sendToTreasury(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_amount", e), this._strictEncodeArguments("sendToTreasury(uint256)", [e]);
        }
      }, u.getTreasuryWallet = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getTreasuryWallet()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getTreasuryWallet()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getTreasuryWallet()", []);
        }
      }, u.pushAvailableTokens = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), n = (r = this)._strictEncodeArguments("pushAvailableTokens(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.pushAvailableTokens.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), n = (r = this)._strictEncodeArguments("pushAvailableTokens(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("pushAvailableTokens(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("pushAvailableTokens(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_beneficiary", e), this._strictEncodeArguments("pushAvailableTokens(address)", [e]);
        }
      }, u.pullAvailableTokens = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pullAvailableTokens()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.pullAvailableTokens.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pullAvailableTokens()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pullAvailableTokens()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pullAvailableTokens()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pullAvailableTokens()", []);
        }
      }, u.addTemplate = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.isBigNumber("_numberOfTokens", t), p.assert.isBigNumber("_duration", a), p.assert.isBigNumber("_frequency", r), u = (o = this)._strictEncodeArguments("addTemplate(bytes32,uint256,uint256,uint256)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.addTemplate.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.isBigNumber("_numberOfTokens", t), p.assert.isBigNumber("_duration", a), p.assert.isBigNumber("_frequency", r), u = (o = this)._strictEncodeArguments("addTemplate(bytes32,uint256,uint256,uint256)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.isBigNumber("_numberOfTokens", t), p.assert.isBigNumber("_duration", a), p.assert.isBigNumber("_frequency", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("addTemplate(bytes32,uint256,uint256,uint256)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("addTemplate(bytes32,uint256,uint256,uint256)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isString("_name", e), p.assert.isBigNumber("_numberOfTokens", t), p.assert.isBigNumber("_duration", a), p.assert.isBigNumber("_frequency", r), this._strictEncodeArguments("addTemplate(bytes32,uint256,uint256,uint256)", [e, t, a, r]);
        }
      }, u.removeTemplate = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), n = (r = this)._strictEncodeArguments("removeTemplate(bytes32)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.removeTemplate.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), n = (r = this)._strictEncodeArguments("removeTemplate(bytes32)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("removeTemplate(bytes32)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("removeTemplate(bytes32)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_name", e), this._strictEncodeArguments("removeTemplate(bytes32)", [e]);
        }
      }, u.getTemplateCount = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getTemplateCount()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getTemplateCount()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getTemplateCount()", []);
        }
      }, u.getAllTemplateNames = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getAllTemplateNames()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getAllTemplateNames()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getAllTemplateNames()", []);
        }
      }, u.addSchedule = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u, f) {
          return o(this, void 0, void 0, function () {
            var o, l, h, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), p.assert.isBigNumber("_numberOfTokens", a), p.assert.isBigNumber("_duration", r), p.assert.isBigNumber("_frequency", n), p.assert.isBigNumber("_startTime", c), l = (o = this)._strictEncodeArguments("addSchedule(address,bytes32,uint256,uint256,uint256,uint256)", [e, t, a, r, n, c]), h = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return m = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: l
                  }), s({
                    from: m
                  }, h), o.addSchedule.estimateGasAsync.bind(o, e, t, a, r, n, c, f))];

                case 2:
                  return void 0 !== (y = i.sent()).from && (y.from = y.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(y)];

                case 3:
                  return v = i.sent(), _ = o._web3Wrapper.awaitTransactionSuccessAsync(v), [2, new b.PolyResponse(v, _)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u, f) {
          return o(this, void 0, void 0, function () {
            var o, l, h, b, m, y, v, _, g;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), p.assert.isBigNumber("_numberOfTokens", a), p.assert.isBigNumber("_duration", r), p.assert.isBigNumber("_frequency", n), p.assert.isBigNumber("_startTime", c), l = (o = this)._strictEncodeArguments("addSchedule(address,bytes32,uint256,uint256,uint256,uint256)", [e, t, a, r, n, c]), h = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return b = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, f, {
                    data: l
                  }), s({
                    from: b
                  }, h))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(m)];

                case 3:
                  return y = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return v = i.sent().gasLimit, _ = void 0 === u ? o._defaultEstimateGasFactor : u, g = Math.round(_ * y), [2, v < g ? v : g];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u, l) {
          return void 0 === u && (u = {}), o(this, void 0, void 0, function () {
            var o, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), p.assert.isBigNumber("_numberOfTokens", a), p.assert.isBigNumber("_duration", r), p.assert.isBigNumber("_frequency", n), p.assert.isBigNumber("_startTime", c), p.assert.doesConformToSchema("callData", u, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== l && p.assert.isBlockParam("defaultBlock", l), h = (o = this)._strictEncodeArguments("addSchedule(address,bytes32,uint256,uint256,uint256,uint256)", [e, t, a, r, n, c]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: h
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (b = i.sent()).from = b.from ? b.from.toLowerCase() : b.from, [4, o._web3Wrapper.callAsync(b, l)];

                case 2:
                  return m = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(m), [2, o._lookupAbiEncoder("addSchedule(address,bytes32,uint256,uint256,uint256,uint256)").strictDecodeReturnValue(m)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s) {
          return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), p.assert.isBigNumber("_numberOfTokens", a), p.assert.isBigNumber("_duration", r), p.assert.isBigNumber("_frequency", n), p.assert.isBigNumber("_startTime", s), this._strictEncodeArguments("addSchedule(address,bytes32,uint256,uint256,uint256,uint256)", [e, t, a, r, n, s]);
        }
      }, u.addScheduleFromTemplate = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), p.assert.isBigNumber("_startTime", a), c = (o = this)._strictEncodeArguments("addScheduleFromTemplate(address,bytes32,uint256)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.addScheduleFromTemplate.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), p.assert.isBigNumber("_startTime", a), c = (o = this)._strictEncodeArguments("addScheduleFromTemplate(address,bytes32,uint256)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), p.assert.isBigNumber("_startTime", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("addScheduleFromTemplate(address,bytes32,uint256)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("addScheduleFromTemplate(address,bytes32,uint256)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), p.assert.isBigNumber("_startTime", a), this._strictEncodeArguments("addScheduleFromTemplate(address,bytes32,uint256)", [e, t, a]);
        }
      }, u.modifySchedule = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), p.assert.isBigNumber("_startTime", a), c = (o = this)._strictEncodeArguments("modifySchedule(address,bytes32,uint256)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.modifySchedule.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), p.assert.isBigNumber("_startTime", a), c = (o = this)._strictEncodeArguments("modifySchedule(address,bytes32,uint256)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), p.assert.isBigNumber("_startTime", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("modifySchedule(address,bytes32,uint256)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("modifySchedule(address,bytes32,uint256)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), p.assert.isBigNumber("_startTime", a), this._strictEncodeArguments("modifySchedule(address,bytes32,uint256)", [e, t, a]);
        }
      }, u.revokeSchedule = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), o = (n = this)._strictEncodeArguments("revokeSchedule(address,bytes32)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.revokeSchedule.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), o = (n = this)._strictEncodeArguments("revokeSchedule(address,bytes32)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("revokeSchedule(address,bytes32)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("revokeSchedule(address,bytes32)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), this._strictEncodeArguments("revokeSchedule(address,bytes32)", [e, t]);
        }
      }, u.revokeAllSchedules = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), n = (r = this)._strictEncodeArguments("revokeAllSchedules(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.revokeAllSchedules.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), n = (r = this)._strictEncodeArguments("revokeAllSchedules(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("revokeAllSchedules(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("revokeAllSchedules(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_beneficiary", e), this._strictEncodeArguments("revokeAllSchedules(address)", [e]);
        }
      }, u.getSchedule = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("getSchedule(address,bytes32)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("getSchedule(address,bytes32)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), this._strictEncodeArguments("getSchedule(address,bytes32)", [e, t]);
        }
      }, u.getTemplateNames = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getTemplateNames(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getTemplateNames(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_beneficiary", e), this._strictEncodeArguments("getTemplateNames(address)", [e]);
        }
      }, u.getScheduleCount = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getScheduleCount(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getScheduleCount(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_beneficiary", e), this._strictEncodeArguments("getScheduleCount(address)", [e]);
        }
      }, u.pushAvailableTokensMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_fromIndex", e), p.assert.isBigNumber("_toIndex", t), o = (n = this)._strictEncodeArguments("pushAvailableTokensMulti(uint256,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.pushAvailableTokensMulti.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_fromIndex", e), p.assert.isBigNumber("_toIndex", t), o = (n = this)._strictEncodeArguments("pushAvailableTokensMulti(uint256,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_fromIndex", e), p.assert.isBigNumber("_toIndex", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("pushAvailableTokensMulti(uint256,uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("pushAvailableTokensMulti(uint256,uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isBigNumber("_fromIndex", e), p.assert.isBigNumber("_toIndex", t), this._strictEncodeArguments("pushAvailableTokensMulti(uint256,uint256)", [e, t]);
        }
      }, u.addScheduleMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u, f) {
          return o(this, void 0, void 0, function () {
            var o, l, h, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_beneficiaries", e), p.assert.isArray("_templateNames", t), p.assert.isArray("_numberOfTokens", a), p.assert.isArray("_durations", r), p.assert.isArray("_frequencies", n), p.assert.isArray("_startTimes", c), l = (o = this)._strictEncodeArguments("addScheduleMulti(address[],bytes32[],uint256[],uint256[],uint256[],uint256[])", [e, t, a, r, n, c]), h = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return m = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: l
                  }), s({
                    from: m
                  }, h), o.addScheduleMulti.estimateGasAsync.bind(o, e, t, a, r, n, c, f))];

                case 2:
                  return void 0 !== (y = i.sent()).from && (y.from = y.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(y)];

                case 3:
                  return v = i.sent(), _ = o._web3Wrapper.awaitTransactionSuccessAsync(v), [2, new b.PolyResponse(v, _)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u, f) {
          return o(this, void 0, void 0, function () {
            var o, l, h, b, m, y, v, _, g;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_beneficiaries", e), p.assert.isArray("_templateNames", t), p.assert.isArray("_numberOfTokens", a), p.assert.isArray("_durations", r), p.assert.isArray("_frequencies", n), p.assert.isArray("_startTimes", c), l = (o = this)._strictEncodeArguments("addScheduleMulti(address[],bytes32[],uint256[],uint256[],uint256[],uint256[])", [e, t, a, r, n, c]), h = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return b = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, f, {
                    data: l
                  }), s({
                    from: b
                  }, h))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(m)];

                case 3:
                  return y = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return v = i.sent().gasLimit, _ = void 0 === u ? o._defaultEstimateGasFactor : u, g = Math.round(_ * y), [2, v < g ? v : g];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u, l) {
          return void 0 === u && (u = {}), o(this, void 0, void 0, function () {
            var o, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_beneficiaries", e), p.assert.isArray("_templateNames", t), p.assert.isArray("_numberOfTokens", a), p.assert.isArray("_durations", r), p.assert.isArray("_frequencies", n), p.assert.isArray("_startTimes", c), p.assert.doesConformToSchema("callData", u, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== l && p.assert.isBlockParam("defaultBlock", l), h = (o = this)._strictEncodeArguments("addScheduleMulti(address[],bytes32[],uint256[],uint256[],uint256[],uint256[])", [e, t, a, r, n, c]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: h
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (b = i.sent()).from = b.from ? b.from.toLowerCase() : b.from, [4, o._web3Wrapper.callAsync(b, l)];

                case 2:
                  return m = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(m), [2, o._lookupAbiEncoder("addScheduleMulti(address[],bytes32[],uint256[],uint256[],uint256[],uint256[])").strictDecodeReturnValue(m)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s) {
          return p.assert.isArray("_beneficiaries", e), p.assert.isArray("_templateNames", t), p.assert.isArray("_numberOfTokens", a), p.assert.isArray("_durations", r), p.assert.isArray("_frequencies", n), p.assert.isArray("_startTimes", s), this._strictEncodeArguments("addScheduleMulti(address[],bytes32[],uint256[],uint256[],uint256[],uint256[])", [e, t, a, r, n, s]);
        }
      }, u.addScheduleFromTemplateMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_beneficiaries", e), p.assert.isArray("_templateNames", t), p.assert.isArray("_startTimes", a), c = (o = this)._strictEncodeArguments("addScheduleFromTemplateMulti(address[],bytes32[],uint256[])", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.addScheduleFromTemplateMulti.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_beneficiaries", e), p.assert.isArray("_templateNames", t), p.assert.isArray("_startTimes", a), c = (o = this)._strictEncodeArguments("addScheduleFromTemplateMulti(address[],bytes32[],uint256[])", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_beneficiaries", e), p.assert.isArray("_templateNames", t), p.assert.isArray("_startTimes", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("addScheduleFromTemplateMulti(address[],bytes32[],uint256[])", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("addScheduleFromTemplateMulti(address[],bytes32[],uint256[])").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isArray("_beneficiaries", e), p.assert.isArray("_templateNames", t), p.assert.isArray("_startTimes", a), this._strictEncodeArguments("addScheduleFromTemplateMulti(address[],bytes32[],uint256[])", [e, t, a]);
        }
      }, u.revokeSchedulesMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_beneficiaries", e), n = (r = this)._strictEncodeArguments("revokeSchedulesMulti(address[])", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.revokeSchedulesMulti.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_beneficiaries", e), n = (r = this)._strictEncodeArguments("revokeSchedulesMulti(address[])", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_beneficiaries", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("revokeSchedulesMulti(address[])", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("revokeSchedulesMulti(address[])").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isArray("_beneficiaries", e), this._strictEncodeArguments("revokeSchedulesMulti(address[])", [e]);
        }
      }, u.modifyScheduleMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_beneficiaries", e), p.assert.isArray("_templateNames", t), p.assert.isArray("_startTimes", a), c = (o = this)._strictEncodeArguments("modifyScheduleMulti(address[],bytes32[],uint256[])", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.modifyScheduleMulti.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_beneficiaries", e), p.assert.isArray("_templateNames", t), p.assert.isArray("_startTimes", a), c = (o = this)._strictEncodeArguments("modifyScheduleMulti(address[],bytes32[],uint256[])", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_beneficiaries", e), p.assert.isArray("_templateNames", t), p.assert.isArray("_startTimes", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("modifyScheduleMulti(address[],bytes32[],uint256[])", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("modifyScheduleMulti(address[],bytes32[],uint256[])").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isArray("_beneficiaries", e), p.assert.isArray("_templateNames", t), p.assert.isArray("_startTimes", a), this._strictEncodeArguments("modifyScheduleMulti(address[],bytes32[],uint256[])", [e, t, a]);
        }
      }, u.getPermissions = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getPermissions()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getPermissions()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getPermissions()", []);
        }
      }, u._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, l.classUtils.bindAll(u, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), u;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n, s, u) {
      return o(this, void 0, void 0, function () {
        var o, b, m, v, _, g, A, w, T, x, D;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return p.assert.isHexString("bytecode", e), p.assert.doesConformToSchema("txDefaults", n, f.schemas.txDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), o = l.providerUtils.standardizeOrThrow(r), b = d.BaseContract._lookupConstructorAbi(a), D = c(d.BaseContract._formatABIDataItemList(b.inputs, [s, u], d.BaseContract._bigNumberToString), 2), s = D[0], u = D[1], m = new y.utils.Interface(a), v = m.deployFunction, _ = v.encode(e, [s, u]), g = new h.Web3Wrapper(o), [4, d.BaseContract._applyDefaultsToTxDataAsync({
                data: _
              }, n, g.estimateGasAsync.bind(g))];

            case 1:
              return A = i.sent(), [4, g.sendTransactionAsync(A)];

            case 2:
              return w = i.sent(), l.logUtils.log("transactionHash: " + w), [4, g.awaitTransactionSuccessAsync(w)];

            case 3:
              return T = i.sent(), l.logUtils.log("VestingEscrowWallet successfully deployed at " + T.contractAddress), (x = new t(T.contractAddress, o, n)).constructorArgs = [s, u], [2, x];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !1,
        inputs: [],
        name: "reclaimETH",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "ADMIN",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "unpause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "treasuryWallet",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "unassignedTokens",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "paused",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "polyToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "pause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "address"
        }, {
          name: "index_1",
          type: "uint256"
        }],
        name: "schedules",
        outputs: [{
          name: "templateName",
          type: "bytes32"
        }, {
          name: "claimedTokens",
          type: "uint256"
        }, {
          name: "startTime",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenContract",
          type: "address"
        }],
        name: "reclaimERC20",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "OPERATOR",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "securityToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "factory",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "uint256"
        }],
        name: "templateNames",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "uint256"
        }],
        name: "beneficiaries",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDataStore",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        inputs: [{
          name: "_securityToken",
          type: "address"
        }, {
          name: "_polyAddress",
          type: "address"
        }],
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "constructor"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address",
          indexed: !0
        }, {
          name: "_templateName",
          type: "bytes32",
          indexed: !1
        }, {
          name: "_startTime",
          type: "uint256",
          indexed: !1
        }],
        name: "AddSchedule",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address",
          indexed: !0
        }, {
          name: "_templateName",
          type: "bytes32",
          indexed: !1
        }, {
          name: "_startTime",
          type: "uint256",
          indexed: !1
        }],
        name: "ModifySchedule",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address",
          indexed: !0
        }],
        name: "RevokeAllSchedules",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address",
          indexed: !0
        }, {
          name: "_templateName",
          type: "bytes32",
          indexed: !1
        }],
        name: "RevokeSchedule",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_numberOfTokens",
          type: "uint256",
          indexed: !1
        }, {
          name: "_sender",
          type: "address",
          indexed: !1
        }],
        name: "DepositTokens",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_numberOfTokens",
          type: "uint256",
          indexed: !1
        }, {
          name: "_sender",
          type: "address",
          indexed: !1
        }],
        name: "SendToTreasury",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address",
          indexed: !0
        }, {
          name: "_numberOfTokens",
          type: "uint256",
          indexed: !1
        }],
        name: "SendTokens",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_name",
          type: "bytes32",
          indexed: !1
        }, {
          name: "_numberOfTokens",
          type: "uint256",
          indexed: !1
        }, {
          name: "_duration",
          type: "uint256",
          indexed: !1
        }, {
          name: "_frequency",
          type: "uint256",
          indexed: !1
        }],
        name: "AddTemplate",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_name",
          type: "bytes32",
          indexed: !1
        }],
        name: "RemoveTemplate",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_newWallet",
          type: "address",
          indexed: !1
        }, {
          name: "_oldWallet",
          type: "address",
          indexed: !1
        }],
        name: "TreasuryWalletChanged",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Pause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Unpause",
        outputs: [],
        type: "event"
      }, {
        constant: !0,
        inputs: [],
        name: "getInitFunction",
        outputs: [{
          name: "",
          type: "bytes4"
        }],
        payable: !1,
        stateMutability: "pure",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_treasuryWallet",
          type: "address"
        }],
        name: "configure",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_newTreasuryWallet",
          type: "address"
        }],
        name: "changeTreasuryWallet",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_numberOfTokens",
          type: "uint256"
        }],
        name: "depositTokens",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_amount",
          type: "uint256"
        }],
        name: "sendToTreasury",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getTreasuryWallet",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address"
        }],
        name: "pushAvailableTokens",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "pullAvailableTokens",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_name",
          type: "bytes32"
        }, {
          name: "_numberOfTokens",
          type: "uint256"
        }, {
          name: "_duration",
          type: "uint256"
        }, {
          name: "_frequency",
          type: "uint256"
        }],
        name: "addTemplate",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_name",
          type: "bytes32"
        }],
        name: "removeTemplate",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getTemplateCount",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getAllTemplateNames",
        outputs: [{
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address"
        }, {
          name: "_templateName",
          type: "bytes32"
        }, {
          name: "_numberOfTokens",
          type: "uint256"
        }, {
          name: "_duration",
          type: "uint256"
        }, {
          name: "_frequency",
          type: "uint256"
        }, {
          name: "_startTime",
          type: "uint256"
        }],
        name: "addSchedule",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address"
        }, {
          name: "_templateName",
          type: "bytes32"
        }, {
          name: "_startTime",
          type: "uint256"
        }],
        name: "addScheduleFromTemplate",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address"
        }, {
          name: "_templateName",
          type: "bytes32"
        }, {
          name: "_startTime",
          type: "uint256"
        }],
        name: "modifySchedule",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address"
        }, {
          name: "_templateName",
          type: "bytes32"
        }],
        name: "revokeSchedule",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address"
        }],
        name: "revokeAllSchedules",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_beneficiary",
          type: "address"
        }, {
          name: "_templateName",
          type: "bytes32"
        }],
        name: "getSchedule",
        outputs: [{
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint8"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_beneficiary",
          type: "address"
        }],
        name: "getTemplateNames",
        outputs: [{
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_beneficiary",
          type: "address"
        }],
        name: "getScheduleCount",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_fromIndex",
          type: "uint256"
        }, {
          name: "_toIndex",
          type: "uint256"
        }],
        name: "pushAvailableTokensMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiaries",
          type: "address[]"
        }, {
          name: "_templateNames",
          type: "bytes32[]"
        }, {
          name: "_numberOfTokens",
          type: "uint256[]"
        }, {
          name: "_durations",
          type: "uint256[]"
        }, {
          name: "_frequencies",
          type: "uint256[]"
        }, {
          name: "_startTimes",
          type: "uint256[]"
        }],
        name: "addScheduleMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiaries",
          type: "address[]"
        }, {
          name: "_templateNames",
          type: "bytes32[]"
        }, {
          name: "_startTimes",
          type: "uint256[]"
        }],
        name: "addScheduleFromTemplateMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiaries",
          type: "address[]"
        }],
        name: "revokeSchedulesMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiaries",
          type: "address[]"
        }, {
          name: "_templateNames",
          type: "bytes32[]"
        }, {
          name: "_startTimes",
          type: "uint256[]"
        }],
        name: "modifyScheduleMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getPermissions",
        outputs: [{
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(d.BaseContract);

  t.VestingEscrowWalletContract_3_0_0 = v, t.isVestingEscrowWalletContract_3_0_0 = function (e) {
    return m.isEqual(v.ABI(), e.abi);
  };
},
/*!***************************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/volume_restriction_t_m.js ***!
  \***************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r102,
      n = this && this.__extends || (_r102 = function r(e, t) {
    return (_r102 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r102(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      c = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || 0 < t--) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u,
      d = a(
  /*! @0x/base-contract */
  12),
      f = a(
  /*! @0x/json-schemas */
  2),
      l = a(
  /*! @0x/utils */
  8),
      h = a(
  /*! @0x/web3-wrapper */
  11),
      p = a(
  /*! @0x/assert */
  10),
      b = a(
  /*! ../../PolyResponse */
  14),
      m = a(
  /*! lodash */
  0),
      y = a(
  /*! ethers */
  13);
  (u = t.VolumeRestrictionTMEvents_3_0_0 || (t.VolumeRestrictionTMEvents_3_0_0 = {})).ChangedExemptWalletList = "ChangedExemptWalletList", u.AddIndividualRestriction = "AddIndividualRestriction", u.AddIndividualDailyRestriction = "AddIndividualDailyRestriction", u.ModifyIndividualRestriction = "ModifyIndividualRestriction", u.ModifyIndividualDailyRestriction = "ModifyIndividualDailyRestriction", u.AddDefaultRestriction = "AddDefaultRestriction", u.AddDefaultDailyRestriction = "AddDefaultDailyRestriction", u.ModifyDefaultRestriction = "ModifyDefaultRestriction", u.ModifyDefaultDailyRestriction = "ModifyDefaultDailyRestriction", u.IndividualRestrictionRemoved = "IndividualRestrictionRemoved", u.IndividualDailyRestrictionRemoved = "IndividualDailyRestrictionRemoved", u.DefaultRestrictionRemoved = "DefaultRestrictionRemoved", u.DefaultDailyRestrictionRemoved = "DefaultDailyRestrictionRemoved", u.Pause = "Pause", u.Unpause = "Unpause";

  var v = function (e) {
    function t(a, r, n, c) {
      var u = e.call(this, "VolumeRestrictionTM", t.ABI(), a, r, n) || this;
      return u.reclaimETH = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.reclaimETH.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("reclaimETH()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("reclaimETH()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("reclaimETH()", []);
        }
      }, u.ADMIN = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("ADMIN()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("ADMIN()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("ADMIN()", []);
        }
      }, u.unpause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.unpause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("unpause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("unpause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("unpause()", []);
        }
      }, u.paused = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("paused()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("paused()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("paused()", []);
        }
      }, u.UNLOCKED = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("UNLOCKED()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("UNLOCKED()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("UNLOCKED()", []);
        }
      }, u.polyToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("polyToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("polyToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("polyToken()", []);
        }
      }, u.pause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.pause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pause()", []);
        }
      }, u.reclaimERC20 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.reclaimERC20.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("reclaimERC20(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_tokenContract", e), this._strictEncodeArguments("reclaimERC20(address)", [e]);
        }
      }, u.OPERATOR = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("OPERATOR()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("OPERATOR()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("OPERATOR()", []);
        }
      }, u.LOCKED = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("LOCKED()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("LOCKED()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("LOCKED()", []);
        }
      }, u.securityToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("securityToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("securityToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("securityToken()", []);
        }
      }, u.factory = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("factory()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("factory()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("factory()", []);
        }
      }, u.getDataStore = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDataStore()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDataStore()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDataStore()", []);
        }
      }, u.executeTransfer = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("index_1", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), u = (o = this)._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.executeTransfer.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("index_1", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), u = (o = this)._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("index_1", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("executeTransfer(address,address,uint256,bytes)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isString("_from", e), p.assert.isString("index_1", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), this._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]);
        }
      }, u.verifyTransfer = {
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("index_1", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("verifyTransfer(address,address,uint256,bytes)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("verifyTransfer(address,address,uint256,bytes)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isString("_from", e), p.assert.isString("index_1", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), this._strictEncodeArguments("verifyTransfer(address,address,uint256,bytes)", [e, t, a, r]);
        }
      }, u.changeExemptWalletList = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_wallet", e), p.assert.isBoolean("_exempted", t), o = (n = this)._strictEncodeArguments("changeExemptWalletList(address,bool)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.changeExemptWalletList.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_wallet", e), p.assert.isBoolean("_exempted", t), o = (n = this)._strictEncodeArguments("changeExemptWalletList(address,bool)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_wallet", e), p.assert.isBoolean("_exempted", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("changeExemptWalletList(address,bool)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("changeExemptWalletList(address,bool)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_wallet", e), p.assert.isBoolean("_exempted", t), this._strictEncodeArguments("changeExemptWalletList(address,bool)", [e, t]);
        }
      }, u.addIndividualRestriction = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u, f) {
          return o(this, void 0, void 0, function () {
            var o, l, h, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_holder", e), p.assert.isBigNumber("_allowedTokens", t), p.assert.isBigNumber("_startTime", a), p.assert.isBigNumber("_rollingPeriodInDays", r), p.assert.isBigNumber("_endTime", n), p.assert.isNumberOrBigNumber("_restrictionType", c), l = (o = this)._strictEncodeArguments("addIndividualRestriction(address,uint256,uint256,uint256,uint256,uint8)", [e, t, a, r, n, c]), h = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return m = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: l
                  }), s({
                    from: m
                  }, h), o.addIndividualRestriction.estimateGasAsync.bind(o, e, t, a, r, n, c, f))];

                case 2:
                  return void 0 !== (y = i.sent()).from && (y.from = y.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(y)];

                case 3:
                  return v = i.sent(), _ = o._web3Wrapper.awaitTransactionSuccessAsync(v), [2, new b.PolyResponse(v, _)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u, f) {
          return o(this, void 0, void 0, function () {
            var o, l, h, b, m, y, v, _, g;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_holder", e), p.assert.isBigNumber("_allowedTokens", t), p.assert.isBigNumber("_startTime", a), p.assert.isBigNumber("_rollingPeriodInDays", r), p.assert.isBigNumber("_endTime", n), p.assert.isNumberOrBigNumber("_restrictionType", c), l = (o = this)._strictEncodeArguments("addIndividualRestriction(address,uint256,uint256,uint256,uint256,uint8)", [e, t, a, r, n, c]), h = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return b = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, f, {
                    data: l
                  }), s({
                    from: b
                  }, h))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(m)];

                case 3:
                  return y = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return v = i.sent().gasLimit, _ = void 0 === u ? o._defaultEstimateGasFactor : u, g = Math.round(_ * y), [2, v < g ? v : g];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u, l) {
          return void 0 === u && (u = {}), o(this, void 0, void 0, function () {
            var o, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_holder", e), p.assert.isBigNumber("_allowedTokens", t), p.assert.isBigNumber("_startTime", a), p.assert.isBigNumber("_rollingPeriodInDays", r), p.assert.isBigNumber("_endTime", n), p.assert.isNumberOrBigNumber("_restrictionType", c), p.assert.doesConformToSchema("callData", u, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== l && p.assert.isBlockParam("defaultBlock", l), h = (o = this)._strictEncodeArguments("addIndividualRestriction(address,uint256,uint256,uint256,uint256,uint8)", [e, t, a, r, n, c]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: h
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (b = i.sent()).from = b.from ? b.from.toLowerCase() : b.from, [4, o._web3Wrapper.callAsync(b, l)];

                case 2:
                  return m = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(m), [2, o._lookupAbiEncoder("addIndividualRestriction(address,uint256,uint256,uint256,uint256,uint8)").strictDecodeReturnValue(m)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s) {
          return p.assert.isString("_holder", e), p.assert.isBigNumber("_allowedTokens", t), p.assert.isBigNumber("_startTime", a), p.assert.isBigNumber("_rollingPeriodInDays", r), p.assert.isBigNumber("_endTime", n), p.assert.isNumberOrBigNumber("_restrictionType", s), this._strictEncodeArguments("addIndividualRestriction(address,uint256,uint256,uint256,uint256,uint8)", [e, t, a, r, n, s]);
        }
      }, u.addIndividualDailyRestriction = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_holder", e), p.assert.isBigNumber("_allowedTokens", t), p.assert.isBigNumber("_startTime", a), p.assert.isBigNumber("_endTime", r), p.assert.isNumberOrBigNumber("_restrictionType", n), f = (o = this)._strictEncodeArguments("addIndividualDailyRestriction(address,uint256,uint256,uint256,uint8)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: f
                  }), s({
                    from: h
                  }, l), o.addIndividualDailyRestriction.estimateGasAsync.bind(o, e, t, a, r, n, u))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(m)];

                case 3:
                  return y = i.sent(), v = o._web3Wrapper.awaitTransactionSuccessAsync(y), [2, new b.PolyResponse(y, v)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_holder", e), p.assert.isBigNumber("_allowedTokens", t), p.assert.isBigNumber("_startTime", a), p.assert.isBigNumber("_endTime", r), p.assert.isNumberOrBigNumber("_restrictionType", n), f = (o = this)._strictEncodeArguments("addIndividualDailyRestriction(address,uint256,uint256,uint256,uint8)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: f
                  }), s({
                    from: h
                  }, l))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(b)];

                case 3:
                  return m = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return y = i.sent().gasLimit, v = void 0 === c ? o._defaultEstimateGasFactor : c, _ = Math.round(v * m), [2, y < _ ? y : _];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u) {
          return void 0 === c && (c = {}), o(this, void 0, void 0, function () {
            var o, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_holder", e), p.assert.isBigNumber("_allowedTokens", t), p.assert.isBigNumber("_startTime", a), p.assert.isBigNumber("_endTime", r), p.assert.isNumberOrBigNumber("_restrictionType", n), p.assert.doesConformToSchema("callData", c, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== u && p.assert.isBlockParam("defaultBlock", u), l = (o = this)._strictEncodeArguments("addIndividualDailyRestriction(address,uint256,uint256,uint256,uint8)", [e, t, a, r, n]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: l
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (h = i.sent()).from = h.from ? h.from.toLowerCase() : h.from, [4, o._web3Wrapper.callAsync(h, u)];

                case 2:
                  return b = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(b), [2, o._lookupAbiEncoder("addIndividualDailyRestriction(address,uint256,uint256,uint256,uint8)").strictDecodeReturnValue(b)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n) {
          return p.assert.isString("_holder", e), p.assert.isBigNumber("_allowedTokens", t), p.assert.isBigNumber("_startTime", a), p.assert.isBigNumber("_endTime", r), p.assert.isNumberOrBigNumber("_restrictionType", n), this._strictEncodeArguments("addIndividualDailyRestriction(address,uint256,uint256,uint256,uint8)", [e, t, a, r, n]);
        }
      }, u.addIndividualDailyRestrictionMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_holders", e), p.assert.isArray("_allowedTokens", t), p.assert.isArray("_startTimes", a), p.assert.isArray("_endTimes", r), p.assert.isArray("_restrictionTypes", n), f = (o = this)._strictEncodeArguments("addIndividualDailyRestrictionMulti(address[],uint256[],uint256[],uint256[],uint8[])", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: f
                  }), s({
                    from: h
                  }, l), o.addIndividualDailyRestrictionMulti.estimateGasAsync.bind(o, e, t, a, r, n, u))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(m)];

                case 3:
                  return y = i.sent(), v = o._web3Wrapper.awaitTransactionSuccessAsync(y), [2, new b.PolyResponse(y, v)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_holders", e), p.assert.isArray("_allowedTokens", t), p.assert.isArray("_startTimes", a), p.assert.isArray("_endTimes", r), p.assert.isArray("_restrictionTypes", n), f = (o = this)._strictEncodeArguments("addIndividualDailyRestrictionMulti(address[],uint256[],uint256[],uint256[],uint8[])", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: f
                  }), s({
                    from: h
                  }, l))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(b)];

                case 3:
                  return m = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return y = i.sent().gasLimit, v = void 0 === c ? o._defaultEstimateGasFactor : c, _ = Math.round(v * m), [2, y < _ ? y : _];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u) {
          return void 0 === c && (c = {}), o(this, void 0, void 0, function () {
            var o, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_holders", e), p.assert.isArray("_allowedTokens", t), p.assert.isArray("_startTimes", a), p.assert.isArray("_endTimes", r), p.assert.isArray("_restrictionTypes", n), p.assert.doesConformToSchema("callData", c, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== u && p.assert.isBlockParam("defaultBlock", u), l = (o = this)._strictEncodeArguments("addIndividualDailyRestrictionMulti(address[],uint256[],uint256[],uint256[],uint8[])", [e, t, a, r, n]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: l
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (h = i.sent()).from = h.from ? h.from.toLowerCase() : h.from, [4, o._web3Wrapper.callAsync(h, u)];

                case 2:
                  return b = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(b), [2, o._lookupAbiEncoder("addIndividualDailyRestrictionMulti(address[],uint256[],uint256[],uint256[],uint8[])").strictDecodeReturnValue(b)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n) {
          return p.assert.isArray("_holders", e), p.assert.isArray("_allowedTokens", t), p.assert.isArray("_startTimes", a), p.assert.isArray("_endTimes", r), p.assert.isArray("_restrictionTypes", n), this._strictEncodeArguments("addIndividualDailyRestrictionMulti(address[],uint256[],uint256[],uint256[],uint8[])", [e, t, a, r, n]);
        }
      }, u.addIndividualRestrictionMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u, f) {
          return o(this, void 0, void 0, function () {
            var o, l, h, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_holders", e), p.assert.isArray("_allowedTokens", t), p.assert.isArray("_startTimes", a), p.assert.isArray("_rollingPeriodInDays", r), p.assert.isArray("_endTimes", n), p.assert.isArray("_restrictionTypes", c), l = (o = this)._strictEncodeArguments("addIndividualRestrictionMulti(address[],uint256[],uint256[],uint256[],uint256[],uint8[])", [e, t, a, r, n, c]), h = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return m = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: l
                  }), s({
                    from: m
                  }, h), o.addIndividualRestrictionMulti.estimateGasAsync.bind(o, e, t, a, r, n, c, f))];

                case 2:
                  return void 0 !== (y = i.sent()).from && (y.from = y.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(y)];

                case 3:
                  return v = i.sent(), _ = o._web3Wrapper.awaitTransactionSuccessAsync(v), [2, new b.PolyResponse(v, _)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u, f) {
          return o(this, void 0, void 0, function () {
            var o, l, h, b, m, y, v, _, g;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_holders", e), p.assert.isArray("_allowedTokens", t), p.assert.isArray("_startTimes", a), p.assert.isArray("_rollingPeriodInDays", r), p.assert.isArray("_endTimes", n), p.assert.isArray("_restrictionTypes", c), l = (o = this)._strictEncodeArguments("addIndividualRestrictionMulti(address[],uint256[],uint256[],uint256[],uint256[],uint8[])", [e, t, a, r, n, c]), h = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return b = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, f, {
                    data: l
                  }), s({
                    from: b
                  }, h))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(m)];

                case 3:
                  return y = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return v = i.sent().gasLimit, _ = void 0 === u ? o._defaultEstimateGasFactor : u, g = Math.round(_ * y), [2, v < g ? v : g];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u, l) {
          return void 0 === u && (u = {}), o(this, void 0, void 0, function () {
            var o, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_holders", e), p.assert.isArray("_allowedTokens", t), p.assert.isArray("_startTimes", a), p.assert.isArray("_rollingPeriodInDays", r), p.assert.isArray("_endTimes", n), p.assert.isArray("_restrictionTypes", c), p.assert.doesConformToSchema("callData", u, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== l && p.assert.isBlockParam("defaultBlock", l), h = (o = this)._strictEncodeArguments("addIndividualRestrictionMulti(address[],uint256[],uint256[],uint256[],uint256[],uint8[])", [e, t, a, r, n, c]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: h
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (b = i.sent()).from = b.from ? b.from.toLowerCase() : b.from, [4, o._web3Wrapper.callAsync(b, l)];

                case 2:
                  return m = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(m), [2, o._lookupAbiEncoder("addIndividualRestrictionMulti(address[],uint256[],uint256[],uint256[],uint256[],uint8[])").strictDecodeReturnValue(m)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s) {
          return p.assert.isArray("_holders", e), p.assert.isArray("_allowedTokens", t), p.assert.isArray("_startTimes", a), p.assert.isArray("_rollingPeriodInDays", r), p.assert.isArray("_endTimes", n), p.assert.isArray("_restrictionTypes", s), this._strictEncodeArguments("addIndividualRestrictionMulti(address[],uint256[],uint256[],uint256[],uint256[],uint8[])", [e, t, a, r, n, s]);
        }
      }, u.addDefaultRestriction = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_allowedTokens", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_rollingPeriodInDays", a), p.assert.isBigNumber("_endTime", r), p.assert.isNumberOrBigNumber("_restrictionType", n), f = (o = this)._strictEncodeArguments("addDefaultRestriction(uint256,uint256,uint256,uint256,uint8)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: f
                  }), s({
                    from: h
                  }, l), o.addDefaultRestriction.estimateGasAsync.bind(o, e, t, a, r, n, u))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(m)];

                case 3:
                  return y = i.sent(), v = o._web3Wrapper.awaitTransactionSuccessAsync(y), [2, new b.PolyResponse(y, v)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_allowedTokens", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_rollingPeriodInDays", a), p.assert.isBigNumber("_endTime", r), p.assert.isNumberOrBigNumber("_restrictionType", n), f = (o = this)._strictEncodeArguments("addDefaultRestriction(uint256,uint256,uint256,uint256,uint8)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: f
                  }), s({
                    from: h
                  }, l))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(b)];

                case 3:
                  return m = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return y = i.sent().gasLimit, v = void 0 === c ? o._defaultEstimateGasFactor : c, _ = Math.round(v * m), [2, y < _ ? y : _];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u) {
          return void 0 === c && (c = {}), o(this, void 0, void 0, function () {
            var o, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_allowedTokens", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_rollingPeriodInDays", a), p.assert.isBigNumber("_endTime", r), p.assert.isNumberOrBigNumber("_restrictionType", n), p.assert.doesConformToSchema("callData", c, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== u && p.assert.isBlockParam("defaultBlock", u), l = (o = this)._strictEncodeArguments("addDefaultRestriction(uint256,uint256,uint256,uint256,uint8)", [e, t, a, r, n]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: l
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (h = i.sent()).from = h.from ? h.from.toLowerCase() : h.from, [4, o._web3Wrapper.callAsync(h, u)];

                case 2:
                  return b = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(b), [2, o._lookupAbiEncoder("addDefaultRestriction(uint256,uint256,uint256,uint256,uint8)").strictDecodeReturnValue(b)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n) {
          return p.assert.isBigNumber("_allowedTokens", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_rollingPeriodInDays", a), p.assert.isBigNumber("_endTime", r), p.assert.isNumberOrBigNumber("_restrictionType", n), this._strictEncodeArguments("addDefaultRestriction(uint256,uint256,uint256,uint256,uint8)", [e, t, a, r, n]);
        }
      }, u.addDefaultDailyRestriction = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_allowedTokens", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_endTime", a), p.assert.isNumberOrBigNumber("_restrictionType", r), u = (o = this)._strictEncodeArguments("addDefaultDailyRestriction(uint256,uint256,uint256,uint8)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.addDefaultDailyRestriction.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_allowedTokens", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_endTime", a), p.assert.isNumberOrBigNumber("_restrictionType", r), u = (o = this)._strictEncodeArguments("addDefaultDailyRestriction(uint256,uint256,uint256,uint8)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_allowedTokens", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_endTime", a), p.assert.isNumberOrBigNumber("_restrictionType", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("addDefaultDailyRestriction(uint256,uint256,uint256,uint8)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("addDefaultDailyRestriction(uint256,uint256,uint256,uint8)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isBigNumber("_allowedTokens", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_endTime", a), p.assert.isNumberOrBigNumber("_restrictionType", r), this._strictEncodeArguments("addDefaultDailyRestriction(uint256,uint256,uint256,uint8)", [e, t, a, r]);
        }
      }, u.removeIndividualRestriction = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_holder", e), n = (r = this)._strictEncodeArguments("removeIndividualRestriction(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.removeIndividualRestriction.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_holder", e), n = (r = this)._strictEncodeArguments("removeIndividualRestriction(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_holder", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("removeIndividualRestriction(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("removeIndividualRestriction(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_holder", e), this._strictEncodeArguments("removeIndividualRestriction(address)", [e]);
        }
      }, u.removeIndividualRestrictionMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_holders", e), n = (r = this)._strictEncodeArguments("removeIndividualRestrictionMulti(address[])", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.removeIndividualRestrictionMulti.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_holders", e), n = (r = this)._strictEncodeArguments("removeIndividualRestrictionMulti(address[])", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_holders", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("removeIndividualRestrictionMulti(address[])", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("removeIndividualRestrictionMulti(address[])").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isArray("_holders", e), this._strictEncodeArguments("removeIndividualRestrictionMulti(address[])", [e]);
        }
      }, u.removeIndividualDailyRestriction = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_holder", e), n = (r = this)._strictEncodeArguments("removeIndividualDailyRestriction(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.removeIndividualDailyRestriction.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_holder", e), n = (r = this)._strictEncodeArguments("removeIndividualDailyRestriction(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_holder", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("removeIndividualDailyRestriction(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("removeIndividualDailyRestriction(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_holder", e), this._strictEncodeArguments("removeIndividualDailyRestriction(address)", [e]);
        }
      }, u.removeIndividualDailyRestrictionMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_holders", e), n = (r = this)._strictEncodeArguments("removeIndividualDailyRestrictionMulti(address[])", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.removeIndividualDailyRestrictionMulti.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_holders", e), n = (r = this)._strictEncodeArguments("removeIndividualDailyRestrictionMulti(address[])", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_holders", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("removeIndividualDailyRestrictionMulti(address[])", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("removeIndividualDailyRestrictionMulti(address[])").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isArray("_holders", e), this._strictEncodeArguments("removeIndividualDailyRestrictionMulti(address[])", [e]);
        }
      }, u.removeDefaultRestriction = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("removeDefaultRestriction()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.removeDefaultRestriction.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("removeDefaultRestriction()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("removeDefaultRestriction()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("removeDefaultRestriction()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("removeDefaultRestriction()", []);
        }
      }, u.removeDefaultDailyRestriction = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("removeDefaultDailyRestriction()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.removeDefaultDailyRestriction.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("removeDefaultDailyRestriction()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("removeDefaultDailyRestriction()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("removeDefaultDailyRestriction()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("removeDefaultDailyRestriction()", []);
        }
      }, u.modifyIndividualRestriction = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u, f) {
          return o(this, void 0, void 0, function () {
            var o, l, h, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_holder", e), p.assert.isBigNumber("_allowedTokens", t), p.assert.isBigNumber("_startTime", a), p.assert.isBigNumber("_rollingPeriodInDays", r), p.assert.isBigNumber("_endTime", n), p.assert.isNumberOrBigNumber("_restrictionType", c), l = (o = this)._strictEncodeArguments("modifyIndividualRestriction(address,uint256,uint256,uint256,uint256,uint8)", [e, t, a, r, n, c]), h = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return m = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: l
                  }), s({
                    from: m
                  }, h), o.modifyIndividualRestriction.estimateGasAsync.bind(o, e, t, a, r, n, c, f))];

                case 2:
                  return void 0 !== (y = i.sent()).from && (y.from = y.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(y)];

                case 3:
                  return v = i.sent(), _ = o._web3Wrapper.awaitTransactionSuccessAsync(v), [2, new b.PolyResponse(v, _)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u, f) {
          return o(this, void 0, void 0, function () {
            var o, l, h, b, m, y, v, _, g;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_holder", e), p.assert.isBigNumber("_allowedTokens", t), p.assert.isBigNumber("_startTime", a), p.assert.isBigNumber("_rollingPeriodInDays", r), p.assert.isBigNumber("_endTime", n), p.assert.isNumberOrBigNumber("_restrictionType", c), l = (o = this)._strictEncodeArguments("modifyIndividualRestriction(address,uint256,uint256,uint256,uint256,uint8)", [e, t, a, r, n, c]), h = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return b = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, f, {
                    data: l
                  }), s({
                    from: b
                  }, h))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(m)];

                case 3:
                  return y = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return v = i.sent().gasLimit, _ = void 0 === u ? o._defaultEstimateGasFactor : u, g = Math.round(_ * y), [2, v < g ? v : g];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u, l) {
          return void 0 === u && (u = {}), o(this, void 0, void 0, function () {
            var o, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_holder", e), p.assert.isBigNumber("_allowedTokens", t), p.assert.isBigNumber("_startTime", a), p.assert.isBigNumber("_rollingPeriodInDays", r), p.assert.isBigNumber("_endTime", n), p.assert.isNumberOrBigNumber("_restrictionType", c), p.assert.doesConformToSchema("callData", u, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== l && p.assert.isBlockParam("defaultBlock", l), h = (o = this)._strictEncodeArguments("modifyIndividualRestriction(address,uint256,uint256,uint256,uint256,uint8)", [e, t, a, r, n, c]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: h
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (b = i.sent()).from = b.from ? b.from.toLowerCase() : b.from, [4, o._web3Wrapper.callAsync(b, l)];

                case 2:
                  return m = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(m), [2, o._lookupAbiEncoder("modifyIndividualRestriction(address,uint256,uint256,uint256,uint256,uint8)").strictDecodeReturnValue(m)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s) {
          return p.assert.isString("_holder", e), p.assert.isBigNumber("_allowedTokens", t), p.assert.isBigNumber("_startTime", a), p.assert.isBigNumber("_rollingPeriodInDays", r), p.assert.isBigNumber("_endTime", n), p.assert.isNumberOrBigNumber("_restrictionType", s), this._strictEncodeArguments("modifyIndividualRestriction(address,uint256,uint256,uint256,uint256,uint8)", [e, t, a, r, n, s]);
        }
      }, u.modifyIndividualDailyRestriction = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_holder", e), p.assert.isBigNumber("_allowedTokens", t), p.assert.isBigNumber("_startTime", a), p.assert.isBigNumber("_endTime", r), p.assert.isNumberOrBigNumber("_restrictionType", n), f = (o = this)._strictEncodeArguments("modifyIndividualDailyRestriction(address,uint256,uint256,uint256,uint8)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: f
                  }), s({
                    from: h
                  }, l), o.modifyIndividualDailyRestriction.estimateGasAsync.bind(o, e, t, a, r, n, u))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(m)];

                case 3:
                  return y = i.sent(), v = o._web3Wrapper.awaitTransactionSuccessAsync(y), [2, new b.PolyResponse(y, v)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_holder", e), p.assert.isBigNumber("_allowedTokens", t), p.assert.isBigNumber("_startTime", a), p.assert.isBigNumber("_endTime", r), p.assert.isNumberOrBigNumber("_restrictionType", n), f = (o = this)._strictEncodeArguments("modifyIndividualDailyRestriction(address,uint256,uint256,uint256,uint8)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: f
                  }), s({
                    from: h
                  }, l))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(b)];

                case 3:
                  return m = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return y = i.sent().gasLimit, v = void 0 === c ? o._defaultEstimateGasFactor : c, _ = Math.round(v * m), [2, y < _ ? y : _];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u) {
          return void 0 === c && (c = {}), o(this, void 0, void 0, function () {
            var o, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_holder", e), p.assert.isBigNumber("_allowedTokens", t), p.assert.isBigNumber("_startTime", a), p.assert.isBigNumber("_endTime", r), p.assert.isNumberOrBigNumber("_restrictionType", n), p.assert.doesConformToSchema("callData", c, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== u && p.assert.isBlockParam("defaultBlock", u), l = (o = this)._strictEncodeArguments("modifyIndividualDailyRestriction(address,uint256,uint256,uint256,uint8)", [e, t, a, r, n]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: l
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (h = i.sent()).from = h.from ? h.from.toLowerCase() : h.from, [4, o._web3Wrapper.callAsync(h, u)];

                case 2:
                  return b = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(b), [2, o._lookupAbiEncoder("modifyIndividualDailyRestriction(address,uint256,uint256,uint256,uint8)").strictDecodeReturnValue(b)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n) {
          return p.assert.isString("_holder", e), p.assert.isBigNumber("_allowedTokens", t), p.assert.isBigNumber("_startTime", a), p.assert.isBigNumber("_endTime", r), p.assert.isNumberOrBigNumber("_restrictionType", n), this._strictEncodeArguments("modifyIndividualDailyRestriction(address,uint256,uint256,uint256,uint8)", [e, t, a, r, n]);
        }
      }, u.modifyIndividualDailyRestrictionMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_holders", e), p.assert.isArray("_allowedTokens", t), p.assert.isArray("_startTimes", a), p.assert.isArray("_endTimes", r), p.assert.isArray("_restrictionTypes", n), f = (o = this)._strictEncodeArguments("modifyIndividualDailyRestrictionMulti(address[],uint256[],uint256[],uint256[],uint8[])", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: f
                  }), s({
                    from: h
                  }, l), o.modifyIndividualDailyRestrictionMulti.estimateGasAsync.bind(o, e, t, a, r, n, u))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(m)];

                case 3:
                  return y = i.sent(), v = o._web3Wrapper.awaitTransactionSuccessAsync(y), [2, new b.PolyResponse(y, v)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_holders", e), p.assert.isArray("_allowedTokens", t), p.assert.isArray("_startTimes", a), p.assert.isArray("_endTimes", r), p.assert.isArray("_restrictionTypes", n), f = (o = this)._strictEncodeArguments("modifyIndividualDailyRestrictionMulti(address[],uint256[],uint256[],uint256[],uint8[])", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: f
                  }), s({
                    from: h
                  }, l))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(b)];

                case 3:
                  return m = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return y = i.sent().gasLimit, v = void 0 === c ? o._defaultEstimateGasFactor : c, _ = Math.round(v * m), [2, y < _ ? y : _];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u) {
          return void 0 === c && (c = {}), o(this, void 0, void 0, function () {
            var o, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_holders", e), p.assert.isArray("_allowedTokens", t), p.assert.isArray("_startTimes", a), p.assert.isArray("_endTimes", r), p.assert.isArray("_restrictionTypes", n), p.assert.doesConformToSchema("callData", c, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== u && p.assert.isBlockParam("defaultBlock", u), l = (o = this)._strictEncodeArguments("modifyIndividualDailyRestrictionMulti(address[],uint256[],uint256[],uint256[],uint8[])", [e, t, a, r, n]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: l
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (h = i.sent()).from = h.from ? h.from.toLowerCase() : h.from, [4, o._web3Wrapper.callAsync(h, u)];

                case 2:
                  return b = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(b), [2, o._lookupAbiEncoder("modifyIndividualDailyRestrictionMulti(address[],uint256[],uint256[],uint256[],uint8[])").strictDecodeReturnValue(b)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n) {
          return p.assert.isArray("_holders", e), p.assert.isArray("_allowedTokens", t), p.assert.isArray("_startTimes", a), p.assert.isArray("_endTimes", r), p.assert.isArray("_restrictionTypes", n), this._strictEncodeArguments("modifyIndividualDailyRestrictionMulti(address[],uint256[],uint256[],uint256[],uint8[])", [e, t, a, r, n]);
        }
      }, u.modifyIndividualRestrictionMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u, f) {
          return o(this, void 0, void 0, function () {
            var o, l, h, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_holders", e), p.assert.isArray("_allowedTokens", t), p.assert.isArray("_startTimes", a), p.assert.isArray("_rollingPeriodInDays", r), p.assert.isArray("_endTimes", n), p.assert.isArray("_restrictionTypes", c), l = (o = this)._strictEncodeArguments("modifyIndividualRestrictionMulti(address[],uint256[],uint256[],uint256[],uint256[],uint8[])", [e, t, a, r, n, c]), h = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return m = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: l
                  }), s({
                    from: m
                  }, h), o.modifyIndividualRestrictionMulti.estimateGasAsync.bind(o, e, t, a, r, n, c, f))];

                case 2:
                  return void 0 !== (y = i.sent()).from && (y.from = y.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(y)];

                case 3:
                  return v = i.sent(), _ = o._web3Wrapper.awaitTransactionSuccessAsync(v), [2, new b.PolyResponse(v, _)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u, f) {
          return o(this, void 0, void 0, function () {
            var o, l, h, b, m, y, v, _, g;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_holders", e), p.assert.isArray("_allowedTokens", t), p.assert.isArray("_startTimes", a), p.assert.isArray("_rollingPeriodInDays", r), p.assert.isArray("_endTimes", n), p.assert.isArray("_restrictionTypes", c), l = (o = this)._strictEncodeArguments("modifyIndividualRestrictionMulti(address[],uint256[],uint256[],uint256[],uint256[],uint8[])", [e, t, a, r, n, c]), h = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return b = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, f, {
                    data: l
                  }), s({
                    from: b
                  }, h))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(m)];

                case 3:
                  return y = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return v = i.sent().gasLimit, _ = void 0 === u ? o._defaultEstimateGasFactor : u, g = Math.round(_ * y), [2, v < g ? v : g];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u, l) {
          return void 0 === u && (u = {}), o(this, void 0, void 0, function () {
            var o, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_holders", e), p.assert.isArray("_allowedTokens", t), p.assert.isArray("_startTimes", a), p.assert.isArray("_rollingPeriodInDays", r), p.assert.isArray("_endTimes", n), p.assert.isArray("_restrictionTypes", c), p.assert.doesConformToSchema("callData", u, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== l && p.assert.isBlockParam("defaultBlock", l), h = (o = this)._strictEncodeArguments("modifyIndividualRestrictionMulti(address[],uint256[],uint256[],uint256[],uint256[],uint8[])", [e, t, a, r, n, c]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: h
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (b = i.sent()).from = b.from ? b.from.toLowerCase() : b.from, [4, o._web3Wrapper.callAsync(b, l)];

                case 2:
                  return m = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(m), [2, o._lookupAbiEncoder("modifyIndividualRestrictionMulti(address[],uint256[],uint256[],uint256[],uint256[],uint8[])").strictDecodeReturnValue(m)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s) {
          return p.assert.isArray("_holders", e), p.assert.isArray("_allowedTokens", t), p.assert.isArray("_startTimes", a), p.assert.isArray("_rollingPeriodInDays", r), p.assert.isArray("_endTimes", n), p.assert.isArray("_restrictionTypes", s), this._strictEncodeArguments("modifyIndividualRestrictionMulti(address[],uint256[],uint256[],uint256[],uint256[],uint8[])", [e, t, a, r, n, s]);
        }
      }, u.modifyDefaultRestriction = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_allowedTokens", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_rollingPeriodInDays", a), p.assert.isBigNumber("_endTime", r), p.assert.isNumberOrBigNumber("_restrictionType", n), f = (o = this)._strictEncodeArguments("modifyDefaultRestriction(uint256,uint256,uint256,uint256,uint8)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: f
                  }), s({
                    from: h
                  }, l), o.modifyDefaultRestriction.estimateGasAsync.bind(o, e, t, a, r, n, u))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(m)];

                case 3:
                  return y = i.sent(), v = o._web3Wrapper.awaitTransactionSuccessAsync(y), [2, new b.PolyResponse(y, v)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_allowedTokens", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_rollingPeriodInDays", a), p.assert.isBigNumber("_endTime", r), p.assert.isNumberOrBigNumber("_restrictionType", n), f = (o = this)._strictEncodeArguments("modifyDefaultRestriction(uint256,uint256,uint256,uint256,uint8)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: f
                  }), s({
                    from: h
                  }, l))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(b)];

                case 3:
                  return m = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return y = i.sent().gasLimit, v = void 0 === c ? o._defaultEstimateGasFactor : c, _ = Math.round(v * m), [2, y < _ ? y : _];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u) {
          return void 0 === c && (c = {}), o(this, void 0, void 0, function () {
            var o, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_allowedTokens", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_rollingPeriodInDays", a), p.assert.isBigNumber("_endTime", r), p.assert.isNumberOrBigNumber("_restrictionType", n), p.assert.doesConformToSchema("callData", c, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== u && p.assert.isBlockParam("defaultBlock", u), l = (o = this)._strictEncodeArguments("modifyDefaultRestriction(uint256,uint256,uint256,uint256,uint8)", [e, t, a, r, n]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: l
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (h = i.sent()).from = h.from ? h.from.toLowerCase() : h.from, [4, o._web3Wrapper.callAsync(h, u)];

                case 2:
                  return b = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(b), [2, o._lookupAbiEncoder("modifyDefaultRestriction(uint256,uint256,uint256,uint256,uint8)").strictDecodeReturnValue(b)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n) {
          return p.assert.isBigNumber("_allowedTokens", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_rollingPeriodInDays", a), p.assert.isBigNumber("_endTime", r), p.assert.isNumberOrBigNumber("_restrictionType", n), this._strictEncodeArguments("modifyDefaultRestriction(uint256,uint256,uint256,uint256,uint8)", [e, t, a, r, n]);
        }
      }, u.modifyDefaultDailyRestriction = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_allowedTokens", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_endTime", a), p.assert.isNumberOrBigNumber("_restrictionType", r), u = (o = this)._strictEncodeArguments("modifyDefaultDailyRestriction(uint256,uint256,uint256,uint8)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.modifyDefaultDailyRestriction.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_allowedTokens", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_endTime", a), p.assert.isNumberOrBigNumber("_restrictionType", r), u = (o = this)._strictEncodeArguments("modifyDefaultDailyRestriction(uint256,uint256,uint256,uint8)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_allowedTokens", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_endTime", a), p.assert.isNumberOrBigNumber("_restrictionType", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("modifyDefaultDailyRestriction(uint256,uint256,uint256,uint8)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("modifyDefaultDailyRestriction(uint256,uint256,uint256,uint8)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isBigNumber("_allowedTokens", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_endTime", a), p.assert.isNumberOrBigNumber("_restrictionType", r), this._strictEncodeArguments("modifyDefaultDailyRestriction(uint256,uint256,uint256,uint8)", [e, t, a, r]);
        }
      }, u.getTokensByPartition = {
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_partition", e), p.assert.isString("_tokenHolder", t), p.assert.isBigNumber("_additionalBalance", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("getTokensByPartition(bytes32,address,uint256)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("getTokensByPartition(bytes32,address,uint256)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isString("_partition", e), p.assert.isString("_tokenHolder", t), p.assert.isBigNumber("_additionalBalance", a), this._strictEncodeArguments("getTokensByPartition(bytes32,address,uint256)", [e, t, a]);
        }
      }, u.getIndividualBucketDetailsToUser = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_user", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getIndividualBucketDetailsToUser(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getIndividualBucketDetailsToUser(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_user", e), this._strictEncodeArguments("getIndividualBucketDetailsToUser(address)", [e]);
        }
      }, u.getDefaultBucketDetailsToUser = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_user", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getDefaultBucketDetailsToUser(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getDefaultBucketDetailsToUser(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_user", e), this._strictEncodeArguments("getDefaultBucketDetailsToUser(address)", [e]);
        }
      }, u.getTotalTradedByUser = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_user", e), p.assert.isBigNumber("_at", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("getTotalTradedByUser(address,uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("getTotalTradedByUser(address,uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_user", e), p.assert.isBigNumber("_at", t), this._strictEncodeArguments("getTotalTradedByUser(address,uint256)", [e, t]);
        }
      }, u.getInitFunction = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getInitFunction()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getInitFunction()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getInitFunction()", []);
        }
      }, u.getExemptAddress = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getExemptAddress()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getExemptAddress()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getExemptAddress()", []);
        }
      }, u.getIndividualRestriction = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getIndividualRestriction(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getIndividualRestriction(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_investor", e), this._strictEncodeArguments("getIndividualRestriction(address)", [e]);
        }
      }, u.getIndividualDailyRestriction = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getIndividualDailyRestriction(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getIndividualDailyRestriction(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_investor", e), this._strictEncodeArguments("getIndividualDailyRestriction(address)", [e]);
        }
      }, u.getDefaultRestriction = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDefaultRestriction()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDefaultRestriction()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDefaultRestriction()", []);
        }
      }, u.getDefaultDailyRestriction = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDefaultDailyRestriction()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDefaultDailyRestriction()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDefaultDailyRestriction()", []);
        }
      }, u.getRestrictionData = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getRestrictionData()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getRestrictionData()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getRestrictionData()", []);
        }
      }, u.getPermissions = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getPermissions()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getPermissions()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getPermissions()", []);
        }
      }, u._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, l.classUtils.bindAll(u, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), u;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n, s, u) {
      return o(this, void 0, void 0, function () {
        var o, b, m, v, _, g, A, w, T, x, D;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return p.assert.isHexString("bytecode", e), p.assert.doesConformToSchema("txDefaults", n, f.schemas.txDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), o = l.providerUtils.standardizeOrThrow(r), b = d.BaseContract._lookupConstructorAbi(a), D = c(d.BaseContract._formatABIDataItemList(b.inputs, [s, u], d.BaseContract._bigNumberToString), 2), s = D[0], u = D[1], m = new y.utils.Interface(a), v = m.deployFunction, _ = v.encode(e, [s, u]), g = new h.Web3Wrapper(o), [4, d.BaseContract._applyDefaultsToTxDataAsync({
                data: _
              }, n, g.estimateGasAsync.bind(g))];

            case 1:
              return A = i.sent(), [4, g.sendTransactionAsync(A)];

            case 2:
              return w = i.sent(), l.logUtils.log("transactionHash: " + w), [4, g.awaitTransactionSuccessAsync(w)];

            case 3:
              return T = i.sent(), l.logUtils.log("VolumeRestrictionTM successfully deployed at " + T.contractAddress), (x = new t(T.contractAddress, o, n)).constructorArgs = [s, u], [2, x];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !1,
        inputs: [],
        name: "reclaimETH",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "ADMIN",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "unpause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "paused",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "UNLOCKED",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "polyToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "pause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenContract",
          type: "address"
        }],
        name: "reclaimERC20",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "OPERATOR",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "LOCKED",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "securityToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "factory",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDataStore",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        inputs: [{
          name: "_securityToken",
          type: "address"
        }, {
          name: "_polyAddress",
          type: "address"
        }],
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "constructor"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_wallet",
          type: "address",
          indexed: !0
        }, {
          name: "_exempted",
          type: "bool",
          indexed: !1
        }],
        name: "ChangedExemptWalletList",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_holder",
          type: "address",
          indexed: !0
        }, {
          name: "_allowedTokens",
          type: "uint256",
          indexed: !1
        }, {
          name: "_startTime",
          type: "uint256",
          indexed: !1
        }, {
          name: "_rollingPeriodInDays",
          type: "uint256",
          indexed: !1
        }, {
          name: "_endTime",
          type: "uint256",
          indexed: !1
        }, {
          name: "_typeOfRestriction",
          type: "uint8",
          indexed: !1
        }],
        name: "AddIndividualRestriction",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_holder",
          type: "address",
          indexed: !0
        }, {
          name: "_allowedTokens",
          type: "uint256",
          indexed: !1
        }, {
          name: "_startTime",
          type: "uint256",
          indexed: !1
        }, {
          name: "_rollingPeriodInDays",
          type: "uint256",
          indexed: !1
        }, {
          name: "_endTime",
          type: "uint256",
          indexed: !1
        }, {
          name: "_typeOfRestriction",
          type: "uint8",
          indexed: !1
        }],
        name: "AddIndividualDailyRestriction",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_holder",
          type: "address",
          indexed: !0
        }, {
          name: "_allowedTokens",
          type: "uint256",
          indexed: !1
        }, {
          name: "_startTime",
          type: "uint256",
          indexed: !1
        }, {
          name: "_rollingPeriodInDays",
          type: "uint256",
          indexed: !1
        }, {
          name: "_endTime",
          type: "uint256",
          indexed: !1
        }, {
          name: "_typeOfRestriction",
          type: "uint8",
          indexed: !1
        }],
        name: "ModifyIndividualRestriction",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_holder",
          type: "address",
          indexed: !0
        }, {
          name: "_allowedTokens",
          type: "uint256",
          indexed: !1
        }, {
          name: "_startTime",
          type: "uint256",
          indexed: !1
        }, {
          name: "_rollingPeriodInDays",
          type: "uint256",
          indexed: !1
        }, {
          name: "_endTime",
          type: "uint256",
          indexed: !1
        }, {
          name: "_typeOfRestriction",
          type: "uint8",
          indexed: !1
        }],
        name: "ModifyIndividualDailyRestriction",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_allowedTokens",
          type: "uint256",
          indexed: !1
        }, {
          name: "_startTime",
          type: "uint256",
          indexed: !1
        }, {
          name: "_rollingPeriodInDays",
          type: "uint256",
          indexed: !1
        }, {
          name: "_endTime",
          type: "uint256",
          indexed: !1
        }, {
          name: "_typeOfRestriction",
          type: "uint8",
          indexed: !1
        }],
        name: "AddDefaultRestriction",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_allowedTokens",
          type: "uint256",
          indexed: !1
        }, {
          name: "_startTime",
          type: "uint256",
          indexed: !1
        }, {
          name: "_rollingPeriodInDays",
          type: "uint256",
          indexed: !1
        }, {
          name: "_endTime",
          type: "uint256",
          indexed: !1
        }, {
          name: "_typeOfRestriction",
          type: "uint8",
          indexed: !1
        }],
        name: "AddDefaultDailyRestriction",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_allowedTokens",
          type: "uint256",
          indexed: !1
        }, {
          name: "_startTime",
          type: "uint256",
          indexed: !1
        }, {
          name: "_rollingPeriodInDays",
          type: "uint256",
          indexed: !1
        }, {
          name: "_endTime",
          type: "uint256",
          indexed: !1
        }, {
          name: "_typeOfRestriction",
          type: "uint8",
          indexed: !1
        }],
        name: "ModifyDefaultRestriction",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_allowedTokens",
          type: "uint256",
          indexed: !1
        }, {
          name: "_startTime",
          type: "uint256",
          indexed: !1
        }, {
          name: "_rollingPeriodInDays",
          type: "uint256",
          indexed: !1
        }, {
          name: "_endTime",
          type: "uint256",
          indexed: !1
        }, {
          name: "_typeOfRestriction",
          type: "uint8",
          indexed: !1
        }],
        name: "ModifyDefaultDailyRestriction",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_holder",
          type: "address",
          indexed: !0
        }],
        name: "IndividualRestrictionRemoved",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_holder",
          type: "address",
          indexed: !0
        }],
        name: "IndividualDailyRestrictionRemoved",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [],
        name: "DefaultRestrictionRemoved",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [],
        name: "DefaultDailyRestrictionRemoved",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Pause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Unpause",
        outputs: [],
        type: "event"
      }, {
        constant: !1,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "index_1",
          type: "address"
        }, {
          name: "_amount",
          type: "uint256"
        }, {
          name: "index_3",
          type: "bytes"
        }],
        name: "executeTransfer",
        outputs: [{
          name: "success",
          type: "uint8"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "index_1",
          type: "address"
        }, {
          name: "_amount",
          type: "uint256"
        }, {
          name: "index_3",
          type: "bytes"
        }],
        name: "verifyTransfer",
        outputs: [{
          name: "",
          type: "uint8"
        }, {
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_wallet",
          type: "address"
        }, {
          name: "_exempted",
          type: "bool"
        }],
        name: "changeExemptWalletList",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_holder",
          type: "address"
        }, {
          name: "_allowedTokens",
          type: "uint256"
        }, {
          name: "_startTime",
          type: "uint256"
        }, {
          name: "_rollingPeriodInDays",
          type: "uint256"
        }, {
          name: "_endTime",
          type: "uint256"
        }, {
          name: "_restrictionType",
          type: "uint8"
        }],
        name: "addIndividualRestriction",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_holder",
          type: "address"
        }, {
          name: "_allowedTokens",
          type: "uint256"
        }, {
          name: "_startTime",
          type: "uint256"
        }, {
          name: "_endTime",
          type: "uint256"
        }, {
          name: "_restrictionType",
          type: "uint8"
        }],
        name: "addIndividualDailyRestriction",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_holders",
          type: "address[]"
        }, {
          name: "_allowedTokens",
          type: "uint256[]"
        }, {
          name: "_startTimes",
          type: "uint256[]"
        }, {
          name: "_endTimes",
          type: "uint256[]"
        }, {
          name: "_restrictionTypes",
          type: "uint8[]"
        }],
        name: "addIndividualDailyRestrictionMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_holders",
          type: "address[]"
        }, {
          name: "_allowedTokens",
          type: "uint256[]"
        }, {
          name: "_startTimes",
          type: "uint256[]"
        }, {
          name: "_rollingPeriodInDays",
          type: "uint256[]"
        }, {
          name: "_endTimes",
          type: "uint256[]"
        }, {
          name: "_restrictionTypes",
          type: "uint8[]"
        }],
        name: "addIndividualRestrictionMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_allowedTokens",
          type: "uint256"
        }, {
          name: "_startTime",
          type: "uint256"
        }, {
          name: "_rollingPeriodInDays",
          type: "uint256"
        }, {
          name: "_endTime",
          type: "uint256"
        }, {
          name: "_restrictionType",
          type: "uint8"
        }],
        name: "addDefaultRestriction",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_allowedTokens",
          type: "uint256"
        }, {
          name: "_startTime",
          type: "uint256"
        }, {
          name: "_endTime",
          type: "uint256"
        }, {
          name: "_restrictionType",
          type: "uint8"
        }],
        name: "addDefaultDailyRestriction",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_holder",
          type: "address"
        }],
        name: "removeIndividualRestriction",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_holders",
          type: "address[]"
        }],
        name: "removeIndividualRestrictionMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_holder",
          type: "address"
        }],
        name: "removeIndividualDailyRestriction",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_holders",
          type: "address[]"
        }],
        name: "removeIndividualDailyRestrictionMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "removeDefaultRestriction",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "removeDefaultDailyRestriction",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_holder",
          type: "address"
        }, {
          name: "_allowedTokens",
          type: "uint256"
        }, {
          name: "_startTime",
          type: "uint256"
        }, {
          name: "_rollingPeriodInDays",
          type: "uint256"
        }, {
          name: "_endTime",
          type: "uint256"
        }, {
          name: "_restrictionType",
          type: "uint8"
        }],
        name: "modifyIndividualRestriction",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_holder",
          type: "address"
        }, {
          name: "_allowedTokens",
          type: "uint256"
        }, {
          name: "_startTime",
          type: "uint256"
        }, {
          name: "_endTime",
          type: "uint256"
        }, {
          name: "_restrictionType",
          type: "uint8"
        }],
        name: "modifyIndividualDailyRestriction",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_holders",
          type: "address[]"
        }, {
          name: "_allowedTokens",
          type: "uint256[]"
        }, {
          name: "_startTimes",
          type: "uint256[]"
        }, {
          name: "_endTimes",
          type: "uint256[]"
        }, {
          name: "_restrictionTypes",
          type: "uint8[]"
        }],
        name: "modifyIndividualDailyRestrictionMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_holders",
          type: "address[]"
        }, {
          name: "_allowedTokens",
          type: "uint256[]"
        }, {
          name: "_startTimes",
          type: "uint256[]"
        }, {
          name: "_rollingPeriodInDays",
          type: "uint256[]"
        }, {
          name: "_endTimes",
          type: "uint256[]"
        }, {
          name: "_restrictionTypes",
          type: "uint8[]"
        }],
        name: "modifyIndividualRestrictionMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_allowedTokens",
          type: "uint256"
        }, {
          name: "_startTime",
          type: "uint256"
        }, {
          name: "_rollingPeriodInDays",
          type: "uint256"
        }, {
          name: "_endTime",
          type: "uint256"
        }, {
          name: "_restrictionType",
          type: "uint8"
        }],
        name: "modifyDefaultRestriction",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_allowedTokens",
          type: "uint256"
        }, {
          name: "_startTime",
          type: "uint256"
        }, {
          name: "_endTime",
          type: "uint256"
        }, {
          name: "_restrictionType",
          type: "uint8"
        }],
        name: "modifyDefaultDailyRestriction",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_partition",
          type: "bytes32"
        }, {
          name: "_tokenHolder",
          type: "address"
        }, {
          name: "_additionalBalance",
          type: "uint256"
        }],
        name: "getTokensByPartition",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_user",
          type: "address"
        }],
        name: "getIndividualBucketDetailsToUser",
        outputs: [{
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_user",
          type: "address"
        }],
        name: "getDefaultBucketDetailsToUser",
        outputs: [{
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_user",
          type: "address"
        }, {
          name: "_at",
          type: "uint256"
        }],
        name: "getTotalTradedByUser",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getInitFunction",
        outputs: [{
          name: "",
          type: "bytes4"
        }],
        payable: !1,
        stateMutability: "pure",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getExemptAddress",
        outputs: [{
          name: "",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_investor",
          type: "address"
        }],
        name: "getIndividualRestriction",
        outputs: [{
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint8"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_investor",
          type: "address"
        }],
        name: "getIndividualDailyRestriction",
        outputs: [{
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint8"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDefaultRestriction",
        outputs: [{
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint8"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDefaultDailyRestriction",
        outputs: [{
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint8"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getRestrictionData",
        outputs: [{
          name: "allAddresses",
          type: "address[]"
        }, {
          name: "allowedTokens",
          type: "uint256[]"
        }, {
          name: "startTime",
          type: "uint256[]"
        }, {
          name: "rollingPeriodInDays",
          type: "uint256[]"
        }, {
          name: "endTime",
          type: "uint256[]"
        }, {
          name: "typeOfRestriction",
          type: "uint8[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getPermissions",
        outputs: [{
          name: "allPermissions",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(d.BaseContract);

  t.VolumeRestrictionTMContract_3_0_0 = v, t.isVolumeRestrictionTMContract_3_0_0 = function (e) {
    return m.isEqual(v.ABI(), e.abi);
  };
},
/*!*****************************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/weighted_vote_checkpoint.js ***!
  \*****************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r103,
      n = this && this.__extends || (_r103 = function r(e, t) {
    return (_r103 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r103(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      c = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || 0 < t--) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u,
      d = a(
  /*! @0x/base-contract */
  12),
      f = a(
  /*! @0x/json-schemas */
  2),
      l = a(
  /*! @0x/utils */
  8),
      h = a(
  /*! @0x/web3-wrapper */
  11),
      p = a(
  /*! @0x/assert */
  10),
      b = a(
  /*! ../../PolyResponse */
  14),
      m = a(
  /*! lodash */
  0),
      y = a(
  /*! ethers */
  13);
  (u = t.WeightedVoteCheckpointEvents_3_0_0 || (t.WeightedVoteCheckpointEvents_3_0_0 = {})).BallotCreated = "BallotCreated", u.VoteCast = "VoteCast", u.BallotStatusChanged = "BallotStatusChanged", u.ChangedBallotExemptedVotersList = "ChangedBallotExemptedVotersList", u.ChangedDefaultExemptedVotersList = "ChangedDefaultExemptedVotersList", u.Pause = "Pause", u.Unpause = "Unpause";

  var v = function (e) {
    function t(a, r, n, c) {
      var u = e.call(this, "WeightedVoteCheckpoint", t.ABI(), a, r, n) || this;
      return u.reclaimETH = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.reclaimETH.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("reclaimETH()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("reclaimETH()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("reclaimETH()", []);
        }
      }, u.changeDefaultExemptedVotersListMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_voters", e), p.assert.isArray("_exempts", t), o = (n = this)._strictEncodeArguments("changeDefaultExemptedVotersListMulti(address[],bool[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.changeDefaultExemptedVotersListMulti.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_voters", e), p.assert.isArray("_exempts", t), o = (n = this)._strictEncodeArguments("changeDefaultExemptedVotersListMulti(address[],bool[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_voters", e), p.assert.isArray("_exempts", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("changeDefaultExemptedVotersListMulti(address[],bool[])", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("changeDefaultExemptedVotersListMulti(address[],bool[])").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isArray("_voters", e), p.assert.isArray("_exempts", t), this._strictEncodeArguments("changeDefaultExemptedVotersListMulti(address[],bool[])", [e, t]);
        }
      }, u.ADMIN = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("ADMIN()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("ADMIN()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("ADMIN()", []);
        }
      }, u.unpause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.unpause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("unpause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("unpause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("unpause()", []);
        }
      }, u.paused = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("paused()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("paused()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("paused()", []);
        }
      }, u.polyToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("polyToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("polyToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("polyToken()", []);
        }
      }, u.getDefaultExemptionVotersList = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDefaultExemptionVotersList()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDefaultExemptionVotersList()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDefaultExemptionVotersList()", []);
        }
      }, u.pause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.pause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pause()", []);
        }
      }, u.reclaimERC20 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.reclaimERC20.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("reclaimERC20(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_tokenContract", e), this._strictEncodeArguments("reclaimERC20(address)", [e]);
        }
      }, u.OPERATOR = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("OPERATOR()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("OPERATOR()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("OPERATOR()", []);
        }
      }, u.securityToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("securityToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("securityToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("securityToken()", []);
        }
      }, u.factory = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("factory()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("factory()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("factory()", []);
        }
      }, u.changeDefaultExemptedVotersList = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_voter", e), p.assert.isBoolean("_exempt", t), o = (n = this)._strictEncodeArguments("changeDefaultExemptedVotersList(address,bool)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.changeDefaultExemptedVotersList.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_voter", e), p.assert.isBoolean("_exempt", t), o = (n = this)._strictEncodeArguments("changeDefaultExemptedVotersList(address,bool)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_voter", e), p.assert.isBoolean("_exempt", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("changeDefaultExemptedVotersList(address,bool)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("changeDefaultExemptedVotersList(address,bool)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_voter", e), p.assert.isBoolean("_exempt", t), this._strictEncodeArguments("changeDefaultExemptedVotersList(address,bool)", [e, t]);
        }
      }, u.getDataStore = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDataStore()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDataStore()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDataStore()", []);
        }
      }, u.getInitFunction = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getInitFunction()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getInitFunction()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getInitFunction()", []);
        }
      }, u.createBallot = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_duration", e), p.assert.isBigNumber("_noOfProposals", t), p.assert.isBigNumber("_quorumPercentage", a), c = (o = this)._strictEncodeArguments("createBallot(uint256,uint256,uint256)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.createBallot.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_duration", e), p.assert.isBigNumber("_noOfProposals", t), p.assert.isBigNumber("_quorumPercentage", a), c = (o = this)._strictEncodeArguments("createBallot(uint256,uint256,uint256)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_duration", e), p.assert.isBigNumber("_noOfProposals", t), p.assert.isBigNumber("_quorumPercentage", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("createBallot(uint256,uint256,uint256)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("createBallot(uint256,uint256,uint256)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isBigNumber("_duration", e), p.assert.isBigNumber("_noOfProposals", t), p.assert.isBigNumber("_quorumPercentage", a), this._strictEncodeArguments("createBallot(uint256,uint256,uint256)", [e, t, a]);
        }
      }, u.createCustomBallot = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_checkpointId", e), p.assert.isBigNumber("_quorumPercentage", t), p.assert.isBigNumber("_startTime", a), p.assert.isBigNumber("_endTime", r), p.assert.isBigNumber("_noOfProposals", n), f = (o = this)._strictEncodeArguments("createCustomBallot(uint256,uint256,uint256,uint256,uint256)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: f
                  }), s({
                    from: h
                  }, l), o.createCustomBallot.estimateGasAsync.bind(o, e, t, a, r, n, u))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(m)];

                case 3:
                  return y = i.sent(), v = o._web3Wrapper.awaitTransactionSuccessAsync(y), [2, new b.PolyResponse(y, v)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_checkpointId", e), p.assert.isBigNumber("_quorumPercentage", t), p.assert.isBigNumber("_startTime", a), p.assert.isBigNumber("_endTime", r), p.assert.isBigNumber("_noOfProposals", n), f = (o = this)._strictEncodeArguments("createCustomBallot(uint256,uint256,uint256,uint256,uint256)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: f
                  }), s({
                    from: h
                  }, l))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(b)];

                case 3:
                  return m = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return y = i.sent().gasLimit, v = void 0 === c ? o._defaultEstimateGasFactor : c, _ = Math.round(v * m), [2, y < _ ? y : _];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u) {
          return void 0 === c && (c = {}), o(this, void 0, void 0, function () {
            var o, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_checkpointId", e), p.assert.isBigNumber("_quorumPercentage", t), p.assert.isBigNumber("_startTime", a), p.assert.isBigNumber("_endTime", r), p.assert.isBigNumber("_noOfProposals", n), p.assert.doesConformToSchema("callData", c, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== u && p.assert.isBlockParam("defaultBlock", u), l = (o = this)._strictEncodeArguments("createCustomBallot(uint256,uint256,uint256,uint256,uint256)", [e, t, a, r, n]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: l
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (h = i.sent()).from = h.from ? h.from.toLowerCase() : h.from, [4, o._web3Wrapper.callAsync(h, u)];

                case 2:
                  return b = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(b), [2, o._lookupAbiEncoder("createCustomBallot(uint256,uint256,uint256,uint256,uint256)").strictDecodeReturnValue(b)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n) {
          return p.assert.isBigNumber("_checkpointId", e), p.assert.isBigNumber("_quorumPercentage", t), p.assert.isBigNumber("_startTime", a), p.assert.isBigNumber("_endTime", r), p.assert.isBigNumber("_noOfProposals", n), this._strictEncodeArguments("createCustomBallot(uint256,uint256,uint256,uint256,uint256)", [e, t, a, r, n]);
        }
      }, u.castVote = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isBigNumber("_proposalId", t), o = (n = this)._strictEncodeArguments("castVote(uint256,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.castVote.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isBigNumber("_proposalId", t), o = (n = this)._strictEncodeArguments("castVote(uint256,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isBigNumber("_proposalId", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("castVote(uint256,uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("castVote(uint256,uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isBigNumber("_ballotId", e), p.assert.isBigNumber("_proposalId", t), this._strictEncodeArguments("castVote(uint256,uint256)", [e, t]);
        }
      }, u.changeBallotExemptedVotersList = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isString("_voter", t), p.assert.isBoolean("_exempt", a), c = (o = this)._strictEncodeArguments("changeBallotExemptedVotersList(uint256,address,bool)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.changeBallotExemptedVotersList.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isString("_voter", t), p.assert.isBoolean("_exempt", a), c = (o = this)._strictEncodeArguments("changeBallotExemptedVotersList(uint256,address,bool)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isString("_voter", t), p.assert.isBoolean("_exempt", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("changeBallotExemptedVotersList(uint256,address,bool)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("changeBallotExemptedVotersList(uint256,address,bool)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isBigNumber("_ballotId", e), p.assert.isString("_voter", t), p.assert.isBoolean("_exempt", a), this._strictEncodeArguments("changeBallotExemptedVotersList(uint256,address,bool)", [e, t, a]);
        }
      }, u.changeBallotExemptedVotersListMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isArray("_voters", t), p.assert.isArray("_exempts", a), c = (o = this)._strictEncodeArguments("changeBallotExemptedVotersListMulti(uint256,address[],bool[])", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.changeBallotExemptedVotersListMulti.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isArray("_voters", t), p.assert.isArray("_exempts", a), c = (o = this)._strictEncodeArguments("changeBallotExemptedVotersListMulti(uint256,address[],bool[])", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isArray("_voters", t), p.assert.isArray("_exempts", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("changeBallotExemptedVotersListMulti(uint256,address[],bool[])", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("changeBallotExemptedVotersListMulti(uint256,address[],bool[])").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isBigNumber("_ballotId", e), p.assert.isArray("_voters", t), p.assert.isArray("_exempts", a), this._strictEncodeArguments("changeBallotExemptedVotersListMulti(uint256,address[],bool[])", [e, t, a]);
        }
      }, u.isVoterAllowed = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isString("_voter", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("isVoterAllowed(uint256,address)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("isVoterAllowed(uint256,address)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isBigNumber("_ballotId", e), p.assert.isString("_voter", t), this._strictEncodeArguments("isVoterAllowed(uint256,address)", [e, t]);
        }
      }, u.changeBallotStatus = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isBoolean("_isActive", t), o = (n = this)._strictEncodeArguments("changeBallotStatus(uint256,bool)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.changeBallotStatus.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isBoolean("_isActive", t), o = (n = this)._strictEncodeArguments("changeBallotStatus(uint256,bool)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isBoolean("_isActive", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("changeBallotStatus(uint256,bool)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("changeBallotStatus(uint256,bool)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isBigNumber("_ballotId", e), p.assert.isBoolean("_isActive", t), this._strictEncodeArguments("changeBallotStatus(uint256,bool)", [e, t]);
        }
      }, u.getBallotResults = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getBallotResults(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getBallotResults(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_ballotId", e), this._strictEncodeArguments("getBallotResults(uint256)", [e]);
        }
      }, u.getSelectedProposal = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isString("_voter", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("getSelectedProposal(uint256,address)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("getSelectedProposal(uint256,address)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isBigNumber("_ballotId", e), p.assert.isString("_voter", t), this._strictEncodeArguments("getSelectedProposal(uint256,address)", [e, t]);
        }
      }, u.getBallotDetails = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getBallotDetails(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getBallotDetails(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_ballotId", e), this._strictEncodeArguments("getBallotDetails(uint256)", [e]);
        }
      }, u.getPermissions = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getPermissions()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getPermissions()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getPermissions()", []);
        }
      }, u._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, l.classUtils.bindAll(u, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), u;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n, s, u) {
      return o(this, void 0, void 0, function () {
        var o, b, m, v, _, g, A, w, T, x, D;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return p.assert.isHexString("bytecode", e), p.assert.doesConformToSchema("txDefaults", n, f.schemas.txDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), o = l.providerUtils.standardizeOrThrow(r), b = d.BaseContract._lookupConstructorAbi(a), D = c(d.BaseContract._formatABIDataItemList(b.inputs, [s, u], d.BaseContract._bigNumberToString), 2), s = D[0], u = D[1], m = new y.utils.Interface(a), v = m.deployFunction, _ = v.encode(e, [s, u]), g = new h.Web3Wrapper(o), [4, d.BaseContract._applyDefaultsToTxDataAsync({
                data: _
              }, n, g.estimateGasAsync.bind(g))];

            case 1:
              return A = i.sent(), [4, g.sendTransactionAsync(A)];

            case 2:
              return w = i.sent(), l.logUtils.log("transactionHash: " + w), [4, g.awaitTransactionSuccessAsync(w)];

            case 3:
              return T = i.sent(), l.logUtils.log("WeightedVoteCheckpoint successfully deployed at " + T.contractAddress), (x = new t(T.contractAddress, o, n)).constructorArgs = [s, u], [2, x];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !1,
        inputs: [],
        name: "reclaimETH",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_voters",
          type: "address[]"
        }, {
          name: "_exempts",
          type: "bool[]"
        }],
        name: "changeDefaultExemptedVotersListMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "ADMIN",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "unpause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "paused",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "polyToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDefaultExemptionVotersList",
        outputs: [{
          name: "",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "pause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenContract",
          type: "address"
        }],
        name: "reclaimERC20",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "OPERATOR",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "securityToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "factory",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_voter",
          type: "address"
        }, {
          name: "_exempt",
          type: "bool"
        }],
        name: "changeDefaultExemptedVotersList",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDataStore",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        inputs: [{
          name: "_securityToken",
          type: "address"
        }, {
          name: "_polyToken",
          type: "address"
        }],
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "constructor"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_ballotId",
          type: "uint256",
          indexed: !0
        }, {
          name: "_checkpointId",
          type: "uint256",
          indexed: !0
        }, {
          name: "_startTime",
          type: "uint256",
          indexed: !1
        }, {
          name: "_endTime",
          type: "uint256",
          indexed: !1
        }, {
          name: "_noOfProposals",
          type: "uint256",
          indexed: !1
        }, {
          name: "_quorumPercentage",
          type: "uint256",
          indexed: !1
        }],
        name: "BallotCreated",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_voter",
          type: "address",
          indexed: !0
        }, {
          name: "_weight",
          type: "uint256",
          indexed: !1
        }, {
          name: "_ballotId",
          type: "uint256",
          indexed: !0
        }, {
          name: "_proposalId",
          type: "uint256",
          indexed: !0
        }],
        name: "VoteCast",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_ballotId",
          type: "uint256",
          indexed: !0
        }, {
          name: "_isActive",
          type: "bool",
          indexed: !1
        }],
        name: "BallotStatusChanged",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_ballotId",
          type: "uint256",
          indexed: !0
        }, {
          name: "_voter",
          type: "address",
          indexed: !0
        }, {
          name: "_exempt",
          type: "bool",
          indexed: !1
        }],
        name: "ChangedBallotExemptedVotersList",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_voter",
          type: "address",
          indexed: !0
        }, {
          name: "_exempt",
          type: "bool",
          indexed: !1
        }],
        name: "ChangedDefaultExemptedVotersList",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Pause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Unpause",
        outputs: [],
        type: "event"
      }, {
        constant: !0,
        inputs: [],
        name: "getInitFunction",
        outputs: [{
          name: "",
          type: "bytes4"
        }],
        payable: !1,
        stateMutability: "pure",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_duration",
          type: "uint256"
        }, {
          name: "_noOfProposals",
          type: "uint256"
        }, {
          name: "_quorumPercentage",
          type: "uint256"
        }],
        name: "createBallot",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_checkpointId",
          type: "uint256"
        }, {
          name: "_quorumPercentage",
          type: "uint256"
        }, {
          name: "_startTime",
          type: "uint256"
        }, {
          name: "_endTime",
          type: "uint256"
        }, {
          name: "_noOfProposals",
          type: "uint256"
        }],
        name: "createCustomBallot",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_ballotId",
          type: "uint256"
        }, {
          name: "_proposalId",
          type: "uint256"
        }],
        name: "castVote",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_ballotId",
          type: "uint256"
        }, {
          name: "_voter",
          type: "address"
        }, {
          name: "_exempt",
          type: "bool"
        }],
        name: "changeBallotExemptedVotersList",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_ballotId",
          type: "uint256"
        }, {
          name: "_voters",
          type: "address[]"
        }, {
          name: "_exempts",
          type: "bool[]"
        }],
        name: "changeBallotExemptedVotersListMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_ballotId",
          type: "uint256"
        }, {
          name: "_voter",
          type: "address"
        }],
        name: "isVoterAllowed",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_ballotId",
          type: "uint256"
        }, {
          name: "_isActive",
          type: "bool"
        }],
        name: "changeBallotStatus",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_ballotId",
          type: "uint256"
        }],
        name: "getBallotResults",
        outputs: [{
          name: "voteWeighting",
          type: "uint256[]"
        }, {
          name: "tieWith",
          type: "uint256[]"
        }, {
          name: "winningProposal",
          type: "uint256"
        }, {
          name: "isVotingSucceed",
          type: "bool"
        }, {
          name: "totalVotes",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_ballotId",
          type: "uint256"
        }, {
          name: "_voter",
          type: "address"
        }],
        name: "getSelectedProposal",
        outputs: [{
          name: "proposalId",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_ballotId",
          type: "uint256"
        }],
        name: "getBallotDetails",
        outputs: [{
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getPermissions",
        outputs: [{
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(d.BaseContract);

  t.WeightedVoteCheckpointContract_3_0_0 = v, t.isWeightedVoteCheckpointContract_3_0_0 = function (e) {
    return m.isEqual(v.ABI(), e.abi);
  };
},
/*!******************************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.0.0/p_l_c_r_voting_checkpoint.js ***!
  \******************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r104,
      n = this && this.__extends || (_r104 = function r(e, t) {
    return (_r104 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r104(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      c = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || 0 < t--) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u,
      d = a(
  /*! @0x/base-contract */
  12),
      f = a(
  /*! @0x/json-schemas */
  2),
      l = a(
  /*! @0x/utils */
  8),
      h = a(
  /*! @0x/web3-wrapper */
  11),
      p = a(
  /*! @0x/assert */
  10),
      b = a(
  /*! ../../PolyResponse */
  14),
      m = a(
  /*! lodash */
  0),
      y = a(
  /*! ethers */
  13);
  (u = t.PLCRVotingCheckpointEvents_3_0_0 || (t.PLCRVotingCheckpointEvents_3_0_0 = {})).VoteCommit = "VoteCommit", u.VoteRevealed = "VoteRevealed", u.BallotCreated = "BallotCreated", u.BallotStatusChanged = "BallotStatusChanged", u.ChangedBallotExemptedVotersList = "ChangedBallotExemptedVotersList", u.ChangedDefaultExemptedVotersList = "ChangedDefaultExemptedVotersList", u.Pause = "Pause", u.Unpause = "Unpause";

  var v = function (e) {
    function t(a, r, n, c) {
      var u = e.call(this, "PLCRVotingCheckpoint", t.ABI(), a, r, n) || this;
      return u.reclaimETH = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.reclaimETH.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("reclaimETH()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("reclaimETH()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("reclaimETH()", []);
        }
      }, u.changeDefaultExemptedVotersListMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_voters", e), p.assert.isArray("_exempts", t), o = (n = this)._strictEncodeArguments("changeDefaultExemptedVotersListMulti(address[],bool[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.changeDefaultExemptedVotersListMulti.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_voters", e), p.assert.isArray("_exempts", t), o = (n = this)._strictEncodeArguments("changeDefaultExemptedVotersListMulti(address[],bool[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_voters", e), p.assert.isArray("_exempts", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("changeDefaultExemptedVotersListMulti(address[],bool[])", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("changeDefaultExemptedVotersListMulti(address[],bool[])").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isArray("_voters", e), p.assert.isArray("_exempts", t), this._strictEncodeArguments("changeDefaultExemptedVotersListMulti(address[],bool[])", [e, t]);
        }
      }, u.ADMIN = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("ADMIN()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("ADMIN()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("ADMIN()", []);
        }
      }, u.unpause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.unpause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("unpause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("unpause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("unpause()", []);
        }
      }, u.paused = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("paused()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("paused()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("paused()", []);
        }
      }, u.polyToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("polyToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("polyToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("polyToken()", []);
        }
      }, u.getDefaultExemptionVotersList = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDefaultExemptionVotersList()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDefaultExemptionVotersList()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDefaultExemptionVotersList()", []);
        }
      }, u.pause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.pause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pause()", []);
        }
      }, u.reclaimERC20 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.reclaimERC20.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("reclaimERC20(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_tokenContract", e), this._strictEncodeArguments("reclaimERC20(address)", [e]);
        }
      }, u.OPERATOR = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("OPERATOR()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("OPERATOR()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("OPERATOR()", []);
        }
      }, u.securityToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("securityToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("securityToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("securityToken()", []);
        }
      }, u.factory = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("factory()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("factory()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("factory()", []);
        }
      }, u.changeDefaultExemptedVotersList = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_voter", e), p.assert.isBoolean("_exempt", t), o = (n = this)._strictEncodeArguments("changeDefaultExemptedVotersList(address,bool)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.changeDefaultExemptedVotersList.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_voter", e), p.assert.isBoolean("_exempt", t), o = (n = this)._strictEncodeArguments("changeDefaultExemptedVotersList(address,bool)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_voter", e), p.assert.isBoolean("_exempt", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("changeDefaultExemptedVotersList(address,bool)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("changeDefaultExemptedVotersList(address,bool)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_voter", e), p.assert.isBoolean("_exempt", t), this._strictEncodeArguments("changeDefaultExemptedVotersList(address,bool)", [e, t]);
        }
      }, u.getDataStore = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDataStore()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDataStore()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDataStore()", []);
        }
      }, u.createBallot = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_commitDuration", e), p.assert.isBigNumber("_revealDuration", t), p.assert.isBigNumber("_noOfProposals", a), p.assert.isBigNumber("_quorumPercentage", r), u = (o = this)._strictEncodeArguments("createBallot(uint256,uint256,uint256,uint256)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.createBallot.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_commitDuration", e), p.assert.isBigNumber("_revealDuration", t), p.assert.isBigNumber("_noOfProposals", a), p.assert.isBigNumber("_quorumPercentage", r), u = (o = this)._strictEncodeArguments("createBallot(uint256,uint256,uint256,uint256)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_commitDuration", e), p.assert.isBigNumber("_revealDuration", t), p.assert.isBigNumber("_noOfProposals", a), p.assert.isBigNumber("_quorumPercentage", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("createBallot(uint256,uint256,uint256,uint256)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("createBallot(uint256,uint256,uint256,uint256)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isBigNumber("_commitDuration", e), p.assert.isBigNumber("_revealDuration", t), p.assert.isBigNumber("_noOfProposals", a), p.assert.isBigNumber("_quorumPercentage", r), this._strictEncodeArguments("createBallot(uint256,uint256,uint256,uint256)", [e, t, a, r]);
        }
      }, u.createCustomBallot = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u, f) {
          return o(this, void 0, void 0, function () {
            var o, l, h, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_commitDuration", e), p.assert.isBigNumber("_revealDuration", t), p.assert.isBigNumber("_noOfProposals", a), p.assert.isBigNumber("_quorumPercentage", r), p.assert.isBigNumber("_checkpointId", n), p.assert.isBigNumber("_startTime", c), l = (o = this)._strictEncodeArguments("createCustomBallot(uint256,uint256,uint256,uint256,uint256,uint256)", [e, t, a, r, n, c]), h = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return m = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: l
                  }), s({
                    from: m
                  }, h), o.createCustomBallot.estimateGasAsync.bind(o, e, t, a, r, n, c, f))];

                case 2:
                  return void 0 !== (y = i.sent()).from && (y.from = y.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(y)];

                case 3:
                  return v = i.sent(), _ = o._web3Wrapper.awaitTransactionSuccessAsync(v), [2, new b.PolyResponse(v, _)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u, f) {
          return o(this, void 0, void 0, function () {
            var o, l, h, b, m, y, v, _, g;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_commitDuration", e), p.assert.isBigNumber("_revealDuration", t), p.assert.isBigNumber("_noOfProposals", a), p.assert.isBigNumber("_quorumPercentage", r), p.assert.isBigNumber("_checkpointId", n), p.assert.isBigNumber("_startTime", c), l = (o = this)._strictEncodeArguments("createCustomBallot(uint256,uint256,uint256,uint256,uint256,uint256)", [e, t, a, r, n, c]), h = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return b = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, f, {
                    data: l
                  }), s({
                    from: b
                  }, h))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(m)];

                case 3:
                  return y = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return v = i.sent().gasLimit, _ = void 0 === u ? o._defaultEstimateGasFactor : u, g = Math.round(_ * y), [2, v < g ? v : g];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u, l) {
          return void 0 === u && (u = {}), o(this, void 0, void 0, function () {
            var o, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_commitDuration", e), p.assert.isBigNumber("_revealDuration", t), p.assert.isBigNumber("_noOfProposals", a), p.assert.isBigNumber("_quorumPercentage", r), p.assert.isBigNumber("_checkpointId", n), p.assert.isBigNumber("_startTime", c), p.assert.doesConformToSchema("callData", u, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== l && p.assert.isBlockParam("defaultBlock", l), h = (o = this)._strictEncodeArguments("createCustomBallot(uint256,uint256,uint256,uint256,uint256,uint256)", [e, t, a, r, n, c]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: h
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (b = i.sent()).from = b.from ? b.from.toLowerCase() : b.from, [4, o._web3Wrapper.callAsync(b, l)];

                case 2:
                  return m = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(m), [2, o._lookupAbiEncoder("createCustomBallot(uint256,uint256,uint256,uint256,uint256,uint256)").strictDecodeReturnValue(m)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s) {
          return p.assert.isBigNumber("_commitDuration", e), p.assert.isBigNumber("_revealDuration", t), p.assert.isBigNumber("_noOfProposals", a), p.assert.isBigNumber("_quorumPercentage", r), p.assert.isBigNumber("_checkpointId", n), p.assert.isBigNumber("_startTime", s), this._strictEncodeArguments("createCustomBallot(uint256,uint256,uint256,uint256,uint256,uint256)", [e, t, a, r, n, s]);
        }
      }, u.commitVote = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isString("_secretVote", t), o = (n = this)._strictEncodeArguments("commitVote(uint256,bytes32)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.commitVote.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isString("_secretVote", t), o = (n = this)._strictEncodeArguments("commitVote(uint256,bytes32)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isString("_secretVote", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("commitVote(uint256,bytes32)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("commitVote(uint256,bytes32)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isBigNumber("_ballotId", e), p.assert.isString("_secretVote", t), this._strictEncodeArguments("commitVote(uint256,bytes32)", [e, t]);
        }
      }, u.revealVote = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isBigNumber("_choiceOfProposal", t), p.assert.isBigNumber("_salt", a), c = (o = this)._strictEncodeArguments("revealVote(uint256,uint256,uint256)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.revealVote.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isBigNumber("_choiceOfProposal", t), p.assert.isBigNumber("_salt", a), c = (o = this)._strictEncodeArguments("revealVote(uint256,uint256,uint256)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isBigNumber("_choiceOfProposal", t), p.assert.isBigNumber("_salt", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("revealVote(uint256,uint256,uint256)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("revealVote(uint256,uint256,uint256)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isBigNumber("_ballotId", e), p.assert.isBigNumber("_choiceOfProposal", t), p.assert.isBigNumber("_salt", a), this._strictEncodeArguments("revealVote(uint256,uint256,uint256)", [e, t, a]);
        }
      }, u.changeBallotExemptedVotersList = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isString("_voter", t), p.assert.isBoolean("_exempt", a), c = (o = this)._strictEncodeArguments("changeBallotExemptedVotersList(uint256,address,bool)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.changeBallotExemptedVotersList.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isString("_voter", t), p.assert.isBoolean("_exempt", a), c = (o = this)._strictEncodeArguments("changeBallotExemptedVotersList(uint256,address,bool)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isString("_voter", t), p.assert.isBoolean("_exempt", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("changeBallotExemptedVotersList(uint256,address,bool)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("changeBallotExemptedVotersList(uint256,address,bool)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isBigNumber("_ballotId", e), p.assert.isString("_voter", t), p.assert.isBoolean("_exempt", a), this._strictEncodeArguments("changeBallotExemptedVotersList(uint256,address,bool)", [e, t, a]);
        }
      }, u.changeBallotExemptedVotersListMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isArray("_voters", t), p.assert.isArray("_exempts", a), c = (o = this)._strictEncodeArguments("changeBallotExemptedVotersListMulti(uint256,address[],bool[])", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.changeBallotExemptedVotersListMulti.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isArray("_voters", t), p.assert.isArray("_exempts", a), c = (o = this)._strictEncodeArguments("changeBallotExemptedVotersListMulti(uint256,address[],bool[])", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isArray("_voters", t), p.assert.isArray("_exempts", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("changeBallotExemptedVotersListMulti(uint256,address[],bool[])", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("changeBallotExemptedVotersListMulti(uint256,address[],bool[])").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isBigNumber("_ballotId", e), p.assert.isArray("_voters", t), p.assert.isArray("_exempts", a), this._strictEncodeArguments("changeBallotExemptedVotersListMulti(uint256,address[],bool[])", [e, t, a]);
        }
      }, u.isVoterAllowed = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isString("_voter", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("isVoterAllowed(uint256,address)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("isVoterAllowed(uint256,address)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isBigNumber("_ballotId", e), p.assert.isString("_voter", t), this._strictEncodeArguments("isVoterAllowed(uint256,address)", [e, t]);
        }
      }, u.changeBallotStatus = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isBoolean("_isActive", t), o = (n = this)._strictEncodeArguments("changeBallotStatus(uint256,bool)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.changeBallotStatus.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isBoolean("_isActive", t), o = (n = this)._strictEncodeArguments("changeBallotStatus(uint256,bool)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isBoolean("_isActive", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("changeBallotStatus(uint256,bool)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("changeBallotStatus(uint256,bool)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isBigNumber("_ballotId", e), p.assert.isBoolean("_isActive", t), this._strictEncodeArguments("changeBallotStatus(uint256,bool)", [e, t]);
        }
      }, u.getCurrentBallotStage = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getCurrentBallotStage(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getCurrentBallotStage(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_ballotId", e), this._strictEncodeArguments("getCurrentBallotStage(uint256)", [e]);
        }
      }, u.getBallotResults = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getBallotResults(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getBallotResults(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_ballotId", e), this._strictEncodeArguments("getBallotResults(uint256)", [e]);
        }
      }, u.getSelectedProposal = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isString("_voter", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("getSelectedProposal(uint256,address)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("getSelectedProposal(uint256,address)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isBigNumber("_ballotId", e), p.assert.isString("_voter", t), this._strictEncodeArguments("getSelectedProposal(uint256,address)", [e, t]);
        }
      }, u.getBallotDetails = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getBallotDetails(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getBallotDetails(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_ballotId", e), this._strictEncodeArguments("getBallotDetails(uint256)", [e]);
        }
      }, u.getBallotCommitRevealDuration = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getBallotCommitRevealDuration(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getBallotCommitRevealDuration(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_ballotId", e), this._strictEncodeArguments("getBallotCommitRevealDuration(uint256)", [e]);
        }
      }, u.getInitFunction = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getInitFunction()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getInitFunction()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getInitFunction()", []);
        }
      }, u.getPermissions = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getPermissions()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getPermissions()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getPermissions()", []);
        }
      }, u._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, l.classUtils.bindAll(u, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), u;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n, s, u) {
      return o(this, void 0, void 0, function () {
        var o, b, m, v, _, g, A, w, T, x, D;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return p.assert.isHexString("bytecode", e), p.assert.doesConformToSchema("txDefaults", n, f.schemas.txDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), o = l.providerUtils.standardizeOrThrow(r), b = d.BaseContract._lookupConstructorAbi(a), D = c(d.BaseContract._formatABIDataItemList(b.inputs, [s, u], d.BaseContract._bigNumberToString), 2), s = D[0], u = D[1], m = new y.utils.Interface(a), v = m.deployFunction, _ = v.encode(e, [s, u]), g = new h.Web3Wrapper(o), [4, d.BaseContract._applyDefaultsToTxDataAsync({
                data: _
              }, n, g.estimateGasAsync.bind(g))];

            case 1:
              return A = i.sent(), [4, g.sendTransactionAsync(A)];

            case 2:
              return w = i.sent(), l.logUtils.log("transactionHash: " + w), [4, g.awaitTransactionSuccessAsync(w)];

            case 3:
              return T = i.sent(), l.logUtils.log("PLCRVotingCheckpoint successfully deployed at " + T.contractAddress), (x = new t(T.contractAddress, o, n)).constructorArgs = [s, u], [2, x];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !1,
        inputs: [],
        name: "reclaimETH",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_voters",
          type: "address[]"
        }, {
          name: "_exempts",
          type: "bool[]"
        }],
        name: "changeDefaultExemptedVotersListMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "ADMIN",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "unpause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "paused",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "polyToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDefaultExemptionVotersList",
        outputs: [{
          name: "",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "pause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenContract",
          type: "address"
        }],
        name: "reclaimERC20",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "OPERATOR",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "securityToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "factory",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_voter",
          type: "address"
        }, {
          name: "_exempt",
          type: "bool"
        }],
        name: "changeDefaultExemptedVotersList",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDataStore",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        inputs: [{
          name: "_securityToken",
          type: "address"
        }, {
          name: "_polyAddress",
          type: "address"
        }],
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "constructor"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_voter",
          type: "address",
          indexed: !0
        }, {
          name: "_weight",
          type: "uint256",
          indexed: !1
        }, {
          name: "_ballotId",
          type: "uint256",
          indexed: !0
        }, {
          name: "_secretVote",
          type: "bytes32",
          indexed: !1
        }],
        name: "VoteCommit",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_voter",
          type: "address",
          indexed: !0
        }, {
          name: "_weight",
          type: "uint256",
          indexed: !1
        }, {
          name: "_ballotId",
          type: "uint256",
          indexed: !0
        }, {
          name: "_choiceOfProposal",
          type: "uint256",
          indexed: !1
        }, {
          name: "_salt",
          type: "uint256",
          indexed: !1
        }, {
          name: "_secretVote",
          type: "bytes32",
          indexed: !1
        }],
        name: "VoteRevealed",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_ballotId",
          type: "uint256",
          indexed: !0
        }, {
          name: "_checkpointId",
          type: "uint256",
          indexed: !0
        }, {
          name: "_startTime",
          type: "uint256",
          indexed: !1
        }, {
          name: "_commitDuration",
          type: "uint256",
          indexed: !1
        }, {
          name: "_revealDuration",
          type: "uint256",
          indexed: !1
        }, {
          name: "_noOfProposals",
          type: "uint256",
          indexed: !1
        }, {
          name: "_quorumPercentage",
          type: "uint256",
          indexed: !1
        }],
        name: "BallotCreated",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_ballotId",
          type: "uint256",
          indexed: !0
        }, {
          name: "_newStatus",
          type: "bool",
          indexed: !1
        }],
        name: "BallotStatusChanged",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_ballotId",
          type: "uint256",
          indexed: !0
        }, {
          name: "_voter",
          type: "address",
          indexed: !0
        }, {
          name: "_exempt",
          type: "bool",
          indexed: !1
        }],
        name: "ChangedBallotExemptedVotersList",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_voter",
          type: "address",
          indexed: !0
        }, {
          name: "_exempt",
          type: "bool",
          indexed: !1
        }],
        name: "ChangedDefaultExemptedVotersList",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Pause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Unpause",
        outputs: [],
        type: "event"
      }, {
        constant: !1,
        inputs: [{
          name: "_commitDuration",
          type: "uint256"
        }, {
          name: "_revealDuration",
          type: "uint256"
        }, {
          name: "_noOfProposals",
          type: "uint256"
        }, {
          name: "_quorumPercentage",
          type: "uint256"
        }],
        name: "createBallot",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_commitDuration",
          type: "uint256"
        }, {
          name: "_revealDuration",
          type: "uint256"
        }, {
          name: "_noOfProposals",
          type: "uint256"
        }, {
          name: "_quorumPercentage",
          type: "uint256"
        }, {
          name: "_checkpointId",
          type: "uint256"
        }, {
          name: "_startTime",
          type: "uint256"
        }],
        name: "createCustomBallot",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_ballotId",
          type: "uint256"
        }, {
          name: "_secretVote",
          type: "bytes32"
        }],
        name: "commitVote",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_ballotId",
          type: "uint256"
        }, {
          name: "_choiceOfProposal",
          type: "uint256"
        }, {
          name: "_salt",
          type: "uint256"
        }],
        name: "revealVote",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_ballotId",
          type: "uint256"
        }, {
          name: "_voter",
          type: "address"
        }, {
          name: "_exempt",
          type: "bool"
        }],
        name: "changeBallotExemptedVotersList",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_ballotId",
          type: "uint256"
        }, {
          name: "_voters",
          type: "address[]"
        }, {
          name: "_exempts",
          type: "bool[]"
        }],
        name: "changeBallotExemptedVotersListMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_ballotId",
          type: "uint256"
        }, {
          name: "_voter",
          type: "address"
        }],
        name: "isVoterAllowed",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_ballotId",
          type: "uint256"
        }, {
          name: "_isActive",
          type: "bool"
        }],
        name: "changeBallotStatus",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_ballotId",
          type: "uint256"
        }],
        name: "getCurrentBallotStage",
        outputs: [{
          name: "",
          type: "uint8"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_ballotId",
          type: "uint256"
        }],
        name: "getBallotResults",
        outputs: [{
          name: "voteWeighting",
          type: "uint256[]"
        }, {
          name: "tieWith",
          type: "uint256[]"
        }, {
          name: "winningProposal",
          type: "uint256"
        }, {
          name: "isVotingSucceed",
          type: "bool"
        }, {
          name: "totalVotes",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_ballotId",
          type: "uint256"
        }, {
          name: "_voter",
          type: "address"
        }],
        name: "getSelectedProposal",
        outputs: [{
          name: "proposalId",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_ballotId",
          type: "uint256"
        }],
        name: "getBallotDetails",
        outputs: [{
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_ballotId",
          type: "uint256"
        }],
        name: "getBallotCommitRevealDuration",
        outputs: [{
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getInitFunction",
        outputs: [{
          name: "",
          type: "bytes4"
        }],
        payable: !1,
        stateMutability: "pure",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getPermissions",
        outputs: [{
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(d.BaseContract);

  t.PLCRVotingCheckpointContract_3_0_0 = v, t.isPLCRVotingCheckpointContract_3_0_0 = function (e) {
    return m.isEqual(v.ABI(), e.abi);
  };
},
/*!********************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.1.0/sto.js ***!
  \********************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r105,
      n = this && this.__extends || (_r105 = function r(e, t) {
    return (_r105 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r105(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var c,
      u = a(
  /*! @0x/base-contract */
  12),
      d = a(
  /*! @0x/json-schemas */
  2),
      f = a(
  /*! @0x/utils */
  8),
      l = a(
  /*! @0x/web3-wrapper */
  11),
      h = a(
  /*! @0x/assert */
  10),
      p = a(
  /*! ../../PolyResponse */
  14),
      b = a(
  /*! lodash */
  0),
      m = a(
  /*! ethers */
  13);
  (c = t.STOEvents_3_1_0 || (t.STOEvents_3_1_0 = {})).Pause = "Pause", c.Unpause = "Unpause", c.SetFundRaiseTypes = "SetFundRaiseTypes", c.RevokePreMintFlag = "RevokePreMintFlag", c.AllowPreMintFlag = "AllowPreMintFlag";

  var y = function (e) {
    function t(a, r, n, c) {
      var l = e.call(this, "STO", t.ABI(), a, r, n) || this;
      return l.reclaimETH = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.reclaimETH.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return d = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(d), [2, new p.PolyResponse(d, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return d = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * d), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("reclaimETH()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("reclaimETH()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("reclaimETH()", []);
        }
      }, l.getInitFunction = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getInitFunction()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getInitFunction()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getInitFunction()", []);
        }
      }, l.ADMIN = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("ADMIN()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("ADMIN()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("ADMIN()", []);
        }
      }, l.endTime = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("endTime()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("endTime()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("endTime()", []);
        }
      }, l.unpause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.unpause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return d = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(d), [2, new p.PolyResponse(d, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return d = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * d), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("unpause()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("unpause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("unpause()", []);
        }
      }, l.wallet = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("wallet()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("wallet()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("wallet()", []);
        }
      }, l.paused = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("paused()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("paused()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("paused()", []);
        }
      }, l.totalTokensSold = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("totalTokensSold()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("totalTokensSold()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("totalTokensSold()", []);
        }
      }, l.polyToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("polyToken()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("polyToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("polyToken()", []);
        }
      }, l.startTime = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("startTime()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("startTime()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("startTime()", []);
        }
      }, l.isFinalized = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("isFinalized()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("isFinalized()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("isFinalized()", []);
        }
      }, l.OPERATOR = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("OPERATOR()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("OPERATOR()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("OPERATOR()", []);
        }
      }, l.pausedTime = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pausedTime()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pausedTime()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pausedTime()", []);
        }
      }, l.securityToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("securityToken()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("securityToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("securityToken()", []);
        }
      }, l.getPermissions = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getPermissions()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getPermissions()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getPermissions()", []);
        }
      }, l.factory = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("factory()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("factory()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("factory()", []);
        }
      }, l.fundsRaised = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isNumberOrBigNumber("index_0", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("fundsRaised(uint8)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("fundsRaised(uint8)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isNumberOrBigNumber("index_0", e), this._strictEncodeArguments("fundsRaised(uint8)", [e]);
        }
      }, l.fundRaiseTypes = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isNumberOrBigNumber("index_0", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("fundRaiseTypes(uint8)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("fundRaiseTypes(uint8)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isNumberOrBigNumber("index_0", e), this._strictEncodeArguments("fundRaiseTypes(uint8)", [e]);
        }
      }, l.investorCount = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("investorCount()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("investorCount()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("investorCount()", []);
        }
      }, l.preMintAllowed = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("preMintAllowed()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("preMintAllowed()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("preMintAllowed()", []);
        }
      }, l.getDataStore = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDataStore()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDataStore()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDataStore()", []);
        }
      }, l.getRaised = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isNumberOrBigNumber("_fundRaiseType", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getRaised(uint8)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getRaised(uint8)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isNumberOrBigNumber("_fundRaiseType", e), this._strictEncodeArguments("getRaised(uint8)", [e]);
        }
      }, l.getTokensSold = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getTokensSold()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getTokensSold()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getTokensSold()", []);
        }
      }, l.pause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.pause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return d = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(d), [2, new p.PolyResponse(d, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, d, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return d = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * d), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pause()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pause()", []);
        }
      }, l.getTreasuryWallet = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.doesConformToSchema("callData", e, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== t && h.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getTreasuryWallet()", []), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getTreasuryWallet()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getTreasuryWallet()", []);
        }
      }, l.reclaimERC20 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.reclaimERC20.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(d)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new p.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, d, f, l, p, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (d = i.sent()).from && (d.from = d.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(d)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, p = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(p * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return h.assert.isString("_tokenContract", e), h.assert.doesConformToSchema("callData", t, d.schemas.callDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), void 0 !== a && h.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), [4, u.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), u.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("reclaimERC20(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return h.assert.isString("_tokenContract", e), this._strictEncodeArguments("reclaimERC20(address)", [e]);
        }
      }, l._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, f.classUtils.bindAll(l, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), l;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n) {
      return o(this, void 0, void 0, function () {
        var s, o, c, p, b, y, v, _, g, A;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return h.assert.isHexString("bytecode", e), h.assert.doesConformToSchema("txDefaults", n, d.schemas.txDataSchema, [d.schemas.addressSchema, d.schemas.numberSchema, d.schemas.jsNumber]), s = f.providerUtils.standardizeOrThrow(r), o = u.BaseContract._lookupConstructorAbi(a), u.BaseContract._formatABIDataItemList(o.inputs, [], u.BaseContract._bigNumberToString), c = new m.utils.Interface(a), p = c.deployFunction, b = p.encode(e, []), y = new l.Web3Wrapper(s), [4, u.BaseContract._applyDefaultsToTxDataAsync({
                data: b
              }, n, y.estimateGasAsync.bind(y))];

            case 1:
              return v = i.sent(), [4, y.sendTransactionAsync(v)];

            case 2:
              return _ = i.sent(), f.logUtils.log("transactionHash: " + _), [4, y.awaitTransactionSuccessAsync(_)];

            case 3:
              return g = i.sent(), f.logUtils.log("STO successfully deployed at " + g.contractAddress), (A = new t(g.contractAddress, s, n)).constructorArgs = [], [2, A];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !1,
        inputs: [],
        name: "reclaimETH",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getInitFunction",
        outputs: [{
          name: "initFunction",
          type: "bytes4"
        }],
        payable: !1,
        stateMutability: "pure",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "ADMIN",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "endTime",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "unpause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "wallet",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "paused",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "totalTokensSold",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "polyToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "startTime",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "isFinalized",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "OPERATOR",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "pausedTime",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "securityToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getPermissions",
        outputs: [{
          name: "permissions",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "factory",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "uint8"
        }],
        name: "fundsRaised",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "uint8"
        }],
        name: "fundRaiseTypes",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "investorCount",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "preMintAllowed",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDataStore",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Pause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Unpause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_fundRaiseTypes",
          type: "uint8[]",
          indexed: !1
        }],
        name: "SetFundRaiseTypes",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_owner",
          type: "address",
          indexed: !0
        }, {
          name: "_tokens",
          type: "uint256",
          indexed: !1
        }, {
          name: "_preMint",
          type: "bool",
          indexed: !1
        }],
        name: "RevokePreMintFlag",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_owner",
          type: "address",
          indexed: !0
        }, {
          name: "_tokens",
          type: "uint256",
          indexed: !1
        }, {
          name: "_preMint",
          type: "bool",
          indexed: !1
        }],
        name: "AllowPreMintFlag",
        outputs: [],
        type: "event"
      }, {
        constant: !0,
        inputs: [{
          name: "_fundRaiseType",
          type: "uint8"
        }],
        name: "getRaised",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getTokensSold",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "pause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getTreasuryWallet",
        outputs: [{
          name: "wallet",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenContract",
          type: "address"
        }],
        name: "reclaimERC20",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(u.BaseContract);

  t.STOContract_3_1_0 = y, t.isSTOContract_3_1_0 = function (e) {
    return b.isEqual(y.ABI(), e.abi);
  };
},
/*!*****************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.1.0/capped_s_t_o.js ***!
  \*****************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r106,
      n = this && this.__extends || (_r106 = function r(e, t) {
    return (_r106 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r106(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      c = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || 0 < t--) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u,
      d = a(
  /*! @0x/base-contract */
  12),
      f = a(
  /*! @0x/json-schemas */
  2),
      l = a(
  /*! @0x/utils */
  8),
      h = a(
  /*! @0x/web3-wrapper */
  11),
      p = a(
  /*! @0x/assert */
  10),
      b = a(
  /*! ../../PolyResponse */
  14),
      m = a(
  /*! lodash */
  0),
      y = a(
  /*! ethers */
  13);
  (u = t.CappedSTOEvents_3_1_0 || (t.CappedSTOEvents_3_1_0 = {})).TokenPurchase = "TokenPurchase", u.SetAllowBeneficialInvestments = "SetAllowBeneficialInvestments", u.ReserveTokenMint = "ReserveTokenMint", u.ReserveTokenTransfer = "ReserveTokenTransfer", u.Pause = "Pause", u.Unpause = "Unpause", u.SetFundRaiseTypes = "SetFundRaiseTypes", u.RevokePreMintFlag = "RevokePreMintFlag", u.AllowPreMintFlag = "AllowPreMintFlag";

  var v = function (e) {
    function t(a, r, n, c) {
      var u = e.call(this, "CappedSTO", t.ABI(), a, r, n) || this;
      return u.reclaimETH = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.reclaimETH.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("reclaimETH()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("reclaimETH()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("reclaimETH()", []);
        }
      }, u.ADMIN = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("ADMIN()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("ADMIN()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("ADMIN()", []);
        }
      }, u.getTreasuryWallet = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getTreasuryWallet()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getTreasuryWallet()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getTreasuryWallet()", []);
        }
      }, u.rate = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("rate()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("rate()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("rate()", []);
        }
      }, u.allowBeneficialInvestments = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("allowBeneficialInvestments()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("allowBeneficialInvestments()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("allowBeneficialInvestments()", []);
        }
      }, u.endTime = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("endTime()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("endTime()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("endTime()", []);
        }
      }, u.cap = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("cap()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("cap()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("cap()", []);
        }
      }, u.unpause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.unpause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("unpause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("unpause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("unpause()", []);
        }
      }, u.wallet = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("wallet()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("wallet()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("wallet()", []);
        }
      }, u.paused = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("paused()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("paused()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("paused()", []);
        }
      }, u.totalTokensSold = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("totalTokensSold()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("totalTokensSold()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("totalTokensSold()", []);
        }
      }, u.investors = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("investors(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("investors(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("index_0", e), this._strictEncodeArguments("investors(address)", [e]);
        }
      }, u.polyToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("polyToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("polyToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("polyToken()", []);
        }
      }, u.startTime = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("startTime()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("startTime()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("startTime()", []);
        }
      }, u.pause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.pause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pause()", []);
        }
      }, u.reclaimERC20 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.reclaimERC20.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("reclaimERC20(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_tokenContract", e), this._strictEncodeArguments("reclaimERC20(address)", [e]);
        }
      }, u.isFinalized = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("isFinalized()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("isFinalized()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("isFinalized()", []);
        }
      }, u.OPERATOR = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("OPERATOR()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("OPERATOR()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("OPERATOR()", []);
        }
      }, u.getRaised = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_fundRaiseType", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getRaised(uint8)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getRaised(uint8)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isNumberOrBigNumber("_fundRaiseType", e), this._strictEncodeArguments("getRaised(uint8)", [e]);
        }
      }, u.pausedTime = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pausedTime()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pausedTime()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pausedTime()", []);
        }
      }, u.securityToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("securityToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("securityToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("securityToken()", []);
        }
      }, u.factory = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("factory()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("factory()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("factory()", []);
        }
      }, u.fundsRaised = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("fundsRaised(uint8)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("fundsRaised(uint8)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isNumberOrBigNumber("index_0", e), this._strictEncodeArguments("fundsRaised(uint8)", [e]);
        }
      }, u.fundRaiseTypes = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("fundRaiseTypes(uint8)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("fundRaiseTypes(uint8)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isNumberOrBigNumber("index_0", e), this._strictEncodeArguments("fundRaiseTypes(uint8)", [e]);
        }
      }, u.investorCount = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("investorCount()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("investorCount()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("investorCount()", []);
        }
      }, u.preMintAllowed = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("preMintAllowed()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("preMintAllowed()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("preMintAllowed()", []);
        }
      }, u.getDataStore = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDataStore()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDataStore()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDataStore()", []);
        }
      }, u.configure = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u, f, l) {
          return o(this, void 0, void 0, function () {
            var o, h, m, y, v, _, g;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), p.assert.isBigNumber("_cap", a), p.assert.isBigNumber("_rate", r), p.assert.isArray("_fundRaiseTypes", n), p.assert.isString("_fundsReceiver", c), p.assert.isString("_treasuryWallet", u), h = (o = this)._strictEncodeArguments("configure(uint256,uint256,uint256,uint256,uint8[],address,address)", [e, t, a, r, n, c, u]), m = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return y = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, f, {
                    data: h
                  }), s({
                    from: y
                  }, m), o.configure.estimateGasAsync.bind(o, e, t, a, r, n, c, u, l))];

                case 2:
                  return void 0 !== (v = i.sent()).from && (v.from = v.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(v)];

                case 3:
                  return _ = i.sent(), g = o._web3Wrapper.awaitTransactionSuccessAsync(_), [2, new b.PolyResponse(_, g)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u, f, l) {
          return o(this, void 0, void 0, function () {
            var o, h, b, m, y, v, _, g, A;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), p.assert.isBigNumber("_cap", a), p.assert.isBigNumber("_rate", r), p.assert.isArray("_fundRaiseTypes", n), p.assert.isString("_fundsReceiver", c), p.assert.isString("_treasuryWallet", u), h = (o = this)._strictEncodeArguments("configure(uint256,uint256,uint256,uint256,uint8[],address,address)", [e, t, a, r, n, c, u]), b = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return m = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, l, {
                    data: h
                  }), s({
                    from: m
                  }, b))];

                case 2:
                  return void 0 !== (y = i.sent()).from && (y.from = y.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(y)];

                case 3:
                  return v = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return _ = i.sent().gasLimit, g = void 0 === f ? o._defaultEstimateGasFactor : f, A = Math.round(g * v), [2, _ < A ? _ : A];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u, l, h) {
          return void 0 === l && (l = {}), o(this, void 0, void 0, function () {
            var o, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), p.assert.isBigNumber("_cap", a), p.assert.isBigNumber("_rate", r), p.assert.isArray("_fundRaiseTypes", n), p.assert.isString("_fundsReceiver", c), p.assert.isString("_treasuryWallet", u), p.assert.doesConformToSchema("callData", l, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== h && p.assert.isBlockParam("defaultBlock", h), b = (o = this)._strictEncodeArguments("configure(uint256,uint256,uint256,uint256,uint8[],address,address)", [e, t, a, r, n, c, u]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, l, {
                    data: b
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (m = i.sent()).from = m.from ? m.from.toLowerCase() : m.from, [4, o._web3Wrapper.callAsync(m, h)];

                case 2:
                  return y = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(y), [2, o._lookupAbiEncoder("configure(uint256,uint256,uint256,uint256,uint8[],address,address)").strictDecodeReturnValue(y)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s, o) {
          return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), p.assert.isBigNumber("_cap", a), p.assert.isBigNumber("_rate", r), p.assert.isArray("_fundRaiseTypes", n), p.assert.isString("_fundsReceiver", s), p.assert.isString("_treasuryWallet", o), this._strictEncodeArguments("configure(uint256,uint256,uint256,uint256,uint8[],address,address)", [e, t, a, r, n, s, o]);
        }
      }, u.getInitFunction = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getInitFunction()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getInitFunction()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getInitFunction()", []);
        }
      }, u.allowPreMinting = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("allowPreMinting()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.allowPreMinting.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("allowPreMinting()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("allowPreMinting()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("allowPreMinting()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("allowPreMinting()", []);
        }
      }, u.revokePreMintFlag = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("revokePreMintFlag()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.revokePreMintFlag.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("revokePreMintFlag()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("revokePreMintFlag()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("revokePreMintFlag()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("revokePreMintFlag()", []);
        }
      }, u.changeAllowBeneficialInvestments = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBoolean("_allowBeneficialInvestments", e), n = (r = this)._strictEncodeArguments("changeAllowBeneficialInvestments(bool)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeAllowBeneficialInvestments.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBoolean("_allowBeneficialInvestments", e), n = (r = this)._strictEncodeArguments("changeAllowBeneficialInvestments(bool)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBoolean("_allowBeneficialInvestments", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeAllowBeneficialInvestments(bool)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeAllowBeneficialInvestments(bool)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBoolean("_allowBeneficialInvestments", e), this._strictEncodeArguments("changeAllowBeneficialInvestments(bool)", [e]);
        }
      }, u.buyTokens = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), n = (r = this)._strictEncodeArguments("buyTokens(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.buyTokens.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), n = (r = this)._strictEncodeArguments("buyTokens(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("buyTokens(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("buyTokens(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_beneficiary", e), this._strictEncodeArguments("buyTokens(address)", [e]);
        }
      }, u.buyTokensWithPoly = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_investedPOLY", e), n = (r = this)._strictEncodeArguments("buyTokensWithPoly(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.buyTokensWithPoly.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_investedPOLY", e), n = (r = this)._strictEncodeArguments("buyTokensWithPoly(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_investedPOLY", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("buyTokensWithPoly(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("buyTokensWithPoly(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_investedPOLY", e), this._strictEncodeArguments("buyTokensWithPoly(uint256)", [e]);
        }
      }, u.capReached = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("capReached()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("capReached()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("capReached()", []);
        }
      }, u.getTokensSold = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getTokensSold()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getTokensSold()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getTokensSold()", []);
        }
      }, u.getPermissions = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getPermissions()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getPermissions()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getPermissions()", []);
        }
      }, u.getSTODetails = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getSTODetails()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getSTODetails()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getSTODetails()", []);
        }
      }, u.finalize = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("finalize()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.finalize.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("finalize()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("finalize()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("finalize()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("finalize()", []);
        }
      }, u._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, l.classUtils.bindAll(u, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), u;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n, s, u) {
      return o(this, void 0, void 0, function () {
        var o, b, m, v, _, g, A, w, T, x, D;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return p.assert.isHexString("bytecode", e), p.assert.doesConformToSchema("txDefaults", n, f.schemas.txDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), o = l.providerUtils.standardizeOrThrow(r), b = d.BaseContract._lookupConstructorAbi(a), D = c(d.BaseContract._formatABIDataItemList(b.inputs, [s, u], d.BaseContract._bigNumberToString), 2), s = D[0], u = D[1], m = new y.utils.Interface(a), v = m.deployFunction, _ = v.encode(e, [s, u]), g = new h.Web3Wrapper(o), [4, d.BaseContract._applyDefaultsToTxDataAsync({
                data: _
              }, n, g.estimateGasAsync.bind(g))];

            case 1:
              return A = i.sent(), [4, g.sendTransactionAsync(A)];

            case 2:
              return w = i.sent(), l.logUtils.log("transactionHash: " + w), [4, g.awaitTransactionSuccessAsync(w)];

            case 3:
              return T = i.sent(), l.logUtils.log("CappedSTO successfully deployed at " + T.contractAddress), (x = new t(T.contractAddress, o, n)).constructorArgs = [s, u], [2, x];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !1,
        inputs: [],
        name: "reclaimETH",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "ADMIN",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getTreasuryWallet",
        outputs: [{
          name: "wallet",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "rate",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "allowBeneficialInvestments",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "endTime",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "cap",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "unpause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "wallet",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "paused",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "totalTokensSold",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "address"
        }],
        name: "investors",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "polyToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "startTime",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "pause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenContract",
          type: "address"
        }],
        name: "reclaimERC20",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "isFinalized",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "OPERATOR",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_fundRaiseType",
          type: "uint8"
        }],
        name: "getRaised",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "pausedTime",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "securityToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "factory",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "uint8"
        }],
        name: "fundsRaised",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "uint8"
        }],
        name: "fundRaiseTypes",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "investorCount",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "preMintAllowed",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDataStore",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        inputs: [{
          name: "_securityToken",
          type: "address"
        }, {
          name: "_polyToken",
          type: "address"
        }],
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "constructor"
      }, {
        inputs: [],
        outputs: [],
        payable: !0,
        stateMutability: "payable",
        type: "fallback"
      }, {
        anonymous: !1,
        inputs: [{
          name: "purchaser",
          type: "address",
          indexed: !0
        }, {
          name: "beneficiary",
          type: "address",
          indexed: !0
        }, {
          name: "value",
          type: "uint256",
          indexed: !1
        }, {
          name: "amount",
          type: "uint256",
          indexed: !1
        }],
        name: "TokenPurchase",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_allowed",
          type: "bool",
          indexed: !1
        }],
        name: "SetAllowBeneficialInvestments",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_owner",
          type: "address",
          indexed: !0
        }, {
          name: "_wallet",
          type: "address",
          indexed: !0
        }, {
          name: "_tokens",
          type: "uint256",
          indexed: !1
        }],
        name: "ReserveTokenMint",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_from",
          type: "address",
          indexed: !0
        }, {
          name: "_wallet",
          type: "address",
          indexed: !0
        }, {
          name: "_tokens",
          type: "uint256",
          indexed: !1
        }],
        name: "ReserveTokenTransfer",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Pause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Unpause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_fundRaiseTypes",
          type: "uint8[]",
          indexed: !1
        }],
        name: "SetFundRaiseTypes",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_owner",
          type: "address",
          indexed: !0
        }, {
          name: "_tokens",
          type: "uint256",
          indexed: !1
        }, {
          name: "_preMint",
          type: "bool",
          indexed: !1
        }],
        name: "RevokePreMintFlag",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_owner",
          type: "address",
          indexed: !0
        }, {
          name: "_tokens",
          type: "uint256",
          indexed: !1
        }, {
          name: "_preMint",
          type: "bool",
          indexed: !1
        }],
        name: "AllowPreMintFlag",
        outputs: [],
        type: "event"
      }, {
        constant: !1,
        inputs: [{
          name: "_startTime",
          type: "uint256"
        }, {
          name: "_endTime",
          type: "uint256"
        }, {
          name: "_cap",
          type: "uint256"
        }, {
          name: "_rate",
          type: "uint256"
        }, {
          name: "_fundRaiseTypes",
          type: "uint8[]"
        }, {
          name: "_fundsReceiver",
          type: "address"
        }, {
          name: "_treasuryWallet",
          type: "address"
        }],
        name: "configure",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getInitFunction",
        outputs: [{
          name: "",
          type: "bytes4"
        }],
        payable: !1,
        stateMutability: "pure",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "allowPreMinting",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "revokePreMintFlag",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_allowBeneficialInvestments",
          type: "bool"
        }],
        name: "changeAllowBeneficialInvestments",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address"
        }],
        name: "buyTokens",
        outputs: [],
        payable: !0,
        stateMutability: "payable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_investedPOLY",
          type: "uint256"
        }],
        name: "buyTokensWithPoly",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "capReached",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getTokensSold",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getPermissions",
        outputs: [{
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getSTODetails",
        outputs: [{
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "bool"
        }, {
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "finalize",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(d.BaseContract);

  t.CappedSTOContract_3_1_0 = v, t.isCappedSTOContract_3_1_0 = function (e) {
    return m.isEqual(v.ABI(), e.abi);
  };
},
/*!*******************************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.1.0/general_permission_manager.js ***!
  \*******************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r107,
      n = this && this.__extends || (_r107 = function r(e, t) {
    return (_r107 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r107(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      c = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || 0 < t--) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u,
      d = a(
  /*! @0x/base-contract */
  12),
      f = a(
  /*! @0x/json-schemas */
  2),
      l = a(
  /*! @0x/utils */
  8),
      h = a(
  /*! @0x/web3-wrapper */
  11),
      p = a(
  /*! @0x/assert */
  10),
      b = a(
  /*! ../../PolyResponse */
  14),
      m = a(
  /*! lodash */
  0),
      y = a(
  /*! ethers */
  13);
  (u = t.GeneralPermissionManagerEvents_3_1_0 || (t.GeneralPermissionManagerEvents_3_1_0 = {})).ChangePermission = "ChangePermission", u.AddDelegate = "AddDelegate", u.Pause = "Pause", u.Unpause = "Unpause";

  var v = function (e) {
    function t(a, r, n, c) {
      var u = e.call(this, "GeneralPermissionManager", t.ABI(), a, r, n) || this;
      return u.reclaimETH = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.reclaimETH.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("reclaimETH()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("reclaimETH()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("reclaimETH()", []);
        }
      }, u.ADMIN = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("ADMIN()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("ADMIN()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("ADMIN()", []);
        }
      }, u.unpause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.unpause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("unpause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("unpause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("unpause()", []);
        }
      }, u.perms = {
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("index_0", e), p.assert.isString("index_1", t), p.assert.isString("index_2", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("perms(address,address,bytes32)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("perms(address,address,bytes32)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isString("index_0", e), p.assert.isString("index_1", t), p.assert.isString("index_2", a), this._strictEncodeArguments("perms(address,address,bytes32)", [e, t, a]);
        }
      }, u.paused = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("paused()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("paused()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("paused()", []);
        }
      }, u.polyToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("polyToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("polyToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("polyToken()", []);
        }
      }, u.pause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.pause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pause()", []);
        }
      }, u.reclaimERC20 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.reclaimERC20.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("reclaimERC20(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_tokenContract", e), this._strictEncodeArguments("reclaimERC20(address)", [e]);
        }
      }, u.allDelegates = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("allDelegates(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("allDelegates(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("index_0", e), this._strictEncodeArguments("allDelegates(uint256)", [e]);
        }
      }, u.OPERATOR = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("OPERATOR()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("OPERATOR()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("OPERATOR()", []);
        }
      }, u.securityToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("securityToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("securityToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("securityToken()", []);
        }
      }, u.factory = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("factory()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("factory()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("factory()", []);
        }
      }, u.delegateDetails = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("delegateDetails(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("delegateDetails(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("index_0", e), this._strictEncodeArguments("delegateDetails(address)", [e]);
        }
      }, u.getDataStore = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDataStore()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDataStore()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDataStore()", []);
        }
      }, u.getInitFunction = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getInitFunction()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getInitFunction()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getInitFunction()", []);
        }
      }, u.checkPermission = {
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_delegate", e), p.assert.isString("_module", t), p.assert.isString("_perm", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("checkPermission(address,address,bytes32)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("checkPermission(address,address,bytes32)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isString("_delegate", e), p.assert.isString("_module", t), p.assert.isString("_perm", a), this._strictEncodeArguments("checkPermission(address,address,bytes32)", [e, t, a]);
        }
      }, u.addDelegate = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_delegate", e), p.assert.isString("_details", t), o = (n = this)._strictEncodeArguments("addDelegate(address,bytes32)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.addDelegate.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_delegate", e), p.assert.isString("_details", t), o = (n = this)._strictEncodeArguments("addDelegate(address,bytes32)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_delegate", e), p.assert.isString("_details", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("addDelegate(address,bytes32)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("addDelegate(address,bytes32)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_delegate", e), p.assert.isString("_details", t), this._strictEncodeArguments("addDelegate(address,bytes32)", [e, t]);
        }
      }, u.addDelegateMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_delegates", e), p.assert.isArray("_details", t), o = (n = this)._strictEncodeArguments("addDelegateMulti(address[],bytes32[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.addDelegateMulti.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_delegates", e), p.assert.isArray("_details", t), o = (n = this)._strictEncodeArguments("addDelegateMulti(address[],bytes32[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_delegates", e), p.assert.isArray("_details", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("addDelegateMulti(address[],bytes32[])", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("addDelegateMulti(address[],bytes32[])").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isArray("_delegates", e), p.assert.isArray("_details", t), this._strictEncodeArguments("addDelegateMulti(address[],bytes32[])", [e, t]);
        }
      }, u.deleteDelegate = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_delegate", e), n = (r = this)._strictEncodeArguments("deleteDelegate(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.deleteDelegate.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_delegate", e), n = (r = this)._strictEncodeArguments("deleteDelegate(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_delegate", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("deleteDelegate(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("deleteDelegate(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_delegate", e), this._strictEncodeArguments("deleteDelegate(address)", [e]);
        }
      }, u.deleteDelegateMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_delegates", e), n = (r = this)._strictEncodeArguments("deleteDelegateMulti(address[])", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.deleteDelegateMulti.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_delegates", e), n = (r = this)._strictEncodeArguments("deleteDelegateMulti(address[])", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_delegates", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("deleteDelegateMulti(address[])", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("deleteDelegateMulti(address[])").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isArray("_delegates", e), this._strictEncodeArguments("deleteDelegateMulti(address[])", [e]);
        }
      }, u.checkDelegate = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_potentialDelegate", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("checkDelegate(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("checkDelegate(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_potentialDelegate", e), this._strictEncodeArguments("checkDelegate(address)", [e]);
        }
      }, u.changePermission = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_delegate", e), p.assert.isString("_module", t), p.assert.isString("_perm", a), p.assert.isBoolean("_valid", r), u = (o = this)._strictEncodeArguments("changePermission(address,address,bytes32,bool)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.changePermission.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_delegate", e), p.assert.isString("_module", t), p.assert.isString("_perm", a), p.assert.isBoolean("_valid", r), u = (o = this)._strictEncodeArguments("changePermission(address,address,bytes32,bool)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_delegate", e), p.assert.isString("_module", t), p.assert.isString("_perm", a), p.assert.isBoolean("_valid", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("changePermission(address,address,bytes32,bool)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("changePermission(address,address,bytes32,bool)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isString("_delegate", e), p.assert.isString("_module", t), p.assert.isString("_perm", a), p.assert.isBoolean("_valid", r), this._strictEncodeArguments("changePermission(address,address,bytes32,bool)", [e, t, a, r]);
        }
      }, u.changePermissionMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_delegate", e), p.assert.isArray("_modules", t), p.assert.isArray("_perms", a), p.assert.isArray("_valids", r), u = (o = this)._strictEncodeArguments("changePermissionMulti(address,address[],bytes32[],bool[])", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.changePermissionMulti.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_delegate", e), p.assert.isArray("_modules", t), p.assert.isArray("_perms", a), p.assert.isArray("_valids", r), u = (o = this)._strictEncodeArguments("changePermissionMulti(address,address[],bytes32[],bool[])", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_delegate", e), p.assert.isArray("_modules", t), p.assert.isArray("_perms", a), p.assert.isArray("_valids", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("changePermissionMulti(address,address[],bytes32[],bool[])", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("changePermissionMulti(address,address[],bytes32[],bool[])").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isString("_delegate", e), p.assert.isArray("_modules", t), p.assert.isArray("_perms", a), p.assert.isArray("_valids", r), this._strictEncodeArguments("changePermissionMulti(address,address[],bytes32[],bool[])", [e, t, a, r]);
        }
      }, u.getAllDelegatesWithPerm = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_module", e), p.assert.isString("_perm", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("getAllDelegatesWithPerm(address,bytes32)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("getAllDelegatesWithPerm(address,bytes32)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_module", e), p.assert.isString("_perm", t), this._strictEncodeArguments("getAllDelegatesWithPerm(address,bytes32)", [e, t]);
        }
      }, u.getAllModulesAndPermsFromTypes = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_delegate", e), p.assert.isArray("_types", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("getAllModulesAndPermsFromTypes(address,uint8[])", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("getAllModulesAndPermsFromTypes(address,uint8[])").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_delegate", e), p.assert.isArray("_types", t), this._strictEncodeArguments("getAllModulesAndPermsFromTypes(address,uint8[])", [e, t]);
        }
      }, u.getAllDelegates = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getAllDelegates()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getAllDelegates()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getAllDelegates()", []);
        }
      }, u.getPermissions = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getPermissions()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getPermissions()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getPermissions()", []);
        }
      }, u._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, l.classUtils.bindAll(u, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), u;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n, s, u) {
      return o(this, void 0, void 0, function () {
        var o, b, m, v, _, g, A, w, T, x, D;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return p.assert.isHexString("bytecode", e), p.assert.doesConformToSchema("txDefaults", n, f.schemas.txDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), o = l.providerUtils.standardizeOrThrow(r), b = d.BaseContract._lookupConstructorAbi(a), D = c(d.BaseContract._formatABIDataItemList(b.inputs, [s, u], d.BaseContract._bigNumberToString), 2), s = D[0], u = D[1], m = new y.utils.Interface(a), v = m.deployFunction, _ = v.encode(e, [s, u]), g = new h.Web3Wrapper(o), [4, d.BaseContract._applyDefaultsToTxDataAsync({
                data: _
              }, n, g.estimateGasAsync.bind(g))];

            case 1:
              return A = i.sent(), [4, g.sendTransactionAsync(A)];

            case 2:
              return w = i.sent(), l.logUtils.log("transactionHash: " + w), [4, g.awaitTransactionSuccessAsync(w)];

            case 3:
              return T = i.sent(), l.logUtils.log("GeneralPermissionManager successfully deployed at " + T.contractAddress), (x = new t(T.contractAddress, o, n)).constructorArgs = [s, u], [2, x];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !1,
        inputs: [],
        name: "reclaimETH",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "ADMIN",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "unpause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "address"
        }, {
          name: "index_1",
          type: "address"
        }, {
          name: "index_2",
          type: "bytes32"
        }],
        name: "perms",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "paused",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "polyToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "pause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenContract",
          type: "address"
        }],
        name: "reclaimERC20",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "uint256"
        }],
        name: "allDelegates",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "OPERATOR",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "securityToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "factory",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "address"
        }],
        name: "delegateDetails",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDataStore",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        inputs: [{
          name: "_securityToken",
          type: "address"
        }, {
          name: "_polyToken",
          type: "address"
        }],
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "constructor"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_delegate",
          type: "address",
          indexed: !0
        }, {
          name: "_module",
          type: "address",
          indexed: !1
        }, {
          name: "_perm",
          type: "bytes32",
          indexed: !1
        }, {
          name: "_valid",
          type: "bool",
          indexed: !1
        }],
        name: "ChangePermission",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_delegate",
          type: "address",
          indexed: !0
        }, {
          name: "_details",
          type: "bytes32",
          indexed: !1
        }],
        name: "AddDelegate",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Pause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Unpause",
        outputs: [],
        type: "event"
      }, {
        constant: !0,
        inputs: [],
        name: "getInitFunction",
        outputs: [{
          name: "",
          type: "bytes4"
        }],
        payable: !1,
        stateMutability: "pure",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_delegate",
          type: "address"
        }, {
          name: "_module",
          type: "address"
        }, {
          name: "_perm",
          type: "bytes32"
        }],
        name: "checkPermission",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_delegate",
          type: "address"
        }, {
          name: "_details",
          type: "bytes32"
        }],
        name: "addDelegate",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_delegates",
          type: "address[]"
        }, {
          name: "_details",
          type: "bytes32[]"
        }],
        name: "addDelegateMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_delegate",
          type: "address"
        }],
        name: "deleteDelegate",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_delegates",
          type: "address[]"
        }],
        name: "deleteDelegateMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_potentialDelegate",
          type: "address"
        }],
        name: "checkDelegate",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_delegate",
          type: "address"
        }, {
          name: "_module",
          type: "address"
        }, {
          name: "_perm",
          type: "bytes32"
        }, {
          name: "_valid",
          type: "bool"
        }],
        name: "changePermission",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_delegate",
          type: "address"
        }, {
          name: "_modules",
          type: "address[]"
        }, {
          name: "_perms",
          type: "bytes32[]"
        }, {
          name: "_valids",
          type: "bool[]"
        }],
        name: "changePermissionMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_module",
          type: "address"
        }, {
          name: "_perm",
          type: "bytes32"
        }],
        name: "getAllDelegatesWithPerm",
        outputs: [{
          name: "",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_delegate",
          type: "address"
        }, {
          name: "_types",
          type: "uint8[]"
        }],
        name: "getAllModulesAndPermsFromTypes",
        outputs: [{
          name: "",
          type: "address[]"
        }, {
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getAllDelegates",
        outputs: [{
          name: "",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getPermissions",
        outputs: [{
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(d.BaseContract);

  t.GeneralPermissionManagerContract_3_1_0 = v, t.isGeneralPermissionManagerContract_3_1_0 = function (e) {
    return m.isEqual(v.ABI(), e.abi);
  };
},
/*!*****************************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.1.0/general_transfer_manager.js ***!
  \*****************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r108,
      n = this && this.__extends || (_r108 = function r(e, t) {
    return (_r108 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r108(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      c = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || 0 < t--) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u,
      d = a(
  /*! @0x/base-contract */
  12),
      f = a(
  /*! @0x/json-schemas */
  2),
      l = a(
  /*! @0x/utils */
  8),
      h = a(
  /*! @0x/web3-wrapper */
  11),
      p = a(
  /*! @0x/assert */
  10),
      b = a(
  /*! ../../PolyResponse */
  14),
      m = a(
  /*! lodash */
  0),
      y = a(
  /*! ethers */
  13);
  (u = t.GeneralTransferManagerEvents_3_1_0 || (t.GeneralTransferManagerEvents_3_1_0 = {})).ChangeIssuanceAddress = "ChangeIssuanceAddress", u.ChangeDefaults = "ChangeDefaults", u.ModifyKYCData = "ModifyKYCData", u.ModifyInvestorFlag = "ModifyInvestorFlag", u.ModifyTransferRequirements = "ModifyTransferRequirements", u.Pause = "Pause", u.Unpause = "Unpause";

  var v = function (e) {
    function t(a, r, n, c) {
      var u = e.call(this, "GeneralTransferManager", t.ABI(), a, r, n) || this;
      return u.reclaimETH = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.reclaimETH.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("reclaimETH()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("reclaimETH()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("reclaimETH()", []);
        }
      }, u.WHITELIST = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("WHITELIST()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("WHITELIST()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("WHITELIST()", []);
        }
      }, u.ADMIN = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("ADMIN()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("ADMIN()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("ADMIN()", []);
        }
      }, u.unpause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.unpause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("unpause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("unpause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("unpause()", []);
        }
      }, u.paused = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("paused()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("paused()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("paused()", []);
        }
      }, u.INVESTORFLAGS = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("INVESTORFLAGS()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("INVESTORFLAGS()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("INVESTORFLAGS()", []);
        }
      }, u.UNLOCKED = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("UNLOCKED()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("UNLOCKED()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("UNLOCKED()", []);
        }
      }, u.polyToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("polyToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("polyToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("polyToken()", []);
        }
      }, u.pause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.pause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pause()", []);
        }
      }, u.reclaimERC20 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.reclaimERC20.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("reclaimERC20(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_tokenContract", e), this._strictEncodeArguments("reclaimERC20(address)", [e]);
        }
      }, u.OPERATOR = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("OPERATOR()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("OPERATOR()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("OPERATOR()", []);
        }
      }, u.nonceMap = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("index_0", e), p.assert.isBigNumber("index_1", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("nonceMap(address,uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("nonceMap(address,uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("index_0", e), p.assert.isBigNumber("index_1", t), this._strictEncodeArguments("nonceMap(address,uint256)", [e, t]);
        }
      }, u.LOCKED = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("LOCKED()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("LOCKED()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("LOCKED()", []);
        }
      }, u.issuanceAddress = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("issuanceAddress()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("issuanceAddress()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("issuanceAddress()", []);
        }
      }, u.securityToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("securityToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("securityToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("securityToken()", []);
        }
      }, u.INVESTORSKEY = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("INVESTORSKEY()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("INVESTORSKEY()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("INVESTORSKEY()", []);
        }
      }, u.transferRequirements = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("transferRequirements(uint8)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("transferRequirements(uint8)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isNumberOrBigNumber("index_0", e), this._strictEncodeArguments("transferRequirements(uint8)", [e]);
        }
      }, u.factory = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("factory()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("factory()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("factory()", []);
        }
      }, u.WHITELISTMODULE = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("WHITELISTMODULE()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("WHITELISTMODULE()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("WHITELISTMODULE()", []);
        }
      }, u.defaults = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("defaults()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("defaults()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("defaults()", []);
        }
      }, u.getDataStore = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDataStore()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDataStore()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDataStore()", []);
        }
      }, u.getInitFunction = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getInitFunction()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getInitFunction()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getInitFunction()", []);
        }
      }, u.changeDefaults = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_defaultCanSendAfter", e), p.assert.isBigNumber("_defaultCanReceiveAfter", t), o = (n = this)._strictEncodeArguments("changeDefaults(uint64,uint64)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.changeDefaults.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_defaultCanSendAfter", e), p.assert.isBigNumber("_defaultCanReceiveAfter", t), o = (n = this)._strictEncodeArguments("changeDefaults(uint64,uint64)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_defaultCanSendAfter", e), p.assert.isBigNumber("_defaultCanReceiveAfter", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("changeDefaults(uint64,uint64)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("changeDefaults(uint64,uint64)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isBigNumber("_defaultCanSendAfter", e), p.assert.isBigNumber("_defaultCanReceiveAfter", t), this._strictEncodeArguments("changeDefaults(uint64,uint64)", [e, t]);
        }
      }, u.changeIssuanceAddress = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_issuanceAddress", e), n = (r = this)._strictEncodeArguments("changeIssuanceAddress(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeIssuanceAddress.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_issuanceAddress", e), n = (r = this)._strictEncodeArguments("changeIssuanceAddress(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_issuanceAddress", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeIssuanceAddress(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeIssuanceAddress(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_issuanceAddress", e), this._strictEncodeArguments("changeIssuanceAddress(address)", [e]);
        }
      }, u.executeTransfer = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("index_2", a), p.assert.isString("_data", r), u = (o = this)._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.executeTransfer.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("index_2", a), p.assert.isString("_data", r), u = (o = this)._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("index_2", a), p.assert.isString("_data", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("executeTransfer(address,address,uint256,bytes)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("index_2", a), p.assert.isString("_data", r), this._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]);
        }
      }, u.verifyTransfer = {
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("index_2", a), p.assert.isString("_data", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("verifyTransfer(address,address,uint256,bytes)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("verifyTransfer(address,address,uint256,bytes)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isString("_from", e), p.assert.isString("_to", t), p.assert.isBigNumber("index_2", a), p.assert.isString("_data", r), this._strictEncodeArguments("verifyTransfer(address,address,uint256,bytes)", [e, t, a, r]);
        }
      }, u.modifyTransferRequirements = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_transferType", e), p.assert.isBoolean("_fromValidKYC", t), p.assert.isBoolean("_toValidKYC", a), p.assert.isBoolean("_fromRestricted", r), p.assert.isBoolean("_toRestricted", n), f = (o = this)._strictEncodeArguments("modifyTransferRequirements(uint8,bool,bool,bool,bool)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: f
                  }), s({
                    from: h
                  }, l), o.modifyTransferRequirements.estimateGasAsync.bind(o, e, t, a, r, n, u))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(m)];

                case 3:
                  return y = i.sent(), v = o._web3Wrapper.awaitTransactionSuccessAsync(y), [2, new b.PolyResponse(y, v)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_transferType", e), p.assert.isBoolean("_fromValidKYC", t), p.assert.isBoolean("_toValidKYC", a), p.assert.isBoolean("_fromRestricted", r), p.assert.isBoolean("_toRestricted", n), f = (o = this)._strictEncodeArguments("modifyTransferRequirements(uint8,bool,bool,bool,bool)", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: f
                  }), s({
                    from: h
                  }, l))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(b)];

                case 3:
                  return m = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return y = i.sent().gasLimit, v = void 0 === c ? o._defaultEstimateGasFactor : c, _ = Math.round(v * m), [2, y < _ ? y : _];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u) {
          return void 0 === c && (c = {}), o(this, void 0, void 0, function () {
            var o, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_transferType", e), p.assert.isBoolean("_fromValidKYC", t), p.assert.isBoolean("_toValidKYC", a), p.assert.isBoolean("_fromRestricted", r), p.assert.isBoolean("_toRestricted", n), p.assert.doesConformToSchema("callData", c, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== u && p.assert.isBlockParam("defaultBlock", u), l = (o = this)._strictEncodeArguments("modifyTransferRequirements(uint8,bool,bool,bool,bool)", [e, t, a, r, n]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: l
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (h = i.sent()).from = h.from ? h.from.toLowerCase() : h.from, [4, o._web3Wrapper.callAsync(h, u)];

                case 2:
                  return b = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(b), [2, o._lookupAbiEncoder("modifyTransferRequirements(uint8,bool,bool,bool,bool)").strictDecodeReturnValue(b)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n) {
          return p.assert.isNumberOrBigNumber("_transferType", e), p.assert.isBoolean("_fromValidKYC", t), p.assert.isBoolean("_toValidKYC", a), p.assert.isBoolean("_fromRestricted", r), p.assert.isBoolean("_toRestricted", n), this._strictEncodeArguments("modifyTransferRequirements(uint8,bool,bool,bool,bool)", [e, t, a, r, n]);
        }
      }, u.modifyTransferRequirementsMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_transferTypes", e), p.assert.isArray("_fromValidKYC", t), p.assert.isArray("_toValidKYC", a), p.assert.isArray("_fromRestricted", r), p.assert.isArray("_toRestricted", n), f = (o = this)._strictEncodeArguments("modifyTransferRequirementsMulti(uint8[],bool[],bool[],bool[],bool[])", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: f
                  }), s({
                    from: h
                  }, l), o.modifyTransferRequirementsMulti.estimateGasAsync.bind(o, e, t, a, r, n, u))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(m)];

                case 3:
                  return y = i.sent(), v = o._web3Wrapper.awaitTransactionSuccessAsync(y), [2, new b.PolyResponse(y, v)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u) {
          return o(this, void 0, void 0, function () {
            var o, f, l, h, b, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_transferTypes", e), p.assert.isArray("_fromValidKYC", t), p.assert.isArray("_toValidKYC", a), p.assert.isArray("_fromRestricted", r), p.assert.isArray("_toRestricted", n), f = (o = this)._strictEncodeArguments("modifyTransferRequirementsMulti(uint8[],bool[],bool[],bool[],bool[])", [e, t, a, r, n]), l = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return h = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: f
                  }), s({
                    from: h
                  }, l))];

                case 2:
                  return void 0 !== (b = i.sent()).from && (b.from = b.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(b)];

                case 3:
                  return m = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return y = i.sent().gasLimit, v = void 0 === c ? o._defaultEstimateGasFactor : c, _ = Math.round(v * m), [2, y < _ ? y : _];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u) {
          return void 0 === c && (c = {}), o(this, void 0, void 0, function () {
            var o, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_transferTypes", e), p.assert.isArray("_fromValidKYC", t), p.assert.isArray("_toValidKYC", a), p.assert.isArray("_fromRestricted", r), p.assert.isArray("_toRestricted", n), p.assert.doesConformToSchema("callData", c, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== u && p.assert.isBlockParam("defaultBlock", u), l = (o = this)._strictEncodeArguments("modifyTransferRequirementsMulti(uint8[],bool[],bool[],bool[],bool[])", [e, t, a, r, n]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: l
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (h = i.sent()).from = h.from ? h.from.toLowerCase() : h.from, [4, o._web3Wrapper.callAsync(h, u)];

                case 2:
                  return b = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(b), [2, o._lookupAbiEncoder("modifyTransferRequirementsMulti(uint8[],bool[],bool[],bool[],bool[])").strictDecodeReturnValue(b)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n) {
          return p.assert.isArray("_transferTypes", e), p.assert.isArray("_fromValidKYC", t), p.assert.isArray("_toValidKYC", a), p.assert.isArray("_fromRestricted", r), p.assert.isArray("_toRestricted", n), this._strictEncodeArguments("modifyTransferRequirementsMulti(uint8[],bool[],bool[],bool[],bool[])", [e, t, a, r, n]);
        }
      }, u.modifyKYCData = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.isBigNumber("_canSendAfter", t), p.assert.isBigNumber("_canReceiveAfter", a), p.assert.isBigNumber("_expiryTime", r), u = (o = this)._strictEncodeArguments("modifyKYCData(address,uint64,uint64,uint64)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.modifyKYCData.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.isBigNumber("_canSendAfter", t), p.assert.isBigNumber("_canReceiveAfter", a), p.assert.isBigNumber("_expiryTime", r), u = (o = this)._strictEncodeArguments("modifyKYCData(address,uint64,uint64,uint64)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.isBigNumber("_canSendAfter", t), p.assert.isBigNumber("_canReceiveAfter", a), p.assert.isBigNumber("_expiryTime", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("modifyKYCData(address,uint64,uint64,uint64)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("modifyKYCData(address,uint64,uint64,uint64)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isString("_investor", e), p.assert.isBigNumber("_canSendAfter", t), p.assert.isBigNumber("_canReceiveAfter", a), p.assert.isBigNumber("_expiryTime", r), this._strictEncodeArguments("modifyKYCData(address,uint64,uint64,uint64)", [e, t, a, r]);
        }
      }, u.modifyKYCDataMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isArray("_canSendAfter", t), p.assert.isArray("_canReceiveAfter", a), p.assert.isArray("_expiryTime", r), u = (o = this)._strictEncodeArguments("modifyKYCDataMulti(address[],uint64[],uint64[],uint64[])", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.modifyKYCDataMulti.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isArray("_canSendAfter", t), p.assert.isArray("_canReceiveAfter", a), p.assert.isArray("_expiryTime", r), u = (o = this)._strictEncodeArguments("modifyKYCDataMulti(address[],uint64[],uint64[],uint64[])", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isArray("_canSendAfter", t), p.assert.isArray("_canReceiveAfter", a), p.assert.isArray("_expiryTime", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("modifyKYCDataMulti(address[],uint64[],uint64[],uint64[])", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("modifyKYCDataMulti(address[],uint64[],uint64[],uint64[])").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isArray("_investors", e), p.assert.isArray("_canSendAfter", t), p.assert.isArray("_canReceiveAfter", a), p.assert.isArray("_expiryTime", r), this._strictEncodeArguments("modifyKYCDataMulti(address[],uint64[],uint64[],uint64[])", [e, t, a, r]);
        }
      }, u.modifyInvestorFlag = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.isNumberOrBigNumber("_flag", t), p.assert.isBoolean("_value", a), c = (o = this)._strictEncodeArguments("modifyInvestorFlag(address,uint8,bool)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.modifyInvestorFlag.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.isNumberOrBigNumber("_flag", t), p.assert.isBoolean("_value", a), c = (o = this)._strictEncodeArguments("modifyInvestorFlag(address,uint8,bool)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.isNumberOrBigNumber("_flag", t), p.assert.isBoolean("_value", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("modifyInvestorFlag(address,uint8,bool)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("modifyInvestorFlag(address,uint8,bool)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isString("_investor", e), p.assert.isNumberOrBigNumber("_flag", t), p.assert.isBoolean("_value", a), this._strictEncodeArguments("modifyInvestorFlag(address,uint8,bool)", [e, t, a]);
        }
      }, u.modifyInvestorFlagMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isArray("_flag", t), p.assert.isArray("_value", a), c = (o = this)._strictEncodeArguments("modifyInvestorFlagMulti(address[],uint8[],bool[])", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.modifyInvestorFlagMulti.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isArray("_flag", t), p.assert.isArray("_value", a), c = (o = this)._strictEncodeArguments("modifyInvestorFlagMulti(address[],uint8[],bool[])", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isArray("_flag", t), p.assert.isArray("_value", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("modifyInvestorFlagMulti(address[],uint8[],bool[])", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("modifyInvestorFlagMulti(address[],uint8[],bool[])").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isArray("_investors", e), p.assert.isArray("_flag", t), p.assert.isArray("_value", a), this._strictEncodeArguments("modifyInvestorFlagMulti(address[],uint8[],bool[])", [e, t, a]);
        }
      }, u.modifyKYCDataSigned = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u, f, l, h) {
          return o(this, void 0, void 0, function () {
            var o, m, y, v, _, g, A;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.isBigNumber("_canSendAfter", t), p.assert.isBigNumber("_canReceiveAfter", a), p.assert.isBigNumber("_expiryTime", r), p.assert.isBigNumber("_validFrom", n), p.assert.isBigNumber("_validTo", c), p.assert.isBigNumber("_nonce", u), p.assert.isString("_signature", f), m = (o = this)._strictEncodeArguments("modifyKYCDataSigned(address,uint256,uint256,uint256,uint256,uint256,uint256,bytes)", [e, t, a, r, n, c, u, f]), y = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return v = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, l, {
                    data: m
                  }), s({
                    from: v
                  }, y), o.modifyKYCDataSigned.estimateGasAsync.bind(o, e, t, a, r, n, c, u, f, h))];

                case 2:
                  return void 0 !== (_ = i.sent()).from && (_.from = _.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(_)];

                case 3:
                  return g = i.sent(), A = o._web3Wrapper.awaitTransactionSuccessAsync(g), [2, new b.PolyResponse(g, A)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u, f, l, h) {
          return o(this, void 0, void 0, function () {
            var o, b, m, y, v, _, g, A, w;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.isBigNumber("_canSendAfter", t), p.assert.isBigNumber("_canReceiveAfter", a), p.assert.isBigNumber("_expiryTime", r), p.assert.isBigNumber("_validFrom", n), p.assert.isBigNumber("_validTo", c), p.assert.isBigNumber("_nonce", u), p.assert.isString("_signature", f), b = (o = this)._strictEncodeArguments("modifyKYCDataSigned(address,uint256,uint256,uint256,uint256,uint256,uint256,bytes)", [e, t, a, r, n, c, u, f]), m = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return y = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, h, {
                    data: b
                  }), s({
                    from: y
                  }, m))];

                case 2:
                  return void 0 !== (v = i.sent()).from && (v.from = v.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(v)];

                case 3:
                  return _ = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return g = i.sent().gasLimit, A = void 0 === l ? o._defaultEstimateGasFactor : l, w = Math.round(A * _), [2, g < w ? g : w];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u, l, h, b) {
          return void 0 === h && (h = {}), o(this, void 0, void 0, function () {
            var o, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.isBigNumber("_canSendAfter", t), p.assert.isBigNumber("_canReceiveAfter", a), p.assert.isBigNumber("_expiryTime", r), p.assert.isBigNumber("_validFrom", n), p.assert.isBigNumber("_validTo", c), p.assert.isBigNumber("_nonce", u), p.assert.isString("_signature", l), p.assert.doesConformToSchema("callData", h, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== b && p.assert.isBlockParam("defaultBlock", b), m = (o = this)._strictEncodeArguments("modifyKYCDataSigned(address,uint256,uint256,uint256,uint256,uint256,uint256,bytes)", [e, t, a, r, n, c, u, l]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, h, {
                    data: m
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (y = i.sent()).from = y.from ? y.from.toLowerCase() : y.from, [4, o._web3Wrapper.callAsync(y, b)];

                case 2:
                  return v = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(v), [2, o._lookupAbiEncoder("modifyKYCDataSigned(address,uint256,uint256,uint256,uint256,uint256,uint256,bytes)").strictDecodeReturnValue(v)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s, o, i) {
          return p.assert.isString("_investor", e), p.assert.isBigNumber("_canSendAfter", t), p.assert.isBigNumber("_canReceiveAfter", a), p.assert.isBigNumber("_expiryTime", r), p.assert.isBigNumber("_validFrom", n), p.assert.isBigNumber("_validTo", s), p.assert.isBigNumber("_nonce", o), p.assert.isString("_signature", i), this._strictEncodeArguments("modifyKYCDataSigned(address,uint256,uint256,uint256,uint256,uint256,uint256,bytes)", [e, t, a, r, n, s, o, i]);
        }
      }, u.modifyKYCDataSignedMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u, f, l, h) {
          return o(this, void 0, void 0, function () {
            var o, m, y, v, _, g, A;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investor", e), p.assert.isArray("_canSendAfter", t), p.assert.isArray("_canReceiveAfter", a), p.assert.isArray("_expiryTime", r), p.assert.isBigNumber("_validFrom", n), p.assert.isBigNumber("_validTo", c), p.assert.isBigNumber("_nonce", u), p.assert.isString("_signature", f), m = (o = this)._strictEncodeArguments("modifyKYCDataSignedMulti(address[],uint256[],uint256[],uint256[],uint256,uint256,uint256,bytes)", [e, t, a, r, n, c, u, f]), y = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return v = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, l, {
                    data: m
                  }), s({
                    from: v
                  }, y), o.modifyKYCDataSignedMulti.estimateGasAsync.bind(o, e, t, a, r, n, c, u, f, h))];

                case 2:
                  return void 0 !== (_ = i.sent()).from && (_.from = _.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(_)];

                case 3:
                  return g = i.sent(), A = o._web3Wrapper.awaitTransactionSuccessAsync(g), [2, new b.PolyResponse(g, A)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u, f, l, h) {
          return o(this, void 0, void 0, function () {
            var o, b, m, y, v, _, g, A, w;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investor", e), p.assert.isArray("_canSendAfter", t), p.assert.isArray("_canReceiveAfter", a), p.assert.isArray("_expiryTime", r), p.assert.isBigNumber("_validFrom", n), p.assert.isBigNumber("_validTo", c), p.assert.isBigNumber("_nonce", u), p.assert.isString("_signature", f), b = (o = this)._strictEncodeArguments("modifyKYCDataSignedMulti(address[],uint256[],uint256[],uint256[],uint256,uint256,uint256,bytes)", [e, t, a, r, n, c, u, f]), m = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return y = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, h, {
                    data: b
                  }), s({
                    from: y
                  }, m))];

                case 2:
                  return void 0 !== (v = i.sent()).from && (v.from = v.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(v)];

                case 3:
                  return _ = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return g = i.sent().gasLimit, A = void 0 === l ? o._defaultEstimateGasFactor : l, w = Math.round(A * _), [2, g < w ? g : w];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u, l, h, b) {
          return void 0 === h && (h = {}), o(this, void 0, void 0, function () {
            var o, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investor", e), p.assert.isArray("_canSendAfter", t), p.assert.isArray("_canReceiveAfter", a), p.assert.isArray("_expiryTime", r), p.assert.isBigNumber("_validFrom", n), p.assert.isBigNumber("_validTo", c), p.assert.isBigNumber("_nonce", u), p.assert.isString("_signature", l), p.assert.doesConformToSchema("callData", h, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== b && p.assert.isBlockParam("defaultBlock", b), m = (o = this)._strictEncodeArguments("modifyKYCDataSignedMulti(address[],uint256[],uint256[],uint256[],uint256,uint256,uint256,bytes)", [e, t, a, r, n, c, u, l]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, h, {
                    data: m
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (y = i.sent()).from = y.from ? y.from.toLowerCase() : y.from, [4, o._web3Wrapper.callAsync(y, b)];

                case 2:
                  return v = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(v), [2, o._lookupAbiEncoder("modifyKYCDataSignedMulti(address[],uint256[],uint256[],uint256[],uint256,uint256,uint256,bytes)").strictDecodeReturnValue(v)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s, o, i) {
          return p.assert.isArray("_investor", e), p.assert.isArray("_canSendAfter", t), p.assert.isArray("_canReceiveAfter", a), p.assert.isArray("_expiryTime", r), p.assert.isBigNumber("_validFrom", n), p.assert.isBigNumber("_validTo", s), p.assert.isBigNumber("_nonce", o), p.assert.isString("_signature", i), this._strictEncodeArguments("modifyKYCDataSignedMulti(address[],uint256[],uint256[],uint256[],uint256,uint256,uint256,bytes)", [e, t, a, r, n, s, o, i]);
        }
      }, u.getAllInvestors = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getAllInvestors()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getAllInvestors()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getAllInvestors()", []);
        }
      }, u.getInvestors = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_fromIndex", e), p.assert.isBigNumber("_toIndex", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("getInvestors(uint256,uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("getInvestors(uint256,uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isBigNumber("_fromIndex", e), p.assert.isBigNumber("_toIndex", t), this._strictEncodeArguments("getInvestors(uint256,uint256)", [e, t]);
        }
      }, u.getAllInvestorFlags = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getAllInvestorFlags()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getAllInvestorFlags()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getAllInvestorFlags()", []);
        }
      }, u.getInvestorFlag = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.isNumberOrBigNumber("_flag", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("getInvestorFlag(address,uint8)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("getInvestorFlag(address,uint8)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_investor", e), p.assert.isNumberOrBigNumber("_flag", t), this._strictEncodeArguments("getInvestorFlag(address,uint8)", [e, t]);
        }
      }, u.getInvestorFlags = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_investor", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getInvestorFlags(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getInvestorFlags(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_investor", e), this._strictEncodeArguments("getInvestorFlags(address)", [e]);
        }
      }, u.getAllKYCData = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getAllKYCData()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getAllKYCData()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getAllKYCData()", []);
        }
      }, u.getKYCData = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getKYCData(address[])", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getKYCData(address[])").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isArray("_investors", e), this._strictEncodeArguments("getKYCData(address[])", [e]);
        }
      }, u.getPermissions = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getPermissions()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getPermissions()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getPermissions()", []);
        }
      }, u.getTokensByPartition = {
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_partition", e), p.assert.isString("_tokenHolder", t), p.assert.isBigNumber("_additionalBalance", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("getTokensByPartition(bytes32,address,uint256)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("getTokensByPartition(bytes32,address,uint256)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isString("_partition", e), p.assert.isString("_tokenHolder", t), p.assert.isBigNumber("_additionalBalance", a), this._strictEncodeArguments("getTokensByPartition(bytes32,address,uint256)", [e, t, a]);
        }
      }, u.getAddressBytes32 = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getAddressBytes32()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getAddressBytes32()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getAddressBytes32()", []);
        }
      }, u._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, l.classUtils.bindAll(u, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), u;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n, s, u) {
      return o(this, void 0, void 0, function () {
        var o, b, m, v, _, g, A, w, T, x, D;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return p.assert.isHexString("bytecode", e), p.assert.doesConformToSchema("txDefaults", n, f.schemas.txDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), o = l.providerUtils.standardizeOrThrow(r), b = d.BaseContract._lookupConstructorAbi(a), D = c(d.BaseContract._formatABIDataItemList(b.inputs, [s, u], d.BaseContract._bigNumberToString), 2), s = D[0], u = D[1], m = new y.utils.Interface(a), v = m.deployFunction, _ = v.encode(e, [s, u]), g = new h.Web3Wrapper(o), [4, d.BaseContract._applyDefaultsToTxDataAsync({
                data: _
              }, n, g.estimateGasAsync.bind(g))];

            case 1:
              return A = i.sent(), [4, g.sendTransactionAsync(A)];

            case 2:
              return w = i.sent(), l.logUtils.log("transactionHash: " + w), [4, g.awaitTransactionSuccessAsync(w)];

            case 3:
              return T = i.sent(), l.logUtils.log("GeneralTransferManager successfully deployed at " + T.contractAddress), (x = new t(T.contractAddress, o, n)).constructorArgs = [s, u], [2, x];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !1,
        inputs: [],
        name: "reclaimETH",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "WHITELIST",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "ADMIN",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "unpause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "paused",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "INVESTORFLAGS",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "UNLOCKED",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "polyToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "pause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenContract",
          type: "address"
        }],
        name: "reclaimERC20",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "OPERATOR",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "address"
        }, {
          name: "index_1",
          type: "uint256"
        }],
        name: "nonceMap",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "LOCKED",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "issuanceAddress",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "securityToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "INVESTORSKEY",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "uint8"
        }],
        name: "transferRequirements",
        outputs: [{
          name: "fromValidKYC",
          type: "bool"
        }, {
          name: "toValidKYC",
          type: "bool"
        }, {
          name: "fromRestricted",
          type: "bool"
        }, {
          name: "toRestricted",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "factory",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "WHITELISTMODULE",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "defaults",
        outputs: [{
          name: "canSendAfter",
          type: "uint64"
        }, {
          name: "canReceiveAfter",
          type: "uint64"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDataStore",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        inputs: [{
          name: "_securityToken",
          type: "address"
        }, {
          name: "_polyToken",
          type: "address"
        }],
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "constructor"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_issuanceAddress",
          type: "address",
          indexed: !1
        }],
        name: "ChangeIssuanceAddress",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_defaultCanSendAfter",
          type: "uint64",
          indexed: !1
        }, {
          name: "_defaultCanReceiveAfter",
          type: "uint64",
          indexed: !1
        }],
        name: "ChangeDefaults",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_investor",
          type: "address",
          indexed: !0
        }, {
          name: "_addedBy",
          type: "address",
          indexed: !0
        }, {
          name: "_canSendAfter",
          type: "uint64",
          indexed: !1
        }, {
          name: "_canReceiveAfter",
          type: "uint64",
          indexed: !1
        }, {
          name: "_expiryTime",
          type: "uint64",
          indexed: !1
        }],
        name: "ModifyKYCData",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_investor",
          type: "address",
          indexed: !0
        }, {
          name: "_flag",
          type: "uint8",
          indexed: !0
        }, {
          name: "_value",
          type: "bool",
          indexed: !1
        }],
        name: "ModifyInvestorFlag",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_transferType",
          type: "uint8",
          indexed: !0
        }, {
          name: "_fromValidKYC",
          type: "bool",
          indexed: !1
        }, {
          name: "_toValidKYC",
          type: "bool",
          indexed: !1
        }, {
          name: "_fromRestricted",
          type: "bool",
          indexed: !1
        }, {
          name: "_toRestricted",
          type: "bool",
          indexed: !1
        }],
        name: "ModifyTransferRequirements",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Pause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Unpause",
        outputs: [],
        type: "event"
      }, {
        constant: !0,
        inputs: [],
        name: "getInitFunction",
        outputs: [{
          name: "",
          type: "bytes4"
        }],
        payable: !1,
        stateMutability: "pure",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_defaultCanSendAfter",
          type: "uint64"
        }, {
          name: "_defaultCanReceiveAfter",
          type: "uint64"
        }],
        name: "changeDefaults",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_issuanceAddress",
          type: "address"
        }],
        name: "changeIssuanceAddress",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "_to",
          type: "address"
        }, {
          name: "index_2",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }],
        name: "executeTransfer",
        outputs: [{
          name: "",
          type: "uint8"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "_to",
          type: "address"
        }, {
          name: "index_2",
          type: "uint256"
        }, {
          name: "_data",
          type: "bytes"
        }],
        name: "verifyTransfer",
        outputs: [{
          name: "",
          type: "uint8"
        }, {
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_transferType",
          type: "uint8"
        }, {
          name: "_fromValidKYC",
          type: "bool"
        }, {
          name: "_toValidKYC",
          type: "bool"
        }, {
          name: "_fromRestricted",
          type: "bool"
        }, {
          name: "_toRestricted",
          type: "bool"
        }],
        name: "modifyTransferRequirements",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_transferTypes",
          type: "uint8[]"
        }, {
          name: "_fromValidKYC",
          type: "bool[]"
        }, {
          name: "_toValidKYC",
          type: "bool[]"
        }, {
          name: "_fromRestricted",
          type: "bool[]"
        }, {
          name: "_toRestricted",
          type: "bool[]"
        }],
        name: "modifyTransferRequirementsMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_investor",
          type: "address"
        }, {
          name: "_canSendAfter",
          type: "uint64"
        }, {
          name: "_canReceiveAfter",
          type: "uint64"
        }, {
          name: "_expiryTime",
          type: "uint64"
        }],
        name: "modifyKYCData",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_investors",
          type: "address[]"
        }, {
          name: "_canSendAfter",
          type: "uint64[]"
        }, {
          name: "_canReceiveAfter",
          type: "uint64[]"
        }, {
          name: "_expiryTime",
          type: "uint64[]"
        }],
        name: "modifyKYCDataMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_investor",
          type: "address"
        }, {
          name: "_flag",
          type: "uint8"
        }, {
          name: "_value",
          type: "bool"
        }],
        name: "modifyInvestorFlag",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_investors",
          type: "address[]"
        }, {
          name: "_flag",
          type: "uint8[]"
        }, {
          name: "_value",
          type: "bool[]"
        }],
        name: "modifyInvestorFlagMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_investor",
          type: "address"
        }, {
          name: "_canSendAfter",
          type: "uint256"
        }, {
          name: "_canReceiveAfter",
          type: "uint256"
        }, {
          name: "_expiryTime",
          type: "uint256"
        }, {
          name: "_validFrom",
          type: "uint256"
        }, {
          name: "_validTo",
          type: "uint256"
        }, {
          name: "_nonce",
          type: "uint256"
        }, {
          name: "_signature",
          type: "bytes"
        }],
        name: "modifyKYCDataSigned",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_investor",
          type: "address[]"
        }, {
          name: "_canSendAfter",
          type: "uint256[]"
        }, {
          name: "_canReceiveAfter",
          type: "uint256[]"
        }, {
          name: "_expiryTime",
          type: "uint256[]"
        }, {
          name: "_validFrom",
          type: "uint256"
        }, {
          name: "_validTo",
          type: "uint256"
        }, {
          name: "_nonce",
          type: "uint256"
        }, {
          name: "_signature",
          type: "bytes"
        }],
        name: "modifyKYCDataSignedMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getAllInvestors",
        outputs: [{
          name: "investors",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_fromIndex",
          type: "uint256"
        }, {
          name: "_toIndex",
          type: "uint256"
        }],
        name: "getInvestors",
        outputs: [{
          name: "investors",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getAllInvestorFlags",
        outputs: [{
          name: "investors",
          type: "address[]"
        }, {
          name: "flags",
          type: "uint256[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_investor",
          type: "address"
        }, {
          name: "_flag",
          type: "uint8"
        }],
        name: "getInvestorFlag",
        outputs: [{
          name: "value",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_investor",
          type: "address"
        }],
        name: "getInvestorFlags",
        outputs: [{
          name: "flags",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getAllKYCData",
        outputs: [{
          name: "investors",
          type: "address[]"
        }, {
          name: "canSendAfters",
          type: "uint256[]"
        }, {
          name: "canReceiveAfters",
          type: "uint256[]"
        }, {
          name: "expiryTimes",
          type: "uint256[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_investors",
          type: "address[]"
        }],
        name: "getKYCData",
        outputs: [{
          name: "",
          type: "uint256[]"
        }, {
          name: "",
          type: "uint256[]"
        }, {
          name: "",
          type: "uint256[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getPermissions",
        outputs: [{
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_partition",
          type: "bytes32"
        }, {
          name: "_tokenHolder",
          type: "address"
        }, {
          name: "_additionalBalance",
          type: "uint256"
        }],
        name: "getTokensByPartition",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getAddressBytes32",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(d.BaseContract);

  t.GeneralTransferManagerContract_3_1_0 = v, t.isGeneralTransferManagerContract_3_1_0 = function (e) {
    return m.isEqual(v.ABI(), e.abi);
  };
},
/*!***********************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.1.0/u_s_d_tiered_s_t_o.js ***!
  \***********************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r109,
      n = this && this.__extends || (_r109 = function r(e, t) {
    return (_r109 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r109(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      c = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || 0 < t--) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u,
      d = a(
  /*! @0x/base-contract */
  12),
      f = a(
  /*! @0x/json-schemas */
  2),
      l = a(
  /*! @0x/utils */
  8),
      h = a(
  /*! @0x/web3-wrapper */
  11),
      p = a(
  /*! @0x/assert */
  10),
      b = a(
  /*! ../../PolyResponse */
  14),
      m = a(
  /*! lodash */
  0),
      y = a(
  /*! ethers */
  13);
  (u = t.USDTieredSTOEvents_3_1_0 || (t.USDTieredSTOEvents_3_1_0 = {})).SetAllowBeneficialInvestments = "SetAllowBeneficialInvestments", u.SetNonAccreditedLimit = "SetNonAccreditedLimit", u.TokenPurchase = "TokenPurchase", u.FundsReceived = "FundsReceived", u.ReserveTokenMint = "ReserveTokenMint", u.ReserveTokenTransfer = "ReserveTokenTransfer", u.SetAddresses = "SetAddresses", u.SetLimits = "SetLimits", u.SetTimes = "SetTimes", u.SetTiers = "SetTiers", u.SetTreasuryWallet = "SetTreasuryWallet", u.SetOracles = "SetOracles", u.UsageFeeDeducted = "UsageFeeDeducted", u.Pause = "Pause", u.Unpause = "Unpause", u.SetFundRaiseTypes = "SetFundRaiseTypes", u.RevokePreMintFlag = "RevokePreMintFlag", u.AllowPreMintFlag = "AllowPreMintFlag";

  var v = function (e) {
    function t(a, r, n, c) {
      var u = e.call(this, "USDTieredSTO", t.ABI(), a, r, n) || this;
      return u.tiers = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("tiers(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("tiers(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("index_0", e), this._strictEncodeArguments("tiers(uint256)", [e]);
        }
      }, u.reclaimETH = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.reclaimETH.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("reclaimETH()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("reclaimETH()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("reclaimETH()", []);
        }
      }, u.denominatedCurrency = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("denominatedCurrency()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("denominatedCurrency()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("denominatedCurrency()", []);
        }
      }, u.ADMIN = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("ADMIN()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("ADMIN()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("ADMIN()", []);
        }
      }, u.getTreasuryWallet = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getTreasuryWallet()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getTreasuryWallet()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getTreasuryWallet()", []);
        }
      }, u.allowBeneficialInvestments = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("allowBeneficialInvestments()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("allowBeneficialInvestments()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("allowBeneficialInvestments()", []);
        }
      }, u.endTime = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("endTime()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("endTime()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("endTime()", []);
        }
      }, u.unpause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.unpause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("unpause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("unpause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("unpause()", []);
        }
      }, u.nonAccreditedLimitUSD = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("nonAccreditedLimitUSD()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("nonAccreditedLimitUSD()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("nonAccreditedLimitUSD()", []);
        }
      }, u.wallet = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("wallet()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("wallet()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("wallet()", []);
        }
      }, u.paused = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("paused()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("paused()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("paused()", []);
        }
      }, u.totalTokensSold = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("totalTokensSold()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("totalTokensSold()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("totalTokensSold()", []);
        }
      }, u.finalAmountReturned = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("finalAmountReturned()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("finalAmountReturned()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("finalAmountReturned()", []);
        }
      }, u.polyToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("polyToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("polyToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("polyToken()", []);
        }
      }, u.stableCoinsRaised = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("stableCoinsRaised(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("stableCoinsRaised(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("index_0", e), this._strictEncodeArguments("stableCoinsRaised(address)", [e]);
        }
      }, u.startTime = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("startTime()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("startTime()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("startTime()", []);
        }
      }, u.pause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.pause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pause()", []);
        }
      }, u.investorInvested = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("index_0", e), p.assert.isNumberOrBigNumber("index_1", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("investorInvested(address,uint8)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("investorInvested(address,uint8)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("index_0", e), p.assert.isNumberOrBigNumber("index_1", t), this._strictEncodeArguments("investorInvested(address,uint8)", [e, t]);
        }
      }, u.reclaimERC20 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.reclaimERC20.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("reclaimERC20(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_tokenContract", e), this._strictEncodeArguments("reclaimERC20(address)", [e]);
        }
      }, u.isFinalized = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("isFinalized()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("isFinalized()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("isFinalized()", []);
        }
      }, u.OPERATOR = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("OPERATOR()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("OPERATOR()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("OPERATOR()", []);
        }
      }, u.getRaised = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_fundRaiseType", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getRaised(uint8)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getRaised(uint8)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isNumberOrBigNumber("_fundRaiseType", e), this._strictEncodeArguments("getRaised(uint8)", [e]);
        }
      }, u.pausedTime = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pausedTime()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pausedTime()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pausedTime()", []);
        }
      }, u.securityToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("securityToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("securityToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("securityToken()", []);
        }
      }, u.factory = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("factory()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("factory()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("factory()", []);
        }
      }, u.fundsRaised = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("fundsRaised(uint8)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("fundsRaised(uint8)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isNumberOrBigNumber("index_0", e), this._strictEncodeArguments("fundsRaised(uint8)", [e]);
        }
      }, u.investorInvestedUSD = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("investorInvestedUSD(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("investorInvestedUSD(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("index_0", e), this._strictEncodeArguments("investorInvestedUSD(address)", [e]);
        }
      }, u.fundRaiseTypes = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("fundRaiseTypes(uint8)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("fundRaiseTypes(uint8)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isNumberOrBigNumber("index_0", e), this._strictEncodeArguments("fundRaiseTypes(uint8)", [e]);
        }
      }, u.currentTier = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("currentTier()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("currentTier()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("currentTier()", []);
        }
      }, u.investorCount = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("investorCount()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("investorCount()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("investorCount()", []);
        }
      }, u.nonAccreditedLimitUSDOverride = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("nonAccreditedLimitUSDOverride(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("nonAccreditedLimitUSDOverride(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("index_0", e), this._strictEncodeArguments("nonAccreditedLimitUSDOverride(address)", [e]);
        }
      }, u.minimumInvestmentUSD = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("minimumInvestmentUSD()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("minimumInvestmentUSD()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("minimumInvestmentUSD()", []);
        }
      }, u.preMintAllowed = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("preMintAllowed()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("preMintAllowed()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("preMintAllowed()", []);
        }
      }, u.getDataStore = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDataStore()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDataStore()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDataStore()", []);
        }
      }, u.fundsRaisedUSD = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("fundsRaisedUSD()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("fundsRaisedUSD()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("fundsRaisedUSD()", []);
        }
      }, u.configure = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u, f, l, h, m, y, v, _, g, A) {
          return o(this, void 0, void 0, function () {
            var o, w, T, x, D, C, S;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), p.assert.isArray("_ratePerTier", a), p.assert.isArray("_ratePerTierDiscountPoly", r), p.assert.isArray("_tokensPerTierTotal", n), p.assert.isArray("_tokensPerTierDiscountPoly", c), p.assert.isBigNumber("_nonAccreditedLimitUSD", u), p.assert.isBigNumber("_minimumInvestmentUSD", f), p.assert.isArray("_fundRaiseTypes", l), p.assert.isString("_wallet", h), p.assert.isString("_treasuryWallet", m), p.assert.isArray("_stableTokens", y), p.assert.isArray("_customOracleAddresses", v), p.assert.isString("_denominatedCurrency", _), w = (o = this)._strictEncodeArguments("configure(uint256,uint256,uint256[],uint256[],uint256[],uint256[],uint256,uint256,uint8[],address,address,address[],address[],bytes32)", [e, t, a, r, n, c, u, f, l, h, m, y, v, _]), T = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return x = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, g, {
                    data: w
                  }), s({
                    from: x
                  }, T), o.configure.estimateGasAsync.bind(o, e, t, a, r, n, c, u, f, l, h, m, y, v, _, A))];

                case 2:
                  return void 0 !== (D = i.sent()).from && (D.from = D.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(D)];

                case 3:
                  return C = i.sent(), S = o._web3Wrapper.awaitTransactionSuccessAsync(C), [2, new b.PolyResponse(C, S)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u, f, l, h, b, m, y, v, _, g) {
          return o(this, void 0, void 0, function () {
            var o, A, w, T, x, D, C, S, E;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), p.assert.isArray("_ratePerTier", a), p.assert.isArray("_ratePerTierDiscountPoly", r), p.assert.isArray("_tokensPerTierTotal", n), p.assert.isArray("_tokensPerTierDiscountPoly", c), p.assert.isBigNumber("_nonAccreditedLimitUSD", u), p.assert.isBigNumber("_minimumInvestmentUSD", f), p.assert.isArray("_fundRaiseTypes", l), p.assert.isString("_wallet", h), p.assert.isString("_treasuryWallet", b), p.assert.isArray("_stableTokens", m), p.assert.isArray("_customOracleAddresses", y), p.assert.isString("_denominatedCurrency", v), A = (o = this)._strictEncodeArguments("configure(uint256,uint256,uint256[],uint256[],uint256[],uint256[],uint256,uint256,uint8[],address,address,address[],address[],bytes32)", [e, t, a, r, n, c, u, f, l, h, b, m, y, v]), w = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return T = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, g, {
                    data: A
                  }), s({
                    from: T
                  }, w))];

                case 2:
                  return void 0 !== (x = i.sent()).from && (x.from = x.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(x)];

                case 3:
                  return D = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return C = i.sent().gasLimit, S = void 0 === _ ? o._defaultEstimateGasFactor : _, E = Math.round(S * D), [2, C < E ? C : E];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u, l, h, b, m, y, v, _, g, A) {
          return void 0 === g && (g = {}), o(this, void 0, void 0, function () {
            var o, w, T, x;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), p.assert.isArray("_ratePerTier", a), p.assert.isArray("_ratePerTierDiscountPoly", r), p.assert.isArray("_tokensPerTierTotal", n), p.assert.isArray("_tokensPerTierDiscountPoly", c), p.assert.isBigNumber("_nonAccreditedLimitUSD", u), p.assert.isBigNumber("_minimumInvestmentUSD", l), p.assert.isArray("_fundRaiseTypes", h), p.assert.isString("_wallet", b), p.assert.isString("_treasuryWallet", m), p.assert.isArray("_stableTokens", y), p.assert.isArray("_customOracleAddresses", v), p.assert.isString("_denominatedCurrency", _), p.assert.doesConformToSchema("callData", g, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== A && p.assert.isBlockParam("defaultBlock", A), w = (o = this)._strictEncodeArguments("configure(uint256,uint256,uint256[],uint256[],uint256[],uint256[],uint256,uint256,uint8[],address,address,address[],address[],bytes32)", [e, t, a, r, n, c, u, l, h, b, m, y, v, _]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, g, {
                    data: w
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (T = i.sent()).from = T.from ? T.from.toLowerCase() : T.from, [4, o._web3Wrapper.callAsync(T, A)];

                case 2:
                  return x = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(x), [2, o._lookupAbiEncoder("configure(uint256,uint256,uint256[],uint256[],uint256[],uint256[],uint256,uint256,uint8[],address,address,address[],address[],bytes32)").strictDecodeReturnValue(x)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s, o, i, c, u, d, f, l, h) {
          return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), p.assert.isArray("_ratePerTier", a), p.assert.isArray("_ratePerTierDiscountPoly", r), p.assert.isArray("_tokensPerTierTotal", n), p.assert.isArray("_tokensPerTierDiscountPoly", s), p.assert.isBigNumber("_nonAccreditedLimitUSD", o), p.assert.isBigNumber("_minimumInvestmentUSD", i), p.assert.isArray("_fundRaiseTypes", c), p.assert.isString("_wallet", u), p.assert.isString("_treasuryWallet", d), p.assert.isArray("_stableTokens", f), p.assert.isArray("_customOracleAddresses", l), p.assert.isString("_denominatedCurrency", h), this._strictEncodeArguments("configure(uint256,uint256,uint256[],uint256[],uint256[],uint256[],uint256,uint256,uint8[],address,address,address[],address[],bytes32)", [e, t, a, r, n, s, o, i, c, u, d, f, l, h]);
        }
      }, u.allowPreMinting = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("allowPreMinting()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.allowPreMinting.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("allowPreMinting()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("allowPreMinting()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("allowPreMinting()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("allowPreMinting()", []);
        }
      }, u.revokePreMintFlag = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("revokePreMintFlag()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.revokePreMintFlag.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("revokePreMintFlag()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("revokePreMintFlag()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("revokePreMintFlag()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("revokePreMintFlag()", []);
        }
      }, u.modifyFunding = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_fundRaiseTypes", e), n = (r = this)._strictEncodeArguments("modifyFunding(uint8[])", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.modifyFunding.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_fundRaiseTypes", e), n = (r = this)._strictEncodeArguments("modifyFunding(uint8[])", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_fundRaiseTypes", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("modifyFunding(uint8[])", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("modifyFunding(uint8[])").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isArray("_fundRaiseTypes", e), this._strictEncodeArguments("modifyFunding(uint8[])", [e]);
        }
      }, u.modifyLimits = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_nonAccreditedLimitUSD", e), p.assert.isBigNumber("_minimumInvestmentUSD", t), o = (n = this)._strictEncodeArguments("modifyLimits(uint256,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.modifyLimits.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_nonAccreditedLimitUSD", e), p.assert.isBigNumber("_minimumInvestmentUSD", t), o = (n = this)._strictEncodeArguments("modifyLimits(uint256,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_nonAccreditedLimitUSD", e), p.assert.isBigNumber("_minimumInvestmentUSD", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("modifyLimits(uint256,uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("modifyLimits(uint256,uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isBigNumber("_nonAccreditedLimitUSD", e), p.assert.isBigNumber("_minimumInvestmentUSD", t), this._strictEncodeArguments("modifyLimits(uint256,uint256)", [e, t]);
        }
      }, u.modifyTiers = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_ratePerTier", e), p.assert.isArray("_ratePerTierDiscountPoly", t), p.assert.isArray("_tokensPerTierTotal", a), p.assert.isArray("_tokensPerTierDiscountPoly", r), u = (o = this)._strictEncodeArguments("modifyTiers(uint256[],uint256[],uint256[],uint256[])", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.modifyTiers.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_ratePerTier", e), p.assert.isArray("_ratePerTierDiscountPoly", t), p.assert.isArray("_tokensPerTierTotal", a), p.assert.isArray("_tokensPerTierDiscountPoly", r), u = (o = this)._strictEncodeArguments("modifyTiers(uint256[],uint256[],uint256[],uint256[])", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_ratePerTier", e), p.assert.isArray("_ratePerTierDiscountPoly", t), p.assert.isArray("_tokensPerTierTotal", a), p.assert.isArray("_tokensPerTierDiscountPoly", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("modifyTiers(uint256[],uint256[],uint256[],uint256[])", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("modifyTiers(uint256[],uint256[],uint256[],uint256[])").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isArray("_ratePerTier", e), p.assert.isArray("_ratePerTierDiscountPoly", t), p.assert.isArray("_tokensPerTierTotal", a), p.assert.isArray("_tokensPerTierDiscountPoly", r), this._strictEncodeArguments("modifyTiers(uint256[],uint256[],uint256[],uint256[])", [e, t, a, r]);
        }
      }, u.modifyTimes = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), o = (n = this)._strictEncodeArguments("modifyTimes(uint256,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.modifyTimes.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), o = (n = this)._strictEncodeArguments("modifyTimes(uint256,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("modifyTimes(uint256,uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("modifyTimes(uint256,uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isBigNumber("_startTime", e), p.assert.isBigNumber("_endTime", t), this._strictEncodeArguments("modifyTimes(uint256,uint256)", [e, t]);
        }
      }, u.modifyAddresses = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_wallet", e), p.assert.isString("_treasuryWallet", t), p.assert.isArray("_stableTokens", a), c = (o = this)._strictEncodeArguments("modifyAddresses(address,address,address[])", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.modifyAddresses.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_wallet", e), p.assert.isString("_treasuryWallet", t), p.assert.isArray("_stableTokens", a), c = (o = this)._strictEncodeArguments("modifyAddresses(address,address,address[])", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_wallet", e), p.assert.isString("_treasuryWallet", t), p.assert.isArray("_stableTokens", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("modifyAddresses(address,address,address[])", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("modifyAddresses(address,address,address[])").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isString("_wallet", e), p.assert.isString("_treasuryWallet", t), p.assert.isArray("_stableTokens", a), this._strictEncodeArguments("modifyAddresses(address,address,address[])", [e, t, a]);
        }
      }, u.modifyOracles = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_customOracleAddresses", e), p.assert.isString("_denominatedCurrencySymbol", t), o = (n = this)._strictEncodeArguments("modifyOracles(address[],bytes32)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.modifyOracles.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_customOracleAddresses", e), p.assert.isString("_denominatedCurrencySymbol", t), o = (n = this)._strictEncodeArguments("modifyOracles(address[],bytes32)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_customOracleAddresses", e), p.assert.isString("_denominatedCurrencySymbol", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("modifyOracles(address[],bytes32)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("modifyOracles(address[],bytes32)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isArray("_customOracleAddresses", e), p.assert.isString("_denominatedCurrencySymbol", t), this._strictEncodeArguments("modifyOracles(address[],bytes32)", [e, t]);
        }
      }, u.finalize = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("finalize()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.finalize.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("finalize()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("finalize()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("finalize()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("finalize()", []);
        }
      }, u.changeNonAccreditedLimit = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isArray("_nonAccreditedLimit", t), o = (n = this)._strictEncodeArguments("changeNonAccreditedLimit(address[],uint256[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.changeNonAccreditedLimit.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isArray("_nonAccreditedLimit", t), o = (n = this)._strictEncodeArguments("changeNonAccreditedLimit(address[],uint256[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_investors", e), p.assert.isArray("_nonAccreditedLimit", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("changeNonAccreditedLimit(address[],uint256[])", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("changeNonAccreditedLimit(address[],uint256[])").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isArray("_investors", e), p.assert.isArray("_nonAccreditedLimit", t), this._strictEncodeArguments("changeNonAccreditedLimit(address[],uint256[])", [e, t]);
        }
      }, u.getAccreditedData = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getAccreditedData()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getAccreditedData()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getAccreditedData()", []);
        }
      }, u.changeAllowBeneficialInvestments = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBoolean("_allowBeneficialInvestments", e), n = (r = this)._strictEncodeArguments("changeAllowBeneficialInvestments(bool)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeAllowBeneficialInvestments.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBoolean("_allowBeneficialInvestments", e), n = (r = this)._strictEncodeArguments("changeAllowBeneficialInvestments(bool)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBoolean("_allowBeneficialInvestments", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeAllowBeneficialInvestments(bool)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeAllowBeneficialInvestments(bool)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBoolean("_allowBeneficialInvestments", e), this._strictEncodeArguments("changeAllowBeneficialInvestments(bool)", [e]);
        }
      }, u.buyWithETH = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), n = (r = this)._strictEncodeArguments("buyWithETH(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.buyWithETH.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), n = (r = this)._strictEncodeArguments("buyWithETH(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("buyWithETH(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("buyWithETH(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_beneficiary", e), this._strictEncodeArguments("buyWithETH(address)", [e]);
        }
      }, u.buyWithPOLY = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_investedPOLY", t), o = (n = this)._strictEncodeArguments("buyWithPOLY(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.buyWithPOLY.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_investedPOLY", t), o = (n = this)._strictEncodeArguments("buyWithPOLY(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_investedPOLY", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("buyWithPOLY(address,uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("buyWithPOLY(address,uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_investedPOLY", t), this._strictEncodeArguments("buyWithPOLY(address,uint256)", [e, t]);
        }
      }, u.buyWithUSD = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_investedSC", t), p.assert.isString("_usdToken", a), c = (o = this)._strictEncodeArguments("buyWithUSD(address,uint256,address)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.buyWithUSD.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_investedSC", t), p.assert.isString("_usdToken", a), c = (o = this)._strictEncodeArguments("buyWithUSD(address,uint256,address)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_investedSC", t), p.assert.isString("_usdToken", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("buyWithUSD(address,uint256,address)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("buyWithUSD(address,uint256,address)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_investedSC", t), p.assert.isString("_usdToken", a), this._strictEncodeArguments("buyWithUSD(address,uint256,address)", [e, t, a]);
        }
      }, u.buyWithETHRateLimited = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_minTokens", t), o = (n = this)._strictEncodeArguments("buyWithETHRateLimited(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.buyWithETHRateLimited.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_minTokens", t), o = (n = this)._strictEncodeArguments("buyWithETHRateLimited(address,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_minTokens", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("buyWithETHRateLimited(address,uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("buyWithETHRateLimited(address,uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_minTokens", t), this._strictEncodeArguments("buyWithETHRateLimited(address,uint256)", [e, t]);
        }
      }, u.buyWithPOLYRateLimited = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_investedPOLY", t), p.assert.isBigNumber("_minTokens", a), c = (o = this)._strictEncodeArguments("buyWithPOLYRateLimited(address,uint256,uint256)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.buyWithPOLYRateLimited.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_investedPOLY", t), p.assert.isBigNumber("_minTokens", a), c = (o = this)._strictEncodeArguments("buyWithPOLYRateLimited(address,uint256,uint256)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_investedPOLY", t), p.assert.isBigNumber("_minTokens", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("buyWithPOLYRateLimited(address,uint256,uint256)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("buyWithPOLYRateLimited(address,uint256,uint256)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_investedPOLY", t), p.assert.isBigNumber("_minTokens", a), this._strictEncodeArguments("buyWithPOLYRateLimited(address,uint256,uint256)", [e, t, a]);
        }
      }, u.buyWithUSDRateLimited = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_investedSC", t), p.assert.isBigNumber("_minTokens", a), p.assert.isString("_usdToken", r), u = (o = this)._strictEncodeArguments("buyWithUSDRateLimited(address,uint256,uint256,address)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.buyWithUSDRateLimited.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_investedSC", t), p.assert.isBigNumber("_minTokens", a), p.assert.isString("_usdToken", r), u = (o = this)._strictEncodeArguments("buyWithUSDRateLimited(address,uint256,uint256,address)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_investedSC", t), p.assert.isBigNumber("_minTokens", a), p.assert.isString("_usdToken", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("buyWithUSDRateLimited(address,uint256,uint256,address)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("buyWithUSDRateLimited(address,uint256,uint256,address)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isString("_beneficiary", e), p.assert.isBigNumber("_investedSC", t), p.assert.isBigNumber("_minTokens", a), p.assert.isString("_usdToken", r), this._strictEncodeArguments("buyWithUSDRateLimited(address,uint256,uint256,address)", [e, t, a, r]);
        }
      }, u.isOpen = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("isOpen()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("isOpen()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("isOpen()", []);
        }
      }, u.capReached = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("capReached()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("capReached()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("capReached()", []);
        }
      }, u.getRate = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_fundRaiseType", e), n = (r = this)._strictEncodeArguments("getRate(uint8)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.getRate.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_fundRaiseType", e), n = (r = this)._strictEncodeArguments("getRate(uint8)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_fundRaiseType", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getRate(uint8)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getRate(uint8)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isNumberOrBigNumber("_fundRaiseType", e), this._strictEncodeArguments("getRate(uint8)", [e]);
        }
      }, u.getCustomOracleAddress = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_fundRaiseType", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getCustomOracleAddress(uint8)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getCustomOracleAddress(uint8)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isNumberOrBigNumber("_fundRaiseType", e), this._strictEncodeArguments("getCustomOracleAddress(uint8)", [e]);
        }
      }, u.convertToUSD = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_fundRaiseType", e), p.assert.isBigNumber("_amount", t), o = (n = this)._strictEncodeArguments("convertToUSD(uint8,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.convertToUSD.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_fundRaiseType", e), p.assert.isBigNumber("_amount", t), o = (n = this)._strictEncodeArguments("convertToUSD(uint8,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_fundRaiseType", e), p.assert.isBigNumber("_amount", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("convertToUSD(uint8,uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("convertToUSD(uint8,uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isNumberOrBigNumber("_fundRaiseType", e), p.assert.isBigNumber("_amount", t), this._strictEncodeArguments("convertToUSD(uint8,uint256)", [e, t]);
        }
      }, u.convertFromUSD = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_fundRaiseType", e), p.assert.isBigNumber("_amount", t), o = (n = this)._strictEncodeArguments("convertFromUSD(uint8,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.convertFromUSD.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_fundRaiseType", e), p.assert.isBigNumber("_amount", t), o = (n = this)._strictEncodeArguments("convertFromUSD(uint8,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_fundRaiseType", e), p.assert.isBigNumber("_amount", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("convertFromUSD(uint8,uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("convertFromUSD(uint8,uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isNumberOrBigNumber("_fundRaiseType", e), p.assert.isBigNumber("_amount", t), this._strictEncodeArguments("convertFromUSD(uint8,uint256)", [e, t]);
        }
      }, u.getTokensSold = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getTokensSold()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getTokensSold()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getTokensSold()", []);
        }
      }, u.getTokensMinted = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getTokensMinted()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getTokensMinted()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getTokensMinted()", []);
        }
      }, u.getTokensSoldFor = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isNumberOrBigNumber("_fundRaiseType", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getTokensSoldFor(uint8)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getTokensSoldFor(uint8)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isNumberOrBigNumber("_fundRaiseType", e), this._strictEncodeArguments("getTokensSoldFor(uint8)", [e]);
        }
      }, u.getTokensSoldByTier = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_tier", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getTokensSoldByTier(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getTokensSoldByTier(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_tier", e), this._strictEncodeArguments("getTokensSoldByTier(uint256)", [e]);
        }
      }, u.getTotalTokensSoldByTier = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_tier", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getTotalTokensSoldByTier(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getTotalTokensSoldByTier(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_tier", e), this._strictEncodeArguments("getTotalTokensSoldByTier(uint256)", [e]);
        }
      }, u.getNumberOfTiers = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getNumberOfTiers()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getNumberOfTiers()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getNumberOfTiers()", []);
        }
      }, u.getUsdTokens = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getUsdTokens()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getUsdTokens()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getUsdTokens()", []);
        }
      }, u.getPermissions = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getPermissions()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getPermissions()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getPermissions()", []);
        }
      }, u.getSTODetails = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getSTODetails()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getSTODetails()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getSTODetails()", []);
        }
      }, u.getInitFunction = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getInitFunction()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getInitFunction()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getInitFunction()", []);
        }
      }, u._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, l.classUtils.bindAll(u, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), u;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n, s, u) {
      return o(this, void 0, void 0, function () {
        var o, b, m, v, _, g, A, w, T, x, D;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return p.assert.isHexString("bytecode", e), p.assert.doesConformToSchema("txDefaults", n, f.schemas.txDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), o = l.providerUtils.standardizeOrThrow(r), b = d.BaseContract._lookupConstructorAbi(a), D = c(d.BaseContract._formatABIDataItemList(b.inputs, [s, u], d.BaseContract._bigNumberToString), 2), s = D[0], u = D[1], m = new y.utils.Interface(a), v = m.deployFunction, _ = v.encode(e, [s, u]), g = new h.Web3Wrapper(o), [4, d.BaseContract._applyDefaultsToTxDataAsync({
                data: _
              }, n, g.estimateGasAsync.bind(g))];

            case 1:
              return A = i.sent(), [4, g.sendTransactionAsync(A)];

            case 2:
              return w = i.sent(), l.logUtils.log("transactionHash: " + w), [4, g.awaitTransactionSuccessAsync(w)];

            case 3:
              return T = i.sent(), l.logUtils.log("USDTieredSTO successfully deployed at " + T.contractAddress), (x = new t(T.contractAddress, o, n)).constructorArgs = [s, u], [2, x];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "uint256"
        }],
        name: "tiers",
        outputs: [{
          name: "rate",
          type: "uint256"
        }, {
          name: "rateDiscountPoly",
          type: "uint256"
        }, {
          name: "tokenTotal",
          type: "uint256"
        }, {
          name: "tokensDiscountPoly",
          type: "uint256"
        }, {
          name: "totalTokensSoldInTier",
          type: "uint256"
        }, {
          name: "soldDiscountPoly",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "reclaimETH",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "denominatedCurrency",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "ADMIN",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getTreasuryWallet",
        outputs: [{
          name: "wallet",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "allowBeneficialInvestments",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "endTime",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "unpause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "nonAccreditedLimitUSD",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "wallet",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "paused",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "totalTokensSold",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "finalAmountReturned",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "polyToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "address"
        }],
        name: "stableCoinsRaised",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "startTime",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "pause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "address"
        }, {
          name: "index_1",
          type: "uint8"
        }],
        name: "investorInvested",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenContract",
          type: "address"
        }],
        name: "reclaimERC20",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "isFinalized",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "OPERATOR",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_fundRaiseType",
          type: "uint8"
        }],
        name: "getRaised",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "pausedTime",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "securityToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "factory",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "uint8"
        }],
        name: "fundsRaised",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "address"
        }],
        name: "investorInvestedUSD",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "uint8"
        }],
        name: "fundRaiseTypes",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "currentTier",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "investorCount",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "address"
        }],
        name: "nonAccreditedLimitUSDOverride",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "minimumInvestmentUSD",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "preMintAllowed",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDataStore",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "fundsRaisedUSD",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        inputs: [{
          name: "_securityToken",
          type: "address"
        }, {
          name: "_polyAddress",
          type: "address"
        }],
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "constructor"
      }, {
        inputs: [],
        outputs: [],
        payable: !0,
        stateMutability: "payable",
        type: "fallback"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_allowed",
          type: "bool",
          indexed: !1
        }],
        name: "SetAllowBeneficialInvestments",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_investor",
          type: "address",
          indexed: !1
        }, {
          name: "_limit",
          type: "uint256",
          indexed: !1
        }],
        name: "SetNonAccreditedLimit",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_purchaser",
          type: "address",
          indexed: !0
        }, {
          name: "_beneficiary",
          type: "address",
          indexed: !0
        }, {
          name: "_tokens",
          type: "uint256",
          indexed: !1
        }, {
          name: "_usdAmount",
          type: "uint256",
          indexed: !1
        }, {
          name: "_tierPrice",
          type: "uint256",
          indexed: !1
        }, {
          name: "_tier",
          type: "uint256",
          indexed: !1
        }],
        name: "TokenPurchase",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_purchaser",
          type: "address",
          indexed: !0
        }, {
          name: "_beneficiary",
          type: "address",
          indexed: !0
        }, {
          name: "_usdAmount",
          type: "uint256",
          indexed: !1
        }, {
          name: "_fundRaiseType",
          type: "uint8",
          indexed: !1
        }, {
          name: "_receivedValue",
          type: "uint256",
          indexed: !1
        }, {
          name: "_spentValue",
          type: "uint256",
          indexed: !1
        }, {
          name: "_rate",
          type: "uint256",
          indexed: !1
        }],
        name: "FundsReceived",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_owner",
          type: "address",
          indexed: !0
        }, {
          name: "_wallet",
          type: "address",
          indexed: !0
        }, {
          name: "_tokens",
          type: "uint256",
          indexed: !1
        }, {
          name: "_latestTier",
          type: "uint256",
          indexed: !1
        }],
        name: "ReserveTokenMint",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_from",
          type: "address",
          indexed: !0
        }, {
          name: "_wallet",
          type: "address",
          indexed: !0
        }, {
          name: "_tokens",
          type: "uint256",
          indexed: !1
        }],
        name: "ReserveTokenTransfer",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_wallet",
          type: "address",
          indexed: !0
        }, {
          name: "_stableTokens",
          type: "address[]",
          indexed: !1
        }],
        name: "SetAddresses",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_nonAccreditedLimitUSD",
          type: "uint256",
          indexed: !1
        }, {
          name: "_minimumInvestmentUSD",
          type: "uint256",
          indexed: !1
        }],
        name: "SetLimits",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_startTime",
          type: "uint256",
          indexed: !1
        }, {
          name: "_endTime",
          type: "uint256",
          indexed: !1
        }],
        name: "SetTimes",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_ratePerTier",
          type: "uint256[]",
          indexed: !1
        }, {
          name: "_ratePerTierDiscountPoly",
          type: "uint256[]",
          indexed: !1
        }, {
          name: "_tokensPerTierTotal",
          type: "uint256[]",
          indexed: !1
        }, {
          name: "_tokensPerTierDiscountPoly",
          type: "uint256[]",
          indexed: !1
        }],
        name: "SetTiers",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_oldWallet",
          type: "address",
          indexed: !1
        }, {
          name: "_newWallet",
          type: "address",
          indexed: !1
        }],
        name: "SetTreasuryWallet",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_denominatedCurrency",
          type: "bytes32",
          indexed: !1
        }, {
          name: "_isCustomOracles",
          type: "bool",
          indexed: !1
        }],
        name: "SetOracles",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_wallet",
          type: "address",
          indexed: !0
        }, {
          name: "_securityToken",
          type: "address",
          indexed: !0
        }, {
          name: "_module",
          type: "address",
          indexed: !1
        }],
        name: "UsageFeeDeducted",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Pause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Unpause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_fundRaiseTypes",
          type: "uint8[]",
          indexed: !1
        }],
        name: "SetFundRaiseTypes",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_owner",
          type: "address",
          indexed: !0
        }, {
          name: "_tokens",
          type: "uint256",
          indexed: !1
        }, {
          name: "_preMint",
          type: "bool",
          indexed: !1
        }],
        name: "RevokePreMintFlag",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_owner",
          type: "address",
          indexed: !0
        }, {
          name: "_tokens",
          type: "uint256",
          indexed: !1
        }, {
          name: "_preMint",
          type: "bool",
          indexed: !1
        }],
        name: "AllowPreMintFlag",
        outputs: [],
        type: "event"
      }, {
        constant: !1,
        inputs: [{
          name: "_startTime",
          type: "uint256"
        }, {
          name: "_endTime",
          type: "uint256"
        }, {
          name: "_ratePerTier",
          type: "uint256[]"
        }, {
          name: "_ratePerTierDiscountPoly",
          type: "uint256[]"
        }, {
          name: "_tokensPerTierTotal",
          type: "uint256[]"
        }, {
          name: "_tokensPerTierDiscountPoly",
          type: "uint256[]"
        }, {
          name: "_nonAccreditedLimitUSD",
          type: "uint256"
        }, {
          name: "_minimumInvestmentUSD",
          type: "uint256"
        }, {
          name: "_fundRaiseTypes",
          type: "uint8[]"
        }, {
          name: "_wallet",
          type: "address"
        }, {
          name: "_treasuryWallet",
          type: "address"
        }, {
          name: "_stableTokens",
          type: "address[]"
        }, {
          name: "_customOracleAddresses",
          type: "address[]"
        }, {
          name: "_denominatedCurrency",
          type: "bytes32"
        }],
        name: "configure",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "allowPreMinting",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "revokePreMintFlag",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_fundRaiseTypes",
          type: "uint8[]"
        }],
        name: "modifyFunding",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_nonAccreditedLimitUSD",
          type: "uint256"
        }, {
          name: "_minimumInvestmentUSD",
          type: "uint256"
        }],
        name: "modifyLimits",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_ratePerTier",
          type: "uint256[]"
        }, {
          name: "_ratePerTierDiscountPoly",
          type: "uint256[]"
        }, {
          name: "_tokensPerTierTotal",
          type: "uint256[]"
        }, {
          name: "_tokensPerTierDiscountPoly",
          type: "uint256[]"
        }],
        name: "modifyTiers",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_startTime",
          type: "uint256"
        }, {
          name: "_endTime",
          type: "uint256"
        }],
        name: "modifyTimes",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_wallet",
          type: "address"
        }, {
          name: "_treasuryWallet",
          type: "address"
        }, {
          name: "_stableTokens",
          type: "address[]"
        }],
        name: "modifyAddresses",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_customOracleAddresses",
          type: "address[]"
        }, {
          name: "_denominatedCurrencySymbol",
          type: "bytes32"
        }],
        name: "modifyOracles",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "finalize",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_investors",
          type: "address[]"
        }, {
          name: "_nonAccreditedLimit",
          type: "uint256[]"
        }],
        name: "changeNonAccreditedLimit",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getAccreditedData",
        outputs: [{
          name: "investors",
          type: "address[]"
        }, {
          name: "accredited",
          type: "bool[]"
        }, {
          name: "overrides",
          type: "uint256[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_allowBeneficialInvestments",
          type: "bool"
        }],
        name: "changeAllowBeneficialInvestments",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address"
        }],
        name: "buyWithETH",
        outputs: [{
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }],
        payable: !0,
        stateMutability: "payable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address"
        }, {
          name: "_investedPOLY",
          type: "uint256"
        }],
        name: "buyWithPOLY",
        outputs: [{
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address"
        }, {
          name: "_investedSC",
          type: "uint256"
        }, {
          name: "_usdToken",
          type: "address"
        }],
        name: "buyWithUSD",
        outputs: [{
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address"
        }, {
          name: "_minTokens",
          type: "uint256"
        }],
        name: "buyWithETHRateLimited",
        outputs: [{
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }],
        payable: !0,
        stateMutability: "payable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address"
        }, {
          name: "_investedPOLY",
          type: "uint256"
        }, {
          name: "_minTokens",
          type: "uint256"
        }],
        name: "buyWithPOLYRateLimited",
        outputs: [{
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address"
        }, {
          name: "_investedSC",
          type: "uint256"
        }, {
          name: "_minTokens",
          type: "uint256"
        }, {
          name: "_usdToken",
          type: "address"
        }],
        name: "buyWithUSDRateLimited",
        outputs: [{
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "isOpen",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "capReached",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_fundRaiseType",
          type: "uint8"
        }],
        name: "getRate",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_fundRaiseType",
          type: "uint8"
        }],
        name: "getCustomOracleAddress",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_fundRaiseType",
          type: "uint8"
        }, {
          name: "_amount",
          type: "uint256"
        }],
        name: "convertToUSD",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_fundRaiseType",
          type: "uint8"
        }, {
          name: "_amount",
          type: "uint256"
        }],
        name: "convertFromUSD",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getTokensSold",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getTokensMinted",
        outputs: [{
          name: "tokensMinted",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_fundRaiseType",
          type: "uint8"
        }],
        name: "getTokensSoldFor",
        outputs: [{
          name: "tokensSold",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_tier",
          type: "uint256"
        }],
        name: "getTokensSoldByTier",
        outputs: [{
          name: "",
          type: "uint256[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_tier",
          type: "uint256"
        }],
        name: "getTotalTokensSoldByTier",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getNumberOfTiers",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getUsdTokens",
        outputs: [{
          name: "",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getPermissions",
        outputs: [{
          name: "allPermissions",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getSTODetails",
        outputs: [{
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256[]"
        }, {
          name: "",
          type: "uint256[]"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "bool[]"
        }, {
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getInitFunction",
        outputs: [{
          name: "",
          type: "bytes4"
        }],
        payable: !1,
        stateMutability: "pure",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(d.BaseContract);

  t.USDTieredSTOContract_3_1_0 = v, t.isUSDTieredSTOContract_3_1_0 = function (e) {
    return m.isEqual(v.ABI(), e.abi);
  };
},
/*!**************************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.1.0/vesting_escrow_wallet.js ***!
  \**************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r110,
      n = this && this.__extends || (_r110 = function r(e, t) {
    return (_r110 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r110(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      c = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || 0 < t--) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u,
      d = a(
  /*! @0x/base-contract */
  12),
      f = a(
  /*! @0x/json-schemas */
  2),
      l = a(
  /*! @0x/utils */
  8),
      h = a(
  /*! @0x/web3-wrapper */
  11),
      p = a(
  /*! @0x/assert */
  10),
      b = a(
  /*! ../../PolyResponse */
  14),
      m = a(
  /*! lodash */
  0),
      y = a(
  /*! ethers */
  13);
  (u = t.VestingEscrowWalletEvents_3_1_0 || (t.VestingEscrowWalletEvents_3_1_0 = {})).AddSchedule = "AddSchedule", u.ModifySchedule = "ModifySchedule", u.RevokeAllSchedules = "RevokeAllSchedules", u.RevokeSchedule = "RevokeSchedule", u.DepositTokens = "DepositTokens", u.SendToTreasury = "SendToTreasury", u.SendTokens = "SendTokens", u.AddTemplate = "AddTemplate", u.RemoveTemplate = "RemoveTemplate", u.TreasuryWalletChanged = "TreasuryWalletChanged", u.Pause = "Pause", u.Unpause = "Unpause";

  var v = function (e) {
    function t(a, r, n, c) {
      var u = e.call(this, "VestingEscrowWallet", t.ABI(), a, r, n) || this;
      return u.templates = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("templates(bytes32)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("templates(bytes32)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("index_0", e), this._strictEncodeArguments("templates(bytes32)", [e]);
        }
      }, u.reclaimETH = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.reclaimETH.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("reclaimETH()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("reclaimETH()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("reclaimETH()", []);
        }
      }, u.ADMIN = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("ADMIN()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("ADMIN()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("ADMIN()", []);
        }
      }, u.unpause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.unpause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("unpause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("unpause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("unpause()", []);
        }
      }, u.unassignedTokens = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("unassignedTokens()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("unassignedTokens()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("unassignedTokens()", []);
        }
      }, u.paused = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("paused()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("paused()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("paused()", []);
        }
      }, u.polyToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("polyToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("polyToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("polyToken()", []);
        }
      }, u.pause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.pause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pause()", []);
        }
      }, u.schedules = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("index_0", e), p.assert.isBigNumber("index_1", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("schedules(address,uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("schedules(address,uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("index_0", e), p.assert.isBigNumber("index_1", t), this._strictEncodeArguments("schedules(address,uint256)", [e, t]);
        }
      }, u.reclaimERC20 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.reclaimERC20.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("reclaimERC20(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_tokenContract", e), this._strictEncodeArguments("reclaimERC20(address)", [e]);
        }
      }, u.OPERATOR = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("OPERATOR()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("OPERATOR()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("OPERATOR()", []);
        }
      }, u.securityToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("securityToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("securityToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("securityToken()", []);
        }
      }, u.factory = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("factory()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("factory()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("factory()", []);
        }
      }, u.templateNames = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("templateNames(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("templateNames(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("index_0", e), this._strictEncodeArguments("templateNames(uint256)", [e]);
        }
      }, u.beneficiaries = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("index_0", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("beneficiaries(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("beneficiaries(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("index_0", e), this._strictEncodeArguments("beneficiaries(uint256)", [e]);
        }
      }, u.getDataStore = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDataStore()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDataStore()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDataStore()", []);
        }
      }, u.getInitFunction = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getInitFunction()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getInitFunction()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getInitFunction()", []);
        }
      }, u.configure = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_treasuryWallet", e), n = (r = this)._strictEncodeArguments("configure(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.configure.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_treasuryWallet", e), n = (r = this)._strictEncodeArguments("configure(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_treasuryWallet", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("configure(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("configure(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_treasuryWallet", e), this._strictEncodeArguments("configure(address)", [e]);
        }
      }, u.changeTreasuryWallet = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_newTreasuryWallet", e), n = (r = this)._strictEncodeArguments("changeTreasuryWallet(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.changeTreasuryWallet.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_newTreasuryWallet", e), n = (r = this)._strictEncodeArguments("changeTreasuryWallet(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_newTreasuryWallet", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("changeTreasuryWallet(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("changeTreasuryWallet(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_newTreasuryWallet", e), this._strictEncodeArguments("changeTreasuryWallet(address)", [e]);
        }
      }, u.depositTokens = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_numberOfTokens", e), n = (r = this)._strictEncodeArguments("depositTokens(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.depositTokens.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_numberOfTokens", e), n = (r = this)._strictEncodeArguments("depositTokens(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_numberOfTokens", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("depositTokens(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("depositTokens(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_numberOfTokens", e), this._strictEncodeArguments("depositTokens(uint256)", [e]);
        }
      }, u.sendToTreasury = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_amount", e), n = (r = this)._strictEncodeArguments("sendToTreasury(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.sendToTreasury.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_amount", e), n = (r = this)._strictEncodeArguments("sendToTreasury(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_amount", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("sendToTreasury(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("sendToTreasury(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_amount", e), this._strictEncodeArguments("sendToTreasury(uint256)", [e]);
        }
      }, u.getTreasuryWallet = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getTreasuryWallet()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getTreasuryWallet()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getTreasuryWallet()", []);
        }
      }, u.pushAvailableTokens = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), n = (r = this)._strictEncodeArguments("pushAvailableTokens(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.pushAvailableTokens.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), n = (r = this)._strictEncodeArguments("pushAvailableTokens(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("pushAvailableTokens(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("pushAvailableTokens(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_beneficiary", e), this._strictEncodeArguments("pushAvailableTokens(address)", [e]);
        }
      }, u.pullAvailableTokens = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pullAvailableTokens()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.pullAvailableTokens.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pullAvailableTokens()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pullAvailableTokens()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pullAvailableTokens()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pullAvailableTokens()", []);
        }
      }, u.addTemplate = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.isBigNumber("_numberOfTokens", t), p.assert.isBigNumber("_duration", a), p.assert.isBigNumber("_frequency", r), u = (o = this)._strictEncodeArguments("addTemplate(bytes32,uint256,uint256,uint256)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.addTemplate.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.isBigNumber("_numberOfTokens", t), p.assert.isBigNumber("_duration", a), p.assert.isBigNumber("_frequency", r), u = (o = this)._strictEncodeArguments("addTemplate(bytes32,uint256,uint256,uint256)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.isBigNumber("_numberOfTokens", t), p.assert.isBigNumber("_duration", a), p.assert.isBigNumber("_frequency", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("addTemplate(bytes32,uint256,uint256,uint256)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("addTemplate(bytes32,uint256,uint256,uint256)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isString("_name", e), p.assert.isBigNumber("_numberOfTokens", t), p.assert.isBigNumber("_duration", a), p.assert.isBigNumber("_frequency", r), this._strictEncodeArguments("addTemplate(bytes32,uint256,uint256,uint256)", [e, t, a, r]);
        }
      }, u.removeTemplate = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), n = (r = this)._strictEncodeArguments("removeTemplate(bytes32)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.removeTemplate.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), n = (r = this)._strictEncodeArguments("removeTemplate(bytes32)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("removeTemplate(bytes32)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("removeTemplate(bytes32)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_name", e), this._strictEncodeArguments("removeTemplate(bytes32)", [e]);
        }
      }, u.getTemplateCount = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getTemplateCount()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getTemplateCount()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getTemplateCount()", []);
        }
      }, u.getAllTemplateNames = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getAllTemplateNames()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getAllTemplateNames()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getAllTemplateNames()", []);
        }
      }, u.addSchedule = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u, f) {
          return o(this, void 0, void 0, function () {
            var o, l, h, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), p.assert.isBigNumber("_numberOfTokens", a), p.assert.isBigNumber("_duration", r), p.assert.isBigNumber("_frequency", n), p.assert.isBigNumber("_startTime", c), l = (o = this)._strictEncodeArguments("addSchedule(address,bytes32,uint256,uint256,uint256,uint256)", [e, t, a, r, n, c]), h = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return m = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: l
                  }), s({
                    from: m
                  }, h), o.addSchedule.estimateGasAsync.bind(o, e, t, a, r, n, c, f))];

                case 2:
                  return void 0 !== (y = i.sent()).from && (y.from = y.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(y)];

                case 3:
                  return v = i.sent(), _ = o._web3Wrapper.awaitTransactionSuccessAsync(v), [2, new b.PolyResponse(v, _)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u, f) {
          return o(this, void 0, void 0, function () {
            var o, l, h, b, m, y, v, _, g;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), p.assert.isBigNumber("_numberOfTokens", a), p.assert.isBigNumber("_duration", r), p.assert.isBigNumber("_frequency", n), p.assert.isBigNumber("_startTime", c), l = (o = this)._strictEncodeArguments("addSchedule(address,bytes32,uint256,uint256,uint256,uint256)", [e, t, a, r, n, c]), h = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return b = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, f, {
                    data: l
                  }), s({
                    from: b
                  }, h))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(m)];

                case 3:
                  return y = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return v = i.sent().gasLimit, _ = void 0 === u ? o._defaultEstimateGasFactor : u, g = Math.round(_ * y), [2, v < g ? v : g];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u, l) {
          return void 0 === u && (u = {}), o(this, void 0, void 0, function () {
            var o, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), p.assert.isBigNumber("_numberOfTokens", a), p.assert.isBigNumber("_duration", r), p.assert.isBigNumber("_frequency", n), p.assert.isBigNumber("_startTime", c), p.assert.doesConformToSchema("callData", u, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== l && p.assert.isBlockParam("defaultBlock", l), h = (o = this)._strictEncodeArguments("addSchedule(address,bytes32,uint256,uint256,uint256,uint256)", [e, t, a, r, n, c]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: h
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (b = i.sent()).from = b.from ? b.from.toLowerCase() : b.from, [4, o._web3Wrapper.callAsync(b, l)];

                case 2:
                  return m = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(m), [2, o._lookupAbiEncoder("addSchedule(address,bytes32,uint256,uint256,uint256,uint256)").strictDecodeReturnValue(m)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s) {
          return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), p.assert.isBigNumber("_numberOfTokens", a), p.assert.isBigNumber("_duration", r), p.assert.isBigNumber("_frequency", n), p.assert.isBigNumber("_startTime", s), this._strictEncodeArguments("addSchedule(address,bytes32,uint256,uint256,uint256,uint256)", [e, t, a, r, n, s]);
        }
      }, u.addScheduleFromTemplate = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), p.assert.isBigNumber("_startTime", a), c = (o = this)._strictEncodeArguments("addScheduleFromTemplate(address,bytes32,uint256)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.addScheduleFromTemplate.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), p.assert.isBigNumber("_startTime", a), c = (o = this)._strictEncodeArguments("addScheduleFromTemplate(address,bytes32,uint256)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), p.assert.isBigNumber("_startTime", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("addScheduleFromTemplate(address,bytes32,uint256)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("addScheduleFromTemplate(address,bytes32,uint256)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), p.assert.isBigNumber("_startTime", a), this._strictEncodeArguments("addScheduleFromTemplate(address,bytes32,uint256)", [e, t, a]);
        }
      }, u.modifySchedule = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), p.assert.isBigNumber("_startTime", a), c = (o = this)._strictEncodeArguments("modifySchedule(address,bytes32,uint256)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.modifySchedule.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), p.assert.isBigNumber("_startTime", a), c = (o = this)._strictEncodeArguments("modifySchedule(address,bytes32,uint256)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), p.assert.isBigNumber("_startTime", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("modifySchedule(address,bytes32,uint256)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("modifySchedule(address,bytes32,uint256)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), p.assert.isBigNumber("_startTime", a), this._strictEncodeArguments("modifySchedule(address,bytes32,uint256)", [e, t, a]);
        }
      }, u.revokeSchedule = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), o = (n = this)._strictEncodeArguments("revokeSchedule(address,bytes32)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.revokeSchedule.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), o = (n = this)._strictEncodeArguments("revokeSchedule(address,bytes32)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("revokeSchedule(address,bytes32)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("revokeSchedule(address,bytes32)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), this._strictEncodeArguments("revokeSchedule(address,bytes32)", [e, t]);
        }
      }, u.revokeAllSchedules = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), n = (r = this)._strictEncodeArguments("revokeAllSchedules(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.revokeAllSchedules.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), n = (r = this)._strictEncodeArguments("revokeAllSchedules(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("revokeAllSchedules(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("revokeAllSchedules(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_beneficiary", e), this._strictEncodeArguments("revokeAllSchedules(address)", [e]);
        }
      }, u.getSchedule = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("getSchedule(address,bytes32)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("getSchedule(address,bytes32)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_beneficiary", e), p.assert.isString("_templateName", t), this._strictEncodeArguments("getSchedule(address,bytes32)", [e, t]);
        }
      }, u.getTemplateNames = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getTemplateNames(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getTemplateNames(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_beneficiary", e), this._strictEncodeArguments("getTemplateNames(address)", [e]);
        }
      }, u.getSchedulesCountByTemplate = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_templateName", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getSchedulesCountByTemplate(bytes32)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getSchedulesCountByTemplate(bytes32)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_templateName", e), this._strictEncodeArguments("getSchedulesCountByTemplate(bytes32)", [e]);
        }
      }, u.getAllBeneficiaries = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getAllBeneficiaries()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getAllBeneficiaries()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getAllBeneficiaries()", []);
        }
      }, u.getAvailableTokens = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getAvailableTokens(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getAvailableTokens(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_beneficiary", e), this._strictEncodeArguments("getAvailableTokens(address)", [e]);
        }
      }, u.getScheduleCount = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_beneficiary", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getScheduleCount(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getScheduleCount(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_beneficiary", e), this._strictEncodeArguments("getScheduleCount(address)", [e]);
        }
      }, u.pushAvailableTokensMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_fromIndex", e), p.assert.isBigNumber("_toIndex", t), o = (n = this)._strictEncodeArguments("pushAvailableTokensMulti(uint256,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.pushAvailableTokensMulti.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_fromIndex", e), p.assert.isBigNumber("_toIndex", t), o = (n = this)._strictEncodeArguments("pushAvailableTokensMulti(uint256,uint256)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_fromIndex", e), p.assert.isBigNumber("_toIndex", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("pushAvailableTokensMulti(uint256,uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("pushAvailableTokensMulti(uint256,uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isBigNumber("_fromIndex", e), p.assert.isBigNumber("_toIndex", t), this._strictEncodeArguments("pushAvailableTokensMulti(uint256,uint256)", [e, t]);
        }
      }, u.addScheduleMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u, f) {
          return o(this, void 0, void 0, function () {
            var o, l, h, m, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_beneficiaries", e), p.assert.isArray("_templateNames", t), p.assert.isArray("_numberOfTokens", a), p.assert.isArray("_durations", r), p.assert.isArray("_frequencies", n), p.assert.isArray("_startTimes", c), l = (o = this)._strictEncodeArguments("addScheduleMulti(address[],bytes32[],uint256[],uint256[],uint256[],uint256[])", [e, t, a, r, n, c]), h = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return m = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: l
                  }), s({
                    from: m
                  }, h), o.addScheduleMulti.estimateGasAsync.bind(o, e, t, a, r, n, c, f))];

                case 2:
                  return void 0 !== (y = i.sent()).from && (y.from = y.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(y)];

                case 3:
                  return v = i.sent(), _ = o._web3Wrapper.awaitTransactionSuccessAsync(v), [2, new b.PolyResponse(v, _)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u, f) {
          return o(this, void 0, void 0, function () {
            var o, l, h, b, m, y, v, _, g;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_beneficiaries", e), p.assert.isArray("_templateNames", t), p.assert.isArray("_numberOfTokens", a), p.assert.isArray("_durations", r), p.assert.isArray("_frequencies", n), p.assert.isArray("_startTimes", c), l = (o = this)._strictEncodeArguments("addScheduleMulti(address[],bytes32[],uint256[],uint256[],uint256[],uint256[])", [e, t, a, r, n, c]), h = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return b = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, f, {
                    data: l
                  }), s({
                    from: b
                  }, h))];

                case 2:
                  return void 0 !== (m = i.sent()).from && (m.from = m.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(m)];

                case 3:
                  return y = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return v = i.sent().gasLimit, _ = void 0 === u ? o._defaultEstimateGasFactor : u, g = Math.round(_ * y), [2, v < g ? v : g];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u, l) {
          return void 0 === u && (u = {}), o(this, void 0, void 0, function () {
            var o, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_beneficiaries", e), p.assert.isArray("_templateNames", t), p.assert.isArray("_numberOfTokens", a), p.assert.isArray("_durations", r), p.assert.isArray("_frequencies", n), p.assert.isArray("_startTimes", c), p.assert.doesConformToSchema("callData", u, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== l && p.assert.isBlockParam("defaultBlock", l), h = (o = this)._strictEncodeArguments("addScheduleMulti(address[],bytes32[],uint256[],uint256[],uint256[],uint256[])", [e, t, a, r, n, c]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, u, {
                    data: h
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (b = i.sent()).from = b.from ? b.from.toLowerCase() : b.from, [4, o._web3Wrapper.callAsync(b, l)];

                case 2:
                  return m = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(m), [2, o._lookupAbiEncoder("addScheduleMulti(address[],bytes32[],uint256[],uint256[],uint256[],uint256[])").strictDecodeReturnValue(m)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s) {
          return p.assert.isArray("_beneficiaries", e), p.assert.isArray("_templateNames", t), p.assert.isArray("_numberOfTokens", a), p.assert.isArray("_durations", r), p.assert.isArray("_frequencies", n), p.assert.isArray("_startTimes", s), this._strictEncodeArguments("addScheduleMulti(address[],bytes32[],uint256[],uint256[],uint256[],uint256[])", [e, t, a, r, n, s]);
        }
      }, u.addScheduleFromTemplateMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_beneficiaries", e), p.assert.isArray("_templateNames", t), p.assert.isArray("_startTimes", a), c = (o = this)._strictEncodeArguments("addScheduleFromTemplateMulti(address[],bytes32[],uint256[])", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.addScheduleFromTemplateMulti.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_beneficiaries", e), p.assert.isArray("_templateNames", t), p.assert.isArray("_startTimes", a), c = (o = this)._strictEncodeArguments("addScheduleFromTemplateMulti(address[],bytes32[],uint256[])", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_beneficiaries", e), p.assert.isArray("_templateNames", t), p.assert.isArray("_startTimes", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("addScheduleFromTemplateMulti(address[],bytes32[],uint256[])", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("addScheduleFromTemplateMulti(address[],bytes32[],uint256[])").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isArray("_beneficiaries", e), p.assert.isArray("_templateNames", t), p.assert.isArray("_startTimes", a), this._strictEncodeArguments("addScheduleFromTemplateMulti(address[],bytes32[],uint256[])", [e, t, a]);
        }
      }, u.revokeSchedulesMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_beneficiaries", e), n = (r = this)._strictEncodeArguments("revokeSchedulesMulti(address[])", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.revokeSchedulesMulti.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_beneficiaries", e), n = (r = this)._strictEncodeArguments("revokeSchedulesMulti(address[])", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_beneficiaries", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("revokeSchedulesMulti(address[])", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("revokeSchedulesMulti(address[])").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isArray("_beneficiaries", e), this._strictEncodeArguments("revokeSchedulesMulti(address[])", [e]);
        }
      }, u.modifyScheduleMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_beneficiaries", e), p.assert.isArray("_templateNames", t), p.assert.isArray("_startTimes", a), c = (o = this)._strictEncodeArguments("modifyScheduleMulti(address[],bytes32[],uint256[])", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.modifyScheduleMulti.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_beneficiaries", e), p.assert.isArray("_templateNames", t), p.assert.isArray("_startTimes", a), c = (o = this)._strictEncodeArguments("modifyScheduleMulti(address[],bytes32[],uint256[])", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_beneficiaries", e), p.assert.isArray("_templateNames", t), p.assert.isArray("_startTimes", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("modifyScheduleMulti(address[],bytes32[],uint256[])", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("modifyScheduleMulti(address[],bytes32[],uint256[])").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isArray("_beneficiaries", e), p.assert.isArray("_templateNames", t), p.assert.isArray("_startTimes", a), this._strictEncodeArguments("modifyScheduleMulti(address[],bytes32[],uint256[])", [e, t, a]);
        }
      }, u.getPermissions = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getPermissions()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getPermissions()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getPermissions()", []);
        }
      }, u._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, l.classUtils.bindAll(u, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), u;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n, s, u) {
      return o(this, void 0, void 0, function () {
        var o, b, m, v, _, g, A, w, T, x, D;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return p.assert.isHexString("bytecode", e), p.assert.doesConformToSchema("txDefaults", n, f.schemas.txDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), o = l.providerUtils.standardizeOrThrow(r), b = d.BaseContract._lookupConstructorAbi(a), D = c(d.BaseContract._formatABIDataItemList(b.inputs, [s, u], d.BaseContract._bigNumberToString), 2), s = D[0], u = D[1], m = new y.utils.Interface(a), v = m.deployFunction, _ = v.encode(e, [s, u]), g = new h.Web3Wrapper(o), [4, d.BaseContract._applyDefaultsToTxDataAsync({
                data: _
              }, n, g.estimateGasAsync.bind(g))];

            case 1:
              return A = i.sent(), [4, g.sendTransactionAsync(A)];

            case 2:
              return w = i.sent(), l.logUtils.log("transactionHash: " + w), [4, g.awaitTransactionSuccessAsync(w)];

            case 3:
              return T = i.sent(), l.logUtils.log("VestingEscrowWallet successfully deployed at " + T.contractAddress), (x = new t(T.contractAddress, o, n)).constructorArgs = [s, u], [2, x];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "bytes32"
        }],
        name: "templates",
        outputs: [{
          name: "numberOfTokens",
          type: "uint256"
        }, {
          name: "duration",
          type: "uint256"
        }, {
          name: "frequency",
          type: "uint256"
        }, {
          name: "index",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "reclaimETH",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "ADMIN",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "unpause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "unassignedTokens",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "paused",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "polyToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "pause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "address"
        }, {
          name: "index_1",
          type: "uint256"
        }],
        name: "schedules",
        outputs: [{
          name: "templateName",
          type: "bytes32"
        }, {
          name: "claimedTokens",
          type: "uint256"
        }, {
          name: "startTime",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenContract",
          type: "address"
        }],
        name: "reclaimERC20",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "OPERATOR",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "securityToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "factory",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "uint256"
        }],
        name: "templateNames",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "index_0",
          type: "uint256"
        }],
        name: "beneficiaries",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDataStore",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        inputs: [{
          name: "_securityToken",
          type: "address"
        }, {
          name: "_polyAddress",
          type: "address"
        }],
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "constructor"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address",
          indexed: !0
        }, {
          name: "_templateName",
          type: "bytes32",
          indexed: !1
        }, {
          name: "_startTime",
          type: "uint256",
          indexed: !1
        }],
        name: "AddSchedule",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address",
          indexed: !0
        }, {
          name: "_templateName",
          type: "bytes32",
          indexed: !1
        }, {
          name: "_startTime",
          type: "uint256",
          indexed: !1
        }],
        name: "ModifySchedule",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address",
          indexed: !0
        }],
        name: "RevokeAllSchedules",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address",
          indexed: !0
        }, {
          name: "_templateName",
          type: "bytes32",
          indexed: !1
        }],
        name: "RevokeSchedule",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_numberOfTokens",
          type: "uint256",
          indexed: !1
        }, {
          name: "_sender",
          type: "address",
          indexed: !1
        }],
        name: "DepositTokens",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_numberOfTokens",
          type: "uint256",
          indexed: !1
        }, {
          name: "_sender",
          type: "address",
          indexed: !1
        }],
        name: "SendToTreasury",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address",
          indexed: !0
        }, {
          name: "_numberOfTokens",
          type: "uint256",
          indexed: !1
        }],
        name: "SendTokens",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_name",
          type: "bytes32",
          indexed: !1
        }, {
          name: "_numberOfTokens",
          type: "uint256",
          indexed: !1
        }, {
          name: "_duration",
          type: "uint256",
          indexed: !1
        }, {
          name: "_frequency",
          type: "uint256",
          indexed: !1
        }],
        name: "AddTemplate",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_name",
          type: "bytes32",
          indexed: !1
        }],
        name: "RemoveTemplate",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_newWallet",
          type: "address",
          indexed: !1
        }, {
          name: "_oldWallet",
          type: "address",
          indexed: !1
        }],
        name: "TreasuryWalletChanged",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Pause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Unpause",
        outputs: [],
        type: "event"
      }, {
        constant: !0,
        inputs: [],
        name: "getInitFunction",
        outputs: [{
          name: "",
          type: "bytes4"
        }],
        payable: !1,
        stateMutability: "pure",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_treasuryWallet",
          type: "address"
        }],
        name: "configure",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_newTreasuryWallet",
          type: "address"
        }],
        name: "changeTreasuryWallet",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_numberOfTokens",
          type: "uint256"
        }],
        name: "depositTokens",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_amount",
          type: "uint256"
        }],
        name: "sendToTreasury",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getTreasuryWallet",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address"
        }],
        name: "pushAvailableTokens",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "pullAvailableTokens",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_name",
          type: "bytes32"
        }, {
          name: "_numberOfTokens",
          type: "uint256"
        }, {
          name: "_duration",
          type: "uint256"
        }, {
          name: "_frequency",
          type: "uint256"
        }],
        name: "addTemplate",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_name",
          type: "bytes32"
        }],
        name: "removeTemplate",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getTemplateCount",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getAllTemplateNames",
        outputs: [{
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address"
        }, {
          name: "_templateName",
          type: "bytes32"
        }, {
          name: "_numberOfTokens",
          type: "uint256"
        }, {
          name: "_duration",
          type: "uint256"
        }, {
          name: "_frequency",
          type: "uint256"
        }, {
          name: "_startTime",
          type: "uint256"
        }],
        name: "addSchedule",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address"
        }, {
          name: "_templateName",
          type: "bytes32"
        }, {
          name: "_startTime",
          type: "uint256"
        }],
        name: "addScheduleFromTemplate",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address"
        }, {
          name: "_templateName",
          type: "bytes32"
        }, {
          name: "_startTime",
          type: "uint256"
        }],
        name: "modifySchedule",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address"
        }, {
          name: "_templateName",
          type: "bytes32"
        }],
        name: "revokeSchedule",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiary",
          type: "address"
        }],
        name: "revokeAllSchedules",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_beneficiary",
          type: "address"
        }, {
          name: "_templateName",
          type: "bytes32"
        }],
        name: "getSchedule",
        outputs: [{
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint256"
        }, {
          name: "",
          type: "uint8"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_beneficiary",
          type: "address"
        }],
        name: "getTemplateNames",
        outputs: [{
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_templateName",
          type: "bytes32"
        }],
        name: "getSchedulesCountByTemplate",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getAllBeneficiaries",
        outputs: [{
          name: "",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_beneficiary",
          type: "address"
        }],
        name: "getAvailableTokens",
        outputs: [{
          name: "availableTokens",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_beneficiary",
          type: "address"
        }],
        name: "getScheduleCount",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_fromIndex",
          type: "uint256"
        }, {
          name: "_toIndex",
          type: "uint256"
        }],
        name: "pushAvailableTokensMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiaries",
          type: "address[]"
        }, {
          name: "_templateNames",
          type: "bytes32[]"
        }, {
          name: "_numberOfTokens",
          type: "uint256[]"
        }, {
          name: "_durations",
          type: "uint256[]"
        }, {
          name: "_frequencies",
          type: "uint256[]"
        }, {
          name: "_startTimes",
          type: "uint256[]"
        }],
        name: "addScheduleMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiaries",
          type: "address[]"
        }, {
          name: "_templateNames",
          type: "bytes32[]"
        }, {
          name: "_startTimes",
          type: "uint256[]"
        }],
        name: "addScheduleFromTemplateMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiaries",
          type: "address[]"
        }],
        name: "revokeSchedulesMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_beneficiaries",
          type: "address[]"
        }, {
          name: "_templateNames",
          type: "bytes32[]"
        }, {
          name: "_startTimes",
          type: "uint256[]"
        }],
        name: "modifyScheduleMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getPermissions",
        outputs: [{
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(d.BaseContract);

  t.VestingEscrowWalletContract_3_1_0 = v, t.isVestingEscrowWalletContract_3_1_0 = function (e) {
    return m.isEqual(v.ABI(), e.abi);
  };
},
/*!********************************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.1.0/restricted_partial_sale_t_m.js ***!
  \********************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r111,
      n = this && this.__extends || (_r111 = function r(e, t) {
    return (_r111 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r111(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      c = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || 0 < t--) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u,
      d = a(
  /*! @0x/base-contract */
  12),
      f = a(
  /*! @0x/json-schemas */
  2),
      l = a(
  /*! @0x/utils */
  8),
      h = a(
  /*! @0x/web3-wrapper */
  11),
      p = a(
  /*! @0x/assert */
  10),
      b = a(
  /*! ../../PolyResponse */
  14),
      m = a(
  /*! lodash */
  0),
      y = a(
  /*! ethers */
  13);
  (u = t.RestrictedPartialSaleTMEvents_3_1_0 || (t.RestrictedPartialSaleTMEvents_3_1_0 = {})).ChangedExemptWalletList = "ChangedExemptWalletList", u.Pause = "Pause", u.Unpause = "Unpause";

  var v = function (e) {
    function t(a, r, n, c) {
      var u = e.call(this, "RestrictedPartialSaleTM", t.ABI(), a, r, n) || this;
      return u.reclaimETH = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.reclaimETH.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("reclaimETH()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("reclaimETH()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("reclaimETH()", []);
        }
      }, u.getTokensByPartition = {
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_partition", e), p.assert.isString("_tokenHolder", t), p.assert.isBigNumber("index_2", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("getTokensByPartition(bytes32,address,uint256)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("getTokensByPartition(bytes32,address,uint256)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isString("_partition", e), p.assert.isString("_tokenHolder", t), p.assert.isBigNumber("index_2", a), this._strictEncodeArguments("getTokensByPartition(bytes32,address,uint256)", [e, t, a]);
        }
      }, u.ADMIN = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("ADMIN()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("ADMIN()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("ADMIN()", []);
        }
      }, u.unpause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.unpause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("unpause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("unpause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("unpause()", []);
        }
      }, u.paused = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("paused()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("paused()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("paused()", []);
        }
      }, u.UNLOCKED = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("UNLOCKED()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("UNLOCKED()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("UNLOCKED()", []);
        }
      }, u.polyToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("polyToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("polyToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("polyToken()", []);
        }
      }, u.pause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.pause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pause()", []);
        }
      }, u.reclaimERC20 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.reclaimERC20.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("reclaimERC20(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_tokenContract", e), this._strictEncodeArguments("reclaimERC20(address)", [e]);
        }
      }, u.OPERATOR = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("OPERATOR()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("OPERATOR()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("OPERATOR()", []);
        }
      }, u.LOCKED = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("LOCKED()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("LOCKED()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("LOCKED()", []);
        }
      }, u.securityToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("securityToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("securityToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("securityToken()", []);
        }
      }, u.factory = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("factory()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("factory()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("factory()", []);
        }
      }, u.getDataStore = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDataStore()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDataStore()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDataStore()", []);
        }
      }, u.getInitFunction = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getInitFunction()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getInitFunction()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getInitFunction()", []);
        }
      }, u.configure = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_treasuryWallet", e), n = (r = this)._strictEncodeArguments("configure(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.configure.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_treasuryWallet", e), n = (r = this)._strictEncodeArguments("configure(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_treasuryWallet", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("configure(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("configure(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_treasuryWallet", e), this._strictEncodeArguments("configure(address)", [e]);
        }
      }, u.executeTransfer = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("index_1", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), u = (o = this)._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), s({
                    from: l
                  }, f), o.executeTransfer.estimateGasAsync.bind(o, e, t, a, r, c))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(h)];

                case 3:
                  return m = i.sent(), y = o._web3Wrapper.awaitTransactionSuccessAsync(m), [2, new b.PolyResponse(m, y)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c) {
          return o(this, void 0, void 0, function () {
            var o, u, f, l, h, b, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("index_1", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), u = (o = this)._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]), f = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return l = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, c, {
                    data: u
                  }), s({
                    from: l
                  }, f))];

                case 2:
                  return void 0 !== (h = i.sent()).from && (h.from = h.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(h)];

                case 3:
                  return b = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return m = i.sent().gasLimit, y = void 0 === n ? o._defaultEstimateGasFactor : n, v = Math.round(y * b), [2, m < v ? m : v];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("index_1", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("executeTransfer(address,address,uint256,bytes)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isString("_from", e), p.assert.isString("index_1", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), this._strictEncodeArguments("executeTransfer(address,address,uint256,bytes)", [e, t, a, r]);
        }
      }, u.verifyTransfer = {
        callAsync: function callAsync(e, t, a, r, n, c) {
          return void 0 === n && (n = {}), o(this, void 0, void 0, function () {
            var o, u, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_from", e), p.assert.isString("index_1", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), p.assert.doesConformToSchema("callData", n, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== c && p.assert.isBlockParam("defaultBlock", c), u = (o = this)._strictEncodeArguments("verifyTransfer(address,address,uint256,bytes)", [e, t, a, r]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: u
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (l = i.sent()).from = l.from ? l.from.toLowerCase() : l.from, [4, o._web3Wrapper.callAsync(l, c)];

                case 2:
                  return h = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(h), [2, o._lookupAbiEncoder("verifyTransfer(address,address,uint256,bytes)").strictDecodeReturnValue(h)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r) {
          return p.assert.isString("_from", e), p.assert.isString("index_1", t), p.assert.isBigNumber("_amount", a), p.assert.isString("index_3", r), this._strictEncodeArguments("verifyTransfer(address,address,uint256,bytes)", [e, t, a, r]);
        }
      }, u.changeExemptWalletList = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_wallet", e), p.assert.isBoolean("_exempted", t), o = (n = this)._strictEncodeArguments("changeExemptWalletList(address,bool)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.changeExemptWalletList.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_wallet", e), p.assert.isBoolean("_exempted", t), o = (n = this)._strictEncodeArguments("changeExemptWalletList(address,bool)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_wallet", e), p.assert.isBoolean("_exempted", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("changeExemptWalletList(address,bool)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("changeExemptWalletList(address,bool)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_wallet", e), p.assert.isBoolean("_exempted", t), this._strictEncodeArguments("changeExemptWalletList(address,bool)", [e, t]);
        }
      }, u.changeExemptWalletListMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_wallet", e), p.assert.isArray("_exempted", t), o = (n = this)._strictEncodeArguments("changeExemptWalletListMulti(address[],bool[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.changeExemptWalletListMulti.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_wallet", e), p.assert.isArray("_exempted", t), o = (n = this)._strictEncodeArguments("changeExemptWalletListMulti(address[],bool[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_wallet", e), p.assert.isArray("_exempted", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("changeExemptWalletListMulti(address[],bool[])", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("changeExemptWalletListMulti(address[],bool[])").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isArray("_wallet", e), p.assert.isArray("_exempted", t), this._strictEncodeArguments("changeExemptWalletListMulti(address[],bool[])", [e, t]);
        }
      }, u.getExemptAddresses = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getExemptAddresses()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getExemptAddresses()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getExemptAddresses()", []);
        }
      }, u.getPermissions = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getPermissions()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getPermissions()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getPermissions()", []);
        }
      }, u._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, l.classUtils.bindAll(u, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), u;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n, s, u) {
      return o(this, void 0, void 0, function () {
        var o, b, m, v, _, g, A, w, T, x, D;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return p.assert.isHexString("bytecode", e), p.assert.doesConformToSchema("txDefaults", n, f.schemas.txDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), o = l.providerUtils.standardizeOrThrow(r), b = d.BaseContract._lookupConstructorAbi(a), D = c(d.BaseContract._formatABIDataItemList(b.inputs, [s, u], d.BaseContract._bigNumberToString), 2), s = D[0], u = D[1], m = new y.utils.Interface(a), v = m.deployFunction, _ = v.encode(e, [s, u]), g = new h.Web3Wrapper(o), [4, d.BaseContract._applyDefaultsToTxDataAsync({
                data: _
              }, n, g.estimateGasAsync.bind(g))];

            case 1:
              return A = i.sent(), [4, g.sendTransactionAsync(A)];

            case 2:
              return w = i.sent(), l.logUtils.log("transactionHash: " + w), [4, g.awaitTransactionSuccessAsync(w)];

            case 3:
              return T = i.sent(), l.logUtils.log("RestrictedPartialSaleTM successfully deployed at " + T.contractAddress), (x = new t(T.contractAddress, o, n)).constructorArgs = [s, u], [2, x];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !1,
        inputs: [],
        name: "reclaimETH",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_partition",
          type: "bytes32"
        }, {
          name: "_tokenHolder",
          type: "address"
        }, {
          name: "index_2",
          type: "uint256"
        }],
        name: "getTokensByPartition",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "ADMIN",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "unpause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "paused",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "UNLOCKED",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "polyToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "pause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenContract",
          type: "address"
        }],
        name: "reclaimERC20",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "OPERATOR",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "LOCKED",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "securityToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "factory",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDataStore",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        inputs: [{
          name: "_securityToken",
          type: "address"
        }, {
          name: "_polyAddress",
          type: "address"
        }],
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "constructor"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_wallet",
          type: "address",
          indexed: !0
        }, {
          name: "_exempted",
          type: "bool",
          indexed: !1
        }],
        name: "ChangedExemptWalletList",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Pause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Unpause",
        outputs: [],
        type: "event"
      }, {
        constant: !0,
        inputs: [],
        name: "getInitFunction",
        outputs: [{
          name: "",
          type: "bytes4"
        }],
        payable: !1,
        stateMutability: "pure",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_treasuryWallet",
          type: "address"
        }],
        name: "configure",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "index_1",
          type: "address"
        }, {
          name: "_amount",
          type: "uint256"
        }, {
          name: "index_3",
          type: "bytes"
        }],
        name: "executeTransfer",
        outputs: [{
          name: "",
          type: "uint8"
        }],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_from",
          type: "address"
        }, {
          name: "index_1",
          type: "address"
        }, {
          name: "_amount",
          type: "uint256"
        }, {
          name: "index_3",
          type: "bytes"
        }],
        name: "verifyTransfer",
        outputs: [{
          name: "",
          type: "uint8"
        }, {
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_wallet",
          type: "address"
        }, {
          name: "_exempted",
          type: "bool"
        }],
        name: "changeExemptWalletList",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_wallet",
          type: "address[]"
        }, {
          name: "_exempted",
          type: "bool[]"
        }],
        name: "changeExemptWalletListMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getExemptAddresses",
        outputs: [{
          name: "",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getPermissions",
        outputs: [{
          name: "",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(d.BaseContract);

  t.RestrictedPartialSaleTMContract_3_1_0 = v, t.isRestrictedPartialSaleTMContract_3_1_0 = function (e) {
    return m.isEqual(v.ABI(), e.abi);
  };
},
/*!***************************************************************************************************************************!*\
  !*** ./node_modules/@polymathnetwork/abi-wrappers/lib/src/generated-wrappers/3.1.0/advanced_p_l_c_r_voting_checkpoint.js ***!
  \***************************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r112,
      n = this && this.__extends || (_r112 = function r(e, t) {
    return (_r112 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r112(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a = a || Promise)(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = 0 < (n = o.trys).length && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      c = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || 0 < t--) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var u,
      d = a(
  /*! @0x/base-contract */
  12),
      f = a(
  /*! @0x/json-schemas */
  2),
      l = a(
  /*! @0x/utils */
  8),
      h = a(
  /*! @0x/web3-wrapper */
  11),
      p = a(
  /*! @0x/assert */
  10),
      b = a(
  /*! ../../PolyResponse */
  14),
      m = a(
  /*! lodash */
  0),
      y = a(
  /*! ethers */
  13);
  (u = t.AdvancedPLCRVotingCheckpointEvents_3_1_0 || (t.AdvancedPLCRVotingCheckpointEvents_3_1_0 = {})).StatutoryBallotCreated = "StatutoryBallotCreated", u.CumulativeBallotCreated = "CumulativeBallotCreated", u.VotersExempted = "VotersExempted", u.VoteCommit = "VoteCommit", u.VoteRevealed = "VoteRevealed", u.BallotCancelled = "BallotCancelled", u.ChangedBallotExemptedVotersList = "ChangedBallotExemptedVotersList", u.ChangedDefaultExemptedVotersList = "ChangedDefaultExemptedVotersList", u.Pause = "Pause", u.Unpause = "Unpause";

  var v = function (e) {
    function t(a, r, n, c) {
      var u = e.call(this, "AdvancedPLCRVotingCheckpoint", t.ABI(), a, r, n) || this;
      return u.reclaimETH = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.reclaimETH.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("reclaimETH()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("reclaimETH()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("reclaimETH()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("reclaimETH()", []);
        }
      }, u.ADMIN = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("ADMIN()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("ADMIN()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("ADMIN()", []);
        }
      }, u.unpause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.unpause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("unpause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("unpause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("unpause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("unpause()", []);
        }
      }, u.paused = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("paused()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("paused()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("paused()", []);
        }
      }, u.polyToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("polyToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("polyToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("polyToken()", []);
        }
      }, u.getDefaultExemptionVotersList = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDefaultExemptionVotersList()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDefaultExemptionVotersList()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDefaultExemptionVotersList()", []);
        }
      }, u.pause = {
        sendTransactionAsync: function sendTransactionAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), s({
                    from: o
                  }, n), a.pause.estimateGasAsync.bind(a, t))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.sendTransactionAsync(c)];

                case 3:
                  return u = i.sent(), f = a._web3Wrapper.awaitTransactionSuccessAsync(u), [2, new b.PolyResponse(u, f)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t) {
          return o(this, void 0, void 0, function () {
            var a, r, n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return r = (a = this)._strictEncodeArguments("pause()", []), n = a._web3Wrapper.getContractDefaults(), [4, a._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return o = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, t, {
                    data: r
                  }), s({
                    from: o
                  }, n))];

                case 2:
                  return void 0 !== (c = i.sent()).from && (c.from = c.from.toLowerCase()), [4, a._web3Wrapper.estimateGasAsync(c)];

                case 3:
                  return u = i.sent(), [4, a._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return f = i.sent().gasLimit, l = void 0 === e ? a._defaultEstimateGasFactor : e, h = Math.round(l * u), [2, f < h ? f : h];
              }
            });
          });
        },
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("pause()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("pause()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("pause()", []);
        }
      }, u.reclaimERC20 = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.reclaimERC20.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_tokenContract", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("reclaimERC20(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("reclaimERC20(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_tokenContract", e), this._strictEncodeArguments("reclaimERC20(address)", [e]);
        }
      }, u.OPERATOR = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("OPERATOR()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("OPERATOR()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("OPERATOR()", []);
        }
      }, u.securityToken = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("securityToken()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("securityToken()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("securityToken()", []);
        }
      }, u.factory = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("factory()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("factory()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("factory()", []);
        }
      }, u.getDataStore = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getDataStore()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getDataStore()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getDataStore()", []);
        }
      }, u.createStatutoryBallot = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u, f, l, h) {
          return o(this, void 0, void 0, function () {
            var o, m, y, v, _, g, A;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_commitDuration", a), p.assert.isBigNumber("_revealDuration", r), p.assert.isString("_proposalTitle", n), p.assert.isString("_details", c), p.assert.isString("_choices", u), p.assert.isBigNumber("_noOfChoices", f), m = (o = this)._strictEncodeArguments("createStatutoryBallot(bytes32,uint256,uint256,uint256,string,bytes32,string,uint256)", [e, t, a, r, n, c, u, f]), y = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return v = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, l, {
                    data: m
                  }), s({
                    from: v
                  }, y), o.createStatutoryBallot.estimateGasAsync.bind(o, e, t, a, r, n, c, u, f, h))];

                case 2:
                  return void 0 !== (_ = i.sent()).from && (_.from = _.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(_)];

                case 3:
                  return g = i.sent(), A = o._web3Wrapper.awaitTransactionSuccessAsync(g), [2, new b.PolyResponse(g, A)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u, f, l, h) {
          return o(this, void 0, void 0, function () {
            var o, b, m, y, v, _, g, A, w;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_commitDuration", a), p.assert.isBigNumber("_revealDuration", r), p.assert.isString("_proposalTitle", n), p.assert.isString("_details", c), p.assert.isString("_choices", u), p.assert.isBigNumber("_noOfChoices", f), b = (o = this)._strictEncodeArguments("createStatutoryBallot(bytes32,uint256,uint256,uint256,string,bytes32,string,uint256)", [e, t, a, r, n, c, u, f]), m = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return y = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, h, {
                    data: b
                  }), s({
                    from: y
                  }, m))];

                case 2:
                  return void 0 !== (v = i.sent()).from && (v.from = v.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(v)];

                case 3:
                  return _ = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return g = i.sent().gasLimit, A = void 0 === l ? o._defaultEstimateGasFactor : l, w = Math.round(A * _), [2, g < w ? g : w];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u, l, h, b) {
          return void 0 === h && (h = {}), o(this, void 0, void 0, function () {
            var o, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_commitDuration", a), p.assert.isBigNumber("_revealDuration", r), p.assert.isString("_proposalTitle", n), p.assert.isString("_details", c), p.assert.isString("_choices", u), p.assert.isBigNumber("_noOfChoices", l), p.assert.doesConformToSchema("callData", h, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== b && p.assert.isBlockParam("defaultBlock", b), m = (o = this)._strictEncodeArguments("createStatutoryBallot(bytes32,uint256,uint256,uint256,string,bytes32,string,uint256)", [e, t, a, r, n, c, u, l]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, h, {
                    data: m
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (y = i.sent()).from = y.from ? y.from.toLowerCase() : y.from, [4, o._web3Wrapper.callAsync(y, b)];

                case 2:
                  return v = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(v), [2, o._lookupAbiEncoder("createStatutoryBallot(bytes32,uint256,uint256,uint256,string,bytes32,string,uint256)").strictDecodeReturnValue(v)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s, o, i) {
          return p.assert.isString("_name", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_commitDuration", a), p.assert.isBigNumber("_revealDuration", r), p.assert.isString("_proposalTitle", n), p.assert.isString("_details", s), p.assert.isString("_choices", o), p.assert.isBigNumber("_noOfChoices", i), this._strictEncodeArguments("createStatutoryBallot(bytes32,uint256,uint256,uint256,string,bytes32,string,uint256)", [e, t, a, r, n, s, o, i]);
        }
      }, u.createCustomStatutoryBallot = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u, f, l, h, m) {
          return o(this, void 0, void 0, function () {
            var o, y, v, _, g, A, w;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_commitDuration", a), p.assert.isBigNumber("_revealDuration", r), p.assert.isString("_proposalTitle", n), p.assert.isString("_details", c), p.assert.isString("_choices", u), p.assert.isBigNumber("_noOfChoices", f), p.assert.isBigNumber("_checkpointId", l), y = (o = this)._strictEncodeArguments("createCustomStatutoryBallot(bytes32,uint256,uint256,uint256,string,bytes32,string,uint256,uint256)", [e, t, a, r, n, c, u, f, l]), v = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return _ = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, h, {
                    data: y
                  }), s({
                    from: _
                  }, v), o.createCustomStatutoryBallot.estimateGasAsync.bind(o, e, t, a, r, n, c, u, f, l, m))];

                case 2:
                  return void 0 !== (g = i.sent()).from && (g.from = g.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(g)];

                case 3:
                  return A = i.sent(), w = o._web3Wrapper.awaitTransactionSuccessAsync(A), [2, new b.PolyResponse(A, w)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u, f, l, h, b) {
          return o(this, void 0, void 0, function () {
            var o, m, y, v, _, g, A, w, T;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_commitDuration", a), p.assert.isBigNumber("_revealDuration", r), p.assert.isString("_proposalTitle", n), p.assert.isString("_details", c), p.assert.isString("_choices", u), p.assert.isBigNumber("_noOfChoices", f), p.assert.isBigNumber("_checkpointId", l), m = (o = this)._strictEncodeArguments("createCustomStatutoryBallot(bytes32,uint256,uint256,uint256,string,bytes32,string,uint256,uint256)", [e, t, a, r, n, c, u, f, l]), y = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return v = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, b, {
                    data: m
                  }), s({
                    from: v
                  }, y))];

                case 2:
                  return void 0 !== (_ = i.sent()).from && (_.from = _.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(_)];

                case 3:
                  return g = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return A = i.sent().gasLimit, w = void 0 === h ? o._defaultEstimateGasFactor : h, T = Math.round(w * g), [2, A < T ? A : T];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u, l, h, b, m) {
          return void 0 === b && (b = {}), o(this, void 0, void 0, function () {
            var o, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_commitDuration", a), p.assert.isBigNumber("_revealDuration", r), p.assert.isString("_proposalTitle", n), p.assert.isString("_details", c), p.assert.isString("_choices", u), p.assert.isBigNumber("_noOfChoices", l), p.assert.isBigNumber("_checkpointId", h), p.assert.doesConformToSchema("callData", b, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== m && p.assert.isBlockParam("defaultBlock", m), y = (o = this)._strictEncodeArguments("createCustomStatutoryBallot(bytes32,uint256,uint256,uint256,string,bytes32,string,uint256,uint256)", [e, t, a, r, n, c, u, l, h]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, b, {
                    data: y
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (v = i.sent()).from = v.from ? v.from.toLowerCase() : v.from, [4, o._web3Wrapper.callAsync(v, m)];

                case 2:
                  return _ = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(_), [2, o._lookupAbiEncoder("createCustomStatutoryBallot(bytes32,uint256,uint256,uint256,string,bytes32,string,uint256,uint256)").strictDecodeReturnValue(_)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s, o, i, c) {
          return p.assert.isString("_name", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_commitDuration", a), p.assert.isBigNumber("_revealDuration", r), p.assert.isString("_proposalTitle", n), p.assert.isString("_details", s), p.assert.isString("_choices", o), p.assert.isBigNumber("_noOfChoices", i), p.assert.isBigNumber("_checkpointId", c), this._strictEncodeArguments("createCustomStatutoryBallot(bytes32,uint256,uint256,uint256,string,bytes32,string,uint256,uint256)", [e, t, a, r, n, s, o, i, c]);
        }
      }, u.createCustomCumulativeBallot = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u, f, l, h, m) {
          return o(this, void 0, void 0, function () {
            var o, y, v, _, g, A, w;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_commitDuration", a), p.assert.isBigNumber("_revealDuration", r), p.assert.isString("_proposalTitles", n), p.assert.isArray("_details", c), p.assert.isString("_choices", u), p.assert.isArray("_noOfChoices", f), p.assert.isBigNumber("_checkpointId", l), y = (o = this)._strictEncodeArguments("createCustomCumulativeBallot(bytes32,uint256,uint256,uint256,string,bytes32[],string,uint256[],uint256)", [e, t, a, r, n, c, u, f, l]), v = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return _ = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, h, {
                    data: y
                  }), s({
                    from: _
                  }, v), o.createCustomCumulativeBallot.estimateGasAsync.bind(o, e, t, a, r, n, c, u, f, l, m))];

                case 2:
                  return void 0 !== (g = i.sent()).from && (g.from = g.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(g)];

                case 3:
                  return A = i.sent(), w = o._web3Wrapper.awaitTransactionSuccessAsync(A), [2, new b.PolyResponse(A, w)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u, f, l, h, b) {
          return o(this, void 0, void 0, function () {
            var o, m, y, v, _, g, A, w, T;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_commitDuration", a), p.assert.isBigNumber("_revealDuration", r), p.assert.isString("_proposalTitles", n), p.assert.isArray("_details", c), p.assert.isString("_choices", u), p.assert.isArray("_noOfChoices", f), p.assert.isBigNumber("_checkpointId", l), m = (o = this)._strictEncodeArguments("createCustomCumulativeBallot(bytes32,uint256,uint256,uint256,string,bytes32[],string,uint256[],uint256)", [e, t, a, r, n, c, u, f, l]), y = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return v = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, b, {
                    data: m
                  }), s({
                    from: v
                  }, y))];

                case 2:
                  return void 0 !== (_ = i.sent()).from && (_.from = _.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(_)];

                case 3:
                  return g = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return A = i.sent().gasLimit, w = void 0 === h ? o._defaultEstimateGasFactor : h, T = Math.round(w * g), [2, A < T ? A : T];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u, l, h, b, m) {
          return void 0 === b && (b = {}), o(this, void 0, void 0, function () {
            var o, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_commitDuration", a), p.assert.isBigNumber("_revealDuration", r), p.assert.isString("_proposalTitles", n), p.assert.isArray("_details", c), p.assert.isString("_choices", u), p.assert.isArray("_noOfChoices", l), p.assert.isBigNumber("_checkpointId", h), p.assert.doesConformToSchema("callData", b, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== m && p.assert.isBlockParam("defaultBlock", m), y = (o = this)._strictEncodeArguments("createCustomCumulativeBallot(bytes32,uint256,uint256,uint256,string,bytes32[],string,uint256[],uint256)", [e, t, a, r, n, c, u, l, h]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, b, {
                    data: y
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (v = i.sent()).from = v.from ? v.from.toLowerCase() : v.from, [4, o._web3Wrapper.callAsync(v, m)];

                case 2:
                  return _ = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(_), [2, o._lookupAbiEncoder("createCustomCumulativeBallot(bytes32,uint256,uint256,uint256,string,bytes32[],string,uint256[],uint256)").strictDecodeReturnValue(_)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s, o, i, c) {
          return p.assert.isString("_name", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_commitDuration", a), p.assert.isBigNumber("_revealDuration", r), p.assert.isString("_proposalTitles", n), p.assert.isArray("_details", s), p.assert.isString("_choices", o), p.assert.isArray("_noOfChoices", i), p.assert.isBigNumber("_checkpointId", c), this._strictEncodeArguments("createCustomCumulativeBallot(bytes32,uint256,uint256,uint256,string,bytes32[],string,uint256[],uint256)", [e, t, a, r, n, s, o, i, c]);
        }
      }, u.createCumulativeBallot = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u, f, l, h) {
          return o(this, void 0, void 0, function () {
            var o, m, y, v, _, g, A;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_commitDuration", a), p.assert.isBigNumber("_revealDuration", r), p.assert.isString("_proposalTitles", n), p.assert.isArray("_details", c), p.assert.isString("_choices", u), p.assert.isArray("_noOfChoices", f), m = (o = this)._strictEncodeArguments("createCumulativeBallot(bytes32,uint256,uint256,uint256,string,bytes32[],string,uint256[])", [e, t, a, r, n, c, u, f]), y = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return v = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, l, {
                    data: m
                  }), s({
                    from: v
                  }, y), o.createCumulativeBallot.estimateGasAsync.bind(o, e, t, a, r, n, c, u, f, h))];

                case 2:
                  return void 0 !== (_ = i.sent()).from && (_.from = _.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(_)];

                case 3:
                  return g = i.sent(), A = o._web3Wrapper.awaitTransactionSuccessAsync(g), [2, new b.PolyResponse(g, A)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u, f, l, h) {
          return o(this, void 0, void 0, function () {
            var o, b, m, y, v, _, g, A, w;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_commitDuration", a), p.assert.isBigNumber("_revealDuration", r), p.assert.isString("_proposalTitles", n), p.assert.isArray("_details", c), p.assert.isString("_choices", u), p.assert.isArray("_noOfChoices", f), b = (o = this)._strictEncodeArguments("createCumulativeBallot(bytes32,uint256,uint256,uint256,string,bytes32[],string,uint256[])", [e, t, a, r, n, c, u, f]), m = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return y = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, h, {
                    data: b
                  }), s({
                    from: y
                  }, m))];

                case 2:
                  return void 0 !== (v = i.sent()).from && (v.from = v.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(v)];

                case 3:
                  return _ = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return g = i.sent().gasLimit, A = void 0 === l ? o._defaultEstimateGasFactor : l, w = Math.round(A * _), [2, g < w ? g : w];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u, l, h, b) {
          return void 0 === h && (h = {}), o(this, void 0, void 0, function () {
            var o, m, y, v;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_commitDuration", a), p.assert.isBigNumber("_revealDuration", r), p.assert.isString("_proposalTitles", n), p.assert.isArray("_details", c), p.assert.isString("_choices", u), p.assert.isArray("_noOfChoices", l), p.assert.doesConformToSchema("callData", h, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== b && p.assert.isBlockParam("defaultBlock", b), m = (o = this)._strictEncodeArguments("createCumulativeBallot(bytes32,uint256,uint256,uint256,string,bytes32[],string,uint256[])", [e, t, a, r, n, c, u, l]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, h, {
                    data: m
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (y = i.sent()).from = y.from ? y.from.toLowerCase() : y.from, [4, o._web3Wrapper.callAsync(y, b)];

                case 2:
                  return v = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(v), [2, o._lookupAbiEncoder("createCumulativeBallot(bytes32,uint256,uint256,uint256,string,bytes32[],string,uint256[])").strictDecodeReturnValue(v)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s, o, i) {
          return p.assert.isString("_name", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_commitDuration", a), p.assert.isBigNumber("_revealDuration", r), p.assert.isString("_proposalTitles", n), p.assert.isArray("_details", s), p.assert.isString("_choices", o), p.assert.isArray("_noOfChoices", i), this._strictEncodeArguments("createCumulativeBallot(bytes32,uint256,uint256,uint256,string,bytes32[],string,uint256[])", [e, t, a, r, n, s, o, i]);
        }
      }, u.createCustomCumulativeBallotWithExemption = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u, f, l, h, m, y) {
          return o(this, void 0, void 0, function () {
            var o, v, _, g, A, w, T;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_commitDuration", a), p.assert.isBigNumber("_revealDuration", r), p.assert.isString("_proposalTitles", n), p.assert.isArray("_details", c), p.assert.isString("_choices", u), p.assert.isArray("_noOfChoices", f), p.assert.isBigNumber("_checkpointId", l), p.assert.isArray("_exemptedAddresses", h), v = (o = this)._strictEncodeArguments("createCustomCumulativeBallotWithExemption(bytes32,uint256,uint256,uint256,string,bytes32[],string,uint256[],uint256,address[])", [e, t, a, r, n, c, u, f, l, h]), _ = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return g = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, m, {
                    data: v
                  }), s({
                    from: g
                  }, _), o.createCustomCumulativeBallotWithExemption.estimateGasAsync.bind(o, e, t, a, r, n, c, u, f, l, h, y))];

                case 2:
                  return void 0 !== (A = i.sent()).from && (A.from = A.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(A)];

                case 3:
                  return w = i.sent(), T = o._web3Wrapper.awaitTransactionSuccessAsync(w), [2, new b.PolyResponse(w, T)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u, f, l, h, b, m) {
          return o(this, void 0, void 0, function () {
            var o, y, v, _, g, A, w, T, x;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_commitDuration", a), p.assert.isBigNumber("_revealDuration", r), p.assert.isString("_proposalTitles", n), p.assert.isArray("_details", c), p.assert.isString("_choices", u), p.assert.isArray("_noOfChoices", f), p.assert.isBigNumber("_checkpointId", l), p.assert.isArray("_exemptedAddresses", h), y = (o = this)._strictEncodeArguments("createCustomCumulativeBallotWithExemption(bytes32,uint256,uint256,uint256,string,bytes32[],string,uint256[],uint256,address[])", [e, t, a, r, n, c, u, f, l, h]), v = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return _ = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, m, {
                    data: y
                  }), s({
                    from: _
                  }, v))];

                case 2:
                  return void 0 !== (g = i.sent()).from && (g.from = g.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(g)];

                case 3:
                  return A = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return w = i.sent().gasLimit, T = void 0 === b ? o._defaultEstimateGasFactor : b, x = Math.round(T * A), [2, w < x ? w : x];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u, l, h, b, m, y) {
          return void 0 === m && (m = {}), o(this, void 0, void 0, function () {
            var o, v, _, g;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_commitDuration", a), p.assert.isBigNumber("_revealDuration", r), p.assert.isString("_proposalTitles", n), p.assert.isArray("_details", c), p.assert.isString("_choices", u), p.assert.isArray("_noOfChoices", l), p.assert.isBigNumber("_checkpointId", h), p.assert.isArray("_exemptedAddresses", b), p.assert.doesConformToSchema("callData", m, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== y && p.assert.isBlockParam("defaultBlock", y), v = (o = this)._strictEncodeArguments("createCustomCumulativeBallotWithExemption(bytes32,uint256,uint256,uint256,string,bytes32[],string,uint256[],uint256,address[])", [e, t, a, r, n, c, u, l, h, b]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, m, {
                    data: v
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (_ = i.sent()).from = _.from ? _.from.toLowerCase() : _.from, [4, o._web3Wrapper.callAsync(_, y)];

                case 2:
                  return g = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(g), [2, o._lookupAbiEncoder("createCustomCumulativeBallotWithExemption(bytes32,uint256,uint256,uint256,string,bytes32[],string,uint256[],uint256,address[])").strictDecodeReturnValue(g)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s, o, i, c, u) {
          return p.assert.isString("_name", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_commitDuration", a), p.assert.isBigNumber("_revealDuration", r), p.assert.isString("_proposalTitles", n), p.assert.isArray("_details", s), p.assert.isString("_choices", o), p.assert.isArray("_noOfChoices", i), p.assert.isBigNumber("_checkpointId", c), p.assert.isArray("_exemptedAddresses", u), this._strictEncodeArguments("createCustomCumulativeBallotWithExemption(bytes32,uint256,uint256,uint256,string,bytes32[],string,uint256[],uint256,address[])", [e, t, a, r, n, s, o, i, c, u]);
        }
      }, u.createCumulativeBallotWithExemption = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u, f, l, h, m) {
          return o(this, void 0, void 0, function () {
            var o, y, v, _, g, A, w;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_commitDuration", a), p.assert.isBigNumber("_revealDuration", r), p.assert.isString("_proposalTitles", n), p.assert.isArray("_details", c), p.assert.isString("_choices", u), p.assert.isArray("_noOfChoices", f), p.assert.isArray("_exemptedAddresses", l), y = (o = this)._strictEncodeArguments("createCumulativeBallotWithExemption(bytes32,uint256,uint256,uint256,string,bytes32[],string,uint256[],address[])", [e, t, a, r, n, c, u, f, l]), v = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return _ = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, h, {
                    data: y
                  }), s({
                    from: _
                  }, v), o.createCumulativeBallotWithExemption.estimateGasAsync.bind(o, e, t, a, r, n, c, u, f, l, m))];

                case 2:
                  return void 0 !== (g = i.sent()).from && (g.from = g.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(g)];

                case 3:
                  return A = i.sent(), w = o._web3Wrapper.awaitTransactionSuccessAsync(A), [2, new b.PolyResponse(A, w)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u, f, l, h, b) {
          return o(this, void 0, void 0, function () {
            var o, m, y, v, _, g, A, w, T;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_commitDuration", a), p.assert.isBigNumber("_revealDuration", r), p.assert.isString("_proposalTitles", n), p.assert.isArray("_details", c), p.assert.isString("_choices", u), p.assert.isArray("_noOfChoices", f), p.assert.isArray("_exemptedAddresses", l), m = (o = this)._strictEncodeArguments("createCumulativeBallotWithExemption(bytes32,uint256,uint256,uint256,string,bytes32[],string,uint256[],address[])", [e, t, a, r, n, c, u, f, l]), y = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return v = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, b, {
                    data: m
                  }), s({
                    from: v
                  }, y))];

                case 2:
                  return void 0 !== (_ = i.sent()).from && (_.from = _.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(_)];

                case 3:
                  return g = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return A = i.sent().gasLimit, w = void 0 === h ? o._defaultEstimateGasFactor : h, T = Math.round(w * g), [2, A < T ? A : T];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u, l, h, b, m) {
          return void 0 === b && (b = {}), o(this, void 0, void 0, function () {
            var o, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_commitDuration", a), p.assert.isBigNumber("_revealDuration", r), p.assert.isString("_proposalTitles", n), p.assert.isArray("_details", c), p.assert.isString("_choices", u), p.assert.isArray("_noOfChoices", l), p.assert.isArray("_exemptedAddresses", h), p.assert.doesConformToSchema("callData", b, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== m && p.assert.isBlockParam("defaultBlock", m), y = (o = this)._strictEncodeArguments("createCumulativeBallotWithExemption(bytes32,uint256,uint256,uint256,string,bytes32[],string,uint256[],address[])", [e, t, a, r, n, c, u, l, h]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, b, {
                    data: y
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (v = i.sent()).from = v.from ? v.from.toLowerCase() : v.from, [4, o._web3Wrapper.callAsync(v, m)];

                case 2:
                  return _ = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(_), [2, o._lookupAbiEncoder("createCumulativeBallotWithExemption(bytes32,uint256,uint256,uint256,string,bytes32[],string,uint256[],address[])").strictDecodeReturnValue(_)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s, o, i, c) {
          return p.assert.isString("_name", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_commitDuration", a), p.assert.isBigNumber("_revealDuration", r), p.assert.isString("_proposalTitles", n), p.assert.isArray("_details", s), p.assert.isString("_choices", o), p.assert.isArray("_noOfChoices", i), p.assert.isArray("_exemptedAddresses", c), this._strictEncodeArguments("createCumulativeBallotWithExemption(bytes32,uint256,uint256,uint256,string,bytes32[],string,uint256[],address[])", [e, t, a, r, n, s, o, i, c]);
        }
      }, u.createStatutoryBallotWithExemption = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u, f, l, h, m) {
          return o(this, void 0, void 0, function () {
            var o, y, v, _, g, A, w;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_commitDuration", a), p.assert.isBigNumber("_revealDuration", r), p.assert.isString("_proposalTitle", n), p.assert.isString("_details", c), p.assert.isString("_choices", u), p.assert.isBigNumber("_noOfChoices", f), p.assert.isArray("_exemptedAddresses", l), y = (o = this)._strictEncodeArguments("createStatutoryBallotWithExemption(bytes32,uint256,uint256,uint256,string,bytes32,string,uint256,address[])", [e, t, a, r, n, c, u, f, l]), v = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return _ = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, h, {
                    data: y
                  }), s({
                    from: _
                  }, v), o.createStatutoryBallotWithExemption.estimateGasAsync.bind(o, e, t, a, r, n, c, u, f, l, m))];

                case 2:
                  return void 0 !== (g = i.sent()).from && (g.from = g.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(g)];

                case 3:
                  return A = i.sent(), w = o._web3Wrapper.awaitTransactionSuccessAsync(A), [2, new b.PolyResponse(A, w)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u, f, l, h, b) {
          return o(this, void 0, void 0, function () {
            var o, m, y, v, _, g, A, w, T;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_commitDuration", a), p.assert.isBigNumber("_revealDuration", r), p.assert.isString("_proposalTitle", n), p.assert.isString("_details", c), p.assert.isString("_choices", u), p.assert.isBigNumber("_noOfChoices", f), p.assert.isArray("_exemptedAddresses", l), m = (o = this)._strictEncodeArguments("createStatutoryBallotWithExemption(bytes32,uint256,uint256,uint256,string,bytes32,string,uint256,address[])", [e, t, a, r, n, c, u, f, l]), y = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return v = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, b, {
                    data: m
                  }), s({
                    from: v
                  }, y))];

                case 2:
                  return void 0 !== (_ = i.sent()).from && (_.from = _.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(_)];

                case 3:
                  return g = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return A = i.sent().gasLimit, w = void 0 === h ? o._defaultEstimateGasFactor : h, T = Math.round(w * g), [2, A < T ? A : T];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u, l, h, b, m) {
          return void 0 === b && (b = {}), o(this, void 0, void 0, function () {
            var o, y, v, _;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_commitDuration", a), p.assert.isBigNumber("_revealDuration", r), p.assert.isString("_proposalTitle", n), p.assert.isString("_details", c), p.assert.isString("_choices", u), p.assert.isBigNumber("_noOfChoices", l), p.assert.isArray("_exemptedAddresses", h), p.assert.doesConformToSchema("callData", b, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== m && p.assert.isBlockParam("defaultBlock", m), y = (o = this)._strictEncodeArguments("createStatutoryBallotWithExemption(bytes32,uint256,uint256,uint256,string,bytes32,string,uint256,address[])", [e, t, a, r, n, c, u, l, h]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, b, {
                    data: y
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (v = i.sent()).from = v.from ? v.from.toLowerCase() : v.from, [4, o._web3Wrapper.callAsync(v, m)];

                case 2:
                  return _ = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(_), [2, o._lookupAbiEncoder("createStatutoryBallotWithExemption(bytes32,uint256,uint256,uint256,string,bytes32,string,uint256,address[])").strictDecodeReturnValue(_)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s, o, i, c) {
          return p.assert.isString("_name", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_commitDuration", a), p.assert.isBigNumber("_revealDuration", r), p.assert.isString("_proposalTitle", n), p.assert.isString("_details", s), p.assert.isString("_choices", o), p.assert.isBigNumber("_noOfChoices", i), p.assert.isArray("_exemptedAddresses", c), this._strictEncodeArguments("createStatutoryBallotWithExemption(bytes32,uint256,uint256,uint256,string,bytes32,string,uint256,address[])", [e, t, a, r, n, s, o, i, c]);
        }
      }, u.createCustomStatutoryBallotWithExemption = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n, c, u, f, l, h, m, y) {
          return o(this, void 0, void 0, function () {
            var o, v, _, g, A, w, T;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_commitDuration", a), p.assert.isBigNumber("_revealDuration", r), p.assert.isString("_proposalTitle", n), p.assert.isString("_details", c), p.assert.isString("_choices", u), p.assert.isBigNumber("_noOfChoices", f), p.assert.isBigNumber("_checkpointId", l), p.assert.isArray("_exemptedAddresses", h), v = (o = this)._strictEncodeArguments("createCustomStatutoryBallotWithExemption(bytes32,uint256,uint256,uint256,string,bytes32,string,uint256,uint256,address[])", [e, t, a, r, n, c, u, f, l, h]), _ = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return g = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, m, {
                    data: v
                  }), s({
                    from: g
                  }, _), o.createCustomStatutoryBallotWithExemption.estimateGasAsync.bind(o, e, t, a, r, n, c, u, f, l, h, y))];

                case 2:
                  return void 0 !== (A = i.sent()).from && (A.from = A.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(A)];

                case 3:
                  return w = i.sent(), T = o._web3Wrapper.awaitTransactionSuccessAsync(w), [2, new b.PolyResponse(w, T)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n, c, u, f, l, h, b, m) {
          return o(this, void 0, void 0, function () {
            var o, y, v, _, g, A, w, T, x;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_commitDuration", a), p.assert.isBigNumber("_revealDuration", r), p.assert.isString("_proposalTitle", n), p.assert.isString("_details", c), p.assert.isString("_choices", u), p.assert.isBigNumber("_noOfChoices", f), p.assert.isBigNumber("_checkpointId", l), p.assert.isArray("_exemptedAddresses", h), y = (o = this)._strictEncodeArguments("createCustomStatutoryBallotWithExemption(bytes32,uint256,uint256,uint256,string,bytes32,string,uint256,uint256,address[])", [e, t, a, r, n, c, u, f, l, h]), v = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return _ = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, m, {
                    data: y
                  }), s({
                    from: _
                  }, v))];

                case 2:
                  return void 0 !== (g = i.sent()).from && (g.from = g.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(g)];

                case 3:
                  return A = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return w = i.sent().gasLimit, T = void 0 === b ? o._defaultEstimateGasFactor : b, x = Math.round(T * A), [2, w < x ? w : x];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n, c, u, l, h, b, m, y) {
          return void 0 === m && (m = {}), o(this, void 0, void 0, function () {
            var o, v, _, g;

            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_name", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_commitDuration", a), p.assert.isBigNumber("_revealDuration", r), p.assert.isString("_proposalTitle", n), p.assert.isString("_details", c), p.assert.isString("_choices", u), p.assert.isBigNumber("_noOfChoices", l), p.assert.isBigNumber("_checkpointId", h), p.assert.isArray("_exemptedAddresses", b), p.assert.doesConformToSchema("callData", m, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== y && p.assert.isBlockParam("defaultBlock", y), v = (o = this)._strictEncodeArguments("createCustomStatutoryBallotWithExemption(bytes32,uint256,uint256,uint256,string,bytes32,string,uint256,uint256,address[])", [e, t, a, r, n, c, u, l, h, b]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, m, {
                    data: v
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (_ = i.sent()).from = _.from ? _.from.toLowerCase() : _.from, [4, o._web3Wrapper.callAsync(_, y)];

                case 2:
                  return g = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(g), [2, o._lookupAbiEncoder("createCustomStatutoryBallotWithExemption(bytes32,uint256,uint256,uint256,string,bytes32,string,uint256,uint256,address[])").strictDecodeReturnValue(g)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a, r, n, s, o, i, c, u) {
          return p.assert.isString("_name", e), p.assert.isBigNumber("_startTime", t), p.assert.isBigNumber("_commitDuration", a), p.assert.isBigNumber("_revealDuration", r), p.assert.isString("_proposalTitle", n), p.assert.isString("_details", s), p.assert.isString("_choices", o), p.assert.isBigNumber("_noOfChoices", i), p.assert.isBigNumber("_checkpointId", c), p.assert.isArray("_exemptedAddresses", u), this._strictEncodeArguments("createCustomStatutoryBallotWithExemption(bytes32,uint256,uint256,uint256,string,bytes32,string,uint256,uint256,address[])", [e, t, a, r, n, s, o, i, c, u]);
        }
      }, u.commitVote = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isString("_secretVote", t), o = (n = this)._strictEncodeArguments("commitVote(uint256,bytes32)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.commitVote.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isString("_secretVote", t), o = (n = this)._strictEncodeArguments("commitVote(uint256,bytes32)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isString("_secretVote", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("commitVote(uint256,bytes32)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("commitVote(uint256,bytes32)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isBigNumber("_ballotId", e), p.assert.isString("_secretVote", t), this._strictEncodeArguments("commitVote(uint256,bytes32)", [e, t]);
        }
      }, u.revealVote = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isArray("_choices", t), p.assert.isBigNumber("_salt", a), c = (o = this)._strictEncodeArguments("revealVote(uint256,uint256[],uint256)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.revealVote.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isArray("_choices", t), p.assert.isBigNumber("_salt", a), c = (o = this)._strictEncodeArguments("revealVote(uint256,uint256[],uint256)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isArray("_choices", t), p.assert.isBigNumber("_salt", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("revealVote(uint256,uint256[],uint256)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("revealVote(uint256,uint256[],uint256)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isBigNumber("_ballotId", e), p.assert.isArray("_choices", t), p.assert.isBigNumber("_salt", a), this._strictEncodeArguments("revealVote(uint256,uint256[],uint256)", [e, t, a]);
        }
      }, u.cancelBallot = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), n = (r = this)._strictEncodeArguments("cancelBallot(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), s({
                    from: c
                  }, o), r.cancelBallot.estimateGasAsync.bind(r, e, a))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.sendTransactionAsync(u)];

                case 3:
                  return f = i.sent(), l = r._web3Wrapper.awaitTransactionSuccessAsync(f), [2, new b.PolyResponse(f, l)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a) {
          return o(this, void 0, void 0, function () {
            var r, n, o, c, u, f, l, h, b;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), n = (r = this)._strictEncodeArguments("cancelBallot(uint256)", [e]), o = r._web3Wrapper.getContractDefaults(), [4, r._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return c = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, a, {
                    data: n
                  }), s({
                    from: c
                  }, o))];

                case 2:
                  return void 0 !== (u = i.sent()).from && (u.from = u.from.toLowerCase()), [4, r._web3Wrapper.estimateGasAsync(u)];

                case 3:
                  return f = i.sent(), [4, r._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return l = i.sent().gasLimit, h = void 0 === t ? r._defaultEstimateGasFactor : t, b = Math.round(h * f), [2, l < b ? l : b];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("cancelBallot(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("cancelBallot(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_ballotId", e), this._strictEncodeArguments("cancelBallot(uint256)", [e]);
        }
      }, u.changeBallotExemptedVotersList = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isString("_exemptedAddress", t), p.assert.isBoolean("_exempt", a), c = (o = this)._strictEncodeArguments("changeBallotExemptedVotersList(uint256,address,bool)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.changeBallotExemptedVotersList.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isString("_exemptedAddress", t), p.assert.isBoolean("_exempt", a), c = (o = this)._strictEncodeArguments("changeBallotExemptedVotersList(uint256,address,bool)", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isString("_exemptedAddress", t), p.assert.isBoolean("_exempt", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("changeBallotExemptedVotersList(uint256,address,bool)", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("changeBallotExemptedVotersList(uint256,address,bool)").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isBigNumber("_ballotId", e), p.assert.isString("_exemptedAddress", t), p.assert.isBoolean("_exempt", a), this._strictEncodeArguments("changeBallotExemptedVotersList(uint256,address,bool)", [e, t, a]);
        }
      }, u.changeBallotExemptedVotersListMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isArray("_exemptedAddresses", t), p.assert.isArray("_exempts", a), c = (o = this)._strictEncodeArguments("changeBallotExemptedVotersListMulti(uint256,address[],bool[])", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), s({
                    from: f
                  }, u), o.changeBallotExemptedVotersListMulti.estimateGasAsync.bind(o, e, t, a, n))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.sendTransactionAsync(l)];

                case 3:
                  return h = i.sent(), m = o._web3Wrapper.awaitTransactionSuccessAsync(h), [2, new b.PolyResponse(h, m)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r, n) {
          return o(this, void 0, void 0, function () {
            var o, c, u, f, l, h, b, m, y;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isArray("_exemptedAddresses", t), p.assert.isArray("_exempts", a), c = (o = this)._strictEncodeArguments("changeBallotExemptedVotersListMulti(uint256,address[],bool[])", [e, t, a]), u = o._web3Wrapper.getContractDefaults(), [4, o._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return f = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, n, {
                    data: c
                  }), s({
                    from: f
                  }, u))];

                case 2:
                  return void 0 !== (l = i.sent()).from && (l.from = l.from.toLowerCase()), [4, o._web3Wrapper.estimateGasAsync(l)];

                case 3:
                  return h = i.sent(), [4, o._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return b = i.sent().gasLimit, m = void 0 === r ? o._defaultEstimateGasFactor : r, y = Math.round(m * h), [2, b < y ? b : y];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r, n) {
          return void 0 === r && (r = {}), o(this, void 0, void 0, function () {
            var o, c, u, l;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isArray("_exemptedAddresses", t), p.assert.isArray("_exempts", a), p.assert.doesConformToSchema("callData", r, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== n && p.assert.isBlockParam("defaultBlock", n), c = (o = this)._strictEncodeArguments("changeBallotExemptedVotersListMulti(uint256,address[],bool[])", [e, t, a]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: o.address
                  }, r, {
                    data: c
                  }), o._web3Wrapper.getContractDefaults())];

                case 1:
                  return (u = i.sent()).from = u.from ? u.from.toLowerCase() : u.from, [4, o._web3Wrapper.callAsync(u, n)];

                case 2:
                  return l = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(l), [2, o._lookupAbiEncoder("changeBallotExemptedVotersListMulti(uint256,address[],bool[])").strictDecodeReturnValue(l)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t, a) {
          return p.assert.isBigNumber("_ballotId", e), p.assert.isArray("_exemptedAddresses", t), p.assert.isArray("_exempts", a), this._strictEncodeArguments("changeBallotExemptedVotersListMulti(uint256,address[],bool[])", [e, t, a]);
        }
      }, u.changeDefaultExemptedVotersList = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_voter", e), p.assert.isBoolean("_exempt", t), o = (n = this)._strictEncodeArguments("changeDefaultExemptedVotersList(address,bool)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.changeDefaultExemptedVotersList.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_voter", e), p.assert.isBoolean("_exempt", t), o = (n = this)._strictEncodeArguments("changeDefaultExemptedVotersList(address,bool)", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_voter", e), p.assert.isBoolean("_exempt", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("changeDefaultExemptedVotersList(address,bool)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("changeDefaultExemptedVotersList(address,bool)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_voter", e), p.assert.isBoolean("_exempt", t), this._strictEncodeArguments("changeDefaultExemptedVotersList(address,bool)", [e, t]);
        }
      }, u.changeDefaultExemptedVotersListMulti = {
        sendTransactionAsync: function sendTransactionAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_voters", e), p.assert.isArray("_exempts", t), o = (n = this)._strictEncodeArguments("changeDefaultExemptedVotersListMulti(address[],bool[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), s({
                    from: u
                  }, c), n.changeDefaultExemptedVotersListMulti.estimateGasAsync.bind(n, e, t, r))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.sendTransactionAsync(f)];

                case 3:
                  return l = i.sent(), h = n._web3Wrapper.awaitTransactionSuccessAsync(l), [2, new b.PolyResponse(l, h)];
              }
            });
          });
        },
        estimateGasAsync: function estimateGasAsync(e, t, a, r) {
          return o(this, void 0, void 0, function () {
            var n, o, c, u, f, l, h, b, m;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_voters", e), p.assert.isArray("_exempts", t), o = (n = this)._strictEncodeArguments("changeDefaultExemptedVotersListMulti(address[],bool[])", [e, t]), c = n._web3Wrapper.getContractDefaults(), [4, n._web3Wrapper.getAvailableAddressesAsync()];

                case 1:
                  return u = i.sent()[0], [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, r, {
                    data: o
                  }), s({
                    from: u
                  }, c))];

                case 2:
                  return void 0 !== (f = i.sent()).from && (f.from = f.from.toLowerCase()), [4, n._web3Wrapper.estimateGasAsync(f)];

                case 3:
                  return l = i.sent(), [4, n._web3Wrapper.getBlockWithTransactionDataAsync("latest")];

                case 4:
                  return h = i.sent().gasLimit, b = void 0 === a ? n._defaultEstimateGasFactor : a, m = Math.round(b * l), [2, h < m ? h : m];
              }
            });
          });
        },
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isArray("_voters", e), p.assert.isArray("_exempts", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("changeDefaultExemptedVotersListMulti(address[],bool[])", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("changeDefaultExemptedVotersListMulti(address[],bool[])").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isArray("_voters", e), p.assert.isArray("_exempts", t), this._strictEncodeArguments("changeDefaultExemptedVotersListMulti(address[],bool[])", [e, t]);
        }
      }, u.getCheckpointData = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_checkpointId", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getCheckpointData(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getCheckpointData(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_checkpointId", e), this._strictEncodeArguments("getCheckpointData(uint256)", [e]);
        }
      }, u.getPendingInvestorToVote = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getPendingInvestorToVote(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getPendingInvestorToVote(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_ballotId", e), this._strictEncodeArguments("getPendingInvestorToVote(uint256)", [e]);
        }
      }, u.getCommitedVoteCount = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getCommitedVoteCount(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getCommitedVoteCount(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_ballotId", e), this._strictEncodeArguments("getCommitedVoteCount(uint256)", [e]);
        }
      }, u.getAllowedVotersByBallot = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getAllowedVotersByBallot(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getAllowedVotersByBallot(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_ballotId", e), this._strictEncodeArguments("getAllowedVotersByBallot(uint256)", [e]);
        }
      }, u.getAllBallots = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getAllBallots()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getAllBallots()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getAllBallots()", []);
        }
      }, u.getExemptedVotersByBallot = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getExemptedVotersByBallot(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getExemptedVotersByBallot(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_ballotId", e), this._strictEncodeArguments("getExemptedVotersByBallot(uint256)", [e]);
        }
      }, u.pendingBallots = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_voter", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("pendingBallots(address)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("pendingBallots(address)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isString("_voter", e), this._strictEncodeArguments("pendingBallots(address)", [e]);
        }
      }, u.getCurrentBallotStage = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getCurrentBallotStage(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getCurrentBallotStage(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_ballotId", e), this._strictEncodeArguments("getCurrentBallotStage(uint256)", [e]);
        }
      }, u.getVoteTokenCount = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isString("_voter", e), p.assert.isBigNumber("_ballotId", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("getVoteTokenCount(address,uint256)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("getVoteTokenCount(address,uint256)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isString("_voter", e), p.assert.isBigNumber("_ballotId", t), this._strictEncodeArguments("getVoteTokenCount(address,uint256)", [e, t]);
        }
      }, u.getBallotResults = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getBallotResults(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getBallotResults(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_ballotId", e), this._strictEncodeArguments("getBallotResults(uint256)", [e]);
        }
      }, u.getBallotDetails = {
        callAsync: function callAsync(e, t, a) {
          return void 0 === t && (t = {}), o(this, void 0, void 0, function () {
            var r, n, o, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.doesConformToSchema("callData", t, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== a && p.assert.isBlockParam("defaultBlock", a), n = (r = this)._strictEncodeArguments("getBallotDetails(uint256)", [e]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: r.address
                  }, t, {
                    data: n
                  }), r._web3Wrapper.getContractDefaults())];

                case 1:
                  return (o = i.sent()).from = o.from ? o.from.toLowerCase() : o.from, [4, r._web3Wrapper.callAsync(o, a)];

                case 2:
                  return c = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(c), [2, r._lookupAbiEncoder("getBallotDetails(uint256)").strictDecodeReturnValue(c)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e) {
          return p.assert.isBigNumber("_ballotId", e), this._strictEncodeArguments("getBallotDetails(uint256)", [e]);
        }
      }, u.getBallotsArrayLength = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getBallotsArrayLength()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getBallotsArrayLength()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getBallotsArrayLength()", []);
        }
      }, u.isVoterAllowed = {
        callAsync: function callAsync(e, t, a, r) {
          return void 0 === a && (a = {}), o(this, void 0, void 0, function () {
            var n, o, c, u;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.isBigNumber("_ballotId", e), p.assert.isString("_voter", t), p.assert.doesConformToSchema("callData", a, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== r && p.assert.isBlockParam("defaultBlock", r), o = (n = this)._strictEncodeArguments("isVoterAllowed(uint256,address)", [e, t]), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: n.address
                  }, a, {
                    data: o
                  }), n._web3Wrapper.getContractDefaults())];

                case 1:
                  return (c = i.sent()).from = c.from ? c.from.toLowerCase() : c.from, [4, n._web3Wrapper.callAsync(c, r)];

                case 2:
                  return u = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(u), [2, n._lookupAbiEncoder("isVoterAllowed(uint256,address)").strictDecodeReturnValue(u)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData(e, t) {
          return p.assert.isBigNumber("_ballotId", e), p.assert.isString("_voter", t), this._strictEncodeArguments("isVoterAllowed(uint256,address)", [e, t]);
        }
      }, u.getInitFunction = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getInitFunction()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getInitFunction()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getInitFunction()", []);
        }
      }, u.getPermissions = {
        callAsync: function callAsync(e, t) {
          return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
            var a, r, n, o;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return p.assert.doesConformToSchema("callData", e, f.schemas.callDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), void 0 !== t && p.assert.isBlockParam("defaultBlock", t), r = (a = this)._strictEncodeArguments("getPermissions()", []), [4, d.BaseContract._applyDefaultsToTxDataAsync(s({
                    to: a.address
                  }, e, {
                    data: r
                  }), a._web3Wrapper.getContractDefaults())];

                case 1:
                  return (n = i.sent()).from = n.from ? n.from.toLowerCase() : n.from, [4, a._web3Wrapper.callAsync(n, t)];

                case 2:
                  return o = i.sent(), d.BaseContract._throwIfRevertWithReasonCallResult(o), [2, a._lookupAbiEncoder("getPermissions()").strictDecodeReturnValue(o)];
              }
            });
          });
        },
        getABIEncodedTransactionData: function getABIEncodedTransactionData() {
          return this._strictEncodeArguments("getPermissions()", []);
        }
      }, u._defaultEstimateGasFactor = void 0 === c ? 1.1 : c, l.classUtils.bindAll(u, ["_abiEncoderByFunctionSignature", "address", "_web3Wrapper", "_defaultEstimateGasFactor"]), u;
    }

    return n(t, e), t.deployAsync = function (e, a, r, n, s, u) {
      return o(this, void 0, void 0, function () {
        var o, b, m, v, _, g, A, w, T, x, D;

        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return p.assert.isHexString("bytecode", e), p.assert.doesConformToSchema("txDefaults", n, f.schemas.txDataSchema, [f.schemas.addressSchema, f.schemas.numberSchema, f.schemas.jsNumber]), o = l.providerUtils.standardizeOrThrow(r), b = d.BaseContract._lookupConstructorAbi(a), D = c(d.BaseContract._formatABIDataItemList(b.inputs, [s, u], d.BaseContract._bigNumberToString), 2), s = D[0], u = D[1], m = new y.utils.Interface(a), v = m.deployFunction, _ = v.encode(e, [s, u]), g = new h.Web3Wrapper(o), [4, d.BaseContract._applyDefaultsToTxDataAsync({
                data: _
              }, n, g.estimateGasAsync.bind(g))];

            case 1:
              return A = i.sent(), [4, g.sendTransactionAsync(A)];

            case 2:
              return w = i.sent(), l.logUtils.log("transactionHash: " + w), [4, g.awaitTransactionSuccessAsync(w)];

            case 3:
              return T = i.sent(), l.logUtils.log("AdvancedPLCRVotingCheckpoint successfully deployed at " + T.contractAddress), (x = new t(T.contractAddress, o, n)).constructorArgs = [s, u], [2, x];
          }
        });
      });
    }, t.ABI = function () {
      return [{
        constant: !1,
        inputs: [],
        name: "reclaimETH",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "ADMIN",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "unpause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "paused",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "polyToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDefaultExemptionVotersList",
        outputs: [{
          name: "",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !1,
        inputs: [],
        name: "pause",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_tokenContract",
          type: "address"
        }],
        name: "reclaimERC20",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "OPERATOR",
        outputs: [{
          name: "",
          type: "bytes32"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "securityToken",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "factory",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getDataStore",
        outputs: [{
          name: "",
          type: "address"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        inputs: [{
          name: "_securityToken",
          type: "address"
        }, {
          name: "_polyAddress",
          type: "address"
        }],
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "constructor"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_ballotId",
          type: "uint256",
          indexed: !0
        }, {
          name: "_checkpointId",
          type: "uint256",
          indexed: !0
        }, {
          name: "_name",
          type: "bytes32",
          indexed: !0
        }, {
          name: "_startTime",
          type: "uint256",
          indexed: !1
        }, {
          name: "_commitDuration",
          type: "uint256",
          indexed: !1
        }, {
          name: "_revealDuration",
          type: "uint256",
          indexed: !1
        }, {
          name: "_details",
          type: "bytes32",
          indexed: !1
        }, {
          name: "_noOfChoices",
          type: "uint256",
          indexed: !1
        }, {
          name: "_proposalTitle",
          type: "string",
          indexed: !1
        }, {
          name: "_choices",
          type: "string",
          indexed: !1
        }],
        name: "StatutoryBallotCreated",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_ballotId",
          type: "uint256",
          indexed: !0
        }, {
          name: "_checkpointId",
          type: "uint256",
          indexed: !0
        }, {
          name: "_name",
          type: "bytes32",
          indexed: !0
        }, {
          name: "_startTime",
          type: "uint256",
          indexed: !1
        }, {
          name: "_commitDuration",
          type: "uint256",
          indexed: !1
        }, {
          name: "_revealDuration",
          type: "uint256",
          indexed: !1
        }, {
          name: "_details",
          type: "bytes32[]",
          indexed: !1
        }, {
          name: "_noOfChoices",
          type: "uint256[]",
          indexed: !1
        }, {
          name: "_proposalTitle",
          type: "string",
          indexed: !1
        }, {
          name: "_choices",
          type: "string",
          indexed: !1
        }],
        name: "CumulativeBallotCreated",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_ballotId",
          type: "uint256",
          indexed: !0
        }, {
          name: "_exemptedAddresses",
          type: "address[]",
          indexed: !1
        }],
        name: "VotersExempted",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_voter",
          type: "address",
          indexed: !0
        }, {
          name: "_weight",
          type: "uint256",
          indexed: !1
        }, {
          name: "_ballotId",
          type: "uint256",
          indexed: !1
        }, {
          name: "_secretHash",
          type: "bytes32",
          indexed: !1
        }],
        name: "VoteCommit",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_voter",
          type: "address",
          indexed: !0
        }, {
          name: "_weight",
          type: "uint256",
          indexed: !1
        }, {
          name: "_ballotId",
          type: "uint256",
          indexed: !0
        }, {
          name: "_choices",
          type: "uint256[]",
          indexed: !1
        }, {
          name: "_salt",
          type: "uint256",
          indexed: !1
        }],
        name: "VoteRevealed",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_ballotId",
          type: "uint256",
          indexed: !0
        }],
        name: "BallotCancelled",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_ballotId",
          type: "uint256",
          indexed: !0
        }, {
          name: "_exemptedAddress",
          type: "address",
          indexed: !1
        }, {
          name: "_exempt",
          type: "bool",
          indexed: !1
        }],
        name: "ChangedBallotExemptedVotersList",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "_voter",
          type: "address",
          indexed: !0
        }, {
          name: "_exempt",
          type: "bool",
          indexed: !1
        }],
        name: "ChangedDefaultExemptedVotersList",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Pause",
        outputs: [],
        type: "event"
      }, {
        anonymous: !1,
        inputs: [{
          name: "account",
          type: "address",
          indexed: !1
        }],
        name: "Unpause",
        outputs: [],
        type: "event"
      }, {
        constant: !1,
        inputs: [{
          name: "_name",
          type: "bytes32"
        }, {
          name: "_startTime",
          type: "uint256"
        }, {
          name: "_commitDuration",
          type: "uint256"
        }, {
          name: "_revealDuration",
          type: "uint256"
        }, {
          name: "_proposalTitle",
          type: "string"
        }, {
          name: "_details",
          type: "bytes32"
        }, {
          name: "_choices",
          type: "string"
        }, {
          name: "_noOfChoices",
          type: "uint256"
        }],
        name: "createStatutoryBallot",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_name",
          type: "bytes32"
        }, {
          name: "_startTime",
          type: "uint256"
        }, {
          name: "_commitDuration",
          type: "uint256"
        }, {
          name: "_revealDuration",
          type: "uint256"
        }, {
          name: "_proposalTitle",
          type: "string"
        }, {
          name: "_details",
          type: "bytes32"
        }, {
          name: "_choices",
          type: "string"
        }, {
          name: "_noOfChoices",
          type: "uint256"
        }, {
          name: "_checkpointId",
          type: "uint256"
        }],
        name: "createCustomStatutoryBallot",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_name",
          type: "bytes32"
        }, {
          name: "_startTime",
          type: "uint256"
        }, {
          name: "_commitDuration",
          type: "uint256"
        }, {
          name: "_revealDuration",
          type: "uint256"
        }, {
          name: "_proposalTitles",
          type: "string"
        }, {
          name: "_details",
          type: "bytes32[]"
        }, {
          name: "_choices",
          type: "string"
        }, {
          name: "_noOfChoices",
          type: "uint256[]"
        }, {
          name: "_checkpointId",
          type: "uint256"
        }],
        name: "createCustomCumulativeBallot",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_name",
          type: "bytes32"
        }, {
          name: "_startTime",
          type: "uint256"
        }, {
          name: "_commitDuration",
          type: "uint256"
        }, {
          name: "_revealDuration",
          type: "uint256"
        }, {
          name: "_proposalTitles",
          type: "string"
        }, {
          name: "_details",
          type: "bytes32[]"
        }, {
          name: "_choices",
          type: "string"
        }, {
          name: "_noOfChoices",
          type: "uint256[]"
        }],
        name: "createCumulativeBallot",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_name",
          type: "bytes32"
        }, {
          name: "_startTime",
          type: "uint256"
        }, {
          name: "_commitDuration",
          type: "uint256"
        }, {
          name: "_revealDuration",
          type: "uint256"
        }, {
          name: "_proposalTitles",
          type: "string"
        }, {
          name: "_details",
          type: "bytes32[]"
        }, {
          name: "_choices",
          type: "string"
        }, {
          name: "_noOfChoices",
          type: "uint256[]"
        }, {
          name: "_checkpointId",
          type: "uint256"
        }, {
          name: "_exemptedAddresses",
          type: "address[]"
        }],
        name: "createCustomCumulativeBallotWithExemption",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_name",
          type: "bytes32"
        }, {
          name: "_startTime",
          type: "uint256"
        }, {
          name: "_commitDuration",
          type: "uint256"
        }, {
          name: "_revealDuration",
          type: "uint256"
        }, {
          name: "_proposalTitles",
          type: "string"
        }, {
          name: "_details",
          type: "bytes32[]"
        }, {
          name: "_choices",
          type: "string"
        }, {
          name: "_noOfChoices",
          type: "uint256[]"
        }, {
          name: "_exemptedAddresses",
          type: "address[]"
        }],
        name: "createCumulativeBallotWithExemption",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_name",
          type: "bytes32"
        }, {
          name: "_startTime",
          type: "uint256"
        }, {
          name: "_commitDuration",
          type: "uint256"
        }, {
          name: "_revealDuration",
          type: "uint256"
        }, {
          name: "_proposalTitle",
          type: "string"
        }, {
          name: "_details",
          type: "bytes32"
        }, {
          name: "_choices",
          type: "string"
        }, {
          name: "_noOfChoices",
          type: "uint256"
        }, {
          name: "_exemptedAddresses",
          type: "address[]"
        }],
        name: "createStatutoryBallotWithExemption",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_name",
          type: "bytes32"
        }, {
          name: "_startTime",
          type: "uint256"
        }, {
          name: "_commitDuration",
          type: "uint256"
        }, {
          name: "_revealDuration",
          type: "uint256"
        }, {
          name: "_proposalTitle",
          type: "string"
        }, {
          name: "_details",
          type: "bytes32"
        }, {
          name: "_choices",
          type: "string"
        }, {
          name: "_noOfChoices",
          type: "uint256"
        }, {
          name: "_checkpointId",
          type: "uint256"
        }, {
          name: "_exemptedAddresses",
          type: "address[]"
        }],
        name: "createCustomStatutoryBallotWithExemption",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_ballotId",
          type: "uint256"
        }, {
          name: "_secretVote",
          type: "bytes32"
        }],
        name: "commitVote",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_ballotId",
          type: "uint256"
        }, {
          name: "_choices",
          type: "uint256[]"
        }, {
          name: "_salt",
          type: "uint256"
        }],
        name: "revealVote",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_ballotId",
          type: "uint256"
        }],
        name: "cancelBallot",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_ballotId",
          type: "uint256"
        }, {
          name: "_exemptedAddress",
          type: "address"
        }, {
          name: "_exempt",
          type: "bool"
        }],
        name: "changeBallotExemptedVotersList",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_ballotId",
          type: "uint256"
        }, {
          name: "_exemptedAddresses",
          type: "address[]"
        }, {
          name: "_exempts",
          type: "bool[]"
        }],
        name: "changeBallotExemptedVotersListMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_voter",
          type: "address"
        }, {
          name: "_exempt",
          type: "bool"
        }],
        name: "changeDefaultExemptedVotersList",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !1,
        inputs: [{
          name: "_voters",
          type: "address[]"
        }, {
          name: "_exempts",
          type: "bool[]"
        }],
        name: "changeDefaultExemptedVotersListMulti",
        outputs: [],
        payable: !1,
        stateMutability: "nonpayable",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_checkpointId",
          type: "uint256"
        }],
        name: "getCheckpointData",
        outputs: [{
          name: "investors",
          type: "address[]"
        }, {
          name: "balances",
          type: "uint256[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_ballotId",
          type: "uint256"
        }],
        name: "getPendingInvestorToVote",
        outputs: [{
          name: "pendingInvestors",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_ballotId",
          type: "uint256"
        }],
        name: "getCommitedVoteCount",
        outputs: [{
          name: "commitedVoteCount",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_ballotId",
          type: "uint256"
        }],
        name: "getAllowedVotersByBallot",
        outputs: [{
          name: "voters",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getAllBallots",
        outputs: [{
          name: "ballotIds",
          type: "uint256[]"
        }, {
          name: "names",
          type: "bytes32[]"
        }, {
          name: "totalProposals",
          type: "uint256[]"
        }, {
          name: "currentStages",
          type: "uint8[]"
        }, {
          name: "isCancelled",
          type: "bool[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_ballotId",
          type: "uint256"
        }],
        name: "getExemptedVotersByBallot",
        outputs: [{
          name: "exemptedVoters",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_voter",
          type: "address"
        }],
        name: "pendingBallots",
        outputs: [{
          name: "commitBallots",
          type: "uint256[]"
        }, {
          name: "revealBallots",
          type: "uint256[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_ballotId",
          type: "uint256"
        }],
        name: "getCurrentBallotStage",
        outputs: [{
          name: "",
          type: "uint8"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_voter",
          type: "address"
        }, {
          name: "_ballotId",
          type: "uint256"
        }],
        name: "getVoteTokenCount",
        outputs: [{
          name: "",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_ballotId",
          type: "uint256"
        }],
        name: "getBallotResults",
        outputs: [{
          name: "choicesWeighting",
          type: "uint256[]"
        }, {
          name: "noOfChoicesInProposal",
          type: "uint256[]"
        }, {
          name: "voters",
          type: "address[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_ballotId",
          type: "uint256"
        }],
        name: "getBallotDetails",
        outputs: [{
          name: "name",
          type: "bytes32"
        }, {
          name: "totalSupplyAtCheckpoint",
          type: "uint256"
        }, {
          name: "checkpointId",
          type: "uint256"
        }, {
          name: "startTime",
          type: "uint256"
        }, {
          name: "commitDuration",
          type: "uint256"
        }, {
          name: "revealDuration",
          type: "uint256"
        }, {
          name: "totalProposals",
          type: "uint256"
        }, {
          name: "totalVoters",
          type: "uint256"
        }, {
          name: "commitedVoteCount",
          type: "uint256"
        }, {
          name: "isCancelled",
          type: "bool"
        }, {
          name: "currentStage",
          type: "uint8"
        }, {
          name: "proposalDetails",
          type: "bytes32[]"
        }, {
          name: "proposalChoicesCounts",
          type: "uint256[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getBallotsArrayLength",
        outputs: [{
          name: "length",
          type: "uint256"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [{
          name: "_ballotId",
          type: "uint256"
        }, {
          name: "_voter",
          type: "address"
        }],
        name: "isVoterAllowed",
        outputs: [{
          name: "",
          type: "bool"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getInitFunction",
        outputs: [{
          name: "initFunction",
          type: "bytes4"
        }],
        payable: !1,
        stateMutability: "pure",
        type: "function"
      }, {
        constant: !0,
        inputs: [],
        name: "getPermissions",
        outputs: [{
          name: "permissions",
          type: "bytes32[]"
        }],
        payable: !1,
        stateMutability: "view",
        type: "function"
      }];
    }, t.prototype.addABItoDecoder = function (e, t) {
      this._web3Wrapper.abiDecoder.addABI(e, t);
    }, t;
  }(d.BaseContract);

  t.AdvancedPLCRVotingCheckpointContract_3_1_0 = v, t.isAdvancedPLCRVotingCheckpointContract_3_1_0 = function (e) {
    return m.isEqual(v.ABI(), e.abi);
  };
},
/*!********************************************************************!*\
  !*** ./node_modules/ethereumjs-blockstream/output/source/index.js ***!
  \********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = a(
  /*! ./block-and-log-streamer */
  820);
  t.BlockAndLogStreamer = r.BlockAndLogStreamer;
},
/*!*************************************************************************************!*\
  !*** ./node_modules/ethereumjs-blockstream/output/source/block-and-log-streamer.js ***!
  \*************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      n = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var s = a(
  /*! ./block-reconciler */
  821),
      o = a(
  /*! ./log-reconciler */
  822),
      i = a(
  /*! immutable */
  277),
      c = a(
  /*! uuid */
  823),
      u = function u(e, t, a, _u3) {
    var f = this;
    if (this.lastKnownGoodBlockHistory = i.List(), this.blockHistory = Promise.resolve(this.lastKnownGoodBlockHistory), this.lastKnownGoodLogHistory = i.List(), this.logHistory = Promise.resolve(this.lastKnownGoodLogHistory), this.pendingCallbacks = [], this.onError = function () {}, this.logFilters = {}, this.onBlockAddedSubscribers = {}, this.onBlockRemovedSubscribers = {}, this.onLogAddedSubscribers = {}, this.onLogRemovedSubscribers = {}, this.reconcileNewBlock = function (e) {
      return r(f, void 0, void 0, function () {
        var t, a, r;
        return n(this, function (n) {
          switch (n.label) {
            case 0:
              return n.trys.push([0, 3,, 4]), this.blockHistory = s.reconcileBlockHistory(this.getBlockByHash, this.blockHistory, e, this.onBlockAdded, this.onBlockRemoved, this.blockRetention), [4, this.blockHistory];

            case 1:
              return t = n.sent(), [4, this.logHistory];

            case 2:
              return a = n.sent(), this.lastKnownGoodBlockHistory = t, this.lastKnownGoodLogHistory = a, this.pendingCallbacks.forEach(function (e) {
                return e();
              }), this.pendingCallbacks = [], [3, 4];

            case 3:
              throw r = n.sent(), this.blockHistory = Promise.resolve(this.lastKnownGoodBlockHistory), this.logHistory = Promise.resolve(this.lastKnownGoodLogHistory), this.pendingCallbacks = [], r;

            case 4:
              return [2];
          }
        });
      });
    }, this.onBlockAdded = function (e) {
      return r(f, void 0, void 0, function () {
        var t,
            a = this;
        return n(this, function (r) {
          switch (r.label) {
            case 0:
              return Object.keys(this.onBlockAddedSubscribers).map(function (e) {
                return a.onBlockAddedSubscribers[e];
              }).map(function (e) {
                return d(e, a.onError);
              }).forEach(function (t) {
                return a.pendingCallbacks.push(function () {
                  return t(e);
                });
              }), t = Object.keys(this.logFilters).map(function (e) {
                return a.logFilters[e];
              }), this.logHistory = o.reconcileLogHistoryWithAddedBlock(this.getLogs, this.logHistory, e, this.onLogAdded, t, this.blockRetention), [4, this.logHistory];

            case 1:
              return r.sent(), [2];
          }
        });
      });
    }, this.onBlockRemoved = function (e) {
      return r(f, void 0, void 0, function () {
        var t = this;
        return n(this, function (a) {
          switch (a.label) {
            case 0:
              return this.logHistory = o.reconcileLogHistoryWithRemovedBlock(this.logHistory, e, this.onLogRemoved), [4, this.logHistory];

            case 1:
              return a.sent(), Object.keys(this.onBlockRemovedSubscribers).map(function (e) {
                return t.onBlockRemovedSubscribers[e];
              }).map(function (e) {
                return d(e, t.onError);
              }).forEach(function (a) {
                return t.pendingCallbacks.push(function () {
                  return a(e);
                });
              }), [2];
          }
        });
      });
    }, this.onLogAdded = function (e) {
      return r(f, void 0, void 0, function () {
        var t = this;
        return n(this, function (a) {
          return Object.keys(this.onLogAddedSubscribers).map(function (e) {
            return t.onLogAddedSubscribers[e];
          }).map(function (e) {
            return d(e, t.onError);
          }).forEach(function (a) {
            return t.pendingCallbacks.push(function () {
              return a(e);
            });
          }), [2];
        });
      });
    }, this.onLogRemoved = function (e) {
      return r(f, void 0, void 0, function () {
        var t = this;
        return n(this, function (a) {
          return Object.keys(this.onLogRemovedSubscribers).map(function (e) {
            return t.onLogRemovedSubscribers[e];
          }).map(function (e) {
            return d(e, t.onError);
          }).forEach(function (a) {
            return t.pendingCallbacks.push(function () {
              return a(e);
            });
          }), [2];
        });
      });
    }, this.getLatestReconciledBlock = function () {
      return f.lastKnownGoodBlockHistory.isEmpty() ? null : f.lastKnownGoodBlockHistory.last();
    }, this.addLogFilter = function (e) {
      var t = "log filter token " + c();
      return f.logFilters[t] = e, t;
    }, this.removeLogFilter = function (e) {
      if (!e.startsWith("log filter token ")) throw new Error("Expected a log filter token.  Actual: " + e);
      delete f.logFilters[e];
    }, this.subscribeToOnBlockAdded = function (e) {
      var t = "on block added token " + c();
      return f.onBlockAddedSubscribers[t] = e, t;
    }, this.unsubscribeFromOnBlockAdded = function (e) {
      if (!e.startsWith("on block added token ")) throw new Error("Expected a block added subscription token.  Actual: " + e);
      delete f.onBlockAddedSubscribers[e];
    }, this.subscribeToOnBlockRemoved = function (e) {
      var t = "on block removed token " + c();
      return f.onBlockRemovedSubscribers[t] = e, t;
    }, this.unsubscribeFromOnBlockRemoved = function (e) {
      if (!e.startsWith("on block removed token ")) throw new Error("Expected a block added subscription token.  Actual: " + e);
      delete f.onBlockRemovedSubscribers[e];
    }, this.subscribeToOnLogAdded = function (e) {
      var t = "on log added token " + c();
      return f.onLogAddedSubscribers[t] = e, t;
    }, this.unsubscribeFromOnLogAdded = function (e) {
      if (!e.startsWith("on log added token ")) throw new Error("Expected a log added subscription token.  Actual: " + e);
      delete f.onLogAddedSubscribers[e];
    }, this.subscribeToOnLogRemoved = function (e) {
      var t = "on log removed token " + c();
      return f.onLogRemovedSubscribers[t] = e, t;
    }, this.unsubscribeFromOnLogRemoved = function (e) {
      if (!e.startsWith("on log removed token ")) throw new Error("Expected a log added subscription token.  Actual: " + e);
      delete f.onLogRemovedSubscribers[e];
    }, void 0 === e) throw new Error("getBlockByHash must be provided");
    if (this.getBlockByHash = e, void 0 === t) throw new Error("getLogs must be provided");
    if (this.getLogs = t, void 0 === a) throw new Error("onError must be provided");
    this.onError = a, this.blockRetention = _u3 && _u3.blockRetention ? _u3.blockRetention : 100;
  };

  function d(e, t) {
    return function (a) {
      try {
        e(a);
      } catch (e) {
        t(e);
      }
    };
  }

  t.BlockAndLogStreamer = u;
},
/*!*******************************************************************************!*\
  !*** ./node_modules/ethereumjs-blockstream/output/source/block-reconciler.js ***!
  \*******************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      n = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      s = this;

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = a(
  /*! ./utilities */
  282);

  t.reconcileBlockHistory = function (e, t, a, o, m, y) {
    return void 0 === y && (y = 100), r(s, void 0, void 0, function () {
      return n(this, function (r) {
        switch (r.label) {
          case 0:
            return [4, t];

          case 1:
            return t = r.sent(), f(t) ? [4, u(t, a, o, y)] : [3, 3];

          case 2:
            return [2, r.sent()];

          case 3:
            return l(t, a) ? [4, i(t, m)] : [3, 6];

          case 4:
            return t = r.sent(), [4, u(t, a, o, y)];

          case 5:
            return [2, r.sent()];

          case 6:
            return h(t, a) ? [2, t] : p(t, a) ? [4, u(t, a, o, y)] : [3, 8];

          case 7:
            return [2, r.sent()];

          case 8:
            if (!b(t, a)) return [3, 13];
            r.label = 9;

          case 9:
            return t.last().hash === a.parentHash ? [3, 11] : [4, d(t, m)];

          case 10:
            return t = r.sent(), [3, 9];

          case 11:
            return [4, u(t, a, o, y)];

          case 12:
            return [2, r.sent()];

          case 13:
            return [4, c(e, t, a, o, m, y)];

          case 14:
            return [2, r.sent()];
        }
      });
    });
  };

  var i = function i(e, t) {
    return r(s, void 0, void 0, function () {
      return n(this, function (a) {
        switch (a.label) {
          case 0:
            return e.isEmpty() ? [3, 2] : [4, d(e, t)];

          case 1:
            return e = a.sent(), [3, 0];

          case 2:
            return [2, e];
        }
      });
    });
  },
      c = function c(e, a, _c3, u, d, f) {
    return r(s, void 0, void 0, function () {
      var r;
      return n(this, function (n) {
        switch (n.label) {
          case 0:
            return "0x0000000000000000000000000000000000000000000000000000000000000000" !== _c3.parentHash ? [3, 2] : [4, i(a, d)];

          case 1:
            return [2, n.sent()];

          case 2:
            return [4, e(_c3.parentHash)];

          case 3:
            if (null === (r = n.sent())) throw new Error("Failed to fetch parent block.");
            return o.parseHexInt(r.number) + f < o.parseHexInt(a.last().number) ? [4, i(a, d)] : [3, 5];

          case 4:
            return [2, n.sent()];

          case 5:
            return [4, t.reconcileBlockHistory(e, a, r, u, d, f)];

          case 6:
            return a = n.sent(), [4, t.reconcileBlockHistory(e, a, _c3, u, d, f)];

          case 7:
            return [2, n.sent()];
        }
      });
    });
  },
      u = function u(e, t, a, o) {
    return r(s, void 0, void 0, function () {
      return n(this, function (r) {
        switch (r.label) {
          case 0:
            if (!e.isEmpty() && e.last().hash !== t.parentHash) throw new Error("New head block's parent isn't our current head.");
            return [4, a(t)];

          case 1:
            return r.sent(), [2, (e = e.push(t)).takeLast(o).toList()];
        }
      });
    });
  },
      d = function d(e, t) {
    return r(s, void 0, void 0, function () {
      var a;
      return n(this, function (r) {
        switch (r.label) {
          case 0:
            return a = e.last(), e = e.pop(), [4, t(a)];

          case 1:
            return r.sent(), [2, e];
        }
      });
    });
  },
      f = function f(e) {
    return e.isEmpty();
  },
      l = function l(e, t) {
    return o.parseHexInt(e.first().number) > o.parseHexInt(t.number);
  },
      h = function h(e, t) {
    return e.some(function (e) {
      return e.hash === t.hash;
    });
  },
      p = function p(e, t) {
    return e.last().hash === t.parentHash;
  },
      b = function b(e, t) {
    return e.some(function (e) {
      return e.hash === t.parentHash;
    });
  };
},
/*!*****************************************************************************!*\
  !*** ./node_modules/ethereumjs-blockstream/output/source/log-reconciler.js ***!
  \*****************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      n = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      s = this;

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = a(
  /*! ./utilities */
  282);

  t.reconcileLogHistoryWithAddedBlock = function (e, t, a, o, d, f) {
    return void 0 === d && (d = []), void 0 === f && (f = 100), r(s, void 0, void 0, function () {
      var r;
      return n(this, function (n) {
        switch (n.label) {
          case 0:
            return [4, t];

          case 1:
            return t = n.sent(), [4, i(e, a, d)];

          case 2:
            return r = n.sent(), [4, c(t, r, o)];

          case 3:
            return t = n.sent(), [4, u(t, a, f)];

          case 4:
            return [2, t = n.sent()];
        }
      });
    });
  };

  var i = function i(e, t, a) {
    return r(s, void 0, void 0, function () {
      var r;
      return n(this, function (n) {
        switch (n.label) {
          case 0:
            return r = a.map(function (e) {
              return {
                blockHash: t.hash,
                address: e.address,
                topics: e.topics
              };
            }).map(function (t) {
              return e(t);
            }), [4, Promise.all(r)];

          case 1:
            return [2, n.sent().reduce(function (e, t) {
              return e.concat(t);
            }, [])];
        }
      });
    });
  },
      c = function c(e, t, a) {
    return r(s, void 0, void 0, function () {
      var r, s, i, c, u;
      return n(this, function (l) {
        switch (l.label) {
          case 0:
            r = t.sort(function (e, t) {
              return o.parseHexInt(e.logIndex) - o.parseHexInt(t.logIndex);
            }), s = function s(t) {
              return n(this, function (r) {
                switch (r.label) {
                  case 0:
                    return e.some(function (e) {
                      return e.blockHash === t.blockHash && e.logIndex === t.logIndex;
                    }) ? [2, "continue"] : (f(e.last(), t), [4, d(e, t, a)]);

                  case 1:
                    return e = r.sent(), [2];
                }
              });
            }, i = 0, c = r, l.label = 1;

          case 1:
            return i < c.length ? (u = c[i], [5, s(u)]) : [3, 4];

          case 2:
            l.sent(), l.label = 3;

          case 3:
            return i++, [3, 1];

          case 4:
            return [2, e];
        }
      });
    });
  },
      u = function u(e, t, a) {
    return r(s, void 0, void 0, function () {
      return n(this, function (r) {
        return [2, e.skipUntil(function (e) {
          return o.parseHexInt(t.number) - o.parseHexInt(e.blockNumber) < a;
        }).toList()];
      });
    });
  },
      d = function d(e, t, a) {
    return r(s, void 0, void 0, function () {
      return n(this, function (r) {
        switch (r.label) {
          case 0:
            return e = e.push(t), [4, a(t)];

          case 1:
            return r.sent(), [2, e];
        }
      });
    });
  },
      f = function f(e, t) {
    if (void 0 !== e) {
      var a = o.parseHexInt(e.blockNumber),
          r = o.parseHexInt(t.blockNumber);
      if (a > r) throw new Error("received log for a block (" + r + ") older than current head log's block (" + a + ")");

      if (a === r) {
        var n = o.parseHexInt(e.logIndex),
            s = o.parseHexInt(t.logIndex);
        if (n >= s) throw new Error("received log with same block number (" + r + ") but index (" + s + ") is the same or older than previous index (" + n + ")");
      }
    }
  };

  t.reconcileLogHistoryWithRemovedBlock = function (e, t, a) {
    return r(s, void 0, void 0, function () {
      return n(this, function (r) {
        switch (r.label) {
          case 0:
            return [4, e];

          case 1:
            e = r.sent(), r.label = 2;

          case 2:
            return e.isEmpty() || e.last().blockHash !== t.hash ? [3, 4] : [4, a(e.last())];

          case 3:
            return r.sent(), e = e.pop(), [3, 2];

          case 4:
            if (e.some(function (e) {
              return e.blockHash === t.hash;
            })) throw new Error("found logs for removed block not at head of log history");
            return [2, e];
        }
      });
    });
  };
},
/*!************************************************************************!*\
  !*** ./node_modules/ethereumjs-blockstream/node_modules/uuid/index.js ***!
  \************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./v1 */
  824),
      n = a(
  /*! ./v4 */
  825),
      s = n;
  s.v1 = r, s.v4 = n, e.exports = s;
},
/*!*********************************************************************!*\
  !*** ./node_modules/ethereumjs-blockstream/node_modules/uuid/v1.js ***!
  \*********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r,
      n,
      s = a(
  /*! ./lib/rng */
  283),
      o = a(
  /*! ./lib/bytesToUuid */
  284),
      i = 0,
      c = 0;

  e.exports = function (e, t, a) {
    var u = t && a || 0,
        d = t || [],
        f = (e = e || {}).node || r,
        l = void 0 !== e.clockseq ? e.clockseq : n;

    if (null == f || null == l) {
      var h = s();
      null == f && (f = r = [1 | h[0], h[1], h[2], h[3], h[4], h[5]]), null == l && (l = n = 16383 & (h[6] << 8 | h[7]));
    }

    var p = void 0 !== e.msecs ? e.msecs : new Date().getTime(),
        b = void 0 !== e.nsecs ? e.nsecs : c + 1,
        m = p - i + (b - c) / 1e4;
    if (m < 0 && void 0 === e.clockseq && (l = l + 1 & 16383), (m < 0 || p > i) && void 0 === e.nsecs && (b = 0), b >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    i = p, c = b, n = l;
    var y = (1e4 * (268435455 & (p += 122192928e5)) + b) % 4294967296;
    d[u++] = y >>> 24 & 255, d[u++] = y >>> 16 & 255, d[u++] = y >>> 8 & 255, d[u++] = 255 & y;
    var v = p / 4294967296 * 1e4 & 268435455;
    d[u++] = v >>> 8 & 255, d[u++] = 255 & v, d[u++] = v >>> 24 & 15 | 16, d[u++] = v >>> 16 & 255, d[u++] = l >>> 8 | 128, d[u++] = 255 & l;

    for (var _ = 0; _ < 6; ++_) {
      d[u + _] = f[_];
    }

    return t || o(d);
  };
},
/*!*********************************************************************!*\
  !*** ./node_modules/ethereumjs-blockstream/node_modules/uuid/v4.js ***!
  \*********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var r = a(
  /*! ./lib/rng */
  283),
      n = a(
  /*! ./lib/bytesToUuid */
  284);

  e.exports = function (e, t, a) {
    var s = t && a || 0;
    "string" == typeof e && (t = "binary" === e ? new Array(16) : null, e = null);
    var o = (e = e || {}).random || (e.rng || r)();
    if (o[6] = 15 & o[6] | 64, o[8] = 63 & o[8] | 128, t) for (var i = 0; i < 16; ++i) {
      t[s + i] = o[i];
    }
    return t || n(o);
  };
},
/*!***********************************!*\
  !*** ./src/utils/filter_utils.ts ***!
  \***********************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = this && this.__assign || function () {
    return (r = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      n = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || t-- > 0) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  },
      s = this && this.__spread || function () {
    for (var e = [], t = 0; t < arguments.length; t++) {
      e = e.concat(n(arguments[t]));
    }

    return e;
  },
      o = this && this.__importStar || function (e) {
    if (e && e.__esModule) return e;
    var t = {};
    if (null != e) for (var a in e) {
      Object.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t.default = e, t;
  },
      i = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var c = o(a(
  /*! ethereumjs-util */
  182)),
      u = i(a(
  /*! js-sha3 */
  827)),
      d = i(a(
  /*! lodash */
  0)),
      f = i(a(
  /*! uuid/v4 */
  281)),
      l = {
    generateUUID: function generateUUID() {
      return f.default();
    },
    getFilter: function getFilter(e, t, a, n, o) {
      var i = d.default.find(n, {
        name: t
      }),
          f = l.getEventSignatureFromAbiByName(i),
          h = c.addHexPrefix(u.default.keccak_256(f)),
          p = l.getTopicsForIndexedArgs(i, a),
          b = {
        address: e,
        topics: s([h], p)
      };
      return d.default.isUndefined(o) || (b = r({}, o, b)), b;
    },
    getEventSignatureFromAbiByName: function getEventSignatureFromAbiByName(e) {
      var t = d.default.map(e.inputs, "type");
      return e.name + "(" + t.join(",") + ")";
    },
    getTopicsForIndexedArgs: function getTopicsForIndexedArgs(e, t) {
      var a = [];
      return e.inputs.forEach(function (e) {
        if (e.indexed) if (d.default.isUndefined(t[e.name])) a.push(null);else {
          var r = t[e.name],
              n = c.toBuffer(r),
              s = c.setLengthLeft(n, 32),
              o = c.bufferToHex(s);
          a.push(o);
        }
      }), a;
    },
    matchesFilter: function matchesFilter(e, t) {
      return !(!d.default.isUndefined(t.address) && e.address !== t.address) && (!!d.default.isUndefined(t.topics) || l.doesMatchTopics(e.topics, t.topics));
    },
    doesMatchTopics: function doesMatchTopics(e, t) {
      var a = d.default.zipWith(e, t, l.matchesTopic.bind(l));
      return d.default.every(a);
    },
    matchesTopic: function matchesTopic(e, t) {
      return d.default.isArray(t) ? d.default.includes(t, e) : !d.default.isString(t) || t === e;
    }
  };
  t.default = l;
},
/*!******************************************!*\
  !*** ./node_modules/js-sha3/src/sha3.js ***!
  \******************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (r, n) {
    var s;
    /**
     * [js-sha3]{@link https://github.com/emn178/js-sha3}
     *
     * @version 0.8.0
     * @author Chen, Yi-Cyuan [emn178@gmail.com]
     * @copyright Chen, Yi-Cyuan 2015-2018
     * @license MIT
     */

    !function () {
      "use strict";

      var o = "input is invalid type",
          i = "object" == typeof window,
          c = i ? window : {};
      c.JS_SHA3_NO_WINDOW && (i = !1);
      var u = !i && "object" == typeof self;
      !c.JS_SHA3_NO_NODE_JS && "object" == typeof r && r.versions && r.versions.node ? c = n : u && (c = self);
      var d = !c.JS_SHA3_NO_COMMON_JS && "object" == typeof e && e.exports,
          f = a(
      /*! !webpack amd options */
      103),
          l = !c.JS_SHA3_NO_ARRAY_BUFFER && "undefined" != typeof ArrayBuffer,
          h = "0123456789abcdef".split(""),
          p = [4, 1024, 262144, 67108864],
          b = [0, 8, 16, 24],
          m = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649, 0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0, 2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771, 2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648, 2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648],
          y = [224, 256, 384, 512],
          v = [128, 256],
          _ = ["hex", "buffer", "arrayBuffer", "array", "digest"],
          g = {
        128: 168,
        256: 136
      };
      !c.JS_SHA3_NO_NODE_JS && Array.isArray || (Array.isArray = function (e) {
        return "[object Array]" === Object.prototype.toString.call(e);
      }), !l || !c.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW && ArrayBuffer.isView || (ArrayBuffer.isView = function (e) {
        return "object" == typeof e && e.buffer && e.buffer.constructor === ArrayBuffer;
      });

      for (var A = function A(e, t, a) {
        return function (r) {
          return new P(e, t, e).update(r)[a]();
        };
      }, w = function w(e, t, a) {
        return function (r, n) {
          return new P(e, t, n).update(r)[a]();
        };
      }, T = function T(e, t, a) {
        return function (t, r, n, s) {
          return E["cshake" + e].update(t, r, n, s)[a]();
        };
      }, x = function x(e, t, a) {
        return function (t, r, n, s) {
          return E["kmac" + e].update(t, r, n, s)[a]();
        };
      }, D = function D(e, t, a, r) {
        for (var n = 0; n < _.length; ++n) {
          var s = _[n];
          e[s] = t(a, r, s);
        }

        return e;
      }, C = function C(e, t) {
        var a = A(e, t, "hex");
        return a.create = function () {
          return new P(e, t, e);
        }, a.update = function (e) {
          return a.create().update(e);
        }, D(a, A, e, t);
      }, S = [{
        name: "keccak",
        padding: [1, 256, 65536, 16777216],
        bits: y,
        createMethod: C
      }, {
        name: "sha3",
        padding: [6, 1536, 393216, 100663296],
        bits: y,
        createMethod: C
      }, {
        name: "shake",
        padding: [31, 7936, 2031616, 520093696],
        bits: v,
        createMethod: function createMethod(e, t) {
          var a = w(e, t, "hex");
          return a.create = function (a) {
            return new P(e, t, a);
          }, a.update = function (e, t) {
            return a.create(t).update(e);
          }, D(a, w, e, t);
        }
      }, {
        name: "cshake",
        padding: p,
        bits: v,
        createMethod: function createMethod(e, t) {
          var a = g[e],
              r = T(e, 0, "hex");
          return r.create = function (r, n, s) {
            return n || s ? new P(e, t, r).bytepad([n, s], a) : E["shake" + e].create(r);
          }, r.update = function (e, t, a, n) {
            return r.create(t, a, n).update(e);
          }, D(r, T, e, t);
        }
      }, {
        name: "kmac",
        padding: p,
        bits: v,
        createMethod: function createMethod(e, t) {
          var a = g[e],
              r = x(e, 0, "hex");
          return r.create = function (r, n, s) {
            return new L(e, t, n).bytepad(["KMAC", s], a).bytepad([r], a);
          }, r.update = function (e, t, a, n) {
            return r.create(e, a, n).update(t);
          }, D(r, x, e, t);
        }
      }], E = {}, B = [], k = 0; k < S.length; ++k) {
        for (var R = S[k], W = R.bits, I = 0; I < W.length; ++I) {
          var N = R.name + "_" + W[I];

          if (B.push(N), E[N] = R.createMethod(W[I], R.padding), "sha3" !== R.name) {
            var M = R.name + W[I];
            B.push(M), E[M] = E[N];
          }
        }
      }

      function P(e, t, a) {
        this.blocks = [], this.s = [], this.padding = t, this.outputBits = a, this.reset = !0, this.finalized = !1, this.block = 0, this.start = 0, this.blockCount = 1600 - (e << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = a >> 5, this.extraBytes = (31 & a) >> 3;

        for (var r = 0; r < 50; ++r) {
          this.s[r] = 0;
        }
      }

      function L(e, t, a) {
        P.call(this, e, t, a);
      }

      P.prototype.update = function (e) {
        if (this.finalized) throw new Error("finalize already called");
        var t,
            a = typeof e;

        if ("string" !== a) {
          if ("object" !== a) throw new Error(o);
          if (null === e) throw new Error(o);
          if (l && e.constructor === ArrayBuffer) e = new Uint8Array(e);else if (!(Array.isArray(e) || l && ArrayBuffer.isView(e))) throw new Error(o);
          t = !0;
        }

        for (var r, n, s = this.blocks, i = this.byteCount, c = e.length, u = this.blockCount, d = 0, f = this.s; d < c;) {
          if (this.reset) for (this.reset = !1, s[0] = this.block, r = 1; r < u + 1; ++r) {
            s[r] = 0;
          }
          if (t) for (r = this.start; d < c && r < i; ++d) {
            s[r >> 2] |= e[d] << b[3 & r++];
          } else for (r = this.start; d < c && r < i; ++d) {
            (n = e.charCodeAt(d)) < 128 ? s[r >> 2] |= n << b[3 & r++] : n < 2048 ? (s[r >> 2] |= (192 | n >> 6) << b[3 & r++], s[r >> 2] |= (128 | 63 & n) << b[3 & r++]) : n < 55296 || n >= 57344 ? (s[r >> 2] |= (224 | n >> 12) << b[3 & r++], s[r >> 2] |= (128 | n >> 6 & 63) << b[3 & r++], s[r >> 2] |= (128 | 63 & n) << b[3 & r++]) : (n = 65536 + ((1023 & n) << 10 | 1023 & e.charCodeAt(++d)), s[r >> 2] |= (240 | n >> 18) << b[3 & r++], s[r >> 2] |= (128 | n >> 12 & 63) << b[3 & r++], s[r >> 2] |= (128 | n >> 6 & 63) << b[3 & r++], s[r >> 2] |= (128 | 63 & n) << b[3 & r++]);
          }

          if (this.lastByteIndex = r, r >= i) {
            for (this.start = r - i, this.block = s[u], r = 0; r < u; ++r) {
              f[r] ^= s[r];
            }

            O(f), this.reset = !0;
          } else this.start = r;
        }

        return this;
      }, P.prototype.encode = function (e, t) {
        var a = 255 & e,
            r = 1,
            n = [a];

        for (a = 255 & (e >>= 8); a > 0;) {
          n.unshift(a), a = 255 & (e >>= 8), ++r;
        }

        return t ? n.push(r) : n.unshift(r), this.update(n), n.length;
      }, P.prototype.encodeString = function (e) {
        var t,
            a = typeof e;

        if ("string" !== a) {
          if ("object" !== a) throw new Error(o);
          if (null === e) throw new Error(o);
          if (l && e.constructor === ArrayBuffer) e = new Uint8Array(e);else if (!(Array.isArray(e) || l && ArrayBuffer.isView(e))) throw new Error(o);
          t = !0;
        }

        var r = 0,
            n = e.length;
        if (t) r = n;else for (var s = 0; s < e.length; ++s) {
          var i = e.charCodeAt(s);
          i < 128 ? r += 1 : i < 2048 ? r += 2 : i < 55296 || i >= 57344 ? r += 3 : (i = 65536 + ((1023 & i) << 10 | 1023 & e.charCodeAt(++s)), r += 4);
        }
        return r += this.encode(8 * r), this.update(e), r;
      }, P.prototype.bytepad = function (e, t) {
        for (var a = this.encode(t), r = 0; r < e.length; ++r) {
          a += this.encodeString(e[r]);
        }

        var n = t - a % t,
            s = [];
        return s.length = n, this.update(s), this;
      }, P.prototype.finalize = function () {
        if (!this.finalized) {
          this.finalized = !0;
          var e = this.blocks,
              t = this.lastByteIndex,
              a = this.blockCount,
              r = this.s;
          if (e[t >> 2] |= this.padding[3 & t], this.lastByteIndex === this.byteCount) for (e[0] = e[a], t = 1; t < a + 1; ++t) {
            e[t] = 0;
          }

          for (e[a - 1] |= 2147483648, t = 0; t < a; ++t) {
            r[t] ^= e[t];
          }

          O(r);
        }
      }, P.prototype.toString = P.prototype.hex = function () {
        this.finalize();

        for (var e, t = this.blockCount, a = this.s, r = this.outputBlocks, n = this.extraBytes, s = 0, o = 0, i = ""; o < r;) {
          for (s = 0; s < t && o < r; ++s, ++o) {
            e = a[s], i += h[e >> 4 & 15] + h[15 & e] + h[e >> 12 & 15] + h[e >> 8 & 15] + h[e >> 20 & 15] + h[e >> 16 & 15] + h[e >> 28 & 15] + h[e >> 24 & 15];
          }

          o % t == 0 && (O(a), s = 0);
        }

        return n && (e = a[s], i += h[e >> 4 & 15] + h[15 & e], n > 1 && (i += h[e >> 12 & 15] + h[e >> 8 & 15]), n > 2 && (i += h[e >> 20 & 15] + h[e >> 16 & 15])), i;
      }, P.prototype.arrayBuffer = function () {
        this.finalize();
        var e,
            t = this.blockCount,
            a = this.s,
            r = this.outputBlocks,
            n = this.extraBytes,
            s = 0,
            o = 0,
            i = this.outputBits >> 3;
        e = n ? new ArrayBuffer(r + 1 << 2) : new ArrayBuffer(i);

        for (var c = new Uint32Array(e); o < r;) {
          for (s = 0; s < t && o < r; ++s, ++o) {
            c[o] = a[s];
          }

          o % t == 0 && O(a);
        }

        return n && (c[s] = a[s], e = e.slice(0, i)), e;
      }, P.prototype.buffer = P.prototype.arrayBuffer, P.prototype.digest = P.prototype.array = function () {
        this.finalize();

        for (var e, t, a = this.blockCount, r = this.s, n = this.outputBlocks, s = this.extraBytes, o = 0, i = 0, c = []; i < n;) {
          for (o = 0; o < a && i < n; ++o, ++i) {
            e = i << 2, t = r[o], c[e] = 255 & t, c[e + 1] = t >> 8 & 255, c[e + 2] = t >> 16 & 255, c[e + 3] = t >> 24 & 255;
          }

          i % a == 0 && O(r);
        }

        return s && (e = i << 2, t = r[o], c[e] = 255 & t, s > 1 && (c[e + 1] = t >> 8 & 255), s > 2 && (c[e + 2] = t >> 16 & 255)), c;
      }, L.prototype = new P(), L.prototype.finalize = function () {
        return this.encode(this.outputBits, !0), P.prototype.finalize.call(this);
      };

      var O = function O(e) {
        var t, a, r, n, s, o, i, c, u, d, f, l, h, p, b, y, v, _, g, A, w, T, x, D, C, S, E, B, k, R, W, I, N, M, P, L, O, F, j, G, V, U, H, z, K, q, Y, Z, J, X, $, Q, ee, te, ae, re, ne, se, oe, ie, ce, ue, de;

        for (r = 0; r < 48; r += 2) {
          n = e[0] ^ e[10] ^ e[20] ^ e[30] ^ e[40], s = e[1] ^ e[11] ^ e[21] ^ e[31] ^ e[41], o = e[2] ^ e[12] ^ e[22] ^ e[32] ^ e[42], i = e[3] ^ e[13] ^ e[23] ^ e[33] ^ e[43], c = e[4] ^ e[14] ^ e[24] ^ e[34] ^ e[44], u = e[5] ^ e[15] ^ e[25] ^ e[35] ^ e[45], d = e[6] ^ e[16] ^ e[26] ^ e[36] ^ e[46], f = e[7] ^ e[17] ^ e[27] ^ e[37] ^ e[47], t = (l = e[8] ^ e[18] ^ e[28] ^ e[38] ^ e[48]) ^ (o << 1 | i >>> 31), a = (h = e[9] ^ e[19] ^ e[29] ^ e[39] ^ e[49]) ^ (i << 1 | o >>> 31), e[0] ^= t, e[1] ^= a, e[10] ^= t, e[11] ^= a, e[20] ^= t, e[21] ^= a, e[30] ^= t, e[31] ^= a, e[40] ^= t, e[41] ^= a, t = n ^ (c << 1 | u >>> 31), a = s ^ (u << 1 | c >>> 31), e[2] ^= t, e[3] ^= a, e[12] ^= t, e[13] ^= a, e[22] ^= t, e[23] ^= a, e[32] ^= t, e[33] ^= a, e[42] ^= t, e[43] ^= a, t = o ^ (d << 1 | f >>> 31), a = i ^ (f << 1 | d >>> 31), e[4] ^= t, e[5] ^= a, e[14] ^= t, e[15] ^= a, e[24] ^= t, e[25] ^= a, e[34] ^= t, e[35] ^= a, e[44] ^= t, e[45] ^= a, t = c ^ (l << 1 | h >>> 31), a = u ^ (h << 1 | l >>> 31), e[6] ^= t, e[7] ^= a, e[16] ^= t, e[17] ^= a, e[26] ^= t, e[27] ^= a, e[36] ^= t, e[37] ^= a, e[46] ^= t, e[47] ^= a, t = d ^ (n << 1 | s >>> 31), a = f ^ (s << 1 | n >>> 31), e[8] ^= t, e[9] ^= a, e[18] ^= t, e[19] ^= a, e[28] ^= t, e[29] ^= a, e[38] ^= t, e[39] ^= a, e[48] ^= t, e[49] ^= a, p = e[0], b = e[1], q = e[11] << 4 | e[10] >>> 28, Y = e[10] << 4 | e[11] >>> 28, B = e[20] << 3 | e[21] >>> 29, k = e[21] << 3 | e[20] >>> 29, ie = e[31] << 9 | e[30] >>> 23, ce = e[30] << 9 | e[31] >>> 23, U = e[40] << 18 | e[41] >>> 14, H = e[41] << 18 | e[40] >>> 14, M = e[2] << 1 | e[3] >>> 31, P = e[3] << 1 | e[2] >>> 31, y = e[13] << 12 | e[12] >>> 20, v = e[12] << 12 | e[13] >>> 20, Z = e[22] << 10 | e[23] >>> 22, J = e[23] << 10 | e[22] >>> 22, R = e[33] << 13 | e[32] >>> 19, W = e[32] << 13 | e[33] >>> 19, ue = e[42] << 2 | e[43] >>> 30, de = e[43] << 2 | e[42] >>> 30, te = e[5] << 30 | e[4] >>> 2, ae = e[4] << 30 | e[5] >>> 2, L = e[14] << 6 | e[15] >>> 26, O = e[15] << 6 | e[14] >>> 26, _ = e[25] << 11 | e[24] >>> 21, g = e[24] << 11 | e[25] >>> 21, X = e[34] << 15 | e[35] >>> 17, $ = e[35] << 15 | e[34] >>> 17, I = e[45] << 29 | e[44] >>> 3, N = e[44] << 29 | e[45] >>> 3, D = e[6] << 28 | e[7] >>> 4, C = e[7] << 28 | e[6] >>> 4, re = e[17] << 23 | e[16] >>> 9, ne = e[16] << 23 | e[17] >>> 9, F = e[26] << 25 | e[27] >>> 7, j = e[27] << 25 | e[26] >>> 7, A = e[36] << 21 | e[37] >>> 11, w = e[37] << 21 | e[36] >>> 11, Q = e[47] << 24 | e[46] >>> 8, ee = e[46] << 24 | e[47] >>> 8, z = e[8] << 27 | e[9] >>> 5, K = e[9] << 27 | e[8] >>> 5, S = e[18] << 20 | e[19] >>> 12, E = e[19] << 20 | e[18] >>> 12, se = e[29] << 7 | e[28] >>> 25, oe = e[28] << 7 | e[29] >>> 25, G = e[38] << 8 | e[39] >>> 24, V = e[39] << 8 | e[38] >>> 24, T = e[48] << 14 | e[49] >>> 18, x = e[49] << 14 | e[48] >>> 18, e[0] = p ^ ~y & _, e[1] = b ^ ~v & g, e[10] = D ^ ~S & B, e[11] = C ^ ~E & k, e[20] = M ^ ~L & F, e[21] = P ^ ~O & j, e[30] = z ^ ~q & Z, e[31] = K ^ ~Y & J, e[40] = te ^ ~re & se, e[41] = ae ^ ~ne & oe, e[2] = y ^ ~_ & A, e[3] = v ^ ~g & w, e[12] = S ^ ~B & R, e[13] = E ^ ~k & W, e[22] = L ^ ~F & G, e[23] = O ^ ~j & V, e[32] = q ^ ~Z & X, e[33] = Y ^ ~J & $, e[42] = re ^ ~se & ie, e[43] = ne ^ ~oe & ce, e[4] = _ ^ ~A & T, e[5] = g ^ ~w & x, e[14] = B ^ ~R & I, e[15] = k ^ ~W & N, e[24] = F ^ ~G & U, e[25] = j ^ ~V & H, e[34] = Z ^ ~X & Q, e[35] = J ^ ~$ & ee, e[44] = se ^ ~ie & ue, e[45] = oe ^ ~ce & de, e[6] = A ^ ~T & p, e[7] = w ^ ~x & b, e[16] = R ^ ~I & D, e[17] = W ^ ~N & C, e[26] = G ^ ~U & M, e[27] = V ^ ~H & P, e[36] = X ^ ~Q & z, e[37] = $ ^ ~ee & K, e[46] = ie ^ ~ue & te, e[47] = ce ^ ~de & ae, e[8] = T ^ ~p & y, e[9] = x ^ ~b & v, e[18] = I ^ ~D & S, e[19] = N ^ ~C & E, e[28] = U ^ ~M & L, e[29] = H ^ ~P & O, e[38] = Q ^ ~z & q, e[39] = ee ^ ~K & Y, e[48] = ue ^ ~te & re, e[49] = de ^ ~ae & ne, e[0] ^= m[r], e[1] ^= m[r + 1];
        }
      };

      if (d) e.exports = E;else {
        for (k = 0; k < B.length; ++k) {
          c[B[k]] = E[B[k]];
        }

        f && (void 0 === (s = function () {
          return E;
        }.call(t, a, t, e)) || (e.exports = s));
      }
    }();
  }).call(this, a(
  /*! ./../../process/browser.js */
  9), a(
  /*! ./../../webpack/buildin/global.js */
  18));
},
/*!***********************************************************************!*\
  !*** ./src/contract_wrappers/modules/module_factory_wrapper/3.0.0.ts ***!
  \***********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r113,
      n = this && this.__extends || (_r113 = function r(e, t) {
    return (_r113 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r113(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o = a(
  /*! ../../../types */
  4),
      i = function (e) {
    function t(t, a) {
      var r = e.call(this, t, a) || this;
      return r.contractVersion = o.ContractVersion.V3_0_0, r.contract = a, r;
    }

    return n(t, e), t;
  }(s(a(
  /*! ./common */
  291)).default);

  t.ModuleFactory_3_0_0 = i, t.isModuleFactory_3_0_0 = function (e) {
    return e.contractVersion === o.ContractVersion.V3_0_0;
  };
},
/*!***************************************!*\
  !*** ./node_modules/semver/semver.js ***!
  \***************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (a) {
    var r;
    t = e.exports = h, r = "object" == typeof a && a.env && a.env.NODE_DEBUG && /\bsemver\b/i.test(a.env.NODE_DEBUG) ? function () {
      var e = Array.prototype.slice.call(arguments, 0);
      e.unshift("SEMVER"), console.log.apply(console, e);
    } : function () {}, t.SEMVER_SPEC_VERSION = "2.0.0";
    var n = 256,
        s = Number.MAX_SAFE_INTEGER || 9007199254740991,
        o = t.re = [],
        i = t.src = [],
        c = t.tokens = {},
        u = 0;

    function d(e) {
      c[e] = u++;
    }

    d("NUMERICIDENTIFIER"), i[c.NUMERICIDENTIFIER] = "0|[1-9]\\d*", d("NUMERICIDENTIFIERLOOSE"), i[c.NUMERICIDENTIFIERLOOSE] = "[0-9]+", d("NONNUMERICIDENTIFIER"), i[c.NONNUMERICIDENTIFIER] = "\\d*[a-zA-Z-][a-zA-Z0-9-]*", d("MAINVERSION"), i[c.MAINVERSION] = "(" + i[c.NUMERICIDENTIFIER] + ")\\.(" + i[c.NUMERICIDENTIFIER] + ")\\.(" + i[c.NUMERICIDENTIFIER] + ")", d("MAINVERSIONLOOSE"), i[c.MAINVERSIONLOOSE] = "(" + i[c.NUMERICIDENTIFIERLOOSE] + ")\\.(" + i[c.NUMERICIDENTIFIERLOOSE] + ")\\.(" + i[c.NUMERICIDENTIFIERLOOSE] + ")", d("PRERELEASEIDENTIFIER"), i[c.PRERELEASEIDENTIFIER] = "(?:" + i[c.NUMERICIDENTIFIER] + "|" + i[c.NONNUMERICIDENTIFIER] + ")", d("PRERELEASEIDENTIFIERLOOSE"), i[c.PRERELEASEIDENTIFIERLOOSE] = "(?:" + i[c.NUMERICIDENTIFIERLOOSE] + "|" + i[c.NONNUMERICIDENTIFIER] + ")", d("PRERELEASE"), i[c.PRERELEASE] = "(?:-(" + i[c.PRERELEASEIDENTIFIER] + "(?:\\." + i[c.PRERELEASEIDENTIFIER] + ")*))", d("PRERELEASELOOSE"), i[c.PRERELEASELOOSE] = "(?:-?(" + i[c.PRERELEASEIDENTIFIERLOOSE] + "(?:\\." + i[c.PRERELEASEIDENTIFIERLOOSE] + ")*))", d("BUILDIDENTIFIER"), i[c.BUILDIDENTIFIER] = "[0-9A-Za-z-]+", d("BUILD"), i[c.BUILD] = "(?:\\+(" + i[c.BUILDIDENTIFIER] + "(?:\\." + i[c.BUILDIDENTIFIER] + ")*))", d("FULL"), d("FULLPLAIN"), i[c.FULLPLAIN] = "v?" + i[c.MAINVERSION] + i[c.PRERELEASE] + "?" + i[c.BUILD] + "?", i[c.FULL] = "^" + i[c.FULLPLAIN] + "$", d("LOOSEPLAIN"), i[c.LOOSEPLAIN] = "[v=\\s]*" + i[c.MAINVERSIONLOOSE] + i[c.PRERELEASELOOSE] + "?" + i[c.BUILD] + "?", d("LOOSE"), i[c.LOOSE] = "^" + i[c.LOOSEPLAIN] + "$", d("GTLT"), i[c.GTLT] = "((?:<|>)?=?)", d("XRANGEIDENTIFIERLOOSE"), i[c.XRANGEIDENTIFIERLOOSE] = i[c.NUMERICIDENTIFIERLOOSE] + "|x|X|\\*", d("XRANGEIDENTIFIER"), i[c.XRANGEIDENTIFIER] = i[c.NUMERICIDENTIFIER] + "|x|X|\\*", d("XRANGEPLAIN"), i[c.XRANGEPLAIN] = "[v=\\s]*(" + i[c.XRANGEIDENTIFIER] + ")(?:\\.(" + i[c.XRANGEIDENTIFIER] + ")(?:\\.(" + i[c.XRANGEIDENTIFIER] + ")(?:" + i[c.PRERELEASE] + ")?" + i[c.BUILD] + "?)?)?", d("XRANGEPLAINLOOSE"), i[c.XRANGEPLAINLOOSE] = "[v=\\s]*(" + i[c.XRANGEIDENTIFIERLOOSE] + ")(?:\\.(" + i[c.XRANGEIDENTIFIERLOOSE] + ")(?:\\.(" + i[c.XRANGEIDENTIFIERLOOSE] + ")(?:" + i[c.PRERELEASELOOSE] + ")?" + i[c.BUILD] + "?)?)?", d("XRANGE"), i[c.XRANGE] = "^" + i[c.GTLT] + "\\s*" + i[c.XRANGEPLAIN] + "$", d("XRANGELOOSE"), i[c.XRANGELOOSE] = "^" + i[c.GTLT] + "\\s*" + i[c.XRANGEPLAINLOOSE] + "$", d("COERCE"), i[c.COERCE] = "(^|[^\\d])(\\d{1,16})(?:\\.(\\d{1,16}))?(?:\\.(\\d{1,16}))?(?:$|[^\\d])", d("COERCERTL"), o[c.COERCERTL] = new RegExp(i[c.COERCE], "g"), d("LONETILDE"), i[c.LONETILDE] = "(?:~>?)", d("TILDETRIM"), i[c.TILDETRIM] = "(\\s*)" + i[c.LONETILDE] + "\\s+", o[c.TILDETRIM] = new RegExp(i[c.TILDETRIM], "g");
    d("TILDE"), i[c.TILDE] = "^" + i[c.LONETILDE] + i[c.XRANGEPLAIN] + "$", d("TILDELOOSE"), i[c.TILDELOOSE] = "^" + i[c.LONETILDE] + i[c.XRANGEPLAINLOOSE] + "$", d("LONECARET"), i[c.LONECARET] = "(?:\\^)", d("CARETTRIM"), i[c.CARETTRIM] = "(\\s*)" + i[c.LONECARET] + "\\s+", o[c.CARETTRIM] = new RegExp(i[c.CARETTRIM], "g");
    d("CARET"), i[c.CARET] = "^" + i[c.LONECARET] + i[c.XRANGEPLAIN] + "$", d("CARETLOOSE"), i[c.CARETLOOSE] = "^" + i[c.LONECARET] + i[c.XRANGEPLAINLOOSE] + "$", d("COMPARATORLOOSE"), i[c.COMPARATORLOOSE] = "^" + i[c.GTLT] + "\\s*(" + i[c.LOOSEPLAIN] + ")$|^$", d("COMPARATOR"), i[c.COMPARATOR] = "^" + i[c.GTLT] + "\\s*(" + i[c.FULLPLAIN] + ")$|^$", d("COMPARATORTRIM"), i[c.COMPARATORTRIM] = "(\\s*)" + i[c.GTLT] + "\\s*(" + i[c.LOOSEPLAIN] + "|" + i[c.XRANGEPLAIN] + ")", o[c.COMPARATORTRIM] = new RegExp(i[c.COMPARATORTRIM], "g");
    d("HYPHENRANGE"), i[c.HYPHENRANGE] = "^\\s*(" + i[c.XRANGEPLAIN] + ")\\s+-\\s+(" + i[c.XRANGEPLAIN] + ")\\s*$", d("HYPHENRANGELOOSE"), i[c.HYPHENRANGELOOSE] = "^\\s*(" + i[c.XRANGEPLAINLOOSE] + ")\\s+-\\s+(" + i[c.XRANGEPLAINLOOSE] + ")\\s*$", d("STAR"), i[c.STAR] = "(<|>)?=?\\s*\\*";

    for (var f = 0; f < u; f++) {
      r(f, i[f]), o[f] || (o[f] = new RegExp(i[f]));
    }

    function l(e, t) {
      if (t && "object" == typeof t || (t = {
        loose: !!t,
        includePrerelease: !1
      }), e instanceof h) return e;
      if ("string" != typeof e) return null;
      if (e.length > n) return null;
      if (!(t.loose ? o[c.LOOSE] : o[c.FULL]).test(e)) return null;

      try {
        return new h(e, t);
      } catch (e) {
        return null;
      }
    }

    function h(e, t) {
      if (t && "object" == typeof t || (t = {
        loose: !!t,
        includePrerelease: !1
      }), e instanceof h) {
        if (e.loose === t.loose) return e;
        e = e.version;
      } else if ("string" != typeof e) throw new TypeError("Invalid Version: " + e);

      if (e.length > n) throw new TypeError("version is longer than " + n + " characters");
      if (!(this instanceof h)) return new h(e, t);
      r("SemVer", e, t), this.options = t, this.loose = !!t.loose;
      var a = e.trim().match(t.loose ? o[c.LOOSE] : o[c.FULL]);
      if (!a) throw new TypeError("Invalid Version: " + e);
      if (this.raw = e, this.major = +a[1], this.minor = +a[2], this.patch = +a[3], this.major > s || this.major < 0) throw new TypeError("Invalid major version");
      if (this.minor > s || this.minor < 0) throw new TypeError("Invalid minor version");
      if (this.patch > s || this.patch < 0) throw new TypeError("Invalid patch version");
      a[4] ? this.prerelease = a[4].split(".").map(function (e) {
        if (/^[0-9]+$/.test(e)) {
          var t = +e;
          if (t >= 0 && t < s) return t;
        }

        return e;
      }) : this.prerelease = [], this.build = a[5] ? a[5].split(".") : [], this.format();
    }

    t.parse = l, t.valid = function (e, t) {
      var a = l(e, t);
      return a ? a.version : null;
    }, t.clean = function (e, t) {
      var a = l(e.trim().replace(/^[=v]+/, ""), t);
      return a ? a.version : null;
    }, t.SemVer = h, h.prototype.format = function () {
      return this.version = this.major + "." + this.minor + "." + this.patch, this.prerelease.length && (this.version += "-" + this.prerelease.join(".")), this.version;
    }, h.prototype.toString = function () {
      return this.version;
    }, h.prototype.compare = function (e) {
      return r("SemVer.compare", this.version, this.options, e), e instanceof h || (e = new h(e, this.options)), this.compareMain(e) || this.comparePre(e);
    }, h.prototype.compareMain = function (e) {
      return e instanceof h || (e = new h(e, this.options)), b(this.major, e.major) || b(this.minor, e.minor) || b(this.patch, e.patch);
    }, h.prototype.comparePre = function (e) {
      if (e instanceof h || (e = new h(e, this.options)), this.prerelease.length && !e.prerelease.length) return -1;
      if (!this.prerelease.length && e.prerelease.length) return 1;
      if (!this.prerelease.length && !e.prerelease.length) return 0;
      var t = 0;

      do {
        var a = this.prerelease[t],
            n = e.prerelease[t];
        if (r("prerelease compare", t, a, n), void 0 === a && void 0 === n) return 0;
        if (void 0 === n) return 1;
        if (void 0 === a) return -1;
        if (a !== n) return b(a, n);
      } while (++t);
    }, h.prototype.compareBuild = function (e) {
      e instanceof h || (e = new h(e, this.options));
      var t = 0;

      do {
        var a = this.build[t],
            n = e.build[t];
        if (r("prerelease compare", t, a, n), void 0 === a && void 0 === n) return 0;
        if (void 0 === n) return 1;
        if (void 0 === a) return -1;
        if (a !== n) return b(a, n);
      } while (++t);
    }, h.prototype.inc = function (e, t) {
      switch (e) {
        case "premajor":
          this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", t);
          break;

        case "preminor":
          this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", t);
          break;

        case "prepatch":
          this.prerelease.length = 0, this.inc("patch", t), this.inc("pre", t);
          break;

        case "prerelease":
          0 === this.prerelease.length && this.inc("patch", t), this.inc("pre", t);
          break;

        case "major":
          0 === this.minor && 0 === this.patch && 0 !== this.prerelease.length || this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
          break;

        case "minor":
          0 === this.patch && 0 !== this.prerelease.length || this.minor++, this.patch = 0, this.prerelease = [];
          break;

        case "patch":
          0 === this.prerelease.length && this.patch++, this.prerelease = [];
          break;

        case "pre":
          if (0 === this.prerelease.length) this.prerelease = [0];else {
            for (var a = this.prerelease.length; --a >= 0;) {
              "number" == typeof this.prerelease[a] && (this.prerelease[a]++, a = -2);
            }

            -1 === a && this.prerelease.push(0);
          }
          t && (this.prerelease[0] === t ? isNaN(this.prerelease[1]) && (this.prerelease = [t, 0]) : this.prerelease = [t, 0]);
          break;

        default:
          throw new Error("invalid increment argument: " + e);
      }

      return this.format(), this.raw = this.version, this;
    }, t.inc = function (e, t, a, r) {
      "string" == typeof a && (r = a, a = void 0);

      try {
        return new h(e, a).inc(t, r).version;
      } catch (e) {
        return null;
      }
    }, t.diff = function (e, t) {
      if (_(e, t)) return null;
      var a = l(e),
          r = l(t),
          n = "";

      if (a.prerelease.length || r.prerelease.length) {
        n = "pre";
        var s = "prerelease";
      }

      for (var o in a) {
        if (("major" === o || "minor" === o || "patch" === o) && a[o] !== r[o]) return n + o;
      }

      return s;
    }, t.compareIdentifiers = b;
    var p = /^[0-9]+$/;

    function b(e, t) {
      var a = p.test(e),
          r = p.test(t);
      return a && r && (e = +e, t = +t), e === t ? 0 : a && !r ? -1 : r && !a ? 1 : e < t ? -1 : 1;
    }

    function m(e, t, a) {
      return new h(e, a).compare(new h(t, a));
    }

    function y(e, t, a) {
      return m(e, t, a) > 0;
    }

    function v(e, t, a) {
      return m(e, t, a) < 0;
    }

    function _(e, t, a) {
      return 0 === m(e, t, a);
    }

    function g(e, t, a) {
      return 0 !== m(e, t, a);
    }

    function A(e, t, a) {
      return m(e, t, a) >= 0;
    }

    function w(e, t, a) {
      return m(e, t, a) <= 0;
    }

    function T(e, t, a, r) {
      switch (t) {
        case "===":
          return "object" == typeof e && (e = e.version), "object" == typeof a && (a = a.version), e === a;

        case "!==":
          return "object" == typeof e && (e = e.version), "object" == typeof a && (a = a.version), e !== a;

        case "":
        case "=":
        case "==":
          return _(e, a, r);

        case "!=":
          return g(e, a, r);

        case ">":
          return y(e, a, r);

        case ">=":
          return A(e, a, r);

        case "<":
          return v(e, a, r);

        case "<=":
          return w(e, a, r);

        default:
          throw new TypeError("Invalid operator: " + t);
      }
    }

    function x(e, t) {
      if (t && "object" == typeof t || (t = {
        loose: !!t,
        includePrerelease: !1
      }), e instanceof x) {
        if (e.loose === !!t.loose) return e;
        e = e.value;
      }

      if (!(this instanceof x)) return new x(e, t);
      r("comparator", e, t), this.options = t, this.loose = !!t.loose, this.parse(e), this.semver === D ? this.value = "" : this.value = this.operator + this.semver.version, r("comp", this);
    }

    t.rcompareIdentifiers = function (e, t) {
      return b(t, e);
    }, t.major = function (e, t) {
      return new h(e, t).major;
    }, t.minor = function (e, t) {
      return new h(e, t).minor;
    }, t.patch = function (e, t) {
      return new h(e, t).patch;
    }, t.compare = m, t.compareLoose = function (e, t) {
      return m(e, t, !0);
    }, t.compareBuild = function (e, t, a) {
      var r = new h(e, a),
          n = new h(t, a);
      return r.compare(n) || r.compareBuild(n);
    }, t.rcompare = function (e, t, a) {
      return m(t, e, a);
    }, t.sort = function (e, a) {
      return e.sort(function (e, r) {
        return t.compareBuild(e, r, a);
      });
    }, t.rsort = function (e, a) {
      return e.sort(function (e, r) {
        return t.compareBuild(r, e, a);
      });
    }, t.gt = y, t.lt = v, t.eq = _, t.neq = g, t.gte = A, t.lte = w, t.cmp = T, t.Comparator = x;
    var D = {};

    function C(e, t) {
      if (t && "object" == typeof t || (t = {
        loose: !!t,
        includePrerelease: !1
      }), e instanceof C) return e.loose === !!t.loose && e.includePrerelease === !!t.includePrerelease ? e : new C(e.raw, t);
      if (e instanceof x) return new C(e.value, t);
      if (!(this instanceof C)) return new C(e, t);
      if (this.options = t, this.loose = !!t.loose, this.includePrerelease = !!t.includePrerelease, this.raw = e, this.set = e.split(/\s*\|\|\s*/).map(function (e) {
        return this.parseRange(e.trim());
      }, this).filter(function (e) {
        return e.length;
      }), !this.set.length) throw new TypeError("Invalid SemVer Range: " + e);
      this.format();
    }

    function S(e, t) {
      for (var a = !0, r = e.slice(), n = r.pop(); a && r.length;) {
        a = r.every(function (e) {
          return n.intersects(e, t);
        }), n = r.pop();
      }

      return a;
    }

    function E(e) {
      return !e || "x" === e.toLowerCase() || "*" === e;
    }

    function B(e, t, a, r, n, s, o, i, c, u, d, f, l) {
      return ((t = E(a) ? "" : E(r) ? ">=" + a + ".0.0" : E(n) ? ">=" + a + "." + r + ".0" : ">=" + t) + " " + (i = E(c) ? "" : E(u) ? "<" + (+c + 1) + ".0.0" : E(d) ? "<" + c + "." + (+u + 1) + ".0" : f ? "<=" + c + "." + u + "." + d + "-" + f : "<=" + i)).trim();
    }

    function k(e, t, a) {
      for (var n = 0; n < e.length; n++) {
        if (!e[n].test(t)) return !1;
      }

      if (t.prerelease.length && !a.includePrerelease) {
        for (n = 0; n < e.length; n++) {
          if (r(e[n].semver), e[n].semver !== D && e[n].semver.prerelease.length > 0) {
            var s = e[n].semver;
            if (s.major === t.major && s.minor === t.minor && s.patch === t.patch) return !0;
          }
        }

        return !1;
      }

      return !0;
    }

    function R(e, t, a) {
      try {
        t = new C(t, a);
      } catch (e) {
        return !1;
      }

      return t.test(e);
    }

    function W(e, t, a, r) {
      var n, s, o, i, c;

      switch (e = new h(e, r), t = new C(t, r), a) {
        case ">":
          n = y, s = w, o = v, i = ">", c = ">=";
          break;

        case "<":
          n = v, s = A, o = y, i = "<", c = "<=";
          break;

        default:
          throw new TypeError('Must provide a hilo val of "<" or ">"');
      }

      if (R(e, t, r)) return !1;

      for (var u = 0; u < t.set.length; ++u) {
        var d = t.set[u],
            f = null,
            l = null;
        if (d.forEach(function (e) {
          e.semver === D && (e = new x(">=0.0.0")), f = f || e, l = l || e, n(e.semver, f.semver, r) ? f = e : o(e.semver, l.semver, r) && (l = e);
        }), f.operator === i || f.operator === c) return !1;
        if ((!l.operator || l.operator === i) && s(e, l.semver)) return !1;
        if (l.operator === c && o(e, l.semver)) return !1;
      }

      return !0;
    }

    x.prototype.parse = function (e) {
      var t = this.options.loose ? o[c.COMPARATORLOOSE] : o[c.COMPARATOR],
          a = e.match(t);
      if (!a) throw new TypeError("Invalid comparator: " + e);
      this.operator = void 0 !== a[1] ? a[1] : "", "=" === this.operator && (this.operator = ""), a[2] ? this.semver = new h(a[2], this.options.loose) : this.semver = D;
    }, x.prototype.toString = function () {
      return this.value;
    }, x.prototype.test = function (e) {
      if (r("Comparator.test", e, this.options.loose), this.semver === D || e === D) return !0;
      if ("string" == typeof e) try {
        e = new h(e, this.options);
      } catch (e) {
        return !1;
      }
      return T(e, this.operator, this.semver, this.options);
    }, x.prototype.intersects = function (e, t) {
      if (!(e instanceof x)) throw new TypeError("a Comparator is required");
      var a;
      if (t && "object" == typeof t || (t = {
        loose: !!t,
        includePrerelease: !1
      }), "" === this.operator) return "" === this.value || (a = new C(e.value, t), R(this.value, a, t));
      if ("" === e.operator) return "" === e.value || (a = new C(this.value, t), R(e.semver, a, t));
      var r = !(">=" !== this.operator && ">" !== this.operator || ">=" !== e.operator && ">" !== e.operator),
          n = !("<=" !== this.operator && "<" !== this.operator || "<=" !== e.operator && "<" !== e.operator),
          s = this.semver.version === e.semver.version,
          o = !(">=" !== this.operator && "<=" !== this.operator || ">=" !== e.operator && "<=" !== e.operator),
          i = T(this.semver, "<", e.semver, t) && (">=" === this.operator || ">" === this.operator) && ("<=" === e.operator || "<" === e.operator),
          c = T(this.semver, ">", e.semver, t) && ("<=" === this.operator || "<" === this.operator) && (">=" === e.operator || ">" === e.operator);
      return r || n || s && o || i || c;
    }, t.Range = C, C.prototype.format = function () {
      return this.range = this.set.map(function (e) {
        return e.join(" ").trim();
      }).join("||").trim(), this.range;
    }, C.prototype.toString = function () {
      return this.range;
    }, C.prototype.parseRange = function (e) {
      var t = this.options.loose;
      e = e.trim();
      var a = t ? o[c.HYPHENRANGELOOSE] : o[c.HYPHENRANGE];
      e = e.replace(a, B), r("hyphen replace", e), e = e.replace(o[c.COMPARATORTRIM], "$1$2$3"), r("comparator trim", e, o[c.COMPARATORTRIM]), e = (e = (e = e.replace(o[c.TILDETRIM], "$1~")).replace(o[c.CARETTRIM], "$1^")).split(/\s+/).join(" ");
      var n = t ? o[c.COMPARATORLOOSE] : o[c.COMPARATOR],
          s = e.split(" ").map(function (e) {
        return function (e, t) {
          return r("comp", e, t), e = function (e, t) {
            return e.trim().split(/\s+/).map(function (e) {
              return function (e, t) {
                r("caret", e, t);
                var a = t.loose ? o[c.CARETLOOSE] : o[c.CARET];
                return e.replace(a, function (t, a, n, s, o) {
                  var i;
                  return r("caret", e, t, a, n, s, o), E(a) ? i = "" : E(n) ? i = ">=" + a + ".0.0 <" + (+a + 1) + ".0.0" : E(s) ? i = "0" === a ? ">=" + a + "." + n + ".0 <" + a + "." + (+n + 1) + ".0" : ">=" + a + "." + n + ".0 <" + (+a + 1) + ".0.0" : o ? (r("replaceCaret pr", o), i = "0" === a ? "0" === n ? ">=" + a + "." + n + "." + s + "-" + o + " <" + a + "." + n + "." + (+s + 1) : ">=" + a + "." + n + "." + s + "-" + o + " <" + a + "." + (+n + 1) + ".0" : ">=" + a + "." + n + "." + s + "-" + o + " <" + (+a + 1) + ".0.0") : (r("no pr"), i = "0" === a ? "0" === n ? ">=" + a + "." + n + "." + s + " <" + a + "." + n + "." + (+s + 1) : ">=" + a + "." + n + "." + s + " <" + a + "." + (+n + 1) + ".0" : ">=" + a + "." + n + "." + s + " <" + (+a + 1) + ".0.0"), r("caret return", i), i;
                });
              }(e, t);
            }).join(" ");
          }(e, t), r("caret", e), e = function (e, t) {
            return e.trim().split(/\s+/).map(function (e) {
              return function (e, t) {
                var a = t.loose ? o[c.TILDELOOSE] : o[c.TILDE];
                return e.replace(a, function (t, a, n, s, o) {
                  var i;
                  return r("tilde", e, t, a, n, s, o), E(a) ? i = "" : E(n) ? i = ">=" + a + ".0.0 <" + (+a + 1) + ".0.0" : E(s) ? i = ">=" + a + "." + n + ".0 <" + a + "." + (+n + 1) + ".0" : o ? (r("replaceTilde pr", o), i = ">=" + a + "." + n + "." + s + "-" + o + " <" + a + "." + (+n + 1) + ".0") : i = ">=" + a + "." + n + "." + s + " <" + a + "." + (+n + 1) + ".0", r("tilde return", i), i;
                });
              }(e, t);
            }).join(" ");
          }(e, t), r("tildes", e), e = function (e, t) {
            return r("replaceXRanges", e, t), e.split(/\s+/).map(function (e) {
              return function (e, t) {
                e = e.trim();
                var a = t.loose ? o[c.XRANGELOOSE] : o[c.XRANGE];
                return e.replace(a, function (a, n, s, o, i, c) {
                  r("xRange", e, a, n, s, o, i, c);
                  var u = E(s),
                      d = u || E(o),
                      f = d || E(i),
                      l = f;
                  return "=" === n && l && (n = ""), c = t.includePrerelease ? "-0" : "", u ? a = ">" === n || "<" === n ? "<0.0.0-0" : "*" : n && l ? (d && (o = 0), i = 0, ">" === n ? (n = ">=", d ? (s = +s + 1, o = 0, i = 0) : (o = +o + 1, i = 0)) : "<=" === n && (n = "<", d ? s = +s + 1 : o = +o + 1), a = n + s + "." + o + "." + i + c) : d ? a = ">=" + s + ".0.0" + c + " <" + (+s + 1) + ".0.0" + c : f && (a = ">=" + s + "." + o + ".0" + c + " <" + s + "." + (+o + 1) + ".0" + c), r("xRange return", a), a;
                });
              }(e, t);
            }).join(" ");
          }(e, t), r("xrange", e), e = function (e, t) {
            return r("replaceStars", e, t), e.trim().replace(o[c.STAR], "");
          }(e, t), r("stars", e), e;
        }(e, this.options);
      }, this).join(" ").split(/\s+/);
      return this.options.loose && (s = s.filter(function (e) {
        return !!e.match(n);
      })), s = s.map(function (e) {
        return new x(e, this.options);
      }, this);
    }, C.prototype.intersects = function (e, t) {
      if (!(e instanceof C)) throw new TypeError("a Range is required");
      return this.set.some(function (a) {
        return S(a, t) && e.set.some(function (e) {
          return S(e, t) && a.every(function (a) {
            return e.every(function (e) {
              return a.intersects(e, t);
            });
          });
        });
      });
    }, t.toComparators = function (e, t) {
      return new C(e, t).set.map(function (e) {
        return e.map(function (e) {
          return e.value;
        }).join(" ").trim().split(" ");
      });
    }, C.prototype.test = function (e) {
      if (!e) return !1;
      if ("string" == typeof e) try {
        e = new h(e, this.options);
      } catch (e) {
        return !1;
      }

      for (var t = 0; t < this.set.length; t++) {
        if (k(this.set[t], e, this.options)) return !0;
      }

      return !1;
    }, t.satisfies = R, t.maxSatisfying = function (e, t, a) {
      var r = null,
          n = null;

      try {
        var s = new C(t, a);
      } catch (e) {
        return null;
      }

      return e.forEach(function (e) {
        s.test(e) && (r && -1 !== n.compare(e) || (n = new h(r = e, a)));
      }), r;
    }, t.minSatisfying = function (e, t, a) {
      var r = null,
          n = null;

      try {
        var s = new C(t, a);
      } catch (e) {
        return null;
      }

      return e.forEach(function (e) {
        s.test(e) && (r && 1 !== n.compare(e) || (n = new h(r = e, a)));
      }), r;
    }, t.minVersion = function (e, t) {
      e = new C(e, t);
      var a = new h("0.0.0");
      if (e.test(a)) return a;
      if (a = new h("0.0.0-0"), e.test(a)) return a;
      a = null;

      for (var r = 0; r < e.set.length; ++r) {
        e.set[r].forEach(function (e) {
          var t = new h(e.semver.version);

          switch (e.operator) {
            case ">":
              0 === t.prerelease.length ? t.patch++ : t.prerelease.push(0), t.raw = t.format();

            case "":
            case ">=":
              a && !y(a, t) || (a = t);
              break;

            case "<":
            case "<=":
              break;

            default:
              throw new Error("Unexpected operation: " + e.operator);
          }
        });
      }

      if (a && e.test(a)) return a;
      return null;
    }, t.validRange = function (e, t) {
      try {
        return new C(e, t).range || "*";
      } catch (e) {
        return null;
      }
    }, t.ltr = function (e, t, a) {
      return W(e, t, "<", a);
    }, t.gtr = function (e, t, a) {
      return W(e, t, ">", a);
    }, t.outside = W, t.prerelease = function (e, t) {
      var a = l(e, t);
      return a && a.prerelease.length ? a.prerelease : null;
    }, t.intersects = function (e, t, a) {
      return e = new C(e, a), t = new C(t, a), e.intersects(t);
    }, t.coerce = function (e, t) {
      if (e instanceof h) return e;
      "number" == typeof e && (e = String(e));
      if ("string" != typeof e) return null;
      var a = null;

      if ((t = t || {}).rtl) {
        for (var r; (r = o[c.COERCERTL].exec(e)) && (!a || a.index + a[0].length !== e.length);) {
          a && r.index + r[0].length === a.index + a[0].length || (a = r), o[c.COERCERTL].lastIndex = r.index + r[1].length + r[2].length;
        }

        o[c.COERCERTL].lastIndex = -1;
      } else a = e.match(o[c.COERCE]);

      if (null === a) return null;
      return l(a[2] + "." + (a[3] || "0") + "." + (a[4] || "0"), t);
    };
  }).call(this, a(
  /*! ./../process/browser.js */
  9));
},
/*!**********************************************************************!*\
  !*** ./src/contract_wrappers/tokens/security_token_wrapper/3.0.0.ts ***!
  \**********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r114,
      n = this && this.__extends || (_r114 = function r(e, t) {
    return (_r114 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r114(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o = s(a(
  /*! ./common */
  293)),
      i = a(
  /*! ../../../types */
  4),
      c = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.contractVersion = i.ContractVersion.V3_0_0, n.contract = a, n;
    }

    return n(t, e), t;
  }(o.default);

  t.SecurityToken_3_0_0 = c, t.isSecurityToken_3_0_0 = function (e) {
    return e.contractVersion === i.ContractVersion.V3_0_0;
  };
},
/*!********************************************!*\
  !*** ./node_modules/eth-sig-util/index.js ***!
  \********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  var _a12 = a(
  /*! buffer */
  1),
      r = _a12.Buffer,
      n = a(
  /*! ethereumjs-util */
  832),
      s = a(
  /*! ethereumjs-abi */
  833),
      o = a(
  /*! tweetnacl */
  836);

  o.util = a(
  /*! tweetnacl-util */
  838);
  var i = {
    type: "object",
    properties: {
      types: {
        type: "object",
        additionalProperties: {
          type: "array",
          items: {
            type: "object",
            properties: {
              name: {
                type: "string"
              },
              type: {
                type: "string"
              }
            },
            required: ["name", "type"]
          }
        }
      },
      primaryType: {
        type: "string"
      },
      domain: {
        type: "object"
      },
      message: {
        type: "object"
      }
    },
    required: ["types", "primaryType", "domain", "message"]
  },
      c = {
    encodeData: function encodeData(e, t, a) {
      var _this5 = this;

      var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
      var i = ["bytes32"],
          c = [this.hashType(e, a)];

      if (o) {
        var _u4 = function _u4(e, t, i) {
          if (void 0 !== a[t]) return ["bytes32", null == i ? "0x0000000000000000000000000000000000000000000000000000000000000000" : n.sha3(_this5.encodeData(t, i, a, o))];
          if (void 0 === i) throw new Error("missing value for field ".concat(e, " of type ").concat(t));
          if ("bytes" === t) return ["bytes32", n.sha3(i)];
          if ("string" === t) return "string" == typeof i && (i = r.from(i, "utf8")), ["bytes32", n.sha3(i)];

          if (t.lastIndexOf("]") === t.length - 1) {
            var _a13 = t.slice(0, t.lastIndexOf("[")),
                _r115 = i.map(function (t) {
              return _u4(e, _a13, t);
            });

            return ["bytes32", n.sha3(s.rawEncode(_r115.map(function (_ref) {
              var _ref2 = _slicedToArray(_ref, 1),
                  e = _ref2[0];

              return e;
            }), _r115.map(function (_ref3) {
              var _ref4 = _slicedToArray(_ref3, 2),
                  e = _ref4[1];

              return e;
            })))];
          }

          return [t, i];
        };

        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = a[e][Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var _r116 = _step5.value;

            var _u5 = _u4(_r116.name, _r116.type, t[_r116.name]),
                _u6 = _slicedToArray(_u5, 2),
                _e14 = _u6[0],
                _a14 = _u6[1];

            i.push(_e14), c.push(_a14);
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }
      } else {
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = a[e][Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var _s2 = _step6.value;
            var _e15 = t[_s2.name];
            if (void 0 !== _e15) if ("bytes" === _s2.type) i.push("bytes32"), _e15 = n.sha3(_e15), c.push(_e15);else if ("string" === _s2.type) i.push("bytes32"), "string" == typeof _e15 && (_e15 = r.from(_e15, "utf8")), _e15 = n.sha3(_e15), c.push(_e15);else if (void 0 !== a[_s2.type]) i.push("bytes32"), _e15 = n.sha3(this.encodeData(_s2.type, _e15, a, o)), c.push(_e15);else {
              if (_s2.type.lastIndexOf("]") === _s2.type.length - 1) throw new Error("Arrays currently unimplemented in encodeData");
              i.push(_s2.type), c.push(_e15);
            }
          }
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
              _iterator6.return();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }
      }

      return s.rawEncode(i, c);
    },
    encodeType: function encodeType(e, t) {
      var a = "",
          r = this.findTypeDependencies(e, t).filter(function (t) {
        return t !== e;
      });
      r = [e].concat(r.sort());
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = r[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var _e16 = _step7.value;
          if (!t[_e16]) throw new Error("No type definition specified: " + _e16);
          a += _e16 + "(" + t[_e16].map(function (_ref5) {
            var e = _ref5.name,
                t = _ref5.type;
            return t + " " + e;
          }).join(",") + ")";
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      return a;
    },
    findTypeDependencies: function findTypeDependencies(e, t) {
      var a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      if (e = e.match(/^\w*/)[0], a.includes(e) || void 0 === t[e]) return a;
      a.push(e);
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = t[e][Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var _r117 = _step8.value;
          var _iteratorNormalCompletion9 = true;
          var _didIteratorError9 = false;
          var _iteratorError9 = undefined;

          try {
            for (var _iterator9 = this.findTypeDependencies(_r117.type, t, a)[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
              var _e17 = _step9.value;
              !a.includes(_e17) && a.push(_e17);
            }
          } catch (err) {
            _didIteratorError9 = true;
            _iteratorError9 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
                _iterator9.return();
              }
            } finally {
              if (_didIteratorError9) {
                throw _iteratorError9;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      return a;
    },
    hashStruct: function hashStruct(e, t, a) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
      return n.sha3(this.encodeData(e, t, a, r));
    },
    hashType: function hashType(e, t) {
      return n.sha3(this.encodeType(e, t));
    },
    sanitizeData: function sanitizeData(e) {
      var t = {};

      for (var _a15 in i.properties) {
        e[_a15] && (t[_a15] = e[_a15]);
      }

      return t.types && (t.types = Object.assign({
        EIP712Domain: []
      }, t.types)), t;
    },
    sign: function sign(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var a = this.sanitizeData(e),
          s = [r.from("1901", "hex")];
      return s.push(this.hashStruct("EIP712Domain", a.domain, a.types, t)), "EIP712Domain" !== a.primaryType && s.push(this.hashStruct(a.primaryType, a.message, a.types, t)), n.sha3(r.concat(s));
    }
  };

  function u(e) {
    var t = new Error("Expect argument to be non-empty array");
    if ("object" != typeof e || !e.length) throw t;
    var a = e.map(function (e) {
      return "bytes" === e.type ? n.toBuffer(e.value) : e.value;
    }),
        r = e.map(function (e) {
      return e.type;
    }),
        o = e.map(function (e) {
      if (!e.name) throw t;
      return e.type + " " + e.name;
    });
    return s.soliditySHA3(["bytes32", "bytes32"], [s.soliditySHA3(new Array(e.length).fill("string"), o), s.soliditySHA3(r, a)]);
  }

  function d(e, t) {
    var a = n.toBuffer(t),
        r = n.fromRpcSig(a);
    return n.ecrecover(e, r.v, r.r, r.s);
  }

  function f(e) {
    var t = n.toBuffer(e.data);
    return d(n.hashPersonalMessage(t), e.sig);
  }

  function l(e, t) {
    for (var a = "" + e; a.length < t;) {
      a = "0" + a;
    }

    return a;
  }

  function h(e) {
    var t = r.from(e, "hex").toString("base64");
    return o.util.decodeBase64(t);
  }

  e.exports = {
    TYPED_MESSAGE_SCHEMA: i,
    TypedDataUtils: c,
    concatSig: function concatSig(e, t, a) {
      var r = n.fromSigned(t),
          s = n.fromSigned(a),
          o = n.bufferToInt(e),
          i = l(n.toUnsigned(r).toString("hex"), 64),
          c = l(n.toUnsigned(s).toString("hex"), 64),
          u = n.stripHexPrefix(n.intToHex(o));
      return n.addHexPrefix(i.concat(c, u)).toString("hex");
    },
    normalize: function normalize(e) {
      if (e) {
        if ("number" == typeof e) {
          var _t16 = n.toBuffer(e);

          e = n.bufferToHex(_t16);
        }

        if ("string" != typeof e) {
          var t = "eth-sig-util.normalize() requires hex string or integer input.";
          throw new Error(t += " received " + typeof e + ": " + e);
        }

        return n.addHexPrefix(e.toLowerCase());
      }
    },
    personalSign: function personalSign(e, t) {
      var a = n.toBuffer(t.data),
          r = n.hashPersonalMessage(a),
          s = n.ecsign(r, e);
      return n.bufferToHex(this.concatSig(s.v, s.r, s.s));
    },
    recoverPersonalSignature: function recoverPersonalSignature(e) {
      var t = f(e),
          a = n.publicToAddress(t);
      return n.bufferToHex(a);
    },
    extractPublicKey: function extractPublicKey(e) {
      return "0x" + f(e).toString("hex");
    },
    typedSignatureHash: function typedSignatureHash(e) {
      var t = u(e);
      return n.bufferToHex(t);
    },
    signTypedDataLegacy: function signTypedDataLegacy(e, t) {
      var a = u(t.data),
          r = n.ecsign(a, e);
      return n.bufferToHex(this.concatSig(r.v, r.r, r.s));
    },
    recoverTypedSignatureLegacy: function recoverTypedSignatureLegacy(e) {
      var t = d(u(e.data), e.sig),
          a = n.publicToAddress(t);
      return n.bufferToHex(a);
    },
    encrypt: function encrypt(e, t, a) {
      switch (a) {
        case "x25519-xsalsa20-poly1305":
          if (void 0 === t.data) throw new Error('Cannot detect secret message, message params should be of the form {data: "secret message"} ');
          var r = o.box.keyPair();

          try {
            var n = o.util.decodeBase64(e);
          } catch (e) {
            throw new Error("Bad public key");
          }

          var s = o.util.decodeUTF8(t.data),
              i = o.randomBytes(o.box.nonceLength),
              c = o.box(s, i, n, r.secretKey);
          return {
            version: "x25519-xsalsa20-poly1305",
            nonce: o.util.encodeBase64(i),
            ephemPublicKey: o.util.encodeBase64(r.publicKey),
            ciphertext: o.util.encodeBase64(c)
          };

        default:
          throw new Error("Encryption type/version not supported");
      }
    },
    encryptSafely: function encryptSafely(e, t, a) {
      var n = t.data;
      if (!n) throw new Error("Cannot encrypt empty msg.data");
      if ("object" == typeof n && n.toJSON) throw new Error("Cannot encrypt with toJSON property.  Please remove toJSON property");
      var s = {
        data: n,
        padding: ""
      },
          o = r.byteLength(JSON.stringify(s), "utf-8") % 2048;
      var i = 0;
      o > 0 && (i = 2048 - o - 16), s.padding = "0".repeat(i);
      var c = {
        data: JSON.stringify(s)
      };
      return this.encrypt(e, c, a);
    },
    decrypt: function decrypt(e, t) {
      switch (e.version) {
        case "x25519-xsalsa20-poly1305":
          var a = h(t),
              r = o.box.keyPair.fromSecretKey(a).secretKey,
              n = o.util.decodeBase64(e.nonce),
              s = o.util.decodeBase64(e.ciphertext),
              i = o.util.decodeBase64(e.ephemPublicKey),
              c = o.box.open(s, n, i, r);

          try {
            var u = o.util.encodeUTF8(c);
          } catch (e) {
            throw new Error("Decryption failed.");
          }

          if (u) return u;
          throw new Error("Decryption failed.");

        default:
          throw new Error("Encryption type/version not supported.");
      }
    },
    decryptSafely: function decryptSafely(e, t) {
      return JSON.parse(this.decrypt(e, t)).data;
    },
    getEncryptionPublicKey: function getEncryptionPublicKey(e) {
      var t = h(e),
          a = o.box.keyPair.fromSecretKey(t).publicKey;
      return o.util.encodeBase64(a);
    },
    signTypedMessage: function signTypedMessage(e, t) {
      var a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "V4";

      switch (a) {
        case "V1":
          return this.signTypedDataLegacy(e, t);

        case "V3":
          return this.signTypedData(e, t);

        case "V4":
        default:
          return this.signTypedData_v4(e, t);
      }
    },
    recoverTypedMessage: function recoverTypedMessage(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "V4";

      switch (t) {
        case "V1":
          return this.recoverTypedSignatureLegacy(e);

        case "V3":
          return this.recoverTypedSignature(e);

        case "V4":
        default:
          return this.recoverTypedSignature_v4(e);
      }
    },
    signTypedData: function signTypedData(e, t) {
      var a = c.sign(t.data, !1),
          r = n.ecsign(a, e);
      return n.bufferToHex(this.concatSig(r.v, r.r, r.s));
    },
    signTypedData_v4: function signTypedData_v4(e, t) {
      var a = c.sign(t.data),
          r = n.ecsign(a, e);
      return n.bufferToHex(this.concatSig(r.v, r.r, r.s));
    },
    recoverTypedSignature: function recoverTypedSignature(e) {
      var t = d(c.sign(e.data, !1), e.sig),
          a = n.publicToAddress(t);
      return n.bufferToHex(a);
    },
    recoverTypedSignature_v4: function recoverTypedSignature_v4(e) {
      var t = d(c.sign(e.data), e.sig),
          a = n.publicToAddress(t);
      return n.bufferToHex(a);
    }
  };
},
/*!******************************************************************************!*\
  !*** ./node_modules/eth-sig-util/node_modules/ethereumjs-util/dist/index.js ***!
  \******************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
      n = a(
  /*! keccak */
  33),
      s = a(
  /*! secp256k1 */
  30),
      o = a(
  /*! assert */
  19),
      i = a(
  /*! rlp */
  21),
      c = a(
  /*! bn.js */
  5),
      u = a(
  /*! create-hash */
  20),
      d = a(
  /*! safe-buffer */
  7).Buffer;
  Object.assign(t, a(
  /*! ethjs-util */
  36)), t.MAX_INTEGER = new c("ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff", 16), t.TWO_POW256 = new c("10000000000000000000000000000000000000000000000000000000000000000", 16), t.KECCAK256_NULL_S = "c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470", t.SHA3_NULL_S = t.KECCAK256_NULL_S, t.KECCAK256_NULL = d.from(t.KECCAK256_NULL_S, "hex"), t.SHA3_NULL = t.KECCAK256_NULL, t.KECCAK256_RLP_ARRAY_S = "1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347", t.SHA3_RLP_ARRAY_S = t.KECCAK256_RLP_ARRAY_S, t.KECCAK256_RLP_ARRAY = d.from(t.KECCAK256_RLP_ARRAY_S, "hex"), t.SHA3_RLP_ARRAY = t.KECCAK256_RLP_ARRAY, t.KECCAK256_RLP_S = "56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421", t.SHA3_RLP_S = t.KECCAK256_RLP_S, t.KECCAK256_RLP = d.from(t.KECCAK256_RLP_S, "hex"), t.SHA3_RLP = t.KECCAK256_RLP, t.BN = c, t.rlp = i, t.secp256k1 = s, t.zeros = function (e) {
    return d.allocUnsafe(e).fill(0);
  }, t.zeroAddress = function () {
    var e = t.zeros(20);
    return t.bufferToHex(e);
  }, t.setLengthLeft = t.setLength = function (e, a, r) {
    var n = t.zeros(a);
    return e = t.toBuffer(e), r ? e.length < a ? (e.copy(n), n) : e.slice(0, a) : e.length < a ? (e.copy(n, a - e.length), n) : e.slice(-a);
  }, t.setLengthRight = function (e, a) {
    return t.setLength(e, a, !0);
  }, t.unpad = t.stripZeros = function (e) {
    for (var a = (e = t.stripHexPrefix(e))[0]; e.length > 0 && "0" === a.toString();) {
      a = (e = e.slice(1))[0];
    }

    return e;
  }, t.toBuffer = function (e) {
    if (!d.isBuffer(e)) if (Array.isArray(e)) e = d.from(e);else if ("string" == typeof e) e = t.isHexString(e) ? d.from(t.padToEven(t.stripHexPrefix(e)), "hex") : d.from(e);else if ("number" == typeof e) e = t.intToBuffer(e);else if (null == e) e = d.allocUnsafe(0);else if (c.isBN(e)) e = e.toArrayLike(d);else {
      if (!e.toArray) throw new Error("invalid type");
      e = d.from(e.toArray());
    }
    return e;
  }, t.bufferToInt = function (e) {
    return new c(t.toBuffer(e)).toNumber();
  }, t.bufferToHex = function (e) {
    return "0x" + (e = t.toBuffer(e)).toString("hex");
  }, t.fromSigned = function (e) {
    return new c(e).fromTwos(256);
  }, t.toUnsigned = function (e) {
    return d.from(e.toTwos(256).toArray());
  }, t.keccak = function (e, a) {
    return e = t.toBuffer(e), a || (a = 256), n("keccak" + a).update(e).digest();
  }, t.keccak256 = function (e) {
    return t.keccak(e);
  }, t.sha3 = t.keccak, t.sha256 = function (e) {
    return e = t.toBuffer(e), u("sha256").update(e).digest();
  }, t.ripemd160 = function (e, a) {
    e = t.toBuffer(e);
    var r = u("rmd160").update(e).digest();
    return !0 === a ? t.setLength(r, 32) : r;
  }, t.rlphash = function (e) {
    return t.keccak(i.encode(e));
  }, t.isValidPrivate = function (e) {
    return s.privateKeyVerify(e);
  }, t.isValidPublic = function (e, t) {
    return 64 === e.length ? s.publicKeyVerify(d.concat([d.from([4]), e])) : !!t && s.publicKeyVerify(e);
  }, t.pubToAddress = t.publicToAddress = function (e, a) {
    return e = t.toBuffer(e), a && 64 !== e.length && (e = s.publicKeyConvert(e, !1).slice(1)), o(64 === e.length), t.keccak(e).slice(-20);
  };

  var f = t.privateToPublic = function (e) {
    return e = t.toBuffer(e), s.publicKeyCreate(e, !1).slice(1);
  };

  t.importPublic = function (e) {
    return 64 !== (e = t.toBuffer(e)).length && (e = s.publicKeyConvert(e, !1).slice(1)), e;
  }, t.ecsign = function (e, t) {
    var a = s.sign(e, t),
        r = {};
    return r.r = a.signature.slice(0, 32), r.s = a.signature.slice(32, 64), r.v = a.recovery + 27, r;
  }, t.hashPersonalMessage = function (e) {
    var a = t.toBuffer("Ethereum Signed Message:\n" + e.length.toString());
    return t.keccak(d.concat([a, e]));
  }, t.ecrecover = function (e, a, r, n) {
    var o = d.concat([t.setLength(r, 32), t.setLength(n, 32)], 64),
        i = a - 27;
    if (0 !== i && 1 !== i) throw new Error("Invalid signature v value");
    var c = s.recover(e, o, i);
    return s.publicKeyConvert(c, !1).slice(1);
  }, t.toRpcSig = function (e, a, r) {
    if (27 !== e && 28 !== e) throw new Error("Invalid recovery id");
    return t.bufferToHex(d.concat([t.setLengthLeft(a, 32), t.setLengthLeft(r, 32), t.toBuffer(e - 27)]));
  }, t.fromRpcSig = function (e) {
    if (65 !== (e = t.toBuffer(e)).length) throw new Error("Invalid signature length");
    var a = e[64];
    return a < 27 && (a += 27), {
      v: a,
      r: e.slice(0, 32),
      s: e.slice(32, 64)
    };
  }, t.privateToAddress = function (e) {
    return t.publicToAddress(f(e));
  }, t.isValidAddress = function (e) {
    return /^0x[0-9a-fA-F]{40}$/.test(e);
  }, t.isZeroAddress = function (e) {
    return t.zeroAddress() === t.addHexPrefix(e);
  }, t.toChecksumAddress = function (e) {
    e = t.stripHexPrefix(e).toLowerCase();

    for (var a = t.keccak(e).toString("hex"), r = "0x", n = 0; n < e.length; n++) {
      parseInt(a[n], 16) >= 8 ? r += e[n].toUpperCase() : r += e[n];
    }

    return r;
  }, t.isValidChecksumAddress = function (e) {
    return t.isValidAddress(e) && t.toChecksumAddress(e) === e;
  }, t.generateAddress = function (e, a) {
    return e = t.toBuffer(e), a = (a = new c(a)).isZero() ? null : d.from(a.toArray()), t.rlphash([e, a]).slice(-20);
  }, t.isPrecompiled = function (e) {
    var a = t.unpad(e);
    return 1 === a.length && a[0] >= 1 && a[0] <= 8;
  }, t.addHexPrefix = function (e) {
    return "string" != typeof e ? e : t.isHexPrefixed(e) ? e : "0x" + e;
  }, t.isValidSignature = function (e, t, a, r) {
    var n = new c("7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a0", 16),
        s = new c("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", 16);
    return 32 === t.length && 32 === a.length && (27 === e || 28 === e) && (t = new c(t), a = new c(a), !(t.isZero() || t.gt(s) || a.isZero() || a.gt(s)) && (!1 !== r || 1 !== new c(a).cmp(n)));
  }, t.baToJSON = function (e) {
    if (d.isBuffer(e)) return "0x" + e.toString("hex");

    if (e instanceof Array) {
      for (var a = [], r = 0; r < e.length; r++) {
        a.push(t.baToJSON(e[r]));
      }

      return a;
    }
  }, t.defineProperties = function (e, a, n) {
    if (e.raw = [], e._fields = [], e.toJSON = function (a) {
      if (a) {
        var r = {};
        return e._fields.forEach(function (t) {
          r[t] = "0x" + e[t].toString("hex");
        }), r;
      }

      return t.baToJSON(this.raw);
    }, e.serialize = function () {
      return i.encode(e.raw);
    }, a.forEach(function (a, r) {
      function n() {
        return e.raw[r];
      }

      function s(n) {
        "00" !== (n = t.toBuffer(n)).toString("hex") || a.allowZero || (n = d.allocUnsafe(0)), a.allowLess && a.length ? (n = t.stripZeros(n), o(a.length >= n.length, "The field " + a.name + " must not have more " + a.length + " bytes")) : a.allowZero && 0 === n.length || !a.length || o(a.length === n.length, "The field " + a.name + " must have byte length of " + a.length), e.raw[r] = n;
      }

      e._fields.push(a.name), Object.defineProperty(e, a.name, {
        enumerable: !0,
        configurable: !0,
        get: n,
        set: s
      }), a.default && (e[a.name] = a.default), a.alias && Object.defineProperty(e, a.alias, {
        enumerable: !1,
        configurable: !0,
        set: s,
        get: n
      });
    }), n) if ("string" == typeof n && (n = d.from(t.stripHexPrefix(n), "hex")), d.isBuffer(n) && (n = i.decode(n)), Array.isArray(n)) {
      if (n.length > e._fields.length) throw new Error("wrong number of fields in data");
      n.forEach(function (a, r) {
        e[e._fields[r]] = t.toBuffer(a);
      });
    } else {
      if ("object" !== (void 0 === n ? "undefined" : r(n))) throw new Error("invalid data");
      var s = Object.keys(n);
      a.forEach(function (t) {
        -1 !== s.indexOf(t.name) && (e[t.name] = n[t.name]), -1 !== s.indexOf(t.alias) && (e[t.alias] = n[t.alias]);
      });
    }
  };
},
/*!**********************************************!*\
  !*** ./node_modules/ethereumjs-abi/index.js ***!
  \**********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  e.exports = a(
  /*! ./lib/index.js */
  834);
},
/*!**************************************************!*\
  !*** ./node_modules/ethereumjs-abi/lib/index.js ***!
  \**************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    var r = a(
    /*! ethereumjs-util */
    835),
        n = a(
    /*! bn.js */
    5);

    var s = function s() {};

    function o(e) {
      return e.startsWith("int[") ? "int256" + e.slice(3) : "int" === e ? "int256" : e.startsWith("uint[") ? "uint256" + e.slice(4) : "uint" === e ? "uint256" : e.startsWith("fixed[") ? "fixed128x128" + e.slice(5) : "fixed" === e ? "fixed128x128" : e.startsWith("ufixed[") ? "ufixed128x128" + e.slice(6) : "ufixed" === e ? "ufixed128x128" : e;
    }

    function i(e) {
      return parseInt(/^\D+(\d+)$/.exec(e)[1], 10);
    }

    function c(e) {
      var t = /^\D+(\d+)x(\d+)$/.exec(e);
      return [parseInt(t[1], 10), parseInt(t[2], 10)];
    }

    function u(e) {
      var t = e.match(/(.*)\[(.*?)\]$/);
      return t ? "" === t[2] ? "dynamic" : parseInt(t[2], 10) : null;
    }

    function d(e) {
      var t = typeof e;
      if ("string" === t) return r.isHexPrefixed(e) ? new n(r.stripHexPrefix(e), 16) : new n(e, 10);
      if ("number" === t) return new n(e);
      if (e.toArray) return e;
      throw new Error("Argument is not a number");
    }

    function f(e) {
      var t = /^(\w+)\((.+)\)$/.exec(e);
      if (3 !== t.length) throw new Error("Invalid method signature");
      var a = /^(.+)\):\((.+)$/.exec(t[2]);
      return null !== a && 3 === a.length ? {
        method: t[1],
        args: a[1].split(","),
        retargs: a[2].split(",")
      } : {
        method: t[1],
        args: t[2].split(",")
      };
    }

    function l(e, a) {
      var s, o, f, h;
      if ("address" === e) return l("uint160", d(a));
      if ("bool" === e) return l("uint8", a ? 1 : 0);
      if ("string" === e) return l("bytes", new t(a, "utf8"));

      if (m(e)) {
        if (void 0 === a.length) throw new Error("Not an array?");
        if ("dynamic" !== (s = u(e)) && 0 !== s && a.length > s) throw new Error("Elements exceed array size: " + s);

        for (h in f = [], e = e.slice(0, e.lastIndexOf("[")), "string" == typeof a && (a = JSON.parse(a)), a) {
          f.push(l(e, a[h]));
        }

        if ("dynamic" === s) {
          var p = l("uint256", a.length);
          f.unshift(p);
        }

        return t.concat(f);
      }

      if ("bytes" === e) return a = new t(a), f = t.concat([l("uint256", a.length), a]), a.length % 32 != 0 && (f = t.concat([f, r.zeros(32 - a.length % 32)])), f;

      if (e.startsWith("bytes")) {
        if ((s = i(e)) < 1 || s > 32) throw new Error("Invalid bytes<N> width: " + s);
        return r.setLengthRight(a, 32);
      }

      if (e.startsWith("uint")) {
        if ((s = i(e)) % 8 || s < 8 || s > 256) throw new Error("Invalid uint<N> width: " + s);
        if ((o = d(a)).bitLength() > s) throw new Error("Supplied uint exceeds width: " + s + " vs " + o.bitLength());
        if (o < 0) throw new Error("Supplied uint is negative");
        return o.toArrayLike(t, "be", 32);
      }

      if (e.startsWith("int")) {
        if ((s = i(e)) % 8 || s < 8 || s > 256) throw new Error("Invalid int<N> width: " + s);
        if ((o = d(a)).bitLength() > s) throw new Error("Supplied int exceeds width: " + s + " vs " + o.bitLength());
        return o.toTwos(256).toArrayLike(t, "be", 32);
      }

      if (e.startsWith("ufixed")) {
        if (s = c(e), (o = d(a)) < 0) throw new Error("Supplied ufixed is negative");
        return l("uint256", o.mul(new n(2).pow(new n(s[1]))));
      }

      if (e.startsWith("fixed")) return s = c(e), l("int256", d(a).mul(new n(2).pow(new n(s[1]))));
      throw new Error("Unsupported or invalid type: " + e);
    }

    function h(e, a, r) {
      var s, o, i, c;
      if ("string" == typeof e && (e = p(e)), "address" === e.name) return h(e.rawType, a, r).toArrayLike(t, "be", 20).toString("hex");
      if ("bool" === e.name) return h(e.rawType, a, r).toString() === new n(1).toString();

      if ("string" === e.name) {
        var u = h(e.rawType, a, r);
        return new t(u, "utf8").toString();
      }

      if (e.isArray) {
        for (i = [], s = e.size, "dynamic" === e.size && (r = h("uint256", a, r).toNumber(), s = h("uint256", a, r).toNumber(), r += 32), c = 0; c < s; c++) {
          var d = h(e.subArray, a, r);
          i.push(d), r += e.subArray.memoryUsage;
        }

        return i;
      }

      if ("bytes" === e.name) return r = h("uint256", a, r).toNumber(), s = h("uint256", a, r).toNumber(), a.slice(r + 32, r + 32 + s);
      if (e.name.startsWith("bytes")) return a.slice(r, r + e.size);

      if (e.name.startsWith("uint")) {
        if ((o = new n(a.slice(r, r + 32), 16, "be")).bitLength() > e.size) throw new Error("Decoded int exceeds width: " + e.size + " vs " + o.bitLength());
        return o;
      }

      if (e.name.startsWith("int")) {
        if ((o = new n(a.slice(r, r + 32), 16, "be").fromTwos(256)).bitLength() > e.size) throw new Error("Decoded uint exceeds width: " + e.size + " vs " + o.bitLength());
        return o;
      }

      if (e.name.startsWith("ufixed")) {
        if (s = new n(2).pow(new n(e.size[1])), !(o = h("uint256", a, r)).mod(s).isZero()) throw new Error("Decimals not supported yet");
        return o.div(s);
      }

      if (e.name.startsWith("fixed")) {
        if (s = new n(2).pow(new n(e.size[1])), !(o = h("int256", a, r)).mod(s).isZero()) throw new Error("Decimals not supported yet");
        return o.div(s);
      }

      throw new Error("Unsupported or invalid type: " + e.name);
    }

    function p(e) {
      var t, a, r;

      if (m(e)) {
        t = u(e);
        var n = e.slice(0, e.lastIndexOf("["));
        return n = p(n), a = {
          isArray: !0,
          name: e,
          size: t,
          memoryUsage: "dynamic" === t ? 32 : n.memoryUsage * t,
          subArray: n
        };
      }

      switch (e) {
        case "address":
          r = "uint160";
          break;

        case "bool":
          r = "uint8";
          break;

        case "string":
          r = "bytes";
      }

      if (a = {
        rawType: r,
        name: e,
        memoryUsage: 32
      }, e.startsWith("bytes") && "bytes" !== e || e.startsWith("uint") || e.startsWith("int") ? a.size = i(e) : (e.startsWith("ufixed") || e.startsWith("fixed")) && (a.size = c(e)), e.startsWith("bytes") && "bytes" !== e && (a.size < 1 || a.size > 32)) throw new Error("Invalid bytes<N> width: " + a.size);
      if ((e.startsWith("uint") || e.startsWith("int")) && (a.size % 8 || a.size < 8 || a.size > 256)) throw new Error("Invalid int/uint<N> width: " + a.size);
      return a;
    }

    function b(e) {
      return "string" === e || "bytes" === e || "dynamic" === u(e);
    }

    function m(e) {
      return e.lastIndexOf("]") === e.length - 1;
    }

    function y(e, t) {
      return e.startsWith("address") || e.startsWith("bytes") ? "0x" + t.toString("hex") : t.toString();
    }

    s.eventID = function (e, a) {
      var n = e + "(" + a.map(o).join(",") + ")";
      return r.sha3(new t(n));
    }, s.methodID = function (e, t) {
      return s.eventID(e, t).slice(0, 4);
    }, s.rawEncode = function (e, a) {
      var r = [],
          n = [],
          s = 32 * e.length;

      for (var i in e) {
        var c = o(e[i]),
            u = l(c, a[i]);
        b(c) ? (r.push(l("uint256", s)), n.push(u), s += u.length) : r.push(u);
      }

      return t.concat(r.concat(n));
    }, s.rawDecode = function (e, a) {
      var r = [];
      a = new t(a);
      var n = 0;

      for (var s in e) {
        var i = p(o(e[s])),
            c = h(i, a, n);
        n += i.memoryUsage, r.push(c);
      }

      return r;
    }, s.simpleEncode = function (e) {
      var a = Array.prototype.slice.call(arguments).slice(1),
          r = f(e);
      if (a.length !== r.args.length) throw new Error("Argument count mismatch");
      return t.concat([s.methodID(r.method, r.args), s.rawEncode(r.args, a)]);
    }, s.simpleDecode = function (e, t) {
      var a = f(e);
      if (!a.retargs) throw new Error("No return values in method");
      return s.rawDecode(a.retargs, t);
    }, s.stringify = function (e, t) {
      var a = [];

      for (var r in e) {
        var n = e[r],
            s = t[r];
        s = /^[^\[]+\[.*\]$/.test(n) ? s.map(function (e) {
          return y(n, e);
        }).join(", ") : y(n, s), a.push(s);
      }

      return a;
    }, s.solidityPack = function (e, a) {
      if (e.length !== a.length) throw new Error("Number of types are not matching the values");

      for (var n, s, c = [], u = 0; u < e.length; u++) {
        var f = o(e[u]),
            l = a[u];
        if ("bytes" === f) c.push(l);else if ("string" === f) c.push(new t(l, "utf8"));else if ("bool" === f) c.push(new t(l ? "01" : "00", "hex"));else if ("address" === f) c.push(r.setLengthLeft(l, 20));else if (f.startsWith("bytes")) {
          if ((n = i(f)) < 1 || n > 32) throw new Error("Invalid bytes<N> width: " + n);
          c.push(r.setLengthRight(l, n));
        } else if (f.startsWith("uint")) {
          if ((n = i(f)) % 8 || n < 8 || n > 256) throw new Error("Invalid uint<N> width: " + n);
          if ((s = d(l)).bitLength() > n) throw new Error("Supplied uint exceeds width: " + n + " vs " + s.bitLength());
          c.push(s.toArrayLike(t, "be", n / 8));
        } else {
          if (!f.startsWith("int")) throw new Error("Unsupported or invalid type: " + f);
          if ((n = i(f)) % 8 || n < 8 || n > 256) throw new Error("Invalid int<N> width: " + n);
          if ((s = d(l)).bitLength() > n) throw new Error("Supplied int exceeds width: " + n + " vs " + s.bitLength());
          c.push(s.toTwos(n).toArrayLike(t, "be", n / 8));
        }
      }

      return t.concat(c);
    }, s.soliditySHA3 = function (e, t) {
      return r.sha3(s.solidityPack(e, t));
    }, s.soliditySHA256 = function (e, t) {
      return r.sha256(s.solidityPack(e, t));
    }, s.solidityRIPEMD160 = function (e, t) {
      return r.ripemd160(s.solidityPack(e, t), !0);
    }, s.fromSerpent = function (e) {
      for (var t, a = [], r = 0; r < e.length; r++) {
        var n = e[r];
        if ("s" === n) a.push("bytes");else if ("b" === n) {
          for (var s = "bytes", o = r + 1; o < e.length && (t = e[o]) >= "0" && t <= "9";) {
            s += e[o] - "0", o++;
          }

          r = o - 1, a.push(s);
        } else if ("i" === n) a.push("int256");else {
          if ("a" !== n) throw new Error("Unsupported or invalid type: " + n);
          a.push("int256[]");
        }
      }

      return a;
    }, s.toSerpent = function (e) {
      for (var t = [], a = 0; a < e.length; a++) {
        var r = e[a];
        if ("bytes" === r) t.push("s");else if (r.startsWith("bytes")) t.push("b" + i(r));else if ("int256" === r) t.push("i");else {
          if ("int256[]" !== r) throw new Error("Unsupported or invalid type: " + r);
          t.push("a");
        }
      }

      return t.join("");
    }, e.exports = s;
  }).call(this, a(
  /*! ./../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!***************************************************************************!*\
  !*** ./node_modules/ethereumjs-abi/node_modules/ethereumjs-util/index.js ***!
  \***************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (e) {
    var r = a(
    /*! keccakjs */
    213),
        n = a(
    /*! secp256k1 */
    30),
        s = a(
    /*! assert */
    19),
        o = a(
    /*! rlp */
    21),
        i = a(
    /*! bn.js */
    5),
        c = a(
    /*! create-hash */
    20);
    t.MAX_INTEGER = new i("ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff", 16), t.TWO_POW256 = new i("10000000000000000000000000000000000000000000000000000000000000000", 16), t.SHA3_NULL_S = "c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470", t.SHA3_NULL = new e(t.SHA3_NULL_S, "hex"), t.SHA3_RLP_ARRAY_S = "1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347", t.SHA3_RLP_ARRAY = new e(t.SHA3_RLP_ARRAY_S, "hex"), t.SHA3_RLP_S = "56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421", t.SHA3_RLP = new e(t.SHA3_RLP_S, "hex"), t.BN = i, t.rlp = o, t.secp256k1 = n, t.zeros = function (t) {
      var a = new e(t);
      return a.fill(0), a;
    }, t.setLengthLeft = t.setLength = function (e, a, r) {
      var n = t.zeros(a);
      return e = t.toBuffer(e), r ? e.length < a ? (e.copy(n), n) : e.slice(0, a) : e.length < a ? (e.copy(n, a - e.length), n) : e.slice(-a);
    }, t.setLengthRight = function (e, a) {
      return t.setLength(e, a, !0);
    }, t.unpad = t.stripZeros = function (e) {
      for (var a = (e = t.stripHexPrefix(e))[0]; e.length > 0 && "0" === a.toString();) {
        a = (e = e.slice(1))[0];
      }

      return e;
    }, t.toBuffer = function (a) {
      if (!e.isBuffer(a)) if (Array.isArray(a)) a = new e(a);else if ("string" == typeof a) a = t.isHexPrefixed(a) ? new e(t.padToEven(t.stripHexPrefix(a)), "hex") : new e(a);else if ("number" == typeof a) a = t.intToBuffer(a);else if (null == a) a = new e([]);else {
        if (!a.toArray) throw new Error("invalid type");
        a = new e(a.toArray());
      }
      return a;
    }, t.intToHex = function (e) {
      s(e % 1 == 0, "number is not a integer"), s(e >= 0, "number must be positive");
      var t = e.toString(16);
      return t.length % 2 && (t = "0" + t), "0x" + t;
    }, t.intToBuffer = function (a) {
      var r = t.intToHex(a);
      return new e(r.slice(2), "hex");
    }, t.bufferToInt = function (e) {
      return parseInt(t.bufferToHex(e), 16);
    }, t.bufferToHex = function (e) {
      return 0 === (e = t.toBuffer(e)).length ? 0 : "0x" + e.toString("hex");
    }, t.fromSigned = function (e) {
      return new i(e).fromTwos(256);
    }, t.toUnsigned = function (t) {
      return new e(t.toTwos(256).toArray());
    }, t.sha3 = function (a, n) {
      a = t.toBuffer(a), n || (n = 256);
      var s = new r(n);
      return a && s.update(a), new e(s.digest("hex"), "hex");
    }, t.sha256 = function (e) {
      return e = t.toBuffer(e), c("sha256").update(e).digest();
    }, t.ripemd160 = function (e, a) {
      e = t.toBuffer(e);
      var r = c("rmd160").update(e).digest();
      return !0 === a ? t.setLength(r, 32) : r;
    }, t.rlphash = function (e) {
      return t.sha3(o.encode(e));
    }, t.isValidPrivate = function (e) {
      return n.privateKeyVerify(e);
    }, t.isValidPublic = function (t, a) {
      return 64 === t.length ? n.publicKeyVerify(e.concat([new e([4]), t])) : !!a && n.publicKeyVerify(t);
    }, t.pubToAddress = t.publicToAddress = function (e, a) {
      return e = t.toBuffer(e), a && 64 !== e.length && (e = n.publicKeyConvert(e, !1).slice(1)), s(64 === e.length), t.sha3(e).slice(-20);
    };

    var u = t.privateToPublic = function (e) {
      return e = t.toBuffer(e), n.publicKeyCreate(e, !1).slice(1);
    };

    t.importPublic = function (e) {
      return 64 !== (e = t.toBuffer(e)).length && (e = n.publicKeyConvert(e, !1).slice(1)), e;
    }, t.ecsign = function (e, t) {
      var a = n.sign(e, t),
          r = {};
      return r.r = a.signature.slice(0, 32), r.s = a.signature.slice(32, 64), r.v = a.recovery + 27, r;
    }, t.ecrecover = function (a, r, s, o) {
      var i = e.concat([t.setLength(s, 32), t.setLength(o, 32)], 64),
          c = t.bufferToInt(r) - 27;
      if (0 !== c && 1 !== c) throw new Error("Invalid signature v value");
      var u = n.recover(a, i, c);
      return n.publicKeyConvert(u, !1).slice(1);
    }, t.toRpcSig = function (a, r, n) {
      return t.bufferToHex(e.concat([r, n, t.toBuffer(a - 27)]));
    }, t.fromRpcSig = function (e) {
      var a = (e = t.toBuffer(e))[64];
      return a < 27 && (a += 27), {
        v: a,
        r: e.slice(0, 32),
        s: e.slice(32, 64)
      };
    }, t.privateToAddress = function (e) {
      return t.publicToAddress(u(e));
    }, t.isValidAddress = function (e) {
      return /^0x[0-9a-fA-F]{40}$/i.test(e);
    }, t.toChecksumAddress = function (e) {
      e = t.stripHexPrefix(e).toLowerCase();

      for (var a = t.sha3(e).toString("hex"), r = "0x", n = 0; n < e.length; n++) {
        parseInt(a[n], 16) >= 8 ? r += e[n].toUpperCase() : r += e[n];
      }

      return r;
    }, t.isValidChecksumAddress = function (e) {
      return t.isValidAddress(e) && t.toChecksumAddress(e) === e;
    }, t.generateAddress = function (a, r) {
      return a = t.toBuffer(a), r = (r = new i(r)).isZero() ? null : new e(r.toArray()), t.rlphash([a, r]).slice(-20);
    }, t.isPrecompiled = function (e) {
      var a = t.unpad(e);
      return 1 === a.length && a[0] > 0 && a[0] < 5;
    }, t.isHexPrefixed = function (e) {
      return "0x" === e.slice(0, 2);
    }, t.stripHexPrefix = function (e) {
      return "string" != typeof e ? e : t.isHexPrefixed(e) ? e.slice(2) : e;
    }, t.addHexPrefix = function (e) {
      return "string" != typeof e ? e : t.isHexPrefixed(e) ? e : "0x" + e;
    }, t.padToEven = function (e) {
      return e.length % 2 && (e = "0" + e), e;
    }, t.baToJSON = function (a) {
      if (e.isBuffer(a)) return "0x" + a.toString("hex");

      if (a instanceof Array) {
        for (var r = [], n = 0; n < a.length; n++) {
          r.push(t.baToJSON(a[n]));
        }

        return r;
      }
    }, t.defineProperties = function (a, r, n) {
      if (a.raw = [], a._fields = [], a.toJSON = function (e) {
        if (e) {
          var r = {};
          return a._fields.forEach(function (e) {
            r[e] = "0x" + a[e].toString("hex");
          }), r;
        }

        return t.baToJSON(this.raw);
      }, a.serialize = function () {
        return o.encode(a.raw);
      }, r.forEach(function (r, n) {
        function o() {
          return a.raw[n];
        }

        function i(o) {
          "00" !== (o = t.toBuffer(o)).toString("hex") || r.allowZero || (o = new e([])), r.allowLess && r.length ? (o = t.stripZeros(o), s(r.length >= o.length, "The field " + r.name + " must not have more " + r.length + " bytes")) : r.allowZero && 0 === o.length || !r.length || s(r.length === o.length, "The field " + r.name + " must have byte length of " + r.length), a.raw[n] = o;
        }

        a._fields.push(r.name), Object.defineProperty(a, r.name, {
          enumerable: !0,
          configurable: !0,
          get: o,
          set: i
        }), r.default && (a[r.name] = r.default), r.alias && Object.defineProperty(a, r.alias, {
          enumerable: !1,
          configurable: !0,
          set: i,
          get: o
        });
      }), n) if ("string" == typeof n && (n = new e(t.stripHexPrefix(n), "hex")), e.isBuffer(n) && (n = o.decode(n)), Array.isArray(n)) {
        if (n.length > a._fields.length) throw new Error("wrong number of fields in data");
        n.forEach(function (e, r) {
          a[a._fields[r]] = t.toBuffer(e);
        });
      } else {
        if ("object" != typeof n) throw new Error("invalid data");

        for (var i in n) {
          -1 !== a._fields.indexOf(i) && (a[i] = n[i]);
        }
      }
    };
  }).call(this, a(
  /*! ./../../../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!***********************************************************************!*\
  !*** ./node_modules/eth-sig-util/node_modules/tweetnacl/nacl-fast.js ***!
  \***********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  !function (e) {
    "use strict";

    var t = function t(e) {
      var t,
          a = new Float64Array(16);
      if (e) for (t = 0; t < e.length; t++) {
        a[t] = e[t];
      }
      return a;
    },
        r = function r() {
      throw new Error("no PRNG");
    },
        n = new Uint8Array(16),
        s = new Uint8Array(32);

    s[0] = 9;
    var o = t(),
        i = t([1]),
        c = t([56129, 1]),
        u = t([30883, 4953, 19914, 30187, 55467, 16705, 2637, 112, 59544, 30585, 16505, 36039, 65139, 11119, 27886, 20995]),
        d = t([61785, 9906, 39828, 60374, 45398, 33411, 5274, 224, 53552, 61171, 33010, 6542, 64743, 22239, 55772, 9222]),
        f = t([54554, 36645, 11616, 51542, 42930, 38181, 51040, 26924, 56412, 64982, 57905, 49316, 21502, 52590, 14035, 8553]),
        l = t([26200, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214]),
        h = t([41136, 18958, 6951, 50414, 58488, 44335, 6150, 12099, 55207, 15867, 153, 11085, 57099, 20417, 9344, 11139]);

    function p(e, t, a, r) {
      e[t] = a >> 24 & 255, e[t + 1] = a >> 16 & 255, e[t + 2] = a >> 8 & 255, e[t + 3] = 255 & a, e[t + 4] = r >> 24 & 255, e[t + 5] = r >> 16 & 255, e[t + 6] = r >> 8 & 255, e[t + 7] = 255 & r;
    }

    function b(e, t, a, r, n) {
      var s,
          o = 0;

      for (s = 0; s < n; s++) {
        o |= e[t + s] ^ a[r + s];
      }

      return (1 & o - 1 >>> 8) - 1;
    }

    function m(e, t, a, r) {
      return b(e, t, a, r, 16);
    }

    function y(e, t, a, r) {
      return b(e, t, a, r, 32);
    }

    function v(e, t, a, r) {
      !function (e, t, a, r) {
        for (var n, s = 255 & r[0] | (255 & r[1]) << 8 | (255 & r[2]) << 16 | (255 & r[3]) << 24, o = 255 & a[0] | (255 & a[1]) << 8 | (255 & a[2]) << 16 | (255 & a[3]) << 24, i = 255 & a[4] | (255 & a[5]) << 8 | (255 & a[6]) << 16 | (255 & a[7]) << 24, c = 255 & a[8] | (255 & a[9]) << 8 | (255 & a[10]) << 16 | (255 & a[11]) << 24, u = 255 & a[12] | (255 & a[13]) << 8 | (255 & a[14]) << 16 | (255 & a[15]) << 24, d = 255 & r[4] | (255 & r[5]) << 8 | (255 & r[6]) << 16 | (255 & r[7]) << 24, f = 255 & t[0] | (255 & t[1]) << 8 | (255 & t[2]) << 16 | (255 & t[3]) << 24, l = 255 & t[4] | (255 & t[5]) << 8 | (255 & t[6]) << 16 | (255 & t[7]) << 24, h = 255 & t[8] | (255 & t[9]) << 8 | (255 & t[10]) << 16 | (255 & t[11]) << 24, p = 255 & t[12] | (255 & t[13]) << 8 | (255 & t[14]) << 16 | (255 & t[15]) << 24, b = 255 & r[8] | (255 & r[9]) << 8 | (255 & r[10]) << 16 | (255 & r[11]) << 24, m = 255 & a[16] | (255 & a[17]) << 8 | (255 & a[18]) << 16 | (255 & a[19]) << 24, y = 255 & a[20] | (255 & a[21]) << 8 | (255 & a[22]) << 16 | (255 & a[23]) << 24, v = 255 & a[24] | (255 & a[25]) << 8 | (255 & a[26]) << 16 | (255 & a[27]) << 24, _ = 255 & a[28] | (255 & a[29]) << 8 | (255 & a[30]) << 16 | (255 & a[31]) << 24, g = 255 & r[12] | (255 & r[13]) << 8 | (255 & r[14]) << 16 | (255 & r[15]) << 24, A = s, w = o, T = i, x = c, D = u, C = d, S = f, E = l, B = h, k = p, R = b, W = m, I = y, N = v, M = _, P = g, L = 0; L < 20; L += 2) {
          A ^= (n = (I ^= (n = (B ^= (n = (D ^= (n = A + I | 0) << 7 | n >>> 25) + A | 0) << 9 | n >>> 23) + D | 0) << 13 | n >>> 19) + B | 0) << 18 | n >>> 14, C ^= (n = (w ^= (n = (N ^= (n = (k ^= (n = C + w | 0) << 7 | n >>> 25) + C | 0) << 9 | n >>> 23) + k | 0) << 13 | n >>> 19) + N | 0) << 18 | n >>> 14, R ^= (n = (S ^= (n = (T ^= (n = (M ^= (n = R + S | 0) << 7 | n >>> 25) + R | 0) << 9 | n >>> 23) + M | 0) << 13 | n >>> 19) + T | 0) << 18 | n >>> 14, P ^= (n = (W ^= (n = (E ^= (n = (x ^= (n = P + W | 0) << 7 | n >>> 25) + P | 0) << 9 | n >>> 23) + x | 0) << 13 | n >>> 19) + E | 0) << 18 | n >>> 14, A ^= (n = (x ^= (n = (T ^= (n = (w ^= (n = A + x | 0) << 7 | n >>> 25) + A | 0) << 9 | n >>> 23) + w | 0) << 13 | n >>> 19) + T | 0) << 18 | n >>> 14, C ^= (n = (D ^= (n = (E ^= (n = (S ^= (n = C + D | 0) << 7 | n >>> 25) + C | 0) << 9 | n >>> 23) + S | 0) << 13 | n >>> 19) + E | 0) << 18 | n >>> 14, R ^= (n = (k ^= (n = (B ^= (n = (W ^= (n = R + k | 0) << 7 | n >>> 25) + R | 0) << 9 | n >>> 23) + W | 0) << 13 | n >>> 19) + B | 0) << 18 | n >>> 14, P ^= (n = (M ^= (n = (N ^= (n = (I ^= (n = P + M | 0) << 7 | n >>> 25) + P | 0) << 9 | n >>> 23) + I | 0) << 13 | n >>> 19) + N | 0) << 18 | n >>> 14;
        }

        A = A + s | 0, w = w + o | 0, T = T + i | 0, x = x + c | 0, D = D + u | 0, C = C + d | 0, S = S + f | 0, E = E + l | 0, B = B + h | 0, k = k + p | 0, R = R + b | 0, W = W + m | 0, I = I + y | 0, N = N + v | 0, M = M + _ | 0, P = P + g | 0, e[0] = A >>> 0 & 255, e[1] = A >>> 8 & 255, e[2] = A >>> 16 & 255, e[3] = A >>> 24 & 255, e[4] = w >>> 0 & 255, e[5] = w >>> 8 & 255, e[6] = w >>> 16 & 255, e[7] = w >>> 24 & 255, e[8] = T >>> 0 & 255, e[9] = T >>> 8 & 255, e[10] = T >>> 16 & 255, e[11] = T >>> 24 & 255, e[12] = x >>> 0 & 255, e[13] = x >>> 8 & 255, e[14] = x >>> 16 & 255, e[15] = x >>> 24 & 255, e[16] = D >>> 0 & 255, e[17] = D >>> 8 & 255, e[18] = D >>> 16 & 255, e[19] = D >>> 24 & 255, e[20] = C >>> 0 & 255, e[21] = C >>> 8 & 255, e[22] = C >>> 16 & 255, e[23] = C >>> 24 & 255, e[24] = S >>> 0 & 255, e[25] = S >>> 8 & 255, e[26] = S >>> 16 & 255, e[27] = S >>> 24 & 255, e[28] = E >>> 0 & 255, e[29] = E >>> 8 & 255, e[30] = E >>> 16 & 255, e[31] = E >>> 24 & 255, e[32] = B >>> 0 & 255, e[33] = B >>> 8 & 255, e[34] = B >>> 16 & 255, e[35] = B >>> 24 & 255, e[36] = k >>> 0 & 255, e[37] = k >>> 8 & 255, e[38] = k >>> 16 & 255, e[39] = k >>> 24 & 255, e[40] = R >>> 0 & 255, e[41] = R >>> 8 & 255, e[42] = R >>> 16 & 255, e[43] = R >>> 24 & 255, e[44] = W >>> 0 & 255, e[45] = W >>> 8 & 255, e[46] = W >>> 16 & 255, e[47] = W >>> 24 & 255, e[48] = I >>> 0 & 255, e[49] = I >>> 8 & 255, e[50] = I >>> 16 & 255, e[51] = I >>> 24 & 255, e[52] = N >>> 0 & 255, e[53] = N >>> 8 & 255, e[54] = N >>> 16 & 255, e[55] = N >>> 24 & 255, e[56] = M >>> 0 & 255, e[57] = M >>> 8 & 255, e[58] = M >>> 16 & 255, e[59] = M >>> 24 & 255, e[60] = P >>> 0 & 255, e[61] = P >>> 8 & 255, e[62] = P >>> 16 & 255, e[63] = P >>> 24 & 255;
      }(e, t, a, r);
    }

    function _(e, t, a, r) {
      !function (e, t, a, r) {
        for (var n, s = 255 & r[0] | (255 & r[1]) << 8 | (255 & r[2]) << 16 | (255 & r[3]) << 24, o = 255 & a[0] | (255 & a[1]) << 8 | (255 & a[2]) << 16 | (255 & a[3]) << 24, i = 255 & a[4] | (255 & a[5]) << 8 | (255 & a[6]) << 16 | (255 & a[7]) << 24, c = 255 & a[8] | (255 & a[9]) << 8 | (255 & a[10]) << 16 | (255 & a[11]) << 24, u = 255 & a[12] | (255 & a[13]) << 8 | (255 & a[14]) << 16 | (255 & a[15]) << 24, d = 255 & r[4] | (255 & r[5]) << 8 | (255 & r[6]) << 16 | (255 & r[7]) << 24, f = 255 & t[0] | (255 & t[1]) << 8 | (255 & t[2]) << 16 | (255 & t[3]) << 24, l = 255 & t[4] | (255 & t[5]) << 8 | (255 & t[6]) << 16 | (255 & t[7]) << 24, h = 255 & t[8] | (255 & t[9]) << 8 | (255 & t[10]) << 16 | (255 & t[11]) << 24, p = 255 & t[12] | (255 & t[13]) << 8 | (255 & t[14]) << 16 | (255 & t[15]) << 24, b = 255 & r[8] | (255 & r[9]) << 8 | (255 & r[10]) << 16 | (255 & r[11]) << 24, m = 255 & a[16] | (255 & a[17]) << 8 | (255 & a[18]) << 16 | (255 & a[19]) << 24, y = 255 & a[20] | (255 & a[21]) << 8 | (255 & a[22]) << 16 | (255 & a[23]) << 24, v = 255 & a[24] | (255 & a[25]) << 8 | (255 & a[26]) << 16 | (255 & a[27]) << 24, _ = 255 & a[28] | (255 & a[29]) << 8 | (255 & a[30]) << 16 | (255 & a[31]) << 24, g = 255 & r[12] | (255 & r[13]) << 8 | (255 & r[14]) << 16 | (255 & r[15]) << 24, A = 0; A < 20; A += 2) {
          s ^= (n = (y ^= (n = (h ^= (n = (u ^= (n = s + y | 0) << 7 | n >>> 25) + s | 0) << 9 | n >>> 23) + u | 0) << 13 | n >>> 19) + h | 0) << 18 | n >>> 14, d ^= (n = (o ^= (n = (v ^= (n = (p ^= (n = d + o | 0) << 7 | n >>> 25) + d | 0) << 9 | n >>> 23) + p | 0) << 13 | n >>> 19) + v | 0) << 18 | n >>> 14, b ^= (n = (f ^= (n = (i ^= (n = (_ ^= (n = b + f | 0) << 7 | n >>> 25) + b | 0) << 9 | n >>> 23) + _ | 0) << 13 | n >>> 19) + i | 0) << 18 | n >>> 14, g ^= (n = (m ^= (n = (l ^= (n = (c ^= (n = g + m | 0) << 7 | n >>> 25) + g | 0) << 9 | n >>> 23) + c | 0) << 13 | n >>> 19) + l | 0) << 18 | n >>> 14, s ^= (n = (c ^= (n = (i ^= (n = (o ^= (n = s + c | 0) << 7 | n >>> 25) + s | 0) << 9 | n >>> 23) + o | 0) << 13 | n >>> 19) + i | 0) << 18 | n >>> 14, d ^= (n = (u ^= (n = (l ^= (n = (f ^= (n = d + u | 0) << 7 | n >>> 25) + d | 0) << 9 | n >>> 23) + f | 0) << 13 | n >>> 19) + l | 0) << 18 | n >>> 14, b ^= (n = (p ^= (n = (h ^= (n = (m ^= (n = b + p | 0) << 7 | n >>> 25) + b | 0) << 9 | n >>> 23) + m | 0) << 13 | n >>> 19) + h | 0) << 18 | n >>> 14, g ^= (n = (_ ^= (n = (v ^= (n = (y ^= (n = g + _ | 0) << 7 | n >>> 25) + g | 0) << 9 | n >>> 23) + y | 0) << 13 | n >>> 19) + v | 0) << 18 | n >>> 14;
        }

        e[0] = s >>> 0 & 255, e[1] = s >>> 8 & 255, e[2] = s >>> 16 & 255, e[3] = s >>> 24 & 255, e[4] = d >>> 0 & 255, e[5] = d >>> 8 & 255, e[6] = d >>> 16 & 255, e[7] = d >>> 24 & 255, e[8] = b >>> 0 & 255, e[9] = b >>> 8 & 255, e[10] = b >>> 16 & 255, e[11] = b >>> 24 & 255, e[12] = g >>> 0 & 255, e[13] = g >>> 8 & 255, e[14] = g >>> 16 & 255, e[15] = g >>> 24 & 255, e[16] = f >>> 0 & 255, e[17] = f >>> 8 & 255, e[18] = f >>> 16 & 255, e[19] = f >>> 24 & 255, e[20] = l >>> 0 & 255, e[21] = l >>> 8 & 255, e[22] = l >>> 16 & 255, e[23] = l >>> 24 & 255, e[24] = h >>> 0 & 255, e[25] = h >>> 8 & 255, e[26] = h >>> 16 & 255, e[27] = h >>> 24 & 255, e[28] = p >>> 0 & 255, e[29] = p >>> 8 & 255, e[30] = p >>> 16 & 255, e[31] = p >>> 24 & 255;
      }(e, t, a, r);
    }

    var g = new Uint8Array([101, 120, 112, 97, 110, 100, 32, 51, 50, 45, 98, 121, 116, 101, 32, 107]);

    function A(e, t, a, r, n, s, o) {
      var i,
          c,
          u = new Uint8Array(16),
          d = new Uint8Array(64);

      for (c = 0; c < 16; c++) {
        u[c] = 0;
      }

      for (c = 0; c < 8; c++) {
        u[c] = s[c];
      }

      for (; n >= 64;) {
        for (v(d, u, o, g), c = 0; c < 64; c++) {
          e[t + c] = a[r + c] ^ d[c];
        }

        for (i = 1, c = 8; c < 16; c++) {
          i = i + (255 & u[c]) | 0, u[c] = 255 & i, i >>>= 8;
        }

        n -= 64, t += 64, r += 64;
      }

      if (n > 0) for (v(d, u, o, g), c = 0; c < n; c++) {
        e[t + c] = a[r + c] ^ d[c];
      }
      return 0;
    }

    function w(e, t, a, r, n) {
      var s,
          o,
          i = new Uint8Array(16),
          c = new Uint8Array(64);

      for (o = 0; o < 16; o++) {
        i[o] = 0;
      }

      for (o = 0; o < 8; o++) {
        i[o] = r[o];
      }

      for (; a >= 64;) {
        for (v(c, i, n, g), o = 0; o < 64; o++) {
          e[t + o] = c[o];
        }

        for (s = 1, o = 8; o < 16; o++) {
          s = s + (255 & i[o]) | 0, i[o] = 255 & s, s >>>= 8;
        }

        a -= 64, t += 64;
      }

      if (a > 0) for (v(c, i, n, g), o = 0; o < a; o++) {
        e[t + o] = c[o];
      }
      return 0;
    }

    function T(e, t, a, r, n) {
      var s = new Uint8Array(32);

      _(s, r, n, g);

      for (var o = new Uint8Array(8), i = 0; i < 8; i++) {
        o[i] = r[i + 16];
      }

      return w(e, t, a, o, s);
    }

    function x(e, t, a, r, n, s, o) {
      var i = new Uint8Array(32);

      _(i, s, o, g);

      for (var c = new Uint8Array(8), u = 0; u < 8; u++) {
        c[u] = s[u + 16];
      }

      return A(e, t, a, r, n, c, i);
    }

    var D = function D(e) {
      var t, a, r, n, s, o, i, c;
      this.buffer = new Uint8Array(16), this.r = new Uint16Array(10), this.h = new Uint16Array(10), this.pad = new Uint16Array(8), this.leftover = 0, this.fin = 0, t = 255 & e[0] | (255 & e[1]) << 8, this.r[0] = 8191 & t, a = 255 & e[2] | (255 & e[3]) << 8, this.r[1] = 8191 & (t >>> 13 | a << 3), r = 255 & e[4] | (255 & e[5]) << 8, this.r[2] = 7939 & (a >>> 10 | r << 6), n = 255 & e[6] | (255 & e[7]) << 8, this.r[3] = 8191 & (r >>> 7 | n << 9), s = 255 & e[8] | (255 & e[9]) << 8, this.r[4] = 255 & (n >>> 4 | s << 12), this.r[5] = s >>> 1 & 8190, o = 255 & e[10] | (255 & e[11]) << 8, this.r[6] = 8191 & (s >>> 14 | o << 2), i = 255 & e[12] | (255 & e[13]) << 8, this.r[7] = 8065 & (o >>> 11 | i << 5), c = 255 & e[14] | (255 & e[15]) << 8, this.r[8] = 8191 & (i >>> 8 | c << 8), this.r[9] = c >>> 5 & 127, this.pad[0] = 255 & e[16] | (255 & e[17]) << 8, this.pad[1] = 255 & e[18] | (255 & e[19]) << 8, this.pad[2] = 255 & e[20] | (255 & e[21]) << 8, this.pad[3] = 255 & e[22] | (255 & e[23]) << 8, this.pad[4] = 255 & e[24] | (255 & e[25]) << 8, this.pad[5] = 255 & e[26] | (255 & e[27]) << 8, this.pad[6] = 255 & e[28] | (255 & e[29]) << 8, this.pad[7] = 255 & e[30] | (255 & e[31]) << 8;
    };

    function C(e, t, a, r, n, s) {
      var o = new D(s);
      return o.update(a, r, n), o.finish(e, t), 0;
    }

    function S(e, t, a, r, n, s) {
      var o = new Uint8Array(16);
      return C(o, 0, a, r, n, s), m(e, t, o, 0);
    }

    function E(e, t, a, r, n) {
      var s;
      if (a < 32) return -1;

      for (x(e, 0, t, 0, a, r, n), C(e, 16, e, 32, a - 32, e), s = 0; s < 16; s++) {
        e[s] = 0;
      }

      return 0;
    }

    function B(e, t, a, r, n) {
      var s,
          o = new Uint8Array(32);
      if (a < 32) return -1;
      if (T(o, 0, 32, r, n), 0 !== S(t, 16, t, 32, a - 32, o)) return -1;

      for (x(e, 0, t, 0, a, r, n), s = 0; s < 32; s++) {
        e[s] = 0;
      }

      return 0;
    }

    function k(e, t) {
      var a;

      for (a = 0; a < 16; a++) {
        e[a] = 0 | t[a];
      }
    }

    function R(e) {
      var t,
          a,
          r = 1;

      for (t = 0; t < 16; t++) {
        a = e[t] + r + 65535, r = Math.floor(a / 65536), e[t] = a - 65536 * r;
      }

      e[0] += r - 1 + 37 * (r - 1);
    }

    function W(e, t, a) {
      for (var r, n = ~(a - 1), s = 0; s < 16; s++) {
        r = n & (e[s] ^ t[s]), e[s] ^= r, t[s] ^= r;
      }
    }

    function I(e, a) {
      var r,
          n,
          s,
          o = t(),
          i = t();

      for (r = 0; r < 16; r++) {
        i[r] = a[r];
      }

      for (R(i), R(i), R(i), n = 0; n < 2; n++) {
        for (o[0] = i[0] - 65517, r = 1; r < 15; r++) {
          o[r] = i[r] - 65535 - (o[r - 1] >> 16 & 1), o[r - 1] &= 65535;
        }

        o[15] = i[15] - 32767 - (o[14] >> 16 & 1), s = o[15] >> 16 & 1, o[14] &= 65535, W(i, o, 1 - s);
      }

      for (r = 0; r < 16; r++) {
        e[2 * r] = 255 & i[r], e[2 * r + 1] = i[r] >> 8;
      }
    }

    function N(e, t) {
      var a = new Uint8Array(32),
          r = new Uint8Array(32);
      return I(a, e), I(r, t), y(a, 0, r, 0);
    }

    function M(e) {
      var t = new Uint8Array(32);
      return I(t, e), 1 & t[0];
    }

    function P(e, t) {
      var a;

      for (a = 0; a < 16; a++) {
        e[a] = t[2 * a] + (t[2 * a + 1] << 8);
      }

      e[15] &= 32767;
    }

    function L(e, t, a) {
      for (var r = 0; r < 16; r++) {
        e[r] = t[r] + a[r];
      }
    }

    function O(e, t, a) {
      for (var r = 0; r < 16; r++) {
        e[r] = t[r] - a[r];
      }
    }

    function F(e, t, a) {
      var r,
          n,
          s = 0,
          o = 0,
          i = 0,
          c = 0,
          u = 0,
          d = 0,
          f = 0,
          l = 0,
          h = 0,
          p = 0,
          b = 0,
          m = 0,
          y = 0,
          v = 0,
          _ = 0,
          g = 0,
          A = 0,
          w = 0,
          T = 0,
          x = 0,
          D = 0,
          C = 0,
          S = 0,
          E = 0,
          B = 0,
          k = 0,
          R = 0,
          W = 0,
          I = 0,
          N = 0,
          M = 0,
          P = a[0],
          L = a[1],
          O = a[2],
          F = a[3],
          j = a[4],
          G = a[5],
          V = a[6],
          U = a[7],
          H = a[8],
          z = a[9],
          K = a[10],
          q = a[11],
          Y = a[12],
          Z = a[13],
          J = a[14],
          X = a[15];
      s += (r = t[0]) * P, o += r * L, i += r * O, c += r * F, u += r * j, d += r * G, f += r * V, l += r * U, h += r * H, p += r * z, b += r * K, m += r * q, y += r * Y, v += r * Z, _ += r * J, g += r * X, o += (r = t[1]) * P, i += r * L, c += r * O, u += r * F, d += r * j, f += r * G, l += r * V, h += r * U, p += r * H, b += r * z, m += r * K, y += r * q, v += r * Y, _ += r * Z, g += r * J, A += r * X, i += (r = t[2]) * P, c += r * L, u += r * O, d += r * F, f += r * j, l += r * G, h += r * V, p += r * U, b += r * H, m += r * z, y += r * K, v += r * q, _ += r * Y, g += r * Z, A += r * J, w += r * X, c += (r = t[3]) * P, u += r * L, d += r * O, f += r * F, l += r * j, h += r * G, p += r * V, b += r * U, m += r * H, y += r * z, v += r * K, _ += r * q, g += r * Y, A += r * Z, w += r * J, T += r * X, u += (r = t[4]) * P, d += r * L, f += r * O, l += r * F, h += r * j, p += r * G, b += r * V, m += r * U, y += r * H, v += r * z, _ += r * K, g += r * q, A += r * Y, w += r * Z, T += r * J, x += r * X, d += (r = t[5]) * P, f += r * L, l += r * O, h += r * F, p += r * j, b += r * G, m += r * V, y += r * U, v += r * H, _ += r * z, g += r * K, A += r * q, w += r * Y, T += r * Z, x += r * J, D += r * X, f += (r = t[6]) * P, l += r * L, h += r * O, p += r * F, b += r * j, m += r * G, y += r * V, v += r * U, _ += r * H, g += r * z, A += r * K, w += r * q, T += r * Y, x += r * Z, D += r * J, C += r * X, l += (r = t[7]) * P, h += r * L, p += r * O, b += r * F, m += r * j, y += r * G, v += r * V, _ += r * U, g += r * H, A += r * z, w += r * K, T += r * q, x += r * Y, D += r * Z, C += r * J, S += r * X, h += (r = t[8]) * P, p += r * L, b += r * O, m += r * F, y += r * j, v += r * G, _ += r * V, g += r * U, A += r * H, w += r * z, T += r * K, x += r * q, D += r * Y, C += r * Z, S += r * J, E += r * X, p += (r = t[9]) * P, b += r * L, m += r * O, y += r * F, v += r * j, _ += r * G, g += r * V, A += r * U, w += r * H, T += r * z, x += r * K, D += r * q, C += r * Y, S += r * Z, E += r * J, B += r * X, b += (r = t[10]) * P, m += r * L, y += r * O, v += r * F, _ += r * j, g += r * G, A += r * V, w += r * U, T += r * H, x += r * z, D += r * K, C += r * q, S += r * Y, E += r * Z, B += r * J, k += r * X, m += (r = t[11]) * P, y += r * L, v += r * O, _ += r * F, g += r * j, A += r * G, w += r * V, T += r * U, x += r * H, D += r * z, C += r * K, S += r * q, E += r * Y, B += r * Z, k += r * J, R += r * X, y += (r = t[12]) * P, v += r * L, _ += r * O, g += r * F, A += r * j, w += r * G, T += r * V, x += r * U, D += r * H, C += r * z, S += r * K, E += r * q, B += r * Y, k += r * Z, R += r * J, W += r * X, v += (r = t[13]) * P, _ += r * L, g += r * O, A += r * F, w += r * j, T += r * G, x += r * V, D += r * U, C += r * H, S += r * z, E += r * K, B += r * q, k += r * Y, R += r * Z, W += r * J, I += r * X, _ += (r = t[14]) * P, g += r * L, A += r * O, w += r * F, T += r * j, x += r * G, D += r * V, C += r * U, S += r * H, E += r * z, B += r * K, k += r * q, R += r * Y, W += r * Z, I += r * J, N += r * X, g += (r = t[15]) * P, o += 38 * (w += r * O), i += 38 * (T += r * F), c += 38 * (x += r * j), u += 38 * (D += r * G), d += 38 * (C += r * V), f += 38 * (S += r * U), l += 38 * (E += r * H), h += 38 * (B += r * z), p += 38 * (k += r * K), b += 38 * (R += r * q), m += 38 * (W += r * Y), y += 38 * (I += r * Z), v += 38 * (N += r * J), _ += 38 * (M += r * X), s = (r = (s += 38 * (A += r * L)) + (n = 1) + 65535) - 65536 * (n = Math.floor(r / 65536)), o = (r = o + n + 65535) - 65536 * (n = Math.floor(r / 65536)), i = (r = i + n + 65535) - 65536 * (n = Math.floor(r / 65536)), c = (r = c + n + 65535) - 65536 * (n = Math.floor(r / 65536)), u = (r = u + n + 65535) - 65536 * (n = Math.floor(r / 65536)), d = (r = d + n + 65535) - 65536 * (n = Math.floor(r / 65536)), f = (r = f + n + 65535) - 65536 * (n = Math.floor(r / 65536)), l = (r = l + n + 65535) - 65536 * (n = Math.floor(r / 65536)), h = (r = h + n + 65535) - 65536 * (n = Math.floor(r / 65536)), p = (r = p + n + 65535) - 65536 * (n = Math.floor(r / 65536)), b = (r = b + n + 65535) - 65536 * (n = Math.floor(r / 65536)), m = (r = m + n + 65535) - 65536 * (n = Math.floor(r / 65536)), y = (r = y + n + 65535) - 65536 * (n = Math.floor(r / 65536)), v = (r = v + n + 65535) - 65536 * (n = Math.floor(r / 65536)), _ = (r = _ + n + 65535) - 65536 * (n = Math.floor(r / 65536)), g = (r = g + n + 65535) - 65536 * (n = Math.floor(r / 65536)), s = (r = (s += n - 1 + 37 * (n - 1)) + (n = 1) + 65535) - 65536 * (n = Math.floor(r / 65536)), o = (r = o + n + 65535) - 65536 * (n = Math.floor(r / 65536)), i = (r = i + n + 65535) - 65536 * (n = Math.floor(r / 65536)), c = (r = c + n + 65535) - 65536 * (n = Math.floor(r / 65536)), u = (r = u + n + 65535) - 65536 * (n = Math.floor(r / 65536)), d = (r = d + n + 65535) - 65536 * (n = Math.floor(r / 65536)), f = (r = f + n + 65535) - 65536 * (n = Math.floor(r / 65536)), l = (r = l + n + 65535) - 65536 * (n = Math.floor(r / 65536)), h = (r = h + n + 65535) - 65536 * (n = Math.floor(r / 65536)), p = (r = p + n + 65535) - 65536 * (n = Math.floor(r / 65536)), b = (r = b + n + 65535) - 65536 * (n = Math.floor(r / 65536)), m = (r = m + n + 65535) - 65536 * (n = Math.floor(r / 65536)), y = (r = y + n + 65535) - 65536 * (n = Math.floor(r / 65536)), v = (r = v + n + 65535) - 65536 * (n = Math.floor(r / 65536)), _ = (r = _ + n + 65535) - 65536 * (n = Math.floor(r / 65536)), g = (r = g + n + 65535) - 65536 * (n = Math.floor(r / 65536)), s += n - 1 + 37 * (n - 1), e[0] = s, e[1] = o, e[2] = i, e[3] = c, e[4] = u, e[5] = d, e[6] = f, e[7] = l, e[8] = h, e[9] = p, e[10] = b, e[11] = m, e[12] = y, e[13] = v, e[14] = _, e[15] = g;
    }

    function j(e, t) {
      F(e, t, t);
    }

    function G(e, a) {
      var r,
          n = t();

      for (r = 0; r < 16; r++) {
        n[r] = a[r];
      }

      for (r = 253; r >= 0; r--) {
        j(n, n), 2 !== r && 4 !== r && F(n, n, a);
      }

      for (r = 0; r < 16; r++) {
        e[r] = n[r];
      }
    }

    function V(e, a, r) {
      var n,
          s,
          o = new Uint8Array(32),
          i = new Float64Array(80),
          u = t(),
          d = t(),
          f = t(),
          l = t(),
          h = t(),
          p = t();

      for (s = 0; s < 31; s++) {
        o[s] = a[s];
      }

      for (o[31] = 127 & a[31] | 64, o[0] &= 248, P(i, r), s = 0; s < 16; s++) {
        d[s] = i[s], l[s] = u[s] = f[s] = 0;
      }

      for (u[0] = l[0] = 1, s = 254; s >= 0; --s) {
        W(u, d, n = o[s >>> 3] >>> (7 & s) & 1), W(f, l, n), L(h, u, f), O(u, u, f), L(f, d, l), O(d, d, l), j(l, h), j(p, u), F(u, f, u), F(f, d, h), L(h, u, f), O(u, u, f), j(d, u), O(f, l, p), F(u, f, c), L(u, u, l), F(f, f, u), F(u, l, p), F(l, d, i), j(d, h), W(u, d, n), W(f, l, n);
      }

      for (s = 0; s < 16; s++) {
        i[s + 16] = u[s], i[s + 32] = f[s], i[s + 48] = d[s], i[s + 64] = l[s];
      }

      var b = i.subarray(32),
          m = i.subarray(16);
      return G(b, b), F(m, m, b), I(e, m), 0;
    }

    function U(e, t) {
      return V(e, t, s);
    }

    function H(e, t) {
      return r(t, 32), U(e, t);
    }

    function z(e, t, a) {
      var r = new Uint8Array(32);
      return V(r, a, t), _(e, n, r, g);
    }

    D.prototype.blocks = function (e, t, a) {
      for (var r, n, s, o, i, c, u, d, f, l, h, p, b, m, y, v, _, g, A, w = this.fin ? 0 : 2048, T = this.h[0], x = this.h[1], D = this.h[2], C = this.h[3], S = this.h[4], E = this.h[5], B = this.h[6], k = this.h[7], R = this.h[8], W = this.h[9], I = this.r[0], N = this.r[1], M = this.r[2], P = this.r[3], L = this.r[4], O = this.r[5], F = this.r[6], j = this.r[7], G = this.r[8], V = this.r[9]; a >= 16;) {
        l = f = 0, l += (T += 8191 & (r = 255 & e[t + 0] | (255 & e[t + 1]) << 8)) * I, l += (x += 8191 & (r >>> 13 | (n = 255 & e[t + 2] | (255 & e[t + 3]) << 8) << 3)) * (5 * V), l += (D += 8191 & (n >>> 10 | (s = 255 & e[t + 4] | (255 & e[t + 5]) << 8) << 6)) * (5 * G), l += (C += 8191 & (s >>> 7 | (o = 255 & e[t + 6] | (255 & e[t + 7]) << 8) << 9)) * (5 * j), f = (l += (S += 8191 & (o >>> 4 | (i = 255 & e[t + 8] | (255 & e[t + 9]) << 8) << 12)) * (5 * F)) >>> 13, l &= 8191, l += (E += i >>> 1 & 8191) * (5 * O), l += (B += 8191 & (i >>> 14 | (c = 255 & e[t + 10] | (255 & e[t + 11]) << 8) << 2)) * (5 * L), l += (k += 8191 & (c >>> 11 | (u = 255 & e[t + 12] | (255 & e[t + 13]) << 8) << 5)) * (5 * P), l += (R += 8191 & (u >>> 8 | (d = 255 & e[t + 14] | (255 & e[t + 15]) << 8) << 8)) * (5 * M), h = f += (l += (W += d >>> 5 | w) * (5 * N)) >>> 13, h += T * N, h += x * I, h += D * (5 * V), h += C * (5 * G), f = (h += S * (5 * j)) >>> 13, h &= 8191, h += E * (5 * F), h += B * (5 * O), h += k * (5 * L), h += R * (5 * P), f += (h += W * (5 * M)) >>> 13, h &= 8191, p = f, p += T * M, p += x * N, p += D * I, p += C * (5 * V), f = (p += S * (5 * G)) >>> 13, p &= 8191, p += E * (5 * j), p += B * (5 * F), p += k * (5 * O), p += R * (5 * L), b = f += (p += W * (5 * P)) >>> 13, b += T * P, b += x * M, b += D * N, b += C * I, f = (b += S * (5 * V)) >>> 13, b &= 8191, b += E * (5 * G), b += B * (5 * j), b += k * (5 * F), b += R * (5 * O), m = f += (b += W * (5 * L)) >>> 13, m += T * L, m += x * P, m += D * M, m += C * N, f = (m += S * I) >>> 13, m &= 8191, m += E * (5 * V), m += B * (5 * G), m += k * (5 * j), m += R * (5 * F), y = f += (m += W * (5 * O)) >>> 13, y += T * O, y += x * L, y += D * P, y += C * M, f = (y += S * N) >>> 13, y &= 8191, y += E * I, y += B * (5 * V), y += k * (5 * G), y += R * (5 * j), v = f += (y += W * (5 * F)) >>> 13, v += T * F, v += x * O, v += D * L, v += C * P, f = (v += S * M) >>> 13, v &= 8191, v += E * N, v += B * I, v += k * (5 * V), v += R * (5 * G), _ = f += (v += W * (5 * j)) >>> 13, _ += T * j, _ += x * F, _ += D * O, _ += C * L, f = (_ += S * P) >>> 13, _ &= 8191, _ += E * M, _ += B * N, _ += k * I, _ += R * (5 * V), g = f += (_ += W * (5 * G)) >>> 13, g += T * G, g += x * j, g += D * F, g += C * O, f = (g += S * L) >>> 13, g &= 8191, g += E * P, g += B * M, g += k * N, g += R * I, A = f += (g += W * (5 * V)) >>> 13, A += T * V, A += x * G, A += D * j, A += C * F, f = (A += S * O) >>> 13, A &= 8191, A += E * L, A += B * P, A += k * M, A += R * N, T = l = 8191 & (f = (f = ((f += (A += W * I) >>> 13) << 2) + f | 0) + (l &= 8191) | 0), x = h += f >>>= 13, D = p &= 8191, C = b &= 8191, S = m &= 8191, E = y &= 8191, B = v &= 8191, k = _ &= 8191, R = g &= 8191, W = A &= 8191, t += 16, a -= 16;
      }

      this.h[0] = T, this.h[1] = x, this.h[2] = D, this.h[3] = C, this.h[4] = S, this.h[5] = E, this.h[6] = B, this.h[7] = k, this.h[8] = R, this.h[9] = W;
    }, D.prototype.finish = function (e, t) {
      var a,
          r,
          n,
          s,
          o = new Uint16Array(10);

      if (this.leftover) {
        for (s = this.leftover, this.buffer[s++] = 1; s < 16; s++) {
          this.buffer[s] = 0;
        }

        this.fin = 1, this.blocks(this.buffer, 0, 16);
      }

      for (a = this.h[1] >>> 13, this.h[1] &= 8191, s = 2; s < 10; s++) {
        this.h[s] += a, a = this.h[s] >>> 13, this.h[s] &= 8191;
      }

      for (this.h[0] += 5 * a, a = this.h[0] >>> 13, this.h[0] &= 8191, this.h[1] += a, a = this.h[1] >>> 13, this.h[1] &= 8191, this.h[2] += a, o[0] = this.h[0] + 5, a = o[0] >>> 13, o[0] &= 8191, s = 1; s < 10; s++) {
        o[s] = this.h[s] + a, a = o[s] >>> 13, o[s] &= 8191;
      }

      for (o[9] -= 8192, r = (1 ^ a) - 1, s = 0; s < 10; s++) {
        o[s] &= r;
      }

      for (r = ~r, s = 0; s < 10; s++) {
        this.h[s] = this.h[s] & r | o[s];
      }

      for (this.h[0] = 65535 & (this.h[0] | this.h[1] << 13), this.h[1] = 65535 & (this.h[1] >>> 3 | this.h[2] << 10), this.h[2] = 65535 & (this.h[2] >>> 6 | this.h[3] << 7), this.h[3] = 65535 & (this.h[3] >>> 9 | this.h[4] << 4), this.h[4] = 65535 & (this.h[4] >>> 12 | this.h[5] << 1 | this.h[6] << 14), this.h[5] = 65535 & (this.h[6] >>> 2 | this.h[7] << 11), this.h[6] = 65535 & (this.h[7] >>> 5 | this.h[8] << 8), this.h[7] = 65535 & (this.h[8] >>> 8 | this.h[9] << 5), n = this.h[0] + this.pad[0], this.h[0] = 65535 & n, s = 1; s < 8; s++) {
        n = (this.h[s] + this.pad[s] | 0) + (n >>> 16) | 0, this.h[s] = 65535 & n;
      }

      e[t + 0] = this.h[0] >>> 0 & 255, e[t + 1] = this.h[0] >>> 8 & 255, e[t + 2] = this.h[1] >>> 0 & 255, e[t + 3] = this.h[1] >>> 8 & 255, e[t + 4] = this.h[2] >>> 0 & 255, e[t + 5] = this.h[2] >>> 8 & 255, e[t + 6] = this.h[3] >>> 0 & 255, e[t + 7] = this.h[3] >>> 8 & 255, e[t + 8] = this.h[4] >>> 0 & 255, e[t + 9] = this.h[4] >>> 8 & 255, e[t + 10] = this.h[5] >>> 0 & 255, e[t + 11] = this.h[5] >>> 8 & 255, e[t + 12] = this.h[6] >>> 0 & 255, e[t + 13] = this.h[6] >>> 8 & 255, e[t + 14] = this.h[7] >>> 0 & 255, e[t + 15] = this.h[7] >>> 8 & 255;
    }, D.prototype.update = function (e, t, a) {
      var r, n;

      if (this.leftover) {
        for ((n = 16 - this.leftover) > a && (n = a), r = 0; r < n; r++) {
          this.buffer[this.leftover + r] = e[t + r];
        }

        if (a -= n, t += n, this.leftover += n, this.leftover < 16) return;
        this.blocks(this.buffer, 0, 16), this.leftover = 0;
      }

      if (a >= 16 && (n = a - a % 16, this.blocks(e, t, n), t += n, a -= n), a) {
        for (r = 0; r < a; r++) {
          this.buffer[this.leftover + r] = e[t + r];
        }

        this.leftover += a;
      }
    };
    var K = E,
        q = B;
    var Y = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591];

    function Z(e, t, a, r) {
      for (var n, s, o, i, c, u, d, f, l, h, p, b, m, y, v, _, g, A, w, T, x, D, C, S, E, B, k = new Int32Array(16), R = new Int32Array(16), W = e[0], I = e[1], N = e[2], M = e[3], P = e[4], L = e[5], O = e[6], F = e[7], j = t[0], G = t[1], V = t[2], U = t[3], H = t[4], z = t[5], K = t[6], q = t[7], Z = 0; r >= 128;) {
        for (w = 0; w < 16; w++) {
          T = 8 * w + Z, k[w] = a[T + 0] << 24 | a[T + 1] << 16 | a[T + 2] << 8 | a[T + 3], R[w] = a[T + 4] << 24 | a[T + 5] << 16 | a[T + 6] << 8 | a[T + 7];
        }

        for (w = 0; w < 80; w++) {
          if (n = W, s = I, o = N, i = M, c = P, u = L, d = O, F, l = j, h = G, p = V, b = U, m = H, y = z, v = K, q, C = 65535 & (D = q), S = D >>> 16, E = 65535 & (x = F), B = x >>> 16, C += 65535 & (D = (H >>> 14 | P << 18) ^ (H >>> 18 | P << 14) ^ (P >>> 9 | H << 23)), S += D >>> 16, E += 65535 & (x = (P >>> 14 | H << 18) ^ (P >>> 18 | H << 14) ^ (H >>> 9 | P << 23)), B += x >>> 16, C += 65535 & (D = H & z ^ ~H & K), S += D >>> 16, E += 65535 & (x = P & L ^ ~P & O), B += x >>> 16, x = Y[2 * w], C += 65535 & (D = Y[2 * w + 1]), S += D >>> 16, E += 65535 & x, B += x >>> 16, x = k[w % 16], S += (D = R[w % 16]) >>> 16, E += 65535 & x, B += x >>> 16, E += (S += (C += 65535 & D) >>> 16) >>> 16, C = 65535 & (D = A = 65535 & C | S << 16), S = D >>> 16, E = 65535 & (x = g = 65535 & E | (B += E >>> 16) << 16), B = x >>> 16, C += 65535 & (D = (j >>> 28 | W << 4) ^ (W >>> 2 | j << 30) ^ (W >>> 7 | j << 25)), S += D >>> 16, E += 65535 & (x = (W >>> 28 | j << 4) ^ (j >>> 2 | W << 30) ^ (j >>> 7 | W << 25)), B += x >>> 16, S += (D = j & G ^ j & V ^ G & V) >>> 16, E += 65535 & (x = W & I ^ W & N ^ I & N), B += x >>> 16, f = 65535 & (E += (S += (C += 65535 & D) >>> 16) >>> 16) | (B += E >>> 16) << 16, _ = 65535 & C | S << 16, C = 65535 & (D = b), S = D >>> 16, E = 65535 & (x = i), B = x >>> 16, S += (D = A) >>> 16, E += 65535 & (x = g), B += x >>> 16, I = n, N = s, M = o, P = i = 65535 & (E += (S += (C += 65535 & D) >>> 16) >>> 16) | (B += E >>> 16) << 16, L = c, O = u, F = d, W = f, G = l, V = h, U = p, H = b = 65535 & C | S << 16, z = m, K = y, q = v, j = _, w % 16 == 15) for (T = 0; T < 16; T++) {
            x = k[T], C = 65535 & (D = R[T]), S = D >>> 16, E = 65535 & x, B = x >>> 16, x = k[(T + 9) % 16], C += 65535 & (D = R[(T + 9) % 16]), S += D >>> 16, E += 65535 & x, B += x >>> 16, g = k[(T + 1) % 16], C += 65535 & (D = ((A = R[(T + 1) % 16]) >>> 1 | g << 31) ^ (A >>> 8 | g << 24) ^ (A >>> 7 | g << 25)), S += D >>> 16, E += 65535 & (x = (g >>> 1 | A << 31) ^ (g >>> 8 | A << 24) ^ g >>> 7), B += x >>> 16, g = k[(T + 14) % 16], S += (D = ((A = R[(T + 14) % 16]) >>> 19 | g << 13) ^ (g >>> 29 | A << 3) ^ (A >>> 6 | g << 26)) >>> 16, E += 65535 & (x = (g >>> 19 | A << 13) ^ (A >>> 29 | g << 3) ^ g >>> 6), B += x >>> 16, B += (E += (S += (C += 65535 & D) >>> 16) >>> 16) >>> 16, k[T] = 65535 & E | B << 16, R[T] = 65535 & C | S << 16;
          }
        }

        C = 65535 & (D = j), S = D >>> 16, E = 65535 & (x = W), B = x >>> 16, x = e[0], S += (D = t[0]) >>> 16, E += 65535 & x, B += x >>> 16, B += (E += (S += (C += 65535 & D) >>> 16) >>> 16) >>> 16, e[0] = W = 65535 & E | B << 16, t[0] = j = 65535 & C | S << 16, C = 65535 & (D = G), S = D >>> 16, E = 65535 & (x = I), B = x >>> 16, x = e[1], S += (D = t[1]) >>> 16, E += 65535 & x, B += x >>> 16, B += (E += (S += (C += 65535 & D) >>> 16) >>> 16) >>> 16, e[1] = I = 65535 & E | B << 16, t[1] = G = 65535 & C | S << 16, C = 65535 & (D = V), S = D >>> 16, E = 65535 & (x = N), B = x >>> 16, x = e[2], S += (D = t[2]) >>> 16, E += 65535 & x, B += x >>> 16, B += (E += (S += (C += 65535 & D) >>> 16) >>> 16) >>> 16, e[2] = N = 65535 & E | B << 16, t[2] = V = 65535 & C | S << 16, C = 65535 & (D = U), S = D >>> 16, E = 65535 & (x = M), B = x >>> 16, x = e[3], S += (D = t[3]) >>> 16, E += 65535 & x, B += x >>> 16, B += (E += (S += (C += 65535 & D) >>> 16) >>> 16) >>> 16, e[3] = M = 65535 & E | B << 16, t[3] = U = 65535 & C | S << 16, C = 65535 & (D = H), S = D >>> 16, E = 65535 & (x = P), B = x >>> 16, x = e[4], S += (D = t[4]) >>> 16, E += 65535 & x, B += x >>> 16, B += (E += (S += (C += 65535 & D) >>> 16) >>> 16) >>> 16, e[4] = P = 65535 & E | B << 16, t[4] = H = 65535 & C | S << 16, C = 65535 & (D = z), S = D >>> 16, E = 65535 & (x = L), B = x >>> 16, x = e[5], S += (D = t[5]) >>> 16, E += 65535 & x, B += x >>> 16, B += (E += (S += (C += 65535 & D) >>> 16) >>> 16) >>> 16, e[5] = L = 65535 & E | B << 16, t[5] = z = 65535 & C | S << 16, C = 65535 & (D = K), S = D >>> 16, E = 65535 & (x = O), B = x >>> 16, x = e[6], S += (D = t[6]) >>> 16, E += 65535 & x, B += x >>> 16, B += (E += (S += (C += 65535 & D) >>> 16) >>> 16) >>> 16, e[6] = O = 65535 & E | B << 16, t[6] = K = 65535 & C | S << 16, C = 65535 & (D = q), S = D >>> 16, E = 65535 & (x = F), B = x >>> 16, x = e[7], S += (D = t[7]) >>> 16, E += 65535 & x, B += x >>> 16, B += (E += (S += (C += 65535 & D) >>> 16) >>> 16) >>> 16, e[7] = F = 65535 & E | B << 16, t[7] = q = 65535 & C | S << 16, Z += 128, r -= 128;
      }

      return r;
    }

    function J(e, t, a) {
      var r,
          n = new Int32Array(8),
          s = new Int32Array(8),
          o = new Uint8Array(256),
          i = a;

      for (n[0] = 1779033703, n[1] = 3144134277, n[2] = 1013904242, n[3] = 2773480762, n[4] = 1359893119, n[5] = 2600822924, n[6] = 528734635, n[7] = 1541459225, s[0] = 4089235720, s[1] = 2227873595, s[2] = 4271175723, s[3] = 1595750129, s[4] = 2917565137, s[5] = 725511199, s[6] = 4215389547, s[7] = 327033209, Z(n, s, t, a), a %= 128, r = 0; r < a; r++) {
        o[r] = t[i - a + r];
      }

      for (o[a] = 128, o[(a = 256 - 128 * (a < 112 ? 1 : 0)) - 9] = 0, p(o, a - 8, i / 536870912 | 0, i << 3), Z(n, s, o, a), r = 0; r < 8; r++) {
        p(e, 8 * r, n[r], s[r]);
      }

      return 0;
    }

    function X(e, a) {
      var r = t(),
          n = t(),
          s = t(),
          o = t(),
          i = t(),
          c = t(),
          u = t(),
          f = t(),
          l = t();
      O(r, e[1], e[0]), O(l, a[1], a[0]), F(r, r, l), L(n, e[0], e[1]), L(l, a[0], a[1]), F(n, n, l), F(s, e[3], a[3]), F(s, s, d), F(o, e[2], a[2]), L(o, o, o), O(i, n, r), O(c, o, s), L(u, o, s), L(f, n, r), F(e[0], i, c), F(e[1], f, u), F(e[2], u, c), F(e[3], i, f);
    }

    function $(e, t, a) {
      var r;

      for (r = 0; r < 4; r++) {
        W(e[r], t[r], a);
      }
    }

    function Q(e, a) {
      var r = t(),
          n = t(),
          s = t();
      G(s, a[2]), F(r, a[0], s), F(n, a[1], s), I(e, n), e[31] ^= M(r) << 7;
    }

    function ee(e, t, a) {
      var r, n;

      for (k(e[0], o), k(e[1], i), k(e[2], i), k(e[3], o), n = 255; n >= 0; --n) {
        $(e, t, r = a[n / 8 | 0] >> (7 & n) & 1), X(t, e), X(e, e), $(e, t, r);
      }
    }

    function te(e, a) {
      var r = [t(), t(), t(), t()];
      k(r[0], f), k(r[1], l), k(r[2], i), F(r[3], f, l), ee(e, r, a);
    }

    function ae(e, a, n) {
      var s,
          o = new Uint8Array(64),
          i = [t(), t(), t(), t()];

      for (n || r(a, 32), J(o, a, 32), o[0] &= 248, o[31] &= 127, o[31] |= 64, te(i, o), Q(e, i), s = 0; s < 32; s++) {
        a[s + 32] = e[s];
      }

      return 0;
    }

    var re = new Float64Array([237, 211, 245, 92, 26, 99, 18, 88, 214, 156, 247, 162, 222, 249, 222, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16]);

    function ne(e, t) {
      var a, r, n, s;

      for (r = 63; r >= 32; --r) {
        for (a = 0, n = r - 32, s = r - 12; n < s; ++n) {
          t[n] += a - 16 * t[r] * re[n - (r - 32)], a = t[n] + 128 >> 8, t[n] -= 256 * a;
        }

        t[n] += a, t[r] = 0;
      }

      for (a = 0, n = 0; n < 32; n++) {
        t[n] += a - (t[31] >> 4) * re[n], a = t[n] >> 8, t[n] &= 255;
      }

      for (n = 0; n < 32; n++) {
        t[n] -= a * re[n];
      }

      for (r = 0; r < 32; r++) {
        t[r + 1] += t[r] >> 8, e[r] = 255 & t[r];
      }
    }

    function se(e) {
      var t,
          a = new Float64Array(64);

      for (t = 0; t < 64; t++) {
        a[t] = e[t];
      }

      for (t = 0; t < 64; t++) {
        e[t] = 0;
      }

      ne(e, a);
    }

    function oe(e, a, r, n) {
      var s,
          o,
          i = new Uint8Array(64),
          c = new Uint8Array(64),
          u = new Uint8Array(64),
          d = new Float64Array(64),
          f = [t(), t(), t(), t()];
      J(i, n, 32), i[0] &= 248, i[31] &= 127, i[31] |= 64;
      var l = r + 64;

      for (s = 0; s < r; s++) {
        e[64 + s] = a[s];
      }

      for (s = 0; s < 32; s++) {
        e[32 + s] = i[32 + s];
      }

      for (J(u, e.subarray(32), r + 32), se(u), te(f, u), Q(e, f), s = 32; s < 64; s++) {
        e[s] = n[s];
      }

      for (J(c, e, r + 64), se(c), s = 0; s < 64; s++) {
        d[s] = 0;
      }

      for (s = 0; s < 32; s++) {
        d[s] = u[s];
      }

      for (s = 0; s < 32; s++) {
        for (o = 0; o < 32; o++) {
          d[s + o] += c[s] * i[o];
        }
      }

      return ne(e.subarray(32), d), l;
    }

    function ie(e, a) {
      var r = t(),
          n = t(),
          s = t(),
          c = t(),
          d = t(),
          f = t(),
          l = t();
      return k(e[2], i), P(e[1], a), j(s, e[1]), F(c, s, u), O(s, s, e[2]), L(c, e[2], c), j(d, c), j(f, d), F(l, f, d), F(r, l, s), F(r, r, c), function (e, a) {
        var r,
            n = t();

        for (r = 0; r < 16; r++) {
          n[r] = a[r];
        }

        for (r = 250; r >= 0; r--) {
          j(n, n), 1 !== r && F(n, n, a);
        }

        for (r = 0; r < 16; r++) {
          e[r] = n[r];
        }
      }(r, r), F(r, r, s), F(r, r, c), F(r, r, c), F(e[0], r, c), j(n, e[0]), F(n, n, c), N(n, s) && F(e[0], e[0], h), j(n, e[0]), F(n, n, c), N(n, s) ? -1 : (M(e[0]) === a[31] >> 7 && O(e[0], o, e[0]), F(e[3], e[0], e[1]), 0);
    }

    function ce(e, a, r, n) {
      var s,
          o = new Uint8Array(32),
          i = new Uint8Array(64),
          c = [t(), t(), t(), t()],
          u = [t(), t(), t(), t()];
      if (-1, r < 64) return -1;
      if (ie(u, n)) return -1;

      for (s = 0; s < r; s++) {
        e[s] = a[s];
      }

      for (s = 0; s < 32; s++) {
        e[s + 32] = n[s];
      }

      if (J(i, e, r), se(i), ee(c, u, i), te(u, a.subarray(32)), X(c, u), Q(o, c), r -= 64, y(a, 0, o, 0)) {
        for (s = 0; s < r; s++) {
          e[s] = 0;
        }

        return -1;
      }

      for (s = 0; s < r; s++) {
        e[s] = a[s + 64];
      }

      return r;
    }

    var ue = 32,
        de = 24,
        fe = 32,
        le = 32,
        he = de;

    function pe(e, t) {
      if (e.length !== ue) throw new Error("bad key size");
      if (t.length !== de) throw new Error("bad nonce size");
    }

    function be() {
      for (var e = 0; e < arguments.length; e++) {
        if (!(arguments[e] instanceof Uint8Array)) throw new TypeError("unexpected type, use Uint8Array");
      }
    }

    function me(e) {
      for (var t = 0; t < e.length; t++) {
        e[t] = 0;
      }
    }

    e.lowlevel = {
      crypto_core_hsalsa20: _,
      crypto_stream_xor: x,
      crypto_stream: T,
      crypto_stream_salsa20_xor: A,
      crypto_stream_salsa20: w,
      crypto_onetimeauth: C,
      crypto_onetimeauth_verify: S,
      crypto_verify_16: m,
      crypto_verify_32: y,
      crypto_secretbox: E,
      crypto_secretbox_open: B,
      crypto_scalarmult: V,
      crypto_scalarmult_base: U,
      crypto_box_beforenm: z,
      crypto_box_afternm: K,
      crypto_box: function crypto_box(e, t, a, r, n, s) {
        var o = new Uint8Array(32);
        return z(o, n, s), K(e, t, a, r, o);
      },
      crypto_box_open: function crypto_box_open(e, t, a, r, n, s) {
        var o = new Uint8Array(32);
        return z(o, n, s), q(e, t, a, r, o);
      },
      crypto_box_keypair: H,
      crypto_hash: J,
      crypto_sign: oe,
      crypto_sign_keypair: ae,
      crypto_sign_open: ce,
      crypto_secretbox_KEYBYTES: ue,
      crypto_secretbox_NONCEBYTES: de,
      crypto_secretbox_ZEROBYTES: 32,
      crypto_secretbox_BOXZEROBYTES: 16,
      crypto_scalarmult_BYTES: 32,
      crypto_scalarmult_SCALARBYTES: 32,
      crypto_box_PUBLICKEYBYTES: fe,
      crypto_box_SECRETKEYBYTES: le,
      crypto_box_BEFORENMBYTES: 32,
      crypto_box_NONCEBYTES: he,
      crypto_box_ZEROBYTES: 32,
      crypto_box_BOXZEROBYTES: 16,
      crypto_sign_BYTES: 64,
      crypto_sign_PUBLICKEYBYTES: 32,
      crypto_sign_SECRETKEYBYTES: 64,
      crypto_sign_SEEDBYTES: 32,
      crypto_hash_BYTES: 64
    }, e.randomBytes = function (e) {
      var t = new Uint8Array(e);
      return r(t, e), t;
    }, e.secretbox = function (e, t, a) {
      be(e, t, a), pe(a, t);

      for (var r = new Uint8Array(32 + e.length), n = new Uint8Array(r.length), s = 0; s < e.length; s++) {
        r[s + 32] = e[s];
      }

      return E(n, r, r.length, t, a), n.subarray(16);
    }, e.secretbox.open = function (e, t, a) {
      be(e, t, a), pe(a, t);

      for (var r = new Uint8Array(16 + e.length), n = new Uint8Array(r.length), s = 0; s < e.length; s++) {
        r[s + 16] = e[s];
      }

      return r.length < 32 ? null : 0 !== B(n, r, r.length, t, a) ? null : n.subarray(32);
    }, e.secretbox.keyLength = ue, e.secretbox.nonceLength = de, e.secretbox.overheadLength = 16, e.scalarMult = function (e, t) {
      if (be(e, t), 32 !== e.length) throw new Error("bad n size");
      if (32 !== t.length) throw new Error("bad p size");
      var a = new Uint8Array(32);
      return V(a, e, t), a;
    }, e.scalarMult.base = function (e) {
      if (be(e), 32 !== e.length) throw new Error("bad n size");
      var t = new Uint8Array(32);
      return U(t, e), t;
    }, e.scalarMult.scalarLength = 32, e.scalarMult.groupElementLength = 32, e.box = function (t, a, r, n) {
      var s = e.box.before(r, n);
      return e.secretbox(t, a, s);
    }, e.box.before = function (e, t) {
      be(e, t), function (e, t) {
        if (e.length !== fe) throw new Error("bad public key size");
        if (t.length !== le) throw new Error("bad secret key size");
      }(e, t);
      var a = new Uint8Array(32);
      return z(a, e, t), a;
    }, e.box.after = e.secretbox, e.box.open = function (t, a, r, n) {
      var s = e.box.before(r, n);
      return e.secretbox.open(t, a, s);
    }, e.box.open.after = e.secretbox.open, e.box.keyPair = function () {
      var e = new Uint8Array(fe),
          t = new Uint8Array(le);
      return H(e, t), {
        publicKey: e,
        secretKey: t
      };
    }, e.box.keyPair.fromSecretKey = function (e) {
      if (be(e), e.length !== le) throw new Error("bad secret key size");
      var t = new Uint8Array(fe);
      return U(t, e), {
        publicKey: t,
        secretKey: new Uint8Array(e)
      };
    }, e.box.publicKeyLength = fe, e.box.secretKeyLength = le, e.box.sharedKeyLength = 32, e.box.nonceLength = he, e.box.overheadLength = e.secretbox.overheadLength, e.sign = function (e, t) {
      if (be(e, t), 64 !== t.length) throw new Error("bad secret key size");
      var a = new Uint8Array(64 + e.length);
      return oe(a, e, e.length, t), a;
    }, e.sign.open = function (e, t) {
      if (be(e, t), 32 !== t.length) throw new Error("bad public key size");
      var a = new Uint8Array(e.length),
          r = ce(a, e, e.length, t);
      if (r < 0) return null;

      for (var n = new Uint8Array(r), s = 0; s < n.length; s++) {
        n[s] = a[s];
      }

      return n;
    }, e.sign.detached = function (t, a) {
      for (var r = e.sign(t, a), n = new Uint8Array(64), s = 0; s < n.length; s++) {
        n[s] = r[s];
      }

      return n;
    }, e.sign.detached.verify = function (e, t, a) {
      if (be(e, t, a), 64 !== t.length) throw new Error("bad signature size");
      if (32 !== a.length) throw new Error("bad public key size");
      var r,
          n = new Uint8Array(64 + e.length),
          s = new Uint8Array(64 + e.length);

      for (r = 0; r < 64; r++) {
        n[r] = t[r];
      }

      for (r = 0; r < e.length; r++) {
        n[r + 64] = e[r];
      }

      return ce(s, n, n.length, a) >= 0;
    }, e.sign.keyPair = function () {
      var e = new Uint8Array(32),
          t = new Uint8Array(64);
      return ae(e, t), {
        publicKey: e,
        secretKey: t
      };
    }, e.sign.keyPair.fromSecretKey = function (e) {
      if (be(e), 64 !== e.length) throw new Error("bad secret key size");

      for (var t = new Uint8Array(32), a = 0; a < t.length; a++) {
        t[a] = e[32 + a];
      }

      return {
        publicKey: t,
        secretKey: new Uint8Array(e)
      };
    }, e.sign.keyPair.fromSeed = function (e) {
      if (be(e), 32 !== e.length) throw new Error("bad seed size");

      for (var t = new Uint8Array(32), a = new Uint8Array(64), r = 0; r < 32; r++) {
        a[r] = e[r];
      }

      return ae(t, a, !0), {
        publicKey: t,
        secretKey: a
      };
    }, e.sign.publicKeyLength = 32, e.sign.secretKeyLength = 64, e.sign.seedLength = 32, e.sign.signatureLength = 64, e.hash = function (e) {
      be(e);
      var t = new Uint8Array(64);
      return J(t, e, e.length), t;
    }, e.hash.hashLength = 64, e.verify = function (e, t) {
      return be(e, t), 0 !== e.length && 0 !== t.length && e.length === t.length && 0 === b(e, 0, t, 0, e.length);
    }, e.setPRNG = function (e) {
      r = e;
    }, function () {
      var t = "undefined" != typeof self ? self.crypto || self.msCrypto : null;

      if (t && t.getRandomValues) {
        e.setPRNG(function (e, a) {
          var r,
              n = new Uint8Array(a);

          for (r = 0; r < a; r += 65536) {
            t.getRandomValues(n.subarray(r, r + Math.min(a - r, 65536)));
          }

          for (r = 0; r < a; r++) {
            e[r] = n[r];
          }

          me(n);
        });
      } else (t = a(
      /*! crypto */
      837)) && t.randomBytes && e.setPRNG(function (e, a) {
        var r,
            n = t.randomBytes(a);

        for (r = 0; r < a; r++) {
          e[r] = n[r];
        }

        me(n);
      });
    }();
  }(e.exports ? e.exports : self.nacl = self.nacl || {});
},
/*!************************!*\
  !*** crypto (ignored) ***!
  \************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t) {},
/*!**************************************************!*\
  !*** ./node_modules/tweetnacl-util/nacl-util.js ***!
  \**************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  (function (t) {
    !function (t, a) {
      "use strict";

      e.exports ? e.exports = a() : t.nacl ? t.nacl.util = a() : (t.nacl = {}, t.nacl.util = a());
    }(this, function () {
      "use strict";

      var e = {};

      function a(e) {
        if (!/^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(e)) throw new TypeError("invalid encoding");
      }

      return e.decodeUTF8 = function (e) {
        if ("string" != typeof e) throw new TypeError("expected string");
        var t,
            a = unescape(encodeURIComponent(e)),
            r = new Uint8Array(a.length);

        for (t = 0; t < a.length; t++) {
          r[t] = a.charCodeAt(t);
        }

        return r;
      }, e.encodeUTF8 = function (e) {
        var t,
            a = [];

        for (t = 0; t < e.length; t++) {
          a.push(String.fromCharCode(e[t]));
        }

        return decodeURIComponent(escape(a.join("")));
      }, "undefined" == typeof atob ? void 0 !== t.from ? (e.encodeBase64 = function (e) {
        return t.from(e).toString("base64");
      }, e.decodeBase64 = function (e) {
        return a(e), new Uint8Array(Array.prototype.slice.call(t.from(e, "base64"), 0));
      }) : (e.encodeBase64 = function (e) {
        return new t(e).toString("base64");
      }, e.decodeBase64 = function (e) {
        return a(e), new Uint8Array(Array.prototype.slice.call(new t(e, "base64"), 0));
      }) : (e.encodeBase64 = function (e) {
        var t,
            a = [],
            r = e.length;

        for (t = 0; t < r; t++) {
          a.push(String.fromCharCode(e[t]));
        }

        return btoa(a.join(""));
      }, e.decodeBase64 = function (e) {
        a(e);
        var t,
            r = atob(e),
            n = new Uint8Array(r.length);

        for (t = 0; t < r.length; t++) {
          n[t] = r.charCodeAt(t);
        }

        return n;
      }), e;
    });
  }).call(this, a(
  /*! ./../node-libs-browser/node_modules/buffer/index.js */
  1).Buffer);
},
/*!*********************************!*\
  !*** ./src/utils/sign_utils.ts ***!
  \*********************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      n = a(
  /*! ./convert */
  16);

  function s(e) {
    return {
      investorAddresses: e.map(function (e) {
        return e.investorAddress;
      }),
      fromTimes: e.map(function (e) {
        return n.dateToBigNumber(e.canSendAfter).toString();
      }),
      toTimes: e.map(function (e) {
        return n.dateToBigNumber(e.canReceiveAfter).toString();
      }),
      expiryTimes: e.map(function (e) {
        return n.dateToBigNumber(e.expiryTime).toString();
      })
    };
  }

  function o(e, t, a) {
    return {
      types: {
        EIP712Domain: [{
          name: "name",
          type: "string"
        }, {
          name: "chainId",
          type: "uint256"
        }, {
          name: "verifyingContract",
          type: "address"
        }],
        Acknowledgment: [{
          name: "text",
          type: "string"
        }]
      },
      primaryType: "Acknowledgment",
      domain: {
        name: "Polymath",
        chainId: e,
        verifyingContract: t
      },
      message: {
        text: "I acknowledge that " + a + " is a permanent and irrevocable change"
      }
    };
  }

  t.getFreezeIssuanceTypedData = function (e, t) {
    return o(e, t, "freezing Issuance");
  }, t.getDisableControllerTypedData = function (e, t) {
    return o(e, t, "disabling controller");
  }, t.getHashedTransferData = function (e, t, a, o, i) {
    var c = s(t),
        u = [e, c.investorAddresses, c.fromTimes, c.toTimes, c.expiryTimes, n.dateToBigNumber(a).toString(), n.dateToBigNumber(o).toString(), n.numberToBigNumber(i).toString()];
    return r.ethersUtils.solidityKeccak256(["address", "address[]", "uint256[]", "uint256[]", "uint256[]", "uint256", "uint256", "uint256"], u);
  }, t.encodeSignedTransferData = function (e, t, a, o, i, c) {
    var u = s(t),
        d = u.investorAddresses,
        f = u.fromTimes,
        l = u.toTimes,
        h = u.expiryTimes,
        p = r.ethersUtils.defaultAbiCoder.encode(["address[]", "uint256[]", "uint256[]", "uint256[]", "bytes"], [d, f, l, h, c]);
    return r.ethersUtils.defaultAbiCoder.encode(["address", "uint256", "uint256", "uint256", "bytes"], [e, n.numberToBigNumber(i).toString(), n.dateToBigNumber(a).toString(), n.dateToBigNumber(o).toString(), p]);
  };
},
/*!*********************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/checkpoint/erc20_dividend_checkpoint_wrapper/3.0.0.ts ***!
  \*********************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r118,
      n = this && this.__extends || (_r118 = function r(e, t) {
    return (_r118 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r118(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o = a(
  /*! ../dividend_checkpoint_wrapper */
  93),
      i = a(
  /*! ../../../../types */
  4),
      c = s(a(
  /*! ./common */
  296)),
      u = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.contractVersion = i.ContractVersion.V3_0_0, n.contract = a, n;
    }

    return n(t, e), t;
  }(o.WithDividendCheckpoint_3_0_0(c.default));

  t.ERC20DividendCheckpoint_3_0_0 = u, t.isERC20DividendCheckpoint_3_0_0 = function (e) {
    return e.contractVersion === i.ContractVersion.V3_0_0;
  };
},
/*!***************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/checkpoint/dividend_checkpoint_wrapper/3.0.0.ts ***!
  \***************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r119,
      n = this && this.__extends || (_r119 = function r(e, t) {
    return (_r119 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r119(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  });

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var s = a(
  /*! ../../module_wrapper */
  17);

  t.WithDividendCheckpoint_3_0_0 = function (e) {
    var t = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t;
    }(e);

    return s.WithModule_3_0_0(t);
  };
},
/*!***************************************************************!*\
  !*** ./src/contract_wrappers/modules/module_wrapper/3.0.0.ts ***!
  \***************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r120,
      n = this && this.__extends || (_r120 = function r(e, t) {
    return (_r120 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r120(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  });

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.WithModule_3_0_0 = function (e) {
    return function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t;
    }(e);
  };
},
/*!****************************************************************!*\
  !*** ./src/contract_wrappers/modules/module_wrapper/common.ts ***!
  \****************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r121,
      n = this && this.__extends || (_r121 = function r(e, t) {
    return (_r121 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r121(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      i = this && this.__read || function (e, t) {
    var a = "function" == typeof Symbol && e[Symbol.iterator];
    if (!a) return e;
    var r,
        n,
        s = a.call(e),
        o = [];

    try {
      for (; (void 0 === t || t-- > 0) && !(r = s.next()).done;) {
        o.push(r.value);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (a = s.return) && a.call(s);
      } finally {
        if (n) throw n.error;
      }
    }

    return o;
  },
      c = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var u = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      d = c(a(
  /*! ../../contract_wrapper */
  44)),
      f = a(
  /*! ../../../PolymathError */
  43),
      l = a(
  /*! ../../../types */
  4),
      h = a(
  /*! ../../../utils/convert */
  16),
      p = c(a(
  /*! ../../../utils/functions_utils */
  40)),
      b = c(a(
  /*! ../../../utils/assert */
  15)),
      m = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a) || this;
      return n.securityTokenContract = function () {
        return s(n, void 0, void 0, function () {
          var e;
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, t.sent().securityToken.callAsync()];

              case 2:
                return e = t.sent(), [2, this.contractFactory.getSecurityTokenContract(e)];
            }
          });
        });
      }, n.polyTokenContract = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            return [2, this.contractFactory.getPolyTokenContract()];
          });
        });
      }, n.detailedERC20TokenContract = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            return [2, this.contractFactory.getERC20DetailedContract(e)];
          });
        });
      }, n.moduleFactoryContract = function () {
        return s(n, void 0, void 0, function () {
          var e;
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, t.sent().factory.callAsync()];

              case 2:
                return e = t.sent(), [2, this.contractFactory.getModuleFactoryContract(e)];
            }
          });
        });
      }, n.paused = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().paused.callAsync()];
            }
          });
        });
      }, n.getInitFunction = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().getInitFunction.callAsync()];
            }
          });
        });
      }, n.polyToken = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().polyToken.callAsync()];
            }
          });
        });
      }, n.securityToken = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().securityToken.callAsync()];
            }
          });
        });
      }, n.getPermissions = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, e.sent().getPermissions.callAsync()];

              case 2:
                return [2, e.sent().map(h.parsePermBytes32Value)];
            }
          });
        });
      }, n.factory = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().factory.callAsync()];
            }
          });
        });
      }, n.reclaimETH = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = b.default).assert, [4, this.isCallerTheSecurityTokenOwner(e.txData)];

              case 1:
                return a.apply(t, [r.sent(), l.ErrorCode.Unauthorized, "The caller must be the ST owner"]), [4, this.contract];

              case 2:
                return [2, r.sent().reclaimETH.sendTransactionAsync(e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.reclaimERC20 = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = b.default).assert, [4, this.isCallerTheSecurityTokenOwner(e.txData)];

              case 1:
                return a.apply(t, [r.sent(), l.ErrorCode.Unauthorized, "The caller must be the ST owner"]), b.default.isNonZeroETHAddressHex("tokenContract", e.tokenContract), [4, this.contract];

              case 2:
                return [2, r.sent().reclaimERC20.sendTransactionAsync(e.tokenContract, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.pause = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = b.default).assert, [4, this.paused()];

              case 1:
                return a.apply(t, [!s.sent(), l.ErrorCode.ContractPaused, "Contract currently paused"]), n = (r = b.default).assert, [4, this.isCallerTheSecurityTokenOwner(e.txData)];

              case 2:
                return n.apply(r, [s.sent(), l.ErrorCode.Unauthorized, "The caller must be the ST owner"]), [4, this.contract];

              case 3:
                return [2, s.sent().pause.sendTransactionAsync(e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.unpause = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = b.default).assert, [4, this.paused()];

              case 1:
                return a.apply(t, [s.sent(), l.ErrorCode.PreconditionRequired, "Contract currently not paused"]), n = (r = b.default).assert, [4, this.isCallerTheSecurityTokenOwner(e.txData)];

              case 2:
                return n.apply(r, [s.sent(), l.ErrorCode.Unauthorized, "The caller must be the ST owner"]), [4, this.contract];

              case 3:
                return [2, s.sent().unpause.sendTransactionAsync(e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.isValidModule = function () {
        return s(n, void 0, void 0, function () {
          var e, t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, this.moduleFactoryContract()];

              case 1:
                return [4, n.sent().getTypes.callAsync()];

              case 2:
                if (e = n.sent(), !(t = e.filter(function (e) {
                  try {
                    return h.parseModuleTypeValue(new u.BigNumber(e)) !== l.ModuleType.Burn;
                  } catch (e) {
                    return !1;
                  }
                })).length || t.length > 1) throw new f.PolymathError({
                  code: l.ErrorCode.InvalidData
                });
                return [4, this.address()];

              case 3:
                return a = n.sent(), [4, this.securityTokenContract()];

              case 4:
                return [4, n.sent().getModule.callAsync(a)];

              case 5:
                return r = i.apply(void 0, [n.sent(), 1]), [2, "" !== r[0]];
            }
          });
        });
      }, n.isCallerTheSecurityTokenOwner = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return [4, this.getCallerAddress(e)];

              case 1:
                return t = o.sent(), [4, this.securityTokenContract()];

              case 2:
                return a = o.sent(), n = (r = p.default).checksumAddressComparision, s = [t], [4, a.owner.callAsync()];

              case 3:
                return [2, n.apply(r, s.concat([o.sent()]))];
            }
          });
        });
      }, n.isCallerAllowed = function (e, t) {
        return s(n, void 0, void 0, function () {
          var a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return [4, this.isCallerTheSecurityTokenOwner(e)];

              case 1:
                return o.sent() ? [2, !0] : [4, this.getCallerAddress(e)];

              case 2:
                return a = o.sent(), [4, this.securityTokenContract()];

              case 3:
                return n = (r = o.sent().checkPermission).callAsync, s = [a], [4, this.contract];

              case 4:
                return [4, n.apply(r, s.concat([o.sent().address, h.stringToBytes32(t)]))];

              case 5:
                return o.sent() ? [2, !0] : [2, !1];
            }
          });
        });
      }, n.contractFactory = r, n;
    }

    return n(t, e), t;
  }(d.default);

  t.default = m;
},
/*!****************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/checkpoint/dividend_checkpoint_wrapper/common.ts ***!
  \****************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r122,
      n = this && this.__extends || (_r122 = function r(e, t) {
    return (_r122 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r122(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      i = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var c = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      u = a(
  /*! ../../module_wrapper */
  17),
      d = i(a(
  /*! ../../../../utils/assert */
  15)),
      f = a(
  /*! ../../../../types */
  4),
      l = a(
  /*! ../../../../utils/convert */
  16),
      h = 150,
      p = function (e) {
    function t() {
      var t = null !== e && e.apply(this, arguments) || this;
      return t.erc20DetailedContract = function (e) {
        return s(t, void 0, void 0, function () {
          return o(this, function (t) {
            return [2, this.contractFactory.getERC20DetailedContract(e)];
          });
        });
      }, t.wallet = function () {
        return s(t, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().wallet.callAsync()];
            }
          });
        });
      }, t.getTreasuryWallet = function () {
        return s(t, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().getTreasuryWallet.callAsync()];
            }
          });
        });
      }, t.dividends = function (e) {
        return s(t, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.getDecimals(e.dividendIndex)];

              case 1:
                return t = r.sent(), [4, this.contract];

              case 2:
                return [4, r.sent().dividends.callAsync(l.numberToBigNumber(e.dividendIndex))];

              case 3:
                return a = r.sent(), [2, {
                  checkpointId: new c.BigNumber(a[0]).toNumber(),
                  created: l.bigNumberToDate(a[1]),
                  maturity: l.bigNumberToDate(a[2]),
                  expiry: l.bigNumberToDate(a[3]),
                  amount: l.weiToValue(a[4], t),
                  claimedAmount: l.weiToValue(a[5], t),
                  totalSupply: l.weiToValue(a[6], t),
                  reclaimed: a[7],
                  totalWithheld: l.weiToValue(a[8], t),
                  totalWithheldWithdrawn: l.weiToValue(a[9], t),
                  name: a[10]
                }];
            }
          });
        });
      }, t.excluded = function (e) {
        return s(t, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, t.sent().excluded.callAsync(l.numberToBigNumber(e.dividendIndex))];
            }
          });
        });
      }, t.withholdingTax = function (e) {
        return s(t, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return d.default.isETHAddressHex("investor", e.investor), [4, this.contract];

              case 1:
                return [2, t.sent().withholdingTax.callAsync(e.investor)];
            }
          });
        });
      }, t.changeWallet = function (e) {
        return s(t, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return d.default.isNonZeroETHAddressHex("wallet", e.wallet), a = (t = d.default).assert, [4, this.isCallerTheSecurityTokenOwner(e.txData)];

              case 1:
                return a.apply(t, [r.sent(), f.ErrorCode.Unauthorized, "The caller must be the ST owner"]), [4, this.contract];

              case 2:
                return [2, r.sent().changeWallet.sendTransactionAsync(e.wallet, e.txData, e.safetyFactor)];
            }
          });
        });
      }, t.getDefaultExcluded = function () {
        return s(t, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().getDefaultExcluded.callAsync()];
            }
          });
        });
      }, t.createCheckpoint = function (e) {
        return s(t, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, f.Perm.Operator)];

              case 1:
                return a.apply(t, [r.sent(), f.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.contract];

              case 2:
                return [2, r.sent().createCheckpoint.sendTransactionAsync(e.txData, e.safetyFactor)];
            }
          });
        });
      }, t.setDefaultExcluded = function (e) {
        return s(t, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, f.Perm.Admin)];

              case 1:
                return a.apply(t, [r.sent(), f.ErrorCode.Unauthorized, "Caller is not allowed"]), d.default.assert(e.excluded.length <= h, f.ErrorCode.InvalidData, "Too many excluded addresses"), e.excluded.forEach(function (e) {
                  return d.default.isNonZeroETHAddressHex("excluded", e);
                }), d.default.areThereDuplicatedStrings("excluded", e.excluded), [4, this.contract];

              case 2:
                return [2, r.sent().setDefaultExcluded.sendTransactionAsync(e.excluded, e.txData, e.safetyFactor)];
            }
          });
        });
      }, t.setWithholding = function (e) {
        return s(t, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, f.Perm.Admin)];

              case 1:
                return a.apply(t, [r.sent(), f.ErrorCode.Unauthorized, "Caller is not allowed"]), d.default.assert(e.investors.length === e.withholding.length, f.ErrorCode.InvalidData, "Mismatched input lengths"), e.withholding.forEach(function (e) {
                  return d.default.isPercentage("withholding tax", e);
                }), [4, this.contract];

              case 2:
                return [2, r.sent().setWithholding.sendTransactionAsync(e.investors, l.valueArrayToWeiArray(e.withholding, f.PERCENTAGE_DECIMALS), e.txData, e.safetyFactor)];
            }
          });
        });
      }, t.setWithholdingFixed = function (e) {
        return s(t, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, f.Perm.Admin)];

              case 1:
                return a.apply(t, [r.sent(), f.ErrorCode.Unauthorized, "Caller is not allowed"]), d.default.isPercentage("withholding tax", e.withholding), [4, this.contract];

              case 2:
                return [2, r.sent().setWithholdingFixed.sendTransactionAsync(e.investors, l.valueToWei(e.withholding, f.PERCENTAGE_DECIMALS), e.txData, e.safetyFactor)];
            }
          });
        });
      }, t.pushDividendPaymentToAddresses = function (e) {
        return s(t, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, f.Perm.Operator)];

              case 1:
                return a.apply(t, [r.sent(), f.ErrorCode.Unauthorized, "Caller is not allowed"]), e.payees.forEach(function (e) {
                  return d.default.isNonZeroETHAddressHex("payees", e);
                }), [4, this.checkValidDividend(e.dividendIndex)];

              case 2:
                return r.sent(), [4, this.contract];

              case 3:
                return [2, r.sent().pushDividendPaymentToAddresses.sendTransactionAsync(l.numberToBigNumber(e.dividendIndex), e.payees, e.txData, e.safetyFactor)];
            }
          });
        });
      }, t.pushDividendPayment = function (e) {
        return s(t, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, f.Perm.Operator)];

              case 1:
                return a.apply(t, [r.sent(), f.ErrorCode.Unauthorized, "Caller is not allowed"]), [4, this.checkValidDividend(e.dividendIndex)];

              case 2:
                return r.sent(), [4, this.contract];

              case 3:
                return [2, r.sent().pushDividendPayment.sendTransactionAsync(l.numberToBigNumber(e.dividendIndex), l.numberToBigNumber(e.start), l.numberToBigNumber(e.end), e.txData, e.safetyFactor)];
            }
          });
        });
      }, t.pullDividendPayment = function (e) {
        return s(t, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return [4, this.checkValidDividend(e.dividendIndex)];

              case 1:
                return o.sent(), a = (t = d.default).assert, [4, this.paused()];

              case 2:
                return a.apply(t, [!o.sent(), f.ErrorCode.PreconditionRequired, "Contract currently paused"]), [4, this.getCallerAddress(e.txData)];

              case 3:
                return r = o.sent(), [4, this.contract];

              case 4:
                return [4, o.sent().isClaimed.callAsync(r, l.numberToBigNumber(e.dividendIndex))];

              case 5:
                return n = o.sent(), d.default.assert(!n, f.ErrorCode.AlreadyClaimed, r + " has already claimed this dividend"), [4, this.contract];

              case 6:
                return [4, o.sent().isExcluded.callAsync(r, l.numberToBigNumber(e.dividendIndex))];

              case 7:
                return s = o.sent(), d.default.assert(!s, f.ErrorCode.AddressExcluded, r + " is excluded from dividend"), [4, this.contract];

              case 8:
                return [2, o.sent().pullDividendPayment.sendTransactionAsync(l.numberToBigNumber(e.dividendIndex), e.txData, e.safetyFactor)];
            }
          });
        });
      }, t.reclaimDividend = function (e) {
        return s(t, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, f.Perm.Operator)];

              case 1:
                return a.apply(t, [o.sent(), f.ErrorCode.Unauthorized, "Caller is not allowed"]), n = (r = d.default).assert, [4, this.isValidDividendIndex(e.dividendIndex)];

              case 2:
                return n.apply(r, [o.sent(), f.ErrorCode.InvalidData, "Invalid dividend index"]), [4, this.dividends(e)];

              case 3:
                return s = o.sent(), d.default.isPastDate(s.expiry, "Dividend expiry is in the future"), d.default.assert(!s.reclaimed, f.ErrorCode.AlreadyClaimed, "Dividend is already claimed"), [4, this.contract];

              case 4:
                return [2, o.sent().reclaimDividend.sendTransactionAsync(l.numberToBigNumber(e.dividendIndex), e.txData, e.safetyFactor)];
            }
          });
        });
      }, t.calculateDividend = function (e) {
        return s(t, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isValidDividendIndex(e.dividendIndex)];

              case 1:
                return a.apply(t, [s.sent(), f.ErrorCode.InvalidDividend, "Invalid dividend index"]), [4, this.contract];

              case 2:
                return [4, s.sent().calculateDividend.callAsync(l.numberToBigNumber(e.dividendIndex), e.payee)];

              case 3:
                return r = s.sent(), [4, this.getDecimals(e.dividendIndex)];

              case 4:
                return n = s.sent(), [2, {
                  claim: l.weiToValue(r[0], n),
                  withheld: l.weiToValue(r[1], n)
                }];
            }
          });
        });
      }, t.getDividendIndex = function (e) {
        return s(t, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, t.sent().getDividendIndex.callAsync(l.numberToBigNumber(e.checkpointId))];

              case 2:
                return [2, t.sent().map(function (e) {
                  return e.toNumber();
                })];
            }
          });
        });
      }, t.withdrawWithholding = function (e) {
        return s(t, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerAllowed(e.txData, f.Perm.Operator)];

              case 1:
                return a.apply(t, [s.sent(), f.ErrorCode.Unauthorized, "Caller is not allowed"]), n = (r = d.default).assert, [4, this.isValidDividendIndex(e.dividendIndex)];

              case 2:
                return n.apply(r, [s.sent(), f.ErrorCode.InvalidDividend, "Invalid dividend index"]), [4, this.contract];

              case 3:
                return [2, s.sent().withdrawWithholding.sendTransactionAsync(l.numberToBigNumber(e.dividendIndex), e.txData, e.safetyFactor)];
            }
          });
        });
      }, t.updateDividendDates = function (e) {
        return s(t, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerTheSecurityTokenOwner(e.txData)];

              case 1:
                return a.apply(t, [s.sent(), f.ErrorCode.Unauthorized, "The caller must be the ST owner"]), n = (r = d.default).assert, [4, this.isValidDividendIndex(e.dividendIndex)];

              case 2:
                return n.apply(r, [s.sent(), f.ErrorCode.InvalidDividend, "Invalid dividend index"]), d.default.assert(e.expiry > e.maturity, f.ErrorCode.TooLate, "Expiry before maturity"), [4, this.contract];

              case 3:
                return [2, s.sent().updateDividendDates.sendTransactionAsync(l.numberToBigNumber(e.dividendIndex), l.dateToBigNumber(e.maturity), l.dateToBigNumber(e.expiry), e.txData, e.safetyFactor)];
            }
          });
        });
      }, t.getDividendsData = function () {
        return s(t, void 0, void 0, function () {
          var e, t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, r.sent().getDividendsData.callAsync()];

              case 2:
                for (e = r.sent(), t = [], a = 0; a < e[0].length; a += 1) {
                  t.push(this.pushDividendsData(e, a));
                }

                return [2, Promise.all(t)];
            }
          });
        });
      }, t.pushDividendsData = function (e, a) {
        return s(t, void 0, void 0, function () {
          var t;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.securityTokenContract()];

              case 1:
                return [4, r.sent().decimals.callAsync()];

              case 2:
                return t = r.sent(), [2, {
                  created: l.bigNumberToDate(e[0][a]),
                  maturity: l.bigNumberToDate(e[1][a]),
                  expiry: l.bigNumberToDate(e[2][a]),
                  amount: l.weiToValue(e[3][a], t),
                  claimedAmount: l.weiToValue(e[4][a], t),
                  name: l.bytes32ToString(e[5][a])
                }];
            }
          });
        });
      }, t.getDividendData = function (e) {
        return s(t, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.securityTokenContract()];

              case 1:
                return [4, r.sent().decimals.callAsync()];

              case 2:
                return t = r.sent(), [4, this.contract];

              case 3:
                return [4, r.sent().getDividendData.callAsync(l.numberToBigNumber(e.dividendIndex))];

              case 4:
                return a = r.sent(), [2, {
                  created: l.bigNumberToDate(a[0]),
                  maturity: l.bigNumberToDate(a[1]),
                  expiry: l.bigNumberToDate(a[2]),
                  amount: l.weiToValue(a[3], t),
                  claimedAmount: l.weiToValue(a[4], t),
                  name: l.bytes32ToString(a[5])
                }];
            }
          });
        });
      }, t.getDividendProgress = function (e) {
        return s(t, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isValidDividendIndex(e.dividendIndex)];

              case 1:
                return a.apply(t, [o.sent(), f.ErrorCode.InvalidDividend, "Invalid dividend index"]), [4, this.contract];

              case 2:
                return [4, o.sent().getDividendProgress.callAsync(l.numberToBigNumber(e.dividendIndex))];

              case 3:
                for (r = o.sent(), n = [], s = 0; s < r[0].length; s += 1) {
                  n.push(this.pushDividendProgress(r, s, e.dividendIndex));
                }

                return [2, Promise.all(n)];
            }
          });
        });
      }, t.pushDividendProgress = function (e, a, r) {
        return s(t, void 0, void 0, function () {
          var t;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, this.getDecimals(r)];

              case 1:
                return t = n.sent(), [2, {
                  investor: e[0][a],
                  claimed: e[1][a],
                  excluded: e[2][a],
                  withheld: l.weiToValue(e[3][a], t),
                  amount: l.weiToValue(e[4][a], t),
                  balance: l.weiToValue(e[5][a], t)
                }];
            }
          });
        });
      }, t.getCheckpointData = function (e) {
        return s(t, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return [4, this.securityTokenContract()];

              case 1:
                return [4, s.sent().currentCheckpointId.callAsync()];

              case 2:
                return t = s.sent(), d.default.assert(e.checkpointId <= new c.BigNumber(t).toNumber(), f.ErrorCode.InvalidCheckpoint, "Invalid checkpoint"), [4, this.contract];

              case 3:
                return [4, s.sent().getCheckpointData.callAsync(l.numberToBigNumber(e.checkpointId))];

              case 4:
                for (a = s.sent(), r = [], n = 0; n < a[0].length; n += 1) {
                  r.push(this.pushCheckpointData(a, n));
                }

                return [2, Promise.all(r)];
            }
          });
        });
      }, t.pushCheckpointData = function (e, a) {
        return s(t, void 0, void 0, function () {
          var t;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.securityTokenContract()];

              case 1:
                return [4, r.sent().decimals.callAsync()];

              case 2:
                return t = r.sent(), [2, {
                  investor: e[0][a],
                  balance: l.weiToValue(e[1][a], t),
                  withheld: l.weiToValue(e[2][a], t)
                }];
            }
          });
        });
      }, t.isClaimed = function (e) {
        return s(t, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return d.default.isETHAddressHex("investor", e.investor), a = (t = d.default).assert, [4, this.isValidDividendIndex(e.dividendIndex)];

              case 1:
                return a.apply(t, [r.sent(), f.ErrorCode.InvalidDividend, "Invalid dividend index"]), [4, this.contract];

              case 2:
                return [2, r.sent().isClaimed.callAsync(e.investor, l.numberToBigNumber(e.dividendIndex))];
            }
          });
        });
      }, t.isExcluded = function (e) {
        return s(t, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return d.default.isETHAddressHex("investor", e.investor), a = (t = d.default).assert, [4, this.isValidDividendIndex(e.dividendIndex)];

              case 1:
                return a.apply(t, [r.sent(), f.ErrorCode.InvalidDividend, "Invalid dividend index"]), [4, this.contract];

              case 2:
                return [2, r.sent().isExcluded.callAsync(e.investor, l.numberToBigNumber(e.dividendIndex))];
            }
          });
        });
      }, t.isValidDividendIndex = function (e) {
        return s(t, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, a.sent().getDividendsData.callAsync()];

              case 2:
                return t = a.sent(), [2, e < t[0].length];
            }
          });
        });
      }, t.checkValidDividend = function (e) {
        return s(t, void 0, void 0, function () {
          var t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isValidDividendIndex(e)];

              case 1:
                return a.apply(t, [n.sent(), f.ErrorCode.InvalidDividend, "Invalid dividend index"]), [4, this.getDividendData({
                  dividendIndex: e
                })];

              case 2:
                return r = n.sent(), d.default.assert(!r.claimedAmount.isGreaterThan(0), f.ErrorCode.InvalidData, "Dividend claimed amount greater than 0, dividend reclaimed"), d.default.isPastDate(r.maturity, "Dividend maturity in future"), d.default.isFutureDate(r.expiry, "Dividend expiry in past"), [2];
            }
          });
        });
      }, t.checkIfDividendCreationIsValid = function (e, a, r, n, i, u, l, p) {
        return void 0 === p && (p = []), s(t, void 0, void 0, function () {
          var t, s, b, m, y, v, _, g, A, w, T, x, D, C, S;

          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return p.forEach(function (e) {
                  return d.default.isNonZeroETHAddressHex("Excluded address", e);
                }), d.default.areThereDuplicatedStrings("Excluded addresses", p), d.default.assert(p.length <= h, f.ErrorCode.ArrayTooLarge, "Too many addresses excluded"), d.default.assert(e > a, f.ErrorCode.TooLate, "Expiry before maturity"), d.default.isFutureDate(e, "Expiry in past"), d.default.isBigNumberGreaterThanZero(r, "No dividend sent"), d.default.assert(n.length > 0, f.ErrorCode.InvalidData, "The name can not be empty"), [4, this.securityTokenContract()];

              case 1:
                return t = o.sent(), l ? [4, t.currentCheckpointId.callAsync()] : [3, 3];

              case 2:
                s = o.sent(), d.default.assert(l <= s.toNumber(), f.ErrorCode.InvalidCheckpoint, "Invalid checkpoint"), o.label = 3;

              case 3:
                return [4, this.getCallerAddress(u)];

              case 4:
                return b = o.sent(), i ? (d.default.isNonZeroETHAddressHex("token", i), [4, this.erc20DetailedContract(i)]) : [3, 9];

              case 5:
                return [4, (m = o.sent()).balanceOf.callAsync(b)];

              case 6:
                return y = o.sent(), g = (_ = m.allowance).callAsync, A = [b], [4, this.address()];

              case 7:
                return [4, g.apply(_, A.concat([o.sent()]))];

              case 8:
                return v = o.sent(), d.default.assert(v.isGreaterThanOrEqualTo(r), f.ErrorCode.InsufficientAllowance, "Your allowance is less than dividend amount"), d.default.assert(y.isGreaterThanOrEqualTo(r), f.ErrorCode.InsufficientBalance, "Your balance is less than dividend amount"), [3, 11];

              case 9:
                return T = (w = d.default).assert, [4, this.web3Wrapper.getBalanceInWeiAsync(b)];

              case 10:
                T.apply(w, [o.sent().isGreaterThanOrEqualTo(r.valueOf()), f.ErrorCode.PreconditionRequired, "Caller Address ETH Balance does not meet amount needed to create dividend"]), o.label = 11;

              case 11:
                return D = [], l ? (D = p.map(function (e) {
                  return t.balanceOfAt.callAsync(e, new c.BigNumber(l));
                }), [4, t.totalSupplyAt.callAsync(new c.BigNumber(l))]) : [3, 13];

              case 12:
                return x = o.sent(), [3, 15];

              case 13:
                return D = p.map(function (e) {
                  return t.balanceOf.callAsync(e);
                }), [4, t.totalSupply.callAsync()];

              case 14:
                x = o.sent(), o.label = 15;

              case 15:
                return d.default.assert(!x.isZero(), f.ErrorCode.InvalidData, "Invalid supply, current supply must be greater than 0"), [4, Promise.all([Promise.resolve(new c.BigNumber(0))].concat(D))];

              case 16:
                return C = o.sent(), S = c.BigNumber.sum.apply(null, C), d.default.assert(x.isGreaterThan(S), f.ErrorCode.InvalidData, "Invalid supply, current supply must be greater than excluded supply"), [2];
            }
          });
        });
      }, t;
    }

    return n(t, e), t;
  }(u.ModuleCommon);

  t.default = p;
},
/*!*********************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/checkpoint/ether_dividend_checkpoint_wrapper/3.0.0.ts ***!
  \*********************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r123,
      n = this && this.__extends || (_r123 = function r(e, t) {
    return (_r123 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r123(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o = a(
  /*! ../dividend_checkpoint_wrapper */
  93),
      i = a(
  /*! ../../../../types */
  4),
      c = s(a(
  /*! ./common */
  298)),
      u = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.contractVersion = i.ContractVersion.V3_0_0, n.contract = a, n;
    }

    return n(t, e), t;
  }(o.WithDividendCheckpoint_3_0_0(c.default));

  t.EtherDividendCheckpoint_3_0_0 = u, t.isEtherDividendCheckpoint_3_0_0 = function (e) {
    return e.contractVersion === i.ContractVersion.V3_0_0;
  };
},
/*!******************************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/permission_manager/general_permission_manager_wrapper/3.0.0.ts ***!
  \******************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r124,
      n = this && this.__extends || (_r124 = function r(e, t) {
    return (_r124 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r124(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o = a(
  /*! ../../../../types */
  4),
      i = s(a(
  /*! ./common */
  143)),
      c = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.contractVersion = o.ContractVersion.V3_0_0, n.contract = a, n;
    }

    return n(t, e), t;
  }(a(
  /*! ../../module_wrapper */
  17).WithModule_3_0_0(i.default));

  t.GeneralPermissionManager_3_0_0 = c, t.isGeneralPermissionManager_3_0_0 = function (e) {
    return e.contractVersion === o.ContractVersion.V3_0_0;
  };
},
/*!******************************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/permission_manager/general_permission_manager_wrapper/3.1.0.ts ***!
  \******************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r125,
      n = this && this.__extends || (_r125 = function r(e, t) {
    return (_r125 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r125(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      i = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var c = i(a(
  /*! ../../../../utils/assert */
  15)),
      u = a(
  /*! ../../../../types */
  4),
      d = a(
  /*! ../../../../utils/convert */
  16),
      f = i(a(
  /*! ./common */
  143)),
      l = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.contractVersion = u.ContractVersion.V3_1_0, n.addDelegateMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = c.default).assert, [4, this.isCallerAllowed(e.txData, u.Perm.Admin)];

              case 1:
                for (a.apply(t, [s.sent(), u.ErrorCode.Unauthorized, "Caller is not allowed"]), c.default.assert(e.delegates.length === e.details.length, u.ErrorCode.MismatchedArrayLength, "Array length mismatch"), r = [], n = 0; n < e.delegates.length; n += 1) {
                  c.default.isNonZeroETHAddressHex("delegate", e.delegates[n]), c.default.assert(e.details[n].length > 0, u.ErrorCode.InvalidData, "0 value not allowed"), r.push(this.delegateIsNotPresent(e.delegates[n]));
                }

                return [4, Promise.all(r)];

              case 2:
                return s.sent(), [4, this.contract];

              case 3:
                return [2, s.sent().addDelegateMulti.sendTransactionAsync(e.delegates, d.stringArrayToBytes32Array(e.details), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.deleteDelegateMulti = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = c.default).assert, [4, this.isCallerAllowed(e.txData, u.Perm.Admin)];

              case 1:
                for (a.apply(t, [s.sent(), u.ErrorCode.Unauthorized, "Caller is not allowed"]), r = [], n = 0; n < e.delegates.length; n += 1) {
                  c.default.isNonZeroETHAddressHex("delegate", e.delegates[n]), r.push(this.delegateDoesNotExist(e.delegates[n]));
                }

                return [4, Promise.all(r)];

              case 2:
                return s.sent(), [4, this.contract];

              case 3:
                return [2, s.sent().deleteDelegateMulti.sendTransactionAsync(e.delegates, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.delegateIsNotPresent = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = c.default).assert, [4, this.contract];

              case 1:
                return [4, r.sent().checkDelegate.callAsync(e)];

              case 2:
                return a.apply(t, [!r.sent(), u.ErrorCode.AlreadyExists, "Delegate already present"]), [2];
            }
          });
        });
      }, n.delegateDoesNotExist = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = c.default).assert, [4, this.contract];

              case 1:
                return [4, r.sent().checkDelegate.callAsync(e)];

              case 2:
                return a.apply(t, [r.sent(), u.ErrorCode.NotFound, "Delegate does not exist"]), [2];
            }
          });
        });
      }, n.contract = a, n;
    }

    return n(t, e), t;
  }(a(
  /*! ../../module_wrapper */
  17).WithModule_3_0_0(f.default));

  t.GeneralPermissionManager_3_1_0 = l, t.isGeneralPermissionManager_3_1_0 = function (e) {
    return e.contractVersion === u.ContractVersion.V3_1_0;
  };
},
/*!***********************************************************************!*\
  !*** ./src/contract_wrappers/modules/sto/capped_sto_wrapper/3.0.0.ts ***!
  \***********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r126,
      n = this && this.__extends || (_r126 = function r(e, t) {
    return (_r126 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r126(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      i = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var c = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      u = i(a(
  /*! ./common */
  144)),
      d = a(
  /*! ../../../../types */
  4),
      f = a(
  /*! ../sto_wrapper */
  68),
      l = a(
  /*! ../../../../utils/convert */
  16),
      h = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.contractVersion = d.ContractVersion.V3_0_0, n.getSTODetails = function () {
        return s(n, void 0, void 0, function () {
          var e, t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.securityTokenContract()];

              case 1:
                return [4, a.sent().decimals.callAsync()];

              case 2:
                return e = a.sent(), [4, this.contract];

              case 3:
                return [4, a.sent().getSTODetails.callAsync()];

              case 4:
                return t = a.sent(), [2, {
                  startTime: l.bigNumberToDate(t[0]),
                  endTime: l.bigNumberToDate(t[1]),
                  cap: l.weiToValue(t[2], e),
                  rate: l.weiToValue(t[3], d.FULL_DECIMALS),
                  fundsRaised: l.weiToValue(t[4], d.FULL_DECIMALS),
                  investorCount: new c.BigNumber(t[5]).toNumber(),
                  totalTokensSold: l.weiToValue(t[6], e),
                  isRaisedInPoly: t[7]
                }];
            }
          });
        });
      }, n.contract = a, n;
    }

    return n(t, e), t;
  }(f.WithSTO_3_0_0(u.default));

  t.CappedSTO_3_0_0 = h, t.isCappedSTO_3_0_0 = function (e) {
    return e.contractVersion === d.ContractVersion.V3_0_0;
  };
},
/*!****************************************************************!*\
  !*** ./src/contract_wrappers/modules/sto/sto_wrapper/3.0.0.ts ***!
  \****************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r127,
      n = this && this.__extends || (_r127 = function r(e, t) {
    return (_r127 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r127(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  });

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var s = a(
  /*! ../../module_wrapper */
  17);

  t.WithSTO_3_0_0 = function (e) {
    var t = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return n(t, e), t;
    }(e);

    return s.WithModule_3_0_0(t);
  };
},
/*!****************************************************************!*\
  !*** ./src/contract_wrappers/modules/sto/sto_wrapper/3.1.0.ts ***!
  \****************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r128,
      n = this && this.__extends || (_r128 = function r(e, t) {
    return (_r128 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r128(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      i = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var c = a(
  /*! ../../../../types */
  4),
      u = i(a(
  /*! ../../../../utils/assert */
  15)),
      d = a(
  /*! ../../module_wrapper */
  17);

  t.WithSTO_3_1_0 = function (e) {
    var t = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.preMintAllowed = function () {
          return s(t, void 0, void 0, function () {
            return o(this, function (e) {
              switch (e.label) {
                case 0:
                  return [4, this.contract];

                case 1:
                  return [2, e.sent().preMintAllowed.callAsync()];
              }
            });
          });
        }, t.isFinalized = function () {
          return s(t, void 0, void 0, function () {
            return o(this, function (e) {
              switch (e.label) {
                case 0:
                  return [4, this.contract];

                case 1:
                  return [2, e.sent().isFinalized.callAsync()];
              }
            });
          });
        }, t.getTreasuryWallet = function () {
          return s(t, void 0, void 0, function () {
            return o(this, function (e) {
              switch (e.label) {
                case 0:
                  return [4, this.contract];

                case 1:
                  return [2, e.sent().getTreasuryWallet.callAsync()];
              }
            });
          });
        }, t.pause = function (e) {
          return s(t, void 0, void 0, function () {
            var t, a, r, n, s, i;
            return o(this, function (o) {
              switch (o.label) {
                case 0:
                  return a = (t = u.default).assert, [4, this.isFinalized()];

                case 1:
                  return a.apply(t, [!o.sent(), c.ErrorCode.PreconditionRequired, "STO already finalized"]), n = (r = u.default).assert, [4, this.paused()];

                case 2:
                  return n.apply(r, [!o.sent(), c.ErrorCode.PreconditionRequired, "Contract already paused"]), i = (s = u.default).assert, [4, this.isCallerTheSecurityTokenOwner(e.txData)];

                case 3:
                  return i.apply(s, [o.sent(), c.ErrorCode.Unauthorized, "The caller must be the ST owner"]), [4, this.contract];

                case 4:
                  return [2, o.sent().pause.sendTransactionAsync(e.txData, e.safetyFactor)];
              }
            });
          });
        }, t.finalize = function (e) {
          return s(t, void 0, void 0, function () {
            var t, a, r, n;
            return o(this, function (s) {
              switch (s.label) {
                case 0:
                  return a = (t = u.default).assert, [4, this.isCallerTheSecurityTokenOwner(e.txData)];

                case 1:
                  return a.apply(t, [s.sent(), c.ErrorCode.Unauthorized, "The caller must be the ST owner"]), n = (r = u.default).assert, [4, this.isFinalized()];

                case 2:
                  return n.apply(r, [!s.sent(), c.ErrorCode.PreconditionRequired, "STO is already finalized"]), [4, this.contract];

                case 3:
                  return [2, s.sent().finalize.sendTransactionAsync(e.txData, e.safetyFactor)];
              }
            });
          });
        }, t.reclaimERC20 = function (e) {
          return s(t, void 0, void 0, function () {
            var t, a, r, n, s;
            return o(this, function (o) {
              switch (o.label) {
                case 0:
                  return [4, this.contract];

                case 1:
                  return t = o.sent(), r = (a = u.default).assert, [4, this.isCallerTheSecurityTokenOwner(e.txData)];

                case 2:
                  return r.apply(a, [o.sent(), c.ErrorCode.Unauthorized, "The caller must be the ST owner"]), [4, t.securityToken.callAsync()];

                case 3:
                  return o.sent() !== e.tokenContract ? [3, 5] : (s = (n = u.default).assert, [4, this.isFinalized()]);

                case 4:
                  s.apply(n, [o.sent(), c.ErrorCode.PreconditionRequired, "STO should be finalized to be able to reclaim minted tokens"]), o.label = 5;

                case 5:
                  return u.default.isNonZeroETHAddressHex("tokenContract", e.tokenContract), [4, this.contract];

                case 6:
                  return [2, o.sent().reclaimERC20.sendTransactionAsync(e.tokenContract, e.txData, e.safetyFactor)];
              }
            });
          });
        }, t.allowPreMinting = function (e) {
          return s(t, void 0, void 0, function () {
            var t, a;
            return o(this, function (r) {
              switch (r.label) {
                case 0:
                  return a = (t = u.default).isFutureDate, [4, this.startTime()];

                case 1:
                  return a.apply(t, [r.sent(), "STO already started"]), [4, this.contract];

                case 2:
                  return [2, r.sent().allowPreMinting.sendTransactionAsync(e.txData, e.safetyFactor)];
              }
            });
          });
        }, t.revokePreMintFlag = function (e) {
          return s(t, void 0, void 0, function () {
            var t, a;
            return o(this, function (r) {
              switch (r.label) {
                case 0:
                  return a = (t = u.default).isFutureDate, [4, this.startTime()];

                case 1:
                  return a.apply(t, [r.sent(), "STO already started"]), [4, this.contract];

                case 2:
                  return [2, r.sent().revokePreMintFlag.sendTransactionAsync(e.txData, e.safetyFactor)];
              }
            });
          });
        }, t;
      }

      return n(t, e), t;
    }(e);

    return d.WithModule_3_0_0(t);
  };
},
/*!*****************************************************************!*\
  !*** ./src/contract_wrappers/modules/sto/sto_wrapper/common.ts ***!
  \*****************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r129,
      n = this && this.__extends || (_r129 = function r(e, t) {
    return (_r129 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r129(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var i = a(
  /*! ../../../../types */
  4),
      c = a(
  /*! ../../module_wrapper */
  17),
      u = a(
  /*! ../../../../utils/convert */
  16),
      d = function (e) {
    function t() {
      var t = null !== e && e.apply(this, arguments) || this;
      return t.fundRaiseTypes = function (e) {
        return s(t, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, t.sent().fundRaiseTypes.callAsync(e.type)];
            }
          });
        });
      }, t.fundsRaised = function (e) {
        return s(t, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return t = u.weiToValue, [4, this.contract];

              case 1:
                return [4, a.sent().fundsRaised.callAsync(e.type)];

              case 2:
                return [2, t.apply(void 0, [a.sent(), i.FULL_DECIMALS])];
            }
          });
        });
      }, t.startTime = function () {
        return s(t, void 0, void 0, function () {
          var e;
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return e = u.bigNumberToDate, [4, this.contract];

              case 1:
                return [4, t.sent().startTime.callAsync()];

              case 2:
                return [2, e.apply(void 0, [t.sent()])];
            }
          });
        });
      }, t.endTime = function () {
        return s(t, void 0, void 0, function () {
          var e;
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return e = u.bigNumberToDate, [4, this.contract];

              case 1:
                return [4, t.sent().endTime.callAsync()];

              case 2:
                return [2, e.apply(void 0, [t.sent()])];
            }
          });
        });
      }, t.pausedTime = function () {
        return s(t, void 0, void 0, function () {
          var e;
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return e = u.bigNumberToDate, [4, this.contract];

              case 1:
                return [4, t.sent().pausedTime.callAsync()];

              case 2:
                return [2, e.apply(void 0, [t.sent()])];
            }
          });
        });
      }, t.investorCount = function () {
        return s(t, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, e.sent().investorCount.callAsync()];

              case 2:
                return [2, e.sent().toNumber()];
            }
          });
        });
      }, t.wallet = function () {
        return s(t, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().wallet.callAsync()];
            }
          });
        });
      }, t.totalTokensSold = function () {
        return s(t, void 0, void 0, function () {
          var e, t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return e = u.weiToValue, [4, this.contract];

              case 1:
                return [4, a.sent().totalTokensSold.callAsync()];

              case 2:
                return t = [a.sent()], [4, this.securityTokenContract()];

              case 3:
                return [4, a.sent().decimals.callAsync()];

              case 4:
                return [2, e.apply(void 0, t.concat([a.sent()]))];
            }
          });
        });
      }, t.getRaised = function (e) {
        return s(t, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return t = u.weiToValue, [4, this.contract];

              case 1:
                return [4, a.sent().getRaised.callAsync(e.type)];

              case 2:
                return [2, t.apply(void 0, [a.sent(), i.FULL_DECIMALS])];
            }
          });
        });
      }, t;
    }

    return n(t, e), t;
  }(c.ModuleCommon);

  t.default = d;
},
/*!***********************************************************************!*\
  !*** ./src/contract_wrappers/modules/sto/capped_sto_wrapper/3.1.0.ts ***!
  \***********************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r130,
      n = this && this.__extends || (_r130 = function r(e, t) {
    return (_r130 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r130(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__assign || function () {
    return (s = Object.assign || function (e) {
      for (var t, a = 1, r = arguments.length; a < r; a++) {
        for (var n in t = arguments[a]) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  },
      o = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      i = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      c = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var u = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      d = a(
  /*! @0x/json-schemas */
  2),
      f = c(a(
  /*! ../../../../utils/functions_utils */
  40)),
      l = c(a(
  /*! ./common */
  144)),
      h = c(a(
  /*! ../../../../utils/assert */
  15)),
      p = a(
  /*! ../../../../types */
  4),
      b = a(
  /*! ../../../../utils/convert */
  16),
      m = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.contractVersion = p.ContractVersion.V3_1_0, n.getSTODetails = function () {
        return o(n, void 0, void 0, function () {
          var e, t;
          return i(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.securityTokenContract()];

              case 1:
                return [4, a.sent().decimals.callAsync()];

              case 2:
                return e = a.sent(), [4, this.contract];

              case 3:
                return [4, a.sent().getSTODetails.callAsync()];

              case 4:
                return t = a.sent(), [2, {
                  startTime: b.bigNumberToDate(t[0]),
                  endTime: b.bigNumberToDate(t[1]),
                  cap: b.weiToValue(t[2], e),
                  rate: b.weiToValue(t[3], p.FULL_DECIMALS),
                  fundsRaised: b.weiToValue(t[4], p.FULL_DECIMALS),
                  investorCount: new u.BigNumber(t[5]).toNumber(),
                  totalTokensSold: b.weiToValue(t[6], e),
                  isRaisedInPoly: t[7],
                  preMintingAllowed: t[8]
                }];
            }
          });
        });
      }, n.buyTokens = function (e) {
        return o(n, void 0, void 0, function () {
          var t, a, r, n, o, c, u, d, l, m, y, v, _, g, A, w, T, x, D;

          return i(this, function (i) {
            switch (i.label) {
              case 0:
                return a = (t = h.default).assert, [4, this.isFinalized()];

              case 1:
                return a.apply(t, [!i.sent(), p.ErrorCode.PreconditionRequired, "STO is already finalized"]), h.default.isNonZeroETHAddressHex("beneficiary", e.beneficiary), n = (r = h.default).assert, [4, this.paused()];

              case 2:
                return n.apply(r, [!i.sent(), p.ErrorCode.ContractPaused, "Should not be paused"]), h.default.isBigNumberGreaterThanZero(e.value, "Amount invested should not be equal to 0"), u = (c = this.web3Wrapper).getBalanceInWeiAsync, [4, this.getCallerAddress(e.txData)];

              case 3:
                return [4, u.apply(c, [i.sent()])];

              case 4:
                return o = i.sent(), h.default.assert(o.isGreaterThan(b.valueToWei(e.value, p.FULL_DECIMALS)), p.ErrorCode.InsufficientBalance, "Insufficient ETH funds"), l = (d = h.default).assert, [4, this.fundRaiseTypes({
                  type: p.FundRaiseType.ETH
                })];

              case 5:
                return l.apply(d, [i.sent(), p.ErrorCode.DifferentMode, "Mode of investment is not ETH"]), [4, this.allowBeneficialInvestments()];

              case 6:
                return i.sent() ? (y = (m = h.default).assert, _ = (v = f.default).checksumAddressComparision, g = [e.beneficiary], [4, this.getCallerAddress(e.txData)]) : [3, 8];

              case 7:
                y.apply(m, [_.apply(v, g.concat([i.sent()])), p.ErrorCode.Unauthorized, "Beneficiary address does not match msg.sender"]), i.label = 8;

              case 8:
                return w = (A = h.default).isPastDate, [4, this.startTime()];

              case 9:
                return w.apply(A, [i.sent(), "Offering is not yet started"]), x = (T = h.default).isFutureDate, [4, this.endTime()];

              case 10:
                return x.apply(T, [i.sent(), "Offering is closed"]), D = s({}, e.txData, {
                  value: b.valueToWei(e.value, p.FULL_DECIMALS)
                }), [4, this.contract];

              case 11:
                return [2, i.sent().buyTokens.sendTransactionAsync(e.beneficiary, D, e.safetyFactor)];
            }
          });
        });
      }, n.buyTokensWithPoly = function (e) {
        return o(n, void 0, void 0, function () {
          var t, a, r, n, s, o, c, u, d, f, l, m, y;
          return i(this, function (i) {
            switch (i.label) {
              case 0:
                return a = (t = h.default).assert, [4, this.isFinalized()];

              case 1:
                return a.apply(t, [!i.sent(), p.ErrorCode.PreconditionRequired, "STO is already finalized"]), h.default.isBigNumberGreaterThanZero(e.investedPOLY, "Amount invested should not be equal to 0"), n = (r = h.default).assert, [4, this.paused()];

              case 2:
                return n.apply(r, [!i.sent(), p.ErrorCode.ContractPaused, "Should not be paused"]), o = (s = h.default).assert, [4, this.fundRaiseTypes({
                  type: p.FundRaiseType.POLY
                })];

              case 3:
                return o.apply(s, [i.sent(), p.ErrorCode.DifferentMode, "Mode of investment is not POLY"]), [4, this.polyTokenContract()];

              case 4:
                return d = (u = i.sent().balanceOf).callAsync, [4, this.getCallerAddress(e.txData)];

              case 5:
                return [4, d.apply(u, [i.sent()])];

              case 6:
                return c = i.sent(), h.default.assert(c.isGreaterThanOrEqualTo(b.valueToWei(e.investedPOLY, p.FULL_DECIMALS)), p.ErrorCode.InvalidTransfer, "Budget less than amount unable to transfer fee"), l = (f = h.default).isPastDate, [4, this.startTime()];

              case 7:
                return l.apply(f, [i.sent(), "Offering is not yet started"]), y = (m = h.default).isFutureDate, [4, this.endTime()];

              case 8:
                return y.apply(m, [i.sent(), "Offering is closed"]), [4, this.contract];

              case 9:
                return [2, i.sent().buyTokensWithPoly.sendTransactionAsync(b.valueToWei(e.investedPOLY, p.FULL_DECIMALS), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.subscribeAsync = function (e) {
        return o(n, void 0, void 0, function () {
          var t;
          return i(this, function (a) {
            switch (a.label) {
              case 0:
                return h.default.doesBelongToStringEnum("eventName", e.eventName, u.CappedSTOEvents_3_1_0), h.default.doesConformToSchema("indexFilterValues", e.indexFilterValues, d.schemas.indexFilterValuesSchema), h.default.isFunction("callback", e.callback), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.subscribeInternal(t, e.eventName, e.indexFilterValues, e.callback, e.isVerbose)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.getLogsAsync = function (e) {
        return o(n, void 0, void 0, function () {
          var t;
          return i(this, function (a) {
            switch (a.label) {
              case 0:
                return h.default.doesBelongToStringEnum("eventName", e.eventName, u.CappedSTOEvents_3_1_0), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.getLogsAsyncInternal(t, e.eventName, e.blockRange, e.indexFilterValues)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.contract = a, n;
    }

    return n(t, e), t;
  }(a(
  /*! ../sto_wrapper */
  68).WithSTO_3_1_0(l.default));

  t.CappedSTO_3_1_0 = m, t.isCappedSTO_3_1_0 = function (e) {
    return e.contractVersion === p.ContractVersion.V3_1_0;
  };
},
/*!***************************************************************************!*\
  !*** ./src/contract_wrappers/modules/sto/usd_tiered_sto_wrapper/3.0.0.ts ***!
  \***************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r131,
      n = this && this.__extends || (_r131 = function r(e, t) {
    return (_r131 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r131(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      i = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var c = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      u = i(a(
  /*! ./common */
  145)),
      d = i(a(
  /*! ../../../../utils/assert */
  15)),
      f = a(
  /*! ../../../../types */
  4),
      l = a(
  /*! ../../../../utils/convert */
  16),
      h = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.contractVersion = f.ContractVersion.V3_0_0, n.getTokensSoldByTier = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, this.getNumberOfTiers()];

              case 1:
                return t = n.sent(), d.default.assert(e.tier < new c.BigNumber(t).toNumber(), f.ErrorCode.InvalidData, "Invalid tier"), a = l.weiToValue, [4, this.contract];

              case 2:
                return [4, n.sent().getTokensSoldByTier.callAsync(l.numberToBigNumber(e.tier))];

              case 3:
                return r = [n.sent()], [4, this.securityTokenContract()];

              case 4:
                return [4, n.sent().decimals.callAsync()];

              case 5:
                return [2, a.apply(void 0, r.concat([n.sent()]))];
            }
          });
        });
      }, n.treasuryWallet = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().treasuryWallet.callAsync()];
            }
          });
        });
      }, n.isFinalized = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().isFinalized.callAsync()];
            }
          });
        });
      }, n.tiers = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.securityTokenContract()];

              case 1:
                return [4, r.sent().decimals.callAsync()];

              case 2:
                return t = r.sent(), [4, this.contract];

              case 3:
                return [4, r.sent().tiers.callAsync(l.numberToBigNumber(e.tier))];

              case 4:
                return a = r.sent(), [2, {
                  rate: l.weiToValue(a[0], f.FULL_DECIMALS),
                  rateDiscountPoly: l.weiToValue(a[1], f.FULL_DECIMALS),
                  tokenTotal: l.weiToValue(a[2], t),
                  tokensDiscountPoly: l.weiToValue(a[3], t),
                  mintedTotal: l.weiToValue(a[4], t),
                  mintedDiscountPoly: l.weiToValue(a[5], t)
                }];
            }
          });
        });
      }, n.getTokensMintedByTier = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return [4, this.securityTokenContract()];

              case 1:
                return [4, o.sent().decimals.callAsync()];

              case 2:
                return t = o.sent(), r = (a = d.default).assert, n = e.tier, [4, this.getNumberOfTiers()];

              case 3:
                return r.apply(a, [n < o.sent(), f.ErrorCode.InvalidData, "Invalid tier"]), [4, this.contract];

              case 4:
                return [4, o.sent().getTokensMintedByTier.callAsync(l.numberToBigNumber(e.tier))];

              case 5:
                return s = o.sent(), [2, {
                  mintedInETH: l.weiToValue(s[0], t),
                  mintedInPOLY: l.weiToValue(s[1], t),
                  mintedInSC: l.weiToValue(s[2], t)
                }];
            }
          });
        });
      }, n.finalize = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerTheSecurityTokenOwner(e.txData)];

              case 1:
                return a.apply(t, [s.sent(), f.ErrorCode.Unauthorized, "The caller must be the ST owner"]), n = (r = d.default).assert, [4, this.isFinalized()];

              case 2:
                return n.apply(r, [!s.sent(), f.ErrorCode.PreconditionRequired, "STO is already finalized"]), [4, this.contract];

              case 3:
                return [2, s.sent().finalize.sendTransactionAsync(e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.modifyOracle = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = d.default).assert, [4, this.isCallerTheSecurityTokenOwner(e.txData)];

              case 1:
                return a.apply(t, [r.sent(), f.ErrorCode.Unauthorized, "The caller must be the ST owner"]), d.default.assert(e.fundRaiseType === f.FundRaiseType.POLY || e.fundRaiseType === f.FundRaiseType.ETH, f.ErrorCode.InvalidData, "Invalid currency"), [4, this.contract];

              case 2:
                return [2, r.sent().modifyOracle.sendTransactionAsync(e.fundRaiseType, e.oracleAddress, e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.contract = a, n;
    }

    return n(t, e), t;
  }(a(
  /*! ../sto_wrapper */
  68).WithSTO_3_0_0(u.default));

  t.USDTieredSTO_3_0_0 = h, t.isUSDTieredSTO_3_0_0 = function (e) {
    return e.contractVersion === f.ContractVersion.V3_0_0;
  };
},
/*!**************************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/transfer_manager/general_transfer_manager_wrapper/3.0.0.ts ***!
  \**************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r132,
      n = this && this.__extends || (_r132 = function r(e, t) {
    return (_r132 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r132(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o = a(
  /*! ../../../../types */
  4),
      i = s(a(
  /*! ./common */
  147)),
      c = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.contractVersion = o.ContractVersion.V3_0_0, n.contract = a, n;
    }

    return n(t, e), t;
  }(a(
  /*! ../../module_wrapper */
  17).WithModule_3_0_0(i.default));

  t.GeneralTransferManager_3_0_0 = c, t.isGeneralTransferManager_3_0_0 = function (e) {
    return e.contractVersion === o.ContractVersion.V3_0_0;
  };
},
/*!**************************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/transfer_manager/general_transfer_manager_wrapper/3.1.0.ts ***!
  \**************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r133,
      n = this && this.__extends || (_r133 = function r(e, t) {
    return (_r133 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r133(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      i = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var c = a(
  /*! ../../../../types */
  4),
      u = i(a(
  /*! ./common */
  147)),
      d = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.contractVersion = c.ContractVersion.V3_1_0, n.whitelistModule = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, e.sent().WHITELISTMODULE.callAsync()];

              case 2:
                return [2, e.sent().toNumber()];
            }
          });
        });
      }, n.contract = a, n;
    }

    return n(t, e), t;
  }(a(
  /*! ../../module_wrapper */
  17).WithModule_3_0_0(u.default));

  t.GeneralTransferManager_3_1_0 = d, t.isGeneralTransferManager_3_1_0 = function (e) {
    return e.contractVersion === c.ContractVersion.V3_1_0;
  };
},
/*!***************************************************************************!*\
  !*** ./src/contract_wrappers/modules/sto/usd_tiered_sto_wrapper/3.1.0.ts ***!
  \***************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r134,
      n = this && this.__extends || (_r134 = function r(e, t) {
    return (_r134 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r134(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      i = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var c = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      u = a(
  /*! @0x/json-schemas */
  2),
      d = i(a(
  /*! ./common */
  145)),
      f = i(a(
  /*! ../../../../utils/assert */
  15)),
      l = a(
  /*! ../../../../types */
  4),
      h = a(
  /*! ../../../../utils/convert */
  16),
      p = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.contractVersion = l.ContractVersion.V3_1_0, n.getSTODetails = function () {
        return s(n, void 0, void 0, function () {
          var e, t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, a.sent().getSTODetails.callAsync()];

              case 2:
                return e = a.sent(), [4, this.securityTokenContract()];

              case 3:
                return [4, a.sent().decimals.callAsync()];

              case 4:
                return t = a.sent(), [2, {
                  startTime: h.bigNumberToDate(e[0]),
                  endTime: h.bigNumberToDate(e[1]),
                  currentTier: new c.BigNumber(e[2]).toNumber(),
                  capPerTier: h.weiArrayToValueArray(e[3], t),
                  ratePerTier: h.weiArrayToValueArray(e[4], l.FULL_DECIMALS),
                  fundsRaised: h.weiToValue(e[5], l.FULL_DECIMALS),
                  investorCount: e[6].toNumber(),
                  tokensSold: h.weiToValue(e[7], t),
                  isRaisedInETH: e[8][0],
                  isRaisedInPOLY: e[8][1],
                  isRaisedInSC: e[8][2],
                  preMintingAllowed: e[9]
                }];
            }
          });
        });
      }, n.tiers = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, this.securityTokenContract()];

              case 1:
                return [4, r.sent().decimals.callAsync()];

              case 2:
                return t = r.sent(), [4, this.contract];

              case 3:
                return [4, r.sent().tiers.callAsync(h.numberToBigNumber(e.tier))];

              case 4:
                return a = r.sent(), [2, {
                  rate: h.weiToValue(a[0], l.FULL_DECIMALS),
                  rateDiscountPoly: h.weiToValue(a[1], l.FULL_DECIMALS),
                  tokenTotal: h.weiToValue(a[2], t),
                  tokensDiscountPoly: h.weiToValue(a[3], t),
                  totalTokensSoldInTier: h.weiToValue(a[4], t),
                  soldDiscountPoly: h.weiToValue(a[5], t)
                }];
            }
          });
        });
      }, n.getTotalTokensSoldByTier = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r;
          return o(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, this.getNumberOfTiers()];

              case 1:
                return t = n.sent(), f.default.assert(e.tier < new c.BigNumber(t).toNumber(), l.ErrorCode.InvalidData, "Invalid tier"), a = h.weiToValue, [4, this.contract];

              case 2:
                return [4, n.sent().getTotalTokensSoldByTier.callAsync(h.numberToBigNumber(e.tier))];

              case 3:
                return r = [n.sent()], [4, this.securityTokenContract()];

              case 4:
                return [4, n.sent().decimals.callAsync()];

              case 5:
                return [2, a.apply(void 0, r.concat([n.sent()]))];
            }
          });
        });
      }, n.getTokensSoldByTier = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n, s;
          return o(this, function (o) {
            switch (o.label) {
              case 0:
                return [4, this.securityTokenContract()];

              case 1:
                return [4, o.sent().decimals.callAsync()];

              case 2:
                return t = o.sent(), r = (a = f.default).assert, n = e.tier, [4, this.getNumberOfTiers()];

              case 3:
                return r.apply(a, [n < o.sent(), l.ErrorCode.InvalidData, "Invalid tier"]), [4, this.contract];

              case 4:
                return [4, o.sent().getTokensSoldByTier.callAsync(h.numberToBigNumber(e.tier))];

              case 5:
                return s = o.sent(), [2, {
                  mintedInETH: h.weiToValue(s[0], t),
                  mintedInPOLY: h.weiToValue(s[1], t),
                  mintedInSC: h.weiToValue(s[2], t)
                }];
            }
          });
        });
      }, n.denominatedCurrency = function () {
        return s(n, void 0, void 0, function () {
          var e;
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, t.sent().denominatedCurrency.callAsync()];

              case 2:
                return e = t.sent(), [2, h.bytes32ToString(e)];
            }
          });
        });
      }, n.modifyOracles = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.isCallerTheSecurityTokenOwner(e.txData)];

              case 1:
                return a.apply(t, [s.sent(), l.ErrorCode.Unauthorized, "The caller must be the ST owner"]), [4, this.denominatedCurrency()];

              case 2:
                return s.sent() === e.denominatedCurrencySymbol ? [3, 4] : (n = (r = f.default).isFutureDate, [4, this.startTime()]);

              case 3:
                n.apply(r, [s.sent(), "The denominated currency can change only if the STO hasn't started yet"]), s.label = 4;

              case 4:
                return e.customOracleAddresses.length > 0 ? (f.default.assert("" !== e.denominatedCurrencySymbol, l.ErrorCode.InvalidData, "Denominated currency symbol can not be empty"), f.default.assert(2 === e.customOracleAddresses.length, l.ErrorCode.InvalidLength, "Custom oracle addresses array must have two values"), [4, this.fundRaiseTypes({
                  type: l.FundRaiseType.ETH
                })]) : [3, 7];

              case 5:
                return s.sent() && f.default.isNonZeroETHAddressHex("ETH Oracle Address", e.customOracleAddresses[0]), [4, this.fundRaiseTypes({
                  type: l.FundRaiseType.POLY
                })];

              case 6:
                return s.sent() && f.default.isNonZeroETHAddressHex("POLY Oracle Address", e.customOracleAddresses[1]), [3, 8];

              case 7:
                f.default.assert("" === e.denominatedCurrencySymbol, l.ErrorCode.InvalidData, "Invalid denominatedCurrencySymbol"), s.label = 8;

              case 8:
                return [4, this.contract];

              case 9:
                return [2, s.sent().modifyOracles.sendTransactionAsync(e.customOracleAddresses, h.stringToBytes32(e.denominatedCurrencySymbol), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.getCustomOracleAddress = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, t.sent().getCustomOracleAddress.callAsync(e.fundRaiseType)];

              case 2:
                return [2, t.sent()];
            }
          });
        });
      }, n.subscribeAsync = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return f.default.doesBelongToStringEnum("eventName", e.eventName, c.USDTieredSTOEvents_3_1_0), f.default.doesConformToSchema("indexFilterValues", e.indexFilterValues, u.schemas.indexFilterValuesSchema), f.default.isFunction("callback", e.callback), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.subscribeInternal(t, e.eventName, e.indexFilterValues, e.callback, e.isVerbose)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.getLogsAsync = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return f.default.doesBelongToStringEnum("eventName", e.eventName, c.USDTieredSTOEvents_3_1_0), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.getLogsAsyncInternal(t, e.eventName, e.blockRange, e.indexFilterValues)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, n.contract = a, n;
    }

    return n(t, e), t;
  }(a(
  /*! ../sto_wrapper */
  68).WithSTO_3_1_0(d.default));

  t.USDTieredSTO_3_1_0 = p, t.isUSDTieredSTO_3_1_0 = function (e) {
    return e.contractVersion === l.ContractVersion.V3_1_0;
  };
},
/*!************************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/transfer_manager/count_transfer_manager_wrapper/3.0.0.ts ***!
  \************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r135,
      n = this && this.__extends || (_r135 = function r(e, t) {
    return (_r135 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r135(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o = a(
  /*! ../../../../types */
  4),
      i = s(a(
  /*! ./common */
  303)),
      c = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.contractVersion = o.ContractVersion.V3_0_0, n.contract = a, n;
    }

    return n(t, e), t;
  }(a(
  /*! ../../module_wrapper */
  17).WithModule_3_0_0(i.default));

  t.CountTransferManager_3_0_0 = c, t.isCountTransferManager_3_0_0 = function (e) {
    return e.contractVersion === o.ContractVersion.V3_0_0;
  };
},
/*!**********************************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/transfer_manager/manual_approval_transfer_manager_wrapper/3.0.0.ts ***!
  \**********************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r136,
      n = this && this.__extends || (_r136 = function r(e, t) {
    return (_r136 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r136(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o = s(a(
  /*! ./common */
  305)),
      i = a(
  /*! ../../../../types */
  4),
      c = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.contractVersion = i.ContractVersion.V3_0_0, n.contract = a, n;
    }

    return n(t, e), t;
  }(a(
  /*! ../../module_wrapper */
  17).WithModule_3_0_0(o.default));

  t.ManualApprovalTransferManager_3_0_0 = c, t.isManualApprovalTransferManager_3_0_0 = function (e) {
    return e.contractVersion === i.ContractVersion.V3_0_0;
  };
},
/*!*****************************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/transfer_manager/percentage_transfer_manager_wrapper/3.0.0.ts ***!
  \*****************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r137,
      n = this && this.__extends || (_r137 = function r(e, t) {
    return (_r137 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r137(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o = a(
  /*! ../../../../types */
  4),
      i = s(a(
  /*! ./common */
  307)),
      c = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.contractVersion = o.ContractVersion.V3_0_0, n.contract = a, n;
    }

    return n(t, e), t;
  }(a(
  /*! ../../module_wrapper */
  17).WithModule_3_0_0(i.default));

  t.PercentageTransferManager_3_0_0 = c, t.isPercentageTransferManager_3_0_0 = function (e) {
    return e.contractVersion === o.ContractVersion.V3_0_0;
  };
},
/*!**************************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/transfer_manager/lock_up_transfer_manager_wrapper/3.0.0.ts ***!
  \**************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r138,
      n = this && this.__extends || (_r138 = function r(e, t) {
    return (_r138 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r138(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o = s(a(
  /*! ./common */
  309)),
      i = a(
  /*! ../../../../types */
  4),
      c = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.contractVersion = i.ContractVersion.V3_0_0, n.contract = a, n;
    }

    return n(t, e), t;
  }(a(
  /*! ../../module_wrapper */
  17).WithModule_3_0_0(o.default));

  t.LockUpTransferManager_3_0_0 = c, t.isLockUpTransferManager_3_0_0 = function (e) {
    return e.contractVersion === i.ContractVersion.V3_0_0;
  };
},
/*!****************************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/transfer_manager/blacklist_transfer_manager_wrapper/3.0.0.ts ***!
  \****************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r139,
      n = this && this.__extends || (_r139 = function r(e, t) {
    return (_r139 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r139(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o = a(
  /*! ../../../../types */
  4),
      i = s(a(
  /*! ./common */
  311)),
      c = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.contractVersion = o.ContractVersion.V3_0_0, n.contract = a, n;
    }

    return n(t, e), t;
  }(a(
  /*! ../../module_wrapper */
  17).WithModule_3_0_0(i.default));

  t.BlacklistTransferManager_3_0_0 = c, t.isBlacklistTransferManager_3_0_0 = function (e) {
    return e.contractVersion === o.ContractVersion.V3_0_0;
  };
},
/*!*************************************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/transfer_manager/volume_restriction_transfer_manager_wrapper/3.0.0.ts ***!
  \*************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r140,
      n = this && this.__extends || (_r140 = function r(e, t) {
    return (_r140 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r140(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o = s(a(
  /*! ./common */
  313)),
      i = a(
  /*! ../../../../types */
  4),
      c = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.contractVersion = i.ContractVersion.V3_0_0, n.contract = a, n;
    }

    return n(t, e), t;
  }(a(
  /*! ../../module_wrapper */
  17).WithModule_3_0_0(o.default));

  t.VolumeRestrictionTransferManager_3_0_0 = c, t.isVolumeRestrictionTransferManager_3_0_0 = function (e) {
    return e.contractVersion === i.ContractVersion.V3_0_0;
  };
},
/*!******************************************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/transfer_manager/restricted_partial_sale_transfer_manager_wrapper/3.1.0.ts ***!
  \******************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r141,
      n = this && this.__extends || (_r141 = function r(e, t) {
    return (_r141 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r141(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o = a(
  /*! ../../../../types */
  4),
      i = s(a(
  /*! ./common */
  315)),
      c = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.contractVersion = o.ContractVersion.V3_1_0, n.contract = a, n;
    }

    return n(t, e), t;
  }(a(
  /*! ../../module_wrapper */
  17).WithModule_3_0_0(i.default));

  t.RestrictedPartialSaleTransferManager_3_1_0 = c, t.isRestrictedPartialSaleTransferManager_3_1_0 = function (e) {
    return e.contractVersion === o.ContractVersion.V3_1_0;
  };
},
/*!*************************************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/checkpoint/voting/advanced_p_l_c_r_voting_checkpoint_wrapper/3.1.0.ts ***!
  \*************************************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r142,
      n = this && this.__extends || (_r142 = function r(e, t) {
    return (_r142 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r142(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o = a(
  /*! ../../../../../types */
  4),
      i = s(a(
  /*! ./common */
  317)),
      c = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.contractVersion = o.ContractVersion.V3_1_0, n.contract = a, n;
    }

    return n(t, e), t;
  }(a(
  /*! ../../../module_wrapper */
  17).WithModule_3_0_0(i.default));

  t.AdvancedPLCRVotingCheckpoint_3_1_0 = c, t.isAdvancedPLCRVotingCheckpoint_3_1_0 = function (e) {
    return e.contractVersion === o.ContractVersion.V3_1_0;
  };
},
/*!*************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/wallet/vesting_escrow_wallet_wrapper/3.0.0.ts ***!
  \*************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r143,
      n = this && this.__extends || (_r143 = function r(e, t) {
    return (_r143 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r143(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      i = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var c = a(
  /*! ../../../../types */
  4),
      u = a(
  /*! ../../../../utils/convert */
  16),
      d = i(a(
  /*! ./common */
  148)),
      f = i(a(
  /*! ../../../../utils/assert */
  15)),
      l = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.contractVersion = c.ContractVersion.V3_0_0, n.treasuryWallet = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [2, e.sent().treasuryWallet.callAsync()];
            }
          });
        });
      }, n.modifySchedule = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = f.default).assert, [4, this.isCallerAllowed(e.txData, c.Perm.Admin)];

              case 1:
                return a.apply(t, [r.sent(), c.ErrorCode.Unauthorized, "Caller is not allowed"]), this.checkSchedule(e.beneficiary), f.default.assert(e.startTime.getTime() > Date.now(), c.ErrorCode.TooEarly, "Date in the past"), [4, this.contract];

              case 2:
                return [2, r.sent().modifySchedule.sendTransactionAsync(e.beneficiary, u.stringToBytes32(e.templateName), u.dateToBigNumber(e.startTime), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.contract = a, n;
    }

    return n(t, e), t;
  }(a(
  /*! ../../module_wrapper */
  17).WithModule_3_0_0(d.default));

  t.VestingEscrowWallet_3_0_0 = l, t.isVestingEscrowWallet_3_0_0 = function (e) {
    return e.contractVersion === c.ContractVersion.V3_0_0;
  };
},
/*!*************************************************************************************!*\
  !*** ./src/contract_wrappers/modules/wallet/vesting_escrow_wallet_wrapper/3.1.0.ts ***!
  \*************************************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r144,
      n = this && this.__extends || (_r144 = function r(e, t) {
    return (_r144 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r144(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      i = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var c = i(a(
  /*! ../../../../utils/assert */
  15)),
      u = a(
  /*! ../../../../types */
  4),
      d = a(
  /*! ../../../../utils/convert */
  16),
      f = i(a(
  /*! ./common */
  148)),
      l = function (e) {
    function t(t, a, r) {
      var n = e.call(this, t, a, r) || this;
      return n.contractVersion = u.ContractVersion.V3_1_0, n.modifySchedule = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return a = (t = c.default).assert, [4, this.isCallerAllowed(e.txData, u.Perm.Admin)];

              case 1:
                return a.apply(t, [r.sent(), u.ErrorCode.Unauthorized, "Caller is not allowed"]), this.checkSchedule(e.beneficiary), c.default.assert(e.startTime.getTime() >= Date.now(), u.ErrorCode.TooEarly, "Date in the past"), [4, this.contract];

              case 2:
                return [2, r.sent().modifySchedule.sendTransactionAsync(e.beneficiary, d.stringToBytes32(e.templateName), d.dateToBigNumber(e.startTime), e.txData, e.safetyFactor)];
            }
          });
        });
      }, n.templates = function (e) {
        return s(n, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, a.sent().templates.callAsync(d.stringToBytes32(e))];

              case 2:
                return t = a.sent(), [2, {
                  numberOfTokens: t[0],
                  duration: t[1].toNumber(),
                  frequency: t[2].toNumber(),
                  index: t[3].toNumber()
                }];
            }
          });
        });
      }, n.getSchedulesCountByTemplate = function (e) {
        return s(n, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return c.default.assert("" !== e, u.ErrorCode.InvalidData, "Invalid name"), [4, this.contract];

              case 1:
                return [4, t.sent().getSchedulesCountByTemplate.callAsync(d.stringToBytes32(e))];

              case 2:
                return [2, t.sent().toNumber()];
            }
          });
        });
      }, n.getAllBeneficiaries = function () {
        return s(n, void 0, void 0, function () {
          return o(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, this.contract];

              case 1:
                return [4, e.sent().getAllBeneficiaries.callAsync()];

              case 2:
                return [2, e.sent()];
            }
          });
        });
      }, n.getAvailableTokens = function (e) {
        return s(n, void 0, void 0, function () {
          var t, a;
          return o(this, function (r) {
            switch (r.label) {
              case 0:
                return c.default.isNonZeroETHAddressHex("beneficiary", e), [4, this.contract];

              case 1:
                return [4, r.sent().getAvailableTokens.callAsync(e)];

              case 2:
                return t = r.sent(), [4, this.securityTokenContract()];

              case 3:
                return [4, r.sent().decimals.callAsync()];

              case 4:
                return a = r.sent(), [2, d.weiToValue(t, a)];
            }
          });
        });
      }, n.contract = a, n;
    }

    return n(t, e), t;
  }(a(
  /*! ../../module_wrapper */
  17).WithModule_3_0_0(f.default));

  t.VestingEscrowWallet_3_1_0 = l, t.isVestingEscrowWallet_3_1_0 = function (e) {
    return e.contractVersion === u.ContractVersion.V3_1_0;
  };
},
/*!****************************!*\
  !*** ./src/PolymathAPI.ts ***!
  \****************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      n = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      s = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      i = s(a(
  /*! ./contract_wrappers/registries/polymath_registry_wrapper */
  288)),
      c = s(a(
  /*! ./contract_wrappers/registries/security_token_registry_wrapper */
  289)),
      u = s(a(
  /*! ./contract_wrappers/tokens/poly_token_wrapper */
  287)),
      d = s(a(
  /*! ./contract_wrappers/registries/module_registry_wrapper */
  286)),
      f = s(a(
  /*! ./factories/tokenWrapperFactory */
  868)),
      l = s(a(
  /*! ./factories/moduleWrapperFactory */
  869)),
      h = s(a(
  /*! ./contract_wrappers/registries/feature_registry_wrapper */
  285)),
      p = s(a(
  /*! ./utils/assert */
  15)),
      b = s(a(
  /*! ./contract_wrappers/tokens/poly_token_faucet_wrapper */
  870)),
      m = s(a(
  /*! ./factories/contractFactory */
  871)),
      y = a(
  /*! ./types */
  4),
      v = a(
  /*! ./PolymathError */
  43),
      _ = function _(e) {
    var t = this;
    this.getPolyTokens = function (e) {
      return r(t, void 0, void 0, function () {
        var t, a;
        return n(this, function (r) {
          switch (r.label) {
            case 0:
              return [4, this.web3Wrapper.getNetworkIdAsync()];

            case 1:
              if (1 === r.sent()) throw new v.PolymathError({
                message: "Only for testnet",
                code: y.ErrorCode.PreconditionRequired
              });
              return void 0 === e.address ? [3, 2] : (a = e.address, [3, 4]);

            case 2:
              return [4, this.getAccount()];

            case 3:
              a = r.sent(), r.label = 4;

            case 4:
              return t = a, p.default.isETHAddressHex("address", t), [2, this.polyTokenFaucet.getTokens({
                amount: e.amount,
                recipient: t
              })];
          }
        });
      });
    }, this.getERC20TokenWrapper = function (e) {
      return r(t, void 0, void 0, function () {
        return n(this, function (t) {
          return [2, this.tokenFactory.getERC20TokenInstanceFromAddress(e.address)];
        });
      });
    }, this.getAccount = function () {
      return r(t, void 0, void 0, function () {
        return n(this, function (e) {
          switch (e.label) {
            case 0:
              return [4, this.web3Wrapper.getAvailableAddressesAsync()];

            case 1:
              return [2, e.sent()[0]];
          }
        });
      });
    }, this.getBalance = function (e) {
      return r(t, void 0, void 0, function () {
        var t, a;
        return n(this, function (r) {
          switch (r.label) {
            case 0:
              return void 0 === e.address ? [3, 1] : (a = e.address, [3, 3]);

            case 1:
              return [4, this.getAccount()];

            case 2:
              a = r.sent(), r.label = 3;

            case 3:
              return t = a, p.default.isETHAddressHex("address", t), [2, this.web3Wrapper.getBalanceInWeiAsync(t)];
          }
        });
      });
    }, this.isTestnet = function () {
      return r(t, void 0, void 0, function () {
        return n(this, function (e) {
          switch (e.label) {
            case 0:
              return [4, this.web3Wrapper.getNetworkIdAsync()];

            case 1:
              return [2, 1 !== e.sent()];
          }
        });
      });
    }, o.providerUtils.standardizeOrThrow(e.provider), void 0 !== e.polymathRegistryAddress && p.default.isNonZeroETHAddressHex("polymathRegistryAddress", e.polymathRegistryAddress), this.web3Wrapper = new o.Web3Wrapper(e.provider, {
      gasPrice: e.defaultGasPrice
    });
    var a = [o.FeatureRegistryContract_3_0_0.ABI(), o.ModuleRegistryContract_3_0_0.ABI(), o.PolymathRegistryContract_3_0_0.ABI(), o.ISecurityTokenRegistryContract_3_0_0.ABI(), o.ModuleFactoryContract_3_0_0.ABI(), o.ModuleContract_3_0_0.ABI(), o.ERC20DividendCheckpointContract_3_0_0.ABI(), o.EtherDividendCheckpointContract_3_0_0.ABI(), o.GeneralPermissionManagerContract_3_0_0.ABI(), o.CappedSTOContract_3_0_0.ABI(), o.USDTieredSTOContract_3_0_0.ABI(), o.CountTransferManagerContract_3_0_0.ABI(), o.GeneralTransferManagerContract_3_0_0.ABI(), o.ManualApprovalTransferManagerContract_3_0_0.ABI(), o.PercentageTransferManagerContract_3_0_0.ABI(), o.LockUpTransferManagerContract_3_0_0.ABI(), o.BlacklistTransferManagerContract_3_0_0.ABI(), o.VolumeRestrictionTMContract_3_0_0.ABI(), o.ERC20DetailedContract_3_0_0.ABI(), o.PolyTokenContract_3_0_0.ABI(), o.PolyTokenFaucetContract_3_0_0.ABI(), o.ISecurityTokenContract_3_0_0.ABI(), o.VestingEscrowWalletContract_3_0_0.ABI(), o.GeneralPermissionManagerContract_3_1_0.ABI(), o.CappedSTOContract_3_1_0.ABI(), o.USDTieredSTOContract_3_1_0.ABI(), o.GeneralTransferManagerContract_3_1_0.ABI(), o.RestrictedPartialSaleTMContract_3_1_0.ABI(), o.VestingEscrowWalletContract_3_1_0.ABI(), o.AdvancedPLCRVotingCheckpointContract_3_1_0.ABI()];
    a.forEach(function (e) {
      t.web3Wrapper.abiDecoder.addABI(e);
    }), this.contractFactory = new m.default(this.web3Wrapper, a, e.polymathRegistryAddress), this.polymathRegistry = new i.default(this.web3Wrapper, this.contractFactory.getPolymathRegistryContract()), this.securityTokenRegistry = new c.default(this.web3Wrapper, this.contractFactory.getSecurityTokenRegistryContract(), this.contractFactory), this.polyToken = new u.default(this.web3Wrapper, this.contractFactory.getPolyTokenContract()), this.moduleRegistry = new d.default(this.web3Wrapper, this.contractFactory.getModuleRegistryContract(), this.contractFactory), this.featureRegistry = new h.default(this.web3Wrapper, this.contractFactory.getFeatureRegistryContract()), this.tokenFactory = new f.default(this.web3Wrapper, this.securityTokenRegistry, this.contractFactory), this.moduleFactory = new l.default(this.web3Wrapper, this.contractFactory), this.polyTokenFaucet = new b.default(this.web3Wrapper, this.contractFactory.getPolyTokenFaucetContract());
  };

  t.PolymathAPI = _;
},
/*!**********************************************!*\
  !*** ./src/factories/tokenWrapperFactory.ts ***!
  \**********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      n = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      s = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o = a(
  /*! ../contract_wrappers/tokens/security_token_wrapper */
  292),
      i = s(a(
  /*! ../contract_wrappers/tokens/erc20_detailed_wrapper */
  294)),
      c = s(a(
  /*! ../utils/assert */
  15)),
      u = a(
  /*! ../types */
  4),
      d = a(
  /*! ../PolymathError */
  43),
      f = function f(e, t, a) {
    var s = this;
    this.getERC20TokenInstanceFromAddress = function (e) {
      return r(s, void 0, void 0, function () {
        var t;
        return n(this, function (a) {
          switch (a.label) {
            case 0:
              return c.default.isETHAddressHex("address", e), [4, (t = new i.default(this.web3Wrapper, this.contractFactory.getERC20DetailedContract(e))).isValidContract()];

            case 1:
              if (a.sent()) return [2, t];
              throw new d.PolymathError({
                code: u.ErrorCode.NotFound
              });
          }
        });
      });
    }, this.getSecurityTokenInstanceFromAddress = function (e) {
      return r(s, void 0, void 0, function () {
        return n(this, function (t) {
          switch (t.label) {
            case 0:
              return c.default.isETHAddressHex("address", e), [4, this.securityTokenRegistry.isSecurityToken({
                securityTokenAddress: e
              })];

            case 1:
              if (t.sent()) return [2, new o.SecurityToken_3_0_0(this.web3Wrapper, this.contractFactory.getSecurityTokenContract(e), this.contractFactory)];
              throw new d.PolymathError({
                code: u.ErrorCode.NotFound
              });
          }
        });
      });
    }, this.getSecurityTokenInstanceFromTicker = function (e) {
      return r(s, void 0, void 0, function () {
        var t;
        return n(this, function (a) {
          switch (a.label) {
            case 0:
              return [4, this.securityTokenRegistry.getSecurityTokenAddress({
                ticker: e
              })];

            case 1:
              return t = a.sent(), c.default.isNonZeroETHAddressHex("address", t), [2, new o.SecurityToken_3_0_0(this.web3Wrapper, this.contractFactory.getSecurityTokenContract(t), this.contractFactory)];
          }
        });
      });
    }, this.web3Wrapper = e, this.securityTokenRegistry = t, this.contractFactory = a;
  };

  t.default = f;
},
/*!***********************************************!*\
  !*** ./src/factories/moduleWrapperFactory.ts ***!
  \***********************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      n = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      s = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o = a(
  /*! ../contract_wrappers/modules/transfer_manager/general_transfer_manager_wrapper */
  146),
      i = a(
  /*! ../contract_wrappers/modules/transfer_manager/count_transfer_manager_wrapper */
  302),
      c = a(
  /*! ../contract_wrappers/modules/transfer_manager/manual_approval_transfer_manager_wrapper */
  304),
      u = a(
  /*! ../contract_wrappers/modules/transfer_manager/percentage_transfer_manager_wrapper */
  306),
      d = a(
  /*! ../contract_wrappers/modules/transfer_manager/lock_up_transfer_manager_wrapper */
  308),
      f = a(
  /*! ../contract_wrappers/modules/transfer_manager/blacklist_transfer_manager_wrapper */
  310),
      l = a(
  /*! ../contract_wrappers/modules/transfer_manager/volume_restriction_transfer_manager_wrapper */
  312),
      h = a(
  /*! ../contract_wrappers/modules/checkpoint/erc20_dividend_checkpoint_wrapper */
  295),
      p = a(
  /*! ../contract_wrappers/modules/checkpoint/ether_dividend_checkpoint_wrapper */
  297),
      b = a(
  /*! ../contract_wrappers/modules/sto/capped_sto_wrapper */
  300),
      m = a(
  /*! ../contract_wrappers/modules/sto/usd_tiered_sto_wrapper */
  301),
      y = a(
  /*! ../contract_wrappers/modules/permission_manager/general_permission_manager_wrapper */
  299),
      v = a(
  /*! ../contract_wrappers/modules/module_factory_wrapper */
  290),
      _ = a(
  /*! ../contract_wrappers/modules/wallet/vesting_escrow_wallet_wrapper */
  318),
      g = a(
  /*! ../contract_wrappers/modules/transfer_manager/restricted_partial_sale_transfer_manager_wrapper */
  314),
      A = a(
  /*! ../contract_wrappers/modules/checkpoint/voting/advanced_p_l_c_r_voting_checkpoint_wrapper */
  316),
      w = s(a(
  /*! ../utils/assert */
  15)),
      T = a(
  /*! ../types */
  4),
      x = a(
  /*! ../PolymathError */
  43),
      D = function D(e, t) {
    var a = this;
    this.getModuleFactory = function (e) {
      return r(a, void 0, void 0, function () {
        var t;
        return n(this, function (a) {
          return t = this.contractFactory.getModuleFactoryContract(e), [2, new v.ModuleFactory_3_0_0(this.web3Wrapper, t)];
        });
      });
    }, this.getModuleInstance = function (e) {
      return r(a, void 0, void 0, function () {
        var t, a;
        return n(this, function (r) {
          switch (r.label) {
            case 0:
              return w.default.isETHAddressHex("address", e.address), [4, this.contractFactory.getModuleVersion(e.address)];

            case 1:
              switch (a = r.sent(), e.name) {
                case T.ModuleName.GeneralPermissionManager:
                  t = a === T.ContractVersion.V3_0_0 ? new y.GeneralPermissionManager_3_0_0(this.web3Wrapper, this.contractFactory.getGeneralPermissionManagerContract(e.address, a), this.contractFactory) : new y.GeneralPermissionManager_3_1_0(this.web3Wrapper, this.contractFactory.getGeneralPermissionManagerContract(e.address, a), this.contractFactory);
                  break;

                case T.ModuleName.CountTransferManager:
                  t = new i.CountTransferManager_3_0_0(this.web3Wrapper, this.contractFactory.getCountTransferManagerContract(e.address), this.contractFactory);
                  break;

                case T.ModuleName.GeneralTransferManager:
                  t = a === T.ContractVersion.V3_0_0 ? new o.GeneralTransferManager_3_0_0(this.web3Wrapper, this.contractFactory.getGeneralTransferManagerContract(e.address, a), this.contractFactory) : new o.GeneralTransferManager_3_1_0(this.web3Wrapper, this.contractFactory.getGeneralTransferManagerContract(e.address, a), this.contractFactory);
                  break;

                case T.ModuleName.ManualApprovalTransferManager:
                  t = new c.ManualApprovalTransferManager_3_0_0(this.web3Wrapper, this.contractFactory.getManualApprovalTransferManagerContract(e.address), this.contractFactory);
                  break;

                case T.ModuleName.PercentageTransferManager:
                  t = new u.PercentageTransferManager_3_0_0(this.web3Wrapper, this.contractFactory.getPercentageTransferManagerContract(e.address), this.contractFactory);
                  break;

                case T.ModuleName.LockUpTransferManager:
                  t = new d.LockUpTransferManager_3_0_0(this.web3Wrapper, this.contractFactory.getLockUpTransferManagerContract(e.address), this.contractFactory);
                  break;

                case T.ModuleName.BlacklistTransferManager:
                  t = new f.BlacklistTransferManager_3_0_0(this.web3Wrapper, this.contractFactory.getBlacklistTransferManagerContract(e.address), this.contractFactory);
                  break;

                case T.ModuleName.VolumeRestrictionTM:
                  t = new l.VolumeRestrictionTransferManager_3_0_0(this.web3Wrapper, this.contractFactory.getVolumeRestrictionTMContract(e.address), this.contractFactory);
                  break;

                case T.ModuleName.RestrictedPartialSaleTM:
                  t = new g.RestrictedPartialSaleTransferManager_3_1_0(this.web3Wrapper, this.contractFactory.getRestrictedPartialSaleTMContract(e.address), this.contractFactory);
                  break;

                case T.ModuleName.CappedSTO:
                  t = a === T.ContractVersion.V3_0_0 ? new b.CappedSTO_3_0_0(this.web3Wrapper, this.contractFactory.getCappedSTOContract(e.address, a), this.contractFactory) : new b.CappedSTO_3_1_0(this.web3Wrapper, this.contractFactory.getCappedSTOContract(e.address, a), this.contractFactory);
                  break;

                case T.ModuleName.UsdTieredSTO:
                  t = a === T.ContractVersion.V3_0_0 ? new m.USDTieredSTO_3_0_0(this.web3Wrapper, this.contractFactory.getUSDTieredSTOContract(e.address, a), this.contractFactory) : new m.USDTieredSTO_3_1_0(this.web3Wrapper, this.contractFactory.getUSDTieredSTOContract(e.address, a), this.contractFactory);
                  break;

                case T.ModuleName.ERC20DividendCheckpoint:
                  t = new h.ERC20DividendCheckpoint_3_0_0(this.web3Wrapper, this.contractFactory.getERC20DividendCheckpointContract(e.address), this.contractFactory);
                  break;

                case T.ModuleName.EtherDividendCheckpoint:
                  t = new p.EtherDividendCheckpoint_3_0_0(this.web3Wrapper, this.contractFactory.getEtherDividendCheckpointContract(e.address), this.contractFactory);
                  break;

                case T.ModuleName.AdvancedPLCRVotingCheckpoint:
                  t = new A.AdvancedPLCRVotingCheckpoint_3_1_0(this.web3Wrapper, this.contractFactory.getAdvancedPLCRVotingCheckpointContract(e.address), this.contractFactory);
                  break;

                case T.ModuleName.VestingEscrowWallet:
                  t = a === T.ContractVersion.V3_0_0 ? new _.VestingEscrowWallet_3_0_0(this.web3Wrapper, this.contractFactory.getVestingEscrowWalletContract(e.address, a), this.contractFactory) : new _.VestingEscrowWallet_3_1_0(this.web3Wrapper, this.contractFactory.getVestingEscrowWalletContract(e.address, a), this.contractFactory);
                  break;

                default:
                  throw new x.PolymathError({
                    code: T.ErrorCode.NotFound
                  });
              }

              return [4, t.isValidModule()];

            case 2:
              if (r.sent()) return [2, t];
              throw new x.PolymathError({
                code: T.ErrorCode.InvalidData,
                message: "Invalid module"
              });
          }
        });
      });
    }, this.web3Wrapper = e, this.contractFactory = t;
  };

  t.default = D;
},
/*!*******************************************************************!*\
  !*** ./src/contract_wrappers/tokens/poly_token_faucet_wrapper.ts ***!
  \*******************************************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var _r145,
      n = this && this.__extends || (_r145 = function r(e, t) {
    return (_r145 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var a in t) {
        t.hasOwnProperty(a) && (e[a] = t[a]);
      }
    })(e, t);
  }, function (e, t) {
    function a() {
      this.constructor = e;
    }

    _r145(e, t), e.prototype = null === t ? Object.create(t) : (a.prototype = t.prototype, new a());
  }),
      s = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      o = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      i = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var c = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      u = a(
  /*! @0x/json-schemas */
  2),
      d = i(a(
  /*! ../contract_wrapper */
  44)),
      f = a(
  /*! ../../types */
  4),
      l = i(a(
  /*! ../../utils/assert */
  15)),
      h = a(
  /*! ../../utils/convert */
  16),
      p = new c.BigNumber(1e24),
      b = function (e) {
    function t(t, a) {
      var r = e.call(this, t, a) || this;
      return r.contractVersion = f.ContractVersion.V3_0_0, r.getTokens = function (e) {
        return s(r, void 0, void 0, function () {
          var t, a, r, n;
          return o(this, function (s) {
            switch (s.label) {
              case 0:
                return l.default.isNonZeroETHAddressHex("recipient", e.recipient), l.default.assert(e.amount.isLessThanOrEqualTo(p), f.ErrorCode.InvalidData, "Amount cannot exceed 1 million tokens"), [4, this.contract];

              case 1:
                return a = (t = s.sent().getTokens).sendTransactionAsync, r = h.valueToWei, n = [e.amount], [4, this.contract];

              case 2:
                return [4, s.sent().decimals.callAsync()];

              case 3:
                return [2, a.apply(t, [r.apply(void 0, n.concat([s.sent()])), e.recipient, e.txData, e.safetyFactor])];
            }
          });
        });
      }, r.subscribeAsync = function (e) {
        return s(r, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return l.default.doesBelongToStringEnum("eventName", e.eventName, c.PolyTokenFaucetEvents_3_0_0), l.default.doesConformToSchema("indexFilterValues", e.indexFilterValues, u.schemas.indexFilterValuesSchema), l.default.isFunction("callback", e.callback), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.subscribeInternal(t, e.eventName, e.indexFilterValues, e.callback, e.isVerbose)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, r.getLogsAsync = function (e) {
        return s(r, void 0, void 0, function () {
          var t;
          return o(this, function (a) {
            switch (a.label) {
              case 0:
                return l.default.doesBelongToStringEnum("eventName", e.eventName, c.PolyTokenFaucetEvents_3_0_0), [4, this.contract];

              case 1:
                return t = a.sent().address.toLowerCase(), [4, this.getLogsAsyncInternal(t, e.eventName, e.blockRange, e.indexFilterValues)];

              case 2:
                return [2, a.sent()];
            }
          });
        });
      }, r.contract = a, r;
    }

    return n(t, e), t;
  }(d.default);

  t.default = b;
},
/*!******************************************!*\
  !*** ./src/factories/contractFactory.ts ***!
  \******************************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = this && this.__awaiter || function (e, t, a, r) {
    return new (a || (a = Promise))(function (n, s) {
      function o(e) {
        try {
          c(r.next(e));
        } catch (e) {
          s(e);
        }
      }

      function i(e) {
        try {
          c(r.throw(e));
        } catch (e) {
          s(e);
        }
      }

      function c(e) {
        e.done ? n(e.value) : new a(function (t) {
          t(e.value);
        }).then(o, i);
      }

      c((r = r.apply(e, t || [])).next());
    });
  },
      n = this && this.__generator || function (e, t) {
    var a,
        r,
        n,
        s,
        o = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
    return s = {
      next: i(0),
      throw: i(1),
      return: i(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
      return this;
    }), s;

    function i(s) {
      return function (i) {
        return function (s) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; o;) {
            try {
              if (a = 1, r && (n = 2 & s[0] ? r.return : s[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, s[1])).done) return n;

              switch (r = 0, n && (s = [2 & s[0], n.value]), s[0]) {
                case 0:
                case 1:
                  n = s;
                  break;

                case 4:
                  return o.label++, {
                    value: s[1],
                    done: !1
                  };

                case 5:
                  o.label++, r = s[1], s = [0];
                  continue;

                case 7:
                  s = o.ops.pop(), o.trys.pop();
                  continue;

                default:
                  if (!(n = (n = o.trys).length > 0 && n[n.length - 1]) && (6 === s[0] || 2 === s[0])) {
                    o = 0;
                    continue;
                  }

                  if (3 === s[0] && (!n || s[1] > n[0] && s[1] < n[3])) {
                    o.label = s[1];
                    break;
                  }

                  if (6 === s[0] && o.label < n[1]) {
                    o.label = n[1], n = s;
                    break;
                  }

                  if (n && o.label < n[2]) {
                    o.label = n[2], o.ops.push(s);
                    break;
                  }

                  n[2] && o.ops.pop(), o.trys.pop();
                  continue;
              }

              s = t.call(e, o);
            } catch (e) {
              s = [6, e], r = 0;
            } finally {
              a = n = 0;
            }
          }

          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, i]);
      };
    }
  },
      s = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = a(
  /*! @polymathnetwork/abi-wrappers */
  6),
      i = a(
  /*! ../PolymathError */
  43),
      c = s(a(
  /*! ../utils/assert */
  15)),
      u = s(a(
  /*! ../utils/addresses */
  872)),
      d = a(
  /*! ../types */
  4);

  var f = function () {
    function e(e, t, a) {
      var s = this;
      this.getVestingEscrowWalletContract = function (e, t) {
        return r(s, void 0, void 0, function () {
          var a;
          return n(this, function (r) {
            return c.default.isETHAddressHex("address", e), a = t === d.ContractVersion.V3_0_0 ? new o.VestingEscrowWalletContract_3_0_0(e, this.provider, this.contractDefaults) : new o.VestingEscrowWalletContract_3_1_0(e, this.provider, this.contractDefaults), this.abiArray.forEach(function (e) {
              a.addABItoDecoder(e);
            }), [2, a];
          });
        });
      }, this.getGeneralPermissionManagerContract = function (e, t) {
        return r(s, void 0, void 0, function () {
          var a;
          return n(this, function (r) {
            return c.default.isETHAddressHex("address", e), a = t === d.ContractVersion.V3_0_0 ? new o.GeneralPermissionManagerContract_3_0_0(e, this.provider, this.contractDefaults) : new o.GeneralPermissionManagerContract_3_1_0(e, this.provider, this.contractDefaults), this.abiArray.forEach(function (e) {
              a.addABItoDecoder(e);
            }), [2, a];
          });
        });
      }, this.getCappedSTOContract = function (e, t) {
        return r(s, void 0, void 0, function () {
          var a;
          return n(this, function (r) {
            return c.default.isETHAddressHex("address", e), a = t === d.ContractVersion.V3_0_0 ? new o.CappedSTOContract_3_0_0(e, this.provider, this.contractDefaults) : new o.CappedSTOContract_3_1_0(e, this.provider, this.contractDefaults), this.abiArray.forEach(function (e) {
              a.addABItoDecoder(e);
            }), [2, a];
          });
        });
      }, this.getUSDTieredSTOContract = function (e, t) {
        return r(s, void 0, void 0, function () {
          var a;
          return n(this, function (r) {
            return c.default.isETHAddressHex("address", e), a = t === d.ContractVersion.V3_0_0 ? new o.USDTieredSTOContract_3_0_0(e, this.provider, this.contractDefaults) : new o.USDTieredSTOContract_3_1_0(e, this.provider, this.contractDefaults), this.abiArray.forEach(function (e) {
              a.addABItoDecoder(e);
            }), [2, a];
          });
        });
      }, this.getGeneralTransferManagerContract = function (e, t) {
        return r(s, void 0, void 0, function () {
          var a;
          return n(this, function (r) {
            return c.default.isETHAddressHex("address", e), a = t === d.ContractVersion.V3_0_0 ? new o.GeneralTransferManagerContract_3_0_0(e, this.provider, this.contractDefaults) : new o.GeneralTransferManagerContract_3_1_0(e, this.provider, this.contractDefaults), this.abiArray.forEach(function (e) {
              a.addABItoDecoder(e);
            }), [2, a];
          });
        });
      }, this.web3Wrapper = e, this.abiArray = t, this.provider = e.getProvider(), this.contractDefaults = this.web3Wrapper.getContractDefaults(), this.polymathRegistry = function (e, t) {
        return r(this, void 0, void 0, function () {
          var a, r, s;
          return n(this, function (n) {
            switch (n.label) {
              case 0:
                return a = o.PolymathRegistryContract_3_0_0.bind, (r = t) ? [3, 3] : (s = u.default, [4, e.getNetworkIdAsync()]);

              case 1:
                return [4, s.apply(void 0, [n.sent()])];

              case 2:
                r = n.sent(), n.label = 3;

              case 3:
                return [2, new (a.apply(o.PolymathRegistryContract_3_0_0, [void 0, r, e.getProvider(), e.getContractDefaults()]))()];
            }
          });
        });
      }(e, a);
    }

    return e.prototype.getModuleContract = function (e) {
      return r(this, void 0, void 0, function () {
        var t;
        return n(this, function (a) {
          return c.default.isETHAddressHex("address", e), t = new o.ModuleContract_3_0_0(e, this.provider, this.contractDefaults), this.abiArray.forEach(function (e) {
            t.addABItoDecoder(e);
          }), [2, t];
        });
      });
    }, e.prototype.getERC20DividendCheckpointContract = function (e) {
      return r(this, void 0, void 0, function () {
        var t;
        return n(this, function (a) {
          return c.default.isETHAddressHex("address", e), t = new o.ERC20DividendCheckpointContract_3_0_0(e, this.provider, this.contractDefaults), this.abiArray.forEach(function (e) {
            t.addABItoDecoder(e);
          }), [2, t];
        });
      });
    }, e.prototype.getPolymathRegistryContract = function () {
      return r(this, void 0, void 0, function () {
        var e;
        return n(this, function (t) {
          switch (t.label) {
            case 0:
              return [4, this.polymathRegistry];

            case 1:
              return e = t.sent(), this.abiArray.forEach(function (t) {
                e.addABItoDecoder(t);
              }), [2, e];
          }
        });
      });
    }, e.prototype.getModuleFactoryContract = function (e) {
      return r(this, void 0, void 0, function () {
        var t;
        return n(this, function (a) {
          return c.default.isETHAddressHex("address", e), t = new o.ModuleFactoryContract_3_0_0(e, this.provider, this.contractDefaults), this.abiArray.forEach(function (e) {
            t.addABItoDecoder(e);
          }), [2, t];
        });
      });
    }, e.prototype.getEtherDividendCheckpointContract = function (e) {
      return r(this, void 0, void 0, function () {
        var t;
        return n(this, function (a) {
          return c.default.isETHAddressHex("address", e), t = new o.EtherDividendCheckpointContract_3_0_0(e, this.provider, this.contractDefaults), this.abiArray.forEach(function (e) {
            t.addABItoDecoder(e);
          }), [2, t];
        });
      });
    }, e.prototype.getAdvancedPLCRVotingCheckpointContract = function (e) {
      return r(this, void 0, void 0, function () {
        var t;
        return n(this, function (a) {
          return c.default.isETHAddressHex("address", e), t = new o.AdvancedPLCRVotingCheckpointContract_3_1_0(e, this.provider, this.contractDefaults), this.abiArray.forEach(function (e) {
            t.addABItoDecoder(e);
          }), [2, t];
        });
      });
    }, e.prototype.getERC20DetailedContract = function (e) {
      return r(this, void 0, void 0, function () {
        var t;
        return n(this, function (a) {
          return c.default.isETHAddressHex("address", e), t = new o.ERC20DetailedContract_3_0_0(e, this.provider, this.contractDefaults), this.abiArray.forEach(function (e) {
            t.addABItoDecoder(e);
          }), [2, t];
        });
      });
    }, e.prototype.getAlternativeERC20Contract = function (e) {
      return r(this, void 0, void 0, function () {
        var t;
        return n(this, function (a) {
          return c.default.isETHAddressHex("address", e), t = new o.ERC20DetailedContract_3_0_0(e, this.provider, this.contractDefaults), this.abiArray.forEach(function (e) {
            t.addABItoDecoder(e);
          }), [2, t];
        });
      });
    }, e.prototype.getSecurityTokenContract = function (e) {
      return r(this, void 0, void 0, function () {
        var t;
        return n(this, function (a) {
          return c.default.isETHAddressHex("address", e), t = new o.ISecurityTokenContract_3_0_0(e, this.provider, this.contractDefaults), this.abiArray.forEach(function (e) {
            t.addABItoDecoder(e);
          }), [2, t];
        });
      });
    }, e.prototype.getPolyTokenFaucetContract = function () {
      return r(this, void 0, void 0, function () {
        var e, t;
        return n(this, function (a) {
          switch (a.label) {
            case 0:
              return t = o.PolyTokenFaucetContract_3_0_0.bind, [4, this.polymathRegistry];

            case 1:
              return [4, a.sent().getAddress.callAsync(d.PolymathContract.PolyToken)];

            case 2:
              return e = new (t.apply(o.PolyTokenFaucetContract_3_0_0, [void 0, a.sent(), this.provider, this.contractDefaults]))(), this.abiArray.forEach(function (t) {
                e.addABItoDecoder(t);
              }), [2, e];
          }
        });
      });
    }, e.prototype.getPolyTokenContract = function () {
      return r(this, void 0, void 0, function () {
        var e, t;
        return n(this, function (a) {
          switch (a.label) {
            case 0:
              return t = o.PolyTokenContract_3_0_0.bind, [4, this.polymathRegistry];

            case 1:
              return [4, a.sent().getAddress.callAsync(d.PolymathContract.PolyToken)];

            case 2:
              return e = new (t.apply(o.PolyTokenContract_3_0_0, [void 0, a.sent(), this.provider, this.contractDefaults]))(), this.abiArray.forEach(function (t) {
                e.addABItoDecoder(t);
              }), [2, e];
          }
        });
      });
    }, e.prototype.getCappedSTOFactoryContract = function (e) {
      return r(this, void 0, void 0, function () {
        var t;
        return n(this, function (a) {
          return t = new o.CappedSTOFactoryContract_3_0_0(e, this.provider, this.contractDefaults), this.abiArray.forEach(function (e) {
            t.addABItoDecoder(e);
          }), [2, t];
        });
      });
    }, e.prototype.getUSDTieredSTOFactoryContract = function (e) {
      return r(this, void 0, void 0, function () {
        var t;
        return n(this, function (a) {
          return c.default.isETHAddressHex("address", e), t = new o.USDTieredSTOFactoryContract_3_0_0(e, this.provider, this.contractDefaults), this.abiArray.forEach(function (e) {
            t.addABItoDecoder(e);
          }), [2, t];
        });
      });
    }, e.prototype.getCountTransferManagerContract = function (e) {
      return r(this, void 0, void 0, function () {
        var t;
        return n(this, function (a) {
          return c.default.isETHAddressHex("address", e), t = new o.CountTransferManagerContract_3_0_0(e, this.provider, this.contractDefaults), this.abiArray.forEach(function (e) {
            t.addABItoDecoder(e);
          }), [2, t];
        });
      });
    }, e.prototype.getManualApprovalTransferManagerContract = function (e) {
      return r(this, void 0, void 0, function () {
        var t;
        return n(this, function (a) {
          return c.default.isETHAddressHex("address", e), t = new o.ManualApprovalTransferManagerContract_3_0_0(e, this.provider, this.contractDefaults), this.abiArray.forEach(function (e) {
            t.addABItoDecoder(e);
          }), [2, t];
        });
      });
    }, e.prototype.getPercentageTransferManagerContract = function (e) {
      return r(this, void 0, void 0, function () {
        var t;
        return n(this, function (a) {
          return c.default.isETHAddressHex("address", e), t = new o.PercentageTransferManagerContract_3_0_0(e, this.provider, this.contractDefaults), this.abiArray.forEach(function (e) {
            t.addABItoDecoder(e);
          }), [2, t];
        });
      });
    }, e.prototype.getLockUpTransferManagerContract = function (e) {
      return r(this, void 0, void 0, function () {
        var t;
        return n(this, function (a) {
          return c.default.isETHAddressHex("address", e), t = new o.LockUpTransferManagerContract_3_0_0(e, this.provider, this.contractDefaults), this.abiArray.forEach(function (e) {
            t.addABItoDecoder(e);
          }), [2, t];
        });
      });
    }, e.prototype.getBlacklistTransferManagerContract = function (e) {
      return r(this, void 0, void 0, function () {
        var t;
        return n(this, function (a) {
          return c.default.isETHAddressHex("address", e), t = new o.BlacklistTransferManagerContract_3_0_0(e, this.provider, this.contractDefaults), this.abiArray.forEach(function (e) {
            t.addABItoDecoder(e);
          }), [2, t];
        });
      });
    }, e.prototype.getVolumeRestrictionTMContract = function (e) {
      return r(this, void 0, void 0, function () {
        var t;
        return n(this, function (a) {
          return c.default.isETHAddressHex("address", e), t = new o.VolumeRestrictionTMContract_3_0_0(e, this.provider, this.contractDefaults), this.abiArray.forEach(function (e) {
            t.addABItoDecoder(e);
          }), [2, t];
        });
      });
    }, e.prototype.getRestrictedPartialSaleTMContract = function (e) {
      return r(this, void 0, void 0, function () {
        var t;
        return n(this, function (a) {
          return c.default.isETHAddressHex("address", e), t = new o.RestrictedPartialSaleTMContract_3_1_0(e, this.provider, this.contractDefaults), this.abiArray.forEach(function (e) {
            t.addABItoDecoder(e);
          }), [2, t];
        });
      });
    }, e.prototype.getFeatureRegistryContract = function () {
      return r(this, void 0, void 0, function () {
        var e, t;
        return n(this, function (a) {
          switch (a.label) {
            case 0:
              return t = o.FeatureRegistryContract_3_0_0.bind, [4, this.polymathRegistry];

            case 1:
              return [4, a.sent().getAddress.callAsync(d.PolymathContract.FeatureRegistry)];

            case 2:
              return e = new (t.apply(o.FeatureRegistryContract_3_0_0, [void 0, a.sent(), this.provider, this.contractDefaults]))(), this.abiArray.forEach(function (t) {
                e.addABItoDecoder(t);
              }), [2, e];
          }
        });
      });
    }, e.prototype.getModuleRegistryContract = function () {
      return r(this, void 0, void 0, function () {
        var e, t;
        return n(this, function (a) {
          switch (a.label) {
            case 0:
              return t = o.ModuleRegistryContract_3_0_0.bind, [4, this.polymathRegistry];

            case 1:
              return [4, a.sent().getAddress.callAsync(d.PolymathContract.ModuleRegistry)];

            case 2:
              return e = new (t.apply(o.ModuleRegistryContract_3_0_0, [void 0, a.sent(), this.provider, this.contractDefaults]))(), this.abiArray.forEach(function (t) {
                e.addABItoDecoder(t);
              }), [2, e];
          }
        });
      });
    }, e.prototype.getSecurityTokenRegistryContract = function () {
      return r(this, void 0, void 0, function () {
        var e, t;
        return n(this, function (a) {
          switch (a.label) {
            case 0:
              return t = o.ISecurityTokenRegistryContract_3_0_0.bind, [4, this.polymathRegistry];

            case 1:
              return [4, a.sent().getAddress.callAsync(d.PolymathContract.SecurityTokenRegistry)];

            case 2:
              return e = new (t.apply(o.ISecurityTokenRegistryContract_3_0_0, [void 0, a.sent(), this.provider, this.contractDefaults]))(), this.abiArray.forEach(function (t) {
                e.addABItoDecoder(t);
              }), [2, e];
          }
        });
      });
    }, e.prototype.getModuleVersion = function (e) {
      return r(this, void 0, void 0, function () {
        var t;
        return n(this, function (a) {
          switch (a.label) {
            case 0:
              return [4, new o.ModuleContract_3_0_0(e, this.provider, this.contractDefaults).factory.callAsync()];

            case 1:
              return t = a.sent(), [2, this.getModuleFactoryVersion(t)];
          }
        });
      });
    }, e.prototype.getModuleFactoryVersion = function (e) {
      return r(this, void 0, void 0, function () {
        var t;
        return n(this, function (a) {
          switch (a.label) {
            case 0:
              return [4, new o.ModuleFactoryContract_3_0_0(e, this.provider, this.contractDefaults).version.callAsync()];

            case 1:
              switch (t = a.sent()) {
                case d.ContractVersion.V3_0_0:
                  return [2, d.ContractVersion.V3_0_0];

                case d.ContractVersion.V3_1_0:
                  return [2, d.ContractVersion.V3_1_0];

                default:
                  throw new i.PolymathError({
                    code: d.ErrorCode.UnsupportedVersion,
                    message: "Version " + t + " not supported"
                  });
              }

              return [2];
          }
        });
      });
    }, e;
  }();

  t.default = f;
},
/*!********************************!*\
  !*** ./src/utils/addresses.ts ***!
  \********************************/

/*! no static exports found */

/*! all exports used */

/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
function (e, t, a) {
  "use strict";

  var r = this && this.__importDefault || function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  };

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = r(a(
  /*! lodash */
  0)),
      s = a(
  /*! ../types */
  4),
      o = a(
  /*! ../PolymathError */
  43),
      i = {
    1: "0xdfabf3e4793cd30affb47ab6fa4cf4eef26bbc27",
    5: "0x7e3c8af98538ba19a10dfc7e8f5469a76998b0f0",
    42: "0x5b215a7d39ee305ad28da29bf2f0425c6c2a00b3",
    15: "0x8b21e65058a5e52b423080044634ffac53c1e5ce"
  };

  t.default = function (e) {
    if (!(e in s.NetworkId)) throw new o.PolymathError({
      message: "No default contract addresses found for the given network id (" + e + ").\n    If you want to use ContractWrappers on this network,\n    you must manually pass in the contract address(es) to the constructor.",
      code: s.ErrorCode.NotFound
    });
    return function (e) {
      if (n.default.isUndefined(i[e])) throw new o.PolymathError({
        message: "Unknown network id (" + e + "). No known Polymath contracts have been deployed on this network.",
        code: s.ErrorCode.UnknownNetwork
      });
      return i[e];
    }(e);
  };
}]);